
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9346"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9346"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8JYDX", function(module, exports) {
/* @preserve
 * Leaflet 1.9.4, a JS library for interactive maps. https://leafletjs.com
 * (c) 2010-2023 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */ (function(global, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    'use strict';
    var version = "1.9.4";
    /*
   * @namespace Util
   *
   * Various utility functions, used by Leaflet internally.
   */ // @function extend(dest: Object, src?: Object): Object
    // Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
    function extend(dest) {
        var i, j, len, src;
        for(j = 1, len = arguments.length; j < len; j++){
            src = arguments[j];
            for(i in src)dest[i] = src[i];
        }
        return dest;
    }
    // @function create(proto: Object, properties?: Object): Object
    // Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
    var create$2 = Object.create || function() {
        function F() {}
        return function(proto) {
            F.prototype = proto;
            return new F();
        };
    }();
    // @function bind(fn: Function, …): Function
    // Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
    // Has a `L.bind()` shortcut.
    function bind(fn, obj) {
        var slice = Array.prototype.slice;
        if (fn.bind) return fn.bind.apply(fn, slice.call(arguments, 1));
        var args = slice.call(arguments, 2);
        return function() {
            return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
        };
    }
    // @property lastId: Number
    // Last unique ID used by [`stamp()`](#util-stamp)
    var lastId = 0;
    // @function stamp(obj: Object): Number
    // Returns the unique ID of an object, assigning it one if it doesn't have it.
    function stamp(obj) {
        if (!('_leaflet_id' in obj)) obj['_leaflet_id'] = ++lastId;
        return obj._leaflet_id;
    }
    // @function throttle(fn: Function, time: Number, context: Object): Function
    // Returns a function which executes function `fn` with the given scope `context`
    // (so that the `this` keyword refers to `context` inside `fn`'s code). The function
    // `fn` will be called no more than one time per given amount of `time`. The arguments
    // received by the bound function will be any arguments passed when binding the
    // function, followed by any arguments passed when invoking the bound function.
    // Has an `L.throttle` shortcut.
    function throttle(fn, time, context) {
        var lock, args, wrapperFn, later;
        later = function() {
            // reset lock and call if queued
            lock = false;
            if (args) {
                wrapperFn.apply(context, args);
                args = false;
            }
        };
        wrapperFn = function() {
            if (lock) // called too soon, queue to call later
            args = arguments;
            else {
                // call and lock until later
                fn.apply(context, arguments);
                setTimeout(later, time);
                lock = true;
            }
        };
        return wrapperFn;
    }
    // @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
    // Returns the number `num` modulo `range` in such a way so it lies within
    // `range[0]` and `range[1]`. The returned value will be always smaller than
    // `range[1]` unless `includeMax` is set to `true`.
    function wrapNum(x, range, includeMax) {
        var max = range[1], min = range[0], d = max - min;
        return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
    }
    // @function falseFn(): Function
    // Returns a function which always returns `false`.
    function falseFn() {
        return false;
    }
    // @function formatNum(num: Number, precision?: Number|false): Number
    // Returns the number `num` rounded with specified `precision`.
    // The default `precision` value is 6 decimal places.
    // `false` can be passed to skip any processing (can be useful to avoid round-off errors).
    function formatNum(num, precision) {
        if (precision === false) return num;
        var pow = Math.pow(10, precision === undefined ? 6 : precision);
        return Math.round(num * pow) / pow;
    }
    // @function trim(str: String): String
    // Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
    function trim(str) {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
    }
    // @function splitWords(str: String): String[]
    // Trims and splits the string on whitespace and returns the array of parts.
    function splitWords(str) {
        return trim(str).split(/\s+/);
    }
    // @function setOptions(obj: Object, options: Object): Object
    // Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
    function setOptions(obj, options) {
        if (!Object.prototype.hasOwnProperty.call(obj, 'options')) obj.options = obj.options ? create$2(obj.options) : {};
        for(var i in options)obj.options[i] = options[i];
        return obj.options;
    }
    // @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
    // Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
    // translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
    // be appended at the end. If `uppercase` is `true`, the parameter names will
    // be uppercased (e.g. `'?A=foo&B=bar'`)
    function getParamString(obj, existingUrl, uppercase) {
        var params = [];
        for(var i in obj)params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + '=' + encodeURIComponent(obj[i]));
        return (!existingUrl || existingUrl.indexOf('?') === -1 ? '?' : '&') + params.join('&');
    }
    var templateRe = /\{ *([\w_ -]+) *\}/g;
    // @function template(str: String, data: Object): String
    // Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
    // and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
    // `('Hello foo, bar')`. You can also specify functions instead of strings for
    // data values — they will be evaluated passing `data` as an argument.
    function template(str, data) {
        return str.replace(templateRe, function(str, key) {
            var value = data[key];
            if (value === undefined) throw new Error('No value provided for variable ' + str);
            else if (typeof value === 'function') value = value(data);
            return value;
        });
    }
    // @function isArray(obj): Boolean
    // Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
    var isArray = Array.isArray || function(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };
    // @function indexOf(array: Array, el: Object): Number
    // Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
    function indexOf(array, el) {
        for(var i = 0; i < array.length; i++){
            if (array[i] === el) return i;
        }
        return -1;
    }
    // @property emptyImageUrl: String
    // Data URI string containing a base64-encoded empty GIF image.
    // Used as a hack to free memory from unused images on WebKit-powered
    // mobile devices (by setting image `src` to this string).
    var emptyImageUrl = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
    // inspired by https://paulirish.com/2011/requestanimationframe-for-smart-animating/
    function getPrefixed(name) {
        return window['webkit' + name] || window['moz' + name] || window['ms' + name];
    }
    var lastTime = 0;
    // fallback for IE 7-8
    function timeoutDefer(fn) {
        var time = +new Date(), timeToCall = Math.max(0, 16 - (time - lastTime));
        lastTime = time + timeToCall;
        return window.setTimeout(fn, timeToCall);
    }
    var requestFn = window.requestAnimationFrame || getPrefixed('RequestAnimationFrame') || timeoutDefer;
    var cancelFn = window.cancelAnimationFrame || getPrefixed('CancelAnimationFrame') || getPrefixed('CancelRequestAnimationFrame') || function(id) {
        window.clearTimeout(id);
    };
    // @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
    // Schedules `fn` to be executed when the browser repaints. `fn` is bound to
    // `context` if given. When `immediate` is set, `fn` is called immediately if
    // the browser doesn't have native support for
    // [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
    // otherwise it's delayed. Returns a request ID that can be used to cancel the request.
    function requestAnimFrame(fn, context, immediate) {
        if (immediate && requestFn === timeoutDefer) fn.call(context);
        else return requestFn.call(window, bind(fn, context));
    }
    // @function cancelAnimFrame(id: Number): undefined
    // Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
    function cancelAnimFrame(id) {
        if (id) cancelFn.call(window, id);
    }
    var Util = {
        __proto__: null,
        extend: extend,
        create: create$2,
        bind: bind,
        get lastId () {
            return lastId;
        },
        stamp: stamp,
        throttle: throttle,
        wrapNum: wrapNum,
        falseFn: falseFn,
        formatNum: formatNum,
        trim: trim,
        splitWords: splitWords,
        setOptions: setOptions,
        getParamString: getParamString,
        template: template,
        isArray: isArray,
        indexOf: indexOf,
        emptyImageUrl: emptyImageUrl,
        requestFn: requestFn,
        cancelFn: cancelFn,
        requestAnimFrame: requestAnimFrame,
        cancelAnimFrame: cancelAnimFrame
    };
    // @class Class
    // @aka L.Class
    // @section
    // @uninheritable
    // Thanks to John Resig and Dean Edwards for inspiration!
    function Class() {}
    Class.extend = function(props) {
        // @function extend(props: Object): Function
        // [Extends the current class](#class-inheritance) given the properties to be included.
        // Returns a Javascript function that is a class constructor (to be called with `new`).
        var NewClass = function() {
            setOptions(this);
            // call the constructor
            if (this.initialize) this.initialize.apply(this, arguments);
            // call all constructor hooks
            this.callInitHooks();
        };
        var parentProto = NewClass.__super__ = this.prototype;
        var proto = create$2(parentProto);
        proto.constructor = NewClass;
        NewClass.prototype = proto;
        // inherit parent's statics
        for(var i in this)if (Object.prototype.hasOwnProperty.call(this, i) && i !== 'prototype' && i !== '__super__') NewClass[i] = this[i];
        // mix static properties into the class
        if (props.statics) extend(NewClass, props.statics);
        // mix includes into the prototype
        if (props.includes) {
            checkDeprecatedMixinEvents(props.includes);
            extend.apply(null, [
                proto
            ].concat(props.includes));
        }
        // mix given properties into the prototype
        extend(proto, props);
        delete proto.statics;
        delete proto.includes;
        // merge options
        if (proto.options) {
            proto.options = parentProto.options ? create$2(parentProto.options) : {};
            extend(proto.options, props.options);
        }
        proto._initHooks = [];
        // add method for calling all hooks
        proto.callInitHooks = function() {
            if (this._initHooksCalled) return;
            if (parentProto.callInitHooks) parentProto.callInitHooks.call(this);
            this._initHooksCalled = true;
            for(var i = 0, len = proto._initHooks.length; i < len; i++)proto._initHooks[i].call(this);
        };
        return NewClass;
    };
    // @function include(properties: Object): this
    // [Includes a mixin](#class-includes) into the current class.
    Class.include = function(props) {
        var parentOptions = this.prototype.options;
        extend(this.prototype, props);
        if (props.options) {
            this.prototype.options = parentOptions;
            this.mergeOptions(props.options);
        }
        return this;
    };
    // @function mergeOptions(options: Object): this
    // [Merges `options`](#class-options) into the defaults of the class.
    Class.mergeOptions = function(options) {
        extend(this.prototype.options, options);
        return this;
    };
    // @function addInitHook(fn: Function): this
    // Adds a [constructor hook](#class-constructor-hooks) to the class.
    Class.addInitHook = function(fn) {
        var args = Array.prototype.slice.call(arguments, 1);
        var init = typeof fn === 'function' ? fn : function() {
            this[fn].apply(this, args);
        };
        this.prototype._initHooks = this.prototype._initHooks || [];
        this.prototype._initHooks.push(init);
        return this;
    };
    function checkDeprecatedMixinEvents(includes) {
        /* global L: true */ if (typeof L === 'undefined' || !L || !L.Mixin) return;
        includes = isArray(includes) ? includes : [
            includes
        ];
        for(var i = 0; i < includes.length; i++)if (includes[i] === L.Mixin.Events) console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", new Error().stack);
    }
    /*
   * @class Evented
   * @aka L.Evented
   * @inherits Class
   *
   * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
   *
   * @example
   *
   * ```js
   * map.on('click', function(e) {
   * 	alert(e.latlng);
   * } );
   * ```
   *
   * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
   *
   * ```js
   * function onClick(e) { ... }
   *
   * map.on('click', onClick);
   * map.off('click', onClick);
   * ```
   */ var Events = {
        /* @method on(type: String, fn: Function, context?: Object): this
  	 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
  	 *
  	 * @alternative
  	 * @method on(eventMap: Object): this
  	 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
  	 */ on: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === 'object') for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context);
            }
            return this;
        },
        /* @method off(type: String, fn?: Function, context?: Object): this
  	 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
  	 *
  	 * @alternative
  	 * @method off(eventMap: Object): this
  	 * Removes a set of type/listener pairs.
  	 *
  	 * @alternative
  	 * @method off: this
  	 * Removes all listeners to all events on the object. This includes implicitly attached events.
  	 */ off: function(types, fn, context) {
            if (!arguments.length) // clear all listeners if called without arguments
            delete this._events;
            else if (typeof types === 'object') for(var type in types)this._off(type, types[type], fn);
            else {
                types = splitWords(types);
                var removeAll = arguments.length === 1;
                for(var i = 0, len = types.length; i < len; i++)if (removeAll) this._off(types[i]);
                else this._off(types[i], fn, context);
            }
            return this;
        },
        // attach listener (without syntactic sugar now)
        _on: function(type, fn, context, _once) {
            if (typeof fn !== 'function') {
                console.warn('wrong listener type: ' + typeof fn);
                return;
            }
            // check if fn already there
            if (this._listens(type, fn, context) !== false) return;
            if (context === this) // Less memory footprint.
            context = undefined;
            var newListener = {
                fn: fn,
                ctx: context
            };
            if (_once) newListener.once = true;
            this._events = this._events || {};
            this._events[type] = this._events[type] || [];
            this._events[type].push(newListener);
        },
        _off: function(type, fn, context) {
            var listeners, i, len;
            if (!this._events) return;
            listeners = this._events[type];
            if (!listeners) return;
            if (arguments.length === 1) {
                if (this._firingCount) // Set all removed listeners to noop
                // so they are not called if remove happens in fire
                for(i = 0, len = listeners.length; i < len; i++)listeners[i].fn = falseFn;
                // clear all listeners for a type if function isn't specified
                delete this._events[type];
                return;
            }
            if (typeof fn !== 'function') {
                console.warn('wrong listener type: ' + typeof fn);
                return;
            }
            // find fn and remove it
            var index = this._listens(type, fn, context);
            if (index !== false) {
                var listener = listeners[index];
                if (this._firingCount) {
                    // set the removed listener to noop so that's not called if remove happens in fire
                    listener.fn = falseFn;
                    /* copy array in case events are being fired */ this._events[type] = listeners = listeners.slice();
                }
                listeners.splice(index, 1);
            }
        },
        // @method fire(type: String, data?: Object, propagate?: Boolean): this
        // Fires an event of the specified type. You can optionally provide a data
        // object — the first argument of the listener function will contain its
        // properties. The event can optionally be propagated to event parents.
        fire: function(type, data, propagate) {
            if (!this.listens(type, propagate)) return this;
            var event = extend({}, data, {
                type: type,
                target: this,
                sourceTarget: data && data.sourceTarget || this
            });
            if (this._events) {
                var listeners = this._events[type];
                if (listeners) {
                    this._firingCount = this._firingCount + 1 || 1;
                    for(var i = 0, len = listeners.length; i < len; i++){
                        var l = listeners[i];
                        // off overwrites l.fn, so we need to copy fn to a var
                        var fn = l.fn;
                        if (l.once) this.off(type, fn, l.ctx);
                        fn.call(l.ctx || this, event);
                    }
                    this._firingCount--;
                }
            }
            if (propagate) // propagate the event to parents (set with addEventParent)
            this._propagateEvent(event);
            return this;
        },
        // @method listens(type: String, propagate?: Boolean): Boolean
        // @method listens(type: String, fn: Function, context?: Object, propagate?: Boolean): Boolean
        // Returns `true` if a particular event type has any listeners attached to it.
        // The verification can optionally be propagated, it will return `true` if parents have the listener attached to it.
        listens: function(type, fn, context, propagate) {
            if (typeof type !== 'string') console.warn('"string" type argument expected');
            // we don't overwrite the input `fn` value, because we need to use it for propagation
            var _fn = fn;
            if (typeof fn !== 'function') {
                propagate = !!fn;
                _fn = undefined;
                context = undefined;
            }
            var listeners = this._events && this._events[type];
            if (listeners && listeners.length) {
                if (this._listens(type, _fn, context) !== false) return true;
            }
            if (propagate) // also check parents for listeners if event propagates
            for(var id in this._eventParents){
                if (this._eventParents[id].listens(type, fn, context, propagate)) return true;
            }
            return false;
        },
        // returns the index (number) or false
        _listens: function(type, fn, context) {
            if (!this._events) return false;
            var listeners = this._events[type] || [];
            if (!fn) return !!listeners.length;
            if (context === this) // Less memory footprint.
            context = undefined;
            for(var i = 0, len = listeners.length; i < len; i++){
                if (listeners[i].fn === fn && listeners[i].ctx === context) return i;
            }
            return false;
        },
        // @method once(…): this
        // Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
        once: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === 'object') for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn, true);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context, true);
            }
            return this;
        },
        // @method addEventParent(obj: Evented): this
        // Adds an event parent - an `Evented` that will receive propagated events
        addEventParent: function(obj) {
            this._eventParents = this._eventParents || {};
            this._eventParents[stamp(obj)] = obj;
            return this;
        },
        // @method removeEventParent(obj: Evented): this
        // Removes an event parent, so it will stop receiving propagated events
        removeEventParent: function(obj) {
            if (this._eventParents) delete this._eventParents[stamp(obj)];
            return this;
        },
        _propagateEvent: function(e) {
            for(var id in this._eventParents)this._eventParents[id].fire(e.type, extend({
                layer: e.target,
                propagatedFrom: e.target
            }, e), true);
        }
    };
    // aliases; we should ditch those eventually
    // @method addEventListener(…): this
    // Alias to [`on(…)`](#evented-on)
    Events.addEventListener = Events.on;
    // @method removeEventListener(…): this
    // Alias to [`off(…)`](#evented-off)
    // @method clearAllEventListeners(…): this
    // Alias to [`off()`](#evented-off)
    Events.removeEventListener = Events.clearAllEventListeners = Events.off;
    // @method addOneTimeEventListener(…): this
    // Alias to [`once(…)`](#evented-once)
    Events.addOneTimeEventListener = Events.once;
    // @method fireEvent(…): this
    // Alias to [`fire(…)`](#evented-fire)
    Events.fireEvent = Events.fire;
    // @method hasEventListeners(…): Boolean
    // Alias to [`listens(…)`](#evented-listens)
    Events.hasEventListeners = Events.listens;
    var Evented = Class.extend(Events);
    /*
   * @class Point
   * @aka L.Point
   *
   * Represents a point with `x` and `y` coordinates in pixels.
   *
   * @example
   *
   * ```js
   * var point = L.point(200, 300);
   * ```
   *
   * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
   *
   * ```js
   * map.panBy([200, 300]);
   * map.panBy(L.point(200, 300));
   * ```
   *
   * Note that `Point` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Point(x, y, round) {
        // @property x: Number; The `x` coordinate of the point
        this.x = round ? Math.round(x) : x;
        // @property y: Number; The `y` coordinate of the point
        this.y = round ? Math.round(y) : y;
    }
    var trunc = Math.trunc || function(v) {
        return v > 0 ? Math.floor(v) : Math.ceil(v);
    };
    Point.prototype = {
        // @method clone(): Point
        // Returns a copy of the current point.
        clone: function() {
            return new Point(this.x, this.y);
        },
        // @method add(otherPoint: Point): Point
        // Returns the result of addition of the current and the given points.
        add: function(point) {
            // non-destructive, returns a new point
            return this.clone()._add(toPoint(point));
        },
        _add: function(point) {
            // destructive, used directly for performance in situations where it's safe to modify existing point
            this.x += point.x;
            this.y += point.y;
            return this;
        },
        // @method subtract(otherPoint: Point): Point
        // Returns the result of subtraction of the given point from the current.
        subtract: function(point) {
            return this.clone()._subtract(toPoint(point));
        },
        _subtract: function(point) {
            this.x -= point.x;
            this.y -= point.y;
            return this;
        },
        // @method divideBy(num: Number): Point
        // Returns the result of division of the current point by the given number.
        divideBy: function(num) {
            return this.clone()._divideBy(num);
        },
        _divideBy: function(num) {
            this.x /= num;
            this.y /= num;
            return this;
        },
        // @method multiplyBy(num: Number): Point
        // Returns the result of multiplication of the current point by the given number.
        multiplyBy: function(num) {
            return this.clone()._multiplyBy(num);
        },
        _multiplyBy: function(num) {
            this.x *= num;
            this.y *= num;
            return this;
        },
        // @method scaleBy(scale: Point): Point
        // Multiply each coordinate of the current point by each coordinate of
        // `scale`. In linear algebra terms, multiply the point by the
        // [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
        // defined by `scale`.
        scaleBy: function(point) {
            return new Point(this.x * point.x, this.y * point.y);
        },
        // @method unscaleBy(scale: Point): Point
        // Inverse of `scaleBy`. Divide each coordinate of the current point by
        // each coordinate of `scale`.
        unscaleBy: function(point) {
            return new Point(this.x / point.x, this.y / point.y);
        },
        // @method round(): Point
        // Returns a copy of the current point with rounded coordinates.
        round: function() {
            return this.clone()._round();
        },
        _round: function() {
            this.x = Math.round(this.x);
            this.y = Math.round(this.y);
            return this;
        },
        // @method floor(): Point
        // Returns a copy of the current point with floored coordinates (rounded down).
        floor: function() {
            return this.clone()._floor();
        },
        _floor: function() {
            this.x = Math.floor(this.x);
            this.y = Math.floor(this.y);
            return this;
        },
        // @method ceil(): Point
        // Returns a copy of the current point with ceiled coordinates (rounded up).
        ceil: function() {
            return this.clone()._ceil();
        },
        _ceil: function() {
            this.x = Math.ceil(this.x);
            this.y = Math.ceil(this.y);
            return this;
        },
        // @method trunc(): Point
        // Returns a copy of the current point with truncated coordinates (rounded towards zero).
        trunc: function() {
            return this.clone()._trunc();
        },
        _trunc: function() {
            this.x = trunc(this.x);
            this.y = trunc(this.y);
            return this;
        },
        // @method distanceTo(otherPoint: Point): Number
        // Returns the cartesian distance between the current and the given points.
        distanceTo: function(point) {
            point = toPoint(point);
            var x = point.x - this.x, y = point.y - this.y;
            return Math.sqrt(x * x + y * y);
        },
        // @method equals(otherPoint: Point): Boolean
        // Returns `true` if the given point has the same coordinates.
        equals: function(point) {
            point = toPoint(point);
            return point.x === this.x && point.y === this.y;
        },
        // @method contains(otherPoint: Point): Boolean
        // Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
        contains: function(point) {
            point = toPoint(point);
            return Math.abs(point.x) <= Math.abs(this.x) && Math.abs(point.y) <= Math.abs(this.y);
        },
        // @method toString(): String
        // Returns a string representation of the point for debugging purposes.
        toString: function() {
            return 'Point(' + formatNum(this.x) + ', ' + formatNum(this.y) + ')';
        }
    };
    // @factory L.point(x: Number, y: Number, round?: Boolean)
    // Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.
    // @alternative
    // @factory L.point(coords: Number[])
    // Expects an array of the form `[x, y]` instead.
    // @alternative
    // @factory L.point(coords: Object)
    // Expects a plain object of the form `{x: Number, y: Number}` instead.
    function toPoint(x, y, round) {
        if (x instanceof Point) return x;
        if (isArray(x)) return new Point(x[0], x[1]);
        if (x === undefined || x === null) return x;
        if (typeof x === 'object' && 'x' in x && 'y' in x) return new Point(x.x, x.y);
        return new Point(x, y, round);
    }
    /*
   * @class Bounds
   * @aka L.Bounds
   *
   * Represents a rectangular area in pixel coordinates.
   *
   * @example
   *
   * ```js
   * var p1 = L.point(10, 10),
   * p2 = L.point(40, 60),
   * bounds = L.bounds(p1, p2);
   * ```
   *
   * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * otherBounds.intersects([[10, 10], [40, 60]]);
   * ```
   *
   * Note that `Bounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Bounds(a, b) {
        if (!a) return;
        var points = b ? [
            a,
            b
        ] : a;
        for(var i = 0, len = points.length; i < len; i++)this.extend(points[i]);
    }
    Bounds.prototype = {
        // @method extend(point: Point): this
        // Extends the bounds to contain the given point.
        // @alternative
        // @method extend(otherBounds: Bounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var min2, max2;
            if (!obj) return this;
            if (obj instanceof Point || typeof obj[0] === 'number' || 'x' in obj) min2 = max2 = toPoint(obj);
            else {
                obj = toBounds(obj);
                min2 = obj.min;
                max2 = obj.max;
                if (!min2 || !max2) return this;
            }
            // @property min: Point
            // The top left corner of the rectangle.
            // @property max: Point
            // The bottom right corner of the rectangle.
            if (!this.min && !this.max) {
                this.min = min2.clone();
                this.max = max2.clone();
            } else {
                this.min.x = Math.min(min2.x, this.min.x);
                this.max.x = Math.max(max2.x, this.max.x);
                this.min.y = Math.min(min2.y, this.min.y);
                this.max.y = Math.max(max2.y, this.max.y);
            }
            return this;
        },
        // @method getCenter(round?: Boolean): Point
        // Returns the center point of the bounds.
        getCenter: function(round) {
            return toPoint((this.min.x + this.max.x) / 2, (this.min.y + this.max.y) / 2, round);
        },
        // @method getBottomLeft(): Point
        // Returns the bottom-left point of the bounds.
        getBottomLeft: function() {
            return toPoint(this.min.x, this.max.y);
        },
        // @method getTopRight(): Point
        // Returns the top-right point of the bounds.
        getTopRight: function() {
            return toPoint(this.max.x, this.min.y);
        },
        // @method getTopLeft(): Point
        // Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
        getTopLeft: function() {
            return this.min; // left, top
        },
        // @method getBottomRight(): Point
        // Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
        getBottomRight: function() {
            return this.max; // right, bottom
        },
        // @method getSize(): Point
        // Returns the size of the given bounds
        getSize: function() {
            return this.max.subtract(this.min);
        },
        // @method contains(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains(point: Point): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            var min, max;
            if (typeof obj[0] === 'number' || obj instanceof Point) obj = toPoint(obj);
            else obj = toBounds(obj);
            if (obj instanceof Bounds) {
                min = obj.min;
                max = obj.max;
            } else min = max = obj;
            return min.x >= this.min.x && max.x <= this.max.x && min.y >= this.min.y && max.y <= this.max.y;
        },
        // @method intersects(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds
        // intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xIntersects = max2.x >= min.x && min2.x <= max.x, yIntersects = max2.y >= min.y && min2.y <= max.y;
            return xIntersects && yIntersects;
        },
        // @method overlaps(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds
        // overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xOverlaps = max2.x > min.x && min2.x < max.x, yOverlaps = max2.y > min.y && min2.y < max.y;
            return xOverlaps && yOverlaps;
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this.min && this.max);
        },
        // @method pad(bufferRatio: Number): Bounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var min = this.min, max = this.max, heightBuffer = Math.abs(min.x - max.x) * bufferRatio, widthBuffer = Math.abs(min.y - max.y) * bufferRatio;
            return toBounds(toPoint(min.x - heightBuffer, min.y - widthBuffer), toPoint(max.x + heightBuffer, max.y + widthBuffer));
        },
        // @method equals(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle is equivalent to the given bounds.
        equals: function(bounds) {
            if (!bounds) return false;
            bounds = toBounds(bounds);
            return this.min.equals(bounds.getTopLeft()) && this.max.equals(bounds.getBottomRight());
        }
    };
    // @factory L.bounds(corner1: Point, corner2: Point)
    // Creates a Bounds object from two corners coordinate pairs.
    // @alternative
    // @factory L.bounds(points: Point[])
    // Creates a Bounds object from the given array of points.
    function toBounds(a, b) {
        if (!a || a instanceof Bounds) return a;
        return new Bounds(a, b);
    }
    /*
   * @class LatLngBounds
   * @aka L.LatLngBounds
   *
   * Represents a rectangular geographical area on a map.
   *
   * @example
   *
   * ```js
   * var corner1 = L.latLng(40.712, -74.227),
   * corner2 = L.latLng(40.774, -74.125),
   * bounds = L.latLngBounds(corner1, corner2);
   * ```
   *
   * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * map.fitBounds([
   * 	[40.712, -74.227],
   * 	[40.774, -74.125]
   * ]);
   * ```
   *
   * Caution: if the area crosses the antimeridian (often confused with the International Date Line), you must specify corners _outside_ the [-180, 180] degrees longitude range.
   *
   * Note that `LatLngBounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLngBounds(corner1, corner2) {
        if (!corner1) return;
        var latlngs = corner2 ? [
            corner1,
            corner2
        ] : corner1;
        for(var i = 0, len = latlngs.length; i < len; i++)this.extend(latlngs[i]);
    }
    LatLngBounds.prototype = {
        // @method extend(latlng: LatLng): this
        // Extend the bounds to contain the given point
        // @alternative
        // @method extend(otherBounds: LatLngBounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLng) {
                sw2 = obj;
                ne2 = obj;
            } else if (obj instanceof LatLngBounds) {
                sw2 = obj._southWest;
                ne2 = obj._northEast;
                if (!sw2 || !ne2) return this;
            } else return obj ? this.extend(toLatLng(obj) || toLatLngBounds(obj)) : this;
            if (!sw && !ne) {
                this._southWest = new LatLng(sw2.lat, sw2.lng);
                this._northEast = new LatLng(ne2.lat, ne2.lng);
            } else {
                sw.lat = Math.min(sw2.lat, sw.lat);
                sw.lng = Math.min(sw2.lng, sw.lng);
                ne.lat = Math.max(ne2.lat, ne.lat);
                ne.lng = Math.max(ne2.lng, ne.lng);
            }
            return this;
        },
        // @method pad(bufferRatio: Number): LatLngBounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var sw = this._southWest, ne = this._northEast, heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio, widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
            return new LatLngBounds(new LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer), new LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
        },
        // @method getCenter(): LatLng
        // Returns the center point of the bounds.
        getCenter: function() {
            return new LatLng((this._southWest.lat + this._northEast.lat) / 2, (this._southWest.lng + this._northEast.lng) / 2);
        },
        // @method getSouthWest(): LatLng
        // Returns the south-west point of the bounds.
        getSouthWest: function() {
            return this._southWest;
        },
        // @method getNorthEast(): LatLng
        // Returns the north-east point of the bounds.
        getNorthEast: function() {
            return this._northEast;
        },
        // @method getNorthWest(): LatLng
        // Returns the north-west point of the bounds.
        getNorthWest: function() {
            return new LatLng(this.getNorth(), this.getWest());
        },
        // @method getSouthEast(): LatLng
        // Returns the south-east point of the bounds.
        getSouthEast: function() {
            return new LatLng(this.getSouth(), this.getEast());
        },
        // @method getWest(): Number
        // Returns the west longitude of the bounds
        getWest: function() {
            return this._southWest.lng;
        },
        // @method getSouth(): Number
        // Returns the south latitude of the bounds
        getSouth: function() {
            return this._southWest.lat;
        },
        // @method getEast(): Number
        // Returns the east longitude of the bounds
        getEast: function() {
            return this._northEast.lng;
        },
        // @method getNorth(): Number
        // Returns the north latitude of the bounds
        getNorth: function() {
            return this._northEast.lat;
        },
        // @method contains(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains (latlng: LatLng): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            if (typeof obj[0] === 'number' || obj instanceof LatLng || 'lat' in obj) obj = toLatLng(obj);
            else obj = toLatLngBounds(obj);
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLngBounds) {
                sw2 = obj.getSouthWest();
                ne2 = obj.getNorthEast();
            } else sw2 = ne2 = obj;
            return sw2.lat >= sw.lat && ne2.lat <= ne.lat && sw2.lng >= sw.lng && ne2.lng <= ne.lng;
        },
        // @method intersects(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latIntersects = ne2.lat >= sw.lat && sw2.lat <= ne.lat, lngIntersects = ne2.lng >= sw.lng && sw2.lng <= ne.lng;
            return latIntersects && lngIntersects;
        },
        // @method overlaps(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latOverlaps = ne2.lat > sw.lat && sw2.lat < ne.lat, lngOverlaps = ne2.lng > sw.lng && sw2.lng < ne.lng;
            return latOverlaps && lngOverlaps;
        },
        // @method toBBoxString(): String
        // Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
        toBBoxString: function() {
            return [
                this.getWest(),
                this.getSouth(),
                this.getEast(),
                this.getNorth()
            ].join(',');
        },
        // @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
        // Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(bounds, maxMargin) {
            if (!bounds) return false;
            bounds = toLatLngBounds(bounds);
            return this._southWest.equals(bounds.getSouthWest(), maxMargin) && this._northEast.equals(bounds.getNorthEast(), maxMargin);
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this._southWest && this._northEast);
        }
    };
    // TODO International date line?
    // @factory L.latLngBounds(corner1: LatLng, corner2: LatLng)
    // Creates a `LatLngBounds` object by defining two diagonally opposite corners of the rectangle.
    // @alternative
    // @factory L.latLngBounds(latlngs: LatLng[])
    // Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
    function toLatLngBounds(a, b) {
        if (a instanceof LatLngBounds) return a;
        return new LatLngBounds(a, b);
    }
    /* @class LatLng
   * @aka L.LatLng
   *
   * Represents a geographical point with a certain latitude and longitude.
   *
   * @example
   *
   * ```
   * var latlng = L.latLng(50.5, 30.5);
   * ```
   *
   * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
   *
   * ```
   * map.panTo([50, 30]);
   * map.panTo({lon: 30, lat: 50});
   * map.panTo({lat: 50, lng: 30});
   * map.panTo(L.latLng(50, 30));
   * ```
   *
   * Note that `LatLng` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLng(lat, lng, alt) {
        if (isNaN(lat) || isNaN(lng)) throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
        // @property lat: Number
        // Latitude in degrees
        this.lat = +lat;
        // @property lng: Number
        // Longitude in degrees
        this.lng = +lng;
        // @property alt: Number
        // Altitude in meters (optional)
        if (alt !== undefined) this.alt = +alt;
    }
    LatLng.prototype = {
        // @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
        // Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(obj, maxMargin) {
            if (!obj) return false;
            obj = toLatLng(obj);
            var margin = Math.max(Math.abs(this.lat - obj.lat), Math.abs(this.lng - obj.lng));
            return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
        },
        // @method toString(): String
        // Returns a string representation of the point (for debugging purposes).
        toString: function(precision) {
            return 'LatLng(' + formatNum(this.lat, precision) + ', ' + formatNum(this.lng, precision) + ')';
        },
        // @method distanceTo(otherLatLng: LatLng): Number
        // Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
        distanceTo: function(other) {
            return Earth.distance(this, toLatLng(other));
        },
        // @method wrap(): LatLng
        // Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
        wrap: function() {
            return Earth.wrapLatLng(this);
        },
        // @method toBounds(sizeInMeters: Number): LatLngBounds
        // Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
        toBounds: function(sizeInMeters) {
            var latAccuracy = 180 * sizeInMeters / 40075017, lngAccuracy = latAccuracy / Math.cos(Math.PI / 180 * this.lat);
            return toLatLngBounds([
                this.lat - latAccuracy,
                this.lng - lngAccuracy
            ], [
                this.lat + latAccuracy,
                this.lng + lngAccuracy
            ]);
        },
        clone: function() {
            return new LatLng(this.lat, this.lng, this.alt);
        }
    };
    // @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
    // Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).
    // @alternative
    // @factory L.latLng(coords: Array): LatLng
    // Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.
    // @alternative
    // @factory L.latLng(coords: Object): LatLng
    // Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.
    function toLatLng(a, b, c) {
        if (a instanceof LatLng) return a;
        if (isArray(a) && typeof a[0] !== 'object') {
            if (a.length === 3) return new LatLng(a[0], a[1], a[2]);
            if (a.length === 2) return new LatLng(a[0], a[1]);
            return null;
        }
        if (a === undefined || a === null) return a;
        if (typeof a === 'object' && 'lat' in a) return new LatLng(a.lat, 'lng' in a ? a.lng : a.lon, a.alt);
        if (b === undefined) return null;
        return new LatLng(a, b, c);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.Base
   * Object that defines coordinate reference systems for projecting
   * geographical points into pixel (screen) coordinates and back (and to
   * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
   * [spatial reference system](https://en.wikipedia.org/wiki/Spatial_reference_system).
   *
   * Leaflet defines the most usual CRSs by default. If you want to use a
   * CRS not defined by default, take a look at the
   * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
   *
   * Note that the CRS instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.
   */ var CRS = {
        // @method latLngToPoint(latlng: LatLng, zoom: Number): Point
        // Projects geographical coordinates into pixel coordinates for a given zoom.
        latLngToPoint: function(latlng, zoom) {
            var projectedPoint = this.projection.project(latlng), scale = this.scale(zoom);
            return this.transformation._transform(projectedPoint, scale);
        },
        // @method pointToLatLng(point: Point, zoom: Number): LatLng
        // The inverse of `latLngToPoint`. Projects pixel coordinates on a given
        // zoom into geographical coordinates.
        pointToLatLng: function(point, zoom) {
            var scale = this.scale(zoom), untransformedPoint = this.transformation.untransform(point, scale);
            return this.projection.unproject(untransformedPoint);
        },
        // @method project(latlng: LatLng): Point
        // Projects geographical coordinates into coordinates in units accepted for
        // this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
        project: function(latlng) {
            return this.projection.project(latlng);
        },
        // @method unproject(point: Point): LatLng
        // Given a projected coordinate returns the corresponding LatLng.
        // The inverse of `project`.
        unproject: function(point) {
            return this.projection.unproject(point);
        },
        // @method scale(zoom: Number): Number
        // Returns the scale used when transforming projected coordinates into
        // pixel coordinates for a particular zoom. For example, it returns
        // `256 * 2^zoom` for Mercator-based CRS.
        scale: function(zoom) {
            return 256 * Math.pow(2, zoom);
        },
        // @method zoom(scale: Number): Number
        // Inverse of `scale()`, returns the zoom level corresponding to a scale
        // factor of `scale`.
        zoom: function(scale) {
            return Math.log(scale / 256) / Math.LN2;
        },
        // @method getProjectedBounds(zoom: Number): Bounds
        // Returns the projection's bounds scaled and transformed for the provided `zoom`.
        getProjectedBounds: function(zoom) {
            if (this.infinite) return null;
            var b = this.projection.bounds, s = this.scale(zoom), min = this.transformation.transform(b.min, s), max = this.transformation.transform(b.max, s);
            return new Bounds(min, max);
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates.
        // @property code: String
        // Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
        //
        // @property wrapLng: Number[]
        // An array of two numbers defining whether the longitude (horizontal) coordinate
        // axis wraps around a given range and how. Defaults to `[-180, 180]` in most
        // geographical CRSs. If `undefined`, the longitude axis does not wrap around.
        //
        // @property wrapLat: Number[]
        // Like `wrapLng`, but for the latitude (vertical) axis.
        // wrapLng: [min, max],
        // wrapLat: [min, max],
        // @property infinite: Boolean
        // If true, the coordinate space will be unbounded (infinite in both axes)
        infinite: false,
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where lat and lng has been wrapped according to the
        // CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
        wrapLatLng: function(latlng) {
            var lng = this.wrapLng ? wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng, lat = this.wrapLat ? wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat, alt = latlng.alt;
            return new LatLng(lat, lng, alt);
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring
        // that its center is within the CRS's bounds.
        // Only accepts actual `L.LatLngBounds` instances, not arrays.
        wrapLatLngBounds: function(bounds) {
            var center = bounds.getCenter(), newCenter = this.wrapLatLng(center), latShift = center.lat - newCenter.lat, lngShift = center.lng - newCenter.lng;
            if (latShift === 0 && lngShift === 0) return bounds;
            var sw = bounds.getSouthWest(), ne = bounds.getNorthEast(), newSw = new LatLng(sw.lat - latShift, sw.lng - lngShift), newNe = new LatLng(ne.lat - latShift, ne.lng - lngShift);
            return new LatLngBounds(newSw, newNe);
        }
    };
    /*
   * @namespace CRS
   * @crs L.CRS.Earth
   *
   * Serves as the base for CRS that are global such that they cover the earth.
   * Can only be used as the base for other CRS and cannot be used directly,
   * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
   * meters.
   */ var Earth = extend({}, CRS, {
        wrapLng: [
            -180,
            180
        ],
        // Mean Earth Radius, as recommended for use by
        // the International Union of Geodesy and Geophysics,
        // see https://rosettacode.org/wiki/Haversine_formula
        R: 6371000,
        // distance between two geographical points using spherical law of cosines approximation
        distance: function(latlng1, latlng2) {
            var rad = Math.PI / 180, lat1 = latlng1.lat * rad, lat2 = latlng2.lat * rad, sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2), sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2), a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon, c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return this.R * c;
        }
    });
    /*
   * @namespace Projection
   * @projection L.Projection.SphericalMercator
   *
   * Spherical Mercator projection — the most common projection for online maps,
   * used by almost all free and commercial tile providers. Assumes that Earth is
   * a sphere. Used by the `EPSG:3857` CRS.
   */ var earthRadius = 6378137;
    var SphericalMercator = {
        R: earthRadius,
        MAX_LATITUDE: 85.0511287798,
        project: function(latlng) {
            var d = Math.PI / 180, max = this.MAX_LATITUDE, lat = Math.max(Math.min(max, latlng.lat), -max), sin = Math.sin(lat * d);
            return new Point(this.R * latlng.lng * d, this.R * Math.log((1 + sin) / (1 - sin)) / 2);
        },
        unproject: function(point) {
            var d = 180 / Math.PI;
            return new LatLng((2 * Math.atan(Math.exp(point.y / this.R)) - Math.PI / 2) * d, point.x * d / this.R);
        },
        bounds: function() {
            var d = earthRadius * Math.PI;
            return new Bounds([
                -d,
                -d
            ], [
                d,
                d
            ]);
        }()
    };
    /*
   * @class Transformation
   * @aka L.Transformation
   *
   * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
   * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
   * the reverse. Used by Leaflet in its projections code.
   *
   * @example
   *
   * ```js
   * var transformation = L.transformation(2, 5, -1, 10),
   * 	p = L.point(1, 2),
   * 	p2 = transformation.transform(p), //  L.point(7, 8)
   * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
   * ```
   */ // factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
    // Creates a `Transformation` object with the given coefficients.
    function Transformation(a, b, c, d) {
        if (isArray(a)) {
            // use array properties
            this._a = a[0];
            this._b = a[1];
            this._c = a[2];
            this._d = a[3];
            return;
        }
        this._a = a;
        this._b = b;
        this._c = c;
        this._d = d;
    }
    Transformation.prototype = {
        // @method transform(point: Point, scale?: Number): Point
        // Returns a transformed point, optionally multiplied by the given scale.
        // Only accepts actual `L.Point` instances, not arrays.
        transform: function(point, scale) {
            return this._transform(point.clone(), scale);
        },
        // destructive transform (faster)
        _transform: function(point, scale) {
            scale = scale || 1;
            point.x = scale * (this._a * point.x + this._b);
            point.y = scale * (this._c * point.y + this._d);
            return point;
        },
        // @method untransform(point: Point, scale?: Number): Point
        // Returns the reverse transformation of the given point, optionally divided
        // by the given scale. Only accepts actual `L.Point` instances, not arrays.
        untransform: function(point, scale) {
            scale = scale || 1;
            return new Point((point.x / scale - this._b) / this._a, (point.y / scale - this._d) / this._c);
        }
    };
    // factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // @factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // Instantiates a Transformation object with the given coefficients.
    // @alternative
    // @factory L.transformation(coefficients: Array): Transformation
    // Expects an coefficients array of the form
    // `[a: Number, b: Number, c: Number, d: Number]`.
    function toTransformation(a, b, c, d) {
        return new Transformation(a, b, c, d);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3857
   *
   * The most common CRS for online maps, used by almost all free and commercial
   * tile providers. Uses Spherical Mercator projection. Set in by default in
   * Map's `crs` option.
   */ var EPSG3857 = extend({}, Earth, {
        code: 'EPSG:3857',
        projection: SphericalMercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * SphericalMercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    var EPSG900913 = extend({}, EPSG3857, {
        code: 'EPSG:900913'
    });
    // @namespace SVG; @section
    // There are several static functions which can be called without instantiating L.SVG:
    // @function create(name: String): SVGElement
    // Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
    // corresponding to the class name passed. For example, using 'line' will return
    // an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
    function svgCreate(name) {
        return document.createElementNS('http://www.w3.org/2000/svg', name);
    }
    // @function pointsToPath(rings: Point[], closed: Boolean): String
    // Generates a SVG path string for multiple rings, with each ring turning
    // into "M..L..L.." instructions
    function pointsToPath(rings, closed) {
        var str = '', i, j, len, len2, points, p;
        for(i = 0, len = rings.length; i < len; i++){
            points = rings[i];
            for(j = 0, len2 = points.length; j < len2; j++){
                p = points[j];
                str += (j ? 'L' : 'M') + p.x + ' ' + p.y;
            }
            // closes the ring for polygons; "x" is VML syntax
            str += closed ? Browser.svg ? 'z' : 'x' : '';
        }
        // SVG complains about empty path strings
        return str || 'M0 0';
    }
    /*
   * @namespace Browser
   * @aka L.Browser
   *
   * A namespace with static properties for browser/feature detection used by Leaflet internally.
   *
   * @example
   *
   * ```js
   * if (L.Browser.ielt9) {
   *   alert('Upgrade your browser, dude!');
   * }
   * ```
   */ var style = document.documentElement.style;
    // @property ie: Boolean; `true` for all Internet Explorer versions (not Edge).
    var ie = 'ActiveXObject' in window;
    // @property ielt9: Boolean; `true` for Internet Explorer versions less than 9.
    var ielt9 = ie && !document.addEventListener;
    // @property edge: Boolean; `true` for the Edge web browser.
    var edge = 'msLaunchUri' in navigator && !('documentMode' in document);
    // @property webkit: Boolean;
    // `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
    var webkit = userAgentContains('webkit');
    // @property android: Boolean
    // **Deprecated.** `true` for any browser running on an Android platform.
    var android = userAgentContains('android');
    // @property android23: Boolean; **Deprecated.** `true` for browsers running on Android 2 or Android 3.
    var android23 = userAgentContains('android 2') || userAgentContains('android 3');
    /* See https://stackoverflow.com/a/17961266 for details on detecting stock Android */ var webkitVer = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10); // also matches AppleWebKit
    // @property androidStock: Boolean; **Deprecated.** `true` for the Android stock browser (i.e. not Chrome)
    var androidStock = android && userAgentContains('Google') && webkitVer < 537 && !('AudioNode' in window);
    // @property opera: Boolean; `true` for the Opera browser
    var opera = !!window.opera;
    // @property chrome: Boolean; `true` for the Chrome browser.
    var chrome = !edge && userAgentContains('chrome');
    // @property gecko: Boolean; `true` for gecko-based browsers like Firefox.
    var gecko = userAgentContains('gecko') && !webkit && !opera && !ie;
    // @property safari: Boolean; `true` for the Safari browser.
    var safari = !chrome && userAgentContains('safari');
    var phantom = userAgentContains('phantom');
    // @property opera12: Boolean
    // `true` for the Opera browser supporting CSS transforms (version 12 or later).
    var opera12 = 'OTransition' in style;
    // @property win: Boolean; `true` when the browser is running in a Windows platform
    var win = navigator.platform.indexOf('Win') === 0;
    // @property ie3d: Boolean; `true` for all Internet Explorer versions supporting CSS transforms.
    var ie3d = ie && 'transition' in style;
    // @property webkit3d: Boolean; `true` for webkit-based browsers supporting CSS transforms.
    var webkit3d = 'WebKitCSSMatrix' in window && 'm11' in new window.WebKitCSSMatrix() && !android23;
    // @property gecko3d: Boolean; `true` for gecko-based browsers supporting CSS transforms.
    var gecko3d = 'MozPerspective' in style;
    // @property any3d: Boolean
    // `true` for all browsers supporting CSS transforms.
    var any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantom;
    // @property mobile: Boolean; `true` for all browsers running in a mobile device.
    var mobile = typeof orientation !== 'undefined' || userAgentContains('mobile');
    // @property mobileWebkit: Boolean; `true` for all webkit-based browsers in a mobile device.
    var mobileWebkit = mobile && webkit;
    // @property mobileWebkit3d: Boolean
    // `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
    var mobileWebkit3d = mobile && webkit3d;
    // @property msPointer: Boolean
    // `true` for browsers implementing the Microsoft touch events model (notably IE10).
    var msPointer = !window.PointerEvent && window.MSPointerEvent;
    // @property pointer: Boolean
    // `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
    var pointer = !!(window.PointerEvent || msPointer);
    // @property touchNative: Boolean
    // `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
    // **This does not necessarily mean** that the browser is running in a computer with
    // a touchscreen, it only means that the browser is capable of understanding
    // touch events.
    var touchNative = 'ontouchstart' in window || !!window.TouchEvent;
    // @property touch: Boolean
    // `true` for all browsers supporting either [touch](#browser-touch) or [pointer](#browser-pointer) events.
    // Note: pointer events will be preferred (if available), and processed for all `touch*` listeners.
    var touch = !window.L_NO_TOUCH && (touchNative || pointer);
    // @property mobileOpera: Boolean; `true` for the Opera browser in a mobile device.
    var mobileOpera = mobile && opera;
    // @property mobileGecko: Boolean
    // `true` for gecko-based browsers running in a mobile device.
    var mobileGecko = mobile && gecko;
    // @property retina: Boolean
    // `true` for browsers on a high-resolution "retina" screen or on any screen when browser's display zoom is more than 100%.
    var retina = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1;
    // @property passiveEvents: Boolean
    // `true` for browsers that support passive events.
    var passiveEvents = function() {
        var supportsPassiveOption = false;
        try {
            var opts = Object.defineProperty({}, 'passive', {
                get: function() {
                    supportsPassiveOption = true;
                }
            });
            window.addEventListener('testPassiveEventSupport', falseFn, opts);
            window.removeEventListener('testPassiveEventSupport', falseFn, opts);
        } catch (e) {
        // Errors can safely be ignored since this is only a browser support test.
        }
        return supportsPassiveOption;
    }();
    // @property canvas: Boolean
    // `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
    var canvas$1 = function() {
        return !!document.createElement('canvas').getContext;
    }();
    // @property svg: Boolean
    // `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
    var svg$1 = !!(document.createElementNS && svgCreate('svg').createSVGRect);
    var inlineSvg = !!svg$1 && function() {
        var div = document.createElement('div');
        div.innerHTML = '<svg/>';
        return (div.firstChild && div.firstChild.namespaceURI) === 'http://www.w3.org/2000/svg';
    }();
    // @property vml: Boolean
    // `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
    var vml = !svg$1 && function() {
        try {
            var div = document.createElement('div');
            div.innerHTML = '<v:shape adj="1"/>';
            var shape = div.firstChild;
            shape.style.behavior = 'url(#default#VML)';
            return shape && typeof shape.adj === 'object';
        } catch (e) {
            return false;
        }
    }();
    // @property mac: Boolean; `true` when the browser is running in a Mac platform
    var mac = navigator.platform.indexOf('Mac') === 0;
    // @property mac: Boolean; `true` when the browser is running in a Linux platform
    var linux = navigator.platform.indexOf('Linux') === 0;
    function userAgentContains(str) {
        return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
    }
    var Browser = {
        ie: ie,
        ielt9: ielt9,
        edge: edge,
        webkit: webkit,
        android: android,
        android23: android23,
        androidStock: androidStock,
        opera: opera,
        chrome: chrome,
        gecko: gecko,
        safari: safari,
        phantom: phantom,
        opera12: opera12,
        win: win,
        ie3d: ie3d,
        webkit3d: webkit3d,
        gecko3d: gecko3d,
        any3d: any3d,
        mobile: mobile,
        mobileWebkit: mobileWebkit,
        mobileWebkit3d: mobileWebkit3d,
        msPointer: msPointer,
        pointer: pointer,
        touch: touch,
        touchNative: touchNative,
        mobileOpera: mobileOpera,
        mobileGecko: mobileGecko,
        retina: retina,
        passiveEvents: passiveEvents,
        canvas: canvas$1,
        svg: svg$1,
        vml: vml,
        inlineSvg: inlineSvg,
        mac: mac,
        linux: linux
    };
    /*
   * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
   */ var POINTER_DOWN = Browser.msPointer ? 'MSPointerDown' : 'pointerdown';
    var POINTER_MOVE = Browser.msPointer ? 'MSPointerMove' : 'pointermove';
    var POINTER_UP = Browser.msPointer ? 'MSPointerUp' : 'pointerup';
    var POINTER_CANCEL = Browser.msPointer ? 'MSPointerCancel' : 'pointercancel';
    var pEvent = {
        touchstart: POINTER_DOWN,
        touchmove: POINTER_MOVE,
        touchend: POINTER_UP,
        touchcancel: POINTER_CANCEL
    };
    var handle = {
        touchstart: _onPointerStart,
        touchmove: _handlePointer,
        touchend: _handlePointer,
        touchcancel: _handlePointer
    };
    var _pointers = {};
    var _pointerDocListener = false;
    // Provides a touch events wrapper for (ms)pointer events.
    // ref https://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890
    function addPointerListener(obj, type, handler) {
        if (type === 'touchstart') _addPointerDocListener();
        if (!handle[type]) {
            console.warn('wrong event specified:', type);
            return falseFn;
        }
        handler = handle[type].bind(this, handler);
        obj.addEventListener(pEvent[type], handler, false);
        return handler;
    }
    function removePointerListener(obj, type, handler) {
        if (!pEvent[type]) {
            console.warn('wrong event specified:', type);
            return;
        }
        obj.removeEventListener(pEvent[type], handler, false);
    }
    function _globalPointerDown(e) {
        _pointers[e.pointerId] = e;
    }
    function _globalPointerMove(e) {
        if (_pointers[e.pointerId]) _pointers[e.pointerId] = e;
    }
    function _globalPointerUp(e) {
        delete _pointers[e.pointerId];
    }
    function _addPointerDocListener() {
        // need to keep track of what pointers and how many are active to provide e.touches emulation
        if (!_pointerDocListener) {
            // we listen document as any drags that end by moving the touch off the screen get fired there
            document.addEventListener(POINTER_DOWN, _globalPointerDown, true);
            document.addEventListener(POINTER_MOVE, _globalPointerMove, true);
            document.addEventListener(POINTER_UP, _globalPointerUp, true);
            document.addEventListener(POINTER_CANCEL, _globalPointerUp, true);
            _pointerDocListener = true;
        }
    }
    function _handlePointer(handler, e) {
        if (e.pointerType === (e.MSPOINTER_TYPE_MOUSE || 'mouse')) return;
        e.touches = [];
        for(var i in _pointers)e.touches.push(_pointers[i]);
        e.changedTouches = [
            e
        ];
        handler(e);
    }
    function _onPointerStart(handler, e) {
        // IE10 specific: MsTouch needs preventDefault. See #2000
        if (e.MSPOINTER_TYPE_TOUCH && e.pointerType === e.MSPOINTER_TYPE_TOUCH) preventDefault(e);
        _handlePointer(handler, e);
    }
    /*
   * Extends the event handling code with double tap support for mobile browsers.
   *
   * Note: currently most browsers fire native dblclick, with only a few exceptions
   * (see https://github.com/Leaflet/Leaflet/issues/7012#issuecomment-595087386)
   */ function makeDblclick(event) {
        // in modern browsers `type` cannot be just overridden:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only
        var newEvent = {}, prop, i;
        for(i in event){
            prop = event[i];
            newEvent[i] = prop && prop.bind ? prop.bind(event) : prop;
        }
        event = newEvent;
        newEvent.type = 'dblclick';
        newEvent.detail = 2;
        newEvent.isTrusted = false;
        newEvent._simulated = true; // for debug purposes
        return newEvent;
    }
    var delay = 200;
    function addDoubleTapListener(obj, handler) {
        // Most browsers handle double tap natively
        obj.addEventListener('dblclick', handler);
        // On some platforms the browser doesn't fire native dblclicks for touch events.
        // It seems that in all such cases `detail` property of `click` event is always `1`.
        // So here we rely on that fact to avoid excessive 'dblclick' simulation when not needed.
        var last = 0, detail;
        function simDblclick(e) {
            if (e.detail !== 1) {
                detail = e.detail; // keep in sync to avoid false dblclick in some cases
                return;
            }
            if (e.pointerType === 'mouse' || e.sourceCapabilities && !e.sourceCapabilities.firesTouchEvents) return;
            // When clicking on an <input>, the browser generates a click on its
            // <label> (and vice versa) triggering two clicks in quick succession.
            // This ignores clicks on elements which are a label with a 'for'
            // attribute (or children of such a label), but not children of
            // a <input>.
            var path = getPropagationPath(e);
            if (path.some(function(el) {
                return el instanceof HTMLLabelElement && el.attributes.for;
            }) && !path.some(function(el) {
                return el instanceof HTMLInputElement || el instanceof HTMLSelectElement;
            })) return;
            var now = Date.now();
            if (now - last <= delay) {
                detail++;
                if (detail === 2) handler(makeDblclick(e));
            } else detail = 1;
            last = now;
        }
        obj.addEventListener('click', simDblclick);
        return {
            dblclick: handler,
            simDblclick: simDblclick
        };
    }
    function removeDoubleTapListener(obj, handlers) {
        obj.removeEventListener('dblclick', handlers.dblclick);
        obj.removeEventListener('click', handlers.simDblclick);
    }
    /*
   * @namespace DomUtil
   *
   * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
   * tree, used by Leaflet internally.
   *
   * Most functions expecting or returning a `HTMLElement` also work for
   * SVG elements. The only difference is that classes refer to CSS classes
   * in HTML and SVG classes in SVG.
   */ // @property TRANSFORM: String
    // Vendor-prefixed transform style name (e.g. `'webkitTransform'` for WebKit).
    var TRANSFORM = testProp([
        'transform',
        'webkitTransform',
        'OTransform',
        'MozTransform',
        'msTransform'
    ]);
    // webkitTransition comes first because some browser versions that drop vendor prefix don't do
    // the same for the transitionend event, in particular the Android 4.1 stock browser
    // @property TRANSITION: String
    // Vendor-prefixed transition style name.
    var TRANSITION = testProp([
        'webkitTransition',
        'transition',
        'OTransition',
        'MozTransition',
        'msTransition'
    ]);
    // @property TRANSITION_END: String
    // Vendor-prefixed transitionend event name.
    var TRANSITION_END = TRANSITION === 'webkitTransition' || TRANSITION === 'OTransition' ? TRANSITION + 'End' : 'transitionend';
    // @function get(id: String|HTMLElement): HTMLElement
    // Returns an element given its DOM id, or returns the element itself
    // if it was passed directly.
    function get(id) {
        return typeof id === 'string' ? document.getElementById(id) : id;
    }
    // @function getStyle(el: HTMLElement, styleAttrib: String): String
    // Returns the value for a certain style attribute on an element,
    // including computed values or values set through CSS.
    function getStyle(el, style) {
        var value = el.style[style] || el.currentStyle && el.currentStyle[style];
        if ((!value || value === 'auto') && document.defaultView) {
            var css = document.defaultView.getComputedStyle(el, null);
            value = css ? css[style] : null;
        }
        return value === 'auto' ? null : value;
    }
    // @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
    // Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
    function create$1(tagName, className, container) {
        var el = document.createElement(tagName);
        el.className = className || '';
        if (container) container.appendChild(el);
        return el;
    }
    // @function remove(el: HTMLElement)
    // Removes `el` from its parent element
    function remove(el) {
        var parent = el.parentNode;
        if (parent) parent.removeChild(el);
    }
    // @function empty(el: HTMLElement)
    // Removes all of `el`'s children elements from `el`
    function empty(el) {
        while(el.firstChild)el.removeChild(el.firstChild);
    }
    // @function toFront(el: HTMLElement)
    // Makes `el` the last child of its parent, so it renders in front of the other children.
    function toFront(el) {
        var parent = el.parentNode;
        if (parent && parent.lastChild !== el) parent.appendChild(el);
    }
    // @function toBack(el: HTMLElement)
    // Makes `el` the first child of its parent, so it renders behind the other children.
    function toBack(el) {
        var parent = el.parentNode;
        if (parent && parent.firstChild !== el) parent.insertBefore(el, parent.firstChild);
    }
    // @function hasClass(el: HTMLElement, name: String): Boolean
    // Returns `true` if the element's class attribute contains `name`.
    function hasClass(el, name) {
        if (el.classList !== undefined) return el.classList.contains(name);
        var className = getClass(el);
        return className.length > 0 && new RegExp('(^|\\s)' + name + '(\\s|$)').test(className);
    }
    // @function addClass(el: HTMLElement, name: String)
    // Adds `name` to the element's class attribute.
    function addClass(el, name) {
        if (el.classList !== undefined) {
            var classes = splitWords(name);
            for(var i = 0, len = classes.length; i < len; i++)el.classList.add(classes[i]);
        } else if (!hasClass(el, name)) {
            var className = getClass(el);
            setClass(el, (className ? className + ' ' : '') + name);
        }
    }
    // @function removeClass(el: HTMLElement, name: String)
    // Removes `name` from the element's class attribute.
    function removeClass(el, name) {
        if (el.classList !== undefined) el.classList.remove(name);
        else setClass(el, trim((' ' + getClass(el) + ' ').replace(' ' + name + ' ', ' ')));
    }
    // @function setClass(el: HTMLElement, name: String)
    // Sets the element's class.
    function setClass(el, name) {
        if (el.className.baseVal === undefined) el.className = name;
        else // in case of SVG element
        el.className.baseVal = name;
    }
    // @function getClass(el: HTMLElement): String
    // Returns the element's class.
    function getClass(el) {
        // Check if the element is an SVGElementInstance and use the correspondingElement instead
        // (Required for linked SVG elements in IE11.)
        if (el.correspondingElement) el = el.correspondingElement;
        return el.className.baseVal === undefined ? el.className : el.className.baseVal;
    }
    // @function setOpacity(el: HTMLElement, opacity: Number)
    // Set the opacity of an element (including old IE support).
    // `opacity` must be a number from `0` to `1`.
    function setOpacity(el, value) {
        if ('opacity' in el.style) el.style.opacity = value;
        else if ('filter' in el.style) _setOpacityIE(el, value);
    }
    function _setOpacityIE(el, value) {
        var filter = false, filterName = 'DXImageTransform.Microsoft.Alpha';
        // filters collection throws an error if we try to retrieve a filter that doesn't exist
        try {
            filter = el.filters.item(filterName);
        } catch (e) {
            // don't set opacity to 1 if we haven't already set an opacity,
            // it isn't needed and breaks transparent pngs.
            if (value === 1) return;
        }
        value = Math.round(value * 100);
        if (filter) {
            filter.Enabled = value !== 100;
            filter.Opacity = value;
        } else el.style.filter += ' progid:' + filterName + '(opacity=' + value + ')';
    }
    // @function testProp(props: String[]): String|false
    // Goes through the array of style names and returns the first name
    // that is a valid style name for an element. If no such name is found,
    // it returns false. Useful for vendor-prefixed styles like `transform`.
    function testProp(props) {
        var style = document.documentElement.style;
        for(var i = 0; i < props.length; i++){
            if (props[i] in style) return props[i];
        }
        return false;
    }
    // @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
    // Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
    // and optionally scaled by `scale`. Does not have an effect if the
    // browser doesn't support 3D CSS transforms.
    function setTransform(el, offset, scale) {
        var pos = offset || new Point(0, 0);
        el.style[TRANSFORM] = (Browser.ie3d ? 'translate(' + pos.x + 'px,' + pos.y + 'px)' : 'translate3d(' + pos.x + 'px,' + pos.y + 'px,0)') + (scale ? ' scale(' + scale + ')' : '');
    }
    // @function setPosition(el: HTMLElement, position: Point)
    // Sets the position of `el` to coordinates specified by `position`,
    // using CSS translate or top/left positioning depending on the browser
    // (used by Leaflet internally to position its layers).
    function setPosition(el, point) {
        /*eslint-disable */ el._leaflet_pos = point;
        /* eslint-enable */ if (Browser.any3d) setTransform(el, point);
        else {
            el.style.left = point.x + 'px';
            el.style.top = point.y + 'px';
        }
    }
    // @function getPosition(el: HTMLElement): Point
    // Returns the coordinates of an element previously positioned with setPosition.
    function getPosition(el) {
        // this method is only used for elements previously positioned using setPosition,
        // so it's safe to cache the position for performance
        return el._leaflet_pos || new Point(0, 0);
    }
    // @function disableTextSelection()
    // Prevents the user from generating `selectstart` DOM events, usually generated
    // when the user drags the mouse through a page with text. Used internally
    // by Leaflet to override the behaviour of any click-and-drag interaction on
    // the map. Affects drag interactions on the whole document.
    // @function enableTextSelection()
    // Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
    var disableTextSelection;
    var enableTextSelection;
    var _userSelect;
    if ('onselectstart' in document) {
        disableTextSelection = function() {
            on(window, 'selectstart', preventDefault);
        };
        enableTextSelection = function() {
            off(window, 'selectstart', preventDefault);
        };
    } else {
        var userSelectProperty = testProp([
            'userSelect',
            'WebkitUserSelect',
            'OUserSelect',
            'MozUserSelect',
            'msUserSelect'
        ]);
        disableTextSelection = function() {
            if (userSelectProperty) {
                var style = document.documentElement.style;
                _userSelect = style[userSelectProperty];
                style[userSelectProperty] = 'none';
            }
        };
        enableTextSelection = function() {
            if (userSelectProperty) {
                document.documentElement.style[userSelectProperty] = _userSelect;
                _userSelect = undefined;
            }
        };
    }
    // @function disableImageDrag()
    // As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
    // for `dragstart` DOM events, usually generated when the user drags an image.
    function disableImageDrag() {
        on(window, 'dragstart', preventDefault);
    }
    // @function enableImageDrag()
    // Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
    function enableImageDrag() {
        off(window, 'dragstart', preventDefault);
    }
    var _outlineElement, _outlineStyle;
    // @function preventOutline(el: HTMLElement)
    // Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
    // of the element `el` invisible. Used internally by Leaflet to prevent
    // focusable elements from displaying an outline when the user performs a
    // drag interaction on them.
    function preventOutline(element) {
        while(element.tabIndex === -1)element = element.parentNode;
        if (!element.style) return;
        restoreOutline();
        _outlineElement = element;
        _outlineStyle = element.style.outlineStyle;
        element.style.outlineStyle = 'none';
        on(window, 'keydown', restoreOutline);
    }
    // @function restoreOutline()
    // Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
    function restoreOutline() {
        if (!_outlineElement) return;
        _outlineElement.style.outlineStyle = _outlineStyle;
        _outlineElement = undefined;
        _outlineStyle = undefined;
        off(window, 'keydown', restoreOutline);
    }
    // @function getSizedParentNode(el: HTMLElement): HTMLElement
    // Finds the closest parent node which size (width and height) is not null.
    function getSizedParentNode(element) {
        do element = element.parentNode;
        while ((!element.offsetWidth || !element.offsetHeight) && element !== document.body);
        return element;
    }
    // @function getScale(el: HTMLElement): Object
    // Computes the CSS scale currently applied on the element.
    // Returns an object with `x` and `y` members as horizontal and vertical scales respectively,
    // and `boundingClientRect` as the result of [`getBoundingClientRect()`](https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect).
    function getScale(element) {
        var rect = element.getBoundingClientRect(); // Read-only in old browsers.
        return {
            x: rect.width / element.offsetWidth || 1,
            y: rect.height / element.offsetHeight || 1,
            boundingClientRect: rect
        };
    }
    var DomUtil = {
        __proto__: null,
        TRANSFORM: TRANSFORM,
        TRANSITION: TRANSITION,
        TRANSITION_END: TRANSITION_END,
        get: get,
        getStyle: getStyle,
        create: create$1,
        remove: remove,
        empty: empty,
        toFront: toFront,
        toBack: toBack,
        hasClass: hasClass,
        addClass: addClass,
        removeClass: removeClass,
        setClass: setClass,
        getClass: getClass,
        setOpacity: setOpacity,
        testProp: testProp,
        setTransform: setTransform,
        setPosition: setPosition,
        getPosition: getPosition,
        get disableTextSelection () {
            return disableTextSelection;
        },
        get enableTextSelection () {
            return enableTextSelection;
        },
        disableImageDrag: disableImageDrag,
        enableImageDrag: enableImageDrag,
        preventOutline: preventOutline,
        restoreOutline: restoreOutline,
        getSizedParentNode: getSizedParentNode,
        getScale: getScale
    };
    /*
   * @namespace DomEvent
   * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
   */ // Inspired by John Resig, Dean Edwards and YUI addEvent implementations.
    // @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Adds a listener function (`fn`) to a particular DOM event type of the
    // element `el`. You can optionally specify the context of the listener
    // (object the `this` keyword will point to). You can also pass several
    // space-separated types (e.g. `'click dblclick'`).
    // @alternative
    // @function on(el: HTMLElement, eventMap: Object, context?: Object): this
    // Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    function on(obj, types, fn, context) {
        if (types && typeof types === 'object') for(var type in types)addOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            for(var i = 0, len = types.length; i < len; i++)addOne(obj, types[i], fn, context);
        }
        return this;
    }
    var eventsKey = '_leaflet_events';
    // @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Removes a previously added listener function.
    // Note that if you passed a custom context to on, you must pass the same
    // context to `off` in order to remove the listener.
    // @alternative
    // @function off(el: HTMLElement, eventMap: Object, context?: Object): this
    // Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    // @alternative
    // @function off(el: HTMLElement, types: String): this
    // Removes all previously added listeners of given types.
    // @alternative
    // @function off(el: HTMLElement): this
    // Removes all previously added listeners from given HTMLElement
    function off(obj, types, fn, context) {
        if (arguments.length === 1) {
            batchRemove(obj);
            delete obj[eventsKey];
        } else if (types && typeof types === 'object') for(var type in types)removeOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            if (arguments.length === 2) batchRemove(obj, function(type) {
                return indexOf(types, type) !== -1;
            });
            else for(var i = 0, len = types.length; i < len; i++)removeOne(obj, types[i], fn, context);
        }
        return this;
    }
    function batchRemove(obj, filterFn) {
        for(var id in obj[eventsKey]){
            var type = id.split(/\d/)[0];
            if (!filterFn || filterFn(type)) removeOne(obj, type, null, null, id);
        }
    }
    var mouseSubst = {
        mouseenter: 'mouseover',
        mouseleave: 'mouseout',
        wheel: !('onwheel' in window) && 'mousewheel'
    };
    function addOne(obj, type, fn, context) {
        var id = type + stamp(fn) + (context ? '_' + stamp(context) : '');
        if (obj[eventsKey] && obj[eventsKey][id]) return this;
        var handler = function(e) {
            return fn.call(context || obj, e || window.event);
        };
        var originalHandler = handler;
        if (!Browser.touchNative && Browser.pointer && type.indexOf('touch') === 0) // Needs DomEvent.Pointer.js
        handler = addPointerListener(obj, type, handler);
        else if (Browser.touch && type === 'dblclick') handler = addDoubleTapListener(obj, handler);
        else if ('addEventListener' in obj) {
            if (type === 'touchstart' || type === 'touchmove' || type === 'wheel' || type === 'mousewheel') obj.addEventListener(mouseSubst[type] || type, handler, Browser.passiveEvents ? {
                passive: false
            } : false);
            else if (type === 'mouseenter' || type === 'mouseleave') {
                handler = function(e) {
                    e = e || window.event;
                    if (isExternalTarget(obj, e)) originalHandler(e);
                };
                obj.addEventListener(mouseSubst[type], handler, false);
            } else obj.addEventListener(type, originalHandler, false);
        } else obj.attachEvent('on' + type, handler);
        obj[eventsKey] = obj[eventsKey] || {};
        obj[eventsKey][id] = handler;
    }
    function removeOne(obj, type, fn, context, id) {
        id = id || type + stamp(fn) + (context ? '_' + stamp(context) : '');
        var handler = obj[eventsKey] && obj[eventsKey][id];
        if (!handler) return this;
        if (!Browser.touchNative && Browser.pointer && type.indexOf('touch') === 0) removePointerListener(obj, type, handler);
        else if (Browser.touch && type === 'dblclick') removeDoubleTapListener(obj, handler);
        else if ('removeEventListener' in obj) obj.removeEventListener(mouseSubst[type] || type, handler, false);
        else obj.detachEvent('on' + type, handler);
        obj[eventsKey][id] = null;
    }
    // @function stopPropagation(ev: DOMEvent): this
    // Stop the given event from propagation to parent elements. Used inside the listener functions:
    // ```js
    // L.DomEvent.on(div, 'click', function (ev) {
    // 	L.DomEvent.stopPropagation(ev);
    // });
    // ```
    function stopPropagation(e) {
        if (e.stopPropagation) e.stopPropagation();
        else if (e.originalEvent) e.originalEvent._stopped = true;
        else e.cancelBubble = true;
        return this;
    }
    // @function disableScrollPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'wheel'` events (plus browser variants).
    function disableScrollPropagation(el) {
        addOne(el, 'wheel', stopPropagation);
        return this;
    }
    // @function disableClickPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'click'`, `'dblclick'`, `'contextmenu'`,
    // `'mousedown'` and `'touchstart'` events (plus browser variants).
    function disableClickPropagation(el) {
        on(el, 'mousedown touchstart dblclick contextmenu', stopPropagation);
        el['_leaflet_disable_click'] = true;
        return this;
    }
    // @function preventDefault(ev: DOMEvent): this
    // Prevents the default action of the DOM Event `ev` from happening (such as
    // following a link in the href of the a element, or doing a POST request
    // with page reload when a `<form>` is submitted).
    // Use it inside listener functions.
    function preventDefault(e) {
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return this;
    }
    // @function stop(ev: DOMEvent): this
    // Does `stopPropagation` and `preventDefault` at the same time.
    function stop(e) {
        preventDefault(e);
        stopPropagation(e);
        return this;
    }
    // @function getPropagationPath(ev: DOMEvent): Array
    // Compatibility polyfill for [`Event.composedPath()`](https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath).
    // Returns an array containing the `HTMLElement`s that the given DOM event
    // should propagate to (if not stopped).
    function getPropagationPath(ev) {
        if (ev.composedPath) return ev.composedPath();
        var path = [];
        var el = ev.target;
        while(el){
            path.push(el);
            el = el.parentNode;
        }
        return path;
    }
    // @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
    // Gets normalized mouse position from a DOM event relative to the
    // `container` (border excluded) or to the whole page if not specified.
    function getMousePosition(e, container) {
        if (!container) return new Point(e.clientX, e.clientY);
        var scale = getScale(container), offset = scale.boundingClientRect; // left and top  values are in page scale (like the event clientX/Y)
        return new Point(// offset.left/top values are in page scale (like clientX/Y),
        // whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
        (e.clientX - offset.left) / scale.x - container.clientLeft, (e.clientY - offset.top) / scale.y - container.clientTop);
    }
    //  except , Safari and
    // We need double the scroll pixels (see #7403 and #4538) for all Browsers
    // except OSX (Mac) -> 3x, Chrome running on Linux 1x
    var wheelPxFactor = Browser.linux && Browser.chrome ? window.devicePixelRatio : Browser.mac ? window.devicePixelRatio * 3 : window.devicePixelRatio > 0 ? 2 * window.devicePixelRatio : 1;
    // @function getWheelDelta(ev: DOMEvent): Number
    // Gets normalized wheel delta from a wheel DOM event, in vertical
    // pixels scrolled (negative if scrolling down).
    // Events from pointing devices without precise scrolling are mapped to
    // a best guess of 60 pixels.
    function getWheelDelta(e) {
        return Browser.edge ? e.wheelDeltaY / 2 : e.deltaY && e.deltaMode === 0 ? -e.deltaY / wheelPxFactor : e.deltaY && e.deltaMode === 1 ? -e.deltaY * 20 : e.deltaY && e.deltaMode === 2 ? -e.deltaY * 60 : e.deltaX || e.deltaZ ? 0 : e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : e.detail && Math.abs(e.detail) < 32765 ? -e.detail * 20 : e.detail ? e.detail / -32765 * 60 : 0;
    }
    // check if element really left/entered the event target (for mouseenter/mouseleave)
    function isExternalTarget(el, e) {
        var related = e.relatedTarget;
        if (!related) return true;
        try {
            while(related && related !== el)related = related.parentNode;
        } catch (err) {
            return false;
        }
        return related !== el;
    }
    var DomEvent = {
        __proto__: null,
        on: on,
        off: off,
        stopPropagation: stopPropagation,
        disableScrollPropagation: disableScrollPropagation,
        disableClickPropagation: disableClickPropagation,
        preventDefault: preventDefault,
        stop: stop,
        getPropagationPath: getPropagationPath,
        getMousePosition: getMousePosition,
        getWheelDelta: getWheelDelta,
        isExternalTarget: isExternalTarget,
        addListener: on,
        removeListener: off
    };
    /*
   * @class PosAnimation
   * @aka L.PosAnimation
   * @inherits Evented
   * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
   *
   * @example
   * ```js
   * var myPositionMarker = L.marker([48.864716, 2.294694]).addTo(map);
   *
   * myPositionMarker.on("click", function() {
   * 	var pos = map.latLngToLayerPoint(myPositionMarker.getLatLng());
   * 	pos.y -= 25;
   * 	var fx = new L.PosAnimation();
   *
   * 	fx.once('end',function() {
   * 		pos.y += 25;
   * 		fx.run(myPositionMarker._icon, pos, 0.8);
   * 	});
   *
   * 	fx.run(myPositionMarker._icon, pos, 0.3);
   * });
   *
   * ```
   *
   * @constructor L.PosAnimation()
   * Creates a `PosAnimation` object.
   *
   */ var PosAnimation = Evented.extend({
        // @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
        // Run an animation of a given element to a new position, optionally setting
        // duration in seconds (`0.25` by default) and easing linearity factor (3rd
        // argument of the [cubic bezier curve](https://cubic-bezier.com/#0,0,.5,1),
        // `0.5` by default).
        run: function(el, newPos, duration, easeLinearity) {
            this.stop();
            this._el = el;
            this._inProgress = true;
            this._duration = duration || 0.25;
            this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
            this._startPos = getPosition(el);
            this._offset = newPos.subtract(this._startPos);
            this._startTime = +new Date();
            // @event start: Event
            // Fired when the animation starts
            this.fire('start');
            this._animate();
        },
        // @method stop()
        // Stops the animation (if currently running).
        stop: function() {
            if (!this._inProgress) return;
            this._step(true);
            this._complete();
        },
        _animate: function() {
            // animation loop
            this._animId = requestAnimFrame(this._animate, this);
            this._step();
        },
        _step: function(round) {
            var elapsed = +new Date() - this._startTime, duration = this._duration * 1000;
            if (elapsed < duration) this._runFrame(this._easeOut(elapsed / duration), round);
            else {
                this._runFrame(1);
                this._complete();
            }
        },
        _runFrame: function(progress, round) {
            var pos = this._startPos.add(this._offset.multiplyBy(progress));
            if (round) pos._round();
            setPosition(this._el, pos);
            // @event step: Event
            // Fired continuously during the animation.
            this.fire('step');
        },
        _complete: function() {
            cancelAnimFrame(this._animId);
            this._inProgress = false;
            // @event end: Event
            // Fired when the animation ends.
            this.fire('end');
        },
        _easeOut: function(t) {
            return 1 - Math.pow(1 - t, this._easeOutPower);
        }
    });
    /*
   * @class Map
   * @aka L.Map
   * @inherits Evented
   *
   * The central class of the API — it is used to create a map on a page and manipulate it.
   *
   * @example
   *
   * ```js
   * // initialize the map on the "map" div with a given center and zoom
   * var map = L.map('map', {
   * 	center: [51.505, -0.09],
   * 	zoom: 13
   * });
   * ```
   *
   */ var Map = Evented.extend({
        options: {
            // @section Map State Options
            // @option crs: CRS = L.CRS.EPSG3857
            // The [Coordinate Reference System](#crs) to use. Don't change this if you're not
            // sure what it means.
            crs: EPSG3857,
            // @option center: LatLng = undefined
            // Initial geographic center of the map
            center: undefined,
            // @option zoom: Number = undefined
            // Initial map zoom level
            zoom: undefined,
            // @option minZoom: Number = *
            // Minimum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the lowest of their `minZoom` options will be used instead.
            minZoom: undefined,
            // @option maxZoom: Number = *
            // Maximum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the highest of their `maxZoom` options will be used instead.
            maxZoom: undefined,
            // @option layers: Layer[] = []
            // Array of layers that will be added to the map initially
            layers: [],
            // @option maxBounds: LatLngBounds = null
            // When this option is set, the map restricts the view to the given
            // geographical bounds, bouncing the user back if the user tries to pan
            // outside the view. To set the restriction dynamically, use
            // [`setMaxBounds`](#map-setmaxbounds) method.
            maxBounds: undefined,
            // @option renderer: Renderer = *
            // The default method for drawing vector layers on the map. `L.SVG`
            // or `L.Canvas` by default depending on browser support.
            renderer: undefined,
            // @section Animation Options
            // @option zoomAnimation: Boolean = true
            // Whether the map zoom animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            zoomAnimation: true,
            // @option zoomAnimationThreshold: Number = 4
            // Won't animate zoom if the zoom difference exceeds this value.
            zoomAnimationThreshold: 4,
            // @option fadeAnimation: Boolean = true
            // Whether the tile fade animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            fadeAnimation: true,
            // @option markerZoomAnimation: Boolean = true
            // Whether markers animate their zoom with the zoom animation, if disabled
            // they will disappear for the length of the animation. By default it's
            // enabled in all browsers that support CSS3 Transitions except Android.
            markerZoomAnimation: true,
            // @option transform3DLimit: Number = 2^23
            // Defines the maximum size of a CSS translation transform. The default
            // value should not be changed unless a web browser positions layers in
            // the wrong place after doing a large `panBy`.
            transform3DLimit: 8388608,
            // @section Interaction Options
            // @option zoomSnap: Number = 1
            // Forces the map's zoom level to always be a multiple of this, particularly
            // right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
            // By default, the zoom level snaps to the nearest integer; lower values
            // (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
            // means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
            zoomSnap: 1,
            // @option zoomDelta: Number = 1
            // Controls how much the map's zoom level will change after a
            // [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
            // or `-` on the keyboard, or using the [zoom controls](#control-zoom).
            // Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
            zoomDelta: 1,
            // @option trackResize: Boolean = true
            // Whether the map automatically handles browser window resize to update itself.
            trackResize: true
        },
        initialize: function(id, options) {
            options = setOptions(this, options);
            // Make sure to assign internal flags at the beginning,
            // to avoid inconsistent state in some edge cases.
            this._handlers = [];
            this._layers = {};
            this._zoomBoundLayers = {};
            this._sizeChanged = true;
            this._initContainer(id);
            this._initLayout();
            // hack for https://github.com/Leaflet/Leaflet/issues/1980
            this._onResize = bind(this._onResize, this);
            this._initEvents();
            if (options.maxBounds) this.setMaxBounds(options.maxBounds);
            if (options.zoom !== undefined) this._zoom = this._limitZoom(options.zoom);
            if (options.center && options.zoom !== undefined) this.setView(toLatLng(options.center), options.zoom, {
                reset: true
            });
            this.callInitHooks();
            // don't animate on browsers without hardware-accelerated transitions or old Android/Opera
            this._zoomAnimated = TRANSITION && Browser.any3d && !Browser.mobileOpera && this.options.zoomAnimation;
            // zoom transitions run with the same duration for all layers, so if one of transitionend events
            // happens after starting zoom animation (propagating to the map pane), we know that it ended globally
            if (this._zoomAnimated) {
                this._createAnimProxy();
                on(this._proxy, TRANSITION_END, this._catchTransitionEnd, this);
            }
            this._addLayers(this.options.layers);
        },
        // @section Methods for modifying map state
        // @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) with the given
        // animation options.
        setView: function(center, zoom, options) {
            zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
            center = this._limitCenter(toLatLng(center), zoom, this.options.maxBounds);
            options = options || {};
            this._stop();
            if (this._loaded && !options.reset && options !== true) {
                if (options.animate !== undefined) {
                    options.zoom = extend({
                        animate: options.animate
                    }, options.zoom);
                    options.pan = extend({
                        animate: options.animate,
                        duration: options.duration
                    }, options.pan);
                }
                // try animating pan or zoom
                var moved = this._zoom !== zoom ? this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) : this._tryAnimatedPan(center, options.pan);
                if (moved) {
                    // prevent resize handler call, the view will refresh after animation anyway
                    clearTimeout(this._sizeTimer);
                    return this;
                }
            }
            // animation didn't start, just reset the map view
            this._resetView(center, zoom, options.pan && options.pan.noMoveStart);
            return this;
        },
        // @method setZoom(zoom: Number, options?: Zoom/pan options): this
        // Sets the zoom of the map.
        setZoom: function(zoom, options) {
            if (!this._loaded) {
                this._zoom = zoom;
                return this;
            }
            return this.setView(this.getCenter(), zoom, {
                zoom: options
            });
        },
        // @method zoomIn(delta?: Number, options?: Zoom options): this
        // Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomIn: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom + delta, options);
        },
        // @method zoomOut(delta?: Number, options?: Zoom options): this
        // Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomOut: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom - delta, options);
        },
        // @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified geographical point on the map
        // stationary (e.g. used internally for scroll zoom and double-click zoom).
        // @alternative
        // @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
        setZoomAround: function(latlng, zoom, options) {
            var scale = this.getZoomScale(zoom), viewHalf = this.getSize().divideBy(2), containerPoint = latlng instanceof Point ? latlng : this.latLngToContainerPoint(latlng), centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale), newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
            return this.setView(newCenter, zoom, {
                zoom: options
            });
        },
        _getBoundsCenterZoom: function(bounds, options) {
            options = options || {};
            bounds = bounds.getBounds ? bounds.getBounds() : toLatLngBounds(bounds);
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
            zoom = typeof options.maxZoom === 'number' ? Math.min(options.maxZoom, zoom) : zoom;
            if (zoom === Infinity) return {
                center: bounds.getCenter(),
                zoom: zoom
            };
            var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2), swPoint = this.project(bounds.getSouthWest(), zoom), nePoint = this.project(bounds.getNorthEast(), zoom), center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);
            return {
                center: center,
                zoom: zoom
            };
        },
        // @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets a map view that contains the given geographical bounds with the
        // maximum zoom level possible.
        fitBounds: function(bounds, options) {
            bounds = toLatLngBounds(bounds);
            if (!bounds.isValid()) throw new Error('Bounds are not valid.');
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.setView(target.center, target.zoom, options);
        },
        // @method fitWorld(options?: fitBounds options): this
        // Sets a map view that mostly contains the whole world with the maximum
        // zoom level possible.
        fitWorld: function(options) {
            return this.fitBounds([
                [
                    -90,
                    -180
                ],
                [
                    90,
                    180
                ]
            ], options);
        },
        // @method panTo(latlng: LatLng, options?: Pan options): this
        // Pans the map to a given center.
        panTo: function(center, options) {
            return this.setView(center, this._zoom, {
                pan: options
            });
        },
        // @method panBy(offset: Point, options?: Pan options): this
        // Pans the map by a given number of pixels (animated).
        panBy: function(offset, options) {
            offset = toPoint(offset).round();
            options = options || {};
            if (!offset.x && !offset.y) return this.fire('moveend');
            // If we pan too far, Chrome gets issues with tiles
            // and makes them disappear or appear in the wrong place (slightly offset) #2602
            if (options.animate !== true && !this.getSize().contains(offset)) {
                this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
                return this;
            }
            if (!this._panAnim) {
                this._panAnim = new PosAnimation();
                this._panAnim.on({
                    'step': this._onPanTransitionStep,
                    'end': this._onPanTransitionEnd
                }, this);
            }
            // don't fire movestart if animating inertia
            if (!options.noMoveStart) this.fire('movestart');
            // animate pan unless animate: false specified
            if (options.animate !== false) {
                addClass(this._mapPane, 'leaflet-pan-anim');
                var newPos = this._getMapPanePos().subtract(offset).round();
                this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
            } else {
                this._rawPanBy(offset);
                this.fire('move').fire('moveend');
            }
            return this;
        },
        // @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) performing a smooth
        // pan-zoom animation.
        flyTo: function(targetCenter, targetZoom, options) {
            options = options || {};
            if (options.animate === false || !Browser.any3d) return this.setView(targetCenter, targetZoom, options);
            this._stop();
            var from = this.project(this.getCenter()), to = this.project(targetCenter), size = this.getSize(), startZoom = this._zoom;
            targetCenter = toLatLng(targetCenter);
            targetZoom = targetZoom === undefined ? startZoom : targetZoom;
            var w0 = Math.max(size.x, size.y), w1 = w0 * this.getZoomScale(startZoom, targetZoom), u1 = to.distanceTo(from) || 1, rho = 1.42, rho2 = rho * rho;
            function r(i) {
                var s1 = i ? -1 : 1, s2 = i ? w1 : w0, t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1, b1 = 2 * s2 * rho2 * u1, b = t1 / b1, sq = Math.sqrt(b * b + 1) - b;
                // workaround for floating point precision bug when sq = 0, log = -Infinite,
                // thus triggering an infinite loop in flyTo
                var log = sq < 0.000000001 ? -18 : Math.log(sq);
                return log;
            }
            function sinh(n) {
                return (Math.exp(n) - Math.exp(-n)) / 2;
            }
            function cosh(n) {
                return (Math.exp(n) + Math.exp(-n)) / 2;
            }
            function tanh(n) {
                return sinh(n) / cosh(n);
            }
            var r0 = r(0);
            function w(s) {
                return w0 * (cosh(r0) / cosh(r0 + rho * s));
            }
            function u(s) {
                return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2;
            }
            function easeOut(t) {
                return 1 - Math.pow(1 - t, 1.5);
            }
            var start = Date.now(), S = (r(1) - r0) / rho, duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;
            function frame() {
                var t = (Date.now() - start) / duration, s = easeOut(t) * S;
                if (t <= 1) {
                    this._flyToFrame = requestAnimFrame(frame, this);
                    this._move(this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom), this.getScaleZoom(w0 / w(s), startZoom), {
                        flyTo: true
                    });
                } else this._move(targetCenter, targetZoom)._moveEnd(true);
            }
            this._moveStart(true, options.noMoveStart);
            frame.call(this);
            return this;
        },
        // @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
        // but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
        flyToBounds: function(bounds, options) {
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.flyTo(target.center, target.zoom, options);
        },
        // @method setMaxBounds(bounds: LatLngBounds): this
        // Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
        setMaxBounds: function(bounds) {
            bounds = toLatLngBounds(bounds);
            if (this.listens('moveend', this._panInsideMaxBounds)) this.off('moveend', this._panInsideMaxBounds);
            if (!bounds.isValid()) {
                this.options.maxBounds = null;
                return this;
            }
            this.options.maxBounds = bounds;
            if (this._loaded) this._panInsideMaxBounds();
            return this.on('moveend', this._panInsideMaxBounds);
        },
        // @method setMinZoom(zoom: Number): this
        // Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
        setMinZoom: function(zoom) {
            var oldZoom = this.options.minZoom;
            this.options.minZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire('zoomlevelschange');
                if (this.getZoom() < this.options.minZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method setMaxZoom(zoom: Number): this
        // Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
        setMaxZoom: function(zoom) {
            var oldZoom = this.options.maxZoom;
            this.options.maxZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire('zoomlevelschange');
                if (this.getZoom() > this.options.maxZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
        // Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
        panInsideBounds: function(bounds, options) {
            this._enforcingBounds = true;
            var center = this.getCenter(), newCenter = this._limitCenter(center, this._zoom, toLatLngBounds(bounds));
            if (!center.equals(newCenter)) this.panTo(newCenter, options);
            this._enforcingBounds = false;
            return this;
        },
        // @method panInside(latlng: LatLng, options?: padding options): this
        // Pans the map the minimum amount to make the `latlng` visible. Use
        // padding options to fit the display to more restricted bounds.
        // If `latlng` is already within the (optionally padded) display bounds,
        // the map will not be panned.
        panInside: function(latlng, options) {
            options = options || {};
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), pixelCenter = this.project(this.getCenter()), pixelPoint = this.project(latlng), pixelBounds = this.getPixelBounds(), paddedBounds = toBounds([
                pixelBounds.min.add(paddingTL),
                pixelBounds.max.subtract(paddingBR)
            ]), paddedSize = paddedBounds.getSize();
            if (!paddedBounds.contains(pixelPoint)) {
                this._enforcingBounds = true;
                var centerOffset = pixelPoint.subtract(paddedBounds.getCenter());
                var offset = paddedBounds.extend(pixelPoint).getSize().subtract(paddedSize);
                pixelCenter.x += centerOffset.x < 0 ? -offset.x : offset.x;
                pixelCenter.y += centerOffset.y < 0 ? -offset.y : offset.y;
                this.panTo(this.unproject(pixelCenter), options);
                this._enforcingBounds = false;
            }
            return this;
        },
        // @method invalidateSize(options: Zoom/pan options): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default. If `options.pan` is `false`, panning will not occur.
        // If `options.debounceMoveend` is `true`, it will delay `moveend` event so
        // that it doesn't happen often even if the method is called many
        // times in a row.
        // @alternative
        // @method invalidateSize(animate: Boolean): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default.
        invalidateSize: function(options) {
            if (!this._loaded) return this;
            options = extend({
                animate: false,
                pan: true
            }, options === true ? {
                animate: true
            } : options);
            var oldSize = this.getSize();
            this._sizeChanged = true;
            this._lastCenter = null;
            var newSize = this.getSize(), oldCenter = oldSize.divideBy(2).round(), newCenter = newSize.divideBy(2).round(), offset = oldCenter.subtract(newCenter);
            if (!offset.x && !offset.y) return this;
            if (options.animate && options.pan) this.panBy(offset);
            else {
                if (options.pan) this._rawPanBy(offset);
                this.fire('move');
                if (options.debounceMoveend) {
                    clearTimeout(this._sizeTimer);
                    this._sizeTimer = setTimeout(bind(this.fire, this, 'moveend'), 200);
                } else this.fire('moveend');
            }
            // @section Map state change events
            // @event resize: ResizeEvent
            // Fired when the map is resized.
            return this.fire('resize', {
                oldSize: oldSize,
                newSize: newSize
            });
        },
        // @section Methods for modifying map state
        // @method stop(): this
        // Stops the currently running `panTo` or `flyTo` animation, if any.
        stop: function() {
            this.setZoom(this._limitZoom(this._zoom));
            if (!this.options.zoomSnap) this.fire('viewreset');
            return this._stop();
        },
        // @section Geolocation methods
        // @method locate(options?: Locate options): this
        // Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
        // event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
        // and optionally sets the map view to the user's location with respect to
        // detection accuracy (or to the world view if geolocation failed).
        // Note that, if your page doesn't use HTTPS, this method will fail in
        // modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
        // See `Locate options` for more details.
        locate: function(options) {
            options = this._locateOptions = extend({
                timeout: 10000,
                watch: false
            }, options);
            if (!('geolocation' in navigator)) {
                this._handleGeolocationError({
                    code: 0,
                    message: 'Geolocation not supported.'
                });
                return this;
            }
            var onResponse = bind(this._handleGeolocationResponse, this), onError = bind(this._handleGeolocationError, this);
            if (options.watch) this._locationWatchId = navigator.geolocation.watchPosition(onResponse, onError, options);
            else navigator.geolocation.getCurrentPosition(onResponse, onError, options);
            return this;
        },
        // @method stopLocate(): this
        // Stops watching location previously initiated by `map.locate({watch: true})`
        // and aborts resetting the map view if map.locate was called with
        // `{setView: true}`.
        stopLocate: function() {
            if (navigator.geolocation && navigator.geolocation.clearWatch) navigator.geolocation.clearWatch(this._locationWatchId);
            if (this._locateOptions) this._locateOptions.setView = false;
            return this;
        },
        _handleGeolocationError: function(error) {
            if (!this._container._leaflet_id) return;
            var c = error.code, message = error.message || (c === 1 ? 'permission denied' : c === 2 ? 'position unavailable' : 'timeout');
            if (this._locateOptions.setView && !this._loaded) this.fitWorld();
            // @section Location events
            // @event locationerror: ErrorEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method) failed.
            this.fire('locationerror', {
                code: c,
                message: 'Geolocation error: ' + message + '.'
            });
        },
        _handleGeolocationResponse: function(pos) {
            if (!this._container._leaflet_id) return;
            var lat = pos.coords.latitude, lng = pos.coords.longitude, latlng = new LatLng(lat, lng), bounds = latlng.toBounds(pos.coords.accuracy * 2), options = this._locateOptions;
            if (options.setView) {
                var zoom = this.getBoundsZoom(bounds);
                this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
            }
            var data = {
                latlng: latlng,
                bounds: bounds,
                timestamp: pos.timestamp
            };
            for(var i in pos.coords)if (typeof pos.coords[i] === 'number') data[i] = pos.coords[i];
            // @event locationfound: LocationEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method)
            // went successfully.
            this.fire('locationfound', data);
        },
        // TODO Appropriate docs section?
        // @section Other Methods
        // @method addHandler(name: String, HandlerClass: Function): this
        // Adds a new `Handler` to the map, given its name and constructor function.
        addHandler: function(name, HandlerClass) {
            if (!HandlerClass) return this;
            var handler = this[name] = new HandlerClass(this);
            this._handlers.push(handler);
            if (this.options[name]) handler.enable();
            return this;
        },
        // @method remove(): this
        // Destroys the map and clears all related event listeners.
        remove: function() {
            this._initEvents(true);
            if (this.options.maxBounds) this.off('moveend', this._panInsideMaxBounds);
            if (this._containerId !== this._container._leaflet_id) throw new Error('Map container is being reused by another instance');
            try {
                // throws error in IE6-8
                delete this._container._leaflet_id;
                delete this._containerId;
            } catch (e) {
                /*eslint-disable */ this._container._leaflet_id = undefined;
                /* eslint-enable */ this._containerId = undefined;
            }
            if (this._locationWatchId !== undefined) this.stopLocate();
            this._stop();
            remove(this._mapPane);
            if (this._clearControlPos) this._clearControlPos();
            if (this._resizeRequest) {
                cancelAnimFrame(this._resizeRequest);
                this._resizeRequest = null;
            }
            this._clearHandlers();
            if (this._loaded) // @section Map state change events
            // @event unload: Event
            // Fired when the map is destroyed with [remove](#map-remove) method.
            this.fire('unload');
            var i;
            for(i in this._layers)this._layers[i].remove();
            for(i in this._panes)remove(this._panes[i]);
            this._layers = [];
            this._panes = [];
            delete this._mapPane;
            delete this._renderer;
            return this;
        },
        // @section Other Methods
        // @method createPane(name: String, container?: HTMLElement): HTMLElement
        // Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
        // then returns it. The pane is created as a child of `container`, or
        // as a child of the main map pane if not set.
        createPane: function(name, container) {
            var className = 'leaflet-pane' + (name ? ' leaflet-' + name.replace('Pane', '') + '-pane' : ''), pane = create$1('div', className, container || this._mapPane);
            if (name) this._panes[name] = pane;
            return pane;
        },
        // @section Methods for Getting Map State
        // @method getCenter(): LatLng
        // Returns the geographical center of the map view
        getCenter: function() {
            this._checkIfLoaded();
            if (this._lastCenter && !this._moved()) return this._lastCenter.clone();
            return this.layerPointToLatLng(this._getCenterLayerPoint());
        },
        // @method getZoom(): Number
        // Returns the current zoom level of the map view
        getZoom: function() {
            return this._zoom;
        },
        // @method getBounds(): LatLngBounds
        // Returns the geographical bounds visible in the current map view
        getBounds: function() {
            var bounds = this.getPixelBounds(), sw = this.unproject(bounds.getBottomLeft()), ne = this.unproject(bounds.getTopRight());
            return new LatLngBounds(sw, ne);
        },
        // @method getMinZoom(): Number
        // Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
        getMinZoom: function() {
            return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
        },
        // @method getMaxZoom(): Number
        // Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
        getMaxZoom: function() {
            return this.options.maxZoom === undefined ? this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom : this.options.maxZoom;
        },
        // @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
        // Returns the maximum zoom level on which the given bounds fit to the map
        // view in its entirety. If `inside` (optional) is set to `true`, the method
        // instead returns the minimum zoom level on which the map view fits into
        // the given bounds in its entirety.
        getBoundsZoom: function(bounds, inside, padding) {
            bounds = toLatLngBounds(bounds);
            padding = toPoint(padding || [
                0,
                0
            ]);
            var zoom = this.getZoom() || 0, min = this.getMinZoom(), max = this.getMaxZoom(), nw = bounds.getNorthWest(), se = bounds.getSouthEast(), size = this.getSize().subtract(padding), boundsSize = toBounds(this.project(se, zoom), this.project(nw, zoom)).getSize(), snap = Browser.any3d ? this.options.zoomSnap : 1, scalex = size.x / boundsSize.x, scaley = size.y / boundsSize.y, scale = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);
            zoom = this.getScaleZoom(scale, zoom);
            if (snap) {
                zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
                zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
            }
            return Math.max(min, Math.min(max, zoom));
        },
        // @method getSize(): Point
        // Returns the current size of the map container (in pixels).
        getSize: function() {
            if (!this._size || this._sizeChanged) {
                this._size = new Point(this._container.clientWidth || 0, this._container.clientHeight || 0);
                this._sizeChanged = false;
            }
            return this._size.clone();
        },
        // @method getPixelBounds(): Bounds
        // Returns the bounds of the current map view in projected pixel
        // coordinates (sometimes useful in layer and overlay implementations).
        getPixelBounds: function(center, zoom) {
            var topLeftPoint = this._getTopLeftPoint(center, zoom);
            return new Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
        },
        // TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
        // the map pane? "left point of the map layer" can be confusing, specially
        // since there can be negative offsets.
        // @method getPixelOrigin(): Point
        // Returns the projected pixel coordinates of the top left point of
        // the map layer (useful in custom layer and overlay implementations).
        getPixelOrigin: function() {
            this._checkIfLoaded();
            return this._pixelOrigin;
        },
        // @method getPixelWorldBounds(zoom?: Number): Bounds
        // Returns the world's bounds in pixel coordinates for zoom level `zoom`.
        // If `zoom` is omitted, the map's current zoom level is used.
        getPixelWorldBounds: function(zoom) {
            return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
        },
        // @section Other Methods
        // @method getPane(pane: String|HTMLElement): HTMLElement
        // Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
        getPane: function(pane) {
            return typeof pane === 'string' ? this._panes[pane] : pane;
        },
        // @method getPanes(): Object
        // Returns a plain object containing the names of all [panes](#map-pane) as keys and
        // the panes as values.
        getPanes: function() {
            return this._panes;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the map.
        getContainer: function() {
            return this._container;
        },
        // @section Conversion Methods
        // @method getZoomScale(toZoom: Number, fromZoom: Number): Number
        // Returns the scale factor to be applied to a map transition from zoom level
        // `fromZoom` to `toZoom`. Used internally to help with zoom animations.
        getZoomScale: function(toZoom, fromZoom) {
            // TODO replace with universal implementation after refactoring projections
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            return crs.scale(toZoom) / crs.scale(fromZoom);
        },
        // @method getScaleZoom(scale: Number, fromZoom: Number): Number
        // Returns the zoom level that the map would end up at, if it is at `fromZoom`
        // level and everything is scaled by a factor of `scale`. Inverse of
        // [`getZoomScale`](#map-getZoomScale).
        getScaleZoom: function(scale, fromZoom) {
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            var zoom = crs.zoom(scale * crs.scale(fromZoom));
            return isNaN(zoom) ? Infinity : zoom;
        },
        // @method project(latlng: LatLng, zoom: Number): Point
        // Projects a geographical coordinate `LatLng` according to the projection
        // of the map's CRS, then scales it according to `zoom` and the CRS's
        // `Transformation`. The result is pixel coordinate relative to
        // the CRS origin.
        project: function(latlng, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.latLngToPoint(toLatLng(latlng), zoom);
        },
        // @method unproject(point: Point, zoom: Number): LatLng
        // Inverse of [`project`](#map-project).
        unproject: function(point, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.pointToLatLng(toPoint(point), zoom);
        },
        // @method layerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding geographical coordinate (for the current zoom level).
        layerPointToLatLng: function(point) {
            var projectedPoint = toPoint(point).add(this.getPixelOrigin());
            return this.unproject(projectedPoint);
        },
        // @method latLngToLayerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the [origin pixel](#map-getpixelorigin).
        latLngToLayerPoint: function(latlng) {
            var projectedPoint = this.project(toLatLng(latlng))._round();
            return projectedPoint._subtract(this.getPixelOrigin());
        },
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
        // map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
        // CRS's bounds.
        // By default this means longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees.
        wrapLatLng: function(latlng) {
            return this.options.crs.wrapLatLng(toLatLng(latlng));
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring that
        // its center is within the CRS's bounds.
        // By default this means the center longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees, and the majority of the bounds
        // overlaps the CRS's bounds.
        wrapLatLngBounds: function(latlng) {
            return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng));
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates according to
        // the map's CRS. By default this measures distance in meters.
        distance: function(latlng1, latlng2) {
            return this.options.crs.distance(toLatLng(latlng1), toLatLng(latlng2));
        },
        // @method containerPointToLayerPoint(point: Point): Point
        // Given a pixel coordinate relative to the map container, returns the corresponding
        // pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
        containerPointToLayerPoint: function(point) {
            return toPoint(point).subtract(this._getMapPanePos());
        },
        // @method layerPointToContainerPoint(point: Point): Point
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding pixel coordinate relative to the map container.
        layerPointToContainerPoint: function(point) {
            return toPoint(point).add(this._getMapPanePos());
        },
        // @method containerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the map container, returns
        // the corresponding geographical coordinate (for the current zoom level).
        containerPointToLatLng: function(point) {
            var layerPoint = this.containerPointToLayerPoint(toPoint(point));
            return this.layerPointToLatLng(layerPoint);
        },
        // @method latLngToContainerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the map container.
        latLngToContainerPoint: function(latlng) {
            return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)));
        },
        // @method mouseEventToContainerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to the
        // map container where the event took place.
        mouseEventToContainerPoint: function(e) {
            return getMousePosition(e, this._container);
        },
        // @method mouseEventToLayerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to
        // the [origin pixel](#map-getpixelorigin) where the event took place.
        mouseEventToLayerPoint: function(e) {
            return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
        },
        // @method mouseEventToLatLng(ev: MouseEvent): LatLng
        // Given a MouseEvent object, returns geographical coordinate where the
        // event took place.
        mouseEventToLatLng: function(e) {
            return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
        },
        // map initialization methods
        _initContainer: function(id) {
            var container = this._container = get(id);
            if (!container) throw new Error('Map container not found.');
            else if (container._leaflet_id) throw new Error('Map container is already initialized.');
            on(container, 'scroll', this._onScroll, this);
            this._containerId = stamp(container);
        },
        _initLayout: function() {
            var container = this._container;
            this._fadeAnimated = this.options.fadeAnimation && Browser.any3d;
            addClass(container, 'leaflet-container' + (Browser.touch ? ' leaflet-touch' : '') + (Browser.retina ? ' leaflet-retina' : '') + (Browser.ielt9 ? ' leaflet-oldie' : '') + (Browser.safari ? ' leaflet-safari' : '') + (this._fadeAnimated ? ' leaflet-fade-anim' : ''));
            var position = getStyle(container, 'position');
            if (position !== 'absolute' && position !== 'relative' && position !== 'fixed' && position !== 'sticky') container.style.position = 'relative';
            this._initPanes();
            if (this._initControlPos) this._initControlPos();
        },
        _initPanes: function() {
            var panes = this._panes = {};
            this._paneRenderers = {};
            // @section
            //
            // Panes are DOM elements used to control the ordering of layers on the map. You
            // can access panes with [`map.getPane`](#map-getpane) or
            // [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
            // [`map.createPane`](#map-createpane) method.
            //
            // Every map has the following default panes that differ only in zIndex.
            //
            // @pane mapPane: HTMLElement = 'auto'
            // Pane that contains all other map panes
            this._mapPane = this.createPane('mapPane', this._container);
            setPosition(this._mapPane, new Point(0, 0));
            // @pane tilePane: HTMLElement = 200
            // Pane for `GridLayer`s and `TileLayer`s
            this.createPane('tilePane');
            // @pane overlayPane: HTMLElement = 400
            // Pane for vectors (`Path`s, like `Polyline`s and `Polygon`s), `ImageOverlay`s and `VideoOverlay`s
            this.createPane('overlayPane');
            // @pane shadowPane: HTMLElement = 500
            // Pane for overlay shadows (e.g. `Marker` shadows)
            this.createPane('shadowPane');
            // @pane markerPane: HTMLElement = 600
            // Pane for `Icon`s of `Marker`s
            this.createPane('markerPane');
            // @pane tooltipPane: HTMLElement = 650
            // Pane for `Tooltip`s.
            this.createPane('tooltipPane');
            // @pane popupPane: HTMLElement = 700
            // Pane for `Popup`s.
            this.createPane('popupPane');
            if (!this.options.markerZoomAnimation) {
                addClass(panes.markerPane, 'leaflet-zoom-hide');
                addClass(panes.shadowPane, 'leaflet-zoom-hide');
            }
        },
        // private methods that modify map state
        // @section Map state change events
        _resetView: function(center, zoom, noMoveStart) {
            setPosition(this._mapPane, new Point(0, 0));
            var loading = !this._loaded;
            this._loaded = true;
            zoom = this._limitZoom(zoom);
            this.fire('viewprereset');
            var zoomChanged = this._zoom !== zoom;
            this._moveStart(zoomChanged, noMoveStart)._move(center, zoom)._moveEnd(zoomChanged);
            // @event viewreset: Event
            // Fired when the map needs to redraw its content (this usually happens
            // on map zoom or load). Very useful for creating custom overlays.
            this.fire('viewreset');
            // @event load: Event
            // Fired when the map is initialized (when its center and zoom are set
            // for the first time).
            if (loading) this.fire('load');
        },
        _moveStart: function(zoomChanged, noMoveStart) {
            // @event zoomstart: Event
            // Fired when the map zoom is about to change (e.g. before zoom animation).
            // @event movestart: Event
            // Fired when the view of the map starts changing (e.g. user starts dragging the map).
            if (zoomChanged) this.fire('zoomstart');
            if (!noMoveStart) this.fire('movestart');
            return this;
        },
        _move: function(center, zoom, data, supressEvent) {
            if (zoom === undefined) zoom = this._zoom;
            var zoomChanged = this._zoom !== zoom;
            this._zoom = zoom;
            this._lastCenter = center;
            this._pixelOrigin = this._getNewPixelOrigin(center);
            if (!supressEvent) {
                // @event zoom: Event
                // Fired repeatedly during any change in zoom level,
                // including zoom and fly animations.
                if (zoomChanged || data && data.pinch) this.fire('zoom', data);
                // @event move: Event
                // Fired repeatedly during any movement of the map,
                // including pan and fly animations.
                this.fire('move', data);
            } else if (data && data.pinch) this.fire('zoom', data);
            return this;
        },
        _moveEnd: function(zoomChanged) {
            // @event zoomend: Event
            // Fired when the map zoom changed, after any animations.
            if (zoomChanged) this.fire('zoomend');
            // @event moveend: Event
            // Fired when the center of the map stops changing
            // (e.g. user stopped dragging the map or after non-centered zoom).
            return this.fire('moveend');
        },
        _stop: function() {
            cancelAnimFrame(this._flyToFrame);
            if (this._panAnim) this._panAnim.stop();
            return this;
        },
        _rawPanBy: function(offset) {
            setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
        },
        _getZoomSpan: function() {
            return this.getMaxZoom() - this.getMinZoom();
        },
        _panInsideMaxBounds: function() {
            if (!this._enforcingBounds) this.panInsideBounds(this.options.maxBounds);
        },
        _checkIfLoaded: function() {
            if (!this._loaded) throw new Error('Set map center and zoom first.');
        },
        // DOM event handling
        // @section Interaction events
        _initEvents: function(remove) {
            this._targets = {};
            this._targets[stamp(this._container)] = this;
            var onOff = remove ? off : on;
            // @event click: MouseEvent
            // Fired when the user clicks (or taps) the map.
            // @event dblclick: MouseEvent
            // Fired when the user double-clicks (or double-taps) the map.
            // @event mousedown: MouseEvent
            // Fired when the user pushes the mouse button on the map.
            // @event mouseup: MouseEvent
            // Fired when the user releases the mouse button on the map.
            // @event mouseover: MouseEvent
            // Fired when the mouse enters the map.
            // @event mouseout: MouseEvent
            // Fired when the mouse leaves the map.
            // @event mousemove: MouseEvent
            // Fired while the mouse moves over the map.
            // @event contextmenu: MouseEvent
            // Fired when the user pushes the right mouse button on the map, prevents
            // default browser context menu from showing if there are listeners on
            // this event. Also fired on mobile when the user holds a single touch
            // for a second (also called long press).
            // @event keypress: KeyboardEvent
            // Fired when the user presses a key from the keyboard that produces a character value while the map is focused.
            // @event keydown: KeyboardEvent
            // Fired when the user presses a key from the keyboard while the map is focused. Unlike the `keypress` event,
            // the `keydown` event is fired for keys that produce a character value and for keys
            // that do not produce a character value.
            // @event keyup: KeyboardEvent
            // Fired when the user releases a key from the keyboard while the map is focused.
            onOff(this._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this);
            if (this.options.trackResize) onOff(window, 'resize', this._onResize, this);
            if (Browser.any3d && this.options.transform3DLimit) (remove ? this.off : this.on).call(this, 'moveend', this._onMoveEnd);
        },
        _onResize: function() {
            cancelAnimFrame(this._resizeRequest);
            this._resizeRequest = requestAnimFrame(function() {
                this.invalidateSize({
                    debounceMoveend: true
                });
            }, this);
        },
        _onScroll: function() {
            this._container.scrollTop = 0;
            this._container.scrollLeft = 0;
        },
        _onMoveEnd: function() {
            var pos = this._getMapPanePos();
            if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) // https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
            // a pixel offset on very high values, see: https://jsfiddle.net/dg6r5hhb/
            this._resetView(this.getCenter(), this.getZoom());
        },
        _findEventTargets: function(e, type) {
            var targets = [], target, isHover = type === 'mouseout' || type === 'mouseover', src = e.target || e.srcElement, dragging = false;
            while(src){
                target = this._targets[stamp(src)];
                if (target && (type === 'click' || type === 'preclick') && this._draggableMoved(target)) {
                    // Prevent firing click after you just dragged an object.
                    dragging = true;
                    break;
                }
                if (target && target.listens(type, true)) {
                    if (isHover && !isExternalTarget(src, e)) break;
                    targets.push(target);
                    if (isHover) break;
                }
                if (src === this._container) break;
                src = src.parentNode;
            }
            if (!targets.length && !dragging && !isHover && this.listens(type, true)) targets = [
                this
            ];
            return targets;
        },
        _isClickDisabled: function(el) {
            while(el && el !== this._container){
                if (el['_leaflet_disable_click']) return true;
                el = el.parentNode;
            }
        },
        _handleDOMEvent: function(e) {
            var el = e.target || e.srcElement;
            if (!this._loaded || el['_leaflet_disable_events'] || e.type === 'click' && this._isClickDisabled(el)) return;
            var type = e.type;
            if (type === 'mousedown') // prevents outline when clicking on keyboard-focusable element
            preventOutline(el);
            this._fireDOMEvent(e, type);
        },
        _mouseEvents: [
            'click',
            'dblclick',
            'mouseover',
            'mouseout',
            'contextmenu'
        ],
        _fireDOMEvent: function(e, type, canvasTargets) {
            if (e.type === 'click') {
                // Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
                // @event preclick: MouseEvent
                // Fired before mouse click on the map (sometimes useful when you
                // want something to happen on click before any existing click
                // handlers start running).
                var synth = extend({}, e);
                synth.type = 'preclick';
                this._fireDOMEvent(synth, synth.type, canvasTargets);
            }
            // Find the layer the event is propagating from and its parents.
            var targets = this._findEventTargets(e, type);
            if (canvasTargets) {
                var filtered = []; // pick only targets with listeners
                for(var i = 0; i < canvasTargets.length; i++)if (canvasTargets[i].listens(type, true)) filtered.push(canvasTargets[i]);
                targets = filtered.concat(targets);
            }
            if (!targets.length) return;
            if (type === 'contextmenu') preventDefault(e);
            var target = targets[0];
            var data = {
                originalEvent: e
            };
            if (e.type !== 'keypress' && e.type !== 'keydown' && e.type !== 'keyup') {
                var isMarker = target.getLatLng && (!target._radius || target._radius <= 10);
                data.containerPoint = isMarker ? this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
                data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
                data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
            }
            for(i = 0; i < targets.length; i++){
                targets[i].fire(type, data, true);
                if (data.originalEvent._stopped || targets[i].options.bubblingMouseEvents === false && indexOf(this._mouseEvents, type) !== -1) return;
            }
        },
        _draggableMoved: function(obj) {
            obj = obj.dragging && obj.dragging.enabled() ? obj : this;
            return obj.dragging && obj.dragging.moved() || this.boxZoom && this.boxZoom.moved();
        },
        _clearHandlers: function() {
            for(var i = 0, len = this._handlers.length; i < len; i++)this._handlers[i].disable();
        },
        // @section Other Methods
        // @method whenReady(fn: Function, context?: Object): this
        // Runs the given function `fn` when the map gets initialized with
        // a view (center and zoom) and at least one layer, or immediately
        // if it's already initialized, optionally passing a function context.
        whenReady: function(callback, context) {
            if (this._loaded) callback.call(context || this, {
                target: this
            });
            else this.on('load', callback, context);
            return this;
        },
        // private methods for getting map state
        _getMapPanePos: function() {
            return getPosition(this._mapPane) || new Point(0, 0);
        },
        _moved: function() {
            var pos = this._getMapPanePos();
            return pos && !pos.equals([
                0,
                0
            ]);
        },
        _getTopLeftPoint: function(center, zoom) {
            var pixelOrigin = center && zoom !== undefined ? this._getNewPixelOrigin(center, zoom) : this.getPixelOrigin();
            return pixelOrigin.subtract(this._getMapPanePos());
        },
        _getNewPixelOrigin: function(center, zoom) {
            var viewHalf = this.getSize()._divideBy(2);
            return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
        },
        _latLngToNewLayerPoint: function(latlng, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return this.project(latlng, zoom)._subtract(topLeft);
        },
        _latLngBoundsToNewLayerBounds: function(latLngBounds, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return toBounds([
                this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
            ]);
        },
        // layer point of the current center
        _getCenterLayerPoint: function() {
            return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
        },
        // offset of the specified place to the current center in pixels
        _getCenterOffset: function(latlng) {
            return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
        },
        // adjust center for view to get inside bounds
        _limitCenter: function(center, zoom, bounds) {
            if (!bounds) return center;
            var centerPoint = this.project(center, zoom), viewHalf = this.getSize().divideBy(2), viewBounds = new Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)), offset = this._getBoundsOffset(viewBounds, bounds, zoom);
            // If offset is less than a pixel, ignore.
            // This prevents unstable projections from getting into
            // an infinite loop of tiny offsets.
            if (Math.abs(offset.x) <= 1 && Math.abs(offset.y) <= 1) return center;
            return this.unproject(centerPoint.add(offset), zoom);
        },
        // adjust offset for view to get inside bounds
        _limitOffset: function(offset, bounds) {
            if (!bounds) return offset;
            var viewBounds = this.getPixelBounds(), newBounds = new Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));
            return offset.add(this._getBoundsOffset(newBounds, bounds));
        },
        // returns offset needed for pxBounds to get inside maxBounds at a specified zoom
        _getBoundsOffset: function(pxBounds, maxBounds, zoom) {
            var projectedMaxBounds = toBounds(this.project(maxBounds.getNorthEast(), zoom), this.project(maxBounds.getSouthWest(), zoom)), minOffset = projectedMaxBounds.min.subtract(pxBounds.min), maxOffset = projectedMaxBounds.max.subtract(pxBounds.max), dx = this._rebound(minOffset.x, -maxOffset.x), dy = this._rebound(minOffset.y, -maxOffset.y);
            return new Point(dx, dy);
        },
        _rebound: function(left, right) {
            return left + right > 0 ? Math.round(left - right) / 2 : Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
        },
        _limitZoom: function(zoom) {
            var min = this.getMinZoom(), max = this.getMaxZoom(), snap = Browser.any3d ? this.options.zoomSnap : 1;
            if (snap) zoom = Math.round(zoom / snap) * snap;
            return Math.max(min, Math.min(max, zoom));
        },
        _onPanTransitionStep: function() {
            this.fire('move');
        },
        _onPanTransitionEnd: function() {
            removeClass(this._mapPane, 'leaflet-pan-anim');
            this.fire('moveend');
        },
        _tryAnimatedPan: function(center, options) {
            // difference between the new and current centers in pixels
            var offset = this._getCenterOffset(center)._trunc();
            // don't animate too far unless animate: true specified in options
            if ((options && options.animate) !== true && !this.getSize().contains(offset)) return false;
            this.panBy(offset, options);
            return true;
        },
        _createAnimProxy: function() {
            var proxy = this._proxy = create$1('div', 'leaflet-proxy leaflet-zoom-animated');
            this._panes.mapPane.appendChild(proxy);
            this.on('zoomanim', function(e) {
                var prop = TRANSFORM, transform = this._proxy.style[prop];
                setTransform(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));
                // workaround for case when transform is the same and so transitionend event is not fired
                if (transform === this._proxy.style[prop] && this._animatingZoom) this._onZoomTransitionEnd();
            }, this);
            this.on('load moveend', this._animMoveEnd, this);
            this._on('unload', this._destroyAnimProxy, this);
        },
        _destroyAnimProxy: function() {
            remove(this._proxy);
            this.off('load moveend', this._animMoveEnd, this);
            delete this._proxy;
        },
        _animMoveEnd: function() {
            var c = this.getCenter(), z = this.getZoom();
            setTransform(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
        },
        _catchTransitionEnd: function(e) {
            if (this._animatingZoom && e.propertyName.indexOf('transform') >= 0) this._onZoomTransitionEnd();
        },
        _nothingToAnimate: function() {
            return !this._container.getElementsByClassName('leaflet-zoom-animated').length;
        },
        _tryAnimatedZoom: function(center, zoom, options) {
            if (this._animatingZoom) return true;
            options = options || {};
            // don't animate if disabled, not supported or zoom difference is too large
            if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() || Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) return false;
            // offset is the pixel coords of the zoom origin relative to the current center
            var scale = this.getZoomScale(zoom), offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);
            // don't animate if the zoom origin isn't within one screen from the current center, unless forced
            if (options.animate !== true && !this.getSize().contains(offset)) return false;
            requestAnimFrame(function() {
                this._moveStart(true, options.noMoveStart || false)._animateZoom(center, zoom, true);
            }, this);
            return true;
        },
        _animateZoom: function(center, zoom, startAnim, noUpdate) {
            if (!this._mapPane) return;
            if (startAnim) {
                this._animatingZoom = true;
                // remember what center/zoom to set after animation
                this._animateToCenter = center;
                this._animateToZoom = zoom;
                addClass(this._mapPane, 'leaflet-zoom-anim');
            }
            // @section Other Events
            // @event zoomanim: ZoomAnimEvent
            // Fired at least once per zoom animation. For continuous zoom, like pinch zooming, fired once per frame during zoom.
            this.fire('zoomanim', {
                center: center,
                zoom: zoom,
                noUpdate: noUpdate
            });
            if (!this._tempFireZoomEvent) this._tempFireZoomEvent = this._zoom !== this._animateToZoom;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            // Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
            setTimeout(bind(this._onZoomTransitionEnd, this), 250);
        },
        _onZoomTransitionEnd: function() {
            if (!this._animatingZoom) return;
            if (this._mapPane) removeClass(this._mapPane, 'leaflet-zoom-anim');
            this._animatingZoom = false;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            if (this._tempFireZoomEvent) this.fire('zoom');
            delete this._tempFireZoomEvent;
            this.fire('move');
            this._moveEnd(true);
        }
    });
    // @section
    // @factory L.map(id: String, options?: Map options)
    // Instantiates a map object given the DOM ID of a `<div>` element
    // and optionally an object literal with `Map options`.
    //
    // @alternative
    // @factory L.map(el: HTMLElement, options?: Map options)
    // Instantiates a map object given an instance of a `<div>` HTML element
    // and optionally an object literal with `Map options`.
    function createMap(id, options) {
        return new Map(id, options);
    }
    /*
   * @class Control
   * @aka L.Control
   * @inherits Class
   *
   * L.Control is a base class for implementing map controls. Handles positioning.
   * All other controls extend from this class.
   */ var Control = Class.extend({
        // @section
        // @aka Control Options
        options: {
            // @option position: String = 'topright'
            // The position of the control (one of the map corners). Possible values are `'topleft'`,
            // `'topright'`, `'bottomleft'` or `'bottomright'`
            position: 'topright'
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        /* @section
  	 * Classes extending L.Control will inherit the following methods:
  	 *
  	 * @method getPosition: string
  	 * Returns the position of the control.
  	 */ getPosition: function() {
            return this.options.position;
        },
        // @method setPosition(position: string): this
        // Sets the position of the control.
        setPosition: function(position) {
            var map = this._map;
            if (map) map.removeControl(this);
            this.options.position = position;
            if (map) map.addControl(this);
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTMLElement that contains the control.
        getContainer: function() {
            return this._container;
        },
        // @method addTo(map: Map): this
        // Adds the control to the given map.
        addTo: function(map) {
            this.remove();
            this._map = map;
            var container = this._container = this.onAdd(map), pos = this.getPosition(), corner = map._controlCorners[pos];
            addClass(container, 'leaflet-control');
            if (pos.indexOf('bottom') !== -1) corner.insertBefore(container, corner.firstChild);
            else corner.appendChild(container);
            this._map.on('unload', this.remove, this);
            return this;
        },
        // @method remove: this
        // Removes the control from the map it is currently active on.
        remove: function() {
            if (!this._map) return this;
            remove(this._container);
            if (this.onRemove) this.onRemove(this._map);
            this._map.off('unload', this.remove, this);
            this._map = null;
            return this;
        },
        _refocusOnMap: function(e) {
            // if map exists and event is not a keyboard event
            if (this._map && e && e.screenX > 0 && e.screenY > 0) this._map.getContainer().focus();
        }
    });
    var control = function(options) {
        return new Control(options);
    };
    /* @section Extension methods
   * @uninheritable
   *
   * Every control should extend from `L.Control` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): HTMLElement
   * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
   *
   * @method onRemove(map: Map)
   * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
   */ /* @namespace Map
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addControl(control: Control): this
        // Adds the given control to the map
        addControl: function(control) {
            control.addTo(this);
            return this;
        },
        // @method removeControl(control: Control): this
        // Removes the given control from the map
        removeControl: function(control) {
            control.remove();
            return this;
        },
        _initControlPos: function() {
            var corners = this._controlCorners = {}, l = 'leaflet-', container = this._controlContainer = create$1('div', l + 'control-container', this._container);
            function createCorner(vSide, hSide) {
                var className = l + vSide + ' ' + l + hSide;
                corners[vSide + hSide] = create$1('div', className, container);
            }
            createCorner('top', 'left');
            createCorner('top', 'right');
            createCorner('bottom', 'left');
            createCorner('bottom', 'right');
        },
        _clearControlPos: function() {
            for(var i in this._controlCorners)remove(this._controlCorners[i]);
            remove(this._controlContainer);
            delete this._controlCorners;
            delete this._controlContainer;
        }
    });
    /*
   * @class Control.Layers
   * @aka L.Control.Layers
   * @inherits Control
   *
   * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](https://leafletjs.com/examples/layers-control/)). Extends `Control`.
   *
   * @example
   *
   * ```js
   * var baseLayers = {
   * 	"Mapbox": mapbox,
   * 	"OpenStreetMap": osm
   * };
   *
   * var overlays = {
   * 	"Marker": marker,
   * 	"Roads": roadsLayer
   * };
   *
   * L.control.layers(baseLayers, overlays).addTo(map);
   * ```
   *
   * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
   *
   * ```js
   * {
   *     "<someName1>": layer1,
   *     "<someName2>": layer2
   * }
   * ```
   *
   * The layer names can contain HTML, which allows you to add additional styling to the items:
   *
   * ```js
   * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
   * ```
   */ var Layers = Control.extend({
        // @section
        // @aka Control.Layers options
        options: {
            // @option collapsed: Boolean = true
            // If `true`, the control will be collapsed into an icon and expanded on mouse hover, touch, or keyboard activation.
            collapsed: true,
            position: 'topright',
            // @option autoZIndex: Boolean = true
            // If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
            autoZIndex: true,
            // @option hideSingleBase: Boolean = false
            // If `true`, the base layers in the control will be hidden when there is only one.
            hideSingleBase: false,
            // @option sortLayers: Boolean = false
            // Whether to sort the layers. When `false`, layers will keep the order
            // in which they were added to the control.
            sortLayers: false,
            // @option sortFunction: Function = *
            // A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
            // that will be used for sorting the layers, when `sortLayers` is `true`.
            // The function receives both the `L.Layer` instances and their names, as in
            // `sortFunction(layerA, layerB, nameA, nameB)`.
            // By default, it sorts layers alphabetically by their name.
            sortFunction: function(layerA, layerB, nameA, nameB) {
                return nameA < nameB ? -1 : nameB < nameA ? 1 : 0;
            }
        },
        initialize: function(baseLayers, overlays, options) {
            setOptions(this, options);
            this._layerControlInputs = [];
            this._layers = [];
            this._lastZIndex = 0;
            this._handlingClick = false;
            this._preventClick = false;
            for(var i in baseLayers)this._addLayer(baseLayers[i], i);
            for(i in overlays)this._addLayer(overlays[i], i, true);
        },
        onAdd: function(map) {
            this._initLayout();
            this._update();
            this._map = map;
            map.on('zoomend', this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.on('add remove', this._onLayerChange, this);
            return this._container;
        },
        addTo: function(map) {
            Control.prototype.addTo.call(this, map);
            // Trigger expand after Layers Control has been inserted into DOM so that is now has an actual height.
            return this._expandIfNotCollapsed();
        },
        onRemove: function() {
            this._map.off('zoomend', this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.off('add remove', this._onLayerChange, this);
        },
        // @method addBaseLayer(layer: Layer, name: String): this
        // Adds a base layer (radio button entry) with the given name to the control.
        addBaseLayer: function(layer, name) {
            this._addLayer(layer, name);
            return this._map ? this._update() : this;
        },
        // @method addOverlay(layer: Layer, name: String): this
        // Adds an overlay (checkbox entry) with the given name to the control.
        addOverlay: function(layer, name) {
            this._addLayer(layer, name, true);
            return this._map ? this._update() : this;
        },
        // @method removeLayer(layer: Layer): this
        // Remove the given layer from the control.
        removeLayer: function(layer) {
            layer.off('add remove', this._onLayerChange, this);
            var obj = this._getLayer(stamp(layer));
            if (obj) this._layers.splice(this._layers.indexOf(obj), 1);
            return this._map ? this._update() : this;
        },
        // @method expand(): this
        // Expand the control container if collapsed.
        expand: function() {
            addClass(this._container, 'leaflet-control-layers-expanded');
            this._section.style.height = null;
            var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
            if (acceptableHeight < this._section.clientHeight) {
                addClass(this._section, 'leaflet-control-layers-scrollbar');
                this._section.style.height = acceptableHeight + 'px';
            } else removeClass(this._section, 'leaflet-control-layers-scrollbar');
            this._checkDisabledLayers();
            return this;
        },
        // @method collapse(): this
        // Collapse the control container if expanded.
        collapse: function() {
            removeClass(this._container, 'leaflet-control-layers-expanded');
            return this;
        },
        _initLayout: function() {
            var className = 'leaflet-control-layers', container = this._container = create$1('div', className), collapsed = this.options.collapsed;
            // makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
            container.setAttribute('aria-haspopup', true);
            disableClickPropagation(container);
            disableScrollPropagation(container);
            var section = this._section = create$1('section', className + '-list');
            if (collapsed) {
                this._map.on('click', this.collapse, this);
                on(container, {
                    mouseenter: this._expandSafely,
                    mouseleave: this.collapse
                }, this);
            }
            var link = this._layersLink = create$1('a', className + '-toggle', container);
            link.href = '#';
            link.title = 'Layers';
            link.setAttribute('role', 'button');
            on(link, {
                keydown: function(e) {
                    if (e.keyCode === 13) this._expandSafely();
                },
                // Certain screen readers intercept the key event and instead send a click event
                click: function(e) {
                    preventDefault(e);
                    this._expandSafely();
                }
            }, this);
            if (!collapsed) this.expand();
            this._baseLayersList = create$1('div', className + '-base', section);
            this._separator = create$1('div', className + '-separator', section);
            this._overlaysList = create$1('div', className + '-overlays', section);
            container.appendChild(section);
        },
        _getLayer: function(id) {
            for(var i = 0; i < this._layers.length; i++){
                if (this._layers[i] && stamp(this._layers[i].layer) === id) return this._layers[i];
            }
        },
        _addLayer: function(layer, name, overlay) {
            if (this._map) layer.on('add remove', this._onLayerChange, this);
            this._layers.push({
                layer: layer,
                name: name,
                overlay: overlay
            });
            if (this.options.sortLayers) this._layers.sort(bind(function(a, b) {
                return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
            }, this));
            if (this.options.autoZIndex && layer.setZIndex) {
                this._lastZIndex++;
                layer.setZIndex(this._lastZIndex);
            }
            this._expandIfNotCollapsed();
        },
        _update: function() {
            if (!this._container) return this;
            empty(this._baseLayersList);
            empty(this._overlaysList);
            this._layerControlInputs = [];
            var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;
            for(i = 0; i < this._layers.length; i++){
                obj = this._layers[i];
                this._addItem(obj);
                overlaysPresent = overlaysPresent || obj.overlay;
                baseLayersPresent = baseLayersPresent || !obj.overlay;
                baseLayersCount += !obj.overlay ? 1 : 0;
            }
            // Hide base layers section if there's only one layer.
            if (this.options.hideSingleBase) {
                baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
                this._baseLayersList.style.display = baseLayersPresent ? '' : 'none';
            }
            this._separator.style.display = overlaysPresent && baseLayersPresent ? '' : 'none';
            return this;
        },
        _onLayerChange: function(e) {
            if (!this._handlingClick) this._update();
            var obj = this._getLayer(stamp(e.target));
            // @namespace Map
            // @section Layer events
            // @event baselayerchange: LayersControlEvent
            // Fired when the base layer is changed through the [layers control](#control-layers).
            // @event overlayadd: LayersControlEvent
            // Fired when an overlay is selected through the [layers control](#control-layers).
            // @event overlayremove: LayersControlEvent
            // Fired when an overlay is deselected through the [layers control](#control-layers).
            // @namespace Control.Layers
            var type = obj.overlay ? e.type === 'add' ? 'overlayadd' : 'overlayremove' : e.type === 'add' ? 'baselayerchange' : null;
            if (type) this._map.fire(type, obj);
        },
        // IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see https://stackoverflow.com/a/119079)
        _createRadioElement: function(name, checked) {
            var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' + name + '"' + (checked ? ' checked="checked"' : '') + '/>';
            var radioFragment = document.createElement('div');
            radioFragment.innerHTML = radioHtml;
            return radioFragment.firstChild;
        },
        _addItem: function(obj) {
            var label = document.createElement('label'), checked = this._map.hasLayer(obj.layer), input;
            if (obj.overlay) {
                input = document.createElement('input');
                input.type = 'checkbox';
                input.className = 'leaflet-control-layers-selector';
                input.defaultChecked = checked;
            } else input = this._createRadioElement('leaflet-base-layers_' + stamp(this), checked);
            this._layerControlInputs.push(input);
            input.layerId = stamp(obj.layer);
            on(input, 'click', this._onInputClick, this);
            var name = document.createElement('span');
            name.innerHTML = ' ' + obj.name;
            // Helps from preventing layer control flicker when checkboxes are disabled
            // https://github.com/Leaflet/Leaflet/issues/2771
            var holder = document.createElement('span');
            label.appendChild(holder);
            holder.appendChild(input);
            holder.appendChild(name);
            var container = obj.overlay ? this._overlaysList : this._baseLayersList;
            container.appendChild(label);
            this._checkDisabledLayers();
            return label;
        },
        _onInputClick: function() {
            // expanding the control on mobile with a click can cause adding a layer - we don't want this
            if (this._preventClick) return;
            var inputs = this._layerControlInputs, input, layer;
            var addedLayers = [], removedLayers = [];
            this._handlingClick = true;
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                if (input.checked) addedLayers.push(layer);
                else if (!input.checked) removedLayers.push(layer);
            }
            // Bugfix issue 2318: Should remove all old layers before readding new ones
            for(i = 0; i < removedLayers.length; i++)if (this._map.hasLayer(removedLayers[i])) this._map.removeLayer(removedLayers[i]);
            for(i = 0; i < addedLayers.length; i++)if (!this._map.hasLayer(addedLayers[i])) this._map.addLayer(addedLayers[i]);
            this._handlingClick = false;
            this._refocusOnMap();
        },
        _checkDisabledLayers: function() {
            var inputs = this._layerControlInputs, input, layer, zoom = this._map.getZoom();
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                input.disabled = layer.options.minZoom !== undefined && zoom < layer.options.minZoom || layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom;
            }
        },
        _expandIfNotCollapsed: function() {
            if (this._map && !this.options.collapsed) this.expand();
            return this;
        },
        _expandSafely: function() {
            var section = this._section;
            this._preventClick = true;
            on(section, 'click', preventDefault);
            this.expand();
            var that = this;
            setTimeout(function() {
                off(section, 'click', preventDefault);
                that._preventClick = false;
            });
        }
    });
    // @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
    // Creates a layers control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
    var layers = function(baseLayers, overlays, options) {
        return new Layers(baseLayers, overlays, options);
    };
    /*
   * @class Control.Zoom
   * @aka L.Control.Zoom
   * @inherits Control
   *
   * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
   */ var Zoom = Control.extend({
        // @section
        // @aka Control.Zoom options
        options: {
            position: 'topleft',
            // @option zoomInText: String = '<span aria-hidden="true">+</span>'
            // The text set on the 'zoom in' button.
            zoomInText: '<span aria-hidden="true">+</span>',
            // @option zoomInTitle: String = 'Zoom in'
            // The title set on the 'zoom in' button.
            zoomInTitle: 'Zoom in',
            // @option zoomOutText: String = '<span aria-hidden="true">&#x2212;</span>'
            // The text set on the 'zoom out' button.
            zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
            // @option zoomOutTitle: String = 'Zoom out'
            // The title set on the 'zoom out' button.
            zoomOutTitle: 'Zoom out'
        },
        onAdd: function(map) {
            var zoomName = 'leaflet-control-zoom', container = create$1('div', zoomName + ' leaflet-bar'), options = this.options;
            this._zoomInButton = this._createButton(options.zoomInText, options.zoomInTitle, zoomName + '-in', container, this._zoomIn);
            this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle, zoomName + '-out', container, this._zoomOut);
            this._updateDisabled();
            map.on('zoomend zoomlevelschange', this._updateDisabled, this);
            return container;
        },
        onRemove: function(map) {
            map.off('zoomend zoomlevelschange', this._updateDisabled, this);
        },
        disable: function() {
            this._disabled = true;
            this._updateDisabled();
            return this;
        },
        enable: function() {
            this._disabled = false;
            this._updateDisabled();
            return this;
        },
        _zoomIn: function(e) {
            if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _zoomOut: function(e) {
            if (!this._disabled && this._map._zoom > this._map.getMinZoom()) this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _createButton: function(html, title, className, container, fn) {
            var link = create$1('a', className, container);
            link.innerHTML = html;
            link.href = '#';
            link.title = title;
            /*
  		 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
  		 */ link.setAttribute('role', 'button');
            link.setAttribute('aria-label', title);
            disableClickPropagation(link);
            on(link, 'click', stop);
            on(link, 'click', fn, this);
            on(link, 'click', this._refocusOnMap, this);
            return link;
        },
        _updateDisabled: function() {
            var map = this._map, className = 'leaflet-disabled';
            removeClass(this._zoomInButton, className);
            removeClass(this._zoomOutButton, className);
            this._zoomInButton.setAttribute('aria-disabled', 'false');
            this._zoomOutButton.setAttribute('aria-disabled', 'false');
            if (this._disabled || map._zoom === map.getMinZoom()) {
                addClass(this._zoomOutButton, className);
                this._zoomOutButton.setAttribute('aria-disabled', 'true');
            }
            if (this._disabled || map._zoom === map.getMaxZoom()) {
                addClass(this._zoomInButton, className);
                this._zoomInButton.setAttribute('aria-disabled', 'true');
            }
        }
    });
    // @namespace Map
    // @section Control options
    // @option zoomControl: Boolean = true
    // Whether a [zoom control](#control-zoom) is added to the map by default.
    Map.mergeOptions({
        zoomControl: true
    });
    Map.addInitHook(function() {
        if (this.options.zoomControl) {
            // @section Controls
            // @property zoomControl: Control.Zoom
            // The default zoom control (only available if the
            // [`zoomControl` option](#map-zoomcontrol) was `true` when creating the map).
            this.zoomControl = new Zoom();
            this.addControl(this.zoomControl);
        }
    });
    // @namespace Control.Zoom
    // @factory L.control.zoom(options: Control.Zoom options)
    // Creates a zoom control
    var zoom = function(options) {
        return new Zoom(options);
    };
    /*
   * @class Control.Scale
   * @aka L.Control.Scale
   * @inherits Control
   *
   * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
   *
   * @example
   *
   * ```js
   * L.control.scale().addTo(map);
   * ```
   */ var Scale = Control.extend({
        // @section
        // @aka Control.Scale options
        options: {
            position: 'bottomleft',
            // @option maxWidth: Number = 100
            // Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
            maxWidth: 100,
            // @option metric: Boolean = True
            // Whether to show the metric scale line (m/km).
            metric: true,
            // @option imperial: Boolean = True
            // Whether to show the imperial scale line (mi/ft).
            imperial: true
        },
        onAdd: function(map) {
            var className = 'leaflet-control-scale', container = create$1('div', className), options = this.options;
            this._addScales(options, className + '-line', container);
            map.on(options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
            map.whenReady(this._update, this);
            return container;
        },
        onRemove: function(map) {
            map.off(this.options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
        },
        _addScales: function(options, className, container) {
            if (options.metric) this._mScale = create$1('div', className, container);
            if (options.imperial) this._iScale = create$1('div', className, container);
        },
        _update: function() {
            var map = this._map, y = map.getSize().y / 2;
            var maxMeters = map.distance(map.containerPointToLatLng([
                0,
                y
            ]), map.containerPointToLatLng([
                this.options.maxWidth,
                y
            ]));
            this._updateScales(maxMeters);
        },
        _updateScales: function(maxMeters) {
            if (this.options.metric && maxMeters) this._updateMetric(maxMeters);
            if (this.options.imperial && maxMeters) this._updateImperial(maxMeters);
        },
        _updateMetric: function(maxMeters) {
            var meters = this._getRoundNum(maxMeters), label = meters < 1000 ? meters + ' m' : meters / 1000 + ' km';
            this._updateScale(this._mScale, label, meters / maxMeters);
        },
        _updateImperial: function(maxMeters) {
            var maxFeet = maxMeters * 3.2808399, maxMiles, miles, feet;
            if (maxFeet > 5280) {
                maxMiles = maxFeet / 5280;
                miles = this._getRoundNum(maxMiles);
                this._updateScale(this._iScale, miles + ' mi', miles / maxMiles);
            } else {
                feet = this._getRoundNum(maxFeet);
                this._updateScale(this._iScale, feet + ' ft', feet / maxFeet);
            }
        },
        _updateScale: function(scale, text, ratio) {
            scale.style.width = Math.round(this.options.maxWidth * ratio) + 'px';
            scale.innerHTML = text;
        },
        _getRoundNum: function(num) {
            var pow10 = Math.pow(10, (Math.floor(num) + '').length - 1), d = num / pow10;
            d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : 1;
            return pow10 * d;
        }
    });
    // @factory L.control.scale(options?: Control.Scale options)
    // Creates an scale control with the given options.
    var scale = function(options) {
        return new Scale(options);
    };
    var ukrainianFlag = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg>';
    /*
   * @class Control.Attribution
   * @aka L.Control.Attribution
   * @inherits Control
   *
   * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
   */ var Attribution = Control.extend({
        // @section
        // @aka Control.Attribution options
        options: {
            position: 'bottomright',
            // @option prefix: String|false = 'Leaflet'
            // The HTML text shown before the attributions. Pass `false` to disable.
            prefix: '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">' + (Browser.inlineSvg ? ukrainianFlag + ' ' : '') + 'Leaflet</a>'
        },
        initialize: function(options) {
            setOptions(this, options);
            this._attributions = {};
        },
        onAdd: function(map) {
            map.attributionControl = this;
            this._container = create$1('div', 'leaflet-control-attribution');
            disableClickPropagation(this._container);
            // TODO ugly, refactor
            for(var i in map._layers)if (map._layers[i].getAttribution) this.addAttribution(map._layers[i].getAttribution());
            this._update();
            map.on('layeradd', this._addAttribution, this);
            return this._container;
        },
        onRemove: function(map) {
            map.off('layeradd', this._addAttribution, this);
        },
        _addAttribution: function(ev) {
            if (ev.layer.getAttribution) {
                this.addAttribution(ev.layer.getAttribution());
                ev.layer.once('remove', function() {
                    this.removeAttribution(ev.layer.getAttribution());
                }, this);
            }
        },
        // @method setPrefix(prefix: String|false): this
        // The HTML text shown before the attributions. Pass `false` to disable.
        setPrefix: function(prefix) {
            this.options.prefix = prefix;
            this._update();
            return this;
        },
        // @method addAttribution(text: String): this
        // Adds an attribution text (e.g. `'&copy; OpenStreetMap contributors'`).
        addAttribution: function(text) {
            if (!text) return this;
            if (!this._attributions[text]) this._attributions[text] = 0;
            this._attributions[text]++;
            this._update();
            return this;
        },
        // @method removeAttribution(text: String): this
        // Removes an attribution text.
        removeAttribution: function(text) {
            if (!text) return this;
            if (this._attributions[text]) {
                this._attributions[text]--;
                this._update();
            }
            return this;
        },
        _update: function() {
            if (!this._map) return;
            var attribs = [];
            for(var i in this._attributions)if (this._attributions[i]) attribs.push(i);
            var prefixAndAttribs = [];
            if (this.options.prefix) prefixAndAttribs.push(this.options.prefix);
            if (attribs.length) prefixAndAttribs.push(attribs.join(', '));
            this._container.innerHTML = prefixAndAttribs.join(' <span aria-hidden="true">|</span> ');
        }
    });
    // @namespace Map
    // @section Control options
    // @option attributionControl: Boolean = true
    // Whether a [attribution control](#control-attribution) is added to the map by default.
    Map.mergeOptions({
        attributionControl: true
    });
    Map.addInitHook(function() {
        if (this.options.attributionControl) new Attribution().addTo(this);
    });
    // @namespace Control.Attribution
    // @factory L.control.attribution(options: Control.Attribution options)
    // Creates an attribution control.
    var attribution = function(options) {
        return new Attribution(options);
    };
    Control.Layers = Layers;
    Control.Zoom = Zoom;
    Control.Scale = Scale;
    Control.Attribution = Attribution;
    control.layers = layers;
    control.zoom = zoom;
    control.scale = scale;
    control.attribution = attribution;
    /*
  	L.Handler is a base class for handler classes that are used internally to inject
  	interaction features like dragging to classes like Map and Marker.
  */ // @class Handler
    // @aka L.Handler
    // Abstract class for map interaction handlers
    var Handler = Class.extend({
        initialize: function(map) {
            this._map = map;
        },
        // @method enable(): this
        // Enables the handler
        enable: function() {
            if (this._enabled) return this;
            this._enabled = true;
            this.addHooks();
            return this;
        },
        // @method disable(): this
        // Disables the handler
        disable: function() {
            if (!this._enabled) return this;
            this._enabled = false;
            this.removeHooks();
            return this;
        },
        // @method enabled(): Boolean
        // Returns `true` if the handler is enabled
        enabled: function() {
            return !!this._enabled;
        }
    });
    // @section There is static function which can be called without instantiating L.Handler:
    // @function addTo(map: Map, name: String): this
    // Adds a new Handler to the given map with the given name.
    Handler.addTo = function(map, name) {
        map.addHandler(name, this);
        return this;
    };
    var Mixin = {
        Events: Events
    };
    /*
   * @class Draggable
   * @aka L.Draggable
   * @inherits Evented
   *
   * A class for making DOM elements draggable (including touch support).
   * Used internally for map and marker dragging. Only works for elements
   * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
   *
   * @example
   * ```js
   * var draggable = new L.Draggable(elementToDrag);
   * draggable.enable();
   * ```
   */ var START = Browser.touch ? 'touchstart mousedown' : 'mousedown';
    var Draggable = Evented.extend({
        options: {
            // @section
            // @aka Draggable options
            // @option clickTolerance: Number = 3
            // The max number of pixels a user can shift the mouse pointer during a click
            // for it to be considered a valid click (as opposed to a mouse drag).
            clickTolerance: 3
        },
        // @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
        // Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
        initialize: function(element, dragStartTarget, preventOutline, options) {
            setOptions(this, options);
            this._element = element;
            this._dragStartTarget = dragStartTarget || element;
            this._preventOutline = preventOutline;
        },
        // @method enable()
        // Enables the dragging ability
        enable: function() {
            if (this._enabled) return;
            on(this._dragStartTarget, START, this._onDown, this);
            this._enabled = true;
        },
        // @method disable()
        // Disables the dragging ability
        disable: function() {
            if (!this._enabled) return;
            // If we're currently dragging this draggable,
            // disabling it counts as first ending the drag.
            if (Draggable._dragging === this) this.finishDrag(true);
            off(this._dragStartTarget, START, this._onDown, this);
            this._enabled = false;
            this._moved = false;
        },
        _onDown: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this._moved = false;
            if (hasClass(this._element, 'leaflet-zoom-anim')) return;
            if (e.touches && e.touches.length !== 1) {
                // Finish dragging to avoid conflict with touchZoom
                if (Draggable._dragging === this) this.finishDrag();
                return;
            }
            if (Draggable._dragging || e.shiftKey || e.which !== 1 && e.button !== 1 && !e.touches) return;
            Draggable._dragging = this; // Prevent dragging multiple objects at once.
            if (this._preventOutline) preventOutline(this._element);
            disableImageDrag();
            disableTextSelection();
            if (this._moving) return;
            // @event down: Event
            // Fired when a drag is about to start.
            this.fire('down');
            var first = e.touches ? e.touches[0] : e, sizedParent = getSizedParentNode(this._element);
            this._startPoint = new Point(first.clientX, first.clientY);
            this._startPos = getPosition(this._element);
            // Cache the scale, so that we can continuously compensate for it during drag (_onMove).
            this._parentScale = getScale(sizedParent);
            var mouseevent = e.type === 'mousedown';
            on(document, mouseevent ? 'mousemove' : 'touchmove', this._onMove, this);
            on(document, mouseevent ? 'mouseup' : 'touchend touchcancel', this._onUp, this);
        },
        _onMove: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            if (e.touches && e.touches.length > 1) {
                this._moved = true;
                return;
            }
            var first = e.touches && e.touches.length === 1 ? e.touches[0] : e, offset = new Point(first.clientX, first.clientY)._subtract(this._startPoint);
            if (!offset.x && !offset.y) return;
            if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) return;
            // We assume that the parent container's position, border and scale do not change for the duration of the drag.
            // Therefore there is no need to account for the position and border (they are eliminated by the subtraction)
            // and we can use the cached value for the scale.
            offset.x /= this._parentScale.x;
            offset.y /= this._parentScale.y;
            preventDefault(e);
            if (!this._moved) {
                // @event dragstart: Event
                // Fired when a drag starts
                this.fire('dragstart');
                this._moved = true;
                addClass(document.body, 'leaflet-dragging');
                this._lastTarget = e.target || e.srcElement;
                // IE and Edge do not give the <use> element, so fetch it
                // if necessary
                if (window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance) this._lastTarget = this._lastTarget.correspondingUseElement;
                addClass(this._lastTarget, 'leaflet-drag-target');
            }
            this._newPos = this._startPos.add(offset);
            this._moving = true;
            this._lastEvent = e;
            this._updatePosition();
        },
        _updatePosition: function() {
            var e = {
                originalEvent: this._lastEvent
            };
            // @event predrag: Event
            // Fired continuously during dragging *before* each corresponding
            // update of the element's position.
            this.fire('predrag', e);
            setPosition(this._element, this._newPos);
            // @event drag: Event
            // Fired continuously during dragging.
            this.fire('drag', e);
        },
        _onUp: function() {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this.finishDrag();
        },
        finishDrag: function(noInertia) {
            removeClass(document.body, 'leaflet-dragging');
            if (this._lastTarget) {
                removeClass(this._lastTarget, 'leaflet-drag-target');
                this._lastTarget = null;
            }
            off(document, 'mousemove touchmove', this._onMove, this);
            off(document, 'mouseup touchend touchcancel', this._onUp, this);
            enableImageDrag();
            enableTextSelection();
            var fireDragend = this._moved && this._moving;
            this._moving = false;
            Draggable._dragging = false;
            if (fireDragend) // @event dragend: DragEndEvent
            // Fired when the drag ends.
            this.fire('dragend', {
                noInertia: noInertia,
                distance: this._newPos.distanceTo(this._startPos)
            });
        }
    });
    /*
   * @namespace PolyUtil
   * Various utility functions for polygon geometries.
   */ /* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
   * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
   * Used by Leaflet to only show polygon points that are on the screen or near, increasing
   * performance. Note that polygon points needs different algorithm for clipping
   * than polyline, so there's a separate method for it.
   */ function clipPolygon(points, bounds, round) {
        var clippedPoints, edges = [
            1,
            4,
            2,
            8
        ], i, j, k, a, b, len, edge, p;
        for(i = 0, len = points.length; i < len; i++)points[i]._code = _getBitCode(points[i], bounds);
        // for each edge (left, bottom, right, top)
        for(k = 0; k < 4; k++){
            edge = edges[k];
            clippedPoints = [];
            for(i = 0, len = points.length, j = len - 1; i < len; j = i++){
                a = points[i];
                b = points[j];
                // if a is inside the clip window
                if (!(a._code & edge)) {
                    // if b is outside the clip window (a->b goes out of screen)
                    if (b._code & edge) {
                        p = _getEdgeIntersection(b, a, edge, bounds, round);
                        p._code = _getBitCode(p, bounds);
                        clippedPoints.push(p);
                    }
                    clippedPoints.push(a);
                // else if b is inside the clip window (a->b enters the screen)
                } else if (!(b._code & edge)) {
                    p = _getEdgeIntersection(b, a, edge, bounds, round);
                    p._code = _getBitCode(p, bounds);
                    clippedPoints.push(p);
                }
            }
            points = clippedPoints;
        }
        return points;
    }
    /* @function polygonCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polygon.
   */ function polygonCenter(latlngs, crs) {
        var i, j, p1, p2, f, area, x, y, center;
        if (!latlngs || latlngs.length === 0) throw new Error('latlngs not passed');
        if (!isFlat(latlngs)) {
            console.warn('latlngs are not flat! Only the first ring will be used');
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        area = x = y = 0;
        // polygon centroid algorithm;
        for(i = 0, j = len - 1; i < len; j = i++){
            p1 = points[i];
            p2 = points[j];
            f = p1.y * p2.x - p2.y * p1.x;
            x += (p1.x + p2.x) * f;
            y += (p1.y + p2.y) * f;
            area += f * 3;
        }
        if (area === 0) // Polygon is so small that all points are on same pixel.
        center = points[0];
        else center = [
            x / area,
            y / area
        ];
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    /* @function centroid(latlngs: LatLng[]): LatLng
   * Returns the 'center of mass' of the passed LatLngs.
   */ function centroid(coords) {
        var latSum = 0;
        var lngSum = 0;
        var len = 0;
        for(var i = 0; i < coords.length; i++){
            var latlng = toLatLng(coords[i]);
            latSum += latlng.lat;
            lngSum += latlng.lng;
            len++;
        }
        return toLatLng([
            latSum / len,
            lngSum / len
        ]);
    }
    var PolyUtil = {
        __proto__: null,
        clipPolygon: clipPolygon,
        polygonCenter: polygonCenter,
        centroid: centroid
    };
    /*
   * @namespace LineUtil
   *
   * Various utility functions for polyline points processing, used by Leaflet internally to make polylines lightning-fast.
   */ // Simplify polyline with vertex reduction and Douglas-Peucker simplification.
    // Improves rendering performance dramatically by lessening the number of points to draw.
    // @function simplify(points: Point[], tolerance: Number): Point[]
    // Dramatically reduces the number of points in a polyline while retaining
    // its shape and returns a new array of simplified points, using the
    // [Ramer-Douglas-Peucker algorithm](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm).
    // Used for a huge performance boost when processing/displaying Leaflet polylines for
    // each zoom level and also reducing visual noise. tolerance affects the amount of
    // simplification (lesser value means higher quality but slower and with more points).
    // Also released as a separated micro-library [Simplify.js](https://mourner.github.io/simplify-js/).
    function simplify(points, tolerance) {
        if (!tolerance || !points.length) return points.slice();
        var sqTolerance = tolerance * tolerance;
        // stage 1: vertex reduction
        points = _reducePoints(points, sqTolerance);
        // stage 2: Douglas-Peucker simplification
        points = _simplifyDP(points, sqTolerance);
        return points;
    }
    // @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
    // Returns the distance between point `p` and segment `p1` to `p2`.
    function pointToSegmentDistance(p, p1, p2) {
        return Math.sqrt(_sqClosestPointOnSegment(p, p1, p2, true));
    }
    // @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
    // Returns the closest point from a point `p` on a segment `p1` to `p2`.
    function closestPointOnSegment(p, p1, p2) {
        return _sqClosestPointOnSegment(p, p1, p2);
    }
    // Ramer-Douglas-Peucker simplification, see https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm
    function _simplifyDP(points, sqTolerance) {
        var len = points.length, ArrayConstructor = typeof Uint8Array !== "undefined" ? Uint8Array : Array, markers = new ArrayConstructor(len);
        markers[0] = markers[len - 1] = 1;
        _simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
        var i, newPoints = [];
        for(i = 0; i < len; i++)if (markers[i]) newPoints.push(points[i]);
        return newPoints;
    }
    function _simplifyDPStep(points, markers, sqTolerance, first, last) {
        var maxSqDist = 0, index, i, sqDist;
        for(i = first + 1; i <= last - 1; i++){
            sqDist = _sqClosestPointOnSegment(points[i], points[first], points[last], true);
            if (sqDist > maxSqDist) {
                index = i;
                maxSqDist = sqDist;
            }
        }
        if (maxSqDist > sqTolerance) {
            markers[index] = 1;
            _simplifyDPStep(points, markers, sqTolerance, first, index);
            _simplifyDPStep(points, markers, sqTolerance, index, last);
        }
    }
    // reduce points that are too close to each other to a single point
    function _reducePoints(points, sqTolerance) {
        var reducedPoints = [
            points[0]
        ];
        for(var i = 1, prev = 0, len = points.length; i < len; i++)if (_sqDist(points[i], points[prev]) > sqTolerance) {
            reducedPoints.push(points[i]);
            prev = i;
        }
        if (prev < len - 1) reducedPoints.push(points[len - 1]);
        return reducedPoints;
    }
    var _lastCode;
    // @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
    // Clips the segment a to b by rectangular bounds with the
    // [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
    // (modifying the segment points directly!). Used by Leaflet to only show polyline
    // points that are on the screen or near, increasing performance.
    function clipSegment(a, b, bounds, useLastCode, round) {
        var codeA = useLastCode ? _lastCode : _getBitCode(a, bounds), codeB = _getBitCode(b, bounds), codeOut, p, newCode;
        // save 2nd code to avoid calculating it on the next segment
        _lastCode = codeB;
        while(true){
            // if a,b is inside the clip window (trivial accept)
            if (!(codeA | codeB)) return [
                a,
                b
            ];
            // if a,b is outside the clip window (trivial reject)
            if (codeA & codeB) return false;
            // other cases
            codeOut = codeA || codeB;
            p = _getEdgeIntersection(a, b, codeOut, bounds, round);
            newCode = _getBitCode(p, bounds);
            if (codeOut === codeA) {
                a = p;
                codeA = newCode;
            } else {
                b = p;
                codeB = newCode;
            }
        }
    }
    function _getEdgeIntersection(a, b, code, bounds, round) {
        var dx = b.x - a.x, dy = b.y - a.y, min = bounds.min, max = bounds.max, x, y;
        if (code & 8) {
            x = a.x + dx * (max.y - a.y) / dy;
            y = max.y;
        } else if (code & 4) {
            x = a.x + dx * (min.y - a.y) / dy;
            y = min.y;
        } else if (code & 2) {
            x = max.x;
            y = a.y + dy * (max.x - a.x) / dx;
        } else if (code & 1) {
            x = min.x;
            y = a.y + dy * (min.x - a.x) / dx;
        }
        return new Point(x, y, round);
    }
    function _getBitCode(p, bounds) {
        var code = 0;
        if (p.x < bounds.min.x) code |= 1;
        else if (p.x > bounds.max.x) code |= 2;
        if (p.y < bounds.min.y) code |= 4;
        else if (p.y > bounds.max.y) code |= 8;
        return code;
    }
    // square distance (to avoid unnecessary Math.sqrt calls)
    function _sqDist(p1, p2) {
        var dx = p2.x - p1.x, dy = p2.y - p1.y;
        return dx * dx + dy * dy;
    }
    // return closest point on segment or distance to that point
    function _sqClosestPointOnSegment(p, p1, p2, sqDist) {
        var x = p1.x, y = p1.y, dx = p2.x - x, dy = p2.y - y, dot = dx * dx + dy * dy, t;
        if (dot > 0) {
            t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
            if (t > 1) {
                x = p2.x;
                y = p2.y;
            } else if (t > 0) {
                x += dx * t;
                y += dy * t;
            }
        }
        dx = p.x - x;
        dy = p.y - y;
        return sqDist ? dx * dx + dy * dy : new Point(x, y);
    }
    // @function isFlat(latlngs: LatLng[]): Boolean
    // Returns true if `latlngs` is a flat array, false is nested.
    function isFlat(latlngs) {
        return !isArray(latlngs[0]) || typeof latlngs[0][0] !== 'object' && typeof latlngs[0][0] !== 'undefined';
    }
    function _flat(latlngs) {
        console.warn('Deprecated use of _flat, please use L.LineUtil.isFlat instead.');
        return isFlat(latlngs);
    }
    /* @function polylineCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polyline.
   */ function polylineCenter(latlngs, crs) {
        var i, halfDist, segDist, dist, p1, p2, ratio, center;
        if (!latlngs || latlngs.length === 0) throw new Error('latlngs not passed');
        if (!isFlat(latlngs)) {
            console.warn('latlngs are not flat! Only the first ring will be used');
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        for(i = 0, halfDist = 0; i < len - 1; i++)halfDist += points[i].distanceTo(points[i + 1]) / 2;
        // The line is so small in the current view that all points are on the same pixel.
        if (halfDist === 0) center = points[0];
        else for(i = 0, dist = 0; i < len - 1; i++){
            p1 = points[i];
            p2 = points[i + 1];
            segDist = p1.distanceTo(p2);
            dist += segDist;
            if (dist > halfDist) {
                ratio = (dist - halfDist) / segDist;
                center = [
                    p2.x - ratio * (p2.x - p1.x),
                    p2.y - ratio * (p2.y - p1.y)
                ];
                break;
            }
        }
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    var LineUtil = {
        __proto__: null,
        simplify: simplify,
        pointToSegmentDistance: pointToSegmentDistance,
        closestPointOnSegment: closestPointOnSegment,
        clipSegment: clipSegment,
        _getEdgeIntersection: _getEdgeIntersection,
        _getBitCode: _getBitCode,
        _sqClosestPointOnSegment: _sqClosestPointOnSegment,
        isFlat: isFlat,
        _flat: _flat,
        polylineCenter: polylineCenter
    };
    /*
   * @namespace Projection
   * @section
   * Leaflet comes with a set of already defined Projections out of the box:
   *
   * @projection L.Projection.LonLat
   *
   * Equirectangular, or Plate Carree projection — the most simple projection,
   * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
   * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
   * `EPSG:4326` and `Simple` CRS.
   */ var LonLat = {
        project: function(latlng) {
            return new Point(latlng.lng, latlng.lat);
        },
        unproject: function(point) {
            return new LatLng(point.y, point.x);
        },
        bounds: new Bounds([
            -180,
            -90
        ], [
            180,
            90
        ])
    };
    /*
   * @namespace Projection
   * @projection L.Projection.Mercator
   *
   * Elliptical Mercator projection — more complex than Spherical Mercator. Assumes that Earth is an ellipsoid. Used by the EPSG:3395 CRS.
   */ var Mercator = {
        R: 6378137,
        R_MINOR: 6356752.314245179,
        bounds: new Bounds([
            -20037508.34279,
            -15496570.73972
        ], [
            20037508.34279,
            18764656.23138
        ]),
        project: function(latlng) {
            var d = Math.PI / 180, r = this.R, y = latlng.lat * d, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), con = e * Math.sin(y);
            var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
            y = -r * Math.log(Math.max(ts, 1E-10));
            return new Point(latlng.lng * d * r, y);
        },
        unproject: function(point) {
            var d = 180 / Math.PI, r = this.R, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), ts = Math.exp(-point.y / r), phi = Math.PI / 2 - 2 * Math.atan(ts);
            for(var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++){
                con = e * Math.sin(phi);
                con = Math.pow((1 - con) / (1 + con), e / 2);
                dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
                phi += dphi;
            }
            return new LatLng(phi * d, point.x * d / r);
        }
    };
    /*
   * @class Projection

   * An object with methods for projecting geographical coordinates of the world onto
   * a flat surface (and back). See [Map projection](https://en.wikipedia.org/wiki/Map_projection).

   * @property bounds: Bounds
   * The bounds (specified in CRS units) where the projection is valid

   * @method project(latlng: LatLng): Point
   * Projects geographical coordinates into a 2D point.
   * Only accepts actual `L.LatLng` instances, not arrays.

   * @method unproject(point: Point): LatLng
   * The inverse of `project`. Projects a 2D point into a geographical location.
   * Only accepts actual `L.Point` instances, not arrays.

   * Note that the projection instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.

   */ var index = {
        __proto__: null,
        LonLat: LonLat,
        Mercator: Mercator,
        SphericalMercator: SphericalMercator
    };
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3395
   *
   * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
   */ var EPSG3395 = extend({}, Earth, {
        code: 'EPSG:3395',
        projection: Mercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * Mercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG4326
   *
   * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
   *
   * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
   * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
   * with this CRS, ensure that there are two 256x256 pixel tiles covering the
   * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
   * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
   */ var EPSG4326 = extend({}, Earth, {
        code: 'EPSG:4326',
        projection: LonLat,
        transformation: toTransformation(1 / 180, 1, -1 / 180, 0.5)
    });
    /*
   * @namespace CRS
   * @crs L.CRS.Simple
   *
   * A simple CRS that maps longitude and latitude into `x` and `y` directly.
   * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
   * axis should still be inverted (going from bottom to top). `distance()` returns
   * simple euclidean distance.
   */ var Simple = extend({}, CRS, {
        projection: LonLat,
        transformation: toTransformation(1, 0, -1, 0),
        scale: function(zoom) {
            return Math.pow(2, zoom);
        },
        zoom: function(scale) {
            return Math.log(scale) / Math.LN2;
        },
        distance: function(latlng1, latlng2) {
            var dx = latlng2.lng - latlng1.lng, dy = latlng2.lat - latlng1.lat;
            return Math.sqrt(dx * dx + dy * dy);
        },
        infinite: true
    });
    CRS.Earth = Earth;
    CRS.EPSG3395 = EPSG3395;
    CRS.EPSG3857 = EPSG3857;
    CRS.EPSG900913 = EPSG900913;
    CRS.EPSG4326 = EPSG4326;
    CRS.Simple = Simple;
    /*
   * @class Layer
   * @inherits Evented
   * @aka L.Layer
   * @aka ILayer
   *
   * A set of methods from the Layer base class that all Leaflet layers use.
   * Inherits all methods, options and events from `L.Evented`.
   *
   * @example
   *
   * ```js
   * var layer = L.marker(latlng).addTo(map);
   * layer.addTo(map);
   * layer.remove();
   * ```
   *
   * @event add: Event
   * Fired after the layer is added to a map
   *
   * @event remove: Event
   * Fired after the layer is removed from a map
   */ var Layer = Evented.extend({
        // Classes extending `L.Layer` will inherit the following options:
        options: {
            // @option pane: String = 'overlayPane'
            // By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
            pane: 'overlayPane',
            // @option attribution: String = null
            // String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
            attribution: null,
            bubblingMouseEvents: true
        },
        /* @section
  	 * Classes extending `L.Layer` will inherit the following methods:
  	 *
  	 * @method addTo(map: Map|LayerGroup): this
  	 * Adds the layer to the given map or layer group.
  	 */ addTo: function(map) {
            map.addLayer(this);
            return this;
        },
        // @method remove: this
        // Removes the layer from the map it is currently active on.
        remove: function() {
            return this.removeFrom(this._map || this._mapToAdd);
        },
        // @method removeFrom(map: Map): this
        // Removes the layer from the given map
        //
        // @alternative
        // @method removeFrom(group: LayerGroup): this
        // Removes the layer from the given `LayerGroup`
        removeFrom: function(obj) {
            if (obj) obj.removeLayer(this);
            return this;
        },
        // @method getPane(name? : String): HTMLElement
        // Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
        getPane: function(name) {
            return this._map.getPane(name ? this.options[name] || name : this.options.pane);
        },
        addInteractiveTarget: function(targetEl) {
            this._map._targets[stamp(targetEl)] = this;
            return this;
        },
        removeInteractiveTarget: function(targetEl) {
            delete this._map._targets[stamp(targetEl)];
            return this;
        },
        // @method getAttribution: String
        // Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
        getAttribution: function() {
            return this.options.attribution;
        },
        _layerAdd: function(e) {
            var map = e.target;
            // check in case layer gets added and then removed before the map is ready
            if (!map.hasLayer(this)) return;
            this._map = map;
            this._zoomAnimated = map._zoomAnimated;
            if (this.getEvents) {
                var events = this.getEvents();
                map.on(events, this);
                this.once('remove', function() {
                    map.off(events, this);
                }, this);
            }
            this.onAdd(map);
            this.fire('add');
            map.fire('layeradd', {
                layer: this
            });
        }
    });
    /* @section Extension methods
   * @uninheritable
   *
   * Every layer should extend from `L.Layer` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): this
   * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
   *
   * @method onRemove(map: Map): this
   * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
   *
   * @method getEvents(): Object
   * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
   *
   * @method getAttribution(): String
   * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
   *
   * @method beforeAdd(map: Map): this
   * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
   */ /* @namespace Map
   * @section Layer events
   *
   * @event layeradd: LayerEvent
   * Fired when a new layer is added to the map.
   *
   * @event layerremove: LayerEvent
   * Fired when some layer is removed from the map
   *
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the map
        addLayer: function(layer) {
            if (!layer._layerAdd) throw new Error('The provided object is not a Layer.');
            var id = stamp(layer);
            if (this._layers[id]) return this;
            this._layers[id] = layer;
            layer._mapToAdd = this;
            if (layer.beforeAdd) layer.beforeAdd(this);
            this.whenReady(layer._layerAdd, layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the map.
        removeLayer: function(layer) {
            var id = stamp(layer);
            if (!this._layers[id]) return this;
            if (this._loaded) layer.onRemove(this);
            delete this._layers[id];
            if (this._loaded) {
                this.fire('layerremove', {
                    layer: layer
                });
                layer.fire('remove');
            }
            layer._map = layer._mapToAdd = null;
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the map
        hasLayer: function(layer) {
            return stamp(layer) in this._layers;
        },
        /* @method eachLayer(fn: Function, context?: Object): this
  	 * Iterates over the layers of the map, optionally specifying context of the iterator function.
  	 * ```
  	 * map.eachLayer(function(layer){
  	 *     layer.bindPopup('Hello');
  	 * });
  	 * ```
  	 */ eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        _addLayers: function(layers) {
            layers = layers ? isArray(layers) ? layers : [
                layers
            ] : [];
            for(var i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        _addZoomLimit: function(layer) {
            if (!isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
                this._zoomBoundLayers[stamp(layer)] = layer;
                this._updateZoomLevels();
            }
        },
        _removeZoomLimit: function(layer) {
            var id = stamp(layer);
            if (this._zoomBoundLayers[id]) {
                delete this._zoomBoundLayers[id];
                this._updateZoomLevels();
            }
        },
        _updateZoomLevels: function() {
            var minZoom = Infinity, maxZoom = -Infinity, oldZoomSpan = this._getZoomSpan();
            for(var i in this._zoomBoundLayers){
                var options = this._zoomBoundLayers[i].options;
                minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
                maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
            }
            this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
            this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;
            // @section Map state change events
            // @event zoomlevelschange: Event
            // Fired when the number of zoomlevels on the map is changed due
            // to adding or removing a layer.
            if (oldZoomSpan !== this._getZoomSpan()) this.fire('zoomlevelschange');
            if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) this.setZoom(this._layersMaxZoom);
            if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) this.setZoom(this._layersMinZoom);
        }
    });
    /*
   * @class LayerGroup
   * @aka L.LayerGroup
   * @inherits Interactive layer
   *
   * Used to group several layers and handle them as one. If you add it to the map,
   * any layers added or removed from the group will be added/removed on the map as
   * well. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.layerGroup([marker1, marker2])
   * 	.addLayer(polyline)
   * 	.addTo(map);
   * ```
   */ var LayerGroup = Layer.extend({
        initialize: function(layers, options) {
            setOptions(this, options);
            this._layers = {};
            var i, len;
            if (layers) for(i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the group.
        addLayer: function(layer) {
            var id = this.getLayerId(layer);
            this._layers[id] = layer;
            if (this._map) this._map.addLayer(layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the group.
        // @alternative
        // @method removeLayer(id: Number): this
        // Removes the layer with the given internal ID from the group.
        removeLayer: function(layer) {
            var id = layer in this._layers ? layer : this.getLayerId(layer);
            if (this._map && this._layers[id]) this._map.removeLayer(this._layers[id]);
            delete this._layers[id];
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the group.
        // @alternative
        // @method hasLayer(id: Number): Boolean
        // Returns `true` if the given internal ID is currently added to the group.
        hasLayer: function(layer) {
            var layerId = typeof layer === 'number' ? layer : this.getLayerId(layer);
            return layerId in this._layers;
        },
        // @method clearLayers(): this
        // Removes all the layers from the group.
        clearLayers: function() {
            return this.eachLayer(this.removeLayer, this);
        },
        // @method invoke(methodName: String, …): this
        // Calls `methodName` on every layer contained in this group, passing any
        // additional parameters. Has no effect if the layers contained do not
        // implement `methodName`.
        invoke: function(methodName) {
            var args = Array.prototype.slice.call(arguments, 1), i, layer;
            for(i in this._layers){
                layer = this._layers[i];
                if (layer[methodName]) layer[methodName].apply(layer, args);
            }
            return this;
        },
        onAdd: function(map) {
            this.eachLayer(map.addLayer, map);
        },
        onRemove: function(map) {
            this.eachLayer(map.removeLayer, map);
        },
        // @method eachLayer(fn: Function, context?: Object): this
        // Iterates over the layers of the group, optionally specifying context of the iterator function.
        // ```js
        // group.eachLayer(function (layer) {
        // 	layer.bindPopup('Hello');
        // });
        // ```
        eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        // @method getLayer(id: Number): Layer
        // Returns the layer with the given internal ID.
        getLayer: function(id) {
            return this._layers[id];
        },
        // @method getLayers(): Layer[]
        // Returns an array of all the layers added to the group.
        getLayers: function() {
            var layers = [];
            this.eachLayer(layers.push, layers);
            return layers;
        },
        // @method setZIndex(zIndex: Number): this
        // Calls `setZIndex` on every layer contained in this group, passing the z-index.
        setZIndex: function(zIndex) {
            return this.invoke('setZIndex', zIndex);
        },
        // @method getLayerId(layer: Layer): Number
        // Returns the internal ID for a layer
        getLayerId: function(layer) {
            return stamp(layer);
        }
    });
    // @factory L.layerGroup(layers?: Layer[], options?: Object)
    // Create a layer group, optionally given an initial set of layers and an `options` object.
    var layerGroup = function(layers, options) {
        return new LayerGroup(layers, options);
    };
    /*
   * @class FeatureGroup
   * @aka L.FeatureGroup
   * @inherits LayerGroup
   *
   * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
   *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
   *  * Events are propagated to the `FeatureGroup`, so if the group has an event
   * handler, it will handle events from any of the layers. This includes mouse events
   * and custom events.
   *  * Has `layeradd` and `layerremove` events
   *
   * @example
   *
   * ```js
   * L.featureGroup([marker1, marker2, polyline])
   * 	.bindPopup('Hello world!')
   * 	.on('click', function() { alert('Clicked on a member of the group!'); })
   * 	.addTo(map);
   * ```
   */ var FeatureGroup = LayerGroup.extend({
        addLayer: function(layer) {
            if (this.hasLayer(layer)) return this;
            layer.addEventParent(this);
            LayerGroup.prototype.addLayer.call(this, layer);
            // @event layeradd: LayerEvent
            // Fired when a layer is added to this `FeatureGroup`
            return this.fire('layeradd', {
                layer: layer
            });
        },
        removeLayer: function(layer) {
            if (!this.hasLayer(layer)) return this;
            if (layer in this._layers) layer = this._layers[layer];
            layer.removeEventParent(this);
            LayerGroup.prototype.removeLayer.call(this, layer);
            // @event layerremove: LayerEvent
            // Fired when a layer is removed from this `FeatureGroup`
            return this.fire('layerremove', {
                layer: layer
            });
        },
        // @method setStyle(style: Path options): this
        // Sets the given path options to each layer of the group that has a `setStyle` method.
        setStyle: function(style) {
            return this.invoke('setStyle', style);
        },
        // @method bringToFront(): this
        // Brings the layer group to the top of all other layers
        bringToFront: function() {
            return this.invoke('bringToFront');
        },
        // @method bringToBack(): this
        // Brings the layer group to the back of all other layers
        bringToBack: function() {
            return this.invoke('bringToBack');
        },
        // @method getBounds(): LatLngBounds
        // Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
        getBounds: function() {
            var bounds = new LatLngBounds();
            for(var id in this._layers){
                var layer = this._layers[id];
                bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
            }
            return bounds;
        }
    });
    // @factory L.featureGroup(layers?: Layer[], options?: Object)
    // Create a feature group, optionally given an initial set of layers and an `options` object.
    var featureGroup = function(layers, options) {
        return new FeatureGroup(layers, options);
    };
    /*
   * @class Icon
   * @aka L.Icon
   *
   * Represents an icon to provide when creating a marker.
   *
   * @example
   *
   * ```js
   * var myIcon = L.icon({
   *     iconUrl: 'my-icon.png',
   *     iconRetinaUrl: 'my-icon@2x.png',
   *     iconSize: [38, 95],
   *     iconAnchor: [22, 94],
   *     popupAnchor: [-3, -76],
   *     shadowUrl: 'my-icon-shadow.png',
   *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
   *     shadowSize: [68, 95],
   *     shadowAnchor: [22, 94]
   * });
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
   *
   */ var Icon = Class.extend({
        /* @section
  	 * @aka Icon options
  	 *
  	 * @option iconUrl: String = null
  	 * **(required)** The URL to the icon image (absolute or relative to your script path).
  	 *
  	 * @option iconRetinaUrl: String = null
  	 * The URL to a retina sized version of the icon image (absolute or relative to your
  	 * script path). Used for Retina screen devices.
  	 *
  	 * @option iconSize: Point = null
  	 * Size of the icon image in pixels.
  	 *
  	 * @option iconAnchor: Point = null
  	 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
  	 * will be aligned so that this point is at the marker's geographical location. Centered
  	 * by default if size is specified, also can be set in CSS with negative margins.
  	 *
  	 * @option popupAnchor: Point = [0, 0]
  	 * The coordinates of the point from which popups will "open", relative to the icon anchor.
  	 *
  	 * @option tooltipAnchor: Point = [0, 0]
  	 * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
  	 *
  	 * @option shadowUrl: String = null
  	 * The URL to the icon shadow image. If not specified, no shadow image will be created.
  	 *
  	 * @option shadowRetinaUrl: String = null
  	 *
  	 * @option shadowSize: Point = null
  	 * Size of the shadow image in pixels.
  	 *
  	 * @option shadowAnchor: Point = null
  	 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
  	 * as iconAnchor if not specified).
  	 *
  	 * @option className: String = ''
  	 * A custom class name to assign to both icon and shadow images. Empty by default.
  	 */ options: {
            popupAnchor: [
                0,
                0
            ],
            tooltipAnchor: [
                0,
                0
            ],
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        // @method createIcon(oldIcon?: HTMLElement): HTMLElement
        // Called internally when the icon has to be shown, returns a `<img>` HTML element
        // styled according to the options.
        createIcon: function(oldIcon) {
            return this._createIcon('icon', oldIcon);
        },
        // @method createShadow(oldIcon?: HTMLElement): HTMLElement
        // As `createIcon`, but for the shadow beneath it.
        createShadow: function(oldIcon) {
            return this._createIcon('shadow', oldIcon);
        },
        _createIcon: function(name, oldIcon) {
            var src = this._getIconUrl(name);
            if (!src) {
                if (name === 'icon') throw new Error('iconUrl not set in Icon options (see the docs).');
                return null;
            }
            var img = this._createImg(src, oldIcon && oldIcon.tagName === 'IMG' ? oldIcon : null);
            this._setIconStyles(img, name);
            if (this.options.crossOrigin || this.options.crossOrigin === '') img.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            return img;
        },
        _setIconStyles: function(img, name) {
            var options = this.options;
            var sizeOption = options[name + 'Size'];
            if (typeof sizeOption === 'number') sizeOption = [
                sizeOption,
                sizeOption
            ];
            var size = toPoint(sizeOption), anchor = toPoint(name === 'shadow' && options.shadowAnchor || options.iconAnchor || size && size.divideBy(2, true));
            img.className = 'leaflet-marker-' + name + ' ' + (options.className || '');
            if (anchor) {
                img.style.marginLeft = -anchor.x + 'px';
                img.style.marginTop = -anchor.y + 'px';
            }
            if (size) {
                img.style.width = size.x + 'px';
                img.style.height = size.y + 'px';
            }
        },
        _createImg: function(src, el) {
            el = el || document.createElement('img');
            el.src = src;
            return el;
        },
        _getIconUrl: function(name) {
            return Browser.retina && this.options[name + 'RetinaUrl'] || this.options[name + 'Url'];
        }
    });
    // @factory L.icon(options: Icon options)
    // Creates an icon instance with the given options.
    function icon(options) {
        return new Icon(options);
    }
    /*
   * @miniclass Icon.Default (Icon)
   * @aka L.Icon.Default
   * @section
   *
   * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
   * no icon is specified. Points to the blue marker image distributed with Leaflet
   * releases.
   *
   * In order to customize the default icon, just change the properties of `L.Icon.Default.prototype.options`
   * (which is a set of `Icon options`).
   *
   * If you want to _completely_ replace the default icon, override the
   * `L.Marker.prototype.options.icon` with your own icon instead.
   */ var IconDefault = Icon.extend({
        options: {
            iconUrl: 'marker-icon.png',
            iconRetinaUrl: 'marker-icon-2x.png',
            shadowUrl: 'marker-shadow.png',
            iconSize: [
                25,
                41
            ],
            iconAnchor: [
                12,
                41
            ],
            popupAnchor: [
                1,
                -34
            ],
            tooltipAnchor: [
                16,
                -28
            ],
            shadowSize: [
                41,
                41
            ]
        },
        _getIconUrl: function(name) {
            if (typeof IconDefault.imagePath !== 'string') IconDefault.imagePath = this._detectIconPath();
            // @option imagePath: String
            // `Icon.Default` will try to auto-detect the location of the
            // blue icon images. If you are placing these images in a non-standard
            // way, set this option to point to the right path.
            return (this.options.imagePath || IconDefault.imagePath) + Icon.prototype._getIconUrl.call(this, name);
        },
        _stripUrl: function(path) {
            var strip = function(str, re, idx) {
                var match = re.exec(str);
                return match && match[idx];
            };
            path = strip(path, /^url\((['"])?(.+)\1\)$/, 2);
            return path && strip(path, /^(.*)marker-icon\.png$/, 1);
        },
        _detectIconPath: function() {
            var el = create$1('div', 'leaflet-default-icon-path', document.body);
            var path = getStyle(el, 'background-image') || getStyle(el, 'backgroundImage'); // IE8
            document.body.removeChild(el);
            path = this._stripUrl(path);
            if (path) return path;
            var link = document.querySelector('link[href$="leaflet.css"]');
            if (!link) return '';
            return link.href.substring(0, link.href.length - 11 - 1);
        }
    });
    /*
   * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
   */ /* @namespace Marker
   * @section Interaction handlers
   *
   * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
   *
   * ```js
   * marker.dragging.disable();
   * ```
   *
   * @property dragging: Handler
   * Marker dragging handler (by both mouse and touch). Only valid when the marker is on the map (Otherwise set [`marker.options.draggable`](#marker-draggable)).
   */ var MarkerDrag = Handler.extend({
        initialize: function(marker) {
            this._marker = marker;
        },
        addHooks: function() {
            var icon = this._marker._icon;
            if (!this._draggable) this._draggable = new Draggable(icon, icon, true);
            this._draggable.on({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).enable();
            addClass(icon, 'leaflet-marker-draggable');
        },
        removeHooks: function() {
            this._draggable.off({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).disable();
            if (this._marker._icon) removeClass(this._marker._icon, 'leaflet-marker-draggable');
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        _adjustPan: function(e) {
            var marker = this._marker, map = marker._map, speed = this._marker.options.autoPanSpeed, padding = this._marker.options.autoPanPadding, iconPos = getPosition(marker._icon), bounds = map.getPixelBounds(), origin = map.getPixelOrigin();
            var panBounds = toBounds(bounds.min._subtract(origin).add(padding), bounds.max._subtract(origin).subtract(padding));
            if (!panBounds.contains(iconPos)) {
                // Compute incremental movement
                var movement = toPoint((Math.max(panBounds.max.x, iconPos.x) - panBounds.max.x) / (bounds.max.x - panBounds.max.x) - (Math.min(panBounds.min.x, iconPos.x) - panBounds.min.x) / (bounds.min.x - panBounds.min.x), (Math.max(panBounds.max.y, iconPos.y) - panBounds.max.y) / (bounds.max.y - panBounds.max.y) - (Math.min(panBounds.min.y, iconPos.y) - panBounds.min.y) / (bounds.min.y - panBounds.min.y)).multiplyBy(speed);
                map.panBy(movement, {
                    animate: false
                });
                this._draggable._newPos._add(movement);
                this._draggable._startPos._add(movement);
                setPosition(marker._icon, this._draggable._newPos);
                this._onDrag(e);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDragStart: function() {
            // @section Dragging events
            // @event dragstart: Event
            // Fired when the user starts dragging the marker.
            // @event movestart: Event
            // Fired when the marker starts moving (because of dragging).
            this._oldLatLng = this._marker.getLatLng();
            // When using ES6 imports it could not be set when `Popup` was not imported as well
            this._marker.closePopup && this._marker.closePopup();
            this._marker.fire('movestart').fire('dragstart');
        },
        _onPreDrag: function(e) {
            if (this._marker.options.autoPan) {
                cancelAnimFrame(this._panRequest);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDrag: function(e) {
            var marker = this._marker, shadow = marker._shadow, iconPos = getPosition(marker._icon), latlng = marker._map.layerPointToLatLng(iconPos);
            // update shadow position
            if (shadow) setPosition(shadow, iconPos);
            marker._latlng = latlng;
            e.latlng = latlng;
            e.oldLatLng = this._oldLatLng;
            // @event drag: Event
            // Fired repeatedly while the user drags the marker.
            marker.fire('move', e).fire('drag', e);
        },
        _onDragEnd: function(e) {
            // @event dragend: DragEndEvent
            // Fired when the user stops dragging the marker.
            cancelAnimFrame(this._panRequest);
            // @event moveend: Event
            // Fired when the marker stops moving (because of dragging).
            delete this._oldLatLng;
            this._marker.fire('moveend').fire('dragend', e);
        }
    });
    /*
   * @class Marker
   * @inherits Interactive layer
   * @aka L.Marker
   * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.marker([50.5, 30.5]).addTo(map);
   * ```
   */ var Marker = Layer.extend({
        // @section
        // @aka Marker options
        options: {
            // @option icon: Icon = *
            // Icon instance to use for rendering the marker.
            // See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
            // If not specified, a common instance of `L.Icon.Default` is used.
            icon: new IconDefault(),
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option keyboard: Boolean = true
            // Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
            keyboard: true,
            // @option title: String = ''
            // Text for the browser tooltip that appear on marker hover (no tooltip by default).
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            title: '',
            // @option alt: String = 'Marker'
            // Text for the `alt` attribute of the icon image.
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            alt: 'Marker',
            // @option zIndexOffset: Number = 0
            // By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
            zIndexOffset: 0,
            // @option opacity: Number = 1.0
            // The opacity of the marker.
            opacity: 1,
            // @option riseOnHover: Boolean = false
            // If `true`, the marker will get on top of others when you hover the mouse over it.
            riseOnHover: false,
            // @option riseOffset: Number = 250
            // The z-index offset used for the `riseOnHover` feature.
            riseOffset: 250,
            // @option pane: String = 'markerPane'
            // `Map pane` where the markers icon will be added.
            pane: 'markerPane',
            // @option shadowPane: String = 'shadowPane'
            // `Map pane` where the markers shadow will be added.
            shadowPane: 'shadowPane',
            // @option bubblingMouseEvents: Boolean = false
            // When `true`, a mouse event on this marker will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: false,
            // @option autoPanOnFocus: Boolean = true
            // When `true`, the map will pan whenever the marker is focused (via
            // e.g. pressing `tab` on the keyboard) to ensure the marker is
            // visible within the map's bounds
            autoPanOnFocus: true,
            // @section Draggable marker options
            // @option draggable: Boolean = false
            // Whether the marker is draggable with mouse/touch or not.
            draggable: false,
            // @option autoPan: Boolean = false
            // Whether to pan the map when dragging this marker near its edge or not.
            autoPan: false,
            // @option autoPanPadding: Point = Point(50, 50)
            // Distance (in pixels to the left/right and to the top/bottom) of the
            // map edge to start panning the map.
            autoPanPadding: [
                50,
                50
            ],
            // @option autoPanSpeed: Number = 10
            // Number of pixels the map should pan by.
            autoPanSpeed: 10
        },
        /* @section
  	 *
  	 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
  	 */ initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
        },
        onAdd: function(map) {
            this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
            if (this._zoomAnimated) map.on('zoomanim', this._animateZoom, this);
            this._initIcon();
            this.update();
        },
        onRemove: function(map) {
            if (this.dragging && this.dragging.enabled()) {
                this.options.draggable = true;
                this.dragging.removeHooks();
            }
            delete this.dragging;
            if (this._zoomAnimated) map.off('zoomanim', this._animateZoom, this);
            this._removeIcon();
            this._removeShadow();
        },
        getEvents: function() {
            return {
                zoom: this.update,
                viewreset: this.update
            };
        },
        // @method getLatLng: LatLng
        // Returns the current geographical position of the marker.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Changes the marker position to the given point.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.update();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire('move', {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method setZIndexOffset(offset: Number): this
        // Changes the [zIndex offset](#marker-zindexoffset) of the marker.
        setZIndexOffset: function(offset) {
            this.options.zIndexOffset = offset;
            return this.update();
        },
        // @method getIcon: Icon
        // Returns the current icon used by the marker
        getIcon: function() {
            return this.options.icon;
        },
        // @method setIcon(icon: Icon): this
        // Changes the marker icon.
        setIcon: function(icon) {
            this.options.icon = icon;
            if (this._map) {
                this._initIcon();
                this.update();
            }
            if (this._popup) this.bindPopup(this._popup, this._popup.options);
            return this;
        },
        getElement: function() {
            return this._icon;
        },
        update: function() {
            if (this._icon && this._map) {
                var pos = this._map.latLngToLayerPoint(this._latlng).round();
                this._setPos(pos);
            }
            return this;
        },
        _initIcon: function() {
            var options = this.options, classToAdd = 'leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
            var icon = options.icon.createIcon(this._icon), addIcon = false;
            // if we're not reusing the icon, remove the old one and init new one
            if (icon !== this._icon) {
                if (this._icon) this._removeIcon();
                addIcon = true;
                if (options.title) icon.title = options.title;
                if (icon.tagName === 'IMG') icon.alt = options.alt || '';
            }
            addClass(icon, classToAdd);
            if (options.keyboard) {
                icon.tabIndex = '0';
                icon.setAttribute('role', 'button');
            }
            this._icon = icon;
            if (options.riseOnHover) this.on({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) on(icon, 'focus', this._panOnFocus, this);
            var newShadow = options.icon.createShadow(this._shadow), addShadow = false;
            if (newShadow !== this._shadow) {
                this._removeShadow();
                addShadow = true;
            }
            if (newShadow) {
                addClass(newShadow, classToAdd);
                newShadow.alt = '';
            }
            this._shadow = newShadow;
            if (options.opacity < 1) this._updateOpacity();
            if (addIcon) this.getPane().appendChild(this._icon);
            this._initInteraction();
            if (newShadow && addShadow) this.getPane(options.shadowPane).appendChild(this._shadow);
        },
        _removeIcon: function() {
            if (this.options.riseOnHover) this.off({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) off(this._icon, 'focus', this._panOnFocus, this);
            remove(this._icon);
            this.removeInteractiveTarget(this._icon);
            this._icon = null;
        },
        _removeShadow: function() {
            if (this._shadow) remove(this._shadow);
            this._shadow = null;
        },
        _setPos: function(pos) {
            if (this._icon) setPosition(this._icon, pos);
            if (this._shadow) setPosition(this._shadow, pos);
            this._zIndex = pos.y + this.options.zIndexOffset;
            this._resetZIndex();
        },
        _updateZIndex: function(offset) {
            if (this._icon) this._icon.style.zIndex = this._zIndex + offset;
        },
        _animateZoom: function(opt) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
            this._setPos(pos);
        },
        _initInteraction: function() {
            if (!this.options.interactive) return;
            addClass(this._icon, 'leaflet-interactive');
            this.addInteractiveTarget(this._icon);
            if (MarkerDrag) {
                var draggable = this.options.draggable;
                if (this.dragging) {
                    draggable = this.dragging.enabled();
                    this.dragging.disable();
                }
                this.dragging = new MarkerDrag(this);
                if (draggable) this.dragging.enable();
            }
        },
        // @method setOpacity(opacity: Number): this
        // Changes the opacity of the marker.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._map) this._updateOpacity();
            return this;
        },
        _updateOpacity: function() {
            var opacity = this.options.opacity;
            if (this._icon) setOpacity(this._icon, opacity);
            if (this._shadow) setOpacity(this._shadow, opacity);
        },
        _bringToFront: function() {
            this._updateZIndex(this.options.riseOffset);
        },
        _resetZIndex: function() {
            this._updateZIndex(0);
        },
        _panOnFocus: function() {
            var map = this._map;
            if (!map) return;
            var iconOpts = this.options.icon.options;
            var size = iconOpts.iconSize ? toPoint(iconOpts.iconSize) : toPoint(0, 0);
            var anchor = iconOpts.iconAnchor ? toPoint(iconOpts.iconAnchor) : toPoint(0, 0);
            map.panInside(this._latlng, {
                paddingTopLeft: anchor,
                paddingBottomRight: size.subtract(anchor)
            });
        },
        _getPopupAnchor: function() {
            return this.options.icon.options.popupAnchor;
        },
        _getTooltipAnchor: function() {
            return this.options.icon.options.tooltipAnchor;
        }
    });
    // factory L.marker(latlng: LatLng, options? : Marker options)
    // @factory L.marker(latlng: LatLng, options? : Marker options)
    // Instantiates a Marker object given a geographical point and optionally an options object.
    function marker(latlng, options) {
        return new Marker(latlng, options);
    }
    /*
   * @class Path
   * @aka L.Path
   * @inherits Interactive layer
   *
   * An abstract class that contains options and constants shared between vector
   * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
   */ var Path = Layer.extend({
        // @section
        // @aka Path options
        options: {
            // @option stroke: Boolean = true
            // Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
            stroke: true,
            // @option color: String = '#3388ff'
            // Stroke color
            color: '#3388ff',
            // @option weight: Number = 3
            // Stroke width in pixels
            weight: 3,
            // @option opacity: Number = 1.0
            // Stroke opacity
            opacity: 1,
            // @option lineCap: String= 'round'
            // A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
            lineCap: 'round',
            // @option lineJoin: String = 'round'
            // A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
            lineJoin: 'round',
            // @option dashArray: String = null
            // A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashArray: null,
            // @option dashOffset: String = null
            // A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashOffset: null,
            // @option fill: Boolean = depends
            // Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
            fill: false,
            // @option fillColor: String = *
            // Fill color. Defaults to the value of the [`color`](#path-color) option
            fillColor: null,
            // @option fillOpacity: Number = 0.2
            // Fill opacity.
            fillOpacity: 0.2,
            // @option fillRule: String = 'evenodd'
            // A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
            fillRule: 'evenodd',
            // className: '',
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option bubblingMouseEvents: Boolean = true
            // When `true`, a mouse event on this path will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: true
        },
        beforeAdd: function(map) {
            // Renderer is set here because we need to call renderer.getEvents
            // before this.getEvents.
            this._renderer = map.getRenderer(this);
        },
        onAdd: function() {
            this._renderer._initPath(this);
            this._reset();
            this._renderer._addPath(this);
        },
        onRemove: function() {
            this._renderer._removePath(this);
        },
        // @method redraw(): this
        // Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
        redraw: function() {
            if (this._map) this._renderer._updatePath(this);
            return this;
        },
        // @method setStyle(style: Path options): this
        // Changes the appearance of a Path based on the options in the `Path options` object.
        setStyle: function(style) {
            setOptions(this, style);
            if (this._renderer) {
                this._renderer._updateStyle(this);
                if (this.options.stroke && style && Object.prototype.hasOwnProperty.call(style, 'weight')) this._updateBounds();
            }
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all path layers.
        bringToFront: function() {
            if (this._renderer) this._renderer._bringToFront(this);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all path layers.
        bringToBack: function() {
            if (this._renderer) this._renderer._bringToBack(this);
            return this;
        },
        getElement: function() {
            return this._path;
        },
        _reset: function() {
            // defined in child classes
            this._project();
            this._update();
        },
        _clickTolerance: function() {
            // used when doing hit detection for Canvas layers
            return (this.options.stroke ? this.options.weight / 2 : 0) + (this._renderer.options.tolerance || 0);
        }
    });
    /*
   * @class CircleMarker
   * @aka L.CircleMarker
   * @inherits Path
   *
   * A circle of a fixed size with radius specified in pixels. Extends `Path`.
   */ var CircleMarker = Path.extend({
        // @section
        // @aka CircleMarker options
        options: {
            fill: true,
            // @option radius: Number = 10
            // Radius of the circle marker, in pixels
            radius: 10
        },
        initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            this._radius = this.options.radius;
        },
        // @method setLatLng(latLng: LatLng): this
        // Sets the position of a circle marker to a new location.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.redraw();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#circlemarker-setlatlng). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire('move', {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method getLatLng(): LatLng
        // Returns the current geographical position of the circle marker
        getLatLng: function() {
            return this._latlng;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle marker. Units are in pixels.
        setRadius: function(radius) {
            this.options.radius = this._radius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of the circle
        getRadius: function() {
            return this._radius;
        },
        setStyle: function(options) {
            var radius = options && options.radius || this._radius;
            Path.prototype.setStyle.call(this, options);
            this.setRadius(radius);
            return this;
        },
        _project: function() {
            this._point = this._map.latLngToLayerPoint(this._latlng);
            this._updateBounds();
        },
        _updateBounds: function() {
            var r = this._radius, r2 = this._radiusY || r, w = this._clickTolerance(), p = [
                r + w,
                r2 + w
            ];
            this._pxBounds = new Bounds(this._point.subtract(p), this._point.add(p));
        },
        _update: function() {
            if (this._map) this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updateCircle(this);
        },
        _empty: function() {
            return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
        }
    });
    // @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
    // Instantiates a circle marker object given a geographical point, and an optional options object.
    function circleMarker(latlng, options) {
        return new CircleMarker(latlng, options);
    }
    /*
   * @class Circle
   * @aka L.Circle
   * @inherits CircleMarker
   *
   * A class for drawing circle overlays on a map. Extends `CircleMarker`.
   *
   * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
   *
   * @example
   *
   * ```js
   * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
   * ```
   */ var Circle = CircleMarker.extend({
        initialize: function(latlng, options, legacyOptions) {
            if (typeof options === 'number') // Backwards compatibility with 0.7.x factory (latlng, radius, options?)
            options = extend({}, legacyOptions, {
                radius: options
            });
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            if (isNaN(this.options.radius)) throw new Error('Circle radius cannot be NaN');
            // @section
            // @aka Circle options
            // @option radius: Number; Radius of the circle, in meters.
            this._mRadius = this.options.radius;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle. Units are in meters.
        setRadius: function(radius) {
            this._mRadius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of a circle. Units are in meters.
        getRadius: function() {
            return this._mRadius;
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            var half = [
                this._radius,
                this._radiusY || this._radius
            ];
            return new LatLngBounds(this._map.layerPointToLatLng(this._point.subtract(half)), this._map.layerPointToLatLng(this._point.add(half)));
        },
        setStyle: Path.prototype.setStyle,
        _project: function() {
            var lng = this._latlng.lng, lat = this._latlng.lat, map = this._map, crs = map.options.crs;
            if (crs.distance === Earth.distance) {
                var d = Math.PI / 180, latR = this._mRadius / Earth.R / d, top = map.project([
                    lat + latR,
                    lng
                ]), bottom = map.project([
                    lat - latR,
                    lng
                ]), p = top.add(bottom).divideBy(2), lat2 = map.unproject(p).lat, lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) / (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
                if (isNaN(lngR) || lngR === 0) lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
                this._point = p.subtract(map.getPixelOrigin());
                this._radius = isNaN(lngR) ? 0 : p.x - map.project([
                    lat2,
                    lng - lngR
                ]).x;
                this._radiusY = p.y - top.y;
            } else {
                var latlng2 = crs.unproject(crs.project(this._latlng).subtract([
                    this._mRadius,
                    0
                ]));
                this._point = map.latLngToLayerPoint(this._latlng);
                this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
            }
            this._updateBounds();
        }
    });
    // @factory L.circle(latlng: LatLng, options?: Circle options)
    // Instantiates a circle object given a geographical point, and an options object
    // which contains the circle radius.
    // @alternative
    // @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
    // Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
    // Do not use in new applications or plugins.
    function circle(latlng, options, legacyOptions) {
        return new Circle(latlng, options, legacyOptions);
    }
    /*
   * @class Polyline
   * @aka L.Polyline
   * @inherits Path
   *
   * A class for drawing polyline overlays on a map. Extends `Path`.
   *
   * @example
   *
   * ```js
   * // create a red polyline from an array of LatLng points
   * var latlngs = [
   * 	[45.51, -122.68],
   * 	[37.77, -122.43],
   * 	[34.04, -118.2]
   * ];
   *
   * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polyline
   * map.fitBounds(polyline.getBounds());
   * ```
   *
   * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
   *
   * ```js
   * // create a red polyline from an array of arrays of LatLng points
   * var latlngs = [
   * 	[[45.51, -122.68],
   * 	 [37.77, -122.43],
   * 	 [34.04, -118.2]],
   * 	[[40.78, -73.91],
   * 	 [41.83, -87.62],
   * 	 [32.76, -96.72]]
   * ];
   * ```
   */ var Polyline = Path.extend({
        // @section
        // @aka Polyline options
        options: {
            // @option smoothFactor: Number = 1.0
            // How much to simplify the polyline on each zoom level. More means
            // better performance and smoother look, and less means more accurate representation.
            smoothFactor: 1.0,
            // @option noClip: Boolean = false
            // Disable polyline clipping.
            noClip: false
        },
        initialize: function(latlngs, options) {
            setOptions(this, options);
            this._setLatLngs(latlngs);
        },
        // @method getLatLngs(): LatLng[]
        // Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
        getLatLngs: function() {
            return this._latlngs;
        },
        // @method setLatLngs(latlngs: LatLng[]): this
        // Replaces all the points in the polyline with the given array of geographical points.
        setLatLngs: function(latlngs) {
            this._setLatLngs(latlngs);
            return this.redraw();
        },
        // @method isEmpty(): Boolean
        // Returns `true` if the Polyline has no LatLngs.
        isEmpty: function() {
            return !this._latlngs.length;
        },
        // @method closestLayerPoint(p: Point): Point
        // Returns the point closest to `p` on the Polyline.
        closestLayerPoint: function(p) {
            var minDistance = Infinity, minPoint = null, closest = _sqClosestPointOnSegment, p1, p2;
            for(var j = 0, jLen = this._parts.length; j < jLen; j++){
                var points = this._parts[j];
                for(var i = 1, len = points.length; i < len; i++){
                    p1 = points[i - 1];
                    p2 = points[i];
                    var sqDist = closest(p, p1, p2, true);
                    if (sqDist < minDistance) {
                        minDistance = sqDist;
                        minPoint = closest(p, p1, p2);
                    }
                }
            }
            if (minPoint) minPoint.distance = Math.sqrt(minDistance);
            return minPoint;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](https://en.wikipedia.org/wiki/Centroid)) of the polyline.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error('Must add layer to map before using getCenter()');
            return polylineCenter(this._defaultShape(), this._map.options.crs);
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            return this._bounds;
        },
        // @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
        // Adds a given point to the polyline. By default, adds to the first ring of
        // the polyline in case of a multi-polyline, but can be overridden by passing
        // a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
        addLatLng: function(latlng, latlngs) {
            latlngs = latlngs || this._defaultShape();
            latlng = toLatLng(latlng);
            latlngs.push(latlng);
            this._bounds.extend(latlng);
            return this.redraw();
        },
        _setLatLngs: function(latlngs) {
            this._bounds = new LatLngBounds();
            this._latlngs = this._convertLatLngs(latlngs);
        },
        _defaultShape: function() {
            return isFlat(this._latlngs) ? this._latlngs : this._latlngs[0];
        },
        // recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
        _convertLatLngs: function(latlngs) {
            var result = [], flat = isFlat(latlngs);
            for(var i = 0, len = latlngs.length; i < len; i++)if (flat) {
                result[i] = toLatLng(latlngs[i]);
                this._bounds.extend(result[i]);
            } else result[i] = this._convertLatLngs(latlngs[i]);
            return result;
        },
        _project: function() {
            var pxBounds = new Bounds();
            this._rings = [];
            this._projectLatlngs(this._latlngs, this._rings, pxBounds);
            if (this._bounds.isValid() && pxBounds.isValid()) {
                this._rawPxBounds = pxBounds;
                this._updateBounds();
            }
        },
        _updateBounds: function() {
            var w = this._clickTolerance(), p = new Point(w, w);
            if (!this._rawPxBounds) return;
            this._pxBounds = new Bounds([
                this._rawPxBounds.min.subtract(p),
                this._rawPxBounds.max.add(p)
            ]);
        },
        // recursively turns latlngs into a set of rings with projected coordinates
        _projectLatlngs: function(latlngs, result, projectedBounds) {
            var flat = latlngs[0] instanceof LatLng, len = latlngs.length, i, ring;
            if (flat) {
                ring = [];
                for(i = 0; i < len; i++){
                    ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
                    projectedBounds.extend(ring[i]);
                }
                result.push(ring);
            } else for(i = 0; i < len; i++)this._projectLatlngs(latlngs[i], result, projectedBounds);
        },
        // clip polyline by renderer bounds so that we have less to render for performance
        _clipPoints: function() {
            var bounds = this._renderer._bounds;
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            var parts = this._parts, i, j, k, len, len2, segment, points;
            for(i = 0, k = 0, len = this._rings.length; i < len; i++){
                points = this._rings[i];
                for(j = 0, len2 = points.length; j < len2 - 1; j++){
                    segment = clipSegment(points[j], points[j + 1], bounds, j, true);
                    if (!segment) continue;
                    parts[k] = parts[k] || [];
                    parts[k].push(segment[0]);
                    // if segment goes out of screen, or it's the last one, it's the end of the line part
                    if (segment[1] !== points[j + 1] || j === len2 - 2) {
                        parts[k].push(segment[1]);
                        k++;
                    }
                }
            }
        },
        // simplify each clipped part of the polyline for performance
        _simplifyPoints: function() {
            var parts = this._parts, tolerance = this.options.smoothFactor;
            for(var i = 0, len = parts.length; i < len; i++)parts[i] = simplify(parts[i], tolerance);
        },
        _update: function() {
            if (!this._map) return;
            this._clipPoints();
            this._simplifyPoints();
            this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updatePoly(this);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p, closed) {
            var i, j, k, len, len2, part, w = this._clickTolerance();
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // hit detection for polylines
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    if (!closed && j === 0) continue;
                    if (pointToSegmentDistance(p, part[k], part[j]) <= w) return true;
                }
            }
            return false;
        }
    });
    // @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
    // Instantiates a polyline object given an array of geographical points and
    // optionally an options object. You can create a `Polyline` object with
    // multiple separate lines (`MultiPolyline`) by passing an array of arrays
    // of geographic points.
    function polyline(latlngs, options) {
        return new Polyline(latlngs, options);
    }
    // Retrocompat. Allow plugins to support Leaflet versions before and after 1.1.
    Polyline._flat = _flat;
    /*
   * @class Polygon
   * @aka L.Polygon
   * @inherits Polyline
   *
   * A class for drawing polygon overlays on a map. Extends `Polyline`.
   *
   * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
   *
   *
   * @example
   *
   * ```js
   * // create a red polygon from an array of LatLng points
   * var latlngs = [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]];
   *
   * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polygon
   * map.fitBounds(polygon.getBounds());
   * ```
   *
   * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
   *
   * ```js
   * var latlngs = [
   *   [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *   [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   * ];
   * ```
   *
   * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
   *
   * ```js
   * var latlngs = [
   *   [ // first polygon
   *     [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *     [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   *   ],
   *   [ // second polygon
   *     [[41, -111.03],[45, -111.04],[45, -104.05],[41, -104.05]]
   *   ]
   * ];
   * ```
   */ var Polygon = Polyline.extend({
        options: {
            fill: true
        },
        isEmpty: function() {
            return !this._latlngs.length || !this._latlngs[0].length;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the Polygon.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error('Must add layer to map before using getCenter()');
            return polygonCenter(this._defaultShape(), this._map.options.crs);
        },
        _convertLatLngs: function(latlngs) {
            var result = Polyline.prototype._convertLatLngs.call(this, latlngs), len = result.length;
            // remove last point if it equals first one
            if (len >= 2 && result[0] instanceof LatLng && result[0].equals(result[len - 1])) result.pop();
            return result;
        },
        _setLatLngs: function(latlngs) {
            Polyline.prototype._setLatLngs.call(this, latlngs);
            if (isFlat(this._latlngs)) this._latlngs = [
                this._latlngs
            ];
        },
        _defaultShape: function() {
            return isFlat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
        },
        _clipPoints: function() {
            // polygons need a different clipping algorithm so we redefine that
            var bounds = this._renderer._bounds, w = this.options.weight, p = new Point(w, w);
            // increase clip padding by stroke width to avoid stroke on clip edges
            bounds = new Bounds(bounds.min.subtract(p), bounds.max.add(p));
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            for(var i = 0, len = this._rings.length, clipped; i < len; i++){
                clipped = clipPolygon(this._rings[i], bounds, true);
                if (clipped.length) this._parts.push(clipped);
            }
        },
        _updatePath: function() {
            this._renderer._updatePoly(this, true);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            var inside = false, part, p1, p2, i, j, k, len, len2;
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // ray casting algorithm for detecting if point is in polygon
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    p1 = part[j];
                    p2 = part[k];
                    if (p1.y > p.y !== p2.y > p.y && p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x) inside = !inside;
                }
            }
            // also check if it's on polygon stroke
            return inside || Polyline.prototype._containsPoint.call(this, p, true);
        }
    });
    // @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
    function polygon(latlngs, options) {
        return new Polygon(latlngs, options);
    }
    /*
   * @class GeoJSON
   * @aka L.GeoJSON
   * @inherits FeatureGroup
   *
   * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
   * GeoJSON data and display it on the map. Extends `FeatureGroup`.
   *
   * @example
   *
   * ```js
   * L.geoJSON(data, {
   * 	style: function (feature) {
   * 		return {color: feature.properties.color};
   * 	}
   * }).bindPopup(function (layer) {
   * 	return layer.feature.properties.description;
   * }).addTo(map);
   * ```
   */ var GeoJSON = FeatureGroup.extend({
        /* @section
  	 * @aka GeoJSON options
  	 *
  	 * @option pointToLayer: Function = *
  	 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
  	 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
  	 * The default is to spawn a default `Marker`:
  	 * ```js
  	 * function(geoJsonPoint, latlng) {
  	 * 	return L.marker(latlng);
  	 * }
  	 * ```
  	 *
  	 * @option style: Function = *
  	 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
  	 * called internally when data is added.
  	 * The default value is to not override any defaults:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return {}
  	 * }
  	 * ```
  	 *
  	 * @option onEachFeature: Function = *
  	 * A `Function` that will be called once for each created `Feature`, after it has
  	 * been created and styled. Useful for attaching events and popups to features.
  	 * The default is to do nothing with the newly created layers:
  	 * ```js
  	 * function (feature, layer) {}
  	 * ```
  	 *
  	 * @option filter: Function = *
  	 * A `Function` that will be used to decide whether to include a feature or not.
  	 * The default is to include all features:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return true;
  	 * }
  	 * ```
  	 * Note: dynamically changing the `filter` option will have effect only on newly
  	 * added data. It will _not_ re-evaluate already included features.
  	 *
  	 * @option coordsToLatLng: Function = *
  	 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
  	 * The default is the `coordsToLatLng` static method.
  	 *
  	 * @option markersInheritOptions: Boolean = false
  	 * Whether default Markers for "Point" type Features inherit from group options.
  	 */ initialize: function(geojson, options) {
            setOptions(this, options);
            this._layers = {};
            if (geojson) this.addData(geojson);
        },
        // @method addData( <GeoJSON> data ): this
        // Adds a GeoJSON object to the layer.
        addData: function(geojson) {
            var features = isArray(geojson) ? geojson : geojson.features, i, len, feature;
            if (features) {
                for(i = 0, len = features.length; i < len; i++){
                    // only add this if geometry or geometries are set and not null
                    feature = features[i];
                    if (feature.geometries || feature.geometry || feature.features || feature.coordinates) this.addData(feature);
                }
                return this;
            }
            var options = this.options;
            if (options.filter && !options.filter(geojson)) return this;
            var layer = geometryToLayer(geojson, options);
            if (!layer) return this;
            layer.feature = asFeature(geojson);
            layer.defaultOptions = layer.options;
            this.resetStyle(layer);
            if (options.onEachFeature) options.onEachFeature(geojson, layer);
            return this.addLayer(layer);
        },
        // @method resetStyle( <Path> layer? ): this
        // Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
        // If `layer` is omitted, the style of all features in the current layer is reset.
        resetStyle: function(layer) {
            if (layer === undefined) return this.eachLayer(this.resetStyle, this);
            // reset any custom styles
            layer.options = extend({}, layer.defaultOptions);
            this._setLayerStyle(layer, this.options.style);
            return this;
        },
        // @method setStyle( <Function> style ): this
        // Changes styles of GeoJSON vector layers with the given style function.
        setStyle: function(style) {
            return this.eachLayer(function(layer) {
                this._setLayerStyle(layer, style);
            }, this);
        },
        _setLayerStyle: function(layer, style) {
            if (layer.setStyle) {
                if (typeof style === 'function') style = style(layer.feature);
                layer.setStyle(style);
            }
        }
    });
    // @section
    // There are several static functions which can be called without instantiating L.GeoJSON:
    // @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
    // Creates a `Layer` from a given GeoJSON feature. Can use a custom
    // [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
    // functions if provided as options.
    function geometryToLayer(geojson, options) {
        var geometry = geojson.type === 'Feature' ? geojson.geometry : geojson, coords = geometry ? geometry.coordinates : null, layers = [], pointToLayer = options && options.pointToLayer, _coordsToLatLng = options && options.coordsToLatLng || coordsToLatLng, latlng, latlngs, i, len;
        if (!coords && !geometry) return null;
        switch(geometry.type){
            case 'Point':
                latlng = _coordsToLatLng(coords);
                return _pointToLayer(pointToLayer, geojson, latlng, options);
            case 'MultiPoint':
                for(i = 0, len = coords.length; i < len; i++){
                    latlng = _coordsToLatLng(coords[i]);
                    layers.push(_pointToLayer(pointToLayer, geojson, latlng, options));
                }
                return new FeatureGroup(layers);
            case 'LineString':
            case 'MultiLineString':
                latlngs = coordsToLatLngs(coords, geometry.type === 'LineString' ? 0 : 1, _coordsToLatLng);
                return new Polyline(latlngs, options);
            case 'Polygon':
            case 'MultiPolygon':
                latlngs = coordsToLatLngs(coords, geometry.type === 'Polygon' ? 1 : 2, _coordsToLatLng);
                return new Polygon(latlngs, options);
            case 'GeometryCollection':
                for(i = 0, len = geometry.geometries.length; i < len; i++){
                    var geoLayer = geometryToLayer({
                        geometry: geometry.geometries[i],
                        type: 'Feature',
                        properties: geojson.properties
                    }, options);
                    if (geoLayer) layers.push(geoLayer);
                }
                return new FeatureGroup(layers);
            case 'FeatureCollection':
                for(i = 0, len = geometry.features.length; i < len; i++){
                    var featureLayer = geometryToLayer(geometry.features[i], options);
                    if (featureLayer) layers.push(featureLayer);
                }
                return new FeatureGroup(layers);
            default:
                throw new Error('Invalid GeoJSON object.');
        }
    }
    function _pointToLayer(pointToLayerFn, geojson, latlng, options) {
        return pointToLayerFn ? pointToLayerFn(geojson, latlng) : new Marker(latlng, options && options.markersInheritOptions && options);
    }
    // @function coordsToLatLng(coords: Array): LatLng
    // Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
    // or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
    function coordsToLatLng(coords) {
        return new LatLng(coords[1], coords[0], coords[2]);
    }
    // @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
    // Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
    // `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
    // Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
    function coordsToLatLngs(coords, levelsDeep, _coordsToLatLng) {
        var latlngs = [];
        for(var i = 0, len = coords.length, latlng; i < len; i++){
            latlng = levelsDeep ? coordsToLatLngs(coords[i], levelsDeep - 1, _coordsToLatLng) : (_coordsToLatLng || coordsToLatLng)(coords[i]);
            latlngs.push(latlng);
        }
        return latlngs;
    }
    // @function latLngToCoords(latlng: LatLng, precision?: Number|false): Array
    // Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngToCoords(latlng, precision) {
        latlng = toLatLng(latlng);
        return latlng.alt !== undefined ? [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision),
            formatNum(latlng.alt, precision)
        ] : [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision)
        ];
    }
    // @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean, precision?: Number|false): Array
    // Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
    // `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngsToCoords(latlngs, levelsDeep, closed, precision) {
        var coords = [];
        for(var i = 0, len = latlngs.length; i < len; i++)// Check for flat arrays required to ensure unbalanced arrays are correctly converted in recursion
        coords.push(levelsDeep ? latLngsToCoords(latlngs[i], isFlat(latlngs[i]) ? 0 : levelsDeep - 1, closed, precision) : latLngToCoords(latlngs[i], precision));
        if (!levelsDeep && closed && coords.length > 0) coords.push(coords[0].slice());
        return coords;
    }
    function getFeature(layer, newGeometry) {
        return layer.feature ? extend({}, layer.feature, {
            geometry: newGeometry
        }) : asFeature(newGeometry);
    }
    // @function asFeature(geojson: Object): Object
    // Normalize GeoJSON geometries/features into GeoJSON features.
    function asFeature(geojson) {
        if (geojson.type === 'Feature' || geojson.type === 'FeatureCollection') return geojson;
        return {
            type: 'Feature',
            properties: {},
            geometry: geojson
        };
    }
    var PointToGeoJSON = {
        toGeoJSON: function(precision) {
            return getFeature(this, {
                type: 'Point',
                coordinates: latLngToCoords(this.getLatLng(), precision)
            });
        }
    };
    // @namespace Marker
    // @section Other methods
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
    Marker.include(PointToGeoJSON);
    // @namespace CircleMarker
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
    Circle.include(PointToGeoJSON);
    CircleMarker.include(PointToGeoJSON);
    // @namespace Polyline
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
    Polyline.include({
        toGeoJSON: function(precision) {
            var multi = !isFlat(this._latlngs);
            var coords = latLngsToCoords(this._latlngs, multi ? 1 : 0, false, precision);
            return getFeature(this, {
                type: (multi ? 'Multi' : '') + 'LineString',
                coordinates: coords
            });
        }
    });
    // @namespace Polygon
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
    Polygon.include({
        toGeoJSON: function(precision) {
            var holes = !isFlat(this._latlngs), multi = holes && !isFlat(this._latlngs[0]);
            var coords = latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);
            if (!holes) coords = [
                coords
            ];
            return getFeature(this, {
                type: (multi ? 'Multi' : '') + 'Polygon',
                coordinates: coords
            });
        }
    });
    // @namespace LayerGroup
    LayerGroup.include({
        toMultiPoint: function(precision) {
            var coords = [];
            this.eachLayer(function(layer) {
                coords.push(layer.toGeoJSON(precision).geometry.coordinates);
            });
            return getFeature(this, {
                type: 'MultiPoint',
                coordinates: coords
            });
        },
        // @method toGeoJSON(precision?: Number|false): Object
        // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
        // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
        toGeoJSON: function(precision) {
            var type = this.feature && this.feature.geometry && this.feature.geometry.type;
            if (type === 'MultiPoint') return this.toMultiPoint(precision);
            var isGeometryCollection = type === 'GeometryCollection', jsons = [];
            this.eachLayer(function(layer) {
                if (layer.toGeoJSON) {
                    var json = layer.toGeoJSON(precision);
                    if (isGeometryCollection) jsons.push(json.geometry);
                    else {
                        var feature = asFeature(json);
                        // Squash nested feature collections
                        if (feature.type === 'FeatureCollection') jsons.push.apply(jsons, feature.features);
                        else jsons.push(feature);
                    }
                }
            });
            if (isGeometryCollection) return getFeature(this, {
                geometries: jsons,
                type: 'GeometryCollection'
            });
            return {
                type: 'FeatureCollection',
                features: jsons
            };
        }
    });
    // @namespace GeoJSON
    // @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
    // Creates a GeoJSON layer. Optionally accepts an object in
    // [GeoJSON format](https://tools.ietf.org/html/rfc7946) to display on the map
    // (you can alternatively add it later with `addData` method) and an `options` object.
    function geoJSON(geojson, options) {
        return new GeoJSON(geojson, options);
    }
    // Backward compatibility.
    var geoJson = geoJSON;
    /*
   * @class ImageOverlay
   * @aka L.ImageOverlay
   * @inherits Interactive layer
   *
   * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * var imageUrl = 'https://maps.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
   * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
   * L.imageOverlay(imageUrl, imageBounds).addTo(map);
   * ```
   */ var ImageOverlay = Layer.extend({
        // @section
        // @aka ImageOverlay options
        options: {
            // @option opacity: Number = 1.0
            // The opacity of the image overlay.
            opacity: 1,
            // @option alt: String = ''
            // Text for the `alt` attribute of the image (useful for accessibility).
            alt: '',
            // @option interactive: Boolean = false
            // If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
            interactive: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the image.
            // If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option errorOverlayUrl: String = ''
            // URL to the overlay image to show in place of the overlay that failed to load.
            errorOverlayUrl: '',
            // @option zIndex: Number = 1
            // The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
            zIndex: 1,
            // @option className: String = ''
            // A custom class name to assign to the image. Empty by default.
            className: ''
        },
        initialize: function(url, bounds, options) {
            this._url = url;
            this._bounds = toLatLngBounds(bounds);
            setOptions(this, options);
        },
        onAdd: function() {
            if (!this._image) {
                this._initImage();
                if (this.options.opacity < 1) this._updateOpacity();
            }
            if (this.options.interactive) {
                addClass(this._image, 'leaflet-interactive');
                this.addInteractiveTarget(this._image);
            }
            this.getPane().appendChild(this._image);
            this._reset();
        },
        onRemove: function() {
            remove(this._image);
            if (this.options.interactive) this.removeInteractiveTarget(this._image);
        },
        // @method setOpacity(opacity: Number): this
        // Sets the opacity of the overlay.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._image) this._updateOpacity();
            return this;
        },
        setStyle: function(styleOpts) {
            if (styleOpts.opacity) this.setOpacity(styleOpts.opacity);
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all overlays.
        bringToFront: function() {
            if (this._map) toFront(this._image);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all overlays.
        bringToBack: function() {
            if (this._map) toBack(this._image);
            return this;
        },
        // @method setUrl(url: String): this
        // Changes the URL of the image.
        setUrl: function(url) {
            this._url = url;
            if (this._image) this._image.src = url;
            return this;
        },
        // @method setBounds(bounds: LatLngBounds): this
        // Update the bounds that this ImageOverlay covers
        setBounds: function(bounds) {
            this._bounds = toLatLngBounds(bounds);
            if (this._map) this._reset();
            return this;
        },
        getEvents: function() {
            var events = {
                zoom: this._reset,
                viewreset: this._reset
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method setZIndex(value: Number): this
        // Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
        setZIndex: function(value) {
            this.options.zIndex = value;
            this._updateZIndex();
            return this;
        },
        // @method getBounds(): LatLngBounds
        // Get the bounds that this ImageOverlay covers
        getBounds: function() {
            return this._bounds;
        },
        // @method getElement(): HTMLElement
        // Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
        // used by this overlay.
        getElement: function() {
            return this._image;
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === 'IMG';
            var img = this._image = wasElementSupplied ? this._url : create$1('img');
            addClass(img, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(img, 'leaflet-zoom-animated');
            if (this.options.className) addClass(img, this.options.className);
            img.onselectstart = falseFn;
            img.onmousemove = falseFn;
            // @event load: Event
            // Fired when the ImageOverlay layer has loaded its image
            img.onload = bind(this.fire, this, 'load');
            img.onerror = bind(this._overlayOnError, this, 'error');
            if (this.options.crossOrigin || this.options.crossOrigin === '') img.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            if (this.options.zIndex) this._updateZIndex();
            if (wasElementSupplied) {
                this._url = img.src;
                return;
            }
            img.src = this._url;
            img.alt = this.options.alt;
        },
        _animateZoom: function(e) {
            var scale = this._map.getZoomScale(e.zoom), offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
            setTransform(this._image, offset, scale);
        },
        _reset: function() {
            var image = this._image, bounds = new Bounds(this._map.latLngToLayerPoint(this._bounds.getNorthWest()), this._map.latLngToLayerPoint(this._bounds.getSouthEast())), size = bounds.getSize();
            setPosition(image, bounds.min);
            image.style.width = size.x + 'px';
            image.style.height = size.y + 'px';
        },
        _updateOpacity: function() {
            setOpacity(this._image, this.options.opacity);
        },
        _updateZIndex: function() {
            if (this._image && this.options.zIndex !== undefined && this.options.zIndex !== null) this._image.style.zIndex = this.options.zIndex;
        },
        _overlayOnError: function() {
            // @event error: Event
            // Fired when the ImageOverlay layer fails to load its image
            this.fire('error');
            var errorUrl = this.options.errorOverlayUrl;
            if (errorUrl && this._url !== errorUrl) {
                this._url = errorUrl;
                this._image.src = errorUrl;
            }
        },
        // @method getCenter(): LatLng
        // Returns the center of the ImageOverlay.
        getCenter: function() {
            return this._bounds.getCenter();
        }
    });
    // @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
    // Instantiates an image overlay object given the URL of the image and the
    // geographical bounds it is tied to.
    var imageOverlay = function(url, bounds, options) {
        return new ImageOverlay(url, bounds, options);
    };
    /*
   * @class VideoOverlay
   * @aka L.VideoOverlay
   * @inherits ImageOverlay
   *
   * Used to load and display a video player over specific bounds of the map. Extends `ImageOverlay`.
   *
   * A video overlay uses the [`<video>`](https://developer.mozilla.org/docs/Web/HTML/Element/video)
   * HTML5 element.
   *
   * @example
   *
   * ```js
   * var videoUrl = 'https://www.mapbox.com/bites/00188/patricia_nasa.webm',
   * 	videoBounds = [[ 32, -130], [ 13, -100]];
   * L.videoOverlay(videoUrl, videoBounds ).addTo(map);
   * ```
   */ var VideoOverlay = ImageOverlay.extend({
        // @section
        // @aka VideoOverlay options
        options: {
            // @option autoplay: Boolean = true
            // Whether the video starts playing automatically when loaded.
            // On some browsers autoplay will only work with `muted: true`
            autoplay: true,
            // @option loop: Boolean = true
            // Whether the video will loop back to the beginning when played.
            loop: true,
            // @option keepAspectRatio: Boolean = true
            // Whether the video will save aspect ratio after the projection.
            // Relevant for supported browsers. See [browser compatibility](https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit)
            keepAspectRatio: true,
            // @option muted: Boolean = false
            // Whether the video starts on mute when loaded.
            muted: false,
            // @option playsInline: Boolean = true
            // Mobile browsers will play the video right where it is instead of open it up in fullscreen mode.
            playsInline: true
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === 'VIDEO';
            var vid = this._image = wasElementSupplied ? this._url : create$1('video');
            addClass(vid, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(vid, 'leaflet-zoom-animated');
            if (this.options.className) addClass(vid, this.options.className);
            vid.onselectstart = falseFn;
            vid.onmousemove = falseFn;
            // @event load: Event
            // Fired when the video has finished loading the first frame
            vid.onloadeddata = bind(this.fire, this, 'load');
            if (wasElementSupplied) {
                var sourceElements = vid.getElementsByTagName('source');
                var sources = [];
                for(var j = 0; j < sourceElements.length; j++)sources.push(sourceElements[j].src);
                this._url = sourceElements.length > 0 ? sources : [
                    vid.src
                ];
                return;
            }
            if (!isArray(this._url)) this._url = [
                this._url
            ];
            if (!this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(vid.style, 'objectFit')) vid.style['objectFit'] = 'fill';
            vid.autoplay = !!this.options.autoplay;
            vid.loop = !!this.options.loop;
            vid.muted = !!this.options.muted;
            vid.playsInline = !!this.options.playsInline;
            for(var i = 0; i < this._url.length; i++){
                var source = create$1('source');
                source.src = this._url[i];
                vid.appendChild(source);
            }
        }
    });
    // @factory L.videoOverlay(video: String|Array|HTMLVideoElement, bounds: LatLngBounds, options?: VideoOverlay options)
    // Instantiates an image overlay object given the URL of the video (or array of URLs, or even a video element) and the
    // geographical bounds it is tied to.
    function videoOverlay(video, bounds, options) {
        return new VideoOverlay(video, bounds, options);
    }
    /*
   * @class SVGOverlay
   * @aka L.SVGOverlay
   * @inherits ImageOverlay
   *
   * Used to load, display and provide DOM access to an SVG file over specific bounds of the map. Extends `ImageOverlay`.
   *
   * An SVG overlay uses the [`<svg>`](https://developer.mozilla.org/docs/Web/SVG/Element/svg) element.
   *
   * @example
   *
   * ```js
   * var svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
   * svgElement.setAttribute('xmlns', "http://www.w3.org/2000/svg");
   * svgElement.setAttribute('viewBox', "0 0 200 200");
   * svgElement.innerHTML = '<rect width="200" height="200"/><rect x="75" y="23" width="50" height="50" style="fill:red"/><rect x="75" y="123" width="50" height="50" style="fill:#0013ff"/>';
   * var svgElementBounds = [ [ 32, -130 ], [ 13, -100 ] ];
   * L.svgOverlay(svgElement, svgElementBounds).addTo(map);
   * ```
   */ var SVGOverlay = ImageOverlay.extend({
        _initImage: function() {
            var el = this._image = this._url;
            addClass(el, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(el, 'leaflet-zoom-animated');
            if (this.options.className) addClass(el, this.options.className);
            el.onselectstart = falseFn;
            el.onmousemove = falseFn;
        }
    });
    // @factory L.svgOverlay(svg: String|SVGElement, bounds: LatLngBounds, options?: SVGOverlay options)
    // Instantiates an image overlay object given an SVG element and the geographical bounds it is tied to.
    // A viewBox attribute is required on the SVG element to zoom in and out properly.
    function svgOverlay(el, bounds, options) {
        return new SVGOverlay(el, bounds, options);
    }
    /*
   * @class DivOverlay
   * @inherits Interactive layer
   * @aka L.DivOverlay
   * Base model for L.Popup and L.Tooltip. Inherit from it for custom overlays like plugins.
   */ // @namespace DivOverlay
    var DivOverlay = Layer.extend({
        // @section
        // @aka DivOverlay options
        options: {
            // @option interactive: Boolean = false
            // If true, the popup/tooltip will listen to the mouse events.
            interactive: false,
            // @option offset: Point = Point(0, 0)
            // The offset of the overlay position.
            offset: [
                0,
                0
            ],
            // @option className: String = ''
            // A custom CSS class name to assign to the overlay.
            className: '',
            // @option pane: String = undefined
            // `Map pane` where the overlay will be added.
            pane: undefined,
            // @option content: String|HTMLElement|Function = ''
            // Sets the HTML content of the overlay while initializing. If a function is passed the source layer will be
            // passed to the function. The function should return a `String` or `HTMLElement` to be used in the overlay.
            content: ''
        },
        initialize: function(options, source) {
            if (options && (options instanceof LatLng || isArray(options))) {
                this._latlng = toLatLng(options);
                setOptions(this, source);
            } else {
                setOptions(this, options);
                this._source = source;
            }
            if (this.options.content) this._content = this.options.content;
        },
        // @method openOn(map: Map): this
        // Adds the overlay to the map.
        // Alternative to `map.openPopup(popup)`/`.openTooltip(tooltip)`.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this)) map.addLayer(this);
            return this;
        },
        // @method close(): this
        // Closes the overlay.
        // Alternative to `map.closePopup(popup)`/`.closeTooltip(tooltip)`
        // and `layer.closePopup()`/`.closeTooltip()`.
        close: function() {
            if (this._map) this._map.removeLayer(this);
            return this;
        },
        // @method toggle(layer?: Layer): this
        // Opens or closes the overlay bound to layer depending on its current state.
        // Argument may be omitted only for overlay bound to layer.
        // Alternative to `layer.togglePopup()`/`.toggleTooltip()`.
        toggle: function(layer) {
            if (this._map) this.close();
            else {
                if (arguments.length) this._source = layer;
                else layer = this._source;
                this._prepareOpen();
                // open the overlay on the map
                this.openOn(layer._map);
            }
            return this;
        },
        onAdd: function(map) {
            this._zoomAnimated = map._zoomAnimated;
            if (!this._container) this._initLayout();
            if (map._fadeAnimated) setOpacity(this._container, 0);
            clearTimeout(this._removeTimeout);
            this.getPane().appendChild(this._container);
            this.update();
            if (map._fadeAnimated) setOpacity(this._container, 1);
            this.bringToFront();
            if (this.options.interactive) {
                addClass(this._container, 'leaflet-interactive');
                this.addInteractiveTarget(this._container);
            }
        },
        onRemove: function(map) {
            if (map._fadeAnimated) {
                setOpacity(this._container, 0);
                this._removeTimeout = setTimeout(bind(remove, undefined, this._container), 200);
            } else remove(this._container);
            if (this.options.interactive) {
                removeClass(this._container, 'leaflet-interactive');
                this.removeInteractiveTarget(this._container);
            }
        },
        // @namespace DivOverlay
        // @method getLatLng: LatLng
        // Returns the geographical point of the overlay.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Sets the geographical point where the overlay will open.
        setLatLng: function(latlng) {
            this._latlng = toLatLng(latlng);
            if (this._map) {
                this._updatePosition();
                this._adjustPan();
            }
            return this;
        },
        // @method getContent: String|HTMLElement
        // Returns the content of the overlay.
        getContent: function() {
            return this._content;
        },
        // @method setContent(htmlContent: String|HTMLElement|Function): this
        // Sets the HTML content of the overlay. If a function is passed the source layer will be passed to the function.
        // The function should return a `String` or `HTMLElement` to be used in the overlay.
        setContent: function(content) {
            this._content = content;
            this.update();
            return this;
        },
        // @method getElement: String|HTMLElement
        // Returns the HTML container of the overlay.
        getElement: function() {
            return this._container;
        },
        // @method update: null
        // Updates the overlay content, layout and position. Useful for updating the overlay after something inside changed, e.g. image loaded.
        update: function() {
            if (!this._map) return;
            this._container.style.visibility = 'hidden';
            this._updateContent();
            this._updateLayout();
            this._updatePosition();
            this._container.style.visibility = '';
            this._adjustPan();
        },
        getEvents: function() {
            var events = {
                zoom: this._updatePosition,
                viewreset: this._updatePosition
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method isOpen: Boolean
        // Returns `true` when the overlay is visible on the map.
        isOpen: function() {
            return !!this._map && this._map.hasLayer(this);
        },
        // @method bringToFront: this
        // Brings this overlay in front of other overlays (in the same map pane).
        bringToFront: function() {
            if (this._map) toFront(this._container);
            return this;
        },
        // @method bringToBack: this
        // Brings this overlay to the back of other overlays (in the same map pane).
        bringToBack: function() {
            if (this._map) toBack(this._container);
            return this;
        },
        // prepare bound overlay to open: update latlng pos / content source (for FeatureGroup)
        _prepareOpen: function(latlng) {
            var source = this._source;
            if (!source._map) return false;
            if (source instanceof FeatureGroup) {
                source = null;
                var layers = this._source._layers;
                for(var id in layers)if (layers[id]._map) {
                    source = layers[id];
                    break;
                }
                if (!source) return false;
                 // Unable to get source layer.
                // set overlay source to this layer
                this._source = source;
            }
            if (!latlng) {
                if (source.getCenter) latlng = source.getCenter();
                else if (source.getLatLng) latlng = source.getLatLng();
                else if (source.getBounds) latlng = source.getBounds().getCenter();
                else throw new Error('Unable to get source layer LatLng.');
            }
            this.setLatLng(latlng);
            if (this._map) // update the overlay (content, layout, etc...)
            this.update();
            return true;
        },
        _updateContent: function() {
            if (!this._content) return;
            var node = this._contentNode;
            var content = typeof this._content === 'function' ? this._content(this._source || this) : this._content;
            if (typeof content === 'string') node.innerHTML = content;
            else {
                while(node.hasChildNodes())node.removeChild(node.firstChild);
                node.appendChild(content);
            }
            // @namespace DivOverlay
            // @section DivOverlay events
            // @event contentupdate: Event
            // Fired when the content of the overlay is updated
            this.fire('contentupdate');
        },
        _updatePosition: function() {
            if (!this._map) return;
            var pos = this._map.latLngToLayerPoint(this._latlng), offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (this._zoomAnimated) setPosition(this._container, pos.add(anchor));
            else offset = offset.add(pos).add(anchor);
            var bottom = this._containerBottom = -offset.y, left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;
            // bottom position the overlay in case the height of the overlay changes (images loading etc)
            this._container.style.bottom = bottom + 'px';
            this._container.style.left = left + 'px';
        },
        _getAnchor: function() {
            return [
                0,
                0
            ];
        }
    });
    Map.include({
        _initOverlay: function(OverlayClass, content, latlng, options) {
            var overlay = content;
            if (!(overlay instanceof OverlayClass)) overlay = new OverlayClass(options).setContent(content);
            if (latlng) overlay.setLatLng(latlng);
            return overlay;
        }
    });
    Layer.include({
        _initOverlay: function(OverlayClass, old, content, options) {
            var overlay = content;
            if (overlay instanceof OverlayClass) {
                setOptions(overlay, options);
                overlay._source = this;
            } else {
                overlay = old && !options ? old : new OverlayClass(options, this);
                overlay.setContent(content);
            }
            return overlay;
        }
    });
    /*
   * @class Popup
   * @inherits DivOverlay
   * @aka L.Popup
   * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
   * open popups while making sure that only one popup is open at one time
   * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
   *
   * @example
   *
   * If you want to just bind a popup to marker click and then open it, it's really easy:
   *
   * ```js
   * marker.bindPopup(popupContent).openPopup();
   * ```
   * Path overlays like polylines also have a `bindPopup` method.
   *
   * A popup can be also standalone:
   *
   * ```js
   * var popup = L.popup()
   * 	.setLatLng(latlng)
   * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   * or
   * ```js
   * var popup = L.popup(latlng, {content: '<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   */ // @namespace Popup
    var Popup = DivOverlay.extend({
        // @section
        // @aka Popup options
        options: {
            // @option pane: String = 'popupPane'
            // `Map pane` where the popup will be added.
            pane: 'popupPane',
            // @option offset: Point = Point(0, 7)
            // The offset of the popup position.
            offset: [
                0,
                7
            ],
            // @option maxWidth: Number = 300
            // Max width of the popup, in pixels.
            maxWidth: 300,
            // @option minWidth: Number = 50
            // Min width of the popup, in pixels.
            minWidth: 50,
            // @option maxHeight: Number = null
            // If set, creates a scrollable container of the given height
            // inside a popup if its content exceeds it.
            // The scrollable container can be styled using the
            // `leaflet-popup-scrolled` CSS class selector.
            maxHeight: null,
            // @option autoPan: Boolean = true
            // Set it to `false` if you don't want the map to do panning animation
            // to fit the opened popup.
            autoPan: true,
            // @option autoPanPaddingTopLeft: Point = null
            // The margin between the popup and the top left corner of the map
            // view after autopanning was performed.
            autoPanPaddingTopLeft: null,
            // @option autoPanPaddingBottomRight: Point = null
            // The margin between the popup and the bottom right corner of the map
            // view after autopanning was performed.
            autoPanPaddingBottomRight: null,
            // @option autoPanPadding: Point = Point(5, 5)
            // Equivalent of setting both top left and bottom right autopan padding to the same value.
            autoPanPadding: [
                5,
                5
            ],
            // @option keepInView: Boolean = false
            // Set it to `true` if you want to prevent users from panning the popup
            // off of the screen while it is open.
            keepInView: false,
            // @option closeButton: Boolean = true
            // Controls the presence of a close button in the popup.
            closeButton: true,
            // @option autoClose: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the popup closing when another popup is opened.
            autoClose: true,
            // @option closeOnEscapeKey: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the ESC key for closing of the popup.
            closeOnEscapeKey: true,
            // @option closeOnClick: Boolean = *
            // Set it if you want to override the default behavior of the popup closing when user clicks
            // on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
            // @option className: String = ''
            // A custom CSS class name to assign to the popup.
            className: ''
        },
        // @namespace Popup
        // @method openOn(map: Map): this
        // Alternative to `map.openPopup(popup)`.
        // Adds the popup to the map and closes the previous one.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this) && map._popup && map._popup.options.autoClose) map.removeLayer(map._popup);
            map._popup = this;
            return DivOverlay.prototype.openOn.call(this, map);
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupopen: PopupEvent
            // Fired when a popup is opened in the map
            map.fire('popupopen', {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupopen: PopupEvent
                // Fired when a popup bound to this layer is opened
                this._source.fire('popupopen', {
                    popup: this
                }, true);
                // For non-path layers, we toggle the popup when clicking
                // again the layer, so prevent the map to reopen it.
                if (!(this._source instanceof Path)) this._source.on('preclick', stopPropagation);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupclose: PopupEvent
            // Fired when a popup in the map is closed
            map.fire('popupclose', {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupclose: PopupEvent
                // Fired when a popup bound to this layer is closed
                this._source.fire('popupclose', {
                    popup: this
                }, true);
                if (!(this._source instanceof Path)) this._source.off('preclick', stopPropagation);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (this.options.closeOnClick !== undefined ? this.options.closeOnClick : this._map.options.closePopupOnClick) events.preclick = this.close;
            if (this.options.keepInView) events.moveend = this._adjustPan;
            return events;
        },
        _initLayout: function() {
            var prefix = 'leaflet-popup', container = this._container = create$1('div', prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-animated');
            var wrapper = this._wrapper = create$1('div', prefix + '-content-wrapper', container);
            this._contentNode = create$1('div', prefix + '-content', wrapper);
            disableClickPropagation(container);
            disableScrollPropagation(this._contentNode);
            on(container, 'contextmenu', stopPropagation);
            this._tipContainer = create$1('div', prefix + '-tip-container', container);
            this._tip = create$1('div', prefix + '-tip', this._tipContainer);
            if (this.options.closeButton) {
                var closeButton = this._closeButton = create$1('a', prefix + '-close-button', container);
                closeButton.setAttribute('role', 'button'); // overrides the implicit role=link of <a> elements #7399
                closeButton.setAttribute('aria-label', 'Close popup');
                closeButton.href = '#close';
                closeButton.innerHTML = '<span aria-hidden="true">&#215;</span>';
                on(closeButton, 'click', function(ev) {
                    preventDefault(ev);
                    this.close();
                }, this);
            }
        },
        _updateLayout: function() {
            var container = this._contentNode, style = container.style;
            style.width = '';
            style.whiteSpace = 'nowrap';
            var width = container.offsetWidth;
            width = Math.min(width, this.options.maxWidth);
            width = Math.max(width, this.options.minWidth);
            style.width = width + 1 + 'px';
            style.whiteSpace = '';
            style.height = '';
            var height = container.offsetHeight, maxHeight = this.options.maxHeight, scrolledClass = 'leaflet-popup-scrolled';
            if (maxHeight && height > maxHeight) {
                style.height = maxHeight + 'px';
                addClass(container, scrolledClass);
            } else removeClass(container, scrolledClass);
            this._containerWidth = this._container.offsetWidth;
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center), anchor = this._getAnchor();
            setPosition(this._container, pos.add(anchor));
        },
        _adjustPan: function() {
            if (!this.options.autoPan) return;
            if (this._map._panAnim) this._map._panAnim.stop();
            // We can endlessly recurse if keepInView is set and the view resets.
            // Let's guard against that by exiting early if we're responding to our own autopan.
            if (this._autopanning) {
                this._autopanning = false;
                return;
            }
            var map = this._map, marginBottom = parseInt(getStyle(this._container, 'marginBottom'), 10) || 0, containerHeight = this._container.offsetHeight + marginBottom, containerWidth = this._containerWidth, layerPos = new Point(this._containerLeft, -containerHeight - this._containerBottom);
            layerPos._add(getPosition(this._container));
            var containerPos = map.layerPointToContainerPoint(layerPos), padding = toPoint(this.options.autoPanPadding), paddingTL = toPoint(this.options.autoPanPaddingTopLeft || padding), paddingBR = toPoint(this.options.autoPanPaddingBottomRight || padding), size = map.getSize(), dx = 0, dy = 0;
            if (containerPos.x + containerWidth + paddingBR.x > size.x) dx = containerPos.x + containerWidth - size.x + paddingBR.x;
            if (containerPos.x - dx - paddingTL.x < 0) dx = containerPos.x - paddingTL.x;
            if (containerPos.y + containerHeight + paddingBR.y > size.y) dy = containerPos.y + containerHeight - size.y + paddingBR.y;
            if (containerPos.y - dy - paddingTL.y < 0) dy = containerPos.y - paddingTL.y;
            // @namespace Map
            // @section Popup events
            // @event autopanstart: Event
            // Fired when the map starts autopanning when opening a popup.
            if (dx || dy) {
                // Track that we're autopanning, as this function will be re-ran on moveend
                if (this.options.keepInView) this._autopanning = true;
                map.fire('autopanstart').panBy([
                    dx,
                    dy
                ]);
            }
        },
        _getAnchor: function() {
            // Where should we anchor the popup on the source layer?
            return toPoint(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Popup
    // @factory L.popup(options?: Popup options, source?: Layer)
    // Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.popup(latlng: LatLng, options?: Popup options)
    // Instantiates a `Popup` object given `latlng` where the popup will open and an optional `options` object that describes its appearance and location.
    var popup = function(options, source) {
        return new Popup(options, source);
    };
    /* @namespace Map
   * @section Interaction Options
   * @option closePopupOnClick: Boolean = true
   * Set it to `false` if you don't want popups to close when user clicks the map.
   */ Map.mergeOptions({
        closePopupOnClick: true
    });
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openPopup(popup: Popup): this
        // Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
        // @alternative
        // @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
        // Creates a popup with the specified content and options and opens it in the given point on a map.
        openPopup: function(popup, latlng, options) {
            this._initOverlay(Popup, popup, latlng, options).openOn(this);
            return this;
        },
        // @method closePopup(popup?: Popup): this
        // Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
        closePopup: function(popup) {
            popup = arguments.length ? popup : this._popup;
            if (popup) popup.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Popup methods example
   *
   * All layers share a set of methods convenient for binding popups to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
   * layer.openPopup();
   * layer.closePopup();
   * ```
   *
   * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
   */ // @section Popup methods
    Layer.include({
        // @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
        // Binds a popup to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindPopup: function(content, options) {
            this._popup = this._initOverlay(Popup, this._popup, content, options);
            if (!this._popupHandlersAdded) {
                this.on({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = true;
            }
            return this;
        },
        // @method unbindPopup(): this
        // Removes the popup previously bound with `bindPopup`.
        unbindPopup: function() {
            if (this._popup) {
                this.off({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = false;
                this._popup = null;
            }
            return this;
        },
        // @method openPopup(latlng?: LatLng): this
        // Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
        openPopup: function(latlng) {
            if (this._popup) {
                if (!(this instanceof FeatureGroup)) this._popup._source = this;
                if (this._popup._prepareOpen(latlng || this._latlng)) // open the popup on the map
                this._popup.openOn(this._map);
            }
            return this;
        },
        // @method closePopup(): this
        // Closes the popup bound to this layer if it is open.
        closePopup: function() {
            if (this._popup) this._popup.close();
            return this;
        },
        // @method togglePopup(): this
        // Opens or closes the popup bound to this layer depending on its current state.
        togglePopup: function() {
            if (this._popup) this._popup.toggle(this);
            return this;
        },
        // @method isPopupOpen(): boolean
        // Returns `true` if the popup bound to this layer is currently open.
        isPopupOpen: function() {
            return this._popup ? this._popup.isOpen() : false;
        },
        // @method setPopupContent(content: String|HTMLElement|Popup): this
        // Sets the content of the popup bound to this layer.
        setPopupContent: function(content) {
            if (this._popup) this._popup.setContent(content);
            return this;
        },
        // @method getPopup(): Popup
        // Returns the popup bound to this layer.
        getPopup: function() {
            return this._popup;
        },
        _openPopup: function(e) {
            if (!this._popup || !this._map) return;
            // prevent map click
            stop(e);
            var target = e.layer || e.target;
            if (this._popup._source === target && !(target instanceof Path)) {
                // treat it like a marker and figure out
                // if we should toggle it open/closed
                if (this._map.hasLayer(this._popup)) this.closePopup();
                else this.openPopup(e.latlng);
                return;
            }
            this._popup._source = target;
            this.openPopup(e.latlng);
        },
        _movePopup: function(e) {
            this._popup.setLatLng(e.latlng);
        },
        _onKeyPress: function(e) {
            if (e.originalEvent.keyCode === 13) this._openPopup(e);
        }
    });
    /*
   * @class Tooltip
   * @inherits DivOverlay
   * @aka L.Tooltip
   * Used to display small texts on top of map layers.
   *
   * @example
   * If you want to just bind a tooltip to marker:
   *
   * ```js
   * marker.bindTooltip("my tooltip text").openTooltip();
   * ```
   * Path overlays like polylines also have a `bindTooltip` method.
   *
   * A tooltip can be also standalone:
   *
   * ```js
   * var tooltip = L.tooltip()
   * 	.setLatLng(latlng)
   * 	.setContent('Hello world!<br />This is a nice tooltip.')
   * 	.addTo(map);
   * ```
   * or
   * ```js
   * var tooltip = L.tooltip(latlng, {content: 'Hello world!<br />This is a nice tooltip.'})
   * 	.addTo(map);
   * ```
   *
   *
   * Note about tooltip offset. Leaflet takes two options in consideration
   * for computing tooltip offsetting:
   * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
   *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
   *   move it to the bottom. Negatives will move to the left and top.
   * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
   *   should adapt this value if you use a custom icon.
   */ // @namespace Tooltip
    var Tooltip = DivOverlay.extend({
        // @section
        // @aka Tooltip options
        options: {
            // @option pane: String = 'tooltipPane'
            // `Map pane` where the tooltip will be added.
            pane: 'tooltipPane',
            // @option offset: Point = Point(0, 0)
            // Optional offset of the tooltip position.
            offset: [
                0,
                0
            ],
            // @option direction: String = 'auto'
            // Direction where to open the tooltip. Possible values are: `right`, `left`,
            // `top`, `bottom`, `center`, `auto`.
            // `auto` will dynamically switch between `right` and `left` according to the tooltip
            // position on the map.
            direction: 'auto',
            // @option permanent: Boolean = false
            // Whether to open the tooltip permanently or only on mouseover.
            permanent: false,
            // @option sticky: Boolean = false
            // If true, the tooltip will follow the mouse instead of being fixed at the feature center.
            sticky: false,
            // @option opacity: Number = 0.9
            // Tooltip container opacity.
            opacity: 0.9
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            this.setOpacity(this.options.opacity);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipopen: TooltipEvent
            // Fired when a tooltip is opened in the map.
            map.fire('tooltipopen', {
                tooltip: this
            });
            if (this._source) {
                this.addEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipopen: TooltipEvent
                // Fired when a tooltip bound to this layer is opened.
                this._source.fire('tooltipopen', {
                    tooltip: this
                }, true);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipclose: TooltipEvent
            // Fired when a tooltip in the map is closed.
            map.fire('tooltipclose', {
                tooltip: this
            });
            if (this._source) {
                this.removeEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipclose: TooltipEvent
                // Fired when a tooltip bound to this layer is closed.
                this._source.fire('tooltipclose', {
                    tooltip: this
                }, true);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (!this.options.permanent) events.preclick = this.close;
            return events;
        },
        _initLayout: function() {
            var prefix = 'leaflet-tooltip', className = prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
            this._contentNode = this._container = create$1('div', className);
            this._container.setAttribute('role', 'tooltip');
            this._container.setAttribute('id', 'leaflet-tooltip-' + stamp(this));
        },
        _updateLayout: function() {},
        _adjustPan: function() {},
        _setPosition: function(pos) {
            var subX, subY, map = this._map, container = this._container, centerPoint = map.latLngToContainerPoint(map.getCenter()), tooltipPoint = map.layerPointToContainerPoint(pos), direction = this.options.direction, tooltipWidth = container.offsetWidth, tooltipHeight = container.offsetHeight, offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (direction === 'top') {
                subX = tooltipWidth / 2;
                subY = tooltipHeight;
            } else if (direction === 'bottom') {
                subX = tooltipWidth / 2;
                subY = 0;
            } else if (direction === 'center') {
                subX = tooltipWidth / 2;
                subY = tooltipHeight / 2;
            } else if (direction === 'right') {
                subX = 0;
                subY = tooltipHeight / 2;
            } else if (direction === 'left') {
                subX = tooltipWidth;
                subY = tooltipHeight / 2;
            } else if (tooltipPoint.x < centerPoint.x) {
                direction = 'right';
                subX = 0;
                subY = tooltipHeight / 2;
            } else {
                direction = 'left';
                subX = tooltipWidth + (offset.x + anchor.x) * 2;
                subY = tooltipHeight / 2;
            }
            pos = pos.subtract(toPoint(subX, subY, true)).add(offset).add(anchor);
            removeClass(container, 'leaflet-tooltip-right');
            removeClass(container, 'leaflet-tooltip-left');
            removeClass(container, 'leaflet-tooltip-top');
            removeClass(container, 'leaflet-tooltip-bottom');
            addClass(container, 'leaflet-tooltip-' + direction);
            setPosition(container, pos);
        },
        _updatePosition: function() {
            var pos = this._map.latLngToLayerPoint(this._latlng);
            this._setPosition(pos);
        },
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._container) setOpacity(this._container, opacity);
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
            this._setPosition(pos);
        },
        _getAnchor: function() {
            // Where should we anchor the tooltip on the source layer?
            return toPoint(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Tooltip
    // @factory L.tooltip(options?: Tooltip options, source?: Layer)
    // Instantiates a `Tooltip` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.tooltip(latlng: LatLng, options?: Tooltip options)
    // Instantiates a `Tooltip` object given `latlng` where the tooltip will open and an optional `options` object that describes its appearance and location.
    var tooltip = function(options, source) {
        return new Tooltip(options, source);
    };
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openTooltip(tooltip: Tooltip): this
        // Opens the specified tooltip.
        // @alternative
        // @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
        // Creates a tooltip with the specified content and options and open it.
        openTooltip: function(tooltip, latlng, options) {
            this._initOverlay(Tooltip, tooltip, latlng, options).openOn(this);
            return this;
        },
        // @method closeTooltip(tooltip: Tooltip): this
        // Closes the tooltip given as parameter.
        closeTooltip: function(tooltip) {
            tooltip.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Tooltip methods example
   *
   * All layers share a set of methods convenient for binding tooltips to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
   * layer.openTooltip();
   * layer.closeTooltip();
   * ```
   */ // @section Tooltip methods
    Layer.include({
        // @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
        // Binds a tooltip to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindTooltip: function(content, options) {
            if (this._tooltip && this.isTooltipOpen()) this.unbindTooltip();
            this._tooltip = this._initOverlay(Tooltip, this._tooltip, content, options);
            this._initTooltipInteractions();
            if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) this.openTooltip();
            return this;
        },
        // @method unbindTooltip(): this
        // Removes the tooltip previously bound with `bindTooltip`.
        unbindTooltip: function() {
            if (this._tooltip) {
                this._initTooltipInteractions(true);
                this.closeTooltip();
                this._tooltip = null;
            }
            return this;
        },
        _initTooltipInteractions: function(remove) {
            if (!remove && this._tooltipHandlersAdded) return;
            var onOff = remove ? 'off' : 'on', events = {
                remove: this.closeTooltip,
                move: this._moveTooltip
            };
            if (!this._tooltip.options.permanent) {
                events.mouseover = this._openTooltip;
                events.mouseout = this.closeTooltip;
                events.click = this._openTooltip;
                if (this._map) this._addFocusListeners();
                else events.add = this._addFocusListeners;
            } else events.add = this._openTooltip;
            if (this._tooltip.options.sticky) events.mousemove = this._moveTooltip;
            this[onOff](events);
            this._tooltipHandlersAdded = !remove;
        },
        // @method openTooltip(latlng?: LatLng): this
        // Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
        openTooltip: function(latlng) {
            if (this._tooltip) {
                if (!(this instanceof FeatureGroup)) this._tooltip._source = this;
                if (this._tooltip._prepareOpen(latlng)) {
                    // open the tooltip on the map
                    this._tooltip.openOn(this._map);
                    if (this.getElement) this._setAriaDescribedByOnLayer(this);
                    else if (this.eachLayer) this.eachLayer(this._setAriaDescribedByOnLayer, this);
                }
            }
            return this;
        },
        // @method closeTooltip(): this
        // Closes the tooltip bound to this layer if it is open.
        closeTooltip: function() {
            if (this._tooltip) return this._tooltip.close();
        },
        // @method toggleTooltip(): this
        // Opens or closes the tooltip bound to this layer depending on its current state.
        toggleTooltip: function() {
            if (this._tooltip) this._tooltip.toggle(this);
            return this;
        },
        // @method isTooltipOpen(): boolean
        // Returns `true` if the tooltip bound to this layer is currently open.
        isTooltipOpen: function() {
            return this._tooltip.isOpen();
        },
        // @method setTooltipContent(content: String|HTMLElement|Tooltip): this
        // Sets the content of the tooltip bound to this layer.
        setTooltipContent: function(content) {
            if (this._tooltip) this._tooltip.setContent(content);
            return this;
        },
        // @method getTooltip(): Tooltip
        // Returns the tooltip bound to this layer.
        getTooltip: function() {
            return this._tooltip;
        },
        _addFocusListeners: function() {
            if (this.getElement) this._addFocusListenersOnLayer(this);
            else if (this.eachLayer) this.eachLayer(this._addFocusListenersOnLayer, this);
        },
        _addFocusListenersOnLayer: function(layer) {
            var el = typeof layer.getElement === 'function' && layer.getElement();
            if (el) {
                on(el, 'focus', function() {
                    this._tooltip._source = layer;
                    this.openTooltip();
                }, this);
                on(el, 'blur', this.closeTooltip, this);
            }
        },
        _setAriaDescribedByOnLayer: function(layer) {
            var el = typeof layer.getElement === 'function' && layer.getElement();
            if (el) el.setAttribute('aria-describedby', this._tooltip._container.id);
        },
        _openTooltip: function(e) {
            if (!this._tooltip || !this._map) return;
            // If the map is moving, we will show the tooltip after it's done.
            if (this._map.dragging && this._map.dragging.moving() && !this._openOnceFlag) {
                this._openOnceFlag = true;
                var that = this;
                this._map.once('moveend', function() {
                    that._openOnceFlag = false;
                    that._openTooltip(e);
                });
                return;
            }
            this._tooltip._source = e.layer || e.target;
            this.openTooltip(this._tooltip.options.sticky ? e.latlng : undefined);
        },
        _moveTooltip: function(e) {
            var latlng = e.latlng, containerPoint, layerPoint;
            if (this._tooltip.options.sticky && e.originalEvent) {
                containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
                layerPoint = this._map.containerPointToLayerPoint(containerPoint);
                latlng = this._map.layerPointToLatLng(layerPoint);
            }
            this._tooltip.setLatLng(latlng);
        }
    });
    /*
   * @class DivIcon
   * @aka L.DivIcon
   * @inherits Icon
   *
   * Represents a lightweight icon for markers that uses a simple `<div>`
   * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
   *
   * @example
   * ```js
   * var myIcon = L.divIcon({className: 'my-div-icon'});
   * // you can set .my-div-icon styles in CSS
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
   */ var DivIcon = Icon.extend({
        options: {
            // @section
            // @aka DivIcon options
            iconSize: [
                12,
                12
            ],
            // iconAnchor: (Point),
            // popupAnchor: (Point),
            // @option html: String|HTMLElement = ''
            // Custom HTML code to put inside the div element, empty by default. Alternatively,
            // an instance of `HTMLElement`.
            html: false,
            // @option bgPos: Point = [0, 0]
            // Optional relative position of the background, in pixels
            bgPos: null,
            className: 'leaflet-div-icon'
        },
        createIcon: function(oldIcon) {
            var div = oldIcon && oldIcon.tagName === 'DIV' ? oldIcon : document.createElement('div'), options = this.options;
            if (options.html instanceof Element) {
                empty(div);
                div.appendChild(options.html);
            } else div.innerHTML = options.html !== false ? options.html : '';
            if (options.bgPos) {
                var bgPos = toPoint(options.bgPos);
                div.style.backgroundPosition = -bgPos.x + 'px ' + -bgPos.y + 'px';
            }
            this._setIconStyles(div, 'icon');
            return div;
        },
        createShadow: function() {
            return null;
        }
    });
    // @factory L.divIcon(options: DivIcon options)
    // Creates a `DivIcon` instance with the given options.
    function divIcon(options) {
        return new DivIcon(options);
    }
    Icon.Default = IconDefault;
    /*
   * @class GridLayer
   * @inherits Layer
   * @aka L.GridLayer
   *
   * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
   * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
   *
   *
   * @section Synchronous usage
   * @example
   *
   * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords){
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
   *         var ctx = tile.getContext('2d');
   *
   *         // return the tile so it can be rendered on screen
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section Asynchronous usage
   * @example
   *
   * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords, done){
   *         var error;
   *
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // draw something asynchronously and pass the tile to the done() callback
   *         setTimeout(function() {
   *             done(error, tile);
   *         }, 1000);
   *
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section
   */ var GridLayer = Layer.extend({
        // @section
        // @aka GridLayer options
        options: {
            // @option tileSize: Number|Point = 256
            // Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
            tileSize: 256,
            // @option opacity: Number = 1.0
            // Opacity of the tiles. Can be used in the `createTile()` function.
            opacity: 1,
            // @option updateWhenIdle: Boolean = (depends)
            // Load new tiles only when panning ends.
            // `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
            // `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
            // [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
            updateWhenIdle: Browser.mobile,
            // @option updateWhenZooming: Boolean = true
            // By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
            updateWhenZooming: true,
            // @option updateInterval: Number = 200
            // Tiles will not update more than once every `updateInterval` milliseconds when panning.
            updateInterval: 200,
            // @option zIndex: Number = 1
            // The explicit zIndex of the tile layer.
            zIndex: 1,
            // @option bounds: LatLngBounds = undefined
            // If set, tiles will only be loaded inside the set `LatLngBounds`.
            bounds: null,
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = undefined
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: undefined,
            // @option maxNativeZoom: Number = undefined
            // Maximum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
            // from `maxNativeZoom` level and auto-scaled.
            maxNativeZoom: undefined,
            // @option minNativeZoom: Number = undefined
            // Minimum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels lower than `minNativeZoom` will be loaded
            // from `minNativeZoom` level and auto-scaled.
            minNativeZoom: undefined,
            // @option noWrap: Boolean = false
            // Whether the layer is wrapped around the antimeridian. If `true`, the
            // GridLayer will only be displayed once at low zoom levels. Has no
            // effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
            // in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
            // tiles outside the CRS limits.
            noWrap: false,
            // @option pane: String = 'tilePane'
            // `Map pane` where the grid layer will be added.
            pane: 'tilePane',
            // @option className: String = ''
            // A custom class name to assign to the tile layer. Empty by default.
            className: '',
            // @option keepBuffer: Number = 2
            // When panning the map, keep this many rows and columns of tiles before unloading them.
            keepBuffer: 2
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        onAdd: function() {
            this._initContainer();
            this._levels = {};
            this._tiles = {};
            this._resetView(); // implicit _update() call
        },
        beforeAdd: function(map) {
            map._addZoomLimit(this);
        },
        onRemove: function(map) {
            this._removeAllTiles();
            remove(this._container);
            map._removeZoomLimit(this);
            this._container = null;
            this._tileZoom = undefined;
        },
        // @method bringToFront: this
        // Brings the tile layer to the top of all tile layers.
        bringToFront: function() {
            if (this._map) {
                toFront(this._container);
                this._setAutoZIndex(Math.max);
            }
            return this;
        },
        // @method bringToBack: this
        // Brings the tile layer to the bottom of all tile layers.
        bringToBack: function() {
            if (this._map) {
                toBack(this._container);
                this._setAutoZIndex(Math.min);
            }
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the tiles for this layer.
        getContainer: function() {
            return this._container;
        },
        // @method setOpacity(opacity: Number): this
        // Changes the [opacity](#gridlayer-opacity) of the grid layer.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            this._updateOpacity();
            return this;
        },
        // @method setZIndex(zIndex: Number): this
        // Changes the [zIndex](#gridlayer-zindex) of the grid layer.
        setZIndex: function(zIndex) {
            this.options.zIndex = zIndex;
            this._updateZIndex();
            return this;
        },
        // @method isLoading: Boolean
        // Returns `true` if any tile in the grid layer has not finished loading.
        isLoading: function() {
            return this._loading;
        },
        // @method redraw: this
        // Causes the layer to clear all the tiles and request them again.
        redraw: function() {
            if (this._map) {
                this._removeAllTiles();
                var tileZoom = this._clampZoom(this._map.getZoom());
                if (tileZoom !== this._tileZoom) {
                    this._tileZoom = tileZoom;
                    this._updateLevels();
                }
                this._update();
            }
            return this;
        },
        getEvents: function() {
            var events = {
                viewprereset: this._invalidateAll,
                viewreset: this._resetView,
                zoom: this._resetView,
                moveend: this._onMoveEnd
            };
            if (!this.options.updateWhenIdle) {
                // update tiles on move, but not more often than once per given interval
                if (!this._onMove) this._onMove = throttle(this._onMoveEnd, this.options.updateInterval, this);
                events.move = this._onMove;
            }
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @section Extension methods
        // Layers extending `GridLayer` shall reimplement the following method.
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, must be overridden by classes extending `GridLayer`.
        // Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
        // is specified, it must be called when the tile has finished loading and drawing.
        createTile: function() {
            return document.createElement('div');
        },
        // @section
        // @method getTileSize: Point
        // Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
        getTileSize: function() {
            var s = this.options.tileSize;
            return s instanceof Point ? s : new Point(s, s);
        },
        _updateZIndex: function() {
            if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) this._container.style.zIndex = this.options.zIndex;
        },
        _setAutoZIndex: function(compare) {
            // go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)
            var layers = this.getPane().children, edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min
            for(var i = 0, len = layers.length, zIndex; i < len; i++){
                zIndex = layers[i].style.zIndex;
                if (layers[i] !== this._container && zIndex) edgeZIndex = compare(edgeZIndex, +zIndex);
            }
            if (isFinite(edgeZIndex)) {
                this.options.zIndex = edgeZIndex + compare(-1, 1);
                this._updateZIndex();
            }
        },
        _updateOpacity: function() {
            if (!this._map) return;
            // IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
            if (Browser.ielt9) return;
            setOpacity(this._container, this.options.opacity);
            var now = +new Date(), nextFrame = false, willPrune = false;
            for(var key in this._tiles){
                var tile = this._tiles[key];
                if (!tile.current || !tile.loaded) continue;
                var fade = Math.min(1, (now - tile.loaded) / 200);
                setOpacity(tile.el, fade);
                if (fade < 1) nextFrame = true;
                else {
                    if (tile.active) willPrune = true;
                    else this._onOpaqueTile(tile);
                    tile.active = true;
                }
            }
            if (willPrune && !this._noPrune) this._pruneTiles();
            if (nextFrame) {
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            }
        },
        _onOpaqueTile: falseFn,
        _initContainer: function() {
            if (this._container) return;
            this._container = create$1('div', 'leaflet-layer ' + (this.options.className || ''));
            this._updateZIndex();
            if (this.options.opacity < 1) this._updateOpacity();
            this.getPane().appendChild(this._container);
        },
        _updateLevels: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom;
            if (zoom === undefined) return undefined;
            for(var z in this._levels){
                z = Number(z);
                if (this._levels[z].el.children.length || z === zoom) {
                    this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
                    this._onUpdateLevel(z);
                } else {
                    remove(this._levels[z].el);
                    this._removeTilesAtZoom(z);
                    this._onRemoveLevel(z);
                    delete this._levels[z];
                }
            }
            var level = this._levels[zoom], map = this._map;
            if (!level) {
                level = this._levels[zoom] = {};
                level.el = create$1('div', 'leaflet-tile-container leaflet-zoom-animated', this._container);
                level.el.style.zIndex = maxZoom;
                level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
                level.zoom = zoom;
                this._setZoomTransform(level, map.getCenter(), map.getZoom());
                // force the browser to consider the newly added element for transition
                falseFn(level.el.offsetWidth);
                this._onCreateLevel(level);
            }
            this._level = level;
            return level;
        },
        _onUpdateLevel: falseFn,
        _onRemoveLevel: falseFn,
        _onCreateLevel: falseFn,
        _pruneTiles: function() {
            if (!this._map) return;
            var key, tile;
            var zoom = this._map.getZoom();
            if (zoom > this.options.maxZoom || zoom < this.options.minZoom) {
                this._removeAllTiles();
                return;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                tile.retain = tile.current;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                if (tile.current && !tile.active) {
                    var coords = tile.coords;
                    if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
                }
            }
            for(key in this._tiles)if (!this._tiles[key].retain) this._removeTile(key);
        },
        _removeTilesAtZoom: function(zoom) {
            for(var key in this._tiles){
                if (this._tiles[key].coords.z !== zoom) continue;
                this._removeTile(key);
            }
        },
        _removeAllTiles: function() {
            for(var key in this._tiles)this._removeTile(key);
        },
        _invalidateAll: function() {
            for(var z in this._levels){
                remove(this._levels[z].el);
                this._onRemoveLevel(Number(z));
                delete this._levels[z];
            }
            this._removeAllTiles();
            this._tileZoom = undefined;
        },
        _retainParent: function(x, y, z, minZoom) {
            var x2 = Math.floor(x / 2), y2 = Math.floor(y / 2), z2 = z - 1, coords2 = new Point(+x2, +y2);
            coords2.z = +z2;
            var key = this._tileCoordsToKey(coords2), tile = this._tiles[key];
            if (tile && tile.active) {
                tile.retain = true;
                return true;
            } else if (tile && tile.loaded) tile.retain = true;
            if (z2 > minZoom) return this._retainParent(x2, y2, z2, minZoom);
            return false;
        },
        _retainChildren: function(x, y, z, maxZoom) {
            for(var i = 2 * x; i < 2 * x + 2; i++)for(var j = 2 * y; j < 2 * y + 2; j++){
                var coords = new Point(i, j);
                coords.z = z + 1;
                var key = this._tileCoordsToKey(coords), tile = this._tiles[key];
                if (tile && tile.active) {
                    tile.retain = true;
                    continue;
                } else if (tile && tile.loaded) tile.retain = true;
                if (z + 1 < maxZoom) this._retainChildren(i, j, z + 1, maxZoom);
            }
        },
        _resetView: function(e) {
            var animating = e && (e.pinch || e.flyTo);
            this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
        },
        _animateZoom: function(e) {
            this._setView(e.center, e.zoom, true, e.noUpdate);
        },
        _clampZoom: function(zoom) {
            var options = this.options;
            if (undefined !== options.minNativeZoom && zoom < options.minNativeZoom) return options.minNativeZoom;
            if (undefined !== options.maxNativeZoom && options.maxNativeZoom < zoom) return options.maxNativeZoom;
            return zoom;
        },
        _setView: function(center, zoom, noPrune, noUpdate) {
            var tileZoom = Math.round(zoom);
            if (this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom || this.options.minZoom !== undefined && tileZoom < this.options.minZoom) tileZoom = undefined;
            else tileZoom = this._clampZoom(tileZoom);
            var tileZoomChanged = this.options.updateWhenZooming && tileZoom !== this._tileZoom;
            if (!noUpdate || tileZoomChanged) {
                this._tileZoom = tileZoom;
                if (this._abortLoading) this._abortLoading();
                this._updateLevels();
                this._resetGrid();
                if (tileZoom !== undefined) this._update(center);
                if (!noPrune) this._pruneTiles();
                // Flag to prevent _updateOpacity from pruning tiles during
                // a zoom anim or a pinch gesture
                this._noPrune = !!noPrune;
            }
            this._setZoomTransforms(center, zoom);
        },
        _setZoomTransforms: function(center, zoom) {
            for(var i in this._levels)this._setZoomTransform(this._levels[i], center, zoom);
        },
        _setZoomTransform: function(level, center, zoom) {
            var scale = this._map.getZoomScale(zoom, level.zoom), translate = level.origin.multiplyBy(scale).subtract(this._map._getNewPixelOrigin(center, zoom)).round();
            if (Browser.any3d) setTransform(level.el, translate, scale);
            else setPosition(level.el, translate);
        },
        _resetGrid: function() {
            var map = this._map, crs = map.options.crs, tileSize = this._tileSize = this.getTileSize(), tileZoom = this._tileZoom;
            var bounds = this._map.getPixelWorldBounds(this._tileZoom);
            if (bounds) this._globalTileRange = this._pxBoundsToTileRange(bounds);
            this._wrapX = crs.wrapLng && !this.options.noWrap && [
                Math.floor(map.project([
                    0,
                    crs.wrapLng[0]
                ], tileZoom).x / tileSize.x),
                Math.ceil(map.project([
                    0,
                    crs.wrapLng[1]
                ], tileZoom).x / tileSize.y)
            ];
            this._wrapY = crs.wrapLat && !this.options.noWrap && [
                Math.floor(map.project([
                    crs.wrapLat[0],
                    0
                ], tileZoom).y / tileSize.x),
                Math.ceil(map.project([
                    crs.wrapLat[1],
                    0
                ], tileZoom).y / tileSize.y)
            ];
        },
        _onMoveEnd: function() {
            if (!this._map || this._map._animatingZoom) return;
            this._update();
        },
        _getTiledPixelBounds: function(center) {
            var map = this._map, mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(), scale = map.getZoomScale(mapZoom, this._tileZoom), pixelCenter = map.project(center, this._tileZoom).floor(), halfSize = map.getSize().divideBy(scale * 2);
            return new Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
        },
        // Private method to load tiles in the grid's active zoom level according to map bounds
        _update: function(center) {
            var map = this._map;
            if (!map) return;
            var zoom = this._clampZoom(map.getZoom());
            if (center === undefined) center = map.getCenter();
            if (this._tileZoom === undefined) return;
             // if out of minzoom/maxzoom
            var pixelBounds = this._getTiledPixelBounds(center), tileRange = this._pxBoundsToTileRange(pixelBounds), tileCenter = tileRange.getCenter(), queue = [], margin = this.options.keepBuffer, noPruneRange = new Bounds(tileRange.getBottomLeft().subtract([
                margin,
                -margin
            ]), tileRange.getTopRight().add([
                margin,
                -margin
            ]));
            // Sanity check: panic if the tile range contains Infinity somewhere.
            if (!(isFinite(tileRange.min.x) && isFinite(tileRange.min.y) && isFinite(tileRange.max.x) && isFinite(tileRange.max.y))) throw new Error('Attempted to load an infinite number of tiles');
            for(var key in this._tiles){
                var c = this._tiles[key].coords;
                if (c.z !== this._tileZoom || !noPruneRange.contains(new Point(c.x, c.y))) this._tiles[key].current = false;
            }
            // _update just loads more tiles. If the tile zoom level differs too much
            // from the map's, let _setView reset levels and prune old tiles.
            if (Math.abs(zoom - this._tileZoom) > 1) {
                this._setView(center, zoom);
                return;
            }
            // create a queue of coordinates to load tiles from
            for(var j = tileRange.min.y; j <= tileRange.max.y; j++)for(var i = tileRange.min.x; i <= tileRange.max.x; i++){
                var coords = new Point(i, j);
                coords.z = this._tileZoom;
                if (!this._isValidTile(coords)) continue;
                var tile = this._tiles[this._tileCoordsToKey(coords)];
                if (tile) tile.current = true;
                else queue.push(coords);
            }
            // sort tile queue to load tiles in order of their distance to center
            queue.sort(function(a, b) {
                return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
            });
            if (queue.length !== 0) {
                // if it's the first batch of tiles to load
                if (!this._loading) {
                    this._loading = true;
                    // @event loading: Event
                    // Fired when the grid layer starts loading tiles.
                    this.fire('loading');
                }
                // create DOM fragment to append tiles in one batch
                var fragment = document.createDocumentFragment();
                for(i = 0; i < queue.length; i++)this._addTile(queue[i], fragment);
                this._level.el.appendChild(fragment);
            }
        },
        _isValidTile: function(coords) {
            var crs = this._map.options.crs;
            if (!crs.infinite) {
                // don't load tile if it's out of bounds and not wrapped
                var bounds = this._globalTileRange;
                if (!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x) || !crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y)) return false;
            }
            if (!this.options.bounds) return true;
            // don't load tile if it doesn't intersect the bounds in options
            var tileBounds = this._tileCoordsToBounds(coords);
            return toLatLngBounds(this.options.bounds).overlaps(tileBounds);
        },
        _keyToBounds: function(key) {
            return this._tileCoordsToBounds(this._keyToTileCoords(key));
        },
        _tileCoordsToNwSe: function(coords) {
            var map = this._map, tileSize = this.getTileSize(), nwPoint = coords.scaleBy(tileSize), sePoint = nwPoint.add(tileSize), nw = map.unproject(nwPoint, coords.z), se = map.unproject(sePoint, coords.z);
            return [
                nw,
                se
            ];
        },
        // converts tile coordinates to its geographical bounds
        _tileCoordsToBounds: function(coords) {
            var bp = this._tileCoordsToNwSe(coords), bounds = new LatLngBounds(bp[0], bp[1]);
            if (!this.options.noWrap) bounds = this._map.wrapLatLngBounds(bounds);
            return bounds;
        },
        // converts tile coordinates to key for the tile cache
        _tileCoordsToKey: function(coords) {
            return coords.x + ':' + coords.y + ':' + coords.z;
        },
        // converts tile cache key to coordinates
        _keyToTileCoords: function(key) {
            var k = key.split(':'), coords = new Point(+k[0], +k[1]);
            coords.z = +k[2];
            return coords;
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            remove(tile.el);
            delete this._tiles[key];
            // @event tileunload: TileEvent
            // Fired when a tile is removed (e.g. when a tile goes off the screen).
            this.fire('tileunload', {
                tile: tile.el,
                coords: this._keyToTileCoords(key)
            });
        },
        _initTile: function(tile) {
            addClass(tile, 'leaflet-tile');
            var tileSize = this.getTileSize();
            tile.style.width = tileSize.x + 'px';
            tile.style.height = tileSize.y + 'px';
            tile.onselectstart = falseFn;
            tile.onmousemove = falseFn;
            // update opacity on tiles in IE7-8 because of filter inheritance problems
            if (Browser.ielt9 && this.options.opacity < 1) setOpacity(tile, this.options.opacity);
        },
        _addTile: function(coords, container) {
            var tilePos = this._getTilePos(coords), key = this._tileCoordsToKey(coords);
            var tile = this.createTile(this._wrapCoords(coords), bind(this._tileReady, this, coords));
            this._initTile(tile);
            // if createTile is defined with a second argument ("done" callback),
            // we know that tile is async and will be ready later; otherwise
            if (this.createTile.length < 2) // mark tile as ready, but delay one frame for opacity animation to happen
            requestAnimFrame(bind(this._tileReady, this, coords, null, tile));
            setPosition(tile, tilePos);
            // save tile in cache
            this._tiles[key] = {
                el: tile,
                coords: coords,
                current: true
            };
            container.appendChild(tile);
            // @event tileloadstart: TileEvent
            // Fired when a tile is requested and starts loading.
            this.fire('tileloadstart', {
                tile: tile,
                coords: coords
            });
        },
        _tileReady: function(coords, err, tile) {
            if (err) // @event tileerror: TileErrorEvent
            // Fired when there is an error loading a tile.
            this.fire('tileerror', {
                error: err,
                tile: tile,
                coords: coords
            });
            var key = this._tileCoordsToKey(coords);
            tile = this._tiles[key];
            if (!tile) return;
            tile.loaded = +new Date();
            if (this._map._fadeAnimated) {
                setOpacity(tile.el, 0);
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            } else {
                tile.active = true;
                this._pruneTiles();
            }
            if (!err) {
                addClass(tile.el, 'leaflet-tile-loaded');
                // @event tileload: TileEvent
                // Fired when a tile loads.
                this.fire('tileload', {
                    tile: tile.el,
                    coords: coords
                });
            }
            if (this._noTilesToLoad()) {
                this._loading = false;
                // @event load: Event
                // Fired when the grid layer loaded all visible tiles.
                this.fire('load');
                if (Browser.ielt9 || !this._map._fadeAnimated) requestAnimFrame(this._pruneTiles, this);
                else // Wait a bit more than 0.2 secs (the duration of the tile fade-in)
                // to trigger a pruning.
                setTimeout(bind(this._pruneTiles, this), 250);
            }
        },
        _getTilePos: function(coords) {
            return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
        },
        _wrapCoords: function(coords) {
            var newCoords = new Point(this._wrapX ? wrapNum(coords.x, this._wrapX) : coords.x, this._wrapY ? wrapNum(coords.y, this._wrapY) : coords.y);
            newCoords.z = coords.z;
            return newCoords;
        },
        _pxBoundsToTileRange: function(bounds) {
            var tileSize = this.getTileSize();
            return new Bounds(bounds.min.unscaleBy(tileSize).floor(), bounds.max.unscaleBy(tileSize).ceil().subtract([
                1,
                1
            ]));
        },
        _noTilesToLoad: function() {
            for(var key in this._tiles){
                if (!this._tiles[key].loaded) return false;
            }
            return true;
        }
    });
    // @factory L.gridLayer(options?: GridLayer options)
    // Creates a new instance of GridLayer with the supplied options.
    function gridLayer(options) {
        return new GridLayer(options);
    }
    /*
   * @class TileLayer
   * @inherits GridLayer
   * @aka L.TileLayer
   * Used to load and display tile layers on the map. Note that most tile servers require attribution, which you can set under `Layer`. Extends `GridLayer`.
   *
   * @example
   *
   * ```js
   * L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar', attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}).addTo(map);
   * ```
   *
   * @section URL template
   * @example
   *
   * A string of the following form:
   *
   * ```
   * 'https://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
   * ```
   *
   * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add "&commat;2x" to the URL to load retina tiles.
   *
   * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
   *
   * ```
   * L.tileLayer('https://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
   * ```
   */ var TileLayer = GridLayer.extend({
        // @section
        // @aka TileLayer options
        options: {
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = 18
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: 18,
            // @option subdomains: String|String[] = 'abc'
            // Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
            subdomains: 'abc',
            // @option errorTileUrl: String = ''
            // URL to the tile image to show in place of the tile that failed to load.
            errorTileUrl: '',
            // @option zoomOffset: Number = 0
            // The zoom number used in tile URLs will be offset with this value.
            zoomOffset: 0,
            // @option tms: Boolean = false
            // If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
            tms: false,
            // @option zoomReverse: Boolean = false
            // If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
            zoomReverse: false,
            // @option detectRetina: Boolean = false
            // If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
            detectRetina: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option referrerPolicy: Boolean|String = false
            // Whether the referrerPolicy attribute will be added to the tiles.
            // If a String is provided, all tiles will have their referrerPolicy attribute set to the String provided.
            // This may be needed if your map's rendering context has a strict default but your tile provider expects a valid referrer
            // (e.g. to validate an API token).
            // Refer to [HTMLImageElement.referrerPolicy](https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/referrerPolicy) for valid String values.
            referrerPolicy: false
        },
        initialize: function(url, options) {
            this._url = url;
            options = setOptions(this, options);
            // detecting retina displays, adjusting tileSize and zoom levels
            if (options.detectRetina && Browser.retina && options.maxZoom > 0) {
                options.tileSize = Math.floor(options.tileSize / 2);
                if (!options.zoomReverse) {
                    options.zoomOffset++;
                    options.maxZoom = Math.max(options.minZoom, options.maxZoom - 1);
                } else {
                    options.zoomOffset--;
                    options.minZoom = Math.min(options.maxZoom, options.minZoom + 1);
                }
                options.minZoom = Math.max(0, options.minZoom);
            } else if (!options.zoomReverse) // make sure maxZoom is gte minZoom
            options.maxZoom = Math.max(options.minZoom, options.maxZoom);
            else // make sure minZoom is lte maxZoom
            options.minZoom = Math.min(options.maxZoom, options.minZoom);
            if (typeof options.subdomains === 'string') options.subdomains = options.subdomains.split('');
            this.on('tileunload', this._onTileRemove);
        },
        // @method setUrl(url: String, noRedraw?: Boolean): this
        // Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
        // If the URL does not change, the layer will not be redrawn unless
        // the noRedraw parameter is set to false.
        setUrl: function(url, noRedraw) {
            if (this._url === url && noRedraw === undefined) noRedraw = true;
            this._url = url;
            if (!noRedraw) this.redraw();
            return this;
        },
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
        // to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
        // callback is called when the tile has been loaded.
        createTile: function(coords, done) {
            var tile = document.createElement('img');
            on(tile, 'load', bind(this._tileOnLoad, this, done, tile));
            on(tile, 'error', bind(this._tileOnError, this, done, tile));
            if (this.options.crossOrigin || this.options.crossOrigin === '') tile.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            // for this new option we follow the documented behavior
            // more closely by only setting the property when string
            if (typeof this.options.referrerPolicy === 'string') tile.referrerPolicy = this.options.referrerPolicy;
            // The alt attribute is set to the empty string,
            // allowing screen readers to ignore the decorative image tiles.
            // https://www.w3.org/WAI/tutorials/images/decorative/
            // https://www.w3.org/TR/html-aria/#el-img-empty-alt
            tile.alt = '';
            tile.src = this.getTileUrl(coords);
            return tile;
        },
        // @section Extension methods
        // @uninheritable
        // Layers extending `TileLayer` might reimplement the following method.
        // @method getTileUrl(coords: Object): String
        // Called only internally, returns the URL for a tile given its coordinates.
        // Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
        getTileUrl: function(coords) {
            var data = {
                r: Browser.retina ? '@2x' : '',
                s: this._getSubdomain(coords),
                x: coords.x,
                y: coords.y,
                z: this._getZoomForUrl()
            };
            if (this._map && !this._map.options.crs.infinite) {
                var invertedY = this._globalTileRange.max.y - coords.y;
                if (this.options.tms) data['y'] = invertedY;
                data['-y'] = invertedY;
            }
            return template(this._url, extend(data, this.options));
        },
        _tileOnLoad: function(done, tile) {
            // For https://github.com/Leaflet/Leaflet/issues/3332
            if (Browser.ielt9) setTimeout(bind(done, this, null, tile), 0);
            else done(null, tile);
        },
        _tileOnError: function(done, tile, e) {
            var errorUrl = this.options.errorTileUrl;
            if (errorUrl && tile.getAttribute('src') !== errorUrl) tile.src = errorUrl;
            done(e, tile);
        },
        _onTileRemove: function(e) {
            e.tile.onload = null;
        },
        _getZoomForUrl: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom, zoomReverse = this.options.zoomReverse, zoomOffset = this.options.zoomOffset;
            if (zoomReverse) zoom = maxZoom - zoom;
            return zoom + zoomOffset;
        },
        _getSubdomain: function(tilePoint) {
            var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
            return this.options.subdomains[index];
        },
        // stops loading all tiles in the background layer
        _abortLoading: function() {
            var i, tile;
            for(i in this._tiles)if (this._tiles[i].coords.z !== this._tileZoom) {
                tile = this._tiles[i].el;
                tile.onload = falseFn;
                tile.onerror = falseFn;
                if (!tile.complete) {
                    tile.src = emptyImageUrl;
                    var coords = this._tiles[i].coords;
                    remove(tile);
                    delete this._tiles[i];
                    // @event tileabort: TileEvent
                    // Fired when a tile was loading but is now not wanted.
                    this.fire('tileabort', {
                        tile: tile,
                        coords: coords
                    });
                }
            }
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            // Cancels any pending http requests associated with the tile
            tile.el.setAttribute('src', emptyImageUrl);
            return GridLayer.prototype._removeTile.call(this, key);
        },
        _tileReady: function(coords, err, tile) {
            if (!this._map || tile && tile.getAttribute('src') === emptyImageUrl) return;
            return GridLayer.prototype._tileReady.call(this, coords, err, tile);
        }
    });
    // @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
    // Instantiates a tile layer object given a `URL template` and optionally an options object.
    function tileLayer(url, options) {
        return new TileLayer(url, options);
    }
    /*
   * @class TileLayer.WMS
   * @inherits TileLayer
   * @aka L.TileLayer.WMS
   * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
   *
   * @example
   *
   * ```js
   * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
   * 	layers: 'nexrad-n0r-900913',
   * 	format: 'image/png',
   * 	transparent: true,
   * 	attribution: "Weather data © 2012 IEM Nexrad"
   * });
   * ```
   */ var TileLayerWMS = TileLayer.extend({
        // @section
        // @aka TileLayer.WMS options
        // If any custom options not documented here are used, they will be sent to the
        // WMS server as extra parameters in each request URL. This can be useful for
        // [non-standard vendor WMS parameters](https://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
        defaultWmsParams: {
            service: 'WMS',
            request: 'GetMap',
            // @option layers: String = ''
            // **(required)** Comma-separated list of WMS layers to show.
            layers: '',
            // @option styles: String = ''
            // Comma-separated list of WMS styles.
            styles: '',
            // @option format: String = 'image/jpeg'
            // WMS image format (use `'image/png'` for layers with transparency).
            format: 'image/jpeg',
            // @option transparent: Boolean = false
            // If `true`, the WMS service will return images with transparency.
            transparent: false,
            // @option version: String = '1.1.1'
            // Version of the WMS service to use
            version: '1.1.1'
        },
        options: {
            // @option crs: CRS = null
            // Coordinate Reference System to use for the WMS requests, defaults to
            // map CRS. Don't change this if you're not sure what it means.
            crs: null,
            // @option uppercase: Boolean = false
            // If `true`, WMS request parameter keys will be uppercase.
            uppercase: false
        },
        initialize: function(url, options) {
            this._url = url;
            var wmsParams = extend({}, this.defaultWmsParams);
            // all keys that are not TileLayer options go to WMS params
            for(var i in options)if (!(i in this.options)) wmsParams[i] = options[i];
            options = setOptions(this, options);
            var realRetina = options.detectRetina && Browser.retina ? 2 : 1;
            var tileSize = this.getTileSize();
            wmsParams.width = tileSize.x * realRetina;
            wmsParams.height = tileSize.y * realRetina;
            this.wmsParams = wmsParams;
        },
        onAdd: function(map) {
            this._crs = this.options.crs || map.options.crs;
            this._wmsVersion = parseFloat(this.wmsParams.version);
            var projectionKey = this._wmsVersion >= 1.3 ? 'crs' : 'srs';
            this.wmsParams[projectionKey] = this._crs.code;
            TileLayer.prototype.onAdd.call(this, map);
        },
        getTileUrl: function(coords) {
            var tileBounds = this._tileCoordsToNwSe(coords), crs = this._crs, bounds = toBounds(crs.project(tileBounds[0]), crs.project(tileBounds[1])), min = bounds.min, max = bounds.max, bbox = (this._wmsVersion >= 1.3 && this._crs === EPSG4326 ? [
                min.y,
                min.x,
                max.y,
                max.x
            ] : [
                min.x,
                min.y,
                max.x,
                max.y
            ]).join(','), url = TileLayer.prototype.getTileUrl.call(this, coords);
            return url + getParamString(this.wmsParams, url, this.options.uppercase) + (this.options.uppercase ? '&BBOX=' : '&bbox=') + bbox;
        },
        // @method setParams(params: Object, noRedraw?: Boolean): this
        // Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
        setParams: function(params, noRedraw) {
            extend(this.wmsParams, params);
            if (!noRedraw) this.redraw();
            return this;
        }
    });
    // @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
    // Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
    function tileLayerWMS(url, options) {
        return new TileLayerWMS(url, options);
    }
    TileLayer.WMS = TileLayerWMS;
    tileLayer.wms = tileLayerWMS;
    /*
   * @class Renderer
   * @inherits Layer
   * @aka L.Renderer
   *
   * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
   * DOM container of the renderer, its bounds, and its zoom animation.
   *
   * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
   * itself can be added or removed to the map. All paths use a renderer, which can
   * be implicit (the map will decide the type of renderer and use it automatically)
   * or explicit (using the [`renderer`](#path-renderer) option of the path).
   *
   * Do not use this class directly, use `SVG` and `Canvas` instead.
   *
   * @event update: Event
   * Fired when the renderer updates its bounds, center and zoom, for example when
   * its map has moved
   */ var Renderer = Layer.extend({
        // @section
        // @aka Renderer options
        options: {
            // @option padding: Number = 0.1
            // How much to extend the clip area around the map view (relative to its size)
            // e.g. 0.1 would be 10% of map view in each direction
            padding: 0.1
        },
        initialize: function(options) {
            setOptions(this, options);
            stamp(this);
            this._layers = this._layers || {};
        },
        onAdd: function() {
            if (!this._container) {
                this._initContainer(); // defined by renderer implementations
                // always keep transform-origin as 0 0
                addClass(this._container, 'leaflet-zoom-animated');
            }
            this.getPane().appendChild(this._container);
            this._update();
            this.on('update', this._updatePaths, this);
        },
        onRemove: function() {
            this.off('update', this._updatePaths, this);
            this._destroyContainer();
        },
        getEvents: function() {
            var events = {
                viewreset: this._reset,
                zoom: this._onZoom,
                moveend: this._update,
                zoomend: this._onZoomEnd
            };
            if (this._zoomAnimated) events.zoomanim = this._onAnimZoom;
            return events;
        },
        _onAnimZoom: function(ev) {
            this._updateTransform(ev.center, ev.zoom);
        },
        _onZoom: function() {
            this._updateTransform(this._map.getCenter(), this._map.getZoom());
        },
        _updateTransform: function(center, zoom) {
            var scale = this._map.getZoomScale(zoom, this._zoom), viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding), currentCenterPoint = this._map.project(this._center, zoom), topLeftOffset = viewHalf.multiplyBy(-scale).add(currentCenterPoint).subtract(this._map._getNewPixelOrigin(center, zoom));
            if (Browser.any3d) setTransform(this._container, topLeftOffset, scale);
            else setPosition(this._container, topLeftOffset);
        },
        _reset: function() {
            this._update();
            this._updateTransform(this._center, this._zoom);
            for(var id in this._layers)this._layers[id]._reset();
        },
        _onZoomEnd: function() {
            for(var id in this._layers)this._layers[id]._project();
        },
        _updatePaths: function() {
            for(var id in this._layers)this._layers[id]._update();
        },
        _update: function() {
            // Update pixel bounds of renderer container (for positioning/sizing/clipping later)
            // Subclasses are responsible of firing the 'update' event.
            var p = this.options.padding, size = this._map.getSize(), min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
            this._bounds = new Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());
            this._center = this._map.getCenter();
            this._zoom = this._map.getZoom();
        }
    });
    /*
   * @class Canvas
   * @inherits Renderer
   * @aka L.Canvas
   *
   * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/canvas), Canvas is not
   * available in all web browsers, notably IE8, and overlapping geometries might
   * not display properly in some edge cases.
   *
   * @example
   *
   * Use Canvas by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.canvas()
   * });
   * ```
   *
   * Use a Canvas renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.canvas({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var Canvas = Renderer.extend({
        // @section
        // @aka Canvas options
        options: {
            // @option tolerance: Number = 0
            // How much to extend the click tolerance around a path/object on the map.
            tolerance: 0
        },
        getEvents: function() {
            var events = Renderer.prototype.getEvents.call(this);
            events.viewprereset = this._onViewPreReset;
            return events;
        },
        _onViewPreReset: function() {
            // Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
            this._postponeUpdatePaths = true;
        },
        onAdd: function() {
            Renderer.prototype.onAdd.call(this);
            // Redraw vectors since canvas is cleared upon removal,
            // in case of removing the renderer itself from the map.
            this._draw();
        },
        _initContainer: function() {
            var container = this._container = document.createElement('canvas');
            on(container, 'mousemove', this._onMouseMove, this);
            on(container, 'click dblclick mousedown mouseup contextmenu', this._onClick, this);
            on(container, 'mouseout', this._handleMouseOut, this);
            container['_leaflet_disable_events'] = true;
            this._ctx = container.getContext('2d');
        },
        _destroyContainer: function() {
            cancelAnimFrame(this._redrawRequest);
            delete this._ctx;
            remove(this._container);
            off(this._container);
            delete this._container;
        },
        _updatePaths: function() {
            if (this._postponeUpdatePaths) return;
            var layer;
            this._redrawBounds = null;
            for(var id in this._layers){
                layer = this._layers[id];
                layer._update();
            }
            this._redraw();
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, container = this._container, size = b.getSize(), m = Browser.retina ? 2 : 1;
            setPosition(container, b.min);
            // set canvas size (also clearing it); use double size on retina
            container.width = m * size.x;
            container.height = m * size.y;
            container.style.width = size.x + 'px';
            container.style.height = size.y + 'px';
            if (Browser.retina) this._ctx.scale(2, 2);
            // translate so we use the same path coordinates after canvas element moves
            this._ctx.translate(-b.min.x, -b.min.y);
            // Tell paths to redraw themselves
            this.fire('update');
        },
        _reset: function() {
            Renderer.prototype._reset.call(this);
            if (this._postponeUpdatePaths) {
                this._postponeUpdatePaths = false;
                this._updatePaths();
            }
        },
        _initPath: function(layer) {
            this._updateDashArray(layer);
            this._layers[stamp(layer)] = layer;
            var order = layer._order = {
                layer: layer,
                prev: this._drawLast,
                next: null
            };
            if (this._drawLast) this._drawLast.next = order;
            this._drawLast = order;
            this._drawFirst = this._drawFirst || this._drawLast;
        },
        _addPath: function(layer) {
            this._requestRedraw(layer);
        },
        _removePath: function(layer) {
            var order = layer._order;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else this._drawLast = prev;
            if (prev) prev.next = next;
            else this._drawFirst = next;
            delete layer._order;
            delete this._layers[stamp(layer)];
            this._requestRedraw(layer);
        },
        _updatePath: function(layer) {
            // Redraw the union of the layer's old pixel
            // bounds and the new pixel bounds.
            this._extendRedrawBounds(layer);
            layer._project();
            layer._update();
            // The redraw will extend the redraw bounds
            // with the new pixel bounds.
            this._requestRedraw(layer);
        },
        _updateStyle: function(layer) {
            this._updateDashArray(layer);
            this._requestRedraw(layer);
        },
        _updateDashArray: function(layer) {
            if (typeof layer.options.dashArray === 'string') {
                var parts = layer.options.dashArray.split(/[, ]+/), dashArray = [], dashValue, i;
                for(i = 0; i < parts.length; i++){
                    dashValue = Number(parts[i]);
                    // Ignore dash array containing invalid lengths
                    if (isNaN(dashValue)) return;
                    dashArray.push(dashValue);
                }
                layer.options._dashArray = dashArray;
            } else layer.options._dashArray = layer.options.dashArray;
        },
        _requestRedraw: function(layer) {
            if (!this._map) return;
            this._extendRedrawBounds(layer);
            this._redrawRequest = this._redrawRequest || requestAnimFrame(this._redraw, this);
        },
        _extendRedrawBounds: function(layer) {
            if (layer._pxBounds) {
                var padding = (layer.options.weight || 0) + 1;
                this._redrawBounds = this._redrawBounds || new Bounds();
                this._redrawBounds.extend(layer._pxBounds.min.subtract([
                    padding,
                    padding
                ]));
                this._redrawBounds.extend(layer._pxBounds.max.add([
                    padding,
                    padding
                ]));
            }
        },
        _redraw: function() {
            this._redrawRequest = null;
            if (this._redrawBounds) {
                this._redrawBounds.min._floor();
                this._redrawBounds.max._ceil();
            }
            this._clear(); // clear layers in redraw bounds
            this._draw(); // draw layers
            this._redrawBounds = null;
        },
        _clear: function() {
            var bounds = this._redrawBounds;
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
            } else {
                this._ctx.save();
                this._ctx.setTransform(1, 0, 0, 1, 0, 0);
                this._ctx.clearRect(0, 0, this._container.width, this._container.height);
                this._ctx.restore();
            }
        },
        _draw: function() {
            var layer, bounds = this._redrawBounds;
            this._ctx.save();
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.beginPath();
                this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
                this._ctx.clip();
            }
            this._drawing = true;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (!bounds || layer._pxBounds && layer._pxBounds.intersects(bounds)) layer._updatePath();
            }
            this._drawing = false;
            this._ctx.restore(); // Restore state before clipping.
        },
        _updatePoly: function(layer, closed) {
            if (!this._drawing) return;
            var i, j, len2, p, parts = layer._parts, len = parts.length, ctx = this._ctx;
            if (!len) return;
            ctx.beginPath();
            for(i = 0; i < len; i++){
                for(j = 0, len2 = parts[i].length; j < len2; j++){
                    p = parts[i][j];
                    ctx[j ? 'lineTo' : 'moveTo'](p.x, p.y);
                }
                if (closed) ctx.closePath();
            }
            this._fillStroke(ctx, layer);
        // TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
        },
        _updateCircle: function(layer) {
            if (!this._drawing || layer._empty()) return;
            var p = layer._point, ctx = this._ctx, r = Math.max(Math.round(layer._radius), 1), s = (Math.max(Math.round(layer._radiusY), 1) || r) / r;
            if (s !== 1) {
                ctx.save();
                ctx.scale(1, s);
            }
            ctx.beginPath();
            ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);
            if (s !== 1) ctx.restore();
            this._fillStroke(ctx, layer);
        },
        _fillStroke: function(ctx, layer) {
            var options = layer.options;
            if (options.fill) {
                ctx.globalAlpha = options.fillOpacity;
                ctx.fillStyle = options.fillColor || options.color;
                ctx.fill(options.fillRule || 'evenodd');
            }
            if (options.stroke && options.weight !== 0) {
                if (ctx.setLineDash) ctx.setLineDash(layer.options && layer.options._dashArray || []);
                ctx.globalAlpha = options.opacity;
                ctx.lineWidth = options.weight;
                ctx.strokeStyle = options.color;
                ctx.lineCap = options.lineCap;
                ctx.lineJoin = options.lineJoin;
                ctx.stroke();
            }
        },
        // Canvas obviously doesn't have mouse events for individual drawn objects,
        // so we emulate that by calculating what's under the mouse on mousemove/click manually
        _onClick: function(e) {
            var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) {
                    if (!(e.type === 'click' || e.type === 'preclick') || !this._map._draggableMoved(layer)) clickedLayer = layer;
                }
            }
            this._fireEvent(clickedLayer ? [
                clickedLayer
            ] : false, e);
        },
        _onMouseMove: function(e) {
            if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) return;
            var point = this._map.mouseEventToLayerPoint(e);
            this._handleMouseHover(e, point);
        },
        _handleMouseOut: function(e) {
            var layer = this._hoveredLayer;
            if (layer) {
                // if we're leaving the layer, fire mouseout
                removeClass(this._container, 'leaflet-interactive');
                this._fireEvent([
                    layer
                ], e, 'mouseout');
                this._hoveredLayer = null;
                this._mouseHoverThrottled = false;
            }
        },
        _handleMouseHover: function(e, point) {
            if (this._mouseHoverThrottled) return;
            var layer, candidateHoveredLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) candidateHoveredLayer = layer;
            }
            if (candidateHoveredLayer !== this._hoveredLayer) {
                this._handleMouseOut(e);
                if (candidateHoveredLayer) {
                    addClass(this._container, 'leaflet-interactive'); // change cursor
                    this._fireEvent([
                        candidateHoveredLayer
                    ], e, 'mouseover');
                    this._hoveredLayer = candidateHoveredLayer;
                }
            }
            this._fireEvent(this._hoveredLayer ? [
                this._hoveredLayer
            ] : false, e);
            this._mouseHoverThrottled = true;
            setTimeout(bind(function() {
                this._mouseHoverThrottled = false;
            }, this), 32);
        },
        _fireEvent: function(layers, e, type) {
            this._map._fireDOMEvent(e, type || e.type, layers);
        },
        _bringToFront: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else // Already last
            return;
            if (prev) prev.next = next;
            else if (next) // Update first entry unless this is the
            // single entry
            this._drawFirst = next;
            order.prev = this._drawLast;
            this._drawLast.next = order;
            order.next = null;
            this._drawLast = order;
            this._requestRedraw(layer);
        },
        _bringToBack: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (prev) prev.next = next;
            else // Already first
            return;
            if (next) next.prev = prev;
            else if (prev) // Update last entry unless this is the
            // single entry
            this._drawLast = prev;
            order.prev = null;
            order.next = this._drawFirst;
            this._drawFirst.prev = order;
            this._drawFirst = order;
            this._requestRedraw(layer);
        }
    });
    // @factory L.canvas(options?: Renderer options)
    // Creates a Canvas renderer with the given options.
    function canvas(options) {
        return Browser.canvas ? new Canvas(options) : null;
    }
    /*
   * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
   */ var vmlCreate = function() {
        try {
            document.namespaces.add('lvml', 'urn:schemas-microsoft-com:vml');
            return function(name) {
                return document.createElement('<lvml:' + name + ' class="lvml">');
            };
        } catch (e) {
        // Do not return fn from catch block so `e` can be garbage collected
        // See https://github.com/Leaflet/Leaflet/pull/7279
        }
        return function(name) {
            return document.createElement('<' + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
        };
    }();
    /*
   * @class SVG
   *
   *
   * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
   * with old versions of Internet Explorer.
   */ // mixin to redefine some SVG methods to handle VML syntax which is similar but with some differences
    var vmlMixin = {
        _initContainer: function() {
            this._container = create$1('div', 'leaflet-vml-container');
        },
        _update: function() {
            if (this._map._animatingZoom) return;
            Renderer.prototype._update.call(this);
            this.fire('update');
        },
        _initPath: function(layer) {
            var container = layer._container = vmlCreate('shape');
            addClass(container, 'leaflet-vml-shape ' + (this.options.className || ''));
            container.coordsize = '1 1';
            layer._path = vmlCreate('path');
            container.appendChild(layer._path);
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            var container = layer._container;
            this._container.appendChild(container);
            if (layer.options.interactive) layer.addInteractiveTarget(container);
        },
        _removePath: function(layer) {
            var container = layer._container;
            remove(container);
            layer.removeInteractiveTarget(container);
            delete this._layers[stamp(layer)];
        },
        _updateStyle: function(layer) {
            var stroke = layer._stroke, fill = layer._fill, options = layer.options, container = layer._container;
            container.stroked = !!options.stroke;
            container.filled = !!options.fill;
            if (options.stroke) {
                if (!stroke) stroke = layer._stroke = vmlCreate('stroke');
                container.appendChild(stroke);
                stroke.weight = options.weight + 'px';
                stroke.color = options.color;
                stroke.opacity = options.opacity;
                if (options.dashArray) stroke.dashStyle = isArray(options.dashArray) ? options.dashArray.join(' ') : options.dashArray.replace(/( *, *)/g, ' ');
                else stroke.dashStyle = '';
                stroke.endcap = options.lineCap.replace('butt', 'flat');
                stroke.joinstyle = options.lineJoin;
            } else if (stroke) {
                container.removeChild(stroke);
                layer._stroke = null;
            }
            if (options.fill) {
                if (!fill) fill = layer._fill = vmlCreate('fill');
                container.appendChild(fill);
                fill.color = options.fillColor || options.color;
                fill.opacity = options.fillOpacity;
            } else if (fill) {
                container.removeChild(fill);
                layer._fill = null;
            }
        },
        _updateCircle: function(layer) {
            var p = layer._point.round(), r = Math.round(layer._radius), r2 = Math.round(layer._radiusY || r);
            this._setPath(layer, layer._empty() ? 'M0 0' : 'AL ' + p.x + ',' + p.y + ' ' + r + ',' + r2 + ' 0,' + 23592600);
        },
        _setPath: function(layer, path) {
            layer._path.v = path;
        },
        _bringToFront: function(layer) {
            toFront(layer._container);
        },
        _bringToBack: function(layer) {
            toBack(layer._container);
        }
    };
    var create = Browser.vml ? vmlCreate : svgCreate;
    /*
   * @class SVG
   * @inherits Renderer
   * @aka L.SVG
   *
   * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/svg), SVG is not
   * available in all web browsers, notably Android 2.x and 3.x.
   *
   * Although SVG is not available on IE7 and IE8, these browsers support
   * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
   * (a now deprecated technology), and the SVG renderer will fall back to VML in
   * this case.
   *
   * @example
   *
   * Use SVG by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.svg()
   * });
   * ```
   *
   * Use a SVG renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.svg({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var SVG = Renderer.extend({
        _initContainer: function() {
            this._container = create('svg');
            // makes it possible to click through svg root; we'll reset it back in individual paths
            this._container.setAttribute('pointer-events', 'none');
            this._rootGroup = create('g');
            this._container.appendChild(this._rootGroup);
        },
        _destroyContainer: function() {
            remove(this._container);
            off(this._container);
            delete this._container;
            delete this._rootGroup;
            delete this._svgSize;
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, size = b.getSize(), container = this._container;
            // set size of svg-container if changed
            if (!this._svgSize || !this._svgSize.equals(size)) {
                this._svgSize = size;
                container.setAttribute('width', size.x);
                container.setAttribute('height', size.y);
            }
            // movement: update container viewBox so that we don't have to change coordinates of individual layers
            setPosition(container, b.min);
            container.setAttribute('viewBox', [
                b.min.x,
                b.min.y,
                size.x,
                size.y
            ].join(' '));
            this.fire('update');
        },
        // methods below are called by vector layers implementations
        _initPath: function(layer) {
            var path = layer._path = create('path');
            // @namespace Path
            // @option className: String = null
            // Custom class name set on an element. Only for SVG renderer.
            if (layer.options.className) addClass(path, layer.options.className);
            if (layer.options.interactive) addClass(path, 'leaflet-interactive');
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            if (!this._rootGroup) this._initContainer();
            this._rootGroup.appendChild(layer._path);
            layer.addInteractiveTarget(layer._path);
        },
        _removePath: function(layer) {
            remove(layer._path);
            layer.removeInteractiveTarget(layer._path);
            delete this._layers[stamp(layer)];
        },
        _updatePath: function(layer) {
            layer._project();
            layer._update();
        },
        _updateStyle: function(layer) {
            var path = layer._path, options = layer.options;
            if (!path) return;
            if (options.stroke) {
                path.setAttribute('stroke', options.color);
                path.setAttribute('stroke-opacity', options.opacity);
                path.setAttribute('stroke-width', options.weight);
                path.setAttribute('stroke-linecap', options.lineCap);
                path.setAttribute('stroke-linejoin', options.lineJoin);
                if (options.dashArray) path.setAttribute('stroke-dasharray', options.dashArray);
                else path.removeAttribute('stroke-dasharray');
                if (options.dashOffset) path.setAttribute('stroke-dashoffset', options.dashOffset);
                else path.removeAttribute('stroke-dashoffset');
            } else path.setAttribute('stroke', 'none');
            if (options.fill) {
                path.setAttribute('fill', options.fillColor || options.color);
                path.setAttribute('fill-opacity', options.fillOpacity);
                path.setAttribute('fill-rule', options.fillRule || 'evenodd');
            } else path.setAttribute('fill', 'none');
        },
        _updatePoly: function(layer, closed) {
            this._setPath(layer, pointsToPath(layer._parts, closed));
        },
        _updateCircle: function(layer) {
            var p = layer._point, r = Math.max(Math.round(layer._radius), 1), r2 = Math.max(Math.round(layer._radiusY), 1) || r, arc = 'a' + r + ',' + r2 + ' 0 1,0 ';
            // drawing a circle with two half-arcs
            var d = layer._empty() ? 'M0 0' : 'M' + (p.x - r) + ',' + p.y + arc + r * 2 + ',0 ' + arc + -r * 2 + ',0 ';
            this._setPath(layer, d);
        },
        _setPath: function(layer, path) {
            layer._path.setAttribute('d', path);
        },
        // SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
        _bringToFront: function(layer) {
            toFront(layer._path);
        },
        _bringToBack: function(layer) {
            toBack(layer._path);
        }
    });
    if (Browser.vml) SVG.include(vmlMixin);
    // @namespace SVG
    // @factory L.svg(options?: Renderer options)
    // Creates a SVG renderer with the given options.
    function svg(options) {
        return Browser.svg || Browser.vml ? new SVG(options) : null;
    }
    Map.include({
        // @namespace Map; @method getRenderer(layer: Path): Renderer
        // Returns the instance of `Renderer` that should be used to render the given
        // `Path`. It will ensure that the `renderer` options of the map and paths
        // are respected, and that the renderers do exist on the map.
        getRenderer: function(layer) {
            // @namespace Path; @option renderer: Renderer
            // Use this specific instance of `Renderer` for this path. Takes
            // precedence over the map's [default renderer](#map-renderer).
            var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
            if (!renderer) renderer = this._renderer = this._createRenderer();
            if (!this.hasLayer(renderer)) this.addLayer(renderer);
            return renderer;
        },
        _getPaneRenderer: function(name) {
            if (name === 'overlayPane' || name === undefined) return false;
            var renderer = this._paneRenderers[name];
            if (renderer === undefined) {
                renderer = this._createRenderer({
                    pane: name
                });
                this._paneRenderers[name] = renderer;
            }
            return renderer;
        },
        _createRenderer: function(options) {
            // @namespace Map; @option preferCanvas: Boolean = false
            // Whether `Path`s should be rendered on a `Canvas` renderer.
            // By default, all `Path`s are rendered in a `SVG` renderer.
            return this.options.preferCanvas && canvas(options) || svg(options);
        }
    });
    /*
   * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
   */ /*
   * @class Rectangle
   * @aka L.Rectangle
   * @inherits Polygon
   *
   * A class for drawing rectangle overlays on a map. Extends `Polygon`.
   *
   * @example
   *
   * ```js
   * // define rectangle geographical bounds
   * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
   *
   * // create an orange rectangle
   * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
   *
   * // zoom the map to the rectangle bounds
   * map.fitBounds(bounds);
   * ```
   *
   */ var Rectangle = Polygon.extend({
        initialize: function(latLngBounds, options) {
            Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
        },
        // @method setBounds(latLngBounds: LatLngBounds): this
        // Redraws the rectangle with the passed bounds.
        setBounds: function(latLngBounds) {
            return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
        },
        _boundsToLatLngs: function(latLngBounds) {
            latLngBounds = toLatLngBounds(latLngBounds);
            return [
                latLngBounds.getSouthWest(),
                latLngBounds.getNorthWest(),
                latLngBounds.getNorthEast(),
                latLngBounds.getSouthEast()
            ];
        }
    });
    // @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
    function rectangle(latLngBounds, options) {
        return new Rectangle(latLngBounds, options);
    }
    SVG.create = create;
    SVG.pointsToPath = pointsToPath;
    GeoJSON.geometryToLayer = geometryToLayer;
    GeoJSON.coordsToLatLng = coordsToLatLng;
    GeoJSON.coordsToLatLngs = coordsToLatLngs;
    GeoJSON.latLngToCoords = latLngToCoords;
    GeoJSON.latLngsToCoords = latLngsToCoords;
    GeoJSON.getFeature = getFeature;
    GeoJSON.asFeature = asFeature;
    /*
   * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
   * (zoom to a selected bounding box), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option boxZoom: Boolean = true
        // Whether the map can be zoomed to a rectangular area specified by
        // dragging the mouse while pressing the shift key.
        boxZoom: true
    });
    var BoxZoom = Handler.extend({
        initialize: function(map) {
            this._map = map;
            this._container = map._container;
            this._pane = map._panes.overlayPane;
            this._resetStateTimeout = 0;
            map.on('unload', this._destroy, this);
        },
        addHooks: function() {
            on(this._container, 'mousedown', this._onMouseDown, this);
        },
        removeHooks: function() {
            off(this._container, 'mousedown', this._onMouseDown, this);
        },
        moved: function() {
            return this._moved;
        },
        _destroy: function() {
            remove(this._pane);
            delete this._pane;
        },
        _resetState: function() {
            this._resetStateTimeout = 0;
            this._moved = false;
        },
        _clearDeferredResetState: function() {
            if (this._resetStateTimeout !== 0) {
                clearTimeout(this._resetStateTimeout);
                this._resetStateTimeout = 0;
            }
        },
        _onMouseDown: function(e) {
            if (!e.shiftKey || e.which !== 1 && e.button !== 1) return false;
            // Clear the deferred resetState if it hasn't executed yet, otherwise it
            // will interrupt the interaction and orphan a box element in the container.
            this._clearDeferredResetState();
            this._resetState();
            disableTextSelection();
            disableImageDrag();
            this._startPoint = this._map.mouseEventToContainerPoint(e);
            on(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseMove: function(e) {
            if (!this._moved) {
                this._moved = true;
                this._box = create$1('div', 'leaflet-zoom-box', this._container);
                addClass(this._container, 'leaflet-crosshair');
                this._map.fire('boxzoomstart');
            }
            this._point = this._map.mouseEventToContainerPoint(e);
            var bounds = new Bounds(this._point, this._startPoint), size = bounds.getSize();
            setPosition(this._box, bounds.min);
            this._box.style.width = size.x + 'px';
            this._box.style.height = size.y + 'px';
        },
        _finish: function() {
            if (this._moved) {
                remove(this._box);
                removeClass(this._container, 'leaflet-crosshair');
            }
            enableTextSelection();
            enableImageDrag();
            off(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseUp: function(e) {
            if (e.which !== 1 && e.button !== 1) return;
            this._finish();
            if (!this._moved) return;
            // Postpone to next JS tick so internal click event handling
            // still see it as "moved".
            this._clearDeferredResetState();
            this._resetStateTimeout = setTimeout(bind(this._resetState, this), 0);
            var bounds = new LatLngBounds(this._map.containerPointToLatLng(this._startPoint), this._map.containerPointToLatLng(this._point));
            this._map.fitBounds(bounds).fire('boxzoomend', {
                boxZoomBounds: bounds
            });
        },
        _onKeyDown: function(e) {
            if (e.keyCode === 27) {
                this._finish();
                this._clearDeferredResetState();
                this._resetState();
            }
        }
    });
    // @section Handlers
    // @property boxZoom: Handler
    // Box (shift-drag with mouse) zoom handler.
    Map.addInitHook('addHandler', 'boxZoom', BoxZoom);
    /*
   * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option doubleClickZoom: Boolean|String = true
        // Whether the map can be zoomed in by double clicking on it and
        // zoomed out by double clicking while holding shift. If passed
        // `'center'`, double-click zoom will zoom to the center of the
        //  view regardless of where the mouse was.
        doubleClickZoom: true
    });
    var DoubleClickZoom = Handler.extend({
        addHooks: function() {
            this._map.on('dblclick', this._onDoubleClick, this);
        },
        removeHooks: function() {
            this._map.off('dblclick', this._onDoubleClick, this);
        },
        _onDoubleClick: function(e) {
            var map = this._map, oldZoom = map.getZoom(), delta = map.options.zoomDelta, zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
            if (map.options.doubleClickZoom === 'center') map.setZoom(zoom);
            else map.setZoomAround(e.containerPoint, zoom);
        }
    });
    // @section Handlers
    //
    // Map properties include interaction handlers that allow you to control
    // interaction behavior in runtime, enabling or disabling certain features such
    // as dragging or touch zoom (see `Handler` methods). For example:
    //
    // ```js
    // map.doubleClickZoom.disable();
    // ```
    //
    // @property doubleClickZoom: Handler
    // Double click zoom handler.
    Map.addInitHook('addHandler', 'doubleClickZoom', DoubleClickZoom);
    /*
   * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option dragging: Boolean = true
        // Whether the map is draggable with mouse/touch or not.
        dragging: true,
        // @section Panning Inertia Options
        // @option inertia: Boolean = *
        // If enabled, panning of the map will have an inertia effect where
        // the map builds momentum while dragging and continues moving in
        // the same direction for some time. Feels especially nice on touch
        // devices. Enabled by default.
        inertia: true,
        // @option inertiaDeceleration: Number = 3000
        // The rate with which the inertial movement slows down, in pixels/second².
        inertiaDeceleration: 3400,
        // @option inertiaMaxSpeed: Number = Infinity
        // Max speed of the inertial movement, in pixels/second.
        inertiaMaxSpeed: Infinity,
        // @option easeLinearity: Number = 0.2
        easeLinearity: 0.2,
        // TODO refactor, move to CRS
        // @option worldCopyJump: Boolean = false
        // With this option enabled, the map tracks when you pan to another "copy"
        // of the world and seamlessly jumps to the original one so that all overlays
        // like markers and vector layers are still visible.
        worldCopyJump: false,
        // @option maxBoundsViscosity: Number = 0.0
        // If `maxBounds` is set, this option will control how solid the bounds
        // are when dragging the map around. The default value of `0.0` allows the
        // user to drag outside the bounds at normal speed, higher values will
        // slow down map dragging outside bounds, and `1.0` makes the bounds fully
        // solid, preventing the user from dragging outside the bounds.
        maxBoundsViscosity: 0.0
    });
    var Drag = Handler.extend({
        addHooks: function() {
            if (!this._draggable) {
                var map = this._map;
                this._draggable = new Draggable(map._mapPane, map._container);
                this._draggable.on({
                    dragstart: this._onDragStart,
                    drag: this._onDrag,
                    dragend: this._onDragEnd
                }, this);
                this._draggable.on('predrag', this._onPreDragLimit, this);
                if (map.options.worldCopyJump) {
                    this._draggable.on('predrag', this._onPreDragWrap, this);
                    map.on('zoomend', this._onZoomEnd, this);
                    map.whenReady(this._onZoomEnd, this);
                }
            }
            addClass(this._map._container, 'leaflet-grab leaflet-touch-drag');
            this._draggable.enable();
            this._positions = [];
            this._times = [];
        },
        removeHooks: function() {
            removeClass(this._map._container, 'leaflet-grab');
            removeClass(this._map._container, 'leaflet-touch-drag');
            this._draggable.disable();
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        moving: function() {
            return this._draggable && this._draggable._moving;
        },
        _onDragStart: function() {
            var map = this._map;
            map._stop();
            if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
                var bounds = toLatLngBounds(this._map.options.maxBounds);
                this._offsetLimit = toBounds(this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1), this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1).add(this._map.getSize()));
                this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
            } else this._offsetLimit = null;
            map.fire('movestart').fire('dragstart');
            if (map.options.inertia) {
                this._positions = [];
                this._times = [];
            }
        },
        _onDrag: function(e) {
            if (this._map.options.inertia) {
                var time = this._lastTime = +new Date(), pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
                this._positions.push(pos);
                this._times.push(time);
                this._prunePositions(time);
            }
            this._map.fire('move', e).fire('drag', e);
        },
        _prunePositions: function(time) {
            while(this._positions.length > 1 && time - this._times[0] > 50){
                this._positions.shift();
                this._times.shift();
            }
        },
        _onZoomEnd: function() {
            var pxCenter = this._map.getSize().divideBy(2), pxWorldCenter = this._map.latLngToLayerPoint([
                0,
                0
            ]);
            this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
            this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
        },
        _viscousLimit: function(value, threshold) {
            return value - (value - threshold) * this._viscosity;
        },
        _onPreDragLimit: function() {
            if (!this._viscosity || !this._offsetLimit) return;
            var offset = this._draggable._newPos.subtract(this._draggable._startPos);
            var limit = this._offsetLimit;
            if (offset.x < limit.min.x) offset.x = this._viscousLimit(offset.x, limit.min.x);
            if (offset.y < limit.min.y) offset.y = this._viscousLimit(offset.y, limit.min.y);
            if (offset.x > limit.max.x) offset.x = this._viscousLimit(offset.x, limit.max.x);
            if (offset.y > limit.max.y) offset.y = this._viscousLimit(offset.y, limit.max.y);
            this._draggable._newPos = this._draggable._startPos.add(offset);
        },
        _onPreDragWrap: function() {
            // TODO refactor to be able to adjust map pane position after zoom
            var worldWidth = this._worldWidth, halfWidth = Math.round(worldWidth / 2), dx = this._initialWorldOffset, x = this._draggable._newPos.x, newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx, newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx, newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
            this._draggable._absPos = this._draggable._newPos.clone();
            this._draggable._newPos.x = newX;
        },
        _onDragEnd: function(e) {
            var map = this._map, options = map.options, noInertia = !options.inertia || e.noInertia || this._times.length < 2;
            map.fire('dragend', e);
            if (noInertia) map.fire('moveend');
            else {
                this._prunePositions(+new Date());
                var direction = this._lastPos.subtract(this._positions[0]), duration = (this._lastTime - this._times[0]) / 1000, ease = options.easeLinearity, speedVector = direction.multiplyBy(ease / duration), speed = speedVector.distanceTo([
                    0,
                    0
                ]), limitedSpeed = Math.min(options.inertiaMaxSpeed, speed), limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed), decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease), offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
                if (!offset.x && !offset.y) map.fire('moveend');
                else {
                    offset = map._limitOffset(offset, map.options.maxBounds);
                    requestAnimFrame(function() {
                        map.panBy(offset, {
                            duration: decelerationDuration,
                            easeLinearity: ease,
                            noMoveStart: true,
                            animate: true
                        });
                    });
                }
            }
        }
    });
    // @section Handlers
    // @property dragging: Handler
    // Map dragging handler (by both mouse and touch).
    Map.addInitHook('addHandler', 'dragging', Drag);
    /*
   * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
   */ // @namespace Map
    // @section Keyboard Navigation Options
    Map.mergeOptions({
        // @option keyboard: Boolean = true
        // Makes the map focusable and allows users to navigate the map with keyboard
        // arrows and `+`/`-` keys.
        keyboard: true,
        // @option keyboardPanDelta: Number = 80
        // Amount of pixels to pan when pressing an arrow key.
        keyboardPanDelta: 80
    });
    var Keyboard = Handler.extend({
        keyCodes: {
            left: [
                37
            ],
            right: [
                39
            ],
            down: [
                40
            ],
            up: [
                38
            ],
            zoomIn: [
                187,
                107,
                61,
                171
            ],
            zoomOut: [
                189,
                109,
                54,
                173
            ]
        },
        initialize: function(map) {
            this._map = map;
            this._setPanDelta(map.options.keyboardPanDelta);
            this._setZoomDelta(map.options.zoomDelta);
        },
        addHooks: function() {
            var container = this._map._container;
            // make the container focusable by tabbing
            if (container.tabIndex <= 0) container.tabIndex = '0';
            on(container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.on({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        removeHooks: function() {
            this._removeHooks();
            off(this._map._container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.off({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        _onMouseDown: function() {
            if (this._focused) return;
            var body = document.body, docEl = document.documentElement, top = body.scrollTop || docEl.scrollTop, left = body.scrollLeft || docEl.scrollLeft;
            this._map._container.focus();
            window.scrollTo(left, top);
        },
        _onFocus: function() {
            this._focused = true;
            this._map.fire('focus');
        },
        _onBlur: function() {
            this._focused = false;
            this._map.fire('blur');
        },
        _setPanDelta: function(panDelta) {
            var keys = this._panKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.left.length; i < len; i++)keys[codes.left[i]] = [
                -1 * panDelta,
                0
            ];
            for(i = 0, len = codes.right.length; i < len; i++)keys[codes.right[i]] = [
                panDelta,
                0
            ];
            for(i = 0, len = codes.down.length; i < len; i++)keys[codes.down[i]] = [
                0,
                panDelta
            ];
            for(i = 0, len = codes.up.length; i < len; i++)keys[codes.up[i]] = [
                0,
                -1 * panDelta
            ];
        },
        _setZoomDelta: function(zoomDelta) {
            var keys = this._zoomKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.zoomIn.length; i < len; i++)keys[codes.zoomIn[i]] = zoomDelta;
            for(i = 0, len = codes.zoomOut.length; i < len; i++)keys[codes.zoomOut[i]] = -zoomDelta;
        },
        _addHooks: function() {
            on(document, 'keydown', this._onKeyDown, this);
        },
        _removeHooks: function() {
            off(document, 'keydown', this._onKeyDown, this);
        },
        _onKeyDown: function(e) {
            if (e.altKey || e.ctrlKey || e.metaKey) return;
            var key = e.keyCode, map = this._map, offset;
            if (key in this._panKeys) {
                if (!map._panAnim || !map._panAnim._inProgress) {
                    offset = this._panKeys[key];
                    if (e.shiftKey) offset = toPoint(offset).multiplyBy(3);
                    if (map.options.maxBounds) offset = map._limitOffset(toPoint(offset), map.options.maxBounds);
                    if (map.options.worldCopyJump) {
                        var newLatLng = map.wrapLatLng(map.unproject(map.project(map.getCenter()).add(offset)));
                        map.panTo(newLatLng);
                    } else map.panBy(offset);
                }
            } else if (key in this._zoomKeys) map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
            else if (key === 27 && map._popup && map._popup.options.closeOnEscapeKey) map.closePopup();
            else return;
            stop(e);
        }
    });
    // @section Handlers
    // @section Handlers
    // @property keyboard: Handler
    // Keyboard navigation handler.
    Map.addInitHook('addHandler', 'keyboard', Keyboard);
    /*
   * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Mouse wheel options
        // @option scrollWheelZoom: Boolean|String = true
        // Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
        // it will zoom to the center of the view regardless of where the mouse was.
        scrollWheelZoom: true,
        // @option wheelDebounceTime: Number = 40
        // Limits the rate at which a wheel can fire (in milliseconds). By default
        // user can't zoom via wheel more often than once per 40 ms.
        wheelDebounceTime: 40,
        // @option wheelPxPerZoomLevel: Number = 60
        // How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
        // mean a change of one full zoom level. Smaller values will make wheel-zooming
        // faster (and vice versa).
        wheelPxPerZoomLevel: 60
    });
    var ScrollWheelZoom = Handler.extend({
        addHooks: function() {
            on(this._map._container, 'wheel', this._onWheelScroll, this);
            this._delta = 0;
        },
        removeHooks: function() {
            off(this._map._container, 'wheel', this._onWheelScroll, this);
        },
        _onWheelScroll: function(e) {
            var delta = getWheelDelta(e);
            var debounce = this._map.options.wheelDebounceTime;
            this._delta += delta;
            this._lastMousePos = this._map.mouseEventToContainerPoint(e);
            if (!this._startTime) this._startTime = +new Date();
            var left = Math.max(debounce - (+new Date() - this._startTime), 0);
            clearTimeout(this._timer);
            this._timer = setTimeout(bind(this._performZoom, this), left);
            stop(e);
        },
        _performZoom: function() {
            var map = this._map, zoom = map.getZoom(), snap = this._map.options.zoomSnap || 0;
            map._stop(); // stop panning and fly animations if any
            // map the delta with a sigmoid function to -4..4 range leaning on -1..1
            var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4), d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2, d4 = snap ? Math.ceil(d3 / snap) * snap : d3, delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;
            this._delta = 0;
            this._startTime = null;
            if (!delta) return;
            if (map.options.scrollWheelZoom === 'center') map.setZoom(zoom + delta);
            else map.setZoomAround(this._lastMousePos, zoom + delta);
        }
    });
    // @section Handlers
    // @property scrollWheelZoom: Handler
    // Scroll wheel zoom handler.
    Map.addInitHook('addHandler', 'scrollWheelZoom', ScrollWheelZoom);
    /*
   * L.Map.TapHold is used to simulate `contextmenu` event on long hold,
   * which otherwise is not fired by mobile Safari.
   */ var tapHoldDelay = 600;
    // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option tapHold: Boolean
        // Enables simulation of `contextmenu` event, default is `true` for mobile Safari.
        tapHold: Browser.touchNative && Browser.safari && Browser.mobile,
        // @option tapTolerance: Number = 15
        // The max number of pixels a user can shift his finger during touch
        // for it to be considered a valid tap.
        tapTolerance: 15
    });
    var TapHold = Handler.extend({
        addHooks: function() {
            on(this._map._container, 'touchstart', this._onDown, this);
        },
        removeHooks: function() {
            off(this._map._container, 'touchstart', this._onDown, this);
        },
        _onDown: function(e) {
            clearTimeout(this._holdTimeout);
            if (e.touches.length !== 1) return;
            var first = e.touches[0];
            this._startPos = this._newPos = new Point(first.clientX, first.clientY);
            this._holdTimeout = setTimeout(bind(function() {
                this._cancel();
                if (!this._isTapValid()) return;
                // prevent simulated mouse events https://w3c.github.io/touch-events/#mouse-events
                on(document, 'touchend', preventDefault);
                on(document, 'touchend touchcancel', this._cancelClickPrevent);
                this._simulateEvent('contextmenu', first);
            }, this), tapHoldDelay);
            on(document, 'touchend touchcancel contextmenu', this._cancel, this);
            on(document, 'touchmove', this._onMove, this);
        },
        _cancelClickPrevent: function cancelClickPrevent() {
            off(document, 'touchend', preventDefault);
            off(document, 'touchend touchcancel', cancelClickPrevent);
        },
        _cancel: function() {
            clearTimeout(this._holdTimeout);
            off(document, 'touchend touchcancel contextmenu', this._cancel, this);
            off(document, 'touchmove', this._onMove, this);
        },
        _onMove: function(e) {
            var first = e.touches[0];
            this._newPos = new Point(first.clientX, first.clientY);
        },
        _isTapValid: function() {
            return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
        },
        _simulateEvent: function(type, e) {
            var simulatedEvent = new MouseEvent(type, {
                bubbles: true,
                cancelable: true,
                view: window,
                // detail: 1,
                screenX: e.screenX,
                screenY: e.screenY,
                clientX: e.clientX,
                clientY: e.clientY
            });
            simulatedEvent._simulated = true;
            e.target.dispatchEvent(simulatedEvent);
        }
    });
    // @section Handlers
    // @property tapHold: Handler
    // Long tap handler to simulate `contextmenu` event (useful in mobile Safari).
    Map.addInitHook('addHandler', 'tapHold', TapHold);
    /*
   * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option touchZoom: Boolean|String = *
        // Whether the map can be zoomed by touch-dragging with two fingers. If
        // passed `'center'`, it will zoom to the center of the view regardless of
        // where the touch events (fingers) were. Enabled for touch-capable web
        // browsers.
        touchZoom: Browser.touch,
        // @option bounceAtZoomLimits: Boolean = true
        // Set it to false if you don't want the map to zoom beyond min/max zoom
        // and then bounce back when pinch-zooming.
        bounceAtZoomLimits: true
    });
    var TouchZoom = Handler.extend({
        addHooks: function() {
            addClass(this._map._container, 'leaflet-touch-zoom');
            on(this._map._container, 'touchstart', this._onTouchStart, this);
        },
        removeHooks: function() {
            removeClass(this._map._container, 'leaflet-touch-zoom');
            off(this._map._container, 'touchstart', this._onTouchStart, this);
        },
        _onTouchStart: function(e) {
            var map = this._map;
            if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) return;
            var p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]);
            this._centerPoint = map.getSize()._divideBy(2);
            this._startLatLng = map.containerPointToLatLng(this._centerPoint);
            if (map.options.touchZoom !== 'center') this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
            this._startDist = p1.distanceTo(p2);
            this._startZoom = map.getZoom();
            this._moved = false;
            this._zooming = true;
            map._stop();
            on(document, 'touchmove', this._onTouchMove, this);
            on(document, 'touchend touchcancel', this._onTouchEnd, this);
            preventDefault(e);
        },
        _onTouchMove: function(e) {
            if (!e.touches || e.touches.length !== 2 || !this._zooming) return;
            var map = this._map, p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]), scale = p1.distanceTo(p2) / this._startDist;
            this._zoom = map.getScaleZoom(scale, this._startZoom);
            if (!map.options.bounceAtZoomLimits && (this._zoom < map.getMinZoom() && scale < 1 || this._zoom > map.getMaxZoom() && scale > 1)) this._zoom = map._limitZoom(this._zoom);
            if (map.options.touchZoom === 'center') {
                this._center = this._startLatLng;
                if (scale === 1) return;
            } else {
                // Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
                var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
                if (scale === 1 && delta.x === 0 && delta.y === 0) return;
                this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
            }
            if (!this._moved) {
                map._moveStart(true, false);
                this._moved = true;
            }
            cancelAnimFrame(this._animRequest);
            var moveFn = bind(map._move, map, this._center, this._zoom, {
                pinch: true,
                round: false
            }, undefined);
            this._animRequest = requestAnimFrame(moveFn, this, true);
            preventDefault(e);
        },
        _onTouchEnd: function() {
            if (!this._moved || !this._zooming) {
                this._zooming = false;
                return;
            }
            this._zooming = false;
            cancelAnimFrame(this._animRequest);
            off(document, 'touchmove', this._onTouchMove, this);
            off(document, 'touchend touchcancel', this._onTouchEnd, this);
            // Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
            if (this._map.options.zoomAnimation) this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
            else this._map._resetView(this._center, this._map._limitZoom(this._zoom));
        }
    });
    // @section Handlers
    // @property touchZoom: Handler
    // Touch zoom handler.
    Map.addInitHook('addHandler', 'touchZoom', TouchZoom);
    Map.BoxZoom = BoxZoom;
    Map.DoubleClickZoom = DoubleClickZoom;
    Map.Drag = Drag;
    Map.Keyboard = Keyboard;
    Map.ScrollWheelZoom = ScrollWheelZoom;
    Map.TapHold = TapHold;
    Map.TouchZoom = TouchZoom;
    exports1.Bounds = Bounds;
    exports1.Browser = Browser;
    exports1.CRS = CRS;
    exports1.Canvas = Canvas;
    exports1.Circle = Circle;
    exports1.CircleMarker = CircleMarker;
    exports1.Class = Class;
    exports1.Control = Control;
    exports1.DivIcon = DivIcon;
    exports1.DivOverlay = DivOverlay;
    exports1.DomEvent = DomEvent;
    exports1.DomUtil = DomUtil;
    exports1.Draggable = Draggable;
    exports1.Evented = Evented;
    exports1.FeatureGroup = FeatureGroup;
    exports1.GeoJSON = GeoJSON;
    exports1.GridLayer = GridLayer;
    exports1.Handler = Handler;
    exports1.Icon = Icon;
    exports1.ImageOverlay = ImageOverlay;
    exports1.LatLng = LatLng;
    exports1.LatLngBounds = LatLngBounds;
    exports1.Layer = Layer;
    exports1.LayerGroup = LayerGroup;
    exports1.LineUtil = LineUtil;
    exports1.Map = Map;
    exports1.Marker = Marker;
    exports1.Mixin = Mixin;
    exports1.Path = Path;
    exports1.Point = Point;
    exports1.PolyUtil = PolyUtil;
    exports1.Polygon = Polygon;
    exports1.Polyline = Polyline;
    exports1.Popup = Popup;
    exports1.PosAnimation = PosAnimation;
    exports1.Projection = index;
    exports1.Rectangle = Rectangle;
    exports1.Renderer = Renderer;
    exports1.SVG = SVG;
    exports1.SVGOverlay = SVGOverlay;
    exports1.TileLayer = TileLayer;
    exports1.Tooltip = Tooltip;
    exports1.Transformation = Transformation;
    exports1.Util = Util;
    exports1.VideoOverlay = VideoOverlay;
    exports1.bind = bind;
    exports1.bounds = toBounds;
    exports1.canvas = canvas;
    exports1.circle = circle;
    exports1.circleMarker = circleMarker;
    exports1.control = control;
    exports1.divIcon = divIcon;
    exports1.extend = extend;
    exports1.featureGroup = featureGroup;
    exports1.geoJSON = geoJSON;
    exports1.geoJson = geoJson;
    exports1.gridLayer = gridLayer;
    exports1.icon = icon;
    exports1.imageOverlay = imageOverlay;
    exports1.latLng = toLatLng;
    exports1.latLngBounds = toLatLngBounds;
    exports1.layerGroup = layerGroup;
    exports1.map = createMap;
    exports1.marker = marker;
    exports1.point = toPoint;
    exports1.polygon = polygon;
    exports1.polyline = polyline;
    exports1.popup = popup;
    exports1.rectangle = rectangle;
    exports1.setOptions = setOptions;
    exports1.stamp = stamp;
    exports1.svg = svg;
    exports1.svgOverlay = svgOverlay;
    exports1.tileLayer = tileLayer;
    exports1.tooltip = tooltip;
    exports1.transformation = toTransformation;
    exports1.version = version;
    exports1.videoOverlay = videoOverlay;
    var oldL = window.L;
    exports1.noConflict = function() {
        window.L = oldL;
        return this;
    };
    // Always export us to window global (see #2364)
    window.L = exports1;
});

});

parcelRegister("ayUSI", function(module, exports) {
module.exports = import("CcPYP").then(()=>parcelRequire('jukXf'));

});

parcelRegister("8gngE", function(module, exports) {
module.exports = import("03d8G").then(()=>parcelRequire('kmLF0'));

});

parcelRegister("eRNLR", function(module, exports) {
module.exports = import("dzMri").then(()=>parcelRequire('ifOf4'));

});

parcelRegister("ebcW3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a52c207aab93bf4f$export$2e2bcd8739ae039);

var $66mQQ = parcelRequire("66mQQ");

var $38qqf = parcelRequire("38qqf");

var $iCFRA = parcelRequire("iCFRA");

var $5vTfu = parcelRequire("5vTfu");

var $ezj1P = parcelRequire("ezj1P");

var $flUkq = parcelRequire("flUkq");

var $ceNev = parcelRequire("ceNev");

var $4hMrQ = parcelRequire("4hMrQ");

var $j48cx = parcelRequire("j48cx");
/**
 * @typedef {Object} Mgrs
 * @property {(lonlat: [number, number]) => string} forward
 * @property {(mgrsString: string) => [number, number, number, number]} inverse
 * @property {(mgrsString: string) => [number, number]} toPoint
 */ /**
 * @typedef {import('./defs').ProjectionDefinition} ProjectionDefinition
 * @typedef {import('./core').TemplateCoordinates} TemplateCoordinates
 * @typedef {import('./core').InterfaceCoordinates} InterfaceCoordinates
 * @typedef {import('./core').Converter} Converter
 * @typedef {import('./Proj').DatumDefinition} DatumDefinition
 */ /**
 * @template {import('./core').TemplateCoordinates} T
 * @type {core<T> & {defaultDatum: string, Proj: typeof Proj, WGS84: Proj, Point: typeof Point, toPoint: typeof common, defs: typeof defs, nadgrid: typeof nadgrid, transform: typeof transform, mgrs: Mgrs, version: string}}
 */ const $a52c207aab93bf4f$var$proj4 = Object.assign((0, $66mQQ.default), {
    defaultDatum: 'WGS84',
    Proj: $38qqf.default,
    WGS84: new (0, $38qqf.default)('WGS84'),
    Point: $iCFRA.default,
    toPoint: (0, $5vTfu.default),
    defs: $ezj1P.default,
    nadgrid: $flUkq.default,
    transform: $ceNev.default,
    mgrs: $4hMrQ.default,
    version: '__VERSION__'
});
(0, $j48cx.default)($a52c207aab93bf4f$var$proj4);
var $a52c207aab93bf4f$export$2e2bcd8739ae039 = $a52c207aab93bf4f$var$proj4;

});
parcelRegister("66mQQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $471507637a3ff861$export$2e2bcd8739ae039);

var $38qqf = parcelRequire("38qqf");

var $ceNev = parcelRequire("ceNev");
var $471507637a3ff861$var$wgs84 = (0, $38qqf.default)('WGS84');
/**
 * @typedef {{x: number, y: number, z?: number, m?: number}} InterfaceCoordinates
 */ /**
 * @typedef {Array<number> | InterfaceCoordinates} TemplateCoordinates
 */ /**
 * @typedef {Object} Converter
 * @property {<T extends TemplateCoordinates>(coordinates: T, enforceAxis?: boolean) => T} forward
 * @property {<T extends TemplateCoordinates>(coordinates: T, enforceAxis?: boolean) => T} inverse
 * @property {proj} [oProj]
 */ /**
 * @typedef {Object} PROJJSONDefinition
 * @property {string} [$schema]
 * @property {string} type
 * @property {string} [name]
 * @property {{authority: string, code: number}} [id]
 * @property {string} [scope]
 * @property {string} [area]
 * @property {{south_latitude: number, west_longitude: number, north_latitude: number, east_longitude: number}} [bbox]
 * @property {PROJJSONDefinition[]} [components]
 * @property {{type: string, name: string}} [datum]
 * @property {{
 *   name: string,
 *   members: Array<{
 *     name: string,
 *     id?: {authority: string, code: number}
 *   }>,
 *   ellipsoid?: {
 *     name: string,
 *     semi_major_axis: number,
 *     inverse_flattening?: number
 *   },
 *   accuracy?: string,
 *   id?: {authority: string, code: number}
 * }} [datum_ensemble]
 * @property {{
 *   subtype: string,
 *   axis: Array<{
 *     name: string,
 *     abbreviation?: string,
 *     direction: string,
 *     unit: string
 *   }>
 * }} [coordinate_system]
 * @property {{
 *   name: string,
 *   method: {name: string},
 *   parameters: Array<{
 *     name: string,
 *     value: number,
 *     unit?: string
 *   }>
 * }} [conversion]
 * @property {{
 *   name: string,
 *   method: {name: string},
 *   parameters: Array<{
 *     name: string,
 *     value: number,
 *     unit?: string,
 *     type?: string,
 *     file_name?: string
 *   }>
 * }} [transformation]
 */ /**
 * @template {TemplateCoordinates} T
 * @param {proj} from
 * @param {proj} to
 * @param {T} coords
 * @param {boolean} [enforceAxis]
 * @returns {T}
 */ function $471507637a3ff861$var$transformer(from, to, coords, enforceAxis) {
    var transformedArray, out, keys;
    if (Array.isArray(coords)) {
        transformedArray = (0, $ceNev.default)(from, to, coords, enforceAxis) || {
            x: NaN,
            y: NaN
        };
        if (coords.length > 2) {
            if (typeof from.name !== 'undefined' && from.name === 'geocent' || typeof to.name !== 'undefined' && to.name === 'geocent') {
                if (typeof transformedArray.z === 'number') return /** @type {T} */ [
                    transformedArray.x,
                    transformedArray.y,
                    transformedArray.z
                ].concat(coords.slice(3));
                else return /** @type {T} */ [
                    transformedArray.x,
                    transformedArray.y,
                    coords[2]
                ].concat(coords.slice(3));
            } else return /** @type {T} */ [
                transformedArray.x,
                transformedArray.y
            ].concat(coords.slice(2));
        } else return /** @type {T} */ [
            transformedArray.x,
            transformedArray.y
        ];
    } else {
        out = (0, $ceNev.default)(from, to, coords, enforceAxis);
        keys = Object.keys(coords);
        if (keys.length === 2) return /** @type {T} */ out;
        keys.forEach(function(key) {
            if (typeof from.name !== 'undefined' && from.name === 'geocent' || typeof to.name !== 'undefined' && to.name === 'geocent') {
                if (key === 'x' || key === 'y' || key === 'z') return;
            } else {
                if (key === 'x' || key === 'y') return;
            }
            out[key] = coords[key];
        });
        return /** @type {T} */ out;
    }
}
/**
 * @param {proj | string | PROJJSONDefinition | Converter} item
 * @returns {import('./Proj').default}
 */ function $471507637a3ff861$var$checkProj(item) {
    if (item instanceof (0, $38qqf.default)) return item;
    if (typeof item === 'object' && 'oProj' in item) return item.oProj;
    return (0, $38qqf.default)(/** @type {string | PROJJSONDefinition} */ item);
}
/**
 * @overload
 * @param {string | PROJJSONDefinition | proj} toProj
 * @returns {Converter}
 */ /**
 * @overload
 * @param {string | PROJJSONDefinition | proj} fromProj
 * @param {string | PROJJSONDefinition | proj} toProj
 * @returns {Converter}
 */ /**
 * @template {TemplateCoordinates} T
 * @overload
 * @param {string | PROJJSONDefinition | proj} toProj
 * @param {T} coord
 * @returns {T}
 */ /**
 * @template {TemplateCoordinates} T
 * @overload
 * @param {string | PROJJSONDefinition | proj} fromProj
 * @param {string | PROJJSONDefinition | proj} toProj
 * @param {T} coord
 * @returns {T}
 */ /**
 * @template {TemplateCoordinates} T
 * @param {string | PROJJSONDefinition | proj} fromProjOrToProj
 * @param {string | PROJJSONDefinition | proj | TemplateCoordinates} [toProjOrCoord]
 * @param {T} [coord]
 * @returns {T|Converter}
 */ function $471507637a3ff861$var$proj4(fromProjOrToProj, toProjOrCoord, coord) {
    /** @type {proj} */ var fromProj;
    /** @type {proj} */ var toProj;
    var single = false;
    /** @type {Converter} */ var obj;
    if (typeof toProjOrCoord === 'undefined') {
        toProj = $471507637a3ff861$var$checkProj(fromProjOrToProj);
        fromProj = $471507637a3ff861$var$wgs84;
        single = true;
    } else if (typeof /** @type {?} */ toProjOrCoord.x !== 'undefined' || Array.isArray(toProjOrCoord)) {
        coord = /** @type {?} */ toProjOrCoord;
        toProj = $471507637a3ff861$var$checkProj(fromProjOrToProj);
        fromProj = $471507637a3ff861$var$wgs84;
        single = true;
    }
    if (!fromProj) fromProj = $471507637a3ff861$var$checkProj(fromProjOrToProj);
    if (!toProj) toProj = $471507637a3ff861$var$checkProj(/** @type {string | PROJJSONDefinition | proj } */ toProjOrCoord);
    if (coord) return $471507637a3ff861$var$transformer(fromProj, toProj, coord);
    else {
        obj = {
            /**
       * @template {TemplateCoordinates} T
       * @param {T} coords
       * @param {boolean=} enforceAxis
       * @returns {T}
       */ forward: function(coords, enforceAxis) {
                return $471507637a3ff861$var$transformer(fromProj, toProj, coords, enforceAxis);
            },
            /**
       * @template {TemplateCoordinates} T
       * @param {T} coords
       * @param {boolean=} enforceAxis
       * @returns {T}
       */ inverse: function(coords, enforceAxis) {
                return $471507637a3ff861$var$transformer(toProj, fromProj, coords, enforceAxis);
            }
        };
        if (single) obj.oProj = toProj;
        return obj;
    }
}
var $471507637a3ff861$export$2e2bcd8739ae039 = $471507637a3ff861$var$proj4;

});
parcelRegister("38qqf", function(module, exports) {

$parcel$export(module.exports, "default", () => $24869d6338533b3b$export$2e2bcd8739ae039);

var $giDQh = parcelRequire("giDQh");

var $cWauz = parcelRequire("cWauz");

var $1Wo5P = parcelRequire("1Wo5P");

var $d8b9d = parcelRequire("d8b9d");

var $gMdFS = parcelRequire("gMdFS");

var $3MCqb = parcelRequire("3MCqb");

var $hzXAi = parcelRequire("hzXAi");

var $flUkq = parcelRequire("flUkq");
/**
 * @typedef {Object} DatumDefinition
 * @property {number} datum_type - The type of datum.
 * @property {number} a - Semi-major axis of the ellipsoid.
 * @property {number} b - Semi-minor axis of the ellipsoid.
 * @property {number} es - Eccentricity squared of the ellipsoid.
 * @property {number} ep2 - Second eccentricity squared of the ellipsoid.
 */ /**
 * @param {string | import('./core').PROJJSONDefinition | import('./defs').ProjectionDefinition} srsCode
 * @param {(errorMessage?: string, instance?: Projection) => void} [callback]
 */ function $24869d6338533b3b$var$Projection(srsCode, callback) {
    if (!(this instanceof $24869d6338533b3b$var$Projection)) return new $24869d6338533b3b$var$Projection(srsCode);
    /** @type {<T extends import('./core').TemplateCoordinates>(coordinates: T, enforceAxis?: boolean) => T} */ this.forward = null;
    /** @type {<T extends import('./core').TemplateCoordinates>(coordinates: T, enforceAxis?: boolean) => T} */ this.inverse = null;
    /** @type {function(): void} */ this.init = null;
    /** @type {string} */ this.name;
    /** @type {Array<string>} */ this.names = null;
    /** @type {string} */ this.title;
    callback = callback || function(error) {
        if (error) throw error;
    };
    var json = (0, $giDQh.default)(srsCode);
    if (typeof json !== 'object') {
        callback('Could not parse to valid json: ' + srsCode);
        return;
    }
    var ourProj = $24869d6338533b3b$var$Projection.projections.get(json.projName);
    if (!ourProj) {
        callback('Could not get projection name from: ' + srsCode);
        return;
    }
    if (json.datumCode && json.datumCode !== 'none') {
        var datumDef = (0, $hzXAi.default)((0, $gMdFS.default), json.datumCode);
        if (datumDef) {
            json.datum_params = json.datum_params || (datumDef.towgs84 ? datumDef.towgs84.split(',') : null);
            json.ellps = datumDef.ellipse;
            json.datumName = datumDef.datumName ? datumDef.datumName : json.datumCode;
        }
    }
    json.k0 = json.k0 || 1.0;
    json.axis = json.axis || 'enu';
    json.ellps = json.ellps || 'wgs84';
    json.lat1 = json.lat1 || json.lat0; // Lambert_Conformal_Conic_1SP, for example, needs this
    var sphere_ = (0, $d8b9d.sphere)(json.a, json.b, json.rf, json.ellps, json.sphere);
    var ecc = (0, $d8b9d.eccentricity)(sphere_.a, sphere_.b, sphere_.rf, json.R_A);
    var nadgrids = (0, $flUkq.getNadgrids)(json.nadgrids);
    /** @type {DatumDefinition} */ var datumObj = json.datum || (0, $3MCqb.default)(json.datumCode, json.datum_params, sphere_.a, sphere_.b, ecc.es, ecc.ep2, nadgrids);
    (0, $cWauz.default)(this, json); // transfer everything over from the projection because we don't know what we'll need
    (0, $cWauz.default)(this, ourProj); // transfer all the methods from the projection
    // copy the 4 things over we calculated in deriveConstants.sphere
    this.a = sphere_.a;
    this.b = sphere_.b;
    this.rf = sphere_.rf;
    this.sphere = sphere_.sphere;
    // copy the 3 things we calculated in deriveConstants.eccentricity
    this.es = ecc.es;
    this.e = ecc.e;
    this.ep2 = ecc.ep2;
    // add in the datum object
    this.datum = datumObj;
    // init the projection
    if ('init' in this && typeof this.init === 'function') this.init();
    // legecy callback from back in the day when it went to spatialreference.org
    callback(null, this);
}
$24869d6338533b3b$var$Projection.projections = (0, $1Wo5P.default);
$24869d6338533b3b$var$Projection.projections.start();
var $24869d6338533b3b$export$2e2bcd8739ae039 = $24869d6338533b3b$var$Projection;

});
parcelRegister("giDQh", function(module, exports) {

$parcel$export(module.exports, "default", () => $bddd3b9c0d2064cd$export$2e2bcd8739ae039);

var $ezj1P = parcelRequire("ezj1P");

var $7UVTv = parcelRequire("7UVTv");

var $7zrM7 = parcelRequire("7zrM7");

var $hzXAi = parcelRequire("hzXAi");
function $bddd3b9c0d2064cd$var$testObj(code) {
    return typeof code === 'string';
}
function $bddd3b9c0d2064cd$var$testDef(code) {
    return code in (0, $ezj1P.default);
}
function $bddd3b9c0d2064cd$var$testWKT(code) {
    return code.indexOf('+') !== 0 && code.indexOf('[') !== -1 || typeof code === 'object' && !('srsCode' in code);
}
var $bddd3b9c0d2064cd$var$codes = [
    '3857',
    '900913',
    '3785',
    '102113'
];
function $bddd3b9c0d2064cd$var$checkMercator(item) {
    var auth = (0, $hzXAi.default)(item, 'authority');
    if (!auth) return;
    var code = (0, $hzXAi.default)(auth, 'epsg');
    return code && $bddd3b9c0d2064cd$var$codes.indexOf(code) > -1;
}
function $bddd3b9c0d2064cd$var$checkProjStr(item) {
    var ext = (0, $hzXAi.default)(item, 'extension');
    if (!ext) return;
    return (0, $hzXAi.default)(ext, 'proj4');
}
function $bddd3b9c0d2064cd$var$testProj(code) {
    return code[0] === '+';
}
/**
 * @param {string | import('./core').PROJJSONDefinition | import('./defs').ProjectionDefinition} code
 * @returns {import('./defs').ProjectionDefinition}
 */ function $bddd3b9c0d2064cd$var$parse(code) {
    if ($bddd3b9c0d2064cd$var$testObj(code)) {
        // check to see if this is a WKT string
        if ($bddd3b9c0d2064cd$var$testDef(code)) return (0, $ezj1P.default)[code];
        if ($bddd3b9c0d2064cd$var$testWKT(code)) {
            var out = (0, $7UVTv.default)(code);
            // test of spetial case, due to this being a very common and often malformed
            if ($bddd3b9c0d2064cd$var$checkMercator(out)) return (0, $ezj1P.default)['EPSG:3857'];
            var maybeProjStr = $bddd3b9c0d2064cd$var$checkProjStr(out);
            if (maybeProjStr) return (0, $7zrM7.default)(maybeProjStr);
            return out;
        }
        if ($bddd3b9c0d2064cd$var$testProj(code)) return (0, $7zrM7.default)(code);
    } else if (!('projName' in code)) return (0, $7UVTv.default)(code);
    else return code;
}
var $bddd3b9c0d2064cd$export$2e2bcd8739ae039 = $bddd3b9c0d2064cd$var$parse;

});
parcelRegister("ezj1P", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9b3183caccb3297$export$2e2bcd8739ae039);

var $cR6T8 = parcelRequire("cR6T8");

var $7zrM7 = parcelRequire("7zrM7");

var $7UVTv = parcelRequire("7UVTv");
/**
 * @typedef {Object} ProjectionDefinition
 * @property {string} title
 * @property {string} [projName]
 * @property {string} [ellps]
 * @property {import('./Proj.js').DatumDefinition} [datum]
 * @property {string} [datumName]
 * @property {number} [rf]
 * @property {number} [lat0]
 * @property {number} [lat1]
 * @property {number} [lat2]
 * @property {number} [lat_ts]
 * @property {number} [long0]
 * @property {number} [long1]
 * @property {number} [long2]
 * @property {number} [alpha]
 * @property {number} [longc]
 * @property {number} [x0]
 * @property {number} [y0]
 * @property {number} [k0]
 * @property {number} [a]
 * @property {number} [b]
 * @property {true} [R_A]
 * @property {number} [zone]
 * @property {true} [utmSouth]
 * @property {string|Array<number>} [datum_params]
 * @property {number} [to_meter]
 * @property {string} [units]
 * @property {number} [from_greenwich]
 * @property {string} [datumCode]
 * @property {string} [nadgrids]
 * @property {string} [axis]
 * @property {boolean} [sphere]
 * @property {number} [rectified_grid_angle]
 * @property {boolean} [approx]
 * @property {boolean} [over]
 * @property {string} [projStr]
 * @property {<T extends import('./core').TemplateCoordinates>(coordinates: T, enforceAxis?: boolean) => T} inverse
 * @property {<T extends import('./core').TemplateCoordinates>(coordinates: T, enforceAxis?: boolean) => T} forward
 */ /**
 * @overload
 * @param {string} name
 * @param {string|ProjectionDefinition|import('./core.js').PROJJSONDefinition} projection
 * @returns {void}
 */ /**
 * @overload
 * @param {Array<[string, string]>} name
 * @returns {Array<ProjectionDefinition|undefined>}
 */ /**
 * @overload
 * @param {string} name
 * @returns {ProjectionDefinition}
 */ /**
 * @param {string | Array<Array<string>> | Partial<Record<'EPSG'|'ESRI'|'IAU2000', ProjectionDefinition>>} name
 * @returns {ProjectionDefinition | Array<ProjectionDefinition|undefined> | void}
 */ function $a9b3183caccb3297$var$defs(name) {
    /* global console */ var that = this;
    if (arguments.length === 2) {
        var def = arguments[1];
        if (typeof def === 'string') {
            if (def.charAt(0) === '+') $a9b3183caccb3297$var$defs[/** @type {string} */ name] = (0, $7zrM7.default)(arguments[1]);
            else $a9b3183caccb3297$var$defs[/** @type {string} */ name] = (0, $7UVTv.default)(arguments[1]);
        } else if (def && typeof def === 'object' && !('projName' in def)) // PROJJSON
        $a9b3183caccb3297$var$defs[/** @type {string} */ name] = (0, $7UVTv.default)(arguments[1]);
        else {
            $a9b3183caccb3297$var$defs[/** @type {string} */ name] = def;
            if (!def) delete $a9b3183caccb3297$var$defs[/** @type {string} */ name];
        }
    } else if (arguments.length === 1) {
        if (Array.isArray(name)) return name.map(function(v) {
            if (Array.isArray(v)) return $a9b3183caccb3297$var$defs.apply(that, v);
            else return $a9b3183caccb3297$var$defs(v);
        });
        else if (typeof name === 'string') {
            if (name in $a9b3183caccb3297$var$defs) return $a9b3183caccb3297$var$defs[name];
        } else if ('EPSG' in name) $a9b3183caccb3297$var$defs['EPSG:' + name.EPSG] = name;
        else if ('ESRI' in name) $a9b3183caccb3297$var$defs['ESRI:' + name.ESRI] = name;
        else if ('IAU2000' in name) $a9b3183caccb3297$var$defs['IAU2000:' + name.IAU2000] = name;
        else console.log(name);
        return;
    }
}
(0, $cR6T8.default)($a9b3183caccb3297$var$defs);
var $a9b3183caccb3297$export$2e2bcd8739ae039 = $a9b3183caccb3297$var$defs;

});
parcelRegister("cR6T8", function(module, exports) {

$parcel$export(module.exports, "default", () => $95bfc720255032a6$export$2e2bcd8739ae039);
function $95bfc720255032a6$export$2e2bcd8739ae039(defs) {
    defs('EPSG:4326', '+title=WGS 84 (long/lat) +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees');
    defs('EPSG:4269', '+title=NAD83 (long/lat) +proj=longlat +a=6378137.0 +b=6356752.31414036 +ellps=GRS80 +datum=NAD83 +units=degrees');
    defs('EPSG:3857', '+title=WGS 84 / Pseudo-Mercator +proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +no_defs');
    // UTM WGS84
    for(var i = 1; i <= 60; ++i){
        defs('EPSG:' + (32600 + i), '+proj=utm +zone=' + i + ' +datum=WGS84 +units=m');
        defs('EPSG:' + (32700 + i), '+proj=utm +zone=' + i + ' +south +datum=WGS84 +units=m');
    }
    defs('EPSG:5041', '+title=WGS 84 / UPS North (E,N) +proj=stere +lat_0=90 +lon_0=0 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m');
    defs('EPSG:5042', '+title=WGS 84 / UPS South (E,N) +proj=stere +lat_0=-90 +lon_0=0 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m');
    defs.WGS84 = defs['EPSG:4326'];
    defs['EPSG:3785'] = defs['EPSG:3857']; // maintain backward compat, official code is 3857
    defs.GOOGLE = defs['EPSG:3857'];
    defs['EPSG:900913'] = defs['EPSG:3857'];
    defs['EPSG:102113'] = defs['EPSG:3857'];
}

});

parcelRegister("7zrM7", function(module, exports) {

$parcel$export(module.exports, "default", () => $583158df16d3522c$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");

var $gyWgF = parcelRequire("gyWgF");

var $6CY0Z = parcelRequire("6CY0Z");

var $hzXAi = parcelRequire("hzXAi");
function $583158df16d3522c$export$2e2bcd8739ae039(defData) {
    /** @type {import('./defs').ProjectionDefinition} */ var self = {};
    var paramObj = defData.split('+').map(function(v) {
        return v.trim();
    }).filter(function(a) {
        return a;
    }).reduce(function(p, a) {
        /** @type {Array<?>} */ var split = a.split('=');
        split.push(true);
        p[split[0].toLowerCase()] = split[1];
        return p;
    }, {});
    var paramName, paramVal, paramOutname;
    var params = {
        proj: 'projName',
        datum: 'datumCode',
        rf: function(v) {
            self.rf = parseFloat(v);
        },
        lat_0: function(v) {
            self.lat0 = v * (0, $gyVUi.D2R);
        },
        lat_1: function(v) {
            self.lat1 = v * (0, $gyVUi.D2R);
        },
        lat_2: function(v) {
            self.lat2 = v * (0, $gyVUi.D2R);
        },
        lat_ts: function(v) {
            self.lat_ts = v * (0, $gyVUi.D2R);
        },
        lon_0: function(v) {
            self.long0 = v * (0, $gyVUi.D2R);
        },
        lon_1: function(v) {
            self.long1 = v * (0, $gyVUi.D2R);
        },
        lon_2: function(v) {
            self.long2 = v * (0, $gyVUi.D2R);
        },
        alpha: function(v) {
            self.alpha = parseFloat(v) * (0, $gyVUi.D2R);
        },
        gamma: function(v) {
            self.rectified_grid_angle = parseFloat(v) * (0, $gyVUi.D2R);
        },
        lonc: function(v) {
            self.longc = v * (0, $gyVUi.D2R);
        },
        x_0: function(v) {
            self.x0 = parseFloat(v);
        },
        y_0: function(v) {
            self.y0 = parseFloat(v);
        },
        k_0: function(v) {
            self.k0 = parseFloat(v);
        },
        k: function(v) {
            self.k0 = parseFloat(v);
        },
        a: function(v) {
            self.a = parseFloat(v);
        },
        b: function(v) {
            self.b = parseFloat(v);
        },
        r: function(v) {
            self.a = self.b = parseFloat(v);
        },
        r_a: function() {
            self.R_A = true;
        },
        zone: function(v) {
            self.zone = parseInt(v, 10);
        },
        south: function() {
            self.utmSouth = true;
        },
        towgs84: function(v) {
            self.datum_params = v.split(',').map(function(a) {
                return parseFloat(a);
            });
        },
        to_meter: function(v) {
            self.to_meter = parseFloat(v);
        },
        units: function(v) {
            self.units = v;
            var unit = (0, $hzXAi.default)((0, $6CY0Z.default), v);
            if (unit) self.to_meter = unit.to_meter;
        },
        from_greenwich: function(v) {
            self.from_greenwich = v * (0, $gyVUi.D2R);
        },
        pm: function(v) {
            var pm = (0, $hzXAi.default)((0, $gyWgF.default), v);
            self.from_greenwich = (pm ? pm : parseFloat(v)) * (0, $gyVUi.D2R);
        },
        nadgrids: function(v) {
            if (v === '@null') self.datumCode = 'none';
            else self.nadgrids = v;
        },
        axis: function(v) {
            var legalAxis = 'ewnsud';
            if (v.length === 3 && legalAxis.indexOf(v.substr(0, 1)) !== -1 && legalAxis.indexOf(v.substr(1, 1)) !== -1 && legalAxis.indexOf(v.substr(2, 1)) !== -1) self.axis = v;
        },
        approx: function() {
            self.approx = true;
        },
        over: function() {
            self.over = true;
        }
    };
    for(paramName in paramObj){
        paramVal = paramObj[paramName];
        if (paramName in params) {
            paramOutname = params[paramName];
            if (typeof paramOutname === 'function') paramOutname(paramVal);
            else self[paramOutname] = paramVal;
        } else self[paramName] = paramVal;
    }
    if (typeof self.datumCode === 'string' && self.datumCode !== 'WGS84') self.datumCode = self.datumCode.toLowerCase();
    self['projStr'] = defData;
    return self;
}

});
parcelRegister("gyVUi", function(module, exports) {

$parcel$export(module.exports, "PJD_3PARAM", () => $c0ecbd71ed29ee86$export$3a3ed3e590e8ec27);
$parcel$export(module.exports, "PJD_7PARAM", () => $c0ecbd71ed29ee86$export$8cab19b7f383a7a7);
$parcel$export(module.exports, "PJD_GRIDSHIFT", () => $c0ecbd71ed29ee86$export$83d26ae02793dd10);
$parcel$export(module.exports, "PJD_WGS84", () => $c0ecbd71ed29ee86$export$ab5bf8c731b6bbbb);
$parcel$export(module.exports, "PJD_NODATUM", () => $c0ecbd71ed29ee86$export$8df4c7729d8ed58d);
$parcel$export(module.exports, "SRS_WGS84_SEMIMAJOR", () => $c0ecbd71ed29ee86$export$d612c03b7390d945);
$parcel$export(module.exports, "SRS_WGS84_SEMIMINOR", () => $c0ecbd71ed29ee86$export$59af086d7527ec46);
$parcel$export(module.exports, "SRS_WGS84_ESQUARED", () => $c0ecbd71ed29ee86$export$9b798f9d78b99fc0);
$parcel$export(module.exports, "SEC_TO_RAD", () => $c0ecbd71ed29ee86$export$e0b9011552f3b2f7);
$parcel$export(module.exports, "HALF_PI", () => $c0ecbd71ed29ee86$export$f504979d7e0a75c7);
$parcel$export(module.exports, "SIXTH", () => $c0ecbd71ed29ee86$export$d7977f56a0faa834);
$parcel$export(module.exports, "RA4", () => $c0ecbd71ed29ee86$export$9e703428410a9c7b);
$parcel$export(module.exports, "RA6", () => $c0ecbd71ed29ee86$export$bb54dde5565ed6e3);
$parcel$export(module.exports, "EPSLN", () => $c0ecbd71ed29ee86$export$2aa89dbfb8b504bb);
$parcel$export(module.exports, "D2R", () => $c0ecbd71ed29ee86$export$ed6012a68c0f4a70);
$parcel$export(module.exports, "R2D", () => $c0ecbd71ed29ee86$export$456934b8be7498c3);
$parcel$export(module.exports, "FORTPI", () => $c0ecbd71ed29ee86$export$10cb69dd603c11b0);
$parcel$export(module.exports, "TWO_PI", () => $c0ecbd71ed29ee86$export$6eec49b1a6289c4e);
$parcel$export(module.exports, "SPI", () => $c0ecbd71ed29ee86$export$703a92fc6506ffb9);
var $c0ecbd71ed29ee86$export$3a3ed3e590e8ec27 = 1;
var $c0ecbd71ed29ee86$export$8cab19b7f383a7a7 = 2;
var $c0ecbd71ed29ee86$export$83d26ae02793dd10 = 3;
var $c0ecbd71ed29ee86$export$ab5bf8c731b6bbbb = 4; // WGS84 or equivalent
var $c0ecbd71ed29ee86$export$8df4c7729d8ed58d = 5; // WGS84 or equivalent
var $c0ecbd71ed29ee86$export$d612c03b7390d945 = 6378137.0; // only used in grid shift transforms
var $c0ecbd71ed29ee86$export$59af086d7527ec46 = 6356752.314; // only used in grid shift transforms
var $c0ecbd71ed29ee86$export$9b798f9d78b99fc0 = 0.0066943799901413165; // only used in grid shift transforms
var $c0ecbd71ed29ee86$export$e0b9011552f3b2f7 = 4.84813681109535993589914102357e-6;
var $c0ecbd71ed29ee86$export$f504979d7e0a75c7 = Math.PI / 2;
var $c0ecbd71ed29ee86$export$d7977f56a0faa834 = 0.1666666666666666667;
var $c0ecbd71ed29ee86$export$9e703428410a9c7b = 0.04722222222222222222;
var $c0ecbd71ed29ee86$export$bb54dde5565ed6e3 = 0.02215608465608465608;
var $c0ecbd71ed29ee86$export$2aa89dbfb8b504bb = 1.0e-10;
var $c0ecbd71ed29ee86$export$ed6012a68c0f4a70 = 0.01745329251994329577;
var $c0ecbd71ed29ee86$export$456934b8be7498c3 = 57.29577951308232088;
var $c0ecbd71ed29ee86$export$10cb69dd603c11b0 = Math.PI / 4;
var $c0ecbd71ed29ee86$export$6eec49b1a6289c4e = Math.PI * 2;
var $c0ecbd71ed29ee86$export$703a92fc6506ffb9 = 3.14159265359;

});

parcelRegister("gyWgF", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0ed0517e336f22b$export$2e2bcd8739ae039);
var $c0ed0517e336f22b$var$primeMeridian = {};
$c0ed0517e336f22b$var$primeMeridian.greenwich = 0.0; // "0dE",
$c0ed0517e336f22b$var$primeMeridian.lisbon = -9.131906111111; // "9d07'54.862\"W",
$c0ed0517e336f22b$var$primeMeridian.paris = 2.337229166667; // "2d20'14.025\"E",
$c0ed0517e336f22b$var$primeMeridian.bogota = -74.080916666667; // "74d04'51.3\"W",
$c0ed0517e336f22b$var$primeMeridian.madrid = -3.687938888889; // "3d41'16.58\"W",
$c0ed0517e336f22b$var$primeMeridian.rome = 12.452333333333; // "12d27'8.4\"E",
$c0ed0517e336f22b$var$primeMeridian.bern = 7.439583333333; // "7d26'22.5\"E",
$c0ed0517e336f22b$var$primeMeridian.jakarta = 106.807719444444; // "106d48'27.79\"E",
$c0ed0517e336f22b$var$primeMeridian.ferro = -17.666666666667; // "17d40'W",
$c0ed0517e336f22b$var$primeMeridian.brussels = 4.367975; // "4d22'4.71\"E",
$c0ed0517e336f22b$var$primeMeridian.stockholm = 18.058277777778; // "18d3'29.8\"E",
$c0ed0517e336f22b$var$primeMeridian.athens = 23.7163375; // "23d42'58.815\"E",
$c0ed0517e336f22b$var$primeMeridian.oslo = 10.722916666667; // "10d43'22.5\"E"
var $c0ed0517e336f22b$export$2e2bcd8739ae039 = $c0ed0517e336f22b$var$primeMeridian;

});

parcelRegister("6CY0Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d34d8675ead8d22$export$2e2bcd8739ae039);
var $4d34d8675ead8d22$export$2e2bcd8739ae039 = {
    mm: {
        to_meter: 0.001
    },
    cm: {
        to_meter: 0.01
    },
    ft: {
        to_meter: 0.3048
    },
    'us-ft': {
        to_meter: 1200 / 3937
    },
    fath: {
        to_meter: 1.8288
    },
    kmi: {
        to_meter: 1852
    },
    'us-ch': {
        to_meter: 20.1168402336805
    },
    'us-mi': {
        to_meter: 1609.34721869444
    },
    km: {
        to_meter: 1000
    },
    'ind-ft': {
        to_meter: 0.30479841
    },
    'ind-yd': {
        to_meter: 0.91439523
    },
    mi: {
        to_meter: 1609.344
    },
    yd: {
        to_meter: 0.9144
    },
    ch: {
        to_meter: 20.1168
    },
    link: {
        to_meter: 0.201168
    },
    dm: {
        to_meter: 0.1
    },
    in: {
        to_meter: 0.0254
    },
    'ind-ch': {
        to_meter: 20.11669506
    },
    'us-in': {
        to_meter: 0.025400050800101
    },
    'us-yd': {
        to_meter: 0.914401828803658
    }
};

});

parcelRegister("hzXAi", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccc3ecc4732a4173$export$2e2bcd8739ae039);
var $ccc3ecc4732a4173$var$ignoredChar = /[\s_\-\/\(\)]/g;
function $ccc3ecc4732a4173$export$2e2bcd8739ae039(obj, key) {
    if (obj[key]) return obj[key];
    var keys = Object.keys(obj);
    var lkey = key.toLowerCase().replace($ccc3ecc4732a4173$var$ignoredChar, '');
    var i = -1;
    var testkey, processedKey;
    while(++i < keys.length){
        testkey = keys[i];
        processedKey = testkey.toLowerCase().replace($ccc3ecc4732a4173$var$ignoredChar, '');
        if (processedKey === lkey) return obj[testkey];
    }
}

});


parcelRegister("7UVTv", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c3aabf591259c07$export$2e2bcd8739ae039);

var $5uKqK = parcelRequire("5uKqK");

var $ad1Gh = parcelRequire("ad1Gh");

var $6Pz8X = parcelRequire("6Pz8X");

var $7SVqc = parcelRequire("7SVqc");

var $hwbbo = parcelRequire("hwbbo");

var $am47V = parcelRequire("am47V");
var $5c3aabf591259c07$var$knownTypes = [
    'PROJECTEDCRS',
    'PROJCRS',
    'GEOGCS',
    'GEOCCS',
    'PROJCS',
    'LOCAL_CS',
    'GEODCRS',
    'GEODETICCRS',
    'GEODETICDATUM',
    'ENGCRS',
    'ENGINEERINGCRS'
];
function $5c3aabf591259c07$var$rename(obj, params) {
    var outName = params[0];
    var inName = params[1];
    if (!(outName in obj) && inName in obj) {
        obj[outName] = obj[inName];
        if (params.length === 3) obj[outName] = params[2](obj[outName]);
    }
}
function $5c3aabf591259c07$var$cleanWKT(wkt) {
    var keys = Object.keys(wkt);
    for(var i = 0, ii = keys.length; i < ii; ++i){
        var key = keys[i];
        // the followings are the crs defined in
        // https://github.com/proj4js/proj4js/blob/1da4ed0b865d0fcb51c136090569210cdcc9019e/lib/parseCode.js#L11
        if ($5c3aabf591259c07$var$knownTypes.indexOf(key) !== -1) $5c3aabf591259c07$var$setPropertiesFromWkt(wkt[key]);
        if (typeof wkt[key] === 'object') $5c3aabf591259c07$var$cleanWKT(wkt[key]);
    }
}
function $5c3aabf591259c07$var$setPropertiesFromWkt(wkt) {
    if (wkt.AUTHORITY) {
        var authority = Object.keys(wkt.AUTHORITY)[0];
        if (authority && authority in wkt.AUTHORITY) wkt.title = authority + ':' + wkt.AUTHORITY[authority];
    }
    if (wkt.type === 'GEOGCS') wkt.projName = 'longlat';
    else if (wkt.type === 'LOCAL_CS') {
        wkt.projName = 'identity';
        wkt.local = true;
    } else if (typeof wkt.PROJECTION === 'object') wkt.projName = Object.keys(wkt.PROJECTION)[0];
    else wkt.projName = wkt.PROJECTION;
    if (wkt.AXIS) {
        var axisOrder = '';
        for(var i = 0, ii = wkt.AXIS.length; i < ii; ++i){
            var axis = [
                wkt.AXIS[i][0].toLowerCase(),
                wkt.AXIS[i][1].toLowerCase()
            ];
            if (axis[0].indexOf('north') !== -1 || (axis[0] === 'y' || axis[0] === 'lat') && axis[1] === 'north') axisOrder += 'n';
            else if (axis[0].indexOf('south') !== -1 || (axis[0] === 'y' || axis[0] === 'lat') && axis[1] === 'south') axisOrder += 's';
            else if (axis[0].indexOf('east') !== -1 || (axis[0] === 'x' || axis[0] === 'lon') && axis[1] === 'east') axisOrder += 'e';
            else if (axis[0].indexOf('west') !== -1 || (axis[0] === 'x' || axis[0] === 'lon') && axis[1] === 'west') axisOrder += 'w';
        }
        if (axisOrder.length === 2) axisOrder += 'u';
        if (axisOrder.length === 3) wkt.axis = axisOrder;
    }
    if (wkt.UNIT) {
        wkt.units = wkt.UNIT.name.toLowerCase();
        if (wkt.units === 'metre') wkt.units = 'meter';
        if (wkt.UNIT.convert) {
            if (wkt.type === 'GEOGCS') {
                if (wkt.DATUM && wkt.DATUM.SPHEROID) wkt.to_meter = wkt.UNIT.convert * wkt.DATUM.SPHEROID.a;
            } else wkt.to_meter = wkt.UNIT.convert;
        }
    }
    var geogcs = wkt.GEOGCS;
    if (wkt.type === 'GEOGCS') geogcs = wkt;
    if (geogcs) {
        //if(wkt.GEOGCS.PRIMEM&&wkt.GEOGCS.PRIMEM.convert){
        //  wkt.from_greenwich=wkt.GEOGCS.PRIMEM.convert*D2R;
        //}
        if (geogcs.DATUM) wkt.datumCode = geogcs.DATUM.name.toLowerCase();
        else wkt.datumCode = geogcs.name.toLowerCase();
        if (wkt.datumCode.slice(0, 2) === 'd_') wkt.datumCode = wkt.datumCode.slice(2);
        if (wkt.datumCode === 'new_zealand_1949') wkt.datumCode = 'nzgd49';
        if (wkt.datumCode === 'wgs_1984' || wkt.datumCode === 'world_geodetic_system_1984') {
            if (wkt.PROJECTION === 'Mercator_Auxiliary_Sphere') wkt.sphere = true;
            wkt.datumCode = 'wgs84';
        }
        if (wkt.datumCode === 'belge_1972') wkt.datumCode = 'rnb72';
        if (geogcs.DATUM && geogcs.DATUM.SPHEROID) {
            wkt.ellps = geogcs.DATUM.SPHEROID.name.replace('_19', '').replace(/[Cc]larke\_18/, 'clrk');
            if (wkt.ellps.toLowerCase().slice(0, 13) === 'international') wkt.ellps = 'intl';
            wkt.a = geogcs.DATUM.SPHEROID.a;
            wkt.rf = parseFloat(geogcs.DATUM.SPHEROID.rf, 10);
        }
        if (geogcs.DATUM && geogcs.DATUM.TOWGS84) wkt.datum_params = geogcs.DATUM.TOWGS84;
        if (~wkt.datumCode.indexOf('osgb_1936')) wkt.datumCode = 'osgb36';
        if (~wkt.datumCode.indexOf('osni_1952')) wkt.datumCode = 'osni52';
        if (~wkt.datumCode.indexOf('tm65') || ~wkt.datumCode.indexOf('geodetic_datum_of_1965')) wkt.datumCode = 'ire65';
        if (wkt.datumCode === 'ch1903+') wkt.datumCode = 'ch1903';
        if (~wkt.datumCode.indexOf('israel')) wkt.datumCode = 'isr93';
    }
    if (wkt.b && !isFinite(wkt.b)) wkt.b = wkt.a;
    if (wkt.rectified_grid_angle) wkt.rectified_grid_angle = (0, $am47V.d2r)(wkt.rectified_grid_angle);
    function toMeter(input) {
        var ratio = wkt.to_meter || 1;
        return input * ratio;
    }
    var renamer = function(a) {
        return $5c3aabf591259c07$var$rename(wkt, a);
    };
    var list = [
        [
            'standard_parallel_1',
            'Standard_Parallel_1'
        ],
        [
            'standard_parallel_1',
            'Latitude of 1st standard parallel'
        ],
        [
            'standard_parallel_2',
            'Standard_Parallel_2'
        ],
        [
            'standard_parallel_2',
            'Latitude of 2nd standard parallel'
        ],
        [
            'false_easting',
            'False_Easting'
        ],
        [
            'false_easting',
            'False easting'
        ],
        [
            'false-easting',
            'Easting at false origin'
        ],
        [
            'false_northing',
            'False_Northing'
        ],
        [
            'false_northing',
            'False northing'
        ],
        [
            'false_northing',
            'Northing at false origin'
        ],
        [
            'central_meridian',
            'Central_Meridian'
        ],
        [
            'central_meridian',
            'Longitude of natural origin'
        ],
        [
            'central_meridian',
            'Longitude of false origin'
        ],
        [
            'latitude_of_origin',
            'Latitude_Of_Origin'
        ],
        [
            'latitude_of_origin',
            'Central_Parallel'
        ],
        [
            'latitude_of_origin',
            'Latitude of natural origin'
        ],
        [
            'latitude_of_origin',
            'Latitude of false origin'
        ],
        [
            'scale_factor',
            'Scale_Factor'
        ],
        [
            'k0',
            'scale_factor'
        ],
        [
            'latitude_of_center',
            'Latitude_Of_Center'
        ],
        [
            'latitude_of_center',
            'Latitude_of_center'
        ],
        [
            'lat0',
            'latitude_of_center',
            (0, $am47V.d2r)
        ],
        [
            'longitude_of_center',
            'Longitude_Of_Center'
        ],
        [
            'longitude_of_center',
            'Longitude_of_center'
        ],
        [
            'longc',
            'longitude_of_center',
            (0, $am47V.d2r)
        ],
        [
            'x0',
            'false_easting',
            toMeter
        ],
        [
            'y0',
            'false_northing',
            toMeter
        ],
        [
            'long0',
            'central_meridian',
            (0, $am47V.d2r)
        ],
        [
            'lat0',
            'latitude_of_origin',
            (0, $am47V.d2r)
        ],
        [
            'lat0',
            'standard_parallel_1',
            (0, $am47V.d2r)
        ],
        [
            'lat1',
            'standard_parallel_1',
            (0, $am47V.d2r)
        ],
        [
            'lat2',
            'standard_parallel_2',
            (0, $am47V.d2r)
        ],
        [
            'azimuth',
            'Azimuth'
        ],
        [
            'alpha',
            'azimuth',
            (0, $am47V.d2r)
        ],
        [
            'srsCode',
            'name'
        ]
    ];
    list.forEach(renamer);
    (0, $am47V.applyProjectionDefaults)(wkt);
}
function $5c3aabf591259c07$export$2e2bcd8739ae039(wkt) {
    if (typeof wkt === 'object') return (0, $hwbbo.transformPROJJSON)(wkt);
    const version = (0, $ad1Gh.detectWKTVersion)(wkt);
    var lisp = (0, $6Pz8X.default)(wkt);
    if (version === 'WKT2') {
        const projjson = (0, $5uKqK.buildPROJJSON)(lisp);
        return (0, $hwbbo.transformPROJJSON)(projjson);
    }
    var type = lisp[0];
    var obj = {};
    (0, $7SVqc.sExpr)(lisp, obj);
    $5c3aabf591259c07$var$cleanWKT(obj);
    return obj[type];
}

});
parcelRegister("5uKqK", function(module, exports) {

$parcel$export(module.exports, "buildPROJJSON", () => $4003c53a8a2e570b$export$48d0005f67ba915);

var $g1F38 = parcelRequire("g1F38");

var $7HCiu = parcelRequire("7HCiu");
/**
 * Detects the WKT2 version based on the structure of the WKT.
 * @param {Array} root The root WKT array node.
 * @returns {string} The detected version ("2015" or "2019").
 */ function $4003c53a8a2e570b$var$detectWKT2Version(root) {
    // Check for WKT2-2019-specific nodes
    if (root.find((child)=>Array.isArray(child) && child[0] === 'USAGE')) return '2019'; // `USAGE` is specific to WKT2-2019
    // Check for WKT2-2015-specific nodes
    if (root.find((child)=>Array.isArray(child) && child[0] === 'CS')) return '2015'; // `CS` is valid in both, but default to 2015 unless `USAGE` is present
    if (root[0] === 'BOUNDCRS' || root[0] === 'PROJCRS' || root[0] === 'GEOGCRS') return '2015'; // These are valid in both, but default to 2015
    // Default to WKT2-2015 if no specific indicators are found
    return '2015';
}
function $4003c53a8a2e570b$export$48d0005f67ba915(root) {
    const version = $4003c53a8a2e570b$var$detectWKT2Version(root);
    const builder = version === '2019' ? (0, $7HCiu.default) : (0, $g1F38.default);
    return builder.convert(root);
}

});
parcelRegister("g1F38", function(module, exports) {

$parcel$export(module.exports, "default", () => $baac94ed6bfdac10$export$2e2bcd8739ae039);

var $fYQzQ = parcelRequire("fYQzQ");
class $baac94ed6bfdac10$var$PROJJSONBuilder2015 extends (0, $fYQzQ.default) {
    static convert(node, result = {}) {
        super.convert(node, result);
        // Skip `CS` and `USAGE` nodes for WKT2-2015
        if (result.coordinate_system && result.coordinate_system.subtype === 'Cartesian') delete result.coordinate_system;
        if (result.usage) delete result.usage;
        return result;
    }
}
var $baac94ed6bfdac10$export$2e2bcd8739ae039 = $baac94ed6bfdac10$var$PROJJSONBuilder2015;

});
parcelRegister("fYQzQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba253e570caf793b$export$2e2bcd8739ae039);
class $ba253e570caf793b$var$PROJJSONBuilderBase {
    static getId(node) {
        const idNode = node.find((child)=>Array.isArray(child) && child[0] === 'ID');
        if (idNode && idNode.length >= 3) return {
            authority: idNode[1],
            code: parseInt(idNode[2], 10)
        };
        return null;
    }
    static convertUnit(node, type = 'unit') {
        if (!node || node.length < 3) return {
            type: type,
            name: 'unknown',
            conversion_factor: null
        };
        const name = node[1];
        const conversionFactor = parseFloat(node[2]) || null;
        const idNode = node.find((child)=>Array.isArray(child) && child[0] === 'ID');
        const id = idNode ? {
            authority: idNode[1],
            code: parseInt(idNode[2], 10)
        } : null;
        return {
            type: type,
            name: name,
            conversion_factor: conversionFactor,
            id: id
        };
    }
    static convertAxis(node) {
        const name = node[1] || 'Unknown';
        // Determine the direction
        let direction;
        const abbreviationMatch = name.match(/^\((.)\)$/); // Match abbreviations like "(E)" or "(N)"
        if (abbreviationMatch) {
            // Use the abbreviation to determine the direction
            const abbreviation = abbreviationMatch[1].toUpperCase();
            if (abbreviation === 'E') direction = 'east';
            else if (abbreviation === 'N') direction = 'north';
            else if (abbreviation === 'U') direction = 'up';
            else throw new Error(`Unknown axis abbreviation: ${abbreviation}`);
        } else // Use the explicit direction provided in the AXIS node
        direction = node[2] ? node[2].toLowerCase() : 'unknown';
        const orderNode = node.find((child)=>Array.isArray(child) && child[0] === 'ORDER');
        const order = orderNode ? parseInt(orderNode[1], 10) : null;
        const unitNode = node.find((child)=>Array.isArray(child) && (child[0] === 'LENGTHUNIT' || child[0] === 'ANGLEUNIT' || child[0] === 'SCALEUNIT'));
        const unit = this.convertUnit(unitNode);
        return {
            name: name,
            direction: direction,
            unit: unit,
            order: order
        };
    }
    static extractAxes(node) {
        return node.filter((child)=>Array.isArray(child) && child[0] === 'AXIS').map((axis)=>this.convertAxis(axis)).sort((a, b)=>(a.order || 0) - (b.order || 0)); // Sort by the "order" property
    }
    static convert(node, result = {}) {
        switch(node[0]){
            case 'PROJCRS':
                result.type = 'ProjectedCRS';
                result.name = node[1];
                result.base_crs = node.find((child)=>Array.isArray(child) && child[0] === 'BASEGEOGCRS') ? this.convert(node.find((child)=>Array.isArray(child) && child[0] === 'BASEGEOGCRS')) : null;
                result.conversion = node.find((child)=>Array.isArray(child) && child[0] === 'CONVERSION') ? this.convert(node.find((child)=>Array.isArray(child) && child[0] === 'CONVERSION')) : null;
                const csNode = node.find((child)=>Array.isArray(child) && child[0] === 'CS');
                if (csNode) result.coordinate_system = {
                    type: csNode[1],
                    axis: this.extractAxes(node)
                };
                const lengthUnitNode = node.find((child)=>Array.isArray(child) && child[0] === 'LENGTHUNIT');
                if (lengthUnitNode) {
                    const unit = this.convertUnit(lengthUnitNode);
                    result.coordinate_system.unit = unit; // Add unit to coordinate_system
                }
                result.id = this.getId(node);
                break;
            case 'BASEGEOGCRS':
            case 'GEOGCRS':
                result.type = 'GeographicCRS';
                result.name = node[1];
                // Handle DATUM or ENSEMBLE
                const datumOrEnsembleNode = node.find((child)=>Array.isArray(child) && (child[0] === 'DATUM' || child[0] === 'ENSEMBLE'));
                if (datumOrEnsembleNode) {
                    const datumOrEnsemble = this.convert(datumOrEnsembleNode);
                    if (datumOrEnsembleNode[0] === 'ENSEMBLE') result.datum_ensemble = datumOrEnsemble;
                    else result.datum = datumOrEnsemble;
                    const primem = node.find((child)=>Array.isArray(child) && child[0] === 'PRIMEM');
                    if (primem && primem[1] !== 'Greenwich') datumOrEnsemble.prime_meridian = {
                        name: primem[1],
                        longitude: parseFloat(primem[2])
                    };
                }
                result.coordinate_system = {
                    type: 'ellipsoidal',
                    axis: this.extractAxes(node)
                };
                result.id = this.getId(node);
                break;
            case 'DATUM':
                result.type = 'GeodeticReferenceFrame';
                result.name = node[1];
                result.ellipsoid = node.find((child)=>Array.isArray(child) && child[0] === 'ELLIPSOID') ? this.convert(node.find((child)=>Array.isArray(child) && child[0] === 'ELLIPSOID')) : null;
                break;
            case 'ENSEMBLE':
                result.type = 'DatumEnsemble';
                result.name = node[1];
                // Extract ensemble members
                result.members = node.filter((child)=>Array.isArray(child) && child[0] === 'MEMBER').map((member)=>({
                        type: 'DatumEnsembleMember',
                        name: member[1],
                        id: this.getId(member)
                    }));
                // Extract accuracy
                const accuracyNode = node.find((child)=>Array.isArray(child) && child[0] === 'ENSEMBLEACCURACY');
                if (accuracyNode) result.accuracy = parseFloat(accuracyNode[1]);
                // Extract ellipsoid
                const ellipsoidNode = node.find((child)=>Array.isArray(child) && child[0] === 'ELLIPSOID');
                if (ellipsoidNode) result.ellipsoid = this.convert(ellipsoidNode); // Convert the ellipsoid node
                // Extract identifier for the ensemble
                result.id = this.getId(node);
                break;
            case 'ELLIPSOID':
                result.type = 'Ellipsoid';
                result.name = node[1];
                result.semi_major_axis = parseFloat(node[2]);
                result.inverse_flattening = parseFloat(node[3]);
                const units = node.find((child)=>Array.isArray(child) && child[0] === 'LENGTHUNIT') ? this.convert(node.find((child)=>Array.isArray(child) && child[0] === 'LENGTHUNIT'), result) : null;
                break;
            case 'CONVERSION':
                result.type = 'Conversion';
                result.name = node[1];
                result.method = node.find((child)=>Array.isArray(child) && child[0] === 'METHOD') ? this.convert(node.find((child)=>Array.isArray(child) && child[0] === 'METHOD')) : null;
                result.parameters = node.filter((child)=>Array.isArray(child) && child[0] === 'PARAMETER').map((param)=>this.convert(param));
                break;
            case 'METHOD':
                result.type = 'Method';
                result.name = node[1];
                result.id = this.getId(node);
                break;
            case 'PARAMETER':
                result.type = 'Parameter';
                result.name = node[1];
                result.value = parseFloat(node[2]);
                result.unit = this.convertUnit(node.find((child)=>Array.isArray(child) && (child[0] === 'LENGTHUNIT' || child[0] === 'ANGLEUNIT' || child[0] === 'SCALEUNIT')));
                result.id = this.getId(node);
                break;
            case 'BOUNDCRS':
                result.type = 'BoundCRS';
                // Process SOURCECRS
                const sourceCrsNode = node.find((child)=>Array.isArray(child) && child[0] === 'SOURCECRS');
                if (sourceCrsNode) {
                    const sourceCrsContent = sourceCrsNode.find((child)=>Array.isArray(child));
                    result.source_crs = sourceCrsContent ? this.convert(sourceCrsContent) : null;
                }
                // Process TARGETCRS
                const targetCrsNode = node.find((child)=>Array.isArray(child) && child[0] === 'TARGETCRS');
                if (targetCrsNode) {
                    const targetCrsContent = targetCrsNode.find((child)=>Array.isArray(child));
                    result.target_crs = targetCrsContent ? this.convert(targetCrsContent) : null;
                }
                // Process ABRIDGEDTRANSFORMATION
                const transformationNode = node.find((child)=>Array.isArray(child) && child[0] === 'ABRIDGEDTRANSFORMATION');
                if (transformationNode) result.transformation = this.convert(transformationNode);
                else result.transformation = null;
                break;
            case 'ABRIDGEDTRANSFORMATION':
                result.type = 'Transformation';
                result.name = node[1];
                result.method = node.find((child)=>Array.isArray(child) && child[0] === 'METHOD') ? this.convert(node.find((child)=>Array.isArray(child) && child[0] === 'METHOD')) : null;
                result.parameters = node.filter((child)=>Array.isArray(child) && (child[0] === 'PARAMETER' || child[0] === 'PARAMETERFILE')).map((param)=>{
                    if (param[0] === 'PARAMETER') return this.convert(param);
                    else if (param[0] === 'PARAMETERFILE') return {
                        name: param[1],
                        value: param[2],
                        id: {
                            'authority': 'EPSG',
                            'code': 8656
                        }
                    };
                });
                // Adjust the Scale difference parameter if present
                if (result.parameters.length === 7) {
                    const scaleDifference = result.parameters[6];
                    if (scaleDifference.name === 'Scale difference') scaleDifference.value = Math.round((scaleDifference.value - 1) * 1e12) / 1e6;
                }
                result.id = this.getId(node);
                break;
            case 'AXIS':
                if (!result.coordinate_system) result.coordinate_system = {
                    type: 'unspecified',
                    axis: []
                };
                result.coordinate_system.axis.push(this.convertAxis(node));
                break;
            case 'LENGTHUNIT':
                const unit = this.convertUnit(node, 'LinearUnit');
                if (result.coordinate_system && result.coordinate_system.axis) result.coordinate_system.axis.forEach((axis)=>{
                    if (!axis.unit) axis.unit = unit;
                });
                if (unit.conversion_factor && unit.conversion_factor !== 1) {
                    if (result.semi_major_axis) result.semi_major_axis = {
                        value: result.semi_major_axis,
                        unit: unit
                    };
                }
                break;
            default:
                result.keyword = node[0];
                break;
        }
        return result;
    }
}
var $ba253e570caf793b$export$2e2bcd8739ae039 = $ba253e570caf793b$var$PROJJSONBuilderBase;

});


parcelRegister("7HCiu", function(module, exports) {

$parcel$export(module.exports, "default", () => $59ba41957df98247$export$2e2bcd8739ae039);

var $fYQzQ = parcelRequire("fYQzQ");
class $59ba41957df98247$var$PROJJSONBuilder2019 extends (0, $fYQzQ.default) {
    static convert(node, result = {}) {
        super.convert(node, result);
        // Handle `CS` node for WKT2-2019
        const csNode = node.find((child)=>Array.isArray(child) && child[0] === 'CS');
        if (csNode) result.coordinate_system = {
            subtype: csNode[1],
            axis: this.extractAxes(node)
        };
        // Handle `USAGE` node for WKT2-2019
        const usageNode = node.find((child)=>Array.isArray(child) && child[0] === 'USAGE');
        if (usageNode) {
            const scope = usageNode.find((child)=>Array.isArray(child) && child[0] === 'SCOPE');
            const area = usageNode.find((child)=>Array.isArray(child) && child[0] === 'AREA');
            const bbox = usageNode.find((child)=>Array.isArray(child) && child[0] === 'BBOX');
            result.usage = {};
            if (scope) result.usage.scope = scope[1];
            if (area) result.usage.area = area[1];
            if (bbox) result.usage.bbox = bbox.slice(1);
        }
        return result;
    }
}
var $59ba41957df98247$export$2e2bcd8739ae039 = $59ba41957df98247$var$PROJJSONBuilder2019;

});


parcelRegister("ad1Gh", function(module, exports) {

$parcel$export(module.exports, "detectWKTVersion", () => $76ec6c11849d6ec6$export$9362d65e4771b5d5);
/**
 * Detects whether the WKT string is WKT1 or WKT2.
 * @param {string} wkt The WKT string.
 * @returns {string} The detected version ("WKT1" or "WKT2").
 */ function $76ec6c11849d6ec6$export$9362d65e4771b5d5(wkt) {
    // Normalize the WKT string for easier keyword matching
    const normalizedWKT = wkt.toUpperCase();
    // Check for WKT2-specific keywords
    if (normalizedWKT.includes('PROJCRS') || normalizedWKT.includes('GEOGCRS') || normalizedWKT.includes('BOUNDCRS') || normalizedWKT.includes('VERTCRS') || normalizedWKT.includes('LENGTHUNIT') || normalizedWKT.includes('ANGLEUNIT') || normalizedWKT.includes('SCALEUNIT')) return 'WKT2';
    // Check for WKT1-specific keywords
    if (normalizedWKT.includes('PROJCS') || normalizedWKT.includes('GEOGCS') || normalizedWKT.includes('LOCAL_CS') || normalizedWKT.includes('VERT_CS') || normalizedWKT.includes('UNIT')) return 'WKT1';
    // Default to WKT1 if no specific indicators are found
    return 'WKT1';
}

});

parcelRegister("6Pz8X", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f92c43f9960a1f4$export$2e2bcd8739ae039);
var $4f92c43f9960a1f4$export$2e2bcd8739ae039 = $4f92c43f9960a1f4$var$parseString;
var $4f92c43f9960a1f4$var$NEUTRAL = 1;
var $4f92c43f9960a1f4$var$KEYWORD = 2;
var $4f92c43f9960a1f4$var$NUMBER = 3;
var $4f92c43f9960a1f4$var$QUOTED = 4;
var $4f92c43f9960a1f4$var$AFTERQUOTE = 5;
var $4f92c43f9960a1f4$var$ENDED = -1;
var $4f92c43f9960a1f4$var$whitespace = /\s/;
var $4f92c43f9960a1f4$var$latin = /[A-Za-z]/;
var $4f92c43f9960a1f4$var$keyword = /[A-Za-z84_]/;
var $4f92c43f9960a1f4$var$endThings = /[,\]]/;
var $4f92c43f9960a1f4$var$digets = /[\d\.E\-\+]/;
// const ignoredChar = /[\s_\-\/\(\)]/g;
function $4f92c43f9960a1f4$var$Parser(text) {
    if (typeof text !== 'string') throw new Error('not a string');
    this.text = text.trim();
    this.level = 0;
    this.place = 0;
    this.root = null;
    this.stack = [];
    this.currentObject = null;
    this.state = $4f92c43f9960a1f4$var$NEUTRAL;
}
$4f92c43f9960a1f4$var$Parser.prototype.readCharicter = function() {
    var char = this.text[this.place++];
    if (this.state !== $4f92c43f9960a1f4$var$QUOTED) while($4f92c43f9960a1f4$var$whitespace.test(char)){
        if (this.place >= this.text.length) return;
        char = this.text[this.place++];
    }
    switch(this.state){
        case $4f92c43f9960a1f4$var$NEUTRAL:
            return this.neutral(char);
        case $4f92c43f9960a1f4$var$KEYWORD:
            return this.keyword(char);
        case $4f92c43f9960a1f4$var$QUOTED:
            return this.quoted(char);
        case $4f92c43f9960a1f4$var$AFTERQUOTE:
            return this.afterquote(char);
        case $4f92c43f9960a1f4$var$NUMBER:
            return this.number(char);
        case $4f92c43f9960a1f4$var$ENDED:
            return;
    }
};
$4f92c43f9960a1f4$var$Parser.prototype.afterquote = function(char) {
    if (char === '"') {
        this.word += '"';
        this.state = $4f92c43f9960a1f4$var$QUOTED;
        return;
    }
    if ($4f92c43f9960a1f4$var$endThings.test(char)) {
        this.word = this.word.trim();
        this.afterItem(char);
        return;
    }
    throw new Error('havn\'t handled "' + char + '" in afterquote yet, index ' + this.place);
};
$4f92c43f9960a1f4$var$Parser.prototype.afterItem = function(char) {
    if (char === ',') {
        if (this.word !== null) this.currentObject.push(this.word);
        this.word = null;
        this.state = $4f92c43f9960a1f4$var$NEUTRAL;
        return;
    }
    if (char === ']') {
        this.level--;
        if (this.word !== null) {
            this.currentObject.push(this.word);
            this.word = null;
        }
        this.state = $4f92c43f9960a1f4$var$NEUTRAL;
        this.currentObject = this.stack.pop();
        if (!this.currentObject) this.state = $4f92c43f9960a1f4$var$ENDED;
        return;
    }
};
$4f92c43f9960a1f4$var$Parser.prototype.number = function(char) {
    if ($4f92c43f9960a1f4$var$digets.test(char)) {
        this.word += char;
        return;
    }
    if ($4f92c43f9960a1f4$var$endThings.test(char)) {
        this.word = parseFloat(this.word);
        this.afterItem(char);
        return;
    }
    throw new Error('havn\'t handled "' + char + '" in number yet, index ' + this.place);
};
$4f92c43f9960a1f4$var$Parser.prototype.quoted = function(char) {
    if (char === '"') {
        this.state = $4f92c43f9960a1f4$var$AFTERQUOTE;
        return;
    }
    this.word += char;
    return;
};
$4f92c43f9960a1f4$var$Parser.prototype.keyword = function(char) {
    if ($4f92c43f9960a1f4$var$keyword.test(char)) {
        this.word += char;
        return;
    }
    if (char === '[') {
        var newObjects = [];
        newObjects.push(this.word);
        this.level++;
        if (this.root === null) this.root = newObjects;
        else this.currentObject.push(newObjects);
        this.stack.push(this.currentObject);
        this.currentObject = newObjects;
        this.state = $4f92c43f9960a1f4$var$NEUTRAL;
        return;
    }
    if ($4f92c43f9960a1f4$var$endThings.test(char)) {
        this.afterItem(char);
        return;
    }
    throw new Error('havn\'t handled "' + char + '" in keyword yet, index ' + this.place);
};
$4f92c43f9960a1f4$var$Parser.prototype.neutral = function(char) {
    if ($4f92c43f9960a1f4$var$latin.test(char)) {
        this.word = char;
        this.state = $4f92c43f9960a1f4$var$KEYWORD;
        return;
    }
    if (char === '"') {
        this.word = '';
        this.state = $4f92c43f9960a1f4$var$QUOTED;
        return;
    }
    if ($4f92c43f9960a1f4$var$digets.test(char)) {
        this.word = char;
        this.state = $4f92c43f9960a1f4$var$NUMBER;
        return;
    }
    if ($4f92c43f9960a1f4$var$endThings.test(char)) {
        this.afterItem(char);
        return;
    }
    throw new Error('havn\'t handled "' + char + '" in neutral yet, index ' + this.place);
};
$4f92c43f9960a1f4$var$Parser.prototype.output = function() {
    while(this.place < this.text.length)this.readCharicter();
    if (this.state === $4f92c43f9960a1f4$var$ENDED) return this.root;
    throw new Error('unable to parse string "' + this.text + '". State is ' + this.state);
};
function $4f92c43f9960a1f4$var$parseString(txt) {
    var parser = new $4f92c43f9960a1f4$var$Parser(txt);
    return parser.output();
}

});

parcelRegister("7SVqc", function(module, exports) {

$parcel$export(module.exports, "sExpr", () => $5bda1e467f1c2649$export$337bc7a3aef1f775);
function $5bda1e467f1c2649$var$mapit(obj, key, value) {
    if (Array.isArray(key)) {
        value.unshift(key);
        key = null;
    }
    var thing = key ? {} : obj;
    var out = value.reduce(function(newObj, item) {
        $5bda1e467f1c2649$export$337bc7a3aef1f775(item, newObj);
        return newObj;
    }, thing);
    if (key) obj[key] = out;
}
function $5bda1e467f1c2649$export$337bc7a3aef1f775(v, obj) {
    if (!Array.isArray(v)) {
        obj[v] = true;
        return;
    }
    var key = v.shift();
    if (key === 'PARAMETER') key = v.shift();
    if (v.length === 1) {
        if (Array.isArray(v[0])) {
            obj[key] = {};
            $5bda1e467f1c2649$export$337bc7a3aef1f775(v[0], obj[key]);
            return;
        }
        obj[key] = v[0];
        return;
    }
    if (!v.length) {
        obj[key] = true;
        return;
    }
    if (key === 'TOWGS84') {
        obj[key] = v;
        return;
    }
    if (key === 'AXIS') {
        if (!(key in obj)) obj[key] = [];
        obj[key].push(v);
        return;
    }
    if (!Array.isArray(key)) obj[key] = {};
    var i;
    switch(key){
        case 'UNIT':
        case 'PRIMEM':
        case 'VERT_DATUM':
            obj[key] = {
                name: v[0].toLowerCase(),
                convert: v[1]
            };
            if (v.length === 3) $5bda1e467f1c2649$export$337bc7a3aef1f775(v[2], obj[key]);
            return;
        case 'SPHEROID':
        case 'ELLIPSOID':
            obj[key] = {
                name: v[0],
                a: v[1],
                rf: v[2]
            };
            if (v.length === 4) $5bda1e467f1c2649$export$337bc7a3aef1f775(v[3], obj[key]);
            return;
        case 'EDATUM':
        case 'ENGINEERINGDATUM':
        case 'LOCAL_DATUM':
        case 'DATUM':
        case 'VERT_CS':
        case 'VERTCRS':
        case 'VERTICALCRS':
            v[0] = [
                'name',
                v[0]
            ];
            $5bda1e467f1c2649$var$mapit(obj, key, v);
            return;
        case 'COMPD_CS':
        case 'COMPOUNDCRS':
        case 'FITTED_CS':
        // the followings are the crs defined in
        // https://github.com/proj4js/proj4js/blob/1da4ed0b865d0fcb51c136090569210cdcc9019e/lib/parseCode.js#L11
        case 'PROJECTEDCRS':
        case 'PROJCRS':
        case 'GEOGCS':
        case 'GEOCCS':
        case 'PROJCS':
        case 'LOCAL_CS':
        case 'GEODCRS':
        case 'GEODETICCRS':
        case 'GEODETICDATUM':
        case 'ENGCRS':
        case 'ENGINEERINGCRS':
            v[0] = [
                'name',
                v[0]
            ];
            $5bda1e467f1c2649$var$mapit(obj, key, v);
            obj[key].type = key;
            return;
        default:
            i = -1;
            while(++i < v.length){
                if (!Array.isArray(v[i])) return $5bda1e467f1c2649$export$337bc7a3aef1f775(v, obj[key]);
            }
            return $5bda1e467f1c2649$var$mapit(obj, key, v);
    }
}

});

parcelRegister("hwbbo", function(module, exports) {

$parcel$export(module.exports, "transformPROJJSON", () => $cc0e197ab4726924$export$b04e619e90585ec3);

var $am47V = parcelRequire("am47V");
// Helper function to process units and to_meter
function $cc0e197ab4726924$var$processUnit(unit) {
    let result = {
        units: null,
        to_meter: undefined
    };
    if (typeof unit === 'string') {
        result.units = unit.toLowerCase();
        if (result.units === 'metre') result.units = 'meter'; // Normalize 'metre' to 'meter'
        if (result.units === 'meter') result.to_meter = 1; // Only set to_meter if units are 'meter'
    } else if (unit && unit.name) {
        result.units = unit.name.toLowerCase();
        if (result.units === 'metre') result.units = 'meter'; // Normalize 'metre' to 'meter'
        result.to_meter = unit.conversion_factor;
    }
    return result;
}
function $cc0e197ab4726924$var$toValue(valueOrObject) {
    if (typeof valueOrObject === 'object') return valueOrObject.value * valueOrObject.unit.conversion_factor;
    return valueOrObject;
}
function $cc0e197ab4726924$var$calculateEllipsoid(value, result) {
    if (value.ellipsoid.radius) {
        result.a = value.ellipsoid.radius;
        result.rf = 0;
    } else {
        result.a = $cc0e197ab4726924$var$toValue(value.ellipsoid.semi_major_axis);
        if (value.ellipsoid.inverse_flattening !== undefined) result.rf = value.ellipsoid.inverse_flattening;
        else if (value.ellipsoid.semi_major_axis !== undefined && value.ellipsoid.semi_minor_axis !== undefined) result.rf = result.a / (result.a - $cc0e197ab4726924$var$toValue(value.ellipsoid.semi_minor_axis));
    }
}
function $cc0e197ab4726924$export$b04e619e90585ec3(projjson, result = {}) {
    if (!projjson || typeof projjson !== 'object') return projjson; // Return primitive values as-is
    if (projjson.type === 'BoundCRS') {
        $cc0e197ab4726924$export$b04e619e90585ec3(projjson.source_crs, result);
        if (projjson.transformation) {
            if (projjson.transformation.method && projjson.transformation.method.name === 'NTv2') // Set nadgrids to the filename from the parameterfile
            result.nadgrids = projjson.transformation.parameters[0].value;
            else // Populate datum_params if no parameterfile is found
            result.datum_params = projjson.transformation.parameters.map((param)=>param.value);
        }
        return result; // Return early for BoundCRS
    }
    // Handle specific keys in PROJJSON
    Object.keys(projjson).forEach((key)=>{
        const value = projjson[key];
        if (value === null) return;
        switch(key){
            case 'name':
                if (result.srsCode) break;
                result.name = value;
                result.srsCode = value; // Map `name` to `srsCode`
                break;
            case 'type':
                if (value === 'GeographicCRS') result.projName = 'longlat';
                else if (value === 'ProjectedCRS' && projjson.conversion && projjson.conversion.method) result.projName = projjson.conversion.method.name; // Retain original capitalization
                break;
            case 'datum':
            case 'datum_ensemble':
                if (value.ellipsoid) {
                    // Extract ellipsoid properties
                    result.ellps = value.ellipsoid.name;
                    $cc0e197ab4726924$var$calculateEllipsoid(value, result);
                }
                if (value.prime_meridian) result.from_greenwich = value.prime_meridian.longitude * Math.PI / 180; // Convert to radians
                break;
            case 'ellipsoid':
                result.ellps = value.name;
                $cc0e197ab4726924$var$calculateEllipsoid(value, result);
                break;
            case 'prime_meridian':
                result.long0 = (value.longitude || 0) * Math.PI / 180; // Convert to radians
                break;
            case 'coordinate_system':
                if (value.axis) {
                    result.axis = value.axis.map((axis)=>{
                        const direction = axis.direction;
                        if (direction === 'east') return 'e';
                        if (direction === 'north') return 'n';
                        if (direction === 'west') return 'w';
                        if (direction === 'south') return 's';
                        throw new Error(`Unknown axis direction: ${direction}`);
                    }).join('') + 'u'; // Combine into a single string (e.g., "enu")
                    if (value.unit) {
                        const { units: units, to_meter: to_meter } = $cc0e197ab4726924$var$processUnit(value.unit);
                        result.units = units;
                        result.to_meter = to_meter;
                    } else if (value.axis[0] && value.axis[0].unit) {
                        const { units: units, to_meter: to_meter } = $cc0e197ab4726924$var$processUnit(value.axis[0].unit);
                        result.units = units;
                        result.to_meter = to_meter;
                    }
                }
                break;
            case 'id':
                if (value.authority && value.code) result.title = value.authority + ':' + value.code;
                break;
            case 'conversion':
                if (value.method && value.method.name) result.projName = value.method.name; // Retain original capitalization
                if (value.parameters) value.parameters.forEach((param)=>{
                    const paramName = param.name.toLowerCase().replace(/\s+/g, '_');
                    const paramValue = param.value;
                    if (param.unit && param.unit.conversion_factor) result[paramName] = paramValue * param.unit.conversion_factor; // Convert to radians or meters
                    else if (param.unit === 'degree') result[paramName] = paramValue * Math.PI / 180; // Convert to radians
                    else result[paramName] = paramValue;
                });
                break;
            case 'unit':
                if (value.name) {
                    result.units = value.name.toLowerCase();
                    if (result.units === 'metre') result.units = 'meter';
                }
                if (value.conversion_factor) result.to_meter = value.conversion_factor;
                break;
            case 'base_crs':
                $cc0e197ab4726924$export$b04e619e90585ec3(value, result); // Pass `result` directly
                result.datumCode = value.id ? value.id.authority + '_' + value.id.code : value.name; // Set datumCode
                break;
            default:
                break;
        }
    });
    // Additional calculated properties
    if (result.latitude_of_false_origin !== undefined) result.lat0 = result.latitude_of_false_origin; // Already in radians
    if (result.longitude_of_false_origin !== undefined) result.long0 = result.longitude_of_false_origin;
    if (result.latitude_of_standard_parallel !== undefined) {
        result.lat0 = result.latitude_of_standard_parallel;
        result.lat1 = result.latitude_of_standard_parallel;
    }
    if (result.latitude_of_1st_standard_parallel !== undefined) result.lat1 = result.latitude_of_1st_standard_parallel;
    if (result.latitude_of_2nd_standard_parallel !== undefined) result.lat2 = result.latitude_of_2nd_standard_parallel;
    if (result.latitude_of_projection_centre !== undefined) result.lat0 = result.latitude_of_projection_centre;
    if (result.longitude_of_projection_centre !== undefined) result.longc = result.longitude_of_projection_centre;
    if (result.easting_at_false_origin !== undefined) result.x0 = result.easting_at_false_origin;
    if (result.northing_at_false_origin !== undefined) result.y0 = result.northing_at_false_origin;
    if (result.latitude_of_natural_origin !== undefined) result.lat0 = result.latitude_of_natural_origin;
    if (result.longitude_of_natural_origin !== undefined) result.long0 = result.longitude_of_natural_origin;
    if (result.longitude_of_origin !== undefined) result.long0 = result.longitude_of_origin;
    if (result.false_easting !== undefined) result.x0 = result.false_easting;
    if (result.easting_at_projection_centre) result.x0 = result.easting_at_projection_centre;
    if (result.false_northing !== undefined) result.y0 = result.false_northing;
    if (result.northing_at_projection_centre) result.y0 = result.northing_at_projection_centre;
    if (result.standard_parallel_1 !== undefined) result.lat1 = result.standard_parallel_1;
    if (result.standard_parallel_2 !== undefined) result.lat2 = result.standard_parallel_2;
    if (result.scale_factor_at_natural_origin !== undefined) result.k0 = result.scale_factor_at_natural_origin;
    if (result.scale_factor_at_projection_centre !== undefined) result.k0 = result.scale_factor_at_projection_centre;
    if (result.scale_factor_on_pseudo_standard_parallel !== undefined) result.k0 = result.scale_factor_on_pseudo_standard_parallel;
    if (result.azimuth !== undefined) result.alpha = result.azimuth;
    if (result.azimuth_at_projection_centre !== undefined) result.alpha = result.azimuth_at_projection_centre;
    if (result.angle_from_rectified_to_skew_grid) result.rectified_grid_angle = result.angle_from_rectified_to_skew_grid;
    // Apply projection defaults
    (0, $am47V.applyProjectionDefaults)(result);
    return result;
}

});
parcelRegister("am47V", function(module, exports) {

$parcel$export(module.exports, "d2r", () => $789f28efd4cd941a$export$e726aea149b4fd71);
$parcel$export(module.exports, "applyProjectionDefaults", () => $789f28efd4cd941a$export$d6def86a6ec68808);
var $789f28efd4cd941a$var$D2R = 0.01745329251994329577;
function $789f28efd4cd941a$export$e726aea149b4fd71(input) {
    return input * $789f28efd4cd941a$var$D2R;
}
function $789f28efd4cd941a$export$d6def86a6ec68808(wkt) {
    // Normalize projName for WKT2 compatibility
    const normalizedProjName = (wkt.projName || '').toLowerCase().replace(/_/g, ' ');
    if (!wkt.long0 && wkt.longc && (normalizedProjName === 'albers conic equal area' || normalizedProjName === 'lambert azimuthal equal area')) wkt.long0 = wkt.longc;
    if (!wkt.lat_ts && wkt.lat1 && (normalizedProjName === 'stereographic south pole' || normalizedProjName === 'polar stereographic (variant b)')) {
        wkt.lat0 = $789f28efd4cd941a$export$e726aea149b4fd71(wkt.lat1 > 0 ? 90 : -90);
        wkt.lat_ts = wkt.lat1;
        delete wkt.lat1;
    } else if (!wkt.lat_ts && wkt.lat0 && (normalizedProjName === 'polar stereographic' || normalizedProjName === 'polar stereographic (variant a)')) {
        wkt.lat_ts = wkt.lat0;
        wkt.lat0 = $789f28efd4cd941a$export$e726aea149b4fd71(wkt.lat0 > 0 ? 90 : -90);
        delete wkt.lat1;
    }
}

});





parcelRegister("cWauz", function(module, exports) {

$parcel$export(module.exports, "default", () => $96b30a4c80088893$export$2e2bcd8739ae039);
function $96b30a4c80088893$export$2e2bcd8739ae039(destination, source) {
    destination = destination || {};
    var value, property;
    if (!source) return destination;
    for(property in source){
        value = source[property];
        if (value !== undefined) destination[property] = value;
    }
    return destination;
}

});

parcelRegister("1Wo5P", function(module, exports) {

$parcel$export(module.exports, "getNormalizedProjName", () => $169de593aeaa174c$export$9ee0bb5510679155);
$parcel$export(module.exports, "default", () => $169de593aeaa174c$export$2e2bcd8739ae039);

var $ioIYn = parcelRequire("ioIYn");

var $iMMJV = parcelRequire("iMMJV");
/** @type {Array<Partial<import('./Proj').default>>} */ var $169de593aeaa174c$var$projs = [
    (0, $ioIYn.default),
    (0, $iMMJV.default)
];
var $169de593aeaa174c$var$names = {};
var $169de593aeaa174c$var$projStore = [];
function $169de593aeaa174c$export$e16d8520af44a096(proj, i) {
    var len = $169de593aeaa174c$var$projStore.length;
    if (!proj.names) {
        console.log(i);
        return true;
    }
    $169de593aeaa174c$var$projStore[len] = proj;
    proj.names.forEach(function(n) {
        $169de593aeaa174c$var$names[n.toLowerCase()] = len;
    });
    return this;
}
function $169de593aeaa174c$export$9ee0bb5510679155(n) {
    return n.replace(/[-\(\)\s]+/g, ' ').trim().replace(/ /g, '_');
}
function $169de593aeaa174c$export$3988ae62b71be9a3(name) {
    if (!name) return false;
    var n = name.toLowerCase();
    if (typeof $169de593aeaa174c$var$names[n] !== 'undefined' && $169de593aeaa174c$var$projStore[$169de593aeaa174c$var$names[n]]) return $169de593aeaa174c$var$projStore[$169de593aeaa174c$var$names[n]];
    n = $169de593aeaa174c$export$9ee0bb5510679155(n);
    if (n in $169de593aeaa174c$var$names && $169de593aeaa174c$var$projStore[$169de593aeaa174c$var$names[n]]) return $169de593aeaa174c$var$projStore[$169de593aeaa174c$var$names[n]];
}
function $169de593aeaa174c$export$b3571188c770cc5a() {
    $169de593aeaa174c$var$projs.forEach($169de593aeaa174c$export$e16d8520af44a096);
}
var $169de593aeaa174c$export$2e2bcd8739ae039 = {
    start: $169de593aeaa174c$export$b3571188c770cc5a,
    add: $169de593aeaa174c$export$e16d8520af44a096,
    get: $169de593aeaa174c$export$3988ae62b71be9a3
};

});
parcelRegister("ioIYn", function(module, exports) {

$parcel$export(module.exports, "default", () => $d64d5a882433f366$export$2e2bcd8739ae039);

var $bi5ZC = parcelRequire("bi5ZC");

var $a9oRf = parcelRequire("a9oRf");

var $3xC66 = parcelRequire("3xC66");

var $2AZR8 = parcelRequire("2AZR8");

var $gyVUi = parcelRequire("gyVUi");
function $d64d5a882433f366$export$2cd8252107eb640b() {
    var con = this.b / this.a;
    this.es = 1 - con * con;
    if (!('x0' in this)) this.x0 = 0;
    if (!('y0' in this)) this.y0 = 0;
    this.e = Math.sqrt(this.es);
    if (this.lat_ts) {
        if (this.sphere) this.k0 = Math.cos(this.lat_ts);
        else this.k0 = (0, $bi5ZC.default)(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts));
    } else if (!this.k0) {
        if (this.k) this.k0 = this.k;
        else this.k0 = 1;
    }
}
function $d64d5a882433f366$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    // convert to radians
    if (lat * (0, $gyVUi.R2D) > 90 && lat * (0, $gyVUi.R2D) < -90 && lon * (0, $gyVUi.R2D) > 180 && lon * (0, $gyVUi.R2D) < -180) return null;
    var x, y;
    if (Math.abs(Math.abs(lat) - (0, $gyVUi.HALF_PI)) <= (0, $gyVUi.EPSLN)) return null;
    else {
        if (this.sphere) {
            x = this.x0 + this.a * this.k0 * (0, $a9oRf.default)(lon - this.long0, this.over);
            y = this.y0 + this.a * this.k0 * Math.log(Math.tan((0, $gyVUi.FORTPI) + 0.5 * lat));
        } else {
            var sinphi = Math.sin(lat);
            var ts = (0, $3xC66.default)(this.e, lat, sinphi);
            x = this.x0 + this.a * this.k0 * (0, $a9oRf.default)(lon - this.long0, this.over);
            y = this.y0 - this.a * this.k0 * Math.log(ts);
        }
        p.x = x;
        p.y = y;
        return p;
    }
}
function $d64d5a882433f366$export$70ae2c07e401031b(p) {
    var x = p.x - this.x0;
    var y = p.y - this.y0;
    var lon, lat;
    if (this.sphere) lat = (0, $gyVUi.HALF_PI) - 2 * Math.atan(Math.exp(-y / (this.a * this.k0)));
    else {
        var ts = Math.exp(-y / (this.a * this.k0));
        lat = (0, $2AZR8.default)(this.e, ts);
        if (lat === -9999) return null;
    }
    lon = (0, $a9oRf.default)(this.long0 + x / (this.a * this.k0), this.over);
    p.x = lon;
    p.y = lat;
    return p;
}
var $d64d5a882433f366$export$e4b2ac9215619f8d = [
    'Mercator',
    'Popular Visualisation Pseudo Mercator',
    'Mercator_1SP',
    'Mercator_Auxiliary_Sphere',
    'Mercator_Variant_A',
    'merc'
];
var $d64d5a882433f366$export$2e2bcd8739ae039 = {
    init: $d64d5a882433f366$export$2cd8252107eb640b,
    forward: $d64d5a882433f366$export$174bb771924e7eb1,
    inverse: $d64d5a882433f366$export$70ae2c07e401031b,
    names: $d64d5a882433f366$export$e4b2ac9215619f8d
};

});
parcelRegister("bi5ZC", function(module, exports) {

$parcel$export(module.exports, "default", () => $8386063044328ea8$export$2e2bcd8739ae039);
function $8386063044328ea8$export$2e2bcd8739ae039(eccent, sinphi, cosphi) {
    var con = eccent * sinphi;
    return cosphi / Math.sqrt(1 - con * con);
}

});

parcelRegister("a9oRf", function(module, exports) {

$parcel$export(module.exports, "default", () => $763e06e438986b6c$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");

var $boTd3 = parcelRequire("boTd3");
function $763e06e438986b6c$export$2e2bcd8739ae039(x, skipAdjust) {
    if (skipAdjust) return x;
    return Math.abs(x) <= (0, $gyVUi.SPI) ? x : x - (0, $boTd3.default)(x) * (0, $gyVUi.TWO_PI);
}

});
parcelRegister("boTd3", function(module, exports) {

$parcel$export(module.exports, "default", () => $84ccc316da8510bf$export$2e2bcd8739ae039);
function $84ccc316da8510bf$export$2e2bcd8739ae039(x) {
    return x < 0 ? -1 : 1;
}

});


parcelRegister("3xC66", function(module, exports) {

$parcel$export(module.exports, "default", () => $2942018063c2eff1$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");
function $2942018063c2eff1$export$2e2bcd8739ae039(eccent, phi, sinphi) {
    var con = eccent * sinphi;
    var com = 0.5 * eccent;
    con = Math.pow((1 - con) / (1 + con), com);
    return Math.tan(0.5 * ((0, $gyVUi.HALF_PI) - phi)) / con;
}

});

parcelRegister("2AZR8", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e3eece278ef2a71$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");
function $1e3eece278ef2a71$export$2e2bcd8739ae039(eccent, ts) {
    var eccnth = 0.5 * eccent;
    var con, dphi;
    var phi = (0, $gyVUi.HALF_PI) - 2 * Math.atan(ts);
    for(var i = 0; i <= 15; i++){
        con = eccent * Math.sin(phi);
        dphi = (0, $gyVUi.HALF_PI) - 2 * Math.atan(ts * Math.pow((1 - con) / (1 + con), eccnth)) - phi;
        phi += dphi;
        if (Math.abs(dphi) <= 0.0000000001) return phi;
    }
    // console.log("phi2z has NoConvergence");
    return -9999;
}

});


parcelRegister("iMMJV", function(module, exports) {

$parcel$export(module.exports, "names", () => $dad2845bfa7291b9$export$e4b2ac9215619f8d);
$parcel$export(module.exports, "default", () => $dad2845bfa7291b9$export$2e2bcd8739ae039);
function $dad2845bfa7291b9$export$2cd8252107eb640b() {
// no-op for longlat
}
function $dad2845bfa7291b9$export$174bb771924e7eb1(pt) {
    return pt;
}
var $dad2845bfa7291b9$export$e4b2ac9215619f8d = [
    'longlat',
    'identity'
];
var $dad2845bfa7291b9$export$2e2bcd8739ae039 = {
    init: $dad2845bfa7291b9$export$2cd8252107eb640b,
    forward: $dad2845bfa7291b9$export$174bb771924e7eb1,
    inverse: $dad2845bfa7291b9$export$174bb771924e7eb1,
    names: $dad2845bfa7291b9$export$e4b2ac9215619f8d
};

});


parcelRegister("d8b9d", function(module, exports) {

$parcel$export(module.exports, "eccentricity", () => $98f4ab684186b766$export$e3d7bf2ed2a7479f);
$parcel$export(module.exports, "sphere", () => $98f4ab684186b766$export$b2690196de52b050);

var $gyVUi = parcelRequire("gyVUi");

var $bO5FE = parcelRequire("bO5FE");

var $hzXAi = parcelRequire("hzXAi");
const $98f4ab684186b766$var$WGS84 = (0, $bO5FE.default).WGS84; // default ellipsoid
function $98f4ab684186b766$export$e3d7bf2ed2a7479f(a, b, rf, R_A) {
    var a2 = a * a; // used in geocentric
    var b2 = b * b; // used in geocentric
    var es = (a2 - b2) / a2; // e ^ 2
    var e = 0;
    if (R_A) {
        a *= 1 - es * ((0, $gyVUi.SIXTH) + es * ((0, $gyVUi.RA4) + es * (0, $gyVUi.RA6)));
        a2 = a * a;
        es = 0;
    } else e = Math.sqrt(es); // eccentricity
    var ep2 = (a2 - b2) / b2; // used in geocentric
    return {
        es: es,
        e: e,
        ep2: ep2
    };
}
function $98f4ab684186b766$export$b2690196de52b050(a, b, rf, ellps, sphere) {
    if (!a) {
        var ellipse = (0, $hzXAi.default)((0, $bO5FE.default), ellps);
        if (!ellipse) ellipse = $98f4ab684186b766$var$WGS84;
        a = ellipse.a;
        b = ellipse.b;
        rf = ellipse.rf;
    }
    if (rf && !b) b = (1.0 - 1.0 / rf) * a;
    if (rf === 0 || Math.abs(a - b) < (0, $gyVUi.EPSLN)) {
        sphere = true;
        b = a;
    }
    return {
        a: a,
        b: b,
        rf: rf,
        sphere: sphere
    };
}

});
parcelRegister("bO5FE", function(module, exports) {

$parcel$export(module.exports, "default", () => $8988c354f092c217$export$2e2bcd8739ae039);
var $8988c354f092c217$var$ellipsoids = {
    MERIT: {
        a: 6378137,
        rf: 298.257,
        ellipseName: 'MERIT 1983'
    },
    SGS85: {
        a: 6378136,
        rf: 298.257,
        ellipseName: 'Soviet Geodetic System 85'
    },
    GRS80: {
        a: 6378137,
        rf: 298.257222101,
        ellipseName: 'GRS 1980(IUGG, 1980)'
    },
    IAU76: {
        a: 6378140,
        rf: 298.257,
        ellipseName: 'IAU 1976'
    },
    airy: {
        a: 6377563.396,
        b: 6356256.91,
        ellipseName: 'Airy 1830'
    },
    APL4: {
        a: 6378137,
        rf: 298.25,
        ellipseName: 'Appl. Physics. 1965'
    },
    NWL9D: {
        a: 6378145,
        rf: 298.25,
        ellipseName: 'Naval Weapons Lab., 1965'
    },
    mod_airy: {
        a: 6377340.189,
        b: 6356034.446,
        ellipseName: 'Modified Airy'
    },
    andrae: {
        a: 6377104.43,
        rf: 300,
        ellipseName: 'Andrae 1876 (Den., Iclnd.)'
    },
    aust_SA: {
        a: 6378160,
        rf: 298.25,
        ellipseName: 'Australian Natl & S. Amer. 1969'
    },
    GRS67: {
        a: 6378160,
        rf: 298.247167427,
        ellipseName: 'GRS 67(IUGG 1967)'
    },
    bessel: {
        a: 6377397.155,
        rf: 299.1528128,
        ellipseName: 'Bessel 1841'
    },
    bess_nam: {
        a: 6377483.865,
        rf: 299.1528128,
        ellipseName: 'Bessel 1841 (Namibia)'
    },
    clrk66: {
        a: 6378206.4,
        b: 6356583.8,
        ellipseName: 'Clarke 1866'
    },
    clrk80: {
        a: 6378249.145,
        rf: 293.4663,
        ellipseName: 'Clarke 1880 mod.'
    },
    clrk80ign: {
        a: 6378249.2,
        b: 6356515,
        rf: 293.4660213,
        ellipseName: 'Clarke 1880 (IGN)'
    },
    clrk58: {
        a: 6378293.645208759,
        rf: 294.2606763692654,
        ellipseName: 'Clarke 1858'
    },
    CPM: {
        a: 6375738.7,
        rf: 334.29,
        ellipseName: 'Comm. des Poids et Mesures 1799'
    },
    delmbr: {
        a: 6376428,
        rf: 311.5,
        ellipseName: 'Delambre 1810 (Belgium)'
    },
    engelis: {
        a: 6378136.05,
        rf: 298.2566,
        ellipseName: 'Engelis 1985'
    },
    evrst30: {
        a: 6377276.345,
        rf: 300.8017,
        ellipseName: 'Everest 1830'
    },
    evrst48: {
        a: 6377304.063,
        rf: 300.8017,
        ellipseName: 'Everest 1948'
    },
    evrst56: {
        a: 6377301.243,
        rf: 300.8017,
        ellipseName: 'Everest 1956'
    },
    evrst69: {
        a: 6377295.664,
        rf: 300.8017,
        ellipseName: 'Everest 1969'
    },
    evrstSS: {
        a: 6377298.556,
        rf: 300.8017,
        ellipseName: 'Everest (Sabah & Sarawak)'
    },
    fschr60: {
        a: 6378166,
        rf: 298.3,
        ellipseName: 'Fischer (Mercury Datum) 1960'
    },
    fschr60m: {
        a: 6378155,
        rf: 298.3,
        ellipseName: 'Fischer 1960'
    },
    fschr68: {
        a: 6378150,
        rf: 298.3,
        ellipseName: 'Fischer 1968'
    },
    helmert: {
        a: 6378200,
        rf: 298.3,
        ellipseName: 'Helmert 1906'
    },
    hough: {
        a: 6378270,
        rf: 297,
        ellipseName: 'Hough'
    },
    intl: {
        a: 6378388,
        rf: 297,
        ellipseName: 'International 1909 (Hayford)'
    },
    kaula: {
        a: 6378163,
        rf: 298.24,
        ellipseName: 'Kaula 1961'
    },
    lerch: {
        a: 6378139,
        rf: 298.257,
        ellipseName: 'Lerch 1979'
    },
    mprts: {
        a: 6397300,
        rf: 191,
        ellipseName: 'Maupertius 1738'
    },
    new_intl: {
        a: 6378157.5,
        b: 6356772.2,
        ellipseName: 'New International 1967'
    },
    plessis: {
        a: 6376523,
        rf: 6355863,
        ellipseName: 'Plessis 1817 (France)'
    },
    krass: {
        a: 6378245,
        rf: 298.3,
        ellipseName: 'Krassovsky, 1942'
    },
    SEasia: {
        a: 6378155,
        b: 6356773.3205,
        ellipseName: 'Southeast Asia'
    },
    walbeck: {
        a: 6376896,
        b: 6355834.8467,
        ellipseName: 'Walbeck'
    },
    WGS60: {
        a: 6378165,
        rf: 298.3,
        ellipseName: 'WGS 60'
    },
    WGS66: {
        a: 6378145,
        rf: 298.25,
        ellipseName: 'WGS 66'
    },
    WGS7: {
        a: 6378135,
        rf: 298.26,
        ellipseName: 'WGS 72'
    },
    WGS84: {
        a: 6378137,
        rf: 298.257223563,
        ellipseName: 'WGS 84'
    },
    sphere: {
        a: 6370997,
        b: 6370997,
        ellipseName: 'Normal Sphere (r=6370997)'
    }
};
var $8988c354f092c217$export$2e2bcd8739ae039 = $8988c354f092c217$var$ellipsoids;

});


parcelRegister("gMdFS", function(module, exports) {

$parcel$export(module.exports, "default", () => $c36bbc8057de3d00$export$2e2bcd8739ae039);
var $c36bbc8057de3d00$var$datums = {
    wgs84: {
        towgs84: '0,0,0',
        ellipse: 'WGS84',
        datumName: 'WGS84'
    },
    ch1903: {
        towgs84: '674.374,15.056,405.346',
        ellipse: 'bessel',
        datumName: 'swiss'
    },
    ggrs87: {
        towgs84: '-199.87,74.79,246.62',
        ellipse: 'GRS80',
        datumName: 'Greek_Geodetic_Reference_System_1987'
    },
    nad83: {
        towgs84: '0,0,0',
        ellipse: 'GRS80',
        datumName: 'North_American_Datum_1983'
    },
    nad27: {
        nadgrids: '@conus,@alaska,@ntv2_0.gsb,@ntv1_can.dat',
        ellipse: 'clrk66',
        datumName: 'North_American_Datum_1927'
    },
    potsdam: {
        towgs84: '598.1,73.7,418.2,0.202,0.045,-2.455,6.7',
        ellipse: 'bessel',
        datumName: 'Potsdam Rauenberg 1950 DHDN'
    },
    carthage: {
        towgs84: '-263.0,6.0,431.0',
        ellipse: 'clark80',
        datumName: 'Carthage 1934 Tunisia'
    },
    hermannskogel: {
        towgs84: '577.326,90.129,463.919,5.137,1.474,5.297,2.4232',
        ellipse: 'bessel',
        datumName: 'Hermannskogel'
    },
    mgi: {
        towgs84: '577.326,90.129,463.919,5.137,1.474,5.297,2.4232',
        ellipse: 'bessel',
        datumName: 'Militar-Geographische Institut'
    },
    osni52: {
        towgs84: '482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15',
        ellipse: 'airy',
        datumName: 'Irish National'
    },
    ire65: {
        towgs84: '482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15',
        ellipse: 'mod_airy',
        datumName: 'Ireland 1965'
    },
    rassadiran: {
        towgs84: '-133.63,-157.5,-158.62',
        ellipse: 'intl',
        datumName: 'Rassadiran'
    },
    nzgd49: {
        towgs84: '59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993',
        ellipse: 'intl',
        datumName: 'New Zealand Geodetic Datum 1949'
    },
    osgb36: {
        towgs84: '446.448,-125.157,542.060,0.1502,0.2470,0.8421,-20.4894',
        ellipse: 'airy',
        datumName: 'Ordnance Survey of Great Britain 1936'
    },
    s_jtsk: {
        towgs84: '589,76,480',
        ellipse: 'bessel',
        datumName: 'S-JTSK (Ferro)'
    },
    beduaram: {
        towgs84: '-106,-87,188',
        ellipse: 'clrk80',
        datumName: 'Beduaram'
    },
    gunung_segara: {
        towgs84: '-403,684,41',
        ellipse: 'bessel',
        datumName: 'Gunung Segara Jakarta'
    },
    rnb72: {
        towgs84: '106.869,-52.2978,103.724,-0.33657,0.456955,-1.84218,1',
        ellipse: 'intl',
        datumName: 'Reseau National Belge 1972'
    },
    EPSG_5451: {
        towgs84: '6.41,-49.05,-11.28,1.5657,0.5242,6.9718,-5.7649'
    },
    IGNF_LURESG: {
        towgs84: '-192.986,13.673,-39.309,-0.4099,-2.9332,2.6881,0.43'
    },
    EPSG_4614: {
        towgs84: '-119.4248,-303.65872,-11.00061,1.164298,0.174458,1.096259,3.657065'
    },
    EPSG_4615: {
        towgs84: '-494.088,-312.129,279.877,-1.423,-1.013,1.59,-0.748'
    },
    ESRI_37241: {
        towgs84: '-76.822,257.457,-12.817,2.136,-0.033,-2.392,-0.031'
    },
    ESRI_37249: {
        towgs84: '-440.296,58.548,296.265,1.128,10.202,4.559,-0.438'
    },
    ESRI_37245: {
        towgs84: '-511.151,-181.269,139.609,1.05,2.703,1.798,3.071'
    },
    EPSG_4178: {
        towgs84: '24.9,-126.4,-93.2,-0.063,-0.247,-0.041,1.01'
    },
    EPSG_4622: {
        towgs84: '-472.29,-5.63,-304.12,0.4362,-0.8374,0.2563,1.8984'
    },
    EPSG_4625: {
        towgs84: '126.93,547.94,130.41,-2.7867,5.1612,-0.8584,13.8227'
    },
    EPSG_5252: {
        towgs84: '0.023,0.036,-0.068,0.00176,0.00912,-0.01136,0.00439'
    },
    EPSG_4314: {
        towgs84: '597.1,71.4,412.1,0.894,0.068,-1.563,7.58'
    },
    EPSG_4282: {
        towgs84: '-178.3,-316.7,-131.5,5.278,6.077,10.979,19.166'
    },
    EPSG_4231: {
        towgs84: '-83.11,-97.38,-117.22,0.0276,-0.2167,0.2147,0.1218'
    },
    EPSG_4274: {
        towgs84: '-230.994,102.591,25.199,0.633,-0.239,0.9,1.95'
    },
    EPSG_4134: {
        towgs84: '-180.624,-225.516,173.919,-0.81,-1.898,8.336,16.71006'
    },
    EPSG_4254: {
        towgs84: '18.38,192.45,96.82,0.056,-0.142,-0.2,-0.0013'
    },
    EPSG_4159: {
        towgs84: '-194.513,-63.978,-25.759,-3.4027,3.756,-3.352,-0.9175'
    },
    EPSG_4687: {
        towgs84: '0.072,-0.507,-0.245,0.0183,-0.0003,0.007,-0.0093'
    },
    EPSG_4227: {
        towgs84: '-83.58,-397.54,458.78,-17.595,-2.847,4.256,3.225'
    },
    EPSG_4746: {
        towgs84: '599.4,72.4,419.2,-0.062,-0.022,-2.723,6.46'
    },
    EPSG_4745: {
        towgs84: '612.4,77,440.2,-0.054,0.057,-2.797,2.55'
    },
    EPSG_6311: {
        towgs84: '8.846,-4.394,-1.122,-0.00237,-0.146528,0.130428,0.783926'
    },
    EPSG_4289: {
        towgs84: '565.7381,50.4018,465.2904,-1.91514,1.60363,-9.09546,4.07244'
    },
    EPSG_4230: {
        towgs84: '-68.863,-134.888,-111.49,-0.53,-0.14,0.57,-3.4'
    },
    EPSG_4154: {
        towgs84: '-123.02,-158.95,-168.47'
    },
    EPSG_4156: {
        towgs84: '570.8,85.7,462.8,4.998,1.587,5.261,3.56'
    },
    EPSG_4299: {
        towgs84: '482.5,-130.6,564.6,-1.042,-0.214,-0.631,8.15'
    },
    EPSG_4179: {
        towgs84: '33.4,-146.6,-76.3,-0.359,-0.053,0.844,-0.84'
    },
    EPSG_4313: {
        towgs84: '-106.8686,52.2978,-103.7239,0.3366,-0.457,1.8422,-1.2747'
    },
    EPSG_4194: {
        towgs84: '163.511,127.533,-159.789'
    },
    EPSG_4195: {
        towgs84: '105,326,-102.5'
    },
    EPSG_4196: {
        towgs84: '-45,417,-3.5'
    },
    EPSG_4611: {
        towgs84: '-162.619,-276.959,-161.764,0.067753,-2.243649,-1.158827,-1.094246'
    },
    EPSG_4633: {
        towgs84: '137.092,131.66,91.475,-1.9436,-11.5993,-4.3321,-7.4824'
    },
    EPSG_4641: {
        towgs84: '-408.809,366.856,-412.987,1.8842,-0.5308,2.1655,-121.0993'
    },
    EPSG_4643: {
        towgs84: '-480.26,-438.32,-643.429,16.3119,20.1721,-4.0349,-111.7002'
    },
    EPSG_4300: {
        towgs84: '482.5,-130.6,564.6,-1.042,-0.214,-0.631,8.15'
    },
    EPSG_4188: {
        towgs84: '482.5,-130.6,564.6,-1.042,-0.214,-0.631,8.15'
    },
    EPSG_4660: {
        towgs84: '982.6087,552.753,-540.873,32.39344,-153.25684,-96.2266,16.805'
    },
    EPSG_4662: {
        towgs84: '97.295,-263.247,310.882,-1.5999,0.8386,3.1409,13.3259'
    },
    EPSG_3906: {
        towgs84: '577.88891,165.22205,391.18289,4.9145,-0.94729,-13.05098,7.78664'
    },
    EPSG_4307: {
        towgs84: '-209.3622,-87.8162,404.6198,0.0046,3.4784,0.5805,-1.4547'
    },
    EPSG_6892: {
        towgs84: '-76.269,-16.683,68.562,-6.275,10.536,-4.286,-13.686'
    },
    EPSG_4690: {
        towgs84: '221.597,152.441,176.523,2.403,1.3893,0.884,11.4648'
    },
    EPSG_4691: {
        towgs84: '218.769,150.75,176.75,3.5231,2.0037,1.288,10.9817'
    },
    EPSG_4629: {
        towgs84: '72.51,345.411,79.241,-1.5862,-0.8826,-0.5495,1.3653'
    },
    EPSG_4630: {
        towgs84: '165.804,216.213,180.26,-0.6251,-0.4515,-0.0721,7.4111'
    },
    EPSG_4692: {
        towgs84: '217.109,86.452,23.711,0.0183,-0.0003,0.007,-0.0093'
    },
    EPSG_9333: {
        towgs84: '0,0,0,-8.393,0.749,-10.276,0'
    },
    EPSG_9059: {
        towgs84: '0,0,0'
    },
    EPSG_4312: {
        towgs84: '601.705,84.263,485.227,4.7354,1.3145,5.393,-2.3887'
    },
    EPSG_4123: {
        towgs84: '-96.062,-82.428,-121.753,4.801,0.345,-1.376,1.496'
    },
    EPSG_4309: {
        towgs84: '-124.45,183.74,44.64,-0.4384,0.5446,-0.9706,-2.1365'
    },
    ESRI_104106: {
        towgs84: '-283.088,-70.693,117.445,-1.157,0.059,-0.652,-4.058'
    },
    EPSG_4281: {
        towgs84: '-219.247,-73.802,269.529'
    },
    EPSG_4322: {
        towgs84: '0,0,4.5'
    },
    EPSG_4324: {
        towgs84: '0,0,1.9'
    },
    EPSG_4284: {
        towgs84: '43.822,-108.842,-119.585,1.455,-0.761,0.737,0.549'
    },
    EPSG_4277: {
        towgs84: '446.448,-125.157,542.06,0.15,0.247,0.842,-20.489'
    },
    EPSG_4207: {
        towgs84: '-282.1,-72.2,120,-1.529,0.145,-0.89,-4.46'
    },
    EPSG_4688: {
        towgs84: '347.175,1077.618,2623.677,33.9058,-70.6776,9.4013,186.0647'
    },
    EPSG_4689: {
        towgs84: '410.793,54.542,80.501,-2.5596,-2.3517,-0.6594,17.3218'
    },
    EPSG_4720: {
        towgs84: '0,0,4.5'
    },
    EPSG_4273: {
        towgs84: '278.3,93,474.5,7.889,0.05,-6.61,6.21'
    },
    EPSG_4240: {
        towgs84: '204.64,834.74,293.8'
    },
    EPSG_4817: {
        towgs84: '278.3,93,474.5,7.889,0.05,-6.61,6.21'
    },
    ESRI_104131: {
        towgs84: '426.62,142.62,460.09,4.98,4.49,-12.42,-17.1'
    },
    EPSG_4265: {
        towgs84: '-104.1,-49.1,-9.9,0.971,-2.917,0.714,-11.68'
    },
    EPSG_4263: {
        towgs84: '-111.92,-87.85,114.5,1.875,0.202,0.219,0.032'
    },
    EPSG_4298: {
        towgs84: '-689.5937,623.84046,-65.93566,-0.02331,1.17094,-0.80054,5.88536'
    },
    EPSG_4270: {
        towgs84: '-253.4392,-148.452,386.5267,0.15605,0.43,-0.1013,-0.0424'
    },
    EPSG_4229: {
        towgs84: '-121.8,98.1,-10.7'
    },
    EPSG_4220: {
        towgs84: '-55.5,-348,-229.2'
    },
    EPSG_4214: {
        towgs84: '12.646,-155.176,-80.863'
    },
    EPSG_4232: {
        towgs84: '-345,3,223'
    },
    EPSG_4238: {
        towgs84: '-1.977,-13.06,-9.993,0.364,0.254,0.689,-1.037'
    },
    EPSG_4168: {
        towgs84: '-170,33,326'
    },
    EPSG_4131: {
        towgs84: '199,931,318.9'
    },
    EPSG_4152: {
        towgs84: '-0.9102,2.0141,0.5602,0.029039,0.010065,0.010101,0'
    },
    EPSG_5228: {
        towgs84: '572.213,85.334,461.94,4.9732,1.529,5.2484,3.5378'
    },
    EPSG_8351: {
        towgs84: '485.021,169.465,483.839,7.786342,4.397554,4.102655,0'
    },
    EPSG_4683: {
        towgs84: '-127.62,-67.24,-47.04,-3.068,4.903,1.578,-1.06'
    },
    EPSG_4133: {
        towgs84: '0,0,0'
    },
    EPSG_7373: {
        towgs84: '0.819,-0.5762,-1.6446,-0.00378,-0.03317,0.00318,0.0693'
    },
    EPSG_9075: {
        towgs84: '-0.9102,2.0141,0.5602,0.029039,0.010065,0.010101,0'
    },
    EPSG_9072: {
        towgs84: '-0.9102,2.0141,0.5602,0.029039,0.010065,0.010101,0'
    },
    EPSG_9294: {
        towgs84: '1.16835,-1.42001,-2.24431,-0.00822,-0.05508,0.01818,0.23388'
    },
    EPSG_4212: {
        towgs84: '-267.434,173.496,181.814,-13.4704,8.7154,7.3926,14.7492'
    },
    EPSG_4191: {
        towgs84: '-44.183,-0.58,-38.489,2.3867,2.7072,-3.5196,-8.2703'
    },
    EPSG_4237: {
        towgs84: '52.684,-71.194,-13.975,-0.312,-0.1063,-0.3729,1.0191'
    },
    EPSG_4740: {
        towgs84: '-1.08,-0.27,-0.9'
    },
    EPSG_4124: {
        towgs84: '419.3836,99.3335,591.3451,0.850389,1.817277,-7.862238,-0.99496'
    },
    EPSG_5681: {
        towgs84: '584.9636,107.7175,413.8067,1.1155,0.2824,-3.1384,7.9922'
    },
    EPSG_4141: {
        towgs84: '23.772,17.49,17.859,-0.3132,-1.85274,1.67299,-5.4262'
    },
    EPSG_4204: {
        towgs84: '-85.645,-273.077,-79.708,2.289,-1.421,2.532,3.194'
    },
    EPSG_4319: {
        towgs84: '226.702,-193.337,-35.371,-2.229,-4.391,9.238,0.9798'
    },
    EPSG_4200: {
        towgs84: '24.82,-131.21,-82.66'
    },
    EPSG_4130: {
        towgs84: '0,0,0'
    },
    EPSG_4127: {
        towgs84: '-82.875,-57.097,-156.768,-2.158,1.524,-0.982,-0.359'
    },
    EPSG_4149: {
        towgs84: '674.374,15.056,405.346'
    },
    EPSG_4617: {
        towgs84: '-0.991,1.9072,0.5129,1.25033e-7,4.6785e-8,5.6529e-8,0'
    },
    EPSG_4663: {
        towgs84: '-210.502,-66.902,-48.476,2.094,-15.067,-5.817,0.485'
    },
    EPSG_4664: {
        towgs84: '-211.939,137.626,58.3,-0.089,0.251,0.079,0.384'
    },
    EPSG_4665: {
        towgs84: '-105.854,165.589,-38.312,-0.003,-0.026,0.024,-0.048'
    },
    EPSG_4666: {
        towgs84: '631.392,-66.551,481.442,1.09,-4.445,-4.487,-4.43'
    },
    EPSG_4756: {
        towgs84: '-192.873,-39.382,-111.202,-0.00205,-0.0005,0.00335,0.0188'
    },
    EPSG_4723: {
        towgs84: '-179.483,-69.379,-27.584,-7.862,8.163,6.042,-13.925'
    },
    EPSG_4726: {
        towgs84: '8.853,-52.644,180.304,-0.393,-2.323,2.96,-24.081'
    },
    EPSG_4267: {
        towgs84: '-8.0,160.0,176.0'
    },
    EPSG_5365: {
        towgs84: '-0.16959,0.35312,0.51846,0.03385,-0.16325,0.03446,0.03693'
    },
    EPSG_4218: {
        towgs84: '304.5,306.5,-318.1'
    },
    EPSG_4242: {
        towgs84: '-33.722,153.789,94.959,-8.581,-4.478,4.54,8.95'
    },
    EPSG_4216: {
        towgs84: '-292.295,248.758,429.447,4.9971,2.99,6.6906,1.0289'
    },
    ESRI_104105: {
        towgs84: '631.392,-66.551,481.442,1.09,-4.445,-4.487,-4.43'
    },
    ESRI_104129: {
        towgs84: '0,0,0'
    },
    EPSG_4673: {
        towgs84: '174.05,-25.49,112.57'
    },
    EPSG_4202: {
        towgs84: '-124,-60,154'
    },
    EPSG_4203: {
        towgs84: '-117.763,-51.51,139.061,0.292,0.443,0.277,-0.191'
    },
    EPSG_3819: {
        towgs84: '595.48,121.69,515.35,4.115,-2.9383,0.853,-3.408'
    },
    EPSG_8694: {
        towgs84: '-93.799,-132.737,-219.073,-1.844,0.648,-6.37,-0.169'
    },
    EPSG_4145: {
        towgs84: '275.57,676.78,229.6'
    },
    EPSG_4283: {
        towgs84: '61.55,-10.87,-40.19,39.4924,32.7221,32.8979,-9.994'
    },
    EPSG_4317: {
        towgs84: '2.3287,-147.0425,-92.0802,-0.3092483,0.32482185,0.49729934,5.68906266'
    },
    EPSG_4272: {
        towgs84: '59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993'
    },
    EPSG_4248: {
        towgs84: '-307.7,265.3,-363.5'
    },
    EPSG_5561: {
        towgs84: '24,-121,-76'
    },
    EPSG_5233: {
        towgs84: '-0.293,766.95,87.713,0.195704,1.695068,3.473016,-0.039338'
    },
    ESRI_104130: {
        towgs84: '-86,-98,-119'
    },
    ESRI_104102: {
        towgs84: '682,-203,480'
    },
    ESRI_37207: {
        towgs84: '7,-10,-26'
    },
    EPSG_4675: {
        towgs84: '59.935,118.4,-10.871'
    },
    ESRI_104109: {
        towgs84: '-89.121,-348.182,260.871'
    },
    ESRI_104112: {
        towgs84: '-185.583,-230.096,281.361'
    },
    ESRI_104113: {
        towgs84: '25.1,-275.6,222.6'
    },
    IGNF_WGS72G: {
        towgs84: '0,12,6'
    },
    IGNF_NTFG: {
        towgs84: '-168,-60,320'
    },
    IGNF_EFATE57G: {
        towgs84: '-127,-769,472'
    },
    IGNF_PGP50G: {
        towgs84: '324.8,153.6,172.1'
    },
    IGNF_REUN47G: {
        towgs84: '94,-948,-1262'
    },
    IGNF_CSG67G: {
        towgs84: '-186,230,110'
    },
    IGNF_GUAD48G: {
        towgs84: '-467,-16,-300'
    },
    IGNF_TAHI51G: {
        towgs84: '162,117,154'
    },
    IGNF_TAHAAG: {
        towgs84: '65,342,77'
    },
    IGNF_NUKU72G: {
        towgs84: '84,274,65'
    },
    IGNF_PETRELS72G: {
        towgs84: '365,194,166'
    },
    IGNF_WALL78G: {
        towgs84: '253,-133,-127'
    },
    IGNF_MAYO50G: {
        towgs84: '-382,-59,-262'
    },
    IGNF_TANNAG: {
        towgs84: '-139,-967,436'
    },
    IGNF_IGN72G: {
        towgs84: '-13,-348,292'
    },
    IGNF_ATIGG: {
        towgs84: '1118,23,66'
    },
    IGNF_FANGA84G: {
        towgs84: '150.57,158.33,118.32'
    },
    IGNF_RUSAT84G: {
        towgs84: '202.13,174.6,-15.74'
    },
    IGNF_KAUE70G: {
        towgs84: '126.74,300.1,-75.49'
    },
    IGNF_MOP90G: {
        towgs84: '-10.8,-1.8,12.77'
    },
    IGNF_MHPF67G: {
        towgs84: '338.08,212.58,-296.17'
    },
    IGNF_TAHI79G: {
        towgs84: '160.61,116.05,153.69'
    },
    IGNF_ANAA92G: {
        towgs84: '1.5,3.84,4.81'
    },
    IGNF_MARQUI72G: {
        towgs84: '330.91,-13.92,58.56'
    },
    IGNF_APAT86G: {
        towgs84: '143.6,197.82,74.05'
    },
    IGNF_TUBU69G: {
        towgs84: '237.17,171.61,-77.84'
    },
    IGNF_STPM50G: {
        towgs84: '11.363,424.148,373.13'
    },
    EPSG_4150: {
        towgs84: '674.374,15.056,405.346'
    },
    EPSG_4754: {
        towgs84: '-208.4058,-109.8777,-2.5764'
    },
    ESRI_104101: {
        towgs84: '374,150,588'
    },
    EPSG_4693: {
        towgs84: '0,-0.15,0.68'
    },
    EPSG_6207: {
        towgs84: '293.17,726.18,245.36'
    },
    EPSG_4153: {
        towgs84: '-133.63,-157.5,-158.62'
    },
    EPSG_4132: {
        towgs84: '-241.54,-163.64,396.06'
    },
    EPSG_4221: {
        towgs84: '-154.5,150.7,100.4'
    },
    EPSG_4266: {
        towgs84: '-80.7,-132.5,41.1'
    },
    EPSG_4193: {
        towgs84: '-70.9,-151.8,-41.4'
    },
    EPSG_5340: {
        towgs84: '-0.41,0.46,-0.35'
    },
    EPSG_4246: {
        towgs84: '-294.7,-200.1,525.5'
    },
    EPSG_4318: {
        towgs84: '-3.2,-5.7,2.8'
    },
    EPSG_4121: {
        towgs84: '-199.87,74.79,246.62'
    },
    EPSG_4223: {
        towgs84: '-260.1,5.5,432.2'
    },
    EPSG_4158: {
        towgs84: '-0.465,372.095,171.736'
    },
    EPSG_4285: {
        towgs84: '-128.16,-282.42,21.93'
    },
    EPSG_4613: {
        towgs84: '-404.78,685.68,45.47'
    },
    EPSG_4607: {
        towgs84: '195.671,332.517,274.607'
    },
    EPSG_4475: {
        towgs84: '-381.788,-57.501,-256.673'
    },
    EPSG_4208: {
        towgs84: '-157.84,308.54,-146.6'
    },
    EPSG_4743: {
        towgs84: '70.995,-335.916,262.898'
    },
    EPSG_4710: {
        towgs84: '-323.65,551.39,-491.22'
    },
    EPSG_7881: {
        towgs84: '-0.077,0.079,0.086'
    },
    EPSG_4682: {
        towgs84: '283.729,735.942,261.143'
    },
    EPSG_4739: {
        towgs84: '-156,-271,-189'
    },
    EPSG_4679: {
        towgs84: '-80.01,253.26,291.19'
    },
    EPSG_4750: {
        towgs84: '-56.263,16.136,-22.856'
    },
    EPSG_4644: {
        towgs84: '-10.18,-350.43,291.37'
    },
    EPSG_4695: {
        towgs84: '-103.746,-9.614,-255.95'
    },
    EPSG_4292: {
        towgs84: '-355,21,72'
    },
    EPSG_4302: {
        towgs84: '-61.702,284.488,472.052'
    },
    EPSG_4143: {
        towgs84: '-124.76,53,466.79'
    },
    EPSG_4606: {
        towgs84: '-153,153,307'
    },
    EPSG_4699: {
        towgs84: '-770.1,158.4,-498.2'
    },
    EPSG_4247: {
        towgs84: '-273.5,110.6,-357.9'
    },
    EPSG_4160: {
        towgs84: '8.88,184.86,106.69'
    },
    EPSG_4161: {
        towgs84: '-233.43,6.65,173.64'
    },
    EPSG_9251: {
        towgs84: '-9.5,122.9,138.2'
    },
    EPSG_9253: {
        towgs84: '-78.1,101.6,133.3'
    },
    EPSG_4297: {
        towgs84: '-198.383,-240.517,-107.909'
    },
    EPSG_4269: {
        towgs84: '0,0,0'
    },
    EPSG_4301: {
        towgs84: '-147,506,687'
    },
    EPSG_4618: {
        towgs84: '-59,-11,-52'
    },
    EPSG_4612: {
        towgs84: '0,0,0'
    },
    EPSG_4678: {
        towgs84: '44.585,-131.212,-39.544'
    },
    EPSG_4250: {
        towgs84: '-130,29,364'
    },
    EPSG_4144: {
        towgs84: '214,804,268'
    },
    EPSG_4147: {
        towgs84: '-17.51,-108.32,-62.39'
    },
    EPSG_4259: {
        towgs84: '-254.1,-5.36,-100.29'
    },
    EPSG_4164: {
        towgs84: '-76,-138,67'
    },
    EPSG_4211: {
        towgs84: '-378.873,676.002,-46.255'
    },
    EPSG_4182: {
        towgs84: '-422.651,-172.995,84.02'
    },
    EPSG_4224: {
        towgs84: '-143.87,243.37,-33.52'
    },
    EPSG_4225: {
        towgs84: '-205.57,168.77,-4.12'
    },
    EPSG_5527: {
        towgs84: '-67.35,3.88,-38.22'
    },
    EPSG_4752: {
        towgs84: '98,390,-22'
    },
    EPSG_4310: {
        towgs84: '-30,190,89'
    },
    EPSG_9248: {
        towgs84: '-192.26,65.72,132.08'
    },
    EPSG_4680: {
        towgs84: '124.5,-63.5,-281'
    },
    EPSG_4701: {
        towgs84: '-79.9,-158,-168.9'
    },
    EPSG_4706: {
        towgs84: '-146.21,112.63,4.05'
    },
    EPSG_4805: {
        towgs84: '682,-203,480'
    },
    EPSG_4201: {
        towgs84: '-165,-11,206'
    },
    EPSG_4210: {
        towgs84: '-157,-2,-299'
    },
    EPSG_4183: {
        towgs84: '-104,167,-38'
    },
    EPSG_4139: {
        towgs84: '11,72,-101'
    },
    EPSG_4668: {
        towgs84: '-86,-98,-119'
    },
    EPSG_4717: {
        towgs84: '-2,151,181'
    },
    EPSG_4732: {
        towgs84: '102,52,-38'
    },
    EPSG_4280: {
        towgs84: '-377,681,-50'
    },
    EPSG_4209: {
        towgs84: '-138,-105,-289'
    },
    EPSG_4261: {
        towgs84: '31,146,47'
    },
    EPSG_4658: {
        towgs84: '-73,46,-86'
    },
    EPSG_4721: {
        towgs84: '265.025,384.929,-194.046'
    },
    EPSG_4222: {
        towgs84: '-136,-108,-292'
    },
    EPSG_4601: {
        towgs84: '-255,-15,71'
    },
    EPSG_4602: {
        towgs84: '725,685,536'
    },
    EPSG_4603: {
        towgs84: '72,213.7,93'
    },
    EPSG_4605: {
        towgs84: '9,183,236'
    },
    EPSG_4621: {
        towgs84: '137,248,-430'
    },
    EPSG_4657: {
        towgs84: '-28,199,5'
    },
    EPSG_4316: {
        towgs84: '103.25,-100.4,-307.19'
    },
    EPSG_4642: {
        towgs84: '-13,-348,292'
    },
    EPSG_4698: {
        towgs84: '145,-187,103'
    },
    EPSG_4192: {
        towgs84: '-206.1,-174.7,-87.7'
    },
    EPSG_4311: {
        towgs84: '-265,120,-358'
    },
    EPSG_4135: {
        towgs84: '58,-283,-182'
    },
    ESRI_104138: {
        towgs84: '198,-226,-347'
    },
    EPSG_4245: {
        towgs84: '-11,851,5'
    },
    EPSG_4142: {
        towgs84: '-125,53,467'
    },
    EPSG_4213: {
        towgs84: '-106,-87,188'
    },
    EPSG_4253: {
        towgs84: '-133,-77,-51'
    },
    EPSG_4129: {
        towgs84: '-132,-110,-335'
    },
    EPSG_4713: {
        towgs84: '-77,-128,142'
    },
    EPSG_4239: {
        towgs84: '217,823,299'
    },
    EPSG_4146: {
        towgs84: '295,736,257'
    },
    EPSG_4155: {
        towgs84: '-83,37,124'
    },
    EPSG_4165: {
        towgs84: '-173,253,27'
    },
    EPSG_4672: {
        towgs84: '175,-38,113'
    },
    EPSG_4236: {
        towgs84: '-637,-549,-203'
    },
    EPSG_4251: {
        towgs84: '-90,40,88'
    },
    EPSG_4271: {
        towgs84: '-2,374,172'
    },
    EPSG_4175: {
        towgs84: '-88,4,101'
    },
    EPSG_4716: {
        towgs84: '298,-304,-375'
    },
    EPSG_4315: {
        towgs84: '-23,259,-9'
    },
    EPSG_4744: {
        towgs84: '-242.2,-144.9,370.3'
    },
    EPSG_4244: {
        towgs84: '-97,787,86'
    },
    EPSG_4293: {
        towgs84: '616,97,-251'
    },
    EPSG_4714: {
        towgs84: '-127,-769,472'
    },
    EPSG_4736: {
        towgs84: '260,12,-147'
    },
    EPSG_6883: {
        towgs84: '-235,-110,393'
    },
    EPSG_6894: {
        towgs84: '-63,176,185'
    },
    EPSG_4205: {
        towgs84: '-43,-163,45'
    },
    EPSG_4256: {
        towgs84: '41,-220,-134'
    },
    EPSG_4262: {
        towgs84: '639,405,60'
    },
    EPSG_4604: {
        towgs84: '174,359,365'
    },
    EPSG_4169: {
        towgs84: '-115,118,426'
    },
    EPSG_4620: {
        towgs84: '-106,-129,165'
    },
    EPSG_4184: {
        towgs84: '-203,141,53'
    },
    EPSG_4616: {
        towgs84: '-289,-124,60'
    },
    EPSG_9403: {
        towgs84: '-307,-92,127'
    },
    EPSG_4684: {
        towgs84: '-133,-321,50'
    },
    EPSG_4708: {
        towgs84: '-491,-22,435'
    },
    EPSG_4707: {
        towgs84: '114,-116,-333'
    },
    EPSG_4709: {
        towgs84: '145,75,-272'
    },
    EPSG_4712: {
        towgs84: '-205,107,53'
    },
    EPSG_4711: {
        towgs84: '124,-234,-25'
    },
    EPSG_4718: {
        towgs84: '230,-199,-752'
    },
    EPSG_4719: {
        towgs84: '211,147,111'
    },
    EPSG_4724: {
        towgs84: '208,-435,-229'
    },
    EPSG_4725: {
        towgs84: '189,-79,-202'
    },
    EPSG_4735: {
        towgs84: '647,1777,-1124'
    },
    EPSG_4722: {
        towgs84: '-794,119,-298'
    },
    EPSG_4728: {
        towgs84: '-307,-92,127'
    },
    EPSG_4734: {
        towgs84: '-632,438,-609'
    },
    EPSG_4727: {
        towgs84: '912,-58,1227'
    },
    EPSG_4729: {
        towgs84: '185,165,42'
    },
    EPSG_4730: {
        towgs84: '170,42,84'
    },
    EPSG_4733: {
        towgs84: '276,-57,149'
    },
    ESRI_37218: {
        towgs84: '230,-199,-752'
    },
    ESRI_37240: {
        towgs84: '-7,215,225'
    },
    ESRI_37221: {
        towgs84: '252,-209,-751'
    },
    ESRI_4305: {
        towgs84: '-123,-206,219'
    },
    ESRI_104139: {
        towgs84: '-73,-247,227'
    },
    EPSG_4748: {
        towgs84: '51,391,-36'
    },
    EPSG_4219: {
        towgs84: '-384,664,-48'
    },
    EPSG_4255: {
        towgs84: '-333,-222,114'
    },
    EPSG_4257: {
        towgs84: '-587.8,519.75,145.76'
    },
    EPSG_4646: {
        towgs84: '-963,510,-359'
    },
    EPSG_6881: {
        towgs84: '-24,-203,268'
    },
    EPSG_6882: {
        towgs84: '-183,-15,273'
    },
    EPSG_4715: {
        towgs84: '-104,-129,239'
    },
    IGNF_RGF93GDD: {
        towgs84: '0,0,0'
    },
    IGNF_RGM04GDD: {
        towgs84: '0,0,0'
    },
    IGNF_RGSPM06GDD: {
        towgs84: '0,0,0'
    },
    IGNF_RGTAAF07GDD: {
        towgs84: '0,0,0'
    },
    IGNF_RGFG95GDD: {
        towgs84: '0,0,0'
    },
    IGNF_RGNCG: {
        towgs84: '0,0,0'
    },
    IGNF_RGPFGDD: {
        towgs84: '0,0,0'
    },
    IGNF_ETRS89G: {
        towgs84: '0,0,0'
    },
    IGNF_RGR92GDD: {
        towgs84: '0,0,0'
    },
    EPSG_4173: {
        towgs84: '0,0,0'
    },
    EPSG_4180: {
        towgs84: '0,0,0'
    },
    EPSG_4619: {
        towgs84: '0,0,0'
    },
    EPSG_4667: {
        towgs84: '0,0,0'
    },
    EPSG_4075: {
        towgs84: '0,0,0'
    },
    EPSG_6706: {
        towgs84: '0,0,0'
    },
    EPSG_7798: {
        towgs84: '0,0,0'
    },
    EPSG_4661: {
        towgs84: '0,0,0'
    },
    EPSG_4669: {
        towgs84: '0,0,0'
    },
    EPSG_8685: {
        towgs84: '0,0,0'
    },
    EPSG_4151: {
        towgs84: '0,0,0'
    },
    EPSG_9702: {
        towgs84: '0,0,0'
    },
    EPSG_4758: {
        towgs84: '0,0,0'
    },
    EPSG_4761: {
        towgs84: '0,0,0'
    },
    EPSG_4765: {
        towgs84: '0,0,0'
    },
    EPSG_8997: {
        towgs84: '0,0,0'
    },
    EPSG_4023: {
        towgs84: '0,0,0'
    },
    EPSG_4670: {
        towgs84: '0,0,0'
    },
    EPSG_4694: {
        towgs84: '0,0,0'
    },
    EPSG_4148: {
        towgs84: '0,0,0'
    },
    EPSG_4163: {
        towgs84: '0,0,0'
    },
    EPSG_4167: {
        towgs84: '0,0,0'
    },
    EPSG_4189: {
        towgs84: '0,0,0'
    },
    EPSG_4190: {
        towgs84: '0,0,0'
    },
    EPSG_4176: {
        towgs84: '0,0,0'
    },
    EPSG_4659: {
        towgs84: '0,0,0'
    },
    EPSG_3824: {
        towgs84: '0,0,0'
    },
    EPSG_3889: {
        towgs84: '0,0,0'
    },
    EPSG_4046: {
        towgs84: '0,0,0'
    },
    EPSG_4081: {
        towgs84: '0,0,0'
    },
    EPSG_4558: {
        towgs84: '0,0,0'
    },
    EPSG_4483: {
        towgs84: '0,0,0'
    },
    EPSG_5013: {
        towgs84: '0,0,0'
    },
    EPSG_5264: {
        towgs84: '0,0,0'
    },
    EPSG_5324: {
        towgs84: '0,0,0'
    },
    EPSG_5354: {
        towgs84: '0,0,0'
    },
    EPSG_5371: {
        towgs84: '0,0,0'
    },
    EPSG_5373: {
        towgs84: '0,0,0'
    },
    EPSG_5381: {
        towgs84: '0,0,0'
    },
    EPSG_5393: {
        towgs84: '0,0,0'
    },
    EPSG_5489: {
        towgs84: '0,0,0'
    },
    EPSG_5593: {
        towgs84: '0,0,0'
    },
    EPSG_6135: {
        towgs84: '0,0,0'
    },
    EPSG_6365: {
        towgs84: '0,0,0'
    },
    EPSG_5246: {
        towgs84: '0,0,0'
    },
    EPSG_7886: {
        towgs84: '0,0,0'
    },
    EPSG_8431: {
        towgs84: '0,0,0'
    },
    EPSG_8427: {
        towgs84: '0,0,0'
    },
    EPSG_8699: {
        towgs84: '0,0,0'
    },
    EPSG_8818: {
        towgs84: '0,0,0'
    },
    EPSG_4757: {
        towgs84: '0,0,0'
    },
    EPSG_9140: {
        towgs84: '0,0,0'
    },
    EPSG_8086: {
        towgs84: '0,0,0'
    },
    EPSG_4686: {
        towgs84: '0,0,0'
    },
    EPSG_4737: {
        towgs84: '0,0,0'
    },
    EPSG_4702: {
        towgs84: '0,0,0'
    },
    EPSG_4747: {
        towgs84: '0,0,0'
    },
    EPSG_4749: {
        towgs84: '0,0,0'
    },
    EPSG_4674: {
        towgs84: '0,0,0'
    },
    EPSG_4755: {
        towgs84: '0,0,0'
    },
    EPSG_4759: {
        towgs84: '0,0,0'
    },
    EPSG_4762: {
        towgs84: '0,0,0'
    },
    EPSG_4763: {
        towgs84: '0,0,0'
    },
    EPSG_4764: {
        towgs84: '0,0,0'
    },
    EPSG_4166: {
        towgs84: '0,0,0'
    },
    EPSG_4170: {
        towgs84: '0,0,0'
    },
    EPSG_5546: {
        towgs84: '0,0,0'
    },
    EPSG_7844: {
        towgs84: '0,0,0'
    },
    EPSG_4818: {
        towgs84: '589,76,480'
    }
};
for(var $c36bbc8057de3d00$var$key in $c36bbc8057de3d00$var$datums){
    var $c36bbc8057de3d00$var$datum = $c36bbc8057de3d00$var$datums[$c36bbc8057de3d00$var$key];
    if (!$c36bbc8057de3d00$var$datum.datumName) continue;
    $c36bbc8057de3d00$var$datums[$c36bbc8057de3d00$var$datum.datumName] = $c36bbc8057de3d00$var$datum;
}
var $c36bbc8057de3d00$export$2e2bcd8739ae039 = $c36bbc8057de3d00$var$datums;

});

parcelRegister("3MCqb", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c13a87cc45f972b$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");
function $2c13a87cc45f972b$var$datum(datumCode, datum_params, a, b, es, ep2, nadgrids) {
    var out = {};
    if (datumCode === undefined || datumCode === 'none') out.datum_type = (0, $gyVUi.PJD_NODATUM);
    else out.datum_type = (0, $gyVUi.PJD_WGS84);
    if (datum_params) {
        out.datum_params = datum_params.map(parseFloat);
        if (out.datum_params[0] !== 0 || out.datum_params[1] !== 0 || out.datum_params[2] !== 0) out.datum_type = (0, $gyVUi.PJD_3PARAM);
        if (out.datum_params.length > 3) {
            if (out.datum_params[3] !== 0 || out.datum_params[4] !== 0 || out.datum_params[5] !== 0 || out.datum_params[6] !== 0) {
                out.datum_type = (0, $gyVUi.PJD_7PARAM);
                out.datum_params[3] *= (0, $gyVUi.SEC_TO_RAD);
                out.datum_params[4] *= (0, $gyVUi.SEC_TO_RAD);
                out.datum_params[5] *= (0, $gyVUi.SEC_TO_RAD);
                out.datum_params[6] = out.datum_params[6] / 1000000.0 + 1.0;
            }
        }
    }
    if (nadgrids) {
        out.datum_type = (0, $gyVUi.PJD_GRIDSHIFT);
        out.grids = nadgrids;
    }
    out.a = a; // datum object also uses these values
    out.b = b;
    out.es = es;
    out.ep2 = ep2;
    return out;
}
var $2c13a87cc45f972b$export$2e2bcd8739ae039 = $2c13a87cc45f972b$var$datum;

});

parcelRegister("flUkq", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2d482da445fbb18$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getNadgrids", () => $b2d482da445fbb18$export$31c4d9288d81329a);
/**
 * Resources for details of NTv2 file formats:
 * - https://web.archive.org/web/20140127204822if_/http://www.mgs.gov.on.ca:80/stdprodconsume/groups/content/@mgs/@iandit/documents/resourcelist/stel02_047447.pdf
 * - http://mimaka.com/help/gs/html/004_NTV2%20Data%20Format.htm
 */ /**
 * @typedef {Object} NadgridInfo
 * @property {string} name The name of the NAD grid or 'null' if not specified.
 * @property {boolean} mandatory Indicates if the grid is mandatory (true) or optional (false).
 * @property {*} grid The loaded NAD grid object, or null if not loaded or not applicable.
 * @property {boolean} isNull True if the grid is explicitly 'null', otherwise false.
 */ /**
 * @typedef {Object} NTV2GridOptions
 * @property {boolean} [includeErrorFields=true] Whether to include error fields in the subgrids.
 */ /**
 * @typedef {Object} NadgridHeader
 * @property {number} [nFields] Number of fields in the header.
 * @property {number} [nSubgridFields] Number of fields in each subgrid header.
 * @property {number} nSubgrids Number of subgrids in the file.
 * @property {string} [shiftType] Type of shift (e.g., "SECONDS").
 * @property {number} [fromSemiMajorAxis] Source ellipsoid semi-major axis.
 * @property {number} [fromSemiMinorAxis] Source ellipsoid semi-minor axis.
 * @property {number} [toSemiMajorAxis] Target ellipsoid semi-major axis.
 * @property {number} [toSemiMinorAxis] Target ellipsoid semi-minor axis.
 */ /**
 * @typedef {Object} Subgrid
 * @property {Array<number>} ll Lower left corner of the grid in radians [longitude, latitude].
 * @property {Array<number>} del Grid spacing in radians [longitude interval, latitude interval].
 * @property {Array<number>} lim Number of columns in the grid [longitude columns, latitude columns].
 * @property {number} [count] Total number of grid nodes.
 * @property {Array} cvs Mapped node values for the grid.
 */ /** @typedef {{header: NadgridHeader, subgrids: Array<Subgrid>}} NADGrid */ /**
 * @typedef {Object} GeoTIFF
 * @property {() => Promise<number>} getImageCount - Returns the number of images in the GeoTIFF.
 * @property {(index: number) => Promise<GeoTIFFImage>} getImage - Returns a GeoTIFFImage for the given index.
 */ /**
 * @typedef {Object} GeoTIFFImage
 * @property {() => number} getWidth - Returns the width of the image.
 * @property {() => number} getHeight - Returns the height of the image.
 * @property {() => number[]} getBoundingBox - Returns the bounding box as [minX, minY, maxX, maxY] in degrees.
 * @property {() => Promise<ArrayLike<ArrayLike<number>>>} readRasters - Returns the raster data as an array of bands.
 * @property {Object} fileDirectory - The file directory object containing metadata.
 * @property {Object} fileDirectory.ModelPixelScale - The pixel scale array [scaleX, scaleY, scaleZ] in degrees.
 */ var $b2d482da445fbb18$var$loadedNadgrids = {};
function $b2d482da445fbb18$export$2e2bcd8739ae039(key, data, options) {
    if (data instanceof ArrayBuffer) return $b2d482da445fbb18$var$readNTV2Grid(key, data, options);
    return {
        ready: $b2d482da445fbb18$var$readGeotiffGrid(key, data)
    };
}
/**
 * @param {string} key The key to associate with the loaded grid.
 * @param {ArrayBuffer} data The NTv2 grid data as an ArrayBuffer.
 * @param {NTV2GridOptions} [options] Optional parameters for loading the grid.
 * @returns {NADGrid} The loaded NAD grid information.
 */ function $b2d482da445fbb18$var$readNTV2Grid(key, data, options) {
    var includeErrorFields = true;
    if (options !== undefined && options.includeErrorFields === false) includeErrorFields = false;
    var view = new DataView(data);
    var isLittleEndian = $b2d482da445fbb18$var$detectLittleEndian(view);
    var header = $b2d482da445fbb18$var$readHeader(view, isLittleEndian);
    var subgrids = $b2d482da445fbb18$var$readSubgrids(view, header, isLittleEndian, includeErrorFields);
    var nadgrid = {
        header: header,
        subgrids: subgrids
    };
    $b2d482da445fbb18$var$loadedNadgrids[key] = nadgrid;
    return nadgrid;
}
/**
 * @param {string} key The key to associate with the loaded grid.
 * @param {GeoTIFF} tiff The GeoTIFF instance to read the grid from.
 * @returns {Promise<NADGrid>} A promise that resolves to the loaded NAD grid information.
 */ async function $b2d482da445fbb18$var$readGeotiffGrid(key, tiff) {
    var subgrids = [];
    var subGridCount = await tiff.getImageCount();
    // proj produced tiff grid shift files appear to organize lower res subgrids first, higher res/ child subgrids last.
    for(var subgridIndex = subGridCount - 1; subgridIndex >= 0; subgridIndex--){
        var image = await tiff.getImage(subgridIndex);
        var rasters = await image.readRasters();
        var data = rasters;
        var lim = [
            image.getWidth(),
            image.getHeight()
        ];
        var imageBBoxRadians = image.getBoundingBox().map($b2d482da445fbb18$var$degreesToRadians);
        var del = [
            image.fileDirectory.ModelPixelScale[0],
            image.fileDirectory.ModelPixelScale[1]
        ].map($b2d482da445fbb18$var$degreesToRadians);
        var maxX = imageBBoxRadians[0] + (lim[0] - 1) * del[0];
        var minY = imageBBoxRadians[3] - (lim[1] - 1) * del[1];
        var latitudeOffsetBand = data[0];
        var longitudeOffsetBand = data[1];
        var nodes = [];
        for(let i = lim[1] - 1; i >= 0; i--)for(let j = lim[0] - 1; j >= 0; j--){
            var index = i * lim[0] + j;
            nodes.push([
                -$b2d482da445fbb18$var$secondsToRadians(longitudeOffsetBand[index]),
                $b2d482da445fbb18$var$secondsToRadians(latitudeOffsetBand[index])
            ]);
        }
        subgrids.push({
            del: del,
            lim: lim,
            ll: [
                -maxX,
                minY
            ],
            cvs: nodes
        });
    }
    var tifGrid = {
        header: {
            nSubgrids: subGridCount
        },
        subgrids: subgrids
    };
    $b2d482da445fbb18$var$loadedNadgrids[key] = tifGrid;
    return tifGrid;
}
function $b2d482da445fbb18$export$31c4d9288d81329a(nadgrids) {
    // Format details: http://proj.maptools.org/gen_parms.html
    if (nadgrids === undefined) return null;
    var grids = nadgrids.split(',');
    return grids.map($b2d482da445fbb18$var$parseNadgridString);
}
/**
 * @param {string} value The nadgrid string to get information for.
 * @returns {NadgridInfo|null} An object with grid information, or null if the input is empty.
 */ function $b2d482da445fbb18$var$parseNadgridString(value) {
    if (value.length === 0) return null;
    var optional = value[0] === '@';
    if (optional) value = value.slice(1);
    if (value === 'null') return {
        name: 'null',
        mandatory: !optional,
        grid: null,
        isNull: true
    };
    return {
        name: value,
        mandatory: !optional,
        grid: $b2d482da445fbb18$var$loadedNadgrids[value] || null,
        isNull: false
    };
}
function $b2d482da445fbb18$var$degreesToRadians(degrees) {
    return degrees * Math.PI / 180;
}
function $b2d482da445fbb18$var$secondsToRadians(seconds) {
    return seconds / 3600 * Math.PI / 180;
}
function $b2d482da445fbb18$var$detectLittleEndian(view) {
    var nFields = view.getInt32(8, false);
    if (nFields === 11) return false;
    nFields = view.getInt32(8, true);
    if (nFields !== 11) console.warn('Failed to detect nadgrid endian-ness, defaulting to little-endian');
    return true;
}
function $b2d482da445fbb18$var$readHeader(view, isLittleEndian) {
    return {
        nFields: view.getInt32(8, isLittleEndian),
        nSubgridFields: view.getInt32(24, isLittleEndian),
        nSubgrids: view.getInt32(40, isLittleEndian),
        shiftType: $b2d482da445fbb18$var$decodeString(view, 56, 64).trim(),
        fromSemiMajorAxis: view.getFloat64(120, isLittleEndian),
        fromSemiMinorAxis: view.getFloat64(136, isLittleEndian),
        toSemiMajorAxis: view.getFloat64(152, isLittleEndian),
        toSemiMinorAxis: view.getFloat64(168, isLittleEndian)
    };
}
function $b2d482da445fbb18$var$decodeString(view, start, end) {
    return String.fromCharCode.apply(null, new Uint8Array(view.buffer.slice(start, end)));
}
function $b2d482da445fbb18$var$readSubgrids(view, header, isLittleEndian, includeErrorFields) {
    var gridOffset = 176;
    var grids = [];
    for(var i = 0; i < header.nSubgrids; i++){
        var subHeader = $b2d482da445fbb18$var$readGridHeader(view, gridOffset, isLittleEndian);
        var nodes = $b2d482da445fbb18$var$readGridNodes(view, gridOffset, subHeader, isLittleEndian, includeErrorFields);
        var lngColumnCount = Math.round(1 + (subHeader.upperLongitude - subHeader.lowerLongitude) / subHeader.longitudeInterval);
        var latColumnCount = Math.round(1 + (subHeader.upperLatitude - subHeader.lowerLatitude) / subHeader.latitudeInterval);
        // Proj4 operates on radians whereas the coordinates are in seconds in the grid
        grids.push({
            ll: [
                $b2d482da445fbb18$var$secondsToRadians(subHeader.lowerLongitude),
                $b2d482da445fbb18$var$secondsToRadians(subHeader.lowerLatitude)
            ],
            del: [
                $b2d482da445fbb18$var$secondsToRadians(subHeader.longitudeInterval),
                $b2d482da445fbb18$var$secondsToRadians(subHeader.latitudeInterval)
            ],
            lim: [
                lngColumnCount,
                latColumnCount
            ],
            count: subHeader.gridNodeCount,
            cvs: $b2d482da445fbb18$var$mapNodes(nodes)
        });
        var rowSize = 16;
        if (includeErrorFields === false) rowSize = 8;
        gridOffset += 176 + subHeader.gridNodeCount * rowSize;
    }
    return grids;
}
/**
 * @param {*} nodes
 * @returns Array<Array<number>>
 */ function $b2d482da445fbb18$var$mapNodes(nodes) {
    return nodes.map(function(r) {
        return [
            $b2d482da445fbb18$var$secondsToRadians(r.longitudeShift),
            $b2d482da445fbb18$var$secondsToRadians(r.latitudeShift)
        ];
    });
}
function $b2d482da445fbb18$var$readGridHeader(view, offset, isLittleEndian) {
    return {
        name: $b2d482da445fbb18$var$decodeString(view, offset + 8, offset + 16).trim(),
        parent: $b2d482da445fbb18$var$decodeString(view, offset + 24, offset + 24 + 8).trim(),
        lowerLatitude: view.getFloat64(offset + 72, isLittleEndian),
        upperLatitude: view.getFloat64(offset + 88, isLittleEndian),
        lowerLongitude: view.getFloat64(offset + 104, isLittleEndian),
        upperLongitude: view.getFloat64(offset + 120, isLittleEndian),
        latitudeInterval: view.getFloat64(offset + 136, isLittleEndian),
        longitudeInterval: view.getFloat64(offset + 152, isLittleEndian),
        gridNodeCount: view.getInt32(offset + 168, isLittleEndian)
    };
}
function $b2d482da445fbb18$var$readGridNodes(view, offset, gridHeader, isLittleEndian, includeErrorFields) {
    var nodesOffset = offset + 176;
    var gridRecordLength = 16;
    if (includeErrorFields === false) gridRecordLength = 8;
    var gridShiftRecords = [];
    for(var i = 0; i < gridHeader.gridNodeCount; i++){
        var record = {
            latitudeShift: view.getFloat32(nodesOffset + i * gridRecordLength, isLittleEndian),
            longitudeShift: view.getFloat32(nodesOffset + i * gridRecordLength + 4, isLittleEndian)
        };
        if (includeErrorFields !== false) {
            record.latitudeAccuracy = view.getFloat32(nodesOffset + i * gridRecordLength + 8, isLittleEndian);
            record.longitudeAccuracy = view.getFloat32(nodesOffset + i * gridRecordLength + 12, isLittleEndian);
        }
        gridShiftRecords.push(record);
    }
    return gridShiftRecords;
}

});


parcelRegister("ceNev", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e8cfb7cbefc2113$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");

var $d7qcu = parcelRequire("d7qcu");

var $hL60j = parcelRequire("hL60j");

var $38qqf = parcelRequire("38qqf");

var $5vTfu = parcelRequire("5vTfu");

var $coO2L = parcelRequire("coO2L");
function $8e8cfb7cbefc2113$var$checkNotWGS(source, dest) {
    return (source.datum.datum_type === (0, $gyVUi.PJD_3PARAM) || source.datum.datum_type === (0, $gyVUi.PJD_7PARAM) || source.datum.datum_type === (0, $gyVUi.PJD_GRIDSHIFT)) && dest.datumCode !== 'WGS84' || (dest.datum.datum_type === (0, $gyVUi.PJD_3PARAM) || dest.datum.datum_type === (0, $gyVUi.PJD_7PARAM) || dest.datum.datum_type === (0, $gyVUi.PJD_GRIDSHIFT)) && source.datumCode !== 'WGS84';
}
function $8e8cfb7cbefc2113$export$2e2bcd8739ae039(source, dest, point, enforceAxis) {
    var wgs84;
    if (Array.isArray(point)) point = (0, $5vTfu.default)(point);
    else // Clone the point object so inputs don't get modified
    point = {
        x: point.x,
        y: point.y,
        z: point.z,
        m: point.m
    };
    var hasZ = point.z !== undefined;
    (0, $coO2L.default)(point);
    // Workaround for datum shifts towgs84, if either source or destination projection is not wgs84
    if (source.datum && dest.datum && $8e8cfb7cbefc2113$var$checkNotWGS(source, dest)) {
        wgs84 = new (0, $38qqf.default)('WGS84');
        point = $8e8cfb7cbefc2113$export$2e2bcd8739ae039(source, wgs84, point, enforceAxis);
        source = wgs84;
    }
    // DGR, 2010/11/12
    if (enforceAxis && source.axis !== 'enu') point = (0, $hL60j.default)(source, false, point);
    // Transform source points to long/lat, if they aren't already.
    if (source.projName === 'longlat') point = {
        x: point.x * (0, $gyVUi.D2R),
        y: point.y * (0, $gyVUi.D2R),
        z: point.z || 0
    };
    else {
        if (source.to_meter) point = {
            x: point.x * source.to_meter,
            y: point.y * source.to_meter,
            z: point.z || 0
        };
        point = source.inverse(point); // Convert Cartesian to longlat
        if (!point) return;
    }
    // Adjust for the prime meridian if necessary
    if (source.from_greenwich) point.x += source.from_greenwich;
    // Convert datums if needed, and if possible.
    point = (0, $d7qcu.default)(source.datum, dest.datum, point);
    if (!point) return;
    /** @type {import('./core').InterfaceCoordinates} */ point;
    // Adjust for the prime meridian if necessary
    if (dest.from_greenwich) point = {
        x: point.x - dest.from_greenwich,
        y: point.y,
        z: point.z || 0
    };
    if (dest.projName === 'longlat') // convert radians to decimal degrees
    point = {
        x: point.x * (0, $gyVUi.R2D),
        y: point.y * (0, $gyVUi.R2D),
        z: point.z || 0
    };
    else {
        point = dest.forward(point);
        if (dest.to_meter) point = {
            x: point.x / dest.to_meter,
            y: point.y / dest.to_meter,
            z: point.z || 0
        };
    }
    // DGR, 2010/11/12
    if (enforceAxis && dest.axis !== 'enu') return (0, $hL60j.default)(dest, true, point);
    if (point && !hasZ) delete point.z;
    return point;
}

});
parcelRegister("d7qcu", function(module, exports) {

$parcel$export(module.exports, "default", () => $98d040a88dc0214f$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");

var $4YPx7 = parcelRequire("4YPx7");

var $a9oRf = parcelRequire("a9oRf");
function $98d040a88dc0214f$var$checkParams(type) {
    return type === (0, $gyVUi.PJD_3PARAM) || type === (0, $gyVUi.PJD_7PARAM);
}
function $98d040a88dc0214f$export$2e2bcd8739ae039(source, dest, point) {
    // Short cut if the datums are identical.
    if ((0, $4YPx7.compareDatums)(source, dest)) return point; // in this case, zero is sucess,
    // Explicitly skip datum transform by setting 'datum=none' as parameter for either source or dest
    if (source.datum_type === (0, $gyVUi.PJD_NODATUM) || dest.datum_type === (0, $gyVUi.PJD_NODATUM)) return point;
    // If this datum requires grid shifts, then apply it to geodetic coordinates.
    var source_a = source.a;
    var source_es = source.es;
    if (source.datum_type === (0, $gyVUi.PJD_GRIDSHIFT)) {
        var gridShiftCode = $98d040a88dc0214f$export$cfa06df23524576a(source, false, point);
        if (gridShiftCode !== 0) return undefined;
        source_a = (0, $gyVUi.SRS_WGS84_SEMIMAJOR);
        source_es = (0, $gyVUi.SRS_WGS84_ESQUARED);
    }
    var dest_a = dest.a;
    var dest_b = dest.b;
    var dest_es = dest.es;
    if (dest.datum_type === (0, $gyVUi.PJD_GRIDSHIFT)) {
        dest_a = (0, $gyVUi.SRS_WGS84_SEMIMAJOR);
        dest_b = (0, $gyVUi.SRS_WGS84_SEMIMINOR);
        dest_es = (0, $gyVUi.SRS_WGS84_ESQUARED);
    }
    // Do we need to go through geocentric coordinates?
    if (source_es === dest_es && source_a === dest_a && !$98d040a88dc0214f$var$checkParams(source.datum_type) && !$98d040a88dc0214f$var$checkParams(dest.datum_type)) return point;
    // Convert to geocentric coordinates.
    point = (0, $4YPx7.geodeticToGeocentric)(point, source_es, source_a);
    // Convert between datums
    if ($98d040a88dc0214f$var$checkParams(source.datum_type)) point = (0, $4YPx7.geocentricToWgs84)(point, source.datum_type, source.datum_params);
    if ($98d040a88dc0214f$var$checkParams(dest.datum_type)) point = (0, $4YPx7.geocentricFromWgs84)(point, dest.datum_type, dest.datum_params);
    point = (0, $4YPx7.geocentricToGeodetic)(point, dest_es, dest_a, dest_b);
    if (dest.datum_type === (0, $gyVUi.PJD_GRIDSHIFT)) {
        var destGridShiftResult = $98d040a88dc0214f$export$cfa06df23524576a(dest, true, point);
        if (destGridShiftResult !== 0) return undefined;
    }
    return point;
}
function $98d040a88dc0214f$export$cfa06df23524576a(source, inverse, point) {
    if (source.grids === null || source.grids.length === 0) {
        console.log('Grid shift grids not found');
        return -1;
    }
    var input = {
        x: -point.x,
        y: point.y
    };
    var output = {
        x: Number.NaN,
        y: Number.NaN
    };
    var attemptedGrids = [];
    outer: for(var i = 0; i < source.grids.length; i++){
        var grid = source.grids[i];
        attemptedGrids.push(grid.name);
        if (grid.isNull) {
            output = input;
            break;
        }
        if (grid.grid === null) {
            if (grid.mandatory) {
                console.log('Unable to find mandatory grid \'' + grid.name + '\'');
                return -1;
            }
            continue;
        }
        var subgrids = grid.grid.subgrids;
        for(var j = 0, jj = subgrids.length; j < jj; j++){
            var subgrid = subgrids[j];
            // skip tables that don't match our point at all
            var epsilon = (Math.abs(subgrid.del[1]) + Math.abs(subgrid.del[0])) / 10000.0;
            var minX = subgrid.ll[0] - epsilon;
            var minY = subgrid.ll[1] - epsilon;
            var maxX = subgrid.ll[0] + (subgrid.lim[0] - 1) * subgrid.del[0] + epsilon;
            var maxY = subgrid.ll[1] + (subgrid.lim[1] - 1) * subgrid.del[1] + epsilon;
            if (minY > input.y || minX > input.x || maxY < input.y || maxX < input.x) continue;
            output = $98d040a88dc0214f$var$applySubgridShift(input, inverse, subgrid);
            if (!isNaN(output.x)) break outer;
        }
    }
    if (isNaN(output.x)) {
        console.log('Failed to find a grid shift table for location \'' + -input.x * (0, $gyVUi.R2D) + ' ' + input.y * (0, $gyVUi.R2D) + ' tried: \'' + attemptedGrids + '\'');
        return -1;
    }
    point.x = -output.x;
    point.y = output.y;
    return 0;
}
function $98d040a88dc0214f$var$applySubgridShift(pin, inverse, ct) {
    var val = {
        x: Number.NaN,
        y: Number.NaN
    };
    if (isNaN(pin.x)) return val;
    var tb = {
        x: pin.x,
        y: pin.y
    };
    tb.x -= ct.ll[0];
    tb.y -= ct.ll[1];
    tb.x = (0, $a9oRf.default)(tb.x - Math.PI) + Math.PI;
    var t = $98d040a88dc0214f$var$nadInterpolate(tb, ct);
    if (inverse) {
        if (isNaN(t.x)) return val;
        t.x = tb.x - t.x;
        t.y = tb.y - t.y;
        var i = 9, tol = 1e-12;
        var dif, del;
        do {
            del = $98d040a88dc0214f$var$nadInterpolate(t, ct);
            if (isNaN(del.x)) {
                console.log('Inverse grid shift iteration failed, presumably at grid edge.  Using first approximation.');
                break;
            }
            dif = {
                x: tb.x - (del.x + t.x),
                y: tb.y - (del.y + t.y)
            };
            t.x += dif.x;
            t.y += dif.y;
        }while (i-- && Math.abs(dif.x) > tol && Math.abs(dif.y) > tol);
        if (i < 0) {
            console.log('Inverse grid shift iterator failed to converge.');
            return val;
        }
        val.x = (0, $a9oRf.default)(t.x + ct.ll[0]);
        val.y = t.y + ct.ll[1];
    } else if (!isNaN(t.x)) {
        val.x = pin.x + t.x;
        val.y = pin.y + t.y;
    }
    return val;
}
function $98d040a88dc0214f$var$nadInterpolate(pin, ct) {
    var t = {
        x: pin.x / ct.del[0],
        y: pin.y / ct.del[1]
    };
    var indx = {
        x: Math.floor(t.x),
        y: Math.floor(t.y)
    };
    var frct = {
        x: t.x - 1.0 * indx.x,
        y: t.y - 1.0 * indx.y
    };
    var val = {
        x: Number.NaN,
        y: Number.NaN
    };
    var inx;
    if (indx.x < 0 || indx.x >= ct.lim[0]) return val;
    if (indx.y < 0 || indx.y >= ct.lim[1]) return val;
    inx = indx.y * ct.lim[0] + indx.x;
    var f00 = {
        x: ct.cvs[inx][0],
        y: ct.cvs[inx][1]
    };
    inx++;
    var f10 = {
        x: ct.cvs[inx][0],
        y: ct.cvs[inx][1]
    };
    inx += ct.lim[0];
    var f11 = {
        x: ct.cvs[inx][0],
        y: ct.cvs[inx][1]
    };
    inx--;
    var f01 = {
        x: ct.cvs[inx][0],
        y: ct.cvs[inx][1]
    };
    var m11 = frct.x * frct.y, m10 = frct.x * (1.0 - frct.y), m00 = (1.0 - frct.x) * (1.0 - frct.y), m01 = (1.0 - frct.x) * frct.y;
    val.x = m00 * f00.x + m10 * f10.x + m01 * f01.x + m11 * f11.x;
    val.y = m00 * f00.y + m10 * f10.y + m01 * f01.y + m11 * f11.y;
    return val;
}

});
parcelRegister("4YPx7", function(module, exports) {

$parcel$export(module.exports, "compareDatums", () => $3a04bd721826a648$export$68c8d8590fbb24e4);
$parcel$export(module.exports, "geodeticToGeocentric", () => $3a04bd721826a648$export$4a4ae2976f9a808a);
$parcel$export(module.exports, "geocentricToGeodetic", () => $3a04bd721826a648$export$26210192c8922750);
$parcel$export(module.exports, "geocentricToWgs84", () => $3a04bd721826a648$export$d18952b9ecb47c8f);
$parcel$export(module.exports, "geocentricFromWgs84", () => $3a04bd721826a648$export$2b744ad521e7ac0b);

var $gyVUi = parcelRequire("gyVUi");
'use strict';
function $3a04bd721826a648$export$68c8d8590fbb24e4(source, dest) {
    if (source.datum_type !== dest.datum_type) return false; // false, datums are not equal
    else if (source.a !== dest.a || Math.abs(source.es - dest.es) > 0.000000000050) // the tolerance for es is to ensure that GRS80 and WGS84
    // are considered identical
    return false;
    else if (source.datum_type === (0, $gyVUi.PJD_3PARAM)) return source.datum_params[0] === dest.datum_params[0] && source.datum_params[1] === dest.datum_params[1] && source.datum_params[2] === dest.datum_params[2];
    else if (source.datum_type === (0, $gyVUi.PJD_7PARAM)) return source.datum_params[0] === dest.datum_params[0] && source.datum_params[1] === dest.datum_params[1] && source.datum_params[2] === dest.datum_params[2] && source.datum_params[3] === dest.datum_params[3] && source.datum_params[4] === dest.datum_params[4] && source.datum_params[5] === dest.datum_params[5] && source.datum_params[6] === dest.datum_params[6];
    else return true; // datums are equal
} // cs_compare_datums()
function $3a04bd721826a648$export$4a4ae2976f9a808a(p, es, a) {
    var Longitude = p.x;
    var Latitude = p.y;
    var Height = p.z ? p.z : 0; // Z value not always supplied
    var Rn; /*  Earth radius at location  */ 
    var Sin_Lat; /*  Math.sin(Latitude)  */ 
    var Sin2_Lat; /*  Square of Math.sin(Latitude)  */ 
    var Cos_Lat; /*  Math.cos(Latitude)  */ 
    /*
   ** Don't blow up if Latitude is just a little out of the value
   ** range as it may just be a rounding issue.  Also removed longitude
   ** test, it should be wrapped by Math.cos() and Math.sin().  NFW for PROJ.4, Sep/2001.
   */ if (Latitude < -(0, $gyVUi.HALF_PI) && Latitude > -1.001 * (0, $gyVUi.HALF_PI)) Latitude = -(0, $gyVUi.HALF_PI);
    else if (Latitude > (0, $gyVUi.HALF_PI) && Latitude < 1.001 * (0, $gyVUi.HALF_PI)) Latitude = (0, $gyVUi.HALF_PI);
    else if (Latitude < -(0, $gyVUi.HALF_PI)) /* Latitude out of range */ // ..reportError('geocent:lat out of range:' + Latitude);
    return {
        x: -Infinity,
        y: -Infinity,
        z: p.z
    };
    else if (Latitude > (0, $gyVUi.HALF_PI)) /* Latitude out of range */ return {
        x: Infinity,
        y: Infinity,
        z: p.z
    };
    if (Longitude > Math.PI) Longitude -= 2 * Math.PI;
    Sin_Lat = Math.sin(Latitude);
    Cos_Lat = Math.cos(Latitude);
    Sin2_Lat = Sin_Lat * Sin_Lat;
    Rn = a / Math.sqrt(1.0e0 - es * Sin2_Lat);
    return {
        x: (Rn + Height) * Cos_Lat * Math.cos(Longitude),
        y: (Rn + Height) * Cos_Lat * Math.sin(Longitude),
        z: (Rn * (1 - es) + Height) * Sin_Lat
    };
} // cs_geodetic_to_geocentric()
function $3a04bd721826a648$export$26210192c8922750(p, es, a, b) {
    /* local defintions and variables */ /* end-criterium of loop, accuracy of sin(Latitude) */ var genau = 1e-12;
    var genau2 = genau * genau;
    var maxiter = 30;
    var P; /* distance between semi-minor axis and location */ 
    var RR; /* distance between center and location */ 
    var CT; /* sin of geocentric latitude */ 
    var ST; /* cos of geocentric latitude */ 
    var RX;
    var RK;
    var RN; /* Earth radius at location */ 
    var CPHI0; /* cos of start or old geodetic latitude in iterations */ 
    var SPHI0; /* sin of start or old geodetic latitude in iterations */ 
    var CPHI; /* cos of searched geodetic latitude */ 
    var SPHI; /* sin of searched geodetic latitude */ 
    var SDPHI; /* end-criterium: addition-theorem of sin(Latitude(iter)-Latitude(iter-1)) */ 
    var iter; /* # of continous iteration, max. 30 is always enough (s.a.) */ 
    var X = p.x;
    var Y = p.y;
    var Z = p.z ? p.z : 0.0; // Z value not always supplied
    var Longitude;
    var Latitude;
    var Height;
    P = Math.sqrt(X * X + Y * Y);
    RR = Math.sqrt(X * X + Y * Y + Z * Z);
    /*      special cases for latitude and longitude */ if (P / a < genau) {
        /*  special case, if P=0. (X=0., Y=0.) */ Longitude = 0.0;
        /*  if (X,Y,Z)=(0.,0.,0.) then Height becomes semi-minor axis
     *  of ellipsoid (=center of mass), Latitude becomes PI/2 */ if (RR / a < genau) {
            Latitude = (0, $gyVUi.HALF_PI);
            Height = -b;
            return {
                x: p.x,
                y: p.y,
                z: p.z
            };
        }
    } else /*  ellipsoidal (geodetic) longitude
     *  interval: -PI < Longitude <= +PI */ Longitude = Math.atan2(Y, X);
    /* --------------------------------------------------------------
   * Following iterative algorithm was developped by
   * "Institut for Erdmessung", University of Hannover, July 1988.
   * Internet: www.ife.uni-hannover.de
   * Iterative computation of CPHI,SPHI and Height.
   * Iteration of CPHI and SPHI to 10**-12 radian resp.
   * 2*10**-7 arcsec.
   * --------------------------------------------------------------
   */ CT = Z / RR;
    ST = P / RR;
    RX = 1.0 / Math.sqrt(1.0 - es * (2.0 - es) * ST * ST);
    CPHI0 = ST * (1.0 - es) * RX;
    SPHI0 = CT * RX;
    iter = 0;
    /* loop to find sin(Latitude) resp. Latitude
   * until |sin(Latitude(iter)-Latitude(iter-1))| < genau */ do {
        iter++;
        RN = a / Math.sqrt(1.0 - es * SPHI0 * SPHI0);
        /*  ellipsoidal (geodetic) height */ Height = P * CPHI0 + Z * SPHI0 - RN * (1.0 - es * SPHI0 * SPHI0);
        RK = es * RN / (RN + Height);
        RX = 1.0 / Math.sqrt(1.0 - RK * (2.0 - RK) * ST * ST);
        CPHI = ST * (1.0 - RK) * RX;
        SPHI = CT * RX;
        SDPHI = SPHI * CPHI0 - CPHI * SPHI0;
        CPHI0 = CPHI;
        SPHI0 = SPHI;
    }while (SDPHI * SDPHI > genau2 && iter < maxiter);
    /*      ellipsoidal (geodetic) latitude */ Latitude = Math.atan(SPHI / Math.abs(CPHI));
    return {
        x: Longitude,
        y: Latitude,
        z: Height
    };
} // cs_geocentric_to_geodetic()
function $3a04bd721826a648$export$d18952b9ecb47c8f(p, datum_type, datum_params) {
    if (datum_type === (0, $gyVUi.PJD_3PARAM)) // if( x[io] === HUGE_VAL )
    //    continue;
    return {
        x: p.x + datum_params[0],
        y: p.y + datum_params[1],
        z: p.z + datum_params[2]
    };
    else if (datum_type === (0, $gyVUi.PJD_7PARAM)) {
        var Dx_BF = datum_params[0];
        var Dy_BF = datum_params[1];
        var Dz_BF = datum_params[2];
        var Rx_BF = datum_params[3];
        var Ry_BF = datum_params[4];
        var Rz_BF = datum_params[5];
        var M_BF = datum_params[6];
        // if( x[io] === HUGE_VAL )
        //    continue;
        return {
            x: M_BF * (p.x - Rz_BF * p.y + Ry_BF * p.z) + Dx_BF,
            y: M_BF * (Rz_BF * p.x + p.y - Rx_BF * p.z) + Dy_BF,
            z: M_BF * (-Ry_BF * p.x + Rx_BF * p.y + p.z) + Dz_BF
        };
    }
} // cs_geocentric_to_wgs84
function $3a04bd721826a648$export$2b744ad521e7ac0b(p, datum_type, datum_params) {
    if (datum_type === (0, $gyVUi.PJD_3PARAM)) // if( x[io] === HUGE_VAL )
    //    continue;
    return {
        x: p.x - datum_params[0],
        y: p.y - datum_params[1],
        z: p.z - datum_params[2]
    };
    else if (datum_type === (0, $gyVUi.PJD_7PARAM)) {
        var Dx_BF = datum_params[0];
        var Dy_BF = datum_params[1];
        var Dz_BF = datum_params[2];
        var Rx_BF = datum_params[3];
        var Ry_BF = datum_params[4];
        var Rz_BF = datum_params[5];
        var M_BF = datum_params[6];
        var x_tmp = (p.x - Dx_BF) / M_BF;
        var y_tmp = (p.y - Dy_BF) / M_BF;
        var z_tmp = (p.z - Dz_BF) / M_BF;
        // if( x[io] === HUGE_VAL )
        //    continue;
        return {
            x: x_tmp + Rz_BF * y_tmp - Ry_BF * z_tmp,
            y: -Rz_BF * x_tmp + y_tmp + Rx_BF * z_tmp,
            z: Ry_BF * x_tmp - Rx_BF * y_tmp + z_tmp
        };
    } // cs_geocentric_from_wgs84()
}

});


parcelRegister("hL60j", function(module, exports) {

$parcel$export(module.exports, "default", () => $cedb7bb5617791b0$export$2e2bcd8739ae039);
function $cedb7bb5617791b0$export$2e2bcd8739ae039(crs, denorm, point) {
    var xin = point.x, yin = point.y, zin = point.z || 0.0;
    var v, t, i;
    /** @type {import("./core").InterfaceCoordinates} */ var out = {};
    for(i = 0; i < 3; i++){
        if (denorm && i === 2 && point.z === undefined) continue;
        if (i === 0) {
            v = xin;
            if ('ew'.indexOf(crs.axis[i]) !== -1) t = 'x';
            else t = 'y';
        } else if (i === 1) {
            v = yin;
            if ('ns'.indexOf(crs.axis[i]) !== -1) t = 'y';
            else t = 'x';
        } else {
            v = zin;
            t = 'z';
        }
        switch(crs.axis[i]){
            case 'e':
                out[t] = v;
                break;
            case 'w':
                out[t] = -v;
                break;
            case 'n':
                out[t] = v;
                break;
            case 's':
                out[t] = -v;
                break;
            case 'u':
                if (point[t] !== undefined) out.z = v;
                break;
            case 'd':
                if (point[t] !== undefined) out.z = -v;
                break;
            default:
                // console.log("ERROR: unknow axis ("+crs.axis[i]+") - check definition of "+crs.projName);
                return null;
        }
    }
    return out;
}

});

parcelRegister("5vTfu", function(module, exports) {

$parcel$export(module.exports, "default", () => $01093474ae9bd8f6$export$2e2bcd8739ae039);
/**
 * @param {Array<number>} array
 * @returns {import("../core").InterfaceCoordinates}
 */ function $01093474ae9bd8f6$export$2e2bcd8739ae039(array) {
    var out = {
        x: array[0],
        y: array[1]
    };
    if (array.length > 2) out.z = array[2];
    if (array.length > 3) out.m = array[3];
    return out;
}

});

parcelRegister("coO2L", function(module, exports) {

$parcel$export(module.exports, "default", () => $906e8b8bdc80d434$export$2e2bcd8739ae039);
function $906e8b8bdc80d434$export$2e2bcd8739ae039(point) {
    $906e8b8bdc80d434$var$checkCoord(point.x);
    $906e8b8bdc80d434$var$checkCoord(point.y);
}
function $906e8b8bdc80d434$var$checkCoord(num) {
    if (typeof Number.isFinite === 'function') {
        if (Number.isFinite(num)) return;
        throw new TypeError('coordinates must be finite numbers');
    }
    if (typeof num !== 'number' || num !== num || !isFinite(num)) throw new TypeError('coordinates must be finite numbers');
}

});



parcelRegister("iCFRA", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8ec3fc1ff061c76$export$2e2bcd8739ae039);

var $4hMrQ = parcelRequire("4hMrQ");
/**
 * @deprecated v3.0.0 - use proj4.toPoint instead
 * @param {number | import('./core').TemplateCoordinates | string} x
 * @param {number} [y]
 * @param {number} [z]
 */ function $d8ec3fc1ff061c76$var$Point(x, y, z) {
    if (!(this instanceof $d8ec3fc1ff061c76$var$Point)) return new $d8ec3fc1ff061c76$var$Point(x, y, z);
    if (Array.isArray(x)) {
        this.x = x[0];
        this.y = x[1];
        this.z = x[2] || 0.0;
    } else if (typeof x === 'object') {
        this.x = x.x;
        this.y = x.y;
        this.z = x.z || 0.0;
    } else if (typeof x === 'string' && typeof y === 'undefined') {
        var coords = x.split(',');
        this.x = parseFloat(coords[0]);
        this.y = parseFloat(coords[1]);
        this.z = parseFloat(coords[2]) || 0.0;
    } else {
        this.x = x;
        this.y = y;
        this.z = z || 0.0;
    }
    console.warn('proj4.Point will be removed in version 3, use proj4.toPoint');
}
$d8ec3fc1ff061c76$var$Point.fromMGRS = function(mgrsStr) {
    return new $d8ec3fc1ff061c76$var$Point((0, $4hMrQ.toPoint)(mgrsStr));
};
$d8ec3fc1ff061c76$var$Point.prototype.toMGRS = function(accuracy) {
    return (0, $4hMrQ.forward)([
        this.x,
        this.y
    ], accuracy);
};
var $d8ec3fc1ff061c76$export$2e2bcd8739ae039 = $d8ec3fc1ff061c76$var$Point;

});
parcelRegister("4hMrQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $31ee54b8e1d1cd8f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "forward", () => $31ee54b8e1d1cd8f$export$174bb771924e7eb1);
$parcel$export(module.exports, "toPoint", () => $31ee54b8e1d1cd8f$export$b63cca88ddc558a9);
/**
 * UTM zones are grouped, and assigned to one of a group of 6
 * sets.
 *
 * {int} @private
 */ var $31ee54b8e1d1cd8f$var$NUM_100K_SETS = 6;
/**
 * The column letters (for easting) of the lower left value, per
 * set.
 *
 * {string} @private
 */ var $31ee54b8e1d1cd8f$var$SET_ORIGIN_COLUMN_LETTERS = 'AJSAJS';
/**
 * The row letters (for northing) of the lower left value, per
 * set.
 *
 * {string} @private
 */ var $31ee54b8e1d1cd8f$var$SET_ORIGIN_ROW_LETTERS = 'AFAFAF';
var $31ee54b8e1d1cd8f$var$A = 65; // A
var $31ee54b8e1d1cd8f$var$I = 73; // I
var $31ee54b8e1d1cd8f$var$O = 79; // O
var $31ee54b8e1d1cd8f$var$V = 86; // V
var $31ee54b8e1d1cd8f$var$Z = 90; // Z
var $31ee54b8e1d1cd8f$export$2e2bcd8739ae039 = {
    forward: $31ee54b8e1d1cd8f$export$174bb771924e7eb1,
    inverse: $31ee54b8e1d1cd8f$export$70ae2c07e401031b,
    toPoint: $31ee54b8e1d1cd8f$export$b63cca88ddc558a9
};
function $31ee54b8e1d1cd8f$export$174bb771924e7eb1(ll, accuracy) {
    accuracy = accuracy || 5; // default accuracy 1m
    return $31ee54b8e1d1cd8f$var$encode($31ee54b8e1d1cd8f$var$LLtoUTM({
        lat: ll[1],
        lon: ll[0]
    }), accuracy);
}
function $31ee54b8e1d1cd8f$export$70ae2c07e401031b(mgrs) {
    var bbox = $31ee54b8e1d1cd8f$var$UTMtoLL($31ee54b8e1d1cd8f$var$decode(mgrs.toUpperCase()));
    if (bbox.lat && bbox.lon) return [
        bbox.lon,
        bbox.lat,
        bbox.lon,
        bbox.lat
    ];
    return [
        bbox.left,
        bbox.bottom,
        bbox.right,
        bbox.top
    ];
}
function $31ee54b8e1d1cd8f$export$b63cca88ddc558a9(mgrs) {
    var bbox = $31ee54b8e1d1cd8f$var$UTMtoLL($31ee54b8e1d1cd8f$var$decode(mgrs.toUpperCase()));
    if (bbox.lat && bbox.lon) return [
        bbox.lon,
        bbox.lat
    ];
    return [
        (bbox.left + bbox.right) / 2,
        (bbox.top + bbox.bottom) / 2
    ];
}
/**
 * Conversion from degrees to radians.
 *
 * @private
 * @param {number} deg the angle in degrees.
 * @return {number} the angle in radians.
 */ function $31ee54b8e1d1cd8f$var$degToRad(deg) {
    return deg * (Math.PI / 180.0);
}
/**
 * Conversion from radians to degrees.
 *
 * @private
 * @param {number} rad the angle in radians.
 * @return {number} the angle in degrees.
 */ function $31ee54b8e1d1cd8f$var$radToDeg(rad) {
    return 180.0 * (rad / Math.PI);
}
/**
 * Converts a set of Longitude and Latitude co-ordinates to UTM
 * using the WGS84 ellipsoid.
 *
 * @private
 * @param {object} ll Object literal with lat and lon properties
 *     representing the WGS84 coordinate to be converted.
 * @return {object} Object literal containing the UTM value with easting,
 *     northing, zoneNumber and zoneLetter properties, and an optional
 *     accuracy property in digits. Returns null if the conversion failed.
 */ function $31ee54b8e1d1cd8f$var$LLtoUTM(ll) {
    var Lat = ll.lat;
    var Long = ll.lon;
    var a = 6378137.0; //ellip.radius;
    var eccSquared = 0.00669438; //ellip.eccsq;
    var k0 = 0.9996;
    var LongOrigin;
    var eccPrimeSquared;
    var N, T, C, A, M;
    var LatRad = $31ee54b8e1d1cd8f$var$degToRad(Lat);
    var LongRad = $31ee54b8e1d1cd8f$var$degToRad(Long);
    var LongOriginRad;
    var ZoneNumber;
    // (int)
    ZoneNumber = Math.floor((Long + 180) / 6) + 1;
    //Make sure the longitude 180.00 is in Zone 60
    if (Long === 180) ZoneNumber = 60;
    // Special zone for Norway
    if (Lat >= 56.0 && Lat < 64.0 && Long >= 3.0 && Long < 12.0) ZoneNumber = 32;
    // Special zones for Svalbard
    if (Lat >= 72.0 && Lat < 84.0) {
        if (Long >= 0.0 && Long < 9.0) ZoneNumber = 31;
        else if (Long >= 9.0 && Long < 21.0) ZoneNumber = 33;
        else if (Long >= 21.0 && Long < 33.0) ZoneNumber = 35;
        else if (Long >= 33.0 && Long < 42.0) ZoneNumber = 37;
    }
    LongOrigin = (ZoneNumber - 1) * 6 - 180 + 3; //+3 puts origin
    // in middle of
    // zone
    LongOriginRad = $31ee54b8e1d1cd8f$var$degToRad(LongOrigin);
    eccPrimeSquared = eccSquared / (1 - eccSquared);
    N = a / Math.sqrt(1 - eccSquared * Math.sin(LatRad) * Math.sin(LatRad));
    T = Math.tan(LatRad) * Math.tan(LatRad);
    C = eccPrimeSquared * Math.cos(LatRad) * Math.cos(LatRad);
    A = Math.cos(LatRad) * (LongRad - LongOriginRad);
    M = a * ((1 - eccSquared / 4 - 3 * eccSquared * eccSquared / 64 - 5 * eccSquared * eccSquared * eccSquared / 256) * LatRad - (3 * eccSquared / 8 + 3 * eccSquared * eccSquared / 32 + 45 * eccSquared * eccSquared * eccSquared / 1024) * Math.sin(2 * LatRad) + (15 * eccSquared * eccSquared / 256 + 45 * eccSquared * eccSquared * eccSquared / 1024) * Math.sin(4 * LatRad) - 35 * eccSquared * eccSquared * eccSquared / 3072 * Math.sin(6 * LatRad));
    var UTMEasting = k0 * N * (A + (1 - T + C) * A * A * A / 6.0 + (5 - 18 * T + T * T + 72 * C - 58 * eccPrimeSquared) * A * A * A * A * A / 120.0) + 500000.0;
    var UTMNorthing = k0 * (M + N * Math.tan(LatRad) * (A * A / 2 + (5 - T + 9 * C + 4 * C * C) * A * A * A * A / 24.0 + (61 - 58 * T + T * T + 600 * C - 330 * eccPrimeSquared) * A * A * A * A * A * A / 720.0));
    if (Lat < 0.0) UTMNorthing += 10000000.0; //10000000 meter offset for
    return {
        northing: Math.round(UTMNorthing),
        easting: Math.round(UTMEasting),
        zoneNumber: ZoneNumber,
        zoneLetter: $31ee54b8e1d1cd8f$var$getLetterDesignator(Lat)
    };
}
/**
 * Converts UTM coords to lat/long, using the WGS84 ellipsoid. This is a convenience
 * class where the Zone can be specified as a single string eg."60N" which
 * is then broken down into the ZoneNumber and ZoneLetter.
 *
 * @private
 * @param {object} utm An object literal with northing, easting, zoneNumber
 *     and zoneLetter properties. If an optional accuracy property is
 *     provided (in meters), a bounding box will be returned instead of
 *     latitude and longitude.
 * @return {object} An object literal containing either lat and lon values
 *     (if no accuracy was provided), or top, right, bottom and left values
 *     for the bounding box calculated according to the provided accuracy.
 *     Returns null if the conversion failed.
 */ function $31ee54b8e1d1cd8f$var$UTMtoLL(utm) {
    var UTMNorthing = utm.northing;
    var UTMEasting = utm.easting;
    var zoneLetter = utm.zoneLetter;
    var zoneNumber = utm.zoneNumber;
    // check the ZoneNummber is valid
    if (zoneNumber < 0 || zoneNumber > 60) return null;
    var k0 = 0.9996;
    var a = 6378137.0; //ellip.radius;
    var eccSquared = 0.00669438; //ellip.eccsq;
    var eccPrimeSquared;
    var e1 = (1 - Math.sqrt(1 - eccSquared)) / (1 + Math.sqrt(1 - eccSquared));
    var N1, T1, C1, R1, D, M;
    var LongOrigin;
    var mu, phi1Rad;
    // remove 500,000 meter offset for longitude
    var x = UTMEasting - 500000.0;
    var y = UTMNorthing;
    // We must know somehow if we are in the Northern or Southern
    // hemisphere, this is the only time we use the letter So even
    // if the Zone letter isn't exactly correct it should indicate
    // the hemisphere correctly
    if (zoneLetter < 'N') y -= 10000000.0; // remove 10,000,000 meter offset used
    // There are 60 zones with zone 1 being at West -180 to -174
    LongOrigin = (zoneNumber - 1) * 6 - 180 + 3; // +3 puts origin
    // in middle of
    // zone
    eccPrimeSquared = eccSquared / (1 - eccSquared);
    M = y / k0;
    mu = M / (a * (1 - eccSquared / 4 - 3 * eccSquared * eccSquared / 64 - 5 * eccSquared * eccSquared * eccSquared / 256));
    phi1Rad = mu + (3 * e1 / 2 - 27 * e1 * e1 * e1 / 32) * Math.sin(2 * mu) + (21 * e1 * e1 / 16 - 55 * e1 * e1 * e1 * e1 / 32) * Math.sin(4 * mu) + 151 * e1 * e1 * e1 / 96 * Math.sin(6 * mu);
    // double phi1 = ProjMath.radToDeg(phi1Rad);
    N1 = a / Math.sqrt(1 - eccSquared * Math.sin(phi1Rad) * Math.sin(phi1Rad));
    T1 = Math.tan(phi1Rad) * Math.tan(phi1Rad);
    C1 = eccPrimeSquared * Math.cos(phi1Rad) * Math.cos(phi1Rad);
    R1 = a * (1 - eccSquared) / Math.pow(1 - eccSquared * Math.sin(phi1Rad) * Math.sin(phi1Rad), 1.5);
    D = x / (N1 * k0);
    var lat = phi1Rad - N1 * Math.tan(phi1Rad) / R1 * (D * D / 2 - (5 + 3 * T1 + 10 * C1 - 4 * C1 * C1 - 9 * eccPrimeSquared) * D * D * D * D / 24 + (61 + 90 * T1 + 298 * C1 + 45 * T1 * T1 - 252 * eccPrimeSquared - 3 * C1 * C1) * D * D * D * D * D * D / 720);
    lat = $31ee54b8e1d1cd8f$var$radToDeg(lat);
    var lon = (D - (1 + 2 * T1 + C1) * D * D * D / 6 + (5 - 2 * C1 + 28 * T1 - 3 * C1 * C1 + 8 * eccPrimeSquared + 24 * T1 * T1) * D * D * D * D * D / 120) / Math.cos(phi1Rad);
    lon = LongOrigin + $31ee54b8e1d1cd8f$var$radToDeg(lon);
    var result;
    if (utm.accuracy) {
        var topRight = $31ee54b8e1d1cd8f$var$UTMtoLL({
            northing: utm.northing + utm.accuracy,
            easting: utm.easting + utm.accuracy,
            zoneLetter: utm.zoneLetter,
            zoneNumber: utm.zoneNumber
        });
        result = {
            top: topRight.lat,
            right: topRight.lon,
            bottom: lat,
            left: lon
        };
    } else result = {
        lat: lat,
        lon: lon
    };
    return result;
}
/**
 * Calculates the MGRS letter designator for the given latitude.
 *
 * @private
 * @param {number} lat The latitude in WGS84 to get the letter designator
 *     for.
 * @return {char} The letter designator.
 */ function $31ee54b8e1d1cd8f$var$getLetterDesignator(lat) {
    //This is here as an error flag to show that the Latitude is
    //outside MGRS limits
    var LetterDesignator = 'Z';
    if (84 >= lat && lat >= 72) LetterDesignator = 'X';
    else if (72 > lat && lat >= 64) LetterDesignator = 'W';
    else if (64 > lat && lat >= 56) LetterDesignator = 'V';
    else if (56 > lat && lat >= 48) LetterDesignator = 'U';
    else if (48 > lat && lat >= 40) LetterDesignator = 'T';
    else if (40 > lat && lat >= 32) LetterDesignator = 'S';
    else if (32 > lat && lat >= 24) LetterDesignator = 'R';
    else if (24 > lat && lat >= 16) LetterDesignator = 'Q';
    else if (16 > lat && lat >= 8) LetterDesignator = 'P';
    else if (8 > lat && lat >= 0) LetterDesignator = 'N';
    else if (0 > lat && lat >= -8) LetterDesignator = 'M';
    else if (-8 > lat && lat >= -16) LetterDesignator = 'L';
    else if (-16 > lat && lat >= -24) LetterDesignator = 'K';
    else if (-24 > lat && lat >= -32) LetterDesignator = 'J';
    else if (-32 > lat && lat >= -40) LetterDesignator = 'H';
    else if (-40 > lat && lat >= -48) LetterDesignator = 'G';
    else if (-48 > lat && lat >= -56) LetterDesignator = 'F';
    else if (-56 > lat && lat >= -64) LetterDesignator = 'E';
    else if (-64 > lat && lat >= -72) LetterDesignator = 'D';
    else if (-72 > lat && lat >= -80) LetterDesignator = 'C';
    return LetterDesignator;
}
/**
 * Encodes a UTM location as MGRS string.
 *
 * @private
 * @param {object} utm An object literal with easting, northing,
 *     zoneLetter, zoneNumber
 * @param {number} accuracy Accuracy in digits (1-5).
 * @return {string} MGRS string for the given UTM location.
 */ function $31ee54b8e1d1cd8f$var$encode(utm, accuracy) {
    // prepend with leading zeroes
    var seasting = "00000" + utm.easting, snorthing = "00000" + utm.northing;
    return utm.zoneNumber + utm.zoneLetter + $31ee54b8e1d1cd8f$var$get100kID(utm.easting, utm.northing, utm.zoneNumber) + seasting.substr(seasting.length - 5, accuracy) + snorthing.substr(snorthing.length - 5, accuracy);
}
/**
 * Get the two letter 100k designator for a given UTM easting,
 * northing and zone number value.
 *
 * @private
 * @param {number} easting
 * @param {number} northing
 * @param {number} zoneNumber
 * @return the two letter 100k designator for the given UTM location.
 */ function $31ee54b8e1d1cd8f$var$get100kID(easting, northing, zoneNumber) {
    var setParm = $31ee54b8e1d1cd8f$var$get100kSetForZone(zoneNumber);
    var setColumn = Math.floor(easting / 100000);
    var setRow = Math.floor(northing / 100000) % 20;
    return $31ee54b8e1d1cd8f$var$getLetter100kID(setColumn, setRow, setParm);
}
/**
 * Given a UTM zone number, figure out the MGRS 100K set it is in.
 *
 * @private
 * @param {number} i An UTM zone number.
 * @return {number} the 100k set the UTM zone is in.
 */ function $31ee54b8e1d1cd8f$var$get100kSetForZone(i) {
    var setParm = i % $31ee54b8e1d1cd8f$var$NUM_100K_SETS;
    if (setParm === 0) setParm = $31ee54b8e1d1cd8f$var$NUM_100K_SETS;
    return setParm;
}
/**
 * Get the two-letter MGRS 100k designator given information
 * translated from the UTM northing, easting and zone number.
 *
 * @private
 * @param {number} column the column index as it relates to the MGRS
 *        100k set spreadsheet, created from the UTM easting.
 *        Values are 1-8.
 * @param {number} row the row index as it relates to the MGRS 100k set
 *        spreadsheet, created from the UTM northing value. Values
 *        are from 0-19.
 * @param {number} parm the set block, as it relates to the MGRS 100k set
 *        spreadsheet, created from the UTM zone. Values are from
 *        1-60.
 * @return two letter MGRS 100k code.
 */ function $31ee54b8e1d1cd8f$var$getLetter100kID(column, row, parm) {
    // colOrigin and rowOrigin are the letters at the origin of the set
    var index = parm - 1;
    var colOrigin = $31ee54b8e1d1cd8f$var$SET_ORIGIN_COLUMN_LETTERS.charCodeAt(index);
    var rowOrigin = $31ee54b8e1d1cd8f$var$SET_ORIGIN_ROW_LETTERS.charCodeAt(index);
    // colInt and rowInt are the letters to build to return
    var colInt = colOrigin + column - 1;
    var rowInt = rowOrigin + row;
    var rollover = false;
    if (colInt > $31ee54b8e1d1cd8f$var$Z) {
        colInt = colInt - $31ee54b8e1d1cd8f$var$Z + $31ee54b8e1d1cd8f$var$A - 1;
        rollover = true;
    }
    if (colInt === $31ee54b8e1d1cd8f$var$I || colOrigin < $31ee54b8e1d1cd8f$var$I && colInt > $31ee54b8e1d1cd8f$var$I || (colInt > $31ee54b8e1d1cd8f$var$I || colOrigin < $31ee54b8e1d1cd8f$var$I) && rollover) colInt++;
    if (colInt === $31ee54b8e1d1cd8f$var$O || colOrigin < $31ee54b8e1d1cd8f$var$O && colInt > $31ee54b8e1d1cd8f$var$O || (colInt > $31ee54b8e1d1cd8f$var$O || colOrigin < $31ee54b8e1d1cd8f$var$O) && rollover) {
        colInt++;
        if (colInt === $31ee54b8e1d1cd8f$var$I) colInt++;
    }
    if (colInt > $31ee54b8e1d1cd8f$var$Z) colInt = colInt - $31ee54b8e1d1cd8f$var$Z + $31ee54b8e1d1cd8f$var$A - 1;
    if (rowInt > $31ee54b8e1d1cd8f$var$V) {
        rowInt = rowInt - $31ee54b8e1d1cd8f$var$V + $31ee54b8e1d1cd8f$var$A - 1;
        rollover = true;
    } else rollover = false;
    if (rowInt === $31ee54b8e1d1cd8f$var$I || rowOrigin < $31ee54b8e1d1cd8f$var$I && rowInt > $31ee54b8e1d1cd8f$var$I || (rowInt > $31ee54b8e1d1cd8f$var$I || rowOrigin < $31ee54b8e1d1cd8f$var$I) && rollover) rowInt++;
    if (rowInt === $31ee54b8e1d1cd8f$var$O || rowOrigin < $31ee54b8e1d1cd8f$var$O && rowInt > $31ee54b8e1d1cd8f$var$O || (rowInt > $31ee54b8e1d1cd8f$var$O || rowOrigin < $31ee54b8e1d1cd8f$var$O) && rollover) {
        rowInt++;
        if (rowInt === $31ee54b8e1d1cd8f$var$I) rowInt++;
    }
    if (rowInt > $31ee54b8e1d1cd8f$var$V) rowInt = rowInt - $31ee54b8e1d1cd8f$var$V + $31ee54b8e1d1cd8f$var$A - 1;
    var twoLetter = String.fromCharCode(colInt) + String.fromCharCode(rowInt);
    return twoLetter;
}
/**
 * Decode the UTM parameters from a MGRS string.
 *
 * @private
 * @param {string} mgrsString an UPPERCASE coordinate string is expected.
 * @return {object} An object literal with easting, northing, zoneLetter,
 *     zoneNumber and accuracy (in meters) properties.
 */ function $31ee54b8e1d1cd8f$var$decode(mgrsString) {
    if (mgrsString && mgrsString.length === 0) throw "MGRSPoint coverting from nothing";
    var length = mgrsString.length;
    var hunK = null;
    var sb = "";
    var testChar;
    var i = 0;
    // get Zone number
    while(!/[A-Z]/.test(testChar = mgrsString.charAt(i))){
        if (i >= 2) throw "MGRSPoint bad conversion from: " + mgrsString;
        sb += testChar;
        i++;
    }
    var zoneNumber = parseInt(sb, 10);
    if (i === 0 || i + 3 > length) // A good MGRS string has to be 4-5 digits long,
    // ##AAA/#AAA at least.
    throw "MGRSPoint bad conversion from: " + mgrsString;
    var zoneLetter = mgrsString.charAt(i++);
    // Should we check the zone letter here? Why not.
    if (zoneLetter <= 'A' || zoneLetter === 'B' || zoneLetter === 'Y' || zoneLetter >= 'Z' || zoneLetter === 'I' || zoneLetter === 'O') throw "MGRSPoint zone letter " + zoneLetter + " not handled: " + mgrsString;
    hunK = mgrsString.substring(i, i += 2);
    var set = $31ee54b8e1d1cd8f$var$get100kSetForZone(zoneNumber);
    var east100k = $31ee54b8e1d1cd8f$var$getEastingFromChar(hunK.charAt(0), set);
    var north100k = $31ee54b8e1d1cd8f$var$getNorthingFromChar(hunK.charAt(1), set);
    // We have a bug where the northing may be 2000000 too low.
    // How
    // do we know when to roll over?
    while(north100k < $31ee54b8e1d1cd8f$var$getMinNorthing(zoneLetter))north100k += 2000000;
    // calculate the char index for easting/northing separator
    var remainder = length - i;
    if (remainder % 2 !== 0) throw "MGRSPoint has to have an even number \nof digits after the zone letter and two 100km letters - front \nhalf for easting meters, second half for \nnorthing meters" + mgrsString;
    var sep = remainder / 2;
    var sepEasting = 0.0;
    var sepNorthing = 0.0;
    var accuracyBonus, sepEastingString, sepNorthingString, easting, northing;
    if (sep > 0) {
        accuracyBonus = 100000.0 / Math.pow(10, sep);
        sepEastingString = mgrsString.substring(i, i + sep);
        sepEasting = parseFloat(sepEastingString) * accuracyBonus;
        sepNorthingString = mgrsString.substring(i + sep);
        sepNorthing = parseFloat(sepNorthingString) * accuracyBonus;
    }
    easting = sepEasting + east100k;
    northing = sepNorthing + north100k;
    return {
        easting: easting,
        northing: northing,
        zoneLetter: zoneLetter,
        zoneNumber: zoneNumber,
        accuracy: accuracyBonus
    };
}
/**
 * Given the first letter from a two-letter MGRS 100k zone, and given the
 * MGRS table set for the zone number, figure out the easting value that
 * should be added to the other, secondary easting value.
 *
 * @private
 * @param {char} e The first letter from a two-letter MGRS 100´k zone.
 * @param {number} set The MGRS table set for the zone number.
 * @return {number} The easting value for the given letter and set.
 */ function $31ee54b8e1d1cd8f$var$getEastingFromChar(e, set) {
    // colOrigin is the letter at the origin of the set for the
    // column
    var curCol = $31ee54b8e1d1cd8f$var$SET_ORIGIN_COLUMN_LETTERS.charCodeAt(set - 1);
    var eastingValue = 100000.0;
    var rewindMarker = false;
    while(curCol !== e.charCodeAt(0)){
        curCol++;
        if (curCol === $31ee54b8e1d1cd8f$var$I) curCol++;
        if (curCol === $31ee54b8e1d1cd8f$var$O) curCol++;
        if (curCol > $31ee54b8e1d1cd8f$var$Z) {
            if (rewindMarker) throw "Bad character: " + e;
            curCol = $31ee54b8e1d1cd8f$var$A;
            rewindMarker = true;
        }
        eastingValue += 100000.0;
    }
    return eastingValue;
}
/**
 * Given the second letter from a two-letter MGRS 100k zone, and given the
 * MGRS table set for the zone number, figure out the northing value that
 * should be added to the other, secondary northing value. You have to
 * remember that Northings are determined from the equator, and the vertical
 * cycle of letters mean a 2000000 additional northing meters. This happens
 * approx. every 18 degrees of latitude. This method does *NOT* count any
 * additional northings. You have to figure out how many 2000000 meters need
 * to be added for the zone letter of the MGRS coordinate.
 *
 * @private
 * @param {char} n Second letter of the MGRS 100k zone
 * @param {number} set The MGRS table set number, which is dependent on the
 *     UTM zone number.
 * @return {number} The northing value for the given letter and set.
 */ function $31ee54b8e1d1cd8f$var$getNorthingFromChar(n, set) {
    if (n > 'V') throw "MGRSPoint given invalid Northing " + n;
    // rowOrigin is the letter at the origin of the set for the
    // column
    var curRow = $31ee54b8e1d1cd8f$var$SET_ORIGIN_ROW_LETTERS.charCodeAt(set - 1);
    var northingValue = 0.0;
    var rewindMarker = false;
    while(curRow !== n.charCodeAt(0)){
        curRow++;
        if (curRow === $31ee54b8e1d1cd8f$var$I) curRow++;
        if (curRow === $31ee54b8e1d1cd8f$var$O) curRow++;
        // fixing a bug making whole application hang in this loop
        // when 'n' is a wrong character
        if (curRow > $31ee54b8e1d1cd8f$var$V) {
            if (rewindMarker) throw "Bad character: " + n;
            curRow = $31ee54b8e1d1cd8f$var$A;
            rewindMarker = true;
        }
        northingValue += 100000.0;
    }
    return northingValue;
}
/**
 * The function getMinNorthing returns the minimum northing value of a MGRS
 * zone.
 *
 * Ported from Geotrans' c Lattitude_Band_Value structure table.
 *
 * @private
 * @param {char} zoneLetter The MGRS zone to get the min northing for.
 * @return {number}
 */ function $31ee54b8e1d1cd8f$var$getMinNorthing(zoneLetter) {
    var northing;
    switch(zoneLetter){
        case 'C':
            northing = 1100000.0;
            break;
        case 'D':
            northing = 2000000.0;
            break;
        case 'E':
            northing = 2800000.0;
            break;
        case 'F':
            northing = 3700000.0;
            break;
        case 'G':
            northing = 4600000.0;
            break;
        case 'H':
            northing = 5500000.0;
            break;
        case 'J':
            northing = 6400000.0;
            break;
        case 'K':
            northing = 7300000.0;
            break;
        case 'L':
            northing = 8200000.0;
            break;
        case 'M':
            northing = 9100000.0;
            break;
        case 'N':
            northing = 0.0;
            break;
        case 'P':
            northing = 800000.0;
            break;
        case 'Q':
            northing = 1700000.0;
            break;
        case 'R':
            northing = 2600000.0;
            break;
        case 'S':
            northing = 3500000.0;
            break;
        case 'T':
            northing = 4400000.0;
            break;
        case 'U':
            northing = 5300000.0;
            break;
        case 'V':
            northing = 6200000.0;
            break;
        case 'W':
            northing = 7000000.0;
            break;
        case 'X':
            northing = 7900000.0;
            break;
        default:
            northing = -1;
    }
    if (northing >= 0.0) return northing;
    else throw "Invalid zone letter: " + zoneLetter;
}

});


parcelRegister("j48cx", function(module, exports) {

$parcel$export(module.exports, "default", () => $de14c0a63cfa0e0d$export$2e2bcd8739ae039);

var $9t3dO = parcelRequire("9t3dO");

var $9zr9G = parcelRequire("9zr9G");

var $kAWkR = parcelRequire("kAWkR");

var $5HQRm = parcelRequire("5HQRm");

var $llHto = parcelRequire("llHto");

var $4gjYM = parcelRequire("4gjYM");

var $ejQ1Z = parcelRequire("ejQ1Z");

var $iubsy = parcelRequire("iubsy");

var $h7o5G = parcelRequire("h7o5G");

var $0599r = parcelRequire("0599r");

var $deudM = parcelRequire("deudM");

var $8mhgZ = parcelRequire("8mhgZ");

var $iSJfu = parcelRequire("iSJfu");

var $6CTAc = parcelRequire("6CTAc");

var $cEGTl = parcelRequire("cEGTl");

var $2Lrqq = parcelRequire("2Lrqq");

var $6Eu1X = parcelRequire("6Eu1X");

var $fpjAW = parcelRequire("fpjAW");

var $eA4Bc = parcelRequire("eA4Bc");

var $7uCfv = parcelRequire("7uCfv");

var $hp0oy = parcelRequire("hp0oy");

var $1W450 = parcelRequire("1W450");

var $i6dz6 = parcelRequire("i6dz6");

var $37G1n = parcelRequire("37G1n");

var $2XUb4 = parcelRequire("2XUb4");

var $byZja = parcelRequire("byZja");

var $Fj8jS = parcelRequire("Fj8jS");

var $eJp9e = parcelRequire("eJp9e");

var $jJ6PL = parcelRequire("jJ6PL");

var $cbANR = parcelRequire("cbANR");

var $gtZfx = parcelRequire("gtZfx");

var $kU0qj = parcelRequire("kU0qj");
function $de14c0a63cfa0e0d$export$2e2bcd8739ae039(proj4) {
    proj4.Proj.projections.add((0, $9t3dO.default));
    proj4.Proj.projections.add((0, $9zr9G.default));
    proj4.Proj.projections.add((0, $kAWkR.default));
    proj4.Proj.projections.add((0, $5HQRm.default));
    proj4.Proj.projections.add((0, $llHto.default));
    proj4.Proj.projections.add((0, $4gjYM.default));
    proj4.Proj.projections.add((0, $ejQ1Z.default));
    proj4.Proj.projections.add((0, $iubsy.default));
    proj4.Proj.projections.add((0, $h7o5G.default));
    proj4.Proj.projections.add((0, $0599r.default));
    proj4.Proj.projections.add((0, $deudM.default));
    proj4.Proj.projections.add((0, $8mhgZ.default));
    proj4.Proj.projections.add((0, $iSJfu.default));
    proj4.Proj.projections.add((0, $6CTAc.default));
    proj4.Proj.projections.add((0, $cEGTl.default));
    proj4.Proj.projections.add((0, $2Lrqq.default));
    proj4.Proj.projections.add((0, $6Eu1X.default));
    proj4.Proj.projections.add((0, $fpjAW.default));
    proj4.Proj.projections.add((0, $eA4Bc.default));
    proj4.Proj.projections.add((0, $7uCfv.default));
    proj4.Proj.projections.add((0, $hp0oy.default));
    proj4.Proj.projections.add((0, $1W450.default));
    proj4.Proj.projections.add((0, $i6dz6.default));
    proj4.Proj.projections.add((0, $37G1n.default));
    proj4.Proj.projections.add((0, $2XUb4.default));
    proj4.Proj.projections.add((0, $byZja.default));
    proj4.Proj.projections.add((0, $Fj8jS.default));
    proj4.Proj.projections.add((0, $eJp9e.default));
    proj4.Proj.projections.add((0, $jJ6PL.default));
    proj4.Proj.projections.add((0, $cbANR.default));
    proj4.Proj.projections.add((0, $gtZfx.default));
    proj4.Proj.projections.add((0, $kU0qj.default));
}

});
parcelRegister("9t3dO", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e495242beb4668f$export$2e2bcd8739ae039);
// Heavily based on this tmerc projection implementation
// https://github.com/mbloch/mapshaper-proj/blob/master/src/projections/tmerc.js

var $gqKpL = parcelRequire("gqKpL");

var $hpUQm = parcelRequire("hpUQm");

var $jQUK6 = parcelRequire("jQUK6");

var $a9oRf = parcelRequire("a9oRf");

var $gyVUi = parcelRequire("gyVUi");

var $boTd3 = parcelRequire("boTd3");
function $6e495242beb4668f$export$2cd8252107eb640b() {
    this.x0 = this.x0 !== undefined ? this.x0 : 0;
    this.y0 = this.y0 !== undefined ? this.y0 : 0;
    this.long0 = this.long0 !== undefined ? this.long0 : 0;
    this.lat0 = this.lat0 !== undefined ? this.lat0 : 0;
    if (this.es) {
        this.en = (0, $gqKpL.default)(this.es);
        this.ml0 = (0, $hpUQm.default)(this.lat0, Math.sin(this.lat0), Math.cos(this.lat0), this.en);
    }
}
function $6e495242beb4668f$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var delta_lon = (0, $a9oRf.default)(lon - this.long0, this.over);
    var con;
    var x, y;
    var sin_phi = Math.sin(lat);
    var cos_phi = Math.cos(lat);
    if (!this.es) {
        var b = cos_phi * Math.sin(delta_lon);
        if (Math.abs(Math.abs(b) - 1) < (0, $gyVUi.EPSLN)) return 93;
        else {
            x = 0.5 * this.a * this.k0 * Math.log((1 + b) / (1 - b)) + this.x0;
            y = cos_phi * Math.cos(delta_lon) / Math.sqrt(1 - Math.pow(b, 2));
            b = Math.abs(y);
            if (b >= 1) {
                if (b - 1 > (0, $gyVUi.EPSLN)) return 93;
                else y = 0;
            } else y = Math.acos(y);
            if (lat < 0) y = -y;
            y = this.a * this.k0 * (y - this.lat0) + this.y0;
        }
    } else {
        var al = cos_phi * delta_lon;
        var als = Math.pow(al, 2);
        var c = this.ep2 * Math.pow(cos_phi, 2);
        var cs = Math.pow(c, 2);
        var tq = Math.abs(cos_phi) > (0, $gyVUi.EPSLN) ? Math.tan(lat) : 0;
        var t = Math.pow(tq, 2);
        var ts = Math.pow(t, 2);
        con = 1 - this.es * Math.pow(sin_phi, 2);
        al = al / Math.sqrt(con);
        var ml = (0, $hpUQm.default)(lat, sin_phi, cos_phi, this.en);
        x = this.a * (this.k0 * al * (1 + als / 6 * (1 - t + c + als / 20 * (5 - 18 * t + ts + 14 * c - 58 * t * c + als / 42 * (61 + 179 * ts - ts * t - 479 * t))))) + this.x0;
        y = this.a * (this.k0 * (ml - this.ml0 + sin_phi * delta_lon * al / 2 * (1 + als / 12 * (5 - t + 9 * c + 4 * cs + als / 30 * (61 + ts - 58 * t + 270 * c - 330 * t * c + als / 56 * (1385 + 543 * ts - ts * t - 3111 * t)))))) + this.y0;
    }
    p.x = x;
    p.y = y;
    return p;
}
function $6e495242beb4668f$export$70ae2c07e401031b(p) {
    var con, phi;
    var lat, lon;
    var x = (p.x - this.x0) * (1 / this.a);
    var y = (p.y - this.y0) * (1 / this.a);
    if (!this.es) {
        var f = Math.exp(x / this.k0);
        var g = 0.5 * (f - 1 / f);
        var temp = this.lat0 + y / this.k0;
        var h = Math.cos(temp);
        con = Math.sqrt((1 - Math.pow(h, 2)) / (1 + Math.pow(g, 2)));
        lat = Math.asin(con);
        if (y < 0) lat = -lat;
        if (g === 0 && h === 0) lon = 0;
        else lon = (0, $a9oRf.default)(Math.atan2(g, h) + this.long0, this.over);
    } else {
        con = this.ml0 + y / this.k0;
        phi = (0, $jQUK6.default)(con, this.es, this.en);
        if (Math.abs(phi) < (0, $gyVUi.HALF_PI)) {
            var sin_phi = Math.sin(phi);
            var cos_phi = Math.cos(phi);
            var tan_phi = Math.abs(cos_phi) > (0, $gyVUi.EPSLN) ? Math.tan(phi) : 0;
            var c = this.ep2 * Math.pow(cos_phi, 2);
            var cs = Math.pow(c, 2);
            var t = Math.pow(tan_phi, 2);
            var ts = Math.pow(t, 2);
            con = 1 - this.es * Math.pow(sin_phi, 2);
            var d = x * Math.sqrt(con) / this.k0;
            var ds = Math.pow(d, 2);
            con = con * tan_phi;
            lat = phi - con * ds / (1 - this.es) * 0.5 * (1 - ds / 12 * (5 + 3 * t - 9 * c * t + c - 4 * cs - ds / 30 * (61 + 90 * t - 252 * c * t + 45 * ts + 46 * c - ds / 56 * (1385 + 3633 * t + 4095 * ts + 1574 * ts * t))));
            lon = (0, $a9oRf.default)(this.long0 + d * (1 - ds / 6 * (1 + 2 * t + c - ds / 20 * (5 + 28 * t + 24 * ts + 8 * c * t + 6 * c - ds / 42 * (61 + 662 * t + 1320 * ts + 720 * ts * t)))) / cos_phi, this.over);
        } else {
            lat = (0, $gyVUi.HALF_PI) * (0, $boTd3.default)(y);
            lon = 0;
        }
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var $6e495242beb4668f$export$e4b2ac9215619f8d = [
    'Fast_Transverse_Mercator',
    'Fast Transverse Mercator'
];
var $6e495242beb4668f$export$2e2bcd8739ae039 = {
    init: $6e495242beb4668f$export$2cd8252107eb640b,
    forward: $6e495242beb4668f$export$174bb771924e7eb1,
    inverse: $6e495242beb4668f$export$70ae2c07e401031b,
    names: $6e495242beb4668f$export$e4b2ac9215619f8d
};

});
parcelRegister("gqKpL", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf6313ff986be9ac$export$2e2bcd8739ae039);
var $bf6313ff986be9ac$var$C00 = 1;
var $bf6313ff986be9ac$var$C02 = 0.25;
var $bf6313ff986be9ac$var$C04 = 0.046875;
var $bf6313ff986be9ac$var$C06 = 0.01953125;
var $bf6313ff986be9ac$var$C08 = 0.01068115234375;
var $bf6313ff986be9ac$var$C22 = 0.75;
var $bf6313ff986be9ac$var$C44 = 0.46875;
var $bf6313ff986be9ac$var$C46 = 0.01302083333333333333;
var $bf6313ff986be9ac$var$C48 = 0.00712076822916666666;
var $bf6313ff986be9ac$var$C66 = 0.36458333333333333333;
var $bf6313ff986be9ac$var$C68 = 0.00569661458333333333;
var $bf6313ff986be9ac$var$C88 = 0.3076171875;
function $bf6313ff986be9ac$export$2e2bcd8739ae039(es) {
    var en = [];
    en[0] = $bf6313ff986be9ac$var$C00 - es * ($bf6313ff986be9ac$var$C02 + es * ($bf6313ff986be9ac$var$C04 + es * ($bf6313ff986be9ac$var$C06 + es * $bf6313ff986be9ac$var$C08)));
    en[1] = es * ($bf6313ff986be9ac$var$C22 - es * ($bf6313ff986be9ac$var$C04 + es * ($bf6313ff986be9ac$var$C06 + es * $bf6313ff986be9ac$var$C08)));
    var t = es * es;
    en[2] = t * ($bf6313ff986be9ac$var$C44 - es * ($bf6313ff986be9ac$var$C46 + es * $bf6313ff986be9ac$var$C48));
    t *= es;
    en[3] = t * ($bf6313ff986be9ac$var$C66 - es * $bf6313ff986be9ac$var$C68);
    en[4] = t * es * $bf6313ff986be9ac$var$C88;
    return en;
}

});

parcelRegister("hpUQm", function(module, exports) {

$parcel$export(module.exports, "default", () => $cae0dd692f473684$export$2e2bcd8739ae039);
function $cae0dd692f473684$export$2e2bcd8739ae039(phi, sphi, cphi, en) {
    cphi *= sphi;
    sphi *= sphi;
    return en[0] * phi - cphi * (en[1] + sphi * (en[2] + sphi * (en[3] + sphi * en[4])));
}

});

parcelRegister("jQUK6", function(module, exports) {

$parcel$export(module.exports, "default", () => $e73ee39023f9c198$export$2e2bcd8739ae039);

var $hpUQm = parcelRequire("hpUQm");

var $gyVUi = parcelRequire("gyVUi");
var $e73ee39023f9c198$var$MAX_ITER = 20;
function $e73ee39023f9c198$export$2e2bcd8739ae039(arg, es, en) {
    var k = 1 / (1 - es);
    var phi = arg;
    for(var i = $e73ee39023f9c198$var$MAX_ITER; i; --i){
        var s = Math.sin(phi);
        var t = 1 - es * s * s;
        // t = this.pj_mlfn(phi, s, Math.cos(phi), en) - arg;
        // phi -= t * (t * Math.sqrt(t)) * k;
        t = ((0, $hpUQm.default)(phi, s, Math.cos(phi), en) - arg) * (t * Math.sqrt(t)) * k;
        phi -= t;
        if (Math.abs(t) < (0, $gyVUi.EPSLN)) return phi;
    }
    // ..reportError("cass:pj_inv_mlfn: Convergence error");
    return phi;
}

});


parcelRegister("9zr9G", function(module, exports) {

$parcel$export(module.exports, "init", () => init);
$parcel$export(module.exports, "forward", () => forward);
$parcel$export(module.exports, "inverse", () => inverse);
$parcel$export(module.exports, "names", () => names);
$parcel$export(module.exports, "default", () => $6f7c72613b8aa92a$export$2e2bcd8739ae039);
// Heavily based on this etmerc projection implementation
// https://github.com/mbloch/mapshaper-proj/blob/master/src/projections/etmerc.js

var $9t3dO = parcelRequire("9t3dO");

var $zBlxr = parcelRequire("zBlxr");

var $jU5gu = parcelRequire("jU5gu");

var $cVtoA = parcelRequire("cVtoA");

var $klaWo = parcelRequire("klaWo");

var $k0stT = parcelRequire("k0stT");

var $iKZ74 = parcelRequire("iKZ74");

var $a9oRf = parcelRequire("a9oRf");
function init() {
    if (!this.approx && (isNaN(this.es) || this.es <= 0)) throw new Error('Incorrect elliptical usage. Try using the +approx option in the proj string, or PROJECTION["Fast_Transverse_Mercator"] in the WKT.');
    if (this.approx) {
        // When '+approx' is set, use tmerc instead
        (0, $9t3dO.default).init.apply(this);
        this.forward = (0, $9t3dO.default).forward;
        this.inverse = (0, $9t3dO.default).inverse;
    }
    this.x0 = this.x0 !== undefined ? this.x0 : 0;
    this.y0 = this.y0 !== undefined ? this.y0 : 0;
    this.long0 = this.long0 !== undefined ? this.long0 : 0;
    this.lat0 = this.lat0 !== undefined ? this.lat0 : 0;
    this.cgb = [];
    this.cbg = [];
    this.utg = [];
    this.gtu = [];
    var f = this.es / (1 + Math.sqrt(1 - this.es));
    var n = f / (2 - f);
    var np = n;
    this.cgb[0] = n * (2 + n * (-2 / 3 + n * (-2 + n * (116 / 45 + n * (26 / 45 + n * (-2854 / 675))))));
    this.cbg[0] = n * (-2 + n * (2 / 3 + n * (4 / 3 + n * (-82 / 45 + n * (32 / 45 + n * (4642 / 4725))))));
    np = np * n;
    this.cgb[1] = np * (7 / 3 + n * (-1.6 + n * (-227 / 45 + n * (2704 / 315 + n * (2323 / 945)))));
    this.cbg[1] = np * (5 / 3 + n * (-16 / 15 + n * (-13 / 9 + n * (904 / 315 + n * (-1522 / 945)))));
    np = np * n;
    this.cgb[2] = np * (56 / 15 + n * (-136 / 35 + n * (-1262 / 105 + n * (73814 / 2835))));
    this.cbg[2] = np * (-26 / 15 + n * (34 / 21 + n * (1.6 + n * (-12686 / 2835))));
    np = np * n;
    this.cgb[3] = np * (4279 / 630 + n * (-332 / 35 + n * (-399572 / 14175)));
    this.cbg[3] = np * (1237 / 630 + n * (-2.4 + n * (-24832 / 14175)));
    np = np * n;
    this.cgb[4] = np * (4174 / 315 + n * (-144838 / 6237));
    this.cbg[4] = np * (-734 / 315 + n * (109598 / 31185));
    np = np * n;
    this.cgb[5] = np * (601676 / 22275);
    this.cbg[5] = np * (444337 / 155925);
    np = Math.pow(n, 2);
    this.Qn = this.k0 / (1 + n) * (1 + np * (1 / 4 + np * (1 / 64 + np / 256)));
    this.utg[0] = n * (-0.5 + n * (2 / 3 + n * (-37 / 96 + n * (1 / 360 + n * (81 / 512 + n * (-96199 / 604800))))));
    this.gtu[0] = n * (0.5 + n * (-2 / 3 + n * (5 / 16 + n * (41 / 180 + n * (-127 / 288 + n * (7891 / 37800))))));
    this.utg[1] = np * (-1 / 48 + n * (-1 / 15 + n * (437 / 1440 + n * (-46 / 105 + n * (1118711 / 3870720)))));
    this.gtu[1] = np * (13 / 48 + n * (-0.6 + n * (557 / 1440 + n * (281 / 630 + n * (-1983433 / 1935360)))));
    np = np * n;
    this.utg[2] = np * (-17 / 480 + n * (37 / 840 + n * (209 / 4480 + n * (-5569 / 90720))));
    this.gtu[2] = np * (61 / 240 + n * (-103 / 140 + n * (15061 / 26880 + n * (167603 / 181440))));
    np = np * n;
    this.utg[3] = np * (-4397 / 161280 + n * (11 / 504 + n * (830251 / 7257600)));
    this.gtu[3] = np * (49561 / 161280 + n * (-179 / 168 + n * (6601661 / 7257600)));
    np = np * n;
    this.utg[4] = np * (-4583 / 161280 + n * (108847 / 3991680));
    this.gtu[4] = np * (34729 / 80640 + n * (-3418889 / 1995840));
    np = np * n;
    this.utg[5] = np * (-20648693 / 638668800);
    this.gtu[5] = np * 0.6650675310896665;
    var Z = (0, $klaWo.default)(this.cbg, this.lat0);
    this.Zb = -this.Qn * (Z + (0, $k0stT.default)(this.gtu, 2 * Z));
}
function forward(p) {
    var Ce = (0, $a9oRf.default)(p.x - this.long0, this.over);
    var Cn = p.y;
    Cn = (0, $klaWo.default)(this.cbg, Cn);
    var sin_Cn = Math.sin(Cn);
    var cos_Cn = Math.cos(Cn);
    var sin_Ce = Math.sin(Ce);
    var cos_Ce = Math.cos(Ce);
    Cn = Math.atan2(sin_Cn, cos_Ce * cos_Cn);
    Ce = Math.atan2(sin_Ce * cos_Cn, (0, $jU5gu.default)(sin_Cn, cos_Cn * cos_Ce));
    Ce = (0, $cVtoA.default)(Math.tan(Ce));
    var tmp = (0, $iKZ74.default)(this.gtu, 2 * Cn, 2 * Ce);
    Cn = Cn + tmp[0];
    Ce = Ce + tmp[1];
    var x;
    var y;
    if (Math.abs(Ce) <= 2.623395162778) {
        x = this.a * (this.Qn * Ce) + this.x0;
        y = this.a * (this.Qn * Cn + this.Zb) + this.y0;
    } else {
        x = Infinity;
        y = Infinity;
    }
    p.x = x;
    p.y = y;
    return p;
}
function inverse(p) {
    var Ce = (p.x - this.x0) * (1 / this.a);
    var Cn = (p.y - this.y0) * (1 / this.a);
    Cn = (Cn - this.Zb) / this.Qn;
    Ce = Ce / this.Qn;
    var lon;
    var lat;
    if (Math.abs(Ce) <= 2.623395162778) {
        var tmp = (0, $iKZ74.default)(this.utg, 2 * Cn, 2 * Ce);
        Cn = Cn + tmp[0];
        Ce = Ce + tmp[1];
        Ce = Math.atan((0, $zBlxr.default)(Ce));
        var sin_Cn = Math.sin(Cn);
        var cos_Cn = Math.cos(Cn);
        var sin_Ce = Math.sin(Ce);
        var cos_Ce = Math.cos(Ce);
        Cn = Math.atan2(sin_Cn * cos_Ce, (0, $jU5gu.default)(sin_Ce, cos_Ce * cos_Cn));
        Ce = Math.atan2(sin_Ce, cos_Ce * cos_Cn);
        lon = (0, $a9oRf.default)(Ce + this.long0, this.over);
        lat = (0, $klaWo.default)(this.cgb, Cn);
    } else {
        lon = Infinity;
        lat = Infinity;
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var names = [
    'Extended_Transverse_Mercator',
    'Extended Transverse Mercator',
    'etmerc',
    'Transverse_Mercator',
    'Transverse Mercator',
    'Gauss Kruger',
    'Gauss_Kruger',
    'tmerc'
];
var $6f7c72613b8aa92a$export$2e2bcd8739ae039 = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names
};

});
parcelRegister("zBlxr", function(module, exports) {

$parcel$export(module.exports, "default", () => $06b03d370063c40e$export$2e2bcd8739ae039);
function $06b03d370063c40e$export$2e2bcd8739ae039(x) {
    var r = Math.exp(x);
    r = (r - 1 / r) / 2;
    return r;
}

});

parcelRegister("jU5gu", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7d754d244264a37$export$2e2bcd8739ae039);
function $e7d754d244264a37$export$2e2bcd8739ae039(x, y) {
    x = Math.abs(x);
    y = Math.abs(y);
    var a = Math.max(x, y);
    var b = Math.min(x, y) / (a ? a : 1);
    return a * Math.sqrt(1 + Math.pow(b, 2));
}

});

parcelRegister("cVtoA", function(module, exports) {

$parcel$export(module.exports, "default", () => $96919c3c2b0cfee9$export$2e2bcd8739ae039);

var $jU5gu = parcelRequire("jU5gu");

var $g1hBf = parcelRequire("g1hBf");
function $96919c3c2b0cfee9$export$2e2bcd8739ae039(x) {
    var y = Math.abs(x);
    y = (0, $g1hBf.default)(y * (1 + y / ((0, $jU5gu.default)(1, y) + 1)));
    return x < 0 ? -y : y;
}

});
parcelRegister("g1hBf", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba9a64430787103e$export$2e2bcd8739ae039);
function $ba9a64430787103e$export$2e2bcd8739ae039(x) {
    var y = 1 + x;
    var z = y - 1;
    return z === 0 ? x : x * Math.log(y) / z;
}

});


parcelRegister("klaWo", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecee41736c9c0e4b$export$2e2bcd8739ae039);
function $ecee41736c9c0e4b$export$2e2bcd8739ae039(pp, B) {
    var cos_2B = 2 * Math.cos(2 * B);
    var i = pp.length - 1;
    var h1 = pp[i];
    var h2 = 0;
    var h;
    while(--i >= 0){
        h = -h2 + cos_2B * h1 + pp[i];
        h2 = h1;
        h1 = h;
    }
    return B + h * Math.sin(2 * B);
}

});

parcelRegister("k0stT", function(module, exports) {

$parcel$export(module.exports, "default", () => $e909e682fc23c405$export$2e2bcd8739ae039);
function $e909e682fc23c405$export$2e2bcd8739ae039(pp, arg_r) {
    var r = 2 * Math.cos(arg_r);
    var i = pp.length - 1;
    var hr1 = pp[i];
    var hr2 = 0;
    var hr;
    while(--i >= 0){
        hr = -hr2 + r * hr1 + pp[i];
        hr2 = hr1;
        hr1 = hr;
    }
    return Math.sin(arg_r) * hr;
}

});

parcelRegister("iKZ74", function(module, exports) {

$parcel$export(module.exports, "default", () => $da7beda932685c15$export$2e2bcd8739ae039);

var $zBlxr = parcelRequire("zBlxr");

var $cz4ED = parcelRequire("cz4ED");
function $da7beda932685c15$export$2e2bcd8739ae039(pp, arg_r, arg_i) {
    var sin_arg_r = Math.sin(arg_r);
    var cos_arg_r = Math.cos(arg_r);
    var sinh_arg_i = (0, $zBlxr.default)(arg_i);
    var cosh_arg_i = (0, $cz4ED.default)(arg_i);
    var r = 2 * cos_arg_r * cosh_arg_i;
    var i = -2 * sin_arg_r * sinh_arg_i;
    var j = pp.length - 1;
    var hr = pp[j];
    var hi1 = 0;
    var hr1 = 0;
    var hi = 0;
    var hr2;
    var hi2;
    while(--j >= 0){
        hr2 = hr1;
        hi2 = hi1;
        hr1 = hr;
        hi1 = hi;
        hr = -hr2 + r * hr1 - i * hi1 + pp[j];
        hi = -hi2 + i * hr1 + r * hi1;
    }
    r = sin_arg_r * cosh_arg_i;
    i = cos_arg_r * sinh_arg_i;
    return [
        r * hr - i * hi,
        r * hi + i * hr
    ];
}

});
parcelRegister("cz4ED", function(module, exports) {

$parcel$export(module.exports, "default", () => $925c5d35b4e59088$export$2e2bcd8739ae039);
function $925c5d35b4e59088$export$2e2bcd8739ae039(x) {
    var r = Math.exp(x);
    r = (r + 1 / r) / 2;
    return r;
}

});



parcelRegister("kAWkR", function(module, exports) {

$parcel$export(module.exports, "default", () => $efe46ba059d82de2$export$2e2bcd8739ae039);

var $b4YJ1 = parcelRequire("b4YJ1");

var $9zr9G = parcelRequire("9zr9G");

var $gyVUi = parcelRequire("gyVUi");
var $efe46ba059d82de2$export$3f91ef0e0d0d8bf8 = 'etmerc';
function $efe46ba059d82de2$export$2cd8252107eb640b() {
    var zone = (0, $b4YJ1.default)(this.zone, this.long0);
    if (zone === undefined) throw new Error('unknown utm zone');
    this.lat0 = 0;
    this.long0 = (6 * Math.abs(zone) - 183) * (0, $gyVUi.D2R);
    this.x0 = 500000;
    this.y0 = this.utmSouth ? 10000000 : 0;
    this.k0 = 0.9996;
    (0, $9zr9G.default).init.apply(this);
    this.forward = (0, $9zr9G.default).forward;
    this.inverse = (0, $9zr9G.default).inverse;
}
var $efe46ba059d82de2$export$e4b2ac9215619f8d = [
    'Universal Transverse Mercator System',
    'utm'
];
var $efe46ba059d82de2$export$2e2bcd8739ae039 = {
    init: $efe46ba059d82de2$export$2cd8252107eb640b,
    names: $efe46ba059d82de2$export$e4b2ac9215619f8d,
    dependsOn: $efe46ba059d82de2$export$3f91ef0e0d0d8bf8
};

});
parcelRegister("b4YJ1", function(module, exports) {

$parcel$export(module.exports, "default", () => $810f2c2910fd20b1$export$2e2bcd8739ae039);

var $a9oRf = parcelRequire("a9oRf");
function $810f2c2910fd20b1$export$2e2bcd8739ae039(zone, lon) {
    if (zone === undefined) {
        zone = Math.floor(((0, $a9oRf.default)(lon) + Math.PI) * 30 / Math.PI) + 1;
        if (zone < 0) return 0;
        else if (zone > 60) return 60;
    }
    return zone;
}

});


parcelRegister("5HQRm", function(module, exports) {

$parcel$export(module.exports, "default", () => $4279f8b9d31284e6$export$2e2bcd8739ae039);

var $zGHAa = parcelRequire("zGHAa");

var $a9oRf = parcelRequire("a9oRf");

var $jU5gu = parcelRequire("jU5gu");
function $4279f8b9d31284e6$export$2cd8252107eb640b() {
    (0, $zGHAa.default).init.apply(this);
    if (!this.rc) return;
    this.sinc0 = Math.sin(this.phic0);
    this.cosc0 = Math.cos(this.phic0);
    this.R2 = 2 * this.rc;
    if (!this.title) this.title = 'Oblique Stereographic Alternative';
}
function $4279f8b9d31284e6$export$174bb771924e7eb1(p) {
    var sinc, cosc, cosl, k;
    p.x = (0, $a9oRf.default)(p.x - this.long0, this.over);
    (0, $zGHAa.default).forward.apply(this, [
        p
    ]);
    sinc = Math.sin(p.y);
    cosc = Math.cos(p.y);
    cosl = Math.cos(p.x);
    k = this.k0 * this.R2 / (1 + this.sinc0 * sinc + this.cosc0 * cosc * cosl);
    p.x = k * cosc * Math.sin(p.x);
    p.y = k * (this.cosc0 * sinc - this.sinc0 * cosc * cosl);
    p.x = this.a * p.x + this.x0;
    p.y = this.a * p.y + this.y0;
    return p;
}
function $4279f8b9d31284e6$export$70ae2c07e401031b(p) {
    var sinc, cosc, lon, lat, rho;
    p.x = (p.x - this.x0) / this.a;
    p.y = (p.y - this.y0) / this.a;
    p.x /= this.k0;
    p.y /= this.k0;
    if (rho = (0, $jU5gu.default)(p.x, p.y)) {
        var c = 2 * Math.atan2(rho, this.R2);
        sinc = Math.sin(c);
        cosc = Math.cos(c);
        lat = Math.asin(cosc * this.sinc0 + p.y * sinc * this.cosc0 / rho);
        lon = Math.atan2(p.x * sinc, rho * this.cosc0 * cosc - p.y * this.sinc0 * sinc);
    } else {
        lat = this.phic0;
        lon = 0;
    }
    p.x = lon;
    p.y = lat;
    (0, $zGHAa.default).inverse.apply(this, [
        p
    ]);
    p.x = (0, $a9oRf.default)(p.x + this.long0, this.over);
    return p;
}
var $4279f8b9d31284e6$export$e4b2ac9215619f8d = [
    'Stereographic_North_Pole',
    'Oblique_Stereographic',
    'sterea',
    'Oblique Stereographic Alternative',
    'Double_Stereographic'
];
var $4279f8b9d31284e6$export$2e2bcd8739ae039 = {
    init: $4279f8b9d31284e6$export$2cd8252107eb640b,
    forward: $4279f8b9d31284e6$export$174bb771924e7eb1,
    inverse: $4279f8b9d31284e6$export$70ae2c07e401031b,
    names: $4279f8b9d31284e6$export$e4b2ac9215619f8d
};

});
parcelRegister("zGHAa", function(module, exports) {

$parcel$export(module.exports, "default", () => $06b464b721451620$export$2e2bcd8739ae039);

var $82Tex = parcelRequire("82Tex");

var $gyVUi = parcelRequire("gyVUi");
var $06b464b721451620$var$MAX_ITER = 20;
function $06b464b721451620$export$2cd8252107eb640b() {
    var sphi = Math.sin(this.lat0);
    var cphi = Math.cos(this.lat0);
    cphi *= cphi;
    this.rc = Math.sqrt(1 - this.es) / (1 - this.es * sphi * sphi);
    this.C = Math.sqrt(1 + this.es * cphi * cphi / (1 - this.es));
    this.phic0 = Math.asin(sphi / this.C);
    this.ratexp = 0.5 * this.C * this.e;
    this.K = Math.tan(0.5 * this.phic0 + (0, $gyVUi.FORTPI)) / (Math.pow(Math.tan(0.5 * this.lat0 + (0, $gyVUi.FORTPI)), this.C) * (0, $82Tex.default)(this.e * sphi, this.ratexp));
}
function $06b464b721451620$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    p.y = 2 * Math.atan(this.K * Math.pow(Math.tan(0.5 * lat + (0, $gyVUi.FORTPI)), this.C) * (0, $82Tex.default)(this.e * Math.sin(lat), this.ratexp)) - (0, $gyVUi.HALF_PI);
    p.x = this.C * lon;
    return p;
}
function $06b464b721451620$export$70ae2c07e401031b(p) {
    var DEL_TOL = 1e-14;
    var lon = p.x / this.C;
    var lat = p.y;
    var num = Math.pow(Math.tan(0.5 * lat + (0, $gyVUi.FORTPI)) / this.K, 1 / this.C);
    for(var i = $06b464b721451620$var$MAX_ITER; i > 0; --i){
        lat = 2 * Math.atan(num * (0, $82Tex.default)(this.e * Math.sin(p.y), -0.5 * this.e)) - (0, $gyVUi.HALF_PI);
        if (Math.abs(lat - p.y) < DEL_TOL) break;
        p.y = lat;
    }
    /* convergence failed */ if (!i) return null;
    p.x = lon;
    p.y = lat;
    return p;
}
var $06b464b721451620$export$e4b2ac9215619f8d = [
    'gauss'
];
var $06b464b721451620$export$2e2bcd8739ae039 = {
    init: $06b464b721451620$export$2cd8252107eb640b,
    forward: $06b464b721451620$export$174bb771924e7eb1,
    inverse: $06b464b721451620$export$70ae2c07e401031b,
    names: $06b464b721451620$export$e4b2ac9215619f8d
};

});
parcelRegister("82Tex", function(module, exports) {

$parcel$export(module.exports, "default", () => $5db95ad4da70d3a6$export$2e2bcd8739ae039);
function $5db95ad4da70d3a6$export$2e2bcd8739ae039(esinp, exp) {
    return Math.pow((1 - esinp) / (1 + esinp), exp);
}

});



parcelRegister("llHto", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8ad4802022ce868$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");

var $boTd3 = parcelRequire("boTd3");

var $bi5ZC = parcelRequire("bi5ZC");

var $3xC66 = parcelRequire("3xC66");

var $2AZR8 = parcelRequire("2AZR8");

var $a9oRf = parcelRequire("a9oRf");
function $f8ad4802022ce868$export$8adc077b4b982c95(phit, sinphi, eccen) {
    sinphi *= eccen;
    return Math.tan(0.5 * ((0, $gyVUi.HALF_PI) + phit)) * Math.pow((1 - sinphi) / (1 + sinphi), 0.5 * eccen);
}
function $f8ad4802022ce868$export$2cd8252107eb640b() {
    // setting default parameters
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    this.lat0 = this.lat0 || 0;
    this.long0 = this.long0 || 0;
    this.coslat0 = Math.cos(this.lat0);
    this.sinlat0 = Math.sin(this.lat0);
    if (this.sphere) {
        if (this.k0 === 1 && !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= (0, $gyVUi.EPSLN)) this.k0 = 0.5 * (1 + (0, $boTd3.default)(this.lat0) * Math.sin(this.lat_ts));
    } else {
        if (Math.abs(this.coslat0) <= (0, $gyVUi.EPSLN)) {
            if (this.lat0 > 0) // North pole
            // trace('stere:north pole');
            this.con = 1;
            else // South pole
            // trace('stere:south pole');
            this.con = -1;
        }
        this.cons = Math.sqrt(Math.pow(1 + this.e, 1 + this.e) * Math.pow(1 - this.e, 1 - this.e));
        if (this.k0 === 1 && !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= (0, $gyVUi.EPSLN) && Math.abs(Math.cos(this.lat_ts)) > (0, $gyVUi.EPSLN)) // When k0 is 1 (default value) and lat_ts is a vaild number and lat0 is at a pole and lat_ts is not at a pole
        // Recalculate k0 using formula 21-35 from p161 of Snyder, 1987
        this.k0 = 0.5 * this.cons * (0, $bi5ZC.default)(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts)) / (0, $3xC66.default)(this.e, this.con * this.lat_ts, this.con * Math.sin(this.lat_ts));
        this.ms1 = (0, $bi5ZC.default)(this.e, this.sinlat0, this.coslat0);
        this.X0 = 2 * Math.atan($f8ad4802022ce868$export$8adc077b4b982c95(this.lat0, this.sinlat0, this.e)) - (0, $gyVUi.HALF_PI);
        this.cosX0 = Math.cos(this.X0);
        this.sinX0 = Math.sin(this.X0);
    }
}
function $f8ad4802022ce868$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var sinlat = Math.sin(lat);
    var coslat = Math.cos(lat);
    var A, X, sinX, cosX, ts, rh;
    var dlon = (0, $a9oRf.default)(lon - this.long0, this.over);
    if (Math.abs(Math.abs(lon - this.long0) - Math.PI) <= (0, $gyVUi.EPSLN) && Math.abs(lat + this.lat0) <= (0, $gyVUi.EPSLN)) {
        // case of the origine point
        // trace('stere:this is the origin point');
        p.x = NaN;
        p.y = NaN;
        return p;
    }
    if (this.sphere) {
        // trace('stere:sphere case');
        A = 2 * this.k0 / (1 + this.sinlat0 * sinlat + this.coslat0 * coslat * Math.cos(dlon));
        p.x = this.a * A * coslat * Math.sin(dlon) + this.x0;
        p.y = this.a * A * (this.coslat0 * sinlat - this.sinlat0 * coslat * Math.cos(dlon)) + this.y0;
        return p;
    } else {
        X = 2 * Math.atan($f8ad4802022ce868$export$8adc077b4b982c95(lat, sinlat, this.e)) - (0, $gyVUi.HALF_PI);
        cosX = Math.cos(X);
        sinX = Math.sin(X);
        if (Math.abs(this.coslat0) <= (0, $gyVUi.EPSLN)) {
            ts = (0, $3xC66.default)(this.e, lat * this.con, this.con * sinlat);
            rh = 2 * this.a * this.k0 * ts / this.cons;
            p.x = this.x0 + rh * Math.sin(lon - this.long0);
            p.y = this.y0 - this.con * rh * Math.cos(lon - this.long0);
            // trace(p.toString());
            return p;
        } else if (Math.abs(this.sinlat0) < (0, $gyVUi.EPSLN)) {
            // Eq
            // trace('stere:equateur');
            A = 2 * this.a * this.k0 / (1 + cosX * Math.cos(dlon));
            p.y = A * sinX;
        } else {
            // other case
            // trace('stere:normal case');
            A = 2 * this.a * this.k0 * this.ms1 / (this.cosX0 * (1 + this.sinX0 * sinX + this.cosX0 * cosX * Math.cos(dlon)));
            p.y = A * (this.cosX0 * sinX - this.sinX0 * cosX * Math.cos(dlon)) + this.y0;
        }
        p.x = A * cosX * Math.sin(dlon) + this.x0;
    }
    // trace(p.toString());
    return p;
}
function $f8ad4802022ce868$export$70ae2c07e401031b(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var lon, lat, ts, ce, Chi;
    var rh = Math.sqrt(p.x * p.x + p.y * p.y);
    if (this.sphere) {
        var c = 2 * Math.atan(rh / (2 * this.a * this.k0));
        lon = this.long0;
        lat = this.lat0;
        if (rh <= (0, $gyVUi.EPSLN)) {
            p.x = lon;
            p.y = lat;
            return p;
        }
        lat = Math.asin(Math.cos(c) * this.sinlat0 + p.y * Math.sin(c) * this.coslat0 / rh);
        if (Math.abs(this.coslat0) < (0, $gyVUi.EPSLN)) {
            if (this.lat0 > 0) lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x, -1 * p.y), this.over);
            else lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x, p.y), this.over);
        } else lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x * Math.sin(c), rh * this.coslat0 * Math.cos(c) - p.y * this.sinlat0 * Math.sin(c)), this.over);
        p.x = lon;
        p.y = lat;
        return p;
    } else if (Math.abs(this.coslat0) <= (0, $gyVUi.EPSLN)) {
        if (rh <= (0, $gyVUi.EPSLN)) {
            lat = this.lat0;
            lon = this.long0;
            p.x = lon;
            p.y = lat;
            // trace(p.toString());
            return p;
        }
        p.x *= this.con;
        p.y *= this.con;
        ts = rh * this.cons / (2 * this.a * this.k0);
        lat = this.con * (0, $2AZR8.default)(this.e, ts);
        lon = this.con * (0, $a9oRf.default)(this.con * this.long0 + Math.atan2(p.x, -1 * p.y), this.over);
    } else {
        ce = 2 * Math.atan(rh * this.cosX0 / (2 * this.a * this.k0 * this.ms1));
        lon = this.long0;
        if (rh <= (0, $gyVUi.EPSLN)) Chi = this.X0;
        else {
            Chi = Math.asin(Math.cos(ce) * this.sinX0 + p.y * Math.sin(ce) * this.cosX0 / rh);
            lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x * Math.sin(ce), rh * this.cosX0 * Math.cos(ce) - p.y * this.sinX0 * Math.sin(ce)), this.over);
        }
        lat = -1 * (0, $2AZR8.default)(this.e, Math.tan(0.5 * ((0, $gyVUi.HALF_PI) + Chi)));
    }
    p.x = lon;
    p.y = lat;
    // trace(p.toString());
    return p;
}
var $f8ad4802022ce868$export$e4b2ac9215619f8d = [
    'stere',
    'Stereographic_South_Pole',
    'Polar_Stereographic_variant_A',
    'Polar_Stereographic_variant_B',
    'Polar_Stereographic'
];
var $f8ad4802022ce868$export$2e2bcd8739ae039 = {
    init: $f8ad4802022ce868$export$2cd8252107eb640b,
    forward: $f8ad4802022ce868$export$174bb771924e7eb1,
    inverse: $f8ad4802022ce868$export$70ae2c07e401031b,
    names: $f8ad4802022ce868$export$e4b2ac9215619f8d,
    ssfn_: $f8ad4802022ce868$export$8adc077b4b982c95
};

});

parcelRegister("4gjYM", function(module, exports) {

$parcel$export(module.exports, "default", () => $31a8278a941356d4$export$2e2bcd8739ae039);
/*
  references:
    Formules et constantes pour le Calcul pour la
    projection cylindrique conforme à axe oblique et pour la transformation entre
    des systèmes de référence.
    http://www.swisstopo.admin.ch/internet/swisstopo/fr/home/topics/survey/sys/refsys/switzerland.parsysrelated1.31216.downloadList.77004.DownloadFile.tmp/swissprojectionfr.pdf
  */ /**
 * @typedef {Object} LocalThis
 * @property {number} lambda0
 * @property {number} e
 * @property {number} R
 * @property {number} b0
 * @property {number} K
 */ /** @this {import('../defs.js').ProjectionDefinition & LocalThis} */ function $31a8278a941356d4$export$2cd8252107eb640b() {
    var phy0 = this.lat0;
    this.lambda0 = this.long0;
    var sinPhy0 = Math.sin(phy0);
    var semiMajorAxis = this.a;
    var invF = this.rf;
    var flattening = 1 / invF;
    var e2 = 2 * flattening - Math.pow(flattening, 2);
    var e = this.e = Math.sqrt(e2);
    this.R = this.k0 * semiMajorAxis * Math.sqrt(1 - e2) / (1 - e2 * Math.pow(sinPhy0, 2));
    this.alpha = Math.sqrt(1 + e2 / (1 - e2) * Math.pow(Math.cos(phy0), 4));
    this.b0 = Math.asin(sinPhy0 / this.alpha);
    var k1 = Math.log(Math.tan(Math.PI / 4 + this.b0 / 2));
    var k2 = Math.log(Math.tan(Math.PI / 4 + phy0 / 2));
    var k3 = Math.log((1 + e * sinPhy0) / (1 - e * sinPhy0));
    this.K = k1 - this.alpha * k2 + this.alpha * e / 2 * k3;
}
function $31a8278a941356d4$export$174bb771924e7eb1(p) {
    var Sa1 = Math.log(Math.tan(Math.PI / 4 - p.y / 2));
    var Sa2 = this.e / 2 * Math.log((1 + this.e * Math.sin(p.y)) / (1 - this.e * Math.sin(p.y)));
    var S = -this.alpha * (Sa1 + Sa2) + this.K;
    // spheric latitude
    var b = 2 * (Math.atan(Math.exp(S)) - Math.PI / 4);
    // spheric longitude
    var I = this.alpha * (p.x - this.lambda0);
    // psoeudo equatorial rotation
    var rotI = Math.atan(Math.sin(I) / (Math.sin(this.b0) * Math.tan(b) + Math.cos(this.b0) * Math.cos(I)));
    var rotB = Math.asin(Math.cos(this.b0) * Math.sin(b) - Math.sin(this.b0) * Math.cos(b) * Math.cos(I));
    p.y = this.R / 2 * Math.log((1 + Math.sin(rotB)) / (1 - Math.sin(rotB))) + this.y0;
    p.x = this.R * rotI + this.x0;
    return p;
}
function $31a8278a941356d4$export$70ae2c07e401031b(p) {
    var Y = p.x - this.x0;
    var X = p.y - this.y0;
    var rotI = Y / this.R;
    var rotB = 2 * (Math.atan(Math.exp(X / this.R)) - Math.PI / 4);
    var b = Math.asin(Math.cos(this.b0) * Math.sin(rotB) + Math.sin(this.b0) * Math.cos(rotB) * Math.cos(rotI));
    var I = Math.atan(Math.sin(rotI) / (Math.cos(this.b0) * Math.cos(rotI) - Math.sin(this.b0) * Math.tan(rotB)));
    var lambda = this.lambda0 + I / this.alpha;
    var S = 0;
    var phy = b;
    var prevPhy = -1000;
    var iteration = 0;
    while(Math.abs(phy - prevPhy) > 0.0000001){
        if (++iteration > 20) // ...reportError("omercFwdInfinity");
        return;
        // S = Math.log(Math.tan(Math.PI / 4 + phy / 2));
        S = 1 / this.alpha * (Math.log(Math.tan(Math.PI / 4 + b / 2)) - this.K) + this.e * Math.log(Math.tan(Math.PI / 4 + Math.asin(this.e * Math.sin(phy)) / 2));
        prevPhy = phy;
        phy = 2 * Math.atan(Math.exp(S)) - Math.PI / 2;
    }
    p.x = lambda;
    p.y = phy;
    return p;
}
var $31a8278a941356d4$export$e4b2ac9215619f8d = [
    'somerc'
];
var $31a8278a941356d4$export$2e2bcd8739ae039 = {
    init: $31a8278a941356d4$export$2cd8252107eb640b,
    forward: $31a8278a941356d4$export$174bb771924e7eb1,
    inverse: $31a8278a941356d4$export$70ae2c07e401031b,
    names: $31a8278a941356d4$export$e4b2ac9215619f8d
};

});

parcelRegister("ejQ1Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6cb33582cb5910b$export$2e2bcd8739ae039);

var $3xC66 = parcelRequire("3xC66");

var $a9oRf = parcelRequire("a9oRf");

var $2AZR8 = parcelRequire("2AZR8");

var $gyVUi = parcelRequire("gyVUi");

var $1Wo5P = parcelRequire("1Wo5P");
/**
 * @typedef {Object} LocalThis
 * @property {boolean} no_off
 * @property {boolean} no_rot
 * @property {number} rectified_grid_angle
 * @property {number} es
 * @property {number} A
 * @property {number} B
 * @property {number} E
 * @property {number} e
 * @property {number} lam0
 * @property {number} singam
 * @property {number} cosgam
 * @property {number} sinrot
 * @property {number} cosrot
 * @property {number} rB
 * @property {number} ArB
 * @property {number} BrA
 * @property {number} u_0
 * @property {number} v_pole_n
 * @property {number} v_pole_s
 */ var $a6cb33582cb5910b$var$TOL = 1e-7;
function $a6cb33582cb5910b$var$isTypeA(P) {
    var typeAProjections = [
        'Hotine_Oblique_Mercator',
        'Hotine_Oblique_Mercator_variant_A',
        'Hotine_Oblique_Mercator_Azimuth_Natural_Origin'
    ];
    var projectionName = typeof P.projName === 'object' ? Object.keys(P.projName)[0] : P.projName;
    return 'no_uoff' in P || 'no_off' in P || typeAProjections.indexOf(projectionName) !== -1 || typeAProjections.indexOf((0, $1Wo5P.getNormalizedProjName)(projectionName)) !== -1;
}
function $a6cb33582cb5910b$export$2cd8252107eb640b() {
    var con, com, cosph0, D, F, H, L, sinph0, p, J, gamma = 0, gamma0, lamc = 0, lam1 = 0, lam2 = 0, phi1 = 0, phi2 = 0, alpha_c = 0;
    // only Type A uses the no_off or no_uoff property
    // https://github.com/OSGeo/proj.4/issues/104
    this.no_off = $a6cb33582cb5910b$var$isTypeA(this);
    this.no_rot = 'no_rot' in this;
    var alp = false;
    if ('alpha' in this) alp = true;
    var gam = false;
    if ('rectified_grid_angle' in this) gam = true;
    if (alp) alpha_c = this.alpha;
    if (gam) gamma = this.rectified_grid_angle;
    if (alp || gam) lamc = this.longc;
    else {
        lam1 = this.long1;
        phi1 = this.lat1;
        lam2 = this.long2;
        phi2 = this.lat2;
        if (Math.abs(phi1 - phi2) <= $a6cb33582cb5910b$var$TOL || (con = Math.abs(phi1)) <= $a6cb33582cb5910b$var$TOL || Math.abs(con - (0, $gyVUi.HALF_PI)) <= $a6cb33582cb5910b$var$TOL || Math.abs(Math.abs(this.lat0) - (0, $gyVUi.HALF_PI)) <= $a6cb33582cb5910b$var$TOL || Math.abs(Math.abs(phi2) - (0, $gyVUi.HALF_PI)) <= $a6cb33582cb5910b$var$TOL) throw new Error();
    }
    var one_es = 1.0 - this.es;
    com = Math.sqrt(one_es);
    if (Math.abs(this.lat0) > (0, $gyVUi.EPSLN)) {
        sinph0 = Math.sin(this.lat0);
        cosph0 = Math.cos(this.lat0);
        con = 1 - this.es * sinph0 * sinph0;
        this.B = cosph0 * cosph0;
        this.B = Math.sqrt(1 + this.es * this.B * this.B / one_es);
        this.A = this.B * this.k0 * com / con;
        D = this.B * com / (cosph0 * Math.sqrt(con));
        F = D * D - 1;
        if (F <= 0) F = 0;
        else {
            F = Math.sqrt(F);
            if (this.lat0 < 0) F = -F;
        }
        this.E = F += D;
        this.E *= Math.pow((0, $3xC66.default)(this.e, this.lat0, sinph0), this.B);
    } else {
        this.B = 1 / com;
        this.A = this.k0;
        this.E = D = F = 1;
    }
    if (alp || gam) {
        if (alp) {
            gamma0 = Math.asin(Math.sin(alpha_c) / D);
            if (!gam) gamma = alpha_c;
        } else {
            gamma0 = gamma;
            alpha_c = Math.asin(D * Math.sin(gamma0));
        }
        this.lam0 = lamc - Math.asin(0.5 * (F - 1 / F) * Math.tan(gamma0)) / this.B;
    } else {
        H = Math.pow((0, $3xC66.default)(this.e, phi1, Math.sin(phi1)), this.B);
        L = Math.pow((0, $3xC66.default)(this.e, phi2, Math.sin(phi2)), this.B);
        F = this.E / H;
        p = (L - H) / (L + H);
        J = this.E * this.E;
        J = (J - L * H) / (J + L * H);
        con = lam1 - lam2;
        if (con < -Math.PI) lam2 -= (0, $gyVUi.TWO_PI);
        else if (con > Math.PI) lam2 += (0, $gyVUi.TWO_PI);
        this.lam0 = (0, $a9oRf.default)(0.5 * (lam1 + lam2) - Math.atan(J * Math.tan(0.5 * this.B * (lam1 - lam2)) / p) / this.B, this.over);
        gamma0 = Math.atan(2 * Math.sin(this.B * (0, $a9oRf.default)(lam1 - this.lam0, this.over)) / (F - 1 / F));
        gamma = alpha_c = Math.asin(D * Math.sin(gamma0));
    }
    this.singam = Math.sin(gamma0);
    this.cosgam = Math.cos(gamma0);
    this.sinrot = Math.sin(gamma);
    this.cosrot = Math.cos(gamma);
    this.rB = 1 / this.B;
    this.ArB = this.A * this.rB;
    this.BrA = 1 / this.ArB;
    if (this.no_off) this.u_0 = 0;
    else {
        this.u_0 = Math.abs(this.ArB * Math.atan(Math.sqrt(D * D - 1) / Math.cos(alpha_c)));
        if (this.lat0 < 0) this.u_0 = -this.u_0;
    }
    F = 0.5 * gamma0;
    this.v_pole_n = this.ArB * Math.log(Math.tan((0, $gyVUi.FORTPI) - F));
    this.v_pole_s = this.ArB * Math.log(Math.tan((0, $gyVUi.FORTPI) + F));
}
function $a6cb33582cb5910b$export$174bb771924e7eb1(p) {
    var coords = {};
    var S, T, U, V, W, temp, u, v;
    p.x = p.x - this.lam0;
    if (Math.abs(Math.abs(p.y) - (0, $gyVUi.HALF_PI)) > (0, $gyVUi.EPSLN)) {
        W = this.E / Math.pow((0, $3xC66.default)(this.e, p.y, Math.sin(p.y)), this.B);
        temp = 1 / W;
        S = 0.5 * (W - temp);
        T = 0.5 * (W + temp);
        V = Math.sin(this.B * p.x);
        U = (S * this.singam - V * this.cosgam) / T;
        if (Math.abs(Math.abs(U) - 1.0) < (0, $gyVUi.EPSLN)) throw new Error();
        v = 0.5 * this.ArB * Math.log((1 - U) / (1 + U));
        temp = Math.cos(this.B * p.x);
        if (Math.abs(temp) < $a6cb33582cb5910b$var$TOL) u = this.A * p.x;
        else u = this.ArB * Math.atan2(S * this.cosgam + V * this.singam, temp);
    } else {
        v = p.y > 0 ? this.v_pole_n : this.v_pole_s;
        u = this.ArB * p.y;
    }
    if (this.no_rot) {
        coords.x = u;
        coords.y = v;
    } else {
        u -= this.u_0;
        coords.x = v * this.cosrot + u * this.sinrot;
        coords.y = u * this.cosrot - v * this.sinrot;
    }
    coords.x = this.a * coords.x + this.x0;
    coords.y = this.a * coords.y + this.y0;
    return coords;
}
function $a6cb33582cb5910b$export$70ae2c07e401031b(p) {
    var u, v, Qp, Sp, Tp, Vp, Up;
    var coords = {};
    p.x = (p.x - this.x0) * (1.0 / this.a);
    p.y = (p.y - this.y0) * (1.0 / this.a);
    if (this.no_rot) {
        v = p.y;
        u = p.x;
    } else {
        v = p.x * this.cosrot - p.y * this.sinrot;
        u = p.y * this.cosrot + p.x * this.sinrot + this.u_0;
    }
    Qp = Math.exp(-this.BrA * v);
    Sp = 0.5 * (Qp - 1 / Qp);
    Tp = 0.5 * (Qp + 1 / Qp);
    Vp = Math.sin(this.BrA * u);
    Up = (Vp * this.cosgam + Sp * this.singam) / Tp;
    if (Math.abs(Math.abs(Up) - 1) < (0, $gyVUi.EPSLN)) {
        coords.x = 0;
        coords.y = Up < 0 ? -(0, $gyVUi.HALF_PI) : (0, $gyVUi.HALF_PI);
    } else {
        coords.y = this.E / Math.sqrt((1 + Up) / (1 - Up));
        coords.y = (0, $2AZR8.default)(this.e, Math.pow(coords.y, 1 / this.B));
        if (coords.y === Infinity) throw new Error();
        coords.x = -this.rB * Math.atan2(Sp * this.cosgam - Vp * this.singam, Math.cos(this.BrA * u));
    }
    coords.x += this.lam0;
    return coords;
}
var $a6cb33582cb5910b$export$e4b2ac9215619f8d = [
    'Hotine_Oblique_Mercator',
    'Hotine Oblique Mercator',
    'Hotine_Oblique_Mercator_variant_A',
    'Hotine_Oblique_Mercator_Variant_B',
    'Hotine_Oblique_Mercator_Azimuth_Natural_Origin',
    'Hotine_Oblique_Mercator_Two_Point_Natural_Origin',
    'Hotine_Oblique_Mercator_Azimuth_Center',
    'Oblique_Mercator',
    'omerc'
];
var $a6cb33582cb5910b$export$2e2bcd8739ae039 = {
    init: $a6cb33582cb5910b$export$2cd8252107eb640b,
    forward: $a6cb33582cb5910b$export$174bb771924e7eb1,
    inverse: $a6cb33582cb5910b$export$70ae2c07e401031b,
    names: $a6cb33582cb5910b$export$e4b2ac9215619f8d
};

});

parcelRegister("iubsy", function(module, exports) {

$parcel$export(module.exports, "default", () => $d753eaf12887a276$export$2e2bcd8739ae039);

var $bi5ZC = parcelRequire("bi5ZC");

var $3xC66 = parcelRequire("3xC66");

var $boTd3 = parcelRequire("boTd3");

var $a9oRf = parcelRequire("a9oRf");

var $2AZR8 = parcelRequire("2AZR8");

var $gyVUi = parcelRequire("gyVUi");
function $d753eaf12887a276$export$2cd8252107eb640b() {
    // double lat0;                    /* the reference latitude               */
    // double long0;                   /* the reference longitude              */
    // double lat1;                    /* first standard parallel              */
    // double lat2;                    /* second standard parallel             */
    // double r_maj;                   /* major axis                           */
    // double r_min;                   /* minor axis                           */
    // double false_east;              /* x offset in meters                   */
    // double false_north;             /* y offset in meters                   */
    // the above value can be set with proj4.defs
    // example: proj4.defs("EPSG:2154","+proj=lcc +lat_1=49 +lat_2=44 +lat_0=46.5 +lon_0=3 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs");
    if (!this.lat2) this.lat2 = this.lat1;
     // if lat2 is not defined
    if (!this.k0) this.k0 = 1;
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    // Standard Parallels cannot be equal and on opposite sides of the equator
    if (Math.abs(this.lat1 + this.lat2) < (0, $gyVUi.EPSLN)) return;
    var temp = this.b / this.a;
    this.e = Math.sqrt(1 - temp * temp);
    var sin1 = Math.sin(this.lat1);
    var cos1 = Math.cos(this.lat1);
    var ms1 = (0, $bi5ZC.default)(this.e, sin1, cos1);
    var ts1 = (0, $3xC66.default)(this.e, this.lat1, sin1);
    var sin2 = Math.sin(this.lat2);
    var cos2 = Math.cos(this.lat2);
    var ms2 = (0, $bi5ZC.default)(this.e, sin2, cos2);
    var ts2 = (0, $3xC66.default)(this.e, this.lat2, sin2);
    var ts0 = Math.abs(Math.abs(this.lat0) - (0, $gyVUi.HALF_PI)) < (0, $gyVUi.EPSLN) ? 0 // Handle poles by setting ts0 to 0
     : (0, $3xC66.default)(this.e, this.lat0, Math.sin(this.lat0));
    if (Math.abs(this.lat1 - this.lat2) > (0, $gyVUi.EPSLN)) this.ns = Math.log(ms1 / ms2) / Math.log(ts1 / ts2);
    else this.ns = sin1;
    if (isNaN(this.ns)) this.ns = sin1;
    this.f0 = ms1 / (this.ns * Math.pow(ts1, this.ns));
    this.rh = this.a * this.f0 * Math.pow(ts0, this.ns);
    if (!this.title) this.title = 'Lambert Conformal Conic';
}
function $d753eaf12887a276$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    // singular cases :
    if (Math.abs(2 * Math.abs(lat) - Math.PI) <= (0, $gyVUi.EPSLN)) lat = (0, $boTd3.default)(lat) * ((0, $gyVUi.HALF_PI) - 2 * (0, $gyVUi.EPSLN));
    var con = Math.abs(Math.abs(lat) - (0, $gyVUi.HALF_PI));
    var ts, rh1;
    if (con > (0, $gyVUi.EPSLN)) {
        ts = (0, $3xC66.default)(this.e, lat, Math.sin(lat));
        rh1 = this.a * this.f0 * Math.pow(ts, this.ns);
    } else {
        con = lat * this.ns;
        if (con <= 0) return null;
        rh1 = 0;
    }
    var theta = this.ns * (0, $a9oRf.default)(lon - this.long0, this.over);
    p.x = this.k0 * (rh1 * Math.sin(theta)) + this.x0;
    p.y = this.k0 * (this.rh - rh1 * Math.cos(theta)) + this.y0;
    return p;
}
function $d753eaf12887a276$export$70ae2c07e401031b(p) {
    var rh1, con, ts;
    var lat, lon;
    var x = (p.x - this.x0) / this.k0;
    var y = this.rh - (p.y - this.y0) / this.k0;
    if (this.ns > 0) {
        rh1 = Math.sqrt(x * x + y * y);
        con = 1;
    } else {
        rh1 = -Math.sqrt(x * x + y * y);
        con = -1;
    }
    var theta = 0;
    if (rh1 !== 0) theta = Math.atan2(con * x, con * y);
    if (rh1 !== 0 || this.ns > 0) {
        con = 1 / this.ns;
        ts = Math.pow(rh1 / (this.a * this.f0), con);
        lat = (0, $2AZR8.default)(this.e, ts);
        if (lat === -9999) return null;
    } else lat = -(0, $gyVUi.HALF_PI);
    lon = (0, $a9oRf.default)(theta / this.ns + this.long0, this.over);
    p.x = lon;
    p.y = lat;
    return p;
}
var $d753eaf12887a276$export$e4b2ac9215619f8d = [
    'Lambert Tangential Conformal Conic Projection',
    'Lambert_Conformal_Conic',
    'Lambert_Conformal_Conic_1SP',
    'Lambert_Conformal_Conic_2SP',
    'lcc',
    'Lambert Conic Conformal (1SP)',
    'Lambert Conic Conformal (2SP)'
];
var $d753eaf12887a276$export$2e2bcd8739ae039 = {
    init: $d753eaf12887a276$export$2cd8252107eb640b,
    forward: $d753eaf12887a276$export$174bb771924e7eb1,
    inverse: $d753eaf12887a276$export$70ae2c07e401031b,
    names: $d753eaf12887a276$export$e4b2ac9215619f8d
};

});

parcelRegister("h7o5G", function(module, exports) {

$parcel$export(module.exports, "default", () => $c765c705b741a192$export$2e2bcd8739ae039);

var $a9oRf = parcelRequire("a9oRf");
function $c765c705b741a192$export$2cd8252107eb640b() {
    this.a = 6377397.155;
    this.es = 0.006674372230614;
    this.e = Math.sqrt(this.es);
    if (!this.lat0) this.lat0 = 0.863937979737193;
    if (!this.long0) this.long0 = 0.4334234309119251;
    /* if scale not set default to 0.9999 */ if (!this.k0) this.k0 = 0.9999;
    this.s45 = 0.785398163397448; /* 45 */ 
    this.s90 = 2 * this.s45;
    this.fi0 = this.lat0;
    this.e2 = this.es;
    this.e = Math.sqrt(this.e2);
    this.alfa = Math.sqrt(1 + this.e2 * Math.pow(Math.cos(this.fi0), 4) / (1 - this.e2));
    this.uq = 1.04216856380474;
    this.u0 = Math.asin(Math.sin(this.fi0) / this.alfa);
    this.g = Math.pow((1 + this.e * Math.sin(this.fi0)) / (1 - this.e * Math.sin(this.fi0)), this.alfa * this.e / 2);
    this.k = Math.tan(this.u0 / 2 + this.s45) / Math.pow(Math.tan(this.fi0 / 2 + this.s45), this.alfa) * this.g;
    this.k1 = this.k0;
    this.n0 = this.a * Math.sqrt(1 - this.e2) / (1 - this.e2 * Math.pow(Math.sin(this.fi0), 2));
    this.s0 = 1.37008346281555;
    this.n = Math.sin(this.s0);
    this.ro0 = this.k1 * this.n0 / Math.tan(this.s0);
    this.ad = this.s90 - this.uq;
}
function $c765c705b741a192$export$174bb771924e7eb1(p) {
    var gfi, u, deltav, s, d, eps, ro;
    var lon = p.x;
    var lat = p.y;
    var delta_lon = (0, $a9oRf.default)(lon - this.long0, this.over);
    /* Transformation */ gfi = Math.pow((1 + this.e * Math.sin(lat)) / (1 - this.e * Math.sin(lat)), this.alfa * this.e / 2);
    u = 2 * (Math.atan(this.k * Math.pow(Math.tan(lat / 2 + this.s45), this.alfa) / gfi) - this.s45);
    deltav = -delta_lon * this.alfa;
    s = Math.asin(Math.cos(this.ad) * Math.sin(u) + Math.sin(this.ad) * Math.cos(u) * Math.cos(deltav));
    d = Math.asin(Math.cos(u) * Math.sin(deltav) / Math.cos(s));
    eps = this.n * d;
    ro = this.ro0 * Math.pow(Math.tan(this.s0 / 2 + this.s45), this.n) / Math.pow(Math.tan(s / 2 + this.s45), this.n);
    p.y = ro * Math.cos(eps) / 1;
    p.x = ro * Math.sin(eps) / 1;
    if (!this.czech) {
        p.y *= -1;
        p.x *= -1;
    }
    return p;
}
function $c765c705b741a192$export$70ae2c07e401031b(p) {
    var u, deltav, s, d, eps, ro, fi1;
    var ok;
    /* Transformation */ /* revert y, x */ var tmp = p.x;
    p.x = p.y;
    p.y = tmp;
    if (!this.czech) {
        p.y *= -1;
        p.x *= -1;
    }
    ro = Math.sqrt(p.x * p.x + p.y * p.y);
    eps = Math.atan2(p.y, p.x);
    d = eps / Math.sin(this.s0);
    s = 2 * (Math.atan(Math.pow(this.ro0 / ro, 1 / this.n) * Math.tan(this.s0 / 2 + this.s45)) - this.s45);
    u = Math.asin(Math.cos(this.ad) * Math.sin(s) - Math.sin(this.ad) * Math.cos(s) * Math.cos(d));
    deltav = Math.asin(Math.cos(s) * Math.sin(d) / Math.cos(u));
    p.x = this.long0 - deltav / this.alfa;
    fi1 = u;
    ok = 0;
    var iter = 0;
    do {
        p.y = 2 * (Math.atan(Math.pow(this.k, -1 / this.alfa) * Math.pow(Math.tan(u / 2 + this.s45), 1 / this.alfa) * Math.pow((1 + this.e * Math.sin(fi1)) / (1 - this.e * Math.sin(fi1)), this.e / 2)) - this.s45);
        if (Math.abs(fi1 - p.y) < 0.0000000001) ok = 1;
        fi1 = p.y;
        iter += 1;
    }while (ok === 0 && iter < 15);
    if (iter >= 15) return null;
    return p;
}
var $c765c705b741a192$export$e4b2ac9215619f8d = [
    'Krovak',
    'krovak'
];
var $c765c705b741a192$export$2e2bcd8739ae039 = {
    init: $c765c705b741a192$export$2cd8252107eb640b,
    forward: $c765c705b741a192$export$174bb771924e7eb1,
    inverse: $c765c705b741a192$export$70ae2c07e401031b,
    names: $c765c705b741a192$export$e4b2ac9215619f8d
};

});

parcelRegister("0599r", function(module, exports) {

$parcel$export(module.exports, "default", () => $00f791059e8f61f5$export$2e2bcd8739ae039);

var $f3cKo = parcelRequire("f3cKo");

var $bWC4D = parcelRequire("bWC4D");

var $hU8aC = parcelRequire("hU8aC");

var $i9r9A = parcelRequire("i9r9A");

var $bM0eI = parcelRequire("bM0eI");

var $3eeGT = parcelRequire("3eeGT");

var $a9oRf = parcelRequire("a9oRf");

var $aDUFA = parcelRequire("aDUFA");

var $cfNuL = parcelRequire("cfNuL");

var $gyVUi = parcelRequire("gyVUi");
function $00f791059e8f61f5$export$2cd8252107eb640b() {
    if (!this.sphere) {
        this.e0 = (0, $bWC4D.default)(this.es);
        this.e1 = (0, $hU8aC.default)(this.es);
        this.e2 = (0, $i9r9A.default)(this.es);
        this.e3 = (0, $bM0eI.default)(this.es);
        this.ml0 = this.a * (0, $f3cKo.default)(this.e0, this.e1, this.e2, this.e3, this.lat0);
    }
}
function $00f791059e8f61f5$export$174bb771924e7eb1(p) {
    /* Forward equations
      ----------------- */ var x, y;
    var lam = p.x;
    var phi = p.y;
    lam = (0, $a9oRf.default)(lam - this.long0, this.over);
    if (this.sphere) {
        x = this.a * Math.asin(Math.cos(phi) * Math.sin(lam));
        y = this.a * (Math.atan2(Math.tan(phi), Math.cos(lam)) - this.lat0);
    } else {
        // ellipsoid
        var sinphi = Math.sin(phi);
        var cosphi = Math.cos(phi);
        var nl = (0, $3eeGT.default)(this.a, this.e, sinphi);
        var tl = Math.tan(phi) * Math.tan(phi);
        var al = lam * Math.cos(phi);
        var asq = al * al;
        var cl = this.es * cosphi * cosphi / (1 - this.es);
        var ml = this.a * (0, $f3cKo.default)(this.e0, this.e1, this.e2, this.e3, phi);
        x = nl * al * (1 - asq * tl * (1 / 6 - (8 - tl + 8 * cl) * asq / 120));
        y = ml - this.ml0 + nl * sinphi / cosphi * asq * (0.5 + (5 - tl + 6 * cl) * asq / 24);
    }
    p.x = x + this.x0;
    p.y = y + this.y0;
    return p;
}
function $00f791059e8f61f5$export$70ae2c07e401031b(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var x = p.x / this.a;
    var y = p.y / this.a;
    var phi, lam;
    if (this.sphere) {
        var dd = y + this.lat0;
        phi = Math.asin(Math.sin(dd) * Math.cos(x));
        lam = Math.atan2(Math.tan(x), Math.cos(dd));
    } else {
        /* ellipsoid */ var ml1 = this.ml0 / this.a + y;
        var phi1 = (0, $cfNuL.default)(ml1, this.e0, this.e1, this.e2, this.e3);
        if (Math.abs(Math.abs(phi1) - (0, $gyVUi.HALF_PI)) <= (0, $gyVUi.EPSLN)) {
            p.x = this.long0;
            p.y = (0, $gyVUi.HALF_PI);
            if (y < 0) p.y *= -1;
            return p;
        }
        var nl1 = (0, $3eeGT.default)(this.a, this.e, Math.sin(phi1));
        var rl1 = nl1 * nl1 * nl1 / this.a / this.a * (1 - this.es);
        var tl1 = Math.pow(Math.tan(phi1), 2);
        var dl = x * this.a / nl1;
        var dsq = dl * dl;
        phi = phi1 - nl1 * Math.tan(phi1) / rl1 * dl * dl * (0.5 - (1 + 3 * tl1) * dl * dl / 24);
        lam = dl * (1 - dsq * (tl1 / 3 + (1 + 3 * tl1) * tl1 * dsq / 15)) / Math.cos(phi1);
    }
    p.x = (0, $a9oRf.default)(lam + this.long0, this.over);
    p.y = (0, $aDUFA.default)(phi);
    return p;
}
var $00f791059e8f61f5$export$e4b2ac9215619f8d = [
    'Cassini',
    'Cassini_Soldner',
    'cass'
];
var $00f791059e8f61f5$export$2e2bcd8739ae039 = {
    init: $00f791059e8f61f5$export$2cd8252107eb640b,
    forward: $00f791059e8f61f5$export$174bb771924e7eb1,
    inverse: $00f791059e8f61f5$export$70ae2c07e401031b,
    names: $00f791059e8f61f5$export$e4b2ac9215619f8d
};

});
parcelRegister("f3cKo", function(module, exports) {

$parcel$export(module.exports, "default", () => $af51062589eeb2ce$export$2e2bcd8739ae039);
function $af51062589eeb2ce$export$2e2bcd8739ae039(e0, e1, e2, e3, phi) {
    return e0 * phi - e1 * Math.sin(2 * phi) + e2 * Math.sin(4 * phi) - e3 * Math.sin(6 * phi);
}

});

parcelRegister("bWC4D", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b22a51ec249391e$export$2e2bcd8739ae039);
function $8b22a51ec249391e$export$2e2bcd8739ae039(x) {
    return 1 - 0.25 * x * (1 + x / 16 * (3 + 1.25 * x));
}

});

parcelRegister("hU8aC", function(module, exports) {

$parcel$export(module.exports, "default", () => $d08e0117e308bb87$export$2e2bcd8739ae039);
function $d08e0117e308bb87$export$2e2bcd8739ae039(x) {
    return 0.375 * x * (1 + 0.25 * x * (1 + 0.46875 * x));
}

});

parcelRegister("i9r9A", function(module, exports) {

$parcel$export(module.exports, "default", () => $d36e2161accfe0ec$export$2e2bcd8739ae039);
function $d36e2161accfe0ec$export$2e2bcd8739ae039(x) {
    return 0.05859375 * x * x * (1 + 0.75 * x);
}

});

parcelRegister("bM0eI", function(module, exports) {

$parcel$export(module.exports, "default", () => $89245c5bc9a5a616$export$2e2bcd8739ae039);
function $89245c5bc9a5a616$export$2e2bcd8739ae039(x) {
    return x * x * x * (35 / 3072);
}

});

parcelRegister("3eeGT", function(module, exports) {

$parcel$export(module.exports, "default", () => $259e1333723cc7cb$export$2e2bcd8739ae039);
function $259e1333723cc7cb$export$2e2bcd8739ae039(a, e, sinphi) {
    var temp = e * sinphi;
    return a / Math.sqrt(1 - temp * temp);
}

});

parcelRegister("aDUFA", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bf9815baea17aa9$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");

var $boTd3 = parcelRequire("boTd3");
function $7bf9815baea17aa9$export$2e2bcd8739ae039(x) {
    return Math.abs(x) < (0, $gyVUi.HALF_PI) ? x : x - (0, $boTd3.default)(x) * Math.PI;
}

});

parcelRegister("cfNuL", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ebd4771f70de1ee$export$2e2bcd8739ae039);
function $8ebd4771f70de1ee$export$2e2bcd8739ae039(ml, e0, e1, e2, e3) {
    var phi;
    var dphi;
    phi = ml / e0;
    for(var i = 0; i < 15; i++){
        dphi = (ml - (e0 * phi - e1 * Math.sin(2 * phi) + e2 * Math.sin(4 * phi) - e3 * Math.sin(6 * phi))) / (e0 - 2 * e1 * Math.cos(2 * phi) + 4 * e2 * Math.cos(4 * phi) - 6 * e3 * Math.cos(6 * phi));
        phi += dphi;
        if (Math.abs(dphi) <= 0.0000000001) return phi;
    }
    // ..reportError("IMLFN-CONV:Latitude failed to converge after 15 iterations");
    return NaN;
}

});


parcelRegister("deudM", function(module, exports) {

$parcel$export(module.exports, "S_POLE", () => S_POLE);
$parcel$export(module.exports, "N_POLE", () => N_POLE);
$parcel$export(module.exports, "EQUIT", () => EQUIT);
$parcel$export(module.exports, "OBLIQ", () => OBLIQ);
$parcel$export(module.exports, "init", () => init);
$parcel$export(module.exports, "forward", () => forward);
$parcel$export(module.exports, "inverse", () => inverse);
$parcel$export(module.exports, "names", () => names);
$parcel$export(module.exports, "default", () => $9a24067d8ab69621$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");

var $874JP = parcelRequire("874JP");

var $a9oRf = parcelRequire("a9oRf");
var S_POLE = 1;
var N_POLE = 2;
var EQUIT = 3;
var OBLIQ = 4;
function init() {
    var t = Math.abs(this.lat0);
    if (Math.abs(t - (0, $gyVUi.HALF_PI)) < (0, $gyVUi.EPSLN)) this.mode = this.lat0 < 0 ? S_POLE : N_POLE;
    else if (Math.abs(t) < (0, $gyVUi.EPSLN)) this.mode = EQUIT;
    else this.mode = OBLIQ;
    if (this.es > 0) {
        var sinphi;
        this.qp = (0, $874JP.default)(this.e, 1);
        this.mmf = 0.5 / (1 - this.es);
        this.apa = authset(this.es);
        switch(this.mode){
            case N_POLE:
                this.dd = 1;
                break;
            case S_POLE:
                this.dd = 1;
                break;
            case EQUIT:
                this.rq = Math.sqrt(0.5 * this.qp);
                this.dd = 1 / this.rq;
                this.xmf = 1;
                this.ymf = 0.5 * this.qp;
                break;
            case OBLIQ:
                this.rq = Math.sqrt(0.5 * this.qp);
                sinphi = Math.sin(this.lat0);
                this.sinb1 = (0, $874JP.default)(this.e, sinphi) / this.qp;
                this.cosb1 = Math.sqrt(1 - this.sinb1 * this.sinb1);
                this.dd = Math.cos(this.lat0) / (Math.sqrt(1 - this.es * sinphi * sinphi) * this.rq * this.cosb1);
                this.ymf = (this.xmf = this.rq) / this.dd;
                this.xmf *= this.dd;
                break;
        }
    } else if (this.mode === OBLIQ) {
        this.sinph0 = Math.sin(this.lat0);
        this.cosph0 = Math.cos(this.lat0);
    }
}
function forward(p) {
    /* Forward equations
      ----------------- */ var x, y, coslam, sinlam, sinphi, q, sinb, cosb, b, cosphi;
    var lam = p.x;
    var phi = p.y;
    lam = (0, $a9oRf.default)(lam - this.long0, this.over);
    if (this.sphere) {
        sinphi = Math.sin(phi);
        cosphi = Math.cos(phi);
        coslam = Math.cos(lam);
        if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
            y = this.mode === this.EQUIT ? 1 + cosphi * coslam : 1 + this.sinph0 * sinphi + this.cosph0 * cosphi * coslam;
            if (y <= (0, $gyVUi.EPSLN)) return null;
            y = Math.sqrt(2 / y);
            x = y * cosphi * Math.sin(lam);
            y *= this.mode === this.EQUIT ? sinphi : this.cosph0 * sinphi - this.sinph0 * cosphi * coslam;
        } else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
            if (this.mode === this.N_POLE) coslam = -coslam;
            if (Math.abs(phi + this.lat0) < (0, $gyVUi.EPSLN)) return null;
            y = (0, $gyVUi.FORTPI) - phi * 0.5;
            y = 2 * (this.mode === this.S_POLE ? Math.cos(y) : Math.sin(y));
            x = y * Math.sin(lam);
            y *= coslam;
        }
    } else {
        sinb = 0;
        cosb = 0;
        b = 0;
        coslam = Math.cos(lam);
        sinlam = Math.sin(lam);
        sinphi = Math.sin(phi);
        q = (0, $874JP.default)(this.e, sinphi);
        if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
            sinb = q / this.qp;
            cosb = Math.sqrt(1 - sinb * sinb);
        }
        switch(this.mode){
            case this.OBLIQ:
                b = 1 + this.sinb1 * sinb + this.cosb1 * cosb * coslam;
                break;
            case this.EQUIT:
                b = 1 + cosb * coslam;
                break;
            case this.N_POLE:
                b = (0, $gyVUi.HALF_PI) + phi;
                q = this.qp - q;
                break;
            case this.S_POLE:
                b = phi - (0, $gyVUi.HALF_PI);
                q = this.qp + q;
                break;
        }
        if (Math.abs(b) < (0, $gyVUi.EPSLN)) return null;
        switch(this.mode){
            case this.OBLIQ:
            case this.EQUIT:
                b = Math.sqrt(2 / b);
                if (this.mode === this.OBLIQ) y = this.ymf * b * (this.cosb1 * sinb - this.sinb1 * cosb * coslam);
                else y = (b = Math.sqrt(2 / (1 + cosb * coslam))) * sinb * this.ymf;
                x = this.xmf * b * cosb * sinlam;
                break;
            case this.N_POLE:
            case this.S_POLE:
                if (q >= 0) {
                    x = (b = Math.sqrt(q)) * sinlam;
                    y = coslam * (this.mode === this.S_POLE ? b : -b);
                } else x = y = 0;
                break;
        }
    }
    p.x = this.a * x + this.x0;
    p.y = this.a * y + this.y0;
    return p;
}
function inverse(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var x = p.x / this.a;
    var y = p.y / this.a;
    var lam, phi, cCe, sCe, q, rho, ab;
    if (this.sphere) {
        var cosz = 0, rh, sinz = 0;
        rh = Math.sqrt(x * x + y * y);
        phi = rh * 0.5;
        if (phi > 1) return null;
        phi = 2 * Math.asin(phi);
        if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
            sinz = Math.sin(phi);
            cosz = Math.cos(phi);
        }
        switch(this.mode){
            case this.EQUIT:
                phi = Math.abs(rh) <= (0, $gyVUi.EPSLN) ? 0 : Math.asin(y * sinz / rh);
                x *= sinz;
                y = cosz * rh;
                break;
            case this.OBLIQ:
                phi = Math.abs(rh) <= (0, $gyVUi.EPSLN) ? this.lat0 : Math.asin(cosz * this.sinph0 + y * sinz * this.cosph0 / rh);
                x *= sinz * this.cosph0;
                y = (cosz - Math.sin(phi) * this.sinph0) * rh;
                break;
            case this.N_POLE:
                y = -y;
                phi = (0, $gyVUi.HALF_PI) - phi;
                break;
            case this.S_POLE:
                phi -= (0, $gyVUi.HALF_PI);
                break;
        }
        lam = y === 0 && (this.mode === this.EQUIT || this.mode === this.OBLIQ) ? 0 : Math.atan2(x, y);
    } else {
        ab = 0;
        if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
            x /= this.dd;
            y *= this.dd;
            rho = Math.sqrt(x * x + y * y);
            if (rho < (0, $gyVUi.EPSLN)) {
                p.x = this.long0;
                p.y = this.lat0;
                return p;
            }
            sCe = 2 * Math.asin(0.5 * rho / this.rq);
            cCe = Math.cos(sCe);
            x *= sCe = Math.sin(sCe);
            if (this.mode === this.OBLIQ) {
                ab = cCe * this.sinb1 + y * sCe * this.cosb1 / rho;
                q = this.qp * ab;
                y = rho * this.cosb1 * cCe - y * this.sinb1 * sCe;
            } else {
                ab = y * sCe / rho;
                q = this.qp * ab;
                y = rho * cCe;
            }
        } else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
            if (this.mode === this.N_POLE) y = -y;
            q = x * x + y * y;
            if (!q) {
                p.x = this.long0;
                p.y = this.lat0;
                return p;
            }
            ab = 1 - q / this.qp;
            if (this.mode === this.S_POLE) ab = -ab;
        }
        lam = Math.atan2(x, y);
        phi = authlat(Math.asin(ab), this.apa);
    }
    p.x = (0, $a9oRf.default)(this.long0 + lam, this.over);
    p.y = phi;
    return p;
}
/* determine latitude from authalic latitude */ var P00 = 0.33333333333333333333;
var P01 = 0.17222222222222222222;
var P02 = 0.10257936507936507936;
var P10 = 0.06388888888888888888;
var P11 = 0.06640211640211640211;
var P20 = 0.01641501294219154443;
function authset(es) {
    var t;
    var APA = [];
    APA[0] = es * P00;
    t = es * es;
    APA[0] += t * P01;
    APA[1] = t * P10;
    t *= es;
    APA[0] += t * P02;
    APA[1] += t * P11;
    APA[2] = t * P20;
    return APA;
}
function authlat(beta, APA) {
    var t = beta + beta;
    return beta + APA[0] * Math.sin(t) + APA[1] * Math.sin(t + t) + APA[2] * Math.sin(t + t + t);
}
var names = [
    'Lambert Azimuthal Equal Area',
    'Lambert_Azimuthal_Equal_Area',
    'laea'
];
var $9a24067d8ab69621$export$2e2bcd8739ae039 = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names,
    S_POLE: S_POLE,
    N_POLE: N_POLE,
    EQUIT: EQUIT,
    OBLIQ: OBLIQ
};

});
parcelRegister("874JP", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e82a7153665d151$export$2e2bcd8739ae039);
function $5e82a7153665d151$export$2e2bcd8739ae039(eccent, sinphi) {
    var con;
    if (eccent > 1.0e-7) {
        con = eccent * sinphi;
        return (1 - eccent * eccent) * (sinphi / (1 - con * con) - 0.5 / eccent * Math.log((1 - con) / (1 + con)));
    } else return 2 * sinphi;
}

});


parcelRegister("8mhgZ", function(module, exports) {

$parcel$export(module.exports, "init", () => init);
$parcel$export(module.exports, "forward", () => forward);
$parcel$export(module.exports, "inverse", () => inverse);
$parcel$export(module.exports, "phi1z", () => phi1z);
$parcel$export(module.exports, "names", () => names);
$parcel$export(module.exports, "default", () => $615dc6dbd83ac6d5$export$2e2bcd8739ae039);

var $bi5ZC = parcelRequire("bi5ZC");

var $874JP = parcelRequire("874JP");

var $a9oRf = parcelRequire("a9oRf");

var $ljPJJ = parcelRequire("ljPJJ");

var $gyVUi = parcelRequire("gyVUi");
function init() {
    if (Math.abs(this.lat1 + this.lat2) < (0, $gyVUi.EPSLN)) return;
    this.temp = this.b / this.a;
    this.es = 1 - Math.pow(this.temp, 2);
    this.e3 = Math.sqrt(this.es);
    this.sin_po = Math.sin(this.lat1);
    this.cos_po = Math.cos(this.lat1);
    this.t1 = this.sin_po;
    this.con = this.sin_po;
    this.ms1 = (0, $bi5ZC.default)(this.e3, this.sin_po, this.cos_po);
    this.qs1 = (0, $874JP.default)(this.e3, this.sin_po);
    this.sin_po = Math.sin(this.lat2);
    this.cos_po = Math.cos(this.lat2);
    this.t2 = this.sin_po;
    this.ms2 = (0, $bi5ZC.default)(this.e3, this.sin_po, this.cos_po);
    this.qs2 = (0, $874JP.default)(this.e3, this.sin_po);
    this.sin_po = Math.sin(this.lat0);
    this.cos_po = Math.cos(this.lat0);
    this.t3 = this.sin_po;
    this.qs0 = (0, $874JP.default)(this.e3, this.sin_po);
    if (Math.abs(this.lat1 - this.lat2) > (0, $gyVUi.EPSLN)) this.ns0 = (this.ms1 * this.ms1 - this.ms2 * this.ms2) / (this.qs2 - this.qs1);
    else this.ns0 = this.con;
    this.c = this.ms1 * this.ms1 + this.ns0 * this.qs1;
    this.rh = this.a * Math.sqrt(this.c - this.ns0 * this.qs0) / this.ns0;
}
function forward(p) {
    var lon = p.x;
    var lat = p.y;
    this.sin_phi = Math.sin(lat);
    this.cos_phi = Math.cos(lat);
    var qs = (0, $874JP.default)(this.e3, this.sin_phi);
    var rh1 = this.a * Math.sqrt(this.c - this.ns0 * qs) / this.ns0;
    var theta = this.ns0 * (0, $a9oRf.default)(lon - this.long0, this.over);
    var x = rh1 * Math.sin(theta) + this.x0;
    var y = this.rh - rh1 * Math.cos(theta) + this.y0;
    p.x = x;
    p.y = y;
    return p;
}
function inverse(p) {
    var rh1, qs, con, theta, lon, lat;
    p.x -= this.x0;
    p.y = this.rh - p.y + this.y0;
    if (this.ns0 >= 0) {
        rh1 = Math.sqrt(p.x * p.x + p.y * p.y);
        con = 1;
    } else {
        rh1 = -Math.sqrt(p.x * p.x + p.y * p.y);
        con = -1;
    }
    theta = 0;
    if (rh1 !== 0) theta = Math.atan2(con * p.x, con * p.y);
    con = rh1 * this.ns0 / this.a;
    if (this.sphere) lat = Math.asin((this.c - con * con) / (2 * this.ns0));
    else {
        qs = (this.c - con * con) / this.ns0;
        lat = this.phi1z(this.e3, qs);
    }
    lon = (0, $a9oRf.default)(theta / this.ns0 + this.long0, this.over);
    p.x = lon;
    p.y = lat;
    return p;
}
function phi1z(eccent, qs) {
    var sinphi, cosphi, con, com, dphi;
    var phi = (0, $ljPJJ.default)(0.5 * qs);
    if (eccent < (0, $gyVUi.EPSLN)) return phi;
    var eccnts = eccent * eccent;
    for(var i = 1; i <= 25; i++){
        sinphi = Math.sin(phi);
        cosphi = Math.cos(phi);
        con = eccent * sinphi;
        com = 1 - con * con;
        dphi = 0.5 * com * com / cosphi * (qs / (1 - eccnts) - sinphi / com + 0.5 / eccent * Math.log((1 - con) / (1 + con)));
        phi = phi + dphi;
        if (Math.abs(dphi) <= 1e-7) return phi;
    }
    return null;
}
var names = [
    'Albers_Conic_Equal_Area',
    'Albers_Equal_Area',
    'Albers',
    'aea'
];
var $615dc6dbd83ac6d5$export$2e2bcd8739ae039 = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names,
    phi1z: phi1z
};

});
parcelRegister("ljPJJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8538120e633ea57$export$2e2bcd8739ae039);
function $f8538120e633ea57$export$2e2bcd8739ae039(x) {
    if (Math.abs(x) > 1) x = x > 1 ? 1 : -1;
    return Math.asin(x);
}

});


parcelRegister("iSJfu", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbf05e97c9232a2a$export$2e2bcd8739ae039);

var $a9oRf = parcelRequire("a9oRf");

var $ljPJJ = parcelRequire("ljPJJ");

var $gyVUi = parcelRequire("gyVUi");
function $dbf05e97c9232a2a$export$2cd8252107eb640b() {
    /* Place parameters in static storage for common use
      ------------------------------------------------- */ this.sin_p14 = Math.sin(this.lat0);
    this.cos_p14 = Math.cos(this.lat0);
    // Approximation for projecting points to the horizon (infinity)
    this.infinity_dist = 1000 * this.a;
    this.rc = 1;
}
function $dbf05e97c9232a2a$export$174bb771924e7eb1(p) {
    var sinphi, cosphi; /* sin and cos value        */ 
    var dlon; /* delta longitude value      */ 
    var coslon; /* cos of longitude        */ 
    var ksp; /* scale factor          */ 
    var g;
    var x, y;
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
      ----------------- */ dlon = (0, $a9oRf.default)(lon - this.long0, this.over);
    sinphi = Math.sin(lat);
    cosphi = Math.cos(lat);
    coslon = Math.cos(dlon);
    g = this.sin_p14 * sinphi + this.cos_p14 * cosphi * coslon;
    ksp = 1;
    if (g > 0 || Math.abs(g) <= (0, $gyVUi.EPSLN)) {
        x = this.x0 + this.a * ksp * cosphi * Math.sin(dlon) / g;
        y = this.y0 + this.a * ksp * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon) / g;
    } else {
        // Point is in the opposing hemisphere and is unprojectable
        // We still need to return a reasonable point, so we project
        // to infinity, on a bearing
        // equivalent to the northern hemisphere equivalent
        // This is a reasonable approximation for short shapes and lines that
        // straddle the horizon.
        x = this.x0 + this.infinity_dist * cosphi * Math.sin(dlon);
        y = this.y0 + this.infinity_dist * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon);
    }
    p.x = x;
    p.y = y;
    return p;
}
function $dbf05e97c9232a2a$export$70ae2c07e401031b(p) {
    var rh; /* Rho */ 
    var sinc, cosc;
    var c;
    var lon, lat;
    /* Inverse equations
      ----------------- */ p.x = (p.x - this.x0) / this.a;
    p.y = (p.y - this.y0) / this.a;
    p.x /= this.k0;
    p.y /= this.k0;
    if (rh = Math.sqrt(p.x * p.x + p.y * p.y)) {
        c = Math.atan2(rh, this.rc);
        sinc = Math.sin(c);
        cosc = Math.cos(c);
        lat = (0, $ljPJJ.default)(cosc * this.sin_p14 + p.y * sinc * this.cos_p14 / rh);
        lon = Math.atan2(p.x * sinc, rh * this.cos_p14 * cosc - p.y * this.sin_p14 * sinc);
        lon = (0, $a9oRf.default)(this.long0 + lon, this.over);
    } else {
        lat = this.phic0;
        lon = 0;
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var $dbf05e97c9232a2a$export$e4b2ac9215619f8d = [
    'gnom'
];
var $dbf05e97c9232a2a$export$2e2bcd8739ae039 = {
    init: $dbf05e97c9232a2a$export$2cd8252107eb640b,
    forward: $dbf05e97c9232a2a$export$174bb771924e7eb1,
    inverse: $dbf05e97c9232a2a$export$70ae2c07e401031b,
    names: $dbf05e97c9232a2a$export$e4b2ac9215619f8d
};

});

parcelRegister("6CTAc", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d31684dfe594c29$export$2e2bcd8739ae039);

var $a9oRf = parcelRequire("a9oRf");

var $874JP = parcelRequire("874JP");

var $bi5ZC = parcelRequire("bi5ZC");

var $b4Ogv = parcelRequire("b4Ogv");
function $4d31684dfe594c29$export$2cd8252107eb640b() {
    // no-op
    if (!this.sphere) this.k0 = (0, $bi5ZC.default)(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts));
}
function $4d31684dfe594c29$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var x, y;
    /* Forward equations
      ----------------- */ var dlon = (0, $a9oRf.default)(lon - this.long0, this.over);
    if (this.sphere) {
        x = this.x0 + this.a * dlon * Math.cos(this.lat_ts);
        y = this.y0 + this.a * Math.sin(lat) / Math.cos(this.lat_ts);
    } else {
        var qs = (0, $874JP.default)(this.e, Math.sin(lat));
        x = this.x0 + this.a * this.k0 * dlon;
        y = this.y0 + this.a * qs * 0.5 / this.k0;
    }
    p.x = x;
    p.y = y;
    return p;
}
function $4d31684dfe594c29$export$70ae2c07e401031b(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var lon, lat;
    if (this.sphere) {
        lon = (0, $a9oRf.default)(this.long0 + p.x / this.a / Math.cos(this.lat_ts), this.over);
        lat = Math.asin(p.y / this.a * Math.cos(this.lat_ts));
    } else {
        lat = (0, $b4Ogv.default)(this.e, 2 * p.y * this.k0 / this.a);
        lon = (0, $a9oRf.default)(this.long0 + p.x / (this.a * this.k0), this.over);
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var $4d31684dfe594c29$export$e4b2ac9215619f8d = [
    'cea'
];
var $4d31684dfe594c29$export$2e2bcd8739ae039 = {
    init: $4d31684dfe594c29$export$2cd8252107eb640b,
    forward: $4d31684dfe594c29$export$174bb771924e7eb1,
    inverse: $4d31684dfe594c29$export$70ae2c07e401031b,
    names: $4d31684dfe594c29$export$e4b2ac9215619f8d
};

});
parcelRegister("b4Ogv", function(module, exports) {

$parcel$export(module.exports, "default", () => $81070f0f2a61f650$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");
function $81070f0f2a61f650$export$2e2bcd8739ae039(eccent, q) {
    var temp = 1 - (1 - eccent * eccent) / (2 * eccent) * Math.log((1 - eccent) / (1 + eccent));
    if (Math.abs(Math.abs(q) - temp) < 1.0E-6) {
        if (q < 0) return -1 * (0, $gyVUi.HALF_PI);
        else return 0, $gyVUi.HALF_PI;
    }
    // var phi = 0.5* q/(1-eccent*eccent);
    var phi = Math.asin(0.5 * q);
    var dphi;
    var sin_phi;
    var cos_phi;
    var con;
    for(var i = 0; i < 30; i++){
        sin_phi = Math.sin(phi);
        cos_phi = Math.cos(phi);
        con = eccent * sin_phi;
        dphi = Math.pow(1 - con * con, 2) / (2 * cos_phi) * (q / (1 - eccent * eccent) - sin_phi / (1 - con * con) + 0.5 / eccent * Math.log((1 - con) / (1 + con)));
        phi += dphi;
        if (Math.abs(dphi) <= 0.0000000001) return phi;
    }
    // console.log("IQSFN-CONV:Latitude failed to converge after 30 iterations");
    return NaN;
}

});


parcelRegister("cEGTl", function(module, exports) {

$parcel$export(module.exports, "default", () => $936a7dd52884a3fc$export$2e2bcd8739ae039);

var $a9oRf = parcelRequire("a9oRf");

var $aDUFA = parcelRequire("aDUFA");
function $936a7dd52884a3fc$export$2cd8252107eb640b() {
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    this.lat0 = this.lat0 || 0;
    this.long0 = this.long0 || 0;
    this.lat_ts = this.lat_ts || 0;
    this.title = this.title || 'Equidistant Cylindrical (Plate Carre)';
    this.rc = Math.cos(this.lat_ts);
}
function $936a7dd52884a3fc$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var dlon = (0, $a9oRf.default)(lon - this.long0, this.over);
    var dlat = (0, $aDUFA.default)(lat - this.lat0);
    p.x = this.x0 + this.a * dlon * this.rc;
    p.y = this.y0 + this.a * dlat;
    return p;
}
function $936a7dd52884a3fc$export$70ae2c07e401031b(p) {
    var x = p.x;
    var y = p.y;
    p.x = (0, $a9oRf.default)(this.long0 + (x - this.x0) / (this.a * this.rc), this.over);
    p.y = (0, $aDUFA.default)(this.lat0 + (y - this.y0) / this.a);
    return p;
}
var $936a7dd52884a3fc$export$e4b2ac9215619f8d = [
    'Equirectangular',
    'Equidistant_Cylindrical',
    'Equidistant_Cylindrical_Spherical',
    'eqc'
];
var $936a7dd52884a3fc$export$2e2bcd8739ae039 = {
    init: $936a7dd52884a3fc$export$2cd8252107eb640b,
    forward: $936a7dd52884a3fc$export$174bb771924e7eb1,
    inverse: $936a7dd52884a3fc$export$70ae2c07e401031b,
    names: $936a7dd52884a3fc$export$e4b2ac9215619f8d
};

});

parcelRegister("2Lrqq", function(module, exports) {

$parcel$export(module.exports, "default", () => $20353e9e716518d0$export$2e2bcd8739ae039);

var $bWC4D = parcelRequire("bWC4D");

var $hU8aC = parcelRequire("hU8aC");

var $i9r9A = parcelRequire("i9r9A");

var $bM0eI = parcelRequire("bM0eI");

var $a9oRf = parcelRequire("a9oRf");

var $aDUFA = parcelRequire("aDUFA");

var $f3cKo = parcelRequire("f3cKo");

var $gyVUi = parcelRequire("gyVUi");

var $3eeGT = parcelRequire("3eeGT");
/**
 * @typedef {Object} LocalThis
 * @property {number} temp
 * @property {number} es
 * @property {number} e
 * @property {number} e0
 * @property {number} e1
 * @property {number} e2
 * @property {number} e3
 * @property {number} ml0
 */ var $20353e9e716518d0$var$MAX_ITER = 20;
function $20353e9e716518d0$export$2cd8252107eb640b() {
    /* Place parameters in static storage for common use
      ------------------------------------------------- */ this.temp = this.b / this.a;
    this.es = 1 - Math.pow(this.temp, 2); // devait etre dans tmerc.js mais n y est pas donc je commente sinon retour de valeurs nulles
    this.e = Math.sqrt(this.es);
    this.e0 = (0, $bWC4D.default)(this.es);
    this.e1 = (0, $hU8aC.default)(this.es);
    this.e2 = (0, $i9r9A.default)(this.es);
    this.e3 = (0, $bM0eI.default)(this.es);
    this.ml0 = this.a * (0, $f3cKo.default)(this.e0, this.e1, this.e2, this.e3, this.lat0); // si que des zeros le calcul ne se fait pas
}
function $20353e9e716518d0$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var x, y, el;
    var dlon = (0, $a9oRf.default)(lon - this.long0, this.over);
    el = dlon * Math.sin(lat);
    if (this.sphere) {
        if (Math.abs(lat) <= (0, $gyVUi.EPSLN)) {
            x = this.a * dlon;
            y = -1 * this.a * this.lat0;
        } else {
            x = this.a * Math.sin(el) / Math.tan(lat);
            y = this.a * ((0, $aDUFA.default)(lat - this.lat0) + (1 - Math.cos(el)) / Math.tan(lat));
        }
    } else if (Math.abs(lat) <= (0, $gyVUi.EPSLN)) {
        x = this.a * dlon;
        y = -1 * this.ml0;
    } else {
        var nl = (0, $3eeGT.default)(this.a, this.e, Math.sin(lat)) / Math.tan(lat);
        x = nl * Math.sin(el);
        y = this.a * (0, $f3cKo.default)(this.e0, this.e1, this.e2, this.e3, lat) - this.ml0 + nl * (1 - Math.cos(el));
    }
    p.x = x + this.x0;
    p.y = y + this.y0;
    return p;
}
function $20353e9e716518d0$export$70ae2c07e401031b(p) {
    var lon, lat, x, y, i;
    var al, bl;
    var phi, dphi;
    x = p.x - this.x0;
    y = p.y - this.y0;
    if (this.sphere) {
        if (Math.abs(y + this.a * this.lat0) <= (0, $gyVUi.EPSLN)) {
            lon = (0, $a9oRf.default)(x / this.a + this.long0, this.over);
            lat = 0;
        } else {
            al = this.lat0 + y / this.a;
            bl = x * x / this.a / this.a + al * al;
            phi = al;
            var tanphi;
            for(i = $20353e9e716518d0$var$MAX_ITER; i; --i){
                tanphi = Math.tan(phi);
                dphi = -1 * (al * (phi * tanphi + 1) - phi - 0.5 * (phi * phi + bl) * tanphi) / ((phi - al) / tanphi - 1);
                phi += dphi;
                if (Math.abs(dphi) <= (0, $gyVUi.EPSLN)) {
                    lat = phi;
                    break;
                }
            }
            lon = (0, $a9oRf.default)(this.long0 + Math.asin(x * Math.tan(phi) / this.a) / Math.sin(lat), this.over);
        }
    } else if (Math.abs(y + this.ml0) <= (0, $gyVUi.EPSLN)) {
        lat = 0;
        lon = (0, $a9oRf.default)(this.long0 + x / this.a, this.over);
    } else {
        al = (this.ml0 + y) / this.a;
        bl = x * x / this.a / this.a + al * al;
        phi = al;
        var cl, mln, mlnp, ma;
        var con;
        for(i = $20353e9e716518d0$var$MAX_ITER; i; --i){
            con = this.e * Math.sin(phi);
            cl = Math.sqrt(1 - con * con) * Math.tan(phi);
            mln = this.a * (0, $f3cKo.default)(this.e0, this.e1, this.e2, this.e3, phi);
            mlnp = this.e0 - 2 * this.e1 * Math.cos(2 * phi) + 4 * this.e2 * Math.cos(4 * phi) - 6 * this.e3 * Math.cos(6 * phi);
            ma = mln / this.a;
            dphi = (al * (cl * ma + 1) - ma - 0.5 * cl * (ma * ma + bl)) / (this.es * Math.sin(2 * phi) * (ma * ma + bl - 2 * al * ma) / (4 * cl) + (al - ma) * (cl * mlnp - 2 / Math.sin(2 * phi)) - mlnp);
            phi -= dphi;
            if (Math.abs(dphi) <= (0, $gyVUi.EPSLN)) {
                lat = phi;
                break;
            }
        }
        // lat=phi4z(this.e,this.e0,this.e1,this.e2,this.e3,al,bl,0,0);
        cl = Math.sqrt(1 - this.es * Math.pow(Math.sin(lat), 2)) * Math.tan(lat);
        lon = (0, $a9oRf.default)(this.long0 + Math.asin(x * cl / this.a) / Math.sin(lat), this.over);
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var $20353e9e716518d0$export$e4b2ac9215619f8d = [
    'Polyconic',
    'American_Polyconic',
    'poly'
];
var $20353e9e716518d0$export$2e2bcd8739ae039 = {
    init: $20353e9e716518d0$export$2cd8252107eb640b,
    forward: $20353e9e716518d0$export$174bb771924e7eb1,
    inverse: $20353e9e716518d0$export$70ae2c07e401031b,
    names: $20353e9e716518d0$export$e4b2ac9215619f8d
};

});

parcelRegister("6Eu1X", function(module, exports) {

$parcel$export(module.exports, "iterations", () => iterations);
$parcel$export(module.exports, "init", () => init);
$parcel$export(module.exports, "forward", () => forward);
$parcel$export(module.exports, "inverse", () => inverse);
$parcel$export(module.exports, "names", () => names);
$parcel$export(module.exports, "default", () => $4d7dc5ed367b221e$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");
var iterations = 1;
function init() {
    this.A = [];
    this.A[1] = 0.6399175073;
    this.A[2] = -0.1358797613;
    this.A[3] = 0.063294409;
    this.A[4] = -0.02526853;
    this.A[5] = 0.0117879;
    this.A[6] = -0.0055161;
    this.A[7] = 0.0026906;
    this.A[8] = -0.001333;
    this.A[9] = 0.00067;
    this.A[10] = -0.00034;
    this.B_re = [];
    this.B_im = [];
    this.B_re[1] = 0.7557853228;
    this.B_im[1] = 0;
    this.B_re[2] = 0.249204646;
    this.B_im[2] = 0.003371507;
    this.B_re[3] = -0.001541739;
    this.B_im[3] = 0.041058560;
    this.B_re[4] = -0.10162907;
    this.B_im[4] = 0.01727609;
    this.B_re[5] = -0.26623489;
    this.B_im[5] = -0.36249218;
    this.B_re[6] = -0.6870983;
    this.B_im[6] = -1.1651967;
    this.C_re = [];
    this.C_im = [];
    this.C_re[1] = 1.3231270439;
    this.C_im[1] = 0;
    this.C_re[2] = -0.577245789;
    this.C_im[2] = -0.007809598;
    this.C_re[3] = 0.508307513;
    this.C_im[3] = -0.112208952;
    this.C_re[4] = -0.15094762;
    this.C_im[4] = 0.18200602;
    this.C_re[5] = 1.01418179;
    this.C_im[5] = 1.64497696;
    this.C_re[6] = 1.9660549;
    this.C_im[6] = 2.5127645;
    this.D = [];
    this.D[1] = 1.5627014243;
    this.D[2] = 0.5185406398;
    this.D[3] = -0.03333098;
    this.D[4] = -0.1052906;
    this.D[5] = -0.0368594;
    this.D[6] = 0.007317;
    this.D[7] = 0.01220;
    this.D[8] = 0.00394;
    this.D[9] = -0.0013;
}
function forward(p) {
    var n;
    var lon = p.x;
    var lat = p.y;
    var delta_lat = lat - this.lat0;
    var delta_lon = lon - this.long0;
    // 1. Calculate d_phi and d_psi    ...                          // and d_lambda
    // For this algorithm, delta_latitude is in seconds of arc x 10-5, so we need to scale to those units. Longitude is radians.
    var d_phi = delta_lat / (0, $gyVUi.SEC_TO_RAD) * 1E-5;
    var d_lambda = delta_lon;
    var d_phi_n = 1; // d_phi^0
    var d_psi = 0;
    for(n = 1; n <= 10; n++){
        d_phi_n = d_phi_n * d_phi;
        d_psi = d_psi + this.A[n] * d_phi_n;
    }
    // 2. Calculate theta
    var th_re = d_psi;
    var th_im = d_lambda;
    // 3. Calculate z
    var th_n_re = 1;
    var th_n_im = 0; // theta^0
    var th_n_re1;
    var th_n_im1;
    var z_re = 0;
    var z_im = 0;
    for(n = 1; n <= 6; n++){
        th_n_re1 = th_n_re * th_re - th_n_im * th_im;
        th_n_im1 = th_n_im * th_re + th_n_re * th_im;
        th_n_re = th_n_re1;
        th_n_im = th_n_im1;
        z_re = z_re + this.B_re[n] * th_n_re - this.B_im[n] * th_n_im;
        z_im = z_im + this.B_im[n] * th_n_re + this.B_re[n] * th_n_im;
    }
    // 4. Calculate easting and northing
    p.x = z_im * this.a + this.x0;
    p.y = z_re * this.a + this.y0;
    return p;
}
function inverse(p) {
    var n;
    var x = p.x;
    var y = p.y;
    var delta_x = x - this.x0;
    var delta_y = y - this.y0;
    // 1. Calculate z
    var z_re = delta_y / this.a;
    var z_im = delta_x / this.a;
    // 2a. Calculate theta - first approximation gives km accuracy
    var z_n_re = 1;
    var z_n_im = 0; // z^0
    var z_n_re1;
    var z_n_im1;
    var th_re = 0;
    var th_im = 0;
    for(n = 1; n <= 6; n++){
        z_n_re1 = z_n_re * z_re - z_n_im * z_im;
        z_n_im1 = z_n_im * z_re + z_n_re * z_im;
        z_n_re = z_n_re1;
        z_n_im = z_n_im1;
        th_re = th_re + this.C_re[n] * z_n_re - this.C_im[n] * z_n_im;
        th_im = th_im + this.C_im[n] * z_n_re + this.C_re[n] * z_n_im;
    }
    // 2b. Iterate to refine the accuracy of the calculation
    //        0 iterations gives km accuracy
    //        1 iteration gives m accuracy -- good enough for most mapping applications
    //        2 iterations bives mm accuracy
    for(var i = 0; i < this.iterations; i++){
        var th_n_re = th_re;
        var th_n_im = th_im;
        var th_n_re1;
        var th_n_im1;
        var num_re = z_re;
        var num_im = z_im;
        for(n = 2; n <= 6; n++){
            th_n_re1 = th_n_re * th_re - th_n_im * th_im;
            th_n_im1 = th_n_im * th_re + th_n_re * th_im;
            th_n_re = th_n_re1;
            th_n_im = th_n_im1;
            num_re = num_re + (n - 1) * (this.B_re[n] * th_n_re - this.B_im[n] * th_n_im);
            num_im = num_im + (n - 1) * (this.B_im[n] * th_n_re + this.B_re[n] * th_n_im);
        }
        th_n_re = 1;
        th_n_im = 0;
        var den_re = this.B_re[1];
        var den_im = this.B_im[1];
        for(n = 2; n <= 6; n++){
            th_n_re1 = th_n_re * th_re - th_n_im * th_im;
            th_n_im1 = th_n_im * th_re + th_n_re * th_im;
            th_n_re = th_n_re1;
            th_n_im = th_n_im1;
            den_re = den_re + n * (this.B_re[n] * th_n_re - this.B_im[n] * th_n_im);
            den_im = den_im + n * (this.B_im[n] * th_n_re + this.B_re[n] * th_n_im);
        }
        // Complex division
        var den2 = den_re * den_re + den_im * den_im;
        th_re = (num_re * den_re + num_im * den_im) / den2;
        th_im = (num_im * den_re - num_re * den_im) / den2;
    }
    // 3. Calculate d_phi              ...                                    // and d_lambda
    var d_psi = th_re;
    var d_lambda = th_im;
    var d_psi_n = 1; // d_psi^0
    var d_phi = 0;
    for(n = 1; n <= 9; n++){
        d_psi_n = d_psi_n * d_psi;
        d_phi = d_phi + this.D[n] * d_psi_n;
    }
    // 4. Calculate latitude and longitude
    // d_phi is calcuated in second of arc * 10^-5, so we need to scale back to radians. d_lambda is in radians.
    var lat = this.lat0 + d_phi * (0, $gyVUi.SEC_TO_RAD) * 1E5;
    var lon = this.long0 + d_lambda;
    p.x = lon;
    p.y = lat;
    return p;
}
var names = [
    'New_Zealand_Map_Grid',
    'nzmg'
];
var $4d7dc5ed367b221e$export$2e2bcd8739ae039 = {
    init: init,
    forward: forward,
    inverse: inverse,
    names: names
};

});

parcelRegister("fpjAW", function(module, exports) {

$parcel$export(module.exports, "default", () => $b37863f65bf2a2a4$export$2e2bcd8739ae039);

var $a9oRf = parcelRequire("a9oRf");
function $b37863f65bf2a2a4$export$2cd8252107eb640b() {
// no-op
}
function $b37863f65bf2a2a4$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
      ----------------- */ var dlon = (0, $a9oRf.default)(lon - this.long0, this.over);
    var x = this.x0 + this.a * dlon;
    var y = this.y0 + this.a * Math.log(Math.tan(Math.PI / 4 + lat / 2.5)) * 1.25;
    p.x = x;
    p.y = y;
    return p;
}
function $b37863f65bf2a2a4$export$70ae2c07e401031b(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var lon = (0, $a9oRf.default)(this.long0 + p.x / this.a, this.over);
    var lat = 2.5 * (Math.atan(Math.exp(0.8 * p.y / this.a)) - Math.PI / 4);
    p.x = lon;
    p.y = lat;
    return p;
}
var $b37863f65bf2a2a4$export$e4b2ac9215619f8d = [
    'Miller_Cylindrical',
    'mill'
];
var $b37863f65bf2a2a4$export$2e2bcd8739ae039 = {
    init: $b37863f65bf2a2a4$export$2cd8252107eb640b,
    forward: $b37863f65bf2a2a4$export$174bb771924e7eb1,
    inverse: $b37863f65bf2a2a4$export$70ae2c07e401031b,
    names: $b37863f65bf2a2a4$export$e4b2ac9215619f8d
};

});

parcelRegister("eA4Bc", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9d7febe7a8566f2$export$2e2bcd8739ae039);

var $a9oRf = parcelRequire("a9oRf");

var $aDUFA = parcelRequire("aDUFA");

var $gqKpL = parcelRequire("gqKpL");

var $hpUQm = parcelRequire("hpUQm");

var $jQUK6 = parcelRequire("jQUK6");

var $gyVUi = parcelRequire("gyVUi");

var $ljPJJ = parcelRequire("ljPJJ");
var $a9d7febe7a8566f2$var$MAX_ITER = 20;
function $a9d7febe7a8566f2$export$2cd8252107eb640b() {
    /* Place parameters in static storage for common use
    ------------------------------------------------- */ if (!this.sphere) this.en = (0, $gqKpL.default)(this.es);
    else {
        this.n = 1;
        this.m = 0;
        this.es = 0;
        this.C_y = Math.sqrt((this.m + 1) / this.n);
        this.C_x = this.C_y / (this.m + 1);
    }
}
function $a9d7febe7a8566f2$export$174bb771924e7eb1(p) {
    var x, y;
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
    ----------------- */ lon = (0, $a9oRf.default)(lon - this.long0, this.over);
    if (this.sphere) {
        if (!this.m) lat = this.n !== 1 ? Math.asin(this.n * Math.sin(lat)) : lat;
        else {
            var k = this.n * Math.sin(lat);
            for(var i = $a9d7febe7a8566f2$var$MAX_ITER; i; --i){
                var V = (this.m * lat + Math.sin(lat) - k) / (this.m + Math.cos(lat));
                lat -= V;
                if (Math.abs(V) < (0, $gyVUi.EPSLN)) break;
            }
        }
        x = this.a * this.C_x * lon * (this.m + Math.cos(lat));
        y = this.a * this.C_y * lat;
    } else {
        var s = Math.sin(lat);
        var c = Math.cos(lat);
        y = this.a * (0, $hpUQm.default)(lat, s, c, this.en);
        x = this.a * lon * c / Math.sqrt(1 - this.es * s * s);
    }
    p.x = x;
    p.y = y;
    return p;
}
function $a9d7febe7a8566f2$export$70ae2c07e401031b(p) {
    var lat, temp, lon, s;
    p.x -= this.x0;
    lon = p.x / this.a;
    p.y -= this.y0;
    lat = p.y / this.a;
    if (this.sphere) {
        lat /= this.C_y;
        lon = lon / (this.C_x * (this.m + Math.cos(lat)));
        if (this.m) lat = (0, $ljPJJ.default)((this.m * lat + Math.sin(lat)) / this.n);
        else if (this.n !== 1) lat = (0, $ljPJJ.default)(Math.sin(lat) / this.n);
        lon = (0, $a9oRf.default)(lon + this.long0, this.over);
        lat = (0, $aDUFA.default)(lat);
    } else {
        lat = (0, $jQUK6.default)(p.y / this.a, this.es, this.en);
        s = Math.abs(lat);
        if (s < (0, $gyVUi.HALF_PI)) {
            s = Math.sin(lat);
            temp = this.long0 + p.x * Math.sqrt(1 - this.es * s * s) / (this.a * Math.cos(lat));
            // temp = this.long0 + p.x / (this.a * Math.cos(lat));
            lon = (0, $a9oRf.default)(temp, this.over);
        } else if (s - (0, $gyVUi.EPSLN) < (0, $gyVUi.HALF_PI)) lon = this.long0;
    }
    p.x = lon;
    p.y = lat;
    return p;
}
var $a9d7febe7a8566f2$export$e4b2ac9215619f8d = [
    'Sinusoidal',
    'sinu'
];
var $a9d7febe7a8566f2$export$2e2bcd8739ae039 = {
    init: $a9d7febe7a8566f2$export$2cd8252107eb640b,
    forward: $a9d7febe7a8566f2$export$174bb771924e7eb1,
    inverse: $a9d7febe7a8566f2$export$70ae2c07e401031b,
    names: $a9d7febe7a8566f2$export$e4b2ac9215619f8d
};

});

parcelRegister("7uCfv", function(module, exports) {

$parcel$export(module.exports, "default", () => $57490138fba0a0b8$export$2e2bcd8739ae039);

var $a9oRf = parcelRequire("a9oRf");

var $gyVUi = parcelRequire("gyVUi");
function $57490138fba0a0b8$export$2cd8252107eb640b() {
    this.x0 = this.x0 !== undefined ? this.x0 : 0;
    this.y0 = this.y0 !== undefined ? this.y0 : 0;
    this.long0 = this.long0 !== undefined ? this.long0 : 0;
}
function $57490138fba0a0b8$export$174bb771924e7eb1(p) {
    /* Forward equations
      ----------------- */ var lon = p.x;
    var lat = p.y;
    var delta_lon = (0, $a9oRf.default)(lon - this.long0, this.over);
    var theta = lat;
    var con = Math.PI * Math.sin(lat);
    /* Iterate using the Newton-Raphson method to find theta
      ----------------------------------------------------- */ while(true){
        var delta_theta = -(theta + Math.sin(theta) - con) / (1 + Math.cos(theta));
        theta += delta_theta;
        if (Math.abs(delta_theta) < (0, $gyVUi.EPSLN)) break;
    }
    theta /= 2;
    /* If the latitude is 90 deg, force the x coordinate to be "0 + false easting"
       this is done here because of precision problems with "cos(theta)"
       -------------------------------------------------------------------------- */ if (Math.PI / 2 - Math.abs(lat) < (0, $gyVUi.EPSLN)) delta_lon = 0;
    var x = 0.900316316158 * this.a * delta_lon * Math.cos(theta) + this.x0;
    var y = 1.4142135623731 * this.a * Math.sin(theta) + this.y0;
    p.x = x;
    p.y = y;
    return p;
}
function $57490138fba0a0b8$export$70ae2c07e401031b(p) {
    var theta;
    var arg;
    /* Inverse equations
      ----------------- */ p.x -= this.x0;
    p.y -= this.y0;
    arg = p.y / (1.4142135623731 * this.a);
    /* Because of division by zero problems, 'arg' can not be 1.  Therefore
       a number very close to one is used instead.
       ------------------------------------------------------------------- */ if (Math.abs(arg) > 0.999999999999) arg = 0.999999999999;
    theta = Math.asin(arg);
    var lon = (0, $a9oRf.default)(this.long0 + p.x / (0.900316316158 * this.a * Math.cos(theta)), this.over);
    if (lon < -Math.PI) lon = -Math.PI;
    if (lon > Math.PI) lon = Math.PI;
    arg = (2 * theta + Math.sin(2 * theta)) / Math.PI;
    if (Math.abs(arg) > 1) arg = 1;
    var lat = Math.asin(arg);
    p.x = lon;
    p.y = lat;
    return p;
}
var $57490138fba0a0b8$export$e4b2ac9215619f8d = [
    'Mollweide',
    'moll'
];
var $57490138fba0a0b8$export$2e2bcd8739ae039 = {
    init: $57490138fba0a0b8$export$2cd8252107eb640b,
    forward: $57490138fba0a0b8$export$174bb771924e7eb1,
    inverse: $57490138fba0a0b8$export$70ae2c07e401031b,
    names: $57490138fba0a0b8$export$e4b2ac9215619f8d
};

});

parcelRegister("hp0oy", function(module, exports) {

$parcel$export(module.exports, "default", () => $cab513e7d920927e$export$2e2bcd8739ae039);

var $bWC4D = parcelRequire("bWC4D");

var $hU8aC = parcelRequire("hU8aC");

var $i9r9A = parcelRequire("i9r9A");

var $bM0eI = parcelRequire("bM0eI");

var $bi5ZC = parcelRequire("bi5ZC");

var $f3cKo = parcelRequire("f3cKo");

var $a9oRf = parcelRequire("a9oRf");

var $aDUFA = parcelRequire("aDUFA");

var $cfNuL = parcelRequire("cfNuL");

var $gyVUi = parcelRequire("gyVUi");
function $cab513e7d920927e$export$2cd8252107eb640b() {
    /* Place parameters in static storage for common use
      ------------------------------------------------- */ // Standard Parallels cannot be equal and on opposite sides of the equator
    if (Math.abs(this.lat1 + this.lat2) < (0, $gyVUi.EPSLN)) return;
    this.lat2 = this.lat2 || this.lat1;
    this.temp = this.b / this.a;
    this.es = 1 - Math.pow(this.temp, 2);
    this.e = Math.sqrt(this.es);
    this.e0 = (0, $bWC4D.default)(this.es);
    this.e1 = (0, $hU8aC.default)(this.es);
    this.e2 = (0, $i9r9A.default)(this.es);
    this.e3 = (0, $bM0eI.default)(this.es);
    this.sin_phi = Math.sin(this.lat1);
    this.cos_phi = Math.cos(this.lat1);
    this.ms1 = (0, $bi5ZC.default)(this.e, this.sin_phi, this.cos_phi);
    this.ml1 = (0, $f3cKo.default)(this.e0, this.e1, this.e2, this.e3, this.lat1);
    if (Math.abs(this.lat1 - this.lat2) < (0, $gyVUi.EPSLN)) this.ns = this.sin_phi;
    else {
        this.sin_phi = Math.sin(this.lat2);
        this.cos_phi = Math.cos(this.lat2);
        this.ms2 = (0, $bi5ZC.default)(this.e, this.sin_phi, this.cos_phi);
        this.ml2 = (0, $f3cKo.default)(this.e0, this.e1, this.e2, this.e3, this.lat2);
        this.ns = (this.ms1 - this.ms2) / (this.ml2 - this.ml1);
    }
    this.g = this.ml1 + this.ms1 / this.ns;
    this.ml0 = (0, $f3cKo.default)(this.e0, this.e1, this.e2, this.e3, this.lat0);
    this.rh = this.a * (this.g - this.ml0);
}
function $cab513e7d920927e$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var rh1;
    /* Forward equations
      ----------------- */ if (this.sphere) rh1 = this.a * (this.g - lat);
    else {
        var ml = (0, $f3cKo.default)(this.e0, this.e1, this.e2, this.e3, lat);
        rh1 = this.a * (this.g - ml);
    }
    var theta = this.ns * (0, $a9oRf.default)(lon - this.long0, this.over);
    var x = this.x0 + rh1 * Math.sin(theta);
    var y = this.y0 + this.rh - rh1 * Math.cos(theta);
    p.x = x;
    p.y = y;
    return p;
}
function $cab513e7d920927e$export$70ae2c07e401031b(p) {
    p.x -= this.x0;
    p.y = this.rh - p.y + this.y0;
    var con, rh1, lat, lon;
    if (this.ns >= 0) {
        rh1 = Math.sqrt(p.x * p.x + p.y * p.y);
        con = 1;
    } else {
        rh1 = -Math.sqrt(p.x * p.x + p.y * p.y);
        con = -1;
    }
    var theta = 0;
    if (rh1 !== 0) theta = Math.atan2(con * p.x, con * p.y);
    if (this.sphere) {
        lon = (0, $a9oRf.default)(this.long0 + theta / this.ns, this.over);
        lat = (0, $aDUFA.default)(this.g - rh1 / this.a);
        p.x = lon;
        p.y = lat;
        return p;
    } else {
        var ml = this.g - rh1 / this.a;
        lat = (0, $cfNuL.default)(ml, this.e0, this.e1, this.e2, this.e3);
        lon = (0, $a9oRf.default)(this.long0 + theta / this.ns, this.over);
        p.x = lon;
        p.y = lat;
        return p;
    }
}
var $cab513e7d920927e$export$e4b2ac9215619f8d = [
    'Equidistant_Conic',
    'eqdc'
];
var $cab513e7d920927e$export$2e2bcd8739ae039 = {
    init: $cab513e7d920927e$export$2cd8252107eb640b,
    forward: $cab513e7d920927e$export$174bb771924e7eb1,
    inverse: $cab513e7d920927e$export$70ae2c07e401031b,
    names: $cab513e7d920927e$export$e4b2ac9215619f8d
};

});

parcelRegister("1W450", function(module, exports) {

$parcel$export(module.exports, "default", () => $168e5f6524a6fc5f$export$2e2bcd8739ae039);

var $a9oRf = parcelRequire("a9oRf");

var $gyVUi = parcelRequire("gyVUi");

var $ljPJJ = parcelRequire("ljPJJ");
function $168e5f6524a6fc5f$export$2cd8252107eb640b() {
    // this.R = 6370997; //Radius of earth
    this.R = this.a;
}
function $168e5f6524a6fc5f$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
    ----------------- */ var dlon = (0, $a9oRf.default)(lon - this.long0, this.over);
    var x, y;
    if (Math.abs(lat) <= (0, $gyVUi.EPSLN)) {
        x = this.x0 + this.R * dlon;
        y = this.y0;
    }
    var theta = (0, $ljPJJ.default)(2 * Math.abs(lat / Math.PI));
    if (Math.abs(dlon) <= (0, $gyVUi.EPSLN) || Math.abs(Math.abs(lat) - (0, $gyVUi.HALF_PI)) <= (0, $gyVUi.EPSLN)) {
        x = this.x0;
        if (lat >= 0) y = this.y0 + Math.PI * this.R * Math.tan(0.5 * theta);
        else y = this.y0 + Math.PI * this.R * -Math.tan(0.5 * theta);
    //  return(OK);
    }
    var al = 0.5 * Math.abs(Math.PI / dlon - dlon / Math.PI);
    var asq = al * al;
    var sinth = Math.sin(theta);
    var costh = Math.cos(theta);
    var g = costh / (sinth + costh - 1);
    var gsq = g * g;
    var m = g * (2 / sinth - 1);
    var msq = m * m;
    var con = Math.PI * this.R * (al * (g - msq) + Math.sqrt(asq * (g - msq) * (g - msq) - (msq + asq) * (gsq - msq))) / (msq + asq);
    if (dlon < 0) con = -con;
    x = this.x0 + con;
    // con = Math.abs(con / (Math.PI * this.R));
    var q = asq + g;
    con = Math.PI * this.R * (m * q - al * Math.sqrt((msq + asq) * (asq + 1) - q * q)) / (msq + asq);
    if (lat >= 0) // y = this.y0 + Math.PI * this.R * Math.sqrt(1 - con * con - 2 * al * con);
    y = this.y0 + con;
    else // y = this.y0 - Math.PI * this.R * Math.sqrt(1 - con * con - 2 * al * con);
    y = this.y0 - con;
    p.x = x;
    p.y = y;
    return p;
}
function $168e5f6524a6fc5f$export$70ae2c07e401031b(p) {
    var lon, lat;
    var xx, yy, xys, c1, c2, c3;
    var a1;
    var m1;
    var con;
    var th1;
    var d;
    /* inverse equations
    ----------------- */ p.x -= this.x0;
    p.y -= this.y0;
    con = Math.PI * this.R;
    xx = p.x / con;
    yy = p.y / con;
    xys = xx * xx + yy * yy;
    c1 = -Math.abs(yy) * (1 + xys);
    c2 = c1 - 2 * yy * yy + xx * xx;
    c3 = -2 * c1 + 1 + 2 * yy * yy + xys * xys;
    d = yy * yy / c3 + (2 * c2 * c2 * c2 / c3 / c3 / c3 - 9 * c1 * c2 / c3 / c3) / 27;
    a1 = (c1 - c2 * c2 / 3 / c3) / c3;
    m1 = 2 * Math.sqrt(-a1 / 3);
    con = 3 * d / a1 / m1;
    if (Math.abs(con) > 1) {
        if (con >= 0) con = 1;
        else con = -1;
    }
    th1 = Math.acos(con) / 3;
    if (p.y >= 0) lat = (-m1 * Math.cos(th1 + Math.PI / 3) - c2 / 3 / c3) * Math.PI;
    else lat = -(-m1 * Math.cos(th1 + Math.PI / 3) - c2 / 3 / c3) * Math.PI;
    if (Math.abs(xx) < (0, $gyVUi.EPSLN)) lon = this.long0;
    else lon = (0, $a9oRf.default)(this.long0 + Math.PI * (xys - 1 + Math.sqrt(1 + 2 * (xx * xx - yy * yy) + xys * xys)) / 2 / xx, this.over);
    p.x = lon;
    p.y = lat;
    return p;
}
var $168e5f6524a6fc5f$export$e4b2ac9215619f8d = [
    'Van_der_Grinten_I',
    'VanDerGrinten',
    'Van_der_Grinten',
    'vandg'
];
var $168e5f6524a6fc5f$export$2e2bcd8739ae039 = {
    init: $168e5f6524a6fc5f$export$2cd8252107eb640b,
    forward: $168e5f6524a6fc5f$export$174bb771924e7eb1,
    inverse: $168e5f6524a6fc5f$export$70ae2c07e401031b,
    names: $168e5f6524a6fc5f$export$e4b2ac9215619f8d
};

});

parcelRegister("i6dz6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2d34f4dbda3af26$export$2e2bcd8739ae039);

var $a9oRf = parcelRequire("a9oRf");

var $gyVUi = parcelRequire("gyVUi");

var $f3cKo = parcelRequire("f3cKo");

var $bWC4D = parcelRequire("bWC4D");

var $hU8aC = parcelRequire("hU8aC");

var $i9r9A = parcelRequire("i9r9A");

var $bM0eI = parcelRequire("bM0eI");

var $ljPJJ = parcelRequire("ljPJJ");

var $cfNuL = parcelRequire("cfNuL");

var $7StUg = parcelRequire("7StUg");
function $d2d34f4dbda3af26$export$2cd8252107eb640b() {
    this.sin_p12 = Math.sin(this.lat0);
    this.cos_p12 = Math.cos(this.lat0);
    // flattening for ellipsoid
    this.f = this.es / (1 + Math.sqrt(1 - this.es));
}
function $d2d34f4dbda3af26$export$174bb771924e7eb1(p) {
    var lon = p.x;
    var lat = p.y;
    var sinphi = Math.sin(p.y);
    var cosphi = Math.cos(p.y);
    var dlon = (0, $a9oRf.default)(lon - this.long0, this.over);
    var e0, e1, e2, e3, Mlp, Ml, c, kp, cos_c, vars, azi1;
    if (this.sphere) {
        if (Math.abs(this.sin_p12 - 1) <= (0, $gyVUi.EPSLN)) {
            // North Pole case
            p.x = this.x0 + this.a * ((0, $gyVUi.HALF_PI) - lat) * Math.sin(dlon);
            p.y = this.y0 - this.a * ((0, $gyVUi.HALF_PI) - lat) * Math.cos(dlon);
            return p;
        } else if (Math.abs(this.sin_p12 + 1) <= (0, $gyVUi.EPSLN)) {
            // South Pole case
            p.x = this.x0 + this.a * ((0, $gyVUi.HALF_PI) + lat) * Math.sin(dlon);
            p.y = this.y0 + this.a * ((0, $gyVUi.HALF_PI) + lat) * Math.cos(dlon);
            return p;
        } else {
            // default case
            cos_c = this.sin_p12 * sinphi + this.cos_p12 * cosphi * Math.cos(dlon);
            c = Math.acos(cos_c);
            kp = c ? c / Math.sin(c) : 1;
            p.x = this.x0 + this.a * kp * cosphi * Math.sin(dlon);
            p.y = this.y0 + this.a * kp * (this.cos_p12 * sinphi - this.sin_p12 * cosphi * Math.cos(dlon));
            return p;
        }
    } else {
        e0 = (0, $bWC4D.default)(this.es);
        e1 = (0, $hU8aC.default)(this.es);
        e2 = (0, $i9r9A.default)(this.es);
        e3 = (0, $bM0eI.default)(this.es);
        if (Math.abs(this.sin_p12 - 1) <= (0, $gyVUi.EPSLN)) {
            // North Pole case
            Mlp = this.a * (0, $f3cKo.default)(e0, e1, e2, e3, (0, $gyVUi.HALF_PI));
            Ml = this.a * (0, $f3cKo.default)(e0, e1, e2, e3, lat);
            p.x = this.x0 + (Mlp - Ml) * Math.sin(dlon);
            p.y = this.y0 - (Mlp - Ml) * Math.cos(dlon);
            return p;
        } else if (Math.abs(this.sin_p12 + 1) <= (0, $gyVUi.EPSLN)) {
            // South Pole case
            Mlp = this.a * (0, $f3cKo.default)(e0, e1, e2, e3, (0, $gyVUi.HALF_PI));
            Ml = this.a * (0, $f3cKo.default)(e0, e1, e2, e3, lat);
            p.x = this.x0 + (Mlp + Ml) * Math.sin(dlon);
            p.y = this.y0 + (Mlp + Ml) * Math.cos(dlon);
            return p;
        } else {
            // Default case
            if (Math.abs(lon) < (0, $gyVUi.EPSLN) && Math.abs(lat - this.lat0) < (0, $gyVUi.EPSLN)) {
                p.x = p.y = 0;
                return p;
            }
            vars = (0, $7StUg.vincentyInverse)(this.lat0, this.long0, lat, lon, this.a, this.f);
            azi1 = vars.azi1;
            p.x = vars.s12 * Math.sin(azi1);
            p.y = vars.s12 * Math.cos(azi1);
            return p;
        }
    }
}
function $d2d34f4dbda3af26$export$70ae2c07e401031b(p) {
    p.x -= this.x0;
    p.y -= this.y0;
    var rh, z, sinz, cosz, lon, lat, con, e0, e1, e2, e3, Mlp, M, azi1, s12, vars;
    if (this.sphere) {
        rh = Math.sqrt(p.x * p.x + p.y * p.y);
        if (rh > 2 * (0, $gyVUi.HALF_PI) * this.a) return;
        z = rh / this.a;
        sinz = Math.sin(z);
        cosz = Math.cos(z);
        lon = this.long0;
        if (Math.abs(rh) <= (0, $gyVUi.EPSLN)) lat = this.lat0;
        else {
            lat = (0, $ljPJJ.default)(cosz * this.sin_p12 + p.y * sinz * this.cos_p12 / rh);
            con = Math.abs(this.lat0) - (0, $gyVUi.HALF_PI);
            if (Math.abs(con) <= (0, $gyVUi.EPSLN)) {
                if (this.lat0 >= 0) lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x, -p.y), this.over);
                else lon = (0, $a9oRf.default)(this.long0 - Math.atan2(-p.x, p.y), this.over);
            } else lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x * sinz, rh * this.cos_p12 * cosz - p.y * this.sin_p12 * sinz), this.over);
        }
        p.x = lon;
        p.y = lat;
        return p;
    } else {
        e0 = (0, $bWC4D.default)(this.es);
        e1 = (0, $hU8aC.default)(this.es);
        e2 = (0, $i9r9A.default)(this.es);
        e3 = (0, $bM0eI.default)(this.es);
        if (Math.abs(this.sin_p12 - 1) <= (0, $gyVUi.EPSLN)) {
            // North pole case
            Mlp = this.a * (0, $f3cKo.default)(e0, e1, e2, e3, (0, $gyVUi.HALF_PI));
            rh = Math.sqrt(p.x * p.x + p.y * p.y);
            M = Mlp - rh;
            lat = (0, $cfNuL.default)(M / this.a, e0, e1, e2, e3);
            lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x, -1 * p.y), this.over);
            p.x = lon;
            p.y = lat;
            return p;
        } else if (Math.abs(this.sin_p12 + 1) <= (0, $gyVUi.EPSLN)) {
            // South pole case
            Mlp = this.a * (0, $f3cKo.default)(e0, e1, e2, e3, (0, $gyVUi.HALF_PI));
            rh = Math.sqrt(p.x * p.x + p.y * p.y);
            M = rh - Mlp;
            lat = (0, $cfNuL.default)(M / this.a, e0, e1, e2, e3);
            lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x, p.y), this.over);
            p.x = lon;
            p.y = lat;
            return p;
        } else {
            // default case
            azi1 = Math.atan2(p.x, p.y);
            s12 = Math.sqrt(p.x * p.x + p.y * p.y);
            vars = (0, $7StUg.vincentyDirect)(this.lat0, this.long0, azi1, s12, this.a, this.f);
            p.x = vars.lon2;
            p.y = vars.lat2;
            return p;
        }
    }
}
var $d2d34f4dbda3af26$export$e4b2ac9215619f8d = [
    'Azimuthal_Equidistant',
    'aeqd'
];
var $d2d34f4dbda3af26$export$2e2bcd8739ae039 = {
    init: $d2d34f4dbda3af26$export$2cd8252107eb640b,
    forward: $d2d34f4dbda3af26$export$174bb771924e7eb1,
    inverse: $d2d34f4dbda3af26$export$70ae2c07e401031b,
    names: $d2d34f4dbda3af26$export$e4b2ac9215619f8d
};

});
parcelRegister("7StUg", function(module, exports) {

$parcel$export(module.exports, "vincentyInverse", () => $5bc4c6541701a39b$export$56278523bd130841);
$parcel$export(module.exports, "vincentyDirect", () => $5bc4c6541701a39b$export$b5a922c94102a306);
/**
 * Calculates the inverse geodesic problem using Vincenty's formulae.
 * Computes the forward azimuth and ellipsoidal distance between two points
 * specified by latitude and longitude on the surface of an ellipsoid.
 *
 * @param {number} lat1 Latitude of the first point in radians.
 * @param {number} lon1 Longitude of the first point in radians.
 * @param {number} lat2 Latitude of the second point in radians.
 * @param {number} lon2 Longitude of the second point in radians.
 * @param {number} a Semi-major axis of the ellipsoid (meters).
 * @param {number} f Flattening of the ellipsoid.
 * @returns {{ azi1: number, s12: number }} An object containing:
 *   - azi1: Forward azimuth from the first point to the second point (radians).
 *   - s12: Ellipsoidal distance between the two points (meters).
 */ function $5bc4c6541701a39b$export$56278523bd130841(lat1, lon1, lat2, lon2, a, f) {
    const L = lon2 - lon1;
    const U1 = Math.atan((1 - f) * Math.tan(lat1));
    const U2 = Math.atan((1 - f) * Math.tan(lat2));
    const sinU1 = Math.sin(U1), cosU1 = Math.cos(U1);
    const sinU2 = Math.sin(U2), cosU2 = Math.cos(U2);
    let lambda = L, lambdaP, iterLimit = 100;
    let sinLambda, cosLambda, sinSigma, cosSigma, sigma, sinAlpha, cos2Alpha, cos2SigmaM, C;
    let uSq, A, B, deltaSigma, s;
    do {
        sinLambda = Math.sin(lambda);
        cosLambda = Math.cos(lambda);
        sinSigma = Math.sqrt(cosU2 * sinLambda * (cosU2 * sinLambda) + (cosU1 * sinU2 - sinU1 * cosU2 * cosLambda) * (cosU1 * sinU2 - sinU1 * cosU2 * cosLambda));
        if (sinSigma === 0) return {
            azi1: 0,
            s12: 0
        }; // coincident points
        cosSigma = sinU1 * sinU2 + cosU1 * cosU2 * cosLambda;
        sigma = Math.atan2(sinSigma, cosSigma);
        sinAlpha = cosU1 * cosU2 * sinLambda / sinSigma;
        cos2Alpha = 1 - sinAlpha * sinAlpha;
        cos2SigmaM = cos2Alpha !== 0 ? cosSigma - 2 * sinU1 * sinU2 / cos2Alpha : 0;
        C = f / 16 * cos2Alpha * (4 + f * (4 - 3 * cos2Alpha));
        lambdaP = lambda;
        lambda = L + (1 - C) * f * sinAlpha * (sigma + C * sinSigma * (cos2SigmaM + C * cosSigma * (-1 + 2 * cos2SigmaM * cos2SigmaM)));
    }while (Math.abs(lambda - lambdaP) > 1e-12 && --iterLimit > 0);
    if (iterLimit === 0) return {
        azi1: NaN,
        s12: NaN
    }; // formula failed to converge
    uSq = cos2Alpha * (a * a - a * (1 - f) * (a * (1 - f))) / (a * (1 - f) * (a * (1 - f)));
    A = 1 + uSq / 16384 * (4096 + uSq * (-768 + uSq * (320 - 175 * uSq)));
    B = uSq / 1024 * (256 + uSq * (-128 + uSq * (74 - 47 * uSq)));
    deltaSigma = B * sinSigma * (cos2SigmaM + B / 4 * (cosSigma * (-1 + 2 * cos2SigmaM * cos2SigmaM) - B / 6 * cos2SigmaM * (-3 + 4 * sinSigma * sinSigma) * (-3 + 4 * cos2SigmaM * cos2SigmaM)));
    s = a * (1 - f) * A * (sigma - deltaSigma);
    // Forward azimuth
    const azi1 = Math.atan2(cosU2 * sinLambda, cosU1 * sinU2 - sinU1 * cosU2 * cosLambda);
    return {
        azi1: azi1,
        s12: s
    };
}
function $5bc4c6541701a39b$export$b5a922c94102a306(lat1, lon1, azi1, s12, a, f) {
    const U1 = Math.atan((1 - f) * Math.tan(lat1));
    const sinU1 = Math.sin(U1), cosU1 = Math.cos(U1);
    const sinAlpha1 = Math.sin(azi1), cosAlpha1 = Math.cos(azi1);
    const sigma1 = Math.atan2(sinU1, cosU1 * cosAlpha1);
    const sinAlpha = cosU1 * sinAlpha1;
    const cos2Alpha = 1 - sinAlpha * sinAlpha;
    const uSq = cos2Alpha * (a * a - a * (1 - f) * (a * (1 - f))) / (a * (1 - f) * (a * (1 - f)));
    const A = 1 + uSq / 16384 * (4096 + uSq * (-768 + uSq * (320 - 175 * uSq)));
    const B = uSq / 1024 * (256 + uSq * (-128 + uSq * (74 - 47 * uSq)));
    let sigma = s12 / (a * (1 - f) * A), sigmaP, iterLimit = 100;
    let cos2SigmaM, sinSigma, cosSigma, deltaSigma;
    do {
        cos2SigmaM = Math.cos(2 * sigma1 + sigma);
        sinSigma = Math.sin(sigma);
        cosSigma = Math.cos(sigma);
        deltaSigma = B * sinSigma * (cos2SigmaM + B / 4 * (cosSigma * (-1 + 2 * cos2SigmaM * cos2SigmaM) - B / 6 * cos2SigmaM * (-3 + 4 * sinSigma * sinSigma) * (-3 + 4 * cos2SigmaM * cos2SigmaM)));
        sigmaP = sigma;
        sigma = s12 / (a * (1 - f) * A) + deltaSigma;
    }while (Math.abs(sigma - sigmaP) > 1e-12 && --iterLimit > 0);
    if (iterLimit === 0) return {
        lat2: NaN,
        lon2: NaN
    };
    const tmp = sinU1 * sinSigma - cosU1 * cosSigma * cosAlpha1;
    const lat2 = Math.atan2(sinU1 * cosSigma + cosU1 * sinSigma * cosAlpha1, (1 - f) * Math.sqrt(sinAlpha * sinAlpha + tmp * tmp));
    const lambda = Math.atan2(sinSigma * sinAlpha1, cosU1 * cosSigma - sinU1 * sinSigma * cosAlpha1);
    const C = f / 16 * cos2Alpha * (4 + f * (4 - 3 * cos2Alpha));
    const L = lambda - (1 - C) * f * sinAlpha * (sigma + C * sinSigma * (cos2SigmaM + C * cosSigma * (-1 + 2 * cos2SigmaM * cos2SigmaM)));
    const lon2 = lon1 + L;
    return {
        lat2: lat2,
        lon2: lon2
    };
}

});


parcelRegister("37G1n", function(module, exports) {

$parcel$export(module.exports, "default", () => $24629f153ebf2c1f$export$2e2bcd8739ae039);

var $a9oRf = parcelRequire("a9oRf");

var $ljPJJ = parcelRequire("ljPJJ");

var $gyVUi = parcelRequire("gyVUi");
function $24629f153ebf2c1f$export$2cd8252107eb640b() {
    // double temp;      /* temporary variable    */
    /* Place parameters in static storage for common use
      ------------------------------------------------- */ this.sin_p14 = Math.sin(this.lat0);
    this.cos_p14 = Math.cos(this.lat0);
}
function $24629f153ebf2c1f$export$174bb771924e7eb1(p) {
    var sinphi, cosphi; /* sin and cos value        */ 
    var dlon; /* delta longitude value      */ 
    var coslon; /* cos of longitude        */ 
    var ksp; /* scale factor          */ 
    var g, x, y;
    var lon = p.x;
    var lat = p.y;
    /* Forward equations
      ----------------- */ dlon = (0, $a9oRf.default)(lon - this.long0, this.over);
    sinphi = Math.sin(lat);
    cosphi = Math.cos(lat);
    coslon = Math.cos(dlon);
    g = this.sin_p14 * sinphi + this.cos_p14 * cosphi * coslon;
    ksp = 1;
    if (g > 0 || Math.abs(g) <= (0, $gyVUi.EPSLN)) {
        x = this.a * ksp * cosphi * Math.sin(dlon);
        y = this.y0 + this.a * ksp * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon);
    }
    p.x = x;
    p.y = y;
    return p;
}
function $24629f153ebf2c1f$export$70ae2c07e401031b(p) {
    var rh; /* height above ellipsoid      */ 
    var z; /* angle          */ 
    var sinz, cosz; /* sin of z and cos of z      */ 
    var con;
    var lon, lat;
    /* Inverse equations
      ----------------- */ p.x -= this.x0;
    p.y -= this.y0;
    rh = Math.sqrt(p.x * p.x + p.y * p.y);
    z = (0, $ljPJJ.default)(rh / this.a);
    sinz = Math.sin(z);
    cosz = Math.cos(z);
    lon = this.long0;
    if (Math.abs(rh) <= (0, $gyVUi.EPSLN)) {
        lat = this.lat0;
        p.x = lon;
        p.y = lat;
        return p;
    }
    lat = (0, $ljPJJ.default)(cosz * this.sin_p14 + p.y * sinz * this.cos_p14 / rh);
    con = Math.abs(this.lat0) - (0, $gyVUi.HALF_PI);
    if (Math.abs(con) <= (0, $gyVUi.EPSLN)) {
        if (this.lat0 >= 0) lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x, -p.y), this.over);
        else lon = (0, $a9oRf.default)(this.long0 - Math.atan2(-p.x, p.y), this.over);
        p.x = lon;
        p.y = lat;
        return p;
    }
    lon = (0, $a9oRf.default)(this.long0 + Math.atan2(p.x * sinz, rh * this.cos_p14 * cosz - p.y * this.sin_p14 * sinz), this.over);
    p.x = lon;
    p.y = lat;
    return p;
}
var $24629f153ebf2c1f$export$e4b2ac9215619f8d = [
    'ortho'
];
var $24629f153ebf2c1f$export$2e2bcd8739ae039 = {
    init: $24629f153ebf2c1f$export$2cd8252107eb640b,
    forward: $24629f153ebf2c1f$export$174bb771924e7eb1,
    inverse: $24629f153ebf2c1f$export$70ae2c07e401031b,
    names: $24629f153ebf2c1f$export$e4b2ac9215619f8d
};

});

parcelRegister("2XUb4", function(module, exports) {

$parcel$export(module.exports, "default", () => $228cab2632c5bcf7$export$2e2bcd8739ae039);
// QSC projection rewritten from the original PROJ4
// https://github.com/OSGeo/proj.4/blob/master/src/PJ_qsc.c

var $gyVUi = parcelRequire("gyVUi");
/**
 * @typedef {Object} LocalThis
 * @property {number} face
 * @property {number} x0
 * @property {number} y0
 * @property {number} es
 * @property {number} one_minus_f
 * @property {number} one_minus_f_squared
 */ /* constants */ var $228cab2632c5bcf7$var$FACE_ENUM = {
    FRONT: 1,
    RIGHT: 2,
    BACK: 3,
    LEFT: 4,
    TOP: 5,
    BOTTOM: 6
};
var $228cab2632c5bcf7$var$AREA_ENUM = {
    AREA_0: 1,
    AREA_1: 2,
    AREA_2: 3,
    AREA_3: 4
};
function $228cab2632c5bcf7$export$2cd8252107eb640b() {
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    this.lat0 = this.lat0 || 0;
    this.long0 = this.long0 || 0;
    this.lat_ts = this.lat_ts || 0;
    this.title = this.title || 'Quadrilateralized Spherical Cube';
    /* Determine the cube face from the center of projection. */ if (this.lat0 >= (0, $gyVUi.HALF_PI) - (0, $gyVUi.FORTPI) / 2.0) this.face = $228cab2632c5bcf7$var$FACE_ENUM.TOP;
    else if (this.lat0 <= -((0, $gyVUi.HALF_PI) - (0, $gyVUi.FORTPI) / 2.0)) this.face = $228cab2632c5bcf7$var$FACE_ENUM.BOTTOM;
    else if (Math.abs(this.long0) <= (0, $gyVUi.FORTPI)) this.face = $228cab2632c5bcf7$var$FACE_ENUM.FRONT;
    else if (Math.abs(this.long0) <= (0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI)) this.face = this.long0 > 0.0 ? $228cab2632c5bcf7$var$FACE_ENUM.RIGHT : $228cab2632c5bcf7$var$FACE_ENUM.LEFT;
    else this.face = $228cab2632c5bcf7$var$FACE_ENUM.BACK;
    /* Fill in useful values for the ellipsoid <-> sphere shift
   * described in [LK12]. */ if (this.es !== 0) {
        this.one_minus_f = 1 - (this.a - this.b) / this.a;
        this.one_minus_f_squared = this.one_minus_f * this.one_minus_f;
    }
}
function $228cab2632c5bcf7$export$174bb771924e7eb1(p) {
    var xy = {
        x: 0,
        y: 0
    };
    var lat, lon;
    var theta, phi;
    var t, mu;
    /* nu; */ var area = {
        value: 0
    };
    // move lon according to projection's lon
    p.x -= this.long0;
    /* Convert the geodetic latitude to a geocentric latitude.
   * This corresponds to the shift from the ellipsoid to the sphere
   * described in [LK12]. */ if (this.es !== 0) lat = Math.atan(this.one_minus_f_squared * Math.tan(p.y));
    else lat = p.y;
    /* Convert the input lat, lon into theta, phi as used by QSC.
   * This depends on the cube face and the area on it.
   * For the top and bottom face, we can compute theta and phi
   * directly from phi, lam. For the other faces, we must use
   * unit sphere cartesian coordinates as an intermediate step. */ lon = p.x; // lon = lp.lam;
    if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.TOP) {
        phi = (0, $gyVUi.HALF_PI) - lat;
        if (lon >= (0, $gyVUi.FORTPI) && lon <= (0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI)) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_0;
            theta = lon - (0, $gyVUi.HALF_PI);
        } else if (lon > (0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI) || lon <= -((0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI))) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_1;
            theta = lon > 0.0 ? lon - (0, $gyVUi.SPI) : lon + (0, $gyVUi.SPI);
        } else if (lon > -((0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI)) && lon <= -(0, $gyVUi.FORTPI)) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_2;
            theta = lon + (0, $gyVUi.HALF_PI);
        } else {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_3;
            theta = lon;
        }
    } else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.BOTTOM) {
        phi = (0, $gyVUi.HALF_PI) + lat;
        if (lon >= (0, $gyVUi.FORTPI) && lon <= (0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI)) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_0;
            theta = -lon + (0, $gyVUi.HALF_PI);
        } else if (lon < (0, $gyVUi.FORTPI) && lon >= -(0, $gyVUi.FORTPI)) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_1;
            theta = -lon;
        } else if (lon < -(0, $gyVUi.FORTPI) && lon >= -((0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI))) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_2;
            theta = -lon - (0, $gyVUi.HALF_PI);
        } else {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_3;
            theta = lon > 0.0 ? -lon + (0, $gyVUi.SPI) : -lon - (0, $gyVUi.SPI);
        }
    } else {
        var q, r, s;
        var sinlat, coslat;
        var sinlon, coslon;
        if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.RIGHT) lon = $228cab2632c5bcf7$var$qsc_shift_lon_origin(lon, +(0, $gyVUi.HALF_PI));
        else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.BACK) lon = $228cab2632c5bcf7$var$qsc_shift_lon_origin(lon, +(0, $gyVUi.SPI));
        else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.LEFT) lon = $228cab2632c5bcf7$var$qsc_shift_lon_origin(lon, -(0, $gyVUi.HALF_PI));
        sinlat = Math.sin(lat);
        coslat = Math.cos(lat);
        sinlon = Math.sin(lon);
        coslon = Math.cos(lon);
        q = coslat * coslon;
        r = coslat * sinlon;
        s = sinlat;
        if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.FRONT) {
            phi = Math.acos(q);
            theta = $228cab2632c5bcf7$var$qsc_fwd_equat_face_theta(phi, s, r, area);
        } else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.RIGHT) {
            phi = Math.acos(r);
            theta = $228cab2632c5bcf7$var$qsc_fwd_equat_face_theta(phi, s, -q, area);
        } else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.BACK) {
            phi = Math.acos(-q);
            theta = $228cab2632c5bcf7$var$qsc_fwd_equat_face_theta(phi, s, -r, area);
        } else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.LEFT) {
            phi = Math.acos(-r);
            theta = $228cab2632c5bcf7$var$qsc_fwd_equat_face_theta(phi, s, q, area);
        } else {
            /* Impossible */ phi = theta = 0;
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_0;
        }
    }
    /* Compute mu and nu for the area of definition.
   * For mu, see Eq. (3-21) in [OL76], but note the typos:
   * compare with Eq. (3-14). For nu, see Eq. (3-38). */ mu = Math.atan(12 / (0, $gyVUi.SPI) * (theta + Math.acos(Math.sin(theta) * Math.cos((0, $gyVUi.FORTPI))) - (0, $gyVUi.HALF_PI)));
    t = Math.sqrt((1 - Math.cos(phi)) / (Math.cos(mu) * Math.cos(mu)) / (1 - Math.cos(Math.atan(1 / Math.cos(theta)))));
    /* Apply the result to the real area. */ if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_1) mu += (0, $gyVUi.HALF_PI);
    else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_2) mu += (0, $gyVUi.SPI);
    else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_3) mu += 1.5 * (0, $gyVUi.SPI);
    /* Now compute x, y from mu and nu */ xy.x = t * Math.cos(mu);
    xy.y = t * Math.sin(mu);
    xy.x = xy.x * this.a + this.x0;
    xy.y = xy.y * this.a + this.y0;
    p.x = xy.x;
    p.y = xy.y;
    return p;
}
function $228cab2632c5bcf7$export$70ae2c07e401031b(p) {
    var lp = {
        lam: 0,
        phi: 0
    };
    var mu, nu, cosmu, tannu;
    var tantheta, theta, cosphi, phi;
    var t;
    var area = {
        value: 0
    };
    /* de-offset */ p.x = (p.x - this.x0) / this.a;
    p.y = (p.y - this.y0) / this.a;
    /* Convert the input x, y to the mu and nu angles as used by QSC.
   * This depends on the area of the cube face. */ nu = Math.atan(Math.sqrt(p.x * p.x + p.y * p.y));
    mu = Math.atan2(p.y, p.x);
    if (p.x >= 0.0 && p.x >= Math.abs(p.y)) area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_0;
    else if (p.y >= 0.0 && p.y >= Math.abs(p.x)) {
        area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_1;
        mu -= (0, $gyVUi.HALF_PI);
    } else if (p.x < 0.0 && -p.x >= Math.abs(p.y)) {
        area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_2;
        mu = mu < 0.0 ? mu + (0, $gyVUi.SPI) : mu - (0, $gyVUi.SPI);
    } else {
        area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_3;
        mu += (0, $gyVUi.HALF_PI);
    }
    /* Compute phi and theta for the area of definition.
   * The inverse projection is not described in the original paper, but some
   * good hints can be found here (as of 2011-12-14):
   * http://fits.gsfc.nasa.gov/fitsbits/saf.93/saf.9302
   * (search for "Message-Id: <9302181759.AA25477 at fits.cv.nrao.edu>") */ t = (0, $gyVUi.SPI) / 12 * Math.tan(mu);
    tantheta = Math.sin(t) / (Math.cos(t) - 1 / Math.sqrt(2));
    theta = Math.atan(tantheta);
    cosmu = Math.cos(mu);
    tannu = Math.tan(nu);
    cosphi = 1 - cosmu * cosmu * tannu * tannu * (1 - Math.cos(Math.atan(1 / Math.cos(theta))));
    if (cosphi < -1) cosphi = -1;
    else if (cosphi > 1) cosphi = 1;
    /* Apply the result to the real area on the cube face.
   * For the top and bottom face, we can compute phi and lam directly.
   * For the other faces, we must use unit sphere cartesian coordinates
   * as an intermediate step. */ if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.TOP) {
        phi = Math.acos(cosphi);
        lp.phi = (0, $gyVUi.HALF_PI) - phi;
        if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_0) lp.lam = theta + (0, $gyVUi.HALF_PI);
        else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_1) lp.lam = theta < 0.0 ? theta + (0, $gyVUi.SPI) : theta - (0, $gyVUi.SPI);
        else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_2) lp.lam = theta - (0, $gyVUi.HALF_PI);
        else lp.lam = theta;
    } else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.BOTTOM) {
        phi = Math.acos(cosphi);
        lp.phi = phi - (0, $gyVUi.HALF_PI);
        if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_0) lp.lam = -theta + (0, $gyVUi.HALF_PI);
        else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_1) lp.lam = -theta;
        else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_2) lp.lam = -theta - (0, $gyVUi.HALF_PI);
        else lp.lam = theta < 0.0 ? -theta - (0, $gyVUi.SPI) : -theta + (0, $gyVUi.SPI);
    } else {
        /* Compute phi and lam via cartesian unit sphere coordinates. */ var q, r, s;
        q = cosphi;
        t = q * q;
        if (t >= 1) s = 0;
        else s = Math.sqrt(1 - t) * Math.sin(theta);
        t += s * s;
        if (t >= 1) r = 0;
        else r = Math.sqrt(1 - t);
        /* Rotate q,r,s into the correct area. */ if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_1) {
            t = r;
            r = -s;
            s = t;
        } else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_2) {
            r = -r;
            s = -s;
        } else if (area.value === $228cab2632c5bcf7$var$AREA_ENUM.AREA_3) {
            t = r;
            r = s;
            s = -t;
        }
        /* Rotate q,r,s into the correct cube face. */ if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.RIGHT) {
            t = q;
            q = -r;
            r = t;
        } else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.BACK) {
            q = -q;
            r = -r;
        } else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.LEFT) {
            t = q;
            q = r;
            r = -t;
        }
        /* Now compute phi and lam from the unit sphere coordinates. */ lp.phi = Math.acos(-s) - (0, $gyVUi.HALF_PI);
        lp.lam = Math.atan2(r, q);
        if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.RIGHT) lp.lam = $228cab2632c5bcf7$var$qsc_shift_lon_origin(lp.lam, -(0, $gyVUi.HALF_PI));
        else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.BACK) lp.lam = $228cab2632c5bcf7$var$qsc_shift_lon_origin(lp.lam, -(0, $gyVUi.SPI));
        else if (this.face === $228cab2632c5bcf7$var$FACE_ENUM.LEFT) lp.lam = $228cab2632c5bcf7$var$qsc_shift_lon_origin(lp.lam, +(0, $gyVUi.HALF_PI));
    }
    /* Apply the shift from the sphere to the ellipsoid as described
   * in [LK12]. */ if (this.es !== 0) {
        var invert_sign;
        var tanphi, xa;
        invert_sign = lp.phi < 0 ? 1 : 0;
        tanphi = Math.tan(lp.phi);
        xa = this.b / Math.sqrt(tanphi * tanphi + this.one_minus_f_squared);
        lp.phi = Math.atan(Math.sqrt(this.a * this.a - xa * xa) / (this.one_minus_f * xa));
        if (invert_sign) lp.phi = -lp.phi;
    }
    lp.lam += this.long0;
    p.x = lp.lam;
    p.y = lp.phi;
    return p;
}
/* Helper function for forward projection: compute the theta angle
 * and determine the area number. */ function $228cab2632c5bcf7$var$qsc_fwd_equat_face_theta(phi, y, x, area) {
    var theta;
    if (phi < (0, $gyVUi.EPSLN)) {
        area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_0;
        theta = 0.0;
    } else {
        theta = Math.atan2(y, x);
        if (Math.abs(theta) <= (0, $gyVUi.FORTPI)) area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_0;
        else if (theta > (0, $gyVUi.FORTPI) && theta <= (0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI)) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_1;
            theta -= (0, $gyVUi.HALF_PI);
        } else if (theta > (0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI) || theta <= -((0, $gyVUi.HALF_PI) + (0, $gyVUi.FORTPI))) {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_2;
            theta = theta >= 0.0 ? theta - (0, $gyVUi.SPI) : theta + (0, $gyVUi.SPI);
        } else {
            area.value = $228cab2632c5bcf7$var$AREA_ENUM.AREA_3;
            theta += (0, $gyVUi.HALF_PI);
        }
    }
    return theta;
}
/* Helper function: shift the longitude. */ function $228cab2632c5bcf7$var$qsc_shift_lon_origin(lon, offset) {
    var slon = lon + offset;
    if (slon < -(0, $gyVUi.SPI)) slon += (0, $gyVUi.TWO_PI);
    else if (slon > +(0, $gyVUi.SPI)) slon -= (0, $gyVUi.TWO_PI);
    return slon;
}
var $228cab2632c5bcf7$export$e4b2ac9215619f8d = [
    'Quadrilateralized Spherical Cube',
    'Quadrilateralized_Spherical_Cube',
    'qsc'
];
var $228cab2632c5bcf7$export$2e2bcd8739ae039 = {
    init: $228cab2632c5bcf7$export$2cd8252107eb640b,
    forward: $228cab2632c5bcf7$export$174bb771924e7eb1,
    inverse: $228cab2632c5bcf7$export$70ae2c07e401031b,
    names: $228cab2632c5bcf7$export$e4b2ac9215619f8d
};

});

parcelRegister("byZja", function(module, exports) {

$parcel$export(module.exports, "default", () => $86b26d30d3579075$export$2e2bcd8739ae039);
// Robinson projection
// Based on https://github.com/OSGeo/proj.4/blob/master/src/PJ_robin.c
// Polynomial coeficients from http://article.gmane.org/gmane.comp.gis.proj-4.devel/6039

var $gyVUi = parcelRequire("gyVUi");

var $a9oRf = parcelRequire("a9oRf");
var $86b26d30d3579075$var$COEFS_X = [
    [
        1.0000,
        2.2199e-17,
        -0.0000715515,
        3.1103e-06
    ],
    [
        0.9986,
        -0.000482243,
        -0.000024897,
        -0.0000013309
    ],
    [
        0.9954,
        -0.00083103,
        -0.0000448605,
        -0.000000986701
    ],
    [
        0.9900,
        -0.00135364,
        -0.000059661,
        3.6777e-06
    ],
    [
        0.9822,
        -0.00167442,
        -0.00000449547,
        -0.00000572411
    ],
    [
        0.9730,
        -0.00214868,
        -0.0000903571,
        1.8736e-08
    ],
    [
        0.9600,
        -0.00305085,
        -0.0000900761,
        1.64917e-06
    ],
    [
        0.9427,
        -0.00382792,
        -0.0000653386,
        -0.0000026154
    ],
    [
        0.9216,
        -0.00467746,
        -0.00010457,
        4.81243e-06
    ],
    [
        0.8962,
        -0.00536223,
        -0.0000323831,
        -0.00000543432
    ],
    [
        0.8679,
        -0.00609363,
        -0.000113898,
        3.32484e-06
    ],
    [
        0.8350,
        -0.00698325,
        -0.0000640253,
        9.34959e-07
    ],
    [
        0.7986,
        -0.00755338,
        -0.0000500009,
        9.35324e-07
    ],
    [
        0.7597,
        -0.00798324,
        -0.000035971,
        -0.00000227626
    ],
    [
        0.7186,
        -0.00851367,
        -0.0000701149,
        -0.0000086303
    ],
    [
        0.6732,
        -0.00986209,
        -0.000199569,
        1.91974e-05
    ],
    [
        0.6213,
        -0.010418,
        8.83923e-05,
        6.24051e-06
    ],
    [
        0.5722,
        -0.00906601,
        0.000182,
        6.24051e-06
    ],
    [
        0.5322,
        -0.00677797,
        0.000275608,
        6.24051e-06
    ]
];
var $86b26d30d3579075$var$COEFS_Y = [
    [
        -0.00000000000000000520417,
        0.0124,
        1.21431e-18,
        -0.0000000000845284
    ],
    [
        0.0620,
        0.0124,
        -0.00000000126793,
        4.22642e-10
    ],
    [
        0.1240,
        0.0124,
        5.07171e-09,
        -0.00000000160604
    ],
    [
        0.1860,
        0.0123999,
        -0.0000000190189,
        6.00152e-09
    ],
    [
        0.2480,
        0.0124002,
        7.10039e-08,
        -0.0000000224
    ],
    [
        0.3100,
        0.0123992,
        -0.000000264997,
        8.35986e-08
    ],
    [
        0.3720,
        0.0124029,
        9.88983e-07,
        -0.000000311994
    ],
    [
        0.4340,
        0.0123893,
        -0.00000369093,
        -0.000000435621
    ],
    [
        0.4958,
        0.0123198,
        -0.0000102252,
        -0.000000345523
    ],
    [
        0.5571,
        0.0121916,
        -0.0000154081,
        -0.000000582288
    ],
    [
        0.6176,
        0.0119938,
        -0.0000241424,
        -0.000000525327
    ],
    [
        0.6769,
        0.011713,
        -0.0000320223,
        -0.000000516405
    ],
    [
        0.7346,
        0.0113541,
        -0.0000397684,
        -0.000000609052
    ],
    [
        0.7903,
        0.0109107,
        -0.0000489042,
        -0.00000104739
    ],
    [
        0.8435,
        0.0103431,
        -0.000064615,
        -0.00000000140374
    ],
    [
        0.8936,
        0.00969686,
        -0.000064636,
        -0.000008547
    ],
    [
        0.9394,
        0.00840947,
        -0.000192841,
        -0.0000042106
    ],
    [
        0.9761,
        0.00616527,
        -0.000256,
        -0.0000042106
    ],
    [
        1.0000,
        0.00328947,
        -0.000319159,
        -0.0000042106
    ]
];
var $86b26d30d3579075$var$FXC = 0.8487;
var $86b26d30d3579075$var$FYC = 1.3523;
var $86b26d30d3579075$var$C1 = (0, $gyVUi.R2D) / 5; // rad to 5-degree interval
var $86b26d30d3579075$var$RC1 = 1 / $86b26d30d3579075$var$C1;
var $86b26d30d3579075$var$NODES = 18;
var $86b26d30d3579075$var$poly3_val = function(coefs, x) {
    return coefs[0] + x * (coefs[1] + x * (coefs[2] + x * coefs[3]));
};
var $86b26d30d3579075$var$poly3_der = function(coefs, x) {
    return coefs[1] + x * (2 * coefs[2] + x * 3 * coefs[3]);
};
function $86b26d30d3579075$var$newton_rapshon(f_df, start, max_err, iters) {
    var x = start;
    for(; iters; --iters){
        var upd = f_df(x);
        x -= upd;
        if (Math.abs(upd) < max_err) break;
    }
    return x;
}
function $86b26d30d3579075$export$2cd8252107eb640b() {
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    this.long0 = this.long0 || 0;
    this.es = 0;
    this.title = this.title || 'Robinson';
}
function $86b26d30d3579075$export$174bb771924e7eb1(ll) {
    var lon = (0, $a9oRf.default)(ll.x - this.long0, this.over);
    var dphi = Math.abs(ll.y);
    var i = Math.floor(dphi * $86b26d30d3579075$var$C1);
    if (i < 0) i = 0;
    else if (i >= $86b26d30d3579075$var$NODES) i = $86b26d30d3579075$var$NODES - 1;
    dphi = (0, $gyVUi.R2D) * (dphi - $86b26d30d3579075$var$RC1 * i);
    var xy = {
        x: $86b26d30d3579075$var$poly3_val($86b26d30d3579075$var$COEFS_X[i], dphi) * lon,
        y: $86b26d30d3579075$var$poly3_val($86b26d30d3579075$var$COEFS_Y[i], dphi)
    };
    if (ll.y < 0) xy.y = -xy.y;
    xy.x = xy.x * this.a * $86b26d30d3579075$var$FXC + this.x0;
    xy.y = xy.y * this.a * $86b26d30d3579075$var$FYC + this.y0;
    return xy;
}
function $86b26d30d3579075$export$70ae2c07e401031b(xy) {
    var ll = {
        x: (xy.x - this.x0) / (this.a * $86b26d30d3579075$var$FXC),
        y: Math.abs(xy.y - this.y0) / (this.a * $86b26d30d3579075$var$FYC)
    };
    if (ll.y >= 1) {
        ll.x /= $86b26d30d3579075$var$COEFS_X[$86b26d30d3579075$var$NODES][0];
        ll.y = xy.y < 0 ? -(0, $gyVUi.HALF_PI) : (0, $gyVUi.HALF_PI);
    } else {
        // find table interval
        var i = Math.floor(ll.y * $86b26d30d3579075$var$NODES);
        if (i < 0) i = 0;
        else if (i >= $86b26d30d3579075$var$NODES) i = $86b26d30d3579075$var$NODES - 1;
        for(;;){
            if ($86b26d30d3579075$var$COEFS_Y[i][0] > ll.y) --i;
            else if ($86b26d30d3579075$var$COEFS_Y[i + 1][0] <= ll.y) ++i;
            else break;
        }
        // linear interpolation in 5 degree interval
        var coefs = $86b26d30d3579075$var$COEFS_Y[i];
        var t = 5 * (ll.y - coefs[0]) / ($86b26d30d3579075$var$COEFS_Y[i + 1][0] - coefs[0]);
        // find t so that poly3_val(coefs, t) = ll.y
        t = $86b26d30d3579075$var$newton_rapshon(function(x) {
            return ($86b26d30d3579075$var$poly3_val(coefs, x) - ll.y) / $86b26d30d3579075$var$poly3_der(coefs, x);
        }, t, (0, $gyVUi.EPSLN), 100);
        ll.x /= $86b26d30d3579075$var$poly3_val($86b26d30d3579075$var$COEFS_X[i], t);
        ll.y = (5 * i + t) * (0, $gyVUi.D2R);
        if (xy.y < 0) ll.y = -ll.y;
    }
    ll.x = (0, $a9oRf.default)(ll.x + this.long0, this.over);
    return ll;
}
var $86b26d30d3579075$export$e4b2ac9215619f8d = [
    'Robinson',
    'robin'
];
var $86b26d30d3579075$export$2e2bcd8739ae039 = {
    init: $86b26d30d3579075$export$2cd8252107eb640b,
    forward: $86b26d30d3579075$export$174bb771924e7eb1,
    inverse: $86b26d30d3579075$export$70ae2c07e401031b,
    names: $86b26d30d3579075$export$e4b2ac9215619f8d
};

});

parcelRegister("Fj8jS", function(module, exports) {

$parcel$export(module.exports, "default", () => $07c2abe70612fbc5$export$2e2bcd8739ae039);

var $4YPx7 = parcelRequire("4YPx7");
function $07c2abe70612fbc5$export$2cd8252107eb640b() {
    this.name = 'geocent';
}
function $07c2abe70612fbc5$export$174bb771924e7eb1(p) {
    var point = (0, $4YPx7.geodeticToGeocentric)(p, this.es, this.a);
    return point;
}
function $07c2abe70612fbc5$export$70ae2c07e401031b(p) {
    var point = (0, $4YPx7.geocentricToGeodetic)(p, this.es, this.a, this.b);
    return point;
}
var $07c2abe70612fbc5$export$e4b2ac9215619f8d = [
    'Geocentric',
    'geocentric',
    'geocent',
    'Geocent'
];
var $07c2abe70612fbc5$export$2e2bcd8739ae039 = {
    init: $07c2abe70612fbc5$export$2cd8252107eb640b,
    forward: $07c2abe70612fbc5$export$174bb771924e7eb1,
    inverse: $07c2abe70612fbc5$export$70ae2c07e401031b,
    names: $07c2abe70612fbc5$export$e4b2ac9215619f8d
};

});

parcelRegister("eJp9e", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab98c67e9f567a4b$export$2e2bcd8739ae039);

var $gyVUi = parcelRequire("gyVUi");

var $jU5gu = parcelRequire("jU5gu");
/**
 * @typedef {Object} LocalThis
 * @property {number} mode
 * @property {number} sinph0
 * @property {number} cosph0
 * @property {number} pn1
 * @property {number} h
 * @property {number} rp
 * @property {number} p
 * @property {number} h1
 * @property {number} pfact
 * @property {number} es
 * @property {number} tilt
 * @property {number} azi
 * @property {number} cg
 * @property {number} sg
 * @property {number} cw
 * @property {number} sw
 */ var $ab98c67e9f567a4b$var$mode = {
    N_POLE: 0,
    S_POLE: 1,
    EQUIT: 2,
    OBLIQ: 3
};
var $ab98c67e9f567a4b$var$params = {
    h: {
        def: 100000,
        num: true
    },
    azi: {
        def: 0,
        num: true,
        degrees: true
    },
    tilt: {
        def: 0,
        num: true,
        degrees: true
    },
    long0: {
        def: 0,
        num: true
    },
    lat0: {
        def: 0,
        num: true
    } // default is Equator, conversion to rad is automatic
};
function $ab98c67e9f567a4b$export$2cd8252107eb640b() {
    Object.keys($ab98c67e9f567a4b$var$params).forEach((function(p) {
        if (typeof this[p] === 'undefined') this[p] = $ab98c67e9f567a4b$var$params[p].def;
        else if ($ab98c67e9f567a4b$var$params[p].num && isNaN(this[p])) throw new Error('Invalid parameter value, must be numeric ' + p + ' = ' + this[p]);
        else if ($ab98c67e9f567a4b$var$params[p].num) this[p] = parseFloat(this[p]);
        if ($ab98c67e9f567a4b$var$params[p].degrees) this[p] = this[p] * (0, $gyVUi.D2R);
    }).bind(this));
    if (Math.abs(Math.abs(this.lat0) - (0, $gyVUi.HALF_PI)) < (0, $gyVUi.EPSLN)) this.mode = this.lat0 < 0 ? $ab98c67e9f567a4b$var$mode.S_POLE : $ab98c67e9f567a4b$var$mode.N_POLE;
    else if (Math.abs(this.lat0) < (0, $gyVUi.EPSLN)) this.mode = $ab98c67e9f567a4b$var$mode.EQUIT;
    else {
        this.mode = $ab98c67e9f567a4b$var$mode.OBLIQ;
        this.sinph0 = Math.sin(this.lat0);
        this.cosph0 = Math.cos(this.lat0);
    }
    this.pn1 = this.h / this.a; // Normalize relative to the Earth's radius
    if (this.pn1 <= 0 || this.pn1 > 1e10) throw new Error('Invalid height');
    this.p = 1 + this.pn1;
    this.rp = 1 / this.p;
    this.h1 = 1 / this.pn1;
    this.pfact = (this.p + 1) * this.h1;
    this.es = 0;
    var omega = this.tilt;
    var gamma = this.azi;
    this.cg = Math.cos(gamma);
    this.sg = Math.sin(gamma);
    this.cw = Math.cos(omega);
    this.sw = Math.sin(omega);
}
function $ab98c67e9f567a4b$export$174bb771924e7eb1(p) {
    p.x -= this.long0;
    var sinphi = Math.sin(p.y);
    var cosphi = Math.cos(p.y);
    var coslam = Math.cos(p.x);
    var x, y;
    switch(this.mode){
        case $ab98c67e9f567a4b$var$mode.OBLIQ:
            y = this.sinph0 * sinphi + this.cosph0 * cosphi * coslam;
            break;
        case $ab98c67e9f567a4b$var$mode.EQUIT:
            y = cosphi * coslam;
            break;
        case $ab98c67e9f567a4b$var$mode.S_POLE:
            y = -sinphi;
            break;
        case $ab98c67e9f567a4b$var$mode.N_POLE:
            y = sinphi;
            break;
    }
    y = this.pn1 / (this.p - y);
    x = y * cosphi * Math.sin(p.x);
    switch(this.mode){
        case $ab98c67e9f567a4b$var$mode.OBLIQ:
            y *= this.cosph0 * sinphi - this.sinph0 * cosphi * coslam;
            break;
        case $ab98c67e9f567a4b$var$mode.EQUIT:
            y *= sinphi;
            break;
        case $ab98c67e9f567a4b$var$mode.N_POLE:
            y *= -(cosphi * coslam);
            break;
        case $ab98c67e9f567a4b$var$mode.S_POLE:
            y *= cosphi * coslam;
            break;
    }
    // Tilt
    var yt, ba;
    yt = y * this.cg + x * this.sg;
    ba = 1 / (yt * this.sw * this.h1 + this.cw);
    x = (x * this.cg - y * this.sg) * this.cw * ba;
    y = yt * ba;
    p.x = x * this.a;
    p.y = y * this.a;
    return p;
}
function $ab98c67e9f567a4b$export$70ae2c07e401031b(p) {
    p.x /= this.a;
    p.y /= this.a;
    var r = {
        x: p.x,
        y: p.y
    };
    // Un-Tilt
    var bm, bq, yt;
    yt = 1 / (this.pn1 - p.y * this.sw);
    bm = this.pn1 * p.x * yt;
    bq = this.pn1 * p.y * this.cw * yt;
    p.x = bm * this.cg + bq * this.sg;
    p.y = bq * this.cg - bm * this.sg;
    var rh = (0, $jU5gu.default)(p.x, p.y);
    if (Math.abs(rh) < (0, $gyVUi.EPSLN)) {
        r.x = 0;
        r.y = p.y;
    } else {
        var cosz, sinz;
        sinz = 1 - rh * rh * this.pfact;
        sinz = (this.p - Math.sqrt(sinz)) / (this.pn1 / rh + rh / this.pn1);
        cosz = Math.sqrt(1 - sinz * sinz);
        switch(this.mode){
            case $ab98c67e9f567a4b$var$mode.OBLIQ:
                r.y = Math.asin(cosz * this.sinph0 + p.y * sinz * this.cosph0 / rh);
                p.y = (cosz - this.sinph0 * Math.sin(r.y)) * rh;
                p.x *= sinz * this.cosph0;
                break;
            case $ab98c67e9f567a4b$var$mode.EQUIT:
                r.y = Math.asin(p.y * sinz / rh);
                p.y = cosz * rh;
                p.x *= sinz;
                break;
            case $ab98c67e9f567a4b$var$mode.N_POLE:
                r.y = Math.asin(cosz);
                p.y = -p.y;
                break;
            case $ab98c67e9f567a4b$var$mode.S_POLE:
                r.y = -Math.asin(cosz);
                break;
        }
        r.x = Math.atan2(p.x, p.y);
    }
    p.x = r.x + this.long0;
    p.y = r.y;
    return p;
}
var $ab98c67e9f567a4b$export$e4b2ac9215619f8d = [
    'Tilted_Perspective',
    'tpers'
];
var $ab98c67e9f567a4b$export$2e2bcd8739ae039 = {
    init: $ab98c67e9f567a4b$export$2cd8252107eb640b,
    forward: $ab98c67e9f567a4b$export$174bb771924e7eb1,
    inverse: $ab98c67e9f567a4b$export$70ae2c07e401031b,
    names: $ab98c67e9f567a4b$export$e4b2ac9215619f8d
};

});

parcelRegister("jJ6PL", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5c7855edcbcda04$export$2e2bcd8739ae039);

var $jU5gu = parcelRequire("jU5gu");
function $e5c7855edcbcda04$export$2cd8252107eb640b() {
    this.flip_axis = this.sweep === 'x' ? 1 : 0;
    this.h = Number(this.h);
    this.radius_g_1 = this.h / this.a;
    if (this.radius_g_1 <= 0 || this.radius_g_1 > 1e10) throw new Error();
    this.radius_g = 1.0 + this.radius_g_1;
    this.C = this.radius_g * this.radius_g - 1.0;
    if (this.es !== 0.0) {
        var one_es = 1.0 - this.es;
        var rone_es = 1 / one_es;
        this.radius_p = Math.sqrt(one_es);
        this.radius_p2 = one_es;
        this.radius_p_inv2 = rone_es;
        this.shape = 'ellipse'; // Use as a condition in the forward and inverse functions.
    } else {
        this.radius_p = 1.0;
        this.radius_p2 = 1.0;
        this.radius_p_inv2 = 1.0;
        this.shape = 'sphere'; // Use as a condition in the forward and inverse functions.
    }
    if (!this.title) this.title = 'Geostationary Satellite View';
}
function $e5c7855edcbcda04$var$forward(p) {
    var lon = p.x;
    var lat = p.y;
    var tmp, v_x, v_y, v_z;
    lon = lon - this.long0;
    if (this.shape === 'ellipse') {
        lat = Math.atan(this.radius_p2 * Math.tan(lat));
        var r = this.radius_p / (0, $jU5gu.default)(this.radius_p * Math.cos(lat), Math.sin(lat));
        v_x = r * Math.cos(lon) * Math.cos(lat);
        v_y = r * Math.sin(lon) * Math.cos(lat);
        v_z = r * Math.sin(lat);
        if ((this.radius_g - v_x) * v_x - v_y * v_y - v_z * v_z * this.radius_p_inv2 < 0.0) {
            p.x = Number.NaN;
            p.y = Number.NaN;
            return p;
        }
        tmp = this.radius_g - v_x;
        if (this.flip_axis) {
            p.x = this.radius_g_1 * Math.atan(v_y / (0, $jU5gu.default)(v_z, tmp));
            p.y = this.radius_g_1 * Math.atan(v_z / tmp);
        } else {
            p.x = this.radius_g_1 * Math.atan(v_y / tmp);
            p.y = this.radius_g_1 * Math.atan(v_z / (0, $jU5gu.default)(v_y, tmp));
        }
    } else if (this.shape === 'sphere') {
        tmp = Math.cos(lat);
        v_x = Math.cos(lon) * tmp;
        v_y = Math.sin(lon) * tmp;
        v_z = Math.sin(lat);
        tmp = this.radius_g - v_x;
        if (this.flip_axis) {
            p.x = this.radius_g_1 * Math.atan(v_y / (0, $jU5gu.default)(v_z, tmp));
            p.y = this.radius_g_1 * Math.atan(v_z / tmp);
        } else {
            p.x = this.radius_g_1 * Math.atan(v_y / tmp);
            p.y = this.radius_g_1 * Math.atan(v_z / (0, $jU5gu.default)(v_y, tmp));
        }
    }
    p.x = p.x * this.a;
    p.y = p.y * this.a;
    return p;
}
function $e5c7855edcbcda04$var$inverse(p) {
    var v_x = -1;
    var v_y = 0.0;
    var v_z = 0.0;
    var a, b, det, k;
    p.x = p.x / this.a;
    p.y = p.y / this.a;
    if (this.shape === 'ellipse') {
        if (this.flip_axis) {
            v_z = Math.tan(p.y / this.radius_g_1);
            v_y = Math.tan(p.x / this.radius_g_1) * (0, $jU5gu.default)(1.0, v_z);
        } else {
            v_y = Math.tan(p.x / this.radius_g_1);
            v_z = Math.tan(p.y / this.radius_g_1) * (0, $jU5gu.default)(1.0, v_y);
        }
        var v_zp = v_z / this.radius_p;
        a = v_y * v_y + v_zp * v_zp + v_x * v_x;
        b = 2 * this.radius_g * v_x;
        det = b * b - 4 * a * this.C;
        if (det < 0.0) {
            p.x = Number.NaN;
            p.y = Number.NaN;
            return p;
        }
        k = (-b - Math.sqrt(det)) / (2.0 * a);
        v_x = this.radius_g + k * v_x;
        v_y *= k;
        v_z *= k;
        p.x = Math.atan2(v_y, v_x);
        p.y = Math.atan(v_z * Math.cos(p.x) / v_x);
        p.y = Math.atan(this.radius_p_inv2 * Math.tan(p.y));
    } else if (this.shape === 'sphere') {
        if (this.flip_axis) {
            v_z = Math.tan(p.y / this.radius_g_1);
            v_y = Math.tan(p.x / this.radius_g_1) * Math.sqrt(1.0 + v_z * v_z);
        } else {
            v_y = Math.tan(p.x / this.radius_g_1);
            v_z = Math.tan(p.y / this.radius_g_1) * Math.sqrt(1.0 + v_y * v_y);
        }
        a = v_y * v_y + v_z * v_z + v_x * v_x;
        b = 2 * this.radius_g * v_x;
        det = b * b - 4 * a * this.C;
        if (det < 0.0) {
            p.x = Number.NaN;
            p.y = Number.NaN;
            return p;
        }
        k = (-b - Math.sqrt(det)) / (2.0 * a);
        v_x = this.radius_g + k * v_x;
        v_y *= k;
        v_z *= k;
        p.x = Math.atan2(v_y, v_x);
        p.y = Math.atan(v_z * Math.cos(p.x) / v_x);
    }
    p.x = p.x + this.long0;
    return p;
}
var $e5c7855edcbcda04$export$e4b2ac9215619f8d = [
    'Geostationary Satellite View',
    'Geostationary_Satellite',
    'geos'
];
var $e5c7855edcbcda04$export$2e2bcd8739ae039 = {
    init: $e5c7855edcbcda04$export$2cd8252107eb640b,
    forward: $e5c7855edcbcda04$var$forward,
    inverse: $e5c7855edcbcda04$var$inverse,
    names: $e5c7855edcbcda04$export$e4b2ac9215619f8d
};

});

parcelRegister("cbANR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8df30f7b6f96e4d8$export$2e2bcd8739ae039);
/**
 * Copyright 2018 Bernie Jenny, Monash University, Melbourne, Australia.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Equal Earth is a projection inspired by the Robinson projection, but unlike
 * the Robinson projection retains the relative size of areas. The projection
 * was designed in 2018 by Bojan Savric, Tom Patterson and Bernhard Jenny.
 *
 * Publication:
 * Bojan Savric, Tom Patterson & Bernhard Jenny (2018). The Equal Earth map
 * projection, International Journal of Geographical Information Science,
 * DOI: 10.1080/13658816.2018.1504949
 *
 * Code released August 2018
 * Ported to JavaScript and adapted for mapshaper-proj by Matthew Bloch August 2018
 * Modified for proj4js by Andreas Hocevar by Andreas Hocevar March 2024
 */ 
var $a9oRf = parcelRequire("a9oRf");
var $8df30f7b6f96e4d8$var$A1 = 1.340264, $8df30f7b6f96e4d8$var$A2 = -0.081106, $8df30f7b6f96e4d8$var$A3 = 0.000893, $8df30f7b6f96e4d8$var$A4 = 0.003796, $8df30f7b6f96e4d8$var$M = Math.sqrt(3) / 2.0;
function $8df30f7b6f96e4d8$export$2cd8252107eb640b() {
    this.es = 0;
    this.long0 = this.long0 !== undefined ? this.long0 : 0;
    this.x0 = this.x0 !== undefined ? this.x0 : 0;
    this.y0 = this.y0 !== undefined ? this.y0 : 0;
}
function $8df30f7b6f96e4d8$export$174bb771924e7eb1(p) {
    var lam = (0, $a9oRf.default)(p.x - this.long0, this.over);
    var phi = p.y;
    var paramLat = Math.asin($8df30f7b6f96e4d8$var$M * Math.sin(phi)), paramLatSq = paramLat * paramLat, paramLatPow6 = paramLatSq * paramLatSq * paramLatSq;
    p.x = lam * Math.cos(paramLat) / ($8df30f7b6f96e4d8$var$M * ($8df30f7b6f96e4d8$var$A1 + 3 * $8df30f7b6f96e4d8$var$A2 * paramLatSq + paramLatPow6 * (7 * $8df30f7b6f96e4d8$var$A3 + 9 * $8df30f7b6f96e4d8$var$A4 * paramLatSq)));
    p.y = paramLat * ($8df30f7b6f96e4d8$var$A1 + $8df30f7b6f96e4d8$var$A2 * paramLatSq + paramLatPow6 * ($8df30f7b6f96e4d8$var$A3 + $8df30f7b6f96e4d8$var$A4 * paramLatSq));
    p.x = this.a * p.x + this.x0;
    p.y = this.a * p.y + this.y0;
    return p;
}
function $8df30f7b6f96e4d8$export$70ae2c07e401031b(p) {
    p.x = (p.x - this.x0) / this.a;
    p.y = (p.y - this.y0) / this.a;
    var EPS = 1e-9, NITER = 12, paramLat = p.y, paramLatSq, paramLatPow6, fy, fpy, dlat, i;
    for(i = 0; i < NITER; ++i){
        paramLatSq = paramLat * paramLat;
        paramLatPow6 = paramLatSq * paramLatSq * paramLatSq;
        fy = paramLat * ($8df30f7b6f96e4d8$var$A1 + $8df30f7b6f96e4d8$var$A2 * paramLatSq + paramLatPow6 * ($8df30f7b6f96e4d8$var$A3 + $8df30f7b6f96e4d8$var$A4 * paramLatSq)) - p.y;
        fpy = $8df30f7b6f96e4d8$var$A1 + 3 * $8df30f7b6f96e4d8$var$A2 * paramLatSq + paramLatPow6 * (7 * $8df30f7b6f96e4d8$var$A3 + 9 * $8df30f7b6f96e4d8$var$A4 * paramLatSq);
        paramLat -= dlat = fy / fpy;
        if (Math.abs(dlat) < EPS) break;
    }
    paramLatSq = paramLat * paramLat;
    paramLatPow6 = paramLatSq * paramLatSq * paramLatSq;
    p.x = $8df30f7b6f96e4d8$var$M * p.x * ($8df30f7b6f96e4d8$var$A1 + 3 * $8df30f7b6f96e4d8$var$A2 * paramLatSq + paramLatPow6 * (7 * $8df30f7b6f96e4d8$var$A3 + 9 * $8df30f7b6f96e4d8$var$A4 * paramLatSq)) / Math.cos(paramLat);
    p.y = Math.asin(Math.sin(paramLat) / $8df30f7b6f96e4d8$var$M);
    p.x = (0, $a9oRf.default)(p.x + this.long0, this.over);
    return p;
}
var $8df30f7b6f96e4d8$export$e4b2ac9215619f8d = [
    'eqearth',
    'Equal Earth',
    'Equal_Earth'
];
var $8df30f7b6f96e4d8$export$2e2bcd8739ae039 = {
    init: $8df30f7b6f96e4d8$export$2cd8252107eb640b,
    forward: $8df30f7b6f96e4d8$export$174bb771924e7eb1,
    inverse: $8df30f7b6f96e4d8$export$70ae2c07e401031b,
    names: $8df30f7b6f96e4d8$export$e4b2ac9215619f8d
};

});

parcelRegister("gtZfx", function(module, exports) {

$parcel$export(module.exports, "default", () => $bffedda91368999e$export$2e2bcd8739ae039);

var $aDUFA = parcelRequire("aDUFA");

var $a9oRf = parcelRequire("a9oRf");

var $jU5gu = parcelRequire("jU5gu");

var $gqKpL = parcelRequire("gqKpL");

var $jQUK6 = parcelRequire("jQUK6");

var $hpUQm = parcelRequire("hpUQm");

var $gyVUi = parcelRequire("gyVUi");
/**
 * @typedef {Object} LocalThis
 * @property {number} phi1
 * @property {number} cphi1
 * @property {number} es
 * @property {Array<number>} en
 * @property {number} m1
 * @property {number} am1
 */ var $bffedda91368999e$var$EPS10 = 1e-10;
function $bffedda91368999e$export$2cd8252107eb640b() {
    var c;
    this.phi1 = this.lat1;
    if (Math.abs(this.phi1) < $bffedda91368999e$var$EPS10) throw new Error();
    if (this.es) {
        this.en = (0, $gqKpL.default)(this.es);
        this.m1 = (0, $hpUQm.default)(this.phi1, this.am1 = Math.sin(this.phi1), c = Math.cos(this.phi1), this.en);
        this.am1 = c / (Math.sqrt(1 - this.es * this.am1 * this.am1) * this.am1);
        this.inverse = $bffedda91368999e$var$e_inv;
        this.forward = $bffedda91368999e$var$e_fwd;
    } else {
        if (Math.abs(this.phi1) + $bffedda91368999e$var$EPS10 >= (0, $gyVUi.HALF_PI)) this.cphi1 = 0;
        else this.cphi1 = 1 / Math.tan(this.phi1);
        this.inverse = $bffedda91368999e$var$s_inv;
        this.forward = $bffedda91368999e$var$s_fwd;
    }
}
function $bffedda91368999e$var$e_fwd(p) {
    var lam = (0, $a9oRf.default)(p.x - (this.long0 || 0), this.over);
    var phi = p.y;
    var rh, E, c;
    rh = this.am1 + this.m1 - (0, $hpUQm.default)(phi, E = Math.sin(phi), c = Math.cos(phi), this.en);
    E = c * lam / (rh * Math.sqrt(1 - this.es * E * E));
    p.x = rh * Math.sin(E);
    p.y = this.am1 - rh * Math.cos(E);
    p.x = this.a * p.x + (this.x0 || 0);
    p.y = this.a * p.y + (this.y0 || 0);
    return p;
}
function $bffedda91368999e$var$e_inv(p) {
    p.x = (p.x - (this.x0 || 0)) / this.a;
    p.y = (p.y - (this.y0 || 0)) / this.a;
    var s, rh, lam, phi;
    rh = (0, $jU5gu.default)(p.x, p.y = this.am1 - p.y);
    phi = (0, $jQUK6.default)(this.am1 + this.m1 - rh, this.es, this.en);
    if ((s = Math.abs(phi)) < (0, $gyVUi.HALF_PI)) {
        s = Math.sin(phi);
        lam = rh * Math.atan2(p.x, p.y) * Math.sqrt(1 - this.es * s * s) / Math.cos(phi);
    } else if (Math.abs(s - (0, $gyVUi.HALF_PI)) <= $bffedda91368999e$var$EPS10) lam = 0;
    else throw new Error();
    p.x = (0, $a9oRf.default)(lam + (this.long0 || 0), this.over);
    p.y = (0, $aDUFA.default)(phi);
    return p;
}
function $bffedda91368999e$var$s_fwd(p) {
    var lam = (0, $a9oRf.default)(p.x - (this.long0 || 0), this.over);
    var phi = p.y;
    var E, rh;
    rh = this.cphi1 + this.phi1 - phi;
    if (Math.abs(rh) > $bffedda91368999e$var$EPS10) {
        p.x = rh * Math.sin(E = lam * Math.cos(phi) / rh);
        p.y = this.cphi1 - rh * Math.cos(E);
    } else p.x = p.y = 0;
    p.x = this.a * p.x + (this.x0 || 0);
    p.y = this.a * p.y + (this.y0 || 0);
    return p;
}
function $bffedda91368999e$var$s_inv(p) {
    p.x = (p.x - (this.x0 || 0)) / this.a;
    p.y = (p.y - (this.y0 || 0)) / this.a;
    var lam, phi;
    var rh = (0, $jU5gu.default)(p.x, p.y = this.cphi1 - p.y);
    phi = this.cphi1 + this.phi1 - rh;
    if (Math.abs(phi) > (0, $gyVUi.HALF_PI)) throw new Error();
    if (Math.abs(Math.abs(phi) - (0, $gyVUi.HALF_PI)) <= $bffedda91368999e$var$EPS10) lam = 0;
    else lam = rh * Math.atan2(p.x, p.y) / Math.cos(phi);
    p.x = (0, $a9oRf.default)(lam + (this.long0 || 0), this.over);
    p.y = (0, $aDUFA.default)(phi);
    return p;
}
var $bffedda91368999e$export$e4b2ac9215619f8d = [
    'bonne',
    'Bonne (Werner lat_1=90)'
];
var $bffedda91368999e$export$2e2bcd8739ae039 = {
    init: $bffedda91368999e$export$2cd8252107eb640b,
    names: $bffedda91368999e$export$e4b2ac9215619f8d
};

});

parcelRegister("kU0qj", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3795daa9f669a64$export$2e2bcd8739ae039);

var $a9oRf = parcelRequire("a9oRf");

var $gyVUi = parcelRequire("gyVUi");

var $38qqf = parcelRequire("38qqf");

var $iMMJV = parcelRequire("iMMJV");
/**
    Original projection implementation:
        https://github.com/OSGeo/PROJ/blob/46c47e9adf6376ae06afabe5d24a0016a05ced82/src/projections/ob_tran.cpp

    Documentation:
        https://proj.org/operations/projections/ob_tran.html

    References/Formulas:
        https://pubs.usgs.gov/pp/1395/report.pdf

    Examples:
        +proj=ob_tran +o_proj=moll +o_lat_p=45 +o_lon_p=-90
        +proj=ob_tran +o_proj=moll +o_lat_p=45 +o_lon_p=-90 +lon_0=60
        +proj=ob_tran +o_proj=moll +o_lat_p=45 +o_lon_p=-90 +lon_0=-90
*/ const $f3795daa9f669a64$var$projectionType = {
    OBLIQUE: {
        forward: $f3795daa9f669a64$var$forwardOblique,
        inverse: $f3795daa9f669a64$var$inverseOblique
    },
    TRANSVERSE: {
        forward: $f3795daa9f669a64$var$forwardTransverse,
        inverse: $f3795daa9f669a64$var$inverseTransverse
    }
};
/**
 * @typedef {Object} LocalThis
 * @property {number} lamp
 * @property {number} cphip
 * @property {number} sphip
 * @property {Object} projectionType
 * @property {string | undefined} o_proj
 * @property {string | undefined} o_lon_p
 * @property {string | undefined} o_lat_p
 * @property {string | undefined} o_alpha
 * @property {string | undefined} o_lon_c
 * @property {string | undefined} o_lat_c
 * @property {string | undefined} o_lon_1
 * @property {string | undefined} o_lat_1
 * @property {string | undefined} o_lon_2
 * @property {string | undefined} o_lat_2
 * @property {number | undefined} oLongP
 * @property {number | undefined} oLatP
 * @property {number | undefined} oAlpha
 * @property {number | undefined} oLongC
 * @property {number | undefined} oLatC
 * @property {number | undefined} oLong1
 * @property {number | undefined} oLat1
 * @property {number | undefined} oLong2
 * @property {number | undefined} oLat2
 * @property {boolean} isIdentity
 * @property {import('..').Converter} obliqueProjection
 *
 */ /**
 *    Parameters can be from the following sets:
 *       New pole --> o_lat_p, o_lon_p
 *       Rotate about point --> o_alpha, o_lon_c, o_lat_c
 *       New equator points --> lon_1, lat_1, lon_2, lat_2
 *
 *    Per the original source code, the parameter sets are
 *    checked in the order of the object below.
 */ const $f3795daa9f669a64$var$paramSets = {
    ROTATE: {
        o_alpha: 'oAlpha',
        o_lon_c: 'oLongC',
        o_lat_c: 'oLatC'
    },
    NEW_POLE: {
        o_lat_p: 'oLatP',
        o_lon_p: 'oLongP'
    },
    NEW_EQUATOR: {
        o_lon_1: 'oLong1',
        o_lat_1: 'oLat1',
        o_lon_2: 'oLong2',
        o_lat_2: 'oLat2'
    }
};
function $f3795daa9f669a64$export$2cd8252107eb640b() {
    this.x0 = this.x0 || 0;
    this.y0 = this.y0 || 0;
    this.long0 = this.long0 || 0;
    this.title = this.title || 'General Oblique Transformation';
    this.isIdentity = (0, $iMMJV.names).includes(this.o_proj);
    /** Verify required parameters exist */ if (!this.o_proj) throw new Error('Missing parameter: o_proj');
    if (this.o_proj === `ob_tran`) throw new Error('Invalid value for o_proj: ' + this.o_proj);
    const newProjStr = this.projStr.replace('+proj=ob_tran', '').replace('+o_proj=', '+proj=').trim();
    /** @type {import('../defs.js').ProjectionDefinition} */ const oProj = (0, $38qqf.default)(newProjStr);
    if (!oProj) throw new Error('Invalid parameter: o_proj. Unknown projection ' + this.o_proj);
    oProj.long0 = 0; // we handle long0 before/after forward/inverse
    this.obliqueProjection = oProj;
    let matchedSet;
    const paramSetsKeys = Object.keys($f3795daa9f669a64$var$paramSets);
    /**
   * parse strings, convert to radians, throw on NaN
   * @param {string} name
   * @returns {number | undefined}
   */ const parseParam = (name)=>{
        if (typeof this[name] === `undefined`) return undefined;
        const val = parseFloat(this[name]) * (0, $gyVUi.D2R);
        if (isNaN(val)) throw new Error('Invalid value for ' + name + ': ' + this[name]);
        return val;
    };
    for(let i = 0; i < paramSetsKeys.length; i++){
        const setKey = paramSetsKeys[i];
        const set = $f3795daa9f669a64$var$paramSets[setKey];
        const params = Object.entries(set);
        const setHasParams = params.some(([p])=>typeof this[p] !== 'undefined');
        if (!setHasParams) continue;
        matchedSet = set;
        for(let ii = 0; ii < params.length; ii++){
            const [inputParam, param] = params[ii];
            const val = parseParam(inputParam);
            if (typeof val === 'undefined') throw new Error('Missing parameter: ' + inputParam + '.');
            this[param] = val;
        }
        break;
    }
    if (!matchedSet) throw new Error('No valid parameters provided for ob_tran projection.');
    const { lamp: lamp, phip: phip } = $f3795daa9f669a64$var$createRotation(this, matchedSet);
    this.lamp = lamp;
    if (Math.abs(phip) > (0, $gyVUi.EPSLN)) {
        this.cphip = Math.cos(phip);
        this.sphip = Math.sin(phip);
        this.projectionType = $f3795daa9f669a64$var$projectionType.OBLIQUE;
    } else this.projectionType = $f3795daa9f669a64$var$projectionType.TRANSVERSE;
}
function $f3795daa9f669a64$export$174bb771924e7eb1(p) {
    return this.projectionType.forward(this, p);
}
function $f3795daa9f669a64$export$70ae2c07e401031b(p) {
    return this.projectionType.inverse(this, p);
}
/**
 * @param {import('../defs.js').ProjectionDefinition & LocalThis} params - Initialized projection definition
 * @param {Object} how - Transformation method
 * @returns {{phip: number, lamp: number}}
 */ function $f3795daa9f669a64$var$createRotation(params, how) {
    let phip, lamp;
    if (how === $f3795daa9f669a64$var$paramSets.ROTATE) {
        let lamc = params.oLongC;
        let phic = params.oLatC;
        let alpha = params.oAlpha;
        if (Math.abs(Math.abs(phic) - (0, $gyVUi.HALF_PI)) <= (0, $gyVUi.EPSLN)) throw new Error('Invalid value for o_lat_c: ' + params.o_lat_c + " should be < 90\xb0");
        lamp = lamc + Math.atan2(-1 * Math.cos(alpha), -1 * Math.sin(alpha) * Math.sin(phic));
        phip = Math.asin(Math.cos(phic) * Math.sin(alpha));
    } else if (how === $f3795daa9f669a64$var$paramSets.NEW_POLE) {
        lamp = params.oLongP;
        phip = params.oLatP;
    } else {
        let lam1 = params.oLong1;
        let phi1 = params.oLat1;
        let lam2 = params.oLong2;
        let phi2 = params.oLat2;
        let con = Math.abs(phi1);
        if (Math.abs(phi1) > (0, $gyVUi.HALF_PI) - (0, $gyVUi.EPSLN)) throw new Error('Invalid value for o_lat_1: ' + params.o_lat_1 + " should be < 90\xb0");
        if (Math.abs(phi2) > (0, $gyVUi.HALF_PI) - (0, $gyVUi.EPSLN)) throw new Error('Invalid value for o_lat_2: ' + params.o_lat_2 + " should be < 90\xb0");
        if (Math.abs(phi1 - phi2) < (0, $gyVUi.EPSLN)) throw new Error('Invalid value for o_lat_1 and o_lat_2: o_lat_1 should be different from o_lat_2');
        if (con < (0, $gyVUi.EPSLN)) throw new Error('Invalid value for o_lat_1: o_lat_1 should be different from zero');
        lamp = Math.atan2(Math.cos(phi1) * Math.sin(phi2) * Math.cos(lam1) - Math.sin(phi1) * Math.cos(phi2) * Math.cos(lam2), Math.sin(phi1) * Math.cos(phi2) * Math.sin(lam2) - Math.cos(phi1) * Math.sin(phi2) * Math.sin(lam1));
        phip = Math.atan(-1 * Math.cos(lamp - lam1) / Math.tan(phi1));
    }
    return {
        lamp: lamp,
        phip: phip
    };
}
/**
 * Forward (lng, lat) to (x, y) for oblique case
 * @param {import('../defs.js').ProjectionDefinition & LocalThis} self
 * @param {{x: number, y: number}} lp - lambda, phi
 */ function $f3795daa9f669a64$var$forwardOblique(self, lp) {
    let { x: lam, y: phi } = lp;
    lam += self.long0;
    const coslam = Math.cos(lam);
    const sinphi = Math.sin(phi);
    const cosphi = Math.cos(phi);
    lp.x = (0, $a9oRf.default)(Math.atan2(cosphi * Math.sin(lam), self.sphip * cosphi * coslam + self.cphip * sinphi) + self.lamp);
    lp.y = Math.asin(self.sphip * sinphi - self.cphip * cosphi * coslam);
    const result = self.obliqueProjection.forward(lp);
    if (self.isIdentity) {
        result.x *= (0, $gyVUi.R2D);
        result.y *= (0, $gyVUi.R2D);
    }
    return result;
}
/**
 * Forward (lng, lat) to (x, y) for transverse case
 * @param {import('../defs.js').ProjectionDefinition & LocalThis} self
 * @param {{x: number, y: number}} lp - lambda, phi
 */ function $f3795daa9f669a64$var$forwardTransverse(self, lp) {
    let { x: lam, y: phi } = lp;
    lam += self.long0;
    const cosphi = Math.cos(phi);
    const coslam = Math.cos(lam);
    lp.x = (0, $a9oRf.default)(Math.atan2(cosphi * Math.sin(lam), Math.sin(phi)) + self.lamp);
    lp.y = Math.asin(-1 * cosphi * coslam);
    const result = self.obliqueProjection.forward(lp);
    if (self.isIdentity) {
        result.x *= (0, $gyVUi.R2D);
        result.y *= (0, $gyVUi.R2D);
    }
    return result;
}
/**
 * Inverse (x, y) to (lng, lat) for oblique case
 * @param {import('../defs.js').ProjectionDefinition & LocalThis} self
 * @param {{x: number, y: number}} lp - lambda, phi
 */ function $f3795daa9f669a64$var$inverseOblique(self, lp) {
    if (self.isIdentity) {
        lp.x *= (0, $gyVUi.D2R);
        lp.y *= (0, $gyVUi.D2R);
    }
    const innerLp = self.obliqueProjection.inverse(lp);
    let { x: lam, y: phi } = innerLp;
    if (lam < Number.MAX_VALUE) {
        lam -= self.lamp;
        const coslam = Math.cos(lam);
        const sinphi = Math.sin(phi);
        const cosphi = Math.cos(phi);
        lp.x = Math.atan2(cosphi * Math.sin(lam), self.sphip * cosphi * coslam - self.cphip * sinphi);
        lp.y = Math.asin(self.sphip * sinphi + self.cphip * cosphi * coslam);
    }
    lp.x = (0, $a9oRf.default)(lp.x + self.long0);
    return lp;
}
/**
 * Inverse (x, y) to (lng, lat) for transverse case
 * @param {import('../defs.js').ProjectionDefinition & LocalThis} self
 * @param {{x: number, y: number}} lp - lambda, phi
 */ function $f3795daa9f669a64$var$inverseTransverse(self, lp) {
    if (self.isIdentity) {
        lp.x *= (0, $gyVUi.D2R);
        lp.y *= (0, $gyVUi.D2R);
    }
    const innerLp = self.obliqueProjection.inverse(lp);
    let { x: lam, y: phi } = innerLp;
    if (lam < Number.MAX_VALUE) {
        const cosphi = Math.cos(phi);
        lam -= self.lamp;
        lp.x = Math.atan2(cosphi * Math.sin(lam), -1 * Math.sin(phi));
        lp.y = Math.asin(cosphi * Math.cos(lam));
    }
    lp.x = (0, $a9oRf.default)(lp.x + self.long0);
    return lp;
}
var $f3795daa9f669a64$export$e4b2ac9215619f8d = [
    'General Oblique Transformation',
    'General_Oblique_Transformation',
    'ob_tran'
];
var $f3795daa9f669a64$export$2e2bcd8739ae039 = {
    init: $f3795daa9f669a64$export$2cd8252107eb640b,
    forward: $f3795daa9f669a64$export$174bb771924e7eb1,
    inverse: $f3795daa9f669a64$export$70ae2c07e401031b,
    names: $f3795daa9f669a64$export$e4b2ac9215619f8d
};

});



// Import JS libraries
/*!
  * Bootstrap v5.3.8 (https://getbootstrap.com/)
  * Copyright 2011-2025 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ var $cc4ed71c4f27adbc$exports = {};

$parcel$export($cc4ed71c4f27adbc$exports, "popperGenerator", () => $60bdf67e43f5dfcb$export$ed5e13716264f202);
$parcel$export($cc4ed71c4f27adbc$exports, "detectOverflow", () => $c24a1421ba2f823c$export$2e2bcd8739ae039);
$parcel$export($cc4ed71c4f27adbc$exports, "createPopperBase", () => $60bdf67e43f5dfcb$export$8f7491d57c8f97a9);
$parcel$export($cc4ed71c4f27adbc$exports, "createPopper", () => $288fbeb449f53487$export$8f7491d57c8f97a9);
$parcel$export($cc4ed71c4f27adbc$exports, "createPopperLite", () => $ef991c361ca719ad$export$8f7491d57c8f97a9);
var $1472b89a65155de2$exports = {};

$parcel$export($1472b89a65155de2$exports, "top", () => $1472b89a65155de2$export$1e95b668f3b82d);
$parcel$export($1472b89a65155de2$exports, "bottom", () => $1472b89a65155de2$export$40e543e69a8b3fbb);
$parcel$export($1472b89a65155de2$exports, "right", () => $1472b89a65155de2$export$79ffe56a765070d2);
$parcel$export($1472b89a65155de2$exports, "left", () => $1472b89a65155de2$export$eabcd2c8791e7bf4);
$parcel$export($1472b89a65155de2$exports, "auto", () => $1472b89a65155de2$export$dfb5619354ba860);
$parcel$export($1472b89a65155de2$exports, "basePlacements", () => $1472b89a65155de2$export$aec2ce47c367b8c3);
$parcel$export($1472b89a65155de2$exports, "start", () => $1472b89a65155de2$export$b3571188c770cc5a);
$parcel$export($1472b89a65155de2$exports, "end", () => $1472b89a65155de2$export$bd5df0f255a350f8);
$parcel$export($1472b89a65155de2$exports, "clippingParents", () => $1472b89a65155de2$export$390fd549c5303b4d);
$parcel$export($1472b89a65155de2$exports, "viewport", () => $1472b89a65155de2$export$d7b7311ec04a3e8f);
$parcel$export($1472b89a65155de2$exports, "popper", () => $1472b89a65155de2$export$ae5ab1c730825774);
$parcel$export($1472b89a65155de2$exports, "reference", () => $1472b89a65155de2$export$ca50aac9f3ba507f);
$parcel$export($1472b89a65155de2$exports, "variationPlacements", () => $1472b89a65155de2$export$368f9a87e87fa4e1);
$parcel$export($1472b89a65155de2$exports, "placements", () => $1472b89a65155de2$export$803cd8101b6c182b);
$parcel$export($1472b89a65155de2$exports, "beforeRead", () => $1472b89a65155de2$export$421679a7c3d56e);
$parcel$export($1472b89a65155de2$exports, "read", () => $1472b89a65155de2$export$aafa59e2e03f2942);
$parcel$export($1472b89a65155de2$exports, "afterRead", () => $1472b89a65155de2$export$6964f6c886723980);
$parcel$export($1472b89a65155de2$exports, "beforeMain", () => $1472b89a65155de2$export$c65e99957a05207c);
$parcel$export($1472b89a65155de2$exports, "main", () => $1472b89a65155de2$export$f22da7240b7add18);
$parcel$export($1472b89a65155de2$exports, "afterMain", () => $1472b89a65155de2$export$bab79516f2d662fe);
$parcel$export($1472b89a65155de2$exports, "beforeWrite", () => $1472b89a65155de2$export$8d4d2d70e7d46032);
$parcel$export($1472b89a65155de2$exports, "write", () => $1472b89a65155de2$export$68d8715fc104d294);
$parcel$export($1472b89a65155de2$exports, "afterWrite", () => $1472b89a65155de2$export$70a6e5159acce2e6);
$parcel$export($1472b89a65155de2$exports, "modifierPhases", () => $1472b89a65155de2$export$d087d3878fdf71d5);
var $1472b89a65155de2$export$1e95b668f3b82d = 'top';
var $1472b89a65155de2$export$40e543e69a8b3fbb = 'bottom';
var $1472b89a65155de2$export$79ffe56a765070d2 = 'right';
var $1472b89a65155de2$export$eabcd2c8791e7bf4 = 'left';
var $1472b89a65155de2$export$dfb5619354ba860 = 'auto';
var $1472b89a65155de2$export$aec2ce47c367b8c3 = [
    $1472b89a65155de2$export$1e95b668f3b82d,
    $1472b89a65155de2$export$40e543e69a8b3fbb,
    $1472b89a65155de2$export$79ffe56a765070d2,
    $1472b89a65155de2$export$eabcd2c8791e7bf4
];
var $1472b89a65155de2$export$b3571188c770cc5a = 'start';
var $1472b89a65155de2$export$bd5df0f255a350f8 = 'end';
var $1472b89a65155de2$export$390fd549c5303b4d = 'clippingParents';
var $1472b89a65155de2$export$d7b7311ec04a3e8f = 'viewport';
var $1472b89a65155de2$export$ae5ab1c730825774 = 'popper';
var $1472b89a65155de2$export$ca50aac9f3ba507f = 'reference';
var $1472b89a65155de2$export$368f9a87e87fa4e1 = /*#__PURE__*/ $1472b89a65155de2$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []);
var $1472b89a65155de2$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($1472b89a65155de2$export$aec2ce47c367b8c3, [
    $1472b89a65155de2$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $1472b89a65155de2$export$421679a7c3d56e = 'beforeRead';
var $1472b89a65155de2$export$aafa59e2e03f2942 = 'read';
var $1472b89a65155de2$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $1472b89a65155de2$export$c65e99957a05207c = 'beforeMain';
var $1472b89a65155de2$export$f22da7240b7add18 = 'main';
var $1472b89a65155de2$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $1472b89a65155de2$export$8d4d2d70e7d46032 = 'beforeWrite';
var $1472b89a65155de2$export$68d8715fc104d294 = 'write';
var $1472b89a65155de2$export$70a6e5159acce2e6 = 'afterWrite';
var $1472b89a65155de2$export$d087d3878fdf71d5 = [
    $1472b89a65155de2$export$421679a7c3d56e,
    $1472b89a65155de2$export$aafa59e2e03f2942,
    $1472b89a65155de2$export$6964f6c886723980,
    $1472b89a65155de2$export$c65e99957a05207c,
    $1472b89a65155de2$export$f22da7240b7add18,
    $1472b89a65155de2$export$bab79516f2d662fe,
    $1472b89a65155de2$export$8d4d2d70e7d46032,
    $1472b89a65155de2$export$68d8715fc104d294,
    $1472b89a65155de2$export$70a6e5159acce2e6
];


var $a3382052de3d061b$exports = {};

$parcel$export($a3382052de3d061b$exports, "applyStyles", () => $7deefb3680d4558f$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "arrow", () => $f37d2f7eaf2ad10e$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "computeStyles", () => $45d468ca92a1d24b$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "eventListeners", () => $e7d7845625089588$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "flip", () => $cf1ba1dd94205465$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "hide", () => $69d8d7bda7717b01$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "offset", () => $ff9a9783c10adebd$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "popperOffsets", () => $8e8ecd9a827a16d7$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "preventOverflow", () => $865d356b2ca960a5$export$2e2bcd8739ae039);
function $04a691b7a330df44$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}


function $6985093033570817$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $69730206aa270d41$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $69730206aa270d41$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $69730206aa270d41$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $7deefb3680d4558f$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || !(0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $7deefb3680d4558f$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || !(0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $7deefb3680d4558f$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $7deefb3680d4558f$var$applyStyles,
    effect: $7deefb3680d4558f$var$effect,
    requires: [
        'computeStyles'
    ]
};



function $c6075629d0814627$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}



var $3711db8b00de96df$export$8960430cfd85939f = Math.max;
var $3711db8b00de96df$export$96ec731ed4dcb222 = Math.min;
var $3711db8b00de96df$export$2077e0241d6afd3c = Math.round;



function $6de7caa8ee90d63c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $bef5ff765617d084$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
}


function $2ef6a598263dba8e$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? (0, $6985093033570817$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $bef5ff765617d084$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $9effe2b32f662e4a$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $8f3b5a3db2e59cbc$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $69730206aa270d41$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}





function $cbd21d1454570861$export$2e2bcd8739ae039(element) {
    return (0, $6985093033570817$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $fd46d779ec622be4$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) >= 0;
}




function $0d1d9daad62fa952$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $773048fc1d2aa7ee$export$2e2bcd8739ae039(element) {
    if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $69730206aa270d41$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $42fc94c94931c781$var$getTrueOffsetParent(element) {
    if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $42fc94c94931c781$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    if (isIE && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element);
    if ((0, $69730206aa270d41$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $69730206aa270d41$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $42fc94c94931c781$export$2e2bcd8739ae039(element) {
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $fd46d779ec622be4$export$2e2bcd8739ae039)(offsetParent) && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $42fc94c94931c781$var$getContainingBlock(element) || window;
}


function $ba9a98a4204389e3$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $95428a5e75015184$export$f28d906d67a997f3(min, value, max) {
    return (0, $3711db8b00de96df$export$8960430cfd85939f)(min, (0, $3711db8b00de96df$export$96ec731ed4dcb222)(value, max));
}
function $95428a5e75015184$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $95428a5e75015184$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $bcb51404109b5184$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $2c6bd604be4c867e$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $bcb51404109b5184$export$2e2bcd8739ae039)(), paddingObject);
}


function $c88039fe47959ef5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}



var $f37d2f7eaf2ad10e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
};
function $f37d2f7eaf2ad10e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $f37d2f7eaf2ad10e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $95428a5e75015184$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $f37d2f7eaf2ad10e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $f37d2f7eaf2ad10e$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $f37d2f7eaf2ad10e$var$arrow,
    effect: $f37d2f7eaf2ad10e$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};








function $5553ed9c2ee225e3$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}



var $45d468ca92a1d24b$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $45d468ca92a1d24b$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $45d468ca92a1d24b$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var sideY = (0, $1472b89a65155de2$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(popper);
            if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || placement === (0, $1472b89a65155de2$export$79ffe56a765070d2)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideY = (0, $1472b89a65155de2$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || placement === (0, $1472b89a65155de2$export$40e543e69a8b3fbb)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideX = (0, $1472b89a65155de2$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $45d468ca92a1d24b$var$unsetSides);
    var _ref4 = roundOffsets === true ? $45d468ca92a1d24b$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $45d468ca92a1d24b$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $45d468ca92a1d24b$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $45d468ca92a1d24b$var$computeStyles,
    data: {}
};



var $e7d7845625089588$var$passive = {
    passive: true
};
function $e7d7845625089588$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $e7d7845625089588$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $e7d7845625089588$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $e7d7845625089588$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $e7d7845625089588$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e7d7845625089588$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $e7d7845625089588$var$effect,
    data: {}
};


var $aaefa8315f14c8e2$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $aaefa8315f14c8e2$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $aaefa8315f14c8e2$var$hash[matched];
    });
}



var $37f85a49ff946cb6$var$hash = {
    start: 'end',
    end: 'start'
};
function $37f85a49ff946cb6$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $37f85a49ff946cb6$var$hash[matched];
    });
}








function $39a9a96b6f99add9$export$2e2bcd8739ae039(node) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $60124eceeef28a28$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)).left + (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $a35bf29d5fc5ab40$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $bef5ff765617d084$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $a5e625ef2dd801ec$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $3711db8b00de96df$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $12881c0013479a14$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $2cddda83e3357241$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(node) && (0, $12881c0013479a14$export$2e2bcd8739ae039)(node)) return node;
    return $2cddda83e3357241$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(node));
}





function $90b72ed15edfd54a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $2cddda83e3357241$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $12881c0013479a14$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($90b72ed15edfd54a$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(target)));
}










function $d5700acdd3ba9a3c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $449799046a13d100$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) ? (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a35bf29d5fc5ab40$export$2e2bcd8739ae039)(element, strategy)) : (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) ? $449799046a13d100$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a5e625ef2dd801ec$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $449799046a13d100$var$getClippingParents(element) {
    var clippingParents = (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) ? (0, $42fc94c94931c781$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) && (0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $04a691b7a330df44$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $449799046a13d100$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $449799046a13d100$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $449799046a13d100$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $9a8b7e877fbba4f3$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1472b89a65155de2$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1472b89a65155de2$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1472b89a65155de2$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1472b89a65155de2$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $1472b89a65155de2$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1472b89a65155de2$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $c24a1421ba2f823c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1472b89a65155de2$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1472b89a65155de2$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? (0, $1472b89a65155de2$export$ca50aac9f3ba507f) : (0, $1472b89a65155de2$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $449799046a13d100$export$2e2bcd8739ae039)((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1472b89a65155de2$export$79ffe56a765070d2),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1472b89a65155de2$export$1e95b668f3b82d),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $dae0983d65fbfc0b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1472b89a65155de2$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $1472b89a65155de2$export$368f9a87e87fa4e1) : (0, $1472b89a65155de2$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $1472b89a65155de2$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $c6075629d0814627$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $cf1ba1dd94205465$var$getExpandedFallbackPlacements(placement) {
    if ((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(placement);
    return [
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $cf1ba1dd94205465$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $cf1ba1dd94205465$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860) ? (0, $dae0983d65fbfc0b$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$b3571188c770cc5a);
        var isVertical = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1472b89a65155de2$export$79ffe56a765070d2) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $cf1ba1dd94205465$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $cf1ba1dd94205465$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};




function $69d8d7bda7717b01$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $69d8d7bda7717b01$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1472b89a65155de2$export$1e95b668f3b82d),
        (0, $1472b89a65155de2$export$79ffe56a765070d2),
        (0, $1472b89a65155de2$export$40e543e69a8b3fbb),
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $69d8d7bda7717b01$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $69d8d7bda7717b01$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $69d8d7bda7717b01$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $69d8d7bda7717b01$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $69d8d7bda7717b01$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $69d8d7bda7717b01$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $69d8d7bda7717b01$var$hide
};




function $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ff9a9783c10adebd$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1472b89a65155de2$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ff9a9783c10adebd$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $ff9a9783c10adebd$var$offset
};



function $8e8ecd9a827a16d7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8e8ecd9a827a16d7$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $8e8ecd9a827a16d7$var$popperOffsets,
    data: {}
};





function $61f76a8076c296c7$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}









function $865d356b2ca960a5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $61f76a8076c296c7$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $bcb51404109b5184$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $95428a5e75015184$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $42fc94c94931c781$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? (0, $3711db8b00de96df$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $3711db8b00de96df$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $95428a5e75015184$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $865d356b2ca960a5$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $865d356b2ca960a5$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};








function $d47756cb7a847081$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $ac7dd8aeabb81fe8$export$2e2bcd8739ae039(node) {
    if (node === (0, $6985093033570817$export$2e2bcd8739ae039)(node) || !(0, $69730206aa270d41$export$1b3bfaa9684536aa)(node)) return (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(node);
    else return (0, $d47756cb7a847081$export$2e2bcd8739ae039)(node);
}








function $bcb265ed9201975a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $bcb265ed9201975a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent) && $bcb265ed9201975a$var$isElementScaled(offsetParent);
    var documentElement = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $12881c0013479a14$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $ac7dd8aeabb81fe8$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $60124eceeef28a28$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $77bc085de34276f2$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $77bc085de34276f2$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $77bc085de34276f2$var$order(modifiers); // order based on phase
    return (0, $1472b89a65155de2$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $9b685cb08303911c$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $f58f9fd4551b4b0f$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $60bdf67e43f5dfcb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $60bdf67e43f5dfcb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(reference) ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $77bc085de34276f2$export$2e2bcd8739ae039)((0, $f58f9fd4551b4b0f$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $bcb265ed9201975a$export$2e2bcd8739ae039)(reference, (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9b685cb08303911c$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $60bdf67e43f5dfcb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $60bdf67e43f5dfcb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules














var $288fbeb449f53487$export$d34966752335dd47 = [
    (0, $e7d7845625089588$export$2e2bcd8739ae039),
    (0, $8e8ecd9a827a16d7$export$2e2bcd8739ae039),
    (0, $45d468ca92a1d24b$export$2e2bcd8739ae039),
    (0, $7deefb3680d4558f$export$2e2bcd8739ae039),
    (0, $ff9a9783c10adebd$export$2e2bcd8739ae039),
    (0, $cf1ba1dd94205465$export$2e2bcd8739ae039),
    (0, $865d356b2ca960a5$export$2e2bcd8739ae039),
    (0, $f37d2f7eaf2ad10e$export$2e2bcd8739ae039),
    (0, $69d8d7bda7717b01$export$2e2bcd8739ae039)
];
var $288fbeb449f53487$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $60bdf67e43f5dfcb$export$ed5e13716264f202)({
    defaultModifiers: $288fbeb449f53487$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules







var $ef991c361ca719ad$export$d34966752335dd47 = [
    (0, $e7d7845625089588$export$2e2bcd8739ae039),
    (0, $8e8ecd9a827a16d7$export$2e2bcd8739ae039),
    (0, $45d468ca92a1d24b$export$2e2bcd8739ae039),
    (0, $7deefb3680d4558f$export$2e2bcd8739ae039)
];
var $ef991c361ca719ad$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $60bdf67e43f5dfcb$export$ed5e13716264f202)({
    defaultModifiers: $ef991c361ca719ad$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


$parcel$exportWildcard($cc4ed71c4f27adbc$exports, $1472b89a65155de2$exports);
$parcel$exportWildcard($cc4ed71c4f27adbc$exports, $a3382052de3d061b$exports);


/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$elementMap = new Map();
const $e9dd36436aec3b21$var$Data = {
    set (element, key, instance) {
        if (!$e9dd36436aec3b21$var$elementMap.has(element)) $e9dd36436aec3b21$var$elementMap.set(element, new Map());
        const instanceMap = $e9dd36436aec3b21$var$elementMap.get(element);
        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
            return;
        }
        instanceMap.set(key, instance);
    },
    get (element, key) {
        if ($e9dd36436aec3b21$var$elementMap.has(element)) return $e9dd36436aec3b21$var$elementMap.get(element).get(key) || null;
        return null;
    },
    remove (element, key) {
        if (!$e9dd36436aec3b21$var$elementMap.has(element)) return;
        const instanceMap = $e9dd36436aec3b21$var$elementMap.get(element);
        instanceMap.delete(key);
        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) $e9dd36436aec3b21$var$elementMap.delete(element);
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $e9dd36436aec3b21$var$MAX_UID = 1000000;
const $e9dd36436aec3b21$var$MILLISECONDS_MULTIPLIER = 1000;
const $e9dd36436aec3b21$var$TRANSITION_END = 'transitionend';
/**
 * Properly escape IDs selectors to handle weird IDs
 * @param {string} selector
 * @returns {string}
 */ const $e9dd36436aec3b21$var$parseSelector = (selector)=>{
    if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
    selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
    return selector;
};
// Shout-out Angus Croll (https://goo.gl/pxwQGp)
const $e9dd36436aec3b21$var$toType = (object)=>{
    if (object === null || object === undefined) return `${object}`;
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ const $e9dd36436aec3b21$var$getUID = (prefix)=>{
    do prefix += Math.floor(Math.random() * $e9dd36436aec3b21$var$MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
const $e9dd36436aec3b21$var$getTransitionDurationFromElement = (element)=>{
    if (!element) return 0;
    // Get transition-duration of the element
    let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
    const floatTransitionDuration = Number.parseFloat(transitionDuration);
    const floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(',')[0];
    transitionDelay = transitionDelay.split(',')[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * $e9dd36436aec3b21$var$MILLISECONDS_MULTIPLIER;
};
const $e9dd36436aec3b21$var$triggerTransitionEnd = (element)=>{
    element.dispatchEvent(new Event($e9dd36436aec3b21$var$TRANSITION_END));
};
const $e9dd36436aec3b21$var$isElement = (object)=>{
    if (!object || typeof object !== 'object') return false;
    if (typeof object.jquery !== 'undefined') object = object[0];
    return typeof object.nodeType !== 'undefined';
};
const $e9dd36436aec3b21$var$getElement = (object)=>{
    // it's a jQuery object or a node element
    if ($e9dd36436aec3b21$var$isElement(object)) return object.jquery ? object[0] : object;
    if (typeof object === 'string' && object.length > 0) return document.querySelector($e9dd36436aec3b21$var$parseSelector(object));
    return null;
};
const $e9dd36436aec3b21$var$isVisible = (element)=>{
    if (!$e9dd36436aec3b21$var$isElement(element) || element.getClientRects().length === 0) return false;
    const elementIsVisible = getComputedStyle(element).getPropertyValue('visibility') === 'visible';
    // Handle `details` element as its content may falsie appear visible when it is closed
    const closedDetails = element.closest('details:not([open])');
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        const summary = element.closest('summary');
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
const $e9dd36436aec3b21$var$isDisabled = (element)=>{
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains('disabled')) return true;
    if (typeof element.disabled !== 'undefined') return element.disabled;
    return element.hasAttribute('disabled') && element.getAttribute('disabled') !== 'false';
};
const $e9dd36436aec3b21$var$findShadowRoot = (element)=>{
    if (!document.documentElement.attachShadow) return null;
    // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === 'function') {
        const root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
    // when we don't find a shadow root
    if (!element.parentNode) return null;
    return $e9dd36436aec3b21$var$findShadowRoot(element.parentNode);
};
const $e9dd36436aec3b21$var$noop = ()=>{};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.harrytheo.com/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ const $e9dd36436aec3b21$var$reflow = (element)=>{
    element.offsetHeight; // eslint-disable-line no-unused-expressions
};
const $e9dd36436aec3b21$var$getjQuery = ()=>{
    if (window.jQuery && !document.body.hasAttribute('data-bs-no-jquery')) return window.jQuery;
    return null;
};
const $e9dd36436aec3b21$var$DOMContentLoadedCallbacks = [];
const $e9dd36436aec3b21$var$onDOMContentLoaded = (callback)=>{
    if (document.readyState === 'loading') {
        // add listener on the first call when the document is in loading state
        if (!$e9dd36436aec3b21$var$DOMContentLoadedCallbacks.length) document.addEventListener('DOMContentLoaded', ()=>{
            for (const callback of $e9dd36436aec3b21$var$DOMContentLoadedCallbacks)callback();
        });
        $e9dd36436aec3b21$var$DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
const $e9dd36436aec3b21$var$isRTL = ()=>document.documentElement.dir === 'rtl';
const $e9dd36436aec3b21$var$defineJQueryPlugin = (plugin)=>{
    $e9dd36436aec3b21$var$onDOMContentLoaded(()=>{
        const $ = $e9dd36436aec3b21$var$getjQuery();
        /* istanbul ignore if */ if ($) {
            const name = plugin.NAME;
            const JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = ()=>{
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
const $e9dd36436aec3b21$var$execute = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
    return typeof possibleCallback === 'function' ? possibleCallback.call(...args) : defaultValue;
};
const $e9dd36436aec3b21$var$executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
    if (!waitForTransition) {
        $e9dd36436aec3b21$var$execute(callback);
        return;
    }
    const durationPadding = 5;
    const emulatedDuration = $e9dd36436aec3b21$var$getTransitionDurationFromElement(transitionElement) + durationPadding;
    let called = false;
    const handler = ({ target: target })=>{
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener($e9dd36436aec3b21$var$TRANSITION_END, handler);
        $e9dd36436aec3b21$var$execute(callback);
    };
    transitionElement.addEventListener($e9dd36436aec3b21$var$TRANSITION_END, handler);
    setTimeout(()=>{
        if (!called) $e9dd36436aec3b21$var$triggerTransitionEnd(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ const $e9dd36436aec3b21$var$getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
    const listLength = list.length;
    let index = list.indexOf(activeElement);
    // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
const $e9dd36436aec3b21$var$stripNameRegex = /\..*/;
const $e9dd36436aec3b21$var$stripUidRegex = /::\d+$/;
const $e9dd36436aec3b21$var$eventRegistry = {}; // Events storage
let $e9dd36436aec3b21$var$uidEvent = 1;
const $e9dd36436aec3b21$var$customEvents = {
    mouseenter: 'mouseover',
    mouseleave: 'mouseout'
};
const $e9dd36436aec3b21$var$nativeEvents = new Set([
    'click',
    'dblclick',
    'mouseup',
    'mousedown',
    'contextmenu',
    'mousewheel',
    'DOMMouseScroll',
    'mouseover',
    'mouseout',
    'mousemove',
    'selectstart',
    'selectend',
    'keydown',
    'keypress',
    'keyup',
    'orientationchange',
    'touchstart',
    'touchmove',
    'touchend',
    'touchcancel',
    'pointerdown',
    'pointermove',
    'pointerup',
    'pointerleave',
    'pointercancel',
    'gesturestart',
    'gesturechange',
    'gestureend',
    'focus',
    'blur',
    'change',
    'reset',
    'select',
    'submit',
    'focusin',
    'focusout',
    'load',
    'unload',
    'beforeunload',
    'resize',
    'move',
    'DOMContentLoaded',
    'readystatechange',
    'error',
    'abort',
    'scroll'
]);
/**
 * Private methods
 */ function $e9dd36436aec3b21$var$makeEventUid(element, uid) {
    return uid && `${uid}::${$e9dd36436aec3b21$var$uidEvent++}` || element.uidEvent || $e9dd36436aec3b21$var$uidEvent++;
}
function $e9dd36436aec3b21$var$getElementEvents(element) {
    const uid = $e9dd36436aec3b21$var$makeEventUid(element);
    element.uidEvent = uid;
    $e9dd36436aec3b21$var$eventRegistry[uid] = $e9dd36436aec3b21$var$eventRegistry[uid] || {};
    return $e9dd36436aec3b21$var$eventRegistry[uid];
}
function $e9dd36436aec3b21$var$bootstrapHandler(element, fn) {
    return function handler(event) {
        $e9dd36436aec3b21$var$hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) $e9dd36436aec3b21$var$EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function $e9dd36436aec3b21$var$bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        const domElements = element.querySelectorAll(selector);
        for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
            if (domElement !== target) continue;
            $e9dd36436aec3b21$var$hydrateObj(event, {
                delegateTarget: target
            });
            if (handler.oneOff) $e9dd36436aec3b21$var$EventHandler.off(element, event.type, selector, fn);
            return fn.apply(target, [
                event
            ]);
        }
    };
}
function $e9dd36436aec3b21$var$findHandler(events, callable, delegationSelector = null) {
    return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
}
function $e9dd36436aec3b21$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    const isDelegated = typeof handler === 'string';
    // TODO: tooltip passes `false` instead of selector, so we need to check
    const callable = isDelegated ? delegationFunction : handler || delegationFunction;
    let typeEvent = $e9dd36436aec3b21$var$getTypeEvent(originalTypeEvent);
    if (!$e9dd36436aec3b21$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $e9dd36436aec3b21$var$addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== 'string' || !element) return;
    let [isDelegated, callable, typeEvent] = $e9dd36436aec3b21$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
    // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in $e9dd36436aec3b21$var$customEvents) {
        const wrapFunction = (fn)=>{
            return function(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    const events = $e9dd36436aec3b21$var$getElementEvents(element);
    const handlers = events[typeEvent] || (events[typeEvent] = {});
    const previousFunction = $e9dd36436aec3b21$var$findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    const uid = $e9dd36436aec3b21$var$makeEventUid(callable, originalTypeEvent.replace($e9dd36436aec3b21$var$namespaceRegex, ''));
    const fn = isDelegated ? $e9dd36436aec3b21$var$bootstrapDelegationHandler(element, handler, callable) : $e9dd36436aec3b21$var$bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function $e9dd36436aec3b21$var$removeHandler(element, events, typeEvent, handler, delegationSelector) {
    const fn = $e9dd36436aec3b21$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $e9dd36436aec3b21$var$removeNamespacedHandlers(element, events, typeEvent, namespace) {
    const storeElementEvent = events[typeEvent] || {};
    for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) $e9dd36436aec3b21$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
}
function $e9dd36436aec3b21$var$getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace($e9dd36436aec3b21$var$stripNameRegex, '');
    return $e9dd36436aec3b21$var$customEvents[event] || event;
}
const $e9dd36436aec3b21$var$EventHandler = {
    on (element, event, handler, delegationFunction) {
        $e9dd36436aec3b21$var$addHandler(element, event, handler, delegationFunction, false);
    },
    one (element, event, handler, delegationFunction) {
        $e9dd36436aec3b21$var$addHandler(element, event, handler, delegationFunction, true);
    },
    off (element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== 'string' || !element) return;
        const [isDelegated, callable, typeEvent] = $e9dd36436aec3b21$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
        const inNamespace = typeEvent !== originalTypeEvent;
        const events = $e9dd36436aec3b21$var$getElementEvents(element);
        const storeElementEvent = events[typeEvent] || {};
        const isNamespace = originalTypeEvent.startsWith('.');
        if (typeof callable !== 'undefined') {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            $e9dd36436aec3b21$var$removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        if (isNamespace) for (const elementEvent of Object.keys(events))$e9dd36436aec3b21$var$removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
        for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
            const handlerKey = keyHandlers.replace($e9dd36436aec3b21$var$stripUidRegex, '');
            if (!inNamespace || originalTypeEvent.includes(handlerKey)) $e9dd36436aec3b21$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
    },
    trigger (element, event, args) {
        if (typeof event !== 'string' || !element) return null;
        const $ = $e9dd36436aec3b21$var$getjQuery();
        const typeEvent = $e9dd36436aec3b21$var$getTypeEvent(event);
        const inNamespace = event !== typeEvent;
        let jQueryEvent = null;
        let bubbles = true;
        let nativeDispatch = true;
        let defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        const evt = $e9dd36436aec3b21$var$hydrateObj(new Event(event, {
            bubbles: bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $e9dd36436aec3b21$var$hydrateObj(obj, meta = {}) {
    for (const [key, value] of Object.entries(meta))try {
        obj[key] = value;
    } catch (_unused) {
        Object.defineProperty(obj, key, {
            configurable: true,
            get () {
                return value;
            }
        });
    }
    return obj;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function $e9dd36436aec3b21$var$normalizeData(value) {
    if (value === 'true') return true;
    if (value === 'false') return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === '' || value === 'null') return null;
    if (typeof value !== 'string') return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch (_unused) {
        return value;
    }
}
function $e9dd36436aec3b21$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
}
const $e9dd36436aec3b21$var$Manipulator = {
    setDataAttribute (element, key, value) {
        element.setAttribute(`data-bs-${$e9dd36436aec3b21$var$normalizeDataKey(key)}`, value);
    },
    removeDataAttribute (element, key) {
        element.removeAttribute(`data-bs-${$e9dd36436aec3b21$var$normalizeDataKey(key)}`);
    },
    getDataAttributes (element) {
        if (!element) return {};
        const attributes = {};
        const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith('bs') && !key.startsWith('bsConfig'));
        for (const key of bsKeys){
            let pureKey = key.replace(/^bs/, '');
            pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1);
            attributes[pureKey] = $e9dd36436aec3b21$var$normalizeData(element.dataset[key]);
        }
        return attributes;
    },
    getDataAttribute (element, key) {
        return $e9dd36436aec3b21$var$normalizeData(element.getAttribute(`data-bs-${$e9dd36436aec3b21$var$normalizeDataKey(key)}`));
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Class definition
 */ class $e9dd36436aec3b21$var$Config {
    // Getters
    static get Default() {
        return {};
    }
    static get DefaultType() {
        return {};
    }
    static get NAME() {
        throw new Error('You have to implement the static method "NAME", for each component!');
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        return config;
    }
    _mergeConfigObj(config, element) {
        const jsonConfig = $e9dd36436aec3b21$var$isElement(element) ? $e9dd36436aec3b21$var$Manipulator.getDataAttribute(element, 'config') : {}; // try to parse
        return {
            ...this.constructor.Default,
            ...typeof jsonConfig === 'object' ? jsonConfig : {},
            ...$e9dd36436aec3b21$var$isElement(element) ? $e9dd36436aec3b21$var$Manipulator.getDataAttributes(element) : {},
            ...typeof config === 'object' ? config : {}
        };
    }
    _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
        for (const [property, expectedTypes] of Object.entries(configTypes)){
            const value = config[property];
            const valueType = $e9dd36436aec3b21$var$isElement(value) ? 'element' : $e9dd36436aec3b21$var$toType(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        }
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$VERSION = '5.3.8';
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$BaseComponent extends $e9dd36436aec3b21$var$Config {
    constructor(element, config){
        super();
        element = $e9dd36436aec3b21$var$getElement(element);
        if (!element) return;
        this._element = element;
        this._config = this._getConfig(config);
        $e9dd36436aec3b21$var$Data.set(this._element, this.constructor.DATA_KEY, this);
    }
    // Public
    dispose() {
        $e9dd36436aec3b21$var$Data.remove(this._element, this.constructor.DATA_KEY);
        $e9dd36436aec3b21$var$EventHandler.off(this._element, this.constructor.EVENT_KEY);
        for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
    }
    // Private
    _queueCallback(callback, element, isAnimated = true) {
        $e9dd36436aec3b21$var$executeAfterTransition(callback, element, isAnimated);
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config, this._element);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    // Static
    static getInstance(element) {
        return $e9dd36436aec3b21$var$Data.get($e9dd36436aec3b21$var$getElement(element), this.DATA_KEY);
    }
    static getOrCreateInstance(element, config = {}) {
        return this.getInstance(element) || new this(element, typeof config === 'object' ? config : null);
    }
    static get VERSION() {
        return $e9dd36436aec3b21$var$VERSION;
    }
    static get DATA_KEY() {
        return `bs.${this.NAME}`;
    }
    static get EVENT_KEY() {
        return `.${this.DATA_KEY}`;
    }
    static eventName(name) {
        return `${name}${this.EVENT_KEY}`;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $e9dd36436aec3b21$var$getSelector = (element)=>{
    let selector = element.getAttribute('data-bs-target');
    if (!selector || selector === '#') {
        let hrefAttribute = element.getAttribute('href');
        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes('#') && !hrefAttribute.startsWith('.')) return null;
        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes('#') && !hrefAttribute.startsWith('#')) hrefAttribute = `#${hrefAttribute.split('#')[1]}`;
        selector = hrefAttribute && hrefAttribute !== '#' ? hrefAttribute.trim() : null;
    }
    return selector ? selector.split(',').map((sel)=>$e9dd36436aec3b21$var$parseSelector(sel)).join(',') : null;
};
const $e9dd36436aec3b21$var$SelectorEngine = {
    find (selector, element = document.documentElement) {
        return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
    },
    findOne (selector, element = document.documentElement) {
        return Element.prototype.querySelector.call(element, selector);
    },
    children (element, selector) {
        return [].concat(...element.children).filter((child)=>child.matches(selector));
    },
    parents (element, selector) {
        const parents = [];
        let ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev (element, selector) {
        let previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next (element, selector) {
        let next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren (element) {
        const focusables = [
            'a',
            'button',
            'input',
            'textarea',
            'select',
            'details',
            '[tabindex]',
            '[contenteditable="true"]'
        ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(',');
        return this.find(focusables, element).filter((el)=>!$e9dd36436aec3b21$var$isDisabled(el) && $e9dd36436aec3b21$var$isVisible(el));
    },
    getSelectorFromElement (element) {
        const selector = $e9dd36436aec3b21$var$getSelector(element);
        if (selector) return $e9dd36436aec3b21$var$SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector (element) {
        const selector = $e9dd36436aec3b21$var$getSelector(element);
        return selector ? $e9dd36436aec3b21$var$SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector (element) {
        const selector = $e9dd36436aec3b21$var$getSelector(element);
        return selector ? $e9dd36436aec3b21$var$SelectorEngine.find(selector) : [];
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $e9dd36436aec3b21$var$enableDismissTrigger = (component, method = 'hide')=>{
    const clickEvent = `click.dismiss${component.EVENT_KEY}`;
    const name = component.NAME;
    $e9dd36436aec3b21$var$EventHandler.on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
        if ([
            'A',
            'AREA'
        ].includes(this.tagName)) event.preventDefault();
        if ($e9dd36436aec3b21$var$isDisabled(this)) return;
        const target = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(this) || this.closest(`.${name}`);
        const instance = component.getOrCreateInstance(target);
        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$f = 'alert';
const $e9dd36436aec3b21$var$DATA_KEY$a = 'bs.alert';
const $e9dd36436aec3b21$var$EVENT_KEY$b = `.${$e9dd36436aec3b21$var$DATA_KEY$a}`;
const $e9dd36436aec3b21$var$EVENT_CLOSE = `close${$e9dd36436aec3b21$var$EVENT_KEY$b}`;
const $e9dd36436aec3b21$var$EVENT_CLOSED = `closed${$e9dd36436aec3b21$var$EVENT_KEY$b}`;
const $e9dd36436aec3b21$var$CLASS_NAME_FADE$5 = 'fade';
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$8 = 'show';
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$caec2af78bcc877f extends $e9dd36436aec3b21$var$BaseComponent {
    // Getters
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$f;
    }
    // Public
    close() {
        const closeEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_CLOSE);
        if (closeEvent.defaultPrevented) return;
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$8);
        const isAnimated = this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_FADE$5);
        this._queueCallback(()=>this._destroyElement(), this._element, isAnimated);
    }
    // Private
    _destroyElement() {
        this._element.remove();
        $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_CLOSED);
        this.dispose();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$caec2af78bcc877f.getOrCreateInstance(this);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$enableDismissTrigger($e9dd36436aec3b21$export$caec2af78bcc877f, 'close');
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$caec2af78bcc877f);
/**
 * --------------------------------------------------------------------------
 * Bootstrap button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$e = 'button';
const $e9dd36436aec3b21$var$DATA_KEY$9 = 'bs.button';
const $e9dd36436aec3b21$var$EVENT_KEY$a = `.${$e9dd36436aec3b21$var$DATA_KEY$9}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$6 = '.data-api';
const $e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$3 = 'active';
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$6 = `click${$e9dd36436aec3b21$var$EVENT_KEY$a}${$e9dd36436aec3b21$var$DATA_API_KEY$6}`;
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$353f5b6fc5456de1 extends $e9dd36436aec3b21$var$BaseComponent {
    // Getters
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$e;
    }
    // Public
    toggle() {
        // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
        this._element.setAttribute('aria-pressed', this._element.classList.toggle($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$3));
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$353f5b6fc5456de1.getOrCreateInstance(this);
            if (config === 'toggle') data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$6, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$5, (event)=>{
    event.preventDefault();
    const button = event.target.closest($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$5);
    const data = $e9dd36436aec3b21$export$353f5b6fc5456de1.getOrCreateInstance(button);
    data.toggle();
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$353f5b6fc5456de1);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/swipe.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$d = 'swipe';
const $e9dd36436aec3b21$var$EVENT_KEY$9 = '.bs.swipe';
const $e9dd36436aec3b21$var$EVENT_TOUCHSTART = `touchstart${$e9dd36436aec3b21$var$EVENT_KEY$9}`;
const $e9dd36436aec3b21$var$EVENT_TOUCHMOVE = `touchmove${$e9dd36436aec3b21$var$EVENT_KEY$9}`;
const $e9dd36436aec3b21$var$EVENT_TOUCHEND = `touchend${$e9dd36436aec3b21$var$EVENT_KEY$9}`;
const $e9dd36436aec3b21$var$EVENT_POINTERDOWN = `pointerdown${$e9dd36436aec3b21$var$EVENT_KEY$9}`;
const $e9dd36436aec3b21$var$EVENT_POINTERUP = `pointerup${$e9dd36436aec3b21$var$EVENT_KEY$9}`;
const $e9dd36436aec3b21$var$POINTER_TYPE_TOUCH = 'touch';
const $e9dd36436aec3b21$var$POINTER_TYPE_PEN = 'pen';
const $e9dd36436aec3b21$var$CLASS_NAME_POINTER_EVENT = 'pointer-event';
const $e9dd36436aec3b21$var$SWIPE_THRESHOLD = 40;
const $e9dd36436aec3b21$var$Default$c = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
const $e9dd36436aec3b21$var$DefaultType$c = {
    endCallback: '(function|null)',
    leftCallback: '(function|null)',
    rightCallback: '(function|null)'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$Swipe extends $e9dd36436aec3b21$var$Config {
    constructor(element, config){
        super();
        this._element = element;
        if (!element || !$e9dd36436aec3b21$var$Swipe.isSupported()) return;
        this._config = this._getConfig(config);
        this._deltaX = 0;
        this._supportPointerEvents = Boolean(window.PointerEvent);
        this._initEvents();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$c;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$c;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$d;
    }
    // Public
    dispose() {
        $e9dd36436aec3b21$var$EventHandler.off(this._element, $e9dd36436aec3b21$var$EVENT_KEY$9);
    }
    // Private
    _start(event) {
        if (!this._supportPointerEvents) {
            this._deltaX = event.touches[0].clientX;
            return;
        }
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
    }
    _end(event) {
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
        this._handleSwipe();
        $e9dd36436aec3b21$var$execute(this._config.endCallback);
    }
    _move(event) {
        this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
    }
    _handleSwipe() {
        const absDeltaX = Math.abs(this._deltaX);
        if (absDeltaX <= $e9dd36436aec3b21$var$SWIPE_THRESHOLD) return;
        const direction = absDeltaX / this._deltaX;
        this._deltaX = 0;
        if (!direction) return;
        $e9dd36436aec3b21$var$execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
    }
    _initEvents() {
        if (this._supportPointerEvents) {
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_POINTERDOWN, (event)=>this._start(event));
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_POINTERUP, (event)=>this._end(event));
            this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_POINTER_EVENT);
        } else {
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_TOUCHSTART, (event)=>this._start(event));
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_TOUCHMOVE, (event)=>this._move(event));
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_TOUCHEND, (event)=>this._end(event));
        }
    }
    _eventIsPointerPenTouch(event) {
        return this._supportPointerEvents && (event.pointerType === $e9dd36436aec3b21$var$POINTER_TYPE_PEN || event.pointerType === $e9dd36436aec3b21$var$POINTER_TYPE_TOUCH);
    }
    // Static
    static isSupported() {
        return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$c = 'carousel';
const $e9dd36436aec3b21$var$DATA_KEY$8 = 'bs.carousel';
const $e9dd36436aec3b21$var$EVENT_KEY$8 = `.${$e9dd36436aec3b21$var$DATA_KEY$8}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$5 = '.data-api';
const $e9dd36436aec3b21$var$ARROW_LEFT_KEY$1 = 'ArrowLeft';
const $e9dd36436aec3b21$var$ARROW_RIGHT_KEY$1 = 'ArrowRight';
const $e9dd36436aec3b21$var$TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
const $e9dd36436aec3b21$var$ORDER_NEXT = 'next';
const $e9dd36436aec3b21$var$ORDER_PREV = 'prev';
const $e9dd36436aec3b21$var$DIRECTION_LEFT = 'left';
const $e9dd36436aec3b21$var$DIRECTION_RIGHT = 'right';
const $e9dd36436aec3b21$var$EVENT_SLIDE = `slide${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_SLID = `slid${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN$1 = `keydown${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_MOUSEENTER$1 = `mouseenter${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_MOUSELEAVE$1 = `mouseleave${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_DRAG_START = `dragstart${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$3 = `load${$e9dd36436aec3b21$var$EVENT_KEY$8}${$e9dd36436aec3b21$var$DATA_API_KEY$5}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$5 = `click${$e9dd36436aec3b21$var$EVENT_KEY$8}${$e9dd36436aec3b21$var$DATA_API_KEY$5}`;
const $e9dd36436aec3b21$var$CLASS_NAME_CAROUSEL = 'carousel';
const $e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$2 = 'active';
const $e9dd36436aec3b21$var$CLASS_NAME_SLIDE = 'slide';
const $e9dd36436aec3b21$var$CLASS_NAME_END = 'carousel-item-end';
const $e9dd36436aec3b21$var$CLASS_NAME_START = 'carousel-item-start';
const $e9dd36436aec3b21$var$CLASS_NAME_NEXT = 'carousel-item-next';
const $e9dd36436aec3b21$var$CLASS_NAME_PREV = 'carousel-item-prev';
const $e9dd36436aec3b21$var$SELECTOR_ACTIVE = '.active';
const $e9dd36436aec3b21$var$SELECTOR_ITEM = '.carousel-item';
const $e9dd36436aec3b21$var$SELECTOR_ACTIVE_ITEM = $e9dd36436aec3b21$var$SELECTOR_ACTIVE + $e9dd36436aec3b21$var$SELECTOR_ITEM;
const $e9dd36436aec3b21$var$SELECTOR_ITEM_IMG = '.carousel-item img';
const $e9dd36436aec3b21$var$SELECTOR_INDICATORS = '.carousel-indicators';
const $e9dd36436aec3b21$var$SELECTOR_DATA_SLIDE = '[data-bs-slide], [data-bs-slide-to]';
const $e9dd36436aec3b21$var$SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
const $e9dd36436aec3b21$var$KEY_TO_DIRECTION = {
    [$e9dd36436aec3b21$var$ARROW_LEFT_KEY$1]: $e9dd36436aec3b21$var$DIRECTION_RIGHT,
    [$e9dd36436aec3b21$var$ARROW_RIGHT_KEY$1]: $e9dd36436aec3b21$var$DIRECTION_LEFT
};
const $e9dd36436aec3b21$var$Default$b = {
    interval: 5000,
    keyboard: true,
    pause: 'hover',
    ride: false,
    touch: true,
    wrap: true
};
const $e9dd36436aec3b21$var$DefaultType$b = {
    interval: '(number|boolean)',
    // TODO:v6 remove boolean support
    keyboard: 'boolean',
    pause: '(string|boolean)',
    ride: '(boolean|string)',
    touch: 'boolean',
    wrap: 'boolean'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$144901db2ea8e967 extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._interval = null;
        this._activeElement = null;
        this._isSliding = false;
        this.touchTimeout = null;
        this._swipeHelper = null;
        this._indicatorsElement = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_INDICATORS, this._element);
        this._addEventListeners();
        if (this._config.ride === $e9dd36436aec3b21$var$CLASS_NAME_CAROUSEL) this.cycle();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$b;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$b;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$c;
    }
    // Public
    next() {
        this._slide($e9dd36436aec3b21$var$ORDER_NEXT);
    }
    nextWhenVisible() {
        // FIXME TODO use `document.visibilityState`
        // Don't call next when the page isn't visible
        // or the carousel or its parent isn't visible
        if (!document.hidden && $e9dd36436aec3b21$var$isVisible(this._element)) this.next();
    }
    prev() {
        this._slide($e9dd36436aec3b21$var$ORDER_PREV);
    }
    pause() {
        if (this._isSliding) $e9dd36436aec3b21$var$triggerTransitionEnd(this._element);
        this._clearInterval();
    }
    cycle() {
        this._clearInterval();
        this._updateInterval();
        this._interval = setInterval(()=>this.nextWhenVisible(), this._config.interval);
    }
    _maybeEnableCycle() {
        if (!this._config.ride) return;
        if (this._isSliding) {
            $e9dd36436aec3b21$var$EventHandler.one(this._element, $e9dd36436aec3b21$var$EVENT_SLID, ()=>this.cycle());
            return;
        }
        this.cycle();
    }
    to(index) {
        const items = this._getItems();
        if (index > items.length - 1 || index < 0) return;
        if (this._isSliding) {
            $e9dd36436aec3b21$var$EventHandler.one(this._element, $e9dd36436aec3b21$var$EVENT_SLID, ()=>this.to(index));
            return;
        }
        const activeIndex = this._getItemIndex(this._getActive());
        if (activeIndex === index) return;
        const order = index > activeIndex ? $e9dd36436aec3b21$var$ORDER_NEXT : $e9dd36436aec3b21$var$ORDER_PREV;
        this._slide(order, items[index]);
    }
    dispose() {
        if (this._swipeHelper) this._swipeHelper.dispose();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        config.defaultInterval = config.interval;
        return config;
    }
    _addEventListeners() {
        if (this._config.keyboard) $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_KEYDOWN$1, (event)=>this._keydown(event));
        if (this._config.pause === 'hover') {
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_MOUSEENTER$1, ()=>this.pause());
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_MOUSELEAVE$1, ()=>this._maybeEnableCycle());
        }
        if (this._config.touch && $e9dd36436aec3b21$var$Swipe.isSupported()) this._addTouchEventListeners();
    }
    _addTouchEventListeners() {
        for (const img of $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_ITEM_IMG, this._element))$e9dd36436aec3b21$var$EventHandler.on(img, $e9dd36436aec3b21$var$EVENT_DRAG_START, (event)=>event.preventDefault());
        const endCallBack = ()=>{
            if (this._config.pause !== 'hover') return;
            // If it's a touch-enabled device, mouseenter/leave are fired as
            // part of the mouse compatibility events on first tap - the carousel
            // would stop cycling until user tapped out of it;
            // here, we listen for touchend, explicitly pause the carousel
            // (as if it's the second time we tap on it, mouseenter compat event
            // is NOT fired) and after a timeout (to allow for mouse compatibility
            // events to fire) we explicitly restart cycling
            this.pause();
            if (this.touchTimeout) clearTimeout(this.touchTimeout);
            this.touchTimeout = setTimeout(()=>this._maybeEnableCycle(), $e9dd36436aec3b21$var$TOUCHEVENT_COMPAT_WAIT + this._config.interval);
        };
        const swipeConfig = {
            leftCallback: ()=>this._slide(this._directionToOrder($e9dd36436aec3b21$var$DIRECTION_LEFT)),
            rightCallback: ()=>this._slide(this._directionToOrder($e9dd36436aec3b21$var$DIRECTION_RIGHT)),
            endCallback: endCallBack
        };
        this._swipeHelper = new $e9dd36436aec3b21$var$Swipe(this._element, swipeConfig);
    }
    _keydown(event) {
        if (/input|textarea/i.test(event.target.tagName)) return;
        const direction = $e9dd36436aec3b21$var$KEY_TO_DIRECTION[event.key];
        if (direction) {
            event.preventDefault();
            this._slide(this._directionToOrder(direction));
        }
    }
    _getItemIndex(element) {
        return this._getItems().indexOf(element);
    }
    _setActiveIndicatorElement(index) {
        if (!this._indicatorsElement) return;
        const activeIndicator = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_ACTIVE, this._indicatorsElement);
        activeIndicator.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$2);
        activeIndicator.removeAttribute('aria-current');
        const newActiveIndicator = $e9dd36436aec3b21$var$SelectorEngine.findOne(`[data-bs-slide-to="${index}"]`, this._indicatorsElement);
        if (newActiveIndicator) {
            newActiveIndicator.classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$2);
            newActiveIndicator.setAttribute('aria-current', 'true');
        }
    }
    _updateInterval() {
        const element = this._activeElement || this._getActive();
        if (!element) return;
        const elementInterval = Number.parseInt(element.getAttribute('data-bs-interval'), 10);
        this._config.interval = elementInterval || this._config.defaultInterval;
    }
    _slide(order, element = null) {
        if (this._isSliding) return;
        const activeElement = this._getActive();
        const isNext = order === $e9dd36436aec3b21$var$ORDER_NEXT;
        const nextElement = element || $e9dd36436aec3b21$var$getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
        if (nextElement === activeElement) return;
        const nextElementIndex = this._getItemIndex(nextElement);
        const triggerEvent = (eventName)=>{
            return $e9dd36436aec3b21$var$EventHandler.trigger(this._element, eventName, {
                relatedTarget: nextElement,
                direction: this._orderToDirection(order),
                from: this._getItemIndex(activeElement),
                to: nextElementIndex
            });
        };
        const slideEvent = triggerEvent($e9dd36436aec3b21$var$EVENT_SLIDE);
        if (slideEvent.defaultPrevented) return;
        if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
        // TODO: change tests that use empty divs to avoid this check
        return;
        const isCycling = Boolean(this._interval);
        this.pause();
        this._isSliding = true;
        this._setActiveIndicatorElement(nextElementIndex);
        this._activeElement = nextElement;
        const directionalClassName = isNext ? $e9dd36436aec3b21$var$CLASS_NAME_START : $e9dd36436aec3b21$var$CLASS_NAME_END;
        const orderClassName = isNext ? $e9dd36436aec3b21$var$CLASS_NAME_NEXT : $e9dd36436aec3b21$var$CLASS_NAME_PREV;
        nextElement.classList.add(orderClassName);
        $e9dd36436aec3b21$var$reflow(nextElement);
        activeElement.classList.add(directionalClassName);
        nextElement.classList.add(directionalClassName);
        const completeCallBack = ()=>{
            nextElement.classList.remove(directionalClassName, orderClassName);
            nextElement.classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$2);
            activeElement.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
            this._isSliding = false;
            triggerEvent($e9dd36436aec3b21$var$EVENT_SLID);
        };
        this._queueCallback(completeCallBack, activeElement, this._isAnimated());
        if (isCycling) this.cycle();
    }
    _isAnimated() {
        return this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_SLIDE);
    }
    _getActive() {
        return $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_ACTIVE_ITEM, this._element);
    }
    _getItems() {
        return $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_ITEM, this._element);
    }
    _clearInterval() {
        if (this._interval) {
            clearInterval(this._interval);
            this._interval = null;
        }
    }
    _directionToOrder(direction) {
        if ($e9dd36436aec3b21$var$isRTL()) return direction === $e9dd36436aec3b21$var$DIRECTION_LEFT ? $e9dd36436aec3b21$var$ORDER_PREV : $e9dd36436aec3b21$var$ORDER_NEXT;
        return direction === $e9dd36436aec3b21$var$DIRECTION_LEFT ? $e9dd36436aec3b21$var$ORDER_NEXT : $e9dd36436aec3b21$var$ORDER_PREV;
    }
    _orderToDirection(order) {
        if ($e9dd36436aec3b21$var$isRTL()) return order === $e9dd36436aec3b21$var$ORDER_PREV ? $e9dd36436aec3b21$var$DIRECTION_LEFT : $e9dd36436aec3b21$var$DIRECTION_RIGHT;
        return order === $e9dd36436aec3b21$var$ORDER_PREV ? $e9dd36436aec3b21$var$DIRECTION_RIGHT : $e9dd36436aec3b21$var$DIRECTION_LEFT;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$144901db2ea8e967.getOrCreateInstance(this, config);
            if (typeof config === 'number') {
                data.to(config);
                return;
            }
            if (typeof config === 'string') {
                if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$5, $e9dd36436aec3b21$var$SELECTOR_DATA_SLIDE, function(event) {
    const target = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(this);
    if (!target || !target.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_CAROUSEL)) return;
    event.preventDefault();
    const carousel = $e9dd36436aec3b21$export$144901db2ea8e967.getOrCreateInstance(target);
    const slideIndex = this.getAttribute('data-bs-slide-to');
    if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
    }
    if ($e9dd36436aec3b21$var$Manipulator.getDataAttribute(this, 'slide') === 'next') {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
    }
    carousel.prev();
    carousel._maybeEnableCycle();
});
$e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$3, ()=>{
    const carousels = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_DATA_RIDE);
    for (const carousel of carousels)$e9dd36436aec3b21$export$144901db2ea8e967.getOrCreateInstance(carousel);
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$144901db2ea8e967);
/**
 * --------------------------------------------------------------------------
 * Bootstrap collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$b = 'collapse';
const $e9dd36436aec3b21$var$DATA_KEY$7 = 'bs.collapse';
const $e9dd36436aec3b21$var$EVENT_KEY$7 = `.${$e9dd36436aec3b21$var$DATA_KEY$7}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$4 = '.data-api';
const $e9dd36436aec3b21$var$EVENT_SHOW$6 = `show${$e9dd36436aec3b21$var$EVENT_KEY$7}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN$6 = `shown${$e9dd36436aec3b21$var$EVENT_KEY$7}`;
const $e9dd36436aec3b21$var$EVENT_HIDE$6 = `hide${$e9dd36436aec3b21$var$EVENT_KEY$7}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN$6 = `hidden${$e9dd36436aec3b21$var$EVENT_KEY$7}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$4 = `click${$e9dd36436aec3b21$var$EVENT_KEY$7}${$e9dd36436aec3b21$var$DATA_API_KEY$4}`;
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$7 = 'show';
const $e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE = 'collapse';
const $e9dd36436aec3b21$var$CLASS_NAME_COLLAPSING = 'collapsing';
const $e9dd36436aec3b21$var$CLASS_NAME_COLLAPSED = 'collapsed';
const $e9dd36436aec3b21$var$CLASS_NAME_DEEPER_CHILDREN = `:scope .${$e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE} .${$e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE}`;
const $e9dd36436aec3b21$var$CLASS_NAME_HORIZONTAL = 'collapse-horizontal';
const $e9dd36436aec3b21$var$WIDTH = 'width';
const $e9dd36436aec3b21$var$HEIGHT = 'height';
const $e9dd36436aec3b21$var$SELECTOR_ACTIVES = '.collapse.show, .collapse.collapsing';
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
const $e9dd36436aec3b21$var$Default$a = {
    parent: null,
    toggle: true
};
const $e9dd36436aec3b21$var$DefaultType$a = {
    parent: '(null|element)',
    toggle: 'boolean'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$78768a9af065a7b extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isTransitioning = false;
        this._triggerArray = [];
        const toggleList = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$4);
        for (const elem of toggleList){
            const selector = $e9dd36436aec3b21$var$SelectorEngine.getSelectorFromElement(elem);
            const filterElement = $e9dd36436aec3b21$var$SelectorEngine.find(selector).filter((foundElement)=>foundElement === this._element);
            if (selector !== null && filterElement.length) this._triggerArray.push(elem);
        }
        this._initializeChildren();
        if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
        if (this._config.toggle) this.toggle();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$a;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$a;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$b;
    }
    // Public
    toggle() {
        if (this._isShown()) this.hide();
        else this.show();
    }
    show() {
        if (this._isTransitioning || this._isShown()) return;
        let activeChildren = [];
        // find active children
        if (this._config.parent) activeChildren = this._getFirstLevelChildren($e9dd36436aec3b21$var$SELECTOR_ACTIVES).filter((element)=>element !== this._element).map((element)=>$e9dd36436aec3b21$export$78768a9af065a7b.getOrCreateInstance(element, {
                toggle: false
            }));
        if (activeChildren.length && activeChildren[0]._isTransitioning) return;
        const startEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOW$6);
        if (startEvent.defaultPrevented) return;
        for (const activeInstance of activeChildren)activeInstance.hide();
        const dimension = this._getDimension();
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE);
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSING);
        this._element.style[dimension] = 0;
        this._addAriaAndCollapsedClass(this._triggerArray, true);
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE, $e9dd36436aec3b21$var$CLASS_NAME_SHOW$7);
            this._element.style[dimension] = '';
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOWN$6);
        };
        const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
        const scrollSize = `scroll${capitalizedDimension}`;
        this._queueCallback(complete, this._element, true);
        this._element.style[dimension] = `${this._element[scrollSize]}px`;
    }
    hide() {
        if (this._isTransitioning || !this._isShown()) return;
        const startEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE$6);
        if (startEvent.defaultPrevented) return;
        const dimension = this._getDimension();
        this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
        $e9dd36436aec3b21$var$reflow(this._element);
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSING);
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE, $e9dd36436aec3b21$var$CLASS_NAME_SHOW$7);
        for (const trigger of this._triggerArray){
            const element = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(trigger);
            if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                trigger
            ], false);
        }
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE);
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDDEN$6);
        };
        this._element.style[dimension] = '';
        this._queueCallback(complete, this._element, true);
    }
    // Private
    _isShown(element = this._element) {
        return element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_SHOW$7);
    }
    _configAfterMerge(config) {
        config.toggle = Boolean(config.toggle); // Coerce string values
        config.parent = $e9dd36436aec3b21$var$getElement(config.parent);
        return config;
    }
    _getDimension() {
        return this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_HORIZONTAL) ? $e9dd36436aec3b21$var$WIDTH : $e9dd36436aec3b21$var$HEIGHT;
    }
    _initializeChildren() {
        if (!this._config.parent) return;
        const children = this._getFirstLevelChildren($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$4);
        for (const element of children){
            const selected = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(element);
            if (selected) this._addAriaAndCollapsedClass([
                element
            ], this._isShown(selected));
        }
    }
    _getFirstLevelChildren(selector) {
        const children = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
        // remove children if greater depth
        return $e9dd36436aec3b21$var$SelectorEngine.find(selector, this._config.parent).filter((element)=>!children.includes(element));
    }
    _addAriaAndCollapsedClass(triggerArray, isOpen) {
        if (!triggerArray.length) return;
        for (const element of triggerArray){
            element.classList.toggle($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSED, !isOpen);
            element.setAttribute('aria-expanded', isOpen);
        }
    }
    // Static
    static jQueryInterface(config) {
        const _config = {};
        if (typeof config === 'string' && /show|hide/.test(config)) _config.toggle = false;
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$78768a9af065a7b.getOrCreateInstance(this, _config);
            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$4, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$4, function(event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === 'A' || event.delegateTarget && event.delegateTarget.tagName === 'A') event.preventDefault();
    for (const element of $e9dd36436aec3b21$var$SelectorEngine.getMultipleElementsFromSelector(this))$e9dd36436aec3b21$export$78768a9af065a7b.getOrCreateInstance(element, {
        toggle: false
    }).toggle();
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$78768a9af065a7b);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$a = 'dropdown';
const $e9dd36436aec3b21$var$DATA_KEY$6 = 'bs.dropdown';
const $e9dd36436aec3b21$var$EVENT_KEY$6 = `.${$e9dd36436aec3b21$var$DATA_KEY$6}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$3 = '.data-api';
const $e9dd36436aec3b21$var$ESCAPE_KEY$2 = 'Escape';
const $e9dd36436aec3b21$var$TAB_KEY$1 = 'Tab';
const $e9dd36436aec3b21$var$ARROW_UP_KEY$1 = 'ArrowUp';
const $e9dd36436aec3b21$var$ARROW_DOWN_KEY$1 = 'ArrowDown';
const $e9dd36436aec3b21$var$RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
const $e9dd36436aec3b21$var$EVENT_HIDE$5 = `hide${$e9dd36436aec3b21$var$EVENT_KEY$6}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN$5 = `hidden${$e9dd36436aec3b21$var$EVENT_KEY$6}`;
const $e9dd36436aec3b21$var$EVENT_SHOW$5 = `show${$e9dd36436aec3b21$var$EVENT_KEY$6}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN$5 = `shown${$e9dd36436aec3b21$var$EVENT_KEY$6}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$3 = `click${$e9dd36436aec3b21$var$EVENT_KEY$6}${$e9dd36436aec3b21$var$DATA_API_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN_DATA_API = `keydown${$e9dd36436aec3b21$var$EVENT_KEY$6}${$e9dd36436aec3b21$var$DATA_API_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_KEYUP_DATA_API = `keyup${$e9dd36436aec3b21$var$EVENT_KEY$6}${$e9dd36436aec3b21$var$DATA_API_KEY$3}`;
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$6 = 'show';
const $e9dd36436aec3b21$var$CLASS_NAME_DROPUP = 'dropup';
const $e9dd36436aec3b21$var$CLASS_NAME_DROPEND = 'dropend';
const $e9dd36436aec3b21$var$CLASS_NAME_DROPSTART = 'dropstart';
const $e9dd36436aec3b21$var$CLASS_NAME_DROPUP_CENTER = 'dropup-center';
const $e9dd36436aec3b21$var$CLASS_NAME_DROPDOWN_CENTER = 'dropdown-center';
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE_SHOWN = `${$e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3}.${$e9dd36436aec3b21$var$CLASS_NAME_SHOW$6}`;
const $e9dd36436aec3b21$var$SELECTOR_MENU = '.dropdown-menu';
const $e9dd36436aec3b21$var$SELECTOR_NAVBAR = '.navbar';
const $e9dd36436aec3b21$var$SELECTOR_NAVBAR_NAV = '.navbar-nav';
const $e9dd36436aec3b21$var$SELECTOR_VISIBLE_ITEMS = '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)';
const $e9dd36436aec3b21$var$PLACEMENT_TOP = $e9dd36436aec3b21$var$isRTL() ? 'top-end' : 'top-start';
const $e9dd36436aec3b21$var$PLACEMENT_TOPEND = $e9dd36436aec3b21$var$isRTL() ? 'top-start' : 'top-end';
const $e9dd36436aec3b21$var$PLACEMENT_BOTTOM = $e9dd36436aec3b21$var$isRTL() ? 'bottom-end' : 'bottom-start';
const $e9dd36436aec3b21$var$PLACEMENT_BOTTOMEND = $e9dd36436aec3b21$var$isRTL() ? 'bottom-start' : 'bottom-end';
const $e9dd36436aec3b21$var$PLACEMENT_RIGHT = $e9dd36436aec3b21$var$isRTL() ? 'left-start' : 'right-start';
const $e9dd36436aec3b21$var$PLACEMENT_LEFT = $e9dd36436aec3b21$var$isRTL() ? 'right-start' : 'left-start';
const $e9dd36436aec3b21$var$PLACEMENT_TOPCENTER = 'top';
const $e9dd36436aec3b21$var$PLACEMENT_BOTTOMCENTER = 'bottom';
const $e9dd36436aec3b21$var$Default$9 = {
    autoClose: true,
    boundary: 'clippingParents',
    display: 'dynamic',
    offset: [
        0,
        2
    ],
    popperConfig: null,
    reference: 'toggle'
};
const $e9dd36436aec3b21$var$DefaultType$9 = {
    autoClose: '(boolean|string)',
    boundary: '(string|element)',
    display: 'string',
    offset: '(array|string|function)',
    popperConfig: '(null|object|function)',
    reference: '(string|element|object)'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$931cbfb6bfb85fc extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._popper = null;
        this._parent = this._element.parentNode; // dropdown wrapper
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        this._menu = $e9dd36436aec3b21$var$SelectorEngine.next(this._element, $e9dd36436aec3b21$var$SELECTOR_MENU)[0] || $e9dd36436aec3b21$var$SelectorEngine.prev(this._element, $e9dd36436aec3b21$var$SELECTOR_MENU)[0] || $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_MENU, this._parent);
        this._inNavbar = this._detectNavbar();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$9;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$9;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$a;
    }
    // Public
    toggle() {
        return this._isShown() ? this.hide() : this.show();
    }
    show() {
        if ($e9dd36436aec3b21$var$isDisabled(this._element) || this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOW$5, relatedTarget);
        if (showEvent.defaultPrevented) return;
        this._createPopper();
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ('ontouchstart' in document.documentElement && !this._parent.closest($e9dd36436aec3b21$var$SELECTOR_NAVBAR_NAV)) for (const element of [].concat(...document.body.children))$e9dd36436aec3b21$var$EventHandler.on(element, 'mouseover', $e9dd36436aec3b21$var$noop);
        this._element.focus();
        this._element.setAttribute('aria-expanded', true);
        this._menu.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$6);
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$6);
        $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOWN$5, relatedTarget);
    }
    hide() {
        if ($e9dd36436aec3b21$var$isDisabled(this._element) || !this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        this._completeHide(relatedTarget);
    }
    dispose() {
        if (this._popper) this._popper.destroy();
        super.dispose();
    }
    update() {
        this._inNavbar = this._detectNavbar();
        if (this._popper) this._popper.update();
    }
    // Private
    _completeHide(relatedTarget) {
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE$5, relatedTarget);
        if (hideEvent.defaultPrevented) return;
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$e9dd36436aec3b21$var$EventHandler.off(element, 'mouseover', $e9dd36436aec3b21$var$noop);
        if (this._popper) this._popper.destroy();
        this._menu.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$6);
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$6);
        this._element.setAttribute('aria-expanded', 'false');
        $e9dd36436aec3b21$var$Manipulator.removeDataAttribute(this._menu, 'popper');
        $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDDEN$5, relatedTarget);
    }
    _getConfig(config) {
        config = super._getConfig(config);
        if (typeof config.reference === 'object' && !$e9dd36436aec3b21$var$isElement(config.reference) && typeof config.reference.getBoundingClientRect !== 'function') // Popper virtual elements require a getBoundingClientRect method
        throw new TypeError(`${$e9dd36436aec3b21$var$NAME$a.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
        return config;
    }
    _createPopper() {
        if (typeof $cc4ed71c4f27adbc$exports === 'undefined') throw new TypeError('Bootstrap\'s dropdowns require Popper (https://popper.js.org/docs/v2/)');
        let referenceElement = this._element;
        if (this._config.reference === 'parent') referenceElement = this._parent;
        else if ($e9dd36436aec3b21$var$isElement(this._config.reference)) referenceElement = $e9dd36436aec3b21$var$getElement(this._config.reference);
        else if (typeof this._config.reference === 'object') referenceElement = this._config.reference;
        const popperConfig = this._getPopperConfig();
        this._popper = $cc4ed71c4f27adbc$exports.createPopper(referenceElement, this._menu, popperConfig);
    }
    _isShown() {
        return this._menu.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_SHOW$6);
    }
    _getPlacement() {
        const parentDropdown = this._parent;
        if (parentDropdown.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPEND)) return $e9dd36436aec3b21$var$PLACEMENT_RIGHT;
        if (parentDropdown.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPSTART)) return $e9dd36436aec3b21$var$PLACEMENT_LEFT;
        if (parentDropdown.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPUP_CENTER)) return $e9dd36436aec3b21$var$PLACEMENT_TOPCENTER;
        if (parentDropdown.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPDOWN_CENTER)) return $e9dd36436aec3b21$var$PLACEMENT_BOTTOMCENTER;
        // We need to trim the value because custom properties can also include spaces
        const isEnd = getComputedStyle(this._menu).getPropertyValue('--bs-position').trim() === 'end';
        if (parentDropdown.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPUP)) return isEnd ? $e9dd36436aec3b21$var$PLACEMENT_TOPEND : $e9dd36436aec3b21$var$PLACEMENT_TOP;
        return isEnd ? $e9dd36436aec3b21$var$PLACEMENT_BOTTOMEND : $e9dd36436aec3b21$var$PLACEMENT_BOTTOM;
    }
    _detectNavbar() {
        return this._element.closest($e9dd36436aec3b21$var$SELECTOR_NAVBAR) !== null;
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
        if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _getPopperConfig() {
        const defaultBsPopperConfig = {
            placement: this._getPlacement(),
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: this._getOffset()
                    }
                }
            ]
        };
        // Disable Popper if we have a static display or Dropdown is in Navbar
        if (this._inNavbar || this._config.display === 'static') {
            $e9dd36436aec3b21$var$Manipulator.setDataAttribute(this._menu, 'popper', 'static'); // TODO: v6 remove
            defaultBsPopperConfig.modifiers = [
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ];
        }
        return {
            ...defaultBsPopperConfig,
            ...$e9dd36436aec3b21$var$execute(this._config.popperConfig, [
                undefined,
                defaultBsPopperConfig
            ])
        };
    }
    _selectMenuItem({ key: key, target: target }) {
        const items = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_VISIBLE_ITEMS, this._menu).filter((element)=>$e9dd36436aec3b21$var$isVisible(element));
        if (!items.length) return;
        // if target isn't included in items (e.g. when expanding the dropdown)
        // allow cycling to get the last item in case key equals ARROW_UP_KEY
        $e9dd36436aec3b21$var$getNextActiveElement(items, target, key === $e9dd36436aec3b21$var$ARROW_DOWN_KEY$1, !items.includes(target)).focus();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$931cbfb6bfb85fc.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    static clearMenus(event) {
        if (event.button === $e9dd36436aec3b21$var$RIGHT_MOUSE_BUTTON || event.type === 'keyup' && event.key !== $e9dd36436aec3b21$var$TAB_KEY$1) return;
        const openToggles = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE_SHOWN);
        for (const toggle of openToggles){
            const context = $e9dd36436aec3b21$export$931cbfb6bfb85fc.getInstance(toggle);
            if (!context || context._config.autoClose === false) continue;
            const composedPath = event.composedPath();
            const isMenuTarget = composedPath.includes(context._menu);
            if (composedPath.includes(context._element) || context._config.autoClose === 'inside' && !isMenuTarget || context._config.autoClose === 'outside' && isMenuTarget) continue;
            // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
            if (context._menu.contains(event.target) && (event.type === 'keyup' && event.key === $e9dd36436aec3b21$var$TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
            const relatedTarget = {
                relatedTarget: context._element
            };
            if (event.type === 'click') relatedTarget.clickEvent = event;
            context._completeHide(relatedTarget);
        }
    }
    static dataApiKeydownHandler(event) {
        // If not an UP | DOWN | ESCAPE key => not a dropdown command
        // If input/textarea && if key is other than ESCAPE => not a dropdown command
        const isInput = /input|textarea/i.test(event.target.tagName);
        const isEscapeEvent = event.key === $e9dd36436aec3b21$var$ESCAPE_KEY$2;
        const isUpOrDownEvent = [
            $e9dd36436aec3b21$var$ARROW_UP_KEY$1,
            $e9dd36436aec3b21$var$ARROW_DOWN_KEY$1
        ].includes(event.key);
        if (!isUpOrDownEvent && !isEscapeEvent) return;
        if (isInput && !isEscapeEvent) return;
        event.preventDefault();
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        const getToggleButton = this.matches($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3) ? this : $e9dd36436aec3b21$var$SelectorEngine.prev(this, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3)[0] || $e9dd36436aec3b21$var$SelectorEngine.next(this, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3)[0] || $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
        const instance = $e9dd36436aec3b21$export$931cbfb6bfb85fc.getOrCreateInstance(getToggleButton);
        if (isUpOrDownEvent) {
            event.stopPropagation();
            instance.show();
            instance._selectMenuItem(event);
            return;
        }
        if (instance._isShown()) {
            // else is escape and we check if it is shown
            event.stopPropagation();
            instance.hide();
            getToggleButton.focus();
        }
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_KEYDOWN_DATA_API, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3, $e9dd36436aec3b21$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_KEYDOWN_DATA_API, $e9dd36436aec3b21$var$SELECTOR_MENU, $e9dd36436aec3b21$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$3, $e9dd36436aec3b21$export$931cbfb6bfb85fc.clearMenus);
$e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_KEYUP_DATA_API, $e9dd36436aec3b21$export$931cbfb6bfb85fc.clearMenus);
$e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$3, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3, function(event) {
    event.preventDefault();
    $e9dd36436aec3b21$export$931cbfb6bfb85fc.getOrCreateInstance(this).toggle();
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$931cbfb6bfb85fc);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$9 = 'backdrop';
const $e9dd36436aec3b21$var$CLASS_NAME_FADE$4 = 'fade';
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$5 = 'show';
const $e9dd36436aec3b21$var$EVENT_MOUSEDOWN = `mousedown.bs.${$e9dd36436aec3b21$var$NAME$9}`;
const $e9dd36436aec3b21$var$Default$8 = {
    className: 'modal-backdrop',
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    // if false, we use the backdrop helper without adding any element to the dom
    rootElement: 'body' // give the choice to place backdrop under different elements
};
const $e9dd36436aec3b21$var$DefaultType$8 = {
    className: 'string',
    clickCallback: '(function|null)',
    isAnimated: 'boolean',
    isVisible: 'boolean',
    rootElement: '(element|string)'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$Backdrop extends $e9dd36436aec3b21$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isAppended = false;
        this._element = null;
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$8;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$8;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$9;
    }
    // Public
    show(callback) {
        if (!this._config.isVisible) {
            $e9dd36436aec3b21$var$execute(callback);
            return;
        }
        this._append();
        const element = this._getElement();
        if (this._config.isAnimated) $e9dd36436aec3b21$var$reflow(element);
        element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            $e9dd36436aec3b21$var$execute(callback);
        });
    }
    hide(callback) {
        if (!this._config.isVisible) {
            $e9dd36436aec3b21$var$execute(callback);
            return;
        }
        this._getElement().classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            this.dispose();
            $e9dd36436aec3b21$var$execute(callback);
        });
    }
    dispose() {
        if (!this._isAppended) return;
        $e9dd36436aec3b21$var$EventHandler.off(this._element, $e9dd36436aec3b21$var$EVENT_MOUSEDOWN);
        this._element.remove();
        this._isAppended = false;
    }
    // Private
    _getElement() {
        if (!this._element) {
            const backdrop = document.createElement('div');
            backdrop.className = this._config.className;
            if (this._config.isAnimated) backdrop.classList.add($e9dd36436aec3b21$var$CLASS_NAME_FADE$4);
            this._element = backdrop;
        }
        return this._element;
    }
    _configAfterMerge(config) {
        // use getElement() with the default "body" to get a fresh Element on each instantiation
        config.rootElement = $e9dd36436aec3b21$var$getElement(config.rootElement);
        return config;
    }
    _append() {
        if (this._isAppended) return;
        const element = this._getElement();
        this._config.rootElement.append(element);
        $e9dd36436aec3b21$var$EventHandler.on(element, $e9dd36436aec3b21$var$EVENT_MOUSEDOWN, ()=>{
            $e9dd36436aec3b21$var$execute(this._config.clickCallback);
        });
        this._isAppended = true;
    }
    _emulateAnimation(callback) {
        $e9dd36436aec3b21$var$executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$8 = 'focustrap';
const $e9dd36436aec3b21$var$DATA_KEY$5 = 'bs.focustrap';
const $e9dd36436aec3b21$var$EVENT_KEY$5 = `.${$e9dd36436aec3b21$var$DATA_KEY$5}`;
const $e9dd36436aec3b21$var$EVENT_FOCUSIN$2 = `focusin${$e9dd36436aec3b21$var$EVENT_KEY$5}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN_TAB = `keydown.tab${$e9dd36436aec3b21$var$EVENT_KEY$5}`;
const $e9dd36436aec3b21$var$TAB_KEY = 'Tab';
const $e9dd36436aec3b21$var$TAB_NAV_FORWARD = 'forward';
const $e9dd36436aec3b21$var$TAB_NAV_BACKWARD = 'backward';
const $e9dd36436aec3b21$var$Default$7 = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
const $e9dd36436aec3b21$var$DefaultType$7 = {
    autofocus: 'boolean',
    trapElement: 'element'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$FocusTrap extends $e9dd36436aec3b21$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isActive = false;
        this._lastTabNavDirection = null;
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$7;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$7;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$8;
    }
    // Public
    activate() {
        if (this._isActive) return;
        if (this._config.autofocus) this._config.trapElement.focus();
        $e9dd36436aec3b21$var$EventHandler.off(document, $e9dd36436aec3b21$var$EVENT_KEY$5); // guard against infinite focus loop
        $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_FOCUSIN$2, (event)=>this._handleFocusin(event));
        $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_KEYDOWN_TAB, (event)=>this._handleKeydown(event));
        this._isActive = true;
    }
    deactivate() {
        if (!this._isActive) return;
        this._isActive = false;
        $e9dd36436aec3b21$var$EventHandler.off(document, $e9dd36436aec3b21$var$EVENT_KEY$5);
    }
    // Private
    _handleFocusin(event) {
        const { trapElement: trapElement } = this._config;
        if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
        const elements = $e9dd36436aec3b21$var$SelectorEngine.focusableChildren(trapElement);
        if (elements.length === 0) trapElement.focus();
        else if (this._lastTabNavDirection === $e9dd36436aec3b21$var$TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
        else elements[0].focus();
    }
    _handleKeydown(event) {
        if (event.key !== $e9dd36436aec3b21$var$TAB_KEY) return;
        this._lastTabNavDirection = event.shiftKey ? $e9dd36436aec3b21$var$TAB_NAV_BACKWARD : $e9dd36436aec3b21$var$TAB_NAV_FORWARD;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
const $e9dd36436aec3b21$var$SELECTOR_STICKY_CONTENT = '.sticky-top';
const $e9dd36436aec3b21$var$PROPERTY_PADDING = 'padding-right';
const $e9dd36436aec3b21$var$PROPERTY_MARGIN = 'margin-right';
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$ScrollBarHelper {
    constructor(){
        this._element = document.body;
    }
    // Public
    getWidth() {
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
        const documentWidth = document.documentElement.clientWidth;
        return Math.abs(window.innerWidth - documentWidth);
    }
    hide() {
        const width = this.getWidth();
        this._disableOverFlow();
        // give padding to element to balance the hidden scrollbar width
        this._setElementAttributes(this._element, $e9dd36436aec3b21$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
        this._setElementAttributes($e9dd36436aec3b21$var$SELECTOR_FIXED_CONTENT, $e9dd36436aec3b21$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        this._setElementAttributes($e9dd36436aec3b21$var$SELECTOR_STICKY_CONTENT, $e9dd36436aec3b21$var$PROPERTY_MARGIN, (calculatedValue)=>calculatedValue - width);
    }
    reset() {
        this._resetElementAttributes(this._element, 'overflow');
        this._resetElementAttributes(this._element, $e9dd36436aec3b21$var$PROPERTY_PADDING);
        this._resetElementAttributes($e9dd36436aec3b21$var$SELECTOR_FIXED_CONTENT, $e9dd36436aec3b21$var$PROPERTY_PADDING);
        this._resetElementAttributes($e9dd36436aec3b21$var$SELECTOR_STICKY_CONTENT, $e9dd36436aec3b21$var$PROPERTY_MARGIN);
    }
    isOverflowing() {
        return this.getWidth() > 0;
    }
    // Private
    _disableOverFlow() {
        this._saveInitialAttribute(this._element, 'overflow');
        this._element.style.overflow = 'hidden';
    }
    _setElementAttributes(selector, styleProperty, callback) {
        const scrollbarWidth = this.getWidth();
        const manipulationCallBack = (element)=>{
            if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
            this._saveInitialAttribute(element, styleProperty);
            const calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
            element.style.setProperty(styleProperty, `${callback(Number.parseFloat(calculatedValue))}px`);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _saveInitialAttribute(element, styleProperty) {
        const actualValue = element.style.getPropertyValue(styleProperty);
        if (actualValue) $e9dd36436aec3b21$var$Manipulator.setDataAttribute(element, styleProperty, actualValue);
    }
    _resetElementAttributes(selector, styleProperty) {
        const manipulationCallBack = (element)=>{
            const value = $e9dd36436aec3b21$var$Manipulator.getDataAttribute(element, styleProperty);
            // We only want to remove the property if the value is `null`; the value can also be zero
            if (value === null) {
                element.style.removeProperty(styleProperty);
                return;
            }
            $e9dd36436aec3b21$var$Manipulator.removeDataAttribute(element, styleProperty);
            element.style.setProperty(styleProperty, value);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _applyManipulationCallback(selector, callBack) {
        if ($e9dd36436aec3b21$var$isElement(selector)) {
            callBack(selector);
            return;
        }
        for (const sel of $e9dd36436aec3b21$var$SelectorEngine.find(selector, this._element))callBack(sel);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$7 = 'modal';
const $e9dd36436aec3b21$var$DATA_KEY$4 = 'bs.modal';
const $e9dd36436aec3b21$var$EVENT_KEY$4 = `.${$e9dd36436aec3b21$var$DATA_KEY$4}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$2 = '.data-api';
const $e9dd36436aec3b21$var$ESCAPE_KEY$1 = 'Escape';
const $e9dd36436aec3b21$var$EVENT_HIDE$4 = `hide${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_HIDE_PREVENTED$1 = `hidePrevented${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN$4 = `hidden${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_SHOW$4 = `show${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN$4 = `shown${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_RESIZE$1 = `resize${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DISMISS = `click.dismiss${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN_DISMISS$1 = `keydown.dismiss${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$2 = `click${$e9dd36436aec3b21$var$EVENT_KEY$4}${$e9dd36436aec3b21$var$DATA_API_KEY$2}`;
const $e9dd36436aec3b21$var$CLASS_NAME_OPEN = 'modal-open';
const $e9dd36436aec3b21$var$CLASS_NAME_FADE$3 = 'fade';
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$4 = 'show';
const $e9dd36436aec3b21$var$CLASS_NAME_STATIC = 'modal-static';
const $e9dd36436aec3b21$var$OPEN_SELECTOR$1 = '.modal.show';
const $e9dd36436aec3b21$var$SELECTOR_DIALOG = '.modal-dialog';
const $e9dd36436aec3b21$var$SELECTOR_MODAL_BODY = '.modal-body';
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
const $e9dd36436aec3b21$var$Default$6 = {
    backdrop: true,
    focus: true,
    keyboard: true
};
const $e9dd36436aec3b21$var$DefaultType$6 = {
    backdrop: '(boolean|string)',
    focus: 'boolean',
    keyboard: 'boolean'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$2b77a92f1a5ad772 extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._dialog = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_DIALOG, this._element);
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._isShown = false;
        this._isTransitioning = false;
        this._scrollBar = new $e9dd36436aec3b21$var$ScrollBarHelper();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$6;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$6;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$7;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown || this._isTransitioning) return;
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOW$4, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._isTransitioning = true;
        this._scrollBar.hide();
        document.body.classList.add($e9dd36436aec3b21$var$CLASS_NAME_OPEN);
        this._adjustDialog();
        this._backdrop.show(()=>this._showElement(relatedTarget));
    }
    hide() {
        if (!this._isShown || this._isTransitioning) return;
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE$4);
        if (hideEvent.defaultPrevented) return;
        this._isShown = false;
        this._isTransitioning = true;
        this._focustrap.deactivate();
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$4);
        this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated());
    }
    dispose() {
        $e9dd36436aec3b21$var$EventHandler.off(window, $e9dd36436aec3b21$var$EVENT_KEY$4);
        $e9dd36436aec3b21$var$EventHandler.off(this._dialog, $e9dd36436aec3b21$var$EVENT_KEY$4);
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    handleUpdate() {
        this._adjustDialog();
    }
    // Private
    _initializeBackDrop() {
        return new $e9dd36436aec3b21$var$Backdrop({
            isVisible: Boolean(this._config.backdrop),
            // 'static' option will be translated to true, and booleans will keep their value,
            isAnimated: this._isAnimated()
        });
    }
    _initializeFocusTrap() {
        return new $e9dd36436aec3b21$var$FocusTrap({
            trapElement: this._element
        });
    }
    _showElement(relatedTarget) {
        // try to append dynamic modal
        if (!document.body.contains(this._element)) document.body.append(this._element);
        this._element.style.display = 'block';
        this._element.removeAttribute('aria-hidden');
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.scrollTop = 0;
        const modalBody = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_MODAL_BODY, this._dialog);
        if (modalBody) modalBody.scrollTop = 0;
        $e9dd36436aec3b21$var$reflow(this._element);
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$4);
        const transitionComplete = ()=>{
            if (this._config.focus) this._focustrap.activate();
            this._isTransitioning = false;
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOWN$4, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
    }
    _addEventListeners() {
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_KEYDOWN_DISMISS$1, (event)=>{
            if (event.key !== $e9dd36436aec3b21$var$ESCAPE_KEY$1) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            this._triggerBackdropTransition();
        });
        $e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_RESIZE$1, ()=>{
            if (this._isShown && !this._isTransitioning) this._adjustDialog();
        });
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_MOUSEDOWN_DISMISS, (event)=>{
            // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
            $e9dd36436aec3b21$var$EventHandler.one(this._element, $e9dd36436aec3b21$var$EVENT_CLICK_DISMISS, (event2)=>{
                if (this._element !== event.target || this._element !== event2.target) return;
                if (this._config.backdrop === 'static') {
                    this._triggerBackdropTransition();
                    return;
                }
                if (this._config.backdrop) this.hide();
            });
        });
    }
    _hideModal() {
        this._element.style.display = 'none';
        this._element.setAttribute('aria-hidden', true);
        this._element.removeAttribute('aria-modal');
        this._element.removeAttribute('role');
        this._isTransitioning = false;
        this._backdrop.hide(()=>{
            document.body.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_OPEN);
            this._resetAdjustments();
            this._scrollBar.reset();
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDDEN$4);
        });
    }
    _isAnimated() {
        return this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_FADE$3);
    }
    _triggerBackdropTransition() {
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE_PREVENTED$1);
        if (hideEvent.defaultPrevented) return;
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const initialOverflowY = this._element.style.overflowY;
        // return if the following background transition hasn't yet completed
        if (initialOverflowY === 'hidden' || this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_STATIC)) return;
        if (!isModalOverflowing) this._element.style.overflowY = 'hidden';
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_STATIC);
        this._queueCallback(()=>{
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_STATIC);
            this._queueCallback(()=>{
                this._element.style.overflowY = initialOverflowY;
            }, this._dialog);
        }, this._dialog);
        this._element.focus();
    }
    /**
   * The following methods are used to handle overflowing modals
   */ _adjustDialog() {
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const scrollbarWidth = this._scrollBar.getWidth();
        const isBodyOverflowing = scrollbarWidth > 0;
        if (isBodyOverflowing && !isModalOverflowing) {
            const property = $e9dd36436aec3b21$var$isRTL() ? 'paddingLeft' : 'paddingRight';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
        if (!isBodyOverflowing && isModalOverflowing) {
            const property = $e9dd36436aec3b21$var$isRTL() ? 'paddingRight' : 'paddingLeft';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
    }
    _resetAdjustments() {
        this._element.style.paddingLeft = '';
        this._element.style.paddingRight = '';
    }
    // Static
    static jQueryInterface(config, relatedTarget) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$2b77a92f1a5ad772.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config](relatedTarget);
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$2, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$2, function(event) {
    const target = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    $e9dd36436aec3b21$var$EventHandler.one(target, $e9dd36436aec3b21$var$EVENT_SHOW$4, (showEvent)=>{
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        $e9dd36436aec3b21$var$EventHandler.one(target, $e9dd36436aec3b21$var$EVENT_HIDDEN$4, ()=>{
            if ($e9dd36436aec3b21$var$isVisible(this)) this.focus();
        });
    });
    // avoid conflict when clicking modal toggler while another one is open
    const alreadyOpen = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$OPEN_SELECTOR$1);
    if (alreadyOpen) $e9dd36436aec3b21$export$2b77a92f1a5ad772.getInstance(alreadyOpen).hide();
    const data = $e9dd36436aec3b21$export$2b77a92f1a5ad772.getOrCreateInstance(target);
    data.toggle(this);
});
$e9dd36436aec3b21$var$enableDismissTrigger($e9dd36436aec3b21$export$2b77a92f1a5ad772);
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$2b77a92f1a5ad772);
/**
 * --------------------------------------------------------------------------
 * Bootstrap offcanvas.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$6 = 'offcanvas';
const $e9dd36436aec3b21$var$DATA_KEY$3 = 'bs.offcanvas';
const $e9dd36436aec3b21$var$EVENT_KEY$3 = `.${$e9dd36436aec3b21$var$DATA_KEY$3}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$1 = '.data-api';
const $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$2 = `load${$e9dd36436aec3b21$var$EVENT_KEY$3}${$e9dd36436aec3b21$var$DATA_API_KEY$1}`;
const $e9dd36436aec3b21$var$ESCAPE_KEY = 'Escape';
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$3 = 'show';
const $e9dd36436aec3b21$var$CLASS_NAME_SHOWING$1 = 'showing';
const $e9dd36436aec3b21$var$CLASS_NAME_HIDING = 'hiding';
const $e9dd36436aec3b21$var$CLASS_NAME_BACKDROP = 'offcanvas-backdrop';
const $e9dd36436aec3b21$var$OPEN_SELECTOR = '.offcanvas.show';
const $e9dd36436aec3b21$var$EVENT_SHOW$3 = `show${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN$3 = `shown${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_HIDE$3 = `hide${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_HIDE_PREVENTED = `hidePrevented${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN$3 = `hidden${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_RESIZE = `resize${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$1 = `click${$e9dd36436aec3b21$var$EVENT_KEY$3}${$e9dd36436aec3b21$var$DATA_API_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN_DISMISS = `keydown.dismiss${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
const $e9dd36436aec3b21$var$Default$5 = {
    backdrop: true,
    keyboard: true,
    scroll: false
};
const $e9dd36436aec3b21$var$DefaultType$5 = {
    backdrop: '(boolean|string)',
    keyboard: 'boolean',
    scroll: 'boolean'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$591ca0244c9dfcd4 extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isShown = false;
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$5;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$5;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$6;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown) return;
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOW$3, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._backdrop.show();
        if (!this._config.scroll) new $e9dd36436aec3b21$var$ScrollBarHelper().hide();
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOWING$1);
        const completeCallBack = ()=>{
            if (!this._config.scroll || this._config.backdrop) this._focustrap.activate();
            this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$3);
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOWING$1);
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOWN$3, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(completeCallBack, this._element, true);
    }
    hide() {
        if (!this._isShown) return;
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE$3);
        if (hideEvent.defaultPrevented) return;
        this._focustrap.deactivate();
        this._element.blur();
        this._isShown = false;
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_HIDING);
        this._backdrop.hide();
        const completeCallback = ()=>{
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$3, $e9dd36436aec3b21$var$CLASS_NAME_HIDING);
            this._element.removeAttribute('aria-modal');
            this._element.removeAttribute('role');
            if (!this._config.scroll) new $e9dd36436aec3b21$var$ScrollBarHelper().reset();
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDDEN$3);
        };
        this._queueCallback(completeCallback, this._element, true);
    }
    dispose() {
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    // Private
    _initializeBackDrop() {
        const clickCallback = ()=>{
            if (this._config.backdrop === 'static') {
                $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE_PREVENTED);
                return;
            }
            this.hide();
        };
        // 'static' option will be translated to true, and booleans will keep their value
        const isVisible = Boolean(this._config.backdrop);
        return new $e9dd36436aec3b21$var$Backdrop({
            className: $e9dd36436aec3b21$var$CLASS_NAME_BACKDROP,
            isVisible: isVisible,
            isAnimated: true,
            rootElement: this._element.parentNode,
            clickCallback: isVisible ? clickCallback : null
        });
    }
    _initializeFocusTrap() {
        return new $e9dd36436aec3b21$var$FocusTrap({
            trapElement: this._element
        });
    }
    _addEventListeners() {
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_KEYDOWN_DISMISS, (event)=>{
            if (event.key !== $e9dd36436aec3b21$var$ESCAPE_KEY) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE_PREVENTED);
        });
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$591ca0244c9dfcd4.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$1, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$1, function(event) {
    const target = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($e9dd36436aec3b21$var$isDisabled(this)) return;
    $e9dd36436aec3b21$var$EventHandler.one(target, $e9dd36436aec3b21$var$EVENT_HIDDEN$3, ()=>{
        // focus on trigger when it is closed
        if ($e9dd36436aec3b21$var$isVisible(this)) this.focus();
    });
    // avoid conflict when clicking a toggler of an offcanvas, while another is open
    const alreadyOpen = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$OPEN_SELECTOR);
    if (alreadyOpen && alreadyOpen !== target) $e9dd36436aec3b21$export$591ca0244c9dfcd4.getInstance(alreadyOpen).hide();
    const data = $e9dd36436aec3b21$export$591ca0244c9dfcd4.getOrCreateInstance(target);
    data.toggle(this);
});
$e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$2, ()=>{
    for (const selector of $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$OPEN_SELECTOR))$e9dd36436aec3b21$export$591ca0244c9dfcd4.getOrCreateInstance(selector).show();
});
$e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_RESIZE, ()=>{
    for (const element of $e9dd36436aec3b21$var$SelectorEngine.find('[aria-modal][class*=show][class*=offcanvas-]'))if (getComputedStyle(element).position !== 'fixed') $e9dd36436aec3b21$export$591ca0244c9dfcd4.getOrCreateInstance(element).hide();
});
$e9dd36436aec3b21$var$enableDismissTrigger($e9dd36436aec3b21$export$591ca0244c9dfcd4);
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$591ca0244c9dfcd4);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/sanitizer.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ // js-docs-start allow-list
const $e9dd36436aec3b21$var$ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
const $e9dd36436aec3b21$var$DefaultAllowlist = {
    // Global attributes allowed on any supplied element below.
    '*': [
        'class',
        'dir',
        'id',
        'lang',
        'role',
        $e9dd36436aec3b21$var$ARIA_ATTRIBUTE_PATTERN
    ],
    a: [
        'target',
        'href',
        'title',
        'rel'
    ],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    dd: [],
    div: [],
    dl: [],
    dt: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: [
        'src',
        'srcset',
        'alt',
        'title',
        'width',
        'height'
    ],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
};
// js-docs-end allow-list
const $e9dd36436aec3b21$var$uriAttributes = new Set([
    'background',
    'cite',
    'href',
    'itemtype',
    'longdesc',
    'poster',
    'src',
    'xlink:href'
]);
/**
 * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
 * contexts.
 *
 * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
 */ const $e9dd36436aec3b21$var$SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
const $e9dd36436aec3b21$var$allowedAttribute = (attribute, allowedAttributeList)=>{
    const attributeName = attribute.nodeName.toLowerCase();
    if (allowedAttributeList.includes(attributeName)) {
        if ($e9dd36436aec3b21$var$uriAttributes.has(attributeName)) return Boolean($e9dd36436aec3b21$var$SAFE_URL_PATTERN.test(attribute.nodeValue));
        return true;
    }
    // Check if a regular expression validates the attribute.
    return allowedAttributeList.filter((attributeRegex)=>attributeRegex instanceof RegExp).some((regex)=>regex.test(attributeName));
};
function $e9dd36436aec3b21$var$sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
    if (!unsafeHtml.length) return unsafeHtml;
    if (sanitizeFunction && typeof sanitizeFunction === 'function') return sanitizeFunction(unsafeHtml);
    const domParser = new window.DOMParser();
    const createdDocument = domParser.parseFromString(unsafeHtml, 'text/html');
    const elements = [].concat(...createdDocument.body.querySelectorAll('*'));
    for (const element of elements){
        const elementName = element.nodeName.toLowerCase();
        if (!Object.keys(allowList).includes(elementName)) {
            element.remove();
            continue;
        }
        const attributeList = [].concat(...element.attributes);
        const allowedAttributes = [].concat(allowList['*'] || [], allowList[elementName] || []);
        for (const attribute of attributeList)if (!$e9dd36436aec3b21$var$allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
    }
    return createdDocument.body.innerHTML;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/template-factory.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$5 = 'TemplateFactory';
const $e9dd36436aec3b21$var$Default$4 = {
    allowList: $e9dd36436aec3b21$var$DefaultAllowlist,
    content: {},
    // { selector : text ,  selector2 : text2 , }
    extraClass: '',
    html: false,
    sanitize: true,
    sanitizeFn: null,
    template: '<div></div>'
};
const $e9dd36436aec3b21$var$DefaultType$4 = {
    allowList: 'object',
    content: 'object',
    extraClass: '(string|function)',
    html: 'boolean',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    template: 'string'
};
const $e9dd36436aec3b21$var$DefaultContentType = {
    entry: '(string|element|function|null)',
    selector: '(string|element)'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$TemplateFactory extends $e9dd36436aec3b21$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$4;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$4;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$5;
    }
    // Public
    getContent() {
        return Object.values(this._config.content).map((config)=>this._resolvePossibleFunction(config)).filter(Boolean);
    }
    hasContent() {
        return this.getContent().length > 0;
    }
    changeContent(content) {
        this._checkContent(content);
        this._config.content = {
            ...this._config.content,
            ...content
        };
        return this;
    }
    toHtml() {
        const templateWrapper = document.createElement('div');
        templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
        for (const [selector, text] of Object.entries(this._config.content))this._setContent(templateWrapper, text, selector);
        const template = templateWrapper.children[0];
        const extraClass = this._resolvePossibleFunction(this._config.extraClass);
        if (extraClass) template.classList.add(...extraClass.split(' '));
        return template;
    }
    // Private
    _typeCheckConfig(config) {
        super._typeCheckConfig(config);
        this._checkContent(config.content);
    }
    _checkContent(arg) {
        for (const [selector, content] of Object.entries(arg))super._typeCheckConfig({
            selector: selector,
            entry: content
        }, $e9dd36436aec3b21$var$DefaultContentType);
    }
    _setContent(template, content, selector) {
        const templateElement = $e9dd36436aec3b21$var$SelectorEngine.findOne(selector, template);
        if (!templateElement) return;
        content = this._resolvePossibleFunction(content);
        if (!content) {
            templateElement.remove();
            return;
        }
        if ($e9dd36436aec3b21$var$isElement(content)) {
            this._putElementInTemplate($e9dd36436aec3b21$var$getElement(content), templateElement);
            return;
        }
        if (this._config.html) {
            templateElement.innerHTML = this._maybeSanitize(content);
            return;
        }
        templateElement.textContent = content;
    }
    _maybeSanitize(arg) {
        return this._config.sanitize ? $e9dd36436aec3b21$var$sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
    }
    _resolvePossibleFunction(arg) {
        return $e9dd36436aec3b21$var$execute(arg, [
            undefined,
            this
        ]);
    }
    _putElementInTemplate(element, templateElement) {
        if (this._config.html) {
            templateElement.innerHTML = '';
            templateElement.append(element);
            return;
        }
        templateElement.textContent = element.textContent;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$4 = 'tooltip';
const $e9dd36436aec3b21$var$DISALLOWED_ATTRIBUTES = new Set([
    'sanitize',
    'allowList',
    'sanitizeFn'
]);
const $e9dd36436aec3b21$var$CLASS_NAME_FADE$2 = 'fade';
const $e9dd36436aec3b21$var$CLASS_NAME_MODAL = 'modal';
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$2 = 'show';
const $e9dd36436aec3b21$var$SELECTOR_TOOLTIP_INNER = '.tooltip-inner';
const $e9dd36436aec3b21$var$SELECTOR_MODAL = `.${$e9dd36436aec3b21$var$CLASS_NAME_MODAL}`;
const $e9dd36436aec3b21$var$EVENT_MODAL_HIDE = 'hide.bs.modal';
const $e9dd36436aec3b21$var$TRIGGER_HOVER = 'hover';
const $e9dd36436aec3b21$var$TRIGGER_FOCUS = 'focus';
const $e9dd36436aec3b21$var$TRIGGER_CLICK = 'click';
const $e9dd36436aec3b21$var$TRIGGER_MANUAL = 'manual';
const $e9dd36436aec3b21$var$EVENT_HIDE$2 = 'hide';
const $e9dd36436aec3b21$var$EVENT_HIDDEN$2 = 'hidden';
const $e9dd36436aec3b21$var$EVENT_SHOW$2 = 'show';
const $e9dd36436aec3b21$var$EVENT_SHOWN$2 = 'shown';
const $e9dd36436aec3b21$var$EVENT_INSERTED = 'inserted';
const $e9dd36436aec3b21$var$EVENT_CLICK$1 = 'click';
const $e9dd36436aec3b21$var$EVENT_FOCUSIN$1 = 'focusin';
const $e9dd36436aec3b21$var$EVENT_FOCUSOUT$1 = 'focusout';
const $e9dd36436aec3b21$var$EVENT_MOUSEENTER = 'mouseenter';
const $e9dd36436aec3b21$var$EVENT_MOUSELEAVE = 'mouseleave';
const $e9dd36436aec3b21$var$AttachmentMap = {
    AUTO: 'auto',
    TOP: 'top',
    RIGHT: $e9dd36436aec3b21$var$isRTL() ? 'left' : 'right',
    BOTTOM: 'bottom',
    LEFT: $e9dd36436aec3b21$var$isRTL() ? 'right' : 'left'
};
const $e9dd36436aec3b21$var$Default$3 = {
    allowList: $e9dd36436aec3b21$var$DefaultAllowlist,
    animation: true,
    boundary: 'clippingParents',
    container: false,
    customClass: '',
    delay: 0,
    fallbackPlacements: [
        'top',
        'right',
        'bottom',
        'left'
    ],
    html: false,
    offset: [
        0,
        6
    ],
    placement: 'top',
    popperConfig: null,
    sanitize: true,
    sanitizeFn: null,
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    title: '',
    trigger: 'hover focus'
};
const $e9dd36436aec3b21$var$DefaultType$3 = {
    allowList: 'object',
    animation: 'boolean',
    boundary: '(string|element)',
    container: '(string|element|boolean)',
    customClass: '(string|function)',
    delay: '(number|object)',
    fallbackPlacements: 'array',
    html: 'boolean',
    offset: '(array|string|function)',
    placement: '(string|function)',
    popperConfig: '(null|object|function)',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    selector: '(string|boolean)',
    template: 'string',
    title: '(string|element|function)',
    trigger: 'string'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$28c660c63b792dea extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        if (typeof $cc4ed71c4f27adbc$exports === 'undefined') throw new TypeError('Bootstrap\'s tooltips require Popper (https://popper.js.org/docs/v2/)');
        super(element, config);
        // Private
        this._isEnabled = true;
        this._timeout = 0;
        this._isHovered = null;
        this._activeTrigger = {};
        this._popper = null;
        this._templateFactory = null;
        this._newContent = null;
        // Protected
        this.tip = null;
        this._setListeners();
        if (!this._config.selector) this._fixTitle();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$3;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$3;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$4;
    }
    // Public
    enable() {
        this._isEnabled = true;
    }
    disable() {
        this._isEnabled = false;
    }
    toggleEnabled() {
        this._isEnabled = !this._isEnabled;
    }
    toggle() {
        if (!this._isEnabled) return;
        if (this._isShown()) {
            this._leave();
            return;
        }
        this._enter();
    }
    dispose() {
        clearTimeout(this._timeout);
        $e9dd36436aec3b21$var$EventHandler.off(this._element.closest($e9dd36436aec3b21$var$SELECTOR_MODAL), $e9dd36436aec3b21$var$EVENT_MODAL_HIDE, this._hideModalHandler);
        if (this._element.getAttribute('data-bs-original-title')) this._element.setAttribute('title', this._element.getAttribute('data-bs-original-title'));
        this._disposePopper();
        super.dispose();
    }
    show() {
        if (this._element.style.display === 'none') throw new Error('Please use show on visible elements');
        if (!(this._isWithContent() && this._isEnabled)) return;
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_SHOW$2));
        const shadowRoot = $e9dd36436aec3b21$var$findShadowRoot(this._element);
        const isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
        if (showEvent.defaultPrevented || !isInTheDom) return;
        // TODO: v6 remove this or make it optional
        this._disposePopper();
        const tip = this._getTipElement();
        this._element.setAttribute('aria-describedby', tip.getAttribute('id'));
        const { container: container } = this._config;
        if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
            container.append(tip);
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_INSERTED));
        }
        this._popper = this._createPopper(tip);
        tip.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$e9dd36436aec3b21$var$EventHandler.on(element, 'mouseover', $e9dd36436aec3b21$var$noop);
        const complete = ()=>{
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_SHOWN$2));
            if (this._isHovered === false) this._leave();
            this._isHovered = false;
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    hide() {
        if (!this._isShown()) return;
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_HIDE$2));
        if (hideEvent.defaultPrevented) return;
        const tip = this._getTipElement();
        tip.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$e9dd36436aec3b21$var$EventHandler.off(element, 'mouseover', $e9dd36436aec3b21$var$noop);
        this._activeTrigger[$e9dd36436aec3b21$var$TRIGGER_CLICK] = false;
        this._activeTrigger[$e9dd36436aec3b21$var$TRIGGER_FOCUS] = false;
        this._activeTrigger[$e9dd36436aec3b21$var$TRIGGER_HOVER] = false;
        this._isHovered = null; // it is a trick to support manual triggering
        const complete = ()=>{
            if (this._isWithActiveTrigger()) return;
            if (!this._isHovered) this._disposePopper();
            this._element.removeAttribute('aria-describedby');
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_HIDDEN$2));
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    update() {
        if (this._popper) this._popper.update();
    }
    // Protected
    _isWithContent() {
        return Boolean(this._getTitle());
    }
    _getTipElement() {
        if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
        return this.tip;
    }
    _createTipElement(content) {
        const tip = this._getTemplateFactory(content).toHtml();
        // TODO: remove this check in v6
        if (!tip) return null;
        tip.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_FADE$2, $e9dd36436aec3b21$var$CLASS_NAME_SHOW$2);
        // TODO: v6 the following can be achieved with CSS only
        tip.classList.add(`bs-${this.constructor.NAME}-auto`);
        const tipId = $e9dd36436aec3b21$var$getUID(this.constructor.NAME).toString();
        tip.setAttribute('id', tipId);
        if (this._isAnimated()) tip.classList.add($e9dd36436aec3b21$var$CLASS_NAME_FADE$2);
        return tip;
    }
    setContent(content) {
        this._newContent = content;
        if (this._isShown()) {
            this._disposePopper();
            this.show();
        }
    }
    _getTemplateFactory(content) {
        if (this._templateFactory) this._templateFactory.changeContent(content);
        else this._templateFactory = new $e9dd36436aec3b21$var$TemplateFactory({
            ...this._config,
            content: // the `content` var has to be after `this._config`
            // to override config.content in case of popover
            content,
            extraClass: this._resolvePossibleFunction(this._config.customClass)
        });
        return this._templateFactory;
    }
    _getContentForTemplate() {
        return {
            [$e9dd36436aec3b21$var$SELECTOR_TOOLTIP_INNER]: this._getTitle()
        };
    }
    _getTitle() {
        return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute('data-bs-original-title');
    }
    // Private
    _initializeOnDelegatedTarget(event) {
        return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
    }
    _isAnimated() {
        return this._config.animation || this.tip && this.tip.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_FADE$2);
    }
    _isShown() {
        return this.tip && this.tip.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_SHOW$2);
    }
    _createPopper(tip) {
        const placement = $e9dd36436aec3b21$var$execute(this._config.placement, [
            this,
            tip,
            this._element
        ]);
        const attachment = $e9dd36436aec3b21$var$AttachmentMap[placement.toUpperCase()];
        return $cc4ed71c4f27adbc$exports.createPopper(this._element, tip, this._getPopperConfig(attachment));
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
        if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _resolvePossibleFunction(arg) {
        return $e9dd36436aec3b21$var$execute(arg, [
            this._element,
            this._element
        ]);
    }
    _getPopperConfig(attachment) {
        const defaultBsPopperConfig = {
            placement: attachment,
            modifiers: [
                {
                    name: 'flip',
                    options: {
                        fallbackPlacements: this._config.fallbackPlacements
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: this._getOffset()
                    }
                },
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: 'arrow',
                    options: {
                        element: `.${this.constructor.NAME}-arrow`
                    }
                },
                {
                    name: 'preSetPlacement',
                    enabled: true,
                    phase: 'beforeMain',
                    fn: (data)=>{
                        // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                        // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                        this._getTipElement().setAttribute('data-popper-placement', data.state.placement);
                    }
                }
            ]
        };
        return {
            ...defaultBsPopperConfig,
            ...$e9dd36436aec3b21$var$execute(this._config.popperConfig, [
                undefined,
                defaultBsPopperConfig
            ])
        };
    }
    _setListeners() {
        const triggers = this._config.trigger.split(' ');
        for (const trigger of triggers){
            if (trigger === 'click') $e9dd36436aec3b21$var$EventHandler.on(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_CLICK$1), this._config.selector, (event)=>{
                const context = this._initializeOnDelegatedTarget(event);
                context._activeTrigger[$e9dd36436aec3b21$var$TRIGGER_CLICK] = !(context._isShown() && context._activeTrigger[$e9dd36436aec3b21$var$TRIGGER_CLICK]);
                context.toggle();
            });
            else if (trigger !== $e9dd36436aec3b21$var$TRIGGER_MANUAL) {
                const eventIn = trigger === $e9dd36436aec3b21$var$TRIGGER_HOVER ? this.constructor.eventName($e9dd36436aec3b21$var$EVENT_MOUSEENTER) : this.constructor.eventName($e9dd36436aec3b21$var$EVENT_FOCUSIN$1);
                const eventOut = trigger === $e9dd36436aec3b21$var$TRIGGER_HOVER ? this.constructor.eventName($e9dd36436aec3b21$var$EVENT_MOUSELEAVE) : this.constructor.eventName($e9dd36436aec3b21$var$EVENT_FOCUSOUT$1);
                $e9dd36436aec3b21$var$EventHandler.on(this._element, eventIn, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === 'focusin' ? $e9dd36436aec3b21$var$TRIGGER_FOCUS : $e9dd36436aec3b21$var$TRIGGER_HOVER] = true;
                    context._enter();
                });
                $e9dd36436aec3b21$var$EventHandler.on(this._element, eventOut, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === 'focusout' ? $e9dd36436aec3b21$var$TRIGGER_FOCUS : $e9dd36436aec3b21$var$TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                    context._leave();
                });
            }
        }
        this._hideModalHandler = ()=>{
            if (this._element) this.hide();
        };
        $e9dd36436aec3b21$var$EventHandler.on(this._element.closest($e9dd36436aec3b21$var$SELECTOR_MODAL), $e9dd36436aec3b21$var$EVENT_MODAL_HIDE, this._hideModalHandler);
    }
    _fixTitle() {
        const title = this._element.getAttribute('title');
        if (!title) return;
        if (!this._element.getAttribute('aria-label') && !this._element.textContent.trim()) this._element.setAttribute('aria-label', title);
        this._element.setAttribute('data-bs-original-title', title); // DO NOT USE IT. Is only for backwards compatibility
        this._element.removeAttribute('title');
    }
    _enter() {
        if (this._isShown() || this._isHovered) {
            this._isHovered = true;
            return;
        }
        this._isHovered = true;
        this._setTimeout(()=>{
            if (this._isHovered) this.show();
        }, this._config.delay.show);
    }
    _leave() {
        if (this._isWithActiveTrigger()) return;
        this._isHovered = false;
        this._setTimeout(()=>{
            if (!this._isHovered) this.hide();
        }, this._config.delay.hide);
    }
    _setTimeout(handler, timeout) {
        clearTimeout(this._timeout);
        this._timeout = setTimeout(handler, timeout);
    }
    _isWithActiveTrigger() {
        return Object.values(this._activeTrigger).includes(true);
    }
    _getConfig(config) {
        const dataAttributes = $e9dd36436aec3b21$var$Manipulator.getDataAttributes(this._element);
        for (const dataAttribute of Object.keys(dataAttributes))if ($e9dd36436aec3b21$var$DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
        config = {
            ...dataAttributes,
            ...typeof config === 'object' && config ? config : {}
        };
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        config.container = config.container === false ? document.body : $e9dd36436aec3b21$var$getElement(config.container);
        if (typeof config.delay === 'number') config.delay = {
            show: config.delay,
            hide: config.delay
        };
        if (typeof config.title === 'number') config.title = config.title.toString();
        if (typeof config.content === 'number') config.content = config.content.toString();
        return config;
    }
    _getDelegateConfig() {
        const config = {};
        for (const [key, value] of Object.entries(this._config))if (this.constructor.Default[key] !== value) config[key] = value;
        config.selector = false;
        config.trigger = 'manual';
        // In the future can be replaced with:
        // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
        // `Object.fromEntries(keysWithDifferentValues)`
        return config;
    }
    _disposePopper() {
        if (this._popper) {
            this._popper.destroy();
            this._popper = null;
        }
        if (this.tip) {
            this.tip.remove();
            this.tip = null;
        }
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$28c660c63b792dea.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$28c660c63b792dea);
/**
 * --------------------------------------------------------------------------
 * Bootstrap popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$3 = 'popover';
const $e9dd36436aec3b21$var$SELECTOR_TITLE = '.popover-header';
const $e9dd36436aec3b21$var$SELECTOR_CONTENT = '.popover-body';
const $e9dd36436aec3b21$var$Default$2 = {
    ...$e9dd36436aec3b21$export$28c660c63b792dea.Default,
    content: '',
    offset: [
        0,
        8
    ],
    placement: 'right',
    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    trigger: 'click'
};
const $e9dd36436aec3b21$var$DefaultType$2 = {
    ...$e9dd36436aec3b21$export$28c660c63b792dea.DefaultType,
    content: '(null|string|element|function)'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$5b6b19405a83ff9d extends $e9dd36436aec3b21$export$28c660c63b792dea {
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$2;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$2;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$3;
    }
    // Overrides
    _isWithContent() {
        return this._getTitle() || this._getContent();
    }
    // Private
    _getContentForTemplate() {
        return {
            [$e9dd36436aec3b21$var$SELECTOR_TITLE]: this._getTitle(),
            [$e9dd36436aec3b21$var$SELECTOR_CONTENT]: this._getContent()
        };
    }
    _getContent() {
        return this._resolvePossibleFunction(this._config.content);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$5b6b19405a83ff9d.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$5b6b19405a83ff9d);
/**
 * --------------------------------------------------------------------------
 * Bootstrap scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$2 = 'scrollspy';
const $e9dd36436aec3b21$var$DATA_KEY$2 = 'bs.scrollspy';
const $e9dd36436aec3b21$var$EVENT_KEY$2 = `.${$e9dd36436aec3b21$var$DATA_KEY$2}`;
const $e9dd36436aec3b21$var$DATA_API_KEY = '.data-api';
const $e9dd36436aec3b21$var$EVENT_ACTIVATE = `activate${$e9dd36436aec3b21$var$EVENT_KEY$2}`;
const $e9dd36436aec3b21$var$EVENT_CLICK = `click${$e9dd36436aec3b21$var$EVENT_KEY$2}`;
const $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$1 = `load${$e9dd36436aec3b21$var$EVENT_KEY$2}${$e9dd36436aec3b21$var$DATA_API_KEY}`;
const $e9dd36436aec3b21$var$CLASS_NAME_DROPDOWN_ITEM = 'dropdown-item';
const $e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1 = 'active';
const $e9dd36436aec3b21$var$SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
const $e9dd36436aec3b21$var$SELECTOR_TARGET_LINKS = '[href]';
const $e9dd36436aec3b21$var$SELECTOR_NAV_LIST_GROUP = '.nav, .list-group';
const $e9dd36436aec3b21$var$SELECTOR_NAV_LINKS = '.nav-link';
const $e9dd36436aec3b21$var$SELECTOR_NAV_ITEMS = '.nav-item';
const $e9dd36436aec3b21$var$SELECTOR_LIST_ITEMS = '.list-group-item';
const $e9dd36436aec3b21$var$SELECTOR_LINK_ITEMS = `${$e9dd36436aec3b21$var$SELECTOR_NAV_LINKS}, ${$e9dd36436aec3b21$var$SELECTOR_NAV_ITEMS} > ${$e9dd36436aec3b21$var$SELECTOR_NAV_LINKS}, ${$e9dd36436aec3b21$var$SELECTOR_LIST_ITEMS}`;
const $e9dd36436aec3b21$var$SELECTOR_DROPDOWN = '.dropdown';
const $e9dd36436aec3b21$var$SELECTOR_DROPDOWN_TOGGLE$1 = '.dropdown-toggle';
const $e9dd36436aec3b21$var$Default$1 = {
    offset: null,
    // TODO: v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: '0px 0px -25%',
    smoothScroll: false,
    target: null,
    threshold: [
        0.1,
        0.5,
        1
    ]
};
const $e9dd36436aec3b21$var$DefaultType$1 = {
    offset: '(number|null)',
    // TODO v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: 'string',
    smoothScroll: 'boolean',
    target: 'element',
    threshold: 'array'
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$a6472a5298a374be extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        // this._element is the observablesContainer and config.target the menu links wrapper
        this._targetLinks = new Map();
        this._observableSections = new Map();
        this._rootElement = getComputedStyle(this._element).overflowY === 'visible' ? null : this._element;
        this._activeTarget = null;
        this._observer = null;
        this._previousScrollData = {
            visibleEntryTop: 0,
            parentScrollTop: 0
        };
        this.refresh(); // initialize
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$1;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$1;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$2;
    }
    // Public
    refresh() {
        this._initializeTargetsAndObservables();
        this._maybeEnableSmoothScroll();
        if (this._observer) this._observer.disconnect();
        else this._observer = this._getNewObserver();
        for (const section of this._observableSections.values())this._observer.observe(section);
    }
    dispose() {
        this._observer.disconnect();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
        config.target = $e9dd36436aec3b21$var$getElement(config.target) || document.body;
        // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
        config.rootMargin = config.offset ? `${config.offset}px 0px -30%` : config.rootMargin;
        if (typeof config.threshold === 'string') config.threshold = config.threshold.split(',').map((value)=>Number.parseFloat(value));
        return config;
    }
    _maybeEnableSmoothScroll() {
        if (!this._config.smoothScroll) return;
        // unregister any previous listeners
        $e9dd36436aec3b21$var$EventHandler.off(this._config.target, $e9dd36436aec3b21$var$EVENT_CLICK);
        $e9dd36436aec3b21$var$EventHandler.on(this._config.target, $e9dd36436aec3b21$var$EVENT_CLICK, $e9dd36436aec3b21$var$SELECTOR_TARGET_LINKS, (event)=>{
            const observableSection = this._observableSections.get(event.target.hash);
            if (observableSection) {
                event.preventDefault();
                const root = this._rootElement || window;
                const height = observableSection.offsetTop - this._element.offsetTop;
                if (root.scrollTo) {
                    root.scrollTo({
                        top: height,
                        behavior: 'smooth'
                    });
                    return;
                }
                // Chrome 60 doesn't support `scrollTo`
                root.scrollTop = height;
            }
        });
    }
    _getNewObserver() {
        const options = {
            root: this._rootElement,
            threshold: this._config.threshold,
            rootMargin: this._config.rootMargin
        };
        return new IntersectionObserver((entries)=>this._observerCallback(entries), options);
    }
    // The logic of selection
    _observerCallback(entries) {
        const targetElement = (entry)=>this._targetLinks.get(`#${entry.target.id}`);
        const activate = (entry)=>{
            this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
            this._process(targetElement(entry));
        };
        const parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
        const userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
        this._previousScrollData.parentScrollTop = parentScrollTop;
        for (const entry of entries){
            if (!entry.isIntersecting) {
                this._activeTarget = null;
                this._clearActiveClass(targetElement(entry));
                continue;
            }
            const entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
            // if we are scrolling down, pick the bigger offsetTop
            if (userScrollsDown && entryIsLowerThanPrevious) {
                activate(entry);
                // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                if (!parentScrollTop) return;
                continue;
            }
            // if we are scrolling up, pick the smallest offsetTop
            if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
        }
    }
    _initializeTargetsAndObservables() {
        this._targetLinks = new Map();
        this._observableSections = new Map();
        const targetLinks = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_TARGET_LINKS, this._config.target);
        for (const anchor of targetLinks){
            // ensure that the anchor has an id and is not disabled
            if (!anchor.hash || $e9dd36436aec3b21$var$isDisabled(anchor)) continue;
            const observableSection = $e9dd36436aec3b21$var$SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
            // ensure that the observableSection exists & is visible
            if ($e9dd36436aec3b21$var$isVisible(observableSection)) {
                this._targetLinks.set(decodeURI(anchor.hash), anchor);
                this._observableSections.set(anchor.hash, observableSection);
            }
        }
    }
    _process(target) {
        if (this._activeTarget === target) return;
        this._clearActiveClass(this._config.target);
        this._activeTarget = target;
        target.classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1);
        this._activateParents(target);
        $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_ACTIVATE, {
            relatedTarget: target
        });
    }
    _activateParents(target) {
        // Activate dropdown parents
        if (target.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPDOWN_ITEM)) {
            $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_DROPDOWN_TOGGLE$1, target.closest($e9dd36436aec3b21$var$SELECTOR_DROPDOWN)).classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1);
            return;
        }
        for (const listGroup of $e9dd36436aec3b21$var$SelectorEngine.parents(target, $e9dd36436aec3b21$var$SELECTOR_NAV_LIST_GROUP))// Set triggered links parents as active
        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
        for (const item of $e9dd36436aec3b21$var$SelectorEngine.prev(listGroup, $e9dd36436aec3b21$var$SELECTOR_LINK_ITEMS))item.classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1);
    }
    _clearActiveClass(parent) {
        parent.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1);
        const activeNodes = $e9dd36436aec3b21$var$SelectorEngine.find(`${$e9dd36436aec3b21$var$SELECTOR_TARGET_LINKS}.${$e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1}`, parent);
        for (const node of activeNodes)node.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$a6472a5298a374be.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$1, ()=>{
    for (const spy of $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_DATA_SPY))$e9dd36436aec3b21$export$a6472a5298a374be.getOrCreateInstance(spy);
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$a6472a5298a374be);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$1 = 'tab';
const $e9dd36436aec3b21$var$DATA_KEY$1 = 'bs.tab';
const $e9dd36436aec3b21$var$EVENT_KEY$1 = `.${$e9dd36436aec3b21$var$DATA_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_HIDE$1 = `hide${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN$1 = `hidden${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_SHOW$1 = `show${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN$1 = `shown${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API = `click${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN = `keydown${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API = `load${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$ARROW_LEFT_KEY = 'ArrowLeft';
const $e9dd36436aec3b21$var$ARROW_RIGHT_KEY = 'ArrowRight';
const $e9dd36436aec3b21$var$ARROW_UP_KEY = 'ArrowUp';
const $e9dd36436aec3b21$var$ARROW_DOWN_KEY = 'ArrowDown';
const $e9dd36436aec3b21$var$HOME_KEY = 'Home';
const $e9dd36436aec3b21$var$END_KEY = 'End';
const $e9dd36436aec3b21$var$CLASS_NAME_ACTIVE = 'active';
const $e9dd36436aec3b21$var$CLASS_NAME_FADE$1 = 'fade';
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$1 = 'show';
const $e9dd36436aec3b21$var$CLASS_DROPDOWN = 'dropdown';
const $e9dd36436aec3b21$var$SELECTOR_DROPDOWN_TOGGLE = '.dropdown-toggle';
const $e9dd36436aec3b21$var$SELECTOR_DROPDOWN_MENU = '.dropdown-menu';
const $e9dd36436aec3b21$var$NOT_SELECTOR_DROPDOWN_TOGGLE = `:not(${$e9dd36436aec3b21$var$SELECTOR_DROPDOWN_TOGGLE})`;
const $e9dd36436aec3b21$var$SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
const $e9dd36436aec3b21$var$SELECTOR_OUTER = '.nav-item, .list-group-item';
const $e9dd36436aec3b21$var$SELECTOR_INNER = `.nav-link${$e9dd36436aec3b21$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, .list-group-item${$e9dd36436aec3b21$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, [role="tab"]${$e9dd36436aec3b21$var$NOT_SELECTOR_DROPDOWN_TOGGLE}`;
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
const $e9dd36436aec3b21$var$SELECTOR_INNER_ELEM = `${$e9dd36436aec3b21$var$SELECTOR_INNER}, ${$e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE}`;
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE_ACTIVE = `.${$e9dd36436aec3b21$var$CLASS_NAME_ACTIVE}[data-bs-toggle="tab"], .${$e9dd36436aec3b21$var$CLASS_NAME_ACTIVE}[data-bs-toggle="pill"], .${$e9dd36436aec3b21$var$CLASS_NAME_ACTIVE}[data-bs-toggle="list"]`;
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$3e41faf802a29e71 extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element){
        super(element);
        this._parent = this._element.closest($e9dd36436aec3b21$var$SELECTOR_TAB_PANEL);
        if (!this._parent) return;
        // Set up initial aria attributes
        this._setInitialAttributes(this._parent, this._getChildren());
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_KEYDOWN, (event)=>this._keydown(event));
    }
    // Getters
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$1;
    }
    // Public
    show() {
        // Shows this elem and deactivate the active sibling if exists
        const innerElem = this._element;
        if (this._elemIsActive(innerElem)) return;
        // Search for active tab on same parent to deactivate it
        const active = this._getActiveElem();
        const hideEvent = active ? $e9dd36436aec3b21$var$EventHandler.trigger(active, $e9dd36436aec3b21$var$EVENT_HIDE$1, {
            relatedTarget: innerElem
        }) : null;
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(innerElem, $e9dd36436aec3b21$var$EVENT_SHOW$1, {
            relatedTarget: active
        });
        if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
        this._deactivate(active, innerElem);
        this._activate(innerElem, active);
    }
    // Private
    _activate(element, relatedElem) {
        if (!element) return;
        element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE);
        this._activate($e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
        const complete = ()=>{
            if (element.getAttribute('role') !== 'tab') {
                element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.removeAttribute('tabindex');
            element.setAttribute('aria-selected', true);
            this._toggleDropDown(element, true);
            $e9dd36436aec3b21$var$EventHandler.trigger(element, $e9dd36436aec3b21$var$EVENT_SHOWN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_FADE$1));
    }
    _deactivate(element, relatedElem) {
        if (!element) return;
        element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE);
        element.blur();
        this._deactivate($e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
        const complete = ()=>{
            if (element.getAttribute('role') !== 'tab') {
                element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.setAttribute('aria-selected', false);
            element.setAttribute('tabindex', '-1');
            this._toggleDropDown(element, false);
            $e9dd36436aec3b21$var$EventHandler.trigger(element, $e9dd36436aec3b21$var$EVENT_HIDDEN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_FADE$1));
    }
    _keydown(event) {
        if (![
            $e9dd36436aec3b21$var$ARROW_LEFT_KEY,
            $e9dd36436aec3b21$var$ARROW_RIGHT_KEY,
            $e9dd36436aec3b21$var$ARROW_UP_KEY,
            $e9dd36436aec3b21$var$ARROW_DOWN_KEY,
            $e9dd36436aec3b21$var$HOME_KEY,
            $e9dd36436aec3b21$var$END_KEY
        ].includes(event.key)) return;
        event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
        event.preventDefault();
        const children = this._getChildren().filter((element)=>!$e9dd36436aec3b21$var$isDisabled(element));
        let nextActiveElement;
        if ([
            $e9dd36436aec3b21$var$HOME_KEY,
            $e9dd36436aec3b21$var$END_KEY
        ].includes(event.key)) nextActiveElement = children[event.key === $e9dd36436aec3b21$var$HOME_KEY ? 0 : children.length - 1];
        else {
            const isNext = [
                $e9dd36436aec3b21$var$ARROW_RIGHT_KEY,
                $e9dd36436aec3b21$var$ARROW_DOWN_KEY
            ].includes(event.key);
            nextActiveElement = $e9dd36436aec3b21$var$getNextActiveElement(children, event.target, isNext, true);
        }
        if (nextActiveElement) {
            nextActiveElement.focus({
                preventScroll: true
            });
            $e9dd36436aec3b21$export$3e41faf802a29e71.getOrCreateInstance(nextActiveElement).show();
        }
    }
    _getChildren() {
        // collection of inner elements
        return $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_INNER_ELEM, this._parent);
    }
    _getActiveElem() {
        return this._getChildren().find((child)=>this._elemIsActive(child)) || null;
    }
    _setInitialAttributes(parent, children) {
        this._setAttributeIfNotExists(parent, 'role', 'tablist');
        for (const child of children)this._setInitialAttributesOnChild(child);
    }
    _setInitialAttributesOnChild(child) {
        child = this._getInnerElement(child);
        const isActive = this._elemIsActive(child);
        const outerElem = this._getOuterElement(child);
        child.setAttribute('aria-selected', isActive);
        if (outerElem !== child) this._setAttributeIfNotExists(outerElem, 'role', 'presentation');
        if (!isActive) child.setAttribute('tabindex', '-1');
        this._setAttributeIfNotExists(child, 'role', 'tab');
        // set attributes to the related panel too
        this._setInitialAttributesOnTargetPanel(child);
    }
    _setInitialAttributesOnTargetPanel(child) {
        const target = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(child);
        if (!target) return;
        this._setAttributeIfNotExists(target, 'role', 'tabpanel');
        if (child.id) this._setAttributeIfNotExists(target, 'aria-labelledby', `${child.id}`);
    }
    _toggleDropDown(element, open) {
        const outerElem = this._getOuterElement(element);
        if (!outerElem.classList.contains($e9dd36436aec3b21$var$CLASS_DROPDOWN)) return;
        const toggle = (selector, className)=>{
            const element = $e9dd36436aec3b21$var$SelectorEngine.findOne(selector, outerElem);
            if (element) element.classList.toggle(className, open);
        };
        toggle($e9dd36436aec3b21$var$SELECTOR_DROPDOWN_TOGGLE, $e9dd36436aec3b21$var$CLASS_NAME_ACTIVE);
        toggle($e9dd36436aec3b21$var$SELECTOR_DROPDOWN_MENU, $e9dd36436aec3b21$var$CLASS_NAME_SHOW$1);
        outerElem.setAttribute('aria-expanded', open);
    }
    _setAttributeIfNotExists(element, attribute, value) {
        if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
    }
    _elemIsActive(elem) {
        return elem.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE);
    }
    // Try to get the inner element (usually the .nav-link)
    _getInnerElement(elem) {
        return elem.matches($e9dd36436aec3b21$var$SELECTOR_INNER_ELEM) ? elem : $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_INNER_ELEM, elem);
    }
    // Try to get the outer element (usually the .nav-item)
    _getOuterElement(elem) {
        return elem.closest($e9dd36436aec3b21$var$SELECTOR_OUTER) || elem;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$3e41faf802a29e71.getOrCreateInstance(this);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE, function(event) {
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($e9dd36436aec3b21$var$isDisabled(this)) return;
    $e9dd36436aec3b21$export$3e41faf802a29e71.getOrCreateInstance(this).show();
});
/**
 * Initialize on focus
 */ $e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API, ()=>{
    for (const element of $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE_ACTIVE))$e9dd36436aec3b21$export$3e41faf802a29e71.getOrCreateInstance(element);
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$3e41faf802a29e71);
/**
 * --------------------------------------------------------------------------
 * Bootstrap toast.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME = 'toast';
const $e9dd36436aec3b21$var$DATA_KEY = 'bs.toast';
const $e9dd36436aec3b21$var$EVENT_KEY = `.${$e9dd36436aec3b21$var$DATA_KEY}`;
const $e9dd36436aec3b21$var$EVENT_MOUSEOVER = `mouseover${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_MOUSEOUT = `mouseout${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_FOCUSIN = `focusin${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_FOCUSOUT = `focusout${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_HIDE = `hide${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN = `hidden${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_SHOW = `show${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN = `shown${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$CLASS_NAME_FADE = 'fade';
const $e9dd36436aec3b21$var$CLASS_NAME_HIDE = 'hide'; // @deprecated - kept here only for backwards compatibility
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW = 'show';
const $e9dd36436aec3b21$var$CLASS_NAME_SHOWING = 'showing';
const $e9dd36436aec3b21$var$DefaultType = {
    animation: 'boolean',
    autohide: 'boolean',
    delay: 'number'
};
const $e9dd36436aec3b21$var$Default = {
    animation: true,
    autohide: true,
    delay: 5000
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$8d8dc7d5f743331b extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._timeout = null;
        this._hasMouseInteraction = false;
        this._hasKeyboardInteraction = false;
        this._setListeners();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME;
    }
    // Public
    show() {
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOW);
        if (showEvent.defaultPrevented) return;
        this._clearTimeout();
        if (this._config.animation) this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_FADE);
        const complete = ()=>{
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOWING);
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOWN);
            this._maybeScheduleHide();
        };
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_HIDE); // @deprecated
        $e9dd36436aec3b21$var$reflow(this._element);
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW, $e9dd36436aec3b21$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    hide() {
        if (!this.isShown()) return;
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE);
        if (hideEvent.defaultPrevented) return;
        const complete = ()=>{
            this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_HIDE); // @deprecated
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOWING, $e9dd36436aec3b21$var$CLASS_NAME_SHOW);
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDDEN);
        };
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    dispose() {
        this._clearTimeout();
        if (this.isShown()) this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW);
        super.dispose();
    }
    isShown() {
        return this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_SHOW);
    }
    // Private
    _maybeScheduleHide() {
        if (!this._config.autohide) return;
        if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
        this._timeout = setTimeout(()=>{
            this.hide();
        }, this._config.delay);
    }
    _onInteraction(event, isInteracting) {
        switch(event.type){
            case 'mouseover':
            case 'mouseout':
                this._hasMouseInteraction = isInteracting;
                break;
            case 'focusin':
            case 'focusout':
                this._hasKeyboardInteraction = isInteracting;
                break;
        }
        if (isInteracting) {
            this._clearTimeout();
            return;
        }
        const nextElement = event.relatedTarget;
        if (this._element === nextElement || this._element.contains(nextElement)) return;
        this._maybeScheduleHide();
    }
    _setListeners() {
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_MOUSEOVER, (event)=>this._onInteraction(event, true));
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_MOUSEOUT, (event)=>this._onInteraction(event, false));
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_FOCUSIN, (event)=>this._onInteraction(event, true));
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_FOCUSOUT, (event)=>this._onInteraction(event, false));
    }
    _clearTimeout() {
        clearTimeout(this._timeout);
        this._timeout = null;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$8d8dc7d5f743331b.getOrCreateInstance(this, config);
            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config](this);
            }
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$enableDismissTrigger($e9dd36436aec3b21$export$8d8dc7d5f743331b);
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$8d8dc7d5f743331b);



var $8JYDX = parcelRequire("8JYDX");
var $125d88de280575d0$exports = {};
/*! choices.js v10.2.0 | © 2022 Josh Johnson | https://github.com/jshjohnson/Choices#readme */ (function webpackUniversalModuleDefinition(root, factory) {
    $125d88de280575d0$exports = factory();
})(window, function() {
    return /******/ function() {
        /******/ "use strict";
        /******/ var __webpack_modules__ = {
            /***/ 282: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.clearChoices = exports.activateChoices = exports.filterChoices = exports.addChoice = void 0;
                var constants_1 = __webpack_require__(883);
                var addChoice = function(_a) {
                    var value = _a.value, label = _a.label, id = _a.id, groupId = _a.groupId, disabled = _a.disabled, elementId = _a.elementId, customProperties = _a.customProperties, placeholder = _a.placeholder, keyCode = _a.keyCode;
                    return {
                        type: constants_1.ACTION_TYPES.ADD_CHOICE,
                        value: value,
                        label: label,
                        id: id,
                        groupId: groupId,
                        disabled: disabled,
                        elementId: elementId,
                        customProperties: customProperties,
                        placeholder: placeholder,
                        keyCode: keyCode
                    };
                };
                exports.addChoice = addChoice;
                var filterChoices = function(results) {
                    return {
                        type: constants_1.ACTION_TYPES.FILTER_CHOICES,
                        results: results
                    };
                };
                exports.filterChoices = filterChoices;
                var activateChoices = function(active) {
                    if (active === void 0) active = true;
                    return {
                        type: constants_1.ACTION_TYPES.ACTIVATE_CHOICES,
                        active: active
                    };
                };
                exports.activateChoices = activateChoices;
                var clearChoices = function() {
                    return {
                        type: constants_1.ACTION_TYPES.CLEAR_CHOICES
                    };
                };
                exports.clearChoices = clearChoices;
            /***/ },
            /***/ 783: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.addGroup = void 0;
                var constants_1 = __webpack_require__(883);
                var addGroup = function(_a) {
                    var value = _a.value, id = _a.id, active = _a.active, disabled = _a.disabled;
                    return {
                        type: constants_1.ACTION_TYPES.ADD_GROUP,
                        value: value,
                        id: id,
                        active: active,
                        disabled: disabled
                    };
                };
                exports.addGroup = addGroup;
            /***/ },
            /***/ 464: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.highlightItem = exports.removeItem = exports.addItem = void 0;
                var constants_1 = __webpack_require__(883);
                var addItem = function(_a) {
                    var value = _a.value, label = _a.label, id = _a.id, choiceId = _a.choiceId, groupId = _a.groupId, customProperties = _a.customProperties, placeholder = _a.placeholder, keyCode = _a.keyCode;
                    return {
                        type: constants_1.ACTION_TYPES.ADD_ITEM,
                        value: value,
                        label: label,
                        id: id,
                        choiceId: choiceId,
                        groupId: groupId,
                        customProperties: customProperties,
                        placeholder: placeholder,
                        keyCode: keyCode
                    };
                };
                exports.addItem = addItem;
                var removeItem = function(id, choiceId) {
                    return {
                        type: constants_1.ACTION_TYPES.REMOVE_ITEM,
                        id: id,
                        choiceId: choiceId
                    };
                };
                exports.removeItem = removeItem;
                var highlightItem = function(id, highlighted) {
                    return {
                        type: constants_1.ACTION_TYPES.HIGHLIGHT_ITEM,
                        id: id,
                        highlighted: highlighted
                    };
                };
                exports.highlightItem = highlightItem;
            /***/ },
            /***/ 137: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.setIsLoading = exports.resetTo = exports.clearAll = void 0;
                var constants_1 = __webpack_require__(883);
                var clearAll = function() {
                    return {
                        type: constants_1.ACTION_TYPES.CLEAR_ALL
                    };
                };
                exports.clearAll = clearAll;
                var resetTo = function(state) {
                    return {
                        type: constants_1.ACTION_TYPES.RESET_TO,
                        state: state
                    };
                };
                exports.resetTo = resetTo;
                var setIsLoading = function(isLoading) {
                    return {
                        type: constants_1.ACTION_TYPES.SET_IS_LOADING,
                        isLoading: isLoading
                    };
                };
                exports.setIsLoading = setIsLoading;
            /***/ },
            /***/ 373: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                    if (pack || arguments.length === 2) {
                        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                            ar[i] = from[i];
                        }
                    }
                    return to.concat(ar || Array.prototype.slice.call(from));
                };
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var deepmerge_1 = __importDefault(__webpack_require__(996));
                /* eslint-disable @typescript-eslint/no-explicit-any */ var fuse_js_1 = __importDefault(__webpack_require__(221));
                var choices_1 = __webpack_require__(282);
                var groups_1 = __webpack_require__(783);
                var items_1 = __webpack_require__(464);
                var misc_1 = __webpack_require__(137);
                var components_1 = __webpack_require__(520);
                var constants_1 = __webpack_require__(883);
                var defaults_1 = __webpack_require__(789);
                var utils_1 = __webpack_require__(799);
                var reducers_1 = __webpack_require__(655);
                var store_1 = __importDefault(__webpack_require__(744));
                var templates_1 = __importDefault(__webpack_require__(686));
                /** @see {@link http://browserhacks.com/#hack-acea075d0ac6954f275a70023906050c} */ var IS_IE11 = '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style;
                var USER_DEFAULTS = {};
                /**
 * Choices
 * @author Josh Johnson<josh@joshuajohnson.co.uk>
 */ var Choices = /** @class */ function() {
                    function Choices(element, userConfig) {
                        if (element === void 0) element = '[data-choice]';
                        if (userConfig === void 0) userConfig = {};
                        var _this = this;
                        if (userConfig.allowHTML === undefined) console.warn('Deprecation warning: allowHTML will default to false in a future release. To render HTML in Choices, you will need to set it to true. Setting allowHTML will suppress this message.');
                        this.config = deepmerge_1.default.all([
                            defaults_1.DEFAULT_CONFIG,
                            Choices.defaults.options,
                            userConfig
                        ], // When merging array configs, replace with a copy of the userConfig array,
                        // instead of concatenating with the default array
                        {
                            arrayMerge: function(_, sourceArray) {
                                return __spreadArray([], sourceArray, true);
                            }
                        });
                        var invalidConfigOptions = (0, utils_1.diff)(this.config, defaults_1.DEFAULT_CONFIG);
                        if (invalidConfigOptions.length) console.warn('Unknown config option(s) passed', invalidConfigOptions.join(', '));
                        var passedElement = typeof element === 'string' ? document.querySelector(element) : element;
                        if (!(passedElement instanceof HTMLInputElement || passedElement instanceof HTMLSelectElement)) throw TypeError('Expected one of the following types text|select-one|select-multiple');
                        this._isTextElement = passedElement.type === constants_1.TEXT_TYPE;
                        this._isSelectOneElement = passedElement.type === constants_1.SELECT_ONE_TYPE;
                        this._isSelectMultipleElement = passedElement.type === constants_1.SELECT_MULTIPLE_TYPE;
                        this._isSelectElement = this._isSelectOneElement || this._isSelectMultipleElement;
                        this.config.searchEnabled = this._isSelectMultipleElement || this.config.searchEnabled;
                        if (![
                            'auto',
                            'always'
                        ].includes("".concat(this.config.renderSelectedChoices))) this.config.renderSelectedChoices = 'auto';
                        if (userConfig.addItemFilter && typeof userConfig.addItemFilter !== 'function') {
                            var re = userConfig.addItemFilter instanceof RegExp ? userConfig.addItemFilter : new RegExp(userConfig.addItemFilter);
                            this.config.addItemFilter = re.test.bind(re);
                        }
                        if (this._isTextElement) this.passedElement = new components_1.WrappedInput({
                            element: passedElement,
                            classNames: this.config.classNames,
                            delimiter: this.config.delimiter
                        });
                        else this.passedElement = new components_1.WrappedSelect({
                            element: passedElement,
                            classNames: this.config.classNames,
                            template: function(data) {
                                return _this._templates.option(data);
                            }
                        });
                        this.initialised = false;
                        this._store = new store_1.default();
                        this._initialState = reducers_1.defaultState;
                        this._currentState = reducers_1.defaultState;
                        this._prevState = reducers_1.defaultState;
                        this._currentValue = '';
                        this._canSearch = !!this.config.searchEnabled;
                        this._isScrollingOnIe = false;
                        this._highlightPosition = 0;
                        this._wasTap = true;
                        this._placeholderValue = this._generatePlaceholderValue();
                        this._baseId = (0, utils_1.generateId)(this.passedElement.element, 'choices-');
                        /**
     * setting direction in cases where it's explicitly set on passedElement
     * or when calculated direction is different from the document
     */ this._direction = this.passedElement.dir;
                        if (!this._direction) {
                            var elementDirection = window.getComputedStyle(this.passedElement.element).direction;
                            var documentDirection = window.getComputedStyle(document.documentElement).direction;
                            if (elementDirection !== documentDirection) this._direction = elementDirection;
                        }
                        this._idNames = {
                            itemChoice: 'item-choice'
                        };
                        if (this._isSelectElement) {
                            // Assign preset groups from passed element
                            this._presetGroups = this.passedElement.optionGroups;
                            // Assign preset options from passed element
                            this._presetOptions = this.passedElement.options;
                        }
                        // Assign preset choices from passed object
                        this._presetChoices = this.config.choices;
                        // Assign preset items from passed object first
                        this._presetItems = this.config.items;
                        // Add any values passed from attribute
                        if (this.passedElement.value && this._isTextElement) {
                            var splitValues = this.passedElement.value.split(this.config.delimiter);
                            this._presetItems = this._presetItems.concat(splitValues);
                        }
                        // Create array of choices from option elements
                        if (this.passedElement.options) this.passedElement.options.forEach(function(option) {
                            _this._presetChoices.push({
                                value: option.value,
                                label: option.innerHTML,
                                selected: !!option.selected,
                                disabled: option.disabled || option.parentNode.disabled,
                                placeholder: option.value === '' || option.hasAttribute('placeholder'),
                                customProperties: (0, utils_1.parseCustomProperties)(option.dataset.customProperties)
                            });
                        });
                        this._render = this._render.bind(this);
                        this._onFocus = this._onFocus.bind(this);
                        this._onBlur = this._onBlur.bind(this);
                        this._onKeyUp = this._onKeyUp.bind(this);
                        this._onKeyDown = this._onKeyDown.bind(this);
                        this._onClick = this._onClick.bind(this);
                        this._onTouchMove = this._onTouchMove.bind(this);
                        this._onTouchEnd = this._onTouchEnd.bind(this);
                        this._onMouseDown = this._onMouseDown.bind(this);
                        this._onMouseOver = this._onMouseOver.bind(this);
                        this._onFormReset = this._onFormReset.bind(this);
                        this._onSelectKey = this._onSelectKey.bind(this);
                        this._onEnterKey = this._onEnterKey.bind(this);
                        this._onEscapeKey = this._onEscapeKey.bind(this);
                        this._onDirectionKey = this._onDirectionKey.bind(this);
                        this._onDeleteKey = this._onDeleteKey.bind(this);
                        // If element has already been initialised with Choices, fail silently
                        if (this.passedElement.isActive) {
                            if (!this.config.silent) console.warn('Trying to initialise Choices on element already initialised', {
                                element: element
                            });
                            this.initialised = true;
                            return;
                        }
                        // Let's go
                        this.init();
                    }
                    Object.defineProperty(Choices, "defaults", {
                        get: function() {
                            return Object.preventExtensions({
                                get options () {
                                    return USER_DEFAULTS;
                                },
                                get templates () {
                                    return templates_1.default;
                                }
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Choices.prototype.init = function() {
                        if (this.initialised) return;
                        this._createTemplates();
                        this._createElements();
                        this._createStructure();
                        this._store.subscribe(this._render);
                        this._render();
                        this._addEventListeners();
                        var shouldDisable = !this.config.addItems || this.passedElement.element.hasAttribute('disabled');
                        if (shouldDisable) this.disable();
                        this.initialised = true;
                        var callbackOnInit = this.config.callbackOnInit;
                        // Run callback if it is a function
                        if (callbackOnInit && typeof callbackOnInit === 'function') callbackOnInit.call(this);
                    };
                    Choices.prototype.destroy = function() {
                        if (!this.initialised) return;
                        this._removeEventListeners();
                        this.passedElement.reveal();
                        this.containerOuter.unwrap(this.passedElement.element);
                        this.clearStore();
                        if (this._isSelectElement) this.passedElement.options = this._presetOptions;
                        this._templates = templates_1.default;
                        this.initialised = false;
                    };
                    Choices.prototype.enable = function() {
                        if (this.passedElement.isDisabled) this.passedElement.enable();
                        if (this.containerOuter.isDisabled) {
                            this._addEventListeners();
                            this.input.enable();
                            this.containerOuter.enable();
                        }
                        return this;
                    };
                    Choices.prototype.disable = function() {
                        if (!this.passedElement.isDisabled) this.passedElement.disable();
                        if (!this.containerOuter.isDisabled) {
                            this._removeEventListeners();
                            this.input.disable();
                            this.containerOuter.disable();
                        }
                        return this;
                    };
                    Choices.prototype.highlightItem = function(item, runEvent) {
                        if (runEvent === void 0) runEvent = true;
                        if (!item || !item.id) return this;
                        var id = item.id, _a = item.groupId, groupId = _a === void 0 ? -1 : _a, _b = item.value, value = _b === void 0 ? '' : _b, _c = item.label, label = _c === void 0 ? '' : _c;
                        var group = groupId >= 0 ? this._store.getGroupById(groupId) : null;
                        this._store.dispatch((0, items_1.highlightItem)(id, true));
                        if (runEvent) this.passedElement.triggerEvent(constants_1.EVENTS.highlightItem, {
                            id: id,
                            value: value,
                            label: label,
                            groupValue: group && group.value ? group.value : null
                        });
                        return this;
                    };
                    Choices.prototype.unhighlightItem = function(item) {
                        if (!item || !item.id) return this;
                        var id = item.id, _a = item.groupId, groupId = _a === void 0 ? -1 : _a, _b = item.value, value = _b === void 0 ? '' : _b, _c = item.label, label = _c === void 0 ? '' : _c;
                        var group = groupId >= 0 ? this._store.getGroupById(groupId) : null;
                        this._store.dispatch((0, items_1.highlightItem)(id, false));
                        this.passedElement.triggerEvent(constants_1.EVENTS.highlightItem, {
                            id: id,
                            value: value,
                            label: label,
                            groupValue: group && group.value ? group.value : null
                        });
                        return this;
                    };
                    Choices.prototype.highlightAll = function() {
                        var _this = this;
                        this._store.items.forEach(function(item) {
                            return _this.highlightItem(item);
                        });
                        return this;
                    };
                    Choices.prototype.unhighlightAll = function() {
                        var _this = this;
                        this._store.items.forEach(function(item) {
                            return _this.unhighlightItem(item);
                        });
                        return this;
                    };
                    Choices.prototype.removeActiveItemsByValue = function(value) {
                        var _this = this;
                        this._store.activeItems.filter(function(item) {
                            return item.value === value;
                        }).forEach(function(item) {
                            return _this._removeItem(item);
                        });
                        return this;
                    };
                    Choices.prototype.removeActiveItems = function(excludedId) {
                        var _this = this;
                        this._store.activeItems.filter(function(_a) {
                            var id = _a.id;
                            return id !== excludedId;
                        }).forEach(function(item) {
                            return _this._removeItem(item);
                        });
                        return this;
                    };
                    Choices.prototype.removeHighlightedItems = function(runEvent) {
                        var _this = this;
                        if (runEvent === void 0) runEvent = false;
                        this._store.highlightedActiveItems.forEach(function(item) {
                            _this._removeItem(item);
                            // If this action was performed by the user
                            // trigger the event
                            if (runEvent) _this._triggerChange(item.value);
                        });
                        return this;
                    };
                    Choices.prototype.showDropdown = function(preventInputFocus) {
                        var _this = this;
                        if (this.dropdown.isActive) return this;
                        requestAnimationFrame(function() {
                            _this.dropdown.show();
                            _this.containerOuter.open(_this.dropdown.distanceFromTopWindow);
                            if (!preventInputFocus && _this._canSearch) _this.input.focus();
                            _this.passedElement.triggerEvent(constants_1.EVENTS.showDropdown, {});
                        });
                        return this;
                    };
                    Choices.prototype.hideDropdown = function(preventInputBlur) {
                        var _this = this;
                        if (!this.dropdown.isActive) return this;
                        requestAnimationFrame(function() {
                            _this.dropdown.hide();
                            _this.containerOuter.close();
                            if (!preventInputBlur && _this._canSearch) {
                                _this.input.removeActiveDescendant();
                                _this.input.blur();
                            }
                            _this.passedElement.triggerEvent(constants_1.EVENTS.hideDropdown, {});
                        });
                        return this;
                    };
                    Choices.prototype.getValue = function(valueOnly) {
                        if (valueOnly === void 0) valueOnly = false;
                        var values = this._store.activeItems.reduce(function(selectedItems, item) {
                            var itemValue = valueOnly ? item.value : item;
                            selectedItems.push(itemValue);
                            return selectedItems;
                        }, []);
                        return this._isSelectOneElement ? values[0] : values;
                    };
                    Choices.prototype.setValue = function(items) {
                        var _this = this;
                        if (!this.initialised) return this;
                        items.forEach(function(value) {
                            return _this._setChoiceOrItem(value);
                        });
                        return this;
                    };
                    Choices.prototype.setChoiceByValue = function(value) {
                        var _this = this;
                        if (!this.initialised || this._isTextElement) return this;
                        // If only one value has been passed, convert to array
                        var choiceValue = Array.isArray(value) ? value : [
                            value
                        ];
                        // Loop through each value and
                        choiceValue.forEach(function(val) {
                            return _this._findAndSelectChoiceByValue(val);
                        });
                        return this;
                    };
                    /**
   * Set choices of select input via an array of objects (or function that returns array of object or promise of it),
   * a value field name and a label field name.
   * This behaves the same as passing items via the choices option but can be called after initialising Choices.
   * This can also be used to add groups of choices (see example 2); Optionally pass a true `replaceChoices` value to remove any existing choices.
   * Optionally pass a `customProperties` object to add additional data to your choices (useful when searching/filtering etc).
   *
   * **Input types affected:** select-one, select-multiple
   *
   * @example
   * ```js
   * const example = new Choices(element);
   *
   * example.setChoices([
   *   {value: 'One', label: 'Label One', disabled: true},
   *   {value: 'Two', label: 'Label Two', selected: true},
   *   {value: 'Three', label: 'Label Three'},
   * ], 'value', 'label', false);
   * ```
   *
   * @example
   * ```js
   * const example = new Choices(element);
   *
   * example.setChoices(async () => {
   *   try {
   *      const items = await fetch('/items');
   *      return items.json()
   *   } catch(err) {
   *      console.error(err)
   *   }
   * });
   * ```
   *
   * @example
   * ```js
   * const example = new Choices(element);
   *
   * example.setChoices([{
   *   label: 'Group one',
   *   id: 1,
   *   disabled: false,
   *   choices: [
   *     {value: 'Child One', label: 'Child One', selected: true},
   *     {value: 'Child Two', label: 'Child Two',  disabled: true},
   *     {value: 'Child Three', label: 'Child Three'},
   *   ]
   * },
   * {
   *   label: 'Group two',
   *   id: 2,
   *   disabled: false,
   *   choices: [
   *     {value: 'Child Four', label: 'Child Four', disabled: true},
   *     {value: 'Child Five', label: 'Child Five'},
   *     {value: 'Child Six', label: 'Child Six', customProperties: {
   *       description: 'Custom description about child six',
   *       random: 'Another random custom property'
   *     }},
   *   ]
   * }], 'value', 'label', false);
   * ```
   */ Choices.prototype.setChoices = function(choicesArrayOrFetcher, value, label, replaceChoices) {
                        var _this = this;
                        if (choicesArrayOrFetcher === void 0) choicesArrayOrFetcher = [];
                        if (value === void 0) value = 'value';
                        if (label === void 0) label = 'label';
                        if (replaceChoices === void 0) replaceChoices = false;
                        if (!this.initialised) throw new ReferenceError("setChoices was called on a non-initialized instance of Choices");
                        if (!this._isSelectElement) throw new TypeError("setChoices can't be used with INPUT based Choices");
                        if (typeof value !== 'string' || !value) throw new TypeError("value parameter must be a name of 'value' field in passed objects");
                        // Clear choices if needed
                        if (replaceChoices) this.clearChoices();
                        if (typeof choicesArrayOrFetcher === 'function') {
                            // it's a choices fetcher function
                            var fetcher_1 = choicesArrayOrFetcher(this);
                            if (typeof Promise === 'function' && fetcher_1 instanceof Promise) // that's a promise
                            // eslint-disable-next-line no-promise-executor-return
                            return new Promise(function(resolve) {
                                return requestAnimationFrame(resolve);
                            }).then(function() {
                                return _this._handleLoadingState(true);
                            }).then(function() {
                                return fetcher_1;
                            }).then(function(data) {
                                return _this.setChoices(data, value, label, replaceChoices);
                            }).catch(function(err) {
                                if (!_this.config.silent) console.error(err);
                            }).then(function() {
                                return _this._handleLoadingState(false);
                            }).then(function() {
                                return _this;
                            });
                            // function returned something else than promise, let's check if it's an array of choices
                            if (!Array.isArray(fetcher_1)) throw new TypeError(".setChoices first argument function must return either array of choices or Promise, got: ".concat(typeof fetcher_1));
                            // recursion with results, it's sync and choices were cleared already
                            return this.setChoices(fetcher_1, value, label, false);
                        }
                        if (!Array.isArray(choicesArrayOrFetcher)) throw new TypeError(".setChoices must be called either with array of choices with a function resulting into Promise of array of choices");
                        this.containerOuter.removeLoadingState();
                        this._startLoading();
                        choicesArrayOrFetcher.forEach(function(groupOrChoice) {
                            if (groupOrChoice.choices) _this._addGroup({
                                id: groupOrChoice.id ? parseInt("".concat(groupOrChoice.id), 10) : null,
                                group: groupOrChoice,
                                valueKey: value,
                                labelKey: label
                            });
                            else {
                                var choice = groupOrChoice;
                                _this._addChoice({
                                    value: choice[value],
                                    label: choice[label],
                                    isSelected: !!choice.selected,
                                    isDisabled: !!choice.disabled,
                                    placeholder: !!choice.placeholder,
                                    customProperties: choice.customProperties
                                });
                            }
                        });
                        this._stopLoading();
                        return this;
                    };
                    Choices.prototype.clearChoices = function() {
                        this._store.dispatch((0, choices_1.clearChoices)());
                        return this;
                    };
                    Choices.prototype.clearStore = function() {
                        this._store.dispatch((0, misc_1.clearAll)());
                        return this;
                    };
                    Choices.prototype.clearInput = function() {
                        var shouldSetInputWidth = !this._isSelectOneElement;
                        this.input.clear(shouldSetInputWidth);
                        if (!this._isTextElement && this._canSearch) {
                            this._isSearching = false;
                            this._store.dispatch((0, choices_1.activateChoices)(true));
                        }
                        return this;
                    };
                    Choices.prototype._render = function() {
                        if (this._store.isLoading()) return;
                        this._currentState = this._store.state;
                        var stateChanged = this._currentState.choices !== this._prevState.choices || this._currentState.groups !== this._prevState.groups || this._currentState.items !== this._prevState.items;
                        var shouldRenderChoices = this._isSelectElement;
                        var shouldRenderItems = this._currentState.items !== this._prevState.items;
                        if (!stateChanged) return;
                        if (shouldRenderChoices) this._renderChoices();
                        if (shouldRenderItems) this._renderItems();
                        this._prevState = this._currentState;
                    };
                    Choices.prototype._renderChoices = function() {
                        var _this = this;
                        var _a = this._store, activeGroups = _a.activeGroups, activeChoices = _a.activeChoices;
                        var choiceListFragment = document.createDocumentFragment();
                        this.choiceList.clear();
                        if (this.config.resetScrollPosition) requestAnimationFrame(function() {
                            return _this.choiceList.scrollToTop();
                        });
                        // If we have grouped options
                        if (activeGroups.length >= 1 && !this._isSearching) {
                            // If we have a placeholder choice along with groups
                            var activePlaceholders = activeChoices.filter(function(activeChoice) {
                                return activeChoice.placeholder === true && activeChoice.groupId === -1;
                            });
                            if (activePlaceholders.length >= 1) choiceListFragment = this._createChoicesFragment(activePlaceholders, choiceListFragment);
                            choiceListFragment = this._createGroupsFragment(activeGroups, activeChoices, choiceListFragment);
                        } else if (activeChoices.length >= 1) choiceListFragment = this._createChoicesFragment(activeChoices, choiceListFragment);
                        // If we have choices to show
                        if (choiceListFragment.childNodes && choiceListFragment.childNodes.length > 0) {
                            var activeItems = this._store.activeItems;
                            var canAddItem = this._canAddItem(activeItems, this.input.value);
                            // ...and we can select them
                            if (canAddItem.response) {
                                // ...append them and highlight the first choice
                                this.choiceList.append(choiceListFragment);
                                this._highlightChoice();
                            } else {
                                var notice = this._getTemplate('notice', canAddItem.notice);
                                this.choiceList.append(notice);
                            }
                        } else {
                            // Otherwise show a notice
                            var dropdownItem = void 0;
                            var notice = void 0;
                            if (this._isSearching) {
                                notice = typeof this.config.noResultsText === 'function' ? this.config.noResultsText() : this.config.noResultsText;
                                dropdownItem = this._getTemplate('notice', notice, 'no-results');
                            } else {
                                notice = typeof this.config.noChoicesText === 'function' ? this.config.noChoicesText() : this.config.noChoicesText;
                                dropdownItem = this._getTemplate('notice', notice, 'no-choices');
                            }
                            this.choiceList.append(dropdownItem);
                        }
                    };
                    Choices.prototype._renderItems = function() {
                        var activeItems = this._store.activeItems || [];
                        this.itemList.clear();
                        // Create a fragment to store our list items
                        // (so we don't have to update the DOM for each item)
                        var itemListFragment = this._createItemsFragment(activeItems);
                        // If we have items to add, append them
                        if (itemListFragment.childNodes) this.itemList.append(itemListFragment);
                    };
                    Choices.prototype._createGroupsFragment = function(groups, choices, fragment) {
                        var _this = this;
                        if (fragment === void 0) fragment = document.createDocumentFragment();
                        var getGroupChoices = function(group) {
                            return choices.filter(function(choice) {
                                if (_this._isSelectOneElement) return choice.groupId === group.id;
                                return choice.groupId === group.id && (_this.config.renderSelectedChoices === 'always' || !choice.selected);
                            });
                        };
                        // If sorting is enabled, filter groups
                        if (this.config.shouldSort) groups.sort(this.config.sorter);
                        groups.forEach(function(group) {
                            var groupChoices = getGroupChoices(group);
                            if (groupChoices.length >= 1) {
                                var dropdownGroup = _this._getTemplate('choiceGroup', group);
                                fragment.appendChild(dropdownGroup);
                                _this._createChoicesFragment(groupChoices, fragment, true);
                            }
                        });
                        return fragment;
                    };
                    Choices.prototype._createChoicesFragment = function(choices, fragment, withinGroup) {
                        var _this = this;
                        if (fragment === void 0) fragment = document.createDocumentFragment();
                        if (withinGroup === void 0) withinGroup = false;
                        // Create a fragment to store our list items (so we don't have to update the DOM for each item)
                        var _a = this.config, renderSelectedChoices = _a.renderSelectedChoices, searchResultLimit = _a.searchResultLimit, renderChoiceLimit = _a.renderChoiceLimit;
                        var filter = this._isSearching ? utils_1.sortByScore : this.config.sorter;
                        var appendChoice = function(choice) {
                            var shouldRender = renderSelectedChoices === 'auto' ? _this._isSelectOneElement || !choice.selected : true;
                            if (shouldRender) {
                                var dropdownItem = _this._getTemplate('choice', choice, _this.config.itemSelectText);
                                fragment.appendChild(dropdownItem);
                            }
                        };
                        var rendererableChoices = choices;
                        if (renderSelectedChoices === 'auto' && !this._isSelectOneElement) rendererableChoices = choices.filter(function(choice) {
                            return !choice.selected;
                        });
                        // Split array into placeholders and "normal" choices
                        var _b = rendererableChoices.reduce(function(acc, choice) {
                            if (choice.placeholder) acc.placeholderChoices.push(choice);
                            else acc.normalChoices.push(choice);
                            return acc;
                        }, {
                            placeholderChoices: [],
                            normalChoices: []
                        }), placeholderChoices = _b.placeholderChoices, normalChoices = _b.normalChoices;
                        // If sorting is enabled or the user is searching, filter choices
                        if (this.config.shouldSort || this._isSearching) normalChoices.sort(filter);
                        var choiceLimit = rendererableChoices.length;
                        // Prepend placeholeder
                        var sortedChoices = this._isSelectOneElement ? __spreadArray(__spreadArray([], placeholderChoices, true), normalChoices, true) : normalChoices;
                        if (this._isSearching) choiceLimit = searchResultLimit;
                        else if (renderChoiceLimit && renderChoiceLimit > 0 && !withinGroup) choiceLimit = renderChoiceLimit;
                        // Add each choice to dropdown within range
                        for(var i = 0; i < choiceLimit; i += 1)if (sortedChoices[i]) appendChoice(sortedChoices[i]);
                        return fragment;
                    };
                    Choices.prototype._createItemsFragment = function(items, fragment) {
                        var _this = this;
                        if (fragment === void 0) fragment = document.createDocumentFragment();
                        // Create fragment to add elements to
                        var _a = this.config, shouldSortItems = _a.shouldSortItems, sorter = _a.sorter, removeItemButton = _a.removeItemButton;
                        // If sorting is enabled, filter items
                        if (shouldSortItems && !this._isSelectOneElement) items.sort(sorter);
                        if (this._isTextElement) // Update the value of the hidden input
                        this.passedElement.value = items.map(function(_a) {
                            var value = _a.value;
                            return value;
                        }).join(this.config.delimiter);
                        else // Update the options of the hidden input
                        this.passedElement.options = items;
                        var addItemToFragment = function(item) {
                            // Create new list element
                            var listItem = _this._getTemplate('item', item, removeItemButton);
                            // Append it to list
                            fragment.appendChild(listItem);
                        };
                        // Add each list item to list
                        items.forEach(addItemToFragment);
                        return fragment;
                    };
                    Choices.prototype._triggerChange = function(value) {
                        if (value === undefined || value === null) return;
                        this.passedElement.triggerEvent(constants_1.EVENTS.change, {
                            value: value
                        });
                    };
                    Choices.prototype._selectPlaceholderChoice = function(placeholderChoice) {
                        this._addItem({
                            value: placeholderChoice.value,
                            label: placeholderChoice.label,
                            choiceId: placeholderChoice.id,
                            groupId: placeholderChoice.groupId,
                            placeholder: placeholderChoice.placeholder
                        });
                        this._triggerChange(placeholderChoice.value);
                    };
                    Choices.prototype._handleButtonAction = function(activeItems, element) {
                        if (!activeItems || !element || !this.config.removeItems || !this.config.removeItemButton) return;
                        var itemId = element.parentNode && element.parentNode.dataset.id;
                        var itemToRemove = itemId && activeItems.find(function(item) {
                            return item.id === parseInt(itemId, 10);
                        });
                        if (!itemToRemove) return;
                        // Remove item associated with button
                        this._removeItem(itemToRemove);
                        this._triggerChange(itemToRemove.value);
                        if (this._isSelectOneElement && this._store.placeholderChoice) this._selectPlaceholderChoice(this._store.placeholderChoice);
                    };
                    Choices.prototype._handleItemAction = function(activeItems, element, hasShiftKey) {
                        var _this = this;
                        if (hasShiftKey === void 0) hasShiftKey = false;
                        if (!activeItems || !element || !this.config.removeItems || this._isSelectOneElement) return;
                        var passedId = element.dataset.id;
                        // We only want to select one item with a click
                        // so we deselect any items that aren't the target
                        // unless shift is being pressed
                        activeItems.forEach(function(item) {
                            if (item.id === parseInt("".concat(passedId), 10) && !item.highlighted) _this.highlightItem(item);
                            else if (!hasShiftKey && item.highlighted) _this.unhighlightItem(item);
                        });
                        // Focus input as without focus, a user cannot do anything with a
                        // highlighted item
                        this.input.focus();
                    };
                    Choices.prototype._handleChoiceAction = function(activeItems, element) {
                        if (!activeItems || !element) return;
                        // If we are clicking on an option
                        var id = element.dataset.id;
                        var choice = id && this._store.getChoiceById(id);
                        if (!choice) return;
                        var passedKeyCode = activeItems[0] && activeItems[0].keyCode ? activeItems[0].keyCode : undefined;
                        var hasActiveDropdown = this.dropdown.isActive;
                        // Update choice keyCode
                        choice.keyCode = passedKeyCode;
                        this.passedElement.triggerEvent(constants_1.EVENTS.choice, {
                            choice: choice
                        });
                        if (!choice.selected && !choice.disabled) {
                            var canAddItem = this._canAddItem(activeItems, choice.value);
                            if (canAddItem.response) {
                                this._addItem({
                                    value: choice.value,
                                    label: choice.label,
                                    choiceId: choice.id,
                                    groupId: choice.groupId,
                                    customProperties: choice.customProperties,
                                    placeholder: choice.placeholder,
                                    keyCode: choice.keyCode
                                });
                                this._triggerChange(choice.value);
                            }
                        }
                        this.clearInput();
                        // We want to close the dropdown if we are dealing with a single select box
                        if (hasActiveDropdown && this._isSelectOneElement) {
                            this.hideDropdown(true);
                            this.containerOuter.focus();
                        }
                    };
                    Choices.prototype._handleBackspace = function(activeItems) {
                        if (!this.config.removeItems || !activeItems) return;
                        var lastItem = activeItems[activeItems.length - 1];
                        var hasHighlightedItems = activeItems.some(function(item) {
                            return item.highlighted;
                        });
                        // If editing the last item is allowed and there are not other selected items,
                        // we can edit the item value. Otherwise if we can remove items, remove all selected items
                        if (this.config.editItems && !hasHighlightedItems && lastItem) {
                            this.input.value = lastItem.value;
                            this.input.setWidth();
                            this._removeItem(lastItem);
                            this._triggerChange(lastItem.value);
                        } else {
                            if (!hasHighlightedItems) // Highlight last item if none already highlighted
                            this.highlightItem(lastItem, false);
                            this.removeHighlightedItems(true);
                        }
                    };
                    Choices.prototype._startLoading = function() {
                        this._store.dispatch((0, misc_1.setIsLoading)(true));
                    };
                    Choices.prototype._stopLoading = function() {
                        this._store.dispatch((0, misc_1.setIsLoading)(false));
                    };
                    Choices.prototype._handleLoadingState = function(setLoading) {
                        if (setLoading === void 0) setLoading = true;
                        var placeholderItem = this.itemList.getChild(".".concat(this.config.classNames.placeholder));
                        if (setLoading) {
                            this.disable();
                            this.containerOuter.addLoadingState();
                            if (this._isSelectOneElement) {
                                if (!placeholderItem) {
                                    placeholderItem = this._getTemplate('placeholder', this.config.loadingText);
                                    if (placeholderItem) this.itemList.append(placeholderItem);
                                } else placeholderItem.innerHTML = this.config.loadingText;
                            } else this.input.placeholder = this.config.loadingText;
                        } else {
                            this.enable();
                            this.containerOuter.removeLoadingState();
                            if (this._isSelectOneElement) {
                                if (placeholderItem) placeholderItem.innerHTML = this._placeholderValue || '';
                            } else this.input.placeholder = this._placeholderValue || '';
                        }
                    };
                    Choices.prototype._handleSearch = function(value) {
                        if (!this.input.isFocussed) return;
                        var choices = this._store.choices;
                        var _a = this.config, searchFloor = _a.searchFloor, searchChoices = _a.searchChoices;
                        var hasUnactiveChoices = choices.some(function(option) {
                            return !option.active;
                        });
                        // Check that we have a value to search and the input was an alphanumeric character
                        if (value !== null && typeof value !== 'undefined' && value.length >= searchFloor) {
                            var resultCount = searchChoices ? this._searchChoices(value) : 0;
                            // Trigger search event
                            this.passedElement.triggerEvent(constants_1.EVENTS.search, {
                                value: value,
                                resultCount: resultCount
                            });
                        } else if (hasUnactiveChoices) {
                            // Otherwise reset choices to active
                            this._isSearching = false;
                            this._store.dispatch((0, choices_1.activateChoices)(true));
                        }
                    };
                    Choices.prototype._canAddItem = function(activeItems, value) {
                        var canAddItem = true;
                        var notice = typeof this.config.addItemText === 'function' ? this.config.addItemText(value) : this.config.addItemText;
                        if (!this._isSelectOneElement) {
                            var isDuplicateValue = (0, utils_1.existsInArray)(activeItems, value);
                            if (this.config.maxItemCount > 0 && this.config.maxItemCount <= activeItems.length) {
                                // If there is a max entry limit and we have reached that limit
                                // don't update
                                canAddItem = false;
                                notice = typeof this.config.maxItemText === 'function' ? this.config.maxItemText(this.config.maxItemCount) : this.config.maxItemText;
                            }
                            if (!this.config.duplicateItemsAllowed && isDuplicateValue && canAddItem) {
                                canAddItem = false;
                                notice = typeof this.config.uniqueItemText === 'function' ? this.config.uniqueItemText(value) : this.config.uniqueItemText;
                            }
                            if (this._isTextElement && this.config.addItems && canAddItem && typeof this.config.addItemFilter === 'function' && !this.config.addItemFilter(value)) {
                                canAddItem = false;
                                notice = typeof this.config.customAddItemText === 'function' ? this.config.customAddItemText(value) : this.config.customAddItemText;
                            }
                        }
                        return {
                            response: canAddItem,
                            notice: notice
                        };
                    };
                    Choices.prototype._searchChoices = function(value) {
                        var newValue = typeof value === 'string' ? value.trim() : value;
                        var currentValue = typeof this._currentValue === 'string' ? this._currentValue.trim() : this._currentValue;
                        if (newValue.length < 1 && newValue === "".concat(currentValue, " ")) return 0;
                        // If new value matches the desired length and is not the same as the current value with a space
                        var haystack = this._store.searchableChoices;
                        var needle = newValue;
                        var options = Object.assign(this.config.fuseOptions, {
                            keys: __spreadArray([], this.config.searchFields, true),
                            includeMatches: true
                        });
                        var fuse = new fuse_js_1.default(haystack, options);
                        var results = fuse.search(needle); // see https://github.com/krisk/Fuse/issues/303
                        this._currentValue = newValue;
                        this._highlightPosition = 0;
                        this._isSearching = true;
                        this._store.dispatch((0, choices_1.filterChoices)(results));
                        return results.length;
                    };
                    Choices.prototype._addEventListeners = function() {
                        var documentElement = document.documentElement;
                        // capture events - can cancel event processing or propagation
                        documentElement.addEventListener('touchend', this._onTouchEnd, true);
                        this.containerOuter.element.addEventListener('keydown', this._onKeyDown, true);
                        this.containerOuter.element.addEventListener('mousedown', this._onMouseDown, true);
                        // passive events - doesn't call `preventDefault` or `stopPropagation`
                        documentElement.addEventListener('click', this._onClick, {
                            passive: true
                        });
                        documentElement.addEventListener('touchmove', this._onTouchMove, {
                            passive: true
                        });
                        this.dropdown.element.addEventListener('mouseover', this._onMouseOver, {
                            passive: true
                        });
                        if (this._isSelectOneElement) {
                            this.containerOuter.element.addEventListener('focus', this._onFocus, {
                                passive: true
                            });
                            this.containerOuter.element.addEventListener('blur', this._onBlur, {
                                passive: true
                            });
                        }
                        this.input.element.addEventListener('keyup', this._onKeyUp, {
                            passive: true
                        });
                        this.input.element.addEventListener('focus', this._onFocus, {
                            passive: true
                        });
                        this.input.element.addEventListener('blur', this._onBlur, {
                            passive: true
                        });
                        if (this.input.element.form) this.input.element.form.addEventListener('reset', this._onFormReset, {
                            passive: true
                        });
                        this.input.addEventListeners();
                    };
                    Choices.prototype._removeEventListeners = function() {
                        var documentElement = document.documentElement;
                        documentElement.removeEventListener('touchend', this._onTouchEnd, true);
                        this.containerOuter.element.removeEventListener('keydown', this._onKeyDown, true);
                        this.containerOuter.element.removeEventListener('mousedown', this._onMouseDown, true);
                        documentElement.removeEventListener('click', this._onClick);
                        documentElement.removeEventListener('touchmove', this._onTouchMove);
                        this.dropdown.element.removeEventListener('mouseover', this._onMouseOver);
                        if (this._isSelectOneElement) {
                            this.containerOuter.element.removeEventListener('focus', this._onFocus);
                            this.containerOuter.element.removeEventListener('blur', this._onBlur);
                        }
                        this.input.element.removeEventListener('keyup', this._onKeyUp);
                        this.input.element.removeEventListener('focus', this._onFocus);
                        this.input.element.removeEventListener('blur', this._onBlur);
                        if (this.input.element.form) this.input.element.form.removeEventListener('reset', this._onFormReset);
                        this.input.removeEventListeners();
                    };
                    Choices.prototype._onKeyDown = function(event) {
                        var keyCode = event.keyCode;
                        var activeItems = this._store.activeItems;
                        var hasFocusedInput = this.input.isFocussed;
                        var hasActiveDropdown = this.dropdown.isActive;
                        var hasItems = this.itemList.hasChildren();
                        var keyString = String.fromCharCode(keyCode);
                        // eslint-disable-next-line no-control-regex
                        var wasPrintableChar = /[^\x00-\x1F]/.test(keyString);
                        var BACK_KEY = constants_1.KEY_CODES.BACK_KEY, DELETE_KEY = constants_1.KEY_CODES.DELETE_KEY, ENTER_KEY = constants_1.KEY_CODES.ENTER_KEY, A_KEY = constants_1.KEY_CODES.A_KEY, ESC_KEY = constants_1.KEY_CODES.ESC_KEY, UP_KEY = constants_1.KEY_CODES.UP_KEY, DOWN_KEY = constants_1.KEY_CODES.DOWN_KEY, PAGE_UP_KEY = constants_1.KEY_CODES.PAGE_UP_KEY, PAGE_DOWN_KEY = constants_1.KEY_CODES.PAGE_DOWN_KEY;
                        if (!this._isTextElement && !hasActiveDropdown && wasPrintableChar) {
                            this.showDropdown();
                            if (!this.input.isFocussed) /*
          We update the input value with the pressed key as
          the input was not focussed at the time of key press
          therefore does not have the value of the key.
        */ this.input.value += event.key.toLowerCase();
                        }
                        switch(keyCode){
                            case A_KEY:
                                return this._onSelectKey(event, hasItems);
                            case ENTER_KEY:
                                return this._onEnterKey(event, activeItems, hasActiveDropdown);
                            case ESC_KEY:
                                return this._onEscapeKey(hasActiveDropdown);
                            case UP_KEY:
                            case PAGE_UP_KEY:
                            case DOWN_KEY:
                            case PAGE_DOWN_KEY:
                                return this._onDirectionKey(event, hasActiveDropdown);
                            case DELETE_KEY:
                            case BACK_KEY:
                                return this._onDeleteKey(event, activeItems, hasFocusedInput);
                            default:
                        }
                    };
                    Choices.prototype._onKeyUp = function(_a) {
                        var target = _a.target, keyCode = _a.keyCode;
                        var value = this.input.value;
                        var activeItems = this._store.activeItems;
                        var canAddItem = this._canAddItem(activeItems, value);
                        var backKey = constants_1.KEY_CODES.BACK_KEY, deleteKey = constants_1.KEY_CODES.DELETE_KEY;
                        // We are typing into a text input and have a value, we want to show a dropdown
                        // notice. Otherwise hide the dropdown
                        if (this._isTextElement) {
                            var canShowDropdownNotice = canAddItem.notice && value;
                            if (canShowDropdownNotice) {
                                var dropdownItem = this._getTemplate('notice', canAddItem.notice);
                                this.dropdown.element.innerHTML = dropdownItem.outerHTML;
                                this.showDropdown(true);
                            } else this.hideDropdown(true);
                        } else {
                            var wasRemovalKeyCode = keyCode === backKey || keyCode === deleteKey;
                            var userHasRemovedValue = wasRemovalKeyCode && target && !target.value;
                            var canReactivateChoices = !this._isTextElement && this._isSearching;
                            var canSearch = this._canSearch && canAddItem.response;
                            if (userHasRemovedValue && canReactivateChoices) {
                                this._isSearching = false;
                                this._store.dispatch((0, choices_1.activateChoices)(true));
                            } else if (canSearch) this._handleSearch(this.input.rawValue);
                        }
                        this._canSearch = this.config.searchEnabled;
                    };
                    Choices.prototype._onSelectKey = function(event, hasItems) {
                        var ctrlKey = event.ctrlKey, metaKey = event.metaKey;
                        var hasCtrlDownKeyPressed = ctrlKey || metaKey;
                        // If CTRL + A or CMD + A have been pressed and there are items to select
                        if (hasCtrlDownKeyPressed && hasItems) {
                            this._canSearch = false;
                            var shouldHightlightAll = this.config.removeItems && !this.input.value && this.input.element === document.activeElement;
                            if (shouldHightlightAll) this.highlightAll();
                        }
                    };
                    Choices.prototype._onEnterKey = function(event, activeItems, hasActiveDropdown) {
                        var target = event.target;
                        var enterKey = constants_1.KEY_CODES.ENTER_KEY;
                        var targetWasButton = target && target.hasAttribute('data-button');
                        if (this._isTextElement && target && target.value) {
                            var value = this.input.value;
                            var canAddItem = this._canAddItem(activeItems, value);
                            if (canAddItem.response) {
                                this.hideDropdown(true);
                                this._addItem({
                                    value: value
                                });
                                this._triggerChange(value);
                                this.clearInput();
                            }
                        }
                        if (targetWasButton) {
                            this._handleButtonAction(activeItems, target);
                            event.preventDefault();
                        }
                        if (hasActiveDropdown) {
                            var highlightedChoice = this.dropdown.getChild(".".concat(this.config.classNames.highlightedState));
                            if (highlightedChoice) {
                                // add enter keyCode value
                                if (activeItems[0]) activeItems[0].keyCode = enterKey; // eslint-disable-line no-param-reassign
                                this._handleChoiceAction(activeItems, highlightedChoice);
                            }
                            event.preventDefault();
                        } else if (this._isSelectOneElement) {
                            this.showDropdown();
                            event.preventDefault();
                        }
                    };
                    Choices.prototype._onEscapeKey = function(hasActiveDropdown) {
                        if (hasActiveDropdown) {
                            this.hideDropdown(true);
                            this.containerOuter.focus();
                        }
                    };
                    Choices.prototype._onDirectionKey = function(event, hasActiveDropdown) {
                        var keyCode = event.keyCode, metaKey = event.metaKey;
                        var downKey = constants_1.KEY_CODES.DOWN_KEY, pageUpKey = constants_1.KEY_CODES.PAGE_UP_KEY, pageDownKey = constants_1.KEY_CODES.PAGE_DOWN_KEY;
                        // If up or down key is pressed, traverse through options
                        if (hasActiveDropdown || this._isSelectOneElement) {
                            this.showDropdown();
                            this._canSearch = false;
                            var directionInt = keyCode === downKey || keyCode === pageDownKey ? 1 : -1;
                            var skipKey = metaKey || keyCode === pageDownKey || keyCode === pageUpKey;
                            var selectableChoiceIdentifier = '[data-choice-selectable]';
                            var nextEl = void 0;
                            if (skipKey) {
                                if (directionInt > 0) nextEl = this.dropdown.element.querySelector("".concat(selectableChoiceIdentifier, ":last-of-type"));
                                else nextEl = this.dropdown.element.querySelector(selectableChoiceIdentifier);
                            } else {
                                var currentEl = this.dropdown.element.querySelector(".".concat(this.config.classNames.highlightedState));
                                if (currentEl) nextEl = (0, utils_1.getAdjacentEl)(currentEl, selectableChoiceIdentifier, directionInt);
                                else nextEl = this.dropdown.element.querySelector(selectableChoiceIdentifier);
                            }
                            if (nextEl) {
                                // We prevent default to stop the cursor moving
                                // when pressing the arrow
                                if (!(0, utils_1.isScrolledIntoView)(nextEl, this.choiceList.element, directionInt)) this.choiceList.scrollToChildElement(nextEl, directionInt);
                                this._highlightChoice(nextEl);
                            }
                            // Prevent default to maintain cursor position whilst
                            // traversing dropdown options
                            event.preventDefault();
                        }
                    };
                    Choices.prototype._onDeleteKey = function(event, activeItems, hasFocusedInput) {
                        var target = event.target;
                        // If backspace or delete key is pressed and the input has no value
                        if (!this._isSelectOneElement && !target.value && hasFocusedInput) {
                            this._handleBackspace(activeItems);
                            event.preventDefault();
                        }
                    };
                    Choices.prototype._onTouchMove = function() {
                        if (this._wasTap) this._wasTap = false;
                    };
                    Choices.prototype._onTouchEnd = function(event) {
                        var target = (event || event.touches[0]).target;
                        var touchWasWithinContainer = this._wasTap && this.containerOuter.element.contains(target);
                        if (touchWasWithinContainer) {
                            var containerWasExactTarget = target === this.containerOuter.element || target === this.containerInner.element;
                            if (containerWasExactTarget) {
                                if (this._isTextElement) this.input.focus();
                                else if (this._isSelectMultipleElement) this.showDropdown();
                            }
                            // Prevents focus event firing
                            event.stopPropagation();
                        }
                        this._wasTap = true;
                    };
                    /**
   * Handles mousedown event in capture mode for containetOuter.element
   */ Choices.prototype._onMouseDown = function(event) {
                        var target = event.target;
                        if (!(target instanceof HTMLElement)) return;
                        // If we have our mouse down on the scrollbar and are on IE11...
                        if (IS_IE11 && this.choiceList.element.contains(target)) {
                            // check if click was on a scrollbar area
                            var firstChoice = this.choiceList.element.firstElementChild;
                            var isOnScrollbar = this._direction === 'ltr' ? event.offsetX >= firstChoice.offsetWidth : event.offsetX < firstChoice.offsetLeft;
                            this._isScrollingOnIe = isOnScrollbar;
                        }
                        if (target === this.input.element) return;
                        var item = target.closest('[data-button],[data-item],[data-choice]');
                        if (item instanceof HTMLElement) {
                            var hasShiftKey = event.shiftKey;
                            var activeItems = this._store.activeItems;
                            var dataset = item.dataset;
                            if ('button' in dataset) this._handleButtonAction(activeItems, item);
                            else if ('item' in dataset) this._handleItemAction(activeItems, item, hasShiftKey);
                            else if ('choice' in dataset) this._handleChoiceAction(activeItems, item);
                        }
                        event.preventDefault();
                    };
                    /**
   * Handles mouseover event over this.dropdown
   * @param {MouseEvent} event
   */ Choices.prototype._onMouseOver = function(_a) {
                        var target = _a.target;
                        if (target instanceof HTMLElement && 'choice' in target.dataset) this._highlightChoice(target);
                    };
                    Choices.prototype._onClick = function(_a) {
                        var target = _a.target;
                        var clickWasWithinContainer = this.containerOuter.element.contains(target);
                        if (clickWasWithinContainer) {
                            if (!this.dropdown.isActive && !this.containerOuter.isDisabled) {
                                if (this._isTextElement) {
                                    if (document.activeElement !== this.input.element) this.input.focus();
                                } else {
                                    this.showDropdown();
                                    this.containerOuter.focus();
                                }
                            } else if (this._isSelectOneElement && target !== this.input.element && !this.dropdown.element.contains(target)) this.hideDropdown();
                        } else {
                            var hasHighlightedItems = this._store.highlightedActiveItems.length > 0;
                            if (hasHighlightedItems) this.unhighlightAll();
                            this.containerOuter.removeFocusState();
                            this.hideDropdown(true);
                        }
                    };
                    Choices.prototype._onFocus = function(_a) {
                        var _b;
                        var _this = this;
                        var target = _a.target;
                        var focusWasWithinContainer = target && this.containerOuter.element.contains(target);
                        if (!focusWasWithinContainer) return;
                        var focusActions = (_b = {}, _b[constants_1.TEXT_TYPE] = function() {
                            if (target === _this.input.element) _this.containerOuter.addFocusState();
                        }, _b[constants_1.SELECT_ONE_TYPE] = function() {
                            _this.containerOuter.addFocusState();
                            if (target === _this.input.element) _this.showDropdown(true);
                        }, _b[constants_1.SELECT_MULTIPLE_TYPE] = function() {
                            if (target === _this.input.element) {
                                _this.showDropdown(true);
                                // If element is a select box, the focused element is the container and the dropdown
                                // isn't already open, focus and show dropdown
                                _this.containerOuter.addFocusState();
                            }
                        }, _b);
                        focusActions[this.passedElement.element.type]();
                    };
                    Choices.prototype._onBlur = function(_a) {
                        var _b;
                        var _this = this;
                        var target = _a.target;
                        var blurWasWithinContainer = target && this.containerOuter.element.contains(target);
                        if (blurWasWithinContainer && !this._isScrollingOnIe) {
                            var activeItems = this._store.activeItems;
                            var hasHighlightedItems_1 = activeItems.some(function(item) {
                                return item.highlighted;
                            });
                            var blurActions = (_b = {}, _b[constants_1.TEXT_TYPE] = function() {
                                if (target === _this.input.element) {
                                    _this.containerOuter.removeFocusState();
                                    if (hasHighlightedItems_1) _this.unhighlightAll();
                                    _this.hideDropdown(true);
                                }
                            }, _b[constants_1.SELECT_ONE_TYPE] = function() {
                                _this.containerOuter.removeFocusState();
                                if (target === _this.input.element || target === _this.containerOuter.element && !_this._canSearch) _this.hideDropdown(true);
                            }, _b[constants_1.SELECT_MULTIPLE_TYPE] = function() {
                                if (target === _this.input.element) {
                                    _this.containerOuter.removeFocusState();
                                    _this.hideDropdown(true);
                                    if (hasHighlightedItems_1) _this.unhighlightAll();
                                }
                            }, _b);
                            blurActions[this.passedElement.element.type]();
                        } else {
                            // On IE11, clicking the scollbar blurs our input and thus
                            // closes the dropdown. To stop this, we refocus our input
                            // if we know we are on IE *and* are scrolling.
                            this._isScrollingOnIe = false;
                            this.input.element.focus();
                        }
                    };
                    Choices.prototype._onFormReset = function() {
                        this._store.dispatch((0, misc_1.resetTo)(this._initialState));
                    };
                    Choices.prototype._highlightChoice = function(el) {
                        var _this = this;
                        if (el === void 0) el = null;
                        var choices = Array.from(this.dropdown.element.querySelectorAll('[data-choice-selectable]'));
                        if (!choices.length) return;
                        var passedEl = el;
                        var highlightedChoices = Array.from(this.dropdown.element.querySelectorAll(".".concat(this.config.classNames.highlightedState)));
                        // Remove any highlighted choices
                        highlightedChoices.forEach(function(choice) {
                            choice.classList.remove(_this.config.classNames.highlightedState);
                            choice.setAttribute('aria-selected', 'false');
                        });
                        if (passedEl) this._highlightPosition = choices.indexOf(passedEl);
                        else {
                            // Highlight choice based on last known highlight location
                            if (choices.length > this._highlightPosition) // If we have an option to highlight
                            passedEl = choices[this._highlightPosition];
                            else // Otherwise highlight the option before
                            passedEl = choices[choices.length - 1];
                            if (!passedEl) passedEl = choices[0];
                        }
                        passedEl.classList.add(this.config.classNames.highlightedState);
                        passedEl.setAttribute('aria-selected', 'true');
                        this.passedElement.triggerEvent(constants_1.EVENTS.highlightChoice, {
                            el: passedEl
                        });
                        if (this.dropdown.isActive) {
                            // IE11 ignores aria-label and blocks virtual keyboard
                            // if aria-activedescendant is set without a dropdown
                            this.input.setActiveDescendant(passedEl.id);
                            this.containerOuter.setActiveDescendant(passedEl.id);
                        }
                    };
                    Choices.prototype._addItem = function(_a) {
                        var value = _a.value, _b = _a.label, label = _b === void 0 ? null : _b, _c = _a.choiceId, choiceId = _c === void 0 ? -1 : _c, _d = _a.groupId, groupId = _d === void 0 ? -1 : _d, _e = _a.customProperties, customProperties = _e === void 0 ? {} : _e, _f = _a.placeholder, placeholder = _f === void 0 ? false : _f, _g = _a.keyCode, keyCode = _g === void 0 ? -1 : _g;
                        var passedValue = typeof value === 'string' ? value.trim() : value;
                        var items = this._store.items;
                        var passedLabel = label || passedValue;
                        var passedOptionId = choiceId || -1;
                        var group = groupId >= 0 ? this._store.getGroupById(groupId) : null;
                        var id = items ? items.length + 1 : 1;
                        // If a prepended value has been passed, prepend it
                        if (this.config.prependValue) passedValue = this.config.prependValue + passedValue.toString();
                        // If an appended value has been passed, append it
                        if (this.config.appendValue) passedValue += this.config.appendValue.toString();
                        this._store.dispatch((0, items_1.addItem)({
                            value: passedValue,
                            label: passedLabel,
                            id: id,
                            choiceId: passedOptionId,
                            groupId: groupId,
                            customProperties: customProperties,
                            placeholder: placeholder,
                            keyCode: keyCode
                        }));
                        if (this._isSelectOneElement) this.removeActiveItems(id);
                        // Trigger change event
                        this.passedElement.triggerEvent(constants_1.EVENTS.addItem, {
                            id: id,
                            value: passedValue,
                            label: passedLabel,
                            customProperties: customProperties,
                            groupValue: group && group.value ? group.value : null,
                            keyCode: keyCode
                        });
                    };
                    Choices.prototype._removeItem = function(item) {
                        var id = item.id, value = item.value, label = item.label, customProperties = item.customProperties, choiceId = item.choiceId, groupId = item.groupId;
                        var group = groupId && groupId >= 0 ? this._store.getGroupById(groupId) : null;
                        if (!id || !choiceId) return;
                        this._store.dispatch((0, items_1.removeItem)(id, choiceId));
                        this.passedElement.triggerEvent(constants_1.EVENTS.removeItem, {
                            id: id,
                            value: value,
                            label: label,
                            customProperties: customProperties,
                            groupValue: group && group.value ? group.value : null
                        });
                    };
                    Choices.prototype._addChoice = function(_a) {
                        var value = _a.value, _b = _a.label, label = _b === void 0 ? null : _b, _c = _a.isSelected, isSelected = _c === void 0 ? false : _c, _d = _a.isDisabled, isDisabled = _d === void 0 ? false : _d, _e = _a.groupId, groupId = _e === void 0 ? -1 : _e, _f = _a.customProperties, customProperties = _f === void 0 ? {} : _f, _g = _a.placeholder, placeholder = _g === void 0 ? false : _g, _h = _a.keyCode, keyCode = _h === void 0 ? -1 : _h;
                        if (typeof value === 'undefined' || value === null) return;
                        // Generate unique id
                        var choices = this._store.choices;
                        var choiceLabel = label || value;
                        var choiceId = choices ? choices.length + 1 : 1;
                        var choiceElementId = "".concat(this._baseId, "-").concat(this._idNames.itemChoice, "-").concat(choiceId);
                        this._store.dispatch((0, choices_1.addChoice)({
                            id: choiceId,
                            groupId: groupId,
                            elementId: choiceElementId,
                            value: value,
                            label: choiceLabel,
                            disabled: isDisabled,
                            customProperties: customProperties,
                            placeholder: placeholder,
                            keyCode: keyCode
                        }));
                        if (isSelected) this._addItem({
                            value: value,
                            label: choiceLabel,
                            choiceId: choiceId,
                            customProperties: customProperties,
                            placeholder: placeholder,
                            keyCode: keyCode
                        });
                    };
                    Choices.prototype._addGroup = function(_a) {
                        var _this = this;
                        var group = _a.group, id = _a.id, _b = _a.valueKey, valueKey = _b === void 0 ? 'value' : _b, _c = _a.labelKey, labelKey = _c === void 0 ? 'label' : _c;
                        var groupChoices = (0, utils_1.isType)('Object', group) ? group.choices : Array.from(group.getElementsByTagName('OPTION'));
                        var groupId = id || Math.floor(new Date().valueOf() * Math.random());
                        var isDisabled = group.disabled ? group.disabled : false;
                        if (groupChoices) {
                            this._store.dispatch((0, groups_1.addGroup)({
                                value: group.label,
                                id: groupId,
                                active: true,
                                disabled: isDisabled
                            }));
                            var addGroupChoices = function(choice) {
                                var isOptDisabled = choice.disabled || choice.parentNode && choice.parentNode.disabled;
                                _this._addChoice({
                                    value: choice[valueKey],
                                    label: (0, utils_1.isType)('Object', choice) ? choice[labelKey] : choice.innerHTML,
                                    isSelected: choice.selected,
                                    isDisabled: isOptDisabled,
                                    groupId: groupId,
                                    customProperties: choice.customProperties,
                                    placeholder: choice.placeholder
                                });
                            };
                            groupChoices.forEach(addGroupChoices);
                        } else this._store.dispatch((0, groups_1.addGroup)({
                            value: group.label,
                            id: group.id,
                            active: false,
                            disabled: group.disabled
                        }));
                    };
                    Choices.prototype._getTemplate = function(template) {
                        var _a;
                        var args = [];
                        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
                        return (_a = this._templates[template]).call.apply(_a, __spreadArray([
                            this,
                            this.config
                        ], args, false));
                    };
                    Choices.prototype._createTemplates = function() {
                        var callbackOnCreateTemplates = this.config.callbackOnCreateTemplates;
                        var userTemplates = {};
                        if (callbackOnCreateTemplates && typeof callbackOnCreateTemplates === 'function') userTemplates = callbackOnCreateTemplates.call(this, utils_1.strToEl);
                        this._templates = (0, deepmerge_1.default)(templates_1.default, userTemplates);
                    };
                    Choices.prototype._createElements = function() {
                        this.containerOuter = new components_1.Container({
                            element: this._getTemplate('containerOuter', this._direction, this._isSelectElement, this._isSelectOneElement, this.config.searchEnabled, this.passedElement.element.type, this.config.labelId),
                            classNames: this.config.classNames,
                            type: this.passedElement.element.type,
                            position: this.config.position
                        });
                        this.containerInner = new components_1.Container({
                            element: this._getTemplate('containerInner'),
                            classNames: this.config.classNames,
                            type: this.passedElement.element.type,
                            position: this.config.position
                        });
                        this.input = new components_1.Input({
                            element: this._getTemplate('input', this._placeholderValue),
                            classNames: this.config.classNames,
                            type: this.passedElement.element.type,
                            preventPaste: !this.config.paste
                        });
                        this.choiceList = new components_1.List({
                            element: this._getTemplate('choiceList', this._isSelectOneElement)
                        });
                        this.itemList = new components_1.List({
                            element: this._getTemplate('itemList', this._isSelectOneElement)
                        });
                        this.dropdown = new components_1.Dropdown({
                            element: this._getTemplate('dropdown'),
                            classNames: this.config.classNames,
                            type: this.passedElement.element.type
                        });
                    };
                    Choices.prototype._createStructure = function() {
                        // Hide original element
                        this.passedElement.conceal();
                        // Wrap input in container preserving DOM ordering
                        this.containerInner.wrap(this.passedElement.element);
                        // Wrapper inner container with outer container
                        this.containerOuter.wrap(this.containerInner.element);
                        if (this._isSelectOneElement) this.input.placeholder = this.config.searchPlaceholderValue || '';
                        else if (this._placeholderValue) {
                            this.input.placeholder = this._placeholderValue;
                            this.input.setWidth();
                        }
                        this.containerOuter.element.appendChild(this.containerInner.element);
                        this.containerOuter.element.appendChild(this.dropdown.element);
                        this.containerInner.element.appendChild(this.itemList.element);
                        if (!this._isTextElement) this.dropdown.element.appendChild(this.choiceList.element);
                        if (!this._isSelectOneElement) this.containerInner.element.appendChild(this.input.element);
                        else if (this.config.searchEnabled) this.dropdown.element.insertBefore(this.input.element, this.dropdown.element.firstChild);
                        if (this._isSelectElement) {
                            this._highlightPosition = 0;
                            this._isSearching = false;
                            this._startLoading();
                            if (this._presetGroups.length) this._addPredefinedGroups(this._presetGroups);
                            else this._addPredefinedChoices(this._presetChoices);
                            this._stopLoading();
                        }
                        if (this._isTextElement) this._addPredefinedItems(this._presetItems);
                    };
                    Choices.prototype._addPredefinedGroups = function(groups) {
                        var _this = this;
                        // If we have a placeholder option
                        var placeholderChoice = this.passedElement.placeholderOption;
                        if (placeholderChoice && placeholderChoice.parentNode && placeholderChoice.parentNode.tagName === 'SELECT') this._addChoice({
                            value: placeholderChoice.value,
                            label: placeholderChoice.innerHTML,
                            isSelected: placeholderChoice.selected,
                            isDisabled: placeholderChoice.disabled,
                            placeholder: true
                        });
                        groups.forEach(function(group) {
                            return _this._addGroup({
                                group: group,
                                id: group.id || null
                            });
                        });
                    };
                    Choices.prototype._addPredefinedChoices = function(choices) {
                        var _this = this;
                        // If sorting is enabled or the user is searching, filter choices
                        if (this.config.shouldSort) choices.sort(this.config.sorter);
                        var hasSelectedChoice = choices.some(function(choice) {
                            return choice.selected;
                        });
                        var firstEnabledChoiceIndex = choices.findIndex(function(choice) {
                            return choice.disabled === undefined || !choice.disabled;
                        });
                        choices.forEach(function(choice, index) {
                            var _a = choice.value, value = _a === void 0 ? '' : _a, label = choice.label, customProperties = choice.customProperties, placeholder = choice.placeholder;
                            if (_this._isSelectElement) {
                                // If the choice is actually a group
                                if (choice.choices) _this._addGroup({
                                    group: choice,
                                    id: choice.id || null
                                });
                                else {
                                    /**
           * If there is a selected choice already or the choice is not the first in
           * the array, add each choice normally.
           *
           * Otherwise we pre-select the first enabled choice in the array ("select-one" only)
           */ var shouldPreselect = _this._isSelectOneElement && !hasSelectedChoice && index === firstEnabledChoiceIndex;
                                    var isSelected = shouldPreselect ? true : choice.selected;
                                    var isDisabled = choice.disabled;
                                    _this._addChoice({
                                        value: value,
                                        label: label,
                                        isSelected: !!isSelected,
                                        isDisabled: !!isDisabled,
                                        placeholder: !!placeholder,
                                        customProperties: customProperties
                                    });
                                }
                            } else _this._addChoice({
                                value: value,
                                label: label,
                                isSelected: !!choice.selected,
                                isDisabled: !!choice.disabled,
                                placeholder: !!choice.placeholder,
                                customProperties: customProperties
                            });
                        });
                    };
                    Choices.prototype._addPredefinedItems = function(items) {
                        var _this = this;
                        items.forEach(function(item) {
                            if (typeof item === 'object' && item.value) _this._addItem({
                                value: item.value,
                                label: item.label,
                                choiceId: item.id,
                                customProperties: item.customProperties,
                                placeholder: item.placeholder
                            });
                            if (typeof item === 'string') _this._addItem({
                                value: item
                            });
                        });
                    };
                    Choices.prototype._setChoiceOrItem = function(item) {
                        var _this = this;
                        var itemType = (0, utils_1.getType)(item).toLowerCase();
                        var handleType = {
                            object: function() {
                                if (!item.value) return;
                                // If we are dealing with a select input, we need to create an option first
                                // that is then selected. For text inputs we can just add items normally.
                                if (!_this._isTextElement) _this._addChoice({
                                    value: item.value,
                                    label: item.label,
                                    isSelected: true,
                                    isDisabled: false,
                                    customProperties: item.customProperties,
                                    placeholder: item.placeholder
                                });
                                else _this._addItem({
                                    value: item.value,
                                    label: item.label,
                                    choiceId: item.id,
                                    customProperties: item.customProperties,
                                    placeholder: item.placeholder
                                });
                            },
                            string: function() {
                                if (!_this._isTextElement) _this._addChoice({
                                    value: item,
                                    label: item,
                                    isSelected: true,
                                    isDisabled: false
                                });
                                else _this._addItem({
                                    value: item
                                });
                            }
                        };
                        handleType[itemType]();
                    };
                    Choices.prototype._findAndSelectChoiceByValue = function(value) {
                        var _this = this;
                        var choices = this._store.choices;
                        // Check 'value' property exists and the choice isn't already selected
                        var foundChoice = choices.find(function(choice) {
                            return _this.config.valueComparer(choice.value, value);
                        });
                        if (foundChoice && !foundChoice.selected) this._addItem({
                            value: foundChoice.value,
                            label: foundChoice.label,
                            choiceId: foundChoice.id,
                            groupId: foundChoice.groupId,
                            customProperties: foundChoice.customProperties,
                            placeholder: foundChoice.placeholder,
                            keyCode: foundChoice.keyCode
                        });
                    };
                    Choices.prototype._generatePlaceholderValue = function() {
                        if (this._isSelectElement && this.passedElement.placeholderOption) {
                            var placeholderOption = this.passedElement.placeholderOption;
                            return placeholderOption ? placeholderOption.text : null;
                        }
                        var _a = this.config, placeholder = _a.placeholder, placeholderValue = _a.placeholderValue;
                        var dataset = this.passedElement.element.dataset;
                        if (placeholder) {
                            if (placeholderValue) return placeholderValue;
                            if (dataset.placeholder) return dataset.placeholder;
                        }
                        return null;
                    };
                    return Choices;
                }();
                exports["default"] = Choices;
            /***/ },
            /***/ 613: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var utils_1 = __webpack_require__(799);
                var constants_1 = __webpack_require__(883);
                var Container = /** @class */ function() {
                    function Container(_a) {
                        var element = _a.element, type = _a.type, classNames = _a.classNames, position = _a.position;
                        this.element = element;
                        this.classNames = classNames;
                        this.type = type;
                        this.position = position;
                        this.isOpen = false;
                        this.isFlipped = false;
                        this.isFocussed = false;
                        this.isDisabled = false;
                        this.isLoading = false;
                        this._onFocus = this._onFocus.bind(this);
                        this._onBlur = this._onBlur.bind(this);
                    }
                    Container.prototype.addEventListeners = function() {
                        this.element.addEventListener('focus', this._onFocus);
                        this.element.addEventListener('blur', this._onBlur);
                    };
                    Container.prototype.removeEventListeners = function() {
                        this.element.removeEventListener('focus', this._onFocus);
                        this.element.removeEventListener('blur', this._onBlur);
                    };
                    /**
   * Determine whether container should be flipped based on passed
   * dropdown position
   */ Container.prototype.shouldFlip = function(dropdownPos) {
                        if (typeof dropdownPos !== 'number') return false;
                        // If flip is enabled and the dropdown bottom position is
                        // greater than the window height flip the dropdown.
                        var shouldFlip = false;
                        if (this.position === 'auto') shouldFlip = !window.matchMedia("(min-height: ".concat(dropdownPos + 1, "px)")).matches;
                        else if (this.position === 'top') shouldFlip = true;
                        return shouldFlip;
                    };
                    Container.prototype.setActiveDescendant = function(activeDescendantID) {
                        this.element.setAttribute('aria-activedescendant', activeDescendantID);
                    };
                    Container.prototype.removeActiveDescendant = function() {
                        this.element.removeAttribute('aria-activedescendant');
                    };
                    Container.prototype.open = function(dropdownPos) {
                        this.element.classList.add(this.classNames.openState);
                        this.element.setAttribute('aria-expanded', 'true');
                        this.isOpen = true;
                        if (this.shouldFlip(dropdownPos)) {
                            this.element.classList.add(this.classNames.flippedState);
                            this.isFlipped = true;
                        }
                    };
                    Container.prototype.close = function() {
                        this.element.classList.remove(this.classNames.openState);
                        this.element.setAttribute('aria-expanded', 'false');
                        this.removeActiveDescendant();
                        this.isOpen = false;
                        // A dropdown flips if it does not have space within the page
                        if (this.isFlipped) {
                            this.element.classList.remove(this.classNames.flippedState);
                            this.isFlipped = false;
                        }
                    };
                    Container.prototype.focus = function() {
                        if (!this.isFocussed) this.element.focus();
                    };
                    Container.prototype.addFocusState = function() {
                        this.element.classList.add(this.classNames.focusState);
                    };
                    Container.prototype.removeFocusState = function() {
                        this.element.classList.remove(this.classNames.focusState);
                    };
                    Container.prototype.enable = function() {
                        this.element.classList.remove(this.classNames.disabledState);
                        this.element.removeAttribute('aria-disabled');
                        if (this.type === constants_1.SELECT_ONE_TYPE) this.element.setAttribute('tabindex', '0');
                        this.isDisabled = false;
                    };
                    Container.prototype.disable = function() {
                        this.element.classList.add(this.classNames.disabledState);
                        this.element.setAttribute('aria-disabled', 'true');
                        if (this.type === constants_1.SELECT_ONE_TYPE) this.element.setAttribute('tabindex', '-1');
                        this.isDisabled = true;
                    };
                    Container.prototype.wrap = function(element) {
                        (0, utils_1.wrap)(element, this.element);
                    };
                    Container.prototype.unwrap = function(element) {
                        if (this.element.parentNode) {
                            // Move passed element outside this element
                            this.element.parentNode.insertBefore(element, this.element);
                            // Remove this element
                            this.element.parentNode.removeChild(this.element);
                        }
                    };
                    Container.prototype.addLoadingState = function() {
                        this.element.classList.add(this.classNames.loadingState);
                        this.element.setAttribute('aria-busy', 'true');
                        this.isLoading = true;
                    };
                    Container.prototype.removeLoadingState = function() {
                        this.element.classList.remove(this.classNames.loadingState);
                        this.element.removeAttribute('aria-busy');
                        this.isLoading = false;
                    };
                    Container.prototype._onFocus = function() {
                        this.isFocussed = true;
                    };
                    Container.prototype._onBlur = function() {
                        this.isFocussed = false;
                    };
                    return Container;
                }();
                exports["default"] = Container;
            /***/ },
            /***/ 217: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var Dropdown = /** @class */ function() {
                    function Dropdown(_a) {
                        var element = _a.element, type = _a.type, classNames = _a.classNames;
                        this.element = element;
                        this.classNames = classNames;
                        this.type = type;
                        this.isActive = false;
                    }
                    Object.defineProperty(Dropdown.prototype, "distanceFromTopWindow", {
                        /**
     * Bottom position of dropdown in viewport coordinates
     */ get: function() {
                            return this.element.getBoundingClientRect().bottom;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Dropdown.prototype.getChild = function(selector) {
                        return this.element.querySelector(selector);
                    };
                    /**
   * Show dropdown to user by adding active state class
   */ Dropdown.prototype.show = function() {
                        this.element.classList.add(this.classNames.activeState);
                        this.element.setAttribute('aria-expanded', 'true');
                        this.isActive = true;
                        return this;
                    };
                    /**
   * Hide dropdown from user
   */ Dropdown.prototype.hide = function() {
                        this.element.classList.remove(this.classNames.activeState);
                        this.element.setAttribute('aria-expanded', 'false');
                        this.isActive = false;
                        return this;
                    };
                    return Dropdown;
                }();
                exports["default"] = Dropdown;
            /***/ },
            /***/ 520: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.WrappedSelect = exports.WrappedInput = exports.List = exports.Input = exports.Container = exports.Dropdown = void 0;
                var dropdown_1 = __importDefault(__webpack_require__(217));
                exports.Dropdown = dropdown_1.default;
                var container_1 = __importDefault(__webpack_require__(613));
                exports.Container = container_1.default;
                var input_1 = __importDefault(__webpack_require__(11));
                exports.Input = input_1.default;
                var list_1 = __importDefault(__webpack_require__(624));
                exports.List = list_1.default;
                var wrapped_input_1 = __importDefault(__webpack_require__(541));
                exports.WrappedInput = wrapped_input_1.default;
                var wrapped_select_1 = __importDefault(__webpack_require__(982));
                exports.WrappedSelect = wrapped_select_1.default;
            /***/ },
            /***/ 11: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var utils_1 = __webpack_require__(799);
                var constants_1 = __webpack_require__(883);
                var Input = /** @class */ function() {
                    function Input(_a) {
                        var element = _a.element, type = _a.type, classNames = _a.classNames, preventPaste = _a.preventPaste;
                        this.element = element;
                        this.type = type;
                        this.classNames = classNames;
                        this.preventPaste = preventPaste;
                        this.isFocussed = this.element.isEqualNode(document.activeElement);
                        this.isDisabled = element.disabled;
                        this._onPaste = this._onPaste.bind(this);
                        this._onInput = this._onInput.bind(this);
                        this._onFocus = this._onFocus.bind(this);
                        this._onBlur = this._onBlur.bind(this);
                    }
                    Object.defineProperty(Input.prototype, "placeholder", {
                        set: function(placeholder) {
                            this.element.placeholder = placeholder;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Input.prototype, "value", {
                        get: function() {
                            return (0, utils_1.sanitise)(this.element.value);
                        },
                        set: function(value) {
                            this.element.value = value;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Input.prototype, "rawValue", {
                        get: function() {
                            return this.element.value;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Input.prototype.addEventListeners = function() {
                        this.element.addEventListener('paste', this._onPaste);
                        this.element.addEventListener('input', this._onInput, {
                            passive: true
                        });
                        this.element.addEventListener('focus', this._onFocus, {
                            passive: true
                        });
                        this.element.addEventListener('blur', this._onBlur, {
                            passive: true
                        });
                    };
                    Input.prototype.removeEventListeners = function() {
                        this.element.removeEventListener('input', this._onInput);
                        this.element.removeEventListener('paste', this._onPaste);
                        this.element.removeEventListener('focus', this._onFocus);
                        this.element.removeEventListener('blur', this._onBlur);
                    };
                    Input.prototype.enable = function() {
                        this.element.removeAttribute('disabled');
                        this.isDisabled = false;
                    };
                    Input.prototype.disable = function() {
                        this.element.setAttribute('disabled', '');
                        this.isDisabled = true;
                    };
                    Input.prototype.focus = function() {
                        if (!this.isFocussed) this.element.focus();
                    };
                    Input.prototype.blur = function() {
                        if (this.isFocussed) this.element.blur();
                    };
                    Input.prototype.clear = function(setWidth) {
                        if (setWidth === void 0) setWidth = true;
                        if (this.element.value) this.element.value = '';
                        if (setWidth) this.setWidth();
                        return this;
                    };
                    /**
   * Set the correct input width based on placeholder
   * value or input value
   */ Input.prototype.setWidth = function() {
                        // Resize input to contents or placeholder
                        var _a = this.element, style = _a.style, value = _a.value, placeholder = _a.placeholder;
                        style.minWidth = "".concat(placeholder.length + 1, "ch");
                        style.width = "".concat(value.length + 1, "ch");
                    };
                    Input.prototype.setActiveDescendant = function(activeDescendantID) {
                        this.element.setAttribute('aria-activedescendant', activeDescendantID);
                    };
                    Input.prototype.removeActiveDescendant = function() {
                        this.element.removeAttribute('aria-activedescendant');
                    };
                    Input.prototype._onInput = function() {
                        if (this.type !== constants_1.SELECT_ONE_TYPE) this.setWidth();
                    };
                    Input.prototype._onPaste = function(event) {
                        if (this.preventPaste) event.preventDefault();
                    };
                    Input.prototype._onFocus = function() {
                        this.isFocussed = true;
                    };
                    Input.prototype._onBlur = function() {
                        this.isFocussed = false;
                    };
                    return Input;
                }();
                exports["default"] = Input;
            /***/ },
            /***/ 624: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var constants_1 = __webpack_require__(883);
                var List = /** @class */ function() {
                    function List(_a) {
                        var element = _a.element;
                        this.element = element;
                        this.scrollPos = this.element.scrollTop;
                        this.height = this.element.offsetHeight;
                    }
                    List.prototype.clear = function() {
                        this.element.innerHTML = '';
                    };
                    List.prototype.append = function(node) {
                        this.element.appendChild(node);
                    };
                    List.prototype.getChild = function(selector) {
                        return this.element.querySelector(selector);
                    };
                    List.prototype.hasChildren = function() {
                        return this.element.hasChildNodes();
                    };
                    List.prototype.scrollToTop = function() {
                        this.element.scrollTop = 0;
                    };
                    List.prototype.scrollToChildElement = function(element, direction) {
                        var _this = this;
                        if (!element) return;
                        var listHeight = this.element.offsetHeight;
                        // Scroll position of dropdown
                        var listScrollPosition = this.element.scrollTop + listHeight;
                        var elementHeight = element.offsetHeight;
                        // Distance from bottom of element to top of parent
                        var elementPos = element.offsetTop + elementHeight;
                        // Difference between the element and scroll position
                        var destination = direction > 0 ? this.element.scrollTop + elementPos - listScrollPosition : element.offsetTop;
                        requestAnimationFrame(function() {
                            _this._animateScroll(destination, direction);
                        });
                    };
                    List.prototype._scrollDown = function(scrollPos, strength, destination) {
                        var easing = (destination - scrollPos) / strength;
                        var distance = easing > 1 ? easing : 1;
                        this.element.scrollTop = scrollPos + distance;
                    };
                    List.prototype._scrollUp = function(scrollPos, strength, destination) {
                        var easing = (scrollPos - destination) / strength;
                        var distance = easing > 1 ? easing : 1;
                        this.element.scrollTop = scrollPos - distance;
                    };
                    List.prototype._animateScroll = function(destination, direction) {
                        var _this = this;
                        var strength = constants_1.SCROLLING_SPEED;
                        var choiceListScrollTop = this.element.scrollTop;
                        var continueAnimation = false;
                        if (direction > 0) {
                            this._scrollDown(choiceListScrollTop, strength, destination);
                            if (choiceListScrollTop < destination) continueAnimation = true;
                        } else {
                            this._scrollUp(choiceListScrollTop, strength, destination);
                            if (choiceListScrollTop > destination) continueAnimation = true;
                        }
                        if (continueAnimation) requestAnimationFrame(function() {
                            _this._animateScroll(destination, direction);
                        });
                    };
                    return List;
                }();
                exports["default"] = List;
            /***/ },
            /***/ 730: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var utils_1 = __webpack_require__(799);
                var WrappedElement = /** @class */ function() {
                    function WrappedElement(_a) {
                        var element = _a.element, classNames = _a.classNames;
                        this.element = element;
                        this.classNames = classNames;
                        if (!(element instanceof HTMLInputElement) && !(element instanceof HTMLSelectElement)) throw new TypeError('Invalid element passed');
                        this.isDisabled = false;
                    }
                    Object.defineProperty(WrappedElement.prototype, "isActive", {
                        get: function() {
                            return this.element.dataset.choice === 'active';
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(WrappedElement.prototype, "dir", {
                        get: function() {
                            return this.element.dir;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(WrappedElement.prototype, "value", {
                        get: function() {
                            return this.element.value;
                        },
                        set: function(value) {
                            // you must define setter here otherwise it will be readonly property
                            this.element.value = value;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    WrappedElement.prototype.conceal = function() {
                        // Hide passed input
                        this.element.classList.add(this.classNames.input);
                        this.element.hidden = true;
                        // Remove element from tab index
                        this.element.tabIndex = -1;
                        // Backup original styles if any
                        var origStyle = this.element.getAttribute('style');
                        if (origStyle) this.element.setAttribute('data-choice-orig-style', origStyle);
                        this.element.setAttribute('data-choice', 'active');
                    };
                    WrappedElement.prototype.reveal = function() {
                        // Reinstate passed element
                        this.element.classList.remove(this.classNames.input);
                        this.element.hidden = false;
                        this.element.removeAttribute('tabindex');
                        // Recover original styles if any
                        var origStyle = this.element.getAttribute('data-choice-orig-style');
                        if (origStyle) {
                            this.element.removeAttribute('data-choice-orig-style');
                            this.element.setAttribute('style', origStyle);
                        } else this.element.removeAttribute('style');
                        this.element.removeAttribute('data-choice');
                        // Re-assign values - this is weird, I know
                        // @todo Figure out why we need to do this
                        this.element.value = this.element.value; // eslint-disable-line no-self-assign
                    };
                    WrappedElement.prototype.enable = function() {
                        this.element.removeAttribute('disabled');
                        this.element.disabled = false;
                        this.isDisabled = false;
                    };
                    WrappedElement.prototype.disable = function() {
                        this.element.setAttribute('disabled', '');
                        this.element.disabled = true;
                        this.isDisabled = true;
                    };
                    WrappedElement.prototype.triggerEvent = function(eventType, data) {
                        (0, utils_1.dispatchEvent)(this.element, eventType, data);
                    };
                    return WrappedElement;
                }();
                exports["default"] = WrappedElement;
            /***/ },
            /***/ 541: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var wrapped_element_1 = __importDefault(__webpack_require__(730));
                var WrappedInput = /** @class */ function(_super) {
                    __extends(WrappedInput, _super);
                    function WrappedInput(_a) {
                        var element = _a.element, classNames = _a.classNames, delimiter = _a.delimiter;
                        var _this = _super.call(this, {
                            element: element,
                            classNames: classNames
                        }) || this;
                        _this.delimiter = delimiter;
                        return _this;
                    }
                    Object.defineProperty(WrappedInput.prototype, "value", {
                        get: function() {
                            return this.element.value;
                        },
                        set: function(value) {
                            this.element.setAttribute('value', value);
                            this.element.value = value;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    return WrappedInput;
                }(wrapped_element_1.default);
                exports["default"] = WrappedInput;
            /***/ },
            /***/ 982: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var wrapped_element_1 = __importDefault(__webpack_require__(730));
                var WrappedSelect = /** @class */ function(_super) {
                    __extends(WrappedSelect, _super);
                    function WrappedSelect(_a) {
                        var element = _a.element, classNames = _a.classNames, template = _a.template;
                        var _this = _super.call(this, {
                            element: element,
                            classNames: classNames
                        }) || this;
                        _this.template = template;
                        return _this;
                    }
                    Object.defineProperty(WrappedSelect.prototype, "placeholderOption", {
                        get: function() {
                            return this.element.querySelector('option[value=""]') || // Backward compatibility layer for the non-standard placeholder attribute supported in older versions.
                            this.element.querySelector('option[placeholder]');
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(WrappedSelect.prototype, "optionGroups", {
                        get: function() {
                            return Array.from(this.element.getElementsByTagName('OPTGROUP'));
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(WrappedSelect.prototype, "options", {
                        get: function() {
                            return Array.from(this.element.options);
                        },
                        set: function(options) {
                            var _this = this;
                            var fragment = document.createDocumentFragment();
                            var addOptionToFragment = function(data) {
                                // Create a standard select option
                                var option = _this.template(data);
                                // Append it to fragment
                                fragment.appendChild(option);
                            };
                            // Add each list item to list
                            options.forEach(function(optionData) {
                                return addOptionToFragment(optionData);
                            });
                            this.appendDocFragment(fragment);
                        },
                        enumerable: false,
                        configurable: true
                    });
                    WrappedSelect.prototype.appendDocFragment = function(fragment) {
                        this.element.innerHTML = '';
                        this.element.appendChild(fragment);
                    };
                    return WrappedSelect;
                }(wrapped_element_1.default);
                exports["default"] = WrappedSelect;
            /***/ },
            /***/ 883: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.SCROLLING_SPEED = exports.SELECT_MULTIPLE_TYPE = exports.SELECT_ONE_TYPE = exports.TEXT_TYPE = exports.KEY_CODES = exports.ACTION_TYPES = exports.EVENTS = void 0;
                exports.EVENTS = {
                    showDropdown: 'showDropdown',
                    hideDropdown: 'hideDropdown',
                    change: 'change',
                    choice: 'choice',
                    search: 'search',
                    addItem: 'addItem',
                    removeItem: 'removeItem',
                    highlightItem: 'highlightItem',
                    highlightChoice: 'highlightChoice',
                    unhighlightItem: 'unhighlightItem'
                };
                exports.ACTION_TYPES = {
                    ADD_CHOICE: 'ADD_CHOICE',
                    FILTER_CHOICES: 'FILTER_CHOICES',
                    ACTIVATE_CHOICES: 'ACTIVATE_CHOICES',
                    CLEAR_CHOICES: 'CLEAR_CHOICES',
                    ADD_GROUP: 'ADD_GROUP',
                    ADD_ITEM: 'ADD_ITEM',
                    REMOVE_ITEM: 'REMOVE_ITEM',
                    HIGHLIGHT_ITEM: 'HIGHLIGHT_ITEM',
                    CLEAR_ALL: 'CLEAR_ALL',
                    RESET_TO: 'RESET_TO',
                    SET_IS_LOADING: 'SET_IS_LOADING'
                };
                exports.KEY_CODES = {
                    BACK_KEY: 46,
                    DELETE_KEY: 8,
                    ENTER_KEY: 13,
                    A_KEY: 65,
                    ESC_KEY: 27,
                    UP_KEY: 38,
                    DOWN_KEY: 40,
                    PAGE_UP_KEY: 33,
                    PAGE_DOWN_KEY: 34
                };
                exports.TEXT_TYPE = 'text';
                exports.SELECT_ONE_TYPE = 'select-one';
                exports.SELECT_MULTIPLE_TYPE = 'select-multiple';
                exports.SCROLLING_SPEED = 4;
            /***/ },
            /***/ 789: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.DEFAULT_CONFIG = exports.DEFAULT_CLASSNAMES = void 0;
                var utils_1 = __webpack_require__(799);
                exports.DEFAULT_CLASSNAMES = {
                    containerOuter: 'choices',
                    containerInner: 'choices__inner',
                    input: 'choices__input',
                    inputCloned: 'choices__input--cloned',
                    list: 'choices__list',
                    listItems: 'choices__list--multiple',
                    listSingle: 'choices__list--single',
                    listDropdown: 'choices__list--dropdown',
                    item: 'choices__item',
                    itemSelectable: 'choices__item--selectable',
                    itemDisabled: 'choices__item--disabled',
                    itemChoice: 'choices__item--choice',
                    placeholder: 'choices__placeholder',
                    group: 'choices__group',
                    groupHeading: 'choices__heading',
                    button: 'choices__button',
                    activeState: 'is-active',
                    focusState: 'is-focused',
                    openState: 'is-open',
                    disabledState: 'is-disabled',
                    highlightedState: 'is-highlighted',
                    selectedState: 'is-selected',
                    flippedState: 'is-flipped',
                    loadingState: 'is-loading',
                    noResults: 'has-no-results',
                    noChoices: 'has-no-choices'
                };
                exports.DEFAULT_CONFIG = {
                    items: [],
                    choices: [],
                    silent: false,
                    renderChoiceLimit: -1,
                    maxItemCount: -1,
                    addItems: true,
                    addItemFilter: null,
                    removeItems: true,
                    removeItemButton: false,
                    editItems: false,
                    allowHTML: true,
                    duplicateItemsAllowed: true,
                    delimiter: ',',
                    paste: true,
                    searchEnabled: true,
                    searchChoices: true,
                    searchFloor: 1,
                    searchResultLimit: 4,
                    searchFields: [
                        'label',
                        'value'
                    ],
                    position: 'auto',
                    resetScrollPosition: true,
                    shouldSort: true,
                    shouldSortItems: false,
                    sorter: utils_1.sortByAlpha,
                    placeholder: true,
                    placeholderValue: null,
                    searchPlaceholderValue: null,
                    prependValue: null,
                    appendValue: null,
                    renderSelectedChoices: 'auto',
                    loadingText: 'Loading...',
                    noResultsText: 'No results found',
                    noChoicesText: 'No choices to choose from',
                    itemSelectText: 'Press to select',
                    uniqueItemText: 'Only unique values can be added',
                    customAddItemText: 'Only values matching specific conditions can be added',
                    addItemText: function(value) {
                        return "Press Enter to add <b>\"".concat((0, utils_1.sanitise)(value), "\"</b>");
                    },
                    maxItemText: function(maxItemCount) {
                        return "Only ".concat(maxItemCount, " values can be added");
                    },
                    valueComparer: function(value1, value2) {
                        return value1 === value2;
                    },
                    fuseOptions: {
                        includeScore: true
                    },
                    labelId: '',
                    callbackOnInit: null,
                    callbackOnCreateTemplates: null,
                    classNames: exports.DEFAULT_CLASSNAMES
                };
            /***/ },
            /***/ 18: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 978: /***/ function(__unused_webpack_module, exports) {
                /* eslint-disable @typescript-eslint/no-explicit-any */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 948: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 359: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 285: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 533: /***/ function(__unused_webpack_module, exports) {
                /* eslint-disable @typescript-eslint/no-explicit-any */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 187: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
                    if (k2 === undefined) k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
                        enumerable: true,
                        get: function() {
                            return m[k];
                        }
                    };
                    Object.defineProperty(o, k2, desc);
                } : function(o, m, k, k2) {
                    if (k2 === undefined) k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function(m, exports) {
                    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                __exportStar(__webpack_require__(18), exports);
                __exportStar(__webpack_require__(978), exports);
                __exportStar(__webpack_require__(948), exports);
                __exportStar(__webpack_require__(359), exports);
                __exportStar(__webpack_require__(285), exports);
                __exportStar(__webpack_require__(533), exports);
                __exportStar(__webpack_require__(287), exports);
                __exportStar(__webpack_require__(132), exports);
                __exportStar(__webpack_require__(837), exports);
                __exportStar(__webpack_require__(598), exports);
                __exportStar(__webpack_require__(369), exports);
                __exportStar(__webpack_require__(37), exports);
                __exportStar(__webpack_require__(47), exports);
                __exportStar(__webpack_require__(923), exports);
                __exportStar(__webpack_require__(876), exports);
            /***/ },
            /***/ 287: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 132: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 837: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 598: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 37: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 369: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 47: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 923: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 876: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 799: /***/ function(__unused_webpack_module, exports) {
                /* eslint-disable @typescript-eslint/no-explicit-any */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.parseCustomProperties = exports.diff = exports.cloneObject = exports.existsInArray = exports.dispatchEvent = exports.sortByScore = exports.sortByAlpha = exports.strToEl = exports.sanitise = exports.isScrolledIntoView = exports.getAdjacentEl = exports.wrap = exports.isType = exports.getType = exports.generateId = exports.generateChars = exports.getRandomNumber = void 0;
                var getRandomNumber = function(min, max) {
                    return Math.floor(Math.random() * (max - min) + min);
                };
                exports.getRandomNumber = getRandomNumber;
                var generateChars = function(length) {
                    return Array.from({
                        length: length
                    }, function() {
                        return (0, exports.getRandomNumber)(0, 36).toString(36);
                    }).join('');
                };
                exports.generateChars = generateChars;
                var generateId = function(element, prefix) {
                    var id = element.id || element.name && "".concat(element.name, "-").concat((0, exports.generateChars)(2)) || (0, exports.generateChars)(4);
                    id = id.replace(/(:|\.|\[|\]|,)/g, '');
                    id = "".concat(prefix, "-").concat(id);
                    return id;
                };
                exports.generateId = generateId;
                var getType = function(obj) {
                    return Object.prototype.toString.call(obj).slice(8, -1);
                };
                exports.getType = getType;
                var isType = function(type, obj) {
                    return obj !== undefined && obj !== null && (0, exports.getType)(obj) === type;
                };
                exports.isType = isType;
                var wrap = function(element, wrapper) {
                    if (wrapper === void 0) wrapper = document.createElement('div');
                    if (element.parentNode) {
                        if (element.nextSibling) element.parentNode.insertBefore(wrapper, element.nextSibling);
                        else element.parentNode.appendChild(wrapper);
                    }
                    return wrapper.appendChild(element);
                };
                exports.wrap = wrap;
                var getAdjacentEl = function(startEl, selector, direction) {
                    if (direction === void 0) direction = 1;
                    var prop = "".concat(direction > 0 ? 'next' : 'previous', "ElementSibling");
                    var sibling = startEl[prop];
                    while(sibling){
                        if (sibling.matches(selector)) return sibling;
                        sibling = sibling[prop];
                    }
                    return sibling;
                };
                exports.getAdjacentEl = getAdjacentEl;
                var isScrolledIntoView = function(element, parent, direction) {
                    if (direction === void 0) direction = 1;
                    if (!element) return false;
                    var isVisible;
                    if (direction > 0) // In view from bottom
                    isVisible = parent.scrollTop + parent.offsetHeight >= element.offsetTop + element.offsetHeight;
                    else // In view from top
                    isVisible = element.offsetTop >= parent.scrollTop;
                    return isVisible;
                };
                exports.isScrolledIntoView = isScrolledIntoView;
                var sanitise = function(value) {
                    if (typeof value !== 'string') return value;
                    return value.replace(/&/g, '&amp;').replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
                };
                exports.sanitise = sanitise;
                exports.strToEl = function() {
                    var tmpEl = document.createElement('div');
                    return function(str) {
                        var cleanedInput = str.trim();
                        tmpEl.innerHTML = cleanedInput;
                        var firldChild = tmpEl.children[0];
                        while(tmpEl.firstChild)tmpEl.removeChild(tmpEl.firstChild);
                        return firldChild;
                    };
                }();
                var sortByAlpha = function(_a, _b) {
                    var value = _a.value, _c = _a.label, label = _c === void 0 ? value : _c;
                    var value2 = _b.value, _d = _b.label, label2 = _d === void 0 ? value2 : _d;
                    return label.localeCompare(label2, [], {
                        sensitivity: 'base',
                        ignorePunctuation: true,
                        numeric: true
                    });
                };
                exports.sortByAlpha = sortByAlpha;
                var sortByScore = function(a, b) {
                    var _a = a.score, scoreA = _a === void 0 ? 0 : _a;
                    var _b = b.score, scoreB = _b === void 0 ? 0 : _b;
                    return scoreA - scoreB;
                };
                exports.sortByScore = sortByScore;
                var dispatchEvent = function(element, type, customArgs) {
                    if (customArgs === void 0) customArgs = null;
                    var event = new CustomEvent(type, {
                        detail: customArgs,
                        bubbles: true,
                        cancelable: true
                    });
                    return element.dispatchEvent(event);
                };
                exports.dispatchEvent = dispatchEvent;
                var existsInArray = function(array, value, key) {
                    if (key === void 0) key = 'value';
                    return array.some(function(item) {
                        if (typeof value === 'string') return item[key] === value.trim();
                        return item[key] === value;
                    });
                };
                exports.existsInArray = existsInArray;
                var cloneObject = function(obj) {
                    return JSON.parse(JSON.stringify(obj));
                };
                exports.cloneObject = cloneObject;
                /**
 * Returns an array of keys present on the first but missing on the second object
 */ var diff = function(a, b) {
                    var aKeys = Object.keys(a).sort();
                    var bKeys = Object.keys(b).sort();
                    return aKeys.filter(function(i) {
                        return bKeys.indexOf(i) < 0;
                    });
                };
                exports.diff = diff;
                var parseCustomProperties = function(customProperties) {
                    if (typeof customProperties !== 'undefined') try {
                        return JSON.parse(customProperties);
                    } catch (e) {
                        return customProperties;
                    }
                    return {};
                };
                exports.parseCustomProperties = parseCustomProperties;
            /***/ },
            /***/ 273: /***/ function(__unused_webpack_module, exports) {
                var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                    if (pack || arguments.length === 2) {
                        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                            ar[i] = from[i];
                        }
                    }
                    return to.concat(ar || Array.prototype.slice.call(from));
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.defaultState = void 0;
                exports.defaultState = [];
                function choices(state, action) {
                    if (state === void 0) state = exports.defaultState;
                    if (action === void 0) action = {};
                    switch(action.type){
                        case 'ADD_CHOICE':
                            var addChoiceAction = action;
                            var choice = {
                                id: addChoiceAction.id,
                                elementId: addChoiceAction.elementId,
                                groupId: addChoiceAction.groupId,
                                value: addChoiceAction.value,
                                label: addChoiceAction.label || addChoiceAction.value,
                                disabled: addChoiceAction.disabled || false,
                                selected: false,
                                active: true,
                                score: 9999,
                                customProperties: addChoiceAction.customProperties,
                                placeholder: addChoiceAction.placeholder || false
                            };
                            /*
          A disabled choice appears in the choice dropdown but cannot be selected
          A selected choice has been added to the passed input's value (added as an item)
          An active choice appears within the choice dropdown
        */ return __spreadArray(__spreadArray([], state, true), [
                                choice
                            ], false);
                        case 'ADD_ITEM':
                            var addItemAction_1 = action;
                            // When an item is added and it has an associated choice,
                            // we want to disable it so it can't be chosen again
                            if (addItemAction_1.choiceId > -1) return state.map(function(obj) {
                                var choice = obj;
                                if (choice.id === parseInt("".concat(addItemAction_1.choiceId), 10)) choice.selected = true;
                                return choice;
                            });
                            return state;
                        case 'REMOVE_ITEM':
                            var removeItemAction_1 = action;
                            // When an item is removed and it has an associated choice,
                            // we want to re-enable it so it can be chosen again
                            if (removeItemAction_1.choiceId && removeItemAction_1.choiceId > -1) return state.map(function(obj) {
                                var choice = obj;
                                if (choice.id === parseInt("".concat(removeItemAction_1.choiceId), 10)) choice.selected = false;
                                return choice;
                            });
                            return state;
                        case 'FILTER_CHOICES':
                            var filterChoicesAction_1 = action;
                            return state.map(function(obj) {
                                var choice = obj;
                                // Set active state based on whether choice is
                                // within filtered results
                                choice.active = filterChoicesAction_1.results.some(function(_a) {
                                    var item = _a.item, score = _a.score;
                                    if (item.id === choice.id) {
                                        choice.score = score;
                                        return true;
                                    }
                                    return false;
                                });
                                return choice;
                            });
                        case 'ACTIVATE_CHOICES':
                            var activateChoicesAction_1 = action;
                            return state.map(function(obj) {
                                var choice = obj;
                                choice.active = activateChoicesAction_1.active;
                                return choice;
                            });
                        case 'CLEAR_CHOICES':
                            return exports.defaultState;
                        default:
                            return state;
                    }
                }
                exports["default"] = choices;
            /***/ },
            /***/ 871: /***/ function(__unused_webpack_module, exports) {
                var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                    if (pack || arguments.length === 2) {
                        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                            ar[i] = from[i];
                        }
                    }
                    return to.concat(ar || Array.prototype.slice.call(from));
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.defaultState = void 0;
                exports.defaultState = [];
                function groups(state, action) {
                    if (state === void 0) state = exports.defaultState;
                    if (action === void 0) action = {};
                    switch(action.type){
                        case 'ADD_GROUP':
                            var addGroupAction = action;
                            return __spreadArray(__spreadArray([], state, true), [
                                {
                                    id: addGroupAction.id,
                                    value: addGroupAction.value,
                                    active: addGroupAction.active,
                                    disabled: addGroupAction.disabled
                                }
                            ], false);
                        case 'CLEAR_CHOICES':
                            return [];
                        default:
                            return state;
                    }
                }
                exports["default"] = groups;
            /***/ },
            /***/ 655: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.defaultState = void 0;
                var redux_1 = __webpack_require__(791);
                var items_1 = __importDefault(__webpack_require__(52));
                var groups_1 = __importDefault(__webpack_require__(871));
                var choices_1 = __importDefault(__webpack_require__(273));
                var loading_1 = __importDefault(__webpack_require__(502));
                var utils_1 = __webpack_require__(799);
                exports.defaultState = {
                    groups: [],
                    items: [],
                    choices: [],
                    loading: false
                };
                var appReducer = (0, redux_1.combineReducers)({
                    items: items_1.default,
                    groups: groups_1.default,
                    choices: choices_1.default,
                    loading: loading_1.default
                });
                var rootReducer = function(passedState, action) {
                    var state = passedState;
                    // If we are clearing all items, groups and options we reassign
                    // state and then pass that state to our proper reducer. This isn't
                    // mutating our actual state
                    // See: http://stackoverflow.com/a/35641992
                    if (action.type === 'CLEAR_ALL') state = exports.defaultState;
                    else if (action.type === 'RESET_TO') return (0, utils_1.cloneObject)(action.state);
                    return appReducer(state, action);
                };
                exports["default"] = rootReducer;
            /***/ },
            /***/ 52: /***/ function(__unused_webpack_module, exports) {
                var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                    if (pack || arguments.length === 2) {
                        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                            ar[i] = from[i];
                        }
                    }
                    return to.concat(ar || Array.prototype.slice.call(from));
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.defaultState = void 0;
                exports.defaultState = [];
                function items(state, action) {
                    if (state === void 0) state = exports.defaultState;
                    if (action === void 0) action = {};
                    switch(action.type){
                        case 'ADD_ITEM':
                            var addItemAction = action;
                            // Add object to items array
                            var newState = __spreadArray(__spreadArray([], state, true), [
                                {
                                    id: addItemAction.id,
                                    choiceId: addItemAction.choiceId,
                                    groupId: addItemAction.groupId,
                                    value: addItemAction.value,
                                    label: addItemAction.label,
                                    active: true,
                                    highlighted: false,
                                    customProperties: addItemAction.customProperties,
                                    placeholder: addItemAction.placeholder || false,
                                    keyCode: null
                                }
                            ], false);
                            return newState.map(function(obj) {
                                var item = obj;
                                item.highlighted = false;
                                return item;
                            });
                        case 'REMOVE_ITEM':
                            // Set item to inactive
                            return state.map(function(obj) {
                                var item = obj;
                                if (item.id === action.id) item.active = false;
                                return item;
                            });
                        case 'HIGHLIGHT_ITEM':
                            var highlightItemAction_1 = action;
                            return state.map(function(obj) {
                                var item = obj;
                                if (item.id === highlightItemAction_1.id) item.highlighted = highlightItemAction_1.highlighted;
                                return item;
                            });
                        default:
                            return state;
                    }
                }
                exports["default"] = items;
            /***/ },
            /***/ 502: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.defaultState = void 0;
                exports.defaultState = false;
                var general = function(state, action) {
                    if (state === void 0) state = exports.defaultState;
                    if (action === void 0) action = {};
                    switch(action.type){
                        case 'SET_IS_LOADING':
                            return action.isLoading;
                        default:
                            return state;
                    }
                };
                exports["default"] = general;
            /***/ },
            /***/ 744: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                    if (pack || arguments.length === 2) {
                        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                            ar[i] = from[i];
                        }
                    }
                    return to.concat(ar || Array.prototype.slice.call(from));
                };
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                /* eslint-disable @typescript-eslint/no-explicit-any */ var redux_1 = __webpack_require__(791);
                var index_1 = __importDefault(__webpack_require__(655));
                var Store = /** @class */ function() {
                    function Store() {
                        this._store = (0, redux_1.createStore)(index_1.default, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
                    }
                    /**
   * Subscribe store to function call (wrapped Redux method)
   */ Store.prototype.subscribe = function(onChange) {
                        this._store.subscribe(onChange);
                    };
                    /**
   * Dispatch event to store (wrapped Redux method)
   */ Store.prototype.dispatch = function(action) {
                        this._store.dispatch(action);
                    };
                    Object.defineProperty(Store.prototype, "state", {
                        /**
     * Get store object (wrapping Redux method)
     */ get: function() {
                            return this._store.getState();
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "items", {
                        /**
     * Get items from store
     */ get: function() {
                            return this.state.items;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "activeItems", {
                        /**
     * Get active items from store
     */ get: function() {
                            return this.items.filter(function(item) {
                                return item.active === true;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "highlightedActiveItems", {
                        /**
     * Get highlighted items from store
     */ get: function() {
                            return this.items.filter(function(item) {
                                return item.active && item.highlighted;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "choices", {
                        /**
     * Get choices from store
     */ get: function() {
                            return this.state.choices;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "activeChoices", {
                        /**
     * Get active choices from store
     */ get: function() {
                            return this.choices.filter(function(choice) {
                                return choice.active === true;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "selectableChoices", {
                        /**
     * Get selectable choices from store
     */ get: function() {
                            return this.choices.filter(function(choice) {
                                return choice.disabled !== true;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "searchableChoices", {
                        /**
     * Get choices that can be searched (excluding placeholders)
     */ get: function() {
                            return this.selectableChoices.filter(function(choice) {
                                return choice.placeholder !== true;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "placeholderChoice", {
                        /**
     * Get placeholder choice from store
     */ get: function() {
                            return __spreadArray([], this.choices, true).reverse().find(function(choice) {
                                return choice.placeholder === true;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "groups", {
                        /**
     * Get groups from store
     */ get: function() {
                            return this.state.groups;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "activeGroups", {
                        /**
     * Get active groups from store
     */ get: function() {
                            var _a = this, groups = _a.groups, choices = _a.choices;
                            return groups.filter(function(group) {
                                var isActive = group.active === true && group.disabled === false;
                                var hasActiveOptions = choices.some(function(choice) {
                                    return choice.active === true && choice.disabled === false;
                                });
                                return isActive && hasActiveOptions;
                            }, []);
                        },
                        enumerable: false,
                        configurable: true
                    });
                    /**
   * Get loading state from store
   */ Store.prototype.isLoading = function() {
                        return this.state.loading;
                    };
                    /**
   * Get single choice by it's ID
   */ Store.prototype.getChoiceById = function(id) {
                        return this.activeChoices.find(function(choice) {
                            return choice.id === parseInt(id, 10);
                        });
                    };
                    /**
   * Get group by group id
   */ Store.prototype.getGroupById = function(id) {
                        return this.groups.find(function(group) {
                            return group.id === id;
                        });
                    };
                    return Store;
                }();
                exports["default"] = Store;
            /***/ },
            /***/ 686: /***/ function(__unused_webpack_module, exports) {
                /**
 * Helpers to create HTML elements used by Choices
 * Can be overridden by providing `callbackOnCreateTemplates` option
 */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var templates = {
                    containerOuter: function(_a, dir, isSelectElement, isSelectOneElement, searchEnabled, passedElementType, labelId) {
                        var containerOuter = _a.classNames.containerOuter;
                        var div = Object.assign(document.createElement('div'), {
                            className: containerOuter
                        });
                        div.dataset.type = passedElementType;
                        if (dir) div.dir = dir;
                        if (isSelectOneElement) div.tabIndex = 0;
                        if (isSelectElement) {
                            div.setAttribute('role', searchEnabled ? 'combobox' : 'listbox');
                            if (searchEnabled) div.setAttribute('aria-autocomplete', 'list');
                        }
                        div.setAttribute('aria-haspopup', 'true');
                        div.setAttribute('aria-expanded', 'false');
                        if (labelId) div.setAttribute('aria-labelledby', labelId);
                        return div;
                    },
                    containerInner: function(_a) {
                        var containerInner = _a.classNames.containerInner;
                        return Object.assign(document.createElement('div'), {
                            className: containerInner
                        });
                    },
                    itemList: function(_a, isSelectOneElement) {
                        var _b = _a.classNames, list = _b.list, listSingle = _b.listSingle, listItems = _b.listItems;
                        return Object.assign(document.createElement('div'), {
                            className: "".concat(list, " ").concat(isSelectOneElement ? listSingle : listItems)
                        });
                    },
                    placeholder: function(_a, value) {
                        var _b;
                        var allowHTML = _a.allowHTML, placeholder = _a.classNames.placeholder;
                        return Object.assign(document.createElement('div'), (_b = {
                            className: placeholder
                        }, _b[allowHTML ? 'innerHTML' : 'innerText'] = value, _b));
                    },
                    item: function(_a, _b, removeItemButton) {
                        var _c, _d;
                        var allowHTML = _a.allowHTML, _e = _a.classNames, item = _e.item, button = _e.button, highlightedState = _e.highlightedState, itemSelectable = _e.itemSelectable, placeholder = _e.placeholder;
                        var id = _b.id, value = _b.value, label = _b.label, customProperties = _b.customProperties, active = _b.active, disabled = _b.disabled, highlighted = _b.highlighted, isPlaceholder = _b.placeholder;
                        var div = Object.assign(document.createElement('div'), (_c = {
                            className: item
                        }, _c[allowHTML ? 'innerHTML' : 'innerText'] = label, _c));
                        Object.assign(div.dataset, {
                            item: '',
                            id: id,
                            value: value,
                            customProperties: customProperties
                        });
                        if (active) div.setAttribute('aria-selected', 'true');
                        if (disabled) div.setAttribute('aria-disabled', 'true');
                        if (isPlaceholder) div.classList.add(placeholder);
                        div.classList.add(highlighted ? highlightedState : itemSelectable);
                        if (removeItemButton) {
                            if (disabled) div.classList.remove(itemSelectable);
                            div.dataset.deletable = '';
                            /** @todo This MUST be localizable, not hardcoded! */ var REMOVE_ITEM_TEXT = 'Remove item';
                            var removeButton = Object.assign(document.createElement('button'), (_d = {
                                type: 'button',
                                className: button
                            }, _d[allowHTML ? 'innerHTML' : 'innerText'] = REMOVE_ITEM_TEXT, _d));
                            removeButton.setAttribute('aria-label', "".concat(REMOVE_ITEM_TEXT, ": '").concat(value, "'"));
                            removeButton.dataset.button = '';
                            div.appendChild(removeButton);
                        }
                        return div;
                    },
                    choiceList: function(_a, isSelectOneElement) {
                        var list = _a.classNames.list;
                        var div = Object.assign(document.createElement('div'), {
                            className: list
                        });
                        if (!isSelectOneElement) div.setAttribute('aria-multiselectable', 'true');
                        div.setAttribute('role', 'listbox');
                        return div;
                    },
                    choiceGroup: function(_a, _b) {
                        var _c;
                        var allowHTML = _a.allowHTML, _d = _a.classNames, group = _d.group, groupHeading = _d.groupHeading, itemDisabled = _d.itemDisabled;
                        var id = _b.id, value = _b.value, disabled = _b.disabled;
                        var div = Object.assign(document.createElement('div'), {
                            className: "".concat(group, " ").concat(disabled ? itemDisabled : '')
                        });
                        div.setAttribute('role', 'group');
                        Object.assign(div.dataset, {
                            group: '',
                            id: id,
                            value: value
                        });
                        if (disabled) div.setAttribute('aria-disabled', 'true');
                        div.appendChild(Object.assign(document.createElement('div'), (_c = {
                            className: groupHeading
                        }, _c[allowHTML ? 'innerHTML' : 'innerText'] = value, _c)));
                        return div;
                    },
                    choice: function(_a, _b, selectText) {
                        var _c;
                        var allowHTML = _a.allowHTML, _d = _a.classNames, item = _d.item, itemChoice = _d.itemChoice, itemSelectable = _d.itemSelectable, selectedState = _d.selectedState, itemDisabled = _d.itemDisabled, placeholder = _d.placeholder;
                        var id = _b.id, value = _b.value, label = _b.label, groupId = _b.groupId, elementId = _b.elementId, isDisabled = _b.disabled, isSelected = _b.selected, isPlaceholder = _b.placeholder;
                        var div = Object.assign(document.createElement('div'), (_c = {
                            id: elementId
                        }, _c[allowHTML ? 'innerHTML' : 'innerText'] = label, _c.className = "".concat(item, " ").concat(itemChoice), _c));
                        if (isSelected) div.classList.add(selectedState);
                        if (isPlaceholder) div.classList.add(placeholder);
                        div.setAttribute('role', groupId && groupId > 0 ? 'treeitem' : 'option');
                        Object.assign(div.dataset, {
                            choice: '',
                            id: id,
                            value: value,
                            selectText: selectText
                        });
                        if (isDisabled) {
                            div.classList.add(itemDisabled);
                            div.dataset.choiceDisabled = '';
                            div.setAttribute('aria-disabled', 'true');
                        } else {
                            div.classList.add(itemSelectable);
                            div.dataset.choiceSelectable = '';
                        }
                        return div;
                    },
                    input: function(_a, placeholderValue) {
                        var _b = _a.classNames, input = _b.input, inputCloned = _b.inputCloned;
                        var inp = Object.assign(document.createElement('input'), {
                            type: 'search',
                            name: 'search_terms',
                            className: "".concat(input, " ").concat(inputCloned),
                            autocomplete: 'off',
                            autocapitalize: 'off',
                            spellcheck: false
                        });
                        inp.setAttribute('role', 'textbox');
                        inp.setAttribute('aria-autocomplete', 'list');
                        inp.setAttribute('aria-label', placeholderValue);
                        return inp;
                    },
                    dropdown: function(_a) {
                        var _b = _a.classNames, list = _b.list, listDropdown = _b.listDropdown;
                        var div = document.createElement('div');
                        div.classList.add(list, listDropdown);
                        div.setAttribute('aria-expanded', 'false');
                        return div;
                    },
                    notice: function(_a, innerText, type) {
                        var _b;
                        var allowHTML = _a.allowHTML, _c = _a.classNames, item = _c.item, itemChoice = _c.itemChoice, noResults = _c.noResults, noChoices = _c.noChoices;
                        if (type === void 0) type = '';
                        var classes = [
                            item,
                            itemChoice
                        ];
                        if (type === 'no-choices') classes.push(noChoices);
                        else if (type === 'no-results') classes.push(noResults);
                        return Object.assign(document.createElement('div'), (_b = {}, _b[allowHTML ? 'innerHTML' : 'innerText'] = innerText, _b.className = classes.join(' '), _b));
                    },
                    option: function(_a) {
                        var label = _a.label, value = _a.value, customProperties = _a.customProperties, active = _a.active, disabled = _a.disabled;
                        var opt = new Option(label, value, false, active);
                        if (customProperties) opt.dataset.customProperties = "".concat(customProperties);
                        opt.disabled = !!disabled;
                        return opt;
                    }
                };
                exports["default"] = templates;
            /***/ },
            /***/ 996: /***/ function(module1) {
                var isMergeableObject = function isMergeableObject(value) {
                    return isNonNullObject(value) && !isSpecial(value);
                };
                function isNonNullObject(value) {
                    return !!value && typeof value === 'object';
                }
                function isSpecial(value) {
                    var stringValue = Object.prototype.toString.call(value);
                    return stringValue === '[object RegExp]' || stringValue === '[object Date]' || isReactElement(value);
                }
                // see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
                var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
                var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;
                function isReactElement(value) {
                    return value.$$typeof === REACT_ELEMENT_TYPE;
                }
                function emptyTarget(val) {
                    return Array.isArray(val) ? [] : {};
                }
                function cloneUnlessOtherwiseSpecified(value, options) {
                    return options.clone !== false && options.isMergeableObject(value) ? deepmerge(emptyTarget(value), value, options) : value;
                }
                function defaultArrayMerge(target, source, options) {
                    return target.concat(source).map(function(element) {
                        return cloneUnlessOtherwiseSpecified(element, options);
                    });
                }
                function getMergeFunction(key, options) {
                    if (!options.customMerge) return deepmerge;
                    var customMerge = options.customMerge(key);
                    return typeof customMerge === 'function' ? customMerge : deepmerge;
                }
                function getEnumerableOwnPropertySymbols(target) {
                    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
                        return target.propertyIsEnumerable(symbol);
                    }) : [];
                }
                function getKeys(target) {
                    return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));
                }
                function propertyIsOnObject(object, property) {
                    try {
                        return property in object;
                    } catch (_) {
                        return false;
                    }
                }
                // Protects from prototype poisoning and unexpected merging up the prototype chain.
                function propertyIsUnsafe(target, key) {
                    return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
                     && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
                     && Object.propertyIsEnumerable.call(target, key) // and also unsafe if they're nonenumerable.
                    );
                }
                function mergeObject(target, source, options) {
                    var destination = {};
                    if (options.isMergeableObject(target)) getKeys(target).forEach(function(key) {
                        destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
                    });
                    getKeys(source).forEach(function(key) {
                        if (propertyIsUnsafe(target, key)) return;
                        if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
                        else destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
                    });
                    return destination;
                }
                function deepmerge(target, source, options) {
                    options = options || {};
                    options.arrayMerge = options.arrayMerge || defaultArrayMerge;
                    options.isMergeableObject = options.isMergeableObject || isMergeableObject;
                    // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
                    // implementations can use it. The caller may not replace it.
                    options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
                    var sourceIsArray = Array.isArray(source);
                    var targetIsArray = Array.isArray(target);
                    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
                    if (!sourceAndTargetTypesMatch) return cloneUnlessOtherwiseSpecified(source, options);
                    else if (sourceIsArray) return options.arrayMerge(target, source, options);
                    else return mergeObject(target, source, options);
                }
                deepmerge.all = function deepmergeAll(array, options) {
                    if (!Array.isArray(array)) throw new Error('first argument should be an array');
                    return array.reduce(function(prev, next) {
                        return deepmerge(prev, next, options);
                    }, {});
                };
                var deepmerge_1 = deepmerge;
                module1.exports = deepmerge_1;
            /***/ },
            /***/ 221: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "default": function() {
                        return /* binding */ Fuse;
                    }
                });
                /**
 * Fuse.js v6.6.2 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2022 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ function isArray(value) {
                    return !Array.isArray ? getTag(value) === '[object Array]' : Array.isArray(value);
                }
                // Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
                const INFINITY = 1 / 0;
                function baseToString(value) {
                    // Exit early for strings to avoid a performance hit in some environments.
                    if (typeof value == 'string') return value;
                    let result = value + '';
                    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
                }
                function toString(value) {
                    return value == null ? '' : baseToString(value);
                }
                function isString(value) {
                    return typeof value === 'string';
                }
                function isNumber(value) {
                    return typeof value === 'number';
                }
                // Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
                function isBoolean(value) {
                    return value === true || value === false || isObjectLike(value) && getTag(value) == '[object Boolean]';
                }
                function isObject(value) {
                    return typeof value === 'object';
                }
                // Checks if `value` is object-like.
                function isObjectLike(value) {
                    return isObject(value) && value !== null;
                }
                function isDefined(value) {
                    return value !== undefined && value !== null;
                }
                function isBlank(value) {
                    return !value.trim().length;
                }
                // Gets the `toStringTag` of `value`.
                // Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
                function getTag(value) {
                    return value == null ? value === undefined ? '[object Undefined]' : '[object Null]' : Object.prototype.toString.call(value);
                }
                const EXTENDED_SEARCH_UNAVAILABLE = 'Extended search is not available';
                const INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
                const LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key)=>`Invalid value for key ${key}`;
                const PATTERN_LENGTH_TOO_LARGE = (max)=>`Pattern length exceeds max of ${max}.`;
                const MISSING_KEY_PROPERTY = (name)=>`Missing ${name} property in key`;
                const INVALID_KEY_WEIGHT_VALUE = (key)=>`Property 'weight' in key '${key}' must be a positive integer`;
                const hasOwn = Object.prototype.hasOwnProperty;
                class KeyStore {
                    constructor(keys){
                        this._keys = [];
                        this._keyMap = {};
                        let totalWeight = 0;
                        keys.forEach((key)=>{
                            let obj = createKey(key);
                            totalWeight += obj.weight;
                            this._keys.push(obj);
                            this._keyMap[obj.id] = obj;
                            totalWeight += obj.weight;
                        });
                        // Normalize weights so that their sum is equal to 1
                        this._keys.forEach((key)=>{
                            key.weight /= totalWeight;
                        });
                    }
                    get(keyId) {
                        return this._keyMap[keyId];
                    }
                    keys() {
                        return this._keys;
                    }
                    toJSON() {
                        return JSON.stringify(this._keys);
                    }
                }
                function createKey(key) {
                    let path = null;
                    let id = null;
                    let src = null;
                    let weight = 1;
                    let getFn = null;
                    if (isString(key) || isArray(key)) {
                        src = key;
                        path = createKeyPath(key);
                        id = createKeyId(key);
                    } else {
                        if (!hasOwn.call(key, 'name')) throw new Error(MISSING_KEY_PROPERTY('name'));
                        const name = key.name;
                        src = name;
                        if (hasOwn.call(key, 'weight')) {
                            weight = key.weight;
                            if (weight <= 0) throw new Error(INVALID_KEY_WEIGHT_VALUE(name));
                        }
                        path = createKeyPath(name);
                        id = createKeyId(name);
                        getFn = key.getFn;
                    }
                    return {
                        path: path,
                        id: id,
                        weight: weight,
                        src: src,
                        getFn: getFn
                    };
                }
                function createKeyPath(key) {
                    return isArray(key) ? key : key.split('.');
                }
                function createKeyId(key) {
                    return isArray(key) ? key.join('.') : key;
                }
                function get(obj, path) {
                    let list = [];
                    let arr = false;
                    const deepGet = (obj, path, index)=>{
                        if (!isDefined(obj)) return;
                        if (!path[index]) // If there's no path left, we've arrived at the object we care about.
                        list.push(obj);
                        else {
                            let key = path[index];
                            const value = obj[key];
                            if (!isDefined(value)) return;
                            // If we're at the last value in the path, and if it's a string/number/bool,
                            // add it to the list
                            if (index === path.length - 1 && (isString(value) || isNumber(value) || isBoolean(value))) list.push(toString(value));
                            else if (isArray(value)) {
                                arr = true;
                                // Search each item in the array.
                                for(let i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1);
                            } else if (path.length) // An object. Recurse further.
                            deepGet(value, path, index + 1);
                        }
                    };
                    // Backwards compatibility (since path used to be a string)
                    deepGet(obj, isString(path) ? path.split('.') : path, 0);
                    return arr ? list : list[0];
                }
                const MatchOptions = {
                    // Whether the matches should be included in the result set. When `true`, each record in the result
                    // set will include the indices of the matched characters.
                    // These can consequently be used for highlighting purposes.
                    includeMatches: false,
                    // When `true`, the matching function will continue to the end of a search pattern even if
                    // a perfect match has already been located in the string.
                    findAllMatches: false,
                    // Minimum number of characters that must be matched before a result is considered a match
                    minMatchCharLength: 1
                };
                const BasicOptions = {
                    // When `true`, the algorithm continues searching to the end of the input even if a perfect
                    // match is found before the end of the same input.
                    isCaseSensitive: false,
                    // When true, the matching function will continue to the end of a search pattern even if
                    includeScore: false,
                    // List of properties that will be searched. This also supports nested properties.
                    keys: [],
                    // Whether to sort the result list, by score
                    shouldSort: true,
                    // Default sort function: sort by ascending score, ascending index
                    sortFn: (a, b)=>a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
                };
                const FuzzyOptions = {
                    // Approximately where in the text is the pattern expected to be found?
                    location: 0,
                    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
                    // (of both letters and location), a threshold of '1.0' would match anything.
                    threshold: 0.6,
                    // Determines how close the match must be to the fuzzy location (specified above).
                    // An exact letter match which is 'distance' characters away from the fuzzy location
                    // would score as a complete mismatch. A distance of '0' requires the match be at
                    // the exact location specified, a threshold of '1000' would require a perfect match
                    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
                    distance: 100
                };
                const AdvancedOptions = {
                    // When `true`, it enables the use of unix-like search commands
                    useExtendedSearch: false,
                    // The get function to use when fetching an object's properties.
                    // The default will search nested paths *ie foo.bar.baz*
                    getFn: get,
                    // When `true`, search will ignore `location` and `distance`, so it won't matter
                    // where in the string the pattern appears.
                    // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
                    ignoreLocation: false,
                    // When `true`, the calculation for the relevance score (used for sorting) will
                    // ignore the field-length norm.
                    // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
                    ignoreFieldNorm: false,
                    // The weight to determine how much field length norm effects scoring.
                    fieldNormWeight: 1
                };
                var Config = {
                    ...BasicOptions,
                    ...MatchOptions,
                    ...FuzzyOptions,
                    ...AdvancedOptions
                };
                const SPACE = /[^ ]+/g;
                // Field-length norm: the shorter the field, the higher the weight.
                // Set to 3 decimals to reduce index size.
                function norm(weight = 1, mantissa = 3) {
                    const cache = new Map();
                    const m = Math.pow(10, mantissa);
                    return {
                        get (value) {
                            const numTokens = value.match(SPACE).length;
                            if (cache.has(numTokens)) return cache.get(numTokens);
                            // Default function is 1/sqrt(x), weight makes that variable
                            const norm = 1 / Math.pow(numTokens, 0.5 * weight);
                            // In place of `toFixed(mantissa)`, for faster computation
                            const n = parseFloat(Math.round(norm * m) / m);
                            cache.set(numTokens, n);
                            return n;
                        },
                        clear () {
                            cache.clear();
                        }
                    };
                }
                class FuseIndex {
                    constructor({ getFn: getFn = Config.getFn, fieldNormWeight: fieldNormWeight = Config.fieldNormWeight } = {}){
                        this.norm = norm(fieldNormWeight, 3);
                        this.getFn = getFn;
                        this.isCreated = false;
                        this.setIndexRecords();
                    }
                    setSources(docs = []) {
                        this.docs = docs;
                    }
                    setIndexRecords(records = []) {
                        this.records = records;
                    }
                    setKeys(keys = []) {
                        this.keys = keys;
                        this._keysMap = {};
                        keys.forEach((key, idx)=>{
                            this._keysMap[key.id] = idx;
                        });
                    }
                    create() {
                        if (this.isCreated || !this.docs.length) return;
                        this.isCreated = true;
                        // List is Array<String>
                        if (isString(this.docs[0])) this.docs.forEach((doc, docIndex)=>{
                            this._addString(doc, docIndex);
                        });
                        else // List is Array<Object>
                        this.docs.forEach((doc, docIndex)=>{
                            this._addObject(doc, docIndex);
                        });
                        this.norm.clear();
                    }
                    // Adds a doc to the end of the index
                    add(doc) {
                        const idx = this.size();
                        if (isString(doc)) this._addString(doc, idx);
                        else this._addObject(doc, idx);
                    }
                    // Removes the doc at the specified index of the index
                    removeAt(idx) {
                        this.records.splice(idx, 1);
                        // Change ref index of every subsquent doc
                        for(let i = idx, len = this.size(); i < len; i += 1)this.records[i].i -= 1;
                    }
                    getValueForItemAtKeyId(item, keyId) {
                        return item[this._keysMap[keyId]];
                    }
                    size() {
                        return this.records.length;
                    }
                    _addString(doc, docIndex) {
                        if (!isDefined(doc) || isBlank(doc)) return;
                        let record = {
                            v: doc,
                            i: docIndex,
                            n: this.norm.get(doc)
                        };
                        this.records.push(record);
                    }
                    _addObject(doc, docIndex) {
                        let record = {
                            i: docIndex,
                            $: {}
                        };
                        // Iterate over every key (i.e, path), and fetch the value at that key
                        this.keys.forEach((key, keyIndex)=>{
                            let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
                            if (!isDefined(value)) return;
                            if (isArray(value)) {
                                let subRecords = [];
                                const stack = [
                                    {
                                        nestedArrIndex: -1,
                                        value: value
                                    }
                                ];
                                while(stack.length){
                                    const { nestedArrIndex: nestedArrIndex, value: value } = stack.pop();
                                    if (!isDefined(value)) continue;
                                    if (isString(value) && !isBlank(value)) {
                                        let subRecord = {
                                            v: value,
                                            i: nestedArrIndex,
                                            n: this.norm.get(value)
                                        };
                                        subRecords.push(subRecord);
                                    } else if (isArray(value)) value.forEach((item, k)=>{
                                        stack.push({
                                            nestedArrIndex: k,
                                            value: item
                                        });
                                    });
                                }
                                record.$[keyIndex] = subRecords;
                            } else if (isString(value) && !isBlank(value)) {
                                let subRecord = {
                                    v: value,
                                    n: this.norm.get(value)
                                };
                                record.$[keyIndex] = subRecord;
                            }
                        });
                        this.records.push(record);
                    }
                    toJSON() {
                        return {
                            keys: this.keys,
                            records: this.records
                        };
                    }
                }
                function createIndex(keys, docs, { getFn: getFn = Config.getFn, fieldNormWeight: fieldNormWeight = Config.fieldNormWeight } = {}) {
                    const myIndex = new FuseIndex({
                        getFn: getFn,
                        fieldNormWeight: fieldNormWeight
                    });
                    myIndex.setKeys(keys.map(createKey));
                    myIndex.setSources(docs);
                    myIndex.create();
                    return myIndex;
                }
                function parseIndex(data, { getFn: getFn = Config.getFn, fieldNormWeight: fieldNormWeight = Config.fieldNormWeight } = {}) {
                    const { keys: keys, records: records } = data;
                    const myIndex = new FuseIndex({
                        getFn: getFn,
                        fieldNormWeight: fieldNormWeight
                    });
                    myIndex.setKeys(keys);
                    myIndex.setIndexRecords(records);
                    return myIndex;
                }
                function computeScore$1(pattern, { errors: errors = 0, currentLocation: currentLocation = 0, expectedLocation: expectedLocation = 0, distance: distance = Config.distance, ignoreLocation: ignoreLocation = Config.ignoreLocation } = {}) {
                    const accuracy = errors / pattern.length;
                    if (ignoreLocation) return accuracy;
                    const proximity = Math.abs(expectedLocation - currentLocation);
                    if (!distance) // Dodge divide by zero error.
                    return proximity ? 1.0 : accuracy;
                    return accuracy + proximity / distance;
                }
                function convertMaskToIndices(matchmask = [], minMatchCharLength = Config.minMatchCharLength) {
                    let indices = [];
                    let start = -1;
                    let end = -1;
                    let i = 0;
                    for(let len = matchmask.length; i < len; i += 1){
                        let match = matchmask[i];
                        if (match && start === -1) start = i;
                        else if (!match && start !== -1) {
                            end = i - 1;
                            if (end - start + 1 >= minMatchCharLength) indices.push([
                                start,
                                end
                            ]);
                            start = -1;
                        }
                    }
                    // (i-1 - start) + 1 => i - start
                    if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
                        start,
                        i - 1
                    ]);
                    return indices;
                }
                // Machine word size
                const MAX_BITS = 32;
                function search(text, pattern, patternAlphabet, { location: location = Config.location, distance: distance = Config.distance, threshold: threshold = Config.threshold, findAllMatches: findAllMatches = Config.findAllMatches, minMatchCharLength: minMatchCharLength = Config.minMatchCharLength, includeMatches: includeMatches = Config.includeMatches, ignoreLocation: ignoreLocation = Config.ignoreLocation } = {}) {
                    if (pattern.length > MAX_BITS) throw new Error(PATTERN_LENGTH_TOO_LARGE(MAX_BITS));
                    const patternLen = pattern.length;
                    // Set starting location at beginning text and initialize the alphabet.
                    const textLen = text.length;
                    // Handle the case when location > text.length
                    const expectedLocation = Math.max(0, Math.min(location, textLen));
                    // Highest score beyond which we give up.
                    let currentThreshold = threshold;
                    // Is there a nearby exact match? (speedup)
                    let bestLocation = expectedLocation;
                    // Performance: only computer matches when the minMatchCharLength > 1
                    // OR if `includeMatches` is true.
                    const computeMatches = minMatchCharLength > 1 || includeMatches;
                    // A mask of the matches, used for building the indices
                    const matchMask = computeMatches ? Array(textLen) : [];
                    let index;
                    // Get all exact matches, here for speed up
                    while((index = text.indexOf(pattern, bestLocation)) > -1){
                        let score = computeScore$1(pattern, {
                            currentLocation: index,
                            expectedLocation: expectedLocation,
                            distance: distance,
                            ignoreLocation: ignoreLocation
                        });
                        currentThreshold = Math.min(score, currentThreshold);
                        bestLocation = index + patternLen;
                        if (computeMatches) {
                            let i = 0;
                            while(i < patternLen){
                                matchMask[index + i] = 1;
                                i += 1;
                            }
                        }
                    }
                    // Reset the best location
                    bestLocation = -1;
                    let lastBitArr = [];
                    let finalScore = 1;
                    let binMax = patternLen + textLen;
                    const mask = 1 << patternLen - 1;
                    for(let i = 0; i < patternLen; i += 1){
                        // Scan for the best match; each iteration allows for one more error.
                        // Run a binary search to determine how far from the match location we can stray
                        // at this error level.
                        let binMin = 0;
                        let binMid = binMax;
                        while(binMin < binMid){
                            const score = computeScore$1(pattern, {
                                errors: i,
                                currentLocation: expectedLocation + binMid,
                                expectedLocation: expectedLocation,
                                distance: distance,
                                ignoreLocation: ignoreLocation
                            });
                            if (score <= currentThreshold) binMin = binMid;
                            else binMax = binMid;
                            binMid = Math.floor((binMax - binMin) / 2 + binMin);
                        }
                        // Use the result from this iteration as the maximum for the next.
                        binMax = binMid;
                        let start = Math.max(1, expectedLocation - binMid + 1);
                        let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
                        // Initialize the bit array
                        let bitArr = Array(finish + 2);
                        bitArr[finish + 1] = (1 << i) - 1;
                        for(let j = finish; j >= start; j -= 1){
                            let currentLocation = j - 1;
                            let charMatch = patternAlphabet[text.charAt(currentLocation)];
                            if (computeMatches) // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
                            matchMask[currentLocation] = +!!charMatch;
                            // First pass: exact match
                            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
                            // Subsequent passes: fuzzy match
                            if (i) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
                            if (bitArr[j] & mask) {
                                finalScore = computeScore$1(pattern, {
                                    errors: i,
                                    currentLocation: currentLocation,
                                    expectedLocation: expectedLocation,
                                    distance: distance,
                                    ignoreLocation: ignoreLocation
                                });
                                // This match will almost certainly be better than any existing match.
                                // But check anyway.
                                if (finalScore <= currentThreshold) {
                                    // Indeed it is
                                    currentThreshold = finalScore;
                                    bestLocation = currentLocation;
                                    // Already passed `loc`, downhill from here on in.
                                    if (bestLocation <= expectedLocation) break;
                                    // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                                }
                            }
                        }
                        // No hope for a (better) match at greater error levels.
                        const score = computeScore$1(pattern, {
                            errors: i + 1,
                            currentLocation: expectedLocation,
                            expectedLocation: expectedLocation,
                            distance: distance,
                            ignoreLocation: ignoreLocation
                        });
                        if (score > currentThreshold) break;
                        lastBitArr = bitArr;
                    }
                    const result = {
                        isMatch: bestLocation >= 0,
                        // Count exact matches (those with a score of 0) to be "almost" exact
                        score: Math.max(0.001, finalScore)
                    };
                    if (computeMatches) {
                        const indices = convertMaskToIndices(matchMask, minMatchCharLength);
                        if (!indices.length) result.isMatch = false;
                        else if (includeMatches) result.indices = indices;
                    }
                    return result;
                }
                function createPatternAlphabet(pattern) {
                    let mask = {};
                    for(let i = 0, len = pattern.length; i < len; i += 1){
                        const char = pattern.charAt(i);
                        mask[char] = (mask[char] || 0) | 1 << len - i - 1;
                    }
                    return mask;
                }
                class BitapSearch {
                    constructor(pattern, { location: location = Config.location, threshold: threshold = Config.threshold, distance: distance = Config.distance, includeMatches: includeMatches = Config.includeMatches, findAllMatches: findAllMatches = Config.findAllMatches, minMatchCharLength: minMatchCharLength = Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = Config.isCaseSensitive, ignoreLocation: ignoreLocation = Config.ignoreLocation } = {}){
                        this.options = {
                            location: location,
                            threshold: threshold,
                            distance: distance,
                            includeMatches: includeMatches,
                            findAllMatches: findAllMatches,
                            minMatchCharLength: minMatchCharLength,
                            isCaseSensitive: isCaseSensitive,
                            ignoreLocation: ignoreLocation
                        };
                        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
                        this.chunks = [];
                        if (!this.pattern.length) return;
                        const addChunk = (pattern, startIndex)=>{
                            this.chunks.push({
                                pattern: pattern,
                                alphabet: createPatternAlphabet(pattern),
                                startIndex: startIndex
                            });
                        };
                        const len = this.pattern.length;
                        if (len > MAX_BITS) {
                            let i = 0;
                            const remainder = len % MAX_BITS;
                            const end = len - remainder;
                            while(i < end){
                                addChunk(this.pattern.substr(i, MAX_BITS), i);
                                i += MAX_BITS;
                            }
                            if (remainder) {
                                const startIndex = len - MAX_BITS;
                                addChunk(this.pattern.substr(startIndex), startIndex);
                            }
                        } else addChunk(this.pattern, 0);
                    }
                    searchIn(text) {
                        const { isCaseSensitive: isCaseSensitive, includeMatches: includeMatches } = this.options;
                        if (!isCaseSensitive) text = text.toLowerCase();
                        // Exact match
                        if (this.pattern === text) {
                            let result = {
                                isMatch: true,
                                score: 0
                            };
                            if (includeMatches) result.indices = [
                                [
                                    0,
                                    text.length - 1
                                ]
                            ];
                            return result;
                        }
                        // Otherwise, use Bitap algorithm
                        const { location: location, distance: distance, threshold: threshold, findAllMatches: findAllMatches, minMatchCharLength: minMatchCharLength, ignoreLocation: ignoreLocation } = this.options;
                        let allIndices = [];
                        let totalScore = 0;
                        let hasMatches = false;
                        this.chunks.forEach(({ pattern: pattern, alphabet: alphabet, startIndex: startIndex })=>{
                            const { isMatch: isMatch, score: score, indices: indices } = search(text, pattern, alphabet, {
                                location: location + startIndex,
                                distance: distance,
                                threshold: threshold,
                                findAllMatches: findAllMatches,
                                minMatchCharLength: minMatchCharLength,
                                includeMatches: includeMatches,
                                ignoreLocation: ignoreLocation
                            });
                            if (isMatch) hasMatches = true;
                            totalScore += score;
                            if (isMatch && indices) allIndices = [
                                ...allIndices,
                                ...indices
                            ];
                        });
                        let result = {
                            isMatch: hasMatches,
                            score: hasMatches ? totalScore / this.chunks.length : 1
                        };
                        if (hasMatches && includeMatches) result.indices = allIndices;
                        return result;
                    }
                }
                class BaseMatch {
                    constructor(pattern){
                        this.pattern = pattern;
                    }
                    static isMultiMatch(pattern) {
                        return getMatch(pattern, this.multiRegex);
                    }
                    static isSingleMatch(pattern) {
                        return getMatch(pattern, this.singleRegex);
                    }
                    search() {}
                }
                function getMatch(pattern, exp) {
                    const matches = pattern.match(exp);
                    return matches ? matches[1] : null;
                }
                // Token: 'file
                class ExactMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return 'exact';
                    }
                    static get multiRegex() {
                        return /^="(.*)"$/;
                    }
                    static get singleRegex() {
                        return /^=(.*)$/;
                    }
                    search(text) {
                        const isMatch = text === this.pattern;
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: [
                                0,
                                this.pattern.length - 1
                            ]
                        };
                    }
                }
                // Token: !fire
                class InverseExactMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return 'inverse-exact';
                    }
                    static get multiRegex() {
                        return /^!"(.*)"$/;
                    }
                    static get singleRegex() {
                        return /^!(.*)$/;
                    }
                    search(text) {
                        const index = text.indexOf(this.pattern);
                        const isMatch = index === -1;
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: [
                                0,
                                text.length - 1
                            ]
                        };
                    }
                }
                // Token: ^file
                class PrefixExactMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return 'prefix-exact';
                    }
                    static get multiRegex() {
                        return /^\^"(.*)"$/;
                    }
                    static get singleRegex() {
                        return /^\^(.*)$/;
                    }
                    search(text) {
                        const isMatch = text.startsWith(this.pattern);
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: [
                                0,
                                this.pattern.length - 1
                            ]
                        };
                    }
                }
                // Token: !^fire
                class InversePrefixExactMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return 'inverse-prefix-exact';
                    }
                    static get multiRegex() {
                        return /^!\^"(.*)"$/;
                    }
                    static get singleRegex() {
                        return /^!\^(.*)$/;
                    }
                    search(text) {
                        const isMatch = !text.startsWith(this.pattern);
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: [
                                0,
                                text.length - 1
                            ]
                        };
                    }
                }
                // Token: .file$
                class SuffixExactMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return 'suffix-exact';
                    }
                    static get multiRegex() {
                        return /^"(.*)"\$$/;
                    }
                    static get singleRegex() {
                        return /^(.*)\$$/;
                    }
                    search(text) {
                        const isMatch = text.endsWith(this.pattern);
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: [
                                text.length - this.pattern.length,
                                text.length - 1
                            ]
                        };
                    }
                }
                // Token: !.file$
                class InverseSuffixExactMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return 'inverse-suffix-exact';
                    }
                    static get multiRegex() {
                        return /^!"(.*)"\$$/;
                    }
                    static get singleRegex() {
                        return /^!(.*)\$$/;
                    }
                    search(text) {
                        const isMatch = !text.endsWith(this.pattern);
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: [
                                0,
                                text.length - 1
                            ]
                        };
                    }
                }
                class FuzzyMatch extends BaseMatch {
                    constructor(pattern, { location: location = Config.location, threshold: threshold = Config.threshold, distance: distance = Config.distance, includeMatches: includeMatches = Config.includeMatches, findAllMatches: findAllMatches = Config.findAllMatches, minMatchCharLength: minMatchCharLength = Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = Config.isCaseSensitive, ignoreLocation: ignoreLocation = Config.ignoreLocation } = {}){
                        super(pattern);
                        this._bitapSearch = new BitapSearch(pattern, {
                            location: location,
                            threshold: threshold,
                            distance: distance,
                            includeMatches: includeMatches,
                            findAllMatches: findAllMatches,
                            minMatchCharLength: minMatchCharLength,
                            isCaseSensitive: isCaseSensitive,
                            ignoreLocation: ignoreLocation
                        });
                    }
                    static get type() {
                        return 'fuzzy';
                    }
                    static get multiRegex() {
                        return /^"(.*)"$/;
                    }
                    static get singleRegex() {
                        return /^(.*)$/;
                    }
                    search(text) {
                        return this._bitapSearch.searchIn(text);
                    }
                }
                // Token: 'file
                class IncludeMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return 'include';
                    }
                    static get multiRegex() {
                        return /^'"(.*)"$/;
                    }
                    static get singleRegex() {
                        return /^'(.*)$/;
                    }
                    search(text) {
                        let location = 0;
                        let index;
                        const indices = [];
                        const patternLen = this.pattern.length;
                        // Get all exact matches
                        while((index = text.indexOf(this.pattern, location)) > -1){
                            location = index + patternLen;
                            indices.push([
                                index,
                                location - 1
                            ]);
                        }
                        const isMatch = !!indices.length;
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: indices
                        };
                    }
                }
                // ❗Order is important. DO NOT CHANGE.
                const searchers = [
                    ExactMatch,
                    IncludeMatch,
                    PrefixExactMatch,
                    InversePrefixExactMatch,
                    InverseSuffixExactMatch,
                    SuffixExactMatch,
                    InverseExactMatch,
                    FuzzyMatch
                ];
                const searchersLen = searchers.length;
                // Regex to split by spaces, but keep anything in quotes together
                const SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
                const OR_TOKEN = '|';
                // Return a 2D array representation of the query, for simpler parsing.
                // Example:
                // "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
                function parseQuery(pattern, options = {}) {
                    return pattern.split(OR_TOKEN).map((item)=>{
                        let query = item.trim().split(SPACE_RE).filter((item)=>item && !!item.trim());
                        let results = [];
                        for(let i = 0, len = query.length; i < len; i += 1){
                            const queryItem = query[i];
                            // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
                            let found = false;
                            let idx = -1;
                            while(!found && ++idx < searchersLen){
                                const searcher = searchers[idx];
                                let token = searcher.isMultiMatch(queryItem);
                                if (token) {
                                    results.push(new searcher(token, options));
                                    found = true;
                                }
                            }
                            if (found) continue;
                            // 2. Handle single query matches (i.e, once that are *not* quoted)
                            idx = -1;
                            while(++idx < searchersLen){
                                const searcher = searchers[idx];
                                let token = searcher.isSingleMatch(queryItem);
                                if (token) {
                                    results.push(new searcher(token, options));
                                    break;
                                }
                            }
                        }
                        return results;
                    });
                }
                // These extended matchers can return an array of matches, as opposed
                // to a singl match
                const MultiMatchSet = new Set([
                    FuzzyMatch.type,
                    IncludeMatch.type
                ]);
                /**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */ class ExtendedSearch {
                    constructor(pattern, { isCaseSensitive: isCaseSensitive = Config.isCaseSensitive, includeMatches: includeMatches = Config.includeMatches, minMatchCharLength: minMatchCharLength = Config.minMatchCharLength, ignoreLocation: ignoreLocation = Config.ignoreLocation, findAllMatches: findAllMatches = Config.findAllMatches, location: location = Config.location, threshold: threshold = Config.threshold, distance: distance = Config.distance } = {}){
                        this.query = null;
                        this.options = {
                            isCaseSensitive: isCaseSensitive,
                            includeMatches: includeMatches,
                            minMatchCharLength: minMatchCharLength,
                            findAllMatches: findAllMatches,
                            ignoreLocation: ignoreLocation,
                            location: location,
                            threshold: threshold,
                            distance: distance
                        };
                        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
                        this.query = parseQuery(this.pattern, this.options);
                    }
                    static condition(_, options) {
                        return options.useExtendedSearch;
                    }
                    searchIn(text) {
                        const query = this.query;
                        if (!query) return {
                            isMatch: false,
                            score: 1
                        };
                        const { includeMatches: includeMatches, isCaseSensitive: isCaseSensitive } = this.options;
                        text = isCaseSensitive ? text : text.toLowerCase();
                        let numMatches = 0;
                        let allIndices = [];
                        let totalScore = 0;
                        // ORs
                        for(let i = 0, qLen = query.length; i < qLen; i += 1){
                            const searchers = query[i];
                            // Reset indices
                            allIndices.length = 0;
                            numMatches = 0;
                            // ANDs
                            for(let j = 0, pLen = searchers.length; j < pLen; j += 1){
                                const searcher = searchers[j];
                                const { isMatch: isMatch, indices: indices, score: score } = searcher.search(text);
                                if (isMatch) {
                                    numMatches += 1;
                                    totalScore += score;
                                    if (includeMatches) {
                                        const type = searcher.constructor.type;
                                        if (MultiMatchSet.has(type)) allIndices = [
                                            ...allIndices,
                                            ...indices
                                        ];
                                        else allIndices.push(indices);
                                    }
                                } else {
                                    totalScore = 0;
                                    numMatches = 0;
                                    allIndices.length = 0;
                                    break;
                                }
                            }
                            // OR condition, so if TRUE, return
                            if (numMatches) {
                                let result = {
                                    isMatch: true,
                                    score: totalScore / numMatches
                                };
                                if (includeMatches) result.indices = allIndices;
                                return result;
                            }
                        }
                        // Nothing was matched
                        return {
                            isMatch: false,
                            score: 1
                        };
                    }
                }
                const registeredSearchers = [];
                function register(...args) {
                    registeredSearchers.push(...args);
                }
                function createSearcher(pattern, options) {
                    for(let i = 0, len = registeredSearchers.length; i < len; i += 1){
                        let searcherClass = registeredSearchers[i];
                        if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
                    }
                    return new BitapSearch(pattern, options);
                }
                const LogicalOperator = {
                    AND: '$and',
                    OR: '$or'
                };
                const KeyType = {
                    PATH: '$path',
                    PATTERN: '$val'
                };
                const isExpression = (query)=>!!(query[LogicalOperator.AND] || query[LogicalOperator.OR]);
                const isPath = (query)=>!!query[KeyType.PATH];
                const isLeaf = (query)=>!isArray(query) && isObject(query) && !isExpression(query);
                const convertToExplicit = (query)=>({
                        [LogicalOperator.AND]: Object.keys(query).map((key)=>({
                                [key]: query[key]
                            }))
                    });
                // When `auto` is `true`, the parse function will infer and initialize and add
                // the appropriate `Searcher` instance
                function parse(query, options, { auto: auto = true } = {}) {
                    const next = (query)=>{
                        let keys = Object.keys(query);
                        const isQueryPath = isPath(query);
                        if (!isQueryPath && keys.length > 1 && !isExpression(query)) return next(convertToExplicit(query));
                        if (isLeaf(query)) {
                            const key = isQueryPath ? query[KeyType.PATH] : keys[0];
                            const pattern = isQueryPath ? query[KeyType.PATTERN] : query[key];
                            if (!isString(pattern)) throw new Error(LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
                            const obj = {
                                keyId: createKeyId(key),
                                pattern: pattern
                            };
                            if (auto) obj.searcher = createSearcher(pattern, options);
                            return obj;
                        }
                        let node = {
                            children: [],
                            operator: keys[0]
                        };
                        keys.forEach((key)=>{
                            const value = query[key];
                            if (isArray(value)) value.forEach((item)=>{
                                node.children.push(next(item));
                            });
                        });
                        return node;
                    };
                    if (!isExpression(query)) query = convertToExplicit(query);
                    return next(query);
                }
                // Practical scoring function
                function computeScore(results, { ignoreFieldNorm: ignoreFieldNorm = Config.ignoreFieldNorm }) {
                    results.forEach((result)=>{
                        let totalScore = 1;
                        result.matches.forEach(({ key: key, norm: norm, score: score })=>{
                            const weight = key ? key.weight : null;
                            totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
                        });
                        result.score = totalScore;
                    });
                }
                function transformMatches(result, data) {
                    const matches = result.matches;
                    data.matches = [];
                    if (!isDefined(matches)) return;
                    matches.forEach((match)=>{
                        if (!isDefined(match.indices) || !match.indices.length) return;
                        const { indices: indices, value: value } = match;
                        let obj = {
                            indices: indices,
                            value: value
                        };
                        if (match.key) obj.key = match.key.src;
                        if (match.idx > -1) obj.refIndex = match.idx;
                        data.matches.push(obj);
                    });
                }
                function transformScore(result, data) {
                    data.score = result.score;
                }
                function format(results, docs, { includeMatches: includeMatches = Config.includeMatches, includeScore: includeScore = Config.includeScore } = {}) {
                    const transformers = [];
                    if (includeMatches) transformers.push(transformMatches);
                    if (includeScore) transformers.push(transformScore);
                    return results.map((result)=>{
                        const { idx: idx } = result;
                        const data = {
                            item: docs[idx],
                            refIndex: idx
                        };
                        if (transformers.length) transformers.forEach((transformer)=>{
                            transformer(result, data);
                        });
                        return data;
                    });
                }
                class Fuse {
                    constructor(docs, options = {}, index){
                        this.options = {
                            ...Config,
                            ...options
                        };
                        this.options.useExtendedSearch;
                        this._keyStore = new KeyStore(this.options.keys);
                        this.setCollection(docs, index);
                    }
                    setCollection(docs, index) {
                        this._docs = docs;
                        if (index && !(index instanceof FuseIndex)) throw new Error(INCORRECT_INDEX_TYPE);
                        this._myIndex = index || createIndex(this.options.keys, this._docs, {
                            getFn: this.options.getFn,
                            fieldNormWeight: this.options.fieldNormWeight
                        });
                    }
                    add(doc) {
                        if (!isDefined(doc)) return;
                        this._docs.push(doc);
                        this._myIndex.add(doc);
                    }
                    remove(predicate = ()=>false) {
                        const results = [];
                        for(let i = 0, len = this._docs.length; i < len; i += 1){
                            const doc = this._docs[i];
                            if (predicate(doc, i)) {
                                this.removeAt(i);
                                i -= 1;
                                len -= 1;
                                results.push(doc);
                            }
                        }
                        return results;
                    }
                    removeAt(idx) {
                        this._docs.splice(idx, 1);
                        this._myIndex.removeAt(idx);
                    }
                    getIndex() {
                        return this._myIndex;
                    }
                    search(query, { limit: limit = -1 } = {}) {
                        const { includeMatches: includeMatches, includeScore: includeScore, shouldSort: shouldSort, sortFn: sortFn, ignoreFieldNorm: ignoreFieldNorm } = this.options;
                        let results = isString(query) ? isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
                        computeScore(results, {
                            ignoreFieldNorm: ignoreFieldNorm
                        });
                        if (shouldSort) results.sort(sortFn);
                        if (isNumber(limit) && limit > -1) results = results.slice(0, limit);
                        return format(results, this._docs, {
                            includeMatches: includeMatches,
                            includeScore: includeScore
                        });
                    }
                    _searchStringList(query) {
                        const searcher = createSearcher(query, this.options);
                        const { records: records } = this._myIndex;
                        const results = [];
                        // Iterate over every string in the index
                        records.forEach(({ v: text, i: idx, n: norm })=>{
                            if (!isDefined(text)) return;
                            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
                            if (isMatch) results.push({
                                item: text,
                                idx: idx,
                                matches: [
                                    {
                                        score: score,
                                        value: text,
                                        norm: norm,
                                        indices: indices
                                    }
                                ]
                            });
                        });
                        return results;
                    }
                    _searchLogical(query) {
                        const expression = parse(query, this.options);
                        const evaluate = (node, item, idx)=>{
                            if (!node.children) {
                                const { keyId: keyId, searcher: searcher } = node;
                                const matches = this._findMatches({
                                    key: this._keyStore.get(keyId),
                                    value: this._myIndex.getValueForItemAtKeyId(item, keyId),
                                    searcher: searcher
                                });
                                if (matches && matches.length) return [
                                    {
                                        idx: idx,
                                        item: item,
                                        matches: matches
                                    }
                                ];
                                return [];
                            }
                            const res = [];
                            for(let i = 0, len = node.children.length; i < len; i += 1){
                                const child = node.children[i];
                                const result = evaluate(child, item, idx);
                                if (result.length) res.push(...result);
                                else if (node.operator === LogicalOperator.AND) return [];
                            }
                            return res;
                        };
                        const records = this._myIndex.records;
                        const resultMap = {};
                        const results = [];
                        records.forEach(({ $: item, i: idx })=>{
                            if (isDefined(item)) {
                                let expResults = evaluate(expression, item, idx);
                                if (expResults.length) {
                                    // Dedupe when adding
                                    if (!resultMap[idx]) {
                                        resultMap[idx] = {
                                            idx: idx,
                                            item: item,
                                            matches: []
                                        };
                                        results.push(resultMap[idx]);
                                    }
                                    expResults.forEach(({ matches: matches })=>{
                                        resultMap[idx].matches.push(...matches);
                                    });
                                }
                            }
                        });
                        return results;
                    }
                    _searchObjectList(query) {
                        const searcher = createSearcher(query, this.options);
                        const { keys: keys, records: records } = this._myIndex;
                        const results = [];
                        // List is Array<Object>
                        records.forEach(({ $: item, i: idx })=>{
                            if (!isDefined(item)) return;
                            let matches = [];
                            // Iterate over every key (i.e, path), and fetch the value at that key
                            keys.forEach((key, keyIndex)=>{
                                matches.push(...this._findMatches({
                                    key: key,
                                    value: item[keyIndex],
                                    searcher: searcher
                                }));
                            });
                            if (matches.length) results.push({
                                idx: idx,
                                item: item,
                                matches: matches
                            });
                        });
                        return results;
                    }
                    _findMatches({ key: key, value: value, searcher: searcher }) {
                        if (!isDefined(value)) return [];
                        let matches = [];
                        if (isArray(value)) value.forEach(({ v: text, i: idx, n: norm })=>{
                            if (!isDefined(text)) return;
                            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
                            if (isMatch) matches.push({
                                score: score,
                                key: key,
                                value: text,
                                idx: idx,
                                norm: norm,
                                indices: indices
                            });
                        });
                        else {
                            const { v: text, n: norm } = value;
                            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
                            if (isMatch) matches.push({
                                score: score,
                                key: key,
                                value: text,
                                norm: norm,
                                indices: indices
                            });
                        }
                        return matches;
                    }
                }
                Fuse.version = '6.6.2';
                Fuse.createIndex = createIndex;
                Fuse.parseIndex = parseIndex;
                Fuse.config = Config;
                Fuse.parseQuery = parse;
                register(ExtendedSearch);
            /***/ },
            /***/ 791: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                // ESM COMPAT FLAG
                __webpack_require__.r(__webpack_exports__);
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    "__DO_NOT_USE__ActionTypes": function() {
                        return /* binding */ ActionTypes;
                    },
                    "applyMiddleware": function() {
                        return /* binding */ applyMiddleware;
                    },
                    "bindActionCreators": function() {
                        return /* binding */ bindActionCreators;
                    },
                    "combineReducers": function() {
                        return /* binding */ combineReducers;
                    },
                    "compose": function() {
                        return /* binding */ compose;
                    },
                    "createStore": function() {
                        return /* binding */ createStore;
                    },
                    "legacy_createStore": function() {
                        return /* binding */ legacy_createStore;
                    }
                });
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                        return typeof obj;
                    } : function(obj) {
                        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    }, _typeof(obj);
                }
                function _toPrimitive(input, hint) {
                    if (_typeof(input) !== "object" || input === null) return input;
                    var prim = input[Symbol.toPrimitive];
                    if (prim !== undefined) {
                        var res = prim.call(input, hint || "default");
                        if (_typeof(res) !== "object") return res;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (hint === "string" ? String : Number)(input);
                }
                function _toPropertyKey(arg) {
                    var key = _toPrimitive(arg, "string");
                    return _typeof(key) === "symbol" ? key : String(key);
                }
                function _defineProperty(obj, key, value) {
                    key = _toPropertyKey(key);
                    if (key in obj) Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                    else obj[key] = value;
                    return obj;
                }
                function ownKeys(object, enumerableOnly) {
                    var keys = Object.keys(object);
                    if (Object.getOwnPropertySymbols) {
                        var symbols = Object.getOwnPropertySymbols(object);
                        enumerableOnly && (symbols = symbols.filter(function(sym) {
                            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                        })), keys.push.apply(keys, symbols);
                    }
                    return keys;
                }
                function _objectSpread2(target) {
                    for(var i = 1; i < arguments.length; i++){
                        var source = null != arguments[i] ? arguments[i] : {};
                        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
                            _defineProperty(target, key, source[key]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                        });
                    }
                    return target;
                }
                /**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function formatProdErrorMessage(code) {
                    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
                }
                // Inlined version of the `symbol-observable` polyfill
                var $$observable = function() {
                    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
                }();
                /**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var randomString = function randomString() {
                    return Math.random().toString(36).substring(7).split('').join('.');
                };
                var ActionTypes = {
                    INIT: "@@redux/INIT" + randomString(),
                    REPLACE: "@@redux/REPLACE" + randomString(),
                    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
                        return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
                    }
                };
                /**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function isPlainObject(obj) {
                    if (typeof obj !== 'object' || obj === null) return false;
                    var proto = obj;
                    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
                    return Object.getPrototypeOf(obj) === proto;
                }
                // Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
                function miniKindOf(val) {
                    if (val === void 0) return 'undefined';
                    if (val === null) return 'null';
                    var type = typeof val;
                    switch(type){
                        case 'boolean':
                        case 'string':
                        case 'number':
                        case 'symbol':
                        case 'function':
                            return type;
                    }
                    if (Array.isArray(val)) return 'array';
                    if (isDate(val)) return 'date';
                    if (isError(val)) return 'error';
                    var constructorName = ctorName(val);
                    switch(constructorName){
                        case 'Symbol':
                        case 'Promise':
                        case 'WeakMap':
                        case 'WeakSet':
                        case 'Map':
                        case 'Set':
                            return constructorName;
                    } // other
                    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
                }
                function ctorName(val) {
                    return typeof val.constructor === 'function' ? val.constructor.name : null;
                }
                function isError(val) {
                    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
                }
                function isDate(val) {
                    if (val instanceof Date) return true;
                    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
                }
                function kindOf(val) {
                    var typeOfVal = typeof val;
                    return typeOfVal;
                }
                /**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function createStore(reducer, preloadedState, enhancer) {
                    var _ref2;
                    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error(formatProdErrorMessage(0));
                    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
                        enhancer = preloadedState;
                        preloadedState = undefined;
                    }
                    if (typeof enhancer !== 'undefined') {
                        if (typeof enhancer !== 'function') throw new Error(formatProdErrorMessage(1));
                        return enhancer(createStore)(reducer, preloadedState);
                    }
                    if (typeof reducer !== 'function') throw new Error(formatProdErrorMessage(2));
                    var currentReducer = reducer;
                    var currentState = preloadedState;
                    var currentListeners = [];
                    var nextListeners = currentListeners;
                    var isDispatching = false;
                    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
                        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
                    }
                    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
                        if (isDispatching) throw new Error(formatProdErrorMessage(3));
                        return currentState;
                    }
                    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
                        if (typeof listener !== 'function') throw new Error(formatProdErrorMessage(4));
                        if (isDispatching) throw new Error(formatProdErrorMessage(5));
                        var isSubscribed = true;
                        ensureCanMutateNextListeners();
                        nextListeners.push(listener);
                        return function unsubscribe() {
                            if (!isSubscribed) return;
                            if (isDispatching) throw new Error(formatProdErrorMessage(6));
                            isSubscribed = false;
                            ensureCanMutateNextListeners();
                            var index = nextListeners.indexOf(listener);
                            nextListeners.splice(index, 1);
                            currentListeners = null;
                        };
                    }
                    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
                        if (!isPlainObject(action)) throw new Error(formatProdErrorMessage(7));
                        if (typeof action.type === 'undefined') throw new Error(formatProdErrorMessage(8));
                        if (isDispatching) throw new Error(formatProdErrorMessage(9));
                        try {
                            isDispatching = true;
                            currentState = currentReducer(currentState, action);
                        } finally{
                            isDispatching = false;
                        }
                        var listeners = currentListeners = nextListeners;
                        for(var i = 0; i < listeners.length; i++){
                            var listener = listeners[i];
                            listener();
                        }
                        return action;
                    }
                    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
                        if (typeof nextReducer !== 'function') throw new Error(formatProdErrorMessage(10));
                        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
                        // Any reducers that existed in both the new and old rootReducer
                        // will receive the previous state. This effectively populates
                        // the new state tree with any relevant data from the old one.
                        dispatch({
                            type: ActionTypes.REPLACE
                        });
                    }
                    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
                        var _ref;
                        var outerSubscribe = subscribe;
                        return _ref = {
                            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                                if (typeof observer !== 'object' || observer === null) throw new Error(formatProdErrorMessage(11));
                                function observeState() {
                                    if (observer.next) observer.next(getState());
                                }
                                observeState();
                                var unsubscribe = outerSubscribe(observeState);
                                return {
                                    unsubscribe: unsubscribe
                                };
                            }
                        }, _ref[$$observable] = function() {
                            return this;
                        }, _ref;
                    } // When a store is created, an "INIT" action is dispatched so that every
                    // reducer returns their initial state. This effectively populates
                    // the initial state tree.
                    dispatch({
                        type: ActionTypes.INIT
                    });
                    return _ref2 = {
                        dispatch: dispatch,
                        subscribe: subscribe,
                        getState: getState,
                        replaceReducer: replaceReducer
                    }, _ref2[$$observable] = observable, _ref2;
                }
                /**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var legacy_createStore = createStore;
                /**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function warning(message) {
                    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
                    /* eslint-enable no-console */ try {
                        // This error was thrown as a convenience so that if you enable
                        // "break on all exceptions" in your console,
                        // it would pause the execution at this line.
                        throw new Error(message);
                    } catch (e) {} // eslint-disable-line no-empty
                }
                function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
                    var reducerKeys = Object.keys(reducers);
                    var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
                    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
                    if (!isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
                    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
                        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
                    });
                    unexpectedKeys.forEach(function(key) {
                        unexpectedKeyCache[key] = true;
                    });
                    if (action && action.type === ActionTypes.REPLACE) return;
                    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
                }
                function assertReducerShape(reducers) {
                    Object.keys(reducers).forEach(function(key) {
                        var reducer = reducers[key];
                        var initialState = reducer(undefined, {
                            type: ActionTypes.INIT
                        });
                        if (typeof initialState === 'undefined') throw new Error(formatProdErrorMessage(12));
                        if (typeof reducer(undefined, {
                            type: ActionTypes.PROBE_UNKNOWN_ACTION()
                        }) === 'undefined') throw new Error(formatProdErrorMessage(13));
                    });
                }
                /**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function combineReducers(reducers) {
                    var reducerKeys = Object.keys(reducers);
                    var finalReducers = {};
                    for(var i = 0; i < reducerKeys.length; i++){
                        var key = reducerKeys[i];
                        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
                    }
                    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
                    // keys multiple times.
                    var unexpectedKeyCache;
                    var shapeAssertionError;
                    try {
                        assertReducerShape(finalReducers);
                    } catch (e) {
                        shapeAssertionError = e;
                    }
                    return function combination(state, action) {
                        if (state === void 0) state = {};
                        if (shapeAssertionError) throw shapeAssertionError;
                        var warningMessage;
                        var hasChanged = false;
                        var nextState = {};
                        for(var _i = 0; _i < finalReducerKeys.length; _i++){
                            var _key = finalReducerKeys[_i];
                            var reducer = finalReducers[_key];
                            var previousStateForKey = state[_key];
                            var nextStateForKey = reducer(previousStateForKey, action);
                            if (typeof nextStateForKey === 'undefined') {
                                var actionType = action && action.type;
                                throw new Error(formatProdErrorMessage(14));
                            }
                            nextState[_key] = nextStateForKey;
                            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
                        }
                        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
                        return hasChanged ? nextState : state;
                    };
                }
                function bindActionCreator(actionCreator, dispatch) {
                    return function() {
                        return dispatch(actionCreator.apply(this, arguments));
                    };
                }
                /**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function bindActionCreators(actionCreators, dispatch) {
                    if (typeof actionCreators === 'function') return bindActionCreator(actionCreators, dispatch);
                    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error(formatProdErrorMessage(16));
                    var boundActionCreators = {};
                    for(var key in actionCreators){
                        var actionCreator = actionCreators[key];
                        if (typeof actionCreator === 'function') boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
                    }
                    return boundActionCreators;
                }
                /**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function compose() {
                    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
                    if (funcs.length === 0) return function(arg) {
                        return arg;
                    };
                    if (funcs.length === 1) return funcs[0];
                    return funcs.reduce(function(a, b) {
                        return function() {
                            return a(b.apply(void 0, arguments));
                        };
                    });
                }
                /**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function applyMiddleware() {
                    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
                    return function(createStore) {
                        return function() {
                            var store = createStore.apply(void 0, arguments);
                            var _dispatch = function dispatch() {
                                throw new Error(formatProdErrorMessage(15));
                            };
                            var middlewareAPI = {
                                getState: store.getState,
                                dispatch: function dispatch() {
                                    return _dispatch.apply(void 0, arguments);
                                }
                            };
                            var chain = middlewares.map(function(middleware) {
                                return middleware(middlewareAPI);
                            });
                            _dispatch = compose.apply(void 0, chain)(store.dispatch);
                            return _objectSpread2(_objectSpread2({}, store), {}, {
                                dispatch: _dispatch
                            });
                        };
                    };
                }
                /*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */ function isCrushed() {}
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/compat get default export */ /******/ !function() {
            /******/ // getDefaultExport function for compatibility with non-harmony modules
            /******/ __webpack_require__.n = function(module1) {
                /******/ var getter = module1 && module1.__esModule ? /******/ function() {
                    return module1['default'];
                } : /******/ function() {
                    return module1;
                };
                /******/ __webpack_require__.d(getter, {
                    a: getter
                });
                /******/ return getter;
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/define property getters */ /******/ !function() {
            /******/ // define getter functions for harmony exports
            /******/ __webpack_require__.d = function(exports, definition) {
                /******/ for(var key in definition)/******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                });
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ !function() {
            /******/ __webpack_require__.o = function(obj, prop) {
                return Object.prototype.hasOwnProperty.call(obj, prop);
            };
        /******/ }();
        /******/ /******/ /* webpack/runtime/make namespace object */ /******/ !function() {
            /******/ // define __esModule on exports
            /******/ __webpack_require__.r = function(exports) {
                /******/ if (typeof Symbol !== 'undefined' && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                    value: 'Module'
                });
                /******/ Object.defineProperty(exports, '__esModule', {
                    value: true
                });
            /******/ };
        /******/ }();
        /******/ /************************************************************************/ var __webpack_exports__ = {};
        // This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
        !function() {
            /* harmony import */ var _scripts_choices__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(373);
            /* harmony import */ var _scripts_choices__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_scripts_choices__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _scripts_interfaces__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(187);
            /* harmony import */ var _scripts_interfaces__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(_scripts_interfaces__WEBPACK_IMPORTED_MODULE_1__);
            /* harmony import */ var _scripts_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(883);
            /* harmony import */ var _scripts_defaults__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(789);
            /* harmony import */ var _scripts_templates__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(686);
            /* harmony default export */ __webpack_exports__["default"] = _scripts_choices__WEBPACK_IMPORTED_MODULE_0___default();
        }();
        __webpack_exports__ = __webpack_exports__["default"];
        /******/ return __webpack_exports__;
    /******/ }();
});


/*
 leaflet.responsive.popup 1.0.0
 (c) 20222 https://github.com/yafred
*/ var $c9fbb13121e97103$export$ccfdee0fbd1573b;
var $c9fbb13121e97103$export$713eca98442a58b5;
L.ResponsivePopup = L.Popup.extend({
    options: {
        hasTip: true
    },
    /**
	 * Overrides https://github.com/Leaflet/Leaflet/blob/399ed2105220f10b79e69b57420597e03502e611/src/layer/Popup.js#L183
	 * This is to add hasTip option
	 */ _initLayout: function() {
        var prefix = 'leaflet-popup', container = this._container = L.DomUtil.create('div', prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-animated');
        var wrapper = this._wrapper = L.DomUtil.create('div', prefix + '-content-wrapper', container);
        this._contentNode = L.DomUtil.create('div', prefix + '-content', wrapper);
        L.DomEvent.disableClickPropagation(container);
        L.DomEvent.disableScrollPropagation(this._contentNode);
        L.DomEvent.on(container, 'contextmenu', L.DomEvent.stopPropagation);
        this._tipContainer = L.DomUtil.create('div', prefix + '-tip-container', container);
        if (!this.options.hasTip) this._tipContainer.style.visibility = 'hidden';
        this._tip = L.DomUtil.create('div', prefix + '-tip', this._tipContainer);
        if (this.options.closeButton) {
            var closeButton = this._closeButton = L.DomUtil.create('a', prefix + '-close-button', container);
            closeButton.setAttribute('role', 'button'); // overrides the implicit role=link of <a> elements #7399
            closeButton.setAttribute('aria-label', 'Close popup');
            closeButton.href = '#close';
            closeButton.innerHTML = '<span aria-hidden="true">&#215;</span>';
            L.DomEvent.on(closeButton, 'click', function(ev) {
                L.DomEvent.preventDefault(ev);
                this.close();
            }, this);
        }
    },
    /**
	 * Overrides https://github.com/Leaflet/Leaflet/blob/v1.3.4/src/layer/DivOverlay.js#L178
	 */ _updatePosition: function() {
        if (!this._map) return;
        var pos = this._map.latLngToLayerPoint(this._latlng), basePoint = this._map.layerPointToContainerPoint(pos), containerWidth = this._container.offsetWidth, containerHeight = this._container.offsetHeight, padding = L.point(this.options.autoPanPadding), paddingTL = L.point(this.options.autoPanPaddingTopLeft || padding), paddingBR = L.point(this.options.autoPanPaddingBottomRight || padding), mapSize = this._map.getSize(), anchor = this._getAnchor(), offset = L.point(this.options.offset); // offset relative to anchor (option from L.DivOverlay. We only use absolute values).
        // Leaflet default dimensions (should not be hard coded in the future)
        var tipHeight = 11; //px
        var tipWidth = 22; //px
        var containerRadius = 12; //px  
        // Tweak offset to include tip dimensions 
        var offsetX = Math.abs(offset.x);
        var offsetY = Math.abs(offset.y);
        if (this.options.hasTip) {
            offsetX += tipHeight;
            offsetY += tipHeight;
            // clear CSS
            L.DomUtil.removeClass(this._container, 'leaflet-resp-popup-north');
            L.DomUtil.removeClass(this._container, 'leaflet-resp-popup-south');
            L.DomUtil.removeClass(this._container, 'leaflet-resp-popup-east');
            L.DomUtil.removeClass(this._container, 'leaflet-resp-popup-west');
            L.DomUtil.removeClass(this._container, 'leaflet-resp-popup-north-east');
            L.DomUtil.removeClass(this._container, 'leaflet-resp-popup-north-west');
            L.DomUtil.removeClass(this._container, 'leaflet-resp-popup-south-east');
            L.DomUtil.removeClass(this._container, 'leaflet-resp-popup-south-west');
            L.DomUtil.removeClass(this._container, 'leaflet-resp-popup-east-north');
            L.DomUtil.removeClass(this._container, 'leaflet-resp-popup-east-south');
            L.DomUtil.removeClass(this._container, 'leaflet-resp-popup-west-north');
            L.DomUtil.removeClass(this._container, 'leaflet-resp-popup-west-south');
        // this._container.style.display = 'initial'; // this does not work
        }
        // Where can we fit the popup ?
        var canGoTop = true, canGoBottom = true, canGoLeft = true, canGoRight = true, containerPos = false;
        if (basePoint.y + anchor.y - offsetY - containerHeight - Math.abs(paddingTL.y) < 0) canGoTop = false;
        if (basePoint.y + anchor.y + offsetY + containerHeight + Math.abs(paddingBR.y) > mapSize.y) canGoBottom = false;
        if (basePoint.x + anchor.x - offsetX - containerWidth - Math.abs(paddingTL.x) < 0) canGoLeft = false;
        if (basePoint.x + anchor.x + offsetX + containerWidth + Math.abs(paddingBR.x) > mapSize.x) canGoRight = false;
        // manage overflows
        var subtractX = containerWidth / 2 - anchor.x, subtractY = containerHeight / 2 - anchor.y;
        if (canGoTop || canGoBottom) {
            var containerLeft = basePoint.x + anchor.x - containerWidth / 2;
            var containerRight = basePoint.x + anchor.x + containerWidth / 2;
            if (containerLeft < Math.abs(paddingTL.x)) subtractX = containerWidth / 2 - anchor.x - Math.abs(paddingTL.x) + containerLeft;
            if (containerRight > mapSize.x - Math.abs(paddingBR.x)) subtractX = containerWidth / 2 - anchor.x + containerRight - mapSize.x + Math.abs(paddingBR.x);
        }
        if (canGoLeft || canGoRight) {
            var containerTop = basePoint.y + anchor.y - containerHeight / 2;
            var containerBottom = basePoint.y + anchor.y + containerHeight / 2;
            if (containerTop < Math.abs(paddingTL.y)) subtractY = containerHeight / 2 - anchor.y - Math.abs(paddingTL.y) + containerTop;
            if (containerBottom > mapSize.y - Math.abs(paddingBR.y)) subtractY = containerHeight / 2 - anchor.y + containerBottom - mapSize.y + Math.abs(paddingBR.y);
        }
        // position the popup (order of preference is: top, left, bottom, right, centerOnMap)
        if (canGoTop) {
            containerPos = pos.subtract(L.point(subtractX, -anchor.y + containerHeight + offsetY, true));
            if (this.options.hasTip) {
                if (basePoint.x + anchor.x < paddingTL.x + containerRadius + tipWidth / 2) {
                    containerPos.x = pos.x + anchor.x;
                    L.DomUtil.addClass(this._container, 'leaflet-resp-popup-north-east');
                    this._tipContainer.style.top = containerHeight + 'px';
                    this._tipContainer.style.left = '0px';
                } else if (basePoint.x + anchor.x > mapSize.x - paddingBR.x - containerRadius - tipWidth / 2) {
                    containerPos.x = pos.x + anchor.x - containerWidth;
                    L.DomUtil.addClass(this._container, 'leaflet-resp-popup-north-west');
                    this._tipContainer.style.top = containerHeight + 'px';
                    this._tipContainer.style.left = containerWidth + 'px';
                } else {
                    L.DomUtil.addClass(this._container, 'leaflet-resp-popup-north');
                    this._tipContainer.style.top = containerHeight + 'px';
                    this._tipContainer.style.left = pos.x + anchor.x - containerPos.x + 'px';
                }
            }
        } else if (canGoLeft) {
            containerPos = pos.subtract(L.point(-anchor.x + containerWidth + offsetX, subtractY, true));
            if (this.options.hasTip) {
                if (basePoint.y + anchor.y < paddingTL.y + containerRadius + tipWidth / 2) {
                    containerPos.y = pos.y + anchor.y;
                    L.DomUtil.addClass(this._container, 'leaflet-resp-popup-west-south');
                    this._tipContainer.style.top = '0px';
                    this._tipContainer.style.left = containerWidth + 'px';
                } else if (basePoint.y + anchor.y > mapSize.y - paddingBR.y - containerRadius - tipWidth / 2) {
                    containerPos.y = pos.y + anchor.y - containerHeight;
                    L.DomUtil.addClass(this._container, 'leaflet-resp-popup-west-north');
                    this._tipContainer.style.top = containerHeight + 'px';
                    this._tipContainer.style.left = containerWidth + 'px';
                } else {
                    L.DomUtil.addClass(this._container, 'leaflet-resp-popup-west');
                    this._tipContainer.style.top = pos.y + anchor.y - containerPos.y + 'px';
                    this._tipContainer.style.left = containerWidth + 'px';
                }
            }
        } else if (canGoBottom) {
            containerPos = pos.subtract(L.point(subtractX, -anchor.y - offsetY, true));
            if (this.options.hasTip) {
                if (basePoint.x + anchor.x < paddingTL.x + containerRadius + tipWidth / 2) {
                    containerPos.x = pos.x + anchor.x;
                    L.DomUtil.addClass(this._container, 'leaflet-resp-popup-south-east');
                    this._tipContainer.style.top = '0px';
                    this._tipContainer.style.left = '0px';
                } else if (basePoint.x + anchor.x > mapSize.x - paddingBR.x - containerRadius - tipWidth / 2) {
                    containerPos.x = pos.x + anchor.x - containerWidth;
                    L.DomUtil.addClass(this._container, 'leaflet-resp-popup-south-west');
                    this._tipContainer.style.top = '0px';
                    this._tipContainer.style.left = containerWidth + 'px';
                } else {
                    L.DomUtil.addClass(this._container, 'leaflet-resp-popup-south');
                    this._tipContainer.style.top = '0px';
                    this._tipContainer.style.left = pos.x + anchor.x - containerPos.x + 'px';
                }
            }
        } else if (canGoRight) {
            containerPos = pos.subtract(L.point(-anchor.x - offsetX, subtractY, true));
            if (this.options.hasTip) {
                if (basePoint.y + anchor.y < paddingTL.y + containerRadius + tipWidth / 2) {
                    containerPos.y = pos.y + anchor.y;
                    L.DomUtil.addClass(this._container, 'leaflet-resp-popup-east-south');
                    this._tipContainer.style.top = '0px';
                    this._tipContainer.style.left = '0px';
                } else if (basePoint.y + anchor.y > mapSize.y - paddingBR.y - containerRadius - tipWidth / 2) {
                    containerPos.y = pos.y + anchor.y - containerHeight;
                    L.DomUtil.addClass(this._container, 'leaflet-resp-popup-east-north');
                    this._tipContainer.style.top = containerHeight + 'px';
                    this._tipContainer.style.left = '0px';
                } else {
                    L.DomUtil.addClass(this._container, 'leaflet-resp-popup-east');
                    this._tipContainer.style.top = pos.y + anchor.y - containerPos.y + 'px';
                    this._tipContainer.style.left = '0px';
                }
            }
        } else {
            var pos = this._map.latLngToLayerPoint(this._map.getCenter());
            containerPos = pos.subtract(L.point(containerWidth / 2, containerHeight / 2));
            this.options.hasTip;
        }
        // if point is not visible, just hide the popup
        basePoint.x < 0 || basePoint.y < 0 || basePoint.x > mapSize.x || (basePoint.y, mapSize.y);
        // if container is too big, just hide the popup
        containerWidth - Math.abs(paddingTL.x) - Math.abs(paddingBR.x) > mapSize.x || (paddingTL.y, paddingBR.y, mapSize.y);
        L.DomUtil.setPosition(this._container, containerPos);
    }
});
//Instantiates a `ResponsivePopup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
L.responsivePopup = function(options, source) {
    return new L.ResponsivePopup(options, source);
};
$c9fbb13121e97103$export$ccfdee0fbd1573b = L.responsivePopup;
$c9fbb13121e97103$export$713eca98442a58b5 = L.ResponsivePopup;


var $549f5169b246c417$exports = {};
!function(e, t) {
    t($549f5169b246c417$exports);
}($549f5169b246c417$exports, function(e) {
    "use strict";
    var t = "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {};
    function n(e, t) {
        return e(t = {
            exports: {}
        }, t.exports), t.exports;
    }
    var o = n(function(e, n) {
        !function(t) {
            const n = {
                escape: function(e) {
                    return e.replace(/([.*+?^${}()|\[\]\/\\])/g, "\\$1");
                },
                parseExtension: o,
                mimeType: function(e) {
                    return e = o(e).toLowerCase(), function() {
                        var e = "application/font-woff", t = "image/jpeg";
                        return {
                            woff: e,
                            woff2: e,
                            ttf: "application/font-truetype",
                            eot: "application/vnd.ms-fontobject",
                            png: "image/png",
                            jpg: t,
                            jpeg: t,
                            gif: "image/gif",
                            tiff: "image/tiff",
                            svg: "image/svg+xml"
                        };
                    }()[e] || "";
                },
                dataAsUrl: function(e, t) {
                    return `data:${t};base64,` + e;
                },
                isDataUrl: function(e) {
                    return -1 !== e.search(/^(data:)/);
                },
                canvasToBlob: function(e) {
                    var t;
                    return e.toBlob ? new Promise(function(t) {
                        e.toBlob(t);
                    }) : (t = e, new Promise(function(e) {
                        const n = d(t.toDataURL().split(",")[1]);
                        var o = n.length;
                        const r = new Uint8Array(o);
                        for(let e = 0; e < o; e++)r[e] = n.charCodeAt(e);
                        e(new Blob([
                            r
                        ], {
                            type: "image/png"
                        }));
                    }));
                },
                resolveUrl: function(e, t) {
                    const n = document.implementation.createHTMLDocument(), o = n.createElement("base"), r = (n.head.appendChild(o), n.createElement("a"));
                    return n.body.appendChild(r), o.href = t, r.href = e, r.href;
                },
                getAndEncode: function(e) {
                    let t = h.impl.urlCache.find(function(t) {
                        return t.url === e;
                    });
                    return t || (t = {
                        url: e,
                        promise: null
                    }, h.impl.urlCache.push(t)), null === t.promise && (h.impl.options.cacheBust && (e += (/\?/.test(e) ? "&" : "?") + (new Date).getTime()), t.promise = new Promise(function(t) {
                        const n = h.impl.options.httpTimeout, o = new XMLHttpRequest;
                        let r;
                        var i;
                        function a(e) {
                            console.error(e), t("");
                        }
                        o.onreadystatechange = function() {
                            if (4 === o.readyState) {
                                if (200 !== o.status) r ? t(r) : a(`cannot fetch resource: ${e}, status: ` + o.status);
                                else {
                                    const e = new FileReader;
                                    e.onloadend = function() {
                                        var n = e.result.split(/,/)[1];
                                        t(n);
                                    }, e.readAsDataURL(o.response);
                                }
                            }
                        }, o.ontimeout = function() {
                            r ? t(r) : a(`timeout of ${n}ms occured while fetching resource: ` + e);
                        }, o.responseType = "blob", o.timeout = n, h.impl.options.useCredentials && (o.withCredentials = !0), o.open("GET", e, !0), o.send(), h.impl.options.imagePlaceholder && (i = h.impl.options.imagePlaceholder.split(/,/)) && i[1] && (r = i[1]);
                    })), t.promise;
                },
                uid: function() {
                    let e = 0;
                    return function() {
                        return "u" + ("0000" + (Math.random() * Math.pow(36, 4) << 0).toString(36)).slice(-4) + e++;
                    };
                }(),
                delay: function(e) {
                    return function(t) {
                        return new Promise(function(n) {
                            setTimeout(function() {
                                n(t);
                            }, e);
                        });
                    };
                },
                asArray: function(e) {
                    const t = [], n = e.length;
                    for(let o = 0; o < n; o++)t.push(e[o]);
                    return t;
                },
                escapeXhtml: function(e) {
                    return e.replace(/%/g, "%25").replace(/#/g, "%23").replace(/\n/g, "%0A");
                },
                makeImage: function(e) {
                    return "data:," !== e ? new Promise(function(t, n) {
                        const o = new Image;
                        h.impl.options.useCredentials && (o.crossOrigin = "use-credentials"), o.onload = function() {
                            t(o);
                        }, o.onerror = n, o.src = e;
                    }) : Promise.resolve();
                },
                width: function(e) {
                    var t = r(e, "border-left-width"), n = r(e, "border-right-width");
                    return e.scrollWidth + t + n;
                },
                height: function(e) {
                    var t = r(e, "border-top-width"), n = r(e, "border-bottom-width");
                    return e.scrollHeight + t + n;
                }
            };
            function o(e) {
                return (e = /\.([^\.\/]*?)(\?|$)/g.exec(e)) ? e[1] : "";
            }
            function r(e, t) {
                const n = f(e).getPropertyValue(t);
                return parseFloat(n.replace("px", ""));
            }
            const i = function() {
                const e = /url\(['"]?([^'"]+?)['"]?\)/g;
                return {
                    inlineAll: function(e, n, i) {
                        return t(e) ? Promise.resolve(e).then(o).then(function(t) {
                            let o = Promise.resolve(e);
                            return t.forEach(function(e) {
                                o = o.then(function(t) {
                                    return r(t, e, n, i);
                                });
                            }), o;
                        }) : Promise.resolve(e);
                    },
                    shouldProcess: t,
                    impl: {
                        readUrls: o,
                        inline: r
                    }
                };
                function t(t) {
                    return -1 !== t.search(e);
                }
                function o(t) {
                    const o = [];
                    for(var r; null !== (r = e.exec(t));)o.push(r[1]);
                    return o.filter(function(e) {
                        return !n.isDataUrl(e);
                    });
                }
                function r(e, t, o, r) {
                    return Promise.resolve(t).then(function(e) {
                        return o ? n.resolveUrl(e, o) : e;
                    }).then(r || n.getAndEncode).then(function(e) {
                        return n.dataAsUrl(e, n.mimeType(t));
                    }).then(function(o) {
                        var r;
                        return e.replace((r = t, new RegExp(`(url\\(['"]?)(${n.escape(r)})(['"]?\\))`, "g")), `$1${o}$3`);
                    });
                }
            }(), a = {
                resolveAll: function() {
                    return s().then(function(e) {
                        return Promise.all(e.map(function(e) {
                            return e.resolve();
                        }));
                    }).then(function(e) {
                        return e.join("\n");
                    });
                },
                impl: {
                    readAll: s
                }
            };
            function s() {
                return Promise.resolve(n.asArray(document.styleSheets)).then(function(e) {
                    const t = [];
                    return e.forEach(function(e) {
                        if (Object.getPrototypeOf(e).hasOwnProperty("cssRules")) try {
                            n.asArray(e.cssRules || []).forEach(t.push.bind(t));
                        } catch (t) {
                            console.log("Error while reading CSS rules from " + e.href, t.toString());
                        }
                    }), t;
                }).then(function(e) {
                    return e.filter(function(e) {
                        return e.type === CSSRule.FONT_FACE_RULE;
                    }).filter(function(e) {
                        return i.shouldProcess(e.style.getPropertyValue("src"));
                    });
                }).then(function(t) {
                    return t.map(e);
                });
                function e(e) {
                    return {
                        resolve: function() {
                            var t = (e.parentStyleSheet || {}).href;
                            return i.inlineAll(e.cssText, t);
                        },
                        src: function() {
                            return e.style.getPropertyValue("src");
                        }
                    };
                }
            }
            const c = {
                inlineAll: function e(t) {
                    return t instanceof Element ? (function(e) {
                        const t = e.style.getPropertyValue("background");
                        return t ? i.inlineAll(t).then(function(n) {
                            e.style.setProperty("background", n, t);
                        }).then(function() {
                            return e;
                        }) : Promise.resolve(e);
                    })(t).then(function() {
                        return t instanceof HTMLImageElement ? l(t).inline() : Promise.all(n.asArray(t.childNodes).map(function(t) {
                            return e(t);
                        }));
                    }) : Promise.resolve(t);
                },
                impl: {
                    newImage: l
                }
            };
            function l(e) {
                return {
                    inline: function(t) {
                        return n.isDataUrl(e.src) ? Promise.resolve() : Promise.resolve(e.src).then(t || n.getAndEncode).then(function(t) {
                            return n.dataAsUrl(t, n.mimeType(e.src));
                        }).then(function(t) {
                            return new Promise(function(n) {
                                e.onload = n, e.onerror = n, e.src = t;
                            });
                        });
                    }
                };
            }
            const u = {
                imagePlaceholder: void 0,
                cacheBust: !1,
                useCredentials: !1,
                httpTimeout: 3e4
            }, h = {
                toSvg: p,
                toPng: function(e, t) {
                    return (t = t || {}).raster = !0, m(e, t).then(function(e) {
                        return e.toDataURL();
                    });
                },
                toJpeg: function(e, t) {
                    return (t = t || {}).raster = !0, m(e, t).then(function(e) {
                        return e.toDataURL("image/jpeg", t.quality || 1);
                    });
                },
                toBlob: function(e, t) {
                    return (t = t || {}).raster = !0, m(e, t).then(n.canvasToBlob);
                },
                toPixelData: function(e, t) {
                    return (t = t || {}).raster = !0, m(e, t).then(function(t) {
                        return t.getContext("2d").getImageData(0, 0, n.width(e), n.height(e)).data;
                    });
                },
                toCanvas: function(e, t) {
                    return (t = t || {}).raster = !0, m(e, t || {});
                },
                impl: {
                    fontFaces: a,
                    images: c,
                    util: n,
                    inliner: i,
                    urlCache: [],
                    options: {}
                }
            }, f = (e.exports = h, t.getComputedStyle || window.getComputedStyle), d = t.atob || window.atob;
            function p(e, t) {
                var o = t = t || {};
                return void 0 === o.imagePlaceholder ? h.impl.options.imagePlaceholder = u.imagePlaceholder : h.impl.options.imagePlaceholder = o.imagePlaceholder, void 0 === o.cacheBust ? h.impl.options.cacheBust = u.cacheBust : h.impl.options.cacheBust = o.cacheBust, void 0 === o.useCredentials ? h.impl.options.useCredentials = u.useCredentials : h.impl.options.useCredentials = o.useCredentials, Promise.resolve(e).then(function(e) {
                    return function e(t, o, r, i, a = null) {
                        return r || !o || o(t) ? Promise.resolve(t).then(function(e) {
                            return e instanceof HTMLCanvasElement ? n.makeImage(e.toDataURL()) : "IFRAME" === e.nodeName ? html2canvas(e.contentDocument.body).then((e)=>e.toDataURL()).then(n.makeImage) : e.cloneNode(!1);
                        }).then(function(r) {
                            return function(t, r) {
                                const a = t.childNodes;
                                return 0 === a.length ? Promise.resolve(r) : (function(n, r) {
                                    const a = f(t);
                                    let s = Promise.resolve();
                                    return r.forEach(function(t) {
                                        s = s.then(function() {
                                            return e(t, o, !1, i, a);
                                        }).then(function(e) {
                                            e && n.appendChild(e);
                                        });
                                    }), s;
                                })(r, n.asArray(a)).then(function() {
                                    return r;
                                });
                            }(t, r);
                        }).then(function(e) {
                            return function(e, t, o) {
                                return t instanceof Element ? Promise.resolve().then(function() {
                                    !function(e, t) {
                                        const i = f(e);
                                        i.cssText ? (t.style.cssText = i.cssText, function(e, t) {
                                            t.font = e.font, t.fontFamily = e.fontFamily, t.fontFeatureSettings = e.fontFeatureSettings, t.fontKerning = e.fontKerning, t.fontSize = e.fontSize, t.fontStretch = e.fontStretch, t.fontStyle = e.fontStyle, t.fontVariant = e.fontVariant, t.fontVariantCaps = e.fontVariantCaps, t.fontVariantEastAsian = e.fontVariantEastAsian, t.fontVariantLigatures = e.fontVariantLigatures, t.fontVariantNumeric = e.fontVariantNumeric, t.fontVariationSettings = e.fontVariationSettings, t.fontWeight = e.fontWeight;
                                        }(i, t.style)) : (o ? function(e, t, n, o) {
                                            const r = n.style, i = e.style;
                                            for (var a of t){
                                                var s = t.getPropertyValue(a), c = i.getPropertyValue(a), l = (i.setProperty(a, o ? "initial" : "unset"), t.getPropertyValue(a));
                                                l !== s ? r.setProperty(a, s) : r.removeProperty(a), i.setProperty(a, c);
                                            }
                                        }(e, i, t, r) : function(e, t, o) {
                                            const r = function(e) {
                                                if (v[e]) return v[e];
                                                y || ((y = document.createElement("iframe")).style.visibility = "hidden", y.style.position = "fixed", document.body.appendChild(y), y.contentWindow.document.write('<!DOCTYPE html><meta charset="UTF-8"><title>sandbox</title><body>'));
                                                const t = document.createElement(e), o = (y.contentWindow.document.body.appendChild(t), t.textContent = ".", y.contentWindow.getComputedStyle(t)), r = {};
                                                return n.asArray(o).forEach(function(e) {
                                                    r[e] = "width" === e || "height" === e ? "auto" : o.getPropertyValue(e);
                                                }), y.contentWindow.document.body.removeChild(t), v[e] = r;
                                            }(o.tagName), i = o.style;
                                            n.asArray(e).forEach(function(n) {
                                                var o = e.getPropertyValue(n);
                                                (o !== r[n] || t && o !== t.getPropertyValue(n)) && i.setProperty(n, o, e.getPropertyPriority(n));
                                            });
                                        }(i, a, t), r && ([
                                            "inset-block",
                                            "inset-block-start",
                                            "inset-block-end"
                                        ].forEach((e)=>t.style.removeProperty(e)), [
                                            "left",
                                            "right",
                                            "top",
                                            "bottom"
                                        ].forEach((e)=>{
                                            t.style.getPropertyValue(e) && t.style.setProperty(e, "0px");
                                        })));
                                    }(e, t);
                                }).then(function() {
                                    [
                                        ":before",
                                        ":after"
                                    ].forEach(function(o) {
                                        !function(o) {
                                            const r = f(e, o), i = r.getPropertyValue("content");
                                            if ("" !== i && "none" !== i) {
                                                const e = n.uid(), i = t.getAttribute("class"), a = (i && t.setAttribute("class", i + " " + e), document.createElement("style"));
                                                a.appendChild(function() {
                                                    const t = `.${e}:` + o, i = (r.cssText ? function() {
                                                        return `${r.cssText} content: ${r.getPropertyValue("content")};`;
                                                    } : function() {
                                                        return n.asArray(r).map(function(e) {
                                                            return e + ": " + r.getPropertyValue(e) + (r.getPropertyPriority(e) ? " !important" : "");
                                                        }).join("; ") + ";";
                                                    })();
                                                    return document.createTextNode(t + `{${i}}`);
                                                }()), t.appendChild(a);
                                            }
                                        }(o);
                                    });
                                }).then(function() {
                                    e instanceof HTMLTextAreaElement && (t.innerHTML = e.value), e instanceof HTMLInputElement && t.setAttribute("value", e.value);
                                }).then(function() {
                                    t instanceof SVGElement && (t.setAttribute("xmlns", "http://www.w3.org/2000/svg"), t instanceof SVGRectElement && [
                                        "width",
                                        "height"
                                    ].forEach(function(e) {
                                        const n = t.getAttribute(e);
                                        n && t.style.setProperty(e, n);
                                    }));
                                }).then(function() {
                                    return t;
                                }) : t;
                            }(t, e, i);
                        }) : Promise.resolve();
                    }(e, t.filter, !0, !t.raster);
                }).then(g).then(w).then(function(e) {
                    t.bgcolor && (e.style.backgroundColor = t.bgcolor), t.width && (e.style.width = t.width + "px"), t.height && (e.style.height = t.height + "px"), t.style && Object.keys(t.style).forEach(function(n) {
                        e.style[n] = t.style[n];
                    });
                    let n = null;
                    return "function" == typeof t.onclone && (n = t.onclone(e)), Promise.resolve(n).then(function() {
                        return e;
                    });
                }).then(function(o) {
                    var r, i;
                    return o, r = t.width || n.width(e), i = t.height || n.height(e), Promise.resolve(o).then(function(e) {
                        return e.setAttribute("xmlns", "http://www.w3.org/1999/xhtml"), (new XMLSerializer).serializeToString(e);
                    }).then(n.escapeXhtml).then(function(e) {
                        return `<foreignObject x="0" y="0" width="100%" height="100%">${e}</foreignObject>`;
                    }).then(function(e) {
                        return `<svg xmlns="http://www.w3.org/2000/svg" width="${r}" height="${i}">${e}</svg>`;
                    }).then(function(e) {
                        return "data:image/svg+xml;charset=utf-8," + e;
                    });
                }).then(function(e) {
                    return h.impl.urlCache = [], e;
                });
            }
            function m(e, t) {
                return p(e, t).then(n.makeImage).then(n.delay(0)).then(function(o) {
                    var r = "number" != typeof t.scale ? 1 : t.scale;
                    const i = function(e, o) {
                        const r = document.createElement("canvas");
                        if (r.width = (t.width || n.width(e)) * o, r.height = (t.height || n.height(e)) * o, t.bgcolor) {
                            const e = r.getContext("2d");
                            e.fillStyle = t.bgcolor, e.fillRect(0, 0, r.width, r.height);
                        }
                        return r;
                    }(e, r), a = i.getContext("2d");
                    return a.mozImageSmoothingEnabled = !1, a.msImageSmoothingEnabled = !1, a.imageSmoothingEnabled = !1, o && (a.scale(r, r), a.drawImage(o, 0, 0)), y && (document.body.removeChild(y), y = null, M && clearTimeout(M), M = setTimeout(()=>{
                        M = null, v = {};
                    }, 2e4)), i;
                });
            }
            function g(e) {
                return a.resolveAll().then(function(t) {
                    const n = document.createElement("style");
                    return e.appendChild(n), n.appendChild(document.createTextNode(t)), e;
                });
            }
            function w(e) {
                return c.inlineAll(e).then(function() {
                    return e;
                });
            }
            let M = null, y = null, v = {};
        }(t);
    }), r = n(function(e, n) {
        (function() {
            function n(e, t, n) {
                var o = new XMLHttpRequest;
                o.open("GET", e), o.responseType = "blob", o.onload = function() {
                    a(o.response, t, n);
                }, o.onerror = function() {
                    console.error("could not download file");
                }, o.send();
            }
            function o(e) {
                var t = new XMLHttpRequest;
                t.open("HEAD", e, !1);
                try {
                    t.send();
                } catch (e) {}
                return 200 <= t.status && 299 >= t.status;
            }
            function r(e) {
                try {
                    e.dispatchEvent(new MouseEvent("click"));
                } catch (n) {
                    var t = document.createEvent("MouseEvents");
                    t.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), e.dispatchEvent(t);
                }
            }
            var i = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof t && t.global === t ? t : void 0, a = i.saveAs || ("object" != typeof window || window !== i ? function() {} : "download" in HTMLAnchorElement.prototype ? function(e, t, a) {
                var s = i.URL || i.webkitURL, c = document.createElement("a");
                t = t || e.name || "download", c.download = t, c.rel = "noopener", "string" == typeof e ? (c.href = e, c.origin === location.origin ? r(c) : o(c.href) ? n(e, t, a) : r(c, c.target = "_blank")) : (c.href = s.createObjectURL(e), setTimeout(function() {
                    s.revokeObjectURL(c.href);
                }, 4e4), setTimeout(function() {
                    r(c);
                }, 0));
            } : "msSaveOrOpenBlob" in navigator ? function(e, t, i) {
                if (t = t || e.name || "download", "string" != typeof e) navigator.msSaveOrOpenBlob(function(e, t) {
                    return void 0 === t ? t = {
                        autoBom: !1
                    } : "object" != typeof t && (console.warn("Deprecated: Expected third argument to be a object"), t = {
                        autoBom: !t
                    }), t.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(e.type) ? new Blob([
                        "\ufeff",
                        e
                    ], {
                        type: e.type
                    }) : e;
                }(e, i), t);
                else if (o(e)) n(e, t, i);
                else {
                    var a = document.createElement("a");
                    a.href = e, a.target = "_blank", setTimeout(function() {
                        r(a);
                    });
                }
            } : function(e, t, o, r) {
                if ((r = r || open("", "_blank")) && (r.document.title = r.document.body.innerText = "downloading..."), "string" == typeof e) return n(e, t, o);
                var a = "application/octet-stream" === e.type, s = /constructor/i.test(i.HTMLElement) || i.safari, c = /CriOS\/[\d]+/.test(navigator.userAgent);
                if ((c || a && s) && "object" == typeof FileReader) {
                    var l = new FileReader;
                    l.onloadend = function() {
                        var e = l.result;
                        e = c ? e : e.replace(/^data:[^;]*;/, "data:attachment/file;"), r ? r.location.href = e : location = e, r = null;
                    }, l.readAsDataURL(e);
                } else {
                    var u = i.URL || i.webkitURL, h = u.createObjectURL(e);
                    r ? r.location = h : location.href = h, r = null, setTimeout(function() {
                        u.revokeObjectURL(h);
                    }, 4e4);
                }
            });
            i.saveAs = a.saveAs = a, e.exports = a;
        })();
    }), i = L.Control.extend({
        options: {
            cropImageByInnerWH: !0,
            hidden: !1,
            domtoimageOptions: {},
            position: "topleft",
            screenName: "screen",
            iconUrl: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/PjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDMyIDMyIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAzMiAzMjsiIHhtbDpzcGFjZT0icHJlc2VydmUiPjxnPjxnIGlkPSJjYW1lcmEiPjxwYXRoIHN0eWxlPSJmaWxsOiMwMTAwMDI7IiBkPSJNMTYsOS41MDFjLTQuNDE5LDAtOCwzLjU4MS04LDhjMCw0LjQxOCwzLjU4MSw4LDgsOGM0LjQxOCwwLDgtMy41ODIsOC04UzIwLjQxOCw5LjUwMSwxNiw5LjUwMXogTTIwLjU1NSwyMS40MDZjLTIuMTU2LDIuNTE2LTUuOTQzLDIuODA3LTguNDU5LDAuNjVjLTIuNTE3LTIuMTU2LTIuODA3LTUuOTQ0LTAuNjUtOC40NTljMi4xNTUtMi41MTcsNS45NDMtMi44MDcsOC40NTktMC42NUMyMi40MiwxNS4xMDIsMjIuNzExLDE4Ljg5MSwyMC41NTUsMjEuNDA2eiIvPjxwYXRoIHN0eWxlPSJmaWxsOiMwMTAwMDI7IiBkPSJNMTYsMTMuNTAxYy0yLjIwOSwwLTMuOTk5LDEuNzkxLTQsMy45OTl2MC4wMDJjMCwwLjI3NSwwLjIyNCwwLjUsMC41LDAuNXMwLjUtMC4yMjUsMC41LTAuNVYxNy41YzAuMDAxLTEuNjU2LDEuMzQzLTIuOTk5LDMtMi45OTljMC4yNzYsMCwwLjUtMC4yMjQsMC41LTAuNVMxNi4yNzYsMTMuNTAxLDE2LDEzLjUwMXoiLz48cGF0aCBzdHlsZT0iZmlsbDojMDEwMDAyOyIgZD0iTTI5LjQ5Miw4LjU0MmwtNC4zMzQtMC43MjNsLTEuMzczLTMuNDM0QzIzLjMyNiwzLjI0LDIyLjIzMiwyLjUsMjEsMi41SDExYy0xLjIzMiwwLTIuMzI2LDAuNzQtMi43ODYsMS44ODZMNi44NDIsNy44MTlMMi41MDksOC41NDJDMS4wNTUsOC43ODMsMCwxMC4wMjcsMCwxMS41djE1YzAsMS42NTQsMS4zNDYsMywzLDNoMjZjMS42NTQsMCwzLTEuMzQ2LDMtM3YtMTVDMzIsMTAuMDI3LDMwLjk0NSw4Ljc4MywyOS40OTIsOC41NDJ6IE0zMCwyNi41YzAsMC41NTMtMC40NDcsMS0xLDFIM2MtMC41NTMsMC0xLTAuNDQ3LTEtMXYtMTVjMC0wLjQ4OSwwLjM1NC0wLjkwNiwwLjgzNi0wLjk4Nkw4LjI4LDkuNjA3bDEuNzkxLTQuNDc4QzEwLjIyNCw0Ljc1LDEwLjU5MSw0LjUsMTEsNC41aDEwYzAuNDA4LDAsMC43NzUsMC4yNDksMC45MjgsMC42MjlsMS43OTEsNC40NzhsNS40NDUsMC45MDdDMjkuNjQ2LDEwLjU5NCwzMCwxMS4wMTEsMzAsMTEuNVYyNi41eiIvPjwvZz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PC9zdmc+",
            hideElementsWithSelectors: [
                ".leaflet-control-container"
            ],
            onCropBorderSize: 2,
            caption: null,
            captionFontSize: 15,
            captionFont: "Arial",
            captionColor: "black",
            captionBgColor: "white",
            captionOffset: 5,
            mimeType: "image/png",
            debugMode: !1,
            preventDownload: !1,
            onPixelDataFail: function(e) {
                var t = e.node, n = e.error;
                return console.warn("Map node is very big " + t.scrollWidth + "x" + t.scrollHeight), console.warn("Add function: SimpleMapScreenshoter({\n              onPixelDataFail: function({ node, plugin, error, mapPane, domtoimageOptions }) {\n                 // Solutions:\n                 // decrease size of map\n                 // or decrease zoom level\n                 // or remove elements with big distanses\n                 // and after that return image in Promise - plugin._getPixelDataOfNormalMap\n                 return plugin._getPixelDataOfNormalMap(domtoimageOptions)\n              }\n            })"), Promise.reject(n);
            }
        },
        onAdd: function() {
            return this._container = L.DomUtil.create("div", "leaflet-control-simpleMapScreenshoter"), this._link = null, this._screenState = {
                status: 1,
                promise: null
            }, !1 === this.options.hidden && this._addScreenBtn(), this._onUserStartInteractWithMap = this._onUserStartInteractWithMap.bind(this), this._onUserEndInteractWithMap = this._onUserEndInteractWithMap.bind(this), this._map.on("zoomstart", this._onUserStartInteractWithMap), this._map.on("move", this._onUserStartInteractWithMap), this._map.on("zoomend", this._onUserEndInteractWithMap), this._map.on("moveend", this._onUserEndInteractWithMap), this._container;
        },
        takeScreen: function() {
            var e = this, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "blob", n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, o = {};
            for(var r in this.options)n.hasOwnProperty(r) ? o[r] = n[r] : o[r] = this.options[r];
            return 2 === this._screenState.status ? this._screenState.promise : (this._map.fire("simpleMapScreenshoter.takeScreen"), this._screenState.status = 2, this._setElementsVisible(!1), this._screenState.promise = this._waitEndOfInteractions().then(function() {
                return e._getPixelData(o);
            }).then(function(t) {
                return e._setElementsVisible(!0), e._toCanvas(t, o);
            }).then(function(n) {
                return "image" === t ? e._canvasToImage(n, o) : "canvas" === t ? n : e._canvasToBlob(n, o);
            }).then(function(t) {
                return e._screenState.status = 1, e._map.fire("simpleMapScreenshoter.done"), t;
            }).catch(function(t) {
                return e._setElementsVisible(!0), e._screenState.status = 1, e._map.fire("simpleMapScreenshoter.error", {
                    e: t
                }), Promise.reject(t);
            }), this._screenState.promise);
        },
        _setElementsVisible: function() {
            var e = this, t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
            this.options.hideElementsWithSelectors.forEach(function(n) {
                var o = e._map._container.querySelectorAll(n), r = !0, i = !1, a = void 0;
                try {
                    for(var s, c = o[Symbol.iterator](); !(r = (s = c.next()).done); r = !0)s.value.style.opacity = !1 === t ? 0 : 1;
                } catch (e) {
                    i = !0, a = e;
                } finally{
                    try {
                        !r && c.return && c.return();
                    } finally{
                        if (i) throw a;
                    }
                }
            });
        },
        _canvasToImage: function(e, t) {
            var n = t.mimeType, o = e.toDataURL(n);
            return -1 === o.indexOf("base64") ? Promise.reject(new Error("Base64 image generation error")) : Promise.resolve(o);
        },
        _canvasToBlob: function(e, t) {
            var n = t.mimeType;
            return new Promise(function(t, o) {
                e.toBlob(function(e) {
                    t(e);
                }, n);
            });
        },
        _toCanvas: function(e, t) {
            var n = t.captionOffset, o = t.caption, r = t.captionFontSize, i = t.captionFont, a = t.captionColor, s = t.captionBgColor, c = this._node, l = c.screenHeight, u = c.screenWidth, h = document.createElement("canvas");
            h.width = u, h.height = l;
            for(var f = h.getContext("2d"), d = f.createImageData(u, l), p = 0; p < e.length; ++p)d.data[p] = e[p];
            f.putImageData(d, 0, 0), d = null;
            var m = document.createElement("canvas"), g = m.getContext("2d"), w = 0, M = 0, y = l, v = u;
            if (!0 === this.options.cropImageByInnerWH) {
                for(var L1 = [], b = 0, P = 0; P < l; ++P){
                    b = 0;
                    for(var x = 0; x < u; ++x)0 === e[4 * P * u + 4 * x + 4] && b++;
                    b === u && L1.push(P);
                }
                var S = this._getMinAndMaxOnValuesBreak(L1);
                w = S.min;
                for(var C = u, T = S.max, j = [], D = 0, E = M; E < C; ++E){
                    D = 0;
                    for(var N = 0; N < l; ++N)0 === e[4 * N * u + 4 * E + 4] && D++;
                    D === l && j.push(E);
                }
                var I = this._getMinAndMaxOnValuesBreak(j);
                M = I.min, C = I.max, (0 === M && 0 === C || null === C) && (C = u), (0 === w && 0 === T || null === T) && (T = l), !0 === this.options.debugMode && (console.log("emptyYLine", L1), console.log("minMaxY", S), console.log("emptyXLine", j), console.log("minMaxX", I), console.log("debugX", {}), console.log("debugY", {})), 0 === w && T === l && 0 === M && C === u || (w += this.options.onCropBorderSize, T -= this.options.onCropBorderSize, M += this.options.onCropBorderSize, C -= this.options.onCropBorderSize), y = T - w, v = C - M, m.width = v, m.height = y;
            } else m.width = v, m.height = y;
            var A = null;
            return o && (A = "function" == typeof o ? o.call(this) : o), null !== A && (m.height = m.height + (n + r + n), g.beginPath(), g.rect(0, 0, m.width, m.height), g.fillStyle = s, g.fill(), g.save()), g.drawImage(h, M, w, v, y, 0, 0, v, y), null !== A && (g.font = r + "px " + i, g.fillStyle = a, g.fillText(A, n, y + n + r)), Promise.resolve(m);
        },
        _getMinAndMaxOnValuesBreak: function(e) {
            for(var t = 0, n = 0, o = !1, r = 1; r < e.length; r++){
                if (e[r] - 1 !== e[r - 1]) {
                    n = e[r], o = !0;
                    break;
                }
                t = e[r];
            }
            return !1 === o && e[0] > 1 ? (t = 0, n = e[0]) : !1 === o && (t = e[e.length - 1] || 0, n = null), {
                min: t,
                max: n
            };
        },
        _getPixelData: function(e) {
            var t = this, n = e.domtoimageOptions, o = void 0 === n ? {} : n;
            return this._getPixelDataOfNormalMap(o).catch(function(e) {
                return console.warn("May be map size very big on that zoom level, we have error:", e.toString()), console.warn("You can manually hide map elements with large distances between them for fix that warn"), t._getPixelDataOfBigMap(o);
            });
        },
        _getPixelDataOfNormalMap: function() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = this._map.getContainer();
            return this._node = {
                node: t,
                screenHeight: t.scrollHeight,
                screenWidth: t.scrollWidth
            }, o.toPixelData(t, e);
        },
        _getPixelDataOfBigMap: function() {
            var e = this, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, n = this._map.getContainer(), r = this._map.getPane("mapPane");
            r.style.width = 2 * n.clientWidth + "px", r.style.height = 2 * n.clientHeight + "px", r.style.overflow = "hidden";
            var i = function() {
                r.style.width = "initial", r.style.height = "initial", r.style.overflow = "initial";
            };
            return this._node = {
                node: n,
                screenHeight: n.scrollHeight,
                screenWidth: n.scrollWidth
            }, o.toPixelData(n, t).then(function(e) {
                return i(), e;
            }).catch(function(o) {
                return i(), n.scrollHeight >= 4e3 || n.scrollWidth >= 4e3 ? e.options.onPixelDataFail({
                    plugin: e,
                    node: n,
                    mapPane: r,
                    error: o,
                    domtoimageOptions: t
                }) : Promise.reject(o);
            });
        },
        _addScreenBtn: function() {
            this._link = L.DomUtil.create("a", "leaflet-control-simpleMapScreenshoter-btn", this._container), this._addCss(), L.DomEvent.addListener(this._link, "click", this._onScreenBtn, this), L.DomEvent.disableClickPropagation(this._link);
        },
        _addCss: function() {
            var e = "\n    .leaflet-control-simpleMapScreenshoter{\n       border: 2px solid rgba(0,0,0,0.2);\n       background-clip: padding-box;\n    }\n    .leaflet-control-simpleMapScreenshoter a{\n       background-color: #fff;\n       border-bottom: 1px solid #ccc;\n       width: 30px;\n       height: 30px;\n       line-height: 30px;\n       display: block;\n       text-align: center;\n       text-decoration: none;\n       color: black;\n       overflow: hidden;\n       border-radius: 2px;\n       background-image: url('" + this.options.iconUrl + "');\n       background-position: 46% 41%;\n       background-repeat: no-repeat;\n       background-size: 63%;\n    }\n    .leaflet-control-simpleMapScreenshoter a:hover{\n       cursor: pointer;\n    }\n    ", t = document.head || document.getElementsByTagName("head")[0], n = document.createElement("style");
            n.appendChild(document.createTextNode(e)), t.appendChild(n);
        },
        _onScreenBtn: function() {
            var e = this;
            this._map.fire("simpleMapScreenshoter.click"), this.options.preventDownload || this.takeScreen().then(function(t) {
                var n = "function" == typeof e.options.screenName ? e.options.screenName.call(e) : e.options.screenName;
                r.saveAs(t, n + ".png");
            }).catch(function(t) {
                e._map.fire("simpleMapScreenshoter.error", {
                    e: t
                });
            });
        },
        _onUserStartInteractWithMap: function() {
            this._interaction = !0;
        },
        _onUserEndInteractWithMap: function() {
            this._interaction = !1;
        },
        _waitEndOfInteractions: function() {
            var e = this;
            return new Promise(function(t) {
                var n = setInterval(function() {
                    e._interaction || (t(), clearInterval(n));
                }, 100);
            });
        }
    }), a = (L.Control.SimpleMapScreenshoter = i, L.simpleMapScreenshoter = function(e) {
        return new L.Control.SimpleMapScreenshoter(e);
    }, i);
    e.default = a, e.SimpleMapScreenshoter = i, Object.defineProperty(e, "__esModule", {
        value: !0
    });
});




const $202d9c9f4997d984$export$ec896fb550a5e0a = {
    "type": "FeatureCollection",
    "name": "gmst_1851_2022",
    "crs": {
        "type": "name",
        "properties": {
            "name": "urn:ogc:def:crs:OGC:1.3:CRS84"
        }
    },
    "features": [
        {
            "type": "Feature",
            "properties": {
                "ISO3": "AFG",
                "Country": "Afghanistan",
                "Total_3GHG": 0.08,
                "Total_3GHG_timeseries": [
                    2.873e-06,
                    5.771e-06,
                    8.6931e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013
                ],
                "Fossil_3GHG": 0.03,
                "Fossil_3GHG_timeseries": [
                    2.0446e-07,
                    4.106e-07,
                    6.1842e-07,
                    8.2792e-07,
                    1.0391e-06,
                    1.252e-06,
                    1.4666e-06,
                    1.683e-06,
                    1.901e-06,
                    2.1208e-06,
                    2.3424e-06,
                    2.5658e-06,
                    2.791e-06,
                    3.018e-06,
                    3.2469e-06,
                    3.4777e-06,
                    3.7103e-06,
                    3.9449e-06,
                    4.1813e-06,
                    4.4297e-06,
                    4.6814e-06,
                    4.9366e-06,
                    5.1951e-06,
                    5.457e-06,
                    5.7224e-06,
                    5.9912e-06,
                    6.2635e-06,
                    6.5391e-06,
                    6.8181e-06,
                    7.1003e-06,
                    7.388e-06,
                    7.6811e-06,
                    7.9797e-06,
                    8.2836e-06,
                    8.593e-06,
                    8.9079e-06,
                    9.2282e-06,
                    9.554e-06,
                    9.8852e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Land_3GHG": 0.17,
                "Land_3GHG_timeseries": [
                    2.6686e-06,
                    5.3604e-06,
                    8.0747e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001
                ],
                "Total_CO2": 0.05,
                "Total_CO2_timeseries": [
                    1.6037e-06,
                    3.2234e-06,
                    4.8582e-06,
                    6.5077e-06,
                    8.1714e-06,
                    9.8489e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Fossil_CO2": 0.01,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    6.6e-09,
                    4.455e-08,
                    8.58e-08,
                    1.2705e-07,
                    1.749e-07,
                    2.2275e-07,
                    2.9205e-07,
                    3.7455e-07,
                    5.0655e-07,
                    6.5505e-07,
                    8.2823e-07,
                    1.0146e-06,
                    1.2356e-06,
                    1.5457e-06,
                    1.864e-06,
                    2.2416e-06,
                    2.6951e-06,
                    3.1864e-06,
                    3.7637e-06,
                    4.3146e-06,
                    4.7385e-06,
                    5.4907e-06,
                    6.3434e-06,
                    7.0326e-06,
                    7.7691e-06,
                    8.6306e-06,
                    9.5859e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CO2": 0.12,
                "Land_CO2_timeseries": [
                    1.6037e-06,
                    3.2234e-06,
                    4.8582e-06,
                    6.5077e-06,
                    8.1714e-06,
                    9.8489e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Total_CH4": 0.16,
                "Total_CH4_timeseries": [
                    1.1668e-06,
                    2.3406e-06,
                    3.5213e-06,
                    4.709e-06,
                    5.9038e-06,
                    7.1055e-06,
                    8.3142e-06,
                    9.5299e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Fossil_CH4": 0.09,
                "Fossil_CH4_timeseries": [
                    2.0184e-07,
                    4.0531e-07,
                    6.1042e-07,
                    8.1718e-07,
                    1.0256e-06,
                    1.2357e-06,
                    1.4475e-06,
                    1.6609e-06,
                    1.8761e-06,
                    2.0929e-06,
                    2.3116e-06,
                    2.532e-06,
                    2.7543e-06,
                    2.9784e-06,
                    3.2044e-06,
                    3.4321e-06,
                    3.6618e-06,
                    3.8933e-06,
                    4.1267e-06,
                    4.3721e-06,
                    4.6208e-06,
                    4.8727e-06,
                    5.128e-06,
                    5.3865e-06,
                    5.6483e-06,
                    5.9133e-06,
                    6.1816e-06,
                    6.4532e-06,
                    6.728e-06,
                    7.006e-06,
                    7.2894e-06,
                    7.5781e-06,
                    7.8723e-06,
                    8.1718e-06,
                    8.4768e-06,
                    8.7872e-06,
                    9.103e-06,
                    9.4242e-06,
                    9.7509e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_CH4": 0.29,
                "Land_CH4_timeseries": [
                    9.6497e-07,
                    1.9353e-06,
                    2.9109e-06,
                    3.8919e-06,
                    4.8782e-06,
                    5.8698e-06,
                    6.8667e-06,
                    7.869e-06,
                    8.8766e-06,
                    9.8896e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005
                ],
                "Total_N2O": 0.16,
                "Total_N2O_timeseries": [
                    1.0252e-07,
                    2.0708e-07,
                    3.136e-07,
                    4.2195e-07,
                    5.3197e-07,
                    6.4349e-07,
                    7.5627e-07,
                    8.7008e-07,
                    9.846e-07,
                    1.0995e-06,
                    1.2147e-06,
                    1.33e-06,
                    1.4454e-06,
                    1.5609e-06,
                    1.6764e-06,
                    1.7921e-06,
                    1.9078e-06,
                    2.0237e-06,
                    2.1397e-06,
                    2.256e-06,
                    2.3742e-06,
                    2.4973e-06,
                    2.6275e-06,
                    2.7664e-06,
                    2.915e-06,
                    3.0734e-06,
                    3.2412e-06,
                    3.4172e-06,
                    3.5996e-06,
                    3.7859e-06,
                    3.9744e-06,
                    4.1647e-06,
                    4.3566e-06,
                    4.5499e-06,
                    4.7443e-06,
                    4.9399e-06,
                    5.1366e-06,
                    5.3346e-06,
                    5.5339e-06,
                    5.7424e-06,
                    5.9513e-06,
                    6.1606e-06,
                    6.3706e-06,
                    6.5813e-06,
                    6.7928e-06,
                    7.0052e-06,
                    7.2186e-06,
                    7.433e-06,
                    7.6485e-06,
                    7.8651e-06,
                    8.083e-06,
                    8.3024e-06,
                    8.5235e-06,
                    8.7464e-06,
                    8.9714e-06,
                    9.1984e-06,
                    9.4276e-06,
                    9.659e-06,
                    9.8924e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_N2O": 0.03,
                "Fossil_N2O_timeseries": [
                    2.6229e-09,
                    5.2885e-09,
                    7.9954e-09,
                    1.0742e-08,
                    1.3524e-08,
                    1.6341e-08,
                    1.9188e-08,
                    2.2061e-08,
                    2.4955e-08,
                    2.7865e-08,
                    3.0787e-08,
                    3.3722e-08,
                    3.6668e-08,
                    3.9625e-08,
                    4.2593e-08,
                    4.5571e-08,
                    4.856e-08,
                    5.1561e-08,
                    5.4574e-08,
                    5.76e-08,
                    6.0667e-08,
                    6.3823e-08,
                    6.7104e-08,
                    7.0538e-08,
                    7.4137e-08,
                    7.7906e-08,
                    8.1838e-08,
                    8.5912e-08,
                    9.0101e-08,
                    9.4362e-08,
                    9.8669e-08,
                    1.0301e-07,
                    1.074e-07,
                    1.1181e-07,
                    1.1625e-07,
                    1.2072e-07,
                    1.2522e-07,
                    1.2974e-07,
                    1.343e-07,
                    1.389e-07,
                    1.4353e-07,
                    1.4821e-07,
                    1.5292e-07,
                    1.5767e-07,
                    1.6247e-07,
                    1.6731e-07,
                    1.7219e-07,
                    1.7713e-07,
                    1.8211e-07,
                    1.8715e-07,
                    1.9226e-07,
                    1.9743e-07,
                    2.0269e-07,
                    2.0802e-07,
                    2.1345e-07,
                    2.1897e-07,
                    2.2459e-07,
                    2.3029e-07,
                    2.3609e-07,
                    2.4197e-07,
                    2.4794e-07,
                    2.5399e-07,
                    2.6013e-07,
                    2.6634e-07,
                    2.7264e-07,
                    2.7903e-07,
                    2.8549e-07,
                    2.9205e-07,
                    2.9868e-07,
                    3.054e-07,
                    3.1221e-07,
                    3.191e-07,
                    3.2608e-07,
                    3.3315e-07,
                    3.4031e-07,
                    3.4756e-07,
                    3.5489e-07,
                    3.6231e-07,
                    3.6981e-07,
                    3.7739e-07,
                    3.8505e-07,
                    3.9278e-07,
                    4.006e-07,
                    4.085e-07,
                    4.165e-07,
                    4.2459e-07,
                    4.3278e-07,
                    4.4109e-07,
                    4.4953e-07,
                    4.5809e-07,
                    4.6691e-07,
                    4.7618e-07,
                    4.8605e-07,
                    4.9664e-07,
                    5.0801e-07,
                    5.202e-07,
                    5.3318e-07,
                    5.4691e-07,
                    5.6127e-07,
                    5.7612e-07,
                    5.9137e-07,
                    6.0695e-07,
                    6.2284e-07,
                    6.3902e-07,
                    6.5549e-07,
                    6.7225e-07,
                    6.8933e-07,
                    7.0677e-07,
                    7.2461e-07,
                    7.4291e-07,
                    7.618e-07,
                    7.8143e-07,
                    8.0194e-07,
                    8.2342e-07,
                    8.4597e-07,
                    8.6963e-07,
                    8.9444e-07,
                    9.2039e-07,
                    9.4746e-07,
                    9.7592e-07,
                    1.0056e-06,
                    1.0369e-06,
                    1.0692e-06,
                    1.1036e-06,
                    1.1397e-06,
                    1.1766e-06,
                    1.2159e-06,
                    1.2558e-06,
                    1.2974e-06,
                    1.3406e-06,
                    1.3862e-06,
                    1.433e-06,
                    1.4835e-06,
                    1.5349e-06,
                    1.5921e-06,
                    1.6507e-06,
                    1.7111e-06,
                    1.7716e-06,
                    1.8319e-06,
                    1.8948e-06,
                    1.9573e-06,
                    2.0164e-06,
                    2.0792e-06,
                    2.1445e-06,
                    2.2169e-06,
                    2.2943e-06,
                    2.375e-06,
                    2.4554e-06,
                    2.5357e-06,
                    2.6177e-06,
                    2.7029e-06,
                    2.7912e-06,
                    2.8857e-06,
                    2.9865e-06,
                    3.0928e-06,
                    3.2033e-06,
                    3.3205e-06,
                    3.4569e-06,
                    3.6171e-06,
                    3.7967e-06,
                    4.0106e-06,
                    4.2177e-06,
                    4.4071e-06,
                    4.5903e-06,
                    4.7787e-06,
                    4.9555e-06,
                    5.1413e-06,
                    5.3317e-06,
                    5.5367e-06,
                    5.7409e-06,
                    5.9488e-06,
                    6.1593e-06
                ],
                "Land_N2O": 0.22,
                "Land_N2O_timeseries": [
                    9.9898e-08,
                    2.0179e-07,
                    3.056e-07,
                    4.112e-07,
                    5.1845e-07,
                    6.2715e-07,
                    7.3709e-07,
                    8.4801e-07,
                    9.5965e-07,
                    1.0717e-06,
                    1.1839e-06,
                    1.2962e-06,
                    1.4087e-06,
                    1.5212e-06,
                    1.6339e-06,
                    1.7465e-06,
                    1.8593e-06,
                    1.9722e-06,
                    2.0852e-06,
                    2.1984e-06,
                    2.3135e-06,
                    2.4335e-06,
                    2.5604e-06,
                    2.6959e-06,
                    2.8409e-06,
                    2.9955e-06,
                    3.1594e-06,
                    3.3313e-06,
                    3.5095e-06,
                    3.6915e-06,
                    3.8757e-06,
                    4.0617e-06,
                    4.2492e-06,
                    4.4381e-06,
                    4.6281e-06,
                    4.8192e-06,
                    5.0114e-06,
                    5.2048e-06,
                    5.3996e-06,
                    5.6035e-06,
                    5.8077e-06,
                    6.0124e-06,
                    6.2177e-06,
                    6.4236e-06,
                    6.6303e-06,
                    6.8379e-06,
                    7.0464e-06,
                    7.2559e-06,
                    7.4664e-06,
                    7.678e-06,
                    7.8907e-06,
                    8.105e-06,
                    8.3208e-06,
                    8.5384e-06,
                    8.7579e-06,
                    8.9795e-06,
                    9.203e-06,
                    9.4287e-06,
                    9.6564e-06,
                    9.886e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            66.55373,
                            37.35475
                        ],
                        [
                            66.47556,
                            37.32925
                        ],
                        [
                            66.41647,
                            37.34685
                        ],
                        [
                            66.31489,
                            37.32202
                        ],
                        [
                            66.24604,
                            37.36375
                        ],
                        [
                            66.16319,
                            37.37558
                        ],
                        [
                            66.07059,
                            37.44881
                        ],
                        [
                            65.82199,
                            37.49756
                        ],
                        [
                            65.69959,
                            37.53235
                        ],
                        [
                            65.64665,
                            37.4419
                        ],
                        [
                            65.64229,
                            37.34273
                        ],
                        [
                            65.53126,
                            37.23865
                        ],
                        [
                            65.27058,
                            37.23289
                        ],
                        [
                            65.13009,
                            37.24554
                        ],
                        [
                            64.9894,
                            37.21802
                        ],
                        [
                            64.75796,
                            37.11379
                        ],
                        [
                            64.79765,
                            36.92269
                        ],
                        [
                            64.70645,
                            36.79511
                        ],
                        [
                            64.61894,
                            36.63719
                        ],
                        [
                            64.63596,
                            36.44298
                        ],
                        [
                            64.57784,
                            36.34982
                        ],
                        [
                            64.44537,
                            36.24313
                        ],
                        [
                            64.31547,
                            36.20728
                        ],
                        [
                            64.28326,
                            36.1521
                        ],
                        [
                            64.16048,
                            36.16007
                        ],
                        [
                            64.05782,
                            36.1004
                        ],
                        [
                            64.06867,
                            35.99821
                        ],
                        [
                            63.9872,
                            36.03569
                        ],
                        [
                            63.70478,
                            35.96798
                        ],
                        [
                            63.57229,
                            35.95147
                        ],
                        [
                            63.5306,
                            35.90233
                        ],
                        [
                            63.30599,
                            35.85813
                        ],
                        [
                            63.12157,
                            35.86263
                        ],
                        [
                            63.10085,
                            35.81647
                        ],
                        [
                            63.19467,
                            35.71426
                        ],
                        [
                            63.24762,
                            35.68224
                        ],
                        [
                            63.11453,
                            35.63453
                        ],
                        [
                            63.12952,
                            35.54245
                        ],
                        [
                            63.09949,
                            35.4197
                        ],
                        [
                            63.00478,
                            35.40815
                        ],
                        [
                            62.76401,
                            35.28709
                        ],
                        [
                            62.74615,
                            35.25379
                        ],
                        [
                            62.57809,
                            35.22172
                        ],
                        [
                            62.47723,
                            35.27805
                        ],
                        [
                            62.33123,
                            35.14947
                        ],
                        [
                            62.26542,
                            35.29491
                        ],
                        [
                            62.1532,
                            35.34156
                        ],
                        [
                            62.06341,
                            35.43433
                        ],
                        [
                            61.96773,
                            35.45367
                        ],
                        [
                            61.77905,
                            35.41144
                        ],
                        [
                            61.58912,
                            35.43678
                        ],
                        [
                            61.38649,
                            35.56794
                        ],
                        [
                            61.36418,
                            35.62499
                        ],
                        [
                            61.27413,
                            35.60515
                        ],
                        [
                            61.27649,
                            35.52074
                        ],
                        [
                            61.1993,
                            35.41045
                        ],
                        [
                            61.18927,
                            35.29456
                        ],
                        [
                            61.09317,
                            35.2648
                        ],
                        [
                            61.09504,
                            35.18458
                        ],
                        [
                            61.13,
                            35.13216
                        ],
                        [
                            61.09713,
                            34.95404
                        ],
                        [
                            61.05887,
                            34.90062
                        ],
                        [
                            61.0675,
                            34.81225
                        ],
                        [
                            61.00415,
                            34.71
                        ],
                        [
                            60.98326,
                            34.62085
                        ],
                        [
                            60.92251,
                            34.62127
                        ],
                        [
                            60.85333,
                            34.5446
                        ],
                        [
                            60.74718,
                            34.52791
                        ],
                        [
                            60.80782,
                            34.47052
                        ],
                        [
                            60.8495,
                            34.37076
                        ],
                        [
                            60.91593,
                            34.30574
                        ],
                        [
                            60.67726,
                            34.30373
                        ],
                        [
                            60.47751,
                            34.08065
                        ],
                        [
                            60.58111,
                            33.80683
                        ],
                        [
                            60.54834,
                            33.7279
                        ],
                        [
                            60.65951,
                            33.53779
                        ],
                        [
                            60.89832,
                            33.543
                        ],
                        [
                            60.8543,
                            33.48417
                        ],
                        [
                            60.86494,
                            33.42174
                        ],
                        [
                            60.82073,
                            33.39651
                        ],
                        [
                            60.63653,
                            33.23011
                        ],
                        [
                            60.5843,
                            33.1302
                        ],
                        [
                            60.63019,
                            33.01893
                        ],
                        [
                            60.73272,
                            32.66549
                        ],
                        [
                            60.81502,
                            32.48024
                        ],
                        [
                            60.8821,
                            32.19945
                        ],
                        [
                            60.81692,
                            32.0244
                        ],
                        [
                            60.8136,
                            31.70865
                        ],
                        [
                            60.86493,
                            31.48548
                        ],
                        [
                            61.707,
                            31.3755
                        ],
                        [
                            61.77763,
                            31.3035
                        ],
                        [
                            61.77252,
                            31.20648
                        ],
                        [
                            61.80467,
                            31.16521
                        ],
                        [
                            61.83794,
                            31.03704
                        ],
                        [
                            61.83347,
                            30.97365
                        ],
                        [
                            61.78554,
                            30.94045
                        ],
                        [
                            61.80444,
                            30.83561
                        ],
                        [
                            61.49299,
                            30.51625
                        ],
                        [
                            60.87297,
                            29.85847
                        ],
                        [
                            61.64878,
                            29.63315
                        ],
                        [
                            62.46983,
                            29.38894
                        ],
                        [
                            63.57599,
                            29.4869
                        ],
                        [
                            64.05234,
                            29.40741
                        ],
                        [
                            64.09844,
                            29.38016
                        ],
                        [
                            64.14243,
                            29.43625
                        ],
                        [
                            64.25094,
                            29.51678
                        ],
                        [
                            64.58163,
                            29.5848
                        ],
                        [
                            65.06677,
                            29.53042
                        ],
                        [
                            65.52252,
                            29.65316
                        ],
                        [
                            66.24423,
                            29.84758
                        ],
                        [
                            66.37034,
                            29.96891
                        ],
                        [
                            66.23806,
                            30.05932
                        ],
                        [
                            66.32461,
                            30.24757
                        ],
                        [
                            66.3548,
                            30.48085
                        ],
                        [
                            66.28808,
                            30.52817
                        ],
                        [
                            66.29056,
                            30.58483
                        ],
                        [
                            66.3926,
                            30.93813
                        ],
                        [
                            66.58085,
                            30.97965
                        ],
                        [
                            66.66934,
                            31.06392
                        ],
                        [
                            66.72992,
                            31.20588
                        ],
                        [
                            66.81106,
                            31.22256
                        ],
                        [
                            66.83316,
                            31.26242
                        ],
                        [
                            66.95415,
                            31.30633
                        ],
                        [
                            67.03613,
                            31.30997
                        ],
                        [
                            67.0263,
                            31.25653
                        ],
                        [
                            67.0654,
                            31.21702
                        ],
                        [
                            67.17013,
                            31.24229
                        ],
                        [
                            67.26901,
                            31.20072
                        ],
                        [
                            67.39614,
                            31.21154
                        ],
                        [
                            67.54882,
                            31.26165
                        ],
                        [
                            67.64877,
                            31.27886
                        ],
                        [
                            67.72275,
                            31.3255
                        ],
                        [
                            67.7855,
                            31.33316
                        ],
                        [
                            67.79485,
                            31.38042
                        ],
                        [
                            67.74655,
                            31.41472
                        ],
                        [
                            67.65578,
                            31.39417
                        ],
                        [
                            67.60349,
                            31.4253
                        ],
                        [
                            67.57358,
                            31.52178
                        ],
                        [
                            67.71376,
                            31.51535
                        ],
                        [
                            67.82385,
                            31.60161
                        ],
                        [
                            67.97825,
                            31.64333
                        ],
                        [
                            68.06692,
                            31.69646
                        ],
                        [
                            68.17007,
                            31.83006
                        ],
                        [
                            68.25787,
                            31.80252
                        ],
                        [
                            68.2832,
                            31.75909
                        ],
                        [
                            68.42481,
                            31.75524
                        ],
                        [
                            68.57627,
                            31.82973
                        ],
                        [
                            68.64204,
                            31.7806
                        ],
                        [
                            68.70648,
                            31.76677
                        ],
                        [
                            68.72912,
                            31.69681
                        ],
                        [
                            68.79168,
                            31.62552
                        ],
                        [
                            68.91229,
                            31.59926
                        ],
                        [
                            68.96303,
                            31.64536
                        ],
                        [
                            69.0167,
                            31.63136
                        ],
                        [
                            69.11603,
                            31.70494
                        ],
                        [
                            69.19944,
                            31.85274
                        ],
                        [
                            69.32578,
                            31.93228
                        ],
                        [
                            69.29535,
                            32.01561
                        ],
                        [
                            69.27184,
                            32.15087
                        ],
                        [
                            69.27522,
                            32.36752
                        ],
                        [
                            69.24017,
                            32.459
                        ],
                        [
                            69.28015,
                            32.52754
                        ],
                        [
                            69.38105,
                            32.56339
                        ],
                        [
                            69.45037,
                            32.65572
                        ],
                        [
                            69.38997,
                            32.77359
                        ],
                        [
                            69.50095,
                            32.8875
                        ],
                        [
                            69.50067,
                            33.02295
                        ],
                        [
                            69.57969,
                            33.0998
                        ],
                        [
                            69.71319,
                            33.09138
                        ],
                        [
                            69.79566,
                            33.12978
                        ],
                        [
                            69.87318,
                            33.0956
                        ],
                        [
                            70.02134,
                            33.14134
                        ],
                        [
                            70.07059,
                            33.2168
                        ],
                        [
                            70.16103,
                            33.21833
                        ],
                        [
                            70.32446,
                            33.35483
                        ],
                        [
                            70.29623,
                            33.42993
                        ],
                        [
                            70.25379,
                            33.43706
                        ],
                        [
                            70.17363,
                            33.51801
                        ],
                        [
                            70.1978,
                            33.61738
                        ],
                        [
                            70.14498,
                            33.65768
                        ],
                        [
                            70.14179,
                            33.72423
                        ],
                        [
                            70.00191,
                            33.73335
                        ],
                        [
                            69.96359,
                            33.77128
                        ],
                        [
                            69.91057,
                            33.89548
                        ],
                        [
                            69.86001,
                            33.92544
                        ],
                        [
                            69.88932,
                            34.01821
                        ],
                        [
                            69.99156,
                            34.04723
                        ],
                        [
                            70.20056,
                            33.98153
                        ],
                        [
                            70.41928,
                            33.96647
                        ],
                        [
                            70.49637,
                            33.94015
                        ],
                        [
                            70.88214,
                            33.97382
                        ],
                        [
                            70.96841,
                            34.02955
                        ],
                        [
                            71.08182,
                            34.06302
                        ],
                        [
                            71.07136,
                            34.1089
                        ],
                        [
                            71.12937,
                            34.16458
                        ],
                        [
                            71.12014,
                            34.24119
                        ],
                        [
                            71.1754,
                            34.36279
                        ],
                        [
                            71.11698,
                            34.37659
                        ],
                        [
                            71.10793,
                            34.43238
                        ],
                        [
                            71.0242,
                            34.45182
                        ],
                        [
                            71.01222,
                            34.53499
                        ],
                        [
                            71.11615,
                            34.62812
                        ],
                        [
                            71.08932,
                            34.67545
                        ],
                        [
                            71.28103,
                            34.80561
                        ],
                        [
                            71.29665,
                            34.87565
                        ],
                        [
                            71.34816,
                            34.91205
                        ],
                        [
                            71.47282,
                            34.94979
                        ],
                        [
                            71.54674,
                            35.01995
                        ],
                        [
                            71.53319,
                            35.09157
                        ],
                        [
                            71.62387,
                            35.14011
                        ],
                        [
                            71.68074,
                            35.20874
                        ],
                        [
                            71.63234,
                            35.22665
                        ],
                        [
                            71.54416,
                            35.31044
                        ],
                        [
                            71.65675,
                            35.44195
                        ],
                        [
                            71.59443,
                            35.50067
                        ],
                        [
                            71.61733,
                            35.55293
                        ],
                        [
                            71.50091,
                            35.62914
                        ],
                        [
                            71.55152,
                            35.724
                        ],
                        [
                            71.49148,
                            35.75456
                        ],
                        [
                            71.3821,
                            35.9564
                        ],
                        [
                            71.32124,
                            35.961
                        ],
                        [
                            71.19915,
                            36.05262
                        ],
                        [
                            71.25656,
                            36.13339
                        ],
                        [
                            71.43248,
                            36.23124
                        ],
                        [
                            71.44606,
                            36.26782
                        ],
                        [
                            71.57651,
                            36.32989
                        ],
                        [
                            71.65778,
                            36.48092
                        ],
                        [
                            71.80567,
                            36.40138
                        ],
                        [
                            71.8075,
                            36.50466
                        ],
                        [
                            71.91233,
                            36.5087
                        ],
                        [
                            71.93895,
                            36.54641
                        ],
                        [
                            72.08177,
                            36.59046
                        ],
                        [
                            72.09799,
                            36.64559
                        ],
                        [
                            72.20715,
                            36.66853
                        ],
                        [
                            72.18804,
                            36.71334
                        ],
                        [
                            72.24847,
                            36.75079
                        ],
                        [
                            72.49848,
                            36.78032
                        ],
                        [
                            72.56055,
                            36.82716
                        ],
                        [
                            72.65077,
                            36.85071
                        ],
                        [
                            72.7175,
                            36.83837
                        ],
                        [
                            72.93059,
                            36.8446
                        ],
                        [
                            73.06919,
                            36.88515
                        ],
                        [
                            73.2681,
                            36.89042
                        ],
                        [
                            73.37599,
                            36.87988
                        ],
                        [
                            73.60066,
                            36.90775
                        ],
                        [
                            73.8907,
                            36.91217
                        ],
                        [
                            73.95782,
                            36.84301
                        ],
                        [
                            74.0463,
                            36.82646
                        ],
                        [
                            74.12075,
                            36.83894
                        ],
                        [
                            74.17661,
                            36.91616
                        ],
                        [
                            74.23926,
                            36.89504
                        ],
                        [
                            74.30822,
                            36.91893
                        ],
                        [
                            74.42567,
                            37.0103
                        ],
                        [
                            74.56463,
                            37.03085
                        ],
                        [
                            74.45663,
                            37.1424
                        ],
                        [
                            74.50229,
                            37.23938
                        ],
                        [
                            74.63089,
                            37.26356
                        ],
                        [
                            74.65997,
                            37.23514
                        ],
                        [
                            74.75011,
                            37.28346
                        ],
                        [
                            74.80962,
                            37.21517
                        ],
                        [
                            74.88986,
                            37.23409
                        ],
                        [
                            74.80243,
                            37.35481
                        ],
                        [
                            74.6756,
                            37.39022
                        ],
                        [
                            74.5666,
                            37.37379
                        ],
                        [
                            74.37124,
                            37.4236
                        ],
                        [
                            74.24911,
                            37.37927
                        ],
                        [
                            74.20037,
                            37.33695
                        ],
                        [
                            74.06498,
                            37.32467
                        ],
                        [
                            73.75529,
                            37.22368
                        ],
                        [
                            73.63023,
                            37.28046
                        ],
                        [
                            73.77188,
                            37.34008
                        ],
                        [
                            73.77332,
                            37.43749
                        ],
                        [
                            73.64363,
                            37.43655
                        ],
                        [
                            73.53384,
                            37.47077
                        ],
                        [
                            73.45334,
                            37.4735
                        ],
                        [
                            73.37391,
                            37.44353
                        ],
                        [
                            73.30323,
                            37.46215
                        ],
                        [
                            73.21596,
                            37.40613
                        ],
                        [
                            73.15207,
                            37.4032
                        ],
                        [
                            73.09212,
                            37.32398
                        ],
                        [
                            72.93741,
                            37.28115
                        ],
                        [
                            72.77437,
                            37.19091
                        ],
                        [
                            72.67486,
                            37.02278
                        ],
                        [
                            72.47564,
                            36.99462
                        ],
                        [
                            72.34337,
                            36.98752
                        ],
                        [
                            72.21066,
                            36.92518
                        ],
                        [
                            72.10849,
                            36.84494
                        ],
                        [
                            72.02144,
                            36.81137
                        ],
                        [
                            71.84304,
                            36.68265
                        ],
                        [
                            71.67472,
                            36.67517
                        ],
                        [
                            71.56784,
                            36.76387
                        ],
                        [
                            71.54048,
                            36.84469
                        ],
                        [
                            71.46787,
                            36.95322
                        ],
                        [
                            71.43064,
                            37.06803
                        ],
                        [
                            71.4563,
                            37.21006
                        ],
                        [
                            71.5034,
                            37.31092
                        ],
                        [
                            71.48945,
                            37.33459
                        ],
                        [
                            71.52365,
                            37.47687
                        ],
                        [
                            71.49576,
                            37.54202
                        ],
                        [
                            71.54991,
                            37.71398
                        ],
                        [
                            71.53624,
                            37.764
                        ],
                        [
                            71.59373,
                            37.80547
                        ],
                        [
                            71.59009,
                            37.91912
                        ],
                        [
                            71.50664,
                            37.95175
                        ],
                        [
                            71.3324,
                            37.88778
                        ],
                        [
                            71.2579,
                            37.92538
                        ],
                        [
                            71.28603,
                            38.03965
                        ],
                        [
                            71.35281,
                            38.1489
                        ],
                        [
                            71.37083,
                            38.25722
                        ],
                        [
                            71.3255,
                            38.30266
                        ],
                        [
                            71.18525,
                            38.34713
                        ],
                        [
                            71.10219,
                            38.42055
                        ],
                        [
                            71.04615,
                            38.4136
                        ],
                        [
                            70.99068,
                            38.4881
                        ],
                        [
                            70.92827,
                            38.43334
                        ],
                        [
                            70.77428,
                            38.45345
                        ],
                        [
                            70.68233,
                            38.40985
                        ],
                        [
                            70.6841,
                            38.36491
                        ],
                        [
                            70.613,
                            38.34501
                        ],
                        [
                            70.50366,
                            38.16298
                        ],
                        [
                            70.5029,
                            38.12341
                        ],
                        [
                            70.36764,
                            38.0533
                        ],
                        [
                            70.32864,
                            38.00116
                        ],
                        [
                            70.20975,
                            37.9253
                        ],
                        [
                            70.18812,
                            37.8492
                        ],
                        [
                            70.27772,
                            37.81314
                        ],
                        [
                            70.29938,
                            37.69032
                        ],
                        [
                            70.17001,
                            37.53206
                        ],
                        [
                            70.1161,
                            37.52448
                        ],
                        [
                            69.9597,
                            37.56472
                        ],
                        [
                            69.91048,
                            37.61891
                        ],
                        [
                            69.79983,
                            37.57052
                        ],
                        [
                            69.74663,
                            37.58727
                        ],
                        [
                            69.62122,
                            37.57426
                        ],
                        [
                            69.5317,
                            37.58877
                        ],
                        [
                            69.49239,
                            37.52366
                        ],
                        [
                            69.3948,
                            37.44963
                        ],
                        [
                            69.3805,
                            37.32505
                        ],
                        [
                            69.45202,
                            37.23181
                        ],
                        [
                            69.40044,
                            37.16634
                        ],
                        [
                            69.25536,
                            37.09443
                        ],
                        [
                            69.11687,
                            37.17559
                        ],
                        [
                            69.08637,
                            37.2253
                        ],
                        [
                            68.97059,
                            37.31957
                        ],
                        [
                            68.81951,
                            37.3117
                        ],
                        [
                            68.64424,
                            37.20835
                        ],
                        [
                            68.53939,
                            37.1645
                        ],
                        [
                            68.42737,
                            37.14423
                        ],
                        [
                            68.42024,
                            37.11074
                        ],
                        [
                            68.29798,
                            37.10553
                        ],
                        [
                            68.28256,
                            37.02474
                        ],
                        [
                            68.18961,
                            37.02082
                        ],
                        [
                            68.12129,
                            36.96246
                        ],
                        [
                            68.02029,
                            36.92467
                        ],
                        [
                            67.89875,
                            37.02998
                        ],
                        [
                            67.815,
                            37.07021
                        ],
                        [
                            67.77866,
                            37.17963
                        ],
                        [
                            67.73687,
                            37.21456
                        ],
                        [
                            67.61277,
                            37.23919
                        ],
                        [
                            67.57109,
                            37.22424
                        ],
                        [
                            67.49915,
                            37.28137
                        ],
                        [
                            67.44898,
                            37.23465
                        ],
                        [
                            67.26022,
                            37.18436
                        ],
                        [
                            67.20854,
                            37.24899
                        ],
                        [
                            67.12529,
                            37.27324
                        ],
                        [
                            67.05904,
                            37.37261
                        ],
                        [
                            66.94659,
                            37.39834
                        ],
                        [
                            66.85115,
                            37.35352
                        ],
                        [
                            66.60406,
                            37.36362
                        ],
                        [
                            66.55373,
                            37.35475
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "ALB",
                "Country": "Albania",
                "Total_3GHG": 0.02,
                "Total_3GHG_timeseries": [
                    5.6584e-07,
                    1.1431e-06,
                    1.7297e-06,
                    2.3227e-06,
                    2.921e-06,
                    3.5258e-06,
                    4.1432e-06,
                    4.7667e-06,
                    5.3942e-06,
                    6.0267e-06,
                    6.6668e-06,
                    7.3026e-06,
                    7.9477e-06,
                    8.5911e-06,
                    9.25e-06,
                    9.9216e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Fossil_3GHG": 0.02,
                "Fossil_3GHG_timeseries": [
                    9.3939e-08,
                    1.9088e-07,
                    2.9088e-07,
                    3.9399e-07,
                    5.0026e-07,
                    6.0974e-07,
                    7.2249e-07,
                    8.3856e-07,
                    9.58e-07,
                    1.0809e-06,
                    1.2071e-06,
                    1.3367e-06,
                    1.4698e-06,
                    1.6065e-06,
                    1.7467e-06,
                    1.8906e-06,
                    2.0383e-06,
                    2.1897e-06,
                    2.3449e-06,
                    2.5041e-06,
                    2.6648e-06,
                    2.8272e-06,
                    2.9913e-06,
                    3.1571e-06,
                    3.3246e-06,
                    3.4939e-06,
                    3.665e-06,
                    3.8378e-06,
                    4.0124e-06,
                    4.1888e-06,
                    4.3669e-06,
                    4.5468e-06,
                    4.7284e-06,
                    4.9119e-06,
                    5.0971e-06,
                    5.2841e-06,
                    5.473e-06,
                    5.6637e-06,
                    5.8563e-06,
                    6.0508e-06,
                    6.2477e-06,
                    6.4468e-06,
                    6.6482e-06,
                    6.852e-06,
                    7.0582e-06,
                    7.2668e-06,
                    7.4779e-06,
                    7.6914e-06,
                    7.9075e-06,
                    8.126e-06,
                    8.3455e-06,
                    8.5658e-06,
                    8.7871e-06,
                    9.0093e-06,
                    9.2324e-06,
                    9.4563e-06,
                    9.6812e-06,
                    9.9069e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_3GHG": 0.04,
                "Land_3GHG_timeseries": [
                    4.719e-07,
                    9.5221e-07,
                    1.4389e-06,
                    1.9287e-06,
                    2.4207e-06,
                    2.9161e-06,
                    3.4207e-06,
                    3.9282e-06,
                    4.4362e-06,
                    4.9458e-06,
                    5.4597e-06,
                    5.9658e-06,
                    6.4778e-06,
                    6.9846e-06,
                    7.5033e-06,
                    8.0309e-06,
                    8.5637e-06,
                    9.0924e-06,
                    9.6288e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Total_CO2": 0.02,
                "Total_CO2_timeseries": [
                    3.3926e-07,
                    6.8301e-07,
                    1.0292e-06,
                    1.3747e-06,
                    1.7184e-06,
                    2.0616e-06,
                    2.4103e-06,
                    2.758e-06,
                    3.1025e-06,
                    3.4448e-06,
                    3.7879e-06,
                    4.1198e-06,
                    4.454e-06,
                    4.7795e-06,
                    5.1135e-06,
                    5.4529e-06,
                    5.794e-06,
                    6.1275e-06,
                    6.4652e-06,
                    6.8143e-06,
                    7.1647e-06,
                    7.5244e-06,
                    7.8933e-06,
                    8.2628e-06,
                    8.6331e-06,
                    9.006e-06,
                    9.3883e-06,
                    9.7767e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_CO2": 0.02,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    3.3e-09,
                    6.6e-09,
                    1.485e-08,
                    7.2586e-08,
                    2.0621e-07,
                    3.6296e-07,
                    5.5766e-07,
                    8.6951e-07,
                    1.1516e-06,
                    1.4866e-06,
                    1.6945e-06,
                    1.7638e-06,
                    1.8182e-06,
                    2.036e-06,
                    2.4535e-06,
                    2.7703e-06,
                    3.2273e-06,
                    3.361e-06,
                    3.5424e-06,
                    3.7107e-06,
                    3.8971e-06,
                    4.1232e-06,
                    4.4217e-06,
                    4.7995e-06,
                    5.4775e-06,
                    6.0185e-06,
                    6.6685e-06,
                    7.5792e-06,
                    8.6052e-06,
                    9.7138e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CO2": 0.02,
                "Land_CO2_timeseries": [
                    3.3926e-07,
                    6.8301e-07,
                    1.0292e-06,
                    1.3747e-06,
                    1.7184e-06,
                    2.0616e-06,
                    2.4103e-06,
                    2.758e-06,
                    3.1025e-06,
                    3.4448e-06,
                    3.7879e-06,
                    4.1198e-06,
                    4.454e-06,
                    4.7795e-06,
                    5.1135e-06,
                    5.4529e-06,
                    5.794e-06,
                    6.1275e-06,
                    6.4652e-06,
                    6.8143e-06,
                    7.1647e-06,
                    7.5244e-06,
                    7.8933e-06,
                    8.2628e-06,
                    8.6331e-06,
                    9.006e-06,
                    9.3883e-06,
                    9.7767e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_CH4": 0.03,
                "Total_CH4_timeseries": [
                    2.0679e-07,
                    4.2018e-07,
                    6.4023e-07,
                    8.6698e-07,
                    1.1005e-06,
                    1.3409e-06,
                    1.5881e-06,
                    1.8422e-06,
                    2.1034e-06,
                    2.3715e-06,
                    2.6465e-06,
                    2.9282e-06,
                    3.2169e-06,
                    3.5125e-06,
                    3.8151e-06,
                    4.1247e-06,
                    4.4415e-06,
                    4.7655e-06,
                    5.0967e-06,
                    5.4352e-06,
                    5.7771e-06,
                    6.1224e-06,
                    6.471e-06,
                    6.8231e-06,
                    7.1786e-06,
                    7.5376e-06,
                    7.9e-06,
                    8.2658e-06,
                    8.6352e-06,
                    9.0081e-06,
                    9.3844e-06,
                    9.7643e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_CH4": 0.01,
                "Fossil_CH4_timeseries": [
                    8.5986e-08,
                    1.7489e-07,
                    2.6675e-07,
                    3.6164e-07,
                    4.596e-07,
                    5.607e-07,
                    6.6497e-07,
                    7.7249e-07,
                    8.833e-07,
                    9.9747e-07,
                    1.1149e-06,
                    1.2357e-06,
                    1.3599e-06,
                    1.4876e-06,
                    1.6188e-06,
                    1.7536e-06,
                    1.8921e-06,
                    2.0342e-06,
                    2.1802e-06,
                    2.3299e-06,
                    2.4812e-06,
                    2.634e-06,
                    2.7883e-06,
                    2.9442e-06,
                    3.1016e-06,
                    3.2607e-06,
                    3.4213e-06,
                    3.5835e-06,
                    3.7474e-06,
                    3.9129e-06,
                    4.0801e-06,
                    4.2489e-06,
                    4.4194e-06,
                    4.5917e-06,
                    4.7656e-06,
                    4.9413e-06,
                    5.1187e-06,
                    5.2979e-06,
                    5.4789e-06,
                    5.6617e-06,
                    5.8467e-06,
                    6.0338e-06,
                    6.2232e-06,
                    6.4149e-06,
                    6.6088e-06,
                    6.805e-06,
                    7.0036e-06,
                    7.2045e-06,
                    7.4078e-06,
                    7.6135e-06,
                    7.82e-06,
                    8.0272e-06,
                    8.2353e-06,
                    8.444e-06,
                    8.6535e-06,
                    8.8638e-06,
                    9.0748e-06,
                    9.2865e-06,
                    9.499e-06,
                    9.7121e-06,
                    9.9256e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CH4": 0.06,
                "Land_CH4_timeseries": [
                    1.208e-07,
                    2.4529e-07,
                    3.7347e-07,
                    5.0534e-07,
                    6.409e-07,
                    7.8016e-07,
                    9.231e-07,
                    1.0697e-06,
                    1.2201e-06,
                    1.3741e-06,
                    1.5316e-06,
                    1.6925e-06,
                    1.8569e-06,
                    2.0249e-06,
                    2.1962e-06,
                    2.3711e-06,
                    2.5494e-06,
                    2.7313e-06,
                    2.9165e-06,
                    3.1053e-06,
                    3.2959e-06,
                    3.4884e-06,
                    3.6827e-06,
                    3.8789e-06,
                    4.077e-06,
                    4.2769e-06,
                    4.4787e-06,
                    4.6823e-06,
                    4.8878e-06,
                    5.0951e-06,
                    5.3043e-06,
                    5.5154e-06,
                    5.7283e-06,
                    5.9431e-06,
                    6.1598e-06,
                    6.3783e-06,
                    6.5986e-06,
                    6.8208e-06,
                    7.0449e-06,
                    7.2708e-06,
                    7.4991e-06,
                    7.7296e-06,
                    7.9624e-06,
                    8.1976e-06,
                    8.435e-06,
                    8.6747e-06,
                    8.9167e-06,
                    9.161e-06,
                    9.4077e-06,
                    9.6566e-06,
                    9.9091e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_N2O": 0.05,
                "Total_N2O_timeseries": [
                    1.9788e-08,
                    3.9904e-08,
                    6.0335e-08,
                    8.1067e-08,
                    1.0208e-07,
                    1.2335e-07,
                    1.4485e-07,
                    1.6654e-07,
                    1.8839e-07,
                    2.1036e-07,
                    2.3243e-07,
                    2.5457e-07,
                    2.768e-07,
                    2.9911e-07,
                    3.2149e-07,
                    3.4395e-07,
                    3.6649e-07,
                    3.8911e-07,
                    4.1182e-07,
                    4.3462e-07,
                    4.5773e-07,
                    4.8154e-07,
                    5.0632e-07,
                    5.3229e-07,
                    5.5955e-07,
                    5.8814e-07,
                    6.1799e-07,
                    6.4897e-07,
                    6.8082e-07,
                    7.1324e-07,
                    7.4601e-07,
                    7.7908e-07,
                    8.1241e-07,
                    8.4599e-07,
                    8.7978e-07,
                    9.1379e-07,
                    9.4801e-07,
                    9.8244e-07,
                    1.0171e-06,
                    1.0545e-06,
                    1.0903e-06,
                    1.1247e-06,
                    1.1576e-06,
                    1.1893e-06,
                    1.2199e-06,
                    1.2496e-06,
                    1.2785e-06,
                    1.3068e-06,
                    1.3349e-06,
                    1.3629e-06,
                    1.3911e-06,
                    1.4195e-06,
                    1.4482e-06,
                    1.4772e-06,
                    1.5065e-06,
                    1.5362e-06,
                    1.5664e-06,
                    1.597e-06,
                    1.6281e-06,
                    1.6597e-06,
                    1.6924e-06,
                    1.7269e-06,
                    1.764e-06,
                    1.8044e-06,
                    1.8485e-06,
                    1.8968e-06,
                    1.9494e-06,
                    2.0066e-06,
                    2.0683e-06,
                    2.1345e-06,
                    2.2059e-06,
                    2.2838e-06,
                    2.3692e-06,
                    2.4624e-06,
                    2.5636e-06,
                    2.6723e-06,
                    2.7876e-06,
                    2.9083e-06,
                    3.0325e-06,
                    3.1581e-06,
                    3.2824e-06,
                    3.4028e-06,
                    3.5175e-06,
                    3.6253e-06,
                    3.7255e-06,
                    3.8181e-06,
                    3.9038e-06,
                    3.9838e-06,
                    4.06e-06,
                    4.1349e-06,
                    4.2143e-06,
                    4.3056e-06,
                    4.4145e-06,
                    4.5449e-06,
                    4.699e-06,
                    4.8773e-06,
                    5.0786e-06,
                    5.2997e-06,
                    5.5361e-06,
                    5.7811e-06,
                    6.0307e-06,
                    6.2844e-06,
                    6.5418e-06,
                    6.8026e-06,
                    7.0665e-06,
                    7.3335e-06,
                    7.6034e-06,
                    7.8764e-06,
                    8.1524e-06,
                    8.4317e-06,
                    8.7366e-06,
                    9.0431e-06,
                    9.3463e-06,
                    9.6538e-06,
                    9.9788e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_N2O": 0.02,
                "Fossil_N2O_timeseries": [
                    7.9527e-09,
                    1.5996e-08,
                    2.4128e-08,
                    3.2349e-08,
                    4.0656e-08,
                    4.9047e-08,
                    5.7519e-08,
                    6.607e-08,
                    7.4697e-08,
                    8.3396e-08,
                    9.2164e-08,
                    1.01e-07,
                    1.0991e-07,
                    1.1888e-07,
                    1.2792e-07,
                    1.3703e-07,
                    1.4621e-07,
                    1.5546e-07,
                    1.6477e-07,
                    1.7416e-07,
                    1.8363e-07,
                    1.9323e-07,
                    2.0298e-07,
                    2.1289e-07,
                    2.2298e-07,
                    2.3325e-07,
                    2.4369e-07,
                    2.5429e-07,
                    2.6503e-07,
                    2.7589e-07,
                    2.8683e-07,
                    2.9787e-07,
                    3.0898e-07,
                    3.2019e-07,
                    3.3147e-07,
                    3.4283e-07,
                    3.5427e-07,
                    3.658e-07,
                    3.774e-07,
                    3.8915e-07,
                    4.01e-07,
                    4.1296e-07,
                    4.2501e-07,
                    4.3718e-07,
                    4.4945e-07,
                    4.6183e-07,
                    4.7432e-07,
                    4.8693e-07,
                    4.9966e-07,
                    5.125e-07,
                    5.2548e-07,
                    5.3859e-07,
                    5.5184e-07,
                    5.6525e-07,
                    5.7881e-07,
                    5.9252e-07,
                    6.0639e-07,
                    6.204e-07,
                    6.3456e-07,
                    6.4885e-07,
                    6.6328e-07,
                    6.7782e-07,
                    6.925e-07,
                    7.0729e-07,
                    7.222e-07,
                    7.3724e-07,
                    7.524e-07,
                    7.6768e-07,
                    7.8308e-07,
                    7.9862e-07,
                    8.1429e-07,
                    8.301e-07,
                    8.4606e-07,
                    8.6216e-07,
                    8.7841e-07,
                    8.9482e-07,
                    9.1137e-07,
                    9.2807e-07,
                    9.4492e-07,
                    9.619e-07,
                    9.7902e-07,
                    9.9626e-07,
                    1.0136e-06,
                    1.0311e-06,
                    1.0488e-06,
                    1.0665e-06,
                    1.0844e-06,
                    1.1025e-06,
                    1.1207e-06,
                    1.1392e-06,
                    1.1579e-06,
                    1.177e-06,
                    1.1967e-06,
                    1.217e-06,
                    1.2381e-06,
                    1.2599e-06,
                    1.2824e-06,
                    1.3057e-06,
                    1.3297e-06,
                    1.3543e-06,
                    1.3794e-06,
                    1.4051e-06,
                    1.4313e-06,
                    1.4581e-06,
                    1.4855e-06,
                    1.5135e-06,
                    1.5422e-06,
                    1.5716e-06,
                    1.6019e-06,
                    1.633e-06,
                    1.665e-06,
                    1.698e-06,
                    1.732e-06,
                    1.7671e-06,
                    1.8035e-06,
                    1.8415e-06,
                    1.8812e-06,
                    1.9231e-06,
                    1.9673e-06,
                    2.0112e-06,
                    2.0555e-06,
                    2.1028e-06,
                    2.1473e-06,
                    2.1934e-06,
                    2.2398e-06,
                    2.2888e-06,
                    2.3399e-06,
                    2.3938e-06,
                    2.4521e-06,
                    2.5128e-06,
                    2.5673e-06,
                    2.6235e-06,
                    2.6828e-06,
                    2.7466e-06,
                    2.8085e-06,
                    2.871e-06,
                    2.9341e-06,
                    2.9986e-06,
                    3.062e-06,
                    3.1182e-06,
                    3.1683e-06,
                    3.2135e-06,
                    3.2578e-06,
                    3.3031e-06,
                    3.3464e-06,
                    3.3894e-06,
                    3.4297e-06,
                    3.4725e-06,
                    3.5373e-06,
                    3.6025e-06,
                    3.6681e-06,
                    3.7364e-06,
                    3.8047e-06,
                    3.8667e-06,
                    3.9332e-06,
                    4.0058e-06,
                    4.0686e-06,
                    4.1325e-06,
                    4.1913e-06,
                    4.2504e-06,
                    4.3135e-06,
                    4.3735e-06,
                    4.4357e-06,
                    4.4999e-06,
                    4.5639e-06,
                    4.6271e-06,
                    4.6926e-06,
                    4.7595e-06,
                    4.8241e-06,
                    4.8869e-06,
                    4.9494e-06,
                    5.0132e-06
                ],
                "Land_N2O": 0.06,
                "Land_N2O_timeseries": [
                    1.1836e-08,
                    2.3908e-08,
                    3.6207e-08,
                    4.8718e-08,
                    6.1423e-08,
                    7.4302e-08,
                    8.7327e-08,
                    1.0047e-07,
                    1.137e-07,
                    1.2697e-07,
                    1.4026e-07,
                    1.5357e-07,
                    1.669e-07,
                    1.8023e-07,
                    1.9357e-07,
                    2.0692e-07,
                    2.2028e-07,
                    2.3365e-07,
                    2.4704e-07,
                    2.6046e-07,
                    2.741e-07,
                    2.8831e-07,
                    3.0334e-07,
                    3.194e-07,
                    3.3658e-07,
                    3.549e-07,
                    3.7431e-07,
                    3.9468e-07,
                    4.1579e-07,
                    4.3735e-07,
                    4.5918e-07,
                    4.8121e-07,
                    5.0343e-07,
                    5.258e-07,
                    5.4831e-07,
                    5.7096e-07,
                    5.9373e-07,
                    6.1665e-07,
                    6.3972e-07,
                    6.6534e-07,
                    6.8932e-07,
                    7.1171e-07,
                    7.3263e-07,
                    7.5217e-07,
                    7.7049e-07,
                    7.8775e-07,
                    8.0415e-07,
                    8.199e-07,
                    8.3524e-07,
                    8.5043e-07,
                    8.6565e-07,
                    8.8094e-07,
                    8.9635e-07,
                    9.1192e-07,
                    9.2768e-07,
                    9.4369e-07,
                    9.5997e-07,
                    9.7657e-07,
                    9.9353e-07,
                    1.0109e-06,
                    1.0291e-06,
                    1.0491e-06,
                    1.0715e-06,
                    1.0971e-06,
                    1.1263e-06,
                    1.1595e-06,
                    1.197e-06,
                    1.2389e-06,
                    1.2853e-06,
                    1.3359e-06,
                    1.3916e-06,
                    1.4537e-06,
                    1.5231e-06,
                    1.6003e-06,
                    1.6852e-06,
                    1.7775e-06,
                    1.8763e-06,
                    1.9802e-06,
                    2.0876e-06,
                    2.1962e-06,
                    2.3034e-06,
                    2.4066e-06,
                    2.5039e-06,
                    2.5942e-06,
                    2.6767e-06,
                    2.7516e-06,
                    2.8194e-06,
                    2.8813e-06,
                    2.9392e-06,
                    2.9957e-06,
                    3.0564e-06,
                    3.1286e-06,
                    3.2178e-06,
                    3.3279e-06,
                    3.4609e-06,
                    3.6175e-06,
                    3.7962e-06,
                    3.994e-06,
                    4.2064e-06,
                    4.4268e-06,
                    4.6513e-06,
                    4.8793e-06,
                    5.1105e-06,
                    5.3445e-06,
                    5.5811e-06,
                    5.82e-06,
                    6.0612e-06,
                    6.3047e-06,
                    6.5505e-06,
                    6.7987e-06,
                    7.0716e-06,
                    7.3451e-06,
                    7.6144e-06,
                    7.8867e-06,
                    8.1752e-06,
                    8.4666e-06,
                    8.7711e-06,
                    9.0834e-06,
                    9.3807e-06,
                    9.692e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            20.0763,
                            42.55582
                        ],
                        [
                            19.94045,
                            42.5179
                        ],
                        [
                            19.89781,
                            42.48546
                        ],
                        [
                            19.79282,
                            42.48167
                        ],
                        [
                            19.74392,
                            42.54504
                        ],
                        [
                            19.75536,
                            42.63725
                        ],
                        [
                            19.72286,
                            42.66054
                        ],
                        [
                            19.61209,
                            42.57759
                        ],
                        [
                            19.56253,
                            42.50158
                        ],
                        [
                            19.34886,
                            42.24014
                        ],
                        [
                            19.28184,
                            42.18051
                        ],
                        [
                            19.40117,
                            42.10409
                        ],
                        [
                            19.36967,
                            42.02656
                        ],
                        [
                            19.38159,
                            41.96155
                        ],
                        [
                            19.34308,
                            41.90567
                        ],
                        [
                            19.37253,
                            41.84415
                        ],
                        [
                            19.48588,
                            41.85078
                        ],
                        [
                            19.60026,
                            41.80074
                        ],
                        [
                            19.5726,
                            41.74927
                        ],
                        [
                            19.58728,
                            41.616
                        ],
                        [
                            19.50512,
                            41.53879
                        ],
                        [
                            19.50881,
                            41.48782
                        ],
                        [
                            19.42175,
                            41.38294
                        ],
                        [
                            19.41937,
                            41.33874
                        ],
                        [
                            19.50436,
                            41.29003
                        ],
                        [
                            19.51887,
                            41.24943
                        ],
                        [
                            19.47336,
                            41.16415
                        ],
                        [
                            19.44248,
                            41.00053
                        ],
                        [
                            19.35931,
                            40.70566
                        ],
                        [
                            19.31422,
                            40.64723
                        ],
                        [
                            19.37861,
                            40.5336
                        ],
                        [
                            19.49108,
                            40.44911
                        ],
                        [
                            19.4852,
                            40.34999
                        ],
                        [
                            19.37868,
                            40.30056
                        ],
                        [
                            19.44513,
                            40.23508
                        ],
                        [
                            19.75166,
                            40.0807
                        ],
                        [
                            19.85677,
                            40.04254
                        ],
                        [
                            19.95331,
                            39.89465
                        ],
                        [
                            20.01917,
                            39.8451
                        ],
                        [
                            19.97496,
                            39.75356
                        ],
                        [
                            20.00881,
                            39.69129
                        ],
                        [
                            20.19362,
                            39.64495
                        ],
                        [
                            20.32045,
                            39.72848
                        ],
                        [
                            20.30561,
                            39.81558
                        ],
                        [
                            20.39131,
                            39.78848
                        ],
                        [
                            20.41635,
                            39.84071
                        ],
                        [
                            20.33951,
                            39.92327
                        ],
                        [
                            20.313,
                            39.99022
                        ],
                        [
                            20.39246,
                            39.99593
                        ],
                        [
                            20.44901,
                            40.07288
                        ],
                        [
                            20.55092,
                            40.06383
                        ],
                        [
                            20.6778,
                            40.09705
                        ],
                        [
                            20.67861,
                            40.1888
                        ],
                        [
                            20.72411,
                            40.22355
                        ],
                        [
                            20.71414,
                            40.28276
                        ],
                        [
                            20.79029,
                            40.36348
                        ],
                        [
                            20.78584,
                            40.42467
                        ],
                        [
                            20.84495,
                            40.47938
                        ],
                        [
                            20.95378,
                            40.46897
                        ],
                        [
                            21.04158,
                            40.55823
                        ],
                        [
                            21.05673,
                            40.6675
                        ],
                        [
                            20.96026,
                            40.77087
                        ],
                        [
                            20.9802,
                            40.85566
                        ],
                        [
                            20.93896,
                            40.92408
                        ],
                        [
                            20.84752,
                            40.93705
                        ],
                        [
                            20.80197,
                            40.89825
                        ],
                        [
                            20.73227,
                            40.91173
                        ],
                        [
                            20.67063,
                            41.08735
                        ],
                        [
                            20.59676,
                            41.12984
                        ],
                        [
                            20.5164,
                            41.23053
                        ],
                        [
                            20.51657,
                            41.33753
                        ],
                        [
                            20.56003,
                            41.40367
                        ],
                        [
                            20.51399,
                            41.43809
                        ],
                        [
                            20.45628,
                            41.55402
                        ],
                        [
                            20.55777,
                            41.58187
                        ],
                        [
                            20.51446,
                            41.72184
                        ],
                        [
                            20.57239,
                            41.78788
                        ],
                        [
                            20.59429,
                            41.87733
                        ],
                        [
                            20.62603,
                            41.96333
                        ],
                        [
                            20.55555,
                            42.08404
                        ],
                        [
                            20.55799,
                            42.14669
                        ],
                        [
                            20.4567,
                            42.27187
                        ],
                        [
                            20.32479,
                            42.32597
                        ],
                        [
                            20.26033,
                            42.31916
                        ],
                        [
                            20.21848,
                            42.43544
                        ],
                        [
                            20.16495,
                            42.50593
                        ],
                        [
                            20.0763,
                            42.55582
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "DZA",
                "Country": "Algeria",
                "Total_3GHG": 0.4,
                "Total_3GHG_timeseries": [
                    1.0678e-06,
                    2.1252e-06,
                    3.1748e-06,
                    4.2185e-06,
                    5.2573e-06,
                    6.2916e-06,
                    7.3218e-06,
                    8.3591e-06,
                    9.3965e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0054,
                    0.0055,
                    0.0056,
                    0.0057,
                    0.0058,
                    0.0059,
                    0.006,
                    0.0061,
                    0.0063,
                    0.0063,
                    0.0065,
                    0.0066
                ],
                "Fossil_3GHG": 0.56,
                "Fossil_3GHG_timeseries": [
                    2.9869e-07,
                    5.9675e-07,
                    8.9353e-07,
                    1.189e-06,
                    1.4832e-06,
                    1.7761e-06,
                    2.0676e-06,
                    2.3687e-06,
                    2.6725e-06,
                    2.9792e-06,
                    3.2887e-06,
                    3.6011e-06,
                    3.9165e-06,
                    4.2301e-06,
                    4.5417e-06,
                    4.8515e-06,
                    5.1593e-06,
                    5.4662e-06,
                    5.7719e-06,
                    6.0766e-06,
                    6.3818e-06,
                    6.6876e-06,
                    6.9948e-06,
                    7.3036e-06,
                    7.6138e-06,
                    7.9256e-06,
                    8.2389e-06,
                    8.5434e-06,
                    8.8503e-06,
                    9.1594e-06,
                    9.4708e-06,
                    9.7845e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0044,
                    0.0045,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0055,
                    0.0056,
                    0.0057,
                    0.0058,
                    0.006
                ],
                "Land_3GHG": 0.11,
                "Land_3GHG_timeseries": [
                    7.6908e-07,
                    1.5284e-06,
                    2.2813e-06,
                    3.0295e-06,
                    3.7741e-06,
                    4.5156e-06,
                    5.2542e-06,
                    5.9904e-06,
                    6.724e-06,
                    7.4546e-06,
                    8.1826e-06,
                    8.9081e-06,
                    9.6314e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006
                ],
                "Total_CO2": 0.22,
                "Total_CO2_timeseries": [
                    2.9128e-07,
                    5.7111e-07,
                    8.4281e-07,
                    1.1082e-06,
                    1.3684e-06,
                    1.6238e-06,
                    1.875e-06,
                    2.1222e-06,
                    2.3656e-06,
                    2.6048e-06,
                    2.84e-06,
                    3.0716e-06,
                    3.2997e-06,
                    3.5244e-06,
                    3.7458e-06,
                    3.964e-06,
                    4.179e-06,
                    4.3908e-06,
                    4.5996e-06,
                    4.8067e-06,
                    5.0115e-06,
                    5.2138e-06,
                    5.4134e-06,
                    5.6103e-06,
                    5.8045e-06,
                    5.9959e-06,
                    6.1846e-06,
                    6.3705e-06,
                    6.5537e-06,
                    6.7361e-06,
                    6.917e-06,
                    7.0959e-06,
                    7.2725e-06,
                    7.4468e-06,
                    7.6186e-06,
                    7.7879e-06,
                    7.9546e-06,
                    8.1189e-06,
                    8.2805e-06,
                    8.4454e-06,
                    8.6111e-06,
                    8.7762e-06,
                    8.94e-06,
                    9.102e-06,
                    9.262e-06,
                    9.4199e-06,
                    9.5755e-06,
                    9.7356e-06,
                    9.9159e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0025
                ],
                "Fossil_CO2": 0.29,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.65e-09,
                    4.95e-09,
                    1.32e-08,
                    2.145e-08,
                    3.135e-08,
                    4.29e-08,
                    5.445e-08,
                    6.105e-08,
                    7.425e-08,
                    8.91e-08,
                    1.0725e-07,
                    1.3365e-07,
                    1.6656e-07,
                    2.0275e-07,
                    2.4058e-07,
                    2.8499e-07,
                    3.3598e-07,
                    3.903e-07,
                    4.5283e-07,
                    5.1211e-07,
                    5.3509e-07,
                    5.6632e-07,
                    5.8117e-07,
                    6.5377e-07,
                    7.6102e-07,
                    9.0127e-07,
                    1.1257e-06,
                    1.3367e-06,
                    1.5609e-06,
                    1.838e-06,
                    2.1809e-06,
                    2.5157e-06,
                    2.8768e-06,
                    3.2858e-06,
                    4.9896e-06,
                    6.85e-06,
                    8.6014e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023
                ],
                "Land_CO2": 0.07,
                "Land_CO2_timeseries": [
                    2.9128e-07,
                    5.7111e-07,
                    8.4281e-07,
                    1.1082e-06,
                    1.3684e-06,
                    1.6238e-06,
                    1.875e-06,
                    2.1222e-06,
                    2.3656e-06,
                    2.6048e-06,
                    2.84e-06,
                    3.0716e-06,
                    3.2997e-06,
                    3.5244e-06,
                    3.7458e-06,
                    3.964e-06,
                    4.179e-06,
                    4.3908e-06,
                    4.5996e-06,
                    4.8067e-06,
                    5.0115e-06,
                    5.2138e-06,
                    5.4134e-06,
                    5.6103e-06,
                    5.8045e-06,
                    5.9959e-06,
                    6.1846e-06,
                    6.3705e-06,
                    6.5537e-06,
                    6.7361e-06,
                    6.917e-06,
                    7.0959e-06,
                    7.2725e-06,
                    7.4468e-06,
                    7.6186e-06,
                    7.7879e-06,
                    7.9546e-06,
                    8.1189e-06,
                    8.2805e-06,
                    8.4454e-06,
                    8.6111e-06,
                    8.7762e-06,
                    8.94e-06,
                    9.102e-06,
                    9.262e-06,
                    9.4199e-06,
                    9.5755e-06,
                    9.7356e-06,
                    9.9159e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Total_CH4": 0.94,
                "Total_CH4_timeseries": [
                    7.3528e-07,
                    1.4709e-06,
                    2.2061e-06,
                    2.9411e-06,
                    3.6757e-06,
                    4.41e-06,
                    5.1439e-06,
                    5.8884e-06,
                    6.6367e-06,
                    7.3889e-06,
                    8.145e-06,
                    8.9051e-06,
                    9.6693e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039
                ],
                "Fossil_CH4": 1.4,
                "Fossil_CH4_timeseries": [
                    2.8448e-07,
                    5.6812e-07,
                    8.5027e-07,
                    1.1309e-06,
                    1.4101e-06,
                    1.6878e-06,
                    1.9639e-06,
                    2.2496e-06,
                    2.5378e-06,
                    2.8287e-06,
                    3.1224e-06,
                    3.4189e-06,
                    3.7184e-06,
                    4.0159e-06,
                    4.3115e-06,
                    4.6051e-06,
                    4.8967e-06,
                    5.1872e-06,
                    5.4766e-06,
                    5.7648e-06,
                    6.0532e-06,
                    6.3419e-06,
                    6.6315e-06,
                    6.9218e-06,
                    7.213e-06,
                    7.5049e-06,
                    7.7975e-06,
                    8.0807e-06,
                    8.3657e-06,
                    8.6527e-06,
                    8.9417e-06,
                    9.2328e-06,
                    9.526e-06,
                    9.8279e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0035,
                    0.0035,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036
                ],
                "Land_CH4": 0.18,
                "Land_CH4_timeseries": [
                    4.508e-07,
                    9.0276e-07,
                    1.3559e-06,
                    1.8102e-06,
                    2.2656e-06,
                    2.7222e-06,
                    3.18e-06,
                    3.6389e-06,
                    4.099e-06,
                    4.5602e-06,
                    5.0226e-06,
                    5.4861e-06,
                    5.9509e-06,
                    6.4167e-06,
                    6.8838e-06,
                    7.352e-06,
                    7.8213e-06,
                    8.2919e-06,
                    8.7635e-06,
                    9.2364e-06,
                    9.7104e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Total_N2O": 0.18,
                "Total_N2O_timeseries": [
                    4.1214e-08,
                    8.3182e-08,
                    1.2588e-07,
                    1.6925e-07,
                    2.1326e-07,
                    2.5784e-07,
                    3.0291e-07,
                    3.4839e-07,
                    3.9418e-07,
                    4.4017e-07,
                    4.863e-07,
                    5.3254e-07,
                    5.7889e-07,
                    6.2533e-07,
                    6.7187e-07,
                    7.185e-07,
                    7.6522e-07,
                    8.1206e-07,
                    8.5901e-07,
                    9.061e-07,
                    9.5392e-07,
                    1.0034e-06,
                    1.0554e-06,
                    1.1105e-06,
                    1.1688e-06,
                    1.2305e-06,
                    1.2954e-06,
                    1.3632e-06,
                    1.4332e-06,
                    1.5046e-06,
                    1.5768e-06,
                    1.6497e-06,
                    1.7231e-06,
                    1.7971e-06,
                    1.8716e-06,
                    1.9465e-06,
                    2.0219e-06,
                    2.0977e-06,
                    2.1741e-06,
                    2.2536e-06,
                    2.3339e-06,
                    2.415e-06,
                    2.4969e-06,
                    2.5796e-06,
                    2.6633e-06,
                    2.7479e-06,
                    2.8335e-06,
                    2.92e-06,
                    3.0076e-06,
                    3.0963e-06,
                    3.186e-06,
                    3.2769e-06,
                    3.3689e-06,
                    3.4621e-06,
                    3.5566e-06,
                    3.6524e-06,
                    3.7496e-06,
                    3.8484e-06,
                    3.9488e-06,
                    4.051e-06,
                    4.1556e-06,
                    4.2635e-06,
                    4.3756e-06,
                    4.4925e-06,
                    4.6146e-06,
                    4.7423e-06,
                    4.8757e-06,
                    5.0146e-06,
                    5.159e-06,
                    5.3082e-06,
                    5.4626e-06,
                    5.6226e-06,
                    5.7887e-06,
                    5.9608e-06,
                    6.1388e-06,
                    6.3223e-06,
                    6.5107e-06,
                    6.703e-06,
                    6.898e-06,
                    7.0944e-06,
                    7.2914e-06,
                    7.4889e-06,
                    7.687e-06,
                    7.8859e-06,
                    8.0859e-06,
                    8.2874e-06,
                    8.4908e-06,
                    8.6965e-06,
                    8.9054e-06,
                    9.118e-06,
                    9.3492e-06,
                    9.6236e-06,
                    9.9598e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002
                ],
                "Fossil_N2O": 0.2,
                "Fossil_N2O_timeseries": [
                    1.421e-08,
                    2.8633e-08,
                    4.3265e-08,
                    5.8095e-08,
                    7.3114e-08,
                    8.8307e-08,
                    1.0366e-07,
                    1.1915e-07,
                    1.3477e-07,
                    1.5048e-07,
                    1.6627e-07,
                    1.8214e-07,
                    1.9809e-07,
                    2.1411e-07,
                    2.3021e-07,
                    2.4638e-07,
                    2.6262e-07,
                    2.7894e-07,
                    2.9535e-07,
                    3.1183e-07,
                    3.2852e-07,
                    3.4563e-07,
                    3.6332e-07,
                    3.817e-07,
                    4.0084e-07,
                    4.2075e-07,
                    4.414e-07,
                    4.627e-07,
                    4.8453e-07,
                    5.067e-07,
                    5.2911e-07,
                    5.5171e-07,
                    5.7449e-07,
                    5.9743e-07,
                    6.2054e-07,
                    6.4378e-07,
                    6.6718e-07,
                    6.9074e-07,
                    7.1446e-07,
                    7.3857e-07,
                    7.6292e-07,
                    7.8752e-07,
                    8.1238e-07,
                    8.375e-07,
                    8.6289e-07,
                    8.8856e-07,
                    9.1453e-07,
                    9.4081e-07,
                    9.6742e-07,
                    9.9437e-07,
                    1.0217e-06,
                    1.0495e-06,
                    1.0777e-06,
                    1.1064e-06,
                    1.1357e-06,
                    1.1655e-06,
                    1.1958e-06,
                    1.2266e-06,
                    1.258e-06,
                    1.2898e-06,
                    1.322e-06,
                    1.3546e-06,
                    1.3876e-06,
                    1.421e-06,
                    1.4549e-06,
                    1.4891e-06,
                    1.5237e-06,
                    1.5587e-06,
                    1.5942e-06,
                    1.63e-06,
                    1.6663e-06,
                    1.703e-06,
                    1.7401e-06,
                    1.7777e-06,
                    1.8157e-06,
                    1.8541e-06,
                    1.893e-06,
                    1.9323e-06,
                    1.972e-06,
                    2.0122e-06,
                    2.0534e-06,
                    2.0968e-06,
                    2.1432e-06,
                    2.1934e-06,
                    2.2479e-06,
                    2.3071e-06,
                    2.3712e-06,
                    2.4401e-06,
                    2.5136e-06,
                    2.5914e-06,
                    2.6739e-06,
                    2.7621e-06,
                    2.8569e-06,
                    2.9588e-06,
                    3.0679e-06,
                    3.1842e-06,
                    3.3073e-06,
                    3.4365e-06,
                    3.5707e-06,
                    3.7087e-06,
                    3.8495e-06,
                    3.9928e-06,
                    4.1383e-06,
                    4.2859e-06,
                    4.4356e-06,
                    4.5874e-06,
                    4.7412e-06,
                    4.8975e-06,
                    5.0563e-06,
                    5.218e-06,
                    5.3842e-06,
                    5.5573e-06,
                    5.7398e-06,
                    5.9339e-06,
                    6.142e-06,
                    6.3662e-06,
                    6.6086e-06,
                    6.8711e-06,
                    7.1558e-06,
                    7.4618e-06,
                    7.7775e-06,
                    8.1245e-06,
                    8.4069e-06,
                    8.6188e-06,
                    8.9795e-06,
                    9.3851e-06,
                    9.8305e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.18,
                "Land_N2O_timeseries": [
                    2.7005e-08,
                    5.4549e-08,
                    8.2611e-08,
                    1.1116e-07,
                    1.4015e-07,
                    1.6953e-07,
                    1.9925e-07,
                    2.2924e-07,
                    2.5941e-07,
                    2.8969e-07,
                    3.2003e-07,
                    3.504e-07,
                    3.808e-07,
                    4.1122e-07,
                    4.4166e-07,
                    4.7212e-07,
                    5.026e-07,
                    5.3311e-07,
                    5.6366e-07,
                    5.9427e-07,
                    6.2539e-07,
                    6.5781e-07,
                    6.9213e-07,
                    7.2876e-07,
                    7.6795e-07,
                    8.0975e-07,
                    8.5404e-07,
                    9.0051e-07,
                    9.4868e-07,
                    9.9789e-07,
                    1.0477e-06,
                    1.098e-06,
                    1.1486e-06,
                    1.1997e-06,
                    1.2511e-06,
                    1.3027e-06,
                    1.3547e-06,
                    1.407e-06,
                    1.4596e-06,
                    1.515e-06,
                    1.5709e-06,
                    1.6274e-06,
                    1.6845e-06,
                    1.7421e-06,
                    1.8004e-06,
                    1.8594e-06,
                    1.919e-06,
                    1.9792e-06,
                    2.0402e-06,
                    2.1019e-06,
                    2.1643e-06,
                    2.2274e-06,
                    2.2912e-06,
                    2.3557e-06,
                    2.4209e-06,
                    2.4869e-06,
                    2.5538e-06,
                    2.6217e-06,
                    2.6908e-06,
                    2.7612e-06,
                    2.8336e-06,
                    2.9089e-06,
                    2.988e-06,
                    3.0715e-06,
                    3.1598e-06,
                    3.2533e-06,
                    3.352e-06,
                    3.4559e-06,
                    3.5648e-06,
                    3.6782e-06,
                    3.7963e-06,
                    3.9196e-06,
                    4.0485e-06,
                    4.1831e-06,
                    4.3231e-06,
                    4.4682e-06,
                    4.6177e-06,
                    4.7707e-06,
                    4.926e-06,
                    5.0822e-06,
                    5.238e-06,
                    5.3921e-06,
                    5.5438e-06,
                    5.6925e-06,
                    5.838e-06,
                    5.9803e-06,
                    6.1196e-06,
                    6.2565e-06,
                    6.3917e-06,
                    6.5265e-06,
                    6.6753e-06,
                    6.8615e-06,
                    7.1029e-06,
                    7.4114e-06,
                    7.7932e-06,
                    8.2482e-06,
                    8.771e-06,
                    9.35e-06,
                    9.9677e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            11.9985,
                            23.5127
                        ],
                        [
                            11.60896,
                            24.25957
                        ],
                        [
                            11.4244,
                            24.19974
                        ],
                        [
                            11.13561,
                            24.39056
                        ],
                        [
                            10.96304,
                            24.47478
                        ],
                        [
                            10.71444,
                            24.56611
                        ],
                        [
                            10.48269,
                            24.47923
                        ],
                        [
                            10.423,
                            24.47883
                        ],
                        [
                            10.25429,
                            24.60476
                        ],
                        [
                            10.21685,
                            24.75109
                        ],
                        [
                            10.05505,
                            24.83969
                        ],
                        [
                            10.03691,
                            24.96182
                        ],
                        [
                            10.02459,
                            25.33656
                        ],
                        [
                            9.39859,
                            26.20038
                        ],
                        [
                            9.44742,
                            26.24921
                        ],
                        [
                            9.52609,
                            26.38362
                        ],
                        [
                            9.86492,
                            26.52287
                        ],
                        [
                            9.91709,
                            26.64751
                        ],
                        [
                            9.90308,
                            26.74501
                        ],
                        [
                            9.92757,
                            26.86027
                        ],
                        [
                            9.87892,
                            26.91179
                        ],
                        [
                            9.84562,
                            27.02323
                        ],
                        [
                            9.82916,
                            27.15237
                        ],
                        [
                            9.78203,
                            27.27807
                        ],
                        [
                            9.81552,
                            27.4592
                        ],
                        [
                            9.85763,
                            27.50068
                        ],
                        [
                            9.94116,
                            27.73783
                        ],
                        [
                            9.96109,
                            27.88622
                        ],
                        [
                            9.83768,
                            28.28692
                        ],
                        [
                            9.9054,
                            28.76569
                        ],
                        [
                            9.87506,
                            29.02699
                        ],
                        [
                            9.78262,
                            29.42682
                        ],
                        [
                            9.53771,
                            29.90395
                        ],
                        [
                            9.4214,
                            30.03975
                        ],
                        [
                            9.39103,
                            30.16566
                        ],
                        [
                            9.55156,
                            30.24639
                        ],
                        [
                            9.47009,
                            30.56122
                        ],
                        [
                            9.31376,
                            31.16831
                        ],
                        [
                            9.07522,
                            32.08578
                        ],
                        [
                            8.35839,
                            32.50184
                        ],
                        [
                            8.3223,
                            32.82239
                        ],
                        [
                            8.10702,
                            33.04709
                        ],
                        [
                            8.14064,
                            33.0839
                        ],
                        [
                            7.81023,
                            33.20718
                        ],
                        [
                            7.74313,
                            33.42388
                        ],
                        [
                            7.62932,
                            33.5718
                        ],
                        [
                            7.59446,
                            33.6445
                        ],
                        [
                            7.58656,
                            33.75155
                        ],
                        [
                            7.52654,
                            33.7973
                        ],
                        [
                            7.52353,
                            33.90499
                        ],
                        [
                            7.55304,
                            34.01625
                        ],
                        [
                            7.53048,
                            34.05872
                        ],
                        [
                            7.60474,
                            34.11112
                        ],
                        [
                            7.65382,
                            34.19495
                        ],
                        [
                            7.72432,
                            34.16719
                        ],
                        [
                            7.80349,
                            34.219
                        ],
                        [
                            7.8563,
                            34.40314
                        ],
                        [
                            7.9338,
                            34.42078
                        ],
                        [
                            8.04028,
                            34.49001
                        ],
                        [
                            8.14662,
                            34.53337
                        ],
                        [
                            8.24337,
                            34.63153
                        ],
                        [
                            8.23745,
                            34.67605
                        ],
                        [
                            8.29628,
                            34.72938
                        ],
                        [
                            8.24807,
                            34.91995
                        ],
                        [
                            8.31372,
                            34.94796
                        ],
                        [
                            8.31665,
                            35.00977
                        ],
                        [
                            8.35692,
                            35.09632
                        ],
                        [
                            8.40217,
                            35.12943
                        ],
                        [
                            8.47271,
                            35.23691
                        ],
                        [
                            8.33435,
                            35.28009
                        ],
                        [
                            8.31238,
                            35.31434
                        ],
                        [
                            8.32994,
                            35.42257
                        ],
                        [
                            8.38382,
                            35.48586
                        ],
                        [
                            8.3609,
                            35.52365
                        ],
                        [
                            8.35552,
                            35.66799
                        ],
                        [
                            8.26616,
                            35.73023
                        ],
                        [
                            8.25557,
                            35.88559
                        ],
                        [
                            8.29064,
                            35.95772
                        ],
                        [
                            8.29797,
                            36.03958
                        ],
                        [
                            8.34414,
                            36.10256
                        ],
                        [
                            8.30762,
                            36.17184
                        ],
                        [
                            8.38914,
                            36.30432
                        ],
                        [
                            8.40421,
                            36.42183
                        ],
                        [
                            8.35562,
                            36.44362
                        ],
                        [
                            8.20988,
                            36.44713
                        ],
                        [
                            8.15563,
                            36.49607
                        ],
                        [
                            8.29043,
                            36.53889
                        ],
                        [
                            8.32888,
                            36.57377
                        ],
                        [
                            8.44635,
                            36.6196
                        ],
                        [
                            8.48635,
                            36.69434
                        ],
                        [
                            8.48653,
                            36.7781
                        ],
                        [
                            8.57145,
                            36.77315
                        ],
                        [
                            8.65594,
                            36.80934
                        ],
                        [
                            8.62675,
                            36.85677
                        ],
                        [
                            8.64209,
                            36.94115
                        ],
                        [
                            8.43,
                            36.89695
                        ],
                        [
                            8.36271,
                            36.92033
                        ],
                        [
                            8.27343,
                            36.91691
                        ],
                        [
                            8.22702,
                            36.94992
                        ],
                        [
                            7.99151,
                            36.85861
                        ],
                        [
                            7.88646,
                            36.84252
                        ],
                        [
                            7.76968,
                            36.87211
                        ],
                        [
                            7.7652,
                            36.95899
                        ],
                        [
                            7.7103,
                            36.95064
                        ],
                        [
                            7.5664,
                            36.98713
                        ],
                        [
                            7.51225,
                            37.04035
                        ],
                        [
                            7.21467,
                            37.08759
                        ],
                        [
                            7.25369,
                            37.02546
                        ],
                        [
                            7.20072,
                            36.94255
                        ],
                        [
                            6.92796,
                            36.88208
                        ],
                        [
                            6.84208,
                            36.95233
                        ],
                        [
                            6.67038,
                            36.95047
                        ],
                        [
                            6.58177,
                            36.97738
                        ],
                        [
                            6.54488,
                            37.05172
                        ],
                        [
                            6.47353,
                            37.08634
                        ],
                        [
                            6.3394,
                            37.06691
                        ],
                        [
                            6.26704,
                            37.0245
                        ],
                        [
                            6.23677,
                            36.92104
                        ],
                        [
                            5.99973,
                            36.841
                        ],
                        [
                            5.80134,
                            36.80764
                        ],
                        [
                            5.69391,
                            36.81647
                        ],
                        [
                            5.59618,
                            36.77638
                        ],
                        [
                            5.49878,
                            36.67858
                        ],
                        [
                            5.29902,
                            36.63877
                        ],
                        [
                            5.21752,
                            36.64992
                        ],
                        [
                            5.08342,
                            36.71235
                        ],
                        [
                            5.10099,
                            36.77408
                        ],
                        [
                            5.02663,
                            36.7907
                        ],
                        [
                            4.92086,
                            36.84795
                        ],
                        [
                            4.75918,
                            36.89385
                        ],
                        [
                            4.70814,
                            36.88142
                        ],
                        [
                            4.39772,
                            36.89142
                        ],
                        [
                            4.29117,
                            36.90636
                        ],
                        [
                            4.10374,
                            36.89125
                        ],
                        [
                            3.94904,
                            36.89876
                        ],
                        [
                            3.89145,
                            36.92128
                        ],
                        [
                            3.73372,
                            36.88564
                        ],
                        [
                            3.68581,
                            36.84596
                        ],
                        [
                            3.48127,
                            36.76796
                        ],
                        [
                            3.32667,
                            36.78644
                        ],
                        [
                            3.23147,
                            36.77996
                        ],
                        [
                            3.1509,
                            36.74214
                        ],
                        [
                            3.08107,
                            36.75288
                        ],
                        [
                            3.01121,
                            36.81803
                        ],
                        [
                            2.89958,
                            36.80377
                        ],
                        [
                            2.82181,
                            36.71387
                        ],
                        [
                            2.64171,
                            36.61734
                        ],
                        [
                            2.55841,
                            36.59288
                        ],
                        [
                            2.43228,
                            36.59538
                        ],
                        [
                            2.34791,
                            36.64338
                        ],
                        [
                            2.12664,
                            36.58661
                        ],
                        [
                            2.00362,
                            36.56674
                        ],
                        [
                            1.91203,
                            36.57601
                        ],
                        [
                            1.65367,
                            36.55398
                        ],
                        [
                            1.51194,
                            36.53002
                        ],
                        [
                            1.34008,
                            36.54945
                        ],
                        [
                            1.31437,
                            36.51813
                        ],
                        [
                            1.18781,
                            36.51426
                        ],
                        [
                            0.93918,
                            36.44733
                        ],
                        [
                            0.87012,
                            36.37278
                        ],
                        [
                            0.75165,
                            36.33437
                        ],
                        [
                            0.65876,
                            36.32932
                        ],
                        [
                            0.5924,
                            36.28465
                        ],
                        [
                            0.34003,
                            36.18975
                        ],
                        [
                            0.12977,
                            36.03651
                        ],
                        [
                            0.02382,
                            35.85877
                        ],
                        [
                            -0.11146,
                            35.78918
                        ],
                        [
                            -0.27523,
                            35.81948
                        ],
                        [
                            -0.29219,
                            35.87012
                        ],
                        [
                            -0.35248,
                            35.90561
                        ],
                        [
                            -0.47988,
                            35.86997
                        ],
                        [
                            -0.50084,
                            35.79444
                        ],
                        [
                            -0.6075,
                            35.7209
                        ],
                        [
                            -0.68191,
                            35.71406
                        ],
                        [
                            -0.82551,
                            35.76652
                        ],
                        [
                            -0.86082,
                            35.71627
                        ],
                        [
                            -0.95508,
                            35.7168
                        ],
                        [
                            -1.04944,
                            35.66413
                        ],
                        [
                            -1.15557,
                            35.57429
                        ],
                        [
                            -1.18192,
                            35.58033
                        ],
                        [
                            -1.25577,
                            35.39594
                        ],
                        [
                            -1.28537,
                            35.35651
                        ],
                        [
                            -1.4174,
                            35.29968
                        ],
                        [
                            -1.46215,
                            35.30739
                        ],
                        [
                            -1.69983,
                            35.17757
                        ],
                        [
                            -1.77257,
                            35.11969
                        ],
                        [
                            -1.96113,
                            35.07273
                        ],
                        [
                            -2.08355,
                            35.07336
                        ],
                        [
                            -2.15565,
                            35.10134
                        ],
                        [
                            -2.20974,
                            35.0846
                        ],
                        [
                            -2.20601,
                            35.05081
                        ],
                        [
                            -2.07844,
                            34.95499
                        ],
                        [
                            -1.98322,
                            34.93454
                        ],
                        [
                            -1.95954,
                            34.87342
                        ],
                        [
                            -1.88285,
                            34.81332
                        ],
                        [
                            -1.74696,
                            34.75314
                        ],
                        [
                            -1.84606,
                            34.62384
                        ],
                        [
                            -1.74801,
                            34.5233
                        ],
                        [
                            -1.69298,
                            34.49983
                        ],
                        [
                            -1.78102,
                            34.39324
                        ],
                        [
                            -1.70585,
                            34.31002
                        ],
                        [
                            -1.70916,
                            34.22989
                        ],
                        [
                            -1.64602,
                            34.10476
                        ],
                        [
                            -1.69659,
                            33.87223
                        ],
                        [
                            -1.66954,
                            33.77407
                        ],
                        [
                            -1.72646,
                            33.73458
                        ],
                        [
                            -1.70006,
                            33.67631
                        ],
                        [
                            -1.64568,
                            33.6758
                        ],
                        [
                            -1.59401,
                            33.60445
                        ],
                        [
                            -1.58792,
                            33.52927
                        ],
                        [
                            -1.66105,
                            33.37782
                        ],
                        [
                            -1.6675,
                            33.27915
                        ],
                        [
                            -1.57087,
                            33.14499
                        ],
                        [
                            -1.47471,
                            33.07517
                        ],
                        [
                            -1.49342,
                            32.96742
                        ],
                        [
                            -1.54098,
                            32.95655
                        ],
                        [
                            -1.38196,
                            32.74377
                        ],
                        [
                            -1.26695,
                            32.6935
                        ],
                        [
                            -0.9994,
                            32.51715
                        ],
                        [
                            -1.0631,
                            32.45179
                        ],
                        [
                            -1.20381,
                            32.39303
                        ],
                        [
                            -1.24181,
                            32.20638
                        ],
                        [
                            -1.15505,
                            32.11173
                        ],
                        [
                            -1.24505,
                            32.07572
                        ],
                        [
                            -1.47606,
                            32.09507
                        ],
                        [
                            -1.5814,
                            32.09272
                        ],
                        [
                            -1.75183,
                            32.12268
                        ],
                        [
                            -1.89454,
                            32.16073
                        ],
                        [
                            -2.01639,
                            32.17514
                        ],
                        [
                            -2.1367,
                            32.13933
                        ],
                        [
                            -2.26968,
                            32.16137
                        ],
                        [
                            -2.53443,
                            32.14741
                        ],
                        [
                            -2.59516,
                            32.11227
                        ],
                        [
                            -2.90057,
                            32.11844
                        ],
                        [
                            -2.92752,
                            32.04186
                        ],
                        [
                            -2.84388,
                            31.88364
                        ],
                        [
                            -2.82442,
                            31.8013
                        ],
                        [
                            -3.66499,
                            31.63171
                        ],
                        [
                            -3.66971,
                            31.37788
                        ],
                        [
                            -3.76059,
                            31.33104
                        ],
                        [
                            -3.75645,
                            31.17916
                        ],
                        [
                            -3.67009,
                            31.15325
                        ],
                        [
                            -3.5514,
                            31.06445
                        ],
                        [
                            -3.53901,
                            30.95792
                        ],
                        [
                            -3.64945,
                            30.84367
                        ],
                        [
                            -3.6389,
                            30.70005
                        ],
                        [
                            -3.84456,
                            30.62689
                        ],
                        [
                            -3.98376,
                            30.59615
                        ],
                        [
                            -4.14959,
                            30.58384
                        ],
                        [
                            -4.32252,
                            30.52736
                        ],
                        [
                            -4.59741,
                            30.2912
                        ],
                        [
                            -4.93553,
                            30.13983
                        ],
                        [
                            -5.27837,
                            29.90054
                        ],
                        [
                            -5.32807,
                            29.83746
                        ],
                        [
                            -5.32358,
                            29.77823
                        ],
                        [
                            -5.55115,
                            29.5012
                        ],
                        [
                            -5.64016,
                            29.49906
                        ],
                        [
                            -5.72135,
                            29.58597
                        ],
                        [
                            -5.78954,
                            29.61264
                        ],
                        [
                            -6.06352,
                            29.56337
                        ],
                        [
                            -6.1933,
                            29.58385
                        ],
                        [
                            -6.24133,
                            29.5684
                        ],
                        [
                            -6.45983,
                            29.56313
                        ],
                        [
                            -6.52448,
                            29.52066
                        ],
                        [
                            -6.69752,
                            29.51202
                        ],
                        [
                            -6.77994,
                            29.46201
                        ],
                        [
                            -6.90763,
                            29.49922
                        ],
                        [
                            -7.02234,
                            29.49444
                        ],
                        [
                            -7.15253,
                            29.5192
                        ],
                        [
                            -7.24973,
                            29.47431
                        ],
                        [
                            -7.33806,
                            29.39754
                        ],
                        [
                            -7.4868,
                            29.3631
                        ],
                        [
                            -7.58324,
                            29.37465
                        ],
                        [
                            -7.6487,
                            29.30529
                        ],
                        [
                            -7.77368,
                            29.25817
                        ],
                        [
                            -7.89384,
                            29.18672
                        ],
                        [
                            -7.96402,
                            29.12719
                        ],
                        [
                            -8.22371,
                            28.98884
                        ],
                        [
                            -8.45111,
                            28.80244
                        ],
                        [
                            -8.66421,
                            28.71337
                        ],
                        [
                            -8.66665,
                            27.66204
                        ],
                        [
                            -8.66667,
                            27.31274
                        ],
                        [
                            -7.85542,
                            26.83217
                        ],
                        [
                            -7.21442,
                            26.44891
                        ],
                        [
                            -6.75,
                            26.17015
                        ],
                        [
                            -6.31388,
                            25.90535
                        ],
                        [
                            -5.68229,
                            25.52041
                        ],
                        [
                            -4.83333,
                            24.99759
                        ],
                        [
                            -4.34244,
                            24.68283
                        ],
                        [
                            -3.83333,
                            24.36397
                        ],
                        [
                            -2.98222,
                            23.82438
                        ],
                        [
                            -2.25,
                            23.35635
                        ],
                        [
                            -1.66667,
                            22.98038
                        ],
                        [
                            -1,
                            22.54746
                        ],
                        [
                            -0.4043,
                            22.15752
                        ],
                        [
                            1.15442,
                            21.1249
                        ],
                        [
                            1.19303,
                            20.97151
                        ],
                        [
                            1.16464,
                            20.78943
                        ],
                        [
                            1.1789,
                            20.72425
                        ],
                        [
                            1.3165,
                            20.73045
                        ],
                        [
                            1.38638,
                            20.65217
                        ],
                        [
                            1.60224,
                            20.59255
                        ],
                        [
                            1.66719,
                            20.52498
                        ],
                        [
                            1.67043,
                            20.39966
                        ],
                        [
                            1.77566,
                            20.33209
                        ],
                        [
                            1.79744,
                            20.29166
                        ],
                        [
                            1.88264,
                            20.28863
                        ],
                        [
                            2.00021,
                            20.23673
                        ],
                        [
                            2.04297,
                            20.26344
                        ],
                        [
                            2.13208,
                            20.23633
                        ],
                        [
                            2.21079,
                            20.3109
                        ],
                        [
                            2.30431,
                            20.27459
                        ],
                        [
                            2.33269,
                            20.17975
                        ],
                        [
                            2.40254,
                            20.11668
                        ],
                        [
                            2.38058,
                            20.02172
                        ],
                        [
                            2.48171,
                            20.10134
                        ],
                        [
                            2.56204,
                            20.03556
                        ],
                        [
                            2.69686,
                            20.07089
                        ],
                        [
                            2.73587,
                            19.99069
                        ],
                        [
                            2.83053,
                            19.95969
                        ],
                        [
                            2.97662,
                            19.94845
                        ],
                        [
                            3.03647,
                            19.90722
                        ],
                        [
                            3.19936,
                            19.8393
                        ],
                        [
                            3.25342,
                            19.83229
                        ],
                        [
                            3.22945,
                            19.70944
                        ],
                        [
                            3.25048,
                            19.63305
                        ],
                        [
                            3.23155,
                            19.58385
                        ],
                        [
                            3.26465,
                            19.44962
                        ],
                        [
                            3.20951,
                            19.43004
                        ],
                        [
                            3.17716,
                            19.35578
                        ],
                        [
                            3.1969,
                            19.27103
                        ],
                        [
                            3.12409,
                            19.18096
                        ],
                        [
                            3.16562,
                            19.10741
                        ],
                        [
                            3.3604,
                            18.9639
                        ],
                        [
                            4.24295,
                            19.1389
                        ],
                        [
                            5.1955,
                            19.32392
                        ],
                        [
                            5.81302,
                            19.44127
                        ],
                        [
                            6.10689,
                            19.69413
                        ],
                        [
                            6.70447,
                            20.2039
                        ],
                        [
                            7.04491,
                            20.49229
                        ],
                        [
                            7.45937,
                            20.84132
                        ],
                        [
                            8.21619,
                            21.30133
                        ],
                        [
                            8.91646,
                            21.72254
                        ],
                        [
                            9.6516,
                            22.15752
                        ],
                        [
                            10.25713,
                            22.5149
                        ],
                        [
                            10.79315,
                            22.82406
                        ],
                        [
                            11.36313,
                            23.15256
                        ],
                        [
                            11.9985,
                            23.5127
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "AND",
                "Country": "Andorra",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    1.173e-08,
                    2.302e-08,
                    3.3972e-08,
                    4.4886e-08,
                    5.5165e-08,
                    6.4957e-08,
                    7.4264e-08,
                    8.2952e-08,
                    9.1608e-08,
                    1.0037e-07,
                    1.0929e-07,
                    1.1801e-07,
                    1.2677e-07,
                    1.3555e-07,
                    1.4454e-07,
                    1.5356e-07,
                    1.6274e-07,
                    1.7177e-07,
                    1.8086e-07,
                    1.8925e-07,
                    1.983e-07,
                    2.0817e-07,
                    2.1855e-07,
                    2.2745e-07,
                    2.371e-07,
                    2.4655e-07,
                    2.5602e-07,
                    2.6561e-07,
                    2.7516e-07,
                    2.8522e-07,
                    2.9543e-07,
                    3.059e-07,
                    3.165e-07,
                    3.2614e-07,
                    3.3527e-07,
                    3.4383e-07,
                    3.5294e-07,
                    3.6273e-07,
                    3.727e-07,
                    3.833e-07,
                    3.941e-07,
                    4.0417e-07,
                    4.1298e-07,
                    4.2363e-07,
                    4.3374e-07,
                    4.443e-07,
                    4.5531e-07,
                    4.6657e-07,
                    4.7862e-07,
                    4.9042e-07,
                    5.014e-07,
                    5.1221e-07,
                    5.2349e-07,
                    5.3476e-07,
                    5.4682e-07,
                    5.5946e-07,
                    5.7331e-07,
                    5.8635e-07,
                    5.9927e-07,
                    6.1156e-07,
                    6.2378e-07,
                    6.3572e-07,
                    6.4964e-07,
                    6.5874e-07,
                    6.6612e-07,
                    6.7356e-07,
                    6.7981e-07,
                    6.839e-07,
                    6.8574e-07,
                    6.8852e-07,
                    6.8732e-07,
                    6.8902e-07,
                    6.9058e-07,
                    6.9433e-07,
                    6.9676e-07,
                    6.9379e-07,
                    6.9476e-07,
                    6.9503e-07,
                    6.9691e-07,
                    6.9692e-07,
                    6.9425e-07,
                    6.8961e-07,
                    6.837e-07,
                    6.818e-07,
                    6.8108e-07,
                    6.8027e-07,
                    6.8118e-07,
                    6.8298e-07,
                    6.8649e-07,
                    6.897e-07,
                    6.9833e-07,
                    7.0632e-07,
                    7.1497e-07,
                    7.1973e-07,
                    7.2263e-07,
                    7.3278e-07,
                    7.4337e-07,
                    7.5746e-07,
                    7.7366e-07,
                    7.9684e-07,
                    8.2177e-07,
                    8.5231e-07,
                    8.8122e-07,
                    9.0968e-07,
                    9.4363e-07,
                    9.7741e-07,
                    1.0296e-06,
                    1.0704e-06,
                    1.1057e-06,
                    1.1409e-06,
                    1.1787e-06,
                    1.2152e-06,
                    1.2517e-06,
                    1.29e-06,
                    1.3316e-06,
                    1.3703e-06,
                    1.404e-06,
                    1.4376e-06,
                    1.4698e-06,
                    1.5086e-06,
                    1.5481e-06,
                    1.591e-06,
                    1.6387e-06,
                    1.6909e-06,
                    1.7464e-06,
                    1.8074e-06,
                    1.874e-06,
                    1.9457e-06,
                    2.0244e-06,
                    2.1061e-06,
                    2.1915e-06,
                    2.2805e-06,
                    2.3761e-06,
                    2.4779e-06,
                    2.5818e-06,
                    2.6925e-06,
                    2.8048e-06,
                    2.9175e-06,
                    3.0339e-06,
                    3.3304e-06,
                    3.6322e-06,
                    3.9405e-06,
                    4.253e-06,
                    4.5646e-06,
                    4.8845e-06,
                    5.213e-06,
                    5.5368e-06,
                    5.862e-06,
                    6.1895e-06,
                    6.5237e-06,
                    6.858e-06,
                    7.1971e-06,
                    7.5367e-06,
                    7.8878e-06,
                    8.2473e-06,
                    8.5853e-06,
                    8.9153e-06,
                    9.2395e-06,
                    9.538e-06,
                    9.8283e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    3.8555e-09,
                    7.685e-09,
                    1.1535e-08,
                    1.6025e-08,
                    2.0361e-08,
                    2.4597e-08,
                    2.873e-08,
                    3.2617e-08,
                    3.6717e-08,
                    4.1184e-08,
                    4.5873e-08,
                    5.0409e-08,
                    5.5142e-08,
                    6.0185e-08,
                    6.5354e-08,
                    7.0799e-08,
                    7.6118e-08,
                    8.1369e-08,
                    8.6707e-08,
                    9.156e-08,
                    9.6874e-08,
                    1.0284e-07,
                    1.0911e-07,
                    1.1402e-07,
                    1.1968e-07,
                    1.2503e-07,
                    1.3041e-07,
                    1.3579e-07,
                    1.4103e-07,
                    1.4675e-07,
                    1.526e-07,
                    1.5875e-07,
                    1.6512e-07,
                    1.7071e-07,
                    1.7569e-07,
                    1.8031e-07,
                    1.8514e-07,
                    1.9058e-07,
                    1.9618e-07,
                    2.0258e-07,
                    2.0897e-07,
                    2.144e-07,
                    2.1854e-07,
                    2.2463e-07,
                    2.3023e-07,
                    2.3639e-07,
                    2.4315e-07,
                    2.5026e-07,
                    2.5822e-07,
                    2.6595e-07,
                    2.7284e-07,
                    2.7948e-07,
                    2.8647e-07,
                    2.938e-07,
                    3.0181e-07,
                    3.1057e-07,
                    3.2062e-07,
                    3.3002e-07,
                    3.3923e-07,
                    3.4805e-07,
                    3.5725e-07,
                    3.6665e-07,
                    3.7852e-07,
                    3.861e-07,
                    3.9262e-07,
                    3.997e-07,
                    4.0635e-07,
                    4.1107e-07,
                    4.1381e-07,
                    4.1819e-07,
                    4.1921e-07,
                    4.2344e-07,
                    4.2775e-07,
                    4.3477e-07,
                    4.4075e-07,
                    4.4163e-07,
                    4.4678e-07,
                    4.5133e-07,
                    4.5757e-07,
                    4.6239e-07,
                    4.6434e-07,
                    4.6436e-07,
                    4.6311e-07,
                    4.6584e-07,
                    4.6969e-07,
                    4.7344e-07,
                    4.7903e-07,
                    4.8537e-07,
                    4.9328e-07,
                    4.9757e-07,
                    5.0535e-07,
                    5.1065e-07,
                    5.153e-07,
                    5.1477e-07,
                    5.1064e-07,
                    5.1276e-07,
                    5.1415e-07,
                    5.1774e-07,
                    5.2163e-07,
                    5.268e-07,
                    5.3682e-07,
                    5.4902e-07,
                    5.6124e-07,
                    5.7368e-07,
                    5.8778e-07,
                    6.0288e-07,
                    6.1683e-07,
                    6.3076e-07,
                    6.4357e-07,
                    6.5932e-07,
                    6.7578e-07,
                    6.9297e-07,
                    7.1173e-07,
                    7.3295e-07,
                    7.5795e-07,
                    7.8042e-07,
                    7.981e-07,
                    8.1509e-07,
                    8.3125e-07,
                    8.5075e-07,
                    8.6832e-07,
                    8.869e-07,
                    9.0642e-07,
                    9.2594e-07,
                    9.4592e-07,
                    9.6722e-07,
                    9.9099e-07,
                    1.0166e-06,
                    1.0449e-06,
                    1.0725e-06,
                    1.1011e-06,
                    1.1304e-06,
                    1.162e-06,
                    1.1956e-06,
                    1.2298e-06,
                    1.2661e-06,
                    1.3051e-06,
                    1.3429e-06,
                    1.38e-06,
                    1.5963e-06,
                    1.8197e-06,
                    2.0469e-06,
                    2.2769e-06,
                    2.506e-06,
                    2.7442e-06,
                    2.9944e-06,
                    3.2442e-06,
                    3.4999e-06,
                    3.7623e-06,
                    4.0295e-06,
                    4.2971e-06,
                    4.5702e-06,
                    4.8471e-06,
                    5.1364e-06,
                    5.433e-06,
                    5.7135e-06,
                    5.9886e-06,
                    6.2644e-06,
                    6.5242e-06,
                    6.7837e-06,
                    7.023e-06,
                    7.2549e-06,
                    7.4785e-06,
                    7.6902e-06,
                    7.8977e-06,
                    8.1067e-06,
                    8.3147e-06,
                    8.5359e-06,
                    8.7501e-06,
                    8.9125e-06,
                    9.0719e-06,
                    9.2259e-06
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [
                    7.8745e-09,
                    1.5335e-08,
                    2.2437e-08,
                    2.8861e-08,
                    3.4804e-08,
                    4.036e-08,
                    4.5533e-08,
                    5.0335e-08,
                    5.489e-08,
                    5.9188e-08,
                    6.342e-08,
                    6.7604e-08,
                    7.1624e-08,
                    7.5364e-08,
                    7.9181e-08,
                    8.2763e-08,
                    8.662e-08,
                    9.0401e-08,
                    9.4155e-08,
                    9.769e-08,
                    1.0142e-07,
                    1.0532e-07,
                    1.0943e-07,
                    1.1343e-07,
                    1.1742e-07,
                    1.2152e-07,
                    1.2562e-07,
                    1.2982e-07,
                    1.3414e-07,
                    1.3847e-07,
                    1.4283e-07,
                    1.4715e-07,
                    1.5138e-07,
                    1.5542e-07,
                    1.5957e-07,
                    1.6352e-07,
                    1.6781e-07,
                    1.7214e-07,
                    1.7652e-07,
                    1.8072e-07,
                    1.8514e-07,
                    1.8977e-07,
                    1.9443e-07,
                    1.99e-07,
                    2.0351e-07,
                    2.0791e-07,
                    2.1216e-07,
                    2.1631e-07,
                    2.204e-07,
                    2.2447e-07,
                    2.2856e-07,
                    2.3272e-07,
                    2.3702e-07,
                    2.4095e-07,
                    2.4501e-07,
                    2.4888e-07,
                    2.5269e-07,
                    2.5634e-07,
                    2.6004e-07,
                    2.6352e-07,
                    2.6653e-07,
                    2.6907e-07,
                    2.7112e-07,
                    2.7264e-07,
                    2.735e-07,
                    2.7386e-07,
                    2.7347e-07,
                    2.7283e-07,
                    2.7192e-07,
                    2.7033e-07,
                    2.6811e-07,
                    2.6558e-07,
                    2.6283e-07,
                    2.5956e-07,
                    2.5601e-07,
                    2.5216e-07,
                    2.4797e-07,
                    2.437e-07,
                    2.3934e-07,
                    2.3453e-07,
                    2.299e-07,
                    2.2525e-07,
                    2.2059e-07,
                    2.1596e-07,
                    2.1139e-07,
                    2.0683e-07,
                    2.0215e-07,
                    1.9761e-07,
                    1.9321e-07,
                    1.9213e-07,
                    1.9298e-07,
                    1.9567e-07,
                    1.9967e-07,
                    2.0496e-07,
                    2.1199e-07,
                    2.2002e-07,
                    2.2922e-07,
                    2.3971e-07,
                    2.5203e-07,
                    2.7003e-07,
                    2.8495e-07,
                    3.0329e-07,
                    3.1998e-07,
                    3.36e-07,
                    3.5585e-07,
                    3.7454e-07,
                    4.1276e-07,
                    4.3959e-07,
                    4.621e-07,
                    4.8158e-07,
                    5.0297e-07,
                    5.2218e-07,
                    5.4001e-07,
                    5.5705e-07,
                    5.7362e-07,
                    5.8989e-07,
                    6.0589e-07,
                    6.2253e-07,
                    6.3856e-07,
                    6.5783e-07,
                    6.7977e-07,
                    7.0411e-07,
                    7.3228e-07,
                    7.6499e-07,
                    8.0053e-07,
                    8.4017e-07,
                    8.8303e-07,
                    9.2908e-07,
                    9.7946e-07,
                    1.0336e-06,
                    1.0904e-06,
                    1.1501e-06,
                    1.2142e-06,
                    1.2823e-06,
                    1.3521e-06,
                    1.4264e-06,
                    1.4998e-06,
                    1.5746e-06,
                    1.6538e-06,
                    1.7341e-06,
                    1.8126e-06,
                    1.8936e-06,
                    1.9762e-06,
                    2.0586e-06,
                    2.1404e-06,
                    2.2186e-06,
                    2.2926e-06,
                    2.3621e-06,
                    2.4273e-06,
                    2.4942e-06,
                    2.5609e-06,
                    2.6268e-06,
                    2.6896e-06,
                    2.7513e-06,
                    2.8143e-06,
                    2.8718e-06,
                    2.9267e-06,
                    2.9751e-06,
                    3.0138e-06,
                    3.0445e-06,
                    3.0679e-06,
                    3.0905e-06,
                    3.1113e-06,
                    3.1294e-06,
                    3.1454e-06,
                    3.1602e-06,
                    3.1761e-06,
                    3.1921e-06,
                    3.2079e-06,
                    3.2177e-06,
                    3.2261e-06,
                    3.2248e-06
                ],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    5.1535e-09,
                    9.9935e-09,
                    1.4575e-08,
                    1.8579e-08,
                    2.2204e-08,
                    2.5542e-08,
                    2.86e-08,
                    3.1388e-08,
                    3.4034e-08,
                    3.6525e-08,
                    3.8885e-08,
                    4.1129e-08,
                    4.3142e-08,
                    4.4809e-08,
                    4.6486e-08,
                    4.7861e-08,
                    4.9445e-08,
                    5.0886e-08,
                    5.2234e-08,
                    5.3295e-08,
                    5.4461e-08,
                    5.5688e-08,
                    5.7024e-08,
                    5.8129e-08,
                    5.9131e-08,
                    6.0115e-08,
                    6.0995e-08,
                    6.187e-08,
                    6.275e-08,
                    6.3547e-08,
                    6.4339e-08,
                    6.5065e-08,
                    6.5665e-08,
                    6.6044e-08,
                    6.65e-08,
                    6.6721e-08,
                    6.7254e-08,
                    6.7804e-08,
                    6.8359e-08,
                    6.8767e-08,
                    6.9305e-08,
                    6.9977e-08,
                    7.0609e-08,
                    7.1071e-08,
                    7.1407e-08,
                    7.1577e-08,
                    7.1539e-08,
                    7.1351e-08,
                    7.106e-08,
                    7.0719e-08,
                    7.0312e-08,
                    6.9899e-08,
                    6.9553e-08,
                    6.8767e-08,
                    6.8041e-08,
                    6.7067e-08,
                    6.5956e-08,
                    6.4614e-08,
                    6.3256e-08,
                    6.1578e-08,
                    5.9521e-08,
                    5.7079e-08,
                    5.4214e-08,
                    5.0903e-08,
                    4.7014e-08,
                    4.2702e-08,
                    3.7708e-08,
                    3.2549e-08,
                    2.7203e-08,
                    2.1241e-08,
                    1.4735e-08,
                    7.997e-09,
                    1.111e-09,
                    -0.000000006226,
                    -0.000000013766,
                    -0.000000021533,
                    -0.000000029568,
                    -0.00000003762,
                    -0.000000045683,
                    -0.00000005412,
                    -0.000000062497,
                    -0.000000071021,
                    -0.000000079673,
                    -0.000000088423,
                    -0.000000097234,
                    -0.00000010616,
                    -0.00000011532,
                    -0.00000012445,
                    -0.00000013356,
                    -0.00000013947,
                    -0.00000014353,
                    -0.00000014591,
                    -0.00000014722,
                    -0.0000001475,
                    -0.00000014633,
                    -0.00000014444,
                    -0.00000014166,
                    -0.00000013782,
                    -0.00000013233,
                    -0.00000012126,
                    -0.00000011335,
                    -0.00000010211,
                    -0.000000092614,
                    -0.000000083914,
                    -0.000000071489,
                    -0.000000060357,
                    -0.00000002981,
                    -0.000000010797,
                    3.7455e-09,
                    1.507e-08,
                    2.8039e-08,
                    3.8484e-08,
                    4.714e-08,
                    5.4598e-08,
                    6.1149e-08,
                    6.7001e-08,
                    7.2182e-08,
                    7.7644e-08,
                    8.2165e-08,
                    8.5888e-08,
                    8.9282e-08,
                    9.2048e-08,
                    9.4501e-08,
                    9.6954e-08,
                    9.8263e-08,
                    1.0002e-07,
                    1.015e-07,
                    1.0216e-07,
                    1.0274e-07,
                    1.036e-07,
                    1.0475e-07,
                    1.0589e-07,
                    1.0724e-07,
                    1.0887e-07,
                    1.1062e-07,
                    1.13e-07,
                    1.1445e-07,
                    1.156e-07,
                    1.1761e-07,
                    3.0308e-07,
                    4.8782e-07,
                    6.7774e-07,
                    8.7188e-07,
                    1.0649e-06,
                    1.2653e-06,
                    1.4765e-06,
                    1.6923e-06,
                    1.9189e-06,
                    2.1548e-06,
                    2.3955e-06,
                    2.6358e-06,
                    2.8791e-06,
                    3.1237e-06,
                    3.3786e-06,
                    3.6405e-06,
                    3.8877e-06,
                    4.131e-06,
                    4.374e-06,
                    4.6063e-06,
                    4.8387e-06,
                    5.0588e-06,
                    5.2769e-06,
                    5.4901e-06,
                    5.6964e-06,
                    5.9043e-06,
                    6.1138e-06,
                    6.3214e-06,
                    6.5421e-06,
                    6.7578e-06,
                    6.9238e-06,
                    7.0854e-06,
                    7.2498e-06
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.8315e-07,
                    3.663e-07,
                    5.4945e-07,
                    7.3425e-07,
                    9.174e-07,
                    1.1088e-06,
                    1.3134e-06,
                    1.5229e-06,
                    1.7441e-06,
                    1.975e-06,
                    2.211e-06,
                    2.4469e-06,
                    2.6862e-06,
                    2.9271e-06,
                    3.1795e-06,
                    3.4386e-06,
                    3.6844e-06,
                    3.927e-06,
                    4.1695e-06,
                    4.4022e-06,
                    4.6349e-06,
                    4.8559e-06,
                    5.0754e-06,
                    5.2899e-06,
                    5.4978e-06,
                    5.7073e-06,
                    5.9186e-06,
                    6.1281e-06,
                    6.3509e-06,
                    6.5687e-06,
                    6.7369e-06,
                    6.9004e-06,
                    7.0665e-06
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [
                    5.1535e-09,
                    9.9935e-09,
                    1.4575e-08,
                    1.8579e-08,
                    2.2204e-08,
                    2.5542e-08,
                    2.86e-08,
                    3.1388e-08,
                    3.4034e-08,
                    3.6525e-08,
                    3.8885e-08,
                    4.1129e-08,
                    4.3142e-08,
                    4.4809e-08,
                    4.6486e-08,
                    4.7861e-08,
                    4.9445e-08,
                    5.0886e-08,
                    5.2234e-08,
                    5.3295e-08,
                    5.4461e-08,
                    5.5688e-08,
                    5.7024e-08,
                    5.8129e-08,
                    5.9131e-08,
                    6.0115e-08,
                    6.0995e-08,
                    6.187e-08,
                    6.275e-08,
                    6.3547e-08,
                    6.4339e-08,
                    6.5065e-08,
                    6.5665e-08,
                    6.6044e-08,
                    6.65e-08,
                    6.6721e-08,
                    6.7254e-08,
                    6.7804e-08,
                    6.8359e-08,
                    6.8767e-08,
                    6.9305e-08,
                    6.9977e-08,
                    7.0609e-08,
                    7.1071e-08,
                    7.1407e-08,
                    7.1577e-08,
                    7.1539e-08,
                    7.1351e-08,
                    7.106e-08,
                    7.0719e-08,
                    7.0312e-08,
                    6.9899e-08,
                    6.9553e-08,
                    6.8767e-08,
                    6.8041e-08,
                    6.7067e-08,
                    6.5956e-08,
                    6.4614e-08,
                    6.3256e-08,
                    6.1578e-08,
                    5.9521e-08,
                    5.7079e-08,
                    5.4214e-08,
                    5.0903e-08,
                    4.7014e-08,
                    4.2702e-08,
                    3.7708e-08,
                    3.2549e-08,
                    2.7203e-08,
                    2.1241e-08,
                    1.4735e-08,
                    7.997e-09,
                    1.111e-09,
                    -0.000000006226,
                    -0.000000013766,
                    -0.000000021533,
                    -0.000000029568,
                    -0.00000003762,
                    -0.000000045683,
                    -0.00000005412,
                    -0.000000062497,
                    -0.000000071021,
                    -0.000000079673,
                    -0.000000088423,
                    -0.000000097234,
                    -0.00000010616,
                    -0.00000011532,
                    -0.00000012445,
                    -0.00000013356,
                    -0.00000013947,
                    -0.00000014353,
                    -0.00000014591,
                    -0.00000014722,
                    -0.0000001475,
                    -0.00000014633,
                    -0.00000014444,
                    -0.00000014166,
                    -0.00000013782,
                    -0.00000013233,
                    -0.00000012126,
                    -0.00000011335,
                    -0.00000010211,
                    -0.000000092614,
                    -0.000000083914,
                    -0.000000071489,
                    -0.000000060357,
                    -0.00000002981,
                    -0.000000010797,
                    3.7455e-09,
                    1.507e-08,
                    2.8039e-08,
                    3.8484e-08,
                    4.714e-08,
                    5.4598e-08,
                    6.1149e-08,
                    6.7001e-08,
                    7.2182e-08,
                    7.7644e-08,
                    8.2165e-08,
                    8.5888e-08,
                    8.9282e-08,
                    9.2048e-08,
                    9.4501e-08,
                    9.6954e-08,
                    9.8263e-08,
                    1.0002e-07,
                    1.015e-07,
                    1.0216e-07,
                    1.0274e-07,
                    1.036e-07,
                    1.0475e-07,
                    1.0589e-07,
                    1.0724e-07,
                    1.0887e-07,
                    1.1062e-07,
                    1.13e-07,
                    1.1445e-07,
                    1.156e-07,
                    1.1761e-07,
                    1.1993e-07,
                    1.2152e-07,
                    1.2829e-07,
                    1.3763e-07,
                    1.4748e-07,
                    1.565e-07,
                    1.6308e-07,
                    1.6935e-07,
                    1.7482e-07,
                    1.797e-07,
                    1.8447e-07,
                    1.8883e-07,
                    1.9288e-07,
                    1.9658e-07,
                    1.9909e-07,
                    2.0188e-07,
                    2.0322e-07,
                    2.0395e-07,
                    2.0443e-07,
                    2.0408e-07,
                    2.0381e-07,
                    2.0289e-07,
                    2.0148e-07,
                    2.0021e-07,
                    1.9861e-07,
                    1.9692e-07,
                    1.9525e-07,
                    1.9333e-07,
                    1.9127e-07,
                    1.8914e-07,
                    1.8687e-07,
                    1.8493e-07,
                    1.8336e-07
                ],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [
                    6.0883e-09,
                    1.2043e-08,
                    1.791e-08,
                    2.4309e-08,
                    3.0447e-08,
                    3.6377e-08,
                    4.2097e-08,
                    4.7463e-08,
                    5.2936e-08,
                    5.8668e-08,
                    6.4686e-08,
                    7.0617e-08,
                    7.6808e-08,
                    8.3374e-08,
                    9.013e-08,
                    9.7227e-08,
                    1.0426e-07,
                    1.1129e-07,
                    1.1847e-07,
                    1.2524e-07,
                    1.3255e-07,
                    1.406e-07,
                    1.4903e-07,
                    1.562e-07,
                    1.6419e-07,
                    1.7195e-07,
                    1.7983e-07,
                    1.878e-07,
                    1.9571e-07,
                    2.0419e-07,
                    2.1282e-07,
                    2.2177e-07,
                    2.3097e-07,
                    2.3943e-07,
                    2.4729e-07,
                    2.5482e-07,
                    2.6258e-07,
                    2.7099e-07,
                    2.7958e-07,
                    2.8897e-07,
                    2.9839e-07,
                    3.0687e-07,
                    3.1408e-07,
                    3.2326e-07,
                    3.3198e-07,
                    3.4128e-07,
                    3.5121e-07,
                    3.6151e-07,
                    3.7268e-07,
                    3.8363e-07,
                    3.9383e-07,
                    4.0387e-07,
                    4.1432e-07,
                    4.252e-07,
                    4.3682e-07,
                    4.4928e-07,
                    4.631e-07,
                    4.7635e-07,
                    4.8949e-07,
                    5.0231e-07,
                    5.1544e-07,
                    5.2866e-07,
                    5.4428e-07,
                    5.5551e-07,
                    5.656e-07,
                    5.7617e-07,
                    5.8621e-07,
                    5.9424e-07,
                    6.002e-07,
                    6.0771e-07,
                    6.1177e-07,
                    6.1895e-07,
                    6.2611e-07,
                    6.3589e-07,
                    6.4453e-07,
                    6.4798e-07,
                    6.5561e-07,
                    6.6254e-07,
                    6.7107e-07,
                    6.781e-07,
                    6.8235e-07,
                    6.8476e-07,
                    6.8597e-07,
                    6.9123e-07,
                    6.9768e-07,
                    7.041e-07,
                    7.1241e-07,
                    7.2154e-07,
                    7.323e-07,
                    7.3951e-07,
                    7.5021e-07,
                    7.5845e-07,
                    7.6605e-07,
                    7.6849e-07,
                    7.6733e-07,
                    7.7244e-07,
                    7.7681e-07,
                    7.8339e-07,
                    7.9026e-07,
                    7.984e-07,
                    8.1136e-07,
                    8.2645e-07,
                    8.415e-07,
                    8.5668e-07,
                    8.734e-07,
                    8.91e-07,
                    9.0734e-07,
                    9.2353e-07,
                    9.385e-07,
                    9.5635e-07,
                    9.749e-07,
                    9.9416e-07,
                    1.015e-06,
                    1.0382e-06,
                    1.0652e-06,
                    1.0896e-06,
                    1.1091e-06,
                    1.1278e-06,
                    1.1457e-06,
                    1.1705e-06,
                    1.1953e-06,
                    1.2232e-06,
                    1.2549e-06,
                    1.2901e-06,
                    1.3293e-06,
                    1.373e-06,
                    1.4216e-06,
                    1.475e-06,
                    1.5346e-06,
                    1.5966e-06,
                    1.6615e-06,
                    1.7286e-06,
                    1.7998e-06,
                    1.8763e-06,
                    1.9549e-06,
                    2.0391e-06,
                    2.1255e-06,
                    2.2116e-06,
                    2.302e-06,
                    2.3903e-06,
                    2.4816e-06,
                    2.5736e-06,
                    2.6651e-06,
                    2.7561e-06,
                    2.8461e-06,
                    2.9326e-06,
                    3.0124e-06,
                    3.088e-06,
                    3.1577e-06,
                    3.2295e-06,
                    3.3019e-06,
                    3.3755e-06,
                    3.4481e-06,
                    3.5212e-06,
                    3.5959e-06,
                    3.6646e-06,
                    3.7294e-06,
                    3.7901e-06,
                    3.8367e-06,
                    3.8751e-06,
                    3.8995e-06,
                    3.9177e-06,
                    3.9304e-06,
                    3.9355e-06,
                    3.9326e-06,
                    3.9286e-06,
                    3.9261e-06,
                    3.9242e-06,
                    3.9199e-06,
                    3.9086e-06,
                    3.8971e-06,
                    3.869e-06
                ],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [
                    3.5876e-09,
                    7.146e-09,
                    1.0722e-08,
                    1.4934e-08,
                    1.899e-08,
                    2.2943e-08,
                    2.679e-08,
                    3.0387e-08,
                    3.4196e-08,
                    3.8369e-08,
                    4.2762e-08,
                    4.7001e-08,
                    5.1434e-08,
                    5.6174e-08,
                    6.1039e-08,
                    6.6177e-08,
                    7.1188e-08,
                    7.6128e-08,
                    8.1152e-08,
                    8.5691e-08,
                    9.0687e-08,
                    9.6333e-08,
                    1.0227e-07,
                    1.0685e-07,
                    1.1216e-07,
                    1.1716e-07,
                    1.2218e-07,
                    1.2719e-07,
                    1.3206e-07,
                    1.3741e-07,
                    1.4288e-07,
                    1.4865e-07,
                    1.5463e-07,
                    1.5984e-07,
                    1.6443e-07,
                    1.6865e-07,
                    1.7308e-07,
                    1.7813e-07,
                    1.8333e-07,
                    1.8931e-07,
                    1.9527e-07,
                    2.0028e-07,
                    2.0399e-07,
                    2.0963e-07,
                    2.1478e-07,
                    2.2048e-07,
                    2.2678e-07,
                    2.3342e-07,
                    2.409e-07,
                    2.4814e-07,
                    2.5453e-07,
                    2.6067e-07,
                    2.6714e-07,
                    2.7394e-07,
                    2.8141e-07,
                    2.8962e-07,
                    2.9911e-07,
                    3.0793e-07,
                    3.1656e-07,
                    3.2479e-07,
                    3.334e-07,
                    3.4219e-07,
                    3.5345e-07,
                    3.6042e-07,
                    3.6631e-07,
                    3.7277e-07,
                    3.7878e-07,
                    3.8287e-07,
                    3.8496e-07,
                    3.8869e-07,
                    3.8905e-07,
                    3.9261e-07,
                    3.9624e-07,
                    4.0257e-07,
                    4.0785e-07,
                    4.0801e-07,
                    4.1245e-07,
                    4.1627e-07,
                    4.2177e-07,
                    4.2585e-07,
                    4.2705e-07,
                    4.263e-07,
                    4.2424e-07,
                    4.2613e-07,
                    4.2909e-07,
                    4.3192e-07,
                    4.3653e-07,
                    4.4185e-07,
                    4.4869e-07,
                    4.5187e-07,
                    4.5851e-07,
                    4.6263e-07,
                    4.6608e-07,
                    4.6433e-07,
                    4.5893e-07,
                    4.5976e-07,
                    4.5981e-07,
                    4.6203e-07,
                    4.6449e-07,
                    4.6818e-07,
                    4.7664e-07,
                    4.8715e-07,
                    4.9752e-07,
                    5.0794e-07,
                    5.198e-07,
                    5.3245e-07,
                    5.4372e-07,
                    5.5473e-07,
                    5.6439e-07,
                    5.7677e-07,
                    5.8963e-07,
                    6.0298e-07,
                    6.1763e-07,
                    6.3447e-07,
                    6.5481e-07,
                    6.7235e-07,
                    6.8484e-07,
                    6.964e-07,
                    7.069e-07,
                    7.2075e-07,
                    7.3201e-07,
                    7.4367e-07,
                    7.5538e-07,
                    7.6626e-07,
                    7.7772e-07,
                    7.9042e-07,
                    8.0495e-07,
                    8.2101e-07,
                    8.3957e-07,
                    8.5737e-07,
                    8.7599e-07,
                    8.9421e-07,
                    9.1312e-07,
                    9.3407e-07,
                    9.5602e-07,
                    9.8028e-07,
                    1.007e-06,
                    1.0321e-06,
                    1.0585e-06,
                    1.0822e-06,
                    1.1105e-06,
                    1.1414e-06,
                    1.1732e-06,
                    1.2057e-06,
                    1.2378e-06,
                    1.2681e-06,
                    1.2957e-06,
                    1.3228e-06,
                    1.348e-06,
                    1.373e-06,
                    1.3987e-06,
                    1.4266e-06,
                    1.4564e-06,
                    1.4872e-06,
                    1.5187e-06,
                    1.548e-06,
                    1.5755e-06,
                    1.6039e-06,
                    1.6265e-06,
                    1.6488e-06,
                    1.6627e-06,
                    1.671e-06,
                    1.6759e-06,
                    1.6757e-06,
                    1.6696e-06,
                    1.6634e-06,
                    1.6578e-06,
                    1.6523e-06,
                    1.6447e-06,
                    1.6349e-06,
                    1.6266e-06,
                    1.6107e-06
                ],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [
                    2.5007e-09,
                    4.8968e-09,
                    7.1882e-09,
                    9.375e-09,
                    1.1457e-08,
                    1.3435e-08,
                    1.5308e-08,
                    1.7076e-08,
                    1.874e-08,
                    2.0299e-08,
                    2.1924e-08,
                    2.3616e-08,
                    2.5375e-08,
                    2.72e-08,
                    2.9091e-08,
                    3.1049e-08,
                    3.3074e-08,
                    3.5165e-08,
                    3.7322e-08,
                    3.9546e-08,
                    4.1861e-08,
                    4.4267e-08,
                    4.6763e-08,
                    4.935e-08,
                    5.2028e-08,
                    5.4796e-08,
                    5.7656e-08,
                    6.0606e-08,
                    6.3647e-08,
                    6.6778e-08,
                    6.9938e-08,
                    7.3127e-08,
                    7.6344e-08,
                    7.959e-08,
                    8.2864e-08,
                    8.6167e-08,
                    8.9499e-08,
                    9.2859e-08,
                    9.6247e-08,
                    9.9665e-08,
                    1.0311e-07,
                    1.0659e-07,
                    1.101e-07,
                    1.1364e-07,
                    1.172e-07,
                    1.208e-07,
                    1.2443e-07,
                    1.2809e-07,
                    1.3178e-07,
                    1.355e-07,
                    1.3931e-07,
                    1.432e-07,
                    1.4718e-07,
                    1.5125e-07,
                    1.5541e-07,
                    1.5966e-07,
                    1.6399e-07,
                    1.6841e-07,
                    1.7292e-07,
                    1.7752e-07,
                    1.8204e-07,
                    1.8647e-07,
                    1.9083e-07,
                    1.951e-07,
                    1.9929e-07,
                    2.034e-07,
                    2.0743e-07,
                    2.1137e-07,
                    2.1524e-07,
                    2.1902e-07,
                    2.2272e-07,
                    2.2634e-07,
                    2.2987e-07,
                    2.3332e-07,
                    2.3668e-07,
                    2.3996e-07,
                    2.4316e-07,
                    2.4627e-07,
                    2.493e-07,
                    2.5224e-07,
                    2.553e-07,
                    2.5846e-07,
                    2.6173e-07,
                    2.6511e-07,
                    2.6859e-07,
                    2.7218e-07,
                    2.7589e-07,
                    2.7969e-07,
                    2.8361e-07,
                    2.8764e-07,
                    2.917e-07,
                    2.9581e-07,
                    2.9997e-07,
                    3.0416e-07,
                    3.084e-07,
                    3.1268e-07,
                    3.17e-07,
                    3.2136e-07,
                    3.2577e-07,
                    3.3022e-07,
                    3.3472e-07,
                    3.393e-07,
                    3.4397e-07,
                    3.4874e-07,
                    3.536e-07,
                    3.5856e-07,
                    3.6362e-07,
                    3.688e-07,
                    3.7411e-07,
                    3.7958e-07,
                    3.8526e-07,
                    3.9118e-07,
                    3.9735e-07,
                    4.0375e-07,
                    4.1039e-07,
                    4.1723e-07,
                    4.2425e-07,
                    4.3145e-07,
                    4.3883e-07,
                    4.4976e-07,
                    4.6333e-07,
                    4.7957e-07,
                    4.9951e-07,
                    5.2384e-07,
                    5.5163e-07,
                    5.8261e-07,
                    6.1663e-07,
                    6.5397e-07,
                    6.9504e-07,
                    7.3926e-07,
                    7.8554e-07,
                    8.3437e-07,
                    8.867e-07,
                    9.4223e-07,
                    9.9887e-07,
                    1.0589e-06,
                    1.1186e-06,
                    1.1795e-06,
                    1.2435e-06,
                    1.3081e-06,
                    1.3711e-06,
                    1.4322e-06,
                    1.4919e-06,
                    1.5504e-06,
                    1.6083e-06,
                    1.6645e-06,
                    1.7167e-06,
                    1.7652e-06,
                    1.8097e-06,
                    1.8565e-06,
                    1.9032e-06,
                    1.9489e-06,
                    1.9918e-06,
                    2.0339e-06,
                    2.0772e-06,
                    2.1166e-06,
                    2.1539e-06,
                    2.1862e-06,
                    2.2103e-06,
                    2.2262e-06,
                    2.2368e-06,
                    2.2467e-06,
                    2.2545e-06,
                    2.2598e-06,
                    2.263e-06,
                    2.2652e-06,
                    2.2683e-06,
                    2.2719e-06,
                    2.2751e-06,
                    2.2737e-06,
                    2.2705e-06,
                    2.2583e-06
                ],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [
                    4.8824e-10,
                    9.8412e-10,
                    1.4874e-09,
                    1.9977e-09,
                    2.5147e-09,
                    3.0379e-09,
                    3.5665e-09,
                    4.1e-09,
                    4.6376e-09,
                    5.1783e-09,
                    5.7216e-09,
                    6.2674e-09,
                    6.8156e-09,
                    7.366e-09,
                    7.9188e-09,
                    8.4738e-09,
                    9.0312e-09,
                    9.5909e-09,
                    1.0153e-08,
                    1.0718e-08,
                    1.129e-08,
                    1.1878e-08,
                    1.2487e-08,
                    1.3123e-08,
                    1.3786e-08,
                    1.4478e-08,
                    1.5199e-08,
                    1.5943e-08,
                    1.6707e-08,
                    1.7484e-08,
                    1.8269e-08,
                    1.9062e-08,
                    1.986e-08,
                    2.0664e-08,
                    2.1474e-08,
                    2.2288e-08,
                    2.3108e-08,
                    2.3933e-08,
                    2.4764e-08,
                    2.5559e-08,
                    2.6413e-08,
                    2.7323e-08,
                    2.8284e-08,
                    2.9294e-08,
                    3.0347e-08,
                    3.1439e-08,
                    3.2563e-08,
                    3.3713e-08,
                    3.4883e-08,
                    3.6065e-08,
                    3.7252e-08,
                    3.8438e-08,
                    3.9619e-08,
                    4.0792e-08,
                    4.1955e-08,
                    4.3108e-08,
                    4.4253e-08,
                    4.5392e-08,
                    4.653e-08,
                    4.7672e-08,
                    4.8822e-08,
                    4.998e-08,
                    5.1146e-08,
                    5.232e-08,
                    5.3503e-08,
                    5.4695e-08,
                    5.5897e-08,
                    5.7109e-08,
                    5.8333e-08,
                    5.9567e-08,
                    6.0816e-08,
                    6.2081e-08,
                    6.3365e-08,
                    6.467e-08,
                    6.5997e-08,
                    6.7346e-08,
                    6.8716e-08,
                    7.0107e-08,
                    7.1517e-08,
                    7.2944e-08,
                    7.4393e-08,
                    7.5876e-08,
                    7.7405e-08,
                    7.8987e-08,
                    8.0625e-08,
                    8.2323e-08,
                    8.408e-08,
                    8.5893e-08,
                    8.7755e-08,
                    8.9658e-08,
                    9.1642e-08,
                    9.3781e-08,
                    9.6135e-08,
                    9.8742e-08,
                    1.0163e-07,
                    1.0479e-07,
                    1.0822e-07,
                    1.1188e-07,
                    1.1573e-07,
                    1.197e-07,
                    1.2376e-07,
                    1.2796e-07,
                    1.3234e-07,
                    1.3692e-07,
                    1.4172e-07,
                    1.4676e-07,
                    1.5206e-07,
                    1.5761e-07,
                    1.6342e-07,
                    1.6947e-07,
                    1.7581e-07,
                    1.8251e-07,
                    1.8962e-07,
                    1.9718e-07,
                    2.0522e-07,
                    2.1373e-07,
                    2.2271e-07,
                    2.3213e-07,
                    2.4192e-07,
                    2.5218e-07,
                    2.6347e-07,
                    2.7572e-07,
                    2.8932e-07,
                    3.0388e-07,
                    3.1883e-07,
                    3.3435e-07,
                    3.5094e-07,
                    3.6853e-07,
                    3.8701e-07,
                    4.0587e-07,
                    4.2524e-07,
                    4.4606e-07,
                    4.6907e-07,
                    4.9274e-07,
                    5.1631e-07,
                    5.4035e-07,
                    5.6487e-07,
                    5.903e-07,
                    6.1422e-07,
                    6.3702e-07,
                    6.6279e-07,
                    6.8922e-07,
                    7.1605e-07,
                    7.4361e-07,
                    7.7312e-07,
                    8.0395e-07,
                    8.3208e-07,
                    8.5515e-07,
                    8.7707e-07,
                    8.9867e-07,
                    9.2039e-07,
                    9.4247e-07,
                    9.6488e-07,
                    9.8794e-07,
                    1.0109e-06,
                    1.033e-06,
                    1.0549e-06,
                    1.0755e-06,
                    1.095e-06,
                    1.1145e-06,
                    1.1325e-06,
                    1.1508e-06,
                    1.1693e-06,
                    1.1877e-06,
                    1.2063e-06,
                    1.2245e-06,
                    1.2433e-06,
                    1.2617e-06,
                    1.2804e-06,
                    1.2978e-06,
                    1.3156e-06,
                    1.3319e-06
                ],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [
                    2.679e-10,
                    5.3904e-10,
                    8.1335e-10,
                    1.0908e-09,
                    1.3712e-09,
                    1.6546e-09,
                    1.9408e-09,
                    2.2296e-09,
                    2.5209e-09,
                    2.8145e-09,
                    3.1104e-09,
                    3.4083e-09,
                    3.7085e-09,
                    4.0107e-09,
                    4.3151e-09,
                    4.6216e-09,
                    4.9303e-09,
                    5.2411e-09,
                    5.5541e-09,
                    5.8692e-09,
                    6.1876e-09,
                    6.5108e-09,
                    6.84e-09,
                    7.1763e-09,
                    7.5201e-09,
                    7.8715e-09,
                    8.2303e-09,
                    8.5957e-09,
                    8.9669e-09,
                    9.3423e-09,
                    9.721e-09,
                    1.0103e-08,
                    1.0488e-08,
                    1.0875e-08,
                    1.1266e-08,
                    1.1659e-08,
                    1.2055e-08,
                    1.2454e-08,
                    1.2855e-08,
                    1.3272e-08,
                    1.3694e-08,
                    1.4123e-08,
                    1.4558e-08,
                    1.5e-08,
                    1.5449e-08,
                    1.5906e-08,
                    1.637e-08,
                    1.6842e-08,
                    1.7322e-08,
                    1.781e-08,
                    1.8307e-08,
                    1.8814e-08,
                    1.9331e-08,
                    1.986e-08,
                    2.04e-08,
                    2.0951e-08,
                    2.1513e-08,
                    2.2085e-08,
                    2.2667e-08,
                    2.3256e-08,
                    2.3853e-08,
                    2.4457e-08,
                    2.5067e-08,
                    2.5683e-08,
                    2.6304e-08,
                    2.6931e-08,
                    2.7564e-08,
                    2.8203e-08,
                    2.8848e-08,
                    2.9501e-08,
                    3.0161e-08,
                    3.083e-08,
                    3.151e-08,
                    3.22e-08,
                    3.29e-08,
                    3.3611e-08,
                    3.4331e-08,
                    3.506e-08,
                    3.5796e-08,
                    3.6538e-08,
                    3.729e-08,
                    3.8063e-08,
                    3.8867e-08,
                    3.9708e-08,
                    4.0593e-08,
                    4.1523e-08,
                    4.2501e-08,
                    4.3525e-08,
                    4.4593e-08,
                    4.57e-08,
                    4.684e-08,
                    4.8013e-08,
                    4.9215e-08,
                    5.0446e-08,
                    5.1709e-08,
                    5.3005e-08,
                    5.4339e-08,
                    5.5714e-08,
                    5.7139e-08,
                    5.862e-08,
                    6.0183e-08,
                    6.187e-08,
                    6.3714e-08,
                    6.5742e-08,
                    6.7976e-08,
                    7.043e-08,
                    7.3115e-08,
                    7.6033e-08,
                    7.9181e-08,
                    8.2549e-08,
                    8.6143e-08,
                    8.9987e-08,
                    9.4096e-08,
                    9.8479e-08,
                    1.0314e-07,
                    1.0807e-07,
                    1.1326e-07,
                    1.187e-07,
                    1.2435e-07,
                    1.3e-07,
                    1.3631e-07,
                    1.4323e-07,
                    1.5104e-07,
                    1.5968e-07,
                    1.682e-07,
                    1.768e-07,
                    1.8604e-07,
                    1.9558e-07,
                    2.0533e-07,
                    2.1517e-07,
                    2.2514e-07,
                    2.3619e-07,
                    2.4883e-07,
                    2.6152e-07,
                    2.7375e-07,
                    2.8581e-07,
                    2.981e-07,
                    3.1085e-07,
                    3.215e-07,
                    3.3094e-07,
                    3.4284e-07,
                    3.5612e-07,
                    3.694e-07,
                    3.8284e-07,
                    3.9761e-07,
                    4.1293e-07,
                    4.2555e-07,
                    4.3301e-07,
                    4.3919e-07,
                    4.4544e-07,
                    4.5143e-07,
                    4.5741e-07,
                    4.6361e-07,
                    4.6964e-07,
                    4.7565e-07,
                    4.8104e-07,
                    4.861e-07,
                    4.9094e-07,
                    4.9554e-07,
                    5.0002e-07,
                    5.0427e-07,
                    5.085e-07,
                    5.1271e-07,
                    5.1672e-07,
                    5.2075e-07,
                    5.2478e-07,
                    5.288e-07,
                    5.3281e-07,
                    5.3677e-07,
                    5.4063e-07,
                    5.4487e-07,
                    5.4877e-07
                ],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": [
                    2.2034e-10,
                    4.4508e-10,
                    6.7405e-10,
                    9.0696e-10,
                    1.1435e-09,
                    1.3833e-09,
                    1.6257e-09,
                    1.8704e-09,
                    2.1166e-09,
                    2.3637e-09,
                    2.6112e-09,
                    2.859e-09,
                    3.1071e-09,
                    3.3553e-09,
                    3.6037e-09,
                    3.8522e-09,
                    4.1009e-09,
                    4.3498e-09,
                    4.5991e-09,
                    4.8489e-09,
                    5.1028e-09,
                    5.3673e-09,
                    5.6473e-09,
                    5.9462e-09,
                    6.2659e-09,
                    6.607e-09,
                    6.9684e-09,
                    7.3476e-09,
                    7.7406e-09,
                    8.1421e-09,
                    8.5484e-09,
                    8.9586e-09,
                    9.3722e-09,
                    9.7887e-09,
                    1.0208e-08,
                    1.0629e-08,
                    1.1053e-08,
                    1.148e-08,
                    1.1909e-08,
                    1.2288e-08,
                    1.2719e-08,
                    1.32e-08,
                    1.3726e-08,
                    1.4294e-08,
                    1.4898e-08,
                    1.5533e-08,
                    1.6193e-08,
                    1.6872e-08,
                    1.7562e-08,
                    1.8255e-08,
                    1.8945e-08,
                    1.9625e-08,
                    2.0288e-08,
                    2.0932e-08,
                    2.1555e-08,
                    2.2157e-08,
                    2.274e-08,
                    2.3307e-08,
                    2.3864e-08,
                    2.4416e-08,
                    2.4969e-08,
                    2.5523e-08,
                    2.6079e-08,
                    2.6637e-08,
                    2.7199e-08,
                    2.7764e-08,
                    2.8333e-08,
                    2.8906e-08,
                    2.9484e-08,
                    3.0067e-08,
                    3.0655e-08,
                    3.125e-08,
                    3.1855e-08,
                    3.247e-08,
                    3.3096e-08,
                    3.3735e-08,
                    3.4385e-08,
                    3.5047e-08,
                    3.5721e-08,
                    3.6406e-08,
                    3.7103e-08,
                    3.7813e-08,
                    3.8538e-08,
                    3.9278e-08,
                    4.0032e-08,
                    4.08e-08,
                    4.1579e-08,
                    4.2368e-08,
                    4.3162e-08,
                    4.3959e-08,
                    4.4801e-08,
                    4.5768e-08,
                    4.692e-08,
                    4.8296e-08,
                    4.9917e-08,
                    5.1785e-08,
                    5.3881e-08,
                    5.617e-08,
                    5.8594e-08,
                    6.1077e-08,
                    6.3576e-08,
                    6.6091e-08,
                    6.8624e-08,
                    7.1174e-08,
                    7.3744e-08,
                    7.6335e-08,
                    7.8946e-08,
                    8.1581e-08,
                    8.4241e-08,
                    8.6926e-08,
                    8.9668e-08,
                    9.2519e-08,
                    9.5519e-08,
                    9.87e-08,
                    1.0208e-07,
                    1.0566e-07,
                    1.0945e-07,
                    1.1343e-07,
                    1.1757e-07,
                    1.2218e-07,
                    1.2716e-07,
                    1.3249e-07,
                    1.3828e-07,
                    1.442e-07,
                    1.5063e-07,
                    1.5755e-07,
                    1.649e-07,
                    1.7295e-07,
                    1.8168e-07,
                    1.907e-07,
                    2.0009e-07,
                    2.0987e-07,
                    2.2024e-07,
                    2.3122e-07,
                    2.4256e-07,
                    2.5454e-07,
                    2.6677e-07,
                    2.7945e-07,
                    2.9271e-07,
                    3.0609e-07,
                    3.1995e-07,
                    3.331e-07,
                    3.4664e-07,
                    3.6077e-07,
                    3.7551e-07,
                    3.9102e-07,
                    4.0653e-07,
                    4.2214e-07,
                    4.3787e-07,
                    4.5323e-07,
                    4.6896e-07,
                    4.8506e-07,
                    5.0128e-07,
                    5.1831e-07,
                    5.3525e-07,
                    5.52e-07,
                    5.6883e-07,
                    5.8451e-07,
                    5.9947e-07,
                    6.1451e-07,
                    6.2822e-07,
                    6.4233e-07,
                    6.5656e-07,
                    6.7098e-07,
                    6.8552e-07,
                    6.9976e-07,
                    7.1447e-07,
                    7.2893e-07,
                    7.4361e-07,
                    7.5713e-07,
                    7.707e-07,
                    7.8317e-07
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            1.44257,
                            42.60367
                        ],
                        [
                            1.46726,
                            42.51108
                        ],
                        [
                            1.44945,
                            42.43839
                        ],
                        [
                            1.5519,
                            42.43343
                        ],
                        [
                            1.6627,
                            42.49326
                        ],
                        [
                            1.7258,
                            42.5044
                        ],
                        [
                            1.73788,
                            42.61152
                        ],
                        [
                            1.47935,
                            42.65092
                        ],
                        [
                            1.44257,
                            42.60367
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "AGO",
                "Country": "Angola",
                "Total_3GHG": 0.41,
                "Total_3GHG_timeseries": [
                    2.8462e-06,
                    5.7504e-06,
                    8.6799e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0048,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0054,
                    0.0055,
                    0.0057,
                    0.0058,
                    0.0059,
                    0.0061,
                    0.0062,
                    0.0063,
                    0.0064,
                    0.0065,
                    0.0065,
                    0.0066,
                    0.0066,
                    0.0067,
                    0.0067
                ],
                "Fossil_3GHG": 0.2,
                "Fossil_3GHG_timeseries": [
                    8.2721e-08,
                    1.6578e-07,
                    2.4917e-07,
                    3.3288e-07,
                    4.1692e-07,
                    5.0127e-07,
                    5.8592e-07,
                    6.7086e-07,
                    7.5918e-07,
                    8.5095e-07,
                    9.4729e-07,
                    1.0483e-06,
                    1.1547e-06,
                    1.266e-06,
                    1.3827e-06,
                    1.5051e-06,
                    1.6332e-06,
                    1.7673e-06,
                    1.9074e-06,
                    2.0538e-06,
                    2.2066e-06,
                    2.366e-06,
                    2.5324e-06,
                    2.706e-06,
                    2.8871e-06,
                    3.0758e-06,
                    3.2724e-06,
                    3.4769e-06,
                    3.6866e-06,
                    3.9015e-06,
                    4.1207e-06,
                    4.3444e-06,
                    4.572e-06,
                    4.8043e-06,
                    5.041e-06,
                    5.2822e-06,
                    5.5281e-06,
                    5.7787e-06,
                    6.0343e-06,
                    6.2954e-06,
                    6.5499e-06,
                    6.7976e-06,
                    7.0384e-06,
                    7.2721e-06,
                    7.4986e-06,
                    7.7178e-06,
                    7.9295e-06,
                    8.1334e-06,
                    8.3296e-06,
                    8.5177e-06,
                    8.7323e-06,
                    8.9729e-06,
                    9.2387e-06,
                    9.5293e-06,
                    9.8439e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021
                ],
                "Land_3GHG": 0.81,
                "Land_3GHG_timeseries": [
                    2.7635e-06,
                    5.5847e-06,
                    8.4307e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0045,
                    0.0046,
                    0.0046
                ],
                "Total_CO2": 0.32,
                "Total_CO2_timeseries": [
                    2.3638e-06,
                    4.7809e-06,
                    7.2188e-06,
                    9.6139e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0037
                ],
                "Fossil_CO2": 0.04,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    8.415e-08,
                    1.9635e-07,
                    3.366e-07,
                    4.603e-07,
                    6.1697e-07,
                    8.0328e-07,
                    1.0292e-06,
                    1.3078e-06,
                    1.5748e-06,
                    1.8533e-06,
                    2.1006e-06,
                    2.3049e-06,
                    2.8359e-06,
                    3.3536e-06,
                    3.9043e-06,
                    4.4385e-06,
                    5.1376e-06,
                    5.5842e-06,
                    6.3361e-06,
                    7.5894e-06,
                    9.2006e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Land_CO2": 0.94,
                "Land_CO2_timeseries": [
                    2.3638e-06,
                    4.7809e-06,
                    7.2188e-06,
                    9.6139e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034
                ],
                "Total_CH4": 0.62,
                "Total_CH4_timeseries": [
                    2.6633e-07,
                    5.3302e-07,
                    8.0007e-07,
                    1.0675e-06,
                    1.3353e-06,
                    1.6034e-06,
                    1.872e-06,
                    2.1408e-06,
                    2.4132e-06,
                    2.6891e-06,
                    2.9727e-06,
                    3.264e-06,
                    3.5639e-06,
                    3.8717e-06,
                    4.1881e-06,
                    4.5132e-06,
                    4.8472e-06,
                    5.1902e-06,
                    5.5423e-06,
                    5.9038e-06,
                    6.2748e-06,
                    6.6554e-06,
                    7.0458e-06,
                    7.4462e-06,
                    7.8568e-06,
                    8.2778e-06,
                    8.7094e-06,
                    9.1517e-06,
                    9.602e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026
                ],
                "Fossil_CH4": 0.68,
                "Fossil_CH4_timeseries": [
                    7.426e-08,
                    1.4872e-07,
                    2.2339e-07,
                    2.9827e-07,
                    3.7335e-07,
                    4.4863e-07,
                    5.2412e-07,
                    5.9981e-07,
                    6.7881e-07,
                    7.6122e-07,
                    8.4814e-07,
                    9.3967e-07,
                    1.0366e-06,
                    1.1383e-06,
                    1.2455e-06,
                    1.3583e-06,
                    1.4767e-06,
                    1.6011e-06,
                    1.7315e-06,
                    1.8681e-06,
                    2.0109e-06,
                    2.1602e-06,
                    2.316e-06,
                    2.4787e-06,
                    2.6482e-06,
                    2.8249e-06,
                    3.009e-06,
                    3.2006e-06,
                    3.397e-06,
                    3.5984e-06,
                    3.8041e-06,
                    4.014e-06,
                    4.2278e-06,
                    4.4461e-06,
                    4.6688e-06,
                    4.8959e-06,
                    5.1275e-06,
                    5.3638e-06,
                    5.605e-06,
                    5.8511e-06,
                    6.0903e-06,
                    6.3225e-06,
                    6.5475e-06,
                    6.7651e-06,
                    6.9752e-06,
                    7.1777e-06,
                    7.3724e-06,
                    7.559e-06,
                    7.7375e-06,
                    7.9076e-06,
                    8.1037e-06,
                    8.3254e-06,
                    8.5718e-06,
                    8.8425e-06,
                    9.1366e-06,
                    9.4536e-06,
                    9.7929e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018
                ],
                "Land_CH4": 0.52,
                "Land_CH4_timeseries": [
                    1.9207e-07,
                    3.8429e-07,
                    5.7668e-07,
                    7.6923e-07,
                    9.6194e-07,
                    1.1548e-06,
                    1.3478e-06,
                    1.541e-06,
                    1.7344e-06,
                    1.9279e-06,
                    2.1246e-06,
                    2.3244e-06,
                    2.5273e-06,
                    2.7334e-06,
                    2.9426e-06,
                    3.1549e-06,
                    3.3704e-06,
                    3.589e-06,
                    3.8108e-06,
                    4.0357e-06,
                    4.2638e-06,
                    4.4952e-06,
                    4.7298e-06,
                    4.9676e-06,
                    5.2086e-06,
                    5.4529e-06,
                    5.7004e-06,
                    5.9511e-06,
                    6.205e-06,
                    6.4622e-06,
                    6.7199e-06,
                    6.9781e-06,
                    7.2368e-06,
                    7.4961e-06,
                    7.7559e-06,
                    8.0162e-06,
                    8.277e-06,
                    8.5384e-06,
                    8.8002e-06,
                    9.0627e-06,
                    9.3256e-06,
                    9.5891e-06,
                    9.8531e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008
                ],
                "Total_N2O": 0.56,
                "Total_N2O_timeseries": [
                    2.161e-07,
                    4.3648e-07,
                    6.6097e-07,
                    8.893e-07,
                    1.1212e-06,
                    1.3562e-06,
                    1.5938e-06,
                    1.8336e-06,
                    2.075e-06,
                    2.3172e-06,
                    2.5598e-06,
                    2.8028e-06,
                    3.0461e-06,
                    3.2895e-06,
                    3.5332e-06,
                    3.777e-06,
                    4.021e-06,
                    4.2653e-06,
                    4.5099e-06,
                    4.7551e-06,
                    5.0043e-06,
                    5.2637e-06,
                    5.5381e-06,
                    5.8308e-06,
                    6.1436e-06,
                    6.477e-06,
                    6.8301e-06,
                    7.2003e-06,
                    7.584e-06,
                    7.9758e-06,
                    8.3722e-06,
                    8.7726e-06,
                    9.1762e-06,
                    9.5826e-06,
                    9.9916e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005
                ],
                "Fossil_N2O": 0.08,
                "Fossil_N2O_timeseries": [
                    8.4601e-09,
                    1.7053e-08,
                    2.5774e-08,
                    3.4617e-08,
                    4.3576e-08,
                    5.2642e-08,
                    6.1803e-08,
                    7.1048e-08,
                    8.0363e-08,
                    8.9733e-08,
                    9.9148e-08,
                    1.0861e-07,
                    1.181e-07,
                    1.2764e-07,
                    1.3722e-07,
                    1.4684e-07,
                    1.5649e-07,
                    1.6619e-07,
                    1.7593e-07,
                    1.8572e-07,
                    1.9564e-07,
                    2.0582e-07,
                    2.1638e-07,
                    2.2739e-07,
                    2.3889e-07,
                    2.5089e-07,
                    2.6338e-07,
                    2.7629e-07,
                    2.8955e-07,
                    3.0302e-07,
                    3.1664e-07,
                    3.3037e-07,
                    3.4422e-07,
                    3.5817e-07,
                    3.7221e-07,
                    3.8634e-07,
                    4.0055e-07,
                    4.1487e-07,
                    4.2928e-07,
                    4.4432e-07,
                    4.5961e-07,
                    4.7514e-07,
                    4.9095e-07,
                    5.0703e-07,
                    5.2341e-07,
                    5.401e-07,
                    5.571e-07,
                    5.7444e-07,
                    5.9212e-07,
                    6.1016e-07,
                    6.2861e-07,
                    6.4751e-07,
                    6.6691e-07,
                    6.8683e-07,
                    7.073e-07,
                    7.283e-07,
                    7.4983e-07,
                    7.7186e-07,
                    7.9433e-07,
                    8.1719e-07,
                    8.404e-07,
                    8.6393e-07,
                    8.8776e-07,
                    9.1189e-07,
                    9.3631e-07,
                    9.61e-07,
                    9.8598e-07,
                    1.0112e-06,
                    1.0368e-06,
                    1.0627e-06,
                    1.0889e-06,
                    1.1153e-06,
                    1.1421e-06,
                    1.1692e-06,
                    1.1967e-06,
                    1.2244e-06,
                    1.2525e-06,
                    1.2809e-06,
                    1.3097e-06,
                    1.339e-06,
                    1.3687e-06,
                    1.3992e-06,
                    1.4306e-06,
                    1.463e-06,
                    1.4967e-06,
                    1.5317e-06,
                    1.568e-06,
                    1.6057e-06,
                    1.6448e-06,
                    1.6852e-06,
                    1.7271e-06,
                    1.771e-06,
                    1.8171e-06,
                    1.8657e-06,
                    1.917e-06,
                    1.971e-06,
                    2.0277e-06,
                    2.0869e-06,
                    2.1485e-06,
                    2.2122e-06,
                    2.2779e-06,
                    2.3458e-06,
                    2.4159e-06,
                    2.4883e-06,
                    2.5631e-06,
                    2.6401e-06,
                    2.7195e-06,
                    2.801e-06,
                    2.8845e-06,
                    2.9699e-06,
                    3.0572e-06,
                    3.1466e-06,
                    3.2385e-06,
                    3.3331e-06,
                    3.4308e-06,
                    3.532e-06,
                    3.6369e-06,
                    3.746e-06,
                    3.8597e-06,
                    3.9726e-06,
                    4.0871e-06,
                    4.2083e-06,
                    4.3314e-06,
                    4.4581e-06,
                    4.5843e-06,
                    4.7051e-06,
                    4.8358e-06,
                    4.9765e-06,
                    5.1183e-06,
                    5.2625e-06,
                    5.4076e-06,
                    5.6078e-06,
                    5.8062e-06,
                    5.9989e-06,
                    6.2161e-06,
                    6.4304e-06,
                    6.6441e-06,
                    6.8469e-06,
                    7.0663e-06,
                    7.2775e-06,
                    7.4952e-06,
                    7.7173e-06,
                    7.9463e-06,
                    8.1818e-06,
                    8.4209e-06,
                    8.6696e-06,
                    8.9234e-06,
                    9.1798e-06,
                    9.4477e-06,
                    9.7233e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.75,
                "Land_N2O_timeseries": [
                    2.0764e-07,
                    4.1943e-07,
                    6.3519e-07,
                    8.5468e-07,
                    1.0776e-06,
                    1.3035e-06,
                    1.532e-06,
                    1.7626e-06,
                    1.9946e-06,
                    2.2275e-06,
                    2.4607e-06,
                    2.6942e-06,
                    2.928e-06,
                    3.1619e-06,
                    3.3959e-06,
                    3.6301e-06,
                    3.8645e-06,
                    4.0991e-06,
                    4.334e-06,
                    4.5693e-06,
                    4.8086e-06,
                    5.0579e-06,
                    5.3218e-06,
                    5.6034e-06,
                    5.9047e-06,
                    6.2261e-06,
                    6.5667e-06,
                    6.924e-06,
                    7.2944e-06,
                    7.6728e-06,
                    8.0556e-06,
                    8.4422e-06,
                    8.8319e-06,
                    9.2245e-06,
                    9.6194e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                23.42989,
                                -17.63446
                            ],
                            [
                                23.3625,
                                -17.55246
                            ],
                            [
                                23.22621,
                                -17.52588
                            ],
                            [
                                23.14178,
                                -17.46746
                            ],
                            [
                                23.07048,
                                -17.38756
                            ],
                            [
                                23.067,
                                -17.35536
                            ],
                            [
                                22.99276,
                                -17.2705
                            ],
                            [
                                22.91894,
                                -17.26606
                            ],
                            [
                                22.80069,
                                -17.16191
                            ],
                            [
                                22.78472,
                                -17.11608
                            ],
                            [
                                22.60924,
                                -16.93977
                            ],
                            [
                                22.48765,
                                -16.84674
                            ],
                            [
                                22.32574,
                                -16.64507
                            ],
                            [
                                22.17954,
                                -16.53277
                            ],
                            [
                                22.12823,
                                -16.44848
                            ],
                            [
                                22.11935,
                                -16.35013
                            ],
                            [
                                21.9999,
                                -16.18406
                            ],
                            [
                                22.00028,
                                -13.4738
                            ],
                            [
                                22.00417,
                                -13.00401
                            ],
                            [
                                22.01,
                                -13.00148
                            ],
                            [
                                23.92582,
                                -12.9967
                            ],
                            [
                                24.04521,
                                -12.9964
                            ],
                            [
                                24.02649,
                                -12.94391
                            ],
                            [
                                23.89393,
                                -12.84073
                            ],
                            [
                                23.89941,
                                -12.76354
                            ],
                            [
                                23.95956,
                                -12.59326
                            ],
                            [
                                23.94663,
                                -12.55667
                            ],
                            [
                                24.03338,
                                -12.44003
                            ],
                            [
                                24.07574,
                                -12.3596
                            ],
                            [
                                24.05955,
                                -12.26441
                            ],
                            [
                                23.98419,
                                -12.17063
                            ],
                            [
                                23.98357,
                                -11.9069
                            ],
                            [
                                24.01269,
                                -11.81187
                            ],
                            [
                                23.98046,
                                -11.64278
                            ],
                            [
                                24.03822,
                                -11.52534
                            ],
                            [
                                24.02348,
                                -11.4481
                            ],
                            [
                                24.08506,
                                -11.4039
                            ],
                            [
                                24.03355,
                                -11.26478
                            ],
                            [
                                24.03555,
                                -11.13938
                            ],
                            [
                                24.0071,
                                -11.02103
                            ],
                            [
                                24.01842,
                                -10.94207
                            ],
                            [
                                23.99953,
                                -10.88725
                            ],
                            [
                                23.87297,
                                -11.01642
                            ],
                            [
                                23.81545,
                                -11.02758
                            ],
                            [
                                23.73693,
                                -10.99345
                            ],
                            [
                                23.67235,
                                -11.00788
                            ],
                            [
                                23.58578,
                                -10.99306
                            ],
                            [
                                23.50853,
                                -10.9474
                            ],
                            [
                                23.43637,
                                -10.93838
                            ],
                            [
                                23.19088,
                                -11.10357
                            ],
                            [
                                23.14995,
                                -11.09379
                            ],
                            [
                                23.07198,
                                -11.12233
                            ],
                            [
                                22.85778,
                                -11.06303
                            ],
                            [
                                22.79259,
                                -11.11094
                            ],
                            [
                                22.65484,
                                -11.08304
                            ],
                            [
                                22.58526,
                                -11.03642
                            ],
                            [
                                22.51061,
                                -11.04312
                            ],
                            [
                                22.48704,
                                -11.13134
                            ],
                            [
                                22.4233,
                                -11.17845
                            ],
                            [
                                22.35005,
                                -11.17796
                            ],
                            [
                                22.27645,
                                -11.26119
                            ],
                            [
                                22.24929,
                                -11.13658
                            ],
                            [
                                22.21234,
                                -11.07956
                            ],
                            [
                                22.20453,
                                -10.93592
                            ],
                            [
                                22.16963,
                                -10.87546
                            ],
                            [
                                22.19568,
                                -10.83144
                            ],
                            [
                                22.32952,
                                -10.7513
                            ],
                            [
                                22.30658,
                                -10.53168
                            ],
                            [
                                22.27306,
                                -10.50739
                            ],
                            [
                                22.32696,
                                -10.38575
                            ],
                            [
                                22.27662,
                                -10.26172
                            ],
                            [
                                22.21641,
                                -10.15841
                            ],
                            [
                                22.21709,
                                -10.06717
                            ],
                            [
                                22.18691,
                                -9.92476
                            ],
                            [
                                22.14892,
                                -9.88768
                            ],
                            [
                                22.07007,
                                -9.87372
                            ],
                            [
                                22.01514,
                                -9.82139
                            ],
                            [
                                21.93365,
                                -9.68527
                            ],
                            [
                                21.87513,
                                -9.64836
                            ],
                            [
                                21.86463,
                                -9.56115
                            ],
                            [
                                21.82981,
                                -9.45793
                            ],
                            [
                                21.79143,
                                -9.41505
                            ],
                            [
                                21.80924,
                                -9.3315
                            ],
                            [
                                21.85784,
                                -9.22741
                            ],
                            [
                                21.83602,
                                -9.063
                            ],
                            [
                                21.86722,
                                -8.87514
                            ],
                            [
                                21.89754,
                                -8.76452
                            ],
                            [
                                21.89261,
                                -8.70451
                            ],
                            [
                                21.9519,
                                -8.50308
                            ],
                            [
                                21.91931,
                                -8.39223
                            ],
                            [
                                21.92495,
                                -8.30857
                            ],
                            [
                                21.89331,
                                -8.29202
                            ],
                            [
                                21.87248,
                                -8.1944
                            ],
                            [
                                21.82373,
                                -8.07111
                            ],
                            [
                                21.77595,
                                -8.02744
                            ],
                            [
                                21.75173,
                                -7.94044
                            ],
                            [
                                21.7764,
                                -7.9079
                            ],
                            [
                                21.77623,
                                -7.77337
                            ],
                            [
                                21.85068,
                                -7.60849
                            ],
                            [
                                21.8446,
                                -7.50835
                            ],
                            [
                                21.85836,
                                -7.42822
                            ],
                            [
                                21.82716,
                                -7.33803
                            ],
                            [
                                21.78607,
                                -7.28289
                            ],
                            [
                                20.55715,
                                -7.28211
                            ],
                            [
                                20.54648,
                                -7.14747
                            ],
                            [
                                20.59484,
                                -7.0617
                            ],
                            [
                                20.62542,
                                -6.91657
                            ],
                            [
                                20.32479,
                                -6.91675
                            ],
                            [
                                20.29848,
                                -6.99982
                            ],
                            [
                                19.55119,
                                -7.00232
                            ],
                            [
                                19.5618,
                                -7.05274
                            ],
                            [
                                19.52366,
                                -7.11079
                            ],
                            [
                                19.4866,
                                -7.31147
                            ],
                            [
                                19.54392,
                                -7.45675
                            ],
                            [
                                19.48729,
                                -7.50347
                            ],
                            [
                                19.47773,
                                -7.56891
                            ],
                            [
                                19.36944,
                                -7.59034
                            ],
                            [
                                19.40931,
                                -7.69427
                            ],
                            [
                                19.3655,
                                -7.85975
                            ],
                            [
                                19.34354,
                                -7.90024
                            ],
                            [
                                19.37946,
                                -7.99694
                            ],
                            [
                                18.80254,
                                -7.99896
                            ],
                            [
                                18.76978,
                                -7.91689
                            ],
                            [
                                18.53821,
                                -7.91618
                            ],
                            [
                                18.52767,
                                -7.99822
                            ],
                            [
                                18.18738,
                                -7.99773
                            ],
                            [
                                18.09789,
                                -8.09569
                            ],
                            [
                                17.96625,
                                -8.09595
                            ],
                            [
                                17.86633,
                                -8.07969
                            ],
                            [
                                17.7972,
                                -8.11059
                            ],
                            [
                                17.683,
                                -8.10213
                            ],
                            [
                                17.61657,
                                -8.12879
                            ],
                            [
                                17.54684,
                                -8.11632
                            ],
                            [
                                17.52752,
                                -8.04034
                            ],
                            [
                                17.48357,
                                -7.99817
                            ],
                            [
                                17.43873,
                                -7.90661
                            ],
                            [
                                17.44583,
                                -7.87077
                            ],
                            [
                                17.33679,
                                -7.77875
                            ],
                            [
                                17.29384,
                                -7.69031
                            ],
                            [
                                17.29029,
                                -7.62196
                            ],
                            [
                                17.2175,
                                -7.57695
                            ],
                            [
                                17.17825,
                                -7.42993
                            ],
                            [
                                17.10852,
                                -7.39537
                            ],
                            [
                                17.10472,
                                -7.34949
                            ],
                            [
                                17.02185,
                                -7.29542
                            ],
                            [
                                16.98177,
                                -7.29166
                            ],
                            [
                                16.94291,
                                -7.22704
                            ],
                            [
                                16.9181,
                                -7.10704
                            ],
                            [
                                16.96561,
                                -7.06663
                            ],
                            [
                                16.90457,
                                -7.01935
                            ],
                            [
                                16.90847,
                                -6.90925
                            ],
                            [
                                16.84017,
                                -6.87685
                            ],
                            [
                                16.84043,
                                -6.82519
                            ],
                            [
                                16.76356,
                                -6.70558
                            ],
                            [
                                16.74922,
                                -6.52199
                            ],
                            [
                                16.70955,
                                -6.47999
                            ],
                            [
                                16.6923,
                                -6.35188
                            ],
                            [
                                16.71854,
                                -6.32771
                            ],
                            [
                                16.70544,
                                -6.20626
                            ],
                            [
                                16.72749,
                                -6.16463
                            ],
                            [
                                16.64167,
                                -6.06596
                            ],
                            [
                                16.60607,
                                -6.06096
                            ],
                            [
                                16.58434,
                                -5.89024
                            ],
                            [
                                16.49129,
                                -5.84546
                            ],
                            [
                                16.44432,
                                -5.86705
                            ],
                            [
                                16.35981,
                                -5.85315
                            ],
                            [
                                16.21848,
                                -5.85261
                            ],
                            [
                                15.81473,
                                -5.86935
                            ],
                            [
                                15.67936,
                                -5.85718
                            ],
                            [
                                15.08111,
                                -5.86276
                            ],
                            [
                                14.71503,
                                -5.88038
                            ],
                            [
                                14.59434,
                                -5.90789
                            ],
                            [
                                14.24294,
                                -5.88554
                            ],
                            [
                                14.08119,
                                -5.86645
                            ],
                            [
                                13.97328,
                                -5.83642
                            ],
                            [
                                13.75972,
                                -5.8625
                            ],
                            [
                                13.54249,
                                -5.8647
                            ],
                            [
                                13.45674,
                                -5.84871
                            ],
                            [
                                13.37747,
                                -5.87294
                            ],
                            [
                                13.36213,
                                -5.90605
                            ],
                            [
                                13.22118,
                                -5.86208
                            ],
                            [
                                13.09929,
                                -5.88629
                            ],
                            [
                                12.96542,
                                -5.92151
                            ],
                            [
                                12.94892,
                                -5.96573
                            ],
                            [
                                12.85081,
                                -6.02657
                            ],
                            [
                                12.74058,
                                -6.04716
                            ],
                            [
                                12.63811,
                                -6.03084
                            ],
                            [
                                12.64489,
                                -6.14439
                            ],
                            [
                                12.52362,
                                -6.13008
                            ],
                            [
                                12.3992,
                                -6.15418
                            ],
                            [
                                12.31343,
                                -6.12139
                            ],
                            [
                                12.28754,
                                -6.16602
                            ],
                            [
                                12.39745,
                                -6.3292
                            ],
                            [
                                12.49762,
                                -6.54083
                            ],
                            [
                                12.56863,
                                -6.67037
                            ],
                            [
                                12.7429,
                                -6.86385
                            ],
                            [
                                12.8306,
                                -7.00587
                            ],
                            [
                                12.84822,
                                -7.10818
                            ],
                            [
                                12.85557,
                                -7.26661
                            ],
                            [
                                12.91201,
                                -7.33519
                            ],
                            [
                                12.93864,
                                -7.43627
                            ],
                            [
                                12.99988,
                                -7.57317
                            ],
                            [
                                13.10346,
                                -7.84947
                            ],
                            [
                                13.14395,
                                -7.91306
                            ],
                            [
                                13.27079,
                                -8.1795
                            ],
                            [
                                13.37022,
                                -8.33708
                            ],
                            [
                                13.38844,
                                -8.45095
                            ],
                            [
                                13.35104,
                                -8.47801
                            ],
                            [
                                13.37651,
                                -8.58787
                            ],
                            [
                                13.41173,
                                -8.64547
                            ],
                            [
                                13.39504,
                                -8.7435
                            ],
                            [
                                13.36242,
                                -8.7712
                            ],
                            [
                                13.29833,
                                -8.76182
                            ],
                            [
                                13.21956,
                                -8.80867
                            ],
                            [
                                13.14888,
                                -8.95045
                            ],
                            [
                                13.10426,
                                -8.96359
                            ],
                            [
                                13.01265,
                                -9.09626
                            ],
                            [
                                13.04937,
                                -9.18207
                            ],
                            [
                                13.15193,
                                -9.34365
                            ],
                            [
                                13.17243,
                                -9.46404
                            ],
                            [
                                13.22908,
                                -9.65417
                            ],
                            [
                                13.21094,
                                -9.71181
                            ],
                            [
                                13.29123,
                                -9.82572
                            ],
                            [
                                13.33982,
                                -9.95071
                            ],
                            [
                                13.3178,
                                -9.98392
                            ],
                            [
                                13.43481,
                                -10.11823
                            ],
                            [
                                13.4705,
                                -10.2099
                            ],
                            [
                                13.52665,
                                -10.2802
                            ],
                            [
                                13.53844,
                                -10.39611
                            ],
                            [
                                13.62184,
                                -10.4821
                            ],
                            [
                                13.76978,
                                -10.66348
                            ],
                            [
                                13.7782,
                                -10.70164
                            ],
                            [
                                13.72568,
                                -10.76133
                            ],
                            [
                                13.83391,
                                -10.91569
                            ],
                            [
                                13.86408,
                                -11.01764
                            ],
                            [
                                13.82657,
                                -11.24758
                            ],
                            [
                                13.79847,
                                -11.34368
                            ],
                            [
                                13.80419,
                                -11.39723
                            ],
                            [
                                13.77375,
                                -11.5793
                            ],
                            [
                                13.7981,
                                -11.76335
                            ],
                            [
                                13.76242,
                                -11.95189
                            ],
                            [
                                13.72849,
                                -11.99398
                            ],
                            [
                                13.70758,
                                -12.104
                            ],
                            [
                                13.67305,
                                -12.15175
                            ],
                            [
                                13.65124,
                                -12.2432
                            ],
                            [
                                13.57802,
                                -12.34202
                            ],
                            [
                                13.53619,
                                -12.35114
                            ],
                            [
                                13.48245,
                                -12.44608
                            ],
                            [
                                13.47497,
                                -12.50693
                            ],
                            [
                                13.34855,
                                -12.60925
                            ],
                            [
                                13.27013,
                                -12.58773
                            ],
                            [
                                13.19478,
                                -12.60142
                            ],
                            [
                                13.13495,
                                -12.67187
                            ],
                            [
                                12.94475,
                                -12.83414
                            ],
                            [
                                12.97618,
                                -12.9796
                            ],
                            [
                                12.87606,
                                -13.10171
                            ],
                            [
                                12.78285,
                                -13.19284
                            ],
                            [
                                12.66168,
                                -13.26238
                            ],
                            [
                                12.6464,
                                -13.34252
                            ],
                            [
                                12.53365,
                                -13.42297
                            ],
                            [
                                12.54972,
                                -13.58768
                            ],
                            [
                                12.52406,
                                -13.76759
                            ],
                            [
                                12.52591,
                                -13.85199
                            ],
                            [
                                12.42351,
                                -13.88071
                            ],
                            [
                                12.42364,
                                -13.94346
                            ],
                            [
                                12.36092,
                                -14.06544
                            ],
                            [
                                12.36823,
                                -14.15921
                            ],
                            [
                                12.33396,
                                -14.1931
                            ],
                            [
                                12.3674,
                                -14.28809
                            ],
                            [
                                12.35407,
                                -14.41295
                            ],
                            [
                                12.27533,
                                -14.69523
                            ],
                            [
                                12.28659,
                                -14.75407
                            ],
                            [
                                12.16569,
                                -14.98748
                            ],
                            [
                                12.11933,
                                -15.10847
                            ],
                            [
                                12.15157,
                                -15.18383
                            ],
                            [
                                12.05679,
                                -15.23429
                            ],
                            [
                                12.05288,
                                -15.33867
                            ],
                            [
                                12.03069,
                                -15.39945
                            ],
                            [
                                12.01914,
                                -15.56465
                            ],
                            [
                                11.99458,
                                -15.62986
                            ],
                            [
                                11.92645,
                                -15.68025
                            ],
                            [
                                11.90842,
                                -15.74546
                            ],
                            [
                                11.84439,
                                -15.8016
                            ],
                            [
                                11.76487,
                                -15.7986
                            ],
                            [
                                11.73493,
                                -15.89939
                            ],
                            [
                                11.80544,
                                -16.01866
                            ],
                            [
                                11.79218,
                                -16.09038
                            ],
                            [
                                11.82591,
                                -16.45359
                            ],
                            [
                                11.81437,
                                -16.65203
                            ],
                            [
                                11.81889,
                                -16.74809
                            ],
                            [
                                11.76503,
                                -16.94255
                            ],
                            [
                                11.7521,
                                -17.08033
                            ],
                            [
                                11.75086,
                                -17.25245
                            ],
                            [
                                11.79271,
                                -17.27288
                            ],
                            [
                                11.94206,
                                -17.18217
                            ],
                            [
                                12.07999,
                                -17.14252
                            ],
                            [
                                12.15693,
                                -17.16033
                            ],
                            [
                                12.25124,
                                -17.23926
                            ],
                            [
                                12.39745,
                                -17.20782
                            ],
                            [
                                12.4798,
                                -17.24241
                            ],
                            [
                                12.59619,
                                -17.23402
                            ],
                            [
                                12.61294,
                                -17.20865
                            ],
                            [
                                12.80495,
                                -17.11486
                            ],
                            [
                                12.91519,
                                -17.02194
                            ],
                            [
                                12.98382,
                                -16.98253
                            ],
                            [
                                13.16705,
                                -16.9635
                            ],
                            [
                                13.27554,
                                -16.99776
                            ],
                            [
                                13.35382,
                                -16.97475
                            ],
                            [
                                13.46158,
                                -17.0106
                            ],
                            [
                                13.52147,
                                -17.09137
                            ],
                            [
                                13.51614,
                                -17.13721
                            ],
                            [
                                13.91662,
                                -17.3784
                            ],
                            [
                                13.95539,
                                -17.43261
                            ],
                            [
                                14.01668,
                                -17.4145
                            ],
                            [
                                14.10157,
                                -17.43863
                            ],
                            [
                                14.22016,
                                -17.38849
                            ],
                            [
                                14.60215,
                                -17.38848
                            ],
                            [
                                18.41645,
                                -17.38833
                            ],
                            [
                                18.53508,
                                -17.52252
                            ],
                            [
                                18.56388,
                                -17.58041
                            ],
                            [
                                18.79092,
                                -17.76504
                            ],
                            [
                                18.9006,
                                -17.8176
                            ],
                            [
                                19.10456,
                                -17.83661
                            ],
                            [
                                19.14623,
                                -17.80841
                            ],
                            [
                                19.24652,
                                -17.81555
                            ],
                            [
                                19.43053,
                                -17.86926
                            ],
                            [
                                19.55029,
                                -17.87466
                            ],
                            [
                                19.671,
                                -17.84905
                            ],
                            [
                                19.76315,
                                -17.90674
                            ],
                            [
                                19.81151,
                                -17.86777
                            ],
                            [
                                19.91084,
                                -17.86265
                            ],
                            [
                                20.10965,
                                -17.91048
                            ],
                            [
                                20.17262,
                                -17.8768
                            ],
                            [
                                20.24539,
                                -17.89218
                            ],
                            [
                                20.32202,
                                -17.86193
                            ],
                            [
                                20.43854,
                                -17.90637
                            ],
                            [
                                20.5412,
                                -17.98218
                            ],
                            [
                                20.64417,
                                -17.97713
                            ],
                            [
                                20.74658,
                                -18.00189
                            ],
                            [
                                20.80549,
                                -18.03748
                            ],
                            [
                                20.97792,
                                -17.95823
                            ],
                            [
                                21.21303,
                                -17.92924
                            ],
                            [
                                21.25584,
                                -17.96234
                            ],
                            [
                                21.42651,
                                -18.0234
                            ],
                            [
                                22.0751,
                                -17.89762
                            ],
                            [
                                22.85778,
                                -17.74563
                            ],
                            [
                                23.42989,
                                -17.63446
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                13.10176,
                                -4.68505
                            ],
                            [
                                12.98401,
                                -4.58519
                            ],
                            [
                                12.97033,
                                -4.53501
                            ],
                            [
                                12.88661,
                                -4.45553
                            ],
                            [
                                12.77129,
                                -4.39055
                            ],
                            [
                                12.64308,
                                -4.5621
                            ],
                            [
                                12.56315,
                                -4.56374
                            ],
                            [
                                12.39262,
                                -4.61015
                            ],
                            [
                                12.39711,
                                -4.66724
                            ],
                            [
                                12.32324,
                                -4.79657
                            ],
                            [
                                12.26117,
                                -4.79821
                            ],
                            [
                                12.21408,
                                -4.75795
                            ],
                            [
                                12.1618,
                                -4.86981
                            ],
                            [
                                11.98925,
                                -4.99932
                            ],
                            [
                                12.13935,
                                -5.21476
                            ],
                            [
                                12.133,
                                -5.24242
                            ],
                            [
                                12.20531,
                                -5.41341
                            ],
                            [
                                12.23291,
                                -5.52367
                            ],
                            [
                                12.18197,
                                -5.551
                            ],
                            [
                                12.14528,
                                -5.64065
                            ],
                            [
                                12.19545,
                                -5.76388
                            ],
                            [
                                12.28812,
                                -5.7377
                            ],
                            [
                                12.53618,
                                -5.73648
                            ],
                            [
                                12.53667,
                                -5.18787
                            ],
                            [
                                12.46209,
                                -5.10004
                            ],
                            [
                                12.50338,
                                -5.04836
                            ],
                            [
                                12.60175,
                                -5.02614
                            ],
                            [
                                12.64471,
                                -4.94609
                            ],
                            [
                                12.72052,
                                -4.95001
                            ],
                            [
                                12.75962,
                                -4.87543
                            ],
                            [
                                12.81446,
                                -4.84101
                            ],
                            [
                                12.85762,
                                -4.75249
                            ],
                            [
                                12.92191,
                                -4.74749
                            ],
                            [
                                13.05093,
                                -4.67609
                            ],
                            [
                                13.10176,
                                -4.68505
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "AIA",
                "Country": "Anguilla",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2.145e-08,
                    4.29e-08,
                    6.435e-08,
                    8.91e-08,
                    1.1385e-07,
                    1.4025e-07,
                    1.683e-07,
                    1.9635e-07,
                    2.2605e-07,
                    2.5575e-07,
                    2.904e-07,
                    3.2835e-07,
                    3.663e-07,
                    4.059e-07,
                    4.521e-07,
                    5.016e-07,
                    5.5605e-07,
                    6.1215e-07,
                    6.6825e-07,
                    7.2435e-07,
                    7.8375e-07,
                    8.3985e-07,
                    8.943e-07,
                    9.471e-07,
                    1.0015e-06,
                    1.0643e-06,
                    1.127e-06,
                    1.1847e-06,
                    1.2441e-06,
                    1.3101e-06,
                    1.3745e-06,
                    1.4365e-06,
                    1.499e-06
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2.145e-08,
                    4.29e-08,
                    6.435e-08,
                    8.91e-08,
                    1.1385e-07,
                    1.4025e-07,
                    1.683e-07,
                    1.9635e-07,
                    2.2605e-07,
                    2.5575e-07,
                    2.904e-07,
                    3.2835e-07,
                    3.663e-07,
                    4.059e-07,
                    4.521e-07,
                    5.016e-07,
                    5.5605e-07,
                    6.1215e-07,
                    6.6825e-07,
                    7.2435e-07,
                    7.8375e-07,
                    8.3985e-07,
                    8.943e-07,
                    9.471e-07,
                    1.0015e-06,
                    1.0643e-06,
                    1.127e-06,
                    1.1847e-06,
                    1.2441e-06,
                    1.3101e-06,
                    1.3745e-06,
                    1.4365e-06,
                    1.499e-06
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2.145e-08,
                    4.29e-08,
                    6.435e-08,
                    8.91e-08,
                    1.1385e-07,
                    1.4025e-07,
                    1.683e-07,
                    1.9635e-07,
                    2.2605e-07,
                    2.5575e-07,
                    2.904e-07,
                    3.2835e-07,
                    3.663e-07,
                    4.059e-07,
                    4.521e-07,
                    5.016e-07,
                    5.5605e-07,
                    6.1215e-07,
                    6.6825e-07,
                    7.2435e-07,
                    7.8375e-07,
                    8.3985e-07,
                    8.943e-07,
                    9.471e-07,
                    1.0015e-06,
                    1.0643e-06,
                    1.127e-06,
                    1.1847e-06,
                    1.2441e-06,
                    1.3101e-06,
                    1.3745e-06,
                    1.4365e-06,
                    1.499e-06
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2.145e-08,
                    4.29e-08,
                    6.435e-08,
                    8.91e-08,
                    1.1385e-07,
                    1.4025e-07,
                    1.683e-07,
                    1.9635e-07,
                    2.2605e-07,
                    2.5575e-07,
                    2.904e-07,
                    3.2835e-07,
                    3.663e-07,
                    4.059e-07,
                    4.521e-07,
                    5.016e-07,
                    5.5605e-07,
                    6.1215e-07,
                    6.6825e-07,
                    7.2435e-07,
                    7.8375e-07,
                    8.3985e-07,
                    8.943e-07,
                    9.471e-07,
                    1.0015e-06,
                    1.0643e-06,
                    1.127e-06,
                    1.1847e-06,
                    1.2441e-06,
                    1.3101e-06,
                    1.3745e-06,
                    1.4365e-06,
                    1.499e-06
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": []
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -63.16735,
                            18.16328
                        ],
                        [
                            -63.0826,
                            18.17421
                        ],
                        [
                            -62.99074,
                            18.22528
                        ],
                        [
                            -62.99811,
                            18.25789
                        ],
                        [
                            -63.06978,
                            18.23405
                        ],
                        [
                            -63.0943,
                            18.19632
                        ],
                        [
                            -63.16735,
                            18.16328
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "ATA",
                "Country": "Antarctica",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.65e-09,
                    4.95e-09,
                    8.25e-09,
                    1.32e-08,
                    1.98e-08,
                    2.64e-08,
                    3.3e-08,
                    3.96e-08,
                    4.125e-08,
                    4.29e-08,
                    4.455e-08,
                    4.62e-08,
                    4.785e-08,
                    4.95e-08,
                    5.115e-08,
                    5.28e-08,
                    5.445e-08,
                    5.775e-08,
                    6.105e-08,
                    6.435e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.65e-09,
                    4.95e-09,
                    8.25e-09,
                    1.32e-08,
                    1.98e-08,
                    2.64e-08,
                    3.3e-08,
                    3.96e-08,
                    4.125e-08,
                    4.29e-08,
                    4.455e-08,
                    4.62e-08,
                    4.785e-08,
                    4.95e-08,
                    5.115e-08,
                    5.28e-08,
                    5.445e-08,
                    5.775e-08,
                    6.105e-08,
                    6.435e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.65e-09,
                    4.95e-09,
                    8.25e-09,
                    1.32e-08,
                    1.98e-08,
                    2.64e-08,
                    3.3e-08,
                    3.96e-08,
                    4.125e-08,
                    4.29e-08,
                    4.455e-08,
                    4.62e-08,
                    4.785e-08,
                    4.95e-08,
                    5.115e-08,
                    5.28e-08,
                    5.445e-08,
                    5.775e-08,
                    6.105e-08,
                    6.435e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.65e-09,
                    4.95e-09,
                    8.25e-09,
                    1.32e-08,
                    1.98e-08,
                    2.64e-08,
                    3.3e-08,
                    3.96e-08,
                    4.125e-08,
                    4.29e-08,
                    4.455e-08,
                    4.62e-08,
                    4.785e-08,
                    4.95e-08,
                    5.115e-08,
                    5.28e-08,
                    5.445e-08,
                    5.775e-08,
                    6.105e-08,
                    6.435e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08,
                    6.93e-08
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": []
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -57.2881,
                                -63.22475
                            ],
                            [
                                -57.5815,
                                -63.27888
                            ],
                            [
                                -57.88511,
                                -63.30185
                            ],
                            [
                                -58.14191,
                                -63.4524
                            ],
                            [
                                -58.39956,
                                -63.44133
                            ],
                            [
                                -58.70244,
                                -63.49588
                            ],
                            [
                                -58.94772,
                                -63.56299
                            ],
                            [
                                -58.96416,
                                -63.63962
                            ],
                            [
                                -59.11959,
                                -63.71547
                            ],
                            [
                                -59.23253,
                                -63.67795
                            ],
                            [
                                -59.37625,
                                -63.69967
                            ],
                            [
                                -59.34536,
                                -63.76514
                            ],
                            [
                                -59.47893,
                                -63.82011
                            ],
                            [
                                -59.455,
                                -63.88292
                            ],
                            [
                                -59.82326,
                                -63.87306
                            ],
                            [
                                -59.85614,
                                -63.77619
                            ],
                            [
                                -59.9507,
                                -63.80541
                            ],
                            [
                                -59.92642,
                                -63.86906
                            ],
                            [
                                -60.05696,
                                -63.95177
                            ],
                            [
                                -60.31147,
                                -63.9191
                            ],
                            [
                                -60.59417,
                                -64.00155
                            ],
                            [
                                -60.72784,
                                -64.0108
                            ],
                            [
                                -60.73948,
                                -64.06432
                            ],
                            [
                                -60.9681,
                                -64.04251
                            ],
                            [
                                -60.93297,
                                -64.26997
                            ],
                            [
                                -61.08468,
                                -64.28619
                            ],
                            [
                                -61.12682,
                                -64.37807
                            ],
                            [
                                -61.43973,
                                -64.38937
                            ],
                            [
                                -61.60499,
                                -64.4294
                            ],
                            [
                                -61.51775,
                                -64.51877
                            ],
                            [
                                -61.53031,
                                -64.59306
                            ],
                            [
                                -61.63564,
                                -64.64529
                            ],
                            [
                                -61.73666,
                                -64.53584
                            ],
                            [
                                -61.97836,
                                -64.59965
                            ],
                            [
                                -61.97657,
                                -64.676
                            ],
                            [
                                -62.17696,
                                -64.6967
                            ],
                            [
                                -62.2196,
                                -64.76294
                            ],
                            [
                                -62.36004,
                                -64.74601
                            ],
                            [
                                -62.43373,
                                -64.59381
                            ],
                            [
                                -62.59295,
                                -64.62231
                            ],
                            [
                                -62.56071,
                                -64.73954
                            ],
                            [
                                -62.70923,
                                -64.75967
                            ],
                            [
                                -62.55197,
                                -64.85391
                            ],
                            [
                                -62.65132,
                                -64.91543
                            ],
                            [
                                -62.75991,
                                -64.79935
                            ],
                            [
                                -62.87981,
                                -64.81878
                            ],
                            [
                                -62.90468,
                                -64.90834
                            ],
                            [
                                -63.10368,
                                -64.9001
                            ],
                            [
                                -63.2639,
                                -64.94787
                            ],
                            [
                                -63.10135,
                                -65.02477
                            ],
                            [
                                -63.02446,
                                -65.11036
                            ],
                            [
                                -63.10181,
                                -65.14349
                            ],
                            [
                                -63.24002,
                                -65.1146
                            ],
                            [
                                -63.66487,
                                -65.0675
                            ],
                            [
                                -63.84392,
                                -65.02696
                            ],
                            [
                                -64.08542,
                                -65.16198
                            ],
                            [
                                -64.07893,
                                -65.30514
                            ],
                            [
                                -64.00608,
                                -65.36631
                            ],
                            [
                                -64.08751,
                                -65.40361
                            ],
                            [
                                -63.94441,
                                -65.45093
                            ],
                            [
                                -63.75802,
                                -65.46087
                            ],
                            [
                                -63.80711,
                                -65.57327
                            ],
                            [
                                -63.94013,
                                -65.57469
                            ],
                            [
                                -64.0217,
                                -65.50489
                            ],
                            [
                                -64.19775,
                                -65.517
                            ],
                            [
                                -64.15788,
                                -65.61383
                            ],
                            [
                                -64.46815,
                                -65.62676
                            ],
                            [
                                -64.3767,
                                -65.68978
                            ],
                            [
                                -64.39505,
                                -65.78846
                            ],
                            [
                                -64.64627,
                                -65.72158
                            ],
                            [
                                -64.71476,
                                -65.8222
                            ],
                            [
                                -64.48786,
                                -65.93146
                            ],
                            [
                                -64.49758,
                                -65.98132
                            ],
                            [
                                -64.72889,
                                -66.00878
                            ],
                            [
                                -64.79642,
                                -65.93975
                            ],
                            [
                                -65.00948,
                                -65.92524
                            ],
                            [
                                -65.32028,
                                -65.97089
                            ],
                            [
                                -65.2848,
                                -66.0551
                            ],
                            [
                                -65.12336,
                                -66.15219
                            ],
                            [
                                -65.22162,
                                -66.17322
                            ],
                            [
                                -65.42118,
                                -66.15303
                            ],
                            [
                                -65.6351,
                                -66.09884
                            ],
                            [
                                -65.70441,
                                -66.24042
                            ],
                            [
                                -65.83993,
                                -66.27185
                            ],
                            [
                                -65.61396,
                                -66.39553
                            ],
                            [
                                -65.71658,
                                -66.42403
                            ],
                            [
                                -65.8031,
                                -66.62985
                            ],
                            [
                                -65.88681,
                                -66.68035
                            ],
                            [
                                -66.18673,
                                -66.59242
                            ],
                            [
                                -66.53436,
                                -66.61426
                            ],
                            [
                                -66.59651,
                                -66.64635
                            ],
                            [
                                -66.55082,
                                -66.77273
                            ],
                            [
                                -66.48326,
                                -66.85056
                            ],
                            [
                                -66.62252,
                                -66.99808
                            ],
                            [
                                -66.61362,
                                -67.04012
                            ],
                            [
                                -66.46781,
                                -67.16579
                            ],
                            [
                                -66.49468,
                                -67.21579
                            ],
                            [
                                -66.85839,
                                -67.19327
                            ],
                            [
                                -66.95401,
                                -67.08265
                            ],
                            [
                                -66.90509,
                                -67.04965
                            ],
                            [
                                -66.90713,
                                -66.95266
                            ],
                            [
                                -67.05824,
                                -66.91778
                            ],
                            [
                                -67.26162,
                                -66.98442
                            ],
                            [
                                -67.31486,
                                -67.04514
                            ],
                            [
                                -67.48125,
                                -67.04542
                            ],
                            [
                                -67.54442,
                                -67.13697
                            ],
                            [
                                -67.50172,
                                -67.21093
                            ],
                            [
                                -67.58455,
                                -67.27101
                            ],
                            [
                                -67.51291,
                                -67.32589
                            ],
                            [
                                -67.64492,
                                -67.44938
                            ],
                            [
                                -67.50014,
                                -67.55572
                            ],
                            [
                                -67.03077,
                                -67.46693
                            ],
                            [
                                -66.60128,
                                -67.49847
                            ],
                            [
                                -66.58974,
                                -67.57596
                            ],
                            [
                                -66.77357,
                                -67.58057
                            ],
                            [
                                -66.98147,
                                -67.66842
                            ],
                            [
                                -67.07001,
                                -67.73417
                            ],
                            [
                                -66.84907,
                                -67.87341
                            ],
                            [
                                -66.89396,
                                -67.91528
                            ],
                            [
                                -67.28092,
                                -67.94467
                            ],
                            [
                                -67.13141,
                                -68.05217
                            ],
                            [
                                -67.13631,
                                -68.09649
                            ],
                            [
                                -66.95488,
                                -68.22126
                            ],
                            [
                                -66.71857,
                                -68.188
                            ],
                            [
                                -66.63474,
                                -68.22361
                            ],
                            [
                                -66.74647,
                                -68.30332
                            ],
                            [
                                -66.93974,
                                -68.30614
                            ],
                            [
                                -67.16088,
                                -68.2779
                            ],
                            [
                                -67.13737,
                                -68.34284
                            ],
                            [
                                -66.9717,
                                -68.33995
                            ],
                            [
                                -66.95361,
                                -68.41227
                            ],
                            [
                                -67.20268,
                                -68.52542
                            ],
                            [
                                -67.04109,
                                -68.64381
                            ],
                            [
                                -66.93716,
                                -68.75173
                            ],
                            [
                                -67.15002,
                                -68.80418
                            ],
                            [
                                -67.38166,
                                -68.78852
                            ],
                            [
                                -67.50614,
                                -68.84779
                            ],
                            [
                                -67.35846,
                                -68.91722
                            ],
                            [
                                -67.02139,
                                -68.95567
                            ],
                            [
                                -66.76933,
                                -69.0435
                            ],
                            [
                                -66.89141,
                                -69.09544
                            ],
                            [
                                -67.06941,
                                -69.21587
                            ],
                            [
                                -67.2979,
                                -69.30559
                            ],
                            [
                                -67.33444,
                                -69.34342
                            ],
                            [
                                -67.53101,
                                -69.35704
                            ],
                            [
                                -67.90174,
                                -69.35565
                            ],
                            [
                                -68.28256,
                                -69.2766
                            ],
                            [
                                -68.35569,
                                -69.31566
                            ],
                            [
                                -68.32952,
                                -69.38393
                            ],
                            [
                                -68.71718,
                                -69.37797
                            ],
                            [
                                -68.85238,
                                -69.43076
                            ],
                            [
                                -68.68021,
                                -69.51548
                            ],
                            [
                                -68.60034,
                                -69.52195
                            ],
                            [
                                -68.50858,
                                -69.62241
                            ],
                            [
                                -68.38254,
                                -69.6612
                            ],
                            [
                                -68.38123,
                                -69.87577
                            ],
                            [
                                -68.48743,
                                -69.91834
                            ],
                            [
                                -68.45716,
                                -70.07945
                            ],
                            [
                                -68.3865,
                                -70.14944
                            ],
                            [
                                -68.22417,
                                -70.22137
                            ],
                            [
                                -68.06853,
                                -70.24427
                            ],
                            [
                                -67.92261,
                                -70.35714
                            ],
                            [
                                -67.85665,
                                -70.50067
                            ],
                            [
                                -67.73209,
                                -70.5568
                            ],
                            [
                                -67.78777,
                                -70.64521
                            ],
                            [
                                -67.65024,
                                -70.71084
                            ],
                            [
                                -67.63058,
                                -70.77505
                            ],
                            [
                                -67.41097,
                                -71.00059
                            ],
                            [
                                -67.53278,
                                -71.28948
                            ],
                            [
                                -67.65556,
                                -71.38643
                            ],
                            [
                                -67.62797,
                                -71.46579
                            ],
                            [
                                -67.50108,
                                -71.5319
                            ],
                            [
                                -67.34335,
                                -71.67274
                            ],
                            [
                                -67.16072,
                                -71.6989
                            ],
                            [
                                -66.91633,
                                -71.88416
                            ],
                            [
                                -66.98884,
                                -71.99656
                            ],
                            [
                                -66.91651,
                                -72.03149
                            ],
                            [
                                -66.99767,
                                -72.09491
                            ],
                            [
                                -66.93371,
                                -72.14433
                            ],
                            [
                                -66.99581,
                                -72.21813
                            ],
                            [
                                -66.92202,
                                -72.2611
                            ],
                            [
                                -66.92732,
                                -72.39021
                            ],
                            [
                                -66.86303,
                                -72.41159
                            ],
                            [
                                -67.34573,
                                -72.58822
                            ],
                            [
                                -67.46228,
                                -72.75273
                            ],
                            [
                                -67.57427,
                                -72.83747
                            ],
                            [
                                -67.71222,
                                -72.8694
                            ],
                            [
                                -68.04667,
                                -72.8929
                            ],
                            [
                                -68.17572,
                                -72.94762
                            ],
                            [
                                -68.53042,
                                -73.00558
                            ],
                            [
                                -68.59002,
                                -73.05274
                            ],
                            [
                                -68.97865,
                                -73.11721
                            ],
                            [
                                -69.20382,
                                -73.13617
                            ],
                            [
                                -69.33608,
                                -73.18173
                            ],
                            [
                                -70.06065,
                                -73.24373
                            ],
                            [
                                -70.40119,
                                -73.29768
                            ],
                            [
                                -70.75108,
                                -73.27072
                            ],
                            [
                                -71.16133,
                                -73.28212
                            ],
                            [
                                -71.41217,
                                -73.34002
                            ],
                            [
                                -71.5363,
                                -73.39383
                            ],
                            [
                                -71.8823,
                                -73.38251
                            ],
                            [
                                -72.35011,
                                -73.42439
                            ],
                            [
                                -72.55622,
                                -73.42806
                            ],
                            [
                                -72.64793,
                                -73.4795
                            ],
                            [
                                -73.1738,
                                -73.48955
                            ],
                            [
                                -73.30069,
                                -73.53464
                            ],
                            [
                                -73.54232,
                                -73.54068
                            ],
                            [
                                -73.82845,
                                -73.62978
                            ],
                            [
                                -73.98368,
                                -73.71858
                            ],
                            [
                                -74.19632,
                                -73.67756
                            ],
                            [
                                -74.57609,
                                -73.70887
                            ],
                            [
                                -74.84858,
                                -73.69515
                            ],
                            [
                                -75.1281,
                                -73.65545
                            ],
                            [
                                -75.75914,
                                -73.73887
                            ],
                            [
                                -76.11449,
                                -73.82374
                            ],
                            [
                                -76.68393,
                                -73.81207
                            ],
                            [
                                -76.93138,
                                -73.87643
                            ],
                            [
                                -77.12543,
                                -73.83045
                            ],
                            [
                                -76.75288,
                                -73.71487
                            ],
                            [
                                -76.59139,
                                -73.59245
                            ],
                            [
                                -76.75404,
                                -73.52543
                            ],
                            [
                                -77.1314,
                                -73.55848
                            ],
                            [
                                -77.41484,
                                -73.52443
                            ],
                            [
                                -78.01465,
                                -73.58648
                            ],
                            [
                                -78.21272,
                                -73.59298
                            ],
                            [
                                -78.39962,
                                -73.64018
                            ],
                            [
                                -78.6225,
                                -73.62196
                            ],
                            [
                                -78.51091,
                                -73.48625
                            ],
                            [
                                -78.63843,
                                -73.36863
                            ],
                            [
                                -78.91602,
                                -73.30921
                            ],
                            [
                                -79.39598,
                                -73.11165
                            ],
                            [
                                -80.24251,
                                -73.00624
                            ],
                            [
                                -80.34628,
                                -73.07019
                            ],
                            [
                                -80.34775,
                                -73.13606
                            ],
                            [
                                -80.16164,
                                -73.23488
                            ],
                            [
                                -80.06648,
                                -73.34049
                            ],
                            [
                                -80.23489,
                                -73.40104
                            ],
                            [
                                -80.41907,
                                -73.37563
                            ],
                            [
                                -80.66838,
                                -73.27934
                            ],
                            [
                                -81.02884,
                                -73.28175
                            ],
                            [
                                -81.08063,
                                -73.5095
                            ],
                            [
                                -80.79374,
                                -73.64613
                            ],
                            [
                                -80.87862,
                                -73.71526
                            ],
                            [
                                -80.82159,
                                -73.7646
                            ],
                            [
                                -81.36343,
                                -73.86625
                            ],
                            [
                                -81.79633,
                                -73.88326
                            ],
                            [
                                -82.0097,
                                -73.93523
                            ],
                            [
                                -82.20894,
                                -73.87213
                            ],
                            [
                                -82.7349,
                                -73.76154
                            ],
                            [
                                -83.30668,
                                -73.61424
                            ],
                            [
                                -83.3205,
                                -73.53902
                            ],
                            [
                                -83.49295,
                                -73.51983
                            ],
                            [
                                -83.69571,
                                -73.53808
                            ],
                            [
                                -84.20891,
                                -73.52185
                            ],
                            [
                                -84.47822,
                                -73.53877
                            ],
                            [
                                -84.7395,
                                -73.522
                            ],
                            [
                                -85.4217,
                                -73.41221
                            ],
                            [
                                -85.57724,
                                -73.2291
                            ],
                            [
                                -85.72907,
                                -73.15491
                            ],
                            [
                                -85.75911,
                                -73.01691
                            ],
                            [
                                -85.85442,
                                -73.00414
                            ],
                            [
                                -85.97448,
                                -73.16132
                            ],
                            [
                                -86.20844,
                                -73.237
                            ],
                            [
                                -86.44425,
                                -73.22572
                            ],
                            [
                                -86.49821,
                                -73.27133
                            ],
                            [
                                -86.7646,
                                -73.32839
                            ],
                            [
                                -86.96862,
                                -73.31039
                            ],
                            [
                                -87.30498,
                                -73.21147
                            ],
                            [
                                -87.39618,
                                -73.16045
                            ],
                            [
                                -87.93788,
                                -73.07604
                            ],
                            [
                                -88.1129,
                                -73.12489
                            ],
                            [
                                -88.25518,
                                -73.09165
                            ],
                            [
                                -88.59767,
                                -73.05941
                            ],
                            [
                                -88.61381,
                                -73.02188
                            ],
                            [
                                -88.20122,
                                -72.85882
                            ],
                            [
                                -88.11876,
                                -72.77259
                            ],
                            [
                                -88.21453,
                                -72.70461
                            ],
                            [
                                -88.5533,
                                -72.64695
                            ],
                            [
                                -88.7072,
                                -72.65608
                            ],
                            [
                                -89.14194,
                                -72.59857
                            ],
                            [
                                -89.54905,
                                -72.61932
                            ],
                            [
                                -89.40094,
                                -72.67547
                            ],
                            [
                                -89.30972,
                                -72.78239
                            ],
                            [
                                -89.29237,
                                -72.89288
                            ],
                            [
                                -89.39294,
                                -72.95708
                            ],
                            [
                                -89.40665,
                                -73.04566
                            ],
                            [
                                -89.79377,
                                -73.16758
                            ],
                            [
                                -90.06688,
                                -73.14635
                            ],
                            [
                                -90.32635,
                                -73.15479
                            ],
                            [
                                -90.54996,
                                -73.21622
                            ],
                            [
                                -90.59795,
                                -73.25991
                            ],
                            [
                                -90.98949,
                                -73.29729
                            ],
                            [
                                -91.10636,
                                -73.26549
                            ],
                            [
                                -91.46284,
                                -73.24049
                            ],
                            [
                                -91.75851,
                                -73.24609
                            ],
                            [
                                -91.93156,
                                -73.20869
                            ],
                            [
                                -92.52018,
                                -73.1555
                            ],
                            [
                                -92.69984,
                                -73.1814
                            ],
                            [
                                -93.15643,
                                -73.18632
                            ],
                            [
                                -93.57599,
                                -73.17214
                            ],
                            [
                                -93.66614,
                                -73.22129
                            ],
                            [
                                -93.88682,
                                -73.19504
                            ],
                            [
                                -93.99312,
                                -73.0266
                            ],
                            [
                                -94.11102,
                                -73.02734
                            ],
                            [
                                -94.35377,
                                -72.9052
                            ],
                            [
                                -94.4792,
                                -72.92525
                            ],
                            [
                                -94.38194,
                                -73.07825
                            ],
                            [
                                -94.40566,
                                -73.14371
                            ],
                            [
                                -94.70371,
                                -73.18538
                            ],
                            [
                                -94.81869,
                                -73.23167
                            ],
                            [
                                -95.05492,
                                -73.22943
                            ],
                            [
                                -95.25858,
                                -73.19476
                            ],
                            [
                                -95.84464,
                                -73.25823
                            ],
                            [
                                -95.96609,
                                -73.3474
                            ],
                            [
                                -96.26904,
                                -73.28806
                            ],
                            [
                                -96.6879,
                                -73.26805
                            ],
                            [
                                -97.0123,
                                -73.21875
                            ],
                            [
                                -97.23325,
                                -73.15839
                            ],
                            [
                                -97.55347,
                                -73.12117
                            ],
                            [
                                -97.73597,
                                -72.97639
                            ],
                            [
                                -98.03325,
                                -72.90919
                            ],
                            [
                                -98.49516,
                                -72.93826
                            ],
                            [
                                -98.8327,
                                -72.98209
                            ],
                            [
                                -99.66431,
                                -73.12183
                            ],
                            [
                                -99.95249,
                                -73.17759
                            ],
                            [
                                -100.08291,
                                -73.15485
                            ],
                            [
                                -100.38806,
                                -73.05064
                            ],
                            [
                                -100.66176,
                                -72.99252
                            ],
                            [
                                -101.08956,
                                -73.00571
                            ],
                            [
                                -101.26105,
                                -73.03881
                            ],
                            [
                                -101.73479,
                                -73.08024
                            ],
                            [
                                -101.80044,
                                -73.04144
                            ],
                            [
                                -102.0201,
                                -73.04037
                            ],
                            [
                                -102.18382,
                                -73.00147
                            ],
                            [
                                -102.05827,
                                -72.9304
                            ],
                            [
                                -102.10268,
                                -72.86338
                            ],
                            [
                                -102.25165,
                                -72.82617
                            ],
                            [
                                -102.83167,
                                -72.82175
                            ],
                            [
                                -103.06632,
                                -72.78707
                            ],
                            [
                                -103.47316,
                                -72.87414
                            ],
                            [
                                -103.50612,
                                -72.95382
                            ],
                            [
                                -103.33121,
                                -73.05229
                            ],
                            [
                                -103.18896,
                                -73.22739
                            ],
                            [
                                -103.00703,
                                -73.24351
                            ],
                            [
                                -102.81065,
                                -73.35287
                            ],
                            [
                                -102.66108,
                                -73.38333
                            ],
                            [
                                -101.91831,
                                -73.33064
                            ],
                            [
                                -101.63673,
                                -73.29031
                            ],
                            [
                                -101.51209,
                                -73.29733
                            ],
                            [
                                -101.39899,
                                -73.22207
                            ],
                            [
                                -101.18182,
                                -73.13345
                            ],
                            [
                                -100.97247,
                                -73.11209
                            ],
                            [
                                -100.80067,
                                -73.13586
                            ],
                            [
                                -100.37264,
                                -73.25871
                            ],
                            [
                                -99.98989,
                                -73.33151
                            ],
                            [
                                -100.0153,
                                -73.51032
                            ],
                            [
                                -100.06762,
                                -73.53971
                            ],
                            [
                                -100.47125,
                                -73.61308
                            ],
                            [
                                -100.84589,
                                -73.57266
                            ],
                            [
                                -101.18684,
                                -73.5814
                            ],
                            [
                                -101.38346,
                                -73.53734
                            ],
                            [
                                -101.82555,
                                -73.53078
                            ],
                            [
                                -102.28507,
                                -73.56465
                            ],
                            [
                                -102.24019,
                                -73.62798
                            ],
                            [
                                -102.09541,
                                -73.65803
                            ],
                            [
                                -102.15952,
                                -73.75029
                            ],
                            [
                                -102.08362,
                                -73.82701
                            ],
                            [
                                -101.00175,
                                -73.87003
                            ],
                            [
                                -101.00948,
                                -73.92027
                            ],
                            [
                                -100.4965,
                                -74.12955
                            ],
                            [
                                -100.47417,
                                -74.28237
                            ],
                            [
                                -100.65386,
                                -74.2544
                            ],
                            [
                                -100.92623,
                                -74.2596
                            ],
                            [
                                -101.18136,
                                -74.33836
                            ],
                            [
                                -101.66721,
                                -74.44361
                            ],
                            [
                                -101.70911,
                                -74.51025
                            ],
                            [
                                -101.49754,
                                -74.61661
                            ],
                            [
                                -100.82614,
                                -74.85602
                            ],
                            [
                                -100.57831,
                                -74.96092
                            ],
                            [
                                -100.42419,
                                -75.12415
                            ],
                            [
                                -100.65553,
                                -75.13644
                            ],
                            [
                                -101.09232,
                                -75.20399
                            ],
                            [
                                -101.9923,
                                -75.26131
                            ],
                            [
                                -101.97911,
                                -75.14309
                            ],
                            [
                                -102.07288,
                                -75.03736
                            ],
                            [
                                -102.27027,
                                -74.99013
                            ],
                            [
                                -103.14573,
                                -74.84917
                            ],
                            [
                                -103.30838,
                                -74.8059
                            ],
                            [
                                -103.38307,
                                -74.7408
                            ],
                            [
                                -103.96185,
                                -74.74779
                            ],
                            [
                                -104.29483,
                                -74.69521
                            ],
                            [
                                -104.67857,
                                -74.72294
                            ],
                            [
                                -104.98159,
                                -74.68837
                            ],
                            [
                                -105.17507,
                                -74.79515
                            ],
                            [
                                -105.15727,
                                -74.85121
                            ],
                            [
                                -105.30292,
                                -74.9481
                            ],
                            [
                                -105.33309,
                                -75.03195
                            ],
                            [
                                -105.26519,
                                -75.12724
                            ],
                            [
                                -105.39751,
                                -75.18705
                            ],
                            [
                                -105.6621,
                                -75.22822
                            ],
                            [
                                -106.23975,
                                -75.286
                            ],
                            [
                                -106.56205,
                                -75.2914
                            ],
                            [
                                -106.8557,
                                -75.25244
                            ],
                            [
                                -106.66831,
                                -75.0882
                            ],
                            [
                                -106.60517,
                                -74.9708
                            ],
                            [
                                -106.66541,
                                -74.89781
                            ],
                            [
                                -106.5516,
                                -74.81357
                            ],
                            [
                                -106.63203,
                                -74.78417
                            ],
                            [
                                -106.94384,
                                -74.78356
                            ],
                            [
                                -107.19122,
                                -74.75037
                            ],
                            [
                                -107.25439,
                                -74.5891
                            ],
                            [
                                -107.32877,
                                -74.56479
                            ],
                            [
                                -107.96316,
                                -74.62038
                            ],
                            [
                                -108.22391,
                                -74.59735
                            ],
                            [
                                -108.31411,
                                -74.70725
                            ],
                            [
                                -108.58664,
                                -74.72071
                            ],
                            [
                                -108.76325,
                                -74.80904
                            ],
                            [
                                -109.04233,
                                -74.73867
                            ],
                            [
                                -109.04352,
                                -74.6658
                            ],
                            [
                                -109.2224,
                                -74.59375
                            ],
                            [
                                -109.80414,
                                -74.65174
                            ],
                            [
                                -109.95059,
                                -74.60242
                            ],
                            [
                                -109.92715,
                                -74.54209
                            ],
                            [
                                -110.05301,
                                -74.38569
                            ],
                            [
                                -110.20202,
                                -74.27541
                            ],
                            [
                                -110.67881,
                                -74.26933
                            ],
                            [
                                -111.11594,
                                -74.20439
                            ],
                            [
                                -111.58197,
                                -74.20677
                            ],
                            [
                                -111.64979,
                                -74.28804
                            ],
                            [
                                -111.44533,
                                -74.42129
                            ],
                            [
                                -111.46593,
                                -74.50268
                            ],
                            [
                                -111.66948,
                                -74.51436
                            ],
                            [
                                -111.73898,
                                -74.57489
                            ],
                            [
                                -111.55159,
                                -74.68608
                            ],
                            [
                                -111.2239,
                                -74.71587
                            ],
                            [
                                -111.40282,
                                -74.78057
                            ],
                            [
                                -112.12672,
                                -74.7964
                            ],
                            [
                                -112.3263,
                                -74.83209
                            ],
                            [
                                -112.81487,
                                -74.84701
                            ],
                            [
                                -112.64813,
                                -74.74601
                            ],
                            [
                                -112.95811,
                                -74.64466
                            ],
                            [
                                -112.81661,
                                -74.52832
                            ],
                            [
                                -113.00555,
                                -74.43854
                            ],
                            [
                                -113.23271,
                                -74.39912
                            ],
                            [
                                -113.49192,
                                -74.41122
                            ],
                            [
                                -113.60307,
                                -74.35954
                            ],
                            [
                                -113.40552,
                                -74.30811
                            ],
                            [
                                -113.47968,
                                -74.22713
                            ],
                            [
                                -113.23715,
                                -74.18734
                            ],
                            [
                                -113.1076,
                                -74.11888
                            ],
                            [
                                -113.22202,
                                -74.02512
                            ],
                            [
                                -113.564,
                                -74.01307
                            ],
                            [
                                -114.11976,
                                -74.14004
                            ],
                            [
                                -113.98389,
                                -74.03691
                            ],
                            [
                                -113.6046,
                                -73.93042
                            ],
                            [
                                -113.65465,
                                -73.88406
                            ],
                            [
                                -113.95044,
                                -73.84293
                            ],
                            [
                                -114.23692,
                                -73.90987
                            ],
                            [
                                -114.4602,
                                -73.90846
                            ],
                            [
                                -114.88835,
                                -74.0795
                            ],
                            [
                                -114.91862,
                                -74.16193
                            ],
                            [
                                -114.62121,
                                -74.35938
                            ],
                            [
                                -114.65915,
                                -74.48365
                            ],
                            [
                                -114.92992,
                                -74.4665
                            ],
                            [
                                -115.43687,
                                -74.5063
                            ],
                            [
                                -115.72418,
                                -74.43591
                            ],
                            [
                                -116.08811,
                                -74.51136
                            ],
                            [
                                -116.29288,
                                -74.50681
                            ],
                            [
                                -116.52479,
                                -74.5389
                            ],
                            [
                                -117.04118,
                                -74.51672
                            ],
                            [
                                -117.29255,
                                -74.47455
                            ],
                            [
                                -117.29076,
                                -74.41795
                            ],
                            [
                                -117.62243,
                                -74.37214
                            ],
                            [
                                -117.84528,
                                -74.23106
                            ],
                            [
                                -118.14407,
                                -74.34131
                            ],
                            [
                                -118.32046,
                                -74.4362
                            ],
                            [
                                -118.63373,
                                -74.51547
                            ],
                            [
                                -118.99734,
                                -74.50001
                            ],
                            [
                                -119.22786,
                                -74.528
                            ],
                            [
                                -120.23997,
                                -74.59129
                            ],
                            [
                                -120.61165,
                                -74.52799
                            ],
                            [
                                -120.85336,
                                -74.60848
                            ],
                            [
                                -121.05928,
                                -74.62484
                            ],
                            [
                                -121.45142,
                                -74.606
                            ],
                            [
                                -122.2103,
                                -74.60861
                            ],
                            [
                                -122.87614,
                                -74.67059
                            ],
                            [
                                -123.61646,
                                -74.66214
                            ],
                            [
                                -124.11947,
                                -74.68385
                            ],
                            [
                                -124.59445,
                                -74.67585
                            ],
                            [
                                -125.25263,
                                -74.69378
                            ],
                            [
                                -125.63796,
                                -74.75314
                            ],
                            [
                                -126.08994,
                                -74.76897
                            ],
                            [
                                -126.27441,
                                -74.74831
                            ],
                            [
                                -126.52031,
                                -74.66905
                            ],
                            [
                                -126.85196,
                                -74.64171
                            ],
                            [
                                -127.30788,
                                -74.65661
                            ],
                            [
                                -127.46835,
                                -74.69479
                            ],
                            [
                                -127.63757,
                                -74.68222
                            ],
                            [
                                -128.00667,
                                -74.72513
                            ],
                            [
                                -128.4837,
                                -74.7459
                            ],
                            [
                                -128.61163,
                                -74.78487
                            ],
                            [
                                -128.89575,
                                -74.80047
                            ],
                            [
                                -129.1514,
                                -74.84241
                            ],
                            [
                                -129.46101,
                                -74.83554
                            ],
                            [
                                -129.72865,
                                -74.86763
                            ],
                            [
                                -130.10309,
                                -74.85732
                            ],
                            [
                                -130.42455,
                                -74.80494
                            ],
                            [
                                -130.9254,
                                -74.79141
                            ],
                            [
                                -131.44797,
                                -74.80722
                            ],
                            [
                                -131.92845,
                                -74.73363
                            ],
                            [
                                -132.40535,
                                -74.78748
                            ],
                            [
                                -132.73865,
                                -74.73093
                            ],
                            [
                                -132.9536,
                                -74.77683
                            ],
                            [
                                -133.5298,
                                -74.81348
                            ],
                            [
                                -133.78876,
                                -74.86532
                            ],
                            [
                                -134.24445,
                                -74.82861
                            ],
                            [
                                -134.15517,
                                -74.70239
                            ],
                            [
                                -134.28177,
                                -74.68933
                            ],
                            [
                                -134.40053,
                                -74.60435
                            ],
                            [
                                -134.93266,
                                -74.5675
                            ],
                            [
                                -135.06786,
                                -74.5131
                            ],
                            [
                                -135.57787,
                                -74.49553
                            ],
                            [
                                -135.73195,
                                -74.52883
                            ],
                            [
                                -136.04414,
                                -74.66638
                            ],
                            [
                                -136.49654,
                                -74.64688
                            ],
                            [
                                -136.84747,
                                -74.72316
                            ],
                            [
                                -137.17298,
                                -74.72849
                            ],
                            [
                                -137.11205,
                                -74.84749
                            ],
                            [
                                -136.88004,
                                -74.85241
                            ],
                            [
                                -136.96191,
                                -74.93072
                            ],
                            [
                                -136.95627,
                                -75.03193
                            ],
                            [
                                -137.43001,
                                -75.14493
                            ],
                            [
                                -137.64834,
                                -75.09596
                            ],
                            [
                                -137.87606,
                                -75.08767
                            ],
                            [
                                -138.07729,
                                -75.14509
                            ],
                            [
                                -138.73647,
                                -75.19768
                            ],
                            [
                                -139.78554,
                                -75.18723
                            ],
                            [
                                -140.05481,
                                -75.24216
                            ],
                            [
                                -140.18682,
                                -75.38123
                            ],
                            [
                                -140.31909,
                                -75.44641
                            ],
                            [
                                -140.52911,
                                -75.46447
                            ],
                            [
                                -140.5335,
                                -75.53886
                            ],
                            [
                                -141.15205,
                                -75.58958
                            ],
                            [
                                -141.57818,
                                -75.57813
                            ],
                            [
                                -141.52714,
                                -75.66402
                            ],
                            [
                                -141.90531,
                                -75.70457
                            ],
                            [
                                -142.0147,
                                -75.61837
                            ],
                            [
                                -142.44124,
                                -75.53278
                            ],
                            [
                                -142.7188,
                                -75.5545
                            ],
                            [
                                -142.7075,
                                -75.65148
                            ],
                            [
                                -142.90105,
                                -75.66653
                            ],
                            [
                                -143.31393,
                                -75.60957
                            ],
                            [
                                -144.00326,
                                -75.68421
                            ],
                            [
                                -144.27119,
                                -75.68888
                            ],
                            [
                                -144.23725,
                                -75.81036
                            ],
                            [
                                -144.56163,
                                -75.88045
                            ],
                            [
                                -144.85996,
                                -75.89041
                            ],
                            [
                                -145.25125,
                                -75.95279
                            ],
                            [
                                -145.90628,
                                -75.92821
                            ],
                            [
                                -146.12369,
                                -75.96057
                            ],
                            [
                                -146.39961,
                                -76.0863
                            ],
                            [
                                -146.33365,
                                -76.15185
                            ],
                            [
                                -145.87975,
                                -76.30584
                            ],
                            [
                                -145.46077,
                                -76.35907
                            ],
                            [
                                -145.43414,
                                -76.45203
                            ],
                            [
                                -145.71309,
                                -76.49831
                            ],
                            [
                                -146.3018,
                                -76.41989
                            ],
                            [
                                -146.58351,
                                -76.40846
                            ],
                            [
                                -147.2232,
                                -76.27196
                            ],
                            [
                                -148.22612,
                                -76.12678
                            ],
                            [
                                -148.42341,
                                -76.12997
                            ],
                            [
                                -148.6358,
                                -76.2062
                            ],
                            [
                                -148.50688,
                                -76.2752
                            ],
                            [
                                -148.99648,
                                -76.32372
                            ],
                            [
                                -149.26553,
                                -76.31256
                            ],
                            [
                                -149.52727,
                                -76.36966
                            ],
                            [
                                -149.50574,
                                -76.4513
                            ],
                            [
                                -149.00201,
                                -76.48629
                            ],
                            [
                                -148.65748,
                                -76.53269
                            ],
                            [
                                -148.355,
                                -76.54706
                            ],
                            [
                                -147.93069,
                                -76.46757
                            ],
                            [
                                -146.98568,
                                -76.49879
                            ],
                            [
                                -146.56218,
                                -76.57631
                            ],
                            [
                                -146.28029,
                                -76.67302
                            ],
                            [
                                -145.83282,
                                -76.72346
                            ],
                            [
                                -145.53082,
                                -76.78036
                            ],
                            [
                                -145.58083,
                                -76.8547
                            ],
                            [
                                -146.1814,
                                -76.87109
                            ],
                            [
                                -145.73675,
                                -76.96014
                            ],
                            [
                                -145.39214,
                                -76.983
                            ],
                            [
                                -145.33056,
                                -77.0832
                            ],
                            [
                                -146.08642,
                                -77.01701
                            ],
                            [
                                -146.29753,
                                -77.07168
                            ],
                            [
                                -145.98724,
                                -77.11317
                            ],
                            [
                                -145.93417,
                                -77.2238
                            ],
                            [
                                -146.01938,
                                -77.31094
                            ],
                            [
                                -145.83133,
                                -77.33387
                            ],
                            [
                                -146.01516,
                                -77.41586
                            ],
                            [
                                -146.31563,
                                -77.44877
                            ],
                            [
                                -146.8656,
                                -77.25792
                            ],
                            [
                                -147.08231,
                                -77.30369
                            ],
                            [
                                -147.10031,
                                -77.38095
                            ],
                            [
                                -147.3992,
                                -77.36414
                            ],
                            [
                                -147.46205,
                                -77.43549
                            ],
                            [
                                -147.70203,
                                -77.50898
                            ],
                            [
                                -148.12343,
                                -77.51166
                            ],
                            [
                                -148.60067,
                                -77.55778
                            ],
                            [
                                -148.54012,
                                -77.64637
                            ],
                            [
                                -148.71363,
                                -77.69387
                            ],
                            [
                                -149.29802,
                                -77.6105
                            ],
                            [
                                -149.56719,
                                -77.66268
                            ],
                            [
                                -149.06194,
                                -77.72436
                            ],
                            [
                                -149.02801,
                                -77.75495
                            ],
                            [
                                -149.37112,
                                -77.81784
                            ],
                            [
                                -149.62741,
                                -77.82246
                            ],
                            [
                                -149.95009,
                                -77.78535
                            ],
                            [
                                -150.60723,
                                -77.6276
                            ],
                            [
                                -150.85062,
                                -77.58845
                            ],
                            [
                                -150.98005,
                                -77.52937
                            ],
                            [
                                -151.41549,
                                -77.41686
                            ],
                            [
                                -151.90206,
                                -77.39581
                            ],
                            [
                                -152.06291,
                                -77.34069
                            ],
                            [
                                -152.26227,
                                -77.35149
                            ],
                            [
                                -152.26036,
                                -77.45246
                            ],
                            [
                                -152.3807,
                                -77.5084
                            ],
                            [
                                -152.82898,
                                -77.51352
                            ],
                            [
                                -153.0543,
                                -77.48832
                            ],
                            [
                                -153.6441,
                                -77.48187
                            ],
                            [
                                -153.66957,
                                -77.4556
                            ],
                            [
                                -153.18343,
                                -77.42844
                            ],
                            [
                                -153.14085,
                                -77.35454
                            ],
                            [
                                -153.34462,
                                -77.30083
                            ],
                            [
                                -153.8152,
                                -77.26087
                            ],
                            [
                                -154.15674,
                                -77.21287
                            ],
                            [
                                -154.40538,
                                -77.23146
                            ],
                            [
                                -154.61309,
                                -77.17638
                            ],
                            [
                                -155.16349,
                                -77.21918
                            ],
                            [
                                -155.42621,
                                -77.14
                            ],
                            [
                                -155.7379,
                                -77.11777
                            ],
                            [
                                -156.07078,
                                -77.12177
                            ],
                            [
                                -156.33853,
                                -77.19596
                            ],
                            [
                                -156.23005,
                                -77.28383
                            ],
                            [
                                -156.62166,
                                -77.41167
                            ],
                            [
                                -156.74257,
                                -77.40991
                            ],
                            [
                                -157.23221,
                                -77.29684
                            ],
                            [
                                -157.485,
                                -77.15818
                            ],
                            [
                                -157.79507,
                                -77.12065
                            ],
                            [
                                -157.9901,
                                -77.17964
                            ],
                            [
                                -157.82941,
                                -77.24356
                            ],
                            [
                                -157.99147,
                                -77.34017
                            ],
                            [
                                -157.89444,
                                -77.43398
                            ],
                            [
                                -157.69151,
                                -77.52023
                            ],
                            [
                                -157.74931,
                                -77.61858
                            ],
                            [
                                -157.96156,
                                -77.71889
                            ],
                            [
                                -158.20865,
                                -77.90778
                            ],
                            [
                                -157.94504,
                                -78.06959
                            ],
                            [
                                -156.76675,
                                -78.14735
                            ],
                            [
                                -156.99675,
                                -78.25002
                            ],
                            [
                                -157.00101,
                                -78.2946
                            ],
                            [
                                -156.80644,
                                -78.41953
                            ],
                            [
                                -157.27422,
                                -78.45041
                            ],
                            [
                                -157.64755,
                                -78.53055
                            ],
                            [
                                -157.73164,
                                -78.67101
                            ],
                            [
                                -157.57228,
                                -78.76943
                            ],
                            [
                                -157.32913,
                                -78.83317
                            ],
                            [
                                -156.58038,
                                -78.95347
                            ],
                            [
                                -155.87752,
                                -79.08281
                            ],
                            [
                                -155.22035,
                                -79.25357
                            ],
                            [
                                -154.23859,
                                -79.36346
                            ],
                            [
                                -153.88487,
                                -79.43668
                            ],
                            [
                                -153.48318,
                                -79.66644
                            ],
                            [
                                -153.14546,
                                -79.77237
                            ],
                            [
                                -152.66856,
                                -79.8151
                            ],
                            [
                                -152.28615,
                                -79.82536
                            ],
                            [
                                -151.96837,
                                -79.88522
                            ],
                            [
                                -151.91289,
                                -80.00626
                            ],
                            [
                                -151.54707,
                                -80.10858
                            ],
                            [
                                -151.34904,
                                -80.1976
                            ],
                            [
                                -151.05319,
                                -80.26772
                            ],
                            [
                                -150.42149,
                                -80.26476
                            ],
                            [
                                -149.71773,
                                -80.21904
                            ],
                            [
                                -149.00104,
                                -80.23148
                            ],
                            [
                                -148.2478,
                                -80.2655
                            ],
                            [
                                -147.55649,
                                -80.33382
                            ],
                            [
                                -146.63463,
                                -80.50131
                            ],
                            [
                                -145.37379,
                                -80.65057
                            ],
                            [
                                -145.20314,
                                -80.70447
                            ],
                            [
                                -145.44705,
                                -80.8131
                            ],
                            [
                                -145.93327,
                                -80.85959
                            ],
                            [
                                -147.60492,
                                -80.8962
                            ],
                            [
                                -149.77898,
                                -80.95528
                            ],
                            [
                                -150.74008,
                                -80.9955
                            ],
                            [
                                -152.61929,
                                -81.14221
                            ],
                            [
                                -153.60503,
                                -81.23679
                            ],
                            [
                                -154.53134,
                                -81.45603
                            ],
                            [
                                -154.79625,
                                -81.56052
                            ],
                            [
                                -155.03296,
                                -81.72175
                            ],
                            [
                                -154.85242,
                                -81.94204
                            ],
                            [
                                -154.15379,
                                -82.22446
                            ],
                            [
                                -154.06586,
                                -82.35356
                            ],
                            [
                                -154.18991,
                                -82.62779
                            ],
                            [
                                -154.16226,
                                -82.75488
                            ],
                            [
                                -153.30971,
                                -83.13039
                            ],
                            [
                                -152.86479,
                                -83.35514
                            ],
                            [
                                -152.87112,
                                -83.67805
                            ],
                            [
                                -152.93225,
                                -83.77394
                            ],
                            [
                                -153.21646,
                                -83.86245
                            ],
                            [
                                -152.9778,
                                -84.00491
                            ],
                            [
                                -152.1235,
                                -84.27312
                            ],
                            [
                                -151.12679,
                                -84.45387
                            ],
                            [
                                -150.02705,
                                -84.57755
                            ],
                            [
                                -148.99477,
                                -84.65346
                            ],
                            [
                                -146.62993,
                                -84.84483
                            ],
                            [
                                -145.50716,
                                -84.91724
                            ],
                            [
                                -143.27332,
                                -85.00756
                            ],
                            [
                                -140.79541,
                                -85.06191
                            ],
                            [
                                -138.31429,
                                -85.02263
                            ],
                            [
                                -137.44627,
                                -85.06761
                            ],
                            [
                                -138.46155,
                                -85.25356
                            ],
                            [
                                -139.34795,
                                -85.2896
                            ],
                            [
                                -140.69695,
                                -85.2944
                            ],
                            [
                                -142.68114,
                                -85.20293
                            ],
                            [
                                -145.51607,
                                -85.16131
                            ],
                            [
                                -147.94872,
                                -85.1452
                            ],
                            [
                                -148.81174,
                                -85.18704
                            ],
                            [
                                -149.3112,
                                -85.3465
                            ],
                            [
                                -150.00165,
                                -85.43597
                            ],
                            [
                                -150.26662,
                                -85.50776
                            ],
                            [
                                -151.47794,
                                -85.47619
                            ],
                            [
                                -151.47598,
                                -85.58276
                            ],
                            [
                                -153.63676,
                                -85.57531
                            ],
                            [
                                -153.74414,
                                -85.53984
                            ],
                            [
                                -154.75385,
                                -85.49984
                            ],
                            [
                                -155.99232,
                                -85.51338
                            ],
                            [
                                -157.14977,
                                -85.47869
                            ],
                            [
                                -157.85559,
                                -85.47762
                            ],
                            [
                                -158.22758,
                                -85.5302
                            ],
                            [
                                -161.02605,
                                -85.49464
                            ],
                            [
                                -160.49568,
                                -85.39356
                            ],
                            [
                                -161.53705,
                                -85.36217
                            ],
                            [
                                -161.81172,
                                -85.44962
                            ],
                            [
                                -162.42932,
                                -85.3914
                            ],
                            [
                                -162.14471,
                                -85.30005
                            ],
                            [
                                -162.73639,
                                -85.23741
                            ],
                            [
                                -162.9406,
                                -85.16615
                            ],
                            [
                                -163.6915,
                                -85.18713
                            ],
                            [
                                -164.12973,
                                -85.10892
                            ],
                            [
                                -164.83252,
                                -85.11621
                            ],
                            [
                                -166.15372,
                                -84.97176
                            ],
                            [
                                -166.87286,
                                -84.92787
                            ],
                            [
                                -167.04311,
                                -84.79213
                            ],
                            [
                                -167.83377,
                                -84.82929
                            ],
                            [
                                -168.48488,
                                -84.71349
                            ],
                            [
                                -169.08092,
                                -84.67844
                            ],
                            [
                                -171.28723,
                                -84.58618
                            ],
                            [
                                -173.63515,
                                -84.49458
                            ],
                            [
                                -175.0717,
                                -84.48048
                            ],
                            [
                                -175.28941,
                                -84.44107
                            ],
                            [
                                -176.4304,
                                -84.36146
                            ],
                            [
                                -177.94899,
                                -84.28226
                            ],
                            [
                                -178.89047,
                                -84.24849
                            ],
                            [
                                -179.07394,
                                -84.26801
                            ],
                            [
                                -178.2959,
                                -84.35055
                            ],
                            [
                                -179.43007,
                                -84.38486
                            ],
                            [
                                -180,
                                -84.42873
                            ],
                            [
                                -180,
                                -89.9
                            ],
                            [
                                179.77973,
                                -84.62101
                            ],
                            [
                                179.77878,
                                -84.41762
                            ],
                            [
                                179.51232,
                                -84.3752
                            ],
                            [
                                179.39897,
                                -84.2838
                            ],
                            [
                                179.02546,
                                -84.24896
                            ],
                            [
                                177.9048,
                                -84.20359
                            ],
                            [
                                176.57443,
                                -84.03642
                            ],
                            [
                                175.14343,
                                -84.0013
                            ],
                            [
                                174.96849,
                                -83.91456
                            ],
                            [
                                174.38623,
                                -83.89782
                            ],
                            [
                                173.36915,
                                -83.95687
                            ],
                            [
                                172.9212,
                                -83.93664
                            ],
                            [
                                173.49086,
                                -83.82755
                            ],
                            [
                                172.7743,
                                -83.75082
                            ],
                            [
                                172.16262,
                                -83.75593
                            ],
                            [
                                171.62863,
                                -83.79329
                            ],
                            [
                                171.90877,
                                -83.61168
                            ],
                            [
                                171.61955,
                                -83.56651
                            ],
                            [
                                170.81244,
                                -83.55751
                            ],
                            [
                                170.0784,
                                -83.52281
                            ],
                            [
                                169.83072,
                                -83.46832
                            ],
                            [
                                169.09175,
                                -83.40141
                            ],
                            [
                                168.3546,
                                -83.45959
                            ],
                            [
                                168.18179,
                                -83.5172
                            ],
                            [
                                167.81645,
                                -83.52216
                            ],
                            [
                                167.57236,
                                -83.4555
                            ],
                            [
                                167.70663,
                                -83.33859
                            ],
                            [
                                168.13968,
                                -83.32457
                            ],
                            [
                                168.06211,
                                -83.24914
                            ],
                            [
                                168.56376,
                                -83.19874
                            ],
                            [
                                168.33549,
                                -83.08865
                            ],
                            [
                                168.1213,
                                -83.05996
                            ],
                            [
                                166.83115,
                                -83.00668
                            ],
                            [
                                166.48724,
                                -82.94247
                            ],
                            [
                                167.14688,
                                -82.92182
                            ],
                            [
                                166.92331,
                                -82.86137
                            ],
                            [
                                166.35875,
                                -82.82484
                            ],
                            [
                                166.3067,
                                -82.74675
                            ],
                            [
                                165.63233,
                                -82.69066
                            ],
                            [
                                165.04806,
                                -82.72298
                            ],
                            [
                                164.75786,
                                -82.68165
                            ],
                            [
                                165.23818,
                                -82.57634
                            ],
                            [
                                165.33669,
                                -82.52019
                            ],
                            [
                                164.70004,
                                -82.42046
                            ],
                            [
                                164.40939,
                                -82.41938
                            ],
                            [
                                163.85647,
                                -82.47358
                            ],
                            [
                                163.11298,
                                -82.49933
                            ],
                            [
                                163.34716,
                                -82.58293
                            ],
                            [
                                162.85841,
                                -82.66013
                            ],
                            [
                                162.59024,
                                -82.55975
                            ],
                            [
                                162.33551,
                                -82.53736
                            ],
                            [
                                161.66638,
                                -82.5497
                            ],
                            [
                                161.57545,
                                -82.47211
                            ],
                            [
                                161.21857,
                                -82.401
                            ],
                            [
                                161.67252,
                                -82.35355
                            ],
                            [
                                162.37348,
                                -82.3123
                            ],
                            [
                                163.03481,
                                -82.29796
                            ],
                            [
                                163.56698,
                                -82.31179
                            ],
                            [
                                163.75165,
                                -82.26545
                            ],
                            [
                                163.50603,
                                -82.16085
                            ],
                            [
                                163.05243,
                                -82.03318
                            ],
                            [
                                162.77946,
                                -82.00116
                            ],
                            [
                                162.69415,
                                -81.89266
                            ],
                            [
                                162.29201,
                                -81.90448
                            ],
                            [
                                162.17053,
                                -81.85369
                            ],
                            [
                                162.17796,
                                -81.74687
                            ],
                            [
                                160.90291,
                                -81.56866
                            ],
                            [
                                160.95546,
                                -81.4937
                            ],
                            [
                                160.81175,
                                -81.43195
                            ],
                            [
                                160.45798,
                                -81.40993
                            ],
                            [
                                160.51302,
                                -81.27066
                            ],
                            [
                                160.33051,
                                -81.02643
                            ],
                            [
                                160.65745,
                                -80.97578
                            ],
                            [
                                160.07494,
                                -80.90519
                            ],
                            [
                                160.55167,
                                -80.82267
                            ],
                            [
                                160.58979,
                                -80.7756
                            ],
                            [
                                160.90686,
                                -80.74831
                            ],
                            [
                                160.93284,
                                -80.6994
                            ],
                            [
                                160.62796,
                                -80.66762
                            ],
                            [
                                160.15265,
                                -80.72907
                            ],
                            [
                                159.66422,
                                -80.68928
                            ],
                            [
                                160.39025,
                                -80.57626
                            ],
                            [
                                160.77499,
                                -80.54842
                            ],
                            [
                                160.28832,
                                -80.30088
                            ],
                            [
                                159.98726,
                                -80.18459
                            ],
                            [
                                160.36933,
                                -80.02298
                            ],
                            [
                                160.1587,
                                -79.9327
                            ],
                            [
                                160.22602,
                                -79.81808
                            ],
                            [
                                159.9956,
                                -79.73491
                            ],
                            [
                                160.02055,
                                -79.6249
                            ],
                            [
                                160.27914,
                                -79.5462
                            ],
                            [
                                160.24016,
                                -79.44808
                            ],
                            [
                                160.49086,
                                -79.37228
                            ],
                            [
                                160.50698,
                                -79.32093
                            ],
                            [
                                160.26777,
                                -79.2467
                            ],
                            [
                                160.45965,
                                -79.21994
                            ],
                            [
                                160.88914,
                                -79.10886
                            ],
                            [
                                161.7314,
                                -79.10945
                            ],
                            [
                                161.98117,
                                -79.12593
                            ],
                            [
                                162.49469,
                                -79.11402
                            ],
                            [
                                162.61066,
                                -79.07194
                            ],
                            [
                                162.61669,
                                -78.88326
                            ],
                            [
                                163.15489,
                                -78.82728
                            ],
                            [
                                163.25947,
                                -78.76704
                            ],
                            [
                                163.70883,
                                -78.76522
                            ],
                            [
                                163.92221,
                                -78.73972
                            ],
                            [
                                164.0526,
                                -78.65239
                            ],
                            [
                                164.26531,
                                -78.63439
                            ],
                            [
                                165.08791,
                                -78.65692
                            ],
                            [
                                165.45615,
                                -78.65245
                            ],
                            [
                                165.62027,
                                -78.60559
                            ],
                            [
                                166.10938,
                                -78.58442
                            ],
                            [
                                166.76781,
                                -78.64428
                            ],
                            [
                                166.94994,
                                -78.73949
                            ],
                            [
                                167.11805,
                                -78.71498
                            ],
                            [
                                166.97203,
                                -78.56415
                            ],
                            [
                                166.56366,
                                -78.55134
                            ],
                            [
                                165.85365,
                                -78.50467
                            ],
                            [
                                165.56982,
                                -78.4294
                            ],
                            [
                                165.56704,
                                -78.32195
                            ],
                            [
                                165.22798,
                                -78.24567
                            ],
                            [
                                165.45741,
                                -78.1842
                            ],
                            [
                                165.47129,
                                -78.10147
                            ],
                            [
                                165.21506,
                                -78.10311
                            ],
                            [
                                165.04088,
                                -78.20799
                            ],
                            [
                                165.00468,
                                -78.29124
                            ],
                            [
                                164.57329,
                                -78.37561
                            ],
                            [
                                164.23246,
                                -78.33686
                            ],
                            [
                                163.73027,
                                -78.41762
                            ],
                            [
                                163.29886,
                                -78.31164
                            ],
                            [
                                163.41797,
                                -78.26997
                            ],
                            [
                                163.7329,
                                -78.2492
                            ],
                            [
                                164.26999,
                                -78.13929
                            ],
                            [
                                164.45748,
                                -77.99167
                            ],
                            [
                                164.31148,
                                -77.73587
                            ],
                            [
                                164.04751,
                                -77.70259
                            ],
                            [
                                163.68343,
                                -77.75285
                            ],
                            [
                                163.35861,
                                -77.71315
                            ],
                            [
                                163.58706,
                                -77.66485
                            ],
                            [
                                163.38317,
                                -77.6068
                            ],
                            [
                                163.72428,
                                -77.55271
                            ],
                            [
                                163.72194,
                                -77.45625
                            ],
                            [
                                163.4275,
                                -77.40692
                            ],
                            [
                                163.47443,
                                -77.3589
                            ],
                            [
                                163.01609,
                                -77.12075
                            ],
                            [
                                163.0508,
                                -77.08608
                            ],
                            [
                                162.54241,
                                -77.05195
                            ],
                            [
                                162.37059,
                                -77.07429
                            ],
                            [
                                162.20304,
                                -76.9999
                            ],
                            [
                                162.4525,
                                -76.97499
                            ],
                            [
                                162.52289,
                                -76.88082
                            ],
                            [
                                162.82777,
                                -76.86615
                            ],
                            [
                                162.87511,
                                -76.76853
                            ],
                            [
                                162.55358,
                                -76.69135
                            ],
                            [
                                162.61225,
                                -76.59929
                            ],
                            [
                                162.77287,
                                -76.48123
                            ],
                            [
                                162.61801,
                                -76.40747
                            ],
                            [
                                162.66823,
                                -76.28896
                            ],
                            [
                                162.40013,
                                -76.27424
                            ],
                            [
                                162.3762,
                                -76.20861
                            ],
                            [
                                162.23335,
                                -76.16093
                            ],
                            [
                                162.62872,
                                -76.11955
                            ],
                            [
                                162.58925,
                                -75.98191
                            ],
                            [
                                162.762,
                                -75.87902
                            ],
                            [
                                162.72233,
                                -75.82216
                            ],
                            [
                                162.96704,
                                -75.78161
                            ],
                            [
                                162.4984,
                                -75.71817
                            ],
                            [
                                162.62584,
                                -75.62353
                            ],
                            [
                                162.8505,
                                -75.59458
                            ],
                            [
                                162.67949,
                                -75.49737
                            ],
                            [
                                163.09832,
                                -75.50768
                            ],
                            [
                                164.62763,
                                -75.57177
                            ],
                            [
                                164.66727,
                                -75.43249
                            ],
                            [
                                164.28525,
                                -75.43075
                            ],
                            [
                                164.35204,
                                -75.37233
                            ],
                            [
                                164.16083,
                                -75.30367
                            ],
                            [
                                163.94306,
                                -75.27256
                            ],
                            [
                                163.82842,
                                -75.3011
                            ],
                            [
                                163.54804,
                                -75.27981
                            ],
                            [
                                163.25233,
                                -75.28787
                            ],
                            [
                                162.55995,
                                -75.25793
                            ],
                            [
                                162.58996,
                                -75.13403
                            ],
                            [
                                162.73668,
                                -75.03948
                            ],
                            [
                                162.40901,
                                -74.98216
                            ],
                            [
                                162.49916,
                                -74.91115
                            ],
                            [
                                162.73439,
                                -74.85999
                            ],
                            [
                                162.69187,
                                -74.7914
                            ],
                            [
                                163.04594,
                                -74.73322
                            ],
                            [
                                163.21365,
                                -74.57998
                            ],
                            [
                                163.44467,
                                -74.52177
                            ],
                            [
                                163.598,
                                -74.57706
                            ],
                            [
                                163.62101,
                                -74.66338
                            ],
                            [
                                163.93749,
                                -74.65122
                            ],
                            [
                                163.62349,
                                -74.77486
                            ],
                            [
                                163.72611,
                                -74.87072
                            ],
                            [
                                163.93256,
                                -74.82815
                            ],
                            [
                                164.25525,
                                -74.57406
                            ],
                            [
                                164.45802,
                                -74.6045
                            ],
                            [
                                164.81887,
                                -74.62478
                            ],
                            [
                                165.11318,
                                -74.57547
                            ],
                            [
                                165.3745,
                                -74.66584
                            ],
                            [
                                165.39849,
                                -74.55484
                            ],
                            [
                                165.19295,
                                -74.51065
                            ],
                            [
                                164.99727,
                                -74.31357
                            ],
                            [
                                164.8301,
                                -74.28593
                            ],
                            [
                                165.09327,
                                -74.19824
                            ],
                            [
                                165.07466,
                                -74.12062
                            ],
                            [
                                165.27284,
                                -74.0734
                            ],
                            [
                                165.47166,
                                -74.06957
                            ],
                            [
                                165.72251,
                                -74.1223
                            ],
                            [
                                166.06408,
                                -74.14425
                            ],
                            [
                                166.23057,
                                -74.03796
                            ],
                            [
                                166.00718,
                                -73.99735
                            ],
                            [
                                165.61455,
                                -73.9596
                            ],
                            [
                                165.80778,
                                -73.8789
                            ],
                            [
                                166.13281,
                                -73.85565
                            ],
                            [
                                166.65459,
                                -73.74398
                            ],
                            [
                                166.64724,
                                -73.65664
                            ],
                            [
                                166.85746,
                                -73.69414
                            ],
                            [
                                167.00285,
                                -73.60297
                            ],
                            [
                                167.20553,
                                -73.55947
                            ],
                            [
                                167.76284,
                                -73.51654
                            ],
                            [
                                168.23286,
                                -73.60494
                            ],
                            [
                                168.37723,
                                -73.61467
                            ],
                            [
                                168.52492,
                                -73.55752
                            ],
                            [
                                168.58456,
                                -73.46919
                            ],
                            [
                                168.91126,
                                -73.50321
                            ],
                            [
                                169.04163,
                                -73.45753
                            ],
                            [
                                168.97066,
                                -73.40259
                            ],
                            [
                                169.15903,
                                -73.30093
                            ],
                            [
                                169.16045,
                                -73.13821
                            ],
                            [
                                169.35032,
                                -73.1448
                            ],
                            [
                                169.58244,
                                -73.10734
                            ],
                            [
                                169.60506,
                                -73.00422
                            ],
                            [
                                169.85644,
                                -72.76632
                            ],
                            [
                                169.86304,
                                -72.71002
                            ],
                            [
                                170.11913,
                                -72.71251
                            ],
                            [
                                170.11123,
                                -72.64761
                            ],
                            [
                                170.25429,
                                -72.60649
                            ],
                            [
                                170.28308,
                                -72.46671
                            ],
                            [
                                170.24183,
                                -72.35059
                            ],
                            [
                                170.12803,
                                -72.34669
                            ],
                            [
                                169.95158,
                                -72.42513
                            ],
                            [
                                169.81469,
                                -72.41759
                            ],
                            [
                                169.96854,
                                -72.33213
                            ],
                            [
                                169.88722,
                                -72.25032
                            ],
                            [
                                170.15082,
                                -72.03113
                            ],
                            [
                                170.31997,
                                -72.06293
                            ],
                            [
                                170.62237,
                                -72.00351
                            ],
                            [
                                170.89521,
                                -71.89565
                            ],
                            [
                                170.69999,
                                -71.75929
                            ],
                            [
                                170.65081,
                                -71.67916
                            ],
                            [
                                170.42399,
                                -71.52966
                            ],
                            [
                                170.4174,
                                -71.45746
                            ],
                            [
                                170.17733,
                                -71.42128
                            ],
                            [
                                170.28479,
                                -71.54116
                            ],
                            [
                                170.18267,
                                -71.64727
                            ],
                            [
                                170.02063,
                                -71.64781
                            ],
                            [
                                169.76102,
                                -71.58429
                            ],
                            [
                                169.73329,
                                -71.5391
                            ],
                            [
                                169.44129,
                                -71.55544
                            ],
                            [
                                169.25887,
                                -71.43508
                            ],
                            [
                                169.04702,
                                -71.39543
                            ],
                            [
                                168.8013,
                                -71.2945
                            ],
                            [
                                168.06888,
                                -71.18719
                            ],
                            [
                                167.90153,
                                -71.07912
                            ],
                            [
                                167.77562,
                                -71.04298
                            ],
                            [
                                167.89092,
                                -70.93188
                            ],
                            [
                                167.76223,
                                -70.84845
                            ],
                            [
                                167.48979,
                                -70.79974
                            ],
                            [
                                167.1577,
                                -70.79905
                            ],
                            [
                                166.85132,
                                -70.82969
                            ],
                            [
                                166.54804,
                                -70.81471
                            ],
                            [
                                166.34202,
                                -70.73506
                            ],
                            [
                                166.79679,
                                -70.74557
                            ],
                            [
                                166.75733,
                                -70.67488
                            ],
                            [
                                166.48495,
                                -70.63992
                            ],
                            [
                                166.24041,
                                -70.64622
                            ],
                            [
                                165.91161,
                                -70.72593
                            ],
                            [
                                165.78814,
                                -70.73604
                            ],
                            [
                                165.56719,
                                -70.69478
                            ],
                            [
                                165.30184,
                                -70.6188
                            ],
                            [
                                165.03526,
                                -70.59908
                            ],
                            [
                                164.72655,
                                -70.61841
                            ],
                            [
                                164.2605,
                                -70.5325
                            ],
                            [
                                164.04859,
                                -70.53045
                            ],
                            [
                                163.90564,
                                -70.57965
                            ],
                            [
                                163.5807,
                                -70.52064
                            ],
                            [
                                163.4387,
                                -70.54152
                            ],
                            [
                                163.69094,
                                -70.64961
                            ],
                            [
                                163.57247,
                                -70.69518
                            ],
                            [
                                163.08851,
                                -70.65451
                            ],
                            [
                                163.0287,
                                -70.56734
                            ],
                            [
                                162.88961,
                                -70.54797
                            ],
                            [
                                162.71093,
                                -70.43858
                            ],
                            [
                                162.62538,
                                -70.32717
                            ],
                            [
                                162.32341,
                                -70.30682
                            ],
                            [
                                162.14149,
                                -70.38641
                            ],
                            [
                                161.91964,
                                -70.37999
                            ],
                            [
                                161.5767,
                                -70.30332
                            ],
                            [
                                161.59107,
                                -70.27505
                            ],
                            [
                                161.22968,
                                -70.27092
                            ],
                            [
                                160.975,
                                -70.31465
                            ],
                            [
                                160.82216,
                                -70.2599
                            ],
                            [
                                160.73168,
                                -70.13818
                            ],
                            [
                                160.29779,
                                -70.05941
                            ],
                            [
                                160.33675,
                                -70.01522
                            ],
                            [
                                160.55936,
                                -70.00814
                            ],
                            [
                                160.4869,
                                -69.91603
                            ],
                            [
                                160.24522,
                                -69.9091
                            ],
                            [
                                160.23458,
                                -69.82722
                            ],
                            [
                                160.05906,
                                -69.78157
                            ],
                            [
                                159.76296,
                                -69.78627
                            ],
                            [
                                159.76494,
                                -69.73315
                            ],
                            [
                                159.54559,
                                -69.6286
                            ],
                            [
                                159.37196,
                                -69.60966
                            ],
                            [
                                159.41337,
                                -69.56251
                            ],
                            [
                                159.26888,
                                -69.49693
                            ],
                            [
                                159.02768,
                                -69.44455
                            ],
                            [
                                159.01934,
                                -69.38371
                            ],
                            [
                                158.89963,
                                -69.34094
                            ],
                            [
                                158.38583,
                                -69.40101
                            ],
                            [
                                158.29125,
                                -69.37003
                            ],
                            [
                                158.19669,
                                -69.28312
                            ],
                            [
                                157.95905,
                                -69.24116
                            ],
                            [
                                157.8078,
                                -69.18722
                            ],
                            [
                                157.67496,
                                -69.22097
                            ],
                            [
                                157.56142,
                                -69.18665
                            ],
                            [
                                157.37905,
                                -69.23676
                            ],
                            [
                                157.19977,
                                -69.06421
                            ],
                            [
                                157.05539,
                                -69.0945
                            ],
                            [
                                157.09797,
                                -69.19939
                            ],
                            [
                                156.80626,
                                -69.16489
                            ],
                            [
                                156.73914,
                                -69.22211
                            ],
                            [
                                156.43673,
                                -69.09572
                            ],
                            [
                                156.05196,
                                -69.05044
                            ],
                            [
                                155.98589,
                                -68.99896
                            ],
                            [
                                155.69772,
                                -68.97233
                            ],
                            [
                                155.56203,
                                -68.97818
                            ],
                            [
                                155.4342,
                                -68.92129
                            ],
                            [
                                155.15509,
                                -68.91805
                            ],
                            [
                                155.01151,
                                -69.03629
                            ],
                            [
                                154.86329,
                                -69.03226
                            ],
                            [
                                154.71088,
                                -68.96528
                            ],
                            [
                                154.4593,
                                -68.81404
                            ],
                            [
                                154.6293,
                                -68.73959
                            ],
                            [
                                154.44648,
                                -68.6464
                            ],
                            [
                                154.7599,
                                -68.67032
                            ],
                            [
                                154.69366,
                                -68.5885
                            ],
                            [
                                154.48574,
                                -68.53473
                            ],
                            [
                                154.28775,
                                -68.54528
                            ],
                            [
                                154.17843,
                                -68.4573
                            ],
                            [
                                153.81339,
                                -68.34055
                            ],
                            [
                                153.57088,
                                -68.34294
                            ],
                            [
                                153.46471,
                                -68.43302
                            ],
                            [
                                153.2971,
                                -68.47407
                            ],
                            [
                                153.01654,
                                -68.43394
                            ],
                            [
                                152.63406,
                                -68.42698
                            ],
                            [
                                152.40452,
                                -68.48593
                            ],
                            [
                                152.18777,
                                -68.64862
                            ],
                            [
                                152.04004,
                                -68.70325
                            ],
                            [
                                151.86528,
                                -68.73111
                            ],
                            [
                                151.39988,
                                -68.73899
                            ],
                            [
                                151.17878,
                                -68.69864
                            ],
                            [
                                151.05302,
                                -68.64077
                            ],
                            [
                                151.01122,
                                -68.54098
                            ],
                            [
                                151.08028,
                                -68.44965
                            ],
                            [
                                151.00211,
                                -68.3125
                            ],
                            [
                                149.81199,
                                -68.46562
                            ],
                            [
                                149.54182,
                                -68.37371
                            ],
                            [
                                149.12511,
                                -68.33661
                            ],
                            [
                                148.40131,
                                -68.44246
                            ],
                            [
                                147.87859,
                                -68.4071
                            ],
                            [
                                147.83926,
                                -68.29872
                            ],
                            [
                                148.06335,
                                -68.28109
                            ],
                            [
                                148.41885,
                                -68.32941
                            ],
                            [
                                148.60281,
                                -68.2816
                            ],
                            [
                                148.61091,
                                -68.22382
                            ],
                            [
                                148.44392,
                                -67.81815
                            ],
                            [
                                147.8154,
                                -67.80572
                            ],
                            [
                                147.49744,
                                -67.87616
                            ],
                            [
                                147.0576,
                                -67.92482
                            ],
                            [
                                146.73758,
                                -67.82792
                            ],
                            [
                                146.50838,
                                -67.8514
                            ],
                            [
                                146.56944,
                                -67.72763
                            ],
                            [
                                146.34758,
                                -67.7233
                            ],
                            [
                                146.20603,
                                -67.65311
                            ],
                            [
                                146.0344,
                                -67.6078
                            ],
                            [
                                145.68832,
                                -67.63812
                            ],
                            [
                                145.24862,
                                -67.60288
                            ],
                            [
                                145.28638,
                                -67.54198
                            ],
                            [
                                145.53397,
                                -67.422
                            ],
                            [
                                146.59645,
                                -67.24378
                            ],
                            [
                                146.67764,
                                -67.21542
                            ],
                            [
                                146.80745,
                                -67.10149
                            ],
                            [
                                146.82686,
                                -67.02353
                            ],
                            [
                                146.45131,
                                -66.85011
                            ],
                            [
                                146.24927,
                                -66.8324
                            ],
                            [
                                146.04644,
                                -66.84977
                            ],
                            [
                                145.81423,
                                -66.81198
                            ],
                            [
                                145.53731,
                                -66.82501
                            ],
                            [
                                145.53295,
                                -66.92059
                            ],
                            [
                                145.36974,
                                -67.01478
                            ],
                            [
                                145.26946,
                                -66.90296
                            ],
                            [
                                144.81101,
                                -67.08799
                            ],
                            [
                                144.72289,
                                -67.15692
                            ],
                            [
                                144.58862,
                                -67.17234
                            ],
                            [
                                144.54377,
                                -67.08833
                            ],
                            [
                                144.39637,
                                -67.01828
                            ],
                            [
                                144.30211,
                                -67.01833
                            ],
                            [
                                143.99367,
                                -67.09058
                            ],
                            [
                                143.78765,
                                -67.07499
                            ],
                            [
                                143.73527,
                                -67.02639
                            ],
                            [
                                143.76787,
                                -66.93794
                            ],
                            [
                                143.64837,
                                -66.8957
                            ],
                            [
                                143.40306,
                                -66.8658
                            ],
                            [
                                143.15235,
                                -66.89845
                            ],
                            [
                                142.8354,
                                -66.99851
                            ],
                            [
                                142.52127,
                                -67.03176
                            ],
                            [
                                142.34538,
                                -66.99289
                            ],
                            [
                                142.18077,
                                -66.87591
                            ],
                            [
                                141.88987,
                                -66.79478
                            ],
                            [
                                141.55919,
                                -66.78499
                            ],
                            [
                                141.33236,
                                -66.84005
                            ],
                            [
                                141.08255,
                                -66.74727
                            ],
                            [
                                140.5227,
                                -66.71932
                            ],
                            [
                                140.38596,
                                -66.74112
                            ],
                            [
                                140.09966,
                                -66.73479
                            ],
                            [
                                139.5991,
                                -66.61437
                            ],
                            [
                                139.23114,
                                -66.55441
                            ],
                            [
                                138.74256,
                                -66.55701
                            ],
                            [
                                138.56781,
                                -66.52335
                            ],
                            [
                                138.33417,
                                -66.53371
                            ],
                            [
                                137.89134,
                                -66.45218
                            ],
                            [
                                137.7054,
                                -66.38634
                            ],
                            [
                                136.91503,
                                -66.32232
                            ],
                            [
                                136.65358,
                                -66.36376
                            ],
                            [
                                136.41213,
                                -66.38259
                            ],
                            [
                                136.30966,
                                -66.3049
                            ],
                            [
                                136.16173,
                                -66.2928
                            ],
                            [
                                136.0058,
                                -66.20189
                            ],
                            [
                                136.06584,
                                -66.14779
                            ],
                            [
                                135.97492,
                                -66.121
                            ],
                            [
                                135.82495,
                                -66.17822
                            ],
                            [
                                135.69402,
                                -66.12032
                            ],
                            [
                                135.50009,
                                -66.09365
                            ],
                            [
                                135.35415,
                                -66.03021
                            ],
                            [
                                135.31211,
                                -65.90829
                            ],
                            [
                                135.47083,
                                -65.68065
                            ],
                            [
                                135.44736,
                                -65.58192
                            ],
                            [
                                135.23976,
                                -65.48488
                            ],
                            [
                                134.88817,
                                -65.28373
                            ],
                            [
                                134.69174,
                                -65.29041
                            ],
                            [
                                134.54657,
                                -65.32879
                            ],
                            [
                                134.51472,
                                -65.4192
                            ],
                            [
                                134.56033,
                                -65.50896
                            ],
                            [
                                134.46671,
                                -65.56662
                            ],
                            [
                                134.5908,
                                -65.64486
                            ],
                            [
                                134.75719,
                                -65.78969
                            ],
                            [
                                134.73015,
                                -65.86317
                            ],
                            [
                                134.55268,
                                -65.9044
                            ],
                            [
                                134.66661,
                                -65.976
                            ],
                            [
                                134.5329,
                                -66.00443
                            ],
                            [
                                134.44775,
                                -66.07749
                            ],
                            [
                                134.29105,
                                -66.11259
                            ],
                            [
                                134.13401,
                                -66.21049
                            ],
                            [
                                133.90239,
                                -66.16574
                            ],
                            [
                                133.81639,
                                -66.11182
                            ],
                            [
                                133.27659,
                                -66.10415
                            ],
                            [
                                132.79363,
                                -66.20394
                            ],
                            [
                                132.60727,
                                -66.18619
                            ],
                            [
                                132.46193,
                                -66.14496
                            ],
                            [
                                132.14448,
                                -66.15914
                            ],
                            [
                                131.87611,
                                -66.20929
                            ],
                            [
                                131.66114,
                                -66.21046
                            ],
                            [
                                131.40726,
                                -66.18448
                            ],
                            [
                                130.86634,
                                -66.07679
                            ],
                            [
                                130.45543,
                                -66.03883
                            ],
                            [
                                130.15833,
                                -66.02583
                            ],
                            [
                                129.96211,
                                -65.96616
                            ],
                            [
                                129.74378,
                                -65.92631
                            ],
                            [
                                129.49965,
                                -65.94489
                            ],
                            [
                                129.46347,
                                -65.97963
                            ],
                            [
                                129.55683,
                                -66.04623
                            ],
                            [
                                129.79489,
                                -66.13671
                            ],
                            [
                                130.00447,
                                -66.23885
                            ],
                            [
                                129.82149,
                                -66.36029
                            ],
                            [
                                129.76647,
                                -66.46062
                            ],
                            [
                                129.66524,
                                -66.53082
                            ],
                            [
                                129.60706,
                                -66.63137
                            ],
                            [
                                129.73073,
                                -66.69462
                            ],
                            [
                                129.60943,
                                -66.92706
                            ],
                            [
                                129.40008,
                                -67.01498
                            ],
                            [
                                129.24167,
                                -67.02367
                            ],
                            [
                                128.98354,
                                -66.9803
                            ],
                            [
                                128.65919,
                                -66.98384
                            ],
                            [
                                128.64882,
                                -67.02002
                            ],
                            [
                                128.32898,
                                -67.03586
                            ],
                            [
                                127.92013,
                                -67.01992
                            ],
                            [
                                127.93864,
                                -66.96715
                            ],
                            [
                                127.72685,
                                -66.85321
                            ],
                            [
                                127.6973,
                                -66.80181
                            ],
                            [
                                127.46818,
                                -66.70747
                            ],
                            [
                                127.44008,
                                -66.61062
                            ],
                            [
                                126.95195,
                                -66.51892
                            ],
                            [
                                126.76412,
                                -66.41045
                            ],
                            [
                                126.41261,
                                -66.3427
                            ],
                            [
                                126.14521,
                                -66.27038
                            ],
                            [
                                125.91543,
                                -66.29803
                            ],
                            [
                                125.66615,
                                -66.37966
                            ],
                            [
                                125.48338,
                                -66.40298
                            ],
                            [
                                125.18288,
                                -66.50016
                            ],
                            [
                                124.868,
                                -66.56273
                            ],
                            [
                                124.81109,
                                -66.6209
                            ],
                            [
                                124.52878,
                                -66.67365
                            ],
                            [
                                124.28739,
                                -66.66644
                            ],
                            [
                                123.8981,
                                -66.71168
                            ],
                            [
                                123.13423,
                                -66.81525
                            ],
                            [
                                122.84247,
                                -66.86258
                            ],
                            [
                                121.91789,
                                -66.96854
                            ],
                            [
                                121.41569,
                                -67.04262
                            ],
                            [
                                121.12438,
                                -67.10272
                            ],
                            [
                                121.14594,
                                -66.91548
                            ],
                            [
                                121.12789,
                                -66.81453
                            ],
                            [
                                121.00049,
                                -66.79582
                            ],
                            [
                                120.88087,
                                -66.84856
                            ],
                            [
                                120.69222,
                                -66.89132
                            ],
                            [
                                120.43158,
                                -66.8313
                            ],
                            [
                                119.89009,
                                -66.88827
                            ],
                            [
                                119.70993,
                                -66.89489
                            ],
                            [
                                119.4325,
                                -66.94559
                            ],
                            [
                                119.21427,
                                -66.9191
                            ],
                            [
                                118.82819,
                                -66.93035
                            ],
                            [
                                118.54593,
                                -66.91038
                            ],
                            [
                                118.44715,
                                -66.92513
                            ],
                            [
                                118.2804,
                                -67.0164
                            ],
                            [
                                118.21336,
                                -67.0223
                            ],
                            [
                                117.92843,
                                -66.96342
                            ],
                            [
                                117.76271,
                                -66.98953
                            ],
                            [
                                117.2167,
                                -66.88823
                            ],
                            [
                                116.98673,
                                -66.81465
                            ],
                            [
                                116.79822,
                                -66.6944
                            ],
                            [
                                116.72533,
                                -66.59199
                            ],
                            [
                                116.49121,
                                -66.53328
                            ],
                            [
                                116.22374,
                                -66.39627
                            ],
                            [
                                116.01091,
                                -66.35605
                            ],
                            [
                                115.81361,
                                -66.34847
                            ],
                            [
                                115.46333,
                                -66.37205
                            ],
                            [
                                115.20239,
                                -66.41804
                            ],
                            [
                                115.11417,
                                -66.46556
                            ],
                            [
                                114.88297,
                                -66.46553
                            ],
                            [
                                114.68297,
                                -66.38204
                            ],
                            [
                                114.47431,
                                -66.40645
                            ],
                            [
                                114.57622,
                                -66.31628
                            ],
                            [
                                114.45164,
                                -66.2716
                            ],
                            [
                                114.52889,
                                -66.18463
                            ],
                            [
                                114.3434,
                                -66.16438
                            ],
                            [
                                114.15587,
                                -66.05518
                            ],
                            [
                                113.95667,
                                -66.04684
                            ],
                            [
                                113.53416,
                                -65.82927
                            ],
                            [
                                113.41806,
                                -65.73408
                            ],
                            [
                                113.19275,
                                -65.7022
                            ],
                            [
                                112.78214,
                                -65.78862
                            ],
                            [
                                112.48199,
                                -65.86909
                            ],
                            [
                                112.172,
                                -65.88094
                            ],
                            [
                                111.91769,
                                -65.91436
                            ],
                            [
                                111.55029,
                                -65.91461
                            ],
                            [
                                111.30945,
                                -65.95321
                            ],
                            [
                                111.22062,
                                -65.98555
                            ],
                            [
                                110.89341,
                                -66.04908
                            ],
                            [
                                110.73836,
                                -66.13045
                            ],
                            [
                                110.67751,
                                -66.20808
                            ],
                            [
                                110.53693,
                                -66.23456
                            ],
                            [
                                110.49403,
                                -66.33312
                            ],
                            [
                                110.60668,
                                -66.39939
                            ],
                            [
                                110.50697,
                                -66.51548
                            ],
                            [
                                110.36623,
                                -66.45828
                            ],
                            [
                                110.26246,
                                -66.57526
                            ],
                            [
                                110.29687,
                                -66.61951
                            ],
                            [
                                109.9742,
                                -66.62674
                            ],
                            [
                                109.80206,
                                -66.56398
                            ],
                            [
                                109.47619,
                                -66.6007
                            ],
                            [
                                109.34853,
                                -66.65717
                            ],
                            [
                                109.32552,
                                -66.7317
                            ],
                            [
                                109.23582,
                                -66.79714
                            ],
                            [
                                109.32412,
                                -66.8508
                            ],
                            [
                                109.17502,
                                -66.89661
                            ],
                            [
                                109.05961,
                                -66.87893
                            ],
                            [
                                108.89399,
                                -66.92147
                            ],
                            [
                                108.75976,
                                -66.89563
                            ],
                            [
                                108.61171,
                                -66.77794
                            ],
                            [
                                108.32847,
                                -66.7148
                            ],
                            [
                                108.17538,
                                -66.60864
                            ],
                            [
                                108.04649,
                                -66.58025
                            ],
                            [
                                107.88767,
                                -66.60228
                            ],
                            [
                                107.6931,
                                -66.54136
                            ],
                            [
                                107.54825,
                                -66.53833
                            ],
                            [
                                107.14171,
                                -66.45919
                            ],
                            [
                                106.97766,
                                -66.46106
                            ],
                            [
                                106.74403,
                                -66.39686
                            ],
                            [
                                106.5639,
                                -66.38173
                            ],
                            [
                                106.23677,
                                -66.29004
                            ],
                            [
                                105.90915,
                                -66.21309
                            ],
                            [
                                105.64805,
                                -66.18091
                            ],
                            [
                                105.58654,
                                -66.15253
                            ],
                            [
                                105.11289,
                                -66.07282
                            ],
                            [
                                104.73691,
                                -66.06454
                            ],
                            [
                                104.47978,
                                -66.02087
                            ],
                            [
                                104.21414,
                                -66.01653
                            ],
                            [
                                103.95728,
                                -65.96584
                            ],
                            [
                                103.73254,
                                -65.99093
                            ],
                            [
                                103.59375,
                                -65.98425
                            ],
                            [
                                103.42096,
                                -65.93707
                            ],
                            [
                                103.25231,
                                -65.92129
                            ],
                            [
                                103.01379,
                                -65.84711
                            ],
                            [
                                102.95265,
                                -65.88442
                            ],
                            [
                                102.63614,
                                -65.85945
                            ],
                            [
                                102.43213,
                                -65.91093
                            ],
                            [
                                102.03349,
                                -65.95638
                            ],
                            [
                                101.7217,
                                -65.95814
                            ],
                            [
                                101.5895,
                                -65.98949
                            ],
                            [
                                101.36744,
                                -65.94314
                            ],
                            [
                                101.26,
                                -66.01988
                            ],
                            [
                                101.35255,
                                -66.08452
                            ],
                            [
                                101.29976,
                                -66.14397
                            ],
                            [
                                101.0106,
                                -66.24634
                            ],
                            [
                                100.73906,
                                -66.21562
                            ],
                            [
                                100.88045,
                                -66.1362
                            ],
                            [
                                100.61534,
                                -66.04645
                            ],
                            [
                                100.54577,
                                -66.1445
                            ],
                            [
                                100.35156,
                                -66.14953
                            ],
                            [
                                100.16727,
                                -66.11094
                            ],
                            [
                                100.15064,
                                -66.02539
                            ],
                            [
                                100.18294,
                                -65.93196
                            ],
                            [
                                100.12189,
                                -65.82246
                            ],
                            [
                                100.24831,
                                -65.6764
                            ],
                            [
                                100.52473,
                                -65.70377
                            ],
                            [
                                100.75346,
                                -65.61737
                            ],
                            [
                                100.91542,
                                -65.57561
                            ],
                            [
                                101.17943,
                                -65.54283
                            ],
                            [
                                101.17288,
                                -65.47151
                            ],
                            [
                                101.05085,
                                -65.41563
                            ],
                            [
                                100.74323,
                                -65.38309
                            ],
                            [
                                100.59362,
                                -65.40852
                            ],
                            [
                                100.38955,
                                -65.48521
                            ],
                            [
                                100.27255,
                                -65.55701
                            ],
                            [
                                100.26378,
                                -65.6452
                            ],
                            [
                                100.18855,
                                -65.66728
                            ],
                            [
                                99.9532,
                                -65.65725
                            ],
                            [
                                99.82256,
                                -65.6922
                            ],
                            [
                                99.72972,
                                -65.67233
                            ],
                            [
                                99.63396,
                                -65.73308
                            ],
                            [
                                99.49957,
                                -65.73848
                            ],
                            [
                                99.60559,
                                -65.81348
                            ],
                            [
                                99.5609,
                                -65.87238
                            ],
                            [
                                99.38091,
                                -65.84729
                            ],
                            [
                                99.29565,
                                -65.76644
                            ],
                            [
                                99.0721,
                                -65.78527
                            ],
                            [
                                98.77695,
                                -65.74896
                            ],
                            [
                                98.72058,
                                -65.76733
                            ],
                            [
                                98.85728,
                                -66.00171
                            ],
                            [
                                99.0556,
                                -66.15139
                            ],
                            [
                                98.96379,
                                -66.25013
                            ],
                            [
                                98.99085,
                                -66.40378
                            ],
                            [
                                98.84367,
                                -66.47395
                            ],
                            [
                                98.73199,
                                -66.47702
                            ],
                            [
                                98.64479,
                                -66.40869
                            ],
                            [
                                98.4966,
                                -66.44099
                            ],
                            [
                                98.25623,
                                -66.45864
                            ],
                            [
                                97.95831,
                                -66.55302
                            ],
                            [
                                97.84961,
                                -66.52868
                            ],
                            [
                                97.74488,
                                -66.58243
                            ],
                            [
                                97.56672,
                                -66.60755
                            ],
                            [
                                97.20534,
                                -66.49799
                            ],
                            [
                                97.04541,
                                -66.50047
                            ],
                            [
                                96.69652,
                                -66.60279
                            ],
                            [
                                96.52364,
                                -66.61774
                            ],
                            [
                                96.44255,
                                -66.5769
                            ],
                            [
                                96.15032,
                                -66.58005
                            ],
                            [
                                95.9165,
                                -66.60429
                            ],
                            [
                                95.69184,
                                -66.5343
                            ],
                            [
                                95.55699,
                                -66.45289
                            ],
                            [
                                95.29923,
                                -66.54533
                            ],
                            [
                                94.95459,
                                -66.53505
                            ],
                            [
                                94.74065,
                                -66.4852
                            ],
                            [
                                94.61535,
                                -66.50179
                            ],
                            [
                                94.42161,
                                -66.62173
                            ],
                            [
                                94.28115,
                                -66.63405
                            ],
                            [
                                94.27755,
                                -66.55561
                            ],
                            [
                                94.20729,
                                -66.52308
                            ],
                            [
                                93.94722,
                                -66.53871
                            ],
                            [
                                93.56993,
                                -66.61286
                            ],
                            [
                                93.14226,
                                -66.59163
                            ],
                            [
                                93.02476,
                                -66.55884
                            ],
                            [
                                92.83794,
                                -66.63014
                            ],
                            [
                                92.68525,
                                -66.62346
                            ],
                            [
                                92.52966,
                                -66.56481
                            ],
                            [
                                92.41306,
                                -66.57873
                            ],
                            [
                                92.22574,
                                -66.50181
                            ],
                            [
                                91.87734,
                                -66.47165
                            ],
                            [
                                91.34696,
                                -66.5879
                            ],
                            [
                                91.10766,
                                -66.57485
                            ],
                            [
                                90.86508,
                                -66.6457
                            ],
                            [
                                90.80018,
                                -66.68712
                            ],
                            [
                                90.50324,
                                -66.71186
                            ],
                            [
                                90.3385,
                                -66.77
                            ],
                            [
                                90.07643,
                                -66.78412
                            ],
                            [
                                89.89198,
                                -66.81225
                            ],
                            [
                                89.48084,
                                -66.77458
                            ],
                            [
                                89.16502,
                                -66.78948
                            ],
                            [
                                88.97993,
                                -66.72173
                            ],
                            [
                                88.71874,
                                -66.69062
                            ],
                            [
                                88.37846,
                                -66.70556
                            ],
                            [
                                88.10645,
                                -66.69264
                            ],
                            [
                                87.86499,
                                -66.79564
                            ],
                            [
                                87.6575,
                                -66.81258
                            ],
                            [
                                87.33432,
                                -66.88115
                            ],
                            [
                                87.08102,
                                -66.96087
                            ],
                            [
                                86.82474,
                                -66.97357
                            ],
                            [
                                86.59284,
                                -67.00245
                            ],
                            [
                                86.27386,
                                -67.06294
                            ],
                            [
                                86.18295,
                                -67.13844
                            ],
                            [
                                85.93368,
                                -67.19293
                            ],
                            [
                                85.71675,
                                -67.14457
                            ],
                            [
                                85.46207,
                                -67.18735
                            ],
                            [
                                85.34895,
                                -67.17975
                            ],
                            [
                                85.24893,
                                -67.07943
                            ],
                            [
                                84.69764,
                                -67.06097
                            ],
                            [
                                84.54403,
                                -67.08004
                            ],
                            [
                                84.38019,
                                -67.16709
                            ],
                            [
                                84.21808,
                                -67.21666
                            ],
                            [
                                84.08791,
                                -67.32427
                            ],
                            [
                                83.79585,
                                -67.38349
                            ],
                            [
                                83.54848,
                                -67.46258
                            ],
                            [
                                83.25059,
                                -67.50573
                            ],
                            [
                                83.03058,
                                -67.59349
                            ],
                            [
                                82.67494,
                                -67.65181
                            ],
                            [
                                82.50453,
                                -67.62211
                            ],
                            [
                                82.30892,
                                -67.69281
                            ],
                            [
                                82.03395,
                                -67.73076
                            ],
                            [
                                81.88982,
                                -67.77957
                            ],
                            [
                                81.67133,
                                -67.79132
                            ],
                            [
                                81.55478,
                                -67.82288
                            ],
                            [
                                81.09214,
                                -67.87849
                            ],
                            [
                                80.74266,
                                -67.89944
                            ],
                            [
                                80.18487,
                                -67.97989
                            ],
                            [
                                79.98018,
                                -68.03772
                            ],
                            [
                                79.48851,
                                -68.11961
                            ],
                            [
                                79.36309,
                                -68.15085
                            ],
                            [
                                79.06603,
                                -68.2616
                            ],
                            [
                                78.76591,
                                -68.42106
                            ],
                            [
                                78.65941,
                                -68.43035
                            ],
                            [
                                78.65506,
                                -68.51401
                            ],
                            [
                                78.31292,
                                -68.53392
                            ],
                            [
                                78.17042,
                                -68.60263
                            ],
                            [
                                78.33485,
                                -68.66588
                            ],
                            [
                                78.1054,
                                -68.6955
                            ],
                            [
                                78.30617,
                                -68.77908
                            ],
                            [
                                78.25198,
                                -68.96817
                            ],
                            [
                                78.08693,
                                -69.11843
                            ],
                            [
                                77.77555,
                                -69.10818
                            ],
                            [
                                77.50329,
                                -69.20321
                            ],
                            [
                                77.17803,
                                -69.23415
                            ],
                            [
                                77.14659,
                                -69.28431
                            ],
                            [
                                77.01025,
                                -69.29497
                            ],
                            [
                                76.83131,
                                -69.39685
                            ],
                            [
                                76.56851,
                                -69.41181
                            ],
                            [
                                76.40426,
                                -69.40168
                            ],
                            [
                                76.25713,
                                -69.5092
                            ],
                            [
                                76.14654,
                                -69.55005
                            ],
                            [
                                76.03605,
                                -69.6631
                            ],
                            [
                                75.93422,
                                -69.71471
                            ],
                            [
                                75.7147,
                                -69.71828
                            ],
                            [
                                75.44519,
                                -69.75225
                            ],
                            [
                                75.17384,
                                -69.82076
                            ],
                            [
                                75.0433,
                                -69.79063
                            ],
                            [
                                75.0586,
                                -69.72831
                            ],
                            [
                                74.8505,
                                -69.72085
                            ],
                            [
                                74.66464,
                                -69.75799
                            ],
                            [
                                74.34207,
                                -69.72558
                            ],
                            [
                                74.11001,
                                -69.76044
                            ],
                            [
                                73.97308,
                                -69.82602
                            ],
                            [
                                73.86145,
                                -69.80884
                            ],
                            [
                                73.63599,
                                -69.83469
                            ],
                            [
                                73.38987,
                                -69.91914
                            ],
                            [
                                73.37848,
                                -69.96455
                            ],
                            [
                                73.14551,
                                -70.03839
                            ],
                            [
                                72.91934,
                                -70.0727
                            ],
                            [
                                72.86474,
                                -70.19308
                            ],
                            [
                                73.2585,
                                -70.35589
                            ],
                            [
                                73.25415,
                                -70.45857
                            ],
                            [
                                73.05337,
                                -70.53108
                            ],
                            [
                                72.64563,
                                -70.60669
                            ],
                            [
                                72.46709,
                                -70.67255
                            ],
                            [
                                72.47698,
                                -70.79362
                            ],
                            [
                                72.36311,
                                -70.91377
                            ],
                            [
                                72.23391,
                                -70.98893
                            ],
                            [
                                71.93367,
                                -71.09782
                            ],
                            [
                                71.68582,
                                -71.21567
                            ],
                            [
                                71.54087,
                                -71.40994
                            ],
                            [
                                71.40083,
                                -71.4349
                            ],
                            [
                                71.32372,
                                -71.37098
                            ],
                            [
                                71.06764,
                                -71.36999
                            ],
                            [
                                70.64855,
                                -71.21427
                            ],
                            [
                                70.30123,
                                -71.11723
                            ],
                            [
                                70.11383,
                                -71.04514
                            ],
                            [
                                69.42708,
                                -70.82734
                            ],
                            [
                                69.28479,
                                -70.79169
                            ],
                            [
                                69.2524,
                                -70.66252
                            ],
                            [
                                69.27927,
                                -70.51492
                            ],
                            [
                                69.2378,
                                -70.40615
                            ],
                            [
                                69.15817,
                                -70.33277
                            ],
                            [
                                68.90419,
                                -70.38374
                            ],
                            [
                                68.57854,
                                -70.3809
                            ],
                            [
                                68.37295,
                                -70.40966
                            ],
                            [
                                68.0867,
                                -70.26626
                            ],
                            [
                                68.15567,
                                -70.16176
                            ],
                            [
                                68.20783,
                                -69.96349
                            ],
                            [
                                68.35949,
                                -69.8964
                            ],
                            [
                                68.51491,
                                -69.87073
                            ],
                            [
                                68.74949,
                                -69.92927
                            ],
                            [
                                68.9077,
                                -69.92636
                            ],
                            [
                                69.13615,
                                -69.8868
                            ],
                            [
                                69.23509,
                                -69.84412
                            ],
                            [
                                69.22562,
                                -69.78861
                            ],
                            [
                                69.11034,
                                -69.71288
                            ],
                            [
                                68.47469,
                                -69.63496
                            ],
                            [
                                68.48551,
                                -69.55855
                            ],
                            [
                                68.73188,
                                -69.58217
                            ],
                            [
                                68.67789,
                                -69.50634
                            ],
                            [
                                68.96793,
                                -69.41364
                            ],
                            [
                                68.71918,
                                -69.35254
                            ],
                            [
                                68.69202,
                                -69.29708
                            ],
                            [
                                68.83409,
                                -69.26253
                            ],
                            [
                                69.109,
                                -69.27028
                            ],
                            [
                                69.4225,
                                -69.32467
                            ],
                            [
                                69.72767,
                                -69.31457
                            ],
                            [
                                69.87915,
                                -69.25042
                            ],
                            [
                                69.85302,
                                -69.18721
                            ],
                            [
                                69.70004,
                                -69.13785
                            ],
                            [
                                69.35648,
                                -69.16678
                            ],
                            [
                                69.20247,
                                -69.16253
                            ],
                            [
                                69.07336,
                                -69.11663
                            ],
                            [
                                69.3841,
                                -69.07012
                            ],
                            [
                                69.50852,
                                -69.07052
                            ],
                            [
                                69.87389,
                                -68.99374
                            ],
                            [
                                70.0035,
                                -68.9072
                            ],
                            [
                                69.71686,
                                -68.91677
                            ],
                            [
                                69.21878,
                                -68.97141
                            ],
                            [
                                69.16391,
                                -68.94078
                            ],
                            [
                                69.41016,
                                -68.88671
                            ],
                            [
                                69.40726,
                                -68.84814
                            ],
                            [
                                69.697,
                                -68.82928
                            ],
                            [
                                70.05435,
                                -68.74089
                            ],
                            [
                                70.13576,
                                -68.69264
                            ],
                            [
                                70.14852,
                                -68.62142
                            ],
                            [
                                69.99199,
                                -68.52388
                            ],
                            [
                                70.13954,
                                -68.43622
                            ],
                            [
                                70.15085,
                                -68.34371
                            ],
                            [
                                69.94808,
                                -68.20564
                            ],
                            [
                                69.85764,
                                -68.09767
                            ],
                            [
                                69.84996,
                                -67.99586
                            ],
                            [
                                69.92011,
                                -67.89611
                            ],
                            [
                                69.85703,
                                -67.77277
                            ],
                            [
                                69.69551,
                                -67.7474
                            ],
                            [
                                69.43952,
                                -67.77802
                            ],
                            [
                                69.30665,
                                -67.88321
                            ],
                            [
                                69.05415,
                                -67.91921
                            ],
                            [
                                68.59633,
                                -67.89998
                            ],
                            [
                                68.48926,
                                -67.91987
                            ],
                            [
                                68.24413,
                                -67.87274
                            ],
                            [
                                67.9343,
                                -67.85295
                            ],
                            [
                                67.5614,
                                -67.84963
                            ],
                            [
                                67.23509,
                                -67.78164
                            ],
                            [
                                66.6649,
                                -67.78393
                            ],
                            [
                                66.37161,
                                -67.76803
                            ],
                            [
                                66.26537,
                                -67.7785
                            ],
                            [
                                66.05743,
                                -67.72992
                            ],
                            [
                                65.82678,
                                -67.71352
                            ],
                            [
                                65.70082,
                                -67.68357
                            ],
                            [
                                65.31434,
                                -67.67548
                            ],
                            [
                                64.84761,
                                -67.65263
                            ],
                            [
                                64.41708,
                                -67.56448
                            ],
                            [
                                63.61817,
                                -67.5042
                            ],
                            [
                                63.21717,
                                -67.54318
                            ],
                            [
                                62.89854,
                                -67.64033
                            ],
                            [
                                62.76725,
                                -67.65801
                            ],
                            [
                                62.44843,
                                -67.58776
                            ],
                            [
                                62.07429,
                                -67.54436
                            ],
                            [
                                61.8676,
                                -67.55656
                            ],
                            [
                                61.78376,
                                -67.5332
                            ],
                            [
                                61.5273,
                                -67.56778
                            ],
                            [
                                61.39244,
                                -67.49963
                            ],
                            [
                                61.15877,
                                -67.4964
                            ],
                            [
                                61.11269,
                                -67.45217
                            ],
                            [
                                60.82176,
                                -67.43638
                            ],
                            [
                                60.69993,
                                -67.39433
                            ],
                            [
                                60.46872,
                                -67.37925
                            ],
                            [
                                59.91871,
                                -67.41116
                            ],
                            [
                                59.80321,
                                -67.39613
                            ],
                            [
                                59.67159,
                                -67.45433
                            ],
                            [
                                59.43443,
                                -67.38754
                            ],
                            [
                                59.26406,
                                -67.38701
                            ],
                            [
                                59.21854,
                                -67.4477
                            ],
                            [
                                59.06935,
                                -67.40117
                            ],
                            [
                                58.71754,
                                -67.36288
                            ],
                            [
                                58.73453,
                                -67.29094
                            ],
                            [
                                59.00878,
                                -67.32925
                            ],
                            [
                                59.06094,
                                -67.25975
                            ],
                            [
                                58.85281,
                                -67.17265
                            ],
                            [
                                58.47598,
                                -67.2092
                            ],
                            [
                                58.46579,
                                -67.17876
                            ],
                            [
                                58.15017,
                                -67.10341
                            ],
                            [
                                58.02162,
                                -67.11419
                            ],
                            [
                                57.6067,
                                -66.99785
                            ],
                            [
                                57.41042,
                                -67.10332
                            ],
                            [
                                57.19362,
                                -67.06052
                            ],
                            [
                                56.98476,
                                -67.07581
                            ],
                            [
                                56.76263,
                                -67.00419
                            ],
                            [
                                56.75782,
                                -66.86254
                            ],
                            [
                                56.56068,
                                -66.88362
                            ],
                            [
                                56.45232,
                                -66.83442
                            ],
                            [
                                56.61262,
                                -66.79534
                            ],
                            [
                                56.78804,
                                -66.80417
                            ],
                            [
                                56.92293,
                                -66.7669
                            ],
                            [
                                56.98068,
                                -66.70032
                            ],
                            [
                                57.13836,
                                -66.72814
                            ],
                            [
                                57.35731,
                                -66.67468
                            ],
                            [
                                57.35794,
                                -66.57181
                            ],
                            [
                                56.89284,
                                -66.4091
                            ],
                            [
                                56.76103,
                                -66.39055
                            ],
                            [
                                56.42346,
                                -66.39251
                            ],
                            [
                                56.28433,
                                -66.30595
                            ],
                            [
                                56.04019,
                                -66.21826
                            ],
                            [
                                55.96735,
                                -66.14615
                            ],
                            [
                                55.73236,
                                -66.0088
                            ],
                            [
                                55.46863,
                                -65.95489
                            ],
                            [
                                55.33428,
                                -65.90878
                            ],
                            [
                                54.92996,
                                -65.88029
                            ],
                            [
                                54.33597,
                                -65.86636
                            ],
                            [
                                54.08139,
                                -65.88829
                            ],
                            [
                                53.84299,
                                -65.84323
                            ],
                            [
                                53.44741,
                                -65.89861
                            ],
                            [
                                53.2677,
                                -65.88835
                            ],
                            [
                                52.89642,
                                -65.93747
                            ],
                            [
                                52.4782,
                                -65.93038
                            ],
                            [
                                52.27291,
                                -65.93916
                            ],
                            [
                                51.77056,
                                -66.03757
                            ],
                            [
                                51.57693,
                                -66.10786
                            ],
                            [
                                51.41093,
                                -66.21547
                            ],
                            [
                                51.22337,
                                -66.21582
                            ],
                            [
                                51.0249,
                                -66.26949
                            ],
                            [
                                50.86388,
                                -66.27719
                            ],
                            [
                                50.63225,
                                -66.31767
                            ],
                            [
                                50.39637,
                                -66.43039
                            ],
                            [
                                50.29187,
                                -66.5426
                            ],
                            [
                                50.26989,
                                -66.63091
                            ],
                            [
                                50.35193,
                                -66.75648
                            ],
                            [
                                50.79148,
                                -66.77314
                            ],
                            [
                                50.74045,
                                -66.83417
                            ],
                            [
                                50.51427,
                                -66.936
                            ],
                            [
                                50.50001,
                                -66.97373
                            ],
                            [
                                50.609,
                                -67.06354
                            ],
                            [
                                50.73563,
                                -67.07013
                            ],
                            [
                                50.93722,
                                -67.12313
                            ],
                            [
                                50.71377,
                                -67.2014
                            ],
                            [
                                50.50802,
                                -67.20514
                            ],
                            [
                                50.29628,
                                -67.13546
                            ],
                            [
                                50.15665,
                                -67.12475
                            ],
                            [
                                50.04526,
                                -67.22662
                            ],
                            [
                                49.78657,
                                -67.2494
                            ],
                            [
                                50.01156,
                                -67.09541
                            ],
                            [
                                49.90913,
                                -67.04221
                            ],
                            [
                                49.70161,
                                -67.03413
                            ],
                            [
                                49.44642,
                                -66.94894
                            ],
                            [
                                49.42871,
                                -66.86555
                            ],
                            [
                                49.3224,
                                -66.80885
                            ],
                            [
                                49.13164,
                                -66.9006
                            ],
                            [
                                48.79849,
                                -66.95564
                            ],
                            [
                                48.43686,
                                -66.96874
                            ],
                            [
                                48.37234,
                                -67.0006
                            ],
                            [
                                48.3438,
                                -67.09404
                            ],
                            [
                                48.47164,
                                -67.20199
                            ],
                            [
                                48.66696,
                                -67.2494
                            ],
                            [
                                48.84736,
                                -67.24656
                            ],
                            [
                                49.0503,
                                -67.17573
                            ],
                            [
                                49.24228,
                                -67.15558
                            ],
                            [
                                49.44573,
                                -67.2147
                            ],
                            [
                                49.45622,
                                -67.29556
                            ],
                            [
                                49.26059,
                                -67.3457
                            ],
                            [
                                49.23225,
                                -67.38675
                            ],
                            [
                                48.71649,
                                -67.45862
                            ],
                            [
                                48.60876,
                                -67.53915
                            ],
                            [
                                48.48272,
                                -67.56912
                            ],
                            [
                                48.33468,
                                -67.55978
                            ],
                            [
                                47.84377,
                                -67.70367
                            ],
                            [
                                47.51314,
                                -67.68902
                            ],
                            [
                                47.25227,
                                -67.63807
                            ],
                            [
                                47.36652,
                                -67.58059
                            ],
                            [
                                47.2751,
                                -67.48969
                            ],
                            [
                                47.48212,
                                -67.41666
                            ],
                            [
                                47.2949,
                                -67.35912
                            ],
                            [
                                47.13131,
                                -67.36591
                            ],
                            [
                                47.00509,
                                -67.33639
                            ],
                            [
                                46.91426,
                                -67.27683
                            ],
                            [
                                46.74372,
                                -67.30553
                            ],
                            [
                                46.61066,
                                -67.28477
                            ],
                            [
                                46.38334,
                                -67.32145
                            ],
                            [
                                46.28541,
                                -67.36171
                            ],
                            [
                                46.34487,
                                -67.48609
                            ],
                            [
                                46.32407,
                                -67.54702
                            ],
                            [
                                46.40739,
                                -67.60951
                            ],
                            [
                                46.34143,
                                -67.65436
                            ],
                            [
                                46.1617,
                                -67.63821
                            ],
                            [
                                45.85524,
                                -67.67344
                            ],
                            [
                                45.80215,
                                -67.7746
                            ],
                            [
                                45.63608,
                                -67.77248
                            ],
                            [
                                45.53438,
                                -67.71857
                            ],
                            [
                                45.27359,
                                -67.71888
                            ],
                            [
                                45.05686,
                                -67.75699
                            ],
                            [
                                44.85827,
                                -67.8153
                            ],
                            [
                                44.7315,
                                -67.88626
                            ],
                            [
                                44.6264,
                                -67.90256
                            ],
                            [
                                44.53943,
                                -67.97505
                            ],
                            [
                                44.28468,
                                -67.98846
                            ],
                            [
                                44.11174,
                                -67.97542
                            ],
                            [
                                44.07119,
                                -68.02768
                            ],
                            [
                                43.91587,
                                -68.02649
                            ],
                            [
                                43.77927,
                                -68.06383
                            ],
                            [
                                43.2935,
                                -68.03873
                            ],
                            [
                                42.67308,
                                -68.12659
                            ],
                            [
                                42.55729,
                                -68.23577
                            ],
                            [
                                42.36618,
                                -68.31921
                            ],
                            [
                                42.18569,
                                -68.36753
                            ],
                            [
                                41.97087,
                                -68.36451
                            ],
                            [
                                41.43944,
                                -68.48177
                            ],
                            [
                                41.0705,
                                -68.59096
                            ],
                            [
                                40.92552,
                                -68.69496
                            ],
                            [
                                40.60473,
                                -68.71463
                            ],
                            [
                                40.36055,
                                -68.82854
                            ],
                            [
                                39.99238,
                                -68.87413
                            ],
                            [
                                39.76011,
                                -69.02965
                            ],
                            [
                                39.90804,
                                -69.18977
                            ],
                            [
                                39.74498,
                                -69.20169
                            ],
                            [
                                39.78906,
                                -69.3117
                            ],
                            [
                                39.86433,
                                -69.37415
                            ],
                            [
                                39.80871,
                                -69.53612
                            ],
                            [
                                39.8067,
                                -69.63731
                            ],
                            [
                                39.50699,
                                -69.66435
                            ],
                            [
                                39.23075,
                                -69.74235
                            ],
                            [
                                39.24269,
                                -69.85533
                            ],
                            [
                                39.08984,
                                -69.88544
                            ],
                            [
                                38.89662,
                                -69.96395
                            ],
                            [
                                38.77173,
                                -69.93388
                            ],
                            [
                                38.58318,
                                -69.9601
                            ],
                            [
                                38.36585,
                                -69.86865
                            ],
                            [
                                38.32938,
                                -69.79617
                            ],
                            [
                                37.92057,
                                -69.72858
                            ],
                            [
                                37.76392,
                                -69.66319
                            ],
                            [
                                37.35806,
                                -69.80759
                            ],
                            [
                                37.20448,
                                -69.84845
                            ],
                            [
                                37.12647,
                                -69.68769
                            ],
                            [
                                37.01749,
                                -69.65703
                            ],
                            [
                                36.83662,
                                -69.54159
                            ],
                            [
                                36.63153,
                                -69.53986
                            ],
                            [
                                36.2552,
                                -69.48299
                            ],
                            [
                                35.79956,
                                -69.3579
                            ],
                            [
                                35.59803,
                                -69.259
                            ],
                            [
                                35.50849,
                                -69.1134
                            ],
                            [
                                35.42079,
                                -69.06626
                            ],
                            [
                                34.94238,
                                -68.97646
                            ],
                            [
                                34.63882,
                                -68.8695
                            ],
                            [
                                34.52248,
                                -68.79095
                            ],
                            [
                                34.42925,
                                -68.67093
                            ],
                            [
                                34.25789,
                                -68.59812
                            ],
                            [
                                33.72311,
                                -68.60593
                            ],
                            [
                                33.42021,
                                -68.6795
                            ],
                            [
                                33.26189,
                                -68.75616
                            ],
                            [
                                33.19014,
                                -68.90512
                            ],
                            [
                                33.18752,
                                -69.00991
                            ],
                            [
                                33.4431,
                                -69.14677
                            ],
                            [
                                33.59111,
                                -69.17908
                            ],
                            [
                                33.37331,
                                -69.29433
                            ],
                            [
                                33.52261,
                                -69.55795
                            ],
                            [
                                33.43555,
                                -69.63423
                            ],
                            [
                                33.06709,
                                -69.69125
                            ],
                            [
                                32.81722,
                                -69.69111
                            ],
                            [
                                32.31515,
                                -69.62502
                            ],
                            [
                                31.95815,
                                -69.61645
                            ],
                            [
                                31.62784,
                                -69.63804
                            ],
                            [
                                31.40503,
                                -69.673
                            ],
                            [
                                31.01051,
                                -69.77193
                            ],
                            [
                                30.19059,
                                -69.83858
                            ],
                            [
                                29.57272,
                                -69.86011
                            ],
                            [
                                28.83232,
                                -69.92494
                            ],
                            [
                                28.26164,
                                -70.02978
                            ],
                            [
                                27.60043,
                                -70.1065
                            ],
                            [
                                26.76955,
                                -70.21325
                            ],
                            [
                                26.14326,
                                -70.27036
                            ],
                            [
                                25.43164,
                                -70.2827
                            ],
                            [
                                24.72031,
                                -70.42283
                            ],
                            [
                                24.29647,
                                -70.47745
                            ],
                            [
                                23.41128,
                                -70.51889
                            ],
                            [
                                23.02778,
                                -70.51014
                            ],
                            [
                                22.66377,
                                -70.47466
                            ],
                            [
                                22.45614,
                                -70.46972
                            ],
                            [
                                21.23592,
                                -70.36389
                            ],
                            [
                                20.09112,
                                -70.40772
                            ],
                            [
                                19.63539,
                                -70.35623
                            ],
                            [
                                19.13404,
                                -70.33175
                            ],
                            [
                                18.30804,
                                -70.23479
                            ],
                            [
                                17.32121,
                                -70.21852
                            ],
                            [
                                16.81597,
                                -70.22068
                            ],
                            [
                                16.40607,
                                -70.19294
                            ],
                            [
                                16.07483,
                                -70.19225
                            ],
                            [
                                15.35252,
                                -70.27147
                            ],
                            [
                                14.4517,
                                -70.31333
                            ],
                            [
                                13.92849,
                                -70.32361
                            ],
                            [
                                12.83245,
                                -70.29368
                            ],
                            [
                                12.52257,
                                -70.30254
                            ],
                            [
                                12.29307,
                                -70.33062
                            ],
                            [
                                12.09001,
                                -70.4417
                            ],
                            [
                                11.9879,
                                -70.60292
                            ],
                            [
                                11.77988,
                                -70.62698
                            ],
                            [
                                11.57159,
                                -70.57682
                            ],
                            [
                                11.24905,
                                -70.54265
                            ],
                            [
                                10.92853,
                                -70.56027
                            ],
                            [
                                10.54779,
                                -70.41695
                            ],
                            [
                                10.13911,
                                -70.302
                            ],
                            [
                                9.85137,
                                -70.24589
                            ],
                            [
                                9.49381,
                                -70.19627
                            ],
                            [
                                9.13346,
                                -70.17815
                            ],
                            [
                                8.59263,
                                -70.16628
                            ],
                            [
                                8.05111,
                                -70.16751
                            ],
                            [
                                7.54168,
                                -70.20448
                            ],
                            [
                                7.01917,
                                -70.2629
                            ],
                            [
                                6.56256,
                                -70.38049
                            ],
                            [
                                6.01931,
                                -70.44535
                            ],
                            [
                                5.67075,
                                -70.4614
                            ],
                            [
                                5.38816,
                                -70.44885
                            ],
                            [
                                5.10088,
                                -70.37842
                            ],
                            [
                                4.92207,
                                -70.28812
                            ],
                            [
                                4.8092,
                                -70.26363
                            ],
                            [
                                4.43692,
                                -70.25056
                            ],
                            [
                                4.08297,
                                -70.28368
                            ],
                            [
                                3.60872,
                                -70.36117
                            ],
                            [
                                3.1534,
                                -70.45755
                            ],
                            [
                                2.84327,
                                -70.56372
                            ],
                            [
                                2.55727,
                                -70.77694
                            ],
                            [
                                2.30579,
                                -70.89815
                            ],
                            [
                                1.94373,
                                -70.99734
                            ],
                            [
                                1.33078,
                                -71.12033
                            ],
                            [
                                0.96842,
                                -71.16644
                            ],
                            [
                                0.52969,
                                -71.25835
                            ],
                            [
                                0.00698,
                                -71.44501
                            ],
                            [
                                -0.37357,
                                -71.66879
                            ],
                            [
                                -0.6347,
                                -71.66162
                            ],
                            [
                                -0.96805,
                                -71.59139
                            ],
                            [
                                -0.83626,
                                -71.39824
                            ],
                            [
                                -0.91696,
                                -71.32708
                            ],
                            [
                                -1.13037,
                                -71.28655
                            ],
                            [
                                -1.297,
                                -71.30233
                            ],
                            [
                                -1.5982,
                                -71.44369
                            ],
                            [
                                -2.25706,
                                -71.44026
                            ],
                            [
                                -2.20389,
                                -71.37697
                            ],
                            [
                                -2.41949,
                                -71.2764
                            ],
                            [
                                -2.55314,
                                -71.12474
                            ],
                            [
                                -2.56708,
                                -70.99725
                            ],
                            [
                                -2.50508,
                                -70.94002
                            ],
                            [
                                -2.0733,
                                -70.87522
                            ],
                            [
                                -2.00058,
                                -70.82754
                            ],
                            [
                                -2.27955,
                                -70.78828
                            ],
                            [
                                -2.65972,
                                -70.76248
                            ],
                            [
                                -3.05439,
                                -70.69694
                            ],
                            [
                                -3.17466,
                                -70.6575
                            ],
                            [
                                -3.16536,
                                -70.599
                            ],
                            [
                                -2.81612,
                                -70.49637
                            ],
                            [
                                -2.69206,
                                -70.42544
                            ],
                            [
                                -2.76158,
                                -70.32152
                            ],
                            [
                                -2.90619,
                                -70.29564
                            ],
                            [
                                -3.26214,
                                -70.32673
                            ],
                            [
                                -3.42855,
                                -70.42446
                            ],
                            [
                                -3.52438,
                                -70.55215
                            ],
                            [
                                -3.51599,
                                -70.73761
                            ],
                            [
                                -3.38703,
                                -70.8264
                            ],
                            [
                                -3.41585,
                                -70.90765
                            ],
                            [
                                -3.66371,
                                -71.03801
                            ],
                            [
                                -3.69658,
                                -71.13316
                            ],
                            [
                                -3.19527,
                                -71.20581
                            ],
                            [
                                -3.01804,
                                -71.26322
                            ],
                            [
                                -3.2123,
                                -71.29451
                            ],
                            [
                                -3.44244,
                                -71.30132
                            ],
                            [
                                -3.71043,
                                -71.33979
                            ],
                            [
                                -3.82605,
                                -71.2592
                            ],
                            [
                                -3.98906,
                                -71.25736
                            ],
                            [
                                -4.31716,
                                -71.32962
                            ],
                            [
                                -4.74744,
                                -71.28522
                            ],
                            [
                                -5.17521,
                                -71.36912
                            ],
                            [
                                -5.75918,
                                -71.4282
                            ],
                            [
                                -5.95615,
                                -71.42236
                            ],
                            [
                                -6.178,
                                -71.35851
                            ],
                            [
                                -6.20317,
                                -71.32367
                            ],
                            [
                                -5.91784,
                                -71.19076
                            ],
                            [
                                -5.81749,
                                -71.12312
                            ],
                            [
                                -5.79226,
                                -71.01388
                            ],
                            [
                                -5.68248,
                                -70.95213
                            ],
                            [
                                -5.83657,
                                -70.81735
                            ],
                            [
                                -5.81997,
                                -70.71167
                            ],
                            [
                                -6.08582,
                                -70.66218
                            ],
                            [
                                -6.89078,
                                -70.6872
                            ],
                            [
                                -7.38947,
                                -70.76086
                            ],
                            [
                                -7.65519,
                                -70.84113
                            ],
                            [
                                -7.62493,
                                -70.92195
                            ],
                            [
                                -7.32656,
                                -71.0377
                            ],
                            [
                                -7.31167,
                                -71.13479
                            ],
                            [
                                -7.46199,
                                -71.26047
                            ],
                            [
                                -7.71546,
                                -71.38107
                            ],
                            [
                                -7.74703,
                                -71.50283
                            ],
                            [
                                -7.37653,
                                -71.65774
                            ],
                            [
                                -7.48606,
                                -71.71174
                            ],
                            [
                                -7.92148,
                                -71.70507
                            ],
                            [
                                -8.10188,
                                -71.73908
                            ],
                            [
                                -8.36744,
                                -71.81995
                            ],
                            [
                                -8.5196,
                                -71.81474
                            ],
                            [
                                -8.7574,
                                -71.69005
                            ],
                            [
                                -8.76027,
                                -71.47355
                            ],
                            [
                                -8.87254,
                                -71.29855
                            ],
                            [
                                -9.01313,
                                -71.20218
                            ],
                            [
                                -9.28559,
                                -71.1028
                            ],
                            [
                                -9.65818,
                                -71.04425
                            ],
                            [
                                -9.51993,
                                -70.9298
                            ],
                            [
                                -9.65342,
                                -70.90344
                            ],
                            [
                                -10.2148,
                                -70.9222
                            ],
                            [
                                -10.47827,
                                -70.96699
                            ],
                            [
                                -10.41437,
                                -71.02535
                            ],
                            [
                                -10.10479,
                                -71.06928
                            ],
                            [
                                -10.17376,
                                -71.16968
                            ],
                            [
                                -10.59947,
                                -71.34532
                            ],
                            [
                                -10.75079,
                                -71.46042
                            ],
                            [
                                -10.86379,
                                -71.67319
                            ],
                            [
                                -11.07245,
                                -71.72538
                            ],
                            [
                                -11.16388,
                                -71.61324
                            ],
                            [
                                -11.39291,
                                -71.51439
                            ],
                            [
                                -11.64627,
                                -71.45355
                            ],
                            [
                                -11.73284,
                                -71.37743
                            ],
                            [
                                -11.61404,
                                -71.28748
                            ],
                            [
                                -11.68351,
                                -71.25832
                            ],
                            [
                                -11.90658,
                                -71.26978
                            ],
                            [
                                -12.21779,
                                -71.32629
                            ],
                            [
                                -12.24728,
                                -71.48219
                            ],
                            [
                                -12.1267,
                                -71.60573
                            ],
                            [
                                -11.79156,
                                -71.75053
                            ],
                            [
                                -11.57891,
                                -71.79151
                            ],
                            [
                                -11.28806,
                                -71.79903
                            ],
                            [
                                -11.14441,
                                -71.82963
                            ],
                            [
                                -11.08251,
                                -71.90505
                            ],
                            [
                                -11.10196,
                                -72.00239
                            ],
                            [
                                -11.42008,
                                -72.30421
                            ],
                            [
                                -11.68031,
                                -72.44239
                            ],
                            [
                                -12.08425,
                                -72.57872
                            ],
                            [
                                -12.30068,
                                -72.63585
                            ],
                            [
                                -13.75006,
                                -72.90005
                            ],
                            [
                                -14.08774,
                                -72.92889
                            ],
                            [
                                -14.35094,
                                -72.91771
                            ],
                            [
                                -14.74586,
                                -72.86521
                            ],
                            [
                                -15.10947,
                                -72.90345
                            ],
                            [
                                -15.79934,
                                -73.02445
                            ],
                            [
                                -16.14599,
                                -73.09339
                            ],
                            [
                                -16.95734,
                                -73.26794
                            ],
                            [
                                -17.32289,
                                -73.33091
                            ],
                            [
                                -18.38553,
                                -73.53463
                            ],
                            [
                                -18.75405,
                                -73.62628
                            ],
                            [
                                -19.37567,
                                -73.80886
                            ],
                            [
                                -20.13097,
                                -74.04771
                            ],
                            [
                                -20.75242,
                                -74.20881
                            ],
                            [
                                -21.55614,
                                -74.43468
                            ],
                            [
                                -22.56609,
                                -74.58126
                            ],
                            [
                                -22.86016,
                                -74.68111
                            ],
                            [
                                -23.12992,
                                -74.90195
                            ],
                            [
                                -23.20644,
                                -75.03536
                            ],
                            [
                                -23.45287,
                                -75.22451
                            ],
                            [
                                -23.66445,
                                -75.34024
                            ],
                            [
                                -24.21866,
                                -75.5739
                            ],
                            [
                                -24.42867,
                                -75.62663
                            ],
                            [
                                -24.77009,
                                -75.75783
                            ],
                            [
                                -25.19752,
                                -75.84663
                            ],
                            [
                                -25.9942,
                                -75.97637
                            ],
                            [
                                -26.3818,
                                -76.07813
                            ],
                            [
                                -26.88919,
                                -76.002
                            ],
                            [
                                -27.07513,
                                -76.03087
                            ],
                            [
                                -26.96681,
                                -76.08261
                            ],
                            [
                                -27.30874,
                                -76.12199
                            ],
                            [
                                -27.87626,
                                -76.22881
                            ],
                            [
                                -28.84617,
                                -76.32126
                            ],
                            [
                                -28.78662,
                                -76.38557
                            ],
                            [
                                -28.44006,
                                -76.42919
                            ],
                            [
                                -28.68993,
                                -76.51557
                            ],
                            [
                                -29.13068,
                                -76.599
                            ],
                            [
                                -29.49636,
                                -76.69408
                            ],
                            [
                                -30.10823,
                                -76.81887
                            ],
                            [
                                -30.4008,
                                -76.90934
                            ],
                            [
                                -30.82805,
                                -77.00401
                            ],
                            [
                                -31.03576,
                                -77.08435
                            ],
                            [
                                -31.45882,
                                -77.02951
                            ],
                            [
                                -31.32825,
                                -77.13959
                            ],
                            [
                                -31.54288,
                                -77.16967
                            ],
                            [
                                -31.47054,
                                -77.21957
                            ],
                            [
                                -32.1347,
                                -77.27902
                            ],
                            [
                                -32.95319,
                                -77.38565
                            ],
                            [
                                -33.22497,
                                -77.45054
                            ],
                            [
                                -34.26199,
                                -77.63687
                            ],
                            [
                                -34.44103,
                                -77.68798
                            ],
                            [
                                -34.60358,
                                -77.78503
                            ],
                            [
                                -34.98364,
                                -77.81671
                            ],
                            [
                                -35.28511,
                                -77.80851
                            ],
                            [
                                -35.50941,
                                -77.8644
                            ],
                            [
                                -35.63949,
                                -77.98044
                            ],
                            [
                                -35.61315,
                                -78.10427
                            ],
                            [
                                -36.37922,
                                -78.34823
                            ],
                            [
                                -36.44462,
                                -78.44564
                            ],
                            [
                                -36.37399,
                                -78.52645
                            ],
                            [
                                -36.53309,
                                -78.70312
                            ],
                            [
                                -36.34006,
                                -78.83167
                            ],
                            [
                                -36.14225,
                                -78.8944
                            ],
                            [
                                -35.81275,
                                -78.95003
                            ],
                            [
                                -35.30481,
                                -78.97821
                            ],
                            [
                                -34.92723,
                                -79.0314
                            ],
                            [
                                -34.31138,
                                -79.07818
                            ],
                            [
                                -33.93021,
                                -79.15623
                            ],
                            [
                                -33.70768,
                                -79.17254
                            ],
                            [
                                -33.0862,
                                -79.16684
                            ],
                            [
                                -32.14017,
                                -79.19178
                            ],
                            [
                                -31.47939,
                                -79.18494
                            ],
                            [
                                -30.8543,
                                -79.197
                            ],
                            [
                                -30.2363,
                                -79.2292
                            ],
                            [
                                -29.96377,
                                -79.28152
                            ],
                            [
                                -29.94059,
                                -79.38607
                            ],
                            [
                                -30.64282,
                                -79.50262
                            ],
                            [
                                -30.74646,
                                -79.57926
                            ],
                            [
                                -30.38106,
                                -79.72471
                            ],
                            [
                                -30.41148,
                                -79.80401
                            ],
                            [
                                -30.13311,
                                -79.95937
                            ],
                            [
                                -30.08106,
                                -80.04112
                            ],
                            [
                                -30.25454,
                                -80.19787
                            ],
                            [
                                -30.79356,
                                -80.31213
                            ],
                            [
                                -30.62577,
                                -80.40272
                            ],
                            [
                                -30.74891,
                                -80.43509
                            ],
                            [
                                -31.44986,
                                -80.44692
                            ],
                            [
                                -31.89385,
                                -80.42569
                            ],
                            [
                                -32.06351,
                                -80.3713
                            ],
                            [
                                -31.85018,
                                -80.14105
                            ],
                            [
                                -31.97526,
                                -80.08774
                            ],
                            [
                                -32.43363,
                                -80.13099
                            ],
                            [
                                -33.84385,
                                -80.16826
                            ],
                            [
                                -34.58673,
                                -80.20805
                            ],
                            [
                                -35.61637,
                                -80.31278
                            ],
                            [
                                -36.16704,
                                -80.42256
                            ],
                            [
                                -36.56797,
                                -80.55691
                            ],
                            [
                                -37.91732,
                                -80.83692
                            ],
                            [
                                -38.78831,
                                -80.97426
                            ],
                            [
                                -40.02812,
                                -81.1394
                            ],
                            [
                                -40.82541,
                                -81.2742
                            ],
                            [
                                -42.52381,
                                -81.48885
                            ],
                            [
                                -43.40645,
                                -81.57698
                            ],
                            [
                                -45.24077,
                                -81.70462
                            ],
                            [
                                -46.06355,
                                -81.72634
                            ],
                            [
                                -47.2949,
                                -81.71626
                            ],
                            [
                                -48.68327,
                                -81.75304
                            ],
                            [
                                -50.49566,
                                -81.76544
                            ],
                            [
                                -51.40321,
                                -81.81214
                            ],
                            [
                                -52.03366,
                                -81.8916
                            ],
                            [
                                -53.02375,
                                -82.05271
                            ],
                            [
                                -54.15176,
                                -82.15189
                            ],
                            [
                                -55.70496,
                                -82.35512
                            ],
                            [
                                -56.13927,
                                -82.43459
                            ],
                            [
                                -56.48097,
                                -82.55516
                            ],
                            [
                                -57.0444,
                                -82.68693
                            ],
                            [
                                -57.40203,
                                -82.80711
                            ],
                            [
                                -58.03288,
                                -82.96044
                            ],
                            [
                                -58.4305,
                                -83.0103
                            ],
                            [
                                -59.06245,
                                -83.01633
                            ],
                            [
                                -59.34417,
                                -82.92903
                            ],
                            [
                                -59.24034,
                                -82.80414
                            ],
                            [
                                -59.011,
                                -82.67739
                            ],
                            [
                                -59.17868,
                                -82.5818
                            ],
                            [
                                -59.65424,
                                -82.49054
                            ],
                            [
                                -60.24473,
                                -82.41833
                            ],
                            [
                                -62.98376,
                                -82.49962
                            ],
                            [
                                -64.11073,
                                -82.51144
                            ],
                            [
                                -65.79675,
                                -82.50498
                            ],
                            [
                                -67.83374,
                                -82.41025
                            ],
                            [
                                -68.58469,
                                -82.3426
                            ],
                            [
                                -70.13465,
                                -82.16774
                            ],
                            [
                                -71.03994,
                                -82.03011
                            ],
                            [
                                -71.52957,
                                -81.9253
                            ],
                            [
                                -72.01753,
                                -81.72336
                            ],
                            [
                                -71.941,
                                -81.53014
                            ],
                            [
                                -71.72529,
                                -81.43992
                            ],
                            [
                                -71.32696,
                                -81.37372
                            ],
                            [
                                -70.58945,
                                -81.29648
                            ],
                            [
                                -70.0141,
                                -81.26972
                            ],
                            [
                                -68.2745,
                                -81.22839
                            ],
                            [
                                -66.86411,
                                -81.2163
                            ],
                            [
                                -66.36043,
                                -81.19423
                            ],
                            [
                                -65.55964,
                                -81.19899
                            ],
                            [
                                -64.76814,
                                -81.17447
                            ],
                            [
                                -63.18521,
                                -81.15525
                            ],
                            [
                                -62.18411,
                                -81.09914
                            ],
                            [
                                -61.37206,
                                -81.08208
                            ],
                            [
                                -60.77428,
                                -81.03365
                            ],
                            [
                                -60.4175,
                                -80.97243
                            ],
                            [
                                -59.97982,
                                -80.85015
                            ],
                            [
                                -59.81822,
                                -80.75867
                            ],
                            [
                                -59.42219,
                                -80.69349
                            ],
                            [
                                -58.74747,
                                -80.51629
                            ],
                            [
                                -58.43583,
                                -80.45431
                            ],
                            [
                                -57.19742,
                                -80.26349
                            ],
                            [
                                -56.39068,
                                -80.14416
                            ],
                            [
                                -55.70331,
                                -80.0582
                            ],
                            [
                                -54.69555,
                                -79.97763
                            ],
                            [
                                -54.00109,
                                -80.07705
                            ],
                            [
                                -53.3696,
                                -80.25278
                            ],
                            [
                                -53.17673,
                                -80.34125
                            ],
                            [
                                -52.76888,
                                -80.45922
                            ],
                            [
                                -51.78327,
                                -80.67061
                            ],
                            [
                                -51.10344,
                                -80.72621
                            ],
                            [
                                -50.47221,
                                -80.74087
                            ],
                            [
                                -49.47781,
                                -80.74024
                            ],
                            [
                                -48.87266,
                                -80.72486
                            ],
                            [
                                -45.88077,
                                -80.52343
                            ],
                            [
                                -45.48093,
                                -80.48829
                            ],
                            [
                                -44.91794,
                                -80.39115
                            ],
                            [
                                -44.83666,
                                -80.34686
                            ],
                            [
                                -44.27296,
                                -80.17162
                            ],
                            [
                                -44.44391,
                                -80.05667
                            ],
                            [
                                -44.82065,
                                -80.01796
                            ],
                            [
                                -44.99241,
                                -79.93059
                            ],
                            [
                                -44.83024,
                                -79.86527
                            ],
                            [
                                -44.51107,
                                -79.87133
                            ],
                            [
                                -44.19074,
                                -79.92615
                            ],
                            [
                                -43.55013,
                                -79.97648
                            ],
                            [
                                -43.09249,
                                -79.94663
                            ],
                            [
                                -42.96584,
                                -79.8623
                            ],
                            [
                                -43.13291,
                                -79.79642
                            ],
                            [
                                -43.13199,
                                -79.70925
                            ],
                            [
                                -42.87368,
                                -79.49663
                            ],
                            [
                                -42.8904,
                                -79.39925
                            ],
                            [
                                -43.2098,
                                -79.33363
                            ],
                            [
                                -44.05939,
                                -79.33994
                            ],
                            [
                                -44.39575,
                                -79.39518
                            ],
                            [
                                -45.05267,
                                -79.44121
                            ],
                            [
                                -45.35005,
                                -79.44389
                            ],
                            [
                                -45.9975,
                                -79.48316
                            ],
                            [
                                -46.38082,
                                -79.41905
                            ],
                            [
                                -46.51716,
                                -79.29957
                            ],
                            [
                                -46.44046,
                                -79.2551
                            ],
                            [
                                -45.34515,
                                -79.17819
                            ],
                            [
                                -45.0004,
                                -79.18071
                            ],
                            [
                                -44.30863,
                                -79.13911
                            ],
                            [
                                -44.05535,
                                -79.04589
                            ],
                            [
                                -44.195,
                                -78.96954
                            ],
                            [
                                -44.22805,
                                -78.84569
                            ],
                            [
                                -44.49984,
                                -78.79728
                            ],
                            [
                                -44.87739,
                                -78.79682
                            ],
                            [
                                -45.23838,
                                -78.76744
                            ],
                            [
                                -45.62092,
                                -78.77788
                            ],
                            [
                                -46.46951,
                                -78.86055
                            ],
                            [
                                -46.99738,
                                -78.86799
                            ],
                            [
                                -47.85067,
                                -78.93243
                            ],
                            [
                                -48.30564,
                                -78.93818
                            ],
                            [
                                -48.49907,
                                -78.86124
                            ],
                            [
                                -48.15865,
                                -78.77824
                            ],
                            [
                                -47.55269,
                                -78.73141
                            ],
                            [
                                -46.14419,
                                -78.68074
                            ],
                            [
                                -45.36489,
                                -78.62205
                            ],
                            [
                                -44.90684,
                                -78.53881
                            ],
                            [
                                -44.99036,
                                -78.44461
                            ],
                            [
                                -45.52357,
                                -78.26374
                            ],
                            [
                                -45.88278,
                                -78.07996
                            ],
                            [
                                -46.48027,
                                -77.9387
                            ],
                            [
                                -46.77721,
                                -77.90044
                            ],
                            [
                                -48.06932,
                                -77.76359
                            ],
                            [
                                -48.34869,
                                -77.72296
                            ],
                            [
                                -48.87138,
                                -77.71003
                            ],
                            [
                                -49.37834,
                                -77.79712
                            ],
                            [
                                -49.90682,
                                -77.9566
                            ],
                            [
                                -50.1867,
                                -78.06408
                            ],
                            [
                                -50.54475,
                                -78.16359
                            ],
                            [
                                -51.00194,
                                -78.25104
                            ],
                            [
                                -51.21386,
                                -78.31308
                            ],
                            [
                                -51.82708,
                                -78.44109
                            ],
                            [
                                -53.03976,
                                -78.63452
                            ],
                            [
                                -53.23936,
                                -78.70016
                            ],
                            [
                                -53.55073,
                                -78.96798
                            ],
                            [
                                -53.68852,
                                -79.00034
                            ],
                            [
                                -54.20223,
                                -79.23
                            ],
                            [
                                -54.86782,
                                -79.33264
                            ],
                            [
                                -56.04436,
                                -79.449
                            ],
                            [
                                -57.21109,
                                -79.51078
                            ],
                            [
                                -58.89629,
                                -79.62298
                            ],
                            [
                                -59.25972,
                                -79.7056
                            ],
                            [
                                -59.50198,
                                -79.85898
                            ],
                            [
                                -59.49957,
                                -79.9845
                            ],
                            [
                                -59.69055,
                                -80.10205
                            ],
                            [
                                -59.88869,
                                -80.15547
                            ],
                            [
                                -60.84739,
                                -80.25255
                            ],
                            [
                                -62.11726,
                                -80.30195
                            ],
                            [
                                -62.67924,
                                -80.33403
                            ],
                            [
                                -64.0233,
                                -80.43687
                            ],
                            [
                                -65.32018,
                                -80.51902
                            ],
                            [
                                -65.89949,
                                -80.53934
                            ],
                            [
                                -66.88924,
                                -80.60846
                            ],
                            [
                                -67.62612,
                                -80.64232
                            ],
                            [
                                -68.83045,
                                -80.67699
                            ],
                            [
                                -70.06516,
                                -80.73005
                            ],
                            [
                                -71.43479,
                                -80.74493
                            ],
                            [
                                -72.2767,
                                -80.77513
                            ],
                            [
                                -73.09621,
                                -80.75508
                            ],
                            [
                                -74.59542,
                                -80.68928
                            ],
                            [
                                -75.47948,
                                -80.59971
                            ],
                            [
                                -76.22666,
                                -80.46442
                            ],
                            [
                                -76.9997,
                                -80.2756
                            ],
                            [
                                -76.89663,
                                -80.18458
                            ],
                            [
                                -77.12015,
                                -80.15945
                            ],
                            [
                                -77.70284,
                                -80.18093
                            ],
                            [
                                -79.07625,
                                -80.09282
                            ],
                            [
                                -79.52735,
                                -80.0245
                            ],
                            [
                                -79.92664,
                                -79.99509
                            ],
                            [
                                -79.69194,
                                -79.94379
                            ],
                            [
                                -78.82966,
                                -80.00504
                            ],
                            [
                                -78.44138,
                                -80.00686
                            ],
                            [
                                -77.98978,
                                -80.03675
                            ],
                            [
                                -77.64755,
                                -80.02998
                            ],
                            [
                                -77.33068,
                                -79.98427
                            ],
                            [
                                -77.8555,
                                -79.80996
                            ],
                            [
                                -78.75436,
                                -79.61243
                            ],
                            [
                                -79.01351,
                                -79.50163
                            ],
                            [
                                -78.69537,
                                -79.45339
                            ],
                            [
                                -79.40232,
                                -79.31887
                            ],
                            [
                                -79.89636,
                                -79.25263
                            ],
                            [
                                -80.28692,
                                -79.27923
                            ],
                            [
                                -80.36912,
                                -79.31799
                            ],
                            [
                                -79.99438,
                                -79.57166
                            ],
                            [
                                -80.0199,
                                -79.65273
                            ],
                            [
                                -80.33569,
                                -79.74453
                            ],
                            [
                                -80.46787,
                                -79.73418
                            ],
                            [
                                -80.797,
                                -79.5464
                            ],
                            [
                                -81.1455,
                                -79.45139
                            ],
                            [
                                -81.27632,
                                -79.27103
                            ],
                            [
                                -81.46554,
                                -79.19505
                            ],
                            [
                                -81.03106,
                                -79.07399
                            ],
                            [
                                -81.042,
                                -79.03264
                            ],
                            [
                                -81.31526,
                                -78.98418
                            ],
                            [
                                -81.42149,
                                -78.876
                            ],
                            [
                                -81.32625,
                                -78.79218
                            ],
                            [
                                -81.05477,
                                -78.68758
                            ],
                            [
                                -81.17615,
                                -78.59892
                            ],
                            [
                                -81.37147,
                                -78.53277
                            ],
                            [
                                -81.91743,
                                -78.43017
                            ],
                            [
                                -82.04126,
                                -78.38501
                            ],
                            [
                                -82.03623,
                                -78.30099
                            ],
                            [
                                -81.87488,
                                -78.23683
                            ],
                            [
                                -81.89837,
                                -78.17787
                            ],
                            [
                                -82.34251,
                                -78.10465
                            ],
                            [
                                -81.93616,
                                -78.03395
                            ],
                            [
                                -81.99029,
                                -77.89589
                            ],
                            [
                                -82.2433,
                                -77.71699
                            ],
                            [
                                -82.35415,
                                -77.58365
                            ],
                            [
                                -82.52565,
                                -77.4489
                            ],
                            [
                                -82.71131,
                                -77.39107
                            ],
                            [
                                -82.71948,
                                -77.26627
                            ],
                            [
                                -83.21352,
                                -77.15163
                            ],
                            [
                                -81.95667,
                                -77.0841
                            ],
                            [
                                -81.97357,
                                -77.17897
                            ],
                            [
                                -81.65955,
                                -77.32222
                            ],
                            [
                                -81.50162,
                                -77.44171
                            ],
                            [
                                -81.21085,
                                -77.40888
                            ],
                            [
                                -80.85622,
                                -77.17031
                            ],
                            [
                                -81.06368,
                                -76.99905
                            ],
                            [
                                -80.8873,
                                -76.96742
                            ],
                            [
                                -78.94403,
                                -76.8578
                            ],
                            [
                                -78.2731,
                                -76.79769
                            ],
                            [
                                -77.1228,
                                -76.71627
                            ],
                            [
                                -76.54966,
                                -76.6815
                            ],
                            [
                                -75.75921,
                                -76.64493
                            ],
                            [
                                -75.75776,
                                -77.03417
                            ],
                            [
                                -75.80457,
                                -77.1116
                            ],
                            [
                                -75.69561,
                                -77.17273
                            ],
                            [
                                -75.07744,
                                -77.38169
                            ],
                            [
                                -74.82279,
                                -77.52574
                            ],
                            [
                                -74.44015,
                                -77.68179
                            ],
                            [
                                -73.82563,
                                -77.82247
                            ],
                            [
                                -72.7909,
                                -77.94847
                            ],
                            [
                                -72.3498,
                                -77.98242
                            ],
                            [
                                -71.52207,
                                -78.06731
                            ],
                            [
                                -71.05197,
                                -78.0802
                            ],
                            [
                                -70.42963,
                                -78.07304
                            ],
                            [
                                -69.61994,
                                -78.11275
                            ],
                            [
                                -69.13144,
                                -78.09463
                            ],
                            [
                                -68.49469,
                                -77.98338
                            ],
                            [
                                -68.33626,
                                -77.92405
                            ],
                            [
                                -68.28446,
                                -77.82283
                            ],
                            [
                                -67.96459,
                                -77.76788
                            ],
                            [
                                -67.64277,
                                -77.62786
                            ],
                            [
                                -67.56559,
                                -77.54311
                            ],
                            [
                                -67.55013,
                                -77.34335
                            ],
                            [
                                -67.68376,
                                -77.03311
                            ],
                            [
                                -67.63538,
                                -76.89456
                            ],
                            [
                                -67.7923,
                                -76.8369
                            ],
                            [
                                -68.41078,
                                -76.72723
                            ],
                            [
                                -69.03934,
                                -76.66428
                            ],
                            [
                                -69.18725,
                                -76.58701
                            ],
                            [
                                -69.3756,
                                -76.54635
                            ],
                            [
                                -69.81009,
                                -76.49321
                            ],
                            [
                                -69.90891,
                                -76.45011
                            ],
                            [
                                -69.71747,
                                -76.38649
                            ],
                            [
                                -69.25514,
                                -76.3406
                            ],
                            [
                                -68.54797,
                                -76.29279
                            ],
                            [
                                -67.865,
                                -76.20993
                            ],
                            [
                                -67.47713,
                                -76.13004
                            ],
                            [
                                -67.15366,
                                -76.10246
                            ],
                            [
                                -66.69486,
                                -76.02265
                            ],
                            [
                                -65.75552,
                                -75.92383
                            ],
                            [
                                -65.51929,
                                -75.84051
                            ],
                            [
                                -65.25172,
                                -75.77918
                            ],
                            [
                                -64.99734,
                                -75.78045
                            ],
                            [
                                -64.04561,
                                -75.62478
                            ],
                            [
                                -63.26313,
                                -75.41711
                            ],
                            [
                                -63.14417,
                                -75.34109
                            ],
                            [
                                -63.31615,
                                -75.32067
                            ],
                            [
                                -63.65792,
                                -75.33476
                            ],
                            [
                                -63.91507,
                                -75.3208
                            ],
                            [
                                -64.33793,
                                -75.34399
                            ],
                            [
                                -64.39675,
                                -75.26915
                            ],
                            [
                                -64.02983,
                                -75.21013
                            ],
                            [
                                -63.54013,
                                -75.17006
                            ],
                            [
                                -63.35486,
                                -75.17611
                            ],
                            [
                                -63.08141,
                                -75.14055
                            ],
                            [
                                -62.84534,
                                -75.13843
                            ],
                            [
                                -62.55802,
                                -75.01295
                            ],
                            [
                                -62.21872,
                                -74.97522
                            ],
                            [
                                -61.99457,
                                -74.87389
                            ],
                            [
                                -61.92004,
                                -74.80137
                            ],
                            [
                                -62.10139,
                                -74.66383
                            ],
                            [
                                -61.9361,
                                -74.58343
                            ],
                            [
                                -61.68358,
                                -74.52806
                            ],
                            [
                                -61.34025,
                                -74.54653
                            ],
                            [
                                -61.00125,
                                -74.50903
                            ],
                            [
                                -61.081,
                                -74.41385
                            ],
                            [
                                -60.74508,
                                -74.37641
                            ],
                            [
                                -60.67013,
                                -74.29683
                            ],
                            [
                                -61.00561,
                                -74.28793
                            ],
                            [
                                -61.27807,
                                -74.33794
                            ],
                            [
                                -61.52955,
                                -74.34759
                            ],
                            [
                                -61.67961,
                                -74.3075
                            ],
                            [
                                -61.54426,
                                -74.26252
                            ],
                            [
                                -61.32958,
                                -74.24964
                            ],
                            [
                                -60.99654,
                                -74.09093
                            ],
                            [
                                -60.75109,
                                -74.09942
                            ],
                            [
                                -60.88976,
                                -73.91307
                            ],
                            [
                                -60.92501,
                                -73.81477
                            ],
                            [
                                -60.78129,
                                -73.79563
                            ],
                            [
                                -60.68061,
                                -73.70552
                            ],
                            [
                                -60.78143,
                                -73.64692
                            ],
                            [
                                -60.77538,
                                -73.52337
                            ],
                            [
                                -60.63421,
                                -73.42308
                            ],
                            [
                                -60.5702,
                                -73.18858
                            ],
                            [
                                -60.43345,
                                -73.17566
                            ],
                            [
                                -60.31158,
                                -73.30124
                            ],
                            [
                                -60.17795,
                                -73.31158
                            ],
                            [
                                -59.90483,
                                -73.2666
                            ],
                            [
                                -59.87636,
                                -73.20683
                            ],
                            [
                                -59.94333,
                                -73.12507
                            ],
                            [
                                -59.79683,
                                -72.99026
                            ],
                            [
                                -59.80791,
                                -72.89993
                            ],
                            [
                                -59.91257,
                                -72.86928
                            ],
                            [
                                -60.10424,
                                -72.90588
                            ],
                            [
                                -60.13715,
                                -72.98794
                            ],
                            [
                                -60.48192,
                                -72.95434
                            ],
                            [
                                -60.70001,
                                -73.04383
                            ],
                            [
                                -60.85107,
                                -72.97589
                            ],
                            [
                                -60.69095,
                                -72.96127
                            ],
                            [
                                -60.48869,
                                -72.84743
                            ],
                            [
                                -60.55232,
                                -72.67079
                            ],
                            [
                                -60.72691,
                                -72.64155
                            ],
                            [
                                -60.91499,
                                -72.70397
                            ],
                            [
                                -61.19661,
                                -72.68143
                            ],
                            [
                                -61.46571,
                                -72.6904
                            ],
                            [
                                -61.53421,
                                -72.652
                            ],
                            [
                                -61.36126,
                                -72.61375
                            ],
                            [
                                -61.47625,
                                -72.48577
                            ],
                            [
                                -61.39831,
                                -72.41722
                            ],
                            [
                                -60.93357,
                                -72.48332
                            ],
                            [
                                -60.64261,
                                -72.39993
                            ],
                            [
                                -60.71325,
                                -72.3677
                            ],
                            [
                                -60.99853,
                                -72.37543
                            ],
                            [
                                -60.95667,
                                -72.29292
                            ],
                            [
                                -60.68115,
                                -72.31748
                            ],
                            [
                                -60.81889,
                                -72.18107
                            ],
                            [
                                -61.05366,
                                -72.16144
                            ],
                            [
                                -60.6404,
                                -72.06566
                            ],
                            [
                                -60.77478,
                                -71.99316
                            ],
                            [
                                -61.23178,
                                -72.07414
                            ],
                            [
                                -61.51556,
                                -72.09474
                            ],
                            [
                                -61.83076,
                                -72.0555
                            ],
                            [
                                -61.94424,
                                -71.99958
                            ],
                            [
                                -61.94748,
                                -71.9357
                            ],
                            [
                                -61.74681,
                                -71.87648
                            ],
                            [
                                -61.34831,
                                -71.87674
                            ],
                            [
                                -60.92481,
                                -71.75709
                            ],
                            [
                                -60.76512,
                                -71.74298
                            ],
                            [
                                -60.8137,
                                -71.67063
                            ],
                            [
                                -61.05783,
                                -71.60523
                            ],
                            [
                                -61.19289,
                                -71.52981
                            ],
                            [
                                -61.43435,
                                -71.57718
                            ],
                            [
                                -61.4532,
                                -71.45162
                            ],
                            [
                                -61.23613,
                                -71.45295
                            ],
                            [
                                -61.18742,
                                -71.41722
                            ],
                            [
                                -61.31436,
                                -71.36259
                            ],
                            [
                                -60.99626,
                                -71.36157
                            ],
                            [
                                -61.05911,
                                -71.26613
                            ],
                            [
                                -60.96442,
                                -71.18158
                            ],
                            [
                                -61.13417,
                                -71.12421
                            ],
                            [
                                -61.33967,
                                -71.08929
                            ],
                            [
                                -61.45112,
                                -71.0365
                            ],
                            [
                                -61.30413,
                                -70.91366
                            ],
                            [
                                -61.36483,
                                -70.8381
                            ],
                            [
                                -61.49986,
                                -70.81465
                            ],
                            [
                                -61.68555,
                                -70.84283
                            ],
                            [
                                -61.83711,
                                -70.92698
                            ],
                            [
                                -62.06837,
                                -70.92572
                            ],
                            [
                                -62.12301,
                                -70.87396
                            ],
                            [
                                -61.95101,
                                -70.75632
                            ],
                            [
                                -61.82936,
                                -70.75394
                            ],
                            [
                                -61.6649,
                                -70.69737
                            ],
                            [
                                -61.68845,
                                -70.62295
                            ],
                            [
                                -61.39051,
                                -70.59057
                            ],
                            [
                                -61.49172,
                                -70.48816
                            ],
                            [
                                -62.20309,
                                -70.53922
                            ],
                            [
                                -62.40797,
                                -70.46601
                            ],
                            [
                                -62.47374,
                                -70.37835
                            ],
                            [
                                -62.2067,
                                -70.32819
                            ],
                            [
                                -61.88791,
                                -70.20591
                            ],
                            [
                                -61.97572,
                                -70.06489
                            ],
                            [
                                -62.35152,
                                -69.99358
                            ],
                            [
                                -62.45587,
                                -69.92925
                            ],
                            [
                                -62.39315,
                                -69.89773
                            ],
                            [
                                -62.65614,
                                -69.82539
                            ],
                            [
                                -62.62901,
                                -69.77987
                            ],
                            [
                                -62.44038,
                                -69.75806
                            ],
                            [
                                -62.39714,
                                -69.63326
                            ],
                            [
                                -62.42966,
                                -69.50595
                            ],
                            [
                                -62.59131,
                                -69.47881
                            ],
                            [
                                -62.72522,
                                -69.35293
                            ],
                            [
                                -62.99294,
                                -69.37939
                            ],
                            [
                                -63.11453,
                                -69.30651
                            ],
                            [
                                -63.0824,
                                -69.2578
                            ],
                            [
                                -63.26445,
                                -69.16503
                            ],
                            [
                                -63.38038,
                                -69.23519
                            ],
                            [
                                -63.5789,
                                -69.20048
                            ],
                            [
                                -63.32745,
                                -69.08809
                            ],
                            [
                                -63.81299,
                                -69.04004
                            ],
                            [
                                -63.71332,
                                -68.95457
                            ],
                            [
                                -63.47562,
                                -68.94965
                            ],
                            [
                                -63.38326,
                                -68.89308
                            ],
                            [
                                -63.42759,
                                -68.84528
                            ],
                            [
                                -63.22407,
                                -68.83152
                            ],
                            [
                                -63.416,
                                -68.76565
                            ],
                            [
                                -63.84037,
                                -68.70076
                            ],
                            [
                                -63.67553,
                                -68.56059
                            ],
                            [
                                -63.40136,
                                -68.53305
                            ],
                            [
                                -63.21313,
                                -68.49145
                            ],
                            [
                                -63.09382,
                                -68.53539
                            ],
                            [
                                -62.94509,
                                -68.49091
                            ],
                            [
                                -63.35987,
                                -68.43078
                            ],
                            [
                                -63.63053,
                                -68.43459
                            ],
                            [
                                -63.79428,
                                -68.45922
                            ],
                            [
                                -63.96779,
                                -68.5594
                            ],
                            [
                                -64.22499,
                                -68.67574
                            ],
                            [
                                -64.03214,
                                -68.739
                            ],
                            [
                                -64.27574,
                                -68.77402
                            ],
                            [
                                -64.4831,
                                -68.76062
                            ],
                            [
                                -64.68478,
                                -68.68533
                            ],
                            [
                                -64.85429,
                                -68.68322
                            ],
                            [
                                -64.93744,
                                -68.64452
                            ],
                            [
                                -65.23654,
                                -68.62396
                            ],
                            [
                                -65.35143,
                                -68.51173
                            ],
                            [
                                -65.20961,
                                -68.50921
                            ],
                            [
                                -64.97907,
                                -68.40891
                            ],
                            [
                                -65.07834,
                                -68.36174
                            ],
                            [
                                -65.45873,
                                -68.38174
                            ],
                            [
                                -65.39087,
                                -68.30183
                            ],
                            [
                                -64.81287,
                                -68.17514
                            ],
                            [
                                -64.79382,
                                -68.09529
                            ],
                            [
                                -65.02996,
                                -68.06998
                            ],
                            [
                                -65.29722,
                                -68.17688
                            ],
                            [
                                -65.49693,
                                -68.13918
                            ],
                            [
                                -65.62392,
                                -68.16219
                            ],
                            [
                                -65.72929,
                                -68.1251
                            ],
                            [
                                -65.61586,
                                -68.03101
                            ],
                            [
                                -65.40048,
                                -68.02212
                            ],
                            [
                                -65.33794,
                                -67.97628
                            ],
                            [
                                -65.44852,
                                -67.94325
                            ],
                            [
                                -65.60923,
                                -67.94671
                            ],
                            [
                                -65.74067,
                                -67.87859
                            ],
                            [
                                -65.61915,
                                -67.84734
                            ],
                            [
                                -65.63737,
                                -67.74141
                            ],
                            [
                                -65.4255,
                                -67.69253
                            ],
                            [
                                -65.39806,
                                -67.60347
                            ],
                            [
                                -65.62374,
                                -67.49372
                            ],
                            [
                                -65.53137,
                                -67.42262
                            ],
                            [
                                -65.55044,
                                -67.36088
                            ],
                            [
                                -65.39769,
                                -67.34558
                            ],
                            [
                                -65.31113,
                                -67.39326
                            ],
                            [
                                -65.08363,
                                -67.34735
                            ],
                            [
                                -65.00629,
                                -67.25571
                            ],
                            [
                                -65.01931,
                                -67.19068
                            ],
                            [
                                -64.80441,
                                -67.15438
                            ],
                            [
                                -64.74551,
                                -67.07867
                            ],
                            [
                                -64.94815,
                                -67.04599
                            ],
                            [
                                -64.86783,
                                -66.95847
                            ],
                            [
                                -64.74543,
                                -66.99207
                            ],
                            [
                                -64.69249,
                                -66.92437
                            ],
                            [
                                -64.39984,
                                -66.89468
                            ],
                            [
                                -63.89045,
                                -66.93026
                            ],
                            [
                                -63.71266,
                                -66.86559
                            ],
                            [
                                -63.8381,
                                -66.77479
                            ],
                            [
                                -64.1772,
                                -66.74459
                            ],
                            [
                                -64.13132,
                                -66.58999
                            ],
                            [
                                -63.83927,
                                -66.56085
                            ],
                            [
                                -63.83178,
                                -66.51808
                            ],
                            [
                                -63.96308,
                                -66.46166
                            ],
                            [
                                -63.76577,
                                -66.33655
                            ],
                            [
                                -63.78511,
                                -66.271
                            ],
                            [
                                -63.69096,
                                -66.21941
                            ],
                            [
                                -63.55496,
                                -66.20837
                            ],
                            [
                                -63.44752,
                                -66.25937
                            ],
                            [
                                -63.25388,
                                -66.28056
                            ],
                            [
                                -63.1943,
                                -66.33684
                            ],
                            [
                                -62.88877,
                                -66.48374
                            ],
                            [
                                -62.7556,
                                -66.59186
                            ],
                            [
                                -62.73982,
                                -66.69292
                            ],
                            [
                                -62.60305,
                                -66.73867
                            ],
                            [
                                -62.4734,
                                -66.69465
                            ],
                            [
                                -62.55029,
                                -66.625
                            ],
                            [
                                -62.69889,
                                -66.5497
                            ],
                            [
                                -62.61611,
                                -66.48936
                            ],
                            [
                                -62.42587,
                                -66.43911
                            ],
                            [
                                -62.5737,
                                -66.36902
                            ],
                            [
                                -62.90659,
                                -66.27428
                            ],
                            [
                                -62.86115,
                                -66.22855
                            ],
                            [
                                -62.71323,
                                -66.20554
                            ],
                            [
                                -62.4857,
                                -66.21581
                            ],
                            [
                                -62.45813,
                                -66.1798
                            ],
                            [
                                -62.17536,
                                -66.18222
                            ],
                            [
                                -61.92899,
                                -66.25439
                            ],
                            [
                                -61.81116,
                                -66.33781
                            ],
                            [
                                -61.79452,
                                -66.44029
                            ],
                            [
                                -61.63929,
                                -66.40366
                            ],
                            [
                                -61.70242,
                                -66.36441
                            ],
                            [
                                -61.66212,
                                -66.22668
                            ],
                            [
                                -61.49519,
                                -66.22698
                            ],
                            [
                                -61.48538,
                                -66.13681
                            ],
                            [
                                -61.36568,
                                -66.1221
                            ],
                            [
                                -61.2208,
                                -66.22803
                            ],
                            [
                                -61.15006,
                                -66.33422
                            ],
                            [
                                -60.96198,
                                -66.25823
                            ],
                            [
                                -60.85412,
                                -66.15252
                            ],
                            [
                                -60.72343,
                                -66.11108
                            ],
                            [
                                -60.59578,
                                -65.99703
                            ],
                            [
                                -60.66873,
                                -65.92938
                            ],
                            [
                                -60.86558,
                                -65.94281
                            ],
                            [
                                -61.01218,
                                -65.9226
                            ],
                            [
                                -61.00751,
                                -66.03848
                            ],
                            [
                                -61.10109,
                                -66.02527
                            ],
                            [
                                -61.24377,
                                -65.92803
                            ],
                            [
                                -61.37961,
                                -65.96226
                            ],
                            [
                                -61.35591,
                                -66.07567
                            ],
                            [
                                -61.58997,
                                -66.02354
                            ],
                            [
                                -61.82497,
                                -66.1626
                            ],
                            [
                                -61.8981,
                                -66.17234
                            ],
                            [
                                -62.06688,
                                -66.1021
                            ],
                            [
                                -62.13158,
                                -66.02508
                            ],
                            [
                                -62.39502,
                                -65.93259
                            ],
                            [
                                -62.39918,
                                -65.83194
                            ],
                            [
                                -62.30594,
                                -65.75419
                            ],
                            [
                                -62.1219,
                                -65.71775
                            ],
                            [
                                -62.09148,
                                -65.59764
                            ],
                            [
                                -61.94553,
                                -65.5461
                            ],
                            [
                                -61.73926,
                                -65.56309
                            ],
                            [
                                -61.93569,
                                -65.46836
                            ],
                            [
                                -62.0959,
                                -65.44667
                            ],
                            [
                                -62.06172,
                                -65.38237
                            ],
                            [
                                -62.16714,
                                -65.30011
                            ],
                            [
                                -61.8822,
                                -65.19074
                            ],
                            [
                                -61.77378,
                                -65.24945
                            ],
                            [
                                -61.60271,
                                -65.21625
                            ],
                            [
                                -61.59383,
                                -65.09556
                            ],
                            [
                                -61.46811,
                                -65.04384
                            ],
                            [
                                -61.35435,
                                -65.04529
                            ],
                            [
                                -61.19373,
                                -64.97394
                            ],
                            [
                                -61.06867,
                                -65.0217
                            ],
                            [
                                -60.8788,
                                -64.85782
                            ],
                            [
                                -60.77047,
                                -64.83151
                            ],
                            [
                                -60.71683,
                                -64.72011
                            ],
                            [
                                -60.62135,
                                -64.66589
                            ],
                            [
                                -60.45643,
                                -64.64376
                            ],
                            [
                                -60.37938,
                                -64.56328
                            ],
                            [
                                -60.16357,
                                -64.48942
                            ],
                            [
                                -59.98248,
                                -64.40309
                            ],
                            [
                                -59.71657,
                                -64.39325
                            ],
                            [
                                -59.64469,
                                -64.32571
                            ],
                            [
                                -59.48004,
                                -64.31346
                            ],
                            [
                                -59.32178,
                                -64.44321
                            ],
                            [
                                -59.15759,
                                -64.4731
                            ],
                            [
                                -59.0294,
                                -64.42124
                            ],
                            [
                                -59.01508,
                                -64.51716
                            ],
                            [
                                -58.82144,
                                -64.5137
                            ],
                            [
                                -58.81853,
                                -64.4007
                            ],
                            [
                                -58.94266,
                                -64.36987
                            ],
                            [
                                -58.75652,
                                -64.29851
                            ],
                            [
                                -58.83921,
                                -64.26012
                            ],
                            [
                                -58.71701,
                                -64.13124
                            ],
                            [
                                -58.65791,
                                -64.10356
                            ],
                            [
                                -58.68329,
                                -64.01347
                            ],
                            [
                                -58.5885,
                                -63.93778
                            ],
                            [
                                -58.42823,
                                -63.89507
                            ],
                            [
                                -58.26816,
                                -63.72928
                            ],
                            [
                                -58.08015,
                                -63.66605
                            ],
                            [
                                -57.93886,
                                -63.67611
                            ],
                            [
                                -57.74743,
                                -63.65102
                            ],
                            [
                                -57.68364,
                                -63.55919
                            ],
                            [
                                -57.40971,
                                -63.53474
                            ],
                            [
                                -57.40628,
                                -63.47417
                            ],
                            [
                                -57.22288,
                                -63.46561
                            ],
                            [
                                -57.11375,
                                -63.53709
                            ],
                            [
                                -57.17443,
                                -63.57834
                            ],
                            [
                                -57.14013,
                                -63.64802
                            ],
                            [
                                -56.97311,
                                -63.61513
                            ],
                            [
                                -56.86309,
                                -63.65237
                            ],
                            [
                                -56.77402,
                                -63.59177
                            ],
                            [
                                -56.7879,
                                -63.53378
                            ],
                            [
                                -56.98171,
                                -63.47332
                            ],
                            [
                                -56.93933,
                                -63.42646
                            ],
                            [
                                -57.07433,
                                -63.24646
                            ],
                            [
                                -57.2881,
                                -63.22475
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -70.17203,
                                -68.84693
                            ],
                            [
                                -70.44771,
                                -68.77537
                            ],
                            [
                                -70.60906,
                                -68.76151
                            ],
                            [
                                -71.02369,
                                -68.86282
                            ],
                            [
                                -71.17128,
                                -68.84378
                            ],
                            [
                                -71.6018,
                                -68.90897
                            ],
                            [
                                -71.80764,
                                -69.00099
                            ],
                            [
                                -72.14924,
                                -69.06657
                            ],
                            [
                                -72.18078,
                                -69.12197
                            ],
                            [
                                -72.01455,
                                -69.14673
                            ],
                            [
                                -71.95231,
                                -69.20466
                            ],
                            [
                                -71.736,
                                -69.24853
                            ],
                            [
                                -71.69089,
                                -69.33433
                            ],
                            [
                                -71.82057,
                                -69.36621
                            ],
                            [
                                -71.81405,
                                -69.43074
                            ],
                            [
                                -71.95126,
                                -69.532
                            ],
                            [
                                -71.84844,
                                -69.61679
                            ],
                            [
                                -71.94477,
                                -69.76996
                            ],
                            [
                                -71.67316,
                                -69.85667
                            ],
                            [
                                -71.39285,
                                -69.97821
                            ],
                            [
                                -71.21716,
                                -69.98137
                            ],
                            [
                                -71.09066,
                                -70.07836
                            ],
                            [
                                -70.61795,
                                -70.17447
                            ],
                            [
                                -70.34155,
                                -70.1323
                            ],
                            [
                                -70.0891,
                                -70.1688
                            ],
                            [
                                -70.02054,
                                -70.21832
                            ],
                            [
                                -70.15662,
                                -70.24467
                            ],
                            [
                                -70.31671,
                                -70.21812
                            ],
                            [
                                -70.54379,
                                -70.26324
                            ],
                            [
                                -70.89322,
                                -70.23855
                            ],
                            [
                                -71.38259,
                                -70.27385
                            ],
                            [
                                -71.49623,
                                -70.32045
                            ],
                            [
                                -71.59593,
                                -70.42997
                            ],
                            [
                                -71.55716,
                                -70.54335
                            ],
                            [
                                -71.2307,
                                -70.6131
                            ],
                            [
                                -70.97069,
                                -70.72767
                            ],
                            [
                                -70.89419,
                                -70.79529
                            ],
                            [
                                -70.6544,
                                -70.87722
                            ],
                            [
                                -70.74704,
                                -70.96799
                            ],
                            [
                                -70.93047,
                                -70.9872
                            ],
                            [
                                -70.9771,
                                -70.8625
                            ],
                            [
                                -71.18053,
                                -70.79208
                            ],
                            [
                                -71.48763,
                                -70.83321
                            ],
                            [
                                -71.70755,
                                -70.92731
                            ],
                            [
                                -72.17495,
                                -70.98308
                            ],
                            [
                                -72.3166,
                                -70.96243
                            ],
                            [
                                -72.54117,
                                -70.97032
                            ],
                            [
                                -72.83507,
                                -70.94975
                            ],
                            [
                                -72.99478,
                                -71.01842
                            ],
                            [
                                -73.25698,
                                -71.03236
                            ],
                            [
                                -73.23451,
                                -71.10028
                            ],
                            [
                                -72.91916,
                                -71.21138
                            ],
                            [
                                -72.41665,
                                -71.22503
                            ],
                            [
                                -72.37571,
                                -71.26487
                            ],
                            [
                                -73.04996,
                                -71.33142
                            ],
                            [
                                -73.27498,
                                -71.19144
                            ],
                            [
                                -73.66012,
                                -71.14046
                            ],
                            [
                                -74.10139,
                                -71.18706
                            ],
                            [
                                -74.16325,
                                -71.25734
                            ],
                            [
                                -74.0838,
                                -71.31938
                            ],
                            [
                                -73.48203,
                                -71.42221
                            ],
                            [
                                -73.37566,
                                -71.50777
                            ],
                            [
                                -73.46837,
                                -71.54813
                            ],
                            [
                                -73.9642,
                                -71.44143
                            ],
                            [
                                -74.19453,
                                -71.41673
                            ],
                            [
                                -74.41247,
                                -71.3306
                            ],
                            [
                                -74.48634,
                                -71.25052
                            ],
                            [
                                -74.82843,
                                -71.2128
                            ],
                            [
                                -74.96729,
                                -71.22596
                            ],
                            [
                                -75.09347,
                                -71.30539
                            ],
                            [
                                -75.04295,
                                -71.37171
                            ],
                            [
                                -74.67109,
                                -71.6011
                            ],
                            [
                                -74.76358,
                                -71.63561
                            ],
                            [
                                -75.04753,
                                -71.58642
                            ],
                            [
                                -75.32793,
                                -71.39602
                            ],
                            [
                                -75.54142,
                                -71.34428
                            ],
                            [
                                -75.7141,
                                -71.41789
                            ],
                            [
                                -75.6741,
                                -71.51862
                            ],
                            [
                                -75.47561,
                                -71.6965
                            ],
                            [
                                -75.15602,
                                -71.82202
                            ],
                            [
                                -74.74007,
                                -71.92481
                            ],
                            [
                                -74.36776,
                                -71.99442
                            ],
                            [
                                -74.18947,
                                -72.07945
                            ],
                            [
                                -73.83104,
                                -72.06179
                            ],
                            [
                                -73.67062,
                                -72.08396
                            ],
                            [
                                -73.6516,
                                -72.15132
                            ],
                            [
                                -73.49906,
                                -72.1563
                            ],
                            [
                                -73.32662,
                                -72.04684
                            ],
                            [
                                -73.01587,
                                -71.93558
                            ],
                            [
                                -73.00122,
                                -71.8866
                            ],
                            [
                                -73.3028,
                                -71.84324
                            ],
                            [
                                -73.41692,
                                -71.79224
                            ],
                            [
                                -73.24734,
                                -71.7338
                            ],
                            [
                                -72.97655,
                                -71.7552
                            ],
                            [
                                -72.79737,
                                -71.74124
                            ],
                            [
                                -72.50894,
                                -71.85959
                            ],
                            [
                                -72.33867,
                                -71.84499
                            ],
                            [
                                -72.51958,
                                -71.71328
                            ],
                            [
                                -72.41307,
                                -71.56868
                            ],
                            [
                                -72.0857,
                                -71.57806
                            ],
                            [
                                -71.92426,
                                -71.64013
                            ],
                            [
                                -71.79068,
                                -71.63496
                            ],
                            [
                                -71.4899,
                                -71.75191
                            ],
                            [
                                -71.48618,
                                -71.83119
                            ],
                            [
                                -71.29547,
                                -71.80529
                            ],
                            [
                                -71.12559,
                                -71.84551
                            ],
                            [
                                -71.04266,
                                -71.9708
                            ],
                            [
                                -70.68637,
                                -71.98872
                            ],
                            [
                                -70.7885,
                                -72.04318
                            ],
                            [
                                -71.02073,
                                -72.091
                            ],
                            [
                                -71.0405,
                                -72.13838
                            ],
                            [
                                -70.59672,
                                -72.23021
                            ],
                            [
                                -70.70595,
                                -72.28263
                            ],
                            [
                                -71.31292,
                                -72.28931
                            ],
                            [
                                -71.47492,
                                -72.25748
                            ],
                            [
                                -71.82759,
                                -72.2377
                            ],
                            [
                                -72.12139,
                                -72.23937
                            ],
                            [
                                -72.30475,
                                -72.26584
                            ],
                            [
                                -72.6653,
                                -72.43155
                            ],
                            [
                                -72.68017,
                                -72.46714
                            ],
                            [
                                -72.42908,
                                -72.53851
                            ],
                            [
                                -72.23177,
                                -72.63745
                            ],
                            [
                                -71.935,
                                -72.69746
                            ],
                            [
                                -71.60534,
                                -72.66049
                            ],
                            [
                                -71.01486,
                                -72.68415
                            ],
                            [
                                -70.46856,
                                -72.71654
                            ],
                            [
                                -70.21249,
                                -72.70155
                            ],
                            [
                                -69.9836,
                                -72.66085
                            ],
                            [
                                -69.64443,
                                -72.66671
                            ],
                            [
                                -69.29941,
                                -72.57966
                            ],
                            [
                                -69.2066,
                                -72.58439
                            ],
                            [
                                -69.01703,
                                -72.5107
                            ],
                            [
                                -69.08584,
                                -72.34985
                            ],
                            [
                                -68.90798,
                                -72.27017
                            ],
                            [
                                -68.77122,
                                -72.25615
                            ],
                            [
                                -68.54005,
                                -72.28782
                            ],
                            [
                                -68.44938,
                                -72.26403
                            ],
                            [
                                -68.36785,
                                -72.05751
                            ],
                            [
                                -68.49137,
                                -72.00153
                            ],
                            [
                                -68.48595,
                                -71.95248
                            ],
                            [
                                -68.234,
                                -71.90047
                            ],
                            [
                                -68.19046,
                                -71.715
                            ],
                            [
                                -68.11184,
                                -71.64653
                            ],
                            [
                                -68.17958,
                                -71.59695
                            ],
                            [
                                -68.19131,
                                -71.49943
                            ],
                            [
                                -68.28893,
                                -71.37638
                            ],
                            [
                                -68.20979,
                                -71.29234
                            ],
                            [
                                -68.21888,
                                -71.17172
                            ],
                            [
                                -68.35257,
                                -70.97357
                            ],
                            [
                                -68.35673,
                                -70.82606
                            ],
                            [
                                -68.43659,
                                -70.71816
                            ],
                            [
                                -68.41658,
                                -70.64477
                            ],
                            [
                                -68.52156,
                                -70.49643
                            ],
                            [
                                -68.70809,
                                -70.37785
                            ],
                            [
                                -68.68619,
                                -70.34312
                            ],
                            [
                                -69.01115,
                                -70.2437
                            ],
                            [
                                -69.09289,
                                -70.18965
                            ],
                            [
                                -69.08399,
                                -70.10069
                            ],
                            [
                                -69.13453,
                                -69.99535
                            ],
                            [
                                -69.24752,
                                -69.94092
                            ],
                            [
                                -69.24164,
                                -69.86967
                            ],
                            [
                                -69.31954,
                                -69.83053
                            ],
                            [
                                -69.34769,
                                -69.62585
                            ],
                            [
                                -69.51094,
                                -69.53926
                            ],
                            [
                                -69.52013,
                                -69.44734
                            ],
                            [
                                -69.61301,
                                -69.41429
                            ],
                            [
                                -69.72534,
                                -69.27187
                            ],
                            [
                                -70.0358,
                                -69.2828
                            ],
                            [
                                -70.12004,
                                -69.24035
                            ],
                            [
                                -70.01712,
                                -69.08185
                            ],
                            [
                                -70.09323,
                                -68.99305
                            ],
                            [
                                -70.08562,
                                -68.93234
                            ],
                            [
                                -70.17203,
                                -68.84693
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -77.53115,
                                -77.04431
                            ],
                            [
                                -78.32713,
                                -77.0729
                            ],
                            [
                                -78.93851,
                                -77.14061
                            ],
                            [
                                -79.318,
                                -77.1959
                            ],
                            [
                                -79.67128,
                                -77.27293
                            ],
                            [
                                -79.81228,
                                -77.37878
                            ],
                            [
                                -79.86885,
                                -77.51844
                            ],
                            [
                                -80.23384,
                                -77.61821
                            ],
                            [
                                -80.65379,
                                -77.70442
                            ],
                            [
                                -80.74534,
                                -77.75764
                            ],
                            [
                                -80.65656,
                                -77.83025
                            ],
                            [
                                -80.24537,
                                -77.95411
                            ],
                            [
                                -79.61632,
                                -78.09016
                            ],
                            [
                                -79.3202,
                                -78.04511
                            ],
                            [
                                -79.04495,
                                -78.04565
                            ],
                            [
                                -77.83453,
                                -78.19121
                            ],
                            [
                                -77.39334,
                                -78.19221
                            ],
                            [
                                -76.62002,
                                -78.17248
                            ],
                            [
                                -75.70747,
                                -78.05892
                            ],
                            [
                                -76.01749,
                                -77.91109
                            ],
                            [
                                -76.15562,
                                -77.79318
                            ],
                            [
                                -76.70762,
                                -77.66948
                            ],
                            [
                                -76.76467,
                                -77.60702
                            ],
                            [
                                -76.58649,
                                -77.42087
                            ],
                            [
                                -76.88735,
                                -77.31415
                            ],
                            [
                                -76.93302,
                                -77.26914
                            ],
                            [
                                -76.80934,
                                -77.16571
                            ],
                            [
                                -77.53115,
                                -77.04431
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -160.32489,
                                -79.89787
                            ],
                            [
                                -159.54346,
                                -79.81377
                            ],
                            [
                                -159.23453,
                                -79.76371
                            ],
                            [
                                -159.17427,
                                -79.68585
                            ],
                            [
                                -159.5316,
                                -79.58759
                            ],
                            [
                                -159.75371,
                                -79.40342
                            ],
                            [
                                -160.97328,
                                -79.07472
                            ],
                            [
                                -161.19061,
                                -78.92727
                            ],
                            [
                                -161.42239,
                                -78.85066
                            ],
                            [
                                -162.02652,
                                -78.78609
                            ],
                            [
                                -162.6602,
                                -78.74531
                            ],
                            [
                                -163.13417,
                                -78.75179
                            ],
                            [
                                -163.48119,
                                -78.79045
                            ],
                            [
                                -163.60364,
                                -78.83811
                            ],
                            [
                                -163.64204,
                                -78.96974
                            ],
                            [
                                -163.86127,
                                -79.03301
                            ],
                            [
                                -164.29825,
                                -79.0976
                            ],
                            [
                                -164.36369,
                                -79.16306
                            ],
                            [
                                -164.13208,
                                -79.37596
                            ],
                            [
                                -163.52786,
                                -79.56026
                            ],
                            [
                                -162.29732,
                                -79.76839
                            ],
                            [
                                -161.75826,
                                -79.81721
                            ],
                            [
                                -161.01393,
                                -79.90076
                            ],
                            [
                                -160.32489,
                                -79.89787
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -98.42226,
                                -71.7956
                            ],
                            [
                                -98.30761,
                                -71.73515
                            ],
                            [
                                -98.4894,
                                -71.67701
                            ],
                            [
                                -98.78467,
                                -71.63258
                            ],
                            [
                                -99.0071,
                                -71.67336
                            ],
                            [
                                -99.22999,
                                -71.78022
                            ],
                            [
                                -99.17189,
                                -71.84372
                            ],
                            [
                                -98.87577,
                                -71.93003
                            ],
                            [
                                -98.98853,
                                -71.97965
                            ],
                            [
                                -99.21136,
                                -71.98352
                            ],
                            [
                                -99.27779,
                                -71.93588
                            ],
                            [
                                -99.61951,
                                -71.95551
                            ],
                            [
                                -99.67947,
                                -71.85331
                            ],
                            [
                                -99.82115,
                                -71.86296
                            ],
                            [
                                -99.89581,
                                -71.91895
                            ],
                            [
                                -100.04726,
                                -71.91431
                            ],
                            [
                                -100.31372,
                                -71.992
                            ],
                            [
                                -100.57827,
                                -71.9229
                            ],
                            [
                                -100.18127,
                                -71.82171
                            ],
                            [
                                -100.30501,
                                -71.7757
                            ],
                            [
                                -100.57271,
                                -71.79001
                            ],
                            [
                                -100.70513,
                                -71.898
                            ],
                            [
                                -100.85099,
                                -71.91977
                            ],
                            [
                                -101.09867,
                                -71.86798
                            ],
                            [
                                -101.377,
                                -71.87596
                            ],
                            [
                                -101.49295,
                                -71.9207
                            ],
                            [
                                -101.80729,
                                -71.93869
                            ],
                            [
                                -102.30856,
                                -72.01203
                            ],
                            [
                                -102.41286,
                                -72.11005
                            ],
                            [
                                -102.24211,
                                -72.17617
                            ],
                            [
                                -101.99202,
                                -72.22849
                            ],
                            [
                                -101.66784,
                                -72.23084
                            ],
                            [
                                -101.2606,
                                -72.29201
                            ],
                            [
                                -100.86837,
                                -72.30313
                            ],
                            [
                                -100.37298,
                                -72.33426
                            ],
                            [
                                -100.10149,
                                -72.40678
                            ],
                            [
                                -99.78677,
                                -72.35574
                            ],
                            [
                                -99.36555,
                                -72.39748
                            ],
                            [
                                -99.10551,
                                -72.3805
                            ],
                            [
                                -98.82449,
                                -72.43671
                            ],
                            [
                                -98.97451,
                                -72.48072
                            ],
                            [
                                -98.59644,
                                -72.5164
                            ],
                            [
                                -98.32657,
                                -72.52114
                            ],
                            [
                                -97.39824,
                                -72.47528
                            ],
                            [
                                -97.05375,
                                -72.54505
                            ],
                            [
                                -96.04986,
                                -72.53224
                            ],
                            [
                                -95.98081,
                                -72.51478
                            ],
                            [
                                -96.03374,
                                -72.36583
                            ],
                            [
                                -95.84284,
                                -72.38666
                            ],
                            [
                                -95.55965,
                                -72.3603
                            ],
                            [
                                -95.46212,
                                -72.28835
                            ],
                            [
                                -95.80824,
                                -72.27383
                            ],
                            [
                                -95.87456,
                                -72.24642
                            ],
                            [
                                -96.37618,
                                -72.22661
                            ],
                            [
                                -96.2287,
                                -72.18177
                            ],
                            [
                                -95.9443,
                                -72.16849
                            ],
                            [
                                -95.72465,
                                -72.18606
                            ],
                            [
                                -95.51195,
                                -72.12093
                            ],
                            [
                                -95.62206,
                                -72.0712
                            ],
                            [
                                -95.60679,
                                -72.00774
                            ],
                            [
                                -95.83471,
                                -72.00636
                            ],
                            [
                                -95.92501,
                                -72.07136
                            ],
                            [
                                -96.14471,
                                -72.11193
                            ],
                            [
                                -96.5472,
                                -72.13882
                            ],
                            [
                                -96.68262,
                                -72.18054
                            ],
                            [
                                -97.07992,
                                -72.13409
                            ],
                            [
                                -96.66565,
                                -72.03837
                            ],
                            [
                                -96.4995,
                                -72.03136
                            ],
                            [
                                -96.11334,
                                -71.91811
                            ],
                            [
                                -96.10594,
                                -71.80281
                            ],
                            [
                                -96.35375,
                                -71.7573
                            ],
                            [
                                -96.73462,
                                -71.794
                            ],
                            [
                                -96.95485,
                                -71.7379
                            ],
                            [
                                -97.12774,
                                -71.79738
                            ],
                            [
                                -97.17588,
                                -71.93946
                            ],
                            [
                                -97.41348,
                                -72.07971
                            ],
                            [
                                -97.4506,
                                -72.15772
                            ],
                            [
                                -97.71711,
                                -72.0358
                            ],
                            [
                                -97.4608,
                                -71.94199
                            ],
                            [
                                -97.62425,
                                -71.83593
                            ],
                            [
                                -97.86699,
                                -71.78792
                            ],
                            [
                                -98.01914,
                                -71.81826
                            ],
                            [
                                -97.95424,
                                -71.87231
                            ],
                            [
                                -98.02155,
                                -72.03323
                            ],
                            [
                                -98.38653,
                                -71.95706
                            ],
                            [
                                -98.47224,
                                -71.86114
                            ],
                            [
                                -98.21835,
                                -71.84183
                            ],
                            [
                                -98.17666,
                                -71.76175
                            ],
                            [
                                -98.42226,
                                -71.7956
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -122.46384,
                                -73.59536
                            ],
                            [
                                -122.66217,
                                -73.59335
                            ],
                            [
                                -122.79494,
                                -73.66389
                            ],
                            [
                                -122.82455,
                                -73.74796
                            ],
                            [
                                -122.58916,
                                -73.75183
                            ],
                            [
                                -122.33768,
                                -73.7957
                            ],
                            [
                                -122.28688,
                                -73.87174
                            ],
                            [
                                -122.53921,
                                -73.9654
                            ],
                            [
                                -122.62145,
                                -74.03377
                            ],
                            [
                                -122.48339,
                                -74.07214
                            ],
                            [
                                -122.6605,
                                -74.16496
                            ],
                            [
                                -122.61297,
                                -74.23581
                            ],
                            [
                                -122.36714,
                                -74.28448
                            ],
                            [
                                -121.6089,
                                -74.33375
                            ],
                            [
                                -121.33929,
                                -74.31126
                            ],
                            [
                                -121.178,
                                -74.33538
                            ],
                            [
                                -120.84317,
                                -74.30698
                            ],
                            [
                                -120.47756,
                                -74.33046
                            ],
                            [
                                -120.16187,
                                -74.30032
                            ],
                            [
                                -119.96548,
                                -74.2435
                            ],
                            [
                                -119.5827,
                                -74.09275
                            ],
                            [
                                -118.83015,
                                -73.92902
                            ],
                            [
                                -118.63351,
                                -73.82725
                            ],
                            [
                                -118.69078,
                                -73.75676
                            ],
                            [
                                -118.9004,
                                -73.72241
                            ],
                            [
                                -119.24946,
                                -73.72166
                            ],
                            [
                                -119.53652,
                                -73.74895
                            ],
                            [
                                -120.06844,
                                -73.72166
                            ],
                            [
                                -120.32711,
                                -73.65423
                            ],
                            [
                                -120.43616,
                                -73.6826
                            ],
                            [
                                -120.66393,
                                -73.66059
                            ],
                            [
                                -120.98033,
                                -73.68076
                            ],
                            [
                                -121.60382,
                                -73.63734
                            ],
                            [
                                -121.79604,
                                -73.59129
                            ],
                            [
                                -122.46384,
                                -73.59536
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -125.77312,
                                -73.08384
                            ],
                            [
                                -125.91596,
                                -73.10484
                            ],
                            [
                                -126.15091,
                                -73.09346
                            ],
                            [
                                -126.51955,
                                -73.10883
                            ],
                            [
                                -126.78087,
                                -73.15579
                            ],
                            [
                                -126.91975,
                                -73.28345
                            ],
                            [
                                -126.91064,
                                -73.3788
                            ],
                            [
                                -126.59635,
                                -73.45464
                            ],
                            [
                                -126.69304,
                                -73.54917
                            ],
                            [
                                -126.53381,
                                -73.5954
                            ],
                            [
                                -126.10495,
                                -73.48663
                            ],
                            [
                                -125.92434,
                                -73.68999
                            ],
                            [
                                -125.71605,
                                -73.81211
                            ],
                            [
                                -125.52396,
                                -73.8569
                            ],
                            [
                                -125.20336,
                                -73.87544
                            ],
                            [
                                -124.9573,
                                -73.94531
                            ],
                            [
                                -124.75247,
                                -73.96229
                            ],
                            [
                                -124.5067,
                                -74.06736
                            ],
                            [
                                -124.26253,
                                -74.10041
                            ],
                            [
                                -123.81737,
                                -74.07741
                            ],
                            [
                                -123.44724,
                                -74.09021
                            ],
                            [
                                -123.37534,
                                -73.93112
                            ],
                            [
                                -123.62247,
                                -73.83489
                            ],
                            [
                                -123.70309,
                                -73.77373
                            ],
                            [
                                -123.95001,
                                -73.7055
                            ],
                            [
                                -124.02305,
                                -73.59777
                            ],
                            [
                                -124.34644,
                                -73.68027
                            ],
                            [
                                -124.71521,
                                -73.67793
                            ],
                            [
                                -124.96964,
                                -73.74028
                            ],
                            [
                                -125.09869,
                                -73.66828
                            ],
                            [
                                -124.77707,
                                -73.60105
                            ],
                            [
                                -124.65941,
                                -73.55221
                            ],
                            [
                                -124.68216,
                                -73.49928
                            ],
                            [
                                -124.91962,
                                -73.41234
                            ],
                            [
                                -124.8521,
                                -73.315
                            ],
                            [
                                -125.09038,
                                -73.27201
                            ],
                            [
                                -125.36443,
                                -73.17935
                            ],
                            [
                                -125.40942,
                                -73.12344
                            ],
                            [
                                -125.77312,
                                -73.08384
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -66.24306,
                                -78.37162
                            ],
                            [
                                -67.05907,
                                -78.3896
                            ],
                            [
                                -67.74786,
                                -78.44885
                            ],
                            [
                                -68.06673,
                                -78.49562
                            ],
                            [
                                -69.23231,
                                -78.70506
                            ],
                            [
                                -69.50012,
                                -78.7767
                            ],
                            [
                                -70.03471,
                                -78.98261
                            ],
                            [
                                -70.49313,
                                -79.09846
                            ],
                            [
                                -70.62711,
                                -79.16402
                            ],
                            [
                                -70.16389,
                                -79.17011
                            ],
                            [
                                -69.62512,
                                -79.20924
                            ],
                            [
                                -69.29847,
                                -79.19857
                            ],
                            [
                                -68.74817,
                                -79.09133
                            ],
                            [
                                -68.1004,
                                -78.92723
                            ],
                            [
                                -67.57441,
                                -78.81503
                            ],
                            [
                                -67.10375,
                                -78.68988
                            ],
                            [
                                -66.1065,
                                -78.50567
                            ],
                            [
                                -65.65564,
                                -78.46252
                            ],
                            [
                                -65.46842,
                                -78.40326
                            ],
                            [
                                -65.67903,
                                -78.37021
                            ],
                            [
                                -66.24306,
                                -78.37162
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -75.21809,
                                -72.82021
                            ],
                            [
                                -75.5835,
                                -72.83276
                            ],
                            [
                                -75.82319,
                                -72.94495
                            ],
                            [
                                -75.7131,
                                -73.02068
                            ],
                            [
                                -75.45554,
                                -73.01366
                            ],
                            [
                                -75.48428,
                                -73.08096
                            ],
                            [
                                -76.07777,
                                -73.08812
                            ],
                            [
                                -76.1964,
                                -73.16125
                            ],
                            [
                                -76.11609,
                                -73.2968
                            ],
                            [
                                -75.73507,
                                -73.43448
                            ],
                            [
                                -75.02648,
                                -73.56662
                            ],
                            [
                                -74.66889,
                                -73.65492
                            ],
                            [
                                -74.53774,
                                -73.64536
                            ],
                            [
                                -74.38512,
                                -73.52118
                            ],
                            [
                                -74.61846,
                                -73.32776
                            ],
                            [
                                -74.44332,
                                -73.22421
                            ],
                            [
                                -74.27418,
                                -73.05104
                            ],
                            [
                                -74.29398,
                                -72.99336
                            ],
                            [
                                -74.6262,
                                -72.89158
                            ],
                            [
                                -74.97014,
                                -72.82911
                            ],
                            [
                                -75.21809,
                                -72.82021
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                167.51889,
                                -77.46034
                            ],
                            [
                                166.98059,
                                -77.37953
                            ],
                            [
                                167.01793,
                                -77.31289
                            ],
                            [
                                166.83148,
                                -77.22632
                            ],
                            [
                                166.56625,
                                -77.21448
                            ],
                            [
                                166.23262,
                                -77.31303
                            ],
                            [
                                166.50569,
                                -77.41041
                            ],
                            [
                                166.27754,
                                -77.53472
                            ],
                            [
                                165.99876,
                                -77.58039
                            ],
                            [
                                166.34619,
                                -77.683
                            ],
                            [
                                166.72436,
                                -77.7121
                            ],
                            [
                                166.80841,
                                -77.80951
                            ],
                            [
                                167.49458,
                                -77.67287
                            ],
                            [
                                167.68427,
                                -77.66593
                            ],
                            [
                                168.44155,
                                -77.73661
                            ],
                            [
                                168.73322,
                                -77.6944
                            ],
                            [
                                169.27812,
                                -77.56727
                            ],
                            [
                                169.13498,
                                -77.48926
                            ],
                            [
                                168.24886,
                                -77.40884
                            ],
                            [
                                167.51889,
                                -77.46034
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -67.77852,
                                -66.62033
                            ],
                            [
                                -67.95577,
                                -66.65135
                            ],
                            [
                                -68.11534,
                                -66.72853
                            ],
                            [
                                -68.29056,
                                -66.75204
                            ],
                            [
                                -68.47467,
                                -66.82764
                            ],
                            [
                                -68.66018,
                                -67.09078
                            ],
                            [
                                -68.7613,
                                -67.18657
                            ],
                            [
                                -68.78307,
                                -67.26887
                            ],
                            [
                                -69.05613,
                                -67.41587
                            ],
                            [
                                -69.15928,
                                -67.44728
                            ],
                            [
                                -69.20048,
                                -67.58938
                            ],
                            [
                                -68.96579,
                                -67.73587
                            ],
                            [
                                -68.61661,
                                -67.7527
                            ],
                            [
                                -68.44503,
                                -67.65292
                            ],
                            [
                                -68.46268,
                                -67.56862
                            ],
                            [
                                -68.2665,
                                -67.53272
                            ],
                            [
                                -68.13521,
                                -67.56526
                            ],
                            [
                                -67.9765,
                                -67.42298
                            ],
                            [
                                -68.19167,
                                -67.36832
                            ],
                            [
                                -68.18022,
                                -67.32612
                            ],
                            [
                                -67.99987,
                                -67.29956
                            ],
                            [
                                -67.8694,
                                -67.20738
                            ],
                            [
                                -67.7665,
                                -67.2014
                            ],
                            [
                                -67.69406,
                                -67.13835
                            ],
                            [
                                -67.75178,
                                -67.07486
                            ],
                            [
                                -67.90603,
                                -67.04241
                            ],
                            [
                                -67.99672,
                                -66.93094
                            ],
                            [
                                -67.9339,
                                -66.83389
                            ],
                            [
                                -67.76371,
                                -66.76333
                            ],
                            [
                                -67.65309,
                                -66.68865
                            ],
                            [
                                -67.77852,
                                -66.62033
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                122.52347,
                                -66.52309
                            ],
                            [
                                122.52222,
                                -66.43537
                            ],
                            [
                                122.41434,
                                -66.35832
                            ],
                            [
                                122.11772,
                                -66.24132
                            ],
                            [
                                121.71501,
                                -66.04166
                            ],
                            [
                                121.73716,
                                -65.949
                            ],
                            [
                                121.44105,
                                -65.6806
                            ],
                            [
                                121.35071,
                                -65.64702
                            ],
                            [
                                121.18979,
                                -65.73216
                            ],
                            [
                                121.21345,
                                -65.82294
                            ],
                            [
                                121.18388,
                                -65.91877
                            ],
                            [
                                121.34698,
                                -66.01365
                            ],
                            [
                                121.36705,
                                -66.05766
                            ],
                            [
                                121.21501,
                                -66.19952
                            ],
                            [
                                121.31184,
                                -66.28444
                            ],
                            [
                                121.7039,
                                -66.40311
                            ],
                            [
                                121.75462,
                                -66.45626
                            ],
                            [
                                121.69958,
                                -66.50197
                            ],
                            [
                                121.4934,
                                -66.56792
                            ],
                            [
                                121.37015,
                                -66.6409
                            ],
                            [
                                121.38708,
                                -66.69329
                            ],
                            [
                                121.69968,
                                -66.62347
                            ],
                            [
                                122.068,
                                -66.5555
                            ],
                            [
                                122.18466,
                                -66.57025
                            ],
                            [
                                122.47636,
                                -66.66127
                            ],
                            [
                                122.54991,
                                -66.5629
                            ],
                            [
                                122.52347,
                                -66.52309
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.97098,
                                -69.52576
                            ],
                            [
                                -75.33604,
                                -69.54384
                            ],
                            [
                                -75.32867,
                                -69.61477
                            ],
                            [
                                -75.89132,
                                -69.61308
                            ],
                            [
                                -76.07934,
                                -69.64668
                            ],
                            [
                                -76.07766,
                                -69.6915
                            ],
                            [
                                -75.89839,
                                -69.81016
                            ],
                            [
                                -75.94675,
                                -69.92047
                            ],
                            [
                                -75.66202,
                                -69.96573
                            ],
                            [
                                -75.1466,
                                -69.92986
                            ],
                            [
                                -74.70129,
                                -69.98194
                            ],
                            [
                                -74.45416,
                                -69.8043
                            ],
                            [
                                -74.50613,
                                -69.73388
                            ],
                            [
                                -74.66829,
                                -69.69902
                            ],
                            [
                                -74.68168,
                                -69.58201
                            ],
                            [
                                -74.97098,
                                -69.52576
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -77.46875,
                                -72.70406
                            ],
                            [
                                -77.78701,
                                -72.65423
                            ],
                            [
                                -78.15551,
                                -72.657
                            ],
                            [
                                -78.15357,
                                -72.81023
                            ],
                            [
                                -78.27068,
                                -72.89216
                            ],
                            [
                                -78.5454,
                                -72.9659
                            ],
                            [
                                -78.66923,
                                -72.92732
                            ],
                            [
                                -78.92257,
                                -72.93734
                            ],
                            [
                                -79.06977,
                                -73.00191
                            ],
                            [
                                -78.86757,
                                -73.1525
                            ],
                            [
                                -78.58971,
                                -73.19471
                            ],
                            [
                                -78.34314,
                                -73.15325
                            ],
                            [
                                -78.06433,
                                -73.01068
                            ],
                            [
                                -77.48295,
                                -72.96328
                            ],
                            [
                                -77.38061,
                                -72.93553
                            ],
                            [
                                -77.39201,
                                -72.85439
                            ],
                            [
                                -77.28,
                                -72.81555
                            ],
                            [
                                -77.24051,
                                -72.70984
                            ],
                            [
                                -77.46875,
                                -72.70406
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -57.81221,
                                -63.82947
                            ],
                            [
                                -57.83263,
                                -63.78011
                            ],
                            [
                                -58.05888,
                                -63.84174
                            ],
                            [
                                -58.12796,
                                -63.89904
                            ],
                            [
                                -58.29172,
                                -63.90729
                            ],
                            [
                                -58.30364,
                                -63.95883
                            ],
                            [
                                -58.46168,
                                -64.06137
                            ],
                            [
                                -58.43408,
                                -64.13901
                            ],
                            [
                                -58.31775,
                                -64.14887
                            ],
                            [
                                -58.20291,
                                -64.0802
                            ],
                            [
                                -58.08117,
                                -64.1244
                            ],
                            [
                                -58.17549,
                                -64.173
                            ],
                            [
                                -58.11899,
                                -64.26644
                            ],
                            [
                                -58.27,
                                -64.29879
                            ],
                            [
                                -58.2196,
                                -64.36025
                            ],
                            [
                                -57.90589,
                                -64.43795
                            ],
                            [
                                -57.73266,
                                -64.36715
                            ],
                            [
                                -57.28531,
                                -64.36325
                            ],
                            [
                                -57.3815,
                                -64.30623
                            ],
                            [
                                -57.29057,
                                -64.24278
                            ],
                            [
                                -57.08976,
                                -64.20022
                            ],
                            [
                                -57.19842,
                                -64.14153
                            ],
                            [
                                -57.14918,
                                -64.0853
                            ],
                            [
                                -57.4954,
                                -64.02398
                            ],
                            [
                                -57.50469,
                                -63.97164
                            ],
                            [
                                -57.72806,
                                -63.99742
                            ],
                            [
                                -57.8705,
                                -63.97182
                            ],
                            [
                                -57.79033,
                                -63.90058
                            ],
                            [
                                -57.81221,
                                -63.82947
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -63.35816,
                                -64.25611
                            ],
                            [
                                -63.56345,
                                -64.26946
                            ],
                            [
                                -63.70446,
                                -64.32849
                            ],
                            [
                                -63.72081,
                                -64.41224
                            ],
                            [
                                -63.97323,
                                -64.46612
                            ],
                            [
                                -64.06896,
                                -64.5271
                            ],
                            [
                                -64.23039,
                                -64.584
                            ],
                            [
                                -64.29602,
                                -64.70427
                            ],
                            [
                                -64.14313,
                                -64.70741
                            ],
                            [
                                -64.05467,
                                -64.75988
                            ],
                            [
                                -63.67533,
                                -64.79826
                            ],
                            [
                                -63.49506,
                                -64.72474
                            ],
                            [
                                -63.39006,
                                -64.75499
                            ],
                            [
                                -63.2108,
                                -64.6695
                            ],
                            [
                                -62.85241,
                                -64.54871
                            ],
                            [
                                -62.96612,
                                -64.5132
                            ],
                            [
                                -63.18177,
                                -64.56842
                            ],
                            [
                                -63.26535,
                                -64.53925
                            ],
                            [
                                -63.14037,
                                -64.47816
                            ],
                            [
                                -63.17888,
                                -64.41032
                            ],
                            [
                                -63.30337,
                                -64.38992
                            ],
                            [
                                -63.19852,
                                -64.3182
                            ],
                            [
                                -63.35816,
                                -64.25611
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -73.88017,
                                -70.5816
                            ],
                            [
                                -74.12836,
                                -70.47479
                            ],
                            [
                                -74.30014,
                                -70.58984
                            ],
                            [
                                -74.6094,
                                -70.56188
                            ],
                            [
                                -74.60991,
                                -70.62895
                            ],
                            [
                                -74.73046,
                                -70.66483
                            ],
                            [
                                -75.08085,
                                -70.5869
                            ],
                            [
                                -75.13924,
                                -70.68069
                            ],
                            [
                                -75.30732,
                                -70.71707
                            ],
                            [
                                -75.52312,
                                -70.69542
                            ],
                            [
                                -75.54337,
                                -70.75932
                            ],
                            [
                                -75.32827,
                                -70.87532
                            ],
                            [
                                -75.17606,
                                -70.85889
                            ],
                            [
                                -74.90556,
                                -70.8664
                            ],
                            [
                                -74.83196,
                                -70.84108
                            ],
                            [
                                -74.41019,
                                -70.82396
                            ],
                            [
                                -74.30267,
                                -70.78275
                            ],
                            [
                                -73.90752,
                                -70.70819
                            ],
                            [
                                -73.74155,
                                -70.64313
                            ],
                            [
                                -73.88017,
                                -70.5816
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -147.63507,
                                -77.45622
                            ],
                            [
                                -147.60536,
                                -77.29816
                            ],
                            [
                                -147.75681,
                                -77.22477
                            ],
                            [
                                -148.40341,
                                -77.12422
                            ],
                            [
                                -148.71368,
                                -77.13631
                            ],
                            [
                                -148.8712,
                                -77.22492
                            ],
                            [
                                -148.88141,
                                -77.30952
                            ],
                            [
                                -148.76897,
                                -77.34615
                            ],
                            [
                                -148.26138,
                                -77.41794
                            ],
                            [
                                -148.19641,
                                -77.46984
                            ],
                            [
                                -147.63507,
                                -77.45622
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -91.28525,
                                -73.16826
                            ],
                            [
                                -91.14161,
                                -73.10892
                            ],
                            [
                                -90.80865,
                                -72.85443
                            ],
                            [
                                -90.99516,
                                -72.79259
                            ],
                            [
                                -90.81731,
                                -72.68526
                            ],
                            [
                                -90.97758,
                                -72.55545
                            ],
                            [
                                -91.1609,
                                -72.51952
                            ],
                            [
                                -91.65032,
                                -72.58501
                            ],
                            [
                                -91.66924,
                                -72.61958
                            ],
                            [
                                -91.45777,
                                -72.6992
                            ],
                            [
                                -91.34204,
                                -72.7998
                            ],
                            [
                                -91.29813,
                                -72.919
                            ],
                            [
                                -91.33395,
                                -73.00697
                            ],
                            [
                                -91.50473,
                                -73.10435
                            ],
                            [
                                -91.46549,
                                -73.15405
                            ],
                            [
                                -91.28525,
                                -73.16826
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -116.35664,
                                -74.02222
                            ],
                            [
                                -115.88066,
                                -73.88317
                            ],
                            [
                                -116.13485,
                                -73.82231
                            ],
                            [
                                -116.66704,
                                -73.92039
                            ],
                            [
                                -117.109,
                                -74.03053
                            ],
                            [
                                -117.39204,
                                -74.02808
                            ],
                            [
                                -117.57656,
                                -74.08121
                            ],
                            [
                                -117.72192,
                                -74.17339
                            ],
                            [
                                -117.40739,
                                -74.17266
                            ],
                            [
                                -117.08593,
                                -74.19215
                            ],
                            [
                                -116.7817,
                                -74.17998
                            ],
                            [
                                -116.52193,
                                -74.14742
                            ],
                            [
                                -116.30537,
                                -74.06892
                            ],
                            [
                                -116.35664,
                                -74.02222
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -55.48483,
                                -63.14785
                            ],
                            [
                                -55.63788,
                                -63.11213
                            ],
                            [
                                -55.72311,
                                -63.145
                            ],
                            [
                                -55.83989,
                                -63.12208
                            ],
                            [
                                -56.12991,
                                -63.14881
                            ],
                            [
                                -56.24653,
                                -63.19935
                            ],
                            [
                                -56.42388,
                                -63.24089
                            ],
                            [
                                -56.56492,
                                -63.33945
                            ],
                            [
                                -56.41558,
                                -63.43881
                            ],
                            [
                                -56.1327,
                                -63.3977
                            ],
                            [
                                -55.85798,
                                -63.29904
                            ],
                            [
                                -55.32851,
                                -63.37071
                            ],
                            [
                                -55.19636,
                                -63.36384
                            ],
                            [
                                -55.02159,
                                -63.30784
                            ],
                            [
                                -55.06925,
                                -63.2225
                            ],
                            [
                                -55.48483,
                                -63.14785
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -149.12152,
                                -77.16608
                            ],
                            [
                                -149.06104,
                                -77.14246
                            ],
                            [
                                -149.34587,
                                -77.00472
                            ],
                            [
                                -149.63504,
                                -76.91438
                            ],
                            [
                                -150.00258,
                                -76.91466
                            ],
                            [
                                -150.52504,
                                -76.96925
                            ],
                            [
                                -150.62941,
                                -77.00772
                            ],
                            [
                                -150.30792,
                                -77.10537
                            ],
                            [
                                -149.77467,
                                -77.13162
                            ],
                            [
                                -149.52975,
                                -77.16605
                            ],
                            [
                                -149.12152,
                                -77.16608
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -127.24274,
                                -74.60617
                            ],
                            [
                                -127.05444,
                                -74.58901
                            ],
                            [
                                -126.91769,
                                -74.53851
                            ],
                            [
                                -126.88525,
                                -74.38795
                            ],
                            [
                                -127.38715,
                                -74.29958
                            ],
                            [
                                -127.42231,
                                -74.27231
                            ],
                            [
                                -127.86065,
                                -74.23338
                            ],
                            [
                                -127.82178,
                                -74.44791
                            ],
                            [
                                -127.55756,
                                -74.5522
                            ],
                            [
                                -127.24274,
                                -74.60617
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -130.98015,
                                -74.36237
                            ],
                            [
                                -131.39662,
                                -74.32652
                            ],
                            [
                                -131.58696,
                                -74.25742
                            ],
                            [
                                -131.73715,
                                -74.25372
                            ],
                            [
                                -131.91844,
                                -74.30429
                            ],
                            [
                                -131.90332,
                                -74.4631
                            ],
                            [
                                -131.65604,
                                -74.47946
                            ],
                            [
                                -131.13821,
                                -74.55045
                            ],
                            [
                                -130.87427,
                                -74.53271
                            ],
                            [
                                -130.73463,
                                -74.41314
                            ],
                            [
                                -130.98015,
                                -74.36237
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -62.03489,
                                -69.72171
                            ],
                            [
                                -61.95551,
                                -69.67177
                            ],
                            [
                                -61.89703,
                                -69.52159
                            ],
                            [
                                -61.92756,
                                -69.4101
                            ],
                            [
                                -62.13354,
                                -69.27857
                            ],
                            [
                                -62.22961,
                                -69.16122
                            ],
                            [
                                -62.49051,
                                -69.1508
                            ],
                            [
                                -62.57946,
                                -69.18063
                            ],
                            [
                                -62.58261,
                                -69.24878
                            ],
                            [
                                -62.19283,
                                -69.53007
                            ],
                            [
                                -62.23347,
                                -69.6657
                            ],
                            [
                                -62.03489,
                                -69.72171
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -57.92111,
                                -61.9449
                            ],
                            [
                                -58.0778,
                                -61.93184
                            ],
                            [
                                -58.24065,
                                -61.94893
                            ],
                            [
                                -58.43801,
                                -61.93692
                            ],
                            [
                                -58.60186,
                                -62.01019
                            ],
                            [
                                -58.72108,
                                -62.01653
                            ],
                            [
                                -58.78514,
                                -62.07228
                            ],
                            [
                                -59.01677,
                                -62.20316
                            ],
                            [
                                -58.83149,
                                -62.17582
                            ],
                            [
                                -58.54307,
                                -62.24358
                            ],
                            [
                                -58.44109,
                                -62.20378
                            ],
                            [
                                -58.49734,
                                -62.07584
                            ],
                            [
                                -58.25535,
                                -62.18162
                            ],
                            [
                                -58.14131,
                                -62.14871
                            ],
                            [
                                -58.17215,
                                -62.07378
                            ],
                            [
                                -57.9565,
                                -62.07101
                            ],
                            [
                                -57.82641,
                                -62.02538
                            ],
                            [
                                -57.68826,
                                -62.02587
                            ],
                            [
                                -57.6933,
                                -61.90801
                            ],
                            [
                                -57.92111,
                                -61.9449
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -89.52919,
                                -72.93082
                            ],
                            [
                                -89.55079,
                                -72.86505
                            ],
                            [
                                -89.98752,
                                -72.80404
                            ],
                            [
                                -90,
                                -72.8713
                            ],
                            [
                                -90.16609,
                                -72.92728
                            ],
                            [
                                -90.4011,
                                -72.95669
                            ],
                            [
                                -90.28876,
                                -73.09317
                            ],
                            [
                                -90.16799,
                                -73.10843
                            ],
                            [
                                -89.7811,
                                -73.1025
                            ],
                            [
                                -89.63693,
                                -73.05209
                            ],
                            [
                                -89.65331,
                                -72.97762
                            ],
                            [
                                -89.52919,
                                -72.93082
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -62.36971,
                                -64.00771
                            ],
                            [
                                -62.56344,
                                -64.0513
                            ],
                            [
                                -62.51097,
                                -64.09518
                            ],
                            [
                                -62.59042,
                                -64.1412
                            ],
                            [
                                -62.48478,
                                -64.23154
                            ],
                            [
                                -62.7046,
                                -64.40936
                            ],
                            [
                                -62.57165,
                                -64.49229
                            ],
                            [
                                -62.40149,
                                -64.45558
                            ],
                            [
                                -62.35167,
                                -64.39703
                            ],
                            [
                                -62.21744,
                                -64.35635
                            ],
                            [
                                -62.23587,
                                -64.29429
                            ],
                            [
                                -62.09748,
                                -64.21095
                            ],
                            [
                                -62.04579,
                                -64.13937
                            ],
                            [
                                -62.28616,
                                -64.08044
                            ],
                            [
                                -62.36971,
                                -64.00771
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -60.10196,
                                -62.54444
                            ],
                            [
                                -60.13349,
                                -62.46625
                            ],
                            [
                                -60.34457,
                                -62.54932
                            ],
                            [
                                -60.49741,
                                -62.5749
                            ],
                            [
                                -60.70305,
                                -62.55249
                            ],
                            [
                                -60.84341,
                                -62.56472
                            ],
                            [
                                -61.08612,
                                -62.65878
                            ],
                            [
                                -60.83115,
                                -62.67172
                            ],
                            [
                                -60.71758,
                                -62.62357
                            ],
                            [
                                -60.41859,
                                -62.66962
                            ],
                            [
                                -60.29998,
                                -62.75644
                            ],
                            [
                                -60.06414,
                                -62.70463
                            ],
                            [
                                -59.9939,
                                -62.62524
                            ],
                            [
                                -60.10196,
                                -62.54444
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                86.20576,
                                -67.02325
                            ],
                            [
                                86.29408,
                                -66.97744
                            ],
                            [
                                86.32117,
                                -66.91023
                            ],
                            [
                                86.01608,
                                -66.76737
                            ],
                            [
                                85.85182,
                                -66.73893
                            ],
                            [
                                85.58352,
                                -66.72241
                            ],
                            [
                                85.59905,
                                -66.80524
                            ],
                            [
                                85.86335,
                                -66.9068
                            ],
                            [
                                85.98833,
                                -66.9902
                            ],
                            [
                                86.20576,
                                -67.02325
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -100.20975,
                                -72.47041
                            ],
                            [
                                -100.37532,
                                -72.52647
                            ],
                            [
                                -99.97251,
                                -72.59674
                            ],
                            [
                                -99.51269,
                                -72.63044
                            ],
                            [
                                -99.32835,
                                -72.58157
                            ],
                            [
                                -99.34644,
                                -72.54048
                            ],
                            [
                                -99.99155,
                                -72.46007
                            ],
                            [
                                -100.20975,
                                -72.47041
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                96.72372,
                                -66.07216
                            ],
                            [
                                96.605,
                                -66.04456
                            ],
                            [
                                96.40884,
                                -66.03873
                            ],
                            [
                                96.34342,
                                -66.06459
                            ],
                            [
                                96.25699,
                                -66.18226
                            ],
                            [
                                96.47849,
                                -66.23496
                            ],
                            [
                                96.66236,
                                -66.23214
                            ],
                            [
                                96.97059,
                                -66.17952
                            ],
                            [
                                96.92393,
                                -66.07879
                            ],
                            [
                                96.72372,
                                -66.07216
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -72.5288,
                                -69.31316
                            ],
                            [
                                -72.68703,
                                -69.32931
                            ],
                            [
                                -72.84202,
                                -69.41238
                            ],
                            [
                                -72.83641,
                                -69.4662
                            ],
                            [
                                -72.60253,
                                -69.53363
                            ],
                            [
                                -72.41692,
                                -69.52087
                            ],
                            [
                                -72.15887,
                                -69.55678
                            ],
                            [
                                -72.18136,
                                -69.45862
                            ],
                            [
                                -72.35054,
                                -69.41789
                            ],
                            [
                                -72.42049,
                                -69.31289
                            ],
                            [
                                -72.5288,
                                -69.31316
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                167.33217,
                                -78.30042
                            ],
                            [
                                167.53938,
                                -78.16717
                            ],
                            [
                                167.47726,
                                -78.07682
                            ],
                            [
                                167.32768,
                                -78.05368
                            ],
                            [
                                167.04675,
                                -78.18784
                            ],
                            [
                                166.75786,
                                -78.25101
                            ],
                            [
                                167.05226,
                                -78.30299
                            ],
                            [
                                167.33217,
                                -78.30042
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -148.74687,
                                -76.7256
                            ],
                            [
                                -148.89204,
                                -76.70826
                            ],
                            [
                                -149.21541,
                                -76.7578
                            ],
                            [
                                -149.01442,
                                -76.85364
                            ],
                            [
                                -148.70502,
                                -76.86867
                            ],
                            [
                                -148.31172,
                                -76.81484
                            ],
                            [
                                -148.2,
                                -76.77885
                            ],
                            [
                                -148.74687,
                                -76.7256
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -146.66516,
                                -76.33819
                            ],
                            [
                                -146.62094,
                                -76.2599
                            ],
                            [
                                -146.9695,
                                -76.10902
                            ],
                            [
                                -147.34525,
                                -76.11949
                            ],
                            [
                                -147.39915,
                                -76.14796
                            ],
                            [
                                -146.80963,
                                -76.3412
                            ],
                            [
                                -146.66516,
                                -76.33819
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -150.24983,
                                -77.39787
                            ],
                            [
                                -150.17355,
                                -77.37032
                            ],
                            [
                                -150.67393,
                                -77.28429
                            ],
                            [
                                -150.81134,
                                -77.24203
                            ],
                            [
                                -151.24365,
                                -77.28388
                            ],
                            [
                                -151.09811,
                                -77.35835
                            ],
                            [
                                -150.38298,
                                -77.40862
                            ],
                            [
                                -150.24983,
                                -77.39787
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -65.78128,
                                -65.51835
                            ],
                            [
                                -65.97389,
                                -65.53672
                            ],
                            [
                                -66.01243,
                                -65.61279
                            ],
                            [
                                -66.11056,
                                -65.68239
                            ],
                            [
                                -66.09542,
                                -65.75305
                            ],
                            [
                                -66.20527,
                                -65.76664
                            ],
                            [
                                -66.17804,
                                -65.8734
                            ],
                            [
                                -65.85313,
                                -65.82397
                            ],
                            [
                                -65.85664,
                                -65.75747
                            ],
                            [
                                -65.93365,
                                -65.69818
                            ],
                            [
                                -65.69445,
                                -65.65433
                            ],
                            [
                                -65.675,
                                -65.51835
                            ],
                            [
                                -65.78128,
                                -65.51835
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -77.73809,
                                -73.40831
                            ],
                            [
                                -77.41941,
                                -73.33386
                            ],
                            [
                                -77.70856,
                                -73.22305
                            ],
                            [
                                -77.93359,
                                -73.22186
                            ],
                            [
                                -78.12079,
                                -73.29176
                            ],
                            [
                                -78.09364,
                                -73.38
                            ],
                            [
                                -78.00879,
                                -73.41051
                            ],
                            [
                                -77.73809,
                                -73.40831
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -94.45247,
                                -72.55395
                            ],
                            [
                                -94.46587,
                                -72.46541
                            ],
                            [
                                -94.952,
                                -72.50469
                            ],
                            [
                                -95.17483,
                                -72.55566
                            ],
                            [
                                -95.28873,
                                -72.64246
                            ],
                            [
                                -94.90914,
                                -72.64337
                            ],
                            [
                                -94.6873,
                                -72.60813
                            ],
                            [
                                -94.43655,
                                -72.60088
                            ],
                            [
                                -94.45247,
                                -72.55395
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -73.64682,
                                -73.1478
                            ],
                            [
                                -73.87725,
                                -73.15063
                            ],
                            [
                                -73.91448,
                                -73.23389
                            ],
                            [
                                -74.07135,
                                -73.26035
                            ],
                            [
                                -74.18481,
                                -73.33899
                            ],
                            [
                                -74.09676,
                                -73.42896
                            ],
                            [
                                -73.86511,
                                -73.40813
                            ],
                            [
                                -73.6329,
                                -73.26254
                            ],
                            [
                                -73.64682,
                                -73.1478
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -145.22292,
                                -75.76713
                            ],
                            [
                                -145.23042,
                                -75.67116
                            ],
                            [
                                -145.66904,
                                -75.56419
                            ],
                            [
                                -145.91512,
                                -75.57553
                            ],
                            [
                                -145.93907,
                                -75.62736
                            ],
                            [
                                -145.56915,
                                -75.74354
                            ],
                            [
                                -145.22292,
                                -75.76713
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -67.24948,
                                -67.59904
                            ],
                            [
                                -67.4507,
                                -67.58976
                            ],
                            [
                                -67.68719,
                                -67.6187
                            ],
                            [
                                -67.84704,
                                -67.68316
                            ],
                            [
                                -67.68255,
                                -67.78827
                            ],
                            [
                                -67.53762,
                                -67.79745
                            ],
                            [
                                -67.36655,
                                -67.76785
                            ],
                            [
                                -67.15836,
                                -67.64233
                            ],
                            [
                                -67.24948,
                                -67.59904
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -146.76828,
                                -77.01477
                            ],
                            [
                                -146.37805,
                                -76.98007
                            ],
                            [
                                -146.29189,
                                -76.90349
                            ],
                            [
                                -146.74544,
                                -76.84889
                            ],
                            [
                                -147.00221,
                                -76.87781
                            ],
                            [
                                -146.91661,
                                -77.01331
                            ],
                            [
                                -146.76828,
                                -77.01477
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -148.46431,
                                -76.94817
                            ],
                            [
                                -148.57509,
                                -76.93304
                            ],
                            [
                                -149.15573,
                                -76.95
                            ],
                            [
                                -149.13712,
                                -77.02241
                            ],
                            [
                                -148.85899,
                                -77.05472
                            ],
                            [
                                -148.40263,
                                -77.04847
                            ],
                            [
                                -148.30688,
                                -76.98153
                            ],
                            [
                                -148.46431,
                                -76.94817
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -150.25645,
                                -76.81434
                            ],
                            [
                                -150.01727,
                                -76.78543
                            ],
                            [
                                -149.82872,
                                -76.71227
                            ],
                            [
                                -150.33217,
                                -76.69372
                            ],
                            [
                                -150.60262,
                                -76.71494
                            ],
                            [
                                -150.75951,
                                -76.76743
                            ],
                            [
                                -150.53314,
                                -76.81171
                            ],
                            [
                                -150.25645,
                                -76.81434
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                165.98732,
                                -78.16456
                            ],
                            [
                                166.05594,
                                -78.26637
                            ],
                            [
                                165.96019,
                                -78.31663
                            ],
                            [
                                166.12466,
                                -78.35284
                            ],
                            [
                                166.6234,
                                -78.29482
                            ],
                            [
                                166.49384,
                                -78.21119
                            ],
                            [
                                165.98732,
                                -78.16456
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -55.21225,
                                -61.01552
                            ],
                            [
                                -55.36229,
                                -61.02481
                            ],
                            [
                                -55.31214,
                                -61.0817
                            ],
                            [
                                -55.31783,
                                -61.16771
                            ],
                            [
                                -55.15485,
                                -61.22282
                            ],
                            [
                                -55.07438,
                                -61.15882
                            ],
                            [
                                -54.94599,
                                -61.10608
                            ],
                            [
                                -54.71883,
                                -61.10098
                            ],
                            [
                                -54.69469,
                                -61.03826
                            ],
                            [
                                -54.90885,
                                -61.05536
                            ],
                            [
                                -55.12925,
                                -61.01299
                            ],
                            [
                                -55.21225,
                                -61.01552
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -56.43696,
                                -62.98886
                            ],
                            [
                                -56.62859,
                                -63.0451
                            ],
                            [
                                -56.48478,
                                -63.13244
                            ],
                            [
                                -56.28809,
                                -63.18108
                            ],
                            [
                                -56.03646,
                                -63.0826
                            ],
                            [
                                -56.01629,
                                -63.03848
                            ],
                            [
                                -56.15551,
                                -62.99545
                            ],
                            [
                                -56.27427,
                                -63.00976
                            ],
                            [
                                -56.43696,
                                -62.98886
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -45.64141,
                                -60.53571
                            ],
                            [
                                -45.78431,
                                -60.58438
                            ],
                            [
                                -45.74086,
                                -60.64393
                            ],
                            [
                                -45.42072,
                                -60.65629
                            ],
                            [
                                -45.19092,
                                -60.73197
                            ],
                            [
                                -45.13143,
                                -60.68015
                            ],
                            [
                                -45.16853,
                                -60.63426
                            ],
                            [
                                -45.383,
                                -60.60835
                            ],
                            [
                                -45.45228,
                                -60.54082
                            ],
                            [
                                -45.55308,
                                -60.56214
                            ],
                            [
                                -45.64141,
                                -60.53571
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -60.64288,
                                -71.07498
                            ],
                            [
                                -60.47841,
                                -71.06192
                            ],
                            [
                                -60.40385,
                                -70.98196
                            ],
                            [
                                -60.46613,
                                -70.94013
                            ],
                            [
                                -60.69469,
                                -70.89758
                            ],
                            [
                                -60.97801,
                                -70.96001
                            ],
                            [
                                -60.93646,
                                -71.01506
                            ],
                            [
                                -60.64288,
                                -71.07498
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                169.79309,
                                -73.64186
                            ],
                            [
                                169.84656,
                                -73.57433
                            ],
                            [
                                169.71997,
                                -73.35628
                            ],
                            [
                                169.59499,
                                -73.37727
                            ],
                            [
                                169.60359,
                                -73.46105
                            ],
                            [
                                169.38243,
                                -73.56422
                            ],
                            [
                                169.5565,
                                -73.59835
                            ],
                            [
                                169.62517,
                                -73.65749
                            ],
                            [
                                169.79309,
                                -73.64186
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -146.80104,
                                -76.75159
                            ],
                            [
                                -146.82417,
                                -76.61684
                            ],
                            [
                                -147.15509,
                                -76.54486
                            ],
                            [
                                -147.33781,
                                -76.59945
                            ],
                            [
                                -147.13963,
                                -76.72456
                            ],
                            [
                                -146.80104,
                                -76.75159
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                103.4763,
                                -65.43519
                            ],
                            [
                                103.22336,
                                -65.32027
                            ],
                            [
                                103.19299,
                                -65.24807
                            ],
                            [
                                103.08941,
                                -65.184
                            ],
                            [
                                102.92123,
                                -65.12019
                            ],
                            [
                                102.78807,
                                -65.18244
                            ],
                            [
                                102.85903,
                                -65.23656
                            ],
                            [
                                103.08673,
                                -65.28949
                            ],
                            [
                                103.17722,
                                -65.36597
                            ],
                            [
                                103.17117,
                                -65.43268
                            ],
                            [
                                103.30605,
                                -65.46268
                            ],
                            [
                                103.4763,
                                -65.43519
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -104.29404,
                                -73.3509
                            ],
                            [
                                -104.3195,
                                -73.28003
                            ],
                            [
                                -104.43629,
                                -73.22465
                            ],
                            [
                                -104.82177,
                                -73.11212
                            ],
                            [
                                -104.91649,
                                -73.12385
                            ],
                            [
                                -104.82545,
                                -73.22057
                            ],
                            [
                                -104.44575,
                                -73.35556
                            ],
                            [
                                -104.29404,
                                -73.3509
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -55.90118,
                                -63.38916
                            ],
                            [
                                -56.05297,
                                -63.39289
                            ],
                            [
                                -56.2011,
                                -63.4269
                            ],
                            [
                                -56.2417,
                                -63.48463
                            ],
                            [
                                -56.14949,
                                -63.54052
                            ],
                            [
                                -55.93532,
                                -63.56944
                            ],
                            [
                                -55.75682,
                                -63.51197
                            ],
                            [
                                -55.68356,
                                -63.44912
                            ],
                            [
                                -55.72118,
                                -63.41379
                            ],
                            [
                                -55.90118,
                                -63.38916
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -60.74471,
                                -70.72031
                            ],
                            [
                                -60.60445,
                                -70.64814
                            ],
                            [
                                -60.61969,
                                -70.57021
                            ],
                            [
                                -60.77898,
                                -70.50439
                            ],
                            [
                                -60.87565,
                                -70.51571
                            ],
                            [
                                -61.02945,
                                -70.59891
                            ],
                            [
                                -60.95929,
                                -70.68446
                            ],
                            [
                                -60.74471,
                                -70.72031
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -132.42627,
                                -74.33649
                            ],
                            [
                                -132.7072,
                                -74.33829
                            ],
                            [
                                -132.7534,
                                -74.46941
                            ],
                            [
                                -132.4726,
                                -74.49734
                            ],
                            [
                                -132.28041,
                                -74.46302
                            ],
                            [
                                -132.42627,
                                -74.33649
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -56.9209,
                                -64.35699
                            ],
                            [
                                -57.1181,
                                -64.36407
                            ],
                            [
                                -57.28952,
                                -64.42526
                            ],
                            [
                                -57.50091,
                                -64.44522
                            ],
                            [
                                -57.49816,
                                -64.5118
                            ],
                            [
                                -57.30304,
                                -64.54366
                            ],
                            [
                                -57.04942,
                                -64.48822
                            ],
                            [
                                -56.9209,
                                -64.35699
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                164.73875,
                                -67.62391
                            ],
                            [
                                164.82579,
                                -67.57053
                            ],
                            [
                                164.75627,
                                -67.46542
                            ],
                            [
                                164.61877,
                                -67.34692
                            ],
                            [
                                164.49217,
                                -67.4155
                            ],
                            [
                                164.48801,
                                -67.48795
                            ],
                            [
                                164.58707,
                                -67.60641
                            ],
                            [
                                164.73875,
                                -67.62391
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -57.61813,
                                -63.79702
                            ],
                            [
                                -57.7194,
                                -63.81068
                            ],
                            [
                                -57.62151,
                                -63.90306
                            ],
                            [
                                -57.52488,
                                -63.87633
                            ],
                            [
                                -57.2881,
                                -63.87588
                            ],
                            [
                                -57.19872,
                                -63.89695
                            ],
                            [
                                -57.05633,
                                -63.83238
                            ],
                            [
                                -57.34031,
                                -63.78593
                            ],
                            [
                                -57.61813,
                                -63.79702
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -61.15857,
                                -69.95725
                            ],
                            [
                                -61.04435,
                                -69.93194
                            ],
                            [
                                -60.97747,
                                -69.86469
                            ],
                            [
                                -61.22522,
                                -69.80837
                            ],
                            [
                                -61.41597,
                                -69.89465
                            ],
                            [
                                -61.31588,
                                -69.94898
                            ],
                            [
                                -61.15857,
                                -69.95725
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                162.45044,
                                -66.53761
                            ],
                            [
                                162.45978,
                                -66.45237
                            ],
                            [
                                162.19365,
                                -66.27192
                            ],
                            [
                                162.12476,
                                -66.32596
                            ],
                            [
                                162.13908,
                                -66.40566
                            ],
                            [
                                162.28658,
                                -66.49893
                            ],
                            [
                                162.45044,
                                -66.53761
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                48.85411,
                                -66.69887
                            ],
                            [
                                48.45682,
                                -66.7178
                            ],
                            [
                                48.34277,
                                -66.77334
                            ],
                            [
                                48.57955,
                                -66.77985
                            ],
                            [
                                48.8618,
                                -66.8123
                            ],
                            [
                                48.94995,
                                -66.76321
                            ],
                            [
                                48.85411,
                                -66.69887
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -149.36052,
                                -77.29446
                            ],
                            [
                                -149.57216,
                                -77.32949
                            ],
                            [
                                -149.24086,
                                -77.38818
                            ],
                            [
                                -148.85129,
                                -77.39395
                            ],
                            [
                                -149.10744,
                                -77.30315
                            ],
                            [
                                -149.36052,
                                -77.29446
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -147.48601,
                                -76.71354
                            ],
                            [
                                -147.48549,
                                -76.66933
                            ],
                            [
                                -147.75807,
                                -76.59342
                            ],
                            [
                                -148.02477,
                                -76.6216
                            ],
                            [
                                -147.84779,
                                -76.683
                            ],
                            [
                                -147.48601,
                                -76.71354
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -66.60823,
                                -66.09642
                            ],
                            [
                                -66.82515,
                                -66.11867
                            ],
                            [
                                -66.81446,
                                -66.31448
                            ],
                            [
                                -66.62627,
                                -66.21348
                            ],
                            [
                                -66.60823,
                                -66.09642
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                92.66708,
                                -65.78976
                            ],
                            [
                                92.70522,
                                -65.72813
                            ],
                            [
                                92.52404,
                                -65.67229
                            ],
                            [
                                92.35839,
                                -65.68045
                            ],
                            [
                                92.2868,
                                -65.738
                            ],
                            [
                                92.42356,
                                -65.79634
                            ],
                            [
                                92.66708,
                                -65.78976
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                71.93153,
                                -70.35098
                            ],
                            [
                                71.97238,
                                -70.28484
                            ],
                            [
                                71.80373,
                                -70.12914
                            ],
                            [
                                71.66978,
                                -70.13441
                            ],
                            [
                                71.69412,
                                -70.21863
                            ],
                            [
                                71.79559,
                                -70.30877
                            ],
                            [
                                71.93153,
                                -70.35098
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -67.32526,
                                -66.87603
                            ],
                            [
                                -67.24864,
                                -66.81078
                            ],
                            [
                                -67.45838,
                                -66.72582
                            ],
                            [
                                -67.59053,
                                -66.90093
                            ],
                            [
                                -67.47642,
                                -66.91301
                            ],
                            [
                                -67.32526,
                                -66.87603
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -90.61376,
                                -68.89146
                            ],
                            [
                                -90.46724,
                                -68.87476
                            ],
                            [
                                -90.48981,
                                -68.74422
                            ],
                            [
                                -90.61816,
                                -68.71242
                            ],
                            [
                                -90.72401,
                                -68.77104
                            ],
                            [
                                -90.69325,
                                -68.87598
                            ],
                            [
                                -90.61376,
                                -68.89146
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                86.7446,
                                -66.77079
                            ],
                            [
                                86.93091,
                                -66.72817
                            ],
                            [
                                86.79681,
                                -66.67101
                            ],
                            [
                                86.63313,
                                -66.65713
                            ],
                            [
                                86.51887,
                                -66.72183
                            ],
                            [
                                86.62772,
                                -66.77145
                            ],
                            [
                                86.7446,
                                -66.77079
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -93.88872,
                                -72.80979
                            ],
                            [
                                -94.18283,
                                -72.81413
                            ],
                            [
                                -94.15671,
                                -72.87151
                            ],
                            [
                                -93.77788,
                                -72.92284
                            ],
                            [
                                -93.77547,
                                -72.85741
                            ],
                            [
                                -93.88872,
                                -72.80979
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                47.7112,
                                -67.6161
                            ],
                            [
                                47.56132,
                                -67.54354
                            ],
                            [
                                47.41989,
                                -67.62399
                            ],
                            [
                                47.47209,
                                -67.6544
                            ],
                            [
                                47.71729,
                                -67.64912
                            ],
                            [
                                47.7112,
                                -67.6161
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                97.41733,
                                -66.38051
                            ],
                            [
                                97.40833,
                                -66.32301
                            ],
                            [
                                97.20979,
                                -66.30304
                            ],
                            [
                                97.09187,
                                -66.35571
                            ],
                            [
                                97.2317,
                                -66.42245
                            ],
                            [
                                97.41733,
                                -66.38051
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -60.73732,
                                -63.68179
                            ],
                            [
                                -60.80247,
                                -63.75146
                            ],
                            [
                                -60.78199,
                                -63.80946
                            ],
                            [
                                -60.90197,
                                -63.88679
                            ],
                            [
                                -60.7117,
                                -63.88675
                            ],
                            [
                                -60.71466,
                                -63.82188
                            ],
                            [
                                -60.58297,
                                -63.68461
                            ],
                            [
                                -60.73732,
                                -63.68179
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -59.72662,
                                -65.11477
                            ],
                            [
                                -59.86114,
                                -65.13193
                            ],
                            [
                                -59.76062,
                                -65.2016
                            ],
                            [
                                -59.63036,
                                -65.22174
                            ],
                            [
                                -59.47779,
                                -65.19936
                            ],
                            [
                                -59.60399,
                                -65.12537
                            ],
                            [
                                -59.72662,
                                -65.11477
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -60.04276,
                                -72.1664
                            ],
                            [
                                -60.36096,
                                -72.1758
                            ],
                            [
                                -60.2941,
                                -72.23468
                            ],
                            [
                                -60.07327,
                                -72.26511
                            ],
                            [
                                -59.95464,
                                -72.23257
                            ],
                            [
                                -60.04276,
                                -72.1664
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -62.3109,
                                -62.87363
                            ],
                            [
                                -62.36867,
                                -62.86864
                            ],
                            [
                                -62.55518,
                                -62.93483
                            ],
                            [
                                -62.73918,
                                -63.09088
                            ],
                            [
                                -62.57589,
                                -63.05946
                            ],
                            [
                                -62.44332,
                                -62.99287
                            ],
                            [
                                -62.3109,
                                -62.87363
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -153.85124,
                                -77.19954
                            ],
                            [
                                -153.77769,
                                -77.1631
                            ],
                            [
                                -154.04483,
                                -77.11809
                            ],
                            [
                                -154.27037,
                                -77.1702
                            ],
                            [
                                -153.85124,
                                -77.19954
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -116.72668,
                                -74.24741
                            ],
                            [
                                -117.13594,
                                -74.28772
                            ],
                            [
                                -117.12879,
                                -74.35
                            ],
                            [
                                -116.79911,
                                -74.30397
                            ],
                            [
                                -116.72668,
                                -74.24741
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -59.03344,
                                -62.23008
                            ],
                            [
                                -59.24296,
                                -62.28028
                            ],
                            [
                                -59.12441,
                                -62.34108
                            ],
                            [
                                -58.84127,
                                -62.30119
                            ],
                            [
                                -58.89724,
                                -62.25594
                            ],
                            [
                                -59.03344,
                                -62.23008
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -59.6448,
                                -64.59291
                            ],
                            [
                                -59.59134,
                                -64.53892
                            ],
                            [
                                -59.6895,
                                -64.42706
                            ],
                            [
                                -59.84019,
                                -64.5271
                            ],
                            [
                                -59.73909,
                                -64.58596
                            ],
                            [
                                -59.6448,
                                -64.59291
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -59.78661,
                                -62.44753
                            ],
                            [
                                -60.04095,
                                -62.4457
                            ],
                            [
                                -59.90538,
                                -62.51509
                            ],
                            [
                                -59.67204,
                                -62.55236
                            ],
                            [
                                -59.58974,
                                -62.49768
                            ],
                            [
                                -59.78661,
                                -62.44753
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -59.47411,
                                -62.36147
                            ],
                            [
                                -59.58084,
                                -62.33164
                            ],
                            [
                                -59.69544,
                                -62.35065
                            ],
                            [
                                -59.63425,
                                -62.42102
                            ],
                            [
                                -59.518,
                                -62.45618
                            ],
                            [
                                -59.36655,
                                -62.4071
                            ],
                            [
                                -59.47411,
                                -62.36147
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -60.61332,
                                -63.01599
                            ],
                            [
                                -60.51523,
                                -62.9833
                            ],
                            [
                                -60.55111,
                                -62.89436
                            ],
                            [
                                -60.75817,
                                -62.92071
                            ],
                            [
                                -60.76502,
                                -62.97052
                            ],
                            [
                                -60.61332,
                                -63.01599
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -62.12521,
                                -63.23924
                            ],
                            [
                                -62.24272,
                                -63.25635
                            ],
                            [
                                -62.14445,
                                -63.33879
                            ],
                            [
                                -61.93629,
                                -63.30151
                            ],
                            [
                                -61.97829,
                                -63.25854
                            ],
                            [
                                -62.12521,
                                -63.23924
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -147.17009,
                                -77.19396
                            ],
                            [
                                -147.46497,
                                -77.19984
                            ],
                            [
                                -147.28409,
                                -77.28249
                            ],
                            [
                                -147.02148,
                                -77.22022
                            ],
                            [
                                -147.17009,
                                -77.19396
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -66.83632,
                                -67.51264
                            ],
                            [
                                -67.16997,
                                -67.52303
                            ],
                            [
                                -67.10828,
                                -67.59903
                            ],
                            [
                                -66.95586,
                                -67.57392
                            ],
                            [
                                -66.83632,
                                -67.51264
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -93.16516,
                                -72.62411
                            ],
                            [
                                -93.104,
                                -72.52805
                            ],
                            [
                                -93.25191,
                                -72.52604
                            ],
                            [
                                -93.37006,
                                -72.59078
                            ],
                            [
                                -93.16516,
                                -72.62411
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -61.36746,
                                -62.71234
                            ],
                            [
                                -61.53218,
                                -62.75196
                            ],
                            [
                                -61.54818,
                                -62.8109
                            ],
                            [
                                -61.43374,
                                -62.83822
                            ],
                            [
                                -61.26009,
                                -62.76881
                            ],
                            [
                                -61.36746,
                                -62.71234
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -63.28172,
                                -64.79216
                            ],
                            [
                                -63.46516,
                                -64.80236
                            ],
                            [
                                -63.35126,
                                -64.8623
                            ],
                            [
                                -63.28172,
                                -64.79216
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -54.01994,
                                -61.24417
                            ],
                            [
                                -54.07822,
                                -61.15973
                            ],
                            [
                                -54.17315,
                                -61.21455
                            ],
                            [
                                -54.01994,
                                -61.24417
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -56.61345,
                                -64.24915
                            ],
                            [
                                -56.82416,
                                -64.24591
                            ],
                            [
                                -56.88261,
                                -64.3308
                            ],
                            [
                                -56.71725,
                                -64.3134
                            ],
                            [
                                -56.61345,
                                -64.24915
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -143.15265,
                                -75.4873
                            ],
                            [
                                -143.30684,
                                -75.52307
                            ],
                            [
                                -143.16679,
                                -75.57021
                            ],
                            [
                                -142.98314,
                                -75.53288
                            ],
                            [
                                -143.15265,
                                -75.4873
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                85.46584,
                                -66.62417
                            ],
                            [
                                85.57973,
                                -66.59316
                            ],
                            [
                                85.43047,
                                -66.5234
                            ],
                            [
                                85.38569,
                                -66.61659
                            ],
                            [
                                85.46584,
                                -66.62417
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "ATG",
                "Country": "Antigua and Barbuda",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    6.2332e-09,
                    1.0793e-08,
                    1.3956e-08,
                    1.5762e-08,
                    1.6245e-08,
                    1.582e-08,
                    1.4497e-08,
                    1.2263e-08,
                    9.2461e-09,
                    5.55e-09,
                    1.3154e-09,
                    -0.000000003544,
                    -0.0000000089654,
                    -0.00000001498,
                    -0.000000021622,
                    -0.000000028995,
                    -0.000000036986,
                    -0.000000045626,
                    -0.000000054949,
                    -0.0000000647,
                    -0.000000073986,
                    -0.000000083018,
                    -0.000000091888,
                    -0.00000010056,
                    -0.00000010907,
                    -0.00000011771,
                    -0.0000001265,
                    -0.00000013543,
                    -0.0000001445,
                    -0.00000015334,
                    -0.00000016172,
                    -0.00000016939,
                    -0.0000001765,
                    -0.00000018323,
                    -0.00000018947,
                    -0.00000019523,
                    -0.00000020047,
                    -0.00000020523,
                    -0.00000020941,
                    -0.00000021308,
                    -0.00000021712,
                    -0.00000022143,
                    -0.00000022595,
                    -0.00000023069,
                    -0.00000023565,
                    -0.00000024088,
                    -0.00000024634,
                    -0.00000025194,
                    -0.00000025769,
                    -0.00000026387,
                    -0.00000027032,
                    -0.00000027722,
                    -0.0000002845,
                    -0.00000029201,
                    -0.00000029966,
                    -0.00000030747,
                    -0.00000031555,
                    -0.00000032383,
                    -0.00000033228,
                    -0.00000034202,
                    -0.00000035283,
                    -0.00000036477,
                    -0.00000037782,
                    -0.00000039204,
                    -0.00000040739,
                    -0.00000042379,
                    -0.00000044125,
                    -0.00000045973,
                    -0.00000047925,
                    -0.0000004985,
                    -0.0000005172,
                    -0.00000053525,
                    -0.00000055275,
                    -0.00000056974,
                    -0.00000058623,
                    -0.00000060218,
                    -0.00000061761,
                    -0.00000063252,
                    -0.00000064693,
                    -0.00000066016,
                    -0.00000067146,
                    -0.00000068097,
                    -0.00000068875,
                    -0.00000069489,
                    -0.00000069933,
                    -0.00000070222,
                    -0.00000070364,
                    -0.0000007035,
                    -0.00000070184,
                    -0.00000069743,
                    -0.00000069103,
                    -0.00000068295,
                    -0.00000067347,
                    -0.00000066248,
                    -0.00000064909,
                    -0.00000063309,
                    -0.00000061443,
                    -0.00000059309,
                    -0.000000569,
                    -0.00000053502,
                    -0.00000049866,
                    -0.00000046244,
                    -0.00000042622,
                    -0.00000038914,
                    -0.00000035112,
                    -0.00000031214,
                    -0.00000026226,
                    -0.00000020763,
                    -0.00000015166,
                    -0.000000089629,
                    -0.000000024026,
                    1.0525e-07,
                    2.0539e-07,
                    3.6561e-07,
                    5.2213e-07,
                    7.5354e-07,
                    1.0823e-06,
                    1.6392e-06,
                    2.3009e-06,
                    2.5842e-06,
                    2.8391e-06,
                    3.0672e-06,
                    3.2735e-06,
                    3.5228e-06,
                    3.8978e-06,
                    4.1355e-06,
                    4.4022e-06,
                    4.6882e-06,
                    4.9475e-06,
                    5.0941e-06,
                    5.2201e-06,
                    5.4305e-06,
                    5.5626e-06,
                    5.7388e-06,
                    5.9383e-06,
                    6.1241e-06,
                    6.3121e-06,
                    6.4965e-06,
                    6.6663e-06,
                    6.8254e-06,
                    6.9786e-06,
                    7.1327e-06,
                    7.2918e-06,
                    7.4587e-06,
                    7.6282e-06,
                    7.8045e-06,
                    7.9913e-06,
                    8.1765e-06,
                    8.3623e-06,
                    8.5455e-06,
                    8.7367e-06,
                    8.9431e-06,
                    9.1624e-06,
                    9.3934e-06,
                    9.6323e-06,
                    9.8905e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    4.304e-09,
                    8.1046e-09,
                    1.1613e-08,
                    1.4831e-08,
                    1.776e-08,
                    2.0688e-08,
                    2.3621e-08,
                    2.6562e-08,
                    2.9514e-08,
                    3.2483e-08,
                    3.5462e-08,
                    3.8436e-08,
                    4.142e-08,
                    4.4404e-08,
                    4.7226e-08,
                    4.989e-08,
                    5.2396e-08,
                    5.4748e-08,
                    5.6877e-08,
                    5.8787e-08,
                    6.1122e-08,
                    6.3784e-08,
                    6.658e-08,
                    6.951e-08,
                    7.2552e-08,
                    7.5436e-08,
                    7.8161e-08,
                    8.07e-08,
                    8.3051e-08,
                    8.5212e-08,
                    8.7332e-08,
                    8.9665e-08,
                    9.2084e-08,
                    9.4465e-08,
                    9.6908e-08,
                    9.9412e-08,
                    1.0205e-07,
                    1.0478e-07,
                    1.0773e-07,
                    1.112e-07,
                    1.1459e-07,
                    1.1798e-07,
                    1.214e-07,
                    1.2483e-07,
                    1.2828e-07,
                    1.3174e-07,
                    1.352e-07,
                    1.3872e-07,
                    1.4229e-07,
                    1.4556e-07,
                    1.4881e-07,
                    1.5183e-07,
                    1.5471e-07,
                    1.5759e-07,
                    1.6051e-07,
                    1.6348e-07,
                    1.6641e-07,
                    1.6935e-07,
                    1.7223e-07,
                    1.7476e-07,
                    1.771e-07,
                    1.7917e-07,
                    1.8096e-07,
                    1.8239e-07,
                    1.8348e-07,
                    1.8424e-07,
                    1.8467e-07,
                    1.8477e-07,
                    1.8452e-07,
                    1.8427e-07,
                    1.8401e-07,
                    1.8388e-07,
                    1.8381e-07,
                    1.8377e-07,
                    1.8377e-07,
                    1.8389e-07,
                    1.841e-07,
                    1.8443e-07,
                    1.8488e-07,
                    1.8548e-07,
                    1.8671e-07,
                    1.8851e-07,
                    1.9088e-07,
                    1.9382e-07,
                    1.9735e-07,
                    2.0146e-07,
                    2.0614e-07,
                    2.1143e-07,
                    2.174e-07,
                    2.2397e-07,
                    2.3121e-07,
                    2.3903e-07,
                    2.4729e-07,
                    2.5613e-07,
                    2.6652e-07,
                    2.7867e-07,
                    2.9271e-07,
                    3.0864e-07,
                    3.266e-07,
                    3.4674e-07,
                    3.6937e-07,
                    3.9443e-07,
                    4.2166e-07,
                    4.5089e-07,
                    4.8212e-07,
                    5.1521e-07,
                    5.6013e-07,
                    6.1042e-07,
                    6.6285e-07,
                    7.2116e-07,
                    7.8708e-07,
                    8.8103e-07,
                    9.7017e-07,
                    1.0664e-06,
                    1.1924e-06,
                    1.4111e-06,
                    1.7307e-06,
                    2.2454e-06,
                    2.8837e-06,
                    3.1508e-06,
                    3.4096e-06,
                    3.6433e-06,
                    3.8562e-06,
                    4.1127e-06,
                    4.4945e-06,
                    4.7381e-06,
                    5.0093e-06,
                    5.2908e-06,
                    5.5324e-06,
                    5.6529e-06,
                    5.7531e-06,
                    5.9341e-06,
                    6.0149e-06,
                    6.1192e-06,
                    6.2642e-06,
                    6.4022e-06,
                    6.5461e-06,
                    6.6892e-06,
                    6.8269e-06,
                    6.9552e-06,
                    7.0775e-06,
                    7.2001e-06,
                    7.3262e-06,
                    7.4581e-06,
                    7.592e-06,
                    7.7353e-06,
                    7.89e-06,
                    8.0508e-06,
                    8.2226e-06,
                    8.3996e-06,
                    8.5823e-06,
                    8.7814e-06,
                    8.9924e-06,
                    9.2137e-06,
                    9.4494e-06,
                    9.7034e-06,
                    9.9669e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_3GHG": -0,
                "Land_3GHG_timeseries": [
                    1.9292e-09,
                    2.6881e-09,
                    2.3424e-09,
                    9.3045e-10,
                    -0.0000000015152,
                    -0.0000000048683,
                    -0.000000009124,
                    -0.000000014299,
                    -0.000000020268,
                    -0.000000026933,
                    -0.000000034146,
                    -0.00000004198,
                    -0.000000050385,
                    -0.000000059384,
                    -0.000000068849,
                    -0.000000078885,
                    -0.000000089382,
                    -0.00000010037,
                    -0.00000011183,
                    -0.00000012349,
                    -0.00000013511,
                    -0.0000001468,
                    -0.00000015847,
                    -0.00000017007,
                    -0.00000018163,
                    -0.00000019315,
                    -0.00000020466,
                    -0.00000021613,
                    -0.00000022756,
                    -0.00000023856,
                    -0.00000024905,
                    -0.00000025906,
                    -0.00000026858,
                    -0.0000002777,
                    -0.00000028638,
                    -0.00000029465,
                    -0.00000030252,
                    -0.00000031001,
                    -0.00000031714,
                    -0.00000032428,
                    -0.00000033171,
                    -0.0000003394,
                    -0.00000034735,
                    -0.00000035552,
                    -0.00000036393,
                    -0.00000037262,
                    -0.00000038155,
                    -0.00000039066,
                    -0.00000039998,
                    -0.00000040943,
                    -0.00000041912,
                    -0.00000042905,
                    -0.00000043921,
                    -0.0000004496,
                    -0.00000046017,
                    -0.00000047094,
                    -0.00000048196,
                    -0.00000049317,
                    -0.00000050451,
                    -0.00000051678,
                    -0.00000052993,
                    -0.00000054394,
                    -0.00000055877,
                    -0.00000057443,
                    -0.00000059086,
                    -0.00000060804,
                    -0.00000062592,
                    -0.00000064451,
                    -0.00000066377,
                    -0.00000068276,
                    -0.00000070121,
                    -0.00000071913,
                    -0.00000073656,
                    -0.00000075352,
                    -0.00000077,
                    -0.00000078607,
                    -0.00000080171,
                    -0.00000081696,
                    -0.00000083181,
                    -0.00000084563,
                    -0.00000085817,
                    -0.00000086948,
                    -0.00000087963,
                    -0.00000088872,
                    -0.00000089669,
                    -0.00000090368,
                    -0.00000090977,
                    -0.00000091493,
                    -0.00000091924,
                    -0.0000009214,
                    -0.00000092223,
                    -0.00000092198,
                    -0.00000092075,
                    -0.00000091861,
                    -0.00000091561,
                    -0.00000091177,
                    -0.00000090713,
                    -0.00000090173,
                    -0.0000008956,
                    -0.00000088176,
                    -0.00000086803,
                    -0.00000085687,
                    -0.00000084788,
                    -0.00000084003,
                    -0.00000083324,
                    -0.00000082735,
                    -0.00000082239,
                    -0.00000081805,
                    -0.00000081451,
                    -0.00000081078,
                    -0.00000081111,
                    -0.00000077577,
                    -0.00000076478,
                    -0.00000070079,
                    -0.00000067024,
                    -0.00000065752,
                    -0.0000006484,
                    -0.0000006062,
                    -0.00000058286,
                    -0.00000056664,
                    -0.00000057058,
                    -0.0000005761,
                    -0.00000058274,
                    -0.0000005899,
                    -0.00000059662,
                    -0.00000060259,
                    -0.00000060711,
                    -0.0000006026,
                    -0.00000058496,
                    -0.00000055884,
                    -0.00000053306,
                    -0.00000050362,
                    -0.00000045223,
                    -0.0000003804,
                    -0.00000032583,
                    -0.00000027803,
                    -0.00000023403,
                    -0.00000019263,
                    -0.00000016061,
                    -0.00000012985,
                    -0.000000098877,
                    -0.000000067393,
                    -0.000000034452,
                    5.9951e-10,
                    3.6259e-08,
                    6.9159e-08,
                    1.013e-07,
                    1.2572e-07,
                    1.3965e-07,
                    1.4585e-07,
                    1.5438e-07,
                    1.6165e-07,
                    1.7009e-07,
                    1.7966e-07,
                    1.8286e-07,
                    1.8705e-07,
                    1.9206e-07,
                    1.9811e-07,
                    2.081e-07,
                    1.8063e-07,
                    1.5182e-07,
                    1.2355e-07,
                    9.7798e-08,
                    6.8831e-08,
                    3.8789e-08,
                    1.126e-08,
                    -0.000000012669,
                    -0.000000039596,
                    -0.000000071829,
                    -0.00000010475,
                    -0.00000014035,
                    -0.00000017764
                ],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    -0.000000001903,
                    -0.0000000047245,
                    -0.0000000083985,
                    -0.000000012886,
                    -0.000000018156,
                    -0.000000024079,
                    -0.000000030652,
                    -0.00000003789,
                    -0.000000045667,
                    -0.000000053884,
                    -0.000000062502,
                    -0.000000071593,
                    -0.000000081109,
                    -0.000000091069,
                    -0.00000010135,
                    -0.00000011205,
                    -0.00000012307,
                    -0.00000013443,
                    -0.00000014611,
                    -0.00000015784,
                    -0.00000016963,
                    -0.00000018159,
                    -0.00000019362,
                    -0.00000020569,
                    -0.00000021782,
                    -0.00000023002,
                    -0.00000024231,
                    -0.00000025467,
                    -0.00000026709,
                    -0.00000027917,
                    -0.0000002909,
                    -0.00000030227,
                    -0.00000031332,
                    -0.00000032409,
                    -0.00000033458,
                    -0.00000034478,
                    -0.00000035474,
                    -0.00000036447,
                    -0.00000037397,
                    -0.00000038363,
                    -0.00000039351,
                    -0.00000040362,
                    -0.00000041392,
                    -0.00000042439,
                    -0.00000043505,
                    -0.00000044594,
                    -0.00000045701,
                    -0.00000046822,
                    -0.00000047958,
                    -0.00000049102,
                    -0.00000050261,
                    -0.00000051435,
                    -0.00000052623,
                    -0.00000053825,
                    -0.00000055038,
                    -0.00000056261,
                    -0.00000057501,
                    -0.00000058751,
                    -0.00000060005,
                    -0.00000061344,
                    -0.00000062749,
                    -0.00000064219,
                    -0.0000006575,
                    -0.00000067342,
                    -0.0000006899,
                    -0.00000070691,
                    -0.00000072442,
                    -0.00000074241,
                    -0.00000076086,
                    -0.00000077883,
                    -0.00000079635,
                    -0.00000081343,
                    -0.00000083011,
                    -0.00000084641,
                    -0.00000086232,
                    -0.00000087792,
                    -0.00000089317,
                    -0.00000090811,
                    -0.00000092276,
                    -0.00000093646,
                    -0.0000009494,
                    -0.00000096167,
                    -0.0000009733,
                    -0.0000009844,
                    -0.00000099491,
                    -0.0000010049,
                    -0.0000010144,
                    -0.0000010235,
                    -0.0000010321,
                    -0.000001039,
                    -0.000001045,
                    -0.0000010503,
                    -0.000001055,
                    -0.0000010592,
                    -0.000001063,
                    -0.0000010663,
                    -0.0000010693,
                    -0.000001072,
                    -0.0000010742,
                    -0.0000010692,
                    -0.0000010649,
                    -0.0000010636,
                    -0.0000010647,
                    -0.0000010671,
                    -0.0000010704,
                    -0.0000010746,
                    -0.0000010697,
                    -0.000001062,
                    -0.000001055,
                    -0.0000010445,
                    -0.0000010335,
                    -0.00000096231,
                    -0.00000092366,
                    -0.00000083209,
                    -0.00000074737,
                    -0.00000059022,
                    -0.00000034011,
                    1.3335e-07,
                    7.0707e-07,
                    9.156e-07,
                    1.0868e-06,
                    1.2345e-06,
                    1.3621e-06,
                    1.5352e-06,
                    1.8344e-06,
                    1.997e-06,
                    2.1884e-06,
                    2.3923e-06,
                    2.559e-06,
                    2.6071e-06,
                    2.6395e-06,
                    2.7567e-06,
                    2.802e-06,
                    2.899e-06,
                    3.0177e-06,
                    3.1287e-06,
                    3.2484e-06,
                    3.3716e-06,
                    3.4942e-06,
                    3.5965e-06,
                    3.702e-06,
                    3.8075e-06,
                    3.9165e-06,
                    4.0304e-06,
                    4.1461e-06,
                    4.2702e-06,
                    4.4044e-06,
                    4.5438e-06,
                    4.6932e-06,
                    4.8481e-06,
                    5.0096e-06,
                    5.1883e-06,
                    5.3771e-06,
                    5.5755e-06,
                    5.7872e-06,
                    6.0163e-06,
                    6.2551e-06,
                    6.4969e-06,
                    6.7449e-06,
                    6.9893e-06,
                    7.2318e-06,
                    7.4798e-06,
                    7.7312e-06,
                    7.9853e-06,
                    8.2451e-06,
                    8.5117e-06,
                    8.7847e-06,
                    9.0602e-06,
                    9.3466e-06,
                    9.623e-06,
                    9.8892e-06,
                    0
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    9.9e-09,
                    2.31e-08,
                    3.63e-08,
                    5.28e-08,
                    7.425e-08,
                    1.2045e-07,
                    1.584e-07,
                    1.9965e-07,
                    2.673e-07,
                    4.2405e-07,
                    6.7815e-07,
                    1.1237e-06,
                    1.6896e-06,
                    1.8975e-06,
                    2.0889e-06,
                    2.2572e-06,
                    2.4057e-06,
                    2.5987e-06,
                    2.9172e-06,
                    3.0987e-06,
                    3.3083e-06,
                    3.5293e-06,
                    3.7125e-06,
                    3.7769e-06,
                    3.8247e-06,
                    3.9567e-06,
                    3.9946e-06,
                    4.0606e-06,
                    4.1729e-06,
                    4.285e-06,
                    4.4088e-06,
                    4.5375e-06,
                    4.6662e-06,
                    4.7751e-06,
                    4.8873e-06,
                    4.9995e-06,
                    5.115e-06,
                    5.2354e-06,
                    5.3576e-06,
                    5.4879e-06,
                    5.6281e-06,
                    5.7734e-06,
                    5.9284e-06,
                    6.0885e-06,
                    6.2551e-06,
                    6.4383e-06,
                    6.6313e-06,
                    6.8343e-06,
                    7.0505e-06,
                    7.2831e-06,
                    7.524e-06,
                    7.7665e-06,
                    8.0174e-06,
                    8.2648e-06,
                    8.5107e-06,
                    8.7615e-06,
                    9.0123e-06,
                    9.2681e-06,
                    9.5304e-06,
                    9.7993e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CO2": -0,
                "Land_CO2_timeseries": [
                    -0.000000001903,
                    -0.0000000047245,
                    -0.0000000083985,
                    -0.000000012886,
                    -0.000000018156,
                    -0.000000024079,
                    -0.000000030652,
                    -0.00000003789,
                    -0.000000045667,
                    -0.000000053884,
                    -0.000000062502,
                    -0.000000071593,
                    -0.000000081109,
                    -0.000000091069,
                    -0.00000010135,
                    -0.00000011205,
                    -0.00000012307,
                    -0.00000013443,
                    -0.00000014611,
                    -0.00000015784,
                    -0.00000016963,
                    -0.00000018159,
                    -0.00000019362,
                    -0.00000020569,
                    -0.00000021782,
                    -0.00000023002,
                    -0.00000024231,
                    -0.00000025467,
                    -0.00000026709,
                    -0.00000027917,
                    -0.0000002909,
                    -0.00000030227,
                    -0.00000031332,
                    -0.00000032409,
                    -0.00000033458,
                    -0.00000034478,
                    -0.00000035474,
                    -0.00000036447,
                    -0.00000037397,
                    -0.00000038363,
                    -0.00000039351,
                    -0.00000040362,
                    -0.00000041392,
                    -0.00000042439,
                    -0.00000043505,
                    -0.00000044594,
                    -0.00000045701,
                    -0.00000046822,
                    -0.00000047958,
                    -0.00000049102,
                    -0.00000050261,
                    -0.00000051435,
                    -0.00000052623,
                    -0.00000053825,
                    -0.00000055038,
                    -0.00000056261,
                    -0.00000057501,
                    -0.00000058751,
                    -0.00000060005,
                    -0.00000061344,
                    -0.00000062749,
                    -0.00000064219,
                    -0.0000006575,
                    -0.00000067342,
                    -0.0000006899,
                    -0.00000070691,
                    -0.00000072442,
                    -0.00000074241,
                    -0.00000076086,
                    -0.00000077883,
                    -0.00000079635,
                    -0.00000081343,
                    -0.00000083011,
                    -0.00000084641,
                    -0.00000086232,
                    -0.00000087792,
                    -0.00000089317,
                    -0.00000090811,
                    -0.00000092276,
                    -0.00000093646,
                    -0.0000009494,
                    -0.00000096167,
                    -0.0000009733,
                    -0.0000009844,
                    -0.00000099491,
                    -0.0000010049,
                    -0.0000010144,
                    -0.0000010235,
                    -0.0000010321,
                    -0.000001039,
                    -0.000001045,
                    -0.0000010503,
                    -0.000001055,
                    -0.0000010592,
                    -0.000001063,
                    -0.0000010663,
                    -0.0000010693,
                    -0.000001072,
                    -0.0000010742,
                    -0.0000010692,
                    -0.0000010649,
                    -0.0000010636,
                    -0.0000010647,
                    -0.0000010671,
                    -0.0000010704,
                    -0.0000010746,
                    -0.0000010796,
                    -0.0000010851,
                    -0.0000010913,
                    -0.0000010973,
                    -0.0000011077,
                    -0.0000010828,
                    -0.0000010821,
                    -0.0000010317,
                    -0.0000010147,
                    -0.0000010143,
                    -0.0000010183,
                    -0.0000009903,
                    -0.00000098253,
                    -0.0000009819,
                    -0.0000010021,
                    -0.0000010227,
                    -0.0000010436,
                    -0.0000010635,
                    -0.0000010828,
                    -0.0000011017,
                    -0.0000011199,
                    -0.0000011371,
                    -0.0000011535,
                    -0.0000011697,
                    -0.0000011852,
                    -0.0000012,
                    -0.0000011926,
                    -0.0000011616,
                    -0.0000011551,
                    -0.0000011564,
                    -0.0000011604,
                    -0.0000011659,
                    -0.000001172,
                    -0.0000011786,
                    -0.0000011853,
                    -0.000001192,
                    -0.0000011985,
                    -0.0000012051,
                    -0.0000012115,
                    -0.0000012177,
                    -0.0000012237,
                    -0.0000012295,
                    -0.0000012352,
                    -0.0000012404,
                    -0.0000012455,
                    -0.00000125,
                    -0.0000012542,
                    -0.0000012588,
                    -0.0000012632,
                    -0.0000012668,
                    -0.0000012689,
                    -0.0000012697,
                    -0.0000012724,
                    -0.0000012756,
                    -0.0000012789,
                    -0.0000012817,
                    -0.0000012811,
                    -0.0000012828,
                    -0.0000012853,
                    -0.0000012877,
                    -0.0000012869,
                    -0.0000012886,
                    -0.0000012909,
                    -0.0000012934,
                    -0.0000012959,
                    -0.0000012984
                ],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [
                    6.5938e-09,
                    1.2415e-08,
                    1.7674e-08,
                    2.2373e-08,
                    2.6513e-08,
                    3.0383e-08,
                    3.3989e-08,
                    3.7332e-08,
                    4.0419e-08,
                    4.3252e-08,
                    4.5934e-08,
                    4.8452e-08,
                    5.0818e-08,
                    5.3024e-08,
                    5.4908e-08,
                    5.6472e-08,
                    5.7718e-08,
                    5.8649e-08,
                    5.9196e-08,
                    5.9364e-08,
                    6.0029e-08,
                    6.1092e-08,
                    6.2359e-08,
                    6.383e-08,
                    6.5484e-08,
                    6.7049e-08,
                    6.8524e-08,
                    6.9884e-08,
                    7.1127e-08,
                    7.2251e-08,
                    7.346e-08,
                    7.5011e-08,
                    7.6773e-08,
                    7.8625e-08,
                    8.0665e-08,
                    8.2894e-08,
                    8.5383e-08,
                    8.8096e-08,
                    9.115e-08,
                    9.4854e-08,
                    9.8402e-08,
                    1.0188e-07,
                    1.0532e-07,
                    1.0871e-07,
                    1.1203e-07,
                    1.153e-07,
                    1.1851e-07,
                    1.2169e-07,
                    1.2486e-07,
                    1.2766e-07,
                    1.3033e-07,
                    1.3265e-07,
                    1.3473e-07,
                    1.3669e-07,
                    1.3859e-07,
                    1.4041e-07,
                    1.421e-07,
                    1.4367e-07,
                    1.4508e-07,
                    1.4603e-07,
                    1.4655e-07,
                    1.4657e-07,
                    1.4606e-07,
                    1.4496e-07,
                    1.4328e-07,
                    1.4103e-07,
                    1.3821e-07,
                    1.3483e-07,
                    1.3086e-07,
                    1.2665e-07,
                    1.225e-07,
                    1.1854e-07,
                    1.1471e-07,
                    1.1098e-07,
                    1.0734e-07,
                    1.039e-07,
                    1.0061e-07,
                    9.7511e-08,
                    9.4589e-08,
                    9.1885e-08,
                    9.0329e-08,
                    8.9861e-08,
                    9.0461e-08,
                    9.2161e-08,
                    9.4956e-08,
                    9.8759e-08,
                    1.0355e-07,
                    1.0938e-07,
                    1.163e-07,
                    1.2424e-07,
                    1.3317e-07,
                    1.4301e-07,
                    1.5359e-07,
                    1.6505e-07,
                    1.7836e-07,
                    1.9373e-07,
                    2.1127e-07,
                    2.3098e-07,
                    2.5301e-07,
                    2.775e-07,
                    3.0507e-07,
                    3.3544e-07,
                    3.6819e-07,
                    4.0294e-07,
                    4.396e-07,
                    4.78e-07,
                    5.1818e-07,
                    5.6025e-07,
                    6.0434e-07,
                    6.5093e-07,
                    7.0049e-07,
                    7.5354e-07,
                    8.0991e-07,
                    8.7321e-07,
                    9.3961e-07,
                    1.0084e-06,
                    1.0815e-06,
                    1.1593e-06,
                    1.2415e-06,
                    1.3112e-06,
                    1.3895e-06,
                    1.4641e-06,
                    1.5372e-06,
                    1.608e-06,
                    1.6779e-06,
                    1.7474e-06,
                    1.8168e-06,
                    1.8925e-06,
                    1.978e-06,
                    2.0689e-06,
                    2.1554e-06,
                    2.2407e-06,
                    2.3209e-06,
                    2.3928e-06,
                    2.4661e-06,
                    2.5341e-06,
                    2.5951e-06,
                    2.6489e-06,
                    2.6891e-06,
                    2.7387e-06,
                    2.7791e-06,
                    2.8202e-06,
                    2.8629e-06,
                    2.9083e-06,
                    2.9541e-06,
                    2.9976e-06,
                    3.0415e-06,
                    3.0784e-06,
                    3.1058e-06,
                    3.1258e-06,
                    3.1469e-06,
                    3.1658e-06,
                    3.1869e-06,
                    3.2097e-06,
                    3.227e-06,
                    3.2462e-06,
                    3.2657e-06,
                    3.2853e-06,
                    3.3085e-06,
                    3.2935e-06,
                    3.2757e-06,
                    3.2578e-06,
                    3.2383e-06,
                    3.2162e-06,
                    3.1927e-06,
                    3.1715e-06,
                    3.149e-06,
                    3.1264e-06,
                    3.0936e-06,
                    3.0588e-06,
                    3.0237e-06,
                    2.9886e-06
                ],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [
                    2.9844e-09,
                    5.4521e-09,
                    7.6145e-09,
                    9.473e-09,
                    1.1029e-08,
                    1.2571e-08,
                    1.4105e-08,
                    1.5633e-08,
                    1.7161e-08,
                    1.8691e-08,
                    2.0219e-08,
                    2.173e-08,
                    2.3237e-08,
                    2.4731e-08,
                    2.6052e-08,
                    2.72e-08,
                    2.8179e-08,
                    2.899e-08,
                    2.9566e-08,
                    2.991e-08,
                    3.0665e-08,
                    3.1734e-08,
                    3.2921e-08,
                    3.4227e-08,
                    3.563e-08,
                    3.6859e-08,
                    3.7914e-08,
                    3.8767e-08,
                    3.9419e-08,
                    3.9865e-08,
                    4.0258e-08,
                    4.0851e-08,
                    4.1516e-08,
                    4.213e-08,
                    4.2793e-08,
                    4.3504e-08,
                    4.4335e-08,
                    4.5249e-08,
                    4.6365e-08,
                    4.799e-08,
                    4.9517e-08,
                    5.1032e-08,
                    5.2567e-08,
                    5.4101e-08,
                    5.5636e-08,
                    5.717e-08,
                    5.87e-08,
                    6.026e-08,
                    6.1863e-08,
                    6.3153e-08,
                    6.4413e-08,
                    6.5428e-08,
                    6.6287e-08,
                    6.713e-08,
                    6.8004e-08,
                    6.8906e-08,
                    6.9764e-08,
                    7.0607e-08,
                    7.1383e-08,
                    7.1796e-08,
                    7.2003e-08,
                    7.1927e-08,
                    7.1549e-08,
                    7.0806e-08,
                    6.9705e-08,
                    6.8264e-08,
                    6.6477e-08,
                    6.4344e-08,
                    6.1847e-08,
                    5.9332e-08,
                    5.6803e-08,
                    5.438e-08,
                    5.2014e-08,
                    4.9659e-08,
                    4.7325e-08,
                    4.5101e-08,
                    4.2952e-08,
                    4.0911e-08,
                    3.8968e-08,
                    3.7165e-08,
                    3.5981e-08,
                    3.5359e-08,
                    3.5279e-08,
                    3.577e-08,
                    3.6831e-08,
                    3.8459e-08,
                    4.0635e-08,
                    4.3416e-08,
                    4.6861e-08,
                    5.0897e-08,
                    5.5576e-08,
                    6.0827e-08,
                    6.6485e-08,
                    7.2702e-08,
                    8.0444e-08,
                    8.9924e-08,
                    1.0125e-07,
                    1.1446e-07,
                    1.2967e-07,
                    1.4704e-07,
                    1.6688e-07,
                    1.8913e-07,
                    2.1354e-07,
                    2.3992e-07,
                    2.683e-07,
                    2.9851e-07,
                    3.3065e-07,
                    3.6482e-07,
                    4.0113e-07,
                    4.3999e-07,
                    4.815e-07,
                    5.2625e-07,
                    5.7442e-07,
                    6.2637e-07,
                    6.8162e-07,
                    7.4045e-07,
                    8.0282e-07,
                    8.6888e-07,
                    9.3807e-07,
                    9.9483e-07,
                    1.0597e-06,
                    1.122e-06,
                    1.1835e-06,
                    1.2441e-06,
                    1.3041e-06,
                    1.3632e-06,
                    1.4216e-06,
                    1.4787e-06,
                    1.534e-06,
                    1.587e-06,
                    1.6365e-06,
                    1.6821e-06,
                    1.7228e-06,
                    1.7585e-06,
                    1.7887e-06,
                    1.8126e-06,
                    1.8306e-06,
                    1.8426e-06,
                    1.8493e-06,
                    1.8661e-06,
                    1.8735e-06,
                    1.8811e-06,
                    1.8891e-06,
                    1.8978e-06,
                    1.9066e-06,
                    1.916e-06,
                    1.9269e-06,
                    1.9388e-06,
                    1.9519e-06,
                    1.9657e-06,
                    1.9785e-06,
                    1.9912e-06,
                    2.0051e-06,
                    2.0194e-06,
                    2.0348e-06,
                    2.0519e-06,
                    2.07e-06,
                    2.0884e-06,
                    2.1045e-06,
                    2.1172e-06,
                    2.1283e-06,
                    2.1395e-06,
                    2.1499e-06,
                    2.1585e-06,
                    2.1659e-06,
                    2.1734e-06,
                    2.1791e-06,
                    2.1852e-06,
                    2.1854e-06,
                    2.184e-06,
                    2.1849e-06,
                    2.1874e-06
                ],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [
                    3.6094e-09,
                    6.9625e-09,
                    1.0059e-08,
                    1.29e-08,
                    1.5484e-08,
                    1.7812e-08,
                    1.9884e-08,
                    2.1699e-08,
                    2.3258e-08,
                    2.4561e-08,
                    2.5715e-08,
                    2.6722e-08,
                    2.7581e-08,
                    2.8293e-08,
                    2.8856e-08,
                    2.9271e-08,
                    2.9539e-08,
                    2.9659e-08,
                    2.9631e-08,
                    2.9455e-08,
                    2.9364e-08,
                    2.9358e-08,
                    2.9438e-08,
                    2.9603e-08,
                    2.9854e-08,
                    3.019e-08,
                    3.0611e-08,
                    3.1117e-08,
                    3.1709e-08,
                    3.2385e-08,
                    3.3203e-08,
                    3.416e-08,
                    3.5257e-08,
                    3.6495e-08,
                    3.7872e-08,
                    3.939e-08,
                    4.1049e-08,
                    4.2847e-08,
                    4.4785e-08,
                    4.6864e-08,
                    4.8885e-08,
                    5.0849e-08,
                    5.2756e-08,
                    5.4606e-08,
                    5.6399e-08,
                    5.8134e-08,
                    5.9812e-08,
                    6.1433e-08,
                    6.2996e-08,
                    6.4503e-08,
                    6.5912e-08,
                    6.7225e-08,
                    6.844e-08,
                    6.9559e-08,
                    7.0581e-08,
                    7.1506e-08,
                    7.2334e-08,
                    7.3065e-08,
                    7.37e-08,
                    7.4237e-08,
                    7.4551e-08,
                    7.4641e-08,
                    7.4508e-08,
                    7.4151e-08,
                    7.357e-08,
                    7.2766e-08,
                    7.1738e-08,
                    7.0487e-08,
                    6.9012e-08,
                    6.7313e-08,
                    6.5695e-08,
                    6.4156e-08,
                    6.2697e-08,
                    6.1318e-08,
                    6.0019e-08,
                    5.8799e-08,
                    5.766e-08,
                    5.66e-08,
                    5.5621e-08,
                    5.4721e-08,
                    5.4348e-08,
                    5.4502e-08,
                    5.5183e-08,
                    5.6391e-08,
                    5.8125e-08,
                    6.03e-08,
                    6.2912e-08,
                    6.5959e-08,
                    6.9438e-08,
                    7.3347e-08,
                    7.7597e-08,
                    8.2184e-08,
                    8.7104e-08,
                    9.2351e-08,
                    9.7921e-08,
                    1.0381e-07,
                    1.1001e-07,
                    1.1652e-07,
                    1.2334e-07,
                    1.3046e-07,
                    1.3819e-07,
                    1.4631e-07,
                    1.5464e-07,
                    1.6301e-07,
                    1.713e-07,
                    1.7949e-07,
                    1.8754e-07,
                    1.9543e-07,
                    2.0321e-07,
                    2.1094e-07,
                    2.19e-07,
                    2.2729e-07,
                    2.3549e-07,
                    2.4685e-07,
                    2.5799e-07,
                    2.6799e-07,
                    2.787e-07,
                    2.9044e-07,
                    3.034e-07,
                    3.1634e-07,
                    3.2977e-07,
                    3.4217e-07,
                    3.5371e-07,
                    3.6387e-07,
                    3.7384e-07,
                    3.8423e-07,
                    3.9519e-07,
                    4.1379e-07,
                    4.4401e-07,
                    4.8191e-07,
                    5.1887e-07,
                    5.5858e-07,
                    5.9808e-07,
                    6.3433e-07,
                    6.7739e-07,
                    7.2142e-07,
                    7.6448e-07,
                    8.0629e-07,
                    8.3985e-07,
                    8.7255e-07,
                    9.0562e-07,
                    9.3909e-07,
                    9.7378e-07,
                    1.0105e-06,
                    1.0475e-06,
                    1.0816e-06,
                    1.1146e-06,
                    1.1396e-06,
                    1.1539e-06,
                    1.1601e-06,
                    1.1684e-06,
                    1.1746e-06,
                    1.1818e-06,
                    1.1903e-06,
                    1.1922e-06,
                    1.1943e-06,
                    1.1957e-06,
                    1.1969e-06,
                    1.2041e-06,
                    1.1763e-06,
                    1.1473e-06,
                    1.1183e-06,
                    1.0885e-06,
                    1.0577e-06,
                    1.0268e-06,
                    9.9803e-07,
                    9.6986e-07,
                    9.4123e-07,
                    9.082e-07,
                    8.748e-07,
                    8.3883e-07,
                    8.0119e-07
                ],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [
                    1.5424e-09,
                    3.1026e-09,
                    4.6803e-09,
                    6.2754e-09,
                    7.8874e-09,
                    9.5158e-09,
                    1.116e-08,
                    1.282e-08,
                    1.4494e-08,
                    1.6182e-08,
                    1.7883e-08,
                    1.9597e-08,
                    2.1325e-08,
                    2.3065e-08,
                    2.4818e-08,
                    2.6585e-08,
                    2.8364e-08,
                    3.0156e-08,
                    3.1962e-08,
                    3.378e-08,
                    3.5617e-08,
                    3.7478e-08,
                    3.937e-08,
                    4.1296e-08,
                    4.3258e-08,
                    4.5258e-08,
                    4.7294e-08,
                    4.9362e-08,
                    5.146e-08,
                    5.358e-08,
                    5.5718e-08,
                    5.7873e-08,
                    6.0045e-08,
                    6.2233e-08,
                    6.4437e-08,
                    6.6656e-08,
                    6.8891e-08,
                    7.1142e-08,
                    7.3409e-08,
                    7.5693e-08,
                    7.7993e-08,
                    8.0311e-08,
                    8.2645e-08,
                    8.4997e-08,
                    8.7367e-08,
                    8.9754e-08,
                    9.2159e-08,
                    9.4583e-08,
                    9.7025e-08,
                    9.9488e-08,
                    1.0197e-07,
                    1.0447e-07,
                    1.07e-07,
                    1.0955e-07,
                    1.1213e-07,
                    1.1473e-07,
                    1.1736e-07,
                    1.2001e-07,
                    1.2269e-07,
                    1.2539e-07,
                    1.2811e-07,
                    1.3086e-07,
                    1.3363e-07,
                    1.3642e-07,
                    1.3924e-07,
                    1.4208e-07,
                    1.4495e-07,
                    1.4784e-07,
                    1.5075e-07,
                    1.5369e-07,
                    1.5665e-07,
                    1.5964e-07,
                    1.6265e-07,
                    1.6569e-07,
                    1.6875e-07,
                    1.7183e-07,
                    1.7494e-07,
                    1.7808e-07,
                    1.8123e-07,
                    1.8441e-07,
                    1.8762e-07,
                    1.9084e-07,
                    1.9408e-07,
                    1.9734e-07,
                    2.0062e-07,
                    2.0392e-07,
                    2.0724e-07,
                    2.1058e-07,
                    2.1395e-07,
                    2.1734e-07,
                    2.2078e-07,
                    2.243e-07,
                    2.2792e-07,
                    2.3165e-07,
                    2.3552e-07,
                    2.3951e-07,
                    2.4364e-07,
                    2.4788e-07,
                    2.5223e-07,
                    2.5667e-07,
                    2.6117e-07,
                    2.6572e-07,
                    2.7033e-07,
                    2.7499e-07,
                    2.7969e-07,
                    2.8443e-07,
                    2.8922e-07,
                    2.9407e-07,
                    2.9898e-07,
                    3.0395e-07,
                    3.0896e-07,
                    3.1403e-07,
                    3.1913e-07,
                    3.2449e-07,
                    3.299e-07,
                    3.3533e-07,
                    3.4086e-07,
                    3.4652e-07,
                    3.5231e-07,
                    3.5743e-07,
                    3.6269e-07,
                    3.6854e-07,
                    3.7426e-07,
                    3.7953e-07,
                    3.8551e-07,
                    3.9109e-07,
                    3.9709e-07,
                    4.0345e-07,
                    4.1044e-07,
                    4.1806e-07,
                    4.2514e-07,
                    4.3313e-07,
                    4.3976e-07,
                    4.4696e-07,
                    4.5454e-07,
                    4.6137e-07,
                    4.6862e-07,
                    4.7604e-07,
                    4.8303e-07,
                    4.9017e-07,
                    4.9752e-07,
                    5.0505e-07,
                    5.1241e-07,
                    5.2006e-07,
                    5.2809e-07,
                    5.3666e-07,
                    5.4534e-07,
                    5.5428e-07,
                    5.6322e-07,
                    5.7162e-07,
                    5.8014e-07,
                    5.8887e-07,
                    5.9842e-07,
                    6.0819e-07,
                    6.1805e-07,
                    6.2801e-07,
                    6.3812e-07,
                    6.4834e-07,
                    6.5907e-07,
                    6.6808e-07,
                    6.772e-07,
                    6.8661e-07,
                    6.9627e-07,
                    7.0595e-07,
                    7.1568e-07,
                    7.2547e-07,
                    7.3343e-07,
                    7.4133e-07,
                    7.5051e-07,
                    7.5951e-07,
                    7.6896e-07,
                    7.7859e-07
                ],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [
                    1.3196e-09,
                    2.6525e-09,
                    3.9988e-09,
                    5.3583e-09,
                    6.7311e-09,
                    8.1171e-09,
                    9.5163e-09,
                    1.0928e-08,
                    1.2354e-08,
                    1.3792e-08,
                    1.5243e-08,
                    1.6706e-08,
                    1.8183e-08,
                    1.9672e-08,
                    2.1175e-08,
                    2.2689e-08,
                    2.4217e-08,
                    2.5758e-08,
                    2.7311e-08,
                    2.8877e-08,
                    3.0457e-08,
                    3.2051e-08,
                    3.3659e-08,
                    3.5283e-08,
                    3.6922e-08,
                    3.8577e-08,
                    4.0247e-08,
                    4.1933e-08,
                    4.3633e-08,
                    4.5347e-08,
                    4.7074e-08,
                    4.8814e-08,
                    5.0568e-08,
                    5.2335e-08,
                    5.4115e-08,
                    5.5908e-08,
                    5.7715e-08,
                    5.9534e-08,
                    6.1367e-08,
                    6.3212e-08,
                    6.5071e-08,
                    6.6944e-08,
                    6.8829e-08,
                    7.0728e-08,
                    7.264e-08,
                    7.4566e-08,
                    7.6505e-08,
                    7.8457e-08,
                    8.0423e-08,
                    8.2402e-08,
                    8.4395e-08,
                    8.6402e-08,
                    8.8423e-08,
                    9.0458e-08,
                    9.2507e-08,
                    9.457e-08,
                    9.6647e-08,
                    9.8739e-08,
                    1.0084e-07,
                    1.0296e-07,
                    1.051e-07,
                    1.0725e-07,
                    1.0941e-07,
                    1.1158e-07,
                    1.1377e-07,
                    1.1598e-07,
                    1.182e-07,
                    1.2043e-07,
                    1.2267e-07,
                    1.2493e-07,
                    1.2721e-07,
                    1.295e-07,
                    1.318e-07,
                    1.3412e-07,
                    1.3645e-07,
                    1.3879e-07,
                    1.4115e-07,
                    1.4352e-07,
                    1.4591e-07,
                    1.4831e-07,
                    1.5073e-07,
                    1.5316e-07,
                    1.556e-07,
                    1.5805e-07,
                    1.6052e-07,
                    1.63e-07,
                    1.655e-07,
                    1.6801e-07,
                    1.7054e-07,
                    1.7307e-07,
                    1.7563e-07,
                    1.782e-07,
                    1.808e-07,
                    1.8343e-07,
                    1.8607e-07,
                    1.8875e-07,
                    1.9145e-07,
                    1.9418e-07,
                    1.9693e-07,
                    1.997e-07,
                    2.0249e-07,
                    2.053e-07,
                    2.0812e-07,
                    2.1096e-07,
                    2.1382e-07,
                    2.1669e-07,
                    2.1959e-07,
                    2.2249e-07,
                    2.2542e-07,
                    2.2837e-07,
                    2.3133e-07,
                    2.3433e-07,
                    2.3734e-07,
                    2.4039e-07,
                    2.4346e-07,
                    2.4656e-07,
                    2.497e-07,
                    2.5286e-07,
                    2.5604e-07,
                    2.5851e-07,
                    2.6099e-07,
                    2.641e-07,
                    2.6709e-07,
                    2.6978e-07,
                    2.732e-07,
                    2.7621e-07,
                    2.7952e-07,
                    2.8276e-07,
                    2.8588e-07,
                    2.891e-07,
                    2.9188e-07,
                    2.9534e-07,
                    2.9742e-07,
                    3.0005e-07,
                    3.0265e-07,
                    3.0446e-07,
                    3.067e-07,
                    3.0908e-07,
                    3.1145e-07,
                    3.1399e-07,
                    3.1669e-07,
                    3.1956e-07,
                    3.2215e-07,
                    3.2488e-07,
                    3.2787e-07,
                    3.3139e-07,
                    3.349e-07,
                    3.3863e-07,
                    3.4226e-07,
                    3.4546e-07,
                    3.4864e-07,
                    3.519e-07,
                    3.5586e-07,
                    3.6e-07,
                    3.6418e-07,
                    3.6844e-07,
                    3.7287e-07,
                    3.7745e-07,
                    3.8258e-07,
                    3.8817e-07,
                    3.9384e-07,
                    3.9973e-07,
                    4.0588e-07,
                    4.1208e-07,
                    4.1835e-07,
                    4.2456e-07,
                    4.2906e-07,
                    4.3354e-07,
                    4.3962e-07,
                    4.4567e-07,
                    4.5224e-07,
                    4.5905e-07
                ],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": [
                    2.228e-10,
                    4.5006e-10,
                    6.8157e-10,
                    9.1709e-10,
                    1.1563e-09,
                    1.3987e-09,
                    1.6439e-09,
                    1.8913e-09,
                    2.1403e-09,
                    2.3901e-09,
                    2.6404e-09,
                    2.891e-09,
                    3.1418e-09,
                    3.3928e-09,
                    3.6439e-09,
                    3.8952e-09,
                    4.1467e-09,
                    4.3984e-09,
                    4.6505e-09,
                    4.903e-09,
                    5.1598e-09,
                    5.4272e-09,
                    5.7104e-09,
                    6.0126e-09,
                    6.3359e-09,
                    6.6808e-09,
                    7.0462e-09,
                    7.4296e-09,
                    7.8271e-09,
                    8.233e-09,
                    8.6438e-09,
                    9.0586e-09,
                    9.4769e-09,
                    9.898e-09,
                    1.0322e-08,
                    1.0748e-08,
                    1.1177e-08,
                    1.1608e-08,
                    1.2042e-08,
                    1.248e-08,
                    1.2922e-08,
                    1.3367e-08,
                    1.3816e-08,
                    1.4269e-08,
                    1.4726e-08,
                    1.5188e-08,
                    1.5654e-08,
                    1.6126e-08,
                    1.6603e-08,
                    1.7085e-08,
                    1.7575e-08,
                    1.8073e-08,
                    1.858e-08,
                    1.9096e-08,
                    1.9623e-08,
                    2.0161e-08,
                    2.071e-08,
                    2.127e-08,
                    2.1841e-08,
                    2.2421e-08,
                    2.3011e-08,
                    2.3611e-08,
                    2.4221e-08,
                    2.484e-08,
                    2.5469e-08,
                    2.6107e-08,
                    2.6755e-08,
                    2.7413e-08,
                    2.8081e-08,
                    2.8758e-08,
                    2.9446e-08,
                    3.0144e-08,
                    3.0852e-08,
                    3.1572e-08,
                    3.2302e-08,
                    3.3042e-08,
                    3.3793e-08,
                    3.4553e-08,
                    3.5323e-08,
                    3.6102e-08,
                    3.6889e-08,
                    3.7683e-08,
                    3.8483e-08,
                    3.9288e-08,
                    4.0099e-08,
                    4.0916e-08,
                    4.174e-08,
                    4.2572e-08,
                    4.3415e-08,
                    4.427e-08,
                    4.5155e-08,
                    4.6096e-08,
                    4.7115e-08,
                    4.8227e-08,
                    4.9441e-08,
                    5.0761e-08,
                    5.2185e-08,
                    5.3705e-08,
                    5.5306e-08,
                    5.697e-08,
                    5.868e-08,
                    6.0428e-08,
                    6.2211e-08,
                    6.4023e-08,
                    6.5865e-08,
                    6.7735e-08,
                    6.9637e-08,
                    7.1575e-08,
                    7.3554e-08,
                    7.5583e-08,
                    7.7624e-08,
                    7.9702e-08,
                    8.1792e-08,
                    8.4103e-08,
                    8.6439e-08,
                    8.8762e-08,
                    9.116e-08,
                    9.3668e-08,
                    9.6274e-08,
                    9.8917e-08,
                    1.0171e-07,
                    1.0444e-07,
                    1.0717e-07,
                    1.0975e-07,
                    1.1231e-07,
                    1.1489e-07,
                    1.1757e-07,
                    1.2069e-07,
                    1.2456e-07,
                    1.2896e-07,
                    1.3327e-07,
                    1.3779e-07,
                    1.4234e-07,
                    1.4691e-07,
                    1.5189e-07,
                    1.5691e-07,
                    1.6192e-07,
                    1.6696e-07,
                    1.7157e-07,
                    1.7617e-07,
                    1.8083e-07,
                    1.8549e-07,
                    1.9026e-07,
                    1.9518e-07,
                    2.0022e-07,
                    2.0527e-07,
                    2.1044e-07,
                    2.1565e-07,
                    2.2096e-07,
                    2.2616e-07,
                    2.3151e-07,
                    2.3697e-07,
                    2.4256e-07,
                    2.4819e-07,
                    2.5387e-07,
                    2.5957e-07,
                    2.6525e-07,
                    2.7088e-07,
                    2.7649e-07,
                    2.7991e-07,
                    2.8336e-07,
                    2.8688e-07,
                    2.904e-07,
                    2.9387e-07,
                    2.9733e-07,
                    3.0091e-07,
                    3.0437e-07,
                    3.0779e-07,
                    3.1089e-07,
                    3.1384e-07,
                    3.1672e-07,
                    3.1954e-07
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -61.90268,
                                17.10076
                            ],
                            [
                                -61.88938,
                                17.02645
                            ],
                            [
                                -61.74573,
                                16.9991
                            ],
                            [
                                -61.69312,
                                17.03129
                            ],
                            [
                                -61.68229,
                                17.09528
                            ],
                            [
                                -61.7495,
                                17.11644
                            ],
                            [
                                -61.80243,
                                17.16888
                            ],
                            [
                                -61.84649,
                                17.16494
                            ],
                            [
                                -61.90268,
                                17.10076
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -61.88583,
                                17.6971
                            ],
                            [
                                -61.83301,
                                17.59251
                            ],
                            [
                                -61.73637,
                                17.54962
                            ],
                            [
                                -61.74054,
                                17.63869
                            ],
                            [
                                -61.84063,
                                17.72622
                            ],
                            [
                                -61.88583,
                                17.6971
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "ARG",
                "Country": "Argentina",
                "Total_3GHG": 1.16,
                "Total_3GHG_timeseries": [
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0048,
                    0.0049,
                    0.0051,
                    0.0052,
                    0.0054,
                    0.0055,
                    0.0056,
                    0.0058,
                    0.0059,
                    0.006,
                    0.0062,
                    0.0063,
                    0.0064,
                    0.0065,
                    0.0067,
                    0.0068,
                    0.0069,
                    0.007,
                    0.0071,
                    0.0072,
                    0.0073,
                    0.0074,
                    0.0075,
                    0.0076,
                    0.0078,
                    0.0079,
                    0.008,
                    0.0081,
                    0.0082,
                    0.0083,
                    0.0084,
                    0.0085,
                    0.0087,
                    0.0088,
                    0.0089,
                    0.009,
                    0.0092,
                    0.0093,
                    0.0094,
                    0.0096,
                    0.0097,
                    0.0099,
                    0.0101,
                    0.0103,
                    0.0104,
                    0.0106,
                    0.0107,
                    0.0109,
                    0.0111,
                    0.0112,
                    0.0114,
                    0.0116,
                    0.0117,
                    0.0119,
                    0.012,
                    0.0122,
                    0.0123,
                    0.0125,
                    0.0126,
                    0.0127,
                    0.0129,
                    0.013,
                    0.0131,
                    0.0132,
                    0.0133,
                    0.0135,
                    0.0136,
                    0.0137,
                    0.0139,
                    0.014,
                    0.0141,
                    0.0142,
                    0.0144,
                    0.0145,
                    0.0146,
                    0.0148,
                    0.0149,
                    0.0151,
                    0.0153,
                    0.0156,
                    0.0158,
                    0.0161,
                    0.0163,
                    0.0165,
                    0.0168,
                    0.017,
                    0.0172,
                    0.0174,
                    0.0176,
                    0.0177,
                    0.0179,
                    0.018,
                    0.0182,
                    0.0184,
                    0.0185,
                    0.0186,
                    0.0188,
                    0.0189
                ],
                "Fossil_3GHG": 0.55,
                "Fossil_3GHG_timeseries": [
                    3.3537e-07,
                    6.7781e-07,
                    1.0273e-06,
                    1.3839e-06,
                    1.7476e-06,
                    2.12e-06,
                    2.5012e-06,
                    2.889e-06,
                    3.2835e-06,
                    3.6857e-06,
                    4.1006e-06,
                    4.5281e-06,
                    4.9684e-06,
                    5.4215e-06,
                    5.8877e-06,
                    6.3673e-06,
                    6.8603e-06,
                    7.3656e-06,
                    7.8837e-06,
                    8.4156e-06,
                    8.9758e-06,
                    9.5627e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0055,
                    0.0055,
                    0.0056,
                    0.0057,
                    0.0058,
                    0.0059
                ],
                "Land_3GHG": 2.26,
                "Land_3GHG_timeseries": [
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0055,
                    0.0057,
                    0.0058,
                    0.0059,
                    0.006,
                    0.0061,
                    0.0062,
                    0.0063,
                    0.0064,
                    0.0065,
                    0.0066,
                    0.0067,
                    0.0068,
                    0.0069,
                    0.007,
                    0.007,
                    0.0071,
                    0.0072,
                    0.0073,
                    0.0074,
                    0.0075,
                    0.0075,
                    0.0076,
                    0.0077,
                    0.0078,
                    0.0079,
                    0.008,
                    0.0081,
                    0.0082,
                    0.0083,
                    0.0083,
                    0.0084,
                    0.0086,
                    0.0087,
                    0.0088,
                    0.0089,
                    0.0091,
                    0.0092,
                    0.0093,
                    0.0094,
                    0.0095,
                    0.0096,
                    0.0097,
                    0.0098,
                    0.0099,
                    0.01,
                    0.01,
                    0.0101,
                    0.0102,
                    0.0103,
                    0.0103,
                    0.0104,
                    0.0105,
                    0.0105,
                    0.0105,
                    0.0106,
                    0.0106,
                    0.0107,
                    0.0107,
                    0.0108,
                    0.0108,
                    0.0109,
                    0.0109,
                    0.0109,
                    0.011,
                    0.011,
                    0.011,
                    0.0111,
                    0.0111,
                    0.0112,
                    0.0113,
                    0.0114,
                    0.0116,
                    0.0117,
                    0.0119,
                    0.012,
                    0.0121,
                    0.0122,
                    0.0123,
                    0.0124,
                    0.0125,
                    0.0125,
                    0.0126,
                    0.0127,
                    0.0128,
                    0.0128,
                    0.0129,
                    0.0129,
                    0.013,
                    0.013
                ],
                "Total_CO2": 1.0,
                "Total_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0048,
                    0.0049,
                    0.0049,
                    0.005,
                    0.005,
                    0.0051,
                    0.0051,
                    0.0051,
                    0.0052,
                    0.0052,
                    0.0053,
                    0.0053,
                    0.0054,
                    0.0054,
                    0.0054,
                    0.0055,
                    0.0055,
                    0.0056,
                    0.0056,
                    0.0057,
                    0.0057,
                    0.0058,
                    0.0058,
                    0.0059,
                    0.006,
                    0.0061,
                    0.0061,
                    0.0062,
                    0.0063,
                    0.0063,
                    0.0064,
                    0.0065,
                    0.0065,
                    0.0066,
                    0.0066,
                    0.0067,
                    0.0068,
                    0.0068,
                    0.0069,
                    0.0069,
                    0.007,
                    0.0071,
                    0.0071,
                    0.0072,
                    0.0072,
                    0.0073,
                    0.0074,
                    0.0074,
                    0.0075,
                    0.0076,
                    0.0077,
                    0.0078,
                    0.0079,
                    0.008,
                    0.008,
                    0.0081,
                    0.0082,
                    0.0083,
                    0.0084,
                    0.0086,
                    0.0087,
                    0.0089,
                    0.009,
                    0.0092,
                    0.0094,
                    0.0095,
                    0.0097,
                    0.0099,
                    0.0101,
                    0.0102,
                    0.0104,
                    0.0105,
                    0.0106,
                    0.0107,
                    0.0109,
                    0.011,
                    0.011,
                    0.0111,
                    0.0112,
                    0.0113
                ],
                "Fossil_CO2": 0.51,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    4.884e-07,
                    8.8935e-07,
                    1.6797e-06,
                    2.2968e-06,
                    2.7192e-06,
                    3.3429e-06,
                    4.0425e-06,
                    4.9401e-06,
                    5.9598e-06,
                    6.9976e-06,
                    7.9349e-06,
                    8.9925e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004
                ],
                "Land_CO2": 2.05,
                "Land_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0045,
                    0.0046,
                    0.0046,
                    0.0047,
                    0.0047,
                    0.0048,
                    0.0048,
                    0.0048,
                    0.0049,
                    0.0049,
                    0.0049,
                    0.005,
                    0.005,
                    0.005,
                    0.005,
                    0.005,
                    0.0051,
                    0.0051,
                    0.0051,
                    0.0051,
                    0.0052,
                    0.0052,
                    0.0052,
                    0.0052,
                    0.0053,
                    0.0053,
                    0.0054,
                    0.0054,
                    0.0054,
                    0.0055,
                    0.0055,
                    0.0055,
                    0.0056,
                    0.0056,
                    0.0056,
                    0.0056,
                    0.0056,
                    0.0056,
                    0.0056,
                    0.0056,
                    0.0057,
                    0.0057,
                    0.0057,
                    0.0057,
                    0.0057,
                    0.0057,
                    0.0057,
                    0.0058,
                    0.0058,
                    0.0058,
                    0.0058,
                    0.0058,
                    0.0059,
                    0.0059,
                    0.0059,
                    0.006,
                    0.006,
                    0.006,
                    0.0061,
                    0.0061,
                    0.0061,
                    0.0062,
                    0.0063,
                    0.0064,
                    0.0065,
                    0.0066,
                    0.0067,
                    0.0067,
                    0.0068,
                    0.0069,
                    0.007,
                    0.0071,
                    0.0071,
                    0.0072,
                    0.0072,
                    0.0073,
                    0.0073,
                    0.0073,
                    0.0073,
                    0.0073,
                    0.0073,
                    0.0073
                ],
                "Total_CH4": 1.51,
                "Total_CH4_timeseries": [
                    3.7834e-06,
                    7.6687e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0048,
                    0.0049,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0051,
                    0.0052,
                    0.0052,
                    0.0052,
                    0.0053,
                    0.0053,
                    0.0054,
                    0.0054,
                    0.0054,
                    0.0055,
                    0.0055,
                    0.0055,
                    0.0055,
                    0.0055,
                    0.0056,
                    0.0056,
                    0.0056,
                    0.0057,
                    0.0057,
                    0.0058,
                    0.0058,
                    0.0059,
                    0.006,
                    0.006,
                    0.0061,
                    0.0061,
                    0.0061,
                    0.0061,
                    0.0061,
                    0.0061,
                    0.0061,
                    0.0062,
                    0.0062,
                    0.0062,
                    0.0063,
                    0.0063,
                    0.0063,
                    0.0063
                ],
                "Fossil_CH4": 0.69,
                "Fossil_CH4_timeseries": [
                    2.2135e-07,
                    4.4842e-07,
                    6.8123e-07,
                    9.198e-07,
                    1.1642e-06,
                    1.416e-06,
                    1.6755e-06,
                    1.9405e-06,
                    2.2111e-06,
                    2.4884e-06,
                    2.7774e-06,
                    3.0782e-06,
                    3.3907e-06,
                    3.7152e-06,
                    4.0518e-06,
                    4.4009e-06,
                    4.7625e-06,
                    5.1354e-06,
                    5.5203e-06,
                    5.918e-06,
                    6.3425e-06,
                    6.7918e-06,
                    7.266e-06,
                    7.765e-06,
                    8.2891e-06,
                    8.8362e-06,
                    9.4064e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018
                ],
                "Land_CH4": 2.87,
                "Land_CH4_timeseries": [
                    3.562e-06,
                    7.2203e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.004,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0042,
                    0.0042,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0043,
                    0.0043,
                    0.0043,
                    0.0043,
                    0.0043,
                    0.0042,
                    0.0042,
                    0.0042,
                    0.0042,
                    0.0042,
                    0.0042,
                    0.0042,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0043,
                    0.0043,
                    0.0043,
                    0.0043,
                    0.0043,
                    0.0043,
                    0.0043,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0045,
                    0.0045,
                    0.0045
                ],
                "Total_N2O": 1.53,
                "Total_N2O_timeseries": [
                    2.7646e-07,
                    5.5752e-07,
                    8.4302e-07,
                    1.1327e-06,
                    1.4264e-06,
                    1.7237e-06,
                    2.0242e-06,
                    2.3274e-06,
                    2.6328e-06,
                    2.9399e-06,
                    3.2482e-06,
                    3.5577e-06,
                    3.8682e-06,
                    4.1799e-06,
                    4.4925e-06,
                    4.8062e-06,
                    5.121e-06,
                    5.4369e-06,
                    5.754e-06,
                    6.0723e-06,
                    6.3951e-06,
                    6.7277e-06,
                    7.0741e-06,
                    7.4373e-06,
                    7.8189e-06,
                    8.2193e-06,
                    8.6376e-06,
                    9.0718e-06,
                    9.5185e-06,
                    9.9731e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013
                ],
                "Fossil_N2O": 0.45,
                "Fossil_N2O_timeseries": [
                    1.1402e-07,
                    2.2939e-07,
                    3.461e-07,
                    4.6412e-07,
                    5.8341e-07,
                    7.0394e-07,
                    8.2565e-07,
                    9.4849e-07,
                    1.0724e-06,
                    1.1973e-06,
                    1.3231e-06,
                    1.4499e-06,
                    1.5777e-06,
                    1.7063e-06,
                    1.8359e-06,
                    1.9664e-06,
                    2.0978e-06,
                    2.2301e-06,
                    2.3634e-06,
                    2.4977e-06,
                    2.6333e-06,
                    2.7708e-06,
                    2.9109e-06,
                    3.0537e-06,
                    3.1996e-06,
                    3.3486e-06,
                    3.5005e-06,
                    3.6551e-06,
                    3.812e-06,
                    3.9707e-06,
                    4.1308e-06,
                    4.2922e-06,
                    4.4548e-06,
                    4.6187e-06,
                    4.7837e-06,
                    4.9499e-06,
                    5.1172e-06,
                    5.2857e-06,
                    5.4554e-06,
                    5.6285e-06,
                    5.8035e-06,
                    5.9804e-06,
                    6.1591e-06,
                    6.3399e-06,
                    6.5228e-06,
                    6.7078e-06,
                    6.895e-06,
                    7.0844e-06,
                    7.2762e-06,
                    7.4703e-06,
                    7.667e-06,
                    7.8665e-06,
                    8.0689e-06,
                    8.2743e-06,
                    8.4829e-06,
                    8.6947e-06,
                    8.9096e-06,
                    9.1277e-06,
                    9.3489e-06,
                    9.573e-06,
                    9.8e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_N2O": 1.95,
                "Land_N2O_timeseries": [
                    1.6244e-07,
                    3.2812e-07,
                    4.9691e-07,
                    6.6862e-07,
                    8.43e-07,
                    1.0197e-06,
                    1.1985e-06,
                    1.3789e-06,
                    1.5604e-06,
                    1.7426e-06,
                    1.925e-06,
                    2.1077e-06,
                    2.2906e-06,
                    2.4736e-06,
                    2.6567e-06,
                    2.8399e-06,
                    3.0232e-06,
                    3.2067e-06,
                    3.3905e-06,
                    3.5746e-06,
                    3.7618e-06,
                    3.9568e-06,
                    4.1632e-06,
                    4.3836e-06,
                    4.6193e-06,
                    4.8707e-06,
                    5.1371e-06,
                    5.4167e-06,
                    5.7065e-06,
                    6.0024e-06,
                    6.3019e-06,
                    6.6044e-06,
                    6.9093e-06,
                    7.2163e-06,
                    7.5253e-06,
                    7.8361e-06,
                    8.1486e-06,
                    8.4631e-06,
                    8.7798e-06,
                    9.2575e-06,
                    9.742e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -68.43219,
                                -52.39755
                            ],
                            [
                                -68.35372,
                                -52.32235
                            ],
                            [
                                -68.70162,
                                -51.98942
                            ],
                            [
                                -68.95959,
                                -51.62586
                            ],
                            [
                                -68.95249,
                                -51.53032
                            ],
                            [
                                -68.99496,
                                -51.45387
                            ],
                            [
                                -69.16617,
                                -50.9818
                            ],
                            [
                                -69.30519,
                                -50.98453
                            ],
                            [
                                -69.13339,
                                -50.89914
                            ],
                            [
                                -69.14075,
                                -50.72768
                            ],
                            [
                                -69.07774,
                                -50.56469
                            ],
                            [
                                -68.98312,
                                -50.43309
                            ],
                            [
                                -68.86415,
                                -50.32478
                            ],
                            [
                                -68.76527,
                                -50.28675
                            ],
                            [
                                -68.40512,
                                -50.18598
                            ],
                            [
                                -68.35934,
                                -50.13647
                            ],
                            [
                                -68.48071,
                                -50.09492
                            ],
                            [
                                -68.41827,
                                -50.05658
                            ],
                            [
                                -68.32595,
                                -50.12303
                            ],
                            [
                                -68.19713,
                                -50.11662
                            ],
                            [
                                -68.04231,
                                -50.07057
                            ],
                            [
                                -67.84917,
                                -49.95833
                            ],
                            [
                                -67.73383,
                                -49.78685
                            ],
                            [
                                -67.71958,
                                -49.6376
                            ],
                            [
                                -67.66745,
                                -49.40992
                            ],
                            [
                                -67.59931,
                                -49.29817
                            ],
                            [
                                -67.63442,
                                -49.1362
                            ],
                            [
                                -67.57289,
                                -49.03896
                            ],
                            [
                                -67.48863,
                                -48.95967
                            ],
                            [
                                -67.36664,
                                -48.89023
                            ],
                            [
                                -67.24663,
                                -48.85379
                            ],
                            [
                                -67.19503,
                                -48.81334
                            ],
                            [
                                -67.12558,
                                -48.68337
                            ],
                            [
                                -66.95878,
                                -48.60712
                            ],
                            [
                                -66.87816,
                                -48.59461
                            ],
                            [
                                -66.83484,
                                -48.52774
                            ],
                            [
                                -66.63926,
                                -48.43158
                            ],
                            [
                                -66.49603,
                                -48.41559
                            ],
                            [
                                -66.4484,
                                -48.35383
                            ],
                            [
                                -66.34346,
                                -48.34995
                            ],
                            [
                                -66.33506,
                                -48.27708
                            ],
                            [
                                -66.23047,
                                -48.20414
                            ],
                            [
                                -66.17041,
                                -48.19373
                            ],
                            [
                                -66.11677,
                                -48.12304
                            ],
                            [
                                -65.97673,
                                -48.10175
                            ],
                            [
                                -65.97382,
                                -48.05529
                            ],
                            [
                                -65.89727,
                                -47.93364
                            ],
                            [
                                -65.8294,
                                -47.96207
                            ],
                            [
                                -65.76926,
                                -47.91335
                            ],
                            [
                                -65.84655,
                                -47.88779
                            ],
                            [
                                -65.89565,
                                -47.76399
                            ],
                            [
                                -65.8461,
                                -47.7418
                            ],
                            [
                                -65.73837,
                                -47.50324
                            ],
                            [
                                -65.71745,
                                -47.33465
                            ],
                            [
                                -65.73895,
                                -47.20386
                            ],
                            [
                                -65.85457,
                                -47.11072
                            ],
                            [
                                -65.94473,
                                -47.07771
                            ],
                            [
                                -66.19596,
                                -47.08648
                            ],
                            [
                                -66.49682,
                                -47.04275
                            ],
                            [
                                -66.70156,
                                -47.03318
                            ],
                            [
                                -66.78763,
                                -47.00058
                            ],
                            [
                                -66.94955,
                                -46.85828
                            ],
                            [
                                -67.03447,
                                -46.80922
                            ],
                            [
                                -67.13632,
                                -46.70663
                            ],
                            [
                                -67.39081,
                                -46.59632
                            ],
                            [
                                -67.43933,
                                -46.54907
                            ],
                            [
                                -67.59203,
                                -46.29632
                            ],
                            [
                                -67.62825,
                                -46.13483
                            ],
                            [
                                -67.61686,
                                -46.04792
                            ],
                            [
                                -67.54502,
                                -45.91757
                            ],
                            [
                                -67.45388,
                                -45.82103
                            ],
                            [
                                -67.36718,
                                -45.77738
                            ],
                            [
                                -67.34835,
                                -45.62828
                            ],
                            [
                                -67.22131,
                                -45.52526
                            ],
                            [
                                -67.05825,
                                -45.34201
                            ],
                            [
                                -66.96477,
                                -45.27405
                            ],
                            [
                                -66.84365,
                                -45.2313
                            ],
                            [
                                -66.56602,
                                -45.21305
                            ],
                            [
                                -66.55176,
                                -45.14217
                            ],
                            [
                                -66.46387,
                                -45.07755
                            ],
                            [
                                -66.36037,
                                -45.04206
                            ],
                            [
                                -66.28199,
                                -45.05271
                            ],
                            [
                                -66.19329,
                                -44.98514
                            ],
                            [
                                -66.01872,
                                -45.00267
                            ],
                            [
                                -65.93563,
                                -45.04792
                            ],
                            [
                                -65.87227,
                                -45.00377
                            ],
                            [
                                -65.70532,
                                -45.04678
                            ],
                            [
                                -65.60734,
                                -45.02854
                            ],
                            [
                                -65.52673,
                                -44.9268
                            ],
                            [
                                -65.72096,
                                -44.85907
                            ],
                            [
                                -65.6936,
                                -44.73225
                            ],
                            [
                                -65.59949,
                                -44.6463
                            ],
                            [
                                -65.39643,
                                -44.58907
                            ],
                            [
                                -65.31834,
                                -44.48809
                            ],
                            [
                                -65.32811,
                                -44.45463
                            ],
                            [
                                -65.22105,
                                -44.36529
                            ],
                            [
                                -65.30567,
                                -44.23241
                            ],
                            [
                                -65.30122,
                                -44.17672
                            ],
                            [
                                -65.22165,
                                -44.12581
                            ],
                            [
                                -65.20491,
                                -44.04163
                            ],
                            [
                                -65.2987,
                                -43.92958
                            ],
                            [
                                -65.35198,
                                -43.76362
                            ],
                            [
                                -65.32804,
                                -43.65373
                            ],
                            [
                                -65.05516,
                                -43.40307
                            ],
                            [
                                -65.03302,
                                -43.30835
                            ],
                            [
                                -64.97885,
                                -43.25954
                            ],
                            [
                                -64.78958,
                                -43.16335
                            ],
                            [
                                -64.46164,
                                -43.06464
                            ],
                            [
                                -64.33299,
                                -43.00243
                            ],
                            [
                                -64.33469,
                                -42.93734
                            ],
                            [
                                -64.42311,
                                -42.95317
                            ],
                            [
                                -64.68935,
                                -42.89916
                            ],
                            [
                                -64.80842,
                                -42.84246
                            ],
                            [
                                -65.01448,
                                -42.77967
                            ],
                            [
                                -65.03305,
                                -42.73225
                            ],
                            [
                                -64.93911,
                                -42.62526
                            ],
                            [
                                -64.83883,
                                -42.61124
                            ],
                            [
                                -64.68193,
                                -42.51245
                            ],
                            [
                                -64.57889,
                                -42.49246
                            ],
                            [
                                -64.46609,
                                -42.50391
                            ],
                            [
                                -64.33296,
                                -42.53867
                            ],
                            [
                                -64.21712,
                                -42.63672
                            ],
                            [
                                -64.25747,
                                -42.74634
                            ],
                            [
                                -64.15077,
                                -42.86655
                            ],
                            [
                                -64.10697,
                                -42.87692
                            ],
                            [
                                -63.73256,
                                -42.81049
                            ],
                            [
                                -63.63361,
                                -42.76054
                            ],
                            [
                                -63.63723,
                                -42.70126
                            ],
                            [
                                -63.58536,
                                -42.6063
                            ],
                            [
                                -63.61114,
                                -42.47612
                            ],
                            [
                                -63.61988,
                                -42.28624
                            ],
                            [
                                -63.76447,
                                -42.07776
                            ],
                            [
                                -63.88746,
                                -42.08856
                            ],
                            [
                                -64.08209,
                                -42.17916
                            ],
                            [
                                -64.32356,
                                -42.22709
                            ],
                            [
                                -64.13452,
                                -42.24177
                            ],
                            [
                                -64.04613,
                                -42.31425
                            ],
                            [
                                -64.05793,
                                -42.38102
                            ],
                            [
                                -64.1248,
                                -42.42743
                            ],
                            [
                                -64.30333,
                                -42.4079
                            ],
                            [
                                -64.43671,
                                -42.43864
                            ],
                            [
                                -64.60439,
                                -42.42426
                            ],
                            [
                                -64.61447,
                                -42.39824
                            ],
                            [
                                -64.54167,
                                -42.29365
                            ],
                            [
                                -64.47783,
                                -42.23952
                            ],
                            [
                                -64.61082,
                                -42.23031
                            ],
                            [
                                -64.83142,
                                -42.19539
                            ],
                            [
                                -64.95663,
                                -42.14007
                            ],
                            [
                                -65.02937,
                                -42.07544
                            ],
                            [
                                -65.07239,
                                -41.96939
                            ],
                            [
                                -65.04705,
                                -41.84443
                            ],
                            [
                                -65.00237,
                                -41.76833
                            ],
                            [
                                -65.0247,
                                -41.62615
                            ],
                            [
                                -64.9908,
                                -41.51629
                            ],
                            [
                                -65.07353,
                                -41.40904
                            ],
                            [
                                -65.15055,
                                -41.17124
                            ],
                            [
                                -65.16331,
                                -40.96523
                            ],
                            [
                                -65.12051,
                                -40.84657
                            ],
                            [
                                -65.01573,
                                -40.76472
                            ],
                            [
                                -64.80248,
                                -40.73339
                            ],
                            [
                                -64.74585,
                                -40.81946
                            ],
                            [
                                -64.54295,
                                -40.86501
                            ],
                            [
                                -64.19681,
                                -41.00991
                            ],
                            [
                                -64.13165,
                                -41.01135
                            ],
                            [
                                -63.98175,
                                -41.06419
                            ],
                            [
                                -63.87269,
                                -41.13462
                            ],
                            [
                                -63.78249,
                                -41.15737
                            ],
                            [
                                -63.44559,
                                -41.16122
                            ],
                            [
                                -63.3211,
                                -41.15166
                            ],
                            [
                                -63.14489,
                                -41.1566
                            ],
                            [
                                -63.05158,
                                -41.14122
                            ],
                            [
                                -62.88296,
                                -41.07776
                            ],
                            [
                                -62.79157,
                                -41.02704
                            ],
                            [
                                -62.71758,
                                -41.03168
                            ],
                            [
                                -62.52461,
                                -40.94967
                            ],
                            [
                                -62.4075,
                                -40.91766
                            ],
                            [
                                -62.30425,
                                -40.85343
                            ],
                            [
                                -62.22927,
                                -40.68808
                            ],
                            [
                                -62.17312,
                                -40.61824
                            ],
                            [
                                -62.18951,
                                -40.57324
                            ],
                            [
                                -62.41726,
                                -40.46226
                            ],
                            [
                                -62.48199,
                                -40.32772
                            ],
                            [
                                -62.43803,
                                -40.24663
                            ],
                            [
                                -62.34521,
                                -40.19381
                            ],
                            [
                                -62.34777,
                                -40.06992
                            ],
                            [
                                -62.31026,
                                -39.87567
                            ],
                            [
                                -62.22634,
                                -39.88077
                            ],
                            [
                                -62.11773,
                                -39.84139
                            ],
                            [
                                -62.09992,
                                -39.70584
                            ],
                            [
                                -62.11944,
                                -39.66582
                            ],
                            [
                                -62.05789,
                                -39.44228
                            ],
                            [
                                -62.26032,
                                -39.34581
                            ],
                            [
                                -62.18489,
                                -39.30154
                            ],
                            [
                                -62.08803,
                                -39.38825
                            ],
                            [
                                -62.00729,
                                -39.36871
                            ],
                            [
                                -62.12222,
                                -39.29558
                            ],
                            [
                                -62.27466,
                                -39.26882
                            ],
                            [
                                -62.34216,
                                -39.16264
                            ],
                            [
                                -62.35318,
                                -39.10075
                            ],
                            [
                                -62.29889,
                                -39.02926
                            ],
                            [
                                -62.34209,
                                -38.95389
                            ],
                            [
                                -62.32435,
                                -38.90004
                            ],
                            [
                                -62.39708,
                                -38.82327
                            ],
                            [
                                -62.51464,
                                -38.81621
                            ],
                            [
                                -62.55727,
                                -38.75704
                            ],
                            [
                                -62.35782,
                                -38.71619
                            ],
                            [
                                -62.30527,
                                -38.77406
                            ],
                            [
                                -62.13882,
                                -38.82225
                            ],
                            [
                                -62.10689,
                                -38.88954
                            ],
                            [
                                -62.04747,
                                -38.92906
                            ],
                            [
                                -61.81086,
                                -38.99178
                            ],
                            [
                                -61.69438,
                                -38.96896
                            ],
                            [
                                -61.61772,
                                -39.00368
                            ],
                            [
                                -61.39873,
                                -38.98959
                            ],
                            [
                                -61.11842,
                                -38.9986
                            ],
                            [
                                -61.01196,
                                -38.98232
                            ],
                            [
                                -60.84488,
                                -38.97961
                            ],
                            [
                                -60.66461,
                                -38.94766
                            ],
                            [
                                -60.42593,
                                -38.92009
                            ],
                            [
                                -60.07789,
                                -38.86126
                            ],
                            [
                                -59.78261,
                                -38.82548
                            ],
                            [
                                -59.6767,
                                -38.7948
                            ],
                            [
                                -59.39246,
                                -38.75096
                            ],
                            [
                                -59.01327,
                                -38.67892
                            ],
                            [
                                -58.7334,
                                -38.58668
                            ],
                            [
                                -58.53459,
                                -38.54642
                            ],
                            [
                                -58.27575,
                                -38.46411
                            ],
                            [
                                -57.85149,
                                -38.29567
                            ],
                            [
                                -57.63607,
                                -38.1717
                            ],
                            [
                                -57.54678,
                                -38.10118
                            ],
                            [
                                -57.52468,
                                -38.01741
                            ],
                            [
                                -57.54198,
                                -37.97242
                            ],
                            [
                                -57.51302,
                                -37.86615
                            ],
                            [
                                -57.40711,
                                -37.73191
                            ],
                            [
                                -57.12591,
                                -37.4932
                            ],
                            [
                                -56.99148,
                                -37.29196
                            ],
                            [
                                -56.66539,
                                -36.87478
                            ],
                            [
                                -56.6994,
                                -36.4156
                            ],
                            [
                                -56.75117,
                                -36.34195
                            ],
                            [
                                -56.99777,
                                -36.33895
                            ],
                            [
                                -57.08124,
                                -36.29744
                            ],
                            [
                                -57.25453,
                                -36.1617
                            ],
                            [
                                -57.37537,
                                -35.97132
                            ],
                            [
                                -57.38541,
                                -35.81686
                            ],
                            [
                                -57.25623,
                                -35.61834
                            ],
                            [
                                -57.12607,
                                -35.46783
                            ],
                            [
                                -57.13548,
                                -35.39318
                            ],
                            [
                                -57.19509,
                                -35.30821
                            ],
                            [
                                -57.34427,
                                -35.15259
                            ],
                            [
                                -57.52227,
                                -35.02627
                            ],
                            [
                                -57.73031,
                                -34.92493
                            ],
                            [
                                -57.8753,
                                -34.8381
                            ],
                            [
                                -57.94364,
                                -34.83602
                            ],
                            [
                                -58.02061,
                                -34.78458
                            ],
                            [
                                -58.19195,
                                -34.74465
                            ],
                            [
                                -58.32538,
                                -34.66127
                            ],
                            [
                                -58.37683,
                                -34.58669
                            ],
                            [
                                -58.4674,
                                -34.53847
                            ],
                            [
                                -58.52752,
                                -34.43296
                            ],
                            [
                                -58.49611,
                                -34.35198
                            ],
                            [
                                -58.53889,
                                -34.27061
                            ],
                            [
                                -58.42325,
                                -34.25215
                            ],
                            [
                                -58.38231,
                                -34.1986
                            ],
                            [
                                -58.38176,
                                -34.05005
                            ],
                            [
                                -58.44164,
                                -34.00827
                            ],
                            [
                                -58.453,
                                -33.85599
                            ],
                            [
                                -58.51757,
                                -33.80303
                            ],
                            [
                                -58.55474,
                                -33.72053
                            ],
                            [
                                -58.52346,
                                -33.45735
                            ],
                            [
                                -58.41524,
                                -33.30914
                            ],
                            [
                                -58.43393,
                                -33.25226
                            ],
                            [
                                -58.40987,
                                -33.07613
                            ],
                            [
                                -58.1767,
                                -33.07168
                            ],
                            [
                                -58.13027,
                                -33.02645
                            ],
                            [
                                -58.11375,
                                -32.88603
                            ],
                            [
                                -58.1487,
                                -32.72786
                            ],
                            [
                                -58.14354,
                                -32.66672
                            ],
                            [
                                -58.20379,
                                -32.46778
                            ],
                            [
                                -58.18104,
                                -32.37259
                            ],
                            [
                                -58.11189,
                                -32.32523
                            ],
                            [
                                -58.10383,
                                -32.24523
                            ],
                            [
                                -58.18052,
                                -32.16017
                            ],
                            [
                                -58.1387,
                                -32.02074
                            ],
                            [
                                -58.19907,
                                -31.87125
                            ],
                            [
                                -58.07905,
                                -31.82077
                            ],
                            [
                                -58.04511,
                                -31.76122
                            ],
                            [
                                -57.98111,
                                -31.58305
                            ],
                            [
                                -58.00626,
                                -31.52886
                            ],
                            [
                                -58.08103,
                                -31.45888
                            ],
                            [
                                -57.98361,
                                -31.39124
                            ],
                            [
                                -57.98081,
                                -31.32043
                            ],
                            [
                                -57.90925,
                                -31.20621
                            ],
                            [
                                -57.90648,
                                -31.11078
                            ],
                            [
                                -57.86771,
                                -31.00513
                            ],
                            [
                                -57.90315,
                                -30.93036
                            ],
                            [
                                -57.81339,
                                -30.92478
                            ],
                            [
                                -57.80738,
                                -30.69793
                            ],
                            [
                                -57.88946,
                                -30.58779
                            ],
                            [
                                -57.89335,
                                -30.50968
                            ],
                            [
                                -57.64584,
                                -30.34305
                            ],
                            [
                                -57.61616,
                                -30.25358
                            ],
                            [
                                -57.61898,
                                -30.1759
                            ],
                            [
                                -57.53816,
                                -30.15785
                            ],
                            [
                                -57.46328,
                                -30.10816
                            ],
                            [
                                -57.43551,
                                -30.05656
                            ],
                            [
                                -57.32853,
                                -29.97138
                            ],
                            [
                                -57.32734,
                                -29.87974
                            ],
                            [
                                -57.23156,
                                -29.77984
                            ],
                            [
                                -57.12709,
                                -29.76659
                            ],
                            [
                                -57.03729,
                                -29.699
                            ],
                            [
                                -56.904,
                                -29.53596
                            ],
                            [
                                -56.81836,
                                -29.48651
                            ],
                            [
                                -56.77186,
                                -29.38473
                            ],
                            [
                                -56.70891,
                                -29.3648
                            ],
                            [
                                -56.65913,
                                -29.28654
                            ],
                            [
                                -56.64502,
                                -29.1965
                            ],
                            [
                                -56.59459,
                                -29.12427
                            ],
                            [
                                -56.43371,
                                -29.08008
                            ],
                            [
                                -56.38427,
                                -28.9518
                            ],
                            [
                                -56.30038,
                                -28.89593
                            ],
                            [
                                -56.30056,
                                -28.81607
                            ],
                            [
                                -56.2632,
                                -28.77952
                            ],
                            [
                                -56.19575,
                                -28.77398
                            ],
                            [
                                -56.12384,
                                -28.68581
                            ],
                            [
                                -56.00892,
                                -28.6054
                            ],
                            [
                                -56.01209,
                                -28.50854
                            ],
                            [
                                -55.88401,
                                -28.47727
                            ],
                            [
                                -55.90227,
                                -28.40937
                            ],
                            [
                                -55.87503,
                                -28.35995
                            ],
                            [
                                -55.75625,
                                -28.36987
                            ],
                            [
                                -55.69624,
                                -28.4225
                            ],
                            [
                                -55.6705,
                                -28.33394
                            ],
                            [
                                -55.77745,
                                -28.24624
                            ],
                            [
                                -55.63179,
                                -28.17435
                            ],
                            [
                                -55.56,
                                -28.16219
                            ],
                            [
                                -55.49524,
                                -28.07994
                            ],
                            [
                                -55.44788,
                                -28.09562
                            ],
                            [
                                -55.38494,
                                -28.04092
                            ],
                            [
                                -55.33284,
                                -27.93568
                            ],
                            [
                                -55.26628,
                                -27.9276
                            ],
                            [
                                -55.23041,
                                -27.88238
                            ],
                            [
                                -55.09967,
                                -27.84697
                            ],
                            [
                                -55.04327,
                                -27.85665
                            ],
                            [
                                -55.02628,
                                -27.79251
                            ],
                            [
                                -54.93852,
                                -27.77171
                            ],
                            [
                                -54.90496,
                                -27.72311
                            ],
                            [
                                -54.90491,
                                -27.6399
                            ],
                            [
                                -54.84051,
                                -27.60539
                            ],
                            [
                                -54.8275,
                                -27.55688
                            ],
                            [
                                -54.68193,
                                -27.57339
                            ],
                            [
                                -54.61735,
                                -27.53255
                            ],
                            [
                                -54.59097,
                                -27.46253
                            ],
                            [
                                -54.53714,
                                -27.50137
                            ],
                            [
                                -54.44514,
                                -27.46243
                            ],
                            [
                                -54.27018,
                                -27.43439
                            ],
                            [
                                -54.15245,
                                -27.296
                            ],
                            [
                                -54.07287,
                                -27.28986
                            ],
                            [
                                -54.00864,
                                -27.20076
                            ],
                            [
                                -53.88246,
                                -27.13268
                            ],
                            [
                                -53.78312,
                                -27.09775
                            ],
                            [
                                -53.66429,
                                -26.85871
                            ],
                            [
                                -53.74627,
                                -26.739
                            ],
                            [
                                -53.72121,
                                -26.6817
                            ],
                            [
                                -53.74122,
                                -26.63868
                            ],
                            [
                                -53.72863,
                                -26.50577
                            ],
                            [
                                -53.70104,
                                -26.44382
                            ],
                            [
                                -53.65051,
                                -26.40601
                            ],
                            [
                                -53.59882,
                                -26.26233
                            ],
                            [
                                -53.72029,
                                -26.12933
                            ],
                            [
                                -53.72145,
                                -26.07715
                            ],
                            [
                                -53.83509,
                                -25.96819
                            ],
                            [
                                -53.8229,
                                -25.92467
                            ],
                            [
                                -53.84791,
                                -25.83612
                            ],
                            [
                                -53.86224,
                                -25.66231
                            ],
                            [
                                -53.95104,
                                -25.62233
                            ],
                            [
                                -54.01067,
                                -25.56816
                            ],
                            [
                                -54.09242,
                                -25.61166
                            ],
                            [
                                -54.12336,
                                -25.56617
                            ],
                            [
                                -54.19121,
                                -25.53536
                            ],
                            [
                                -54.23804,
                                -25.59227
                            ],
                            [
                                -54.29017,
                                -25.55682
                            ],
                            [
                                -54.38966,
                                -25.60656
                            ],
                            [
                                -54.4238,
                                -25.65872
                            ],
                            [
                                -54.53779,
                                -25.59873
                            ],
                            [
                                -54.5941,
                                -25.59227
                            ],
                            [
                                -54.58206,
                                -25.65676
                            ],
                            [
                                -54.65854,
                                -25.68032
                            ],
                            [
                                -54.58905,
                                -25.83895
                            ],
                            [
                                -54.62257,
                                -25.91502
                            ],
                            [
                                -54.62275,
                                -25.98508
                            ],
                            [
                                -54.67759,
                                -26.01578
                            ],
                            [
                                -54.6503,
                                -26.06605
                            ],
                            [
                                -54.6742,
                                -26.14192
                            ],
                            [
                                -54.62419,
                                -26.22309
                            ],
                            [
                                -54.67682,
                                -26.25942
                            ],
                            [
                                -54.64972,
                                -26.31379
                            ],
                            [
                                -54.6966,
                                -26.37658
                            ],
                            [
                                -54.71871,
                                -26.4613
                            ],
                            [
                                -54.78377,
                                -26.5116
                            ],
                            [
                                -54.78551,
                                -26.60626
                            ],
                            [
                                -54.81291,
                                -26.66731
                            ],
                            [
                                -54.94087,
                                -26.68143
                            ],
                            [
                                -54.94993,
                                -26.7685
                            ],
                            [
                                -55.05289,
                                -26.7974
                            ],
                            [
                                -55.14096,
                                -26.86525
                            ],
                            [
                                -55.13949,
                                -26.9507
                            ],
                            [
                                -55.2413,
                                -26.94174
                            ],
                            [
                                -55.37994,
                                -26.96735
                            ],
                            [
                                -55.45341,
                                -27.04399
                            ],
                            [
                                -55.45489,
                                -27.10251
                            ],
                            [
                                -55.54488,
                                -27.10274
                            ],
                            [
                                -55.6069,
                                -27.16299
                            ],
                            [
                                -55.58561,
                                -27.2324
                            ],
                            [
                                -55.60362,
                                -27.34032
                            ],
                            [
                                -55.6863,
                                -27.38027
                            ],
                            [
                                -55.73572,
                                -27.44275
                            ],
                            [
                                -55.85922,
                                -27.39791
                            ],
                            [
                                -55.89448,
                                -27.34078
                            ],
                            [
                                -55.98541,
                                -27.33797
                            ],
                            [
                                -56.08155,
                                -27.30514
                            ],
                            [
                                -56.18447,
                                -27.33636
                            ],
                            [
                                -56.19853,
                                -27.37626
                            ],
                            [
                                -56.26874,
                                -27.38286
                            ],
                            [
                                -56.3143,
                                -27.42421
                            ],
                            [
                                -56.29751,
                                -27.49276
                            ],
                            [
                                -56.37368,
                                -27.57524
                            ],
                            [
                                -56.47995,
                                -27.56159
                            ],
                            [
                                -56.5398,
                                -27.45868
                            ],
                            [
                                -56.59845,
                                -27.43169
                            ],
                            [
                                -56.69185,
                                -27.44363
                            ],
                            [
                                -56.76169,
                                -27.49472
                            ],
                            [
                                -56.88857,
                                -27.41359
                            ],
                            [
                                -56.93348,
                                -27.41301
                            ],
                            [
                                -57.05521,
                                -27.48216
                            ],
                            [
                                -57.23377,
                                -27.46627
                            ],
                            [
                                -57.32652,
                                -27.41293
                            ],
                            [
                                -57.39396,
                                -27.41671
                            ],
                            [
                                -57.5937,
                                -27.38013
                            ],
                            [
                                -57.72826,
                                -27.33062
                            ],
                            [
                                -57.82872,
                                -27.3192
                            ],
                            [
                                -57.89831,
                                -27.27026
                            ],
                            [
                                -58.14443,
                                -27.26993
                            ],
                            [
                                -58.29835,
                                -27.25373
                            ],
                            [
                                -58.41252,
                                -27.27777
                            ],
                            [
                                -58.60618,
                                -27.29672
                            ],
                            [
                                -58.59441,
                                -27.22503
                            ],
                            [
                                -58.6541,
                                -27.19245
                            ],
                            [
                                -58.65153,
                                -27.13089
                            ],
                            [
                                -58.55499,
                                -27.1086
                            ],
                            [
                                -58.55144,
                                -27.03454
                            ],
                            [
                                -58.46865,
                                -26.99094
                            ],
                            [
                                -58.46076,
                                -26.92915
                            ],
                            [
                                -58.38406,
                                -26.89209
                            ],
                            [
                                -58.3356,
                                -26.81965
                            ],
                            [
                                -58.24601,
                                -26.74232
                            ],
                            [
                                -58.19341,
                                -26.59145
                            ],
                            [
                                -58.22063,
                                -26.54549
                            ],
                            [
                                -58.21233,
                                -26.37965
                            ],
                            [
                                -58.17353,
                                -26.36289
                            ],
                            [
                                -58.15928,
                                -26.26085
                            ],
                            [
                                -58.11164,
                                -26.24207
                            ],
                            [
                                -58.12073,
                                -26.15909
                            ],
                            [
                                -57.85257,
                                -26.00492
                            ],
                            [
                                -57.89427,
                                -25.95667
                            ],
                            [
                                -57.83828,
                                -25.90335
                            ],
                            [
                                -57.81847,
                                -25.78248
                            ],
                            [
                                -57.73297,
                                -25.72352
                            ],
                            [
                                -57.7477,
                                -25.65759
                            ],
                            [
                                -57.61291,
                                -25.61175
                            ],
                            [
                                -57.556,
                                -25.44637
                            ],
                            [
                                -57.64298,
                                -25.37998
                            ],
                            [
                                -57.69212,
                                -25.28306
                            ],
                            [
                                -57.75584,
                                -25.2149
                            ],
                            [
                                -57.75552,
                                -25.17719
                            ],
                            [
                                -57.83676,
                                -25.1286
                            ],
                            [
                                -57.86172,
                                -25.08372
                            ],
                            [
                                -57.99842,
                                -25.07164
                            ],
                            [
                                -58.07015,
                                -25.04237
                            ],
                            [
                                -58.15258,
                                -24.97461
                            ],
                            [
                                -58.25522,
                                -24.93382
                            ],
                            [
                                -58.31146,
                                -24.98634
                            ],
                            [
                                -58.39055,
                                -24.95254
                            ],
                            [
                                -58.44335,
                                -24.88043
                            ],
                            [
                                -58.57232,
                                -24.82191
                            ],
                            [
                                -58.67133,
                                -24.83031
                            ],
                            [
                                -58.72607,
                                -24.77719
                            ],
                            [
                                -58.80622,
                                -24.77123
                            ],
                            [
                                -58.97421,
                                -24.66288
                            ],
                            [
                                -59.12407,
                                -24.61815
                            ],
                            [
                                -59.18753,
                                -24.56406
                            ],
                            [
                                -59.34616,
                                -24.485
                            ],
                            [
                                -59.47575,
                                -24.33226
                            ],
                            [
                                -60.02568,
                                -24.00746
                            ],
                            [
                                -60.1221,
                                -24.03959
                            ],
                            [
                                -60.2985,
                                -24.04816
                            ],
                            [
                                -60.37365,
                                -24.02532
                            ],
                            [
                                -60.45327,
                                -23.96513
                            ],
                            [
                                -60.56745,
                                -23.9554
                            ],
                            [
                                -60.60313,
                                -23.90437
                            ],
                            [
                                -60.66274,
                                -23.90536
                            ],
                            [
                                -60.76505,
                                -23.87235
                            ],
                            [
                                -60.8369,
                                -23.87059
                            ],
                            [
                                -60.93005,
                                -23.80697
                            ],
                            [
                                -61.00638,
                                -23.78824
                            ],
                            [
                                -61.09793,
                                -23.65925
                            ],
                            [
                                -61.09765,
                                -23.61558
                            ],
                            [
                                -61.17336,
                                -23.5527
                            ],
                            [
                                -61.23822,
                                -23.54824
                            ],
                            [
                                -61.35943,
                                -23.45173
                            ],
                            [
                                -61.39708,
                                -23.4602
                            ],
                            [
                                -61.49114,
                                -23.41938
                            ],
                            [
                                -61.58164,
                                -23.3061
                            ],
                            [
                                -61.67086,
                                -23.28388
                            ],
                            [
                                -61.73616,
                                -23.23882
                            ],
                            [
                                -61.77632,
                                -23.16954
                            ],
                            [
                                -61.86785,
                                -23.09103
                            ],
                            [
                                -61.9886,
                                -23.02152
                            ],
                            [
                                -62.04771,
                                -22.87209
                            ],
                            [
                                -62.19822,
                                -22.71328
                            ],
                            [
                                -62.20064,
                                -22.66492
                            ],
                            [
                                -62.25896,
                                -22.59425
                            ],
                            [
                                -62.2275,
                                -22.55177
                            ],
                            [
                                -62.35311,
                                -22.45621
                            ],
                            [
                                -62.38323,
                                -22.45901
                            ],
                            [
                                -62.47548,
                                -22.37685
                            ],
                            [
                                -62.53612,
                                -22.36783
                            ],
                            [
                                -62.6452,
                                -22.25047
                            ],
                            [
                                -62.69134,
                                -22.19552
                            ],
                            [
                                -62.80942,
                                -22.13658
                            ],
                            [
                                -62.79594,
                                -22.06385
                            ],
                            [
                                -62.81278,
                                -21.99949
                            ],
                            [
                                -63.93168,
                                -22.00155
                            ],
                            [
                                -63.96037,
                                -22.08323
                            ],
                            [
                                -64.06061,
                                -22.24107
                            ],
                            [
                                -64.12058,
                                -22.40022
                            ],
                            [
                                -64.23911,
                                -22.55685
                            ],
                            [
                                -64.26889,
                                -22.66005
                            ],
                            [
                                -64.28154,
                                -22.82593
                            ],
                            [
                                -64.32808,
                                -22.82313
                            ],
                            [
                                -64.34088,
                                -22.75099
                            ],
                            [
                                -64.39905,
                                -22.71791
                            ],
                            [
                                -64.43823,
                                -22.6388
                            ],
                            [
                                -64.41398,
                                -22.54009
                            ],
                            [
                                -64.47954,
                                -22.48044
                            ],
                            [
                                -64.49313,
                                -22.43763
                            ],
                            [
                                -64.56443,
                                -22.37437
                            ],
                            [
                                -64.53484,
                                -22.28364
                            ],
                            [
                                -64.62063,
                                -22.20409
                            ],
                            [
                                -64.73411,
                                -22.19241
                            ],
                            [
                                -64.87101,
                                -22.11908
                            ],
                            [
                                -64.99233,
                                -22.08693
                            ],
                            [
                                -65.46241,
                                -22.08836
                            ],
                            [
                                -65.5721,
                                -22.07711
                            ],
                            [
                                -65.65957,
                                -22.10908
                            ],
                            [
                                -65.74725,
                                -22.10638
                            ],
                            [
                                -65.80798,
                                -22.06923
                            ],
                            [
                                -65.92396,
                                -21.92428
                            ],
                            [
                                -66.06242,
                                -21.91632
                            ],
                            [
                                -66.0937,
                                -21.8236
                            ],
                            [
                                -66.22184,
                                -21.78366
                            ],
                            [
                                -66.28124,
                                -21.98298
                            ],
                            [
                                -66.29196,
                                -22.0857
                            ],
                            [
                                -66.35602,
                                -22.12924
                            ],
                            [
                                -66.73555,
                                -22.23408
                            ],
                            [
                                -66.7844,
                                -22.4362
                            ],
                            [
                                -66.92508,
                                -22.48853
                            ],
                            [
                                -66.97608,
                                -22.53334
                            ],
                            [
                                -67.03033,
                                -22.53504
                            ],
                            [
                                -67.01514,
                                -22.6529
                            ],
                            [
                                -67.13215,
                                -22.71897
                            ],
                            [
                                -67.1775,
                                -22.80469
                            ],
                            [
                                -66.98865,
                                -22.99421
                            ],
                            [
                                -67.15566,
                                -23.5202
                            ],
                            [
                                -67.29349,
                                -23.94925
                            ],
                            [
                                -67.34402,
                                -24.03773
                            ],
                            [
                                -67.63436,
                                -24.15474
                            ],
                            [
                                -68.21554,
                                -24.38086
                            ],
                            [
                                -68.28139,
                                -24.42022
                            ],
                            [
                                -68.31743,
                                -24.48372
                            ],
                            [
                                -68.40359,
                                -24.48653
                            ],
                            [
                                -68.40448,
                                -24.54719
                            ],
                            [
                                -68.49623,
                                -24.64518
                            ],
                            [
                                -68.56744,
                                -24.7507
                            ],
                            [
                                -68.57676,
                                -24.81647
                            ],
                            [
                                -68.45539,
                                -24.92896
                            ],
                            [
                                -68.35374,
                                -25.09211
                            ],
                            [
                                -68.40544,
                                -25.1394
                            ],
                            [
                                -68.4772,
                                -25.13164
                            ],
                            [
                                -68.57909,
                                -25.19605
                            ],
                            [
                                -68.55088,
                                -25.31979
                            ],
                            [
                                -68.58354,
                                -25.44608
                            ],
                            [
                                -68.55632,
                                -25.52143
                            ],
                            [
                                -68.55895,
                                -25.65699
                            ],
                            [
                                -68.48068,
                                -25.72138
                            ],
                            [
                                -68.39124,
                                -26.18775
                            ],
                            [
                                -68.56889,
                                -26.3066
                            ],
                            [
                                -68.58587,
                                -26.51057
                            ],
                            [
                                -68.42427,
                                -26.74195
                            ],
                            [
                                -68.30906,
                                -26.89177
                            ],
                            [
                                -68.32657,
                                -27.04184
                            ],
                            [
                                -68.48041,
                                -27.06485
                            ],
                            [
                                -68.54689,
                                -27.18724
                            ],
                            [
                                -68.60888,
                                -27.16828
                            ],
                            [
                                -68.68486,
                                -27.08429
                            ],
                            [
                                -68.77009,
                                -27.10509
                            ],
                            [
                                -68.85178,
                                -27.17969
                            ],
                            [
                                -68.87592,
                                -27.25212
                            ],
                            [
                                -68.85254,
                                -27.29487
                            ],
                            [
                                -68.90192,
                                -27.37849
                            ],
                            [
                                -68.96529,
                                -27.43701
                            ],
                            [
                                -69.00324,
                                -27.55447
                            ],
                            [
                                -69.06002,
                                -27.63937
                            ],
                            [
                                -69.04968,
                                -27.69857
                            ],
                            [
                                -69.08481,
                                -27.72936
                            ],
                            [
                                -69.11258,
                                -27.89212
                            ],
                            [
                                -69.18256,
                                -27.97376
                            ],
                            [
                                -69.24307,
                                -27.98935
                            ],
                            [
                                -69.28999,
                                -28.06699
                            ],
                            [
                                -69.28329,
                                -28.13487
                            ],
                            [
                                -69.38417,
                                -28.21223
                            ],
                            [
                                -69.44792,
                                -28.20825
                            ],
                            [
                                -69.50354,
                                -28.33693
                            ],
                            [
                                -69.64115,
                                -28.38072
                            ],
                            [
                                -69.65066,
                                -28.58228
                            ],
                            [
                                -69.71543,
                                -28.66368
                            ],
                            [
                                -69.7329,
                                -28.72253
                            ],
                            [
                                -69.69832,
                                -28.79757
                            ],
                            [
                                -69.75474,
                                -28.95887
                            ],
                            [
                                -69.75411,
                                -29.06308
                            ],
                            [
                                -69.79611,
                                -29.15462
                            ],
                            [
                                -69.85917,
                                -29.1465
                            ],
                            [
                                -69.93399,
                                -29.20816
                            ],
                            [
                                -69.95138,
                                -29.27557
                            ],
                            [
                                -70.00612,
                                -29.35601
                            ],
                            [
                                -69.93252,
                                -29.53096
                            ],
                            [
                                -69.94054,
                                -29.62096
                            ],
                            [
                                -69.87907,
                                -29.68142
                            ],
                            [
                                -69.86305,
                                -29.83957
                            ],
                            [
                                -69.87116,
                                -29.9217
                            ],
                            [
                                -69.93779,
                                -30.07682
                            ],
                            [
                                -69.81073,
                                -30.14465
                            ],
                            [
                                -69.81742,
                                -30.21645
                            ],
                            [
                                -69.91272,
                                -30.35149
                            ],
                            [
                                -69.97152,
                                -30.39621
                            ],
                            [
                                -70.07036,
                                -30.38486
                            ],
                            [
                                -70.15815,
                                -30.48498
                            ],
                            [
                                -70.21934,
                                -30.61766
                            ],
                            [
                                -70.21975,
                                -30.7106
                            ],
                            [
                                -70.27589,
                                -30.78874
                            ],
                            [
                                -70.30414,
                                -30.89822
                            ],
                            [
                                -70.29153,
                                -30.96646
                            ],
                            [
                                -70.30989,
                                -31.05371
                            ],
                            [
                                -70.39127,
                                -31.16881
                            ],
                            [
                                -70.45332,
                                -31.09443
                            ],
                            [
                                -70.51018,
                                -31.16318
                            ],
                            [
                                -70.53731,
                                -31.32682
                            ],
                            [
                                -70.55266,
                                -31.56023
                            ],
                            [
                                -70.49573,
                                -31.68787
                            ],
                            [
                                -70.45757,
                                -31.72512
                            ],
                            [
                                -70.44649,
                                -31.83303
                            ],
                            [
                                -70.36467,
                                -31.88736
                            ],
                            [
                                -70.27259,
                                -31.89509
                            ],
                            [
                                -70.21041,
                                -31.98769
                            ],
                            [
                                -70.27874,
                                -32.04314
                            ],
                            [
                                -70.36542,
                                -32.03405
                            ],
                            [
                                -70.29803,
                                -32.15762
                            ],
                            [
                                -70.31875,
                                -32.26318
                            ],
                            [
                                -70.23211,
                                -32.32105
                            ],
                            [
                                -70.22057,
                                -32.44019
                            ],
                            [
                                -70.14168,
                                -32.48583
                            ],
                            [
                                -70.12938,
                                -32.5619
                            ],
                            [
                                -70.16855,
                                -32.61351
                            ],
                            [
                                -70.14854,
                                -32.71788
                            ],
                            [
                                -70.10657,
                                -32.79665
                            ],
                            [
                                -70.00839,
                                -32.88821
                            ],
                            [
                                -70.0484,
                                -33.01897
                            ],
                            [
                                -70.09094,
                                -33.04259
                            ],
                            [
                                -70.0692,
                                -33.15545
                            ],
                            [
                                -70.01527,
                                -33.32441
                            ],
                            [
                                -69.9518,
                                -33.3102
                            ],
                            [
                                -69.90894,
                                -33.232
                            ],
                            [
                                -69.86117,
                                -33.2386
                            ],
                            [
                                -69.77881,
                                -33.33436
                            ],
                            [
                                -69.75218,
                                -33.44445
                            ],
                            [
                                -69.83865,
                                -33.5002
                            ],
                            [
                                -69.87062,
                                -33.56688
                            ],
                            [
                                -69.8843,
                                -33.68
                            ],
                            [
                                -69.86161,
                                -33.76256
                            ],
                            [
                                -69.89048,
                                -33.79776
                            ],
                            [
                                -69.86454,
                                -33.94311
                            ],
                            [
                                -69.83394,
                                -33.97553
                            ],
                            [
                                -69.8716,
                                -34.11654
                            ],
                            [
                                -69.83851,
                                -34.24667
                            ],
                            [
                                -69.92234,
                                -34.29181
                            ],
                            [
                                -69.98752,
                                -34.25921
                            ],
                            [
                                -70.0386,
                                -34.29321
                            ],
                            [
                                -70.01555,
                                -34.40489
                            ],
                            [
                                -70.13095,
                                -34.49241
                            ],
                            [
                                -70.22238,
                                -34.62275
                            ],
                            [
                                -70.22735,
                                -34.67637
                            ],
                            [
                                -70.3117,
                                -34.76632
                            ],
                            [
                                -70.26868,
                                -34.79101
                            ],
                            [
                                -70.28102,
                                -34.85195
                            ],
                            [
                                -70.33784,
                                -34.93049
                            ],
                            [
                                -70.371,
                                -35.04864
                            ],
                            [
                                -70.3586,
                                -35.1229
                            ],
                            [
                                -70.3988,
                                -35.17812
                            ],
                            [
                                -70.5452,
                                -35.20569
                            ],
                            [
                                -70.57675,
                                -35.26033
                            ],
                            [
                                -70.54055,
                                -35.30428
                            ],
                            [
                                -70.42208,
                                -35.35113
                            ],
                            [
                                -70.44224,
                                -35.4461
                            ],
                            [
                                -70.39109,
                                -35.52483
                            ],
                            [
                                -70.40121,
                                -35.62952
                            ],
                            [
                                -70.32653,
                                -35.81375
                            ],
                            [
                                -70.4155,
                                -35.89733
                            ],
                            [
                                -70.37307,
                                -36.03286
                            ],
                            [
                                -70.41955,
                                -36.14422
                            ],
                            [
                                -70.47073,
                                -36.17038
                            ],
                            [
                                -70.56847,
                                -36.12558
                            ],
                            [
                                -70.63482,
                                -36.22918
                            ],
                            [
                                -70.6962,
                                -36.25171
                            ],
                            [
                                -70.7048,
                                -36.41048
                            ],
                            [
                                -70.8913,
                                -36.39187
                            ],
                            [
                                -70.88858,
                                -36.43973
                            ],
                            [
                                -70.95747,
                                -36.48254
                            ],
                            [
                                -71.03789,
                                -36.47314
                            ],
                            [
                                -71.05016,
                                -36.59676
                            ],
                            [
                                -71.02386,
                                -36.64849
                            ],
                            [
                                -71.11186,
                                -36.66165
                            ],
                            [
                                -71.13027,
                                -36.79454
                            ],
                            [
                                -71.16441,
                                -36.83228
                            ],
                            [
                                -71.10278,
                                -36.95121
                            ],
                            [
                                -71.1554,
                                -37.00174
                            ],
                            [
                                -71.13279,
                                -37.07444
                            ],
                            [
                                -71.14418,
                                -37.2081
                            ],
                            [
                                -71.20741,
                                -37.27924
                            ],
                            [
                                -71.18442,
                                -37.3761
                            ],
                            [
                                -71.11862,
                                -37.48178
                            ],
                            [
                                -71.13937,
                                -37.59268
                            ],
                            [
                                -71.20211,
                                -37.68123
                            ],
                            [
                                -71.10411,
                                -37.88562
                            ],
                            [
                                -71.08993,
                                -37.96969
                            ],
                            [
                                -71.03781,
                                -38.06178
                            ],
                            [
                                -71.01634,
                                -38.16832
                            ],
                            [
                                -71.03513,
                                -38.25044
                            ],
                            [
                                -71.00438,
                                -38.40513
                            ],
                            [
                                -70.83352,
                                -38.55671
                            ],
                            [
                                -70.94785,
                                -38.74508
                            ],
                            [
                                -71.08922,
                                -38.75379
                            ],
                            [
                                -71.42151,
                                -38.92404
                            ],
                            [
                                -71.43723,
                                -39.04229
                            ],
                            [
                                -71.38773,
                                -39.20872
                            ],
                            [
                                -71.39143,
                                -39.30378
                            ],
                            [
                                -71.47188,
                                -39.40144
                            ],
                            [
                                -71.49232,
                                -39.6167
                            ],
                            [
                                -71.60213,
                                -39.6267
                            ],
                            [
                                -71.66766,
                                -39.57323
                            ],
                            [
                                -71.71504,
                                -39.64761
                            ],
                            [
                                -71.70967,
                                -39.72909
                            ],
                            [
                                -71.67212,
                                -39.85665
                            ],
                            [
                                -71.59416,
                                -39.89106
                            ],
                            [
                                -71.61499,
                                -39.96334
                            ],
                            [
                                -71.68416,
                                -40.02678
                            ],
                            [
                                -71.66511,
                                -40.07934
                            ],
                            [
                                -71.71008,
                                -40.11313
                            ],
                            [
                                -71.791,
                                -40.07824
                            ],
                            [
                                -71.82674,
                                -40.21721
                            ],
                            [
                                -71.76172,
                                -40.27858
                            ],
                            [
                                -71.68174,
                                -40.29987
                            ],
                            [
                                -71.65484,
                                -40.36102
                            ],
                            [
                                -71.71975,
                                -40.43778
                            ],
                            [
                                -71.80572,
                                -40.41343
                            ],
                            [
                                -71.85008,
                                -40.5592
                            ],
                            [
                                -71.83129,
                                -40.62733
                            ],
                            [
                                -71.94533,
                                -40.7298
                            ],
                            [
                                -71.85822,
                                -40.91286
                            ],
                            [
                                -71.88863,
                                -40.9869
                            ],
                            [
                                -71.82961,
                                -41.05664
                            ],
                            [
                                -71.84252,
                                -41.25408
                            ],
                            [
                                -71.87899,
                                -41.37124
                            ],
                            [
                                -71.85859,
                                -41.50657
                            ],
                            [
                                -71.81943,
                                -41.57103
                            ],
                            [
                                -71.8922,
                                -41.62497
                            ],
                            [
                                -71.83369,
                                -41.73153
                            ],
                            [
                                -71.82635,
                                -41.79095
                            ],
                            [
                                -71.7623,
                                -41.86838
                            ],
                            [
                                -71.75909,
                                -42.02081
                            ],
                            [
                                -71.72856,
                                -42.11544
                            ],
                            [
                                -71.77595,
                                -42.14674
                            ],
                            [
                                -71.91722,
                                -42.18646
                            ],
                            [
                                -72.02845,
                                -42.14261
                            ],
                            [
                                -72.12168,
                                -42.31438
                            ],
                            [
                                -72.05064,
                                -42.37754
                            ],
                            [
                                -72.03407,
                                -42.50278
                            ],
                            [
                                -72.11724,
                                -42.56026
                            ],
                            [
                                -72.12713,
                                -42.6763
                            ],
                            [
                                -72.10182,
                                -42.76659
                            ],
                            [
                                -72.10994,
                                -42.9132
                            ],
                            [
                                -71.98423,
                                -43.03554
                            ],
                            [
                                -71.9665,
                                -43.09126
                            ],
                            [
                                -71.74122,
                                -43.17158
                            ],
                            [
                                -71.73009,
                                -43.30904
                            ],
                            [
                                -71.88387,
                                -43.32651
                            ],
                            [
                                -71.93033,
                                -43.44681
                            ],
                            [
                                -71.77595,
                                -43.54522
                            ],
                            [
                                -71.69362,
                                -43.62932
                            ],
                            [
                                -71.58744,
                                -43.65083
                            ],
                            [
                                -71.60605,
                                -43.70661
                            ],
                            [
                                -71.689,
                                -43.73483
                            ],
                            [
                                -71.75324,
                                -43.83988
                            ],
                            [
                                -71.65515,
                                -43.94629
                            ],
                            [
                                -71.78047,
                                -44.09168
                            ],
                            [
                                -71.85164,
                                -44.11487
                            ],
                            [
                                -71.79255,
                                -44.20548
                            ],
                            [
                                -71.81747,
                                -44.26594
                            ],
                            [
                                -71.78586,
                                -44.40624
                            ],
                            [
                                -71.4155,
                                -44.39465
                            ],
                            [
                                -71.3346,
                                -44.42134
                            ],
                            [
                                -71.21142,
                                -44.4276
                            ],
                            [
                                -71.11021,
                                -44.52308
                            ],
                            [
                                -71.13091,
                                -44.57968
                            ],
                            [
                                -71.20948,
                                -44.60589
                            ],
                            [
                                -71.23639,
                                -44.65525
                            ],
                            [
                                -71.21905,
                                -44.73935
                            ],
                            [
                                -71.30263,
                                -44.80799
                            ],
                            [
                                -71.38043,
                                -44.80099
                            ],
                            [
                                -71.48715,
                                -44.73526
                            ],
                            [
                                -71.60015,
                                -44.77855
                            ],
                            [
                                -71.78314,
                                -44.75513
                            ],
                            [
                                -71.83567,
                                -44.79365
                            ],
                            [
                                -72.06969,
                                -44.76837
                            ],
                            [
                                -72.03351,
                                -44.90615
                            ],
                            [
                                -71.8946,
                                -44.939
                            ],
                            [
                                -71.74612,
                                -44.92677
                            ],
                            [
                                -71.54205,
                                -45.00001
                            ],
                            [
                                -71.43855,
                                -45.15555
                            ],
                            [
                                -71.33313,
                                -45.22021
                            ],
                            [
                                -71.29825,
                                -45.30096
                            ],
                            [
                                -71.36043,
                                -45.35275
                            ],
                            [
                                -71.50374,
                                -45.39829
                            ],
                            [
                                -71.46422,
                                -45.45562
                            ],
                            [
                                -71.51189,
                                -45.52086
                            ],
                            [
                                -71.64644,
                                -45.51884
                            ],
                            [
                                -71.73205,
                                -45.54551
                            ],
                            [
                                -71.771,
                                -45.73731
                            ],
                            [
                                -71.73136,
                                -45.84796
                            ],
                            [
                                -71.63062,
                                -45.88811
                            ],
                            [
                                -71.5983,
                                -45.96413
                            ],
                            [
                                -71.72435,
                                -46.08861
                            ],
                            [
                                -71.88978,
                                -46.15274
                            ],
                            [
                                -71.74295,
                                -46.25306
                            ],
                            [
                                -71.73274,
                                -46.35408
                            ],
                            [
                                -71.66561,
                                -46.50722
                            ],
                            [
                                -71.67657,
                                -46.58047
                            ],
                            [
                                -71.64642,
                                -46.68125
                            ],
                            [
                                -71.76395,
                                -46.76286
                            ],
                            [
                                -71.92968,
                                -46.81137
                            ],
                            [
                                -71.94545,
                                -46.92725
                            ],
                            [
                                -71.9148,
                                -47.00471
                            ],
                            [
                                -71.97251,
                                -47.07087
                            ],
                            [
                                -71.85426,
                                -47.13847
                            ],
                            [
                                -71.84928,
                                -47.21798
                            ],
                            [
                                -71.88813,
                                -47.24011
                            ],
                            [
                                -71.99638,
                                -47.20314
                            ],
                            [
                                -72.00914,
                                -47.2626
                            ],
                            [
                                -72.15421,
                                -47.41404
                            ],
                            [
                                -72.32163,
                                -47.43329
                            ],
                            [
                                -72.28854,
                                -47.50626
                            ],
                            [
                                -72.30697,
                                -47.59165
                            ],
                            [
                                -72.40846,
                                -47.72309
                            ],
                            [
                                -72.4699,
                                -47.84952
                            ],
                            [
                                -72.52324,
                                -47.91269
                            ],
                            [
                                -72.5052,
                                -47.94918
                            ],
                            [
                                -72.33051,
                                -48.08717
                            ],
                            [
                                -72.29416,
                                -48.34898
                            ],
                            [
                                -72.39697,
                                -48.40396
                            ],
                            [
                                -72.49824,
                                -48.42054
                            ],
                            [
                                -72.59693,
                                -48.47634
                            ],
                            [
                                -72.54742,
                                -48.66977
                            ],
                            [
                                -72.56643,
                                -48.81126
                            ],
                            [
                                -72.7365,
                                -48.91836
                            ],
                            [
                                -72.83965,
                                -48.94818
                            ],
                            [
                                -72.92471,
                                -48.94515
                            ],
                            [
                                -73.08077,
                                -49.08343
                            ],
                            [
                                -73.09289,
                                -49.1342
                            ],
                            [
                                -73.21587,
                                -49.16252
                            ],
                            [
                                -73.26505,
                                -49.13887
                            ],
                            [
                                -73.39484,
                                -49.13881
                            ],
                            [
                                -73.4928,
                                -49.18069
                            ],
                            [
                                -73.4588,
                                -49.29952
                            ],
                            [
                                -73.46441,
                                -49.40217
                            ],
                            [
                                -73.52211,
                                -49.44718
                            ],
                            [
                                -73.5019,
                                -49.51239
                            ],
                            [
                                -73.57169,
                                -49.55447
                            ],
                            [
                                -73.50419,
                                -49.61003
                            ],
                            [
                                -73.52813,
                                -49.67171
                            ],
                            [
                                -73.45241,
                                -49.73447
                            ],
                            [
                                -73.44346,
                                -49.83891
                            ],
                            [
                                -73.54389,
                                -49.92498
                            ],
                            [
                                -73.50167,
                                -50.05824
                            ],
                            [
                                -73.57527,
                                -50.26202
                            ],
                            [
                                -73.5409,
                                -50.32924
                            ],
                            [
                                -73.4408,
                                -50.42795
                            ],
                            [
                                -73.16838,
                                -50.64694
                            ],
                            [
                                -73.1705,
                                -50.73408
                            ],
                            [
                                -73.08625,
                                -50.7784
                            ],
                            [
                                -73.00133,
                                -50.74855
                            ],
                            [
                                -72.86376,
                                -50.65619
                            ],
                            [
                                -72.73761,
                                -50.61641
                            ],
                            [
                                -72.61529,
                                -50.67482
                            ],
                            [
                                -72.47365,
                                -50.60267
                            ],
                            [
                                -72.3691,
                                -50.61677
                            ],
                            [
                                -72.27934,
                                -50.66163
                            ],
                            [
                                -72.32682,
                                -50.74478
                            ],
                            [
                                -72.23091,
                                -50.85524
                            ],
                            [
                                -72.25028,
                                -51.02392
                            ],
                            [
                                -72.34209,
                                -51.04548
                            ],
                            [
                                -72.40167,
                                -51.11934
                            ],
                            [
                                -72.36593,
                                -51.18157
                            ],
                            [
                                -72.26013,
                                -51.23578
                            ],
                            [
                                -72.32157,
                                -51.30528
                            ],
                            [
                                -72.35033,
                                -51.48528
                            ],
                            [
                                -72.42289,
                                -51.53585
                            ],
                            [
                                -72.3436,
                                -51.59666
                            ],
                            [
                                -72.29286,
                                -51.69892
                            ],
                            [
                                -72.18418,
                                -51.72243
                            ],
                            [
                                -72.01629,
                                -51.81757
                            ],
                            [
                                -71.94098,
                                -51.90106
                            ],
                            [
                                -71.9988,
                                -51.98426
                            ],
                            [
                                -71.9015,
                                -52.01863
                            ],
                            [
                                -70.95356,
                                -52.01391
                            ],
                            [
                                -70.0129,
                                -52.0086
                            ],
                            [
                                -69.49015,
                                -52.156
                            ],
                            [
                                -69.19073,
                                -52.15546
                            ],
                            [
                                -68.97184,
                                -52.21306
                            ],
                            [
                                -68.8356,
                                -52.27699
                            ],
                            [
                                -68.70765,
                                -52.28503
                            ],
                            [
                                -68.56963,
                                -52.32529
                            ],
                            [
                                -68.41918,
                                -52.33342
                            ],
                            [
                                -68.43219,
                                -52.39755
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -68.60748,
                                -54.89342
                            ],
                            [
                                -68.38316,
                                -54.85065
                            ],
                            [
                                -68.26411,
                                -54.79605
                            ],
                            [
                                -68.03242,
                                -54.84977
                            ],
                            [
                                -67.83158,
                                -54.86053
                            ],
                            [
                                -67.68787,
                                -54.88644
                            ],
                            [
                                -67.53148,
                                -54.86615
                            ],
                            [
                                -67.40286,
                                -54.8884
                            ],
                            [
                                -67.32513,
                                -54.87514
                            ],
                            [
                                -67.15322,
                                -54.89397
                            ],
                            [
                                -66.75547,
                                -54.96656
                            ],
                            [
                                -66.72114,
                                -54.99655
                            ],
                            [
                                -66.52594,
                                -55.05539
                            ],
                            [
                                -66.37156,
                                -55.03782
                            ],
                            [
                                -66.3443,
                                -54.99752
                            ],
                            [
                                -66.11124,
                                -54.99358
                            ],
                            [
                                -65.9581,
                                -54.94185
                            ],
                            [
                                -65.98227,
                                -54.90303
                            ],
                            [
                                -65.73583,
                                -54.91054
                            ],
                            [
                                -65.71639,
                                -54.9669
                            ],
                            [
                                -65.32381,
                                -54.91496
                            ],
                            [
                                -65.22519,
                                -54.81701
                            ],
                            [
                                -65.19317,
                                -54.6962
                            ],
                            [
                                -65.12721,
                                -54.65288
                            ],
                            [
                                -65.3628,
                                -54.64288
                            ],
                            [
                                -65.68367,
                                -54.66405
                            ],
                            [
                                -65.86294,
                                -54.63882
                            ],
                            [
                                -66.38669,
                                -54.48751
                            ],
                            [
                                -66.4617,
                                -54.4796
                            ],
                            [
                                -66.66145,
                                -54.34225
                            ],
                            [
                                -66.75113,
                                -54.25397
                            ],
                            [
                                -66.9008,
                                -54.21689
                            ],
                            [
                                -67.0849,
                                -54.13114
                            ],
                            [
                                -67.1309,
                                -54.12747
                            ],
                            [
                                -67.33069,
                                -54.04005
                            ],
                            [
                                -67.53916,
                                -53.9238
                            ],
                            [
                                -67.56018,
                                -53.83617
                            ],
                            [
                                -67.68778,
                                -53.78475
                            ],
                            [
                                -67.9173,
                                -53.64978
                            ],
                            [
                                -68.02369,
                                -53.54479
                            ],
                            [
                                -68.0813,
                                -53.39486
                            ],
                            [
                                -68.18329,
                                -53.31662
                            ],
                            [
                                -68.29993,
                                -53.32183
                            ],
                            [
                                -68.45502,
                                -53.29725
                            ],
                            [
                                -68.5551,
                                -53.25036
                            ],
                            [
                                -68.54036,
                                -53.14928
                            ],
                            [
                                -68.36503,
                                -53.02015
                            ],
                            [
                                -68.2944,
                                -53.00806
                            ],
                            [
                                -68.2908,
                                -52.94946
                            ],
                            [
                                -68.55641,
                                -52.71226
                            ],
                            [
                                -68.60862,
                                -52.64952
                            ],
                            [
                                -68.60828,
                                -53.31567
                            ],
                            [
                                -68.60796,
                                -53.95507
                            ],
                            [
                                -68.60748,
                                -54.89342
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -64.75256,
                                -54.8365
                            ],
                            [
                                -64.62958,
                                -54.90537
                            ],
                            [
                                -64.39179,
                                -54.8294
                            ],
                            [
                                -64.26204,
                                -54.80238
                            ],
                            [
                                -64.20629,
                                -54.83594
                            ],
                            [
                                -64.07296,
                                -54.79573
                            ],
                            [
                                -63.84859,
                                -54.78872
                            ],
                            [
                                -63.88738,
                                -54.71675
                            ],
                            [
                                -64.2419,
                                -54.7445
                            ],
                            [
                                -64.33775,
                                -54.72794
                            ],
                            [
                                -64.39365,
                                -54.78113
                            ],
                            [
                                -64.48725,
                                -54.76292
                            ],
                            [
                                -64.58961,
                                -54.81914
                            ],
                            [
                                -64.67647,
                                -54.80089
                            ],
                            [
                                -64.75256,
                                -54.8365
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "ARM",
                "Country": "Armenia",
                "Total_3GHG": 0.02,
                "Total_3GHG_timeseries": [
                    3.019e-07,
                    6.0231e-07,
                    9.0219e-07,
                    1.2018e-06,
                    1.5016e-06,
                    1.8008e-06,
                    2.0999e-06,
                    2.3993e-06,
                    2.7013e-06,
                    3.0064e-06,
                    3.3173e-06,
                    3.6334e-06,
                    3.9554e-06,
                    4.2838e-06,
                    4.6155e-06,
                    4.9525e-06,
                    5.2932e-06,
                    5.6367e-06,
                    5.9844e-06,
                    6.3339e-06,
                    6.6855e-06,
                    7.0415e-06,
                    7.4028e-06,
                    7.7715e-06,
                    8.1477e-06,
                    8.5323e-06,
                    8.9238e-06,
                    9.3247e-06,
                    9.7295e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_3GHG": 0.02,
                "Fossil_3GHG_timeseries": [
                    1.5556e-08,
                    3.0716e-08,
                    4.5488e-08,
                    5.9875e-08,
                    7.4234e-08,
                    8.7871e-08,
                    1.0114e-07,
                    1.1453e-07,
                    1.3042e-07,
                    1.4917e-07,
                    1.7141e-07,
                    1.9713e-07,
                    2.2674e-07,
                    2.606e-07,
                    2.9554e-07,
                    3.3352e-07,
                    3.7304e-07,
                    4.1309e-07,
                    4.5514e-07,
                    4.9856e-07,
                    5.4314e-07,
                    5.9025e-07,
                    6.3949e-07,
                    6.9233e-07,
                    7.4865e-07,
                    8.0931e-07,
                    8.7278e-07,
                    9.4167e-07,
                    1.0109e-06,
                    1.082e-06,
                    1.1533e-06,
                    1.2247e-06,
                    1.2976e-06,
                    1.3698e-06,
                    1.4457e-06,
                    1.524e-06,
                    1.6038e-06,
                    1.6848e-06,
                    1.768e-06,
                    1.8548e-06,
                    1.9449e-06,
                    2.0384e-06,
                    2.1394e-06,
                    2.243e-06,
                    2.3543e-06,
                    2.4685e-06,
                    2.5918e-06,
                    2.7214e-06,
                    2.8604e-06,
                    3.0084e-06,
                    3.1584e-06,
                    3.3054e-06,
                    3.4502e-06,
                    3.6029e-06,
                    3.746e-06,
                    3.899e-06,
                    4.0631e-06,
                    4.2298e-06,
                    4.404e-06,
                    4.5785e-06,
                    4.7569e-06,
                    4.9471e-06,
                    5.1455e-06,
                    5.3312e-06,
                    5.507e-06,
                    5.6901e-06,
                    5.8646e-06,
                    5.9805e-06,
                    6.093e-06,
                    6.2049e-06,
                    6.3222e-06,
                    6.4503e-06,
                    6.5861e-06,
                    6.734e-06,
                    6.8853e-06,
                    6.9986e-06,
                    7.1332e-06,
                    7.279e-06,
                    7.4349e-06,
                    7.6351e-06,
                    7.8738e-06,
                    8.1424e-06,
                    8.4433e-06,
                    8.8003e-06,
                    9.2014e-06,
                    9.6551e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_3GHG": 0.02,
                "Land_3GHG_timeseries": [
                    2.8634e-07,
                    5.7159e-07,
                    8.567e-07,
                    1.1419e-06,
                    1.4273e-06,
                    1.713e-06,
                    1.9988e-06,
                    2.2848e-06,
                    2.5708e-06,
                    2.8572e-06,
                    3.1459e-06,
                    3.4362e-06,
                    3.7287e-06,
                    4.0232e-06,
                    4.32e-06,
                    4.619e-06,
                    4.9202e-06,
                    5.2236e-06,
                    5.5293e-06,
                    5.8353e-06,
                    6.1423e-06,
                    6.4512e-06,
                    6.7634e-06,
                    7.0792e-06,
                    7.399e-06,
                    7.723e-06,
                    8.051e-06,
                    8.383e-06,
                    8.7186e-06,
                    9.06e-06,
                    9.4024e-06,
                    9.7452e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_CO2": 0.02,
                "Total_CO2_timeseries": [
                    2.3784e-07,
                    4.7417e-07,
                    7.0997e-07,
                    9.4552e-07,
                    1.1812e-06,
                    1.4165e-06,
                    1.6518e-06,
                    1.8874e-06,
                    2.123e-06,
                    2.3589e-06,
                    2.595e-06,
                    2.8303e-06,
                    3.0655e-06,
                    3.3006e-06,
                    3.5355e-06,
                    3.7722e-06,
                    4.0092e-06,
                    4.2456e-06,
                    4.4828e-06,
                    4.7184e-06,
                    4.9535e-06,
                    5.1871e-06,
                    5.4199e-06,
                    5.6533e-06,
                    5.8874e-06,
                    6.123e-06,
                    6.3586e-06,
                    6.5969e-06,
                    6.8354e-06,
                    7.0785e-06,
                    7.3225e-06,
                    7.5666e-06,
                    7.813e-06,
                    8.0597e-06,
                    8.3081e-06,
                    8.5573e-06,
                    8.8077e-06,
                    9.0593e-06,
                    9.3127e-06,
                    9.5653e-06,
                    9.8169e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003
                ],
                "Fossil_CO2": 0.02,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    3.4225e-10,
                    3.4225e-10,
                    3.4225e-10,
                    8.232e-10,
                    1.333e-09,
                    2.0067e-09,
                    2.8627e-09,
                    3.635e-09,
                    4.4434e-09,
                    5.3503e-09,
                    6.2172e-09,
                    8.9561e-09,
                    1.2099e-08,
                    1.4714e-08,
                    1.8261e-08,
                    2.2111e-08,
                    2.7308e-08,
                    3.2643e-08,
                    3.7651e-08,
                    4.373e-08,
                    5.0726e-08,
                    5.9412e-08,
                    6.8277e-08,
                    7.9862e-08,
                    9.1749e-08,
                    1.0569e-07,
                    1.2038e-07,
                    1.3585e-07,
                    1.5346e-07,
                    1.7134e-07,
                    1.9082e-07,
                    2.1079e-07,
                    2.3192e-07,
                    2.5397e-07,
                    2.7778e-07,
                    3.0474e-07,
                    3.3442e-07,
                    3.6585e-07,
                    4.0268e-07,
                    4.4019e-07,
                    4.833e-07,
                    5.2717e-07,
                    5.7791e-07,
                    6.3481e-07,
                    7.0081e-07,
                    7.7559e-07,
                    8.5236e-07,
                    9.265e-07,
                    9.9903e-07,
                    1.0797e-06,
                    1.1517e-06,
                    1.2339e-06,
                    1.3259e-06,
                    1.4185e-06,
                    1.5163e-06,
                    1.6121e-06,
                    1.7115e-06,
                    1.824e-06,
                    1.9463e-06,
                    2.0567e-06,
                    2.158e-06,
                    2.266e-06,
                    2.3653e-06,
                    2.405e-06,
                    2.4388e-06,
                    2.4697e-06,
                    2.5032e-06,
                    2.544e-06,
                    2.5891e-06,
                    2.6428e-06,
                    2.6958e-06,
                    2.7727e-06,
                    2.8682e-06,
                    2.9731e-06,
                    3.0861e-06,
                    3.2403e-06,
                    3.4258e-06,
                    3.6345e-06,
                    3.8681e-06,
                    4.1503e-06,
                    4.4693e-06,
                    4.8345e-06,
                    5.2083e-06,
                    5.6029e-06,
                    6.0023e-06,
                    6.4813e-06,
                    6.902e-06,
                    7.1328e-06,
                    7.3737e-06,
                    7.7231e-06,
                    8.0914e-06,
                    8.5041e-06,
                    9.0005e-06,
                    9.5278e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_CO2": 0.02,
                "Land_CO2_timeseries": [
                    2.3784e-07,
                    4.7417e-07,
                    7.0997e-07,
                    9.4552e-07,
                    1.1809e-06,
                    1.4162e-06,
                    1.6514e-06,
                    1.8865e-06,
                    2.1216e-06,
                    2.3569e-06,
                    2.5921e-06,
                    2.8267e-06,
                    3.061e-06,
                    3.2952e-06,
                    3.5293e-06,
                    3.7632e-06,
                    3.9971e-06,
                    4.2309e-06,
                    4.4646e-06,
                    4.6963e-06,
                    4.9262e-06,
                    5.1545e-06,
                    5.3822e-06,
                    5.6096e-06,
                    5.8367e-06,
                    6.0636e-06,
                    6.2903e-06,
                    6.517e-06,
                    6.7437e-06,
                    6.9728e-06,
                    7.2021e-06,
                    7.4308e-06,
                    7.6595e-06,
                    7.8883e-06,
                    8.1173e-06,
                    8.3465e-06,
                    8.5758e-06,
                    8.8053e-06,
                    9.0349e-06,
                    9.2606e-06,
                    9.4824e-06,
                    9.7013e-06,
                    9.9187e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_CH4": 0.01,
                "Total_CH4_timeseries": [
                    3.8402e-08,
                    7.6364e-08,
                    1.1389e-07,
                    1.51e-07,
                    1.877e-07,
                    2.2397e-07,
                    2.5985e-07,
                    2.9534e-07,
                    3.3327e-07,
                    3.7386e-07,
                    4.2001e-07,
                    4.7196e-07,
                    5.3e-07,
                    5.9443e-07,
                    6.6222e-07,
                    7.3342e-07,
                    8.08e-07,
                    8.8587e-07,
                    9.6704e-07,
                    1.0515e-06,
                    1.1382e-06,
                    1.2297e-06,
                    1.326e-06,
                    1.4272e-06,
                    1.5333e-06,
                    1.6443e-06,
                    1.7603e-06,
                    1.8814e-06,
                    2.0048e-06,
                    2.1305e-06,
                    2.2561e-06,
                    2.3816e-06,
                    2.507e-06,
                    2.6319e-06,
                    2.7594e-06,
                    2.8894e-06,
                    3.0202e-06,
                    3.152e-06,
                    3.2846e-06,
                    3.4181e-06,
                    3.5527e-06,
                    3.6896e-06,
                    3.8291e-06,
                    3.971e-06,
                    4.1156e-06,
                    4.2628e-06,
                    4.4128e-06,
                    4.5635e-06,
                    4.715e-06,
                    4.8672e-06,
                    5.02e-06,
                    5.173e-06,
                    5.3259e-06,
                    5.4791e-06,
                    5.6319e-06,
                    5.785e-06,
                    5.9399e-06,
                    6.0974e-06,
                    6.2577e-06,
                    6.4207e-06,
                    6.5809e-06,
                    6.7366e-06,
                    6.8875e-06,
                    7.0345e-06,
                    7.1775e-06,
                    7.3179e-06,
                    7.4551e-06,
                    7.5902e-06,
                    7.7245e-06,
                    7.858e-06,
                    7.9908e-06,
                    8.1233e-06,
                    8.2557e-06,
                    8.3878e-06,
                    8.5201e-06,
                    8.5867e-06,
                    8.6521e-06,
                    8.7154e-06,
                    8.7765e-06,
                    8.8369e-06,
                    8.9188e-06,
                    9.0217e-06,
                    9.1459e-06,
                    9.2913e-06,
                    9.4578e-06,
                    9.6552e-06,
                    9.884e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_CH4": 0.01,
                "Fossil_CH4_timeseries": [
                    8.5818e-09,
                    1.6687e-08,
                    2.4322e-08,
                    3.1495e-08,
                    3.822e-08,
                    4.449e-08,
                    5.0318e-08,
                    5.5722e-08,
                    6.3532e-08,
                    7.3967e-08,
                    8.7658e-08,
                    1.0486e-07,
                    1.2584e-07,
                    1.5093e-07,
                    1.7707e-07,
                    2.0433e-07,
                    2.3267e-07,
                    2.6199e-07,
                    2.9234e-07,
                    3.2369e-07,
                    3.5477e-07,
                    3.8814e-07,
                    4.2381e-07,
                    4.6185e-07,
                    5.0229e-07,
                    5.4519e-07,
                    5.9056e-07,
                    6.3847e-07,
                    6.8627e-07,
                    7.3384e-07,
                    7.8067e-07,
                    8.2688e-07,
                    8.7229e-07,
                    9.1669e-07,
                    9.6303e-07,
                    1.0113e-06,
                    1.0598e-06,
                    1.1086e-06,
                    1.1576e-06,
                    1.2071e-06,
                    1.2568e-06,
                    1.3083e-06,
                    1.3617e-06,
                    1.4168e-06,
                    1.474e-06,
                    1.5332e-06,
                    1.5946e-06,
                    1.656e-06,
                    1.7174e-06,
                    1.779e-06,
                    1.8406e-06,
                    1.9015e-06,
                    1.9617e-06,
                    2.0215e-06,
                    2.0802e-06,
                    2.1385e-06,
                    2.1979e-06,
                    2.2592e-06,
                    2.3226e-06,
                    2.388e-06,
                    2.4537e-06,
                    2.518e-06,
                    2.5805e-06,
                    2.6422e-06,
                    2.7029e-06,
                    2.764e-06,
                    2.8251e-06,
                    2.8871e-06,
                    2.9514e-06,
                    3.018e-06,
                    3.0871e-06,
                    3.1593e-06,
                    3.2347e-06,
                    3.313e-06,
                    3.3949e-06,
                    3.4145e-06,
                    3.4361e-06,
                    3.4589e-06,
                    3.4829e-06,
                    3.5093e-06,
                    3.5421e-06,
                    3.5806e-06,
                    3.6251e-06,
                    3.6757e-06,
                    3.732e-06,
                    3.7931e-06,
                    3.8589e-06,
                    3.9305e-06,
                    4.0066e-06,
                    4.0886e-06,
                    4.1715e-06,
                    4.2538e-06,
                    4.3384e-06,
                    4.4249e-06,
                    4.5156e-06,
                    4.6743e-06,
                    4.8419e-06,
                    5.0179e-06,
                    5.2033e-06,
                    5.3971e-06,
                    5.6029e-06,
                    5.8242e-06,
                    6.0618e-06,
                    6.3183e-06,
                    6.5972e-06,
                    6.8979e-06,
                    7.2221e-06,
                    7.5709e-06,
                    7.9456e-06,
                    8.3471e-06,
                    8.7808e-06,
                    9.2481e-06,
                    9.747e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CH4": 0.02,
                "Land_CH4_timeseries": [
                    2.982e-08,
                    5.9677e-08,
                    8.9573e-08,
                    1.1951e-07,
                    1.4948e-07,
                    1.7948e-07,
                    2.0953e-07,
                    2.3961e-07,
                    2.6974e-07,
                    2.9989e-07,
                    3.3235e-07,
                    3.6711e-07,
                    4.0416e-07,
                    4.4351e-07,
                    4.8515e-07,
                    5.2909e-07,
                    5.7533e-07,
                    6.2387e-07,
                    6.7471e-07,
                    7.2784e-07,
                    7.8347e-07,
                    8.4161e-07,
                    9.0224e-07,
                    9.6537e-07,
                    1.031e-06,
                    1.0991e-06,
                    1.1698e-06,
                    1.2429e-06,
                    1.3185e-06,
                    1.3967e-06,
                    1.4754e-06,
                    1.5548e-06,
                    1.6347e-06,
                    1.7152e-06,
                    1.7964e-06,
                    1.8781e-06,
                    1.9605e-06,
                    2.0434e-06,
                    2.1269e-06,
                    2.2111e-06,
                    2.2959e-06,
                    2.3813e-06,
                    2.4674e-06,
                    2.5541e-06,
                    2.6415e-06,
                    2.7296e-06,
                    2.8182e-06,
                    2.9075e-06,
                    2.9975e-06,
                    3.0881e-06,
                    3.1795e-06,
                    3.2715e-06,
                    3.3642e-06,
                    3.4576e-06,
                    3.5517e-06,
                    3.6465e-06,
                    3.742e-06,
                    3.8382e-06,
                    3.9351e-06,
                    4.0327e-06,
                    4.1272e-06,
                    4.2186e-06,
                    4.307e-06,
                    4.3924e-06,
                    4.4746e-06,
                    4.5538e-06,
                    4.63e-06,
                    4.7031e-06,
                    4.7731e-06,
                    4.84e-06,
                    4.9036e-06,
                    4.964e-06,
                    5.021e-06,
                    5.0747e-06,
                    5.1251e-06,
                    5.1722e-06,
                    5.216e-06,
                    5.2565e-06,
                    5.2937e-06,
                    5.3275e-06,
                    5.3767e-06,
                    5.4411e-06,
                    5.5207e-06,
                    5.6156e-06,
                    5.7258e-06,
                    5.8621e-06,
                    6.0251e-06,
                    6.2154e-06,
                    6.4336e-06,
                    6.68e-06,
                    6.9411e-06,
                    7.2169e-06,
                    7.5074e-06,
                    7.8127e-06,
                    8.133e-06,
                    8.4683e-06,
                    8.8187e-06,
                    9.1844e-06,
                    9.5653e-06,
                    9.9615e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_N2O": 0.04,
                "Total_N2O_timeseries": [
                    2.5659e-08,
                    5.1772e-08,
                    7.8324e-08,
                    1.0529e-07,
                    1.3264e-07,
                    1.6034e-07,
                    1.8834e-07,
                    2.1659e-07,
                    2.4505e-07,
                    2.7363e-07,
                    3.0232e-07,
                    3.3108e-07,
                    3.5993e-07,
                    3.8885e-07,
                    4.1784e-07,
                    4.4689e-07,
                    4.7603e-07,
                    5.0524e-07,
                    5.3454e-07,
                    5.6393e-07,
                    5.9377e-07,
                    6.2461e-07,
                    6.5691e-07,
                    6.9098e-07,
                    7.2698e-07,
                    7.6497e-07,
                    8.0485e-07,
                    8.464e-07,
                    8.8926e-07,
                    9.3293e-07,
                    9.771e-07,
                    1.0217e-06,
                    1.0666e-06,
                    1.1119e-06,
                    1.1574e-06,
                    1.2033e-06,
                    1.2494e-06,
                    1.2958e-06,
                    1.3425e-06,
                    1.3902e-06,
                    1.4386e-06,
                    1.4877e-06,
                    1.5374e-06,
                    1.5878e-06,
                    1.6388e-06,
                    1.6904e-06,
                    1.7424e-06,
                    1.7948e-06,
                    1.8476e-06,
                    1.9006e-06,
                    1.9539e-06,
                    2.0073e-06,
                    2.061e-06,
                    2.1148e-06,
                    2.1688e-06,
                    2.223e-06,
                    2.2774e-06,
                    2.3321e-06,
                    2.3869e-06,
                    2.4419e-06,
                    2.4977e-06,
                    2.5549e-06,
                    2.6143e-06,
                    2.6762e-06,
                    2.7409e-06,
                    2.8085e-06,
                    2.8788e-06,
                    2.9516e-06,
                    3.0263e-06,
                    3.1023e-06,
                    3.1793e-06,
                    3.2572e-06,
                    3.3362e-06,
                    3.4162e-06,
                    3.4973e-06,
                    3.5794e-06,
                    3.6624e-06,
                    3.7464e-06,
                    3.8312e-06,
                    3.9168e-06,
                    4.003e-06,
                    4.0894e-06,
                    4.176e-06,
                    4.2626e-06,
                    4.3492e-06,
                    4.4359e-06,
                    4.5228e-06,
                    4.6101e-06,
                    4.6983e-06,
                    4.7875e-06,
                    4.8789e-06,
                    4.9739e-06,
                    5.0736e-06,
                    5.1789e-06,
                    5.2903e-06,
                    5.4081e-06,
                    5.5322e-06,
                    5.6625e-06,
                    5.7984e-06,
                    5.9389e-06,
                    6.0842e-06,
                    6.2353e-06,
                    6.3928e-06,
                    6.5573e-06,
                    6.7289e-06,
                    6.9076e-06,
                    7.0931e-06,
                    7.2848e-06,
                    7.4818e-06,
                    7.6831e-06,
                    7.8961e-06,
                    8.1176e-06,
                    8.3419e-06,
                    8.5679e-06,
                    8.7964e-06,
                    9.0395e-06,
                    9.2876e-06,
                    9.5414e-06,
                    9.7969e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_N2O": 0.03,
                "Fossil_N2O_timeseries": [
                    6.9742e-09,
                    1.403e-08,
                    2.1166e-08,
                    2.8381e-08,
                    3.5672e-08,
                    4.3039e-08,
                    5.0478e-08,
                    5.7985e-08,
                    6.5559e-08,
                    7.3194e-08,
                    8.0888e-08,
                    8.8641e-08,
                    9.6453e-08,
                    1.0432e-07,
                    1.1225e-07,
                    1.2023e-07,
                    1.2828e-07,
                    1.3638e-07,
                    1.4454e-07,
                    1.5276e-07,
                    1.6106e-07,
                    1.6947e-07,
                    1.7803e-07,
                    1.8675e-07,
                    1.9564e-07,
                    2.0471e-07,
                    2.1395e-07,
                    2.2334e-07,
                    2.3286e-07,
                    2.4249e-07,
                    2.5221e-07,
                    2.62e-07,
                    2.7187e-07,
                    2.8181e-07,
                    2.9182e-07,
                    3.0191e-07,
                    3.1206e-07,
                    3.2228e-07,
                    3.3258e-07,
                    3.4305e-07,
                    3.5362e-07,
                    3.643e-07,
                    3.7508e-07,
                    3.8597e-07,
                    3.9697e-07,
                    4.0809e-07,
                    4.1932e-07,
                    4.3068e-07,
                    4.4216e-07,
                    4.5376e-07,
                    4.6551e-07,
                    4.774e-07,
                    4.8944e-07,
                    5.0165e-07,
                    5.1402e-07,
                    5.2656e-07,
                    5.3927e-07,
                    5.5214e-07,
                    5.6517e-07,
                    5.7834e-07,
                    5.9165e-07,
                    6.051e-07,
                    6.1866e-07,
                    6.3235e-07,
                    6.4617e-07,
                    6.601e-07,
                    6.7417e-07,
                    6.8837e-07,
                    7.0272e-07,
                    7.1723e-07,
                    7.3195e-07,
                    7.4696e-07,
                    7.6235e-07,
                    7.7819e-07,
                    7.9453e-07,
                    8.1143e-07,
                    8.2895e-07,
                    8.4711e-07,
                    8.6594e-07,
                    8.8549e-07,
                    9.0587e-07,
                    9.2735e-07,
                    9.5012e-07,
                    9.7434e-07,
                    1.0001e-06,
                    1.0275e-06,
                    1.0565e-06,
                    1.0872e-06,
                    1.1194e-06,
                    1.153e-06,
                    1.188e-06,
                    1.2244e-06,
                    1.2622e-06,
                    1.3015e-06,
                    1.3422e-06,
                    1.3846e-06,
                    1.4285e-06,
                    1.4742e-06,
                    1.5217e-06,
                    1.571e-06,
                    1.6228e-06,
                    1.6778e-06,
                    1.7366e-06,
                    1.7995e-06,
                    1.8666e-06,
                    1.9377e-06,
                    2.0125e-06,
                    2.0903e-06,
                    2.1702e-06,
                    2.2512e-06,
                    2.3324e-06,
                    2.4133e-06,
                    2.4935e-06,
                    2.5729e-06,
                    2.6512e-06,
                    2.7286e-06,
                    2.805e-06,
                    2.8808e-06,
                    2.9562e-06,
                    3.0365e-06,
                    3.1182e-06,
                    3.2041e-06,
                    3.294e-06,
                    3.3877e-06,
                    3.5023e-06,
                    3.6228e-06,
                    3.7459e-06,
                    3.8728e-06,
                    4.003e-06,
                    4.1376e-06,
                    4.2724e-06,
                    4.4074e-06,
                    4.5424e-06,
                    4.6782e-06,
                    4.8149e-06,
                    4.953e-06,
                    5.0942e-06,
                    5.236e-06,
                    5.378e-06,
                    5.4563e-06,
                    5.5069e-06,
                    5.5595e-06,
                    5.5972e-06,
                    5.6238e-06,
                    5.6501e-06,
                    5.6751e-06,
                    5.7008e-06,
                    5.7264e-06,
                    5.7519e-06,
                    5.7804e-06,
                    5.8088e-06,
                    5.8363e-06,
                    5.8652e-06,
                    5.8958e-06,
                    5.9299e-06,
                    5.9658e-06,
                    6.0209e-06,
                    6.0779e-06,
                    6.129e-06,
                    6.1816e-06,
                    6.2382e-06,
                    6.3007e-06,
                    6.3658e-06,
                    6.4342e-06,
                    6.5072e-06,
                    6.5759e-06,
                    6.6448e-06,
                    6.7144e-06,
                    6.7852e-06,
                    6.8548e-06,
                    6.9267e-06,
                    6.9952e-06
                ],
                "Land_N2O": 0.04,
                "Land_N2O_timeseries": [
                    1.8684e-08,
                    3.7743e-08,
                    5.7158e-08,
                    7.6909e-08,
                    9.6967e-08,
                    1.173e-07,
                    1.3786e-07,
                    1.5861e-07,
                    1.7949e-07,
                    2.0044e-07,
                    2.2143e-07,
                    2.4244e-07,
                    2.6348e-07,
                    2.8453e-07,
                    3.0559e-07,
                    3.2666e-07,
                    3.4775e-07,
                    3.6886e-07,
                    3.9e-07,
                    4.1118e-07,
                    4.3271e-07,
                    4.5514e-07,
                    4.7888e-07,
                    5.0423e-07,
                    5.3134e-07,
                    5.6026e-07,
                    5.9091e-07,
                    6.2306e-07,
                    6.5639e-07,
                    6.9044e-07,
                    7.2489e-07,
                    7.5968e-07,
                    7.9475e-07,
                    8.3007e-07,
                    8.6561e-07,
                    9.0135e-07,
                    9.3731e-07,
                    9.7348e-07,
                    1.0099e-06,
                    1.0471e-06,
                    1.085e-06,
                    1.1234e-06,
                    1.1624e-06,
                    1.2019e-06,
                    1.2419e-06,
                    1.2823e-06,
                    1.3231e-06,
                    1.3641e-06,
                    1.4054e-06,
                    1.4469e-06,
                    1.4884e-06,
                    1.5299e-06,
                    1.5715e-06,
                    1.6131e-06,
                    1.6548e-06,
                    1.6965e-06,
                    1.7382e-06,
                    1.7799e-06,
                    1.8217e-06,
                    1.8636e-06,
                    1.906e-06,
                    1.9498e-06,
                    1.9956e-06,
                    2.0439e-06,
                    2.0947e-06,
                    2.1484e-06,
                    2.2046e-06,
                    2.2632e-06,
                    2.3236e-06,
                    2.3851e-06,
                    2.4473e-06,
                    2.5103e-06,
                    2.5739e-06,
                    2.638e-06,
                    2.7027e-06,
                    2.7679e-06,
                    2.8335e-06,
                    2.8993e-06,
                    2.9653e-06,
                    3.0313e-06,
                    3.0971e-06,
                    3.1621e-06,
                    3.2259e-06,
                    3.2883e-06,
                    3.3491e-06,
                    3.4084e-06,
                    3.4663e-06,
                    3.523e-06,
                    3.5789e-06,
                    3.6345e-06,
                    3.6909e-06,
                    3.7495e-06,
                    3.8114e-06,
                    3.8774e-06,
                    3.948e-06,
                    4.0235e-06,
                    4.1037e-06,
                    4.1883e-06,
                    4.2767e-06,
                    4.3679e-06,
                    4.4614e-06,
                    4.5575e-06,
                    4.6562e-06,
                    4.7578e-06,
                    4.8623e-06,
                    4.9699e-06,
                    5.0807e-06,
                    5.1945e-06,
                    5.3116e-06,
                    5.4318e-06,
                    5.5637e-06,
                    5.7043e-06,
                    5.8484e-06,
                    5.9951e-06,
                    6.1452e-06,
                    6.311e-06,
                    6.4826e-06,
                    6.6606e-06,
                    6.8407e-06,
                    7.0312e-06,
                    7.2337e-06,
                    7.4426e-06,
                    7.6647e-06,
                    7.8921e-06,
                    8.1247e-06,
                    8.3624e-06,
                    8.6007e-06,
                    8.8481e-06,
                    9.0895e-06,
                    9.3416e-06,
                    9.5919e-06,
                    9.853e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            46.14066,
                            38.84494
                        ],
                        [
                            46.18321,
                            38.84148
                        ],
                        [
                            46.26905,
                            38.8942
                        ],
                        [
                            46.36258,
                            38.9161
                        ],
                        [
                            46.5458,
                            38.8781
                        ],
                        [
                            46.51486,
                            38.94368
                        ],
                        [
                            46.55202,
                            39.04805
                        ],
                        [
                            46.43992,
                            39.18983
                        ],
                        [
                            46.49289,
                            39.18726
                        ],
                        [
                            46.59202,
                            39.22759
                        ],
                        [
                            46.53584,
                            39.31239
                        ],
                        [
                            46.42797,
                            39.35679
                        ],
                        [
                            46.38705,
                            39.42424
                        ],
                        [
                            46.45381,
                            39.44932
                        ],
                        [
                            46.56174,
                            39.56818
                        ],
                        [
                            46.44513,
                            39.57315
                        ],
                        [
                            46.37209,
                            39.63749
                        ],
                        [
                            46.17588,
                            39.58812
                        ],
                        [
                            46.1649,
                            39.6424
                        ],
                        [
                            46.04052,
                            39.72009
                        ],
                        [
                            45.99602,
                            39.77839
                        ],
                        [
                            45.82903,
                            39.83591
                        ],
                        [
                            45.80682,
                            39.92999
                        ],
                        [
                            45.63346,
                            39.97471
                        ],
                        [
                            45.63609,
                            40.03969
                        ],
                        [
                            45.75515,
                            40.03081
                        ],
                        [
                            45.81235,
                            40.00093
                        ],
                        [
                            45.88482,
                            40.03159
                        ],
                        [
                            45.90499,
                            40.11069
                        ],
                        [
                            45.95629,
                            40.14957
                        ],
                        [
                            45.97669,
                            40.21307
                        ],
                        [
                            45.91353,
                            40.29684
                        ],
                        [
                            45.84962,
                            40.29757
                        ],
                        [
                            45.75554,
                            40.34767
                        ],
                        [
                            45.64289,
                            40.3722
                        ],
                        [
                            45.54465,
                            40.46932
                        ],
                        [
                            45.43797,
                            40.51258
                        ],
                        [
                            45.44884,
                            40.58617
                        ],
                        [
                            45.37169,
                            40.62218
                        ],
                        [
                            45.35904,
                            40.67141
                        ],
                        [
                            45.41187,
                            40.7385
                        ],
                        [
                            45.5674,
                            40.82318
                        ],
                        [
                            45.59146,
                            40.89221
                        ],
                        [
                            45.52553,
                            40.91267
                        ],
                        [
                            45.4009,
                            41.02744
                        ],
                        [
                            45.09495,
                            41.06027
                        ],
                        [
                            45.08581,
                            41.11452
                        ],
                        [
                            45.17784,
                            41.13195
                        ],
                        [
                            45.13278,
                            41.20594
                        ],
                        [
                            45.01537,
                            41.19659
                        ],
                        [
                            45.04365,
                            41.25201
                        ],
                        [
                            45.01315,
                            41.29661
                        ],
                        [
                            44.9597,
                            41.25837
                        ],
                        [
                            44.80657,
                            41.28769
                        ],
                        [
                            44.84105,
                            41.21578
                        ],
                        [
                            44.61255,
                            41.24057
                        ],
                        [
                            44.54777,
                            41.1952
                        ],
                        [
                            44.46832,
                            41.18161
                        ],
                        [
                            44.35682,
                            41.23064
                        ],
                        [
                            44.27218,
                            41.2136
                        ],
                        [
                            44.18127,
                            41.22813
                        ],
                        [
                            44.1598,
                            41.18924
                        ],
                        [
                            44.05443,
                            41.1906
                        ],
                        [
                            43.96206,
                            41.16557
                        ],
                        [
                            43.83969,
                            41.16031
                        ],
                        [
                            43.75147,
                            41.11039
                        ],
                        [
                            43.5674,
                            41.14422
                        ],
                        [
                            43.47383,
                            41.1233
                        ],
                        [
                            43.48579,
                            41.02216
                        ],
                        [
                            43.59561,
                            40.99269
                        ],
                        [
                            43.67059,
                            40.92815
                        ],
                        [
                            43.75018,
                            40.74498
                        ],
                        [
                            43.74091,
                            40.66591
                        ],
                        [
                            43.65383,
                            40.53258
                        ],
                        [
                            43.59313,
                            40.5007
                        ],
                        [
                            43.60723,
                            40.36855
                        ],
                        [
                            43.71459,
                            40.15852
                        ],
                        [
                            43.67002,
                            40.10269
                        ],
                        [
                            43.91002,
                            40.01946
                        ],
                        [
                            44.04455,
                            40.01047
                        ],
                        [
                            44.28422,
                            40.04547
                        ],
                        [
                            44.48653,
                            39.96327
                        ],
                        [
                            44.5927,
                            39.83199
                        ],
                        [
                            44.76834,
                            39.71415
                        ],
                        [
                            44.95345,
                            39.73004
                        ],
                        [
                            45.08199,
                            39.78547
                        ],
                        [
                            45.12802,
                            39.76291
                        ],
                        [
                            45.19273,
                            39.67793
                        ],
                        [
                            45.18605,
                            39.60815
                        ],
                        [
                            45.30372,
                            39.60086
                        ],
                        [
                            45.33145,
                            39.56004
                        ],
                        [
                            45.45702,
                            39.50435
                        ],
                        [
                            45.66953,
                            39.58136
                        ],
                        [
                            45.70769,
                            39.60647
                        ],
                        [
                            45.81799,
                            39.54572
                        ],
                        [
                            45.84,
                            39.47028
                        ],
                        [
                            45.79634,
                            39.40082
                        ],
                        [
                            45.99916,
                            39.29681
                        ],
                        [
                            46.0098,
                            39.15133
                        ],
                        [
                            46.03423,
                            39.08926
                        ],
                        [
                            46.10062,
                            39.02274
                        ],
                        [
                            46.15088,
                            38.88568
                        ],
                        [
                            46.14066,
                            38.84494
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "ABW",
                "Country": "Aruba",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    1.3277e-11,
                    2.6815e-11,
                    4.0602e-11,
                    5.4622e-11,
                    6.8858e-11,
                    8.3285e-11,
                    9.7875e-11,
                    1.126e-10,
                    1.2741e-10,
                    1.4229e-10,
                    1.5719e-10,
                    1.7211e-10,
                    1.8706e-10,
                    2.0201e-10,
                    2.1699e-10,
                    2.3197e-10,
                    2.4697e-10,
                    2.62e-10,
                    2.7704e-10,
                    2.9212e-10,
                    3.0744e-10,
                    3.2339e-10,
                    3.4023e-10,
                    3.5817e-10,
                    3.7733e-10,
                    3.9772e-10,
                    4.193e-10,
                    4.4191e-10,
                    4.6533e-10,
                    4.8924e-10,
                    5.1343e-10,
                    5.3786e-10,
                    5.6249e-10,
                    5.8729e-10,
                    6.1224e-10,
                    6.3735e-10,
                    6.626e-10,
                    6.88e-10,
                    7.1358e-10,
                    7.3968e-10,
                    7.6608e-10,
                    7.9278e-10,
                    8.1979e-10,
                    8.4714e-10,
                    8.7484e-10,
                    9.0291e-10,
                    9.3137e-10,
                    9.6025e-10,
                    9.8957e-10,
                    1.0194e-09,
                    1.0497e-09,
                    1.0806e-09,
                    1.1123e-09,
                    1.1446e-09,
                    1.1778e-09,
                    1.2117e-09,
                    1.2464e-09,
                    1.282e-09,
                    1.3183e-09,
                    1.3553e-09,
                    1.393e-09,
                    1.4315e-09,
                    1.4706e-09,
                    1.5104e-09,
                    1.5508e-09,
                    1.592e-09,
                    1.6338e-09,
                    1.6764e-09,
                    1.7196e-09,
                    1.7635e-09,
                    1.8081e-09,
                    1.8534e-09,
                    1.8995e-09,
                    1.9462e-09,
                    1.9938e-09,
                    1.708e-08,
                    3.3232e-08,
                    7.0545e-08,
                    1.1716e-07,
                    1.7782e-07,
                    2.2821e-07,
                    2.775e-07,
                    3.3026e-07,
                    3.8858e-07,
                    4.5393e-07,
                    5.2495e-07,
                    6.0786e-07,
                    6.9776e-07,
                    7.8165e-07,
                    8.4946e-07,
                    9.3209e-07,
                    9.8026e-07,
                    1.058e-06,
                    1.1555e-06,
                    1.2688e-06,
                    1.3958e-06,
                    1.5397e-06,
                    1.687e-06,
                    1.6871e-06,
                    1.8717e-06,
                    2.1627e-06,
                    2.3308e-06,
                    2.5253e-06,
                    2.9186e-06,
                    3.244e-06,
                    3.6647e-06,
                    3.9521e-06,
                    4.2039e-06,
                    4.528e-06,
                    4.8067e-06,
                    5.0976e-06,
                    5.417e-06,
                    5.723e-06,
                    6.0205e-06,
                    6.2874e-06,
                    6.537e-06,
                    6.8445e-06,
                    7.1304e-06,
                    7.5046e-06,
                    7.9232e-06,
                    8.2875e-06,
                    8.6409e-06,
                    9.0328e-06,
                    9.3881e-06,
                    9.6455e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    1.3277e-11,
                    2.6815e-11,
                    4.0602e-11,
                    5.4622e-11,
                    6.8858e-11,
                    8.3285e-11,
                    9.7875e-11,
                    1.126e-10,
                    1.2741e-10,
                    1.4229e-10,
                    1.5719e-10,
                    1.7211e-10,
                    1.8706e-10,
                    2.0201e-10,
                    2.1699e-10,
                    2.3197e-10,
                    2.4697e-10,
                    2.62e-10,
                    2.7704e-10,
                    2.9212e-10,
                    3.0744e-10,
                    3.2339e-10,
                    3.4023e-10,
                    3.5817e-10,
                    3.7733e-10,
                    3.9772e-10,
                    4.193e-10,
                    4.4191e-10,
                    4.6533e-10,
                    4.8924e-10,
                    5.1343e-10,
                    5.3786e-10,
                    5.6249e-10,
                    5.8729e-10,
                    6.1224e-10,
                    6.3735e-10,
                    6.626e-10,
                    6.88e-10,
                    7.1358e-10,
                    7.3968e-10,
                    7.6608e-10,
                    7.9278e-10,
                    8.1979e-10,
                    8.4714e-10,
                    8.7484e-10,
                    9.0291e-10,
                    9.3137e-10,
                    9.6025e-10,
                    9.8957e-10,
                    1.0194e-09,
                    1.0497e-09,
                    1.0806e-09,
                    1.1123e-09,
                    1.1446e-09,
                    1.1778e-09,
                    1.2117e-09,
                    1.2464e-09,
                    1.282e-09,
                    1.3183e-09,
                    1.3553e-09,
                    1.393e-09,
                    1.4315e-09,
                    1.4706e-09,
                    1.5104e-09,
                    1.5508e-09,
                    1.592e-09,
                    1.6338e-09,
                    1.6764e-09,
                    1.7196e-09,
                    1.7635e-09,
                    1.8081e-09,
                    1.8534e-09,
                    1.8995e-09,
                    1.9462e-09,
                    1.9938e-09,
                    1.708e-08,
                    3.3232e-08,
                    7.0545e-08,
                    1.1716e-07,
                    1.7782e-07,
                    2.2821e-07,
                    2.775e-07,
                    3.3026e-07,
                    3.8858e-07,
                    4.5393e-07,
                    5.2495e-07,
                    6.0786e-07,
                    6.9776e-07,
                    7.8165e-07,
                    8.4946e-07,
                    9.3209e-07,
                    9.8026e-07,
                    1.058e-06,
                    1.1555e-06,
                    1.2688e-06,
                    1.3958e-06,
                    1.5397e-06,
                    1.687e-06,
                    1.6871e-06,
                    1.8717e-06,
                    2.1627e-06,
                    2.3308e-06,
                    2.5253e-06,
                    2.9186e-06,
                    3.244e-06,
                    3.6647e-06,
                    3.9521e-06,
                    4.2039e-06,
                    4.528e-06,
                    4.8067e-06,
                    5.0976e-06,
                    5.417e-06,
                    5.723e-06,
                    6.0205e-06,
                    6.2874e-06,
                    6.537e-06,
                    6.8445e-06,
                    7.1304e-06,
                    7.5046e-06,
                    7.9232e-06,
                    8.2875e-06,
                    8.6409e-06,
                    9.0328e-06,
                    9.3881e-06,
                    9.6455e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    3.9341e-10,
                    3.9341e-10,
                    4.057e-10,
                    4.1799e-10,
                    4.3029e-10,
                    4.4258e-10,
                    4.4258e-10,
                    4.4258e-10,
                    4.4258e-10,
                    4.5488e-10,
                    4.6729e-10
                ],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.5038e-08,
                    3.1141e-08,
                    6.8405e-08,
                    1.1497e-07,
                    1.7558e-07,
                    2.2591e-07,
                    2.7516e-07,
                    3.2786e-07,
                    3.8613e-07,
                    4.5142e-07,
                    5.2239e-07,
                    6.0525e-07,
                    6.9509e-07,
                    7.7893e-07,
                    8.4668e-07,
                    9.2924e-07,
                    9.7735e-07,
                    1.0551e-06,
                    1.1525e-06,
                    1.2657e-06,
                    1.3926e-06,
                    1.5364e-06,
                    1.6836e-06,
                    1.6836e-06,
                    1.8681e-06,
                    2.159e-06,
                    2.3269e-06,
                    2.5213e-06,
                    2.9145e-06,
                    3.2398e-06,
                    3.6604e-06,
                    3.9477e-06,
                    4.1994e-06,
                    4.5233e-06,
                    4.8019e-06,
                    5.0926e-06,
                    5.4119e-06,
                    5.7177e-06,
                    6.015e-06,
                    6.2818e-06,
                    6.5312e-06,
                    6.8385e-06,
                    7.1243e-06,
                    7.4982e-06,
                    7.9165e-06,
                    8.2805e-06,
                    8.6334e-06,
                    9.025e-06,
                    9.3799e-06,
                    9.6369e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.5038e-08,
                    3.1141e-08,
                    6.8405e-08,
                    1.1497e-07,
                    1.7558e-07,
                    2.2591e-07,
                    2.7516e-07,
                    3.2786e-07,
                    3.8613e-07,
                    4.5142e-07,
                    5.2239e-07,
                    6.0525e-07,
                    6.9509e-07,
                    7.7893e-07,
                    8.4668e-07,
                    9.2924e-07,
                    9.7735e-07,
                    1.0551e-06,
                    1.1525e-06,
                    1.2657e-06,
                    1.3926e-06,
                    1.5364e-06,
                    1.6836e-06,
                    1.6836e-06,
                    1.8681e-06,
                    2.159e-06,
                    2.3269e-06,
                    2.5213e-06,
                    2.9145e-06,
                    3.2398e-06,
                    3.6604e-06,
                    3.9477e-06,
                    4.1994e-06,
                    4.5233e-06,
                    4.8019e-06,
                    5.0926e-06,
                    5.4119e-06,
                    5.7177e-06,
                    6.015e-06,
                    6.2818e-06,
                    6.5312e-06,
                    6.8385e-06,
                    7.1243e-06,
                    7.4982e-06,
                    7.9165e-06,
                    8.2805e-06,
                    8.6334e-06,
                    9.025e-06,
                    9.3799e-06,
                    9.6369e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [
                    1.3277e-11,
                    2.6815e-11,
                    4.0602e-11,
                    5.4622e-11,
                    6.8858e-11,
                    8.3285e-11,
                    9.7875e-11,
                    1.126e-10,
                    1.2741e-10,
                    1.4229e-10,
                    1.5719e-10,
                    1.7211e-10,
                    1.8706e-10,
                    2.0201e-10,
                    2.1699e-10,
                    2.3197e-10,
                    2.4697e-10,
                    2.62e-10,
                    2.7704e-10,
                    2.9212e-10,
                    3.0744e-10,
                    3.2339e-10,
                    3.4023e-10,
                    3.5817e-10,
                    3.7733e-10,
                    3.9772e-10,
                    4.193e-10,
                    4.4191e-10,
                    4.6533e-10,
                    4.8924e-10,
                    5.1343e-10,
                    5.3786e-10,
                    5.6249e-10,
                    5.8729e-10,
                    6.1224e-10,
                    6.3735e-10,
                    6.626e-10,
                    6.88e-10,
                    7.1358e-10,
                    7.3968e-10,
                    7.6608e-10,
                    7.9278e-10,
                    8.1979e-10,
                    8.4714e-10,
                    8.7484e-10,
                    9.0291e-10,
                    9.3137e-10,
                    9.6025e-10,
                    9.8957e-10,
                    1.0194e-09,
                    1.0497e-09,
                    1.0806e-09,
                    1.1123e-09,
                    1.1446e-09,
                    1.1778e-09,
                    1.2117e-09,
                    1.2464e-09,
                    1.282e-09,
                    1.3183e-09,
                    1.3553e-09,
                    1.393e-09,
                    1.4315e-09,
                    1.4706e-09,
                    1.5104e-09,
                    1.5508e-09,
                    1.592e-09,
                    1.6338e-09,
                    1.6764e-09,
                    1.7196e-09,
                    1.7635e-09,
                    1.8081e-09,
                    1.8534e-09,
                    1.8995e-09,
                    1.9462e-09,
                    1.9938e-09,
                    2.042e-09,
                    2.0909e-09,
                    2.1406e-09,
                    2.1909e-09,
                    2.2419e-09,
                    2.2936e-09,
                    2.3458e-09,
                    2.3986e-09,
                    2.4519e-09,
                    2.5058e-09,
                    2.5603e-09,
                    2.6154e-09,
                    2.6713e-09,
                    2.728e-09,
                    2.7857e-09,
                    2.8452e-09,
                    2.9081e-09,
                    2.9754e-09,
                    3.0478e-09,
                    3.1261e-09,
                    3.2103e-09,
                    3.3005e-09,
                    3.3962e-09,
                    3.4968e-09,
                    3.6013e-09,
                    3.7091e-09,
                    3.8201e-09,
                    3.9345e-09,
                    4.0522e-09,
                    4.1734e-09,
                    4.2981e-09,
                    4.4264e-09,
                    4.5586e-09,
                    4.6948e-09,
                    4.8352e-09,
                    4.9805e-09,
                    5.1313e-09,
                    5.2883e-09,
                    5.452e-09,
                    5.6229e-09,
                    5.8013e-09,
                    5.9874e-09,
                    6.1814e-09,
                    6.3833e-09,
                    6.7155e-09,
                    7.0603e-09,
                    7.4241e-09,
                    7.8128e-09,
                    8.2072e-09,
                    8.6418e-09,
                    9.1033e-09,
                    9.6202e-09,
                    1.0183e-08,
                    1.0749e-08,
                    1.1384e-08,
                    1.2011e-08,
                    1.2642e-08,
                    1.3287e-08,
                    1.4052e-08,
                    1.485e-08,
                    1.575e-08,
                    1.6719e-08,
                    1.7769e-08,
                    1.9086e-08,
                    2.0846e-08,
                    2.2866e-08,
                    2.5135e-08,
                    2.7511e-08,
                    3.008e-08,
                    3.2965e-08,
                    3.5017e-08,
                    3.84e-08,
                    4.2268e-08,
                    4.6202e-08,
                    4.9445e-08,
                    5.2729e-08,
                    5.5887e-08,
                    5.9528e-08,
                    6.3343e-08,
                    6.7358e-08,
                    7.1373e-08,
                    7.545e-08,
                    7.9337e-08,
                    8.3477e-08,
                    8.7598e-08,
                    9.0722e-08,
                    9.5151e-08,
                    9.9323e-08,
                    1.0353e-07,
                    1.0774e-07,
                    1.1191e-07,
                    1.1553e-07,
                    1.1912e-07,
                    1.2325e-07,
                    1.2722e-07,
                    1.3145e-07,
                    1.3582e-07
                ],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [
                    1.3277e-11,
                    2.6815e-11,
                    4.0602e-11,
                    5.4622e-11,
                    6.8858e-11,
                    8.3285e-11,
                    9.7875e-11,
                    1.126e-10,
                    1.2741e-10,
                    1.4229e-10,
                    1.5719e-10,
                    1.7211e-10,
                    1.8706e-10,
                    2.0201e-10,
                    2.1699e-10,
                    2.3197e-10,
                    2.4697e-10,
                    2.62e-10,
                    2.7704e-10,
                    2.9212e-10,
                    3.0744e-10,
                    3.2339e-10,
                    3.4023e-10,
                    3.5817e-10,
                    3.7733e-10,
                    3.9772e-10,
                    4.193e-10,
                    4.4191e-10,
                    4.6533e-10,
                    4.8924e-10,
                    5.1343e-10,
                    5.3786e-10,
                    5.6249e-10,
                    5.8729e-10,
                    6.1224e-10,
                    6.3735e-10,
                    6.626e-10,
                    6.88e-10,
                    7.1358e-10,
                    7.3968e-10,
                    7.6608e-10,
                    7.9278e-10,
                    8.1979e-10,
                    8.4714e-10,
                    8.7484e-10,
                    9.0291e-10,
                    9.3137e-10,
                    9.6025e-10,
                    9.8957e-10,
                    1.0194e-09,
                    1.0497e-09,
                    1.0806e-09,
                    1.1123e-09,
                    1.1446e-09,
                    1.1778e-09,
                    1.2117e-09,
                    1.2464e-09,
                    1.282e-09,
                    1.3183e-09,
                    1.3553e-09,
                    1.393e-09,
                    1.4315e-09,
                    1.4706e-09,
                    1.5104e-09,
                    1.5508e-09,
                    1.592e-09,
                    1.6338e-09,
                    1.6764e-09,
                    1.7196e-09,
                    1.7635e-09,
                    1.8081e-09,
                    1.8534e-09,
                    1.8995e-09,
                    1.9462e-09,
                    1.9938e-09,
                    2.042e-09,
                    2.0909e-09,
                    2.1406e-09,
                    2.1909e-09,
                    2.2419e-09,
                    2.2936e-09,
                    2.3458e-09,
                    2.3986e-09,
                    2.4519e-09,
                    2.5058e-09,
                    2.5603e-09,
                    2.6154e-09,
                    2.6713e-09,
                    2.728e-09,
                    2.7857e-09,
                    2.8452e-09,
                    2.9081e-09,
                    2.9754e-09,
                    3.0478e-09,
                    3.1261e-09,
                    3.2103e-09,
                    3.3005e-09,
                    3.3962e-09,
                    3.4968e-09,
                    3.6013e-09,
                    3.7091e-09,
                    3.8201e-09,
                    3.9345e-09,
                    4.0522e-09,
                    4.1734e-09,
                    4.2981e-09,
                    4.4264e-09,
                    4.5586e-09,
                    4.6948e-09,
                    4.8352e-09,
                    4.9805e-09,
                    5.1313e-09,
                    5.2883e-09,
                    5.452e-09,
                    5.6229e-09,
                    5.8013e-09,
                    5.9874e-09,
                    6.1814e-09,
                    6.3833e-09,
                    6.7155e-09,
                    7.0603e-09,
                    7.4241e-09,
                    7.8128e-09,
                    8.2072e-09,
                    8.6418e-09,
                    9.1033e-09,
                    9.6202e-09,
                    1.0183e-08,
                    1.0749e-08,
                    1.1384e-08,
                    1.2011e-08,
                    1.2642e-08,
                    1.3287e-08,
                    1.4052e-08,
                    1.485e-08,
                    1.575e-08,
                    1.6719e-08,
                    1.7769e-08,
                    1.9086e-08,
                    2.0846e-08,
                    2.2866e-08,
                    2.5135e-08,
                    2.7511e-08,
                    3.008e-08,
                    3.2965e-08,
                    3.5017e-08,
                    3.84e-08,
                    4.2268e-08,
                    4.6202e-08,
                    4.9445e-08,
                    5.2729e-08,
                    5.5887e-08,
                    5.9528e-08,
                    6.3343e-08,
                    6.7358e-08,
                    7.1373e-08,
                    7.545e-08,
                    7.9337e-08,
                    8.3477e-08,
                    8.7598e-08,
                    9.0722e-08,
                    9.4757e-08,
                    9.8929e-08,
                    1.0313e-07,
                    1.0732e-07,
                    1.1148e-07,
                    1.1509e-07,
                    1.1867e-07,
                    1.2281e-07,
                    1.2678e-07,
                    1.3099e-07,
                    1.3536e-07
                ],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    3.9341e-10,
                    3.9341e-10,
                    4.057e-10,
                    4.1799e-10,
                    4.3029e-10,
                    4.4258e-10,
                    4.4258e-10,
                    4.4258e-10,
                    4.4258e-10,
                    4.5488e-10,
                    4.6729e-10
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -70.06312,
                            12.53982
                        ],
                        [
                            -69.94381,
                            12.44433
                        ],
                        [
                            -69.8871,
                            12.48101
                        ],
                        [
                            -70.02372,
                            12.60242
                        ],
                        [
                            -70.06312,
                            12.53982
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "AUS",
                "Country": "Australia",
                "Total_3GHG": 1.52,
                "Total_3GHG_timeseries": [
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0054,
                    0.0055,
                    0.0056,
                    0.0057,
                    0.0058,
                    0.0058,
                    0.0059,
                    0.006,
                    0.0061,
                    0.0062,
                    0.0063,
                    0.0063,
                    0.0064,
                    0.0065,
                    0.0066,
                    0.0067,
                    0.0069,
                    0.007,
                    0.0071,
                    0.0072,
                    0.0074,
                    0.0075,
                    0.0077,
                    0.0079,
                    0.0081,
                    0.0084,
                    0.0086,
                    0.0088,
                    0.0091,
                    0.0093,
                    0.0096,
                    0.0098,
                    0.0101,
                    0.0103,
                    0.0106,
                    0.0109,
                    0.0111,
                    0.0114,
                    0.0117,
                    0.012,
                    0.0122,
                    0.0125,
                    0.0127,
                    0.013,
                    0.0132,
                    0.0135,
                    0.0138,
                    0.0141,
                    0.0143,
                    0.0146,
                    0.0148,
                    0.0151,
                    0.0153,
                    0.0155,
                    0.0157,
                    0.016,
                    0.0162,
                    0.0164,
                    0.0166,
                    0.0168,
                    0.017,
                    0.0172,
                    0.0174,
                    0.0177,
                    0.0179,
                    0.0181,
                    0.0183,
                    0.0185,
                    0.0188,
                    0.0191,
                    0.0194,
                    0.0198,
                    0.0201,
                    0.0203,
                    0.0206,
                    0.0209,
                    0.0211,
                    0.0214,
                    0.0217,
                    0.022,
                    0.0223,
                    0.0226,
                    0.023,
                    0.0232,
                    0.0234,
                    0.0237,
                    0.0239,
                    0.0241,
                    0.0244,
                    0.0246,
                    0.0247,
                    0.0247,
                    0.0248
                ],
                "Fossil_3GHG": 1.08,
                "Fossil_3GHG_timeseries": [
                    9.8824e-07,
                    2.0806e-06,
                    3.2977e-06,
                    4.6323e-06,
                    6.0844e-06,
                    7.6781e-06,
                    9.39e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0049,
                    0.005,
                    0.0052,
                    0.0053,
                    0.0055,
                    0.0056,
                    0.0058,
                    0.006,
                    0.0061,
                    0.0063,
                    0.0065,
                    0.0067,
                    0.0068,
                    0.007,
                    0.0072,
                    0.0074,
                    0.0076,
                    0.0078,
                    0.008,
                    0.0082,
                    0.0084,
                    0.0086,
                    0.0089,
                    0.0091,
                    0.0093,
                    0.0095,
                    0.0097,
                    0.0099,
                    0.0101,
                    0.0103,
                    0.0105,
                    0.0107,
                    0.0109,
                    0.0111,
                    0.0113,
                    0.0115
                ],
                "Land_3GHG": 2.32,
                "Land_3GHG_timeseries": [
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.0049,
                    0.005,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0054,
                    0.0055,
                    0.0056,
                    0.0056,
                    0.0057,
                    0.0058,
                    0.0059,
                    0.006,
                    0.0061,
                    0.0062,
                    0.0063,
                    0.0065,
                    0.0066,
                    0.0068,
                    0.007,
                    0.0071,
                    0.0073,
                    0.0075,
                    0.0077,
                    0.0079,
                    0.008,
                    0.0082,
                    0.0084,
                    0.0086,
                    0.0088,
                    0.009,
                    0.0091,
                    0.0093,
                    0.0094,
                    0.0096,
                    0.0097,
                    0.0098,
                    0.01,
                    0.0101,
                    0.0103,
                    0.0105,
                    0.0106,
                    0.0107,
                    0.0109,
                    0.011,
                    0.0111,
                    0.0112,
                    0.0113,
                    0.0114,
                    0.0115,
                    0.0115,
                    0.0116,
                    0.0116,
                    0.0117,
                    0.0117,
                    0.0118,
                    0.0119,
                    0.0119,
                    0.012,
                    0.012,
                    0.012,
                    0.0121,
                    0.0122,
                    0.0123,
                    0.0125,
                    0.0126,
                    0.0127,
                    0.0128,
                    0.0128,
                    0.0129,
                    0.013,
                    0.0131,
                    0.0131,
                    0.0132,
                    0.0133,
                    0.0135,
                    0.0135,
                    0.0135,
                    0.0136,
                    0.0136,
                    0.0136,
                    0.0137,
                    0.0136,
                    0.0135,
                    0.0134,
                    0.0134
                ],
                "Total_CO2": 1.28,
                "Total_CO2_timeseries": [
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0053,
                    0.0054,
                    0.0055,
                    0.0056,
                    0.0057,
                    0.0059,
                    0.0059,
                    0.006,
                    0.0061,
                    0.0063,
                    0.0064,
                    0.0065,
                    0.0066,
                    0.0068,
                    0.0069,
                    0.007,
                    0.0072,
                    0.0073,
                    0.0075,
                    0.0076,
                    0.0077,
                    0.0078,
                    0.008,
                    0.0081,
                    0.0082,
                    0.0084,
                    0.0085,
                    0.0087,
                    0.0088,
                    0.009,
                    0.0092,
                    0.0094,
                    0.0096,
                    0.0098,
                    0.01,
                    0.0102,
                    0.0104,
                    0.0106,
                    0.0108,
                    0.011,
                    0.0112,
                    0.0114,
                    0.0117,
                    0.0119,
                    0.0122,
                    0.0124,
                    0.0126,
                    0.0128,
                    0.013,
                    0.0132,
                    0.0134,
                    0.0136,
                    0.0138,
                    0.014,
                    0.0142,
                    0.0143,
                    0.0145
                ],
                "Fossil_CO2": 1.12,
                "Fossil_CO2_timeseries": [
                    4.7905e-08,
                    9.5665e-08,
                    1.6426e-07,
                    2.4691e-07,
                    3.4403e-07,
                    4.7863e-07,
                    6.2773e-07,
                    7.8106e-07,
                    9.9945e-07,
                    1.2695e-06,
                    1.522e-06,
                    1.8767e-06,
                    2.2011e-06,
                    2.6078e-06,
                    3.0462e-06,
                    3.6227e-06,
                    4.181e-06,
                    4.871e-06,
                    5.5306e-06,
                    6.1622e-06,
                    6.811e-06,
                    7.548e-06,
                    8.4174e-06,
                    9.3747e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0039,
                    0.004,
                    0.0042,
                    0.0043,
                    0.0045,
                    0.0046,
                    0.0048,
                    0.0049,
                    0.0051,
                    0.0053,
                    0.0054,
                    0.0056,
                    0.0058,
                    0.006,
                    0.0061,
                    0.0063,
                    0.0065,
                    0.0067,
                    0.0069,
                    0.0071,
                    0.0072,
                    0.0074,
                    0.0076,
                    0.0078,
                    0.008,
                    0.0082,
                    0.0083,
                    0.0085,
                    0.0087
                ],
                "Land_CO2": 1.62,
                "Land_CO2_timeseries": [
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0043,
                    0.0043,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0045,
                    0.0046,
                    0.0046,
                    0.0047,
                    0.0047,
                    0.0048,
                    0.0048,
                    0.0048,
                    0.0048,
                    0.0048,
                    0.0049,
                    0.0049,
                    0.0049,
                    0.0049,
                    0.0049,
                    0.0049,
                    0.005,
                    0.005,
                    0.0051,
                    0.0051,
                    0.0052,
                    0.0052,
                    0.0053,
                    0.0053,
                    0.0053,
                    0.0054,
                    0.0054,
                    0.0054,
                    0.0055,
                    0.0055,
                    0.0055,
                    0.0056,
                    0.0057,
                    0.0057,
                    0.0058,
                    0.0058,
                    0.0058,
                    0.0058,
                    0.0058,
                    0.0058,
                    0.0058,
                    0.0058,
                    0.0058,
                    0.0058
                ],
                "Total_CH4": 1.75,
                "Total_CH4_timeseries": [
                    6.9341e-06,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0054,
                    0.0055,
                    0.0056,
                    0.0057,
                    0.0058,
                    0.006,
                    0.0061,
                    0.0062,
                    0.0063,
                    0.0063,
                    0.0064,
                    0.0064,
                    0.0065,
                    0.0066,
                    0.0066,
                    0.0067,
                    0.0067,
                    0.0067,
                    0.0068,
                    0.0069,
                    0.0069,
                    0.0069,
                    0.007,
                    0.007,
                    0.007,
                    0.007,
                    0.007,
                    0.007,
                    0.0071,
                    0.0072,
                    0.0073,
                    0.0073,
                    0.0074,
                    0.0074,
                    0.0074,
                    0.0075,
                    0.0075,
                    0.0075,
                    0.0075,
                    0.0076,
                    0.0076,
                    0.0076,
                    0.0076,
                    0.0076,
                    0.0076,
                    0.0076,
                    0.0077,
                    0.0076,
                    0.0075,
                    0.0074,
                    0.0073
                ],
                "Fossil_CH4": 1.0,
                "Fossil_CH4_timeseries": [
                    8.2045e-07,
                    1.7436e-06,
                    2.7691e-06,
                    3.8966e-06,
                    5.1257e-06,
                    6.4576e-06,
                    7.8918e-06,
                    9.4278e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026
                ],
                "Land_CH4": 3.0,
                "Land_CH4_timeseries": [
                    6.1137e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0046,
                    0.0047,
                    0.0047,
                    0.0048,
                    0.0048,
                    0.0048,
                    0.0048,
                    0.0049,
                    0.0049,
                    0.0049,
                    0.0049,
                    0.0049,
                    0.005,
                    0.0049,
                    0.005,
                    0.005,
                    0.005,
                    0.0049,
                    0.0049,
                    0.0049,
                    0.0049,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0051,
                    0.0051,
                    0.0051,
                    0.0051,
                    0.0051,
                    0.0051,
                    0.0051,
                    0.0051,
                    0.0051,
                    0.0052,
                    0.0051,
                    0.0051,
                    0.0051,
                    0.0051,
                    0.0051,
                    0.0051,
                    0.005,
                    0.0049,
                    0.0048,
                    0.0047
                ],
                "Total_N2O": 3.65,
                "Total_N2O_timeseries": [
                    4.1806e-06,
                    8.444e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.003
                ],
                "Fossil_N2O": 0.9,
                "Fossil_N2O_timeseries": [
                    1.1988e-07,
                    2.4132e-07,
                    3.6429e-07,
                    4.8874e-07,
                    6.1462e-07,
                    7.4186e-07,
                    8.7038e-07,
                    1.0001e-06,
                    1.1309e-06,
                    1.2626e-06,
                    1.3953e-06,
                    1.5288e-06,
                    1.6632e-06,
                    1.7984e-06,
                    1.9345e-06,
                    2.0714e-06,
                    2.2092e-06,
                    2.3478e-06,
                    2.4873e-06,
                    2.6278e-06,
                    2.7697e-06,
                    2.9142e-06,
                    3.0622e-06,
                    3.2141e-06,
                    3.3703e-06,
                    3.531e-06,
                    3.6958e-06,
                    3.8645e-06,
                    4.0363e-06,
                    4.2103e-06,
                    4.386e-06,
                    4.5631e-06,
                    4.7417e-06,
                    4.9215e-06,
                    5.1026e-06,
                    5.2849e-06,
                    5.4685e-06,
                    5.6533e-06,
                    5.8394e-06,
                    6.0345e-06,
                    6.2328e-06,
                    6.4345e-06,
                    6.6397e-06,
                    6.8488e-06,
                    7.0617e-06,
                    7.2787e-06,
                    7.5e-06,
                    7.7256e-06,
                    7.9557e-06,
                    8.1905e-06,
                    8.4304e-06,
                    8.6759e-06,
                    8.9277e-06,
                    9.186e-06,
                    9.4509e-06,
                    9.7224e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_N2O": 4.7,
                "Land_N2O_timeseries": [
                    4.0607e-06,
                    8.2026e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                142.46123,
                                -10.71909
                            ],
                            [
                                142.42583,
                                -10.72714
                            ],
                            [
                                142.39173,
                                -10.82114
                            ],
                            [
                                142.35112,
                                -10.88031
                            ],
                            [
                                142.28207,
                                -10.91569
                            ],
                            [
                                142.18838,
                                -10.91763
                            ],
                            [
                                142.12834,
                                -10.98416
                            ],
                            [
                                142.15428,
                                -11.12097
                            ],
                            [
                                142.12095,
                                -11.23101
                            ],
                            [
                                142.12619,
                                -11.30147
                            ],
                            [
                                142.10025,
                                -11.436
                            ],
                            [
                                142.04993,
                                -11.56123
                            ],
                            [
                                142.00088,
                                -11.7504
                            ],
                            [
                                141.9628,
                                -11.82147
                            ],
                            [
                                141.94592,
                                -11.97249
                            ],
                            [
                                142.00594,
                                -12.04112
                            ],
                            [
                                141.93635,
                                -12.0691
                            ],
                            [
                                141.89016,
                                -11.98985
                            ],
                            [
                                141.85289,
                                -11.98369
                            ],
                            [
                                141.81246,
                                -12.04659
                            ],
                            [
                                141.73887,
                                -12.20993
                            ],
                            [
                                141.71132,
                                -12.2452
                            ],
                            [
                                141.67198,
                                -12.37273
                            ],
                            [
                                141.59442,
                                -12.55632
                            ],
                            [
                                141.61963,
                                -12.57804
                            ],
                            [
                                141.75695,
                                -12.54011
                            ],
                            [
                                141.82041,
                                -12.59646
                            ],
                            [
                                141.88957,
                                -12.6089
                            ],
                            [
                                141.80679,
                                -12.68281
                            ],
                            [
                                141.76584,
                                -12.80651
                            ],
                            [
                                141.71095,
                                -12.87567
                            ],
                            [
                                141.63066,
                                -12.9163
                            ],
                            [
                                141.59042,
                                -13.01352
                            ],
                            [
                                141.61653,
                                -13.04042
                            ],
                            [
                                141.62993,
                                -13.15399
                            ],
                            [
                                141.6943,
                                -13.27033
                            ],
                            [
                                141.55078,
                                -13.50857
                            ],
                            [
                                141.5044,
                                -13.65433
                            ],
                            [
                                141.46815,
                                -13.86216
                            ],
                            [
                                141.46927,
                                -13.91966
                            ],
                            [
                                141.59443,
                                -14.09777
                            ],
                            [
                                141.60018,
                                -14.24645
                            ],
                            [
                                141.55115,
                                -14.37898
                            ],
                            [
                                141.52666,
                                -14.48637
                            ],
                            [
                                141.55258,
                                -14.58999
                            ],
                            [
                                141.58978,
                                -14.85022
                            ],
                            [
                                141.65979,
                                -14.98526
                            ],
                            [
                                141.63659,
                                -15.15185
                            ],
                            [
                                141.58266,
                                -15.20215
                            ],
                            [
                                141.56915,
                                -15.29237
                            ],
                            [
                                141.47785,
                                -15.50665
                            ],
                            [
                                141.43486,
                                -15.66037
                            ],
                            [
                                141.39298,
                                -15.95385
                            ],
                            [
                                141.43154,
                                -16.07779
                            ],
                            [
                                141.35046,
                                -16.22088
                            ],
                            [
                                141.28833,
                                -16.42613
                            ],
                            [
                                141.30419,
                                -16.45782
                            ],
                            [
                                141.27215,
                                -16.5539
                            ],
                            [
                                141.23452,
                                -16.58607
                            ],
                            [
                                141.18217,
                                -16.72317
                            ],
                            [
                                141.08179,
                                -16.8049
                            ],
                            [
                                141.06352,
                                -16.87222
                            ],
                            [
                                140.97362,
                                -16.97045
                            ],
                            [
                                140.94726,
                                -17.03788
                            ],
                            [
                                140.94979,
                                -17.15075
                            ],
                            [
                                140.9131,
                                -17.23149
                            ],
                            [
                                140.89424,
                                -17.34801
                            ],
                            [
                                140.8272,
                                -17.46486
                            ],
                            [
                                140.70964,
                                -17.51098
                            ],
                            [
                                140.59549,
                                -17.5966
                            ],
                            [
                                140.37732,
                                -17.67979
                            ],
                            [
                                140.21626,
                                -17.70758
                            ],
                            [
                                140.04441,
                                -17.72148
                            ],
                            [
                                139.95067,
                                -17.6756
                            ],
                            [
                                139.9346,
                                -17.63018
                            ],
                            [
                                139.82137,
                                -17.57226
                            ],
                            [
                                139.7575,
                                -17.57566
                            ],
                            [
                                139.64508,
                                -17.53602
                            ],
                            [
                                139.47613,
                                -17.40134
                            ],
                            [
                                139.34241,
                                -17.37363
                            ],
                            [
                                139.2465,
                                -17.32599
                            ],
                            [
                                139.209,
                                -17.28342
                            ],
                            [
                                139.15577,
                                -17.16491
                            ],
                            [
                                139.14129,
                                -17.08033
                            ],
                            [
                                139.15489,
                                -17.02902
                            ],
                            [
                                139.08546,
                                -16.99633
                            ],
                            [
                                139.00745,
                                -16.89566
                            ],
                            [
                                138.84527,
                                -16.86755
                            ],
                            [
                                138.63429,
                                -16.77015
                            ],
                            [
                                138.53945,
                                -16.78164
                            ],
                            [
                                138.4272,
                                -16.77501
                            ],
                            [
                                138.32009,
                                -16.74739
                            ],
                            [
                                138.19218,
                                -16.69452
                            ],
                            [
                                138.11695,
                                -16.64714
                            ],
                            [
                                137.86661,
                                -16.42678
                            ],
                            [
                                137.72838,
                                -16.23356
                            ],
                            [
                                137.54026,
                                -16.16648
                            ],
                            [
                                137.36834,
                                -16.12694
                            ],
                            [
                                137.30964,
                                -16.08908
                            ],
                            [
                                137.25332,
                                -16.01364
                            ],
                            [
                                137.08363,
                                -15.94329
                            ],
                            [
                                137.00518,
                                -15.87747
                            ],
                            [
                                136.91529,
                                -15.90078
                            ],
                            [
                                136.82199,
                                -15.90125
                            ],
                            [
                                136.70916,
                                -15.93045
                            ],
                            [
                                136.71208,
                                -15.85837
                            ],
                            [
                                136.6828,
                                -15.77414
                            ],
                            [
                                136.72043,
                                -15.69996
                            ],
                            [
                                136.67414,
                                -15.66911
                            ],
                            [
                                136.56335,
                                -15.72835
                            ],
                            [
                                136.51932,
                                -15.71711
                            ],
                            [
                                136.4175,
                                -15.63008
                            ],
                            [
                                136.32154,
                                -15.6051
                            ],
                            [
                                136.27639,
                                -15.54825
                            ],
                            [
                                136.23902,
                                -15.42141
                            ],
                            [
                                136.16491,
                                -15.39069
                            ],
                            [
                                135.92634,
                                -15.24844
                            ],
                            [
                                135.86508,
                                -15.18537
                            ],
                            [
                                135.63919,
                                -15.04644
                            ],
                            [
                                135.58411,
                                -15.04476
                            ],
                            [
                                135.47033,
                                -14.96751
                            ],
                            [
                                135.41232,
                                -14.86707
                            ],
                            [
                                135.38563,
                                -14.72951
                            ],
                            [
                                135.41498,
                                -14.73301
                            ],
                            [
                                135.52065,
                                -14.62436
                            ],
                            [
                                135.53702,
                                -14.56226
                            ],
                            [
                                135.58712,
                                -14.50306
                            ],
                            [
                                135.6179,
                                -14.4285
                            ],
                            [
                                135.67172,
                                -14.39538
                            ],
                            [
                                135.7441,
                                -14.2768
                            ],
                            [
                                135.86989,
                                -14.18876
                            ],
                            [
                                135.91242,
                                -14.04173
                            ],
                            [
                                135.91248,
                                -13.9896
                            ],
                            [
                                135.98742,
                                -13.89416
                            ],
                            [
                                136.01295,
                                -13.82844
                            ],
                            [
                                136.02777,
                                -13.68408
                            ],
                            [
                                135.95562,
                                -13.74171
                            ],
                            [
                                135.88341,
                                -13.7138
                            ],
                            [
                                135.83941,
                                -13.59518
                            ],
                            [
                                135.86584,
                                -13.55451
                            ],
                            [
                                135.86105,
                                -13.44665
                            ],
                            [
                                135.95663,
                                -13.44344
                            ],
                            [
                                135.88213,
                                -13.35873
                            ],
                            [
                                135.91531,
                                -13.27746
                            ],
                            [
                                135.97946,
                                -13.23191
                            ],
                            [
                                136.05387,
                                -13.23872
                            ],
                            [
                                136.1025,
                                -13.15812
                            ],
                            [
                                136.13809,
                                -13.20816
                            ],
                            [
                                136.20106,
                                -13.2424
                            ],
                            [
                                136.24068,
                                -13.17191
                            ],
                            [
                                136.30997,
                                -13.16018
                            ],
                            [
                                136.29787,
                                -13.10239
                            ],
                            [
                                136.36781,
                                -13.06892
                            ],
                            [
                                136.36125,
                                -13.1521
                            ],
                            [
                                136.39677,
                                -13.24932
                            ],
                            [
                                136.48395,
                                -13.16585
                            ],
                            [
                                136.52942,
                                -13.14799
                            ],
                            [
                                136.56679,
                                -13.0115
                            ],
                            [
                                136.63364,
                                -12.9536
                            ],
                            [
                                136.5488,
                                -12.91587
                            ],
                            [
                                136.48333,
                                -12.84122
                            ],
                            [
                                136.54824,
                                -12.74421
                            ],
                            [
                                136.59766,
                                -12.78368
                            ],
                            [
                                136.63309,
                                -12.70282
                            ],
                            [
                                136.69017,
                                -12.70698
                            ],
                            [
                                136.69333,
                                -12.62907
                            ],
                            [
                                136.74673,
                                -12.5579
                            ],
                            [
                                136.72942,
                                -12.47868
                            ],
                            [
                                136.77986,
                                -12.45215
                            ],
                            [
                                136.80658,
                                -12.50216
                            ],
                            [
                                136.93466,
                                -12.37494
                            ],
                            [
                                136.9258,
                                -12.28723
                            ],
                            [
                                136.86674,
                                -12.21888
                            ],
                            [
                                136.78113,
                                -12.16419
                            ],
                            [
                                136.71205,
                                -12.19998
                            ],
                            [
                                136.74228,
                                -12.2679
                            ],
                            [
                                136.66736,
                                -12.2808
                            ],
                            [
                                136.59881,
                                -12.19568
                            ],
                            [
                                136.52859,
                                -11.99562
                            ],
                            [
                                136.41462,
                                -11.96276
                            ],
                            [
                                136.33941,
                                -12.05358
                            ],
                            [
                                136.27376,
                                -12.06293
                            ],
                            [
                                136.21149,
                                -12.15143
                            ],
                            [
                                136.23521,
                                -12.21114
                            ],
                            [
                                136.33835,
                                -12.20634
                            ],
                            [
                                136.36056,
                                -12.24957
                            ],
                            [
                                136.30378,
                                -12.39685
                            ],
                            [
                                136.2307,
                                -12.46107
                            ],
                            [
                                136.14875,
                                -12.43891
                            ],
                            [
                                136.02011,
                                -12.4825
                            ],
                            [
                                135.97515,
                                -12.37701
                            ],
                            [
                                136.0517,
                                -12.26723
                            ],
                            [
                                135.96526,
                                -12.27279
                            ],
                            [
                                135.93011,
                                -12.22303
                            ],
                            [
                                135.95694,
                                -12.14863
                            ],
                            [
                                135.88221,
                                -12.15532
                            ],
                            [
                                135.78262,
                                -12.22389
                            ],
                            [
                                135.72951,
                                -12.29189
                            ],
                            [
                                135.65593,
                                -12.20724
                            ],
                            [
                                135.65873,
                                -12.15497
                            ],
                            [
                                135.82652,
                                -12.00458
                            ],
                            [
                                135.8117,
                                -11.98174
                            ],
                            [
                                135.65804,
                                -12.03986
                            ],
                            [
                                135.57397,
                                -12.09598
                            ],
                            [
                                135.5236,
                                -12.06496
                            ],
                            [
                                135.47147,
                                -12.10743
                            ],
                            [
                                135.36678,
                                -12.08841
                            ],
                            [
                                135.26469,
                                -12.17946
                            ],
                            [
                                135.25885,
                                -12.2258
                            ],
                            [
                                135.1701,
                                -12.26603
                            ],
                            [
                                135.14343,
                                -12.2402
                            ],
                            [
                                135.05549,
                                -12.25861
                            ],
                            [
                                134.97245,
                                -12.16089
                            ],
                            [
                                134.85475,
                                -12.1258
                            ],
                            [
                                134.84012,
                                -12.06106
                            ],
                            [
                                134.79657,
                                -12.04076
                            ],
                            [
                                134.75407,
                                -11.95393
                            ],
                            [
                                134.68957,
                                -11.96819
                            ],
                            [
                                134.60591,
                                -12.04601
                            ],
                            [
                                134.48849,
                                -12.07159
                            ],
                            [
                                134.34469,
                                -12.03553
                            ],
                            [
                                134.2855,
                                -11.9883
                            ],
                            [
                                134.24946,
                                -12.03113
                            ],
                            [
                                134.18885,
                                -12.02537
                            ],
                            [
                                134.1273,
                                -11.90298
                            ],
                            [
                                134.07507,
                                -11.93189
                            ],
                            [
                                134.03165,
                                -11.85736
                            ],
                            [
                                133.91682,
                                -11.91938
                            ],
                            [
                                133.83872,
                                -11.87308
                            ],
                            [
                                133.89466,
                                -11.80642
                            ],
                            [
                                133.86876,
                                -11.75213
                            ],
                            [
                                133.79387,
                                -11.73045
                            ],
                            [
                                133.74153,
                                -11.77918
                            ],
                            [
                                133.6737,
                                -11.79061
                            ],
                            [
                                133.62619,
                                -11.83569
                            ],
                            [
                                133.54835,
                                -11.82326
                            ],
                            [
                                133.52227,
                                -11.76626
                            ],
                            [
                                133.46,
                                -11.7971
                            ],
                            [
                                133.32208,
                                -11.76623
                            ],
                            [
                                133.30127,
                                -11.70331
                            ],
                            [
                                133.24603,
                                -11.73105
                            ],
                            [
                                133.15647,
                                -11.70489
                            ],
                            [
                                133.10872,
                                -11.63488
                            ],
                            [
                                133.00573,
                                -11.4338
                            ],
                            [
                                132.96664,
                                -11.41155
                            ],
                            [
                                132.9166,
                                -11.33533
                            ],
                            [
                                132.73138,
                                -11.51755
                            ],
                            [
                                132.67246,
                                -11.51549
                            ],
                            [
                                132.62358,
                                -11.41496
                            ],
                            [
                                132.50924,
                                -11.33086
                            ],
                            [
                                132.50217,
                                -11.2737
                            ],
                            [
                                132.44984,
                                -11.22112
                            ],
                            [
                                132.37877,
                                -11.21136
                            ],
                            [
                                132.31426,
                                -11.16731
                            ],
                            [
                                132.23706,
                                -11.19731
                            ],
                            [
                                132.18492,
                                -11.13348
                            ],
                            [
                                132.14539,
                                -11.15061
                            ],
                            [
                                132.19604,
                                -11.21834
                            ],
                            [
                                132.18456,
                                -11.30718
                            ],
                            [
                                132.22994,
                                -11.35688
                            ],
                            [
                                132.15028,
                                -11.37854
                            ],
                            [
                                132.14985,
                                -11.32453
                            ],
                            [
                                132.10283,
                                -11.30173
                            ],
                            [
                                132.10866,
                                -11.22416
                            ],
                            [
                                131.97515,
                                -11.14168
                            ],
                            [
                                131.98207,
                                -11.21764
                            ],
                            [
                                131.9317,
                                -11.25408
                            ],
                            [
                                131.89773,
                                -11.19397
                            ],
                            [
                                131.82172,
                                -11.22527
                            ],
                            [
                                131.78896,
                                -11.32303
                            ],
                            [
                                131.86152,
                                -11.29608
                            ],
                            [
                                131.95884,
                                -11.34469
                            ],
                            [
                                131.96361,
                                -11.40776
                            ],
                            [
                                132.05166,
                                -11.45552
                            ],
                            [
                                132.06324,
                                -11.51792
                            ],
                            [
                                132.11444,
                                -11.53586
                            ],
                            [
                                132.25188,
                                -11.45622
                            ],
                            [
                                132.35161,
                                -11.44296
                            ],
                            [
                                132.45546,
                                -11.45867
                            ],
                            [
                                132.52949,
                                -11.52185
                            ],
                            [
                                132.54938,
                                -11.60831
                            ],
                            [
                                132.50097,
                                -11.68083
                            ],
                            [
                                132.5955,
                                -11.72947
                            ],
                            [
                                132.5824,
                                -11.78547
                            ],
                            [
                                132.63792,
                                -11.82586
                            ],
                            [
                                132.65361,
                                -11.88775
                            ],
                            [
                                132.61937,
                                -12.0183
                            ],
                            [
                                132.62792,
                                -12.08547
                            ],
                            [
                                132.55299,
                                -12.09818
                            ],
                            [
                                132.44329,
                                -12.14697
                            ],
                            [
                                132.41574,
                                -12.2217
                            ],
                            [
                                132.3524,
                                -12.19971
                            ],
                            [
                                132.27977,
                                -12.22328
                            ],
                            [
                                132.26134,
                                -12.17543
                            ],
                            [
                                132.17259,
                                -12.21345
                            ],
                            [
                                132.07661,
                                -12.2884
                            ],
                            [
                                132.02584,
                                -12.2973
                            ],
                            [
                                131.9396,
                                -12.27208
                            ],
                            [
                                131.8666,
                                -12.2203
                            ],
                            [
                                131.7511,
                                -12.2738
                            ],
                            [
                                131.68648,
                                -12.28282
                            ],
                            [
                                131.47594,
                                -12.28281
                            ],
                            [
                                131.36548,
                                -12.24254
                            ],
                            [
                                131.31701,
                                -12.16932
                            ],
                            [
                                131.31717,
                                -12.09331
                            ],
                            [
                                131.21328,
                                -12.22428
                            ],
                            [
                                131.16422,
                                -12.1753
                            ],
                            [
                                131.04408,
                                -12.14849
                            ],
                            [
                                131.00293,
                                -12.16646
                            ],
                            [
                                131.02711,
                                -12.23162
                            ],
                            [
                                131.01718,
                                -12.31546
                            ],
                            [
                                130.89517,
                                -12.33711
                            ],
                            [
                                130.84982,
                                -12.37944
                            ],
                            [
                                130.86431,
                                -12.51747
                            ],
                            [
                                130.88628,
                                -12.56844
                            ],
                            [
                                130.79102,
                                -12.57619
                            ],
                            [
                                130.75049,
                                -12.43144
                            ],
                            [
                                130.62118,
                                -12.38793
                            ],
                            [
                                130.58704,
                                -12.47063
                            ],
                            [
                                130.56849,
                                -12.56952
                            ],
                            [
                                130.60712,
                                -12.60116
                            ],
                            [
                                130.58547,
                                -12.67593
                            ],
                            [
                                130.53893,
                                -12.67968
                            ],
                            [
                                130.43336,
                                -12.63916
                            ],
                            [
                                130.35317,
                                -12.67698
                            ],
                            [
                                130.35597,
                                -12.81098
                            ],
                            [
                                130.33221,
                                -12.89097
                            ],
                            [
                                130.24211,
                                -12.94691
                            ],
                            [
                                130.1744,
                                -12.91591
                            ],
                            [
                                130.14359,
                                -12.93777
                            ],
                            [
                                130.12116,
                                -13.16254
                            ],
                            [
                                130.17163,
                                -13.1883
                            ],
                            [
                                130.27611,
                                -13.32692
                            ],
                            [
                                130.23244,
                                -13.34489
                            ],
                            [
                                130.14317,
                                -13.45306
                            ],
                            [
                                130.01279,
                                -13.52977
                            ],
                            [
                                129.96133,
                                -13.53424
                            ],
                            [
                                129.90427,
                                -13.50084
                            ],
                            [
                                129.82501,
                                -13.50973
                            ],
                            [
                                129.83109,
                                -13.56448
                            ],
                            [
                                129.79335,
                                -13.66181
                            ],
                            [
                                129.79011,
                                -13.78294
                            ],
                            [
                                129.73681,
                                -13.83429
                            ],
                            [
                                129.74565,
                                -13.92166
                            ],
                            [
                                129.71744,
                                -14.01188
                            ],
                            [
                                129.60686,
                                -14.05174
                            ],
                            [
                                129.50416,
                                -14.12734
                            ],
                            [
                                129.41532,
                                -14.23679
                            ],
                            [
                                129.37219,
                                -14.33878
                            ],
                            [
                                129.36248,
                                -14.4182
                            ],
                            [
                                129.40704,
                                -14.43586
                            ],
                            [
                                129.53013,
                                -14.54788
                            ],
                            [
                                129.65978,
                                -14.57807
                            ],
                            [
                                129.5965,
                                -14.61475
                            ],
                            [
                                129.59265,
                                -14.66397
                            ],
                            [
                                129.67542,
                                -14.76221
                            ],
                            [
                                129.77583,
                                -14.82585
                            ],
                            [
                                129.7147,
                                -14.85108
                            ],
                            [
                                129.58562,
                                -14.83427
                            ],
                            [
                                129.50628,
                                -14.80928
                            ],
                            [
                                129.59192,
                                -14.95937
                            ],
                            [
                                129.6199,
                                -14.95566
                            ],
                            [
                                129.64401,
                                -15.07771
                            ],
                            [
                                129.63067,
                                -15.14013
                            ],
                            [
                                129.52875,
                                -15.02745
                            ],
                            [
                                129.48355,
                                -14.94579
                            ],
                            [
                                129.37774,
                                -14.90602
                            ],
                            [
                                129.32339,
                                -14.8635
                            ],
                            [
                                129.2242,
                                -14.85417
                            ],
                            [
                                129.23747,
                                -15.0044
                            ],
                            [
                                129.26702,
                                -15.03756
                            ],
                            [
                                129.23519,
                                -15.12339
                            ],
                            [
                                129.19577,
                                -15.11739
                            ],
                            [
                                129.17151,
                                -15.04884
                            ],
                            [
                                129.18304,
                                -14.9888
                            ],
                            [
                                129.07226,
                                -14.89752
                            ],
                            [
                                128.904,
                                -14.85829
                            ],
                            [
                                128.79415,
                                -14.85669
                            ],
                            [
                                128.67718,
                                -14.79767
                            ],
                            [
                                128.59561,
                                -14.8009
                            ],
                            [
                                128.54612,
                                -14.7756
                            ],
                            [
                                128.38832,
                                -14.81981
                            ],
                            [
                                128.46161,
                                -14.88491
                            ],
                            [
                                128.35508,
                                -14.90436
                            ],
                            [
                                128.35305,
                                -14.96324
                            ],
                            [
                                128.23948,
                                -14.9969
                            ],
                            [
                                128.19708,
                                -15.08715
                            ],
                            [
                                128.22199,
                                -15.20183
                            ],
                            [
                                128.09588,
                                -15.17376
                            ],
                            [
                                128.07776,
                                -15.10103
                            ],
                            [
                                128.09813,
                                -15.06101
                            ],
                            [
                                128.12653,
                                -14.86281
                            ],
                            [
                                128.18843,
                                -14.83005
                            ],
                            [
                                128.16783,
                                -14.70768
                            ],
                            [
                                128.07298,
                                -14.64427
                            ],
                            [
                                128.03718,
                                -14.58913
                            ],
                            [
                                127.94354,
                                -14.52722
                            ],
                            [
                                127.87029,
                                -14.45571
                            ],
                            [
                                127.82628,
                                -14.4444
                            ],
                            [
                                127.76509,
                                -14.31227
                            ],
                            [
                                127.66,
                                -14.18668
                            ],
                            [
                                127.51416,
                                -14.07235
                            ],
                            [
                                127.45651,
                                -14.05573
                            ],
                            [
                                127.46125,
                                -13.99647
                            ],
                            [
                                127.34968,
                                -13.9111
                            ],
                            [
                                127.30715,
                                -13.95226
                            ],
                            [
                                127.27113,
                                -13.91159
                            ],
                            [
                                127.20454,
                                -13.95923
                            ],
                            [
                                127.1751,
                                -13.91481
                            ],
                            [
                                127.12057,
                                -13.96577
                            ],
                            [
                                127.07595,
                                -13.84621
                            ],
                            [
                                126.96452,
                                -13.74756
                            ],
                            [
                                126.87867,
                                -13.75268
                            ],
                            [
                                126.7497,
                                -13.79311
                            ],
                            [
                                126.80912,
                                -13.92503
                            ],
                            [
                                126.75695,
                                -13.97562
                            ],
                            [
                                126.71469,
                                -14.11753
                            ],
                            [
                                126.65861,
                                -14.07921
                            ],
                            [
                                126.64774,
                                -14.17426
                            ],
                            [
                                126.57096,
                                -14.15513
                            ],
                            [
                                126.49992,
                                -14.10774
                            ],
                            [
                                126.4871,
                                -13.98943
                            ],
                            [
                                126.43487,
                                -13.99073
                            ],
                            [
                                126.30353,
                                -14.1382
                            ],
                            [
                                126.34797,
                                -14.1782
                            ],
                            [
                                126.30001,
                                -14.22675
                            ],
                            [
                                126.24101,
                                -14.2273
                            ],
                            [
                                126.19879,
                                -14.00636
                            ],
                            [
                                126.12761,
                                -13.93871
                            ],
                            [
                                126.05179,
                                -14.02353
                            ],
                            [
                                126.03168,
                                -14.09123
                            ],
                            [
                                126.10471,
                                -14.07937
                            ],
                            [
                                126.16161,
                                -14.14657
                            ],
                            [
                                126.12758,
                                -14.23099
                            ],
                            [
                                126.06019,
                                -14.2529
                            ],
                            [
                                126.08464,
                                -14.3204
                            ],
                            [
                                126.01904,
                                -14.42267
                            ],
                            [
                                126.0459,
                                -14.52847
                            ],
                            [
                                125.96602,
                                -14.52505
                            ],
                            [
                                125.90556,
                                -14.5734
                            ],
                            [
                                125.84399,
                                -14.53298
                            ],
                            [
                                125.80885,
                                -14.47474
                            ],
                            [
                                125.72525,
                                -14.42041
                            ],
                            [
                                125.6863,
                                -14.49928
                            ],
                            [
                                125.65565,
                                -14.38755
                            ],
                            [
                                125.72064,
                                -14.31057
                            ],
                            [
                                125.61208,
                                -14.2389
                            ],
                            [
                                125.58399,
                                -14.31032
                            ],
                            [
                                125.61957,
                                -14.40101
                            ],
                            [
                                125.57705,
                                -14.5399
                            ],
                            [
                                125.52228,
                                -14.50637
                            ],
                            [
                                125.42049,
                                -14.57482
                            ],
                            [
                                125.26555,
                                -14.57145
                            ],
                            [
                                125.21862,
                                -14.67056
                            ],
                            [
                                125.1396,
                                -14.75492
                            ],
                            [
                                125.20109,
                                -14.79153
                            ],
                            [
                                125.21608,
                                -14.86181
                            ],
                            [
                                125.31736,
                                -14.88506
                            ],
                            [
                                125.29138,
                                -14.99613
                            ],
                            [
                                125.38859,
                                -15.02712
                            ],
                            [
                                125.37254,
                                -15.1092
                            ],
                            [
                                125.3282,
                                -15.15632
                            ],
                            [
                                125.28537,
                                -15.1109
                            ],
                            [
                                125.22784,
                                -15.10625
                            ],
                            [
                                125.16001,
                                -15.14547
                            ],
                            [
                                125.06148,
                                -15.02813
                            ],
                            [
                                125.04363,
                                -15.07812
                            ],
                            [
                                124.97426,
                                -15.13173
                            ],
                            [
                                124.9167,
                                -15.11166
                            ],
                            [
                                124.84478,
                                -15.15899
                            ],
                            [
                                124.88357,
                                -15.25489
                            ],
                            [
                                124.88164,
                                -15.30606
                            ],
                            [
                                124.92201,
                                -15.35211
                            ],
                            [
                                125.03448,
                                -15.29
                            ],
                            [
                                125.10368,
                                -15.33329
                            ],
                            [
                                125.07739,
                                -15.46298
                            ],
                            [
                                125.02306,
                                -15.4953
                            ],
                            [
                                124.9516,
                                -15.3923
                            ],
                            [
                                124.84181,
                                -15.32158
                            ],
                            [
                                124.71614,
                                -15.26139
                            ],
                            [
                                124.67963,
                                -15.40081
                            ],
                            [
                                124.68456,
                                -15.46502
                            ],
                            [
                                124.62252,
                                -15.46796
                            ],
                            [
                                124.58564,
                                -15.51749
                            ],
                            [
                                124.51361,
                                -15.47359
                            ],
                            [
                                124.45443,
                                -15.49431
                            ],
                            [
                                124.42291,
                                -15.54614
                            ],
                            [
                                124.44415,
                                -15.66567
                            ],
                            [
                                124.40289,
                                -15.6826
                            ],
                            [
                                124.39367,
                                -15.7466
                            ],
                            [
                                124.40933,
                                -15.85992
                            ],
                            [
                                124.47738,
                                -15.86559
                            ],
                            [
                                124.47741,
                                -15.93544
                            ],
                            [
                                124.53048,
                                -15.95819
                            ],
                            [
                                124.57125,
                                -15.86661
                            ],
                            [
                                124.63273,
                                -15.78913
                            ],
                            [
                                124.70047,
                                -15.76823
                            ],
                            [
                                124.68178,
                                -15.85801
                            ],
                            [
                                124.61223,
                                -15.89628
                            ],
                            [
                                124.58455,
                                -16.03941
                            ],
                            [
                                124.60096,
                                -16.12296
                            ],
                            [
                                124.55813,
                                -16.12873
                            ],
                            [
                                124.5182,
                                -16.18324
                            ],
                            [
                                124.47005,
                                -16.10742
                            ],
                            [
                                124.38426,
                                -16.22323
                            ],
                            [
                                124.39908,
                                -16.33155
                            ],
                            [
                                124.42292,
                                -16.35588
                            ],
                            [
                                124.57223,
                                -16.33067
                            ],
                            [
                                124.6935,
                                -16.34717
                            ],
                            [
                                124.7024,
                                -16.40107
                            ],
                            [
                                124.59731,
                                -16.41377
                            ],
                            [
                                124.45722,
                                -16.40793
                            ],
                            [
                                124.3906,
                                -16.34806
                            ],
                            [
                                124.32096,
                                -16.41911
                            ],
                            [
                                124.22479,
                                -16.41355
                            ],
                            [
                                124.17451,
                                -16.30983
                            ],
                            [
                                124.11649,
                                -16.2805
                            ],
                            [
                                123.99172,
                                -16.25598
                            ],
                            [
                                123.94119,
                                -16.29781
                            ],
                            [
                                123.85417,
                                -16.42264
                            ],
                            [
                                123.8572,
                                -16.32508
                            ],
                            [
                                123.75709,
                                -16.2713
                            ],
                            [
                                123.80313,
                                -16.19165
                            ],
                            [
                                123.72577,
                                -16.14574
                            ],
                            [
                                123.56485,
                                -16.17975
                            ],
                            [
                                123.58711,
                                -16.25859
                            ],
                            [
                                123.6972,
                                -16.34307
                            ],
                            [
                                123.65639,
                                -16.37446
                            ],
                            [
                                123.67055,
                                -16.43233
                            ],
                            [
                                123.58612,
                                -16.52092
                            ],
                            [
                                123.49606,
                                -16.49916
                            ],
                            [
                                123.46472,
                                -16.53281
                            ],
                            [
                                123.60765,
                                -16.5498
                            ],
                            [
                                123.56062,
                                -16.62692
                            ],
                            [
                                123.70566,
                                -16.75518
                            ],
                            [
                                123.7655,
                                -16.87839
                            ],
                            [
                                123.82889,
                                -16.95756
                            ],
                            [
                                123.79975,
                                -17.00974
                            ],
                            [
                                123.83398,
                                -17.13628
                            ],
                            [
                                123.80075,
                                -17.1597
                            ],
                            [
                                123.75351,
                                -17.08164
                            ],
                            [
                                123.63222,
                                -17.00119
                            ],
                            [
                                123.58733,
                                -17.03544
                            ],
                            [
                                123.59163,
                                -17.09987
                            ],
                            [
                                123.64161,
                                -17.18407
                            ],
                            [
                                123.60148,
                                -17.33905
                            ],
                            [
                                123.54395,
                                -17.46816
                            ],
                            [
                                123.45765,
                                -17.35232
                            ],
                            [
                                123.40528,
                                -17.3063
                            ],
                            [
                                123.34492,
                                -17.16497
                            ],
                            [
                                123.29058,
                                -17.10409
                            ],
                            [
                                123.27791,
                                -17.03927
                            ],
                            [
                                123.22961,
                                -16.96734
                            ],
                            [
                                123.15135,
                                -16.91946
                            ],
                            [
                                123.17047,
                                -16.85627
                            ],
                            [
                                123.10986,
                                -16.78919
                            ],
                            [
                                123.11266,
                                -16.71232
                            ],
                            [
                                123.03956,
                                -16.67172
                            ],
                            [
                                122.95971,
                                -16.57802
                            ],
                            [
                                122.98937,
                                -16.53569
                            ],
                            [
                                123.02026,
                                -16.41037
                            ],
                            [
                                122.92617,
                                -16.395
                            ],
                            [
                                122.90083,
                                -16.49103
                            ],
                            [
                                122.79633,
                                -16.56522
                            ],
                            [
                                122.74477,
                                -16.68168
                            ],
                            [
                                122.77786,
                                -16.7314
                            ],
                            [
                                122.7242,
                                -16.78046
                            ],
                            [
                                122.6407,
                                -16.79863
                            ],
                            [
                                122.57654,
                                -16.76874
                            ],
                            [
                                122.53753,
                                -16.84386
                            ],
                            [
                                122.59194,
                                -16.96044
                            ],
                            [
                                122.48305,
                                -16.9408
                            ],
                            [
                                122.41105,
                                -16.96961
                            ],
                            [
                                122.25955,
                                -17.11029
                            ],
                            [
                                122.20878,
                                -17.2382
                            ],
                            [
                                122.17615,
                                -17.26131
                            ],
                            [
                                122.15152,
                                -17.36198
                            ],
                            [
                                122.14777,
                                -17.56294
                            ],
                            [
                                122.19871,
                                -17.6881
                            ],
                            [
                                122.2115,
                                -17.85553
                            ],
                            [
                                122.20335,
                                -17.94558
                            ],
                            [
                                122.35942,
                                -17.98189
                            ],
                            [
                                122.37979,
                                -18.06605
                            ],
                            [
                                122.31721,
                                -18.16798
                            ],
                            [
                                122.21462,
                                -18.2074
                            ],
                            [
                                122.13762,
                                -18.3
                            ],
                            [
                                122.06343,
                                -18.33042
                            ],
                            [
                                122.0174,
                                -18.3889
                            ],
                            [
                                121.90517,
                                -18.46178
                            ],
                            [
                                121.8094,
                                -18.46133
                            ],
                            [
                                121.73453,
                                -18.57628
                            ],
                            [
                                121.78795,
                                -18.65202
                            ],
                            [
                                121.73696,
                                -18.70014
                            ],
                            [
                                121.67545,
                                -18.71637
                            ],
                            [
                                121.65135,
                                -18.81558
                            ],
                            [
                                121.52369,
                                -19.04184
                            ],
                            [
                                121.50351,
                                -19.10502
                            ],
                            [
                                121.33026,
                                -19.34376
                            ],
                            [
                                121.20679,
                                -19.46829
                            ],
                            [
                                121.12072,
                                -19.53312
                            ],
                            [
                                120.95696,
                                -19.63309
                            ],
                            [
                                120.63254,
                                -19.76863
                            ],
                            [
                                120.20239,
                                -19.91122
                            ],
                            [
                                119.97024,
                                -19.93439
                            ],
                            [
                                119.82205,
                                -19.96983
                            ],
                            [
                                119.74144,
                                -19.97357
                            ],
                            [
                                119.65785,
                                -20.04328
                            ],
                            [
                                119.58503,
                                -20.07214
                            ],
                            [
                                119.47894,
                                -20.01469
                            ],
                            [
                                119.31389,
                                -19.98604
                            ],
                            [
                                119.22037,
                                -19.9555
                            ],
                            [
                                119.10217,
                                -19.96312
                            ],
                            [
                                119.06654,
                                -20.01453
                            ],
                            [
                                118.99325,
                                -20.0423
                            ],
                            [
                                118.94167,
                                -20.14213
                            ],
                            [
                                118.84098,
                                -20.23727
                            ],
                            [
                                118.83358,
                                -20.27918
                            ],
                            [
                                118.75522,
                                -20.28728
                            ],
                            [
                                118.6748,
                                -20.33291
                            ],
                            [
                                118.63571,
                                -20.30171
                            ],
                            [
                                118.5202,
                                -20.31098
                            ],
                            [
                                118.48729,
                                -20.34393
                            ],
                            [
                                118.36384,
                                -20.36561
                            ],
                            [
                                118.33703,
                                -20.33579
                            ],
                            [
                                118.25001,
                                -20.37206
                            ],
                            [
                                118.17153,
                                -20.38217
                            ],
                            [
                                118.05493,
                                -20.42195
                            ],
                            [
                                117.94574,
                                -20.48315
                            ],
                            [
                                117.93214,
                                -20.54441
                            ],
                            [
                                117.88082,
                                -20.55505
                            ],
                            [
                                117.85725,
                                -20.60656
                            ],
                            [
                                117.76123,
                                -20.66964
                            ],
                            [
                                117.70216,
                                -20.68576
                            ],
                            [
                                117.6367,
                                -20.66987
                            ],
                            [
                                117.5823,
                                -20.69776
                            ],
                            [
                                117.36834,
                                -20.74017
                            ],
                            [
                                117.18628,
                                -20.68978
                            ],
                            [
                                117.09168,
                                -20.63207
                            ],
                            [
                                116.98535,
                                -20.66443
                            ],
                            [
                                116.9386,
                                -20.70494
                            ],
                            [
                                116.86971,
                                -20.72051
                            ],
                            [
                                116.75325,
                                -20.61542
                            ],
                            [
                                116.69143,
                                -20.67775
                            ],
                            [
                                116.58661,
                                -20.69285
                            ],
                            [
                                116.59016,
                                -20.74079
                            ],
                            [
                                116.53075,
                                -20.75428
                            ],
                            [
                                116.46092,
                                -20.8219
                            ],
                            [
                                116.35102,
                                -20.84153
                            ],
                            [
                                116.30458,
                                -20.87587
                            ],
                            [
                                116.20552,
                                -20.84009
                            ],
                            [
                                116.18664,
                                -20.96088
                            ],
                            [
                                116.14284,
                                -20.99258
                            ],
                            [
                                115.98581,
                                -21.04326
                            ],
                            [
                                115.88369,
                                -21.12025
                            ],
                            [
                                115.82106,
                                -21.24971
                            ],
                            [
                                115.70031,
                                -21.28354
                            ],
                            [
                                115.62325,
                                -21.34333
                            ],
                            [
                                115.49424,
                                -21.4903
                            ],
                            [
                                115.30645,
                                -21.59001
                            ],
                            [
                                115.24131,
                                -21.5835
                            ],
                            [
                                115.04493,
                                -21.68145
                            ],
                            [
                                114.91669,
                                -21.69197
                            ],
                            [
                                114.77622,
                                -21.79013
                            ],
                            [
                                114.65075,
                                -21.84699
                            ],
                            [
                                114.64819,
                                -21.91738
                            ],
                            [
                                114.61298,
                                -21.97787
                            ],
                            [
                                114.53307,
                                -22.05928
                            ],
                            [
                                114.48434,
                                -22.19989
                            ],
                            [
                                114.45401,
                                -22.21806
                            ],
                            [
                                114.42045,
                                -22.3084
                            ],
                            [
                                114.38777,
                                -22.46397
                            ],
                            [
                                114.32464,
                                -22.4853
                            ],
                            [
                                114.26567,
                                -22.44102
                            ],
                            [
                                114.21307,
                                -22.4999
                            ],
                            [
                                114.1573,
                                -22.51989
                            ],
                            [
                                114.12505,
                                -22.41923
                            ],
                            [
                                114.17713,
                                -22.34903
                            ],
                            [
                                114.12559,
                                -22.30367
                            ],
                            [
                                114.12828,
                                -22.2619
                            ],
                            [
                                114.08309,
                                -22.15346
                            ],
                            [
                                114.13591,
                                -21.964
                            ],
                            [
                                114.14894,
                                -21.87214
                            ],
                            [
                                114.18421,
                                -21.81194
                            ],
                            [
                                114.10224,
                                -21.80677
                            ],
                            [
                                114.00145,
                                -21.87219
                            ],
                            [
                                113.93722,
                                -21.97209
                            ],
                            [
                                113.8665,
                                -22.15542
                            ],
                            [
                                113.81659,
                                -22.31294
                            ],
                            [
                                113.75431,
                                -22.40364
                            ],
                            [
                                113.70952,
                                -22.52036
                            ],
                            [
                                113.66891,
                                -22.55177
                            ],
                            [
                                113.68123,
                                -22.71876
                            ],
                            [
                                113.76858,
                                -22.78186
                            ],
                            [
                                113.81606,
                                -22.91035
                            ],
                            [
                                113.82803,
                                -23.00297
                            ],
                            [
                                113.80469,
                                -23.09
                            ],
                            [
                                113.76706,
                                -23.12613
                            ],
                            [
                                113.79273,
                                -23.30072
                            ],
                            [
                                113.77746,
                                -23.46982
                            ],
                            [
                                113.75119,
                                -23.52762
                            ],
                            [
                                113.61775,
                                -23.63133
                            ],
                            [
                                113.56831,
                                -23.74691
                            ],
                            [
                                113.52919,
                                -23.78444
                            ],
                            [
                                113.4723,
                                -23.90125
                            ],
                            [
                                113.45925,
                                -24.00747
                            ],
                            [
                                113.42603,
                                -24.04515
                            ],
                            [
                                113.43214,
                                -24.19855
                            ],
                            [
                                113.39382,
                                -24.232
                            ],
                            [
                                113.40705,
                                -24.46905
                            ],
                            [
                                113.62058,
                                -24.74469
                            ],
                            [
                                113.62282,
                                -24.85893
                            ],
                            [
                                113.68013,
                                -24.9262
                            ],
                            [
                                113.6658,
                                -25.01187
                            ],
                            [
                                113.69622,
                                -25.08111
                            ],
                            [
                                113.79704,
                                -25.1566
                            ],
                            [
                                113.83875,
                                -25.22028
                            ],
                            [
                                113.91132,
                                -25.41649
                            ],
                            [
                                114.05159,
                                -25.67464
                            ],
                            [
                                114.20817,
                                -25.85102
                            ],
                            [
                                114.2591,
                                -25.88621
                            ],
                            [
                                114.25582,
                                -25.98446
                            ],
                            [
                                114.20025,
                                -26.00336
                            ],
                            [
                                114.23788,
                                -26.113
                            ],
                            [
                                114.19204,
                                -26.17765
                            ],
                            [
                                114.23531,
                                -26.28541
                            ],
                            [
                                114.21594,
                                -26.35968
                            ],
                            [
                                114.08509,
                                -26.46476
                            ],
                            [
                                113.97256,
                                -26.33611
                            ],
                            [
                                113.89696,
                                -26.03074
                            ],
                            [
                                113.79415,
                                -26.20073
                            ],
                            [
                                113.7246,
                                -26.17933
                            ],
                            [
                                113.70215,
                                -26.04967
                            ],
                            [
                                113.73112,
                                -26.01091
                            ],
                            [
                                113.75834,
                                -25.88328
                            ],
                            [
                                113.71803,
                                -25.79814
                            ],
                            [
                                113.60949,
                                -25.71596
                            ],
                            [
                                113.58167,
                                -25.62657
                            ],
                            [
                                113.53006,
                                -25.61292
                            ],
                            [
                                113.51729,
                                -25.52552
                            ],
                            [
                                113.43271,
                                -25.62857
                            ],
                            [
                                113.4177,
                                -25.7232
                            ],
                            [
                                113.50982,
                                -25.85148
                            ],
                            [
                                113.55533,
                                -25.94584
                            ],
                            [
                                113.58022,
                                -26.08898
                            ],
                            [
                                113.61475,
                                -26.10187
                            ],
                            [
                                113.69451,
                                -26.21724
                            ],
                            [
                                113.80159,
                                -26.25693
                            ],
                            [
                                113.87995,
                                -26.34163
                            ],
                            [
                                113.88697,
                                -26.47282
                            ],
                            [
                                113.80767,
                                -26.60457
                            ],
                            [
                                113.69694,
                                -26.61101
                            ],
                            [
                                113.63006,
                                -26.57531
                            ],
                            [
                                113.63595,
                                -26.50602
                            ],
                            [
                                113.57323,
                                -26.50378
                            ],
                            [
                                113.54078,
                                -26.29273
                            ],
                            [
                                113.50235,
                                -26.31142
                            ],
                            [
                                113.44456,
                                -26.17581
                            ],
                            [
                                113.38073,
                                -26.19219
                            ],
                            [
                                113.32163,
                                -26.25464
                            ],
                            [
                                113.31958,
                                -26.13382
                            ],
                            [
                                113.2388,
                                -26.23795
                            ],
                            [
                                113.29624,
                                -26.3384
                            ],
                            [
                                113.30455,
                                -26.4059
                            ],
                            [
                                113.54897,
                                -26.63317
                            ],
                            [
                                113.72102,
                                -26.8459
                            ],
                            [
                                113.81392,
                                -26.97669
                            ],
                            [
                                113.96446,
                                -27.23003
                            ],
                            [
                                114.08521,
                                -27.45932
                            ],
                            [
                                114.16156,
                                -27.70279
                            ],
                            [
                                114.10736,
                                -27.8518
                            ],
                            [
                                114.17493,
                                -28.10698
                            ],
                            [
                                114.23951,
                                -28.18567
                            ],
                            [
                                114.32191,
                                -28.23368
                            ],
                            [
                                114.43621,
                                -28.39572
                            ],
                            [
                                114.55503,
                                -28.5335
                            ],
                            [
                                114.60129,
                                -28.62448
                            ],
                            [
                                114.61886,
                                -28.72405
                            ],
                            [
                                114.60735,
                                -28.79346
                            ],
                            [
                                114.64186,
                                -28.88182
                            ],
                            [
                                114.81417,
                                -29.04826
                            ],
                            [
                                114.87088,
                                -29.11627
                            ],
                            [
                                114.92403,
                                -29.3036
                            ],
                            [
                                114.99679,
                                -29.49655
                            ],
                            [
                                114.95923,
                                -29.67458
                            ],
                            [
                                114.98186,
                                -29.90958
                            ],
                            [
                                114.95845,
                                -30.04498
                            ],
                            [
                                115.00435,
                                -30.15576
                            ],
                            [
                                114.9975,
                                -30.2222
                            ],
                            [
                                115.03932,
                                -30.26466
                            ],
                            [
                                115.0687,
                                -30.47462
                            ],
                            [
                                115.06089,
                                -30.50607
                            ],
                            [
                                115.18404,
                                -30.77738
                            ],
                            [
                                115.31299,
                                -30.97558
                            ],
                            [
                                115.44172,
                                -31.27579
                            ],
                            [
                                115.54115,
                                -31.41383
                            ],
                            [
                                115.63366,
                                -31.56489
                            ],
                            [
                                115.71977,
                                -31.7373
                            ],
                            [
                                115.75451,
                                -31.90149
                            ],
                            [
                                115.74582,
                                -32.05295
                            ],
                            [
                                115.77197,
                                -32.19513
                            ],
                            [
                                115.70595,
                                -32.30137
                            ],
                            [
                                115.745,
                                -32.47663
                            ],
                            [
                                115.6347,
                                -32.59631
                            ],
                            [
                                115.6088,
                                -32.69138
                            ],
                            [
                                115.67278,
                                -32.99579
                            ],
                            [
                                115.68747,
                                -33.1131
                            ],
                            [
                                115.67767,
                                -33.28258
                            ],
                            [
                                115.63259,
                                -33.32256
                            ],
                            [
                                115.5652,
                                -33.46246
                            ],
                            [
                                115.42989,
                                -33.60491
                            ],
                            [
                                115.27486,
                                -33.65554
                            ],
                            [
                                115.12772,
                                -33.62428
                            ],
                            [
                                115.08136,
                                -33.56538
                            ],
                            [
                                115.00858,
                                -33.53584
                            ],
                            [
                                115.0256,
                                -33.63427
                            ],
                            [
                                114.97857,
                                -33.70507
                            ],
                            [
                                114.99858,
                                -33.7973
                            ],
                            [
                                114.97969,
                                -33.87051
                            ],
                            [
                                114.99818,
                                -34.00953
                            ],
                            [
                                114.99486,
                                -34.10102
                            ],
                            [
                                115.03702,
                                -34.1932
                            ],
                            [
                                115.02985,
                                -34.25807
                            ],
                            [
                                115.15711,
                                -34.36631
                            ],
                            [
                                115.17418,
                                -34.31948
                            ],
                            [
                                115.26205,
                                -34.30744
                            ],
                            [
                                115.37175,
                                -34.32412
                            ],
                            [
                                115.58642,
                                -34.42775
                            ],
                            [
                                115.79376,
                                -34.58196
                            ],
                            [
                                115.95162,
                                -34.72658
                            ],
                            [
                                116.00381,
                                -34.83904
                            ],
                            [
                                116.14043,
                                -34.84594
                            ],
                            [
                                116.25162,
                                -34.87668
                            ],
                            [
                                116.36868,
                                -34.9342
                            ],
                            [
                                116.48582,
                                -35.01434
                            ],
                            [
                                116.51794,
                                -35.00398
                            ],
                            [
                                116.63236,
                                -35.05702
                            ],
                            [
                                116.76876,
                                -35.01598
                            ],
                            [
                                116.91884,
                                -35.06153
                            ],
                            [
                                116.9648,
                                -35.02086
                            ],
                            [
                                117.09359,
                                -35.0326
                            ],
                            [
                                117.14868,
                                -35.05751
                            ],
                            [
                                117.19394,
                                -35.01822
                            ],
                            [
                                117.32849,
                                -35.0411
                            ],
                            [
                                117.37157,
                                -34.97174
                            ],
                            [
                                117.47707,
                                -34.99146
                            ],
                            [
                                117.47332,
                                -35.07145
                            ],
                            [
                                117.55445,
                                -35.08556
                            ],
                            [
                                117.61562,
                                -35.13093
                            ],
                            [
                                117.67063,
                                -35.04798
                            ],
                            [
                                117.8559,
                                -35.05454
                            ],
                            [
                                117.96494,
                                -35.01246
                            ],
                            [
                                118.04852,
                                -35.0134
                            ],
                            [
                                118.17452,
                                -34.96624
                            ],
                            [
                                118.23428,
                                -34.91722
                            ],
                            [
                                118.38023,
                                -34.90465
                            ],
                            [
                                118.41021,
                                -34.8033
                            ],
                            [
                                118.49084,
                                -34.73031
                            ],
                            [
                                118.7257,
                                -34.65195
                            ],
                            [
                                118.74119,
                                -34.57815
                            ],
                            [
                                118.81482,
                                -34.5101
                            ],
                            [
                                118.90747,
                                -34.50126
                            ],
                            [
                                118.94458,
                                -34.45372
                            ],
                            [
                                119.11881,
                                -34.47173
                            ],
                            [
                                119.2769,
                                -34.52027
                            ],
                            [
                                119.27401,
                                -34.46751
                            ],
                            [
                                119.40257,
                                -34.44816
                            ],
                            [
                                119.44435,
                                -34.36804
                            ],
                            [
                                119.5152,
                                -34.40835
                            ],
                            [
                                119.49982,
                                -34.29216
                            ],
                            [
                                119.58571,
                                -34.14831
                            ],
                            [
                                119.64385,
                                -34.09293
                            ],
                            [
                                119.73403,
                                -34.05874
                            ],
                            [
                                119.81061,
                                -33.98782
                            ],
                            [
                                119.94533,
                                -33.975
                            ],
                            [
                                120.04193,
                                -33.92446
                            ],
                            [
                                120.12113,
                                -33.95094
                            ],
                            [
                                120.17699,
                                -33.93529
                            ],
                            [
                                120.31562,
                                -33.94254
                            ],
                            [
                                120.43477,
                                -33.97033
                            ],
                            [
                                120.55738,
                                -33.92389
                            ],
                            [
                                120.59103,
                                -33.88725
                            ],
                            [
                                120.80837,
                                -33.89064
                            ],
                            [
                                120.86869,
                                -33.85718
                            ],
                            [
                                121.00276,
                                -33.86974
                            ],
                            [
                                121.10249,
                                -33.84907
                            ],
                            [
                                121.17147,
                                -33.86776
                            ],
                            [
                                121.36605,
                                -33.81592
                            ],
                            [
                                121.53332,
                                -33.82769
                            ],
                            [
                                121.64758,
                                -33.89399
                            ],
                            [
                                121.70504,
                                -33.86424
                            ],
                            [
                                121.79032,
                                -33.9073
                            ],
                            [
                                121.89979,
                                -33.87426
                            ],
                            [
                                121.91618,
                                -33.83888
                            ],
                            [
                                122.00545,
                                -33.83169
                            ],
                            [
                                122.08539,
                                -33.90407
                            ],
                            [
                                122.11448,
                                -34.01442
                            ],
                            [
                                122.18819,
                                -34.01398
                            ],
                            [
                                122.36618,
                                -33.91411
                            ],
                            [
                                122.51349,
                                -33.95089
                            ],
                            [
                                122.60621,
                                -33.89772
                            ],
                            [
                                122.83065,
                                -33.90854
                            ],
                            [
                                123.08396,
                                -33.87219
                            ],
                            [
                                123.13714,
                                -33.90932
                            ],
                            [
                                123.17116,
                                -33.98958
                            ],
                            [
                                123.25343,
                                -33.99563
                            ],
                            [
                                123.3696,
                                -33.89651
                            ],
                            [
                                123.47197,
                                -33.90589
                            ],
                            [
                                123.54501,
                                -33.93511
                            ],
                            [
                                123.59079,
                                -33.88145
                            ],
                            [
                                123.75837,
                                -33.79827
                            ],
                            [
                                123.75773,
                                -33.72229
                            ],
                            [
                                123.98024,
                                -33.54775
                            ],
                            [
                                123.99913,
                                -33.42407
                            ],
                            [
                                124.11522,
                                -33.14953
                            ],
                            [
                                124.24714,
                                -33.01292
                            ],
                            [
                                124.35398,
                                -32.9605
                            ],
                            [
                                124.46115,
                                -32.93538
                            ],
                            [
                                124.74034,
                                -32.89982
                            ],
                            [
                                124.89325,
                                -32.83336
                            ],
                            [
                                125.02598,
                                -32.73014
                            ],
                            [
                                125.09982,
                                -32.7159
                            ],
                            [
                                125.31269,
                                -32.60908
                            ],
                            [
                                125.41796,
                                -32.58762
                            ],
                            [
                                125.56374,
                                -32.531
                            ],
                            [
                                125.80111,
                                -32.36724
                            ],
                            [
                                125.96215,
                                -32.28674
                            ],
                            [
                                126.07866,
                                -32.27515
                            ],
                            [
                                126.20496,
                                -32.23274
                            ],
                            [
                                126.42578,
                                -32.28442
                            ],
                            [
                                126.67024,
                                -32.30801
                            ],
                            [
                                126.77526,
                                -32.29284
                            ],
                            [
                                126.94131,
                                -32.2982
                            ],
                            [
                                127.2253,
                                -32.27472
                            ],
                            [
                                127.45443,
                                -32.22204
                            ],
                            [
                                127.70815,
                                -32.13646
                            ],
                            [
                                128.02228,
                                -32.07345
                            ],
                            [
                                128.31606,
                                -31.97805
                            ],
                            [
                                128.64268,
                                -31.85022
                            ],
                            [
                                128.80259,
                                -31.75893
                            ],
                            [
                                128.96144,
                                -31.69502
                            ],
                            [
                                129.05107,
                                -31.67489
                            ],
                            [
                                129.52938,
                                -31.62281
                            ],
                            [
                                129.8424,
                                -31.60741
                            ],
                            [
                                129.93352,
                                -31.58947
                            ],
                            [
                                130.26346,
                                -31.57385
                            ],
                            [
                                130.49063,
                                -31.59267
                            ],
                            [
                                130.56829,
                                -31.58642
                            ],
                            [
                                130.7034,
                                -31.60312
                            ],
                            [
                                130.84922,
                                -31.59644
                            ],
                            [
                                131.02377,
                                -31.53823
                            ],
                            [
                                131.12757,
                                -31.46664
                            ],
                            [
                                131.24593,
                                -31.49297
                            ],
                            [
                                131.4949,
                                -31.59413
                            ],
                            [
                                131.75681,
                                -31.71967
                            ],
                            [
                                132.11089,
                                -31.94728
                            ],
                            [
                                132.19794,
                                -32.02502
                            ],
                            [
                                132.33064,
                                -32.02765
                            ],
                            [
                                132.43898,
                                -31.99054
                            ],
                            [
                                132.47731,
                                -31.94767
                            ],
                            [
                                132.59667,
                                -31.93508
                            ],
                            [
                                132.74895,
                                -31.95067
                            ],
                            [
                                133.06195,
                                -32.10987
                            ],
                            [
                                133.13303,
                                -32.1682
                            ],
                            [
                                133.2227,
                                -32.18809
                            ],
                            [
                                133.34134,
                                -32.18151
                            ],
                            [
                                133.48418,
                                -32.10903
                            ],
                            [
                                133.54872,
                                -32.16765
                            ],
                            [
                                133.61075,
                                -32.08645
                            ],
                            [
                                133.66644,
                                -32.10597
                            ],
                            [
                                133.68157,
                                -32.19908
                            ],
                            [
                                133.75473,
                                -32.20609
                            ],
                            [
                                133.87118,
                                -32.28483
                            ],
                            [
                                133.95021,
                                -32.39028
                            ],
                            [
                                133.89535,
                                -32.42603
                            ],
                            [
                                133.84935,
                                -32.50239
                            ],
                            [
                                133.99016,
                                -32.50298
                            ],
                            [
                                134.03371,
                                -32.46268
                            ],
                            [
                                134.16221,
                                -32.46947
                            ],
                            [
                                134.2573,
                                -32.55998
                            ],
                            [
                                134.29253,
                                -32.66461
                            ],
                            [
                                134.2288,
                                -32.78104
                            ],
                            [
                                134.17447,
                                -32.71925
                            ],
                            [
                                134.10998,
                                -32.72063
                            ],
                            [
                                134.13753,
                                -32.83273
                            ],
                            [
                                134.07505,
                                -32.88384
                            ],
                            [
                                134.0856,
                                -32.92533
                            ],
                            [
                                134.15951,
                                -32.92564
                            ],
                            [
                                134.2609,
                                -33.10106
                            ],
                            [
                                134.26395,
                                -33.15403
                            ],
                            [
                                134.32588,
                                -33.19666
                            ],
                            [
                                134.45263,
                                -33.14685
                            ],
                            [
                                134.57852,
                                -33.18861
                            ],
                            [
                                134.59472,
                                -33.14072
                            ],
                            [
                                134.70397,
                                -33.17786
                            ],
                            [
                                134.73511,
                                -33.27387
                            ],
                            [
                                134.80157,
                                -33.33109
                            ],
                            [
                                134.84343,
                                -33.43197
                            ],
                            [
                                134.86237,
                                -33.54395
                            ],
                            [
                                134.8355,
                                -33.62634
                            ],
                            [
                                135.03084,
                                -33.74831
                            ],
                            [
                                135.18665,
                                -33.88735
                            ],
                            [
                                135.24942,
                                -33.97906
                            ],
                            [
                                135.27963,
                                -34.06897
                            ],
                            [
                                135.24436,
                                -34.14854
                            ],
                            [
                                135.3021,
                                -34.18454
                            ],
                            [
                                135.3497,
                                -34.28137
                            ],
                            [
                                135.36116,
                                -34.42038
                            ],
                            [
                                135.46184,
                                -34.59008
                            ],
                            [
                                135.37871,
                                -34.64307
                            ],
                            [
                                135.31559,
                                -34.51884
                            ],
                            [
                                135.21773,
                                -34.49521
                            ],
                            [
                                135.14106,
                                -34.50367
                            ],
                            [
                                135.12454,
                                -34.5748
                            ],
                            [
                                135.22634,
                                -34.54463
                            ],
                            [
                                135.34053,
                                -34.62884
                            ],
                            [
                                135.37889,
                                -34.68744
                            ],
                            [
                                135.47299,
                                -34.74351
                            ],
                            [
                                135.62189,
                                -34.90748
                            ],
                            [
                                135.68358,
                                -34.91357
                            ],
                            [
                                135.72936,
                                -34.86002
                            ],
                            [
                                135.84614,
                                -34.88211
                            ],
                            [
                                135.85602,
                                -34.92224
                            ],
                            [
                                135.99924,
                                -34.98112
                            ],
                            [
                                135.96473,
                                -34.87637
                            ],
                            [
                                136.00661,
                                -34.80238
                            ],
                            [
                                135.95027,
                                -34.76337
                            ],
                            [
                                135.88939,
                                -34.80484
                            ],
                            [
                                135.84438,
                                -34.75539
                            ],
                            [
                                135.85562,
                                -34.66178
                            ],
                            [
                                135.93435,
                                -34.52966
                            ],
                            [
                                136.03007,
                                -34.4844
                            ],
                            [
                                136.11077,
                                -34.51148
                            ],
                            [
                                136.13397,
                                -34.34385
                            ],
                            [
                                136.18962,
                                -34.33233
                            ],
                            [
                                136.32184,
                                -34.1797
                            ],
                            [
                                136.36259,
                                -34.07313
                            ],
                            [
                                136.4396,
                                -34.01034
                            ],
                            [
                                136.5707,
                                -33.94378
                            ],
                            [
                                136.59479,
                                -33.90044
                            ],
                            [
                                136.66715,
                                -33.87831
                            ],
                            [
                                136.80269,
                                -33.80417
                            ],
                            [
                                136.86426,
                                -33.79435
                            ],
                            [
                                136.99083,
                                -33.72707
                            ],
                            [
                                137.16152,
                                -33.6916
                            ],
                            [
                                137.21228,
                                -33.66008
                            ],
                            [
                                137.27911,
                                -33.56243
                            ],
                            [
                                137.31225,
                                -33.47616
                            ],
                            [
                                137.38358,
                                -33.37491
                            ],
                            [
                                137.38044,
                                -33.30445
                            ],
                            [
                                137.43608,
                                -33.22093
                            ],
                            [
                                137.45134,
                                -33.13811
                            ],
                            [
                                137.5339,
                                -33.09407
                            ],
                            [
                                137.65616,
                                -32.9527
                            ],
                            [
                                137.78322,
                                -32.99574
                            ],
                            [
                                137.80967,
                                -32.84496
                            ],
                            [
                                137.80826,
                                -32.74985
                            ],
                            [
                                137.75157,
                                -32.67126
                            ],
                            [
                                137.76445,
                                -32.59853
                            ],
                            [
                                137.86585,
                                -32.66511
                            ],
                            [
                                137.84248,
                                -32.69735
                            ],
                            [
                                137.904,
                                -32.77747
                            ],
                            [
                                137.95494,
                                -33.00629
                            ],
                            [
                                138.01723,
                                -33.03581
                            ],
                            [
                                138.05272,
                                -33.11837
                            ],
                            [
                                137.83684,
                                -33.21182
                            ],
                            [
                                137.81246,
                                -33.26683
                            ],
                            [
                                137.88525,
                                -33.35196
                            ],
                            [
                                137.8738,
                                -33.39987
                            ],
                            [
                                137.94377,
                                -33.51145
                            ],
                            [
                                137.917,
                                -33.58936
                            ],
                            [
                                137.77518,
                                -33.69703
                            ],
                            [
                                137.72106,
                                -33.77268
                            ],
                            [
                                137.6064,
                                -33.87336
                            ],
                            [
                                137.62931,
                                -33.9184
                            ],
                            [
                                137.53762,
                                -34.00646
                            ],
                            [
                                137.56536,
                                -34.0433
                            ],
                            [
                                137.52156,
                                -34.12699
                            ],
                            [
                                137.45289,
                                -34.13845
                            ],
                            [
                                137.49845,
                                -34.22522
                            ],
                            [
                                137.47606,
                                -34.38912
                            ],
                            [
                                137.47624,
                                -34.51459
                            ],
                            [
                                137.50892,
                                -34.62099
                            ],
                            [
                                137.46004,
                                -34.80886
                            ],
                            [
                                137.45755,
                                -34.88154
                            ],
                            [
                                137.37595,
                                -34.95252
                            ],
                            [
                                137.27554,
                                -34.89495
                            ],
                            [
                                137.08313,
                                -34.919
                            ],
                            [
                                137.0104,
                                -34.89865
                            ],
                            [
                                136.96269,
                                -35.00613
                            ],
                            [
                                136.96061,
                                -35.08327
                            ],
                            [
                                136.82432,
                                -35.24609
                            ],
                            [
                                136.8819,
                                -35.29875
                            ],
                            [
                                136.93988,
                                -35.28189
                            ],
                            [
                                137.00628,
                                -35.22329
                            ],
                            [
                                137.137,
                                -35.24222
                            ],
                            [
                                137.21866,
                                -35.17733
                            ],
                            [
                                137.34175,
                                -35.16466
                            ],
                            [
                                137.42549,
                                -35.0992
                            ],
                            [
                                137.55025,
                                -35.11745
                            ],
                            [
                                137.64623,
                                -35.16662
                            ],
                            [
                                137.75368,
                                -35.11641
                            ],
                            [
                                137.73036,
                                -35.0509
                            ],
                            [
                                137.80652,
                                -34.86599
                            ],
                            [
                                137.86091,
                                -34.77912
                            ],
                            [
                                137.88789,
                                -34.51158
                            ],
                            [
                                137.91943,
                                -34.42836
                            ],
                            [
                                138.00778,
                                -34.34456
                            ],
                            [
                                138.00442,
                                -34.26193
                            ],
                            [
                                138.04014,
                                -34.18278
                            ],
                            [
                                138.1035,
                                -34.14278
                            ],
                            [
                                138.16234,
                                -34.21766
                            ],
                            [
                                138.16024,
                                -34.27058
                            ],
                            [
                                138.22155,
                                -34.31168
                            ],
                            [
                                138.26692,
                                -34.47481
                            ],
                            [
                                138.40395,
                                -34.60086
                            ],
                            [
                                138.43851,
                                -34.67258
                            ],
                            [
                                138.54196,
                                -34.7592
                            ],
                            [
                                138.48362,
                                -34.78436
                            ],
                            [
                                138.47813,
                                -34.85973
                            ],
                            [
                                138.51499,
                                -35.02793
                            ],
                            [
                                138.46978,
                                -35.12121
                            ],
                            [
                                138.46869,
                                -35.23213
                            ],
                            [
                                138.4413,
                                -35.34144
                            ],
                            [
                                138.34186,
                                -35.39463
                            ],
                            [
                                138.29698,
                                -35.46222
                            ],
                            [
                                138.16066,
                                -35.52594
                            ],
                            [
                                138.10031,
                                -35.62514
                            ],
                            [
                                138.19084,
                                -35.66346
                            ],
                            [
                                138.28317,
                                -35.64007
                            ],
                            [
                                138.52116,
                                -35.63919
                            ],
                            [
                                138.6339,
                                -35.5457
                            ],
                            [
                                138.70939,
                                -35.51673
                            ],
                            [
                                138.88839,
                                -35.56093
                            ],
                            [
                                139.09795,
                                -35.67719
                            ],
                            [
                                139.22128,
                                -35.76209
                            ],
                            [
                                139.38501,
                                -35.9004
                            ],
                            [
                                139.56223,
                                -36.09246
                            ],
                            [
                                139.65344,
                                -36.21966
                            ],
                            [
                                139.7863,
                                -36.46701
                            ],
                            [
                                139.84976,
                                -36.64402
                            ],
                            [
                                139.85119,
                                -36.81772
                            ],
                            [
                                139.78882,
                                -36.89222
                            ],
                            [
                                139.67424,
                                -36.95403
                            ],
                            [
                                139.79044,
                                -37.11347
                            ],
                            [
                                139.74375,
                                -37.18149
                            ],
                            [
                                139.84185,
                                -37.31873
                            ],
                            [
                                139.95215,
                                -37.44001
                            ],
                            [
                                140.1197,
                                -37.53125
                            ],
                            [
                                140.11391,
                                -37.57548
                            ],
                            [
                                140.17784,
                                -37.61749
                            ],
                            [
                                140.28024,
                                -37.7282
                            ],
                            [
                                140.39591,
                                -37.91558
                            ],
                            [
                                140.66258,
                                -38.05939
                            ],
                            [
                                140.83535,
                                -38.0417
                            ],
                            [
                                140.98347,
                                -38.059
                            ],
                            [
                                141.13155,
                                -38.11799
                            ],
                            [
                                141.26042,
                                -38.1937
                            ],
                            [
                                141.35765,
                                -38.27548
                            ],
                            [
                                141.39537,
                                -38.3341
                            ],
                            [
                                141.51634,
                                -38.38916
                            ],
                            [
                                141.646,
                                -38.39042
                            ],
                            [
                                141.60757,
                                -38.3093
                            ],
                            [
                                141.7396,
                                -38.25396
                            ],
                            [
                                141.87512,
                                -38.26524
                            ],
                            [
                                141.99212,
                                -38.30507
                            ],
                            [
                                142.15048,
                                -38.3898
                            ],
                            [
                                142.37613,
                                -38.35178
                            ],
                            [
                                142.46647,
                                -38.39957
                            ],
                            [
                                142.56136,
                                -38.42162
                            ],
                            [
                                142.77914,
                                -38.56306
                            ],
                            [
                                142.93479,
                                -38.62513
                            ],
                            [
                                143.01733,
                                -38.62553
                            ],
                            [
                                143.12228,
                                -38.67693
                            ],
                            [
                                143.2154,
                                -38.75753
                            ],
                            [
                                143.35515,
                                -38.75487
                            ],
                            [
                                143.43229,
                                -38.7866
                            ],
                            [
                                143.51235,
                                -38.85642
                            ],
                            [
                                143.55549,
                                -38.85327
                            ],
                            [
                                143.68283,
                                -38.73783
                            ],
                            [
                                143.83682,
                                -38.69117
                            ],
                            [
                                144.03773,
                                -38.47638
                            ],
                            [
                                144.25056,
                                -38.39525
                            ],
                            [
                                144.33293,
                                -38.32465
                            ],
                            [
                                144.42976,
                                -38.28257
                            ],
                            [
                                144.52892,
                                -38.27188
                            ],
                            [
                                144.61106,
                                -38.29027
                            ],
                            [
                                144.71804,
                                -38.14746
                            ],
                            [
                                144.63128,
                                -38.10894
                            ],
                            [
                                144.55652,
                                -38.15466
                            ],
                            [
                                144.47427,
                                -38.16321
                            ],
                            [
                                144.36371,
                                -38.14285
                            ],
                            [
                                144.39579,
                                -38.07607
                            ],
                            [
                                144.50634,
                                -38.08712
                            ],
                            [
                                144.5184,
                                -38.0466
                            ],
                            [
                                144.65348,
                                -37.99906
                            ],
                            [
                                144.79349,
                                -37.92463
                            ],
                            [
                                144.81693,
                                -37.87485
                            ],
                            [
                                144.9246,
                                -37.84125
                            ],
                            [
                                144.97057,
                                -37.86404
                            ],
                            [
                                145.01799,
                                -37.98035
                            ],
                            [
                                145.07745,
                                -38.00284
                            ],
                            [
                                145.12206,
                                -38.08405
                            ],
                            [
                                145.11754,
                                -38.141
                            ],
                            [
                                145.03275,
                                -38.2184
                            ],
                            [
                                144.9707,
                                -38.32866
                            ],
                            [
                                144.8567,
                                -38.36723
                            ],
                            [
                                144.83976,
                                -38.43161
                            ],
                            [
                                144.88779,
                                -38.49515
                            ],
                            [
                                145.02674,
                                -38.48253
                            ],
                            [
                                145.04903,
                                -38.43416
                            ],
                            [
                                145.14239,
                                -38.39188
                            ],
                            [
                                145.27177,
                                -38.22859
                            ],
                            [
                                145.34756,
                                -38.2171
                            ],
                            [
                                145.48745,
                                -38.23776
                            ],
                            [
                                145.54986,
                                -38.3607
                            ],
                            [
                                145.51558,
                                -38.41256
                            ],
                            [
                                145.42416,
                                -38.41071
                            ],
                            [
                                145.42508,
                                -38.53839
                            ],
                            [
                                145.48236,
                                -38.5573
                            ],
                            [
                                145.56386,
                                -38.65069
                            ],
                            [
                                145.65766,
                                -38.67423
                            ],
                            [
                                145.72839,
                                -38.64802
                            ],
                            [
                                145.79056,
                                -38.68643
                            ],
                            [
                                145.86611,
                                -38.77268
                            ],
                            [
                                145.92219,
                                -38.90502
                            ],
                            [
                                146.00363,
                                -38.87363
                            ],
                            [
                                146.04888,
                                -38.81217
                            ],
                            [
                                146.18549,
                                -38.87149
                            ],
                            [
                                146.33905,
                                -39.06019
                            ],
                            [
                                146.371,
                                -39.13199
                            ],
                            [
                                146.42053,
                                -39.12623
                            ],
                            [
                                146.43904,
                                -38.97678
                            ],
                            [
                                146.48633,
                                -38.90759
                            ],
                            [
                                146.41339,
                                -38.84855
                            ],
                            [
                                146.29736,
                                -38.90316
                            ],
                            [
                                146.18981,
                                -38.74259
                            ],
                            [
                                146.2267,
                                -38.6956
                            ],
                            [
                                146.34307,
                                -38.67629
                            ],
                            [
                                146.40776,
                                -38.71867
                            ],
                            [
                                146.49837,
                                -38.68694
                            ],
                            [
                                146.66566,
                                -38.655
                            ],
                            [
                                146.69015,
                                -38.67321
                            ],
                            [
                                146.81828,
                                -38.64848
                            ],
                            [
                                146.93222,
                                -38.59551
                            ],
                            [
                                147.06946,
                                -38.4735
                            ],
                            [
                                147.45995,
                                -38.16457
                            ],
                            [
                                147.64246,
                                -38.0368
                            ],
                            [
                                147.80798,
                                -37.94692
                            ],
                            [
                                147.9508,
                                -37.8946
                            ],
                            [
                                148.17755,
                                -37.83215
                            ],
                            [
                                148.347,
                                -37.80547
                            ],
                            [
                                148.71588,
                                -37.80522
                            ],
                            [
                                148.80604,
                                -37.787
                            ],
                            [
                                149.12121,
                                -37.77746
                            ],
                            [
                                149.48736,
                                -37.77256
                            ],
                            [
                                149.5,
                                -37.75336
                            ],
                            [
                                149.67348,
                                -37.68343
                            ],
                            [
                                149.73395,
                                -37.59248
                            ],
                            [
                                149.81652,
                                -37.54586
                            ],
                            [
                                149.90385,
                                -37.54104
                            ],
                            [
                                149.97311,
                                -37.50482
                            ],
                            [
                                149.9463,
                                -37.27762
                            ],
                            [
                                150.01981,
                                -37.21601
                            ],
                            [
                                150.00222,
                                -37.14452
                            ],
                            [
                                149.88301,
                                -37.07738
                            ],
                            [
                                149.94212,
                                -37.04817
                            ],
                            [
                                149.92814,
                                -36.99273
                            ],
                            [
                                149.94099,
                                -36.81439
                            ],
                            [
                                149.9834,
                                -36.70634
                            ],
                            [
                                150.06419,
                                -36.55699
                            ],
                            [
                                150.07059,
                                -36.39304
                            ],
                            [
                                150.14634,
                                -36.26497
                            ],
                            [
                                150.12497,
                                -36.14547
                            ],
                            [
                                150.16039,
                                -36.00007
                            ],
                            [
                                150.15163,
                                -35.89099
                            ],
                            [
                                150.27152,
                                -35.72034
                            ],
                            [
                                150.30098,
                                -35.64814
                            ],
                            [
                                150.40356,
                                -35.53046
                            ],
                            [
                                150.39566,
                                -35.46255
                            ],
                            [
                                150.4798,
                                -35.35655
                            ],
                            [
                                150.47735,
                                -35.29533
                            ],
                            [
                                150.54473,
                                -35.21348
                            ],
                            [
                                150.63006,
                                -35.16782
                            ],
                            [
                                150.69601,
                                -35.19634
                            ],
                            [
                                150.76381,
                                -35.1408
                            ],
                            [
                                150.69974,
                                -35.1181
                            ],
                            [
                                150.67364,
                                -35.03539
                            ],
                            [
                                150.77463,
                                -35.00383
                            ],
                            [
                                150.77643,
                                -35.07541
                            ],
                            [
                                150.82942,
                                -35.07555
                            ],
                            [
                                150.84565,
                                -35.01029
                            ],
                            [
                                150.78624,
                                -34.98735
                            ],
                            [
                                150.75162,
                                -34.88717
                            ],
                            [
                                150.76455,
                                -34.81536
                            ],
                            [
                                150.8232,
                                -34.77519
                            ],
                            [
                                150.85582,
                                -34.69462
                            ],
                            [
                                150.86952,
                                -34.54828
                            ],
                            [
                                150.84232,
                                -34.48732
                            ],
                            [
                                150.89484,
                                -34.45805
                            ],
                            [
                                150.9321,
                                -34.3139
                            ],
                            [
                                150.98598,
                                -34.23737
                            ],
                            [
                                151.15332,
                                -34.10945
                            ],
                            [
                                151.17732,
                                -34.02234
                            ],
                            [
                                151.24818,
                                -33.9922
                            ],
                            [
                                151.28465,
                                -33.88267
                            ],
                            [
                                151.24668,
                                -33.84507
                            ],
                            [
                                151.29124,
                                -33.79052
                            ],
                            [
                                151.33793,
                                -33.62827
                            ],
                            [
                                151.2501,
                                -33.59848
                            ],
                            [
                                151.30352,
                                -33.55274
                            ],
                            [
                                151.40763,
                                -33.52449
                            ],
                            [
                                151.48115,
                                -33.39867
                            ],
                            [
                                151.44799,
                                -33.3054
                            ],
                            [
                                151.56888,
                                -33.24463
                            ],
                            [
                                151.62167,
                                -33.19532
                            ],
                            [
                                151.65671,
                                -33.09594
                            ],
                            [
                                151.5786,
                                -33.07297
                            ],
                            [
                                151.7252,
                                -33.00916
                            ],
                            [
                                151.76807,
                                -32.90127
                            ],
                            [
                                151.88735,
                                -32.83824
                            ],
                            [
                                152.16579,
                                -32.7582
                            ],
                            [
                                152.17999,
                                -32.71639
                            ],
                            [
                                151.99523,
                                -32.72369
                            ],
                            [
                                151.98574,
                                -32.66228
                            ],
                            [
                                152.17374,
                                -32.68145
                            ],
                            [
                                152.28327,
                                -32.5923
                            ],
                            [
                                152.33665,
                                -32.52724
                            ],
                            [
                                152.5342,
                                -32.44119
                            ],
                            [
                                152.54623,
                                -32.33432
                            ],
                            [
                                152.52549,
                                -32.29185
                            ],
                            [
                                152.56629,
                                -32.218
                            ],
                            [
                                152.51329,
                                -32.17316
                            ],
                            [
                                152.54917,
                                -32.02963
                            ],
                            [
                                152.6106,
                                -31.94638
                            ],
                            [
                                152.74729,
                                -31.84487
                            ],
                            [
                                152.73735,
                                -31.81135
                            ],
                            [
                                152.79984,
                                -31.73123
                            ],
                            [
                                152.83945,
                                -31.64357
                            ],
                            [
                                152.84721,
                                -31.57176
                            ],
                            [
                                152.93433,
                                -31.47315
                            ],
                            [
                                152.91632,
                                -31.41079
                            ],
                            [
                                152.97033,
                                -31.31697
                            ],
                            [
                                152.96238,
                                -31.2376
                            ],
                            [
                                152.99975,
                                -31.13358
                            ],
                            [
                                153.06046,
                                -31.05257
                            ],
                            [
                                153.03971,
                                -31.00686
                            ],
                            [
                                153.08608,
                                -30.91636
                            ],
                            [
                                153.01318,
                                -30.85636
                            ],
                            [
                                152.99764,
                                -30.68266
                            ],
                            [
                                153.03479,
                                -30.49434
                            ],
                            [
                                153.11366,
                                -30.34338
                            ],
                            [
                                153.14284,
                                -30.25356
                            ],
                            [
                                153.20082,
                                -30.15454
                            ],
                            [
                                153.19946,
                                -30.04086
                            ],
                            [
                                153.25617,
                                -29.95157
                            ],
                            [
                                153.29094,
                                -29.82088
                            ],
                            [
                                153.29645,
                                -29.74034
                            ],
                            [
                                153.32748,
                                -29.68153
                            ],
                            [
                                153.36003,
                                -29.51681
                            ],
                            [
                                153.3721,
                                -29.37686
                            ],
                            [
                                153.34616,
                                -29.29559
                            ],
                            [
                                153.44931,
                                -29.14328
                            ],
                            [
                                153.43554,
                                -29.09586
                            ],
                            [
                                153.46216,
                                -29.024
                            ],
                            [
                                153.60077,
                                -28.8494
                            ],
                            [
                                153.59733,
                                -28.77717
                            ],
                            [
                                153.63262,
                                -28.64377
                            ],
                            [
                                153.58751,
                                -28.61779
                            ],
                            [
                                153.55502,
                                -28.53275
                            ],
                            [
                                153.58241,
                                -28.26958
                            ],
                            [
                                153.56127,
                                -28.21026
                            ],
                            [
                                153.45076,
                                -28.08012
                            ],
                            [
                                153.3945,
                                -27.82838
                            ],
                            [
                                153.45256,
                                -27.71854
                            ],
                            [
                                153.48122,
                                -27.58155
                            ],
                            [
                                153.53297,
                                -27.4255
                            ],
                            [
                                153.44171,
                                -27.3993
                            ],
                            [
                                153.41109,
                                -27.5191
                            ],
                            [
                                153.41567,
                                -27.64467
                            ],
                            [
                                153.31833,
                                -27.67467
                            ],
                            [
                                153.28307,
                                -27.52097
                            ],
                            [
                                153.19639,
                                -27.47069
                            ],
                            [
                                153.14712,
                                -27.36283
                            ],
                            [
                                153.07325,
                                -27.3149
                            ],
                            [
                                153.11187,
                                -27.19822
                            ],
                            [
                                153.03312,
                                -27.17746
                            ],
                            [
                                153.07551,
                                -27.10664
                            ],
                            [
                                153.1293,
                                -27.08431
                            ],
                            [
                                153.06433,
                                -26.99714
                            ],
                            [
                                153.04918,
                                -26.94529
                            ],
                            [
                                153.06404,
                                -26.90925
                            ],
                            [
                                153.10359,
                                -26.8872
                            ],
                            [
                                153.14562,
                                -26.79531
                            ],
                            [
                                153.13554,
                                -26.68898
                            ],
                            [
                                153.10021,
                                -26.6342
                            ],
                            [
                                153.09491,
                                -26.51633
                            ],
                            [
                                153.11547,
                                -26.38864
                            ],
                            [
                                153.079,
                                -26.37449
                            ],
                            [
                                153.06709,
                                -26.27327
                            ],
                            [
                                153.11964,
                                -26.08802
                            ],
                            [
                                153.18554,
                                -25.93552
                            ],
                            [
                                153.11343,
                                -25.92638
                            ],
                            [
                                152.91476,
                                -25.73107
                            ],
                            [
                                152.87876,
                                -25.60649
                            ],
                            [
                                152.91999,
                                -25.44979
                            ],
                            [
                                152.9062,
                                -25.28981
                            ],
                            [
                                152.82412,
                                -25.25164
                            ],
                            [
                                152.73425,
                                -25.26616
                            ],
                            [
                                152.66379,
                                -25.24029
                            ],
                            [
                                152.61295,
                                -25.18697
                            ],
                            [
                                152.48826,
                                -24.96655
                            ],
                            [
                                152.49054,
                                -24.90215
                            ],
                            [
                                152.46311,
                                -24.81436
                            ],
                            [
                                152.37989,
                                -24.73732
                            ],
                            [
                                152.29311,
                                -24.72035
                            ],
                            [
                                152.14981,
                                -24.62622
                            ],
                            [
                                152.03497,
                                -24.48681
                            ],
                            [
                                152.00495,
                                -24.42979
                            ],
                            [
                                151.93992,
                                -24.24017
                            ],
                            [
                                151.88876,
                                -24.16414
                            ],
                            [
                                151.83467,
                                -24.17153
                            ],
                            [
                                151.78662,
                                -24.12477
                            ],
                            [
                                151.76166,
                                -24.01998
                            ],
                            [
                                151.6566,
                                -23.98412
                            ],
                            [
                                151.57112,
                                -24.04224
                            ],
                            [
                                151.50859,
                                -24.04424
                            ],
                            [
                                151.3519,
                                -23.92853
                            ],
                            [
                                151.31462,
                                -23.8712
                            ],
                            [
                                151.22604,
                                -23.82111
                            ],
                            [
                                151.30469,
                                -23.75478
                            ],
                            [
                                151.28356,
                                -23.68401
                            ],
                            [
                                151.22837,
                                -23.60867
                            ],
                            [
                                151.2345,
                                -23.52709
                            ],
                            [
                                151.02301,
                                -23.45685
                            ],
                            [
                                150.92724,
                                -23.55027
                            ],
                            [
                                150.87864,
                                -23.5773
                            ],
                            [
                                150.80563,
                                -23.50252
                            ],
                            [
                                150.86574,
                                -23.48322
                            ],
                            [
                                150.82038,
                                -23.42166
                            ],
                            [
                                150.77471,
                                -23.31703
                            ],
                            [
                                150.81944,
                                -23.23047
                            ],
                            [
                                150.75197,
                                -23.12479
                            ],
                            [
                                150.79316,
                                -22.93576
                            ],
                            [
                                150.78981,
                                -22.87077
                            ],
                            [
                                150.82746,
                                -22.69169
                            ],
                            [
                                150.78025,
                                -22.63526
                            ],
                            [
                                150.78527,
                                -22.55485
                            ],
                            [
                                150.6853,
                                -22.55574
                            ],
                            [
                                150.74765,
                                -22.44984
                            ],
                            [
                                150.6238,
                                -22.38998
                            ],
                            [
                                150.63819,
                                -22.34307
                            ],
                            [
                                150.5695,
                                -22.32225
                            ],
                            [
                                150.54179,
                                -22.35407
                            ],
                            [
                                150.53997,
                                -22.45283
                            ],
                            [
                                150.5824,
                                -22.57361
                            ],
                            [
                                150.45104,
                                -22.52244
                            ],
                            [
                                150.29395,
                                -22.40532
                            ],
                            [
                                150.22358,
                                -22.39045
                            ],
                            [
                                150.147,
                                -22.2603
                            ],
                            [
                                150.10176,
                                -22.21972
                            ],
                            [
                                150.05683,
                                -22.13654
                            ],
                            [
                                149.96269,
                                -22.1773
                            ],
                            [
                                149.91785,
                                -22.27871
                            ],
                            [
                                149.91488,
                                -22.34808
                            ],
                            [
                                150.00133,
                                -22.53046
                            ],
                            [
                                149.96282,
                                -22.54126
                            ],
                            [
                                149.88705,
                                -22.48952
                            ],
                            [
                                149.84897,
                                -22.4173
                            ],
                            [
                                149.73118,
                                -22.35064
                            ],
                            [
                                149.66148,
                                -22.35296
                            ],
                            [
                                149.60075,
                                -22.28126
                            ],
                            [
                                149.51943,
                                -22.08015
                            ],
                            [
                                149.52026,
                                -22.02511
                            ],
                            [
                                149.46675,
                                -21.92432
                            ],
                            [
                                149.46865,
                                -21.84241
                            ],
                            [
                                149.43344,
                                -21.79469
                            ],
                            [
                                149.45709,
                                -21.7323
                            ],
                            [
                                149.4401,
                                -21.63937
                            ],
                            [
                                149.48448,
                                -21.56702
                            ],
                            [
                                149.38144,
                                -21.53529
                            ],
                            [
                                149.34076,
                                -21.48041
                            ],
                            [
                                149.29418,
                                -21.27808
                            ],
                            [
                                149.19099,
                                -21.21879
                            ],
                            [
                                149.2225,
                                -21.13485
                            ],
                            [
                                149.205,
                                -21.06766
                            ],
                            [
                                149.15105,
                                -21.00272
                            ],
                            [
                                149.08659,
                                -20.97817
                            ],
                            [
                                149.02023,
                                -20.98754
                            ],
                            [
                                149.00863,
                                -20.90922
                            ],
                            [
                                148.95114,
                                -20.88069
                            ],
                            [
                                148.84723,
                                -20.86987
                            ],
                            [
                                148.83198,
                                -20.79036
                            ],
                            [
                                148.73413,
                                -20.71396
                            ],
                            [
                                148.66671,
                                -20.58541
                            ],
                            [
                                148.73215,
                                -20.47625
                            ],
                            [
                                148.84065,
                                -20.42756
                            ],
                            [
                                148.83684,
                                -20.35357
                            ],
                            [
                                148.68031,
                                -20.23978
                            ],
                            [
                                148.5297,
                                -20.08946
                            ],
                            [
                                148.43129,
                                -20.16379
                            ],
                            [
                                148.35201,
                                -20.1563
                            ],
                            [
                                148.24018,
                                -20.05382
                            ],
                            [
                                148.23948,
                                -19.98177
                            ],
                            [
                                148.19545,
                                -19.94917
                            ],
                            [
                                148.11541,
                                -19.94141
                            ],
                            [
                                148.07529,
                                -19.88597
                            ],
                            [
                                147.99134,
                                -19.92403
                            ],
                            [
                                147.91809,
                                -19.90536
                            ],
                            [
                                147.86572,
                                -19.84909
                            ],
                            [
                                147.84914,
                                -19.73867
                            ],
                            [
                                147.75901,
                                -19.7125
                            ],
                            [
                                147.77748,
                                -19.80819
                            ],
                            [
                                147.73183,
                                -19.84234
                            ],
                            [
                                147.67363,
                                -19.82539
                            ],
                            [
                                147.61376,
                                -19.77154
                            ],
                            [
                                147.61243,
                                -19.68195
                            ],
                            [
                                147.55735,
                                -19.54861
                            ],
                            [
                                147.43365,
                                -19.42072
                            ],
                            [
                                147.30867,
                                -19.41023
                            ],
                            [
                                147.24942,
                                -19.42914
                            ],
                            [
                                147.12807,
                                -19.41702
                            ],
                            [
                                147.04525,
                                -19.30059
                            ],
                            [
                                147.0184,
                                -19.21548
                            ],
                            [
                                146.9612,
                                -19.29691
                            ],
                            [
                                146.87126,
                                -19.29513
                            ],
                            [
                                146.79008,
                                -19.23583
                            ],
                            [
                                146.76715,
                                -19.18864
                            ],
                            [
                                146.66934,
                                -19.18592
                            ],
                            [
                                146.5656,
                                -19.14071
                            ],
                            [
                                146.45497,
                                -19.07067
                            ],
                            [
                                146.33519,
                                -18.95032
                            ],
                            [
                                146.27754,
                                -18.86354
                            ],
                            [
                                146.27509,
                                -18.81455
                            ],
                            [
                                146.33818,
                                -18.60241
                            ],
                            [
                                146.33762,
                                -18.53464
                            ],
                            [
                                146.22213,
                                -18.49112
                            ],
                            [
                                146.14305,
                                -18.3709
                            ],
                            [
                                146.10245,
                                -18.34683
                            ],
                            [
                                146.01756,
                                -18.2431
                            ],
                            [
                                146.00898,
                                -18.1233
                            ],
                            [
                                146.04362,
                                -18.04239
                            ],
                            [
                                146.09702,
                                -17.97137
                            ],
                            [
                                146.11312,
                                -17.85925
                            ],
                            [
                                146.09436,
                                -17.79597
                            ],
                            [
                                146.11243,
                                -17.69856
                            ],
                            [
                                146.14457,
                                -17.64486
                            ],
                            [
                                146.06992,
                                -17.51876
                            ],
                            [
                                146.06989,
                                -17.397
                            ],
                            [
                                146.01562,
                                -17.3358
                            ],
                            [
                                145.97238,
                                -17.23727
                            ],
                            [
                                145.94878,
                                -17.13661
                            ],
                            [
                                145.89195,
                                -17.05538
                            ],
                            [
                                145.90142,
                                -16.98559
                            ],
                            [
                                145.95141,
                                -16.89384
                            ],
                            [
                                145.78232,
                                -16.92643
                            ],
                            [
                                145.77152,
                                -16.87175
                            ],
                            [
                                145.66349,
                                -16.73533
                            ],
                            [
                                145.58209,
                                -16.68304
                            ],
                            [
                                145.40775,
                                -16.43277
                            ],
                            [
                                145.41918,
                                -16.33952
                            ],
                            [
                                145.48205,
                                -16.27266
                            ],
                            [
                                145.44716,
                                -16.15223
                            ],
                            [
                                145.47289,
                                -16.07749
                            ],
                            [
                                145.41368,
                                -15.95275
                            ],
                            [
                                145.35961,
                                -15.91177
                            ],
                            [
                                145.3586,
                                -15.7162
                            ],
                            [
                                145.31566,
                                -15.64531
                            ],
                            [
                                145.32581,
                                -15.59672
                            ],
                            [
                                145.27534,
                                -15.5417
                            ],
                            [
                                145.2379,
                                -15.45791
                            ],
                            [
                                145.28601,
                                -15.37054
                            ],
                            [
                                145.28114,
                                -15.2579
                            ],
                            [
                                145.24153,
                                -15.20167
                            ],
                            [
                                145.23757,
                                -15.13681
                            ],
                            [
                                145.28882,
                                -15.04492
                            ],
                            [
                                145.34908,
                                -14.98305
                            ],
                            [
                                145.28471,
                                -14.95552
                            ],
                            [
                                145.18105,
                                -14.84138
                            ],
                            [
                                145.02598,
                                -14.79223
                            ],
                            [
                                144.95521,
                                -14.73429
                            ],
                            [
                                144.94818,
                                -14.6762
                            ],
                            [
                                144.90654,
                                -14.6149
                            ],
                            [
                                144.78867,
                                -14.59457
                            ],
                            [
                                144.77012,
                                -14.54975
                            ],
                            [
                                144.70648,
                                -14.55699
                            ],
                            [
                                144.62122,
                                -14.47354
                            ],
                            [
                                144.64785,
                                -14.37066
                            ],
                            [
                                144.5893,
                                -14.35903
                            ],
                            [
                                144.59232,
                                -14.26076
                            ],
                            [
                                144.52425,
                                -14.17416
                            ],
                            [
                                144.49269,
                                -14.17045
                            ],
                            [
                                144.43576,
                                -14.25718
                            ],
                            [
                                144.33838,
                                -14.30513
                            ],
                            [
                                144.19666,
                                -14.26749
                            ],
                            [
                                144.19109,
                                -14.34322
                            ],
                            [
                                144.0897,
                                -14.44799
                            ],
                            [
                                144.02935,
                                -14.47992
                            ],
                            [
                                143.8838,
                                -14.4808
                            ],
                            [
                                143.79809,
                                -14.42072
                            ],
                            [
                                143.74672,
                                -14.33346
                            ],
                            [
                                143.70311,
                                -14.20314
                            ],
                            [
                                143.68033,
                                -14.01695
                            ],
                            [
                                143.63474,
                                -13.98072
                            ],
                            [
                                143.5933,
                                -13.86453
                            ],
                            [
                                143.53365,
                                -13.75697
                            ],
                            [
                                143.55641,
                                -13.60165
                            ],
                            [
                                143.58644,
                                -13.53965
                            ],
                            [
                                143.59438,
                                -13.4482
                            ],
                            [
                                143.58075,
                                -13.37684
                            ],
                            [
                                143.52704,
                                -13.32081
                            ],
                            [
                                143.50514,
                                -12.92284
                            ],
                            [
                                143.52901,
                                -12.8751
                            ],
                            [
                                143.45262,
                                -12.85221
                            ],
                            [
                                143.3543,
                                -12.89199
                            ],
                            [
                                143.36033,
                                -12.79339
                            ],
                            [
                                143.41437,
                                -12.59748
                            ],
                            [
                                143.30516,
                                -12.54854
                            ],
                            [
                                143.27512,
                                -12.50492
                            ],
                            [
                                143.27184,
                                -12.40851
                            ],
                            [
                                143.18074,
                                -12.34641
                            ],
                            [
                                143.08688,
                                -12.34437
                            ],
                            [
                                143.10118,
                                -12.14362
                            ],
                            [
                                143.18585,
                                -11.99318
                            ],
                            [
                                143.14372,
                                -11.91864
                            ],
                            [
                                142.97467,
                                -11.93128
                            ],
                            [
                                142.85706,
                                -11.84234
                            ],
                            [
                                142.85952,
                                -11.64339
                            ],
                            [
                                142.83605,
                                -11.55889
                            ],
                            [
                                142.8345,
                                -11.43299
                            ],
                            [
                                142.86629,
                                -11.37907
                            ],
                            [
                                142.79484,
                                -11.27624
                            ],
                            [
                                142.78553,
                                -11.07986
                            ],
                            [
                                142.71793,
                                -10.96801
                            ],
                            [
                                142.61257,
                                -10.93254
                            ],
                            [
                                142.55601,
                                -10.88073
                            ],
                            [
                                142.55019,
                                -10.82906
                            ],
                            [
                                142.60384,
                                -10.75073
                            ],
                            [
                                142.5319,
                                -10.69313
                            ],
                            [
                                142.46123,
                                -10.71909
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                144.74153,
                                -40.69185
                            ],
                            [
                                144.68231,
                                -40.72045
                            ],
                            [
                                144.71059,
                                -40.83925
                            ],
                            [
                                144.68547,
                                -40.902
                            ],
                            [
                                144.61847,
                                -40.93825
                            ],
                            [
                                144.61472,
                                -41.01243
                            ],
                            [
                                144.67357,
                                -41.0897
                            ],
                            [
                                144.68872,
                                -41.23987
                            ],
                            [
                                144.76288,
                                -41.3466
                            ],
                            [
                                144.78618,
                                -41.44976
                            ],
                            [
                                144.8937,
                                -41.60259
                            ],
                            [
                                144.92168,
                                -41.71123
                            ],
                            [
                                144.97337,
                                -41.73161
                            ],
                            [
                                145.02817,
                                -41.80745
                            ],
                            [
                                145.18212,
                                -41.93813
                            ],
                            [
                                145.24843,
                                -42.05379
                            ],
                            [
                                145.25568,
                                -42.17675
                            ],
                            [
                                145.35779,
                                -42.18214
                            ],
                            [
                                145.3673,
                                -42.24729
                            ],
                            [
                                145.54451,
                                -42.38593
                            ],
                            [
                                145.44907,
                                -42.40748
                            ],
                            [
                                145.25578,
                                -42.28557
                            ],
                            [
                                145.1981,
                                -42.32175
                            ],
                            [
                                145.2506,
                                -42.44245
                            ],
                            [
                                145.24155,
                                -42.47614
                            ],
                            [
                                145.30061,
                                -42.57849
                            ],
                            [
                                145.26927,
                                -42.61534
                            ],
                            [
                                145.364,
                                -42.66093
                            ],
                            [
                                145.45577,
                                -42.89926
                            ],
                            [
                                145.5008,
                                -42.98218
                            ],
                            [
                                145.58519,
                                -42.9751
                            ],
                            [
                                145.67202,
                                -43.09861
                            ],
                            [
                                145.7987,
                                -43.20677
                            ],
                            [
                                145.81868,
                                -43.27606
                            ],
                            [
                                145.87008,
                                -43.31788
                            ],
                            [
                                145.92574,
                                -43.21533
                            ],
                            [
                                146.00835,
                                -43.34378
                            ],
                            [
                                145.96468,
                                -43.38515
                            ],
                            [
                                146.02842,
                                -43.46794
                            ],
                            [
                                146.03792,
                                -43.55917
                            ],
                            [
                                146.15574,
                                -43.50597
                            ],
                            [
                                146.26986,
                                -43.49943
                            ],
                            [
                                146.41011,
                                -43.53745
                            ],
                            [
                                146.56802,
                                -43.53067
                            ],
                            [
                                146.72579,
                                -43.62652
                            ],
                            [
                                146.7894,
                                -43.60319
                            ],
                            [
                                146.86904,
                                -43.63334
                            ],
                            [
                                146.9175,
                                -43.59872
                            ],
                            [
                                146.89132,
                                -43.54395
                            ],
                            [
                                147.01606,
                                -43.43905
                            ],
                            [
                                147.09545,
                                -43.28606
                            ],
                            [
                                147.23923,
                                -43.26901
                            ],
                            [
                                147.24145,
                                -43.15495
                            ],
                            [
                                147.33924,
                                -43.04812
                            ],
                            [
                                147.32778,
                                -42.98607
                            ],
                            [
                                147.35515,
                                -42.91208
                            ],
                            [
                                147.49755,
                                -42.91082
                            ],
                            [
                                147.5357,
                                -42.78178
                            ],
                            [
                                147.59913,
                                -42.79701
                            ],
                            [
                                147.61039,
                                -42.86556
                            ],
                            [
                                147.67278,
                                -42.89884
                            ],
                            [
                                147.79613,
                                -42.89441
                            ],
                            [
                                147.84792,
                                -42.95764
                            ],
                            [
                                147.85052,
                                -43.01182
                            ],
                            [
                                147.92331,
                                -43.01537
                            ],
                            [
                                147.99682,
                                -42.96454
                            ],
                            [
                                147.98078,
                                -42.89039
                            ],
                            [
                                147.86167,
                                -42.82664
                            ],
                            [
                                147.87846,
                                -42.77309
                            ],
                            [
                                147.96078,
                                -42.67649
                            ],
                            [
                                147.90371,
                                -42.56934
                            ],
                            [
                                147.9939,
                                -42.52267
                            ],
                            [
                                148.00911,
                                -42.44676
                            ],
                            [
                                147.98327,
                                -42.40504
                            ],
                            [
                                148.02302,
                                -42.34888
                            ],
                            [
                                148.01605,
                                -42.23849
                            ],
                            [
                                148.08007,
                                -42.16821
                            ],
                            [
                                148.07509,
                                -42.11403
                            ],
                            [
                                148.16907,
                                -42.08403
                            ],
                            [
                                148.29867,
                                -42.13102
                            ],
                            [
                                148.2579,
                                -42.24995
                            ],
                            [
                                148.31054,
                                -42.2762
                            ],
                            [
                                148.3517,
                                -42.18247
                            ],
                            [
                                148.34344,
                                -42.11629
                            ],
                            [
                                148.28467,
                                -42.03398
                            ],
                            [
                                148.3181,
                                -41.92453
                            ],
                            [
                                148.27169,
                                -41.84497
                            ],
                            [
                                148.29104,
                                -41.67075
                            ],
                            [
                                148.31912,
                                -41.6132
                            ],
                            [
                                148.26497,
                                -41.46149
                            ],
                            [
                                148.32591,
                                -41.31086
                            ],
                            [
                                148.2667,
                                -41.18429
                            ],
                            [
                                148.27085,
                                -41.12382
                            ],
                            [
                                148.32376,
                                -40.98547
                            ],
                            [
                                148.21829,
                                -40.84676
                            ],
                            [
                                148.12774,
                                -40.82322
                            ],
                            [
                                148.08561,
                                -40.77604
                            ],
                            [
                                147.9815,
                                -40.74152
                            ],
                            [
                                147.89001,
                                -40.86268
                            ],
                            [
                                147.83235,
                                -40.88525
                            ],
                            [
                                147.60111,
                                -40.85108
                            ],
                            [
                                147.51628,
                                -40.95812
                            ],
                            [
                                147.40277,
                                -41.00618
                            ],
                            [
                                147.34569,
                                -40.94661
                            ],
                            [
                                147.25532,
                                -40.95459
                            ],
                            [
                                147.14657,
                                -41.01132
                            ],
                            [
                                147.01199,
                                -40.9846
                            ],
                            [
                                146.9482,
                                -41.02212
                            ],
                            [
                                146.87468,
                                -41.02271
                            ],
                            [
                                146.79951,
                                -41.06211
                            ],
                            [
                                146.65183,
                                -41.09689
                            ],
                            [
                                146.56787,
                                -41.18127
                            ],
                            [
                                146.5337,
                                -41.12475
                            ],
                            [
                                146.47016,
                                -41.1565
                            ],
                            [
                                146.35358,
                                -41.16253
                            ],
                            [
                                146.17352,
                                -41.14971
                            ],
                            [
                                145.96971,
                                -41.06749
                            ],
                            [
                                145.81063,
                                -41.02909
                            ],
                            [
                                145.72493,
                                -40.94793
                            ],
                            [
                                145.55626,
                                -40.91135
                            ],
                            [
                                145.50745,
                                -40.85824
                            ],
                            [
                                145.44688,
                                -40.87311
                            ],
                            [
                                145.31594,
                                -40.8411
                            ],
                            [
                                145.26525,
                                -40.78436
                            ],
                            [
                                145.12234,
                                -40.83057
                            ],
                            [
                                144.98111,
                                -40.74865
                            ],
                            [
                                144.84546,
                                -40.74073
                            ],
                            [
                                144.74153,
                                -40.69185
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                130.38142,
                                -11.16804
                            ],
                            [
                                130.36483,
                                -11.25227
                            ],
                            [
                                130.40841,
                                -11.31075
                            ],
                            [
                                130.43343,
                                -11.50167
                            ],
                            [
                                130.49005,
                                -11.5577
                            ],
                            [
                                130.47738,
                                -11.61476
                            ],
                            [
                                130.50304,
                                -11.66393
                            ],
                            [
                                130.57371,
                                -11.69777
                            ],
                            [
                                130.67445,
                                -11.76238
                            ],
                            [
                                130.68917,
                                -11.79528
                            ],
                            [
                                130.85928,
                                -11.85439
                            ],
                            [
                                130.94275,
                                -11.93392
                            ],
                            [
                                130.97986,
                                -11.92881
                            ],
                            [
                                131.08405,
                                -11.8366
                            ],
                            [
                                131.17818,
                                -11.79275
                            ],
                            [
                                131.33101,
                                -11.68173
                            ],
                            [
                                131.38033,
                                -11.58731
                            ],
                            [
                                131.46852,
                                -11.60593
                            ],
                            [
                                131.45559,
                                -11.55126
                            ],
                            [
                                131.53504,
                                -11.41327
                            ],
                            [
                                131.47995,
                                -11.39816
                            ],
                            [
                                131.41678,
                                -11.25887
                            ],
                            [
                                131.37293,
                                -11.28451
                            ],
                            [
                                131.28906,
                                -11.19736
                            ],
                            [
                                131.16412,
                                -11.26719
                            ],
                            [
                                131.11581,
                                -11.25974
                            ],
                            [
                                131.04494,
                                -11.31793
                            ],
                            [
                                131.03037,
                                -11.36533
                            ],
                            [
                                130.89975,
                                -11.31036
                            ],
                            [
                                130.84935,
                                -11.35358
                            ],
                            [
                                130.70647,
                                -11.38735
                            ],
                            [
                                130.76699,
                                -11.46763
                            ],
                            [
                                130.70805,
                                -11.48415
                            ],
                            [
                                130.66038,
                                -11.40216
                            ],
                            [
                                130.58294,
                                -11.39973
                            ],
                            [
                                130.55541,
                                -11.27039
                            ],
                            [
                                130.51056,
                                -11.28206
                            ],
                            [
                                130.40536,
                                -11.16951
                            ],
                            [
                                130.38142,
                                -11.16804
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                137.60407,
                                -35.57093
                            ],
                            [
                                137.52099,
                                -35.59494
                            ],
                            [
                                137.31499,
                                -35.5795
                            ],
                            [
                                137.11582,
                                -35.65397
                            ],
                            [
                                136.78433,
                                -35.70061
                            ],
                            [
                                136.70012,
                                -35.73812
                            ],
                            [
                                136.58531,
                                -35.75095
                            ],
                            [
                                136.56346,
                                -35.84932
                            ],
                            [
                                136.53373,
                                -35.87622
                            ],
                            [
                                136.59745,
                                -35.96121
                            ],
                            [
                                136.65099,
                                -35.96472
                            ],
                            [
                                136.70744,
                                -36.03547
                            ],
                            [
                                136.75871,
                                -36.04918
                            ],
                            [
                                136.85711,
                                -36.01759
                            ],
                            [
                                136.91385,
                                -36.04251
                            ],
                            [
                                136.99723,
                                -36.0184
                            ],
                            [
                                137.12997,
                                -36.03256
                            ],
                            [
                                137.21051,
                                -35.97433
                            ],
                            [
                                137.37021,
                                -35.99926
                            ],
                            [
                                137.46148,
                                -36.07331
                            ],
                            [
                                137.61795,
                                -35.97871
                            ],
                            [
                                137.59894,
                                -35.93844
                            ],
                            [
                                137.66144,
                                -35.88476
                            ],
                            [
                                137.73901,
                                -35.8549
                            ],
                            [
                                137.93734,
                                -35.86523
                            ],
                            [
                                138.03897,
                                -35.90337
                            ],
                            [
                                138.10868,
                                -35.85039
                            ],
                            [
                                138.06677,
                                -35.75981
                            ],
                            [
                                138.00376,
                                -35.72652
                            ],
                            [
                                137.89596,
                                -35.72572
                            ],
                            [
                                137.85398,
                                -35.79316
                            ],
                            [
                                137.78098,
                                -35.7255
                            ],
                            [
                                137.59838,
                                -35.73526
                            ],
                            [
                                137.64254,
                                -35.65246
                            ],
                            [
                                137.56995,
                                -35.62259
                            ],
                            [
                                137.60407,
                                -35.57093
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                136.67383,
                                -13.6978
                            ],
                            [
                                136.62036,
                                -13.70747
                            ],
                            [
                                136.60762,
                                -13.78622
                            ],
                            [
                                136.53922,
                                -13.80945
                            ],
                            [
                                136.53735,
                                -13.73684
                            ],
                            [
                                136.47037,
                                -13.74669
                            ],
                            [
                                136.52533,
                                -13.81684
                            ],
                            [
                                136.43067,
                                -13.81595
                            ],
                            [
                                136.43511,
                                -13.89112
                            ],
                            [
                                136.40941,
                                -13.9758
                            ],
                            [
                                136.44092,
                                -14.1232
                            ],
                            [
                                136.39257,
                                -14.18031
                            ],
                            [
                                136.48792,
                                -14.2349
                            ],
                            [
                                136.62622,
                                -14.26642
                            ],
                            [
                                136.65301,
                                -14.29288
                            ],
                            [
                                136.78586,
                                -14.26223
                            ],
                            [
                                136.89878,
                                -14.30381
                            ],
                            [
                                136.94488,
                                -14.29656
                            ],
                            [
                                136.95264,
                                -14.23805
                            ],
                            [
                                136.92742,
                                -14.15944
                            ],
                            [
                                136.85548,
                                -14.20483
                            ],
                            [
                                136.79697,
                                -14.14997
                            ],
                            [
                                136.76513,
                                -14.19347
                            ],
                            [
                                136.70999,
                                -14.16787
                            ],
                            [
                                136.72348,
                                -14.07257
                            ],
                            [
                                136.80003,
                                -14.03811
                            ],
                            [
                                136.7649,
                                -14.00158
                            ],
                            [
                                136.78217,
                                -13.93063
                            ],
                            [
                                136.85554,
                                -13.90822
                            ],
                            [
                                136.92016,
                                -13.80314
                            ],
                            [
                                136.84124,
                                -13.74971
                            ],
                            [
                                136.80825,
                                -13.85409
                            ],
                            [
                                136.72799,
                                -13.83908
                            ],
                            [
                                136.67383,
                                -13.6978
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                153.25966,
                                -24.81319
                            ],
                            [
                                153.26638,
                                -24.70303
                            ],
                            [
                                153.21234,
                                -24.71594
                            ],
                            [
                                153.12553,
                                -24.80058
                            ],
                            [
                                153.18442,
                                -24.84826
                            ],
                            [
                                153.22997,
                                -24.92061
                            ],
                            [
                                153.22759,
                                -24.98237
                            ],
                            [
                                153.16196,
                                -25.08169
                            ],
                            [
                                153.02949,
                                -25.17715
                            ],
                            [
                                153.0507,
                                -25.34315
                            ],
                            [
                                152.98734,
                                -25.44816
                            ],
                            [
                                152.98649,
                                -25.50854
                            ],
                            [
                                152.93824,
                                -25.55533
                            ],
                            [
                                153.02673,
                                -25.78302
                            ],
                            [
                                153.08852,
                                -25.75864
                            ],
                            [
                                153.07747,
                                -25.6798
                            ],
                            [
                                153.10884,
                                -25.55806
                            ],
                            [
                                153.18895,
                                -25.36921
                            ],
                            [
                                153.35019,
                                -25.03206
                            ],
                            [
                                153.35032,
                                -24.96673
                            ],
                            [
                                153.28669,
                                -24.92842
                            ],
                            [
                                153.25966,
                                -24.81319
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                147.88195,
                                -39.76019
                            ],
                            [
                                147.83687,
                                -39.83478
                            ],
                            [
                                147.90148,
                                -39.95006
                            ],
                            [
                                147.87761,
                                -40.02375
                            ],
                            [
                                147.93396,
                                -40.03683
                            ],
                            [
                                148.00722,
                                -40.10913
                            ],
                            [
                                148.04647,
                                -40.24692
                            ],
                            [
                                148.12024,
                                -40.2716
                            ],
                            [
                                148.21457,
                                -40.21137
                            ],
                            [
                                148.3312,
                                -40.20571
                            ],
                            [
                                148.2768,
                                -40.11554
                            ],
                            [
                                148.28754,
                                -39.9689
                            ],
                            [
                                148.18208,
                                -39.94706
                            ],
                            [
                                147.95611,
                                -39.7292
                            ],
                            [
                                147.88195,
                                -39.76019
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                130.2716,
                                -11.34372
                            ],
                            [
                                130.15554,
                                -11.48816
                            ],
                            [
                                130.19427,
                                -11.63868
                            ],
                            [
                                130.15211,
                                -11.70312
                            ],
                            [
                                130.09077,
                                -11.6736
                            ],
                            [
                                130.05112,
                                -11.82114
                            ],
                            [
                                130.12411,
                                -11.82503
                            ],
                            [
                                130.31469,
                                -11.77256
                            ],
                            [
                                130.49909,
                                -11.82862
                            ],
                            [
                                130.60753,
                                -11.82386
                            ],
                            [
                                130.63904,
                                -11.76006
                            ],
                            [
                                130.55333,
                                -11.69277
                            ],
                            [
                                130.46976,
                                -11.66351
                            ],
                            [
                                130.46162,
                                -11.57523
                            ],
                            [
                                130.40122,
                                -11.53708
                            ],
                            [
                                130.37889,
                                -11.48493
                            ],
                            [
                                130.39955,
                                -11.42856
                            ],
                            [
                                130.34399,
                                -11.32477
                            ],
                            [
                                130.2716,
                                -11.34372
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                143.92834,
                                -39.59253
                            ],
                            [
                                143.93443,
                                -39.63838
                            ],
                            [
                                143.84589,
                                -39.71486
                            ],
                            [
                                143.86652,
                                -39.83494
                            ],
                            [
                                143.83419,
                                -39.91907
                            ],
                            [
                                143.88553,
                                -39.97948
                            ],
                            [
                                143.87601,
                                -40.11559
                            ],
                            [
                                143.92252,
                                -40.13314
                            ],
                            [
                                144.03477,
                                -40.08631
                            ],
                            [
                                144.12631,
                                -39.99422
                            ],
                            [
                                144.13761,
                                -39.93362
                            ],
                            [
                                144.10499,
                                -39.87941
                            ],
                            [
                                144.1271,
                                -39.823
                            ],
                            [
                                144.10101,
                                -39.73704
                            ],
                            [
                                144.10873,
                                -39.66949
                            ],
                            [
                                144.05111,
                                -39.62578
                            ],
                            [
                                143.92834,
                                -39.59253
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                139.53898,
                                -16.39837
                            ],
                            [
                                139.46441,
                                -16.44565
                            ],
                            [
                                139.30894,
                                -16.46061
                            ],
                            [
                                139.24327,
                                -16.5041
                            ],
                            [
                                139.2125,
                                -16.56858
                            ],
                            [
                                139.16261,
                                -16.60849
                            ],
                            [
                                139.1655,
                                -16.667
                            ],
                            [
                                139.2311,
                                -16.73082
                            ],
                            [
                                139.30423,
                                -16.72459
                            ],
                            [
                                139.36885,
                                -16.67232
                            ],
                            [
                                139.45047,
                                -16.66617
                            ],
                            [
                                139.46707,
                                -16.57103
                            ],
                            [
                                139.50344,
                                -16.51359
                            ],
                            [
                                139.57834,
                                -16.50431
                            ],
                            [
                                139.59627,
                                -16.55219
                            ],
                            [
                                139.70061,
                                -16.50966
                            ],
                            [
                                139.67804,
                                -16.45331
                            ],
                            [
                                139.60286,
                                -16.40364
                            ],
                            [
                                139.53898,
                                -16.39837
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                113.12755,
                                -25.92245
                            ],
                            [
                                113.15475,
                                -25.88864
                            ],
                            [
                                113.07713,
                                -25.76813
                            ],
                            [
                                113.00839,
                                -25.52675
                            ],
                            [
                                112.96366,
                                -25.48435
                            ],
                            [
                                112.9214,
                                -25.58922
                            ],
                            [
                                112.97933,
                                -25.74954
                            ],
                            [
                                112.96767,
                                -25.78234
                            ],
                            [
                                113.05078,
                                -25.93182
                            ],
                            [
                                113.15626,
                                -26.05404
                            ],
                            [
                                113.17804,
                                -26.11548
                            ],
                            [
                                113.23848,
                                -26.10655
                            ],
                            [
                                113.20242,
                                -26.00408
                            ],
                            [
                                113.13662,
                                -25.97497
                            ],
                            [
                                113.12755,
                                -25.92245
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                147.66667,
                                -42.94456
                            ],
                            [
                                147.61992,
                                -43.01551
                            ],
                            [
                                147.62498,
                                -43.06686
                            ],
                            [
                                147.71236,
                                -43.09984
                            ],
                            [
                                147.71489,
                                -43.19338
                            ],
                            [
                                147.802,
                                -43.21521
                            ],
                            [
                                147.84547,
                                -43.19066
                            ],
                            [
                                147.96706,
                                -43.18264
                            ],
                            [
                                148.0002,
                                -43.14262
                            ],
                            [
                                147.92091,
                                -43.01926
                            ],
                            [
                                147.8367,
                                -43.05853
                            ],
                            [
                                147.75139,
                                -43.04095
                            ],
                            [
                                147.73153,
                                -42.97135
                            ],
                            [
                                147.66667,
                                -42.94456
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                148.31832,
                                -40.30909
                            ],
                            [
                                148.196,
                                -40.35129
                            ],
                            [
                                148.14049,
                                -40.33723
                            ],
                            [
                                147.98694,
                                -40.38868
                            ],
                            [
                                148.05022,
                                -40.44871
                            ],
                            [
                                148.1967,
                                -40.43812
                            ],
                            [
                                148.22663,
                                -40.46447
                            ],
                            [
                                148.31655,
                                -40.43384
                            ],
                            [
                                148.34826,
                                -40.49124
                            ],
                            [
                                148.44972,
                                -40.4378
                            ],
                            [
                                148.4095,
                                -40.37448
                            ],
                            [
                                148.31832,
                                -40.30909
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                146.22883,
                                -18.20844
                            ],
                            [
                                146.19714,
                                -18.27744
                            ],
                            [
                                146.15229,
                                -18.31477
                            ],
                            [
                                146.20626,
                                -18.39862
                            ],
                            [
                                146.22397,
                                -18.47777
                            ],
                            [
                                146.30199,
                                -18.49327
                            ],
                            [
                                146.35583,
                                -18.41932
                            ],
                            [
                                146.27569,
                                -18.3146
                            ],
                            [
                                146.30283,
                                -18.23873
                            ],
                            [
                                146.22883,
                                -18.20844
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                147.32207,
                                -43.31414
                            ],
                            [
                                147.26879,
                                -43.29377
                            ],
                            [
                                147.19496,
                                -43.36319
                            ],
                            [
                                147.243,
                                -43.46863
                            ],
                            [
                                147.29983,
                                -43.51229
                            ],
                            [
                                147.34965,
                                -43.4076
                            ],
                            [
                                147.32207,
                                -43.31414
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                132.58004,
                                -11.01314
                            ],
                            [
                                132.47224,
                                -11.15612
                            ],
                            [
                                132.54254,
                                -11.25148
                            ],
                            [
                                132.56609,
                                -11.32856
                            ],
                            [
                                132.61931,
                                -11.28462
                            ],
                            [
                                132.57988,
                                -11.15878
                            ],
                            [
                                132.60252,
                                -11.11766
                            ],
                            [
                                132.58004,
                                -11.01314
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                135.86391,
                                -11.77225
                            ],
                            [
                                135.87087,
                                -11.83314
                            ],
                            [
                                135.73217,
                                -11.93888
                            ],
                            [
                                135.67889,
                                -11.93322
                            ],
                            [
                                135.63055,
                                -11.97503
                            ],
                            [
                                135.59222,
                                -11.95373
                            ],
                            [
                                135.56363,
                                -12.05664
                            ],
                            [
                                135.6353,
                                -12.0189
                            ],
                            [
                                135.73325,
                                -12.00168
                            ],
                            [
                                135.79134,
                                -11.96826
                            ],
                            [
                                135.85773,
                                -11.87914
                            ],
                            [
                                135.93689,
                                -11.80287
                            ],
                            [
                                135.86391,
                                -11.77225
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                136.99392,
                                -15.5853
                            ],
                            [
                                136.94895,
                                -15.65658
                            ],
                            [
                                136.99435,
                                -15.79175
                            ],
                            [
                                137.07442,
                                -15.83418
                            ],
                            [
                                137.07754,
                                -15.65277
                            ],
                            [
                                136.99392,
                                -15.5853
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                115.42025,
                                -20.84962
                            ],
                            [
                                115.47635,
                                -20.73371
                            ],
                            [
                                115.43442,
                                -20.66667
                            ],
                            [
                                115.32555,
                                -20.80155
                            ],
                            [
                                115.30847,
                                -20.86855
                            ],
                            [
                                115.39497,
                                -20.88558
                            ],
                            [
                                115.42025,
                                -20.84962
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                136.26645,
                                -13.69394
                            ],
                            [
                                136.20094,
                                -13.66522
                            ],
                            [
                                136.16996,
                                -13.7692
                            ],
                            [
                                136.21034,
                                -13.82868
                            ],
                            [
                                136.29947,
                                -13.73503
                            ],
                            [
                                136.26645,
                                -13.69394
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                145.29727,
                                -38.28226
                            ],
                            [
                                145.28021,
                                -38.39635
                            ],
                            [
                                145.35123,
                                -38.41968
                            ],
                            [
                                145.4553,
                                -38.30828
                            ],
                            [
                                145.34689,
                                -38.3096
                            ],
                            [
                                145.29727,
                                -38.28226
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                136.72568,
                                -11.04365
                            ],
                            [
                                136.70205,
                                -11.17315
                            ],
                            [
                                136.6595,
                                -11.18645
                            ],
                            [
                                136.58696,
                                -11.27972
                            ],
                            [
                                136.57793,
                                -11.32799
                            ],
                            [
                                136.51647,
                                -11.39124
                            ],
                            [
                                136.53598,
                                -11.44064
                            ],
                            [
                                136.6232,
                                -11.32507
                            ],
                            [
                                136.62969,
                                -11.28279
                            ],
                            [
                                136.71749,
                                -11.19176
                            ],
                            [
                                136.74982,
                                -11.06805
                            ],
                            [
                                136.72568,
                                -11.04365
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                142.18734,
                                -10.59848
                            ],
                            [
                                142.11148,
                                -10.66318
                            ],
                            [
                                142.11384,
                                -10.7206
                            ],
                            [
                                142.17941,
                                -10.76982
                            ],
                            [
                                142.20836,
                                -10.72565
                            ],
                            [
                                142.27637,
                                -10.70584
                            ],
                            [
                                142.18734,
                                -10.59848
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                153.42322,
                                -27.0315
                            ],
                            [
                                153.36221,
                                -27.06093
                            ],
                            [
                                153.36585,
                                -27.20048
                            ],
                            [
                                153.42424,
                                -27.17251
                            ],
                            [
                                153.46772,
                                -27.03368
                            ],
                            [
                                153.42322,
                                -27.0315
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                124.56157,
                                -15.31445
                            ],
                            [
                                124.49982,
                                -15.28891
                            ],
                            [
                                124.48009,
                                -15.38441
                            ],
                            [
                                124.55327,
                                -15.38392
                            ],
                            [
                                124.5312,
                                -15.44674
                            ],
                            [
                                124.619,
                                -15.42425
                            ],
                            [
                                124.62387,
                                -15.38909
                            ],
                            [
                                124.56157,
                                -15.31445
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                125.20818,
                                -14.50189
                            ],
                            [
                                125.16582,
                                -14.44447
                            ],
                            [
                                125.09806,
                                -14.54864
                            ],
                            [
                                125.09239,
                                -14.62861
                            ],
                            [
                                125.13575,
                                -14.64954
                            ],
                            [
                                125.21108,
                                -14.59426
                            ],
                            [
                                125.20818,
                                -14.50189
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                142.21171,
                                -10.14002
                            ],
                            [
                                142.18627,
                                -10.19089
                            ],
                            [
                                142.27569,
                                -10.25883
                            ],
                            [
                                142.34338,
                                -10.17278
                            ],
                            [
                                142.26815,
                                -10.11596
                            ],
                            [
                                142.21171,
                                -10.14002
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                153.19601,
                                -27.09664
                            ],
                            [
                                153.12904,
                                -26.87526
                            ],
                            [
                                153.08054,
                                -26.90679
                            ],
                            [
                                153.07956,
                                -26.97093
                            ],
                            [
                                153.16789,
                                -27.09976
                            ],
                            [
                                153.19601,
                                -27.09664
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                147.36442,
                                -43.08645
                            ],
                            [
                                147.28704,
                                -43.14398
                            ],
                            [
                                147.38471,
                                -43.18888
                            ],
                            [
                                147.36442,
                                -43.08645
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                139.49451,
                                -17.00083
                            ],
                            [
                                139.42216,
                                -17.07786
                            ],
                            [
                                139.48232,
                                -17.11788
                            ],
                            [
                                139.57393,
                                -17.08983
                            ],
                            [
                                139.54223,
                                -17.02965
                            ],
                            [
                                139.49451,
                                -17.00083
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                148.0318,
                                -42.62211
                            ],
                            [
                                148.06199,
                                -42.6641
                            ],
                            [
                                148.1534,
                                -42.65394
                            ],
                            [
                                148.11982,
                                -42.58617
                            ],
                            [
                                148.0318,
                                -42.62211
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                136.5726,
                                -15.51584
                            ],
                            [
                                136.52628,
                                -15.53175
                            ],
                            [
                                136.51269,
                                -15.62296
                            ],
                            [
                                136.58905,
                                -15.64494
                            ],
                            [
                                136.60941,
                                -15.52372
                            ],
                            [
                                136.5726,
                                -15.51584
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                144.93423,
                                -40.64489
                            ],
                            [
                                144.87278,
                                -40.67818
                            ],
                            [
                                144.94506,
                                -40.72987
                            ],
                            [
                                145.02692,
                                -40.68437
                            ],
                            [
                                144.93423,
                                -40.64489
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                145.14619,
                                -38.5028
                            ],
                            [
                                145.22016,
                                -38.52686
                            ],
                            [
                                145.29845,
                                -38.50677
                            ],
                            [
                                145.24089,
                                -38.44704
                            ],
                            [
                                145.14619,
                                -38.5028
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                148.99172,
                                -20.22195
                            ],
                            [
                                148.92489,
                                -20.28857
                            ],
                            [
                                149.02028,
                                -20.31727
                            ],
                            [
                                149.04178,
                                -20.28468
                            ],
                            [
                                148.99172,
                                -20.22195
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                148.2359,
                                -40.50216
                            ],
                            [
                                148.13171,
                                -40.50237
                            ],
                            [
                                148.11456,
                                -40.56339
                            ],
                            [
                                148.17911,
                                -40.5932
                            ],
                            [
                                148.2359,
                                -40.50216
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                142.16034,
                                -10.06421
                            ],
                            [
                                142.08751,
                                -10.1301
                            ],
                            [
                                142.16545,
                                -10.17694
                            ],
                            [
                                142.18781,
                                -10.1484
                            ],
                            [
                                142.16034,
                                -10.06421
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                136.73624,
                                -15.65998
                            ],
                            [
                                136.73924,
                                -15.71553
                            ],
                            [
                                136.80567,
                                -15.72476
                            ],
                            [
                                136.82662,
                                -15.66267
                            ],
                            [
                                136.73624,
                                -15.65998
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                144.88363,
                                -40.39064
                            ],
                            [
                                144.85784,
                                -40.46859
                            ],
                            [
                                144.93221,
                                -40.47021
                            ],
                            [
                                144.96192,
                                -40.40138
                            ],
                            [
                                144.88363,
                                -40.39064
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                150.47204,
                                -22.22214
                            ],
                            [
                                150.48825,
                                -22.32423
                            ],
                            [
                                150.54166,
                                -22.32098
                            ],
                            [
                                150.51994,
                                -22.22725
                            ],
                            [
                                150.47204,
                                -22.22214
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                136.12529,
                                -13.37202
                            ],
                            [
                                136.13286,
                                -13.46231
                            ],
                            [
                                136.19504,
                                -13.45291
                            ],
                            [
                                136.12529,
                                -13.37202
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                148.93327,
                                -20.06998
                            ],
                            [
                                148.88261,
                                -20.15651
                            ],
                            [
                                148.94943,
                                -20.15683
                            ],
                            [
                                148.93327,
                                -20.06998
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                113.07799,
                                -25.27153
                            ],
                            [
                                113.1276,
                                -25.0607
                            ],
                            [
                                113.08749,
                                -25.07216
                            ],
                            [
                                113.07799,
                                -25.27153
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                125.15814,
                                -15.02896
                            ],
                            [
                                125.17519,
                                -15.11933
                            ],
                            [
                                125.24756,
                                -15.09323
                            ],
                            [
                                125.15814,
                                -15.02896
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "AUT",
                "Country": "Austria",
                "Total_3GHG": 0.18,
                "Total_3GHG_timeseries": [
                    3.3364e-06,
                    6.8841e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029
                ],
                "Fossil_3GHG": 0.27,
                "Fossil_3GHG_timeseries": [
                    1.2461e-06,
                    2.7133e-06,
                    4.3739e-06,
                    6.0135e-06,
                    7.8954e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029
                ],
                "Land_3GHG": 0.01,
                "Land_3GHG_timeseries": [
                    2.0903e-06,
                    4.1708e-06,
                    6.2329e-06,
                    8.2793e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_CO2": 0.2,
                "Total_CO2_timeseries": [
                    2.1159e-06,
                    4.4141e-06,
                    6.8581e-06,
                    9.2428e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023
                ],
                "Fossil_CO2": 0.32,
                "Fossil_CO2_timeseries": [
                    1.0511e-06,
                    2.3166e-06,
                    3.7686e-06,
                    5.1992e-06,
                    6.8657e-06,
                    8.7714e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025
                ],
                "Land_CO2": -0.07,
                "Land_CO2_timeseries": [
                    1.0648e-06,
                    2.0975e-06,
                    3.0895e-06,
                    4.0437e-06,
                    4.9704e-06,
                    5.8894e-06,
                    6.8112e-06,
                    7.714e-06,
                    8.5562e-06,
                    9.4774e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    8.6326e-06,
                    5.4537e-06,
                    2.2705e-06,
                    -0.0000010221,
                    -0.0000043038,
                    -0.0000076274,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002
                ],
                "Total_CH4": 0.11,
                "Total_CH4_timeseries": [
                    1.0583e-06,
                    2.1431e-06,
                    3.2545e-06,
                    4.3862e-06,
                    5.544e-06,
                    6.7275e-06,
                    7.9379e-06,
                    9.1887e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Fossil_CH4": 0.09,
                "Fossil_CH4_timeseries": [
                    1.1669e-07,
                    2.3912e-07,
                    3.6765e-07,
                    4.9577e-07,
                    6.2932e-07,
                    7.6794e-07,
                    9.1279e-07,
                    1.0774e-06,
                    1.2283e-06,
                    1.3806e-06,
                    1.5319e-06,
                    1.6802e-06,
                    1.8238e-06,
                    1.9558e-06,
                    2.0861e-06,
                    2.1958e-06,
                    2.3147e-06,
                    2.439e-06,
                    2.5646e-06,
                    2.6928e-06,
                    2.8432e-06,
                    2.9866e-06,
                    3.1311e-06,
                    3.2601e-06,
                    3.3715e-06,
                    3.4796e-06,
                    3.5729e-06,
                    3.6444e-06,
                    3.739e-06,
                    3.9592e-06,
                    4.0607e-06,
                    4.1625e-06,
                    4.2763e-06,
                    4.3936e-06,
                    4.5126e-06,
                    4.6387e-06,
                    4.7598e-06,
                    4.8678e-06,
                    4.9799e-06,
                    5.0862e-06,
                    5.1851e-06,
                    5.2804e-06,
                    5.3975e-06,
                    5.5301e-06,
                    5.6917e-06,
                    5.8555e-06,
                    6.0415e-06,
                    6.2405e-06,
                    6.4306e-06,
                    6.5241e-06,
                    6.729e-06,
                    6.9088e-06,
                    7.0797e-06,
                    7.2653e-06,
                    7.4583e-06,
                    7.7061e-06,
                    8.0223e-06,
                    8.4928e-06,
                    8.8126e-06,
                    9.2646e-06,
                    9.6116e-06,
                    9.9795e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    9.8989e-06,
                    9.7948e-06,
                    9.6828e-06,
                    9.5802e-06,
                    9.4558e-06,
                    9.2868e-06,
                    9.0649e-06,
                    8.7139e-06,
                    8.5287e-06,
                    8.1772e-06,
                    7.9063e-06,
                    7.5915e-06,
                    7.2025e-06,
                    6.9065e-06,
                    6.7372e-06,
                    6.7843e-06,
                    6.8979e-06,
                    6.9263e-06,
                    6.9905e-06,
                    6.9821e-06,
                    7.161e-06,
                    7.5761e-06,
                    8.2328e-06,
                    9.0925e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0002,
                    0.0002
                ],
                "Land_CH4": 0.14,
                "Land_CH4_timeseries": [
                    9.4164e-07,
                    1.9039e-06,
                    2.8869e-06,
                    3.8905e-06,
                    4.9147e-06,
                    5.9596e-06,
                    7.0251e-06,
                    8.1113e-06,
                    9.2181e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Total_N2O": 0.23,
                "Total_N2O_timeseries": [
                    1.6217e-07,
                    3.2692e-07,
                    4.9416e-07,
                    6.6378e-07,
                    8.3563e-07,
                    1.0095e-06,
                    1.1853e-06,
                    1.3627e-06,
                    1.5414e-06,
                    1.7211e-06,
                    1.9016e-06,
                    2.083e-06,
                    2.2651e-06,
                    2.4479e-06,
                    2.6315e-06,
                    2.8158e-06,
                    3.0008e-06,
                    3.1865e-06,
                    3.3731e-06,
                    3.5605e-06,
                    3.7504e-06,
                    3.9456e-06,
                    4.1482e-06,
                    4.3597e-06,
                    4.5809e-06,
                    4.8121e-06,
                    5.0528e-06,
                    5.3019e-06,
                    5.5577e-06,
                    5.8178e-06,
                    6.0807e-06,
                    6.346e-06,
                    6.6134e-06,
                    6.8827e-06,
                    7.1538e-06,
                    7.4266e-06,
                    7.7011e-06,
                    7.9774e-06,
                    8.2557e-06,
                    8.5174e-06,
                    8.8005e-06,
                    9.1039e-06,
                    9.4262e-06,
                    9.7657e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_N2O": 0.35,
                "Fossil_N2O_timeseries": [
                    7.8316e-08,
                    1.5753e-07,
                    2.3763e-07,
                    3.1861e-07,
                    4.0044e-07,
                    4.8311e-07,
                    5.6658e-07,
                    6.5083e-07,
                    7.3581e-07,
                    8.215e-07,
                    9.0787e-07,
                    9.9491e-07,
                    1.0826e-06,
                    1.171e-06,
                    1.26e-06,
                    1.3497e-06,
                    1.4401e-06,
                    1.5311e-06,
                    1.6228e-06,
                    1.7152e-06,
                    1.8084e-06,
                    1.903e-06,
                    1.999e-06,
                    2.0967e-06,
                    2.1962e-06,
                    2.2976e-06,
                    2.4008e-06,
                    2.5056e-06,
                    2.6118e-06,
                    2.7191e-06,
                    2.8274e-06,
                    2.9365e-06,
                    3.0465e-06,
                    3.1573e-06,
                    3.2689e-06,
                    3.3813e-06,
                    3.4945e-06,
                    3.6084e-06,
                    3.7232e-06,
                    3.8409e-06,
                    3.96e-06,
                    4.0804e-06,
                    4.2024e-06,
                    4.3258e-06,
                    4.4507e-06,
                    4.5773e-06,
                    4.7055e-06,
                    4.8354e-06,
                    4.967e-06,
                    5.1004e-06,
                    5.2356e-06,
                    5.373e-06,
                    5.5125e-06,
                    5.6544e-06,
                    5.7986e-06,
                    5.9451e-06,
                    6.0939e-06,
                    6.2449e-06,
                    6.3979e-06,
                    6.5527e-06,
                    6.7091e-06,
                    6.8671e-06,
                    7.0265e-06,
                    7.1873e-06,
                    7.3496e-06,
                    7.5131e-06,
                    7.6781e-06,
                    7.8446e-06,
                    8.0125e-06,
                    8.182e-06,
                    8.3533e-06,
                    8.5265e-06,
                    8.7019e-06,
                    8.8795e-06,
                    9.0593e-06,
                    9.2413e-06,
                    9.4253e-06,
                    9.6112e-06,
                    9.7987e-06,
                    9.9875e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_N2O": 0.18,
                "Land_N2O_timeseries": [
                    8.3856e-08,
                    1.6939e-07,
                    2.5653e-07,
                    3.4517e-07,
                    4.3519e-07,
                    5.2643e-07,
                    6.1872e-07,
                    7.1183e-07,
                    8.0554e-07,
                    8.9958e-07,
                    9.9377e-07,
                    1.0881e-06,
                    1.1825e-06,
                    1.277e-06,
                    1.3715e-06,
                    1.4661e-06,
                    1.5607e-06,
                    1.6554e-06,
                    1.7503e-06,
                    1.8454e-06,
                    1.942e-06,
                    2.0427e-06,
                    2.1492e-06,
                    2.263e-06,
                    2.3847e-06,
                    2.5145e-06,
                    2.652e-06,
                    2.7963e-06,
                    2.9459e-06,
                    3.0987e-06,
                    3.2533e-06,
                    3.4094e-06,
                    3.5668e-06,
                    3.7254e-06,
                    3.8849e-06,
                    4.0453e-06,
                    4.2067e-06,
                    4.369e-06,
                    4.5325e-06,
                    4.6764e-06,
                    4.8405e-06,
                    5.0235e-06,
                    5.2239e-06,
                    5.4399e-06,
                    5.6698e-06,
                    5.9115e-06,
                    6.1627e-06,
                    6.4209e-06,
                    6.6835e-06,
                    6.9476e-06,
                    7.2102e-06,
                    7.4687e-06,
                    7.7211e-06,
                    7.9662e-06,
                    8.2034e-06,
                    8.4326e-06,
                    8.6544e-06,
                    8.8702e-06,
                    9.082e-06,
                    9.2922e-06,
                    9.5026e-06,
                    9.7134e-06,
                    9.925e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            10.45444,
                            47.5558
                        ],
                        [
                            10.43203,
                            47.50357
                        ],
                        [
                            10.47486,
                            47.43307
                        ],
                        [
                            10.32962,
                            47.30486
                        ],
                        [
                            10.23452,
                            47.27111
                        ],
                        [
                            10.17209,
                            47.27908
                        ],
                        [
                            10.23601,
                            47.37245
                        ],
                        [
                            10.11932,
                            47.375
                        ],
                        [
                            10.10459,
                            47.42824
                        ],
                        [
                            9.96112,
                            47.53522
                        ],
                        [
                            9.87449,
                            47.52854
                        ],
                        [
                            9.80275,
                            47.59534
                        ],
                        [
                            9.68036,
                            47.52336
                        ],
                        [
                            9.55872,
                            47.54189
                        ],
                        [
                            9.5658,
                            47.49237
                        ],
                        [
                            9.64434,
                            47.43516
                        ],
                        [
                            9.62448,
                            47.36614
                        ],
                        [
                            9.53075,
                            47.27058
                        ],
                        [
                            9.62498,
                            47.14572
                        ],
                        [
                            9.60708,
                            47.06077
                        ],
                        [
                            9.78334,
                            47.03846
                        ],
                        [
                            9.89167,
                            46.98948
                        ],
                        [
                            9.87615,
                            46.93464
                        ],
                        [
                            9.97789,
                            46.91589
                        ],
                        [
                            10.15781,
                            46.84857
                        ],
                        [
                            10.29361,
                            46.92181
                        ],
                        [
                            10.34898,
                            46.99061
                        ],
                        [
                            10.48935,
                            46.93779
                        ],
                        [
                            10.46965,
                            46.85491
                        ],
                        [
                            10.56907,
                            46.84221
                        ],
                        [
                            10.66737,
                            46.87549
                        ],
                        [
                            10.81431,
                            46.77568
                        ],
                        [
                            11.02225,
                            46.76541
                        ],
                        [
                            11.11458,
                            46.93064
                        ],
                        [
                            11.17518,
                            46.96318
                        ],
                        [
                            11.35909,
                            46.9902
                        ],
                        [
                            11.40217,
                            46.96514
                        ],
                        [
                            11.48029,
                            47.01079
                        ],
                        [
                            11.53854,
                            46.98408
                        ],
                        [
                            11.6272,
                            47.0133
                        ],
                        [
                            11.72776,
                            46.97353
                        ],
                        [
                            11.83534,
                            46.99309
                        ],
                        [
                            11.91707,
                            47.03262
                        ],
                        [
                            12.18628,
                            47.09175
                        ],
                        [
                            12.20487,
                            47.02698
                        ],
                        [
                            12.12134,
                            47.007
                        ],
                        [
                            12.21851,
                            46.87395
                        ],
                        [
                            12.30547,
                            46.83414
                        ],
                        [
                            12.38406,
                            46.71633
                        ],
                        [
                            12.57007,
                            46.65145
                        ],
                        [
                            12.77838,
                            46.64618
                        ],
                        [
                            12.85343,
                            46.60491
                        ],
                        [
                            12.92945,
                            46.61022
                        ],
                        [
                            13.1686,
                            46.5889
                        ],
                        [
                            13.31874,
                            46.55241
                        ],
                        [
                            13.50425,
                            46.5663
                        ],
                        [
                            13.56976,
                            46.54016
                        ],
                        [
                            13.71419,
                            46.5227
                        ],
                        [
                            13.81254,
                            46.50642
                        ],
                        [
                            13.91256,
                            46.52072
                        ],
                        [
                            14.00652,
                            46.48136
                        ],
                        [
                            14.12014,
                            46.47667
                        ],
                        [
                            14.1534,
                            46.43678
                        ],
                        [
                            14.4472,
                            46.42197
                        ],
                        [
                            14.67458,
                            46.45069
                        ],
                        [
                            14.74147,
                            46.50459
                        ],
                        [
                            14.81861,
                            46.50938
                        ],
                        [
                            14.86817,
                            46.6052
                        ],
                        [
                            14.97932,
                            46.6014
                        ],
                        [
                            15.01599,
                            46.64021
                        ],
                        [
                            15.10869,
                            46.65891
                        ],
                        [
                            15.23619,
                            46.63968
                        ],
                        [
                            15.41919,
                            46.65489
                        ],
                        [
                            15.46268,
                            46.61643
                        ],
                        [
                            15.54628,
                            46.67015
                        ],
                        [
                            15.64999,
                            46.70576
                        ],
                        [
                            15.7257,
                            46.69617
                        ],
                        [
                            15.8623,
                            46.72207
                        ],
                        [
                            15.98362,
                            46.68461
                        ],
                        [
                            15.99624,
                            46.8354
                        ],
                        [
                            16.11385,
                            46.86907
                        ],
                        [
                            16.27637,
                            46.96361
                        ],
                        [
                            16.2831,
                            47.00464
                        ],
                        [
                            16.4926,
                            47.01076
                        ],
                        [
                            16.46425,
                            47.09458
                        ],
                        [
                            16.51677,
                            47.14932
                        ],
                        [
                            16.42905,
                            47.18517
                        ],
                        [
                            16.48736,
                            47.28394
                        ],
                        [
                            16.44569,
                            47.40592
                        ],
                        [
                            16.58079,
                            47.41839
                        ],
                        [
                            16.65988,
                            47.45478
                        ],
                        [
                            16.65234,
                            47.50034
                        ],
                        [
                            16.71451,
                            47.53963
                        ],
                        [
                            16.65208,
                            47.6229
                        ],
                        [
                            16.59025,
                            47.61746
                        ],
                        [
                            16.42154,
                            47.6653
                        ],
                        [
                            16.63426,
                            47.75905
                        ],
                        [
                            16.72094,
                            47.73533
                        ],
                        [
                            16.74903,
                            47.68142
                        ],
                        [
                            17.09307,
                            47.70824
                        ],
                        [
                            17.01276,
                            47.85667
                        ],
                        [
                            17.10314,
                            47.89808
                        ],
                        [
                            17.1608,
                            48.00666
                        ],
                        [
                            17.06863,
                            48.03179
                        ],
                        [
                            17.05738,
                            48.14179
                        ],
                        [
                            16.9762,
                            48.17224
                        ],
                        [
                            16.95718,
                            48.26348
                        ],
                        [
                            16.84665,
                            48.34955
                        ],
                        [
                            16.85067,
                            48.44878
                        ],
                        [
                            16.95311,
                            48.54395
                        ],
                        [
                            16.94028,
                            48.61725
                        ],
                        [
                            16.90216,
                            48.71705
                        ],
                        [
                            16.77514,
                            48.71246
                        ],
                        [
                            16.67575,
                            48.76966
                        ],
                        [
                            16.54075,
                            48.81428
                        ],
                        [
                            16.4487,
                            48.79938
                        ],
                        [
                            16.38081,
                            48.72971
                        ],
                        [
                            16.08034,
                            48.7498
                        ],
                        [
                            15.99551,
                            48.77899
                        ],
                        [
                            15.87811,
                            48.85807
                        ],
                        [
                            15.7802,
                            48.87451
                        ],
                        [
                            15.68683,
                            48.85733
                        ],
                        [
                            15.61356,
                            48.89763
                        ],
                        [
                            15.51294,
                            48.91473
                        ],
                        [
                            15.46853,
                            48.95114
                        ],
                        [
                            15.29186,
                            48.98429
                        ],
                        [
                            15.19048,
                            48.9437
                        ],
                        [
                            15.13292,
                            48.99996
                        ],
                        [
                            15.00538,
                            49.01277
                        ],
                        [
                            14.99156,
                            48.89731
                        ],
                        [
                            14.95326,
                            48.78978
                        ],
                        [
                            14.80895,
                            48.77796
                        ],
                        [
                            14.73668,
                            48.69879
                        ],
                        [
                            14.72031,
                            48.60225
                        ],
                        [
                            14.61344,
                            48.62621
                        ],
                        [
                            14.55488,
                            48.60576
                        ],
                        [
                            14.46916,
                            48.64647
                        ],
                        [
                            14.42934,
                            48.58898
                        ],
                        [
                            14.34141,
                            48.55468
                        ],
                        [
                            14.18293,
                            48.59353
                        ],
                        [
                            14.05465,
                            48.60525
                        ],
                        [
                            14.00445,
                            48.70777
                        ],
                        [
                            13.83951,
                            48.7716
                        ],
                        [
                            13.79611,
                            48.7136
                        ],
                        [
                            13.82576,
                            48.61862
                        ],
                        [
                            13.72709,
                            48.51302
                        ],
                        [
                            13.5284,
                            48.58651
                        ],
                        [
                            13.43843,
                            48.54889
                        ],
                        [
                            13.45711,
                            48.51144
                        ],
                        [
                            13.40784,
                            48.37216
                        ],
                        [
                            13.25369,
                            48.29316
                        ],
                        [
                            13.17704,
                            48.29439
                        ],
                        [
                            13.01293,
                            48.25287
                        ],
                        [
                            12.96581,
                            48.2141
                        ],
                        [
                            12.87124,
                            48.20177
                        ],
                        [
                            12.74931,
                            48.10837
                        ],
                        [
                            12.76258,
                            48.07233
                        ],
                        [
                            12.93686,
                            47.94331
                        ],
                        [
                            13.00139,
                            47.85439
                        ],
                        [
                            12.90527,
                            47.72434
                        ],
                        [
                            13.07959,
                            47.68749
                        ],
                        [
                            13.09599,
                            47.62872
                        ],
                        [
                            13.04424,
                            47.58278
                        ],
                        [
                            13.04647,
                            47.49214
                        ],
                        [
                            13.00237,
                            47.46409
                        ],
                        [
                            12.90872,
                            47.49699
                        ],
                        [
                            12.77926,
                            47.57929
                        ],
                        [
                            12.80742,
                            47.61008
                        ],
                        [
                            12.73313,
                            47.67899
                        ],
                        [
                            12.60463,
                            47.67316
                        ],
                        [
                            12.49962,
                            47.62527
                        ],
                        [
                            12.42732,
                            47.69585
                        ],
                        [
                            12.36556,
                            47.68412
                        ],
                        [
                            12.18324,
                            47.70073
                        ],
                        [
                            12.20772,
                            47.61457
                        ],
                        [
                            12.00893,
                            47.62459
                        ],
                        [
                            11.77517,
                            47.59039
                        ],
                        [
                            11.60697,
                            47.58099
                        ],
                        [
                            11.57179,
                            47.51459
                        ],
                        [
                            11.44932,
                            47.50723
                        ],
                        [
                            11.27085,
                            47.39777
                        ],
                        [
                            11.20602,
                            47.43341
                        ],
                        [
                            11.10025,
                            47.39476
                        ],
                        [
                            10.98235,
                            47.43084
                        ],
                        [
                            10.89024,
                            47.53622
                        ],
                        [
                            10.77835,
                            47.51482
                        ],
                        [
                            10.69062,
                            47.5581
                        ],
                        [
                            10.57378,
                            47.53482
                        ],
                        [
                            10.45444,
                            47.5558
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "AZE",
                "Country": "Azerbaijan",
                "Total_3GHG": 0.14,
                "Total_3GHG_timeseries": [
                    1.1635e-06,
                    2.3225e-06,
                    3.48e-06,
                    4.6372e-06,
                    5.7925e-06,
                    6.9483e-06,
                    8.107e-06,
                    9.2665e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022
                ],
                "Fossil_3GHG": 0.16,
                "Fossil_3GHG_timeseries": [
                    7.7517e-08,
                    1.5561e-07,
                    2.3427e-07,
                    3.1349e-07,
                    3.9328e-07,
                    4.7363e-07,
                    5.5454e-07,
                    6.36e-07,
                    7.1823e-07,
                    8.0532e-07,
                    8.9689e-07,
                    9.9136e-07,
                    1.0895e-06,
                    1.1917e-06,
                    1.2975e-06,
                    1.4187e-06,
                    1.5463e-06,
                    1.6743e-06,
                    1.811e-06,
                    1.9529e-06,
                    2.1063e-06,
                    2.2641e-06,
                    2.4239e-06,
                    2.5942e-06,
                    2.7743e-06,
                    2.9692e-06,
                    3.17e-06,
                    3.3916e-06,
                    3.6194e-06,
                    3.8636e-06,
                    4.1156e-06,
                    4.3745e-06,
                    4.6486e-06,
                    4.9303e-06,
                    5.2265e-06,
                    5.5274e-06,
                    5.8408e-06,
                    6.1629e-06,
                    6.4969e-06,
                    6.8571e-06,
                    7.242e-06,
                    7.6398e-06,
                    8.0776e-06,
                    8.5162e-06,
                    9.0038e-06,
                    9.4957e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017
                ],
                "Land_3GHG": 0.09,
                "Land_3GHG_timeseries": [
                    1.086e-06,
                    2.1669e-06,
                    3.2457e-06,
                    4.3237e-06,
                    5.3992e-06,
                    6.4747e-06,
                    7.5524e-06,
                    8.6305e-06,
                    9.7028e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Total_CO2": 0.12,
                "Total_CO2_timeseries": [
                    9.4172e-07,
                    1.877e-06,
                    2.8088e-06,
                    3.7386e-06,
                    4.6649e-06,
                    5.59e-06,
                    6.5166e-06,
                    7.4428e-06,
                    8.3626e-06,
                    9.2963e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014
                ],
                "Fossil_CO2": 0.15,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    4.039e-09,
                    9.1696e-09,
                    1.3798e-08,
                    1.8644e-08,
                    2.408e-08,
                    2.9276e-08,
                    4.5693e-08,
                    6.4534e-08,
                    8.0209e-08,
                    1.0147e-07,
                    1.2455e-07,
                    1.557e-07,
                    1.8769e-07,
                    2.177e-07,
                    2.5414e-07,
                    2.9608e-07,
                    3.4815e-07,
                    4.0128e-07,
                    4.7073e-07,
                    5.4199e-07,
                    6.2558e-07,
                    7.1363e-07,
                    8.0637e-07,
                    9.1192e-07,
                    1.0191e-06,
                    1.1358e-06,
                    1.2555e-06,
                    1.3822e-06,
                    1.5144e-06,
                    1.6571e-06,
                    1.8187e-06,
                    1.9967e-06,
                    2.185e-06,
                    2.4058e-06,
                    2.6307e-06,
                    2.889e-06,
                    3.1521e-06,
                    3.4562e-06,
                    3.7973e-06,
                    4.1929e-06,
                    4.6411e-06,
                    5.1013e-06,
                    5.5458e-06,
                    5.9805e-06,
                    6.4642e-06,
                    6.896e-06,
                    7.3884e-06,
                    7.9401e-06,
                    8.4951e-06,
                    9.0809e-06,
                    9.6555e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011
                ],
                "Land_CO2": 0.07,
                "Land_CO2_timeseries": [
                    9.4172e-07,
                    1.877e-06,
                    2.8088e-06,
                    3.7386e-06,
                    4.6649e-06,
                    5.59e-06,
                    6.5166e-06,
                    7.4428e-06,
                    8.3626e-06,
                    9.2922e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Total_CH4": 0.18,
                "Total_CH4_timeseries": [
                    1.1679e-07,
                    2.338e-07,
                    3.5104e-07,
                    4.6851e-07,
                    5.862e-07,
                    7.0413e-07,
                    8.2228e-07,
                    9.4067e-07,
                    1.0595e-06,
                    1.1789e-06,
                    1.3076e-06,
                    1.4455e-06,
                    1.5929e-06,
                    1.7496e-06,
                    1.9161e-06,
                    2.0926e-06,
                    2.2791e-06,
                    2.4749e-06,
                    2.6799e-06,
                    2.8941e-06,
                    3.1181e-06,
                    3.3521e-06,
                    3.5964e-06,
                    3.8509e-06,
                    4.1159e-06,
                    4.3918e-06,
                    4.6788e-06,
                    4.9764e-06,
                    5.2848e-06,
                    5.6035e-06,
                    5.9268e-06,
                    6.2536e-06,
                    6.5839e-06,
                    6.9215e-06,
                    7.2652e-06,
                    7.6118e-06,
                    7.9652e-06,
                    8.323e-06,
                    8.6835e-06,
                    9.0522e-06,
                    9.4306e-06,
                    9.8127e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Fossil_CH4": 0.22,
                "Fossil_CH4_timeseries": [
                    3.4935e-08,
                    6.9992e-08,
                    1.0517e-07,
                    1.4047e-07,
                    1.759e-07,
                    2.1146e-07,
                    2.4714e-07,
                    2.8294e-07,
                    3.1911e-07,
                    3.557e-07,
                    3.9527e-07,
                    4.3785e-07,
                    4.8348e-07,
                    5.3216e-07,
                    5.8439e-07,
                    6.4024e-07,
                    6.9983e-07,
                    7.6244e-07,
                    8.2791e-07,
                    8.9625e-07,
                    9.6757e-07,
                    1.042e-06,
                    1.1198e-06,
                    1.201e-06,
                    1.2859e-06,
                    1.3748e-06,
                    1.4678e-06,
                    1.5647e-06,
                    1.6655e-06,
                    1.7697e-06,
                    1.8769e-06,
                    1.9859e-06,
                    2.0968e-06,
                    2.2133e-06,
                    2.3343e-06,
                    2.4565e-06,
                    2.5839e-06,
                    2.7141e-06,
                    2.8452e-06,
                    2.9829e-06,
                    3.1286e-06,
                    3.2762e-06,
                    3.4309e-06,
                    3.5818e-06,
                    3.7477e-06,
                    3.9127e-06,
                    4.0847e-06,
                    4.2646e-06,
                    4.4487e-06,
                    4.6451e-06,
                    4.8495e-06,
                    5.047e-06,
                    5.2341e-06,
                    5.4197e-06,
                    5.5792e-06,
                    5.7458e-06,
                    5.9111e-06,
                    6.0753e-06,
                    6.245e-06,
                    6.4128e-06,
                    6.5784e-06,
                    6.7528e-06,
                    6.9275e-06,
                    7.1164e-06,
                    7.3059e-06,
                    7.5096e-06,
                    7.703e-06,
                    7.846e-06,
                    7.9987e-06,
                    8.141e-06,
                    8.2807e-06,
                    8.4429e-06,
                    8.6277e-06,
                    8.82e-06,
                    9.0449e-06,
                    9.2853e-06,
                    9.5469e-06,
                    9.8151e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006
                ],
                "Land_CH4": 0.12,
                "Land_CH4_timeseries": [
                    8.1853e-08,
                    1.6381e-07,
                    2.4587e-07,
                    3.2803e-07,
                    4.103e-07,
                    4.9267e-07,
                    5.7515e-07,
                    6.5772e-07,
                    7.4041e-07,
                    8.2319e-07,
                    9.1228e-07,
                    1.0077e-06,
                    1.1094e-06,
                    1.2174e-06,
                    1.3317e-06,
                    1.4523e-06,
                    1.5793e-06,
                    1.7125e-06,
                    1.852e-06,
                    1.9979e-06,
                    2.1506e-06,
                    2.3101e-06,
                    2.4766e-06,
                    2.6499e-06,
                    2.83e-06,
                    3.0171e-06,
                    3.2109e-06,
                    3.4117e-06,
                    3.6193e-06,
                    3.8338e-06,
                    4.0499e-06,
                    4.2677e-06,
                    4.4871e-06,
                    4.7082e-06,
                    4.9309e-06,
                    5.1553e-06,
                    5.3813e-06,
                    5.609e-06,
                    5.8383e-06,
                    6.0693e-06,
                    6.302e-06,
                    6.5365e-06,
                    6.7728e-06,
                    7.0109e-06,
                    7.2508e-06,
                    7.4924e-06,
                    7.7358e-06,
                    7.981e-06,
                    8.228e-06,
                    8.4767e-06,
                    8.7274e-06,
                    8.9799e-06,
                    9.2344e-06,
                    9.4908e-06,
                    9.7491e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Total_N2O": 0.12,
                "Total_N2O_timeseries": [
                    1.0502e-07,
                    2.1174e-07,
                    3.201e-07,
                    4.3003e-07,
                    5.4142e-07,
                    6.5415e-07,
                    7.6809e-07,
                    8.8308e-07,
                    9.9891e-07,
                    1.1154e-06,
                    1.2324e-06,
                    1.3499e-06,
                    1.4678e-06,
                    1.5862e-06,
                    1.7051e-06,
                    1.8243e-06,
                    1.9441e-06,
                    2.0642e-06,
                    2.1849e-06,
                    2.3061e-06,
                    2.429e-06,
                    2.5553e-06,
                    2.6867e-06,
                    2.824e-06,
                    2.9679e-06,
                    3.1185e-06,
                    3.2756e-06,
                    3.4382e-06,
                    3.6054e-06,
                    3.7755e-06,
                    3.9474e-06,
                    4.1208e-06,
                    4.2957e-06,
                    4.4717e-06,
                    4.649e-06,
                    4.8274e-06,
                    5.0069e-06,
                    5.1875e-06,
                    5.3694e-06,
                    5.5547e-06,
                    5.7424e-06,
                    5.9326e-06,
                    6.1252e-06,
                    6.32e-06,
                    6.517e-06,
                    6.7159e-06,
                    6.9166e-06,
                    7.1187e-06,
                    7.3222e-06,
                    7.5266e-06,
                    7.7319e-06,
                    7.9379e-06,
                    8.1446e-06,
                    8.3521e-06,
                    8.5602e-06,
                    8.7691e-06,
                    8.9788e-06,
                    9.1892e-06,
                    9.4004e-06,
                    9.6124e-06,
                    9.8269e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_N2O": 0.1,
                "Fossil_N2O_timeseries": [
                    4.2582e-08,
                    8.5614e-08,
                    1.2909e-07,
                    1.7302e-07,
                    2.1738e-07,
                    2.6218e-07,
                    3.074e-07,
                    3.5305e-07,
                    3.9911e-07,
                    4.4558e-07,
                    4.9245e-07,
                    5.3971e-07,
                    5.8737e-07,
                    6.3543e-07,
                    6.8388e-07,
                    7.3273e-07,
                    7.8198e-07,
                    8.3162e-07,
                    8.8166e-07,
                    9.321e-07,
                    9.8299e-07,
                    1.0344e-06,
                    1.0864e-06,
                    1.139e-06,
                    1.1923e-06,
                    1.2463e-06,
                    1.3009e-06,
                    1.3561e-06,
                    1.4119e-06,
                    1.4682e-06,
                    1.525e-06,
                    1.5822e-06,
                    1.6398e-06,
                    1.6979e-06,
                    1.7564e-06,
                    1.8153e-06,
                    1.8746e-06,
                    1.9344e-06,
                    1.9946e-06,
                    2.0555e-06,
                    2.1168e-06,
                    2.1786e-06,
                    2.2409e-06,
                    2.3037e-06,
                    2.3671e-06,
                    2.4309e-06,
                    2.4953e-06,
                    2.5602e-06,
                    2.6256e-06,
                    2.6916e-06,
                    2.7582e-06,
                    2.8253e-06,
                    2.893e-06,
                    2.9614e-06,
                    3.0304e-06,
                    3.1e-06,
                    3.1703e-06,
                    3.2412e-06,
                    3.3127e-06,
                    3.3848e-06,
                    3.4574e-06,
                    3.5307e-06,
                    3.6044e-06,
                    3.6787e-06,
                    3.7536e-06,
                    3.8289e-06,
                    3.9049e-06,
                    3.9814e-06,
                    4.0585e-06,
                    4.1362e-06,
                    4.2146e-06,
                    4.294e-06,
                    4.3744e-06,
                    4.4559e-06,
                    4.5388e-06,
                    4.6232e-06,
                    4.709e-06,
                    4.7965e-06,
                    4.8857e-06,
                    4.9765e-06,
                    5.0694e-06,
                    5.1648e-06,
                    5.2631e-06,
                    5.3646e-06,
                    5.4695e-06,
                    5.578e-06,
                    5.6902e-06,
                    5.8059e-06,
                    5.925e-06,
                    6.0474e-06,
                    6.1729e-06,
                    6.3016e-06,
                    6.4335e-06,
                    6.5688e-06,
                    6.7075e-06,
                    6.8499e-06,
                    6.996e-06,
                    7.1459e-06,
                    7.2999e-06,
                    7.4582e-06,
                    7.6216e-06,
                    7.792e-06,
                    7.9704e-06,
                    8.1574e-06,
                    8.3533e-06,
                    8.5577e-06,
                    8.7698e-06,
                    8.9884e-06,
                    9.2117e-06,
                    9.4375e-06,
                    9.664e-06,
                    9.8903e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.13,
                "Land_N2O_timeseries": [
                    6.2438e-08,
                    1.2612e-07,
                    1.9101e-07,
                    2.5701e-07,
                    3.2404e-07,
                    3.9198e-07,
                    4.6069e-07,
                    5.3002e-07,
                    5.998e-07,
                    6.6981e-07,
                    7.3995e-07,
                    8.1017e-07,
                    8.8046e-07,
                    9.508e-07,
                    1.0212e-06,
                    1.0916e-06,
                    1.1621e-06,
                    1.2326e-06,
                    1.3033e-06,
                    1.374e-06,
                    1.446e-06,
                    1.5209e-06,
                    1.6003e-06,
                    1.685e-06,
                    1.7756e-06,
                    1.8722e-06,
                    1.9746e-06,
                    2.0821e-06,
                    2.1935e-06,
                    2.3073e-06,
                    2.4224e-06,
                    2.5386e-06,
                    2.6558e-06,
                    2.7739e-06,
                    2.8926e-06,
                    3.0121e-06,
                    3.1322e-06,
                    3.2531e-06,
                    3.3748e-06,
                    3.4992e-06,
                    3.6257e-06,
                    3.754e-06,
                    3.8843e-06,
                    4.0163e-06,
                    4.1499e-06,
                    4.285e-06,
                    4.4213e-06,
                    4.5586e-06,
                    4.6966e-06,
                    4.835e-06,
                    4.9737e-06,
                    5.1126e-06,
                    5.2516e-06,
                    5.3906e-06,
                    5.5298e-06,
                    5.6691e-06,
                    5.8085e-06,
                    5.948e-06,
                    6.0877e-06,
                    6.2276e-06,
                    6.3695e-06,
                    6.5158e-06,
                    6.6689e-06,
                    6.83e-06,
                    7e-06,
                    7.1793e-06,
                    7.3672e-06,
                    7.5629e-06,
                    7.7647e-06,
                    7.9703e-06,
                    8.1783e-06,
                    8.3886e-06,
                    8.6011e-06,
                    8.8156e-06,
                    9.0318e-06,
                    9.2496e-06,
                    9.4686e-06,
                    9.6886e-06,
                    9.9091e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                48.58352,
                                41.83464
                            ],
                            [
                                48.55571,
                                41.78287
                            ],
                            [
                                48.42476,
                                41.66015
                            ],
                            [
                                48.402,
                                41.61279
                            ],
                            [
                                48.19196,
                                41.50316
                            ],
                            [
                                48.05414,
                                41.49169
                            ],
                            [
                                47.98712,
                                41.38755
                            ],
                            [
                                47.94188,
                                41.36107
                            ],
                            [
                                47.89229,
                                41.2268
                            ],
                            [
                                47.71969,
                                41.19793
                            ],
                            [
                                47.61257,
                                41.23556
                            ],
                            [
                                47.53703,
                                41.20719
                            ],
                            [
                                47.48402,
                                41.26635
                            ],
                            [
                                47.40423,
                                41.26661
                            ],
                            [
                                47.26188,
                                41.32741
                            ],
                            [
                                47.2269,
                                41.44189
                            ],
                            [
                                47.1001,
                                41.58659
                            ],
                            [
                                47.00948,
                                41.55705
                            ],
                            [
                                46.8953,
                                41.73132
                            ],
                            [
                                46.78226,
                                41.78459
                            ],
                            [
                                46.76165,
                                41.85155
                            ],
                            [
                                46.57972,
                                41.80755
                            ],
                            [
                                46.53991,
                                41.87105
                            ],
                            [
                                46.4205,
                                41.90428
                            ],
                            [
                                46.3985,
                                41.84419
                            ],
                            [
                                46.29853,
                                41.77697
                            ],
                            [
                                46.20265,
                                41.7671
                            ],
                            [
                                46.1795,
                                41.71722
                            ],
                            [
                                46.20734,
                                41.61616
                            ],
                            [
                                46.30003,
                                41.57096
                            ],
                            [
                                46.33488,
                                41.5011
                            ],
                            [
                                46.41399,
                                41.47843
                            ],
                            [
                                46.50917,
                                41.41565
                            ],
                            [
                                46.63742,
                                41.37928
                            ],
                            [
                                46.72663,
                                41.29058
                            ],
                            [
                                46.66005,
                                41.20511
                            ],
                            [
                                46.65737,
                                41.1309
                            ],
                            [
                                46.45544,
                                41.09876
                            ],
                            [
                                46.37301,
                                41.10637
                            ],
                            [
                                46.27558,
                                41.18804
                            ],
                            [
                                46.13132,
                                41.19997
                            ],
                            [
                                45.94892,
                                41.18067
                            ],
                            [
                                45.80669,
                                41.22444
                            ],
                            [
                                45.7048,
                                41.29807
                            ],
                            [
                                45.73651,
                                41.33913
                            ],
                            [
                                45.45903,
                                41.45444
                            ],
                            [
                                45.39721,
                                41.42797
                            ],
                            [
                                45.31341,
                                41.46946
                            ],
                            [
                                45.16743,
                                41.40825
                            ],
                            [
                                45.01315,
                                41.29661
                            ],
                            [
                                45.04365,
                                41.25201
                            ],
                            [
                                45.01537,
                                41.19659
                            ],
                            [
                                45.13278,
                                41.20594
                            ],
                            [
                                45.17784,
                                41.13195
                            ],
                            [
                                45.08581,
                                41.11452
                            ],
                            [
                                45.09495,
                                41.06027
                            ],
                            [
                                45.4009,
                                41.02744
                            ],
                            [
                                45.52553,
                                40.91267
                            ],
                            [
                                45.59146,
                                40.89221
                            ],
                            [
                                45.5674,
                                40.82318
                            ],
                            [
                                45.41187,
                                40.7385
                            ],
                            [
                                45.35904,
                                40.67141
                            ],
                            [
                                45.37169,
                                40.62218
                            ],
                            [
                                45.44884,
                                40.58617
                            ],
                            [
                                45.43797,
                                40.51258
                            ],
                            [
                                45.54465,
                                40.46932
                            ],
                            [
                                45.64289,
                                40.3722
                            ],
                            [
                                45.75554,
                                40.34767
                            ],
                            [
                                45.84962,
                                40.29757
                            ],
                            [
                                45.91353,
                                40.29684
                            ],
                            [
                                45.97669,
                                40.21307
                            ],
                            [
                                45.95629,
                                40.14957
                            ],
                            [
                                45.90499,
                                40.11069
                            ],
                            [
                                45.88482,
                                40.03159
                            ],
                            [
                                45.81235,
                                40.00093
                            ],
                            [
                                45.75515,
                                40.03081
                            ],
                            [
                                45.63609,
                                40.03969
                            ],
                            [
                                45.63346,
                                39.97471
                            ],
                            [
                                45.80682,
                                39.92999
                            ],
                            [
                                45.82903,
                                39.83591
                            ],
                            [
                                45.99602,
                                39.77839
                            ],
                            [
                                46.04052,
                                39.72009
                            ],
                            [
                                46.1649,
                                39.6424
                            ],
                            [
                                46.17588,
                                39.58812
                            ],
                            [
                                46.37209,
                                39.63749
                            ],
                            [
                                46.44513,
                                39.57315
                            ],
                            [
                                46.56174,
                                39.56818
                            ],
                            [
                                46.45381,
                                39.44932
                            ],
                            [
                                46.38705,
                                39.42424
                            ],
                            [
                                46.42797,
                                39.35679
                            ],
                            [
                                46.53584,
                                39.31239
                            ],
                            [
                                46.59202,
                                39.22759
                            ],
                            [
                                46.49289,
                                39.18726
                            ],
                            [
                                46.43992,
                                39.18983
                            ],
                            [
                                46.55202,
                                39.04805
                            ],
                            [
                                46.51486,
                                38.94368
                            ],
                            [
                                46.5458,
                                38.8781
                            ],
                            [
                                46.65524,
                                38.9548
                            ],
                            [
                                46.6936,
                                39.01403
                            ],
                            [
                                46.87184,
                                39.13888
                            ],
                            [
                                46.95053,
                                39.14126
                            ],
                            [
                                47.05555,
                                39.19616
                            ],
                            [
                                47.08153,
                                39.26544
                            ],
                            [
                                47.31749,
                                39.37501
                            ],
                            [
                                47.38916,
                                39.46795
                            ],
                            [
                                47.53096,
                                39.49922
                            ],
                            [
                                47.67064,
                                39.57873
                            ],
                            [
                                47.75012,
                                39.60435
                            ],
                            [
                                47.80958,
                                39.65711
                            ],
                            [
                                47.91793,
                                39.66159
                            ],
                            [
                                47.98661,
                                39.70629
                            ],
                            [
                                48.14587,
                                39.59078
                            ],
                            [
                                48.34869,
                                39.4048
                            ],
                            [
                                48.36364,
                                39.37096
                            ],
                            [
                                48.20758,
                                39.32569
                            ],
                            [
                                48.13798,
                                39.27175
                            ],
                            [
                                48.14593,
                                39.20396
                            ],
                            [
                                48.24115,
                                39.12925
                            ],
                            [
                                48.3071,
                                39.1103
                            ],
                            [
                                48.34138,
                                39.0281
                            ],
                            [
                                48.27371,
                                38.96912
                            ],
                            [
                                48.08398,
                                38.93747
                            ],
                            [
                                48.01674,
                                38.89276
                            ],
                            [
                                48.02348,
                                38.84374
                            ],
                            [
                                48.11481,
                                38.77287
                            ],
                            [
                                48.24989,
                                38.72594
                            ],
                            [
                                48.25704,
                                38.6627
                            ],
                            [
                                48.31568,
                                38.60564
                            ],
                            [
                                48.4526,
                                38.60907
                            ],
                            [
                                48.58593,
                                38.45359
                            ],
                            [
                                48.66785,
                                38.39374
                            ],
                            [
                                48.79315,
                                38.44686
                            ],
                            [
                                48.88781,
                                38.44117
                            ],
                            [
                                48.86635,
                                38.7422
                            ],
                            [
                                48.83123,
                                38.85783
                            ],
                            [
                                48.88486,
                                38.87411
                            ],
                            [
                                48.95285,
                                39.02216
                            ],
                            [
                                48.93395,
                                39.11031
                            ],
                            [
                                48.96561,
                                39.17578
                            ],
                            [
                                49.04371,
                                39.17719
                            ],
                            [
                                49.08317,
                                39.10195
                            ],
                            [
                                49.14553,
                                39.09286
                            ],
                            [
                                49.08301,
                                38.96204
                            ],
                            [
                                49.20119,
                                39.02368
                            ],
                            [
                                49.23883,
                                39.14688
                            ],
                            [
                                49.23813,
                                39.27471
                            ],
                            [
                                49.31177,
                                39.33896
                            ],
                            [
                                49.37523,
                                39.29075
                            ],
                            [
                                49.41139,
                                39.3838
                            ],
                            [
                                49.28142,
                                39.49773
                            ],
                            [
                                49.31359,
                                39.61117
                            ],
                            [
                                49.41972,
                                39.72067
                            ],
                            [
                                49.39397,
                                39.77417
                            ],
                            [
                                49.44093,
                                39.87619
                            ],
                            [
                                49.42099,
                                39.92785
                            ],
                            [
                                49.47732,
                                39.9983
                            ],
                            [
                                49.42772,
                                40.04288
                            ],
                            [
                                49.49627,
                                40.08947
                            ],
                            [
                                49.48649,
                                40.14593
                            ],
                            [
                                49.56684,
                                40.20786
                            ],
                            [
                                49.70498,
                                40.25847
                            ],
                            [
                                49.8206,
                                40.28126
                            ],
                            [
                                49.8801,
                                40.35973
                            ],
                            [
                                49.98229,
                                40.31871
                            ],
                            [
                                50.12411,
                                40.35601
                            ],
                            [
                                50.26015,
                                40.32759
                            ],
                            [
                                50.36734,
                                40.28378
                            ],
                            [
                                50.3594,
                                40.36652
                            ],
                            [
                                50.23949,
                                40.48437
                            ],
                            [
                                50.13286,
                                40.50708
                            ],
                            [
                                50.03208,
                                40.57373
                            ],
                            [
                                49.97424,
                                40.5869
                            ],
                            [
                                49.82561,
                                40.56083
                            ],
                            [
                                49.69282,
                                40.5832
                            ],
                            [
                                49.58116,
                                40.62142
                            ],
                            [
                                49.50819,
                                40.69402
                            ],
                            [
                                49.53741,
                                40.7655
                            ],
                            [
                                49.49041,
                                40.82164
                            ],
                            [
                                49.42466,
                                40.83226
                            ],
                            [
                                49.25095,
                                40.9856
                            ],
                            [
                                49.19233,
                                41.06026
                            ],
                            [
                                49.15519,
                                41.14968
                            ],
                            [
                                49.14013,
                                41.26662
                            ],
                            [
                                49.03982,
                                41.41199
                            ],
                            [
                                48.90124,
                                41.5219
                            ],
                            [
                                48.85763,
                                41.59534
                            ],
                            [
                                48.67901,
                                41.77942
                            ],
                            [
                                48.58352,
                                41.83464
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                46.14066,
                                38.84494
                            ],
                            [
                                46.15088,
                                38.88568
                            ],
                            [
                                46.10062,
                                39.02274
                            ],
                            [
                                46.03423,
                                39.08926
                            ],
                            [
                                46.0098,
                                39.15133
                            ],
                            [
                                45.99916,
                                39.29681
                            ],
                            [
                                45.79634,
                                39.40082
                            ],
                            [
                                45.84,
                                39.47028
                            ],
                            [
                                45.81799,
                                39.54572
                            ],
                            [
                                45.70769,
                                39.60647
                            ],
                            [
                                45.66953,
                                39.58136
                            ],
                            [
                                45.45702,
                                39.50435
                            ],
                            [
                                45.33145,
                                39.56004
                            ],
                            [
                                45.30372,
                                39.60086
                            ],
                            [
                                45.18605,
                                39.60815
                            ],
                            [
                                45.19273,
                                39.67793
                            ],
                            [
                                45.12802,
                                39.76291
                            ],
                            [
                                45.08199,
                                39.78547
                            ],
                            [
                                44.95345,
                                39.73004
                            ],
                            [
                                44.76834,
                                39.71415
                            ],
                            [
                                44.81204,
                                39.63174
                            ],
                            [
                                44.91277,
                                39.56698
                            ],
                            [
                                44.94408,
                                39.45776
                            ],
                            [
                                45.08443,
                                39.35106
                            ],
                            [
                                45.17208,
                                39.21392
                            ],
                            [
                                45.33058,
                                39.16517
                            ],
                            [
                                45.45449,
                                39.05173
                            ],
                            [
                                45.45362,
                                38.99279
                            ],
                            [
                                45.61754,
                                38.9431
                            ],
                            [
                                45.69316,
                                38.9497
                            ],
                            [
                                45.84993,
                                38.90883
                            ],
                            [
                                45.89589,
                                38.87799
                            ],
                            [
                                46.0639,
                                38.88627
                            ],
                            [
                                46.14066,
                                38.84494
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "BHS",
                "Country": "Bahamas",
                "Total_3GHG": 0.01,
                "Total_3GHG_timeseries": [
                    5.9571e-09,
                    1.1824e-08,
                    1.7727e-08,
                    2.3644e-08,
                    2.9602e-08,
                    3.5786e-08,
                    4.2244e-08,
                    4.8934e-08,
                    5.5878e-08,
                    6.3365e-08,
                    7.1372e-08,
                    7.9858e-08,
                    8.878e-08,
                    9.8128e-08,
                    1.0776e-07,
                    1.1768e-07,
                    1.2789e-07,
                    1.3838e-07,
                    1.4906e-07,
                    1.6011e-07,
                    1.7179e-07,
                    1.84e-07,
                    1.9654e-07,
                    2.0946e-07,
                    2.2269e-07,
                    2.3605e-07,
                    2.4952e-07,
                    2.6308e-07,
                    2.7671e-07,
                    2.9061e-07,
                    3.0459e-07,
                    3.1883e-07,
                    3.3318e-07,
                    3.4756e-07,
                    3.6199e-07,
                    3.7649e-07,
                    3.9112e-07,
                    4.0584e-07,
                    4.2075e-07,
                    4.3638e-07,
                    4.5217e-07,
                    4.6821e-07,
                    4.8452e-07,
                    5.0109e-07,
                    5.1793e-07,
                    5.3501e-07,
                    5.5237e-07,
                    5.7001e-07,
                    5.8798e-07,
                    6.0603e-07,
                    6.2473e-07,
                    6.435e-07,
                    6.627e-07,
                    6.8248e-07,
                    7.0284e-07,
                    7.2376e-07,
                    7.4499e-07,
                    7.6702e-07,
                    7.8948e-07,
                    8.1301e-07,
                    8.3783e-07,
                    8.6363e-07,
                    8.9027e-07,
                    9.1781e-07,
                    9.4605e-07,
                    9.748e-07,
                    1.004e-06,
                    1.0338e-06,
                    1.0641e-06,
                    1.0957e-06,
                    1.1283e-06,
                    1.1624e-06,
                    1.1975e-06,
                    1.2339e-06,
                    1.2715e-06,
                    1.3107e-06,
                    1.3511e-06,
                    1.3932e-06,
                    1.4371e-06,
                    1.4833e-06,
                    1.5315e-06,
                    1.5816e-06,
                    1.6335e-06,
                    1.6877e-06,
                    1.7436e-06,
                    1.8025e-06,
                    1.8634e-06,
                    1.9266e-06,
                    1.9934e-06,
                    2.0643e-06,
                    2.141e-06,
                    2.2226e-06,
                    2.3092e-06,
                    2.4007e-06,
                    2.4995e-06,
                    2.6059e-06,
                    2.7219e-06,
                    2.8446e-06,
                    2.9746e-06,
                    3.136e-06,
                    3.308e-06,
                    3.4937e-06,
                    3.6889e-06,
                    3.8947e-06,
                    4.1267e-06,
                    4.3726e-06,
                    4.6473e-06,
                    4.9334e-06,
                    5.2696e-06,
                    5.6728e-06,
                    6.1272e-06,
                    6.6745e-06,
                    7.2145e-06,
                    7.9451e-06,
                    8.7882e-06,
                    9.5403e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_3GHG": 0.01,
                "Fossil_3GHG_timeseries": [
                    4.174e-09,
                    8.1947e-09,
                    1.2217e-08,
                    1.624e-08,
                    2.0264e-08,
                    2.4506e-08,
                    2.8969e-08,
                    3.3659e-08,
                    3.8579e-08,
                    4.3733e-08,
                    4.9172e-08,
                    5.4887e-08,
                    6.0891e-08,
                    6.7178e-08,
                    7.3618e-08,
                    8.021e-08,
                    8.6955e-08,
                    9.3854e-08,
                    1.0085e-07,
                    1.0793e-07,
                    1.1544e-07,
                    1.2331e-07,
                    1.3139e-07,
                    1.3969e-07,
                    1.4818e-07,
                    1.5667e-07,
                    1.6515e-07,
                    1.7359e-07,
                    1.8198e-07,
                    1.9032e-07,
                    1.9856e-07,
                    2.0695e-07,
                    2.1536e-07,
                    2.2366e-07,
                    2.3193e-07,
                    2.4016e-07,
                    2.4841e-07,
                    2.5667e-07,
                    2.6503e-07,
                    2.7383e-07,
                    2.8266e-07,
                    2.9161e-07,
                    3.0071e-07,
                    3.0994e-07,
                    3.193e-07,
                    3.2879e-07,
                    3.3841e-07,
                    3.4819e-07,
                    3.5816e-07,
                    3.6789e-07,
                    3.779e-07,
                    3.88e-07,
                    3.9826e-07,
                    4.0883e-07,
                    4.1977e-07,
                    4.3107e-07,
                    4.4267e-07,
                    4.546e-07,
                    4.6681e-07,
                    4.79e-07,
                    4.917e-07,
                    5.0483e-07,
                    5.1838e-07,
                    5.3222e-07,
                    5.4636e-07,
                    5.608e-07,
                    5.7553e-07,
                    5.9055e-07,
                    6.0581e-07,
                    6.2172e-07,
                    6.3791e-07,
                    6.5467e-07,
                    6.7186e-07,
                    6.8939e-07,
                    7.0728e-07,
                    7.2574e-07,
                    7.4469e-07,
                    7.6421e-07,
                    7.8428e-07,
                    8.0502e-07,
                    8.2643e-07,
                    8.4834e-07,
                    8.7072e-07,
                    8.9356e-07,
                    9.1687e-07,
                    9.4067e-07,
                    9.6489e-07,
                    9.8975e-07,
                    1.0154e-06,
                    1.0417e-06,
                    1.0702e-06,
                    1.1008e-06,
                    1.1331e-06,
                    1.1675e-06,
                    1.205e-06,
                    1.2462e-06,
                    1.2913e-06,
                    1.3401e-06,
                    1.393e-06,
                    1.4751e-06,
                    1.5645e-06,
                    1.6617e-06,
                    1.7634e-06,
                    1.8699e-06,
                    2.0002e-06,
                    2.1393e-06,
                    2.2996e-06,
                    2.4663e-06,
                    2.6752e-06,
                    2.9591e-06,
                    3.31e-06,
                    3.7488e-06,
                    4.1866e-06,
                    4.8048e-06,
                    5.536e-06,
                    6.1733e-06,
                    7.0948e-06,
                    7.9926e-06,
                    8.9532e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [
                    1.7831e-09,
                    3.629e-09,
                    5.51e-09,
                    7.4042e-09,
                    9.3389e-09,
                    1.1281e-08,
                    1.3274e-08,
                    1.5275e-08,
                    1.7298e-08,
                    1.9631e-08,
                    2.22e-08,
                    2.4971e-08,
                    2.7889e-08,
                    3.095e-08,
                    3.4141e-08,
                    3.7474e-08,
                    4.0933e-08,
                    4.4523e-08,
                    4.8216e-08,
                    5.2183e-08,
                    5.6353e-08,
                    6.0689e-08,
                    6.5155e-08,
                    6.9772e-08,
                    7.4503e-08,
                    7.9377e-08,
                    8.437e-08,
                    8.9493e-08,
                    9.4728e-08,
                    1.0029e-07,
                    1.0603e-07,
                    1.1188e-07,
                    1.1782e-07,
                    1.2389e-07,
                    1.3006e-07,
                    1.3634e-07,
                    1.4271e-07,
                    1.4917e-07,
                    1.5572e-07,
                    1.6255e-07,
                    1.6951e-07,
                    1.766e-07,
                    1.8381e-07,
                    1.9115e-07,
                    1.9863e-07,
                    2.0622e-07,
                    2.1396e-07,
                    2.2182e-07,
                    2.2982e-07,
                    2.3814e-07,
                    2.4683e-07,
                    2.555e-07,
                    2.6444e-07,
                    2.7365e-07,
                    2.8307e-07,
                    2.9269e-07,
                    3.0231e-07,
                    3.1241e-07,
                    3.2266e-07,
                    3.3401e-07,
                    3.4613e-07,
                    3.588e-07,
                    3.719e-07,
                    3.8558e-07,
                    3.9969e-07,
                    4.1399e-07,
                    4.2847e-07,
                    4.4329e-07,
                    4.5832e-07,
                    4.7398e-07,
                    4.9037e-07,
                    5.077e-07,
                    5.2562e-07,
                    5.4447e-07,
                    5.6424e-07,
                    5.85e-07,
                    6.0642e-07,
                    6.2904e-07,
                    6.5284e-07,
                    6.7832e-07,
                    7.0507e-07,
                    7.333e-07,
                    7.6281e-07,
                    7.9409e-07,
                    8.2675e-07,
                    8.6181e-07,
                    8.9849e-07,
                    9.3681e-07,
                    9.7802e-07,
                    1.0226e-06,
                    1.0708e-06,
                    1.1218e-06,
                    1.1761e-06,
                    1.2332e-06,
                    1.2945e-06,
                    1.3597e-06,
                    1.4306e-06,
                    1.5045e-06,
                    1.5816e-06,
                    1.6609e-06,
                    1.7435e-06,
                    1.8321e-06,
                    1.9256e-06,
                    2.0248e-06,
                    2.1265e-06,
                    2.2333e-06,
                    2.3477e-06,
                    2.4671e-06,
                    2.5944e-06,
                    2.7137e-06,
                    2.8171e-06,
                    2.9257e-06,
                    3.0279e-06,
                    3.1402e-06,
                    3.2522e-06,
                    3.367e-06,
                    3.4701e-06,
                    3.5741e-06,
                    3.6806e-06,
                    3.7747e-06,
                    3.8605e-06,
                    3.9433e-06,
                    4.0123e-06,
                    4.0491e-06,
                    4.0688e-06,
                    4.074e-06,
                    4.0676e-06,
                    4.0547e-06,
                    4.035e-06,
                    4.0129e-06,
                    3.9897e-06,
                    3.9683e-06,
                    3.9524e-06,
                    3.9606e-06,
                    3.9554e-06,
                    3.9426e-06,
                    3.932e-06,
                    3.9193e-06,
                    3.9053e-06,
                    3.8931e-06,
                    3.8826e-06,
                    3.8717e-06,
                    3.8641e-06,
                    3.8682e-06,
                    3.8835e-06,
                    3.9006e-06,
                    3.9168e-06,
                    3.9306e-06,
                    3.9623e-06,
                    3.9637e-06,
                    3.9555e-06,
                    3.9451e-06,
                    3.9222e-06,
                    3.9274e-06,
                    3.9176e-06,
                    3.9018e-06,
                    3.9007e-06,
                    3.9689e-06,
                    3.9978e-06,
                    3.9956e-06,
                    4.0133e-06,
                    4.0115e-06,
                    4.0239e-06,
                    4.0165e-06,
                    4.012e-06,
                    4.0103e-06,
                    4.0201e-06,
                    4.0075e-06,
                    3.9934e-06,
                    3.997e-06,
                    3.9914e-06,
                    3.9865e-06
                ],
                "Total_CO2": 0.01,
                "Total_CO2_timeseries": [
                    1.441e-09,
                    2.9425e-09,
                    4.477e-09,
                    6.0225e-09,
                    7.6065e-09,
                    9.196e-09,
                    1.0835e-08,
                    1.2479e-08,
                    1.4146e-08,
                    1.612e-08,
                    1.8304e-08,
                    2.0663e-08,
                    2.3144e-08,
                    2.574e-08,
                    2.844e-08,
                    3.1256e-08,
                    3.4172e-08,
                    3.7191e-08,
                    4.0288e-08,
                    4.3632e-08,
                    4.7146e-08,
                    5.0793e-08,
                    5.4533e-08,
                    5.8388e-08,
                    6.2321e-08,
                    6.6358e-08,
                    7.0477e-08,
                    7.469e-08,
                    7.898e-08,
                    8.3567e-08,
                    8.8314e-08,
                    9.3154e-08,
                    9.8082e-08,
                    1.0312e-07,
                    1.0824e-07,
                    1.1346e-07,
                    1.1876e-07,
                    1.2414e-07,
                    1.2959e-07,
                    1.3524e-07,
                    1.4101e-07,
                    1.4689e-07,
                    1.5287e-07,
                    1.5895e-07,
                    1.6514e-07,
                    1.7141e-07,
                    1.778e-07,
                    1.8428e-07,
                    1.9087e-07,
                    1.9774e-07,
                    2.0494e-07,
                    2.1207e-07,
                    2.1939e-07,
                    2.2692e-07,
                    2.3458e-07,
                    2.4237e-07,
                    2.501e-07,
                    2.5823e-07,
                    2.6647e-07,
                    2.7577e-07,
                    2.8576e-07,
                    2.9624e-07,
                    3.0705e-07,
                    3.1839e-07,
                    3.3007e-07,
                    3.4187e-07,
                    3.5377e-07,
                    3.6595e-07,
                    3.7827e-07,
                    3.9114e-07,
                    4.0467e-07,
                    4.1905e-07,
                    4.3393e-07,
                    4.4966e-07,
                    4.6625e-07,
                    4.8374e-07,
                    5.0183e-07,
                    5.2102e-07,
                    5.4131e-07,
                    5.6321e-07,
                    5.8629e-07,
                    6.1076e-07,
                    6.3643e-07,
                    6.6377e-07,
                    6.924e-07,
                    7.2296e-07,
                    7.5467e-07,
                    7.8753e-07,
                    8.2277e-07,
                    8.6087e-07,
                    9.0199e-07,
                    9.4519e-07,
                    9.9097e-07,
                    1.0388e-06,
                    1.0899e-06,
                    1.1442e-06,
                    1.2031e-06,
                    1.2642e-06,
                    1.3277e-06,
                    1.4173e-06,
                    1.5145e-06,
                    1.6218e-06,
                    1.7346e-06,
                    1.8536e-06,
                    1.9937e-06,
                    2.1425e-06,
                    2.3141e-06,
                    2.491e-06,
                    2.7104e-06,
                    2.9878e-06,
                    3.3133e-06,
                    3.725e-06,
                    4.1224e-06,
                    4.6983e-06,
                    5.3777e-06,
                    5.9587e-06,
                    6.8026e-06,
                    7.6167e-06,
                    8.4865e-06,
                    9.7181e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_CO2": 0.01,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2.475e-08,
                    5.445e-08,
                    8.91e-08,
                    1.254e-07,
                    1.6335e-07,
                    2.211e-07,
                    2.838e-07,
                    3.63e-07,
                    4.4385e-07,
                    5.61e-07,
                    7.458e-07,
                    9.9165e-07,
                    1.3184e-06,
                    1.6368e-06,
                    2.1252e-06,
                    2.7175e-06,
                    3.2092e-06,
                    3.9753e-06,
                    4.7083e-06,
                    5.4922e-06,
                    6.649e-06,
                    9.6769e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [
                    1.441e-09,
                    2.9425e-09,
                    4.477e-09,
                    6.0225e-09,
                    7.6065e-09,
                    9.196e-09,
                    1.0835e-08,
                    1.2479e-08,
                    1.4146e-08,
                    1.612e-08,
                    1.8304e-08,
                    2.0663e-08,
                    2.3144e-08,
                    2.574e-08,
                    2.844e-08,
                    3.1256e-08,
                    3.4172e-08,
                    3.7191e-08,
                    4.0288e-08,
                    4.3632e-08,
                    4.7146e-08,
                    5.0793e-08,
                    5.4533e-08,
                    5.8388e-08,
                    6.2321e-08,
                    6.6358e-08,
                    7.0477e-08,
                    7.469e-08,
                    7.898e-08,
                    8.3567e-08,
                    8.8314e-08,
                    9.3154e-08,
                    9.8082e-08,
                    1.0312e-07,
                    1.0824e-07,
                    1.1346e-07,
                    1.1876e-07,
                    1.2414e-07,
                    1.2959e-07,
                    1.3524e-07,
                    1.4101e-07,
                    1.4689e-07,
                    1.5287e-07,
                    1.5895e-07,
                    1.6514e-07,
                    1.7141e-07,
                    1.778e-07,
                    1.8428e-07,
                    1.9087e-07,
                    1.9774e-07,
                    2.0494e-07,
                    2.1207e-07,
                    2.1939e-07,
                    2.2692e-07,
                    2.3458e-07,
                    2.4237e-07,
                    2.501e-07,
                    2.5823e-07,
                    2.6647e-07,
                    2.7577e-07,
                    2.8576e-07,
                    2.9624e-07,
                    3.0705e-07,
                    3.1839e-07,
                    3.3007e-07,
                    3.4187e-07,
                    3.5377e-07,
                    3.6595e-07,
                    3.7827e-07,
                    3.9114e-07,
                    4.0467e-07,
                    4.1905e-07,
                    4.3393e-07,
                    4.4966e-07,
                    4.6625e-07,
                    4.8374e-07,
                    5.0183e-07,
                    5.2102e-07,
                    5.4131e-07,
                    5.6321e-07,
                    5.8629e-07,
                    6.1076e-07,
                    6.3643e-07,
                    6.6377e-07,
                    6.924e-07,
                    7.2296e-07,
                    7.5467e-07,
                    7.8753e-07,
                    8.2277e-07,
                    8.6087e-07,
                    9.0199e-07,
                    9.4519e-07,
                    9.9097e-07,
                    1.0388e-06,
                    1.0899e-06,
                    1.1442e-06,
                    1.2031e-06,
                    1.2642e-06,
                    1.3277e-06,
                    1.3926e-06,
                    1.46e-06,
                    1.5327e-06,
                    1.6092e-06,
                    1.6903e-06,
                    1.7726e-06,
                    1.8587e-06,
                    1.9511e-06,
                    2.0471e-06,
                    2.1494e-06,
                    2.242e-06,
                    2.3216e-06,
                    2.4067e-06,
                    2.4856e-06,
                    2.5731e-06,
                    2.6602e-06,
                    2.7495e-06,
                    2.8273e-06,
                    2.9085e-06,
                    2.9943e-06,
                    3.0692e-06,
                    3.1364e-06,
                    3.2022e-06,
                    3.2551e-06,
                    3.2832e-06,
                    3.2963e-06,
                    3.2948e-06,
                    3.2833e-06,
                    3.2693e-06,
                    3.2513e-06,
                    3.2323e-06,
                    3.2094e-06,
                    3.1891e-06,
                    3.1746e-06,
                    3.1859e-06,
                    3.184e-06,
                    3.1747e-06,
                    3.1678e-06,
                    3.1573e-06,
                    3.1437e-06,
                    3.1304e-06,
                    3.1198e-06,
                    3.1074e-06,
                    3.0984e-06,
                    3.0973e-06,
                    3.1028e-06,
                    3.1082e-06,
                    3.1143e-06,
                    3.1086e-06,
                    3.1214e-06,
                    3.1131e-06,
                    3.0979e-06,
                    3.0796e-06,
                    3.0569e-06,
                    3.0312e-06,
                    3.0075e-06,
                    2.9835e-06,
                    2.9712e-06,
                    3.0128e-06,
                    3.031e-06,
                    3.0282e-06,
                    3.0208e-06,
                    3.0114e-06,
                    3.0005e-06,
                    2.9865e-06,
                    2.9716e-06,
                    2.9581e-06,
                    2.9457e-06,
                    2.9324e-06,
                    2.9205e-06,
                    2.9099e-06,
                    2.8964e-06,
                    2.8848e-06
                ],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [
                    9.7444e-10,
                    1.761e-09,
                    2.514e-09,
                    3.2338e-09,
                    3.9203e-09,
                    4.7908e-09,
                    5.8493e-09,
                    7.1004e-09,
                    8.5483e-09,
                    1.0198e-08,
                    1.2125e-08,
                    1.4321e-08,
                    1.6799e-08,
                    1.9553e-08,
                    2.2453e-08,
                    2.5499e-08,
                    2.8691e-08,
                    3.2029e-08,
                    3.5453e-08,
                    3.8962e-08,
                    4.2894e-08,
                    4.7174e-08,
                    5.1659e-08,
                    5.6348e-08,
                    6.1221e-08,
                    6.6072e-08,
                    7.09e-08,
                    7.5676e-08,
                    8.0395e-08,
                    8.5054e-08,
                    8.9594e-08,
                    9.4258e-08,
                    9.892e-08,
                    1.0345e-07,
                    1.0793e-07,
                    1.1234e-07,
                    1.1676e-07,
                    1.2115e-07,
                    1.2563e-07,
                    1.3051e-07,
                    1.354e-07,
                    1.4038e-07,
                    1.4548e-07,
                    1.5069e-07,
                    1.5601e-07,
                    1.6143e-07,
                    1.6695e-07,
                    1.726e-07,
                    1.7841e-07,
                    1.8396e-07,
                    1.8976e-07,
                    1.9562e-07,
                    2.0161e-07,
                    2.0789e-07,
                    2.145e-07,
                    2.2145e-07,
                    2.2866e-07,
                    2.3617e-07,
                    2.4393e-07,
                    2.5164e-07,
                    2.5988e-07,
                    2.6858e-07,
                    2.7771e-07,
                    2.8717e-07,
                    2.9694e-07,
                    3.0705e-07,
                    3.1746e-07,
                    3.2818e-07,
                    3.3917e-07,
                    3.5082e-07,
                    3.6281e-07,
                    3.7541e-07,
                    3.8848e-07,
                    4.0194e-07,
                    4.158e-07,
                    4.3028e-07,
                    4.4529e-07,
                    4.6092e-07,
                    4.7714e-07,
                    4.9407e-07,
                    5.117e-07,
                    5.2986e-07,
                    5.485e-07,
                    5.6764e-07,
                    5.8727e-07,
                    6.0777e-07,
                    6.2909e-07,
                    6.5144e-07,
                    6.7504e-07,
                    6.997e-07,
                    7.2702e-07,
                    7.5696e-07,
                    7.8905e-07,
                    8.2378e-07,
                    8.6214e-07,
                    9.0473e-07,
                    9.5175e-07,
                    1.0032e-06,
                    1.0592e-06,
                    1.1203e-06,
                    1.1843e-06,
                    1.2515e-06,
                    1.3224e-06,
                    1.3973e-06,
                    1.4772e-06,
                    1.5617e-06,
                    1.6518e-06,
                    1.7477e-06,
                    1.8508e-06,
                    1.9628e-06,
                    2.0778e-06,
                    2.1995e-06,
                    2.3279e-06,
                    2.4681e-06,
                    2.6169e-06,
                    2.7721e-06,
                    2.9367e-06,
                    3.1079e-06,
                    3.2889e-06,
                    3.4526e-06,
                    3.6404e-06,
                    3.8312e-06,
                    4.0258e-06,
                    4.2186e-06,
                    4.4143e-06,
                    4.6133e-06,
                    4.8157e-06,
                    5.0196e-06,
                    5.2248e-06,
                    5.4322e-06,
                    5.6456e-06,
                    5.8607e-06,
                    6.0779e-06,
                    6.2936e-06,
                    6.5091e-06,
                    6.7265e-06,
                    6.9416e-06,
                    7.1576e-06,
                    7.3717e-06,
                    7.619e-06,
                    7.8448e-06,
                    8.0694e-06,
                    8.2941e-06,
                    8.5265e-06,
                    8.7653e-06,
                    9.0085e-06,
                    9.2502e-06,
                    9.5004e-06,
                    9.7534e-06,
                    1e-05,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_CH4": 0.01,
                "Fossil_CH4_timeseries": [
                    6.9909e-10,
                    1.2094e-09,
                    1.6853e-09,
                    2.1269e-09,
                    2.5344e-09,
                    3.125e-09,
                    3.9027e-09,
                    4.872e-09,
                    6.0373e-09,
                    7.4031e-09,
                    9.0205e-09,
                    1.088e-08,
                    1.2995e-08,
                    1.536e-08,
                    1.7845e-08,
                    2.0449e-08,
                    2.3172e-08,
                    2.6016e-08,
                    2.8918e-08,
                    3.188e-08,
                    3.5233e-08,
                    3.8904e-08,
                    4.2748e-08,
                    4.6766e-08,
                    5.0936e-08,
                    5.5055e-08,
                    5.9118e-08,
                    6.3099e-08,
                    6.6993e-08,
                    7.0795e-08,
                    7.4466e-08,
                    7.8248e-08,
                    8.2017e-08,
                    8.5645e-08,
                    8.92e-08,
                    9.2681e-08,
                    9.616e-08,
                    9.9599e-08,
                    1.0311e-07,
                    1.0701e-07,
                    1.109e-07,
                    1.1488e-07,
                    1.1896e-07,
                    1.2314e-07,
                    1.274e-07,
                    1.3176e-07,
                    1.362e-07,
                    1.4077e-07,
                    1.4547e-07,
                    1.499e-07,
                    1.5457e-07,
                    1.5927e-07,
                    1.641e-07,
                    1.6919e-07,
                    1.746e-07,
                    1.8033e-07,
                    1.8632e-07,
                    1.9258e-07,
                    1.9908e-07,
                    2.0551e-07,
                    2.124e-07,
                    2.1969e-07,
                    2.2734e-07,
                    2.3526e-07,
                    2.4342e-07,
                    2.5184e-07,
                    2.605e-07,
                    2.6941e-07,
                    2.7852e-07,
                    2.8823e-07,
                    2.9818e-07,
                    3.0865e-07,
                    3.1951e-07,
                    3.3067e-07,
                    3.4214e-07,
                    3.5414e-07,
                    3.6659e-07,
                    3.7956e-07,
                    3.9304e-07,
                    4.0714e-07,
                    4.2186e-07,
                    4.3704e-07,
                    4.5265e-07,
                    4.6867e-07,
                    4.8511e-07,
                    5.0199e-07,
                    5.1926e-07,
                    5.3711e-07,
                    5.5572e-07,
                    5.7491e-07,
                    5.9623e-07,
                    6.1962e-07,
                    6.4458e-07,
                    6.716e-07,
                    7.0164e-07,
                    7.3527e-07,
                    7.7269e-07,
                    8.1383e-07,
                    8.5891e-07,
                    9.0834e-07,
                    9.6012e-07,
                    1.0145e-06,
                    1.0717e-06,
                    1.132e-06,
                    1.1961e-06,
                    1.264e-06,
                    1.3363e-06,
                    1.4133e-06,
                    1.4961e-06,
                    1.5861e-06,
                    1.682e-06,
                    1.7849e-06,
                    1.8948e-06,
                    2.0151e-06,
                    2.1444e-06,
                    2.2802e-06,
                    2.4259e-06,
                    2.5807e-06,
                    2.7472e-06,
                    2.8979e-06,
                    3.0734e-06,
                    3.2536e-06,
                    3.4393e-06,
                    3.6295e-06,
                    3.8245e-06,
                    4.0236e-06,
                    4.2283e-06,
                    4.4374e-06,
                    4.6499e-06,
                    4.8666e-06,
                    5.0872e-06,
                    5.3098e-06,
                    5.5344e-06,
                    5.7593e-06,
                    5.9841e-06,
                    6.2111e-06,
                    6.4361e-06,
                    6.6606e-06,
                    6.8816e-06,
                    7.1342e-06,
                    7.3662e-06,
                    7.5958e-06,
                    7.8254e-06,
                    8.0582e-06,
                    8.2951e-06,
                    8.5362e-06,
                    8.7758e-06,
                    9.0179e-06,
                    9.2607e-06,
                    9.5048e-06,
                    9.7488e-06,
                    9.9942e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [
                    2.7535e-10,
                    5.5161e-10,
                    8.2879e-10,
                    1.1069e-09,
                    1.3859e-09,
                    1.6658e-09,
                    1.9467e-09,
                    2.2284e-09,
                    2.5111e-09,
                    2.7947e-09,
                    3.1046e-09,
                    3.441e-09,
                    3.8038e-09,
                    4.193e-09,
                    4.6086e-09,
                    5.0506e-09,
                    5.519e-09,
                    6.0138e-09,
                    6.535e-09,
                    7.0826e-09,
                    7.6611e-09,
                    8.2706e-09,
                    8.9109e-09,
                    9.5822e-09,
                    1.0284e-08,
                    1.1017e-08,
                    1.1782e-08,
                    1.2576e-08,
                    1.3402e-08,
                    1.4259e-08,
                    1.5128e-08,
                    1.6009e-08,
                    1.6903e-08,
                    1.7809e-08,
                    1.8727e-08,
                    1.9657e-08,
                    2.0599e-08,
                    2.1554e-08,
                    2.2521e-08,
                    2.35e-08,
                    2.4493e-08,
                    2.5501e-08,
                    2.6522e-08,
                    2.7557e-08,
                    2.8606e-08,
                    2.9669e-08,
                    3.0746e-08,
                    3.1837e-08,
                    3.2942e-08,
                    3.4061e-08,
                    3.5196e-08,
                    3.6347e-08,
                    3.7514e-08,
                    3.8698e-08,
                    3.9897e-08,
                    4.1111e-08,
                    4.2342e-08,
                    4.3589e-08,
                    4.4852e-08,
                    4.6131e-08,
                    4.7477e-08,
                    4.889e-08,
                    5.0369e-08,
                    5.1915e-08,
                    5.3528e-08,
                    5.5208e-08,
                    5.6955e-08,
                    5.8768e-08,
                    6.0649e-08,
                    6.2596e-08,
                    6.4632e-08,
                    6.6756e-08,
                    6.8968e-08,
                    7.127e-08,
                    7.3659e-08,
                    7.6138e-08,
                    7.8704e-08,
                    8.136e-08,
                    8.4103e-08,
                    8.6936e-08,
                    8.9839e-08,
                    9.2812e-08,
                    9.5857e-08,
                    9.8973e-08,
                    1.0216e-07,
                    1.0577e-07,
                    1.0982e-07,
                    1.1433e-07,
                    1.1932e-07,
                    1.2479e-07,
                    1.3079e-07,
                    1.3734e-07,
                    1.4447e-07,
                    1.5218e-07,
                    1.605e-07,
                    1.6946e-07,
                    1.7906e-07,
                    1.8933e-07,
                    2.0028e-07,
                    2.1194e-07,
                    2.2413e-07,
                    2.3699e-07,
                    2.5067e-07,
                    2.6531e-07,
                    2.8105e-07,
                    2.9771e-07,
                    3.1543e-07,
                    3.3437e-07,
                    3.5471e-07,
                    3.7662e-07,
                    3.9582e-07,
                    4.1463e-07,
                    4.3303e-07,
                    4.5296e-07,
                    4.7257e-07,
                    4.9192e-07,
                    5.1075e-07,
                    5.2719e-07,
                    5.4173e-07,
                    5.547e-07,
                    5.6703e-07,
                    5.7761e-07,
                    5.8648e-07,
                    5.8908e-07,
                    5.8984e-07,
                    5.8965e-07,
                    5.8738e-07,
                    5.8228e-07,
                    5.749e-07,
                    5.6553e-07,
                    5.5841e-07,
                    5.5094e-07,
                    5.4352e-07,
                    5.3422e-07,
                    5.2497e-07,
                    5.1544e-07,
                    5.0553e-07,
                    4.9705e-07,
                    4.9006e-07,
                    4.8479e-07,
                    4.7865e-07,
                    4.736e-07,
                    4.6874e-07,
                    4.6824e-07,
                    4.7022e-07,
                    4.7238e-07,
                    4.7433e-07,
                    4.8248e-07,
                    4.9266e-07,
                    4.9513e-07,
                    4.9458e-07,
                    4.9565e-07,
                    4.8942e-07,
                    5.0906e-07,
                    5.144e-07,
                    5.151e-07,
                    5.1821e-07,
                    5.3428e-07,
                    5.3698e-07,
                    5.311e-07,
                    5.4575e-07,
                    5.4435e-07,
                    5.5662e-07,
                    5.5483e-07,
                    5.556e-07,
                    5.5614e-07,
                    5.647e-07,
                    5.5377e-07,
                    5.431e-07,
                    5.4762e-07,
                    5.4732e-07,
                    5.4568e-07
                ],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [
                    3.5417e-09,
                    7.1202e-09,
                    1.0736e-08,
                    1.4387e-08,
                    1.8076e-08,
                    2.18e-08,
                    2.5559e-08,
                    2.9354e-08,
                    3.3183e-08,
                    3.7046e-08,
                    4.0943e-08,
                    4.4873e-08,
                    4.8837e-08,
                    5.2834e-08,
                    5.6865e-08,
                    6.0929e-08,
                    6.5026e-08,
                    6.9156e-08,
                    7.3321e-08,
                    7.7519e-08,
                    8.1753e-08,
                    8.603e-08,
                    9.0353e-08,
                    9.4724e-08,
                    9.9147e-08,
                    1.0362e-07,
                    1.0814e-07,
                    1.1272e-07,
                    1.1733e-07,
                    1.2199e-07,
                    1.2668e-07,
                    1.3141e-07,
                    1.3618e-07,
                    1.4098e-07,
                    1.4582e-07,
                    1.507e-07,
                    1.556e-07,
                    1.6055e-07,
                    1.6553e-07,
                    1.7062e-07,
                    1.7576e-07,
                    1.8094e-07,
                    1.8617e-07,
                    1.9145e-07,
                    1.9678e-07,
                    2.0217e-07,
                    2.0762e-07,
                    2.1313e-07,
                    2.187e-07,
                    2.2433e-07,
                    2.3003e-07,
                    2.3581e-07,
                    2.4169e-07,
                    2.4767e-07,
                    2.5376e-07,
                    2.5995e-07,
                    2.6624e-07,
                    2.7262e-07,
                    2.7908e-07,
                    2.856e-07,
                    2.9218e-07,
                    2.9882e-07,
                    3.055e-07,
                    3.1225e-07,
                    3.1904e-07,
                    3.2588e-07,
                    3.3277e-07,
                    3.3971e-07,
                    3.467e-07,
                    3.5373e-07,
                    3.6081e-07,
                    3.6792e-07,
                    3.7507e-07,
                    3.8225e-07,
                    3.8947e-07,
                    3.9671e-07,
                    4.0399e-07,
                    4.1131e-07,
                    4.1867e-07,
                    4.2606e-07,
                    4.3351e-07,
                    4.4102e-07,
                    4.4859e-07,
                    4.5623e-07,
                    4.6395e-07,
                    4.7175e-07,
                    4.7963e-07,
                    4.8759e-07,
                    4.9563e-07,
                    5.0376e-07,
                    5.1201e-07,
                    5.2045e-07,
                    5.2915e-07,
                    5.3814e-07,
                    5.4744e-07,
                    5.5706e-07,
                    5.6701e-07,
                    5.7724e-07,
                    5.8773e-07,
                    5.9841e-07,
                    6.0929e-07,
                    6.2044e-07,
                    6.3191e-07,
                    6.4372e-07,
                    6.5591e-07,
                    6.6848e-07,
                    6.8142e-07,
                    6.9472e-07,
                    7.0833e-07,
                    7.2221e-07,
                    7.3602e-07,
                    7.5004e-07,
                    7.6422e-07,
                    7.7872e-07,
                    7.9358e-07,
                    8.0941e-07,
                    8.2572e-07,
                    8.4212e-07,
                    8.5842e-07,
                    8.7406e-07,
                    8.8974e-07,
                    9.0702e-07,
                    9.2493e-07,
                    9.4077e-07,
                    9.5899e-07,
                    9.7705e-07,
                    9.9648e-07,
                    1.0147e-06,
                    1.0321e-06,
                    1.0508e-06,
                    1.0702e-06,
                    1.0895e-06,
                    1.1054e-06,
                    1.1221e-06,
                    1.1377e-06,
                    1.1539e-06,
                    1.1718e-06,
                    1.1904e-06,
                    1.2114e-06,
                    1.2334e-06,
                    1.2552e-06,
                    1.2772e-06,
                    1.2982e-06,
                    1.3202e-06,
                    1.3478e-06,
                    1.3798e-06,
                    1.4101e-06,
                    1.4481e-06,
                    1.4804e-06,
                    1.5108e-06,
                    1.542e-06,
                    1.5725e-06,
                    1.5968e-06,
                    1.6283e-06,
                    1.6561e-06,
                    1.6855e-06,
                    1.7179e-06,
                    1.7528e-06,
                    1.7811e-06,
                    1.8109e-06,
                    1.8424e-06,
                    1.8754e-06,
                    1.9099e-06,
                    1.9411e-06,
                    1.9723e-06,
                    2.0053e-06,
                    2.0357e-06,
                    2.0641e-06,
                    2.0939e-06,
                    2.1239e-06,
                    2.1539e-06,
                    2.1838e-06
                ],
                "Fossil_N2O": 0.01,
                "Fossil_N2O_timeseries": [
                    3.4749e-09,
                    6.9854e-09,
                    1.0531e-08,
                    1.4113e-08,
                    1.7729e-08,
                    2.1381e-08,
                    2.5067e-08,
                    2.8787e-08,
                    3.2542e-08,
                    3.633e-08,
                    4.0152e-08,
                    4.4007e-08,
                    4.7896e-08,
                    5.1818e-08,
                    5.5773e-08,
                    5.9761e-08,
                    6.3783e-08,
                    6.7838e-08,
                    7.1927e-08,
                    7.6049e-08,
                    8.0207e-08,
                    8.4404e-08,
                    8.8642e-08,
                    9.2923e-08,
                    9.7248e-08,
                    1.0162e-07,
                    1.0603e-07,
                    1.1049e-07,
                    1.1499e-07,
                    1.1952e-07,
                    1.2409e-07,
                    1.287e-07,
                    1.3334e-07,
                    1.3802e-07,
                    1.4273e-07,
                    1.4747e-07,
                    1.5225e-07,
                    1.5707e-07,
                    1.6192e-07,
                    1.6682e-07,
                    1.7175e-07,
                    1.7673e-07,
                    1.8175e-07,
                    1.868e-07,
                    1.919e-07,
                    1.9703e-07,
                    2.0221e-07,
                    2.0743e-07,
                    2.1269e-07,
                    2.1799e-07,
                    2.2334e-07,
                    2.2872e-07,
                    2.3416e-07,
                    2.3964e-07,
                    2.4517e-07,
                    2.5074e-07,
                    2.5636e-07,
                    2.6202e-07,
                    2.6774e-07,
                    2.7349e-07,
                    2.793e-07,
                    2.8514e-07,
                    2.9103e-07,
                    2.9697e-07,
                    3.0294e-07,
                    3.0897e-07,
                    3.1503e-07,
                    3.2114e-07,
                    3.2729e-07,
                    3.3349e-07,
                    3.3973e-07,
                    3.4602e-07,
                    3.5235e-07,
                    3.5872e-07,
                    3.6513e-07,
                    3.716e-07,
                    3.781e-07,
                    3.8465e-07,
                    3.9124e-07,
                    3.9788e-07,
                    4.0457e-07,
                    4.113e-07,
                    4.1807e-07,
                    4.2489e-07,
                    4.3176e-07,
                    4.3867e-07,
                    4.4563e-07,
                    4.5264e-07,
                    4.597e-07,
                    4.6681e-07,
                    4.7398e-07,
                    4.8122e-07,
                    4.8852e-07,
                    4.9591e-07,
                    5.0338e-07,
                    5.1093e-07,
                    5.1857e-07,
                    5.2629e-07,
                    5.341e-07,
                    5.4199e-07,
                    5.4997e-07,
                    5.5805e-07,
                    5.6624e-07,
                    5.7455e-07,
                    5.8298e-07,
                    5.9155e-07,
                    6.0025e-07,
                    6.0909e-07,
                    6.1805e-07,
                    6.2713e-07,
                    6.3633e-07,
                    6.4562e-07,
                    6.5502e-07,
                    6.6451e-07,
                    6.7411e-07,
                    6.8382e-07,
                    6.9367e-07,
                    7.0366e-07,
                    7.1384e-07,
                    7.2326e-07,
                    7.3263e-07,
                    7.4347e-07,
                    7.5413e-07,
                    7.6389e-07,
                    7.7636e-07,
                    7.8744e-07,
                    7.9949e-07,
                    8.115e-07,
                    8.2325e-07,
                    8.3577e-07,
                    8.483e-07,
                    8.6121e-07,
                    8.7111e-07,
                    8.8163e-07,
                    8.9124e-07,
                    9.0134e-07,
                    9.1314e-07,
                    9.2551e-07,
                    9.3986e-07,
                    9.5549e-07,
                    9.7108e-07,
                    9.8652e-07,
                    1.0013e-06,
                    1.0175e-06,
                    1.0373e-06,
                    1.0598e-06,
                    1.0819e-06,
                    1.1086e-06,
                    1.1321e-06,
                    1.1553e-06,
                    1.1791e-06,
                    1.2027e-06,
                    1.2209e-06,
                    1.2411e-06,
                    1.2605e-06,
                    1.2822e-06,
                    1.3067e-06,
                    1.3309e-06,
                    1.3513e-06,
                    1.3746e-06,
                    1.3956e-06,
                    1.4197e-06,
                    1.4431e-06,
                    1.4659e-06,
                    1.4874e-06,
                    1.5093e-06,
                    1.526e-06,
                    1.5428e-06,
                    1.5641e-06,
                    1.5844e-06,
                    1.6062e-06,
                    1.6278e-06
                ],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": [
                    6.6762e-11,
                    1.3486e-10,
                    2.0423e-10,
                    2.7481e-10,
                    3.4648e-10,
                    4.1912e-10,
                    4.9259e-10,
                    5.6672e-10,
                    6.4133e-10,
                    7.1619e-10,
                    7.9119e-10,
                    8.6627e-10,
                    9.4143e-10,
                    1.0166e-09,
                    1.0919e-09,
                    1.1672e-09,
                    1.2425e-09,
                    1.318e-09,
                    1.3935e-09,
                    1.4692e-09,
                    1.5461e-09,
                    1.6263e-09,
                    1.7111e-09,
                    1.8017e-09,
                    1.8985e-09,
                    2.0019e-09,
                    2.1114e-09,
                    2.2263e-09,
                    2.3454e-09,
                    2.467e-09,
                    2.5901e-09,
                    2.7144e-09,
                    2.8397e-09,
                    2.9659e-09,
                    3.0929e-09,
                    3.2206e-09,
                    3.3491e-09,
                    3.4784e-09,
                    3.6085e-09,
                    3.8049e-09,
                    4.004e-09,
                    4.209e-09,
                    4.4228e-09,
                    4.6478e-09,
                    4.8863e-09,
                    5.14e-09,
                    5.4107e-09,
                    5.6995e-09,
                    6.0074e-09,
                    6.335e-09,
                    6.69e-09,
                    7.0854e-09,
                    7.5305e-09,
                    8.0314e-09,
                    8.5904e-09,
                    9.2069e-09,
                    9.8763e-09,
                    1.0591e-08,
                    1.134e-08,
                    1.2108e-08,
                    1.2887e-08,
                    1.3675e-08,
                    1.4473e-08,
                    1.528e-08,
                    1.6094e-08,
                    1.6914e-08,
                    1.7741e-08,
                    1.8571e-08,
                    1.9405e-08,
                    2.024e-08,
                    2.1075e-08,
                    2.1904e-08,
                    2.2724e-08,
                    2.3534e-08,
                    2.4332e-08,
                    2.5118e-08,
                    2.5894e-08,
                    2.6661e-08,
                    2.7423e-08,
                    2.8182e-08,
                    2.8947e-08,
                    2.9725e-08,
                    3.0522e-08,
                    3.1344e-08,
                    3.2196e-08,
                    3.308e-08,
                    3.3997e-08,
                    3.4948e-08,
                    3.5932e-08,
                    3.6947e-08,
                    3.8027e-08,
                    3.9237e-08,
                    4.0626e-08,
                    4.2228e-08,
                    4.4063e-08,
                    4.6137e-08,
                    4.8441e-08,
                    5.0951e-08,
                    5.3628e-08,
                    5.6421e-08,
                    5.9328e-08,
                    6.2398e-08,
                    6.5673e-08,
                    6.9178e-08,
                    7.2929e-08,
                    7.6929e-08,
                    8.1171e-08,
                    8.5634e-08,
                    9.0285e-08,
                    9.5081e-08,
                    9.9697e-08,
                    1.0442e-07,
                    1.092e-07,
                    1.1421e-07,
                    1.1947e-07,
                    1.2558e-07,
                    1.3206e-07,
                    1.3846e-07,
                    1.4458e-07,
                    1.508e-07,
                    1.5711e-07,
                    1.6355e-07,
                    1.708e-07,
                    1.7688e-07,
                    1.8264e-07,
                    1.896e-07,
                    1.9699e-07,
                    2.0318e-07,
                    2.0884e-07,
                    2.1502e-07,
                    2.2187e-07,
                    2.2826e-07,
                    2.3432e-07,
                    2.4051e-07,
                    2.465e-07,
                    2.5251e-07,
                    2.5869e-07,
                    2.6494e-07,
                    2.7151e-07,
                    2.779e-07,
                    2.8415e-07,
                    2.9069e-07,
                    2.9693e-07,
                    3.027e-07,
                    3.1051e-07,
                    3.1999e-07,
                    3.2816e-07,
                    3.3952e-07,
                    3.4829e-07,
                    3.5548e-07,
                    3.6297e-07,
                    3.6985e-07,
                    3.7588e-07,
                    3.8719e-07,
                    3.9567e-07,
                    4.0323e-07,
                    4.1125e-07,
                    4.2187e-07,
                    4.2986e-07,
                    4.363e-07,
                    4.4675e-07,
                    4.5574e-07,
                    4.6687e-07,
                    4.7521e-07,
                    4.8484e-07,
                    4.9604e-07,
                    5.0975e-07,
                    5.2132e-07,
                    5.2982e-07,
                    5.3951e-07,
                    5.4771e-07,
                    5.5595e-07
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -77.92352,
                                24.88911
                            ],
                            [
                                -77.94625,
                                24.94642
                            ],
                            [
                                -77.99626,
                                24.9789
                            ],
                            [
                                -77.97426,
                                25.05169
                            ],
                            [
                                -77.99253,
                                25.12777
                            ],
                            [
                                -78.14959,
                                25.17479
                            ],
                            [
                                -78.21054,
                                25.14196
                            ],
                            [
                                -78.16682,
                                25.04524
                            ],
                            [
                                -78.18545,
                                24.90946
                            ],
                            [
                                -78.25176,
                                24.8258
                            ],
                            [
                                -78.28486,
                                24.67876
                            ],
                            [
                                -78.22397,
                                24.67852
                            ],
                            [
                                -78.31665,
                                24.57218
                            ],
                            [
                                -78.4106,
                                24.63152
                            ],
                            [
                                -78.44564,
                                24.58511
                            ],
                            [
                                -78.25308,
                                24.45117
                            ],
                            [
                                -78.11321,
                                24.37726
                            ],
                            [
                                -78.05632,
                                24.28404
                            ],
                            [
                                -77.97074,
                                24.34292
                            ],
                            [
                                -77.92894,
                                24.316
                            ],
                            [
                                -77.87705,
                                24.37553
                            ],
                            [
                                -77.8902,
                                24.41638
                            ],
                            [
                                -77.73374,
                                24.46665
                            ],
                            [
                                -77.75927,
                                24.69477
                            ],
                            [
                                -77.90621,
                                24.84072
                            ],
                            [
                                -77.92352,
                                24.88911
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -73.14922,
                                20.99115
                            ],
                            [
                                -73.0877,
                                21.10205
                            ],
                            [
                                -73.01983,
                                21.18918
                            ],
                            [
                                -73.01005,
                                21.33019
                            ],
                            [
                                -73.06547,
                                21.32075
                            ],
                            [
                                -73.13654,
                                21.19076
                            ],
                            [
                                -73.26178,
                                21.1343
                            ],
                            [
                                -73.354,
                                21.17245
                            ],
                            [
                                -73.38689,
                                21.23381
                            ],
                            [
                                -73.43282,
                                21.19054
                            ],
                            [
                                -73.51697,
                                21.1848
                            ],
                            [
                                -73.55276,
                                21.12977
                            ],
                            [
                                -73.6171,
                                21.10901
                            ],
                            [
                                -73.6476,
                                21.04854
                            ],
                            [
                                -73.70184,
                                21.0165
                            ],
                            [
                                -73.67435,
                                20.93364
                            ],
                            [
                                -73.55474,
                                20.94735
                            ],
                            [
                                -73.49336,
                                20.9226
                            ],
                            [
                                -73.38248,
                                20.93684
                            ],
                            [
                                -73.3504,
                                20.9625
                            ],
                            [
                                -73.25044,
                                20.95296
                            ],
                            [
                                -73.14922,
                                20.99115
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -77.61655,
                                26.86339
                            ],
                            [
                                -77.52877,
                                26.87924
                            ],
                            [
                                -77.45621,
                                26.7934
                            ],
                            [
                                -77.4257,
                                26.69323
                            ],
                            [
                                -77.35405,
                                26.69842
                            ],
                            [
                                -77.34041,
                                26.6125
                            ],
                            [
                                -77.27256,
                                26.57772
                            ],
                            [
                                -77.1871,
                                26.57551
                            ],
                            [
                                -77.13087,
                                26.53545
                            ],
                            [
                                -77.18112,
                                26.49899
                            ],
                            [
                                -77.2175,
                                26.39317
                            ],
                            [
                                -77.2254,
                                26.30127
                            ],
                            [
                                -77.19855,
                                26.26711
                            ],
                            [
                                -77.23639,
                                26.21594
                            ],
                            [
                                -77.20612,
                                26.15069
                            ],
                            [
                                -77.40451,
                                26.0018
                            ],
                            [
                                -77.30689,
                                25.98245
                            ],
                            [
                                -77.21801,
                                25.84856
                            ],
                            [
                                -77.18006,
                                25.92067
                            ],
                            [
                                -77.1977,
                                26.04224
                            ],
                            [
                                -77.17705,
                                26.20295
                            ],
                            [
                                -77.11449,
                                26.28119
                            ],
                            [
                                -77.03304,
                                26.34656
                            ],
                            [
                                -77.07686,
                                26.54538
                            ],
                            [
                                -77.17185,
                                26.60233
                            ],
                            [
                                -77.28607,
                                26.63985
                            ],
                            [
                                -77.30598,
                                26.70273
                            ],
                            [
                                -77.37787,
                                26.74833
                            ],
                            [
                                -77.53201,
                                26.89146
                            ],
                            [
                                -77.61655,
                                26.86339
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -78.35091,
                                26.68355
                            ],
                            [
                                -78.49639,
                                26.72996
                            ],
                            [
                                -78.54777,
                                26.71724
                            ],
                            [
                                -78.61444,
                                26.60927
                            ],
                            [
                                -78.74979,
                                26.53805
                            ],
                            [
                                -78.66139,
                                26.49737
                            ],
                            [
                                -78.5828,
                                26.53943
                            ],
                            [
                                -78.42239,
                                26.5975
                            ],
                            [
                                -78.24481,
                                26.61815
                            ],
                            [
                                -78.12714,
                                26.64442
                            ],
                            [
                                -77.90914,
                                26.66459
                            ],
                            [
                                -77.90317,
                                26.73781
                            ],
                            [
                                -78.06001,
                                26.72511
                            ],
                            [
                                -78.11536,
                                26.69735
                            ],
                            [
                                -78.35091,
                                26.68355
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -77.63082,
                                23.83981
                            ],
                            [
                                -77.55022,
                                23.83943
                            ],
                            [
                                -77.50838,
                                23.89878
                            ],
                            [
                                -77.5477,
                                24.09911
                            ],
                            [
                                -77.59109,
                                24.19872
                            ],
                            [
                                -77.61959,
                                24.19518
                            ],
                            [
                                -77.70238,
                                24.03923
                            ],
                            [
                                -77.79404,
                                23.98527
                            ],
                            [
                                -77.74315,
                                23.90861
                            ],
                            [
                                -77.63082,
                                23.83981
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.16385,
                                22.31955
                            ],
                            [
                                -74.13384,
                                22.29165
                            ],
                            [
                                -74.00116,
                                22.32693
                            ],
                            [
                                -73.93176,
                                22.4406
                            ],
                            [
                                -73.87763,
                                22.48318
                            ],
                            [
                                -73.84813,
                                22.54814
                            ],
                            [
                                -73.87225,
                                22.66278
                            ],
                            [
                                -73.95847,
                                22.71186
                            ],
                            [
                                -74.0366,
                                22.60999
                            ],
                            [
                                -73.98496,
                                22.58387
                            ],
                            [
                                -73.92582,
                                22.59714
                            ],
                            [
                                -73.87722,
                                22.5151
                            ],
                            [
                                -73.90771,
                                22.47346
                            ],
                            [
                                -73.99772,
                                22.4513
                            ],
                            [
                                -74.00877,
                                22.40829
                            ],
                            [
                                -74.08727,
                                22.39179
                            ],
                            [
                                -74.08411,
                                22.35153
                            ],
                            [
                                -74.16385,
                                22.31955
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -75.34341,
                                23.62823
                            ],
                            [
                                -75.25747,
                                23.54281
                            ],
                            [
                                -75.254,
                                23.49347
                            ],
                            [
                                -75.20428,
                                23.40398
                            ],
                            [
                                -75.14503,
                                23.3797
                            ],
                            [
                                -75.10367,
                                23.27742
                            ],
                            [
                                -75.13871,
                                23.24283
                            ],
                            [
                                -75.13398,
                                23.17868
                            ],
                            [
                                -75.06467,
                                23.12703
                            ],
                            [
                                -75.05401,
                                23.08165
                            ],
                            [
                                -74.95917,
                                23.0522
                            ],
                            [
                                -74.87751,
                                22.88087
                            ],
                            [
                                -74.83043,
                                22.88537
                            ],
                            [
                                -74.85928,
                                23.00641
                            ],
                            [
                                -74.93374,
                                23.09149
                            ],
                            [
                                -75.02167,
                                23.10961
                            ],
                            [
                                -75.08668,
                                23.21242
                            ],
                            [
                                -75.10058,
                                23.32578
                            ],
                            [
                                -75.18895,
                                23.45482
                            ],
                            [
                                -75.20382,
                                23.52552
                            ],
                            [
                                -75.31362,
                                23.67176
                            ],
                            [
                                -75.34341,
                                23.62823
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -75.45912,
                                24.12147
                            ],
                            [
                                -75.3356,
                                24.15604
                            ],
                            [
                                -75.32484,
                                24.21288
                            ],
                            [
                                -75.38316,
                                24.30128
                            ],
                            [
                                -75.47641,
                                24.36815
                            ],
                            [
                                -75.57059,
                                24.52205
                            ],
                            [
                                -75.61265,
                                24.56534
                            ],
                            [
                                -75.62468,
                                24.63671
                            ],
                            [
                                -75.68781,
                                24.69111
                            ],
                            [
                                -75.71225,
                                24.64532
                            ],
                            [
                                -75.64299,
                                24.58425
                            ],
                            [
                                -75.55105,
                                24.45734
                            ],
                            [
                                -75.47125,
                                24.3171
                            ],
                            [
                                -75.41693,
                                24.28811
                            ],
                            [
                                -75.4022,
                                24.20523
                            ],
                            [
                                -75.48327,
                                24.17403
                            ],
                            [
                                -75.45912,
                                24.12147
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -76.58961,
                                25.42433
                            ],
                            [
                                -76.50441,
                                25.35289
                            ],
                            [
                                -76.3595,
                                25.3195
                            ],
                            [
                                -76.21735,
                                25.16354
                            ],
                            [
                                -76.15548,
                                25.12528
                            ],
                            [
                                -76.14515,
                                25.01165
                            ],
                            [
                                -76.19723,
                                24.96051
                            ],
                            [
                                -76.21496,
                                24.88635
                            ],
                            [
                                -76.16202,
                                24.83474
                            ],
                            [
                                -76.23136,
                                24.78461
                            ],
                            [
                                -76.19273,
                                24.74523
                            ],
                            [
                                -76.13786,
                                24.85049
                            ],
                            [
                                -76.16022,
                                24.93091
                            ],
                            [
                                -76.11702,
                                25.04677
                            ],
                            [
                                -76.14718,
                                25.16111
                            ],
                            [
                                -76.22546,
                                25.19865
                            ],
                            [
                                -76.31632,
                                25.2757
                            ],
                            [
                                -76.36701,
                                25.34702
                            ],
                            [
                                -76.44071,
                                25.343
                            ],
                            [
                                -76.58961,
                                25.42433
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -77.70276,
                                24.10332
                            ],
                            [
                                -77.74158,
                                24.16414
                            ],
                            [
                                -77.6365,
                                24.2157
                            ],
                            [
                                -77.67354,
                                24.29619
                            ],
                            [
                                -77.77319,
                                24.25584
                            ],
                            [
                                -77.83869,
                                24.19565
                            ],
                            [
                                -77.8629,
                                24.13133
                            ],
                            [
                                -77.78554,
                                24.06266
                            ],
                            [
                                -77.71253,
                                24.0594
                            ],
                            [
                                -77.70276,
                                24.10332
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -73.16921,
                                22.3635
                            ],
                            [
                                -73.05802,
                                22.33219
                            ],
                            [
                                -73.01305,
                                22.36435
                            ],
                            [
                                -72.86845,
                                22.35463
                            ],
                            [
                                -72.78287,
                                22.28512
                            ],
                            [
                                -72.73155,
                                22.33618
                            ],
                            [
                                -72.88448,
                                22.39972
                            ],
                            [
                                -72.97912,
                                22.40778
                            ],
                            [
                                -73.1284,
                                22.45561
                            ],
                            [
                                -73.16921,
                                22.3635
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.16385,
                                22.75041
                            ],
                            [
                                -74.23235,
                                22.80556
                            ],
                            [
                                -74.30865,
                                22.83528
                            ],
                            [
                                -74.32883,
                                22.78255
                            ],
                            [
                                -74.26892,
                                22.6919
                            ],
                            [
                                -74.16385,
                                22.66813
                            ],
                            [
                                -74.0782,
                                22.66803
                            ],
                            [
                                -74.02096,
                                22.71652
                            ],
                            [
                                -74.16385,
                                22.75041
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -77.55273,
                                25.01311
                            ],
                            [
                                -77.44455,
                                24.97935
                            ],
                            [
                                -77.27386,
                                25.01869
                            ],
                            [
                                -77.30883,
                                25.07364
                            ],
                            [
                                -77.36318,
                                25.0856
                            ],
                            [
                                -77.49487,
                                25.06235
                            ],
                            [
                                -77.55273,
                                25.01311
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -76.06248,
                                23.68669
                            ],
                            [
                                -75.99936,
                                23.60006
                            ],
                            [
                                -75.84404,
                                23.55367
                            ],
                            [
                                -75.99059,
                                23.68013
                            ],
                            [
                                -76.06248,
                                23.68669
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.45788,
                                24.12147
                            ],
                            [
                                -74.50485,
                                24.11857
                            ],
                            [
                                -74.53804,
                                24.06481
                            ],
                            [
                                -74.55091,
                                23.96998
                            ],
                            [
                                -74.48909,
                                23.9501
                            ],
                            [
                                -74.4312,
                                24.0646
                            ],
                            [
                                -74.45788,
                                24.12147
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -73.0761,
                                21.50736
                            ],
                            [
                                -73.05045,
                                21.42356
                            ],
                            [
                                -72.91654,
                                21.48847
                            ],
                            [
                                -72.9938,
                                21.55989
                            ],
                            [
                                -73.0761,
                                21.50736
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -76.7877,
                                25.40733
                            ],
                            [
                                -76.6371,
                                25.45712
                            ],
                            [
                                -76.67114,
                                25.50884
                            ],
                            [
                                -76.75325,
                                25.48046
                            ],
                            [
                                -76.7877,
                                25.40733
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.95114,
                                23.66913
                            ],
                            [
                                -74.80314,
                                23.65297
                            ],
                            [
                                -74.83989,
                                23.71248
                            ],
                            [
                                -74.95114,
                                23.66913
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -77.78224,
                                24.37843
                            ],
                            [
                                -77.76882,
                                24.34103
                            ],
                            [
                                -77.683,
                                24.33957
                            ],
                            [
                                -77.71451,
                                24.4219
                            ],
                            [
                                -77.78224,
                                24.37843
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -77.96259,
                                24.14901
                            ],
                            [
                                -77.86803,
                                24.17638
                            ],
                            [
                                -77.82238,
                                24.26249
                            ],
                            [
                                -77.89672,
                                24.26144
                            ],
                            [
                                -77.89361,
                                24.20285
                            ],
                            [
                                -77.96259,
                                24.14901
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "BHR",
                "Country": "Bahrain",
                "Total_3GHG": 0.1,
                "Total_3GHG_timeseries": [
                    5.4897e-09,
                    1.1e-08,
                    1.653e-08,
                    2.2081e-08,
                    2.765e-08,
                    3.3245e-08,
                    3.8858e-08,
                    4.449e-08,
                    5.0139e-08,
                    5.5806e-08,
                    6.1332e-08,
                    6.6719e-08,
                    7.1966e-08,
                    7.7073e-08,
                    8.2041e-08,
                    8.6871e-08,
                    9.1561e-08,
                    9.6113e-08,
                    1.0053e-07,
                    1.048e-07,
                    1.0893e-07,
                    1.1293e-07,
                    1.1678e-07,
                    1.205e-07,
                    1.241e-07,
                    1.2756e-07,
                    1.3089e-07,
                    1.3408e-07,
                    1.3715e-07,
                    1.4007e-07,
                    1.4299e-07,
                    1.459e-07,
                    1.4881e-07,
                    1.5172e-07,
                    1.5462e-07,
                    1.5751e-07,
                    1.604e-07,
                    1.6328e-07,
                    1.6616e-07,
                    1.6905e-07,
                    1.7193e-07,
                    1.748e-07,
                    1.7767e-07,
                    1.8053e-07,
                    1.8338e-07,
                    1.8622e-07,
                    1.8907e-07,
                    1.919e-07,
                    1.9474e-07,
                    1.9756e-07,
                    2.0015e-07,
                    2.025e-07,
                    2.0462e-07,
                    2.0649e-07,
                    2.0815e-07,
                    2.0957e-07,
                    2.1077e-07,
                    2.1174e-07,
                    2.125e-07,
                    2.1305e-07,
                    2.1361e-07,
                    2.142e-07,
                    2.1481e-07,
                    2.1543e-07,
                    2.1608e-07,
                    2.1675e-07,
                    2.1744e-07,
                    2.1815e-07,
                    2.1887e-07,
                    2.1962e-07,
                    2.2064e-07,
                    2.2193e-07,
                    2.2348e-07,
                    2.2532e-07,
                    2.2742e-07,
                    2.2979e-07,
                    2.3243e-07,
                    2.3534e-07,
                    2.3851e-07,
                    2.4194e-07,
                    2.4543e-07,
                    2.4901e-07,
                    3.0403e-07,
                    4.5503e-07,
                    8.373e-07,
                    1.9046e-06,
                    3.6058e-06,
                    5.454e-06,
                    7.2168e-06,
                    8.9287e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016
                ],
                "Fossil_3GHG": 0.15,
                "Fossil_3GHG_timeseries": [
                    4.4954e-09,
                    9.0052e-09,
                    1.3529e-08,
                    1.8067e-08,
                    2.2619e-08,
                    2.7184e-08,
                    3.1763e-08,
                    3.6354e-08,
                    4.0959e-08,
                    4.5576e-08,
                    5.0072e-08,
                    5.4446e-08,
                    5.8701e-08,
                    6.2834e-08,
                    6.6848e-08,
                    7.0741e-08,
                    7.4514e-08,
                    7.8168e-08,
                    8.1702e-08,
                    8.5117e-08,
                    8.8406e-08,
                    9.1571e-08,
                    9.4614e-08,
                    9.7536e-08,
                    1.0034e-07,
                    1.0302e-07,
                    1.0558e-07,
                    1.0802e-07,
                    1.1034e-07,
                    1.1254e-07,
                    1.1473e-07,
                    1.1692e-07,
                    1.1909e-07,
                    1.2126e-07,
                    1.2343e-07,
                    1.2558e-07,
                    1.2773e-07,
                    1.2987e-07,
                    1.3201e-07,
                    1.3414e-07,
                    1.3626e-07,
                    1.3837e-07,
                    1.4048e-07,
                    1.4258e-07,
                    1.4467e-07,
                    1.4675e-07,
                    1.4883e-07,
                    1.509e-07,
                    1.5296e-07,
                    1.5501e-07,
                    1.5682e-07,
                    1.5839e-07,
                    1.5971e-07,
                    1.608e-07,
                    1.6166e-07,
                    1.6228e-07,
                    1.6268e-07,
                    1.6285e-07,
                    1.628e-07,
                    1.6252e-07,
                    1.6223e-07,
                    1.6192e-07,
                    1.6158e-07,
                    1.6122e-07,
                    1.6084e-07,
                    1.6044e-07,
                    1.6001e-07,
                    1.5956e-07,
                    1.5909e-07,
                    1.5859e-07,
                    1.5831e-07,
                    1.5824e-07,
                    1.5839e-07,
                    1.5874e-07,
                    1.5931e-07,
                    1.6008e-07,
                    1.6105e-07,
                    1.6223e-07,
                    1.6361e-07,
                    1.6518e-07,
                    1.668e-07,
                    1.6848e-07,
                    2.2157e-07,
                    3.7063e-07,
                    7.5094e-07,
                    1.8162e-06,
                    3.5154e-06,
                    5.3615e-06,
                    7.1221e-06,
                    8.8319e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [
                    9.9421e-10,
                    1.9946e-09,
                    3.001e-09,
                    4.0134e-09,
                    5.0316e-09,
                    6.061e-09,
                    7.0957e-09,
                    8.1356e-09,
                    9.1805e-09,
                    1.023e-08,
                    1.126e-08,
                    1.2272e-08,
                    1.3265e-08,
                    1.4239e-08,
                    1.5194e-08,
                    1.613e-08,
                    1.7047e-08,
                    1.7945e-08,
                    1.8824e-08,
                    1.9685e-08,
                    2.0527e-08,
                    2.1354e-08,
                    2.2167e-08,
                    2.2968e-08,
                    2.3758e-08,
                    2.4538e-08,
                    2.5306e-08,
                    2.6062e-08,
                    2.6804e-08,
                    2.7529e-08,
                    2.8257e-08,
                    2.8987e-08,
                    2.9719e-08,
                    3.0452e-08,
                    3.1188e-08,
                    3.1925e-08,
                    3.2663e-08,
                    3.3409e-08,
                    3.4156e-08,
                    3.4913e-08,
                    3.5671e-08,
                    3.6429e-08,
                    3.7189e-08,
                    3.7949e-08,
                    3.8711e-08,
                    3.9474e-08,
                    4.0239e-08,
                    4.1005e-08,
                    4.1778e-08,
                    4.2552e-08,
                    4.3329e-08,
                    4.4112e-08,
                    4.4903e-08,
                    4.5691e-08,
                    4.6487e-08,
                    4.7285e-08,
                    4.8091e-08,
                    4.8894e-08,
                    4.9705e-08,
                    5.0524e-08,
                    5.1381e-08,
                    5.228e-08,
                    5.3227e-08,
                    5.4212e-08,
                    5.524e-08,
                    5.6316e-08,
                    5.743e-08,
                    5.8587e-08,
                    5.9789e-08,
                    6.1035e-08,
                    6.2332e-08,
                    6.3685e-08,
                    6.5098e-08,
                    6.6573e-08,
                    6.8113e-08,
                    6.9718e-08,
                    7.1383e-08,
                    7.3113e-08,
                    7.4906e-08,
                    7.676e-08,
                    7.8633e-08,
                    8.053e-08,
                    8.2454e-08,
                    8.4396e-08,
                    8.636e-08,
                    8.8364e-08,
                    9.0412e-08,
                    9.25e-08,
                    9.4635e-08,
                    9.6812e-08,
                    9.9051e-08,
                    1.0135e-07,
                    1.0374e-07,
                    1.062e-07,
                    1.0876e-07,
                    1.1141e-07,
                    1.1414e-07,
                    1.1695e-07,
                    1.1985e-07,
                    1.2281e-07,
                    1.2586e-07,
                    1.2911e-07,
                    1.3265e-07,
                    1.3655e-07,
                    1.4084e-07,
                    1.4556e-07,
                    1.507e-07,
                    1.5627e-07,
                    1.6228e-07,
                    1.6869e-07,
                    1.7522e-07,
                    1.8185e-07,
                    1.8866e-07,
                    1.9563e-07,
                    2.0275e-07,
                    2.1143e-07,
                    2.2006e-07,
                    2.2862e-07,
                    2.3746e-07,
                    2.4637e-07,
                    2.5572e-07,
                    2.6657e-07,
                    2.7946e-07,
                    2.9216e-07,
                    3.0605e-07,
                    3.2062e-07,
                    3.3659e-07,
                    3.5217e-07,
                    3.682e-07,
                    3.8298e-07,
                    3.9797e-07,
                    4.1314e-07,
                    4.284e-07,
                    4.4419e-07,
                    4.6359e-07,
                    4.8657e-07,
                    5.1066e-07,
                    5.4252e-07,
                    5.7932e-07,
                    6.1784e-07,
                    6.5441e-07,
                    6.9016e-07,
                    7.236e-07,
                    7.5758e-07,
                    7.8694e-07,
                    8.1919e-07,
                    8.5184e-07,
                    8.8582e-07,
                    9.1804e-07,
                    9.4819e-07,
                    9.7613e-07,
                    1.0219e-06,
                    1.0596e-06,
                    1.093e-06,
                    1.1225e-06,
                    1.1497e-06,
                    1.1717e-06,
                    1.1836e-06,
                    1.1896e-06,
                    1.205e-06,
                    1.2203e-06,
                    1.2356e-06,
                    1.2527e-06,
                    1.2714e-06,
                    1.2918e-06,
                    1.3056e-06,
                    1.3195e-06,
                    1.3338e-06,
                    1.3486e-06,
                    1.3604e-06,
                    1.3763e-06,
                    1.3816e-06
                ],
                "Total_CO2": 0.04,
                "Total_CO2_timeseries": [
                    7.15e-11,
                    1.43e-10,
                    2.145e-10,
                    2.86e-10,
                    3.575e-10,
                    4.345e-10,
                    5.115e-10,
                    5.885e-10,
                    6.655e-10,
                    7.425e-10,
                    8.195e-10,
                    8.965e-10,
                    9.735e-10,
                    1.0505e-09,
                    1.1275e-09,
                    1.2045e-09,
                    1.2815e-09,
                    1.3585e-09,
                    1.4355e-09,
                    1.5125e-09,
                    1.5895e-09,
                    1.6665e-09,
                    1.7435e-09,
                    1.8205e-09,
                    1.8975e-09,
                    1.9745e-09,
                    2.0515e-09,
                    2.1285e-09,
                    2.2055e-09,
                    2.2825e-09,
                    2.3595e-09,
                    2.4365e-09,
                    2.5135e-09,
                    2.5905e-09,
                    2.6675e-09,
                    2.7445e-09,
                    2.8215e-09,
                    2.904e-09,
                    2.9865e-09,
                    3.069e-09,
                    3.1515e-09,
                    3.234e-09,
                    3.3165e-09,
                    3.399e-09,
                    3.4815e-09,
                    3.564e-09,
                    3.6465e-09,
                    3.729e-09,
                    3.817e-09,
                    3.905e-09,
                    3.993e-09,
                    4.0865e-09,
                    4.1855e-09,
                    4.279e-09,
                    4.378e-09,
                    4.477e-09,
                    4.5815e-09,
                    4.6805e-09,
                    4.785e-09,
                    4.895e-09,
                    4.9995e-09,
                    5.104e-09,
                    5.214e-09,
                    5.3185e-09,
                    5.423e-09,
                    5.533e-09,
                    5.6375e-09,
                    5.742e-09,
                    5.8465e-09,
                    5.951e-09,
                    6.0555e-09,
                    6.16e-09,
                    6.2645e-09,
                    6.369e-09,
                    6.4735e-09,
                    6.578e-09,
                    6.677e-09,
                    6.776e-09,
                    6.875e-09,
                    6.974e-09,
                    7.0675e-09,
                    7.161e-09,
                    1.221e-08,
                    6.6754e-08,
                    3.061e-07,
                    1.184e-06,
                    2.6493e-06,
                    4.2152e-06,
                    5.6491e-06,
                    6.9857e-06,
                    8.2695e-06,
                    9.4477e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005
                ],
                "Fossil_CO2": 0.06,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    4.95e-09,
                    5.94e-08,
                    2.9865e-07,
                    1.1764e-06,
                    2.6416e-06,
                    4.2075e-06,
                    5.6413e-06,
                    6.9778e-06,
                    8.2616e-06,
                    9.4397e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [
                    7.15e-11,
                    1.43e-10,
                    2.145e-10,
                    2.86e-10,
                    3.575e-10,
                    4.345e-10,
                    5.115e-10,
                    5.885e-10,
                    6.655e-10,
                    7.425e-10,
                    8.195e-10,
                    8.965e-10,
                    9.735e-10,
                    1.0505e-09,
                    1.1275e-09,
                    1.2045e-09,
                    1.2815e-09,
                    1.3585e-09,
                    1.4355e-09,
                    1.5125e-09,
                    1.5895e-09,
                    1.6665e-09,
                    1.7435e-09,
                    1.8205e-09,
                    1.8975e-09,
                    1.9745e-09,
                    2.0515e-09,
                    2.1285e-09,
                    2.2055e-09,
                    2.2825e-09,
                    2.3595e-09,
                    2.4365e-09,
                    2.5135e-09,
                    2.5905e-09,
                    2.6675e-09,
                    2.7445e-09,
                    2.8215e-09,
                    2.904e-09,
                    2.9865e-09,
                    3.069e-09,
                    3.1515e-09,
                    3.234e-09,
                    3.3165e-09,
                    3.399e-09,
                    3.4815e-09,
                    3.564e-09,
                    3.6465e-09,
                    3.729e-09,
                    3.817e-09,
                    3.905e-09,
                    3.993e-09,
                    4.0865e-09,
                    4.1855e-09,
                    4.279e-09,
                    4.378e-09,
                    4.477e-09,
                    4.5815e-09,
                    4.6805e-09,
                    4.785e-09,
                    4.895e-09,
                    4.9995e-09,
                    5.104e-09,
                    5.214e-09,
                    5.3185e-09,
                    5.423e-09,
                    5.533e-09,
                    5.6375e-09,
                    5.742e-09,
                    5.8465e-09,
                    5.951e-09,
                    6.0555e-09,
                    6.16e-09,
                    6.2645e-09,
                    6.369e-09,
                    6.4735e-09,
                    6.578e-09,
                    6.677e-09,
                    6.776e-09,
                    6.875e-09,
                    6.974e-09,
                    7.0675e-09,
                    7.161e-09,
                    7.26e-09,
                    7.3535e-09,
                    7.447e-09,
                    7.535e-09,
                    7.623e-09,
                    7.7055e-09,
                    7.788e-09,
                    7.865e-09,
                    7.9475e-09,
                    8.0245e-09,
                    8.1015e-09,
                    8.173e-09,
                    8.25e-09,
                    8.3215e-09,
                    8.3875e-09,
                    8.4535e-09,
                    8.5195e-09,
                    8.58e-09,
                    8.635e-09,
                    8.6845e-09,
                    8.723e-09,
                    8.756e-09,
                    8.778e-09,
                    8.8055e-09,
                    8.833e-09,
                    8.8605e-09,
                    8.91e-09,
                    8.965e-09,
                    9.02e-09,
                    9.0695e-09,
                    9.1135e-09,
                    9.1465e-09,
                    9.1685e-09,
                    9.185e-09,
                    9.196e-09,
                    9.2015e-09,
                    9.207e-09,
                    9.2125e-09,
                    9.218e-09,
                    9.218e-09,
                    1.0285e-08,
                    1.3843e-08,
                    1.8238e-08,
                    2.326e-08,
                    2.9029e-08,
                    3.4446e-08,
                    3.7972e-08,
                    4.0964e-08,
                    4.3461e-08,
                    4.5485e-08,
                    4.7003e-08,
                    4.8163e-08,
                    4.9252e-08,
                    5.0308e-08,
                    5.1293e-08,
                    5.2223e-08,
                    5.3064e-08,
                    5.4731e-08,
                    5.6479e-08,
                    5.8207e-08,
                    5.9961e-08,
                    6.1776e-08,
                    6.27e-08,
                    6.3437e-08,
                    6.5098e-08,
                    6.6017e-08,
                    6.6754e-08,
                    6.7392e-08,
                    6.781e-08,
                    6.8161e-08,
                    6.8343e-08,
                    6.847e-08,
                    6.8536e-08,
                    6.8492e-08,
                    6.8371e-08,
                    6.8178e-08,
                    6.7963e-08,
                    6.7821e-08,
                    6.7942e-08,
                    6.798e-08,
                    6.7738e-08,
                    6.7463e-08,
                    6.7155e-08,
                    6.6776e-08,
                    6.6319e-08,
                    6.5813e-08,
                    6.5302e-08,
                    6.4796e-08,
                    6.4295e-08,
                    6.3805e-08
                ],
                "Total_CH4": 0.26,
                "Total_CH4_timeseries": [
                    5.0428e-09,
                    1.0101e-08,
                    1.5174e-08,
                    2.0262e-08,
                    2.5365e-08,
                    3.0482e-08,
                    3.5614e-08,
                    4.0761e-08,
                    4.5922e-08,
                    5.1098e-08,
                    5.6131e-08,
                    6.1022e-08,
                    6.5771e-08,
                    7.0378e-08,
                    7.4844e-08,
                    7.9168e-08,
                    8.3351e-08,
                    8.7394e-08,
                    9.1295e-08,
                    9.5057e-08,
                    9.8669e-08,
                    1.0213e-07,
                    1.0544e-07,
                    1.0861e-07,
                    1.1163e-07,
                    1.1449e-07,
                    1.1721e-07,
                    1.1979e-07,
                    1.2221e-07,
                    1.2449e-07,
                    1.2676e-07,
                    1.2902e-07,
                    1.3127e-07,
                    1.3351e-07,
                    1.3574e-07,
                    1.3796e-07,
                    1.4017e-07,
                    1.4237e-07,
                    1.4456e-07,
                    1.4675e-07,
                    1.4892e-07,
                    1.5108e-07,
                    1.5323e-07,
                    1.5536e-07,
                    1.5749e-07,
                    1.5961e-07,
                    1.6171e-07,
                    1.6381e-07,
                    1.6589e-07,
                    1.6797e-07,
                    1.6979e-07,
                    1.7136e-07,
                    1.7269e-07,
                    1.7378e-07,
                    1.7463e-07,
                    1.7524e-07,
                    1.7562e-07,
                    1.7576e-07,
                    1.7568e-07,
                    1.7537e-07,
                    1.7508e-07,
                    1.748e-07,
                    1.7454e-07,
                    1.7429e-07,
                    1.7405e-07,
                    1.7382e-07,
                    1.736e-07,
                    1.734e-07,
                    1.7321e-07,
                    1.7303e-07,
                    1.7311e-07,
                    1.7344e-07,
                    1.7403e-07,
                    1.7486e-07,
                    1.7594e-07,
                    1.7727e-07,
                    1.7884e-07,
                    1.8065e-07,
                    1.827e-07,
                    1.8499e-07,
                    1.8732e-07,
                    1.8969e-07,
                    2.3848e-07,
                    3.337e-07,
                    4.7531e-07,
                    6.6332e-07,
                    8.9772e-07,
                    1.1785e-06,
                    1.5056e-06,
                    1.8793e-06,
                    2.3005e-06,
                    2.7692e-06,
                    3.2854e-06,
                    3.8491e-06,
                    5.3028e-06,
                    7.776e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011
                ],
                "Fossil_CH4": 0.42,
                "Fossil_CH4_timeseries": [
                    4.2172e-09,
                    8.4454e-09,
                    1.2684e-08,
                    1.6934e-08,
                    2.1195e-08,
                    2.5466e-08,
                    2.9747e-08,
                    3.4039e-08,
                    3.8341e-08,
                    4.2652e-08,
                    4.6841e-08,
                    5.0907e-08,
                    5.4849e-08,
                    5.8669e-08,
                    6.2366e-08,
                    6.5941e-08,
                    6.9394e-08,
                    7.2725e-08,
                    7.5934e-08,
                    7.9022e-08,
                    8.1981e-08,
                    8.481e-08,
                    8.7511e-08,
                    9.0084e-08,
                    9.2528e-08,
                    9.4844e-08,
                    9.7032e-08,
                    9.9093e-08,
                    1.0103e-07,
                    1.0283e-07,
                    1.0463e-07,
                    1.0642e-07,
                    1.0819e-07,
                    1.0996e-07,
                    1.1172e-07,
                    1.1346e-07,
                    1.152e-07,
                    1.1693e-07,
                    1.1864e-07,
                    1.2035e-07,
                    1.2204e-07,
                    1.2373e-07,
                    1.254e-07,
                    1.2706e-07,
                    1.2871e-07,
                    1.3035e-07,
                    1.3197e-07,
                    1.3359e-07,
                    1.3519e-07,
                    1.3678e-07,
                    1.3813e-07,
                    1.3922e-07,
                    1.4007e-07,
                    1.4067e-07,
                    1.4104e-07,
                    1.4116e-07,
                    1.4106e-07,
                    1.4072e-07,
                    1.4015e-07,
                    1.3936e-07,
                    1.3854e-07,
                    1.3769e-07,
                    1.3682e-07,
                    1.3591e-07,
                    1.3498e-07,
                    1.3402e-07,
                    1.3303e-07,
                    1.3202e-07,
                    1.3097e-07,
                    1.2989e-07,
                    1.2903e-07,
                    1.2838e-07,
                    1.2793e-07,
                    1.2768e-07,
                    1.2764e-07,
                    1.278e-07,
                    1.2816e-07,
                    1.2872e-07,
                    1.2947e-07,
                    1.3042e-07,
                    1.3139e-07,
                    1.3239e-07,
                    1.798e-07,
                    2.7363e-07,
                    4.1384e-07,
                    6.0042e-07,
                    8.3336e-07,
                    1.1126e-06,
                    1.4382e-06,
                    1.8103e-06,
                    2.2299e-06,
                    2.697e-06,
                    3.2115e-06,
                    3.7735e-06,
                    5.2254e-06,
                    7.6969e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011
                ],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [
                    8.2558e-10,
                    1.6554e-09,
                    2.4894e-09,
                    3.3276e-09,
                    4.17e-09,
                    5.0166e-09,
                    5.8675e-09,
                    6.7225e-09,
                    7.5818e-09,
                    8.4453e-09,
                    9.2898e-09,
                    1.0115e-08,
                    1.0922e-08,
                    1.1709e-08,
                    1.2478e-08,
                    1.3227e-08,
                    1.3957e-08,
                    1.4669e-08,
                    1.5361e-08,
                    1.6035e-08,
                    1.6688e-08,
                    1.7321e-08,
                    1.7934e-08,
                    1.8526e-08,
                    1.9099e-08,
                    1.9651e-08,
                    2.0183e-08,
                    2.0694e-08,
                    2.1186e-08,
                    2.1657e-08,
                    2.2129e-08,
                    2.2601e-08,
                    2.3073e-08,
                    2.3546e-08,
                    2.402e-08,
                    2.4494e-08,
                    2.4969e-08,
                    2.5444e-08,
                    2.5919e-08,
                    2.6395e-08,
                    2.6872e-08,
                    2.7349e-08,
                    2.7826e-08,
                    2.8304e-08,
                    2.8782e-08,
                    2.9261e-08,
                    2.9741e-08,
                    3.022e-08,
                    3.0701e-08,
                    3.1182e-08,
                    3.1663e-08,
                    3.2145e-08,
                    3.2627e-08,
                    3.311e-08,
                    3.3593e-08,
                    3.4077e-08,
                    3.4561e-08,
                    3.5045e-08,
                    3.5531e-08,
                    3.6016e-08,
                    3.6543e-08,
                    3.7111e-08,
                    3.772e-08,
                    3.8371e-08,
                    3.9063e-08,
                    3.9795e-08,
                    4.0569e-08,
                    4.1385e-08,
                    4.2241e-08,
                    4.3139e-08,
                    4.4081e-08,
                    4.5068e-08,
                    4.61e-08,
                    4.7177e-08,
                    4.8299e-08,
                    4.9465e-08,
                    5.0676e-08,
                    5.1932e-08,
                    5.3233e-08,
                    5.4579e-08,
                    5.5935e-08,
                    5.7302e-08,
                    5.8679e-08,
                    6.0066e-08,
                    6.1464e-08,
                    6.2895e-08,
                    6.4359e-08,
                    6.5857e-08,
                    6.7388e-08,
                    6.8954e-08,
                    7.0554e-08,
                    7.2191e-08,
                    7.3863e-08,
                    7.5572e-08,
                    7.7318e-08,
                    7.9101e-08,
                    8.0921e-08,
                    8.278e-08,
                    8.4676e-08,
                    8.6611e-08,
                    8.8616e-08,
                    9.0798e-08,
                    9.3243e-08,
                    9.6015e-08,
                    9.9158e-08,
                    1.0268e-07,
                    1.066e-07,
                    1.1091e-07,
                    1.1562e-07,
                    1.2072e-07,
                    1.2573e-07,
                    1.3083e-07,
                    1.3608e-07,
                    1.4149e-07,
                    1.4702e-07,
                    1.539e-07,
                    1.6073e-07,
                    1.6748e-07,
                    1.7446e-07,
                    1.8149e-07,
                    1.8889e-07,
                    1.9755e-07,
                    2.0698e-07,
                    2.1396e-07,
                    2.2096e-07,
                    2.2796e-07,
                    2.3541e-07,
                    2.4278e-07,
                    2.5214e-07,
                    2.6086e-07,
                    2.6959e-07,
                    2.794e-07,
                    2.8939e-07,
                    2.9985e-07,
                    3.1381e-07,
                    3.2908e-07,
                    3.4727e-07,
                    3.7239e-07,
                    4.0187e-07,
                    4.3196e-07,
                    4.6007e-07,
                    4.873e-07,
                    5.1253e-07,
                    5.3838e-07,
                    5.6081e-07,
                    5.8598e-07,
                    6.1056e-07,
                    6.3592e-07,
                    6.6085e-07,
                    6.8411e-07,
                    7.0562e-07,
                    7.3922e-07,
                    7.6556e-07,
                    7.8815e-07,
                    8.0678e-07,
                    8.2324e-07,
                    8.3646e-07,
                    8.3729e-07,
                    8.3479e-07,
                    8.3749e-07,
                    8.417e-07,
                    8.4576e-07,
                    8.5175e-07,
                    8.591e-07,
                    8.6827e-07,
                    8.7494e-07,
                    8.817e-07,
                    8.8863e-07,
                    8.9549e-07,
                    9.0004e-07,
                    9.0831e-07,
                    9.0532e-07
                ],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [
                    3.7534e-10,
                    7.56e-10,
                    1.1418e-09,
                    1.5327e-09,
                    1.9283e-09,
                    2.3283e-09,
                    2.7324e-09,
                    3.1403e-09,
                    3.5515e-09,
                    3.9654e-09,
                    4.3817e-09,
                    4.8004e-09,
                    5.2215e-09,
                    5.6448e-09,
                    6.0703e-09,
                    6.4982e-09,
                    6.9283e-09,
                    7.3607e-09,
                    7.7955e-09,
                    8.2328e-09,
                    8.6752e-09,
                    9.1274e-09,
                    9.5929e-09,
                    1.0074e-08,
                    1.0572e-08,
                    1.1088e-08,
                    1.1621e-08,
                    1.2169e-08,
                    1.2728e-08,
                    1.3296e-08,
                    1.387e-08,
                    1.4448e-08,
                    1.5031e-08,
                    1.5618e-08,
                    1.621e-08,
                    1.6805e-08,
                    1.7404e-08,
                    1.8007e-08,
                    1.8615e-08,
                    1.9236e-08,
                    1.9861e-08,
                    2.049e-08,
                    2.1124e-08,
                    2.1762e-08,
                    2.2404e-08,
                    2.3052e-08,
                    2.3704e-08,
                    2.4362e-08,
                    2.5025e-08,
                    2.5694e-08,
                    2.6368e-08,
                    2.705e-08,
                    2.7738e-08,
                    2.8434e-08,
                    2.9138e-08,
                    2.985e-08,
                    3.057e-08,
                    3.1299e-08,
                    3.2035e-08,
                    3.2779e-08,
                    3.3531e-08,
                    3.429e-08,
                    3.5057e-08,
                    3.5831e-08,
                    3.6612e-08,
                    3.7401e-08,
                    3.8198e-08,
                    3.9002e-08,
                    3.9816e-08,
                    4.0638e-08,
                    4.1472e-08,
                    4.2322e-08,
                    4.3192e-08,
                    4.4086e-08,
                    4.5004e-08,
                    4.5948e-08,
                    4.6918e-08,
                    4.7914e-08,
                    4.8934e-08,
                    4.9975e-08,
                    5.1045e-08,
                    5.2161e-08,
                    5.3334e-08,
                    5.4577e-08,
                    5.5897e-08,
                    5.7298e-08,
                    5.8782e-08,
                    6.0349e-08,
                    6.1995e-08,
                    6.3714e-08,
                    6.5514e-08,
                    6.7417e-08,
                    6.944e-08,
                    7.1595e-08,
                    7.3884e-08,
                    7.6309e-08,
                    7.8862e-08,
                    8.1531e-08,
                    8.4297e-08,
                    8.7138e-08,
                    9.0041e-08,
                    9.3013e-08,
                    9.6058e-08,
                    9.9179e-08,
                    1.0238e-07,
                    1.0566e-07,
                    1.0902e-07,
                    1.1247e-07,
                    1.1599e-07,
                    1.1959e-07,
                    1.235e-07,
                    1.2763e-07,
                    1.321e-07,
                    1.3698e-07,
                    1.4239e-07,
                    1.4861e-07,
                    1.5555e-07,
                    1.6329e-07,
                    1.72e-07,
                    1.8262e-07,
                    1.9354e-07,
                    2.0564e-07,
                    2.1945e-07,
                    2.3459e-07,
                    2.5179e-07,
                    2.7105e-07,
                    2.9283e-07,
                    3.1604e-07,
                    3.4048e-07,
                    3.6556e-07,
                    3.932e-07,
                    4.2193e-07,
                    4.5296e-07,
                    4.8647e-07,
                    5.215e-07,
                    5.6069e-07,
                    5.9852e-07,
                    6.3869e-07,
                    6.8079e-07,
                    7.2492e-07,
                    7.6884e-07,
                    8.1756e-07,
                    8.684e-07,
                    9.2131e-07,
                    9.762e-07,
                    1.034e-06,
                    1.0954e-06,
                    1.1616e-06,
                    1.2271e-06,
                    1.2872e-06,
                    1.3487e-06,
                    1.4198e-06,
                    1.4932e-06,
                    1.568e-06,
                    1.6488e-06,
                    1.736e-06,
                    1.8215e-06,
                    1.911e-06,
                    1.9973e-06,
                    2.0898e-06,
                    2.1797e-06,
                    2.2711e-06,
                    2.3678e-06,
                    2.4666e-06,
                    2.5662e-06,
                    2.6638e-06,
                    2.7646e-06,
                    2.8676e-06,
                    2.972e-06,
                    3.0768e-06,
                    3.1848e-06,
                    3.2956e-06
                ],
                "Fossil_N2O": 0.01,
                "Fossil_N2O_timeseries": [
                    2.782e-10,
                    5.5978e-10,
                    8.4468e-10,
                    1.1328e-09,
                    1.4241e-09,
                    1.7185e-09,
                    2.0157e-09,
                    2.3157e-09,
                    2.6183e-09,
                    2.9233e-09,
                    3.2305e-09,
                    3.54e-09,
                    3.8517e-09,
                    4.1655e-09,
                    4.4816e-09,
                    4.7999e-09,
                    5.1203e-09,
                    5.443e-09,
                    5.7679e-09,
                    6.0951e-09,
                    6.4256e-09,
                    6.7612e-09,
                    7.1032e-09,
                    7.4527e-09,
                    7.8101e-09,
                    8.1756e-09,
                    8.5489e-09,
                    8.9293e-09,
                    9.3157e-09,
                    9.7066e-09,
                    1.0101e-08,
                    1.0499e-08,
                    1.0899e-08,
                    1.1303e-08,
                    1.1709e-08,
                    1.2119e-08,
                    1.2531e-08,
                    1.2946e-08,
                    1.3364e-08,
                    1.3787e-08,
                    1.4214e-08,
                    1.4644e-08,
                    1.5078e-08,
                    1.5515e-08,
                    1.5957e-08,
                    1.6403e-08,
                    1.6853e-08,
                    1.7307e-08,
                    1.7765e-08,
                    1.8228e-08,
                    1.8696e-08,
                    1.9169e-08,
                    1.9647e-08,
                    2.0132e-08,
                    2.0622e-08,
                    2.1119e-08,
                    2.1621e-08,
                    2.213e-08,
                    2.2646e-08,
                    2.3166e-08,
                    2.3693e-08,
                    2.4226e-08,
                    2.4764e-08,
                    2.5308e-08,
                    2.5858e-08,
                    2.6414e-08,
                    2.6975e-08,
                    2.7542e-08,
                    2.8114e-08,
                    2.8693e-08,
                    2.9276e-08,
                    2.9865e-08,
                    3.0459e-08,
                    3.1059e-08,
                    3.1664e-08,
                    3.2274e-08,
                    3.2889e-08,
                    3.351e-08,
                    3.4136e-08,
                    3.4768e-08,
                    3.5415e-08,
                    3.6094e-08,
                    3.6819e-08,
                    3.7601e-08,
                    3.8448e-08,
                    3.9364e-08,
                    4.0353e-08,
                    4.1411e-08,
                    4.2536e-08,
                    4.372e-08,
                    4.4964e-08,
                    4.6278e-08,
                    4.7669e-08,
                    4.914e-08,
                    5.0693e-08,
                    5.2326e-08,
                    5.4034e-08,
                    5.581e-08,
                    5.7644e-08,
                    5.9522e-08,
                    6.1436e-08,
                    6.3388e-08,
                    6.5377e-08,
                    6.7405e-08,
                    6.9475e-08,
                    7.159e-08,
                    7.3753e-08,
                    7.5968e-08,
                    7.8242e-08,
                    8.0578e-08,
                    8.3027e-08,
                    8.5681e-08,
                    8.8633e-08,
                    9.1983e-08,
                    9.5827e-08,
                    1.0027e-07,
                    1.0541e-07,
                    1.1135e-07,
                    1.1821e-07,
                    1.2695e-07,
                    1.3593e-07,
                    1.4584e-07,
                    1.5725e-07,
                    1.7022e-07,
                    1.8493e-07,
                    2.0165e-07,
                    2.2068e-07,
                    2.411e-07,
                    2.6239e-07,
                    2.844e-07,
                    3.0828e-07,
                    3.3367e-07,
                    3.6095e-07,
                    3.9029e-07,
                    4.2098e-07,
                    4.5351e-07,
                    4.8642e-07,
                    5.2079e-07,
                    5.5641e-07,
                    5.9377e-07,
                    6.3098e-07,
                    6.7291e-07,
                    7.1729e-07,
                    7.6388e-07,
                    8.1277e-07,
                    8.6421e-07,
                    9.1924e-07,
                    9.7769e-07,
                    1.0367e-06,
                    1.0905e-06,
                    1.1461e-06,
                    1.2053e-06,
                    1.2676e-06,
                    1.3316e-06,
                    1.4016e-06,
                    1.4781e-06,
                    1.5547e-06,
                    1.6329e-06,
                    1.7105e-06,
                    1.7901e-06,
                    1.869e-06,
                    1.9493e-06,
                    2.0345e-06,
                    2.1218e-06,
                    2.2098e-06,
                    2.2999e-06,
                    2.3932e-06,
                    2.4882e-06,
                    2.5842e-06,
                    2.6812e-06,
                    2.7811e-06,
                    2.8831e-06
                ],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": [
                    9.7139e-11,
                    1.9622e-10,
                    2.9716e-10,
                    3.9985e-10,
                    5.0413e-10,
                    6.0983e-10,
                    7.1673e-10,
                    8.2459e-10,
                    9.3314e-10,
                    1.0421e-09,
                    1.1512e-09,
                    1.2604e-09,
                    1.3698e-09,
                    1.4792e-09,
                    1.5887e-09,
                    1.6983e-09,
                    1.8079e-09,
                    1.9177e-09,
                    2.0276e-09,
                    2.1377e-09,
                    2.2496e-09,
                    2.3662e-09,
                    2.4897e-09,
                    2.6214e-09,
                    2.7624e-09,
                    2.9128e-09,
                    3.0721e-09,
                    3.2393e-09,
                    3.4126e-09,
                    3.5896e-09,
                    3.7687e-09,
                    3.9495e-09,
                    4.1319e-09,
                    4.3155e-09,
                    4.5002e-09,
                    4.6861e-09,
                    4.873e-09,
                    5.0611e-09,
                    5.2504e-09,
                    5.4487e-09,
                    5.6473e-09,
                    5.8464e-09,
                    6.0459e-09,
                    6.2462e-09,
                    6.4472e-09,
                    6.649e-09,
                    6.8518e-09,
                    7.0555e-09,
                    7.2602e-09,
                    7.4659e-09,
                    7.6728e-09,
                    7.8811e-09,
                    8.091e-09,
                    8.3026e-09,
                    8.516e-09,
                    8.7314e-09,
                    8.9488e-09,
                    9.1682e-09,
                    9.3896e-09,
                    9.613e-09,
                    9.8381e-09,
                    1.0065e-08,
                    1.0293e-08,
                    1.0523e-08,
                    1.0754e-08,
                    1.0988e-08,
                    1.1223e-08,
                    1.1461e-08,
                    1.1701e-08,
                    1.1945e-08,
                    1.2195e-08,
                    1.2457e-08,
                    1.2733e-08,
                    1.3027e-08,
                    1.334e-08,
                    1.3674e-08,
                    1.4029e-08,
                    1.4405e-08,
                    1.4798e-08,
                    1.5208e-08,
                    1.5631e-08,
                    1.6067e-08,
                    1.6516e-08,
                    1.6977e-08,
                    1.7449e-08,
                    1.7933e-08,
                    1.8429e-08,
                    1.8938e-08,
                    1.9459e-08,
                    1.9994e-08,
                    2.0549e-08,
                    2.1139e-08,
                    2.1772e-08,
                    2.2455e-08,
                    2.3191e-08,
                    2.3983e-08,
                    2.4828e-08,
                    2.572e-08,
                    2.6653e-08,
                    2.7616e-08,
                    2.8605e-08,
                    2.9625e-08,
                    3.0681e-08,
                    3.1774e-08,
                    3.2905e-08,
                    3.4072e-08,
                    3.5272e-08,
                    3.65e-08,
                    3.775e-08,
                    3.9013e-08,
                    4.0476e-08,
                    4.1951e-08,
                    4.3463e-08,
                    4.5e-08,
                    4.6561e-08,
                    4.8344e-08,
                    5.0139e-08,
                    5.1934e-08,
                    5.379e-08,
                    5.5671e-08,
                    5.7613e-08,
                    5.9802e-08,
                    6.2199e-08,
                    6.4363e-08,
                    6.6858e-08,
                    6.9403e-08,
                    7.2145e-08,
                    7.4948e-08,
                    7.8083e-08,
                    8.1156e-08,
                    8.4918e-08,
                    8.8262e-08,
                    9.2012e-08,
                    9.6179e-08,
                    1.0052e-07,
                    1.0718e-07,
                    1.121e-07,
                    1.179e-07,
                    1.2438e-07,
                    1.3116e-07,
                    1.3786e-07,
                    1.4465e-07,
                    1.5111e-07,
                    1.5743e-07,
                    1.6343e-07,
                    1.6977e-07,
                    1.7618e-07,
                    1.8388e-07,
                    1.9044e-07,
                    1.9669e-07,
                    2.0269e-07,
                    2.1453e-07,
                    2.2565e-07,
                    2.3642e-07,
                    2.4715e-07,
                    2.5793e-07,
                    2.6683e-07,
                    2.7814e-07,
                    2.8682e-07,
                    2.9967e-07,
                    3.1068e-07,
                    3.2186e-07,
                    3.3326e-07,
                    3.4479e-07,
                    3.5633e-07,
                    3.6384e-07,
                    3.7144e-07,
                    3.7936e-07,
                    3.8778e-07,
                    3.9556e-07,
                    4.0368e-07,
                    4.1243e-07
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            50.45476,
                            26.16102
                        ],
                        [
                            50.49325,
                            26.04355
                        ],
                        [
                            50.46575,
                            25.94966
                        ],
                        [
                            50.53047,
                            25.88996
                        ],
                        [
                            50.57213,
                            25.80225
                        ],
                        [
                            50.61326,
                            25.84976
                        ],
                        [
                            50.63498,
                            26.02969
                        ],
                        [
                            50.62882,
                            26.12157
                        ],
                        [
                            50.51341,
                            26.23152
                        ],
                        [
                            50.45503,
                            26.20928
                        ],
                        [
                            50.45476,
                            26.16102
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "BGD",
                "Country": "Bangladesh",
                "Total_3GHG": 0.41,
                "Total_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.004,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0045,
                    0.0046,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.005,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0055,
                    0.0056,
                    0.0057,
                    0.0058,
                    0.0059,
                    0.006,
                    0.0062,
                    0.0063,
                    0.0064,
                    0.0065,
                    0.0067,
                    0.0068
                ],
                "Fossil_3GHG": 0.23,
                "Fossil_3GHG_timeseries": [
                    2.2803e-06,
                    4.5951e-06,
                    6.9449e-06,
                    9.33e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025
                ],
                "Land_3GHG": 0.75,
                "Land_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0033,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0035,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.004,
                    0.004,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0043
                ],
                "Total_CO2": 0.17,
                "Total_CO2_timeseries": [
                    6.0778e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019
                ],
                "Fossil_CO2": 0.1,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    5.2902e-08,
                    1.0761e-07,
                    1.6799e-07,
                    2.5366e-07,
                    7.0086e-07,
                    1.2531e-06,
                    1.8363e-06,
                    2.4298e-06,
                    3.0326e-06,
                    3.6538e-06,
                    4.3897e-06,
                    5.1502e-06,
                    6.0041e-06,
                    6.8327e-06,
                    7.8288e-06,
                    8.8602e-06,
                    9.9936e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008
                ],
                "Land_CO2": 0.3,
                "Land_CO2_timeseries": [
                    6.0778e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011
                ],
                "Total_CH4": 1.01,
                "Total_CH4_timeseries": [
                    8.9882e-06,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0042
                ],
                "Fossil_CH4": 0.61,
                "Fossil_CH4_timeseries": [
                    2.2232e-06,
                    4.4802e-06,
                    6.7714e-06,
                    9.0969e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016
                ],
                "Land_CH4": 1.66,
                "Land_CH4_timeseries": [
                    6.765e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026
                ],
                "Total_N2O": 0.83,
                "Total_N2O_timeseries": [
                    1.0346e-06,
                    2.0897e-06,
                    3.1642e-06,
                    4.2571e-06,
                    5.3669e-06,
                    6.4915e-06,
                    7.629e-06,
                    8.7767e-06,
                    9.9318e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Fossil_N2O": 0.39,
                "Fossil_N2O_timeseries": [
                    5.702e-08,
                    1.1489e-07,
                    1.7359e-07,
                    2.3308e-07,
                    2.9333e-07,
                    3.5427e-07,
                    4.1585e-07,
                    4.7799e-07,
                    5.4061e-07,
                    6.0363e-07,
                    6.6699e-07,
                    7.3067e-07,
                    7.9466e-07,
                    8.5896e-07,
                    9.2356e-07,
                    9.8846e-07,
                    1.0537e-06,
                    1.1192e-06,
                    1.185e-06,
                    1.2512e-06,
                    1.3182e-06,
                    1.3869e-06,
                    1.4578e-06,
                    1.5315e-06,
                    1.6082e-06,
                    1.6879e-06,
                    1.7704e-06,
                    1.8556e-06,
                    1.9429e-06,
                    2.0315e-06,
                    2.121e-06,
                    2.2113e-06,
                    2.3024e-06,
                    2.3941e-06,
                    2.4864e-06,
                    2.5793e-06,
                    2.6728e-06,
                    2.767e-06,
                    2.8618e-06,
                    2.9606e-06,
                    3.061e-06,
                    3.1629e-06,
                    3.2666e-06,
                    3.3721e-06,
                    3.4794e-06,
                    3.5887e-06,
                    3.7e-06,
                    3.8134e-06,
                    3.9291e-06,
                    4.047e-06,
                    4.1675e-06,
                    4.2908e-06,
                    4.4173e-06,
                    4.5471e-06,
                    4.6803e-06,
                    4.8169e-06,
                    4.9568e-06,
                    5.0998e-06,
                    5.2457e-06,
                    5.3942e-06,
                    5.5449e-06,
                    5.6979e-06,
                    5.8529e-06,
                    6.0099e-06,
                    6.1688e-06,
                    6.3297e-06,
                    6.4924e-06,
                    6.657e-06,
                    6.8235e-06,
                    6.9918e-06,
                    7.1619e-06,
                    7.3338e-06,
                    7.5074e-06,
                    7.6826e-06,
                    7.8595e-06,
                    8.0381e-06,
                    8.2185e-06,
                    8.4007e-06,
                    8.5847e-06,
                    8.7708e-06,
                    8.9591e-06,
                    9.1501e-06,
                    9.3441e-06,
                    9.5414e-06,
                    9.7422e-06,
                    9.9466e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_N2O": 1.0,
                "Land_N2O_timeseries": [
                    9.7761e-07,
                    1.9748e-06,
                    2.9906e-06,
                    4.0241e-06,
                    5.0735e-06,
                    6.1373e-06,
                    7.2131e-06,
                    8.2987e-06,
                    9.3912e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                89.07979,
                                22.15484
                            ],
                            [
                                89.05702,
                                22.06619
                            ],
                            [
                                89.08902,
                                22.02363
                            ],
                            [
                                89.08209,
                                21.90413
                            ],
                            [
                                89.10337,
                                21.81532
                            ],
                            [
                                89.14983,
                                21.79692
                            ],
                            [
                                89.19895,
                                21.90999
                            ],
                            [
                                89.14562,
                                21.91748
                            ],
                            [
                                89.13604,
                                21.96902
                            ],
                            [
                                89.16144,
                                21.9962
                            ],
                            [
                                89.14703,
                                22.03273
                            ],
                            [
                                89.16939,
                                22.02863
                            ],
                            [
                                89.20518,
                                22.00973
                            ],
                            [
                                89.28254,
                                22.12481
                            ],
                            [
                                89.32434,
                                21.99658
                            ],
                            [
                                89.38395,
                                21.89814
                            ],
                            [
                                89.35213,
                                21.80316
                            ],
                            [
                                89.36926,
                                21.74216
                            ],
                            [
                                89.41739,
                                21.73059
                            ],
                            [
                                89.47184,
                                21.79888
                            ],
                            [
                                89.45004,
                                21.85757
                            ],
                            [
                                89.50905,
                                21.95641
                            ],
                            [
                                89.46743,
                                22.0457
                            ],
                            [
                                89.4548,
                                22.14507
                            ],
                            [
                                89.48101,
                                22.21967
                            ],
                            [
                                89.55858,
                                22.00631
                            ],
                            [
                                89.57091,
                                21.94714
                            ],
                            [
                                89.632,
                                21.95223
                            ],
                            [
                                89.67446,
                                21.84069
                            ],
                            [
                                89.82657,
                                21.84943
                            ],
                            [
                                89.87434,
                                21.90407
                            ],
                            [
                                89.85271,
                                22.03134
                            ],
                            [
                                89.90568,
                                22.06785
                            ],
                            [
                                89.94265,
                                21.95747
                            ],
                            [
                                90.02428,
                                21.98147
                            ],
                            [
                                90.03359,
                                21.90501
                            ],
                            [
                                90.11169,
                                21.89659
                            ],
                            [
                                90.09266,
                                21.8414
                            ],
                            [
                                90.15967,
                                21.80462
                            ],
                            [
                                90.24568,
                                21.83462
                            ],
                            [
                                90.32943,
                                22.03863
                            ],
                            [
                                90.38954,
                                22.10407
                            ],
                            [
                                90.46032,
                                22.10438
                            ],
                            [
                                90.54403,
                                22.21955
                            ],
                            [
                                90.60245,
                                22.26308
                            ],
                            [
                                90.65606,
                                22.23661
                            ],
                            [
                                90.62495,
                                22.17916
                            ],
                            [
                                90.60312,
                                22.03554
                            ],
                            [
                                90.63604,
                                21.9977
                            ],
                            [
                                90.69187,
                                22.01038
                            ],
                            [
                                90.81816,
                                22.13884
                            ],
                            [
                                90.84147,
                                22.27009
                            ],
                            [
                                90.84208,
                                22.36201
                            ],
                            [
                                90.87214,
                                22.43413
                            ],
                            [
                                91.03719,
                                22.52808
                            ],
                            [
                                91.10741,
                                22.48314
                            ],
                            [
                                91.24641,
                                22.55628
                            ],
                            [
                                91.25864,
                                22.67159
                            ],
                            [
                                91.29061,
                                22.73606
                            ],
                            [
                                91.41288,
                                22.76179
                            ],
                            [
                                91.4798,
                                22.74746
                            ],
                            [
                                91.56335,
                                22.67773
                            ],
                            [
                                91.69476,
                                22.50881
                            ],
                            [
                                91.74172,
                                22.4188
                            ],
                            [
                                91.76957,
                                22.27215
                            ],
                            [
                                91.81357,
                                22.20344
                            ],
                            [
                                91.881,
                                22.03528
                            ],
                            [
                                91.91887,
                                21.85851
                            ],
                            [
                                91.85943,
                                21.66732
                            ],
                            [
                                91.90434,
                                21.51981
                            ],
                            [
                                92.00531,
                                21.50929
                            ],
                            [
                                91.96055,
                                21.4382
                            ],
                            [
                                92.0443,
                                21.30109
                            ],
                            [
                                92.04698,
                                21.19806
                            ],
                            [
                                92.07468,
                                21.14463
                            ],
                            [
                                92.18217,
                                21.01738
                            ],
                            [
                                92.22421,
                                20.91655
                            ],
                            [
                                92.26399,
                                20.94394
                            ],
                            [
                                92.25264,
                                21.06025
                            ],
                            [
                                92.20214,
                                21.15074
                            ],
                            [
                                92.17522,
                                21.17825
                            ],
                            [
                                92.22254,
                                21.25406
                            ],
                            [
                                92.20265,
                                21.30405
                            ],
                            [
                                92.25924,
                                21.35824
                            ],
                            [
                                92.27383,
                                21.42493
                            ],
                            [
                                92.3299,
                                21.41751
                            ],
                            [
                                92.38133,
                                21.47818
                            ],
                            [
                                92.42265,
                                21.4376
                            ],
                            [
                                92.44175,
                                21.36566
                            ],
                            [
                                92.50129,
                                21.35146
                            ],
                            [
                                92.56131,
                                21.37953
                            ],
                            [
                                92.59809,
                                21.2424
                            ],
                            [
                                92.68006,
                                21.28635
                            ],
                            [
                                92.62515,
                                21.47214
                            ],
                            [
                                92.60172,
                                21.70194
                            ],
                            [
                                92.61694,
                                21.84653
                            ],
                            [
                                92.63344,
                                21.87414
                            ],
                            [
                                92.60676,
                                21.9712
                            ],
                            [
                                92.60654,
                                22.13471
                            ],
                            [
                                92.57848,
                                22.32328
                            ],
                            [
                                92.52531,
                                22.55517
                            ],
                            [
                                92.53552,
                                22.5876
                            ],
                            [
                                92.5146,
                                22.71788
                            ],
                            [
                                92.47475,
                                22.74741
                            ],
                            [
                                92.44251,
                                22.88459
                            ],
                            [
                                92.37339,
                                22.95475
                            ],
                            [
                                92.38833,
                                23.04843
                            ],
                            [
                                92.34901,
                                23.23355
                            ],
                            [
                                92.38549,
                                23.26722
                            ],
                            [
                                92.37595,
                                23.34894
                            ],
                            [
                                92.32773,
                                23.42485
                            ],
                            [
                                92.3027,
                                23.57782
                            ],
                            [
                                92.27383,
                                23.64217
                            ],
                            [
                                92.28895,
                                23.69342
                            ],
                            [
                                92.20989,
                                23.69609
                            ],
                            [
                                92.16939,
                                23.73354
                            ],
                            [
                                92.03091,
                                23.64032
                            ],
                            [
                                91.97813,
                                23.72176
                            ],
                            [
                                91.93828,
                                23.67844
                            ],
                            [
                                91.96603,
                                23.48668
                            ],
                            [
                                91.93624,
                                23.43104
                            ],
                            [
                                91.84132,
                                23.3976
                            ],
                            [
                                91.77124,
                                23.2676
                            ],
                            [
                                91.80475,
                                23.16796
                            ],
                            [
                                91.81222,
                                23.06745
                            ],
                            [
                                91.77456,
                                23.05958
                            ],
                            [
                                91.71688,
                                22.98532
                            ],
                            [
                                91.62621,
                                22.95389
                            ],
                            [
                                91.54485,
                                22.99383
                            ],
                            [
                                91.49628,
                                23.18643
                            ],
                            [
                                91.42817,
                                23.2584
                            ],
                            [
                                91.3928,
                                23.25753
                            ],
                            [
                                91.38003,
                                23.17478
                            ],
                            [
                                91.4015,
                                23.08746
                            ],
                            [
                                91.34899,
                                23.08798
                            ],
                            [
                                91.31829,
                                23.24834
                            ],
                            [
                                91.24334,
                                23.48269
                            ],
                            [
                                91.16261,
                                23.59651
                            ],
                            [
                                91.15154,
                                23.7153
                            ],
                            [
                                91.21175,
                                23.73944
                            ],
                            [
                                91.24576,
                                23.83425
                            ],
                            [
                                91.22838,
                                23.87788
                            ],
                            [
                                91.26322,
                                23.95888
                            ],
                            [
                                91.30339,
                                23.9872
                            ],
                            [
                                91.37002,
                                23.9789
                            ],
                            [
                                91.41081,
                                24.10851
                            ],
                            [
                                91.53733,
                                24.07129
                            ],
                            [
                                91.63764,
                                24.10595
                            ],
                            [
                                91.68449,
                                24.16926
                            ],
                            [
                                91.75926,
                                24.15758
                            ],
                            [
                                91.75829,
                                24.23561
                            ],
                            [
                                91.83816,
                                24.19985
                            ],
                            [
                                91.90596,
                                24.14509
                            ],
                            [
                                91.92815,
                                24.23859
                            ],
                            [
                                91.92213,
                                24.32774
                            ],
                            [
                                91.96599,
                                24.37012
                            ],
                            [
                                92.0869,
                                24.374
                            ],
                            [
                                92.13683,
                                24.39804
                            ],
                            [
                                92.12929,
                                24.51365
                            ],
                            [
                                92.18254,
                                24.55539
                            ],
                            [
                                92.27385,
                                24.78573
                            ],
                            [
                                92.27925,
                                24.85319
                            ],
                            [
                                92.42951,
                                24.85292
                            ],
                            [
                                92.48934,
                                24.86886
                            ],
                            [
                                92.46186,
                                24.96129
                            ],
                            [
                                92.40046,
                                25.03226
                            ],
                            [
                                92.21848,
                                25.10145
                            ],
                            [
                                92.20721,
                                25.12404
                            ],
                            [
                                92.0546,
                                25.18492
                            ],
                            [
                                91.78699,
                                25.16523
                            ],
                            [
                                91.63702,
                                25.1234
                            ],
                            [
                                91.58388,
                                25.16451
                            ],
                            [
                                91.48072,
                                25.13504
                            ],
                            [
                                91.25803,
                                25.20176
                            ],
                            [
                                91.07458,
                                25.1949
                            ],
                            [
                                90.95451,
                                25.16003
                            ],
                            [
                                90.83473,
                                25.15478
                            ],
                            [
                                90.76065,
                                25.17787
                            ],
                            [
                                90.72485,
                                25.1577
                            ],
                            [
                                90.64801,
                                25.18351
                            ],
                            [
                                90.53254,
                                25.17357
                            ],
                            [
                                90.43921,
                                25.14688
                            ],
                            [
                                90.31403,
                                25.18763
                            ],
                            [
                                90.1103,
                                25.22649
                            ],
                            [
                                89.95267,
                                25.30065
                            ],
                            [
                                89.83447,
                                25.29984
                            ],
                            [
                                89.81638,
                                25.37555
                            ],
                            [
                                89.86852,
                                25.5837
                            ],
                            [
                                89.86793,
                                25.66426
                            ],
                            [
                                89.82409,
                                25.73509
                            ],
                            [
                                89.83694,
                                25.87861
                            ],
                            [
                                89.82767,
                                25.98673
                            ],
                            [
                                89.77893,
                                26.04314
                            ],
                            [
                                89.78364,
                                26.0943
                            ],
                            [
                                89.74645,
                                26.15304
                            ],
                            [
                                89.67921,
                                26.16882
                            ],
                            [
                                89.59277,
                                26.15489
                            ],
                            [
                                89.60822,
                                26.05692
                            ],
                            [
                                89.53786,
                                25.99704
                            ],
                            [
                                89.469,
                                26.00243
                            ],
                            [
                                89.41143,
                                26.03652
                            ],
                            [
                                89.35688,
                                26.00965
                            ],
                            [
                                89.2632,
                                26.06222
                            ],
                            [
                                89.14095,
                                26.18552
                            ],
                            [
                                89.10542,
                                26.28581
                            ],
                            [
                                89.09815,
                                26.39487
                            ],
                            [
                                89.04858,
                                26.39809
                            ],
                            [
                                88.95416,
                                26.4589
                            ],
                            [
                                88.91561,
                                26.36766
                            ],
                            [
                                88.98094,
                                26.34863
                            ],
                            [
                                89.064,
                                26.25862
                            ],
                            [
                                88.96341,
                                26.23544
                            ],
                            [
                                88.90806,
                                26.28827
                            ],
                            [
                                88.83628,
                                26.2382
                            ],
                            [
                                88.79535,
                                26.31113
                            ],
                            [
                                88.73349,
                                26.32668
                            ],
                            [
                                88.67891,
                                26.40353
                            ],
                            [
                                88.5239,
                                26.48672
                            ],
                            [
                                88.47946,
                                26.54205
                            ],
                            [
                                88.37503,
                                26.58365
                            ],
                            [
                                88.33267,
                                26.48679
                            ],
                            [
                                88.47913,
                                26.46033
                            ],
                            [
                                88.52244,
                                26.37144
                            ],
                            [
                                88.45112,
                                26.36988
                            ],
                            [
                                88.34701,
                                26.27684
                            ],
                            [
                                88.34897,
                                26.21857
                            ],
                            [
                                88.18314,
                                26.14578
                            ],
                            [
                                88.16173,
                                26.08285
                            ],
                            [
                                88.18062,
                                26.02579
                            ],
                            [
                                88.08952,
                                25.9318
                            ],
                            [
                                88.11752,
                                25.80351
                            ],
                            [
                                88.15184,
                                25.7817
                            ],
                            [
                                88.26151,
                                25.81231
                            ],
                            [
                                88.2738,
                                25.78253
                            ],
                            [
                                88.44596,
                                25.66614
                            ],
                            [
                                88.44561,
                                25.60451
                            ],
                            [
                                88.55162,
                                25.51612
                            ],
                            [
                                88.71036,
                                25.50008
                            ],
                            [
                                88.80079,
                                25.51675
                            ],
                            [
                                88.83722,
                                25.46108
                            ],
                            [
                                88.83654,
                                25.37037
                            ],
                            [
                                88.90929,
                                25.32078
                            ],
                            [
                                88.99617,
                                25.31746
                            ],
                            [
                                88.94919,
                                25.25392
                            ],
                            [
                                88.9208,
                                25.17369
                            ],
                            [
                                88.85692,
                                25.20659
                            ],
                            [
                                88.79766,
                                25.17578
                            ],
                            [
                                88.71379,
                                25.20643
                            ],
                            [
                                88.61325,
                                25.20464
                            ],
                            [
                                88.55854,
                                25.18051
                            ],
                            [
                                88.48215,
                                25.2145
                            ],
                            [
                                88.44078,
                                25.19631
                            ],
                            [
                                88.4419,
                                25.03441
                            ],
                            [
                                88.38859,
                                24.95035
                            ],
                            [
                                88.27451,
                                24.89528
                            ],
                            [
                                88.226,
                                24.95666
                            ],
                            [
                                88.13958,
                                24.92288
                            ],
                            [
                                88.16379,
                                24.85522
                            ],
                            [
                                88.0327,
                                24.68836
                            ],
                            [
                                88.08559,
                                24.61908
                            ],
                            [
                                88.12554,
                                24.5197
                            ],
                            [
                                88.2087,
                                24.47366
                            ],
                            [
                                88.33633,
                                24.43861
                            ],
                            [
                                88.37784,
                                24.39755
                            ],
                            [
                                88.49383,
                                24.3303
                            ],
                            [
                                88.64887,
                                24.30616
                            ],
                            [
                                88.72988,
                                24.27467
                            ],
                            [
                                88.73252,
                                24.20823
                            ],
                            [
                                88.69914,
                                24.10971
                            ],
                            [
                                88.77076,
                                23.99419
                            ],
                            [
                                88.74787,
                                23.93504
                            ],
                            [
                                88.6682,
                                23.86635
                            ],
                            [
                                88.59959,
                                23.86128
                            ],
                            [
                                88.57824,
                                23.7844
                            ],
                            [
                                88.60262,
                                23.63489
                            ],
                            [
                                88.66575,
                                23.55293
                            ],
                            [
                                88.7947,
                                23.44915
                            ],
                            [
                                88.71768,
                                23.28822
                            ],
                            [
                                88.73058,
                                23.25708
                            ],
                            [
                                88.91762,
                                23.23223
                            ],
                            [
                                88.94691,
                                23.17122
                            ],
                            [
                                88.87501,
                                23.07881
                            ],
                            [
                                88.89177,
                                23.03834
                            ],
                            [
                                88.87272,
                                22.95319
                            ],
                            [
                                88.97087,
                                22.84292
                            ],
                            [
                                88.92519,
                                22.75805
                            ],
                            [
                                88.96731,
                                22.68883
                            ],
                            [
                                88.93931,
                                22.63115
                            ],
                            [
                                88.95098,
                                22.56061
                            ],
                            [
                                89.00015,
                                22.4689
                            ],
                            [
                                89.00798,
                                22.28213
                            ],
                            [
                                89.07635,
                                22.19867
                            ],
                            [
                                89.08024,
                                22.18335
                            ],
                            [
                                89.07979,
                                22.15484
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                91.02326,
                                22.10563
                            ],
                            [
                                91.06348,
                                22.09919
                            ],
                            [
                                91.16482,
                                22.18555
                            ],
                            [
                                91.18407,
                                22.29904
                            ],
                            [
                                91.12943,
                                22.40082
                            ],
                            [
                                91.07836,
                                22.42287
                            ],
                            [
                                91.06927,
                                22.24975
                            ],
                            [
                                91.02326,
                                22.10563
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                89.14096,
                                21.95025
                            ],
                            [
                                89.20579,
                                21.92026
                            ],
                            [
                                89.19372,
                                21.78662
                            ],
                            [
                                89.227,
                                21.70632
                            ],
                            [
                                89.2782,
                                21.70478
                            ],
                            [
                                89.26886,
                                21.88124
                            ],
                            [
                                89.21116,
                                21.93608
                            ],
                            [
                                89.20587,
                                21.96151
                            ],
                            [
                                89.23888,
                                21.98533
                            ],
                            [
                                89.19744,
                                22.00095
                            ],
                            [
                                89.18404,
                                22.01978
                            ],
                            [
                                89.14381,
                                21.96288
                            ],
                            [
                                89.14096,
                                21.95025
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                91.41879,
                                22.51911
                            ],
                            [
                                91.48191,
                                22.39572
                            ],
                            [
                                91.56461,
                                22.40834
                            ],
                            [
                                91.54571,
                                22.47866
                            ],
                            [
                                91.46352,
                                22.60052
                            ],
                            [
                                91.41985,
                                22.57789
                            ],
                            [
                                91.41879,
                                22.51911
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                90.31429,
                                21.85703
                            ],
                            [
                                90.38389,
                                21.90272
                            ],
                            [
                                90.47594,
                                21.93241
                            ],
                            [
                                90.47276,
                                22.03072
                            ],
                            [
                                90.42425,
                                22.03357
                            ],
                            [
                                90.359,
                                21.9819
                            ],
                            [
                                90.31429,
                                21.85703
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                89.21137,
                                21.9536
                            ],
                            [
                                89.29436,
                                21.90784
                            ],
                            [
                                89.34125,
                                21.95364
                            ],
                            [
                                89.27833,
                                22.05097
                            ],
                            [
                                89.2199,
                                22.00814
                            ],
                            [
                                89.24777,
                                21.97475
                            ],
                            [
                                89.21137,
                                21.9536
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                89.5488,
                                21.87755
                            ],
                            [
                                89.65917,
                                21.75242
                            ],
                            [
                                89.69566,
                                21.79584
                            ],
                            [
                                89.62726,
                                21.86368
                            ],
                            [
                                89.64583,
                                21.90989
                            ],
                            [
                                89.57789,
                                21.93664
                            ],
                            [
                                89.5488,
                                21.87755
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                90.48359,
                                22.05682
                            ],
                            [
                                90.51882,
                                21.98168
                            ],
                            [
                                90.591,
                                22.06566
                            ],
                            [
                                90.60367,
                                22.1859
                            ],
                            [
                                90.54956,
                                22.15807
                            ],
                            [
                                90.48359,
                                22.05682
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                91.29512,
                                22.69408
                            ],
                            [
                                91.33249,
                                22.63505
                            ],
                            [
                                91.40327,
                                22.65103
                            ],
                            [
                                91.3499,
                                22.7148
                            ],
                            [
                                91.29512,
                                22.69408
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "BRB",
                "Country": "Barbados",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    3.9834e-08,
                    7.9165e-08,
                    1.1849e-07,
                    1.5779e-07,
                    1.9702e-07,
                    2.3716e-07,
                    2.7805e-07,
                    3.1957e-07,
                    3.6209e-07,
                    4.0544e-07,
                    4.4939e-07,
                    4.9355e-07,
                    5.3806e-07,
                    5.8279e-07,
                    6.278e-07,
                    6.7241e-07,
                    7.1704e-07,
                    7.6149e-07,
                    8.0568e-07,
                    8.4966e-07,
                    8.9463e-07,
                    9.3999e-07,
                    9.8573e-07,
                    1.032e-06,
                    1.0786e-06,
                    1.1246e-06,
                    1.1696e-06,
                    1.2139e-06,
                    1.2573e-06,
                    1.2995e-06,
                    1.3416e-06,
                    1.3841e-06,
                    1.4268e-06,
                    1.4693e-06,
                    1.5118e-06,
                    1.5548e-06,
                    1.5984e-06,
                    1.6426e-06,
                    1.6877e-06,
                    1.7346e-06,
                    1.7807e-06,
                    1.8265e-06,
                    1.8722e-06,
                    1.9176e-06,
                    1.9629e-06,
                    2.009e-06,
                    2.0562e-06,
                    2.1047e-06,
                    2.1544e-06,
                    2.2036e-06,
                    2.25e-06,
                    2.2933e-06,
                    2.3339e-06,
                    2.3723e-06,
                    2.4087e-06,
                    2.4423e-06,
                    2.4731e-06,
                    2.5011e-06,
                    2.526e-06,
                    2.5467e-06,
                    2.5662e-06,
                    2.5845e-06,
                    2.6013e-06,
                    2.6166e-06,
                    2.6303e-06,
                    2.6408e-06,
                    2.6482e-06,
                    2.6523e-06,
                    2.653e-06,
                    2.6512e-06,
                    2.6513e-06,
                    2.6534e-06,
                    2.6572e-06,
                    2.6624e-06,
                    2.669e-06,
                    2.6771e-06,
                    2.6867e-06,
                    2.7e-06,
                    2.7153e-06,
                    2.7353e-06,
                    2.7579e-06,
                    2.7849e-06,
                    2.8164e-06,
                    2.8528e-06,
                    2.8925e-06,
                    2.9365e-06,
                    2.9847e-06,
                    3.0378e-06,
                    3.0979e-06,
                    3.1627e-06,
                    3.2344e-06,
                    3.3132e-06,
                    3.399e-06,
                    3.4926e-06,
                    3.5972e-06,
                    3.7147e-06,
                    3.8472e-06,
                    3.9926e-06,
                    4.1517e-06,
                    4.3748e-06,
                    4.6317e-06,
                    4.8872e-06,
                    5.1609e-06,
                    5.4413e-06,
                    5.7328e-06,
                    6.0283e-06,
                    6.3318e-06,
                    6.6467e-06,
                    6.9623e-06,
                    7.2879e-06,
                    7.6313e-06,
                    8.0051e-06,
                    8.3376e-06,
                    8.6673e-06,
                    9.013e-06,
                    9.3996e-06,
                    9.8335e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    1.5947e-08,
                    3.1551e-08,
                    4.7225e-08,
                    6.2967e-08,
                    7.8776e-08,
                    9.5326e-08,
                    1.1263e-07,
                    1.3072e-07,
                    1.4961e-07,
                    1.6931e-07,
                    1.894e-07,
                    2.0986e-07,
                    2.3071e-07,
                    2.5194e-07,
                    2.7319e-07,
                    2.943e-07,
                    3.1528e-07,
                    3.3612e-07,
                    3.5667e-07,
                    3.7697e-07,
                    3.9819e-07,
                    4.2015e-07,
                    4.4247e-07,
                    4.6514e-07,
                    4.8813e-07,
                    5.1032e-07,
                    5.317e-07,
                    5.5219e-07,
                    5.7176e-07,
                    5.904e-07,
                    6.0873e-07,
                    6.2739e-07,
                    6.4604e-07,
                    6.6436e-07,
                    6.8255e-07,
                    7.0101e-07,
                    7.1992e-07,
                    7.3918e-07,
                    7.5909e-07,
                    7.8048e-07,
                    8.0103e-07,
                    8.2097e-07,
                    8.404e-07,
                    8.5926e-07,
                    8.7756e-07,
                    8.9658e-07,
                    9.1633e-07,
                    9.369e-07,
                    9.5834e-07,
                    9.796e-07,
                    9.9964e-07,
                    1.0179e-06,
                    1.0346e-06,
                    1.0501e-06,
                    1.0645e-06,
                    1.0771e-06,
                    1.0879e-06,
                    1.0969e-06,
                    1.1039e-06,
                    1.1082e-06,
                    1.1122e-06,
                    1.1159e-06,
                    1.119e-06,
                    1.1215e-06,
                    1.1232e-06,
                    1.1228e-06,
                    1.12e-06,
                    1.1149e-06,
                    1.1074e-06,
                    1.0986e-06,
                    1.0909e-06,
                    1.0849e-06,
                    1.0803e-06,
                    1.077e-06,
                    1.0751e-06,
                    1.0746e-06,
                    1.0756e-06,
                    1.08e-06,
                    1.0859e-06,
                    1.0952e-06,
                    1.1056e-06,
                    1.1186e-06,
                    1.1342e-06,
                    1.1524e-06,
                    1.1715e-06,
                    1.1927e-06,
                    1.2158e-06,
                    1.2409e-06,
                    1.2701e-06,
                    1.2997e-06,
                    1.3325e-06,
                    1.3684e-06,
                    1.4066e-06,
                    1.4478e-06,
                    1.495e-06,
                    1.5495e-06,
                    1.6134e-06,
                    1.6847e-06,
                    1.764e-06,
                    1.8871e-06,
                    2.037e-06,
                    2.1823e-06,
                    2.3458e-06,
                    2.5175e-06,
                    2.7032e-06,
                    2.8954e-06,
                    3.0989e-06,
                    3.3174e-06,
                    3.5425e-06,
                    3.7874e-06,
                    4.0511e-06,
                    4.3596e-06,
                    4.6352e-06,
                    4.9128e-06,
                    5.2107e-06,
                    5.5508e-06,
                    5.9394e-06,
                    6.398e-06,
                    6.889e-06,
                    7.3375e-06,
                    7.819e-06,
                    8.3078e-06,
                    8.8018e-06,
                    9.2786e-06,
                    9.784e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [
                    2.3887e-08,
                    4.7614e-08,
                    7.1268e-08,
                    9.4821e-08,
                    1.1824e-07,
                    1.4184e-07,
                    1.6542e-07,
                    1.8885e-07,
                    2.1249e-07,
                    2.3613e-07,
                    2.5999e-07,
                    2.8369e-07,
                    3.0735e-07,
                    3.3084e-07,
                    3.546e-07,
                    3.7811e-07,
                    4.0176e-07,
                    4.2537e-07,
                    4.4902e-07,
                    4.7269e-07,
                    4.9643e-07,
                    5.1984e-07,
                    5.4326e-07,
                    5.6684e-07,
                    5.9051e-07,
                    6.1424e-07,
                    6.3793e-07,
                    6.6168e-07,
                    6.8552e-07,
                    7.0913e-07,
                    7.3283e-07,
                    7.5672e-07,
                    7.808e-07,
                    8.0492e-07,
                    8.2925e-07,
                    8.538e-07,
                    8.7852e-07,
                    9.0345e-07,
                    9.2858e-07,
                    9.541e-07,
                    9.797e-07,
                    1.0056e-06,
                    1.0318e-06,
                    1.0584e-06,
                    1.0853e-06,
                    1.1125e-06,
                    1.1399e-06,
                    1.1678e-06,
                    1.1961e-06,
                    1.224e-06,
                    1.2503e-06,
                    1.2754e-06,
                    1.2993e-06,
                    1.3222e-06,
                    1.3442e-06,
                    1.3652e-06,
                    1.3852e-06,
                    1.4042e-06,
                    1.4221e-06,
                    1.4385e-06,
                    1.454e-06,
                    1.4686e-06,
                    1.4823e-06,
                    1.4951e-06,
                    1.507e-06,
                    1.5181e-06,
                    1.5282e-06,
                    1.5374e-06,
                    1.5456e-06,
                    1.5526e-06,
                    1.5604e-06,
                    1.5686e-06,
                    1.577e-06,
                    1.5855e-06,
                    1.5939e-06,
                    1.6024e-06,
                    1.6111e-06,
                    1.62e-06,
                    1.6295e-06,
                    1.6401e-06,
                    1.6524e-06,
                    1.6663e-06,
                    1.6822e-06,
                    1.7004e-06,
                    1.721e-06,
                    1.7437e-06,
                    1.769e-06,
                    1.7969e-06,
                    1.8278e-06,
                    1.863e-06,
                    1.9019e-06,
                    1.9449e-06,
                    1.9924e-06,
                    2.0447e-06,
                    2.1022e-06,
                    2.1652e-06,
                    2.2338e-06,
                    2.3079e-06,
                    2.3876e-06,
                    2.4878e-06,
                    2.5947e-06,
                    2.7049e-06,
                    2.8151e-06,
                    2.9238e-06,
                    3.0296e-06,
                    3.1329e-06,
                    3.2329e-06,
                    3.3293e-06,
                    3.4197e-06,
                    3.5005e-06,
                    3.5802e-06,
                    3.6455e-06,
                    3.7024e-06,
                    3.7544e-06,
                    3.8023e-06,
                    3.8488e-06,
                    3.8941e-06,
                    3.9357e-06,
                    3.9854e-06,
                    4.0363e-06,
                    4.0873e-06,
                    4.1357e-06,
                    4.1878e-06,
                    4.2313e-06,
                    4.2578e-06,
                    4.2866e-06,
                    4.3149e-06,
                    4.3553e-06,
                    4.3956e-06,
                    4.4404e-06,
                    4.4725e-06,
                    4.5122e-06,
                    4.5506e-06,
                    4.5875e-06,
                    4.6183e-06,
                    4.6544e-06,
                    4.6958e-06,
                    4.7435e-06,
                    4.8054e-06,
                    4.8609e-06,
                    4.9135e-06,
                    4.9692e-06,
                    5.0122e-06,
                    5.0614e-06,
                    5.1257e-06,
                    5.1898e-06,
                    5.2438e-06,
                    5.2804e-06,
                    5.3082e-06,
                    5.3273e-06,
                    5.3293e-06,
                    5.3283e-06,
                    5.3159e-06,
                    5.3094e-06,
                    5.2951e-06,
                    5.269e-06,
                    5.2303e-06,
                    5.1923e-06,
                    5.1262e-06,
                    5.0636e-06,
                    4.9968e-06,
                    4.9264e-06,
                    4.8606e-06,
                    4.7876e-06,
                    4.7055e-06,
                    4.6309e-06,
                    4.5621e-06,
                    4.4903e-06,
                    4.4291e-06,
                    4.3743e-06,
                    4.3218e-06,
                    4.2765e-06
                ],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    1.2243e-08,
                    2.4227e-08,
                    3.6041e-08,
                    4.7657e-08,
                    5.9042e-08,
                    7.051e-08,
                    8.1868e-08,
                    9.2977e-08,
                    1.042e-07,
                    1.1533e-07,
                    1.2669e-07,
                    1.3789e-07,
                    1.4906e-07,
                    1.6006e-07,
                    1.7134e-07,
                    1.8236e-07,
                    1.9355e-07,
                    2.0469e-07,
                    2.1587e-07,
                    2.2708e-07,
                    2.384e-07,
                    2.4939e-07,
                    2.6043e-07,
                    2.7162e-07,
                    2.8293e-07,
                    2.9431e-07,
                    3.0565e-07,
                    3.1706e-07,
                    3.2858e-07,
                    3.3991e-07,
                    3.5124e-07,
                    3.6269e-07,
                    3.7425e-07,
                    3.8579e-07,
                    3.9746e-07,
                    4.0928e-07,
                    4.212e-07,
                    4.3325e-07,
                    4.4543e-07,
                    4.5768e-07,
                    4.6986e-07,
                    4.8213e-07,
                    4.9456e-07,
                    5.0723e-07,
                    5.2005e-07,
                    5.3281e-07,
                    5.4571e-07,
                    5.5887e-07,
                    5.7217e-07,
                    5.8485e-07,
                    5.9723e-07,
                    6.0946e-07,
                    6.2175e-07,
                    6.3418e-07,
                    6.4675e-07,
                    6.5945e-07,
                    6.7224e-07,
                    6.8524e-07,
                    6.9841e-07,
                    7.1129e-07,
                    7.2437e-07,
                    7.3776e-07,
                    7.5132e-07,
                    7.6516e-07,
                    7.7925e-07,
                    7.9362e-07,
                    8.0825e-07,
                    8.2311e-07,
                    8.3805e-07,
                    8.5304e-07,
                    8.6776e-07,
                    8.8193e-07,
                    8.9529e-07,
                    9.0775e-07,
                    9.1921e-07,
                    9.2973e-07,
                    9.394e-07,
                    9.5002e-07,
                    9.6014e-07,
                    9.7213e-07,
                    9.8255e-07,
                    9.932e-07,
                    1.0042e-06,
                    1.016e-06,
                    1.0269e-06,
                    1.039e-06,
                    1.0525e-06,
                    1.0676e-06,
                    1.0862e-06,
                    1.1065e-06,
                    1.1297e-06,
                    1.1559e-06,
                    1.1855e-06,
                    1.2185e-06,
                    1.2554e-06,
                    1.2963e-06,
                    1.3432e-06,
                    1.3944e-06,
                    1.4502e-06,
                    1.5568e-06,
                    1.6861e-06,
                    1.8081e-06,
                    1.9394e-06,
                    2.0706e-06,
                    2.2054e-06,
                    2.3373e-06,
                    2.4688e-06,
                    2.6033e-06,
                    2.7318e-06,
                    2.8608e-06,
                    2.9867e-06,
                    3.1378e-06,
                    3.2519e-06,
                    3.3554e-06,
                    3.4669e-06,
                    3.6037e-06,
                    3.7691e-06,
                    3.9791e-06,
                    4.2063e-06,
                    4.4101e-06,
                    4.6381e-06,
                    4.874e-06,
                    5.0996e-06,
                    5.33e-06,
                    5.5942e-06,
                    5.8412e-06,
                    6.1143e-06,
                    6.4066e-06,
                    6.6839e-06,
                    6.9926e-06,
                    7.3051e-06,
                    7.5992e-06,
                    7.911e-06,
                    8.2504e-06,
                    8.6332e-06,
                    9.0472e-06,
                    9.4722e-06,
                    9.8987e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.65e-09,
                    3.3e-09,
                    6.6e-09,
                    8.25e-09,
                    9.9e-09,
                    1.155e-08,
                    1.32e-08,
                    1.32e-08,
                    1.32e-08,
                    1.32e-08,
                    1.32e-08,
                    1.485e-08,
                    1.485e-08,
                    1.485e-08,
                    1.485e-08,
                    1.485e-08,
                    1.485e-08,
                    1.485e-08,
                    1.485e-08,
                    1.65e-08,
                    1.815e-08,
                    1.98e-08,
                    5.28e-08,
                    1.023e-07,
                    1.419e-07,
                    1.914e-07,
                    2.4255e-07,
                    3.003e-07,
                    3.5805e-07,
                    4.191e-07,
                    4.8675e-07,
                    5.544e-07,
                    6.3195e-07,
                    7.194e-07,
                    8.3655e-07,
                    9.2235e-07,
                    1.0032e-06,
                    1.0956e-06,
                    1.216e-06,
                    1.3678e-06,
                    1.5659e-06,
                    1.782e-06,
                    1.975e-06,
                    2.1929e-06,
                    2.4189e-06,
                    2.635e-06,
                    2.8562e-06,
                    3.1119e-06,
                    3.3512e-06,
                    3.6168e-06,
                    3.9006e-06,
                    4.1712e-06,
                    4.4748e-06,
                    4.7833e-06,
                    5.0738e-06,
                    5.3823e-06,
                    5.7187e-06,
                    6.0995e-06,
                    6.5118e-06,
                    6.9356e-06,
                    7.361e-06,
                    7.8062e-06,
                    8.3805e-06,
                    9.0192e-06,
                    9.6324e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [
                    1.2243e-08,
                    2.4227e-08,
                    3.6041e-08,
                    4.7657e-08,
                    5.9042e-08,
                    7.051e-08,
                    8.1868e-08,
                    9.2977e-08,
                    1.042e-07,
                    1.1533e-07,
                    1.2669e-07,
                    1.3789e-07,
                    1.4906e-07,
                    1.6006e-07,
                    1.7134e-07,
                    1.8236e-07,
                    1.9355e-07,
                    2.0469e-07,
                    2.1587e-07,
                    2.2708e-07,
                    2.384e-07,
                    2.4939e-07,
                    2.6043e-07,
                    2.7162e-07,
                    2.8293e-07,
                    2.9431e-07,
                    3.0565e-07,
                    3.1706e-07,
                    3.2858e-07,
                    3.3991e-07,
                    3.5124e-07,
                    3.6269e-07,
                    3.7425e-07,
                    3.8579e-07,
                    3.9746e-07,
                    4.0928e-07,
                    4.212e-07,
                    4.3325e-07,
                    4.4543e-07,
                    4.5768e-07,
                    4.6986e-07,
                    4.8213e-07,
                    4.9456e-07,
                    5.0723e-07,
                    5.2005e-07,
                    5.3281e-07,
                    5.4571e-07,
                    5.5887e-07,
                    5.7217e-07,
                    5.8485e-07,
                    5.9723e-07,
                    6.0946e-07,
                    6.2175e-07,
                    6.3418e-07,
                    6.4675e-07,
                    6.5945e-07,
                    6.7224e-07,
                    6.8524e-07,
                    6.9841e-07,
                    7.1129e-07,
                    7.2437e-07,
                    7.3776e-07,
                    7.5132e-07,
                    7.6516e-07,
                    7.7925e-07,
                    7.9362e-07,
                    8.0825e-07,
                    8.2311e-07,
                    8.3805e-07,
                    8.5304e-07,
                    8.6776e-07,
                    8.8193e-07,
                    8.9529e-07,
                    9.0775e-07,
                    9.1921e-07,
                    9.2973e-07,
                    9.394e-07,
                    9.4837e-07,
                    9.5684e-07,
                    9.6553e-07,
                    9.743e-07,
                    9.833e-07,
                    9.9267e-07,
                    1.0028e-06,
                    1.0137e-06,
                    1.0258e-06,
                    1.0393e-06,
                    1.0544e-06,
                    1.0714e-06,
                    1.0916e-06,
                    1.1148e-06,
                    1.1411e-06,
                    1.1706e-06,
                    1.2037e-06,
                    1.2405e-06,
                    1.2815e-06,
                    1.3267e-06,
                    1.3762e-06,
                    1.4304e-06,
                    1.504e-06,
                    1.5838e-06,
                    1.6662e-06,
                    1.748e-06,
                    1.8281e-06,
                    1.9051e-06,
                    1.9792e-06,
                    2.0497e-06,
                    2.1165e-06,
                    2.1774e-06,
                    2.2288e-06,
                    2.2673e-06,
                    2.3012e-06,
                    2.3295e-06,
                    2.3522e-06,
                    2.3713e-06,
                    2.3877e-06,
                    2.4012e-06,
                    2.4133e-06,
                    2.4243e-06,
                    2.435e-06,
                    2.4452e-06,
                    2.4551e-06,
                    2.4645e-06,
                    2.4738e-06,
                    2.4823e-06,
                    2.4901e-06,
                    2.4975e-06,
                    2.506e-06,
                    2.5127e-06,
                    2.5178e-06,
                    2.5217e-06,
                    2.5254e-06,
                    2.5287e-06,
                    2.5317e-06,
                    2.5336e-06,
                    2.5354e-06,
                    2.5366e-06,
                    2.5377e-06,
                    2.5384e-06,
                    2.5406e-06,
                    2.5434e-06,
                    2.546e-06,
                    2.5489e-06,
                    2.5512e-06,
                    2.553e-06,
                    2.5545e-06,
                    2.5563e-06,
                    2.5526e-06,
                    2.5487e-06,
                    2.5487e-06,
                    2.5421e-06,
                    2.5379e-06,
                    2.5281e-06,
                    2.5226e-06,
                    2.5179e-06,
                    2.5155e-06,
                    2.5112e-06,
                    2.5095e-06,
                    2.4995e-06,
                    2.4864e-06,
                    2.4692e-06,
                    2.4472e-06,
                    2.4204e-06,
                    2.3885e-06,
                    2.3483e-06,
                    2.3147e-06,
                    2.2771e-06,
                    2.2344e-06,
                    2.1942e-06,
                    2.1531e-06,
                    2.1073e-06,
                    2.0619e-06
                ],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [
                    2.5284e-08,
                    5.0298e-08,
                    7.5451e-08,
                    1.0074e-07,
                    1.2618e-07,
                    1.5242e-07,
                    1.795e-07,
                    2.0742e-07,
                    2.3622e-07,
                    2.6591e-07,
                    2.9596e-07,
                    3.2635e-07,
                    3.5711e-07,
                    3.8823e-07,
                    4.1934e-07,
                    4.5029e-07,
                    4.8108e-07,
                    5.1171e-07,
                    5.4201e-07,
                    5.7206e-07,
                    6.0296e-07,
                    6.3454e-07,
                    6.6642e-07,
                    6.986e-07,
                    7.3102e-07,
                    7.6258e-07,
                    7.9327e-07,
                    8.23e-07,
                    8.5176e-07,
                    8.7953e-07,
                    9.0704e-07,
                    9.3491e-07,
                    9.6284e-07,
                    9.9048e-07,
                    1.018e-06,
                    1.0459e-06,
                    1.0743e-06,
                    1.1031e-06,
                    1.1326e-06,
                    1.1636e-06,
                    1.1938e-06,
                    1.2236e-06,
                    1.253e-06,
                    1.282e-06,
                    1.3105e-06,
                    1.3399e-06,
                    1.3701e-06,
                    1.4012e-06,
                    1.4333e-06,
                    1.4654e-06,
                    1.4949e-06,
                    1.5213e-06,
                    1.5447e-06,
                    1.5655e-06,
                    1.5839e-06,
                    1.5993e-06,
                    1.6114e-06,
                    1.6203e-06,
                    1.6258e-06,
                    1.6273e-06,
                    1.6274e-06,
                    1.6258e-06,
                    1.6225e-06,
                    1.6174e-06,
                    1.6104e-06,
                    1.5999e-06,
                    1.5859e-06,
                    1.5684e-06,
                    1.5473e-06,
                    1.5237e-06,
                    1.5022e-06,
                    1.4833e-06,
                    1.4669e-06,
                    1.4529e-06,
                    1.4411e-06,
                    1.4319e-06,
                    1.4251e-06,
                    1.421e-06,
                    1.4194e-06,
                    1.4206e-06,
                    1.4259e-06,
                    1.4354e-06,
                    1.4488e-06,
                    1.4663e-06,
                    1.4878e-06,
                    1.5123e-06,
                    1.5395e-06,
                    1.5697e-06,
                    1.6033e-06,
                    1.6398e-06,
                    1.68e-06,
                    1.7238e-06,
                    1.7704e-06,
                    1.8204e-06,
                    1.8768e-06,
                    1.9409e-06,
                    2.0132e-06,
                    2.0932e-06,
                    2.1816e-06,
                    2.2827e-06,
                    2.3944e-06,
                    2.5114e-06,
                    2.6364e-06,
                    2.7672e-06,
                    2.9046e-06,
                    3.048e-06,
                    3.1987e-06,
                    3.3569e-06,
                    3.5209e-06,
                    3.6941e-06,
                    3.8911e-06,
                    4.0889e-06,
                    4.2844e-06,
                    4.4863e-06,
                    4.6978e-06,
                    4.9253e-06,
                    5.1708e-06,
                    5.4403e-06,
                    5.7336e-06,
                    6.0068e-06,
                    6.2907e-06,
                    6.5684e-06,
                    6.8662e-06,
                    7.1352e-06,
                    7.3828e-06,
                    7.6177e-06,
                    7.8917e-06,
                    8.1498e-06,
                    8.4078e-06,
                    8.6784e-06,
                    8.9e-06,
                    9.1166e-06,
                    9.3266e-06,
                    9.5891e-06,
                    9.7857e-06,
                    9.9336e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    9.9724e-06,
                    9.8742e-06,
                    9.8191e-06,
                    9.7632e-06,
                    9.7256e-06,
                    9.6879e-06,
                    9.6434e-06,
                    9.6041e-06,
                    9.5784e-06,
                    9.5359e-06,
                    9.5042e-06,
                    9.4721e-06,
                    9.4379e-06,
                    9.3976e-06,
                    9.3682e-06,
                    9.3347e-06,
                    9.2915e-06,
                    9.2242e-06,
                    9.178e-06,
                    9.1562e-06
                ],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [
                    1.3895e-08,
                    2.7426e-08,
                    4.1005e-08,
                    5.4631e-08,
                    6.8304e-08,
                    8.2696e-08,
                    9.7826e-08,
                    1.1371e-07,
                    1.3038e-07,
                    1.4785e-07,
                    1.6568e-07,
                    1.8386e-07,
                    2.0241e-07,
                    2.2133e-07,
                    2.4025e-07,
                    2.59e-07,
                    2.776e-07,
                    2.9605e-07,
                    3.1419e-07,
                    3.3206e-07,
                    3.5083e-07,
                    3.7031e-07,
                    3.9012e-07,
                    4.1026e-07,
                    4.3069e-07,
                    4.5029e-07,
                    4.6905e-07,
                    4.8688e-07,
                    5.0378e-07,
                    5.1973e-07,
                    5.3534e-07,
                    5.5125e-07,
                    5.6713e-07,
                    5.8267e-07,
                    5.9807e-07,
                    6.137e-07,
                    6.2976e-07,
                    6.4616e-07,
                    6.6319e-07,
                    6.8166e-07,
                    6.9928e-07,
                    7.1627e-07,
                    7.3273e-07,
                    7.4859e-07,
                    7.6386e-07,
                    7.7985e-07,
                    7.9653e-07,
                    8.1402e-07,
                    8.3234e-07,
                    8.5047e-07,
                    8.6735e-07,
                    8.8243e-07,
                    8.9591e-07,
                    9.0816e-07,
                    9.1927e-07,
                    9.2867e-07,
                    9.3616e-07,
                    9.418e-07,
                    9.4544e-07,
                    9.463e-07,
                    9.4693e-07,
                    9.4713e-07,
                    9.4681e-07,
                    9.4578e-07,
                    9.4404e-07,
                    9.4001e-07,
                    9.3366e-07,
                    9.2499e-07,
                    9.139e-07,
                    9.014e-07,
                    8.9008e-07,
                    8.8035e-07,
                    8.7204e-07,
                    8.6501e-07,
                    8.5931e-07,
                    8.551e-07,
                    8.5229e-07,
                    8.5114e-07,
                    8.5148e-07,
                    8.5361e-07,
                    8.5841e-07,
                    8.6582e-07,
                    8.7579e-07,
                    8.8841e-07,
                    9.0352e-07,
                    9.2066e-07,
                    9.3962e-07,
                    9.6063e-07,
                    9.8413e-07,
                    1.0096e-06,
                    1.0382e-06,
                    1.0698e-06,
                    1.1038e-06,
                    1.1406e-06,
                    1.1834e-06,
                    1.2334e-06,
                    1.2911e-06,
                    1.3562e-06,
                    1.4291e-06,
                    1.5144e-06,
                    1.6101e-06,
                    1.7109e-06,
                    1.8201e-06,
                    1.9357e-06,
                    2.0586e-06,
                    2.1881e-06,
                    2.3255e-06,
                    2.4711e-06,
                    2.6234e-06,
                    2.7855e-06,
                    2.9564e-06,
                    3.1424e-06,
                    3.3268e-06,
                    3.518e-06,
                    3.7178e-06,
                    3.9318e-06,
                    4.1628e-06,
                    4.4176e-06,
                    4.6865e-06,
                    4.9352e-06,
                    5.1922e-06,
                    5.4469e-06,
                    5.7182e-06,
                    5.9677e-06,
                    6.2102e-06,
                    6.4391e-06,
                    6.7063e-06,
                    6.949e-06,
                    7.1897e-06,
                    7.4375e-06,
                    7.6488e-06,
                    7.8471e-06,
                    8.0384e-06,
                    8.2831e-06,
                    8.4654e-06,
                    8.5952e-06,
                    8.6655e-06,
                    8.6983e-06,
                    8.6971e-06,
                    8.7004e-06,
                    8.6767e-06,
                    8.6565e-06,
                    8.603e-06,
                    8.5648e-06,
                    8.5239e-06,
                    8.4952e-06,
                    8.4263e-06,
                    8.3853e-06,
                    8.3512e-06,
                    8.3337e-06,
                    8.3208e-06,
                    8.2855e-06,
                    8.2584e-06,
                    8.1796e-06,
                    8.1482e-06,
                    8.1298e-06,
                    8.1402e-06,
                    8.1536e-06,
                    8.1772e-06,
                    8.1998e-06,
                    8.2369e-06,
                    8.2573e-06,
                    8.2791e-06,
                    8.3014e-06,
                    8.322e-06,
                    8.3365e-06,
                    8.3527e-06,
                    8.3613e-06,
                    8.3521e-06,
                    8.3116e-06,
                    8.2853e-06,
                    8.2765e-06
                ],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [
                    1.139e-08,
                    2.2872e-08,
                    3.4446e-08,
                    4.6114e-08,
                    5.7874e-08,
                    6.9726e-08,
                    8.1671e-08,
                    9.3709e-08,
                    1.0584e-07,
                    1.1806e-07,
                    1.3028e-07,
                    1.4249e-07,
                    1.547e-07,
                    1.669e-07,
                    1.791e-07,
                    1.9129e-07,
                    2.0347e-07,
                    2.1565e-07,
                    2.2783e-07,
                    2.4e-07,
                    2.5213e-07,
                    2.6423e-07,
                    2.763e-07,
                    2.8833e-07,
                    3.0033e-07,
                    3.1229e-07,
                    3.2422e-07,
                    3.3612e-07,
                    3.4798e-07,
                    3.5981e-07,
                    3.717e-07,
                    3.8367e-07,
                    3.957e-07,
                    4.0781e-07,
                    4.1998e-07,
                    4.3222e-07,
                    4.4454e-07,
                    4.5692e-07,
                    4.6937e-07,
                    4.8189e-07,
                    4.9455e-07,
                    5.0736e-07,
                    5.2031e-07,
                    5.334e-07,
                    5.4664e-07,
                    5.6001e-07,
                    5.7353e-07,
                    5.872e-07,
                    6.01e-07,
                    6.1495e-07,
                    6.2756e-07,
                    6.3884e-07,
                    6.4879e-07,
                    6.5739e-07,
                    6.6466e-07,
                    6.706e-07,
                    6.752e-07,
                    6.7847e-07,
                    6.804e-07,
                    6.81e-07,
                    6.8042e-07,
                    6.7866e-07,
                    6.7573e-07,
                    6.7162e-07,
                    6.6633e-07,
                    6.5987e-07,
                    6.5223e-07,
                    6.4342e-07,
                    6.3342e-07,
                    6.2226e-07,
                    6.1211e-07,
                    6.03e-07,
                    5.9491e-07,
                    5.8784e-07,
                    5.818e-07,
                    5.7679e-07,
                    5.728e-07,
                    5.6984e-07,
                    5.679e-07,
                    5.6698e-07,
                    5.6753e-07,
                    5.6953e-07,
                    5.7299e-07,
                    5.7791e-07,
                    5.8429e-07,
                    5.9162e-07,
                    5.9989e-07,
                    6.0909e-07,
                    6.1921e-07,
                    6.3024e-07,
                    6.4182e-07,
                    6.5395e-07,
                    6.6661e-07,
                    6.7977e-07,
                    6.9341e-07,
                    7.0753e-07,
                    7.2209e-07,
                    7.3708e-07,
                    7.5248e-07,
                    7.6827e-07,
                    7.8437e-07,
                    8.0047e-07,
                    8.1628e-07,
                    8.3153e-07,
                    8.4599e-07,
                    8.5992e-07,
                    8.732e-07,
                    8.8575e-07,
                    8.9754e-07,
                    9.086e-07,
                    9.3473e-07,
                    9.465e-07,
                    9.5759e-07,
                    9.6828e-07,
                    9.7994e-07,
                    9.935e-07,
                    1.008e-06,
                    1.0227e-06,
                    1.0472e-06,
                    1.0716e-06,
                    1.0984e-06,
                    1.1215e-06,
                    1.148e-06,
                    1.1675e-06,
                    1.1726e-06,
                    1.1786e-06,
                    1.1854e-06,
                    1.2008e-06,
                    1.2181e-06,
                    1.2409e-06,
                    1.2512e-06,
                    1.2695e-06,
                    1.2882e-06,
                    1.306e-06,
                    1.3203e-06,
                    1.3384e-06,
                    1.3616e-06,
                    1.3902e-06,
                    1.4313e-06,
                    1.4666e-06,
                    1.4985e-06,
                    1.5343e-06,
                    1.5574e-06,
                    1.5871e-06,
                    1.6305e-06,
                    1.6737e-06,
                    1.7071e-06,
                    1.7291e-06,
                    1.743e-06,
                    1.745e-06,
                    1.7379e-06,
                    1.7288e-06,
                    1.714e-06,
                    1.6946e-06,
                    1.6709e-06,
                    1.6334e-06,
                    1.5854e-06,
                    1.5343e-06,
                    1.4662e-06,
                    1.4043e-06,
                    1.3414e-06,
                    1.2787e-06,
                    1.2251e-06,
                    1.1707e-06,
                    1.1159e-06,
                    1.0612e-06,
                    1.0155e-06,
                    9.7343e-07,
                    9.3932e-07,
                    9.1253e-07,
                    8.9273e-07,
                    8.7976e-07
                ],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [
                    2.3069e-09,
                    4.6402e-09,
                    6.9997e-09,
                    9.385e-09,
                    1.1796e-08,
                    1.4231e-08,
                    1.6689e-08,
                    1.9171e-08,
                    2.1674e-08,
                    2.4199e-08,
                    2.6743e-08,
                    2.9306e-08,
                    3.189e-08,
                    3.4493e-08,
                    3.7115e-08,
                    3.9757e-08,
                    4.2419e-08,
                    4.51e-08,
                    4.7801e-08,
                    5.0522e-08,
                    5.3269e-08,
                    5.6053e-08,
                    5.8881e-08,
                    6.176e-08,
                    6.4693e-08,
                    6.7679e-08,
                    7.0719e-08,
                    7.3807e-08,
                    7.6936e-08,
                    8.01e-08,
                    8.329e-08,
                    8.6506e-08,
                    8.9746e-08,
                    9.3011e-08,
                    9.6299e-08,
                    9.9611e-08,
                    1.0295e-07,
                    1.063e-07,
                    1.0969e-07,
                    1.1335e-07,
                    1.1704e-07,
                    1.2077e-07,
                    1.2457e-07,
                    1.2842e-07,
                    1.3235e-07,
                    1.3636e-07,
                    1.4046e-07,
                    1.4465e-07,
                    1.4894e-07,
                    1.5333e-07,
                    1.5784e-07,
                    1.6253e-07,
                    1.6744e-07,
                    1.7259e-07,
                    1.7798e-07,
                    1.8362e-07,
                    1.8949e-07,
                    1.9556e-07,
                    2.0178e-07,
                    2.0811e-07,
                    2.1449e-07,
                    2.2095e-07,
                    2.2746e-07,
                    2.3403e-07,
                    2.4066e-07,
                    2.4733e-07,
                    2.5405e-07,
                    2.6082e-07,
                    2.6762e-07,
                    2.7445e-07,
                    2.813e-07,
                    2.8816e-07,
                    2.9501e-07,
                    3.0185e-07,
                    3.0867e-07,
                    3.1546e-07,
                    3.2225e-07,
                    3.2902e-07,
                    3.358e-07,
                    3.426e-07,
                    3.4944e-07,
                    3.5635e-07,
                    3.6337e-07,
                    3.705e-07,
                    3.7777e-07,
                    3.8519e-07,
                    3.9276e-07,
                    4.0048e-07,
                    4.0836e-07,
                    4.1638e-07,
                    4.2469e-07,
                    4.3355e-07,
                    4.4314e-07,
                    4.536e-07,
                    4.6503e-07,
                    4.7744e-07,
                    4.9079e-07,
                    5.0499e-07,
                    5.199e-07,
                    5.353e-07,
                    5.5118e-07,
                    5.6774e-07,
                    5.8513e-07,
                    6.0344e-07,
                    6.2275e-07,
                    6.4306e-07,
                    6.6434e-07,
                    6.8653e-07,
                    7.0948e-07,
                    7.3305e-07,
                    7.5345e-07,
                    7.7846e-07,
                    8.0138e-07,
                    8.2564e-07,
                    8.4827e-07,
                    8.7055e-07,
                    8.936e-07,
                    9.1435e-07,
                    9.3449e-07,
                    9.5692e-07,
                    9.7755e-07,
                    1.0011e-06,
                    1.024e-06,
                    1.0447e-06,
                    1.0648e-06,
                    1.0852e-06,
                    1.105e-06,
                    1.1273e-06,
                    1.149e-06,
                    1.1718e-06,
                    1.1952e-06,
                    1.2189e-06,
                    1.2415e-06,
                    1.2642e-06,
                    1.2861e-06,
                    1.31e-06,
                    1.3351e-06,
                    1.3608e-06,
                    1.3895e-06,
                    1.4179e-06,
                    1.4469e-06,
                    1.476e-06,
                    1.5031e-06,
                    1.5303e-06,
                    1.5597e-06,
                    1.589e-06,
                    1.619e-06,
                    1.6492e-06,
                    1.6788e-06,
                    1.7066e-06,
                    1.7327e-06,
                    1.7547e-06,
                    1.7773e-06,
                    1.806e-06,
                    1.8317e-06,
                    1.857e-06,
                    1.8816e-06,
                    1.9091e-06,
                    1.9342e-06,
                    1.9605e-06,
                    1.988e-06,
                    2.016e-06,
                    2.045e-06,
                    2.0708e-06,
                    2.0969e-06,
                    2.1237e-06,
                    2.1485e-06,
                    2.1717e-06,
                    2.1978e-06,
                    2.2236e-06,
                    2.2505e-06,
                    2.2778e-06
                ],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [
                    2.0519e-09,
                    4.1252e-09,
                    6.2198e-09,
                    8.3356e-09,
                    1.0472e-08,
                    1.263e-08,
                    1.4808e-08,
                    1.7007e-08,
                    1.9225e-08,
                    2.1464e-08,
                    2.3721e-08,
                    2.5998e-08,
                    2.8295e-08,
                    3.0611e-08,
                    3.2946e-08,
                    3.53e-08,
                    3.7674e-08,
                    4.0067e-08,
                    4.248e-08,
                    4.4912e-08,
                    4.7365e-08,
                    4.9843e-08,
                    5.2347e-08,
                    5.488e-08,
                    5.7443e-08,
                    6.0035e-08,
                    6.2656e-08,
                    6.5305e-08,
                    6.798e-08,
                    7.0679e-08,
                    7.3399e-08,
                    7.614e-08,
                    7.8902e-08,
                    8.1685e-08,
                    8.4488e-08,
                    8.7312e-08,
                    9.0156e-08,
                    9.3021e-08,
                    9.5907e-08,
                    9.8816e-08,
                    1.0175e-07,
                    1.047e-07,
                    1.0768e-07,
                    1.1067e-07,
                    1.1369e-07,
                    1.1674e-07,
                    1.198e-07,
                    1.2289e-07,
                    1.26e-07,
                    1.2913e-07,
                    1.3229e-07,
                    1.3548e-07,
                    1.3868e-07,
                    1.4192e-07,
                    1.4518e-07,
                    1.4846e-07,
                    1.5178e-07,
                    1.5511e-07,
                    1.5848e-07,
                    1.6187e-07,
                    1.6528e-07,
                    1.6873e-07,
                    1.7219e-07,
                    1.7568e-07,
                    1.792e-07,
                    1.8274e-07,
                    1.8631e-07,
                    1.899e-07,
                    1.9351e-07,
                    1.9716e-07,
                    2.0082e-07,
                    2.0452e-07,
                    2.0824e-07,
                    2.1198e-07,
                    2.1575e-07,
                    2.1954e-07,
                    2.2336e-07,
                    2.2721e-07,
                    2.3108e-07,
                    2.3498e-07,
                    2.389e-07,
                    2.4284e-07,
                    2.4681e-07,
                    2.5081e-07,
                    2.5482e-07,
                    2.5887e-07,
                    2.6293e-07,
                    2.6703e-07,
                    2.7115e-07,
                    2.753e-07,
                    2.7948e-07,
                    2.8371e-07,
                    2.88e-07,
                    2.9235e-07,
                    2.9676e-07,
                    3.0125e-07,
                    3.0581e-07,
                    3.1043e-07,
                    3.1511e-07,
                    3.1984e-07,
                    3.2463e-07,
                    3.2946e-07,
                    3.3434e-07,
                    3.3927e-07,
                    3.4425e-07,
                    3.4929e-07,
                    3.5437e-07,
                    3.5951e-07,
                    3.6471e-07,
                    3.6996e-07,
                    3.7528e-07,
                    3.8066e-07,
                    3.8612e-07,
                    3.9165e-07,
                    3.9726e-07,
                    4.0295e-07,
                    4.0873e-07,
                    4.1459e-07,
                    4.2055e-07,
                    4.272e-07,
                    4.3395e-07,
                    4.4203e-07,
                    4.4864e-07,
                    4.5477e-07,
                    4.6197e-07,
                    4.6731e-07,
                    4.7298e-07,
                    4.7873e-07,
                    4.8423e-07,
                    4.9e-07,
                    4.9564e-07,
                    5.0165e-07,
                    5.0781e-07,
                    5.1445e-07,
                    5.2162e-07,
                    5.2938e-07,
                    5.3746e-07,
                    5.4528e-07,
                    5.5377e-07,
                    5.6425e-07,
                    5.754e-07,
                    5.87e-07,
                    5.9725e-07,
                    6.0713e-07,
                    6.1755e-07,
                    6.2741e-07,
                    6.3855e-07,
                    6.5052e-07,
                    6.6239e-07,
                    6.7303e-07,
                    6.8331e-07,
                    6.931e-07,
                    7.0343e-07,
                    7.1388e-07,
                    7.254e-07,
                    7.3685e-07,
                    7.4793e-07,
                    7.607e-07,
                    7.7369e-07,
                    7.8756e-07,
                    8.0179e-07,
                    8.1548e-07,
                    8.298e-07,
                    8.4247e-07,
                    8.556e-07,
                    8.687e-07,
                    8.7896e-07,
                    8.8925e-07,
                    9.0221e-07,
                    9.1497e-07,
                    9.2873e-07,
                    9.4296e-07
                ],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": [
                    2.5494e-10,
                    5.1499e-10,
                    7.7991e-10,
                    1.0494e-09,
                    1.3231e-09,
                    1.6005e-09,
                    1.8811e-09,
                    2.1642e-09,
                    2.4491e-09,
                    2.7349e-09,
                    3.0213e-09,
                    3.3081e-09,
                    3.5951e-09,
                    3.8823e-09,
                    4.1696e-09,
                    4.4572e-09,
                    4.7449e-09,
                    5.033e-09,
                    5.3214e-09,
                    5.6104e-09,
                    5.9042e-09,
                    6.2102e-09,
                    6.5342e-09,
                    6.88e-09,
                    7.25e-09,
                    7.6446e-09,
                    8.0628e-09,
                    8.5015e-09,
                    8.9563e-09,
                    9.4208e-09,
                    9.8909e-09,
                    1.0366e-08,
                    1.0844e-08,
                    1.1326e-08,
                    1.1811e-08,
                    1.2299e-08,
                    1.2789e-08,
                    1.3283e-08,
                    1.378e-08,
                    1.453e-08,
                    1.529e-08,
                    1.6073e-08,
                    1.6889e-08,
                    1.7749e-08,
                    1.8659e-08,
                    1.9628e-08,
                    2.0662e-08,
                    2.1765e-08,
                    2.2941e-08,
                    2.4192e-08,
                    2.5547e-08,
                    2.7057e-08,
                    2.8757e-08,
                    3.0669e-08,
                    3.2804e-08,
                    3.5158e-08,
                    3.7715e-08,
                    4.0444e-08,
                    4.3303e-08,
                    4.6237e-08,
                    4.921e-08,
                    5.2222e-08,
                    5.5269e-08,
                    5.8349e-08,
                    6.1458e-08,
                    6.4591e-08,
                    6.7746e-08,
                    7.0918e-08,
                    7.4102e-08,
                    7.7292e-08,
                    8.0478e-08,
                    8.3643e-08,
                    8.6776e-08,
                    8.9869e-08,
                    9.2917e-08,
                    9.592e-08,
                    9.8883e-08,
                    1.0181e-07,
                    1.0472e-07,
                    1.0762e-07,
                    1.1054e-07,
                    1.1351e-07,
                    1.1655e-07,
                    1.197e-07,
                    1.2295e-07,
                    1.2632e-07,
                    1.2982e-07,
                    1.3346e-07,
                    1.3721e-07,
                    1.4109e-07,
                    1.4521e-07,
                    1.4984e-07,
                    1.5514e-07,
                    1.6126e-07,
                    1.6826e-07,
                    1.7618e-07,
                    1.8498e-07,
                    1.9457e-07,
                    2.0479e-07,
                    2.1546e-07,
                    2.2656e-07,
                    2.3828e-07,
                    2.5079e-07,
                    2.6417e-07,
                    2.7849e-07,
                    2.9377e-07,
                    3.0997e-07,
                    3.2701e-07,
                    3.4477e-07,
                    3.6309e-07,
                    3.7817e-07,
                    3.9779e-07,
                    4.1526e-07,
                    4.34e-07,
                    4.5101e-07,
                    4.676e-07,
                    4.8487e-07,
                    4.9976e-07,
                    5.1395e-07,
                    5.2972e-07,
                    5.436e-07,
                    5.5908e-07,
                    5.7533e-07,
                    5.8994e-07,
                    6.0283e-07,
                    6.1785e-07,
                    6.3199e-07,
                    6.4852e-07,
                    6.6473e-07,
                    6.8176e-07,
                    6.996e-07,
                    7.173e-07,
                    7.3368e-07,
                    7.4972e-07,
                    7.6445e-07,
                    7.8058e-07,
                    7.976e-07,
                    8.1557e-07,
                    8.3573e-07,
                    8.5366e-07,
                    8.7154e-07,
                    8.8897e-07,
                    9.0585e-07,
                    9.2313e-07,
                    9.4212e-07,
                    9.6157e-07,
                    9.8049e-07,
                    9.9871e-07,
                    1.0164e-06,
                    1.0336e-06,
                    1.0494e-06,
                    1.0616e-06,
                    1.0738e-06,
                    1.0922e-06,
                    1.1063e-06,
                    1.1201e-06,
                    1.1337e-06,
                    1.1484e-06,
                    1.1605e-06,
                    1.1729e-06,
                    1.1862e-06,
                    1.2006e-06,
                    1.2152e-06,
                    1.2284e-06,
                    1.2413e-06,
                    1.255e-06,
                    1.2695e-06,
                    1.2825e-06,
                    1.2955e-06,
                    1.3087e-06,
                    1.3217e-06,
                    1.3348e-06
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -59.6508,
                            13.30561
                        ],
                        [
                            -59.6369,
                            13.13295
                        ],
                        [
                            -59.61282,
                            13.07848
                        ],
                        [
                            -59.50439,
                            13.05188
                        ],
                        [
                            -59.42014,
                            13.14881
                        ],
                        [
                            -59.53774,
                            13.22748
                        ],
                        [
                            -59.61258,
                            13.33491
                        ],
                        [
                            -59.6508,
                            13.30561
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "BLR",
                "Country": "Belarus",
                "Total_3GHG": 0.35,
                "Total_3GHG_timeseries": [
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0047,
                    0.0048,
                    0.0048,
                    0.0048,
                    0.0049,
                    0.0049,
                    0.0049,
                    0.0049,
                    0.005,
                    0.005,
                    0.005,
                    0.005,
                    0.0051,
                    0.0051,
                    0.0051,
                    0.0051,
                    0.0052,
                    0.0052,
                    0.0052,
                    0.0052,
                    0.0053,
                    0.0053,
                    0.0054,
                    0.0054,
                    0.0055,
                    0.0055,
                    0.0056,
                    0.0056,
                    0.0056,
                    0.0057,
                    0.0057
                ],
                "Fossil_3GHG": 0.25,
                "Fossil_3GHG_timeseries": [
                    5.5719e-07,
                    1.1372e-06,
                    1.7405e-06,
                    2.3675e-06,
                    3.023e-06,
                    3.6985e-06,
                    4.3989e-06,
                    5.1309e-06,
                    5.8685e-06,
                    6.6136e-06,
                    7.3673e-06,
                    8.1262e-06,
                    8.8921e-06,
                    9.6658e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027
                ],
                "Land_3GHG": 0.53,
                "Land_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.003
                ],
                "Total_CO2": 0.36,
                "Total_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.004,
                    0.004,
                    0.004,
                    0.004,
                    0.0041,
                    0.0041
                ],
                "Fossil_CO2": 0.29,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    4.3249e-09,
                    4.3249e-09,
                    4.3249e-09,
                    1.0398e-08,
                    1.684e-08,
                    2.5351e-08,
                    3.6164e-08,
                    4.5918e-08,
                    5.6132e-08,
                    6.7588e-08,
                    7.8538e-08,
                    1.1314e-07,
                    1.5284e-07,
                    1.8588e-07,
                    2.3069e-07,
                    2.7932e-07,
                    3.4498e-07,
                    4.1238e-07,
                    4.7564e-07,
                    5.5243e-07,
                    6.4082e-07,
                    7.5055e-07,
                    8.6253e-07,
                    1.0089e-06,
                    1.1591e-06,
                    1.3352e-06,
                    1.5208e-06,
                    1.7162e-06,
                    1.9387e-06,
                    2.1645e-06,
                    2.4106e-06,
                    2.6629e-06,
                    2.9299e-06,
                    3.2084e-06,
                    3.5091e-06,
                    3.8497e-06,
                    4.2247e-06,
                    4.6217e-06,
                    5.087e-06,
                    5.5609e-06,
                    6.1054e-06,
                    6.6597e-06,
                    7.3006e-06,
                    8.0194e-06,
                    8.8533e-06,
                    9.7979e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023
                ],
                "Land_CO2": 0.5,
                "Land_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018
                ],
                "Total_CH4": 0.16,
                "Total_CH4_timeseries": [
                    2.0107e-06,
                    4.0515e-06,
                    6.123e-06,
                    8.2255e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Fossil_CH4": 0.1,
                "Fossil_CH4_timeseries": [
                    5.1491e-07,
                    1.0522e-06,
                    1.6123e-06,
                    2.1955e-06,
                    2.8025e-06,
                    3.4335e-06,
                    4.0888e-06,
                    4.7692e-06,
                    5.4545e-06,
                    6.1449e-06,
                    6.8411e-06,
                    7.5434e-06,
                    8.2517e-06,
                    8.9662e-06,
                    9.7499e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_CH4": 0.27,
                "Land_CH4_timeseries": [
                    1.4958e-06,
                    2.9993e-06,
                    4.5108e-06,
                    6.03e-06,
                    7.5571e-06,
                    9.092e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Total_N2O": 1.18,
                "Total_N2O_timeseries": [
                    1.1397e-06,
                    2.3018e-06,
                    3.4854e-06,
                    4.6892e-06,
                    5.9115e-06,
                    7.1502e-06,
                    8.4029e-06,
                    9.667e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001
                ],
                "Fossil_N2O": 0.73,
                "Fossil_N2O_timeseries": [
                    4.2277e-08,
                    8.5034e-08,
                    1.2827e-07,
                    1.7197e-07,
                    2.1613e-07,
                    2.6074e-07,
                    3.0578e-07,
                    3.5124e-07,
                    3.971e-07,
                    4.4334e-07,
                    4.8995e-07,
                    5.3693e-07,
                    5.8427e-07,
                    6.3198e-07,
                    6.8004e-07,
                    7.2847e-07,
                    7.7726e-07,
                    8.2642e-07,
                    8.7594e-07,
                    9.2584e-07,
                    9.7621e-07,
                    1.0272e-06,
                    1.079e-06,
                    1.1317e-06,
                    1.1854e-06,
                    1.24e-06,
                    1.2955e-06,
                    1.3518e-06,
                    1.409e-06,
                    1.4667e-06,
                    1.5249e-06,
                    1.5835e-06,
                    1.6426e-06,
                    1.7022e-06,
                    1.7622e-06,
                    1.8226e-06,
                    1.8834e-06,
                    1.9447e-06,
                    2.0064e-06,
                    2.0688e-06,
                    2.1318e-06,
                    2.1953e-06,
                    2.2593e-06,
                    2.3239e-06,
                    2.3891e-06,
                    2.4548e-06,
                    2.5211e-06,
                    2.5881e-06,
                    2.6556e-06,
                    2.7238e-06,
                    2.7926e-06,
                    2.8621e-06,
                    2.9324e-06,
                    3.0035e-06,
                    3.0753e-06,
                    3.148e-06,
                    3.2214e-06,
                    3.2957e-06,
                    3.3707e-06,
                    3.4464e-06,
                    3.5229e-06,
                    3.6e-06,
                    3.6778e-06,
                    3.7563e-06,
                    3.8354e-06,
                    3.9152e-06,
                    3.9957e-06,
                    4.0768e-06,
                    4.1587e-06,
                    4.2414e-06,
                    4.325e-06,
                    4.4097e-06,
                    4.4958e-06,
                    4.5835e-06,
                    4.673e-06,
                    4.7644e-06,
                    4.8579e-06,
                    4.9534e-06,
                    5.0513e-06,
                    5.1514e-06,
                    5.2553e-06,
                    5.3655e-06,
                    5.4842e-06,
                    5.6131e-06,
                    5.7533e-06,
                    5.9056e-06,
                    6.0703e-06,
                    6.2473e-06,
                    6.4359e-06,
                    6.6351e-06,
                    6.8439e-06,
                    7.0621e-06,
                    7.2897e-06,
                    7.5269e-06,
                    7.774e-06,
                    8.0319e-06,
                    8.3013e-06,
                    8.5834e-06,
                    8.8797e-06,
                    9.1916e-06,
                    9.5284e-06,
                    9.9051e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_N2O": 1.35,
                "Land_N2O_timeseries": [
                    1.0974e-06,
                    2.2168e-06,
                    3.3572e-06,
                    4.5172e-06,
                    5.6953e-06,
                    6.8894e-06,
                    8.0972e-06,
                    9.3157e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            23.61744,
                            51.50954
                        ],
                        [
                            23.66269,
                            51.58224
                        ],
                        [
                            23.60566,
                            51.62167
                        ],
                        [
                            23.78099,
                            51.66677
                        ],
                        [
                            23.88033,
                            51.60783
                        ],
                        [
                            23.99517,
                            51.58084
                        ],
                        [
                            24.11891,
                            51.66662
                        ],
                        [
                            24.31751,
                            51.74936
                        ],
                        [
                            24.29454,
                            51.79954
                        ],
                        [
                            24.38959,
                            51.88245
                        ],
                        [
                            24.6107,
                            51.90188
                        ],
                        [
                            24.74118,
                            51.88291
                        ],
                        [
                            24.91939,
                            51.91152
                        ],
                        [
                            24.96463,
                            51.89768
                        ],
                        [
                            25.09602,
                            51.95205
                        ],
                        [
                            25.26211,
                            51.96676
                        ],
                        [
                            25.41327,
                            51.92111
                        ],
                        [
                            26.09242,
                            51.91167
                        ],
                        [
                            26.15761,
                            51.86678
                        ],
                        [
                            26.36871,
                            51.86315
                        ],
                        [
                            26.46913,
                            51.79959
                        ],
                        [
                            26.6164,
                            51.82449
                        ],
                        [
                            26.75156,
                            51.80153
                        ],
                        [
                            26.94854,
                            51.73572
                        ],
                        [
                            26.9975,
                            51.76975
                        ],
                        [
                            27.19897,
                            51.77313
                        ],
                        [
                            27.20853,
                            51.66701
                        ],
                        [
                            27.26941,
                            51.6063
                        ],
                        [
                            27.45597,
                            51.61135
                        ],
                        [
                            27.55029,
                            51.63637
                        ],
                        [
                            27.72189,
                            51.60333
                        ],
                        [
                            27.67836,
                            51.53957
                        ],
                        [
                            27.73787,
                            51.47526
                        ],
                        [
                            27.86053,
                            51.63047
                        ],
                        [
                            27.94094,
                            51.55791
                        ],
                        [
                            28.1128,
                            51.58378
                        ],
                        [
                            28.17222,
                            51.64497
                        ],
                        [
                            28.34243,
                            51.57675
                        ],
                        [
                            28.46896,
                            51.59259
                        ],
                        [
                            28.62949,
                            51.57301
                        ],
                        [
                            28.6827,
                            51.44511
                        ],
                        [
                            28.76249,
                            51.48727
                        ],
                        [
                            28.81785,
                            51.55716
                        ],
                        [
                            28.8854,
                            51.58386
                        ],
                        [
                            28.99963,
                            51.57471
                        ],
                        [
                            29.11614,
                            51.65524
                        ],
                        [
                            29.25182,
                            51.56566
                        ],
                        [
                            29.24588,
                            51.49919
                        ],
                        [
                            29.35172,
                            51.38471
                        ],
                        [
                            29.73533,
                            51.53059
                        ],
                        [
                            29.7922,
                            51.44301
                        ],
                        [
                            29.96832,
                            51.47457
                        ],
                        [
                            30.01587,
                            51.50416
                        ],
                        [
                            30.11708,
                            51.48791
                        ],
                        [
                            30.17996,
                            51.51239
                        ],
                        [
                            30.34412,
                            51.4238
                        ],
                        [
                            30.32479,
                            51.36202
                        ],
                        [
                            30.4007,
                            51.31136
                        ],
                        [
                            30.53988,
                            51.26264
                        ],
                        [
                            30.61374,
                            51.28361
                        ],
                        [
                            30.65286,
                            51.37524
                        ],
                        [
                            30.53131,
                            51.5622
                        ],
                        [
                            30.5105,
                            51.62909
                        ],
                        [
                            30.61202,
                            51.70969
                        ],
                        [
                            30.69261,
                            51.83684
                        ],
                        [
                            30.80777,
                            51.9438
                        ],
                        [
                            30.88809,
                            51.97081
                        ],
                        [
                            30.95033,
                            52.07611
                        ],
                        [
                            31.13831,
                            52.10184
                        ],
                        [
                            31.25527,
                            52.0431
                        ],
                        [
                            31.32454,
                            52.10456
                        ],
                        [
                            31.45088,
                            52.13983
                        ],
                        [
                            31.72321,
                            52.09603
                        ],
                        [
                            31.78688,
                            52.11145
                        ],
                        [
                            31.78604,
                            52.15756
                        ],
                        [
                            31.59382,
                            52.31312
                        ],
                        [
                            31.62865,
                            52.3676
                        ],
                        [
                            31.58676,
                            52.59232
                        ],
                        [
                            31.50603,
                            52.68735
                        ],
                        [
                            31.59307,
                            52.73679
                        ],
                        [
                            31.53846,
                            52.8542
                        ],
                        [
                            31.38966,
                            52.91135
                        ],
                        [
                            31.26757,
                            53.0232
                        ],
                        [
                            31.38566,
                            53.10332
                        ],
                        [
                            31.42478,
                            53.20792
                        ],
                        [
                            31.62544,
                            53.21738
                        ],
                        [
                            31.77541,
                            53.19268
                        ],
                        [
                            31.80051,
                            53.13216
                        ],
                        [
                            31.91987,
                            53.09821
                        ],
                        [
                            32.11528,
                            53.08747
                        ],
                        [
                            32.29888,
                            53.13193
                        ],
                        [
                            32.61194,
                            53.31305
                        ],
                        [
                            32.72443,
                            53.36028
                        ],
                        [
                            32.74006,
                            53.45881
                        ],
                        [
                            32.47374,
                            53.55277
                        ],
                        [
                            32.42054,
                            53.64756
                        ],
                        [
                            32.50346,
                            53.68199
                        ],
                        [
                            32.45711,
                            53.72431
                        ],
                        [
                            32.12077,
                            53.81959
                        ],
                        [
                            31.89038,
                            53.77842
                        ],
                        [
                            31.76547,
                            53.80433
                        ],
                        [
                            31.82874,
                            53.88644
                        ],
                        [
                            31.865,
                            54.0064
                        ],
                        [
                            31.84593,
                            54.05972
                        ],
                        [
                            31.756,
                            54.10454
                        ],
                        [
                            31.67555,
                            54.10685
                        ],
                        [
                            31.52395,
                            54.15098
                        ],
                        [
                            31.32943,
                            54.24306
                        ],
                        [
                            31.31153,
                            54.34174
                        ],
                        [
                            31.22666,
                            54.45818
                        ],
                        [
                            31.09268,
                            54.4935
                        ],
                        [
                            31.13768,
                            54.57669
                        ],
                        [
                            31.1028,
                            54.64546
                        ],
                        [
                            31.00642,
                            54.71026
                        ],
                        [
                            30.78326,
                            54.79957
                        ],
                        [
                            30.86508,
                            54.94699
                        ],
                        [
                            30.9405,
                            54.96425
                        ],
                        [
                            31.02696,
                            55.04847
                        ],
                        [
                            30.97698,
                            55.15344
                        ],
                        [
                            30.81653,
                            55.30185
                        ],
                        [
                            30.93581,
                            55.39929
                        ],
                        [
                            30.92625,
                            55.60257
                        ],
                        [
                            30.7575,
                            55.597
                        ],
                        [
                            30.49152,
                            55.79902
                        ],
                        [
                            30.24583,
                            55.85444
                        ],
                        [
                            29.97252,
                            55.85637
                        ],
                        [
                            29.65638,
                            55.76527
                        ],
                        [
                            29.485,
                            55.69221
                        ],
                        [
                            29.35979,
                            55.7968
                        ],
                        [
                            29.41007,
                            55.95791
                        ],
                        [
                            29.05944,
                            56.03277
                        ],
                        [
                            28.74611,
                            55.9561
                        ],
                        [
                            28.65,
                            56.09124
                        ],
                        [
                            28.52819,
                            56.10513
                        ],
                        [
                            28.37895,
                            56.09041
                        ],
                        [
                            28.3099,
                            56.05136
                        ],
                        [
                            28.15456,
                            56.16984
                        ],
                        [
                            27.99238,
                            56.12553
                        ],
                        [
                            27.78534,
                            55.97625
                        ],
                        [
                            27.65309,
                            55.92959
                        ],
                        [
                            27.6136,
                            55.78676
                        ],
                        [
                            27.3567,
                            55.81172
                        ],
                        [
                            27.28512,
                            55.78581
                        ],
                        [
                            27.15405,
                            55.85163
                        ],
                        [
                            27.01483,
                            55.82828
                        ],
                        [
                            26.92003,
                            55.78688
                        ],
                        [
                            26.8691,
                            55.71244
                        ],
                        [
                            26.65324,
                            55.70727
                        ],
                        [
                            26.63037,
                            55.68067
                        ],
                        [
                            26.62074,
                            55.56534
                        ],
                        [
                            26.52676,
                            55.51294
                        ],
                        [
                            26.55139,
                            55.38961
                        ],
                        [
                            26.4526,
                            55.34062
                        ],
                        [
                            26.79072,
                            55.32044
                        ],
                        [
                            26.68648,
                            55.17865
                        ],
                        [
                            26.61831,
                            55.14709
                        ],
                        [
                            26.46216,
                            55.1292
                        ],
                        [
                            26.35955,
                            55.15016
                        ],
                        [
                            26.20797,
                            54.99768
                        ],
                        [
                            26.07929,
                            54.95484
                        ],
                        [
                            25.85966,
                            54.92769
                        ],
                        [
                            25.73429,
                            54.80214
                        ],
                        [
                            25.73117,
                            54.6825
                        ],
                        [
                            25.7616,
                            54.5771
                        ],
                        [
                            25.67955,
                            54.53378
                        ],
                        [
                            25.61807,
                            54.45872
                        ],
                        [
                            25.63143,
                            54.42085
                        ],
                        [
                            25.55516,
                            54.31552
                        ],
                        [
                            25.67753,
                            54.32343
                        ],
                        [
                            25.78423,
                            54.23326
                        ],
                        [
                            25.78115,
                            54.15994
                        ],
                        [
                            25.6849,
                            54.14147
                        ],
                        [
                            25.54822,
                            54.15274
                        ],
                        [
                            25.57024,
                            54.24665
                        ],
                        [
                            25.51053,
                            54.30836
                        ],
                        [
                            25.35364,
                            54.26421
                        ],
                        [
                            25.21591,
                            54.25615
                        ],
                        [
                            25.2039,
                            54.2242
                        ],
                        [
                            25.06863,
                            54.13416
                        ],
                        [
                            24.95661,
                            54.17152
                        ],
                        [
                            24.7786,
                            54.10078
                        ],
                        [
                            24.84211,
                            54.03393
                        ],
                        [
                            24.61674,
                            54.007
                        ],
                        [
                            24.43173,
                            53.90437
                        ],
                        [
                            24.35333,
                            53.89702
                        ],
                        [
                            24.20162,
                            53.96995
                        ],
                        [
                            23.98501,
                            53.92428
                        ],
                        [
                            23.88555,
                            53.94364
                        ],
                        [
                            23.60653,
                            53.92252
                        ],
                        [
                            23.51465,
                            53.95656
                        ],
                        [
                            23.54901,
                            53.76883
                        ],
                        [
                            23.65965,
                            53.52176
                        ],
                        [
                            23.818,
                            53.24527
                        ],
                        [
                            23.91491,
                            53.14282
                        ],
                        [
                            23.87233,
                            53.0834
                        ],
                        [
                            23.9255,
                            53.02348
                        ],
                        [
                            23.91688,
                            52.93862
                        ],
                        [
                            23.93835,
                            52.71346
                        ],
                        [
                            23.76604,
                            52.61834
                        ],
                        [
                            23.64273,
                            52.60755
                        ],
                        [
                            23.46692,
                            52.54914
                        ],
                        [
                            23.35672,
                            52.46889
                        ],
                        [
                            23.21635,
                            52.33047
                        ],
                        [
                            23.20421,
                            52.22664
                        ],
                        [
                            23.39317,
                            52.20025
                        ],
                        [
                            23.59605,
                            52.1174
                        ],
                        [
                            23.68858,
                            51.99107
                        ],
                        [
                            23.6076,
                            51.87584
                        ],
                        [
                            23.63036,
                            51.78054
                        ],
                        [
                            23.55969,
                            51.76105
                        ],
                        [
                            23.54133,
                            51.60191
                        ],
                        [
                            23.61744,
                            51.50954
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "BEL",
                "Country": "Belgium",
                "Total_3GHG": 0.41,
                "Total_3GHG_timeseries": [
                    8.5279e-06,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0047,
                    0.0048,
                    0.0048,
                    0.0049,
                    0.0049,
                    0.005,
                    0.005,
                    0.0051,
                    0.0051,
                    0.0052,
                    0.0052,
                    0.0053,
                    0.0053,
                    0.0054,
                    0.0054,
                    0.0055,
                    0.0056,
                    0.0056,
                    0.0057,
                    0.0057,
                    0.0058,
                    0.0058,
                    0.0059,
                    0.0059,
                    0.006,
                    0.0061,
                    0.0061,
                    0.0062,
                    0.0062,
                    0.0063,
                    0.0063,
                    0.0064,
                    0.0064,
                    0.0064,
                    0.0065,
                    0.0065,
                    0.0066,
                    0.0066,
                    0.0067,
                    0.0067,
                    0.0067
                ],
                "Fossil_3GHG": 0.58,
                "Fossil_3GHG_timeseries": [
                    5.5233e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0045,
                    0.0046,
                    0.0046,
                    0.0047,
                    0.0047,
                    0.0048,
                    0.0048,
                    0.0049,
                    0.0049,
                    0.005,
                    0.005,
                    0.0051,
                    0.0051,
                    0.0052,
                    0.0052,
                    0.0053,
                    0.0053,
                    0.0054,
                    0.0054,
                    0.0055,
                    0.0055,
                    0.0056,
                    0.0057,
                    0.0057,
                    0.0057,
                    0.0058,
                    0.0058,
                    0.0059,
                    0.0059,
                    0.006,
                    0.006,
                    0.0061,
                    0.0061,
                    0.0061,
                    0.0062
                ],
                "Land_3GHG": 0.1,
                "Land_3GHG_timeseries": [
                    3.0046e-06,
                    5.9119e-06,
                    9.0045e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006
                ],
                "Total_CO2": 0.51,
                "Total_CO2_timeseries": [
                    6.6312e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.004,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0047,
                    0.0048,
                    0.0048,
                    0.0049,
                    0.005,
                    0.005,
                    0.0051,
                    0.0051,
                    0.0052,
                    0.0052,
                    0.0053,
                    0.0053,
                    0.0054,
                    0.0054,
                    0.0055,
                    0.0055,
                    0.0056,
                    0.0056,
                    0.0056,
                    0.0057,
                    0.0057,
                    0.0058,
                    0.0058
                ],
                "Fossil_CO2": 0.73,
                "Fossil_CO2_timeseries": [
                    4.5787e-06,
                    9.7168e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.004,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0045,
                    0.0046,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0048,
                    0.0049,
                    0.0049,
                    0.005,
                    0.005,
                    0.0051,
                    0.0051,
                    0.0052,
                    0.0052,
                    0.0053,
                    0.0053,
                    0.0054,
                    0.0054,
                    0.0055,
                    0.0055,
                    0.0055,
                    0.0056,
                    0.0056,
                    0.0057
                ],
                "Land_CO2": 0.04,
                "Land_CO2_timeseries": [
                    2.0524e-06,
                    3.9656e-06,
                    6.0224e-06,
                    8.1663e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Total_CH4": 0.14,
                "Total_CH4_timeseries": [
                    1.6618e-06,
                    3.517e-06,
                    5.5002e-06,
                    7.7128e-06,
                    9.9797e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006
                ],
                "Fossil_CH4": 0.11,
                "Fossil_CH4_timeseries": [
                    8.0383e-07,
                    1.7611e-06,
                    2.8063e-06,
                    4.0411e-06,
                    5.2902e-06,
                    6.4409e-06,
                    7.6214e-06,
                    8.8736e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Land_CH4": 0.18,
                "Land_CH4_timeseries": [
                    8.5798e-07,
                    1.7559e-06,
                    2.6938e-06,
                    3.6717e-06,
                    4.6895e-06,
                    5.7473e-06,
                    6.8451e-06,
                    7.9828e-06,
                    9.1605e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Total_N2O": 0.41,
                "Total_N2O_timeseries": [
                    2.3493e-07,
                    4.7341e-07,
                    7.1532e-07,
                    9.6053e-07,
                    1.2089e-06,
                    1.4601e-06,
                    1.7139e-06,
                    1.9701e-06,
                    2.2282e-06,
                    2.488e-06,
                    2.7491e-06,
                    3.0115e-06,
                    3.2752e-06,
                    3.5401e-06,
                    3.8062e-06,
                    4.0736e-06,
                    4.3421e-06,
                    4.612e-06,
                    4.8831e-06,
                    5.1557e-06,
                    5.4316e-06,
                    5.7145e-06,
                    6.007e-06,
                    6.3109e-06,
                    6.6274e-06,
                    6.9567e-06,
                    7.2982e-06,
                    7.6506e-06,
                    8.0116e-06,
                    8.3785e-06,
                    8.749e-06,
                    9.1229e-06,
                    9.4997e-06,
                    9.8793e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_N2O": 0.95,
                "Fossil_N2O_timeseries": [
                    1.4069e-07,
                    2.8304e-07,
                    4.2702e-07,
                    5.726e-07,
                    7.1975e-07,
                    8.6842e-07,
                    1.0185e-06,
                    1.1701e-06,
                    1.3229e-06,
                    1.477e-06,
                    1.6322e-06,
                    1.7886e-06,
                    1.9462e-06,
                    2.105e-06,
                    2.2649e-06,
                    2.4259e-06,
                    2.5881e-06,
                    2.7515e-06,
                    2.916e-06,
                    3.0817e-06,
                    3.2491e-06,
                    3.4188e-06,
                    3.5916e-06,
                    3.7677e-06,
                    3.9474e-06,
                    4.1307e-06,
                    4.3177e-06,
                    4.5079e-06,
                    4.7008e-06,
                    4.8959e-06,
                    5.0927e-06,
                    5.2911e-06,
                    5.4911e-06,
                    5.6925e-06,
                    5.8953e-06,
                    6.0996e-06,
                    6.3053e-06,
                    6.5125e-06,
                    6.7211e-06,
                    6.9371e-06,
                    7.1561e-06,
                    7.3781e-06,
                    7.6034e-06,
                    7.832e-06,
                    8.0642e-06,
                    8.2999e-06,
                    8.5394e-06,
                    8.7828e-06,
                    9.03e-06,
                    9.2813e-06,
                    9.537e-06,
                    9.7975e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_N2O": 0.21,
                "Land_N2O_timeseries": [
                    9.4243e-08,
                    1.9037e-07,
                    2.883e-07,
                    3.8793e-07,
                    4.891e-07,
                    5.9164e-07,
                    6.9536e-07,
                    8.0001e-07,
                    9.0532e-07,
                    1.011e-06,
                    1.1169e-06,
                    1.2229e-06,
                    1.329e-06,
                    1.4351e-06,
                    1.5414e-06,
                    1.6477e-06,
                    1.754e-06,
                    1.8605e-06,
                    1.9671e-06,
                    2.0739e-06,
                    2.1826e-06,
                    2.2957e-06,
                    2.4155e-06,
                    2.5433e-06,
                    2.6801e-06,
                    2.8259e-06,
                    2.9805e-06,
                    3.1427e-06,
                    3.3108e-06,
                    3.4825e-06,
                    3.6563e-06,
                    3.8318e-06,
                    4.0087e-06,
                    4.1868e-06,
                    4.3661e-06,
                    4.5464e-06,
                    4.7277e-06,
                    4.9102e-06,
                    5.0939e-06,
                    5.2557e-06,
                    5.4401e-06,
                    5.6458e-06,
                    5.8709e-06,
                    6.1138e-06,
                    6.3722e-06,
                    6.6438e-06,
                    6.9261e-06,
                    7.2163e-06,
                    7.5114e-06,
                    7.8082e-06,
                    8.1033e-06,
                    8.3938e-06,
                    8.6775e-06,
                    8.953e-06,
                    9.2195e-06,
                    9.4771e-06,
                    9.7264e-06,
                    9.969e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            6.021,
                            50.7543
                        ],
                        [
                            5.88629,
                            50.76948
                        ],
                        [
                            5.73728,
                            50.75779
                        ],
                        [
                            5.65542,
                            50.81976
                        ],
                        [
                            5.64665,
                            50.87212
                        ],
                        [
                            5.72373,
                            50.91053
                        ],
                        [
                            5.72087,
                            50.962
                        ],
                        [
                            5.80032,
                            51.06411
                        ],
                        [
                            5.82648,
                            51.16676
                        ],
                        [
                            5.56008,
                            51.22279
                        ],
                        [
                            5.48488,
                            51.30005
                        ],
                        [
                            5.41738,
                            51.26223
                        ],
                        [
                            5.22658,
                            51.2692
                        ],
                        [
                            5.2411,
                            51.30566
                        ],
                        [
                            5.07105,
                            51.39342
                        ],
                        [
                            5.08015,
                            51.4698
                        ],
                        [
                            4.92871,
                            51.39608
                        ],
                        [
                            4.82916,
                            51.42253
                        ],
                        [
                            4.84139,
                            51.48071
                        ],
                        [
                            4.75061,
                            51.49799
                        ],
                        [
                            4.63997,
                            51.42275
                        ],
                        [
                            4.53545,
                            51.42289
                        ],
                        [
                            4.53676,
                            51.48211
                        ],
                        [
                            4.39118,
                            51.45137
                        ],
                        [
                            4.33314,
                            51.3774
                        ],
                        [
                            4.24367,
                            51.37473
                        ],
                        [
                            4.23482,
                            51.34825
                        ],
                        [
                            4.16576,
                            51.29273
                        ],
                        [
                            3.95849,
                            51.21649
                        ],
                        [
                            3.79076,
                            51.21439
                        ],
                        [
                            3.79409,
                            51.25619
                        ],
                        [
                            3.5898,
                            51.30523
                        ],
                        [
                            3.42795,
                            51.24516
                        ],
                        [
                            3.37609,
                            51.27795
                        ],
                        [
                            3.36579,
                            51.36984
                        ],
                        [
                            3.0759,
                            51.30151
                        ],
                        [
                            2.76482,
                            51.16684
                        ],
                        [
                            2.54601,
                            51.08938
                        ],
                        [
                            2.63495,
                            50.81274
                        ],
                        [
                            2.7082,
                            50.81351
                        ],
                        [
                            2.78279,
                            50.75051
                        ],
                        [
                            2.9004,
                            50.69327
                        ],
                        [
                            2.9401,
                            50.74535
                        ],
                        [
                            3.15017,
                            50.7897
                        ],
                        [
                            3.19291,
                            50.72454
                        ],
                        [
                            3.2604,
                            50.70103
                        ],
                        [
                            3.24523,
                            50.64054
                        ],
                        [
                            3.28649,
                            50.52757
                        ],
                        [
                            3.37723,
                            50.49097
                        ],
                        [
                            3.43941,
                            50.50722
                        ],
                        [
                            3.6067,
                            50.49666
                        ],
                        [
                            3.66339,
                            50.45396
                        ],
                        [
                            3.67363,
                            50.33491
                        ],
                        [
                            3.85259,
                            50.35131
                        ],
                        [
                            3.90343,
                            50.32769
                        ],
                        [
                            4.03757,
                            50.34291
                        ],
                        [
                            4.13581,
                            50.27362
                        ],
                        [
                            4.22137,
                            50.25568
                        ],
                        [
                            4.15348,
                            50.16092
                        ],
                        [
                            4.2275,
                            50.07968
                        ],
                        [
                            4.13743,
                            50.02177
                        ],
                        [
                            4.20661,
                            49.95744
                        ],
                        [
                            4.31041,
                            49.9684
                        ],
                        [
                            4.44576,
                            49.93718
                        ],
                        [
                            4.68565,
                            50.00775
                        ],
                        [
                            4.70145,
                            50.09452
                        ],
                        [
                            4.80565,
                            50.15313
                        ],
                        [
                            4.87692,
                            50.1535
                        ],
                        [
                            4.79087,
                            49.95842
                        ],
                        [
                            4.88905,
                            49.9093
                        ],
                        [
                            4.86171,
                            49.78929
                        ],
                        [
                            4.99626,
                            49.80018
                        ],
                        [
                            5.09657,
                            49.75981
                        ],
                        [
                            5.16617,
                            49.69294
                        ],
                        [
                            5.26717,
                            49.69583
                        ],
                        [
                            5.43094,
                            49.59241
                        ],
                        [
                            5.47663,
                            49.49904
                        ],
                        [
                            5.70124,
                            49.53955
                        ],
                        [
                            5.81812,
                            49.54631
                        ],
                        [
                            5.87156,
                            49.57452
                        ],
                        [
                            5.90967,
                            49.66343
                        ],
                        [
                            5.74,
                            49.83566
                        ],
                        [
                            5.77704,
                            49.88406
                        ],
                        [
                            5.77704,
                            49.96095
                        ],
                        [
                            5.83197,
                            49.97698
                        ],
                        [
                            5.89527,
                            50.11222
                        ],
                        [
                            6.0249,
                            50.18278
                        ],
                        [
                            6.13766,
                            50.12995
                        ],
                        [
                            6.18435,
                            50.17858
                        ],
                        [
                            6.17879,
                            50.23618
                        ],
                        [
                            6.35586,
                            50.30939
                        ],
                        [
                            6.34312,
                            50.38038
                        ],
                        [
                            6.37457,
                            50.45145
                        ],
                        [
                            6.33536,
                            50.4895
                        ],
                        [
                            6.22522,
                            50.49548
                        ],
                        [
                            6.17542,
                            50.55708
                        ],
                        [
                            6.21771,
                            50.63188
                        ],
                        [
                            6.11631,
                            50.72076
                        ],
                        [
                            6.021,
                            50.7543
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "BLZ",
                "Country": "Belize",
                "Total_3GHG": 0.01,
                "Total_3GHG_timeseries": [
                    1.1942e-07,
                    2.0375e-07,
                    3.507e-07,
                    4.5343e-07,
                    5.8033e-07,
                    6.8032e-07,
                    7.7073e-07,
                    8.8837e-07,
                    9.7848e-07,
                    1.0968e-06,
                    1.22e-06,
                    1.3809e-06,
                    1.6251e-06,
                    1.7797e-06,
                    2.0187e-06,
                    2.1891e-06,
                    2.3569e-06,
                    2.5167e-06,
                    2.7e-06,
                    2.8546e-06,
                    3.0183e-06,
                    3.1725e-06,
                    3.3963e-06,
                    3.8207e-06,
                    4.0801e-06,
                    4.2991e-06,
                    4.4725e-06,
                    4.6447e-06,
                    4.8637e-06,
                    5.0487e-06,
                    5.2094e-06,
                    5.3669e-06,
                    5.6778e-06,
                    5.918e-06,
                    6.2132e-06,
                    6.5239e-06,
                    6.7498e-06,
                    6.9417e-06,
                    7.1229e-06,
                    7.4096e-06,
                    7.6581e-06,
                    7.884e-06,
                    8.2159e-06,
                    8.4618e-06,
                    8.6811e-06,
                    8.9662e-06,
                    9.4069e-06,
                    9.6976e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    7.6888e-09,
                    1.2634e-08,
                    1.711e-08,
                    2.1116e-08,
                    2.4654e-08,
                    3.0945e-08,
                    4.0062e-08,
                    5.2078e-08,
                    6.7069e-08,
                    8.5113e-08,
                    1.0616e-07,
                    1.3007e-07,
                    1.5706e-07,
                    1.8705e-07,
                    2.1809e-07,
                    2.502e-07,
                    2.8338e-07,
                    3.1765e-07,
                    3.521e-07,
                    3.8674e-07,
                    4.2634e-07,
                    4.6985e-07,
                    5.1513e-07,
                    5.6222e-07,
                    6.1079e-07,
                    6.5784e-07,
                    7.0331e-07,
                    7.4679e-07,
                    7.8821e-07,
                    8.275e-07,
                    8.6467e-07,
                    9.0341e-07,
                    9.4181e-07,
                    9.7798e-07,
                    1.0129e-06,
                    1.0466e-06,
                    1.0801e-06,
                    1.113e-06,
                    1.1467e-06,
                    1.1863e-06,
                    1.2257e-06,
                    1.2662e-06,
                    1.3083e-06,
                    1.3517e-06,
                    1.3965e-06,
                    1.4425e-06,
                    1.4898e-06,
                    1.5389e-06,
                    1.59e-06,
                    1.6369e-06,
                    1.6848e-06,
                    1.7303e-06,
                    1.7748e-06,
                    1.8203e-06,
                    1.8677e-06,
                    1.9169e-06,
                    1.9666e-06,
                    2.0175e-06,
                    2.0686e-06,
                    2.1153e-06,
                    2.1621e-06,
                    2.2079e-06,
                    2.2521e-06,
                    2.2934e-06,
                    2.3317e-06,
                    2.3672e-06,
                    2.3996e-06,
                    2.4289e-06,
                    2.4545e-06,
                    2.4827e-06,
                    2.5088e-06,
                    2.536e-06,
                    2.5629e-06,
                    2.5884e-06,
                    2.6127e-06,
                    2.6381e-06,
                    2.6635e-06,
                    2.6899e-06,
                    2.717e-06,
                    2.7458e-06,
                    2.7771e-06,
                    2.8094e-06,
                    2.8423e-06,
                    2.8764e-06,
                    2.9115e-06,
                    2.9478e-06,
                    2.9845e-06,
                    3.0232e-06,
                    3.0653e-06,
                    3.1092e-06,
                    3.1542e-06,
                    3.1983e-06,
                    3.2379e-06,
                    3.2764e-06,
                    3.3137e-06,
                    3.3521e-06,
                    3.3921e-06,
                    3.4319e-06,
                    3.4721e-06,
                    3.5184e-06,
                    3.5724e-06,
                    3.6285e-06,
                    3.6857e-06,
                    3.7411e-06,
                    3.7925e-06,
                    3.8379e-06,
                    3.8773e-06,
                    3.9136e-06,
                    3.9399e-06,
                    3.9587e-06,
                    3.9642e-06,
                    3.9753e-06,
                    3.9807e-06,
                    3.9937e-06,
                    4.0061e-06,
                    4.0143e-06,
                    4.0412e-06,
                    4.0655e-06,
                    4.1177e-06,
                    4.1365e-06,
                    4.1764e-06,
                    4.2223e-06,
                    4.265e-06,
                    4.3173e-06,
                    4.3838e-06,
                    4.4538e-06,
                    4.5476e-06,
                    4.6618e-06,
                    4.7812e-06,
                    4.9047e-06,
                    5.0368e-06,
                    5.1801e-06,
                    5.3497e-06,
                    5.516e-06,
                    5.6974e-06,
                    5.8919e-06,
                    6.0928e-06,
                    6.304e-06,
                    6.5297e-06,
                    6.8128e-06,
                    7.1319e-06,
                    7.4322e-06,
                    7.7457e-06,
                    8.0572e-06,
                    8.376e-06,
                    8.6725e-06,
                    9.0135e-06,
                    9.3499e-06,
                    9.6893e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_3GHG": 0.03,
                "Land_3GHG_timeseries": [
                    1.1173e-07,
                    1.9112e-07,
                    3.3359e-07,
                    4.3231e-07,
                    5.5567e-07,
                    6.4938e-07,
                    7.3067e-07,
                    8.3629e-07,
                    9.1142e-07,
                    1.0117e-06,
                    1.1138e-06,
                    1.2509e-06,
                    1.468e-06,
                    1.5927e-06,
                    1.8006e-06,
                    1.9389e-06,
                    2.0735e-06,
                    2.1991e-06,
                    2.3479e-06,
                    2.4679e-06,
                    2.5919e-06,
                    2.7027e-06,
                    2.8812e-06,
                    3.2585e-06,
                    3.4693e-06,
                    3.6413e-06,
                    3.7692e-06,
                    3.8979e-06,
                    4.0755e-06,
                    4.2212e-06,
                    4.3448e-06,
                    4.4635e-06,
                    4.736e-06,
                    4.94e-06,
                    5.2003e-06,
                    5.4773e-06,
                    5.6697e-06,
                    5.8288e-06,
                    5.9762e-06,
                    6.2232e-06,
                    6.4324e-06,
                    6.6178e-06,
                    6.9076e-06,
                    7.1101e-06,
                    7.2846e-06,
                    7.5238e-06,
                    7.9171e-06,
                    8.1587e-06,
                    8.4502e-06,
                    8.7033e-06,
                    8.9429e-06,
                    9.1608e-06,
                    9.4088e-06,
                    9.8223e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002
                ],
                "Total_CO2": 0.01,
                "Total_CO2_timeseries": [
                    1.0856e-07,
                    1.8477e-07,
                    3.2405e-07,
                    4.1957e-07,
                    5.3971e-07,
                    6.3018e-07,
                    7.0824e-07,
                    8.1061e-07,
                    8.8246e-07,
                    9.7943e-07,
                    1.0781e-06,
                    1.2114e-06,
                    1.4245e-06,
                    1.5449e-06,
                    1.7483e-06,
                    1.8819e-06,
                    2.0115e-06,
                    2.1318e-06,
                    2.2752e-06,
                    2.3895e-06,
                    2.5075e-06,
                    2.6119e-06,
                    2.7839e-06,
                    3.1543e-06,
                    3.3579e-06,
                    3.5225e-06,
                    3.6426e-06,
                    3.7632e-06,
                    3.9325e-06,
                    4.0695e-06,
                    4.1843e-06,
                    4.2942e-06,
                    4.5578e-06,
                    4.7527e-06,
                    5.0038e-06,
                    5.2715e-06,
                    5.4546e-06,
                    5.6041e-06,
                    5.742e-06,
                    5.9792e-06,
                    6.1783e-06,
                    6.3537e-06,
                    6.6332e-06,
                    6.8253e-06,
                    6.9894e-06,
                    7.2178e-06,
                    7.6004e-06,
                    7.831e-06,
                    8.1113e-06,
                    8.3531e-06,
                    8.5812e-06,
                    8.7874e-06,
                    9.0235e-06,
                    9.4248e-06,
                    9.7757e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    8.25e-09,
                    1.98e-08,
                    3.135e-08,
                    4.455e-08,
                    5.775e-08,
                    7.095e-08,
                    8.415e-08,
                    9.735e-08,
                    1.155e-07,
                    1.3365e-07,
                    1.5345e-07,
                    1.6995e-07,
                    2.013e-07,
                    2.2935e-07,
                    2.673e-07,
                    3.0525e-07,
                    3.4155e-07,
                    3.96e-07,
                    4.422e-07,
                    5.0325e-07,
                    5.577e-07,
                    6.2205e-07,
                    6.93e-07,
                    7.59e-07,
                    8.283e-07,
                    9.075e-07,
                    9.867e-07,
                    1.0758e-06,
                    1.1731e-06,
                    1.2672e-06,
                    1.353e-06,
                    1.4355e-06,
                    1.5131e-06,
                    1.5906e-06,
                    1.6682e-06,
                    1.7539e-06,
                    1.8463e-06,
                    1.9486e-06,
                    2.0608e-06,
                    2.1962e-06,
                    2.3364e-06,
                    2.5195e-06,
                    2.6796e-06,
                    2.8496e-06,
                    3.0178e-06,
                    3.1878e-06,
                    3.3264e-06,
                    3.5013e-06,
                    3.668e-06,
                    3.8247e-06,
                    4.0029e-06,
                    4.2042e-06,
                    4.3989e-06,
                    4.5936e-06,
                    4.7702e-06,
                    4.9599e-06,
                    5.1595e-06,
                    5.374e-06,
                    5.5704e-06,
                    5.8031e-06,
                    6.0456e-06,
                    6.2948e-06,
                    6.4977e-06,
                    6.6957e-06,
                    6.9069e-06,
                    7.1957e-06,
                    7.4778e-06,
                    7.755e-06,
                    8.0273e-06,
                    8.3457e-06,
                    8.6219e-06,
                    8.9381e-06,
                    9.2646e-06
                ],
                "Land_CO2": 0.04,
                "Land_CO2_timeseries": [
                    1.0856e-07,
                    1.8477e-07,
                    3.2405e-07,
                    4.1957e-07,
                    5.3971e-07,
                    6.3018e-07,
                    7.0824e-07,
                    8.1061e-07,
                    8.8246e-07,
                    9.7943e-07,
                    1.0781e-06,
                    1.2114e-06,
                    1.4245e-06,
                    1.5449e-06,
                    1.7483e-06,
                    1.8819e-06,
                    2.0115e-06,
                    2.1318e-06,
                    2.2752e-06,
                    2.3895e-06,
                    2.5075e-06,
                    2.6119e-06,
                    2.7839e-06,
                    3.1543e-06,
                    3.3579e-06,
                    3.5225e-06,
                    3.6426e-06,
                    3.7632e-06,
                    3.9325e-06,
                    4.0695e-06,
                    4.1843e-06,
                    4.2942e-06,
                    4.5578e-06,
                    4.7527e-06,
                    5.0038e-06,
                    5.2715e-06,
                    5.4546e-06,
                    5.6041e-06,
                    5.742e-06,
                    5.9792e-06,
                    6.1783e-06,
                    6.3537e-06,
                    6.6332e-06,
                    6.8253e-06,
                    6.9894e-06,
                    7.2178e-06,
                    7.6004e-06,
                    7.831e-06,
                    8.1113e-06,
                    8.3531e-06,
                    8.5812e-06,
                    8.7874e-06,
                    9.0235e-06,
                    9.4248e-06,
                    9.7757e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [
                    9.9532e-09,
                    1.7165e-08,
                    2.3908e-08,
                    3.0184e-08,
                    3.5994e-08,
                    4.4559e-08,
                    5.5951e-08,
                    7.0245e-08,
                    8.7518e-08,
                    1.0785e-07,
                    1.3141e-07,
                    1.5809e-07,
                    1.8807e-07,
                    2.213e-07,
                    2.5582e-07,
                    2.9163e-07,
                    3.2876e-07,
                    3.6722e-07,
                    4.0609e-07,
                    4.4539e-07,
                    4.8993e-07,
                    5.3864e-07,
                    5.894e-07,
                    6.4223e-07,
                    6.9681e-07,
                    7.5015e-07,
                    8.0216e-07,
                    8.5246e-07,
                    9.0096e-07,
                    9.4761e-07,
                    9.9224e-07,
                    1.0385e-06,
                    1.0846e-06,
                    1.1285e-06,
                    1.1713e-06,
                    1.2129e-06,
                    1.2545e-06,
                    1.2954e-06,
                    1.3374e-06,
                    1.3853e-06,
                    1.4331e-06,
                    1.4822e-06,
                    1.5329e-06,
                    1.5851e-06,
                    1.6386e-06,
                    1.6936e-06,
                    1.75e-06,
                    1.8082e-06,
                    1.8687e-06,
                    1.925e-06,
                    1.9823e-06,
                    2.0374e-06,
                    2.0916e-06,
                    2.147e-06,
                    2.2044e-06,
                    2.2636e-06,
                    2.3235e-06,
                    2.3847e-06,
                    2.4462e-06,
                    2.5035e-06,
                    2.5611e-06,
                    2.6177e-06,
                    2.673e-06,
                    2.7256e-06,
                    2.7753e-06,
                    2.8224e-06,
                    2.8666e-06,
                    2.9078e-06,
                    2.9456e-06,
                    2.9861e-06,
                    3.0248e-06,
                    3.0648e-06,
                    3.1046e-06,
                    3.1432e-06,
                    3.181e-06,
                    3.2199e-06,
                    3.2592e-06,
                    3.2996e-06,
                    3.341e-06,
                    3.3842e-06,
                    3.4302e-06,
                    3.4774e-06,
                    3.5254e-06,
                    3.5747e-06,
                    3.6253e-06,
                    3.6769e-06,
                    3.7285e-06,
                    3.7817e-06,
                    3.8379e-06,
                    3.8956e-06,
                    3.954e-06,
                    4.0111e-06,
                    4.0633e-06,
                    4.114e-06,
                    4.163e-06,
                    4.2127e-06,
                    4.2634e-06,
                    4.3135e-06,
                    4.3635e-06,
                    4.4109e-06,
                    4.4633e-06,
                    4.5185e-06,
                    4.5738e-06,
                    4.6275e-06,
                    4.6778e-06,
                    4.7232e-06,
                    4.7635e-06,
                    4.797e-06,
                    4.8216e-06,
                    4.8382e-06,
                    4.8477e-06,
                    4.8507e-06,
                    4.861e-06,
                    4.8819e-06,
                    4.9142e-06,
                    4.9492e-06,
                    4.981e-06,
                    5.019e-06,
                    5.0733e-06,
                    5.1063e-06,
                    5.1618e-06,
                    5.2217e-06,
                    5.2882e-06,
                    5.3744e-06,
                    5.4723e-06,
                    5.5763e-06,
                    5.6936e-06,
                    5.8195e-06,
                    5.9623e-06,
                    6.1122e-06,
                    6.2685e-06,
                    6.4459e-06,
                    6.6191e-06,
                    6.7917e-06,
                    6.9561e-06,
                    7.1216e-06,
                    7.2928e-06,
                    7.4658e-06,
                    7.6358e-06,
                    7.8746e-06,
                    8.0771e-06,
                    8.319e-06,
                    8.5272e-06,
                    8.7261e-06,
                    8.8641e-06,
                    9.0087e-06,
                    9.172e-06,
                    9.3568e-06,
                    9.5616e-06,
                    9.7606e-06,
                    9.9887e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [
                    6.9268e-09,
                    1.1102e-08,
                    1.4799e-08,
                    1.8018e-08,
                    2.0761e-08,
                    2.625e-08,
                    3.4556e-08,
                    4.5753e-08,
                    5.9919e-08,
                    7.713e-08,
                    9.7337e-08,
                    1.2041e-07,
                    1.4654e-07,
                    1.7567e-07,
                    2.0585e-07,
                    2.3708e-07,
                    2.6938e-07,
                    3.0276e-07,
                    3.3632e-07,
                    3.7006e-07,
                    4.0875e-07,
                    4.5133e-07,
                    4.9569e-07,
                    5.4183e-07,
                    5.8944e-07,
                    6.3551e-07,
                    6.8e-07,
                    7.2247e-07,
                    7.6288e-07,
                    8.0114e-07,
                    8.3728e-07,
                    8.7497e-07,
                    9.1233e-07,
                    9.4744e-07,
                    9.8131e-07,
                    1.0139e-06,
                    1.0464e-06,
                    1.0781e-06,
                    1.1108e-06,
                    1.1493e-06,
                    1.1875e-06,
                    1.2269e-06,
                    1.2678e-06,
                    1.3101e-06,
                    1.3537e-06,
                    1.3985e-06,
                    1.4446e-06,
                    1.4925e-06,
                    1.5424e-06,
                    1.5881e-06,
                    1.6347e-06,
                    1.6789e-06,
                    1.7221e-06,
                    1.7664e-06,
                    1.8125e-06,
                    1.8603e-06,
                    1.9087e-06,
                    1.9582e-06,
                    2.0079e-06,
                    2.0532e-06,
                    2.0987e-06,
                    2.143e-06,
                    2.1859e-06,
                    2.2257e-06,
                    2.2625e-06,
                    2.2965e-06,
                    2.3274e-06,
                    2.3552e-06,
                    2.3793e-06,
                    2.406e-06,
                    2.4306e-06,
                    2.4562e-06,
                    2.4815e-06,
                    2.5054e-06,
                    2.5281e-06,
                    2.5518e-06,
                    2.5756e-06,
                    2.6004e-06,
                    2.6258e-06,
                    2.6529e-06,
                    2.6825e-06,
                    2.7132e-06,
                    2.7443e-06,
                    2.7766e-06,
                    2.8099e-06,
                    2.8445e-06,
                    2.8794e-06,
                    2.9163e-06,
                    2.9566e-06,
                    2.9986e-06,
                    3.0417e-06,
                    3.0839e-06,
                    3.1216e-06,
                    3.1581e-06,
                    3.1934e-06,
                    3.2297e-06,
                    3.2676e-06,
                    3.3053e-06,
                    3.3432e-06,
                    3.3791e-06,
                    3.4192e-06,
                    3.4614e-06,
                    3.5031e-06,
                    3.5428e-06,
                    3.5784e-06,
                    3.608e-06,
                    3.6315e-06,
                    3.6469e-06,
                    3.6522e-06,
                    3.6483e-06,
                    3.6342e-06,
                    3.6109e-06,
                    3.5852e-06,
                    3.5571e-06,
                    3.5282e-06,
                    3.4969e-06,
                    3.466e-06,
                    3.4406e-06,
                    3.4282e-06,
                    3.3884e-06,
                    3.3598e-06,
                    3.3308e-06,
                    3.3033e-06,
                    3.2823e-06,
                    3.2656e-06,
                    3.2525e-06,
                    3.2531e-06,
                    3.2657e-06,
                    3.2867e-06,
                    3.3198e-06,
                    3.3652e-06,
                    3.424e-06,
                    3.4975e-06,
                    3.5795e-06,
                    3.6694e-06,
                    3.7639e-06,
                    3.8567e-06,
                    3.9485e-06,
                    4.0328e-06,
                    4.1689e-06,
                    4.2972e-06,
                    4.4303e-06,
                    4.5672e-06,
                    4.7039e-06,
                    4.8455e-06,
                    4.9965e-06,
                    5.1541e-06,
                    5.3156e-06,
                    5.4899e-06,
                    5.6733e-06,
                    5.8635e-06,
                    6.0615e-06,
                    6.265e-06,
                    6.4761e-06,
                    6.6871e-06,
                    7.0019e-06,
                    7.3475e-06,
                    7.7033e-06,
                    8.0577e-06,
                    8.3801e-06,
                    8.734e-06,
                    9.0351e-06,
                    9.3106e-06,
                    9.5904e-06,
                    9.8744e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [
                    3.0263e-09,
                    6.0627e-09,
                    9.1092e-09,
                    1.2166e-08,
                    1.5232e-08,
                    1.8309e-08,
                    2.1395e-08,
                    2.4492e-08,
                    2.7599e-08,
                    3.0716e-08,
                    3.4077e-08,
                    3.7683e-08,
                    4.1534e-08,
                    4.5629e-08,
                    4.9968e-08,
                    5.4553e-08,
                    5.9381e-08,
                    6.4455e-08,
                    6.9772e-08,
                    7.5335e-08,
                    8.1179e-08,
                    8.7306e-08,
                    9.3714e-08,
                    1.004e-07,
                    1.0738e-07,
                    1.1463e-07,
                    1.2217e-07,
                    1.2999e-07,
                    1.3809e-07,
                    1.4647e-07,
                    1.5496e-07,
                    1.6355e-07,
                    1.7224e-07,
                    1.8105e-07,
                    1.8995e-07,
                    1.9896e-07,
                    2.0808e-07,
                    2.173e-07,
                    2.2662e-07,
                    2.3605e-07,
                    2.456e-07,
                    2.5527e-07,
                    2.6505e-07,
                    2.7495e-07,
                    2.8497e-07,
                    2.9511e-07,
                    3.0537e-07,
                    3.1574e-07,
                    3.2623e-07,
                    3.3684e-07,
                    3.4758e-07,
                    3.5845e-07,
                    3.6946e-07,
                    3.806e-07,
                    3.9187e-07,
                    4.0327e-07,
                    4.1481e-07,
                    4.2648e-07,
                    4.3828e-07,
                    4.5022e-07,
                    4.6234e-07,
                    4.7466e-07,
                    4.8718e-07,
                    4.9988e-07,
                    5.1278e-07,
                    5.2587e-07,
                    5.3915e-07,
                    5.5263e-07,
                    5.663e-07,
                    5.8016e-07,
                    5.9425e-07,
                    6.0856e-07,
                    6.2311e-07,
                    6.3788e-07,
                    6.5288e-07,
                    6.6811e-07,
                    6.8356e-07,
                    6.9925e-07,
                    7.1516e-07,
                    7.3129e-07,
                    7.4766e-07,
                    7.6426e-07,
                    7.8108e-07,
                    7.9814e-07,
                    8.1542e-07,
                    8.324e-07,
                    8.4905e-07,
                    8.6538e-07,
                    8.8136e-07,
                    8.9698e-07,
                    9.1226e-07,
                    9.2717e-07,
                    9.4172e-07,
                    9.5587e-07,
                    9.6962e-07,
                    9.8295e-07,
                    9.9584e-07,
                    1.0083e-06,
                    1.0203e-06,
                    1.0317e-06,
                    1.0441e-06,
                    1.0571e-06,
                    1.0707e-06,
                    1.0848e-06,
                    1.0994e-06,
                    1.1152e-06,
                    1.1321e-06,
                    1.1501e-06,
                    1.1694e-06,
                    1.19e-06,
                    1.2135e-06,
                    1.2398e-06,
                    1.2758e-06,
                    1.3248e-06,
                    1.3859e-06,
                    1.4522e-06,
                    1.515e-06,
                    1.5784e-06,
                    1.6451e-06,
                    1.7179e-06,
                    1.8019e-06,
                    1.891e-06,
                    1.9849e-06,
                    2.0921e-06,
                    2.2067e-06,
                    2.3237e-06,
                    2.4405e-06,
                    2.5538e-06,
                    2.6756e-06,
                    2.7924e-06,
                    2.9032e-06,
                    3.0219e-06,
                    3.1216e-06,
                    3.2122e-06,
                    3.2867e-06,
                    3.3577e-06,
                    3.4361e-06,
                    3.5173e-06,
                    3.6029e-06,
                    3.7057e-06,
                    3.7799e-06,
                    3.8886e-06,
                    3.96e-06,
                    4.0223e-06,
                    4.0186e-06,
                    4.0121e-06,
                    4.0179e-06,
                    4.0412e-06,
                    4.0717e-06,
                    4.0873e-06,
                    4.1252e-06,
                    4.1582e-06,
                    4.218e-06,
                    4.2497e-06,
                    4.3001e-06,
                    4.3668e-06,
                    4.4658e-06,
                    4.5822e-06,
                    4.7158e-06,
                    4.8396e-06,
                    5.014e-06,
                    5.1318e-06,
                    5.3473e-06,
                    5.4737e-06,
                    5.6697e-06,
                    5.8707e-06,
                    6.0651e-06,
                    6.2468e-06,
                    6.4272e-06,
                    6.6253e-06,
                    6.7982e-06,
                    6.9745e-06
                ],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [
                    9.0276e-10,
                    1.8167e-09,
                    2.7416e-09,
                    3.6773e-09,
                    4.6234e-09,
                    5.5794e-09,
                    6.545e-09,
                    7.5195e-09,
                    8.5022e-09,
                    9.4926e-09,
                    1.049e-08,
                    1.1495e-08,
                    1.2506e-08,
                    1.3525e-08,
                    1.455e-08,
                    1.5582e-08,
                    1.6622e-08,
                    1.7668e-08,
                    1.8721e-08,
                    1.9781e-08,
                    2.0853e-08,
                    2.1941e-08,
                    2.3053e-08,
                    2.419e-08,
                    2.5355e-08,
                    2.6548e-08,
                    2.7768e-08,
                    2.9013e-08,
                    3.0279e-08,
                    3.156e-08,
                    3.2853e-08,
                    3.4156e-08,
                    3.547e-08,
                    3.6793e-08,
                    3.8126e-08,
                    3.9468e-08,
                    4.0819e-08,
                    4.2179e-08,
                    4.3549e-08,
                    4.5077e-08,
                    4.6622e-08,
                    4.819e-08,
                    4.9788e-08,
                    5.1421e-08,
                    5.3094e-08,
                    5.4812e-08,
                    5.6578e-08,
                    5.8394e-08,
                    6.0264e-08,
                    6.2188e-08,
                    6.4184e-08,
                    6.628e-08,
                    6.8496e-08,
                    7.0846e-08,
                    7.3334e-08,
                    7.596e-08,
                    7.8715e-08,
                    8.158e-08,
                    8.4534e-08,
                    8.7544e-08,
                    9.0591e-08,
                    9.3674e-08,
                    9.6791e-08,
                    9.9941e-08,
                    1.0312e-07,
                    1.0633e-07,
                    1.0956e-07,
                    1.1282e-07,
                    1.161e-07,
                    1.194e-07,
                    1.2271e-07,
                    1.2602e-07,
                    1.2933e-07,
                    1.3263e-07,
                    1.3592e-07,
                    1.392e-07,
                    1.4247e-07,
                    1.4574e-07,
                    1.4901e-07,
                    1.523e-07,
                    1.5561e-07,
                    1.5896e-07,
                    1.6237e-07,
                    1.6585e-07,
                    1.6941e-07,
                    1.7305e-07,
                    1.7678e-07,
                    1.806e-07,
                    1.8451e-07,
                    1.885e-07,
                    1.9265e-07,
                    1.9711e-07,
                    2.0198e-07,
                    2.0733e-07,
                    2.1322e-07,
                    2.1966e-07,
                    2.2662e-07,
                    2.3406e-07,
                    2.419e-07,
                    2.5002e-07,
                    2.5843e-07,
                    2.6724e-07,
                    2.7654e-07,
                    2.8641e-07,
                    2.9686e-07,
                    3.0792e-07,
                    3.1958e-07,
                    3.3177e-07,
                    3.4444e-07,
                    3.5749e-07,
                    3.7115e-07,
                    3.856e-07,
                    4.0061e-07,
                    4.1618e-07,
                    4.3286e-07,
                    4.5011e-07,
                    4.6805e-07,
                    4.8691e-07,
                    5.0732e-07,
                    5.2973e-07,
                    5.5039e-07,
                    5.7225e-07,
                    5.9446e-07,
                    6.1754e-07,
                    6.4183e-07,
                    6.6453e-07,
                    6.8801e-07,
                    7.1252e-07,
                    7.3866e-07,
                    7.6442e-07,
                    7.8842e-07,
                    8.1735e-07,
                    8.5695e-07,
                    8.8577e-07,
                    9.1418e-07,
                    9.4588e-07,
                    9.7693e-07,
                    1.0105e-06,
                    1.0421e-06,
                    1.0763e-06,
                    1.1109e-06,
                    1.148e-06,
                    1.1825e-06,
                    1.2157e-06,
                    1.2465e-06,
                    1.2758e-06,
                    1.3069e-06,
                    1.3406e-06,
                    1.3765e-06,
                    1.4123e-06,
                    1.4479e-06,
                    1.5098e-06,
                    1.5969e-06,
                    1.6327e-06,
                    1.6754e-06,
                    1.7143e-06,
                    1.7565e-06,
                    1.7965e-06,
                    1.8487e-06,
                    1.8946e-06,
                    1.9558e-06,
                    2.0135e-06,
                    2.0984e-06,
                    2.1844e-06,
                    2.2726e-06,
                    2.3598e-06,
                    2.4391e-06,
                    2.5242e-06,
                    2.6137e-06,
                    2.7035e-06,
                    2.7937e-06,
                    2.8848e-06
                ],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [
                    7.6199e-10,
                    1.5324e-09,
                    2.311e-09,
                    3.0979e-09,
                    3.8929e-09,
                    4.6957e-09,
                    5.5064e-09,
                    6.3245e-09,
                    7.15e-09,
                    7.9826e-09,
                    8.822e-09,
                    9.6683e-09,
                    1.0521e-08,
                    1.1381e-08,
                    1.2248e-08,
                    1.3121e-08,
                    1.4002e-08,
                    1.4889e-08,
                    1.5783e-08,
                    1.6684e-08,
                    1.7593e-08,
                    1.8513e-08,
                    1.9445e-08,
                    2.0391e-08,
                    2.1351e-08,
                    2.2327e-08,
                    2.3316e-08,
                    2.4319e-08,
                    2.5334e-08,
                    2.6359e-08,
                    2.7392e-08,
                    2.8433e-08,
                    2.9482e-08,
                    3.054e-08,
                    3.1605e-08,
                    3.2677e-08,
                    3.3757e-08,
                    3.4845e-08,
                    3.5941e-08,
                    3.7055e-08,
                    3.818e-08,
                    3.9316e-08,
                    4.0463e-08,
                    4.1621e-08,
                    4.2792e-08,
                    4.3974e-08,
                    4.5169e-08,
                    4.6377e-08,
                    4.7598e-08,
                    4.8831e-08,
                    5.0079e-08,
                    5.1341e-08,
                    5.2618e-08,
                    5.3912e-08,
                    5.5222e-08,
                    5.6548e-08,
                    5.7891e-08,
                    5.925e-08,
                    6.0624e-08,
                    6.2015e-08,
                    6.342e-08,
                    6.484e-08,
                    6.6275e-08,
                    6.7724e-08,
                    6.9187e-08,
                    7.0665e-08,
                    7.2158e-08,
                    7.3664e-08,
                    7.5186e-08,
                    7.6721e-08,
                    7.8272e-08,
                    7.9837e-08,
                    8.1416e-08,
                    8.3009e-08,
                    8.4617e-08,
                    8.6239e-08,
                    8.7876e-08,
                    8.9528e-08,
                    9.1195e-08,
                    9.2877e-08,
                    9.4575e-08,
                    9.6289e-08,
                    9.8018e-08,
                    9.9763e-08,
                    1.0152e-07,
                    1.033e-07,
                    1.051e-07,
                    1.0691e-07,
                    1.0874e-07,
                    1.106e-07,
                    1.1247e-07,
                    1.1438e-07,
                    1.1632e-07,
                    1.183e-07,
                    1.2032e-07,
                    1.2238e-07,
                    1.2448e-07,
                    1.2663e-07,
                    1.2882e-07,
                    1.3106e-07,
                    1.3334e-07,
                    1.3567e-07,
                    1.3807e-07,
                    1.4055e-07,
                    1.4309e-07,
                    1.4572e-07,
                    1.4843e-07,
                    1.5122e-07,
                    1.5408e-07,
                    1.5702e-07,
                    1.6002e-07,
                    1.6307e-07,
                    1.6618e-07,
                    1.6934e-07,
                    1.7256e-07,
                    1.7584e-07,
                    1.792e-07,
                    1.8266e-07,
                    1.8622e-07,
                    1.9043e-07,
                    1.9456e-07,
                    1.9857e-07,
                    2.0268e-07,
                    2.0665e-07,
                    2.1073e-07,
                    2.1452e-07,
                    2.1875e-07,
                    2.2297e-07,
                    2.2736e-07,
                    2.3185e-07,
                    2.3608e-07,
                    2.4303e-07,
                    2.6157e-07,
                    2.6835e-07,
                    2.7401e-07,
                    2.8167e-07,
                    2.874e-07,
                    2.9461e-07,
                    3.0071e-07,
                    3.0756e-07,
                    3.152e-07,
                    3.2226e-07,
                    3.2898e-07,
                    3.3552e-07,
                    3.4269e-07,
                    3.4958e-07,
                    3.5808e-07,
                    3.6637e-07,
                    3.7464e-07,
                    3.8273e-07,
                    3.9055e-07,
                    3.9735e-07,
                    4.0446e-07,
                    4.1148e-07,
                    4.1856e-07,
                    4.26e-07,
                    4.3261e-07,
                    4.3871e-07,
                    4.4537e-07,
                    4.5292e-07,
                    4.6235e-07,
                    4.7215e-07,
                    4.8091e-07,
                    4.8932e-07,
                    4.9838e-07,
                    5.0758e-07,
                    5.1647e-07,
                    5.2495e-07,
                    5.3451e-07,
                    5.4389e-07,
                    5.5375e-07,
                    5.6322e-07
                ],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": [
                    1.4077e-10,
                    2.8435e-10,
                    4.3062e-10,
                    5.7942e-10,
                    7.3054e-10,
                    8.837e-10,
                    1.0386e-09,
                    1.1949e-09,
                    1.3522e-09,
                    1.5101e-09,
                    1.6682e-09,
                    1.8265e-09,
                    1.985e-09,
                    2.1436e-09,
                    2.3022e-09,
                    2.461e-09,
                    2.6199e-09,
                    2.7789e-09,
                    2.9382e-09,
                    3.0977e-09,
                    3.26e-09,
                    3.4289e-09,
                    3.6078e-09,
                    3.7988e-09,
                    4.003e-09,
                    4.2209e-09,
                    4.4518e-09,
                    4.694e-09,
                    4.9452e-09,
                    5.2016e-09,
                    5.4612e-09,
                    5.7233e-09,
                    5.9875e-09,
                    6.2536e-09,
                    6.5213e-09,
                    6.7906e-09,
                    7.0615e-09,
                    7.3341e-09,
                    7.6085e-09,
                    8.0225e-09,
                    8.4423e-09,
                    8.8746e-09,
                    9.3254e-09,
                    9.7998e-09,
                    1.0303e-08,
                    1.0838e-08,
                    1.1408e-08,
                    1.2017e-08,
                    1.2666e-08,
                    1.3357e-08,
                    1.4106e-08,
                    1.4939e-08,
                    1.5878e-08,
                    1.6934e-08,
                    1.8113e-08,
                    1.9412e-08,
                    2.0824e-08,
                    2.2331e-08,
                    2.391e-08,
                    2.5529e-08,
                    2.7171e-08,
                    2.8834e-08,
                    3.0517e-08,
                    3.2217e-08,
                    3.3933e-08,
                    3.5664e-08,
                    3.7406e-08,
                    3.9157e-08,
                    4.0915e-08,
                    4.2676e-08,
                    4.4435e-08,
                    4.6183e-08,
                    4.7913e-08,
                    4.962e-08,
                    5.1303e-08,
                    5.2962e-08,
                    5.4597e-08,
                    5.6215e-08,
                    5.782e-08,
                    5.9421e-08,
                    6.1034e-08,
                    6.2674e-08,
                    6.4355e-08,
                    6.6089e-08,
                    6.7885e-08,
                    6.9748e-08,
                    7.1681e-08,
                    7.3687e-08,
                    7.5761e-08,
                    7.7901e-08,
                    8.0179e-08,
                    8.2731e-08,
                    8.5659e-08,
                    8.9036e-08,
                    9.2906e-08,
                    9.7279e-08,
                    1.0214e-07,
                    1.0743e-07,
                    1.1307e-07,
                    1.1896e-07,
                    1.2509e-07,
                    1.3157e-07,
                    1.3847e-07,
                    1.4586e-07,
                    1.5377e-07,
                    1.622e-07,
                    1.7115e-07,
                    1.8056e-07,
                    1.9036e-07,
                    2.0048e-07,
                    2.1113e-07,
                    2.2253e-07,
                    2.3442e-07,
                    2.4684e-07,
                    2.603e-07,
                    2.7427e-07,
                    2.8884e-07,
                    3.0426e-07,
                    3.211e-07,
                    3.393e-07,
                    3.5583e-07,
                    3.7368e-07,
                    3.9178e-07,
                    4.109e-07,
                    4.311e-07,
                    4.5001e-07,
                    4.6926e-07,
                    4.8955e-07,
                    5.1131e-07,
                    5.3258e-07,
                    5.5234e-07,
                    5.7432e-07,
                    5.9539e-07,
                    6.1742e-07,
                    6.4017e-07,
                    6.6422e-07,
                    6.8953e-07,
                    7.1584e-07,
                    7.4142e-07,
                    7.6879e-07,
                    7.9575e-07,
                    8.2569e-07,
                    8.5349e-07,
                    8.8014e-07,
                    9.0377e-07,
                    9.2617e-07,
                    9.4887e-07,
                    9.7418e-07,
                    1.0018e-06,
                    1.0295e-06,
                    1.0573e-06,
                    1.1125e-06,
                    1.1924e-06,
                    1.2213e-06,
                    1.2568e-06,
                    1.2883e-06,
                    1.3239e-06,
                    1.3578e-06,
                    1.4033e-06,
                    1.4417e-06,
                    1.4934e-06,
                    1.5413e-06,
                    1.6175e-06,
                    1.695e-06,
                    1.7742e-06,
                    1.8522e-06,
                    1.9226e-06,
                    1.9992e-06,
                    2.0792e-06,
                    2.1597e-06,
                    2.24e-06,
                    2.3216e-06
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -88.31683,
                            18.4888
                        ],
                        [
                            -88.47387,
                            18.49406
                        ],
                        [
                            -88.51196,
                            18.46289
                        ],
                        [
                            -88.54588,
                            18.351
                        ],
                        [
                            -88.59219,
                            18.30167
                        ],
                        [
                            -88.5997,
                            18.2493
                        ],
                        [
                            -88.6523,
                            18.1748
                        ],
                        [
                            -88.69969,
                            18.06359
                        ],
                        [
                            -88.75352,
                            18.03559
                        ],
                        [
                            -88.78058,
                            17.97916
                        ],
                        [
                            -88.84697,
                            17.92736
                        ],
                        [
                            -88.91663,
                            17.92154
                        ],
                        [
                            -89.02756,
                            18.00304
                        ],
                        [
                            -89.14518,
                            17.94339
                        ],
                        [
                            -89.14696,
                            17.8095
                        ],
                        [
                            -89.14585,
                            17.04706
                        ],
                        [
                            -89.18488,
                            16.47232
                        ],
                        [
                            -89.22465,
                            15.92644
                        ],
                        [
                            -89.08015,
                            15.8948
                        ],
                        [
                            -89.04181,
                            15.91005
                        ],
                        [
                            -88.91278,
                            15.90013
                        ],
                        [
                            -88.93125,
                            15.98494
                        ],
                        [
                            -88.86075,
                            16.03098
                        ],
                        [
                            -88.79434,
                            16.11775
                        ],
                        [
                            -88.75417,
                            16.13854
                        ],
                        [
                            -88.75206,
                            16.21697
                        ],
                        [
                            -88.65591,
                            16.25956
                        ],
                        [
                            -88.54691,
                            16.27485
                        ],
                        [
                            -88.49115,
                            16.34769
                        ],
                        [
                            -88.48103,
                            16.39621
                        ],
                        [
                            -88.39511,
                            16.50496
                        ],
                        [
                            -88.37044,
                            16.6144
                        ],
                        [
                            -88.30286,
                            16.721
                        ],
                        [
                            -88.31792,
                            16.77039
                        ],
                        [
                            -88.25651,
                            16.80769
                        ],
                        [
                            -88.27476,
                            16.91726
                        ],
                        [
                            -88.22035,
                            16.96165
                        ],
                        [
                            -88.24613,
                            17.06124
                        ],
                        [
                            -88.29956,
                            17.12258
                        ],
                        [
                            -88.30305,
                            17.23785
                        ],
                        [
                            -88.24838,
                            17.46931
                        ],
                        [
                            -88.22719,
                            17.52055
                        ],
                        [
                            -88.28427,
                            17.5646
                        ],
                        [
                            -88.27435,
                            17.72322
                        ],
                        [
                            -88.23292,
                            17.78778
                        ],
                        [
                            -88.20382,
                            17.9223
                        ],
                        [
                            -88.10581,
                            18.10391
                        ],
                        [
                            -88.09101,
                            18.20646
                        ],
                        [
                            -88.10277,
                            18.36784
                        ],
                        [
                            -88.19828,
                            18.33709
                        ],
                        [
                            -88.24542,
                            18.356
                        ],
                        [
                            -88.3364,
                            18.32931
                        ],
                        [
                            -88.38148,
                            18.39261
                        ],
                        [
                            -88.30155,
                            18.45483
                        ],
                        [
                            -88.31683,
                            18.4888
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "BEN",
                "Country": "Benin",
                "Total_3GHG": 0.05,
                "Total_3GHG_timeseries": [
                    -0.00000078823,
                    -0.0000015821,
                    -0.000002382,
                    -0.0000031877,
                    -0.0000039994,
                    -0.0000048168,
                    -0.0000056397,
                    -0.0000064683,
                    -0.0000073022,
                    -0.0000080811,
                    -0.0000088064,
                    -0.0000094819,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    -0.0000099882,
                    -0.0000091453,
                    -0.0000082466,
                    -0.0000072894,
                    -0.0000062902,
                    -0.0000052373,
                    -0.0000041131,
                    -0.0000029136,
                    -0.000001642,
                    -0.00000029537,
                    1.1304e-06,
                    2.6345e-06,
                    4.2014e-06,
                    5.8548e-06,
                    7.5818e-06,
                    9.3887e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009
                ],
                "Fossil_3GHG": 0.02,
                "Fossil_3GHG_timeseries": [
                    -0.000000027818,
                    -0.000000055311,
                    -0.000000082481,
                    -0.00000010933,
                    -0.00000013585,
                    -0.00000016206,
                    -0.00000018796,
                    -0.00000021354,
                    -0.00000023881,
                    -0.00000026379,
                    -0.00000028509,
                    -0.00000030271,
                    -0.00000031667,
                    -0.00000032696,
                    -0.00000033359,
                    -0.00000033654,
                    -0.00000033582,
                    -0.00000033143,
                    -0.00000032338,
                    -0.00000031165,
                    -0.00000029648,
                    -0.00000027782,
                    -0.00000025565,
                    -0.00000022994,
                    -0.00000020068,
                    -0.00000016786,
                    -0.00000013149,
                    -0.000000091582,
                    -0.000000048167,
                    -0.0000000012792,
                    4.5744e-08,
                    9.2897e-08,
                    1.4053e-07,
                    1.9192e-07,
                    2.4718e-07,
                    3.0637e-07,
                    3.6958e-07,
                    4.3692e-07,
                    5.0846e-07,
                    5.845e-07,
                    6.6499e-07,
                    7.5004e-07,
                    8.3973e-07,
                    9.3419e-07,
                    1.0335e-06,
                    1.1378e-06,
                    1.2472e-06,
                    1.3618e-06,
                    1.4818e-06,
                    1.6072e-06,
                    1.743e-06,
                    1.8895e-06,
                    2.0468e-06,
                    2.2119e-06,
                    2.3851e-06,
                    2.5666e-06,
                    2.7566e-06,
                    2.9553e-06,
                    3.163e-06,
                    3.3799e-06,
                    3.6106e-06,
                    3.8555e-06,
                    4.1147e-06,
                    4.4509e-06,
                    4.7935e-06,
                    5.1424e-06,
                    5.4976e-06,
                    5.8522e-06,
                    6.2183e-06,
                    6.596e-06,
                    6.9752e-06,
                    7.3554e-06,
                    7.7363e-06,
                    8.1171e-06,
                    8.4976e-06,
                    8.8771e-06,
                    9.2635e-06,
                    9.6569e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_3GHG": 0.12,
                "Land_3GHG_timeseries": [
                    -0.00000076041,
                    -0.0000015268,
                    -0.0000022995,
                    -0.0000030784,
                    -0.0000038635,
                    -0.0000046547,
                    -0.0000054518,
                    -0.0000062547,
                    -0.0000070633,
                    -0.0000078173,
                    -0.0000085214,
                    -0.0000091791,
                    -0.0000097938,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    -0.0000098888,
                    -0.0000089974,
                    -0.0000080316,
                    -0.0000069868,
                    -0.0000058631,
                    -0.0000046757,
                    -0.0000034087,
                    -0.0000020751,
                    -0.00000066829,
                    8.0282e-07,
                    2.3375e-06,
                    3.9151e-06,
                    5.5653e-06,
                    7.2682e-06,
                    9.024e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007
                ],
                "Total_CO2": 0.05,
                "Total_CO2_timeseries": [
                    -0.00000074489,
                    -0.0000014963,
                    -0.0000022545,
                    -0.0000030194,
                    -0.0000037909,
                    -0.000004569,
                    -0.0000053534,
                    -0.0000061439,
                    -0.0000069405,
                    -0.0000076826,
                    -0.0000083788,
                    -0.0000090326,
                    -0.0000096472,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    -0.0000096687,
                    -0.000008643,
                    -0.0000075647,
                    -0.0000064275,
                    -0.0000052517,
                    -0.0000040069,
                    -0.0000027128,
                    -0.000001369,
                    9.251e-09,
                    1.4262e-06,
                    2.8774e-06,
                    4.3816e-06,
                    5.9724e-06,
                    7.6216e-06,
                    9.2909e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Fossil_CO2": 0.01,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    6.2061e-08,
                    1.1395e-07,
                    1.7198e-07,
                    2.2019e-07,
                    2.7699e-07,
                    3.3362e-07,
                    3.9919e-07,
                    4.6633e-07,
                    5.2243e-07,
                    5.6863e-07,
                    6.4123e-07,
                    6.9898e-07,
                    7.6003e-07,
                    8.1448e-07,
                    8.7883e-07,
                    9.4648e-07,
                    9.9763e-07,
                    1.062e-06,
                    1.1313e-06,
                    1.222e-06,
                    1.3491e-06,
                    1.4811e-06,
                    1.656e-06,
                    1.8276e-06,
                    2.0107e-06,
                    2.2104e-06,
                    2.3275e-06,
                    2.4612e-06,
                    2.6245e-06,
                    2.7895e-06,
                    3.0056e-06,
                    3.18e-06,
                    3.3793e-06,
                    3.5614e-06,
                    3.7633e-06,
                    4.0724e-06,
                    4.3534e-06,
                    4.5667e-06,
                    4.7955e-06,
                    5.0523e-06,
                    5.3132e-06,
                    5.5922e-06,
                    5.8944e-06,
                    6.258e-06,
                    6.6684e-06,
                    7.0991e-06,
                    7.6322e-06,
                    8.1834e-06,
                    8.685e-06,
                    9.3433e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CO2": 0.14,
                "Land_CO2_timeseries": [
                    -0.00000074489,
                    -0.0000014963,
                    -0.0000022545,
                    -0.0000030194,
                    -0.0000037909,
                    -0.000004569,
                    -0.0000053534,
                    -0.0000061439,
                    -0.0000069405,
                    -0.0000076826,
                    -0.0000083788,
                    -0.0000090326,
                    -0.0000096472,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    -0.0000096687,
                    -0.000008643,
                    -0.0000075647,
                    -0.0000064275,
                    -0.0000052517,
                    -0.0000040069,
                    -0.0000027128,
                    -0.000001369,
                    9.251e-09,
                    1.4262e-06,
                    2.8774e-06,
                    4.3816e-06,
                    5.9724e-06,
                    7.6216e-06,
                    9.2909e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Total_CH4": 0.07,
                "Total_CH4_timeseries": [
                    -0.000000061307,
                    -0.00000012213,
                    -0.00000018246,
                    -0.0000002423,
                    -0.00000030165,
                    -0.00000036051,
                    -0.00000041888,
                    -0.00000047677,
                    -0.00000053416,
                    -0.00000059106,
                    -0.00000064042,
                    -0.00000068224,
                    -0.00000071651,
                    -0.00000074324,
                    -0.00000076243,
                    -0.00000077407,
                    -0.00000077817,
                    -0.00000077473,
                    -0.00000076375,
                    -0.00000074522,
                    -0.00000071957,
                    -0.00000068679,
                    -0.0000006469,
                    -0.00000059989,
                    -0.00000054575,
                    -0.00000048449,
                    -0.0000004161,
                    -0.00000034059,
                    -0.00000025796,
                    -0.0000001682,
                    -0.000000078244,
                    1.1902e-08,
                    1.0259e-07,
                    1.9712e-07,
                    2.9557e-07,
                    3.9803e-07,
                    5.046e-07,
                    6.1535e-07,
                    7.3038e-07,
                    8.4979e-07,
                    9.7367e-07,
                    1.1021e-06,
                    1.2352e-06,
                    1.3731e-06,
                    1.5159e-06,
                    1.6636e-06,
                    1.8164e-06,
                    1.9745e-06,
                    2.1378e-06,
                    2.3066e-06,
                    2.4883e-06,
                    2.6832e-06,
                    2.8914e-06,
                    3.1099e-06,
                    3.3389e-06,
                    3.5788e-06,
                    3.8296e-06,
                    4.0916e-06,
                    4.3651e-06,
                    4.6503e-06,
                    4.9608e-06,
                    5.2968e-06,
                    5.6587e-06,
                    6.1088e-06,
                    6.5769e-06,
                    7.0626e-06,
                    7.5661e-06,
                    8.0804e-06,
                    8.6176e-06,
                    9.1778e-06,
                    9.7505e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_CH4": 0.06,
                "Fossil_CH4_timeseries": [
                    -0.000000029817,
                    -0.000000059343,
                    -0.000000088579,
                    -0.00000011752,
                    -0.00000014618,
                    -0.00000017454,
                    -0.00000020261,
                    -0.00000023039,
                    -0.00000025788,
                    -0.00000028507,
                    -0.0000003086,
                    -0.00000032847,
                    -0.00000034468,
                    -0.00000035722,
                    -0.0000003661,
                    -0.00000037132,
                    -0.00000037287,
                    -0.00000037076,
                    -0.00000036499,
                    -0.00000035556,
                    -0.00000034272,
                    -0.00000032646,
                    -0.0000003068,
                    -0.00000028374,
                    -0.00000025726,
                    -0.00000022737,
                    -0.00000019407,
                    -0.00000015736,
                    -0.00000011724,
                    -0.000000073702,
                    -0.000000030069,
                    1.3663e-08,
                    5.7843e-08,
                    1.0577e-07,
                    1.5752e-07,
                    2.132e-07,
                    2.7287e-07,
                    3.3664e-07,
                    4.046e-07,
                    4.7684e-07,
                    5.5346e-07,
                    6.3454e-07,
                    7.202e-07,
                    8.1053e-07,
                    9.0564e-07,
                    1.0056e-06,
                    1.1106e-06,
                    1.2207e-06,
                    1.336e-06,
                    1.4566e-06,
                    1.5876e-06,
                    1.7291e-06,
                    1.8812e-06,
                    2.0409e-06,
                    2.2086e-06,
                    2.3844e-06,
                    2.5685e-06,
                    2.7612e-06,
                    2.9628e-06,
                    3.1733e-06,
                    3.3977e-06,
                    3.636e-06,
                    3.8887e-06,
                    4.2182e-06,
                    4.5541e-06,
                    4.8962e-06,
                    5.2445e-06,
                    5.5921e-06,
                    5.9512e-06,
                    6.3216e-06,
                    6.6936e-06,
                    7.0665e-06,
                    7.4398e-06,
                    7.8132e-06,
                    8.186e-06,
                    8.5578e-06,
                    8.9364e-06,
                    9.3218e-06,
                    9.7139e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CH4": 0.08,
                "Land_CH4_timeseries": [
                    -0.00000003149,
                    -0.000000062783,
                    -0.000000093877,
                    -0.00000012477,
                    -0.00000015547,
                    -0.00000018597,
                    -0.00000021627,
                    -0.00000024638,
                    -0.00000027628,
                    -0.00000030599,
                    -0.00000033182,
                    -0.00000035377,
                    -0.00000037183,
                    -0.00000038602,
                    -0.00000039633,
                    -0.00000040275,
                    -0.0000004053,
                    -0.00000040397,
                    -0.00000039875,
                    -0.00000038966,
                    -0.00000037685,
                    -0.00000036033,
                    -0.0000003401,
                    -0.00000031615,
                    -0.00000028849,
                    -0.00000025712,
                    -0.00000022203,
                    -0.00000018323,
                    -0.00000014072,
                    -0.000000094495,
                    -0.000000048176,
                    -0.0000000017619,
                    4.4746e-08,
                    9.1349e-08,
                    1.3805e-07,
                    1.8484e-07,
                    2.3172e-07,
                    2.787e-07,
                    3.2578e-07,
                    3.7295e-07,
                    4.2021e-07,
                    4.6757e-07,
                    5.1503e-07,
                    5.6258e-07,
                    6.1023e-07,
                    6.5798e-07,
                    7.0582e-07,
                    7.5376e-07,
                    8.018e-07,
                    8.4993e-07,
                    9.0071e-07,
                    9.5414e-07,
                    1.0102e-06,
                    1.069e-06,
                    1.1303e-06,
                    1.1944e-06,
                    1.2611e-06,
                    1.3304e-06,
                    1.4024e-06,
                    1.477e-06,
                    1.5631e-06,
                    1.6608e-06,
                    1.7699e-06,
                    1.8906e-06,
                    2.0228e-06,
                    2.1664e-06,
                    2.3216e-06,
                    2.4883e-06,
                    2.6665e-06,
                    2.8562e-06,
                    3.0569e-06,
                    3.2688e-06,
                    3.4917e-06,
                    3.7256e-06,
                    3.9706e-06,
                    4.2267e-06,
                    4.4939e-06,
                    4.7721e-06,
                    5.0614e-06,
                    5.3618e-06,
                    5.6673e-06,
                    5.9779e-06,
                    6.2936e-06,
                    6.6144e-06,
                    6.9403e-06,
                    7.2794e-06,
                    7.6319e-06,
                    7.9981e-06,
                    8.3784e-06,
                    8.7731e-06,
                    9.1835e-06,
                    9.6101e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_N2O": 0.07,
                "Total_N2O_timeseries": [
                    1.7969e-08,
                    3.6292e-08,
                    5.4955e-08,
                    7.3935e-08,
                    9.3207e-08,
                    1.1274e-07,
                    1.3249e-07,
                    1.5242e-07,
                    1.7248e-07,
                    1.9262e-07,
                    2.1279e-07,
                    2.3299e-07,
                    2.5321e-07,
                    2.7346e-07,
                    2.9372e-07,
                    3.14e-07,
                    3.343e-07,
                    3.5462e-07,
                    3.7497e-07,
                    3.9537e-07,
                    4.161e-07,
                    4.3768e-07,
                    4.6049e-07,
                    4.8479e-07,
                    5.1075e-07,
                    5.3841e-07,
                    5.6767e-07,
                    5.9835e-07,
                    6.3013e-07,
                    6.6258e-07,
                    6.9542e-07,
                    7.2858e-07,
                    7.6201e-07,
                    7.9567e-07,
                    8.2954e-07,
                    8.6362e-07,
                    8.9789e-07,
                    9.3237e-07,
                    9.6709e-07,
                    1.0037e-06,
                    1.0406e-06,
                    1.078e-06,
                    1.1158e-06,
                    1.154e-06,
                    1.1927e-06,
                    1.2318e-06,
                    1.2715e-06,
                    1.3117e-06,
                    1.3524e-06,
                    1.3936e-06,
                    1.4354e-06,
                    1.4778e-06,
                    1.5207e-06,
                    1.5641e-06,
                    1.6082e-06,
                    1.653e-06,
                    1.6984e-06,
                    1.7446e-06,
                    1.7916e-06,
                    1.8396e-06,
                    1.8887e-06,
                    1.9398e-06,
                    1.9931e-06,
                    2.0491e-06,
                    2.1081e-06,
                    2.1702e-06,
                    2.2355e-06,
                    2.304e-06,
                    2.3754e-06,
                    2.4497e-06,
                    2.5268e-06,
                    2.6071e-06,
                    2.6908e-06,
                    2.7779e-06,
                    2.8683e-06,
                    2.9618e-06,
                    3.0581e-06,
                    3.1565e-06,
                    3.2564e-06,
                    3.3569e-06,
                    3.4574e-06,
                    3.557e-06,
                    3.6554e-06,
                    3.7524e-06,
                    3.8476e-06,
                    3.9412e-06,
                    4.0334e-06,
                    4.1244e-06,
                    4.2148e-06,
                    4.3052e-06,
                    4.4042e-06,
                    4.5259e-06,
                    4.6807e-06,
                    4.8759e-06,
                    5.115e-06,
                    5.3982e-06,
                    5.722e-06,
                    6.0798e-06,
                    6.4613e-06,
                    6.8525e-06,
                    7.2415e-06,
                    7.6213e-06,
                    7.9868e-06,
                    8.3344e-06,
                    8.6626e-06,
                    8.9711e-06,
                    9.2619e-06,
                    9.5383e-06,
                    9.8055e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_N2O": 0.03,
                "Fossil_N2O_timeseries": [
                    1.9985e-09,
                    4.0315e-09,
                    6.0978e-09,
                    8.1956e-09,
                    1.0323e-08,
                    1.2477e-08,
                    1.4654e-08,
                    1.6851e-08,
                    1.9063e-08,
                    2.1287e-08,
                    2.3519e-08,
                    2.5758e-08,
                    2.8004e-08,
                    3.0257e-08,
                    3.2516e-08,
                    3.4781e-08,
                    3.7053e-08,
                    3.9331e-08,
                    4.1618e-08,
                    4.3912e-08,
                    4.624e-08,
                    4.8643e-08,
                    5.1154e-08,
                    5.3796e-08,
                    5.6581e-08,
                    5.9512e-08,
                    6.2583e-08,
                    6.5778e-08,
                    6.907e-08,
                    7.2423e-08,
                    7.5812e-08,
                    7.9234e-08,
                    8.2683e-08,
                    8.6157e-08,
                    8.9653e-08,
                    9.3171e-08,
                    9.671e-08,
                    1.0027e-07,
                    1.0386e-07,
                    1.0766e-07,
                    1.1154e-07,
                    1.1549e-07,
                    1.1953e-07,
                    1.2366e-07,
                    1.2788e-07,
                    1.322e-07,
                    1.3661e-07,
                    1.4114e-07,
                    1.4577e-07,
                    1.5052e-07,
                    1.554e-07,
                    1.6042e-07,
                    1.6561e-07,
                    1.7096e-07,
                    1.7649e-07,
                    1.8219e-07,
                    1.8806e-07,
                    1.9408e-07,
                    2.0025e-07,
                    2.0653e-07,
                    2.1292e-07,
                    2.1941e-07,
                    2.2598e-07,
                    2.3265e-07,
                    2.3939e-07,
                    2.4622e-07,
                    2.5313e-07,
                    2.6012e-07,
                    2.672e-07,
                    2.7437e-07,
                    2.8163e-07,
                    2.8898e-07,
                    2.9642e-07,
                    3.0395e-07,
                    3.1158e-07,
                    3.193e-07,
                    3.2712e-07,
                    3.3505e-07,
                    3.4309e-07,
                    3.5126e-07,
                    3.5957e-07,
                    3.6807e-07,
                    3.7678e-07,
                    3.8572e-07,
                    3.9492e-07,
                    4.044e-07,
                    4.1418e-07,
                    4.2425e-07,
                    4.3464e-07,
                    4.4533e-07,
                    4.564e-07,
                    4.6793e-07,
                    4.8e-07,
                    4.9269e-07,
                    5.0603e-07,
                    5.2005e-07,
                    5.3477e-07,
                    5.5016e-07,
                    5.6621e-07,
                    5.8287e-07,
                    6.0015e-07,
                    6.1812e-07,
                    6.3683e-07,
                    6.5631e-07,
                    6.7656e-07,
                    6.9759e-07,
                    7.1937e-07,
                    7.4185e-07,
                    7.6498e-07,
                    7.8866e-07,
                    8.1284e-07,
                    8.3752e-07,
                    8.6269e-07,
                    8.8836e-07,
                    9.1455e-07,
                    9.4131e-07,
                    9.6868e-07,
                    9.9671e-07,
                    1.0255e-06,
                    1.059e-06,
                    1.0934e-06,
                    1.1285e-06,
                    1.1651e-06,
                    1.2019e-06,
                    1.2391e-06,
                    1.2768e-06,
                    1.3153e-06,
                    1.3554e-06,
                    1.3971e-06,
                    1.4396e-06,
                    1.482e-06,
                    1.5357e-06,
                    1.5913e-06,
                    1.6444e-06,
                    1.7017e-06,
                    1.7633e-06,
                    1.8251e-06,
                    1.8851e-06,
                    1.9523e-06,
                    2.0206e-06,
                    2.091e-06,
                    2.1628e-06,
                    2.237e-06,
                    2.3133e-06,
                    2.3912e-06,
                    2.4781e-06,
                    2.5662e-06,
                    2.6554e-06,
                    2.7451e-06,
                    2.8263e-06,
                    2.9107e-06,
                    2.9991e-06,
                    3.0915e-06,
                    3.1876e-06,
                    3.2874e-06,
                    3.3981e-06,
                    3.5175e-06,
                    3.6416e-06,
                    3.7734e-06,
                    3.9094e-06,
                    4.0502e-06,
                    4.1945e-06,
                    4.3522e-06,
                    4.5191e-06,
                    4.6936e-06,
                    4.8911e-06,
                    5.0927e-06,
                    5.3057e-06,
                    5.521e-06,
                    5.7441e-06,
                    5.9749e-06,
                    6.2072e-06
                ],
                "Land_N2O": 0.08,
                "Land_N2O_timeseries": [
                    1.5971e-08,
                    3.2261e-08,
                    4.8857e-08,
                    6.5739e-08,
                    8.2884e-08,
                    1.0026e-07,
                    1.1784e-07,
                    1.3557e-07,
                    1.5342e-07,
                    1.7133e-07,
                    1.8927e-07,
                    2.0723e-07,
                    2.2521e-07,
                    2.432e-07,
                    2.612e-07,
                    2.7922e-07,
                    2.9724e-07,
                    3.1529e-07,
                    3.3336e-07,
                    3.5146e-07,
                    3.6986e-07,
                    3.8904e-07,
                    4.0933e-07,
                    4.31e-07,
                    4.5417e-07,
                    4.7889e-07,
                    5.0509e-07,
                    5.3257e-07,
                    5.6106e-07,
                    5.9016e-07,
                    6.1961e-07,
                    6.4934e-07,
                    6.7932e-07,
                    7.0951e-07,
                    7.3989e-07,
                    7.7045e-07,
                    8.0118e-07,
                    8.321e-07,
                    8.6323e-07,
                    8.96e-07,
                    9.2908e-07,
                    9.6248e-07,
                    9.9622e-07,
                    1.0303e-06,
                    1.0648e-06,
                    1.0996e-06,
                    1.1349e-06,
                    1.1705e-06,
                    1.2066e-06,
                    1.2431e-06,
                    1.28e-06,
                    1.3173e-06,
                    1.3551e-06,
                    1.3932e-06,
                    1.4317e-06,
                    1.4708e-06,
                    1.5104e-06,
                    1.5505e-06,
                    1.5914e-06,
                    1.633e-06,
                    1.6758e-06,
                    1.7204e-06,
                    1.7671e-06,
                    1.8165e-06,
                    1.8687e-06,
                    1.924e-06,
                    1.9824e-06,
                    2.0439e-06,
                    2.1082e-06,
                    2.1753e-06,
                    2.2452e-06,
                    2.3181e-06,
                    2.3944e-06,
                    2.4739e-06,
                    2.5567e-06,
                    2.6425e-06,
                    2.731e-06,
                    2.8214e-06,
                    2.9133e-06,
                    3.0057e-06,
                    3.0978e-06,
                    3.1889e-06,
                    3.2787e-06,
                    3.3666e-06,
                    3.4527e-06,
                    3.5368e-06,
                    3.6192e-06,
                    3.7001e-06,
                    3.7802e-06,
                    3.8599e-06,
                    3.9478e-06,
                    4.0579e-06,
                    4.2007e-06,
                    4.3832e-06,
                    4.609e-06,
                    4.8781e-06,
                    5.1873e-06,
                    5.5297e-06,
                    5.895e-06,
                    6.2696e-06,
                    6.6413e-06,
                    7.0032e-06,
                    7.35e-06,
                    7.6781e-06,
                    7.986e-06,
                    8.2735e-06,
                    8.5425e-06,
                    8.7964e-06,
                    9.0405e-06,
                    9.2819e-06,
                    9.5446e-06,
                    9.8182e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            0.91216,
                            10.99649
                        ],
                        [
                            0.90017,
                            10.88615
                        ],
                        [
                            0.87359,
                            10.80519
                        ],
                        [
                            0.81008,
                            10.73402
                        ],
                        [
                            0.80742,
                            10.5897
                        ],
                        [
                            0.78313,
                            10.51013
                        ],
                        [
                            0.77512,
                            10.38534
                        ],
                        [
                            1.01622,
                            10.20776
                        ],
                        [
                            1.13701,
                            10.1275
                        ],
                        [
                            1.35357,
                            10.00081
                        ],
                        [
                            1.36571,
                            9.61091
                        ],
                        [
                            1.34261,
                            9.54825
                        ],
                        [
                            1.39101,
                            9.49408
                        ],
                        [
                            1.42003,
                            9.30942
                        ],
                        [
                            1.55917,
                            9.16964
                        ],
                        [
                            1.61638,
                            9.07352
                        ],
                        [
                            1.63302,
                            8.79477
                        ],
                        [
                            1.63114,
                            8.52153
                        ],
                        [
                            1.64834,
                            8.49147
                        ],
                        [
                            1.62013,
                            8.3739
                        ],
                        [
                            1.63346,
                            8.31729
                        ],
                        [
                            1.63618,
                            7.98771
                        ],
                        [
                            1.63138,
                            7.66448
                        ],
                        [
                            1.65259,
                            7.53574
                        ],
                        [
                            1.63649,
                            7.41788
                        ],
                        [
                            1.64177,
                            6.99653
                        ],
                        [
                            1.55809,
                            6.99517
                        ],
                        [
                            1.60551,
                            6.90352
                        ],
                        [
                            1.5992,
                            6.8123
                        ],
                        [
                            1.61894,
                            6.74249
                        ],
                        [
                            1.58949,
                            6.68302
                        ],
                        [
                            1.61734,
                            6.59744
                        ],
                        [
                            1.69729,
                            6.5494
                        ],
                        [
                            1.74971,
                            6.46415
                        ],
                        [
                            1.78855,
                            6.35173
                        ],
                        [
                            1.77151,
                            6.28179
                        ],
                        [
                            1.62874,
                            6.23453
                        ],
                        [
                            1.83717,
                            6.28
                        ],
                        [
                            1.9007,
                            6.31607
                        ],
                        [
                            1.96817,
                            6.30148
                        ],
                        [
                            2.10445,
                            6.32498
                        ],
                        [
                            2.47715,
                            6.36046
                        ],
                        [
                            2.70938,
                            6.37568
                        ],
                        [
                            2.72939,
                            6.53446
                        ],
                        [
                            2.75308,
                            6.57031
                        ],
                        [
                            2.7319,
                            6.62872
                        ],
                        [
                            2.78638,
                            6.69663
                        ],
                        [
                            2.74007,
                            6.76539
                        ],
                        [
                            2.74733,
                            6.92755
                        ],
                        [
                            2.72063,
                            6.98446
                        ],
                        [
                            2.79139,
                            7.04124
                        ],
                        [
                            2.74902,
                            7.10375
                        ],
                        [
                            2.7847,
                            7.16125
                        ],
                        [
                            2.7496,
                            7.26185
                        ],
                        [
                            2.74758,
                            7.41317
                        ],
                        [
                            2.79802,
                            7.42568
                        ],
                        [
                            2.79238,
                            7.49436
                        ],
                        [
                            2.75057,
                            7.5264
                        ],
                        [
                            2.72557,
                            7.64849
                        ],
                        [
                            2.73217,
                            7.77247
                        ],
                        [
                            2.66958,
                            7.88913
                        ],
                        [
                            2.69589,
                            7.93323
                        ],
                        [
                            2.75305,
                            8.21064
                        ],
                        [
                            2.69846,
                            8.30674
                        ],
                        [
                            2.70784,
                            8.42108
                        ],
                        [
                            2.73924,
                            8.44297
                        ],
                        [
                            2.76115,
                            8.52248
                        ],
                        [
                            2.72893,
                            8.773
                        ],
                        [
                            2.7626,
                            8.80913
                        ],
                        [
                            2.78819,
                            8.97025
                        ],
                        [
                            2.78383,
                            9.06508
                        ],
                        [
                            2.87093,
                            9.0629
                        ],
                        [
                            2.95195,
                            9.09236
                        ],
                        [
                            3.00847,
                            9.07416
                        ],
                        [
                            3.08697,
                            9.1009
                        ],
                        [
                            3.15775,
                            9.28756
                        ],
                        [
                            3.1313,
                            9.43807
                        ],
                        [
                            3.19482,
                            9.51557
                        ],
                        [
                            3.28096,
                            9.66164
                        ],
                        [
                            3.34857,
                            9.68612
                        ],
                        [
                            3.33001,
                            9.79869
                        ],
                        [
                            3.35725,
                            9.82576
                        ],
                        [
                            3.47531,
                            9.8629
                        ],
                        [
                            3.53258,
                            9.86435
                        ],
                        [
                            3.59526,
                            9.94562
                        ],
                        [
                            3.61144,
                            10.05986
                        ],
                        [
                            3.66234,
                            10.10697
                        ],
                        [
                            3.6787,
                            10.16981
                        ],
                        [
                            3.58465,
                            10.27607
                        ],
                        [
                            3.6457,
                            10.4346
                        ],
                        [
                            3.68859,
                            10.45571
                        ],
                        [
                            3.78606,
                            10.4068
                        ],
                        [
                            3.8012,
                            10.48509
                        ],
                        [
                            3.85153,
                            10.60552
                        ],
                        [
                            3.84089,
                            10.70417
                        ],
                        [
                            3.79631,
                            10.73686
                        ],
                        [
                            3.74989,
                            10.82441
                        ],
                        [
                            3.77109,
                            10.93057
                        ],
                        [
                            3.75724,
                            11.00077
                        ],
                        [
                            3.71715,
                            11.02604
                        ],
                        [
                            3.72695,
                            11.11622
                        ],
                        [
                            3.69048,
                            11.13036
                        ],
                        [
                            3.47198,
                            11.44811
                        ],
                        [
                            3.55742,
                            11.6306
                        ],
                        [
                            3.60507,
                            11.69697
                        ],
                        [
                            3.55534,
                            11.72598
                        ],
                        [
                            3.558,
                            11.77866
                        ],
                        [
                            3.48194,
                            11.86072
                        ],
                        [
                            3.38302,
                            11.88626
                        ],
                        [
                            3.31892,
                            11.88408
                        ],
                        [
                            3.26892,
                            12.01043
                        ],
                        [
                            3.12528,
                            12.15687
                        ],
                        [
                            3.0823,
                            12.17695
                        ],
                        [
                            3.01251,
                            12.26711
                        ],
                        [
                            2.96335,
                            12.28777
                        ],
                        [
                            2.8707,
                            12.38883
                        ],
                        [
                            2.8089,
                            12.39658
                        ],
                        [
                            2.66751,
                            12.30563
                        ],
                        [
                            2.46322,
                            12.25357
                        ],
                        [
                            2.38305,
                            12.25083
                        ],
                        [
                            2.39169,
                            12.1139
                        ],
                        [
                            2.46503,
                            11.98188
                        ],
                        [
                            2.39289,
                            11.92895
                        ],
                        [
                            2.40508,
                            11.89978
                        ],
                        [
                            2.3717,
                            11.79398
                        ],
                        [
                            2.2996,
                            11.7185
                        ],
                        [
                            2.30689,
                            11.67609
                        ],
                        [
                            2.18487,
                            11.59642
                        ],
                        [
                            2.01831,
                            11.42741
                        ],
                        [
                            1.95582,
                            11.42087
                        ],
                        [
                            1.87229,
                            11.44532
                        ],
                        [
                            1.77296,
                            11.41992
                        ],
                        [
                            1.7159,
                            11.42903
                        ],
                        [
                            1.66325,
                            11.39679
                        ],
                        [
                            1.59223,
                            11.39957
                        ],
                        [
                            1.57923,
                            11.44167
                        ],
                        [
                            1.44174,
                            11.4726
                        ],
                        [
                            1.38485,
                            11.44174
                        ],
                        [
                            1.3888,
                            11.40066
                        ],
                        [
                            1.26059,
                            11.32086
                        ],
                        [
                            1.22605,
                            11.25956
                        ],
                        [
                            1.15579,
                            11.22379
                        ],
                        [
                            1.0852,
                            11.11488
                        ],
                        [
                            1.10093,
                            11.05549
                        ],
                        [
                            1.04355,
                            11.04953
                        ],
                        [
                            1.01225,
                            11.08374
                        ],
                        [
                            0.91216,
                            10.99649
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "BMU",
                "Country": "Bermuda",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.98e-08,
                    4.62e-08,
                    9.405e-08,
                    1.353e-07,
                    1.7325e-07,
                    2.2275e-07,
                    2.838e-07,
                    3.465e-07,
                    4.125e-07,
                    4.7355e-07,
                    5.445e-07,
                    6.237e-07,
                    6.9465e-07,
                    7.623e-07,
                    8.5305e-07,
                    9.339e-07,
                    1.0247e-06,
                    1.1203e-06,
                    1.221e-06,
                    1.3101e-06,
                    1.4124e-06,
                    1.5164e-06,
                    1.6302e-06,
                    1.8216e-06,
                    2.0212e-06,
                    2.2275e-06,
                    2.4387e-06,
                    2.6433e-06,
                    2.8347e-06,
                    3.0426e-06,
                    3.239e-06,
                    3.4138e-06,
                    3.5921e-06,
                    3.795e-06,
                    3.9946e-06,
                    4.1976e-06,
                    4.3873e-06,
                    4.6447e-06,
                    4.9351e-06,
                    5.2866e-06,
                    5.5126e-06,
                    5.7552e-06,
                    5.9631e-06,
                    6.2056e-06,
                    6.4449e-06,
                    6.6842e-06,
                    6.9218e-06,
                    7.1577e-06,
                    7.392e-06,
                    7.623e-06,
                    7.8556e-06,
                    8.0933e-06,
                    8.3441e-06,
                    8.5965e-06,
                    8.8589e-06,
                    9.1212e-06,
                    9.4149e-06,
                    9.7433e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.98e-08,
                    4.62e-08,
                    9.405e-08,
                    1.353e-07,
                    1.7325e-07,
                    2.2275e-07,
                    2.838e-07,
                    3.465e-07,
                    4.125e-07,
                    4.7355e-07,
                    5.445e-07,
                    6.237e-07,
                    6.9465e-07,
                    7.623e-07,
                    8.5305e-07,
                    9.339e-07,
                    1.0247e-06,
                    1.1203e-06,
                    1.221e-06,
                    1.3101e-06,
                    1.4124e-06,
                    1.5164e-06,
                    1.6302e-06,
                    1.8216e-06,
                    2.0212e-06,
                    2.2275e-06,
                    2.4387e-06,
                    2.6433e-06,
                    2.8347e-06,
                    3.0426e-06,
                    3.239e-06,
                    3.4138e-06,
                    3.5921e-06,
                    3.795e-06,
                    3.9946e-06,
                    4.1976e-06,
                    4.3873e-06,
                    4.6447e-06,
                    4.9351e-06,
                    5.2866e-06,
                    5.5126e-06,
                    5.7552e-06,
                    5.9631e-06,
                    6.2056e-06,
                    6.4449e-06,
                    6.6842e-06,
                    6.9218e-06,
                    7.1577e-06,
                    7.392e-06,
                    7.623e-06,
                    7.8556e-06,
                    8.0933e-06,
                    8.3441e-06,
                    8.5965e-06,
                    8.8589e-06,
                    9.1212e-06,
                    9.4149e-06,
                    9.7433e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.98e-08,
                    4.62e-08,
                    9.405e-08,
                    1.353e-07,
                    1.7325e-07,
                    2.2275e-07,
                    2.838e-07,
                    3.465e-07,
                    4.125e-07,
                    4.7355e-07,
                    5.445e-07,
                    6.237e-07,
                    6.9465e-07,
                    7.623e-07,
                    8.5305e-07,
                    9.339e-07,
                    1.0247e-06,
                    1.1203e-06,
                    1.221e-06,
                    1.3101e-06,
                    1.4124e-06,
                    1.5164e-06,
                    1.6302e-06,
                    1.8216e-06,
                    2.0212e-06,
                    2.2275e-06,
                    2.4387e-06,
                    2.6433e-06,
                    2.8347e-06,
                    3.0426e-06,
                    3.239e-06,
                    3.4138e-06,
                    3.5921e-06,
                    3.795e-06,
                    3.9946e-06,
                    4.1976e-06,
                    4.3873e-06,
                    4.6447e-06,
                    4.9351e-06,
                    5.2866e-06,
                    5.5126e-06,
                    5.7552e-06,
                    5.9631e-06,
                    6.2056e-06,
                    6.4449e-06,
                    6.6842e-06,
                    6.9218e-06,
                    7.1577e-06,
                    7.392e-06,
                    7.623e-06,
                    7.8556e-06,
                    8.0933e-06,
                    8.3441e-06,
                    8.5965e-06,
                    8.8589e-06,
                    9.1212e-06,
                    9.4149e-06,
                    9.7433e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.98e-08,
                    4.62e-08,
                    9.405e-08,
                    1.353e-07,
                    1.7325e-07,
                    2.2275e-07,
                    2.838e-07,
                    3.465e-07,
                    4.125e-07,
                    4.7355e-07,
                    5.445e-07,
                    6.237e-07,
                    6.9465e-07,
                    7.623e-07,
                    8.5305e-07,
                    9.339e-07,
                    1.0247e-06,
                    1.1203e-06,
                    1.221e-06,
                    1.3101e-06,
                    1.4124e-06,
                    1.5164e-06,
                    1.6302e-06,
                    1.8216e-06,
                    2.0212e-06,
                    2.2275e-06,
                    2.4387e-06,
                    2.6433e-06,
                    2.8347e-06,
                    3.0426e-06,
                    3.239e-06,
                    3.4138e-06,
                    3.5921e-06,
                    3.795e-06,
                    3.9946e-06,
                    4.1976e-06,
                    4.3873e-06,
                    4.6447e-06,
                    4.9351e-06,
                    5.2866e-06,
                    5.5126e-06,
                    5.7552e-06,
                    5.9631e-06,
                    6.2056e-06,
                    6.4449e-06,
                    6.6842e-06,
                    6.9218e-06,
                    7.1577e-06,
                    7.392e-06,
                    7.623e-06,
                    7.8556e-06,
                    8.0933e-06,
                    8.3441e-06,
                    8.5965e-06,
                    8.8589e-06,
                    9.1212e-06,
                    9.4149e-06,
                    9.7433e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": []
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -64.89612,
                            32.2834
                        ],
                        [
                            -64.87696,
                            32.24843
                        ],
                        [
                            -64.79046,
                            32.26642
                        ],
                        [
                            -64.79475,
                            32.28425
                        ],
                        [
                            -64.86587,
                            32.2578
                        ],
                        [
                            -64.89612,
                            32.2834
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "BTN",
                "Country": "Bhutan",
                "Total_3GHG": 0.02,
                "Total_3GHG_timeseries": [
                    7.1755e-07,
                    1.1836e-06,
                    1.6657e-06,
                    2.1794e-06,
                    2.6217e-06,
                    2.8751e-06,
                    2.9383e-06,
                    3.3518e-06,
                    3.794e-06,
                    4.3116e-06,
                    4.8866e-06,
                    5.5043e-06,
                    6.0746e-06,
                    6.9591e-06,
                    7.8425e-06,
                    8.7836e-06,
                    9.7437e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    8.242e-08,
                    1.6555e-07,
                    2.4938e-07,
                    3.3392e-07,
                    4.1917e-07,
                    5.0513e-07,
                    5.9178e-07,
                    6.7915e-07,
                    7.6721e-07,
                    8.5598e-07,
                    9.4655e-07,
                    1.0389e-06,
                    1.1331e-06,
                    1.229e-06,
                    1.3267e-06,
                    1.4263e-06,
                    1.5276e-06,
                    1.6307e-06,
                    1.7356e-06,
                    1.8423e-06,
                    1.9511e-06,
                    2.0619e-06,
                    2.1748e-06,
                    2.2898e-06,
                    2.4069e-06,
                    2.5261e-06,
                    2.6473e-06,
                    2.7706e-06,
                    2.896e-06,
                    3.0235e-06,
                    3.1523e-06,
                    3.2826e-06,
                    3.4142e-06,
                    3.5473e-06,
                    3.6817e-06,
                    3.8176e-06,
                    3.9548e-06,
                    4.0935e-06,
                    4.2335e-06,
                    4.375e-06,
                    4.5181e-06,
                    4.6628e-06,
                    4.8154e-06,
                    4.992e-06,
                    5.1946e-06,
                    5.4251e-06,
                    5.6858e-06,
                    5.979e-06,
                    6.3072e-06,
                    6.6731e-06,
                    7.0384e-06,
                    7.4033e-06,
                    7.7679e-06,
                    8.1326e-06,
                    8.4975e-06,
                    8.8629e-06,
                    9.2291e-06,
                    9.5961e-06,
                    9.9644e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    9.9853e-06,
                    9.4341e-06,
                    8.8667e-06,
                    8.3303e-06,
                    7.8385e-06,
                    7.3921e-06,
                    6.9908e-06,
                    6.6343e-06,
                    6.3159e-06,
                    6.0408e-06,
                    5.8085e-06,
                    5.6311e-06,
                    5.5041e-06,
                    5.4191e-06,
                    5.3855e-06,
                    5.3937e-06,
                    5.4518e-06,
                    5.5507e-06,
                    5.705e-06,
                    5.8934e-06,
                    6.1354e-06,
                    6.4218e-06,
                    6.7205e-06,
                    7.0419e-06,
                    7.367e-06,
                    7.7078e-06,
                    8.0564e-06,
                    8.4292e-06,
                    9.0667e-06,
                    9.8299e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_3GHG": 0.05,
                "Land_3GHG_timeseries": [
                    6.3513e-07,
                    1.0181e-06,
                    1.4163e-06,
                    1.8455e-06,
                    2.2026e-06,
                    2.3699e-06,
                    2.3465e-06,
                    2.6726e-06,
                    3.0268e-06,
                    3.4556e-06,
                    3.94e-06,
                    4.4654e-06,
                    4.9415e-06,
                    5.7301e-06,
                    6.5158e-06,
                    7.3573e-06,
                    8.2161e-06,
                    8.8237e-06,
                    9.2631e-06,
                    9.7582e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Total_CO2": 0.03,
                "Total_CO2_timeseries": [
                    5.2837e-07,
                    8.0356e-07,
                    1.093e-06,
                    1.4124e-06,
                    1.6587e-06,
                    1.7144e-06,
                    1.5783e-06,
                    1.7908e-06,
                    2.0305e-06,
                    2.3439e-06,
                    2.7107e-06,
                    3.1163e-06,
                    3.4705e-06,
                    4.135e-06,
                    4.7943e-06,
                    5.5074e-06,
                    6.2356e-06,
                    6.7103e-06,
                    7.0147e-06,
                    7.3726e-06,
                    7.7276e-06,
                    8.2394e-06,
                    8.7539e-06,
                    8.7901e-06,
                    9.1862e-06,
                    9.7724e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.65e-09,
                    3.3e-09,
                    4.95e-09,
                    6.6e-09,
                    8.25e-09,
                    9.9e-09,
                    1.155e-08,
                    1.485e-08,
                    1.98e-08,
                    2.97e-08,
                    3.96e-08,
                    6.4525e-08,
                    9.2752e-08,
                    1.3182e-07,
                    1.8079e-07,
                    2.3471e-07,
                    2.8533e-07,
                    3.5741e-07,
                    4.328e-07,
                    4.8673e-07,
                    5.7037e-07,
                    6.5401e-07,
                    7.5086e-07,
                    8.3272e-07,
                    9.2838e-07,
                    1.0405e-06,
                    1.1748e-06,
                    1.3505e-06,
                    1.5226e-06,
                    1.6964e-06,
                    1.8751e-06,
                    2.0481e-06,
                    2.2357e-06,
                    2.4051e-06,
                    2.5438e-06,
                    2.722e-06,
                    2.8992e-06,
                    3.0765e-06,
                    3.2666e-06,
                    3.4421e-06,
                    3.6618e-06,
                    3.9914e-06,
                    4.3676e-06,
                    4.781e-06,
                    5.2441e-06,
                    5.7199e-06,
                    6.2879e-06,
                    6.892e-06,
                    7.5575e-06,
                    8.2143e-06,
                    8.6285e-06,
                    9.1069e-06,
                    9.5822e-06
                ],
                "Land_CO2": 0.08,
                "Land_CO2_timeseries": [
                    5.2837e-07,
                    8.0356e-07,
                    1.093e-06,
                    1.4124e-06,
                    1.6587e-06,
                    1.7144e-06,
                    1.5783e-06,
                    1.7908e-06,
                    2.0305e-06,
                    2.3439e-06,
                    2.7107e-06,
                    3.1163e-06,
                    3.4705e-06,
                    4.135e-06,
                    4.7943e-06,
                    5.5074e-06,
                    6.2356e-06,
                    6.7103e-06,
                    7.0147e-06,
                    7.3726e-06,
                    7.7276e-06,
                    8.2394e-06,
                    8.7539e-06,
                    8.7901e-06,
                    9.1862e-06,
                    9.7724e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Total_CH4": 0.01,
                "Total_CH4_timeseries": [
                    1.8041e-07,
                    3.6237e-07,
                    5.4588e-07,
                    7.3094e-07,
                    9.1754e-07,
                    1.1057e-06,
                    1.2954e-06,
                    1.4866e-06,
                    1.6794e-06,
                    1.8738e-06,
                    2.0721e-06,
                    2.2744e-06,
                    2.4806e-06,
                    2.6908e-06,
                    2.9049e-06,
                    3.123e-06,
                    3.3451e-06,
                    3.5711e-06,
                    3.801e-06,
                    4.035e-06,
                    4.2734e-06,
                    4.5165e-06,
                    4.7641e-06,
                    5.0162e-06,
                    5.2729e-06,
                    5.5341e-06,
                    5.7999e-06,
                    6.0703e-06,
                    6.3452e-06,
                    6.6246e-06,
                    6.9072e-06,
                    7.1928e-06,
                    7.4816e-06,
                    7.7734e-06,
                    8.0683e-06,
                    8.3663e-06,
                    8.6674e-06,
                    8.9716e-06,
                    9.2788e-06,
                    9.5892e-06,
                    9.903e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_CH4": 0.01,
                "Fossil_CH4_timeseries": [
                    8.1615e-08,
                    1.6393e-07,
                    2.4694e-07,
                    3.3064e-07,
                    4.1505e-07,
                    5.0014e-07,
                    5.8594e-07,
                    6.7243e-07,
                    7.5962e-07,
                    8.4751e-07,
                    9.3718e-07,
                    1.0286e-06,
                    1.1219e-06,
                    1.2169e-06,
                    1.3138e-06,
                    1.4124e-06,
                    1.5128e-06,
                    1.6149e-06,
                    1.7189e-06,
                    1.8247e-06,
                    1.9325e-06,
                    2.0423e-06,
                    2.1543e-06,
                    2.2682e-06,
                    2.3843e-06,
                    2.5024e-06,
                    2.6225e-06,
                    2.7447e-06,
                    2.8689e-06,
                    2.9952e-06,
                    3.1229e-06,
                    3.252e-06,
                    3.3825e-06,
                    3.5143e-06,
                    3.6476e-06,
                    3.7822e-06,
                    3.9183e-06,
                    4.0557e-06,
                    4.1945e-06,
                    4.3347e-06,
                    4.4764e-06,
                    4.6197e-06,
                    4.771e-06,
                    4.9462e-06,
                    5.1473e-06,
                    5.3764e-06,
                    5.6355e-06,
                    5.9272e-06,
                    6.2538e-06,
                    6.6181e-06,
                    6.9818e-06,
                    7.3449e-06,
                    7.7079e-06,
                    8.0708e-06,
                    8.4339e-06,
                    8.7974e-06,
                    9.1616e-06,
                    9.5267e-06,
                    9.8929e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    9.7222e-06,
                    9.165e-06,
                    8.5915e-06,
                    8.0459e-06,
                    7.545e-06,
                    7.0894e-06,
                    6.6787e-06,
                    6.3127e-06,
                    5.9846e-06,
                    5.6996e-06,
                    5.4556e-06,
                    5.2642e-06,
                    5.1177e-06,
                    5.0128e-06,
                    4.9441e-06,
                    4.9123e-06,
                    4.9184e-06,
                    4.9566e-06,
                    5.0444e-06,
                    5.1692e-06,
                    5.3263e-06,
                    5.5234e-06,
                    5.7529e-06,
                    5.9764e-06,
                    6.2034e-06,
                    6.4329e-06,
                    6.685e-06,
                    6.9473e-06,
                    7.4485e-06,
                    8.0493e-06,
                    8.6341e-06,
                    9.2123e-06,
                    9.8217e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CH4": 0.01,
                "Land_CH4_timeseries": [
                    9.8796e-08,
                    1.9844e-07,
                    2.9894e-07,
                    4.0029e-07,
                    5.025e-07,
                    6.0555e-07,
                    7.0945e-07,
                    8.1421e-07,
                    9.1982e-07,
                    1.0263e-06,
                    1.1349e-06,
                    1.2457e-06,
                    1.3587e-06,
                    1.4738e-06,
                    1.5912e-06,
                    1.7106e-06,
                    1.8323e-06,
                    1.9561e-06,
                    2.0821e-06,
                    2.2103e-06,
                    2.341e-06,
                    2.4741e-06,
                    2.6098e-06,
                    2.748e-06,
                    2.8886e-06,
                    3.0318e-06,
                    3.1774e-06,
                    3.3256e-06,
                    3.4763e-06,
                    3.6294e-06,
                    3.7843e-06,
                    3.9408e-06,
                    4.0991e-06,
                    4.259e-06,
                    4.4207e-06,
                    4.5841e-06,
                    4.7491e-06,
                    4.9159e-06,
                    5.0844e-06,
                    5.2545e-06,
                    5.4266e-06,
                    5.6005e-06,
                    5.7764e-06,
                    5.9541e-06,
                    6.1337e-06,
                    6.3153e-06,
                    6.4987e-06,
                    6.684e-06,
                    6.8711e-06,
                    7.0602e-06,
                    7.2239e-06,
                    7.3622e-06,
                    7.4752e-06,
                    7.5627e-06,
                    7.6249e-06,
                    7.6617e-06,
                    7.6731e-06,
                    7.6591e-06,
                    7.6197e-06,
                    7.5549e-06,
                    7.4728e-06,
                    7.3733e-06,
                    7.2564e-06,
                    7.1221e-06,
                    6.9704e-06,
                    6.8013e-06,
                    6.6148e-06,
                    6.411e-06,
                    6.1897e-06,
                    5.9511e-06,
                    5.7235e-06,
                    5.5069e-06,
                    5.3015e-06,
                    5.107e-06,
                    4.9237e-06,
                    4.7513e-06,
                    4.59e-06,
                    4.4398e-06,
                    4.3006e-06,
                    4.1725e-06,
                    4.0514e-06,
                    3.9374e-06,
                    3.8305e-06,
                    3.7306e-06,
                    3.6377e-06,
                    3.5529e-06,
                    3.476e-06,
                    3.4071e-06,
                    3.3462e-06,
                    3.2932e-06,
                    3.2499e-06,
                    3.2165e-06,
                    3.1928e-06,
                    3.1789e-06,
                    3.1748e-06,
                    3.1806e-06,
                    3.1962e-06,
                    3.2216e-06,
                    3.2569e-06,
                    3.302e-06,
                    3.3623e-06,
                    3.4378e-06,
                    3.5284e-06,
                    3.6341e-06,
                    3.7552e-06,
                    3.8906e-06,
                    4.0407e-06,
                    4.2057e-06,
                    4.3858e-06,
                    4.5816e-06,
                    4.7837e-06,
                    4.9988e-06,
                    5.2251e-06,
                    5.4646e-06,
                    5.7168e-06,
                    5.9795e-06,
                    6.2547e-06,
                    6.5425e-06,
                    6.8431e-06,
                    7.1578e-06,
                    7.4777e-06,
                    7.8032e-06,
                    8.1323e-06,
                    8.4662e-06,
                    8.8078e-06,
                    9.1598e-06,
                    9.5182e-06,
                    9.8851e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_N2O": 0.01,
                "Total_N2O_timeseries": [
                    8.7702e-09,
                    1.771e-08,
                    2.6812e-08,
                    3.6067e-08,
                    4.5462e-08,
                    5.4983e-08,
                    6.4611e-08,
                    7.4325e-08,
                    8.4104e-08,
                    9.392e-08,
                    1.0376e-07,
                    1.1361e-07,
                    1.2348e-07,
                    1.3336e-07,
                    1.4325e-07,
                    1.5316e-07,
                    1.6307e-07,
                    1.7301e-07,
                    1.8296e-07,
                    1.9293e-07,
                    2.0306e-07,
                    2.1359e-07,
                    2.2471e-07,
                    2.3653e-07,
                    2.4913e-07,
                    2.6253e-07,
                    2.767e-07,
                    2.9153e-07,
                    3.0688e-07,
                    3.2255e-07,
                    3.384e-07,
                    3.5441e-07,
                    3.7055e-07,
                    3.868e-07,
                    4.0315e-07,
                    4.196e-07,
                    4.3615e-07,
                    4.528e-07,
                    4.6956e-07,
                    4.8701e-07,
                    5.0451e-07,
                    5.2207e-07,
                    5.3969e-07,
                    5.5738e-07,
                    5.7514e-07,
                    5.9297e-07,
                    6.1088e-07,
                    6.2886e-07,
                    6.4691e-07,
                    6.6505e-07,
                    6.8327e-07,
                    7.0159e-07,
                    7.2001e-07,
                    7.3853e-07,
                    7.5717e-07,
                    7.7591e-07,
                    7.9476e-07,
                    8.137e-07,
                    8.3272e-07,
                    8.5182e-07,
                    8.7098e-07,
                    8.902e-07,
                    9.0947e-07,
                    9.2878e-07,
                    9.4814e-07,
                    9.6755e-07,
                    9.87e-07,
                    1.0065e-06,
                    1.026e-06,
                    1.0456e-06,
                    1.0653e-06,
                    1.085e-06,
                    1.1049e-06,
                    1.1247e-06,
                    1.1447e-06,
                    1.1648e-06,
                    1.1849e-06,
                    1.2051e-06,
                    1.2254e-06,
                    1.2457e-06,
                    1.2661e-06,
                    1.2865e-06,
                    1.307e-06,
                    1.3276e-06,
                    1.3482e-06,
                    1.3689e-06,
                    1.3896e-06,
                    1.4105e-06,
                    1.4314e-06,
                    1.4523e-06,
                    1.4734e-06,
                    1.4947e-06,
                    1.5163e-06,
                    1.5382e-06,
                    1.5604e-06,
                    1.5829e-06,
                    1.6058e-06,
                    1.6291e-06,
                    1.6526e-06,
                    1.6763e-06,
                    1.7003e-06,
                    1.7245e-06,
                    1.749e-06,
                    1.7739e-06,
                    1.7991e-06,
                    1.8247e-06,
                    1.8506e-06,
                    1.8769e-06,
                    1.9035e-06,
                    1.9304e-06,
                    1.9581e-06,
                    1.9866e-06,
                    2.0156e-06,
                    2.0453e-06,
                    2.0757e-06,
                    2.1066e-06,
                    2.1382e-06,
                    2.1706e-06,
                    2.2037e-06,
                    2.239e-06,
                    2.2748e-06,
                    2.3113e-06,
                    2.3484e-06,
                    2.3866e-06,
                    2.4256e-06,
                    2.4658e-06,
                    2.5069e-06,
                    2.5494e-06,
                    2.5929e-06,
                    2.6375e-06,
                    2.6837e-06,
                    2.7327e-06,
                    2.7842e-06,
                    2.8362e-06,
                    2.8903e-06,
                    2.9452e-06,
                    3.002e-06,
                    3.0577e-06,
                    3.1154e-06,
                    3.1747e-06,
                    3.2305e-06,
                    3.283e-06,
                    3.3357e-06,
                    3.3888e-06,
                    3.4543e-06,
                    3.5225e-06,
                    3.5908e-06,
                    3.659e-06,
                    3.7291e-06,
                    3.7976e-06,
                    3.8632e-06,
                    3.9304e-06,
                    3.9985e-06,
                    4.0676e-06,
                    4.1409e-06,
                    4.2146e-06,
                    4.289e-06,
                    4.3666e-06,
                    4.442e-06,
                    4.517e-06,
                    4.5948e-06,
                    4.6729e-06,
                    4.7536e-06,
                    4.8364e-06,
                    4.9204e-06,
                    5.0054e-06,
                    5.0922e-06,
                    5.1806e-06,
                    5.27e-06,
                    5.3569e-06,
                    5.4439e-06,
                    5.5309e-06
                ],
                "Fossil_N2O": 0.01,
                "Fossil_N2O_timeseries": [
                    8.0533e-10,
                    1.6209e-09,
                    2.4465e-09,
                    3.282e-09,
                    4.1269e-09,
                    4.9808e-09,
                    5.8432e-09,
                    6.7136e-09,
                    7.5914e-09,
                    8.4757e-09,
                    9.3663e-09,
                    1.0263e-08,
                    1.1165e-08,
                    1.2074e-08,
                    1.2988e-08,
                    1.3909e-08,
                    1.4835e-08,
                    1.5767e-08,
                    1.6705e-08,
                    1.765e-08,
                    1.8604e-08,
                    1.9575e-08,
                    2.0568e-08,
                    2.1586e-08,
                    2.2631e-08,
                    2.3703e-08,
                    2.4802e-08,
                    2.5925e-08,
                    2.7068e-08,
                    2.8225e-08,
                    2.9393e-08,
                    3.0571e-08,
                    3.1758e-08,
                    3.2953e-08,
                    3.4157e-08,
                    3.537e-08,
                    3.659e-08,
                    3.7819e-08,
                    3.9057e-08,
                    4.0365e-08,
                    4.1697e-08,
                    4.3055e-08,
                    4.4439e-08,
                    4.5851e-08,
                    4.7293e-08,
                    4.8766e-08,
                    5.0271e-08,
                    5.1808e-08,
                    5.338e-08,
                    5.4987e-08,
                    5.6631e-08,
                    5.8318e-08,
                    6.0052e-08,
                    6.1834e-08,
                    6.3666e-08,
                    6.5546e-08,
                    6.7474e-08,
                    6.9445e-08,
                    7.1456e-08,
                    7.3501e-08,
                    7.5576e-08,
                    7.7678e-08,
                    7.9806e-08,
                    8.1959e-08,
                    8.4135e-08,
                    8.6335e-08,
                    8.8556e-08,
                    9.0799e-08,
                    9.3064e-08,
                    9.535e-08,
                    9.7656e-08,
                    9.9981e-08,
                    1.0232e-07,
                    1.0468e-07,
                    1.0706e-07,
                    1.0946e-07,
                    1.1187e-07,
                    1.1431e-07,
                    1.1676e-07,
                    1.1924e-07,
                    1.2176e-07,
                    1.2431e-07,
                    1.2692e-07,
                    1.2957e-07,
                    1.3229e-07,
                    1.3506e-07,
                    1.379e-07,
                    1.4079e-07,
                    1.4374e-07,
                    1.4674e-07,
                    1.498e-07,
                    1.5289e-07,
                    1.5603e-07,
                    1.5922e-07,
                    1.6244e-07,
                    1.6572e-07,
                    1.6904e-07,
                    1.7242e-07,
                    1.7586e-07,
                    1.7937e-07,
                    1.8298e-07,
                    1.8674e-07,
                    1.9066e-07,
                    1.9479e-07,
                    1.9913e-07,
                    2.0369e-07,
                    2.0846e-07,
                    2.1343e-07,
                    2.1859e-07,
                    2.2389e-07,
                    2.293e-07,
                    2.3479e-07,
                    2.4033e-07,
                    2.4593e-07,
                    2.5158e-07,
                    2.573e-07,
                    2.6311e-07,
                    2.6905e-07,
                    2.7516e-07,
                    2.8271e-07,
                    2.9022e-07,
                    2.978e-07,
                    3.0551e-07,
                    3.1345e-07,
                    3.214e-07,
                    3.2959e-07,
                    3.3804e-07,
                    3.4715e-07,
                    3.5671e-07,
                    3.6664e-07,
                    3.7688e-07,
                    3.8868e-07,
                    4.0156e-07,
                    4.1324e-07,
                    4.2592e-07,
                    4.3887e-07,
                    4.5173e-07,
                    4.656e-07,
                    4.8082e-07,
                    4.9509e-07,
                    5.0951e-07,
                    5.2403e-07,
                    5.3864e-07,
                    5.5346e-07,
                    5.7768e-07,
                    6.058e-07,
                    6.3443e-07,
                    6.6384e-07,
                    6.9412e-07,
                    7.2753e-07,
                    7.6132e-07,
                    7.9628e-07,
                    8.3175e-07,
                    8.6764e-07,
                    9.0433e-07,
                    9.4136e-07,
                    9.7845e-07,
                    1.0161e-06,
                    1.0542e-06,
                    1.0936e-06,
                    1.1341e-06,
                    1.1755e-06,
                    1.2188e-06,
                    1.2629e-06,
                    1.3079e-06,
                    1.3523e-06,
                    1.3972e-06,
                    1.4423e-06,
                    1.49e-06,
                    1.5365e-06,
                    1.5834e-06,
                    1.6307e-06
                ],
                "Land_N2O": 0.01,
                "Land_N2O_timeseries": [
                    7.9649e-09,
                    1.6089e-08,
                    2.4366e-08,
                    3.2785e-08,
                    4.1336e-08,
                    5.0002e-08,
                    5.8768e-08,
                    6.7612e-08,
                    7.6512e-08,
                    8.5444e-08,
                    9.4391e-08,
                    1.0335e-07,
                    1.1232e-07,
                    1.2129e-07,
                    1.3027e-07,
                    1.3925e-07,
                    1.4824e-07,
                    1.5724e-07,
                    1.6625e-07,
                    1.7528e-07,
                    1.8446e-07,
                    1.9402e-07,
                    2.0414e-07,
                    2.1494e-07,
                    2.265e-07,
                    2.3883e-07,
                    2.5189e-07,
                    2.656e-07,
                    2.7981e-07,
                    2.9432e-07,
                    3.0901e-07,
                    3.2384e-07,
                    3.3879e-07,
                    3.5384e-07,
                    3.6899e-07,
                    3.8423e-07,
                    3.9956e-07,
                    4.1498e-07,
                    4.3051e-07,
                    4.4664e-07,
                    4.6281e-07,
                    4.7901e-07,
                    4.9526e-07,
                    5.1153e-07,
                    5.2785e-07,
                    5.4421e-07,
                    5.6061e-07,
                    5.7705e-07,
                    5.9353e-07,
                    6.1006e-07,
                    6.2664e-07,
                    6.4327e-07,
                    6.5995e-07,
                    6.767e-07,
                    6.935e-07,
                    7.1036e-07,
                    7.2728e-07,
                    7.4425e-07,
                    7.6127e-07,
                    7.7832e-07,
                    7.9541e-07,
                    8.1252e-07,
                    8.2966e-07,
                    8.4682e-07,
                    8.6401e-07,
                    8.8121e-07,
                    8.9844e-07,
                    9.157e-07,
                    9.3298e-07,
                    9.503e-07,
                    9.6766e-07,
                    9.8507e-07,
                    1.0025e-06,
                    1.0201e-06,
                    1.0377e-06,
                    1.0553e-06,
                    1.073e-06,
                    1.0908e-06,
                    1.1086e-06,
                    1.1265e-06,
                    1.1443e-06,
                    1.1622e-06,
                    1.1801e-06,
                    1.198e-06,
                    1.2159e-06,
                    1.2338e-06,
                    1.2517e-06,
                    1.2697e-06,
                    1.2876e-06,
                    1.3056e-06,
                    1.3236e-06,
                    1.3418e-06,
                    1.3603e-06,
                    1.3789e-06,
                    1.3979e-06,
                    1.4172e-06,
                    1.4368e-06,
                    1.4567e-06,
                    1.4767e-06,
                    1.497e-06,
                    1.5173e-06,
                    1.5378e-06,
                    1.5584e-06,
                    1.5791e-06,
                    1.6e-06,
                    1.621e-06,
                    1.6422e-06,
                    1.6635e-06,
                    1.6849e-06,
                    1.7065e-06,
                    1.7288e-06,
                    1.7518e-06,
                    1.7753e-06,
                    1.7994e-06,
                    1.8241e-06,
                    1.8493e-06,
                    1.8751e-06,
                    1.9016e-06,
                    1.9286e-06,
                    1.9562e-06,
                    1.9845e-06,
                    2.0135e-06,
                    2.0429e-06,
                    2.0732e-06,
                    2.1042e-06,
                    2.1362e-06,
                    2.1688e-06,
                    2.2022e-06,
                    2.2362e-06,
                    2.2708e-06,
                    2.3068e-06,
                    2.344e-06,
                    2.3827e-06,
                    2.4229e-06,
                    2.4644e-06,
                    2.5064e-06,
                    2.5502e-06,
                    2.5921e-06,
                    2.6345e-06,
                    2.6796e-06,
                    2.721e-06,
                    2.759e-06,
                    2.7971e-06,
                    2.8353e-06,
                    2.8766e-06,
                    2.9167e-06,
                    2.9563e-06,
                    2.9952e-06,
                    3.035e-06,
                    3.0701e-06,
                    3.1019e-06,
                    3.1341e-06,
                    3.1668e-06,
                    3.2e-06,
                    3.2366e-06,
                    3.2732e-06,
                    3.3106e-06,
                    3.3505e-06,
                    3.3878e-06,
                    3.4234e-06,
                    3.4607e-06,
                    3.4975e-06,
                    3.5347e-06,
                    3.5736e-06,
                    3.6125e-06,
                    3.6532e-06,
                    3.6951e-06,
                    3.7383e-06,
                    3.78e-06,
                    3.8205e-06,
                    3.8605e-06,
                    3.9002e-06
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            91.64209,
                            27.75846
                        ],
                        [
                            91.61045,
                            27.89439
                        ],
                        [
                            91.48548,
                            27.94254
                        ],
                        [
                            91.46242,
                            28.00566
                        ],
                        [
                            91.31026,
                            28.06138
                        ],
                        [
                            91.25302,
                            27.97631
                        ],
                        [
                            91.1639,
                            27.97058
                        ],
                        [
                            91.14824,
                            27.89271
                        ],
                        [
                            91.11143,
                            27.85284
                        ],
                        [
                            91.03525,
                            27.85792
                        ],
                        [
                            90.96376,
                            27.9054
                        ],
                        [
                            90.96197,
                            27.95472
                        ],
                        [
                            90.84608,
                            27.97328
                        ],
                        [
                            90.80247,
                            28.03894
                        ],
                        [
                            90.70003,
                            28.07905
                        ],
                        [
                            90.59243,
                            28.02647
                        ],
                        [
                            90.51409,
                            28.06462
                        ],
                        [
                            90.37745,
                            28.06641
                        ],
                        [
                            90.29267,
                            28.15723
                        ],
                        [
                            90.22213,
                            28.14976
                        ],
                        [
                            90.12645,
                            28.19369
                        ],
                        [
                            90.02664,
                            28.14529
                        ],
                        [
                            89.97936,
                            28.18997
                        ],
                        [
                            89.90187,
                            28.18593
                        ],
                        [
                            89.79684,
                            28.2476
                        ],
                        [
                            89.72492,
                            28.17502
                        ],
                        [
                            89.60406,
                            28.16471
                        ],
                        [
                            89.4611,
                            28.03611
                        ],
                        [
                            89.43615,
                            27.96382
                        ],
                        [
                            89.36569,
                            27.87367
                        ],
                        [
                            89.29636,
                            27.85284
                        ],
                        [
                            89.23618,
                            27.79879
                        ],
                        [
                            89.22486,
                            27.73104
                        ],
                        [
                            89.12968,
                            27.63538
                        ],
                        [
                            89.15896,
                            27.57659
                        ],
                        [
                            89.10308,
                            27.53746
                        ],
                        [
                            89.09392,
                            27.47688
                        ],
                        [
                            89.17921,
                            27.37718
                        ],
                        [
                            89.14985,
                            27.32355
                        ],
                        [
                            89.07324,
                            27.288
                        ],
                        [
                            89.05222,
                            27.2376
                        ],
                        [
                            88.97992,
                            27.21501
                        ],
                        [
                            88.92332,
                            27.27284
                        ],
                        [
                            88.88386,
                            27.22557
                        ],
                        [
                            88.82565,
                            27.21627
                        ],
                        [
                            88.77215,
                            27.10514
                        ],
                        [
                            88.87676,
                            27.06759
                        ],
                        [
                            88.9488,
                            26.93982
                        ],
                        [
                            89.0237,
                            26.93544
                        ],
                        [
                            89.08982,
                            26.89186
                        ],
                        [
                            89.13693,
                            26.81208
                        ],
                        [
                            89.26448,
                            26.82212
                        ],
                        [
                            89.37377,
                            26.85963
                        ],
                        [
                            89.48652,
                            26.8087
                        ],
                        [
                            89.54234,
                            26.81414
                        ],
                        [
                            89.63625,
                            26.7815
                        ],
                        [
                            89.6231,
                            26.7378
                        ],
                        [
                            89.85694,
                            26.70832
                        ],
                        [
                            89.92,
                            26.72892
                        ],
                        [
                            90.06185,
                            26.74125
                        ],
                        [
                            90.16926,
                            26.76526
                        ],
                        [
                            90.23557,
                            26.86039
                        ],
                        [
                            90.30199,
                            26.85529
                        ],
                        [
                            90.36107,
                            26.90055
                        ],
                        [
                            90.41864,
                            26.90177
                        ],
                        [
                            90.53509,
                            26.82282
                        ],
                        [
                            90.69714,
                            26.77227
                        ],
                        [
                            90.74913,
                            26.78216
                        ],
                        [
                            91.0453,
                            26.78733
                        ],
                        [
                            91.09093,
                            26.81543
                        ],
                        [
                            91.25719,
                            26.80785
                        ],
                        [
                            91.33362,
                            26.77779
                        ],
                        [
                            91.43753,
                            26.87272
                        ],
                        [
                            91.51652,
                            26.86073
                        ],
                        [
                            91.5342,
                            26.81788
                        ],
                        [
                            91.71265,
                            26.79656
                        ],
                        [
                            91.83776,
                            26.86073
                        ],
                        [
                            92.10793,
                            26.85827
                        ],
                        [
                            92.12316,
                            26.96322
                        ],
                        [
                            92.02847,
                            27.08344
                        ],
                        [
                            92.03165,
                            27.17163
                        ],
                        [
                            92.07022,
                            27.24045
                        ],
                        [
                            92.12361,
                            27.27647
                        ],
                        [
                            92.0127,
                            27.47693
                        ],
                        [
                            91.94668,
                            27.46795
                        ],
                        [
                            91.83794,
                            27.49297
                        ],
                        [
                            91.75287,
                            27.46652
                        ],
                        [
                            91.62559,
                            27.51351
                        ],
                        [
                            91.56451,
                            27.57963
                        ],
                        [
                            91.57122,
                            27.65562
                        ],
                        [
                            91.62271,
                            27.69827
                        ],
                        [
                            91.64209,
                            27.75846
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "BOL",
                "Country": "Bolivia",
                "Total_3GHG": 0.29,
                "Total_3GHG_timeseries": [
                    8.62e-06,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0046,
                    0.0047,
                    0.0047
                ],
                "Fossil_3GHG": 0.07,
                "Fossil_3GHG_timeseries": [
                    5.1223e-08,
                    1.1137e-07,
                    1.8043e-07,
                    2.5841e-07,
                    3.4528e-07,
                    4.4104e-07,
                    5.4569e-07,
                    6.5922e-07,
                    7.816e-07,
                    9.1284e-07,
                    1.0354e-06,
                    1.1492e-06,
                    1.259e-06,
                    1.3601e-06,
                    1.4523e-06,
                    1.5359e-06,
                    1.6107e-06,
                    1.6767e-06,
                    1.734e-06,
                    1.7826e-06,
                    1.8142e-06,
                    1.8288e-06,
                    1.8264e-06,
                    1.8072e-06,
                    1.7711e-06,
                    1.7182e-06,
                    1.6484e-06,
                    1.5618e-06,
                    1.4584e-06,
                    1.3381e-06,
                    1.2518e-06,
                    1.1996e-06,
                    1.1769e-06,
                    1.1883e-06,
                    1.2337e-06,
                    1.3131e-06,
                    1.4264e-06,
                    1.5736e-06,
                    1.7547e-06,
                    1.9697e-06,
                    2.1837e-06,
                    2.3969e-06,
                    2.6091e-06,
                    2.8205e-06,
                    3.0309e-06,
                    3.2405e-06,
                    3.4492e-06,
                    3.657e-06,
                    3.864e-06,
                    4.0701e-06,
                    4.2603e-06,
                    4.4345e-06,
                    4.5927e-06,
                    4.7346e-06,
                    4.8603e-06,
                    4.9696e-06,
                    5.0625e-06,
                    5.1387e-06,
                    5.1983e-06,
                    5.241e-06,
                    5.3191e-06,
                    5.432e-06,
                    5.5795e-06,
                    5.7614e-06,
                    5.9783e-06,
                    6.2319e-06,
                    6.5223e-06,
                    6.8494e-06,
                    7.2133e-06,
                    7.6141e-06,
                    8.012e-06,
                    8.4071e-06,
                    8.7996e-06,
                    9.1896e-06,
                    9.5772e-06,
                    9.9619e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Land_3GHG": 0.7,
                "Land_3GHG_timeseries": [
                    8.5688e-06,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.004,
                    0.004
                ],
                "Total_CO2": 0.29,
                "Total_CO2_timeseries": [
                    8.0679e-06,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033
                ],
                "Fossil_CO2": 0.03,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.65e-09,
                    6.6e-09,
                    1.155e-08,
                    1.485e-08,
                    2.145e-08,
                    4.125e-08,
                    7.4199e-08,
                    1.0554e-07,
                    1.2532e-07,
                    1.5006e-07,
                    1.7972e-07,
                    2.1767e-07,
                    2.7538e-07,
                    3.2319e-07,
                    3.842e-07,
                    4.5016e-07,
                    5.128e-07,
                    5.8865e-07,
                    6.6119e-07,
                    7.3703e-07,
                    8.2936e-07,
                    9.5963e-07,
                    1.1823e-06,
                    1.3901e-06,
                    1.6211e-06,
                    1.8636e-06,
                    2.2183e-06,
                    2.6373e-06,
                    3.1355e-06,
                    3.5876e-06,
                    4e-06,
                    4.4273e-06,
                    4.8794e-06,
                    5.3479e-06,
                    5.8428e-06,
                    6.3888e-06,
                    7.0553e-06,
                    7.735e-06,
                    8.4955e-06,
                    9.3468e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003
                ],
                "Land_CO2": 0.84,
                "Land_CO2_timeseries": [
                    8.0679e-06,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.003,
                    0.003
                ],
                "Total_CH4": 0.31,
                "Total_CH4_timeseries": [
                    5.344e-07,
                    1.1629e-06,
                    1.8854e-06,
                    2.702e-06,
                    3.6127e-06,
                    4.6174e-06,
                    5.7162e-06,
                    6.909e-06,
                    8.1958e-06,
                    9.5767e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013
                ],
                "Fossil_CH4": 0.17,
                "Fossil_CH4_timeseries": [
                    4.8516e-08,
                    1.0591e-07,
                    1.7219e-07,
                    2.4733e-07,
                    3.3133e-07,
                    4.242e-07,
                    5.2592e-07,
                    6.3648e-07,
                    7.5589e-07,
                    8.8413e-07,
                    1.0036e-06,
                    1.1144e-06,
                    1.2212e-06,
                    1.3192e-06,
                    1.4084e-06,
                    1.4889e-06,
                    1.5606e-06,
                    1.6235e-06,
                    1.6777e-06,
                    1.7232e-06,
                    1.7516e-06,
                    1.7629e-06,
                    1.7572e-06,
                    1.7344e-06,
                    1.6947e-06,
                    1.6379e-06,
                    1.5642e-06,
                    1.4734e-06,
                    1.3658e-06,
                    1.2411e-06,
                    1.1505e-06,
                    1.0939e-06,
                    1.0669e-06,
                    1.0738e-06,
                    1.1147e-06,
                    1.1895e-06,
                    1.2983e-06,
                    1.4409e-06,
                    1.6174e-06,
                    1.8278e-06,
                    2.0371e-06,
                    2.2456e-06,
                    2.453e-06,
                    2.6595e-06,
                    2.8651e-06,
                    3.0697e-06,
                    3.2734e-06,
                    3.4762e-06,
                    3.6781e-06,
                    3.879e-06,
                    4.064e-06,
                    4.2329e-06,
                    4.3857e-06,
                    4.5222e-06,
                    4.6423e-06,
                    4.7459e-06,
                    4.833e-06,
                    4.9034e-06,
                    4.957e-06,
                    4.9937e-06,
                    5.0656e-06,
                    5.1723e-06,
                    5.3135e-06,
                    5.4889e-06,
                    5.6994e-06,
                    5.9464e-06,
                    6.2301e-06,
                    6.5505e-06,
                    6.9076e-06,
                    7.3014e-06,
                    7.6923e-06,
                    8.0803e-06,
                    8.4656e-06,
                    8.8483e-06,
                    9.2285e-06,
                    9.6058e-06,
                    9.979e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005
                ],
                "Land_CH4": 0.52,
                "Land_CH4_timeseries": [
                    4.8589e-07,
                    1.057e-06,
                    1.7132e-06,
                    2.4547e-06,
                    3.2814e-06,
                    4.1932e-06,
                    5.1903e-06,
                    6.2725e-06,
                    7.4399e-06,
                    8.6926e-06,
                    9.8615e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008
                ],
                "Total_N2O": 0.21,
                "Total_N2O_timeseries": [
                    1.7685e-08,
                    3.5713e-08,
                    5.4067e-08,
                    7.273e-08,
                    9.1676e-08,
                    1.1087e-07,
                    1.3029e-07,
                    1.4988e-07,
                    1.696e-07,
                    1.8939e-07,
                    2.0923e-07,
                    2.291e-07,
                    2.49e-07,
                    2.6893e-07,
                    2.8888e-07,
                    3.0885e-07,
                    3.2884e-07,
                    3.4887e-07,
                    3.6893e-07,
                    3.8904e-07,
                    4.0948e-07,
                    4.3072e-07,
                    4.5313e-07,
                    4.7697e-07,
                    5.0238e-07,
                    5.294e-07,
                    5.5796e-07,
                    5.8786e-07,
                    6.1881e-07,
                    6.504e-07,
                    6.8236e-07,
                    7.1463e-07,
                    7.4717e-07,
                    7.7993e-07,
                    8.1291e-07,
                    8.4607e-07,
                    8.7943e-07,
                    9.13e-07,
                    9.468e-07,
                    9.9551e-07,
                    1.0449e-06,
                    1.0956e-06,
                    1.1484e-06,
                    1.2037e-06,
                    1.2621e-06,
                    1.3239e-06,
                    1.3896e-06,
                    1.4595e-06,
                    1.5336e-06,
                    1.6123e-06,
                    1.6972e-06,
                    1.7912e-06,
                    1.8964e-06,
                    2.0143e-06,
                    2.1453e-06,
                    2.2893e-06,
                    2.4452e-06,
                    2.6114e-06,
                    2.7854e-06,
                    2.9637e-06,
                    3.1446e-06,
                    3.3278e-06,
                    3.5131e-06,
                    3.7004e-06,
                    3.8896e-06,
                    4.0802e-06,
                    4.2723e-06,
                    4.4653e-06,
                    4.6592e-06,
                    4.8536e-06,
                    5.0478e-06,
                    5.2408e-06,
                    5.4321e-06,
                    5.6211e-06,
                    5.8075e-06,
                    5.9914e-06,
                    6.173e-06,
                    6.3528e-06,
                    6.5313e-06,
                    6.7096e-06,
                    6.8891e-06,
                    7.0715e-06,
                    7.2585e-06,
                    7.4511e-06,
                    7.6503e-06,
                    7.8568e-06,
                    8.0709e-06,
                    8.2927e-06,
                    8.5221e-06,
                    8.7584e-06,
                    9.0097e-06,
                    9.2905e-06,
                    9.6119e-06,
                    9.9818e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_N2O": 0.04,
                "Fossil_N2O_timeseries": [
                    2.7076e-09,
                    5.4574e-09,
                    8.2481e-09,
                    1.1078e-08,
                    1.3944e-08,
                    1.6845e-08,
                    1.9776e-08,
                    2.2734e-08,
                    2.5714e-08,
                    2.8713e-08,
                    3.1725e-08,
                    3.4752e-08,
                    3.7792e-08,
                    4.0844e-08,
                    4.391e-08,
                    4.6988e-08,
                    5.0079e-08,
                    5.3184e-08,
                    5.6302e-08,
                    5.9436e-08,
                    6.261e-08,
                    6.5869e-08,
                    6.9247e-08,
                    7.2768e-08,
                    7.6445e-08,
                    8.0281e-08,
                    8.427e-08,
                    8.8393e-08,
                    9.2625e-08,
                    9.6926e-08,
                    1.0127e-07,
                    1.0566e-07,
                    1.1008e-07,
                    1.1453e-07,
                    1.1901e-07,
                    1.2352e-07,
                    1.2806e-07,
                    1.3263e-07,
                    1.3723e-07,
                    1.4189e-07,
                    1.4659e-07,
                    1.5134e-07,
                    1.5613e-07,
                    1.6096e-07,
                    1.6584e-07,
                    1.7077e-07,
                    1.7576e-07,
                    1.808e-07,
                    1.8589e-07,
                    1.9105e-07,
                    1.9628e-07,
                    2.0158e-07,
                    2.0697e-07,
                    2.1245e-07,
                    2.1802e-07,
                    2.237e-07,
                    2.2947e-07,
                    2.3533e-07,
                    2.413e-07,
                    2.4735e-07,
                    2.535e-07,
                    2.5973e-07,
                    2.6604e-07,
                    2.7245e-07,
                    2.7894e-07,
                    2.8551e-07,
                    2.9218e-07,
                    2.9893e-07,
                    3.0576e-07,
                    3.1269e-07,
                    3.197e-07,
                    3.2681e-07,
                    3.3401e-07,
                    3.413e-07,
                    3.4868e-07,
                    3.5615e-07,
                    3.6372e-07,
                    3.7137e-07,
                    3.7911e-07,
                    3.8694e-07,
                    3.9484e-07,
                    4.0282e-07,
                    4.1087e-07,
                    4.1899e-07,
                    4.2718e-07,
                    4.3545e-07,
                    4.438e-07,
                    4.5224e-07,
                    4.608e-07,
                    4.6947e-07,
                    4.7838e-07,
                    4.8769e-07,
                    4.9755e-07,
                    5.0805e-07,
                    5.1927e-07,
                    5.3122e-07,
                    5.4389e-07,
                    5.5725e-07,
                    5.7119e-07,
                    5.8561e-07,
                    6.0042e-07,
                    6.1563e-07,
                    6.3123e-07,
                    6.4723e-07,
                    6.6364e-07,
                    6.8048e-07,
                    6.9777e-07,
                    7.1553e-07,
                    7.3379e-07,
                    7.5259e-07,
                    7.72e-07,
                    7.9214e-07,
                    8.131e-07,
                    8.3496e-07,
                    8.5777e-07,
                    8.8156e-07,
                    9.0634e-07,
                    9.3211e-07,
                    9.5884e-07,
                    9.8964e-07,
                    1.0224e-06,
                    1.0579e-06,
                    1.0935e-06,
                    1.1311e-06,
                    1.1725e-06,
                    1.2175e-06,
                    1.2632e-06,
                    1.3129e-06,
                    1.3613e-06,
                    1.4208e-06,
                    1.485e-06,
                    1.5642e-06,
                    1.6433e-06,
                    1.732e-06,
                    1.8197e-06,
                    1.9169e-06,
                    2.0083e-06,
                    2.0932e-06,
                    2.1922e-06,
                    2.2887e-06,
                    2.3906e-06,
                    2.4935e-06,
                    2.6029e-06,
                    2.716e-06,
                    2.8345e-06,
                    2.9524e-06,
                    3.0701e-06,
                    3.1929e-06,
                    3.3184e-06,
                    3.4637e-06,
                    3.6086e-06,
                    3.754e-06,
                    3.9043e-06,
                    4.0616e-06,
                    4.2228e-06,
                    4.3945e-06,
                    4.5762e-06,
                    4.7643e-06,
                    4.9558e-06,
                    5.1553e-06,
                    5.3632e-06,
                    5.5889e-06,
                    5.8209e-06,
                    6.0601e-06,
                    6.3088e-06,
                    6.5613e-06,
                    6.8211e-06,
                    7.0911e-06,
                    7.3724e-06,
                    7.6381e-06,
                    7.9325e-06,
                    8.2146e-06
                ],
                "Land_N2O": 0.28,
                "Land_N2O_timeseries": [
                    1.4978e-08,
                    3.0255e-08,
                    4.5819e-08,
                    6.1652e-08,
                    7.7731e-08,
                    9.4029e-08,
                    1.1051e-07,
                    1.2714e-07,
                    1.4388e-07,
                    1.6068e-07,
                    1.775e-07,
                    1.9435e-07,
                    2.1121e-07,
                    2.2808e-07,
                    2.4497e-07,
                    2.6186e-07,
                    2.7876e-07,
                    2.9569e-07,
                    3.1263e-07,
                    3.2961e-07,
                    3.4687e-07,
                    3.6485e-07,
                    3.8388e-07,
                    4.042e-07,
                    4.2594e-07,
                    4.4912e-07,
                    4.7369e-07,
                    4.9946e-07,
                    5.2618e-07,
                    5.5347e-07,
                    5.8109e-07,
                    6.0897e-07,
                    6.3709e-07,
                    6.654e-07,
                    6.9389e-07,
                    7.2255e-07,
                    7.5137e-07,
                    7.8037e-07,
                    8.0957e-07,
                    8.5362e-07,
                    8.9829e-07,
                    9.4429e-07,
                    9.9225e-07,
                    1.0427e-06,
                    1.0962e-06,
                    1.1532e-06,
                    1.2139e-06,
                    1.2787e-06,
                    1.3478e-06,
                    1.4212e-06,
                    1.5009e-06,
                    1.5896e-06,
                    1.6895e-06,
                    1.8018e-06,
                    1.9273e-06,
                    2.0656e-06,
                    2.2157e-06,
                    2.3761e-06,
                    2.5441e-06,
                    2.7164e-06,
                    2.8911e-06,
                    3.068e-06,
                    3.2471e-06,
                    3.428e-06,
                    3.6106e-06,
                    3.7947e-06,
                    3.9801e-06,
                    4.1664e-06,
                    4.3535e-06,
                    4.5409e-06,
                    4.7281e-06,
                    4.914e-06,
                    5.0981e-06,
                    5.2798e-06,
                    5.4588e-06,
                    5.6353e-06,
                    5.8093e-06,
                    5.9814e-06,
                    6.1522e-06,
                    6.3226e-06,
                    6.4942e-06,
                    6.6687e-06,
                    6.8476e-06,
                    7.0321e-06,
                    7.2231e-06,
                    7.4214e-06,
                    7.6271e-06,
                    7.8405e-06,
                    8.0613e-06,
                    8.2889e-06,
                    8.5313e-06,
                    8.8028e-06,
                    9.1144e-06,
                    9.4738e-06,
                    9.8855e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -58.16346,
                            -20.16246
                        ],
                        [
                            -57.94682,
                            -20.02429
                        ],
                        [
                            -57.88515,
                            -20.02916
                        ],
                        [
                            -57.8552,
                            -19.97139
                        ],
                        [
                            -58.12069,
                            -19.73142
                        ],
                        [
                            -57.78944,
                            -19.05013
                        ],
                        [
                            -57.7222,
                            -19.04248
                        ],
                        [
                            -57.70577,
                            -19.00007
                        ],
                        [
                            -57.71965,
                            -18.9165
                        ],
                        [
                            -57.76765,
                            -18.90291
                        ],
                        [
                            -57.60202,
                            -18.36516
                        ],
                        [
                            -57.55915,
                            -18.26245
                        ],
                        [
                            -57.46378,
                            -18.23201
                        ],
                        [
                            -57.57378,
                            -18.12459
                        ],
                        [
                            -57.60997,
                            -18.02406
                        ],
                        [
                            -57.70104,
                            -17.86245
                        ],
                        [
                            -57.71536,
                            -17.73495
                        ],
                        [
                            -57.78393,
                            -17.64657
                        ],
                        [
                            -57.80672,
                            -17.51804
                        ],
                        [
                            -57.90354,
                            -17.46121
                        ],
                        [
                            -58.00037,
                            -17.51872
                        ],
                        [
                            -58.05056,
                            -17.46517
                        ],
                        [
                            -58.19546,
                            -17.36567
                        ],
                        [
                            -58.24316,
                            -17.3622
                        ],
                        [
                            -58.34886,
                            -17.2225
                        ],
                        [
                            -58.39436,
                            -17.19633
                        ],
                        [
                            -58.38719,
                            -17.11788
                        ],
                        [
                            -58.45721,
                            -16.9632
                        ],
                        [
                            -58.45554,
                            -16.6583
                        ],
                        [
                            -58.3837,
                            -16.5638
                        ],
                        [
                            -58.34045,
                            -16.54043
                        ],
                        [
                            -58.35023,
                            -16.42134
                        ],
                        [
                            -58.32225,
                            -16.38139
                        ],
                        [
                            -58.30872,
                            -16.27891
                        ],
                        [
                            -58.3706,
                            -16.27602
                        ],
                        [
                            -58.46945,
                            -16.32477
                        ],
                        [
                            -58.81642,
                            -16.30723
                        ],
                        [
                            -59.25856,
                            -16.29055
                        ],
                        [
                            -59.35779,
                            -16.27962
                        ],
                        [
                            -59.91362,
                            -16.2754
                        ],
                        [
                            -60.17277,
                            -16.26319
                        ],
                        [
                            -60.20608,
                            -15.90005
                        ],
                        [
                            -60.23607,
                            -15.47677
                        ],
                        [
                            -60.56421,
                            -15.10627
                        ],
                        [
                            -60.25604,
                            -15.09801
                        ],
                        [
                            -60.27676,
                            -14.61998
                        ],
                        [
                            -60.30582,
                            -14.61206
                        ],
                        [
                            -60.33687,
                            -14.50187
                        ],
                        [
                            -60.3974,
                            -14.42032
                        ],
                        [
                            -60.38938,
                            -14.36723
                        ],
                        [
                            -60.449,
                            -14.28929
                        ],
                        [
                            -60.47056,
                            -14.09855
                        ],
                        [
                            -60.39272,
                            -14.03022
                        ],
                        [
                            -60.44757,
                            -13.89916
                        ],
                        [
                            -60.46842,
                            -13.80191
                        ],
                        [
                            -60.56542,
                            -13.78358
                        ],
                        [
                            -60.59806,
                            -13.74967
                        ],
                        [
                            -60.67061,
                            -13.74812
                        ],
                        [
                            -60.73704,
                            -13.6941
                        ],
                        [
                            -60.88946,
                            -13.6286
                        ],
                        [
                            -60.96925,
                            -13.53846
                        ],
                        [
                            -61.04216,
                            -13.54151
                        ],
                        [
                            -61.04445,
                            -13.49822
                        ],
                        [
                            -61.12186,
                            -13.47248
                        ],
                        [
                            -61.13912,
                            -13.51972
                        ],
                        [
                            -61.25202,
                            -13.52369
                        ],
                        [
                            -61.3206,
                            -13.48112
                        ],
                        [
                            -61.48716,
                            -13.55395
                        ],
                        [
                            -61.57227,
                            -13.51513
                        ],
                        [
                            -61.74163,
                            -13.52409
                        ],
                        [
                            -61.79731,
                            -13.54327
                        ],
                        [
                            -61.85157,
                            -13.50447
                        ],
                        [
                            -61.87196,
                            -13.43884
                        ],
                        [
                            -62.00883,
                            -13.35137
                        ],
                        [
                            -62.10803,
                            -13.25455
                        ],
                        [
                            -62.10856,
                            -13.15
                        ],
                        [
                            -62.24333,
                            -13.12237
                        ],
                        [
                            -62.27811,
                            -13.15013
                        ],
                        [
                            -62.4135,
                            -13.12866
                        ],
                        [
                            -62.46279,
                            -13.07053
                        ],
                        [
                            -62.55323,
                            -13.07306
                        ],
                        [
                            -62.6284,
                            -13.04508
                        ],
                        [
                            -62.67543,
                            -12.9654
                        ],
                        [
                            -62.77974,
                            -13.01377
                        ],
                        [
                            -62.90945,
                            -12.86562
                        ],
                        [
                            -62.99841,
                            -12.84665
                        ],
                        [
                            -63.05684,
                            -12.74208
                        ],
                        [
                            -63.08083,
                            -12.6545
                        ],
                        [
                            -63.13422,
                            -12.64124
                        ],
                        [
                            -63.26687,
                            -12.7164
                        ],
                        [
                            -63.32815,
                            -12.70412
                        ],
                        [
                            -63.4235,
                            -12.65326
                        ],
                        [
                            -63.4805,
                            -12.55897
                        ],
                        [
                            -63.54594,
                            -12.55102
                        ],
                        [
                            -63.6609,
                            -12.47123
                        ],
                        [
                            -63.77344,
                            -12.45492
                        ],
                        [
                            -63.86749,
                            -12.49224
                        ],
                        [
                            -63.93774,
                            -12.5563
                        ],
                        [
                            -64.09051,
                            -12.50583
                        ],
                        [
                            -64.13752,
                            -12.5253
                        ],
                        [
                            -64.17675,
                            -12.48683
                        ],
                        [
                            -64.38755,
                            -12.45908
                        ],
                        [
                            -64.49236,
                            -12.36478
                        ],
                        [
                            -64.46905,
                            -12.29592
                        ],
                        [
                            -64.51876,
                            -12.24053
                        ],
                        [
                            -64.61196,
                            -12.2123
                        ],
                        [
                            -64.7342,
                            -12.1139
                        ],
                        [
                            -64.78575,
                            -12.0451
                        ],
                        [
                            -64.91443,
                            -12.00696
                        ],
                        [
                            -64.99184,
                            -11.9991
                        ],
                        [
                            -64.99982,
                            -11.91668
                        ],
                        [
                            -65.0321,
                            -11.86047
                        ],
                        [
                            -65.04821,
                            -11.75642
                        ],
                        [
                            -65.19945,
                            -11.74624
                        ],
                        [
                            -65.17629,
                            -11.67693
                        ],
                        [
                            -65.20625,
                            -11.55177
                        ],
                        [
                            -65.23688,
                            -11.51011
                        ],
                        [
                            -65.29814,
                            -11.50013
                        ],
                        [
                            -65.33617,
                            -11.36243
                        ],
                        [
                            -65.38412,
                            -11.26853
                        ],
                        [
                            -65.37024,
                            -11.14059
                        ],
                        [
                            -65.32541,
                            -11.1135
                        ],
                        [
                            -65.32687,
                            -11.02567
                        ],
                        [
                            -65.28971,
                            -10.98378
                        ],
                        [
                            -65.31634,
                            -10.87111
                        ],
                        [
                            -65.38748,
                            -10.81954
                        ],
                        [
                            -65.37267,
                            -10.71943
                        ],
                        [
                            -65.41172,
                            -10.59414
                        ],
                        [
                            -65.43003,
                            -10.47921
                        ],
                        [
                            -65.38421,
                            -10.43618
                        ],
                        [
                            -65.38288,
                            -10.38778
                        ],
                        [
                            -65.30881,
                            -10.29705
                        ],
                        [
                            -65.28034,
                            -10.21714
                        ],
                        [
                            -65.3225,
                            -10.04119
                        ],
                        [
                            -65.32335,
                            -9.90489
                        ],
                        [
                            -65.29291,
                            -9.86559
                        ],
                        [
                            -65.36125,
                            -9.71418
                        ],
                        [
                            -65.43409,
                            -9.68188
                        ],
                        [
                            -65.48672,
                            -9.71922
                        ],
                        [
                            -65.50749,
                            -9.79243
                        ],
                        [
                            -65.59498,
                            -9.82961
                        ],
                        [
                            -65.7154,
                            -9.74834
                        ],
                        [
                            -65.7975,
                            -9.78506
                        ],
                        [
                            -65.87529,
                            -9.75747
                        ],
                        [
                            -66.03135,
                            -9.80276
                        ],
                        [
                            -66.0683,
                            -9.77337
                        ],
                        [
                            -66.1602,
                            -9.78559
                        ],
                        [
                            -66.19992,
                            -9.82101
                        ],
                        [
                            -66.31334,
                            -9.83153
                        ],
                        [
                            -66.36418,
                            -9.86034
                        ],
                        [
                            -66.6147,
                            -9.8936
                        ],
                        [
                            -66.62573,
                            -9.93487
                        ],
                        [
                            -66.71533,
                            -9.97007
                        ],
                        [
                            -66.88276,
                            -10.08231
                        ],
                        [
                            -67.03015,
                            -10.25317
                        ],
                        [
                            -67.13567,
                            -10.28885
                        ],
                        [
                            -67.18336,
                            -10.33753
                        ],
                        [
                            -67.23276,
                            -10.31459
                        ],
                        [
                            -67.31308,
                            -10.31721
                        ],
                        [
                            -67.32841,
                            -10.37257
                        ],
                        [
                            -67.41518,
                            -10.37358
                        ],
                        [
                            -67.44508,
                            -10.45017
                        ],
                        [
                            -67.56319,
                            -10.50018
                        ],
                        [
                            -67.63332,
                            -10.59702
                        ],
                        [
                            -67.68414,
                            -10.62977
                        ],
                        [
                            -67.73896,
                            -10.71391
                        ],
                        [
                            -67.81325,
                            -10.66284
                        ],
                        [
                            -68.00384,
                            -10.65512
                        ],
                        [
                            -68.11546,
                            -10.72429
                        ],
                        [
                            -68.11885,
                            -10.76435
                        ],
                        [
                            -68.18718,
                            -10.83916
                        ],
                        [
                            -68.24759,
                            -10.95106
                        ],
                        [
                            -68.28439,
                            -10.98627
                        ],
                        [
                            -68.39662,
                            -11.01624
                        ],
                        [
                            -68.41475,
                            -11.03962
                        ],
                        [
                            -68.51424,
                            -11.04725
                        ],
                        [
                            -68.589,
                            -11.11012
                        ],
                        [
                            -68.73404,
                            -11.14205
                        ],
                        [
                            -68.77584,
                            -11.12479
                        ],
                        [
                            -68.75214,
                            -11.00779
                        ],
                        [
                            -68.78859,
                            -10.99069
                        ],
                        [
                            -68.86887,
                            -11.0223
                        ],
                        [
                            -69.15212,
                            -10.964
                        ],
                        [
                            -69.31466,
                            -10.95565
                        ],
                        [
                            -69.39118,
                            -10.9312
                        ],
                        [
                            -69.43431,
                            -10.95113
                        ],
                        [
                            -69.56644,
                            -10.95666
                        ],
                        [
                            -69.32722,
                            -11.3355
                        ],
                        [
                            -69.03132,
                            -11.81178
                        ],
                        [
                            -68.92433,
                            -11.99408
                        ],
                        [
                            -68.68142,
                            -12.4936
                        ],
                        [
                            -68.7052,
                            -12.55936
                        ],
                        [
                            -68.7694,
                            -12.64601
                        ],
                        [
                            -68.7519,
                            -12.71873
                        ],
                        [
                            -68.84884,
                            -12.72923
                        ],
                        [
                            -68.93497,
                            -12.84401
                        ],
                        [
                            -68.96119,
                            -12.85507
                        ],
                        [
                            -68.96905,
                            -13.0025
                        ],
                        [
                            -68.95104,
                            -13.01994
                        ],
                        [
                            -68.94219,
                            -13.25695
                        ],
                        [
                            -68.95368,
                            -13.39695
                        ],
                        [
                            -68.94272,
                            -13.4891
                        ],
                        [
                            -68.99973,
                            -13.65319
                        ],
                        [
                            -69.07012,
                            -13.64545
                        ],
                        [
                            -69.05086,
                            -13.71737
                        ],
                        [
                            -68.99559,
                            -13.7549
                        ],
                        [
                            -68.99912,
                            -13.8011
                        ],
                        [
                            -68.96013,
                            -13.87665
                        ],
                        [
                            -68.96483,
                            -13.97285
                        ],
                        [
                            -68.88271,
                            -14.06343
                        ],
                        [
                            -68.83979,
                            -14.19391
                        ],
                        [
                            -68.85674,
                            -14.21984
                        ],
                        [
                            -68.98031,
                            -14.23688
                        ],
                        [
                            -68.99596,
                            -14.30004
                        ],
                        [
                            -68.98066,
                            -14.38672
                        ],
                        [
                            -69.15019,
                            -14.506
                        ],
                        [
                            -69.14659,
                            -14.57499
                        ],
                        [
                            -69.2367,
                            -14.6053
                        ],
                        [
                            -69.23751,
                            -14.73729
                        ],
                        [
                            -69.36184,
                            -14.80354
                        ],
                        [
                            -69.34985,
                            -14.90453
                        ],
                        [
                            -69.37344,
                            -14.9504
                        ],
                        [
                            -69.28022,
                            -15.11085
                        ],
                        [
                            -69.19256,
                            -15.16271
                        ],
                        [
                            -69.12704,
                            -15.25513
                        ],
                        [
                            -69.18519,
                            -15.26258
                        ],
                        [
                            -69.26456,
                            -15.33673
                        ],
                        [
                            -69.29815,
                            -15.42064
                        ],
                        [
                            -69.41265,
                            -15.62168
                        ],
                        [
                            -69.29859,
                            -15.93722
                        ],
                        [
                            -69.23592,
                            -16.14172
                        ],
                        [
                            -69.09732,
                            -16.21877
                        ],
                        [
                            -69.00883,
                            -16.21466
                        ],
                        [
                            -68.96189,
                            -16.19009
                        ],
                        [
                            -68.8227,
                            -16.31081
                        ],
                        [
                            -68.82231,
                            -16.34551
                        ],
                        [
                            -68.98431,
                            -16.43699
                        ],
                        [
                            -69.03163,
                            -16.56395
                        ],
                        [
                            -69.00794,
                            -16.67534
                        ],
                        [
                            -69.174,
                            -16.74409
                        ],
                        [
                            -69.18341,
                            -16.79404
                        ],
                        [
                            -69.38918,
                            -17.01881
                        ],
                        [
                            -69.37661,
                            -17.07875
                        ],
                        [
                            -69.45462,
                            -17.10347
                        ],
                        [
                            -69.55242,
                            -17.16301
                        ],
                        [
                            -69.63442,
                            -17.28663
                        ],
                        [
                            -69.57213,
                            -17.29019
                        ],
                        [
                            -69.46502,
                            -17.3744
                        ],
                        [
                            -69.47262,
                            -17.49896
                        ],
                        [
                            -69.4612,
                            -17.60551
                        ],
                        [
                            -69.34478,
                            -17.71768
                        ],
                        [
                            -69.30913,
                            -17.79912
                        ],
                        [
                            -69.3121,
                            -17.91093
                        ],
                        [
                            -69.29583,
                            -17.95062
                        ],
                        [
                            -69.08441,
                            -18.04393
                        ],
                        [
                            -69.06835,
                            -18.06837
                        ],
                        [
                            -69.134,
                            -18.16745
                        ],
                        [
                            -69.07059,
                            -18.23783
                        ],
                        [
                            -69.02377,
                            -18.45566
                        ],
                        [
                            -68.97782,
                            -18.74909
                        ],
                        [
                            -68.90945,
                            -18.87723
                        ],
                        [
                            -68.95426,
                            -18.93568
                        ],
                        [
                            -68.89777,
                            -19.03182
                        ],
                        [
                            -68.8003,
                            -19.08621
                        ],
                        [
                            -68.67008,
                            -19.189
                        ],
                        [
                            -68.61577,
                            -19.26943
                        ],
                        [
                            -68.53169,
                            -19.30078
                        ],
                        [
                            -68.413,
                            -19.39579
                        ],
                        [
                            -68.43283,
                            -19.43898
                        ],
                        [
                            -68.59523,
                            -19.63904
                        ],
                        [
                            -68.62247,
                            -19.69611
                        ],
                        [
                            -68.68426,
                            -19.72497
                        ],
                        [
                            -68.60563,
                            -19.81823
                        ],
                        [
                            -68.5306,
                            -19.84332
                        ],
                        [
                            -68.52346,
                            -19.91928
                        ],
                        [
                            -68.56054,
                            -20.04426
                        ],
                        [
                            -68.65137,
                            -20.05062
                        ],
                        [
                            -68.77523,
                            -20.08088
                        ],
                        [
                            -68.70529,
                            -20.14231
                        ],
                        [
                            -68.71258,
                            -20.23934
                        ],
                        [
                            -68.66389,
                            -20.32292
                        ],
                        [
                            -68.74067,
                            -20.36422
                        ],
                        [
                            -68.73558,
                            -20.44183
                        ],
                        [
                            -68.67814,
                            -20.49832
                        ],
                        [
                            -68.53826,
                            -20.56019
                        ],
                        [
                            -68.50254,
                            -20.67054
                        ],
                        [
                            -68.54916,
                            -20.72633
                        ],
                        [
                            -68.54835,
                            -20.86606
                        ],
                        [
                            -68.5046,
                            -20.93631
                        ],
                        [
                            -68.40053,
                            -20.93809
                        ],
                        [
                            -68.28675,
                            -21.10371
                        ],
                        [
                            -68.17279,
                            -21.29685
                        ],
                        [
                            -68.17689,
                            -21.5982
                        ],
                        [
                            -68.11056,
                            -21.67382
                        ],
                        [
                            -68.05715,
                            -21.76371
                        ],
                        [
                            -68.06403,
                            -21.97504
                        ],
                        [
                            -67.96501,
                            -22.04795
                        ],
                        [
                            -67.93962,
                            -22.11519
                        ],
                        [
                            -67.95196,
                            -22.16283
                        ],
                        [
                            -67.92196,
                            -22.22661
                        ],
                        [
                            -67.9454,
                            -22.32335
                        ],
                        [
                            -67.89585,
                            -22.4157
                        ],
                        [
                            -67.88813,
                            -22.49656
                        ],
                        [
                            -67.84871,
                            -22.54684
                        ],
                        [
                            -67.88532,
                            -22.7093
                        ],
                        [
                            -67.8737,
                            -22.8276
                        ],
                        [
                            -67.79176,
                            -22.87368
                        ],
                        [
                            -67.57216,
                            -22.89566
                        ],
                        [
                            -67.1775,
                            -22.80469
                        ],
                        [
                            -67.13215,
                            -22.71897
                        ],
                        [
                            -67.01514,
                            -22.6529
                        ],
                        [
                            -67.03033,
                            -22.53504
                        ],
                        [
                            -66.97608,
                            -22.53334
                        ],
                        [
                            -66.92508,
                            -22.48853
                        ],
                        [
                            -66.7844,
                            -22.4362
                        ],
                        [
                            -66.73555,
                            -22.23408
                        ],
                        [
                            -66.35602,
                            -22.12924
                        ],
                        [
                            -66.29196,
                            -22.0857
                        ],
                        [
                            -66.28124,
                            -21.98298
                        ],
                        [
                            -66.22184,
                            -21.78366
                        ],
                        [
                            -66.0937,
                            -21.8236
                        ],
                        [
                            -66.06242,
                            -21.91632
                        ],
                        [
                            -65.92396,
                            -21.92428
                        ],
                        [
                            -65.80798,
                            -22.06923
                        ],
                        [
                            -65.74725,
                            -22.10638
                        ],
                        [
                            -65.65957,
                            -22.10908
                        ],
                        [
                            -65.5721,
                            -22.07711
                        ],
                        [
                            -65.46241,
                            -22.08836
                        ],
                        [
                            -64.99233,
                            -22.08693
                        ],
                        [
                            -64.87101,
                            -22.11908
                        ],
                        [
                            -64.73411,
                            -22.19241
                        ],
                        [
                            -64.62063,
                            -22.20409
                        ],
                        [
                            -64.53484,
                            -22.28364
                        ],
                        [
                            -64.56443,
                            -22.37437
                        ],
                        [
                            -64.49313,
                            -22.43763
                        ],
                        [
                            -64.47954,
                            -22.48044
                        ],
                        [
                            -64.41398,
                            -22.54009
                        ],
                        [
                            -64.43823,
                            -22.6388
                        ],
                        [
                            -64.39905,
                            -22.71791
                        ],
                        [
                            -64.34088,
                            -22.75099
                        ],
                        [
                            -64.32808,
                            -22.82313
                        ],
                        [
                            -64.28154,
                            -22.82593
                        ],
                        [
                            -64.26889,
                            -22.66005
                        ],
                        [
                            -64.23911,
                            -22.55685
                        ],
                        [
                            -64.12058,
                            -22.40022
                        ],
                        [
                            -64.06061,
                            -22.24107
                        ],
                        [
                            -63.96037,
                            -22.08323
                        ],
                        [
                            -63.93168,
                            -22.00155
                        ],
                        [
                            -62.81278,
                            -21.99949
                        ],
                        [
                            -62.79594,
                            -22.06385
                        ],
                        [
                            -62.80942,
                            -22.13658
                        ],
                        [
                            -62.69134,
                            -22.19552
                        ],
                        [
                            -62.6452,
                            -22.25047
                        ],
                        [
                            -62.50488,
                            -21.81403
                        ],
                        [
                            -62.26134,
                            -21.05557
                        ],
                        [
                            -62.26587,
                            -20.56136
                        ],
                        [
                            -61.92173,
                            -20.0869
                        ],
                        [
                            -61.73015,
                            -19.64319
                        ],
                        [
                            -61.45804,
                            -19.59828
                        ],
                        [
                            -60.604,
                            -19.45724
                        ],
                        [
                            -59.9767,
                            -19.29231
                        ],
                        [
                            -59.06623,
                            -19.28776
                        ],
                        [
                            -58.23579,
                            -19.77232
                        ],
                        [
                            -58.16373,
                            -19.82634
                        ],
                        [
                            -58.20134,
                            -19.86431
                        ],
                        [
                            -58.194,
                            -19.96315
                        ],
                        [
                            -58.1381,
                            -20.11786
                        ],
                        [
                            -58.16346,
                            -20.16246
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "BES",
                "Country": "Bonaire, Sint Eustatius and Saba",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    3.0334e-09,
                    6.2816e-09,
                    1.3798e-08,
                    2.3192e-08,
                    3.5417e-08,
                    4.5571e-08,
                    5.5505e-08,
                    6.6136e-08,
                    7.7891e-08,
                    9.1062e-08,
                    1.0538e-07,
                    1.2209e-07,
                    1.4021e-07,
                    1.5713e-07,
                    1.7079e-07,
                    1.8745e-07,
                    1.9715e-07,
                    2.1283e-07,
                    2.3248e-07,
                    2.5531e-07,
                    2.8091e-07,
                    3.0992e-07,
                    3.3963e-07,
                    3.3963e-07,
                    3.7683e-07,
                    4.3551e-07,
                    4.694e-07,
                    5.0861e-07,
                    5.8793e-07,
                    6.5354e-07,
                    7.3839e-07,
                    7.9634e-07,
                    8.4711e-07,
                    9.1246e-07,
                    9.6865e-07,
                    1.0273e-06,
                    1.0917e-06,
                    1.1534e-06,
                    1.2134e-06,
                    1.2672e-06,
                    1.3175e-06,
                    1.3795e-06,
                    1.4371e-06,
                    1.5126e-06,
                    1.5969e-06,
                    1.6704e-06,
                    1.7416e-06,
                    1.8205e-06,
                    1.8921e-06,
                    1.944e-06,
                    2.0547e-06,
                    2.1126e-06,
                    2.1618e-06,
                    2.2135e-06,
                    2.2667e-06,
                    2.3173e-06,
                    2.374e-06,
                    2.4031e-06,
                    2.4758e-06,
                    2.5608e-06,
                    2.5772e-06,
                    2.5917e-06,
                    2.6059e-06,
                    2.6331e-06,
                    2.6622e-06,
                    2.6855e-06,
                    2.7046e-06,
                    2.7342e-06,
                    2.7625e-06,
                    2.7905e-06,
                    2.8168e-06,
                    2.8442e-06,
                    2.8457e-06,
                    2.8571e-06,
                    2.8872e-06,
                    2.9179e-06,
                    2.9474e-06,
                    2.977e-06,
                    3.0081e-06,
                    3.0388e-06,
                    3.0709e-06,
                    3.107e-06,
                    3.1417e-06,
                    3.1773e-06,
                    3.2017e-06,
                    3.2329e-06,
                    3.2709e-06,
                    3.3088e-06,
                    3.3468e-06,
                    3.3897e-06,
                    3.4359e-06,
                    3.4821e-06,
                    3.5266e-06,
                    3.5761e-06,
                    3.6273e-06,
                    3.6766e-06,
                    3.7263e-06
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    3.0334e-09,
                    6.2816e-09,
                    1.3798e-08,
                    2.3192e-08,
                    3.5417e-08,
                    4.5571e-08,
                    5.5505e-08,
                    6.6136e-08,
                    7.7891e-08,
                    9.1062e-08,
                    1.0538e-07,
                    1.2209e-07,
                    1.4021e-07,
                    1.5713e-07,
                    1.7079e-07,
                    1.8745e-07,
                    1.9715e-07,
                    2.1283e-07,
                    2.3248e-07,
                    2.5531e-07,
                    2.8091e-07,
                    3.0992e-07,
                    3.3963e-07,
                    3.3963e-07,
                    3.7683e-07,
                    4.3551e-07,
                    4.694e-07,
                    5.0861e-07,
                    5.8793e-07,
                    6.5354e-07,
                    7.3839e-07,
                    7.9634e-07,
                    8.4711e-07,
                    9.1246e-07,
                    9.6865e-07,
                    1.0273e-06,
                    1.0917e-06,
                    1.1534e-06,
                    1.2134e-06,
                    1.2672e-06,
                    1.3175e-06,
                    1.3795e-06,
                    1.4371e-06,
                    1.5126e-06,
                    1.5969e-06,
                    1.6704e-06,
                    1.7416e-06,
                    1.8205e-06,
                    1.8921e-06,
                    1.944e-06,
                    2.0547e-06,
                    2.1126e-06,
                    2.1618e-06,
                    2.2135e-06,
                    2.2667e-06,
                    2.3173e-06,
                    2.374e-06,
                    2.4031e-06,
                    2.4758e-06,
                    2.5608e-06,
                    2.5772e-06,
                    2.5917e-06,
                    2.6059e-06,
                    2.6331e-06,
                    2.6622e-06,
                    2.6855e-06,
                    2.7046e-06,
                    2.7342e-06,
                    2.7625e-06,
                    2.7905e-06,
                    2.8168e-06,
                    2.8442e-06,
                    2.8457e-06,
                    2.8571e-06,
                    2.8872e-06,
                    2.9179e-06,
                    2.9474e-06,
                    2.977e-06,
                    3.0081e-06,
                    3.0388e-06,
                    3.0709e-06,
                    3.107e-06,
                    3.1417e-06,
                    3.1773e-06,
                    3.2017e-06,
                    3.2329e-06,
                    3.2709e-06,
                    3.3088e-06,
                    3.3468e-06,
                    3.3897e-06,
                    3.4359e-06,
                    3.4821e-06,
                    3.5266e-06,
                    3.5761e-06,
                    3.6273e-06,
                    3.6766e-06,
                    3.7263e-06
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    3.0334e-09,
                    6.2816e-09,
                    1.3798e-08,
                    2.3192e-08,
                    3.5417e-08,
                    4.5571e-08,
                    5.5505e-08,
                    6.6136e-08,
                    7.7891e-08,
                    9.1062e-08,
                    1.0538e-07,
                    1.2209e-07,
                    1.4021e-07,
                    1.5713e-07,
                    1.7079e-07,
                    1.8745e-07,
                    1.9715e-07,
                    2.1283e-07,
                    2.3248e-07,
                    2.5531e-07,
                    2.8091e-07,
                    3.0992e-07,
                    3.3963e-07,
                    3.3963e-07,
                    3.7683e-07,
                    4.3551e-07,
                    4.694e-07,
                    5.0861e-07,
                    5.8793e-07,
                    6.5354e-07,
                    7.3839e-07,
                    7.9634e-07,
                    8.4711e-07,
                    9.1246e-07,
                    9.6865e-07,
                    1.0273e-06,
                    1.0917e-06,
                    1.1534e-06,
                    1.2134e-06,
                    1.2672e-06,
                    1.3175e-06,
                    1.3795e-06,
                    1.4371e-06,
                    1.5126e-06,
                    1.5969e-06,
                    1.6704e-06,
                    1.7416e-06,
                    1.8205e-06,
                    1.8921e-06,
                    1.944e-06,
                    2.0547e-06,
                    2.1126e-06,
                    2.1618e-06,
                    2.2135e-06,
                    2.2667e-06,
                    2.3173e-06,
                    2.374e-06,
                    2.4031e-06,
                    2.4758e-06,
                    2.5608e-06,
                    2.5772e-06,
                    2.5917e-06,
                    2.6059e-06,
                    2.6331e-06,
                    2.6622e-06,
                    2.6855e-06,
                    2.7046e-06,
                    2.7342e-06,
                    2.7625e-06,
                    2.7905e-06,
                    2.8168e-06,
                    2.8442e-06,
                    2.8457e-06,
                    2.8571e-06,
                    2.8872e-06,
                    2.9179e-06,
                    2.9474e-06,
                    2.977e-06,
                    3.0081e-06,
                    3.0388e-06,
                    3.0709e-06,
                    3.107e-06,
                    3.1417e-06,
                    3.1773e-06,
                    3.2017e-06,
                    3.2329e-06,
                    3.2709e-06,
                    3.3088e-06,
                    3.3468e-06,
                    3.3897e-06,
                    3.4359e-06,
                    3.4821e-06,
                    3.5266e-06,
                    3.5761e-06,
                    3.6273e-06,
                    3.6766e-06,
                    3.7263e-06
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    3.0334e-09,
                    6.2816e-09,
                    1.3798e-08,
                    2.3192e-08,
                    3.5417e-08,
                    4.5571e-08,
                    5.5505e-08,
                    6.6136e-08,
                    7.7891e-08,
                    9.1062e-08,
                    1.0538e-07,
                    1.2209e-07,
                    1.4021e-07,
                    1.5713e-07,
                    1.7079e-07,
                    1.8745e-07,
                    1.9715e-07,
                    2.1283e-07,
                    2.3248e-07,
                    2.5531e-07,
                    2.8091e-07,
                    3.0992e-07,
                    3.3963e-07,
                    3.3963e-07,
                    3.7683e-07,
                    4.3551e-07,
                    4.694e-07,
                    5.0861e-07,
                    5.8793e-07,
                    6.5354e-07,
                    7.3839e-07,
                    7.9634e-07,
                    8.4711e-07,
                    9.1246e-07,
                    9.6865e-07,
                    1.0273e-06,
                    1.0917e-06,
                    1.1534e-06,
                    1.2134e-06,
                    1.2672e-06,
                    1.3175e-06,
                    1.3795e-06,
                    1.4371e-06,
                    1.5126e-06,
                    1.5969e-06,
                    1.6704e-06,
                    1.7416e-06,
                    1.8205e-06,
                    1.8921e-06,
                    1.944e-06,
                    2.0547e-06,
                    2.1126e-06,
                    2.1618e-06,
                    2.2135e-06,
                    2.2667e-06,
                    2.3173e-06,
                    2.374e-06,
                    2.4031e-06,
                    2.4758e-06,
                    2.5608e-06,
                    2.5772e-06,
                    2.5917e-06,
                    2.6059e-06,
                    2.6331e-06,
                    2.6622e-06,
                    2.6855e-06,
                    2.7046e-06,
                    2.7342e-06,
                    2.7625e-06,
                    2.7905e-06,
                    2.8168e-06,
                    2.8442e-06,
                    2.8457e-06,
                    2.8571e-06,
                    2.8872e-06,
                    2.9179e-06,
                    2.9474e-06,
                    2.977e-06,
                    3.0081e-06,
                    3.0388e-06,
                    3.0709e-06,
                    3.107e-06,
                    3.1417e-06,
                    3.1773e-06,
                    3.2017e-06,
                    3.2329e-06,
                    3.2709e-06,
                    3.3088e-06,
                    3.3468e-06,
                    3.3897e-06,
                    3.4359e-06,
                    3.4821e-06,
                    3.5266e-06,
                    3.5761e-06,
                    3.6273e-06,
                    3.6766e-06,
                    3.7263e-06
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": []
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -68.27932,
                            12.23615
                        ],
                        [
                            -68.38778,
                            12.31173
                        ],
                        [
                            -68.41039,
                            12.22743
                        ],
                        [
                            -68.32095,
                            12.21002
                        ],
                        [
                            -68.27636,
                            12.14559
                        ],
                        [
                            -68.28109,
                            12.05851
                        ],
                        [
                            -68.22509,
                            12.05078
                        ],
                        [
                            -68.19545,
                            12.13386
                        ],
                        [
                            -68.1989,
                            12.22213
                        ],
                        [
                            -68.27932,
                            12.23615
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "BIH",
                "Country": "Bosnia and Herzegovina",
                "Total_3GHG": 0.06,
                "Total_3GHG_timeseries": [
                    1.1289e-06,
                    2.2813e-06,
                    3.457e-06,
                    4.6104e-06,
                    5.7556e-06,
                    6.9184e-06,
                    8.0939e-06,
                    9.2623e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001
                ],
                "Fossil_3GHG": 0.06,
                "Fossil_3GHG_timeseries": [
                    9.7854e-08,
                    1.9624e-07,
                    2.9516e-07,
                    3.946e-07,
                    4.9457e-07,
                    5.9506e-07,
                    6.9606e-07,
                    7.9756e-07,
                    8.9958e-07,
                    1.0021e-06,
                    1.1078e-06,
                    1.2168e-06,
                    1.3291e-06,
                    1.4446e-06,
                    1.5633e-06,
                    1.6853e-06,
                    1.8105e-06,
                    1.9389e-06,
                    2.0705e-06,
                    2.2054e-06,
                    2.344e-06,
                    2.4863e-06,
                    2.6324e-06,
                    2.7823e-06,
                    2.9361e-06,
                    3.0936e-06,
                    3.2549e-06,
                    3.4201e-06,
                    3.5889e-06,
                    3.7615e-06,
                    3.9357e-06,
                    4.1114e-06,
                    4.2888e-06,
                    4.4677e-06,
                    4.6521e-06,
                    4.8342e-06,
                    5.0178e-06,
                    5.203e-06,
                    5.3897e-06,
                    5.5897e-06,
                    5.7932e-06,
                    5.9998e-06,
                    6.2196e-06,
                    6.465e-06,
                    6.712e-06,
                    6.9663e-06,
                    7.2099e-06,
                    7.4776e-06,
                    7.7578e-06,
                    8.0668e-06,
                    8.3684e-06,
                    8.6459e-06,
                    8.9148e-06,
                    9.1736e-06,
                    9.4228e-06,
                    9.6813e-06,
                    9.9237e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006
                ],
                "Land_3GHG": 0.06,
                "Land_3GHG_timeseries": [
                    1.031e-06,
                    2.085e-06,
                    3.1619e-06,
                    4.2158e-06,
                    5.261e-06,
                    6.3233e-06,
                    7.3979e-06,
                    8.4647e-06,
                    9.5055e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Total_CO2": 0.06,
                "Total_CO2_timeseries": [
                    8.1734e-07,
                    1.6562e-06,
                    2.5165e-06,
                    3.3523e-06,
                    4.1781e-06,
                    5.0196e-06,
                    5.8719e-06,
                    6.7152e-06,
                    7.5311e-06,
                    8.462e-06,
                    9.4148e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Fossil_CO2": 0.06,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2.0337e-09,
                    2.0337e-09,
                    2.0337e-09,
                    2.0337e-09,
                    2.0337e-09,
                    8.1343e-09,
                    1.5252e-08,
                    2.3132e-08,
                    3.7113e-08,
                    6.3804e-08,
                    9.0495e-08,
                    1.2024e-07,
                    1.4337e-07,
                    1.7845e-07,
                    2.1937e-07,
                    2.7479e-07,
                    3.3529e-07,
                    3.9197e-07,
                    4.5349e-07,
                    5.1907e-07,
                    5.9025e-07,
                    6.7541e-07,
                    7.6209e-07,
                    8.5538e-07,
                    9.5121e-07,
                    1.046e-06,
                    1.1487e-06,
                    1.254e-06,
                    1.543e-06,
                    1.543e-06,
                    1.543e-06,
                    1.543e-06,
                    1.543e-06,
                    1.543e-06,
                    1.7502e-06,
                    2.0252e-06,
                    2.318e-06,
                    2.7436e-06,
                    3.2077e-06,
                    3.6836e-06,
                    4.206e-06,
                    4.7146e-06,
                    5.2894e-06,
                    5.9423e-06,
                    6.6543e-06,
                    7.3244e-06,
                    7.9438e-06,
                    8.5085e-06,
                    9.0309e-06,
                    9.5748e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005
                ],
                "Land_CO2": 0.07,
                "Land_CO2_timeseries": [
                    8.1734e-07,
                    1.6562e-06,
                    2.5165e-06,
                    3.3523e-06,
                    4.1781e-06,
                    5.0196e-06,
                    5.8719e-06,
                    6.7152e-06,
                    7.5311e-06,
                    8.462e-06,
                    9.4148e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Total_CH4": 0.05,
                "Total_CH4_timeseries": [
                    2.8993e-07,
                    5.815e-07,
                    8.7471e-07,
                    1.1696e-06,
                    1.466e-06,
                    1.7641e-06,
                    2.0639e-06,
                    2.3653e-06,
                    2.6683e-06,
                    2.9729e-06,
                    3.2881e-06,
                    3.6137e-06,
                    3.9498e-06,
                    4.2964e-06,
                    4.6536e-06,
                    5.0212e-06,
                    5.3992e-06,
                    5.7878e-06,
                    6.1868e-06,
                    6.5963e-06,
                    7.0178e-06,
                    7.4514e-06,
                    7.8969e-06,
                    8.3545e-06,
                    8.8241e-06,
                    9.3056e-06,
                    9.7992e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_CH4": 0.06,
                "Fossil_CH4_timeseries": [
                    8.9032e-08,
                    1.7849e-07,
                    2.6838e-07,
                    3.5869e-07,
                    4.4943e-07,
                    5.4059e-07,
                    6.3218e-07,
                    7.2418e-07,
                    8.1661e-07,
                    9.0945e-07,
                    1.0055e-06,
                    1.1047e-06,
                    1.207e-06,
                    1.3126e-06,
                    1.4213e-06,
                    1.5331e-06,
                    1.6482e-06,
                    1.7664e-06,
                    1.8877e-06,
                    2.0122e-06,
                    2.1402e-06,
                    2.2719e-06,
                    2.4072e-06,
                    2.5461e-06,
                    2.6885e-06,
                    2.8345e-06,
                    2.9841e-06,
                    3.1373e-06,
                    3.294e-06,
                    3.4543e-06,
                    3.6161e-06,
                    3.7794e-06,
                    3.9442e-06,
                    4.1104e-06,
                    4.28e-06,
                    4.4492e-06,
                    4.6199e-06,
                    4.7921e-06,
                    4.9657e-06,
                    5.1462e-06,
                    5.3291e-06,
                    5.5143e-06,
                    5.7064e-06,
                    5.9112e-06,
                    6.1175e-06,
                    6.328e-06,
                    6.5342e-06,
                    6.7523e-06,
                    6.977e-06,
                    7.2158e-06,
                    7.4421e-06,
                    7.6477e-06,
                    7.8399e-06,
                    8.0175e-06,
                    8.1799e-06,
                    8.3373e-06,
                    8.4768e-06,
                    8.6026e-06,
                    8.7106e-06,
                    8.7926e-06,
                    8.8623e-06,
                    8.9148e-06,
                    9.0999e-06,
                    9.0083e-06,
                    8.8966e-06,
                    8.7617e-06,
                    8.6112e-06,
                    8.4293e-06,
                    8.3956e-06,
                    8.3845e-06,
                    8.3799e-06,
                    8.4729e-06,
                    8.5898e-06,
                    8.7077e-06,
                    8.8501e-06,
                    8.9624e-06,
                    9.4495e-06,
                    9.9936e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CH4": 0.05,
                "Land_CH4_timeseries": [
                    2.009e-07,
                    4.0301e-07,
                    6.0633e-07,
                    8.1086e-07,
                    1.0166e-06,
                    1.2236e-06,
                    1.4317e-06,
                    1.6411e-06,
                    1.8517e-06,
                    2.0635e-06,
                    2.2826e-06,
                    2.509e-06,
                    2.7428e-06,
                    2.9839e-06,
                    3.2323e-06,
                    3.488e-06,
                    3.7511e-06,
                    4.0214e-06,
                    4.2991e-06,
                    4.5842e-06,
                    4.8776e-06,
                    5.1795e-06,
                    5.4897e-06,
                    5.8084e-06,
                    6.1356e-06,
                    6.4711e-06,
                    6.8151e-06,
                    7.1674e-06,
                    7.5282e-06,
                    7.8975e-06,
                    8.2707e-06,
                    8.6479e-06,
                    9.0291e-06,
                    9.4143e-06,
                    9.8034e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_N2O": 0.04,
                "Total_N2O_timeseries": [
                    2.1598e-08,
                    4.3556e-08,
                    6.5861e-08,
                    8.8497e-08,
                    1.1144e-07,
                    1.3467e-07,
                    1.5814e-07,
                    1.8183e-07,
                    2.057e-07,
                    2.2969e-07,
                    2.5378e-07,
                    2.7795e-07,
                    3.0222e-07,
                    3.2656e-07,
                    3.5099e-07,
                    3.755e-07,
                    4.0009e-07,
                    4.2476e-07,
                    4.4953e-07,
                    4.744e-07,
                    4.9961e-07,
                    5.2559e-07,
                    5.5266e-07,
                    5.8104e-07,
                    6.1087e-07,
                    6.4216e-07,
                    6.7487e-07,
                    7.0881e-07,
                    7.4374e-07,
                    7.7929e-07,
                    8.1522e-07,
                    8.5149e-07,
                    8.8805e-07,
                    9.2487e-07,
                    9.6193e-07,
                    9.9923e-07,
                    1.0367e-06,
                    1.0745e-06,
                    1.1125e-06,
                    1.1535e-06,
                    1.1929e-06,
                    1.2306e-06,
                    1.2669e-06,
                    1.3019e-06,
                    1.3357e-06,
                    1.3684e-06,
                    1.4004e-06,
                    1.4318e-06,
                    1.463e-06,
                    1.4941e-06,
                    1.5255e-06,
                    1.5571e-06,
                    1.589e-06,
                    1.6213e-06,
                    1.6541e-06,
                    1.6873e-06,
                    1.721e-06,
                    1.7553e-06,
                    1.7901e-06,
                    1.8256e-06,
                    1.8621e-06,
                    1.9007e-06,
                    1.9421e-06,
                    1.9871e-06,
                    2.0362e-06,
                    2.0897e-06,
                    2.148e-06,
                    2.2112e-06,
                    2.2793e-06,
                    2.3523e-06,
                    2.4309e-06,
                    2.5166e-06,
                    2.6103e-06,
                    2.7127e-06,
                    2.8236e-06,
                    2.9427e-06,
                    3.069e-06,
                    3.2011e-06,
                    3.337e-06,
                    3.4745e-06,
                    3.6106e-06,
                    3.7426e-06,
                    3.8685e-06,
                    3.9869e-06,
                    4.0972e-06,
                    4.1993e-06,
                    4.2939e-06,
                    4.3825e-06,
                    4.467e-06,
                    4.5503e-06,
                    4.6384e-06,
                    4.7396e-06,
                    4.86e-06,
                    5.0039e-06,
                    5.1737e-06,
                    5.37e-06,
                    5.5913e-06,
                    5.8345e-06,
                    6.0944e-06,
                    6.364e-06,
                    6.6388e-06,
                    6.9184e-06,
                    7.2022e-06,
                    7.4901e-06,
                    7.7817e-06,
                    8.077e-06,
                    8.3759e-06,
                    8.6785e-06,
                    8.9849e-06,
                    9.2955e-06,
                    9.6325e-06,
                    9.9811e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_N2O": 0.03,
                "Fossil_N2O_timeseries": [
                    8.8217e-09,
                    1.7748e-08,
                    2.6778e-08,
                    3.5908e-08,
                    4.5138e-08,
                    5.4462e-08,
                    6.3879e-08,
                    7.3382e-08,
                    8.2968e-08,
                    9.2631e-08,
                    1.0237e-07,
                    1.1218e-07,
                    1.2206e-07,
                    1.3201e-07,
                    1.4204e-07,
                    1.5213e-07,
                    1.623e-07,
                    1.7254e-07,
                    1.8286e-07,
                    1.9324e-07,
                    2.0374e-07,
                    2.1438e-07,
                    2.2521e-07,
                    2.3626e-07,
                    2.4755e-07,
                    2.5907e-07,
                    2.7082e-07,
                    2.8277e-07,
                    2.9491e-07,
                    3.0718e-07,
                    3.1956e-07,
                    3.3204e-07,
                    3.4462e-07,
                    3.5729e-07,
                    3.7005e-07,
                    3.829e-07,
                    3.9584e-07,
                    4.0887e-07,
                    4.2199e-07,
                    4.3533e-07,
                    4.4879e-07,
                    4.6237e-07,
                    4.761e-07,
                    4.8995e-07,
                    5.0395e-07,
                    5.1808e-07,
                    5.3237e-07,
                    5.468e-07,
                    5.6139e-07,
                    5.7613e-07,
                    5.9105e-07,
                    6.0615e-07,
                    6.2146e-07,
                    6.3696e-07,
                    6.5268e-07,
                    6.6862e-07,
                    6.8476e-07,
                    7.0111e-07,
                    7.1765e-07,
                    7.3436e-07,
                    7.5125e-07,
                    7.6829e-07,
                    7.8549e-07,
                    8.0284e-07,
                    8.2035e-07,
                    8.3801e-07,
                    8.5582e-07,
                    8.7378e-07,
                    8.9191e-07,
                    9.1021e-07,
                    9.2868e-07,
                    9.4733e-07,
                    9.6619e-07,
                    9.8524e-07,
                    1.0045e-06,
                    1.024e-06,
                    1.0436e-06,
                    1.0635e-06,
                    1.0836e-06,
                    1.1038e-06,
                    1.1243e-06,
                    1.1449e-06,
                    1.1657e-06,
                    1.1866e-06,
                    1.2077e-06,
                    1.229e-06,
                    1.2506e-06,
                    1.2723e-06,
                    1.2943e-06,
                    1.3165e-06,
                    1.3391e-06,
                    1.3624e-06,
                    1.3865e-06,
                    1.4116e-06,
                    1.4378e-06,
                    1.4651e-06,
                    1.4936e-06,
                    1.5232e-06,
                    1.5538e-06,
                    1.5855e-06,
                    1.618e-06,
                    1.6513e-06,
                    1.6856e-06,
                    1.7209e-06,
                    1.7572e-06,
                    1.7945e-06,
                    1.8331e-06,
                    1.8728e-06,
                    1.9139e-06,
                    1.9566e-06,
                    2.0007e-06,
                    2.0463e-06,
                    2.0936e-06,
                    2.1428e-06,
                    2.1941e-06,
                    2.2479e-06,
                    2.3048e-06,
                    2.3654e-06,
                    2.4304e-06,
                    2.4966e-06,
                    2.5638e-06,
                    2.6257e-06,
                    2.6908e-06,
                    2.7607e-06,
                    2.8311e-06,
                    2.9013e-06,
                    2.9741e-06,
                    3.0484e-06,
                    3.1236e-06,
                    3.1972e-06,
                    3.2784e-06,
                    3.362e-06,
                    3.4475e-06,
                    3.5346e-06,
                    3.6261e-06,
                    3.7232e-06,
                    3.8141e-06,
                    3.9043e-06,
                    3.9972e-06,
                    4.0917e-06,
                    4.1788e-06,
                    4.2634e-06,
                    4.3425e-06,
                    4.3922e-06,
                    4.4429e-06,
                    4.4974e-06,
                    4.5655e-06,
                    4.6411e-06,
                    4.7148e-06,
                    4.8091e-06,
                    4.9029e-06,
                    4.9987e-06,
                    5.0936e-06,
                    5.192e-06,
                    5.2922e-06,
                    5.4005e-06,
                    5.511e-06,
                    5.6281e-06,
                    5.7426e-06,
                    5.8554e-06,
                    5.9779e-06,
                    6.0936e-06,
                    6.2118e-06,
                    6.3197e-06,
                    6.4325e-06,
                    6.555e-06,
                    6.6748e-06,
                    6.8119e-06,
                    6.9467e-06,
                    7.0834e-06,
                    7.2101e-06,
                    7.3379e-06
                ],
                "Land_N2O": 0.05,
                "Land_N2O_timeseries": [
                    1.2776e-08,
                    2.5807e-08,
                    3.9083e-08,
                    5.2589e-08,
                    6.6304e-08,
                    8.0206e-08,
                    9.4266e-08,
                    1.0845e-07,
                    1.2273e-07,
                    1.3706e-07,
                    1.5141e-07,
                    1.6578e-07,
                    1.8016e-07,
                    1.9455e-07,
                    2.0895e-07,
                    2.2336e-07,
                    2.3778e-07,
                    2.5222e-07,
                    2.6667e-07,
                    2.8115e-07,
                    2.9588e-07,
                    3.1121e-07,
                    3.2745e-07,
                    3.4478e-07,
                    3.6332e-07,
                    3.831e-07,
                    4.0405e-07,
                    4.2604e-07,
                    4.4883e-07,
                    4.7211e-07,
                    4.9566e-07,
                    5.1945e-07,
                    5.4343e-07,
                    5.6758e-07,
                    5.9188e-07,
                    6.1633e-07,
                    6.4091e-07,
                    6.6565e-07,
                    6.9055e-07,
                    7.1821e-07,
                    7.4409e-07,
                    7.6827e-07,
                    7.9084e-07,
                    8.1194e-07,
                    8.3171e-07,
                    8.5035e-07,
                    8.6805e-07,
                    8.8504e-07,
                    9.016e-07,
                    9.1801e-07,
                    9.3444e-07,
                    9.5094e-07,
                    9.6757e-07,
                    9.8437e-07,
                    1.0014e-06,
                    1.0187e-06,
                    1.0362e-06,
                    1.0542e-06,
                    1.0725e-06,
                    1.0912e-06,
                    1.1109e-06,
                    1.1324e-06,
                    1.1567e-06,
                    1.1843e-06,
                    1.2158e-06,
                    1.2517e-06,
                    1.2921e-06,
                    1.3374e-06,
                    1.3874e-06,
                    1.4421e-06,
                    1.5022e-06,
                    1.5692e-06,
                    1.6442e-06,
                    1.7274e-06,
                    1.8191e-06,
                    1.9187e-06,
                    2.0253e-06,
                    2.1375e-06,
                    2.2534e-06,
                    2.3707e-06,
                    2.4864e-06,
                    2.5978e-06,
                    2.7029e-06,
                    2.8003e-06,
                    2.8894e-06,
                    2.9702e-06,
                    3.0434e-06,
                    3.1102e-06,
                    3.1728e-06,
                    3.2338e-06,
                    3.2993e-06,
                    3.3772e-06,
                    3.4735e-06,
                    3.5923e-06,
                    3.7359e-06,
                    3.9049e-06,
                    4.0978e-06,
                    4.3114e-06,
                    4.5406e-06,
                    4.7786e-06,
                    5.0209e-06,
                    5.267e-06,
                    5.5166e-06,
                    5.7692e-06,
                    6.0245e-06,
                    6.2825e-06,
                    6.5429e-06,
                    6.8057e-06,
                    7.071e-06,
                    7.3389e-06,
                    7.6319e-06,
                    7.9347e-06,
                    8.2268e-06,
                    8.5198e-06,
                    8.8142e-06,
                    9.1268e-06,
                    9.4485e-06,
                    9.7829e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            19.22407,
                            43.52754
                        ],
                        [
                            19.27216,
                            43.59636
                        ],
                        [
                            19.36839,
                            43.60998
                        ],
                        [
                            19.47925,
                            43.57225
                        ],
                        [
                            19.5259,
                            43.6502
                        ],
                        [
                            19.51799,
                            43.71422
                        ],
                        [
                            19.39561,
                            43.79835
                        ],
                        [
                            19.23652,
                            43.98839
                        ],
                        [
                            19.3863,
                            43.96091
                        ],
                        [
                            19.52783,
                            43.95697
                        ],
                        [
                            19.61717,
                            44.01367
                        ],
                        [
                            19.59908,
                            44.07014
                        ],
                        [
                            19.35917,
                            44.18467
                        ],
                        [
                            19.32531,
                            44.27088
                        ],
                        [
                            19.24272,
                            44.26167
                        ],
                        [
                            19.13281,
                            44.31671
                        ],
                        [
                            19.10302,
                            44.37237
                        ],
                        [
                            19.14889,
                            44.43714
                        ],
                        [
                            19.12346,
                            44.49957
                        ],
                        [
                            19.16625,
                            44.52386
                        ],
                        [
                            19.29799,
                            44.68766
                        ],
                        [
                            19.30555,
                            44.79419
                        ],
                        [
                            19.36707,
                            44.87966
                        ],
                        [
                            19.31033,
                            44.90767
                        ],
                        [
                            19.17159,
                            44.92054
                        ],
                        [
                            19.02207,
                            44.85535
                        ],
                        [
                            18.8502,
                            44.85456
                        ],
                        [
                            18.76544,
                            44.90432
                        ],
                        [
                            18.80379,
                            44.93927
                        ],
                        [
                            18.71743,
                            45.03527
                        ],
                        [
                            18.58532,
                            45.09199
                        ],
                        [
                            18.47766,
                            45.06231
                        ],
                        [
                            18.41767,
                            45.10964
                        ],
                        [
                            18.32088,
                            45.10186
                        ],
                        [
                            18.23625,
                            45.13603
                        ],
                        [
                            18.1935,
                            45.07803
                        ],
                        [
                            18.11832,
                            45.08076
                        ],
                        [
                            18.05983,
                            45.14336
                        ],
                        [
                            17.98645,
                            45.14438
                        ],
                        [
                            17.93573,
                            45.08125
                        ],
                        [
                            17.83395,
                            45.04812
                        ],
                        [
                            17.67581,
                            45.13138
                        ],
                        [
                            17.59274,
                            45.10693
                        ],
                        [
                            17.3395,
                            45.14477
                        ],
                        [
                            17.16432,
                            45.15164
                        ],
                        [
                            16.98433,
                            45.22938
                        ],
                        [
                            16.93253,
                            45.27516
                        ],
                        [
                            16.79863,
                            45.18674
                        ],
                        [
                            16.59828,
                            45.23107
                        ],
                        [
                            16.49162,
                            45.208
                        ],
                        [
                            16.47823,
                            45.16167
                        ],
                        [
                            16.39468,
                            45.11215
                        ],
                        [
                            16.35303,
                            45.00302
                        ],
                        [
                            16.28903,
                            44.99654
                        ],
                        [
                            16.19368,
                            45.0316
                        ],
                        [
                            16.10885,
                            45.09329
                        ],
                        [
                            16.02944,
                            45.19983
                        ],
                        [
                            15.84002,
                            45.22447
                        ],
                        [
                            15.76533,
                            45.16462
                        ],
                        [
                            15.79039,
                            45.11557
                        ],
                        [
                            15.75199,
                            45.05328
                        ],
                        [
                            15.78452,
                            44.99517
                        ],
                        [
                            15.74041,
                            44.93236
                        ],
                        [
                            15.76116,
                            44.8692
                        ],
                        [
                            15.72976,
                            44.8245
                        ],
                        [
                            15.78245,
                            44.74969
                        ],
                        [
                            15.87821,
                            44.729
                        ],
                        [
                            16.05464,
                            44.62326
                        ],
                        [
                            16.01997,
                            44.56369
                        ],
                        [
                            16.10914,
                            44.5256
                        ],
                        [
                            16.14046,
                            44.4796
                        ],
                        [
                            16.12957,
                            44.39518
                        ],
                        [
                            16.21759,
                            44.3488
                        ],
                        [
                            16.18827,
                            44.30586
                        ],
                        [
                            16.2111,
                            44.21784
                        ],
                        [
                            16.44215,
                            44.02879
                        ],
                        [
                            16.50224,
                            44.02437
                        ],
                        [
                            16.54976,
                            43.9552
                        ],
                        [
                            16.70889,
                            43.85573
                        ],
                        [
                            16.75159,
                            43.77136
                        ],
                        [
                            16.80065,
                            43.76273
                        ],
                        [
                            17.00961,
                            43.57513
                        ],
                        [
                            17.15213,
                            43.49487
                        ],
                        [
                            17.26744,
                            43.47911
                        ],
                        [
                            17.25154,
                            43.40224
                        ],
                        [
                            17.34191,
                            43.25392
                        ],
                        [
                            17.42159,
                            43.23007
                        ],
                        [
                            17.43067,
                            43.18033
                        ],
                        [
                            17.64027,
                            43.08967
                        ],
                        [
                            17.71095,
                            42.97308
                        ],
                        [
                            17.58134,
                            42.93842
                        ],
                        [
                            17.64916,
                            42.88892
                        ],
                        [
                            17.67781,
                            42.91985
                        ],
                        [
                            17.79109,
                            42.89257
                        ],
                        [
                            17.84165,
                            42.90353
                        ],
                        [
                            17.8885,
                            42.81694
                        ],
                        [
                            17.94929,
                            42.79898
                        ],
                        [
                            18.10315,
                            42.71336
                        ],
                        [
                            18.24622,
                            42.60288
                        ],
                        [
                            18.36668,
                            42.6155
                        ],
                        [
                            18.4381,
                            42.5557
                        ],
                        [
                            18.57397,
                            42.64547
                        ],
                        [
                            18.53105,
                            42.72438
                        ],
                        [
                            18.47289,
                            42.75783
                        ],
                        [
                            18.451,
                            42.81533
                        ],
                        [
                            18.50805,
                            42.88678
                        ],
                        [
                            18.48979,
                            42.98646
                        ],
                        [
                            18.54203,
                            43.02923
                        ],
                        [
                            18.66078,
                            43.03707
                        ],
                        [
                            18.64885,
                            43.14649
                        ],
                        [
                            18.73627,
                            43.28226
                        ],
                        [
                            18.91586,
                            43.35839
                        ],
                        [
                            18.95514,
                            43.28999
                        ],
                        [
                            19.01355,
                            43.25242
                        ],
                        [
                            19.08499,
                            43.32153
                        ],
                        [
                            19.01814,
                            43.42969
                        ],
                        [
                            18.9564,
                            43.49018
                        ],
                        [
                            19.15582,
                            43.53548
                        ],
                        [
                            19.22407,
                            43.52754
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "BWA",
                "Country": "Botswana",
                "Total_3GHG": 0.04,
                "Total_3GHG_timeseries": [
                    2.6225e-07,
                    5.2885e-07,
                    7.9959e-07,
                    1.0743e-06,
                    1.3527e-06,
                    1.6348e-06,
                    1.9202e-06,
                    2.2088e-06,
                    2.5004e-06,
                    2.7957e-06,
                    3.0952e-06,
                    3.3986e-06,
                    3.7057e-06,
                    4.0164e-06,
                    4.3305e-06,
                    4.648e-06,
                    4.9687e-06,
                    5.2927e-06,
                    5.6199e-06,
                    5.9531e-06,
                    6.2934e-06,
                    6.6421e-06,
                    7.0004e-06,
                    7.3689e-06,
                    7.748e-06,
                    8.1378e-06,
                    8.5377e-06,
                    8.947e-06,
                    9.3644e-06,
                    9.7895e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Fossil_3GHG": 0.01,
                "Fossil_3GHG_timeseries": [
                    6.9748e-09,
                    1.412e-08,
                    2.1437e-08,
                    2.893e-08,
                    3.6602e-08,
                    4.4456e-08,
                    5.2493e-08,
                    6.0717e-08,
                    6.9131e-08,
                    7.7738e-08,
                    8.6549e-08,
                    9.5569e-08,
                    1.048e-07,
                    1.1425e-07,
                    1.2393e-07,
                    1.3382e-07,
                    1.4395e-07,
                    1.5432e-07,
                    1.6493e-07,
                    1.7578e-07,
                    1.8685e-07,
                    1.9816e-07,
                    2.0971e-07,
                    2.2151e-07,
                    2.3357e-07,
                    2.4589e-07,
                    2.5847e-07,
                    2.7131e-07,
                    2.8441e-07,
                    2.9776e-07,
                    3.1139e-07,
                    3.2529e-07,
                    3.3948e-07,
                    3.5395e-07,
                    3.687e-07,
                    3.8375e-07,
                    3.9908e-07,
                    4.1472e-07,
                    4.3065e-07,
                    4.4691e-07,
                    4.6353e-07,
                    4.8051e-07,
                    4.9786e-07,
                    5.1558e-07,
                    5.3368e-07,
                    5.5216e-07,
                    5.7103e-07,
                    5.9029e-07,
                    6.0995e-07,
                    6.3076e-07,
                    6.523e-07,
                    6.7458e-07,
                    6.9764e-07,
                    7.215e-07,
                    7.464e-07,
                    7.722e-07,
                    7.9894e-07,
                    8.2666e-07,
                    8.5539e-07,
                    8.8517e-07,
                    9.1222e-07,
                    9.4128e-07,
                    9.725e-07,
                    1.0061e-06,
                    1.0421e-06,
                    1.0796e-06,
                    1.1185e-06,
                    1.1589e-06,
                    1.2008e-06,
                    1.2437e-06,
                    1.2802e-06,
                    1.3203e-06,
                    1.3642e-06,
                    1.4122e-06,
                    1.4646e-06,
                    1.5192e-06,
                    1.5759e-06,
                    1.6349e-06,
                    1.6961e-06,
                    1.7596e-06,
                    1.8142e-06,
                    1.8739e-06,
                    1.9394e-06,
                    2.0111e-06,
                    2.0896e-06,
                    2.1694e-06,
                    2.2518e-06,
                    2.3367e-06,
                    2.427e-06,
                    2.5228e-06,
                    2.6307e-06,
                    2.7416e-06,
                    2.8555e-06,
                    2.9723e-06,
                    3.0909e-06,
                    3.1913e-06,
                    3.3006e-06,
                    3.4194e-06,
                    3.5481e-06,
                    3.6872e-06,
                    3.8397e-06,
                    3.9876e-06,
                    4.1298e-06,
                    4.2654e-06,
                    4.3933e-06,
                    4.5194e-06,
                    4.6422e-06,
                    4.7613e-06,
                    4.8741e-06,
                    4.9801e-06,
                    5.0802e-06,
                    5.1741e-06,
                    5.2617e-06,
                    5.3426e-06,
                    5.4168e-06,
                    5.5052e-06,
                    5.5819e-06,
                    5.6462e-06,
                    5.6974e-06,
                    5.8064e-06,
                    5.9148e-06,
                    6.0506e-06,
                    6.2238e-06,
                    6.4387e-06,
                    6.7454e-06,
                    7.3831e-06,
                    8.1829e-06,
                    9.04e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_3GHG": 0.1,
                "Land_3GHG_timeseries": [
                    2.5527e-07,
                    5.1473e-07,
                    7.7816e-07,
                    1.0454e-06,
                    1.3161e-06,
                    1.5903e-06,
                    1.8677e-06,
                    2.1481e-06,
                    2.4313e-06,
                    2.718e-06,
                    3.0087e-06,
                    3.3031e-06,
                    3.6009e-06,
                    3.9022e-06,
                    4.2066e-06,
                    4.5141e-06,
                    4.8248e-06,
                    5.1384e-06,
                    5.455e-06,
                    5.7773e-06,
                    6.1065e-06,
                    6.444e-06,
                    6.7907e-06,
                    7.1474e-06,
                    7.5145e-06,
                    7.8919e-06,
                    8.2793e-06,
                    8.6757e-06,
                    9.08e-06,
                    9.4917e-06,
                    9.9107e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006
                ],
                "Total_CO2": 0.03,
                "Total_CO2_timeseries": [
                    8.6367e-08,
                    1.7397e-07,
                    2.6264e-07,
                    3.5226e-07,
                    4.4274e-07,
                    5.3402e-07,
                    6.2603e-07,
                    7.1872e-07,
                    8.1205e-07,
                    9.0693e-07,
                    1.0036e-06,
                    1.1019e-06,
                    1.2015e-06,
                    1.3024e-06,
                    1.4043e-06,
                    1.5073e-06,
                    1.6112e-06,
                    1.716e-06,
                    1.8216e-06,
                    1.9308e-06,
                    2.0432e-06,
                    2.1582e-06,
                    2.2756e-06,
                    2.3952e-06,
                    2.5167e-06,
                    2.64e-06,
                    2.765e-06,
                    2.8915e-06,
                    3.0195e-06,
                    3.1499e-06,
                    3.2831e-06,
                    3.4188e-06,
                    3.557e-06,
                    3.6973e-06,
                    3.8397e-06,
                    3.984e-06,
                    4.13e-06,
                    4.2777e-06,
                    4.4269e-06,
                    4.5811e-06,
                    4.74e-06,
                    4.9029e-06,
                    5.0694e-06,
                    5.2392e-06,
                    5.412e-06,
                    5.5883e-06,
                    5.7685e-06,
                    5.953e-06,
                    6.1427e-06,
                    6.3432e-06,
                    6.5579e-06,
                    6.7827e-06,
                    7.0208e-06,
                    7.2754e-06,
                    7.5419e-06,
                    7.8282e-06,
                    8.1303e-06,
                    8.4436e-06,
                    8.7779e-06,
                    9.1302e-06,
                    9.5029e-06,
                    9.8932e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_CO2": 0.01,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    9.9e-09,
                    3.3e-08,
                    7.26e-08,
                    1.5675e-07,
                    4.2405e-07,
                    7.755e-07,
                    1.15e-06,
                    1.5741e-06,
                    2.0179e-06,
                    2.4717e-06,
                    2.9667e-06,
                    3.4304e-06,
                    3.9006e-06,
                    4.422e-06,
                    4.9022e-06,
                    5.4598e-06,
                    6.0456e-06,
                    6.6891e-06,
                    7.9052e-06,
                    9.0915e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CO2": 0.06,
                "Land_CO2_timeseries": [
                    8.6367e-08,
                    1.7397e-07,
                    2.6264e-07,
                    3.5226e-07,
                    4.4274e-07,
                    5.3402e-07,
                    6.2603e-07,
                    7.1872e-07,
                    8.1205e-07,
                    9.0693e-07,
                    1.0036e-06,
                    1.1019e-06,
                    1.2015e-06,
                    1.3024e-06,
                    1.4043e-06,
                    1.5073e-06,
                    1.6112e-06,
                    1.716e-06,
                    1.8216e-06,
                    1.9308e-06,
                    2.0432e-06,
                    2.1582e-06,
                    2.2756e-06,
                    2.3952e-06,
                    2.5167e-06,
                    2.64e-06,
                    2.765e-06,
                    2.8915e-06,
                    3.0195e-06,
                    3.1499e-06,
                    3.2831e-06,
                    3.4188e-06,
                    3.557e-06,
                    3.6973e-06,
                    3.8397e-06,
                    3.984e-06,
                    4.13e-06,
                    4.2777e-06,
                    4.4269e-06,
                    4.5811e-06,
                    4.74e-06,
                    4.9029e-06,
                    5.0694e-06,
                    5.2392e-06,
                    5.412e-06,
                    5.5883e-06,
                    5.7685e-06,
                    5.953e-06,
                    6.1427e-06,
                    6.3432e-06,
                    6.5579e-06,
                    6.7827e-06,
                    7.0208e-06,
                    7.2754e-06,
                    7.5419e-06,
                    7.8282e-06,
                    8.1303e-06,
                    8.4436e-06,
                    8.7779e-06,
                    9.1302e-06,
                    9.5029e-06,
                    9.8932e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Total_CH4": 0.07,
                "Total_CH4_timeseries": [
                    1.1304e-07,
                    2.2795e-07,
                    3.4473e-07,
                    4.6338e-07,
                    5.839e-07,
                    7.063e-07,
                    8.3059e-07,
                    9.5676e-07,
                    1.0848e-06,
                    1.2148e-06,
                    1.347e-06,
                    1.4815e-06,
                    1.6182e-06,
                    1.7573e-06,
                    1.8986e-06,
                    2.0422e-06,
                    2.188e-06,
                    2.3362e-06,
                    2.4867e-06,
                    2.6395e-06,
                    2.795e-06,
                    2.9532e-06,
                    3.1142e-06,
                    3.278e-06,
                    3.4445e-06,
                    3.6137e-06,
                    3.7857e-06,
                    3.9604e-06,
                    4.1379e-06,
                    4.3182e-06,
                    4.5019e-06,
                    4.689e-06,
                    4.8796e-06,
                    5.0736e-06,
                    5.2711e-06,
                    5.472e-06,
                    5.6763e-06,
                    5.8842e-06,
                    6.0954e-06,
                    6.3102e-06,
                    6.5294e-06,
                    6.753e-06,
                    6.981e-06,
                    7.2136e-06,
                    7.4505e-06,
                    7.692e-06,
                    7.9378e-06,
                    8.1882e-06,
                    8.443e-06,
                    8.7031e-06,
                    8.9656e-06,
                    9.2308e-06,
                    9.4984e-06,
                    9.7687e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_CH4": 0.02,
                "Fossil_CH4_timeseries": [
                    6.3618e-09,
                    1.2884e-08,
                    1.9569e-08,
                    2.642e-08,
                    3.3442e-08,
                    4.0637e-08,
                    4.8009e-08,
                    5.5562e-08,
                    6.3299e-08,
                    7.1226e-08,
                    7.9354e-08,
                    8.7688e-08,
                    9.6233e-08,
                    1.0499e-07,
                    1.1397e-07,
                    1.2317e-07,
                    1.3261e-07,
                    1.4227e-07,
                    1.5217e-07,
                    1.6232e-07,
                    1.7268e-07,
                    1.8324e-07,
                    1.9402e-07,
                    2.0502e-07,
                    2.1624e-07,
                    2.2768e-07,
                    2.3934e-07,
                    2.5123e-07,
                    2.6335e-07,
                    2.7571e-07,
                    2.8833e-07,
                    3.0122e-07,
                    3.1438e-07,
                    3.2782e-07,
                    3.4153e-07,
                    3.5553e-07,
                    3.6982e-07,
                    3.8439e-07,
                    3.9926e-07,
                    4.1443e-07,
                    4.2994e-07,
                    4.458e-07,
                    4.6201e-07,
                    4.7858e-07,
                    4.9551e-07,
                    5.128e-07,
                    5.3047e-07,
                    5.4851e-07,
                    5.6694e-07,
                    5.8649e-07,
                    6.0674e-07,
                    6.2772e-07,
                    6.4944e-07,
                    6.7194e-07,
                    6.9544e-07,
                    7.1981e-07,
                    7.451e-07,
                    7.7133e-07,
                    7.9854e-07,
                    8.2678e-07,
                    8.5227e-07,
                    8.7974e-07,
                    9.0935e-07,
                    9.4127e-07,
                    9.7568e-07,
                    1.0115e-06,
                    1.0487e-06,
                    1.0874e-06,
                    1.1276e-06,
                    1.1687e-06,
                    1.2035e-06,
                    1.2418e-06,
                    1.2838e-06,
                    1.33e-06,
                    1.3805e-06,
                    1.4332e-06,
                    1.488e-06,
                    1.5451e-06,
                    1.6044e-06,
                    1.6659e-06,
                    1.7184e-06,
                    1.7761e-06,
                    1.8394e-06,
                    1.9089e-06,
                    1.9852e-06,
                    2.0626e-06,
                    2.1425e-06,
                    2.2249e-06,
                    2.3126e-06,
                    2.4057e-06,
                    2.5107e-06,
                    2.6187e-06,
                    2.7294e-06,
                    2.8427e-06,
                    2.9578e-06,
                    3.0543e-06,
                    3.1596e-06,
                    3.2741e-06,
                    3.3983e-06,
                    3.5329e-06,
                    3.6806e-06,
                    3.8237e-06,
                    3.961e-06,
                    4.0915e-06,
                    4.2141e-06,
                    4.3349e-06,
                    4.4522e-06,
                    4.5658e-06,
                    4.6729e-06,
                    4.7731e-06,
                    4.8672e-06,
                    4.955e-06,
                    5.0362e-06,
                    5.1104e-06,
                    5.1777e-06,
                    5.2587e-06,
                    5.3278e-06,
                    5.3841e-06,
                    5.4269e-06,
                    5.5254e-06,
                    5.6231e-06,
                    5.7376e-06,
                    5.8755e-06,
                    6.0377e-06,
                    6.2467e-06,
                    6.6027e-06,
                    7.0358e-06,
                    7.5023e-06,
                    8.0262e-06,
                    8.5813e-06,
                    9.2825e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CH4": 0.14,
                "Land_CH4_timeseries": [
                    1.0668e-07,
                    2.1507e-07,
                    3.2516e-07,
                    4.3696e-07,
                    5.5046e-07,
                    6.6567e-07,
                    7.8258e-07,
                    9.012e-07,
                    1.0215e-06,
                    1.1435e-06,
                    1.2676e-06,
                    1.3938e-06,
                    1.522e-06,
                    1.6523e-06,
                    1.7846e-06,
                    1.919e-06,
                    2.0554e-06,
                    2.194e-06,
                    2.3345e-06,
                    2.4772e-06,
                    2.6223e-06,
                    2.77e-06,
                    2.9202e-06,
                    3.073e-06,
                    3.2282e-06,
                    3.386e-06,
                    3.5464e-06,
                    3.7092e-06,
                    3.8746e-06,
                    4.0425e-06,
                    4.2136e-06,
                    4.3878e-06,
                    4.5652e-06,
                    4.7458e-06,
                    4.9295e-06,
                    5.1164e-06,
                    5.3065e-06,
                    5.4998e-06,
                    5.6962e-06,
                    5.8958e-06,
                    6.0994e-06,
                    6.3072e-06,
                    6.519e-06,
                    6.735e-06,
                    6.955e-06,
                    7.1792e-06,
                    7.4074e-06,
                    7.6397e-06,
                    7.8761e-06,
                    8.1166e-06,
                    8.3589e-06,
                    8.603e-06,
                    8.849e-06,
                    9.0968e-06,
                    9.3464e-06,
                    9.5978e-06,
                    9.8511e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Total_N2O": 0.16,
                "Total_N2O_timeseries": [
                    6.2837e-08,
                    1.2693e-07,
                    1.9222e-07,
                    2.5864e-07,
                    3.2609e-07,
                    3.9445e-07,
                    4.636e-07,
                    5.3336e-07,
                    6.0357e-07,
                    6.7403e-07,
                    7.4461e-07,
                    8.1528e-07,
                    8.8602e-07,
                    9.5681e-07,
                    1.0276e-06,
                    1.0985e-06,
                    1.1695e-06,
                    1.2405e-06,
                    1.3116e-06,
                    1.3828e-06,
                    1.4552e-06,
                    1.5307e-06,
                    1.6105e-06,
                    1.6957e-06,
                    1.7868e-06,
                    1.884e-06,
                    1.987e-06,
                    2.0951e-06,
                    2.207e-06,
                    2.3214e-06,
                    2.4371e-06,
                    2.554e-06,
                    2.6718e-06,
                    2.7905e-06,
                    2.9099e-06,
                    3.03e-06,
                    3.1508e-06,
                    3.2723e-06,
                    3.3947e-06,
                    3.5234e-06,
                    3.6534e-06,
                    3.7847e-06,
                    3.9173e-06,
                    4.0513e-06,
                    4.1868e-06,
                    4.3237e-06,
                    4.4622e-06,
                    4.6024e-06,
                    4.7441e-06,
                    4.8876e-06,
                    5.0327e-06,
                    5.1794e-06,
                    5.3277e-06,
                    5.4776e-06,
                    5.6292e-06,
                    5.7828e-06,
                    5.9384e-06,
                    6.0964e-06,
                    6.2571e-06,
                    6.4209e-06,
                    6.5892e-06,
                    6.7643e-06,
                    6.9481e-06,
                    7.1421e-06,
                    7.3473e-06,
                    7.5643e-06,
                    7.7935e-06,
                    8.0346e-06,
                    8.2873e-06,
                    8.5504e-06,
                    8.8243e-06,
                    9.1103e-06,
                    9.4091e-06,
                    9.721e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_N2O": 0.01,
                "Fossil_N2O_timeseries": [
                    6.1296e-10,
                    1.2359e-09,
                    1.8685e-09,
                    2.5103e-09,
                    3.1607e-09,
                    3.8189e-09,
                    4.4842e-09,
                    5.1556e-09,
                    5.8319e-09,
                    6.512e-09,
                    7.1951e-09,
                    7.8809e-09,
                    8.5694e-09,
                    9.2604e-09,
                    9.9539e-09,
                    1.065e-08,
                    1.1348e-08,
                    1.205e-08,
                    1.2754e-08,
                    1.3461e-08,
                    1.4177e-08,
                    1.4915e-08,
                    1.5682e-08,
                    1.6484e-08,
                    1.7326e-08,
                    1.8207e-08,
                    1.9126e-08,
                    2.0079e-08,
                    2.1058e-08,
                    2.2054e-08,
                    2.3061e-08,
                    2.4077e-08,
                    2.5101e-08,
                    2.6133e-08,
                    2.7171e-08,
                    2.8216e-08,
                    2.9268e-08,
                    3.0326e-08,
                    3.1392e-08,
                    3.2486e-08,
                    3.3593e-08,
                    3.4715e-08,
                    3.5851e-08,
                    3.7002e-08,
                    3.817e-08,
                    3.9353e-08,
                    4.0555e-08,
                    4.1774e-08,
                    4.3013e-08,
                    4.4272e-08,
                    4.5553e-08,
                    4.686e-08,
                    4.8195e-08,
                    4.9561e-08,
                    5.0957e-08,
                    5.2385e-08,
                    5.3844e-08,
                    5.5333e-08,
                    5.6849e-08,
                    5.839e-08,
                    5.9955e-08,
                    6.1541e-08,
                    6.3148e-08,
                    6.4777e-08,
                    6.6426e-08,
                    6.8095e-08,
                    6.9785e-08,
                    7.1496e-08,
                    7.3228e-08,
                    7.4981e-08,
                    7.6756e-08,
                    7.8554e-08,
                    8.0373e-08,
                    8.2216e-08,
                    8.408e-08,
                    8.5968e-08,
                    8.7878e-08,
                    8.9813e-08,
                    9.1771e-08,
                    9.3753e-08,
                    9.5768e-08,
                    9.7831e-08,
                    9.9954e-08,
                    1.0215e-07,
                    1.0442e-07,
                    1.0679e-07,
                    1.0924e-07,
                    1.1178e-07,
                    1.1441e-07,
                    1.1714e-07,
                    1.1997e-07,
                    1.2296e-07,
                    1.2614e-07,
                    1.2952e-07,
                    1.3313e-07,
                    1.3697e-07,
                    1.4103e-07,
                    1.4529e-07,
                    1.4974e-07,
                    1.5433e-07,
                    1.5906e-07,
                    1.639e-07,
                    1.6887e-07,
                    1.7396e-07,
                    1.7916e-07,
                    1.8449e-07,
                    1.8993e-07,
                    1.955e-07,
                    2.0119e-07,
                    2.07e-07,
                    2.1296e-07,
                    2.1912e-07,
                    2.2551e-07,
                    2.3217e-07,
                    2.3913e-07,
                    2.4642e-07,
                    2.5408e-07,
                    2.6212e-07,
                    2.7057e-07,
                    2.8101e-07,
                    2.9174e-07,
                    3.0307e-07,
                    3.1534e-07,
                    3.2832e-07,
                    3.4195e-07,
                    3.5638e-07,
                    3.7162e-07,
                    3.8763e-07,
                    4.0526e-07,
                    4.2332e-07,
                    4.4551e-07,
                    4.8131e-07,
                    5.1957e-07,
                    5.5768e-07,
                    5.8942e-07,
                    6.2371e-07,
                    6.6391e-07,
                    7.1848e-07,
                    7.6144e-07,
                    8.0487e-07,
                    8.4873e-07,
                    8.9706e-07,
                    9.4561e-07,
                    9.9436e-07,
                    1.0451e-06,
                    1.0942e-06,
                    1.1448e-06,
                    1.1997e-06,
                    1.2577e-06,
                    1.3159e-06,
                    1.3769e-06,
                    1.4361e-06,
                    1.495e-06,
                    1.5506e-06,
                    1.6084e-06,
                    1.6669e-06,
                    1.7257e-06,
                    1.7879e-06,
                    1.8484e-06,
                    1.9058e-06,
                    1.9677e-06,
                    2.0325e-06,
                    2.1034e-06,
                    2.1816e-06,
                    2.2613e-06,
                    2.3414e-06,
                    2.4253e-06,
                    2.5124e-06,
                    2.5978e-06,
                    2.681e-06,
                    2.767e-06,
                    2.8484e-06
                ],
                "Land_N2O": 0.22,
                "Land_N2O_timeseries": [
                    6.2224e-08,
                    1.2569e-07,
                    1.9035e-07,
                    2.5613e-07,
                    3.2293e-07,
                    3.9063e-07,
                    4.5911e-07,
                    5.2821e-07,
                    5.9774e-07,
                    6.6752e-07,
                    7.3742e-07,
                    8.074e-07,
                    8.7745e-07,
                    9.4755e-07,
                    1.0177e-06,
                    1.0879e-06,
                    1.1581e-06,
                    1.2284e-06,
                    1.2988e-06,
                    1.3693e-06,
                    1.441e-06,
                    1.5157e-06,
                    1.5948e-06,
                    1.6792e-06,
                    1.7695e-06,
                    1.8658e-06,
                    1.9679e-06,
                    2.075e-06,
                    2.186e-06,
                    2.2994e-06,
                    2.4141e-06,
                    2.5299e-06,
                    2.6467e-06,
                    2.7644e-06,
                    2.8827e-06,
                    3.0018e-06,
                    3.1215e-06,
                    3.242e-06,
                    3.3633e-06,
                    3.4909e-06,
                    3.6198e-06,
                    3.75e-06,
                    3.8814e-06,
                    4.0143e-06,
                    4.1486e-06,
                    4.2844e-06,
                    4.4217e-06,
                    4.5606e-06,
                    4.7011e-06,
                    4.8433e-06,
                    4.9871e-06,
                    5.1325e-06,
                    5.2795e-06,
                    5.428e-06,
                    5.5783e-06,
                    5.7304e-06,
                    5.8845e-06,
                    6.0411e-06,
                    6.2002e-06,
                    6.3625e-06,
                    6.5292e-06,
                    6.7028e-06,
                    6.885e-06,
                    7.0773e-06,
                    7.2808e-06,
                    7.4962e-06,
                    7.7237e-06,
                    7.9631e-06,
                    8.214e-06,
                    8.4754e-06,
                    8.7475e-06,
                    9.0317e-06,
                    9.3287e-06,
                    9.6387e-06,
                    9.9614e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            19.99948,
                            -24.75195
                        ],
                        [
                            20.12333,
                            -24.87952
                        ],
                        [
                            20.26144,
                            -24.92464
                        ],
                        [
                            20.29465,
                            -24.97628
                        ],
                        [
                            20.38092,
                            -25.03223
                        ],
                        [
                            20.45133,
                            -25.19358
                        ],
                        [
                            20.56561,
                            -25.38391
                        ],
                        [
                            20.64486,
                            -25.47517
                        ],
                        [
                            20.63269,
                            -25.51659
                        ],
                        [
                            20.69227,
                            -25.5849
                        ],
                        [
                            20.67733,
                            -25.67452
                        ],
                        [
                            20.73493,
                            -25.76729
                        ],
                        [
                            20.78849,
                            -25.80752
                        ],
                        [
                            20.81853,
                            -26.00474
                        ],
                        [
                            20.86091,
                            -26.13306
                        ],
                        [
                            20.82143,
                            -26.18003
                        ],
                        [
                            20.78706,
                            -26.27348
                        ],
                        [
                            20.72064,
                            -26.33625
                        ],
                        [
                            20.68932,
                            -26.39651
                        ],
                        [
                            20.62326,
                            -26.4419
                        ],
                        [
                            20.60568,
                            -26.53199
                        ],
                        [
                            20.62942,
                            -26.59358
                        ],
                        [
                            20.61866,
                            -26.7123
                        ],
                        [
                            20.66127,
                            -26.84216
                        ],
                        [
                            20.72341,
                            -26.87211
                        ],
                        [
                            20.89989,
                            -26.79682
                        ],
                        [
                            20.97381,
                            -26.80969
                        ],
                        [
                            21.02023,
                            -26.84804
                        ],
                        [
                            21.1429,
                            -26.87303
                        ],
                        [
                            21.21503,
                            -26.84954
                        ],
                        [
                            21.42636,
                            -26.82717
                        ],
                        [
                            21.52479,
                            -26.86076
                        ],
                        [
                            21.71263,
                            -26.85236
                        ],
                        [
                            21.78124,
                            -26.79768
                        ],
                        [
                            21.78071,
                            -26.68593
                        ],
                        [
                            21.81785,
                            -26.66612
                        ],
                        [
                            21.94366,
                            -26.67241
                        ],
                        [
                            22.04657,
                            -26.63354
                        ],
                        [
                            22.15949,
                            -26.50859
                        ],
                        [
                            22.19989,
                            -26.3981
                        ],
                        [
                            22.25407,
                            -26.35329
                        ],
                        [
                            22.35317,
                            -26.32924
                        ],
                        [
                            22.4222,
                            -26.23049
                        ],
                        [
                            22.47567,
                            -26.20827
                        ],
                        [
                            22.54258,
                            -26.22884
                        ],
                        [
                            22.58216,
                            -26.14768
                        ],
                        [
                            22.72294,
                            -26.01986
                        ],
                        [
                            22.72152,
                            -25.90198
                        ],
                        [
                            22.77777,
                            -25.7342
                        ],
                        [
                            22.82466,
                            -25.69509
                        ],
                        [
                            22.82072,
                            -25.58341
                        ],
                        [
                            22.91281,
                            -25.41965
                        ],
                        [
                            22.97064,
                            -25.37941
                        ],
                        [
                            23.01161,
                            -25.29575
                        ],
                        [
                            23.08287,
                            -25.32453
                        ],
                        [
                            23.19865,
                            -25.27318
                        ],
                        [
                            23.27669,
                            -25.26961
                        ],
                        [
                            23.41758,
                            -25.30758
                        ],
                        [
                            23.44232,
                            -25.27701
                        ],
                        [
                            23.55785,
                            -25.35624
                        ],
                        [
                            23.63975,
                            -25.43016
                        ],
                        [
                            23.75207,
                            -25.4693
                        ],
                        [
                            23.815,
                            -25.54617
                        ],
                        [
                            23.91363,
                            -25.62722
                        ],
                        [
                            23.97312,
                            -25.61791
                        ],
                        [
                            24.05855,
                            -25.65187
                        ],
                        [
                            24.19165,
                            -25.62267
                        ],
                        [
                            24.2909,
                            -25.7236
                        ],
                        [
                            24.37065,
                            -25.76229
                        ],
                        [
                            24.44907,
                            -25.73828
                        ],
                        [
                            24.68618,
                            -25.82282
                        ],
                        [
                            24.90199,
                            -25.81195
                        ],
                        [
                            25.04375,
                            -25.72307
                        ],
                        [
                            25.13038,
                            -25.75796
                        ],
                        [
                            25.34334,
                            -25.76729
                        ],
                        [
                            25.42367,
                            -25.73499
                        ],
                        [
                            25.5819,
                            -25.6336
                        ],
                        [
                            25.64914,
                            -25.50863
                        ],
                        [
                            25.70877,
                            -25.2838
                        ],
                        [
                            25.74815,
                            -25.22938
                        ],
                        [
                            25.85823,
                            -24.95879
                        ],
                        [
                            25.89074,
                            -24.85564
                        ],
                        [
                            25.86215,
                            -24.77161
                        ],
                        [
                            25.93736,
                            -24.72078
                        ],
                        [
                            26.02444,
                            -24.71876
                        ],
                        [
                            26.42083,
                            -24.63477
                        ],
                        [
                            26.47481,
                            -24.58762
                        ],
                        [
                            26.51884,
                            -24.48857
                        ],
                        [
                            26.59621,
                            -24.4089
                        ],
                        [
                            26.66853,
                            -24.38905
                        ],
                        [
                            26.67936,
                            -24.34828
                        ],
                        [
                            26.85313,
                            -24.2695
                        ],
                        [
                            26.91577,
                            -23.9847
                        ],
                        [
                            26.95397,
                            -23.87736
                        ],
                        [
                            26.93917,
                            -23.85425
                        ],
                        [
                            26.97814,
                            -23.70695
                        ],
                        [
                            27.00858,
                            -23.64532
                        ],
                        [
                            27.18906,
                            -23.53941
                        ],
                        [
                            27.21302,
                            -23.4931
                        ],
                        [
                            27.2764,
                            -23.47895
                        ],
                        [
                            27.33188,
                            -23.40769
                        ],
                        [
                            27.51991,
                            -23.38868
                        ],
                        [
                            27.56384,
                            -23.35178
                        ],
                        [
                            27.60957,
                            -23.22419
                        ],
                        [
                            27.68983,
                            -23.20742
                        ],
                        [
                            27.7205,
                            -23.23995
                        ],
                        [
                            27.78742,
                            -23.14946
                        ],
                        [
                            27.9313,
                            -23.06165
                        ],
                        [
                            27.94001,
                            -22.97067
                        ],
                        [
                            28.04312,
                            -22.91068
                        ],
                        [
                            28.0441,
                            -22.85233
                        ],
                        [
                            28.16309,
                            -22.75329
                        ],
                        [
                            28.20193,
                            -22.67175
                        ],
                        [
                            28.34934,
                            -22.57682
                        ],
                        [
                            28.51217,
                            -22.58608
                        ],
                        [
                            28.62752,
                            -22.55928
                        ],
                        [
                            28.70857,
                            -22.51446
                        ],
                        [
                            28.82494,
                            -22.48674
                        ],
                        [
                            28.86377,
                            -22.44763
                        ],
                        [
                            28.91609,
                            -22.45844
                        ],
                        [
                            28.97071,
                            -22.37508
                        ],
                        [
                            28.96152,
                            -22.33281
                        ],
                        [
                            29.01477,
                            -22.23109
                        ],
                        [
                            29.15039,
                            -22.21375
                        ],
                        [
                            29.18866,
                            -22.18572
                        ],
                        [
                            29.36078,
                            -22.19663
                        ],
                        [
                            29.25189,
                            -22.06163
                        ],
                        [
                            29.18635,
                            -22.07932
                        ],
                        [
                            29.10486,
                            -22.06105
                        ],
                        [
                            29.05548,
                            -22.02286
                        ],
                        [
                            29.02373,
                            -21.95725
                        ],
                        [
                            29.04015,
                            -21.86195
                        ],
                        [
                            29.07468,
                            -21.81888
                        ],
                        [
                            29.00181,
                            -21.77477
                        ],
                        [
                            28.94222,
                            -21.77554
                        ],
                        [
                            28.79497,
                            -21.73455
                        ],
                        [
                            28.56973,
                            -21.63207
                        ],
                        [
                            28.49627,
                            -21.66755
                        ],
                        [
                            28.36696,
                            -21.60872
                        ],
                        [
                            28.27503,
                            -21.59812
                        ],
                        [
                            28.20097,
                            -21.61026
                        ],
                        [
                            28.03183,
                            -21.58131
                        ],
                        [
                            27.90003,
                            -21.30293
                        ],
                        [
                            27.81175,
                            -21.1835
                        ],
                        [
                            27.74964,
                            -21.15216
                        ],
                        [
                            27.68685,
                            -21.06624
                        ],
                        [
                            27.71101,
                            -20.96759
                        ],
                        [
                            27.69063,
                            -20.881
                        ],
                        [
                            27.73026,
                            -20.79412
                        ],
                        [
                            27.7301,
                            -20.71105
                        ],
                        [
                            27.70519,
                            -20.60599
                        ],
                        [
                            27.72963,
                            -20.54647
                        ],
                        [
                            27.68312,
                            -20.49109
                        ],
                        [
                            27.57274,
                            -20.49514
                        ],
                        [
                            27.47455,
                            -20.4737
                        ],
                        [
                            27.35865,
                            -20.47397
                        ],
                        [
                            27.28586,
                            -20.49816
                        ],
                        [
                            27.29764,
                            -20.29987
                        ],
                        [
                            27.24444,
                            -20.14582
                        ],
                        [
                            27.19077,
                            -20.08393
                        ],
                        [
                            27.11623,
                            -20.08598
                        ],
                        [
                            27.05707,
                            -20.02334
                        ],
                        [
                            26.96904,
                            -20.0201
                        ],
                        [
                            26.80737,
                            -19.98143
                        ],
                        [
                            26.79184,
                            -19.94842
                        ],
                        [
                            26.71751,
                            -19.94314
                        ],
                        [
                            26.69418,
                            -19.89472
                        ],
                        [
                            26.61586,
                            -19.88647
                        ],
                        [
                            26.57526,
                            -19.80956
                        ],
                        [
                            26.49112,
                            -19.76118
                        ],
                        [
                            26.44079,
                            -19.75523
                        ],
                        [
                            26.3075,
                            -19.58292
                        ],
                        [
                            26.24299,
                            -19.5888
                        ],
                        [
                            26.1657,
                            -19.54534
                        ],
                        [
                            26.13664,
                            -19.44231
                        ],
                        [
                            26.04247,
                            -19.21909
                        ],
                        [
                            25.9584,
                            -19.09135
                        ],
                        [
                            25.99336,
                            -19.03081
                        ],
                        [
                            25.94099,
                            -18.91113
                        ],
                        [
                            25.82056,
                            -18.84341
                        ],
                        [
                            25.79051,
                            -18.75792
                        ],
                        [
                            25.78338,
                            -18.63459
                        ],
                        [
                            25.71244,
                            -18.59845
                        ],
                        [
                            25.64414,
                            -18.5008
                        ],
                        [
                            25.60798,
                            -18.48643
                        ],
                        [
                            25.52268,
                            -18.38577
                        ],
                        [
                            25.49164,
                            -18.29937
                        ],
                        [
                            25.41942,
                            -18.15725
                        ],
                        [
                            25.32315,
                            -18.07829
                        ],
                        [
                            25.23725,
                            -17.91588
                        ],
                        [
                            25.27033,
                            -17.79891
                        ],
                        [
                            25.2628,
                            -17.79139
                        ],
                        [
                            25.16069,
                            -17.77975
                        ],
                        [
                            25.11483,
                            -17.8252
                        ],
                        [
                            25.01344,
                            -17.83729
                        ],
                        [
                            24.91175,
                            -17.81171
                        ],
                        [
                            24.8555,
                            -17.84769
                        ],
                        [
                            24.73397,
                            -17.8907
                        ],
                        [
                            24.70077,
                            -17.93986
                        ],
                        [
                            24.63029,
                            -17.98196
                        ],
                        [
                            24.57574,
                            -18.07145
                        ],
                        [
                            24.50543,
                            -18.06101
                        ],
                        [
                            24.42413,
                            -17.95293
                        ],
                        [
                            24.36918,
                            -17.9492
                        ],
                        [
                            24.29076,
                            -18.0392
                        ],
                        [
                            24.1916,
                            -18.02889
                        ],
                        [
                            24.12209,
                            -18.10242
                        ],
                        [
                            24.01733,
                            -18.14592
                        ],
                        [
                            23.93158,
                            -18.20507
                        ],
                        [
                            23.90812,
                            -18.25982
                        ],
                        [
                            23.81455,
                            -18.32214
                        ],
                        [
                            23.74882,
                            -18.41715
                        ],
                        [
                            23.63273,
                            -18.48876
                        ],
                        [
                            23.57291,
                            -18.46812
                        ],
                        [
                            23.55253,
                            -18.3245
                        ],
                        [
                            23.499,
                            -18.24327
                        ],
                        [
                            23.39872,
                            -18.20636
                        ],
                        [
                            23.37946,
                            -18.13716
                        ],
                        [
                            23.32457,
                            -18.08038
                        ],
                        [
                            23.29006,
                            -18.00027
                        ],
                        [
                            23.09784,
                            -18.00059
                        ],
                        [
                            22.0751,
                            -18.18912
                        ],
                        [
                            21.46297,
                            -18.30427
                        ],
                        [
                            20.99991,
                            -18.31956
                        ],
                        [
                            20.99947,
                            -20.14223
                        ],
                        [
                            20.99929,
                            -20.85069
                        ],
                        [
                            20.99916,
                            -21.40739
                        ],
                        [
                            20.99901,
                            -21.99793
                        ],
                        [
                            19.99958,
                            -22.00112
                        ],
                        [
                            19.99951,
                            -23.77825
                        ],
                        [
                            19.99949,
                            -24.35396
                        ],
                        [
                            19.99948,
                            -24.75195
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "BRA",
                "Country": "Brazil",
                "Total_3GHG": 5.0,
                "Total_3GHG_timeseries": [
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0035,
                    0.0037,
                    0.0038,
                    0.004,
                    0.0042,
                    0.0044,
                    0.0045,
                    0.0047,
                    0.0049,
                    0.0052,
                    0.0054,
                    0.0056,
                    0.0058,
                    0.0061,
                    0.0063,
                    0.0066,
                    0.0068,
                    0.0071,
                    0.0073,
                    0.0075,
                    0.0077,
                    0.0079,
                    0.0081,
                    0.0082,
                    0.0084,
                    0.0086,
                    0.0088,
                    0.009,
                    0.0092,
                    0.0094,
                    0.0096,
                    0.0099,
                    0.0101,
                    0.0104,
                    0.0106,
                    0.0109,
                    0.0111,
                    0.0114,
                    0.0118,
                    0.0121,
                    0.0125,
                    0.0129,
                    0.0134,
                    0.0139,
                    0.0144,
                    0.0149,
                    0.0155,
                    0.0161,
                    0.0167,
                    0.0174,
                    0.0181,
                    0.0189,
                    0.0196,
                    0.0203,
                    0.021,
                    0.0218,
                    0.0225,
                    0.0233,
                    0.024,
                    0.0248,
                    0.0256,
                    0.0265,
                    0.0273,
                    0.0283,
                    0.0292,
                    0.0302,
                    0.0312,
                    0.0322,
                    0.0332,
                    0.0342,
                    0.0351,
                    0.0361,
                    0.037,
                    0.038,
                    0.039,
                    0.04,
                    0.041,
                    0.042,
                    0.0431,
                    0.0443,
                    0.0454,
                    0.0467,
                    0.0479,
                    0.0491,
                    0.0504,
                    0.0517,
                    0.053,
                    0.0543,
                    0.0556,
                    0.057,
                    0.0586,
                    0.0601,
                    0.0616,
                    0.063,
                    0.0643,
                    0.0656,
                    0.0668,
                    0.068,
                    0.0692,
                    0.0704,
                    0.0716,
                    0.0728,
                    0.074,
                    0.0752,
                    0.0763,
                    0.0774,
                    0.0785,
                    0.0796,
                    0.0806,
                    0.0817
                ],
                "Fossil_3GHG": 1.59,
                "Fossil_3GHG_timeseries": [
                    2.1986e-06,
                    4.41e-06,
                    6.6348e-06,
                    8.8734e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0028,
                    0.0029,
                    0.0031,
                    0.0033,
                    0.0034,
                    0.0036,
                    0.0038,
                    0.004,
                    0.0042,
                    0.0044,
                    0.0046,
                    0.0048,
                    0.005,
                    0.0052,
                    0.0055,
                    0.0057,
                    0.006,
                    0.0062,
                    0.0065,
                    0.0067,
                    0.007,
                    0.0072,
                    0.0075,
                    0.0077,
                    0.008,
                    0.0083,
                    0.0086,
                    0.0089,
                    0.0092,
                    0.0095,
                    0.0098,
                    0.0101,
                    0.0104,
                    0.0108,
                    0.0111,
                    0.0114,
                    0.0117,
                    0.012,
                    0.0124,
                    0.0127,
                    0.0131,
                    0.0135,
                    0.0139,
                    0.0143,
                    0.0146,
                    0.015,
                    0.0154,
                    0.0157,
                    0.0161,
                    0.0165,
                    0.0168
                ],
                "Land_3GHG": 11.28,
                "Land_3GHG_timeseries": [
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0034,
                    0.0035,
                    0.0037,
                    0.0039,
                    0.004,
                    0.0042,
                    0.0044,
                    0.0046,
                    0.0048,
                    0.005,
                    0.0052,
                    0.0054,
                    0.0056,
                    0.0059,
                    0.0061,
                    0.0063,
                    0.0065,
                    0.0067,
                    0.0069,
                    0.0071,
                    0.0073,
                    0.0074,
                    0.0076,
                    0.0078,
                    0.0079,
                    0.0081,
                    0.0083,
                    0.0085,
                    0.0087,
                    0.0089,
                    0.0091,
                    0.0093,
                    0.0095,
                    0.0098,
                    0.01,
                    0.0102,
                    0.0105,
                    0.0108,
                    0.0111,
                    0.0115,
                    0.0118,
                    0.0122,
                    0.0126,
                    0.0131,
                    0.0135,
                    0.014,
                    0.0146,
                    0.0151,
                    0.0157,
                    0.0164,
                    0.017,
                    0.0176,
                    0.0183,
                    0.0189,
                    0.0195,
                    0.0201,
                    0.0208,
                    0.0214,
                    0.0221,
                    0.0227,
                    0.0234,
                    0.0241,
                    0.0248,
                    0.0256,
                    0.0264,
                    0.0272,
                    0.028,
                    0.0288,
                    0.0296,
                    0.0303,
                    0.0311,
                    0.0318,
                    0.0325,
                    0.0333,
                    0.034,
                    0.0348,
                    0.0356,
                    0.0364,
                    0.0373,
                    0.0382,
                    0.0392,
                    0.0402,
                    0.0411,
                    0.0421,
                    0.0431,
                    0.0441,
                    0.0451,
                    0.0461,
                    0.0472,
                    0.0485,
                    0.0497,
                    0.0508,
                    0.0519,
                    0.0529,
                    0.0539,
                    0.0548,
                    0.0557,
                    0.0565,
                    0.0573,
                    0.0581,
                    0.059,
                    0.0598,
                    0.0606,
                    0.0613,
                    0.062,
                    0.0628,
                    0.0635,
                    0.0642,
                    0.0649
                ],
                "Total_CO2": 4.73,
                "Total_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0034,
                    0.0035,
                    0.0037,
                    0.0038,
                    0.004,
                    0.0042,
                    0.0044,
                    0.0045,
                    0.0047,
                    0.0048,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0054,
                    0.0055,
                    0.0056,
                    0.0057,
                    0.0058,
                    0.0059,
                    0.0061,
                    0.0063,
                    0.0064,
                    0.0066,
                    0.0068,
                    0.0069,
                    0.0071,
                    0.0073,
                    0.0075,
                    0.0077,
                    0.0079,
                    0.0081,
                    0.0084,
                    0.0087,
                    0.009,
                    0.0093,
                    0.0097,
                    0.01,
                    0.0104,
                    0.0108,
                    0.0113,
                    0.0118,
                    0.0123,
                    0.0128,
                    0.0133,
                    0.0138,
                    0.0143,
                    0.0148,
                    0.0154,
                    0.0159,
                    0.0164,
                    0.0169,
                    0.0174,
                    0.0179,
                    0.0185,
                    0.019,
                    0.0196,
                    0.0202,
                    0.0208,
                    0.0214,
                    0.022,
                    0.0226,
                    0.0232,
                    0.0238,
                    0.0243,
                    0.0248,
                    0.0253,
                    0.0259,
                    0.0264,
                    0.027,
                    0.0276,
                    0.0282,
                    0.0289,
                    0.0296,
                    0.0304,
                    0.0313,
                    0.0321,
                    0.0329,
                    0.0339,
                    0.0348,
                    0.0357,
                    0.0366,
                    0.0376,
                    0.0387,
                    0.0398,
                    0.0407,
                    0.0416,
                    0.0425,
                    0.0434,
                    0.0442,
                    0.045,
                    0.0458,
                    0.0465,
                    0.0473,
                    0.0481,
                    0.0489,
                    0.0496,
                    0.0503,
                    0.051,
                    0.0517,
                    0.0523,
                    0.053,
                    0.0536
                ],
                "Fossil_CO2": 1.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    9.471e-07,
                    2.0757e-06,
                    3.1746e-06,
                    4.3544e-06,
                    5.615e-06,
                    7.0587e-06,
                    8.613e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0028,
                    0.0029,
                    0.0031,
                    0.0032,
                    0.0034,
                    0.0035,
                    0.0037,
                    0.0038,
                    0.004,
                    0.0042,
                    0.0043,
                    0.0045,
                    0.0047,
                    0.0049,
                    0.0051,
                    0.0053,
                    0.0055,
                    0.0057,
                    0.006,
                    0.0062,
                    0.0064,
                    0.0067,
                    0.0069,
                    0.0071,
                    0.0073,
                    0.0075,
                    0.0077
                ],
                "Land_CO2": 12.81,
                "Land_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0035,
                    0.0036,
                    0.0038,
                    0.004,
                    0.0041,
                    0.0043,
                    0.0045,
                    0.0046,
                    0.0048,
                    0.0049,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0055,
                    0.0056,
                    0.0058,
                    0.0059,
                    0.006,
                    0.0062,
                    0.0063,
                    0.0065,
                    0.0067,
                    0.0068,
                    0.007,
                    0.0072,
                    0.0074,
                    0.0075,
                    0.0078,
                    0.008,
                    0.0083,
                    0.0086,
                    0.0089,
                    0.0092,
                    0.0095,
                    0.0098,
                    0.0102,
                    0.0106,
                    0.011,
                    0.0115,
                    0.012,
                    0.0125,
                    0.013,
                    0.0134,
                    0.0139,
                    0.0144,
                    0.0149,
                    0.0153,
                    0.0158,
                    0.0163,
                    0.0167,
                    0.0172,
                    0.0177,
                    0.0182,
                    0.0187,
                    0.0192,
                    0.0197,
                    0.0202,
                    0.0208,
                    0.0213,
                    0.0218,
                    0.0223,
                    0.0228,
                    0.0232,
                    0.0236,
                    0.0241,
                    0.0245,
                    0.025,
                    0.0255,
                    0.026,
                    0.0266,
                    0.0272,
                    0.0279,
                    0.0286,
                    0.0293,
                    0.03,
                    0.0308,
                    0.0316,
                    0.0323,
                    0.0331,
                    0.0339,
                    0.0349,
                    0.0358,
                    0.0366,
                    0.0373,
                    0.038,
                    0.0387,
                    0.0394,
                    0.0399,
                    0.0405,
                    0.041,
                    0.0416,
                    0.0421,
                    0.0427,
                    0.0432,
                    0.0437,
                    0.0441,
                    0.0446,
                    0.045,
                    0.0455,
                    0.0459
                ],
                "Total_CH4": 5.9,
                "Total_CH4_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0044,
                    0.0045,
                    0.0047,
                    0.0049,
                    0.0051,
                    0.0052,
                    0.0054,
                    0.0056,
                    0.0058,
                    0.0061,
                    0.0063,
                    0.0065,
                    0.0068,
                    0.007,
                    0.0073,
                    0.0076,
                    0.0079,
                    0.0082,
                    0.0085,
                    0.0088,
                    0.0092,
                    0.0096,
                    0.0099,
                    0.0103,
                    0.0107,
                    0.0111,
                    0.0114,
                    0.0118,
                    0.0123,
                    0.0127,
                    0.0131,
                    0.0135,
                    0.0139,
                    0.0143,
                    0.0147,
                    0.0151,
                    0.0154,
                    0.0157,
                    0.0161,
                    0.0164,
                    0.0167,
                    0.0171,
                    0.0174,
                    0.0178,
                    0.0182,
                    0.0187,
                    0.0191,
                    0.0194,
                    0.0198,
                    0.0201,
                    0.0205,
                    0.0208,
                    0.0212,
                    0.0215,
                    0.0219,
                    0.0222,
                    0.0226,
                    0.023,
                    0.0233,
                    0.0236,
                    0.024,
                    0.0243,
                    0.0246
                ],
                "Fossil_CH4": 3.32,
                "Fossil_CH4_timeseries": [
                    1.9052e-06,
                    3.8197e-06,
                    5.7442e-06,
                    7.6791e-06,
                    9.6249e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0033,
                    0.0034,
                    0.0036,
                    0.0037,
                    0.0039,
                    0.004,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.005,
                    0.0051,
                    0.0053,
                    0.0054,
                    0.0055,
                    0.0057,
                    0.0058,
                    0.006,
                    0.0061,
                    0.0063,
                    0.0064,
                    0.0065,
                    0.0067,
                    0.0068,
                    0.0069,
                    0.0071,
                    0.0072,
                    0.0073,
                    0.0075,
                    0.0076,
                    0.0078,
                    0.0079,
                    0.0081,
                    0.0082,
                    0.0083,
                    0.0085,
                    0.0086
                ],
                "Land_CH4": 10.17,
                "Land_CH4_timeseries": [
                    8.2729e-06,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0042,
                    0.0043,
                    0.0045,
                    0.0046,
                    0.0048,
                    0.0049,
                    0.0051,
                    0.0053,
                    0.0055,
                    0.0057,
                    0.006,
                    0.0062,
                    0.0064,
                    0.0067,
                    0.0069,
                    0.0072,
                    0.0074,
                    0.0076,
                    0.0079,
                    0.0081,
                    0.0084,
                    0.0087,
                    0.0089,
                    0.0092,
                    0.0095,
                    0.0097,
                    0.01,
                    0.0102,
                    0.0104,
                    0.0106,
                    0.0108,
                    0.011,
                    0.0112,
                    0.0114,
                    0.0116,
                    0.0118,
                    0.0121,
                    0.0124,
                    0.0127,
                    0.0129,
                    0.0131,
                    0.0133,
                    0.0136,
                    0.0138,
                    0.014,
                    0.0142,
                    0.0144,
                    0.0146,
                    0.0148,
                    0.015,
                    0.0152,
                    0.0154,
                    0.0156,
                    0.0158,
                    0.016
                ],
                "Total_N2O": 4.19,
                "Total_N2O_timeseries": [
                    5.1095e-07,
                    1.0298e-06,
                    1.5562e-06,
                    2.0899e-06,
                    2.6306e-06,
                    3.1775e-06,
                    3.7302e-06,
                    4.288e-06,
                    4.8501e-06,
                    5.4155e-06,
                    5.9838e-06,
                    6.5548e-06,
                    7.1284e-06,
                    7.7045e-06,
                    8.2831e-06,
                    8.8642e-06,
                    9.4479e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035
                ],
                "Fossil_N2O": 2.08,
                "Fossil_N2O_timeseries": [
                    2.9336e-07,
                    5.9024e-07,
                    8.9058e-07,
                    1.1943e-06,
                    1.5013e-06,
                    1.8115e-06,
                    2.1248e-06,
                    2.441e-06,
                    2.7599e-06,
                    3.0813e-06,
                    3.4052e-06,
                    3.7315e-06,
                    4.0601e-06,
                    4.3911e-06,
                    4.7244e-06,
                    5.0601e-06,
                    5.3982e-06,
                    5.7386e-06,
                    6.0814e-06,
                    6.4267e-06,
                    6.7754e-06,
                    7.1293e-06,
                    7.4897e-06,
                    7.8577e-06,
                    8.2336e-06,
                    8.6177e-06,
                    9.0097e-06,
                    9.4088e-06,
                    9.8141e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Land_N2O": 5.0,
                "Land_N2O_timeseries": [
                    2.1759e-07,
                    4.3953e-07,
                    6.6563e-07,
                    8.9564e-07,
                    1.1292e-06,
                    1.366e-06,
                    1.6054e-06,
                    1.847e-06,
                    2.0902e-06,
                    2.3342e-06,
                    2.5786e-06,
                    2.8233e-06,
                    3.0683e-06,
                    3.3134e-06,
                    3.5587e-06,
                    3.8041e-06,
                    4.0497e-06,
                    4.2955e-06,
                    4.5417e-06,
                    4.7883e-06,
                    5.0391e-06,
                    5.3003e-06,
                    5.5768e-06,
                    5.8719e-06,
                    6.1877e-06,
                    6.5245e-06,
                    6.8813e-06,
                    7.2558e-06,
                    7.644e-06,
                    8.0404e-06,
                    8.4416e-06,
                    8.8467e-06,
                    9.2552e-06,
                    9.6665e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -53.37795,
                                -33.7504
                            ],
                            [
                                -53.15689,
                                -33.59143
                            ],
                            [
                                -52.79612,
                                -33.3011
                            ],
                            [
                                -52.61982,
                                -33.10054
                            ],
                            [
                                -52.49232,
                                -32.8639
                            ],
                            [
                                -52.4148,
                                -32.60577
                            ],
                            [
                                -52.32793,
                                -32.3993
                            ],
                            [
                                -52.22122,
                                -32.24808
                            ],
                            [
                                -52.1023,
                                -32.15515
                            ],
                            [
                                -52.10316,
                                -32.10203
                            ],
                            [
                                -52.24182,
                                -32.04644
                            ],
                            [
                                -52.22045,
                                -31.96681
                            ],
                            [
                                -52.13832,
                                -31.92065
                            ],
                            [
                                -52.21919,
                                -31.87671
                            ],
                            [
                                -52.22326,
                                -31.75433
                            ],
                            [
                                -52.15633,
                                -31.70257
                            ],
                            [
                                -52.07391,
                                -31.6762
                            ],
                            [
                                -52.10022,
                                -31.55433
                            ],
                            [
                                -52.01524,
                                -31.53429
                            ],
                            [
                                -51.98273,
                                -31.39178
                            ],
                            [
                                -51.92338,
                                -31.31824
                            ],
                            [
                                -51.85149,
                                -31.325
                            ],
                            [
                                -51.6346,
                                -31.25126
                            ],
                            [
                                -51.62136,
                                -31.14678
                            ],
                            [
                                -51.45011,
                                -31.08823
                            ],
                            [
                                -51.49038,
                                -31.00836
                            ],
                            [
                                -51.49615,
                                -30.91772
                            ],
                            [
                                -51.44884,
                                -30.87499
                            ],
                            [
                                -51.37609,
                                -30.87129
                            ],
                            [
                                -51.40412,
                                -30.7571
                            ],
                            [
                                -51.38927,
                                -30.66794
                            ],
                            [
                                -51.32086,
                                -30.64717
                            ],
                            [
                                -51.26405,
                                -30.48011
                            ],
                            [
                                -51.20157,
                                -30.41105
                            ],
                            [
                                -51.12534,
                                -30.42418
                            ],
                            [
                                -51.09834,
                                -30.37882
                            ],
                            [
                                -51.00663,
                                -30.39225
                            ],
                            [
                                -50.93217,
                                -30.43242
                            ],
                            [
                                -50.91655,
                                -30.32897
                            ],
                            [
                                -50.78943,
                                -30.33014
                            ],
                            [
                                -50.78246,
                                -30.29029
                            ],
                            [
                                -50.6695,
                                -30.29296
                            ],
                            [
                                -50.68144,
                                -30.24197
                            ],
                            [
                                -50.60121,
                                -30.19622
                            ],
                            [
                                -50.53767,
                                -30.27409
                            ],
                            [
                                -50.56553,
                                -30.45611
                            ],
                            [
                                -50.69503,
                                -30.44751
                            ],
                            [
                                -50.67975,
                                -30.61138
                            ],
                            [
                                -50.7186,
                                -30.77537
                            ],
                            [
                                -50.7625,
                                -30.82126
                            ],
                            [
                                -50.89701,
                                -30.89873
                            ],
                            [
                                -50.96088,
                                -30.90154
                            ],
                            [
                                -50.95346,
                                -30.95761
                            ],
                            [
                                -50.986,
                                -31.04051
                            ],
                            [
                                -51.17877,
                                -31.1337
                            ],
                            [
                                -51.1576,
                                -31.23864
                            ],
                            [
                                -51.18534,
                                -31.37748
                            ],
                            [
                                -51.23245,
                                -31.45023
                            ],
                            [
                                -51.35292,
                                -31.52857
                            ],
                            [
                                -51.42813,
                                -31.49603
                            ],
                            [
                                -51.59695,
                                -31.71223
                            ],
                            [
                                -51.69034,
                                -31.77979
                            ],
                            [
                                -51.79606,
                                -31.78942
                            ],
                            [
                                -51.80925,
                                -31.8402
                            ],
                            [
                                -51.87614,
                                -31.87101
                            ],
                            [
                                -52.05721,
                                -31.81688
                            ],
                            [
                                -52.08313,
                                -31.86112
                            ],
                            [
                                -52.01668,
                                -31.9221
                            ],
                            [
                                -52.04852,
                                -31.98248
                            ],
                            [
                                -52.04183,
                                -32.04481
                            ],
                            [
                                -51.93099,
                                -31.99703
                            ],
                            [
                                -51.83307,
                                -31.92084
                            ],
                            [
                                -51.49459,
                                -31.73812
                            ],
                            [
                                -51.29893,
                                -31.60215
                            ],
                            [
                                -51.20519,
                                -31.52327
                            ],
                            [
                                -51.03677,
                                -31.35775
                            ],
                            [
                                -50.89779,
                                -31.24353
                            ],
                            [
                                -50.77421,
                                -31.11696
                            ],
                            [
                                -50.47322,
                                -30.69322
                            ],
                            [
                                -50.36581,
                                -30.55169
                            ],
                            [
                                -50.29019,
                                -30.40758
                            ],
                            [
                                -50.15478,
                                -30.06044
                            ],
                            [
                                -50.06478,
                                -29.86084
                            ],
                            [
                                -49.93479,
                                -29.62555
                            ],
                            [
                                -49.70083,
                                -29.30616
                            ],
                            [
                                -49.46655,
                                -29.04319
                            ],
                            [
                                -49.37223,
                                -28.95254
                            ],
                            [
                                -49.17876,
                                -28.79757
                            ],
                            [
                                -48.96993,
                                -28.67009
                            ],
                            [
                                -48.8152,
                                -28.60631
                            ],
                            [
                                -48.74791,
                                -28.50587
                            ],
                            [
                                -48.76568,
                                -28.4682
                            ],
                            [
                                -48.694,
                                -28.28661
                            ],
                            [
                                -48.64686,
                                -28.23391
                            ],
                            [
                                -48.6615,
                                -28.18034
                            ],
                            [
                                -48.60088,
                                -28.03151
                            ],
                            [
                                -48.6232,
                                -27.95304
                            ],
                            [
                                -48.57571,
                                -27.88809
                            ],
                            [
                                -48.61813,
                                -27.82043
                            ],
                            [
                                -48.61677,
                                -27.7554
                            ],
                            [
                                -48.65673,
                                -27.64733
                            ],
                            [
                                -48.56972,
                                -27.59605
                            ],
                            [
                                -48.64498,
                                -27.4837
                            ],
                            [
                                -48.62058,
                                -27.43048
                            ],
                            [
                                -48.56638,
                                -27.42224
                            ],
                            [
                                -48.55444,
                                -27.36809
                            ],
                            [
                                -48.61439,
                                -27.28798
                            ],
                            [
                                -48.60559,
                                -27.22144
                            ],
                            [
                                -48.49076,
                                -27.14689
                            ],
                            [
                                -48.59195,
                                -27.13712
                            ],
                            [
                                -48.61122,
                                -27.09747
                            ],
                            [
                                -48.57245,
                                -27.01224
                            ],
                            [
                                -48.627,
                                -26.99228
                            ],
                            [
                                -48.64199,
                                -26.90044
                            ],
                            [
                                -48.61702,
                                -26.78793
                            ],
                            [
                                -48.67548,
                                -26.74903
                            ],
                            [
                                -48.68108,
                                -26.62388
                            ],
                            [
                                -48.59929,
                                -26.45852
                            ],
                            [
                                -48.59054,
                                -26.40531
                            ],
                            [
                                -48.50276,
                                -26.23808
                            ],
                            [
                                -48.56242,
                                -26.20835
                            ],
                            [
                                -48.60812,
                                -26.0509
                            ],
                            [
                                -48.56289,
                                -25.86322
                            ],
                            [
                                -48.43173,
                                -25.645
                            ],
                            [
                                -48.35796,
                                -25.58446
                            ],
                            [
                                -48.37453,
                                -25.54899
                            ],
                            [
                                -48.47449,
                                -25.55
                            ],
                            [
                                -48.50439,
                                -25.50652
                            ],
                            [
                                -48.61031,
                                -25.54356
                            ],
                            [
                                -48.67716,
                                -25.49625
                            ],
                            [
                                -48.70494,
                                -25.43347
                            ],
                            [
                                -48.65183,
                                -25.42134
                            ],
                            [
                                -48.56755,
                                -25.45918
                            ],
                            [
                                -48.45925,
                                -25.46738
                            ],
                            [
                                -48.42233,
                                -25.42674
                            ],
                            [
                                -48.44278,
                                -25.37055
                            ],
                            [
                                -48.43394,
                                -25.27756
                            ],
                            [
                                -48.371,
                                -25.26984
                            ],
                            [
                                -48.3049,
                                -25.31872
                            ],
                            [
                                -48.22073,
                                -25.2991
                            ],
                            [
                                -48.21779,
                                -25.37661
                            ],
                            [
                                -48.25158,
                                -25.43008
                            ],
                            [
                                -48.21125,
                                -25.45634
                            ],
                            [
                                -48.16352,
                                -25.37722
                            ],
                            [
                                -48.01849,
                                -25.20385
                            ],
                            [
                                -48.04174,
                                -25.1302
                            ],
                            [
                                -48.01225,
                                -25.0483
                            ],
                            [
                                -47.96021,
                                -25.06126
                            ],
                            [
                                -47.89804,
                                -24.96439
                            ],
                            [
                                -47.83672,
                                -24.90457
                            ],
                            [
                                -47.78301,
                                -24.87448
                            ],
                            [
                                -47.63726,
                                -24.76422
                            ],
                            [
                                -47.53011,
                                -24.69594
                            ],
                            [
                                -47.41363,
                                -24.67238
                            ],
                            [
                                -47.23085,
                                -24.57006
                            ],
                            [
                                -47.08509,
                                -24.451
                            ],
                            [
                                -47.0289,
                                -24.42453
                            ],
                            [
                                -46.99815,
                                -24.33309
                            ],
                            [
                                -46.91913,
                                -24.26514
                            ],
                            [
                                -46.69265,
                                -24.13442
                            ],
                            [
                                -46.34615,
                                -23.97053
                            ],
                            [
                                -46.27744,
                                -24.02098
                            ],
                            [
                                -46.18608,
                                -23.98973
                            ],
                            [
                                -46.17722,
                                -23.92524
                            ],
                            [
                                -46.1216,
                                -23.83837
                            ],
                            [
                                -45.89952,
                                -23.76398
                            ],
                            [
                                -45.64418,
                                -23.78032
                            ],
                            [
                                -45.56211,
                                -23.79366
                            ],
                            [
                                -45.50958,
                                -23.8395
                            ],
                            [
                                -45.39883,
                                -23.80703
                            ],
                            [
                                -45.43049,
                                -23.68087
                            ],
                            [
                                -45.36421,
                                -23.62639
                            ],
                            [
                                -45.19681,
                                -23.52216
                            ],
                            [
                                -45.16199,
                                -23.53267
                            ],
                            [
                                -45.07145,
                                -23.49796
                            ],
                            [
                                -45.05911,
                                -23.42132
                            ],
                            [
                                -44.97736,
                                -23.39775
                            ],
                            [
                                -44.9072,
                                -23.33658
                            ],
                            [
                                -44.82943,
                                -23.38699
                            ],
                            [
                                -44.64185,
                                -23.33391
                            ],
                            [
                                -44.57937,
                                -23.35269
                            ],
                            [
                                -44.58128,
                                -23.26767
                            ],
                            [
                                -44.65135,
                                -23.19191
                            ],
                            [
                                -44.7186,
                                -23.19884
                            ],
                            [
                                -44.68638,
                                -23.07766
                            ],
                            [
                                -44.58989,
                                -23.05762
                            ],
                            [
                                -44.43048,
                                -22.99835
                            ],
                            [
                                -44.41899,
                                -22.94605
                            ],
                            [
                                -44.32376,
                                -22.92395
                            ],
                            [
                                -44.35217,
                                -22.99898
                            ],
                            [
                                -44.24631,
                                -23.00191
                            ],
                            [
                                -44.20114,
                                -23.04103
                            ],
                            [
                                -44.14614,
                                -23.03629
                            ],
                            [
                                -43.999,
                                -22.94099
                            ],
                            [
                                -43.86861,
                                -22.90652
                            ],
                            [
                                -43.79181,
                                -22.92168
                            ],
                            [
                                -43.69735,
                                -22.98386
                            ],
                            [
                                -43.62444,
                                -23.01001
                            ],
                            [
                                -43.56183,
                                -23.07079
                            ],
                            [
                                -43.44165,
                                -23.02296
                            ],
                            [
                                -43.29833,
                                -23.01449
                            ],
                            [
                                -43.16616,
                                -22.96409
                            ],
                            [
                                -43.27325,
                                -22.78025
                            ],
                            [
                                -43.20537,
                                -22.72512
                            ],
                            [
                                -43.08185,
                                -22.68256
                            ],
                            [
                                -43.0308,
                                -22.73286
                            ],
                            [
                                -43.12779,
                                -22.8794
                            ],
                            [
                                -43.10299,
                                -22.95293
                            ],
                            [
                                -43.0427,
                                -22.97747
                            ],
                            [
                                -42.69563,
                                -22.95853
                            ],
                            [
                                -42.60398,
                                -22.93468
                            ],
                            [
                                -42.31375,
                                -22.93749
                            ],
                            [
                                -42.0624,
                                -22.96036
                            ],
                            [
                                -41.92893,
                                -22.76493
                            ],
                            [
                                -41.9854,
                                -22.71087
                            ],
                            [
                                -41.99679,
                                -22.61491
                            ],
                            [
                                -41.96335,
                                -22.54102
                            ],
                            [
                                -41.92619,
                                -22.52818
                            ],
                            [
                                -41.75948,
                                -22.35244
                            ],
                            [
                                -41.67219,
                                -22.29122
                            ],
                            [
                                -41.51429,
                                -22.22302
                            ],
                            [
                                -41.25608,
                                -22.14976
                            ],
                            [
                                -41.15178,
                                -22.10656
                            ],
                            [
                                -41.00791,
                                -22.0221
                            ],
                            [
                                -40.97674,
                                -21.93765
                            ],
                            [
                                -41.02331,
                                -21.72699
                            ],
                            [
                                -41.01368,
                                -21.62132
                            ],
                            [
                                -41.05324,
                                -21.58145
                            ],
                            [
                                -41.07082,
                                -21.51309
                            ],
                            [
                                -40.9667,
                                -21.36524
                            ],
                            [
                                -40.95953,
                                -21.26607
                            ],
                            [
                                -40.91332,
                                -21.17431
                            ],
                            [
                                -40.85578,
                                -21.11763
                            ],
                            [
                                -40.81029,
                                -21.02073
                            ],
                            [
                                -40.7998,
                                -20.93938
                            ],
                            [
                                -40.73886,
                                -20.84884
                            ],
                            [
                                -40.65515,
                                -20.81162
                            ],
                            [
                                -40.62369,
                                -20.83087
                            ],
                            [
                                -40.52877,
                                -20.73216
                            ],
                            [
                                -40.46355,
                                -20.63217
                            ],
                            [
                                -40.43226,
                                -20.63429
                            ],
                            [
                                -40.35849,
                                -20.50942
                            ],
                            [
                                -40.3107,
                                -20.38802
                            ],
                            [
                                -40.2345,
                                -20.28478
                            ],
                            [
                                -40.19706,
                                -20.20741
                            ],
                            [
                                -40.14539,
                                -19.95797
                            ],
                            [
                                -40.10491,
                                -19.91978
                            ],
                            [
                                -40.04624,
                                -19.80483
                            ],
                            [
                                -39.90129,
                                -19.68264
                            ],
                            [
                                -39.81357,
                                -19.647
                            ],
                            [
                                -39.73116,
                                -19.46861
                            ],
                            [
                                -39.68955,
                                -19.3028
                            ],
                            [
                                -39.74804,
                                -18.8616
                            ],
                            [
                                -39.74509,
                                -18.69663
                            ],
                            [
                                -39.71248,
                                -18.45784
                            ],
                            [
                                -39.62734,
                                -18.21921
                            ],
                            [
                                -39.49307,
                                -18.00168
                            ],
                            [
                                -39.44829,
                                -17.95194
                            ],
                            [
                                -39.35358,
                                -17.89435
                            ],
                            [
                                -39.27485,
                                -17.86612
                            ],
                            [
                                -39.20158,
                                -17.74787
                            ],
                            [
                                -39.14138,
                                -17.68926
                            ],
                            [
                                -39.1992,
                                -17.55828
                            ],
                            [
                                -39.19199,
                                -17.45996
                            ],
                            [
                                -39.21919,
                                -17.31021
                            ],
                            [
                                -39.2118,
                                -17.17108
                            ],
                            [
                                -39.18206,
                                -17.10505
                            ],
                            [
                                -39.15022,
                                -16.94592
                            ],
                            [
                                -39.13772,
                                -16.7551
                            ],
                            [
                                -39.10602,
                                -16.69876
                            ],
                            [
                                -39.05901,
                                -16.43327
                            ],
                            [
                                -39.01103,
                                -16.36561
                            ],
                            [
                                -39.02516,
                                -16.26995
                            ],
                            [
                                -38.95419,
                                -16.16562
                            ],
                            [
                                -38.93918,
                                -16.06182
                            ],
                            [
                                -38.86231,
                                -15.86633
                            ],
                            [
                                -38.86281,
                                -15.82507
                            ],
                            [
                                -38.9329,
                                -15.66626
                            ],
                            [
                                -38.9467,
                                -15.50148
                            ],
                            [
                                -38.99626,
                                -15.22586
                            ],
                            [
                                -38.99874,
                                -14.98832
                            ],
                            [
                                -39.0247,
                                -14.81524
                            ],
                            [
                                -39.06219,
                                -14.74214
                            ],
                            [
                                -39.05948,
                                -14.61854
                            ],
                            [
                                -39.01014,
                                -14.38313
                            ],
                            [
                                -38.98266,
                                -14.29628
                            ],
                            [
                                -38.98835,
                                -14.19861
                            ],
                            [
                                -38.95423,
                                -14.07283
                            ],
                            [
                                -38.9785,
                                -14.01118
                            ],
                            [
                                -39.08966,
                                -13.95531
                            ],
                            [
                                -39.07405,
                                -13.78564
                            ],
                            [
                                -39.13874,
                                -13.72262
                            ],
                            [
                                -39.06457,
                                -13.69851
                            ],
                            [
                                -39.04507,
                                -13.80113
                            ],
                            [
                                -38.99607,
                                -13.75245
                            ],
                            [
                                -38.96994,
                                -13.68613
                            ],
                            [
                                -39.01165,
                                -13.58913
                            ],
                            [
                                -39.09872,
                                -13.56636
                            ],
                            [
                                -39.07027,
                                -13.39274
                            ],
                            [
                                -38.96373,
                                -13.3683
                            ],
                            [
                                -38.96333,
                                -13.30145
                            ],
                            [
                                -38.92478,
                                -13.21963
                            ],
                            [
                                -38.81761,
                                -13.14645
                            ],
                            [
                                -38.80981,
                                -13.07432
                            ],
                            [
                                -38.76276,
                                -12.91455
                            ],
                            [
                                -38.80892,
                                -12.834
                            ],
                            [
                                -38.77708,
                                -12.80536
                            ],
                            [
                                -38.71187,
                                -12.58809
                            ],
                            [
                                -38.64435,
                                -12.64207
                            ],
                            [
                                -38.63462,
                                -12.71881
                            ],
                            [
                                -38.5648,
                                -12.7128
                            ],
                            [
                                -38.44603,
                                -12.77737
                            ],
                            [
                                -38.52828,
                                -13.00756
                            ],
                            [
                                -38.46922,
                                -13.01266
                            ],
                            [
                                -38.34921,
                                -12.95238
                            ],
                            [
                                -38.24032,
                                -12.84748
                            ],
                            [
                                -38.127,
                                -12.70831
                            ],
                            [
                                -38.00017,
                                -12.57285
                            ],
                            [
                                -37.93971,
                                -12.47067
                            ],
                            [
                                -37.75922,
                                -12.22134
                            ],
                            [
                                -37.61557,
                                -11.9665
                            ],
                            [
                                -37.51419,
                                -11.74315
                            ],
                            [
                                -37.42591,
                                -11.57195
                            ],
                            [
                                -37.31867,
                                -11.42258
                            ],
                            [
                                -37.26742,
                                -11.30219
                            ],
                            [
                                -37.16827,
                                -11.18429
                            ],
                            [
                                -37.14279,
                                -11.12845
                            ],
                            [
                                -37.00396,
                                -10.91612
                            ],
                            [
                                -36.85588,
                                -10.74658
                            ],
                            [
                                -36.79734,
                                -10.69799
                            ],
                            [
                                -36.59441,
                                -10.57724
                            ],
                            [
                                -36.38973,
                                -10.49887
                            ],
                            [
                                -36.29913,
                                -10.35817
                            ],
                            [
                                -36.2829,
                                -10.29011
                            ],
                            [
                                -36.08986,
                                -10.0984
                            ],
                            [
                                -36.04509,
                                -10.07174
                            ],
                            [
                                -35.94172,
                                -9.90889
                            ],
                            [
                                -35.77779,
                                -9.68202
                            ],
                            [
                                -35.70303,
                                -9.66516
                            ],
                            [
                                -35.69199,
                                -9.62591
                            ],
                            [
                                -35.5018,
                                -9.42027
                            ],
                            [
                                -35.46697,
                                -9.353
                            ],
                            [
                                -35.37117,
                                -9.2736
                            ],
                            [
                                -35.30321,
                                -9.18489
                            ],
                            [
                                -35.22568,
                                -9.02449
                            ],
                            [
                                -35.17927,
                                -8.97053
                            ],
                            [
                                -35.08924,
                                -8.74607
                            ],
                            [
                                -35.08408,
                                -8.68989
                            ],
                            [
                                -35.03564,
                                -8.5772
                            ],
                            [
                                -35.00669,
                                -8.55305
                            ],
                            [
                                -34.94408,
                                -8.35169
                            ],
                            [
                                -34.94959,
                                -8.29086
                            ],
                            [
                                -34.86764,
                                -8.04083
                            ],
                            [
                                -34.82274,
                                -7.93252
                            ],
                            [
                                -34.84404,
                                -7.82468
                            ],
                            [
                                -34.8248,
                                -7.74958
                            ],
                            [
                                -34.83332,
                                -7.68743
                            ],
                            [
                                -34.8105,
                                -7.62465
                            ],
                            [
                                -34.83324,
                                -7.55586
                            ],
                            [
                                -34.81371,
                                -7.51922
                            ],
                            [
                                -34.79628,
                                -7.33752
                            ],
                            [
                                -34.79846,
                                -7.15064
                            ],
                            [
                                -34.8382,
                                -7.04521
                            ],
                            [
                                -34.83052,
                                -6.97375
                            ],
                            [
                                -34.89609,
                                -6.8672
                            ],
                            [
                                -34.93338,
                                -6.75976
                            ],
                            [
                                -34.93261,
                                -6.6947
                            ],
                            [
                                -34.96181,
                                -6.62991
                            ],
                            [
                                -34.97927,
                                -6.40911
                            ],
                            [
                                -35.02635,
                                -6.34895
                            ],
                            [
                                -35.04032,
                                -6.23526
                            ],
                            [
                                -35.09393,
                                -6.17573
                            ],
                            [
                                -35.1095,
                                -6.00243
                            ],
                            [
                                -35.14807,
                                -5.95453
                            ],
                            [
                                -35.17749,
                                -5.86392
                            ],
                            [
                                -35.22864,
                                -5.58244
                            ],
                            [
                                -35.31483,
                                -5.38755
                            ],
                            [
                                -35.35806,
                                -5.34106
                            ],
                            [
                                -35.41371,
                                -5.22687
                            ],
                            [
                                -35.49059,
                                -5.15991
                            ],
                            [
                                -35.60987,
                                -5.11897
                            ],
                            [
                                -35.95467,
                                -5.04482
                            ],
                            [
                                -36.02816,
                                -5.05118
                            ],
                            [
                                -36.12263,
                                -5.0883
                            ],
                            [
                                -36.24095,
                                -5.10694
                            ],
                            [
                                -36.29167,
                                -5.13582
                            ],
                            [
                                -36.34496,
                                -5.09035
                            ],
                            [
                                -36.48592,
                                -5.08005
                            ],
                            [
                                -36.54938,
                                -5.13476
                            ],
                            [
                                -36.6459,
                                -5.0917
                            ],
                            [
                                -36.68168,
                                -5.1018
                            ],
                            [
                                -36.80535,
                                -5.03122
                            ],
                            [
                                -36.87459,
                                -4.9578
                            ],
                            [
                                -36.95359,
                                -4.92632
                            ],
                            [
                                -37.03789,
                                -4.94789
                            ],
                            [
                                -37.10169,
                                -4.92635
                            ],
                            [
                                -37.15424,
                                -4.94378
                            ],
                            [
                                -37.22494,
                                -4.87436
                            ],
                            [
                                -37.28743,
                                -4.74253
                            ],
                            [
                                -37.33594,
                                -4.69576
                            ],
                            [
                                -37.49629,
                                -4.63219
                            ],
                            [
                                -37.59776,
                                -4.61978
                            ],
                            [
                                -37.71981,
                                -4.50469
                            ],
                            [
                                -37.7746,
                                -4.4048
                            ],
                            [
                                -37.85753,
                                -4.37474
                            ],
                            [
                                -38.01933,
                                -4.24054
                            ],
                            [
                                -38.11237,
                                -4.15006
                            ],
                            [
                                -38.2694,
                                -3.95067
                            ],
                            [
                                -38.33174,
                                -3.91399
                            ],
                            [
                                -38.39581,
                                -3.83539
                            ],
                            [
                                -38.46762,
                                -3.71063
                            ],
                            [
                                -38.50916,
                                -3.72146
                            ],
                            [
                                -38.65679,
                                -3.67778
                            ],
                            [
                                -38.76021,
                                -3.60549
                            ],
                            [
                                -38.80915,
                                -3.54911
                            ],
                            [
                                -38.91066,
                                -3.49987
                            ],
                            [
                                -38.94242,
                                -3.44813
                            ],
                            [
                                -39.0078,
                                -3.39895
                            ],
                            [
                                -39.06338,
                                -3.40958
                            ],
                            [
                                -39.15835,
                                -3.33166
                            ],
                            [
                                -39.25236,
                                -3.22433
                            ],
                            [
                                -39.3519,
                                -3.17699
                            ],
                            [
                                -39.46267,
                                -3.14233
                            ],
                            [
                                -39.62765,
                                -3.02616
                            ],
                            [
                                -39.72131,
                                -2.99458
                            ],
                            [
                                -39.84517,
                                -2.91259
                            ],
                            [
                                -39.98533,
                                -2.84438
                            ],
                            [
                                -40.197,
                                -2.81181
                            ],
                            [
                                -40.41552,
                                -2.81175
                            ],
                            [
                                -40.50179,
                                -2.78786
                            ],
                            [
                                -40.58237,
                                -2.84513
                            ],
                            [
                                -40.76003,
                                -2.8524
                            ],
                            [
                                -41.02489,
                                -2.89271
                            ],
                            [
                                -41.25704,
                                -2.88866
                            ],
                            [
                                -41.34094,
                                -2.92395
                            ],
                            [
                                -41.47983,
                                -2.90052
                            ],
                            [
                                -41.59967,
                                -2.90062
                            ],
                            [
                                -41.75449,
                                -2.79603
                            ],
                            [
                                -41.79792,
                                -2.73523
                            ],
                            [
                                -42.00927,
                                -2.71744
                            ],
                            [
                                -42.01017,
                                -2.78724
                            ],
                            [
                                -42.06274,
                                -2.78365
                            ],
                            [
                                -42.14123,
                                -2.76377
                            ],
                            [
                                -42.23742,
                                -2.80205
                            ],
                            [
                                -42.27202,
                                -2.75758
                            ],
                            [
                                -42.37464,
                                -2.71719
                            ],
                            [
                                -42.4785,
                                -2.70509
                            ],
                            [
                                -42.57935,
                                -2.67261
                            ],
                            [
                                -42.70481,
                                -2.57254
                            ],
                            [
                                -42.80834,
                                -2.5549
                            ],
                            [
                                -42.92289,
                                -2.49617
                            ],
                            [
                                -43.21195,
                                -2.37185
                            ],
                            [
                                -43.31653,
                                -2.34062
                            ],
                            [
                                -43.40797,
                                -2.33809
                            ],
                            [
                                -43.45499,
                                -2.40113
                            ],
                            [
                                -43.4681,
                                -2.50502
                            ],
                            [
                                -43.54765,
                                -2.44069
                            ],
                            [
                                -43.57885,
                                -2.51234
                            ],
                            [
                                -43.68504,
                                -2.52824
                            ],
                            [
                                -43.72258,
                                -2.48181
                            ],
                            [
                                -43.82231,
                                -2.46662
                            ],
                            [
                                -43.84552,
                                -2.51691
                            ],
                            [
                                -43.92372,
                                -2.56272
                            ],
                            [
                                -43.95743,
                                -2.62131
                            ],
                            [
                                -44.01602,
                                -2.65241
                            ],
                            [
                                -44.11062,
                                -2.75373
                            ],
                            [
                                -44.28003,
                                -2.80169
                            ],
                            [
                                -44.3052,
                                -2.76801
                            ],
                            [
                                -44.1408,
                                -2.67891
                            ],
                            [
                                -44.07685,
                                -2.56502
                            ],
                            [
                                -44.03721,
                                -2.54836
                            ],
                            [
                                -44.04914,
                                -2.47065
                            ],
                            [
                                -44.03027,
                                -2.41334
                            ],
                            [
                                -44.09961,
                                -2.41188
                            ],
                            [
                                -44.18221,
                                -2.46111
                            ],
                            [
                                -44.30166,
                                -2.49243
                            ],
                            [
                                -44.36595,
                                -2.57257
                            ],
                            [
                                -44.40688,
                                -2.78894
                            ],
                            [
                                -44.40702,
                                -2.89233
                            ],
                            [
                                -44.4493,
                                -2.98987
                            ],
                            [
                                -44.60089,
                                -3.11411
                            ],
                            [
                                -44.64886,
                                -3.19643
                            ],
                            [
                                -44.72953,
                                -3.17583
                            ],
                            [
                                -44.62239,
                                -3.06213
                            ],
                            [
                                -44.67315,
                                -2.9981
                            ],
                            [
                                -44.68082,
                                -2.93926
                            ],
                            [
                                -44.6372,
                                -2.85757
                            ],
                            [
                                -44.67769,
                                -2.71224
                            ],
                            [
                                -44.61143,
                                -2.69213
                            ],
                            [
                                -44.47629,
                                -2.41601
                            ],
                            [
                                -44.3925,
                                -2.40891
                            ],
                            [
                                -44.36179,
                                -2.3344
                            ],
                            [
                                -44.39396,
                                -2.23238
                            ],
                            [
                                -44.45923,
                                -2.14866
                            ],
                            [
                                -44.52258,
                                -2.15923
                            ],
                            [
                                -44.61869,
                                -2.26572
                            ],
                            [
                                -44.63386,
                                -2.22684
                            ],
                            [
                                -44.59353,
                                -2.13521
                            ],
                            [
                                -44.49027,
                                -2.04175
                            ],
                            [
                                -44.50841,
                                -1.89776
                            ],
                            [
                                -44.60717,
                                -1.7439
                            ],
                            [
                                -44.7162,
                                -1.78535
                            ],
                            [
                                -44.71151,
                                -1.71932
                            ],
                            [
                                -44.79109,
                                -1.70446
                            ],
                            [
                                -44.74592,
                                -1.64925
                            ],
                            [
                                -44.65386,
                                -1.64745
                            ],
                            [
                                -44.64411,
                                -1.61436
                            ],
                            [
                                -44.72809,
                                -1.5647
                            ],
                            [
                                -44.76607,
                                -1.60237
                            ],
                            [
                                -44.829,
                                -1.58057
                            ],
                            [
                                -44.91577,
                                -1.61638
                            ],
                            [
                                -44.91335,
                                -1.54685
                            ],
                            [
                                -44.83364,
                                -1.43757
                            ],
                            [
                                -44.87636,
                                -1.42019
                            ],
                            [
                                -44.96982,
                                -1.49999
                            ],
                            [
                                -45.07714,
                                -1.47821
                            ],
                            [
                                -45.19124,
                                -1.50186
                            ],
                            [
                                -45.25228,
                                -1.59777
                            ],
                            [
                                -45.2211,
                                -1.67553
                            ],
                            [
                                -45.27506,
                                -1.74256
                            ],
                            [
                                -45.32842,
                                -1.74847
                            ],
                            [
                                -45.36347,
                                -1.7123
                            ],
                            [
                                -45.30113,
                                -1.43065
                            ],
                            [
                                -45.31459,
                                -1.33033
                            ],
                            [
                                -45.37188,
                                -1.36761
                            ],
                            [
                                -45.40879,
                                -1.43878
                            ],
                            [
                                -45.49533,
                                -1.48359
                            ],
                            [
                                -45.47322,
                                -1.37949
                            ],
                            [
                                -45.41915,
                                -1.3472
                            ],
                            [
                                -45.4275,
                                -1.29374
                            ],
                            [
                                -45.51936,
                                -1.31042
                            ],
                            [
                                -45.62192,
                                -1.29016
                            ],
                            [
                                -45.63907,
                                -1.36845
                            ],
                            [
                                -45.69818,
                                -1.37157
                            ],
                            [
                                -45.70877,
                                -1.27704
                            ],
                            [
                                -45.77067,
                                -1.19561
                            ],
                            [
                                -45.86187,
                                -1.22456
                            ],
                            [
                                -45.87855,
                                -1.15694
                            ],
                            [
                                -45.84853,
                                -1.09426
                            ],
                            [
                                -45.86891,
                                -1.05864
                            ],
                            [
                                -45.93775,
                                -1.18278
                            ],
                            [
                                -45.97466,
                                -1.13486
                            ],
                            [
                                -46.0443,
                                -1.12187
                            ],
                            [
                                -46.15884,
                                -1.01641
                            ],
                            [
                                -46.22581,
                                -1.02985
                            ],
                            [
                                -46.20449,
                                -0.94789
                            ],
                            [
                                -46.2438,
                                -0.90407
                            ],
                            [
                                -46.28941,
                                -0.99903
                            ],
                            [
                                -46.33638,
                                -1.03831
                            ],
                            [
                                -46.40259,
                                -1.0005
                            ],
                            [
                                -46.46948,
                                -1.04075
                            ],
                            [
                                -46.49035,
                                -1.00439
                            ],
                            [
                                -46.47084,
                                -0.91368
                            ],
                            [
                                -46.54956,
                                -0.91559
                            ],
                            [
                                -46.60234,
                                -0.96357
                            ],
                            [
                                -46.65137,
                                -0.9729
                            ],
                            [
                                -46.60964,
                                -0.82385
                            ],
                            [
                                -46.64644,
                                -0.79626
                            ],
                            [
                                -46.71137,
                                -0.85012
                            ],
                            [
                                -46.74469,
                                -0.82926
                            ],
                            [
                                -46.83283,
                                -0.84538
                            ],
                            [
                                -46.83111,
                                -0.76027
                            ],
                            [
                                -46.94135,
                                -0.8488
                            ],
                            [
                                -46.95287,
                                -0.7369
                            ],
                            [
                                -47.06924,
                                -0.79647
                            ],
                            [
                                -47.09856,
                                -0.75463
                            ],
                            [
                                -47.20566,
                                -0.70203
                            ],
                            [
                                -47.20673,
                                -0.65513
                            ],
                            [
                                -47.31172,
                                -0.59525
                            ],
                            [
                                -47.42579,
                                -0.64423
                            ],
                            [
                                -47.48837,
                                -0.73457
                            ],
                            [
                                -47.54202,
                                -0.64093
                            ],
                            [
                                -47.63431,
                                -0.62603
                            ],
                            [
                                -47.71059,
                                -0.54248
                            ],
                            [
                                -47.73802,
                                -0.54461
                            ],
                            [
                                -47.85036,
                                -0.62551
                            ],
                            [
                                -47.86731,
                                -0.56585
                            ],
                            [
                                -47.91299,
                                -0.56663
                            ],
                            [
                                -47.97154,
                                -0.70394
                            ],
                            [
                                -48.06115,
                                -0.67087
                            ],
                            [
                                -48.17224,
                                -0.81617
                            ],
                            [
                                -48.2336,
                                -0.8381
                            ],
                            [
                                -48.30657,
                                -0.95715
                            ],
                            [
                                -48.31268,
                                -1.0609
                            ],
                            [
                                -48.40981,
                                -1.07696
                            ],
                            [
                                -48.46659,
                                -1.14304
                            ],
                            [
                                -48.43495,
                                -1.21845
                            ],
                            [
                                -48.48164,
                                -1.27851
                            ],
                            [
                                -48.50356,
                                -1.46314
                            ],
                            [
                                -48.49769,
                                -1.53012
                            ],
                            [
                                -48.55161,
                                -1.52508
                            ],
                            [
                                -48.6302,
                                -1.40165
                            ],
                            [
                                -48.77698,
                                -1.57584
                            ],
                            [
                                -48.86063,
                                -1.55658
                            ],
                            [
                                -48.97649,
                                -1.60497
                            ],
                            [
                                -49.04128,
                                -1.70204
                            ],
                            [
                                -49.1384,
                                -1.61365
                            ],
                            [
                                -49.12505,
                                -1.57079
                            ],
                            [
                                -49.00082,
                                -1.52091
                            ],
                            [
                                -48.89652,
                                -1.50129
                            ],
                            [
                                -48.82527,
                                -1.44386
                            ],
                            [
                                -48.78352,
                                -1.2636
                            ],
                            [
                                -48.74597,
                                -1.22361
                            ],
                            [
                                -48.73883,
                                -1.15975
                            ],
                            [
                                -48.62293,
                                -1.06765
                            ],
                            [
                                -48.63295,
                                -0.99709
                            ],
                            [
                                -48.60805,
                                -0.94988
                            ],
                            [
                                -48.5357,
                                -0.91924
                            ],
                            [
                                -48.51094,
                                -0.87797
                            ],
                            [
                                -48.5234,
                                -0.80202
                            ],
                            [
                                -48.48325,
                                -0.67117
                            ],
                            [
                                -48.47593,
                                -0.50432
                            ],
                            [
                                -48.44333,
                                -0.41789
                            ],
                            [
                                -48.39443,
                                -0.35945
                            ],
                            [
                                -48.39891,
                                -0.25234
                            ],
                            [
                                -48.43908,
                                -0.23458
                            ],
                            [
                                -48.62741,
                                -0.23147
                            ],
                            [
                                -48.71177,
                                -0.2523
                            ],
                            [
                                -48.83546,
                                -0.22307
                            ],
                            [
                                -48.94694,
                                -0.21996
                            ],
                            [
                                -49.01514,
                                -0.16237
                            ],
                            [
                                -49.12857,
                                -0.17003
                            ],
                            [
                                -49.19257,
                                -0.13472
                            ],
                            [
                                -49.24732,
                                -0.16575
                            ],
                            [
                                -49.33345,
                                -0.16332
                            ],
                            [
                                -49.45946,
                                -0.22264
                            ],
                            [
                                -49.61434,
                                -0.24286
                            ],
                            [
                                -49.67344,
                                -0.2389
                            ],
                            [
                                -49.80147,
                                -0.19273
                            ],
                            [
                                -49.84734,
                                -0.19751
                            ],
                            [
                                -50.12843,
                                -0.13157
                            ],
                            [
                                -50.24726,
                                -0.1269
                            ],
                            [
                                -50.32586,
                                -0.09321
                            ],
                            [
                                -50.40705,
                                -0.10237
                            ],
                            [
                                -50.48212,
                                -0.15626
                            ],
                            [
                                -50.56181,
                                -0.18296
                            ],
                            [
                                -50.64982,
                                -0.26788
                            ],
                            [
                                -50.71276,
                                -0.43187
                            ],
                            [
                                -50.84832,
                                -0.36857
                            ],
                            [
                                -50.94598,
                                -0.35209
                            ],
                            [
                                -50.88822,
                                -0.28749
                            ],
                            [
                                -50.7784,
                                -0.19805
                            ],
                            [
                                -50.71643,
                                -0.17269
                            ],
                            [
                                -50.62547,
                                -0.09284
                            ],
                            [
                                -50.66193,
                                -0.02023
                            ],
                            [
                                -50.71836,
                                0.00385
                            ],
                            [
                                -50.77954,
                                0.18578
                            ],
                            [
                                -50.70312,
                                0.29996
                            ],
                            [
                                -50.57563,
                                0.43002
                            ],
                            [
                                -50.46564,
                                0.64431
                            ],
                            [
                                -50.31891,
                                0.75407
                            ],
                            [
                                -50.28044,
                                0.86384
                            ],
                            [
                                -50.11627,
                                0.95799
                            ],
                            [
                                -50.06752,
                                1.02876
                            ],
                            [
                                -50.04913,
                                1.04586
                            ],
                            [
                                -49.96562,
                                1.08304
                            ],
                            [
                                -49.88616,
                                1.15455
                            ],
                            [
                                -49.8774,
                                1.2245
                            ],
                            [
                                -49.98078,
                                1.20515
                            ],
                            [
                                -49.87804,
                                1.3461
                            ],
                            [
                                -49.89988,
                                1.60383
                            ],
                            [
                                -49.92428,
                                1.69491
                            ],
                            [
                                -50.035,
                                1.76305
                            ],
                            [
                                -50.16387,
                                1.81272
                            ],
                            [
                                -50.32931,
                                1.81511
                            ],
                            [
                                -50.3994,
                                1.80204
                            ],
                            [
                                -50.50539,
                                1.85041
                            ],
                            [
                                -50.52482,
                                1.92699
                            ],
                            [
                                -50.59223,
                                1.99516
                            ],
                            [
                                -50.60058,
                                2.06616
                            ],
                            [
                                -50.65741,
                                2.11224
                            ],
                            [
                                -50.72435,
                                2.21056
                            ],
                            [
                                -50.72592,
                                2.28921
                            ],
                            [
                                -50.76354,
                                2.36443
                            ],
                            [
                                -50.76965,
                                2.44913
                            ],
                            [
                                -50.83385,
                                2.5355
                            ],
                            [
                                -50.8458,
                                2.63427
                            ],
                            [
                                -50.88158,
                                2.68793
                            ],
                            [
                                -50.90619,
                                2.79378
                            ],
                            [
                                -50.94511,
                                2.80984
                            ],
                            [
                                -50.94749,
                                2.88139
                            ],
                            [
                                -50.98995,
                                2.96035
                            ],
                            [
                                -51.00884,
                                3.08047
                            ],
                            [
                                -51.03658,
                                3.14204
                            ],
                            [
                                -51.02677,
                                3.20148
                            ],
                            [
                                -51.07794,
                                3.35736
                            ],
                            [
                                -51.08903,
                                3.44801
                            ],
                            [
                                -51.07064,
                                3.4835
                            ],
                            [
                                -51.08306,
                                3.69809
                            ],
                            [
                                -51.06389,
                                3.87419
                            ],
                            [
                                -51.10898,
                                3.89473
                            ],
                            [
                                -51.16589,
                                3.82328
                            ],
                            [
                                -51.16141,
                                4.02895
                            ],
                            [
                                -51.19327,
                                4.11853
                            ],
                            [
                                -51.33013,
                                4.28701
                            ],
                            [
                                -51.47671,
                                4.41873
                            ],
                            [
                                -51.53302,
                                4.44214
                            ],
                            [
                                -51.57189,
                                4.35124
                            ],
                            [
                                -51.54268,
                                4.23268
                            ],
                            [
                                -51.60605,
                                4.21523
                            ],
                            [
                                -51.60219,
                                4.17338
                            ],
                            [
                                -51.65546,
                                4.05599
                            ],
                            [
                                -51.78213,
                                3.96384
                            ],
                            [
                                -51.79867,
                                3.88731
                            ],
                            [
                                -51.97218,
                                3.70513
                            ],
                            [
                                -51.98899,
                                3.62721
                            ],
                            [
                                -52.08794,
                                3.48613
                            ],
                            [
                                -52.22707,
                                3.24935
                            ],
                            [
                                -52.29243,
                                3.22356
                            ],
                            [
                                -52.34942,
                                3.12302
                            ],
                            [
                                -52.32704,
                                3.07646
                            ],
                            [
                                -52.47279,
                                2.79438
                            ],
                            [
                                -52.52918,
                                2.65421
                            ],
                            [
                                -52.5277,
                                2.58322
                            ],
                            [
                                -52.5527,
                                2.52082
                            ],
                            [
                                -52.61929,
                                2.47311
                            ],
                            [
                                -52.66143,
                                2.37441
                            ],
                            [
                                -52.85634,
                                2.28009
                            ],
                            [
                                -52.90472,
                                2.19023
                            ],
                            [
                                -52.98111,
                                2.16861
                            ],
                            [
                                -53.13307,
                                2.22441
                            ],
                            [
                                -53.22112,
                                2.20233
                            ],
                            [
                                -53.25608,
                                2.27135
                            ],
                            [
                                -53.34007,
                                2.35039
                            ],
                            [
                                -53.46187,
                                2.25387
                            ],
                            [
                                -53.53193,
                                2.25245
                            ],
                            [
                                -53.72223,
                                2.31139
                            ],
                            [
                                -53.73854,
                                2.37236
                            ],
                            [
                                -53.8085,
                                2.35208
                            ],
                            [
                                -53.81569,
                                2.31193
                            ],
                            [
                                -53.93456,
                                2.279
                            ],
                            [
                                -53.94362,
                                2.21745
                            ],
                            [
                                -54.06419,
                                2.19594
                            ],
                            [
                                -54.10462,
                                2.12256
                            ],
                            [
                                -54.14199,
                                2.11528
                            ],
                            [
                                -54.19398,
                                2.16928
                            ],
                            [
                                -54.27124,
                                2.14535
                            ],
                            [
                                -54.34034,
                                2.15366
                            ],
                            [
                                -54.36124,
                                2.2093
                            ],
                            [
                                -54.47667,
                                2.2141
                            ],
                            [
                                -54.58789,
                                2.32207
                            ],
                            [
                                -54.68378,
                                2.32872
                            ],
                            [
                                -54.72405,
                                2.40014
                            ],
                            [
                                -54.68957,
                                2.4495
                            ],
                            [
                                -54.74383,
                                2.47675
                            ],
                            [
                                -54.85654,
                                2.43495
                            ],
                            [
                                -54.9578,
                                2.54025
                            ],
                            [
                                -54.97282,
                                2.6047
                            ],
                            [
                                -55.10197,
                                2.523
                            ],
                            [
                                -55.13006,
                                2.5707
                            ],
                            [
                                -55.18637,
                                2.55388
                            ],
                            [
                                -55.25966,
                                2.49485
                            ],
                            [
                                -55.30076,
                                2.5223
                            ],
                            [
                                -55.35819,
                                2.48603
                            ],
                            [
                                -55.36579,
                                2.41233
                            ],
                            [
                                -55.42892,
                                2.43937
                            ],
                            [
                                -55.59238,
                                2.4331
                            ],
                            [
                                -55.7271,
                                2.39952
                            ],
                            [
                                -55.78452,
                                2.45435
                            ],
                            [
                                -55.83292,
                                2.46478
                            ],
                            [
                                -55.9384,
                                2.53103
                            ],
                            [
                                -55.988,
                                2.51456
                            ],
                            [
                                -55.99428,
                                2.40659
                            ],
                            [
                                -56.04742,
                                2.3434
                            ],
                            [
                                -56.09101,
                                2.35084
                            ],
                            [
                                -56.13337,
                                2.25945
                            ],
                            [
                                -56.0483,
                                2.22587
                            ],
                            [
                                -56.05065,
                                2.18715
                            ],
                            [
                                -55.9236,
                                2.05724
                            ],
                            [
                                -55.90712,
                                1.89199
                            ],
                            [
                                -55.97376,
                                1.83689
                            ],
                            [
                                -56.02717,
                                1.83559
                            ],
                            [
                                -56.18852,
                                1.89165
                            ],
                            [
                                -56.2664,
                                1.88933
                            ],
                            [
                                -56.35928,
                                1.93923
                            ],
                            [
                                -56.41109,
                                1.92545
                            ],
                            [
                                -56.47737,
                                1.94594
                            ],
                            [
                                -56.59181,
                                1.91542
                            ],
                            [
                                -56.63645,
                                1.93862
                            ],
                            [
                                -56.72658,
                                1.91812
                            ],
                            [
                                -56.79856,
                                1.86392
                            ],
                            [
                                -56.91529,
                                1.91794
                            ],
                            [
                                -56.98492,
                                1.9109
                            ],
                            [
                                -57.06014,
                                1.9585
                            ],
                            [
                                -57.08038,
                                2.0175
                            ],
                            [
                                -57.1228,
                                2.01372
                            ],
                            [
                                -57.23519,
                                1.94671
                            ],
                            [
                                -57.30391,
                                1.98958
                            ],
                            [
                                -57.44126,
                                1.88266
                            ],
                            [
                                -57.45398,
                                1.83796
                            ],
                            [
                                -57.54606,
                                1.70008
                            ],
                            [
                                -57.63802,
                                1.68965
                            ],
                            [
                                -57.77088,
                                1.71791
                            ],
                            [
                                -57.81772,
                                1.67882
                            ],
                            [
                                -57.93337,
                                1.64522
                            ],
                            [
                                -57.99946,
                                1.66413
                            ],
                            [
                                -58.00873,
                                1.50102
                            ],
                            [
                                -58.14304,
                                1.5097
                            ],
                            [
                                -58.16749,
                                1.55791
                            ],
                            [
                                -58.23294,
                                1.55211
                            ],
                            [
                                -58.32423,
                                1.58966
                            ],
                            [
                                -58.38204,
                                1.52871
                            ],
                            [
                                -58.38311,
                                1.47023
                            ],
                            [
                                -58.48278,
                                1.46317
                            ],
                            [
                                -58.47419,
                                1.29866
                            ],
                            [
                                -58.50655,
                                1.26511
                            ],
                            [
                                -58.69733,
                                1.28774
                            ],
                            [
                                -58.74804,
                                1.19764
                            ],
                            [
                                -58.79748,
                                1.17533
                            ],
                            [
                                -58.90262,
                                1.23331
                            ],
                            [
                                -58.93996,
                                1.30882
                            ],
                            [
                                -59.15511,
                                1.34835
                            ],
                            [
                                -59.2507,
                                1.39626
                            ],
                            [
                                -59.34545,
                                1.51905
                            ],
                            [
                                -59.38117,
                                1.5202
                            ],
                            [
                                -59.44244,
                                1.60827
                            ],
                            [
                                -59.47936,
                                1.6297
                            ],
                            [
                                -59.54793,
                                1.72752
                            ],
                            [
                                -59.62065,
                                1.7301
                            ],
                            [
                                -59.67941,
                                1.78498
                            ],
                            [
                                -59.64243,
                                1.82842
                            ],
                            [
                                -59.74655,
                                1.84655
                            ],
                            [
                                -59.75641,
                                1.92085
                            ],
                            [
                                -59.72087,
                                2.02639
                            ],
                            [
                                -59.73939,
                                2.17702
                            ],
                            [
                                -59.72511,
                                2.27842
                            ],
                            [
                                -59.8009,
                                2.29125
                            ],
                            [
                                -59.89619,
                                2.36284
                            ],
                            [
                                -59.90747,
                                2.46473
                            ],
                            [
                                -59.96311,
                                2.58852
                            ],
                            [
                                -59.98952,
                                2.68283
                            ],
                            [
                                -59.99152,
                                2.82581
                            ],
                            [
                                -59.96239,
                                2.94604
                            ],
                            [
                                -59.95848,
                                3.06239
                            ],
                            [
                                -59.90274,
                                3.12254
                            ],
                            [
                                -59.90987,
                                3.18244
                            ],
                            [
                                -59.86908,
                                3.27011
                            ],
                            [
                                -59.7995,
                                3.35521
                            ],
                            [
                                -59.83284,
                                3.44494
                            ],
                            [
                                -59.80519,
                                3.49637
                            ],
                            [
                                -59.86403,
                                3.55841
                            ],
                            [
                                -59.84983,
                                3.59861
                            ],
                            [
                                -59.66208,
                                3.71044
                            ],
                            [
                                -59.6657,
                                3.77634
                            ],
                            [
                                -59.5935,
                                3.79734
                            ],
                            [
                                -59.57871,
                                3.88997
                            ],
                            [
                                -59.51703,
                                3.94047
                            ],
                            [
                                -59.61914,
                                4.0593
                            ],
                            [
                                -59.64495,
                                4.14829
                            ],
                            [
                                -59.71327,
                                4.16994
                            ],
                            [
                                -59.72671,
                                4.29005
                            ],
                            [
                                -59.67891,
                                4.34508
                            ],
                            [
                                -59.78168,
                                4.43939
                            ],
                            [
                                -59.90528,
                                4.4695
                            ],
                            [
                                -59.92644,
                                4.50849
                            ],
                            [
                                -60.06619,
                                4.49442
                            ],
                            [
                                -60.16258,
                                4.52113
                            ],
                            [
                                -60.15861,
                                4.5699
                            ],
                            [
                                -60.09301,
                                4.59561
                            ],
                            [
                                -60.07451,
                                4.66063
                            ],
                            [
                                -60.02998,
                                4.70522
                            ],
                            [
                                -60.03148,
                                4.8055
                            ],
                            [
                                -59.96976,
                                5.06815
                            ],
                            [
                                -60.08395,
                                5.1475
                            ],
                            [
                                -60.12192,
                                5.22171
                            ],
                            [
                                -60.21198,
                                5.26422
                            ],
                            [
                                -60.32998,
                                5.19906
                            ],
                            [
                                -60.39621,
                                5.21127
                            ],
                            [
                                -60.43731,
                                5.1776
                            ],
                            [
                                -60.56775,
                                5.18899
                            ],
                            [
                                -60.6664,
                                5.22119
                            ],
                            [
                                -60.73177,
                                5.19614
                            ],
                            [
                                -60.68474,
                                5.19317
                            ],
                            [
                                -60.64102,
                                5.11233
                            ],
                            [
                                -60.63981,
                                5.05507
                            ],
                            [
                                -60.58258,
                                4.95622
                            ],
                            [
                                -60.65747,
                                4.84675
                            ],
                            [
                                -60.74949,
                                4.75291
                            ],
                            [
                                -60.80116,
                                4.74722
                            ],
                            [
                                -60.84952,
                                4.70239
                            ],
                            [
                                -60.89764,
                                4.71709
                            ],
                            [
                                -60.94587,
                                4.6564
                            ],
                            [
                                -60.93202,
                                4.58504
                            ],
                            [
                                -60.99674,
                                4.51749
                            ],
                            [
                                -61.09242,
                                4.52247
                            ],
                            [
                                -61.1469,
                                4.48331
                            ],
                            [
                                -61.18575,
                                4.5178
                            ],
                            [
                                -61.29245,
                                4.53945
                            ],
                            [
                                -61.27949,
                                4.46746
                            ],
                            [
                                -61.34409,
                                4.41896
                            ],
                            [
                                -61.45437,
                                4.43748
                            ],
                            [
                                -61.51063,
                                4.40466
                            ],
                            [
                                -61.50973,
                                4.31437
                            ],
                            [
                                -61.55658,
                                4.25419
                            ],
                            [
                                -61.65376,
                                4.26094
                            ],
                            [
                                -61.79249,
                                4.22679
                            ],
                            [
                                -61.83839,
                                4.15974
                            ],
                            [
                                -61.93691,
                                4.13234
                            ],
                            [
                                -62.00708,
                                4.17257
                            ],
                            [
                                -62.06292,
                                4.15599
                            ],
                            [
                                -62.14207,
                                4.08281
                            ],
                            [
                                -62.39932,
                                4.17938
                            ],
                            [
                                -62.46317,
                                4.17293
                            ],
                            [
                                -62.52977,
                                4.12744
                            ],
                            [
                                -62.55568,
                                4.02051
                            ],
                            [
                                -62.66888,
                                4.04612
                            ],
                            [
                                -62.72977,
                                4.03792
                            ],
                            [
                                -62.77996,
                                3.90446
                            ],
                            [
                                -62.7286,
                                3.73112
                            ],
                            [
                                -62.76783,
                                3.68826
                            ],
                            [
                                -62.83814,
                                3.73384
                            ],
                            [
                                -62.95714,
                                3.61175
                            ],
                            [
                                -63.06872,
                                3.68835
                            ],
                            [
                                -63.07621,
                                3.76935
                            ],
                            [
                                -63.12005,
                                3.80534
                            ],
                            [
                                -63.20509,
                                3.81753
                            ],
                            [
                                -63.22588,
                                3.89827
                            ],
                            [
                                -63.35552,
                                3.96406
                            ],
                            [
                                -63.42587,
                                3.96033
                            ],
                            [
                                -63.45325,
                                3.87416
                            ],
                            [
                                -63.53887,
                                3.87291
                            ],
                            [
                                -63.60569,
                                3.94094
                            ],
                            [
                                -63.6553,
                                3.95378
                            ],
                            [
                                -63.78833,
                                3.93377
                            ],
                            [
                                -63.84305,
                                3.9586
                            ],
                            [
                                -63.9547,
                                3.89269
                            ],
                            [
                                -64.01467,
                                3.88594
                            ],
                            [
                                -64.05749,
                                3.92466
                            ],
                            [
                                -64.09332,
                                4.04472
                            ],
                            [
                                -64.13018,
                                4.11145
                            ],
                            [
                                -64.23828,
                                4.14464
                            ],
                            [
                                -64.38575,
                                4.15243
                            ],
                            [
                                -64.54091,
                                4.12356
                            ],
                            [
                                -64.60763,
                                4.14614
                            ],
                            [
                                -64.65933,
                                4.24681
                            ],
                            [
                                -64.73495,
                                4.28506
                            ],
                            [
                                -64.79317,
                                4.2821
                            ],
                            [
                                -64.79256,
                                4.19226
                            ],
                            [
                                -64.72009,
                                4.15271
                            ],
                            [
                                -64.64575,
                                3.99171
                            ],
                            [
                                -64.56814,
                                3.92167
                            ],
                            [
                                -64.5349,
                                3.86102
                            ],
                            [
                                -64.43869,
                                3.78256
                            ],
                            [
                                -64.33002,
                                3.73724
                            ],
                            [
                                -64.19595,
                                3.60056
                            ],
                            [
                                -64.18358,
                                3.53944
                            ],
                            [
                                -64.23651,
                                3.42872
                            ],
                            [
                                -64.2057,
                                3.25791
                            ],
                            [
                                -64.21797,
                                3.12418
                            ],
                            [
                                -64.14731,
                                3.04158
                            ],
                            [
                                -64.13924,
                                2.99171
                            ],
                            [
                                -64.0798,
                                2.92606
                            ],
                            [
                                -64.01083,
                                2.80335
                            ],
                            [
                                -63.98799,
                                2.72476
                            ],
                            [
                                -63.99386,
                                2.63108
                            ],
                            [
                                -64.04682,
                                2.51428
                            ],
                            [
                                -64.03928,
                                2.47377
                            ],
                            [
                                -63.93337,
                                2.45793
                            ],
                            [
                                -63.84141,
                                2.4927
                            ],
                            [
                                -63.74833,
                                2.44232
                            ],
                            [
                                -63.69424,
                                2.45696
                            ],
                            [
                                -63.62242,
                                2.43518
                            ],
                            [
                                -63.37376,
                                2.42338
                            ],
                            [
                                -63.35817,
                                2.26669
                            ],
                            [
                                -63.40219,
                                2.14668
                            ],
                            [
                                -63.54393,
                                2.1309
                            ],
                            [
                                -63.6057,
                                2.11112
                            ],
                            [
                                -63.78137,
                                1.98971
                            ],
                            [
                                -63.91276,
                                1.99975
                            ],
                            [
                                -63.98065,
                                1.98667
                            ],
                            [
                                -64.05665,
                                1.93075
                            ],
                            [
                                -64.05166,
                                1.71728
                            ],
                            [
                                -64.09386,
                                1.61391
                            ],
                            [
                                -64.19849,
                                1.53141
                            ],
                            [
                                -64.322,
                                1.41373
                            ],
                            [
                                -64.39252,
                                1.51253
                            ],
                            [
                                -64.52546,
                                1.44064
                            ],
                            [
                                -64.59118,
                                1.33323
                            ],
                            [
                                -64.74419,
                                1.24458
                            ],
                            [
                                -64.81279,
                                1.28004
                            ],
                            [
                                -64.88404,
                                1.22018
                            ],
                            [
                                -64.94793,
                                1.20818
                            ],
                            [
                                -65.03395,
                                1.13512
                            ],
                            [
                                -65.12237,
                                1.13551
                            ],
                            [
                                -65.15451,
                                1.08475
                            ],
                            [
                                -65.16293,
                                0.98066
                            ],
                            [
                                -65.18646,
                                0.92725
                            ],
                            [
                                -65.29471,
                                0.92735
                            ],
                            [
                                -65.39483,
                                0.83332
                            ],
                            [
                                -65.3962,
                                0.76599
                            ],
                            [
                                -65.43398,
                                0.69973
                            ],
                            [
                                -65.53608,
                                0.65042
                            ],
                            [
                                -65.58338,
                                0.72099
                            ],
                            [
                                -65.50213,
                                0.85679
                            ],
                            [
                                -65.54265,
                                0.97018
                            ],
                            [
                                -65.60823,
                                1.00898
                            ],
                            [
                                -65.73219,
                                1.00462
                            ],
                            [
                                -65.76412,
                                0.97307
                            ],
                            [
                                -65.8645,
                                0.93573
                            ],
                            [
                                -65.88293,
                                0.89699
                            ],
                            [
                                -65.99099,
                                0.79444
                            ],
                            [
                                -66.06658,
                                0.78636
                            ],
                            [
                                -66.10022,
                                0.74564
                            ],
                            [
                                -66.21861,
                                0.764
                            ],
                            [
                                -66.32618,
                                0.75696
                            ],
                            [
                                -66.8413,
                                1.21941
                            ],
                            [
                                -66.86983,
                                1.22565
                            ],
                            [
                                -67.08658,
                                1.16886
                            ],
                            [
                                -67.09807,
                                1.29131
                            ],
                            [
                                -67.0624,
                                1.52912
                            ],
                            [
                                -67.11352,
                                1.73154
                            ],
                            [
                                -67.15705,
                                1.80575
                            ],
                            [
                                -67.29632,
                                1.99513
                            ],
                            [
                                -67.34672,
                                2.1109
                            ],
                            [
                                -67.4326,
                                2.14709
                            ],
                            [
                                -67.50812,
                                2.11532
                            ],
                            [
                                -67.64167,
                                2.00874
                            ],
                            [
                                -67.69854,
                                1.91897
                            ],
                            [
                                -67.8168,
                                1.78286
                            ],
                            [
                                -67.88677,
                                1.75397
                            ],
                            [
                                -67.96986,
                                1.74717
                            ],
                            [
                                -68.014,
                                1.774
                            ],
                            [
                                -68.12889,
                                1.96937
                            ],
                            [
                                -68.21529,
                                1.9676
                            ],
                            [
                                -68.28019,
                                1.848
                            ],
                            [
                                -68.19005,
                                1.72913
                            ],
                            [
                                -68.64918,
                                1.72907
                            ],
                            [
                                -69.38815,
                                1.72898
                            ],
                            [
                                -69.53858,
                                1.7757
                            ],
                            [
                                -69.63172,
                                1.72346
                            ],
                            [
                                -69.73256,
                                1.73146
                            ],
                            [
                                -69.81548,
                                1.69625
                            ],
                            [
                                -69.84337,
                                1.71353
                            ],
                            [
                                -69.84487,
                                1.08026
                            ],
                            [
                                -69.8193,
                                1.06612
                            ],
                            [
                                -69.74141,
                                1.11384
                            ],
                            [
                                -69.6816,
                                1.07094
                            ],
                            [
                                -69.59984,
                                1.09415
                            ],
                            [
                                -69.56289,
                                1.07205
                            ],
                            [
                                -69.38257,
                                1.07359
                            ],
                            [
                                -69.32159,
                                1.08669
                            ],
                            [
                                -69.24658,
                                1.05518
                            ],
                            [
                                -69.14072,
                                0.87965
                            ],
                            [
                                -69.16604,
                                0.82024
                            ],
                            [
                                -69.14876,
                                0.76899
                            ],
                            [
                                -69.18727,
                                0.73867
                            ],
                            [
                                -69.11922,
                                0.65486
                            ],
                            [
                                -69.18609,
                                0.65095
                            ],
                            [
                                -69.20269,
                                0.60833
                            ],
                            [
                                -69.2754,
                                0.60288
                            ],
                            [
                                -69.29077,
                                0.64797
                            ],
                            [
                                -69.35457,
                                0.61771
                            ],
                            [
                                -69.47417,
                                0.73436
                            ],
                            [
                                -69.56561,
                                0.67828
                            ],
                            [
                                -69.60371,
                                0.63202
                            ],
                            [
                                -69.67619,
                                0.66513
                            ],
                            [
                                -69.72664,
                                0.61473
                            ],
                            [
                                -69.80238,
                                0.57534
                            ],
                            [
                                -69.91272,
                                0.58574
                            ],
                            [
                                -70.04339,
                                0.55565
                            ],
                            [
                                -70.04402,
                                -0.10128
                            ],
                            [
                                -70.05304,
                                -0.175
                            ],
                            [
                                -69.91539,
                                -0.32765
                            ],
                            [
                                -69.82649,
                                -0.37086
                            ],
                            [
                                -69.72587,
                                -0.44429
                            ],
                            [
                                -69.61191,
                                -0.50271
                            ],
                            [
                                -69.59932,
                                -0.59538
                            ],
                            [
                                -69.56635,
                                -0.63806
                            ],
                            [
                                -69.61913,
                                -0.74436
                            ],
                            [
                                -69.52702,
                                -0.8698
                            ],
                            [
                                -69.52516,
                                -0.92379
                            ],
                            [
                                -69.43818,
                                -0.9963
                            ],
                            [
                                -69.42733,
                                -1.07465
                            ],
                            [
                                -69.3965,
                                -1.12832
                            ],
                            [
                                -69.42886,
                                -1.22518
                            ],
                            [
                                -69.39947,
                                -1.3616
                            ],
                            [
                                -69.43587,
                                -1.40967
                            ],
                            [
                                -69.45837,
                                -1.4898
                            ],
                            [
                                -69.45331,
                                -1.55315
                            ],
                            [
                                -69.73771,
                                -3.12712
                            ],
                            [
                                -69.92876,
                                -4.20042
                            ],
                            [
                                -69.95342,
                                -4.23049
                            ],
                            [
                                -69.98742,
                                -4.31521
                            ],
                            [
                                -70.04128,
                                -4.32876
                            ],
                            [
                                -70.10743,
                                -4.25904
                            ],
                            [
                                -70.15002,
                                -4.2677
                            ],
                            [
                                -70.19933,
                                -4.34432
                            ],
                            [
                                -70.27952,
                                -4.28358
                            ],
                            [
                                -70.28713,
                                -4.16876
                            ],
                            [
                                -70.31658,
                                -4.13925
                            ],
                            [
                                -70.43071,
                                -4.12615
                            ],
                            [
                                -70.49112,
                                -4.16241
                            ],
                            [
                                -70.535,
                                -4.13612
                            ],
                            [
                                -70.61362,
                                -4.18475
                            ],
                            [
                                -70.76372,
                                -4.15771
                            ],
                            [
                                -70.87629,
                                -4.3147
                            ],
                            [
                                -70.93478,
                                -4.37792
                            ],
                            [
                                -71.17994,
                                -4.3919
                            ],
                            [
                                -71.26836,
                                -4.38272
                            ],
                            [
                                -71.33167,
                                -4.43808
                            ],
                            [
                                -71.47209,
                                -4.4309
                            ],
                            [
                                -71.50094,
                                -4.47547
                            ],
                            [
                                -71.55066,
                                -4.47854
                            ],
                            [
                                -71.61284,
                                -4.52032
                            ],
                            [
                                -71.70765,
                                -4.50193
                            ],
                            [
                                -71.74211,
                                -4.47416
                            ],
                            [
                                -71.85802,
                                -4.51786
                            ],
                            [
                                -71.89255,
                                -4.51329
                            ],
                            [
                                -71.94176,
                                -4.60327
                            ],
                            [
                                -72.04396,
                                -4.62745
                            ],
                            [
                                -72.11497,
                                -4.7199
                            ],
                            [
                                -72.21467,
                                -4.76079
                            ],
                            [
                                -72.31027,
                                -4.77245
                            ],
                            [
                                -72.3526,
                                -4.80531
                            ],
                            [
                                -72.37505,
                                -4.88185
                            ],
                            [
                                -72.45669,
                                -4.9576
                            ],
                            [
                                -72.57699,
                                -4.99546
                            ],
                            [
                                -72.62129,
                                -5.06072
                            ],
                            [
                                -72.72843,
                                -5.04529
                            ],
                            [
                                -72.82251,
                                -5.08716
                            ],
                            [
                                -72.8931,
                                -5.13858
                            ],
                            [
                                -72.86861,
                                -5.18229
                            ],
                            [
                                -72.87461,
                                -5.2513
                            ],
                            [
                                -72.90643,
                                -5.31044
                            ],
                            [
                                -72.94566,
                                -5.45102
                            ],
                            [
                                -72.93479,
                                -5.52956
                            ],
                            [
                                -72.97799,
                                -5.70783
                            ],
                            [
                                -73.0315,
                                -5.78451
                            ],
                            [
                                -73.11296,
                                -5.8662
                            ],
                            [
                                -73.13251,
                                -5.98538
                            ],
                            [
                                -73.18214,
                                -6.03937
                            ],
                            [
                                -73.18015,
                                -6.16471
                            ],
                            [
                                -73.15726,
                                -6.20508
                            ],
                            [
                                -73.12662,
                                -6.39408
                            ],
                            [
                                -73.16393,
                                -6.48226
                            ],
                            [
                                -73.21442,
                                -6.52805
                            ],
                            [
                                -73.35071,
                                -6.56306
                            ],
                            [
                                -73.38582,
                                -6.60559
                            ],
                            [
                                -73.50855,
                                -6.69827
                            ],
                            [
                                -73.57113,
                                -6.72207
                            ],
                            [
                                -73.66732,
                                -6.81146
                            ],
                            [
                                -73.7443,
                                -6.90724
                            ],
                            [
                                -73.76011,
                                -7.0514
                            ],
                            [
                                -73.79383,
                                -7.11269
                            ],
                            [
                                -73.71053,
                                -7.23141
                            ],
                            [
                                -73.69078,
                                -7.29923
                            ],
                            [
                                -73.73305,
                                -7.33802
                            ],
                            [
                                -73.82794,
                                -7.34316
                            ],
                            [
                                -73.88357,
                                -7.37422
                            ],
                            [
                                -73.95222,
                                -7.3512
                            ],
                            [
                                -73.91784,
                                -7.45877
                            ],
                            [
                                -73.97559,
                                -7.55963
                            ],
                            [
                                -73.81907,
                                -7.71686
                            ],
                            [
                                -73.71862,
                                -7.76293
                            ],
                            [
                                -73.68622,
                                -7.80543
                            ],
                            [
                                -73.70991,
                                -7.87289
                            ],
                            [
                                -73.76509,
                                -7.86501
                            ],
                            [
                                -73.76488,
                                -7.93673
                            ],
                            [
                                -73.63133,
                                -8.02615
                            ],
                            [
                                -73.59076,
                                -8.11864
                            ],
                            [
                                -73.58303,
                                -8.20023
                            ],
                            [
                                -73.53624,
                                -8.26795
                            ],
                            [
                                -73.52369,
                                -8.36908
                            ],
                            [
                                -73.41733,
                                -8.41608
                            ],
                            [
                                -73.32884,
                                -8.50171
                            ],
                            [
                                -73.34309,
                                -8.58385
                            ],
                            [
                                -73.25671,
                                -8.68609
                            ],
                            [
                                -73.1519,
                                -8.72422
                            ],
                            [
                                -73.05804,
                                -8.90358
                            ],
                            [
                                -72.99415,
                                -8.93079
                            ],
                            [
                                -72.94911,
                                -8.98995
                            ],
                            [
                                -72.94814,
                                -9.10056
                            ],
                            [
                                -72.96736,
                                -9.15534
                            ],
                            [
                                -73.01104,
                                -9.17422
                            ],
                            [
                                -73.0285,
                                -9.23158
                            ],
                            [
                                -73.07275,
                                -9.24412
                            ],
                            [
                                -73.11604,
                                -9.32282
                            ],
                            [
                                -73.181,
                                -9.37534
                            ],
                            [
                                -73.19418,
                                -9.41598
                            ],
                            [
                                -72.72708,
                                -9.41743
                            ],
                            [
                                -72.62193,
                                -9.43844
                            ],
                            [
                                -72.52265,
                                -9.48083
                            ],
                            [
                                -72.43252,
                                -9.47587
                            ],
                            [
                                -72.36271,
                                -9.49273
                            ],
                            [
                                -72.28707,
                                -9.55312
                            ],
                            [
                                -72.29232,
                                -9.59053
                            ],
                            [
                                -72.24846,
                                -9.66168
                            ],
                            [
                                -72.26186,
                                -9.73878
                            ],
                            [
                                -72.17962,
                                -9.79614
                            ],
                            [
                                -72.14675,
                                -9.88505
                            ],
                            [
                                -72.16035,
                                -10.00153
                            ],
                            [
                                -71.36536,
                                -10.00049
                            ],
                            [
                                -71.28997,
                                -9.99625
                            ],
                            [
                                -71.18107,
                                -9.94151
                            ],
                            [
                                -71.1295,
                                -9.86092
                            ],
                            [
                                -70.98441,
                                -9.81436
                            ],
                            [
                                -70.87441,
                                -9.67737
                            ],
                            [
                                -70.79389,
                                -9.6367
                            ],
                            [
                                -70.74671,
                                -9.57151
                            ],
                            [
                                -70.6635,
                                -9.52907
                            ],
                            [
                                -70.59343,
                                -9.44845
                            ],
                            [
                                -70.50892,
                                -9.43197
                            ],
                            [
                                -70.51591,
                                -9.48979
                            ],
                            [
                                -70.57011,
                                -9.53082
                            ],
                            [
                                -70.58529,
                                -9.63285
                            ],
                            [
                                -70.52032,
                                -9.72851
                            ],
                            [
                                -70.62189,
                                -9.85045
                            ],
                            [
                                -70.62138,
                                -10.71009
                            ],
                            [
                                -70.6175,
                                -11.00575
                            ],
                            [
                                -70.53333,
                                -10.94239
                            ],
                            [
                                -70.49743,
                                -10.94671
                            ],
                            [
                                -70.43062,
                                -11.03055
                            ],
                            [
                                -70.33324,
                                -11.06644
                            ],
                            [
                                -70.13302,
                                -11.02417
                            ],
                            [
                                -69.94646,
                                -10.92984
                            ],
                            [
                                -69.77326,
                                -10.93495
                            ],
                            [
                                -69.72912,
                                -10.97261
                            ],
                            [
                                -69.56644,
                                -10.95666
                            ],
                            [
                                -69.43431,
                                -10.95113
                            ],
                            [
                                -69.39118,
                                -10.9312
                            ],
                            [
                                -69.31466,
                                -10.95565
                            ],
                            [
                                -69.15212,
                                -10.964
                            ],
                            [
                                -68.86887,
                                -11.0223
                            ],
                            [
                                -68.78859,
                                -10.99069
                            ],
                            [
                                -68.75214,
                                -11.00779
                            ],
                            [
                                -68.77584,
                                -11.12479
                            ],
                            [
                                -68.73404,
                                -11.14205
                            ],
                            [
                                -68.589,
                                -11.11012
                            ],
                            [
                                -68.51424,
                                -11.04725
                            ],
                            [
                                -68.41475,
                                -11.03962
                            ],
                            [
                                -68.39662,
                                -11.01624
                            ],
                            [
                                -68.28439,
                                -10.98627
                            ],
                            [
                                -68.24759,
                                -10.95106
                            ],
                            [
                                -68.18718,
                                -10.83916
                            ],
                            [
                                -68.11885,
                                -10.76435
                            ],
                            [
                                -68.11546,
                                -10.72429
                            ],
                            [
                                -68.00384,
                                -10.65512
                            ],
                            [
                                -67.81325,
                                -10.66284
                            ],
                            [
                                -67.73896,
                                -10.71391
                            ],
                            [
                                -67.68414,
                                -10.62977
                            ],
                            [
                                -67.63332,
                                -10.59702
                            ],
                            [
                                -67.56319,
                                -10.50018
                            ],
                            [
                                -67.44508,
                                -10.45017
                            ],
                            [
                                -67.41518,
                                -10.37358
                            ],
                            [
                                -67.32841,
                                -10.37257
                            ],
                            [
                                -67.31308,
                                -10.31721
                            ],
                            [
                                -67.23276,
                                -10.31459
                            ],
                            [
                                -67.18336,
                                -10.33753
                            ],
                            [
                                -67.13567,
                                -10.28885
                            ],
                            [
                                -67.03015,
                                -10.25317
                            ],
                            [
                                -66.88276,
                                -10.08231
                            ],
                            [
                                -66.71533,
                                -9.97007
                            ],
                            [
                                -66.62573,
                                -9.93487
                            ],
                            [
                                -66.6147,
                                -9.8936
                            ],
                            [
                                -66.36418,
                                -9.86034
                            ],
                            [
                                -66.31334,
                                -9.83153
                            ],
                            [
                                -66.19992,
                                -9.82101
                            ],
                            [
                                -66.1602,
                                -9.78559
                            ],
                            [
                                -66.0683,
                                -9.77337
                            ],
                            [
                                -66.03135,
                                -9.80276
                            ],
                            [
                                -65.87529,
                                -9.75747
                            ],
                            [
                                -65.7975,
                                -9.78506
                            ],
                            [
                                -65.7154,
                                -9.74834
                            ],
                            [
                                -65.59498,
                                -9.82961
                            ],
                            [
                                -65.50749,
                                -9.79243
                            ],
                            [
                                -65.48672,
                                -9.71922
                            ],
                            [
                                -65.43409,
                                -9.68188
                            ],
                            [
                                -65.36125,
                                -9.71418
                            ],
                            [
                                -65.29291,
                                -9.86559
                            ],
                            [
                                -65.32335,
                                -9.90489
                            ],
                            [
                                -65.3225,
                                -10.04119
                            ],
                            [
                                -65.28034,
                                -10.21714
                            ],
                            [
                                -65.30881,
                                -10.29705
                            ],
                            [
                                -65.38288,
                                -10.38778
                            ],
                            [
                                -65.38421,
                                -10.43618
                            ],
                            [
                                -65.43003,
                                -10.47921
                            ],
                            [
                                -65.41172,
                                -10.59414
                            ],
                            [
                                -65.37267,
                                -10.71943
                            ],
                            [
                                -65.38748,
                                -10.81954
                            ],
                            [
                                -65.31634,
                                -10.87111
                            ],
                            [
                                -65.28971,
                                -10.98378
                            ],
                            [
                                -65.32687,
                                -11.02567
                            ],
                            [
                                -65.32541,
                                -11.1135
                            ],
                            [
                                -65.37024,
                                -11.14059
                            ],
                            [
                                -65.38412,
                                -11.26853
                            ],
                            [
                                -65.33617,
                                -11.36243
                            ],
                            [
                                -65.29814,
                                -11.50013
                            ],
                            [
                                -65.23688,
                                -11.51011
                            ],
                            [
                                -65.20625,
                                -11.55177
                            ],
                            [
                                -65.17629,
                                -11.67693
                            ],
                            [
                                -65.19945,
                                -11.74624
                            ],
                            [
                                -65.04821,
                                -11.75642
                            ],
                            [
                                -65.0321,
                                -11.86047
                            ],
                            [
                                -64.99982,
                                -11.91668
                            ],
                            [
                                -64.99184,
                                -11.9991
                            ],
                            [
                                -64.91443,
                                -12.00696
                            ],
                            [
                                -64.78575,
                                -12.0451
                            ],
                            [
                                -64.7342,
                                -12.1139
                            ],
                            [
                                -64.61196,
                                -12.2123
                            ],
                            [
                                -64.51876,
                                -12.24053
                            ],
                            [
                                -64.46905,
                                -12.29592
                            ],
                            [
                                -64.49236,
                                -12.36478
                            ],
                            [
                                -64.38755,
                                -12.45908
                            ],
                            [
                                -64.17675,
                                -12.48683
                            ],
                            [
                                -64.13752,
                                -12.5253
                            ],
                            [
                                -64.09051,
                                -12.50583
                            ],
                            [
                                -63.93774,
                                -12.5563
                            ],
                            [
                                -63.86749,
                                -12.49224
                            ],
                            [
                                -63.77344,
                                -12.45492
                            ],
                            [
                                -63.6609,
                                -12.47123
                            ],
                            [
                                -63.54594,
                                -12.55102
                            ],
                            [
                                -63.4805,
                                -12.55897
                            ],
                            [
                                -63.4235,
                                -12.65326
                            ],
                            [
                                -63.32815,
                                -12.70412
                            ],
                            [
                                -63.26687,
                                -12.7164
                            ],
                            [
                                -63.13422,
                                -12.64124
                            ],
                            [
                                -63.08083,
                                -12.6545
                            ],
                            [
                                -63.05684,
                                -12.74208
                            ],
                            [
                                -62.99841,
                                -12.84665
                            ],
                            [
                                -62.90945,
                                -12.86562
                            ],
                            [
                                -62.77974,
                                -13.01377
                            ],
                            [
                                -62.67543,
                                -12.9654
                            ],
                            [
                                -62.6284,
                                -13.04508
                            ],
                            [
                                -62.55323,
                                -13.07306
                            ],
                            [
                                -62.46279,
                                -13.07053
                            ],
                            [
                                -62.4135,
                                -13.12866
                            ],
                            [
                                -62.27811,
                                -13.15013
                            ],
                            [
                                -62.24333,
                                -13.12237
                            ],
                            [
                                -62.10856,
                                -13.15
                            ],
                            [
                                -62.10803,
                                -13.25455
                            ],
                            [
                                -62.00883,
                                -13.35137
                            ],
                            [
                                -61.87196,
                                -13.43884
                            ],
                            [
                                -61.85157,
                                -13.50447
                            ],
                            [
                                -61.79731,
                                -13.54327
                            ],
                            [
                                -61.74163,
                                -13.52409
                            ],
                            [
                                -61.57227,
                                -13.51513
                            ],
                            [
                                -61.48716,
                                -13.55395
                            ],
                            [
                                -61.3206,
                                -13.48112
                            ],
                            [
                                -61.25202,
                                -13.52369
                            ],
                            [
                                -61.13912,
                                -13.51972
                            ],
                            [
                                -61.12186,
                                -13.47248
                            ],
                            [
                                -61.04445,
                                -13.49822
                            ],
                            [
                                -61.04216,
                                -13.54151
                            ],
                            [
                                -60.96925,
                                -13.53846
                            ],
                            [
                                -60.88946,
                                -13.6286
                            ],
                            [
                                -60.73704,
                                -13.6941
                            ],
                            [
                                -60.67061,
                                -13.74812
                            ],
                            [
                                -60.59806,
                                -13.74967
                            ],
                            [
                                -60.56542,
                                -13.78358
                            ],
                            [
                                -60.46842,
                                -13.80191
                            ],
                            [
                                -60.44757,
                                -13.89916
                            ],
                            [
                                -60.39272,
                                -14.03022
                            ],
                            [
                                -60.47056,
                                -14.09855
                            ],
                            [
                                -60.449,
                                -14.28929
                            ],
                            [
                                -60.38938,
                                -14.36723
                            ],
                            [
                                -60.3974,
                                -14.42032
                            ],
                            [
                                -60.33687,
                                -14.50187
                            ],
                            [
                                -60.30582,
                                -14.61206
                            ],
                            [
                                -60.27676,
                                -14.61998
                            ],
                            [
                                -60.25604,
                                -15.09801
                            ],
                            [
                                -60.56421,
                                -15.10627
                            ],
                            [
                                -60.23607,
                                -15.47677
                            ],
                            [
                                -60.20608,
                                -15.90005
                            ],
                            [
                                -60.17277,
                                -16.26319
                            ],
                            [
                                -59.91362,
                                -16.2754
                            ],
                            [
                                -59.35779,
                                -16.27962
                            ],
                            [
                                -59.25856,
                                -16.29055
                            ],
                            [
                                -58.81642,
                                -16.30723
                            ],
                            [
                                -58.46945,
                                -16.32477
                            ],
                            [
                                -58.3706,
                                -16.27602
                            ],
                            [
                                -58.30872,
                                -16.27891
                            ],
                            [
                                -58.32225,
                                -16.38139
                            ],
                            [
                                -58.35023,
                                -16.42134
                            ],
                            [
                                -58.34045,
                                -16.54043
                            ],
                            [
                                -58.3837,
                                -16.5638
                            ],
                            [
                                -58.45554,
                                -16.6583
                            ],
                            [
                                -58.45721,
                                -16.9632
                            ],
                            [
                                -58.38719,
                                -17.11788
                            ],
                            [
                                -58.39436,
                                -17.19633
                            ],
                            [
                                -58.34886,
                                -17.2225
                            ],
                            [
                                -58.24316,
                                -17.3622
                            ],
                            [
                                -58.19546,
                                -17.36567
                            ],
                            [
                                -58.05056,
                                -17.46517
                            ],
                            [
                                -58.00037,
                                -17.51872
                            ],
                            [
                                -57.90354,
                                -17.46121
                            ],
                            [
                                -57.80672,
                                -17.51804
                            ],
                            [
                                -57.78393,
                                -17.64657
                            ],
                            [
                                -57.71536,
                                -17.73495
                            ],
                            [
                                -57.70104,
                                -17.86245
                            ],
                            [
                                -57.60997,
                                -18.02406
                            ],
                            [
                                -57.57378,
                                -18.12459
                            ],
                            [
                                -57.46378,
                                -18.23201
                            ],
                            [
                                -57.55915,
                                -18.26245
                            ],
                            [
                                -57.60202,
                                -18.36516
                            ],
                            [
                                -57.76765,
                                -18.90291
                            ],
                            [
                                -57.71965,
                                -18.9165
                            ],
                            [
                                -57.70577,
                                -19.00007
                            ],
                            [
                                -57.7222,
                                -19.04248
                            ],
                            [
                                -57.78944,
                                -19.05013
                            ],
                            [
                                -58.12069,
                                -19.73142
                            ],
                            [
                                -57.8552,
                                -19.97139
                            ],
                            [
                                -57.88515,
                                -20.02916
                            ],
                            [
                                -57.94682,
                                -20.02429
                            ],
                            [
                                -58.16346,
                                -20.16246
                            ],
                            [
                                -58.08826,
                                -20.26646
                            ],
                            [
                                -58.07962,
                                -20.37548
                            ],
                            [
                                -57.99619,
                                -20.44415
                            ],
                            [
                                -58.01807,
                                -20.51257
                            ],
                            [
                                -58.0141,
                                -20.60911
                            ],
                            [
                                -57.92072,
                                -20.66782
                            ],
                            [
                                -57.87536,
                                -20.74366
                            ],
                            [
                                -57.86019,
                                -20.84997
                            ],
                            [
                                -57.91817,
                                -20.88238
                            ],
                            [
                                -57.82028,
                                -20.98483
                            ],
                            [
                                -57.86617,
                                -21.04636
                            ],
                            [
                                -57.84786,
                                -21.09948
                            ],
                            [
                                -57.86477,
                                -21.24092
                            ],
                            [
                                -57.91702,
                                -21.27925
                            ],
                            [
                                -57.85531,
                                -21.33826
                            ],
                            [
                                -57.96217,
                                -21.51165
                            ],
                            [
                                -57.92554,
                                -21.57865
                            ],
                            [
                                -57.92904,
                                -21.65581
                            ],
                            [
                                -57.89935,
                                -21.70433
                            ],
                            [
                                -57.94366,
                                -21.75169
                            ],
                            [
                                -57.9234,
                                -21.87434
                            ],
                            [
                                -57.98792,
                                -22.08379
                            ],
                            [
                                -57.92473,
                                -22.12041
                            ],
                            [
                                -57.80359,
                                -22.14618
                            ],
                            [
                                -57.69945,
                                -22.09264
                            ],
                            [
                                -57.61791,
                                -22.09657
                            ],
                            [
                                -57.58469,
                                -22.16574
                            ],
                            [
                                -57.52099,
                                -22.17389
                            ],
                            [
                                -57.31869,
                                -22.23235
                            ],
                            [
                                -57.2428,
                                -22.24402
                            ],
                            [
                                -57.11019,
                                -22.22375
                            ],
                            [
                                -57.00266,
                                -22.22553
                            ],
                            [
                                -56.88353,
                                -22.25667
                            ],
                            [
                                -56.83846,
                                -22.29962
                            ],
                            [
                                -56.74823,
                                -22.23926
                            ],
                            [
                                -56.72042,
                                -22.25604
                            ],
                            [
                                -56.61811,
                                -22.23462
                            ],
                            [
                                -56.56657,
                                -22.19262
                            ],
                            [
                                -56.51746,
                                -22.10227
                            ],
                            [
                                -56.40499,
                                -22.07783
                            ],
                            [
                                -56.34072,
                                -22.20616
                            ],
                            [
                                -56.24972,
                                -22.2395
                            ],
                            [
                                -56.20754,
                                -22.28088
                            ],
                            [
                                -56.06111,
                                -22.29291
                            ],
                            [
                                -55.85913,
                                -22.27994
                            ],
                            [
                                -55.78863,
                                -22.38287
                            ],
                            [
                                -55.74123,
                                -22.39457
                            ],
                            [
                                -55.74581,
                                -22.48394
                            ],
                            [
                                -55.7239,
                                -22.54803
                            ],
                            [
                                -55.6299,
                                -22.61879
                            ],
                            [
                                -55.61489,
                                -22.72089
                            ],
                            [
                                -55.66667,
                                -22.86249
                            ],
                            [
                                -55.62536,
                                -22.98202
                            ],
                            [
                                -55.64278,
                                -23.02216
                            ],
                            [
                                -55.59508,
                                -23.14287
                            ],
                            [
                                -55.5452,
                                -23.1596
                            ],
                            [
                                -55.52115,
                                -23.26267
                            ],
                            [
                                -55.54806,
                                -23.31857
                            ],
                            [
                                -55.50223,
                                -23.38021
                            ],
                            [
                                -55.53605,
                                -23.44456
                            ],
                            [
                                -55.53497,
                                -23.61309
                            ],
                            [
                                -55.47667,
                                -23.6452
                            ],
                            [
                                -55.43207,
                                -23.78049
                            ],
                            [
                                -55.44123,
                                -23.91129
                            ],
                            [
                                -55.41296,
                                -23.95999
                            ],
                            [
                                -55.33419,
                                -23.98903
                            ],
                            [
                                -55.31346,
                                -23.95977
                            ],
                            [
                                -55.23187,
                                -24.01061
                            ],
                            [
                                -55.11301,
                                -23.964
                            ],
                            [
                                -55.05342,
                                -23.98892
                            ],
                            [
                                -55.00519,
                                -23.9585
                            ],
                            [
                                -54.93406,
                                -23.96436
                            ],
                            [
                                -54.92187,
                                -23.92496
                            ],
                            [
                                -54.76132,
                                -23.8578
                            ],
                            [
                                -54.7028,
                                -23.86128
                            ],
                            [
                                -54.67804,
                                -23.81813
                            ],
                            [
                                -54.48318,
                                -23.88527
                            ],
                            [
                                -54.39961,
                                -23.94108
                            ],
                            [
                                -54.36794,
                                -23.99967
                            ],
                            [
                                -54.31708,
                                -24.01452
                            ],
                            [
                                -54.28542,
                                -24.08669
                            ],
                            [
                                -54.33119,
                                -24.15088
                            ],
                            [
                                -54.32403,
                                -24.24509
                            ],
                            [
                                -54.27871,
                                -24.28977
                            ],
                            [
                                -54.26037,
                                -24.36521
                            ],
                            [
                                -54.33348,
                                -24.49452
                            ],
                            [
                                -54.33135,
                                -24.61738
                            ],
                            [
                                -54.40513,
                                -24.83594
                            ],
                            [
                                -54.45801,
                                -25.03268
                            ],
                            [
                                -54.43739,
                                -25.15864
                            ],
                            [
                                -54.49736,
                                -25.28152
                            ],
                            [
                                -54.61608,
                                -25.45846
                            ],
                            [
                                -54.5941,
                                -25.59227
                            ],
                            [
                                -54.53779,
                                -25.59873
                            ],
                            [
                                -54.4238,
                                -25.65872
                            ],
                            [
                                -54.38966,
                                -25.60656
                            ],
                            [
                                -54.29017,
                                -25.55682
                            ],
                            [
                                -54.23804,
                                -25.59227
                            ],
                            [
                                -54.19121,
                                -25.53536
                            ],
                            [
                                -54.12336,
                                -25.56617
                            ],
                            [
                                -54.09242,
                                -25.61166
                            ],
                            [
                                -54.01067,
                                -25.56816
                            ],
                            [
                                -53.95104,
                                -25.62233
                            ],
                            [
                                -53.86224,
                                -25.66231
                            ],
                            [
                                -53.84791,
                                -25.83612
                            ],
                            [
                                -53.8229,
                                -25.92467
                            ],
                            [
                                -53.83509,
                                -25.96819
                            ],
                            [
                                -53.72145,
                                -26.07715
                            ],
                            [
                                -53.72029,
                                -26.12933
                            ],
                            [
                                -53.59882,
                                -26.26233
                            ],
                            [
                                -53.65051,
                                -26.40601
                            ],
                            [
                                -53.70104,
                                -26.44382
                            ],
                            [
                                -53.72863,
                                -26.50577
                            ],
                            [
                                -53.74122,
                                -26.63868
                            ],
                            [
                                -53.72121,
                                -26.6817
                            ],
                            [
                                -53.74627,
                                -26.739
                            ],
                            [
                                -53.66429,
                                -26.85871
                            ],
                            [
                                -53.78312,
                                -27.09775
                            ],
                            [
                                -53.88246,
                                -27.13268
                            ],
                            [
                                -54.00864,
                                -27.20076
                            ],
                            [
                                -54.07287,
                                -27.28986
                            ],
                            [
                                -54.15245,
                                -27.296
                            ],
                            [
                                -54.27018,
                                -27.43439
                            ],
                            [
                                -54.44514,
                                -27.46243
                            ],
                            [
                                -54.53714,
                                -27.50137
                            ],
                            [
                                -54.59097,
                                -27.46253
                            ],
                            [
                                -54.61735,
                                -27.53255
                            ],
                            [
                                -54.68193,
                                -27.57339
                            ],
                            [
                                -54.8275,
                                -27.55688
                            ],
                            [
                                -54.84051,
                                -27.60539
                            ],
                            [
                                -54.90491,
                                -27.6399
                            ],
                            [
                                -54.90496,
                                -27.72311
                            ],
                            [
                                -54.93852,
                                -27.77171
                            ],
                            [
                                -55.02628,
                                -27.79251
                            ],
                            [
                                -55.04327,
                                -27.85665
                            ],
                            [
                                -55.09967,
                                -27.84697
                            ],
                            [
                                -55.23041,
                                -27.88238
                            ],
                            [
                                -55.26628,
                                -27.9276
                            ],
                            [
                                -55.33284,
                                -27.93568
                            ],
                            [
                                -55.38494,
                                -28.04092
                            ],
                            [
                                -55.44788,
                                -28.09562
                            ],
                            [
                                -55.49524,
                                -28.07994
                            ],
                            [
                                -55.56,
                                -28.16219
                            ],
                            [
                                -55.63179,
                                -28.17435
                            ],
                            [
                                -55.77745,
                                -28.24624
                            ],
                            [
                                -55.6705,
                                -28.33394
                            ],
                            [
                                -55.69624,
                                -28.4225
                            ],
                            [
                                -55.75625,
                                -28.36987
                            ],
                            [
                                -55.87503,
                                -28.35995
                            ],
                            [
                                -55.90227,
                                -28.40937
                            ],
                            [
                                -55.88401,
                                -28.47727
                            ],
                            [
                                -56.01209,
                                -28.50854
                            ],
                            [
                                -56.00892,
                                -28.6054
                            ],
                            [
                                -56.12384,
                                -28.68581
                            ],
                            [
                                -56.19575,
                                -28.77398
                            ],
                            [
                                -56.2632,
                                -28.77952
                            ],
                            [
                                -56.30056,
                                -28.81607
                            ],
                            [
                                -56.30038,
                                -28.89593
                            ],
                            [
                                -56.38427,
                                -28.9518
                            ],
                            [
                                -56.43371,
                                -29.08008
                            ],
                            [
                                -56.59459,
                                -29.12427
                            ],
                            [
                                -56.64502,
                                -29.1965
                            ],
                            [
                                -56.65913,
                                -29.28654
                            ],
                            [
                                -56.70891,
                                -29.3648
                            ],
                            [
                                -56.77186,
                                -29.38473
                            ],
                            [
                                -56.81836,
                                -29.48651
                            ],
                            [
                                -56.904,
                                -29.53596
                            ],
                            [
                                -57.03729,
                                -29.699
                            ],
                            [
                                -57.12709,
                                -29.76659
                            ],
                            [
                                -57.23156,
                                -29.77984
                            ],
                            [
                                -57.32734,
                                -29.87974
                            ],
                            [
                                -57.32853,
                                -29.97138
                            ],
                            [
                                -57.43551,
                                -30.05656
                            ],
                            [
                                -57.46328,
                                -30.10816
                            ],
                            [
                                -57.53816,
                                -30.15785
                            ],
                            [
                                -57.61898,
                                -30.1759
                            ],
                            [
                                -57.55731,
                                -30.21385
                            ],
                            [
                                -57.55083,
                                -30.26605
                            ],
                            [
                                -57.42654,
                                -30.276
                            ],
                            [
                                -57.39857,
                                -30.30166
                            ],
                            [
                                -57.31344,
                                -30.26086
                            ],
                            [
                                -57.20952,
                                -30.28149
                            ],
                            [
                                -57.11023,
                                -30.11686
                            ],
                            [
                                -57.04026,
                                -30.10094
                            ],
                            [
                                -56.83516,
                                -30.09207
                            ],
                            [
                                -56.777,
                                -30.1649
                            ],
                            [
                                -56.7067,
                                -30.17877
                            ],
                            [
                                -56.53738,
                                -30.33183
                            ],
                            [
                                -56.48685,
                                -30.39381
                            ],
                            [
                                -56.41728,
                                -30.431
                            ],
                            [
                                -56.38376,
                                -30.49426
                            ],
                            [
                                -56.17695,
                                -30.61691
                            ],
                            [
                                -56.12908,
                                -30.73602
                            ],
                            [
                                -56.02225,
                                -30.78558
                            ],
                            [
                                -55.98793,
                                -30.85832
                            ],
                            [
                                -56.01411,
                                -30.94011
                            ],
                            [
                                -56.00583,
                                -31.0629
                            ],
                            [
                                -55.94528,
                                -31.08826
                            ],
                            [
                                -55.86953,
                                -31.07873
                            ],
                            [
                                -55.70117,
                                -30.9608
                            ],
                            [
                                -55.65472,
                                -30.9541
                            ],
                            [
                                -55.6355,
                                -30.85922
                            ],
                            [
                                -55.59756,
                                -30.84762
                            ],
                            [
                                -55.38546,
                                -31.02941
                            ],
                            [
                                -55.33799,
                                -31.12899
                            ],
                            [
                                -55.29218,
                                -31.16501
                            ],
                            [
                                -55.25133,
                                -31.24823
                            ],
                            [
                                -55.12978,
                                -31.31558
                            ],
                            [
                                -55.07395,
                                -31.32555
                            ],
                            [
                                -55.01509,
                                -31.28521
                            ],
                            [
                                -54.95265,
                                -31.36144
                            ],
                            [
                                -54.82826,
                                -31.44768
                            ],
                            [
                                -54.71904,
                                -31.4418
                            ],
                            [
                                -54.62149,
                                -31.46499
                            ],
                            [
                                -54.50516,
                                -31.51677
                            ],
                            [
                                -54.42671,
                                -31.63902
                            ],
                            [
                                -54.4566,
                                -31.6706
                            ],
                            [
                                -54.09506,
                                -31.90537
                            ],
                            [
                                -54.05591,
                                -31.89012
                            ],
                            [
                                -53.967,
                                -31.91885
                            ],
                            [
                                -53.94864,
                                -31.95692
                            ],
                            [
                                -53.86031,
                                -31.99537
                            ],
                            [
                                -53.82634,
                                -32.0577
                            ],
                            [
                                -53.74286,
                                -32.08218
                            ],
                            [
                                -53.66866,
                                -32.26378
                            ],
                            [
                                -53.63512,
                                -32.29614
                            ],
                            [
                                -53.6316,
                                -32.38565
                            ],
                            [
                                -53.54919,
                                -32.47145
                            ],
                            [
                                -53.45957,
                                -32.48003
                            ],
                            [
                                -53.41893,
                                -32.56339
                            ],
                            [
                                -53.28196,
                                -32.61675
                            ],
                            [
                                -53.24361,
                                -32.60606
                            ],
                            [
                                -53.08669,
                                -32.72712
                            ],
                            [
                                -53.07525,
                                -32.76487
                            ],
                            [
                                -53.15644,
                                -32.7991
                            ],
                            [
                                -53.18235,
                                -32.85067
                            ],
                            [
                                -53.27959,
                                -32.89892
                            ],
                            [
                                -53.25462,
                                -32.94594
                            ],
                            [
                                -53.43545,
                                -33.05528
                            ],
                            [
                                -53.50693,
                                -33.1475
                            ],
                            [
                                -53.5186,
                                -33.27321
                            ],
                            [
                                -53.50525,
                                -33.35647
                            ],
                            [
                                -53.52393,
                                -33.68767
                            ],
                            [
                                -53.43648,
                                -33.70067
                            ],
                            [
                                -53.37795,
                                -33.7504
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -50.09099,
                                0.03259
                            ],
                            [
                                -50.04376,
                                0.01186
                            ],
                            [
                                -50.00831,
                                -0.05035
                            ],
                            [
                                -49.8805,
                                -0.00334
                            ],
                            [
                                -49.83972,
                                0.02613
                            ],
                            [
                                -49.76968,
                                0.12461
                            ],
                            [
                                -49.72071,
                                0.1452
                            ],
                            [
                                -49.68983,
                                0.19938
                            ],
                            [
                                -49.55704,
                                0.29996
                            ],
                            [
                                -49.58239,
                                0.37741
                            ],
                            [
                                -49.69602,
                                0.36076
                            ],
                            [
                                -49.91353,
                                0.28682
                            ],
                            [
                                -49.97264,
                                0.31388
                            ],
                            [
                                -50.02713,
                                0.30508
                            ],
                            [
                                -50.09631,
                                0.23781
                            ],
                            [
                                -50.18941,
                                0.21249
                            ],
                            [
                                -50.26393,
                                0.2292
                            ],
                            [
                                -50.38991,
                                0.21044
                            ],
                            [
                                -50.39005,
                                0.12885
                            ],
                            [
                                -50.34044,
                                0.03601
                            ],
                            [
                                -50.20573,
                                0.04467
                            ],
                            [
                                -50.09099,
                                0.03259
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -49.83363,
                                -0.08305
                            ],
                            [
                                -49.72079,
                                -0.13755
                            ],
                            [
                                -49.58869,
                                -0.13816
                            ],
                            [
                                -49.45389,
                                -0.11984
                            ],
                            [
                                -49.35516,
                                -0.00997
                            ],
                            [
                                -49.38439,
                                0.04908
                            ],
                            [
                                -49.4775,
                                0.08096
                            ],
                            [
                                -49.58282,
                                0.0875
                            ],
                            [
                                -49.68758,
                                0.0398
                            ],
                            [
                                -49.79568,
                                -0.03749
                            ],
                            [
                                -49.83363,
                                -0.08305
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -50.54752,
                                0.2604
                            ],
                            [
                                -50.52599,
                                0.20602
                            ],
                            [
                                -50.4261,
                                0.16093
                            ],
                            [
                                -50.39433,
                                0.24434
                            ],
                            [
                                -50.34021,
                                0.24956
                            ],
                            [
                                -50.30446,
                                0.29008
                            ],
                            [
                                -50.3215,
                                0.37114
                            ],
                            [
                                -50.312,
                                0.52764
                            ],
                            [
                                -50.29516,
                                0.60157
                            ],
                            [
                                -50.34075,
                                0.63674
                            ],
                            [
                                -50.40255,
                                0.57276
                            ],
                            [
                                -50.44959,
                                0.37179
                            ],
                            [
                                -50.48826,
                                0.28679
                            ],
                            [
                                -50.54752,
                                0.2604
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -50.09099,
                                0.49357
                            ],
                            [
                                -50.04485,
                                0.56865
                            ],
                            [
                                -50.09099,
                                0.64042
                            ],
                            [
                                -50.13893,
                                0.59042
                            ],
                            [
                                -50.26191,
                                0.60417
                            ],
                            [
                                -50.29361,
                                0.58
                            ],
                            [
                                -50.31009,
                                0.44494
                            ],
                            [
                                -50.28953,
                                0.34622
                            ],
                            [
                                -50.17631,
                                0.40843
                            ],
                            [
                                -50.09099,
                                0.49357
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -48.58037,
                                -27.76222
                            ],
                            [
                                -48.55999,
                                -27.81259
                            ],
                            [
                                -48.49232,
                                -27.79327
                            ],
                            [
                                -48.49911,
                                -27.70932
                            ],
                            [
                                -48.41221,
                                -27.57392
                            ],
                            [
                                -48.42421,
                                -27.53993
                            ],
                            [
                                -48.37008,
                                -27.45003
                            ],
                            [
                                -48.43458,
                                -27.4199
                            ],
                            [
                                -48.51844,
                                -27.43138
                            ],
                            [
                                -48.53682,
                                -27.47821
                            ],
                            [
                                -48.50966,
                                -27.54821
                            ],
                            [
                                -48.57092,
                                -27.68618
                            ],
                            [
                                -48.58037,
                                -27.76222
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -50.52185,
                                2.00582
                            ],
                            [
                                -50.49325,
                                1.9856
                            ],
                            [
                                -50.45362,
                                1.88469
                            ],
                            [
                                -50.35856,
                                1.89641
                            ],
                            [
                                -50.315,
                                1.94608
                            ],
                            [
                                -50.40822,
                                2.11397
                            ],
                            [
                                -50.50915,
                                2.08672
                            ],
                            [
                                -50.52185,
                                2.00582
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -50.65543,
                                0.13681
                            ],
                            [
                                -50.63552,
                                0.07413
                            ],
                            [
                                -50.58311,
                                0.01826
                            ],
                            [
                                -50.48043,
                                -0.02177
                            ],
                            [
                                -50.43619,
                                -0.00161
                            ],
                            [
                                -50.44876,
                                0.12649
                            ],
                            [
                                -50.51436,
                                0.16819
                            ],
                            [
                                -50.63742,
                                0.1925
                            ],
                            [
                                -50.65543,
                                0.13681
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -50.09099,
                                0.8852
                            ],
                            [
                                -50.18868,
                                0.88963
                            ],
                            [
                                -50.26744,
                                0.83645
                            ],
                            [
                                -50.27998,
                                0.74624
                            ],
                            [
                                -50.15124,
                                0.75142
                            ],
                            [
                                -50.09706,
                                0.76804
                            ],
                            [
                                -50.03691,
                                0.83428
                            ],
                            [
                                -50.09099,
                                0.8852
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -45.46129,
                                -23.8889
                            ],
                            [
                                -45.41311,
                                -23.93892
                            ],
                            [
                                -45.29251,
                                -23.91097
                            ],
                            [
                                -45.24419,
                                -23.83735
                            ],
                            [
                                -45.23281,
                                -23.77532
                            ],
                            [
                                -45.33856,
                                -23.72647
                            ],
                            [
                                -45.36717,
                                -23.81071
                            ],
                            [
                                -45.46129,
                                -23.8889
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -44.60089,
                                -2.91578
                            ],
                            [
                                -44.64121,
                                -2.97273
                            ],
                            [
                                -44.58159,
                                -3.03105
                            ],
                            [
                                -44.48032,
                                -2.9578
                            ],
                            [
                                -44.47566,
                                -2.73476
                            ],
                            [
                                -44.53178,
                                -2.75219
                            ],
                            [
                                -44.58867,
                                -2.81761
                            ],
                            [
                                -44.60089,
                                -2.91578
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -50.09099,
                                0.93317
                            ],
                            [
                                -50.05053,
                                0.92229
                            ],
                            [
                                -49.93327,
                                0.97528
                            ],
                            [
                                -49.91133,
                                1.08732
                            ],
                            [
                                -50.07336,
                                1.01482
                            ],
                            [
                                -50.10989,
                                0.94135
                            ],
                            [
                                -50.09099,
                                0.93317
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -47.55639,
                                -24.75411
                            ],
                            [
                                -47.62766,
                                -24.76373
                            ],
                            [
                                -47.73164,
                                -24.83619
                            ],
                            [
                                -47.89788,
                                -24.97232
                            ],
                            [
                                -47.87323,
                                -25.01341
                            ],
                            [
                                -47.70772,
                                -24.86157
                            ],
                            [
                                -47.55639,
                                -24.75411
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -44.28825,
                                -23.17867
                            ],
                            [
                                -44.25085,
                                -23.20302
                            ],
                            [
                                -44.14155,
                                -23.16848
                            ],
                            [
                                -44.14402,
                                -23.12483
                            ],
                            [
                                -44.23622,
                                -23.08829
                            ],
                            [
                                -44.28825,
                                -23.17867
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -39.0503,
                                -13.43157
                            ],
                            [
                                -39.03854,
                                -13.47521
                            ],
                            [
                                -38.93379,
                                -13.5713
                            ],
                            [
                                -38.90183,
                                -13.46278
                            ],
                            [
                                -38.90529,
                                -13.38672
                            ],
                            [
                                -39.00753,
                                -13.38772
                            ],
                            [
                                -39.0503,
                                -13.43157
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -38.75391,
                                -13.1055
                            ],
                            [
                                -38.65677,
                                -13.03255
                            ],
                            [
                                -38.60591,
                                -12.95745
                            ],
                            [
                                -38.63322,
                                -12.90615
                            ],
                            [
                                -38.68795,
                                -12.98827
                            ],
                            [
                                -38.76395,
                                -13.00486
                            ],
                            [
                                -38.79624,
                                -13.06168
                            ],
                            [
                                -38.75391,
                                -13.1055
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -43.74764,
                                -2.40502
                            ],
                            [
                                -43.70978,
                                -2.4262
                            ],
                            [
                                -43.64325,
                                -2.40017
                            ],
                            [
                                -43.62678,
                                -2.31205
                            ],
                            [
                                -43.7156,
                                -2.2878
                            ],
                            [
                                -43.74764,
                                -2.40502
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -44.99798,
                                -1.35323
                            ],
                            [
                                -44.96877,
                                -1.38965
                            ],
                            [
                                -44.89345,
                                -1.32807
                            ],
                            [
                                -44.90123,
                                -1.27626
                            ],
                            [
                                -44.98794,
                                -1.27182
                            ],
                            [
                                -44.99798,
                                -1.35323
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -50.9195,
                                -0.34435
                            ],
                            [
                                -50.78884,
                                -0.35223
                            ],
                            [
                                -50.75661,
                                -0.2947
                            ],
                            [
                                -50.7625,
                                -0.22316
                            ],
                            [
                                -50.9195,
                                -0.34435
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -48.02635,
                                -25.15266
                            ],
                            [
                                -47.9728,
                                -25.19991
                            ],
                            [
                                -47.91913,
                                -25.15322
                            ],
                            [
                                -47.90026,
                                -25.07467
                            ],
                            [
                                -47.99311,
                                -25.10398
                            ],
                            [
                                -48.02635,
                                -25.15266
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -50.54983,
                                2.15004
                            ],
                            [
                                -50.49783,
                                2.09749
                            ],
                            [
                                -50.41848,
                                2.12001
                            ],
                            [
                                -50.4638,
                                2.18568
                            ],
                            [
                                -50.52113,
                                2.18764
                            ],
                            [
                                -50.54983,
                                2.15004
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -48.34226,
                                -25.41629
                            ],
                            [
                                -48.30818,
                                -25.48426
                            ],
                            [
                                -48.25325,
                                -25.46873
                            ],
                            [
                                -48.2665,
                                -25.34092
                            ],
                            [
                                -48.34226,
                                -25.41629
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -42.22759,
                                -2.68777
                            ],
                            [
                                -42.14626,
                                -2.71194
                            ],
                            [
                                -42.08176,
                                -2.77493
                            ],
                            [
                                -42.04185,
                                -2.78097
                            ],
                            [
                                -42.02816,
                                -2.75026
                            ],
                            [
                                -42.07123,
                                -2.68997
                            ],
                            [
                                -42.22759,
                                -2.68777
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -42.26479,
                                -2.72382
                            ],
                            [
                                -42.15632,
                                -2.76829
                            ],
                            [
                                -42.14623,
                                -2.7281
                            ],
                            [
                                -42.24103,
                                -2.68766
                            ],
                            [
                                -42.26479,
                                -2.72382
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -38.99707,
                                -13.58204
                            ],
                            [
                                -38.96353,
                                -13.66737
                            ],
                            [
                                -38.899,
                                -13.66445
                            ],
                            [
                                -38.91627,
                                -13.57949
                            ],
                            [
                                -38.99707,
                                -13.58204
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -44.51606,
                                -2.52996
                            ],
                            [
                                -44.44362,
                                -2.45058
                            ],
                            [
                                -44.47341,
                                -2.42981
                            ],
                            [
                                -44.51606,
                                -2.52996
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "VGB",
                "Country": "British Virgin Islands",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.65e-09,
                    3.3e-09,
                    6.6e-09,
                    9.9e-09,
                    1.485e-08,
                    1.65e-08,
                    2.31e-08,
                    3.135e-08,
                    3.96e-08,
                    4.95e-08,
                    5.94e-08,
                    7.095e-08,
                    8.25e-08,
                    9.405e-08,
                    1.056e-07,
                    1.188e-07,
                    1.32e-07,
                    1.452e-07,
                    1.584e-07,
                    1.782e-07,
                    1.947e-07,
                    2.1285e-07,
                    2.31e-07,
                    2.5245e-07,
                    2.772e-07,
                    3.0525e-07,
                    3.3495e-07,
                    3.6465e-07,
                    3.9435e-07,
                    4.2735e-07,
                    4.6365e-07,
                    5.016e-07,
                    5.3955e-07,
                    5.7915e-07,
                    6.237e-07,
                    6.699e-07,
                    7.161e-07,
                    7.6725e-07,
                    8.2005e-07,
                    8.7615e-07,
                    9.405e-07,
                    1.0065e-06,
                    1.0758e-06,
                    1.15e-06,
                    1.2309e-06,
                    1.3151e-06,
                    1.4025e-06,
                    1.49e-06,
                    1.5857e-06,
                    1.6814e-06,
                    1.777e-06,
                    1.8727e-06,
                    1.9701e-06,
                    2.0724e-06,
                    2.1763e-06,
                    2.2572e-06,
                    2.3298e-06,
                    2.404e-06,
                    2.4766e-06,
                    2.5466e-06,
                    2.6172e-06
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.65e-09,
                    3.3e-09,
                    6.6e-09,
                    9.9e-09,
                    1.485e-08,
                    1.65e-08,
                    2.31e-08,
                    3.135e-08,
                    3.96e-08,
                    4.95e-08,
                    5.94e-08,
                    7.095e-08,
                    8.25e-08,
                    9.405e-08,
                    1.056e-07,
                    1.188e-07,
                    1.32e-07,
                    1.452e-07,
                    1.584e-07,
                    1.782e-07,
                    1.947e-07,
                    2.1285e-07,
                    2.31e-07,
                    2.5245e-07,
                    2.772e-07,
                    3.0525e-07,
                    3.3495e-07,
                    3.6465e-07,
                    3.9435e-07,
                    4.2735e-07,
                    4.6365e-07,
                    5.016e-07,
                    5.3955e-07,
                    5.7915e-07,
                    6.237e-07,
                    6.699e-07,
                    7.161e-07,
                    7.6725e-07,
                    8.2005e-07,
                    8.7615e-07,
                    9.405e-07,
                    1.0065e-06,
                    1.0758e-06,
                    1.15e-06,
                    1.2309e-06,
                    1.3151e-06,
                    1.4025e-06,
                    1.49e-06,
                    1.5857e-06,
                    1.6814e-06,
                    1.777e-06,
                    1.8727e-06,
                    1.9701e-06,
                    2.0724e-06,
                    2.1763e-06,
                    2.2572e-06,
                    2.3298e-06,
                    2.404e-06,
                    2.4766e-06,
                    2.5466e-06,
                    2.6172e-06
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.65e-09,
                    3.3e-09,
                    6.6e-09,
                    9.9e-09,
                    1.485e-08,
                    1.65e-08,
                    2.31e-08,
                    3.135e-08,
                    3.96e-08,
                    4.95e-08,
                    5.94e-08,
                    7.095e-08,
                    8.25e-08,
                    9.405e-08,
                    1.056e-07,
                    1.188e-07,
                    1.32e-07,
                    1.452e-07,
                    1.584e-07,
                    1.782e-07,
                    1.947e-07,
                    2.1285e-07,
                    2.31e-07,
                    2.5245e-07,
                    2.772e-07,
                    3.0525e-07,
                    3.3495e-07,
                    3.6465e-07,
                    3.9435e-07,
                    4.2735e-07,
                    4.6365e-07,
                    5.016e-07,
                    5.3955e-07,
                    5.7915e-07,
                    6.237e-07,
                    6.699e-07,
                    7.161e-07,
                    7.6725e-07,
                    8.2005e-07,
                    8.7615e-07,
                    9.405e-07,
                    1.0065e-06,
                    1.0758e-06,
                    1.15e-06,
                    1.2309e-06,
                    1.3151e-06,
                    1.4025e-06,
                    1.49e-06,
                    1.5857e-06,
                    1.6814e-06,
                    1.777e-06,
                    1.8727e-06,
                    1.9701e-06,
                    2.0724e-06,
                    2.1763e-06,
                    2.2572e-06,
                    2.3298e-06,
                    2.404e-06,
                    2.4766e-06,
                    2.5466e-06,
                    2.6172e-06
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.65e-09,
                    3.3e-09,
                    6.6e-09,
                    9.9e-09,
                    1.485e-08,
                    1.65e-08,
                    2.31e-08,
                    3.135e-08,
                    3.96e-08,
                    4.95e-08,
                    5.94e-08,
                    7.095e-08,
                    8.25e-08,
                    9.405e-08,
                    1.056e-07,
                    1.188e-07,
                    1.32e-07,
                    1.452e-07,
                    1.584e-07,
                    1.782e-07,
                    1.947e-07,
                    2.1285e-07,
                    2.31e-07,
                    2.5245e-07,
                    2.772e-07,
                    3.0525e-07,
                    3.3495e-07,
                    3.6465e-07,
                    3.9435e-07,
                    4.2735e-07,
                    4.6365e-07,
                    5.016e-07,
                    5.3955e-07,
                    5.7915e-07,
                    6.237e-07,
                    6.699e-07,
                    7.161e-07,
                    7.6725e-07,
                    8.2005e-07,
                    8.7615e-07,
                    9.405e-07,
                    1.0065e-06,
                    1.0758e-06,
                    1.15e-06,
                    1.2309e-06,
                    1.3151e-06,
                    1.4025e-06,
                    1.49e-06,
                    1.5857e-06,
                    1.6814e-06,
                    1.777e-06,
                    1.8727e-06,
                    1.9701e-06,
                    2.0724e-06,
                    2.1763e-06,
                    2.2572e-06,
                    2.3298e-06,
                    2.404e-06,
                    2.4766e-06,
                    2.5466e-06,
                    2.6172e-06
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": []
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -64.71108,
                            18.38926
                        ],
                        [
                            -64.66728,
                            18.38282
                        ],
                        [
                            -64.5415,
                            18.43829
                        ],
                        [
                            -64.64286,
                            18.45336
                        ],
                        [
                            -64.71108,
                            18.38926
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "BRN",
                "Country": "Brunei",
                "Total_3GHG": 0.03,
                "Total_3GHG_timeseries": [
                    -0.000000019061,
                    -0.000000023558,
                    -0.000000019155,
                    6.1096e-09,
                    3.0195e-08,
                    4.4912e-08,
                    8.0366e-08,
                    1.4933e-07,
                    2.1136e-07,
                    2.5671e-07,
                    3.143e-07,
                    3.8914e-07,
                    4.4947e-07,
                    5.2424e-07,
                    6.0419e-07,
                    6.4374e-07,
                    6.7956e-07,
                    7.1466e-07,
                    7.5011e-07,
                    7.8864e-07,
                    8.2705e-07,
                    8.4458e-07,
                    8.8371e-07,
                    9.255e-07,
                    9.6826e-07,
                    1.0115e-06,
                    1.0549e-06,
                    1.0731e-06,
                    1.0861e-06,
                    1.1467e-06,
                    1.209e-06,
                    1.2753e-06,
                    1.344e-06,
                    1.4147e-06,
                    1.4857e-06,
                    1.5448e-06,
                    1.6091e-06,
                    1.7117e-06,
                    1.7401e-06,
                    1.8011e-06,
                    1.8938e-06,
                    1.9667e-06,
                    2.0381e-06,
                    2.1112e-06,
                    2.1863e-06,
                    2.2e-06,
                    2.2702e-06,
                    2.3551e-06,
                    2.4365e-06,
                    2.5534e-06,
                    2.6648e-06,
                    2.7606e-06,
                    2.8935e-06,
                    3.0173e-06,
                    3.1442e-06,
                    3.273e-06,
                    3.4048e-06,
                    3.5414e-06,
                    3.6694e-06,
                    3.8267e-06,
                    3.9794e-06,
                    4.1387e-06,
                    4.3165e-06,
                    4.5081e-06,
                    4.7456e-06,
                    4.9529e-06,
                    5.16e-06,
                    5.367e-06,
                    5.5785e-06,
                    5.7706e-06,
                    5.9782e-06,
                    6.1514e-06,
                    6.321e-06,
                    6.4899e-06,
                    6.6547e-06,
                    6.8206e-06,
                    7.0222e-06,
                    7.2363e-06,
                    7.3984e-06,
                    7.6176e-06,
                    7.8302e-06,
                    8.0446e-06,
                    8.2189e-06,
                    8.4517e-06,
                    8.682e-06,
                    8.9382e-06,
                    9.2546e-06,
                    9.5672e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Fossil_3GHG": 0.04,
                "Fossil_3GHG_timeseries": [
                    1.5567e-09,
                    3.1314e-09,
                    4.7238e-09,
                    6.3335e-09,
                    7.9602e-09,
                    9.6033e-09,
                    1.1262e-08,
                    1.2936e-08,
                    1.4625e-08,
                    1.6327e-08,
                    1.8019e-08,
                    1.9703e-08,
                    2.1377e-08,
                    2.3042e-08,
                    2.4698e-08,
                    2.6345e-08,
                    2.7982e-08,
                    2.9611e-08,
                    3.123e-08,
                    3.2829e-08,
                    3.4426e-08,
                    3.6029e-08,
                    3.7646e-08,
                    3.9282e-08,
                    4.0939e-08,
                    4.2612e-08,
                    4.4299e-08,
                    4.5997e-08,
                    4.77e-08,
                    4.9402e-08,
                    5.1128e-08,
                    5.2876e-08,
                    5.4648e-08,
                    5.6444e-08,
                    5.8264e-08,
                    6.0106e-08,
                    6.1956e-08,
                    6.3829e-08,
                    6.5725e-08,
                    6.7657e-08,
                    6.9613e-08,
                    7.1594e-08,
                    7.36e-08,
                    7.5631e-08,
                    7.7687e-08,
                    7.9771e-08,
                    8.1883e-08,
                    8.4028e-08,
                    8.6207e-08,
                    8.8422e-08,
                    9.0663e-08,
                    9.2919e-08,
                    9.519e-08,
                    9.7476e-08,
                    9.9777e-08,
                    1.0211e-07,
                    1.0449e-07,
                    1.0691e-07,
                    1.0935e-07,
                    1.1184e-07,
                    1.1434e-07,
                    1.1685e-07,
                    1.1937e-07,
                    1.219e-07,
                    1.2445e-07,
                    1.2701e-07,
                    1.2959e-07,
                    1.3217e-07,
                    1.3481e-07,
                    1.3749e-07,
                    1.4036e-07,
                    1.4345e-07,
                    1.4674e-07,
                    1.5025e-07,
                    1.5397e-07,
                    1.5788e-07,
                    1.6199e-07,
                    1.6628e-07,
                    1.7083e-07,
                    1.7563e-07,
                    1.8064e-07,
                    1.8587e-07,
                    1.9296e-07,
                    2.1841e-07,
                    2.3582e-07,
                    2.7662e-07,
                    3.7545e-07,
                    4.7952e-07,
                    1.6696e-06,
                    3.01e-06,
                    3.9037e-06,
                    4.473e-06,
                    5.3249e-06,
                    6.4579e-06,
                    6.8822e-06,
                    7.3191e-06,
                    9.7418e-06,
                    9.7911e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005
                ],
                "Land_3GHG": 0.01,
                "Land_3GHG_timeseries": [
                    -0.000000020618,
                    -0.000000026689,
                    -0.000000023878,
                    -0.00000000022387,
                    2.2235e-08,
                    3.5309e-08,
                    6.9103e-08,
                    1.3639e-07,
                    1.9674e-07,
                    2.4038e-07,
                    2.9628e-07,
                    3.6944e-07,
                    4.2809e-07,
                    5.0119e-07,
                    5.7949e-07,
                    6.1739e-07,
                    6.5158e-07,
                    6.8505e-07,
                    7.1888e-07,
                    7.5581e-07,
                    7.9262e-07,
                    8.0855e-07,
                    8.4606e-07,
                    8.8622e-07,
                    9.2732e-07,
                    9.6884e-07,
                    1.0106e-06,
                    1.0271e-06,
                    1.0384e-06,
                    1.0973e-06,
                    1.1579e-06,
                    1.2224e-06,
                    1.2893e-06,
                    1.3582e-06,
                    1.4274e-06,
                    1.4847e-06,
                    1.5471e-06,
                    1.6478e-06,
                    1.6744e-06,
                    1.7335e-06,
                    1.8242e-06,
                    1.8951e-06,
                    1.9645e-06,
                    2.0356e-06,
                    2.1087e-06,
                    2.1202e-06,
                    2.1883e-06,
                    2.2711e-06,
                    2.3503e-06,
                    2.465e-06,
                    2.5741e-06,
                    2.6676e-06,
                    2.7984e-06,
                    2.9198e-06,
                    3.0444e-06,
                    3.1708e-06,
                    3.3003e-06,
                    3.4345e-06,
                    3.56e-06,
                    3.7148e-06,
                    3.8651e-06,
                    4.0219e-06,
                    4.1971e-06,
                    4.3862e-06,
                    4.6211e-06,
                    4.8259e-06,
                    5.0304e-06,
                    5.2348e-06,
                    5.4437e-06,
                    5.6331e-06,
                    5.8379e-06,
                    6.0079e-06,
                    6.1743e-06,
                    6.3397e-06,
                    6.5008e-06,
                    6.6628e-06,
                    6.8602e-06,
                    7.07e-06,
                    7.2276e-06,
                    7.442e-06,
                    7.6495e-06,
                    7.8588e-06,
                    8.026e-06,
                    8.2333e-06,
                    8.4462e-06,
                    8.6616e-06,
                    8.8792e-06,
                    9.0877e-06,
                    9.2573e-06,
                    9.4412e-06,
                    9.6767e-06,
                    9.9649e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_CO2": 0.02,
                "Total_CO2_timeseries": [
                    -0.00000002327,
                    -0.000000032021,
                    -0.000000031916,
                    -0.000000010994,
                    8.7065e-09,
                    1.8997e-08,
                    4.9984e-08,
                    1.1444e-07,
                    1.7194e-07,
                    2.1271e-07,
                    2.6575e-07,
                    3.361e-07,
                    3.9197e-07,
                    4.6232e-07,
                    5.3789e-07,
                    5.731e-07,
                    6.0462e-07,
                    6.3546e-07,
                    6.6668e-07,
                    7.0105e-07,
                    7.3531e-07,
                    7.4871e-07,
                    7.8371e-07,
                    8.2135e-07,
                    8.5994e-07,
                    8.9895e-07,
                    9.3819e-07,
                    9.5221e-07,
                    9.6097e-07,
                    1.0175e-06,
                    1.0755e-06,
                    1.1374e-06,
                    1.2018e-06,
                    1.268e-06,
                    1.3345e-06,
                    1.3891e-06,
                    1.4487e-06,
                    1.5466e-06,
                    1.5703e-06,
                    1.6263e-06,
                    1.714e-06,
                    1.7818e-06,
                    1.8481e-06,
                    1.916e-06,
                    1.9858e-06,
                    1.9941e-06,
                    2.0588e-06,
                    2.1382e-06,
                    2.214e-06,
                    2.3251e-06,
                    2.4307e-06,
                    2.5206e-06,
                    2.6477e-06,
                    2.7655e-06,
                    2.8863e-06,
                    3.009e-06,
                    3.1347e-06,
                    3.265e-06,
                    3.3866e-06,
                    3.5374e-06,
                    3.6836e-06,
                    3.8363e-06,
                    4.0072e-06,
                    4.192e-06,
                    4.4224e-06,
                    4.6226e-06,
                    4.8223e-06,
                    5.0218e-06,
                    5.2257e-06,
                    5.41e-06,
                    5.6092e-06,
                    5.7732e-06,
                    5.933e-06,
                    6.0913e-06,
                    6.2448e-06,
                    6.3988e-06,
                    6.5877e-06,
                    6.7885e-06,
                    6.9366e-06,
                    7.1411e-06,
                    7.3382e-06,
                    7.5366e-06,
                    7.6942e-06,
                    7.9096e-06,
                    8.1218e-06,
                    8.3587e-06,
                    8.6545e-06,
                    8.9453e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_CO2": 0.02,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.65e-09,
                    2.145e-08,
                    3.3e-08,
                    6.765e-08,
                    1.6005e-07,
                    2.574e-07,
                    1.4404e-06,
                    2.7737e-06,
                    3.6597e-06,
                    4.2207e-06,
                    5.0638e-06,
                    6.1875e-06,
                    6.6016e-06,
                    7.0273e-06,
                    9.438e-06,
                    9.4743e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_CO2": 0.01,
                "Land_CO2_timeseries": [
                    -0.00000002327,
                    -0.000000032021,
                    -0.000000031916,
                    -0.000000010994,
                    8.7065e-09,
                    1.8997e-08,
                    4.9984e-08,
                    1.1444e-07,
                    1.7194e-07,
                    2.1271e-07,
                    2.6575e-07,
                    3.361e-07,
                    3.9197e-07,
                    4.6232e-07,
                    5.3789e-07,
                    5.731e-07,
                    6.0462e-07,
                    6.3546e-07,
                    6.6668e-07,
                    7.0105e-07,
                    7.3531e-07,
                    7.4871e-07,
                    7.8371e-07,
                    8.2135e-07,
                    8.5994e-07,
                    8.9895e-07,
                    9.3819e-07,
                    9.5221e-07,
                    9.6097e-07,
                    1.0175e-06,
                    1.0755e-06,
                    1.1374e-06,
                    1.2018e-06,
                    1.268e-06,
                    1.3345e-06,
                    1.3891e-06,
                    1.4487e-06,
                    1.5466e-06,
                    1.5703e-06,
                    1.6263e-06,
                    1.714e-06,
                    1.7818e-06,
                    1.8481e-06,
                    1.916e-06,
                    1.9858e-06,
                    1.9941e-06,
                    2.0588e-06,
                    2.1382e-06,
                    2.214e-06,
                    2.3251e-06,
                    2.4307e-06,
                    2.5206e-06,
                    2.6477e-06,
                    2.7655e-06,
                    2.8863e-06,
                    3.009e-06,
                    3.1347e-06,
                    3.265e-06,
                    3.3866e-06,
                    3.5374e-06,
                    3.6836e-06,
                    3.8363e-06,
                    4.0072e-06,
                    4.192e-06,
                    4.4224e-06,
                    4.6226e-06,
                    4.8223e-06,
                    5.0218e-06,
                    5.2257e-06,
                    5.41e-06,
                    5.6092e-06,
                    5.7732e-06,
                    5.933e-06,
                    6.0913e-06,
                    6.2448e-06,
                    6.3988e-06,
                    6.5877e-06,
                    6.7885e-06,
                    6.9366e-06,
                    7.1411e-06,
                    7.3382e-06,
                    7.5366e-06,
                    7.6925e-06,
                    7.8881e-06,
                    8.0888e-06,
                    8.291e-06,
                    8.4945e-06,
                    8.6879e-06,
                    8.8414e-06,
                    9.0083e-06,
                    9.2259e-06,
                    9.4952e-06,
                    9.7354e-06,
                    9.9627e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_CH4": 0.07,
                "Total_CH4_timeseries": [
                    3.3013e-09,
                    6.6319e-09,
                    9.9918e-09,
                    1.3381e-08,
                    1.68e-08,
                    2.0248e-08,
                    2.3725e-08,
                    2.7232e-08,
                    3.0768e-08,
                    3.4334e-08,
                    3.7858e-08,
                    4.1339e-08,
                    4.4777e-08,
                    4.8173e-08,
                    5.1526e-08,
                    5.4837e-08,
                    5.8106e-08,
                    6.1332e-08,
                    6.4517e-08,
                    6.7647e-08,
                    7.0731e-08,
                    7.377e-08,
                    7.6763e-08,
                    7.9713e-08,
                    8.2618e-08,
                    8.5472e-08,
                    8.8276e-08,
                    9.1029e-08,
                    9.3731e-08,
                    9.6382e-08,
                    9.9088e-08,
                    1.0185e-07,
                    1.0467e-07,
                    1.0754e-07,
                    1.1047e-07,
                    1.1346e-07,
                    1.1649e-07,
                    1.1958e-07,
                    1.2273e-07,
                    1.2594e-07,
                    1.2921e-07,
                    1.3253e-07,
                    1.3591e-07,
                    1.3934e-07,
                    1.4282e-07,
                    1.4637e-07,
                    1.4997e-07,
                    1.5363e-07,
                    1.5735e-07,
                    1.6114e-07,
                    1.6494e-07,
                    1.6876e-07,
                    1.7257e-07,
                    1.7639e-07,
                    1.8022e-07,
                    1.8407e-07,
                    1.8795e-07,
                    1.9185e-07,
                    1.9578e-07,
                    1.9973e-07,
                    2.0368e-07,
                    2.0764e-07,
                    2.116e-07,
                    2.1556e-07,
                    2.1952e-07,
                    2.2349e-07,
                    2.2746e-07,
                    2.3144e-07,
                    2.3545e-07,
                    2.395e-07,
                    2.4413e-07,
                    2.4936e-07,
                    2.5519e-07,
                    2.6162e-07,
                    2.6866e-07,
                    2.7627e-07,
                    2.8447e-07,
                    2.9325e-07,
                    3.0267e-07,
                    3.1273e-07,
                    3.234e-07,
                    3.3468e-07,
                    3.4656e-07,
                    3.5906e-07,
                    3.7216e-07,
                    3.8644e-07,
                    4.0192e-07,
                    4.1861e-07,
                    4.3652e-07,
                    4.5565e-07,
                    4.7583e-07,
                    4.971e-07,
                    5.1948e-07,
                    5.4301e-07,
                    5.6798e-07,
                    5.9443e-07,
                    6.2242e-07,
                    6.5202e-07,
                    6.8321e-07,
                    7.1605e-07,
                    7.5345e-07,
                    7.9554e-07,
                    8.4338e-07,
                    8.9667e-07,
                    9.5364e-07,
                    1.0159e-06,
                    1.0839e-06,
                    1.1577e-06,
                    1.2383e-06,
                    1.3255e-06,
                    1.4195e-06,
                    1.5201e-06,
                    1.6158e-06,
                    1.702e-06,
                    1.783e-06,
                    1.8855e-06,
                    1.9996e-06,
                    2.1212e-06,
                    2.252e-06,
                    4.3623e-06,
                    6.4685e-06,
                    9.3894e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_CH4": 0.1,
                "Fossil_CH4_timeseries": [
                    1.0123e-09,
                    2.0341e-09,
                    3.0655e-09,
                    4.1065e-09,
                    5.1572e-09,
                    6.2175e-09,
                    7.2875e-09,
                    8.3673e-09,
                    9.4568e-09,
                    1.0556e-08,
                    1.1643e-08,
                    1.2718e-08,
                    1.3782e-08,
                    1.4833e-08,
                    1.5872e-08,
                    1.6899e-08,
                    1.7915e-08,
                    1.8919e-08,
                    1.9911e-08,
                    2.0879e-08,
                    2.1837e-08,
                    2.2784e-08,
                    2.3723e-08,
                    2.4652e-08,
                    2.5572e-08,
                    2.6477e-08,
                    2.7367e-08,
                    2.8241e-08,
                    2.91e-08,
                    2.9943e-08,
                    3.0801e-08,
                    3.1674e-08,
                    3.2564e-08,
                    3.3472e-08,
                    3.4396e-08,
                    3.5339e-08,
                    3.6282e-08,
                    3.7243e-08,
                    3.8221e-08,
                    3.9227e-08,
                    4.0249e-08,
                    4.1288e-08,
                    4.2344e-08,
                    4.3417e-08,
                    4.4507e-08,
                    4.5616e-08,
                    4.6744e-08,
                    4.7896e-08,
                    4.9072e-08,
                    5.0272e-08,
                    5.1487e-08,
                    5.2703e-08,
                    5.3919e-08,
                    5.5133e-08,
                    5.6347e-08,
                    5.7575e-08,
                    5.8833e-08,
                    6.0107e-08,
                    6.1398e-08,
                    6.2708e-08,
                    6.4015e-08,
                    6.532e-08,
                    6.6622e-08,
                    6.792e-08,
                    6.9215e-08,
                    7.051e-08,
                    7.1804e-08,
                    7.3094e-08,
                    7.4413e-08,
                    7.5764e-08,
                    7.7294e-08,
                    7.9017e-08,
                    8.0932e-08,
                    8.3041e-08,
                    8.5342e-08,
                    8.7821e-08,
                    9.0475e-08,
                    9.3306e-08,
                    9.6367e-08,
                    9.9667e-08,
                    1.0317e-07,
                    1.0686e-07,
                    1.1076e-07,
                    1.1486e-07,
                    1.1917e-07,
                    1.2374e-07,
                    1.2859e-07,
                    1.3371e-07,
                    1.3908e-07,
                    1.4467e-07,
                    1.507e-07,
                    1.5717e-07,
                    1.6409e-07,
                    1.7146e-07,
                    1.7957e-07,
                    1.8843e-07,
                    1.981e-07,
                    2.0859e-07,
                    2.199e-07,
                    2.3205e-07,
                    2.4602e-07,
                    2.6187e-07,
                    2.8051e-07,
                    3.0146e-07,
                    3.2273e-07,
                    3.4613e-07,
                    3.7195e-07,
                    4.0008e-07,
                    4.3123e-07,
                    4.6526e-07,
                    5.02e-07,
                    5.4344e-07,
                    5.8718e-07,
                    6.35e-07,
                    6.8356e-07,
                    7.4397e-07,
                    8.0591e-07,
                    8.722e-07,
                    9.4408e-07,
                    2.9958e-06,
                    5.0555e-06,
                    7.9357e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [
                    2.289e-09,
                    4.5978e-09,
                    6.9263e-09,
                    9.2745e-09,
                    1.1642e-08,
                    1.403e-08,
                    1.6438e-08,
                    1.8865e-08,
                    2.1312e-08,
                    2.3778e-08,
                    2.6214e-08,
                    2.862e-08,
                    3.0995e-08,
                    3.334e-08,
                    3.5654e-08,
                    3.7938e-08,
                    4.0191e-08,
                    4.2414e-08,
                    4.4606e-08,
                    4.6768e-08,
                    4.8894e-08,
                    5.0985e-08,
                    5.3041e-08,
                    5.5061e-08,
                    5.7046e-08,
                    5.8995e-08,
                    6.0909e-08,
                    6.2788e-08,
                    6.4631e-08,
                    6.6439e-08,
                    6.8287e-08,
                    7.0174e-08,
                    7.2102e-08,
                    7.407e-08,
                    7.6077e-08,
                    7.8124e-08,
                    8.0212e-08,
                    8.2339e-08,
                    8.4506e-08,
                    8.6713e-08,
                    8.8958e-08,
                    9.1241e-08,
                    9.3562e-08,
                    9.592e-08,
                    9.8316e-08,
                    1.0075e-07,
                    1.0322e-07,
                    1.0573e-07,
                    1.0828e-07,
                    1.1086e-07,
                    1.1346e-07,
                    1.1605e-07,
                    1.1865e-07,
                    1.2126e-07,
                    1.2387e-07,
                    1.2649e-07,
                    1.2912e-07,
                    1.3175e-07,
                    1.3438e-07,
                    1.3702e-07,
                    1.3967e-07,
                    1.4232e-07,
                    1.4498e-07,
                    1.4764e-07,
                    1.5031e-07,
                    1.5298e-07,
                    1.5566e-07,
                    1.5835e-07,
                    1.6104e-07,
                    1.6373e-07,
                    1.6683e-07,
                    1.7034e-07,
                    1.7426e-07,
                    1.7858e-07,
                    1.8331e-07,
                    1.8845e-07,
                    1.9399e-07,
                    1.9994e-07,
                    2.063e-07,
                    2.1307e-07,
                    2.2024e-07,
                    2.2782e-07,
                    2.358e-07,
                    2.4419e-07,
                    2.5299e-07,
                    2.6269e-07,
                    2.7332e-07,
                    2.849e-07,
                    2.9744e-07,
                    3.1097e-07,
                    3.2513e-07,
                    3.3993e-07,
                    3.554e-07,
                    3.7155e-07,
                    3.8841e-07,
                    4.0599e-07,
                    4.2433e-07,
                    4.4342e-07,
                    4.6331e-07,
                    4.8399e-07,
                    5.0743e-07,
                    5.3367e-07,
                    5.6287e-07,
                    5.9521e-07,
                    6.309e-07,
                    6.6974e-07,
                    7.1191e-07,
                    7.5762e-07,
                    8.0702e-07,
                    8.6022e-07,
                    9.1751e-07,
                    9.7663e-07,
                    1.0286e-06,
                    1.067e-06,
                    1.0995e-06,
                    1.1415e-06,
                    1.1937e-06,
                    1.249e-06,
                    1.3079e-06,
                    1.3665e-06,
                    1.413e-06,
                    1.4537e-06,
                    1.4897e-06,
                    1.5365e-06,
                    1.5752e-06,
                    1.6067e-06,
                    1.6273e-06,
                    1.6398e-06,
                    1.6449e-06,
                    1.6439e-06,
                    1.6347e-06,
                    1.6169e-06,
                    1.6045e-06,
                    1.6088e-06,
                    1.6055e-06,
                    1.5685e-06,
                    1.527e-06,
                    1.485e-06,
                    1.4394e-06,
                    1.3774e-06,
                    1.3256e-06,
                    1.2748e-06,
                    1.2215e-06,
                    1.1572e-06,
                    1.0951e-06,
                    1.0369e-06,
                    9.9361e-07,
                    9.5603e-07,
                    9.2311e-07,
                    8.9195e-07,
                    8.6754e-07,
                    8.4697e-07,
                    8.3141e-07,
                    8.0849e-07,
                    7.9757e-07,
                    8.1119e-07,
                    8.2269e-07,
                    8.3157e-07,
                    8.4162e-07,
                    8.6855e-07,
                    8.8594e-07,
                    9.0924e-07,
                    9.3298e-07,
                    9.4968e-07,
                    9.6981e-07,
                    9.904e-07,
                    1.0007e-06,
                    1.0077e-06,
                    1.0108e-06,
                    1.0172e-06,
                    1.019e-06,
                    1.0223e-06
                ],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [
                    9.0794e-10,
                    1.8315e-09,
                    2.7702e-09,
                    3.7231e-09,
                    4.6893e-09,
                    5.6676e-09,
                    6.6565e-09,
                    7.6545e-09,
                    8.6595e-09,
                    9.6696e-09,
                    1.0683e-08,
                    1.1701e-08,
                    1.2721e-08,
                    1.3744e-08,
                    1.4771e-08,
                    1.58e-08,
                    1.6832e-08,
                    1.7868e-08,
                    1.8906e-08,
                    1.9949e-08,
                    2.1007e-08,
                    2.2099e-08,
                    2.3239e-08,
                    2.4439e-08,
                    2.5703e-08,
                    2.7033e-08,
                    2.8427e-08,
                    2.9876e-08,
                    3.137e-08,
                    3.289e-08,
                    3.4428e-08,
                    3.598e-08,
                    3.7544e-08,
                    3.912e-08,
                    4.0706e-08,
                    4.2302e-08,
                    4.3907e-08,
                    4.5523e-08,
                    4.715e-08,
                    4.8857e-08,
                    5.058e-08,
                    5.232e-08,
                    5.4081e-08,
                    5.5864e-08,
                    5.7673e-08,
                    5.9509e-08,
                    6.1375e-08,
                    6.3271e-08,
                    6.5201e-08,
                    6.7164e-08,
                    6.9164e-08,
                    7.1205e-08,
                    7.3292e-08,
                    7.5429e-08,
                    7.762e-08,
                    7.9869e-08,
                    8.2179e-08,
                    8.4555e-08,
                    8.6998e-08,
                    8.9513e-08,
                    9.2112e-08,
                    9.4813e-08,
                    9.763e-08,
                    1.0058e-07,
                    1.0366e-07,
                    1.0687e-07,
                    1.1023e-07,
                    1.1372e-07,
                    1.1733e-07,
                    1.2106e-07,
                    1.2489e-07,
                    1.2883e-07,
                    1.3287e-07,
                    1.3701e-07,
                    1.4126e-07,
                    1.456e-07,
                    1.5003e-07,
                    1.5455e-07,
                    1.5914e-07,
                    1.6381e-07,
                    1.6854e-07,
                    1.7334e-07,
                    1.7819e-07,
                    1.8311e-07,
                    1.8809e-07,
                    1.9312e-07,
                    1.982e-07,
                    2.0331e-07,
                    2.0846e-07,
                    2.1364e-07,
                    2.1902e-07,
                    2.2489e-07,
                    2.3149e-07,
                    2.3898e-07,
                    2.4743e-07,
                    2.5685e-07,
                    2.6716e-07,
                    2.7823e-07,
                    2.8983e-07,
                    3.0167e-07,
                    3.136e-07,
                    3.2562e-07,
                    3.3776e-07,
                    3.5002e-07,
                    3.6242e-07,
                    3.7496e-07,
                    3.8765e-07,
                    4.0048e-07,
                    4.1345e-07,
                    4.2657e-07,
                    4.4086e-07,
                    4.5526e-07,
                    4.6922e-07,
                    4.8257e-07,
                    4.9578e-07,
                    5.1018e-07,
                    5.2498e-07,
                    5.4036e-07,
                    5.5618e-07,
                    5.7316e-07,
                    5.8995e-07,
                    6.0664e-07,
                    6.2364e-07,
                    6.404e-07,
                    6.5676e-07,
                    6.733e-07,
                    6.8986e-07,
                    7.0673e-07,
                    7.2348e-07,
                    7.4298e-07,
                    7.6193e-07,
                    7.8264e-07,
                    8.0437e-07,
                    8.249e-07,
                    8.4694e-07,
                    8.6782e-07,
                    8.905e-07,
                    9.123e-07,
                    9.3322e-07,
                    9.5493e-07,
                    9.777e-07,
                    1.0022e-06,
                    1.0276e-06,
                    1.0539e-06,
                    1.0813e-06,
                    1.1101e-06,
                    1.1428e-06,
                    1.1779e-06,
                    1.2171e-06,
                    1.257e-06,
                    1.2991e-06,
                    1.3401e-06,
                    1.3849e-06,
                    1.4322e-06,
                    1.4769e-06,
                    1.5289e-06,
                    1.5833e-06,
                    1.638e-06,
                    1.6898e-06,
                    1.7428e-06,
                    1.7939e-06,
                    1.8497e-06,
                    1.9071e-06,
                    1.961e-06,
                    2.0135e-06,
                    2.0657e-06,
                    2.1167e-06,
                    2.1697e-06,
                    2.2212e-06,
                    2.2788e-06,
                    2.3398e-06,
                    2.4005e-06
                ],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [
                    5.4447e-10,
                    1.0973e-09,
                    1.6583e-09,
                    2.227e-09,
                    2.803e-09,
                    3.3858e-09,
                    3.9748e-09,
                    4.5691e-09,
                    5.168e-09,
                    5.7705e-09,
                    6.376e-09,
                    6.9845e-09,
                    7.5957e-09,
                    8.2096e-09,
                    8.8262e-09,
                    9.4454e-09,
                    1.0067e-08,
                    1.0692e-08,
                    1.132e-08,
                    1.1951e-08,
                    1.2589e-08,
                    1.3245e-08,
                    1.3924e-08,
                    1.463e-08,
                    1.5367e-08,
                    1.6135e-08,
                    1.6932e-08,
                    1.7756e-08,
                    1.8601e-08,
                    1.9459e-08,
                    2.0327e-08,
                    2.1202e-08,
                    2.2084e-08,
                    2.2973e-08,
                    2.3867e-08,
                    2.4768e-08,
                    2.5674e-08,
                    2.6586e-08,
                    2.7504e-08,
                    2.843e-08,
                    2.9365e-08,
                    3.0306e-08,
                    3.1256e-08,
                    3.2214e-08,
                    3.318e-08,
                    3.4155e-08,
                    3.5139e-08,
                    3.6132e-08,
                    3.7136e-08,
                    3.815e-08,
                    3.9176e-08,
                    4.0216e-08,
                    4.1271e-08,
                    4.2343e-08,
                    4.3431e-08,
                    4.4536e-08,
                    4.5659e-08,
                    4.68e-08,
                    4.7957e-08,
                    4.9131e-08,
                    5.032e-08,
                    5.1525e-08,
                    5.2745e-08,
                    5.3981e-08,
                    5.5232e-08,
                    5.6499e-08,
                    5.7781e-08,
                    5.9079e-08,
                    6.0393e-08,
                    6.1722e-08,
                    6.3068e-08,
                    6.4432e-08,
                    6.5812e-08,
                    6.721e-08,
                    6.8626e-08,
                    7.006e-08,
                    7.1511e-08,
                    7.2979e-08,
                    7.4463e-08,
                    7.5963e-08,
                    7.7477e-08,
                    7.9004e-08,
                    8.0542e-08,
                    8.2092e-08,
                    8.3653e-08,
                    8.5226e-08,
                    8.6811e-08,
                    8.8412e-08,
                    9.0029e-08,
                    9.1665e-08,
                    9.3341e-08,
                    9.5093e-08,
                    9.6946e-08,
                    9.8921e-08,
                    1.0103e-07,
                    1.0328e-07,
                    1.0566e-07,
                    1.0817e-07,
                    1.1079e-07,
                    1.1349e-07,
                    1.1625e-07,
                    1.1907e-07,
                    1.2194e-07,
                    1.2486e-07,
                    1.2783e-07,
                    1.3084e-07,
                    1.3391e-07,
                    1.3703e-07,
                    1.4022e-07,
                    1.4349e-07,
                    1.4685e-07,
                    1.5033e-07,
                    1.5395e-07,
                    1.5773e-07,
                    1.6168e-07,
                    1.658e-07,
                    1.7009e-07,
                    1.7455e-07,
                    1.7916e-07,
                    1.8463e-07,
                    1.8986e-07,
                    1.956e-07,
                    2.0176e-07,
                    2.0727e-07,
                    2.1237e-07,
                    2.1777e-07,
                    2.231e-07,
                    2.2904e-07,
                    2.3455e-07,
                    2.4231e-07,
                    2.4878e-07,
                    2.5639e-07,
                    2.6527e-07,
                    2.7314e-07,
                    2.8205e-07,
                    2.9067e-07,
                    3.0009e-07,
                    3.0953e-07,
                    3.1921e-07,
                    3.2914e-07,
                    3.4009e-07,
                    3.5218e-07,
                    3.6461e-07,
                    3.7791e-07,
                    3.9187e-07,
                    4.071e-07,
                    4.2397e-07,
                    4.4155e-07,
                    4.6001e-07,
                    4.7653e-07,
                    4.9349e-07,
                    5.1069e-07,
                    5.2952e-07,
                    5.4882e-07,
                    5.6737e-07,
                    5.9111e-07,
                    6.15e-07,
                    6.3976e-07,
                    6.6176e-07,
                    6.8244e-07,
                    7.0335e-07,
                    7.2498e-07,
                    7.4618e-07,
                    7.6628e-07,
                    7.848e-07,
                    8.022e-07,
                    8.1989e-07,
                    8.3767e-07,
                    8.5604e-07,
                    8.7667e-07,
                    8.9784e-07,
                    9.1843e-07
                ],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": [
                    3.6347e-10,
                    7.342e-10,
                    1.1119e-09,
                    1.4961e-09,
                    1.8863e-09,
                    2.2818e-09,
                    2.6818e-09,
                    3.0854e-09,
                    3.4915e-09,
                    3.8991e-09,
                    4.3074e-09,
                    4.7162e-09,
                    5.1254e-09,
                    5.5348e-09,
                    5.9445e-09,
                    6.3545e-09,
                    6.7647e-09,
                    7.1754e-09,
                    7.5866e-09,
                    7.9986e-09,
                    8.4174e-09,
                    8.8538e-09,
                    9.3156e-09,
                    9.8087e-09,
                    1.0336e-08,
                    1.0899e-08,
                    1.1495e-08,
                    1.212e-08,
                    1.2769e-08,
                    1.3431e-08,
                    1.4101e-08,
                    1.4778e-08,
                    1.546e-08,
                    1.6147e-08,
                    1.6839e-08,
                    1.7534e-08,
                    1.8233e-08,
                    1.8937e-08,
                    1.9646e-08,
                    2.0427e-08,
                    2.1215e-08,
                    2.2014e-08,
                    2.2825e-08,
                    2.365e-08,
                    2.4493e-08,
                    2.5354e-08,
                    2.6236e-08,
                    2.7139e-08,
                    2.8065e-08,
                    2.9014e-08,
                    2.9987e-08,
                    3.0989e-08,
                    3.2021e-08,
                    3.3087e-08,
                    3.419e-08,
                    3.5333e-08,
                    3.652e-08,
                    3.7755e-08,
                    3.9041e-08,
                    4.0383e-08,
                    4.1792e-08,
                    4.3288e-08,
                    4.4885e-08,
                    4.6595e-08,
                    4.8424e-08,
                    5.0375e-08,
                    5.2449e-08,
                    5.464e-08,
                    5.694e-08,
                    5.9336e-08,
                    6.1822e-08,
                    6.4396e-08,
                    6.7057e-08,
                    6.9804e-08,
                    7.2633e-08,
                    7.554e-08,
                    7.8521e-08,
                    8.157e-08,
                    8.4681e-08,
                    8.7847e-08,
                    9.1063e-08,
                    9.4332e-08,
                    9.7652e-08,
                    1.0102e-07,
                    1.0444e-07,
                    1.0789e-07,
                    1.1138e-07,
                    1.149e-07,
                    1.1844e-07,
                    1.2198e-07,
                    1.2568e-07,
                    1.298e-07,
                    1.3455e-07,
                    1.4006e-07,
                    1.464e-07,
                    1.5357e-07,
                    1.615e-07,
                    1.7006e-07,
                    1.7904e-07,
                    1.8819e-07,
                    1.9735e-07,
                    2.0655e-07,
                    2.1582e-07,
                    2.2516e-07,
                    2.3459e-07,
                    2.4412e-07,
                    2.5374e-07,
                    2.6344e-07,
                    2.7323e-07,
                    2.8308e-07,
                    2.9401e-07,
                    3.0493e-07,
                    3.1527e-07,
                    3.2484e-07,
                    3.341e-07,
                    3.4438e-07,
                    3.5488e-07,
                    3.6581e-07,
                    3.7703e-07,
                    3.8853e-07,
                    4.0009e-07,
                    4.1104e-07,
                    4.2188e-07,
                    4.3312e-07,
                    4.4439e-07,
                    4.5553e-07,
                    4.6676e-07,
                    4.7769e-07,
                    4.8893e-07,
                    5.0067e-07,
                    5.1315e-07,
                    5.2625e-07,
                    5.391e-07,
                    5.5176e-07,
                    5.6489e-07,
                    5.7715e-07,
                    5.9041e-07,
                    6.0277e-07,
                    6.1401e-07,
                    6.258e-07,
                    6.3761e-07,
                    6.5004e-07,
                    6.6298e-07,
                    6.76e-07,
                    6.8945e-07,
                    7.0298e-07,
                    7.1885e-07,
                    7.3634e-07,
                    7.5711e-07,
                    7.8045e-07,
                    8.0564e-07,
                    8.2943e-07,
                    8.5542e-07,
                    8.8338e-07,
                    9.0958e-07,
                    9.3777e-07,
                    9.6829e-07,
                    9.9825e-07,
                    1.0281e-06,
                    1.0603e-06,
                    1.0905e-06,
                    1.1247e-06,
                    1.1609e-06,
                    1.1947e-06,
                    1.2287e-06,
                    1.2635e-06,
                    1.2968e-06,
                    1.3321e-06,
                    1.3652e-06,
                    1.4021e-06,
                    1.4419e-06,
                    1.4821e-06
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                115.01164,
                                4.89172
                            ],
                            [
                                115.05142,
                                5.04601
                            ],
                            [
                                114.84924,
                                4.96913
                            ],
                            [
                                114.67583,
                                4.84592
                            ],
                            [
                                114.5122,
                                4.70409
                            ],
                            [
                                114.44267,
                                4.6642
                            ],
                            [
                                114.29663,
                                4.61148
                            ],
                            [
                                114.17743,
                                4.58917
                            ],
                            [
                                114.07146,
                                4.58887
                            ],
                            [
                                114.1591,
                                4.57043
                            ],
                            [
                                114.25516,
                                4.50396
                            ],
                            [
                                114.32804,
                                4.34376
                            ],
                            [
                                114.31704,
                                4.27871
                            ],
                            [
                                114.45966,
                                4.22031
                            ],
                            [
                                114.49681,
                                4.14819
                            ],
                            [
                                114.54421,
                                4.12404
                            ],
                            [
                                114.57086,
                                4.04558
                            ],
                            [
                                114.68986,
                                4.02231
                            ],
                            [
                                114.79232,
                                4.1247
                            ],
                            [
                                114.80745,
                                4.19219
                            ],
                            [
                                114.8566,
                                4.26802
                            ],
                            [
                                114.88196,
                                4.42346
                            ],
                            [
                                114.83118,
                                4.42843
                            ],
                            [
                                114.81776,
                                4.58738
                            ],
                            [
                                114.77756,
                                4.72882
                            ],
                            [
                                114.82497,
                                4.74759
                            ],
                            [
                                114.88592,
                                4.81403
                            ],
                            [
                                114.97277,
                                4.81253
                            ],
                            [
                                115.01164,
                                4.89172
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                115.15459,
                                4.91276
                            ],
                            [
                                115.03586,
                                4.80439
                            ],
                            [
                                115.02255,
                                4.74704
                            ],
                            [
                                115.0423,
                                4.61904
                            ],
                            [
                                115.09482,
                                4.49152
                            ],
                            [
                                115.11134,
                                4.37124
                            ],
                            [
                                115.14904,
                                4.38346
                            ],
                            [
                                115.29582,
                                4.33591
                            ],
                            [
                                115.36357,
                                4.34072
                            ],
                            [
                                115.27302,
                                4.44717
                            ],
                            [
                                115.26726,
                                4.5288
                            ],
                            [
                                115.29005,
                                4.6092
                            ],
                            [
                                115.26036,
                                4.65089
                            ],
                            [
                                115.23704,
                                4.80414
                            ],
                            [
                                115.15041,
                                4.87293
                            ],
                            [
                                115.15459,
                                4.91276
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "BGR",
                "Country": "Bulgaria",
                "Total_3GHG": 0.16,
                "Total_3GHG_timeseries": [
                    2.4572e-06,
                    4.7973e-06,
                    7.0514e-06,
                    9.2172e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026
                ],
                "Fossil_3GHG": 0.21,
                "Fossil_3GHG_timeseries": [
                    4.7243e-07,
                    9.3834e-07,
                    1.3977e-06,
                    1.8506e-06,
                    2.297e-06,
                    2.7368e-06,
                    3.1701e-06,
                    3.5969e-06,
                    4.0171e-06,
                    4.4308e-06,
                    4.8374e-06,
                    5.2368e-06,
                    5.629e-06,
                    6.0141e-06,
                    6.3921e-06,
                    6.763e-06,
                    7.1268e-06,
                    7.4836e-06,
                    7.8332e-06,
                    8.1758e-06,
                    8.562e-06,
                    8.992e-06,
                    9.4662e-06,
                    9.9849e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022
                ],
                "Land_3GHG": 0.07,
                "Land_3GHG_timeseries": [
                    1.9848e-06,
                    3.859e-06,
                    5.6536e-06,
                    7.3666e-06,
                    9.005e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Total_CO2": 0.17,
                "Total_CO2_timeseries": [
                    1.1078e-06,
                    2.1183e-06,
                    3.0626e-06,
                    3.9386e-06,
                    4.7535e-06,
                    5.5138e-06,
                    6.2337e-06,
                    6.906e-06,
                    7.5324e-06,
                    8.1177e-06,
                    8.665e-06,
                    9.1722e-06,
                    9.6452e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019
                ],
                "Fossil_CO2": 0.23,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.65e-09,
                    3.3e-09,
                    6.6e-09,
                    1.155e-08,
                    1.485e-08,
                    1.815e-08,
                    2.31e-08,
                    3.135e-08,
                    4.29e-08,
                    5.775e-08,
                    7.59e-08,
                    9.735e-08,
                    1.254e-07,
                    1.617e-07,
                    1.9965e-07,
                    2.475e-07,
                    2.97e-07,
                    3.63e-07,
                    4.29e-07,
                    5.2635e-07,
                    6.4845e-07,
                    7.557e-07,
                    8.613e-07,
                    9.966e-07,
                    1.1583e-06,
                    1.3002e-06,
                    1.5048e-06,
                    1.7737e-06,
                    2.046e-06,
                    2.3314e-06,
                    2.7357e-06,
                    3.1399e-06,
                    3.4947e-06,
                    4.0277e-06,
                    4.3708e-06,
                    4.7867e-06,
                    5.2998e-06,
                    5.94e-06,
                    6.3162e-06,
                    6.8112e-06,
                    7.4267e-06,
                    8.1064e-06,
                    8.8291e-06,
                    9.6591e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018
                ],
                "Land_CO2": 0.04,
                "Land_CO2_timeseries": [
                    1.1078e-06,
                    2.1183e-06,
                    3.0626e-06,
                    3.9386e-06,
                    4.7535e-06,
                    5.5138e-06,
                    6.2337e-06,
                    6.906e-06,
                    7.5324e-06,
                    8.1177e-06,
                    8.665e-06,
                    9.1722e-06,
                    9.6452e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Total_CH4": 0.11,
                "Total_CH4_timeseries": [
                    1.2351e-06,
                    2.4485e-06,
                    3.6402e-06,
                    4.8103e-06,
                    5.9588e-06,
                    7.0857e-06,
                    8.1909e-06,
                    9.2746e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Fossil_CH4": 0.15,
                "Fossil_CH4_timeseries": [
                    4.2632e-07,
                    8.4561e-07,
                    1.2579e-06,
                    1.6631e-06,
                    2.0613e-06,
                    2.4526e-06,
                    2.8368e-06,
                    3.214e-06,
                    3.5843e-06,
                    3.9476e-06,
                    4.3033e-06,
                    4.6515e-06,
                    4.9921e-06,
                    5.3252e-06,
                    5.6508e-06,
                    5.9688e-06,
                    6.2794e-06,
                    6.5825e-06,
                    6.8781e-06,
                    7.1662e-06,
                    7.4974e-06,
                    7.8718e-06,
                    8.2895e-06,
                    8.7509e-06,
                    9.2559e-06,
                    9.805e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Land_CH4": 0.06,
                "Land_CH4_timeseries": [
                    8.0874e-07,
                    1.6029e-06,
                    2.3824e-06,
                    3.1472e-06,
                    3.8975e-06,
                    4.6331e-06,
                    5.3541e-06,
                    6.0605e-06,
                    6.7523e-06,
                    7.4294e-06,
                    8.0907e-06,
                    8.7361e-06,
                    9.3656e-06,
                    9.9793e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_N2O": 0.26,
                "Total_N2O_timeseries": [
                    1.1432e-07,
                    2.3052e-07,
                    3.4853e-07,
                    4.6827e-07,
                    5.8962e-07,
                    7.1245e-07,
                    8.366e-07,
                    9.6188e-07,
                    1.0881e-06,
                    1.215e-06,
                    1.3424e-06,
                    1.4704e-06,
                    1.5988e-06,
                    1.7276e-06,
                    1.857e-06,
                    1.9867e-06,
                    2.117e-06,
                    2.2477e-06,
                    2.3789e-06,
                    2.5107e-06,
                    2.6443e-06,
                    2.7818e-06,
                    2.925e-06,
                    3.0748e-06,
                    3.2321e-06,
                    3.3969e-06,
                    3.5689e-06,
                    3.7474e-06,
                    3.9308e-06,
                    4.1175e-06,
                    4.3062e-06,
                    4.4966e-06,
                    4.6886e-06,
                    4.8819e-06,
                    5.0765e-06,
                    5.2723e-06,
                    5.4694e-06,
                    5.6677e-06,
                    5.8674e-06,
                    6.0827e-06,
                    6.2891e-06,
                    6.4871e-06,
                    6.6771e-06,
                    6.8599e-06,
                    7.0363e-06,
                    7.2072e-06,
                    7.3738e-06,
                    7.5374e-06,
                    7.6993e-06,
                    7.8612e-06,
                    8.0239e-06,
                    8.1878e-06,
                    8.3533e-06,
                    8.5206e-06,
                    8.6899e-06,
                    8.8616e-06,
                    9.0357e-06,
                    9.2126e-06,
                    9.3923e-06,
                    9.575e-06,
                    9.7635e-06,
                    9.9628e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_N2O": 0.28,
                "Fossil_N2O_timeseries": [
                    4.6109e-08,
                    9.2732e-08,
                    1.3986e-07,
                    1.875e-07,
                    2.3563e-07,
                    2.8424e-07,
                    3.3332e-07,
                    3.8286e-07,
                    4.3284e-07,
                    4.8324e-07,
                    5.3405e-07,
                    5.8527e-07,
                    6.369e-07,
                    6.8893e-07,
                    7.4137e-07,
                    7.9421e-07,
                    8.4745e-07,
                    9.011e-07,
                    9.5516e-07,
                    1.0096e-06,
                    1.0646e-06,
                    1.1203e-06,
                    1.1767e-06,
                    1.2341e-06,
                    1.2923e-06,
                    1.3516e-06,
                    1.4117e-06,
                    1.4728e-06,
                    1.5345e-06,
                    1.5969e-06,
                    1.6599e-06,
                    1.7233e-06,
                    1.7872e-06,
                    1.8516e-06,
                    1.9165e-06,
                    1.9818e-06,
                    2.0476e-06,
                    2.1138e-06,
                    2.1805e-06,
                    2.2482e-06,
                    2.3165e-06,
                    2.3854e-06,
                    2.4549e-06,
                    2.525e-06,
                    2.5958e-06,
                    2.6672e-06,
                    2.7394e-06,
                    2.8122e-06,
                    2.8857e-06,
                    2.96e-06,
                    3.035e-06,
                    3.1108e-06,
                    3.1875e-06,
                    3.265e-06,
                    3.3435e-06,
                    3.4229e-06,
                    3.5032e-06,
                    3.5844e-06,
                    3.6664e-06,
                    3.7492e-06,
                    3.8327e-06,
                    3.9169e-06,
                    4.0018e-06,
                    4.0874e-06,
                    4.1736e-06,
                    4.2606e-06,
                    4.3482e-06,
                    4.4365e-06,
                    4.5256e-06,
                    4.6153e-06,
                    4.7058e-06,
                    4.7972e-06,
                    4.8894e-06,
                    4.9824e-06,
                    5.0764e-06,
                    5.1712e-06,
                    5.2669e-06,
                    5.3635e-06,
                    5.4609e-06,
                    5.5591e-06,
                    5.6592e-06,
                    5.7632e-06,
                    5.8727e-06,
                    5.989e-06,
                    6.113e-06,
                    6.2454e-06,
                    6.3865e-06,
                    6.5361e-06,
                    6.6939e-06,
                    6.8592e-06,
                    7.0315e-06,
                    7.2111e-06,
                    7.3982e-06,
                    7.5932e-06,
                    7.7967e-06,
                    8.0093e-06,
                    8.2319e-06,
                    8.4652e-06,
                    8.7104e-06,
                    8.9685e-06,
                    9.2449e-06,
                    9.5487e-06,
                    9.8875e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_N2O": 0.25,
                "Land_N2O_timeseries": [
                    6.8211e-08,
                    1.3779e-07,
                    2.0867e-07,
                    2.8077e-07,
                    3.54e-07,
                    4.2822e-07,
                    5.0328e-07,
                    5.7902e-07,
                    6.5525e-07,
                    7.3174e-07,
                    8.0836e-07,
                    8.8508e-07,
                    9.6187e-07,
                    1.0387e-06,
                    1.1156e-06,
                    1.1925e-06,
                    1.2695e-06,
                    1.3466e-06,
                    1.4238e-06,
                    1.5011e-06,
                    1.5797e-06,
                    1.6616e-06,
                    1.7482e-06,
                    1.8408e-06,
                    1.9398e-06,
                    2.0453e-06,
                    2.1572e-06,
                    2.2746e-06,
                    2.3963e-06,
                    2.5206e-06,
                    2.6463e-06,
                    2.7733e-06,
                    2.9014e-06,
                    3.0303e-06,
                    3.1601e-06,
                    3.2905e-06,
                    3.4218e-06,
                    3.5539e-06,
                    3.6868e-06,
                    3.8345e-06,
                    3.9727e-06,
                    4.1018e-06,
                    4.2223e-06,
                    4.3349e-06,
                    4.4405e-06,
                    4.54e-06,
                    4.6345e-06,
                    4.7252e-06,
                    4.8136e-06,
                    4.9012e-06,
                    4.9889e-06,
                    5.0771e-06,
                    5.1659e-06,
                    5.2556e-06,
                    5.3464e-06,
                    5.4387e-06,
                    5.5325e-06,
                    5.6282e-06,
                    5.7259e-06,
                    5.8258e-06,
                    5.9308e-06,
                    6.0459e-06,
                    6.1754e-06,
                    6.3228e-06,
                    6.4912e-06,
                    6.6826e-06,
                    6.8987e-06,
                    7.1402e-06,
                    7.4073e-06,
                    7.6992e-06,
                    8.0203e-06,
                    8.3782e-06,
                    8.7781e-06,
                    9.2227e-06,
                    9.7122e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            22.67516,
                            44.21566
                        ],
                        [
                            22.61427,
                            44.165
                        ],
                        [
                            22.62121,
                            44.06338
                        ],
                        [
                            22.53106,
                            44.02083
                        ],
                        [
                            22.41103,
                            44.0047
                        ],
                        [
                            22.40847,
                            43.94116
                        ],
                        [
                            22.3575,
                            43.81003
                        ],
                        [
                            22.40784,
                            43.69597
                        ],
                        [
                            22.4787,
                            43.65602
                        ],
                        [
                            22.48817,
                            43.56743
                        ],
                        [
                            22.5349,
                            43.47127
                        ],
                        [
                            22.68034,
                            43.39447
                        ],
                        [
                            22.76843,
                            43.37533
                        ],
                        [
                            22.82621,
                            43.3304
                        ],
                        [
                            22.89768,
                            43.22652
                        ],
                        [
                            22.98371,
                            43.20193
                        ],
                        [
                            22.98264,
                            43.11165
                        ],
                        [
                            22.89704,
                            43.03563
                        ],
                        [
                            22.78545,
                            42.98139
                        ],
                        [
                            22.74431,
                            42.88658
                        ],
                        [
                            22.67518,
                            42.86678
                        ],
                        [
                            22.6172,
                            42.8957
                        ],
                        [
                            22.53745,
                            42.88128
                        ],
                        [
                            22.44091,
                            42.80688
                        ],
                        [
                            22.50092,
                            42.73918
                        ],
                        [
                            22.47642,
                            42.71056
                        ],
                        [
                            22.43914,
                            42.56646
                        ],
                        [
                            22.54632,
                            42.50821
                        ],
                        [
                            22.51809,
                            42.39666
                        ],
                        [
                            22.45553,
                            42.33366
                        ],
                        [
                            22.36021,
                            42.31116
                        ],
                        [
                            22.50086,
                            42.19621
                        ],
                        [
                            22.5288,
                            42.13993
                        ],
                        [
                            22.67777,
                            42.06437
                        ],
                        [
                            22.86721,
                            42.0222
                        ],
                        [
                            22.87345,
                            41.9361
                        ],
                        [
                            22.96867,
                            41.77099
                        ],
                        [
                            23.03412,
                            41.70944
                        ],
                        [
                            22.94931,
                            41.59866
                        ],
                        [
                            22.97257,
                            41.56086
                        ],
                        [
                            22.92759,
                            41.33854
                        ],
                        [
                            23.08007,
                            41.31978
                        ],
                        [
                            23.19873,
                            41.32271
                        ],
                        [
                            23.23275,
                            41.37544
                        ],
                        [
                            23.32236,
                            41.39877
                        ],
                        [
                            23.52509,
                            41.4052
                        ],
                        [
                            23.63777,
                            41.37604
                        ],
                        [
                            23.67424,
                            41.4107
                        ],
                        [
                            23.76755,
                            41.39687
                        ],
                        [
                            23.80093,
                            41.4371
                        ],
                        [
                            23.90583,
                            41.45758
                        ],
                        [
                            23.97364,
                            41.43858
                        ],
                        [
                            24.07269,
                            41.46605
                        ],
                        [
                            24.07847,
                            41.54183
                        ],
                        [
                            24.17406,
                            41.52265
                        ],
                        [
                            24.26184,
                            41.57359
                        ],
                        [
                            24.36836,
                            41.51805
                        ],
                        [
                            24.52517,
                            41.5688
                        ],
                        [
                            24.60822,
                            41.42771
                        ],
                        [
                            25.05523,
                            41.36492
                        ],
                        [
                            25.17938,
                            41.31019
                        ],
                        [
                            25.2351,
                            41.24722
                        ],
                        [
                            25.28729,
                            41.23581
                        ],
                        [
                            25.52905,
                            41.27719
                        ],
                        [
                            25.57336,
                            41.31821
                        ],
                        [
                            25.68347,
                            41.30672
                        ],
                        [
                            25.81565,
                            41.33726
                        ],
                        [
                            25.88554,
                            41.30467
                        ],
                        [
                            26.03575,
                            41.35004
                        ],
                        [
                            26.132,
                            41.3553
                        ],
                        [
                            26.17322,
                            41.4323
                        ],
                        [
                            26.18445,
                            41.51978
                        ],
                        [
                            26.15353,
                            41.60488
                        ],
                        [
                            26.07092,
                            41.65041
                        ],
                        [
                            26.07019,
                            41.70907
                        ],
                        [
                            26.17272,
                            41.74881
                        ],
                        [
                            26.35788,
                            41.7111
                        ],
                        [
                            26.32843,
                            41.73698
                        ],
                        [
                            26.36906,
                            41.82068
                        ],
                        [
                            26.53861,
                            41.82348
                        ],
                        [
                            26.6176,
                            41.96533
                        ],
                        [
                            26.75382,
                            41.95843
                        ],
                        [
                            26.78741,
                            41.9896
                        ],
                        [
                            26.96411,
                            41.99707
                        ],
                        [
                            27.06709,
                            42.09318
                        ],
                        [
                            27.15962,
                            42.06566
                        ],
                        [
                            27.27067,
                            42.10432
                        ],
                        [
                            27.37642,
                            42.04614
                        ],
                        [
                            27.44835,
                            41.96724
                        ],
                        [
                            27.57497,
                            41.93682
                        ],
                        [
                            27.70215,
                            41.9766
                        ],
                        [
                            27.83516,
                            41.95035
                        ],
                        [
                            28.03551,
                            41.98308
                        ],
                        [
                            27.94685,
                            42.10317
                        ],
                        [
                            27.75661,
                            42.2455
                        ],
                        [
                            27.7121,
                            42.4071
                        ],
                        [
                            27.64868,
                            42.45007
                        ],
                        [
                            27.5133,
                            42.42915
                        ],
                        [
                            27.45365,
                            42.48491
                        ],
                        [
                            27.52711,
                            42.55894
                        ],
                        [
                            27.63359,
                            42.57825
                        ],
                        [
                            27.64662,
                            42.63852
                        ],
                        [
                            27.72156,
                            42.65687
                        ],
                        [
                            27.72214,
                            42.70229
                        ],
                        [
                            27.89907,
                            42.70025
                        ],
                        [
                            27.88262,
                            42.83841
                        ],
                        [
                            27.9068,
                            42.92957
                        ],
                        [
                            27.89002,
                            43.04213
                        ],
                        [
                            27.94658,
                            43.1675
                        ],
                        [
                            28.01383,
                            43.22759
                        ],
                        [
                            28.09268,
                            43.37632
                        ],
                        [
                            28.15078,
                            43.40473
                        ],
                        [
                            28.30944,
                            43.41797
                        ],
                        [
                            28.47096,
                            43.38279
                        ],
                        [
                            28.5295,
                            43.42354
                        ],
                        [
                            28.60746,
                            43.53937
                        ],
                        [
                            28.5679,
                            43.60175
                        ],
                        [
                            28.57888,
                            43.73874
                        ],
                        [
                            28.44558,
                            43.7338
                        ],
                        [
                            28.23614,
                            43.75852
                        ],
                        [
                            27.99426,
                            43.84296
                        ],
                        [
                            27.94431,
                            43.98478
                        ],
                        [
                            27.71,
                            43.95932
                        ],
                        [
                            27.67365,
                            44.02978
                        ],
                        [
                            27.61204,
                            44.01221
                        ],
                        [
                            27.39862,
                            44.01333
                        ],
                        [
                            27.29177,
                            44.07552
                        ],
                        [
                            27.26376,
                            44.12566
                        ],
                        [
                            27.13497,
                            44.14051
                        ],
                        [
                            26.92368,
                            44.14015
                        ],
                        [
                            26.77211,
                            44.07955
                        ],
                        [
                            26.63306,
                            44.05853
                        ],
                        [
                            26.34596,
                            44.03636
                        ],
                        [
                            26.1008,
                            43.96721
                        ],
                        [
                            26.06076,
                            43.9086
                        ],
                        [
                            25.95283,
                            43.859
                        ],
                        [
                            25.87287,
                            43.7727
                        ],
                        [
                            25.77684,
                            43.70671
                        ],
                        [
                            25.65714,
                            43.6852
                        ],
                        [
                            25.56173,
                            43.64713
                        ],
                        [
                            25.3658,
                            43.62461
                        ],
                        [
                            25.17971,
                            43.70028
                        ],
                        [
                            25.05635,
                            43.69404
                        ],
                        [
                            24.9969,
                            43.72767
                        ],
                        [
                            24.69967,
                            43.69521
                        ],
                        [
                            24.59958,
                            43.74941
                        ],
                        [
                            24.48327,
                            43.76002
                        ],
                        [
                            24.34076,
                            43.69696
                        ],
                        [
                            24.1958,
                            43.68363
                        ],
                        [
                            24.08068,
                            43.70414
                        ],
                        [
                            23.97772,
                            43.74832
                        ],
                        [
                            23.87499,
                            43.75095
                        ],
                        [
                            23.70063,
                            43.80675
                        ],
                        [
                            23.55778,
                            43.80175
                        ],
                        [
                            23.43386,
                            43.85275
                        ],
                        [
                            23.26097,
                            43.84499
                        ],
                        [
                            23.13939,
                            43.80476
                        ],
                        [
                            23.05203,
                            43.79636
                        ],
                        [
                            22.87971,
                            43.8336
                        ],
                        [
                            22.84214,
                            43.86928
                        ],
                        [
                            22.89237,
                            43.99138
                        ],
                        [
                            23.01055,
                            44.01206
                        ],
                        [
                            23.0229,
                            44.08838
                        ],
                        [
                            22.93286,
                            44.09842
                        ],
                        [
                            22.67516,
                            44.21566
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "BFA",
                "Country": "Burkina Faso",
                "Total_3GHG": 0.09,
                "Total_3GHG_timeseries": [
                    3.3786e-07,
                    6.7689e-07,
                    1.0158e-06,
                    1.3541e-06,
                    1.6919e-06,
                    2.0291e-06,
                    2.3661e-06,
                    2.703e-06,
                    3.04e-06,
                    3.374e-06,
                    3.7103e-06,
                    4.0501e-06,
                    4.3947e-06,
                    4.7438e-06,
                    5.0979e-06,
                    5.457e-06,
                    5.8216e-06,
                    6.1916e-06,
                    6.5673e-06,
                    6.951e-06,
                    7.3409e-06,
                    7.738e-06,
                    8.1431e-06,
                    8.5567e-06,
                    8.9794e-06,
                    9.4109e-06,
                    9.8511e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015
                ],
                "Fossil_3GHG": 0.03,
                "Fossil_3GHG_timeseries": [
                    5.8362e-08,
                    1.1948e-07,
                    1.8339e-07,
                    2.501e-07,
                    3.1965e-07,
                    3.9205e-07,
                    4.6733e-07,
                    5.455e-07,
                    6.2659e-07,
                    7.1062e-07,
                    7.9809e-07,
                    8.8901e-07,
                    9.8403e-07,
                    1.0826e-06,
                    1.1847e-06,
                    1.2904e-06,
                    1.3997e-06,
                    1.5126e-06,
                    1.6293e-06,
                    1.7496e-06,
                    1.8714e-06,
                    1.9946e-06,
                    2.1193e-06,
                    2.2457e-06,
                    2.3738e-06,
                    2.5035e-06,
                    2.6349e-06,
                    2.7679e-06,
                    2.9025e-06,
                    3.0387e-06,
                    3.1758e-06,
                    3.314e-06,
                    3.4527e-06,
                    3.5923e-06,
                    3.7331e-06,
                    3.8748e-06,
                    4.0176e-06,
                    4.1615e-06,
                    4.3064e-06,
                    4.453e-06,
                    4.6007e-06,
                    4.7497e-06,
                    4.8999e-06,
                    5.0514e-06,
                    5.2042e-06,
                    5.3584e-06,
                    5.5139e-06,
                    5.6708e-06,
                    5.829e-06,
                    5.984e-06,
                    6.2599e-06,
                    6.5169e-06,
                    6.7553e-06,
                    6.9756e-06,
                    7.1782e-06,
                    7.3907e-06,
                    7.6132e-06,
                    7.8459e-06,
                    8.0887e-06,
                    8.3418e-06,
                    8.6384e-06,
                    8.9808e-06,
                    9.3715e-06,
                    9.8131e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Land_3GHG": 0.21,
                "Land_3GHG_timeseries": [
                    2.795e-07,
                    5.5741e-07,
                    8.324e-07,
                    1.104e-06,
                    1.3722e-06,
                    1.6371e-06,
                    1.8988e-06,
                    2.1575e-06,
                    2.4134e-06,
                    2.6634e-06,
                    2.9122e-06,
                    3.1611e-06,
                    3.4106e-06,
                    3.6612e-06,
                    3.9132e-06,
                    4.1667e-06,
                    4.4219e-06,
                    4.679e-06,
                    4.938e-06,
                    5.2014e-06,
                    5.4696e-06,
                    5.7434e-06,
                    6.0237e-06,
                    6.311e-06,
                    6.6056e-06,
                    6.9074e-06,
                    7.2162e-06,
                    7.5314e-06,
                    7.8519e-06,
                    8.1828e-06,
                    8.517e-06,
                    8.8533e-06,
                    9.191e-06,
                    9.5299e-06,
                    9.8696e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012
                ],
                "Total_CO2": 0.05,
                "Total_CO2_timeseries": [
                    7.2298e-08,
                    1.4191e-07,
                    2.0754e-07,
                    2.688e-07,
                    3.257e-07,
                    3.7841e-07,
                    4.2723e-07,
                    4.7245e-07,
                    5.1436e-07,
                    5.5014e-07,
                    5.8199e-07,
                    6.1123e-07,
                    6.3848e-07,
                    6.6416e-07,
                    6.8857e-07,
                    7.1191e-07,
                    7.3436e-07,
                    7.56e-07,
                    7.7691e-07,
                    7.9948e-07,
                    8.2325e-07,
                    8.4773e-07,
                    8.7256e-07,
                    8.9756e-07,
                    9.2259e-07,
                    9.4753e-07,
                    9.7231e-07,
                    9.968e-07,
                    1.021e-06,
                    1.051e-06,
                    1.0829e-06,
                    1.1155e-06,
                    1.1484e-06,
                    1.1814e-06,
                    1.2142e-06,
                    1.2468e-06,
                    1.2791e-06,
                    1.3111e-06,
                    1.3425e-06,
                    1.376e-06,
                    1.4134e-06,
                    1.4534e-06,
                    1.4957e-06,
                    1.5384e-06,
                    1.5807e-06,
                    1.625e-06,
                    1.6741e-06,
                    1.7295e-06,
                    1.7932e-06,
                    1.8781e-06,
                    1.9885e-06,
                    2.1243e-06,
                    2.2891e-06,
                    2.486e-06,
                    2.7171e-06,
                    2.9867e-06,
                    3.2937e-06,
                    3.642e-06,
                    4.0403e-06,
                    4.4978e-06,
                    5.0111e-06,
                    5.5695e-06,
                    6.1739e-06,
                    6.8209e-06,
                    7.5184e-06,
                    8.2642e-06,
                    9.0564e-06,
                    9.8963e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.8252e-09,
                    3.3513e-09,
                    5.0581e-09,
                    6.4762e-09,
                    8.1469e-09,
                    9.8122e-09,
                    1.174e-08,
                    1.3715e-08,
                    1.5365e-08,
                    1.8665e-08,
                    3.8465e-08,
                    7.9715e-08,
                    1.1767e-07,
                    1.5727e-07,
                    2.0677e-07,
                    2.5297e-07,
                    2.9917e-07,
                    3.4537e-07,
                    3.9157e-07,
                    4.4602e-07,
                    5.1037e-07,
                    5.7802e-07,
                    6.5062e-07,
                    7.2652e-07,
                    8.1892e-07,
                    9.1792e-07,
                    1.012e-06,
                    1.1242e-06,
                    1.2809e-06,
                    1.4641e-06,
                    1.6588e-06,
                    1.9096e-06,
                    2.1686e-06,
                    2.4359e-06,
                    2.6455e-06,
                    2.86e-06,
                    3.0761e-06,
                    3.3088e-06,
                    3.5579e-06,
                    3.9275e-06,
                    4.1899e-06,
                    4.472e-06,
                    4.7558e-06,
                    5.038e-06,
                    5.3284e-06,
                    5.6094e-06,
                    5.9268e-06,
                    6.2888e-06,
                    6.6756e-06,
                    7.088e-06,
                    7.5517e-06,
                    7.998e-06,
                    8.4489e-06,
                    8.9328e-06,
                    9.4282e-06,
                    9.9335e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CO2": 0.13,
                "Land_CO2_timeseries": [
                    7.2298e-08,
                    1.4191e-07,
                    2.0754e-07,
                    2.688e-07,
                    3.257e-07,
                    3.7841e-07,
                    4.2723e-07,
                    4.7245e-07,
                    5.1436e-07,
                    5.5014e-07,
                    5.8199e-07,
                    6.1123e-07,
                    6.3848e-07,
                    6.6416e-07,
                    6.8857e-07,
                    7.1191e-07,
                    7.3436e-07,
                    7.56e-07,
                    7.7691e-07,
                    7.9948e-07,
                    8.2325e-07,
                    8.4773e-07,
                    8.7256e-07,
                    8.9756e-07,
                    9.2259e-07,
                    9.4753e-07,
                    9.7231e-07,
                    9.968e-07,
                    1.021e-06,
                    1.051e-06,
                    1.0829e-06,
                    1.1155e-06,
                    1.1484e-06,
                    1.1814e-06,
                    1.2142e-06,
                    1.2468e-06,
                    1.2791e-06,
                    1.3111e-06,
                    1.3425e-06,
                    1.376e-06,
                    1.4134e-06,
                    1.4534e-06,
                    1.4957e-06,
                    1.5384e-06,
                    1.5807e-06,
                    1.625e-06,
                    1.6741e-06,
                    1.7295e-06,
                    1.7932e-06,
                    1.8781e-06,
                    1.9885e-06,
                    2.1243e-06,
                    2.2891e-06,
                    2.486e-06,
                    2.7171e-06,
                    2.9867e-06,
                    3.2937e-06,
                    3.642e-06,
                    4.0403e-06,
                    4.4978e-06,
                    5.0111e-06,
                    5.5695e-06,
                    6.1739e-06,
                    6.8209e-06,
                    7.5184e-06,
                    8.2642e-06,
                    9.0564e-06,
                    9.8963e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Total_CH4": 0.19,
                "Total_CH4_timeseries": [
                    2.1302e-07,
                    4.2886e-07,
                    6.4754e-07,
                    8.691e-07,
                    1.0936e-06,
                    1.321e-06,
                    1.5513e-06,
                    1.7847e-06,
                    2.021e-06,
                    2.2604e-06,
                    2.5059e-06,
                    2.7574e-06,
                    3.0155e-06,
                    3.2798e-06,
                    3.5502e-06,
                    3.8267e-06,
                    4.1095e-06,
                    4.3985e-06,
                    4.6938e-06,
                    4.9954e-06,
                    5.3009e-06,
                    5.6105e-06,
                    5.924e-06,
                    6.2414e-06,
                    6.5629e-06,
                    6.8884e-06,
                    7.2179e-06,
                    7.5514e-06,
                    7.889e-06,
                    8.2306e-06,
                    8.5736e-06,
                    8.9179e-06,
                    9.2631e-06,
                    9.6098e-06,
                    9.9578e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008
                ],
                "Fossil_CH4": 0.09,
                "Fossil_CH4_timeseries": [
                    5.4334e-08,
                    1.1135e-07,
                    1.7109e-07,
                    2.3356e-07,
                    2.988e-07,
                    3.6685e-07,
                    4.3772e-07,
                    5.1145e-07,
                    5.8806e-07,
                    6.676e-07,
                    7.5055e-07,
                    8.3696e-07,
                    9.2745e-07,
                    1.0215e-06,
                    1.119e-06,
                    1.2201e-06,
                    1.3249e-06,
                    1.4333e-06,
                    1.5453e-06,
                    1.6611e-06,
                    1.7781e-06,
                    1.8965e-06,
                    2.0162e-06,
                    2.1372e-06,
                    2.2596e-06,
                    2.3832e-06,
                    2.5083e-06,
                    2.6346e-06,
                    2.7624e-06,
                    2.8915e-06,
                    3.0216e-06,
                    3.1526e-06,
                    3.2841e-06,
                    3.4165e-06,
                    3.5499e-06,
                    3.6843e-06,
                    3.8197e-06,
                    3.9562e-06,
                    4.0936e-06,
                    4.2321e-06,
                    4.3717e-06,
                    4.5123e-06,
                    4.654e-06,
                    4.7967e-06,
                    4.9405e-06,
                    5.0855e-06,
                    5.2315e-06,
                    5.3787e-06,
                    5.5269e-06,
                    5.6716e-06,
                    5.9371e-06,
                    6.1831e-06,
                    6.4103e-06,
                    6.6189e-06,
                    6.8094e-06,
                    7.0094e-06,
                    7.219e-06,
                    7.4384e-06,
                    7.6676e-06,
                    7.9068e-06,
                    8.1893e-06,
                    8.5173e-06,
                    8.8935e-06,
                    9.3203e-06,
                    9.6503e-06,
                    9.9989e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_CH4": 0.36,
                "Land_CH4_timeseries": [
                    1.5869e-07,
                    3.175e-07,
                    4.7645e-07,
                    6.3554e-07,
                    7.9476e-07,
                    9.5411e-07,
                    1.1136e-06,
                    1.2732e-06,
                    1.433e-06,
                    1.5928e-06,
                    1.7553e-06,
                    1.9204e-06,
                    2.0881e-06,
                    2.2583e-06,
                    2.4312e-06,
                    2.6066e-06,
                    2.7846e-06,
                    2.9653e-06,
                    3.1485e-06,
                    3.3343e-06,
                    3.5228e-06,
                    3.7139e-06,
                    3.9078e-06,
                    4.1042e-06,
                    4.3034e-06,
                    4.5052e-06,
                    4.7097e-06,
                    4.9168e-06,
                    5.1266e-06,
                    5.3391e-06,
                    5.552e-06,
                    5.7653e-06,
                    5.9791e-06,
                    6.1933e-06,
                    6.4079e-06,
                    6.623e-06,
                    6.8385e-06,
                    7.0544e-06,
                    7.2708e-06,
                    7.4876e-06,
                    7.7048e-06,
                    7.9225e-06,
                    8.1407e-06,
                    8.3592e-06,
                    8.5783e-06,
                    8.7977e-06,
                    9.0176e-06,
                    9.238e-06,
                    9.4587e-06,
                    9.68e-06,
                    9.912e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006
                ],
                "Total_N2O": 0.2,
                "Total_N2O_timeseries": [
                    5.2541e-08,
                    1.0613e-07,
                    1.6071e-07,
                    2.1623e-07,
                    2.7262e-07,
                    3.2976e-07,
                    3.8756e-07,
                    4.4587e-07,
                    5.0456e-07,
                    5.6346e-07,
                    6.2247e-07,
                    6.8155e-07,
                    7.4069e-07,
                    7.9988e-07,
                    8.5912e-07,
                    9.1839e-07,
                    9.7771e-07,
                    1.0371e-06,
                    1.0966e-06,
                    1.1562e-06,
                    1.2167e-06,
                    1.2798e-06,
                    1.3465e-06,
                    1.4177e-06,
                    1.4938e-06,
                    1.575e-06,
                    1.6609e-06,
                    1.7511e-06,
                    1.8445e-06,
                    1.9399e-06,
                    2.0364e-06,
                    2.1339e-06,
                    2.2321e-06,
                    2.3311e-06,
                    2.4307e-06,
                    2.5308e-06,
                    2.6316e-06,
                    2.7329e-06,
                    2.835e-06,
                    2.9425e-06,
                    3.0512e-06,
                    3.1611e-06,
                    3.2721e-06,
                    3.3845e-06,
                    3.4982e-06,
                    3.6133e-06,
                    3.7298e-06,
                    3.8478e-06,
                    3.9673e-06,
                    4.0885e-06,
                    4.2111e-06,
                    4.3354e-06,
                    4.4612e-06,
                    4.5887e-06,
                    4.718e-06,
                    4.8491e-06,
                    4.9822e-06,
                    5.1175e-06,
                    5.2552e-06,
                    5.3956e-06,
                    5.5397e-06,
                    5.6894e-06,
                    5.846e-06,
                    6.0107e-06,
                    6.1843e-06,
                    6.3674e-06,
                    6.56e-06,
                    6.7622e-06,
                    6.9736e-06,
                    7.1933e-06,
                    7.4215e-06,
                    7.6594e-06,
                    7.9075e-06,
                    8.166e-06,
                    8.4345e-06,
                    8.7123e-06,
                    8.9983e-06,
                    9.2908e-06,
                    9.5877e-06,
                    9.8866e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_N2O": 0.05,
                "Fossil_N2O_timeseries": [
                    4.0274e-09,
                    8.1289e-09,
                    1.2302e-08,
                    1.6542e-08,
                    2.0844e-08,
                    2.5201e-08,
                    2.9608e-08,
                    3.4054e-08,
                    3.853e-08,
                    4.3026e-08,
                    4.7534e-08,
                    5.2054e-08,
                    5.6583e-08,
                    6.1122e-08,
                    6.5669e-08,
                    7.0224e-08,
                    7.4789e-08,
                    7.9363e-08,
                    8.3949e-08,
                    8.8549e-08,
                    9.3219e-08,
                    9.8058e-08,
                    1.0314e-07,
                    1.0852e-07,
                    1.1423e-07,
                    1.2028e-07,
                    1.2664e-07,
                    1.3328e-07,
                    1.4015e-07,
                    1.4715e-07,
                    1.5423e-07,
                    1.6138e-07,
                    1.6858e-07,
                    1.7584e-07,
                    1.8314e-07,
                    1.9049e-07,
                    1.9788e-07,
                    2.0531e-07,
                    2.128e-07,
                    2.2082e-07,
                    2.29e-07,
                    2.3737e-07,
                    2.4594e-07,
                    2.5471e-07,
                    2.6371e-07,
                    2.7293e-07,
                    2.824e-07,
                    2.9211e-07,
                    3.0209e-07,
                    3.1233e-07,
                    3.2288e-07,
                    3.3378e-07,
                    3.4506e-07,
                    3.5674e-07,
                    3.6884e-07,
                    3.8135e-07,
                    3.9426e-07,
                    4.0753e-07,
                    4.2114e-07,
                    4.3503e-07,
                    4.4916e-07,
                    4.6351e-07,
                    4.7807e-07,
                    4.9282e-07,
                    5.0777e-07,
                    5.229e-07,
                    5.3822e-07,
                    5.5373e-07,
                    5.6943e-07,
                    5.8534e-07,
                    6.0147e-07,
                    6.178e-07,
                    6.3434e-07,
                    6.5108e-07,
                    6.6803e-07,
                    6.8521e-07,
                    7.0262e-07,
                    7.2027e-07,
                    7.382e-07,
                    7.5642e-07,
                    7.7498e-07,
                    7.9398e-07,
                    8.135e-07,
                    8.3359e-07,
                    8.5431e-07,
                    8.757e-07,
                    8.9781e-07,
                    9.2065e-07,
                    9.4424e-07,
                    9.6858e-07,
                    9.9379e-07,
                    1.0201e-06,
                    1.0477e-06,
                    1.0767e-06,
                    1.1072e-06,
                    1.1393e-06,
                    1.1729e-06,
                    1.2082e-06,
                    1.245e-06,
                    1.2833e-06,
                    1.323e-06,
                    1.3644e-06,
                    1.4076e-06,
                    1.4527e-06,
                    1.4996e-06,
                    1.5485e-06,
                    1.5991e-06,
                    1.6515e-06,
                    1.7054e-06,
                    1.7606e-06,
                    1.817e-06,
                    1.8745e-06,
                    1.9332e-06,
                    1.9929e-06,
                    2.0539e-06,
                    2.1161e-06,
                    2.1796e-06,
                    2.2447e-06,
                    2.3116e-06,
                    2.3875e-06,
                    2.4641e-06,
                    2.5408e-06,
                    2.6184e-06,
                    2.697e-06,
                    2.7798e-06,
                    2.8651e-06,
                    2.949e-06,
                    3.0381e-06,
                    3.1296e-06,
                    3.2212e-06,
                    3.3136e-06,
                    3.4282e-06,
                    3.5441e-06,
                    3.6519e-06,
                    3.7661e-06,
                    3.8967e-06,
                    4.025e-06,
                    4.1556e-06,
                    4.2966e-06,
                    4.4423e-06,
                    4.592e-06,
                    4.7429e-06,
                    4.896e-06,
                    5.0559e-06,
                    5.2213e-06,
                    5.3876e-06,
                    5.5574e-06,
                    5.7309e-06,
                    5.8956e-06,
                    6.064e-06,
                    6.2414e-06,
                    6.4173e-06,
                    6.5999e-06,
                    6.7933e-06,
                    7.0001e-06,
                    7.215e-06,
                    7.4437e-06,
                    7.6873e-06,
                    7.938e-06,
                    8.1967e-06,
                    8.4647e-06,
                    8.7437e-06,
                    9.0318e-06,
                    9.3235e-06,
                    9.6273e-06,
                    9.9344e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.26,
                "Land_N2O_timeseries": [
                    4.8514e-08,
                    9.7998e-08,
                    1.4841e-07,
                    1.9969e-07,
                    2.5177e-07,
                    3.0456e-07,
                    3.5795e-07,
                    4.1182e-07,
                    4.6603e-07,
                    5.2044e-07,
                    5.7493e-07,
                    6.295e-07,
                    6.8411e-07,
                    7.3876e-07,
                    7.9345e-07,
                    8.4817e-07,
                    9.0292e-07,
                    9.5774e-07,
                    1.0126e-06,
                    1.0676e-06,
                    1.1235e-06,
                    1.1818e-06,
                    1.2434e-06,
                    1.3092e-06,
                    1.3796e-06,
                    1.4547e-06,
                    1.5343e-06,
                    1.6178e-06,
                    1.7043e-06,
                    1.7927e-06,
                    1.8822e-06,
                    1.9725e-06,
                    2.0635e-06,
                    2.1553e-06,
                    2.2475e-06,
                    2.3403e-06,
                    2.4337e-06,
                    2.5276e-06,
                    2.6222e-06,
                    2.7217e-06,
                    2.8222e-06,
                    2.9237e-06,
                    3.0262e-06,
                    3.1298e-06,
                    3.2345e-06,
                    3.3403e-06,
                    3.4474e-06,
                    3.5557e-06,
                    3.6653e-06,
                    3.7761e-06,
                    3.8883e-06,
                    4.0016e-06,
                    4.1162e-06,
                    4.232e-06,
                    4.3491e-06,
                    4.4677e-06,
                    4.5879e-06,
                    4.71e-06,
                    4.8341e-06,
                    4.9606e-06,
                    5.0906e-06,
                    5.2259e-06,
                    5.3679e-06,
                    5.5179e-06,
                    5.6766e-06,
                    5.8445e-06,
                    6.0218e-06,
                    6.2085e-06,
                    6.4041e-06,
                    6.6079e-06,
                    6.8201e-06,
                    7.0416e-06,
                    7.2732e-06,
                    7.5149e-06,
                    7.7665e-06,
                    8.0271e-06,
                    8.2957e-06,
                    8.5705e-06,
                    8.8495e-06,
                    9.1302e-06,
                    9.41e-06,
                    9.6869e-06,
                    9.9595e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            2.40508,
                            11.89978
                        ],
                        [
                            2.06543,
                            12.35424
                        ],
                        [
                            2.08207,
                            12.39303
                        ],
                        [
                            2.17916,
                            12.42413
                        ],
                        [
                            2.25442,
                            12.41605
                        ],
                        [
                            2.26942,
                            12.47148
                        ],
                        [
                            2.2286,
                            12.52234
                        ],
                        [
                            2.225,
                            12.58389
                        ],
                        [
                            2.15266,
                            12.64906
                        ],
                        [
                            2.15938,
                            12.68786
                        ],
                        [
                            2.08153,
                            12.72174
                        ],
                        [
                            1.97882,
                            12.73653
                        ],
                        [
                            1.92468,
                            12.69179
                        ],
                        [
                            1.86456,
                            12.6059
                        ],
                        [
                            1.57697,
                            12.63329
                        ],
                        [
                            1.39001,
                            12.7779
                        ],
                        [
                            1.1193,
                            12.99868
                        ],
                        [
                            0.99789,
                            13.0008
                        ],
                        [
                            0.99259,
                            13.37046
                        ],
                        [
                            1.05413,
                            13.36799
                        ],
                        [
                            1.16964,
                            13.32278
                        ],
                        [
                            1.28154,
                            13.35649
                        ],
                        [
                            1.13698,
                            13.41447
                        ],
                        [
                            1.0884,
                            13.4599
                        ],
                        [
                            1.01529,
                            13.48758
                        ],
                        [
                            0.99098,
                            13.57487
                        ],
                        [
                            0.90627,
                            13.6184
                        ],
                        [
                            0.8266,
                            13.61933
                        ],
                        [
                            0.77419,
                            13.69096
                        ],
                        [
                            0.63736,
                            13.69347
                        ],
                        [
                            0.62487,
                            13.76408
                        ],
                        [
                            0.53058,
                            13.84108
                        ],
                        [
                            0.4744,
                            13.91532
                        ],
                        [
                            0.48244,
                            13.94907
                        ],
                        [
                            0.4,
                            14.02618
                        ],
                        [
                            0.35731,
                            14.14564
                        ],
                        [
                            0.40295,
                            14.24905
                        ],
                        [
                            0.32401,
                            14.36053
                        ],
                        [
                            0.19312,
                            14.45972
                        ],
                        [
                            0.16674,
                            14.53527
                        ],
                        [
                            0.2356,
                            14.74685
                        ],
                        [
                            0.20211,
                            14.84055
                        ],
                        [
                            0.23524,
                            14.88704
                        ],
                        [
                            0.22935,
                            14.98967
                        ],
                        [
                            0.06126,
                            14.97795
                        ],
                        [
                            -0.00836,
                            14.98526
                        ],
                        [
                            -0.25257,
                            15.07657
                        ],
                        [
                            -0.37565,
                            15.01198
                        ],
                        [
                            -0.45695,
                            15.08101
                        ],
                        [
                            -0.7035,
                            15.08137
                        ],
                        [
                            -0.82349,
                            15.0133
                        ],
                        [
                            -0.88508,
                            14.95207
                        ],
                        [
                            -1.08734,
                            14.79078
                        ],
                        [
                            -1.31542,
                            14.7331
                        ],
                        [
                            -1.6755,
                            14.50687
                        ],
                        [
                            -1.75793,
                            14.48254
                        ],
                        [
                            -1.97421,
                            14.48054
                        ],
                        [
                            -1.99344,
                            14.19946
                        ],
                        [
                            -2.10627,
                            14.15101
                        ],
                        [
                            -2.29202,
                            14.25202
                        ],
                        [
                            -2.47783,
                            14.29654
                        ],
                        [
                            -2.67214,
                            14.13463
                        ],
                        [
                            -2.83699,
                            14.05949
                        ],
                        [
                            -2.83345,
                            13.99529
                        ],
                        [
                            -2.89609,
                            13.82274
                        ],
                        [
                            -2.90271,
                            13.72472
                        ],
                        [
                            -2.87365,
                            13.6551
                        ],
                        [
                            -2.95302,
                            13.62727
                        ],
                        [
                            -2.99483,
                            13.66315
                        ],
                        [
                            -3.03892,
                            13.62919
                        ],
                        [
                            -3.10515,
                            13.69446
                        ],
                        [
                            -3.18491,
                            13.68558
                        ],
                        [
                            -3.26272,
                            13.71835
                        ],
                        [
                            -3.26052,
                            13.57715
                        ],
                        [
                            -3.28163,
                            13.53393
                        ],
                        [
                            -3.25427,
                            13.28487
                        ],
                        [
                            -3.403,
                            13.27156
                        ],
                        [
                            -3.43442,
                            13.25198
                        ],
                        [
                            -3.43372,
                            13.16309
                        ],
                        [
                            -3.53138,
                            13.17194
                        ],
                        [
                            -3.60167,
                            13.20343
                        ],
                        [
                            -3.7236,
                            13.28426
                        ],
                        [
                            -3.77784,
                            13.34597
                        ],
                        [
                            -3.96753,
                            13.38729
                        ],
                        [
                            -3.92063,
                            13.43164
                        ],
                        [
                            -3.95694,
                            13.49458
                        ],
                        [
                            -4.00684,
                            13.4335
                        ],
                        [
                            -4.10405,
                            13.38281
                        ],
                        [
                            -4.15442,
                            13.29189
                        ],
                        [
                            -4.25822,
                            13.22932
                        ],
                        [
                            -4.24296,
                            13.19449
                        ],
                        [
                            -4.34577,
                            13.14592
                        ],
                        [
                            -4.23045,
                            12.93604
                        ],
                        [
                            -4.22898,
                            12.77508
                        ],
                        [
                            -4.29521,
                            12.69934
                        ],
                        [
                            -4.37121,
                            12.73129
                        ],
                        [
                            -4.48835,
                            12.71198
                        ],
                        [
                            -4.47693,
                            12.63369
                        ],
                        [
                            -4.4199,
                            12.59012
                        ],
                        [
                            -4.39418,
                            12.53347
                        ],
                        [
                            -4.42905,
                            12.48386
                        ],
                        [
                            -4.46835,
                            12.3261
                        ],
                        [
                            -4.51464,
                            12.2544
                        ],
                        [
                            -4.58426,
                            12.19834
                        ],
                        [
                            -4.60937,
                            12.1237
                        ],
                        [
                            -4.65792,
                            12.05469
                        ],
                        [
                            -4.70721,
                            12.04978
                        ],
                        [
                            -4.73368,
                            11.99827
                        ],
                        [
                            -4.84023,
                            12.0162
                        ],
                        [
                            -5.09345,
                            11.97063
                        ],
                        [
                            -5.15465,
                            11.94767
                        ],
                        [
                            -5.24829,
                            11.86508
                        ],
                        [
                            -5.32834,
                            11.84418
                        ],
                        [
                            -5.26552,
                            11.74381
                        ],
                        [
                            -5.29842,
                            11.62863
                        ],
                        [
                            -5.24209,
                            11.60465
                        ],
                        [
                            -5.2046,
                            11.53211
                        ],
                        [
                            -5.20001,
                            11.43074
                        ],
                        [
                            -5.25656,
                            11.37041
                        ],
                        [
                            -5.27105,
                            11.2378
                        ],
                        [
                            -5.32788,
                            11.19699
                        ],
                        [
                            -5.34229,
                            11.136
                        ],
                        [
                            -5.39453,
                            11.098
                        ],
                        [
                            -5.496,
                            11.06316
                        ],
                        [
                            -5.48903,
                            10.97359
                        ],
                        [
                            -5.42262,
                            10.85044
                        ],
                        [
                            -5.47334,
                            10.75733
                        ],
                        [
                            -5.48,
                            10.63071
                        ],
                        [
                            -5.46613,
                            10.5927
                        ],
                        [
                            -5.51892,
                            10.43327
                        ],
                        [
                            -5.46872,
                            10.34836
                        ],
                        [
                            -5.36897,
                            10.287
                        ],
                        [
                            -5.20911,
                            10.31964
                        ],
                        [
                            -5.1313,
                            10.30459
                        ],
                        [
                            -5.11875,
                            10.252
                        ],
                        [
                            -5.01463,
                            10.06532
                        ],
                        [
                            -4.97275,
                            10.0408
                        ],
                        [
                            -4.98576,
                            9.98465
                        ],
                        [
                            -4.96597,
                            9.89218
                        ],
                        [
                            -4.83424,
                            9.86414
                        ],
                        [
                            -4.78929,
                            9.82943
                        ],
                        [
                            -4.78374,
                            9.74284
                        ],
                        [
                            -4.7422,
                            9.74921
                        ],
                        [
                            -4.69177,
                            9.67826
                        ],
                        [
                            -4.61607,
                            9.72106
                        ],
                        [
                            -4.50384,
                            9.64785
                        ],
                        [
                            -4.43354,
                            9.66136
                        ],
                        [
                            -4.40438,
                            9.60777
                        ],
                        [
                            -4.29104,
                            9.63932
                        ],
                        [
                            -4.26698,
                            9.732
                        ],
                        [
                            -4.18364,
                            9.77397
                        ],
                        [
                            -4.13212,
                            9.83032
                        ],
                        [
                            -4.04747,
                            9.80132
                        ],
                        [
                            -3.9719,
                            9.86868
                        ],
                        [
                            -3.89971,
                            9.89927
                        ],
                        [
                            -3.81171,
                            9.88877
                        ],
                        [
                            -3.75428,
                            9.93045
                        ],
                        [
                            -3.64271,
                            9.95598
                        ],
                        [
                            -3.59788,
                            9.92057
                        ],
                        [
                            -3.39473,
                            9.91525
                        ],
                        [
                            -3.28014,
                            9.85374
                        ],
                        [
                            -3.21179,
                            9.9218
                        ],
                        [
                            -3.18251,
                            9.84334
                        ],
                        [
                            -3.12356,
                            9.84179
                        ],
                        [
                            -3.06266,
                            9.72185
                        ],
                        [
                            -3.01762,
                            9.74191
                        ],
                        [
                            -2.90204,
                            9.53236
                        ],
                        [
                            -2.79746,
                            9.41826
                        ],
                        [
                            -2.75285,
                            9.41057
                        ],
                        [
                            -2.68692,
                            9.49074
                        ],
                        [
                            -2.76806,
                            9.56948
                        ],
                        [
                            -2.74679,
                            9.64156
                        ],
                        [
                            -2.78811,
                            9.74721
                        ],
                        [
                            -2.73084,
                            9.83889
                        ],
                        [
                            -2.76127,
                            9.88541
                        ],
                        [
                            -2.74522,
                            9.9484
                        ],
                        [
                            -2.79009,
                            10.07177
                        ],
                        [
                            -2.79677,
                            10.19367
                        ],
                        [
                            -2.76676,
                            10.26578
                        ],
                        [
                            -2.83309,
                            10.29644
                        ],
                        [
                            -2.84122,
                            10.36554
                        ],
                        [
                            -2.77996,
                            10.42612
                        ],
                        [
                            -2.86461,
                            10.45463
                        ],
                        [
                            -2.94053,
                            10.61597
                        ],
                        [
                            -2.91261,
                            10.66826
                        ],
                        [
                            -2.93752,
                            10.72103
                        ],
                        [
                            -2.89568,
                            10.76446
                        ],
                        [
                            -2.8582,
                            10.89117
                        ],
                        [
                            -2.81775,
                            10.92452
                        ],
                        [
                            -2.8336,
                            10.99856
                        ],
                        [
                            -2.69806,
                            10.9872
                        ],
                        [
                            -2.58752,
                            10.99935
                        ],
                        [
                            -1.58819,
                            11.0007
                        ],
                        [
                            -1.58399,
                            11.0201
                        ],
                        [
                            -1.43625,
                            11.03006
                        ],
                        [
                            -1.38981,
                            10.98771
                        ],
                        [
                            -1.11892,
                            10.98555
                        ],
                        [
                            -1.11339,
                            11.00381
                        ],
                        [
                            -0.68609,
                            10.99817
                        ],
                        [
                            -0.65523,
                            10.98742
                        ],
                        [
                            -0.61477,
                            10.90457
                        ],
                        [
                            -0.56876,
                            10.99376
                        ],
                        [
                            -0.50394,
                            10.99012
                        ],
                        [
                            -0.41668,
                            11.03113
                        ],
                        [
                            -0.421,
                            11.09968
                        ],
                        [
                            -0.27843,
                            11.12267
                        ],
                        [
                            -0.28279,
                            11.16443
                        ],
                        [
                            -0.14201,
                            11.13898
                        ],
                        [
                            0.50093,
                            11.00901
                        ],
                        [
                            0.49724,
                            10.93257
                        ],
                        [
                            0.65727,
                            10.99723
                        ],
                        [
                            0.91216,
                            10.99649
                        ],
                        [
                            1.01225,
                            11.08374
                        ],
                        [
                            1.04355,
                            11.04953
                        ],
                        [
                            1.10093,
                            11.05549
                        ],
                        [
                            1.0852,
                            11.11488
                        ],
                        [
                            1.15579,
                            11.22379
                        ],
                        [
                            1.22605,
                            11.25956
                        ],
                        [
                            1.26059,
                            11.32086
                        ],
                        [
                            1.3888,
                            11.40066
                        ],
                        [
                            1.38485,
                            11.44174
                        ],
                        [
                            1.44174,
                            11.4726
                        ],
                        [
                            1.57923,
                            11.44167
                        ],
                        [
                            1.59223,
                            11.39957
                        ],
                        [
                            1.66325,
                            11.39679
                        ],
                        [
                            1.7159,
                            11.42903
                        ],
                        [
                            1.77296,
                            11.41992
                        ],
                        [
                            1.87229,
                            11.44532
                        ],
                        [
                            1.95582,
                            11.42087
                        ],
                        [
                            2.01831,
                            11.42741
                        ],
                        [
                            2.18487,
                            11.59642
                        ],
                        [
                            2.30689,
                            11.67609
                        ],
                        [
                            2.2996,
                            11.7185
                        ],
                        [
                            2.3717,
                            11.79398
                        ],
                        [
                            2.40508,
                            11.89978
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "BDI",
                "Country": "Burundi",
                "Total_3GHG": 0.03,
                "Total_3GHG_timeseries": [
                    6.8604e-07,
                    1.3753e-06,
                    2.0526e-06,
                    2.7344e-06,
                    3.4105e-06,
                    4.0946e-06,
                    4.7794e-06,
                    5.4595e-06,
                    6.1478e-06,
                    6.8476e-06,
                    7.5393e-06,
                    8.2309e-06,
                    8.9262e-06,
                    9.6241e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Fossil_3GHG": 0.01,
                "Fossil_3GHG_timeseries": [
                    3.2371e-08,
                    6.5915e-08,
                    1.0064e-07,
                    1.3655e-07,
                    1.7365e-07,
                    2.1194e-07,
                    2.5143e-07,
                    2.9212e-07,
                    3.3401e-07,
                    3.771e-07,
                    4.2171e-07,
                    4.6786e-07,
                    5.1718e-07,
                    5.6805e-07,
                    6.2046e-07,
                    6.7443e-07,
                    7.2995e-07,
                    7.8703e-07,
                    8.4569e-07,
                    9.0591e-07,
                    9.6675e-07,
                    1.0282e-06,
                    1.0904e-06,
                    1.1534e-06,
                    1.217e-06,
                    1.2814e-06,
                    1.3465e-06,
                    1.4124e-06,
                    1.4789e-06,
                    1.546e-06,
                    1.6134e-06,
                    1.6811e-06,
                    1.7476e-06,
                    1.8144e-06,
                    1.8814e-06,
                    1.9488e-06,
                    2.0164e-06,
                    2.0843e-06,
                    2.1525e-06,
                    2.2212e-06,
                    2.2903e-06,
                    2.3598e-06,
                    2.4297e-06,
                    2.4999e-06,
                    2.5706e-06,
                    2.6416e-06,
                    2.7131e-06,
                    2.785e-06,
                    2.8574e-06,
                    2.9303e-06,
                    3.0047e-06,
                    3.0807e-06,
                    3.1585e-06,
                    3.2381e-06,
                    3.3194e-06,
                    3.4027e-06,
                    3.4879e-06,
                    3.5751e-06,
                    3.6643e-06,
                    3.7555e-06,
                    3.8541e-06,
                    3.9602e-06,
                    4.0738e-06,
                    4.195e-06,
                    4.3239e-06,
                    4.4604e-06,
                    4.6047e-06,
                    4.7569e-06,
                    4.917e-06,
                    5.0852e-06,
                    5.2659e-06,
                    5.4595e-06,
                    5.6679e-06,
                    5.8916e-06,
                    6.1309e-06,
                    6.3862e-06,
                    6.658e-06,
                    6.9465e-06,
                    7.2524e-06,
                    7.5759e-06,
                    7.9142e-06,
                    8.2677e-06,
                    8.6371e-06,
                    9.0229e-06,
                    9.4255e-06,
                    9.8455e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_3GHG": 0.07,
                "Land_3GHG_timeseries": [
                    6.5367e-07,
                    1.3094e-06,
                    1.952e-06,
                    2.5979e-06,
                    3.2369e-06,
                    3.8827e-06,
                    4.528e-06,
                    5.1674e-06,
                    5.8138e-06,
                    6.4705e-06,
                    7.1176e-06,
                    7.7631e-06,
                    8.409e-06,
                    9.056e-06,
                    9.7055e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Total_CO2": 0.03,
                "Total_CO2_timeseries": [
                    6.0668e-07,
                    1.2152e-06,
                    1.8103e-06,
                    2.4085e-06,
                    2.9996e-06,
                    3.5974e-06,
                    4.1944e-06,
                    4.7854e-06,
                    5.3833e-06,
                    5.9916e-06,
                    6.5894e-06,
                    7.1852e-06,
                    7.7807e-06,
                    8.3767e-06,
                    8.9746e-06,
                    9.5806e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    3.9602e-09,
                    7.9204e-09,
                    1.5275e-08,
                    2.2063e-08,
                    2.4892e-08,
                    2.8286e-08,
                    3.2246e-08,
                    3.6772e-08,
                    4.1298e-08,
                    5.8835e-08,
                    7.5241e-08,
                    9.6738e-08,
                    1.1654e-07,
                    1.3799e-07,
                    1.5944e-07,
                    1.7594e-07,
                    1.9739e-07,
                    2.1884e-07,
                    2.4359e-07,
                    2.7659e-07,
                    3.0464e-07,
                    3.3764e-07,
                    3.7064e-07,
                    4.0364e-07,
                    4.4489e-07,
                    4.7954e-07,
                    5.1914e-07,
                    5.6369e-07,
                    6.0989e-07,
                    6.5939e-07,
                    7.2539e-07,
                    7.9634e-07,
                    8.6729e-07,
                    9.5969e-07,
                    1.0587e-06,
                    1.1626e-06,
                    1.2682e-06,
                    1.3804e-06,
                    1.4827e-06,
                    1.6032e-06,
                    1.6972e-06,
                    1.8045e-06,
                    1.9018e-06,
                    2.0041e-06,
                    2.1097e-06,
                    2.217e-06,
                    2.3259e-06,
                    2.4381e-06,
                    2.5503e-06,
                    2.6641e-06,
                    2.7862e-06,
                    2.8786e-06,
                    2.9743e-06,
                    3.0469e-06,
                    3.136e-06,
                    3.2053e-06,
                    3.2878e-06,
                    3.3786e-06,
                    3.4726e-06,
                    3.5485e-06,
                    3.6822e-06,
                    3.8356e-06,
                    3.9942e-06,
                    4.1559e-06,
                    4.3126e-06,
                    4.4727e-06,
                    4.6657e-06,
                    4.8967e-06,
                    5.1872e-06,
                    5.4974e-06,
                    5.8287e-06,
                    6.189e-06,
                    6.5486e-06
                ],
                "Land_CO2": 0.09,
                "Land_CO2_timeseries": [
                    6.0668e-07,
                    1.2152e-06,
                    1.8103e-06,
                    2.4085e-06,
                    2.9996e-06,
                    3.5974e-06,
                    4.1944e-06,
                    4.7854e-06,
                    5.3833e-06,
                    5.9916e-06,
                    6.5894e-06,
                    7.1852e-06,
                    7.7807e-06,
                    8.3767e-06,
                    8.9746e-06,
                    9.5806e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Total_CH4": 0.04,
                "Total_CH4_timeseries": [
                    6.3078e-08,
                    1.2729e-07,
                    1.9263e-07,
                    2.5912e-07,
                    3.2677e-07,
                    3.9557e-07,
                    4.6555e-07,
                    5.3669e-07,
                    6.0902e-07,
                    6.8253e-07,
                    7.5811e-07,
                    8.3578e-07,
                    9.1719e-07,
                    1.0007e-06,
                    1.0863e-06,
                    1.174e-06,
                    1.2638e-06,
                    1.3558e-06,
                    1.4498e-06,
                    1.546e-06,
                    1.6433e-06,
                    1.7418e-06,
                    1.8414e-06,
                    1.9422e-06,
                    2.0441e-06,
                    2.1472e-06,
                    2.2513e-06,
                    2.3567e-06,
                    2.4631e-06,
                    2.5707e-06,
                    2.6786e-06,
                    2.7868e-06,
                    2.8938e-06,
                    3.0012e-06,
                    3.1088e-06,
                    3.2168e-06,
                    3.3251e-06,
                    3.4337e-06,
                    3.5427e-06,
                    3.652e-06,
                    3.7616e-06,
                    3.8716e-06,
                    3.9819e-06,
                    4.0926e-06,
                    4.2036e-06,
                    4.315e-06,
                    4.4267e-06,
                    4.5388e-06,
                    4.6513e-06,
                    4.7642e-06,
                    4.8773e-06,
                    4.9905e-06,
                    5.1041e-06,
                    5.2181e-06,
                    5.3324e-06,
                    5.4471e-06,
                    5.5624e-06,
                    5.6782e-06,
                    5.7946e-06,
                    5.9117e-06,
                    6.0441e-06,
                    6.192e-06,
                    6.3555e-06,
                    6.5345e-06,
                    6.7291e-06,
                    6.9395e-06,
                    7.1656e-06,
                    7.4076e-06,
                    7.6656e-06,
                    7.9395e-06,
                    8.2373e-06,
                    8.5592e-06,
                    8.9072e-06,
                    9.2818e-06,
                    9.6832e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_CH4": 0.05,
                "Fossil_CH4_timeseries": [
                    2.6723e-08,
                    5.4545e-08,
                    8.3476e-08,
                    1.1352e-07,
                    1.4469e-07,
                    1.7699e-07,
                    2.1042e-07,
                    2.45e-07,
                    2.8072e-07,
                    3.176e-07,
                    3.5596e-07,
                    3.9581e-07,
                    4.3881e-07,
                    4.8331e-07,
                    5.2931e-07,
                    5.7683e-07,
                    6.2586e-07,
                    6.7641e-07,
                    7.2849e-07,
                    7.821e-07,
                    8.3625e-07,
                    8.9094e-07,
                    9.4617e-07,
                    1.0019e-06,
                    1.0582e-06,
                    1.115e-06,
                    1.1723e-06,
                    1.2302e-06,
                    1.2886e-06,
                    1.3475e-06,
                    1.4066e-06,
                    1.466e-06,
                    1.524e-06,
                    1.5823e-06,
                    1.6408e-06,
                    1.6995e-06,
                    1.7584e-06,
                    1.8176e-06,
                    1.877e-06,
                    1.9366e-06,
                    1.9964e-06,
                    2.0565e-06,
                    2.1169e-06,
                    2.1775e-06,
                    2.2383e-06,
                    2.2994e-06,
                    2.3608e-06,
                    2.4224e-06,
                    2.4843e-06,
                    2.5465e-06,
                    2.6101e-06,
                    2.675e-06,
                    2.7415e-06,
                    2.8095e-06,
                    2.8791e-06,
                    2.9503e-06,
                    3.0231e-06,
                    3.0978e-06,
                    3.1742e-06,
                    3.2525e-06,
                    3.338e-06,
                    3.4308e-06,
                    3.531e-06,
                    3.6387e-06,
                    3.7539e-06,
                    3.8766e-06,
                    4.007e-06,
                    4.1451e-06,
                    4.291e-06,
                    4.4448e-06,
                    4.611e-06,
                    4.7899e-06,
                    4.9836e-06,
                    5.1923e-06,
                    5.4165e-06,
                    5.6566e-06,
                    5.9129e-06,
                    6.1859e-06,
                    6.476e-06,
                    6.7836e-06,
                    7.1058e-06,
                    7.4429e-06,
                    7.7956e-06,
                    8.1642e-06,
                    8.5494e-06,
                    8.9516e-06,
                    9.3713e-06,
                    9.8091e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CH4": 0.03,
                "Land_CH4_timeseries": [
                    3.6355e-08,
                    7.2741e-08,
                    1.0916e-07,
                    1.456e-07,
                    1.8208e-07,
                    2.1859e-07,
                    2.5513e-07,
                    2.917e-07,
                    3.2829e-07,
                    3.6492e-07,
                    4.0215e-07,
                    4.3997e-07,
                    4.7838e-07,
                    5.1738e-07,
                    5.5699e-07,
                    5.9718e-07,
                    6.3797e-07,
                    6.7935e-07,
                    7.2133e-07,
                    7.639e-07,
                    8.0708e-07,
                    8.5087e-07,
                    8.9527e-07,
                    9.4029e-07,
                    9.8591e-07,
                    1.0321e-06,
                    1.079e-06,
                    1.1264e-06,
                    1.1745e-06,
                    1.2232e-06,
                    1.272e-06,
                    1.3208e-06,
                    1.3698e-06,
                    1.4189e-06,
                    1.4681e-06,
                    1.5173e-06,
                    1.5667e-06,
                    1.6162e-06,
                    1.6658e-06,
                    1.7154e-06,
                    1.7652e-06,
                    1.8151e-06,
                    1.865e-06,
                    1.9151e-06,
                    1.9653e-06,
                    2.0156e-06,
                    2.066e-06,
                    2.1164e-06,
                    2.167e-06,
                    2.2177e-06,
                    2.2672e-06,
                    2.3155e-06,
                    2.3626e-06,
                    2.4086e-06,
                    2.4533e-06,
                    2.4969e-06,
                    2.5392e-06,
                    2.5804e-06,
                    2.6204e-06,
                    2.6592e-06,
                    2.7061e-06,
                    2.7612e-06,
                    2.8244e-06,
                    2.8958e-06,
                    2.9752e-06,
                    3.0629e-06,
                    3.1586e-06,
                    3.2625e-06,
                    3.3746e-06,
                    3.4947e-06,
                    3.6263e-06,
                    3.7693e-06,
                    3.9237e-06,
                    4.0895e-06,
                    4.2666e-06,
                    4.4552e-06,
                    4.6553e-06,
                    4.8667e-06,
                    5.0895e-06,
                    5.3237e-06,
                    5.5631e-06,
                    5.8075e-06,
                    6.0572e-06,
                    6.3119e-06,
                    6.5718e-06,
                    6.8288e-06,
                    7.0824e-06,
                    7.3325e-06,
                    7.5787e-06,
                    7.8208e-06,
                    8.0594e-06,
                    8.2941e-06,
                    8.5246e-06,
                    8.7505e-06,
                    8.9715e-06,
                    9.1873e-06,
                    9.3975e-06,
                    9.6017e-06,
                    9.7996e-06,
                    9.991e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_N2O": 0.04,
                "Total_N2O_timeseries": [
                    1.6281e-08,
                    3.2849e-08,
                    4.9693e-08,
                    6.6799e-08,
                    8.4146e-08,
                    1.0171e-07,
                    1.1947e-07,
                    1.3739e-07,
                    1.5544e-07,
                    1.7357e-07,
                    1.9177e-07,
                    2.1002e-07,
                    2.2832e-07,
                    2.4667e-07,
                    2.6507e-07,
                    2.8351e-07,
                    3.02e-07,
                    3.2055e-07,
                    3.3915e-07,
                    3.5781e-07,
                    3.7675e-07,
                    3.9632e-07,
                    4.1681e-07,
                    4.384e-07,
                    4.612e-07,
                    4.8524e-07,
                    5.1047e-07,
                    5.3674e-07,
                    5.6383e-07,
                    5.9143e-07,
                    6.1934e-07,
                    6.4752e-07,
                    6.7592e-07,
                    7.0452e-07,
                    7.3331e-07,
                    7.6227e-07,
                    7.9141e-07,
                    8.2073e-07,
                    8.5026e-07,
                    8.8119e-07,
                    9.1246e-07,
                    9.4407e-07,
                    9.7606e-07,
                    1.0084e-06,
                    1.0412e-06,
                    1.0744e-06,
                    1.108e-06,
                    1.142e-06,
                    1.1765e-06,
                    1.2114e-06,
                    1.2469e-06,
                    1.2828e-06,
                    1.3192e-06,
                    1.3561e-06,
                    1.3936e-06,
                    1.4317e-06,
                    1.4704e-06,
                    1.5097e-06,
                    1.5496e-06,
                    1.5903e-06,
                    1.6319e-06,
                    1.6748e-06,
                    1.7193e-06,
                    1.7657e-06,
                    1.8142e-06,
                    1.8648e-06,
                    1.9176e-06,
                    1.9726e-06,
                    2.0297e-06,
                    2.0888e-06,
                    2.1498e-06,
                    2.213e-06,
                    2.2785e-06,
                    2.3465e-06,
                    2.4167e-06,
                    2.4891e-06,
                    2.5633e-06,
                    2.6391e-06,
                    2.716e-06,
                    2.7935e-06,
                    2.871e-06,
                    2.9481e-06,
                    3.0245e-06,
                    3.1002e-06,
                    3.1749e-06,
                    3.2488e-06,
                    3.3219e-06,
                    3.3945e-06,
                    3.4668e-06,
                    3.5395e-06,
                    3.6181e-06,
                    3.7121e-06,
                    3.8285e-06,
                    3.9722e-06,
                    4.1455e-06,
                    4.3485e-06,
                    4.5791e-06,
                    4.8327e-06,
                    5.1024e-06,
                    5.379e-06,
                    5.6546e-06,
                    5.9245e-06,
                    6.1854e-06,
                    6.4349e-06,
                    6.672e-06,
                    6.8965e-06,
                    7.1097e-06,
                    7.3138e-06,
                    7.5123e-06,
                    7.7096e-06,
                    7.9411e-06,
                    8.1751e-06,
                    8.41e-06,
                    8.6493e-06,
                    8.899e-06,
                    9.1537e-06,
                    9.4222e-06,
                    9.6972e-06,
                    9.9889e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_N2O": 0.03,
                "Fossil_N2O_timeseries": [
                    5.6479e-09,
                    1.137e-08,
                    1.7164e-08,
                    2.3029e-08,
                    2.8961e-08,
                    3.4958e-08,
                    4.1015e-08,
                    4.7128e-08,
                    5.3291e-08,
                    5.95e-08,
                    6.5751e-08,
                    7.2042e-08,
                    7.8373e-08,
                    8.4744e-08,
                    9.1155e-08,
                    9.7604e-08,
                    1.0409e-07,
                    1.1062e-07,
                    1.1719e-07,
                    1.2381e-07,
                    1.3049e-07,
                    1.373e-07,
                    1.4427e-07,
                    1.5144e-07,
                    1.5881e-07,
                    1.6639e-07,
                    1.7418e-07,
                    1.8215e-07,
                    1.9027e-07,
                    1.985e-07,
                    2.068e-07,
                    2.1518e-07,
                    2.2362e-07,
                    2.3212e-07,
                    2.4068e-07,
                    2.493e-07,
                    2.5798e-07,
                    2.6672e-07,
                    2.7551e-07,
                    2.8463e-07,
                    2.9387e-07,
                    3.0325e-07,
                    3.1276e-07,
                    3.2242e-07,
                    3.3223e-07,
                    3.422e-07,
                    3.5234e-07,
                    3.6264e-07,
                    3.7311e-07,
                    3.8377e-07,
                    3.9462e-07,
                    4.0569e-07,
                    4.17e-07,
                    4.2856e-07,
                    4.4037e-07,
                    4.5244e-07,
                    4.6476e-07,
                    4.773e-07,
                    4.9006e-07,
                    5.03e-07,
                    5.1611e-07,
                    5.2936e-07,
                    5.4277e-07,
                    5.5631e-07,
                    5.6998e-07,
                    5.8379e-07,
                    5.9774e-07,
                    6.1182e-07,
                    6.2603e-07,
                    6.404e-07,
                    6.5491e-07,
                    6.6956e-07,
                    6.8436e-07,
                    6.993e-07,
                    7.1439e-07,
                    7.2963e-07,
                    7.4503e-07,
                    7.6059e-07,
                    7.7634e-07,
                    7.9227e-07,
                    8.0842e-07,
                    8.2484e-07,
                    8.4157e-07,
                    8.5865e-07,
                    8.7609e-07,
                    8.9393e-07,
                    9.1219e-07,
                    9.3087e-07,
                    9.4999e-07,
                    9.6954e-07,
                    9.896e-07,
                    1.0103e-06,
                    1.0316e-06,
                    1.0538e-06,
                    1.0768e-06,
                    1.1006e-06,
                    1.1254e-06,
                    1.151e-06,
                    1.1774e-06,
                    1.2047e-06,
                    1.2327e-06,
                    1.2617e-06,
                    1.2917e-06,
                    1.3228e-06,
                    1.3548e-06,
                    1.3879e-06,
                    1.4221e-06,
                    1.4571e-06,
                    1.493e-06,
                    1.5297e-06,
                    1.567e-06,
                    1.6049e-06,
                    1.6435e-06,
                    1.6826e-06,
                    1.7225e-06,
                    1.763e-06,
                    1.8043e-06,
                    1.8464e-06,
                    1.8894e-06,
                    1.9369e-06,
                    1.9838e-06,
                    2.0309e-06,
                    2.0786e-06,
                    2.1251e-06,
                    2.1754e-06,
                    2.227e-06,
                    2.279e-06,
                    2.3319e-06,
                    2.3863e-06,
                    2.4425e-06,
                    2.4997e-06,
                    2.559e-06,
                    2.6197e-06,
                    2.6817e-06,
                    2.7467e-06,
                    2.8141e-06,
                    2.8837e-06,
                    2.9553e-06,
                    3.0271e-06,
                    3.1043e-06,
                    3.1828e-06,
                    3.26e-06,
                    3.3374e-06,
                    3.4178e-06,
                    3.5024e-06,
                    3.5897e-06,
                    3.6774e-06,
                    3.7671e-06,
                    3.8522e-06,
                    3.9492e-06,
                    4.0549e-06,
                    4.1625e-06,
                    4.2731e-06,
                    4.388e-06,
                    4.507e-06,
                    4.6291e-06,
                    4.7562e-06,
                    4.8844e-06,
                    5.0161e-06,
                    5.1519e-06,
                    5.2919e-06,
                    5.4226e-06,
                    5.5602e-06,
                    5.6992e-06,
                    5.8409e-06,
                    5.9862e-06,
                    6.133e-06,
                    6.2827e-06,
                    6.433e-06,
                    6.5854e-06,
                    6.7398e-06,
                    6.8957e-06
                ],
                "Land_N2O": 0.04,
                "Land_N2O_timeseries": [
                    1.0633e-08,
                    2.148e-08,
                    3.2529e-08,
                    4.377e-08,
                    5.5185e-08,
                    6.6755e-08,
                    7.8458e-08,
                    9.0265e-08,
                    1.0215e-07,
                    1.1407e-07,
                    1.2602e-07,
                    1.3798e-07,
                    1.4995e-07,
                    1.6193e-07,
                    1.7391e-07,
                    1.8591e-07,
                    1.9791e-07,
                    2.0992e-07,
                    2.2195e-07,
                    2.34e-07,
                    2.4626e-07,
                    2.5902e-07,
                    2.7254e-07,
                    2.8696e-07,
                    3.0239e-07,
                    3.1885e-07,
                    3.3629e-07,
                    3.5459e-07,
                    3.7356e-07,
                    3.9294e-07,
                    4.1254e-07,
                    4.3234e-07,
                    4.523e-07,
                    4.724e-07,
                    4.9263e-07,
                    5.1297e-07,
                    5.3343e-07,
                    5.5402e-07,
                    5.7475e-07,
                    5.9656e-07,
                    6.1859e-07,
                    6.4083e-07,
                    6.633e-07,
                    6.86e-07,
                    7.0895e-07,
                    7.3215e-07,
                    7.5562e-07,
                    7.7936e-07,
                    8.0337e-07,
                    8.2767e-07,
                    8.5225e-07,
                    8.7709e-07,
                    9.0221e-07,
                    9.2759e-07,
                    9.5327e-07,
                    9.7926e-07,
                    1.0056e-06,
                    1.0324e-06,
                    1.0596e-06,
                    1.0873e-06,
                    1.1158e-06,
                    1.1454e-06,
                    1.1766e-06,
                    1.2094e-06,
                    1.2442e-06,
                    1.281e-06,
                    1.3199e-06,
                    1.3608e-06,
                    1.4037e-06,
                    1.4484e-06,
                    1.4949e-06,
                    1.5434e-06,
                    1.5942e-06,
                    1.6472e-06,
                    1.7023e-06,
                    1.7594e-06,
                    1.8183e-06,
                    1.8785e-06,
                    1.9397e-06,
                    2.0012e-06,
                    2.0625e-06,
                    2.1232e-06,
                    2.183e-06,
                    2.2415e-06,
                    2.2988e-06,
                    2.3548e-06,
                    2.4097e-06,
                    2.4636e-06,
                    2.5169e-06,
                    2.5699e-06,
                    2.6285e-06,
                    2.7018e-06,
                    2.7969e-06,
                    2.9184e-06,
                    3.0687e-06,
                    3.2479e-06,
                    3.4537e-06,
                    3.6817e-06,
                    3.925e-06,
                    4.1744e-06,
                    4.4219e-06,
                    4.6628e-06,
                    4.8937e-06,
                    5.1122e-06,
                    5.3171e-06,
                    5.5086e-06,
                    5.6877e-06,
                    5.8567e-06,
                    6.0193e-06,
                    6.1799e-06,
                    6.3741e-06,
                    6.5702e-06,
                    6.7665e-06,
                    6.9667e-06,
                    7.1765e-06,
                    7.3907e-06,
                    7.6179e-06,
                    7.8508e-06,
                    8.0994e-06,
                    8.3538e-06,
                    8.6101e-06,
                    8.8787e-06,
                    9.1563e-06,
                    9.4358e-06,
                    9.7238e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            29.42333,
                            -4.4475
                        ],
                        [
                            29.67372,
                            -4.44806
                        ],
                        [
                            29.76829,
                            -4.45609
                        ],
                        [
                            29.8128,
                            -4.36554
                        ],
                        [
                            29.85201,
                            -4.38066
                        ],
                        [
                            29.95937,
                            -4.32712
                        ],
                        [
                            30.05317,
                            -4.2553
                        ],
                        [
                            30.077,
                            -4.16929
                        ],
                        [
                            30.1598,
                            -4.11251
                        ],
                        [
                            30.25852,
                            -3.88154
                        ],
                        [
                            30.30772,
                            -3.8455
                        ],
                        [
                            30.38914,
                            -3.71398
                        ],
                        [
                            30.44763,
                            -3.56552
                        ],
                        [
                            30.49259,
                            -3.52
                        ],
                        [
                            30.61965,
                            -3.46532
                        ],
                        [
                            30.67178,
                            -3.41854
                        ],
                        [
                            30.63497,
                            -3.36092
                        ],
                        [
                            30.66632,
                            -3.32063
                        ],
                        [
                            30.82795,
                            -3.26334
                        ],
                        [
                            30.84601,
                            -3.20588
                        ],
                        [
                            30.81408,
                            -3.04188
                        ],
                        [
                            30.83636,
                            -2.97661
                        ],
                        [
                            30.74677,
                            -2.99729
                        ],
                        [
                            30.66969,
                            -2.99311
                        ],
                        [
                            30.61855,
                            -2.92751
                        ],
                        [
                            30.56695,
                            -2.89639
                        ],
                        [
                            30.4847,
                            -2.94727
                        ],
                        [
                            30.40692,
                            -2.86059
                        ],
                        [
                            30.43892,
                            -2.80041
                        ],
                        [
                            30.45864,
                            -2.69121
                        ],
                        [
                            30.42046,
                            -2.66144
                        ],
                        [
                            30.48401,
                            -2.55638
                        ],
                        [
                            30.54325,
                            -2.41324
                        ],
                        [
                            30.40903,
                            -2.30993
                        ],
                        [
                            30.37226,
                            -2.35549
                        ],
                        [
                            30.27951,
                            -2.37493
                        ],
                        [
                            30.23212,
                            -2.35177
                        ],
                        [
                            30.18318,
                            -2.42794
                        ],
                        [
                            30.13119,
                            -2.43747
                        ],
                        [
                            30.03103,
                            -2.3487
                        ],
                        [
                            29.95765,
                            -2.3286
                        ],
                        [
                            29.94372,
                            -2.36955
                        ],
                        [
                            29.96511,
                            -2.48774
                        ],
                        [
                            29.92157,
                            -2.55768
                        ],
                        [
                            29.93551,
                            -2.64299
                        ],
                        [
                            29.88956,
                            -2.75072
                        ],
                        [
                            29.79618,
                            -2.7583
                        ],
                        [
                            29.70852,
                            -2.81824
                        ],
                        [
                            29.66622,
                            -2.79
                        ],
                        [
                            29.5214,
                            -2.8294
                        ],
                        [
                            29.43971,
                            -2.79764
                        ],
                        [
                            29.37102,
                            -2.83898
                        ],
                        [
                            29.33415,
                            -2.74689
                        ],
                        [
                            29.32738,
                            -2.6548
                        ],
                        [
                            29.26435,
                            -2.61913
                        ],
                        [
                            29.22594,
                            -2.62922
                        ],
                        [
                            29.08489,
                            -2.59379
                        ],
                        [
                            29.06217,
                            -2.60344
                        ],
                        [
                            29.04064,
                            -2.74384
                        ],
                        [
                            29.00293,
                            -2.78336
                        ],
                        [
                            29.09191,
                            -2.87337
                        ],
                        [
                            29.09938,
                            -2.921
                        ],
                        [
                            29.16765,
                            -2.95953
                        ],
                        [
                            29.18582,
                            -3.00746
                        ],
                        [
                            29.25835,
                            -3.06903
                        ],
                        [
                            29.22335,
                            -3.19703
                        ],
                        [
                            29.23989,
                            -3.27532
                        ],
                        [
                            29.21169,
                            -3.3043
                        ],
                        [
                            29.23784,
                            -3.462
                        ],
                        [
                            29.24681,
                            -3.59194
                        ],
                        [
                            29.22397,
                            -3.78935
                        ],
                        [
                            29.23934,
                            -3.92142
                        ],
                        [
                            29.34686,
                            -4.05643
                        ],
                        [
                            29.39253,
                            -4.19179
                        ],
                        [
                            29.3978,
                            -4.29794
                        ],
                        [
                            29.42333,
                            -4.4475
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "KHM",
                "Country": "Cambodia",
                "Total_3GHG": 0.15,
                "Total_3GHG_timeseries": [
                    1.6607e-06,
                    3.3212e-06,
                    4.9952e-06,
                    6.674e-06,
                    8.3605e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025
                ],
                "Fossil_3GHG": 0.03,
                "Fossil_3GHG_timeseries": [
                    1.5053e-07,
                    3.0645e-07,
                    4.6781e-07,
                    6.3466e-07,
                    8.0706e-07,
                    9.8505e-07,
                    1.1687e-06,
                    1.358e-06,
                    1.5531e-06,
                    1.7539e-06,
                    1.9606e-06,
                    2.1732e-06,
                    2.3917e-06,
                    2.6162e-06,
                    2.8468e-06,
                    3.0835e-06,
                    3.3263e-06,
                    3.5754e-06,
                    3.8308e-06,
                    4.1156e-06,
                    4.4034e-06,
                    4.6945e-06,
                    4.9887e-06,
                    5.2862e-06,
                    5.5868e-06,
                    5.8912e-06,
                    6.1995e-06,
                    6.5117e-06,
                    6.8276e-06,
                    7.1472e-06,
                    7.4713e-06,
                    7.7998e-06,
                    8.1325e-06,
                    8.4694e-06,
                    8.8105e-06,
                    9.1558e-06,
                    9.5069e-06,
                    9.8621e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Land_3GHG": 0.38,
                "Land_3GHG_timeseries": [
                    1.5101e-06,
                    3.0147e-06,
                    4.5274e-06,
                    6.0394e-06,
                    7.5535e-06,
                    9.0766e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022
                ],
                "Total_CO2": 0.13,
                "Total_CO2_timeseries": [
                    6.3232e-07,
                    1.2564e-06,
                    1.886e-06,
                    2.5122e-06,
                    3.1381e-06,
                    3.7704e-06,
                    4.405e-06,
                    5.0437e-06,
                    5.6932e-06,
                    6.3511e-06,
                    7.0174e-06,
                    7.6943e-06,
                    8.4003e-06,
                    9.0967e-06,
                    9.7967e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014
                ],
                "Fossil_CO2": 0.01,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    4.62e-08,
                    1.056e-07,
                    1.782e-07,
                    2.673e-07,
                    3.63e-07,
                    4.686e-07,
                    5.973e-07,
                    7.359e-07,
                    9.108e-07,
                    1.0642e-06,
                    1.2456e-06,
                    1.4567e-06,
                    1.6447e-06,
                    1.8657e-06,
                    2.4712e-06,
                    2.9991e-06,
                    3.1113e-06,
                    3.1641e-06,
                    3.222e-06,
                    3.2552e-06,
                    3.2885e-06,
                    3.3218e-06,
                    3.3552e-06,
                    3.3784e-06,
                    3.3916e-06,
                    3.5203e-06,
                    3.6556e-06,
                    3.8074e-06,
                    3.9724e-06,
                    4.1572e-06,
                    4.3453e-06,
                    4.54e-06,
                    4.7363e-06,
                    4.9393e-06,
                    5.1422e-06,
                    5.7098e-06,
                    6.2972e-06,
                    6.9044e-06,
                    7.5281e-06,
                    8.1955e-06,
                    8.8959e-06,
                    9.6306e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CO2": 0.37,
                "Land_CO2_timeseries": [
                    6.3232e-07,
                    1.2564e-06,
                    1.886e-06,
                    2.5122e-06,
                    3.1381e-06,
                    3.7704e-06,
                    4.405e-06,
                    5.0437e-06,
                    5.6932e-06,
                    6.3511e-06,
                    7.0174e-06,
                    7.6943e-06,
                    8.4003e-06,
                    9.0967e-06,
                    9.7967e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013
                ],
                "Total_CH4": 0.23,
                "Total_CH4_timeseries": [
                    9.9273e-07,
                    1.9928e-06,
                    3.0003e-06,
                    4.0152e-06,
                    5.0376e-06,
                    6.0676e-06,
                    7.1052e-06,
                    8.1505e-06,
                    9.2035e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009
                ],
                "Fossil_CH4": 0.07,
                "Fossil_CH4_timeseries": [
                    1.4776e-07,
                    3.0085e-07,
                    4.5934e-07,
                    6.2327e-07,
                    7.927e-07,
                    9.6769e-07,
                    1.1483e-06,
                    1.3346e-06,
                    1.5265e-06,
                    1.7243e-06,
                    1.9279e-06,
                    2.1373e-06,
                    2.3527e-06,
                    2.5741e-06,
                    2.8016e-06,
                    3.0351e-06,
                    3.2749e-06,
                    3.5208e-06,
                    3.7731e-06,
                    4.0546e-06,
                    4.3393e-06,
                    4.627e-06,
                    4.9177e-06,
                    5.2115e-06,
                    5.5081e-06,
                    5.8084e-06,
                    6.1123e-06,
                    6.4198e-06,
                    6.7309e-06,
                    7.0456e-06,
                    7.3648e-06,
                    7.6883e-06,
                    8.016e-06,
                    8.3479e-06,
                    8.6839e-06,
                    9.024e-06,
                    9.37e-06,
                    9.72e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_CH4": 0.48,
                "Land_CH4_timeseries": [
                    8.4497e-07,
                    1.6919e-06,
                    2.5409e-06,
                    3.3919e-06,
                    4.2449e-06,
                    5.0999e-06,
                    5.9569e-06,
                    6.8159e-06,
                    7.677e-06,
                    8.54e-06,
                    9.4051e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008
                ],
                "Total_N2O": 0.12,
                "Total_N2O_timeseries": [
                    3.5623e-08,
                    7.1955e-08,
                    1.0897e-07,
                    1.4661e-07,
                    1.8484e-07,
                    2.2359e-07,
                    2.6278e-07,
                    3.0233e-07,
                    3.4212e-07,
                    3.8206e-07,
                    4.2206e-07,
                    4.6213e-07,
                    5.0223e-07,
                    5.4236e-07,
                    5.8251e-07,
                    6.227e-07,
                    6.6292e-07,
                    7.0318e-07,
                    7.4349e-07,
                    7.8389e-07,
                    8.2495e-07,
                    8.6772e-07,
                    9.1297e-07,
                    9.6125e-07,
                    1.0129e-06,
                    1.0679e-06,
                    1.1262e-06,
                    1.1874e-06,
                    1.2508e-06,
                    1.3155e-06,
                    1.381e-06,
                    1.4472e-06,
                    1.5138e-06,
                    1.581e-06,
                    1.6486e-06,
                    1.7165e-06,
                    1.7849e-06,
                    1.8537e-06,
                    1.923e-06,
                    1.9973e-06,
                    2.0733e-06,
                    2.1511e-06,
                    2.2308e-06,
                    2.3123e-06,
                    2.3958e-06,
                    2.4813e-06,
                    2.5689e-06,
                    2.6585e-06,
                    2.7503e-06,
                    2.8444e-06,
                    2.9406e-06,
                    3.0392e-06,
                    3.1401e-06,
                    3.2433e-06,
                    3.3491e-06,
                    3.4574e-06,
                    3.5684e-06,
                    3.6822e-06,
                    3.799e-06,
                    3.9188e-06,
                    4.042e-06,
                    4.1688e-06,
                    4.2995e-06,
                    4.4343e-06,
                    4.5734e-06,
                    4.717e-06,
                    4.865e-06,
                    5.0176e-06,
                    5.1747e-06,
                    5.3362e-06,
                    5.5022e-06,
                    5.6724e-06,
                    5.847e-06,
                    6.0259e-06,
                    6.2092e-06,
                    6.3972e-06,
                    6.5899e-06,
                    6.7876e-06,
                    6.9905e-06,
                    7.199e-06,
                    7.4135e-06,
                    7.6343e-06,
                    7.8616e-06,
                    8.096e-06,
                    8.3377e-06,
                    8.587e-06,
                    8.8444e-06,
                    9.1102e-06,
                    9.3847e-06,
                    9.6683e-06,
                    9.9651e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_N2O": 0.04,
                "Fossil_N2O_timeseries": [
                    2.771e-09,
                    5.5941e-09,
                    8.4673e-09,
                    1.1388e-08,
                    1.4352e-08,
                    1.7354e-08,
                    2.0391e-08,
                    2.3454e-08,
                    2.6538e-08,
                    2.9635e-08,
                    3.274e-08,
                    3.5852e-08,
                    3.8969e-08,
                    4.2091e-08,
                    4.5218e-08,
                    4.835e-08,
                    5.1488e-08,
                    5.4631e-08,
                    5.7781e-08,
                    6.0939e-08,
                    6.4147e-08,
                    6.7476e-08,
                    7.098e-08,
                    7.4697e-08,
                    7.865e-08,
                    8.2843e-08,
                    8.7265e-08,
                    9.1888e-08,
                    9.6668e-08,
                    1.0155e-07,
                    1.0648e-07,
                    1.1146e-07,
                    1.1648e-07,
                    1.2154e-07,
                    1.2663e-07,
                    1.3175e-07,
                    1.369e-07,
                    1.4208e-07,
                    1.473e-07,
                    1.5264e-07,
                    1.5804e-07,
                    1.635e-07,
                    1.6904e-07,
                    1.7464e-07,
                    1.8032e-07,
                    1.8608e-07,
                    1.9193e-07,
                    1.9786e-07,
                    2.0388e-07,
                    2.1e-07,
                    2.1623e-07,
                    2.226e-07,
                    2.291e-07,
                    2.3576e-07,
                    2.4259e-07,
                    2.4957e-07,
                    2.5672e-07,
                    2.6403e-07,
                    2.7148e-07,
                    2.7907e-07,
                    2.8679e-07,
                    2.9463e-07,
                    3.026e-07,
                    3.1069e-07,
                    3.189e-07,
                    3.2724e-07,
                    3.3569e-07,
                    3.4425e-07,
                    3.5292e-07,
                    3.6171e-07,
                    3.706e-07,
                    3.7961e-07,
                    3.8873e-07,
                    3.9795e-07,
                    4.0729e-07,
                    4.1673e-07,
                    4.2629e-07,
                    4.3594e-07,
                    4.4571e-07,
                    4.5557e-07,
                    4.6552e-07,
                    4.7557e-07,
                    4.8572e-07,
                    4.9597e-07,
                    5.0633e-07,
                    5.168e-07,
                    5.2742e-07,
                    5.3818e-07,
                    5.4911e-07,
                    5.6024e-07,
                    5.7173e-07,
                    5.8384e-07,
                    5.9678e-07,
                    6.1072e-07,
                    6.2574e-07,
                    6.4191e-07,
                    6.5922e-07,
                    6.7761e-07,
                    6.9696e-07,
                    7.1711e-07,
                    7.3823e-07,
                    7.6076e-07,
                    7.8506e-07,
                    8.114e-07,
                    8.3994e-07,
                    8.7074e-07,
                    9.0379e-07,
                    9.3895e-07,
                    9.76e-07,
                    1.0146e-06,
                    1.0546e-06,
                    1.0959e-06,
                    1.1386e-06,
                    1.1827e-06,
                    1.2281e-06,
                    1.2752e-06,
                    1.3239e-06,
                    1.3744e-06,
                    1.427e-06,
                    1.4784e-06,
                    1.5314e-06,
                    1.585e-06,
                    1.6389e-06,
                    1.6924e-06,
                    1.742e-06,
                    1.7896e-06,
                    1.8366e-06,
                    1.8812e-06,
                    1.9261e-06,
                    1.97e-06,
                    2.0163e-06,
                    2.0804e-06,
                    2.1409e-06,
                    2.2038e-06,
                    2.2635e-06,
                    2.3308e-06,
                    2.4031e-06,
                    2.4687e-06,
                    2.5418e-06,
                    2.6157e-06,
                    2.6911e-06,
                    2.7678e-06,
                    2.846e-06,
                    2.9251e-06,
                    3.0513e-06,
                    3.1833e-06,
                    3.3212e-06,
                    3.4765e-06,
                    3.638e-06,
                    3.8019e-06,
                    3.9722e-06,
                    4.1486e-06,
                    4.33e-06,
                    4.5066e-06,
                    4.6894e-06,
                    4.8796e-06,
                    5.0798e-06,
                    5.2817e-06,
                    5.5118e-06,
                    5.7449e-06,
                    5.9852e-06,
                    6.2328e-06,
                    6.4848e-06,
                    6.7463e-06,
                    7.0201e-06,
                    7.3113e-06,
                    7.6107e-06,
                    7.917e-06,
                    8.2481e-06,
                    8.5864e-06,
                    8.9296e-06,
                    9.2613e-06
                ],
                "Land_N2O": 0.15,
                "Land_N2O_timeseries": [
                    3.2852e-08,
                    6.6361e-08,
                    1.005e-07,
                    1.3523e-07,
                    1.7049e-07,
                    2.0624e-07,
                    2.4239e-07,
                    2.7887e-07,
                    3.1558e-07,
                    3.5242e-07,
                    3.8932e-07,
                    4.2627e-07,
                    4.6326e-07,
                    5.0026e-07,
                    5.373e-07,
                    5.7435e-07,
                    6.1143e-07,
                    6.4855e-07,
                    6.8571e-07,
                    7.2295e-07,
                    7.6081e-07,
                    8.0025e-07,
                    8.4199e-07,
                    8.8656e-07,
                    9.3423e-07,
                    9.8508e-07,
                    1.039e-06,
                    1.0955e-06,
                    1.1541e-06,
                    1.214e-06,
                    1.2745e-06,
                    1.3357e-06,
                    1.3974e-06,
                    1.4595e-06,
                    1.522e-06,
                    1.5848e-06,
                    1.648e-06,
                    1.7116e-06,
                    1.7757e-06,
                    1.8446e-06,
                    1.9153e-06,
                    1.9876e-06,
                    2.0617e-06,
                    2.1377e-06,
                    2.2155e-06,
                    2.2952e-06,
                    2.3769e-06,
                    2.4607e-06,
                    2.5465e-06,
                    2.6344e-06,
                    2.7244e-06,
                    2.8166e-06,
                    2.911e-06,
                    3.0076e-06,
                    3.1065e-06,
                    3.2078e-06,
                    3.3117e-06,
                    3.4182e-06,
                    3.5275e-06,
                    3.6397e-06,
                    3.7552e-06,
                    3.8741e-06,
                    3.9969e-06,
                    4.1236e-06,
                    4.2545e-06,
                    4.3898e-06,
                    4.5293e-06,
                    4.6734e-06,
                    4.8218e-06,
                    4.9745e-06,
                    5.1316e-06,
                    5.2928e-06,
                    5.4582e-06,
                    5.6279e-06,
                    5.8019e-06,
                    5.9804e-06,
                    6.1636e-06,
                    6.3516e-06,
                    6.5448e-06,
                    6.7435e-06,
                    6.948e-06,
                    7.1587e-06,
                    7.3759e-06,
                    7.6e-06,
                    7.8314e-06,
                    8.0702e-06,
                    8.317e-06,
                    8.572e-06,
                    8.8356e-06,
                    9.1081e-06,
                    9.3933e-06,
                    9.6981e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                104.43861,
                                10.42455
                            ],
                            [
                                104.55171,
                                10.45786
                            ],
                            [
                                104.58737,
                                10.52663
                            ],
                            [
                                104.69493,
                                10.53737
                            ],
                            [
                                104.76024,
                                10.51805
                            ],
                            [
                                104.86904,
                                10.52394
                            ],
                            [
                                104.94874,
                                10.63334
                            ],
                            [
                                105.09177,
                                10.72078
                            ],
                            [
                                105.03094,
                                10.88905
                            ],
                            [
                                105.0835,
                                10.95529
                            ],
                            [
                                105.33803,
                                10.8633
                            ],
                            [
                                105.42891,
                                10.96978
                            ],
                            [
                                105.5357,
                                10.95267
                            ],
                            [
                                105.7744,
                                11.02947
                            ],
                            [
                                105.84619,
                                10.92721
                            ],
                            [
                                105.85628,
                                10.86099
                            ],
                            [
                                105.90267,
                                10.84211
                            ],
                            [
                                105.97754,
                                10.88741
                            ],
                            [
                                106.08974,
                                10.80618
                            ],
                            [
                                106.19422,
                                10.79681
                            ],
                            [
                                106.14512,
                                10.91655
                            ],
                            [
                                106.1515,
                                10.97765
                            ],
                            [
                                106.20711,
                                10.97786
                            ],
                            [
                                106.16158,
                                11.09578
                            ],
                            [
                                106.09529,
                                11.0971
                            ],
                            [
                                106.02419,
                                11.15027
                            ],
                            [
                                106.01498,
                                11.1854
                            ],
                            [
                                105.93105,
                                11.216
                            ],
                            [
                                105.88399,
                                11.35895
                            ],
                            [
                                105.88092,
                                11.54069
                            ],
                            [
                                105.82374,
                                11.57073
                            ],
                            [
                                105.81321,
                                11.61507
                            ],
                            [
                                105.88442,
                                11.67459
                            ],
                            [
                                105.95955,
                                11.64648
                            ],
                            [
                                106.01284,
                                11.72201
                            ],
                            [
                                106.07498,
                                11.77339
                            ],
                            [
                                106.11748,
                                11.74445
                            ],
                            [
                                106.18936,
                                11.74964
                            ],
                            [
                                106.26115,
                                11.72139
                            ],
                            [
                                106.30578,
                                11.67671
                            ],
                            [
                                106.45099,
                                11.6901
                            ],
                            [
                                106.41661,
                                11.76759
                            ],
                            [
                                106.46433,
                                11.8724
                            ],
                            [
                                106.42003,
                                11.97311
                            ],
                            [
                                106.68705,
                                11.96608
                            ],
                            [
                                106.74047,
                                11.9854
                            ],
                            [
                                106.77856,
                                12.07066
                            ],
                            [
                                106.9323,
                                12.06631
                            ],
                            [
                                106.99767,
                                12.09548
                            ],
                            [
                                107.13555,
                                12.23094
                            ],
                            [
                                107.15444,
                                12.27447
                            ],
                            [
                                107.27261,
                                12.3234
                            ],
                            [
                                107.34738,
                                12.3303
                            ],
                            [
                                107.41857,
                                12.2433
                            ],
                            [
                                107.4711,
                                12.31017
                            ],
                            [
                                107.5445,
                                12.3555
                            ],
                            [
                                107.5877,
                                12.55795
                            ],
                            [
                                107.56224,
                                12.7108
                            ],
                            [
                                107.56078,
                                12.79386
                            ],
                            [
                                107.49398,
                                12.89871
                            ],
                            [
                                107.4976,
                                13.03222
                            ],
                            [
                                107.63005,
                                13.36252
                            ],
                            [
                                107.6282,
                                13.48127
                            ],
                            [
                                107.57211,
                                13.66299
                            ],
                            [
                                107.53157,
                                13.742
                            ],
                            [
                                107.45171,
                                13.79369
                            ],
                            [
                                107.47224,
                                13.91381
                            ],
                            [
                                107.44632,
                                13.99226
                            ],
                            [
                                107.36549,
                                14.01558
                            ],
                            [
                                107.3822,
                                14.07869
                            ],
                            [
                                107.33961,
                                14.13206
                            ],
                            [
                                107.40639,
                                14.23551
                            ],
                            [
                                107.41068,
                                14.36008
                            ],
                            [
                                107.4859,
                                14.40238
                            ],
                            [
                                107.52427,
                                14.57497
                            ],
                            [
                                107.55226,
                                14.60648
                            ],
                            [
                                107.55613,
                                14.6866
                            ],
                            [
                                107.45845,
                                14.61459
                            ],
                            [
                                107.43695,
                                14.52817
                            ],
                            [
                                107.29885,
                                14.58559
                            ],
                            [
                                107.25652,
                                14.52578
                            ],
                            [
                                107.24883,
                                14.46706
                            ],
                            [
                                107.2019,
                                14.43075
                            ],
                            [
                                107.07507,
                                14.42179
                            ],
                            [
                                107.0224,
                                14.40182
                            ],
                            [
                                106.97608,
                                14.33416
                            ],
                            [
                                106.81654,
                                14.31024
                            ],
                            [
                                106.73995,
                                14.42412
                            ],
                            [
                                106.63088,
                                14.45099
                            ],
                            [
                                106.54379,
                                14.5879
                            ],
                            [
                                106.46138,
                                14.55039
                            ],
                            [
                                106.40908,
                                14.45232
                            ],
                            [
                                106.3178,
                                14.43746
                            ],
                            [
                                106.25331,
                                14.4813
                            ],
                            [
                                106.21939,
                                14.37879
                            ],
                            [
                                106.1757,
                                14.35705
                            ],
                            [
                                106.09185,
                                14.37385
                            ],
                            [
                                106.02494,
                                14.35
                            ],
                            [
                                106.02737,
                                14.25813
                            ],
                            [
                                106.13354,
                                14.10355
                            ],
                            [
                                106.18453,
                                14.06047
                            ],
                            [
                                106.11762,
                                13.99144
                            ],
                            [
                                106.10733,
                                13.91612
                            ],
                            [
                                106.00361,
                                13.9346
                            ],
                            [
                                105.91068,
                                13.93026
                            ],
                            [
                                105.79078,
                                14.0226
                            ],
                            [
                                105.78148,
                                14.08508
                            ],
                            [
                                105.70323,
                                14.08859
                            ],
                            [
                                105.60346,
                                14.14614
                            ],
                            [
                                105.54851,
                                14.15712
                            ],
                            [
                                105.45391,
                                14.10273
                            ],
                            [
                                105.36092,
                                14.10973
                            ],
                            [
                                105.27208,
                                14.18358
                            ],
                            [
                                105.20007,
                                14.34271
                            ],
                            [
                                105.13595,
                                14.22596
                            ],
                            [
                                105.09906,
                                14.20857
                            ],
                            [
                                105.0302,
                                14.23411
                            ],
                            [
                                104.99806,
                                14.30874
                            ],
                            [
                                105.00001,
                                14.36688
                            ],
                            [
                                104.80445,
                                14.43315
                            ],
                            [
                                104.73667,
                                14.40098
                            ],
                            [
                                104.64621,
                                14.41978
                            ],
                            [
                                104.58019,
                                14.35688
                            ],
                            [
                                104.5125,
                                14.36904
                            ],
                            [
                                104.4733,
                                14.34449
                            ],
                            [
                                104.39825,
                                14.37037
                            ],
                            [
                                104.33637,
                                14.36569
                            ],
                            [
                                104.19906,
                                14.39579
                            ],
                            [
                                104.17199,
                                14.35234
                            ],
                            [
                                104.11747,
                                14.37042
                            ],
                            [
                                104.0268,
                                14.33361
                            ],
                            [
                                103.92758,
                                14.32763
                            ],
                            [
                                103.85017,
                                14.36704
                            ],
                            [
                                103.71345,
                                14.37871
                            ],
                            [
                                103.70398,
                                14.43028
                            ],
                            [
                                103.61902,
                                14.39874
                            ],
                            [
                                103.56159,
                                14.41918
                            ],
                            [
                                103.46775,
                                14.36311
                            ],
                            [
                                103.18259,
                                14.32818
                            ],
                            [
                                103.0753,
                                14.28177
                            ],
                            [
                                103.02002,
                                14.22457
                            ],
                            [
                                102.96359,
                                14.2007
                            ],
                            [
                                102.90747,
                                14.08235
                            ],
                            [
                                102.91163,
                                14.01798
                            ],
                            [
                                102.79289,
                                13.92902
                            ],
                            [
                                102.72426,
                                13.76246
                            ],
                            [
                                102.56372,
                                13.66925
                            ],
                            [
                                102.59102,
                                13.59911
                            ],
                            [
                                102.53492,
                                13.56345
                            ],
                            [
                                102.37238,
                                13.57328
                            ],
                            [
                                102.35343,
                                13.29287
                            ],
                            [
                                102.39674,
                                13.1678
                            ],
                            [
                                102.44387,
                                13.08247
                            ],
                            [
                                102.51536,
                                13.0038
                            ],
                            [
                                102.48802,
                                12.97509
                            ],
                            [
                                102.54302,
                                12.81103
                            ],
                            [
                                102.50715,
                                12.69299
                            ],
                            [
                                102.64148,
                                12.60353
                            ],
                            [
                                102.67524,
                                12.55083
                            ],
                            [
                                102.78066,
                                12.4577
                            ],
                            [
                                102.79214,
                                12.40969
                            ],
                            [
                                102.74431,
                                12.3657
                            ],
                            [
                                102.71646,
                                12.16918
                            ],
                            [
                                102.77978,
                                12.05071
                            ],
                            [
                                102.78416,
                                11.98159
                            ],
                            [
                                102.85233,
                                11.8308
                            ],
                            [
                                102.91619,
                                11.74686
                            ],
                            [
                                102.91095,
                                11.64721
                            ],
                            [
                                103.00955,
                                11.46747
                            ],
                            [
                                103.05851,
                                11.44922
                            ],
                            [
                                103.09291,
                                11.35621
                            ],
                            [
                                103.06662,
                                11.2561
                            ],
                            [
                                103.1134,
                                11.1329
                            ],
                            [
                                103.09694,
                                11.05437
                            ],
                            [
                                103.09968,
                                10.91653
                            ],
                            [
                                103.17209,
                                10.86008
                            ],
                            [
                                103.28255,
                                10.92387
                            ],
                            [
                                103.35355,
                                10.86821
                            ],
                            [
                                103.4234,
                                10.89318
                            ],
                            [
                                103.41161,
                                10.95922
                            ],
                            [
                                103.4684,
                                11.09255
                            ],
                            [
                                103.47319,
                                11.13943
                            ],
                            [
                                103.54959,
                                11.16605
                            ],
                            [
                                103.59452,
                                11.09283
                            ],
                            [
                                103.63425,
                                11.08634
                            ],
                            [
                                103.69973,
                                10.92363
                            ],
                            [
                                103.70765,
                                10.83573
                            ],
                            [
                                103.67041,
                                10.74519
                            ],
                            [
                                103.54517,
                                10.71893
                            ],
                            [
                                103.49247,
                                10.62259
                            ],
                            [
                                103.58827,
                                10.5579
                            ],
                            [
                                103.63402,
                                10.48824
                            ],
                            [
                                103.73656,
                                10.52684
                            ],
                            [
                                103.80099,
                                10.52079
                            ],
                            [
                                103.86744,
                                10.62024
                            ],
                            [
                                104.0497,
                                10.54959
                            ],
                            [
                                104.14341,
                                10.56263
                            ],
                            [
                                104.18005,
                                10.54082
                            ],
                            [
                                104.24565,
                                10.56955
                            ],
                            [
                                104.30463,
                                10.47638
                            ],
                            [
                                104.34221,
                                10.49445
                            ],
                            [
                                104.43861,
                                10.42455
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                102.97049,
                                11.39459
                            ],
                            [
                                103.00075,
                                11.24824
                            ],
                            [
                                103.04299,
                                11.29381
                            ],
                            [
                                103.01408,
                                11.41882
                            ],
                            [
                                102.97049,
                                11.39459
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "CMR",
                "Country": "Cameroon",
                "Total_3GHG": 0.18,
                "Total_3GHG_timeseries": [
                    1.0265e-06,
                    1.668e-06,
                    2.3732e-06,
                    3.6019e-06,
                    3.9929e-06,
                    4.9156e-06,
                    5.8904e-06,
                    6.0423e-06,
                    6.7141e-06,
                    7.3164e-06,
                    8.6809e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.003
                ],
                "Fossil_3GHG": 0.08,
                "Fossil_3GHG_timeseries": [
                    5.1527e-08,
                    1.032e-07,
                    1.55e-07,
                    2.0694e-07,
                    2.5901e-07,
                    3.1119e-07,
                    3.6348e-07,
                    4.1587e-07,
                    4.6834e-07,
                    5.2089e-07,
                    5.7421e-07,
                    6.2829e-07,
                    7.9955e-07,
                    9.7175e-07,
                    1.1449e-06,
                    1.319e-06,
                    1.494e-06,
                    1.67e-06,
                    1.847e-06,
                    2.0255e-06,
                    2.2071e-06,
                    2.3919e-06,
                    2.5802e-06,
                    2.772e-06,
                    2.9675e-06,
                    3.1666e-06,
                    3.3695e-06,
                    3.5762e-06,
                    3.7867e-06,
                    4.0008e-06,
                    4.218e-06,
                    4.4384e-06,
                    4.5528e-06,
                    4.6702e-06,
                    4.7908e-06,
                    4.9147e-06,
                    5.0418e-06,
                    5.1723e-06,
                    5.3063e-06,
                    5.4437e-06,
                    5.583e-06,
                    5.7243e-06,
                    5.8674e-06,
                    6.0126e-06,
                    6.1598e-06,
                    6.3091e-06,
                    6.4606e-06,
                    6.6143e-06,
                    6.7703e-06,
                    6.9286e-06,
                    7.0908e-06,
                    7.257e-06,
                    7.4375e-06,
                    7.6211e-06,
                    7.808e-06,
                    7.9982e-06,
                    8.1916e-06,
                    8.3884e-06,
                    8.5884e-06,
                    8.7918e-06,
                    9.0108e-06,
                    9.2454e-06,
                    9.4958e-06,
                    9.7614e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008
                ],
                "Land_3GHG": 0.37,
                "Land_3GHG_timeseries": [
                    9.7499e-07,
                    1.5648e-06,
                    2.2182e-06,
                    3.3949e-06,
                    3.7339e-06,
                    4.6044e-06,
                    5.5269e-06,
                    5.6264e-06,
                    6.2458e-06,
                    6.7955e-06,
                    8.1067e-06,
                    9.6155e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021
                ],
                "Total_CO2": 0.16,
                "Total_CO2_timeseries": [
                    8.0258e-07,
                    1.219e-06,
                    1.6979e-06,
                    2.6993e-06,
                    2.862e-06,
                    3.5555e-06,
                    4.3003e-06,
                    4.2215e-06,
                    4.6622e-06,
                    5.033e-06,
                    6.163e-06,
                    7.4886e-06,
                    8.3488e-06,
                    9.2892e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018
                ],
                "Fossil_CO2": 0.02,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    6.27e-08,
                    1.452e-07,
                    2.7225e-07,
                    3.63e-07,
                    4.6695e-07,
                    5.7254e-07,
                    6.7976e-07,
                    7.9525e-07,
                    9.2063e-07,
                    1.046e-06,
                    1.1681e-06,
                    1.2952e-06,
                    1.4255e-06,
                    1.5608e-06,
                    1.7126e-06,
                    1.8529e-06,
                    2.008e-06,
                    2.2142e-06,
                    2.4419e-06,
                    2.6993e-06,
                    2.9864e-06,
                    3.3508e-06,
                    3.7382e-06,
                    4.1421e-06,
                    4.5806e-06,
                    5.1032e-06,
                    5.5936e-06,
                    6.2957e-06,
                    7.1933e-06,
                    8.0108e-06,
                    9.7608e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CO2": 0.47,
                "Land_CO2_timeseries": [
                    8.0258e-07,
                    1.219e-06,
                    1.6979e-06,
                    2.6993e-06,
                    2.862e-06,
                    3.5555e-06,
                    4.3003e-06,
                    4.2215e-06,
                    4.6622e-06,
                    5.033e-06,
                    6.163e-06,
                    7.4886e-06,
                    8.3488e-06,
                    9.2892e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017
                ],
                "Total_CH4": 0.24,
                "Total_CH4_timeseries": [
                    1.7106e-07,
                    3.4226e-07,
                    5.1359e-07,
                    6.8507e-07,
                    8.5668e-07,
                    1.0284e-06,
                    1.2003e-06,
                    1.3724e-06,
                    1.5445e-06,
                    1.7169e-06,
                    1.892e-06,
                    2.0699e-06,
                    2.367e-06,
                    2.6671e-06,
                    2.9702e-06,
                    3.2762e-06,
                    3.5853e-06,
                    3.8973e-06,
                    4.2123e-06,
                    4.5309e-06,
                    4.8546e-06,
                    5.1834e-06,
                    5.5175e-06,
                    5.8568e-06,
                    6.2015e-06,
                    6.5515e-06,
                    6.907e-06,
                    7.268e-06,
                    7.6346e-06,
                    8.0069e-06,
                    8.3824e-06,
                    8.7613e-06,
                    9.0346e-06,
                    9.3111e-06,
                    9.5911e-06,
                    9.8746e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001
                ],
                "Fossil_CH4": 0.26,
                "Fossil_CH4_timeseries": [
                    4.5007e-08,
                    9.0047e-08,
                    1.3512e-07,
                    1.8023e-07,
                    2.2537e-07,
                    2.7054e-07,
                    3.1575e-07,
                    3.6099e-07,
                    4.0627e-07,
                    4.5158e-07,
                    4.9762e-07,
                    5.4441e-07,
                    7.0833e-07,
                    8.7319e-07,
                    1.039e-06,
                    1.2057e-06,
                    1.3733e-06,
                    1.5418e-06,
                    1.7113e-06,
                    1.8823e-06,
                    2.0562e-06,
                    2.2332e-06,
                    2.4133e-06,
                    2.5966e-06,
                    2.7831e-06,
                    2.9728e-06,
                    3.1659e-06,
                    3.3624e-06,
                    3.5623e-06,
                    3.7658e-06,
                    3.9722e-06,
                    4.1817e-06,
                    4.2851e-06,
                    4.3915e-06,
                    4.501e-06,
                    4.6136e-06,
                    4.7295e-06,
                    4.8486e-06,
                    4.9712e-06,
                    5.0967e-06,
                    5.2238e-06,
                    5.3526e-06,
                    5.4831e-06,
                    5.6153e-06,
                    5.7494e-06,
                    5.8853e-06,
                    6.0231e-06,
                    6.1628e-06,
                    6.3045e-06,
                    6.4482e-06,
                    6.5954e-06,
                    6.7463e-06,
                    6.9109e-06,
                    7.0783e-06,
                    7.2484e-06,
                    7.4214e-06,
                    7.5971e-06,
                    7.7758e-06,
                    7.9573e-06,
                    8.1418e-06,
                    8.3417e-06,
                    8.5569e-06,
                    8.7875e-06,
                    9.0332e-06,
                    9.294e-06,
                    9.5699e-06,
                    9.8609e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Land_CH4": 0.21,
                "Land_CH4_timeseries": [
                    1.2605e-07,
                    2.5221e-07,
                    3.7847e-07,
                    5.0484e-07,
                    6.3132e-07,
                    7.579e-07,
                    8.8458e-07,
                    1.0114e-06,
                    1.1383e-06,
                    1.2653e-06,
                    1.3943e-06,
                    1.5255e-06,
                    1.6586e-06,
                    1.7939e-06,
                    1.9312e-06,
                    2.0706e-06,
                    2.212e-06,
                    2.3555e-06,
                    2.501e-06,
                    2.6486e-06,
                    2.7983e-06,
                    2.9502e-06,
                    3.1041e-06,
                    3.2602e-06,
                    3.4184e-06,
                    3.5787e-06,
                    3.7411e-06,
                    3.9056e-06,
                    4.0723e-06,
                    4.2411e-06,
                    4.4102e-06,
                    4.5797e-06,
                    4.7495e-06,
                    4.9196e-06,
                    5.0901e-06,
                    5.261e-06,
                    5.4321e-06,
                    5.6037e-06,
                    5.7755e-06,
                    5.9478e-06,
                    6.1203e-06,
                    6.2933e-06,
                    6.4665e-06,
                    6.6402e-06,
                    6.8141e-06,
                    6.9885e-06,
                    7.1631e-06,
                    7.3382e-06,
                    7.5135e-06,
                    7.6893e-06,
                    7.8654e-06,
                    8.0418e-06,
                    8.2186e-06,
                    8.3958e-06,
                    8.5733e-06,
                    8.7512e-06,
                    8.9294e-06,
                    9.1081e-06,
                    9.287e-06,
                    9.4663e-06,
                    9.6783e-06,
                    9.923e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Total_N2O": 0.18,
                "Total_N2O_timeseries": [
                    5.2875e-08,
                    1.0678e-07,
                    1.6168e-07,
                    2.1752e-07,
                    2.742e-07,
                    3.3165e-07,
                    3.8975e-07,
                    4.4837e-07,
                    5.0737e-07,
                    5.6659e-07,
                    6.2593e-07,
                    6.8536e-07,
                    7.4487e-07,
                    8.0444e-07,
                    8.6406e-07,
                    9.2375e-07,
                    9.835e-07,
                    1.0433e-06,
                    1.1032e-06,
                    1.1633e-06,
                    1.2243e-06,
                    1.2878e-06,
                    1.3549e-06,
                    1.4263e-06,
                    1.5026e-06,
                    1.5838e-06,
                    1.6696e-06,
                    1.7596e-06,
                    1.8528e-06,
                    1.9479e-06,
                    2.0442e-06,
                    2.1414e-06,
                    2.2394e-06,
                    2.338e-06,
                    2.4373e-06,
                    2.5372e-06,
                    2.6377e-06,
                    2.7388e-06,
                    2.8406e-06,
                    2.9477e-06,
                    3.0559e-06,
                    3.1652e-06,
                    3.2758e-06,
                    3.3877e-06,
                    3.5009e-06,
                    3.6154e-06,
                    3.7314e-06,
                    3.8489e-06,
                    3.9679e-06,
                    4.0884e-06,
                    4.2105e-06,
                    4.3342e-06,
                    4.4595e-06,
                    4.5864e-06,
                    4.7151e-06,
                    4.8456e-06,
                    4.9782e-06,
                    5.1129e-06,
                    5.25e-06,
                    5.3897e-06,
                    5.5331e-06,
                    5.6818e-06,
                    5.8373e-06,
                    6.0005e-06,
                    6.1723e-06,
                    6.3532e-06,
                    6.5433e-06,
                    6.7426e-06,
                    6.9507e-06,
                    7.1669e-06,
                    7.3913e-06,
                    7.625e-06,
                    7.8685e-06,
                    8.1219e-06,
                    8.3851e-06,
                    8.6572e-06,
                    8.9371e-06,
                    9.2234e-06,
                    9.514e-06,
                    9.8065e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_N2O": 0.06,
                "Fossil_N2O_timeseries": [
                    6.5207e-09,
                    1.3149e-08,
                    1.9882e-08,
                    2.6713e-08,
                    3.3637e-08,
                    4.0645e-08,
                    4.7729e-08,
                    5.4877e-08,
                    6.2077e-08,
                    6.9317e-08,
                    7.6587e-08,
                    8.3885e-08,
                    9.121e-08,
                    9.8561e-08,
                    1.0594e-07,
                    1.1334e-07,
                    1.2076e-07,
                    1.2822e-07,
                    1.357e-07,
                    1.4322e-07,
                    1.5083e-07,
                    1.5868e-07,
                    1.6684e-07,
                    1.754e-07,
                    1.8438e-07,
                    1.938e-07,
                    2.0363e-07,
                    2.1383e-07,
                    2.2433e-07,
                    2.35e-07,
                    2.458e-07,
                    2.5669e-07,
                    2.6767e-07,
                    2.7873e-07,
                    2.8986e-07,
                    3.0106e-07,
                    3.1233e-07,
                    3.2367e-07,
                    3.3509e-07,
                    3.4708e-07,
                    3.5928e-07,
                    3.717e-07,
                    3.8435e-07,
                    3.9724e-07,
                    4.1039e-07,
                    4.2381e-07,
                    4.3751e-07,
                    4.515e-07,
                    4.6579e-07,
                    4.804e-07,
                    4.9536e-07,
                    5.1072e-07,
                    5.2653e-07,
                    5.428e-07,
                    5.5955e-07,
                    5.7678e-07,
                    5.9447e-07,
                    6.126e-07,
                    6.3112e-07,
                    6.4998e-07,
                    6.6914e-07,
                    6.8858e-07,
                    7.0828e-07,
                    7.2823e-07,
                    7.4843e-07,
                    7.6887e-07,
                    7.8955e-07,
                    8.1048e-07,
                    8.3166e-07,
                    8.531e-07,
                    8.7481e-07,
                    8.9679e-07,
                    9.1903e-07,
                    9.4154e-07,
                    9.6431e-07,
                    9.8737e-07,
                    1.0107e-06,
                    1.0344e-06,
                    1.0584e-06,
                    1.0827e-06,
                    1.1074e-06,
                    1.1326e-06,
                    1.1584e-06,
                    1.1848e-06,
                    1.2119e-06,
                    1.2398e-06,
                    1.2684e-06,
                    1.2978e-06,
                    1.328e-06,
                    1.3591e-06,
                    1.3912e-06,
                    1.4246e-06,
                    1.4596e-06,
                    1.4964e-06,
                    1.5352e-06,
                    1.5759e-06,
                    1.6187e-06,
                    1.6635e-06,
                    1.7101e-06,
                    1.7585e-06,
                    1.8086e-06,
                    1.8605e-06,
                    1.9145e-06,
                    1.9704e-06,
                    2.0285e-06,
                    2.0886e-06,
                    2.1507e-06,
                    2.2147e-06,
                    2.2804e-06,
                    2.3477e-06,
                    2.4165e-06,
                    2.4867e-06,
                    2.5585e-06,
                    2.6318e-06,
                    2.7068e-06,
                    2.7835e-06,
                    2.8621e-06,
                    2.9427e-06,
                    3.0254e-06,
                    3.1102e-06,
                    3.1972e-06,
                    3.2865e-06,
                    3.3772e-06,
                    3.4722e-06,
                    3.5712e-06,
                    3.6711e-06,
                    3.7743e-06,
                    3.8789e-06,
                    3.9881e-06,
                    4.0999e-06,
                    4.214e-06,
                    4.3672e-06,
                    4.5305e-06,
                    4.6854e-06,
                    4.8378e-06,
                    4.9977e-06,
                    5.1665e-06,
                    5.3267e-06,
                    5.5101e-06,
                    5.6932e-06,
                    5.8795e-06,
                    6.0697e-06,
                    6.2658e-06,
                    6.4706e-06,
                    6.6808e-06,
                    6.8975e-06,
                    7.1203e-06,
                    7.3502e-06,
                    7.5844e-06,
                    7.8244e-06,
                    8.0693e-06,
                    8.3272e-06,
                    8.5925e-06,
                    8.8651e-06,
                    9.1466e-06,
                    9.4132e-06,
                    9.6613e-06,
                    9.9178e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.22,
                "Land_N2O_timeseries": [
                    4.6354e-08,
                    9.3635e-08,
                    1.418e-07,
                    1.908e-07,
                    2.4057e-07,
                    2.91e-07,
                    3.4202e-07,
                    3.9349e-07,
                    4.4529e-07,
                    4.9727e-07,
                    5.4934e-07,
                    6.0147e-07,
                    6.5366e-07,
                    7.0588e-07,
                    7.5813e-07,
                    8.1041e-07,
                    8.6273e-07,
                    9.151e-07,
                    9.6755e-07,
                    1.0201e-06,
                    1.0735e-06,
                    1.1292e-06,
                    1.1881e-06,
                    1.2509e-06,
                    1.3182e-06,
                    1.39e-06,
                    1.466e-06,
                    1.5458e-06,
                    1.6284e-06,
                    1.7129e-06,
                    1.7984e-06,
                    1.8847e-06,
                    1.9717e-06,
                    2.0593e-06,
                    2.1475e-06,
                    2.2362e-06,
                    2.3254e-06,
                    2.4151e-06,
                    2.5055e-06,
                    2.6006e-06,
                    2.6966e-06,
                    2.7935e-06,
                    2.8915e-06,
                    2.9904e-06,
                    3.0905e-06,
                    3.1916e-06,
                    3.2939e-06,
                    3.3974e-06,
                    3.5021e-06,
                    3.608e-06,
                    3.7152e-06,
                    3.8235e-06,
                    3.9329e-06,
                    4.0436e-06,
                    4.1555e-06,
                    4.2688e-06,
                    4.3837e-06,
                    4.5003e-06,
                    4.6189e-06,
                    4.7397e-06,
                    4.864e-06,
                    4.9932e-06,
                    5.129e-06,
                    5.2723e-06,
                    5.4239e-06,
                    5.5843e-06,
                    5.7538e-06,
                    5.9321e-06,
                    6.119e-06,
                    6.3138e-06,
                    6.5165e-06,
                    6.7282e-06,
                    6.9494e-06,
                    7.1804e-06,
                    7.4207e-06,
                    7.6698e-06,
                    7.9264e-06,
                    8.189e-06,
                    8.4556e-06,
                    8.7238e-06,
                    8.9911e-06,
                    9.2557e-06,
                    9.5161e-06,
                    9.7714e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            16.19199,
                            2.22051
                        ],
                        [
                            16.14793,
                            2.35048
                        ],
                        [
                            16.07648,
                            2.46385
                        ],
                        [
                            16.08465,
                            2.59549
                        ],
                        [
                            16.05137,
                            2.7894
                        ],
                        [
                            16.0869,
                            2.86023
                        ],
                        [
                            16.00397,
                            3.00035
                        ],
                        [
                            15.96817,
                            2.98904
                        ],
                        [
                            15.88696,
                            3.09662
                        ],
                        [
                            15.8022,
                            3.09632
                        ],
                        [
                            15.50935,
                            3.4381
                        ],
                        [
                            15.24759,
                            3.71448
                        ],
                        [
                            15.10816,
                            3.94336
                        ],
                        [
                            15.09116,
                            3.994
                        ],
                        [
                            15.15002,
                            4.06597
                        ],
                        [
                            15.10733,
                            4.13629
                        ],
                        [
                            15.08664,
                            4.30542
                        ],
                        [
                            15.01524,
                            4.4165
                        ],
                        [
                            14.89063,
                            4.46743
                        ],
                        [
                            14.73292,
                            4.60942
                        ],
                        [
                            14.71477,
                            4.77083
                        ],
                        [
                            14.71565,
                            4.86468
                        ],
                        [
                            14.68721,
                            4.92665
                        ],
                        [
                            14.69468,
                            5.0983
                        ],
                        [
                            14.65061,
                            5.21075
                        ],
                        [
                            14.57604,
                            5.2283
                        ],
                        [
                            14.52942,
                            5.27593
                        ],
                        [
                            14.6297,
                            5.50729
                        ],
                        [
                            14.59655,
                            5.60163
                        ],
                        [
                            14.62833,
                            5.70423
                        ],
                        [
                            14.62094,
                            5.89514
                        ],
                        [
                            14.58968,
                            5.91789
                        ],
                        [
                            14.49374,
                            5.91574
                        ],
                        [
                            14.42103,
                            6.03983
                        ],
                        [
                            14.56057,
                            6.18861
                        ],
                        [
                            14.75079,
                            6.26187
                        ],
                        [
                            14.81404,
                            6.35761
                        ],
                        [
                            14.81436,
                            6.41032
                        ],
                        [
                            14.96774,
                            6.74447
                        ],
                        [
                            15.06748,
                            6.77846
                        ],
                        [
                            15.1434,
                            6.94516
                        ],
                        [
                            15.14857,
                            7.02676
                        ],
                        [
                            15.19711,
                            7.07197
                        ],
                        [
                            15.22416,
                            7.13546
                        ],
                        [
                            15.21767,
                            7.22469
                        ],
                        [
                            15.25121,
                            7.27347
                        ],
                        [
                            15.42742,
                            7.41503
                        ],
                        [
                            15.50748,
                            7.52747
                        ],
                        [
                            15.57288,
                            7.59081
                        ],
                        [
                            15.59736,
                            7.68738
                        ],
                        [
                            15.59634,
                            7.76702
                        ],
                        [
                            15.51112,
                            7.79689
                        ],
                        [
                            15.4545,
                            7.89235
                        ],
                        [
                            15.3924,
                            8.03726
                        ],
                        [
                            15.39628,
                            8.09177
                        ],
                        [
                            15.28645,
                            8.30974
                        ],
                        [
                            15.20817,
                            8.60788
                        ],
                        [
                            15.10832,
                            8.67223
                        ],
                        [
                            14.98816,
                            8.67913
                        ],
                        [
                            14.98827,
                            8.71617
                        ],
                        [
                            14.89834,
                            8.80718
                        ],
                        [
                            14.75568,
                            8.81911
                        ],
                        [
                            14.56098,
                            9.01059
                        ],
                        [
                            14.50624,
                            9.03728
                        ],
                        [
                            14.49022,
                            9.09495
                        ],
                        [
                            14.37998,
                            9.1996
                        ],
                        [
                            14.39219,
                            9.26634
                        ],
                        [
                            14.31786,
                            9.36464
                        ],
                        [
                            14.25206,
                            9.39099
                        ],
                        [
                            14.18988,
                            9.47744
                        ],
                        [
                            14.13302,
                            9.51132
                        ],
                        [
                            14.0229,
                            9.64873
                        ],
                        [
                            14.03892,
                            9.73729
                        ],
                        [
                            14.17644,
                            9.89942
                        ],
                        [
                            14.20956,
                            9.98872
                        ],
                        [
                            14.30545,
                            10.00326
                        ],
                        [
                            14.48394,
                            10.00978
                        ],
                        [
                            14.70416,
                            9.95038
                        ],
                        [
                            14.83555,
                            9.92473
                        ],
                        [
                            14.91775,
                            9.9786
                        ],
                        [
                            14.98803,
                            10.00084
                        ],
                        [
                            15.09827,
                            9.96446
                        ],
                        [
                            15.14009,
                            9.99429
                        ],
                        [
                            15.21032,
                            9.96559
                        ],
                        [
                            15.23986,
                            9.99491
                        ],
                        [
                            15.43719,
                            9.93376
                        ],
                        [
                            15.59001,
                            9.95801
                        ],
                        [
                            15.6753,
                            10.00626
                        ],
                        [
                            15.48601,
                            10.1213
                        ],
                        [
                            15.45191,
                            10.18635
                        ],
                        [
                            15.3544,
                            10.29071
                        ],
                        [
                            15.31065,
                            10.30944
                        ],
                        [
                            15.28147,
                            10.40403
                        ],
                        [
                            15.23872,
                            10.47301
                        ],
                        [
                            15.1471,
                            10.53778
                        ],
                        [
                            15.15463,
                            10.64374
                        ],
                        [
                            15.06954,
                            10.80709
                        ],
                        [
                            15.09267,
                            10.86686
                        ],
                        [
                            15.08263,
                            10.94645
                        ],
                        [
                            15.05123,
                            10.99584
                        ],
                        [
                            15.02667,
                            11.13507
                        ],
                        [
                            15.02759,
                            11.28086
                        ],
                        [
                            15.06841,
                            11.36724
                        ],
                        [
                            15.05951,
                            11.40961
                        ],
                        [
                            15.14173,
                            11.55649
                        ],
                        [
                            15.10016,
                            11.58488
                        ],
                        [
                            15.06893,
                            11.72439
                        ],
                        [
                            15.11832,
                            11.79393
                        ],
                        [
                            15.04211,
                            11.8987
                        ],
                        [
                            15.08126,
                            11.99966
                        ],
                        [
                            15.01025,
                            12.11175
                        ],
                        [
                            14.93274,
                            12.11517
                        ],
                        [
                            14.89325,
                            12.16782
                        ],
                        [
                            14.91018,
                            12.37957
                        ],
                        [
                            14.85794,
                            12.4844
                        ],
                        [
                            14.83222,
                            12.62662
                        ],
                        [
                            14.77302,
                            12.63141
                        ],
                        [
                            14.70457,
                            12.72452
                        ],
                        [
                            14.58549,
                            12.74843
                        ],
                        [
                            14.55185,
                            12.7871
                        ],
                        [
                            14.56871,
                            12.89186
                        ],
                        [
                            14.53335,
                            12.96895
                        ],
                        [
                            14.45989,
                            13.07441
                        ],
                        [
                            14.08543,
                            13.07806
                        ],
                        [
                            14.20303,
                            12.53883
                        ],
                        [
                            14.17485,
                            12.40999
                        ],
                        [
                            14.22328,
                            12.36207
                        ],
                        [
                            14.32975,
                            12.37501
                        ],
                        [
                            14.46337,
                            12.35948
                        ],
                        [
                            14.51409,
                            12.32911
                        ],
                        [
                            14.54991,
                            12.2373
                        ],
                        [
                            14.65828,
                            12.19661
                        ],
                        [
                            14.67475,
                            12.15741
                        ],
                        [
                            14.62312,
                            12.04397
                        ],
                        [
                            14.65508,
                            11.96176
                        ],
                        [
                            14.60578,
                            11.86958
                        ],
                        [
                            14.61467,
                            11.7834
                        ],
                        [
                            14.55422,
                            11.71427
                        ],
                        [
                            14.64088,
                            11.65558
                        ],
                        [
                            14.64561,
                            11.58208
                        ],
                        [
                            14.61246,
                            11.51119
                        ],
                        [
                            14.56726,
                            11.47986
                        ],
                        [
                            14.45992,
                            11.46369
                        ],
                        [
                            14.38592,
                            11.42674
                        ],
                        [
                            14.36973,
                            11.36667
                        ],
                        [
                            14.178,
                            11.24031
                        ],
                        [
                            14.00557,
                            11.30578
                        ],
                        [
                            13.94813,
                            11.24097
                        ],
                        [
                            13.79351,
                            11.00726
                        ],
                        [
                            13.74104,
                            11.005
                        ],
                        [
                            13.71221,
                            10.95467
                        ],
                        [
                            13.71798,
                            10.86629
                        ],
                        [
                            13.64872,
                            10.8065
                        ],
                        [
                            13.62547,
                            10.71081
                        ],
                        [
                            13.58225,
                            10.68712
                        ],
                        [
                            13.56804,
                            10.56187
                        ],
                        [
                            13.52131,
                            10.45247
                        ],
                        [
                            13.54123,
                            10.35934
                        ],
                        [
                            13.49879,
                            10.20796
                        ],
                        [
                            13.42661,
                            10.15555
                        ],
                        [
                            13.43008,
                            10.12122
                        ],
                        [
                            13.31324,
                            10.10616
                        ],
                        [
                            13.25082,
                            10.001
                        ],
                        [
                            13.2871,
                            9.9712
                        ],
                        [
                            13.23813,
                            9.91105
                        ],
                        [
                            13.24707,
                            9.86101
                        ],
                        [
                            13.29985,
                            9.82572
                        ],
                        [
                            13.26106,
                            9.77473
                        ],
                        [
                            13.23446,
                            9.62019
                        ],
                        [
                            13.20826,
                            9.5582
                        ],
                        [
                            13.03256,
                            9.50364
                        ],
                        [
                            12.93817,
                            9.41759
                        ],
                        [
                            12.90439,
                            9.35329
                        ],
                        [
                            12.9151,
                            9.24816
                        ],
                        [
                            12.89058,
                            9.18048
                        ],
                        [
                            12.89786,
                            9.11608
                        ],
                        [
                            12.86421,
                            9.01769
                        ],
                        [
                            12.82467,
                            8.97184
                        ],
                        [
                            12.78438,
                            8.74932
                        ],
                        [
                            12.71981,
                            8.75935
                        ],
                        [
                            12.69643,
                            8.66792
                        ],
                        [
                            12.61218,
                            8.63612
                        ],
                        [
                            12.59973,
                            8.59418
                        ],
                        [
                            12.50301,
                            8.64042
                        ],
                        [
                            12.4367,
                            8.6184
                        ],
                        [
                            12.45543,
                            8.55452
                        ],
                        [
                            12.41253,
                            8.5378
                        ],
                        [
                            12.40485,
                            8.47145
                        ],
                        [
                            12.36773,
                            8.42467
                        ],
                        [
                            12.26193,
                            8.44107
                        ],
                        [
                            12.24197,
                            8.36552
                        ],
                        [
                            12.23375,
                            8.16541
                        ],
                        [
                            12.19211,
                            8.1012
                        ],
                        [
                            12.2095,
                            7.98806
                        ],
                        [
                            12.19042,
                            7.9404
                        ],
                        [
                            12.07052,
                            7.79378
                        ],
                        [
                            12.01475,
                            7.681
                        ],
                        [
                            12.00657,
                            7.58116
                        ],
                        [
                            12.0219,
                            7.52738
                        ],
                        [
                            11.91763,
                            7.4691
                        ],
                        [
                            11.92584,
                            7.39378
                        ],
                        [
                            11.84458,
                            7.26962
                        ],
                        [
                            11.86435,
                            7.07841
                        ],
                        [
                            11.80254,
                            7.07983
                        ],
                        [
                            11.63513,
                            6.98849
                        ],
                        [
                            11.60534,
                            6.91322
                        ],
                        [
                            11.55554,
                            6.8607
                        ],
                        [
                            11.58917,
                            6.80261
                        ],
                        [
                            11.55164,
                            6.66585
                        ],
                        [
                            11.49397,
                            6.60101
                        ],
                        [
                            11.41589,
                            6.5971
                        ],
                        [
                            11.42377,
                            6.53228
                        ],
                        [
                            11.31727,
                            6.50771
                        ],
                        [
                            11.27502,
                            6.53606
                        ],
                        [
                            11.20121,
                            6.53555
                        ],
                        [
                            11.16704,
                            6.50181
                        ],
                        [
                            11.09561,
                            6.53277
                        ],
                        [
                            11.09528,
                            6.6712
                        ],
                        [
                            11.06703,
                            6.70747
                        ],
                        [
                            10.98734,
                            6.68752
                        ],
                        [
                            10.9203,
                            6.70684
                        ],
                        [
                            10.91304,
                            6.75487
                        ],
                        [
                            10.8375,
                            6.81364
                        ],
                        [
                            10.81611,
                            6.85699
                        ],
                        [
                            10.83759,
                            6.936
                        ],
                        [
                            10.76224,
                            6.95854
                        ],
                        [
                            10.59769,
                            7.07807
                        ],
                        [
                            10.55985,
                            7.03013
                        ],
                        [
                            10.54095,
                            6.94247
                        ],
                        [
                            10.49012,
                            6.87285
                        ],
                        [
                            10.21791,
                            6.88687
                        ],
                        [
                            10.17516,
                            6.93998
                        ],
                        [
                            10.15068,
                            7.03571
                        ],
                        [
                            9.86938,
                            6.77546
                        ],
                        [
                            9.77819,
                            6.78978
                        ],
                        [
                            9.75168,
                            6.65526
                        ],
                        [
                            9.70377,
                            6.51255
                        ],
                        [
                            9.59886,
                            6.52754
                        ],
                        [
                            9.58381,
                            6.47693
                        ],
                        [
                            9.52575,
                            6.44616
                        ],
                        [
                            9.46579,
                            6.45205
                        ],
                        [
                            9.43209,
                            6.31915
                        ],
                        [
                            9.34673,
                            6.35033
                        ],
                        [
                            9.3333,
                            6.29216
                        ],
                        [
                            9.26422,
                            6.18568
                        ],
                        [
                            9.17251,
                            6.13084
                        ],
                        [
                            9.14877,
                            6.08911
                        ],
                        [
                            8.84438,
                            5.82509
                        ],
                        [
                            8.88024,
                            5.79729
                        ],
                        [
                            8.83492,
                            5.69362
                        ],
                        [
                            8.90338,
                            5.61798
                        ],
                        [
                            8.91791,
                            5.56427
                        ],
                        [
                            8.8357,
                            5.43308
                        ],
                        [
                            8.81612,
                            5.27964
                        ],
                        [
                            8.81867,
                            5.18189
                        ],
                        [
                            8.75051,
                            5.10128
                        ],
                        [
                            8.69557,
                            4.98723
                        ],
                        [
                            8.62202,
                            4.90613
                        ],
                        [
                            8.61678,
                            4.81776
                        ],
                        [
                            8.54933,
                            4.76645
                        ],
                        [
                            8.55899,
                            4.68002
                        ],
                        [
                            8.50158,
                            4.60942
                        ],
                        [
                            8.51057,
                            4.50814
                        ],
                        [
                            8.57063,
                            4.48573
                        ],
                        [
                            8.68772,
                            4.48535
                        ],
                        [
                            8.79281,
                            4.56002
                        ],
                        [
                            8.74987,
                            4.65132
                        ],
                        [
                            8.82385,
                            4.63487
                        ],
                        [
                            8.88121,
                            4.58071
                        ],
                        [
                            8.90014,
                            4.45383
                        ],
                        [
                            8.88681,
                            4.39379
                        ],
                        [
                            8.91913,
                            4.28436
                        ],
                        [
                            8.99312,
                            4.19611
                        ],
                        [
                            8.98384,
                            4.09496
                        ],
                        [
                            9.11604,
                            4.01145
                        ],
                        [
                            9.18981,
                            4.01091
                        ],
                        [
                            9.24491,
                            3.94659
                        ],
                        [
                            9.28715,
                            3.97269
                        ],
                        [
                            9.34561,
                            3.91148
                        ],
                        [
                            9.43615,
                            3.89144
                        ],
                        [
                            9.45795,
                            3.96906
                        ],
                        [
                            9.4411,
                            4.01226
                        ],
                        [
                            9.48928,
                            4.07332
                        ],
                        [
                            9.54063,
                            4.01941
                        ],
                        [
                            9.65156,
                            4.01035
                        ],
                        [
                            9.62559,
                            3.96494
                        ],
                        [
                            9.71026,
                            3.86019
                        ],
                        [
                            9.61384,
                            3.86103
                        ],
                        [
                            9.57745,
                            3.79543
                        ],
                        [
                            9.64901,
                            3.64146
                        ],
                        [
                            9.63369,
                            3.55912
                        ],
                        [
                            9.76674,
                            3.44653
                        ],
                        [
                            9.87748,
                            3.32487
                        ],
                        [
                            9.97219,
                            3.09088
                        ],
                        [
                            9.95476,
                            3.01911
                        ],
                        [
                            9.91555,
                            2.97509
                        ],
                        [
                            9.88482,
                            2.84791
                        ],
                        [
                            9.8918,
                            2.80018
                        ],
                        [
                            9.82554,
                            2.56972
                        ],
                        [
                            9.82147,
                            2.34785
                        ],
                        [
                            9.84719,
                            2.24875
                        ],
                        [
                            9.92555,
                            2.20031
                        ],
                        [
                            10.03896,
                            2.16273
                        ],
                        [
                            10.1938,
                            2.17256
                        ],
                        [
                            10.79315,
                            2.17398
                        ],
                        [
                            11.33461,
                            2.17389
                        ],
                        [
                            11.39178,
                            2.3028
                        ],
                        [
                            11.6111,
                            2.30012
                        ],
                        [
                            11.69633,
                            2.32228
                        ],
                        [
                            11.75378,
                            2.27449
                        ],
                        [
                            11.97994,
                            2.29001
                        ],
                        [
                            12.1523,
                            2.27332
                        ],
                        [
                            12.24312,
                            2.25075
                        ],
                        [
                            12.32756,
                            2.27636
                        ],
                        [
                            12.45339,
                            2.25281
                        ],
                        [
                            12.49488,
                            2.26035
                        ],
                        [
                            12.68702,
                            2.24229
                        ],
                        [
                            12.7457,
                            2.22381
                        ],
                        [
                            12.79657,
                            2.24759
                        ],
                        [
                            12.87347,
                            2.23077
                        ],
                        [
                            12.93491,
                            2.25236
                        ],
                        [
                            13.07641,
                            2.24842
                        ],
                        [
                            13.1605,
                            2.28296
                        ],
                        [
                            13.28632,
                            2.24846
                        ],
                        [
                            13.29897,
                            2.17056
                        ],
                        [
                            13.86248,
                            2.17255
                        ],
                        [
                            14.24567,
                            2.17169
                        ],
                        [
                            14.30992,
                            2.19023
                        ],
                        [
                            14.39575,
                            2.18266
                        ],
                        [
                            14.43165,
                            2.15605
                        ],
                        [
                            14.55655,
                            2.21026
                        ],
                        [
                            14.61047,
                            2.19259
                        ],
                        [
                            14.65165,
                            2.12924
                        ],
                        [
                            14.72968,
                            2.12163
                        ],
                        [
                            14.80978,
                            2.05907
                        ],
                        [
                            14.86639,
                            2.08003
                        ],
                        [
                            14.98727,
                            2.0321
                        ],
                        [
                            15.0508,
                            1.97975
                        ],
                        [
                            15.19603,
                            2.0334
                        ],
                        [
                            15.25043,
                            2.02606
                        ],
                        [
                            15.34564,
                            1.91173
                        ],
                        [
                            15.49048,
                            1.97537
                        ],
                        [
                            15.52691,
                            1.95368
                        ],
                        [
                            15.68899,
                            1.93223
                        ],
                        [
                            15.76914,
                            1.90438
                        ],
                        [
                            15.8069,
                            1.85342
                        ],
                        [
                            15.87021,
                            1.82281
                        ],
                        [
                            15.88707,
                            1.7805
                        ],
                        [
                            16.02349,
                            1.76536
                        ],
                        [
                            16.03162,
                            1.65845
                        ],
                        [
                            16.15242,
                            1.70349
                        ],
                        [
                            16.11293,
                            1.86914
                        ],
                        [
                            16.05649,
                            2.0021
                        ],
                        [
                            16.08287,
                            2.0476
                        ],
                        [
                            16.08498,
                            2.18552
                        ],
                        [
                            16.14129,
                            2.17672
                        ],
                        [
                            16.19199,
                            2.22051
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "CAN",
                "Country": "Canada",
                "Total_3GHG": 2.13,
                "Total_3GHG_timeseries": [
                    0,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0043,
                    0.0044,
                    0.0046,
                    0.0048,
                    0.0049,
                    0.0051,
                    0.0053,
                    0.0055,
                    0.0056,
                    0.0058,
                    0.006,
                    0.0061,
                    0.0063,
                    0.0065,
                    0.0066,
                    0.0068,
                    0.007,
                    0.0071,
                    0.0073,
                    0.0075,
                    0.0076,
                    0.0078,
                    0.008,
                    0.0081,
                    0.0083,
                    0.0084,
                    0.0086,
                    0.0088,
                    0.0089,
                    0.0091,
                    0.0093,
                    0.0095,
                    0.0097,
                    0.0098,
                    0.01,
                    0.0102,
                    0.0104,
                    0.0106,
                    0.0108,
                    0.011,
                    0.0112,
                    0.0114,
                    0.0117,
                    0.0119,
                    0.0121,
                    0.0124,
                    0.0127,
                    0.0129,
                    0.0132,
                    0.0134,
                    0.0137,
                    0.0139,
                    0.0142,
                    0.0145,
                    0.0147,
                    0.015,
                    0.0153,
                    0.0156,
                    0.0159,
                    0.0162,
                    0.0165,
                    0.0168,
                    0.0172,
                    0.0175,
                    0.0178,
                    0.0182,
                    0.0185,
                    0.0189,
                    0.0192,
                    0.0196,
                    0.0199,
                    0.0202,
                    0.0205,
                    0.0209,
                    0.0212,
                    0.0215,
                    0.0218,
                    0.0222,
                    0.0225,
                    0.0228,
                    0.0232,
                    0.0235,
                    0.0238,
                    0.0242,
                    0.0246,
                    0.0249,
                    0.0253,
                    0.0257,
                    0.0261,
                    0.0266,
                    0.027,
                    0.0274,
                    0.0279,
                    0.0283,
                    0.0287,
                    0.0292,
                    0.0296,
                    0.03,
                    0.0303,
                    0.0307,
                    0.0311,
                    0.0314,
                    0.0318,
                    0.0322,
                    0.0326,
                    0.0329,
                    0.0333,
                    0.0336,
                    0.034,
                    0.0342,
                    0.0345,
                    0.0348
                ],
                "Fossil_3GHG": 1.91,
                "Fossil_3GHG_timeseries": [
                    7.2423e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0047,
                    0.0048,
                    0.005,
                    0.0052,
                    0.0054,
                    0.0056,
                    0.0058,
                    0.006,
                    0.0063,
                    0.0065,
                    0.0068,
                    0.007,
                    0.0073,
                    0.0075,
                    0.0078,
                    0.008,
                    0.0083,
                    0.0085,
                    0.0088,
                    0.009,
                    0.0093,
                    0.0095,
                    0.0097,
                    0.01,
                    0.0103,
                    0.0105,
                    0.0108,
                    0.011,
                    0.0113,
                    0.0116,
                    0.0119,
                    0.0122,
                    0.0125,
                    0.0128,
                    0.0131,
                    0.0134,
                    0.0138,
                    0.0141,
                    0.0145,
                    0.0148,
                    0.0151,
                    0.0155,
                    0.0158,
                    0.0161,
                    0.0164,
                    0.0167,
                    0.0171,
                    0.0174,
                    0.0177,
                    0.018,
                    0.0183,
                    0.0186,
                    0.0189,
                    0.0192,
                    0.0195,
                    0.0197,
                    0.0199,
                    0.0202
                ],
                "Land_3GHG": 2.54,
                "Land_3GHG_timeseries": [
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0055,
                    0.0056,
                    0.0058,
                    0.0059,
                    0.006,
                    0.0061,
                    0.0062,
                    0.0064,
                    0.0065,
                    0.0066,
                    0.0067,
                    0.0068,
                    0.0069,
                    0.007,
                    0.0072,
                    0.0073,
                    0.0074,
                    0.0075,
                    0.0076,
                    0.0077,
                    0.0078,
                    0.0079,
                    0.008,
                    0.0082,
                    0.0083,
                    0.0084,
                    0.0086,
                    0.0087,
                    0.0088,
                    0.009,
                    0.0091,
                    0.0093,
                    0.0094,
                    0.0095,
                    0.0097,
                    0.0098,
                    0.0099,
                    0.01,
                    0.0102,
                    0.0103,
                    0.0104,
                    0.0105,
                    0.0106,
                    0.0107,
                    0.0108,
                    0.0109,
                    0.011,
                    0.0111,
                    0.0112,
                    0.0113,
                    0.0114,
                    0.0114,
                    0.0115,
                    0.0116,
                    0.0117,
                    0.0118,
                    0.0119,
                    0.0119,
                    0.012,
                    0.0121,
                    0.0122,
                    0.0122,
                    0.0123,
                    0.0124,
                    0.0125,
                    0.0125,
                    0.0126,
                    0.0127,
                    0.0128,
                    0.0129,
                    0.0129,
                    0.013,
                    0.0131,
                    0.0132,
                    0.0133,
                    0.0134,
                    0.0135,
                    0.0136,
                    0.0137,
                    0.0138,
                    0.0138,
                    0.0139,
                    0.014,
                    0.014,
                    0.0141,
                    0.0141,
                    0.0142,
                    0.0143,
                    0.0143,
                    0.0144,
                    0.0144,
                    0.0145,
                    0.0145,
                    0.0146,
                    0.0146
                ],
                "Total_CO2": 2.45,
                "Total_CO2_timeseries": [
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0042,
                    0.0043,
                    0.0045,
                    0.0046,
                    0.0048,
                    0.0049,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0055,
                    0.0056,
                    0.0058,
                    0.0059,
                    0.0061,
                    0.0062,
                    0.0063,
                    0.0065,
                    0.0066,
                    0.0068,
                    0.0069,
                    0.007,
                    0.0072,
                    0.0073,
                    0.0075,
                    0.0076,
                    0.0078,
                    0.0079,
                    0.0081,
                    0.0082,
                    0.0084,
                    0.0085,
                    0.0087,
                    0.0089,
                    0.009,
                    0.0092,
                    0.0094,
                    0.0095,
                    0.0097,
                    0.0099,
                    0.0101,
                    0.0103,
                    0.0105,
                    0.0107,
                    0.0109,
                    0.011,
                    0.0112,
                    0.0114,
                    0.0116,
                    0.0118,
                    0.012,
                    0.0122,
                    0.0124,
                    0.0126,
                    0.0128,
                    0.0131,
                    0.0133,
                    0.0135,
                    0.0138,
                    0.014,
                    0.0143,
                    0.0145,
                    0.0148,
                    0.015,
                    0.0153,
                    0.0156,
                    0.0158,
                    0.0161,
                    0.0163,
                    0.0166,
                    0.0169,
                    0.0171,
                    0.0174,
                    0.0177,
                    0.0179,
                    0.0182,
                    0.0185,
                    0.0187,
                    0.019,
                    0.0193,
                    0.0196,
                    0.0199,
                    0.0202,
                    0.0205,
                    0.0208,
                    0.0211,
                    0.0215,
                    0.0218,
                    0.0222,
                    0.0225,
                    0.0228,
                    0.0231,
                    0.0234,
                    0.0238,
                    0.024,
                    0.0243,
                    0.0246,
                    0.0249,
                    0.0252,
                    0.0255,
                    0.0258,
                    0.0261,
                    0.0264,
                    0.0267,
                    0.027,
                    0.0273,
                    0.0276,
                    0.0278
                ],
                "Fossil_CO2": 2.01,
                "Fossil_CO2_timeseries": [
                    3.135e-08,
                    6.93e-08,
                    1.155e-07,
                    1.716e-07,
                    2.3925e-07,
                    3.201e-07,
                    4.1745e-07,
                    5.3625e-07,
                    6.7815e-07,
                    8.4975e-07,
                    1.056e-06,
                    1.3084e-06,
                    1.6253e-06,
                    2.0048e-06,
                    2.4635e-06,
                    3.0228e-06,
                    3.7406e-06,
                    4.1663e-06,
                    4.4748e-06,
                    5.0259e-06,
                    5.8278e-06,
                    6.6594e-06,
                    7.3838e-06,
                    8.1147e-06,
                    8.9595e-06,
                    9.796e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.004,
                    0.0041,
                    0.0043,
                    0.0045,
                    0.0047,
                    0.0048,
                    0.005,
                    0.0052,
                    0.0054,
                    0.0056,
                    0.0058,
                    0.006,
                    0.0062,
                    0.0064,
                    0.0065,
                    0.0067,
                    0.0069,
                    0.0071,
                    0.0073,
                    0.0075,
                    0.0077,
                    0.0079,
                    0.0081,
                    0.0084,
                    0.0086,
                    0.0088,
                    0.009,
                    0.0093,
                    0.0095,
                    0.0097,
                    0.01,
                    0.0102,
                    0.0105,
                    0.0108,
                    0.011,
                    0.0113,
                    0.0115,
                    0.0118,
                    0.0121,
                    0.0123,
                    0.0126,
                    0.0128,
                    0.0131,
                    0.0133,
                    0.0136,
                    0.0138,
                    0.0141,
                    0.0143,
                    0.0146,
                    0.0149,
                    0.0151,
                    0.0153,
                    0.0156
                ],
                "Land_CO2": 3.41,
                "Land_CO2_timeseries": [
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0055,
                    0.0056,
                    0.0057,
                    0.0058,
                    0.0059,
                    0.006,
                    0.0061,
                    0.0062,
                    0.0063,
                    0.0064,
                    0.0065,
                    0.0066,
                    0.0067,
                    0.0068,
                    0.0069,
                    0.007,
                    0.007,
                    0.0071,
                    0.0072,
                    0.0074,
                    0.0075,
                    0.0076,
                    0.0077,
                    0.0078,
                    0.0079,
                    0.008,
                    0.0081,
                    0.0082,
                    0.0083,
                    0.0084,
                    0.0085,
                    0.0086,
                    0.0087,
                    0.0088,
                    0.0088,
                    0.0089,
                    0.009,
                    0.0091,
                    0.0091,
                    0.0092,
                    0.0093,
                    0.0094,
                    0.0094,
                    0.0095,
                    0.0096,
                    0.0096,
                    0.0097,
                    0.0098,
                    0.0099,
                    0.0099,
                    0.01,
                    0.0101,
                    0.0101,
                    0.0102,
                    0.0103,
                    0.0103,
                    0.0104,
                    0.0105,
                    0.0105,
                    0.0106,
                    0.0107,
                    0.0107,
                    0.0108,
                    0.0109,
                    0.0109,
                    0.011,
                    0.0111,
                    0.0112,
                    0.0112,
                    0.0113,
                    0.0114,
                    0.0115,
                    0.0115,
                    0.0116,
                    0.0116,
                    0.0117,
                    0.0117,
                    0.0118,
                    0.0118,
                    0.0118,
                    0.0119,
                    0.0119,
                    0.012,
                    0.012,
                    0.0121,
                    0.0121,
                    0.0122,
                    0.0122,
                    0.0122,
                    0.0123
                ],
                "Total_CH4": 1.32,
                "Total_CH4_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.004,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0051,
                    0.0052,
                    0.0052,
                    0.0053,
                    0.0053,
                    0.0054,
                    0.0054,
                    0.0055,
                    0.0055,
                    0.0055,
                    0.0055,
                    0.0055,
                    0.0055
                ],
                "Fossil_CH4": 1.6,
                "Fossil_CH4_timeseries": [
                    6.8113e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.004,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0042,
                    0.0042
                ],
                "Land_CH4": 0.85,
                "Land_CH4_timeseries": [
                    3.2381e-06,
                    6.6186e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0013,
                    0.0013
                ],
                "Total_N2O": 1.79,
                "Total_N2O_timeseries": [
                    1.4066e-06,
                    2.8381e-06,
                    4.2937e-06,
                    5.772e-06,
                    7.2714e-06,
                    8.7898e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015
                ],
                "Fossil_N2O": 1.95,
                "Fossil_N2O_timeseries": [
                    3.9962e-07,
                    8.0408e-07,
                    1.2133e-06,
                    1.6272e-06,
                    2.0456e-06,
                    2.4684e-06,
                    2.8953e-06,
                    3.3262e-06,
                    3.7608e-06,
                    4.1989e-06,
                    4.6402e-06,
                    5.0847e-06,
                    5.5324e-06,
                    5.9833e-06,
                    6.4373e-06,
                    6.8945e-06,
                    7.3548e-06,
                    7.8183e-06,
                    8.2851e-06,
                    8.7551e-06,
                    9.2299e-06,
                    9.712e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Land_N2O": 1.73,
                "Land_N2O_timeseries": [
                    1.0069e-06,
                    2.034e-06,
                    3.0804e-06,
                    4.1448e-06,
                    5.2258e-06,
                    6.3214e-06,
                    7.4296e-06,
                    8.5477e-06,
                    9.673e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -67.27016,
                                45.18856
                            ],
                            [
                                -67.06288,
                                45.12247
                            ],
                            [
                                -66.98954,
                                45.14893
                            ],
                            [
                                -66.90238,
                                45.13053
                            ],
                            [
                                -66.91509,
                                45.06873
                            ],
                            [
                                -66.74445,
                                45.0538
                            ],
                            [
                                -66.58179,
                                45.12289
                            ],
                            [
                                -66.46953,
                                45.12891
                            ],
                            [
                                -66.46574,
                                45.07101
                            ],
                            [
                                -66.32915,
                                45.12533
                            ],
                            [
                                -66.18248,
                                45.16052
                            ],
                            [
                                -66.15416,
                                45.2153
                            ],
                            [
                                -66.04262,
                                45.27504
                            ],
                            [
                                -65.92042,
                                45.19792
                            ],
                            [
                                -65.80626,
                                45.2596
                            ],
                            [
                                -65.56272,
                                45.31099
                            ],
                            [
                                -65.53174,
                                45.3523
                            ],
                            [
                                -65.33905,
                                45.44782
                            ],
                            [
                                -65.13381,
                                45.52018
                            ],
                            [
                                -65.03493,
                                45.5379
                            ],
                            [
                                -64.86652,
                                45.62935
                            ],
                            [
                                -64.7759,
                                45.60054
                            ],
                            [
                                -64.69229,
                                45.68875
                            ],
                            [
                                -64.66448,
                                45.74854
                            ],
                            [
                                -64.56944,
                                45.83384
                            ],
                            [
                                -64.42611,
                                45.79181
                            ],
                            [
                                -64.35298,
                                45.87078
                            ],
                            [
                                -64.27943,
                                45.84313
                            ],
                            [
                                -64.44444,
                                45.73837
                            ],
                            [
                                -64.45764,
                                45.68414
                            ],
                            [
                                -64.68695,
                                45.53821
                            ],
                            [
                                -64.84226,
                                45.47867
                            ],
                            [
                                -64.92632,
                                45.40724
                            ],
                            [
                                -64.93051,
                                45.32967
                            ],
                            [
                                -64.83418,
                                45.35183
                            ],
                            [
                                -64.75699,
                                45.30695
                            ],
                            [
                                -64.68735,
                                45.37596
                            ],
                            [
                                -64.56071,
                                45.4056
                            ],
                            [
                                -64.39279,
                                45.36734
                            ],
                            [
                                -64.32282,
                                45.39708
                            ],
                            [
                                -64.10059,
                                45.40711
                            ],
                            [
                                -63.91906,
                                45.37777
                            ],
                            [
                                -63.75315,
                                45.39943
                            ],
                            [
                                -63.60916,
                                45.39303
                            ],
                            [
                                -63.4503,
                                45.3656
                            ],
                            [
                                -63.4895,
                                45.31258
                            ],
                            [
                                -63.76915,
                                45.31493
                            ],
                            [
                                -64.16826,
                                45.18689
                            ],
                            [
                                -64.18628,
                                45.10223
                            ],
                            [
                                -64.33446,
                                45.12768
                            ],
                            [
                                -64.38095,
                                45.19865
                            ],
                            [
                                -64.33025,
                                45.2728
                            ],
                            [
                                -64.40163,
                                45.28016
                            ],
                            [
                                -64.46123,
                                45.24404
                            ],
                            [
                                -64.76017,
                                45.16957
                            ],
                            [
                                -64.95072,
                                45.10131
                            ],
                            [
                                -65.65401,
                                44.76184
                            ],
                            [
                                -65.74317,
                                44.70969
                            ],
                            [
                                -65.60648,
                                44.67669
                            ],
                            [
                                -65.68005,
                                44.61818
                            ],
                            [
                                -65.74871,
                                44.60322
                            ],
                            [
                                -65.79456,
                                44.68685
                            ],
                            [
                                -65.91394,
                                44.61407
                            ],
                            [
                                -65.85421,
                                44.55974
                            ],
                            [
                                -65.96456,
                                44.48847
                            ],
                            [
                                -66.11391,
                                44.34579
                            ],
                            [
                                -66.1396,
                                44.22997
                            ],
                            [
                                -66.2091,
                                44.10874
                            ],
                            [
                                -66.18083,
                                44.07237
                            ],
                            [
                                -66.15346,
                                43.93231
                            ],
                            [
                                -66.16686,
                                43.86328
                            ],
                            [
                                -66.12315,
                                43.74425
                            ],
                            [
                                -65.99402,
                                43.77727
                            ],
                            [
                                -65.92032,
                                43.82694
                            ],
                            [
                                -65.84128,
                                43.74098
                            ],
                            [
                                -65.82065,
                                43.65811
                            ],
                            [
                                -65.76881,
                                43.63189
                            ],
                            [
                                -65.78441,
                                43.56528
                            ],
                            [
                                -65.72865,
                                43.49576
                            ],
                            [
                                -65.61353,
                                43.52107
                            ],
                            [
                                -65.49713,
                                43.4905
                            ],
                            [
                                -65.43583,
                                43.54431
                            ],
                            [
                                -65.35802,
                                43.55602
                            ],
                            [
                                -65.32869,
                                43.67099
                            ],
                            [
                                -65.23659,
                                43.66263
                            ],
                            [
                                -65.22175,
                                43.70441
                            ],
                            [
                                -65.14428,
                                43.73539
                            ],
                            [
                                -65.04196,
                                43.70147
                            ],
                            [
                                -64.9272,
                                43.79747
                            ],
                            [
                                -64.78553,
                                43.86871
                            ],
                            [
                                -64.83908,
                                43.92523
                            ],
                            [
                                -64.66586,
                                43.99268
                            ],
                            [
                                -64.65696,
                                44.04355
                            ],
                            [
                                -64.57388,
                                44.0634
                            ],
                            [
                                -64.42941,
                                44.22639
                            ],
                            [
                                -64.37205,
                                44.25942
                            ],
                            [
                                -64.2517,
                                44.26148
                            ],
                            [
                                -64.30226,
                                44.33721
                            ],
                            [
                                -64.23824,
                                44.39062
                            ],
                            [
                                -64.33134,
                                44.40801
                            ],
                            [
                                -64.31323,
                                44.54044
                            ],
                            [
                                -64.12051,
                                44.54034
                            ],
                            [
                                -64.11144,
                                44.48159
                            ],
                            [
                                -64.00877,
                                44.51842
                            ],
                            [
                                -64.05898,
                                44.5881
                            ],
                            [
                                -63.96664,
                                44.66335
                            ],
                            [
                                -63.93164,
                                44.63936
                            ],
                            [
                                -63.94574,
                                44.52762
                            ],
                            [
                                -63.91543,
                                44.49365
                            ],
                            [
                                -63.79091,
                                44.47044
                            ],
                            [
                                -63.58338,
                                44.46198
                            ],
                            [
                                -63.5232,
                                44.50581
                            ],
                            [
                                -63.57676,
                                44.65281
                            ],
                            [
                                -63.45203,
                                44.5946
                            ],
                            [
                                -63.41067,
                                44.64615
                            ],
                            [
                                -63.29051,
                                44.63528
                            ],
                            [
                                -63.24977,
                                44.67599
                            ],
                            [
                                -63.13421,
                                44.70677
                            ],
                            [
                                -62.90322,
                                44.73117
                            ],
                            [
                                -62.80476,
                                44.71966
                            ],
                            [
                                -62.7651,
                                44.77577
                            ],
                            [
                                -62.65895,
                                44.7879
                            ],
                            [
                                -62.50484,
                                44.86499
                            ],
                            [
                                -62.31794,
                                44.91222
                            ],
                            [
                                -62.24688,
                                44.96246
                            ],
                            [
                                -61.98712,
                                44.97952
                            ],
                            [
                                -61.90272,
                                45.05084
                            ],
                            [
                                -61.82927,
                                45.08296
                            ],
                            [
                                -61.65999,
                                45.09498
                            ],
                            [
                                -61.60096,
                                45.14819
                            ],
                            [
                                -61.46195,
                                45.1541
                            ],
                            [
                                -61.3219,
                                45.25271
                            ],
                            [
                                -61.19698,
                                45.24883
                            ],
                            [
                                -61.12756,
                                45.21145
                            ],
                            [
                                -61.05349,
                                45.24442
                            ],
                            [
                                -60.96616,
                                45.32228
                            ],
                            [
                                -61.01389,
                                45.3517
                            ],
                            [
                                -61.43512,
                                45.34862
                            ],
                            [
                                -61.38167,
                                45.41072
                            ],
                            [
                                -61.26411,
                                45.45491
                            ],
                            [
                                -61.24679,
                                45.51902
                            ],
                            [
                                -61.336,
                                45.54967
                            ],
                            [
                                -61.39927,
                                45.63096
                            ],
                            [
                                -61.49051,
                                45.69181
                            ],
                            [
                                -61.57061,
                                45.68804
                            ],
                            [
                                -61.6523,
                                45.63205
                            ],
                            [
                                -61.74262,
                                45.63382
                            ],
                            [
                                -61.91105,
                                45.6829
                            ],
                            [
                                -61.8918,
                                45.7373
                            ],
                            [
                                -61.92382,
                                45.84323
                            ],
                            [
                                -61.9768,
                                45.87353
                            ],
                            [
                                -62.0737,
                                45.79935
                            ],
                            [
                                -62.41797,
                                45.63909
                            ],
                            [
                                -62.48284,
                                45.61849
                            ],
                            [
                                -62.65522,
                                45.72707
                            ],
                            [
                                -62.78068,
                                45.76306
                            ],
                            [
                                -63.09292,
                                45.79727
                            ],
                            [
                                -63.10732,
                                45.76362
                            ],
                            [
                                -63.30408,
                                45.72666
                            ],
                            [
                                -63.36412,
                                45.74251
                            ],
                            [
                                -63.36632,
                                45.79944
                            ],
                            [
                                -63.47215,
                                45.87763
                            ],
                            [
                                -63.66879,
                                45.87419
                            ],
                            [
                                -63.80825,
                                45.89361
                            ],
                            [
                                -63.9102,
                                45.98218
                            ],
                            [
                                -64.09113,
                                46.02428
                            ],
                            [
                                -64.0564,
                                46.05479
                            ],
                            [
                                -63.92391,
                                46.05301
                            ],
                            [
                                -63.776,
                                46.10097
                            ],
                            [
                                -63.9772,
                                46.18131
                            ],
                            [
                                -64.06639,
                                46.17115
                            ],
                            [
                                -64.27164,
                                46.23477
                            ],
                            [
                                -64.37216,
                                46.2199
                            ],
                            [
                                -64.51059,
                                46.23971
                            ],
                            [
                                -64.62,
                                46.33398
                            ],
                            [
                                -64.62935,
                                46.43639
                            ],
                            [
                                -64.71663,
                                46.56829
                            ],
                            [
                                -64.71964,
                                46.68414
                            ],
                            [
                                -64.82916,
                                46.68989
                            ],
                            [
                                -64.89288,
                                46.74747
                            ],
                            [
                                -64.919,
                                46.82953
                            ],
                            [
                                -64.88262,
                                46.92487
                            ],
                            [
                                -64.81633,
                                46.97532
                            ],
                            [
                                -64.86101,
                                47.07996
                            ],
                            [
                                -65.03135,
                                47.08349
                            ],
                            [
                                -65.15172,
                                47.03961
                            ],
                            [
                                -65.27137,
                                47.11658
                            ],
                            [
                                -65.06347,
                                47.25327
                            ],
                            [
                                -64.97317,
                                47.2837
                            ],
                            [
                                -64.95753,
                                47.34897
                            ],
                            [
                                -64.90563,
                                47.38699
                            ],
                            [
                                -64.87396,
                                47.46858
                            ],
                            [
                                -64.89993,
                                47.55543
                            ],
                            [
                                -64.80478,
                                47.62881
                            ],
                            [
                                -64.80213,
                                47.67059
                            ],
                            [
                                -64.68781,
                                47.7084
                            ],
                            [
                                -64.75571,
                                47.78675
                            ],
                            [
                                -64.85136,
                                47.80657
                            ],
                            [
                                -65.00189,
                                47.77626
                            ],
                            [
                                -65.11287,
                                47.8283
                            ],
                            [
                                -65.23046,
                                47.80279
                            ],
                            [
                                -65.36072,
                                47.75189
                            ],
                            [
                                -65.48977,
                                47.67505
                            ],
                            [
                                -65.57104,
                                47.66723
                            ],
                            [
                                -65.6425,
                                47.6174
                            ],
                            [
                                -65.69763,
                                47.70096
                            ],
                            [
                                -65.7126,
                                47.78261
                            ],
                            [
                                -65.76537,
                                47.86314
                            ],
                            [
                                -65.90291,
                                47.91989
                            ],
                            [
                                -66.0827,
                                47.92728
                            ],
                            [
                                -66.11251,
                                47.95289
                            ],
                            [
                                -66.35494,
                                48.01308
                            ],
                            [
                                -66.37014,
                                48.07007
                            ],
                            [
                                -66.54005,
                                48.02863
                            ],
                            [
                                -66.47387,
                                48.12125
                            ],
                            [
                                -66.09259,
                                48.09511
                            ],
                            [
                                -65.96288,
                                48.19064
                            ],
                            [
                                -65.81311,
                                48.12273
                            ],
                            [
                                -65.53174,
                                48.06653
                            ],
                            [
                                -65.45014,
                                48.00459
                            ],
                            [
                                -65.32297,
                                48.00354
                            ],
                            [
                                -65.16874,
                                48.04293
                            ],
                            [
                                -64.95024,
                                48.15146
                            ],
                            [
                                -64.93584,
                                48.17722
                            ],
                            [
                                -64.78595,
                                48.20179
                            ],
                            [
                                -64.67606,
                                48.34513
                            ],
                            [
                                -64.32813,
                                48.43631
                            ],
                            [
                                -64.21844,
                                48.50204
                            ],
                            [
                                -64.28816,
                                48.55314
                            ],
                            [
                                -64.29716,
                                48.61642
                            ],
                            [
                                -64.23167,
                                48.62445
                            ],
                            [
                                -64.26307,
                                48.70567
                            ],
                            [
                                -64.37535,
                                48.77007
                            ],
                            [
                                -64.3816,
                                48.85071
                            ],
                            [
                                -64.21238,
                                48.79511
                            ],
                            [
                                -64.20278,
                                48.85683
                            ],
                            [
                                -64.39601,
                                49.00734
                            ],
                            [
                                -64.60244,
                                49.1085
                            ],
                            [
                                -64.74392,
                                49.1382
                            ],
                            [
                                -64.82156,
                                49.17671
                            ],
                            [
                                -65.04858,
                                49.22348
                            ],
                            [
                                -65.27517,
                                49.23434
                            ],
                            [
                                -65.32977,
                                49.25063
                            ],
                            [
                                -65.56675,
                                49.25608
                            ],
                            [
                                -65.73489,
                                49.2304
                            ],
                            [
                                -65.96131,
                                49.22751
                            ],
                            [
                                -66.23811,
                                49.19655
                            ],
                            [
                                -66.73974,
                                49.0886
                            ],
                            [
                                -67.08414,
                                48.96492
                            ],
                            [
                                -67.36718,
                                48.89773
                            ],
                            [
                                -67.47329,
                                48.85848
                            ],
                            [
                                -67.84457,
                                48.74551
                            ],
                            [
                                -67.9635,
                                48.68527
                            ],
                            [
                                -68.18396,
                                48.63342
                            ],
                            [
                                -68.35006,
                                48.55166
                            ],
                            [
                                -68.4632,
                                48.51928
                            ],
                            [
                                -68.53733,
                                48.44802
                            ],
                            [
                                -68.77093,
                                48.36727
                            ],
                            [
                                -68.9521,
                                48.28925
                            ],
                            [
                                -69.34802,
                                48.01713
                            ],
                            [
                                -69.43681,
                                47.9934
                            ],
                            [
                                -69.54492,
                                47.88023
                            ],
                            [
                                -69.63831,
                                47.74026
                            ],
                            [
                                -69.78026,
                                47.62084
                            ],
                            [
                                -70.0315,
                                47.46791
                            ],
                            [
                                -70.05733,
                                47.37528
                            ],
                            [
                                -70.19536,
                                47.30668
                            ],
                            [
                                -70.30974,
                                47.17547
                            ],
                            [
                                -70.49244,
                                47.01482
                            ],
                            [
                                -70.62248,
                                46.98114
                            ],
                            [
                                -70.84137,
                                46.88591
                            ],
                            [
                                -70.98968,
                                46.8352
                            ],
                            [
                                -71.16453,
                                46.8315
                            ],
                            [
                                -71.26163,
                                46.7482
                            ],
                            [
                                -71.48555,
                                46.69315
                            ],
                            [
                                -71.64384,
                                46.63814
                            ],
                            [
                                -71.7703,
                                46.62986
                            ],
                            [
                                -71.86592,
                                46.6642
                            ],
                            [
                                -72.01306,
                                46.56501
                            ],
                            [
                                -72.11254,
                                46.55853
                            ],
                            [
                                -72.20542,
                                46.5043
                            ],
                            [
                                -72.25157,
                                46.41916
                            ],
                            [
                                -72.45478,
                                46.3703
                            ],
                            [
                                -72.64554,
                                46.25286
                            ],
                            [
                                -72.66578,
                                46.19708
                            ],
                            [
                                -72.77346,
                                46.15115
                            ],
                            [
                                -72.94383,
                                46.11824
                            ],
                            [
                                -73.01163,
                                46.07026
                            ],
                            [
                                -73.14433,
                                46.04436
                            ],
                            [
                                -73.23235,
                                45.869
                            ],
                            [
                                -73.38426,
                                45.76078
                            ],
                            [
                                -73.43646,
                                45.70506
                            ],
                            [
                                -73.4654,
                                45.59832
                            ],
                            [
                                -73.52159,
                                45.52843
                            ],
                            [
                                -73.49712,
                                45.45184
                            ],
                            [
                                -73.5422,
                                45.40233
                            ],
                            [
                                -73.6783,
                                45.4144
                            ],
                            [
                                -73.90258,
                                45.31146
                            ],
                            [
                                -73.98639,
                                45.32111
                            ],
                            [
                                -74.00744,
                                45.40922
                            ],
                            [
                                -73.92838,
                                45.40502
                            ],
                            [
                                -73.79091,
                                45.4403
                            ],
                            [
                                -73.62883,
                                45.41573
                            ],
                            [
                                -73.58608,
                                45.4326
                            ],
                            [
                                -73.51235,
                                45.58084
                            ],
                            [
                                -73.48829,
                                45.68431
                            ],
                            [
                                -73.37078,
                                45.81278
                            ],
                            [
                                -73.27912,
                                45.88009
                            ],
                            [
                                -73.19938,
                                45.98116
                            ],
                            [
                                -73.17742,
                                46.04541
                            ],
                            [
                                -72.98923,
                                46.12919
                            ],
                            [
                                -72.97755,
                                46.19959
                            ],
                            [
                                -72.84603,
                                46.26393
                            ],
                            [
                                -72.58755,
                                46.29995
                            ],
                            [
                                -72.46804,
                                46.38951
                            ],
                            [
                                -72.27041,
                                46.45228
                            ],
                            [
                                -72.21212,
                                46.54633
                            ],
                            [
                                -72.04014,
                                46.58858
                            ],
                            [
                                -71.88423,
                                46.68725
                            ],
                            [
                                -71.69398,
                                46.66898
                            ],
                            [
                                -71.62727,
                                46.69347
                            ],
                            [
                                -71.29278,
                                46.74946
                            ],
                            [
                                -71.20471,
                                46.80651
                            ],
                            [
                                -71.20073,
                                46.84876
                            ],
                            [
                                -71.06482,
                                46.92528
                            ],
                            [
                                -70.95952,
                                47.00682
                            ],
                            [
                                -70.80727,
                                47.05047
                            ],
                            [
                                -70.71552,
                                47.10992
                            ],
                            [
                                -70.56915,
                                47.28053
                            ],
                            [
                                -70.55272,
                                47.32776
                            ],
                            [
                                -70.45068,
                                47.42745
                            ],
                            [
                                -70.23145,
                                47.48957
                            ],
                            [
                                -70.20443,
                                47.56597
                            ],
                            [
                                -70.1225,
                                47.65255
                            ],
                            [
                                -69.9899,
                                47.70551
                            ],
                            [
                                -69.90706,
                                47.76954
                            ],
                            [
                                -69.86343,
                                47.86377
                            ],
                            [
                                -69.80623,
                                47.91211
                            ],
                            [
                                -69.77466,
                                48.02695
                            ],
                            [
                                -69.71902,
                                48.12234
                            ],
                            [
                                -69.84612,
                                48.14504
                            ],
                            [
                                -69.89865,
                                48.21683
                            ],
                            [
                                -69.98699,
                                48.2393
                            ],
                            [
                                -70.10624,
                                48.23796
                            ],
                            [
                                -70.36792,
                                48.34002
                            ],
                            [
                                -70.57232,
                                48.35574
                            ],
                            [
                                -70.57138,
                                48.38651
                            ],
                            [
                                -70.38349,
                                48.36965
                            ],
                            [
                                -70.19677,
                                48.28705
                            ],
                            [
                                -70.04315,
                                48.26708
                            ],
                            [
                                -69.88276,
                                48.22752
                            ],
                            [
                                -69.84834,
                                48.17129
                            ],
                            [
                                -69.67926,
                                48.14069
                            ],
                            [
                                -69.58269,
                                48.21545
                            ],
                            [
                                -69.43023,
                                48.29793
                            ],
                            [
                                -69.29119,
                                48.45835
                            ],
                            [
                                -69.22775,
                                48.57302
                            ],
                            [
                                -69.15016,
                                48.56572
                            ],
                            [
                                -69.1032,
                                48.61224
                            ],
                            [
                                -69.05792,
                                48.76684
                            ],
                            [
                                -68.96997,
                                48.77653
                            ],
                            [
                                -68.7676,
                                48.89736
                            ],
                            [
                                -68.6405,
                                48.93891
                            ],
                            [
                                -68.63444,
                                48.9986
                            ],
                            [
                                -68.57805,
                                49.05746
                            ],
                            [
                                -68.48255,
                                49.07095
                            ],
                            [
                                -68.40001,
                                49.04721
                            ],
                            [
                                -68.31359,
                                49.091
                            ],
                            [
                                -68.19164,
                                49.1029
                            ],
                            [
                                -68.12809,
                                49.26556
                            ],
                            [
                                -67.90571,
                                49.29035
                            ],
                            [
                                -67.81444,
                                49.27197
                            ],
                            [
                                -67.76541,
                                49.30398
                            ],
                            [
                                -67.58178,
                                49.32328
                            ],
                            [
                                -67.39143,
                                49.31878
                            ],
                            [
                                -67.23659,
                                49.46594
                            ],
                            [
                                -67.23373,
                                49.58877
                            ],
                            [
                                -67.16905,
                                49.67171
                            ],
                            [
                                -67.1665,
                                49.77198
                            ],
                            [
                                -67.0947,
                                49.84452
                            ],
                            [
                                -67.00489,
                                49.86454
                            ],
                            [
                                -66.92362,
                                50.0019
                            ],
                            [
                                -66.7411,
                                50.04234
                            ],
                            [
                                -66.6707,
                                50.12025
                            ],
                            [
                                -66.53444,
                                50.14938
                            ],
                            [
                                -66.52138,
                                50.2331
                            ],
                            [
                                -66.45468,
                                50.26508
                            ],
                            [
                                -66.3613,
                                50.19013
                            ],
                            [
                                -66.24292,
                                50.21202
                            ],
                            [
                                -66.09096,
                                50.19271
                            ],
                            [
                                -66.00216,
                                50.26306
                            ],
                            [
                                -65.91385,
                                50.28212
                            ],
                            [
                                -65.84441,
                                50.25499
                            ],
                            [
                                -65.69015,
                                50.25515
                            ],
                            [
                                -65.35051,
                                50.30283
                            ],
                            [
                                -64.87333,
                                50.26139
                            ],
                            [
                                -64.5471,
                                50.28435
                            ],
                            [
                                -64.4155,
                                50.31396
                            ],
                            [
                                -64.33933,
                                50.28441
                            ],
                            [
                                -64.16528,
                                50.25767
                            ],
                            [
                                -64.08849,
                                50.28968
                            ],
                            [
                                -63.93576,
                                50.30077
                            ],
                            [
                                -63.71296,
                                50.28629
                            ],
                            [
                                -63.60576,
                                50.23899
                            ],
                            [
                                -63.48646,
                                50.25004
                            ],
                            [
                                -63.44475,
                                50.20567
                            ],
                            [
                                -63.36342,
                                50.23275
                            ],
                            [
                                -63.22746,
                                50.22459
                            ],
                            [
                                -63.06015,
                                50.2765
                            ],
                            [
                                -62.43651,
                                50.26035
                            ],
                            [
                                -62.40376,
                                50.28073
                            ],
                            [
                                -62.00347,
                                50.21237
                            ],
                            [
                                -61.85346,
                                50.21346
                            ],
                            [
                                -61.80161,
                                50.10482
                            ],
                            [
                                -61.65381,
                                50.10225
                            ],
                            [
                                -61.42955,
                                50.16903
                            ],
                            [
                                -61.17705,
                                50.19555
                            ],
                            [
                                -61.03792,
                                50.22182
                            ],
                            [
                                -60.93429,
                                50.1937
                            ],
                            [
                                -60.73541,
                                50.21914
                            ],
                            [
                                -60.61245,
                                50.19808
                            ],
                            [
                                -60.50369,
                                50.24246
                            ],
                            [
                                -60.26421,
                                50.21835
                            ],
                            [
                                -60.11638,
                                50.23494
                            ],
                            [
                                -59.88181,
                                50.29332
                            ],
                            [
                                -59.89351,
                                50.37067
                            ],
                            [
                                -59.81879,
                                50.42725
                            ],
                            [
                                -59.59974,
                                50.46863
                            ],
                            [
                                -59.48687,
                                50.53818
                            ],
                            [
                                -59.41721,
                                50.62548
                            ],
                            [
                                -59.34229,
                                50.65225
                            ],
                            [
                                -59.26518,
                                50.74682
                            ],
                            [
                                -59.12094,
                                50.77416
                            ],
                            [
                                -59.02277,
                                50.77179
                            ],
                            [
                                -58.95537,
                                50.82243
                            ],
                            [
                                -58.96434,
                                51.0273
                            ],
                            [
                                -58.82411,
                                51.02699
                            ],
                            [
                                -58.82229,
                                51.06548
                            ],
                            [
                                -58.60766,
                                51.15861
                            ],
                            [
                                -58.63841,
                                51.21681
                            ],
                            [
                                -58.47982,
                                51.30516
                            ],
                            [
                                -58.33294,
                                51.27613
                            ],
                            [
                                -58.19315,
                                51.26745
                            ],
                            [
                                -57.99618,
                                51.31465
                            ],
                            [
                                -57.88683,
                                51.3823
                            ],
                            [
                                -57.76963,
                                51.426
                            ],
                            [
                                -57.46398,
                                51.43737
                            ],
                            [
                                -57.40127,
                                51.47696
                            ],
                            [
                                -57.29637,
                                51.49342
                            ],
                            [
                                -57.20801,
                                51.41751
                            ],
                            [
                                -57.0372,
                                51.41438
                            ],
                            [
                                -56.86698,
                                51.46179
                            ],
                            [
                                -56.7131,
                                51.5784
                            ],
                            [
                                -56.68936,
                                51.64165
                            ],
                            [
                                -56.61681,
                                51.63947
                            ],
                            [
                                -56.44197,
                                51.72805
                            ],
                            [
                                -56.21318,
                                51.78602
                            ],
                            [
                                -56.14087,
                                51.83637
                            ],
                            [
                                -55.89439,
                                51.96122
                            ],
                            [
                                -55.88879,
                                52.01454
                            ],
                            [
                                -55.79664,
                                52.02685
                            ],
                            [
                                -55.69963,
                                52.09178
                            ],
                            [
                                -55.74048,
                                52.20194
                            ],
                            [
                                -55.71024,
                                52.23578
                            ],
                            [
                                -55.81921,
                                52.30744
                            ],
                            [
                                -55.91231,
                                52.33542
                            ],
                            [
                                -55.74063,
                                52.38133
                            ],
                            [
                                -55.63561,
                                52.36624
                            ],
                            [
                                -55.65731,
                                52.45324
                            ],
                            [
                                -55.86423,
                                52.51521
                            ],
                            [
                                -55.97636,
                                52.50551
                            ],
                            [
                                -56.04461,
                                52.53958
                            ],
                            [
                                -56.05125,
                                52.59211
                            ],
                            [
                                -55.93724,
                                52.62403
                            ],
                            [
                                -55.76783,
                                52.60886
                            ],
                            [
                                -55.77496,
                                52.69075
                            ],
                            [
                                -55.96042,
                                52.68249
                            ],
                            [
                                -56.08251,
                                52.78386
                            ],
                            [
                                -55.80588,
                                52.84341
                            ],
                            [
                                -55.89537,
                                52.9497
                            ],
                            [
                                -55.91511,
                                53.02991
                            ],
                            [
                                -55.86812,
                                53.09268
                            ],
                            [
                                -55.7575,
                                53.13451
                            ],
                            [
                                -55.7746,
                                53.26857
                            ],
                            [
                                -55.87023,
                                53.31438
                            ],
                            [
                                -55.86452,
                                53.37163
                            ],
                            [
                                -56.00008,
                                53.41144
                            ],
                            [
                                -56.08099,
                                53.58743
                            ],
                            [
                                -56.21123,
                                53.57395
                            ],
                            [
                                -56.31783,
                                53.62835
                            ],
                            [
                                -56.41632,
                                53.61307
                            ],
                            [
                                -56.61734,
                                53.65482
                            ],
                            [
                                -56.51855,
                                53.76405
                            ],
                            [
                                -56.68307,
                                53.72732
                            ],
                            [
                                -56.86845,
                                53.7146
                            ],
                            [
                                -56.97209,
                                53.72994
                            ],
                            [
                                -57.14117,
                                53.62351
                            ],
                            [
                                -57.1231,
                                53.55621
                            ],
                            [
                                -57.30837,
                                53.45869
                            ],
                            [
                                -57.28952,
                                53.53546
                            ],
                            [
                                -57.35822,
                                53.59585
                            ],
                            [
                                -57.46328,
                                53.63153
                            ],
                            [
                                -57.2778,
                                53.68035
                            ],
                            [
                                -57.15165,
                                53.73459
                            ],
                            [
                                -57.15825,
                                53.78694
                            ],
                            [
                                -57.07266,
                                53.81196
                            ],
                            [
                                -57.2083,
                                53.88063
                            ],
                            [
                                -57.21638,
                                53.95731
                            ],
                            [
                                -57.28942,
                                54.00238
                            ],
                            [
                                -57.42693,
                                54.18622
                            ],
                            [
                                -57.64397,
                                54.20813
                            ],
                            [
                                -57.97807,
                                54.2198
                            ],
                            [
                                -58.1723,
                                54.23566
                            ],
                            [
                                -58.36515,
                                54.20193
                            ],
                            [
                                -58.41033,
                                54.13239
                            ],
                            [
                                -58.2171,
                                54.06729
                            ],
                            [
                                -58.51808,
                                54.01235
                            ],
                            [
                                -58.72373,
                                53.9535
                            ],
                            [
                                -58.85207,
                                53.94664
                            ],
                            [
                                -58.86907,
                                53.89151
                            ],
                            [
                                -59.0611,
                                53.79386
                            ],
                            [
                                -59.01191,
                                53.75273
                            ],
                            [
                                -59.08585,
                                53.68594
                            ],
                            [
                                -59.24127,
                                53.68645
                            ],
                            [
                                -59.3764,
                                53.65761
                            ],
                            [
                                -59.49577,
                                53.57048
                            ],
                            [
                                -59.59563,
                                53.52923
                            ],
                            [
                                -59.83809,
                                53.54215
                            ],
                            [
                                -59.96344,
                                53.4161
                            ],
                            [
                                -60.0603,
                                53.34325
                            ],
                            [
                                -60.35183,
                                53.37965
                            ],
                            [
                                -60.1391,
                                53.46295
                            ],
                            [
                                -60.16553,
                                53.52421
                            ],
                            [
                                -60.091,
                                53.55705
                            ],
                            [
                                -60.12795,
                                53.61926
                            ],
                            [
                                -60.06214,
                                53.70955
                            ],
                            [
                                -60.08689,
                                53.75864
                            ],
                            [
                                -59.8546,
                                53.84659
                            ],
                            [
                                -59.57128,
                                53.82034
                            ],
                            [
                                -59.39383,
                                53.85976
                            ],
                            [
                                -59.1911,
                                53.93441
                            ],
                            [
                                -58.98011,
                                53.96593
                            ],
                            [
                                -58.96048,
                                54.04606
                            ],
                            [
                                -58.77214,
                                54.02862
                            ],
                            [
                                -58.5856,
                                54.0515
                            ],
                            [
                                -58.51623,
                                54.12447
                            ],
                            [
                                -58.44646,
                                54.15067
                            ],
                            [
                                -58.38164,
                                54.22615
                            ],
                            [
                                -58.55631,
                                54.1904
                            ],
                            [
                                -58.64575,
                                54.15142
                            ],
                            [
                                -59.00287,
                                54.06334
                            ],
                            [
                                -59.12824,
                                54.05533
                            ],
                            [
                                -59.23913,
                                54.08053
                            ],
                            [
                                -58.838,
                                54.14455
                            ],
                            [
                                -58.62753,
                                54.16564
                            ],
                            [
                                -58.57569,
                                54.2062
                            ],
                            [
                                -58.44337,
                                54.23674
                            ],
                            [
                                -58.25612,
                                54.2453
                            ],
                            [
                                -58.2474,
                                54.33034
                            ],
                            [
                                -58.0637,
                                54.38252
                            ],
                            [
                                -57.88876,
                                54.39713
                            ],
                            [
                                -57.7041,
                                54.36934
                            ],
                            [
                                -57.56399,
                                54.41068
                            ],
                            [
                                -57.48428,
                                54.48021
                            ],
                            [
                                -57.40745,
                                54.49459
                            ],
                            [
                                -57.3471,
                                54.57792
                            ],
                            [
                                -57.44732,
                                54.65593
                            ],
                            [
                                -57.55951,
                                54.66293
                            ],
                            [
                                -57.64535,
                                54.62955
                            ],
                            [
                                -57.72289,
                                54.64111
                            ],
                            [
                                -57.84154,
                                54.73969
                            ],
                            [
                                -57.94174,
                                54.75065
                            ],
                            [
                                -57.98986,
                                54.83181
                            ],
                            [
                                -57.94272,
                                54.88436
                            ],
                            [
                                -58.13995,
                                54.87767
                            ],
                            [
                                -58.2762,
                                54.79011
                            ],
                            [
                                -58.43285,
                                54.76777
                            ],
                            [
                                -58.68671,
                                54.8069
                            ],
                            [
                                -58.80647,
                                54.83714
                            ],
                            [
                                -58.92398,
                                54.8338
                            ],
                            [
                                -58.90346,
                                54.94288
                            ],
                            [
                                -59.04912,
                                55.00168
                            ],
                            [
                                -58.96087,
                                55.07127
                            ],
                            [
                                -58.96895,
                                55.12864
                            ],
                            [
                                -59.14527,
                                55.14869
                            ],
                            [
                                -59.1389,
                                55.2246
                            ],
                            [
                                -59.30338,
                                55.14414
                            ],
                            [
                                -59.61989,
                                54.95067
                            ],
                            [
                                -59.71834,
                                54.97529
                            ],
                            [
                                -59.52278,
                                55.04983
                            ],
                            [
                                -59.43835,
                                55.14902
                            ],
                            [
                                -59.4957,
                                55.18035
                            ],
                            [
                                -59.69112,
                                55.14315
                            ],
                            [
                                -59.87522,
                                55.13574
                            ],
                            [
                                -59.72349,
                                55.27281
                            ],
                            [
                                -59.86022,
                                55.2999
                            ],
                            [
                                -59.923,
                                55.23004
                            ],
                            [
                                -60.04627,
                                55.20604
                            ],
                            [
                                -60.17275,
                                55.24378
                            ],
                            [
                                -60.27872,
                                55.23906
                            ],
                            [
                                -60.36718,
                                55.1669
                            ],
                            [
                                -60.46083,
                                55.18945
                            ],
                            [
                                -60.5296,
                                55.26158
                            ],
                            [
                                -60.41308,
                                55.27137
                            ],
                            [
                                -60.36377,
                                55.39159
                            ],
                            [
                                -60.23449,
                                55.42527
                            ],
                            [
                                -60.35469,
                                55.48376
                            ],
                            [
                                -60.3475,
                                55.57384
                            ],
                            [
                                -60.51045,
                                55.63557
                            ],
                            [
                                -60.33508,
                                55.74562
                            ],
                            [
                                -60.37114,
                                55.78213
                            ],
                            [
                                -60.52961,
                                55.77635
                            ],
                            [
                                -60.5987,
                                55.70329
                            ],
                            [
                                -60.64568,
                                55.82585
                            ],
                            [
                                -60.93236,
                                55.86076
                            ],
                            [
                                -61.10447,
                                55.84137
                            ],
                            [
                                -61.07818,
                                55.92916
                            ],
                            [
                                -61.16562,
                                55.97872
                            ],
                            [
                                -61.41172,
                                55.95919
                            ],
                            [
                                -61.45263,
                                56.00293
                            ],
                            [
                                -61.3025,
                                56.04693
                            ],
                            [
                                -61.3715,
                                56.09901
                            ],
                            [
                                -61.34476,
                                56.13915
                            ],
                            [
                                -61.41454,
                                56.20962
                            ],
                            [
                                -61.58793,
                                56.21934
                            ],
                            [
                                -61.91761,
                                56.2114
                            ],
                            [
                                -62.00915,
                                56.22388
                            ],
                            [
                                -62.06478,
                                56.27534
                            ],
                            [
                                -61.89767,
                                56.29455
                            ],
                            [
                                -61.73592,
                                56.24624
                            ],
                            [
                                -61.61793,
                                56.27325
                            ],
                            [
                                -61.65735,
                                56.31927
                            ],
                            [
                                -61.78121,
                                56.33923
                            ],
                            [
                                -61.79041,
                                56.39628
                            ],
                            [
                                -62.03811,
                                56.42486
                            ],
                            [
                                -62.16119,
                                56.45292
                            ],
                            [
                                -62.07127,
                                56.50549
                            ],
                            [
                                -61.77647,
                                56.48438
                            ],
                            [
                                -61.67399,
                                56.50439
                            ],
                            [
                                -61.69874,
                                56.566
                            ],
                            [
                                -61.8733,
                                56.59074
                            ],
                            [
                                -61.95344,
                                56.57611
                            ],
                            [
                                -62.15033,
                                56.70105
                            ],
                            [
                                -61.86509,
                                56.62685
                            ],
                            [
                                -61.69786,
                                56.71792
                            ],
                            [
                                -61.80943,
                                56.78924
                            ],
                            [
                                -61.65904,
                                56.81079
                            ],
                            [
                                -61.65945,
                                56.86851
                            ],
                            [
                                -61.48474,
                                56.98512
                            ],
                            [
                                -61.38462,
                                56.98202
                            ],
                            [
                                -61.36494,
                                57.09834
                            ],
                            [
                                -61.487,
                                57.16379
                            ],
                            [
                                -61.70623,
                                57.1492
                            ],
                            [
                                -61.88992,
                                57.31846
                            ],
                            [
                                -61.83672,
                                57.38677
                            ],
                            [
                                -62.06372,
                                57.45774
                            ],
                            [
                                -62.18402,
                                57.46927
                            ],
                            [
                                -62.36169,
                                57.45154
                            ],
                            [
                                -62.28504,
                                57.53442
                            ],
                            [
                                -62.15007,
                                57.52566
                            ],
                            [
                                -62.10688,
                                57.58475
                            ],
                            [
                                -61.89485,
                                57.6335
                            ],
                            [
                                -61.95048,
                                57.73641
                            ],
                            [
                                -62.02802,
                                57.78864
                            ],
                            [
                                -62.11231,
                                57.78717
                            ],
                            [
                                -62.16102,
                                57.83377
                            ],
                            [
                                -62.08106,
                                57.88806
                            ],
                            [
                                -62.32544,
                                57.94995
                            ],
                            [
                                -62.38219,
                                57.99379
                            ],
                            [
                                -62.31135,
                                58.04301
                            ],
                            [
                                -62.38955,
                                58.10709
                            ],
                            [
                                -62.52725,
                                58.1079
                            ],
                            [
                                -62.71651,
                                58.13995
                            ],
                            [
                                -62.58601,
                                58.22739
                            ],
                            [
                                -62.63404,
                                58.29737
                            ],
                            [
                                -62.564,
                                58.48696
                            ],
                            [
                                -62.81437,
                                58.49508
                            ],
                            [
                                -63.03057,
                                58.4505
                            ],
                            [
                                -63.17218,
                                58.50687
                            ],
                            [
                                -62.9934,
                                58.56366
                            ],
                            [
                                -62.84646,
                                58.67365
                            ],
                            [
                                -62.92691,
                                58.73265
                            ],
                            [
                                -62.90934,
                                58.82122
                            ],
                            [
                                -63.02511,
                                58.89629
                            ],
                            [
                                -63.11826,
                                58.84754
                            ],
                            [
                                -63.23067,
                                58.87459
                            ],
                            [
                                -63.15986,
                                58.97167
                            ],
                            [
                                -63.28346,
                                59.03405
                            ],
                            [
                                -63.30865,
                                59.08776
                            ],
                            [
                                -63.41135,
                                59.12432
                            ],
                            [
                                -63.41702,
                                59.20617
                            ],
                            [
                                -63.54274,
                                59.34293
                            ],
                            [
                                -63.85923,
                                59.37987
                            ],
                            [
                                -63.72561,
                                59.51155
                            ],
                            [
                                -63.85961,
                                59.57185
                            ],
                            [
                                -63.87207,
                                59.60758
                            ],
                            [
                                -64.02886,
                                59.61749
                            ],
                            [
                                -63.94158,
                                59.689
                            ],
                            [
                                -64.16424,
                                59.68779
                            ],
                            [
                                -64.25553,
                                59.75442
                            ],
                            [
                                -64.19403,
                                59.77523
                            ],
                            [
                                -64.1281,
                                59.90028
                            ],
                            [
                                -64.22537,
                                59.94507
                            ],
                            [
                                -64.16971,
                                60.02475
                            ],
                            [
                                -64.36163,
                                60.04734
                            ],
                            [
                                -64.36948,
                                60.18911
                            ],
                            [
                                -64.41742,
                                60.2687
                            ],
                            [
                                -64.62459,
                                60.34339
                            ],
                            [
                                -64.849,
                                60.35942
                            ],
                            [
                                -64.79508,
                                60.31741
                            ],
                            [
                                -64.94525,
                                60.26677
                            ],
                            [
                                -64.96157,
                                60.18558
                            ],
                            [
                                -65.04635,
                                60.1159
                            ],
                            [
                                -65.09588,
                                59.99618
                            ],
                            [
                                -65.17111,
                                59.9199
                            ],
                            [
                                -65.33477,
                                59.8435
                            ],
                            [
                                -65.38609,
                                59.79635
                            ],
                            [
                                -65.53315,
                                59.74541
                            ],
                            [
                                -65.51959,
                                59.6659
                            ],
                            [
                                -65.38068,
                                59.49944
                            ],
                            [
                                -65.51873,
                                59.47823
                            ],
                            [
                                -65.49224,
                                59.36619
                            ],
                            [
                                -65.60184,
                                59.38001
                            ],
                            [
                                -65.51209,
                                59.27243
                            ],
                            [
                                -65.66954,
                                59.27092
                            ],
                            [
                                -65.74459,
                                59.18325
                            ],
                            [
                                -65.70818,
                                59.13062
                            ],
                            [
                                -65.59884,
                                59.07078
                            ],
                            [
                                -65.76539,
                                59.03362
                            ],
                            [
                                -65.82993,
                                58.96212
                            ],
                            [
                                -65.99651,
                                58.91043
                            ],
                            [
                                -66.09589,
                                58.78624
                            ],
                            [
                                -66.23696,
                                58.79702
                            ],
                            [
                                -66.37209,
                                58.85301
                            ],
                            [
                                -66.45856,
                                58.81986
                            ],
                            [
                                -66.44007,
                                58.741
                            ],
                            [
                                -66.53228,
                                58.70311
                            ],
                            [
                                -66.61552,
                                58.61774
                            ],
                            [
                                -66.61242,
                                58.56168
                            ],
                            [
                                -66.80144,
                                58.49529
                            ],
                            [
                                -66.92818,
                                58.5087
                            ],
                            [
                                -67.08441,
                                58.36843
                            ],
                            [
                                -67.18424,
                                58.37038
                            ],
                            [
                                -67.44923,
                                58.2959
                            ],
                            [
                                -67.59154,
                                58.20898
                            ],
                            [
                                -67.74315,
                                58.31184
                            ],
                            [
                                -67.68911,
                                58.41938
                            ],
                            [
                                -67.79233,
                                58.47087
                            ],
                            [
                                -67.86237,
                                58.33606
                            ],
                            [
                                -67.91616,
                                58.37031
                            ],
                            [
                                -67.90495,
                                58.49317
                            ],
                            [
                                -68.06488,
                                58.5118
                            ],
                            [
                                -68.34095,
                                58.59778
                            ],
                            [
                                -68.35225,
                                58.76962
                            ],
                            [
                                -68.46564,
                                58.81768
                            ],
                            [
                                -68.58126,
                                58.89632
                            ],
                            [
                                -68.86067,
                                58.88281
                            ],
                            [
                                -69.00394,
                                58.90058
                            ],
                            [
                                -69.25176,
                                58.90157
                            ],
                            [
                                -69.41024,
                                58.85038
                            ],
                            [
                                -69.46563,
                                58.78891
                            ],
                            [
                                -69.60846,
                                58.76444
                            ],
                            [
                                -69.65711,
                                58.695
                            ],
                            [
                                -69.72451,
                                58.67685
                            ],
                            [
                                -69.80865,
                                58.58681
                            ],
                            [
                                -69.92715,
                                58.69176
                            ],
                            [
                                -70.06844,
                                58.76894
                            ],
                            [
                                -70.03341,
                                58.80924
                            ],
                            [
                                -69.78622,
                                58.83659
                            ],
                            [
                                -69.81022,
                                58.92616
                            ],
                            [
                                -69.71159,
                                58.9661
                            ],
                            [
                                -69.65336,
                                58.7929
                            ],
                            [
                                -69.54676,
                                58.81241
                            ],
                            [
                                -69.52267,
                                58.88397
                            ],
                            [
                                -69.44061,
                                58.9056
                            ],
                            [
                                -69.47069,
                                59.02187
                            ],
                            [
                                -69.34756,
                                59.09348
                            ],
                            [
                                -69.52914,
                                59.14816
                            ],
                            [
                                -69.45264,
                                59.22349
                            ],
                            [
                                -69.35789,
                                59.20538
                            ],
                            [
                                -69.23102,
                                59.24273
                            ],
                            [
                                -69.26592,
                                59.29972
                            ],
                            [
                                -69.4392,
                                59.36046
                            ],
                            [
                                -69.59982,
                                59.31664
                            ],
                            [
                                -69.6369,
                                59.42166
                            ],
                            [
                                -69.74348,
                                59.51115
                            ],
                            [
                                -69.64436,
                                59.58219
                            ],
                            [
                                -69.56381,
                                59.59434
                            ],
                            [
                                -69.51397,
                                59.67749
                            ],
                            [
                                -69.59767,
                                59.78939
                            ],
                            [
                                -69.54972,
                                59.86093
                            ],
                            [
                                -69.70368,
                                59.88939
                            ],
                            [
                                -69.71952,
                                59.9649
                            ],
                            [
                                -70.07769,
                                59.95974
                            ],
                            [
                                -70.25061,
                                60.02689
                            ],
                            [
                                -69.95363,
                                60.01448
                            ],
                            [
                                -69.84236,
                                59.99371
                            ],
                            [
                                -69.82378,
                                60.06994
                            ],
                            [
                                -69.70761,
                                60.04731
                            ],
                            [
                                -69.60655,
                                60.11271
                            ],
                            [
                                -69.59268,
                                60.17138
                            ],
                            [
                                -69.66596,
                                60.28355
                            ],
                            [
                                -69.71548,
                                60.45729
                            ],
                            [
                                -69.80883,
                                60.51423
                            ],
                            [
                                -69.68248,
                                60.54826
                            ],
                            [
                                -69.64782,
                                60.62912
                            ],
                            [
                                -69.69428,
                                60.68445
                            ],
                            [
                                -69.62021,
                                60.72826
                            ],
                            [
                                -69.41455,
                                60.78577
                            ],
                            [
                                -69.37422,
                                60.9167
                            ],
                            [
                                -69.44525,
                                60.95955
                            ],
                            [
                                -69.51074,
                                61.06927
                            ],
                            [
                                -69.60297,
                                61.07831
                            ],
                            [
                                -69.67109,
                                61.02266
                            ],
                            [
                                -69.64427,
                                60.87909
                            ],
                            [
                                -69.8294,
                                60.88693
                            ],
                            [
                                -69.9074,
                                60.80272
                            ],
                            [
                                -70.08622,
                                60.87973
                            ],
                            [
                                -70.08924,
                                60.96301
                            ],
                            [
                                -70.15647,
                                61.00058
                            ],
                            [
                                -70.10631,
                                61.05758
                            ],
                            [
                                -70.25985,
                                61.09673
                            ],
                            [
                                -70.40269,
                                61.08159
                            ],
                            [
                                -70.59034,
                                61.01708
                            ],
                            [
                                -70.73492,
                                61.08036
                            ],
                            [
                                -70.86154,
                                61.07047
                            ],
                            [
                                -71.04333,
                                61.13162
                            ],
                            [
                                -71.17719,
                                61.12144
                            ],
                            [
                                -71.25729,
                                61.15727
                            ],
                            [
                                -71.39499,
                                61.15246
                            ],
                            [
                                -71.53858,
                                61.20932
                            ],
                            [
                                -71.67198,
                                61.3201
                            ],
                            [
                                -71.64358,
                                61.4011
                            ],
                            [
                                -71.7763,
                                61.52873
                            ],
                            [
                                -71.52306,
                                61.57956
                            ],
                            [
                                -71.64122,
                                61.65693
                            ],
                            [
                                -71.86042,
                                61.70066
                            ],
                            [
                                -71.96576,
                                61.59755
                            ],
                            [
                                -72.00833,
                                61.72605
                            ],
                            [
                                -72.11627,
                                61.76806
                            ],
                            [
                                -72.18391,
                                61.8562
                            ],
                            [
                                -72.5946,
                                61.94598
                            ],
                            [
                                -72.61347,
                                62.11036
                            ],
                            [
                                -72.75127,
                                62.14268
                            ],
                            [
                                -72.86816,
                                62.11027
                            ],
                            [
                                -72.9169,
                                62.15875
                            ],
                            [
                                -73.18621,
                                62.26765
                            ],
                            [
                                -73.19898,
                                62.31555
                            ],
                            [
                                -73.38398,
                                62.37385
                            ],
                            [
                                -73.55003,
                                62.37985
                            ],
                            [
                                -73.65974,
                                62.47299
                            ],
                            [
                                -73.85074,
                                62.46053
                            ],
                            [
                                -73.97574,
                                62.37075
                            ],
                            [
                                -74.26213,
                                62.31555
                            ],
                            [
                                -74.42179,
                                62.24438
                            ],
                            [
                                -74.70537,
                                62.25245
                            ],
                            [
                                -74.81547,
                                62.20065
                            ],
                            [
                                -74.92419,
                                62.25453
                            ],
                            [
                                -75.43168,
                                62.3125
                            ],
                            [
                                -75.52875,
                                62.25285
                            ],
                            [
                                -75.62543,
                                62.28829
                            ],
                            [
                                -76.01812,
                                62.33989
                            ],
                            [
                                -76.11647,
                                62.37809
                            ],
                            [
                                -76.55821,
                                62.45572
                            ],
                            [
                                -76.79968,
                                62.52116
                            ],
                            [
                                -77.08946,
                                62.5334
                            ],
                            [
                                -77.42405,
                                62.57858
                            ],
                            [
                                -77.6728,
                                62.51123
                            ],
                            [
                                -77.72191,
                                62.4688
                            ],
                            [
                                -77.92898,
                                62.42206
                            ],
                            [
                                -78.07703,
                                62.36511
                            ],
                            [
                                -78.14693,
                                62.29799
                            ],
                            [
                                -78.1785,
                                62.14588
                            ],
                            [
                                -78.08709,
                                61.93657
                            ],
                            [
                                -78.07914,
                                61.84896
                            ],
                            [
                                -77.95915,
                                61.6843
                            ],
                            [
                                -77.79061,
                                61.68645
                            ],
                            [
                                -77.72761,
                                61.59499
                            ],
                            [
                                -77.59305,
                                61.59431
                            ],
                            [
                                -77.69121,
                                61.51392
                            ],
                            [
                                -77.57281,
                                61.48331
                            ],
                            [
                                -77.71286,
                                61.43278
                            ],
                            [
                                -77.76589,
                                61.3384
                            ],
                            [
                                -77.76286,
                                61.23352
                            ],
                            [
                                -77.82209,
                                61.14439
                            ],
                            [
                                -77.83463,
                                61.05287
                            ],
                            [
                                -77.90703,
                                61.03586
                            ],
                            [
                                -78.19279,
                                60.85622
                            ],
                            [
                                -78.19045,
                                60.80039
                            ],
                            [
                                -77.9175,
                                60.78882
                            ],
                            [
                                -77.87128,
                                60.76064
                            ],
                            [
                                -77.70573,
                                60.77966
                            ],
                            [
                                -77.64498,
                                60.74821
                            ],
                            [
                                -77.71276,
                                60.69148
                            ],
                            [
                                -77.83353,
                                60.65367
                            ],
                            [
                                -77.79489,
                                60.59431
                            ],
                            [
                                -77.59179,
                                60.5005
                            ],
                            [
                                -77.66583,
                                60.4821
                            ],
                            [
                                -77.76981,
                                60.40376
                            ],
                            [
                                -77.59869,
                                60.3231
                            ],
                            [
                                -77.48956,
                                60.19952
                            ],
                            [
                                -77.48448,
                                60.12173
                            ],
                            [
                                -77.60757,
                                60.10938
                            ],
                            [
                                -77.57148,
                                60.04091
                            ],
                            [
                                -77.40673,
                                60.05749
                            ],
                            [
                                -77.27883,
                                59.99135
                            ],
                            [
                                -77.40854,
                                59.93921
                            ],
                            [
                                -77.33953,
                                59.78477
                            ],
                            [
                                -77.45336,
                                59.77906
                            ],
                            [
                                -77.50769,
                                59.70288
                            ],
                            [
                                -77.46944,
                                59.62317
                            ],
                            [
                                -77.72582,
                                59.68616
                            ],
                            [
                                -77.8194,
                                59.67809
                            ],
                            [
                                -77.73742,
                                59.56783
                            ],
                            [
                                -77.90278,
                                59.46954
                            ],
                            [
                                -77.78458,
                                59.41319
                            ],
                            [
                                -77.78503,
                                59.339
                            ],
                            [
                                -77.89728,
                                59.26305
                            ],
                            [
                                -77.98804,
                                59.25664
                            ],
                            [
                                -78.14235,
                                59.19601
                            ],
                            [
                                -78.13075,
                                59.11767
                            ],
                            [
                                -78.22375,
                                59.05498
                            ],
                            [
                                -78.3665,
                                58.90642
                            ],
                            [
                                -78.51279,
                                58.93447
                            ],
                            [
                                -78.57963,
                                58.90467
                            ],
                            [
                                -78.51578,
                                58.8103
                            ],
                            [
                                -78.5034,
                                58.70278
                            ],
                            [
                                -78.58235,
                                58.64885
                            ],
                            [
                                -78.49407,
                                58.62616
                            ],
                            [
                                -78.42943,
                                58.54362
                            ],
                            [
                                -78.35431,
                                58.57568
                            ],
                            [
                                -78.26089,
                                58.5134
                            ],
                            [
                                -78.04546,
                                58.40861
                            ],
                            [
                                -78.06422,
                                58.37738
                            ],
                            [
                                -77.76219,
                                58.28645
                            ],
                            [
                                -77.54673,
                                58.23458
                            ],
                            [
                                -77.45701,
                                58.14505
                            ],
                            [
                                -77.17262,
                                58.00751
                            ],
                            [
                                -76.84571,
                                57.66699
                            ],
                            [
                                -76.86022,
                                57.62548
                            ],
                            [
                                -76.75682,
                                57.46084
                            ],
                            [
                                -76.63056,
                                57.31347
                            ],
                            [
                                -76.55207,
                                57.09324
                            ],
                            [
                                -76.56635,
                                56.92579
                            ],
                            [
                                -76.53297,
                                56.82216
                            ],
                            [
                                -76.53126,
                                56.64621
                            ],
                            [
                                -76.55349,
                                56.55574
                            ],
                            [
                                -76.51962,
                                56.45443
                            ],
                            [
                                -76.54952,
                                56.29939
                            ],
                            [
                                -76.61576,
                                56.24779
                            ],
                            [
                                -76.64786,
                                56.16998
                            ],
                            [
                                -76.51249,
                                56.15829
                            ],
                            [
                                -76.50884,
                                56.23569
                            ],
                            [
                                -76.38428,
                                56.33512
                            ],
                            [
                                -76.44566,
                                56.40351
                            ],
                            [
                                -76.34935,
                                56.47286
                            ],
                            [
                                -76.29181,
                                56.41455
                            ],
                            [
                                -76.29715,
                                56.33634
                            ],
                            [
                                -76.21928,
                                56.288
                            ],
                            [
                                -75.97552,
                                56.19063
                            ],
                            [
                                -76.0757,
                                56.10305
                            ],
                            [
                                -76.33285,
                                56.10585
                            ],
                            [
                                -76.54995,
                                56.15114
                            ],
                            [
                                -76.6442,
                                56.14241
                            ],
                            [
                                -76.69229,
                                56.04854
                            ],
                            [
                                -76.79251,
                                55.9999
                            ],
                            [
                                -76.831,
                                55.93132
                            ],
                            [
                                -77.08965,
                                55.7455
                            ],
                            [
                                -77.11973,
                                55.66519
                            ],
                            [
                                -77.58188,
                                55.38437
                            ],
                            [
                                -77.62843,
                                55.38066
                            ],
                            [
                                -77.80595,
                                55.25997
                            ],
                            [
                                -78.13241,
                                55.1464
                            ],
                            [
                                -78.31743,
                                55.04346
                            ],
                            [
                                -78.53266,
                                54.99049
                            ],
                            [
                                -78.57837,
                                54.96203
                            ],
                            [
                                -78.93586,
                                54.87285
                            ],
                            [
                                -78.98099,
                                54.83373
                            ],
                            [
                                -79.226,
                                54.79606
                            ],
                            [
                                -79.56141,
                                54.72159
                            ],
                            [
                                -79.7111,
                                54.65397
                            ],
                            [
                                -79.6482,
                                54.61419
                            ],
                            [
                                -79.56415,
                                54.61789
                            ],
                            [
                                -79.54461,
                                54.54051
                            ],
                            [
                                -79.47821,
                                54.44146
                            ],
                            [
                                -79.46392,
                                54.31995
                            ],
                            [
                                -79.35203,
                                54.2046
                            ],
                            [
                                -79.1103,
                                54.13659
                            ],
                            [
                                -79.1664,
                                54.08585
                            ],
                            [
                                -79.06168,
                                53.99372
                            ],
                            [
                                -79.08244,
                                53.929
                            ],
                            [
                                -79.03807,
                                53.7837
                            ],
                            [
                                -79.0785,
                                53.75808
                            ],
                            [
                                -79.04073,
                                53.66531
                            ],
                            [
                                -78.9071,
                                53.55175
                            ],
                            [
                                -79.06605,
                                53.5284
                            ],
                            [
                                -79.11773,
                                53.48087
                            ],
                            [
                                -79.02803,
                                53.40698
                            ],
                            [
                                -78.94684,
                                53.38064
                            ],
                            [
                                -78.97001,
                                53.28757
                            ],
                            [
                                -78.91171,
                                53.19752
                            ],
                            [
                                -78.9738,
                                53.08251
                            ],
                            [
                                -78.96131,
                                52.99762
                            ],
                            [
                                -78.83098,
                                52.97717
                            ],
                            [
                                -78.90398,
                                52.91627
                            ],
                            [
                                -78.79685,
                                52.8523
                            ],
                            [
                                -78.74116,
                                52.77301
                            ],
                            [
                                -78.77156,
                                52.71404
                            ],
                            [
                                -78.6694,
                                52.51604
                            ],
                            [
                                -78.59138,
                                52.52186
                            ],
                            [
                                -78.51766,
                                52.4532
                            ],
                            [
                                -78.51999,
                                52.31205
                            ],
                            [
                                -78.5604,
                                52.29166
                            ],
                            [
                                -78.54346,
                                52.17704
                            ],
                            [
                                -78.58865,
                                52.10407
                            ],
                            [
                                -78.6498,
                                52.08058
                            ],
                            [
                                -78.72437,
                                51.97629
                            ],
                            [
                                -78.87891,
                                51.92782
                            ],
                            [
                                -78.83861,
                                51.84291
                            ],
                            [
                                -78.92676,
                                51.79372
                            ],
                            [
                                -79.04138,
                                51.76291
                            ],
                            [
                                -78.93244,
                                51.65063
                            ],
                            [
                                -78.84142,
                                51.60087
                            ],
                            [
                                -78.8265,
                                51.51378
                            ],
                            [
                                -78.76044,
                                51.49356
                            ],
                            [
                                -78.89556,
                                51.38256
                            ],
                            [
                                -78.98284,
                                51.46149
                            ],
                            [
                                -79.0957,
                                51.53053
                            ],
                            [
                                -79.24195,
                                51.54259
                            ],
                            [
                                -79.2266,
                                51.6412
                            ],
                            [
                                -79.31878,
                                51.66319
                            ],
                            [
                                -79.53664,
                                51.55235
                            ],
                            [
                                -79.52394,
                                51.4743
                            ],
                            [
                                -79.68109,
                                51.40136
                            ],
                            [
                                -79.69629,
                                51.29207
                            ],
                            [
                                -79.79388,
                                51.15767
                            ],
                            [
                                -79.89724,
                                51.17838
                            ],
                            [
                                -79.97797,
                                51.23786
                            ],
                            [
                                -80.11368,
                                51.29015
                            ],
                            [
                                -80.21553,
                                51.30128
                            ],
                            [
                                -80.38958,
                                51.34814
                            ],
                            [
                                -80.42899,
                                51.47102
                            ],
                            [
                                -80.51,
                                51.54607
                            ],
                            [
                                -80.57141,
                                51.70692
                            ],
                            [
                                -80.65798,
                                51.79183
                            ],
                            [
                                -80.88113,
                                51.89785
                            ],
                            [
                                -80.98529,
                                52.00917
                            ],
                            [
                                -81.08634,
                                52.05681
                            ],
                            [
                                -81.15123,
                                52.04335
                            ],
                            [
                                -81.36104,
                                52.10712
                            ],
                            [
                                -81.47643,
                                52.21758
                            ],
                            [
                                -81.4578,
                                52.25011
                            ],
                            [
                                -81.55711,
                                52.30219
                            ],
                            [
                                -81.53179,
                                52.43156
                            ],
                            [
                                -81.64018,
                                52.49532
                            ],
                            [
                                -81.76905,
                                52.61056
                            ],
                            [
                                -81.87679,
                                52.66567
                            ],
                            [
                                -81.95453,
                                52.77777
                            ],
                            [
                                -82.10481,
                                52.88167
                            ],
                            [
                                -82.23667,
                                52.92732
                            ],
                            [
                                -82.28257,
                                53.06461
                            ],
                            [
                                -82.2372,
                                53.19404
                            ],
                            [
                                -82.11038,
                                53.26334
                            ],
                            [
                                -82.10138,
                                53.29951
                            ],
                            [
                                -82.20474,
                                53.59303
                            ],
                            [
                                -82.10854,
                                53.79057
                            ],
                            [
                                -82.22228,
                                54.03711
                            ],
                            [
                                -82.41118,
                                54.19933
                            ],
                            [
                                -82.41509,
                                54.32977
                            ],
                            [
                                -82.32734,
                                54.48378
                            ],
                            [
                                -82.28054,
                                54.65548
                            ],
                            [
                                -82.195,
                                54.79924
                            ],
                            [
                                -82.27502,
                                55.03055
                            ],
                            [
                                -82.25247,
                                55.10863
                            ],
                            [
                                -82.48088,
                                55.11307
                            ],
                            [
                                -82.68989,
                                55.19142
                            ],
                            [
                                -82.77471,
                                55.13273
                            ],
                            [
                                -82.88333,
                                55.14788
                            ],
                            [
                                -82.967,
                                55.21928
                            ],
                            [
                                -83.13469,
                                55.19484
                            ],
                            [
                                -83.33318,
                                55.1946
                            ],
                            [
                                -83.54058,
                                55.23686
                            ],
                            [
                                -83.67478,
                                55.2238
                            ],
                            [
                                -83.88914,
                                55.29219
                            ],
                            [
                                -84.08023,
                                55.25125
                            ],
                            [
                                -84.30736,
                                55.27268
                            ],
                            [
                                -84.488,
                                55.23766
                            ],
                            [
                                -84.78542,
                                55.23734
                            ],
                            [
                                -84.97732,
                                55.27984
                            ],
                            [
                                -85.05577,
                                55.27502
                            ],
                            [
                                -85.23374,
                                55.37059
                            ],
                            [
                                -85.33996,
                                55.37722
                            ],
                            [
                                -85.49581,
                                55.45207
                            ],
                            [
                                -85.6446,
                                55.5577
                            ],
                            [
                                -85.94416,
                                55.66913
                            ],
                            [
                                -86.0476,
                                55.67147
                            ],
                            [
                                -86.26531,
                                55.71209
                            ],
                            [
                                -86.39019,
                                55.76877
                            ],
                            [
                                -86.66181,
                                55.83622
                            ],
                            [
                                -86.88788,
                                55.91095
                            ],
                            [
                                -87.19805,
                                55.93534
                            ],
                            [
                                -87.48219,
                                56.01668
                            ],
                            [
                                -87.58328,
                                56.00504
                            ],
                            [
                                -87.58388,
                                56.07891
                            ],
                            [
                                -87.64508,
                                56.10495
                            ],
                            [
                                -87.72588,
                                56.23026
                            ],
                            [
                                -87.83136,
                                56.3391
                            ],
                            [
                                -87.9263,
                                56.39832
                            ],
                            [
                                -87.97362,
                                56.46674
                            ],
                            [
                                -88.34449,
                                56.56517
                            ],
                            [
                                -88.5076,
                                56.65473
                            ],
                            [
                                -88.64853,
                                56.69085
                            ],
                            [
                                -88.79352,
                                56.77896
                            ],
                            [
                                -88.81314,
                                56.83266
                            ],
                            [
                                -89.0589,
                                56.85278
                            ],
                            [
                                -89.4007,
                                56.9244
                            ],
                            [
                                -89.5028,
                                56.92574
                            ],
                            [
                                -89.88748,
                                56.99869
                            ],
                            [
                                -90.16104,
                                57.07503
                            ],
                            [
                                -90.4677,
                                57.19571
                            ],
                            [
                                -90.63038,
                                57.23547
                            ],
                            [
                                -90.69197,
                                57.22546
                            ],
                            [
                                -90.87382,
                                57.26481
                            ],
                            [
                                -91.138,
                                57.24984
                            ],
                            [
                                -91.3762,
                                57.2017
                            ],
                            [
                                -91.96271,
                                57.05629
                            ],
                            [
                                -92.1378,
                                57.04576
                            ],
                            [
                                -92.2244,
                                57.07057
                            ],
                            [
                                -92.47679,
                                57.03596
                            ],
                            [
                                -92.62721,
                                56.97213
                            ],
                            [
                                -92.67707,
                                56.99388
                            ],
                            [
                                -92.53926,
                                57.10986
                            ],
                            [
                                -92.45139,
                                57.23544
                            ],
                            [
                                -92.42597,
                                57.33008
                            ],
                            [
                                -92.49898,
                                57.52372
                            ],
                            [
                                -92.71684,
                                57.78384
                            ],
                            [
                                -92.7729,
                                57.90327
                            ],
                            [
                                -92.84963,
                                58.13174
                            ],
                            [
                                -92.92848,
                                58.20158
                            ],
                            [
                                -92.97573,
                                58.30997
                            ],
                            [
                                -93.03934,
                                58.36214
                            ],
                            [
                                -93.12587,
                                58.52513
                            ],
                            [
                                -93.14606,
                                58.68266
                            ],
                            [
                                -93.20097,
                                58.75738
                            ],
                            [
                                -93.37691,
                                58.74861
                            ],
                            [
                                -93.61121,
                                58.77067
                            ],
                            [
                                -94.0753,
                                58.76304
                            ],
                            [
                                -94.22556,
                                58.79426
                            ],
                            [
                                -94.33637,
                                58.71464
                            ],
                            [
                                -94.47364,
                                58.73742
                            ],
                            [
                                -94.51227,
                                58.82106
                            ],
                            [
                                -94.60531,
                                58.88038
                            ],
                            [
                                -94.60783,
                                58.94126
                            ],
                            [
                                -94.70368,
                                58.96798
                            ],
                            [
                                -94.79863,
                                59.08214
                            ],
                            [
                                -94.7822,
                                59.26814
                            ],
                            [
                                -94.71506,
                                59.32522
                            ],
                            [
                                -94.7397,
                                59.44934
                            ],
                            [
                                -94.79349,
                                59.51753
                            ],
                            [
                                -94.80745,
                                59.61733
                            ],
                            [
                                -94.78927,
                                59.803
                            ],
                            [
                                -94.8361,
                                59.96638
                            ],
                            [
                                -94.70475,
                                60.10061
                            ],
                            [
                                -94.72672,
                                60.16098
                            ],
                            [
                                -94.69384,
                                60.2814
                            ],
                            [
                                -94.61721,
                                60.37544
                            ],
                            [
                                -94.68019,
                                60.46208
                            ],
                            [
                                -94.79629,
                                60.48822
                            ],
                            [
                                -94.76028,
                                60.53241
                            ],
                            [
                                -94.59986,
                                60.51029
                            ],
                            [
                                -94.5365,
                                60.54192
                            ],
                            [
                                -94.50031,
                                60.63858
                            ],
                            [
                                -94.42386,
                                60.70016
                            ],
                            [
                                -94.31491,
                                60.85733
                            ],
                            [
                                -94.22448,
                                60.8929
                            ],
                            [
                                -94.16382,
                                61.02526
                            ],
                            [
                                -94.08739,
                                61.0729
                            ],
                            [
                                -93.97352,
                                61.28702
                            ],
                            [
                                -93.85292,
                                61.31028
                            ],
                            [
                                -93.86699,
                                61.38315
                            ],
                            [
                                -93.98012,
                                61.37557
                            ],
                            [
                                -93.97437,
                                61.45772
                            ],
                            [
                                -93.84869,
                                61.54469
                            ],
                            [
                                -93.51736,
                                61.67781
                            ],
                            [
                                -93.34097,
                                61.70426
                            ],
                            [
                                -93.27671,
                                61.74473
                            ],
                            [
                                -93.65849,
                                61.88196
                            ],
                            [
                                -93.53719,
                                61.88484
                            ],
                            [
                                -93.54967,
                                61.94069
                            ],
                            [
                                -93.4101,
                                61.953
                            ],
                            [
                                -93.12451,
                                62.11177
                            ],
                            [
                                -93.12781,
                                62.18302
                            ],
                            [
                                -92.75065,
                                62.22854
                            ],
                            [
                                -92.84383,
                                62.27631
                            ],
                            [
                                -92.75134,
                                62.30639
                            ],
                            [
                                -92.64737,
                                62.27099
                            ],
                            [
                                -92.57934,
                                62.32724
                            ],
                            [
                                -92.6761,
                                62.39089
                            ],
                            [
                                -92.72805,
                                62.47766
                            ],
                            [
                                -92.54881,
                                62.46891
                            ],
                            [
                                -92.48501,
                                62.53982
                            ],
                            [
                                -92.38961,
                                62.52584
                            ],
                            [
                                -92.31449,
                                62.57313
                            ],
                            [
                                -92.08036,
                                62.52895
                            ],
                            [
                                -91.94859,
                                62.52871
                            ],
                            [
                                -91.85762,
                                62.61925
                            ],
                            [
                                -92.15963,
                                62.66304
                            ],
                            [
                                -92.34617,
                                62.73214
                            ],
                            [
                                -92.42566,
                                62.80178
                            ],
                            [
                                -92.28377,
                                62.83867
                            ],
                            [
                                -92.15473,
                                62.78516
                            ],
                            [
                                -92.06131,
                                62.80576
                            ],
                            [
                                -92.10357,
                                62.86148
                            ],
                            [
                                -91.84809,
                                62.82388
                            ],
                            [
                                -91.77945,
                                62.83382
                            ],
                            [
                                -91.55262,
                                62.79128
                            ],
                            [
                                -91.40925,
                                62.79109
                            ],
                            [
                                -91.34701,
                                62.83111
                            ],
                            [
                                -91.1808,
                                62.86806
                            ],
                            [
                                -91.01191,
                                62.93652
                            ],
                            [
                                -90.75037,
                                62.93362
                            ],
                            [
                                -90.65131,
                                63.02803
                            ],
                            [
                                -90.69634,
                                63.26071
                            ],
                            [
                                -90.74807,
                                63.2919
                            ],
                            [
                                -90.67674,
                                63.35293
                            ],
                            [
                                -90.82228,
                                63.39064
                            ],
                            [
                                -90.99576,
                                63.46987
                            ],
                            [
                                -91.38676,
                                63.5139
                            ],
                            [
                                -91.51275,
                                63.57372
                            ],
                            [
                                -91.63701,
                                63.58023
                            ],
                            [
                                -91.60224,
                                63.64895
                            ],
                            [
                                -91.78065,
                                63.71913
                            ],
                            [
                                -91.9963,
                                63.67906
                            ],
                            [
                                -92.05329,
                                63.63102
                            ],
                            [
                                -92.21563,
                                63.62984
                            ],
                            [
                                -92.16058,
                                63.71519
                            ],
                            [
                                -92.24345,
                                63.74421
                            ],
                            [
                                -92.38116,
                                63.72604
                            ],
                            [
                                -92.46444,
                                63.79925
                            ],
                            [
                                -92.62752,
                                63.77313
                            ],
                            [
                                -92.80345,
                                63.83161
                            ],
                            [
                                -93.09759,
                                63.87195
                            ],
                            [
                                -93.36466,
                                63.96568
                            ],
                            [
                                -93.44568,
                                63.95263
                            ],
                            [
                                -93.38044,
                                63.83795
                            ],
                            [
                                -93.59182,
                                63.86845
                            ],
                            [
                                -93.73849,
                                63.97639
                            ],
                            [
                                -93.43909,
                                63.9989
                            ],
                            [
                                -93.13336,
                                63.9528
                            ],
                            [
                                -92.96242,
                                63.94054
                            ],
                            [
                                -92.92576,
                                63.89427
                            ],
                            [
                                -92.80052,
                                63.89049
                            ],
                            [
                                -92.64333,
                                63.82256
                            ],
                            [
                                -92.51811,
                                63.83325
                            ],
                            [
                                -92.35825,
                                63.76663
                            ],
                            [
                                -92.25094,
                                63.76907
                            ],
                            [
                                -92.09532,
                                63.73124
                            ],
                            [
                                -91.71472,
                                63.73631
                            ],
                            [
                                -91.53915,
                                63.72276
                            ],
                            [
                                -91.37588,
                                63.64858
                            ],
                            [
                                -90.99518,
                                63.59257
                            ],
                            [
                                -90.83491,
                                63.512
                            ],
                            [
                                -90.6314,
                                63.48969
                            ],
                            [
                                -90.55193,
                                63.52286
                            ],
                            [
                                -90.75551,
                                63.56854
                            ],
                            [
                                -90.30879,
                                63.62325
                            ],
                            [
                                -90.21015,
                                63.62384
                            ],
                            [
                                -90.05623,
                                63.75918
                            ],
                            [
                                -89.96656,
                                63.79124
                            ],
                            [
                                -90.1149,
                                63.89022
                            ],
                            [
                                -90.02446,
                                63.9387
                            ],
                            [
                                -89.82537,
                                63.92655
                            ],
                            [
                                -89.84731,
                                64.02969
                            ],
                            [
                                -89.93476,
                                64.07465
                            ],
                            [
                                -89.9674,
                                64.1577
                            ],
                            [
                                -89.79747,
                                64.13833
                            ],
                            [
                                -89.79247,
                                64.09807
                            ],
                            [
                                -89.5484,
                                64.01234
                            ],
                            [
                                -89.38488,
                                64.0426
                            ],
                            [
                                -89.24834,
                                63.97711
                            ],
                            [
                                -89.07365,
                                63.97725
                            ],
                            [
                                -89.11202,
                                64.03369
                            ],
                            [
                                -88.76103,
                                63.96483
                            ],
                            [
                                -88.57015,
                                63.99329
                            ],
                            [
                                -88.25914,
                                64.13978
                            ],
                            [
                                -88.04731,
                                64.18358
                            ],
                            [
                                -88.06328,
                                64.25066
                            ],
                            [
                                -87.85334,
                                64.37493
                            ],
                            [
                                -87.80801,
                                64.50846
                            ],
                            [
                                -87.55662,
                                64.56907
                            ],
                            [
                                -87.49994,
                                64.67458
                            ],
                            [
                                -87.31621,
                                64.74862
                            ],
                            [
                                -87.23828,
                                64.87401
                            ],
                            [
                                -87.16713,
                                64.93399
                            ],
                            [
                                -87.06422,
                                64.9548
                            ],
                            [
                                -87.06758,
                                65.02103
                            ],
                            [
                                -86.93824,
                                65.16203
                            ],
                            [
                                -87.01609,
                                65.23723
                            ],
                            [
                                -87.56218,
                                65.29139
                            ],
                            [
                                -88.30003,
                                65.28055
                            ],
                            [
                                -88.61031,
                                65.31541
                            ],
                            [
                                -89.02322,
                                65.32381
                            ],
                            [
                                -89.16684,
                                65.43927
                            ],
                            [
                                -89.34523,
                                65.49308
                            ],
                            [
                                -89.42871,
                                65.59852
                            ],
                            [
                                -89.57214,
                                65.63951
                            ],
                            [
                                -89.62598,
                                65.69124
                            ],
                            [
                                -90.04386,
                                65.81438
                            ],
                            [
                                -90.29712,
                                65.8565
                            ],
                            [
                                -90.00658,
                                65.88298
                            ],
                            [
                                -89.73144,
                                65.82569
                            ],
                            [
                                -89.6743,
                                65.94581
                            ],
                            [
                                -89.41939,
                                65.87299
                            ],
                            [
                                -89.13217,
                                65.76646
                            ],
                            [
                                -89.10318,
                                65.73793
                            ],
                            [
                                -88.7793,
                                65.6299
                            ],
                            [
                                -88.55486,
                                65.58968
                            ],
                            [
                                -88.4235,
                                65.54069
                            ],
                            [
                                -88.23011,
                                65.431
                            ],
                            [
                                -88.01594,
                                65.34455
                            ],
                            [
                                -87.87546,
                                65.3249
                            ],
                            [
                                -87.64628,
                                65.3323
                            ],
                            [
                                -87.34654,
                                65.32079
                            ],
                            [
                                -87.07049,
                                65.39539
                            ],
                            [
                                -87.07538,
                                65.4776
                            ],
                            [
                                -86.87436,
                                65.55923
                            ],
                            [
                                -86.69253,
                                65.60866
                            ],
                            [
                                -86.53343,
                                65.67542
                            ],
                            [
                                -86.39797,
                                65.8976
                            ],
                            [
                                -86.32643,
                                65.89993
                            ],
                            [
                                -85.99981,
                                66.01959
                            ],
                            [
                                -85.98624,
                                66.10157
                            ],
                            [
                                -85.86501,
                                66.16018
                            ],
                            [
                                -85.89996,
                                66.19512
                            ],
                            [
                                -86.31433,
                                66.28511
                            ],
                            [
                                -86.61411,
                                66.31648
                            ],
                            [
                                -86.76528,
                                66.43002
                            ],
                            [
                                -86.73602,
                                66.51625
                            ],
                            [
                                -86.27802,
                                66.53508
                            ],
                            [
                                -86.0391,
                                66.49485
                            ],
                            [
                                -85.78485,
                                66.50146
                            ],
                            [
                                -85.73673,
                                66.52455
                            ],
                            [
                                -85.41712,
                                66.57192
                            ],
                            [
                                -85.30856,
                                66.47248
                            ],
                            [
                                -85.27644,
                                66.31812
                            ],
                            [
                                -85.12206,
                                66.27637
                            ],
                            [
                                -84.83708,
                                66.25786
                            ],
                            [
                                -84.73958,
                                66.20704
                            ],
                            [
                                -84.55198,
                                66.21673
                            ],
                            [
                                -84.45082,
                                66.16107
                            ],
                            [
                                -84.3598,
                                66.21738
                            ],
                            [
                                -84.36291,
                                66.28103
                            ],
                            [
                                -84.15255,
                                66.30843
                            ],
                            [
                                -84.07748,
                                66.2417
                            ],
                            [
                                -83.92322,
                                66.19271
                            ],
                            [
                                -83.66749,
                                66.18304
                            ],
                            [
                                -83.77775,
                                66.30415
                            ],
                            [
                                -83.83168,
                                66.31499
                            ],
                            [
                                -83.88337,
                                66.44976
                            ],
                            [
                                -84.13683,
                                66.5634
                            ],
                            [
                                -84.10607,
                                66.681
                            ],
                            [
                                -84.40756,
                                66.72244
                            ],
                            [
                                -84.41511,
                                66.7844
                            ],
                            [
                                -84.61626,
                                66.87441
                            ],
                            [
                                -84.65655,
                                66.95189
                            ],
                            [
                                -84.83996,
                                66.9457
                            ],
                            [
                                -84.89888,
                                66.87461
                            ],
                            [
                                -85.09979,
                                66.83837
                            ],
                            [
                                -85.16618,
                                66.86153
                            ],
                            [
                                -85.02641,
                                66.96044
                            ],
                            [
                                -84.5231,
                                66.9782
                            ],
                            [
                                -84.40035,
                                66.92261
                            ],
                            [
                                -84.40683,
                                66.80227
                            ],
                            [
                                -84.26634,
                                66.79092
                            ],
                            [
                                -84.27429,
                                66.71777
                            ],
                            [
                                -83.98953,
                                66.69386
                            ],
                            [
                                -83.9518,
                                66.58985
                            ],
                            [
                                -83.63928,
                                66.51446
                            ],
                            [
                                -83.54254,
                                66.4407
                            ],
                            [
                                -83.53111,
                                66.33987
                            ],
                            [
                                -83.39378,
                                66.34748
                            ],
                            [
                                -83.23338,
                                66.39118
                            ],
                            [
                                -82.99139,
                                66.48888
                            ],
                            [
                                -82.99975,
                                66.54728
                            ],
                            [
                                -82.57238,
                                66.56942
                            ],
                            [
                                -82.46279,
                                66.67958
                            ],
                            [
                                -82.16138,
                                66.75501
                            ],
                            [
                                -81.98794,
                                66.9445
                            ],
                            [
                                -81.80936,
                                66.99541
                            ],
                            [
                                -81.71079,
                                66.96845
                            ],
                            [
                                -81.55439,
                                67.00867
                            ],
                            [
                                -81.46418,
                                66.9973
                            ],
                            [
                                -81.34807,
                                67.168
                            ],
                            [
                                -81.32717,
                                67.30725
                            ],
                            [
                                -81.19231,
                                67.45224
                            ],
                            [
                                -81.37782,
                                67.59493
                            ],
                            [
                                -81.5874,
                                67.66132
                            ],
                            [
                                -81.62279,
                                67.70846
                            ],
                            [
                                -81.83606,
                                67.76647
                            ],
                            [
                                -81.93863,
                                67.84883
                            ],
                            [
                                -82.08025,
                                67.90808
                            ],
                            [
                                -82.13307,
                                68.01793
                            ],
                            [
                                -82.0962,
                                68.10764
                            ],
                            [
                                -82.32996,
                                68.16201
                            ],
                            [
                                -82.21895,
                                68.2499
                            ],
                            [
                                -82.43691,
                                68.28344
                            ],
                            [
                                -82.21023,
                                68.36145
                            ],
                            [
                                -82.62118,
                                68.40003
                            ],
                            [
                                -82.45484,
                                68.479
                            ],
                            [
                                -82.21032,
                                68.45609
                            ],
                            [
                                -82.06133,
                                68.50571
                            ],
                            [
                                -81.9486,
                                68.41995
                            ],
                            [
                                -81.77898,
                                68.47269
                            ],
                            [
                                -81.72304,
                                68.52939
                            ],
                            [
                                -81.59879,
                                68.51504
                            ],
                            [
                                -81.32731,
                                68.59227
                            ],
                            [
                                -81.23654,
                                68.64067
                            ],
                            [
                                -81.20859,
                                68.77425
                            ],
                            [
                                -81.30165,
                                68.84967
                            ],
                            [
                                -81.56018,
                                68.87516
                            ],
                            [
                                -81.636,
                                68.90726
                            ],
                            [
                                -81.85484,
                                68.91223
                            ],
                            [
                                -81.51989,
                                69.00455
                            ],
                            [
                                -81.45818,
                                69.06922
                            ],
                            [
                                -81.30772,
                                69.09661
                            ],
                            [
                                -81.31273,
                                69.19076
                            ],
                            [
                                -81.44715,
                                69.19818
                            ],
                            [
                                -81.66556,
                                69.26472
                            ],
                            [
                                -81.99131,
                                69.27256
                            ],
                            [
                                -82.12169,
                                69.29197
                            ],
                            [
                                -82.29537,
                                69.36543
                            ],
                            [
                                -82.25761,
                                69.39337
                            ],
                            [
                                -82.62901,
                                69.47699
                            ],
                            [
                                -82.52157,
                                69.54501
                            ],
                            [
                                -82.63211,
                                69.61631
                            ],
                            [
                                -82.65376,
                                69.68198
                            ],
                            [
                                -83.2775,
                                69.70567
                            ],
                            [
                                -83.54764,
                                69.6861
                            ],
                            [
                                -83.94553,
                                69.74602
                            ],
                            [
                                -84.09228,
                                69.80348
                            ],
                            [
                                -84.29816,
                                69.84757
                            ],
                            [
                                -84.54718,
                                69.86339
                            ],
                            [
                                -84.80194,
                                69.84632
                            ],
                            [
                                -85.07516,
                                69.77732
                            ],
                            [
                                -85.37493,
                                69.82611
                            ],
                            [
                                -85.49607,
                                69.7557
                            ],
                            [
                                -85.39708,
                                69.72593
                            ],
                            [
                                -85.52331,
                                69.6558
                            ],
                            [
                                -85.46325,
                                69.60683
                            ],
                            [
                                -85.51183,
                                69.5234
                            ],
                            [
                                -85.42302,
                                69.32915
                            ],
                            [
                                -85.44821,
                                69.26325
                            ],
                            [
                                -85.34993,
                                69.22464
                            ],
                            [
                                -85.29337,
                                69.14714
                            ],
                            [
                                -84.74372,
                                69.05197
                            ],
                            [
                                -84.90204,
                                69.00708
                            ],
                            [
                                -85.13817,
                                68.82188
                            ],
                            [
                                -84.84898,
                                68.82263
                            ],
                            [
                                -84.76854,
                                68.73642
                            ],
                            [
                                -85.2154,
                                68.76521
                            ],
                            [
                                -85.61229,
                                68.73981
                            ],
                            [
                                -85.71628,
                                68.62811
                            ],
                            [
                                -85.69024,
                                68.40705
                            ],
                            [
                                -85.80968,
                                68.32187
                            ],
                            [
                                -85.76403,
                                68.29094
                            ],
                            [
                                -85.88491,
                                68.18525
                            ],
                            [
                                -85.83915,
                                68.14275
                            ],
                            [
                                -85.87404,
                                68.04444
                            ],
                            [
                                -86.05991,
                                67.98557
                            ],
                            [
                                -86.23996,
                                67.89217
                            ],
                            [
                                -86.50252,
                                67.69728
                            ],
                            [
                                -86.44106,
                                67.59723
                            ],
                            [
                                -86.51987,
                                67.47263
                            ],
                            [
                                -86.49523,
                                67.36032
                            ],
                            [
                                -86.66435,
                                67.37038
                            ],
                            [
                                -86.76361,
                                67.42091
                            ],
                            [
                                -87.06818,
                                67.32715
                            ],
                            [
                                -86.9613,
                                67.2519
                            ],
                            [
                                -87.06115,
                                67.21673
                            ],
                            [
                                -87.21751,
                                67.22567
                            ],
                            [
                                -87.43608,
                                67.30023
                            ],
                            [
                                -87.9394,
                                67.62026
                            ],
                            [
                                -88.11881,
                                67.67882
                            ],
                            [
                                -88.38588,
                                67.98197
                            ],
                            [
                                -88.27352,
                                68.10564
                            ],
                            [
                                -88.27115,
                                68.15566
                            ],
                            [
                                -88.38831,
                                68.28075
                            ],
                            [
                                -88.25857,
                                68.32349
                            ],
                            [
                                -88.18183,
                                68.25625
                            ],
                            [
                                -87.93087,
                                68.20845
                            ],
                            [
                                -87.78902,
                                68.3126
                            ],
                            [
                                -87.7818,
                                68.41116
                            ],
                            [
                                -87.93935,
                                68.6008
                            ],
                            [
                                -87.93378,
                                68.72932
                            ],
                            [
                                -88.07106,
                                68.84276
                            ],
                            [
                                -88.22067,
                                68.92035
                            ],
                            [
                                -88.63459,
                                69.04507
                            ],
                            [
                                -88.79074,
                                69.10747
                            ],
                            [
                                -88.96163,
                                69.24293
                            ],
                            [
                                -89.1246,
                                69.27577
                            ],
                            [
                                -89.37654,
                                69.2261
                            ],
                            [
                                -89.46601,
                                69.12825
                            ],
                            [
                                -89.63046,
                                69.05922
                            ],
                            [
                                -89.75286,
                                68.96559
                            ],
                            [
                                -89.67057,
                                68.80913
                            ],
                            [
                                -89.73705,
                                68.69352
                            ],
                            [
                                -89.83068,
                                68.69371
                            ],
                            [
                                -89.93596,
                                68.62184
                            ],
                            [
                                -89.83414,
                                68.53085
                            ],
                            [
                                -89.98289,
                                68.38286
                            ],
                            [
                                -90.27619,
                                68.25657
                            ],
                            [
                                -90.28335,
                                68.37439
                            ],
                            [
                                -90.52669,
                                68.41917
                            ],
                            [
                                -90.58488,
                                68.46406
                            ],
                            [
                                -90.46428,
                                68.5311
                            ],
                            [
                                -90.53857,
                                68.62891
                            ],
                            [
                                -90.46449,
                                68.71268
                            ],
                            [
                                -90.43275,
                                68.88285
                            ],
                            [
                                -90.58607,
                                68.94512
                            ],
                            [
                                -90.68976,
                                69.0364
                            ],
                            [
                                -90.64189,
                                69.08012
                            ],
                            [
                                -91.11969,
                                69.25227
                            ],
                            [
                                -90.81438,
                                69.25755
                            ],
                            [
                                -90.76784,
                                69.37268
                            ],
                            [
                                -90.42649,
                                69.4576
                            ],
                            [
                                -90.45554,
                                69.50382
                            ],
                            [
                                -90.68652,
                                69.54709
                            ],
                            [
                                -90.76105,
                                69.49485
                            ],
                            [
                                -90.99867,
                                69.53099
                            ],
                            [
                                -91.11795,
                                69.515
                            ],
                            [
                                -91.27374,
                                69.57335
                            ],
                            [
                                -91.18574,
                                69.65252
                            ],
                            [
                                -91.47764,
                                69.6574
                            ],
                            [
                                -91.80358,
                                69.48792
                            ],
                            [
                                -92.11573,
                                69.55677
                            ],
                            [
                                -92.26755,
                                69.66714
                            ],
                            [
                                -92.47399,
                                69.69899
                            ],
                            [
                                -92.62205,
                                69.68
                            ],
                            [
                                -92.74765,
                                69.73113
                            ],
                            [
                                -92.54493,
                                69.77499
                            ],
                            [
                                -92.28822,
                                69.87033
                            ],
                            [
                                -92.06326,
                                69.98914
                            ],
                            [
                                -91.94348,
                                70.01839
                            ],
                            [
                                -92.00769,
                                70.07182
                            ],
                            [
                                -92.15739,
                                70.09712
                            ],
                            [
                                -92.44853,
                                70.07808
                            ],
                            [
                                -92.42151,
                                70.18536
                            ],
                            [
                                -92.22694,
                                70.19624
                            ],
                            [
                                -91.98078,
                                70.12391
                            ],
                            [
                                -91.52546,
                                70.14904
                            ],
                            [
                                -91.70839,
                                70.31309
                            ],
                            [
                                -91.9016,
                                70.31499
                            ],
                            [
                                -92.25854,
                                70.56188
                            ],
                            [
                                -92.17279,
                                70.61358
                            ],
                            [
                                -92.41477,
                                70.66923
                            ],
                            [
                                -92.602,
                                70.68867
                            ],
                            [
                                -92.66549,
                                70.77642
                            ],
                            [
                                -92.94182,
                                70.82865
                            ],
                            [
                                -92.8737,
                                70.88205
                            ],
                            [
                                -92.89246,
                                70.95671
                            ],
                            [
                                -92.83596,
                                71.04658
                            ],
                            [
                                -92.84301,
                                71.16687
                            ],
                            [
                                -92.92201,
                                71.23021
                            ],
                            [
                                -92.9575,
                                71.35166
                            ],
                            [
                                -93.14467,
                                71.39342
                            ],
                            [
                                -93.19515,
                                71.46509
                            ],
                            [
                                -93.33673,
                                71.53398
                            ],
                            [
                                -93.63177,
                                71.58869
                            ],
                            [
                                -93.77185,
                                71.66342
                            ],
                            [
                                -93.67405,
                                71.75829
                            ],
                            [
                                -93.86821,
                                71.74766
                            ],
                            [
                                -94.07676,
                                71.76655
                            ],
                            [
                                -94.23411,
                                71.74927
                            ],
                            [
                                -94.36132,
                                71.77961
                            ],
                            [
                                -94.59054,
                                71.75661
                            ],
                            [
                                -94.59188,
                                71.83877
                            ],
                            [
                                -94.45348,
                                71.85276
                            ],
                            [
                                -94.38049,
                                71.94721
                            ],
                            [
                                -94.55825,
                                72.00124
                            ],
                            [
                                -95.17239,
                                71.95565
                            ],
                            [
                                -95.2661,
                                71.73689
                            ],
                            [
                                -95.47956,
                                71.73053
                            ],
                            [
                                -95.63913,
                                71.6564
                            ],
                            [
                                -95.88912,
                                71.60997
                            ],
                            [
                                -95.91402,
                                71.55098
                            ],
                            [
                                -95.81317,
                                71.5107
                            ],
                            [
                                -95.45389,
                                71.48594
                            ],
                            [
                                -95.53659,
                                71.41557
                            ],
                            [
                                -95.44183,
                                71.38841
                            ],
                            [
                                -95.54099,
                                71.29694
                            ],
                            [
                                -95.77673,
                                71.32825
                            ],
                            [
                                -95.8412,
                                71.38932
                            ],
                            [
                                -96.02742,
                                71.42066
                            ],
                            [
                                -96.17934,
                                71.39057
                            ],
                            [
                                -96.26647,
                                71.29044
                            ],
                            [
                                -96.44713,
                                71.27714
                            ],
                            [
                                -96.40405,
                                71.16926
                            ],
                            [
                                -96.52348,
                                71.1304
                            ],
                            [
                                -96.43173,
                                71.07872
                            ],
                            [
                                -96.5715,
                                70.78265
                            ],
                            [
                                -96.42729,
                                70.74843
                            ],
                            [
                                -96.335,
                                70.67216
                            ],
                            [
                                -96.15908,
                                70.61829
                            ],
                            [
                                -96.29183,
                                70.49727
                            ],
                            [
                                -96.3108,
                                70.41022
                            ],
                            [
                                -96.48544,
                                70.37372
                            ],
                            [
                                -96.54482,
                                70.30069
                            ],
                            [
                                -96.47432,
                                70.09383
                            ],
                            [
                                -96.05246,
                                69.8989
                            ],
                            [
                                -96.17539,
                                69.86156
                            ],
                            [
                                -96.02997,
                                69.81432
                            ],
                            [
                                -95.68736,
                                69.79178
                            ],
                            [
                                -95.36492,
                                69.67532
                            ],
                            [
                                -94.95057,
                                69.60338
                            ],
                            [
                                -94.80599,
                                69.56379
                            ],
                            [
                                -94.60735,
                                69.67747
                            ],
                            [
                                -94.48792,
                                69.56134
                            ],
                            [
                                -94.27663,
                                69.44233
                            ],
                            [
                                -93.92938,
                                69.43753
                            ],
                            [
                                -93.59364,
                                69.53598
                            ],
                            [
                                -93.42769,
                                69.48271
                            ],
                            [
                                -93.54079,
                                69.38835
                            ],
                            [
                                -93.45953,
                                69.31965
                            ],
                            [
                                -93.81506,
                                69.16913
                            ],
                            [
                                -93.85257,
                                69.26341
                            ],
                            [
                                -93.64829,
                                69.35777
                            ],
                            [
                                -93.9394,
                                69.36602
                            ],
                            [
                                -94.21587,
                                69.33494
                            ],
                            [
                                -94.29617,
                                69.16688
                            ],
                            [
                                -94.158,
                                69.08756
                            ],
                            [
                                -94.30139,
                                69.03987
                            ],
                            [
                                -94.40551,
                                68.95234
                            ],
                            [
                                -94.58158,
                                68.97337
                            ],
                            [
                                -94.52535,
                                68.89177
                            ],
                            [
                                -94.5922,
                                68.76851
                            ],
                            [
                                -94.38221,
                                68.7279
                            ],
                            [
                                -94.24207,
                                68.76093
                            ],
                            [
                                -94.07332,
                                68.76295
                            ],
                            [
                                -93.99299,
                                68.84099
                            ],
                            [
                                -94.05516,
                                68.89585
                            ],
                            [
                                -93.83696,
                                68.97394
                            ],
                            [
                                -93.64086,
                                68.97554
                            ],
                            [
                                -93.56822,
                                68.85491
                            ],
                            [
                                -93.7188,
                                68.62495
                            ],
                            [
                                -93.54925,
                                68.61355
                            ],
                            [
                                -93.59277,
                                68.54978
                            ],
                            [
                                -93.73248,
                                68.5065
                            ],
                            [
                                -94.01345,
                                68.45435
                            ],
                            [
                                -94.17783,
                                68.38077
                            ],
                            [
                                -94.15659,
                                68.28837
                            ],
                            [
                                -94.57724,
                                68.14808
                            ],
                            [
                                -94.70035,
                                68.0566
                            ],
                            [
                                -94.84608,
                                68.03452
                            ],
                            [
                                -95.00525,
                                68.04669
                            ],
                            [
                                -95.08165,
                                68.08881
                            ],
                            [
                                -95.42572,
                                68.06306
                            ],
                            [
                                -95.39439,
                                68.02123
                            ],
                            [
                                -95.52629,
                                67.91594
                            ],
                            [
                                -95.49069,
                                67.86382
                            ],
                            [
                                -95.6859,
                                67.748
                            ],
                            [
                                -95.66764,
                                67.69978
                            ],
                            [
                                -95.48807,
                                67.65688
                            ],
                            [
                                -95.31632,
                                67.56468
                            ],
                            [
                                -95.28974,
                                67.51468
                            ],
                            [
                                -95.38206,
                                67.47258
                            ],
                            [
                                -95.28817,
                                67.34225
                            ],
                            [
                                -95.14111,
                                67.29698
                            ],
                            [
                                -95.50739,
                                67.24665
                            ],
                            [
                                -95.58309,
                                67.20718
                            ],
                            [
                                -95.74018,
                                67.2086
                            ],
                            [
                                -95.52471,
                                67.32903
                            ],
                            [
                                -95.76773,
                                67.3383
                            ],
                            [
                                -96.08431,
                                67.22509
                            ],
                            [
                                -96.20121,
                                67.28787
                            ],
                            [
                                -96.09087,
                                67.4041
                            ],
                            [
                                -96.27495,
                                67.45686
                            ],
                            [
                                -96.40217,
                                67.52633
                            ],
                            [
                                -96.28669,
                                67.61845
                            ],
                            [
                                -96.15029,
                                67.6207
                            ],
                            [
                                -96.1339,
                                67.69997
                            ],
                            [
                                -96.18877,
                                67.80454
                            ],
                            [
                                -96.12511,
                                67.94346
                            ],
                            [
                                -95.99604,
                                68.12576
                            ],
                            [
                                -95.99386,
                                68.24931
                            ],
                            [
                                -96.29267,
                                68.19723
                            ],
                            [
                                -96.41551,
                                68.15695
                            ],
                            [
                                -96.66315,
                                68.00995
                            ],
                            [
                                -96.73799,
                                68.06939
                            ],
                            [
                                -96.57877,
                                68.12549
                            ],
                            [
                                -96.43667,
                                68.24578
                            ],
                            [
                                -96.70987,
                                68.28142
                            ],
                            [
                                -96.89856,
                                68.25011
                            ],
                            [
                                -96.97322,
                                68.34178
                            ],
                            [
                                -97.16038,
                                68.41949
                            ],
                            [
                                -97.3002,
                                68.50407
                            ],
                            [
                                -97.64627,
                                68.52334
                            ],
                            [
                                -97.89882,
                                68.55303
                            ],
                            [
                                -97.99381,
                                68.5198
                            ],
                            [
                                -97.85898,
                                68.45631
                            ],
                            [
                                -97.84497,
                                68.38637
                            ],
                            [
                                -98.19483,
                                68.3194
                            ],
                            [
                                -98.33737,
                                68.37679
                            ],
                            [
                                -98.48055,
                                68.33646
                            ],
                            [
                                -98.64185,
                                68.33408
                            ],
                            [
                                -98.41117,
                                68.21289
                            ],
                            [
                                -98.29241,
                                68.18157
                            ],
                            [
                                -98.26811,
                                68.12042
                            ],
                            [
                                -98.43136,
                                68.08603
                            ],
                            [
                                -98.38564,
                                68.02608
                            ],
                            [
                                -98.18344,
                                67.92356
                            ],
                            [
                                -98.04272,
                                67.92045
                            ],
                            [
                                -97.64561,
                                68.00165
                            ],
                            [
                                -97.43396,
                                67.92346
                            ],
                            [
                                -97.13028,
                                67.85046
                            ],
                            [
                                -97.08916,
                                67.70862
                            ],
                            [
                                -97.19457,
                                67.65425
                            ],
                            [
                                -97.54496,
                                67.60086
                            ],
                            [
                                -97.75092,
                                67.68259
                            ],
                            [
                                -97.9312,
                                67.70943
                            ],
                            [
                                -98.10093,
                                67.78161
                            ],
                            [
                                -98.20265,
                                67.91722
                            ],
                            [
                                -98.50952,
                                68.04538
                            ],
                            [
                                -98.7171,
                                68.07438
                            ],
                            [
                                -98.69777,
                                67.97342
                            ],
                            [
                                -98.51591,
                                67.87001
                            ],
                            [
                                -98.41591,
                                67.87195
                            ],
                            [
                                -98.33327,
                                67.80319
                            ],
                            [
                                -98.48249,
                                67.77906
                            ],
                            [
                                -98.6487,
                                67.80906
                            ],
                            [
                                -98.77983,
                                67.74407
                            ],
                            [
                                -99.2279,
                                67.72934
                            ],
                            [
                                -99.30074,
                                67.774
                            ],
                            [
                                -99.47323,
                                67.80478
                            ],
                            [
                                -100.04382,
                                67.8164
                            ],
                            [
                                -100.23757,
                                67.85461
                            ],
                            [
                                -100.49957,
                                67.81762
                            ],
                            [
                                -100.66035,
                                67.85437
                            ],
                            [
                                -100.93402,
                                67.75721
                            ],
                            [
                                -101.20587,
                                67.78452
                            ],
                            [
                                -101.20848,
                                67.74399
                            ],
                            [
                                -101.52033,
                                67.68294
                            ],
                            [
                                -101.7737,
                                67.7034
                            ],
                            [
                                -101.92383,
                                67.76046
                            ],
                            [
                                -102.15487,
                                67.74984
                            ],
                            [
                                -102.23895,
                                67.72358
                            ],
                            [
                                -102.42588,
                                67.78732
                            ],
                            [
                                -102.61647,
                                67.7938
                            ],
                            [
                                -102.83972,
                                67.83841
                            ],
                            [
                                -102.92817,
                                67.93123
                            ],
                            [
                                -103.0853,
                                67.91657
                            ],
                            [
                                -103.33577,
                                68.00587
                            ],
                            [
                                -103.382,
                                68.15669
                            ],
                            [
                                -103.485,
                                68.14438
                            ],
                            [
                                -103.49701,
                                68.07356
                            ],
                            [
                                -103.8315,
                                68.02209
                            ],
                            [
                                -104.0082,
                                68.04946
                            ],
                            [
                                -104.1534,
                                68.01768
                            ],
                            [
                                -104.34198,
                                68.04837
                            ],
                            [
                                -104.48574,
                                68.02883
                            ],
                            [
                                -104.64105,
                                68.15587
                            ],
                            [
                                -104.56305,
                                68.24658
                            ],
                            [
                                -104.70368,
                                68.25815
                            ],
                            [
                                -104.79843,
                                68.31707
                            ],
                            [
                                -105.19556,
                                68.32048
                            ],
                            [
                                -105.32055,
                                68.38596
                            ],
                            [
                                -105.47745,
                                68.42739
                            ],
                            [
                                -105.37708,
                                68.51465
                            ],
                            [
                                -105.52222,
                                68.67492
                            ],
                            [
                                -105.43551,
                                68.73575
                            ],
                            [
                                -105.76944,
                                68.88252
                            ],
                            [
                                -106.22295,
                                68.91373
                            ],
                            [
                                -106.45887,
                                68.87702
                            ],
                            [
                                -106.66423,
                                68.81654
                            ],
                            [
                                -106.7978,
                                68.81719
                            ],
                            [
                                -107.27031,
                                68.70525
                            ],
                            [
                                -107.70094,
                                68.65553
                            ],
                            [
                                -108.25786,
                                68.63198
                            ],
                            [
                                -108.3539,
                                68.60399
                            ],
                            [
                                -108.60418,
                                68.39169
                            ],
                            [
                                -108.68993,
                                68.3658
                            ],
                            [
                                -108.67382,
                                68.25081
                            ],
                            [
                                -108.35797,
                                68.29872
                            ],
                            [
                                -108.27984,
                                68.20813
                            ],
                            [
                                -107.89235,
                                68.14626
                            ],
                            [
                                -107.71773,
                                68.20866
                            ],
                            [
                                -107.85592,
                                68.25293
                            ],
                            [
                                -107.84556,
                                68.32734
                            ],
                            [
                                -107.60175,
                                68.35518
                            ],
                            [
                                -107.28198,
                                68.32683
                            ],
                            [
                                -107.2026,
                                68.27814
                            ],
                            [
                                -107.03772,
                                68.33325
                            ],
                            [
                                -106.80205,
                                68.33314
                            ],
                            [
                                -106.78928,
                                68.41336
                            ],
                            [
                                -106.54581,
                                68.35637
                            ],
                            [
                                -106.44383,
                                68.40736
                            ],
                            [
                                -106.60943,
                                68.47345
                            ],
                            [
                                -106.46563,
                                68.53686
                            ],
                            [
                                -106.04439,
                                68.59508
                            ],
                            [
                                -105.88924,
                                68.64168
                            ],
                            [
                                -105.77446,
                                68.61233
                            ],
                            [
                                -105.67283,
                                68.49627
                            ],
                            [
                                -105.70824,
                                68.43416
                            ],
                            [
                                -106.0817,
                                68.38352
                            ],
                            [
                                -106.20677,
                                68.39653
                            ],
                            [
                                -106.48654,
                                68.24529
                            ],
                            [
                                -106.7696,
                                68.20794
                            ],
                            [
                                -106.70755,
                                68.13268
                            ],
                            [
                                -106.8698,
                                68.12416
                            ],
                            [
                                -107.37264,
                                68.04413
                            ],
                            [
                                -107.55043,
                                68.06581
                            ],
                            [
                                -107.65929,
                                68.05404
                            ],
                            [
                                -107.67332,
                                68.03354
                            ],
                            [
                                -107.71916,
                                68.02609
                            ],
                            [
                                -107.7004,
                                67.89664
                            ],
                            [
                                -107.94966,
                                67.84658
                            ],
                            [
                                -108.02538,
                                67.74866
                            ],
                            [
                                -107.90711,
                                67.67431
                            ],
                            [
                                -107.66013,
                                67.56849
                            ],
                            [
                                -107.56961,
                                67.50218
                            ],
                            [
                                -107.63347,
                                67.45729
                            ],
                            [
                                -107.57722,
                                67.2655
                            ],
                            [
                                -107.52091,
                                67.2079
                            ],
                            [
                                -107.37256,
                                67.14096
                            ],
                            [
                                -107.21944,
                                67.12861
                            ],
                            [
                                -107.36411,
                                67.02988
                            ],
                            [
                                -107.19007,
                                66.96981
                            ],
                            [
                                -107.4164,
                                66.88524
                            ],
                            [
                                -107.56998,
                                66.91862
                            ],
                            [
                                -107.60069,
                                66.98269
                            ],
                            [
                                -107.75908,
                                66.95235
                            ],
                            [
                                -107.68641,
                                66.86576
                            ],
                            [
                                -107.6785,
                                66.75359
                            ],
                            [
                                -107.53232,
                                66.6296
                            ],
                            [
                                -107.52344,
                                66.57259
                            ],
                            [
                                -107.41512,
                                66.53494
                            ],
                            [
                                -107.16103,
                                66.37278
                            ],
                            [
                                -107.22864,
                                66.353
                            ],
                            [
                                -107.41571,
                                66.46846
                            ],
                            [
                                -107.5016,
                                66.5446
                            ],
                            [
                                -107.60508,
                                66.56882
                            ],
                            [
                                -107.78528,
                                66.70691
                            ],
                            [
                                -107.94048,
                                66.73113
                            ],
                            [
                                -107.96481,
                                66.83754
                            ],
                            [
                                -108.10394,
                                66.85168
                            ],
                            [
                                -108.0842,
                                66.9199
                            ],
                            [
                                -108.15691,
                                66.97192
                            ],
                            [
                                -108.31449,
                                66.9889
                            ],
                            [
                                -108.13827,
                                67.07148
                            ],
                            [
                                -107.98307,
                                67.08598
                            ],
                            [
                                -107.86576,
                                67.14621
                            ],
                            [
                                -107.97366,
                                67.28656
                            ],
                            [
                                -108.10617,
                                67.32495
                            ],
                            [
                                -108.30277,
                                67.4266
                            ],
                            [
                                -108.46981,
                                67.36915
                            ],
                            [
                                -108.5573,
                                67.59766
                            ],
                            [
                                -108.70231,
                                67.58123
                            ],
                            [
                                -108.71378,
                                67.45709
                            ],
                            [
                                -108.76862,
                                67.36144
                            ],
                            [
                                -108.98448,
                                67.48456
                            ],
                            [
                                -108.91552,
                                67.51239
                            ],
                            [
                                -108.97381,
                                67.66559
                            ],
                            [
                                -109.049,
                                67.72975
                            ],
                            [
                                -109.26543,
                                67.72396
                            ],
                            [
                                -109.46099,
                                67.75089
                            ],
                            [
                                -109.49453,
                                67.69606
                            ],
                            [
                                -109.71743,
                                67.73863
                            ],
                            [
                                -109.70759,
                                67.79698
                            ],
                            [
                                -109.78926,
                                67.86715
                            ],
                            [
                                -109.97305,
                                67.90214
                            ],
                            [
                                -109.97368,
                                67.97327
                            ],
                            [
                                -110.13974,
                                68.0132
                            ],
                            [
                                -110.69782,
                                67.86855
                            ],
                            [
                                -110.82581,
                                67.8036
                            ],
                            [
                                -110.97624,
                                67.77189
                            ],
                            [
                                -111.19099,
                                67.83729
                            ],
                            [
                                -111.3415,
                                67.7938
                            ],
                            [
                                -111.37196,
                                67.74644
                            ],
                            [
                                -111.62182,
                                67.72945
                            ],
                            [
                                -111.80001,
                                67.76144
                            ],
                            [
                                -111.98153,
                                67.75214
                            ],
                            [
                                -112.43025,
                                67.68114
                            ],
                            [
                                -112.99348,
                                67.6717
                            ],
                            [
                                -113.1282,
                                67.702
                            ],
                            [
                                -113.69826,
                                67.68874
                            ],
                            [
                                -113.90112,
                                67.71485
                            ],
                            [
                                -114.37762,
                                67.74768
                            ],
                            [
                                -114.49124,
                                67.78701
                            ],
                            [
                                -114.70533,
                                67.81885
                            ],
                            [
                                -114.98539,
                                67.79409
                            ],
                            [
                                -115.19228,
                                67.83294
                            ],
                            [
                                -115.55307,
                                67.92245
                            ],
                            [
                                -115.19518,
                                67.98073
                            ],
                            [
                                -115.21407,
                                68.09385
                            ],
                            [
                                -115.14471,
                                68.18513
                            ],
                            [
                                -114.86821,
                                68.15175
                            ],
                            [
                                -114.62357,
                                68.23844
                            ],
                            [
                                -114.44259,
                                68.26385
                            ],
                            [
                                -114.33905,
                                68.2301
                            ],
                            [
                                -114.0451,
                                68.29538
                            ],
                            [
                                -113.89154,
                                68.39686
                            ],
                            [
                                -114.04813,
                                68.42789
                            ],
                            [
                                -114.10373,
                                68.52589
                            ],
                            [
                                -114.18099,
                                68.56766
                            ],
                            [
                                -114.39431,
                                68.61735
                            ],
                            [
                                -114.54629,
                                68.7283
                            ],
                            [
                                -114.74838,
                                68.74777
                            ],
                            [
                                -114.82466,
                                68.81703
                            ],
                            [
                                -114.97731,
                                68.86957
                            ],
                            [
                                -115.28421,
                                68.90518
                            ],
                            [
                                -115.60024,
                                68.98107
                            ],
                            [
                                -115.82445,
                                68.93232
                            ],
                            [
                                -116.20522,
                                68.99203
                            ],
                            [
                                -116.31923,
                                68.95138
                            ],
                            [
                                -116.1374,
                                68.90913
                            ],
                            [
                                -116.01138,
                                68.80754
                            ],
                            [
                                -116.33168,
                                68.87796
                            ],
                            [
                                -116.65116,
                                68.87018
                            ],
                            [
                                -116.84231,
                                68.88873
                            ],
                            [
                                -116.91568,
                                68.93446
                            ],
                            [
                                -117.17103,
                                68.90197
                            ],
                            [
                                -117.38117,
                                68.96271
                            ],
                            [
                                -117.71188,
                                68.97923
                            ],
                            [
                                -117.98053,
                                69.01694
                            ],
                            [
                                -118.12159,
                                69.06219
                            ],
                            [
                                -118.42703,
                                69.12164
                            ],
                            [
                                -118.66658,
                                69.22758
                            ],
                            [
                                -119.24832,
                                69.30414
                            ],
                            [
                                -119.56715,
                                69.31379
                            ],
                            [
                                -119.821,
                                69.34852
                            ],
                            [
                                -119.95159,
                                69.34579
                            ],
                            [
                                -120.40067,
                                69.44262
                            ],
                            [
                                -120.92022,
                                69.65972
                            ],
                            [
                                -121.10148,
                                69.68294
                            ],
                            [
                                -121.41096,
                                69.77363
                            ],
                            [
                                -121.68252,
                                69.79684
                            ],
                            [
                                -122.34385,
                                69.82443
                            ],
                            [
                                -122.601,
                                69.8095
                            ],
                            [
                                -122.69369,
                                69.778
                            ],
                            [
                                -122.93361,
                                69.81419
                            ],
                            [
                                -123.13786,
                                69.76764
                            ],
                            [
                                -123.08817,
                                69.67656
                            ],
                            [
                                -123.15659,
                                69.60916
                            ],
                            [
                                -123.13137,
                                69.55369
                            ],
                            [
                                -123.21111,
                                69.48073
                            ],
                            [
                                -123.36039,
                                69.47715
                            ],
                            [
                                -123.38373,
                                69.41415
                            ],
                            [
                                -123.7107,
                                69.33492
                            ],
                            [
                                -123.91137,
                                69.35401
                            ],
                            [
                                -124.01377,
                                69.32734
                            ],
                            [
                                -124.3692,
                                69.34079
                            ],
                            [
                                -124.49704,
                                69.36876
                            ],
                            [
                                -124.44764,
                                69.47787
                            ],
                            [
                                -124.25629,
                                69.55624
                            ],
                            [
                                -124.20293,
                                69.62636
                            ],
                            [
                                -124.04394,
                                69.6799
                            ],
                            [
                                -124.20512,
                                69.72382
                            ],
                            [
                                -124.3438,
                                69.69754
                            ],
                            [
                                -124.50876,
                                69.71454
                            ],
                            [
                                -124.42179,
                                69.84599
                            ],
                            [
                                -124.45935,
                                69.99306
                            ],
                            [
                                -124.355,
                                70.01532
                            ],
                            [
                                -124.36954,
                                70.07918
                            ],
                            [
                                -124.52676,
                                70.14621
                            ],
                            [
                                -124.53362,
                                70.19844
                            ],
                            [
                                -124.74691,
                                70.17587
                            ],
                            [
                                -124.75171,
                                70.11506
                            ],
                            [
                                -124.85835,
                                70.0597
                            ],
                            [
                                -124.82846,
                                69.9975
                            ],
                            [
                                -125.10144,
                                69.78104
                            ],
                            [
                                -125.04194,
                                69.742
                            ],
                            [
                                -125.38875,
                                69.67683
                            ],
                            [
                                -125.40439,
                                69.60954
                            ],
                            [
                                -125.25847,
                                69.5909
                            ],
                            [
                                -125.29646,
                                69.51503
                            ],
                            [
                                -125.49631,
                                69.50888
                            ],
                            [
                                -125.58689,
                                69.47726
                            ],
                            [
                                -125.16298,
                                69.42147
                            ],
                            [
                                -125.36498,
                                69.37916
                            ],
                            [
                                -125.41011,
                                69.33542
                            ],
                            [
                                -125.60637,
                                69.33876
                            ],
                            [
                                -125.69457,
                                69.38331
                            ],
                            [
                                -125.91399,
                                69.38838
                            ],
                            [
                                -126.32994,
                                69.5455
                            ],
                            [
                                -126.70675,
                                69.74472
                            ],
                            [
                                -126.87777,
                                69.95718
                            ],
                            [
                                -127.07535,
                                70.16466
                            ],
                            [
                                -127.36027,
                                70.34448
                            ],
                            [
                                -127.5509,
                                70.42347
                            ],
                            [
                                -127.99958,
                                70.56131
                            ],
                            [
                                -128.1578,
                                70.49343
                            ],
                            [
                                -128.20719,
                                70.38038
                            ],
                            [
                                -128.01826,
                                70.27011
                            ],
                            [
                                -127.66759,
                                70.24606
                            ],
                            [
                                -127.74817,
                                70.18736
                            ],
                            [
                                -127.87274,
                                70.18641
                            ],
                            [
                                -128.34508,
                                70.12218
                            ],
                            [
                                -128.39207,
                                70.05688
                            ],
                            [
                                -128.23501,
                                69.93595
                            ],
                            [
                                -128.42356,
                                69.92358
                            ],
                            [
                                -128.61358,
                                69.86764
                            ],
                            [
                                -128.82053,
                                69.74696
                            ],
                            [
                                -129.17003,
                                69.70436
                            ],
                            [
                                -129.17738,
                                69.82079
                            ],
                            [
                                -129.35553,
                                69.83514
                            ],
                            [
                                -129.59118,
                                69.81031
                            ],
                            [
                                -129.72402,
                                69.77123
                            ],
                            [
                                -130.08855,
                                69.70193
                            ],
                            [
                                -130.33263,
                                69.68348
                            ],
                            [
                                -130.46832,
                                69.55933
                            ],
                            [
                                -130.59806,
                                69.49266
                            ],
                            [
                                -130.63536,
                                69.41035
                            ],
                            [
                                -130.84895,
                                69.35066
                            ],
                            [
                                -130.94468,
                                69.42238
                            ],
                            [
                                -131.15732,
                                69.41666
                            ],
                            [
                                -131.29903,
                                69.48952
                            ],
                            [
                                -131.38665,
                                69.41393
                            ],
                            [
                                -131.55301,
                                69.43344
                            ],
                            [
                                -131.75223,
                                69.37929
                            ],
                            [
                                -131.79058,
                                69.31195
                            ],
                            [
                                -132.08957,
                                69.21011
                            ],
                            [
                                -132.36607,
                                69.20082
                            ],
                            [
                                -132.47576,
                                69.1424
                            ],
                            [
                                -132.83941,
                                69.0455
                            ],
                            [
                                -132.86989,
                                68.96554
                            ],
                            [
                                -132.72617,
                                68.86869
                            ],
                            [
                                -132.51799,
                                68.89392
                            ],
                            [
                                -132.4136,
                                68.84741
                            ],
                            [
                                -132.58051,
                                68.79648
                            ],
                            [
                                -132.90003,
                                68.83852
                            ],
                            [
                                -132.94981,
                                68.80888
                            ],
                            [
                                -133.16237,
                                68.81207
                            ],
                            [
                                -133.29901,
                                68.85027
                            ],
                            [
                                -133.24588,
                                68.93648
                            ],
                            [
                                -133.31192,
                                68.96499
                            ],
                            [
                                -133.2161,
                                69.02639
                            ],
                            [
                                -133.05753,
                                69.06651
                            ],
                            [
                                -132.91564,
                                69.03297
                            ],
                            [
                                -132.89763,
                                69.13295
                            ],
                            [
                                -132.771,
                                69.251
                            ],
                            [
                                -132.47248,
                                69.27647
                            ],
                            [
                                -132.17177,
                                69.34899
                            ],
                            [
                                -132.11067,
                                69.47432
                            ],
                            [
                                -132.0049,
                                69.5163
                            ],
                            [
                                -131.78494,
                                69.55166
                            ],
                            [
                                -131.36143,
                                69.55855
                            ],
                            [
                                -131.20248,
                                69.60346
                            ],
                            [
                                -131.05094,
                                69.58851
                            ],
                            [
                                -130.94699,
                                69.53893
                            ],
                            [
                                -130.79769,
                                69.65072
                            ],
                            [
                                -130.57521,
                                69.69986
                            ],
                            [
                                -130.34752,
                                69.81666
                            ],
                            [
                                -130.06508,
                                69.86468
                            ],
                            [
                                -129.94634,
                                69.90588
                            ],
                            [
                                -129.53708,
                                69.99374
                            ],
                            [
                                -129.43516,
                                70.04151
                            ],
                            [
                                -129.63461,
                                70.22236
                            ],
                            [
                                -129.88008,
                                70.05774
                            ],
                            [
                                -130.03093,
                                70.04614
                            ],
                            [
                                -130.16441,
                                70.07401
                            ],
                            [
                                -130.64776,
                                70.11818
                            ],
                            [
                                -130.70672,
                                70.066
                            ],
                            [
                                -130.86263,
                                70.08062
                            ],
                            [
                                -130.944,
                                69.99579
                            ],
                            [
                                -131.0691,
                                69.94467
                            ],
                            [
                                -131.09702,
                                69.88365
                            ],
                            [
                                -131.42155,
                                69.94871
                            ],
                            [
                                -131.44072,
                                69.88953
                            ],
                            [
                                -131.64662,
                                69.86104
                            ],
                            [
                                -132.00252,
                                69.7007
                            ],
                            [
                                -132.36117,
                                69.69741
                            ],
                            [
                                -132.35766,
                                69.65216
                            ],
                            [
                                -132.7117,
                                69.60732
                            ],
                            [
                                -132.84706,
                                69.65171
                            ],
                            [
                                -133.0105,
                                69.57476
                            ],
                            [
                                -132.95873,
                                69.50878
                            ],
                            [
                                -133.06102,
                                69.40751
                            ],
                            [
                                -133.2207,
                                69.37564
                            ],
                            [
                                -133.52361,
                                69.39321
                            ],
                            [
                                -133.83337,
                                69.3342
                            ],
                            [
                                -133.91135,
                                69.28154
                            ],
                            [
                                -134.1841,
                                69.24641
                            ],
                            [
                                -134.22855,
                                69.18437
                            ],
                            [
                                -134.38306,
                                69.08768
                            ],
                            [
                                -134.59188,
                                69.06252
                            ],
                            [
                                -134.66578,
                                68.94957
                            ],
                            [
                                -134.85416,
                                68.92764
                            ],
                            [
                                -135.11905,
                                69.08536
                            ],
                            [
                                -135.01563,
                                69.15911
                            ],
                            [
                                -135.18416,
                                69.25374
                            ],
                            [
                                -135.41832,
                                69.31617
                            ],
                            [
                                -135.57193,
                                69.33235
                            ],
                            [
                                -135.84526,
                                69.29655
                            ],
                            [
                                -135.84196,
                                69.23625
                            ],
                            [
                                -136.00505,
                                69.19405
                            ],
                            [
                                -135.93611,
                                69.07714
                            ],
                            [
                                -135.44036,
                                68.9942
                            ],
                            [
                                -135.45711,
                                68.90578
                            ],
                            [
                                -135.57374,
                                68.84803
                            ],
                            [
                                -135.21563,
                                68.67381
                            ],
                            [
                                -135.41429,
                                68.67933
                            ],
                            [
                                -135.50696,
                                68.72728
                            ],
                            [
                                -135.73262,
                                68.76584
                            ],
                            [
                                -135.78649,
                                68.7988
                            ],
                            [
                                -136.0397,
                                68.85939
                            ],
                            [
                                -136.15388,
                                68.85872
                            ],
                            [
                                -136.52207,
                                68.89936
                            ],
                            [
                                -136.75652,
                                68.85712
                            ],
                            [
                                -137.04507,
                                68.94174
                            ],
                            [
                                -137.27446,
                                68.96125
                            ],
                            [
                                -137.62562,
                                69.01966
                            ],
                            [
                                -138.18533,
                                69.16098
                            ],
                            [
                                -138.35513,
                                69.28549
                            ],
                            [
                                -138.45916,
                                69.21901
                            ],
                            [
                                -139.14983,
                                69.50027
                            ],
                            [
                                -139.34251,
                                69.53215
                            ],
                            [
                                -139.57248,
                                69.53659
                            ],
                            [
                                -139.79146,
                                69.60065
                            ],
                            [
                                -139.96431,
                                69.61299
                            ],
                            [
                                -140.21973,
                                69.59377
                            ],
                            [
                                -140.53329,
                                69.59547
                            ],
                            [
                                -140.91423,
                                69.62721
                            ],
                            [
                                -140.99226,
                                69.61724
                            ],
                            [
                                -140.99298,
                                69.11124
                            ],
                            [
                                -140.99383,
                                68.49429
                            ],
                            [
                                -140.99469,
                                67.85589
                            ],
                            [
                                -140.9952,
                                67.49797
                            ],
                            [
                                -140.99644,
                                66.61118
                            ],
                            [
                                -140.99747,
                                65.83974
                            ],
                            [
                                -140.99863,
                                65.0
                            ],
                            [
                                -140.99936,
                                64.4708
                            ],
                            [
                                -141,
                                63.86211
                            ],
                            [
                                -141,
                                63.21429
                            ],
                            [
                                -141,
                                62.59005
                            ],
                            [
                                -141,
                                61.89744
                            ],
                            [
                                -141,
                                61.12184
                            ],
                            [
                                -141,
                                60.32135
                            ],
                            [
                                -140.52194,
                                60.2258
                            ],
                            [
                                -140.45534,
                                60.31147
                            ],
                            [
                                -139.9773,
                                60.1847
                            ],
                            [
                                -139.67449,
                                60.33945
                            ],
                            [
                                -139.06908,
                                60.35196
                            ],
                            [
                                -139.05818,
                                60.32722
                            ],
                            [
                                -139.18606,
                                60.09253
                            ],
                            [
                                -139.04451,
                                59.99397
                            ],
                            [
                                -138.70583,
                                59.9111
                            ],
                            [
                                -138.62366,
                                59.77159
                            ],
                            [
                                -137.89363,
                                59.40391
                            ],
                            [
                                -137.5983,
                                59.24161
                            ],
                            [
                                -137.49311,
                                58.99193
                            ],
                            [
                                -137.44529,
                                58.91115
                            ],
                            [
                                -137.25435,
                                59.00752
                            ],
                            [
                                -136.8235,
                                59.15788
                            ],
                            [
                                -136.57573,
                                59.17013
                            ],
                            [
                                -136.45799,
                                59.28249
                            ],
                            [
                                -136.46377,
                                59.46465
                            ],
                            [
                                -136.2973,
                                59.47013
                            ],
                            [
                                -136.23604,
                                59.56298
                            ],
                            [
                                -136.34472,
                                59.60228
                            ],
                            [
                                -136.17428,
                                59.64143
                            ],
                            [
                                -135.93219,
                                59.66839
                            ],
                            [
                                -135.48326,
                                59.79997
                            ],
                            [
                                -135.23443,
                                59.6984
                            ],
                            [
                                -135.21499,
                                59.65864
                            ],
                            [
                                -135.02939,
                                59.56913
                            ],
                            [
                                -135.03106,
                                59.4742
                            ],
                            [
                                -135.09391,
                                59.43223
                            ],
                            [
                                -134.99147,
                                59.3896
                            ],
                            [
                                -135.03276,
                                59.35003
                            ],
                            [
                                -134.96091,
                                59.2849
                            ],
                            [
                                -134.70116,
                                59.24873
                            ],
                            [
                                -134.68383,
                                59.19791
                            ],
                            [
                                -134.56309,
                                59.13425
                            ],
                            [
                                -134.4801,
                                59.13171
                            ],
                            [
                                -134.38963,
                                59.05351
                            ],
                            [
                                -134.40166,
                                58.97965
                            ],
                            [
                                -134.24132,
                                58.85849
                            ],
                            [
                                -133.84735,
                                58.73569
                            ],
                            [
                                -133.70354,
                                58.61739
                            ],
                            [
                                -133.37492,
                                58.42799
                            ],
                            [
                                -133.4526,
                                58.38779
                            ],
                            [
                                -133.38187,
                                58.31154
                            ],
                            [
                                -133.1722,
                                58.15582
                            ],
                            [
                                -133.06224,
                                58.00232
                            ],
                            [
                                -132.88195,
                                57.85623
                            ],
                            [
                                -132.72821,
                                57.68049
                            ],
                            [
                                -132.54488,
                                57.49441
                            ],
                            [
                                -132.37207,
                                57.35324
                            ],
                            [
                                -132.24163,
                                57.21421
                            ],
                            [
                                -132.36555,
                                57.09227
                            ],
                            [
                                -132.04235,
                                57.04641
                            ],
                            [
                                -132.11996,
                                56.87983
                            ],
                            [
                                -131.87233,
                                56.80815
                            ],
                            [
                                -131.89984,
                                56.75591
                            ],
                            [
                                -131.84734,
                                56.66231
                            ],
                            [
                                -131.84355,
                                56.64807
                            ],
                            [
                                -131.83096,
                                56.60091
                            ],
                            [
                                -131.58319,
                                56.61447
                            ],
                            [
                                -131.46911,
                                56.55491
                            ],
                            [
                                -131.17163,
                                56.45398
                            ],
                            [
                                -131.07341,
                                56.40677
                            ],
                            [
                                -130.78407,
                                56.37037
                            ],
                            [
                                -130.62557,
                                56.27192
                            ],
                            [
                                -130.46912,
                                56.24501
                            ],
                            [
                                -130.41732,
                                56.14118
                            ],
                            [
                                -130.25009,
                                56.09758
                            ],
                            [
                                -130.10765,
                                56.12399
                            ],
                            [
                                -130.01074,
                                56.00011
                            ],
                            [
                                -130.01016,
                                55.91706
                            ],
                            [
                                -130.00362,
                                55.88702
                            ],
                            [
                                -130.13656,
                                55.74774
                            ],
                            [
                                -130.08751,
                                55.6831
                            ],
                            [
                                -130.10882,
                                55.5654
                            ],
                            [
                                -130.0244,
                                55.45794
                            ],
                            [
                                -130.0015,
                                55.33722
                            ],
                            [
                                -129.94686,
                                55.29019
                            ],
                            [
                                -130.08732,
                                55.19112
                            ],
                            [
                                -130.16023,
                                55.0912
                            ],
                            [
                                -130.10708,
                                54.98728
                            ],
                            [
                                -129.9041,
                                55.16561
                            ],
                            [
                                -129.79888,
                                55.35191
                            ],
                            [
                                -129.82442,
                                55.41221
                            ],
                            [
                                -129.72507,
                                55.4671
                            ],
                            [
                                -129.67941,
                                55.38082
                            ],
                            [
                                -129.74382,
                                55.29245
                            ],
                            [
                                -129.81094,
                                55.26371
                            ],
                            [
                                -129.85999,
                                55.17921
                            ],
                            [
                                -129.98557,
                                55.06004
                            ],
                            [
                                -130.01617,
                                54.97377
                            ],
                            [
                                -130.17199,
                                54.85185
                            ],
                            [
                                -130.20696,
                                54.72183
                            ],
                            [
                                -130.36859,
                                54.67874
                            ],
                            [
                                -130.45381,
                                54.61443
                            ],
                            [
                                -130.44899,
                                54.45529
                            ],
                            [
                                -130.48604,
                                54.43073
                            ],
                            [
                                -130.45754,
                                54.33851
                            ],
                            [
                                -130.27143,
                                54.33546
                            ],
                            [
                                -130.23339,
                                54.27305
                            ],
                            [
                                -130.27623,
                                54.20455
                            ],
                            [
                                -130.05177,
                                54.14433
                            ],
                            [
                                -130.0991,
                                54.06351
                            ],
                            [
                                -130.106,
                                53.94657
                            ],
                            [
                                -129.98376,
                                53.82693
                            ],
                            [
                                -129.75208,
                                53.68133
                            ],
                            [
                                -129.67445,
                                53.58821
                            ],
                            [
                                -129.31374,
                                53.3727
                            ],
                            [
                                -129.23786,
                                53.42511
                            ],
                            [
                                -129.25001,
                                53.57731
                            ],
                            [
                                -129.23173,
                                53.63303
                            ],
                            [
                                -129.12692,
                                53.70819
                            ],
                            [
                                -128.84361,
                                53.85847
                            ],
                            [
                                -128.70968,
                                53.88172
                            ],
                            [
                                -128.68118,
                                53.84952
                            ],
                            [
                                -128.80561,
                                53.77082
                            ],
                            [
                                -128.78306,
                                53.71065
                            ],
                            [
                                -128.83363,
                                53.64483
                            ],
                            [
                                -128.81954,
                                53.56727
                            ],
                            [
                                -128.97296,
                                53.49352
                            ],
                            [
                                -128.88586,
                                53.41096
                            ],
                            [
                                -128.88628,
                                53.30872
                            ],
                            [
                                -128.7545,
                                53.21537
                            ],
                            [
                                -128.6029,
                                53.1583
                            ],
                            [
                                -128.51243,
                                53.00402
                            ],
                            [
                                -128.50079,
                                52.89173
                            ],
                            [
                                -128.44108,
                                52.82209
                            ],
                            [
                                -128.24694,
                                52.79957
                            ],
                            [
                                -128.12595,
                                52.82995
                            ],
                            [
                                -128.11647,
                                52.75439
                            ],
                            [
                                -128.24643,
                                52.52969
                            ],
                            [
                                -128.22009,
                                52.47485
                            ],
                            [
                                -128.2631,
                                52.40005
                            ],
                            [
                                -128.37093,
                                52.34988
                            ],
                            [
                                -128.36341,
                                52.29537
                            ],
                            [
                                -128.2818,
                                52.26677
                            ],
                            [
                                -128.10853,
                                52.47238
                            ],
                            [
                                -128.03827,
                                52.33328
                            ],
                            [
                                -127.97287,
                                52.31545
                            ],
                            [
                                -127.92448,
                                52.28111
                            ],
                            [
                                -127.85718,
                                52.199
                            ],
                            [
                                -127.78668,
                                52.26877
                            ],
                            [
                                -127.62638,
                                52.28471
                            ],
                            [
                                -127.48991,
                                52.33872
                            ],
                            [
                                -127.45275,
                                52.42511
                            ],
                            [
                                -127.34581,
                                52.41922
                            ],
                            [
                                -127.26512,
                                52.47241
                            ],
                            [
                                -127.18901,
                                52.41963
                            ],
                            [
                                -127.16106,
                                52.34391
                            ],
                            [
                                -126.9873,
                                52.33247
                            ],
                            [
                                -127.00093,
                                52.29827
                            ],
                            [
                                -127.18276,
                                52.29339
                            ],
                            [
                                -127.28951,
                                52.23856
                            ],
                            [
                                -127.39936,
                                52.21685
                            ],
                            [
                                -127.43685,
                                52.13883
                            ],
                            [
                                -127.52515,
                                52.15716
                            ],
                            [
                                -127.60732,
                                52.11973
                            ],
                            [
                                -127.65547,
                                51.9835
                            ],
                            [
                                -127.70612,
                                51.9415
                            ],
                            [
                                -127.8175,
                                51.92977
                            ],
                            [
                                -127.89485,
                                51.81725
                            ],
                            [
                                -127.88685,
                                51.69816
                            ],
                            [
                                -127.85521,
                                51.6491
                            ],
                            [
                                -127.71934,
                                51.6179
                            ],
                            [
                                -127.79674,
                                51.5771
                            ],
                            [
                                -127.73598,
                                51.52457
                            ],
                            [
                                -127.64124,
                                51.52886
                            ],
                            [
                                -127.52044,
                                51.57578
                            ],
                            [
                                -127.53021,
                                51.45901
                            ],
                            [
                                -127.58584,
                                51.46503
                            ],
                            [
                                -127.66695,
                                51.40057
                            ],
                            [
                                -127.7258,
                                51.39927
                            ],
                            [
                                -127.77911,
                                51.32097
                            ],
                            [
                                -127.58795,
                                51.30365
                            ],
                            [
                                -127.76701,
                                51.24742
                            ],
                            [
                                -127.77725,
                                51.16039
                            ],
                            [
                                -127.6827,
                                51.13087
                            ],
                            [
                                -127.65723,
                                51.08889
                            ],
                            [
                                -127.40053,
                                50.92588
                            ],
                            [
                                -127.27507,
                                50.91332
                            ],
                            [
                                -127.02359,
                                50.81867
                            ],
                            [
                                -126.93726,
                                50.85462
                            ],
                            [
                                -126.85444,
                                50.92714
                            ],
                            [
                                -126.7201,
                                50.87558
                            ],
                            [
                                -126.54756,
                                50.8955
                            ],
                            [
                                -126.56507,
                                50.8349
                            ],
                            [
                                -126.47404,
                                50.81425
                            ],
                            [
                                -126.33054,
                                50.84945
                            ],
                            [
                                -126.1934,
                                50.84446
                            ],
                            [
                                -126.18074,
                                50.67095
                            ],
                            [
                                -126.01492,
                                50.70084
                            ],
                            [
                                -126.00597,
                                50.66659
                            ],
                            [
                                -126.27297,
                                50.63099
                            ],
                            [
                                -126.19077,
                                50.58036
                            ],
                            [
                                -126.27133,
                                50.50959
                            ],
                            [
                                -125.96352,
                                50.46897
                            ],
                            [
                                -125.77526,
                                50.53198
                            ],
                            [
                                -125.7517,
                                50.45227
                            ],
                            [
                                -125.70305,
                                50.42284
                            ],
                            [
                                -125.61667,
                                50.45251
                            ],
                            [
                                -125.48456,
                                50.44272
                            ],
                            [
                                -125.35528,
                                50.49298
                            ],
                            [
                                -125.1874,
                                50.41021
                            ],
                            [
                                -125.11763,
                                50.42938
                            ],
                            [
                                -125.10792,
                                50.50159
                            ],
                            [
                                -124.99312,
                                50.53763
                            ],
                            [
                                -124.89863,
                                50.63623
                            ],
                            [
                                -124.86097,
                                50.59445
                            ],
                            [
                                -124.97008,
                                50.50127
                            ],
                            [
                                -125.05135,
                                50.47848
                            ],
                            [
                                -125.05414,
                                50.31604
                            ],
                            [
                                -124.99572,
                                50.34669
                            ],
                            [
                                -124.82709,
                                50.30835
                            ],
                            [
                                -124.73062,
                                50.32475
                            ],
                            [
                                -124.63496,
                                50.29287
                            ],
                            [
                                -124.59219,
                                50.24511
                            ],
                            [
                                -124.63416,
                                50.16072
                            ],
                            [
                                -124.70712,
                                50.09702
                            ],
                            [
                                -124.83608,
                                50.05235
                            ],
                            [
                                -124.7528,
                                49.96584
                            ],
                            [
                                -124.55618,
                                49.86961
                            ],
                            [
                                -124.52396,
                                49.80483
                            ],
                            [
                                -124.39973,
                                49.76777
                            ],
                            [
                                -124.13617,
                                49.78121
                            ],
                            [
                                -124.08928,
                                49.83841
                            ],
                            [
                                -123.91968,
                                49.84884
                            ],
                            [
                                -123.94097,
                                49.77432
                            ],
                            [
                                -124.03302,
                                49.73996
                            ],
                            [
                                -124.07199,
                                49.64427
                            ],
                            [
                                -123.99849,
                                49.55498
                            ],
                            [
                                -123.88767,
                                49.47464
                            ],
                            [
                                -123.74952,
                                49.46883
                            ],
                            [
                                -123.72019,
                                49.43867
                            ],
                            [
                                -123.5063,
                                49.39269
                            ],
                            [
                                -123.46909,
                                49.445
                            ],
                            [
                                -123.47212,
                                49.52888
                            ],
                            [
                                -123.28168,
                                49.58271
                            ],
                            [
                                -123.23433,
                                49.4228
                            ],
                            [
                                -123.27087,
                                49.35096
                            ],
                            [
                                -123.11825,
                                49.31036
                            ],
                            [
                                -123.21857,
                                49.23409
                            ],
                            [
                                -123.19736,
                                49.12097
                            ],
                            [
                                -123.09108,
                                49.00255
                            ],
                            [
                                -123.03526,
                                49.00255
                            ],
                            [
                                -123.01794,
                                49.06092
                            ],
                            [
                                -122.8865,
                                49.09083
                            ],
                            [
                                -122.8641,
                                49.02431
                            ],
                            [
                                -122.75708,
                                49.00119
                            ],
                            [
                                -122.03869,
                                49.00122
                            ],
                            [
                                -121.09286,
                                48.99937
                            ],
                            [
                                -119.71965,
                                49.00013
                            ],
                            [
                                -118.52969,
                                49.00104
                            ],
                            [
                                -117.78806,
                                49.00279
                            ],
                            [
                                -117.02686,
                                48.99959
                            ],
                            [
                                -116.04198,
                                49.00033
                            ],
                            [
                                -115.04043,
                                48.99845
                            ],
                            [
                                -114.06876,
                                48.99898
                            ],
                            [
                                -112.8639,
                                48.99536
                            ],
                            [
                                -111.91277,
                                48.99669
                            ],
                            [
                                -110.58365,
                                49.00012
                            ],
                            [
                                -110.00001,
                                48.99657
                            ],
                            [
                                -108.85474,
                                48.99896
                            ],
                            [
                                -108.28253,
                                48.99571
                            ],
                            [
                                -106.9703,
                                48.99378
                            ],
                            [
                                -106.03911,
                                48.99464
                            ],
                            [
                                -104.6577,
                                48.99563
                            ],
                            [
                                -104.02361,
                                48.9903
                            ],
                            [
                                -102.71754,
                                48.99261
                            ],
                            [
                                -102.11605,
                                48.99596
                            ],
                            [
                                -101.26067,
                                48.9958
                            ],
                            [
                                -100.32384,
                                48.99281
                            ],
                            [
                                -99.772,
                                48.9948
                            ],
                            [
                                -98.31402,
                                48.99515
                            ],
                            [
                                -97.12064,
                                48.99405
                            ],
                            [
                                -96.70663,
                                48.99839
                            ],
                            [
                                -96.0729,
                                48.99595
                            ],
                            [
                                -95.16552,
                                48.99942
                            ],
                            [
                                -95.16837,
                                49.38336
                            ],
                            [
                                -95.08123,
                                49.35806
                            ],
                            [
                                -94.98185,
                                49.36324
                            ],
                            [
                                -94.83779,
                                49.31971
                            ],
                            [
                                -94.82058,
                                49.17039
                            ],
                            [
                                -94.70027,
                                48.89448
                            ],
                            [
                                -94.68905,
                                48.77718
                            ],
                            [
                                -94.58995,
                                48.72075
                            ],
                            [
                                -94.43872,
                                48.69622
                            ],
                            [
                                -94.29189,
                                48.70843
                            ],
                            [
                                -94.23516,
                                48.65188
                            ],
                            [
                                -93.85902,
                                48.63488
                            ],
                            [
                                -93.79845,
                                48.52413
                            ],
                            [
                                -93.6806,
                                48.52021
                            ],
                            [
                                -93.47534,
                                48.54667
                            ],
                            [
                                -93.46328,
                                48.59196
                            ],
                            [
                                -93.3508,
                                48.6314
                            ],
                            [
                                -92.9526,
                                48.63019
                            ],
                            [
                                -92.92915,
                                48.60626
                            ],
                            [
                                -92.74711,
                                48.54576
                            ],
                            [
                                -92.67372,
                                48.44176
                            ],
                            [
                                -92.51079,
                                48.44799
                            ],
                            [
                                -92.37606,
                                48.23054
                            ],
                            [
                                -92.2818,
                                48.2477
                            ],
                            [
                                -92.3187,
                                48.30381
                            ],
                            [
                                -92.29778,
                                48.35385
                            ],
                            [
                                -92.05724,
                                48.35891
                            ],
                            [
                                -92.00198,
                                48.32041
                            ],
                            [
                                -92.00605,
                                48.267
                            ],
                            [
                                -91.86222,
                                48.20775
                            ],
                            [
                                -91.71745,
                                48.19963
                            ],
                            [
                                -91.70793,
                                48.12103
                            ],
                            [
                                -91.55797,
                                48.10691
                            ],
                            [
                                -91.43811,
                                48.05151
                            ],
                            [
                                -91.24972,
                                48.08458
                            ],
                            [
                                -91.19995,
                                48.11981
                            ],
                            [
                                -90.95833,
                                48.22977
                            ],
                            [
                                -90.84032,
                                48.23946
                            ],
                            [
                                -90.8346,
                                48.17969
                            ],
                            [
                                -90.75139,
                                48.0921
                            ],
                            [
                                -90.58054,
                                48.12291
                            ],
                            [
                                -90.54988,
                                48.09688
                            ],
                            [
                                -90.13602,
                                48.11167
                            ],
                            [
                                -90.02589,
                                48.08559
                            ],
                            [
                                -89.99216,
                                48.02903
                            ],
                            [
                                -89.89534,
                                47.98863
                            ],
                            [
                                -89.75134,
                                48.023
                            ],
                            [
                                -89.57953,
                                47.99764
                            ],
                            [
                                -89.48578,
                                48.0135
                            ],
                            [
                                -89.33608,
                                47.97571
                            ],
                            [
                                -88.68008,
                                48.24414
                            ],
                            [
                                -88.36729,
                                48.30486
                            ],
                            [
                                -87.64885,
                                48.02928
                            ],
                            [
                                -87.11199,
                                47.81769
                            ],
                            [
                                -85.5895,
                                47.19145
                            ],
                            [
                                -84.86371,
                                46.88943
                            ],
                            [
                                -84.76242,
                                46.63467
                            ],
                            [
                                -84.55728,
                                46.46185
                            ],
                            [
                                -84.47727,
                                46.4536
                            ],
                            [
                                -84.42149,
                                46.49947
                            ],
                            [
                                -84.25539,
                                46.5008
                            ],
                            [
                                -84.22264,
                                46.53448
                            ],
                            [
                                -84.1116,
                                46.50359
                            ],
                            [
                                -84.1458,
                                46.41738
                            ],
                            [
                                -84.10743,
                                46.24057
                            ],
                            [
                                -84.00675,
                                46.1495
                            ],
                            [
                                -83.95538,
                                46.05751
                            ],
                            [
                                -83.82619,
                                46.11832
                            ],
                            [
                                -83.76024,
                                46.10303
                            ],
                            [
                                -83.65539,
                                46.12143
                            ],
                            [
                                -83.57194,
                                46.10544
                            ],
                            [
                                -83.43464,
                                45.9979
                            ],
                            [
                                -83.59543,
                                45.82062
                            ],
                            [
                                -82.51822,
                                45.33677
                            ],
                            [
                                -82.31958,
                                44.47163
                            ],
                            [
                                -82.12317,
                                43.59114
                            ],
                            [
                                -82.45653,
                                42.92414
                            ],
                            [
                                -82.48233,
                                42.80954
                            ],
                            [
                                -82.4677,
                                42.76266
                            ],
                            [
                                -82.52543,
                                42.60578
                            ],
                            [
                                -82.58816,
                                42.55213
                            ],
                            [
                                -82.64388,
                                42.55368
                            ],
                            [
                                -82.83002,
                                42.37405
                            ],
                            [
                                -83.06342,
                                42.3168
                            ],
                            [
                                -83.12576,
                                42.23922
                            ],
                            [
                                -83.11957,
                                42.12439
                            ],
                            [
                                -83.14922,
                                42.04044
                            ],
                            [
                                -83.06801,
                                41.86322
                            ],
                            [
                                -82.67987,
                                41.67691
                            ],
                            [
                                -82.39746,
                                41.67686
                            ],
                            [
                                -81.87195,
                                41.92497
                            ],
                            [
                                -81.79657,
                                41.95415
                            ],
                            [
                                -81.24626,
                                42.20719
                            ],
                            [
                                -80.07975,
                                42.39376
                            ],
                            [
                                -79.46157,
                                42.62887
                            ],
                            [
                                -78.93521,
                                42.82927
                            ],
                            [
                                -78.90581,
                                42.90319
                            ],
                            [
                                -78.9323,
                                42.95538
                            ],
                            [
                                -79.01598,
                                42.98439
                            ],
                            [
                                -79.01383,
                                43.06685
                            ],
                            [
                                -79.07491,
                                43.07993
                            ],
                            [
                                -79.04253,
                                43.14355
                            ],
                            [
                                -79.05592,
                                43.25369
                            ],
                            [
                                -79.19978,
                                43.44982
                            ],
                            [
                                -78.69039,
                                43.63114
                            ],
                            [
                                -77.57146,
                                43.63114
                            ],
                            [
                                -76.79669,
                                43.63114
                            ],
                            [
                                -76.43928,
                                44.09338
                            ],
                            [
                                -76.35322,
                                44.13448
                            ],
                            [
                                -76.31234,
                                44.19871
                            ],
                            [
                                -76.16507,
                                44.23962
                            ],
                            [
                                -76.16188,
                                44.27879
                            ],
                            [
                                -76.00181,
                                44.34729
                            ],
                            [
                                -75.91111,
                                44.369
                            ],
                            [
                                -75.82179,
                                44.43208
                            ],
                            [
                                -75.76656,
                                44.51541
                            ],
                            [
                                -75.50592,
                                44.70457
                            ],
                            [
                                -75.28591,
                                44.84774
                            ],
                            [
                                -75.06491,
                                44.9299
                            ],
                            [
                                -74.97531,
                                44.98265
                            ],
                            [
                                -74.83551,
                                45.01418
                            ],
                            [
                                -74.73025,
                                44.9913
                            ],
                            [
                                -74.63241,
                                45.00115
                            ],
                            [
                                -73.97656,
                                45.00054
                            ],
                            [
                                -72.90278,
                                45.0
                            ],
                            [
                                -72.23205,
                                45.00001
                            ],
                            [
                                -71.53998,
                                45.00005
                            ],
                            [
                                -71.51008,
                                45.06894
                            ],
                            [
                                -71.42095,
                                45.13149
                            ],
                            [
                                -71.35387,
                                45.27133
                            ],
                            [
                                -71.29253,
                                45.29973
                            ],
                            [
                                -71.21413,
                                45.25172
                            ],
                            [
                                -71.13217,
                                45.25094
                            ],
                            [
                                -71.09404,
                                45.30347
                            ],
                            [
                                -71.00743,
                                45.3456
                            ],
                            [
                                -70.91829,
                                45.31551
                            ],
                            [
                                -70.87883,
                                45.23469
                            ],
                            [
                                -70.80944,
                                45.30454
                            ],
                            [
                                -70.77935,
                                45.42689
                            ],
                            [
                                -70.71657,
                                45.38994
                            ],
                            [
                                -70.62942,
                                45.42262
                            ],
                            [
                                -70.70726,
                                45.48331
                            ],
                            [
                                -70.66542,
                                45.5792
                            ],
                            [
                                -70.55202,
                                45.66633
                            ],
                            [
                                -70.39708,
                                45.71995
                            ],
                            [
                                -70.40786,
                                45.79549
                            ],
                            [
                                -70.25936,
                                45.89088
                            ],
                            [
                                -70.23461,
                                45.93616
                            ],
                            [
                                -70.31072,
                                46.0213
                            ],
                            [
                                -70.24513,
                                46.14402
                            ],
                            [
                                -70.30098,
                                46.19217
                            ],
                            [
                                -70.21453,
                                46.30116
                            ],
                            [
                                -70.05683,
                                46.42604
                            ],
                            [
                                -69.99652,
                                46.68536
                            ],
                            [
                                -69.81351,
                                46.8734
                            ],
                            [
                                -69.22549,
                                47.45725
                            ],
                            [
                                -69.04529,
                                47.42642
                            ],
                            [
                                -69.0498,
                                47.25418
                            ],
                            [
                                -68.89612,
                                47.18039
                            ],
                            [
                                -68.7307,
                                47.23745
                            ],
                            [
                                -68.62592,
                                47.24324
                            ],
                            [
                                -68.51159,
                                47.2993
                            ],
                            [
                                -68.39026,
                                47.28748
                            ],
                            [
                                -68.38166,
                                47.34498
                            ],
                            [
                                -68.28995,
                                47.36443
                            ],
                            [
                                -68.16449,
                                47.32974
                            ],
                            [
                                -68.13297,
                                47.29558
                            ],
                            [
                                -67.95619,
                                47.19517
                            ],
                            [
                                -67.88605,
                                47.10423
                            ],
                            [
                                -67.78724,
                                47.06428
                            ],
                            [
                                -67.79107,
                                46.9792
                            ],
                            [
                                -67.78359,
                                46.48485
                            ],
                            [
                                -67.78339,
                                45.94168
                            ],
                            [
                                -67.80807,
                                45.87947
                            ],
                            [
                                -67.76323,
                                45.81899
                            ],
                            [
                                -67.81027,
                                45.79246
                            ],
                            [
                                -67.80411,
                                45.67694
                            ],
                            [
                                -67.70148,
                                45.65954
                            ],
                            [
                                -67.64598,
                                45.61643
                            ],
                            [
                                -67.40765,
                                45.55423
                            ],
                            [
                                -67.49401,
                                45.47825
                            ],
                            [
                                -67.4229,
                                45.37529
                            ],
                            [
                                -67.48228,
                                45.27874
                            ],
                            [
                                -67.41779,
                                45.18789
                            ],
                            [
                                -67.34474,
                                45.12729
                            ],
                            [
                                -67.27016,
                                45.18856
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -86.14778,
                                73.85109
                            ],
                            [
                                -86.51977,
                                73.85122
                            ],
                            [
                                -87.21436,
                                73.79084
                            ],
                            [
                                -87.85009,
                                73.68723
                            ],
                            [
                                -88.25278,
                                73.58066
                            ],
                            [
                                -88.64062,
                                73.43594
                            ],
                            [
                                -89.13937,
                                73.18694
                            ],
                            [
                                -89.34021,
                                73.00263
                            ],
                            [
                                -89.29226,
                                72.93909
                            ],
                            [
                                -89.40132,
                                72.83835
                            ],
                            [
                                -89.52718,
                                72.78556
                            ],
                            [
                                -89.57995,
                                72.70526
                            ],
                            [
                                -89.52524,
                                72.63286
                            ],
                            [
                                -89.7394,
                                72.6132
                            ],
                            [
                                -89.83778,
                                72.39854
                            ],
                            [
                                -89.95713,
                                72.34516
                            ],
                            [
                                -89.89516,
                                72.19494
                            ],
                            [
                                -89.76352,
                                72.12917
                            ],
                            [
                                -90.00185,
                                72.06363
                            ],
                            [
                                -89.96073,
                                72.02886
                            ],
                            [
                                -90.10953,
                                71.93058
                            ],
                            [
                                -89.92657,
                                71.8535
                            ],
                            [
                                -89.8112,
                                71.76772
                            ],
                            [
                                -89.85912,
                                71.6882
                            ],
                            [
                                -89.99231,
                                71.64001
                            ],
                            [
                                -89.9362,
                                71.40918
                            ],
                            [
                                -89.80047,
                                71.33049
                            ],
                            [
                                -89.23997,
                                71.28574
                            ],
                            [
                                -89.12895,
                                71.29214
                            ],
                            [
                                -88.58899,
                                71.24303
                            ],
                            [
                                -88.07687,
                                71.22131
                            ],
                            [
                                -87.83245,
                                71.25932
                            ],
                            [
                                -87.85425,
                                71.19365
                            ],
                            [
                                -87.73286,
                                71.13378
                            ],
                            [
                                -87.28876,
                                71.02741
                            ],
                            [
                                -87.36112,
                                70.95257
                            ],
                            [
                                -87.78463,
                                70.95292
                            ],
                            [
                                -88.05315,
                                70.93618
                            ],
                            [
                                -88.29554,
                                70.95324
                            ],
                            [
                                -88.35443,
                                71.00563
                            ],
                            [
                                -88.63972,
                                71.04945
                            ],
                            [
                                -89.15317,
                                71.02982
                            ],
                            [
                                -89.3358,
                                71.08584
                            ],
                            [
                                -89.48385,
                                71.06301
                            ],
                            [
                                -89.17213,
                                70.95819
                            ],
                            [
                                -89.42063,
                                70.90914
                            ],
                            [
                                -89.32253,
                                70.79817
                            ],
                            [
                                -88.9901,
                                70.66729
                            ],
                            [
                                -89.00003,
                                70.62999
                            ],
                            [
                                -88.86103,
                                70.53257
                            ],
                            [
                                -88.67387,
                                70.46412
                            ],
                            [
                                -88.25541,
                                70.41566
                            ],
                            [
                                -88.01693,
                                70.34892
                            ],
                            [
                                -88.21367,
                                70.32755
                            ],
                            [
                                -87.85733,
                                70.24325
                            ],
                            [
                                -87.74507,
                                70.24926
                            ],
                            [
                                -87.51229,
                                70.33139
                            ],
                            [
                                -86.99302,
                                70.28619
                            ],
                            [
                                -86.86549,
                                70.32227
                            ],
                            [
                                -86.65831,
                                70.33477
                            ],
                            [
                                -86.56061,
                                70.24068
                            ],
                            [
                                -86.25482,
                                70.11336
                            ],
                            [
                                -85.97409,
                                70.05988
                            ],
                            [
                                -85.84016,
                                70.01266
                            ],
                            [
                                -85.34615,
                                70.03421
                            ],
                            [
                                -85.64235,
                                70.08239
                            ],
                            [
                                -85.31286,
                                70.10818
                            ],
                            [
                                -84.94198,
                                70.06759
                            ],
                            [
                                -84.65495,
                                70.00622
                            ],
                            [
                                -84.43281,
                                70.0082
                            ],
                            [
                                -83.64436,
                                69.95972
                            ],
                            [
                                -83.36642,
                                69.98466
                            ],
                            [
                                -83.29859,
                                70.01447
                            ],
                            [
                                -83.04664,
                                70.01
                            ],
                            [
                                -82.6432,
                                69.88893
                            ],
                            [
                                -82.47007,
                                69.86263
                            ],
                            [
                                -82.28146,
                                69.8677
                            ],
                            [
                                -82.25793,
                                69.81752
                            ],
                            [
                                -81.85058,
                                69.86576
                            ],
                            [
                                -81.73247,
                                69.95195
                            ],
                            [
                                -81.92249,
                                69.98299
                            ],
                            [
                                -82.0867,
                                70.07004
                            ],
                            [
                                -82.47498,
                                70.16655
                            ],
                            [
                                -82.82267,
                                70.2185
                            ],
                            [
                                -82.87167,
                                70.26631
                            ],
                            [
                                -82.00735,
                                70.08545
                            ],
                            [
                                -81.74664,
                                69.97774
                            ],
                            [
                                -81.4593,
                                69.93136
                            ],
                            [
                                -81.04376,
                                69.75889
                            ],
                            [
                                -80.82508,
                                69.7306
                            ],
                            [
                                -80.78211,
                                69.79735
                            ],
                            [
                                -81.12758,
                                69.93897
                            ],
                            [
                                -81.28869,
                                70.03608
                            ],
                            [
                                -81.69473,
                                70.07843
                            ],
                            [
                                -81.74109,
                                70.13766
                            ],
                            [
                                -81.38735,
                                70.09692
                            ],
                            [
                                -81.22024,
                                70.09949
                            ],
                            [
                                -80.95929,
                                70.06494
                            ],
                            [
                                -80.83979,
                                70.07669
                            ],
                            [
                                -80.5642,
                                70.05457
                            ],
                            [
                                -80.29148,
                                69.99297
                            ],
                            [
                                -80.21833,
                                70.02402
                            ],
                            [
                                -79.91514,
                                70.011
                            ],
                            [
                                -79.72139,
                                69.8679
                            ],
                            [
                                -79.41343,
                                69.89795
                            ],
                            [
                                -78.86511,
                                69.89751
                            ],
                            [
                                -78.65602,
                                69.97817
                            ],
                            [
                                -78.74492,
                                70.08153
                            ],
                            [
                                -78.76641,
                                70.19665
                            ],
                            [
                                -78.92092,
                                70.30948
                            ],
                            [
                                -79.23065,
                                70.3168
                            ],
                            [
                                -79.34639,
                                70.37378
                            ],
                            [
                                -79.56915,
                                70.39431
                            ],
                            [
                                -79.39246,
                                70.45161
                            ],
                            [
                                -79.16765,
                                70.41828
                            ],
                            [
                                -78.99627,
                                70.45845
                            ],
                            [
                                -78.75967,
                                70.44313
                            ],
                            [
                                -78.37365,
                                70.20662
                            ],
                            [
                                -78.177,
                                70.2048
                            ],
                            [
                                -77.97799,
                                70.24959
                            ],
                            [
                                -77.79522,
                                70.24967
                            ],
                            [
                                -77.67667,
                                70.20332
                            ],
                            [
                                -77.65636,
                                70.07576
                            ],
                            [
                                -77.69325,
                                70.00094
                            ],
                            [
                                -77.63607,
                                69.7543
                            ],
                            [
                                -77.50068,
                                69.78329
                            ],
                            [
                                -77.43396,
                                69.86692
                            ],
                            [
                                -77.30834,
                                69.8377
                            ],
                            [
                                -76.92035,
                                69.81129
                            ],
                            [
                                -76.85706,
                                69.68587
                            ],
                            [
                                -77.13794,
                                69.68463
                            ],
                            [
                                -77.14658,
                                69.62701
                            ],
                            [
                                -76.72282,
                                69.56311
                            ],
                            [
                                -76.39953,
                                69.44983
                            ],
                            [
                                -76.17524,
                                69.42676
                            ],
                            [
                                -75.76222,
                                69.31409
                            ],
                            [
                                -75.58851,
                                69.23827
                            ],
                            [
                                -75.5578,
                                69.15711
                            ],
                            [
                                -75.59353,
                                69.07827
                            ],
                            [
                                -75.7426,
                                69.08792
                            ],
                            [
                                -75.97471,
                                69.00811
                            ],
                            [
                                -76.34181,
                                69.05922
                            ],
                            [
                                -76.59763,
                                69.03149
                            ],
                            [
                                -76.64598,
                                68.94442
                            ],
                            [
                                -76.50779,
                                68.87897
                            ],
                            [
                                -76.67266,
                                68.72311
                            ],
                            [
                                -76.58488,
                                68.6774
                            ],
                            [
                                -76.40765,
                                68.67978
                            ],
                            [
                                -76.07078,
                                68.75833
                            ],
                            [
                                -75.95144,
                                68.82044
                            ],
                            [
                                -75.57946,
                                68.88869
                            ],
                            [
                                -75.49851,
                                68.94016
                            ],
                            [
                                -75.57909,
                                68.97838
                            ],
                            [
                                -75.49134,
                                69.02617
                            ],
                            [
                                -75.35205,
                                68.95334
                            ],
                            [
                                -75.13184,
                                68.88824
                            ],
                            [
                                -75.05015,
                                69.00902
                            ],
                            [
                                -74.85609,
                                69.0742
                            ],
                            [
                                -74.64421,
                                69.0445
                            ],
                            [
                                -74.93428,
                                69.00095
                            ],
                            [
                                -74.82059,
                                68.9447
                            ],
                            [
                                -74.67618,
                                68.93722
                            ],
                            [
                                -74.6652,
                                68.87532
                            ],
                            [
                                -74.8688,
                                68.81968
                            ],
                            [
                                -74.72539,
                                68.73878
                            ],
                            [
                                -74.49862,
                                68.6489
                            ],
                            [
                                -74.48939,
                                68.59746
                            ],
                            [
                                -74.37401,
                                68.55105
                            ],
                            [
                                -74.01204,
                                68.49945
                            ],
                            [
                                -73.88962,
                                68.55909
                            ],
                            [
                                -74.18159,
                                68.73494
                            ],
                            [
                                -73.76569,
                                68.68795
                            ],
                            [
                                -73.71425,
                                68.66219
                            ],
                            [
                                -73.74581,
                                68.51473
                            ],
                            [
                                -73.85917,
                                68.50127
                            ],
                            [
                                -73.9127,
                                68.41426
                            ],
                            [
                                -73.79879,
                                68.32167
                            ],
                            [
                                -73.30885,
                                68.25567
                            ],
                            [
                                -73.16669,
                                68.21936
                            ],
                            [
                                -73.00602,
                                68.23698
                            ],
                            [
                                -72.96875,
                                68.1102
                            ],
                            [
                                -72.8831,
                                68.04243
                            ],
                            [
                                -72.94556,
                                67.98885
                            ],
                            [
                                -72.86301,
                                67.88616
                            ],
                            [
                                -72.69479,
                                67.85639
                            ],
                            [
                                -72.57107,
                                67.73806
                            ],
                            [
                                -72.65415,
                                67.68222
                            ],
                            [
                                -72.48569,
                                67.6232
                            ],
                            [
                                -72.39994,
                                67.42667
                            ],
                            [
                                -72.22868,
                                67.25001
                            ],
                            [
                                -72.27499,
                                67.15515
                            ],
                            [
                                -72.39671,
                                67.08805
                            ],
                            [
                                -72.64269,
                                67.08017
                            ],
                            [
                                -72.79319,
                                67.02569
                            ],
                            [
                                -72.85122,
                                66.9296
                            ],
                            [
                                -72.94825,
                                66.86182
                            ],
                            [
                                -72.9889,
                                66.74683
                            ],
                            [
                                -72.77659,
                                66.7038
                            ],
                            [
                                -72.53117,
                                66.68672
                            ],
                            [
                                -72.28892,
                                66.69655
                            ],
                            [
                                -72.04704,
                                66.68232
                            ],
                            [
                                -71.58157,
                                66.61668
                            ],
                            [
                                -71.37613,
                                66.62335
                            ],
                            [
                                -71.29029,
                                66.72414
                            ],
                            [
                                -71.26625,
                                66.80993
                            ],
                            [
                                -71.18563,
                                66.85263
                            ],
                            [
                                -71.1183,
                                66.95109
                            ],
                            [
                                -71.24772,
                                66.97902
                            ],
                            [
                                -71.10975,
                                67.02789
                            ],
                            [
                                -70.9861,
                                67.02382
                            ],
                            [
                                -70.77725,
                                66.91315
                            ],
                            [
                                -70.62812,
                                66.89167
                            ],
                            [
                                -70.52874,
                                66.76039
                            ],
                            [
                                -70.39591,
                                66.73593
                            ],
                            [
                                -70.2883,
                                66.69578
                            ],
                            [
                                -69.96391,
                                66.69602
                            ],
                            [
                                -69.91238,
                                66.65855
                            ],
                            [
                                -69.71392,
                                66.64369
                            ],
                            [
                                -69.80653,
                                66.55169
                            ],
                            [
                                -69.56287,
                                66.61027
                            ],
                            [
                                -69.40989,
                                66.54096
                            ],
                            [
                                -69.59669,
                                66.41906
                            ],
                            [
                                -69.35648,
                                66.39625
                            ],
                            [
                                -69.27894,
                                66.36234
                            ],
                            [
                                -69.63831,
                                66.24935
                            ],
                            [
                                -69.83096,
                                66.21793
                            ],
                            [
                                -69.84671,
                                66.26502
                            ],
                            [
                                -70.15611,
                                66.23735
                            ],
                            [
                                -70.25572,
                                66.177
                            ],
                            [
                                -70.6177,
                                66.25564
                            ],
                            [
                                -70.64619,
                                66.21471
                            ],
                            [
                                -70.84205,
                                66.1598
                            ],
                            [
                                -70.90911,
                                66.07495
                            ],
                            [
                                -71.13828,
                                65.95683
                            ],
                            [
                                -71.2494,
                                65.93883
                            ],
                            [
                                -71.3069,
                                66.00465
                            ],
                            [
                                -71.16387,
                                66.02131
                            ],
                            [
                                -71.27015,
                                66.10182
                            ],
                            [
                                -71.17115,
                                66.14141
                            ],
                            [
                                -71.13741,
                                66.2926
                            ],
                            [
                                -71.2768,
                                66.5053
                            ],
                            [
                                -71.33677,
                                66.55342
                            ],
                            [
                                -71.64839,
                                66.57907
                            ],
                            [
                                -71.98792,
                                66.65711
                            ],
                            [
                                -72.17294,
                                66.67758
                            ],
                            [
                                -72.34575,
                                66.66296
                            ],
                            [
                                -72.60526,
                                66.6715
                            ],
                            [
                                -73.03486,
                                66.72058
                            ],
                            [
                                -73.32977,
                                66.64852
                            ],
                            [
                                -73.39286,
                                66.56435
                            ],
                            [
                                -73.6558,
                                66.47066
                            ],
                            [
                                -73.76055,
                                66.41287
                            ],
                            [
                                -74.02584,
                                66.30708
                            ],
                            [
                                -74.39541,
                                66.20124
                            ],
                            [
                                -74.46147,
                                66.14813
                            ],
                            [
                                -74.41707,
                                66.08804
                            ],
                            [
                                -74.19974,
                                65.97475
                            ],
                            [
                                -74.02858,
                                65.84698
                            ],
                            [
                                -73.70675,
                                65.75911
                            ],
                            [
                                -73.68798,
                                65.66505
                            ],
                            [
                                -73.50011,
                                65.49146
                            ],
                            [
                                -73.68872,
                                65.45697
                            ],
                            [
                                -73.81317,
                                65.52635
                            ],
                            [
                                -74.06732,
                                65.53438
                            ],
                            [
                                -74.30587,
                                65.47189
                            ],
                            [
                                -74.36203,
                                65.40303
                            ],
                            [
                                -74.54058,
                                65.32351
                            ],
                            [
                                -74.66505,
                                65.37456
                            ],
                            [
                                -74.85769,
                                65.38671
                            ],
                            [
                                -74.98891,
                                65.36789
                            ],
                            [
                                -75.13461,
                                65.25649
                            ],
                            [
                                -75.26876,
                                65.25095
                            ],
                            [
                                -75.56074,
                                65.27062
                            ],
                            [
                                -75.61096,
                                65.29942
                            ],
                            [
                                -75.84215,
                                65.31318
                            ],
                            [
                                -75.93487,
                                65.25424
                            ],
                            [
                                -76.15687,
                                65.2929
                            ],
                            [
                                -76.81671,
                                65.43037
                            ],
                            [
                                -76.99511,
                                65.40023
                            ],
                            [
                                -77.14337,
                                65.4486
                            ],
                            [
                                -77.34408,
                                65.46884
                            ],
                            [
                                -77.41985,
                                65.43181
                            ],
                            [
                                -77.50341,
                                65.31702
                            ],
                            [
                                -77.30911,
                                65.18179
                            ],
                            [
                                -77.49065,
                                65.13128
                            ],
                            [
                                -77.63053,
                                65.13996
                            ],
                            [
                                -77.7551,
                                65.08447
                            ],
                            [
                                -77.96184,
                                65.04518
                            ],
                            [
                                -78.14303,
                                64.94723
                            ],
                            [
                                -78.06697,
                                64.83453
                            ],
                            [
                                -78.16724,
                                64.75941
                            ],
                            [
                                -78.17713,
                                64.62312
                            ],
                            [
                                -78.02654,
                                64.42944
                            ],
                            [
                                -77.7954,
                                64.37507
                            ],
                            [
                                -77.73802,
                                64.33136
                            ],
                            [
                                -77.50004,
                                64.35501
                            ],
                            [
                                -77.40014,
                                64.32542
                            ],
                            [
                                -77.36175,
                                64.24117
                            ],
                            [
                                -77.14696,
                                64.28619
                            ],
                            [
                                -76.8273,
                                64.23568
                            ],
                            [
                                -76.50419,
                                64.29714
                            ],
                            [
                                -76.44696,
                                64.26495
                            ],
                            [
                                -76.0332,
                                64.37913
                            ],
                            [
                                -75.72295,
                                64.36336
                            ],
                            [
                                -75.79818,
                                64.45899
                            ],
                            [
                                -75.71182,
                                64.58086
                            ],
                            [
                                -75.61174,
                                64.54568
                            ],
                            [
                                -75.43688,
                                64.52823
                            ],
                            [
                                -75.19899,
                                64.44154
                            ],
                            [
                                -75.11781,
                                64.47573
                            ],
                            [
                                -74.87008,
                                64.39641
                            ],
                            [
                                -74.46733,
                                64.40227
                            ],
                            [
                                -74.51667,
                                64.51275
                            ],
                            [
                                -74.46932,
                                64.56249
                            ],
                            [
                                -74.65478,
                                64.66682
                            ],
                            [
                                -74.80635,
                                64.70286
                            ],
                            [
                                -74.86705,
                                64.76052
                            ],
                            [
                                -74.69843,
                                64.76863
                            ],
                            [
                                -74.72076,
                                64.83614
                            ],
                            [
                                -74.55866,
                                64.83437
                            ],
                            [
                                -74.68482,
                                64.73444
                            ],
                            [
                                -74.53422,
                                64.63108
                            ],
                            [
                                -74.35754,
                                64.57151
                            ],
                            [
                                -74.22177,
                                64.66336
                            ],
                            [
                                -74.04422,
                                64.6551
                            ],
                            [
                                -74.02898,
                                64.43289
                            ],
                            [
                                -73.95812,
                                64.47866
                            ],
                            [
                                -73.81158,
                                64.46164
                            ],
                            [
                                -73.64591,
                                64.38735
                            ],
                            [
                                -73.37116,
                                64.33816
                            ],
                            [
                                -73.06928,
                                64.25012
                            ],
                            [
                                -73.04173,
                                64.20164
                            ],
                            [
                                -72.90829,
                                64.17297
                            ],
                            [
                                -72.88401,
                                64.12794
                            ],
                            [
                                -72.9475,
                                64.05438
                            ],
                            [
                                -72.7339,
                                64.00268
                            ],
                            [
                                -72.5979,
                                63.87446
                            ],
                            [
                                -72.46566,
                                63.79721
                            ],
                            [
                                -72.30177,
                                63.8674
                            ],
                            [
                                -72.229,
                                63.80077
                            ],
                            [
                                -72.337,
                                63.75998
                            ],
                            [
                                -72.01631,
                                63.68017
                            ],
                            [
                                -71.87484,
                                63.6899
                            ],
                            [
                                -71.83787,
                                63.78239
                            ],
                            [
                                -71.67809,
                                63.68504
                            ],
                            [
                                -71.50858,
                                63.62466
                            ],
                            [
                                -71.34752,
                                63.63245
                            ],
                            [
                                -71.21663,
                                63.59249
                            ],
                            [
                                -71.29272,
                                63.52092
                            ],
                            [
                                -71.37882,
                                63.52646
                            ],
                            [
                                -71.62543,
                                63.41027
                            ],
                            [
                                -71.91439,
                                63.44152
                            ],
                            [
                                -72.05851,
                                63.39911
                            ],
                            [
                                -71.72437,
                                63.35475
                            ],
                            [
                                -71.7844,
                                63.32212
                            ],
                            [
                                -71.68103,
                                63.21763
                            ],
                            [
                                -71.69522,
                                63.18662
                            ],
                            [
                                -71.41143,
                                63.07184
                            ],
                            [
                                -71.10967,
                                62.97933
                            ],
                            [
                                -70.97205,
                                62.98506
                            ],
                            [
                                -70.80034,
                                62.94751
                            ],
                            [
                                -70.79044,
                                62.89556
                            ],
                            [
                                -70.55339,
                                62.88175
                            ],
                            [
                                -70.21345,
                                62.75855
                            ],
                            [
                                -70.08188,
                                62.74941
                            ],
                            [
                                -69.99802,
                                62.78059
                            ],
                            [
                                -69.80035,
                                62.76605
                            ],
                            [
                                -69.54079,
                                62.7707
                            ],
                            [
                                -69.45142,
                                62.71121
                            ],
                            [
                                -69.51755,
                                62.67794
                            ],
                            [
                                -69.39847,
                                62.57269
                            ],
                            [
                                -69.27565,
                                62.57758
                            ],
                            [
                                -69.28118,
                                62.50082
                            ],
                            [
                                -69.19844,
                                62.4402
                            ],
                            [
                                -68.97287,
                                62.36571
                            ],
                            [
                                -68.79905,
                                62.34776
                            ],
                            [
                                -68.5989,
                                62.26113
                            ],
                            [
                                -68.26059,
                                62.21793
                            ],
                            [
                                -68.06469,
                                62.22105
                            ],
                            [
                                -67.99267,
                                62.19549
                            ],
                            [
                                -67.79168,
                                62.19831
                            ],
                            [
                                -67.71099,
                                62.15347
                            ],
                            [
                                -67.54124,
                                62.17767
                            ],
                            [
                                -67.4469,
                                62.13613
                            ],
                            [
                                -67.35465,
                                62.15401
                            ],
                            [
                                -67.29159,
                                62.07074
                            ],
                            [
                                -67.17461,
                                62.0836
                            ],
                            [
                                -67.06934,
                                62.03909
                            ],
                            [
                                -66.70541,
                                62.01439
                            ],
                            [
                                -66.60902,
                                61.93937
                            ],
                            [
                                -66.27381,
                                61.86487
                            ],
                            [
                                -65.94628,
                                61.88145
                            ],
                            [
                                -66.01371,
                                62.05015
                            ],
                            [
                                -66.04283,
                                62.22152
                            ],
                            [
                                -66.20712,
                                62.34748
                            ],
                            [
                                -66.43319,
                                62.33112
                            ],
                            [
                                -66.35842,
                                62.41155
                            ],
                            [
                                -66.44674,
                                62.48779
                            ],
                            [
                                -66.74782,
                                62.66988
                            ],
                            [
                                -67.01434,
                                62.70025
                            ],
                            [
                                -67.0221,
                                62.76846
                            ],
                            [
                                -67.19127,
                                62.86739
                            ],
                            [
                                -67.59501,
                                63.05838
                            ],
                            [
                                -67.75645,
                                63.08054
                            ],
                            [
                                -67.88969,
                                63.14686
                            ],
                            [
                                -68.17733,
                                63.19532
                            ],
                            [
                                -68.26628,
                                63.30475
                            ],
                            [
                                -68.74901,
                                63.55473
                            ],
                            [
                                -68.87846,
                                63.67598
                            ],
                            [
                                -68.90248,
                                63.75897
                            ],
                            [
                                -68.68589,
                                63.73168
                            ],
                            [
                                -68.41621,
                                63.72748
                            ],
                            [
                                -68.3801,
                                63.6629
                            ],
                            [
                                -68.1991,
                                63.62612
                            ],
                            [
                                -67.98343,
                                63.5498
                            ],
                            [
                                -67.81993,
                                63.46727
                            ],
                            [
                                -67.78177,
                                63.41093
                            ],
                            [
                                -67.62376,
                                63.42045
                            ],
                            [
                                -67.78993,
                                63.57582
                            ],
                            [
                                -67.76975,
                                63.6277
                            ],
                            [
                                -67.66099,
                                63.63923
                            ],
                            [
                                -67.4948,
                                63.52818
                            ],
                            [
                                -67.49813,
                                63.48838
                            ],
                            [
                                -67.16156,
                                63.30045
                            ],
                            [
                                -67.03375,
                                63.28374
                            ],
                            [
                                -66.84694,
                                63.14733
                            ],
                            [
                                -66.64814,
                                63.03713
                            ],
                            [
                                -66.54391,
                                63.08287
                            ],
                            [
                                -66.33723,
                                62.99763
                            ],
                            [
                                -66.25404,
                                63.00798
                            ],
                            [
                                -66.15821,
                                62.95305
                            ],
                            [
                                -66.06537,
                                63.00352
                            ],
                            [
                                -65.86952,
                                62.97766
                            ],
                            [
                                -65.63504,
                                62.89906
                            ],
                            [
                                -65.58696,
                                62.82515
                            ],
                            [
                                -65.3939,
                                62.82296
                            ],
                            [
                                -65.28875,
                                62.7651
                            ],
                            [
                                -65.34842,
                                62.69299
                            ],
                            [
                                -65.27011,
                                62.65725
                            ],
                            [
                                -65.17693,
                                62.5619
                            ],
                            [
                                -64.95797,
                                62.52926
                            ],
                            [
                                -64.84287,
                                62.55749
                            ],
                            [
                                -64.92899,
                                62.64611
                            ],
                            [
                                -64.94431,
                                62.72317
                            ],
                            [
                                -65.13551,
                                62.84376
                            ],
                            [
                                -65.19093,
                                62.9083
                            ],
                            [
                                -65.07107,
                                62.9462
                            ],
                            [
                                -64.91302,
                                62.89594
                            ],
                            [
                                -64.80789,
                                62.83382
                            ],
                            [
                                -64.63367,
                                62.89723
                            ],
                            [
                                -64.73545,
                                62.95283
                            ],
                            [
                                -64.79744,
                                63.07377
                            ],
                            [
                                -64.86591,
                                63.08891
                            ],
                            [
                                -64.89587,
                                63.16555
                            ],
                            [
                                -65.00821,
                                63.18664
                            ],
                            [
                                -64.88915,
                                63.24683
                            ],
                            [
                                -64.95728,
                                63.38717
                            ],
                            [
                                -65.12138,
                                63.43139
                            ],
                            [
                                -65.00571,
                                63.45803
                            ],
                            [
                                -65.06505,
                                63.52077
                            ],
                            [
                                -65.05386,
                                63.56621
                            ],
                            [
                                -64.84693,
                                63.54727
                            ],
                            [
                                -64.81414,
                                63.45832
                            ],
                            [
                                -64.6994,
                                63.27972
                            ],
                            [
                                -64.58487,
                                63.23939
                            ],
                            [
                                -64.47386,
                                63.31765
                            ],
                            [
                                -64.50651,
                                63.39772
                            ],
                            [
                                -64.46182,
                                63.43049
                            ],
                            [
                                -64.51713,
                                63.57052
                            ],
                            [
                                -64.51091,
                                63.68647
                            ],
                            [
                                -64.65221,
                                63.73674
                            ],
                            [
                                -64.86936,
                                63.77033
                            ],
                            [
                                -64.96168,
                                63.81105
                            ],
                            [
                                -64.87495,
                                63.89147
                            ],
                            [
                                -64.61126,
                                63.97532
                            ],
                            [
                                -64.6774,
                                64.00438
                            ],
                            [
                                -65.023,
                                63.9983
                            ],
                            [
                                -65.01283,
                                64.04788
                            ],
                            [
                                -65.28885,
                                64.21959
                            ],
                            [
                                -65.44392,
                                64.2794
                            ],
                            [
                                -65.3858,
                                64.30849
                            ],
                            [
                                -65.19706,
                                64.29459
                            ],
                            [
                                -65.15644,
                                64.38474
                            ],
                            [
                                -65.07094,
                                64.40874
                            ],
                            [
                                -65.0882,
                                64.50108
                            ],
                            [
                                -65.31129,
                                64.53625
                            ],
                            [
                                -65.41739,
                                64.49616
                            ],
                            [
                                -65.69372,
                                64.49935
                            ],
                            [
                                -65.67954,
                                64.59437
                            ],
                            [
                                -65.55691,
                                64.64111
                            ],
                            [
                                -65.53079,
                                64.72178
                            ],
                            [
                                -65.66986,
                                64.83493
                            ],
                            [
                                -65.82249,
                                64.88144
                            ],
                            [
                                -66.05475,
                                64.83215
                            ],
                            [
                                -66.1518,
                                64.69519
                            ],
                            [
                                -66.24386,
                                64.76096
                            ],
                            [
                                -66.15604,
                                64.79967
                            ],
                            [
                                -66.1216,
                                64.86851
                            ],
                            [
                                -66.43069,
                                64.93434
                            ],
                            [
                                -66.45665,
                                64.98484
                            ],
                            [
                                -66.61295,
                                65.03554
                            ],
                            [
                                -66.666,
                                64.82271
                            ],
                            [
                                -66.73261,
                                64.83032
                            ],
                            [
                                -66.74258,
                                65.01062
                            ],
                            [
                                -66.8352,
                                65.09511
                            ],
                            [
                                -66.85172,
                                65.15732
                            ],
                            [
                                -66.96301,
                                65.20675
                            ],
                            [
                                -67.09097,
                                65.19877
                            ],
                            [
                                -67.15862,
                                65.25826
                            ],
                            [
                                -67.12931,
                                65.35582
                            ],
                            [
                                -67.05675,
                                65.45215
                            ],
                            [
                                -67.41674,
                                65.49053
                            ],
                            [
                                -67.41045,
                                65.54049
                            ],
                            [
                                -67.26365,
                                65.58827
                            ],
                            [
                                -67.32092,
                                65.66711
                            ],
                            [
                                -67.43806,
                                65.67945
                            ],
                            [
                                -67.74452,
                                65.63618
                            ],
                            [
                                -67.85478,
                                65.65834
                            ],
                            [
                                -67.91521,
                                65.75355
                            ],
                            [
                                -68.09031,
                                65.79787
                            ],
                            [
                                -68.16216,
                                65.85799
                            ],
                            [
                                -68.11748,
                                65.9236
                            ],
                            [
                                -68.2978,
                                65.91227
                            ],
                            [
                                -68.32395,
                                66.01762
                            ],
                            [
                                -68.10557,
                                66.02884
                            ],
                            [
                                -68.01572,
                                66.07902
                            ],
                            [
                                -68.21317,
                                66.1357
                            ],
                            [
                                -68.36126,
                                66.13023
                            ],
                            [
                                -68.4586,
                                66.21775
                            ],
                            [
                                -68.24561,
                                66.21664
                            ],
                            [
                                -68.22451,
                                66.14988
                            ],
                            [
                                -68.00273,
                                66.1051
                            ],
                            [
                                -68.0158,
                                66.03509
                            ],
                            [
                                -67.94103,
                                65.91494
                            ],
                            [
                                -67.78083,
                                65.87791
                            ],
                            [
                                -67.40972,
                                65.92275
                            ],
                            [
                                -67.14009,
                                65.92077
                            ],
                            [
                                -67.15582,
                                66.03985
                            ],
                            [
                                -67.26994,
                                66.10441
                            ],
                            [
                                -67.4415,
                                66.14128
                            ],
                            [
                                -67.7404,
                                66.24798
                            ],
                            [
                                -67.6995,
                                66.28583
                            ],
                            [
                                -67.86868,
                                66.45397
                            ],
                            [
                                -67.68132,
                                66.45401
                            ],
                            [
                                -67.49133,
                                66.39318
                            ],
                            [
                                -67.41788,
                                66.29816
                            ],
                            [
                                -67.2123,
                                66.28443
                            ],
                            [
                                -67.12314,
                                66.44142
                            ],
                            [
                                -67.26355,
                                66.48422
                            ],
                            [
                                -67.37024,
                                66.55145
                            ],
                            [
                                -67.06494,
                                66.51556
                            ],
                            [
                                -66.85873,
                                66.56619
                            ],
                            [
                                -66.79992,
                                66.45559
                            ],
                            [
                                -66.68557,
                                66.37569
                            ],
                            [
                                -66.47481,
                                66.31591
                            ],
                            [
                                -66.53944,
                                66.24021
                            ],
                            [
                                -66.45301,
                                66.20689
                            ],
                            [
                                -66.31488,
                                66.24818
                            ],
                            [
                                -66.14143,
                                66.13172
                            ],
                            [
                                -65.88448,
                                66.09843
                            ],
                            [
                                -65.9623,
                                66.04269
                            ],
                            [
                                -65.95125,
                                65.96884
                            ],
                            [
                                -65.77408,
                                65.96211
                            ],
                            [
                                -65.35522,
                                65.98335
                            ],
                            [
                                -65.01996,
                                66.06851
                            ],
                            [
                                -64.8342,
                                66.1022
                            ],
                            [
                                -64.85296,
                                66.02549
                            ],
                            [
                                -65.33739,
                                65.913
                            ],
                            [
                                -65.49726,
                                65.74682
                            ],
                            [
                                -65.44989,
                                65.675
                            ],
                            [
                                -65.28491,
                                65.63608
                            ],
                            [
                                -65.30472,
                                65.54761
                            ],
                            [
                                -65.15183,
                                65.53938
                            ],
                            [
                                -65.15686,
                                65.43423
                            ],
                            [
                                -65.05172,
                                65.37218
                            ],
                            [
                                -64.96829,
                                65.40721
                            ],
                            [
                                -64.68441,
                                65.42377
                            ],
                            [
                                -64.90017,
                                65.31371
                            ],
                            [
                                -64.89858,
                                65.27074
                            ],
                            [
                                -64.71906,
                                65.2204
                            ],
                            [
                                -64.60828,
                                65.12366
                            ],
                            [
                                -64.51342,
                                65.11495
                            ],
                            [
                                -64.37036,
                                65.17986
                            ],
                            [
                                -64.26202,
                                65.10392
                            ],
                            [
                                -64.0834,
                                65.11348
                            ],
                            [
                                -63.89802,
                                65.07995
                            ],
                            [
                                -63.84382,
                                64.97882
                            ],
                            [
                                -63.71971,
                                64.9606
                            ],
                            [
                                -63.60296,
                                64.8933
                            ],
                            [
                                -63.5585,
                                64.99476
                            ],
                            [
                                -63.39771,
                                65.03428
                            ],
                            [
                                -63.46978,
                                65.18734
                            ],
                            [
                                -63.31722,
                                65.18805
                            ],
                            [
                                -63.38074,
                                65.30866
                            ],
                            [
                                -63.47688,
                                65.39649
                            ],
                            [
                                -63.36042,
                                65.461
                            ],
                            [
                                -63.33258,
                                65.59397
                            ],
                            [
                                -63.58989,
                                65.66761
                            ],
                            [
                                -63.38458,
                                65.68659
                            ],
                            [
                                -63.41466,
                                65.7821
                            ],
                            [
                                -63.5269,
                                65.87198
                            ],
                            [
                                -63.47548,
                                65.91346
                            ],
                            [
                                -63.2271,
                                65.65538
                            ],
                            [
                                -63.04053,
                                65.62384
                            ],
                            [
                                -62.95411,
                                65.575
                            ],
                            [
                                -62.61912,
                                65.62895
                            ],
                            [
                                -62.57227,
                                65.71088
                            ],
                            [
                                -62.60605,
                                65.7702
                            ],
                            [
                                -62.41835,
                                65.7851
                            ],
                            [
                                -62.35133,
                                65.82092
                            ],
                            [
                                -62.41538,
                                65.96335
                            ],
                            [
                                -62.19258,
                                66.0034
                            ],
                            [
                                -62.16174,
                                66.14068
                            ],
                            [
                                -62.27657,
                                66.13905
                            ],
                            [
                                -62.52376,
                                66.21159
                            ],
                            [
                                -62.32104,
                                66.29699
                            ],
                            [
                                -62.50317,
                                66.39921
                            ],
                            [
                                -62.2002,
                                66.40101
                            ],
                            [
                                -62.18452,
                                66.31279
                            ],
                            [
                                -62.07463,
                                66.32306
                            ],
                            [
                                -61.89018,
                                66.27801
                            ],
                            [
                                -61.76118,
                                66.32415
                            ],
                            [
                                -61.53367,
                                66.32866
                            ],
                            [
                                -61.50187,
                                66.38351
                            ],
                            [
                                -61.56171,
                                66.45795
                            ],
                            [
                                -61.80371,
                                66.61411
                            ],
                            [
                                -61.74793,
                                66.63887
                            ],
                            [
                                -61.52943,
                                66.52639
                            ],
                            [
                                -61.35711,
                                66.56638
                            ],
                            [
                                -61.28688,
                                66.67376
                            ],
                            [
                                -61.58912,
                                66.81204
                            ],
                            [
                                -61.62585,
                                66.86264
                            ],
                            [
                                -61.83368,
                                66.95752
                            ],
                            [
                                -62.03848,
                                66.94854
                            ],
                            [
                                -62.01645,
                                67.05571
                            ],
                            [
                                -62.27142,
                                67.03553
                            ],
                            [
                                -62.25733,
                                66.94584
                            ],
                            [
                                -62.50925,
                                66.86633
                            ],
                            [
                                -62.56352,
                                66.9515
                            ],
                            [
                                -62.76264,
                                66.93079
                            ],
                            [
                                -63.13238,
                                66.94588
                            ],
                            [
                                -63.34457,
                                66.87611
                            ],
                            [
                                -63.39112,
                                66.80722
                            ],
                            [
                                -63.55864,
                                66.89188
                            ],
                            [
                                -63.48711,
                                66.92398
                            ],
                            [
                                -63.22079,
                                66.97857
                            ],
                            [
                                -63.28862,
                                67.10464
                            ],
                            [
                                -63.01262,
                                67.1666
                            ],
                            [
                                -62.97604,
                                67.27848
                            ],
                            [
                                -63.07696,
                                67.32831
                            ],
                            [
                                -63.28643,
                                67.30171
                            ],
                            [
                                -63.49363,
                                67.22311
                            ],
                            [
                                -63.75907,
                                67.21511
                            ],
                            [
                                -63.99717,
                                67.27663
                            ],
                            [
                                -63.95136,
                                67.41232
                            ],
                            [
                                -64.14302,
                                67.48096
                            ],
                            [
                                -64.07901,
                                67.60374
                            ],
                            [
                                -64.20828,
                                67.6531
                            ],
                            [
                                -64.23886,
                                67.70245
                            ],
                            [
                                -64.51975,
                                67.81125
                            ],
                            [
                                -64.74681,
                                67.81927
                            ],
                            [
                                -64.77703,
                                67.77804
                            ],
                            [
                                -65.01558,
                                67.78809
                            ],
                            [
                                -65.04665,
                                67.84505
                            ],
                            [
                                -64.9454,
                                67.92053
                            ],
                            [
                                -64.71317,
                                67.97654
                            ],
                            [
                                -64.94035,
                                68.04107
                            ],
                            [
                                -65.09579,
                                68.03676
                            ],
                            [
                                -65.22863,
                                67.93974
                            ],
                            [
                                -65.42308,
                                67.91743
                            ],
                            [
                                -65.45134,
                                67.97612
                            ],
                            [
                                -65.62742,
                                68.00052
                            ],
                            [
                                -65.74848,
                                67.95507
                            ],
                            [
                                -65.77616,
                                67.86386
                            ],
                            [
                                -65.92965,
                                67.86783
                            ],
                            [
                                -66.02585,
                                67.96265
                            ],
                            [
                                -66.22778,
                                68.02949
                            ],
                            [
                                -66.31204,
                                68.12406
                            ],
                            [
                                -66.53557,
                                68.15069
                            ],
                            [
                                -66.83715,
                                68.12059
                            ],
                            [
                                -66.7656,
                                68.23845
                            ],
                            [
                                -67.04601,
                                68.2914
                            ],
                            [
                                -67.07435,
                                68.33417
                            ],
                            [
                                -66.91805,
                                68.42376
                            ],
                            [
                                -67.10195,
                                68.42722
                            ],
                            [
                                -67.41347,
                                68.48405
                            ],
                            [
                                -67.65492,
                                68.56728
                            ],
                            [
                                -67.78452,
                                68.5354
                            ],
                            [
                                -68.13147,
                                68.53757
                            ],
                            [
                                -68.21506,
                                68.58711
                            ],
                            [
                                -68.42394,
                                68.59461
                            ],
                            [
                                -68.2311,
                                68.66333
                            ],
                            [
                                -68.22973,
                                68.71548
                            ],
                            [
                                -68.55852,
                                68.74992
                            ],
                            [
                                -68.67731,
                                68.74027
                            ],
                            [
                                -69.19847,
                                68.82951
                            ],
                            [
                                -69.03775,
                                68.84033
                            ],
                            [
                                -68.93195,
                                68.81173
                            ],
                            [
                                -68.74874,
                                68.81488
                            ],
                            [
                                -68.613,
                                68.85429
                            ],
                            [
                                -68.11041,
                                68.81191
                            ],
                            [
                                -67.98907,
                                68.88767
                            ],
                            [
                                -68.05846,
                                68.94385
                            ],
                            [
                                -68.00264,
                                68.99939
                            ],
                            [
                                -67.72211,
                                69.02674
                            ],
                            [
                                -68.20298,
                                69.15145
                            ],
                            [
                                -68.49376,
                                69.17272
                            ],
                            [
                                -68.57101,
                                69.23868
                            ],
                            [
                                -68.14734,
                                69.20494
                            ],
                            [
                                -68.20893,
                                69.31581
                            ],
                            [
                                -67.71538,
                                69.18594
                            ],
                            [
                                -67.48776,
                                69.17101
                            ],
                            [
                                -67.37495,
                                69.19575
                            ],
                            [
                                -67.13517,
                                69.19714
                            ],
                            [
                                -66.78206,
                                69.14332
                            ],
                            [
                                -66.66233,
                                69.24234
                            ],
                            [
                                -66.76578,
                                69.33025
                            ],
                            [
                                -67.21801,
                                69.46651
                            ],
                            [
                                -67.76706,
                                69.48981
                            ],
                            [
                                -68.03037,
                                69.46781
                            ],
                            [
                                -68.55451,
                                69.58421
                            ],
                            [
                                -68.98525,
                                69.59801
                            ],
                            [
                                -68.67722,
                                69.64975
                            ],
                            [
                                -68.30662,
                                69.63413
                            ],
                            [
                                -68.10779,
                                69.76242
                            ],
                            [
                                -67.78908,
                                69.78265
                            ],
                            [
                                -67.41036,
                                69.72037
                            ],
                            [
                                -67.21007,
                                69.71933
                            ],
                            [
                                -67.16996,
                                69.78255
                            ],
                            [
                                -67.23457,
                                69.97121
                            ],
                            [
                                -67.40797,
                                70.10595
                            ],
                            [
                                -67.79209,
                                70.25817
                            ],
                            [
                                -68.11737,
                                70.32378
                            ],
                            [
                                -68.32852,
                                70.23016
                            ],
                            [
                                -68.3482,
                                70.16864
                            ],
                            [
                                -68.23007,
                                70.10388
                            ],
                            [
                                -68.4386,
                                70.07378
                            ],
                            [
                                -68.69504,
                                69.94567
                            ],
                            [
                                -68.94125,
                                69.95199
                            ],
                            [
                                -69.25111,
                                69.86851
                            ],
                            [
                                -69.40431,
                                69.77865
                            ],
                            [
                                -69.75438,
                                69.80316
                            ],
                            [
                                -69.90336,
                                69.67794
                            ],
                            [
                                -69.98537,
                                69.69211
                            ],
                            [
                                -69.78846,
                                69.83367
                            ],
                            [
                                -69.3843,
                                69.84151
                            ],
                            [
                                -69.25937,
                                69.92897
                            ],
                            [
                                -69.12238,
                                69.98104
                            ],
                            [
                                -68.88327,
                                70.01951
                            ],
                            [
                                -68.644,
                                70.15947
                            ],
                            [
                                -68.82655,
                                70.21274
                            ],
                            [
                                -69.1048,
                                70.17517
                            ],
                            [
                                -69.18394,
                                70.19475
                            ],
                            [
                                -69.63123,
                                70.14708
                            ],
                            [
                                -69.8411,
                                70.14925
                            ],
                            [
                                -69.39281,
                                70.25993
                            ],
                            [
                                -68.70563,
                                70.32865
                            ],
                            [
                                -68.57923,
                                70.40937
                            ],
                            [
                                -68.45741,
                                70.387
                            ],
                            [
                                -68.30108,
                                70.50914
                            ],
                            [
                                -68.35578,
                                70.57595
                            ],
                            [
                                -69.13166,
                                70.72668
                            ],
                            [
                                -69.24275,
                                70.78827
                            ],
                            [
                                -69.46318,
                                70.79204
                            ],
                            [
                                -69.78785,
                                70.7168
                            ],
                            [
                                -70.04945,
                                70.62483
                            ],
                            [
                                -70.21321,
                                70.65116
                            ],
                            [
                                -70.00154,
                                70.72116
                            ],
                            [
                                -69.78407,
                                70.83928
                            ],
                            [
                                -69.87408,
                                70.88147
                            ],
                            [
                                -70.59166,
                                70.72913
                            ],
                            [
                                -70.82269,
                                70.65408
                            ],
                            [
                                -71.00822,
                                70.63018
                            ],
                            [
                                -71.10228,
                                70.46369
                            ],
                            [
                                -71.1948,
                                70.5893
                            ],
                            [
                                -71.1116,
                                70.66969
                            ],
                            [
                                -70.90151,
                                70.71118
                            ],
                            [
                                -70.75626,
                                70.76626
                            ],
                            [
                                -70.71348,
                                70.84267
                            ],
                            [
                                -70.52928,
                                70.92093
                            ],
                            [
                                -70.61047,
                                71.05518
                            ],
                            [
                                -70.78211,
                                71.12035
                            ],
                            [
                                -70.99914,
                                71.05073
                            ],
                            [
                                -71.21519,
                                71.0075
                            ],
                            [
                                -71.28859,
                                70.90617
                            ],
                            [
                                -71.57197,
                                70.87333
                            ],
                            [
                                -71.92726,
                                70.79408
                            ],
                            [
                                -72.1732,
                                70.77936
                            ],
                            [
                                -72.18665,
                                70.83325
                            ],
                            [
                                -72.33404,
                                70.92322
                            ],
                            [
                                -72.19073,
                                70.96653
                            ],
                            [
                                -72.0878,
                                71.08345
                            ],
                            [
                                -71.87853,
                                71.11365
                            ],
                            [
                                -71.48262,
                                71.06689
                            ],
                            [
                                -71.33196,
                                71.18193
                            ],
                            [
                                -71.14628,
                                71.24958
                            ],
                            [
                                -71.30368,
                                71.38107
                            ],
                            [
                                -71.57193,
                                71.49932
                            ],
                            [
                                -71.92713,
                                71.5686
                            ],
                            [
                                -72.15047,
                                71.58583
                            ],
                            [
                                -72.55992,
                                71.65932
                            ],
                            [
                                -72.66817,
                                71.52351
                            ],
                            [
                                -72.79604,
                                71.47789
                            ],
                            [
                                -72.7593,
                                71.42763
                            ],
                            [
                                -72.98643,
                                71.39861
                            ],
                            [
                                -72.94259,
                                71.32864
                            ],
                            [
                                -73.00815,
                                71.23469
                            ],
                            [
                                -73.19347,
                                71.20707
                            ],
                            [
                                -73.21913,
                                71.24152
                            ],
                            [
                                -73.0488,
                                71.28768
                            ],
                            [
                                -73.32495,
                                71.34865
                            ],
                            [
                                -73.42678,
                                71.44119
                            ],
                            [
                                -73.64888,
                                71.44536
                            ],
                            [
                                -73.58871,
                                71.5732
                            ],
                            [
                                -73.74293,
                                71.59138
                            ],
                            [
                                -73.85114,
                                71.53668
                            ],
                            [
                                -73.87871,
                                71.44975
                            ],
                            [
                                -74.06244,
                                71.38366
                            ],
                            [
                                -73.8772,
                                71.61889
                            ],
                            [
                                -73.61597,
                                71.72069
                            ],
                            [
                                -73.70812,
                                71.7739
                            ],
                            [
                                -73.94649,
                                71.76411
                            ],
                            [
                                -74.29213,
                                71.72526
                            ],
                            [
                                -74.32862,
                                71.66873
                            ],
                            [
                                -74.5346,
                                71.64032
                            ],
                            [
                                -74.75972,
                                71.68281
                            ],
                            [
                                -74.70887,
                                71.73754
                            ],
                            [
                                -74.53395,
                                71.80426
                            ],
                            [
                                -74.25015,
                                71.82414
                            ],
                            [
                                -74.11852,
                                71.96415
                            ],
                            [
                                -74.24185,
                                72.0779
                            ],
                            [
                                -74.65332,
                                72.09454
                            ],
                            [
                                -74.99559,
                                72.12591
                            ],
                            [
                                -75.02434,
                                72.1921
                            ],
                            [
                                -74.92901,
                                72.2441
                            ],
                            [
                                -75.18349,
                                72.45951
                            ],
                            [
                                -75.16143,
                                72.49434
                            ],
                            [
                                -75.80081,
                                72.58884
                            ],
                            [
                                -76.13085,
                                72.59318
                            ],
                            [
                                -76.65397,
                                72.64327
                            ],
                            [
                                -76.73431,
                                72.72285
                            ],
                            [
                                -76.95306,
                                72.74498
                            ],
                            [
                                -77.61898,
                                72.75351
                            ],
                            [
                                -77.79041,
                                72.70815
                            ],
                            [
                                -77.96328,
                                72.70177
                            ],
                            [
                                -78.30024,
                                72.61971
                            ],
                            [
                                -78.54676,
                                72.5124
                            ],
                            [
                                -78.54918,
                                72.43745
                            ],
                            [
                                -78.41277,
                                72.38552
                            ],
                            [
                                -77.74841,
                                72.26326
                            ],
                            [
                                -77.7972,
                                72.24596
                            ],
                            [
                                -78.52624,
                                72.35229
                            ],
                            [
                                -78.8241,
                                72.32547
                            ],
                            [
                                -78.7514,
                                72.28086
                            ],
                            [
                                -78.83907,
                                72.20718
                            ],
                            [
                                -78.39564,
                                72.10642
                            ],
                            [
                                -78.47081,
                                72.09218
                            ],
                            [
                                -78.8545,
                                72.1816
                            ],
                            [
                                -78.92852,
                                72.02272
                            ],
                            [
                                -78.67984,
                                71.91714
                            ],
                            [
                                -79.06646,
                                71.9742
                            ],
                            [
                                -79.122,
                                72.01217
                            ],
                            [
                                -79.01048,
                                72.08863
                            ],
                            [
                                -78.94847,
                                72.19745
                            ],
                            [
                                -79.08762,
                                72.33531
                            ],
                            [
                                -79.30242,
                                72.40413
                            ],
                            [
                                -79.47846,
                                72.33167
                            ],
                            [
                                -79.57926,
                                72.34462
                            ],
                            [
                                -79.86748,
                                72.4803
                            ],
                            [
                                -79.88922,
                                72.41061
                            ],
                            [
                                -80.00859,
                                72.39934
                            ],
                            [
                                -80.2852,
                                72.26823
                            ],
                            [
                                -80.2947,
                                72.18178
                            ],
                            [
                                -80.4861,
                                72.18428
                            ],
                            [
                                -80.3199,
                                72.07505
                            ],
                            [
                                -80.38107,
                                72.04242
                            ],
                            [
                                -80.75577,
                                71.98258
                            ],
                            [
                                -80.77646,
                                72.02116
                            ],
                            [
                                -80.99893,
                                72.0655
                            ],
                            [
                                -80.98188,
                                72.0964
                            ],
                            [
                                -80.55059,
                                72.09645
                            ],
                            [
                                -80.88731,
                                72.1849
                            ],
                            [
                                -80.80643,
                                72.2704
                            ],
                            [
                                -80.5754,
                                72.37398
                            ],
                            [
                                -80.46784,
                                72.45867
                            ],
                            [
                                -80.57548,
                                72.51305
                            ],
                            [
                                -80.74389,
                                72.45227
                            ],
                            [
                                -80.97673,
                                72.43887
                            ],
                            [
                                -80.64812,
                                72.55494
                            ],
                            [
                                -80.54339,
                                72.62265
                            ],
                            [
                                -80.24615,
                                72.72893
                            ],
                            [
                                -80.25249,
                                72.78414
                            ],
                            [
                                -80.53082,
                                72.85084
                            ],
                            [
                                -80.63293,
                                72.9292
                            ],
                            [
                                -80.64384,
                                72.99932
                            ],
                            [
                                -80.51026,
                                73.0882
                            ],
                            [
                                -80.61377,
                                73.16439
                            ],
                            [
                                -81.12602,
                                73.23173
                            ],
                            [
                                -81.20444,
                                73.28433
                            ],
                            [
                                -81.14666,
                                73.38695
                            ],
                            [
                                -81.20613,
                                73.5305
                            ],
                            [
                                -81.44044,
                                73.68381
                            ],
                            [
                                -81.56932,
                                73.72534
                            ],
                            [
                                -82.00047,
                                73.73481
                            ],
                            [
                                -82.31664,
                                73.7218
                            ],
                            [
                                -82.704,
                                73.72545
                            ],
                            [
                                -82.88254,
                                73.70707
                            ],
                            [
                                -83.06214,
                                73.64821
                            ],
                            [
                                -83.27152,
                                73.6406
                            ],
                            [
                                -83.64646,
                                73.59171
                            ],
                            [
                                -83.99003,
                                73.50309
                            ],
                            [
                                -83.72786,
                                73.4662
                            ],
                            [
                                -83.7794,
                                73.43351
                            ],
                            [
                                -84.16529,
                                73.48025
                            ],
                            [
                                -84.25571,
                                73.45605
                            ],
                            [
                                -84.76909,
                                73.38696
                            ],
                            [
                                -85.12303,
                                73.31208
                            ],
                            [
                                -85.17025,
                                73.22514
                            ],
                            [
                                -84.64968,
                                73.12811
                            ],
                            [
                                -84.4525,
                                73.11589
                            ],
                            [
                                -84.24373,
                                73.05142
                            ],
                            [
                                -84.89045,
                                73.09685
                            ],
                            [
                                -85.0257,
                                73.13115
                            ],
                            [
                                -85.4012,
                                73.14218
                            ],
                            [
                                -85.54059,
                                73.03101
                            ],
                            [
                                -85.15521,
                                73.01158
                            ],
                            [
                                -84.92207,
                                72.97759
                            ],
                            [
                                -84.62539,
                                72.87448
                            ],
                            [
                                -84.91057,
                                72.89533
                            ],
                            [
                                -85.31291,
                                72.97674
                            ],
                            [
                                -85.56311,
                                72.97221
                            ],
                            [
                                -85.69906,
                                72.90629
                            ],
                            [
                                -85.68584,
                                72.63857
                            ],
                            [
                                -85.51119,
                                72.46007
                            ],
                            [
                                -85.33151,
                                72.40872
                            ],
                            [
                                -84.8767,
                                72.38001
                            ],
                            [
                                -84.92771,
                                72.29161
                            ],
                            [
                                -84.86014,
                                72.22452
                            ],
                            [
                                -85.2219,
                                72.26615
                            ],
                            [
                                -85.37026,
                                72.25528
                            ],
                            [
                                -85.49975,
                                72.1782
                            ],
                            [
                                -85.39135,
                                72.15519
                            ],
                            [
                                -85.51211,
                                72.07138
                            ],
                            [
                                -85.91043,
                                72.03081
                            ],
                            [
                                -85.97807,
                                71.98816
                            ],
                            [
                                -85.55833,
                                71.90238
                            ],
                            [
                                -85.43525,
                                71.80919
                            ],
                            [
                                -85.51739,
                                71.77949
                            ],
                            [
                                -85.25696,
                                71.67364
                            ],
                            [
                                -84.95635,
                                71.65189
                            ],
                            [
                                -84.65662,
                                71.67945
                            ],
                            [
                                -84.66305,
                                71.58437
                            ],
                            [
                                -84.54241,
                                71.54705
                            ],
                            [
                                -84.56901,
                                71.44092
                            ],
                            [
                                -84.75593,
                                71.41749
                            ],
                            [
                                -84.81448,
                                71.06642
                            ],
                            [
                                -84.73593,
                                70.99594
                            ],
                            [
                                -84.77763,
                                70.94112
                            ],
                            [
                                -84.93848,
                                70.92329
                            ],
                            [
                                -84.85218,
                                71.17044
                            ],
                            [
                                -85.08609,
                                71.19924
                            ],
                            [
                                -85.30755,
                                71.17248
                            ],
                            [
                                -85.78033,
                                71.14129
                            ],
                            [
                                -86.1883,
                                71.02221
                            ],
                            [
                                -86.50202,
                                70.98145
                            ],
                            [
                                -86.72175,
                                70.98088
                            ],
                            [
                                -86.77511,
                                71.01171
                            ],
                            [
                                -86.40275,
                                71.03894
                            ],
                            [
                                -86.19509,
                                71.07048
                            ],
                            [
                                -85.94147,
                                71.18441
                            ],
                            [
                                -85.69748,
                                71.2088
                            ],
                            [
                                -85.51505,
                                71.17733
                            ],
                            [
                                -85.3889,
                                71.25887
                            ],
                            [
                                -85.23261,
                                71.30112
                            ],
                            [
                                -84.82864,
                                71.27618
                            ],
                            [
                                -84.92323,
                                71.3515
                            ],
                            [
                                -84.91792,
                                71.42397
                            ],
                            [
                                -85.13768,
                                71.44428
                            ],
                            [
                                -85.39904,
                                71.49644
                            ],
                            [
                                -85.6752,
                                71.60465
                            ],
                            [
                                -86.01886,
                                71.77181
                            ],
                            [
                                -86.12048,
                                71.79834
                            ],
                            [
                                -86.40039,
                                72.01915
                            ],
                            [
                                -86.4539,
                                72.19882
                            ],
                            [
                                -86.43292,
                                72.27197
                            ],
                            [
                                -86.23545,
                                72.4174
                            ],
                            [
                                -86.3757,
                                72.51948
                            ],
                            [
                                -86.69834,
                                72.65869
                            ],
                            [
                                -86.74749,
                                72.72675
                            ],
                            [
                                -86.63234,
                                72.8883
                            ],
                            [
                                -86.43245,
                                72.97556
                            ],
                            [
                                -86.28611,
                                73.07804
                            ],
                            [
                                -86.15009,
                                73.23952
                            ],
                            [
                                -85.86521,
                                73.39395
                            ],
                            [
                                -84.94116,
                                73.6687
                            ],
                            [
                                -84.8401,
                                73.74624
                            ],
                            [
                                -85.09686,
                                73.81035
                            ],
                            [
                                -85.54994,
                                73.82133
                            ],
                            [
                                -86.14778,
                                73.85109
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.48787,
                                83.14282
                            ],
                            [
                                -76.2934,
                                83.13063
                            ],
                            [
                                -77.01048,
                                83.09601
                            ],
                            [
                                -77.47821,
                                83.05011
                            ],
                            [
                                -77.27913,
                                82.95735
                            ],
                            [
                                -76.65796,
                                82.87961
                            ],
                            [
                                -76.30004,
                                82.7634
                            ],
                            [
                                -76.21861,
                                82.69267
                            ],
                            [
                                -75.42279,
                                82.6196
                            ],
                            [
                                -75.75718,
                                82.56248
                            ],
                            [
                                -76.54454,
                                82.66731
                            ],
                            [
                                -77.06881,
                                82.85381
                            ],
                            [
                                -78.22502,
                                82.9682
                            ],
                            [
                                -78.9598,
                                82.95923
                            ],
                            [
                                -79.30601,
                                82.97573
                            ],
                            [
                                -80.08179,
                                82.93443
                            ],
                            [
                                -80.38956,
                                82.88434
                            ],
                            [
                                -81.8434,
                                82.78718
                            ],
                            [
                                -82.33588,
                                82.68023
                            ],
                            [
                                -82.52434,
                                82.59842
                            ],
                            [
                                -82.25812,
                                82.53289
                            ],
                            [
                                -82.72426,
                                82.45715
                            ],
                            [
                                -82.80404,
                                82.38864
                            ],
                            [
                                -82.59999,
                                82.28153
                            ],
                            [
                                -83.29065,
                                82.27262
                            ],
                            [
                                -83.64096,
                                82.34582
                            ],
                            [
                                -84.26901,
                                82.36039
                            ],
                            [
                                -84.59388,
                                82.40232
                            ],
                            [
                                -84.41438,
                                82.45968
                            ],
                            [
                                -85.02764,
                                82.48698
                            ],
                            [
                                -85.64443,
                                82.46913
                            ],
                            [
                                -86.01454,
                                82.43356
                            ],
                            [
                                -86.54316,
                                82.30568
                            ],
                            [
                                -86.12319,
                                82.24454
                            ],
                            [
                                -86.83864,
                                82.21613
                            ],
                            [
                                -86.89732,
                                82.14881
                            ],
                            [
                                -86.5987,
                                82.09797
                            ],
                            [
                                -86.1561,
                                82.09062
                            ],
                            [
                                -85.74806,
                                82.03883
                            ],
                            [
                                -86.87387,
                                82.05159
                            ],
                            [
                                -87.98437,
                                82.12779
                            ],
                            [
                                -88.79224,
                                82.03709
                            ],
                            [
                                -89.85783,
                                81.95675
                            ],
                            [
                                -90.47934,
                                81.967
                            ],
                            [
                                -90.62934,
                                81.84495
                            ],
                            [
                                -90.98379,
                                81.82756
                            ],
                            [
                                -91.65973,
                                81.72764
                            ],
                            [
                                -91.8821,
                                81.61527
                            ],
                            [
                                -91.41199,
                                81.59258
                            ],
                            [
                                -91.18316,
                                81.53357
                            ],
                            [
                                -90.6306,
                                81.66485
                            ],
                            [
                                -89.86035,
                                81.62606
                            ],
                            [
                                -90.27515,
                                81.5193
                            ],
                            [
                                -90.79967,
                                81.44781
                            ],
                            [
                                -90.36648,
                                81.36018
                            ],
                            [
                                -89.02475,
                                81.52199
                            ],
                            [
                                -88.61409,
                                81.51918
                            ],
                            [
                                -89.50452,
                                81.36189
                            ],
                            [
                                -89.89127,
                                81.33853
                            ],
                            [
                                -89.75578,
                                81.24761
                            ],
                            [
                                -90.25535,
                                81.19033
                            ],
                            [
                                -90.09494,
                                81.04891
                            ],
                            [
                                -89.61556,
                                81.00603
                            ],
                            [
                                -88.18536,
                                81.06909
                            ],
                            [
                                -87.36087,
                                81.06565
                            ],
                            [
                                -86.30294,
                                81.13212
                            ],
                            [
                                -85.89598,
                                81.22684
                            ],
                            [
                                -84.95605,
                                81.30589
                            ],
                            [
                                -84.82429,
                                81.26123
                            ],
                            [
                                -85.51438,
                                81.18244
                            ],
                            [
                                -85.90418,
                                81.09156
                            ],
                            [
                                -86.54922,
                                81.01164
                            ],
                            [
                                -87.5216,
                                80.9776
                            ],
                            [
                                -88.00554,
                                81.00873
                            ],
                            [
                                -89.14725,
                                80.94809
                            ],
                            [
                                -89.39909,
                                80.91641
                            ],
                            [
                                -89.28279,
                                80.85372
                            ],
                            [
                                -88.49227,
                                80.74311
                            ],
                            [
                                -88.17738,
                                80.68195
                            ],
                            [
                                -87.48865,
                                80.62248
                            ],
                            [
                                -87.20224,
                                80.62675
                            ],
                            [
                                -87.04017,
                                80.7189
                            ],
                            [
                                -86.57397,
                                80.82188
                            ],
                            [
                                -86.12052,
                                80.96863
                            ],
                            [
                                -85.66497,
                                81.04577
                            ],
                            [
                                -85.18125,
                                81.05021
                            ],
                            [
                                -84.8668,
                                81.07702
                            ],
                            [
                                -83.81577,
                                81.10422
                            ],
                            [
                                -82.78937,
                                81.1676
                            ],
                            [
                                -82.70218,
                                81.12587
                            ],
                            [
                                -83.21905,
                                81.10835
                            ],
                            [
                                -83.93503,
                                81.06026
                            ],
                            [
                                -84.86896,
                                81.02962
                            ],
                            [
                                -85.68021,
                                80.95828
                            ],
                            [
                                -86.59769,
                                80.67848
                            ],
                            [
                                -86.6914,
                                80.59382
                            ],
                            [
                                -86.04832,
                                80.53068
                            ],
                            [
                                -85.14962,
                                80.50958
                            ],
                            [
                                -84.179,
                                80.522
                            ],
                            [
                                -83.7851,
                                80.54339
                            ],
                            [
                                -83.65572,
                                80.62534
                            ],
                            [
                                -83.77556,
                                80.72737
                            ],
                            [
                                -83.35742,
                                80.68113
                            ],
                            [
                                -82.53024,
                                80.74245
                            ],
                            [
                                -81.98652,
                                80.83154
                            ],
                            [
                                -81.75741,
                                80.80918
                            ],
                            [
                                -82.06646,
                                80.73751
                            ],
                            [
                                -82.77155,
                                80.68657
                            ],
                            [
                                -83.08058,
                                80.63943
                            ],
                            [
                                -83.16359,
                                80.56377
                            ],
                            [
                                -82.85597,
                                80.5411
                            ],
                            [
                                -81.59522,
                                80.60163
                            ],
                            [
                                -80.91271,
                                80.65947
                            ],
                            [
                                -79.94797,
                                80.77066
                            ],
                            [
                                -79.46676,
                                80.84855
                            ],
                            [
                                -79.27066,
                                81.04073
                            ],
                            [
                                -78.73417,
                                81.1153
                            ],
                            [
                                -78.6303,
                                81.19239
                            ],
                            [
                                -78.24681,
                                81.2987
                            ],
                            [
                                -77.4019,
                                81.38005
                            ],
                            [
                                -76.89113,
                                81.39656
                            ],
                            [
                                -77.96341,
                                81.2532
                            ],
                            [
                                -78.43142,
                                81.08619
                            ],
                            [
                                -78.95458,
                                80.98116
                            ],
                            [
                                -78.84778,
                                80.85248
                            ],
                            [
                                -77.94173,
                                80.90654
                            ],
                            [
                                -77.54891,
                                80.91562
                            ],
                            [
                                -77.19721,
                                80.88983
                            ],
                            [
                                -76.6744,
                                80.89109
                            ],
                            [
                                -76.74024,
                                80.83891
                            ],
                            [
                                -77.48614,
                                80.83733
                            ],
                            [
                                -78.03461,
                                80.81318
                            ],
                            [
                                -79.28096,
                                80.71124
                            ],
                            [
                                -79.96509,
                                80.60888
                            ],
                            [
                                -79.59304,
                                80.59743
                            ],
                            [
                                -79.0468,
                                80.619
                            ],
                            [
                                -78.18227,
                                80.57053
                            ],
                            [
                                -79.30542,
                                80.55706
                            ],
                            [
                                -80.21052,
                                80.52986
                            ],
                            [
                                -80.32424,
                                80.46531
                            ],
                            [
                                -80.6331,
                                80.46616
                            ],
                            [
                                -81.89432,
                                80.3934
                            ],
                            [
                                -83.19435,
                                80.32743
                            ],
                            [
                                -82.28349,
                                80.05144
                            ],
                            [
                                -81.99696,
                                79.99477
                            ],
                            [
                                -81.40707,
                                79.93838
                            ],
                            [
                                -81.65499,
                                79.91492
                            ],
                            [
                                -81.51509,
                                79.71642
                            ],
                            [
                                -81.08064,
                                79.69306
                            ],
                            [
                                -80.78446,
                                79.64916
                            ],
                            [
                                -80.32585,
                                79.68549
                            ],
                            [
                                -79.86149,
                                79.66397
                            ],
                            [
                                -80.61985,
                                79.60041
                            ],
                            [
                                -81.69655,
                                79.65824
                            ],
                            [
                                -81.96786,
                                79.7195
                            ],
                            [
                                -82.07795,
                                79.85118
                            ],
                            [
                                -83.24362,
                                80.11353
                            ],
                            [
                                -83.55669,
                                80.20933
                            ],
                            [
                                -84.08094,
                                80.27175
                            ],
                            [
                                -85.33844,
                                80.27034
                            ],
                            [
                                -85.716,
                                80.32662
                            ],
                            [
                                -86.03923,
                                80.33447
                            ],
                            [
                                -86.45197,
                                80.30912
                            ],
                            [
                                -86.62419,
                                80.12467
                            ],
                            [
                                -86.43218,
                                79.95214
                            ],
                            [
                                -86.46115,
                                79.78188
                            ],
                            [
                                -85.81673,
                                79.70595
                            ],
                            [
                                -85.59764,
                                79.70751
                            ],
                            [
                                -85.13615,
                                79.64511
                            ],
                            [
                                -84.90224,
                                79.49265
                            ],
                            [
                                -84.49128,
                                79.41674
                            ],
                            [
                                -84.46973,
                                79.33292
                            ],
                            [
                                -84.28745,
                                79.19852
                            ],
                            [
                                -84.01523,
                                79.16903
                            ],
                            [
                                -83.71543,
                                79.06991
                            ],
                            [
                                -83.98986,
                                79.05269
                            ],
                            [
                                -84.14887,
                                79.12142
                            ],
                            [
                                -84.49599,
                                79.14938
                            ],
                            [
                                -84.76208,
                                79.06901
                            ],
                            [
                                -84.67679,
                                79.01867
                            ],
                            [
                                -84.31291,
                                78.97283
                            ],
                            [
                                -83.62178,
                                78.93684
                            ],
                            [
                                -82.87975,
                                78.93528
                            ],
                            [
                                -82.39452,
                                78.89538
                            ],
                            [
                                -82.11299,
                                78.91336
                            ],
                            [
                                -81.82375,
                                79.02225
                            ],
                            [
                                -81.46989,
                                79.0594
                            ],
                            [
                                -81.87965,
                                78.86697
                            ],
                            [
                                -82.44308,
                                78.83524
                            ],
                            [
                                -83.0646,
                                78.86063
                            ],
                            [
                                -83.24993,
                                78.82636
                            ],
                            [
                                -82.8154,
                                78.73289
                            ],
                            [
                                -83.0991,
                                78.71096
                            ],
                            [
                                -83.84971,
                                78.84521
                            ],
                            [
                                -84.66254,
                                78.85762
                            ],
                            [
                                -85.21365,
                                78.91509
                            ],
                            [
                                -85.67237,
                                78.84725
                            ],
                            [
                                -86.6301,
                                78.80096
                            ],
                            [
                                -86.85039,
                                78.74244
                            ],
                            [
                                -87.18066,
                                78.54219
                            ],
                            [
                                -87.39644,
                                78.48024
                            ],
                            [
                                -87.47907,
                                78.36708
                            ],
                            [
                                -87.50073,
                                78.12803
                            ],
                            [
                                -87.12901,
                                78.10473
                            ],
                            [
                                -86.65088,
                                78.12758
                            ],
                            [
                                -86.4919,
                                78.20282
                            ],
                            [
                                -86.2121,
                                78.20058
                            ],
                            [
                                -86.26784,
                                78.08444
                            ],
                            [
                                -86.11734,
                                78.05695
                            ],
                            [
                                -85.41495,
                                78.10768
                            ],
                            [
                                -85.18982,
                                78.20143
                            ],
                            [
                                -84.94388,
                                78.33992
                            ],
                            [
                                -84.77299,
                                78.33728
                            ],
                            [
                                -84.94496,
                                78.23033
                            ],
                            [
                                -84.81668,
                                78.16808
                            ],
                            [
                                -85.05752,
                                78.09915
                            ],
                            [
                                -84.99157,
                                78.06153
                            ],
                            [
                                -85.46044,
                                77.98943
                            ],
                            [
                                -85.67624,
                                77.9332
                            ],
                            [
                                -85.17274,
                                77.76195
                            ],
                            [
                                -85.28812,
                                77.73976
                            ],
                            [
                                -85.21828,
                                77.65438
                            ],
                            [
                                -84.80346,
                                77.58115
                            ],
                            [
                                -84.76237,
                                77.52106
                            ],
                            [
                                -84.22067,
                                77.51703
                            ],
                            [
                                -83.89538,
                                77.49002
                            ],
                            [
                                -83.39759,
                                77.60935
                            ],
                            [
                                -83.20176,
                                77.70557
                            ],
                            [
                                -83.12691,
                                77.7897
                            ],
                            [
                                -82.7512,
                                77.92202
                            ],
                            [
                                -82.69462,
                                77.83069
                            ],
                            [
                                -82.79867,
                                77.80763
                            ],
                            [
                                -83.22277,
                                77.57272
                            ],
                            [
                                -83.39974,
                                77.50953
                            ],
                            [
                                -83.82836,
                                77.44945
                            ],
                            [
                                -84.00173,
                                77.39942
                            ],
                            [
                                -84.58748,
                                77.39421
                            ],
                            [
                                -84.72694,
                                77.31787
                            ],
                            [
                                -84.957,
                                77.38216
                            ],
                            [
                                -85.38225,
                                77.38629
                            ],
                            [
                                -85.51074,
                                77.45905
                            ],
                            [
                                -85.70911,
                                77.43349
                            ],
                            [
                                -85.86519,
                                77.6306
                            ],
                            [
                                -86.18218,
                                77.79592
                            ],
                            [
                                -86.41582,
                                77.8414
                            ],
                            [
                                -86.8308,
                                77.88479
                            ],
                            [
                                -87.26725,
                                77.89825
                            ],
                            [
                                -88.08543,
                                77.81968
                            ],
                            [
                                -88.21732,
                                77.65809
                            ],
                            [
                                -87.70098,
                                77.53737
                            ],
                            [
                                -87.71362,
                                77.36284
                            ],
                            [
                                -87.22715,
                                77.30789
                            ],
                            [
                                -87.04224,
                                77.18454
                            ],
                            [
                                -87.34641,
                                77.18047
                            ],
                            [
                                -87.48042,
                                77.10648
                            ],
                            [
                                -87.68934,
                                77.14149
                            ],
                            [
                                -88.02834,
                                77.11983
                            ],
                            [
                                -88.25743,
                                77.13192
                            ],
                            [
                                -88.45676,
                                77.10194
                            ],
                            [
                                -88.75596,
                                76.9935
                            ],
                            [
                                -89.39364,
                                76.89094
                            ],
                            [
                                -89.517,
                                76.8492
                            ],
                            [
                                -89.40529,
                                76.67416
                            ],
                            [
                                -89.65693,
                                76.57205
                            ],
                            [
                                -89.38195,
                                76.52878
                            ],
                            [
                                -89.22781,
                                76.43609
                            ],
                            [
                                -88.89824,
                                76.40626
                            ],
                            [
                                -88.59084,
                                76.40331
                            ],
                            [
                                -88.48864,
                                76.55873
                            ],
                            [
                                -88.70209,
                                76.7165
                            ],
                            [
                                -88.51565,
                                76.72654
                            ],
                            [
                                -88.49818,
                                76.60833
                            ],
                            [
                                -88.32803,
                                76.49062
                            ],
                            [
                                -88.42407,
                                76.40321
                            ],
                            [
                                -87.69065,
                                76.34292
                            ],
                            [
                                -87.49117,
                                76.37367
                            ],
                            [
                                -87.48956,
                                76.53313
                            ],
                            [
                                -87.20415,
                                76.44605
                            ],
                            [
                                -87.16964,
                                76.40052
                            ],
                            [
                                -86.70834,
                                76.34392
                            ],
                            [
                                -86.56006,
                                76.47766
                            ],
                            [
                                -86.39612,
                                76.46932
                            ],
                            [
                                -86.35206,
                                76.3803
                            ],
                            [
                                -85.73889,
                                76.35219
                            ],
                            [
                                -85.24743,
                                76.28186
                            ],
                            [
                                -84.92361,
                                76.28196
                            ],
                            [
                                -84.43478,
                                76.33286
                            ],
                            [
                                -84.92786,
                                76.41065
                            ],
                            [
                                -85.05904,
                                76.51592
                            ],
                            [
                                -84.56,
                                76.4294
                            ],
                            [
                                -84.19834,
                                76.45418
                            ],
                            [
                                -84.25267,
                                76.5464
                            ],
                            [
                                -83.92596,
                                76.4937
                            ],
                            [
                                -83.68781,
                                76.42323
                            ],
                            [
                                -83.27511,
                                76.4102
                            ],
                            [
                                -83.17195,
                                76.4931
                            ],
                            [
                                -83.23779,
                                76.57167
                            ],
                            [
                                -83.53457,
                                76.68518
                            ],
                            [
                                -83.42776,
                                76.70167
                            ],
                            [
                                -83.18394,
                                76.61777
                            ],
                            [
                                -83.05022,
                                76.50155
                            ],
                            [
                                -83.13063,
                                76.46675
                            ],
                            [
                                -82.79179,
                                76.38262
                            ],
                            [
                                -82.25685,
                                76.39772
                            ],
                            [
                                -82.13485,
                                76.4463
                            ],
                            [
                                -82.09636,
                                76.52462
                            ],
                            [
                                -81.78914,
                                76.47144
                            ],
                            [
                                -81.45636,
                                76.47151
                            ],
                            [
                                -81.19255,
                                76.50274
                            ],
                            [
                                -80.78639,
                                76.42602
                            ],
                            [
                                -81.09529,
                                76.21259
                            ],
                            [
                                -80.62777,
                                76.17336
                            ],
                            [
                                -80.34067,
                                76.22667
                            ],
                            [
                                -80.08593,
                                76.2268
                            ],
                            [
                                -79.47657,
                                76.30575
                            ],
                            [
                                -79.19602,
                                76.3788
                            ],
                            [
                                -79.14355,
                                76.45983
                            ],
                            [
                                -78.93746,
                                76.46843
                            ],
                            [
                                -78.87422,
                                76.54634
                            ],
                            [
                                -78.62118,
                                76.55132
                            ],
                            [
                                -78.54568,
                                76.46583
                            ],
                            [
                                -78.10783,
                                76.59307
                            ],
                            [
                                -78.07112,
                                76.67672
                            ],
                            [
                                -77.82961,
                                76.70369
                            ],
                            [
                                -77.73043,
                                76.8305
                            ],
                            [
                                -78.07462,
                                77.01972
                            ],
                            [
                                -78.34732,
                                77.00932
                            ],
                            [
                                -78.47491,
                                76.96653
                            ],
                            [
                                -78.84319,
                                76.96199
                            ],
                            [
                                -78.95627,
                                76.84548
                            ],
                            [
                                -79.13876,
                                76.74711
                            ],
                            [
                                -79.58257,
                                76.79851
                            ],
                            [
                                -79.35121,
                                76.84801
                            ],
                            [
                                -79.43463,
                                76.89304
                            ],
                            [
                                -79.82609,
                                76.86854
                            ],
                            [
                                -79.76986,
                                76.93685
                            ],
                            [
                                -79.43311,
                                76.93567
                            ],
                            [
                                -79.09262,
                                77.06039
                            ],
                            [
                                -79.04697,
                                77.1631
                            ],
                            [
                                -79.15271,
                                77.20188
                            ],
                            [
                                -79.63838,
                                77.25034
                            ],
                            [
                                -80.05709,
                                77.19867
                            ],
                            [
                                -81.08965,
                                77.28837
                            ],
                            [
                                -81.78807,
                                77.15733
                            ],
                            [
                                -81.88013,
                                77.24188
                            ],
                            [
                                -81.81383,
                                77.28345
                            ],
                            [
                                -81.1404,
                                77.33008
                            ],
                            [
                                -81.48401,
                                77.37502
                            ],
                            [
                                -81.78795,
                                77.44078
                            ],
                            [
                                -81.64852,
                                77.53785
                            ],
                            [
                                -81.02882,
                                77.40166
                            ],
                            [
                                -80.8611,
                                77.34794
                            ],
                            [
                                -80.3809,
                                77.29404
                            ],
                            [
                                -79.99356,
                                77.27502
                            ],
                            [
                                -79.66963,
                                77.3169
                            ],
                            [
                                -79.16917,
                                77.29014
                            ],
                            [
                                -78.6868,
                                77.31783
                            ],
                            [
                                -78.24516,
                                77.44582
                            ],
                            [
                                -78.02807,
                                77.47036
                            ],
                            [
                                -77.9786,
                                77.53455
                            ],
                            [
                                -77.70291,
                                77.61163
                            ],
                            [
                                -78.09855,
                                77.69418
                            ],
                            [
                                -77.94596,
                                77.75452
                            ],
                            [
                                -77.98427,
                                77.81181
                            ],
                            [
                                -78.33352,
                                77.86734
                            ],
                            [
                                -78.43494,
                                77.91963
                            ],
                            [
                                -78.33478,
                                77.97109
                            ],
                            [
                                -77.92985,
                                77.9517
                            ],
                            [
                                -77.15094,
                                77.94249
                            ],
                            [
                                -76.87926,
                                77.89845
                            ],
                            [
                                -76.56312,
                                77.93402
                            ],
                            [
                                -76.22137,
                                78.01987
                            ],
                            [
                                -75.84443,
                                77.97563
                            ],
                            [
                                -75.64062,
                                78.03719
                            ],
                            [
                                -75.5598,
                                78.12435
                            ],
                            [
                                -76.6059,
                                78.1619
                            ],
                            [
                                -76.91594,
                                78.19741
                            ],
                            [
                                -76.61809,
                                78.25189
                            ],
                            [
                                -75.48078,
                                78.21212
                            ],
                            [
                                -75.34225,
                                78.29993
                            ],
                            [
                                -75.08317,
                                78.3115
                            ],
                            [
                                -75.07191,
                                78.36675
                            ],
                            [
                                -75.48358,
                                78.43287
                            ],
                            [
                                -75.96043,
                                78.45975
                            ],
                            [
                                -75.83775,
                                78.50269
                            ],
                            [
                                -75.0147,
                                78.53093
                            ],
                            [
                                -74.79726,
                                78.58536
                            ],
                            [
                                -74.81841,
                                78.69788
                            ],
                            [
                                -74.68861,
                                78.77006
                            ],
                            [
                                -74.73672,
                                78.82622
                            ],
                            [
                                -75.2656,
                                78.88933
                            ],
                            [
                                -76.05876,
                                78.87662
                            ],
                            [
                                -75.7433,
                                78.93957
                            ],
                            [
                                -75.99803,
                                78.99957
                            ],
                            [
                                -76.68467,
                                79.02839
                            ],
                            [
                                -77.29789,
                                78.98572
                            ],
                            [
                                -77.88955,
                                78.96449
                            ],
                            [
                                -77.20452,
                                79.06235
                            ],
                            [
                                -76.59712,
                                79.09227
                            ],
                            [
                                -76.19721,
                                79.07401
                            ],
                            [
                                -76.05174,
                                79.10191
                            ],
                            [
                                -76.65402,
                                79.1523
                            ],
                            [
                                -76.72289,
                                79.19498
                            ],
                            [
                                -75.96864,
                                79.18506
                            ],
                            [
                                -75.75221,
                                79.07622
                            ],
                            [
                                -75.10476,
                                79.03063
                            ],
                            [
                                -74.55453,
                                79.01505
                            ],
                            [
                                -74.38935,
                                79.05286
                            ],
                            [
                                -74.58163,
                                79.14523
                            ],
                            [
                                -74.56611,
                                79.23506
                            ],
                            [
                                -75.63161,
                                79.2414
                            ],
                            [
                                -75.95372,
                                79.22975
                            ],
                            [
                                -76.10539,
                                79.27066
                            ],
                            [
                                -76.73635,
                                79.28335
                            ],
                            [
                                -77.29827,
                                79.26523
                            ],
                            [
                                -77.38095,
                                79.34345
                            ],
                            [
                                -77.02182,
                                79.3987
                            ],
                            [
                                -76.83644,
                                79.35212
                            ],
                            [
                                -76.02845,
                                79.33918
                            ],
                            [
                                -76.28792,
                                79.46724
                            ],
                            [
                                -75.14582,
                                79.37257
                            ],
                            [
                                -74.6515,
                                79.43954
                            ],
                            [
                                -74.01497,
                                79.43787
                            ],
                            [
                                -73.90008,
                                79.46766
                            ],
                            [
                                -73.37438,
                                79.50073
                            ],
                            [
                                -73.09022,
                                79.55371
                            ],
                            [
                                -73.11652,
                                79.62322
                            ],
                            [
                                -73.37422,
                                79.74621
                            ],
                            [
                                -74.03701,
                                79.79418
                            ],
                            [
                                -74.79374,
                                79.78326
                            ],
                            [
                                -75.18767,
                                79.83162
                            ],
                            [
                                -73.957,
                                79.88492
                            ],
                            [
                                -73.65323,
                                79.83037
                            ],
                            [
                                -73.03536,
                                79.80754
                            ],
                            [
                                -72.90574,
                                79.70692
                            ],
                            [
                                -72.67405,
                                79.6745
                            ],
                            [
                                -71.45206,
                                79.72487
                            ],
                            [
                                -71.0832,
                                79.78734
                            ],
                            [
                                -70.85932,
                                79.87978
                            ],
                            [
                                -71.26856,
                                79.95561
                            ],
                            [
                                -70.6743,
                                79.98912
                            ],
                            [
                                -70.4523,
                                80.08714
                            ],
                            [
                                -70.7752,
                                80.13105
                            ],
                            [
                                -71.41138,
                                80.07002
                            ],
                            [
                                -71.60154,
                                80.10606
                            ],
                            [
                                -70.73192,
                                80.20128
                            ],
                            [
                                -70.11517,
                                80.1894
                            ],
                            [
                                -69.91818,
                                80.26965
                            ],
                            [
                                -70.21903,
                                80.34295
                            ],
                            [
                                -69.75353,
                                80.3485
                            ],
                            [
                                -69.42958,
                                80.38379
                            ],
                            [
                                -69.13875,
                                80.52284
                            ],
                            [
                                -68.66918,
                                80.66641
                            ],
                            [
                                -68.2074,
                                80.77122
                            ],
                            [
                                -67.96304,
                                80.78843
                            ],
                            [
                                -67.50478,
                                80.89342
                            ],
                            [
                                -66.55898,
                                81.0533
                            ],
                            [
                                -66.47372,
                                81.10924
                            ],
                            [
                                -66.04853,
                                81.22097
                            ],
                            [
                                -65.84227,
                                81.21839
                            ],
                            [
                                -65.33569,
                                81.27298
                            ],
                            [
                                -64.66573,
                                81.38654
                            ],
                            [
                                -64.42644,
                                81.47905
                            ],
                            [
                                -64.48363,
                                81.54581
                            ],
                            [
                                -65.00179,
                                81.53228
                            ],
                            [
                                -66.06852,
                                81.45583
                            ],
                            [
                                -66.80063,
                                81.38971
                            ],
                            [
                                -67.31634,
                                81.3614
                            ],
                            [
                                -67.96008,
                                81.29433
                            ],
                            [
                                -68.95828,
                                81.26334
                            ],
                            [
                                -67.12073,
                                81.45131
                            ],
                            [
                                -66.61362,
                                81.51003
                            ],
                            [
                                -67.04682,
                                81.564
                            ],
                            [
                                -67.69655,
                                81.55752
                            ],
                            [
                                -67.7504,
                                81.59438
                            ],
                            [
                                -66.43504,
                                81.62675
                            ],
                            [
                                -65.80659,
                                81.63021
                            ],
                            [
                                -65.65228,
                                81.69865
                            ],
                            [
                                -64.86768,
                                81.75367
                            ],
                            [
                                -64.3506,
                                81.71594
                            ],
                            [
                                -63.98799,
                                81.78317
                            ],
                            [
                                -62.57897,
                                81.9567
                            ],
                            [
                                -61.64242,
                                82.15412
                            ],
                            [
                                -61.19328,
                                82.22051
                            ],
                            [
                                -61.09777,
                                82.35581
                            ],
                            [
                                -61.5289,
                                82.47442
                            ],
                            [
                                -61.99916,
                                82.48791
                            ],
                            [
                                -62.27223,
                                82.52943
                            ],
                            [
                                -63.092,
                                82.52512
                            ],
                            [
                                -62.94302,
                                82.57422
                            ],
                            [
                                -63.23133,
                                82.6412
                            ],
                            [
                                -63.63377,
                                82.67442
                            ],
                            [
                                -63.44301,
                                82.79931
                            ],
                            [
                                -64.01311,
                                82.83523
                            ],
                            [
                                -64.51552,
                                82.78594
                            ],
                            [
                                -64.82291,
                                82.90733
                            ],
                            [
                                -65.66548,
                                82.84931
                            ],
                            [
                                -66.99037,
                                82.71721
                            ],
                            [
                                -67.49053,
                                82.64932
                            ],
                            [
                                -68.23773,
                                82.64286
                            ],
                            [
                                -68.34418,
                                82.68559
                            ],
                            [
                                -66.99638,
                                82.79603
                            ],
                            [
                                -66.32459,
                                82.92626
                            ],
                            [
                                -67.16787,
                                82.93171
                            ],
                            [
                                -68.59056,
                                83.00096
                            ],
                            [
                                -69.00057,
                                83.03143
                            ],
                            [
                                -69.37331,
                                83.00746
                            ],
                            [
                                -69.71381,
                                83.1107
                            ],
                            [
                                -70.63213,
                                83.10613
                            ],
                            [
                                -71.02191,
                                83.08229
                            ],
                            [
                                -71.55675,
                                83.10022
                            ],
                            [
                                -72.89801,
                                83.09456
                            ],
                            [
                                -73.6724,
                                83.04852
                            ],
                            [
                                -73.84986,
                                83.00746
                            ],
                            [
                                -73.10178,
                                82.79569
                            ],
                            [
                                -72.60086,
                                82.75
                            ],
                            [
                                -72.6726,
                                82.7011
                            ],
                            [
                                -73.77252,
                                82.85109
                            ],
                            [
                                -73.97269,
                                82.95868
                            ],
                            [
                                -74.34918,
                                83.04132
                            ],
                            [
                                -73.81445,
                                83.09955
                            ],
                            [
                                -74.48787,
                                83.14282
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -114.72288,
                                73.37063
                            ],
                            [
                                -114.87468,
                                73.31994
                            ],
                            [
                                -115.41084,
                                73.22449
                            ],
                            [
                                -115.73091,
                                73.1852
                            ],
                            [
                                -116.55164,
                                73.05651
                            ],
                            [
                                -116.81852,
                                72.98297
                            ],
                            [
                                -117.31092,
                                72.92622
                            ],
                            [
                                -117.55813,
                                72.80615
                            ],
                            [
                                -117.8098,
                                72.71995
                            ],
                            [
                                -118.162,
                                72.64219
                            ],
                            [
                                -118.46324,
                                72.52437
                            ],
                            [
                                -118.54455,
                                72.39785
                            ],
                            [
                                -118.35552,
                                72.35127
                            ],
                            [
                                -118.0979,
                                72.32654
                            ],
                            [
                                -118.08933,
                                72.23838
                            ],
                            [
                                -118.57937,
                                72.1692
                            ],
                            [
                                -118.70604,
                                72.0635
                            ],
                            [
                                -118.86757,
                                72.01705
                            ],
                            [
                                -119.04986,
                                71.92089
                            ],
                            [
                                -119.11235,
                                71.85103
                            ],
                            [
                                -119.07287,
                                71.66702
                            ],
                            [
                                -118.4834,
                                71.6586
                            ],
                            [
                                -118.33728,
                                71.58474
                            ],
                            [
                                -118.0421,
                                71.67509
                            ],
                            [
                                -117.66891,
                                71.56487
                            ],
                            [
                                -117.74118,
                                71.53625
                            ],
                            [
                                -118.10435,
                                71.54437
                            ],
                            [
                                -118.30461,
                                71.47256
                            ],
                            [
                                -118.23923,
                                71.3963
                            ],
                            [
                                -117.99323,
                                71.37813
                            ],
                            [
                                -117.7529,
                                71.4002
                            ],
                            [
                                -117.51635,
                                71.3835
                            ],
                            [
                                -117.20698,
                                71.40618
                            ],
                            [
                                -117.02238,
                                71.44076
                            ],
                            [
                                -116.81306,
                                71.43832
                            ],
                            [
                                -116.6848,
                                71.47008
                            ],
                            [
                                -116.28982,
                                71.50891
                            ],
                            [
                                -116.1697,
                                71.50091
                            ],
                            [
                                -115.62175,
                                71.56401
                            ],
                            [
                                -115.46974,
                                71.48194
                            ],
                            [
                                -115.78838,
                                71.49238
                            ],
                            [
                                -116.11624,
                                71.43172
                            ],
                            [
                                -116.12491,
                                71.37864
                            ],
                            [
                                -116.74468,
                                71.29979
                            ],
                            [
                                -116.83776,
                                71.25382
                            ],
                            [
                                -117.01902,
                                71.24701
                            ],
                            [
                                -117.51439,
                                71.18767
                            ],
                            [
                                -117.80147,
                                71.16879
                            ],
                            [
                                -118.36501,
                                71.03183
                            ],
                            [
                                -118.41557,
                                70.97924
                            ],
                            [
                                -118.19994,
                                70.85436
                            ],
                            [
                                -118.04613,
                                70.80045
                            ],
                            [
                                -117.66049,
                                70.70961
                            ],
                            [
                                -117.70729,
                                70.65564
                            ],
                            [
                                -117.41764,
                                70.58613
                            ],
                            [
                                -117.17166,
                                70.62035
                            ],
                            [
                                -116.7199,
                                70.60548
                            ],
                            [
                                -116.5208,
                                70.63774
                            ],
                            [
                                -116.22121,
                                70.63409
                            ],
                            [
                                -116.16436,
                                70.59084
                            ],
                            [
                                -115.40908,
                                70.61089
                            ],
                            [
                                -115.02711,
                                70.60347
                            ],
                            [
                                -114.4847,
                                70.64615
                            ],
                            [
                                -114.31587,
                                70.68693
                            ],
                            [
                                -114.13651,
                                70.67702
                            ],
                            [
                                -113.96126,
                                70.71888
                            ],
                            [
                                -113.737,
                                70.70017
                            ],
                            [
                                -113.5644,
                                70.64892
                            ],
                            [
                                -113.43907,
                                70.67831
                            ],
                            [
                                -113.24926,
                                70.65748
                            ],
                            [
                                -112.90218,
                                70.57697
                            ],
                            [
                                -112.65256,
                                70.56543
                            ],
                            [
                                -112.60905,
                                70.52621
                            ],
                            [
                                -112.29994,
                                70.53065
                            ],
                            [
                                -112.08113,
                                70.49435
                            ],
                            [
                                -112.02612,
                                70.40911
                            ],
                            [
                                -111.83059,
                                70.3638
                            ],
                            [
                                -111.48791,
                                70.35512
                            ],
                            [
                                -111.46547,
                                70.28809
                            ],
                            [
                                -111.62098,
                                70.27429
                            ],
                            [
                                -112.0248,
                                70.2732
                            ],
                            [
                                -112.1365,
                                70.29353
                            ],
                            [
                                -112.44988,
                                70.24356
                            ],
                            [
                                -112.52669,
                                70.20044
                            ],
                            [
                                -112.79793,
                                70.23711
                            ],
                            [
                                -112.98951,
                                70.23624
                            ],
                            [
                                -113.28907,
                                70.28406
                            ],
                            [
                                -113.62515,
                                70.26944
                            ],
                            [
                                -113.9507,
                                70.28249
                            ],
                            [
                                -114.12506,
                                70.3161
                            ],
                            [
                                -114.55145,
                                70.31906
                            ],
                            [
                                -114.92373,
                                70.28627
                            ],
                            [
                                -115.94233,
                                70.23431
                            ],
                            [
                                -116.97244,
                                70.12353
                            ],
                            [
                                -117.36023,
                                70.03984
                            ],
                            [
                                -117.39071,
                                69.98179
                            ],
                            [
                                -117.21443,
                                69.75904
                            ],
                            [
                                -116.97027,
                                69.67878
                            ],
                            [
                                -116.82418,
                                69.65229
                            ],
                            [
                                -116.88212,
                                69.60028
                            ],
                            [
                                -116.78205,
                                69.56511
                            ],
                            [
                                -116.56651,
                                69.54886
                            ],
                            [
                                -116.61777,
                                69.46258
                            ],
                            [
                                -116.49711,
                                69.40951
                            ],
                            [
                                -116.34201,
                                69.39694
                            ],
                            [
                                -116.17692,
                                69.34892
                            ],
                            [
                                -116.02774,
                                69.34166
                            ],
                            [
                                -115.93563,
                                69.29831
                            ],
                            [
                                -115.31723,
                                69.27161
                            ],
                            [
                                -115.17693,
                                69.25129
                            ],
                            [
                                -114.66121,
                                69.27017
                            ],
                            [
                                -114.36841,
                                69.29298
                            ],
                            [
                                -114.14771,
                                69.25194
                            ],
                            [
                                -113.94848,
                                69.26257
                            ],
                            [
                                -113.60806,
                                69.1984
                            ],
                            [
                                -113.55464,
                                68.95118
                            ],
                            [
                                -113.61913,
                                68.93107
                            ],
                            [
                                -113.65458,
                                68.81564
                            ],
                            [
                                -113.42053,
                                68.69348
                            ],
                            [
                                -113.3211,
                                68.59232
                            ],
                            [
                                -113.06673,
                                68.54539
                            ],
                            [
                                -113.01708,
                                68.49838
                            ],
                            [
                                -112.75319,
                                68.47119
                            ],
                            [
                                -112.58876,
                                68.5116
                            ],
                            [
                                -112.33319,
                                68.50271
                            ],
                            [
                                -112.25415,
                                68.53166
                            ],
                            [
                                -111.84317,
                                68.53001
                            ],
                            [
                                -111.65898,
                                68.55372
                            ],
                            [
                                -111.31909,
                                68.54185
                            ],
                            [
                                -111.33874,
                                68.5993
                            ],
                            [
                                -111.10602,
                                68.58614
                            ],
                            [
                                -110.96635,
                                68.55349
                            ],
                            [
                                -110.80533,
                                68.56829
                            ],
                            [
                                -110.58242,
                                68.62625
                            ],
                            [
                                -110.39472,
                                68.61052
                            ],
                            [
                                -110.22051,
                                68.63606
                            ],
                            [
                                -110.02339,
                                68.62317
                            ],
                            [
                                -109.63875,
                                68.64504
                            ],
                            [
                                -109.38168,
                                68.69984
                            ],
                            [
                                -108.98628,
                                68.73579
                            ],
                            [
                                -108.67674,
                                68.82693
                            ],
                            [
                                -108.50191,
                                68.90609
                            ],
                            [
                                -108.52689,
                                68.94396
                            ],
                            [
                                -107.99196,
                                68.94531
                            ],
                            [
                                -107.49351,
                                68.98378
                            ],
                            [
                                -107.27746,
                                69.04106
                            ],
                            [
                                -107.08526,
                                69.16762
                            ],
                            [
                                -106.9237,
                                69.22208
                            ],
                            [
                                -106.96052,
                                69.35429
                            ],
                            [
                                -106.74061,
                                69.38558
                            ],
                            [
                                -106.73946,
                                69.42444
                            ],
                            [
                                -106.59409,
                                69.49724
                            ],
                            [
                                -106.45077,
                                69.47364
                            ],
                            [
                                -106.32078,
                                69.41008
                            ],
                            [
                                -106.24247,
                                69.29717
                            ],
                            [
                                -106.39086,
                                69.20248
                            ],
                            [
                                -106.06209,
                                69.15391
                            ],
                            [
                                -105.7179,
                                69.18146
                            ],
                            [
                                -105.35071,
                                69.1046
                            ],
                            [
                                -105.11252,
                                69.07676
                            ],
                            [
                                -104.93593,
                                69.03143
                            ],
                            [
                                -105.14522,
                                68.99515
                            ],
                            [
                                -105.20941,
                                68.93673
                            ],
                            [
                                -105.12094,
                                68.89739
                            ],
                            [
                                -104.71594,
                                68.86301
                            ],
                            [
                                -104.535,
                                68.86378
                            ],
                            [
                                -104.35746,
                                68.94181
                            ],
                            [
                                -104.25731,
                                68.89336
                            ],
                            [
                                -104.0434,
                                68.85698
                            ],
                            [
                                -103.48591,
                                68.8118
                            ],
                            [
                                -103.39585,
                                68.78494
                            ],
                            [
                                -103.13515,
                                68.84775
                            ],
                            [
                                -103.00901,
                                68.80089
                            ],
                            [
                                -102.69632,
                                68.85898
                            ],
                            [
                                -102.45661,
                                68.8755
                            ],
                            [
                                -102.37641,
                                68.93577
                            ],
                            [
                                -102.12374,
                                68.97896
                            ],
                            [
                                -101.97348,
                                68.97862
                            ],
                            [
                                -101.85025,
                                69.04142
                            ],
                            [
                                -101.73599,
                                69.18823
                            ],
                            [
                                -101.98644,
                                69.26066
                            ],
                            [
                                -102.06228,
                                69.18685
                            ],
                            [
                                -102.2147,
                                69.26874
                            ],
                            [
                                -102.029,
                                69.30906
                            ],
                            [
                                -102.09896,
                                69.36715
                            ],
                            [
                                -101.9128,
                                69.4087
                            ],
                            [
                                -101.97555,
                                69.46373
                            ],
                            [
                                -102.28323,
                                69.5086
                            ],
                            [
                                -102.47111,
                                69.47535
                            ],
                            [
                                -102.48059,
                                69.42643
                            ],
                            [
                                -102.82318,
                                69.39871
                            ],
                            [
                                -102.8667,
                                69.31783
                            ],
                            [
                                -102.9962,
                                69.22434
                            ],
                            [
                                -103.1379,
                                69.16858
                            ],
                            [
                                -103.22672,
                                69.19065
                            ],
                            [
                                -103.01266,
                                69.26208
                            ],
                            [
                                -103.03908,
                                69.37134
                            ],
                            [
                                -102.97314,
                                69.40897
                            ],
                            [
                                -103.04745,
                                69.53059
                            ],
                            [
                                -103.34111,
                                69.58531
                            ],
                            [
                                -103.48843,
                                69.6387
                            ],
                            [
                                -103.39016,
                                69.71272
                            ],
                            [
                                -103.12922,
                                69.61917
                            ],
                            [
                                -102.89404,
                                69.55427
                            ],
                            [
                                -102.52396,
                                69.55428
                            ],
                            [
                                -102.47652,
                                69.69836
                            ],
                            [
                                -102.60346,
                                69.70672
                            ],
                            [
                                -102.38924,
                                69.82787
                            ],
                            [
                                -102.27951,
                                69.81316
                            ],
                            [
                                -101.98498,
                                69.84398
                            ],
                            [
                                -101.85605,
                                69.75569
                            ],
                            [
                                -101.66589,
                                69.70303
                            ],
                            [
                                -101.43115,
                                69.79544
                            ],
                            [
                                -101.30051,
                                69.6751
                            ],
                            [
                                -100.92084,
                                69.68219
                            ],
                            [
                                -100.84936,
                                69.88441
                            ],
                            [
                                -100.91894,
                                69.96043
                            ],
                            [
                                -100.89278,
                                70.01969
                            ],
                            [
                                -100.98826,
                                70.09647
                            ],
                            [
                                -100.97885,
                                70.18553
                            ],
                            [
                                -101.49226,
                                70.13832
                            ],
                            [
                                -101.62362,
                                70.17973
                            ],
                            [
                                -101.5742,
                                70.261
                            ],
                            [
                                -101.65863,
                                70.31302
                            ],
                            [
                                -101.87974,
                                70.26239
                            ],
                            [
                                -102.20534,
                                70.38534
                            ],
                            [
                                -102.41059,
                                70.4264
                            ],
                            [
                                -102.61407,
                                70.49585
                            ],
                            [
                                -102.85098,
                                70.51843
                            ],
                            [
                                -102.80208,
                                70.59224
                            ],
                            [
                                -103.00669,
                                70.68529
                            ],
                            [
                                -103.12074,
                                70.66723
                            ],
                            [
                                -103.14553,
                                70.55248
                            ],
                            [
                                -103.47138,
                                70.58828
                            ],
                            [
                                -103.60342,
                                70.67596
                            ],
                            [
                                -103.81989,
                                70.75182
                            ],
                            [
                                -103.98013,
                                70.76311
                            ],
                            [
                                -104.07022,
                                70.91576
                            ],
                            [
                                -104.16941,
                                70.97181
                            ],
                            [
                                -104.37434,
                                70.99571
                            ],
                            [
                                -104.59777,
                                71.11058
                            ],
                            [
                                -104.45005,
                                71.19992
                            ],
                            [
                                -104.41188,
                                71.27267
                            ],
                            [
                                -104.47934,
                                71.34737
                            ],
                            [
                                -104.28825,
                                71.45449
                            ],
                            [
                                -104.36163,
                                71.51029
                            ],
                            [
                                -104.30246,
                                71.59805
                            ],
                            [
                                -104.40966,
                                71.64824
                            ],
                            [
                                -104.51941,
                                71.76278
                            ],
                            [
                                -104.82129,
                                71.89663
                            ],
                            [
                                -104.79206,
                                71.97219
                            ],
                            [
                                -104.98948,
                                72.13887
                            ],
                            [
                                -104.94579,
                                72.17968
                            ],
                            [
                                -105.21831,
                                72.41315
                            ],
                            [
                                -105.19417,
                                72.49105
                            ],
                            [
                                -105.29736,
                                72.56079
                            ],
                            [
                                -105.28341,
                                72.66082
                            ],
                            [
                                -105.43254,
                                72.70909
                            ],
                            [
                                -105.32566,
                                72.78603
                            ],
                            [
                                -105.77589,
                                72.97919
                            ],
                            [
                                -105.8316,
                                73.04768
                            ],
                            [
                                -105.99068,
                                73.04149
                            ],
                            [
                                -106.19624,
                                73.08268
                            ],
                            [
                                -106.44138,
                                73.19824
                            ],
                            [
                                -106.67569,
                                73.23504
                            ],
                            [
                                -106.83262,
                                73.31041
                            ],
                            [
                                -107.05971,
                                73.27907
                            ],
                            [
                                -107.17671,
                                73.19834
                            ],
                            [
                                -107.40706,
                                73.28384
                            ],
                            [
                                -107.60995,
                                73.32396
                            ],
                            [
                                -107.99132,
                                73.35205
                            ],
                            [
                                -108.11105,
                                73.31024
                            ],
                            [
                                -108.12363,
                                73.20831
                            ],
                            [
                                -108.25974,
                                73.12384
                            ],
                            [
                                -108.14941,
                                73.0676
                            ],
                            [
                                -108.09611,
                                72.84865
                            ],
                            [
                                -107.92324,
                                72.61745
                            ],
                            [
                                -107.82948,
                                72.57801
                            ],
                            [
                                -107.94307,
                                72.52274
                            ],
                            [
                                -107.82745,
                                72.36849
                            ],
                            [
                                -107.70532,
                                72.31379
                            ],
                            [
                                -107.78051,
                                72.27934
                            ],
                            [
                                -107.72407,
                                72.15236
                            ],
                            [
                                -107.59217,
                                72.08622
                            ],
                            [
                                -107.594,
                                72.01927
                            ],
                            [
                                -107.40671,
                                71.98048
                            ],
                            [
                                -107.25691,
                                71.895
                            ],
                            [
                                -107.34817,
                                71.8363
                            ],
                            [
                                -107.6956,
                                71.70802
                            ],
                            [
                                -107.96911,
                                71.65201
                            ],
                            [
                                -107.99205,
                                71.71396
                            ],
                            [
                                -108.26644,
                                71.79283
                            ],
                            [
                                -108.27772,
                                71.87162
                            ],
                            [
                                -108.18579,
                                71.97163
                            ],
                            [
                                -108.39418,
                                72.01085
                            ],
                            [
                                -108.37893,
                                72.12008
                            ],
                            [
                                -108.48392,
                                72.18197
                            ],
                            [
                                -108.64568,
                                72.34846
                            ],
                            [
                                -108.58542,
                                72.55065
                            ],
                            [
                                -108.77736,
                                72.60264
                            ],
                            [
                                -109.00416,
                                72.57113
                            ],
                            [
                                -109.01748,
                                72.68371
                            ],
                            [
                                -109.12606,
                                72.76304
                            ],
                            [
                                -109.34576,
                                72.78115
                            ],
                            [
                                -109.63232,
                                72.85192
                            ],
                            [
                                -109.60162,
                                72.90414
                            ],
                            [
                                -109.79495,
                                72.9173
                            ],
                            [
                                -109.8954,
                                72.97402
                            ],
                            [
                                -110.39177,
                                73.0106
                            ],
                            [
                                -110.6907,
                                72.99007
                            ],
                            [
                                -110.67855,
                                72.92477
                            ],
                            [
                                -110.45671,
                                72.83733
                            ],
                            [
                                -110.22453,
                                72.82879
                            ],
                            [
                                -110.13532,
                                72.77027
                            ],
                            [
                                -110.19836,
                                72.71455
                            ],
                            [
                                -109.92916,
                                72.60956
                            ],
                            [
                                -109.86724,
                                72.54548
                            ],
                            [
                                -110.22137,
                                72.55259
                            ],
                            [
                                -109.9232,
                                72.47761
                            ],
                            [
                                -110.02034,
                                72.43844
                            ],
                            [
                                -110.32406,
                                72.55961
                            ],
                            [
                                -110.49748,
                                72.54314
                            ],
                            [
                                -110.73047,
                                72.56381
                            ],
                            [
                                -110.93777,
                                72.48692
                            ],
                            [
                                -110.94671,
                                72.43964
                            ],
                            [
                                -111.17623,
                                72.34548
                            ],
                            [
                                -111.30434,
                                72.45758
                            ],
                            [
                                -111.58573,
                                72.36642
                            ],
                            [
                                -111.66149,
                                72.31361
                            ],
                            [
                                -111.8747,
                                72.33688
                            ],
                            [
                                -111.78661,
                                72.39193
                            ],
                            [
                                -111.55996,
                                72.42452
                            ],
                            [
                                -111.264,
                                72.56052
                            ],
                            [
                                -111.17635,
                                72.65728
                            ],
                            [
                                -111.1977,
                                72.7196
                            ],
                            [
                                -111.54713,
                                72.80502
                            ],
                            [
                                -111.81467,
                                72.8385
                            ],
                            [
                                -112.02516,
                                72.89293
                            ],
                            [
                                -112.3352,
                                72.91104
                            ],
                            [
                                -112.49295,
                                72.95669
                            ],
                            [
                                -112.79526,
                                72.99565
                            ],
                            [
                                -113.10556,
                                73.00951
                            ],
                            [
                                -113.23372,
                                72.98734
                            ],
                            [
                                -113.60137,
                                72.77565
                            ],
                            [
                                -113.40421,
                                72.74419
                            ],
                            [
                                -113.50663,
                                72.70124
                            ],
                            [
                                -113.83588,
                                72.64415
                            ],
                            [
                                -114.04519,
                                72.65558
                            ],
                            [
                                -114.34441,
                                72.56336
                            ],
                            [
                                -114.51062,
                                72.57539
                            ],
                            [
                                -114.4474,
                                72.63358
                            ],
                            [
                                -114.27502,
                                72.68041
                            ],
                            [
                                -114.34667,
                                72.74096
                            ],
                            [
                                -114.20223,
                                72.80351
                            ],
                            [
                                -113.93777,
                                72.82476
                            ],
                            [
                                -114.01357,
                                72.87624
                            ],
                            [
                                -114.02557,
                                72.97303
                            ],
                            [
                                -113.94632,
                                73.03063
                            ],
                            [
                                -113.9421,
                                73.16211
                            ],
                            [
                                -114.19744,
                                73.32414
                            ],
                            [
                                -114.48924,
                                73.3764
                            ],
                            [
                                -114.72288,
                                73.37063
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -121.719,
                                74.55193
                            ],
                            [
                                -122.29518,
                                74.47791
                            ],
                            [
                                -122.55026,
                                74.46365
                            ],
                            [
                                -123.23898,
                                74.4494
                            ],
                            [
                                -123.47718,
                                74.42719
                            ],
                            [
                                -124.07768,
                                74.40391
                            ],
                            [
                                -124.62153,
                                74.36417
                            ],
                            [
                                -124.52317,
                                74.22223
                            ],
                            [
                                -124.39837,
                                74.14924
                            ],
                            [
                                -124.45103,
                                74.11238
                            ],
                            [
                                -124.23396,
                                73.95286
                            ],
                            [
                                -124.18513,
                                73.87908
                            ],
                            [
                                -123.81996,
                                73.82614
                            ],
                            [
                                -123.75927,
                                73.77215
                            ],
                            [
                                -123.83512,
                                73.70813
                            ],
                            [
                                -124.05324,
                                73.65818
                            ],
                            [
                                -124.04415,
                                73.53765
                            ],
                            [
                                -124.3051,
                                73.48535
                            ],
                            [
                                -124.54546,
                                73.2952
                            ],
                            [
                                -124.50989,
                                73.25752
                            ],
                            [
                                -124.77472,
                                73.15481
                            ],
                            [
                                -124.86214,
                                73.08452
                            ],
                            [
                                -124.76043,
                                73.02703
                            ],
                            [
                                -124.5429,
                                72.99915
                            ],
                            [
                                -124.42309,
                                72.93815
                            ],
                            [
                                -124.53659,
                                72.9116
                            ],
                            [
                                -124.94108,
                                72.8715
                            ],
                            [
                                -124.9577,
                                72.68796
                            ],
                            [
                                -125.08135,
                                72.62656
                            ],
                            [
                                -125.02151,
                                72.56748
                            ],
                            [
                                -125.25131,
                                72.48854
                            ],
                            [
                                -125.49937,
                                72.33752
                            ],
                            [
                                -125.4904,
                                72.27839
                            ],
                            [
                                -125.67725,
                                72.23886
                            ],
                            [
                                -125.76049,
                                72.14003
                            ],
                            [
                                -125.67936,
                                72.08499
                            ],
                            [
                                -125.70682,
                                71.96036
                            ],
                            [
                                -125.35102,
                                71.98486
                            ],
                            [
                                -124.62098,
                                71.79657
                            ],
                            [
                                -124.18278,
                                71.73546
                            ],
                            [
                                -123.97744,
                                71.6723
                            ],
                            [
                                -123.80608,
                                71.53368
                            ],
                            [
                                -123.62425,
                                71.49582
                            ],
                            [
                                -123.42539,
                                71.21814
                            ],
                            [
                                -123.10048,
                                71.0791
                            ],
                            [
                                -122.76085,
                                71.09541
                            ],
                            [
                                -122.65091,
                                71.16288
                            ],
                            [
                                -122.45717,
                                71.21953
                            ],
                            [
                                -122.05981,
                                71.29233
                            ],
                            [
                                -121.89319,
                                71.40213
                            ],
                            [
                                -121.77127,
                                71.44482
                            ],
                            [
                                -121.571,
                                71.4667
                            ],
                            [
                                -121.38476,
                                71.38093
                            ],
                            [
                                -121.23977,
                                71.39344
                            ],
                            [
                                -120.69717,
                                71.4783
                            ],
                            [
                                -120.4664,
                                71.56799
                            ],
                            [
                                -120.37351,
                                71.70727
                            ],
                            [
                                -120.44463,
                                71.74156
                            ],
                            [
                                -120.38839,
                                71.89484
                            ],
                            [
                                -120.44078,
                                71.94812
                            ],
                            [
                                -120.17356,
                                72.08819
                            ],
                            [
                                -120.13262,
                                72.147
                            ],
                            [
                                -120.19114,
                                72.22798
                            ],
                            [
                                -119.79644,
                                72.22566
                            ],
                            [
                                -119.64509,
                                72.28418
                            ],
                            [
                                -119.28928,
                                72.36644
                            ],
                            [
                                -119.1595,
                                72.61966
                            ],
                            [
                                -118.72302,
                                72.74571
                            ],
                            [
                                -118.52246,
                                72.75906
                            ],
                            [
                                -118.45112,
                                72.80267
                            ],
                            [
                                -117.88058,
                                72.922
                            ],
                            [
                                -117.4543,
                                73.05152
                            ],
                            [
                                -117.22783,
                                73.06255
                            ],
                            [
                                -116.65002,
                                73.22236
                            ],
                            [
                                -116.46232,
                                73.25792
                            ],
                            [
                                -115.79889,
                                73.34212
                            ],
                            [
                                -115.40919,
                                73.46033
                            ],
                            [
                                -115.31273,
                                73.53347
                            ],
                            [
                                -115.76449,
                                73.68803
                            ],
                            [
                                -116.65261,
                                74.01322
                            ],
                            [
                                -117.0487,
                                74.13774
                            ],
                            [
                                -117.37925,
                                74.21896
                            ],
                            [
                                -117.61651,
                                74.25
                            ],
                            [
                                -118.13109,
                                74.28104
                            ],
                            [
                                -118.77708,
                                74.20886
                            ],
                            [
                                -118.77828,
                                74.13144
                            ],
                            [
                                -118.95737,
                                74.00889
                            ],
                            [
                                -119.16398,
                                74.01547
                            ],
                            [
                                -119.04052,
                                74.11945
                            ],
                            [
                                -119.14321,
                                74.22024
                            ],
                            [
                                -119.49614,
                                74.21791
                            ],
                            [
                                -119.90749,
                                74.27129
                            ],
                            [
                                -120.10861,
                                74.27803
                            ],
                            [
                                -120.64516,
                                74.36957
                            ],
                            [
                                -120.96363,
                                74.45018
                            ],
                            [
                                -121.11294,
                                74.52434
                            ],
                            [
                                -121.55926,
                                74.55947
                            ],
                            [
                                -121.719,
                                74.55193
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -93.53984,
                                81.37911
                            ],
                            [
                                -93.42522,
                                81.32214
                            ],
                            [
                                -94.12507,
                                81.36254
                            ],
                            [
                                -94.35245,
                                81.24657
                            ],
                            [
                                -93.89404,
                                81.20031
                            ],
                            [
                                -93.19133,
                                81.21318
                            ],
                            [
                                -92.99389,
                                81.1084
                            ],
                            [
                                -93.42437,
                                81.06068
                            ],
                            [
                                -93.85682,
                                81.03856
                            ],
                            [
                                -94.35219,
                                80.96372
                            ],
                            [
                                -94.49899,
                                81.03585
                            ],
                            [
                                -94.89151,
                                81.03974
                            ],
                            [
                                -95.23286,
                                81.00594
                            ],
                            [
                                -95.24822,
                                80.88521
                            ],
                            [
                                -95.48569,
                                80.81001
                            ],
                            [
                                -95.12244,
                                80.79765
                            ],
                            [
                                -94.70965,
                                80.72945
                            ],
                            [
                                -94.59309,
                                80.63913
                            ],
                            [
                                -94.00141,
                                80.59051
                            ],
                            [
                                -94.02135,
                                80.55261
                            ],
                            [
                                -94.73881,
                                80.56075
                            ],
                            [
                                -94.95637,
                                80.60244
                            ],
                            [
                                -95.88088,
                                80.58331
                            ],
                            [
                                -96.04262,
                                80.49019
                            ],
                            [
                                -95.49812,
                                80.38491
                            ],
                            [
                                -95.57541,
                                80.35901
                            ],
                            [
                                -96.15849,
                                80.37994
                            ],
                            [
                                -96.50738,
                                80.29271
                            ],
                            [
                                -95.91838,
                                80.19431
                            ],
                            [
                                -95.33019,
                                80.11904
                            ],
                            [
                                -94.68271,
                                80.16976
                            ],
                            [
                                -94.83327,
                                80.05109
                            ],
                            [
                                -95.40443,
                                80.03611
                            ],
                            [
                                -96.00709,
                                80.07545
                            ],
                            [
                                -96.22084,
                                80.12837
                            ],
                            [
                                -96.68359,
                                80.14626
                            ],
                            [
                                -96.74116,
                                80.08598
                            ],
                            [
                                -96.59159,
                                79.96351
                            ],
                            [
                                -96.63044,
                                79.90106
                            ],
                            [
                                -96.34257,
                                79.83152
                            ],
                            [
                                -96.22161,
                                79.75078
                            ],
                            [
                                -95.90903,
                                79.65455
                            ],
                            [
                                -95.53548,
                                79.63339
                            ],
                            [
                                -94.75918,
                                79.66521
                            ],
                            [
                                -94.45282,
                                79.74782
                            ],
                            [
                                -94.33033,
                                79.67123
                            ],
                            [
                                -94.92848,
                                79.58878
                            ],
                            [
                                -95.6942,
                                79.54002
                            ],
                            [
                                -95.7513,
                                79.43003
                            ],
                            [
                                -95.55712,
                                79.38739
                            ],
                            [
                                -95.25039,
                                79.38784
                            ],
                            [
                                -95.19236,
                                79.28657
                            ],
                            [
                                -95.04587,
                                79.26961
                            ],
                            [
                                -94.38134,
                                79.36826
                            ],
                            [
                                -94.14819,
                                79.33922
                            ],
                            [
                                -94.10839,
                                79.2681
                            ],
                            [
                                -93.85799,
                                79.26636
                            ],
                            [
                                -93.66797,
                                79.33909
                            ],
                            [
                                -93.07829,
                                79.36028
                            ],
                            [
                                -92.56529,
                                79.45444
                            ],
                            [
                                -92.10662,
                                79.34254
                            ],
                            [
                                -91.22013,
                                79.3835
                            ],
                            [
                                -91.19925,
                                79.34541
                            ],
                            [
                                -91.94387,
                                79.29656
                            ],
                            [
                                -92.5102,
                                79.30756
                            ],
                            [
                                -92.66092,
                                79.26354
                            ],
                            [
                                -92.2719,
                                79.20869
                            ],
                            [
                                -91.64558,
                                79.21445
                            ],
                            [
                                -91.14063,
                                79.24748
                            ],
                            [
                                -90.50948,
                                79.25002
                            ],
                            [
                                -90.48029,
                                79.22096
                            ],
                            [
                                -91.14508,
                                79.20623
                            ],
                            [
                                -92.10487,
                                79.15083
                            ],
                            [
                                -93.1898,
                                79.17027
                            ],
                            [
                                -93.84325,
                                79.03625
                            ],
                            [
                                -94.29531,
                                78.98725
                            ],
                            [
                                -93.85276,
                                78.82749
                            ],
                            [
                                -93.81515,
                                78.76609
                            ],
                            [
                                -93.29197,
                                78.58384
                            ],
                            [
                                -92.94155,
                                78.60311
                            ],
                            [
                                -92.20403,
                                78.57316
                            ],
                            [
                                -92.09246,
                                78.52008
                            ],
                            [
                                -92.8468,
                                78.50032
                            ],
                            [
                                -92.92335,
                                78.42149
                            ],
                            [
                                -91.99916,
                                78.20537
                            ],
                            [
                                -91.00981,
                                78.14411
                            ],
                            [
                                -90.33219,
                                78.1422
                            ],
                            [
                                -90.26236,
                                78.18666
                            ],
                            [
                                -90.52154,
                                78.31669
                            ],
                            [
                                -90.23447,
                                78.33523
                            ],
                            [
                                -90.01533,
                                78.30106
                            ],
                            [
                                -89.88473,
                                78.2141
                            ],
                            [
                                -89.44901,
                                78.17158
                            ],
                            [
                                -89.7536,
                                78.3697
                            ],
                            [
                                -90.0523,
                                78.48902
                            ],
                            [
                                -90.10579,
                                78.55241
                            ],
                            [
                                -89.90664,
                                78.57769
                            ],
                            [
                                -89.67041,
                                78.44246
                            ],
                            [
                                -89.34664,
                                78.32466
                            ],
                            [
                                -89.05171,
                                78.17909
                            ],
                            [
                                -88.73996,
                                78.19277
                            ],
                            [
                                -88.665,
                                78.32599
                            ],
                            [
                                -88.53048,
                                78.42243
                            ],
                            [
                                -88.71129,
                                78.50689
                            ],
                            [
                                -88.54723,
                                78.58247
                            ],
                            [
                                -88.31723,
                                78.4822
                            ],
                            [
                                -88.00838,
                                78.47774
                            ],
                            [
                                -87.85271,
                                78.58465
                            ],
                            [
                                -88.09033,
                                78.68307
                            ],
                            [
                                -88.22216,
                                78.85693
                            ],
                            [
                                -88.19398,
                                78.95612
                            ],
                            [
                                -87.9414,
                                78.91689
                            ],
                            [
                                -87.99367,
                                78.78609
                            ],
                            [
                                -87.89253,
                                78.7033
                            ],
                            [
                                -87.52683,
                                78.66294
                            ],
                            [
                                -87.31203,
                                78.80412
                            ],
                            [
                                -86.97681,
                                78.88605
                            ],
                            [
                                -86.78318,
                                78.96061
                            ],
                            [
                                -86.57878,
                                78.98291
                            ],
                            [
                                -86.49845,
                                79.05903
                            ],
                            [
                                -85.52611,
                                79.15894
                            ],
                            [
                                -84.88118,
                                79.27256
                            ],
                            [
                                -85.11865,
                                79.38942
                            ],
                            [
                                -85.26507,
                                79.40237
                            ],
                            [
                                -85.63921,
                                79.61206
                            ],
                            [
                                -86.13361,
                                79.60911
                            ],
                            [
                                -86.62448,
                                79.66351
                            ],
                            [
                                -87.17199,
                                79.57933
                            ],
                            [
                                -86.94138,
                                79.89068
                            ],
                            [
                                -87.28256,
                                80.08139
                            ],
                            [
                                -87.95318,
                                80.06918
                            ],
                            [
                                -87.96992,
                                80.14256
                            ],
                            [
                                -87.55302,
                                80.17639
                            ],
                            [
                                -87.52177,
                                80.24227
                            ],
                            [
                                -87.60809,
                                80.40666
                            ],
                            [
                                -88.36716,
                                80.43914
                            ],
                            [
                                -88.61056,
                                80.38285
                            ],
                            [
                                -88.66452,
                                80.28157
                            ],
                            [
                                -88.29664,
                                80.13997
                            ],
                            [
                                -88.74562,
                                80.12488
                            ],
                            [
                                -89.11317,
                                80.22424
                            ],
                            [
                                -89.2004,
                                80.29351
                            ],
                            [
                                -88.99204,
                                80.45114
                            ],
                            [
                                -89.22524,
                                80.52506
                            ],
                            [
                                -89.82184,
                                80.52747
                            ],
                            [
                                -90.74418,
                                80.56309
                            ],
                            [
                                -90.54918,
                                80.63764
                            ],
                            [
                                -90.66687,
                                80.70396
                            ],
                            [
                                -91.12861,
                                80.77436
                            ],
                            [
                                -91.10509,
                                80.81821
                            ],
                            [
                                -91.41875,
                                80.90788
                            ],
                            [
                                -91.69931,
                                81.04793
                            ],
                            [
                                -91.77506,
                                81.14593
                            ],
                            [
                                -92.05742,
                                81.22627
                            ],
                            [
                                -92.7672,
                                81.30126
                            ],
                            [
                                -93.23546,
                                81.36619
                            ],
                            [
                                -93.53984,
                                81.37911
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -95.74244,
                                77.06698
                            ],
                            [
                                -96.29273,
                                77.04391
                            ],
                            [
                                -96.37415,
                                76.98132
                            ],
                            [
                                -96.7857,
                                76.98436
                            ],
                            [
                                -96.69091,
                                76.86995
                            ],
                            [
                                -96.50326,
                                76.79075
                            ],
                            [
                                -96.8247,
                                76.76277
                            ],
                            [
                                -96.8003,
                                76.69622
                            ],
                            [
                                -96.47873,
                                76.65987
                            ],
                            [
                                -96.04759,
                                76.55834
                            ],
                            [
                                -96.12447,
                                76.50553
                            ],
                            [
                                -95.97548,
                                76.42767
                            ],
                            [
                                -95.78021,
                                76.39704
                            ],
                            [
                                -95.03135,
                                76.35403
                            ],
                            [
                                -95.10577,
                                76.30461
                            ],
                            [
                                -95.40229,
                                76.29102
                            ],
                            [
                                -95.39747,
                                76.23224
                            ],
                            [
                                -95.06461,
                                76.22
                            ],
                            [
                                -94.76521,
                                76.28751
                            ],
                            [
                                -93.93453,
                                76.26439
                            ],
                            [
                                -93.6541,
                                76.32825
                            ],
                            [
                                -93.33703,
                                76.36585
                            ],
                            [
                                -93.08466,
                                76.36336
                            ],
                            [
                                -92.96163,
                                76.24047
                            ],
                            [
                                -92.79306,
                                76.21212
                            ],
                            [
                                -92.65134,
                                76.12654
                            ],
                            [
                                -92.53361,
                                75.96307
                            ],
                            [
                                -92.14373,
                                75.88088
                            ],
                            [
                                -92.09342,
                                75.81313
                            ],
                            [
                                -92.1648,
                                75.74809
                            ],
                            [
                                -92.00337,
                                75.66344
                            ],
                            [
                                -92.42241,
                                75.43593
                            ],
                            [
                                -92.41048,
                                75.35536
                            ],
                            [
                                -92.50157,
                                75.21796
                            ],
                            [
                                -92.25572,
                                75.13228
                            ],
                            [
                                -92.23718,
                                75.03168
                            ],
                            [
                                -92.04002,
                                74.96015
                            ],
                            [
                                -92.03484,
                                74.77496
                            ],
                            [
                                -91.66538,
                                74.72496
                            ],
                            [
                                -91.69648,
                                74.67259
                            ],
                            [
                                -91.29657,
                                74.6292
                            ],
                            [
                                -91.10753,
                                74.63717
                            ],
                            [
                                -91.23223,
                                74.72737
                            ],
                            [
                                -91.1075,
                                74.74489
                            ],
                            [
                                -90.87908,
                                74.84456
                            ],
                            [
                                -90.7652,
                                74.83223
                            ],
                            [
                                -91.01923,
                                74.70726
                            ],
                            [
                                -90.6336,
                                74.62369
                            ],
                            [
                                -90.39174,
                                74.60621
                            ],
                            [
                                -89.98074,
                                74.5317
                            ],
                            [
                                -89.58226,
                                74.54003
                            ],
                            [
                                -89.28573,
                                74.57477
                            ],
                            [
                                -89.12456,
                                74.6266
                            ],
                            [
                                -89.10024,
                                74.69102
                            ],
                            [
                                -88.93784,
                                74.71933
                            ],
                            [
                                -88.66162,
                                74.82378
                            ],
                            [
                                -88.41771,
                                74.74165
                            ],
                            [
                                -88.58829,
                                74.57009
                            ],
                            [
                                -88.52886,
                                74.49706
                            ],
                            [
                                -87.73504,
                                74.45786
                            ],
                            [
                                -87.32,
                                74.47019
                            ],
                            [
                                -86.62475,
                                74.46657
                            ],
                            [
                                -86.29493,
                                74.49589
                            ],
                            [
                                -86.12765,
                                74.4803
                            ],
                            [
                                -85.36339,
                                74.49997
                            ],
                            [
                                -84.26093,
                                74.50503
                            ],
                            [
                                -83.8624,
                                74.55234
                            ],
                            [
                                -83.60468,
                                74.54302
                            ],
                            [
                                -83.44067,
                                74.5968
                            ],
                            [
                                -83.30357,
                                74.83016
                            ],
                            [
                                -83.09817,
                                74.81681
                            ],
                            [
                                -83.13004,
                                74.68678
                            ],
                            [
                                -82.94893,
                                74.56479
                            ],
                            [
                                -82.7901,
                                74.52821
                            ],
                            [
                                -82.5468,
                                74.52072
                            ],
                            [
                                -82.45267,
                                74.5534
                            ],
                            [
                                -82.03744,
                                74.4878
                            ],
                            [
                                -81.75741,
                                74.47108
                            ],
                            [
                                -81.23233,
                                74.58655
                            ],
                            [
                                -80.57506,
                                74.5649
                            ],
                            [
                                -80.2723,
                                74.58403
                            ],
                            [
                                -80.01595,
                                74.6905
                            ],
                            [
                                -79.32716,
                                74.88981
                            ],
                            [
                                -79.49675,
                                75.0366
                            ],
                            [
                                -79.52486,
                                75.30861
                            ],
                            [
                                -79.47047,
                                75.38441
                            ],
                            [
                                -79.61003,
                                75.46641
                            ],
                            [
                                -79.81564,
                                75.47337
                            ],
                            [
                                -79.84828,
                                75.53138
                            ],
                            [
                                -80.21193,
                                75.63433
                            ],
                            [
                                -80.71211,
                                75.66597
                            ],
                            [
                                -81.13113,
                                75.73334
                            ],
                            [
                                -81.11116,
                                75.76936
                            ],
                            [
                                -81.64281,
                                75.8165
                            ],
                            [
                                -82.34354,
                                75.83645
                            ],
                            [
                                -82.65842,
                                75.81017
                            ],
                            [
                                -82.9483,
                                75.75325
                            ],
                            [
                                -83.35924,
                                75.73909
                            ],
                            [
                                -83.49664,
                                75.77884
                            ],
                            [
                                -83.96622,
                                75.82277
                            ],
                            [
                                -84.34012,
                                75.70477
                            ],
                            [
                                -84.65838,
                                75.69091
                            ],
                            [
                                -84.66062,
                                75.64405
                            ],
                            [
                                -85.04922,
                                75.6657
                            ],
                            [
                                -85.09541,
                                75.6347
                            ],
                            [
                                -85.48362,
                                75.56156
                            ],
                            [
                                -85.66127,
                                75.58633
                            ],
                            [
                                -85.82326,
                                75.54269
                            ],
                            [
                                -86.11292,
                                75.52239
                            ],
                            [
                                -85.86528,
                                75.41692
                            ],
                            [
                                -86.39444,
                                75.42854
                            ],
                            [
                                -86.61544,
                                75.47865
                            ],
                            [
                                -86.83885,
                                75.48325
                            ],
                            [
                                -87.04964,
                                75.53081
                            ],
                            [
                                -87.11607,
                                75.5865
                            ],
                            [
                                -87.30717,
                                75.62199
                            ],
                            [
                                -87.54438,
                                75.56227
                            ],
                            [
                                -87.73559,
                                75.57582
                            ],
                            [
                                -88.18639,
                                75.52774
                            ],
                            [
                                -88.61293,
                                75.66534
                            ],
                            [
                                -88.92135,
                                75.60866
                            ],
                            [
                                -88.74433,
                                75.47643
                            ],
                            [
                                -89.11172,
                                75.48569
                            ],
                            [
                                -89.24757,
                                75.62964
                            ],
                            [
                                -89.16424,
                                75.76956
                            ],
                            [
                                -89.42753,
                                75.83956
                            ],
                            [
                                -89.80266,
                                75.83276
                            ],
                            [
                                -89.67076,
                                75.89262
                            ],
                            [
                                -89.84518,
                                75.96316
                            ],
                            [
                                -90.20335,
                                75.96465
                            ],
                            [
                                -90.45092,
                                75.98611
                            ],
                            [
                                -90.8199,
                                75.98288
                            ],
                            [
                                -91.00862,
                                76.01286
                            ],
                            [
                                -90.18814,
                                76.06089
                            ],
                            [
                                -90.57424,
                                76.09385
                            ],
                            [
                                -90.9466,
                                76.14778
                            ],
                            [
                                -90.885,
                                76.17359
                            ],
                            [
                                -89.63704,
                                76.16785
                            ],
                            [
                                -89.30743,
                                76.19445
                            ],
                            [
                                -89.19229,
                                76.24452
                            ],
                            [
                                -89.29375,
                                76.301
                            ],
                            [
                                -89.7983,
                                76.32937
                            ],
                            [
                                -90.3522,
                                76.39739
                            ],
                            [
                                -90.86034,
                                76.42424
                            ],
                            [
                                -90.84355,
                                76.45977
                            ],
                            [
                                -90.49737,
                                76.46278
                            ],
                            [
                                -90.60171,
                                76.56768
                            ],
                            [
                                -90.77467,
                                76.58179
                            ],
                            [
                                -90.99325,
                                76.65375
                            ],
                            [
                                -91.43519,
                                76.6919
                            ],
                            [
                                -91.9194,
                                76.67088
                            ],
                            [
                                -92.11899,
                                76.62444
                            ],
                            [
                                -92.67439,
                                76.59363
                            ],
                            [
                                -92.88347,
                                76.62212
                            ],
                            [
                                -93.10795,
                                76.59769
                            ],
                            [
                                -93.4743,
                                76.50472
                            ],
                            [
                                -93.18614,
                                76.67822
                            ],
                            [
                                -93.17795,
                                76.74279
                            ],
                            [
                                -93.601,
                                76.86089
                            ],
                            [
                                -93.71832,
                                76.92438
                            ],
                            [
                                -94.28784,
                                76.89275
                            ],
                            [
                                -94.62791,
                                76.98604
                            ],
                            [
                                -94.91421,
                                76.97723
                            ],
                            [
                                -95.28901,
                                77.01735
                            ],
                            [
                                -95.4112,
                                77.05811
                            ],
                            [
                                -95.74244,
                                77.06698
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -108.79079,
                                76.83393
                            ],
                            [
                                -109.30928,
                                76.79821
                            ],
                            [
                                -109.45202,
                                76.73074
                            ],
                            [
                                -109.5412,
                                76.62561
                            ],
                            [
                                -109.68306,
                                76.59781
                            ],
                            [
                                -109.67878,
                                76.52616
                            ],
                            [
                                -110.1079,
                                76.45167
                            ],
                            [
                                -110.38107,
                                76.43114
                            ],
                            [
                                -110.32939,
                                76.35278
                            ],
                            [
                                -110.05291,
                                76.24502
                            ],
                            [
                                -109.71583,
                                76.22448
                            ],
                            [
                                -109.27412,
                                76.10678
                            ],
                            [
                                -109.36534,
                                76.02295
                            ],
                            [
                                -109.58905,
                                75.96451
                            ],
                            [
                                -110.04737,
                                75.90405
                            ],
                            [
                                -109.93383,
                                75.85923
                            ],
                            [
                                -109.62392,
                                75.87293
                            ],
                            [
                                -109.65832,
                                75.80845
                            ],
                            [
                                -109.09277,
                                75.75232
                            ],
                            [
                                -108.79349,
                                75.61564
                            ],
                            [
                                -108.88309,
                                75.59492
                            ],
                            [
                                -108.93597,
                                75.48259
                            ],
                            [
                                -109.24305,
                                75.52119
                            ],
                            [
                                -110.38167,
                                75.54988
                            ],
                            [
                                -110.74839,
                                75.57242
                            ],
                            [
                                -110.98062,
                                75.52948
                            ],
                            [
                                -111.19131,
                                75.52607
                            ],
                            [
                                -111.3978,
                                75.6167
                            ],
                            [
                                -111.31606,
                                75.71598
                            ],
                            [
                                -111.39381,
                                75.76985
                            ],
                            [
                                -111.77429,
                                75.83794
                            ],
                            [
                                -111.91797,
                                75.80727
                            ],
                            [
                                -112.18084,
                                75.84852
                            ],
                            [
                                -111.68807,
                                75.92035
                            ],
                            [
                                -112.00301,
                                76.00635
                            ],
                            [
                                -112.34207,
                                76.03752
                            ],
                            [
                                -112.50629,
                                76.1079
                            ],
                            [
                                -112.44609,
                                76.18969
                            ],
                            [
                                -112.81636,
                                76.21748
                            ],
                            [
                                -112.85481,
                                76.2581
                            ],
                            [
                                -113.32133,
                                76.26713
                            ],
                            [
                                -113.69285,
                                76.20471
                            ],
                            [
                                -114.03691,
                                76.22496
                            ],
                            [
                                -114.17721,
                                76.3441
                            ],
                            [
                                -114.05715,
                                76.41817
                            ],
                            [
                                -114.17101,
                                76.47719
                            ],
                            [
                                -114.41643,
                                76.51055
                            ],
                            [
                                -114.93152,
                                76.48746
                            ],
                            [
                                -115.57722,
                                76.43464
                            ],
                            [
                                -115.87331,
                                76.3611
                            ],
                            [
                                -115.8714,
                                76.26196
                            ],
                            [
                                -115.78559,
                                76.19142
                            ],
                            [
                                -116.21047,
                                76.19825
                            ],
                            [
                                -116.6089,
                                76.12103
                            ],
                            [
                                -116.67419,
                                76.05092
                            ],
                            [
                                -116.496,
                                76.02461
                            ],
                            [
                                -116.69905,
                                75.96574
                            ],
                            [
                                -116.69634,
                                75.89745
                            ],
                            [
                                -116.4181,
                                75.8768
                            ],
                            [
                                -115.93325,
                                75.8775
                            ],
                            [
                                -115.76068,
                                75.89503
                            ],
                            [
                                -115.23052,
                                75.88641
                            ],
                            [
                                -115.4038,
                                75.84496
                            ],
                            [
                                -115.99341,
                                75.81682
                            ],
                            [
                                -116.80398,
                                75.80487
                            ],
                            [
                                -116.9538,
                                75.77496
                            ],
                            [
                                -117.15336,
                                75.67151
                            ],
                            [
                                -117.14602,
                                75.58169
                            ],
                            [
                                -116.40223,
                                75.56531
                            ],
                            [
                                -115.39931,
                                75.65963
                            ],
                            [
                                -115.29538,
                                75.62894
                            ],
                            [
                                -115.61919,
                                75.58386
                            ],
                            [
                                -116.11056,
                                75.48574
                            ],
                            [
                                -117.15149,
                                75.48643
                            ],
                            [
                                -117.31563,
                                75.45836
                            ],
                            [
                                -117.52995,
                                75.36942
                            ],
                            [
                                -117.6656,
                                75.25483
                            ],
                            [
                                -117.30785,
                                75.17566
                            ],
                            [
                                -116.73329,
                                75.12328
                            ],
                            [
                                -116.53669,
                                75.19166
                            ],
                            [
                                -116.21333,
                                75.21504
                            ],
                            [
                                -116.24568,
                                75.06385
                            ],
                            [
                                -115.96731,
                                75.01199
                            ],
                            [
                                -115.63315,
                                74.97649
                            ],
                            [
                                -115.51235,
                                75.03172
                            ],
                            [
                                -115.59884,
                                75.08227
                            ],
                            [
                                -115.16694,
                                75.12475
                            ],
                            [
                                -115.17213,
                                74.9953
                            ],
                            [
                                -115.03243,
                                74.96474
                            ],
                            [
                                -114.4516,
                                75.06283
                            ],
                            [
                                -114.16396,
                                75.22386
                            ],
                            [
                                -114.03512,
                                75.3468
                            ],
                            [
                                -113.62527,
                                75.40051
                            ],
                            [
                                -113.59549,
                                75.35557
                            ],
                            [
                                -113.82403,
                                75.30746
                            ],
                            [
                                -113.94901,
                                75.07599
                            ],
                            [
                                -113.89248,
                                75.05354
                            ],
                            [
                                -113.34327,
                                75.07542
                            ],
                            [
                                -112.8721,
                                75.10776
                            ],
                            [
                                -112.71746,
                                75.14025
                            ],
                            [
                                -112.72684,
                                75.21019
                            ],
                            [
                                -112.42285,
                                75.18571
                            ],
                            [
                                -112.40278,
                                75.12918
                            ],
                            [
                                -111.91146,
                                75.13953
                            ],
                            [
                                -111.69267,
                                75.16964
                            ],
                            [
                                -111.46703,
                                75.16094
                            ],
                            [
                                -111.0616,
                                75.27886
                            ],
                            [
                                -111.01073,
                                75.17816
                            ],
                            [
                                -111.25826,
                                75.12605
                            ],
                            [
                                -111.29099,
                                75.08308
                            ],
                            [
                                -111.69606,
                                74.99144
                            ],
                            [
                                -112.12056,
                                75.00875
                            ],
                            [
                                -112.84788,
                                74.98254
                            ],
                            [
                                -113.44064,
                                74.84211
                            ],
                            [
                                -113.55204,
                                74.84474
                            ],
                            [
                                -114.08512,
                                74.78669
                            ],
                            [
                                -114.43613,
                                74.69667
                            ],
                            [
                                -114.42,
                                74.659
                            ],
                            [
                                -114.08732,
                                74.54435
                            ],
                            [
                                -113.69077,
                                74.45252
                            ],
                            [
                                -113.19574,
                                74.40734
                            ],
                            [
                                -112.47779,
                                74.41718
                            ],
                            [
                                -111.67918,
                                74.50012
                            ],
                            [
                                -111.40613,
                                74.56989
                            ],
                            [
                                -111.2639,
                                74.56973
                            ],
                            [
                                -110.75732,
                                74.68302
                            ],
                            [
                                -110.56317,
                                74.71271
                            ],
                            [
                                -110.62837,
                                74.79801
                            ],
                            [
                                -110.37991,
                                74.80479
                            ],
                            [
                                -110.28229,
                                74.85135
                            ],
                            [
                                -110.03398,
                                74.82788
                            ],
                            [
                                -109.81151,
                                74.87565
                            ],
                            [
                                -109.52697,
                                74.86301
                            ],
                            [
                                -109.34256,
                                74.94819
                            ],
                            [
                                -108.93296,
                                75.00951
                            ],
                            [
                                -108.78561,
                                75.0732
                            ],
                            [
                                -108.4994,
                                75.01036
                            ],
                            [
                                -108.39867,
                                74.92197
                            ],
                            [
                                -107.93419,
                                74.95691
                            ],
                            [
                                -107.98318,
                                75.00098
                            ],
                            [
                                -107.71911,
                                75.02314
                            ],
                            [
                                -107.65459,
                                74.97649
                            ],
                            [
                                -107.18633,
                                74.91377
                            ],
                            [
                                -106.51058,
                                75.00127
                            ],
                            [
                                -106.00799,
                                75.05191
                            ],
                            [
                                -106.06898,
                                75.11146
                            ],
                            [
                                -105.86737,
                                75.14726
                            ],
                            [
                                -105.84597,
                                75.28165
                            ],
                            [
                                -105.62504,
                                75.36123
                            ],
                            [
                                -105.70724,
                                75.49427
                            ],
                            [
                                -105.45836,
                                75.55961
                            ],
                            [
                                -105.35177,
                                75.67935
                            ],
                            [
                                -105.42459,
                                75.85277
                            ],
                            [
                                -105.6448,
                                75.9601
                            ],
                            [
                                -105.94285,
                                76.01982
                            ],
                            [
                                -106.54287,
                                76.07017
                            ],
                            [
                                -106.89675,
                                75.93632
                            ],
                            [
                                -106.87787,
                                75.83889
                            ],
                            [
                                -106.74883,
                                75.81393
                            ],
                            [
                                -106.92412,
                                75.75343
                            ],
                            [
                                -107.10339,
                                75.84692
                            ],
                            [
                                -107.02962,
                                75.89589
                            ],
                            [
                                -107.4519,
                                75.91569
                            ],
                            [
                                -107.72982,
                                75.88885
                            ],
                            [
                                -107.62733,
                                76.00657
                            ],
                            [
                                -107.86312,
                                76.06897
                            ],
                            [
                                -108.36592,
                                76.05437
                            ],
                            [
                                -108.43273,
                                76.1003
                            ],
                            [
                                -108.3485,
                                76.17798
                            ],
                            [
                                -108.066,
                                76.22754
                            ],
                            [
                                -108.26782,
                                76.412
                            ],
                            [
                                -108.57453,
                                76.48773
                            ],
                            [
                                -108.49018,
                                76.56369
                            ],
                            [
                                -108.69398,
                                76.60594
                            ],
                            [
                                -108.40019,
                                76.71194
                            ],
                            [
                                -108.61769,
                                76.81323
                            ],
                            [
                                -108.79079,
                                76.83393
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -55.89462,
                                51.61977
                            ],
                            [
                                -55.99396,
                                51.59583
                            ],
                            [
                                -56.07478,
                                51.54552
                            ],
                            [
                                -56.19195,
                                51.51645
                            ],
                            [
                                -56.43537,
                                51.41501
                            ],
                            [
                                -56.489,
                                51.41515
                            ],
                            [
                                -56.69826,
                                51.33859
                            ],
                            [
                                -56.79948,
                                51.24217
                            ],
                            [
                                -56.79285,
                                51.15342
                            ],
                            [
                                -56.86062,
                                51.12001
                            ],
                            [
                                -56.94043,
                                50.99505
                            ],
                            [
                                -57.00632,
                                51.00448
                            ],
                            [
                                -56.97094,
                                50.89129
                            ],
                            [
                                -57.07848,
                                50.79569
                            ],
                            [
                                -57.17539,
                                50.75204
                            ],
                            [
                                -57.35817,
                                50.69918
                            ],
                            [
                                -57.31235,
                                50.64604
                            ],
                            [
                                -57.37162,
                                50.60039
                            ],
                            [
                                -57.38977,
                                50.53422
                            ],
                            [
                                -57.47132,
                                50.47838
                            ],
                            [
                                -57.52583,
                                50.38473
                            ],
                            [
                                -57.6086,
                                50.17273
                            ],
                            [
                                -57.64849,
                                50.14386
                            ],
                            [
                                -57.82358,
                                49.89712
                            ],
                            [
                                -57.87533,
                                49.79143
                            ],
                            [
                                -57.94323,
                                49.72491
                            ],
                            [
                                -57.95376,
                                49.60652
                            ],
                            [
                                -58.21467,
                                49.42176
                            ],
                            [
                                -58.25103,
                                49.28271
                            ],
                            [
                                -58.11173,
                                49.18135
                            ],
                            [
                                -58.16537,
                                49.05839
                            ],
                            [
                                -58.37329,
                                49.06964
                            ],
                            [
                                -58.50027,
                                49.00296
                            ],
                            [
                                -58.54116,
                                48.87534
                            ],
                            [
                                -58.60986,
                                48.80514
                            ],
                            [
                                -58.68223,
                                48.691
                            ],
                            [
                                -58.65807,
                                48.64765
                            ],
                            [
                                -58.71435,
                                48.56538
                            ],
                            [
                                -58.78786,
                                48.5645
                            ],
                            [
                                -58.94463,
                                48.60301
                            ],
                            [
                                -58.99481,
                                48.65721
                            ],
                            [
                                -59.0939,
                                48.62547
                            ],
                            [
                                -59.22175,
                                48.53783
                            ],
                            [
                                -59.2339,
                                48.46816
                            ],
                            [
                                -59.03751,
                                48.52147
                            ],
                            [
                                -58.93642,
                                48.51039
                            ],
                            [
                                -58.71969,
                                48.55371
                            ],
                            [
                                -58.52997,
                                48.53412
                            ],
                            [
                                -58.40716,
                                48.50401
                            ],
                            [
                                -58.48188,
                                48.43115
                            ],
                            [
                                -58.62065,
                                48.39747
                            ],
                            [
                                -58.6943,
                                48.32849
                            ],
                            [
                                -58.92836,
                                48.17824
                            ],
                            [
                                -58.97808,
                                48.13204
                            ],
                            [
                                -59.08075,
                                48.09945
                            ],
                            [
                                -59.26364,
                                48.00299
                            ],
                            [
                                -59.31711,
                                47.94678
                            ],
                            [
                                -59.4091,
                                47.90113
                            ],
                            [
                                -59.33348,
                                47.82653
                            ],
                            [
                                -59.30144,
                                47.72995
                            ],
                            [
                                -59.30769,
                                47.62598
                            ],
                            [
                                -59.03809,
                                47.57086
                            ],
                            [
                                -58.88422,
                                47.6034
                            ],
                            [
                                -58.63417,
                                47.61782
                            ],
                            [
                                -58.58124,
                                47.65055
                            ],
                            [
                                -58.43678,
                                47.64208
                            ],
                            [
                                -58.37696,
                                47.69142
                            ],
                            [
                                -58.23433,
                                47.66696
                            ],
                            [
                                -58.04954,
                                47.70683
                            ],
                            [
                                -57.95932,
                                47.66485
                            ],
                            [
                                -57.76596,
                                47.63448
                            ],
                            [
                                -57.65078,
                                47.60278
                            ],
                            [
                                -57.57538,
                                47.64015
                            ],
                            [
                                -57.39678,
                                47.62828
                            ],
                            [
                                -57.33547,
                                47.59052
                            ],
                            [
                                -57.18635,
                                47.6131
                            ],
                            [
                                -57.14422,
                                47.58026
                            ],
                            [
                                -57.00948,
                                47.59353
                            ],
                            [
                                -56.85318,
                                47.54369
                            ],
                            [
                                -56.6638,
                                47.58247
                            ],
                            [
                                -56.64422,
                                47.61613
                            ],
                            [
                                -56.4309,
                                47.60318
                            ],
                            [
                                -56.17115,
                                47.63945
                            ],
                            [
                                -56.17302,
                                47.72594
                            ],
                            [
                                -56.05065,
                                47.70386
                            ],
                            [
                                -56.00016,
                                47.75651
                            ],
                            [
                                -55.87362,
                                47.78191
                            ],
                            [
                                -55.83805,
                                47.73174
                            ],
                            [
                                -55.92482,
                                47.67866
                            ],
                            [
                                -55.85113,
                                47.60173
                            ],
                            [
                                -55.96933,
                                47.55294
                            ],
                            [
                                -56.14648,
                                47.51987
                            ],
                            [
                                -56.11723,
                                47.4672
                            ],
                            [
                                -55.97699,
                                47.50195
                            ],
                            [
                                -55.77026,
                                47.45618
                            ],
                            [
                                -55.65928,
                                47.49754
                            ],
                            [
                                -55.59525,
                                47.43098
                            ],
                            [
                                -55.43293,
                                47.47419
                            ],
                            [
                                -55.40515,
                                47.5183
                            ],
                            [
                                -55.40731,
                                47.61951
                            ],
                            [
                                -55.34759,
                                47.65504
                            ],
                            [
                                -55.23575,
                                47.62682
                            ],
                            [
                                -55.14524,
                                47.64186
                            ],
                            [
                                -55.1416,
                                47.58509
                            ],
                            [
                                -54.86872,
                                47.60263
                            ],
                            [
                                -54.85281,
                                47.55708
                            ],
                            [
                                -54.96332,
                                47.50677
                            ],
                            [
                                -55.17239,
                                47.4693
                            ],
                            [
                                -55.28955,
                                47.38838
                            ],
                            [
                                -55.3123,
                                47.27516
                            ],
                            [
                                -55.52544,
                                47.13995
                            ],
                            [
                                -55.682,
                                47.09086
                            ],
                            [
                                -55.77317,
                                47.10674
                            ],
                            [
                                -55.8741,
                                47.06555
                            ],
                            [
                                -55.97182,
                                46.99493
                            ],
                            [
                                -55.97075,
                                46.91549
                            ],
                            [
                                -55.82055,
                                46.86229
                            ],
                            [
                                -55.6333,
                                46.87913
                            ],
                            [
                                -55.55143,
                                46.92597
                            ],
                            [
                                -55.47313,
                                46.87997
                            ],
                            [
                                -55.38204,
                                46.87669
                            ],
                            [
                                -55.23996,
                                46.93896
                            ],
                            [
                                -55.19243,
                                47.01723
                            ],
                            [
                                -55.08247,
                                47.08387
                            ],
                            [
                                -55.09433,
                                47.16373
                            ],
                            [
                                -55.05546,
                                47.22343
                            ],
                            [
                                -54.92493,
                                47.30817
                            ],
                            [
                                -54.85873,
                                47.38464
                            ],
                            [
                                -54.77381,
                                47.36539
                            ],
                            [
                                -54.62576,
                                47.3955
                            ],
                            [
                                -54.58645,
                                47.35265
                            ],
                            [
                                -54.47782,
                                47.43698
                            ],
                            [
                                -54.31884,
                                47.65879
                            ],
                            [
                                -54.15656,
                                47.85062
                            ],
                            [
                                -53.97401,
                                47.76701
                            ],
                            [
                                -53.93297,
                                47.61093
                            ],
                            [
                                -53.89884,
                                47.5821
                            ],
                            [
                                -53.93008,
                                47.45557
                            ],
                            [
                                -53.901,
                                47.39603
                            ],
                            [
                                -53.9212,
                                47.31542
                            ],
                            [
                                -53.98174,
                                47.29288
                            ],
                            [
                                -54.07893,
                                47.09667
                            ],
                            [
                                -54.16428,
                                46.98875
                            ],
                            [
                                -54.19419,
                                46.82409
                            ],
                            [
                                -54.05297,
                                46.80545
                            ],
                            [
                                -53.95875,
                                46.85464
                            ],
                            [
                                -53.81645,
                                46.98055
                            ],
                            [
                                -53.7789,
                                47.03708
                            ],
                            [
                                -53.56639,
                                47.15689
                            ],
                            [
                                -53.5499,
                                47.11002
                            ],
                            [
                                -53.64215,
                                47.00677
                            ],
                            [
                                -53.62636,
                                46.94558
                            ],
                            [
                                -53.56708,
                                46.91832
                            ],
                            [
                                -53.65966,
                                46.8216
                            ],
                            [
                                -53.61514,
                                46.76063
                            ],
                            [
                                -53.64842,
                                46.70494
                            ],
                            [
                                -53.62055,
                                46.64342
                            ],
                            [
                                -53.52523,
                                46.61967
                            ],
                            [
                                -53.39434,
                                46.72326
                            ],
                            [
                                -53.26315,
                                46.70628
                            ],
                            [
                                -53.21592,
                                46.639
                            ],
                            [
                                -53.07987,
                                46.6567
                            ],
                            [
                                -53.03509,
                                46.74286
                            ],
                            [
                                -52.95205,
                                46.79196
                            ],
                            [
                                -52.90311,
                                46.99739
                            ],
                            [
                                -52.85443,
                                47.06621
                            ],
                            [
                                -52.87744,
                                47.11408
                            ],
                            [
                                -52.84551,
                                47.20572
                            ],
                            [
                                -52.73964,
                                47.32745
                            ],
                            [
                                -52.63747,
                                47.48876
                            ],
                            [
                                -52.68323,
                                47.53947
                            ],
                            [
                                -52.66335,
                                47.64871
                            ],
                            [
                                -52.71291,
                                47.75227
                            ],
                            [
                                -52.80934,
                                47.79461
                            ],
                            [
                                -52.85898,
                                47.62872
                            ],
                            [
                                -52.91757,
                                47.54958
                            ],
                            [
                                -53.08051,
                                47.47097
                            ],
                            [
                                -53.13091,
                                47.42725
                            ],
                            [
                                -53.19868,
                                47.56864
                            ],
                            [
                                -53.27131,
                                47.62064
                            ],
                            [
                                -53.18047,
                                47.67118
                            ],
                            [
                                -53.2167,
                                47.72908
                            ],
                            [
                                -53.0938,
                                47.83348
                            ],
                            [
                                -53.0736,
                                47.93791
                            ],
                            [
                                -52.98627,
                                47.98925
                            ],
                            [
                                -52.92349,
                                48.09013
                            ],
                            [
                                -53.01205,
                                48.08223
                            ],
                            [
                                -53.11509,
                                48.03691
                            ],
                            [
                                -53.30505,
                                48.00347
                            ],
                            [
                                -53.38356,
                                47.88819
                            ],
                            [
                                -53.42543,
                                47.86237
                            ],
                            [
                                -53.50272,
                                47.74653
                            ],
                            [
                                -53.48278,
                                47.69195
                            ],
                            [
                                -53.56614,
                                47.61322
                            ],
                            [
                                -53.54904,
                                47.5539
                            ],
                            [
                                -53.6589,
                                47.56853
                            ],
                            [
                                -53.77025,
                                47.61377
                            ],
                            [
                                -53.86337,
                                47.71421
                            ],
                            [
                                -53.77342,
                                47.79368
                            ],
                            [
                                -53.63907,
                                47.9909
                            ],
                            [
                                -53.71658,
                                48.04155
                            ],
                            [
                                -53.7061,
                                48.08202
                            ],
                            [
                                -53.932,
                                48.07947
                            ],
                            [
                                -53.97746,
                                48.18352
                            ],
                            [
                                -53.93902,
                                48.23211
                            ],
                            [
                                -53.84822,
                                48.18857
                            ],
                            [
                                -53.64183,
                                48.17617
                            ],
                            [
                                -53.44608,
                                48.28275
                            ],
                            [
                                -53.29513,
                                48.38902
                            ],
                            [
                                -53.22098,
                                48.35268
                            ],
                            [
                                -53.10909,
                                48.40777
                            ],
                            [
                                -53.05772,
                                48.4593
                            ],
                            [
                                -53.04325,
                                48.54243
                            ],
                            [
                                -52.99857,
                                48.59814
                            ],
                            [
                                -53.0342,
                                48.65529
                            ],
                            [
                                -53.11624,
                                48.66952
                            ],
                            [
                                -53.25974,
                                48.52675
                            ],
                            [
                                -53.37042,
                                48.61511
                            ],
                            [
                                -53.45723,
                                48.61389
                            ],
                            [
                                -53.53871,
                                48.45934
                            ],
                            [
                                -53.64455,
                                48.49333
                            ],
                            [
                                -53.66512,
                                48.53828
                            ],
                            [
                                -53.85404,
                                48.42673
                            ],
                            [
                                -53.90273,
                                48.48455
                            ],
                            [
                                -53.78014,
                                48.50909
                            ],
                            [
                                -53.72764,
                                48.6845
                            ],
                            [
                                -53.79036,
                                48.72265
                            ],
                            [
                                -53.89735,
                                48.71209
                            ],
                            [
                                -53.88405,
                                48.79105
                            ],
                            [
                                -53.94495,
                                48.83831
                            ],
                            [
                                -54.1459,
                                48.78432
                            ],
                            [
                                -54.14819,
                                48.82337
                            ],
                            [
                                -53.98804,
                                48.84195
                            ],
                            [
                                -53.84522,
                                48.97699
                            ],
                            [
                                -53.72594,
                                49.02676
                            ],
                            [
                                -53.6064,
                                49.03904
                            ],
                            [
                                -53.61121,
                                49.11128
                            ],
                            [
                                -53.55044,
                                49.15063
                            ],
                            [
                                -53.51002,
                                49.27825
                            ],
                            [
                                -53.70339,
                                49.33662
                            ],
                            [
                                -53.68615,
                                49.36125
                            ],
                            [
                                -53.8651,
                                49.41165
                            ],
                            [
                                -54.0125,
                                49.47076
                            ],
                            [
                                -54.16043,
                                49.45444
                            ],
                            [
                                -54.18028,
                                49.38962
                            ],
                            [
                                -54.252,
                                49.39183
                            ],
                            [
                                -54.32789,
                                49.43809
                            ],
                            [
                                -54.46704,
                                49.42726
                            ],
                            [
                                -54.55164,
                                49.54161
                            ],
                            [
                                -54.70046,
                                49.37284
                            ],
                            [
                                -54.79405,
                                49.3564
                            ],
                            [
                                -54.83783,
                                49.27203
                            ],
                            [
                                -54.9659,
                                49.30601
                            ],
                            [
                                -55.01551,
                                49.28072
                            ],
                            [
                                -55.24538,
                                49.25838
                            ],
                            [
                                -55.24686,
                                49.34248
                            ],
                            [
                                -55.13909,
                                49.46542
                            ],
                            [
                                -55.16806,
                                49.5422
                            ],
                            [
                                -55.332,
                                49.53121
                            ],
                            [
                                -55.28135,
                                49.47138
                            ],
                            [
                                -55.2621,
                                49.37963
                            ],
                            [
                                -55.36045,
                                49.40014
                            ],
                            [
                                -55.341,
                                49.44772
                            ],
                            [
                                -55.44945,
                                49.50963
                            ],
                            [
                                -55.47772,
                                49.45969
                            ],
                            [
                                -55.57411,
                                49.48639
                            ],
                            [
                                -55.65655,
                                49.4121
                            ],
                            [
                                -55.78626,
                                49.50939
                            ],
                            [
                                -55.88405,
                                49.50762
                            ],
                            [
                                -55.8444,
                                49.57535
                            ],
                            [
                                -55.94028,
                                49.60656
                            ],
                            [
                                -55.91557,
                                49.69074
                            ],
                            [
                                -56.04246,
                                49.70999
                            ],
                            [
                                -55.85228,
                                49.79306
                            ],
                            [
                                -55.50835,
                                49.92185
                            ],
                            [
                                -55.52872,
                                50.00236
                            ],
                            [
                                -55.69556,
                                49.96882
                            ],
                            [
                                -55.73193,
                                49.92533
                            ],
                            [
                                -55.81849,
                                49.95128
                            ],
                            [
                                -55.88563,
                                50.01699
                            ],
                            [
                                -56.02373,
                                50.0326
                            ],
                            [
                                -56.11014,
                                50.12788
                            ],
                            [
                                -56.22719,
                                50.11921
                            ],
                            [
                                -56.44858,
                                49.8961
                            ],
                            [
                                -56.61518,
                                49.81532
                            ],
                            [
                                -56.74367,
                                49.67762
                            ],
                            [
                                -56.80114,
                                49.73097
                            ],
                            [
                                -56.89952,
                                49.76586
                            ],
                            [
                                -56.77923,
                                49.82737
                            ],
                            [
                                -56.73302,
                                49.94803
                            ],
                            [
                                -56.75957,
                                50.01966
                            ],
                            [
                                -56.55246,
                                50.18473
                            ],
                            [
                                -56.4728,
                                50.28083
                            ],
                            [
                                -56.39889,
                                50.40812
                            ],
                            [
                                -56.24402,
                                50.53884
                            ],
                            [
                                -56.2471,
                                50.57387
                            ],
                            [
                                -56.13381,
                                50.63817
                            ],
                            [
                                -56.09548,
                                50.72315
                            ],
                            [
                                -56.03291,
                                50.76555
                            ],
                            [
                                -55.96466,
                                50.86017
                            ],
                            [
                                -55.89541,
                                50.86879
                            ],
                            [
                                -55.87288,
                                50.94303
                            ],
                            [
                                -55.73288,
                                51.09096
                            ],
                            [
                                -55.74202,
                                51.19859
                            ],
                            [
                                -55.86497,
                                51.22767
                            ],
                            [
                                -55.94035,
                                51.19566
                            ],
                            [
                                -56.02888,
                                51.21652
                            ],
                            [
                                -56.03054,
                                51.29667
                            ],
                            [
                                -55.9753,
                                51.33668
                            ],
                            [
                                -55.80728,
                                51.34758
                            ],
                            [
                                -55.63384,
                                51.30222
                            ],
                            [
                                -55.49649,
                                51.37482
                            ],
                            [
                                -55.44881,
                                51.51811
                            ],
                            [
                                -55.47133,
                                51.59547
                            ],
                            [
                                -55.65886,
                                51.59023
                            ],
                            [
                                -55.80838,
                                51.49348
                            ],
                            [
                                -55.87633,
                                51.52107
                            ],
                            [
                                -55.89462,
                                51.61977
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -100.07635,
                                73.94612
                            ],
                            [
                                -100.26331,
                                73.91668
                            ],
                            [
                                -100.30269,
                                73.86737
                            ],
                            [
                                -100.5601,
                                73.86381
                            ],
                            [
                                -100.69266,
                                73.83225
                            ],
                            [
                                -100.97259,
                                73.81495
                            ],
                            [
                                -101.07054,
                                73.70141
                            ],
                            [
                                -100.86526,
                                73.66796
                            ],
                            [
                                -100.9052,
                                73.62763
                            ],
                            [
                                -100.52903,
                                73.57431
                            ],
                            [
                                -100.6869,
                                73.47958
                            ],
                            [
                                -100.87186,
                                73.59998
                            ],
                            [
                                -101.1882,
                                73.60998
                            ],
                            [
                                -101.40682,
                                73.55643
                            ],
                            [
                                -101.57127,
                                73.48335
                            ],
                            [
                                -101.283,
                                73.36307
                            ],
                            [
                                -101.00795,
                                73.32868
                            ],
                            [
                                -100.90218,
                                73.2718
                            ],
                            [
                                -100.57322,
                                73.2858
                            ],
                            [
                                -100.43755,
                                73.26345
                            ],
                            [
                                -100.46053,
                                73.20351
                            ],
                            [
                                -100.58727,
                                73.14499
                            ],
                            [
                                -100.16828,
                                73.09929
                            ],
                            [
                                -100.23281,
                                72.92705
                            ],
                            [
                                -100.44089,
                                72.92793
                            ],
                            [
                                -100.29895,
                                72.80855
                            ],
                            [
                                -100.50942,
                                72.75971
                            ],
                            [
                                -100.76318,
                                72.74779
                            ],
                            [
                                -100.84052,
                                72.69641
                            ],
                            [
                                -101.29038,
                                72.71929
                            ],
                            [
                                -101.29111,
                                72.77495
                            ],
                            [
                                -101.48809,
                                72.87795
                            ],
                            [
                                -101.72415,
                                72.9291
                            ],
                            [
                                -101.76802,
                                73.00838
                            ],
                            [
                                -102.11864,
                                73.08875
                            ],
                            [
                                -102.36588,
                                73.07229
                            ],
                            [
                                -102.51662,
                                73.02445
                            ],
                            [
                                -102.61233,
                                72.87977
                            ],
                            [
                                -102.73814,
                                72.76567
                            ],
                            [
                                -102.59163,
                                72.65911
                            ],
                            [
                                -102.21349,
                                72.542
                            ],
                            [
                                -101.94521,
                                72.49715
                            ],
                            [
                                -101.80128,
                                72.31715
                            ],
                            [
                                -101.3835,
                                72.26606
                            ],
                            [
                                -101.18005,
                                72.33463
                            ],
                            [
                                -100.95672,
                                72.18416
                            ],
                            [
                                -100.76434,
                                72.20658
                            ],
                            [
                                -100.60083,
                                72.18001
                            ],
                            [
                                -100.32826,
                                71.9983
                            ],
                            [
                                -100.07088,
                                71.87889
                            ],
                            [
                                -99.8333,
                                71.84843
                            ],
                            [
                                -99.66887,
                                71.76732
                            ],
                            [
                                -99.5389,
                                71.61657
                            ],
                            [
                                -99.3516,
                                71.57816
                            ],
                            [
                                -99.34401,
                                71.49633
                            ],
                            [
                                -99.21679,
                                71.35478
                            ],
                            [
                                -98.95115,
                                71.39019
                            ],
                            [
                                -98.81427,
                                71.30301
                            ],
                            [
                                -98.53426,
                                71.29736
                            ],
                            [
                                -98.31282,
                                71.39849
                            ],
                            [
                                -98.1923,
                                71.42437
                            ],
                            [
                                -98.04454,
                                71.54281
                            ],
                            [
                                -98.3632,
                                71.6505
                            ],
                            [
                                -97.77755,
                                71.65733
                            ],
                            [
                                -97.48898,
                                71.61657
                            ],
                            [
                                -97.07268,
                                71.70495
                            ],
                            [
                                -96.92137,
                                71.80782
                            ],
                            [
                                -96.69806,
                                71.80181
                            ],
                            [
                                -96.52736,
                                71.83785
                            ],
                            [
                                -96.46381,
                                71.93605
                            ],
                            [
                                -96.46059,
                                72.11142
                            ],
                            [
                                -96.53815,
                                72.2784
                            ],
                            [
                                -96.65712,
                                72.30948
                            ],
                            [
                                -96.2847,
                                72.41261
                            ],
                            [
                                -96.32442,
                                72.51357
                            ],
                            [
                                -96.43776,
                                72.64265
                            ],
                            [
                                -96.68178,
                                72.71525
                            ],
                            [
                                -96.9188,
                                72.67669
                            ],
                            [
                                -97.00905,
                                72.74211
                            ],
                            [
                                -97.25707,
                                72.85217
                            ],
                            [
                                -97.22801,
                                72.93528
                            ],
                            [
                                -97.46072,
                                73.00612
                            ],
                            [
                                -97.83663,
                                73.04999
                            ],
                            [
                                -98.09632,
                                73.02338
                            ],
                            [
                                -98.38924,
                                72.9421
                            ],
                            [
                                -98.46421,
                                73.02461
                            ],
                            [
                                -98.23159,
                                73.07292
                            ],
                            [
                                -97.95029,
                                73.18603
                            ],
                            [
                                -97.83797,
                                73.27828
                            ],
                            [
                                -97.67547,
                                73.32092
                            ],
                            [
                                -97.13387,
                                73.38724
                            ],
                            [
                                -97.40447,
                                73.47923
                            ],
                            [
                                -97.66213,
                                73.47452
                            ],
                            [
                                -97.61585,
                                73.54788
                            ],
                            [
                                -97.42998,
                                73.58766
                            ],
                            [
                                -97.22598,
                                73.55755
                            ],
                            [
                                -96.95838,
                                73.63692
                            ],
                            [
                                -96.93622,
                                73.73479
                            ],
                            [
                                -97.19567,
                                73.85802
                            ],
                            [
                                -97.4688,
                                73.86318
                            ],
                            [
                                -97.75369,
                                73.91717
                            ],
                            [
                                -97.94582,
                                73.85031
                            ],
                            [
                                -98.17175,
                                73.81217
                            ],
                            [
                                -98.54167,
                                73.79327
                            ],
                            [
                                -98.78593,
                                73.75589
                            ],
                            [
                                -99.12047,
                                73.75143
                            ],
                            [
                                -99.47211,
                                73.82704
                            ],
                            [
                                -99.77016,
                                73.87053
                            ],
                            [
                                -99.77158,
                                73.93624
                            ],
                            [
                                -100.07635,
                                73.94612
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -85.48999,
                                65.818
                            ],
                            [
                                -85.46762,
                                65.88946
                            ],
                            [
                                -85.55671,
                                65.91791
                            ],
                            [
                                -85.92504,
                                65.76476
                            ],
                            [
                                -85.99393,
                                65.70727
                            ],
                            [
                                -86.13459,
                                65.38097
                            ],
                            [
                                -86.15689,
                                65.28692
                            ],
                            [
                                -86.11821,
                                65.1623
                            ],
                            [
                                -86.20965,
                                64.98405
                            ],
                            [
                                -86.12894,
                                64.92931
                            ],
                            [
                                -86.16363,
                                64.85638
                            ],
                            [
                                -86.39047,
                                64.58131
                            ],
                            [
                                -86.39182,
                                64.48728
                            ],
                            [
                                -86.34286,
                                64.4195
                            ],
                            [
                                -86.35817,
                                64.30363
                            ],
                            [
                                -86.30057,
                                64.22503
                            ],
                            [
                                -86.18528,
                                64.16729
                            ],
                            [
                                -86.17469,
                                64.08912
                            ],
                            [
                                -86.82335,
                                63.94019
                            ],
                            [
                                -86.94226,
                                63.89253
                            ],
                            [
                                -87.20626,
                                63.71339
                            ],
                            [
                                -87.21136,
                                63.6337
                            ],
                            [
                                -87.16176,
                                63.57542
                            ],
                            [
                                -86.93319,
                                63.54632
                            ],
                            [
                                -86.767,
                                63.57637
                            ],
                            [
                                -86.66137,
                                63.64045
                            ],
                            [
                                -86.52728,
                                63.66503
                            ],
                            [
                                -86.26634,
                                63.63374
                            ],
                            [
                                -86.031,
                                63.68239
                            ],
                            [
                                -85.80758,
                                63.69729
                            ],
                            [
                                -85.64187,
                                63.68815
                            ],
                            [
                                -85.58974,
                                63.65311
                            ],
                            [
                                -85.59496,
                                63.49984
                            ],
                            [
                                -85.66165,
                                63.39919
                            ],
                            [
                                -85.61408,
                                63.17907
                            ],
                            [
                                -85.43276,
                                63.09782
                            ],
                            [
                                -85.17086,
                                63.11848
                            ],
                            [
                                -84.97375,
                                63.16159
                            ],
                            [
                                -84.58356,
                                63.2916
                            ],
                            [
                                -84.45598,
                                63.37223
                            ],
                            [
                                -84.44036,
                                63.47871
                            ],
                            [
                                -84.35714,
                                63.5647
                            ],
                            [
                                -84.25589,
                                63.61778
                            ],
                            [
                                -84.11424,
                                63.5939
                            ],
                            [
                                -83.80976,
                                63.71507
                            ],
                            [
                                -83.72898,
                                63.77229
                            ],
                            [
                                -83.59823,
                                63.77544
                            ],
                            [
                                -83.62557,
                                63.85882
                            ],
                            [
                                -83.59349,
                                63.92381
                            ],
                            [
                                -83.65713,
                                63.99009
                            ],
                            [
                                -83.53913,
                                64.09541
                            ],
                            [
                                -83.39222,
                                64.09995
                            ],
                            [
                                -83.2851,
                                64.14155
                            ],
                            [
                                -83.20105,
                                64.112
                            ],
                            [
                                -83.09133,
                                64.1734
                            ],
                            [
                                -82.93399,
                                64.13195
                            ],
                            [
                                -83.13859,
                                64.00648
                            ],
                            [
                                -83.05927,
                                63.93915
                            ],
                            [
                                -82.88197,
                                63.97678
                            ],
                            [
                                -82.7884,
                                63.9582
                            ],
                            [
                                -82.53038,
                                63.95603
                            ],
                            [
                                -82.35859,
                                63.89399
                            ],
                            [
                                -82.33314,
                                63.84392
                            ],
                            [
                                -82.48811,
                                63.78908
                            ],
                            [
                                -82.52507,
                                63.73738
                            ],
                            [
                                -82.4615,
                                63.67105
                            ],
                            [
                                -82.2935,
                                63.64454
                            ],
                            [
                                -82.19773,
                                63.68053
                            ],
                            [
                                -82.06247,
                                63.68543
                            ],
                            [
                                -81.6741,
                                63.57019
                            ],
                            [
                                -81.55057,
                                63.57296
                            ],
                            [
                                -81.2823,
                                63.49309
                            ],
                            [
                                -81.04379,
                                63.44582
                            ],
                            [
                                -80.92659,
                                63.46237
                            ],
                            [
                                -80.93068,
                                63.51084
                            ],
                            [
                                -80.5742,
                                63.63373
                            ],
                            [
                                -80.47059,
                                63.72234
                            ],
                            [
                                -80.18658,
                                63.739
                            ],
                            [
                                -80.20679,
                                63.7995
                            ],
                            [
                                -80.50088,
                                63.85596
                            ],
                            [
                                -80.55237,
                                63.90959
                            ],
                            [
                                -80.5389,
                                63.97941
                            ],
                            [
                                -80.69752,
                                63.99421
                            ],
                            [
                                -80.74362,
                                64.05924
                            ],
                            [
                                -80.91765,
                                64.11757
                            ],
                            [
                                -80.99681,
                                63.98469
                            ],
                            [
                                -81.28506,
                                64.0726
                            ],
                            [
                                -81.49078,
                                64.02572
                            ],
                            [
                                -81.61695,
                                64.02223
                            ],
                            [
                                -81.86774,
                                63.98003
                            ],
                            [
                                -82.01065,
                                64.03043
                            ],
                            [
                                -81.5849,
                                64.12849
                            ],
                            [
                                -81.6054,
                                64.20037
                            ],
                            [
                                -81.72975,
                                64.2673
                            ],
                            [
                                -81.74387,
                                64.48813
                            ],
                            [
                                -82.09183,
                                64.68523
                            ],
                            [
                                -82.37662,
                                64.76471
                            ],
                            [
                                -82.52162,
                                64.73276
                            ],
                            [
                                -82.77,
                                64.80504
                            ],
                            [
                                -82.81659,
                                64.84779
                            ],
                            [
                                -83.18199,
                                64.95435
                            ],
                            [
                                -83.30254,
                                65.00435
                            ],
                            [
                                -83.30689,
                                65.06738
                            ],
                            [
                                -83.42367,
                                65.14526
                            ],
                            [
                                -83.68918,
                                65.15419
                            ],
                            [
                                -84.05607,
                                65.20495
                            ],
                            [
                                -84.22864,
                                65.26746
                            ],
                            [
                                -84.14987,
                                65.31744
                            ],
                            [
                                -84.19614,
                                65.36039
                            ],
                            [
                                -84.33202,
                                65.38283
                            ],
                            [
                                -84.52236,
                                65.48055
                            ],
                            [
                                -84.73263,
                                65.326
                            ],
                            [
                                -84.77164,
                                65.21451
                            ],
                            [
                                -84.90643,
                                65.21461
                            ],
                            [
                                -84.98135,
                                65.32452
                            ],
                            [
                                -84.97676,
                                65.39403
                            ],
                            [
                                -85.06518,
                                65.45862
                            ],
                            [
                                -85.26624,
                                65.52406
                            ],
                            [
                                -85.06147,
                                65.57381
                            ],
                            [
                                -85.03006,
                                65.62999
                            ],
                            [
                                -85.13264,
                                65.69468
                            ],
                            [
                                -85.19375,
                                65.80816
                            ],
                            [
                                -85.34743,
                                65.83133
                            ],
                            [
                                -85.48999,
                                65.818
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -93.15086,
                                74.15804
                            ],
                            [
                                -93.57273,
                                74.17585
                            ],
                            [
                                -93.76118,
                                74.14781
                            ],
                            [
                                -94.42167,
                                74.1237
                            ],
                            [
                                -95.1089,
                                74.02953
                            ],
                            [
                                -95.28519,
                                73.99346
                            ],
                            [
                                -95.2828,
                                73.88075
                            ],
                            [
                                -94.88342,
                                73.70864
                            ],
                            [
                                -95.12731,
                                73.70326
                            ],
                            [
                                -95.23209,
                                73.76217
                            ],
                            [
                                -95.38663,
                                73.77652
                            ],
                            [
                                -95.65699,
                                73.72912
                            ],
                            [
                                -95.69278,
                                73.63914
                            ],
                            [
                                -95.61054,
                                73.54319
                            ],
                            [
                                -95.66924,
                                73.45539
                            ],
                            [
                                -95.57876,
                                73.38128
                            ],
                            [
                                -95.57917,
                                73.20597
                            ],
                            [
                                -95.51027,
                                73.13398
                            ],
                            [
                                -95.83645,
                                73.09322
                            ],
                            [
                                -95.63067,
                                73.02679
                            ],
                            [
                                -95.6686,
                                72.81951
                            ],
                            [
                                -95.52128,
                                72.74533
                            ],
                            [
                                -95.53046,
                                72.6835
                            ],
                            [
                                -95.34975,
                                72.64569
                            ],
                            [
                                -95.30998,
                                72.54498
                            ],
                            [
                                -95.11883,
                                72.46476
                            ],
                            [
                                -95.21845,
                                72.44591
                            ],
                            [
                                -95.15732,
                                72.34616
                            ],
                            [
                                -95.19831,
                                72.19068
                            ],
                            [
                                -95.14239,
                                72.08669
                            ],
                            [
                                -95.17315,
                                71.97935
                            ],
                            [
                                -94.59021,
                                72.01225
                            ],
                            [
                                -94.10413,
                                72.05709
                            ],
                            [
                                -93.82387,
                                72.3131
                            ],
                            [
                                -93.63445,
                                72.34065
                            ],
                            [
                                -93.4416,
                                72.44939
                            ],
                            [
                                -93.48557,
                                72.53553
                            ],
                            [
                                -93.64793,
                                72.6251
                            ],
                            [
                                -93.86891,
                                72.70762
                            ],
                            [
                                -94.09917,
                                72.73209
                            ],
                            [
                                -93.93801,
                                72.77911
                            ],
                            [
                                -93.54995,
                                72.78681
                            ],
                            [
                                -93.27031,
                                72.81594
                            ],
                            [
                                -93.06657,
                                72.774
                            ],
                            [
                                -92.29293,
                                72.70872
                            ],
                            [
                                -92.12044,
                                72.73674
                            ],
                            [
                                -91.82269,
                                72.86142
                            ],
                            [
                                -91.35032,
                                73.19578
                            ],
                            [
                                -91.19664,
                                73.32792
                            ],
                            [
                                -91.0039,
                                73.43005
                            ],
                            [
                                -90.91774,
                                73.50699
                            ],
                            [
                                -90.77079,
                                73.5559
                            ],
                            [
                                -90.50658,
                                73.68856
                            ],
                            [
                                -90.16393,
                                73.89522
                            ],
                            [
                                -90.3978,
                                73.91873
                            ],
                            [
                                -90.68726,
                                73.97773
                            ],
                            [
                                -91.14606,
                                74.01516
                            ],
                            [
                                -91.53993,
                                74.03161
                            ],
                            [
                                -91.91706,
                                74.01814
                            ],
                            [
                                -92.25375,
                                73.97717
                            ],
                            [
                                -92.30028,
                                74.04053
                            ],
                            [
                                -92.57132,
                                74.10071
                            ],
                            [
                                -93.15086,
                                74.15804
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -116.43962,
                                77.54938
                            ],
                            [
                                -116.73537,
                                77.5387
                            ],
                            [
                                -116.86575,
                                77.47879
                            ],
                            [
                                -117.12671,
                                77.46099
                            ],
                            [
                                -116.80462,
                                77.38607
                            ],
                            [
                                -116.83683,
                                77.32214
                            ],
                            [
                                -117.19218,
                                77.29207
                            ],
                            [
                                -117.61222,
                                77.33601
                            ],
                            [
                                -117.73347,
                                77.36969
                            ],
                            [
                                -118.66059,
                                77.36498
                            ],
                            [
                                -119.20078,
                                77.31812
                            ],
                            [
                                -119.36337,
                                77.1908
                            ],
                            [
                                -119.92999,
                                77.02461
                            ],
                            [
                                -120.07235,
                                77.00846
                            ],
                            [
                                -120.15533,
                                76.92602
                            ],
                            [
                                -120.40493,
                                76.88128
                            ],
                            [
                                -120.34461,
                                76.82083
                            ],
                            [
                                -120.59223,
                                76.75211
                            ],
                            [
                                -120.83263,
                                76.73019
                            ],
                            [
                                -121.41153,
                                76.55795
                            ],
                            [
                                -121.49638,
                                76.44521
                            ],
                            [
                                -121.74219,
                                76.41744
                            ],
                            [
                                -121.9647,
                                76.44845
                            ],
                            [
                                -122.33884,
                                76.4106
                            ],
                            [
                                -122.62664,
                                76.34182
                            ],
                            [
                                -122.62585,
                                76.2775
                            ],
                            [
                                -122.7898,
                                76.24239
                            ],
                            [
                                -122.92804,
                                76.1395
                            ],
                            [
                                -122.61561,
                                76.18291
                            ],
                            [
                                -122.45045,
                                76.11692
                            ],
                            [
                                -122.67056,
                                75.96053
                            ],
                            [
                                -122.36828,
                                75.93108
                            ],
                            [
                                -122.0535,
                                76.03607
                            ],
                            [
                                -121.85078,
                                76.04931
                            ],
                            [
                                -121.23498,
                                75.97913
                            ],
                            [
                                -120.95655,
                                76.0364
                            ],
                            [
                                -121.02017,
                                76.15106
                            ],
                            [
                                -120.85112,
                                76.19508
                            ],
                            [
                                -120.69884,
                                76.16001
                            ],
                            [
                                -120.71089,
                                76.03331
                            ],
                            [
                                -120.43814,
                                76.01004
                            ],
                            [
                                -120.47675,
                                75.8363
                            ],
                            [
                                -120.29182,
                                75.81335
                            ],
                            [
                                -119.90934,
                                75.85195
                            ],
                            [
                                -119.71114,
                                75.89475
                            ],
                            [
                                -119.49142,
                                76.05149
                            ],
                            [
                                -119.6776,
                                76.09827
                            ],
                            [
                                -119.54543,
                                76.19545
                            ],
                            [
                                -119.64672,
                                76.24213
                            ],
                            [
                                -119.6207,
                                76.32453
                            ],
                            [
                                -119.30537,
                                76.20292
                            ],
                            [
                                -119.20792,
                                76.1132
                            ],
                            [
                                -118.94428,
                                76.13021
                            ],
                            [
                                -118.86095,
                                76.1888
                            ],
                            [
                                -118.90716,
                                76.2646
                            ],
                            [
                                -118.63306,
                                76.29058
                            ],
                            [
                                -118.53491,
                                76.33757
                            ],
                            [
                                -118.6658,
                                76.45957
                            ],
                            [
                                -118.95422,
                                76.49859
                            ],
                            [
                                -118.72381,
                                76.54627
                            ],
                            [
                                -118.57369,
                                76.50457
                            ],
                            [
                                -118.30534,
                                76.57223
                            ],
                            [
                                -118.25165,
                                76.78467
                            ],
                            [
                                -117.78238,
                                76.72306
                            ],
                            [
                                -117.92475,
                                76.68531
                            ],
                            [
                                -117.90513,
                                76.53461
                            ],
                            [
                                -118.01821,
                                76.42371
                            ],
                            [
                                -117.68107,
                                76.32617
                            ],
                            [
                                -117.64591,
                                76.29032
                            ],
                            [
                                -117.31317,
                                76.25924
                            ],
                            [
                                -116.93485,
                                76.35172
                            ],
                            [
                                -117.04054,
                                76.53873
                            ],
                            [
                                -116.76777,
                                76.57527
                            ],
                            [
                                -116.49899,
                                76.57057
                            ],
                            [
                                -116.05473,
                                76.62476
                            ],
                            [
                                -115.91658,
                                76.72711
                            ],
                            [
                                -115.95149,
                                76.81273
                            ],
                            [
                                -116.28643,
                                76.8836
                            ],
                            [
                                -116.25873,
                                76.94987
                            ],
                            [
                                -115.94005,
                                76.90055
                            ],
                            [
                                -115.76206,
                                76.96417
                            ],
                            [
                                -116.23808,
                                77.04449
                            ],
                            [
                                -116.32628,
                                77.12096
                            ],
                            [
                                -116.08572,
                                77.19659
                            ],
                            [
                                -115.36927,
                                77.31687
                            ],
                            [
                                -115.70733,
                                77.42208
                            ],
                            [
                                -116.0794,
                                77.46334
                            ],
                            [
                                -116.0635,
                                77.50667
                            ],
                            [
                                -116.43962,
                                77.54938
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -98.7962,
                                76.68043
                            ],
                            [
                                -98.54495,
                                76.61887
                            ],
                            [
                                -98.99798,
                                76.60888
                            ],
                            [
                                -99.03588,
                                76.54439
                            ],
                            [
                                -98.94441,
                                76.47367
                            ],
                            [
                                -99.24225,
                                76.47914
                            ],
                            [
                                -99.53225,
                                76.5885
                            ],
                            [
                                -100.25189,
                                76.64299
                            ],
                            [
                                -100.6685,
                                76.57133
                            ],
                            [
                                -100.95899,
                                76.4744
                            ],
                            [
                                -100.65389,
                                76.37527
                            ],
                            [
                                -100.3195,
                                76.38752
                            ],
                            [
                                -99.95791,
                                76.29745
                            ],
                            [
                                -100.32555,
                                76.28744
                            ],
                            [
                                -100.43268,
                                76.21818
                            ],
                            [
                                -100.14902,
                                76.19215
                            ],
                            [
                                -100.12319,
                                76.10925
                            ],
                            [
                                -99.98923,
                                76.01016
                            ],
                            [
                                -99.66612,
                                75.94062
                            ],
                            [
                                -100.07173,
                                75.91858
                            ],
                            [
                                -100.30275,
                                76.05563
                            ],
                            [
                                -100.67565,
                                76.09048
                            ],
                            [
                                -100.60078,
                                76.13583
                            ],
                            [
                                -101.087,
                                76.26863
                            ],
                            [
                                -101.10611,
                                76.35157
                            ],
                            [
                                -101.28871,
                                76.41541
                            ],
                            [
                                -101.74544,
                                76.45526
                            ],
                            [
                                -101.98496,
                                76.42163
                            ],
                            [
                                -102.0946,
                                76.34557
                            ],
                            [
                                -102.05653,
                                76.21442
                            ],
                            [
                                -101.76892,
                                76.17512
                            ],
                            [
                                -101.91548,
                                76.11229
                            ],
                            [
                                -101.83053,
                                76.01984
                            ],
                            [
                                -101.66193,
                                75.97697
                            ],
                            [
                                -101.50388,
                                75.85793
                            ],
                            [
                                -101.84055,
                                75.90859
                            ],
                            [
                                -102.15145,
                                75.88295
                            ],
                            [
                                -102.36754,
                                75.81167
                            ],
                            [
                                -102.35119,
                                75.73549
                            ],
                            [
                                -102.56851,
                                75.7162
                            ],
                            [
                                -102.66561,
                                75.64776
                            ],
                            [
                                -102.8634,
                                75.63419
                            ],
                            [
                                -102.76564,
                                75.55103
                            ],
                            [
                                -102.60924,
                                75.49971
                            ],
                            [
                                -102.42987,
                                75.53959
                            ],
                            [
                                -101.99219,
                                75.55093
                            ],
                            [
                                -101.53353,
                                75.59186
                            ],
                            [
                                -101.12446,
                                75.59454
                            ],
                            [
                                -100.55827,
                                75.64655
                            ],
                            [
                                -99.87443,
                                75.6766
                            ],
                            [
                                -99.85207,
                                75.62288
                            ],
                            [
                                -100.0717,
                                75.48481
                            ],
                            [
                                -100.01543,
                                75.45634
                            ],
                            [
                                -100.59182,
                                75.43723
                            ],
                            [
                                -100.44917,
                                75.36585
                            ],
                            [
                                -100.66013,
                                75.33951
                            ],
                            [
                                -100.36016,
                                75.25919
                            ],
                            [
                                -100.45957,
                                75.18644
                            ],
                            [
                                -100.35125,
                                75.1074
                            ],
                            [
                                -100.36701,
                                75.03062
                            ],
                            [
                                -100.09859,
                                74.99035
                            ],
                            [
                                -99.55504,
                                74.97491
                            ],
                            [
                                -99.45557,
                                74.99675
                            ],
                            [
                                -98.4676,
                                75.00207
                            ],
                            [
                                -98.31238,
                                75.02855
                            ],
                            [
                                -97.95072,
                                75.03489
                            ],
                            [
                                -98.00777,
                                75.11734
                            ],
                            [
                                -97.61349,
                                75.1215
                            ],
                            [
                                -97.80402,
                                75.2109
                            ],
                            [
                                -97.82841,
                                75.26141
                            ],
                            [
                                -98.07212,
                                75.28373
                            ],
                            [
                                -98.15396,
                                75.34401
                            ],
                            [
                                -97.80472,
                                75.41651
                            ],
                            [
                                -97.725,
                                75.46893
                            ],
                            [
                                -97.79012,
                                75.53294
                            ],
                            [
                                -97.69577,
                                75.56899
                            ],
                            [
                                -97.38394,
                                75.45519
                            ],
                            [
                                -97.41618,
                                75.61362
                            ],
                            [
                                -97.36856,
                                75.69119
                            ],
                            [
                                -97.90066,
                                75.73664
                            ],
                            [
                                -97.644,
                                75.79756
                            ],
                            [
                                -97.59565,
                                75.85206
                            ],
                            [
                                -97.64782,
                                75.98458
                            ],
                            [
                                -97.47119,
                                76.13231
                            ],
                            [
                                -97.49817,
                                76.20217
                            ],
                            [
                                -97.71873,
                                76.27736
                            ],
                            [
                                -97.762,
                                76.33979
                            ],
                            [
                                -97.65073,
                                76.41573
                            ],
                            [
                                -97.67257,
                                76.48873
                            ],
                            [
                                -98.07289,
                                76.52947
                            ],
                            [
                                -98.19245,
                                76.59495
                            ],
                            [
                                -98.40017,
                                76.61972
                            ],
                            [
                                -98.50528,
                                76.68529
                            ],
                            [
                                -98.7962,
                                76.68043
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -104.44534,
                                79.38536
                            ],
                            [
                                -104.95917,
                                79.32643
                            ],
                            [
                                -105.45688,
                                79.33727
                            ],
                            [
                                -105.47663,
                                79.2591
                            ],
                            [
                                -105.64877,
                                79.15704
                            ],
                            [
                                -105.61544,
                                79.0364
                            ],
                            [
                                -105.40387,
                                79.00925
                            ],
                            [
                                -104.94228,
                                79.05651
                            ],
                            [
                                -104.71014,
                                79.03777
                            ],
                            [
                                -104.69121,
                                78.98495
                            ],
                            [
                                -104.98574,
                                78.84174
                            ],
                            [
                                -104.60086,
                                78.84943
                            ],
                            [
                                -104.45684,
                                78.94881
                            ],
                            [
                                -104.10955,
                                78.9826
                            ],
                            [
                                -103.85101,
                                78.91675
                            ],
                            [
                                -104.1404,
                                78.82619
                            ],
                            [
                                -103.96913,
                                78.76242
                            ],
                            [
                                -103.73526,
                                78.78772
                            ],
                            [
                                -103.31878,
                                78.7351
                            ],
                            [
                                -103.4792,
                                78.66761
                            ],
                            [
                                -103.84203,
                                78.67012
                            ],
                            [
                                -103.9079,
                                78.62765
                            ],
                            [
                                -103.38814,
                                78.61997
                            ],
                            [
                                -103.53681,
                                78.50688
                            ],
                            [
                                -104.02085,
                                78.51803
                            ],
                            [
                                -104.46623,
                                78.57362
                            ],
                            [
                                -104.82215,
                                78.57669
                            ],
                            [
                                -105.0188,
                                78.50159
                            ],
                            [
                                -104.8078,
                                78.36149
                            ],
                            [
                                -104.43157,
                                78.26555
                            ],
                            [
                                -103.9141,
                                78.24763
                            ],
                            [
                                -103.82057,
                                78.29647
                            ],
                            [
                                -103.11052,
                                78.37317
                            ],
                            [
                                -102.67866,
                                78.37788
                            ],
                            [
                                -102.82004,
                                78.30152
                            ],
                            [
                                -102.57096,
                                78.23979
                            ],
                            [
                                -102.15257,
                                78.29517
                            ],
                            [
                                -101.4936,
                                78.23771
                            ],
                            [
                                -101.28166,
                                78.17781
                            ],
                            [
                                -101.07828,
                                78.20095
                            ],
                            [
                                -100.88393,
                                78.12759
                            ],
                            [
                                -100.76324,
                                77.97269
                            ],
                            [
                                -100.50634,
                                77.86852
                            ],
                            [
                                -100.21188,
                                77.81484
                            ],
                            [
                                -99.84345,
                                77.78867
                            ],
                            [
                                -99.14327,
                                77.86048
                            ],
                            [
                                -99.08529,
                                77.97261
                            ],
                            [
                                -98.91729,
                                78.05735
                            ],
                            [
                                -99.41522,
                                78.2092
                            ],
                            [
                                -99.48374,
                                78.28311
                            ],
                            [
                                -99.78578,
                                78.30372
                            ],
                            [
                                -99.755,
                                78.40368
                            ],
                            [
                                -99.52225,
                                78.59652
                            ],
                            [
                                -100.03642,
                                78.63752
                            ],
                            [
                                -99.87495,
                                78.70174
                            ],
                            [
                                -100.34696,
                                78.83119
                            ],
                            [
                                -100.60018,
                                78.79997
                            ],
                            [
                                -101.20781,
                                78.80662
                            ],
                            [
                                -100.9585,
                                78.93542
                            ],
                            [
                                -101.205,
                                78.9602
                            ],
                            [
                                -101.63348,
                                79.07803
                            ],
                            [
                                -101.96325,
                                79.08883
                            ],
                            [
                                -102.39516,
                                79.01402
                            ],
                            [
                                -102.3736,
                                78.9598
                            ],
                            [
                                -102.72113,
                                78.94089
                            ],
                            [
                                -102.60207,
                                79.06704
                            ],
                            [
                                -102.88989,
                                79.17152
                            ],
                            [
                                -103.07512,
                                79.28097
                            ],
                            [
                                -103.38958,
                                79.29428
                            ],
                            [
                                -103.68583,
                                79.36479
                            ],
                            [
                                -104.44534,
                                79.38536
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -128.05251,
                                50.86981
                            ],
                            [
                                -128.25087,
                                50.80453
                            ],
                            [
                                -128.40811,
                                50.77739
                            ],
                            [
                                -128.40646,
                                50.74323
                            ],
                            [
                                -128.31227,
                                50.66631
                            ],
                            [
                                -128.32192,
                                50.62746
                            ],
                            [
                                -128.22983,
                                50.58639
                            ],
                            [
                                -128.20193,
                                50.5281
                            ],
                            [
                                -128.08414,
                                50.47764
                            ],
                            [
                                -127.81877,
                                50.48448
                            ],
                            [
                                -127.66224,
                                50.53228
                            ],
                            [
                                -127.58371,
                                50.48614
                            ],
                            [
                                -127.93184,
                                50.46019
                            ],
                            [
                                -127.97303,
                                50.32987
                            ],
                            [
                                -127.87969,
                                50.34082
                            ],
                            [
                                -127.79541,
                                50.2189
                            ],
                            [
                                -127.91455,
                                50.12749
                            ],
                            [
                                -127.79667,
                                50.08277
                            ],
                            [
                                -127.69565,
                                50.13294
                            ],
                            [
                                -127.50913,
                                50.13547
                            ],
                            [
                                -127.4096,
                                50.03848
                            ],
                            [
                                -127.35087,
                                50.02343
                            ],
                            [
                                -127.21218,
                                50.09554
                            ],
                            [
                                -127.1792,
                                50.02031
                            ],
                            [
                                -127.25041,
                                49.96473
                            ],
                            [
                                -127.1678,
                                49.87142
                            ],
                            [
                                -127.04086,
                                49.85303
                            ],
                            [
                                -126.82498,
                                49.88296
                            ],
                            [
                                -126.80436,
                                49.9126
                            ],
                            [
                                -126.75647,
                                49.87778
                            ],
                            [
                                -126.67568,
                                49.86398
                            ],
                            [
                                -126.61303,
                                49.72334
                            ],
                            [
                                -126.50187,
                                49.7122
                            ],
                            [
                                -126.44791,
                                49.65833
                            ],
                            [
                                -126.56443,
                                49.57525
                            ],
                            [
                                -126.57236,
                                49.4163
                            ],
                            [
                                -126.53752,
                                49.38238
                            ],
                            [
                                -126.40122,
                                49.41342
                            ],
                            [
                                -126.28182,
                                49.35512
                            ],
                            [
                                -126.25392,
                                49.41968
                            ],
                            [
                                -126.17991,
                                49.39939
                            ],
                            [
                                -126.11762,
                                49.42794
                            ],
                            [
                                -126.02966,
                                49.28347
                            ],
                            [
                                -125.97833,
                                49.23009
                            ],
                            [
                                -125.90742,
                                49.27866
                            ],
                            [
                                -125.80898,
                                49.24784
                            ],
                            [
                                -125.64511,
                                49.16131
                            ],
                            [
                                -125.75413,
                                49.09284
                            ],
                            [
                                -125.67616,
                                49.00762
                            ],
                            [
                                -125.47192,
                                48.92871
                            ],
                            [
                                -125.37358,
                                48.997
                            ],
                            [
                                -125.19593,
                                48.95735
                            ],
                            [
                                -125.15443,
                                49.00386
                            ],
                            [
                                -125.0091,
                                48.94473
                            ],
                            [
                                -125.2062,
                                48.79579
                            ],
                            [
                                -125.11224,
                                48.72933
                            ],
                            [
                                -124.81608,
                                48.66099
                            ],
                            [
                                -124.71805,
                                48.59592
                            ],
                            [
                                -124.44784,
                                48.52734
                            ],
                            [
                                -124.31193,
                                48.50392
                            ],
                            [
                                -124.21087,
                                48.45908
                            ],
                            [
                                -124.03198,
                                48.41858
                            ],
                            [
                                -123.92529,
                                48.37938
                            ],
                            [
                                -123.76664,
                                48.36862
                            ],
                            [
                                -123.65265,
                                48.31643
                            ],
                            [
                                -123.56007,
                                48.31246
                            ],
                            [
                                -123.47154,
                                48.42675
                            ],
                            [
                                -123.29985,
                                48.41288
                            ],
                            [
                                -123.30709,
                                48.49281
                            ],
                            [
                                -123.36302,
                                48.51707
                            ],
                            [
                                -123.40715,
                                48.62757
                            ],
                            [
                                -123.55253,
                                48.6533
                            ],
                            [
                                -123.58182,
                                48.73073
                            ],
                            [
                                -123.564,
                                48.79629
                            ],
                            [
                                -123.59341,
                                48.84629
                            ],
                            [
                                -123.79334,
                                48.97408
                            ],
                            [
                                -123.75176,
                                49.04327
                            ],
                            [
                                -123.81094,
                                49.12882
                            ],
                            [
                                -123.9097,
                                49.13712
                            ],
                            [
                                -123.96723,
                                49.23548
                            ],
                            [
                                -124.08306,
                                49.25567
                            ],
                            [
                                -124.18368,
                                49.30884
                            ],
                            [
                                -124.25396,
                                49.30756
                            ],
                            [
                                -124.36884,
                                49.35369
                            ],
                            [
                                -124.57821,
                                49.38241
                            ],
                            [
                                -124.72229,
                                49.46357
                            ],
                            [
                                -124.79018,
                                49.46287
                            ],
                            [
                                -124.9257,
                                49.64304
                            ],
                            [
                                -124.86525,
                                49.69456
                            ],
                            [
                                -125.11595,
                                49.88108
                            ],
                            [
                                -125.18178,
                                49.91418
                            ],
                            [
                                -125.24617,
                                50.03944
                            ],
                            [
                                -125.36088,
                                50.13074
                            ],
                            [
                                -125.44588,
                                50.31949
                            ],
                            [
                                -125.58068,
                                50.36783
                            ],
                            [
                                -125.71928,
                                50.357
                            ],
                            [
                                -125.94326,
                                50.39005
                            ],
                            [
                                -126.09505,
                                50.45114
                            ],
                            [
                                -126.31406,
                                50.47901
                            ],
                            [
                                -126.58425,
                                50.48135
                            ],
                            [
                                -126.78608,
                                50.54293
                            ],
                            [
                                -126.97982,
                                50.57878
                            ],
                            [
                                -127.12102,
                                50.58991
                            ],
                            [
                                -127.33766,
                                50.67234
                            ],
                            [
                                -127.48638,
                                50.7646
                            ],
                            [
                                -127.90467,
                                50.87338
                            ],
                            [
                                -128.05251,
                                50.86981
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -80.61131,
                                73.75988
                            ],
                            [
                                -80.80241,
                                73.75512
                            ],
                            [
                                -80.78945,
                                73.65226
                            ],
                            [
                                -80.88958,
                                73.61304
                            ],
                            [
                                -80.85981,
                                73.47786
                            ],
                            [
                                -80.8765,
                                73.34175
                            ],
                            [
                                -80.76218,
                                73.27801
                            ],
                            [
                                -80.18676,
                                73.23698
                            ],
                            [
                                -80.10634,
                                73.18033
                            ],
                            [
                                -80.17345,
                                73.04945
                            ],
                            [
                                -79.99451,
                                72.87488
                            ],
                            [
                                -79.57539,
                                72.75598
                            ],
                            [
                                -79.14086,
                                72.7538
                            ],
                            [
                                -78.42063,
                                72.88084
                            ],
                            [
                                -77.68768,
                                72.90289
                            ],
                            [
                                -76.95599,
                                72.8396
                            ],
                            [
                                -76.37447,
                                72.81809
                            ],
                            [
                                -76.06428,
                                72.86344
                            ],
                            [
                                -76.07539,
                                72.93764
                            ],
                            [
                                -76.32159,
                                72.98556
                            ],
                            [
                                -76.25444,
                                73.09312
                            ],
                            [
                                -76.55547,
                                73.13892
                            ],
                            [
                                -76.56558,
                                73.22114
                            ],
                            [
                                -76.73754,
                                73.29116
                            ],
                            [
                                -76.93029,
                                73.33104
                            ],
                            [
                                -77.20516,
                                73.50977
                            ],
                            [
                                -77.41414,
                                73.55439
                            ],
                            [
                                -77.73757,
                                73.59066
                            ],
                            [
                                -78.10855,
                                73.6663
                            ],
                            [
                                -78.93896,
                                73.66264
                            ],
                            [
                                -78.98579,
                                73.63516
                            ],
                            [
                                -79.51742,
                                73.63703
                            ],
                            [
                                -79.96646,
                                73.71245
                            ],
                            [
                                -80.11227,
                                73.69218
                            ],
                            [
                                -80.4215,
                                73.76612
                            ],
                            [
                                -80.61131,
                                73.75988
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -98.04266,
                                69.86865
                            ],
                            [
                                -98.28931,
                                69.72594
                            ],
                            [
                                -98.31105,
                                69.62454
                            ],
                            [
                                -98.10772,
                                69.50101
                            ],
                            [
                                -98.19233,
                                69.48322
                            ],
                            [
                                -98.32327,
                                69.56469
                            ],
                            [
                                -98.53058,
                                69.59173
                            ],
                            [
                                -98.56997,
                                69.42826
                            ],
                            [
                                -98.39928,
                                69.37538
                            ],
                            [
                                -98.47626,
                                69.31642
                            ],
                            [
                                -98.66917,
                                69.27343
                            ],
                            [
                                -98.66719,
                                69.21491
                            ],
                            [
                                -98.95557,
                                69.15833
                            ],
                            [
                                -99.38681,
                                69.1433
                            ],
                            [
                                -99.46966,
                                69.11443
                            ],
                            [
                                -99.54295,
                                69.02579
                            ],
                            [
                                -99.37551,
                                68.88788
                            ],
                            [
                                -99.15676,
                                68.85594
                            ],
                            [
                                -99.00867,
                                68.9594
                            ],
                            [
                                -98.78963,
                                68.91741
                            ],
                            [
                                -98.83663,
                                68.85276
                            ],
                            [
                                -98.67329,
                                68.79092
                            ],
                            [
                                -98.38045,
                                68.76204
                            ],
                            [
                                -98.3988,
                                68.84185
                            ],
                            [
                                -98.20925,
                                68.82061
                            ],
                            [
                                -98.27178,
                                68.77287
                            ],
                            [
                                -98.09571,
                                68.68502
                            ],
                            [
                                -97.98814,
                                68.69448
                            ],
                            [
                                -97.70289,
                                68.65725
                            ],
                            [
                                -97.58071,
                                68.58428
                            ],
                            [
                                -97.12052,
                                68.51586
                            ],
                            [
                                -96.85808,
                                68.52744
                            ],
                            [
                                -96.54153,
                                68.45397
                            ],
                            [
                                -96.26472,
                                68.47673
                            ],
                            [
                                -95.95458,
                                68.63659
                            ],
                            [
                                -95.82755,
                                68.66478
                            ],
                            [
                                -95.70346,
                                68.74025
                            ],
                            [
                                -95.57913,
                                68.77421
                            ],
                            [
                                -95.4736,
                                68.70987
                            ],
                            [
                                -95.23407,
                                68.80977
                            ],
                            [
                                -95.24508,
                                68.90109
                            ],
                            [
                                -95.36956,
                                68.89837
                            ],
                            [
                                -95.56328,
                                68.84026
                            ],
                            [
                                -95.71324,
                                68.88903
                            ],
                            [
                                -95.81791,
                                68.88227
                            ],
                            [
                                -95.85718,
                                68.99
                            ],
                            [
                                -95.95935,
                                69.05993
                            ],
                            [
                                -95.90914,
                                69.14638
                            ],
                            [
                                -96.02151,
                                69.21412
                            ],
                            [
                                -96.1913,
                                69.17466
                            ],
                            [
                                -96.15693,
                                69.28967
                            ],
                            [
                                -96.55386,
                                69.4471
                            ],
                            [
                                -96.76369,
                                69.50727
                            ],
                            [
                                -96.90143,
                                69.51818
                            ],
                            [
                                -97.07084,
                                69.58717
                            ],
                            [
                                -97.13735,
                                69.66504
                            ],
                            [
                                -97.3018,
                                69.67605
                            ],
                            [
                                -97.42762,
                                69.77669
                            ],
                            [
                                -97.91842,
                                69.9023
                            ],
                            [
                                -98.04266,
                                69.86865
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -94.84122,
                                75.63634
                            ],
                            [
                                -95.34645,
                                75.56781
                            ],
                            [
                                -95.60011,
                                75.55481
                            ],
                            [
                                -95.94706,
                                75.44113
                            ],
                            [
                                -95.93869,
                                75.38812
                            ],
                            [
                                -96.15488,
                                75.31114
                            ],
                            [
                                -96.21143,
                                75.25144
                            ],
                            [
                                -96.37455,
                                75.2126
                            ],
                            [
                                -96.5898,
                                75.08007
                            ],
                            [
                                -96.6121,
                                75.02552
                            ],
                            [
                                -96.36987,
                                75.00831
                            ],
                            [
                                -96.36549,
                                74.91718
                            ],
                            [
                                -96.12846,
                                74.93373
                            ],
                            [
                                -95.81651,
                                74.82772
                            ],
                            [
                                -95.27092,
                                74.8068
                            ],
                            [
                                -95.04737,
                                74.72657
                            ],
                            [
                                -95.07554,
                                74.68328
                            ],
                            [
                                -94.47138,
                                74.63067
                            ],
                            [
                                -93.61494,
                                74.65528
                            ],
                            [
                                -93.47952,
                                74.68037
                            ],
                            [
                                -93.41353,
                                74.79077
                            ],
                            [
                                -93.41813,
                                74.97215
                            ],
                            [
                                -93.54468,
                                75.05125
                            ],
                            [
                                -93.4706,
                                75.13872
                            ],
                            [
                                -93.58354,
                                75.19918
                            ],
                            [
                                -93.48465,
                                75.2485
                            ],
                            [
                                -93.64926,
                                75.35827
                            ],
                            [
                                -93.89548,
                                75.42001
                            ],
                            [
                                -94.31448,
                                75.59052
                            ],
                            [
                                -94.84122,
                                75.63634
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -98.15745,
                                78.81927
                            ],
                            [
                                -98.39426,
                                78.72423
                            ],
                            [
                                -98.35977,
                                78.65647
                            ],
                            [
                                -98.06936,
                                78.55295
                            ],
                            [
                                -98.40897,
                                78.50964
                            ],
                            [
                                -98.35362,
                                78.45118
                            ],
                            [
                                -98.10538,
                                78.38977
                            ],
                            [
                                -98.05544,
                                78.30274
                            ],
                            [
                                -97.59416,
                                78.19846
                            ],
                            [
                                -97.30507,
                                78.20571
                            ],
                            [
                                -96.88168,
                                78.13364
                            ],
                            [
                                -96.89575,
                                78.0816
                            ],
                            [
                                -97.45718,
                                78.0776
                            ],
                            [
                                -97.79376,
                                78.03339
                            ],
                            [
                                -97.50253,
                                78.00181
                            ],
                            [
                                -97.00704,
                                77.91072
                            ],
                            [
                                -97.09974,
                                77.80974
                            ],
                            [
                                -96.90557,
                                77.78636
                            ],
                            [
                                -96.47123,
                                77.90591
                            ],
                            [
                                -96.38042,
                                77.8611
                            ],
                            [
                                -95.93365,
                                77.88777
                            ],
                            [
                                -95.31417,
                                77.96941
                            ],
                            [
                                -95.13161,
                                77.94982
                            ],
                            [
                                -94.90466,
                                78.06337
                            ],
                            [
                                -94.909,
                                78.11706
                            ],
                            [
                                -95.23885,
                                78.21791
                            ],
                            [
                                -95.15923,
                                78.28627
                            ],
                            [
                                -94.84623,
                                78.34619
                            ],
                            [
                                -94.98603,
                                78.41871
                            ],
                            [
                                -95.53551,
                                78.51368
                            ],
                            [
                                -95.97503,
                                78.48105
                            ],
                            [
                                -96.29175,
                                78.53784
                            ],
                            [
                                -96.17426,
                                78.60335
                            ],
                            [
                                -96.52075,
                                78.68164
                            ],
                            [
                                -96.88995,
                                78.69974
                            ],
                            [
                                -97.00623,
                                78.74043
                            ],
                            [
                                -97.50762,
                                78.80238
                            ],
                            [
                                -98.15745,
                                78.81927
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -75.96727,
                                68.33617
                            ],
                            [
                                -76.04005,
                                68.2994
                            ],
                            [
                                -76.25107,
                                68.31173
                            ],
                            [
                                -76.57245,
                                68.28196
                            ],
                            [
                                -76.66748,
                                68.25708
                            ],
                            [
                                -76.95256,
                                68.08881
                            ],
                            [
                                -77.16893,
                                67.88488
                            ],
                            [
                                -77.27997,
                                67.73286
                            ],
                            [
                                -77.21572,
                                67.43551
                            ],
                            [
                                -77.07504,
                                67.25503
                            ],
                            [
                                -76.96266,
                                67.22735
                            ],
                            [
                                -76.6644,
                                67.20669
                            ],
                            [
                                -76.33094,
                                67.25087
                            ],
                            [
                                -75.87519,
                                67.24799
                            ],
                            [
                                -75.42236,
                                67.34639
                            ],
                            [
                                -75.18148,
                                67.44064
                            ],
                            [
                                -75.0428,
                                67.60358
                            ],
                            [
                                -75.05504,
                                67.81184
                            ],
                            [
                                -75.13272,
                                67.97268
                            ],
                            [
                                -75.03736,
                                68.04145
                            ],
                            [
                                -75.02392,
                                68.16842
                            ],
                            [
                                -75.1197,
                                68.23594
                            ],
                            [
                                -75.48943,
                                68.27556
                            ],
                            [
                                -75.78235,
                                68.33851
                            ],
                            [
                                -75.96727,
                                68.33617
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -110.33946,
                                78.11634
                            ],
                            [
                                -110.99269,
                                78.09985
                            ],
                            [
                                -111.81555,
                                78.05742
                            ],
                            [
                                -112.22832,
                                78.00203
                            ],
                            [
                                -112.3904,
                                78.00883
                            ],
                            [
                                -112.83029,
                                77.93746
                            ],
                            [
                                -113.21238,
                                77.92
                            ],
                            [
                                -113.31173,
                                77.78516
                            ],
                            [
                                -113.09581,
                                77.63991
                            ],
                            [
                                -113.17148,
                                77.52559
                            ],
                            [
                                -112.92024,
                                77.46952
                            ],
                            [
                                -112.59257,
                                77.43968
                            ],
                            [
                                -112.46542,
                                77.37734
                            ],
                            [
                                -112.02936,
                                77.32853
                            ],
                            [
                                -111.34438,
                                77.40497
                            ],
                            [
                                -110.8958,
                                77.40659
                            ],
                            [
                                -110.82018,
                                77.43885
                            ],
                            [
                                -110.43473,
                                77.46548
                            ],
                            [
                                -110.05689,
                                77.56673
                            ],
                            [
                                -110.11074,
                                77.68573
                            ],
                            [
                                -110.04853,
                                77.77445
                            ],
                            [
                                -110.28995,
                                77.79024
                            ],
                            [
                                -110.6558,
                                77.77083
                            ],
                            [
                                -110.91296,
                                77.86738
                            ],
                            [
                                -110.01122,
                                77.91902
                            ],
                            [
                                -109.71751,
                                77.95136
                            ],
                            [
                                -109.56048,
                                78.03445
                            ],
                            [
                                -109.67478,
                                78.10484
                            ],
                            [
                                -110.33946,
                                78.11634
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -133.08499,
                                54.18152
                            ],
                            [
                                -133.06852,
                                54.05475
                            ],
                            [
                                -133.11825,
                                53.99902
                            ],
                            [
                                -133.15116,
                                53.88973
                            ],
                            [
                                -133.1158,
                                53.77802
                            ],
                            [
                                -132.99473,
                                53.74215
                            ],
                            [
                                -132.90544,
                                53.58593
                            ],
                            [
                                -132.92746,
                                53.54236
                            ],
                            [
                                -132.88007,
                                53.4681
                            ],
                            [
                                -132.53438,
                                53.41249
                            ],
                            [
                                -132.53857,
                                53.36373
                            ],
                            [
                                -132.68804,
                                53.36669
                            ],
                            [
                                -132.55034,
                                53.16882
                            ],
                            [
                                -132.58456,
                                53.15033
                            ],
                            [
                                -132.49132,
                                53.02983
                            ],
                            [
                                -132.2653,
                                53.01794
                            ],
                            [
                                -132.14915,
                                52.97529
                            ],
                            [
                                -132.36046,
                                52.92953
                            ],
                            [
                                -132.24101,
                                52.85832
                            ],
                            [
                                -132.23436,
                                52.80308
                            ],
                            [
                                -132.09507,
                                52.74647
                            ],
                            [
                                -132.05696,
                                52.69222
                            ],
                            [
                                -131.75359,
                                52.50101
                            ],
                            [
                                -131.66197,
                                52.47771
                            ],
                            [
                                -131.55003,
                                52.32575
                            ],
                            [
                                -131.42508,
                                52.22004
                            ],
                            [
                                -131.30836,
                                52.17222
                            ],
                            [
                                -131.2627,
                                52.125
                            ],
                            [
                                -131.15491,
                                52.12926
                            ],
                            [
                                -131.05063,
                                52.16556
                            ],
                            [
                                -131.02727,
                                52.2294
                            ],
                            [
                                -131.17999,
                                52.32023
                            ],
                            [
                                -131.2642,
                                52.28543
                            ],
                            [
                                -131.28716,
                                52.44731
                            ],
                            [
                                -131.42906,
                                52.4123
                            ],
                            [
                                -131.47733,
                                52.50175
                            ],
                            [
                                -131.68554,
                                52.58587
                            ],
                            [
                                -131.73935,
                                52.68873
                            ],
                            [
                                -131.82696,
                                52.71605
                            ],
                            [
                                -131.81686,
                                52.80015
                            ],
                            [
                                -131.88087,
                                52.83515
                            ],
                            [
                                -131.79522,
                                52.88492
                            ],
                            [
                                -131.69403,
                                52.87156
                            ],
                            [
                                -131.62279,
                                52.92701
                            ],
                            [
                                -131.66102,
                                52.99662
                            ],
                            [
                                -131.63978,
                                53.09672
                            ],
                            [
                                -131.77609,
                                53.19539
                            ],
                            [
                                -131.80624,
                                53.2521
                            ],
                            [
                                -131.91736,
                                53.23701
                            ],
                            [
                                -132.0834,
                                53.15131
                            ],
                            [
                                -132.18216,
                                53.24063
                            ],
                            [
                                -131.99563,
                                53.2511
                            ],
                            [
                                -131.92819,
                                53.36039
                            ],
                            [
                                -131.91419,
                                53.42877
                            ],
                            [
                                -131.95495,
                                53.51971
                            ],
                            [
                                -131.93057,
                                53.62325
                            ],
                            [
                                -131.87639,
                                53.7088
                            ],
                            [
                                -131.85662,
                                53.81275
                            ],
                            [
                                -131.73302,
                                53.94318
                            ],
                            [
                                -131.67953,
                                54.05178
                            ],
                            [
                                -131.78325,
                                54.0785
                            ],
                            [
                                -131.99814,
                                54.0283
                            ],
                            [
                                -132.15053,
                                54.01319
                            ],
                            [
                                -132.09083,
                                53.89566
                            ],
                            [
                                -132.13007,
                                53.82425
                            ],
                            [
                                -132.20625,
                                53.75556
                            ],
                            [
                                -132.16603,
                                53.70344
                            ],
                            [
                                -132.20144,
                                53.6621
                            ],
                            [
                                -132.44205,
                                53.67125
                            ],
                            [
                                -132.40783,
                                53.74497
                            ],
                            [
                                -132.26359,
                                53.76557
                            ],
                            [
                                -132.12997,
                                53.8445
                            ],
                            [
                                -132.10771,
                                53.88499
                            ],
                            [
                                -132.18107,
                                54.01598
                            ],
                            [
                                -132.31743,
                                54.11269
                            ],
                            [
                                -132.43247,
                                54.09903
                            ],
                            [
                                -132.5618,
                                54.04287
                            ],
                            [
                                -132.58507,
                                54.11996
                            ],
                            [
                                -132.66712,
                                54.15329
                            ],
                            [
                                -132.81855,
                                54.12802
                            ],
                            [
                                -133.03359,
                                54.18449
                            ],
                            [
                                -133.08499,
                                54.18152
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -105.51055,
                                73.76967
                            ],
                            [
                                -105.67703,
                                73.73654
                            ],
                            [
                                -106.28592,
                                73.73168
                            ],
                            [
                                -106.64392,
                                73.68639
                            ],
                            [
                                -106.83203,
                                73.56634
                            ],
                            [
                                -107.00669,
                                73.48778
                            ],
                            [
                                -106.53912,
                                73.42075
                            ],
                            [
                                -106.13459,
                                73.30218
                            ],
                            [
                                -106.07922,
                                73.20332
                            ],
                            [
                                -105.90196,
                                73.15066
                            ],
                            [
                                -105.72993,
                                73.04407
                            ],
                            [
                                -105.22245,
                                72.86998
                            ],
                            [
                                -105.21574,
                                72.9303
                            ],
                            [
                                -104.93875,
                                73.03938
                            ],
                            [
                                -104.55277,
                                73.30957
                            ],
                            [
                                -104.44589,
                                73.54624
                            ],
                            [
                                -104.5144,
                                73.59897
                            ],
                            [
                                -104.97603,
                                73.70252
                            ],
                            [
                                -105.15714,
                                73.75796
                            ],
                            [
                                -105.51055,
                                73.76967
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -60.613,
                                47.03107
                            ],
                            [
                                -60.68958,
                                46.92061
                            ],
                            [
                                -60.79492,
                                46.83491
                            ],
                            [
                                -60.88818,
                                46.7892
                            ],
                            [
                                -60.99625,
                                46.65082
                            ],
                            [
                                -61.10127,
                                46.4537
                            ],
                            [
                                -61.32641,
                                46.22803
                            ],
                            [
                                -61.42096,
                                46.18794
                            ],
                            [
                                -61.48009,
                                46.08272
                            ],
                            [
                                -61.54932,
                                46.0399
                            ],
                            [
                                -61.49692,
                                45.89626
                            ],
                            [
                                -61.49429,
                                45.80538
                            ],
                            [
                                -61.46289,
                                45.71471
                            ],
                            [
                                -61.33719,
                                45.57228
                            ],
                            [
                                -61.21535,
                                45.60143
                            ],
                            [
                                -61.12625,
                                45.57431
                            ],
                            [
                                -60.91197,
                                45.63072
                            ],
                            [
                                -60.76075,
                                45.60516
                            ],
                            [
                                -60.73779,
                                45.57566
                            ],
                            [
                                -60.55101,
                                45.62877
                            ],
                            [
                                -60.43059,
                                45.64347
                            ],
                            [
                                -60.2234,
                                45.76324
                            ],
                            [
                                -60.08509,
                                45.80535
                            ],
                            [
                                -60.12411,
                                45.88324
                            ],
                            [
                                -59.99444,
                                45.87699
                            ],
                            [
                                -59.9199,
                                45.92958
                            ],
                            [
                                -59.83485,
                                45.95253
                            ],
                            [
                                -59.8435,
                                45.99496
                            ],
                            [
                                -59.95422,
                                46.01361
                            ],
                            [
                                -59.8363,
                                46.09716
                            ],
                            [
                                -59.85048,
                                46.15992
                            ],
                            [
                                -59.95786,
                                46.21539
                            ],
                            [
                                -60.12649,
                                46.26307
                            ],
                            [
                                -60.21953,
                                46.25997
                            ],
                            [
                                -60.29718,
                                46.32973
                            ],
                            [
                                -60.35849,
                                46.32237
                            ],
                            [
                                -60.55007,
                                46.18634
                            ],
                            [
                                -60.51246,
                                46.09557
                            ],
                            [
                                -60.79247,
                                45.95613
                            ],
                            [
                                -60.73095,
                                45.90752
                            ],
                            [
                                -60.65873,
                                45.91091
                            ],
                            [
                                -60.55951,
                                45.96096
                            ],
                            [
                                -60.54275,
                                45.90821
                            ],
                            [
                                -60.74037,
                                45.7938
                            ],
                            [
                                -60.74637,
                                45.69949
                            ],
                            [
                                -60.90204,
                                45.76627
                            ],
                            [
                                -60.9677,
                                45.76119
                            ],
                            [
                                -61.09609,
                                45.69703
                            ],
                            [
                                -61.14173,
                                45.76134
                            ],
                            [
                                -61.02075,
                                45.82892
                            ],
                            [
                                -60.92564,
                                45.93199
                            ],
                            [
                                -60.81673,
                                45.94912
                            ],
                            [
                                -60.8343,
                                46.07338
                            ],
                            [
                                -60.64308,
                                46.12054
                            ],
                            [
                                -60.4215,
                                46.29541
                            ],
                            [
                                -60.51877,
                                46.37372
                            ],
                            [
                                -60.46439,
                                46.42528
                            ],
                            [
                                -60.4071,
                                46.54923
                            ],
                            [
                                -60.35594,
                                46.61486
                            ],
                            [
                                -60.39161,
                                46.68489
                            ],
                            [
                                -60.32523,
                                46.75135
                            ],
                            [
                                -60.30661,
                                46.84796
                            ],
                            [
                                -60.45695,
                                46.90523
                            ],
                            [
                                -60.45356,
                                46.95638
                            ],
                            [
                                -60.50917,
                                47.00498
                            ],
                            [
                                -60.613,
                                47.03107
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -110.43301,
                                78.7599
                            ],
                            [
                                -110.70698,
                                78.76357
                            ],
                            [
                                -110.81924,
                                78.72003
                            ],
                            [
                                -111.14875,
                                78.6985
                            ],
                            [
                                -111.7064,
                                78.55693
                            ],
                            [
                                -112.29105,
                                78.54887
                            ],
                            [
                                -113.20596,
                                78.41276
                            ],
                            [
                                -113.30975,
                                78.32939
                            ],
                            [
                                -113.18603,
                                78.27222
                            ],
                            [
                                -112.70342,
                                78.33467
                            ],
                            [
                                -112.16093,
                                78.37406
                            ],
                            [
                                -111.86165,
                                78.33291
                            ],
                            [
                                -111.81014,
                                78.28435
                            ],
                            [
                                -111.44954,
                                78.27169
                            ],
                            [
                                -111.41898,
                                78.32891
                            ],
                            [
                                -111.15029,
                                78.39308
                            ],
                            [
                                -110.66789,
                                78.29608
                            ],
                            [
                                -110.34866,
                                78.27744
                            ],
                            [
                                -109.88307,
                                78.32458
                            ],
                            [
                                -109.77764,
                                78.29923
                            ],
                            [
                                -109.37828,
                                78.31943
                            ],
                            [
                                -109.32516,
                                78.42916
                            ],
                            [
                                -109.21443,
                                78.4807
                            ],
                            [
                                -109.44801,
                                78.59567
                            ],
                            [
                                -109.74427,
                                78.61893
                            ],
                            [
                                -109.85067,
                                78.6715
                            ],
                            [
                                -110.43301,
                                78.7599
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -82.33581,
                                62.97734
                            ],
                            [
                                -82.436,
                                62.92739
                            ],
                            [
                                -82.72691,
                                62.93853
                            ],
                            [
                                -83.01092,
                                62.84567
                            ],
                            [
                                -83.12567,
                                62.85759
                            ],
                            [
                                -83.16909,
                                62.91072
                            ],
                            [
                                -83.30089,
                                62.92954
                            ],
                            [
                                -83.5473,
                                62.82661
                            ],
                            [
                                -83.57835,
                                62.69379
                            ],
                            [
                                -83.75285,
                                62.56228
                            ],
                            [
                                -83.92397,
                                62.49174
                            ],
                            [
                                -83.95905,
                                62.43084
                            ],
                            [
                                -83.75356,
                                62.30775
                            ],
                            [
                                -83.71827,
                                62.13964
                            ],
                            [
                                -83.49085,
                                62.23121
                            ],
                            [
                                -83.31083,
                                62.25726
                            ],
                            [
                                -83.12308,
                                62.17069
                            ],
                            [
                                -82.80374,
                                62.28036
                            ],
                            [
                                -82.66969,
                                62.37024
                            ],
                            [
                                -82.47168,
                                62.44814
                            ],
                            [
                                -82.35447,
                                62.55522
                            ],
                            [
                                -82.14541,
                                62.60319
                            ],
                            [
                                -81.95722,
                                62.70908
                            ],
                            [
                                -81.9685,
                                62.79769
                            ],
                            [
                                -81.86709,
                                62.9148
                            ],
                            [
                                -82.18598,
                                62.98626
                            ],
                            [
                                -82.33581,
                                62.97734
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -64.26618,
                                49.93621
                            ],
                            [
                                -64.46222,
                                49.91315
                            ],
                            [
                                -64.52302,
                                49.86435
                            ],
                            [
                                -64.41861,
                                49.80201
                            ],
                            [
                                -64.33221,
                                49.80866
                            ],
                            [
                                -64.27198,
                                49.75922
                            ],
                            [
                                -63.98308,
                                49.69708
                            ],
                            [
                                -63.82546,
                                49.63624
                            ],
                            [
                                -63.66408,
                                49.53753
                            ],
                            [
                                -63.56244,
                                49.38811
                            ],
                            [
                                -63.28515,
                                49.31823
                            ],
                            [
                                -63.1821,
                                49.25887
                            ],
                            [
                                -62.93071,
                                49.19072
                            ],
                            [
                                -62.76944,
                                49.16008
                            ],
                            [
                                -62.50667,
                                49.13106
                            ],
                            [
                                -62.24885,
                                49.06303
                            ],
                            [
                                -62.08582,
                                49.07533
                            ],
                            [
                                -61.82569,
                                49.06527
                            ],
                            [
                                -61.70381,
                                49.08471
                            ],
                            [
                                -61.67973,
                                49.12521
                            ],
                            [
                                -61.72314,
                                49.19912
                            ],
                            [
                                -61.89727,
                                49.35102
                            ],
                            [
                                -62.24842,
                                49.42579
                            ],
                            [
                                -62.25836,
                                49.45583
                            ],
                            [
                                -62.44086,
                                49.51254
                            ],
                            [
                                -62.48473,
                                49.57015
                            ],
                            [
                                -62.92296,
                                49.70799
                            ],
                            [
                                -63.01589,
                                49.75185
                            ],
                            [
                                -63.37961,
                                49.8263
                            ],
                            [
                                -63.92095,
                                49.88689
                            ],
                            [
                                -63.96846,
                                49.91351
                            ],
                            [
                                -64.149,
                                49.95175
                            ],
                            [
                                -64.26618,
                                49.93621
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -95.46797,
                                77.81387
                            ],
                            [
                                -95.9109,
                                77.76159
                            ],
                            [
                                -96.2582,
                                77.693
                            ],
                            [
                                -96.28281,
                                77.59822
                            ],
                            [
                                -96.06555,
                                77.50013
                            ],
                            [
                                -95.82833,
                                77.46479
                            ],
                            [
                                -95.43231,
                                77.47861
                            ],
                            [
                                -95.23567,
                                77.4607
                            ],
                            [
                                -94.85137,
                                77.48933
                            ],
                            [
                                -93.94529,
                                77.4425
                            ],
                            [
                                -93.573,
                                77.44349
                            ],
                            [
                                -93.46571,
                                77.47516
                            ],
                            [
                                -93.4854,
                                77.5528
                            ],
                            [
                                -93.38489,
                                77.62934
                            ],
                            [
                                -93.08219,
                                77.66408
                            ],
                            [
                                -93.24533,
                                77.737
                            ],
                            [
                                -93.64101,
                                77.78367
                            ],
                            [
                                -93.92357,
                                77.73723
                            ],
                            [
                                -94.97353,
                                77.78847
                            ],
                            [
                                -95.08002,
                                77.75864
                            ],
                            [
                                -95.42137,
                                77.75423
                            ],
                            [
                                -95.46797,
                                77.81387
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -63.99275,
                                46.94928
                            ],
                            [
                                -63.98845,
                                47.03908
                            ],
                            [
                                -64.18233,
                                46.93733
                            ],
                            [
                                -64.26392,
                                46.83027
                            ],
                            [
                                -64.40902,
                                46.70643
                            ],
                            [
                                -64.38257,
                                46.61738
                            ],
                            [
                                -64.19315,
                                46.62806
                            ],
                            [
                                -64.07152,
                                46.55263
                            ],
                            [
                                -64.13197,
                                46.40412
                            ],
                            [
                                -63.99824,
                                46.38654
                            ],
                            [
                                -63.74729,
                                46.39108
                            ],
                            [
                                -63.8059,
                                46.3174
                            ],
                            [
                                -63.70313,
                                46.2748
                            ],
                            [
                                -63.64809,
                                46.22307
                            ],
                            [
                                -63.44921,
                                46.18903
                            ],
                            [
                                -63.2539,
                                46.13139
                            ],
                            [
                                -63.10008,
                                46.19413
                            ],
                            [
                                -62.97801,
                                46.19501
                            ],
                            [
                                -62.88857,
                                46.11039
                            ],
                            [
                                -62.98178,
                                46.07083
                            ],
                            [
                                -62.82853,
                                45.96657
                            ],
                            [
                                -62.74959,
                                45.95526
                            ],
                            [
                                -62.52251,
                                45.97438
                            ],
                            [
                                -62.46683,
                                46.00105
                            ],
                            [
                                -62.45193,
                                46.10038
                            ],
                            [
                                -62.53907,
                                46.12411
                            ],
                            [
                                -62.50771,
                                46.21243
                            ],
                            [
                                -62.36442,
                                46.2794
                            ],
                            [
                                -62.34371,
                                46.33788
                            ],
                            [
                                -62.18362,
                                46.35059
                            ],
                            [
                                -61.98412,
                                46.44376
                            ],
                            [
                                -62.1499,
                                46.48261
                            ],
                            [
                                -62.38698,
                                46.46843
                            ],
                            [
                                -62.62756,
                                46.46639
                            ],
                            [
                                -62.75319,
                                46.44136
                            ],
                            [
                                -63.04522,
                                46.41139
                            ],
                            [
                                -63.13249,
                                46.42893
                            ],
                            [
                                -63.27271,
                                46.42319
                            ],
                            [
                                -63.31443,
                                46.48732
                            ],
                            [
                                -63.42773,
                                46.495
                            ],
                            [
                                -63.62137,
                                46.55837
                            ],
                            [
                                -63.69798,
                                46.55747
                            ],
                            [
                                -63.81177,
                                46.45362
                            ],
                            [
                                -63.88359,
                                46.64068
                            ],
                            [
                                -63.98796,
                                46.72787
                            ],
                            [
                                -64.06522,
                                46.72732
                            ],
                            [
                                -64.07181,
                                46.79779
                            ],
                            [
                                -63.97605,
                                46.88513
                            ],
                            [
                                -63.99275,
                                46.94928
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -79.5579,
                                62.40364
                            ],
                            [
                                -79.95449,
                                62.35976
                            ],
                            [
                                -80.06733,
                                62.23834
                            ],
                            [
                                -80.20875,
                                62.13973
                            ],
                            [
                                -80.26604,
                                62.00266
                            ],
                            [
                                -80.26777,
                                61.90956
                            ],
                            [
                                -80.1954,
                                61.78691
                            ],
                            [
                                -80.12496,
                                61.77755
                            ],
                            [
                                -79.95266,
                                61.6917
                            ],
                            [
                                -79.84775,
                                61.57555
                            ],
                            [
                                -79.68184,
                                61.60865
                            ],
                            [
                                -79.59164,
                                61.70377
                            ],
                            [
                                -79.53122,
                                61.80944
                            ],
                            [
                                -79.44814,
                                61.88083
                            ],
                            [
                                -79.45447,
                                61.94817
                            ],
                            [
                                -79.32408,
                                62.07964
                            ],
                            [
                                -79.26221,
                                62.2364
                            ],
                            [
                                -79.38342,
                                62.30168
                            ],
                            [
                                -79.47094,
                                62.38129
                            ],
                            [
                                -79.5579,
                                62.40364
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -105.99359,
                                77.75962
                            ],
                            [
                                -106.11706,
                                77.73449
                            ],
                            [
                                -105.93037,
                                77.67067
                            ],
                            [
                                -105.76714,
                                77.47655
                            ],
                            [
                                -105.64252,
                                77.37801
                            ],
                            [
                                -105.2704,
                                77.15644
                            ],
                            [
                                -104.98415,
                                77.16516
                            ],
                            [
                                -104.63032,
                                77.1081
                            ],
                            [
                                -104.39362,
                                77.16196
                            ],
                            [
                                -104.34534,
                                77.23681
                            ],
                            [
                                -104.46035,
                                77.32186
                            ],
                            [
                                -104.76626,
                                77.42139
                            ],
                            [
                                -105.01994,
                                77.40924
                            ],
                            [
                                -104.95786,
                                77.49745
                            ],
                            [
                                -105.20553,
                                77.63232
                            ],
                            [
                                -105.71155,
                                77.75753
                            ],
                            [
                                -105.99359,
                                77.75962
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -117.49431,
                                76.04413
                            ],
                            [
                                -117.47606,
                                76.10321
                            ],
                            [
                                -117.78447,
                                76.11609
                            ],
                            [
                                -118.15171,
                                75.97665
                            ],
                            [
                                -118.33988,
                                75.97635
                            ],
                            [
                                -118.71509,
                                75.88947
                            ],
                            [
                                -118.74112,
                                75.85366
                            ],
                            [
                                -119.31266,
                                75.66329
                            ],
                            [
                                -119.40299,
                                75.61871
                            ],
                            [
                                -119.19692,
                                75.57689
                            ],
                            [
                                -118.92999,
                                75.57788
                            ],
                            [
                                -118.71498,
                                75.51827
                            ],
                            [
                                -118.54593,
                                75.5085
                            ],
                            [
                                -118.36202,
                                75.55509
                            ],
                            [
                                -117.79204,
                                75.83696
                            ],
                            [
                                -117.73217,
                                75.91622
                            ],
                            [
                                -117.49431,
                                76.04413
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -90.85523,
                                77.65924
                            ],
                            [
                                -91.22368,
                                77.56718
                            ],
                            [
                                -91.20487,
                                77.39056
                            ],
                            [
                                -91.01081,
                                77.32176
                            ],
                            [
                                -90.67544,
                                77.26199
                            ],
                            [
                                -90.29051,
                                77.23318
                            ],
                            [
                                -90.14065,
                                77.19975
                            ],
                            [
                                -89.89673,
                                77.23136
                            ],
                            [
                                -89.65983,
                                77.31685
                            ],
                            [
                                -89.73841,
                                77.46843
                            ],
                            [
                                -90.05122,
                                77.56687
                            ],
                            [
                                -90.3368,
                                77.62665
                            ],
                            [
                                -90.85523,
                                77.65924
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -134.51057,
                                69.69614
                            ],
                            [
                                -134.42908,
                                69.62222
                            ],
                            [
                                -134.4897,
                                69.53021
                            ],
                            [
                                -134.46791,
                                69.43887
                            ],
                            [
                                -134.81038,
                                69.47582
                            ],
                            [
                                -134.9486,
                                69.46918
                            ],
                            [
                                -135.02566,
                                69.4014
                            ],
                            [
                                -134.94332,
                                69.36237
                            ],
                            [
                                -134.9184,
                                69.26218
                            ],
                            [
                                -134.97995,
                                69.24594
                            ],
                            [
                                -135.01223,
                                69.11228
                            ],
                            [
                                -135.10256,
                                69.08573
                            ],
                            [
                                -134.84278,
                                68.98225
                            ],
                            [
                                -134.72656,
                                68.9942
                            ],
                            [
                                -134.59758,
                                69.08163
                            ],
                            [
                                -134.3797,
                                69.10466
                            ],
                            [
                                -134.20904,
                                69.25815
                            ],
                            [
                                -134.10576,
                                69.27491
                            ],
                            [
                                -134.05548,
                                69.33943
                            ],
                            [
                                -133.87973,
                                69.41422
                            ],
                            [
                                -133.79059,
                                69.48448
                            ],
                            [
                                -133.95522,
                                69.49551
                            ],
                            [
                                -134.0604,
                                69.54095
                            ],
                            [
                                -134.25533,
                                69.55825
                            ],
                            [
                                -134.2362,
                                69.6567
                            ],
                            [
                                -134.51057,
                                69.69614
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -81.42916,
                                53.19392
                            ],
                            [
                                -81.60722,
                                53.19252
                            ],
                            [
                                -81.73677,
                                53.15742
                            ],
                            [
                                -81.89638,
                                53.14947
                            ],
                            [
                                -82.04839,
                                53.0215
                            ],
                            [
                                -81.94427,
                                52.9603
                            ],
                            [
                                -81.76967,
                                52.92791
                            ],
                            [
                                -81.54784,
                                52.86864
                            ],
                            [
                                -81.37623,
                                52.85168
                            ],
                            [
                                -81.19968,
                                52.80865
                            ],
                            [
                                -81.04939,
                                52.74883
                            ],
                            [
                                -80.80694,
                                52.70949
                            ],
                            [
                                -80.71418,
                                52.67051
                            ],
                            [
                                -80.67202,
                                52.7365
                            ],
                            [
                                -80.75982,
                                52.92726
                            ],
                            [
                                -80.82876,
                                53.01226
                            ],
                            [
                                -80.96518,
                                53.11075
                            ],
                            [
                                -81.09405,
                                53.17139
                            ],
                            [
                                -81.30627,
                                53.20885
                            ],
                            [
                                -81.42916,
                                53.19392
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -102.93053,
                                76.31866
                            ],
                            [
                                -103.51009,
                                76.27287
                            ],
                            [
                                -104.28366,
                                76.22799
                            ],
                            [
                                -104.47459,
                                76.16267
                            ],
                            [
                                -104.36252,
                                76.09451
                            ],
                            [
                                -103.97237,
                                76.06962
                            ],
                            [
                                -103.91434,
                                76.04089
                            ],
                            [
                                -103.17719,
                                76.05639
                            ],
                            [
                                -102.66437,
                                76.11856
                            ],
                            [
                                -102.5132,
                                76.22732
                            ],
                            [
                                -102.65858,
                                76.30481
                            ],
                            [
                                -102.93053,
                                76.31866
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -103.7701,
                                75.08646
                            ],
                            [
                                -103.58663,
                                75.16351
                            ],
                            [
                                -103.8723,
                                75.37976
                            ],
                            [
                                -104.10219,
                                75.44627
                            ],
                            [
                                -104.49898,
                                75.41477
                            ],
                            [
                                -104.68622,
                                75.32487
                            ],
                            [
                                -104.78959,
                                75.19404
                            ],
                            [
                                -104.89638,
                                75.15789
                            ],
                            [
                                -104.59372,
                                75.05592
                            ],
                            [
                                -104.16217,
                                75.03753
                            ],
                            [
                                -103.7701,
                                75.08646
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.2648,
                                68.07502
                            ],
                            [
                                -74.19858,
                                68.12021
                            ],
                            [
                                -74.3253,
                                68.18181
                            ],
                            [
                                -74.43898,
                                68.07896
                            ],
                            [
                                -74.71147,
                                68.07904
                            ],
                            [
                                -74.76033,
                                67.96161
                            ],
                            [
                                -74.56626,
                                67.81532
                            ],
                            [
                                -74.31421,
                                67.76288
                            ],
                            [
                                -73.98191,
                                67.78525
                            ],
                            [
                                -73.538,
                                67.75444
                            ],
                            [
                                -73.42628,
                                67.75977
                            ],
                            [
                                -73.33285,
                                67.83928
                            ],
                            [
                                -73.41716,
                                67.92976
                            ],
                            [
                                -73.40489,
                                67.97684
                            ],
                            [
                                -73.55732,
                                68.02665
                            ],
                            [
                                -73.79691,
                                67.99442
                            ],
                            [
                                -74.07651,
                                68.0641
                            ],
                            [
                                -74.2648,
                                68.07502
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -98.74395,
                                79.94783
                            ],
                            [
                                -98.82627,
                                80.07842
                            ],
                            [
                                -99.0814,
                                80.13462
                            ],
                            [
                                -99.37574,
                                80.10909
                            ],
                            [
                                -99.87597,
                                80.0191
                            ],
                            [
                                -100.11711,
                                80.00883
                            ],
                            [
                                -100.16263,
                                79.89626
                            ],
                            [
                                -100.02326,
                                79.87543
                            ],
                            [
                                -99.50297,
                                79.88966
                            ],
                            [
                                -99.28516,
                                79.84187
                            ],
                            [
                                -99.34588,
                                79.7638
                            ],
                            [
                                -98.78733,
                                79.7144
                            ],
                            [
                                -98.62484,
                                79.79049
                            ],
                            [
                                -98.74395,
                                79.94783
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -129.05867,
                                53.30003
                            ],
                            [
                                -129.05258,
                                53.21235
                            ],
                            [
                                -129.09264,
                                53.18578
                            ],
                            [
                                -129.08562,
                                53.0974
                            ],
                            [
                                -129.16913,
                                53.07108
                            ],
                            [
                                -129.19605,
                                52.95336
                            ],
                            [
                                -129.12564,
                                52.90275
                            ],
                            [
                                -129.11225,
                                52.80133
                            ],
                            [
                                -129.05746,
                                52.73588
                            ],
                            [
                                -128.88613,
                                52.65037
                            ],
                            [
                                -128.76675,
                                52.70402
                            ],
                            [
                                -128.752,
                                52.56351
                            ],
                            [
                                -128.82312,
                                52.51827
                            ],
                            [
                                -128.77487,
                                52.44409
                            ],
                            [
                                -128.72936,
                                52.31025
                            ],
                            [
                                -128.63009,
                                52.30947
                            ],
                            [
                                -128.6287,
                                52.45839
                            ],
                            [
                                -128.52638,
                                52.43372
                            ],
                            [
                                -128.46795,
                                52.47725
                            ],
                            [
                                -128.54082,
                                52.66313
                            ],
                            [
                                -128.57414,
                                52.68618
                            ],
                            [
                                -128.52393,
                                52.90339
                            ],
                            [
                                -128.5384,
                                53.02375
                            ],
                            [
                                -128.63242,
                                53.15209
                            ],
                            [
                                -128.6955,
                                53.16187
                            ],
                            [
                                -128.90401,
                                53.2945
                            ],
                            [
                                -129.05867,
                                53.30003
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -104.19019,
                                76.67931
                            ],
                            [
                                -104.66314,
                                76.60244
                            ],
                            [
                                -104.67505,
                                76.56038
                            ],
                            [
                                -104.42471,
                                76.49612
                            ],
                            [
                                -104.3239,
                                76.3285
                            ],
                            [
                                -103.79777,
                                76.31344
                            ],
                            [
                                -103.53979,
                                76.31983
                            ],
                            [
                                -103.18338,
                                76.36198
                            ],
                            [
                                -102.99338,
                                76.4466
                            ],
                            [
                                -103.58859,
                                76.53536
                            ],
                            [
                                -103.75083,
                                76.61351
                            ],
                            [
                                -104.00712,
                                76.67039
                            ],
                            [
                                -104.19019,
                                76.67931
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -114.32105,
                                78.07109
                            ],
                            [
                                -115.10352,
                                77.95619
                            ],
                            [
                                -114.89381,
                                77.86846
                            ],
                            [
                                -114.29739,
                                77.71091
                            ],
                            [
                                -113.93758,
                                77.72649
                            ],
                            [
                                -113.54968,
                                77.82697
                            ],
                            [
                                -113.65368,
                                77.87547
                            ],
                            [
                                -114.22245,
                                77.98993
                            ],
                            [
                                -114.32105,
                                78.07109
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -97.6433,
                                74.04822
                            ],
                            [
                                -97.69424,
                                74.12119
                            ],
                            [
                                -98.01382,
                                74.11176
                            ],
                            [
                                -98.521,
                                74.04198
                            ],
                            [
                                -98.77233,
                                74.03681
                            ],
                            [
                                -99.08291,
                                73.95856
                            ],
                            [
                                -99.42507,
                                73.91271
                            ],
                            [
                                -99.34999,
                                73.86755
                            ],
                            [
                                -99.07662,
                                73.81708
                            ],
                            [
                                -98.72379,
                                73.81859
                            ],
                            [
                                -98.06795,
                                73.89812
                            ],
                            [
                                -97.76683,
                                73.98937
                            ],
                            [
                                -97.6433,
                                74.04822
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -79.21142,
                                56.68442
                            ],
                            [
                                -79.26707,
                                56.67297
                            ],
                            [
                                -79.32943,
                                56.37327
                            ],
                            [
                                -79.39483,
                                56.22411
                            ],
                            [
                                -79.54083,
                                56.19232
                            ],
                            [
                                -79.55517,
                                56.24767
                            ],
                            [
                                -79.74661,
                                56.13442
                            ],
                            [
                                -79.84097,
                                56.03266
                            ],
                            [
                                -80.00258,
                                55.92826
                            ],
                            [
                                -79.90907,
                                55.8401
                            ],
                            [
                                -79.70392,
                                55.97152
                            ],
                            [
                                -79.54647,
                                56.11944
                            ],
                            [
                                -79.46293,
                                56.10149
                            ],
                            [
                                -79.56141,
                                56.00634
                            ],
                            [
                                -79.61318,
                                55.90247
                            ],
                            [
                                -79.49198,
                                55.86038
                            ],
                            [
                                -79.4195,
                                55.90778
                            ],
                            [
                                -79.28594,
                                56.05783
                            ],
                            [
                                -79.22134,
                                56.17036
                            ],
                            [
                                -79.12078,
                                56.22812
                            ],
                            [
                                -79.05092,
                                56.34516
                            ],
                            [
                                -78.96263,
                                56.34924
                            ],
                            [
                                -78.91829,
                                56.4112
                            ],
                            [
                                -79.02352,
                                56.42266
                            ],
                            [
                                -79.11371,
                                56.47389
                            ],
                            [
                                -79.1202,
                                56.52525
                            ],
                            [
                                -79.25852,
                                56.55277
                            ],
                            [
                                -79.21142,
                                56.68442
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -86.59539,
                                68.29188
                            ],
                            [
                                -86.67161,
                                68.30406
                            ],
                            [
                                -86.85464,
                                68.20141
                            ],
                            [
                                -86.88161,
                                68.12863
                            ],
                            [
                                -86.97997,
                                68.07882
                            ],
                            [
                                -86.86734,
                                68.03752
                            ],
                            [
                                -86.84994,
                                67.96887
                            ],
                            [
                                -86.95404,
                                67.9315
                            ],
                            [
                                -86.91383,
                                67.83995
                            ],
                            [
                                -86.79638,
                                67.768
                            ],
                            [
                                -86.58971,
                                67.72507
                            ],
                            [
                                -86.45737,
                                67.7754
                            ],
                            [
                                -86.38893,
                                67.84148
                            ],
                            [
                                -86.34639,
                                67.95251
                            ],
                            [
                                -86.40121,
                                68.01726
                            ],
                            [
                                -86.44665,
                                68.23982
                            ],
                            [
                                -86.59539,
                                68.29188
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -78.51485,
                                69.3834
                            ],
                            [
                                -78.58124,
                                69.38824
                            ],
                            [
                                -78.84841,
                                69.20718
                            ],
                            [
                                -78.84175,
                                69.15045
                            ],
                            [
                                -78.95164,
                                69.10821
                            ],
                            [
                                -79.22066,
                                69.08669
                            ],
                            [
                                -79.38103,
                                68.87487
                            ],
                            [
                                -79.26199,
                                68.83893
                            ],
                            [
                                -78.91437,
                                68.91083
                            ],
                            [
                                -78.72011,
                                68.97406
                            ],
                            [
                                -78.71522,
                                69.01433
                            ],
                            [
                                -78.55266,
                                69.08997
                            ],
                            [
                                -78.54414,
                                69.15045
                            ],
                            [
                                -78.37008,
                                69.20197
                            ],
                            [
                                -78.21022,
                                69.29888
                            ],
                            [
                                -78.29209,
                                69.38189
                            ],
                            [
                                -78.51485,
                                69.3834
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -101.74256,
                                77.90899
                            ],
                            [
                                -102.45627,
                                77.87823
                            ],
                            [
                                -102.52106,
                                77.79551
                            ],
                            [
                                -102.07207,
                                77.68545
                            ],
                            [
                                -101.79802,
                                77.67442
                            ],
                            [
                                -101.51176,
                                77.72848
                            ],
                            [
                                -101.10427,
                                77.71822
                            ],
                            [
                                -100.94078,
                                77.77285
                            ],
                            [
                                -101.25259,
                                77.85479
                            ],
                            [
                                -101.74256,
                                77.90899
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -78.22834,
                                63.48037
                            ],
                            [
                                -78.44889,
                                63.44472
                            ],
                            [
                                -78.50789,
                                63.39069
                            ],
                            [
                                -78.35408,
                                63.32153
                            ],
                            [
                                -78.08581,
                                63.15195
                            ],
                            [
                                -77.94216,
                                63.09263
                            ],
                            [
                                -77.85611,
                                63.09288
                            ],
                            [
                                -77.55385,
                                63.1737
                            ],
                            [
                                -77.49611,
                                63.23714
                            ],
                            [
                                -77.52853,
                                63.30374
                            ],
                            [
                                -77.61698,
                                63.3484
                            ],
                            [
                                -77.66707,
                                63.4229
                            ],
                            [
                                -77.95123,
                                63.46756
                            ],
                            [
                                -78.22834,
                                63.48037
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -79.69528,
                                69.81193
                            ],
                            [
                                -79.87928,
                                69.74322
                            ],
                            [
                                -80.1064,
                                69.74767
                            ],
                            [
                                -80.1795,
                                69.80316
                            ],
                            [
                                -80.47818,
                                69.79206
                            ],
                            [
                                -80.814,
                                69.69535
                            ],
                            [
                                -80.7444,
                                69.66727
                            ],
                            [
                                -80.44702,
                                69.66262
                            ],
                            [
                                -80.2183,
                                69.52966
                            ],
                            [
                                -80.00726,
                                69.4949
                            ],
                            [
                                -79.91037,
                                69.52403
                            ],
                            [
                                -79.92397,
                                69.6125
                            ],
                            [
                                -79.64062,
                                69.61527
                            ],
                            [
                                -79.36413,
                                69.68827
                            ],
                            [
                                -79.32679,
                                69.73521
                            ],
                            [
                                -79.43503,
                                69.80042
                            ],
                            [
                                -79.69528,
                                69.81193
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -90.03063,
                                76.84064
                            ],
                            [
                                -90.44127,
                                76.80528
                            ],
                            [
                                -90.58787,
                                76.72682
                            ],
                            [
                                -90.08411,
                                76.48391
                            ],
                            [
                                -89.67574,
                                76.50818
                            ],
                            [
                                -89.83304,
                                76.54829
                            ],
                            [
                                -89.87537,
                                76.61426
                            ],
                            [
                                -89.688,
                                76.69688
                            ],
                            [
                                -89.73509,
                                76.76352
                            ],
                            [
                                -90.03063,
                                76.84064
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -130.15935,
                                53.8923
                            ],
                            [
                                -130.26016,
                                53.88718
                            ],
                            [
                                -130.28706,
                                53.82494
                            ],
                            [
                                -130.21865,
                                53.80448
                            ],
                            [
                                -130.20108,
                                53.72194
                            ],
                            [
                                -130.10098,
                                53.70423
                            ],
                            [
                                -130.06076,
                                53.60323
                            ],
                            [
                                -129.88118,
                                53.54315
                            ],
                            [
                                -129.90572,
                                53.46316
                            ],
                            [
                                -129.58627,
                                53.21478
                            ],
                            [
                                -129.49059,
                                53.22924
                            ],
                            [
                                -129.50162,
                                53.28527
                            ],
                            [
                                -129.46313,
                                53.36888
                            ],
                            [
                                -129.33911,
                                53.36582
                            ],
                            [
                                -129.70774,
                                53.60163
                            ],
                            [
                                -129.83848,
                                53.71885
                            ],
                            [
                                -130.03646,
                                53.83966
                            ],
                            [
                                -130.15935,
                                53.8923
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -84.40441,
                                66.14284
                            ],
                            [
                                -84.45746,
                                66.06211
                            ],
                            [
                                -84.36633,
                                65.99439
                            ],
                            [
                                -84.15909,
                                65.97209
                            ],
                            [
                                -84.07194,
                                65.79613
                            ],
                            [
                                -83.94229,
                                65.74435
                            ],
                            [
                                -83.79758,
                                65.78277
                            ],
                            [
                                -83.78377,
                                65.69183
                            ],
                            [
                                -83.69839,
                                65.64506
                            ],
                            [
                                -83.53708,
                                65.65713
                            ],
                            [
                                -83.32047,
                                65.61563
                            ],
                            [
                                -83.22037,
                                65.65118
                            ],
                            [
                                -83.3014,
                                65.72577
                            ],
                            [
                                -83.44069,
                                65.72378
                            ],
                            [
                                -83.60975,
                                65.75483
                            ],
                            [
                                -83.72208,
                                65.80705
                            ],
                            [
                                -83.66466,
                                65.85107
                            ],
                            [
                                -83.67646,
                                65.93336
                            ],
                            [
                                -84.09329,
                                66.08206
                            ],
                            [
                                -84.1658,
                                66.08037
                            ],
                            [
                                -84.40441,
                                66.14284
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -114.09154,
                                76.893
                            ],
                            [
                                -114.65712,
                                76.86424
                            ],
                            [
                                -114.81349,
                                76.82099
                            ],
                            [
                                -114.8123,
                                76.75885
                            ],
                            [
                                -114.02122,
                                76.71767
                            ],
                            [
                                -113.60478,
                                76.71448
                            ],
                            [
                                -113.446,
                                76.78169
                            ],
                            [
                                -113.47305,
                                76.83066
                            ],
                            [
                                -113.72533,
                                76.88991
                            ],
                            [
                                -114.09154,
                                76.893
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -65.13234,
                                61.68871
                            ],
                            [
                                -65.39372,
                                61.65841
                            ],
                            [
                                -65.47341,
                                61.59589
                            ],
                            [
                                -65.03052,
                                61.40102
                            ],
                            [
                                -64.95534,
                                61.38786
                            ],
                            [
                                -64.86968,
                                61.31102
                            ],
                            [
                                -64.76786,
                                61.36135
                            ],
                            [
                                -64.65839,
                                61.49216
                            ],
                            [
                                -64.727,
                                61.52617
                            ],
                            [
                                -64.62801,
                                61.59367
                            ],
                            [
                                -64.70726,
                                61.64746
                            ],
                            [
                                -65.01099,
                                61.69257
                            ],
                            [
                                -65.13234,
                                61.68871
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -102.06661,
                                75.96586
                            ],
                            [
                                -102.13778,
                                75.99997
                            ],
                            [
                                -103.06677,
                                75.90183
                            ],
                            [
                                -103.1623,
                                75.83541
                            ],
                            [
                                -103.38469,
                                75.76992
                            ],
                            [
                                -103.21812,
                                75.74833
                            ],
                            [
                                -102.88461,
                                75.75
                            ],
                            [
                                -102.555,
                                75.78144
                            ],
                            [
                                -102.43327,
                                75.87551
                            ],
                            [
                                -102.03283,
                                75.93017
                            ],
                            [
                                -102.06661,
                                75.96586
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -77.13976,
                                69.45044
                            ],
                            [
                                -77.339,
                                69.41553
                            ],
                            [
                                -77.32099,
                                69.34205
                            ],
                            [
                                -77.36763,
                                69.25442
                            ],
                            [
                                -77.27189,
                                69.15284
                            ],
                            [
                                -77.10658,
                                69.12827
                            ],
                            [
                                -76.90208,
                                69.16484
                            ],
                            [
                                -76.91533,
                                69.22006
                            ],
                            [
                                -76.66225,
                                69.3196
                            ],
                            [
                                -76.68492,
                                69.41884
                            ],
                            [
                                -76.95161,
                                69.40521
                            ],
                            [
                                -77.13976,
                                69.45044
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -85.11676,
                                66.02406
                            ],
                            [
                                -85.15628,
                                65.99178
                            ],
                            [
                                -85.1076,
                                65.89129
                            ],
                            [
                                -85.11643,
                                65.76457
                            ],
                            [
                                -85.02377,
                                65.70979
                            ],
                            [
                                -84.8811,
                                65.67258
                            ],
                            [
                                -84.81713,
                                65.58505
                            ],
                            [
                                -84.63588,
                                65.55765
                            ],
                            [
                                -84.55521,
                                65.61973
                            ],
                            [
                                -84.69979,
                                65.82992
                            ],
                            [
                                -84.76626,
                                65.85414
                            ],
                            [
                                -84.82841,
                                65.95483
                            ],
                            [
                                -84.91707,
                                66.01761
                            ],
                            [
                                -85.11676,
                                66.02406
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -75.22574,
                                68.7221
                            ],
                            [
                                -75.39147,
                                68.62771
                            ],
                            [
                                -75.41233,
                                68.53417
                            ],
                            [
                                -75.26153,
                                68.44817
                            ],
                            [
                                -75.00401,
                                68.38149
                            ],
                            [
                                -74.99558,
                                68.34184
                            ],
                            [
                                -74.80483,
                                68.33214
                            ],
                            [
                                -74.77115,
                                68.51909
                            ],
                            [
                                -74.93703,
                                68.57906
                            ],
                            [
                                -74.99492,
                                68.67914
                            ],
                            [
                                -75.22574,
                                68.7221
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -68.22311,
                                60.58627
                            ],
                            [
                                -68.38242,
                                60.37708
                            ],
                            [
                                -68.43614,
                                60.26014
                            ],
                            [
                                -68.32633,
                                60.19915
                            ],
                            [
                                -68.18526,
                                60.23977
                            ],
                            [
                                -67.95732,
                                60.33366
                            ],
                            [
                                -67.85674,
                                60.41026
                            ],
                            [
                                -67.83957,
                                60.49001
                            ],
                            [
                                -67.99767,
                                60.58549
                            ],
                            [
                                -68.22311,
                                60.58627
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -77.28999,
                                63.67902
                            ],
                            [
                                -77.40619,
                                63.66196
                            ],
                            [
                                -77.39925,
                                63.58679
                            ],
                            [
                                -77.22612,
                                63.53984
                            ],
                            [
                                -77.18139,
                                63.49997
                            ],
                            [
                                -76.95241,
                                63.39833
                            ],
                            [
                                -76.71468,
                                63.36353
                            ],
                            [
                                -76.6567,
                                63.4134
                            ],
                            [
                                -76.65796,
                                63.51474
                            ],
                            [
                                -76.78261,
                                63.60524
                            ],
                            [
                                -77.03112,
                                63.67602
                            ],
                            [
                                -77.28999,
                                63.67902
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -102.48495,
                                76.09406
                            ],
                            [
                                -102.83767,
                                76.07544
                            ],
                            [
                                -103.43302,
                                75.99426
                            ],
                            [
                                -103.93219,
                                75.95107
                            ],
                            [
                                -103.67657,
                                75.89634
                            ],
                            [
                                -103.22394,
                                75.92298
                            ],
                            [
                                -102.27136,
                                76.03103
                            ],
                            [
                                -102.48495,
                                76.09406
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -71.16906,
                                62.89603
                            ],
                            [
                                -71.20248,
                                62.86749
                            ],
                            [
                                -70.83353,
                                62.77756
                            ],
                            [
                                -70.79177,
                                62.61613
                            ],
                            [
                                -70.68558,
                                62.55107
                            ],
                            [
                                -70.36959,
                                62.52452
                            ],
                            [
                                -70.17095,
                                62.5793
                            ],
                            [
                                -70.26717,
                                62.65732
                            ],
                            [
                                -70.5071,
                                62.77771
                            ],
                            [
                                -71.16906,
                                62.89603
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -130.49302,
                                53.63208
                            ],
                            [
                                -130.54522,
                                53.55419
                            ],
                            [
                                -130.43238,
                                53.49699
                            ],
                            [
                                -130.28464,
                                53.37933
                            ],
                            [
                                -130.22062,
                                53.37621
                            ],
                            [
                                -130.10299,
                                53.30472
                            ],
                            [
                                -130.09429,
                                53.26827
                            ],
                            [
                                -129.95445,
                                53.16359
                            ],
                            [
                                -129.75466,
                                53.21364
                            ],
                            [
                                -129.80309,
                                53.28944
                            ],
                            [
                                -129.90848,
                                53.39296
                            ],
                            [
                                -130.1063,
                                53.51291
                            ],
                            [
                                -130.24639,
                                53.56895
                            ],
                            [
                                -130.49302,
                                53.63208
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -85.77055,
                                79.07312
                            ],
                            [
                                -86.29032,
                                79.00879
                            ],
                            [
                                -86.47942,
                                78.89692
                            ],
                            [
                                -86.1951,
                                78.89699
                            ],
                            [
                                -85.27978,
                                78.98465
                            ],
                            [
                                -85.32658,
                                79.0608
                            ],
                            [
                                -85.77055,
                                79.07312
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -96.2086,
                                75.63039
                            ],
                            [
                                -96.61289,
                                75.55714
                            ],
                            [
                                -97.01187,
                                75.50384
                            ],
                            [
                                -96.84837,
                                75.37974
                            ],
                            [
                                -96.62506,
                                75.3939
                            ],
                            [
                                -96.4156,
                                75.52749
                            ],
                            [
                                -96.11557,
                                75.47911
                            ],
                            [
                                -95.90767,
                                75.57685
                            ],
                            [
                                -96.2086,
                                75.63039
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -71.94516,
                                71.03666
                            ],
                            [
                                -72.21991,
                                70.88355
                            ],
                            [
                                -72.13667,
                                70.81874
                            ],
                            [
                                -71.63131,
                                70.90617
                            ],
                            [
                                -71.42559,
                                70.91953
                            ],
                            [
                                -71.37673,
                                71.01561
                            ],
                            [
                                -71.83725,
                                71.05199
                            ],
                            [
                                -71.94516,
                                71.03666
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -100.55834,
                                76.76329
                            ],
                            [
                                -100.99358,
                                76.72678
                            ],
                            [
                                -101.16729,
                                76.66419
                            ],
                            [
                                -101.69952,
                                76.59298
                            ],
                            [
                                -101.42904,
                                76.55384
                            ],
                            [
                                -100.78533,
                                76.63403
                            ],
                            [
                                -100.2786,
                                76.73302
                            ],
                            [
                                -100.55834,
                                76.76329
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -79.11366,
                                76.12067
                            ],
                            [
                                -79.12287,
                                76.07816
                            ],
                            [
                                -79.56676,
                                75.94247
                            ],
                            [
                                -79.54723,
                                75.81885
                            ],
                            [
                                -79.12318,
                                75.91858
                            ],
                            [
                                -79.15449,
                                75.9731
                            ],
                            [
                                -78.84369,
                                76.04686
                            ],
                            [
                                -78.79859,
                                76.08856
                            ],
                            [
                                -79.11366,
                                76.12067
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -96.74233,
                                73.11918
                            ],
                            [
                                -96.86612,
                                73.19046
                            ],
                            [
                                -97.03531,
                                73.15044
                            ],
                            [
                                -97.11915,
                                73.09172
                            ],
                            [
                                -97.0801,
                                72.99113
                            ],
                            [
                                -96.98372,
                                72.94059
                            ],
                            [
                                -96.64438,
                                72.94821
                            ],
                            [
                                -96.54184,
                                73.03696
                            ],
                            [
                                -96.62865,
                                73.12409
                            ],
                            [
                                -96.74233,
                                73.11918
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -95.79422,
                                69.6291
                            ],
                            [
                                -95.89836,
                                69.60304
                            ],
                            [
                                -95.9611,
                                69.50663
                            ],
                            [
                                -95.90386,
                                69.4294
                            ],
                            [
                                -95.7207,
                                69.47427
                            ],
                            [
                                -95.81471,
                                69.57443
                            ],
                            [
                                -95.67512,
                                69.56602
                            ],
                            [
                                -95.61041,
                                69.42008
                            ],
                            [
                                -95.70929,
                                69.37484
                            ],
                            [
                                -95.61629,
                                69.33118
                            ],
                            [
                                -95.44892,
                                69.35366
                            ],
                            [
                                -95.37032,
                                69.40774
                            ],
                            [
                                -95.32528,
                                69.51479
                            ],
                            [
                                -95.45978,
                                69.57732
                            ],
                            [
                                -95.79422,
                                69.6291
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -127.23381,
                                52.41204
                            ],
                            [
                                -127.27269,
                                52.43566
                            ],
                            [
                                -127.44413,
                                52.3717
                            ],
                            [
                                -127.45269,
                                52.33305
                            ],
                            [
                                -127.76751,
                                52.24349
                            ],
                            [
                                -127.84413,
                                52.16618
                            ],
                            [
                                -127.89309,
                                52.03992
                            ],
                            [
                                -127.88985,
                                51.95713
                            ],
                            [
                                -127.84292,
                                51.94002
                            ],
                            [
                                -127.71093,
                                51.96734
                            ],
                            [
                                -127.64029,
                                52.13713
                            ],
                            [
                                -127.5768,
                                52.15166
                            ],
                            [
                                -127.43346,
                                52.24251
                            ],
                            [
                                -127.31348,
                                52.26427
                            ],
                            [
                                -127.21635,
                                52.32193
                            ],
                            [
                                -127.23381,
                                52.41204
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -78.12866,
                                69.747
                            ],
                            [
                                -78.3898,
                                69.69451
                            ],
                            [
                                -78.85616,
                                69.49928
                            ],
                            [
                                -78.54464,
                                69.49415
                            ],
                            [
                                -78.25023,
                                69.56734
                            ],
                            [
                                -78.07289,
                                69.58632
                            ],
                            [
                                -77.94341,
                                69.64536
                            ],
                            [
                                -77.98276,
                                69.70586
                            ],
                            [
                                -78.12866,
                                69.747
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -100.50971,
                                69.04403
                            ],
                            [
                                -100.61266,
                                68.99708
                            ],
                            [
                                -100.585,
                                68.91934
                            ],
                            [
                                -100.60712,
                                68.78496
                            ],
                            [
                                -100.43576,
                                68.75728
                            ],
                            [
                                -100.14862,
                                68.80923
                            ],
                            [
                                -100.11322,
                                68.90855
                            ],
                            [
                                -100.26543,
                                68.95866
                            ],
                            [
                                -100.36663,
                                69.04256
                            ],
                            [
                                -100.50971,
                                69.04403
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -87.09939,
                                70.15436
                            ],
                            [
                                -87.11,
                                70.12644
                            ],
                            [
                                -87.37372,
                                70.10206
                            ],
                            [
                                -87.13259,
                                69.99993
                            ],
                            [
                                -86.75293,
                                69.97379
                            ],
                            [
                                -86.48418,
                                69.99243
                            ],
                            [
                                -86.59384,
                                70.11776
                            ],
                            [
                                -86.782,
                                70.0891
                            ],
                            [
                                -87.09939,
                                70.15436
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -94.52301,
                                75.983
                            ],
                            [
                                -94.83685,
                                75.95056
                            ],
                            [
                                -94.81438,
                                75.80095
                            ],
                            [
                                -94.65466,
                                75.75027
                            ],
                            [
                                -94.28888,
                                75.76103
                            ],
                            [
                                -94.45007,
                                75.96988
                            ],
                            [
                                -94.52301,
                                75.983
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -101.914,
                                68.82261
                            ],
                            [
                                -102.03992,
                                68.76993
                            ],
                            [
                                -102.33281,
                                68.69546
                            ],
                            [
                                -102.08976,
                                68.61439
                            ],
                            [
                                -101.96146,
                                68.62354
                            ],
                            [
                                -101.81695,
                                68.59204
                            ],
                            [
                                -101.68797,
                                68.64812
                            ],
                            [
                                -101.67856,
                                68.74844
                            ],
                            [
                                -101.78327,
                                68.80686
                            ],
                            [
                                -101.914,
                                68.82261
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -105.01315,
                                68.57739
                            ],
                            [
                                -104.92986,
                                68.46582
                            ],
                            [
                                -104.56259,
                                68.39681
                            ],
                            [
                                -104.42914,
                                68.42443
                            ],
                            [
                                -104.40198,
                                68.48565
                            ],
                            [
                                -104.59942,
                                68.56924
                            ],
                            [
                                -104.94184,
                                68.596
                            ],
                            [
                                -105.01315,
                                68.57739
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -130.43584,
                                54.09565
                            ],
                            [
                                -130.65865,
                                53.99345
                            ],
                            [
                                -130.5112,
                                53.87149
                            ],
                            [
                                -130.50004,
                                53.83986
                            ],
                            [
                                -130.34567,
                                53.83089
                            ],
                            [
                                -130.23673,
                                53.97747
                            ],
                            [
                                -130.32857,
                                54.06034
                            ],
                            [
                                -130.43584,
                                54.09565
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -96.69862,
                                69.58785
                            ],
                            [
                                -96.54262,
                                69.48522
                            ],
                            [
                                -96.37914,
                                69.45371
                            ],
                            [
                                -96.1855,
                                69.36495
                            ],
                            [
                                -96.05741,
                                69.45902
                            ],
                            [
                                -96.07938,
                                69.54586
                            ],
                            [
                                -96.28887,
                                69.53116
                            ],
                            [
                                -96.38031,
                                69.58077
                            ],
                            [
                                -96.58126,
                                69.56428
                            ],
                            [
                                -96.69862,
                                69.58785
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -64.68941,
                                62.52609
                            ],
                            [
                                -64.71906,
                                62.55653
                            ],
                            [
                                -64.92818,
                                62.47516
                            ],
                            [
                                -64.90745,
                                62.42048
                            ],
                            [
                                -64.74062,
                                62.37979
                            ],
                            [
                                -64.54851,
                                62.36604
                            ],
                            [
                                -64.35723,
                                62.46204
                            ],
                            [
                                -64.50947,
                                62.55085
                            ],
                            [
                                -64.68941,
                                62.52609
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -126.79695,
                                49.88521
                            ],
                            [
                                -126.94652,
                                49.83638
                            ],
                            [
                                -126.93316,
                                49.71523
                            ],
                            [
                                -126.82187,
                                49.61826
                            ],
                            [
                                -126.67438,
                                49.58189
                            ],
                            [
                                -126.61511,
                                49.59925
                            ],
                            [
                                -126.61382,
                                49.66606
                            ],
                            [
                                -126.67185,
                                49.85431
                            ],
                            [
                                -126.72937,
                                49.84526
                            ],
                            [
                                -126.79695,
                                49.88521
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -61.46793,
                                56.94552
                            ],
                            [
                                -61.63163,
                                56.86474
                            ],
                            [
                                -61.64602,
                                56.743
                            ],
                            [
                                -61.62387,
                                56.69131
                            ],
                            [
                                -61.38203,
                                56.62967
                            ],
                            [
                                -61.38032,
                                56.7381
                            ],
                            [
                                -61.44393,
                                56.79295
                            ],
                            [
                                -61.3678,
                                56.85337
                            ],
                            [
                                -61.34783,
                                56.9302
                            ],
                            [
                                -61.46793,
                                56.94552
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -73.17817,
                                71.55864
                            ],
                            [
                                -73.38652,
                                71.5192
                            ],
                            [
                                -73.25759,
                                71.40949
                            ],
                            [
                                -73.26302,
                                71.36297
                            ],
                            [
                                -72.97795,
                                71.31233
                            ],
                            [
                                -73.04195,
                                71.40198
                            ],
                            [
                                -72.83399,
                                71.43444
                            ],
                            [
                                -72.9496,
                                71.51897
                            ],
                            [
                                -73.17817,
                                71.55864
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -95.23837,
                                80.69849
                            ],
                            [
                                -95.6568,
                                80.65808
                            ],
                            [
                                -95.13441,
                                80.6106
                            ],
                            [
                                -94.9761,
                                80.67433
                            ],
                            [
                                -95.23837,
                                80.69849
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -95.68379,
                                74.64734
                            ],
                            [
                                -95.83566,
                                74.58055
                            ],
                            [
                                -95.48353,
                                74.50369
                            ],
                            [
                                -95.22852,
                                74.52036
                            ],
                            [
                                -95.33333,
                                74.59531
                            ],
                            [
                                -95.49709,
                                74.64706
                            ],
                            [
                                -95.68379,
                                74.64734
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -129.11247,
                                52.7412
                            ],
                            [
                                -129.26959,
                                52.82333
                            ],
                            [
                                -129.30187,
                                52.76294
                            ],
                            [
                                -129.1484,
                                52.56257
                            ],
                            [
                                -128.94489,
                                52.47835
                            ],
                            [
                                -128.93074,
                                52.60916
                            ],
                            [
                                -129.11247,
                                52.7412
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -100.67465,
                                70.70004
                            ],
                            [
                                -100.66261,
                                70.58798
                            ],
                            [
                                -100.60344,
                                70.54398
                            ],
                            [
                                -100.35812,
                                70.49007
                            ],
                            [
                                -100.16322,
                                70.5691
                            ],
                            [
                                -100.44921,
                                70.6619
                            ],
                            [
                                -100.67465,
                                70.70004
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -134.98274,
                                69.45412
                            ],
                            [
                                -135.16908,
                                69.45001
                            ],
                            [
                                -135.34271,
                                69.39503
                            ],
                            [
                                -135.27172,
                                69.29683
                            ],
                            [
                                -134.97616,
                                69.28862
                            ],
                            [
                                -134.95373,
                                69.36229
                            ],
                            [
                                -135.02903,
                                69.4017
                            ],
                            [
                                -134.98274,
                                69.45412
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -128.21717,
                                52.78773
                            ],
                            [
                                -128.40468,
                                52.79189
                            ],
                            [
                                -128.44655,
                                52.63415
                            ],
                            [
                                -128.43789,
                                52.55008
                            ],
                            [
                                -128.29452,
                                52.52789
                            ],
                            [
                                -128.1772,
                                52.72336
                            ],
                            [
                                -128.21717,
                                52.78773
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -79.1321,
                                68.36643
                            ],
                            [
                                -79.19352,
                                68.23905
                            ],
                            [
                                -79.0792,
                                68.17751
                            ],
                            [
                                -78.85167,
                                68.24649
                            ],
                            [
                                -78.81365,
                                68.2946
                            ],
                            [
                                -78.93832,
                                68.36046
                            ],
                            [
                                -79.1321,
                                68.36643
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -128.88891,
                                53.70819
                            ],
                            [
                                -128.97281,
                                53.7063
                            ],
                            [
                                -129.17502,
                                53.62697
                            ],
                            [
                                -129.17928,
                                53.41354
                            ],
                            [
                                -129.0881,
                                53.44551
                            ],
                            [
                                -129.10159,
                                53.48843
                            ],
                            [
                                -129.02489,
                                53.55524
                            ],
                            [
                                -128.89446,
                                53.55962
                            ],
                            [
                                -128.85927,
                                53.60802
                            ],
                            [
                                -128.88891,
                                53.70819
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -78.74117,
                                56.42795
                            ],
                            [
                                -78.82517,
                                56.35547
                            ],
                            [
                                -78.81401,
                                56.27177
                            ],
                            [
                                -78.89351,
                                56.1905
                            ],
                            [
                                -78.88333,
                                56.10875
                            ],
                            [
                                -78.67033,
                                56.17205
                            ],
                            [
                                -78.64876,
                                56.26971
                            ],
                            [
                                -78.65096,
                                56.41254
                            ],
                            [
                                -78.74117,
                                56.42795
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -126.29632,
                                50.81921
                            ],
                            [
                                -126.43205,
                                50.80098
                            ],
                            [
                                -126.49686,
                                50.74475
                            ],
                            [
                                -126.58699,
                                50.71203
                            ],
                            [
                                -126.55633,
                                50.64608
                            ],
                            [
                                -126.44792,
                                50.67035
                            ],
                            [
                                -126.27227,
                                50.65632
                            ],
                            [
                                -126.21555,
                                50.77469
                            ],
                            [
                                -126.29632,
                                50.81921
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -91.00289,
                                77.25583
                            ],
                            [
                                -91.27403,
                                77.22946
                            ],
                            [
                                -91.01626,
                                77.14064
                            ],
                            [
                                -90.70207,
                                77.18566
                            ],
                            [
                                -91.00289,
                                77.25583
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -65.18621,
                                61.92856
                            ],
                            [
                                -65.24062,
                                61.8737
                            ],
                            [
                                -65.12018,
                                61.77648
                            ],
                            [
                                -65.00349,
                                61.76194
                            ],
                            [
                                -64.92033,
                                61.71433
                            ],
                            [
                                -64.78319,
                                61.74766
                            ],
                            [
                                -65.02502,
                                61.90869
                            ],
                            [
                                -65.18621,
                                61.92856
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -128.02077,
                                52.06445
                            ],
                            [
                                -128.14142,
                                52.05215
                            ],
                            [
                                -128.20108,
                                51.96394
                            ],
                            [
                                -128.11862,
                                51.83137
                            ],
                            [
                                -128.0538,
                                51.80422
                            ],
                            [
                                -127.97633,
                                51.9169
                            ],
                            [
                                -127.95627,
                                52.0632
                            ],
                            [
                                -128.02077,
                                52.06445
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -64.61651,
                                63.87832
                            ],
                            [
                                -64.89585,
                                63.83579
                            ],
                            [
                                -64.90125,
                                63.79336
                            ],
                            [
                                -64.76246,
                                63.75952
                            ],
                            [
                                -64.6547,
                                63.77506
                            ],
                            [
                                -64.37641,
                                63.68856
                            ],
                            [
                                -64.38128,
                                63.74066
                            ],
                            [
                                -64.59125,
                                63.78207
                            ],
                            [
                                -64.49281,
                                63.83842
                            ],
                            [
                                -64.61651,
                                63.87832
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -67.78333,
                                69.66254
                            ],
                            [
                                -68.06972,
                                69.67103
                            ],
                            [
                                -68.24436,
                                69.59353
                            ],
                            [
                                -67.93314,
                                69.52687
                            ],
                            [
                                -67.78333,
                                69.66254
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -79.53749,
                                56.49055
                            ],
                            [
                                -79.65786,
                                56.36934
                            ],
                            [
                                -79.84993,
                                56.31842
                            ],
                            [
                                -80.04496,
                                56.30388
                            ],
                            [
                                -80.04616,
                                56.17264
                            ],
                            [
                                -79.72078,
                                56.28576
                            ],
                            [
                                -79.63805,
                                56.33607
                            ],
                            [
                                -79.53749,
                                56.49055
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -103.00286,
                                78.2715
                            ],
                            [
                                -103.31154,
                                78.15785
                            ],
                            [
                                -103.05142,
                                78.13146
                            ],
                            [
                                -102.78013,
                                78.20801
                            ],
                            [
                                -103.00286,
                                78.2715
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -64.32246,
                                63.57755
                            ],
                            [
                                -64.35006,
                                63.66828
                            ],
                            [
                                -64.47972,
                                63.60586
                            ],
                            [
                                -64.37646,
                                63.52201
                            ],
                            [
                                -64.34902,
                                63.40347
                            ],
                            [
                                -64.25465,
                                63.35601
                            ],
                            [
                                -64.16876,
                                63.39553
                            ],
                            [
                                -64.32246,
                                63.57755
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -64.68131,
                                60.49154
                            ],
                            [
                                -64.83179,
                                60.48317
                            ],
                            [
                                -64.85713,
                                60.42639
                            ],
                            [
                                -64.76699,
                                60.38097
                            ],
                            [
                                -64.56684,
                                60.33407
                            ],
                            [
                                -64.49383,
                                60.30339
                            ],
                            [
                                -64.43054,
                                60.39335
                            ],
                            [
                                -64.68131,
                                60.49154
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -65.37514,
                                64.66812
                            ],
                            [
                                -65.62382,
                                64.5869
                            ],
                            [
                                -65.67211,
                                64.51748
                            ],
                            [
                                -65.4377,
                                64.51176
                            ],
                            [
                                -65.31309,
                                64.5926
                            ],
                            [
                                -65.19418,
                                64.61836
                            ],
                            [
                                -65.28188,
                                64.68206
                            ],
                            [
                                -65.37514,
                                64.66812
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -97.33454,
                                74.62223
                            ],
                            [
                                -97.4441,
                                74.63014
                            ],
                            [
                                -97.77622,
                                74.4874
                            ],
                            [
                                -97.66395,
                                74.46389
                            ],
                            [
                                -97.37403,
                                74.51474
                            ],
                            [
                                -97.25945,
                                74.59262
                            ],
                            [
                                -97.33454,
                                74.62223
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -85.25836,
                                77.58619
                            ],
                            [
                                -85.2502,
                                77.53187
                            ],
                            [
                                -85.01106,
                                77.46132
                            ],
                            [
                                -84.79772,
                                77.50288
                            ],
                            [
                                -85.00849,
                                77.57701
                            ],
                            [
                                -85.25836,
                                77.58619
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -128.1178,
                                51.66865
                            ],
                            [
                                -128.15457,
                                51.6409
                            ],
                            [
                                -128.08808,
                                51.48407
                            ],
                            [
                                -127.87795,
                                51.4508
                            ],
                            [
                                -127.91655,
                                51.60836
                            ],
                            [
                                -127.95997,
                                51.64573
                            ],
                            [
                                -128.1178,
                                51.66865
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -79.32763,
                                52.01793
                            ],
                            [
                                -79.27699,
                                52.07769
                            ],
                            [
                                -79.36263,
                                52.09447
                            ],
                            [
                                -79.55378,
                                52.013
                            ],
                            [
                                -79.65073,
                                51.99884
                            ],
                            [
                                -79.62691,
                                51.90799
                            ],
                            [
                                -79.46554,
                                51.93234
                            ],
                            [
                                -79.37602,
                                51.92558
                            ],
                            [
                                -79.32212,
                                51.96049
                            ],
                            [
                                -79.32763,
                                52.01793
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -101.29572,
                                69.5855
                            ],
                            [
                                -101.36354,
                                69.54426
                            ],
                            [
                                -101.05963,
                                69.42494
                            ],
                            [
                                -101.04165,
                                69.53875
                            ],
                            [
                                -101.29572,
                                69.5855
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -96.60474,
                                72.78621
                            ],
                            [
                                -96.76855,
                                72.89894
                            ],
                            [
                                -96.98252,
                                72.7689
                            ],
                            [
                                -96.7145,
                                72.72928
                            ],
                            [
                                -96.60474,
                                72.78621
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -130.22946,
                                53.73904
                            ],
                            [
                                -130.29015,
                                53.75251
                            ],
                            [
                                -130.39403,
                                53.70767
                            ],
                            [
                                -130.34855,
                                53.62594
                            ],
                            [
                                -130.12573,
                                53.56155
                            ],
                            [
                                -130.12579,
                                53.69498
                            ],
                            [
                                -130.20131,
                                53.70977
                            ],
                            [
                                -130.22946,
                                53.73904
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -124.61525,
                                49.79272
                            ],
                            [
                                -124.61954,
                                49.72264
                            ],
                            [
                                -124.5232,
                                49.69145
                            ],
                            [
                                -124.43371,
                                49.6206
                            ],
                            [
                                -124.20074,
                                49.52448
                            ],
                            [
                                -124.24581,
                                49.60106
                            ],
                            [
                                -124.35874,
                                49.70929
                            ],
                            [
                                -124.4975,
                                49.73614
                            ],
                            [
                                -124.61525,
                                49.79272
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -90.31722,
                                69.42702
                            ],
                            [
                                -90.49778,
                                69.37848
                            ],
                            [
                                -90.39622,
                                69.27482
                            ],
                            [
                                -90.27456,
                                69.25256
                            ],
                            [
                                -90.14741,
                                69.35274
                            ],
                            [
                                -90.31722,
                                69.42702
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.45662,
                                62.72043
                            ],
                            [
                                -74.4865,
                                62.65362
                            ],
                            [
                                -74.16236,
                                62.59843
                            ],
                            [
                                -73.99036,
                                62.59876
                            ],
                            [
                                -73.98035,
                                62.66064
                            ],
                            [
                                -74.17781,
                                62.68041
                            ],
                            [
                                -74.33895,
                                62.66184
                            ],
                            [
                                -74.45662,
                                62.72043
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.14934,
                                68.38354
                            ],
                            [
                                -74.28046,
                                68.46353
                            ],
                            [
                                -74.40188,
                                68.42929
                            ],
                            [
                                -74.22358,
                                68.25591
                            ],
                            [
                                -74.06916,
                                68.34767
                            ],
                            [
                                -74.14934,
                                68.38354
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -100.13283,
                                69.15945
                            ],
                            [
                                -100.23469,
                                69.04594
                            ],
                            [
                                -100.1324,
                                68.96142
                            ],
                            [
                                -99.97163,
                                69.00616
                            ],
                            [
                                -100.13283,
                                69.15945
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.66066,
                                78.77285
                            ],
                            [
                                -74.59069,
                                78.70013
                            ],
                            [
                                -74.27976,
                                78.67548
                            ],
                            [
                                -74.11796,
                                78.7212
                            ],
                            [
                                -74.66066,
                                78.77285
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -125.26189,
                                50.30744
                            ],
                            [
                                -125.37822,
                                50.2767
                            ],
                            [
                                -125.34929,
                                50.15314
                            ],
                            [
                                -125.19929,
                                50.0257
                            ],
                            [
                                -125.18475,
                                50.13643
                            ],
                            [
                                -125.14186,
                                50.20372
                            ],
                            [
                                -125.26189,
                                50.30744
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -72.76974,
                                71.66091
                            ],
                            [
                                -72.92372,
                                71.6479
                            ],
                            [
                                -72.98891,
                                71.56188
                            ],
                            [
                                -72.7437,
                                71.53704
                            ],
                            [
                                -72.66818,
                                71.59455
                            ],
                            [
                                -72.76974,
                                71.66091
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -90.67255,
                                69.37348
                            ],
                            [
                                -90.77111,
                                69.34543
                            ],
                            [
                                -90.68332,
                                69.25383
                            ],
                            [
                                -90.57667,
                                69.19946
                            ],
                            [
                                -90.44368,
                                69.22563
                            ],
                            [
                                -90.53411,
                                69.34054
                            ],
                            [
                                -90.67255,
                                69.37348
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -77.72821,
                                64.03471
                            ],
                            [
                                -77.92804,
                                64.0218
                            ],
                            [
                                -77.95061,
                                63.9546
                            ],
                            [
                                -77.68763,
                                63.92642
                            ],
                            [
                                -77.56911,
                                63.99558
                            ],
                            [
                                -77.72821,
                                64.03471
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -129.14863,
                                53.12716
                            ],
                            [
                                -129.17379,
                                53.28449
                            ],
                            [
                                -129.25823,
                                53.26807
                            ],
                            [
                                -129.33059,
                                53.21709
                            ],
                            [
                                -129.33317,
                                53.12042
                            ],
                            [
                                -129.28144,
                                53.08468
                            ],
                            [
                                -129.14863,
                                53.12716
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -54.15176,
                                49.75148
                            ],
                            [
                                -54.32251,
                                49.66591
                            ],
                            [
                                -54.31654,
                                49.57779
                            ],
                            [
                                -54.15033,
                                49.60352
                            ],
                            [
                                -54.04151,
                                49.65034
                            ],
                            [
                                -54.0539,
                                49.70539
                            ],
                            [
                                -54.15176,
                                49.75148
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -130.22997,
                                55.00888
                            ],
                            [
                                -130.27735,
                                54.95275
                            ],
                            [
                                -130.48769,
                                54.82758
                            ],
                            [
                                -130.4191,
                                54.77004
                            ],
                            [
                                -130.27662,
                                54.83546
                            ],
                            [
                                -130.15499,
                                54.95624
                            ],
                            [
                                -130.22997,
                                55.00888
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -53.87233,
                                48.16175
                            ],
                            [
                                -53.85657,
                                48.09067
                            ],
                            [
                                -53.55181,
                                48.09252
                            ],
                            [
                                -53.52944,
                                48.19838
                            ],
                            [
                                -53.69244,
                                48.14648
                            ],
                            [
                                -53.7797,
                                48.17832
                            ],
                            [
                                -53.87233,
                                48.16175
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -104.1703,
                                77.17272
                            ],
                            [
                                -104.39578,
                                77.13001
                            ],
                            [
                                -104.21292,
                                77.08004
                            ],
                            [
                                -103.96042,
                                77.1405
                            ],
                            [
                                -104.1703,
                                77.17272
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -128.92737,
                                53.35163
                            ],
                            [
                                -128.9204,
                                53.39667
                            ],
                            [
                                -128.99569,
                                53.48325
                            ],
                            [
                                -129.11157,
                                53.40358
                            ],
                            [
                                -129.15258,
                                53.33754
                            ],
                            [
                                -128.92737,
                                53.35163
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -79.80685,
                                56.95582
                            ],
                            [
                                -79.86965,
                                56.94281
                            ],
                            [
                                -79.97485,
                                56.81457
                            ],
                            [
                                -79.96291,
                                56.76529
                            ],
                            [
                                -79.80857,
                                56.82252
                            ],
                            [
                                -79.73924,
                                56.80852
                            ],
                            [
                                -79.80685,
                                56.95582
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -63.84908,
                                67.58191
                            ],
                            [
                                -64.04403,
                                67.54308
                            ],
                            [
                                -63.99987,
                                67.48632
                            ],
                            [
                                -63.74989,
                                67.49861
                            ],
                            [
                                -63.84908,
                                67.58191
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -108.00022,
                                73.61358
                            ],
                            [
                                -107.83978,
                                73.54372
                            ],
                            [
                                -107.56033,
                                73.58091
                            ],
                            [
                                -107.59596,
                                73.61624
                            ],
                            [
                                -108.00022,
                                73.61358
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -69.27307,
                                59.15262
                            ],
                            [
                                -69.34633,
                                59.12662
                            ],
                            [
                                -69.27464,
                                59.07326
                            ],
                            [
                                -69.30571,
                                58.99824
                            ],
                            [
                                -69.23469,
                                58.95396
                            ],
                            [
                                -69.11965,
                                59.06403
                            ],
                            [
                                -69.16418,
                                59.14255
                            ],
                            [
                                -69.27307,
                                59.15262
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.51568,
                                68.57014
                            ],
                            [
                                -74.65718,
                                68.61108
                            ],
                            [
                                -74.63831,
                                68.65821
                            ],
                            [
                                -74.80458,
                                68.67146
                            ],
                            [
                                -74.89011,
                                68.61835
                            ],
                            [
                                -74.81706,
                                68.56814
                            ],
                            [
                                -74.51568,
                                68.57014
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -100.35314,
                                75.62808
                            ],
                            [
                                -100.98333,
                                75.56924
                            ],
                            [
                                -100.86421,
                                75.54756
                            ],
                            [
                                -100.31953,
                                75.59685
                            ],
                            [
                                -100.35314,
                                75.62808
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -61.07148,
                                56.16425
                            ],
                            [
                                -61.1503,
                                56.1485
                            ],
                            [
                                -61.23616,
                                56.07522
                            ],
                            [
                                -61.20254,
                                56.04364
                            ],
                            [
                                -61.04764,
                                56.01076
                            ],
                            [
                                -60.95459,
                                56.09788
                            ],
                            [
                                -61.07148,
                                56.16425
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -78.72975,
                                68.56604
                            ],
                            [
                                -78.82735,
                                68.56259
                            ],
                            [
                                -78.95839,
                                68.48314
                            ],
                            [
                                -78.71433,
                                68.45769
                            ],
                            [
                                -78.61801,
                                68.51346
                            ],
                            [
                                -78.72975,
                                68.56604
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -78.89273,
                                68.65574
                            ],
                            [
                                -78.56579,
                                68.55514
                            ],
                            [
                                -78.47328,
                                68.62774
                            ],
                            [
                                -78.6866,
                                68.6663
                            ],
                            [
                                -78.89273,
                                68.65574
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -61.61101,
                                56.54785
                            ],
                            [
                                -61.6218,
                                56.46433
                            ],
                            [
                                -61.50931,
                                56.44165
                            ],
                            [
                                -61.30403,
                                56.47691
                            ],
                            [
                                -61.33116,
                                56.51868
                            ],
                            [
                                -61.61101,
                                56.54785
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -107.92532,
                                67.615
                            ],
                            [
                                -108.10102,
                                67.66793
                            ],
                            [
                                -108.09848,
                                67.55213
                            ],
                            [
                                -107.90161,
                                67.54882
                            ],
                            [
                                -107.92532,
                                67.615
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -83.23751,
                                66.35265
                            ],
                            [
                                -83.2706,
                                66.25701
                            ],
                            [
                                -83.04372,
                                66.25711
                            ],
                            [
                                -83.23751,
                                66.35265
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -94.35056,
                                78.16208
                            ],
                            [
                                -94.4319,
                                78.2609
                            ],
                            [
                                -94.681,
                                78.25295
                            ],
                            [
                                -94.35056,
                                78.16208
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -138.98851,
                                69.62631
                            ],
                            [
                                -139.13871,
                                69.63601
                            ],
                            [
                                -139.24376,
                                69.592
                            ],
                            [
                                -139.09362,
                                69.5208
                            ],
                            [
                                -138.90324,
                                69.60515
                            ],
                            [
                                -138.98851,
                                69.62631
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -66.24753,
                                68.23789
                            ],
                            [
                                -66.514,
                                68.23039
                            ],
                            [
                                -66.65601,
                                68.18366
                            ],
                            [
                                -66.35694,
                                68.15207
                            ],
                            [
                                -66.26405,
                                68.17267
                            ],
                            [
                                -66.24753,
                                68.23789
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -61.94185,
                                57.55533
                            ],
                            [
                                -62.04524,
                                57.54731
                            ],
                            [
                                -61.9759,
                                57.45968
                            ],
                            [
                                -61.86955,
                                57.46019
                            ],
                            [
                                -61.78699,
                                57.55103
                            ],
                            [
                                -61.89461,
                                57.59091
                            ],
                            [
                                -61.94185,
                                57.55533
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -136.11204,
                                69.00429
                            ],
                            [
                                -136.01925,
                                68.93375
                            ],
                            [
                                -135.76951,
                                68.87974
                            ],
                            [
                                -135.65965,
                                68.89766
                            ],
                            [
                                -135.85039,
                                68.98018
                            ],
                            [
                                -136.11204,
                                69.00429
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -54.63963,
                                49.63996
                            ],
                            [
                                -54.68731,
                                49.58141
                            ],
                            [
                                -54.88257,
                                49.48296
                            ],
                            [
                                -54.75665,
                                49.48976
                            ],
                            [
                                -54.75119,
                                49.52366
                            ],
                            [
                                -54.62567,
                                49.54434
                            ],
                            [
                                -54.55929,
                                49.57857
                            ],
                            [
                                -54.55724,
                                49.64658
                            ],
                            [
                                -54.63963,
                                49.63996
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -89.94111,
                                68.83862
                            ],
                            [
                                -90.03596,
                                68.76384
                            ],
                            [
                                -89.95572,
                                68.68229
                            ],
                            [
                                -89.84456,
                                68.70017
                            ],
                            [
                                -89.78492,
                                68.76262
                            ],
                            [
                                -89.94111,
                                68.83862
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -126.84365,
                                50.88568
                            ],
                            [
                                -126.91815,
                                50.82616
                            ],
                            [
                                -126.84474,
                                50.7859
                            ],
                            [
                                -126.73324,
                                50.7688
                            ],
                            [
                                -126.61313,
                                50.80205
                            ],
                            [
                                -126.60966,
                                50.84219
                            ],
                            [
                                -126.76224,
                                50.84508
                            ],
                            [
                                -126.84365,
                                50.88568
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -62.32692,
                                65.72556
                            ],
                            [
                                -62.44472,
                                65.7374
                            ],
                            [
                                -62.47105,
                                65.65033
                            ],
                            [
                                -62.14231,
                                65.66176
                            ],
                            [
                                -62.32692,
                                65.72556
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -63.5823,
                                67.34948
                            ],
                            [
                                -63.67385,
                                67.34834
                            ],
                            [
                                -63.81576,
                                67.28685
                            ],
                            [
                                -63.46135,
                                67.26775
                            ],
                            [
                                -63.36681,
                                67.2993
                            ],
                            [
                                -63.5823,
                                67.34948
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -131.45176,
                                52.69045
                            ],
                            [
                                -131.49094,
                                52.73729
                            ],
                            [
                                -131.59063,
                                52.70588
                            ],
                            [
                                -131.72774,
                                52.70673
                            ],
                            [
                                -131.58786,
                                52.58155
                            ],
                            [
                                -131.46499,
                                52.62573
                            ],
                            [
                                -131.45176,
                                52.69045
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -129.54453,
                                53.17335
                            ],
                            [
                                -129.42625,
                                53.0116
                            ],
                            [
                                -129.30057,
                                52.97419
                            ],
                            [
                                -129.31684,
                                53.04516
                            ],
                            [
                                -129.39253,
                                53.08938
                            ],
                            [
                                -129.488,
                                53.18648
                            ],
                            [
                                -129.54453,
                                53.17335
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -110.76172,
                                68.54991
                            ],
                            [
                                -111.02089,
                                68.51738
                            ],
                            [
                                -110.9176,
                                68.46869
                            ],
                            [
                                -110.676,
                                68.49072
                            ],
                            [
                                -110.76172,
                                68.54991
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -123.59111,
                                48.94174
                            ],
                            [
                                -123.55036,
                                48.8665
                            ],
                            [
                                -123.56135,
                                48.76434
                            ],
                            [
                                -123.49784,
                                48.71557
                            ],
                            [
                                -123.36868,
                                48.77379
                            ],
                            [
                                -123.44722,
                                48.86121
                            ],
                            [
                                -123.59111,
                                48.94174
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -70.84556,
                                47.02391
                            ],
                            [
                                -70.93138,
                                46.99961
                            ],
                            [
                                -71.11946,
                                46.87577
                            ],
                            [
                                -71.00513,
                                46.85878
                            ],
                            [
                                -70.8907,
                                46.91907
                            ],
                            [
                                -70.8097,
                                46.99813
                            ],
                            [
                                -70.84556,
                                47.02391
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -135.53105,
                                69.00857
                            ],
                            [
                                -135.81401,
                                68.97239
                            ],
                            [
                                -135.64017,
                                68.89463
                            ],
                            [
                                -135.44729,
                                68.97943
                            ],
                            [
                                -135.53105,
                                69.00857
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -124.91069,
                                50.30453
                            ],
                            [
                                -124.97928,
                                50.24927
                            ],
                            [
                                -124.81036,
                                50.11445
                            ],
                            [
                                -124.75172,
                                50.15932
                            ],
                            [
                                -124.85287,
                                50.28609
                            ],
                            [
                                -124.91069,
                                50.30453
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -79.06409,
                                54.91916
                            ],
                            [
                                -79.10925,
                                54.92708
                            ],
                            [
                                -79.4381,
                                54.88255
                            ],
                            [
                                -79.66553,
                                54.83719
                            ],
                            [
                                -79.62358,
                                54.81281
                            ],
                            [
                                -79.37703,
                                54.84182
                            ],
                            [
                                -79.06409,
                                54.91916
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -130.93812,
                                54.60809
                            ],
                            [
                                -130.96935,
                                54.55061
                            ],
                            [
                                -130.95418,
                                54.45945
                            ],
                            [
                                -130.77656,
                                54.55201
                            ],
                            [
                                -130.75279,
                                54.60129
                            ],
                            [
                                -130.93812,
                                54.60809
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -95.55495,
                                77.24729
                            ],
                            [
                                -95.31728,
                                77.16438
                            ],
                            [
                                -95.19067,
                                77.20483
                            ],
                            [
                                -95.55495,
                                77.24729
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -79.99955,
                                53.23671
                            ],
                            [
                                -79.93349,
                                53.26109
                            ],
                            [
                                -79.95527,
                                53.31858
                            ],
                            [
                                -79.89951,
                                53.35804
                            ],
                            [
                                -80.00917,
                                53.39288
                            ],
                            [
                                -80.09717,
                                53.34694
                            ],
                            [
                                -80.05626,
                                53.23169
                            ],
                            [
                                -79.99955,
                                53.23671
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -78.28035,
                                60.81739
                            ],
                            [
                                -78.37621,
                                60.81744
                            ],
                            [
                                -78.6009,
                                60.77543
                            ],
                            [
                                -78.59008,
                                60.7095
                            ],
                            [
                                -78.28134,
                                60.78713
                            ],
                            [
                                -78.28035,
                                60.81739
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -109.14647,
                                67.98121
                            ],
                            [
                                -108.95323,
                                67.85105
                            ],
                            [
                                -108.84465,
                                67.90808
                            ],
                            [
                                -108.8667,
                                67.96515
                            ],
                            [
                                -109.14647,
                                67.98121
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -125.24772,
                                50.42477
                            ],
                            [
                                -125.40661,
                                50.34157
                            ],
                            [
                                -125.39341,
                                50.29471
                            ],
                            [
                                -125.2663,
                                50.3264
                            ],
                            [
                                -125.21631,
                                50.29955
                            ],
                            [
                                -125.13333,
                                50.33189
                            ],
                            [
                                -125.16601,
                                50.38752
                            ],
                            [
                                -125.24772,
                                50.42477
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -64.09492,
                                59.85379
                            ],
                            [
                                -64.18776,
                                59.74214
                            ],
                            [
                                -64.15814,
                                59.70223
                            ],
                            [
                                -64.01931,
                                59.71487
                            ],
                            [
                                -63.95428,
                                59.76499
                            ],
                            [
                                -64.09492,
                                59.85379
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -78.78197,
                                72.39001
                            ],
                            [
                                -78.9856,
                                72.44553
                            ],
                            [
                                -79.08585,
                                72.41912
                            ],
                            [
                                -78.93893,
                                72.34058
                            ],
                            [
                                -78.78197,
                                72.39001
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -61.77796,
                                57.50534
                            ],
                            [
                                -61.87058,
                                57.45183
                            ],
                            [
                                -61.84352,
                                57.40936
                            ],
                            [
                                -61.70105,
                                57.44326
                            ],
                            [
                                -61.6553,
                                57.52768
                            ],
                            [
                                -61.77796,
                                57.50534
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -82.86613,
                                69.80717
                            ],
                            [
                                -82.84869,
                                69.77988
                            ],
                            [
                                -82.49222,
                                69.71437
                            ],
                            [
                                -82.46139,
                                69.77399
                            ],
                            [
                                -82.86613,
                                69.80717
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -61.79335,
                                57.84699
                            ],
                            [
                                -61.86724,
                                57.82389
                            ],
                            [
                                -61.90888,
                                57.75897
                            ],
                            [
                                -61.69305,
                                57.70928
                            ],
                            [
                                -61.65679,
                                57.78531
                            ],
                            [
                                -61.79335,
                                57.84699
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -61.78262,
                                56.40537
                            ],
                            [
                                -61.72725,
                                56.3627
                            ],
                            [
                                -61.55379,
                                56.32086
                            ],
                            [
                                -61.42755,
                                56.31999
                            ],
                            [
                                -61.42799,
                                56.38211
                            ],
                            [
                                -61.65236,
                                56.40849
                            ],
                            [
                                -61.78262,
                                56.40537
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -61.9966,
                                57.91506
                            ],
                            [
                                -62.13746,
                                57.82528
                            ],
                            [
                                -61.96721,
                                57.78624
                            ],
                            [
                                -61.87789,
                                57.84621
                            ],
                            [
                                -61.9966,
                                57.91506
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -126.31685,
                                50.58944
                            ],
                            [
                                -126.47999,
                                50.55651
                            ],
                            [
                                -126.42461,
                                50.51457
                            ],
                            [
                                -126.24735,
                                50.54011
                            ],
                            [
                                -126.31685,
                                50.58944
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -107.61296,
                                67.218
                            ],
                            [
                                -107.56267,
                                67.12101
                            ],
                            [
                                -107.41335,
                                67.1286
                            ],
                            [
                                -107.61296,
                                67.218
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -126.15548,
                                49.38886
                            ],
                            [
                                -126.22742,
                                49.37548
                            ],
                            [
                                -126.22886,
                                49.28429
                            ],
                            [
                                -126.05627,
                                49.2622
                            ],
                            [
                                -126.10088,
                                49.38903
                            ],
                            [
                                -126.15548,
                                49.38886
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -101.55397,
                                69.2288
                            ],
                            [
                                -101.70146,
                                69.18651
                            ],
                            [
                                -101.55329,
                                69.09772
                            ],
                            [
                                -101.47752,
                                69.16134
                            ],
                            [
                                -101.55397,
                                69.2288
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -83.87911,
                                69.81451
                            ],
                            [
                                -83.8742,
                                69.7648
                            ],
                            [
                                -83.62579,
                                69.76798
                            ],
                            [
                                -83.59038,
                                69.80238
                            ],
                            [
                                -83.87911,
                                69.81451
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -64.93414,
                                63.55321
                            ],
                            [
                                -65.04642,
                                63.52839
                            ],
                            [
                                -64.9251,
                                63.41755
                            ],
                            [
                                -64.82039,
                                63.39496
                            ],
                            [
                                -64.88275,
                                63.53112
                            ],
                            [
                                -64.93414,
                                63.55321
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -69.85127,
                                66.43255
                            ],
                            [
                                -70.02202,
                                66.38154
                            ],
                            [
                                -69.77604,
                                66.3589
                            ],
                            [
                                -69.85127,
                                66.43255
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -64.64951,
                                47.87782
                            ],
                            [
                                -64.70709,
                                47.82838
                            ],
                            [
                                -64.5778,
                                47.769
                            ],
                            [
                                -64.50715,
                                47.85029
                            ],
                            [
                                -64.64951,
                                47.87782
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -128.18572,
                                52.20877
                            ],
                            [
                                -128.29248,
                                52.11419
                            ],
                            [
                                -128.13786,
                                52.0873
                            ],
                            [
                                -128.13673,
                                52.20158
                            ],
                            [
                                -128.18572,
                                52.20877
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -128.43955,
                                52.2252
                            ],
                            [
                                -128.48698,
                                52.15213
                            ],
                            [
                                -128.27942,
                                52.15669
                            ],
                            [
                                -128.28221,
                                52.23569
                            ],
                            [
                                -128.43955,
                                52.2252
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -129.756,
                                53.12789
                            ],
                            [
                                -129.73151,
                                53.07808
                            ],
                            [
                                -129.63548,
                                53.02504
                            ],
                            [
                                -129.53438,
                                53.02316
                            ],
                            [
                                -129.68521,
                                53.13456
                            ],
                            [
                                -129.756,
                                53.12789
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -79.53032,
                                72.44534
                            ],
                            [
                                -79.66682,
                                72.43177
                            ],
                            [
                                -79.53673,
                                72.34724
                            ],
                            [
                                -79.41373,
                                72.37876
                            ],
                            [
                                -79.53032,
                                72.44534
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -65.0116,
                                64.3482
                            ],
                            [
                                -65.06987,
                                64.24799
                            ],
                            [
                                -64.98095,
                                64.19228
                            ],
                            [
                                -64.89836,
                                64.27174
                            ],
                            [
                                -65.0116,
                                64.3482
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -66.97194,
                                66.4104
                            ],
                            [
                                -66.83351,
                                66.36277
                            ],
                            [
                                -66.842,
                                66.3259
                            ],
                            [
                                -66.67463,
                                66.29745
                            ],
                            [
                                -66.56743,
                                66.31984
                            ],
                            [
                                -66.83474,
                                66.40122
                            ],
                            [
                                -66.97194,
                                66.4104
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -95.30623,
                                71.84636
                            ],
                            [
                                -95.43482,
                                71.81929
                            ],
                            [
                                -95.42648,
                                71.74357
                            ],
                            [
                                -95.28729,
                                71.74053
                            ],
                            [
                                -95.30623,
                                71.84636
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -124.96001,
                                50.2063
                            ],
                            [
                                -125.06713,
                                50.11391
                            ],
                            [
                                -124.95798,
                                50.045
                            ],
                            [
                                -124.88805,
                                50.07651
                            ],
                            [
                                -124.89693,
                                50.14088
                            ],
                            [
                                -124.96001,
                                50.2063
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -127.88705,
                                52.17131
                            ],
                            [
                                -127.92324,
                                52.15793
                            ],
                            [
                                -128.00582,
                                52.16923
                            ],
                            [
                                -128.13396,
                                52.14777
                            ],
                            [
                                -128.11229,
                                52.10031
                            ],
                            [
                                -127.94245,
                                52.0775
                            ],
                            [
                                -127.88705,
                                52.17131
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -70.46492,
                                66.72509
                            ],
                            [
                                -70.54385,
                                66.67464
                            ],
                            [
                                -70.33006,
                                66.63922
                            ],
                            [
                                -70.29349,
                                66.66262
                            ],
                            [
                                -70.37792,
                                66.72396
                            ],
                            [
                                -70.46492,
                                66.72509
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -93.06477,
                                61.92758
                            ],
                            [
                                -93.15111,
                                61.87746
                            ],
                            [
                                -93.11276,
                                61.83336
                            ],
                            [
                                -92.98697,
                                61.8532
                            ],
                            [
                                -93.06477,
                                61.92758
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -66.79292,
                                44.79257
                            ],
                            [
                                -66.88978,
                                44.66133
                            ],
                            [
                                -66.75672,
                                44.66164
                            ],
                            [
                                -66.73868,
                                44.71754
                            ],
                            [
                                -66.79292,
                                44.79257
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -97.38994,
                                67.7344
                            ],
                            [
                                -97.50041,
                                67.68291
                            ],
                            [
                                -97.3794,
                                67.64086
                            ],
                            [
                                -97.27332,
                                67.69006
                            ],
                            [
                                -97.38994,
                                67.7344
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -127.96828,
                                52.30222
                            ],
                            [
                                -128.09409,
                                52.20217
                            ],
                            [
                                -128.03996,
                                52.17631
                            ],
                            [
                                -127.91854,
                                52.16524
                            ],
                            [
                                -127.91776,
                                52.25147
                            ],
                            [
                                -127.96828,
                                52.30222
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -54.14289,
                                47.58265
                            ],
                            [
                                -54.27056,
                                47.46604
                            ],
                            [
                                -54.24363,
                                47.40478
                            ],
                            [
                                -54.14289,
                                47.58265
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -80.04115,
                                59.87116
                            ],
                            [
                                -80.14191,
                                59.82124
                            ],
                            [
                                -80.05993,
                                59.76658
                            ],
                            [
                                -79.9328,
                                59.84281
                            ],
                            [
                                -80.04115,
                                59.87116
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -107.84722,
                                68.10442
                            ],
                            [
                                -107.84716,
                                68.02556
                            ],
                            [
                                -107.89365,
                                67.9984
                            ],
                            [
                                -107.79877,
                                67.98888
                            ],
                            [
                                -107.7959,
                                68.02021
                            ],
                            [
                                -107.67956,
                                68.03501
                            ],
                            [
                                -107.71901,
                                68.05361
                            ],
                            [
                                -107.68342,
                                68.07674
                            ],
                            [
                                -107.75687,
                                68.08238
                            ],
                            [
                                -107.84722,
                                68.10442
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -108.09183,
                                67.88006
                            ],
                            [
                                -108.01937,
                                67.96295
                            ],
                            [
                                -108.14182,
                                67.97393
                            ],
                            [
                                -108.22265,
                                67.92706
                            ],
                            [
                                -108.09183,
                                67.88006
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -125.3958,
                                50.45757
                            ],
                            [
                                -125.49178,
                                50.41411
                            ],
                            [
                                -125.51119,
                                50.37082
                            ],
                            [
                                -125.38494,
                                50.36635
                            ],
                            [
                                -125.32553,
                                50.42311
                            ],
                            [
                                -125.3958,
                                50.45757
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -130.44741,
                                54.75759
                            ],
                            [
                                -130.49282,
                                54.82452
                            ],
                            [
                                -130.63237,
                                54.75369
                            ],
                            [
                                -130.53787,
                                54.70303
                            ],
                            [
                                -130.44741,
                                54.75759
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -73.23987,
                                71.69345
                            ],
                            [
                                -73.43778,
                                71.59569
                            ],
                            [
                                -73.32465,
                                71.56739
                            ],
                            [
                                -73.23987,
                                71.69345
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -60.97098,
                                45.59183
                            ],
                            [
                                -61.09786,
                                45.57271
                            ],
                            [
                                -61.06657,
                                45.50849
                            ],
                            [
                                -60.96907,
                                45.4968
                            ],
                            [
                                -60.97098,
                                45.59183
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -124.05749,
                                49.77489
                            ],
                            [
                                -124.15126,
                                49.7545
                            ],
                            [
                                -124.19871,
                                49.67116
                            ],
                            [
                                -124.09331,
                                49.64695
                            ],
                            [
                                -124.05749,
                                49.77489
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -55.95182,
                                53.4862
                            ],
                            [
                                -55.98043,
                                53.44064
                            ],
                            [
                                -55.78459,
                                53.40329
                            ],
                            [
                                -55.8322,
                                53.47531
                            ],
                            [
                                -55.95182,
                                53.4862
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -130.74063,
                                54.1941
                            ],
                            [
                                -130.8021,
                                54.14506
                            ],
                            [
                                -130.57522,
                                54.08289
                            ],
                            [
                                -130.74063,
                                54.1941
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -128.34552,
                                52.47219
                            ],
                            [
                                -128.39927,
                                52.458
                            ],
                            [
                                -128.45598,
                                52.36276
                            ],
                            [
                                -128.3824,
                                52.36347
                            ],
                            [
                                -128.28868,
                                52.41727
                            ],
                            [
                                -128.34552,
                                52.47219
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -124.77627,
                                50.28867
                            ],
                            [
                                -124.81184,
                                50.24028
                            ],
                            [
                                -124.69889,
                                50.16548
                            ],
                            [
                                -124.64949,
                                50.20809
                            ],
                            [
                                -124.6639,
                                50.27326
                            ],
                            [
                                -124.77627,
                                50.28867
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -67.62432,
                                58.40464
                            ],
                            [
                                -67.67152,
                                58.30277
                            ],
                            [
                                -67.51232,
                                58.32288
                            ],
                            [
                                -67.49401,
                                58.38427
                            ],
                            [
                                -67.62432,
                                58.40464
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -128.11462,
                                52.42887
                            ],
                            [
                                -128.19425,
                                52.31541
                            ],
                            [
                                -128.15974,
                                52.27452
                            ],
                            [
                                -128.04756,
                                52.32041
                            ],
                            [
                                -128.11462,
                                52.42887
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -128.45686,
                                52.79012
                            ],
                            [
                                -128.5179,
                                52.86849
                            ],
                            [
                                -128.54902,
                                52.69394
                            ],
                            [
                                -128.47599,
                                52.70432
                            ],
                            [
                                -128.45686,
                                52.79012
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -55.50966,
                                50.79291
                            ],
                            [
                                -55.63176,
                                50.7475
                            ],
                            [
                                -55.58572,
                                50.69295
                            ],
                            [
                                -55.51647,
                                50.72142
                            ],
                            [
                                -55.50966,
                                50.79291
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -55.96071,
                                47.6917
                            ],
                            [
                                -56.10058,
                                47.66153
                            ],
                            [
                                -56.10155,
                                47.63114
                            ],
                            [
                                -55.91124,
                                47.5991
                            ],
                            [
                                -55.96071,
                                47.6917
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -65.80026,
                                61.85942
                            ],
                            [
                                -65.76212,
                                61.76448
                            ],
                            [
                                -65.6668,
                                61.80387
                            ],
                            [
                                -65.80026,
                                61.85942
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -79.5774,
                                56.79231
                            ],
                            [
                                -79.55414,
                                56.64355
                            ],
                            [
                                -79.49402,
                                56.66114
                            ],
                            [
                                -79.50196,
                                56.7492
                            ],
                            [
                                -79.5774,
                                56.79231
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -79.89835,
                                53.15682
                            ],
                            [
                                -79.88958,
                                53.06974
                            ],
                            [
                                -79.795,
                                53.0859
                            ],
                            [
                                -79.81008,
                                53.16896
                            ],
                            [
                                -79.89835,
                                53.15682
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -127.16184,
                                50.64018
                            ],
                            [
                                -126.89034,
                                50.62001
                            ],
                            [
                                -126.8958,
                                50.66958
                            ],
                            [
                                -127.026,
                                50.65736
                            ],
                            [
                                -127.10829,
                                50.67384
                            ],
                            [
                                -127.16184,
                                50.64018
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -60.87944,
                                55.92043
                            ],
                            [
                                -60.84977,
                                55.86068
                            ],
                            [
                                -60.69049,
                                55.90931
                            ],
                            [
                                -60.85191,
                                55.94719
                            ],
                            [
                                -60.87944,
                                55.92043
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -125.899,
                                49.2365
                            ],
                            [
                                -125.93021,
                                49.20592
                            ],
                            [
                                -125.85195,
                                49.13484
                            ],
                            [
                                -125.79757,
                                49.12203
                            ],
                            [
                                -125.78163,
                                49.23317
                            ],
                            [
                                -125.899,
                                49.2365
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -64.1712,
                                63.84664
                            ],
                            [
                                -64.33561,
                                63.8187
                            ],
                            [
                                -64.23133,
                                63.76987
                            ],
                            [
                                -64.1712,
                                63.84664
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -61.74578,
                                57.37627
                            ],
                            [
                                -61.77479,
                                57.31843
                            ],
                            [
                                -61.6577,
                                57.30685
                            ],
                            [
                                -61.6459,
                                57.36161
                            ],
                            [
                                -61.74578,
                                57.37627
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -123.44722,
                                49.50581
                            ],
                            [
                                -123.41927,
                                49.46005
                            ],
                            [
                                -123.31573,
                                49.46732
                            ],
                            [
                                -123.38054,
                                49.53394
                            ],
                            [
                                -123.44722,
                                49.50581
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -127.74628,
                                50.91099
                            ],
                            [
                                -127.83595,
                                50.87626
                            ],
                            [
                                -127.65713,
                                50.83334
                            ],
                            [
                                -127.6804,
                                50.89043
                            ],
                            [
                                -127.74628,
                                50.91099
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -80.21741,
                                59.73937
                            ],
                            [
                                -80.32665,
                                59.66587
                            ],
                            [
                                -80.26093,
                                59.6433
                            ],
                            [
                                -80.15534,
                                59.72089
                            ],
                            [
                                -80.21741,
                                59.73937
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -79.76891,
                                57.60734
                            ],
                            [
                                -79.8399,
                                57.51668
                            ],
                            [
                                -79.7053,
                                57.54218
                            ],
                            [
                                -79.76891,
                                57.60734
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -128.40887,
                                52.53804
                            ],
                            [
                                -128.41797,
                                52.46484
                            ],
                            [
                                -128.27051,
                                52.49583
                            ],
                            [
                                -128.40887,
                                52.53804
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -54.68115,
                                49.4931
                            ],
                            [
                                -54.77571,
                                49.43861
                            ],
                            [
                                -54.70368,
                                49.39963
                            ],
                            [
                                -54.68115,
                                49.4931
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "CPV",
                "Country": "Cape Verde",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    6.0421e-09,
                    1.2132e-08,
                    1.8241e-08,
                    2.4369e-08,
                    3.0515e-08,
                    3.6674e-08,
                    4.2838e-08,
                    4.9007e-08,
                    5.5183e-08,
                    6.1586e-08,
                    6.812e-08,
                    7.4728e-08,
                    8.1361e-08,
                    8.8009e-08,
                    9.4696e-08,
                    1.0141e-07,
                    1.0816e-07,
                    1.1494e-07,
                    1.2175e-07,
                    1.287e-07,
                    1.3574e-07,
                    1.4289e-07,
                    1.5013e-07,
                    1.5747e-07,
                    1.6492e-07,
                    1.7247e-07,
                    1.8011e-07,
                    1.8783e-07,
                    1.9563e-07,
                    2.0363e-07,
                    2.1172e-07,
                    2.1986e-07,
                    2.2806e-07,
                    2.363e-07,
                    2.4457e-07,
                    2.5285e-07,
                    2.6114e-07,
                    2.6944e-07,
                    2.7776e-07,
                    2.8629e-07,
                    2.9491e-07,
                    3.0359e-07,
                    3.1231e-07,
                    3.2106e-07,
                    3.2982e-07,
                    3.386e-07,
                    3.4743e-07,
                    3.563e-07,
                    3.6522e-07,
                    3.7426e-07,
                    3.8366e-07,
                    3.9335e-07,
                    4.0336e-07,
                    4.1369e-07,
                    4.2432e-07,
                    4.352e-07,
                    4.4643e-07,
                    4.5797e-07,
                    4.6977e-07,
                    4.8217e-07,
                    4.955e-07,
                    5.0971e-07,
                    5.248e-07,
                    5.4076e-07,
                    5.5759e-07,
                    5.7529e-07,
                    5.9386e-07,
                    6.132e-07,
                    6.3344e-07,
                    6.5478e-07,
                    6.7696e-07,
                    6.9992e-07,
                    7.2369e-07,
                    7.4821e-07,
                    7.735e-07,
                    7.996e-07,
                    8.2631e-07,
                    8.5385e-07,
                    8.8212e-07,
                    9.113e-07,
                    9.4086e-07,
                    9.7078e-07,
                    1.001e-06,
                    1.0315e-06,
                    1.0624e-06,
                    1.0937e-06,
                    1.1258e-06,
                    1.1584e-06,
                    1.1917e-06,
                    1.226e-06,
                    1.2614e-06,
                    1.2985e-06,
                    1.3374e-06,
                    1.3785e-06,
                    1.4225e-06,
                    1.4696e-06,
                    1.5197e-06,
                    1.5726e-06,
                    1.628e-06,
                    1.7479e-06,
                    1.8633e-06,
                    1.9585e-06,
                    2.0421e-06,
                    2.1239e-06,
                    2.2033e-06,
                    2.2845e-06,
                    2.3608e-06,
                    2.4375e-06,
                    2.5202e-06,
                    2.6031e-06,
                    2.6812e-06,
                    2.7638e-06,
                    2.8507e-06,
                    2.9468e-06,
                    3.0458e-06,
                    3.1523e-06,
                    3.2571e-06,
                    3.3685e-06,
                    3.4848e-06,
                    3.5927e-06,
                    3.6935e-06,
                    3.8023e-06,
                    3.9076e-06,
                    4.0079e-06,
                    4.1097e-06,
                    4.2116e-06,
                    4.3168e-06,
                    4.4807e-06,
                    4.6647e-06,
                    4.7905e-06,
                    4.8827e-06,
                    4.9775e-06,
                    5.0525e-06,
                    5.1466e-06,
                    5.245e-06,
                    5.3359e-06,
                    5.4707e-06,
                    5.6075e-06,
                    5.763e-06,
                    5.9891e-06,
                    6.2286e-06,
                    6.4924e-06,
                    6.7666e-06,
                    7.0455e-06,
                    7.355e-06,
                    7.6741e-06,
                    8.0014e-06,
                    8.3442e-06,
                    8.7193e-06,
                    9.1231e-06,
                    9.5512e-06,
                    9.9871e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    1.5572e-09,
                    3.1193e-09,
                    4.6862e-09,
                    6.2579e-09,
                    7.8347e-09,
                    9.4165e-09,
                    1.1003e-08,
                    1.2594e-08,
                    1.4189e-08,
                    1.5789e-08,
                    1.741e-08,
                    1.9052e-08,
                    2.0692e-08,
                    2.2334e-08,
                    2.3999e-08,
                    2.569e-08,
                    2.7404e-08,
                    2.9143e-08,
                    3.0907e-08,
                    3.2695e-08,
                    3.4511e-08,
                    3.6356e-08,
                    3.8243e-08,
                    4.0172e-08,
                    4.2145e-08,
                    4.4153e-08,
                    4.6196e-08,
                    4.8272e-08,
                    5.0381e-08,
                    5.252e-08,
                    5.4669e-08,
                    5.6828e-08,
                    5.9019e-08,
                    6.1239e-08,
                    6.3466e-08,
                    6.5701e-08,
                    6.7942e-08,
                    7.0191e-08,
                    7.2447e-08,
                    7.4719e-08,
                    7.7001e-08,
                    7.9293e-08,
                    8.1587e-08,
                    8.3882e-08,
                    8.6177e-08,
                    8.8482e-08,
                    9.0814e-08,
                    9.3175e-08,
                    9.5565e-08,
                    9.7986e-08,
                    1.0056e-07,
                    1.033e-07,
                    1.0619e-07,
                    1.0923e-07,
                    1.1244e-07,
                    1.158e-07,
                    1.1931e-07,
                    1.2298e-07,
                    1.2681e-07,
                    1.3079e-07,
                    1.3521e-07,
                    1.4008e-07,
                    1.454e-07,
                    1.5116e-07,
                    1.5736e-07,
                    1.6401e-07,
                    1.7107e-07,
                    1.7857e-07,
                    1.8648e-07,
                    1.9482e-07,
                    2.0353e-07,
                    2.1263e-07,
                    2.2211e-07,
                    2.3197e-07,
                    2.4221e-07,
                    2.5284e-07,
                    2.6384e-07,
                    2.7523e-07,
                    2.8701e-07,
                    2.9916e-07,
                    3.1151e-07,
                    3.2405e-07,
                    3.3678e-07,
                    3.4971e-07,
                    3.6284e-07,
                    3.7618e-07,
                    3.8972e-07,
                    4.0348e-07,
                    4.1748e-07,
                    4.3172e-07,
                    4.4635e-07,
                    4.6138e-07,
                    4.7682e-07,
                    4.927e-07,
                    5.0978e-07,
                    5.2809e-07,
                    5.4768e-07,
                    5.6858e-07,
                    5.9082e-07,
                    6.6113e-07,
                    7.2274e-07,
                    7.6844e-07,
                    8.0766e-07,
                    8.5011e-07,
                    8.9393e-07,
                    9.4213e-07,
                    9.8651e-07,
                    1.0305e-06,
                    1.0777e-06,
                    1.1286e-06,
                    1.1817e-06,
                    1.2355e-06,
                    1.2906e-06,
                    1.3563e-06,
                    1.4232e-06,
                    1.4919e-06,
                    1.5625e-06,
                    1.6419e-06,
                    1.7282e-06,
                    1.8094e-06,
                    1.8898e-06,
                    1.9755e-06,
                    2.064e-06,
                    2.1522e-06,
                    2.2448e-06,
                    2.3354e-06,
                    2.4293e-06,
                    2.5799e-06,
                    2.7477e-06,
                    2.8547e-06,
                    2.9214e-06,
                    2.9878e-06,
                    3.053e-06,
                    3.1387e-06,
                    3.2235e-06,
                    3.2943e-06,
                    3.3741e-06,
                    3.4489e-06,
                    3.5266e-06,
                    3.6772e-06,
                    3.8252e-06,
                    3.9856e-06,
                    4.15e-06,
                    4.3234e-06,
                    4.5157e-06,
                    4.7216e-06,
                    4.9398e-06,
                    5.1735e-06,
                    5.4401e-06,
                    5.7232e-06,
                    6.0434e-06,
                    6.3847e-06,
                    6.6922e-06,
                    7.0088e-06,
                    7.3414e-06,
                    7.6987e-06,
                    8.065e-06,
                    8.4161e-06,
                    8.7889e-06,
                    9.1594e-06,
                    9.5563e-06,
                    9.8976e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [
                    4.4849e-09,
                    9.0124e-09,
                    1.3555e-08,
                    1.8111e-08,
                    2.2681e-08,
                    2.7258e-08,
                    3.1835e-08,
                    3.6413e-08,
                    4.0994e-08,
                    4.5798e-08,
                    5.071e-08,
                    5.5676e-08,
                    6.0668e-08,
                    6.5675e-08,
                    7.0697e-08,
                    7.5722e-08,
                    8.0757e-08,
                    8.5796e-08,
                    9.0839e-08,
                    9.6002e-08,
                    1.0123e-07,
                    1.0653e-07,
                    1.1189e-07,
                    1.173e-07,
                    1.2278e-07,
                    1.2832e-07,
                    1.3391e-07,
                    1.3956e-07,
                    1.4525e-07,
                    1.5111e-07,
                    1.5705e-07,
                    1.6303e-07,
                    1.6904e-07,
                    1.7506e-07,
                    1.811e-07,
                    1.8715e-07,
                    1.932e-07,
                    1.9925e-07,
                    2.0531e-07,
                    2.1157e-07,
                    2.1791e-07,
                    2.243e-07,
                    2.3073e-07,
                    2.3717e-07,
                    2.4364e-07,
                    2.5012e-07,
                    2.5662e-07,
                    2.6313e-07,
                    2.6965e-07,
                    2.7627e-07,
                    2.831e-07,
                    2.9005e-07,
                    2.9718e-07,
                    3.0446e-07,
                    3.1188e-07,
                    3.194e-07,
                    3.2712e-07,
                    3.3499e-07,
                    3.4296e-07,
                    3.5138e-07,
                    3.6029e-07,
                    3.6963e-07,
                    3.794e-07,
                    3.896e-07,
                    4.0023e-07,
                    4.1128e-07,
                    4.2279e-07,
                    4.3464e-07,
                    4.4696e-07,
                    4.5996e-07,
                    4.7343e-07,
                    4.8729e-07,
                    5.0158e-07,
                    5.1624e-07,
                    5.3129e-07,
                    5.4676e-07,
                    5.6246e-07,
                    5.7861e-07,
                    5.9511e-07,
                    6.1214e-07,
                    6.2935e-07,
                    6.4673e-07,
                    6.6425e-07,
                    6.8183e-07,
                    6.9953e-07,
                    7.1757e-07,
                    7.3604e-07,
                    7.5488e-07,
                    7.7421e-07,
                    7.9423e-07,
                    8.1509e-07,
                    8.3713e-07,
                    8.6059e-07,
                    8.8578e-07,
                    9.1273e-07,
                    9.4152e-07,
                    9.7201e-07,
                    1.004e-06,
                    1.0372e-06,
                    1.0868e-06,
                    1.1405e-06,
                    1.1901e-06,
                    1.2344e-06,
                    1.2738e-06,
                    1.3094e-06,
                    1.3423e-06,
                    1.3743e-06,
                    1.407e-06,
                    1.4425e-06,
                    1.4745e-06,
                    1.4995e-06,
                    1.5282e-06,
                    1.5601e-06,
                    1.5905e-06,
                    1.6227e-06,
                    1.6604e-06,
                    1.6946e-06,
                    1.7265e-06,
                    1.7567e-06,
                    1.7833e-06,
                    1.8037e-06,
                    1.8268e-06,
                    1.8436e-06,
                    1.8557e-06,
                    1.8649e-06,
                    1.8761e-06,
                    1.8875e-06,
                    1.9008e-06,
                    1.9171e-06,
                    1.9358e-06,
                    1.9613e-06,
                    1.9897e-06,
                    1.9995e-06,
                    2.008e-06,
                    2.0216e-06,
                    2.0416e-06,
                    2.0966e-06,
                    2.1587e-06,
                    2.2364e-06,
                    2.3118e-06,
                    2.4034e-06,
                    2.5068e-06,
                    2.6167e-06,
                    2.7221e-06,
                    2.8394e-06,
                    2.9524e-06,
                    3.0616e-06,
                    3.1707e-06,
                    3.2792e-06,
                    3.3998e-06,
                    3.5078e-06,
                    3.6023e-06,
                    3.7104e-06,
                    3.8251e-06,
                    3.9385e-06,
                    4.0323e-06,
                    4.1298e-06,
                    4.1962e-06,
                    4.2602e-06,
                    4.3351e-06,
                    4.4698e-06,
                    4.5621e-06,
                    4.6158e-06,
                    4.6735e-06,
                    4.724e-06,
                    4.7872e-06,
                    4.8125e-06,
                    4.8264e-06,
                    4.8394e-06,
                    4.8641e-06,
                    4.8949e-06,
                    4.921e-06
                ],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    3.157e-09,
                    6.347e-09,
                    9.5425e-09,
                    1.2743e-08,
                    1.595e-08,
                    1.9157e-08,
                    2.2358e-08,
                    2.5553e-08,
                    2.8749e-08,
                    3.2164e-08,
                    3.5673e-08,
                    3.922e-08,
                    4.2779e-08,
                    4.6337e-08,
                    4.9896e-08,
                    5.3443e-08,
                    5.6985e-08,
                    6.0516e-08,
                    6.4037e-08,
                    6.7661e-08,
                    7.133e-08,
                    7.5031e-08,
                    7.8743e-08,
                    8.2461e-08,
                    8.6185e-08,
                    8.9914e-08,
                    9.3643e-08,
                    9.7372e-08,
                    1.011e-07,
                    1.0497e-07,
                    1.0891e-07,
                    1.1288e-07,
                    1.1686e-07,
                    1.2086e-07,
                    1.2486e-07,
                    1.2885e-07,
                    1.3285e-07,
                    1.3685e-07,
                    1.4084e-07,
                    1.4498e-07,
                    1.4919e-07,
                    1.5344e-07,
                    1.5772e-07,
                    1.62e-07,
                    1.6629e-07,
                    1.7058e-07,
                    1.7488e-07,
                    1.7917e-07,
                    1.8347e-07,
                    1.8784e-07,
                    1.923e-07,
                    1.9675e-07,
                    2.0124e-07,
                    2.0577e-07,
                    2.103e-07,
                    2.148e-07,
                    2.1937e-07,
                    2.2395e-07,
                    2.285e-07,
                    2.3337e-07,
                    2.3834e-07,
                    2.4335e-07,
                    2.4839e-07,
                    2.5343e-07,
                    2.5849e-07,
                    2.6354e-07,
                    2.6861e-07,
                    2.7359e-07,
                    2.7863e-07,
                    2.8392e-07,
                    2.8931e-07,
                    2.9473e-07,
                    3.0019e-07,
                    3.0565e-07,
                    3.1112e-07,
                    3.1663e-07,
                    3.2203e-07,
                    3.2752e-07,
                    3.3304e-07,
                    3.3879e-07,
                    3.4459e-07,
                    3.5045e-07,
                    3.5636e-07,
                    3.6225e-07,
                    3.6816e-07,
                    3.7405e-07,
                    3.7997e-07,
                    3.8586e-07,
                    3.918e-07,
                    3.9797e-07,
                    4.0423e-07,
                    4.1054e-07,
                    4.1681e-07,
                    4.2317e-07,
                    4.2952e-07,
                    4.3594e-07,
                    4.4236e-07,
                    4.4876e-07,
                    4.551e-07,
                    5.2314e-07,
                    5.8224e-07,
                    6.1812e-07,
                    6.4027e-07,
                    6.593e-07,
                    6.7488e-07,
                    6.9198e-07,
                    7.0387e-07,
                    7.1554e-07,
                    7.3185e-07,
                    7.4615e-07,
                    7.5876e-07,
                    7.6888e-07,
                    7.7684e-07,
                    7.911e-07,
                    8.0348e-07,
                    8.141e-07,
                    8.2296e-07,
                    8.3671e-07,
                    8.536e-07,
                    8.7042e-07,
                    8.8721e-07,
                    9.1064e-07,
                    9.3958e-07,
                    9.701e-07,
                    1.0049e-06,
                    1.0377e-06,
                    1.0738e-06,
                    1.1674e-06,
                    1.2792e-06,
                    1.3333e-06,
                    1.3479e-06,
                    1.3642e-06,
                    1.3806e-06,
                    1.4186e-06,
                    1.4566e-06,
                    1.4832e-06,
                    1.5431e-06,
                    1.5877e-06,
                    1.6421e-06,
                    1.7327e-06,
                    1.8243e-06,
                    1.9144e-06,
                    1.9992e-06,
                    2.0946e-06,
                    2.1957e-06,
                    2.3232e-06,
                    2.4426e-06,
                    2.5571e-06,
                    2.6939e-06,
                    2.8536e-06,
                    3.0339e-06,
                    3.2183e-06,
                    3.4227e-06,
                    3.6242e-06,
                    3.8423e-06,
                    4.0766e-06,
                    4.3334e-06,
                    4.5596e-06,
                    4.8023e-06,
                    5.0683e-06,
                    5.4221e-06,
                    5.694e-06,
                    5.9244e-06,
                    6.145e-06,
                    6.3624e-06,
                    6.5845e-06,
                    6.8032e-06,
                    7.0319e-06,
                    7.2684e-06,
                    7.4842e-06,
                    7.718e-06,
                    7.9556e-06
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    4.62e-08,
                    8.085e-08,
                    9.735e-08,
                    1.056e-07,
                    1.155e-07,
                    1.254e-07,
                    1.386e-07,
                    1.4685e-07,
                    1.5345e-07,
                    1.6169e-07,
                    1.7157e-07,
                    1.8146e-07,
                    1.897e-07,
                    1.9628e-07,
                    2.0946e-07,
                    2.2098e-07,
                    2.3088e-07,
                    2.3913e-07,
                    2.5232e-07,
                    2.6879e-07,
                    2.8526e-07,
                    3.0175e-07,
                    3.2484e-07,
                    3.5286e-07,
                    3.8256e-07,
                    4.1721e-07,
                    4.5021e-07,
                    4.8651e-07,
                    5.8042e-07,
                    6.9262e-07,
                    7.4707e-07,
                    7.6192e-07,
                    7.7842e-07,
                    7.9492e-07,
                    8.3287e-07,
                    8.7082e-07,
                    8.9722e-07,
                    9.3352e-07,
                    9.6652e-07,
                    1.0028e-06,
                    1.0837e-06,
                    1.1579e-06,
                    1.2388e-06,
                    1.3163e-06,
                    1.3955e-06,
                    1.4846e-06,
                    1.582e-06,
                    1.6843e-06,
                    1.7932e-06,
                    1.9235e-06,
                    2.0572e-06,
                    2.2139e-06,
                    2.3855e-06,
                    2.572e-06,
                    2.7634e-06,
                    2.9647e-06,
                    3.1874e-06,
                    3.4151e-06,
                    3.6263e-06,
                    3.8606e-06,
                    4.1114e-06,
                    4.3886e-06,
                    4.6147e-06,
                    4.8374e-06,
                    5.0569e-06,
                    5.278e-06,
                    5.5007e-06,
                    5.7301e-06,
                    5.9726e-06,
                    6.2251e-06,
                    6.4577e-06,
                    6.7094e-06,
                    6.9655e-06
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [
                    3.157e-09,
                    6.347e-09,
                    9.5425e-09,
                    1.2743e-08,
                    1.595e-08,
                    1.9157e-08,
                    2.2358e-08,
                    2.5553e-08,
                    2.8749e-08,
                    3.2164e-08,
                    3.5673e-08,
                    3.922e-08,
                    4.2779e-08,
                    4.6337e-08,
                    4.9896e-08,
                    5.3443e-08,
                    5.6985e-08,
                    6.0516e-08,
                    6.4037e-08,
                    6.7661e-08,
                    7.133e-08,
                    7.5031e-08,
                    7.8743e-08,
                    8.2461e-08,
                    8.6185e-08,
                    8.9914e-08,
                    9.3643e-08,
                    9.7372e-08,
                    1.011e-07,
                    1.0497e-07,
                    1.0891e-07,
                    1.1288e-07,
                    1.1686e-07,
                    1.2086e-07,
                    1.2486e-07,
                    1.2885e-07,
                    1.3285e-07,
                    1.3685e-07,
                    1.4084e-07,
                    1.4498e-07,
                    1.4919e-07,
                    1.5344e-07,
                    1.5772e-07,
                    1.62e-07,
                    1.6629e-07,
                    1.7058e-07,
                    1.7488e-07,
                    1.7917e-07,
                    1.8347e-07,
                    1.8784e-07,
                    1.923e-07,
                    1.9675e-07,
                    2.0124e-07,
                    2.0577e-07,
                    2.103e-07,
                    2.148e-07,
                    2.1937e-07,
                    2.2395e-07,
                    2.285e-07,
                    2.3337e-07,
                    2.3834e-07,
                    2.4335e-07,
                    2.4839e-07,
                    2.5343e-07,
                    2.5849e-07,
                    2.6354e-07,
                    2.6861e-07,
                    2.7359e-07,
                    2.7863e-07,
                    2.8392e-07,
                    2.8931e-07,
                    2.9473e-07,
                    3.0019e-07,
                    3.0565e-07,
                    3.1112e-07,
                    3.1663e-07,
                    3.2203e-07,
                    3.2752e-07,
                    3.3304e-07,
                    3.3879e-07,
                    3.4459e-07,
                    3.5045e-07,
                    3.5636e-07,
                    3.6225e-07,
                    3.6816e-07,
                    3.7405e-07,
                    3.7997e-07,
                    3.8586e-07,
                    3.918e-07,
                    3.9797e-07,
                    4.0423e-07,
                    4.1054e-07,
                    4.1681e-07,
                    4.2317e-07,
                    4.2952e-07,
                    4.3594e-07,
                    4.4236e-07,
                    4.4876e-07,
                    4.551e-07,
                    4.7694e-07,
                    5.0139e-07,
                    5.2077e-07,
                    5.3467e-07,
                    5.438e-07,
                    5.4948e-07,
                    5.5338e-07,
                    5.5702e-07,
                    5.6209e-07,
                    5.7016e-07,
                    5.7457e-07,
                    5.773e-07,
                    5.7918e-07,
                    5.8056e-07,
                    5.8164e-07,
                    5.825e-07,
                    5.8323e-07,
                    5.8383e-07,
                    5.8439e-07,
                    5.8481e-07,
                    5.8516e-07,
                    5.8546e-07,
                    5.858e-07,
                    5.8672e-07,
                    5.8754e-07,
                    5.8765e-07,
                    5.875e-07,
                    5.8726e-07,
                    5.8694e-07,
                    5.866e-07,
                    5.8624e-07,
                    5.8596e-07,
                    5.8578e-07,
                    5.857e-07,
                    5.857e-07,
                    5.8576e-07,
                    5.8596e-07,
                    6.0956e-07,
                    6.2119e-07,
                    6.3925e-07,
                    6.4905e-07,
                    6.6638e-07,
                    6.7565e-07,
                    6.8286e-07,
                    6.9903e-07,
                    7.1112e-07,
                    7.4126e-07,
                    7.5828e-07,
                    7.6395e-07,
                    7.7035e-07,
                    7.9647e-07,
                    8.1998e-07,
                    8.3274e-07,
                    8.507e-07,
                    8.6085e-07,
                    8.7759e-07,
                    8.892e-07,
                    9.183e-07,
                    9.3326e-07,
                    9.417e-07,
                    9.5689e-07,
                    1.0334e-06,
                    1.0793e-06,
                    1.087e-06,
                    1.0881e-06,
                    1.0845e-06,
                    1.0838e-06,
                    1.0731e-06,
                    1.0592e-06,
                    1.0434e-06,
                    1.0265e-06,
                    1.0087e-06,
                    9.901e-07
                ],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [
                    2.0258e-09,
                    4.0524e-09,
                    6.0796e-09,
                    8.1076e-09,
                    1.0137e-08,
                    1.2167e-08,
                    1.4198e-08,
                    1.6231e-08,
                    1.8265e-08,
                    2.03e-08,
                    2.2367e-08,
                    2.4467e-08,
                    2.6576e-08,
                    2.8697e-08,
                    3.0853e-08,
                    3.3045e-08,
                    3.5273e-08,
                    3.7536e-08,
                    3.9835e-08,
                    4.2169e-08,
                    4.4541e-08,
                    4.695e-08,
                    4.9406e-08,
                    5.191e-08,
                    5.4461e-08,
                    5.705e-08,
                    5.9678e-08,
                    6.2345e-08,
                    6.5051e-08,
                    6.7795e-08,
                    7.0547e-08,
                    7.3307e-08,
                    7.6096e-08,
                    7.8912e-08,
                    8.1733e-08,
                    8.456e-08,
                    8.7392e-08,
                    9.0229e-08,
                    9.3072e-08,
                    9.592e-08,
                    9.8774e-08,
                    1.0163e-07,
                    1.0449e-07,
                    1.0734e-07,
                    1.1019e-07,
                    1.1304e-07,
                    1.1591e-07,
                    1.1881e-07,
                    1.2173e-07,
                    1.2467e-07,
                    1.2788e-07,
                    1.3135e-07,
                    1.3508e-07,
                    1.3908e-07,
                    1.4333e-07,
                    1.4785e-07,
                    1.5264e-07,
                    1.5768e-07,
                    1.6299e-07,
                    1.6855e-07,
                    1.749e-07,
                    1.8203e-07,
                    1.8994e-07,
                    1.9864e-07,
                    2.0811e-07,
                    2.1836e-07,
                    2.2937e-07,
                    2.4115e-07,
                    2.5368e-07,
                    2.6697e-07,
                    2.8092e-07,
                    2.9554e-07,
                    3.1081e-07,
                    3.2675e-07,
                    3.4334e-07,
                    3.606e-07,
                    3.7852e-07,
                    3.971e-07,
                    4.1634e-07,
                    4.3624e-07,
                    4.5646e-07,
                    4.7699e-07,
                    4.9783e-07,
                    5.19e-07,
                    5.4048e-07,
                    5.6258e-07,
                    5.8531e-07,
                    6.0869e-07,
                    6.3275e-07,
                    6.575e-07,
                    6.8314e-07,
                    7.0968e-07,
                    7.3714e-07,
                    7.6555e-07,
                    7.9569e-07,
                    8.276e-07,
                    8.6134e-07,
                    8.9696e-07,
                    9.345e-07,
                    9.7451e-07,
                    1.019e-06,
                    1.0668e-06,
                    1.117e-06,
                    1.1691e-06,
                    1.2227e-06,
                    1.2771e-06,
                    1.3323e-06,
                    1.3886e-06,
                    1.4463e-06,
                    1.5064e-06,
                    1.5639e-06,
                    1.6277e-06,
                    1.6974e-06,
                    1.7698e-06,
                    1.8462e-06,
                    1.9311e-06,
                    2.0161e-06,
                    2.1031e-06,
                    2.1919e-06,
                    2.2728e-06,
                    2.3469e-06,
                    2.4216e-06,
                    2.4873e-06,
                    2.5474e-06,
                    2.6047e-06,
                    2.6634e-06,
                    2.7218e-06,
                    2.7804e-06,
                    2.8402e-06,
                    2.898e-06,
                    2.9614e-06,
                    3.0238e-06,
                    3.0691e-06,
                    3.1117e-06,
                    3.1569e-06,
                    3.2043e-06,
                    3.2601e-06,
                    3.3312e-06,
                    3.4103e-06,
                    3.5219e-06,
                    3.6431e-06,
                    3.7818e-06,
                    3.9362e-06,
                    4.0912e-06,
                    4.2621e-06,
                    4.4279e-06,
                    4.6059e-06,
                    4.7996e-06,
                    5.0012e-06,
                    5.2087e-06,
                    5.4224e-06,
                    5.6404e-06,
                    5.819e-06,
                    6.0149e-06,
                    6.2084e-06,
                    6.3911e-06,
                    6.5648e-06,
                    6.7234e-06,
                    6.8827e-06,
                    7.0264e-06,
                    7.1676e-06,
                    7.2932e-06,
                    7.4147e-06,
                    7.5433e-06,
                    7.6633e-06,
                    7.7923e-06,
                    7.8942e-06,
                    7.9837e-06,
                    8.0674e-06,
                    8.1568e-06,
                    8.2432e-06,
                    8.3236e-06
                ],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [
                    1.1389e-09,
                    2.2778e-09,
                    3.4166e-09,
                    4.5554e-09,
                    5.6947e-09,
                    6.8343e-09,
                    7.9744e-09,
                    9.1148e-09,
                    1.0256e-08,
                    1.1397e-08,
                    1.2556e-08,
                    1.3733e-08,
                    1.4905e-08,
                    1.6075e-08,
                    1.7265e-08,
                    1.8477e-08,
                    1.9709e-08,
                    2.0962e-08,
                    2.2237e-08,
                    2.3533e-08,
                    2.4851e-08,
                    2.6192e-08,
                    2.7565e-08,
                    2.897e-08,
                    3.0408e-08,
                    3.187e-08,
                    3.3355e-08,
                    3.4864e-08,
                    3.6397e-08,
                    3.7954e-08,
                    3.9516e-08,
                    4.1083e-08,
                    4.2677e-08,
                    4.4296e-08,
                    4.5918e-08,
                    4.7543e-08,
                    4.917e-08,
                    5.0801e-08,
                    5.2434e-08,
                    5.4071e-08,
                    5.571e-08,
                    5.7352e-08,
                    5.8988e-08,
                    6.0619e-08,
                    6.2242e-08,
                    6.3867e-08,
                    6.5511e-08,
                    6.7175e-08,
                    6.886e-08,
                    7.0567e-08,
                    7.242e-08,
                    7.4419e-08,
                    7.6564e-08,
                    7.8854e-08,
                    8.1288e-08,
                    8.3868e-08,
                    8.6593e-08,
                    8.9462e-08,
                    9.2476e-08,
                    9.5634e-08,
                    9.9225e-08,
                    1.0326e-07,
                    1.0773e-07,
                    1.1263e-07,
                    1.1797e-07,
                    1.2374e-07,
                    1.2993e-07,
                    1.3654e-07,
                    1.4356e-07,
                    1.51e-07,
                    1.588e-07,
                    1.6698e-07,
                    1.7554e-07,
                    1.8447e-07,
                    1.9377e-07,
                    2.0344e-07,
                    2.1349e-07,
                    2.2392e-07,
                    2.3471e-07,
                    2.4589e-07,
                    2.5724e-07,
                    2.6877e-07,
                    2.8048e-07,
                    2.9237e-07,
                    3.0445e-07,
                    3.1672e-07,
                    3.2918e-07,
                    3.4184e-07,
                    3.5472e-07,
                    3.6782e-07,
                    3.8129e-07,
                    3.9513e-07,
                    4.0935e-07,
                    4.2397e-07,
                    4.3975e-07,
                    4.5672e-07,
                    4.7493e-07,
                    4.944e-07,
                    5.1518e-07,
                    5.3779e-07,
                    5.6322e-07,
                    5.9085e-07,
                    6.202e-07,
                    6.511e-07,
                    6.8332e-07,
                    7.166e-07,
                    7.5094e-07,
                    7.8652e-07,
                    8.236e-07,
                    8.6276e-07,
                    9.0405e-07,
                    9.4773e-07,
                    9.9427e-07,
                    1.0447e-06,
                    1.098e-06,
                    1.1548e-06,
                    1.215e-06,
                    1.2791e-06,
                    1.3467e-06,
                    1.4094e-06,
                    1.4712e-06,
                    1.5315e-06,
                    1.5897e-06,
                    1.6458e-06,
                    1.7012e-06,
                    1.756e-06,
                    1.8107e-06,
                    1.8641e-06,
                    1.9164e-06,
                    1.9654e-06,
                    2.0138e-06,
                    2.0609e-06,
                    2.1068e-06,
                    2.1514e-06,
                    2.195e-06,
                    2.2367e-06,
                    2.2772e-06,
                    2.316e-06,
                    2.3543e-06,
                    2.4208e-06,
                    2.4909e-06,
                    2.5668e-06,
                    2.65e-06,
                    2.7404e-06,
                    2.8396e-06,
                    2.9439e-06,
                    3.0555e-06,
                    3.1758e-06,
                    3.3074e-06,
                    3.4505e-06,
                    3.6069e-06,
                    3.7691e-06,
                    3.883e-06,
                    4.0007e-06,
                    4.1226e-06,
                    4.2471e-06,
                    4.375e-06,
                    4.5039e-06,
                    4.6315e-06,
                    4.7399e-06,
                    4.8467e-06,
                    4.9501e-06,
                    5.0503e-06,
                    5.1471e-06,
                    5.2386e-06,
                    5.3296e-06,
                    5.4167e-06,
                    5.4997e-06,
                    5.5759e-06,
                    5.6465e-06,
                    5.7071e-06,
                    5.7654e-06
                ],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [
                    8.8692e-10,
                    1.7746e-09,
                    2.663e-09,
                    3.5522e-09,
                    4.442e-09,
                    5.3327e-09,
                    6.2241e-09,
                    7.1162e-09,
                    8.0091e-09,
                    8.9027e-09,
                    9.8108e-09,
                    1.0733e-08,
                    1.1671e-08,
                    1.2622e-08,
                    1.3588e-08,
                    1.4569e-08,
                    1.5564e-08,
                    1.6573e-08,
                    1.7598e-08,
                    1.8636e-08,
                    1.969e-08,
                    2.0758e-08,
                    2.1841e-08,
                    2.2939e-08,
                    2.4052e-08,
                    2.518e-08,
                    2.6323e-08,
                    2.7481e-08,
                    2.8653e-08,
                    2.9841e-08,
                    3.1031e-08,
                    3.2223e-08,
                    3.3418e-08,
                    3.4615e-08,
                    3.5815e-08,
                    3.7017e-08,
                    3.8222e-08,
                    3.9428e-08,
                    4.0638e-08,
                    4.185e-08,
                    4.3064e-08,
                    4.428e-08,
                    4.55e-08,
                    4.6721e-08,
                    4.7945e-08,
                    4.9172e-08,
                    5.0401e-08,
                    5.1633e-08,
                    5.2867e-08,
                    5.4103e-08,
                    5.5457e-08,
                    5.6928e-08,
                    5.8516e-08,
                    6.0222e-08,
                    6.2045e-08,
                    6.3985e-08,
                    6.6043e-08,
                    6.8218e-08,
                    7.051e-08,
                    7.2919e-08,
                    7.5673e-08,
                    7.8772e-08,
                    8.2216e-08,
                    8.6005e-08,
                    9.0138e-08,
                    9.4616e-08,
                    9.9439e-08,
                    1.0461e-07,
                    1.1012e-07,
                    1.1598e-07,
                    1.2212e-07,
                    1.2855e-07,
                    1.3527e-07,
                    1.4228e-07,
                    1.4957e-07,
                    1.5716e-07,
                    1.6502e-07,
                    1.7318e-07,
                    1.8163e-07,
                    1.9036e-07,
                    1.9922e-07,
                    2.0822e-07,
                    2.1736e-07,
                    2.2663e-07,
                    2.3603e-07,
                    2.4586e-07,
                    2.5613e-07,
                    2.6685e-07,
                    2.7803e-07,
                    2.8968e-07,
                    3.0185e-07,
                    3.1455e-07,
                    3.2779e-07,
                    3.4158e-07,
                    3.5594e-07,
                    3.7088e-07,
                    3.8642e-07,
                    4.0256e-07,
                    4.1932e-07,
                    4.3672e-07,
                    4.5577e-07,
                    4.7594e-07,
                    4.9679e-07,
                    5.1801e-07,
                    5.3937e-07,
                    5.605e-07,
                    5.8136e-07,
                    6.0205e-07,
                    6.2271e-07,
                    6.4361e-07,
                    6.5981e-07,
                    6.7999e-07,
                    7.0316e-07,
                    7.2504e-07,
                    7.4819e-07,
                    7.7627e-07,
                    8.0112e-07,
                    8.2394e-07,
                    8.4526e-07,
                    8.6342e-07,
                    8.757e-07,
                    8.9004e-07,
                    8.9761e-07,
                    9.0162e-07,
                    9.0353e-07,
                    9.0733e-07,
                    9.1108e-07,
                    9.1629e-07,
                    9.238e-07,
                    9.3262e-07,
                    9.4758e-07,
                    9.6293e-07,
                    9.6236e-07,
                    9.6037e-07,
                    9.6182e-07,
                    9.6752e-07,
                    9.8292e-07,
                    1.0152e-06,
                    1.0559e-06,
                    1.1011e-06,
                    1.1523e-06,
                    1.215e-06,
                    1.2862e-06,
                    1.3508e-06,
                    1.4225e-06,
                    1.484e-06,
                    1.5504e-06,
                    1.6238e-06,
                    1.6938e-06,
                    1.7582e-06,
                    1.8156e-06,
                    1.8713e-06,
                    1.936e-06,
                    2.0142e-06,
                    2.0858e-06,
                    2.1441e-06,
                    2.1899e-06,
                    2.2194e-06,
                    2.2512e-06,
                    2.2865e-06,
                    2.3209e-06,
                    2.3431e-06,
                    2.3643e-06,
                    2.3962e-06,
                    2.4247e-06,
                    2.4627e-06,
                    2.4774e-06,
                    2.484e-06,
                    2.4915e-06,
                    2.5103e-06,
                    2.536e-06,
                    2.5582e-06
                ],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [
                    8.5924e-10,
                    1.7323e-09,
                    2.6186e-09,
                    3.5177e-09,
                    4.4287e-09,
                    5.3507e-09,
                    6.2825e-09,
                    7.2228e-09,
                    8.1701e-09,
                    9.1228e-09,
                    1.008e-08,
                    1.1041e-08,
                    1.2006e-08,
                    1.2975e-08,
                    1.3947e-08,
                    1.4923e-08,
                    1.5903e-08,
                    1.6887e-08,
                    1.7874e-08,
                    1.8867e-08,
                    1.9872e-08,
                    2.0906e-08,
                    2.198e-08,
                    2.3103e-08,
                    2.4278e-08,
                    2.5507e-08,
                    2.6787e-08,
                    2.8113e-08,
                    2.9476e-08,
                    3.0862e-08,
                    3.2262e-08,
                    3.3675e-08,
                    3.51e-08,
                    3.6535e-08,
                    3.7979e-08,
                    3.9432e-08,
                    4.0895e-08,
                    4.2367e-08,
                    4.3849e-08,
                    4.539e-08,
                    4.6946e-08,
                    4.8518e-08,
                    5.0107e-08,
                    5.1713e-08,
                    5.3337e-08,
                    5.4979e-08,
                    5.6641e-08,
                    5.8322e-08,
                    6.0023e-08,
                    6.1745e-08,
                    6.3487e-08,
                    6.5252e-08,
                    6.7038e-08,
                    6.8847e-08,
                    7.0681e-08,
                    7.2539e-08,
                    7.4424e-08,
                    7.6336e-08,
                    7.8278e-08,
                    8.025e-08,
                    8.2263e-08,
                    8.4333e-08,
                    8.6472e-08,
                    8.869e-08,
                    9.0995e-08,
                    9.3391e-08,
                    9.5881e-08,
                    9.8463e-08,
                    1.0113e-07,
                    1.0389e-07,
                    1.0672e-07,
                    1.0966e-07,
                    1.1269e-07,
                    1.1582e-07,
                    1.1904e-07,
                    1.2236e-07,
                    1.2576e-07,
                    1.2922e-07,
                    1.3274e-07,
                    1.3627e-07,
                    1.3981e-07,
                    1.4333e-07,
                    1.4683e-07,
                    1.503e-07,
                    1.5372e-07,
                    1.5711e-07,
                    1.6047e-07,
                    1.6381e-07,
                    1.6714e-07,
                    1.7048e-07,
                    1.7407e-07,
                    1.783e-07,
                    1.8346e-07,
                    1.8976e-07,
                    1.973e-07,
                    2.0607e-07,
                    2.1599e-07,
                    2.2687e-07,
                    2.3842e-07,
                    2.5026e-07,
                    2.6206e-07,
                    2.7362e-07,
                    2.8481e-07,
                    2.9552e-07,
                    3.0572e-07,
                    3.1539e-07,
                    3.2459e-07,
                    3.3342e-07,
                    3.4201e-07,
                    3.5055e-07,
                    3.5856e-07,
                    3.6718e-07,
                    3.7645e-07,
                    3.8594e-07,
                    3.961e-07,
                    4.0713e-07,
                    4.1803e-07,
                    4.2869e-07,
                    4.3929e-07,
                    4.4945e-07,
                    4.5941e-07,
                    4.7009e-07,
                    4.8069e-07,
                    4.9036e-07,
                    5.0016e-07,
                    5.1047e-07,
                    5.2122e-07,
                    5.3292e-07,
                    5.4534e-07,
                    5.5916e-07,
                    5.7345e-07,
                    5.8948e-07,
                    6.0273e-07,
                    6.1634e-07,
                    6.3161e-07,
                    6.4846e-07,
                    6.6745e-07,
                    6.8856e-07,
                    7.1064e-07,
                    7.3445e-07,
                    7.6115e-07,
                    7.962e-07,
                    8.3122e-07,
                    8.5972e-07,
                    8.9724e-07,
                    9.2289e-07,
                    9.5288e-07,
                    9.8743e-07,
                    1.0242e-06,
                    1.0607e-06,
                    1.0949e-06,
                    1.1284e-06,
                    1.1609e-06,
                    1.1947e-06,
                    1.2293e-06,
                    1.2632e-06,
                    1.2965e-06,
                    1.3294e-06,
                    1.364e-06,
                    1.3997e-06,
                    1.4365e-06,
                    1.4725e-06,
                    1.5091e-06,
                    1.5463e-06,
                    1.5844e-06,
                    1.6236e-06,
                    1.6584e-06,
                    1.6932e-06,
                    1.7288e-06,
                    1.766e-06,
                    1.8042e-06,
                    1.8424e-06
                ],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [
                    4.1825e-10,
                    8.4146e-10,
                    1.2696e-09,
                    1.7025e-09,
                    2.1401e-09,
                    2.5822e-09,
                    3.0287e-09,
                    3.4793e-09,
                    3.9338e-09,
                    4.3919e-09,
                    4.8536e-09,
                    5.3187e-09,
                    5.7872e-09,
                    6.2591e-09,
                    6.7344e-09,
                    7.213e-09,
                    7.6951e-09,
                    8.1806e-09,
                    8.6695e-09,
                    9.162e-09,
                    9.6593e-09,
                    1.0164e-08,
                    1.0678e-08,
                    1.1202e-08,
                    1.1737e-08,
                    1.2283e-08,
                    1.284e-08,
                    1.3408e-08,
                    1.3984e-08,
                    1.4566e-08,
                    1.5153e-08,
                    1.5745e-08,
                    1.6342e-08,
                    1.6943e-08,
                    1.7548e-08,
                    1.8158e-08,
                    1.8772e-08,
                    1.939e-08,
                    2.0013e-08,
                    2.0649e-08,
                    2.1292e-08,
                    2.1941e-08,
                    2.2598e-08,
                    2.3263e-08,
                    2.3935e-08,
                    2.4615e-08,
                    2.5303e-08,
                    2.6e-08,
                    2.6705e-08,
                    2.7419e-08,
                    2.8143e-08,
                    2.8876e-08,
                    2.9621e-08,
                    3.0378e-08,
                    3.1147e-08,
                    3.1927e-08,
                    3.2719e-08,
                    3.3522e-08,
                    3.4336e-08,
                    3.5158e-08,
                    3.5989e-08,
                    3.6829e-08,
                    3.7676e-08,
                    3.8531e-08,
                    3.9394e-08,
                    4.0264e-08,
                    4.1142e-08,
                    4.2027e-08,
                    4.292e-08,
                    4.3821e-08,
                    4.473e-08,
                    4.5646e-08,
                    4.6571e-08,
                    4.7504e-08,
                    4.8445e-08,
                    4.9394e-08,
                    5.0351e-08,
                    5.1317e-08,
                    5.2293e-08,
                    5.3277e-08,
                    5.4272e-08,
                    5.528e-08,
                    5.63e-08,
                    5.7335e-08,
                    5.8386e-08,
                    5.9453e-08,
                    6.0537e-08,
                    6.1639e-08,
                    6.2759e-08,
                    6.3898e-08,
                    6.5059e-08,
                    6.6248e-08,
                    6.747e-08,
                    6.873e-08,
                    7.003e-08,
                    7.1372e-08,
                    7.2755e-08,
                    7.418e-08,
                    7.5643e-08,
                    7.7141e-08,
                    7.8675e-08,
                    8.0246e-08,
                    8.1857e-08,
                    8.3509e-08,
                    8.5203e-08,
                    8.6937e-08,
                    8.8712e-08,
                    9.0525e-08,
                    9.2373e-08,
                    9.4254e-08,
                    9.6166e-08,
                    9.8109e-08,
                    1.0008e-07,
                    1.0209e-07,
                    1.0414e-07,
                    1.0622e-07,
                    1.0834e-07,
                    1.105e-07,
                    1.1271e-07,
                    1.1475e-07,
                    1.1687e-07,
                    1.1914e-07,
                    1.2147e-07,
                    1.2381e-07,
                    1.2642e-07,
                    1.2915e-07,
                    1.3209e-07,
                    1.3539e-07,
                    1.3868e-07,
                    1.422e-07,
                    1.4565e-07,
                    1.4845e-07,
                    1.513e-07,
                    1.5445e-07,
                    1.576e-07,
                    1.6033e-07,
                    1.6333e-07,
                    1.6633e-07,
                    1.6938e-07,
                    1.7278e-07,
                    1.764e-07,
                    1.8006e-07,
                    1.8368e-07,
                    1.875e-07,
                    1.9148e-07,
                    1.9571e-07,
                    2.0006e-07,
                    2.045e-07,
                    2.0917e-07,
                    2.1554e-07,
                    2.2265e-07,
                    2.3011e-07,
                    2.3719e-07,
                    2.4467e-07,
                    2.5416e-07,
                    2.6418e-07,
                    2.7493e-07,
                    2.8587e-07,
                    2.9678e-07,
                    3.0807e-07,
                    3.2104e-07,
                    3.3287e-07,
                    3.4464e-07,
                    3.5706e-07,
                    3.6955e-07,
                    3.8284e-07,
                    3.9642e-07,
                    4.1012e-07,
                    4.243e-07,
                    4.3876e-07,
                    4.5397e-07,
                    4.6969e-07
                ],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": [
                    4.41e-10,
                    8.9081e-10,
                    1.3491e-09,
                    1.8152e-09,
                    2.2887e-09,
                    2.7685e-09,
                    3.2538e-09,
                    3.7435e-09,
                    4.2363e-09,
                    4.7308e-09,
                    5.2262e-09,
                    5.7222e-09,
                    6.2187e-09,
                    6.7155e-09,
                    7.2125e-09,
                    7.7099e-09,
                    8.2077e-09,
                    8.706e-09,
                    9.2049e-09,
                    9.7047e-09,
                    1.0213e-08,
                    1.0742e-08,
                    1.1303e-08,
                    1.1901e-08,
                    1.2541e-08,
                    1.3224e-08,
                    1.3947e-08,
                    1.4706e-08,
                    1.5492e-08,
                    1.6296e-08,
                    1.7109e-08,
                    1.793e-08,
                    1.8758e-08,
                    1.9592e-08,
                    2.043e-08,
                    2.1274e-08,
                    2.2123e-08,
                    2.2976e-08,
                    2.3836e-08,
                    2.4741e-08,
                    2.5654e-08,
                    2.6577e-08,
                    2.7508e-08,
                    2.845e-08,
                    2.9402e-08,
                    3.0364e-08,
                    3.1337e-08,
                    3.2322e-08,
                    3.3318e-08,
                    3.4325e-08,
                    3.5345e-08,
                    3.6375e-08,
                    3.7417e-08,
                    3.8469e-08,
                    3.9534e-08,
                    4.0612e-08,
                    4.1705e-08,
                    4.2814e-08,
                    4.3942e-08,
                    4.5092e-08,
                    4.6274e-08,
                    4.7504e-08,
                    4.8795e-08,
                    5.0158e-08,
                    5.1601e-08,
                    5.3127e-08,
                    5.4739e-08,
                    5.6436e-08,
                    5.8214e-08,
                    6.0067e-08,
                    6.1995e-08,
                    6.4009e-08,
                    6.6114e-08,
                    6.8312e-08,
                    7.0598e-08,
                    7.2968e-08,
                    7.5409e-08,
                    7.7907e-08,
                    8.0443e-08,
                    8.2995e-08,
                    8.5538e-08,
                    8.8055e-08,
                    9.0533e-08,
                    9.2962e-08,
                    9.5338e-08,
                    9.7661e-08,
                    9.9936e-08,
                    1.0217e-07,
                    1.0438e-07,
                    1.0658e-07,
                    1.0901e-07,
                    1.1205e-07,
                    1.1599e-07,
                    1.2103e-07,
                    1.2727e-07,
                    1.347e-07,
                    1.4323e-07,
                    1.5269e-07,
                    1.6278e-07,
                    1.7312e-07,
                    1.8339e-07,
                    1.9338e-07,
                    2.0295e-07,
                    2.1201e-07,
                    2.2051e-07,
                    2.2845e-07,
                    2.3588e-07,
                    2.4289e-07,
                    2.4963e-07,
                    2.563e-07,
                    2.6239e-07,
                    2.6907e-07,
                    2.7636e-07,
                    2.8385e-07,
                    2.9196e-07,
                    3.0091e-07,
                    3.0969e-07,
                    3.1818e-07,
                    3.2658e-07,
                    3.347e-07,
                    3.4254e-07,
                    3.5095e-07,
                    3.5922e-07,
                    3.6655e-07,
                    3.7374e-07,
                    3.8131e-07,
                    3.8913e-07,
                    3.9753e-07,
                    4.0665e-07,
                    4.1697e-07,
                    4.278e-07,
                    4.4103e-07,
                    4.5143e-07,
                    4.6189e-07,
                    4.7401e-07,
                    4.8814e-07,
                    5.0412e-07,
                    5.2223e-07,
                    5.4126e-07,
                    5.6167e-07,
                    5.8474e-07,
                    6.1614e-07,
                    6.4754e-07,
                    6.7223e-07,
                    7.0576e-07,
                    7.2718e-07,
                    7.5282e-07,
                    7.8293e-07,
                    8.15e-07,
                    8.4513e-07,
                    8.7222e-07,
                    8.9829e-07,
                    9.2367e-07,
                    9.5006e-07,
                    9.7516e-07,
                    9.9901e-07,
                    1.0216e-06,
                    1.0435e-06,
                    1.0672e-06,
                    1.0917e-06,
                    1.1154e-06,
                    1.1397e-06,
                    1.1644e-06,
                    1.1892e-06,
                    1.2149e-06,
                    1.2408e-06,
                    1.2619e-06,
                    1.2831e-06,
                    1.3045e-06,
                    1.3273e-06,
                    1.3502e-06,
                    1.3727e-06
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -23.6947,
                                15.30395
                            ],
                            [
                                -23.77915,
                                15.31275
                            ],
                            [
                                -23.76794,
                                15.21255
                            ],
                            [
                                -23.78931,
                                15.08975
                            ],
                            [
                                -23.7053,
                                14.95092
                            ],
                            [
                                -23.62562,
                                14.91203
                            ],
                            [
                                -23.52229,
                                14.89327
                            ],
                            [
                                -23.45586,
                                14.9843
                            ],
                            [
                                -23.45247,
                                15.03599
                            ],
                            [
                                -23.63006,
                                15.22527
                            ],
                            [
                                -23.68828,
                                15.25184
                            ],
                            [
                                -23.6947,
                                15.30395
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -25.35873,
                                17.05512
                            ],
                            [
                                -25.32699,
                                17.02032
                            ],
                            [
                                -25.29362,
                                16.90863
                            ],
                            [
                                -25.18016,
                                16.92371
                            ],
                            [
                                -25.10508,
                                17.00058
                            ],
                            [
                                -24.99948,
                                17.05035
                            ],
                            [
                                -24.97047,
                                17.10799
                            ],
                            [
                                -25.02595,
                                17.17204
                            ],
                            [
                                -25.11212,
                                17.19535
                            ],
                            [
                                -25.23253,
                                17.12886
                            ],
                            [
                                -25.3364,
                                17.09232
                            ],
                            [
                                -25.35873,
                                17.05512
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -22.96502,
                                16.03991
                            ],
                            [
                                -22.88675,
                                15.97342
                            ],
                            [
                                -22.81494,
                                15.97382
                            ],
                            [
                                -22.6884,
                                16.04339
                            ],
                            [
                                -22.66943,
                                16.09785
                            ],
                            [
                                -22.72532,
                                16.20441
                            ],
                            [
                                -22.79613,
                                16.22732
                            ],
                            [
                                -22.8322,
                                16.19761
                            ],
                            [
                                -22.91623,
                                16.22507
                            ],
                            [
                                -22.91015,
                                16.11893
                            ],
                            [
                                -22.96126,
                                16.08535
                            ],
                            [
                                -22.96502,
                                16.03991
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -24.51716,
                                14.92715
                            ],
                            [
                                -24.50956,
                                14.87978
                            ],
                            [
                                -24.42692,
                                14.8146
                            ],
                            [
                                -24.33029,
                                14.82563
                            ],
                            [
                                -24.29247,
                                14.87567
                            ],
                            [
                                -24.31516,
                                15.01342
                            ],
                            [
                                -24.38345,
                                15.04539
                            ],
                            [
                                -24.49901,
                                14.97536
                            ],
                            [
                                -24.51716,
                                14.92715
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -24.43215,
                                16.6367
                            ],
                            [
                                -24.33367,
                                16.50346
                            ],
                            [
                                -24.27014,
                                16.57648
                            ],
                            [
                                -24.19043,
                                16.58669
                            ],
                            [
                                -24.11897,
                                16.54959
                            ],
                            [
                                -24.02382,
                                16.57735
                            ],
                            [
                                -24.19626,
                                16.63766
                            ],
                            [
                                -24.29426,
                                16.63994
                            ],
                            [
                                -24.34911,
                                16.67844
                            ],
                            [
                                -24.43215,
                                16.6367
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -23.13069,
                                15.30395
                            ],
                            [
                                -23.2054,
                                15.31788
                            ],
                            [
                                -23.24056,
                                15.27012
                            ],
                            [
                                -23.25299,
                                15.16202
                            ],
                            [
                                -23.16559,
                                15.11307
                            ],
                            [
                                -23.10045,
                                15.16815
                            ],
                            [
                                -23.13069,
                                15.30395
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -25.0964,
                                16.82384
                            ],
                            [
                                -24.99826,
                                16.77088
                            ],
                            [
                                -24.87072,
                                16.81428
                            ],
                            [
                                -24.92257,
                                16.88027
                            ],
                            [
                                -24.92213,
                                16.91854
                            ],
                            [
                                -25.05624,
                                16.88214
                            ],
                            [
                                -25.0964,
                                16.82384
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -22.99458,
                                16.79963
                            ],
                            [
                                -22.98867,
                                16.72933
                            ],
                            [
                                -22.93811,
                                16.67191
                            ],
                            [
                                -22.87005,
                                16.67257
                            ],
                            [
                                -22.91385,
                                16.83931
                            ],
                            [
                                -22.99458,
                                16.79963
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -24.76223,
                                14.8379
                            ],
                            [
                                -24.70968,
                                14.80222
                            ],
                            [
                                -24.67856,
                                14.84671
                            ],
                            [
                                -24.70676,
                                14.89021
                            ],
                            [
                                -24.76223,
                                14.8379
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "CAF",
                "Country": "Central African Republic",
                "Total_3GHG": 0.08,
                "Total_3GHG_timeseries": [
                    4.1308e-07,
                    7.7535e-07,
                    1.1433e-06,
                    1.5036e-06,
                    1.8491e-06,
                    2.2251e-06,
                    2.6013e-06,
                    2.9583e-06,
                    3.3387e-06,
                    3.7173e-06,
                    4.0992e-06,
                    4.5048e-06,
                    4.9032e-06,
                    5.3118e-06,
                    5.7143e-06,
                    6.1202e-06,
                    6.5216e-06,
                    6.933e-06,
                    7.3459e-06,
                    7.7817e-06,
                    8.2326e-06,
                    8.7005e-06,
                    9.1834e-06,
                    9.7087e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013
                ],
                "Fossil_3GHG": 0.01,
                "Fossil_3GHG_timeseries": [
                    1.2165e-08,
                    2.5107e-08,
                    3.8835e-08,
                    5.3356e-08,
                    6.8678e-08,
                    8.481e-08,
                    1.0176e-07,
                    1.1953e-07,
                    1.3814e-07,
                    1.5758e-07,
                    1.7908e-07,
                    2.0265e-07,
                    2.2829e-07,
                    2.5602e-07,
                    2.8584e-07,
                    3.1778e-07,
                    3.5183e-07,
                    3.8802e-07,
                    4.2635e-07,
                    4.6683e-07,
                    5.0898e-07,
                    5.5281e-07,
                    5.9836e-07,
                    6.4564e-07,
                    6.9466e-07,
                    7.4543e-07,
                    7.9794e-07,
                    8.522e-07,
                    9.082e-07,
                    9.6591e-07,
                    1.0244e-06,
                    1.0837e-06,
                    1.1438e-06,
                    1.2047e-06,
                    1.2664e-06,
                    1.3289e-06,
                    1.3922e-06,
                    1.4564e-06,
                    1.5213e-06,
                    1.5873e-06,
                    1.6541e-06,
                    1.722e-06,
                    1.7908e-06,
                    1.8605e-06,
                    1.9313e-06,
                    2.003e-06,
                    2.0757e-06,
                    2.1495e-06,
                    2.2242e-06,
                    2.3e-06,
                    2.3775e-06,
                    2.4567e-06,
                    2.5376e-06,
                    2.6203e-06,
                    2.7048e-06,
                    2.7911e-06,
                    2.8792e-06,
                    2.9692e-06,
                    3.061e-06,
                    3.1548e-06,
                    3.2515e-06,
                    3.3511e-06,
                    3.4538e-06,
                    3.5596e-06,
                    3.6684e-06,
                    3.7803e-06,
                    3.8953e-06,
                    4.0135e-06,
                    4.1348e-06,
                    4.2594e-06,
                    4.3812e-06,
                    4.5113e-06,
                    4.6499e-06,
                    4.7974e-06,
                    4.9542e-06,
                    5.1205e-06,
                    5.2966e-06,
                    5.4828e-06,
                    5.6796e-06,
                    5.8872e-06,
                    6.1058e-06,
                    6.3144e-06,
                    6.5138e-06,
                    6.7045e-06,
                    6.8871e-06,
                    7.062e-06,
                    7.2424e-06,
                    7.4283e-06,
                    7.6204e-06,
                    7.8187e-06,
                    8.0322e-06,
                    8.2508e-06,
                    8.4745e-06,
                    8.7078e-06,
                    8.9497e-06,
                    9.2003e-06,
                    9.4599e-06,
                    9.7288e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_3GHG": 0.21,
                "Land_3GHG_timeseries": [
                    4.0091e-07,
                    7.5024e-07,
                    1.1045e-06,
                    1.4503e-06,
                    1.7805e-06,
                    2.1403e-06,
                    2.4995e-06,
                    2.8387e-06,
                    3.2005e-06,
                    3.5597e-06,
                    3.9201e-06,
                    4.3022e-06,
                    4.6749e-06,
                    5.0558e-06,
                    5.4284e-06,
                    5.8024e-06,
                    6.1698e-06,
                    6.545e-06,
                    6.9195e-06,
                    7.3148e-06,
                    7.7236e-06,
                    8.1477e-06,
                    8.585e-06,
                    9.063e-06,
                    9.5584e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012
                ],
                "Total_CO2": 0.04,
                "Total_CO2_timeseries": [
                    2.6748e-07,
                    4.811e-07,
                    6.9744e-07,
                    9.0335e-07,
                    1.0918e-06,
                    1.3082e-06,
                    1.5226e-06,
                    1.7158e-06,
                    1.9308e-06,
                    2.1428e-06,
                    2.352e-06,
                    2.5791e-06,
                    2.7931e-06,
                    3.0115e-06,
                    3.2179e-06,
                    3.4219e-06,
                    3.6155e-06,
                    3.8132e-06,
                    4.0063e-06,
                    4.2163e-06,
                    4.4334e-06,
                    4.6562e-06,
                    4.8801e-06,
                    5.1308e-06,
                    5.3841e-06,
                    5.6157e-06,
                    5.8388e-06,
                    6.0845e-06,
                    6.3255e-06,
                    6.5855e-06,
                    6.8616e-06,
                    7.1249e-06,
                    7.3949e-06,
                    7.6617e-06,
                    7.929e-06,
                    8.21e-06,
                    8.5161e-06,
                    8.8111e-06,
                    9.1118e-06,
                    9.4133e-06,
                    9.7386e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2.1172e-08,
                    4.9402e-08,
                    8.6012e-08,
                    1.1689e-07,
                    1.4953e-07,
                    1.8173e-07,
                    2.2363e-07,
                    2.6862e-07,
                    3.2023e-07,
                    3.6478e-07,
                    4.0438e-07,
                    4.4398e-07,
                    4.7698e-07,
                    5.0998e-07,
                    5.4298e-07,
                    5.8258e-07,
                    6.2053e-07,
                    6.6178e-07,
                    7.4428e-07,
                    8.2843e-07,
                    9.2248e-07,
                    1.005e-06,
                    1.0809e-06,
                    1.1535e-06,
                    1.2046e-06,
                    1.2508e-06,
                    1.3086e-06,
                    1.3663e-06,
                    1.4323e-06,
                    1.4785e-06,
                    1.5264e-06,
                    1.5874e-06,
                    1.6518e-06,
                    1.7178e-06,
                    1.7854e-06,
                    1.858e-06,
                    1.9306e-06,
                    2.0478e-06,
                    2.1517e-06,
                    2.2639e-06,
                    2.3464e-06,
                    2.4322e-06,
                    2.5197e-06,
                    2.6088e-06,
                    2.7028e-06,
                    2.7969e-06,
                    2.8926e-06,
                    2.9899e-06,
                    3.0889e-06,
                    3.1929e-06,
                    3.2985e-06,
                    3.409e-06,
                    3.5179e-06,
                    3.6186e-06,
                    3.7176e-06,
                    3.8149e-06,
                    3.9172e-06,
                    4.0212e-06,
                    4.0954e-06,
                    4.168e-06,
                    4.2439e-06,
                    4.3281e-06,
                    4.4139e-06,
                    4.4667e-06,
                    4.5228e-06,
                    4.6036e-06,
                    4.6927e-06,
                    4.7901e-06,
                    4.8891e-06,
                    4.9914e-06,
                    5.0986e-06,
                    5.2109e-06,
                    5.3127e-06
                ],
                "Land_CO2": 0.13,
                "Land_CO2_timeseries": [
                    2.6748e-07,
                    4.811e-07,
                    6.9744e-07,
                    9.0335e-07,
                    1.0918e-06,
                    1.3082e-06,
                    1.5226e-06,
                    1.7158e-06,
                    1.9308e-06,
                    2.1428e-06,
                    2.352e-06,
                    2.5791e-06,
                    2.7931e-06,
                    3.0115e-06,
                    3.2179e-06,
                    3.4219e-06,
                    3.6155e-06,
                    3.8132e-06,
                    4.0063e-06,
                    4.2163e-06,
                    4.4334e-06,
                    4.6562e-06,
                    4.8801e-06,
                    5.1308e-06,
                    5.3841e-06,
                    5.6157e-06,
                    5.8388e-06,
                    6.0845e-06,
                    6.3255e-06,
                    6.5855e-06,
                    6.8616e-06,
                    7.1249e-06,
                    7.3949e-06,
                    7.6617e-06,
                    7.929e-06,
                    8.21e-06,
                    8.5161e-06,
                    8.8111e-06,
                    9.1118e-06,
                    9.4133e-06,
                    9.7386e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Total_CH4": 0.13,
                "Total_CH4_timeseries": [
                    3.2385e-08,
                    6.5547e-08,
                    9.9497e-08,
                    1.3424e-07,
                    1.698e-07,
                    2.0616e-07,
                    2.4335e-07,
                    2.8138e-07,
                    3.2025e-07,
                    3.5997e-07,
                    4.0542e-07,
                    4.566e-07,
                    5.1353e-07,
                    5.7622e-07,
                    6.4468e-07,
                    7.1891e-07,
                    7.9894e-07,
                    8.8476e-07,
                    9.764e-07,
                    1.0739e-06,
                    1.1772e-06,
                    1.2864e-06,
                    1.4015e-06,
                    1.5225e-06,
                    1.6494e-06,
                    1.7821e-06,
                    1.9208e-06,
                    2.0653e-06,
                    2.2158e-06,
                    2.3722e-06,
                    2.5308e-06,
                    2.6915e-06,
                    2.8545e-06,
                    3.0198e-06,
                    3.1872e-06,
                    3.3569e-06,
                    3.5288e-06,
                    3.703e-06,
                    3.8794e-06,
                    4.0581e-06,
                    4.2393e-06,
                    4.423e-06,
                    4.6093e-06,
                    4.7981e-06,
                    4.9895e-06,
                    5.1835e-06,
                    5.3801e-06,
                    5.5792e-06,
                    5.7809e-06,
                    5.9853e-06,
                    6.1933e-06,
                    6.405e-06,
                    6.6204e-06,
                    6.8396e-06,
                    7.0625e-06,
                    7.2892e-06,
                    7.5197e-06,
                    7.7541e-06,
                    7.9923e-06,
                    8.2345e-06,
                    8.4849e-06,
                    8.7436e-06,
                    9.0106e-06,
                    9.2861e-06,
                    9.5699e-06,
                    9.8621e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Fossil_CH4": 0.02,
                "Fossil_CH4_timeseries": [
                    1.1331e-08,
                    2.3422e-08,
                    3.6283e-08,
                    4.9922e-08,
                    6.435e-08,
                    7.9574e-08,
                    9.5605e-08,
                    1.1245e-07,
                    1.3013e-07,
                    1.4864e-07,
                    1.692e-07,
                    1.9183e-07,
                    2.1653e-07,
                    2.4332e-07,
                    2.722e-07,
                    3.032e-07,
                    3.3631e-07,
                    3.7155e-07,
                    4.0893e-07,
                    4.4847e-07,
                    4.8965e-07,
                    5.3249e-07,
                    5.7698e-07,
                    6.2313e-07,
                    6.7094e-07,
                    7.2042e-07,
                    7.7158e-07,
                    8.2441e-07,
                    8.7893e-07,
                    9.3514e-07,
                    9.9211e-07,
                    1.0499e-06,
                    1.1084e-06,
                    1.1677e-06,
                    1.2279e-06,
                    1.2888e-06,
                    1.3505e-06,
                    1.413e-06,
                    1.4764e-06,
                    1.5406e-06,
                    1.6057e-06,
                    1.6716e-06,
                    1.7385e-06,
                    1.8064e-06,
                    1.8751e-06,
                    1.9448e-06,
                    2.0154e-06,
                    2.087e-06,
                    2.1595e-06,
                    2.233e-06,
                    2.3081e-06,
                    2.3848e-06,
                    2.4631e-06,
                    2.5431e-06,
                    2.6249e-06,
                    2.7083e-06,
                    2.7934e-06,
                    2.8803e-06,
                    2.969e-06,
                    3.0595e-06,
                    3.1529e-06,
                    3.2493e-06,
                    3.3486e-06,
                    3.4509e-06,
                    3.5562e-06,
                    3.6646e-06,
                    3.7761e-06,
                    3.8906e-06,
                    4.0083e-06,
                    4.1292e-06,
                    4.2472e-06,
                    4.3735e-06,
                    4.5082e-06,
                    4.6519e-06,
                    4.8047e-06,
                    4.967e-06,
                    5.139e-06,
                    5.3211e-06,
                    5.5136e-06,
                    5.717e-06,
                    5.9312e-06,
                    6.1354e-06,
                    6.3302e-06,
                    6.5162e-06,
                    6.6938e-06,
                    6.8637e-06,
                    7.0388e-06,
                    7.2192e-06,
                    7.4056e-06,
                    7.5981e-06,
                    7.8056e-06,
                    8.0178e-06,
                    8.2349e-06,
                    8.4613e-06,
                    8.6958e-06,
                    8.9386e-06,
                    9.1902e-06,
                    9.4506e-06,
                    9.7199e-06,
                    9.9983e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CH4": 0.3,
                "Land_CH4_timeseries": [
                    2.1054e-08,
                    4.2125e-08,
                    6.3214e-08,
                    8.4321e-08,
                    1.0545e-07,
                    1.2659e-07,
                    1.4775e-07,
                    1.6892e-07,
                    1.9012e-07,
                    2.1133e-07,
                    2.3622e-07,
                    2.6477e-07,
                    2.97e-07,
                    3.329e-07,
                    3.7247e-07,
                    4.1571e-07,
                    4.6263e-07,
                    5.1321e-07,
                    5.6747e-07,
                    6.254e-07,
                    6.8755e-07,
                    7.5393e-07,
                    8.2453e-07,
                    8.9936e-07,
                    9.7841e-07,
                    1.0617e-06,
                    1.1492e-06,
                    1.2409e-06,
                    1.3369e-06,
                    1.437e-06,
                    1.5386e-06,
                    1.6417e-06,
                    1.7461e-06,
                    1.852e-06,
                    1.9594e-06,
                    2.0681e-06,
                    2.1783e-06,
                    2.2899e-06,
                    2.403e-06,
                    2.5175e-06,
                    2.6336e-06,
                    2.7514e-06,
                    2.8707e-06,
                    2.9918e-06,
                    3.1144e-06,
                    3.2387e-06,
                    3.3647e-06,
                    3.4922e-06,
                    3.6214e-06,
                    3.7523e-06,
                    3.8852e-06,
                    4.0202e-06,
                    4.1573e-06,
                    4.2964e-06,
                    4.4376e-06,
                    4.5809e-06,
                    4.7263e-06,
                    4.8738e-06,
                    5.0233e-06,
                    5.1749e-06,
                    5.3319e-06,
                    5.4943e-06,
                    5.662e-06,
                    5.8351e-06,
                    6.0136e-06,
                    6.1975e-06,
                    6.3867e-06,
                    6.5813e-06,
                    6.7813e-06,
                    6.9866e-06,
                    7.1985e-06,
                    7.4169e-06,
                    7.6418e-06,
                    7.8732e-06,
                    8.1112e-06,
                    8.3556e-06,
                    8.6066e-06,
                    8.8641e-06,
                    9.1281e-06,
                    9.3987e-06,
                    9.6746e-06,
                    9.9558e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Total_N2O": 0.3,
                "Total_N2O_timeseries": [
                    1.1322e-07,
                    2.287e-07,
                    3.4635e-07,
                    4.6603e-07,
                    5.8757e-07,
                    7.1076e-07,
                    8.3536e-07,
                    9.6107e-07,
                    1.0876e-06,
                    1.2146e-06,
                    1.3417e-06,
                    1.4691e-06,
                    1.5965e-06,
                    1.7241e-06,
                    1.8517e-06,
                    1.9794e-06,
                    2.1072e-06,
                    2.2351e-06,
                    2.3632e-06,
                    2.4915e-06,
                    2.622e-06,
                    2.7579e-06,
                    2.9018e-06,
                    3.0553e-06,
                    3.2196e-06,
                    3.3949e-06,
                    3.5806e-06,
                    3.7754e-06,
                    3.9774e-06,
                    4.1836e-06,
                    4.3924e-06,
                    4.6032e-06,
                    4.8157e-06,
                    5.0297e-06,
                    5.245e-06,
                    5.4616e-06,
                    5.6795e-06,
                    5.8986e-06,
                    6.1193e-06,
                    6.3517e-06,
                    6.5862e-06,
                    6.8231e-06,
                    7.0625e-06,
                    7.3043e-06,
                    7.5489e-06,
                    7.7962e-06,
                    8.0463e-06,
                    8.2994e-06,
                    8.5554e-06,
                    8.8145e-06,
                    9.0767e-06,
                    9.3417e-06,
                    9.6097e-06,
                    9.8807e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_N2O": 0.01,
                "Fossil_N2O_timeseries": [
                    8.344e-10,
                    1.6853e-09,
                    2.5519e-09,
                    3.4334e-09,
                    4.3284e-09,
                    5.2355e-09,
                    6.1529e-09,
                    7.0786e-09,
                    8.0102e-09,
                    8.9453e-09,
                    9.882e-09,
                    1.082e-08,
                    1.1759e-08,
                    1.2699e-08,
                    1.364e-08,
                    1.4582e-08,
                    1.5524e-08,
                    1.6468e-08,
                    1.7413e-08,
                    1.8359e-08,
                    1.9322e-08,
                    2.0324e-08,
                    2.1383e-08,
                    2.2512e-08,
                    2.3719e-08,
                    2.5004e-08,
                    2.6365e-08,
                    2.7791e-08,
                    2.9269e-08,
                    3.0778e-08,
                    3.2306e-08,
                    3.3848e-08,
                    3.5402e-08,
                    3.6968e-08,
                    3.8543e-08,
                    4.0128e-08,
                    4.1722e-08,
                    4.3326e-08,
                    4.494e-08,
                    4.6691e-08,
                    4.8485e-08,
                    5.0325e-08,
                    5.2215e-08,
                    5.4156e-08,
                    5.6152e-08,
                    5.8206e-08,
                    6.0321e-08,
                    6.2498e-08,
                    6.4741e-08,
                    6.7052e-08,
                    6.944e-08,
                    7.1915e-08,
                    7.4486e-08,
                    7.7159e-08,
                    7.9936e-08,
                    8.2817e-08,
                    8.5797e-08,
                    8.887e-08,
                    9.2025e-08,
                    9.5249e-08,
                    9.8532e-08,
                    1.0187e-07,
                    1.0525e-07,
                    1.0869e-07,
                    1.1217e-07,
                    1.1569e-07,
                    1.1926e-07,
                    1.2287e-07,
                    1.2653e-07,
                    1.3024e-07,
                    1.3399e-07,
                    1.378e-07,
                    1.4166e-07,
                    1.4557e-07,
                    1.4953e-07,
                    1.5354e-07,
                    1.576e-07,
                    1.6173e-07,
                    1.6592e-07,
                    1.7019e-07,
                    1.7454e-07,
                    1.7901e-07,
                    1.836e-07,
                    1.8835e-07,
                    1.9326e-07,
                    1.9834e-07,
                    2.0361e-07,
                    2.0907e-07,
                    2.1472e-07,
                    2.2057e-07,
                    2.2663e-07,
                    2.3296e-07,
                    2.396e-07,
                    2.4657e-07,
                    2.5391e-07,
                    2.6161e-07,
                    2.6971e-07,
                    2.7818e-07,
                    2.8703e-07,
                    2.9624e-07,
                    3.0582e-07,
                    3.1582e-07,
                    3.2629e-07,
                    3.3723e-07,
                    3.4867e-07,
                    3.6059e-07,
                    3.7298e-07,
                    3.8581e-07,
                    3.9903e-07,
                    4.1258e-07,
                    4.2642e-07,
                    4.4051e-07,
                    4.5486e-07,
                    4.6946e-07,
                    4.8432e-07,
                    4.9947e-07,
                    5.1493e-07,
                    5.3076e-07,
                    5.4701e-07,
                    5.6468e-07,
                    5.8246e-07,
                    6.0067e-07,
                    6.1968e-07,
                    6.3972e-07,
                    6.6077e-07,
                    6.8252e-07,
                    7.0463e-07,
                    7.273e-07,
                    7.5084e-07,
                    7.7499e-07,
                    8.0029e-07,
                    8.364e-07,
                    8.7237e-07,
                    9.085e-07,
                    9.458e-07,
                    9.8517e-07,
                    1.0249e-06,
                    1.0635e-06,
                    1.1048e-06,
                    1.146e-06,
                    1.1879e-06,
                    1.2305e-06,
                    1.2727e-06,
                    1.314e-06,
                    1.3563e-06,
                    1.3951e-06,
                    1.4344e-06,
                    1.4743e-06,
                    1.5092e-06,
                    1.5453e-06,
                    1.5818e-06,
                    1.6186e-06,
                    1.6556e-06,
                    1.6932e-06,
                    1.7315e-06,
                    1.7706e-06,
                    1.8139e-06,
                    1.8577e-06,
                    1.9024e-06,
                    1.948e-06,
                    1.9944e-06,
                    2.0413e-06,
                    2.0871e-06,
                    2.1323e-06,
                    2.1774e-06,
                    2.2231e-06,
                    2.2695e-06,
                    2.3167e-06,
                    2.3655e-06,
                    2.4148e-06,
                    2.4646e-06,
                    2.5157e-06
                ],
                "Land_N2O": 0.41,
                "Land_N2O_timeseries": [
                    1.1238e-07,
                    2.2701e-07,
                    3.438e-07,
                    4.6259e-07,
                    5.8324e-07,
                    7.0552e-07,
                    8.292e-07,
                    9.54e-07,
                    1.0796e-06,
                    1.2056e-06,
                    1.3318e-06,
                    1.4582e-06,
                    1.5848e-06,
                    1.7114e-06,
                    1.838e-06,
                    1.9648e-06,
                    2.0916e-06,
                    2.2186e-06,
                    2.3458e-06,
                    2.4731e-06,
                    2.6027e-06,
                    2.7376e-06,
                    2.8804e-06,
                    3.0328e-06,
                    3.1959e-06,
                    3.3699e-06,
                    3.5542e-06,
                    3.7476e-06,
                    3.9481e-06,
                    4.1529e-06,
                    4.3601e-06,
                    4.5693e-06,
                    4.7803e-06,
                    4.9927e-06,
                    5.2065e-06,
                    5.4215e-06,
                    5.6377e-06,
                    5.8553e-06,
                    6.0744e-06,
                    6.305e-06,
                    6.5377e-06,
                    6.7728e-06,
                    7.0102e-06,
                    7.2502e-06,
                    7.4927e-06,
                    7.738e-06,
                    7.986e-06,
                    8.2369e-06,
                    8.4907e-06,
                    8.7475e-06,
                    9.0072e-06,
                    9.2698e-06,
                    9.5352e-06,
                    9.8035e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            16.19199,
                            2.22051
                        ],
                        [
                            16.51902,
                            2.84091
                        ],
                        [
                            16.49059,
                            2.91218
                        ],
                        [
                            16.49337,
                            3.00055
                        ],
                        [
                            16.54347,
                            3.0688
                        ],
                        [
                            16.5068,
                            3.16246
                        ],
                        [
                            16.55721,
                            3.25259
                        ],
                        [
                            16.59703,
                            3.4771
                        ],
                        [
                            16.67094,
                            3.54083
                        ],
                        [
                            16.75364,
                            3.55638
                        ],
                        [
                            16.85518,
                            3.51142
                        ],
                        [
                            16.87036,
                            3.55069
                        ],
                        [
                            16.95622,
                            3.5588
                        ],
                        [
                            17.06,
                            3.54708
                        ],
                        [
                            17.24094,
                            3.58031
                        ],
                        [
                            17.29556,
                            3.62865
                        ],
                        [
                            17.36728,
                            3.61302
                        ],
                        [
                            17.396,
                            3.66254
                        ],
                        [
                            17.47552,
                            3.7029
                        ],
                        [
                            17.54065,
                            3.68663
                        ],
                        [
                            17.60485,
                            3.64192
                        ],
                        [
                            17.73478,
                            3.65011
                        ],
                        [
                            17.82886,
                            3.62572
                        ],
                        [
                            17.86198,
                            3.53376
                        ],
                        [
                            17.94378,
                            3.59815
                        ],
                        [
                            18.11951,
                            3.56718
                        ],
                        [
                            18.17547,
                            3.49034
                        ],
                        [
                            18.22746,
                            3.4897
                        ],
                        [
                            18.26465,
                            3.5851
                        ],
                        [
                            18.34472,
                            3.60661
                        ],
                        [
                            18.4084,
                            3.57922
                        ],
                        [
                            18.48923,
                            3.65152
                        ],
                        [
                            18.54091,
                            3.60121
                        ],
                        [
                            18.59516,
                            3.47824
                        ],
                        [
                            18.62508,
                            3.47165
                        ],
                        [
                            18.60605,
                            3.5339
                        ],
                        [
                            18.59108,
                            3.76899
                        ],
                        [
                            18.61474,
                            3.81832
                        ],
                        [
                            18.61697,
                            3.91627
                        ],
                        [
                            18.65192,
                            3.99433
                        ],
                        [
                            18.64325,
                            4.10503
                        ],
                        [
                            18.6,
                            4.22168
                        ],
                        [
                            18.54293,
                            4.31945
                        ],
                        [
                            18.60021,
                            4.36969
                        ],
                        [
                            18.7005,
                            4.36509
                        ],
                        [
                            18.75569,
                            4.39701
                        ],
                        [
                            18.80034,
                            4.46339
                        ],
                        [
                            18.82774,
                            4.57171
                        ],
                        [
                            18.9378,
                            4.69859
                        ],
                        [
                            19.00181,
                            4.74794
                        ],
                        [
                            19.094,
                            4.92453
                        ],
                        [
                            19.18682,
                            4.94289
                        ],
                        [
                            19.25067,
                            5.01629
                        ],
                        [
                            19.34662,
                            5.06437
                        ],
                        [
                            19.39453,
                            5.11687
                        ],
                        [
                            19.47961,
                            5.12187
                        ],
                        [
                            19.53283,
                            5.14847
                        ],
                        [
                            19.61213,
                            5.13347
                        ],
                        [
                            19.68874,
                            5.14209
                        ],
                        [
                            19.80754,
                            5.10368
                        ],
                        [
                            19.85241,
                            5.07231
                        ],
                        [
                            19.90136,
                            4.99579
                        ],
                        [
                            20.01238,
                            4.97429
                        ],
                        [
                            20.10753,
                            4.90068
                        ],
                        [
                            20.16389,
                            4.8793
                        ],
                        [
                            20.26112,
                            4.78925
                        ],
                        [
                            20.33832,
                            4.76321
                        ],
                        [
                            20.45226,
                            4.62836
                        ],
                        [
                            20.4629,
                            4.51346
                        ],
                        [
                            20.58196,
                            4.41671
                        ],
                        [
                            20.80573,
                            4.42555
                        ],
                        [
                            20.86025,
                            4.4464
                        ],
                        [
                            21.07616,
                            4.39704
                        ],
                        [
                            21.11665,
                            4.34865
                        ],
                        [
                            21.21398,
                            4.29532
                        ],
                        [
                            21.29189,
                            4.33701
                        ],
                        [
                            21.33541,
                            4.29603
                        ],
                        [
                            21.40113,
                            4.27646
                        ],
                        [
                            21.56796,
                            4.25641
                        ],
                        [
                            21.64164,
                            4.30874
                        ],
                        [
                            21.73116,
                            4.30878
                        ],
                        [
                            21.85726,
                            4.2486
                        ],
                        [
                            21.99663,
                            4.2453
                        ],
                        [
                            22.09983,
                            4.21041
                        ],
                        [
                            22.19299,
                            4.14844
                        ],
                        [
                            22.27761,
                            4.11929
                        ],
                        [
                            22.37193,
                            4.1169
                        ],
                        [
                            22.48314,
                            4.15491
                        ],
                        [
                            22.54146,
                            4.2137
                        ],
                        [
                            22.54055,
                            4.27426
                        ],
                        [
                            22.57732,
                            4.34402
                        ],
                        [
                            22.60167,
                            4.47669
                        ],
                        [
                            22.67836,
                            4.47736
                        ],
                        [
                            22.72877,
                            4.55952
                        ],
                        [
                            22.73438,
                            4.62693
                        ],
                        [
                            22.7983,
                            4.72658
                        ],
                        [
                            22.8379,
                            4.70435
                        ],
                        [
                            22.89677,
                            4.75848
                        ],
                        [
                            22.90682,
                            4.81969
                        ],
                        [
                            22.98082,
                            4.82757
                        ],
                        [
                            23.00865,
                            4.75853
                        ],
                        [
                            23.11195,
                            4.71335
                        ],
                        [
                            23.19457,
                            4.72663
                        ],
                        [
                            23.27473,
                            4.63458
                        ],
                        [
                            23.3814,
                            4.59617
                        ],
                        [
                            23.42939,
                            4.60238
                        ],
                        [
                            23.45688,
                            4.67424
                        ],
                        [
                            23.53589,
                            4.69783
                        ],
                        [
                            23.59265,
                            4.76126
                        ],
                        [
                            23.77633,
                            4.78576
                        ],
                        [
                            23.81945,
                            4.82205
                        ],
                        [
                            23.8886,
                            4.83447
                        ],
                        [
                            23.95337,
                            4.81187
                        ],
                        [
                            23.97236,
                            4.87544
                        ],
                        [
                            24.04108,
                            4.86641
                        ],
                        [
                            24.11041,
                            4.91599
                        ],
                        [
                            24.13805,
                            4.89684
                        ],
                        [
                            24.27985,
                            4.99098
                        ],
                        [
                            24.33312,
                            5.01093
                        ],
                        [
                            24.37786,
                            5.11199
                        ],
                        [
                            24.53743,
                            5.07709
                        ],
                        [
                            24.65862,
                            4.9757
                        ],
                        [
                            24.67735,
                            4.91006
                        ],
                        [
                            24.77784,
                            4.89616
                        ],
                        [
                            24.86304,
                            4.95228
                        ],
                        [
                            24.95646,
                            4.98662
                        ],
                        [
                            25.06151,
                            4.92832
                        ],
                        [
                            25.12373,
                            5.0115
                        ],
                        [
                            25.16808,
                            5.00433
                        ],
                        [
                            25.30916,
                            5.03148
                        ],
                        [
                            25.34176,
                            5.10888
                        ],
                        [
                            25.30968,
                            5.1893
                        ],
                        [
                            25.34304,
                            5.27322
                        ],
                        [
                            25.38621,
                            5.31932
                        ],
                        [
                            25.50013,
                            5.34592
                        ],
                        [
                            25.56818,
                            5.38075
                        ],
                        [
                            25.59705,
                            5.32645
                        ],
                        [
                            25.70464,
                            5.30065
                        ],
                        [
                            25.77615,
                            5.25635
                        ],
                        [
                            25.8287,
                            5.1944
                        ],
                        [
                            25.95675,
                            5.21525
                        ],
                        [
                            26.09155,
                            5.21368
                        ],
                        [
                            26.13221,
                            5.26606
                        ],
                        [
                            26.20782,
                            5.23725
                        ],
                        [
                            26.2506,
                            5.17725
                        ],
                        [
                            26.38608,
                            5.1493
                        ],
                        [
                            26.52088,
                            5.05
                        ],
                        [
                            26.58359,
                            5.08639
                        ],
                        [
                            26.66578,
                            5.08248
                        ],
                        [
                            26.76839,
                            5.10279
                        ],
                        [
                            26.80387,
                            5.05154
                        ],
                        [
                            26.8543,
                            5.04104
                        ],
                        [
                            26.92999,
                            5.1424
                        ],
                        [
                            27.09389,
                            5.20837
                        ],
                        [
                            27.14906,
                            5.20145
                        ],
                        [
                            27.23022,
                            5.15317
                        ],
                        [
                            27.42592,
                            5.0821
                        ],
                        [
                            27.44361,
                            5.01944
                        ],
                        [
                            27.45331,
                            5.07567
                        ],
                        [
                            27.39533,
                            5.15424
                        ],
                        [
                            27.30367,
                            5.22577
                        ],
                        [
                            27.24953,
                            5.32846
                        ],
                        [
                            27.23291,
                            5.42625
                        ],
                        [
                            27.283,
                            5.58581
                        ],
                        [
                            27.23189,
                            5.61163
                        ],
                        [
                            27.21778,
                            5.68793
                        ],
                        [
                            27.16048,
                            5.75966
                        ],
                        [
                            27.05215,
                            5.79155
                        ],
                        [
                            27.01718,
                            5.84783
                        ],
                        [
                            26.86607,
                            5.90283
                        ],
                        [
                            26.84542,
                            5.9828
                        ],
                        [
                            26.78462,
                            6.00936
                        ],
                        [
                            26.67299,
                            5.99205
                        ],
                        [
                            26.57444,
                            6.02734
                        ],
                        [
                            26.51623,
                            6.11382
                        ],
                        [
                            26.53289,
                            6.23224
                        ],
                        [
                            26.47942,
                            6.27595
                        ],
                        [
                            26.39372,
                            6.30527
                        ],
                        [
                            26.33671,
                            6.38097
                        ],
                        [
                            26.29863,
                            6.48658
                        ],
                        [
                            26.379,
                            6.58177
                        ],
                        [
                            26.4117,
                            6.65303
                        ],
                        [
                            26.25754,
                            6.73869
                        ],
                        [
                            26.20851,
                            6.74759
                        ],
                        [
                            26.17181,
                            6.8115
                        ],
                        [
                            26.07093,
                            6.83049
                        ],
                        [
                            26.03783,
                            6.97181
                        ],
                        [
                            25.98152,
                            7.03997
                        ],
                        [
                            25.86948,
                            7.0812
                        ],
                        [
                            25.82184,
                            7.1537
                        ],
                        [
                            25.62001,
                            7.21962
                        ],
                        [
                            25.49942,
                            7.30483
                        ],
                        [
                            25.44897,
                            7.3062
                        ],
                        [
                            25.35811,
                            7.34685
                        ],
                        [
                            25.33302,
                            7.42684
                        ],
                        [
                            25.28053,
                            7.4721
                        ],
                        [
                            25.2029,
                            7.49329
                        ],
                        [
                            25.16725,
                            7.57944
                        ],
                        [
                            25.28682,
                            7.65694
                        ],
                        [
                            25.28312,
                            7.79417
                        ],
                        [
                            25.21871,
                            7.88026
                        ],
                        [
                            25.16917,
                            7.91326
                        ],
                        [
                            25.08518,
                            7.8956
                        ],
                        [
                            25.03598,
                            7.94828
                        ],
                        [
                            24.97895,
                            7.95889
                        ],
                        [
                            24.94161,
                            8.03591
                        ],
                        [
                            24.90156,
                            8.05176
                        ],
                        [
                            24.85914,
                            8.17309
                        ],
                        [
                            24.74895,
                            8.18408
                        ],
                        [
                            24.64461,
                            8.22132
                        ],
                        [
                            24.56069,
                            8.20244
                        ],
                        [
                            24.4953,
                            8.236
                        ],
                        [
                            24.48037,
                            8.28339
                        ],
                        [
                            24.3602,
                            8.25172
                        ],
                        [
                            24.20381,
                            8.30517
                        ],
                        [
                            24.15569,
                            8.37084
                        ],
                        [
                            24.16339,
                            8.48075
                        ],
                        [
                            24.203,
                            8.50025
                        ],
                        [
                            24.25439,
                            8.59311
                        ],
                        [
                            24.22336,
                            8.64215
                        ],
                        [
                            24.2301,
                            8.69942
                        ],
                        [
                            24.14226,
                            8.6822
                        ],
                        [
                            24.0528,
                            8.69354
                        ],
                        [
                            23.96455,
                            8.65512
                        ],
                        [
                            23.94856,
                            8.71369
                        ],
                        [
                            23.85451,
                            8.72931
                        ],
                        [
                            23.77671,
                            8.70719
                        ],
                        [
                            23.67732,
                            8.72573
                        ],
                        [
                            23.62527,
                            8.75411
                        ],
                        [
                            23.54586,
                            8.70096
                        ],
                        [
                            23.49849,
                            8.80897
                        ],
                        [
                            23.58876,
                            8.97298
                        ],
                        [
                            23.50475,
                            8.9519
                        ],
                        [
                            23.45234,
                            8.97906
                        ],
                        [
                            23.4821,
                            9.17233
                        ],
                        [
                            23.59293,
                            9.20933
                        ],
                        [
                            23.65876,
                            9.28955
                        ],
                        [
                            23.63869,
                            9.37571
                        ],
                        [
                            23.67143,
                            9.44881
                        ],
                        [
                            23.63214,
                            9.49146
                        ],
                        [
                            23.63144,
                            9.56108
                        ],
                        [
                            23.69866,
                            9.67857
                        ],
                        [
                            23.67133,
                            9.901
                        ],
                        [
                            23.3185,
                            10.4638
                        ],
                        [
                            23.15124,
                            10.5939
                        ],
                        [
                            23.1156,
                            10.64839
                        ],
                        [
                            23.00728,
                            10.70964
                        ],
                        [
                            22.87551,
                            10.93137
                        ],
                        [
                            22.76829,
                            10.94531
                        ],
                        [
                            22.73538,
                            10.97356
                        ],
                        [
                            22.52415,
                            11.00587
                        ],
                        [
                            22.3279,
                            10.95499
                        ],
                        [
                            22.19748,
                            10.90846
                        ],
                        [
                            22.15474,
                            10.87791
                        ],
                        [
                            22.07486,
                            10.89473
                        ],
                        [
                            21.93117,
                            10.8571
                        ],
                        [
                            21.88275,
                            10.86882
                        ],
                        [
                            21.79031,
                            10.79403
                        ],
                        [
                            21.7868,
                            10.6694
                        ],
                        [
                            21.73423,
                            10.65002
                        ],
                        [
                            21.71877,
                            10.50924
                        ],
                        [
                            21.7643,
                            10.40217
                        ],
                        [
                            21.70601,
                            10.27823
                        ],
                        [
                            21.66871,
                            10.2334
                        ],
                        [
                            21.59009,
                            10.21301
                        ],
                        [
                            21.54394,
                            10.22551
                        ],
                        [
                            21.45137,
                            10.12246
                        ],
                        [
                            21.45364,
                            10.088
                        ],
                        [
                            21.39118,
                            9.99932
                        ],
                        [
                            21.33661,
                            9.96659
                        ],
                        [
                            21.25562,
                            9.98943
                        ],
                        [
                            21.199,
                            9.89725
                        ],
                        [
                            21.13144,
                            9.84496
                        ],
                        [
                            21.09294,
                            9.77802
                        ],
                        [
                            21.02529,
                            9.7612
                        ],
                        [
                            20.99286,
                            9.65298
                        ],
                        [
                            20.95129,
                            9.60894
                        ],
                        [
                            20.91699,
                            9.5284
                        ],
                        [
                            20.76991,
                            9.42634
                        ],
                        [
                            20.66674,
                            9.39622
                        ],
                        [
                            20.6042,
                            9.31829
                        ],
                        [
                            20.52855,
                            9.33458
                        ],
                        [
                            20.45573,
                            9.17485
                        ],
                        [
                            20.35377,
                            9.12941
                        ],
                        [
                            20.1024,
                            9.15443
                        ],
                        [
                            20.01433,
                            9.12479
                        ],
                        [
                            19.9252,
                            9.06317
                        ],
                        [
                            19.82036,
                            9.06185
                        ],
                        [
                            19.66833,
                            9.0218
                        ],
                        [
                            19.57235,
                            9.0382
                        ],
                        [
                            19.48087,
                            9.01619
                        ],
                        [
                            19.43749,
                            9.02901
                        ],
                        [
                            19.30487,
                            9.00881
                        ],
                        [
                            19.21828,
                            9.02958
                        ],
                        [
                            19.13461,
                            9.00597
                        ],
                        [
                            19.08039,
                            9.01441
                        ],
                        [
                            18.99003,
                            8.97491
                        ],
                        [
                            18.86797,
                            8.87171
                        ],
                        [
                            18.92318,
                            8.80304
                        ],
                        [
                            19.01744,
                            8.76132
                        ],
                        [
                            19.11901,
                            8.67171
                        ],
                        [
                            19.06781,
                            8.63598
                        ],
                        [
                            19.02867,
                            8.53453
                        ],
                        [
                            18.92217,
                            8.41899
                        ],
                        [
                            18.92392,
                            8.39555
                        ],
                        [
                            18.79946,
                            8.25937
                        ],
                        [
                            18.66392,
                            8.20119
                        ],
                        [
                            18.6301,
                            8.14285
                        ],
                        [
                            18.63521,
                            8.08965
                        ],
                        [
                            18.5918,
                            8.04625
                        ],
                        [
                            18.26524,
                            8.02127
                        ],
                        [
                            18.04098,
                            8.00979
                        ],
                        [
                            17.92516,
                            7.95962
                        ],
                        [
                            17.6737,
                            7.98158
                        ],
                        [
                            17.6489,
                            7.94843
                        ],
                        [
                            17.51334,
                            7.87186
                        ],
                        [
                            17.47097,
                            7.89239
                        ],
                        [
                            17.36917,
                            7.8484
                        ],
                        [
                            17.23086,
                            7.76009
                        ],
                        [
                            17.15705,
                            7.66646
                        ],
                        [
                            16.95587,
                            7.63468
                        ],
                        [
                            16.90189,
                            7.61423
                        ],
                        [
                            16.8654,
                            7.53874
                        ],
                        [
                            16.81508,
                            7.53742
                        ],
                        [
                            16.7286,
                            7.64685
                        ],
                        [
                            16.66999,
                            7.66793
                        ],
                        [
                            16.66562,
                            7.73852
                        ],
                        [
                            16.59723,
                            7.76911
                        ],
                        [
                            16.58523,
                            7.83665
                        ],
                        [
                            16.52043,
                            7.84398
                        ],
                        [
                            16.48799,
                            7.79217
                        ],
                        [
                            16.43737,
                            7.80021
                        ],
                        [
                            16.42657,
                            7.71462
                        ],
                        [
                            16.39128,
                            7.67261
                        ],
                        [
                            16.30438,
                            7.65101
                        ],
                        [
                            16.24014,
                            7.60952
                        ],
                        [
                            16.06416,
                            7.58035
                        ],
                        [
                            15.97527,
                            7.48491
                        ],
                        [
                            15.81337,
                            7.44338
                        ],
                        [
                            15.76249,
                            7.46254
                        ],
                        [
                            15.7239,
                            7.51793
                        ],
                        [
                            15.55714,
                            7.51108
                        ],
                        [
                            15.50748,
                            7.52747
                        ],
                        [
                            15.42742,
                            7.41503
                        ],
                        [
                            15.25121,
                            7.27347
                        ],
                        [
                            15.21767,
                            7.22469
                        ],
                        [
                            15.22416,
                            7.13546
                        ],
                        [
                            15.19711,
                            7.07197
                        ],
                        [
                            15.14857,
                            7.02676
                        ],
                        [
                            15.1434,
                            6.94516
                        ],
                        [
                            15.06748,
                            6.77846
                        ],
                        [
                            14.96774,
                            6.74447
                        ],
                        [
                            14.81436,
                            6.41032
                        ],
                        [
                            14.81404,
                            6.35761
                        ],
                        [
                            14.75079,
                            6.26187
                        ],
                        [
                            14.56057,
                            6.18861
                        ],
                        [
                            14.42103,
                            6.03983
                        ],
                        [
                            14.49374,
                            5.91574
                        ],
                        [
                            14.58968,
                            5.91789
                        ],
                        [
                            14.62094,
                            5.89514
                        ],
                        [
                            14.62833,
                            5.70423
                        ],
                        [
                            14.59655,
                            5.60163
                        ],
                        [
                            14.6297,
                            5.50729
                        ],
                        [
                            14.52942,
                            5.27593
                        ],
                        [
                            14.57604,
                            5.2283
                        ],
                        [
                            14.65061,
                            5.21075
                        ],
                        [
                            14.69468,
                            5.0983
                        ],
                        [
                            14.68721,
                            4.92665
                        ],
                        [
                            14.71565,
                            4.86468
                        ],
                        [
                            14.71477,
                            4.77083
                        ],
                        [
                            14.73292,
                            4.60942
                        ],
                        [
                            14.89063,
                            4.46743
                        ],
                        [
                            15.01524,
                            4.4165
                        ],
                        [
                            15.08664,
                            4.30542
                        ],
                        [
                            15.10733,
                            4.13629
                        ],
                        [
                            15.15002,
                            4.06597
                        ],
                        [
                            15.09116,
                            3.994
                        ],
                        [
                            15.10816,
                            3.94336
                        ],
                        [
                            15.24759,
                            3.71448
                        ],
                        [
                            15.50935,
                            3.4381
                        ],
                        [
                            15.8022,
                            3.09632
                        ],
                        [
                            15.88696,
                            3.09662
                        ],
                        [
                            15.96817,
                            2.98904
                        ],
                        [
                            16.00397,
                            3.00035
                        ],
                        [
                            16.0869,
                            2.86023
                        ],
                        [
                            16.05137,
                            2.7894
                        ],
                        [
                            16.08465,
                            2.59549
                        ],
                        [
                            16.07648,
                            2.46385
                        ],
                        [
                            16.14793,
                            2.35048
                        ],
                        [
                            16.19199,
                            2.22051
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "TCD",
                "Country": "Chad",
                "Total_3GHG": 0.16,
                "Total_3GHG_timeseries": [
                    2.8853e-06,
                    6.4066e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0026,
                    0.0027
                ],
                "Fossil_3GHG": 0.02,
                "Fossil_3GHG_timeseries": [
                    2.9787e-08,
                    5.9641e-08,
                    8.9563e-08,
                    1.1955e-07,
                    1.4959e-07,
                    1.797e-07,
                    2.0985e-07,
                    2.4006e-07,
                    2.703e-07,
                    3.0058e-07,
                    3.3132e-07,
                    3.625e-07,
                    3.9485e-07,
                    4.2764e-07,
                    4.6089e-07,
                    4.946e-07,
                    5.2876e-07,
                    5.6337e-07,
                    5.9844e-07,
                    6.3396e-07,
                    6.6999e-07,
                    7.0658e-07,
                    7.4378e-07,
                    7.8163e-07,
                    8.2013e-07,
                    8.5929e-07,
                    8.9911e-07,
                    9.3956e-07,
                    9.8061e-07,
                    1.0222e-06,
                    1.0639e-06,
                    1.1057e-06,
                    1.147e-06,
                    1.1884e-06,
                    1.2299e-06,
                    1.2714e-06,
                    1.3131e-06,
                    1.3549e-06,
                    1.3968e-06,
                    1.439e-06,
                    1.4814e-06,
                    1.5239e-06,
                    1.5666e-06,
                    1.6095e-06,
                    1.6526e-06,
                    1.6959e-06,
                    1.7393e-06,
                    1.783e-06,
                    1.8269e-06,
                    1.8709e-06,
                    1.914e-06,
                    1.9561e-06,
                    1.9976e-06,
                    2.0408e-06,
                    2.086e-06,
                    2.1331e-06,
                    2.1823e-06,
                    2.2336e-06,
                    2.2871e-06,
                    2.3429e-06,
                    2.407e-06,
                    2.4795e-06,
                    2.5605e-06,
                    2.6501e-06,
                    2.7484e-06,
                    2.8555e-06,
                    2.9715e-06,
                    3.0965e-06,
                    3.2307e-06,
                    3.3743e-06,
                    3.5681e-06,
                    3.769e-06,
                    3.9775e-06,
                    4.1917e-06,
                    4.4123e-06,
                    4.6398e-06,
                    4.8828e-06,
                    5.1418e-06,
                    5.4171e-06,
                    5.7092e-06,
                    6.0148e-06,
                    6.3348e-06,
                    6.67e-06,
                    7.0312e-06,
                    7.4206e-06,
                    7.8401e-06,
                    8.2804e-06,
                    8.7423e-06,
                    9.2269e-06,
                    9.7348e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_3GHG": 0.43,
                "Land_3GHG_timeseries": [
                    2.8555e-06,
                    6.347e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024
                ],
                "Total_CO2": 0.05,
                "Total_CO2_timeseries": [
                    2.4646e-06,
                    5.5627e-06,
                    9.132e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.3331e-08,
                    3.1105e-08,
                    5.4156e-08,
                    7.3597e-08,
                    9.4148e-08,
                    1.1442e-07,
                    1.4081e-07,
                    1.6913e-07,
                    2.0163e-07,
                    2.2968e-07,
                    2.5443e-07,
                    2.7753e-07,
                    3.1548e-07,
                    3.5673e-07,
                    4.0128e-07,
                    4.4913e-07,
                    4.8708e-07,
                    5.3988e-07,
                    5.9598e-07,
                    6.6858e-07,
                    7.2468e-07,
                    7.9233e-07,
                    8.4678e-07,
                    9.1938e-07,
                    9.8703e-07,
                    1.0695e-06,
                    1.152e-06,
                    1.2411e-06,
                    1.3286e-06,
                    1.4193e-06,
                    1.5134e-06,
                    1.6074e-06,
                    1.6998e-06,
                    1.7922e-06,
                    1.8896e-06,
                    1.9704e-06,
                    2.0546e-06,
                    2.1437e-06,
                    2.1734e-06,
                    2.2196e-06,
                    2.3895e-06,
                    2.5628e-06,
                    2.7459e-06,
                    2.9274e-06,
                    3.113e-06,
                    3.3055e-06,
                    3.5051e-06,
                    3.7091e-06,
                    3.918e-06,
                    4.1329e-06,
                    4.3525e-06,
                    4.5801e-06,
                    4.8177e-06,
                    5.2151e-06,
                    5.6215e-06,
                    6.0384e-06,
                    6.4711e-06,
                    6.9615e-06,
                    7.3544e-06,
                    7.902e-06,
                    8.4586e-06,
                    9.0319e-06,
                    9.8168e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CO2": 0.14,
                "Land_CO2_timeseries": [
                    2.4646e-06,
                    5.5627e-06,
                    9.132e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Total_CH4": 0.44,
                "Total_CH4_timeseries": [
                    3.0224e-07,
                    6.0472e-07,
                    9.0747e-07,
                    1.2105e-06,
                    1.5137e-06,
                    1.8172e-06,
                    2.121e-06,
                    2.425e-06,
                    2.7292e-06,
                    3.0338e-06,
                    3.3432e-06,
                    3.6576e-06,
                    3.9776e-06,
                    4.3026e-06,
                    4.6325e-06,
                    4.9674e-06,
                    5.3072e-06,
                    5.652e-06,
                    6.0016e-06,
                    6.3563e-06,
                    6.716e-06,
                    7.0807e-06,
                    7.4506e-06,
                    7.8255e-06,
                    8.2056e-06,
                    8.5906e-06,
                    8.9808e-06,
                    9.376e-06,
                    9.7764e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018
                ],
                "Fossil_CH4": 0.08,
                "Fossil_CH4_timeseries": [
                    2.7279e-08,
                    5.4581e-08,
                    8.1906e-08,
                    1.0925e-07,
                    1.3662e-07,
                    1.6401e-07,
                    1.9143e-07,
                    2.1887e-07,
                    2.4633e-07,
                    2.7381e-07,
                    3.0174e-07,
                    3.3011e-07,
                    3.5964e-07,
                    3.8961e-07,
                    4.2003e-07,
                    4.5089e-07,
                    4.8221e-07,
                    5.1397e-07,
                    5.4619e-07,
                    5.7885e-07,
                    6.1197e-07,
                    6.4554e-07,
                    6.7958e-07,
                    7.1408e-07,
                    7.4903e-07,
                    7.8445e-07,
                    8.2032e-07,
                    8.5665e-07,
                    8.9344e-07,
                    9.3069e-07,
                    9.6801e-07,
                    1.0054e-06,
                    1.0422e-06,
                    1.0791e-06,
                    1.1161e-06,
                    1.1531e-06,
                    1.1902e-06,
                    1.2274e-06,
                    1.2646e-06,
                    1.3019e-06,
                    1.3393e-06,
                    1.3768e-06,
                    1.4143e-06,
                    1.4519e-06,
                    1.4896e-06,
                    1.5274e-06,
                    1.5652e-06,
                    1.6031e-06,
                    1.6411e-06,
                    1.6791e-06,
                    1.716e-06,
                    1.7518e-06,
                    1.7866e-06,
                    1.8231e-06,
                    1.8613e-06,
                    1.9012e-06,
                    1.943e-06,
                    1.9867e-06,
                    2.0324e-06,
                    2.0802e-06,
                    2.1362e-06,
                    2.2005e-06,
                    2.2732e-06,
                    2.3543e-06,
                    2.4441e-06,
                    2.5425e-06,
                    2.6497e-06,
                    2.7659e-06,
                    2.8911e-06,
                    3.0255e-06,
                    3.2101e-06,
                    3.4017e-06,
                    3.6007e-06,
                    3.8053e-06,
                    4.0162e-06,
                    4.2338e-06,
                    4.4669e-06,
                    4.7157e-06,
                    4.9808e-06,
                    5.2625e-06,
                    5.5574e-06,
                    5.8666e-06,
                    6.1907e-06,
                    6.5406e-06,
                    6.9183e-06,
                    7.3258e-06,
                    7.7538e-06,
                    8.2031e-06,
                    8.6746e-06,
                    9.1691e-06,
                    9.6538e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_CH4": 1.02,
                "Land_CH4_timeseries": [
                    2.7496e-07,
                    5.5014e-07,
                    8.2556e-07,
                    1.1012e-06,
                    1.3771e-06,
                    1.6532e-06,
                    1.9295e-06,
                    2.2061e-06,
                    2.4829e-06,
                    2.7599e-06,
                    3.0415e-06,
                    3.3275e-06,
                    3.618e-06,
                    3.913e-06,
                    4.2125e-06,
                    4.5165e-06,
                    4.825e-06,
                    5.138e-06,
                    5.4555e-06,
                    5.7774e-06,
                    6.104e-06,
                    6.4352e-06,
                    6.771e-06,
                    7.1115e-06,
                    7.4565e-06,
                    7.8062e-06,
                    8.1605e-06,
                    8.5194e-06,
                    8.8829e-06,
                    9.2511e-06,
                    9.62e-06,
                    9.9896e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016
                ],
                "Total_N2O": 0.41,
                "Total_N2O_timeseries": [
                    1.1838e-07,
                    2.3912e-07,
                    3.6212e-07,
                    4.8725e-07,
                    6.1431e-07,
                    7.431e-07,
                    8.7336e-07,
                    1.0048e-06,
                    1.1371e-06,
                    1.2698e-06,
                    1.4028e-06,
                    1.5359e-06,
                    1.6692e-06,
                    1.8025e-06,
                    1.936e-06,
                    2.0695e-06,
                    2.2031e-06,
                    2.3369e-06,
                    2.4708e-06,
                    2.605e-06,
                    2.7415e-06,
                    2.8836e-06,
                    3.034e-06,
                    3.1945e-06,
                    3.3662e-06,
                    3.5493e-06,
                    3.7433e-06,
                    3.9468e-06,
                    4.1578e-06,
                    4.3732e-06,
                    4.5913e-06,
                    4.8114e-06,
                    5.0334e-06,
                    5.2569e-06,
                    5.4819e-06,
                    5.7081e-06,
                    5.9356e-06,
                    6.1646e-06,
                    6.3951e-06,
                    6.6377e-06,
                    6.8827e-06,
                    7.1301e-06,
                    7.3801e-06,
                    7.6328e-06,
                    7.8883e-06,
                    8.1466e-06,
                    8.408e-06,
                    8.6724e-06,
                    8.94e-06,
                    9.2108e-06,
                    9.4848e-06,
                    9.7619e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_N2O": 0.03,
                "Fossil_N2O_timeseries": [
                    2.5071e-09,
                    5.06e-09,
                    7.6568e-09,
                    1.0295e-08,
                    1.2972e-08,
                    1.5683e-08,
                    1.8425e-08,
                    2.1191e-08,
                    2.3976e-08,
                    2.6773e-08,
                    2.9579e-08,
                    3.2392e-08,
                    3.5212e-08,
                    3.8037e-08,
                    4.0868e-08,
                    4.3704e-08,
                    4.6547e-08,
                    4.9396e-08,
                    5.2253e-08,
                    5.5118e-08,
                    5.8027e-08,
                    6.104e-08,
                    6.4203e-08,
                    6.7548e-08,
                    7.1094e-08,
                    7.4845e-08,
                    7.8792e-08,
                    8.2911e-08,
                    8.7165e-08,
                    9.1502e-08,
                    9.5889e-08,
                    1.0032e-07,
                    1.0478e-07,
                    1.0928e-07,
                    1.138e-07,
                    1.1836e-07,
                    1.2293e-07,
                    1.2754e-07,
                    1.3218e-07,
                    1.3707e-07,
                    1.4205e-07,
                    1.4713e-07,
                    1.523e-07,
                    1.5758e-07,
                    1.6298e-07,
                    1.6849e-07,
                    1.7412e-07,
                    1.7988e-07,
                    1.8578e-07,
                    1.9181e-07,
                    1.98e-07,
                    2.0437e-07,
                    2.1094e-07,
                    2.1772e-07,
                    2.2471e-07,
                    2.3192e-07,
                    2.3934e-07,
                    2.4695e-07,
                    2.5475e-07,
                    2.6269e-07,
                    2.7078e-07,
                    2.7898e-07,
                    2.8731e-07,
                    2.9575e-07,
                    3.043e-07,
                    3.1296e-07,
                    3.2173e-07,
                    3.3061e-07,
                    3.3961e-07,
                    3.4872e-07,
                    3.5796e-07,
                    3.6732e-07,
                    3.768e-07,
                    3.864e-07,
                    3.9612e-07,
                    4.0597e-07,
                    4.1595e-07,
                    4.2607e-07,
                    4.3634e-07,
                    4.4676e-07,
                    4.5736e-07,
                    4.6819e-07,
                    4.7926e-07,
                    4.906e-07,
                    5.0226e-07,
                    5.1424e-07,
                    5.2656e-07,
                    5.3924e-07,
                    5.5229e-07,
                    5.6571e-07,
                    5.7961e-07,
                    5.9414e-07,
                    6.0944e-07,
                    6.256e-07,
                    6.427e-07,
                    6.6076e-07,
                    6.7981e-07,
                    6.9981e-07,
                    7.2071e-07,
                    7.4241e-07,
                    7.649e-07,
                    7.8825e-07,
                    8.125e-07,
                    8.3768e-07,
                    8.638e-07,
                    8.9086e-07,
                    9.1882e-07,
                    9.4764e-07,
                    9.7728e-07,
                    1.0076e-06,
                    1.0387e-06,
                    1.0705e-06,
                    1.103e-06,
                    1.1363e-06,
                    1.1704e-06,
                    1.2054e-06,
                    1.2414e-06,
                    1.2783e-06,
                    1.3162e-06,
                    1.3565e-06,
                    1.3967e-06,
                    1.4367e-06,
                    1.477e-06,
                    1.5176e-06,
                    1.5592e-06,
                    1.6012e-06,
                    1.6445e-06,
                    1.6886e-06,
                    1.7358e-06,
                    1.7839e-06,
                    1.8331e-06,
                    1.8986e-06,
                    1.9635e-06,
                    2.0222e-06,
                    2.0836e-06,
                    2.1516e-06,
                    2.2209e-06,
                    2.2917e-06,
                    2.3634e-06,
                    2.4397e-06,
                    2.5176e-06,
                    2.5969e-06,
                    2.6766e-06,
                    2.76e-06,
                    2.8469e-06,
                    2.9373e-06,
                    3.0303e-06,
                    3.1275e-06,
                    3.2309e-06,
                    3.3395e-06,
                    3.4502e-06,
                    3.5641e-06,
                    3.682e-06,
                    3.8037e-06,
                    3.9304e-06,
                    4.0601e-06,
                    4.1931e-06,
                    4.329e-06,
                    4.4685e-06,
                    4.6125e-06,
                    4.7612e-06,
                    4.9165e-06,
                    5.0755e-06,
                    5.2405e-06,
                    5.4132e-06,
                    5.5942e-06,
                    5.7838e-06,
                    5.9768e-06,
                    6.172e-06,
                    6.3714e-06,
                    6.5764e-06,
                    6.7767e-06
                ],
                "Land_N2O": 0.56,
                "Land_N2O_timeseries": [
                    1.1587e-07,
                    2.3406e-07,
                    3.5447e-07,
                    4.7695e-07,
                    6.0134e-07,
                    7.2742e-07,
                    8.5494e-07,
                    9.836e-07,
                    1.1131e-06,
                    1.243e-06,
                    1.3732e-06,
                    1.5035e-06,
                    1.6339e-06,
                    1.7645e-06,
                    1.8951e-06,
                    2.0258e-06,
                    2.1566e-06,
                    2.2875e-06,
                    2.4186e-06,
                    2.5499e-06,
                    2.6834e-06,
                    2.8225e-06,
                    2.9698e-06,
                    3.127e-06,
                    3.2951e-06,
                    3.4745e-06,
                    3.6645e-06,
                    3.8639e-06,
                    4.0706e-06,
                    4.2817e-06,
                    4.4954e-06,
                    4.7111e-06,
                    4.9286e-06,
                    5.1477e-06,
                    5.3681e-06,
                    5.5897e-06,
                    5.8127e-06,
                    6.037e-06,
                    6.2629e-06,
                    6.5007e-06,
                    6.7406e-06,
                    6.983e-06,
                    7.2278e-06,
                    7.4752e-06,
                    7.7253e-06,
                    7.9781e-06,
                    8.2339e-06,
                    8.4925e-06,
                    8.7542e-06,
                    9.019e-06,
                    9.2868e-06,
                    9.5575e-06,
                    9.8312e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            15.50748,
                            7.52747
                        ],
                        [
                            15.55714,
                            7.51108
                        ],
                        [
                            15.7239,
                            7.51793
                        ],
                        [
                            15.76249,
                            7.46254
                        ],
                        [
                            15.81337,
                            7.44338
                        ],
                        [
                            15.97527,
                            7.48491
                        ],
                        [
                            16.06416,
                            7.58035
                        ],
                        [
                            16.24014,
                            7.60952
                        ],
                        [
                            16.30438,
                            7.65101
                        ],
                        [
                            16.39128,
                            7.67261
                        ],
                        [
                            16.42657,
                            7.71462
                        ],
                        [
                            16.43737,
                            7.80021
                        ],
                        [
                            16.48799,
                            7.79217
                        ],
                        [
                            16.52043,
                            7.84398
                        ],
                        [
                            16.58523,
                            7.83665
                        ],
                        [
                            16.59723,
                            7.76911
                        ],
                        [
                            16.66562,
                            7.73852
                        ],
                        [
                            16.66999,
                            7.66793
                        ],
                        [
                            16.7286,
                            7.64685
                        ],
                        [
                            16.81508,
                            7.53742
                        ],
                        [
                            16.8654,
                            7.53874
                        ],
                        [
                            16.90189,
                            7.61423
                        ],
                        [
                            16.95587,
                            7.63468
                        ],
                        [
                            17.15705,
                            7.66646
                        ],
                        [
                            17.23086,
                            7.76009
                        ],
                        [
                            17.36917,
                            7.8484
                        ],
                        [
                            17.47097,
                            7.89239
                        ],
                        [
                            17.51334,
                            7.87186
                        ],
                        [
                            17.6489,
                            7.94843
                        ],
                        [
                            17.6737,
                            7.98158
                        ],
                        [
                            17.92516,
                            7.95962
                        ],
                        [
                            18.04098,
                            8.00979
                        ],
                        [
                            18.26524,
                            8.02127
                        ],
                        [
                            18.5918,
                            8.04625
                        ],
                        [
                            18.63521,
                            8.08965
                        ],
                        [
                            18.6301,
                            8.14285
                        ],
                        [
                            18.66392,
                            8.20119
                        ],
                        [
                            18.79946,
                            8.25937
                        ],
                        [
                            18.92392,
                            8.39555
                        ],
                        [
                            18.92217,
                            8.41899
                        ],
                        [
                            19.02867,
                            8.53453
                        ],
                        [
                            19.06781,
                            8.63598
                        ],
                        [
                            19.11901,
                            8.67171
                        ],
                        [
                            19.01744,
                            8.76132
                        ],
                        [
                            18.92318,
                            8.80304
                        ],
                        [
                            18.86797,
                            8.87171
                        ],
                        [
                            18.99003,
                            8.97491
                        ],
                        [
                            19.08039,
                            9.01441
                        ],
                        [
                            19.13461,
                            9.00597
                        ],
                        [
                            19.21828,
                            9.02958
                        ],
                        [
                            19.30487,
                            9.00881
                        ],
                        [
                            19.43749,
                            9.02901
                        ],
                        [
                            19.48087,
                            9.01619
                        ],
                        [
                            19.57235,
                            9.0382
                        ],
                        [
                            19.66833,
                            9.0218
                        ],
                        [
                            19.82036,
                            9.06185
                        ],
                        [
                            19.9252,
                            9.06317
                        ],
                        [
                            20.01433,
                            9.12479
                        ],
                        [
                            20.1024,
                            9.15443
                        ],
                        [
                            20.35377,
                            9.12941
                        ],
                        [
                            20.45573,
                            9.17485
                        ],
                        [
                            20.52855,
                            9.33458
                        ],
                        [
                            20.6042,
                            9.31829
                        ],
                        [
                            20.66674,
                            9.39622
                        ],
                        [
                            20.76991,
                            9.42634
                        ],
                        [
                            20.91699,
                            9.5284
                        ],
                        [
                            20.95129,
                            9.60894
                        ],
                        [
                            20.99286,
                            9.65298
                        ],
                        [
                            21.02529,
                            9.7612
                        ],
                        [
                            21.09294,
                            9.77802
                        ],
                        [
                            21.13144,
                            9.84496
                        ],
                        [
                            21.199,
                            9.89725
                        ],
                        [
                            21.25562,
                            9.98943
                        ],
                        [
                            21.33661,
                            9.96659
                        ],
                        [
                            21.39118,
                            9.99932
                        ],
                        [
                            21.45364,
                            10.088
                        ],
                        [
                            21.45137,
                            10.12246
                        ],
                        [
                            21.54394,
                            10.22551
                        ],
                        [
                            21.59009,
                            10.21301
                        ],
                        [
                            21.66871,
                            10.2334
                        ],
                        [
                            21.70601,
                            10.27823
                        ],
                        [
                            21.7643,
                            10.40217
                        ],
                        [
                            21.71877,
                            10.50924
                        ],
                        [
                            21.73423,
                            10.65002
                        ],
                        [
                            21.7868,
                            10.6694
                        ],
                        [
                            21.79031,
                            10.79403
                        ],
                        [
                            21.88275,
                            10.86882
                        ],
                        [
                            21.93117,
                            10.8571
                        ],
                        [
                            22.07486,
                            10.89473
                        ],
                        [
                            22.15474,
                            10.87791
                        ],
                        [
                            22.19748,
                            10.90846
                        ],
                        [
                            22.3279,
                            10.95499
                        ],
                        [
                            22.52415,
                            11.00587
                        ],
                        [
                            22.73538,
                            10.97356
                        ],
                        [
                            22.76829,
                            10.94531
                        ],
                        [
                            22.87551,
                            10.93137
                        ],
                        [
                            22.9314,
                            11.10076
                        ],
                        [
                            22.98643,
                            11.21621
                        ],
                        [
                            22.98109,
                            11.29625
                        ],
                        [
                            22.93517,
                            11.32093
                        ],
                        [
                            22.93989,
                            11.42344
                        ],
                        [
                            22.7891,
                            11.40698
                        ],
                        [
                            22.73742,
                            11.48911
                        ],
                        [
                            22.65546,
                            11.5185
                        ],
                        [
                            22.56328,
                            11.62908
                        ],
                        [
                            22.55633,
                            11.71002
                        ],
                        [
                            22.58325,
                            11.8524
                        ],
                        [
                            22.63896,
                            12.06793
                        ],
                        [
                            22.47834,
                            12.03417
                        ],
                        [
                            22.49557,
                            12.15867
                        ],
                        [
                            22.44964,
                            12.26452
                        ],
                        [
                            22.42925,
                            12.38952
                        ],
                        [
                            22.38542,
                            12.46088
                        ],
                        [
                            22.42465,
                            12.51559
                        ],
                        [
                            22.4559,
                            12.63314
                        ],
                        [
                            22.31251,
                            12.688
                        ],
                        [
                            22.19654,
                            12.75376
                        ],
                        [
                            22.15073,
                            12.67427
                        ],
                        [
                            21.94762,
                            12.62569
                        ],
                        [
                            21.86138,
                            12.72899
                        ],
                        [
                            21.81705,
                            12.80365
                        ],
                        [
                            21.84801,
                            12.84106
                        ],
                        [
                            21.92948,
                            13.0514
                        ],
                        [
                            21.97423,
                            13.07639
                        ],
                        [
                            22.01076,
                            13.14172
                        ],
                        [
                            22.13596,
                            13.17245
                        ],
                        [
                            22.18331,
                            13.24963
                        ],
                        [
                            22.28931,
                            13.35501
                        ],
                        [
                            22.21858,
                            13.46599
                        ],
                        [
                            22.22438,
                            13.54675
                        ],
                        [
                            22.16667,
                            13.59567
                        ],
                        [
                            22.11602,
                            13.68328
                        ],
                        [
                            22.12545,
                            13.73148
                        ],
                        [
                            22.07406,
                            13.77997
                        ],
                        [
                            22.22884,
                            13.95324
                        ],
                        [
                            22.29367,
                            13.96556
                        ],
                        [
                            22.32323,
                            14.01143
                        ],
                        [
                            22.44039,
                            14.05406
                        ],
                        [
                            22.48615,
                            14.10424
                        ],
                        [
                            22.53363,
                            14.11121
                        ],
                        [
                            22.56647,
                            14.18114
                        ],
                        [
                            22.54291,
                            14.23485
                        ],
                        [
                            22.46503,
                            14.24366
                        ],
                        [
                            22.42669,
                            14.2915
                        ],
                        [
                            22.45351,
                            14.3294
                        ],
                        [
                            22.43353,
                            14.41097
                        ],
                        [
                            22.44178,
                            14.48279
                        ],
                        [
                            22.38287,
                            14.51605
                        ],
                        [
                            22.4119,
                            14.59873
                        ],
                        [
                            22.51702,
                            14.64164
                        ],
                        [
                            22.58078,
                            14.64731
                        ],
                        [
                            22.71375,
                            14.69685
                        ],
                        [
                            22.664,
                            14.84221
                        ],
                        [
                            22.68199,
                            14.87787
                        ],
                        [
                            22.75724,
                            14.90643
                        ],
                        [
                            22.75066,
                            14.96734
                        ],
                        [
                            22.8815,
                            15.08849
                        ],
                        [
                            22.93373,
                            15.10032
                        ],
                        [
                            22.93369,
                            15.16575
                        ],
                        [
                            23.00272,
                            15.2349
                        ],
                        [
                            22.98498,
                            15.41734
                        ],
                        [
                            22.9255,
                            15.47181
                        ],
                        [
                            22.92794,
                            15.55145
                        ],
                        [
                            23.03185,
                            15.62771
                        ],
                        [
                            23.12633,
                            15.71834
                        ],
                        [
                            23.35187,
                            15.69459
                        ],
                        [
                            23.44139,
                            15.71031
                        ],
                        [
                            23.58607,
                            15.76239
                        ],
                        [
                            23.81772,
                            15.75025
                        ],
                        [
                            23.96409,
                            15.71159
                        ],
                        [
                            23.99925,
                            15.71572
                        ],
                        [
                            23.99954,
                            17.17533
                        ],
                        [
                            24.0,
                            19.5
                        ],
                        [
                            23.46692,
                            19.76342
                        ],
                        [
                            22.85778,
                            20.06389
                        ],
                        [
                            22.47313,
                            20.25366
                        ],
                        [
                            21.98411,
                            20.49427
                        ],
                        [
                            21.20811,
                            20.87531
                        ],
                        [
                            20.34196,
                            21.30133
                        ],
                        [
                            19.64221,
                            21.64617
                        ],
                        [
                            18.97313,
                            21.97539
                        ],
                        [
                            18.38743,
                            22.26503
                        ],
                        [
                            17.58537,
                            22.66071
                        ],
                        [
                            16.80296,
                            23.04559
                        ],
                        [
                            15.99942,
                            23.43883
                        ],
                        [
                            14.99842,
                            22.99718
                        ],
                        [
                            15.11438,
                            22.40494
                        ],
                        [
                            15.19184,
                            21.98989
                        ],
                        [
                            15.19888,
                            21.49194
                        ],
                        [
                            15.2892,
                            21.4311
                        ],
                        [
                            15.62418,
                            20.96496
                        ],
                        [
                            15.54665,
                            20.88109
                        ],
                        [
                            15.59066,
                            20.77402
                        ],
                        [
                            15.74425,
                            20.63111
                        ],
                        [
                            15.86586,
                            20.46195
                        ],
                        [
                            15.99468,
                            20.34763
                        ],
                        [
                            15.75473,
                            19.94957
                        ],
                        [
                            15.68984,
                            19.47779
                        ],
                        [
                            15.59375,
                            18.73013
                        ],
                        [
                            15.57047,
                            18.24916
                        ],
                        [
                            15.5386,
                            17.61201
                        ],
                        [
                            15.50531,
                            16.89879
                        ],
                        [
                            14.95782,
                            16.32654
                        ],
                        [
                            14.6943,
                            16.04474
                        ],
                        [
                            14.38375,
                            15.73009
                        ],
                        [
                            14.23565,
                            15.53498
                        ],
                        [
                            13.97086,
                            15.15756
                        ],
                        [
                            13.86867,
                            15.04142
                        ],
                        [
                            13.79011,
                            14.86331
                        ],
                        [
                            13.81027,
                            14.72332
                        ],
                        [
                            13.74417,
                            14.69692
                        ],
                        [
                            13.6789,
                            14.63781
                        ],
                        [
                            13.69502,
                            14.55095
                        ],
                        [
                            13.64082,
                            14.51384
                        ],
                        [
                            13.49333,
                            14.47453
                        ],
                        [
                            13.4735,
                            14.44268
                        ],
                        [
                            13.4856,
                            14.35837
                        ],
                        [
                            13.63455,
                            13.71068
                        ],
                        [
                            13.89132,
                            13.34334
                        ],
                        [
                            14.08543,
                            13.07806
                        ],
                        [
                            14.45989,
                            13.07441
                        ],
                        [
                            14.53335,
                            12.96895
                        ],
                        [
                            14.56871,
                            12.89186
                        ],
                        [
                            14.55185,
                            12.7871
                        ],
                        [
                            14.58549,
                            12.74843
                        ],
                        [
                            14.70457,
                            12.72452
                        ],
                        [
                            14.77302,
                            12.63141
                        ],
                        [
                            14.83222,
                            12.62662
                        ],
                        [
                            14.85794,
                            12.4844
                        ],
                        [
                            14.91018,
                            12.37957
                        ],
                        [
                            14.89325,
                            12.16782
                        ],
                        [
                            14.93274,
                            12.11517
                        ],
                        [
                            15.01025,
                            12.11175
                        ],
                        [
                            15.08126,
                            11.99966
                        ],
                        [
                            15.04211,
                            11.8987
                        ],
                        [
                            15.11832,
                            11.79393
                        ],
                        [
                            15.06893,
                            11.72439
                        ],
                        [
                            15.10016,
                            11.58488
                        ],
                        [
                            15.14173,
                            11.55649
                        ],
                        [
                            15.05951,
                            11.40961
                        ],
                        [
                            15.06841,
                            11.36724
                        ],
                        [
                            15.02759,
                            11.28086
                        ],
                        [
                            15.02667,
                            11.13507
                        ],
                        [
                            15.05123,
                            10.99584
                        ],
                        [
                            15.08263,
                            10.94645
                        ],
                        [
                            15.09267,
                            10.86686
                        ],
                        [
                            15.06954,
                            10.80709
                        ],
                        [
                            15.15463,
                            10.64374
                        ],
                        [
                            15.1471,
                            10.53778
                        ],
                        [
                            15.23872,
                            10.47301
                        ],
                        [
                            15.28147,
                            10.40403
                        ],
                        [
                            15.31065,
                            10.30944
                        ],
                        [
                            15.3544,
                            10.29071
                        ],
                        [
                            15.45191,
                            10.18635
                        ],
                        [
                            15.48601,
                            10.1213
                        ],
                        [
                            15.6753,
                            10.00626
                        ],
                        [
                            15.59001,
                            9.95801
                        ],
                        [
                            15.43719,
                            9.93376
                        ],
                        [
                            15.23986,
                            9.99491
                        ],
                        [
                            15.21032,
                            9.96559
                        ],
                        [
                            15.14009,
                            9.99429
                        ],
                        [
                            15.09827,
                            9.96446
                        ],
                        [
                            14.98803,
                            10.00084
                        ],
                        [
                            14.91775,
                            9.9786
                        ],
                        [
                            14.83555,
                            9.92473
                        ],
                        [
                            14.70416,
                            9.95038
                        ],
                        [
                            14.48394,
                            10.00978
                        ],
                        [
                            14.30545,
                            10.00326
                        ],
                        [
                            14.20956,
                            9.98872
                        ],
                        [
                            14.17644,
                            9.89942
                        ],
                        [
                            14.03892,
                            9.73729
                        ],
                        [
                            14.0229,
                            9.64873
                        ],
                        [
                            14.13302,
                            9.51132
                        ],
                        [
                            14.18988,
                            9.47744
                        ],
                        [
                            14.25206,
                            9.39099
                        ],
                        [
                            14.31786,
                            9.36464
                        ],
                        [
                            14.39219,
                            9.26634
                        ],
                        [
                            14.37998,
                            9.1996
                        ],
                        [
                            14.49022,
                            9.09495
                        ],
                        [
                            14.50624,
                            9.03728
                        ],
                        [
                            14.56098,
                            9.01059
                        ],
                        [
                            14.75568,
                            8.81911
                        ],
                        [
                            14.89834,
                            8.80718
                        ],
                        [
                            14.98827,
                            8.71617
                        ],
                        [
                            14.98816,
                            8.67913
                        ],
                        [
                            15.10832,
                            8.67223
                        ],
                        [
                            15.20817,
                            8.60788
                        ],
                        [
                            15.28645,
                            8.30974
                        ],
                        [
                            15.39628,
                            8.09177
                        ],
                        [
                            15.3924,
                            8.03726
                        ],
                        [
                            15.4545,
                            7.89235
                        ],
                        [
                            15.51112,
                            7.79689
                        ],
                        [
                            15.59634,
                            7.76702
                        ],
                        [
                            15.59736,
                            7.68738
                        ],
                        [
                            15.57288,
                            7.59081
                        ],
                        [
                            15.50748,
                            7.52747
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "CHL",
                "Country": "Chile",
                "Total_3GHG": 0.25,
                "Total_3GHG_timeseries": [
                    3.8337e-06,
                    7.7901e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.004,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0042
                ],
                "Fossil_3GHG": 0.22,
                "Fossil_3GHG_timeseries": [
                    3.122e-07,
                    6.4218e-07,
                    9.9015e-07,
                    1.3559e-06,
                    1.7392e-06,
                    2.1434e-06,
                    2.5621e-06,
                    2.9989e-06,
                    3.4537e-06,
                    3.9267e-06,
                    4.4052e-06,
                    4.8894e-06,
                    5.3797e-06,
                    5.875e-06,
                    6.3767e-06,
                    6.8845e-06,
                    7.3958e-06,
                    7.9107e-06,
                    8.4294e-06,
                    8.9546e-06,
                    9.505e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023
                ],
                "Land_3GHG": 0.33,
                "Land_3GHG_timeseries": [
                    3.5215e-06,
                    7.148e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019
                ],
                "Total_CO2": 0.25,
                "Total_CO2_timeseries": [
                    2.93e-06,
                    5.9328e-06,
                    9.0925e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028
                ],
                "Fossil_CO2": 0.18,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2.3595e-07,
                    4.7685e-07,
                    7.6395e-07,
                    1.0972e-06,
                    1.3827e-06,
                    1.7655e-06,
                    2.4717e-06,
                    3.3545e-06,
                    4.3279e-06,
                    5.214e-06,
                    6.1496e-06,
                    7.2485e-06,
                    8.2302e-06,
                    9.3373e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014
                ],
                "Land_CO2": 0.4,
                "Land_CO2_timeseries": [
                    2.93e-06,
                    5.9328e-06,
                    9.0925e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014
                ],
                "Total_CH4": 0.28,
                "Total_CH4_timeseries": [
                    8.5821e-07,
                    1.7659e-06,
                    2.7233e-06,
                    3.7301e-06,
                    4.7863e-06,
                    5.895e-06,
                    7.05e-06,
                    8.255e-06,
                    9.5096e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012
                ],
                "Fossil_CH4": 0.33,
                "Fossil_CH4_timeseries": [
                    2.8266e-07,
                    5.8274e-07,
                    9.0046e-07,
                    1.2356e-06,
                    1.588e-06,
                    1.9609e-06,
                    2.348e-06,
                    2.753e-06,
                    3.1756e-06,
                    3.6162e-06,
                    4.0621e-06,
                    4.5135e-06,
                    4.9706e-06,
                    5.4326e-06,
                    5.9007e-06,
                    6.3747e-06,
                    6.8521e-06,
                    7.3327e-06,
                    7.8169e-06,
                    8.3074e-06,
                    8.8228e-06,
                    9.3374e-06,
                    9.8513e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008
                ],
                "Land_CH4": 0.2,
                "Land_CH4_timeseries": [
                    5.7555e-07,
                    1.1832e-06,
                    1.8228e-06,
                    2.4945e-06,
                    3.1983e-06,
                    3.9341e-06,
                    4.702e-06,
                    5.502e-06,
                    6.334e-06,
                    7.1981e-06,
                    8.0699e-06,
                    8.9495e-06,
                    9.837e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Total_N2O": 0.21,
                "Total_N2O_timeseries": [
                    4.5406e-08,
                    9.1492e-08,
                    1.3824e-07,
                    1.8562e-07,
                    2.336e-07,
                    2.8214e-07,
                    3.3118e-07,
                    3.8067e-07,
                    4.3055e-07,
                    4.8074e-07,
                    5.312e-07,
                    5.8191e-07,
                    6.3287e-07,
                    6.8407e-07,
                    7.3551e-07,
                    7.8718e-07,
                    8.391e-07,
                    8.9127e-07,
                    9.437e-07,
                    9.9639e-07,
                    1.0497e-06,
                    1.1044e-06,
                    1.1609e-06,
                    1.2196e-06,
                    1.2807e-06,
                    1.3442e-06,
                    1.4101e-06,
                    1.478e-06,
                    1.5476e-06,
                    1.6182e-06,
                    1.6896e-06,
                    1.7617e-06,
                    1.8343e-06,
                    1.9074e-06,
                    1.981e-06,
                    2.0551e-06,
                    2.1297e-06,
                    2.2048e-06,
                    2.2804e-06,
                    2.3726e-06,
                    2.4659e-06,
                    2.5611e-06,
                    2.6589e-06,
                    2.7599e-06,
                    2.8646e-06,
                    2.9735e-06,
                    3.087e-06,
                    3.2054e-06,
                    3.3289e-06,
                    3.4577e-06,
                    3.5937e-06,
                    3.7401e-06,
                    3.899e-06,
                    4.072e-06,
                    4.2597e-06,
                    4.4618e-06,
                    4.6774e-06,
                    4.9047e-06,
                    5.1408e-06,
                    5.3823e-06,
                    5.6271e-06,
                    5.875e-06,
                    6.1259e-06,
                    6.3795e-06,
                    6.6357e-06,
                    6.8942e-06,
                    7.1547e-06,
                    7.417e-06,
                    7.6808e-06,
                    7.9458e-06,
                    8.2112e-06,
                    8.476e-06,
                    8.7396e-06,
                    9.0015e-06,
                    9.2613e-06,
                    9.519e-06,
                    9.775e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_N2O": 0.19,
                "Fossil_N2O_timeseries": [
                    2.9536e-08,
                    5.9435e-08,
                    8.9691e-08,
                    1.203e-07,
                    1.5124e-07,
                    1.8251e-07,
                    2.1409e-07,
                    2.4596e-07,
                    2.781e-07,
                    3.1049e-07,
                    3.4312e-07,
                    3.7599e-07,
                    4.0908e-07,
                    4.424e-07,
                    4.7595e-07,
                    5.0973e-07,
                    5.4374e-07,
                    5.7798e-07,
                    6.1245e-07,
                    6.4716e-07,
                    6.8222e-07,
                    7.1785e-07,
                    7.5419e-07,
                    7.9135e-07,
                    8.294e-07,
                    8.6835e-07,
                    9.0817e-07,
                    9.4878e-07,
                    9.9005e-07,
                    1.0318e-06,
                    1.074e-06,
                    1.1164e-06,
                    1.1593e-06,
                    1.2024e-06,
                    1.2458e-06,
                    1.2896e-06,
                    1.3336e-06,
                    1.378e-06,
                    1.4226e-06,
                    1.4681e-06,
                    1.5141e-06,
                    1.5606e-06,
                    1.6076e-06,
                    1.6551e-06,
                    1.7031e-06,
                    1.7517e-06,
                    1.8008e-06,
                    1.8505e-06,
                    1.9009e-06,
                    1.9518e-06,
                    2.0035e-06,
                    2.0558e-06,
                    2.1089e-06,
                    2.1629e-06,
                    2.2176e-06,
                    2.2733e-06,
                    2.3298e-06,
                    2.3871e-06,
                    2.4452e-06,
                    2.5042e-06,
                    2.5639e-06,
                    2.6243e-06,
                    2.6855e-06,
                    2.7474e-06,
                    2.8101e-06,
                    2.8735e-06,
                    2.9376e-06,
                    3.0025e-06,
                    3.0681e-06,
                    3.1345e-06,
                    3.2016e-06,
                    3.2694e-06,
                    3.338e-06,
                    3.4073e-06,
                    3.4774e-06,
                    3.5482e-06,
                    3.6198e-06,
                    3.6921e-06,
                    3.7652e-06,
                    3.8391e-06,
                    3.9137e-06,
                    3.9891e-06,
                    4.0653e-06,
                    4.1423e-06,
                    4.2202e-06,
                    4.2988e-06,
                    4.3784e-06,
                    4.459e-06,
                    4.5405e-06,
                    4.6232e-06,
                    4.7073e-06,
                    4.7936e-06,
                    4.8825e-06,
                    4.9744e-06,
                    5.0696e-06,
                    5.1682e-06,
                    5.2704e-06,
                    5.3758e-06,
                    5.4845e-06,
                    5.596e-06,
                    5.7104e-06,
                    5.8283e-06,
                    5.9502e-06,
                    6.0764e-06,
                    6.2073e-06,
                    6.343e-06,
                    6.4837e-06,
                    6.6294e-06,
                    6.78e-06,
                    6.9353e-06,
                    7.0952e-06,
                    7.2595e-06,
                    7.4282e-06,
                    7.6016e-06,
                    7.7798e-06,
                    7.9634e-06,
                    8.153e-06,
                    8.3493e-06,
                    8.5532e-06,
                    8.7792e-06,
                    9.0082e-06,
                    9.2364e-06,
                    9.4618e-06,
                    9.6882e-06,
                    9.9025e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.22,
                "Land_N2O_timeseries": [
                    1.587e-08,
                    3.2057e-08,
                    4.8548e-08,
                    6.5324e-08,
                    8.236e-08,
                    9.9628e-08,
                    1.1709e-07,
                    1.3471e-07,
                    1.5245e-07,
                    1.7024e-07,
                    1.8807e-07,
                    2.0592e-07,
                    2.2379e-07,
                    2.4166e-07,
                    2.5955e-07,
                    2.7745e-07,
                    2.9536e-07,
                    3.1329e-07,
                    3.3125e-07,
                    3.4924e-07,
                    3.6752e-07,
                    3.8658e-07,
                    4.0674e-07,
                    4.2827e-07,
                    4.513e-07,
                    4.7586e-07,
                    5.0189e-07,
                    5.292e-07,
                    5.5751e-07,
                    5.8643e-07,
                    6.1569e-07,
                    6.4524e-07,
                    6.7503e-07,
                    7.0503e-07,
                    7.3521e-07,
                    7.6557e-07,
                    7.9611e-07,
                    8.2684e-07,
                    8.5777e-07,
                    9.0445e-07,
                    9.5178e-07,
                    1.0005e-06,
                    1.0513e-06,
                    1.1048e-06,
                    1.1615e-06,
                    1.2218e-06,
                    1.2862e-06,
                    1.3548e-06,
                    1.428e-06,
                    1.5059e-06,
                    1.5903e-06,
                    1.6843e-06,
                    1.7901e-06,
                    1.9091e-06,
                    2.042e-06,
                    2.1885e-06,
                    2.3477e-06,
                    2.5176e-06,
                    2.6956e-06,
                    2.8781e-06,
                    3.0632e-06,
                    3.2507e-06,
                    3.4404e-06,
                    3.6321e-06,
                    3.8256e-06,
                    4.0207e-06,
                    4.2171e-06,
                    4.4145e-06,
                    4.6127e-06,
                    4.8113e-06,
                    5.0096e-06,
                    5.2066e-06,
                    5.4017e-06,
                    5.5942e-06,
                    5.7839e-06,
                    5.9708e-06,
                    6.1553e-06,
                    6.3376e-06,
                    6.5186e-06,
                    6.6991e-06,
                    6.8809e-06,
                    7.0658e-06,
                    7.2553e-06,
                    7.4508e-06,
                    7.6532e-06,
                    7.8633e-06,
                    8.0813e-06,
                    8.3074e-06,
                    8.5413e-06,
                    8.7825e-06,
                    9.0393e-06,
                    9.327e-06,
                    9.6571e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -70.37617,
                                -18.35358
                            ],
                            [
                                -70.30404,
                                -18.44947
                            ],
                            [
                                -70.34844,
                                -18.6478
                            ],
                            [
                                -70.33892,
                                -18.75421
                            ],
                            [
                                -70.35688,
                                -18.79892
                            ],
                            [
                                -70.30757,
                                -18.9903
                            ],
                            [
                                -70.31479,
                                -19.02505
                            ],
                            [
                                -70.27038,
                                -19.14681
                            ],
                            [
                                -70.28191,
                                -19.30766
                            ],
                            [
                                -70.22702,
                                -19.40992
                            ],
                            [
                                -70.20402,
                                -19.49942
                            ],
                            [
                                -70.20574,
                                -19.62076
                            ],
                            [
                                -70.17096,
                                -19.6582
                            ],
                            [
                                -70.14783,
                                -19.78647
                            ],
                            [
                                -70.16003,
                                -19.82957
                            ],
                            [
                                -70.12474,
                                -19.99101
                            ],
                            [
                                -70.12314,
                                -20.08968
                            ],
                            [
                                -70.15599,
                                -20.21638
                            ],
                            [
                                -70.13265,
                                -20.26334
                            ],
                            [
                                -70.17599,
                                -20.35231
                            ],
                            [
                                -70.16699,
                                -20.49978
                            ],
                            [
                                -70.19819,
                                -20.53676
                            ],
                            [
                                -70.18342,
                                -20.65562
                            ],
                            [
                                -70.20334,
                                -20.81027
                            ],
                            [
                                -70.13883,
                                -20.886
                            ],
                            [
                                -70.12863,
                                -20.94413
                            ],
                            [
                                -70.17512,
                                -21.02379
                            ],
                            [
                                -70.12526,
                                -21.08975
                            ],
                            [
                                -70.13071,
                                -21.13095
                            ],
                            [
                                -70.06813,
                                -21.29253
                            ],
                            [
                                -70.09496,
                                -21.34032
                            ],
                            [
                                -70.05752,
                                -21.43999
                            ],
                            [
                                -70.09536,
                                -21.59151
                            ],
                            [
                                -70.14426,
                                -21.63717
                            ],
                            [
                                -70.15499,
                                -21.88152
                            ],
                            [
                                -70.21551,
                                -22.0982
                            ],
                            [
                                -70.24564,
                                -22.38088
                            ],
                            [
                                -70.26464,
                                -22.45992
                            ],
                            [
                                -70.24054,
                                -22.49706
                            ],
                            [
                                -70.282,
                                -22.57262
                            ],
                            [
                                -70.28188,
                                -22.71699
                            ],
                            [
                                -70.31379,
                                -22.80998
                            ],
                            [
                                -70.29102,
                                -22.87769
                            ],
                            [
                                -70.34465,
                                -23.02264
                            ],
                            [
                                -70.38794,
                                -23.0715
                            ],
                            [
                                -70.48266,
                                -23.0968
                            ],
                            [
                                -70.4999,
                                -23.04274
                            ],
                            [
                                -70.57696,
                                -23.08499
                            ],
                            [
                                -70.56205,
                                -23.18914
                            ],
                            [
                                -70.59409,
                                -23.22174
                            ],
                            [
                                -70.60454,
                                -23.362
                            ],
                            [
                                -70.59113,
                                -23.42924
                            ],
                            [
                                -70.62733,
                                -23.50682
                            ],
                            [
                                -70.5375,
                                -23.53113
                            ],
                            [
                                -70.51189,
                                -23.46902
                            ],
                            [
                                -70.43605,
                                -23.49237
                            ],
                            [
                                -70.40133,
                                -23.5437
                            ],
                            [
                                -70.39317,
                                -23.61342
                            ],
                            [
                                -70.44727,
                                -23.74743
                            ],
                            [
                                -70.50103,
                                -23.79626
                            ],
                            [
                                -70.51681,
                                -24.01773
                            ],
                            [
                                -70.49855,
                                -24.08262
                            ],
                            [
                                -70.51841,
                                -24.12644
                            ],
                            [
                                -70.54234,
                                -24.42408
                            ],
                            [
                                -70.57863,
                                -24.5453
                            ],
                            [
                                -70.55086,
                                -24.59188
                            ],
                            [
                                -70.57821,
                                -24.72393
                            ],
                            [
                                -70.54624,
                                -24.78073
                            ],
                            [
                                -70.52688,
                                -24.91385
                            ],
                            [
                                -70.47176,
                                -24.97844
                            ],
                            [
                                -70.50142,
                                -25.11254
                            ],
                            [
                                -70.43692,
                                -25.19486
                            ],
                            [
                                -70.45575,
                                -25.38193
                            ],
                            [
                                -70.52557,
                                -25.42302
                            ],
                            [
                                -70.5307,
                                -25.4797
                            ],
                            [
                                -70.64631,
                                -25.53539
                            ],
                            [
                                -70.63711,
                                -25.64443
                            ],
                            [
                                -70.68155,
                                -25.66461
                            ],
                            [
                                -70.68687,
                                -25.74456
                            ],
                            [
                                -70.72748,
                                -25.7804
                            ],
                            [
                                -70.6912,
                                -25.9034
                            ],
                            [
                                -70.62871,
                                -25.99497
                            ],
                            [
                                -70.65779,
                                -26.06403
                            ],
                            [
                                -70.67147,
                                -26.16738
                            ],
                            [
                                -70.64842,
                                -26.25444
                            ],
                            [
                                -70.67372,
                                -26.29517
                            ],
                            [
                                -70.63008,
                                -26.34519
                            ],
                            [
                                -70.69722,
                                -26.39373
                            ],
                            [
                                -70.7069,
                                -26.52711
                            ],
                            [
                                -70.68517,
                                -26.55347
                            ],
                            [
                                -70.83066,
                                -26.87882
                            ],
                            [
                                -70.79068,
                                -26.98611
                            ],
                            [
                                -70.84721,
                                -27.06216
                            ],
                            [
                                -70.86216,
                                -27.12765
                            ],
                            [
                                -70.92789,
                                -27.11214
                            ],
                            [
                                -70.97091,
                                -27.17115
                            ],
                            [
                                -70.93215,
                                -27.3111
                            ],
                            [
                                -70.96356,
                                -27.36899
                            ],
                            [
                                -70.8873,
                                -27.48914
                            ],
                            [
                                -70.89969,
                                -27.61958
                            ],
                            [
                                -71.00839,
                                -27.68634
                            ],
                            [
                                -71.08434,
                                -27.78814
                            ],
                            [
                                -71.10507,
                                -27.889
                            ],
                            [
                                -71.14026,
                                -27.94977
                            ],
                            [
                                -71.14472,
                                -28.07815
                            ],
                            [
                                -71.17776,
                                -28.10317
                            ],
                            [
                                -71.15518,
                                -28.22933
                            ],
                            [
                                -71.19628,
                                -28.30186
                            ],
                            [
                                -71.16187,
                                -28.35748
                            ],
                            [
                                -71.21357,
                                -28.45888
                            ],
                            [
                                -71.31488,
                                -28.57661
                            ],
                            [
                                -71.2813,
                                -28.63081
                            ],
                            [
                                -71.29772,
                                -28.6801
                            ],
                            [
                                -71.36601,
                                -28.74641
                            ],
                            [
                                -71.37937,
                                -28.79234
                            ],
                            [
                                -71.48406,
                                -28.85123
                            ],
                            [
                                -71.51573,
                                -28.90703
                            ],
                            [
                                -71.50078,
                                -29.02223
                            ],
                            [
                                -71.46267,
                                -29.10486
                            ],
                            [
                                -71.49753,
                                -29.13715
                            ],
                            [
                                -71.46614,
                                -29.24947
                            ],
                            [
                                -71.37644,
                                -29.29648
                            ],
                            [
                                -71.33059,
                                -29.34506
                            ],
                            [
                                -71.30886,
                                -29.42247
                            ],
                            [
                                -71.32996,
                                -29.55366
                            ],
                            [
                                -71.28797,
                                -29.61763
                            ],
                            [
                                -71.34215,
                                -29.75307
                            ],
                            [
                                -71.28324,
                                -29.83339
                            ],
                            [
                                -71.27594,
                                -29.90906
                            ],
                            [
                                -71.34454,
                                -29.93596
                            ],
                            [
                                -71.38615,
                                -29.99121
                            ],
                            [
                                -71.37621,
                                -30.15355
                            ],
                            [
                                -71.44773,
                                -30.17186
                            ],
                            [
                                -71.52653,
                                -30.29172
                            ],
                            [
                                -71.60218,
                                -30.29953
                            ],
                            [
                                -71.6509,
                                -30.27341
                            ],
                            [
                                -71.68739,
                                -30.40564
                            ],
                            [
                                -71.69523,
                                -30.54247
                            ],
                            [
                                -71.71566,
                                -30.60148
                            ],
                            [
                                -71.69914,
                                -30.69929
                            ],
                            [
                                -71.70518,
                                -30.78851
                            ],
                            [
                                -71.68168,
                                -30.92025
                            ],
                            [
                                -71.65176,
                                -30.97117
                            ],
                            [
                                -71.66418,
                                -31.16992
                            ],
                            [
                                -71.61634,
                                -31.3279
                            ],
                            [
                                -71.61663,
                                -31.39248
                            ],
                            [
                                -71.57101,
                                -31.49865
                            ],
                            [
                                -71.57251,
                                -31.58006
                            ],
                            [
                                -71.54454,
                                -31.73559
                            ],
                            [
                                -71.50768,
                                -31.77777
                            ],
                            [
                                -71.52017,
                                -31.85217
                            ],
                            [
                                -71.51144,
                                -32.01922
                            ],
                            [
                                -71.53954,
                                -32.19188
                            ],
                            [
                                -71.47364,
                                -32.27222
                            ],
                            [
                                -71.47411,
                                -32.33079
                            ],
                            [
                                -71.41333,
                                -32.38411
                            ],
                            [
                                -71.43144,
                                -32.48073
                            ],
                            [
                                -71.47138,
                                -32.50853
                            ],
                            [
                                -71.4317,
                                -32.62876
                            ],
                            [
                                -71.49197,
                                -32.77037
                            ],
                            [
                                -71.54299,
                                -32.79044
                            ],
                            [
                                -71.5082,
                                -32.90225
                            ],
                            [
                                -71.55042,
                                -32.93208
                            ],
                            [
                                -71.552,
                                -33.00467
                            ],
                            [
                                -71.66554,
                                -33.09358
                            ],
                            [
                                -71.73447,
                                -33.11717
                            ],
                            [
                                -71.65996,
                                -33.2862
                            ],
                            [
                                -71.65537,
                                -33.34987
                            ],
                            [
                                -71.70829,
                                -33.42559
                            ],
                            [
                                -71.60706,
                                -33.52412
                            ],
                            [
                                -71.64297,
                                -33.67506
                            ],
                            [
                                -71.69222,
                                -33.73497
                            ],
                            [
                                -71.79273,
                                -33.7745
                            ],
                            [
                                -71.8287,
                                -33.89619
                            ],
                            [
                                -71.89867,
                                -34.00717
                            ],
                            [
                                -72.00567,
                                -34.13455
                            ],
                            [
                                -71.98294,
                                -34.23021
                            ],
                            [
                                -71.97816,
                                -34.35102
                            ],
                            [
                                -72.04603,
                                -34.42853
                            ],
                            [
                                -72.02608,
                                -34.48897
                            ],
                            [
                                -72.05122,
                                -34.55197
                            ],
                            [
                                -72.04361,
                                -34.63559
                            ],
                            [
                                -72.07793,
                                -34.7442
                            ],
                            [
                                -72.17967,
                                -34.89903
                            ],
                            [
                                -72.1887,
                                -35.06097
                            ],
                            [
                                -72.22355,
                                -35.12758
                            ],
                            [
                                -72.35923,
                                -35.20251
                            ],
                            [
                                -72.40767,
                                -35.31398
                            ],
                            [
                                -72.49351,
                                -35.39168
                            ],
                            [
                                -72.49029,
                                -35.46296
                            ],
                            [
                                -72.61211,
                                -35.55677
                            ],
                            [
                                -72.63046,
                                -35.60929
                            ],
                            [
                                -72.5665,
                                -35.75528
                            ],
                            [
                                -72.58226,
                                -35.81348
                            ],
                            [
                                -72.64711,
                                -35.84867
                            ],
                            [
                                -72.69844,
                                -35.91846
                            ],
                            [
                                -72.78,
                                -35.9757
                            ],
                            [
                                -72.81181,
                                -36.09139
                            ],
                            [
                                -72.81083,
                                -36.27933
                            ],
                            [
                                -72.93223,
                                -36.52478
                            ],
                            [
                                -72.99546,
                                -36.57704
                            ],
                            [
                                -72.95852,
                                -36.62777
                            ],
                            [
                                -72.99455,
                                -36.73175
                            ],
                            [
                                -73.11013,
                                -36.7038
                            ],
                            [
                                -73.18673,
                                -36.78921
                            ],
                            [
                                -73.1544,
                                -36.8407
                            ],
                            [
                                -73.18664,
                                -37.00067
                            ],
                            [
                                -73.14608,
                                -37.0405
                            ],
                            [
                                -73.15622,
                                -37.10957
                            ],
                            [
                                -73.25815,
                                -37.21713
                            ],
                            [
                                -73.3558,
                                -37.24274
                            ],
                            [
                                -73.52765,
                                -37.20712
                            ],
                            [
                                -73.58605,
                                -37.15076
                            ],
                            [
                                -73.6418,
                                -37.19857
                            ],
                            [
                                -73.67678,
                                -37.35897
                            ],
                            [
                                -73.63806,
                                -37.3735
                            ],
                            [
                                -73.59297,
                                -37.45558
                            ],
                            [
                                -73.60145,
                                -37.53316
                            ],
                            [
                                -73.67269,
                                -37.60358
                            ],
                            [
                                -73.64,
                                -37.7414
                            ],
                            [
                                -73.53148,
                                -37.89383
                            ],
                            [
                                -73.45641,
                                -38.07749
                            ],
                            [
                                -73.46328,
                                -38.2112
                            ],
                            [
                                -73.51153,
                                -38.2622
                            ],
                            [
                                -73.49557,
                                -38.32409
                            ],
                            [
                                -73.52773,
                                -38.39179
                            ],
                            [
                                -73.48415,
                                -38.66367
                            ],
                            [
                                -73.32339,
                                -38.98195
                            ],
                            [
                                -73.2255,
                                -39.25397
                            ],
                            [
                                -73.20622,
                                -39.36052
                            ],
                            [
                                -73.21873,
                                -39.44104
                            ],
                            [
                                -73.28501,
                                -39.58735
                            ],
                            [
                                -73.40762,
                                -39.71577
                            ],
                            [
                                -73.39076,
                                -39.76567
                            ],
                            [
                                -73.41935,
                                -39.87131
                            ],
                            [
                                -73.70194,
                                -40.00369
                            ],
                            [
                                -73.65724,
                                -40.0726
                            ],
                            [
                                -73.65535,
                                -40.13862
                            ],
                            [
                                -73.71998,
                                -40.20309
                            ],
                            [
                                -73.74755,
                                -40.28966
                            ],
                            [
                                -73.77354,
                                -40.45653
                            ],
                            [
                                -73.71889,
                                -40.52661
                            ],
                            [
                                -73.75951,
                                -40.62011
                            ],
                            [
                                -73.83022,
                                -40.6671
                            ],
                            [
                                -73.82687,
                                -40.72623
                            ],
                            [
                                -73.88409,
                                -40.86203
                            ],
                            [
                                -73.86151,
                                -40.9371
                            ],
                            [
                                -73.93554,
                                -40.96605
                            ],
                            [
                                -73.91996,
                                -41.14236
                            ],
                            [
                                -73.88548,
                                -41.18763
                            ],
                            [
                                -73.83383,
                                -41.32682
                            ],
                            [
                                -73.83678,
                                -41.4693
                            ],
                            [
                                -73.78422,
                                -41.55351
                            ],
                            [
                                -73.65573,
                                -41.61675
                            ],
                            [
                                -73.72931,
                                -41.73553
                            ],
                            [
                                -73.48011,
                                -41.79768
                            ],
                            [
                                -73.37569,
                                -41.76532
                            ],
                            [
                                -73.23589,
                                -41.79993
                            ],
                            [
                                -73.04025,
                                -41.70266
                            ],
                            [
                                -73.09434,
                                -41.59154
                            ],
                            [
                                -73.04303,
                                -41.5302
                            ],
                            [
                                -72.93978,
                                -41.47422
                            ],
                            [
                                -72.82263,
                                -41.49608
                            ],
                            [
                                -72.73989,
                                -41.54044
                            ],
                            [
                                -72.62411,
                                -41.7078
                            ],
                            [
                                -72.5793,
                                -41.71417
                            ],
                            [
                                -72.38679,
                                -41.6588
                            ],
                            [
                                -72.39643,
                                -41.69976
                            ],
                            [
                                -72.55602,
                                -41.74328
                            ],
                            [
                                -72.6459,
                                -41.73177
                            ],
                            [
                                -72.87473,
                                -41.91476
                            ],
                            [
                                -72.80449,
                                -41.97378
                            ],
                            [
                                -72.69155,
                                -42.02672
                            ],
                            [
                                -72.52988,
                                -42.03653
                            ],
                            [
                                -72.49433,
                                -41.97317
                            ],
                            [
                                -72.43177,
                                -41.97752
                            ],
                            [
                                -72.4644,
                                -42.07958
                            ],
                            [
                                -72.4587,
                                -42.19924
                            ],
                            [
                                -72.51556,
                                -42.24868
                            ],
                            [
                                -72.58715,
                                -42.19158
                            ],
                            [
                                -72.77028,
                                -42.24694
                            ],
                            [
                                -72.79396,
                                -42.31393
                            ],
                            [
                                -72.75511,
                                -42.38767
                            ],
                            [
                                -72.70166,
                                -42.40871
                            ],
                            [
                                -72.67354,
                                -42.52322
                            ],
                            [
                                -72.80874,
                                -42.51045
                            ],
                            [
                                -72.84958,
                                -42.61821
                            ],
                            [
                                -72.82864,
                                -42.66591
                            ],
                            [
                                -72.84964,
                                -42.7747
                            ],
                            [
                                -72.83087,
                                -42.83488
                            ],
                            [
                                -72.71586,
                                -42.91396
                            ],
                            [
                                -72.78784,
                                -43.02922
                            ],
                            [
                                -72.8574,
                                -43.03222
                            ],
                            [
                                -72.91113,
                                -43.12827
                            ],
                            [
                                -72.87262,
                                -43.22839
                            ],
                            [
                                -73.05303,
                                -43.32175
                            ],
                            [
                                -73.05096,
                                -43.39404
                            ],
                            [
                                -73.08644,
                                -43.46655
                            ],
                            [
                                -72.99694,
                                -43.58837
                            ],
                            [
                                -72.91493,
                                -43.60352
                            ],
                            [
                                -72.96807,
                                -43.68391
                            ],
                            [
                                -73.03337,
                                -43.71462
                            ],
                            [
                                -72.87589,
                                -43.79141
                            ],
                            [
                                -72.98051,
                                -43.81034
                            ],
                            [
                                -73.03931,
                                -43.85314
                            ],
                            [
                                -73.11921,
                                -43.97684
                            ],
                            [
                                -73.11852,
                                -44.03908
                            ],
                            [
                                -73.20777,
                                -44.06957
                            ],
                            [
                                -73.27973,
                                -44.16462
                            ],
                            [
                                -73.19384,
                                -44.20108
                            ],
                            [
                                -73.1799,
                                -44.24443
                            ],
                            [
                                -72.9768,
                                -44.28418
                            ],
                            [
                                -72.89529,
                                -44.33206
                            ],
                            [
                                -72.90031,
                                -44.37842
                            ],
                            [
                                -72.79764,
                                -44.3838
                            ],
                            [
                                -72.71532,
                                -44.49709
                            ],
                            [
                                -72.64925,
                                -44.53626
                            ],
                            [
                                -72.66876,
                                -44.62258
                            ],
                            [
                                -72.71662,
                                -44.66543
                            ],
                            [
                                -72.6863,
                                -44.72916
                            ],
                            [
                                -72.74422,
                                -44.74797
                            ],
                            [
                                -72.92745,
                                -44.86467
                            ],
                            [
                                -72.99998,
                                -44.88076
                            ],
                            [
                                -73.07412,
                                -44.93821
                            ],
                            [
                                -73.36269,
                                -44.96764
                            ],
                            [
                                -73.36236,
                                -45.06271
                            ],
                            [
                                -73.27721,
                                -45.15106
                            ],
                            [
                                -73.31159,
                                -45.20123
                            ],
                            [
                                -73.41898,
                                -45.19031
                            ],
                            [
                                -73.41716,
                                -45.275
                            ],
                            [
                                -73.32537,
                                -45.29178
                            ],
                            [
                                -73.20178,
                                -45.24244
                            ],
                            [
                                -73.00469,
                                -45.39662
                            ],
                            [
                                -72.79723,
                                -45.43542
                            ],
                            [
                                -72.87825,
                                -45.47535
                            ],
                            [
                                -72.98534,
                                -45.45284
                            ],
                            [
                                -73.10071,
                                -45.39702
                            ],
                            [
                                -73.19668,
                                -45.29438
                            ],
                            [
                                -73.28534,
                                -45.32238
                            ],
                            [
                                -73.48476,
                                -45.45855
                            ],
                            [
                                -73.55331,
                                -45.78241
                            ],
                            [
                                -73.51915,
                                -45.8488
                            ],
                            [
                                -73.63377,
                                -45.97729
                            ],
                            [
                                -73.60473,
                                -46.0598
                            ],
                            [
                                -73.66585,
                                -46.30943
                            ],
                            [
                                -73.62136,
                                -46.32714
                            ],
                            [
                                -73.72531,
                                -46.42203
                            ],
                            [
                                -73.80521,
                                -46.57133
                            ],
                            [
                                -73.89789,
                                -46.60635
                            ],
                            [
                                -73.84532,
                                -46.68244
                            ],
                            [
                                -73.94726,
                                -46.74268
                            ],
                            [
                                -74.01594,
                                -46.66446
                            ],
                            [
                                -73.85912,
                                -46.45421
                            ],
                            [
                                -73.775,
                                -46.3831
                            ],
                            [
                                -73.72365,
                                -46.26782
                            ],
                            [
                                -73.86369,
                                -46.136
                            ],
                            [
                                -73.986,
                                -46.148
                            ],
                            [
                                -73.94072,
                                -46.07965
                            ],
                            [
                                -74.00721,
                                -45.98781
                            ],
                            [
                                -74.01569,
                                -45.92297
                            ],
                            [
                                -74.13683,
                                -45.89493
                            ],
                            [
                                -74.05468,
                                -45.84625
                            ],
                            [
                                -74.10966,
                                -45.81083
                            ],
                            [
                                -74.28092,
                                -45.82463
                            ],
                            [
                                -74.33908,
                                -45.80072
                            ],
                            [
                                -74.45136,
                                -45.85945
                            ],
                            [
                                -74.6414,
                                -45.84175
                            ],
                            [
                                -74.69142,
                                -45.81962
                            ],
                            [
                                -74.79457,
                                -45.83783
                            ],
                            [
                                -74.96302,
                                -45.9107
                            ],
                            [
                                -75.0099,
                                -45.86398
                            ],
                            [
                                -75.08098,
                                -45.90801
                            ],
                            [
                                -75.04167,
                                -45.97671
                            ],
                            [
                                -75.05016,
                                -46.04157
                            ],
                            [
                                -75.00892,
                                -46.11219
                            ],
                            [
                                -74.77154,
                                -46.11863
                            ],
                            [
                                -74.88764,
                                -46.17627
                            ],
                            [
                                -74.93544,
                                -46.25034
                            ],
                            [
                                -75.04322,
                                -46.22755
                            ],
                            [
                                -75.18081,
                                -46.37875
                            ],
                            [
                                -75.29919,
                                -46.40845
                            ],
                            [
                                -75.39129,
                                -46.52885
                            ],
                            [
                                -75.4994,
                                -46.59461
                            ],
                            [
                                -75.57878,
                                -46.58411
                            ],
                            [
                                -75.62329,
                                -46.6524
                            ],
                            [
                                -75.6351,
                                -46.80636
                            ],
                            [
                                -75.56573,
                                -46.88686
                            ],
                            [
                                -75.42939,
                                -46.96385
                            ],
                            [
                                -75.26084,
                                -46.90226
                            ],
                            [
                                -75.25611,
                                -46.85866
                            ],
                            [
                                -75.39522,
                                -46.71649
                            ],
                            [
                                -75.3408,
                                -46.66537
                            ],
                            [
                                -75.11165,
                                -46.61637
                            ],
                            [
                                -75.03704,
                                -46.61678
                            ],
                            [
                                -75.02306,
                                -46.68181
                            ],
                            [
                                -74.91744,
                                -46.74682
                            ],
                            [
                                -74.70576,
                                -46.80811
                            ],
                            [
                                -74.619,
                                -46.87079
                            ],
                            [
                                -74.40939,
                                -46.88768
                            ],
                            [
                                -74.5982,
                                -46.78375
                            ],
                            [
                                -74.4743,
                                -46.78726
                            ],
                            [
                                -74.32458,
                                -46.7542
                            ],
                            [
                                -74.22498,
                                -46.82246
                            ],
                            [
                                -74.04626,
                                -47.00642
                            ],
                            [
                                -74.12644,
                                -46.99668
                            ],
                            [
                                -74.1677,
                                -47.03381
                            ],
                            [
                                -74.18563,
                                -47.11809
                            ],
                            [
                                -74.05122,
                                -47.16738
                            ],
                            [
                                -74.26634,
                                -47.19925
                            ],
                            [
                                -74.44311,
                                -47.3545
                            ],
                            [
                                -74.47572,
                                -47.44322
                            ],
                            [
                                -74.21546,
                                -47.60248
                            ],
                            [
                                -74.28516,
                                -47.60883
                            ],
                            [
                                -74.37159,
                                -47.54094
                            ],
                            [
                                -74.49972,
                                -47.51587
                            ],
                            [
                                -74.59986,
                                -47.58295
                            ],
                            [
                                -74.68334,
                                -47.69425
                            ],
                            [
                                -74.62125,
                                -47.74826
                            ],
                            [
                                -74.47073,
                                -47.77847
                            ],
                            [
                                -74.42754,
                                -47.74681
                            ],
                            [
                                -74.31568,
                                -47.77544
                            ],
                            [
                                -74.21345,
                                -47.7573
                            ],
                            [
                                -74.14904,
                                -47.78017
                            ],
                            [
                                -74.02661,
                                -47.76735
                            ],
                            [
                                -73.99289,
                                -47.80424
                            ],
                            [
                                -73.87471,
                                -47.82778
                            ],
                            [
                                -73.71607,
                                -47.77076
                            ],
                            [
                                -73.58029,
                                -47.78443
                            ],
                            [
                                -73.48767,
                                -47.83739
                            ],
                            [
                                -73.46488,
                                -47.89371
                            ],
                            [
                                -73.60764,
                                -47.86983
                            ],
                            [
                                -73.59705,
                                -47.99072
                            ],
                            [
                                -73.44709,
                                -48.1231
                            ],
                            [
                                -73.43515,
                                -48.16847
                            ],
                            [
                                -73.52886,
                                -48.22216
                            ],
                            [
                                -73.54711,
                                -48.1373
                            ],
                            [
                                -73.70787,
                                -48.06298
                            ],
                            [
                                -73.81184,
                                -48.06413
                            ],
                            [
                                -73.9131,
                                -48.03614
                            ],
                            [
                                -74.05446,
                                -47.97078
                            ],
                            [
                                -74.28798,
                                -48.00232
                            ],
                            [
                                -74.48224,
                                -47.9314
                            ],
                            [
                                -74.59355,
                                -47.98511
                            ],
                            [
                                -74.59967,
                                -48.04654
                            ],
                            [
                                -74.54006,
                                -48.08896
                            ],
                            [
                                -74.46488,
                                -48.07541
                            ],
                            [
                                -74.42351,
                                -48.14505
                            ],
                            [
                                -74.28049,
                                -48.2105
                            ],
                            [
                                -74.12218,
                                -48.34445
                            ],
                            [
                                -74.05298,
                                -48.38907
                            ],
                            [
                                -73.95063,
                                -48.41704
                            ],
                            [
                                -73.98063,
                                -48.43361
                            ],
                            [
                                -73.99056,
                                -48.52326
                            ],
                            [
                                -74.14812,
                                -48.46826
                            ],
                            [
                                -74.35416,
                                -48.58636
                            ],
                            [
                                -74.33276,
                                -48.74549
                            ],
                            [
                                -74.4017,
                                -48.80448
                            ],
                            [
                                -74.4013,
                                -48.87188
                            ],
                            [
                                -74.35817,
                                -48.95106
                            ],
                            [
                                -74.41445,
                                -48.97703
                            ],
                            [
                                -74.41462,
                                -49.05798
                            ],
                            [
                                -74.36554,
                                -49.10864
                            ],
                            [
                                -74.34908,
                                -49.32186
                            ],
                            [
                                -74.39188,
                                -49.38461
                            ],
                            [
                                -74.30306,
                                -49.43364
                            ],
                            [
                                -74.2159,
                                -49.53188
                            ],
                            [
                                -74.14961,
                                -49.53184
                            ],
                            [
                                -74.1465,
                                -49.41699
                            ],
                            [
                                -74.0724,
                                -49.4114
                            ],
                            [
                                -74.07402,
                                -49.5019
                            ],
                            [
                                -73.86481,
                                -49.53277
                            ],
                            [
                                -73.89086,
                                -49.5617
                            ],
                            [
                                -74.07553,
                                -49.54132
                            ],
                            [
                                -74.20222,
                                -49.57804
                            ],
                            [
                                -74.30518,
                                -49.64407
                            ],
                            [
                                -74.30031,
                                -49.74754
                            ],
                            [
                                -74.33159,
                                -49.8056
                            ],
                            [
                                -74.32074,
                                -49.88331
                            ],
                            [
                                -74.35787,
                                -49.98722
                            ],
                            [
                                -74.30654,
                                -50.05046
                            ],
                            [
                                -74.19824,
                                -50.11876
                            ],
                            [
                                -74.20308,
                                -50.16091
                            ],
                            [
                                -74.10565,
                                -50.22634
                            ],
                            [
                                -74.15945,
                                -50.24684
                            ],
                            [
                                -74.25483,
                                -50.19018
                            ],
                            [
                                -74.26578,
                                -50.12805
                            ],
                            [
                                -74.43573,
                                -50.01931
                            ],
                            [
                                -74.55631,
                                -50.06333
                            ],
                            [
                                -74.57739,
                                -50.10738
                            ],
                            [
                                -74.70208,
                                -50.20039
                            ],
                            [
                                -74.561,
                                -50.24439
                            ],
                            [
                                -74.5406,
                                -50.30339
                            ],
                            [
                                -74.45403,
                                -50.35883
                            ],
                            [
                                -74.2399,
                                -50.44622
                            ],
                            [
                                -74.14749,
                                -50.43214
                            ],
                            [
                                -74.08873,
                                -50.49558
                            ],
                            [
                                -74.29658,
                                -50.47007
                            ],
                            [
                                -74.23041,
                                -50.55759
                            ],
                            [
                                -74.15223,
                                -50.72993
                            ],
                            [
                                -74.06134,
                                -50.81247
                            ],
                            [
                                -73.9234,
                                -50.83982
                            ],
                            [
                                -73.82261,
                                -50.77334
                            ],
                            [
                                -73.83137,
                                -50.68096
                            ],
                            [
                                -73.74463,
                                -50.54001
                            ],
                            [
                                -73.65177,
                                -50.61463
                            ],
                            [
                                -73.7986,
                                -50.68931
                            ],
                            [
                                -73.7851,
                                -50.79966
                            ],
                            [
                                -73.83748,
                                -50.80265
                            ],
                            [
                                -73.86623,
                                -50.88032
                            ],
                            [
                                -73.95347,
                                -50.89005
                            ],
                            [
                                -74.16955,
                                -50.87939
                            ],
                            [
                                -74.24283,
                                -50.96279
                            ],
                            [
                                -74.20562,
                                -51.05307
                            ],
                            [
                                -74.14144,
                                -51.06262
                            ],
                            [
                                -74.11043,
                                -51.19108
                            ],
                            [
                                -74.00886,
                                -51.20645
                            ],
                            [
                                -73.91257,
                                -51.2523
                            ],
                            [
                                -73.81652,
                                -51.2076
                            ],
                            [
                                -73.69011,
                                -51.29911
                            ],
                            [
                                -73.7127,
                                -51.31922
                            ],
                            [
                                -73.67831,
                                -51.42949
                            ],
                            [
                                -73.72672,
                                -51.45392
                            ],
                            [
                                -73.8105,
                                -51.39455
                            ],
                            [
                                -73.91086,
                                -51.38156
                            ],
                            [
                                -73.936,
                                -51.43898
                            ],
                            [
                                -73.9041,
                                -51.54551
                            ],
                            [
                                -73.92083,
                                -51.61763
                            ],
                            [
                                -73.80967,
                                -51.65267
                            ],
                            [
                                -73.81098,
                                -51.70431
                            ],
                            [
                                -73.71123,
                                -51.78868
                            ],
                            [
                                -73.61485,
                                -51.71746
                            ],
                            [
                                -73.47824,
                                -51.88605
                            ],
                            [
                                -73.64508,
                                -51.83028
                            ],
                            [
                                -73.5645,
                                -52.0163
                            ],
                            [
                                -73.4362,
                                -52.07805
                            ],
                            [
                                -73.38602,
                                -52.1294
                            ],
                            [
                                -73.2702,
                                -52.15701
                            ],
                            [
                                -73.26182,
                                -52.10038
                            ],
                            [
                                -73.16169,
                                -52.10038
                            ],
                            [
                                -73.12244,
                                -51.93893
                            ],
                            [
                                -72.93776,
                                -51.88786
                            ],
                            [
                                -72.90944,
                                -51.84737
                            ],
                            [
                                -72.98213,
                                -51.80269
                            ],
                            [
                                -72.9939,
                                -51.72897
                            ],
                            [
                                -72.82038,
                                -51.76047
                            ],
                            [
                                -72.77158,
                                -51.81126
                            ],
                            [
                                -72.63975,
                                -51.82807
                            ],
                            [
                                -72.55063,
                                -51.77754
                            ],
                            [
                                -72.46462,
                                -51.92169
                            ],
                            [
                                -72.65362,
                                -51.9358
                            ],
                            [
                                -72.66452,
                                -52.0522
                            ],
                            [
                                -72.47447,
                                -52.21921
                            ],
                            [
                                -72.51681,
                                -52.26322
                            ],
                            [
                                -72.5167,
                                -52.34744
                            ],
                            [
                                -72.65769,
                                -52.4229
                            ],
                            [
                                -72.78546,
                                -52.42711
                            ],
                            [
                                -72.71405,
                                -52.35154
                            ],
                            [
                                -72.62598,
                                -52.38161
                            ],
                            [
                                -72.54499,
                                -52.21181
                            ],
                            [
                                -72.62539,
                                -52.11435
                            ],
                            [
                                -72.71017,
                                -52.09161
                            ],
                            [
                                -72.74654,
                                -51.96608
                            ],
                            [
                                -72.80937,
                                -51.94101
                            ],
                            [
                                -72.89812,
                                -51.98371
                            ],
                            [
                                -72.90097,
                                -52.05065
                            ],
                            [
                                -73.03199,
                                -52.06687
                            ],
                            [
                                -73.16511,
                                -52.1202
                            ],
                            [
                                -73.23243,
                                -52.11309
                            ],
                            [
                                -73.25034,
                                -52.19697
                            ],
                            [
                                -73.36754,
                                -52.21717
                            ],
                            [
                                -73.422,
                                -52.15108
                            ],
                            [
                                -73.48965,
                                -52.18237
                            ],
                            [
                                -73.61786,
                                -52.10985
                            ],
                            [
                                -73.57472,
                                -52.40204
                            ],
                            [
                                -73.64709,
                                -52.42775
                            ],
                            [
                                -73.5927,
                                -52.4823
                            ],
                            [
                                -73.57379,
                                -52.57094
                            ],
                            [
                                -73.66007,
                                -52.61927
                            ],
                            [
                                -73.63758,
                                -52.68572
                            ],
                            [
                                -73.71594,
                                -52.74184
                            ],
                            [
                                -73.60423,
                                -52.77812
                            ],
                            [
                                -73.55083,
                                -52.71235
                            ],
                            [
                                -73.32765,
                                -52.65792
                            ],
                            [
                                -73.25069,
                                -52.72949
                            ],
                            [
                                -73.31866,
                                -52.82943
                            ],
                            [
                                -73.52269,
                                -52.79389
                            ],
                            [
                                -73.73676,
                                -52.86817
                            ],
                            [
                                -73.4712,
                                -52.92123
                            ],
                            [
                                -73.48226,
                                -52.95341
                            ],
                            [
                                -73.37106,
                                -53.06799
                            ],
                            [
                                -73.2095,
                                -53.11162
                            ],
                            [
                                -72.98829,
                                -53.07316
                            ],
                            [
                                -72.94483,
                                -52.99882
                            ],
                            [
                                -72.97306,
                                -52.94302
                            ],
                            [
                                -72.94006,
                                -52.91078
                            ],
                            [
                                -73.01421,
                                -52.8552
                            ],
                            [
                                -72.88324,
                                -52.81811
                            ],
                            [
                                -72.6879,
                                -52.69576
                            ],
                            [
                                -72.76421,
                                -52.57501
                            ],
                            [
                                -72.65323,
                                -52.55826
                            ],
                            [
                                -72.57474,
                                -52.58583
                            ],
                            [
                                -72.41043,
                                -52.51192
                            ],
                            [
                                -72.395,
                                -52.55765
                            ],
                            [
                                -72.27894,
                                -52.52989
                            ],
                            [
                                -72.12239,
                                -52.51907
                            ],
                            [
                                -72.03476,
                                -52.56106
                            ],
                            [
                                -71.92276,
                                -52.54397
                            ],
                            [
                                -71.63946,
                                -52.57569
                            ],
                            [
                                -71.55975,
                                -52.56457
                            ],
                            [
                                -71.38585,
                                -52.71989
                            ],
                            [
                                -71.34142,
                                -52.80901
                            ],
                            [
                                -71.25416,
                                -52.79265
                            ],
                            [
                                -71.14009,
                                -52.83753
                            ],
                            [
                                -71.11764,
                                -52.91075
                            ],
                            [
                                -71.2428,
                                -52.98697
                            ],
                            [
                                -71.3574,
                                -53.1223
                            ],
                            [
                                -71.50526,
                                -53.1429
                            ],
                            [
                                -71.60635,
                                -53.19714
                            ],
                            [
                                -71.73247,
                                -53.23292
                            ],
                            [
                                -71.77485,
                                -53.33826
                            ],
                            [
                                -71.85573,
                                -53.23493
                            ],
                            [
                                -71.98181,
                                -53.2271
                            ],
                            [
                                -72.04205,
                                -53.283
                            ],
                            [
                                -72.02208,
                                -53.37851
                            ],
                            [
                                -72.07257,
                                -53.38631
                            ],
                            [
                                -72.12149,
                                -53.2565
                            ],
                            [
                                -72.30321,
                                -53.25481
                            ],
                            [
                                -72.44115,
                                -53.32571
                            ],
                            [
                                -72.47667,
                                -53.39715
                            ],
                            [
                                -72.42518,
                                -53.47818
                            ],
                            [
                                -72.34521,
                                -53.54542
                            ],
                            [
                                -72.11129,
                                -53.68207
                            ],
                            [
                                -71.76247,
                                -53.76508
                            ],
                            [
                                -71.71917,
                                -53.79255
                            ],
                            [
                                -71.41991,
                                -53.85009
                            ],
                            [
                                -71.30231,
                                -53.89555
                            ],
                            [
                                -71.23547,
                                -53.88664
                            ],
                            [
                                -71.00353,
                                -53.80058
                            ],
                            [
                                -70.9283,
                                -53.5847
                            ],
                            [
                                -70.98674,
                                -53.39863
                            ],
                            [
                                -70.93618,
                                -53.31206
                            ],
                            [
                                -70.91679,
                                -53.17298
                            ],
                            [
                                -70.82735,
                                -53.02603
                            ],
                            [
                                -70.85453,
                                -52.92322
                            ],
                            [
                                -70.79485,
                                -52.76295
                            ],
                            [
                                -70.57576,
                                -52.67555
                            ],
                            [
                                -70.52671,
                                -52.72362
                            ],
                            [
                                -70.31194,
                                -52.64029
                            ],
                            [
                                -70.21541,
                                -52.65022
                            ],
                            [
                                -70.16358,
                                -52.58959
                            ],
                            [
                                -70.02262,
                                -52.55698
                            ],
                            [
                                -69.83843,
                                -52.49067
                            ],
                            [
                                -69.7743,
                                -52.52766
                            ],
                            [
                                -69.67071,
                                -52.53721
                            ],
                            [
                                -69.54466,
                                -52.45483
                            ],
                            [
                                -69.48508,
                                -52.38697
                            ],
                            [
                                -69.45482,
                                -52.26418
                            ],
                            [
                                -69.34175,
                                -52.2463
                            ],
                            [
                                -69.22228,
                                -52.19805
                            ],
                            [
                                -69.05354,
                                -52.23201
                            ],
                            [
                                -68.97579,
                                -52.28932
                            ],
                            [
                                -68.79093,
                                -52.31788
                            ],
                            [
                                -68.73124,
                                -52.30912
                            ],
                            [
                                -68.46732,
                                -52.34587
                            ],
                            [
                                -68.43219,
                                -52.39755
                            ],
                            [
                                -68.41918,
                                -52.33342
                            ],
                            [
                                -68.56963,
                                -52.32529
                            ],
                            [
                                -68.70765,
                                -52.28503
                            ],
                            [
                                -68.8356,
                                -52.27699
                            ],
                            [
                                -68.97184,
                                -52.21306
                            ],
                            [
                                -69.19073,
                                -52.15546
                            ],
                            [
                                -69.49015,
                                -52.156
                            ],
                            [
                                -70.0129,
                                -52.0086
                            ],
                            [
                                -70.95356,
                                -52.01391
                            ],
                            [
                                -71.9015,
                                -52.01863
                            ],
                            [
                                -71.9988,
                                -51.98426
                            ],
                            [
                                -71.94098,
                                -51.90106
                            ],
                            [
                                -72.01629,
                                -51.81757
                            ],
                            [
                                -72.18418,
                                -51.72243
                            ],
                            [
                                -72.29286,
                                -51.69892
                            ],
                            [
                                -72.3436,
                                -51.59666
                            ],
                            [
                                -72.42289,
                                -51.53585
                            ],
                            [
                                -72.35033,
                                -51.48528
                            ],
                            [
                                -72.32157,
                                -51.30528
                            ],
                            [
                                -72.26013,
                                -51.23578
                            ],
                            [
                                -72.36593,
                                -51.18157
                            ],
                            [
                                -72.40167,
                                -51.11934
                            ],
                            [
                                -72.34209,
                                -51.04548
                            ],
                            [
                                -72.25028,
                                -51.02392
                            ],
                            [
                                -72.23091,
                                -50.85524
                            ],
                            [
                                -72.32682,
                                -50.74478
                            ],
                            [
                                -72.27934,
                                -50.66163
                            ],
                            [
                                -72.3691,
                                -50.61677
                            ],
                            [
                                -72.47365,
                                -50.60267
                            ],
                            [
                                -72.61529,
                                -50.67482
                            ],
                            [
                                -72.73761,
                                -50.61641
                            ],
                            [
                                -72.86376,
                                -50.65619
                            ],
                            [
                                -73.00133,
                                -50.74855
                            ],
                            [
                                -73.08625,
                                -50.7784
                            ],
                            [
                                -73.1705,
                                -50.73408
                            ],
                            [
                                -73.16838,
                                -50.64694
                            ],
                            [
                                -73.4408,
                                -50.42795
                            ],
                            [
                                -73.5409,
                                -50.32924
                            ],
                            [
                                -73.57527,
                                -50.26202
                            ],
                            [
                                -73.50167,
                                -50.05824
                            ],
                            [
                                -73.54389,
                                -49.92498
                            ],
                            [
                                -73.44346,
                                -49.83891
                            ],
                            [
                                -73.45241,
                                -49.73447
                            ],
                            [
                                -73.52813,
                                -49.67171
                            ],
                            [
                                -73.50419,
                                -49.61003
                            ],
                            [
                                -73.57169,
                                -49.55447
                            ],
                            [
                                -73.5019,
                                -49.51239
                            ],
                            [
                                -73.52211,
                                -49.44718
                            ],
                            [
                                -73.46441,
                                -49.40217
                            ],
                            [
                                -73.4588,
                                -49.29952
                            ],
                            [
                                -73.4928,
                                -49.18069
                            ],
                            [
                                -73.39484,
                                -49.13881
                            ],
                            [
                                -73.26505,
                                -49.13887
                            ],
                            [
                                -73.21587,
                                -49.16252
                            ],
                            [
                                -73.09289,
                                -49.1342
                            ],
                            [
                                -73.08077,
                                -49.08343
                            ],
                            [
                                -72.92471,
                                -48.94515
                            ],
                            [
                                -72.83965,
                                -48.94818
                            ],
                            [
                                -72.7365,
                                -48.91836
                            ],
                            [
                                -72.56643,
                                -48.81126
                            ],
                            [
                                -72.54742,
                                -48.66977
                            ],
                            [
                                -72.59693,
                                -48.47634
                            ],
                            [
                                -72.49824,
                                -48.42054
                            ],
                            [
                                -72.39697,
                                -48.40396
                            ],
                            [
                                -72.29416,
                                -48.34898
                            ],
                            [
                                -72.33051,
                                -48.08717
                            ],
                            [
                                -72.5052,
                                -47.94918
                            ],
                            [
                                -72.52324,
                                -47.91269
                            ],
                            [
                                -72.4699,
                                -47.84952
                            ],
                            [
                                -72.40846,
                                -47.72309
                            ],
                            [
                                -72.30697,
                                -47.59165
                            ],
                            [
                                -72.28854,
                                -47.50626
                            ],
                            [
                                -72.32163,
                                -47.43329
                            ],
                            [
                                -72.15421,
                                -47.41404
                            ],
                            [
                                -72.00914,
                                -47.2626
                            ],
                            [
                                -71.99638,
                                -47.20314
                            ],
                            [
                                -71.88813,
                                -47.24011
                            ],
                            [
                                -71.84928,
                                -47.21798
                            ],
                            [
                                -71.85426,
                                -47.13847
                            ],
                            [
                                -71.97251,
                                -47.07087
                            ],
                            [
                                -71.9148,
                                -47.00471
                            ],
                            [
                                -71.94545,
                                -46.92725
                            ],
                            [
                                -71.92968,
                                -46.81137
                            ],
                            [
                                -71.76395,
                                -46.76286
                            ],
                            [
                                -71.64642,
                                -46.68125
                            ],
                            [
                                -71.67657,
                                -46.58047
                            ],
                            [
                                -71.66561,
                                -46.50722
                            ],
                            [
                                -71.73274,
                                -46.35408
                            ],
                            [
                                -71.74295,
                                -46.25306
                            ],
                            [
                                -71.88978,
                                -46.15274
                            ],
                            [
                                -71.72435,
                                -46.08861
                            ],
                            [
                                -71.5983,
                                -45.96413
                            ],
                            [
                                -71.63062,
                                -45.88811
                            ],
                            [
                                -71.73136,
                                -45.84796
                            ],
                            [
                                -71.771,
                                -45.73731
                            ],
                            [
                                -71.73205,
                                -45.54551
                            ],
                            [
                                -71.64644,
                                -45.51884
                            ],
                            [
                                -71.51189,
                                -45.52086
                            ],
                            [
                                -71.46422,
                                -45.45562
                            ],
                            [
                                -71.50374,
                                -45.39829
                            ],
                            [
                                -71.36043,
                                -45.35275
                            ],
                            [
                                -71.29825,
                                -45.30096
                            ],
                            [
                                -71.33313,
                                -45.22021
                            ],
                            [
                                -71.43855,
                                -45.15555
                            ],
                            [
                                -71.54205,
                                -45.00001
                            ],
                            [
                                -71.74612,
                                -44.92677
                            ],
                            [
                                -71.8946,
                                -44.939
                            ],
                            [
                                -72.03351,
                                -44.90615
                            ],
                            [
                                -72.06969,
                                -44.76837
                            ],
                            [
                                -71.83567,
                                -44.79365
                            ],
                            [
                                -71.78314,
                                -44.75513
                            ],
                            [
                                -71.60015,
                                -44.77855
                            ],
                            [
                                -71.48715,
                                -44.73526
                            ],
                            [
                                -71.38043,
                                -44.80099
                            ],
                            [
                                -71.30263,
                                -44.80799
                            ],
                            [
                                -71.21905,
                                -44.73935
                            ],
                            [
                                -71.23639,
                                -44.65525
                            ],
                            [
                                -71.20948,
                                -44.60589
                            ],
                            [
                                -71.13091,
                                -44.57968
                            ],
                            [
                                -71.11021,
                                -44.52308
                            ],
                            [
                                -71.21142,
                                -44.4276
                            ],
                            [
                                -71.3346,
                                -44.42134
                            ],
                            [
                                -71.4155,
                                -44.39465
                            ],
                            [
                                -71.78586,
                                -44.40624
                            ],
                            [
                                -71.81747,
                                -44.26594
                            ],
                            [
                                -71.79255,
                                -44.20548
                            ],
                            [
                                -71.85164,
                                -44.11487
                            ],
                            [
                                -71.78047,
                                -44.09168
                            ],
                            [
                                -71.65515,
                                -43.94629
                            ],
                            [
                                -71.75324,
                                -43.83988
                            ],
                            [
                                -71.689,
                                -43.73483
                            ],
                            [
                                -71.60605,
                                -43.70661
                            ],
                            [
                                -71.58744,
                                -43.65083
                            ],
                            [
                                -71.69362,
                                -43.62932
                            ],
                            [
                                -71.77595,
                                -43.54522
                            ],
                            [
                                -71.93033,
                                -43.44681
                            ],
                            [
                                -71.88387,
                                -43.32651
                            ],
                            [
                                -71.73009,
                                -43.30904
                            ],
                            [
                                -71.74122,
                                -43.17158
                            ],
                            [
                                -71.9665,
                                -43.09126
                            ],
                            [
                                -71.98423,
                                -43.03554
                            ],
                            [
                                -72.10994,
                                -42.9132
                            ],
                            [
                                -72.10182,
                                -42.76659
                            ],
                            [
                                -72.12713,
                                -42.6763
                            ],
                            [
                                -72.11724,
                                -42.56026
                            ],
                            [
                                -72.03407,
                                -42.50278
                            ],
                            [
                                -72.05064,
                                -42.37754
                            ],
                            [
                                -72.12168,
                                -42.31438
                            ],
                            [
                                -72.02845,
                                -42.14261
                            ],
                            [
                                -71.91722,
                                -42.18646
                            ],
                            [
                                -71.77595,
                                -42.14674
                            ],
                            [
                                -71.72856,
                                -42.11544
                            ],
                            [
                                -71.75909,
                                -42.02081
                            ],
                            [
                                -71.7623,
                                -41.86838
                            ],
                            [
                                -71.82635,
                                -41.79095
                            ],
                            [
                                -71.83369,
                                -41.73153
                            ],
                            [
                                -71.8922,
                                -41.62497
                            ],
                            [
                                -71.81943,
                                -41.57103
                            ],
                            [
                                -71.85859,
                                -41.50657
                            ],
                            [
                                -71.87899,
                                -41.37124
                            ],
                            [
                                -71.84252,
                                -41.25408
                            ],
                            [
                                -71.82961,
                                -41.05664
                            ],
                            [
                                -71.88863,
                                -40.9869
                            ],
                            [
                                -71.85822,
                                -40.91286
                            ],
                            [
                                -71.94533,
                                -40.7298
                            ],
                            [
                                -71.83129,
                                -40.62733
                            ],
                            [
                                -71.85008,
                                -40.5592
                            ],
                            [
                                -71.80572,
                                -40.41343
                            ],
                            [
                                -71.71975,
                                -40.43778
                            ],
                            [
                                -71.65484,
                                -40.36102
                            ],
                            [
                                -71.68174,
                                -40.29987
                            ],
                            [
                                -71.76172,
                                -40.27858
                            ],
                            [
                                -71.82674,
                                -40.21721
                            ],
                            [
                                -71.791,
                                -40.07824
                            ],
                            [
                                -71.71008,
                                -40.11313
                            ],
                            [
                                -71.66511,
                                -40.07934
                            ],
                            [
                                -71.68416,
                                -40.02678
                            ],
                            [
                                -71.61499,
                                -39.96334
                            ],
                            [
                                -71.59416,
                                -39.89106
                            ],
                            [
                                -71.67212,
                                -39.85665
                            ],
                            [
                                -71.70967,
                                -39.72909
                            ],
                            [
                                -71.71504,
                                -39.64761
                            ],
                            [
                                -71.66766,
                                -39.57323
                            ],
                            [
                                -71.60213,
                                -39.6267
                            ],
                            [
                                -71.49232,
                                -39.6167
                            ],
                            [
                                -71.47188,
                                -39.40144
                            ],
                            [
                                -71.39143,
                                -39.30378
                            ],
                            [
                                -71.38773,
                                -39.20872
                            ],
                            [
                                -71.43723,
                                -39.04229
                            ],
                            [
                                -71.42151,
                                -38.92404
                            ],
                            [
                                -71.08922,
                                -38.75379
                            ],
                            [
                                -70.94785,
                                -38.74508
                            ],
                            [
                                -70.83352,
                                -38.55671
                            ],
                            [
                                -71.00438,
                                -38.40513
                            ],
                            [
                                -71.03513,
                                -38.25044
                            ],
                            [
                                -71.01634,
                                -38.16832
                            ],
                            [
                                -71.03781,
                                -38.06178
                            ],
                            [
                                -71.08993,
                                -37.96969
                            ],
                            [
                                -71.10411,
                                -37.88562
                            ],
                            [
                                -71.20211,
                                -37.68123
                            ],
                            [
                                -71.13937,
                                -37.59268
                            ],
                            [
                                -71.11862,
                                -37.48178
                            ],
                            [
                                -71.18442,
                                -37.3761
                            ],
                            [
                                -71.20741,
                                -37.27924
                            ],
                            [
                                -71.14418,
                                -37.2081
                            ],
                            [
                                -71.13279,
                                -37.07444
                            ],
                            [
                                -71.1554,
                                -37.00174
                            ],
                            [
                                -71.10278,
                                -36.95121
                            ],
                            [
                                -71.16441,
                                -36.83228
                            ],
                            [
                                -71.13027,
                                -36.79454
                            ],
                            [
                                -71.11186,
                                -36.66165
                            ],
                            [
                                -71.02386,
                                -36.64849
                            ],
                            [
                                -71.05016,
                                -36.59676
                            ],
                            [
                                -71.03789,
                                -36.47314
                            ],
                            [
                                -70.95747,
                                -36.48254
                            ],
                            [
                                -70.88858,
                                -36.43973
                            ],
                            [
                                -70.8913,
                                -36.39187
                            ],
                            [
                                -70.7048,
                                -36.41048
                            ],
                            [
                                -70.6962,
                                -36.25171
                            ],
                            [
                                -70.63482,
                                -36.22918
                            ],
                            [
                                -70.56847,
                                -36.12558
                            ],
                            [
                                -70.47073,
                                -36.17038
                            ],
                            [
                                -70.41955,
                                -36.14422
                            ],
                            [
                                -70.37307,
                                -36.03286
                            ],
                            [
                                -70.4155,
                                -35.89733
                            ],
                            [
                                -70.32653,
                                -35.81375
                            ],
                            [
                                -70.40121,
                                -35.62952
                            ],
                            [
                                -70.39109,
                                -35.52483
                            ],
                            [
                                -70.44224,
                                -35.4461
                            ],
                            [
                                -70.42208,
                                -35.35113
                            ],
                            [
                                -70.54055,
                                -35.30428
                            ],
                            [
                                -70.57675,
                                -35.26033
                            ],
                            [
                                -70.5452,
                                -35.20569
                            ],
                            [
                                -70.3988,
                                -35.17812
                            ],
                            [
                                -70.3586,
                                -35.1229
                            ],
                            [
                                -70.371,
                                -35.04864
                            ],
                            [
                                -70.33784,
                                -34.93049
                            ],
                            [
                                -70.28102,
                                -34.85195
                            ],
                            [
                                -70.26868,
                                -34.79101
                            ],
                            [
                                -70.3117,
                                -34.76632
                            ],
                            [
                                -70.22735,
                                -34.67637
                            ],
                            [
                                -70.22238,
                                -34.62275
                            ],
                            [
                                -70.13095,
                                -34.49241
                            ],
                            [
                                -70.01555,
                                -34.40489
                            ],
                            [
                                -70.0386,
                                -34.29321
                            ],
                            [
                                -69.98752,
                                -34.25921
                            ],
                            [
                                -69.92234,
                                -34.29181
                            ],
                            [
                                -69.83851,
                                -34.24667
                            ],
                            [
                                -69.8716,
                                -34.11654
                            ],
                            [
                                -69.83394,
                                -33.97553
                            ],
                            [
                                -69.86454,
                                -33.94311
                            ],
                            [
                                -69.89048,
                                -33.79776
                            ],
                            [
                                -69.86161,
                                -33.76256
                            ],
                            [
                                -69.8843,
                                -33.68
                            ],
                            [
                                -69.87062,
                                -33.56688
                            ],
                            [
                                -69.83865,
                                -33.5002
                            ],
                            [
                                -69.75218,
                                -33.44445
                            ],
                            [
                                -69.77881,
                                -33.33436
                            ],
                            [
                                -69.86117,
                                -33.2386
                            ],
                            [
                                -69.90894,
                                -33.232
                            ],
                            [
                                -69.9518,
                                -33.3102
                            ],
                            [
                                -70.01527,
                                -33.32441
                            ],
                            [
                                -70.0692,
                                -33.15545
                            ],
                            [
                                -70.09094,
                                -33.04259
                            ],
                            [
                                -70.0484,
                                -33.01897
                            ],
                            [
                                -70.00839,
                                -32.88821
                            ],
                            [
                                -70.10657,
                                -32.79665
                            ],
                            [
                                -70.14854,
                                -32.71788
                            ],
                            [
                                -70.16855,
                                -32.61351
                            ],
                            [
                                -70.12938,
                                -32.5619
                            ],
                            [
                                -70.14168,
                                -32.48583
                            ],
                            [
                                -70.22057,
                                -32.44019
                            ],
                            [
                                -70.23211,
                                -32.32105
                            ],
                            [
                                -70.31875,
                                -32.26318
                            ],
                            [
                                -70.29803,
                                -32.15762
                            ],
                            [
                                -70.36542,
                                -32.03405
                            ],
                            [
                                -70.27874,
                                -32.04314
                            ],
                            [
                                -70.21041,
                                -31.98769
                            ],
                            [
                                -70.27259,
                                -31.89509
                            ],
                            [
                                -70.36467,
                                -31.88736
                            ],
                            [
                                -70.44649,
                                -31.83303
                            ],
                            [
                                -70.45757,
                                -31.72512
                            ],
                            [
                                -70.49573,
                                -31.68787
                            ],
                            [
                                -70.55266,
                                -31.56023
                            ],
                            [
                                -70.53731,
                                -31.32682
                            ],
                            [
                                -70.51018,
                                -31.16318
                            ],
                            [
                                -70.45332,
                                -31.09443
                            ],
                            [
                                -70.39127,
                                -31.16881
                            ],
                            [
                                -70.30989,
                                -31.05371
                            ],
                            [
                                -70.29153,
                                -30.96646
                            ],
                            [
                                -70.30414,
                                -30.89822
                            ],
                            [
                                -70.27589,
                                -30.78874
                            ],
                            [
                                -70.21975,
                                -30.7106
                            ],
                            [
                                -70.21934,
                                -30.61766
                            ],
                            [
                                -70.15815,
                                -30.48498
                            ],
                            [
                                -70.07036,
                                -30.38486
                            ],
                            [
                                -69.97152,
                                -30.39621
                            ],
                            [
                                -69.91272,
                                -30.35149
                            ],
                            [
                                -69.81742,
                                -30.21645
                            ],
                            [
                                -69.81073,
                                -30.14465
                            ],
                            [
                                -69.93779,
                                -30.07682
                            ],
                            [
                                -69.87116,
                                -29.9217
                            ],
                            [
                                -69.86305,
                                -29.83957
                            ],
                            [
                                -69.87907,
                                -29.68142
                            ],
                            [
                                -69.94054,
                                -29.62096
                            ],
                            [
                                -69.93252,
                                -29.53096
                            ],
                            [
                                -70.00612,
                                -29.35601
                            ],
                            [
                                -69.95138,
                                -29.27557
                            ],
                            [
                                -69.93399,
                                -29.20816
                            ],
                            [
                                -69.85917,
                                -29.1465
                            ],
                            [
                                -69.79611,
                                -29.15462
                            ],
                            [
                                -69.75411,
                                -29.06308
                            ],
                            [
                                -69.75474,
                                -28.95887
                            ],
                            [
                                -69.69832,
                                -28.79757
                            ],
                            [
                                -69.7329,
                                -28.72253
                            ],
                            [
                                -69.71543,
                                -28.66368
                            ],
                            [
                                -69.65066,
                                -28.58228
                            ],
                            [
                                -69.64115,
                                -28.38072
                            ],
                            [
                                -69.50354,
                                -28.33693
                            ],
                            [
                                -69.44792,
                                -28.20825
                            ],
                            [
                                -69.38417,
                                -28.21223
                            ],
                            [
                                -69.28329,
                                -28.13487
                            ],
                            [
                                -69.28999,
                                -28.06699
                            ],
                            [
                                -69.24307,
                                -27.98935
                            ],
                            [
                                -69.18256,
                                -27.97376
                            ],
                            [
                                -69.11258,
                                -27.89212
                            ],
                            [
                                -69.08481,
                                -27.72936
                            ],
                            [
                                -69.04968,
                                -27.69857
                            ],
                            [
                                -69.06002,
                                -27.63937
                            ],
                            [
                                -69.00324,
                                -27.55447
                            ],
                            [
                                -68.96529,
                                -27.43701
                            ],
                            [
                                -68.90192,
                                -27.37849
                            ],
                            [
                                -68.85254,
                                -27.29487
                            ],
                            [
                                -68.87592,
                                -27.25212
                            ],
                            [
                                -68.85178,
                                -27.17969
                            ],
                            [
                                -68.77009,
                                -27.10509
                            ],
                            [
                                -68.68486,
                                -27.08429
                            ],
                            [
                                -68.60888,
                                -27.16828
                            ],
                            [
                                -68.54689,
                                -27.18724
                            ],
                            [
                                -68.48041,
                                -27.06485
                            ],
                            [
                                -68.32657,
                                -27.04184
                            ],
                            [
                                -68.30906,
                                -26.89177
                            ],
                            [
                                -68.42427,
                                -26.74195
                            ],
                            [
                                -68.58587,
                                -26.51057
                            ],
                            [
                                -68.56889,
                                -26.3066
                            ],
                            [
                                -68.39124,
                                -26.18775
                            ],
                            [
                                -68.48068,
                                -25.72138
                            ],
                            [
                                -68.55895,
                                -25.65699
                            ],
                            [
                                -68.55632,
                                -25.52143
                            ],
                            [
                                -68.58354,
                                -25.44608
                            ],
                            [
                                -68.55088,
                                -25.31979
                            ],
                            [
                                -68.57909,
                                -25.19605
                            ],
                            [
                                -68.4772,
                                -25.13164
                            ],
                            [
                                -68.40544,
                                -25.1394
                            ],
                            [
                                -68.35374,
                                -25.09211
                            ],
                            [
                                -68.45539,
                                -24.92896
                            ],
                            [
                                -68.57676,
                                -24.81647
                            ],
                            [
                                -68.56744,
                                -24.7507
                            ],
                            [
                                -68.49623,
                                -24.64518
                            ],
                            [
                                -68.40448,
                                -24.54719
                            ],
                            [
                                -68.40359,
                                -24.48653
                            ],
                            [
                                -68.31743,
                                -24.48372
                            ],
                            [
                                -68.28139,
                                -24.42022
                            ],
                            [
                                -68.21554,
                                -24.38086
                            ],
                            [
                                -67.63436,
                                -24.15474
                            ],
                            [
                                -67.34402,
                                -24.03773
                            ],
                            [
                                -67.29349,
                                -23.94925
                            ],
                            [
                                -67.15566,
                                -23.5202
                            ],
                            [
                                -66.98865,
                                -22.99421
                            ],
                            [
                                -67.1775,
                                -22.80469
                            ],
                            [
                                -67.57216,
                                -22.89566
                            ],
                            [
                                -67.79176,
                                -22.87368
                            ],
                            [
                                -67.8737,
                                -22.8276
                            ],
                            [
                                -67.88532,
                                -22.7093
                            ],
                            [
                                -67.84871,
                                -22.54684
                            ],
                            [
                                -67.88813,
                                -22.49656
                            ],
                            [
                                -67.89585,
                                -22.4157
                            ],
                            [
                                -67.9454,
                                -22.32335
                            ],
                            [
                                -67.92196,
                                -22.22661
                            ],
                            [
                                -67.95196,
                                -22.16283
                            ],
                            [
                                -67.93962,
                                -22.11519
                            ],
                            [
                                -67.96501,
                                -22.04795
                            ],
                            [
                                -68.06403,
                                -21.97504
                            ],
                            [
                                -68.05715,
                                -21.76371
                            ],
                            [
                                -68.11056,
                                -21.67382
                            ],
                            [
                                -68.17689,
                                -21.5982
                            ],
                            [
                                -68.17279,
                                -21.29685
                            ],
                            [
                                -68.28675,
                                -21.10371
                            ],
                            [
                                -68.40053,
                                -20.93809
                            ],
                            [
                                -68.5046,
                                -20.93631
                            ],
                            [
                                -68.54835,
                                -20.86606
                            ],
                            [
                                -68.54916,
                                -20.72633
                            ],
                            [
                                -68.50254,
                                -20.67054
                            ],
                            [
                                -68.53826,
                                -20.56019
                            ],
                            [
                                -68.67814,
                                -20.49832
                            ],
                            [
                                -68.73558,
                                -20.44183
                            ],
                            [
                                -68.74067,
                                -20.36422
                            ],
                            [
                                -68.66389,
                                -20.32292
                            ],
                            [
                                -68.71258,
                                -20.23934
                            ],
                            [
                                -68.70529,
                                -20.14231
                            ],
                            [
                                -68.77523,
                                -20.08088
                            ],
                            [
                                -68.65137,
                                -20.05062
                            ],
                            [
                                -68.56054,
                                -20.04426
                            ],
                            [
                                -68.52346,
                                -19.91928
                            ],
                            [
                                -68.5306,
                                -19.84332
                            ],
                            [
                                -68.60563,
                                -19.81823
                            ],
                            [
                                -68.68426,
                                -19.72497
                            ],
                            [
                                -68.62247,
                                -19.69611
                            ],
                            [
                                -68.59523,
                                -19.63904
                            ],
                            [
                                -68.43283,
                                -19.43898
                            ],
                            [
                                -68.413,
                                -19.39579
                            ],
                            [
                                -68.53169,
                                -19.30078
                            ],
                            [
                                -68.61577,
                                -19.26943
                            ],
                            [
                                -68.67008,
                                -19.189
                            ],
                            [
                                -68.8003,
                                -19.08621
                            ],
                            [
                                -68.89777,
                                -19.03182
                            ],
                            [
                                -68.95426,
                                -18.93568
                            ],
                            [
                                -68.90945,
                                -18.87723
                            ],
                            [
                                -68.97782,
                                -18.74909
                            ],
                            [
                                -69.02377,
                                -18.45566
                            ],
                            [
                                -69.07059,
                                -18.23783
                            ],
                            [
                                -69.134,
                                -18.16745
                            ],
                            [
                                -69.06835,
                                -18.06837
                            ],
                            [
                                -69.08441,
                                -18.04393
                            ],
                            [
                                -69.29583,
                                -17.95062
                            ],
                            [
                                -69.3121,
                                -17.91093
                            ],
                            [
                                -69.30913,
                                -17.79912
                            ],
                            [
                                -69.34478,
                                -17.71768
                            ],
                            [
                                -69.4612,
                                -17.60551
                            ],
                            [
                                -69.47262,
                                -17.49896
                            ],
                            [
                                -69.5565,
                                -17.58354
                            ],
                            [
                                -69.66191,
                                -17.6578
                            ],
                            [
                                -69.7946,
                                -17.64793
                            ],
                            [
                                -69.82127,
                                -17.70107
                            ],
                            [
                                -69.79241,
                                -17.86959
                            ],
                            [
                                -69.74695,
                                -17.93922
                            ],
                            [
                                -69.75551,
                                -17.9919
                            ],
                            [
                                -69.81895,
                                -18.11862
                            ],
                            [
                                -69.93636,
                                -18.23737
                            ],
                            [
                                -70.0487,
                                -18.26488
                            ],
                            [
                                -70.19095,
                                -18.31919
                            ],
                            [
                                -70.3047,
                                -18.30556
                            ],
                            [
                                -70.37617,
                                -18.35358
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -68.60862,
                                -52.64952
                            ],
                            [
                                -68.71346,
                                -52.59037
                            ],
                            [
                                -68.94071,
                                -52.65565
                            ],
                            [
                                -69.14453,
                                -52.69731
                            ],
                            [
                                -69.22566,
                                -52.66505
                            ],
                            [
                                -69.31903,
                                -52.5692
                            ],
                            [
                                -69.3813,
                                -52.47213
                            ],
                            [
                                -69.43394,
                                -52.45477
                            ],
                            [
                                -69.60191,
                                -52.54515
                            ],
                            [
                                -69.59208,
                                -52.6483
                            ],
                            [
                                -69.74814,
                                -52.77572
                            ],
                            [
                                -69.8391,
                                -52.7876
                            ],
                            [
                                -69.90529,
                                -52.8398
                            ],
                            [
                                -70.02158,
                                -52.8282
                            ],
                            [
                                -70.13169,
                                -52.73293
                            ],
                            [
                                -70.3044,
                                -52.74167
                            ],
                            [
                                -70.26043,
                                -52.86496
                            ],
                            [
                                -70.08997,
                                -52.92669
                            ],
                            [
                                -70.13923,
                                -53.01371
                            ],
                            [
                                -70.25405,
                                -53.06253
                            ],
                            [
                                -70.34198,
                                -52.99901
                            ],
                            [
                                -70.41909,
                                -53.01455
                            ],
                            [
                                -70.43494,
                                -53.17096
                            ],
                            [
                                -70.46785,
                                -53.28441
                            ],
                            [
                                -70.45663,
                                -53.37409
                            ],
                            [
                                -70.30879,
                                -53.40906
                            ],
                            [
                                -70.21777,
                                -53.47671
                            ],
                            [
                                -70.10529,
                                -53.45403
                            ],
                            [
                                -69.94864,
                                -53.39292
                            ],
                            [
                                -69.5768,
                                -53.34675
                            ],
                            [
                                -69.37319,
                                -53.35796
                            ],
                            [
                                -69.30856,
                                -53.4773
                            ],
                            [
                                -69.35321,
                                -53.52154
                            ],
                            [
                                -69.6677,
                                -53.64451
                            ],
                            [
                                -69.77885,
                                -53.66597
                            ],
                            [
                                -69.90648,
                                -53.66202
                            ],
                            [
                                -69.95939,
                                -53.71088
                            ],
                            [
                                -70.13286,
                                -53.74575
                            ],
                            [
                                -70.17436,
                                -53.83548
                            ],
                            [
                                -70.13816,
                                -53.93431
                            ],
                            [
                                -70.08227,
                                -53.98846
                            ],
                            [
                                -70.03708,
                                -54.09593
                            ],
                            [
                                -69.90481,
                                -54.15403
                            ],
                            [
                                -69.5367,
                                -54.2491
                            ],
                            [
                                -69.32102,
                                -54.31761
                            ],
                            [
                                -68.98794,
                                -54.43935
                            ],
                            [
                                -69.02882,
                                -54.46841
                            ],
                            [
                                -69.2042,
                                -54.44964
                            ],
                            [
                                -69.38653,
                                -54.39569
                            ],
                            [
                                -69.45629,
                                -54.34792
                            ],
                            [
                                -69.54462,
                                -54.34413
                            ],
                            [
                                -69.5525,
                                -54.40252
                            ],
                            [
                                -69.73798,
                                -54.31049
                            ],
                            [
                                -69.86472,
                                -54.3236
                            ],
                            [
                                -69.93406,
                                -54.36128
                            ],
                            [
                                -69.9879,
                                -54.27136
                            ],
                            [
                                -70.05867,
                                -54.2532
                            ],
                            [
                                -70.20376,
                                -54.33966
                            ],
                            [
                                -70.27341,
                                -54.34548
                            ],
                            [
                                -70.60093,
                                -54.24519
                            ],
                            [
                                -70.83246,
                                -54.14202
                            ],
                            [
                                -70.92604,
                                -54.13711
                            ],
                            [
                                -70.87034,
                                -54.25551
                            ],
                            [
                                -70.61039,
                                -54.28518
                            ],
                            [
                                -70.5898,
                                -54.34468
                            ],
                            [
                                -70.87316,
                                -54.33508
                            ],
                            [
                                -70.93366,
                                -54.3694
                            ],
                            [
                                -70.92799,
                                -54.43432
                            ],
                            [
                                -71.01055,
                                -54.45483
                            ],
                            [
                                -71.37156,
                                -54.37525
                            ],
                            [
                                -71.46844,
                                -54.43417
                            ],
                            [
                                -71.58824,
                                -54.40657
                            ],
                            [
                                -71.59717,
                                -54.47906
                            ],
                            [
                                -71.73952,
                                -54.39761
                            ],
                            [
                                -71.70605,
                                -54.54828
                            ],
                            [
                                -71.81431,
                                -54.53673
                            ],
                            [
                                -71.81352,
                                -54.4896
                            ],
                            [
                                -71.95261,
                                -54.44612
                            ],
                            [
                                -72.00865,
                                -54.51243
                            ],
                            [
                                -71.95309,
                                -54.62192
                            ],
                            [
                                -71.82124,
                                -54.64203
                            ],
                            [
                                -71.73115,
                                -54.61081
                            ],
                            [
                                -71.53008,
                                -54.64478
                            ],
                            [
                                -71.48651,
                                -54.686
                            ],
                            [
                                -71.39231,
                                -54.61052
                            ],
                            [
                                -71.38856,
                                -54.54679
                            ],
                            [
                                -71.25126,
                                -54.57564
                            ],
                            [
                                -71.24925,
                                -54.67967
                            ],
                            [
                                -71.16191,
                                -54.6997
                            ],
                            [
                                -71.09402,
                                -54.64257
                            ],
                            [
                                -71.03569,
                                -54.71069
                            ],
                            [
                                -70.929,
                                -54.75473
                            ],
                            [
                                -70.80831,
                                -54.7631
                            ],
                            [
                                -70.56991,
                                -54.71049
                            ],
                            [
                                -70.55486,
                                -54.63009
                            ],
                            [
                                -70.44379,
                                -54.6531
                            ],
                            [
                                -70.65207,
                                -54.75565
                            ],
                            [
                                -70.8072,
                                -54.78067
                            ],
                            [
                                -70.84871,
                                -54.82528
                            ],
                            [
                                -70.73147,
                                -54.84915
                            ],
                            [
                                -70.60689,
                                -54.8049
                            ],
                            [
                                -70.46484,
                                -54.8106
                            ],
                            [
                                -70.36771,
                                -54.84805
                            ],
                            [
                                -70.2093,
                                -54.87428
                            ],
                            [
                                -69.91465,
                                -54.84271
                            ],
                            [
                                -69.68829,
                                -54.83313
                            ],
                            [
                                -69.49045,
                                -54.88663
                            ],
                            [
                                -69.23024,
                                -54.91979
                            ],
                            [
                                -69.08306,
                                -54.96347
                            ],
                            [
                                -68.84336,
                                -54.95325
                            ],
                            [
                                -68.60748,
                                -54.89342
                            ],
                            [
                                -68.60796,
                                -53.95507
                            ],
                            [
                                -68.60828,
                                -53.31567
                            ],
                            [
                                -68.60862,
                                -52.64952
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.14469,
                                -43.35171
                            ],
                            [
                                -74.10047,
                                -43.3907
                            ],
                            [
                                -74.02294,
                                -43.35582
                            ],
                            [
                                -73.92293,
                                -43.37356
                            ],
                            [
                                -73.87688,
                                -43.42002
                            ],
                            [
                                -73.79521,
                                -43.40548
                            ],
                            [
                                -73.81503,
                                -43.31266
                            ],
                            [
                                -73.6906,
                                -43.32281
                            ],
                            [
                                -73.63292,
                                -43.12186
                            ],
                            [
                                -73.4823,
                                -43.10202
                            ],
                            [
                                -73.54416,
                                -43.05977
                            ],
                            [
                                -73.54762,
                                -42.97618
                            ],
                            [
                                -73.59913,
                                -42.96838
                            ],
                            [
                                -73.59828,
                                -42.88999
                            ],
                            [
                                -73.46618,
                                -42.88012
                            ],
                            [
                                -73.47535,
                                -42.8136
                            ],
                            [
                                -73.54604,
                                -42.75789
                            ],
                            [
                                -73.60848,
                                -42.74773
                            ],
                            [
                                -73.78433,
                                -42.61187
                            ],
                            [
                                -73.75949,
                                -42.57712
                            ],
                            [
                                -73.64512,
                                -42.54635
                            ],
                            [
                                -73.6811,
                                -42.47699
                            ],
                            [
                                -73.66343,
                                -42.38687
                            ],
                            [
                                -73.55977,
                                -42.34178
                            ],
                            [
                                -73.36023,
                                -42.33285
                            ],
                            [
                                -73.36536,
                                -42.21143
                            ],
                            [
                                -73.47706,
                                -42.1659
                            ],
                            [
                                -73.41743,
                                -42.0729
                            ],
                            [
                                -73.54318,
                                -41.93034
                            ],
                            [
                                -73.48369,
                                -41.84322
                            ],
                            [
                                -73.53841,
                                -41.80007
                            ],
                            [
                                -73.66517,
                                -41.80098
                            ],
                            [
                                -73.76708,
                                -41.86424
                            ],
                            [
                                -73.85712,
                                -41.88123
                            ],
                            [
                                -73.89968,
                                -41.80293
                            ],
                            [
                                -74.01902,
                                -41.78601
                            ],
                            [
                                -74.05315,
                                -41.83404
                            ],
                            [
                                -74.00152,
                                -41.87924
                            ],
                            [
                                -74.04907,
                                -41.96886
                            ],
                            [
                                -74.02603,
                                -42.04134
                            ],
                            [
                                -74.05375,
                                -42.14297
                            ],
                            [
                                -74.13006,
                                -42.20137
                            ],
                            [
                                -74.16454,
                                -42.25922
                            ],
                            [
                                -74.14109,
                                -42.32642
                            ],
                            [
                                -74.18685,
                                -42.44622
                            ],
                            [
                                -74.11628,
                                -42.63956
                            ],
                            [
                                -74.17242,
                                -42.90257
                            ],
                            [
                                -74.22789,
                                -43.01138
                            ],
                            [
                                -74.32902,
                                -43.09476
                            ],
                            [
                                -74.39841,
                                -43.2669
                            ],
                            [
                                -74.29503,
                                -43.32204
                            ],
                            [
                                -74.14469,
                                -43.35171
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -75.3264,
                                -49.48185
                            ],
                            [
                                -75.2395,
                                -49.56379
                            ],
                            [
                                -75.29333,
                                -49.60479
                            ],
                            [
                                -75.12503,
                                -49.85137
                            ],
                            [
                                -74.99829,
                                -49.89648
                            ],
                            [
                                -74.91851,
                                -49.75728
                            ],
                            [
                                -74.97596,
                                -49.70713
                            ],
                            [
                                -74.92728,
                                -49.62811
                            ],
                            [
                                -74.97857,
                                -49.58921
                            ],
                            [
                                -74.94141,
                                -49.53236
                            ],
                            [
                                -74.86604,
                                -49.52511
                            ],
                            [
                                -74.8906,
                                -49.65038
                            ],
                            [
                                -74.8851,
                                -49.86067
                            ],
                            [
                                -74.91032,
                                -49.93341
                            ],
                            [
                                -74.85407,
                                -50.03657
                            ],
                            [
                                -74.63333,
                                -50.05563
                            ],
                            [
                                -74.47181,
                                -49.96366
                            ],
                            [
                                -74.39955,
                                -49.85037
                            ],
                            [
                                -74.38331,
                                -49.73937
                            ],
                            [
                                -74.48175,
                                -49.51999
                            ],
                            [
                                -74.42754,
                                -49.43017
                            ],
                            [
                                -74.38969,
                                -49.30113
                            ],
                            [
                                -74.40648,
                                -49.09715
                            ],
                            [
                                -74.45592,
                                -49.01899
                            ],
                            [
                                -74.40975,
                                -48.96034
                            ],
                            [
                                -74.46763,
                                -48.87262
                            ],
                            [
                                -74.45645,
                                -48.74885
                            ],
                            [
                                -74.56832,
                                -48.73483
                            ],
                            [
                                -74.68568,
                                -48.65751
                            ],
                            [
                                -74.81581,
                                -48.68976
                            ],
                            [
                                -74.85467,
                                -48.7191
                            ],
                            [
                                -74.98991,
                                -48.76535
                            ],
                            [
                                -75.01387,
                                -48.82152
                            ],
                            [
                                -74.91698,
                                -48.97628
                            ],
                            [
                                -74.77143,
                                -49.08092
                            ],
                            [
                                -74.83413,
                                -49.17109
                            ],
                            [
                                -74.87057,
                                -49.30499
                            ],
                            [
                                -74.98421,
                                -49.22809
                            ],
                            [
                                -75.10382,
                                -49.26363
                            ],
                            [
                                -75.26875,
                                -49.22802
                            ],
                            [
                                -75.44418,
                                -49.27048
                            ],
                            [
                                -75.43203,
                                -49.38444
                            ],
                            [
                                -75.38633,
                                -49.48169
                            ],
                            [
                                -75.3264,
                                -49.48185
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -71.77567,
                                -52.70187
                            ],
                            [
                                -71.89531,
                                -52.69203
                            ],
                            [
                                -71.99388,
                                -52.65179
                            ],
                            [
                                -72.19005,
                                -52.67261
                            ],
                            [
                                -72.29977,
                                -52.75795
                            ],
                            [
                                -72.43212,
                                -52.82502
                            ],
                            [
                                -72.54124,
                                -52.84711
                            ],
                            [
                                -72.6057,
                                -52.77071
                            ],
                            [
                                -72.6842,
                                -52.72616
                            ],
                            [
                                -72.7408,
                                -52.78268
                            ],
                            [
                                -73.00117,
                                -52.86309
                            ],
                            [
                                -72.91973,
                                -52.91365
                            ],
                            [
                                -72.95819,
                                -52.93784
                            ],
                            [
                                -72.90567,
                                -53.07592
                            ],
                            [
                                -72.93728,
                                -53.11365
                            ],
                            [
                                -72.87588,
                                -53.15071
                            ],
                            [
                                -72.74356,
                                -53.13965
                            ],
                            [
                                -72.74119,
                                -53.18502
                            ],
                            [
                                -72.88953,
                                -53.2005
                            ],
                            [
                                -72.94937,
                                -53.16953
                            ],
                            [
                                -73.16053,
                                -53.18615
                            ],
                            [
                                -73.25472,
                                -53.21096
                            ],
                            [
                                -73.16863,
                                -53.26721
                            ],
                            [
                                -73.00435,
                                -53.30768
                            ],
                            [
                                -72.90057,
                                -53.38431
                            ],
                            [
                                -72.76501,
                                -53.40585
                            ],
                            [
                                -72.72557,
                                -53.45781
                            ],
                            [
                                -72.53778,
                                -53.53712
                            ],
                            [
                                -72.39062,
                                -53.52484
                            ],
                            [
                                -72.5214,
                                -53.40464
                            ],
                            [
                                -72.48135,
                                -53.30592
                            ],
                            [
                                -72.42801,
                                -53.2615
                            ],
                            [
                                -72.20844,
                                -53.19425
                            ],
                            [
                                -72.33933,
                                -53.13688
                            ],
                            [
                                -72.24701,
                                -53.05887
                            ],
                            [
                                -72.14772,
                                -53.13688
                            ],
                            [
                                -72.0242,
                                -53.13113
                            ],
                            [
                                -71.89845,
                                -53.00219
                            ],
                            [
                                -71.39254,
                                -52.80201
                            ],
                            [
                                -71.39601,
                                -52.73573
                            ],
                            [
                                -71.48081,
                                -52.64719
                            ],
                            [
                                -71.66683,
                                -52.69502
                            ],
                            [
                                -71.77567,
                                -52.70187
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -68.53811,
                                -55.33727
                            ],
                            [
                                -68.45516,
                                -55.30718
                            ],
                            [
                                -68.34067,
                                -55.30607
                            ],
                            [
                                -68.2697,
                                -55.25109
                            ],
                            [
                                -68.34723,
                                -55.18299
                            ],
                            [
                                -68.54178,
                                -55.19164
                            ],
                            [
                                -68.96791,
                                -55.11607
                            ],
                            [
                                -68.96621,
                                -55.07708
                            ],
                            [
                                -68.75322,
                                -55.14142
                            ],
                            [
                                -68.61938,
                                -55.16283
                            ],
                            [
                                -68.33435,
                                -55.07981
                            ],
                            [
                                -68.3072,
                                -55.03141
                            ],
                            [
                                -68.40492,
                                -54.95035
                            ],
                            [
                                -68.49699,
                                -54.92534
                            ],
                            [
                                -68.713,
                                -54.95041
                            ],
                            [
                                -68.80858,
                                -54.98723
                            ],
                            [
                                -68.90789,
                                -54.9825
                            ],
                            [
                                -69.02116,
                                -55.01184
                            ],
                            [
                                -69.12807,
                                -54.9927
                            ],
                            [
                                -69.2766,
                                -55.00639
                            ],
                            [
                                -69.39982,
                                -55.03892
                            ],
                            [
                                -69.91147,
                                -55.09344
                            ],
                            [
                                -69.93904,
                                -55.1823
                            ],
                            [
                                -69.85442,
                                -55.30224
                            ],
                            [
                                -69.66131,
                                -55.26032
                            ],
                            [
                                -69.72691,
                                -55.34957
                            ],
                            [
                                -69.57975,
                                -55.38425
                            ],
                            [
                                -69.37365,
                                -55.48925
                            ],
                            [
                                -69.20671,
                                -55.51684
                            ],
                            [
                                -69.19948,
                                -55.40281
                            ],
                            [
                                -69.37873,
                                -55.27595
                            ],
                            [
                                -69.2248,
                                -55.25127
                            ],
                            [
                                -68.94937,
                                -55.27852
                            ],
                            [
                                -68.84245,
                                -55.24128
                            ],
                            [
                                -68.84697,
                                -55.32459
                            ],
                            [
                                -68.92528,
                                -55.38369
                            ],
                            [
                                -68.91025,
                                -55.4643
                            ],
                            [
                                -68.74015,
                                -55.5032
                            ],
                            [
                                -68.69925,
                                -55.4707
                            ],
                            [
                                -68.51861,
                                -55.44261
                            ],
                            [
                                -68.43417,
                                -55.4932
                            ],
                            [
                                -68.34001,
                                -55.47745
                            ],
                            [
                                -68.221,
                                -55.53507
                            ],
                            [
                                -68.06477,
                                -55.71213
                            ],
                            [
                                -67.98188,
                                -55.6276
                            ],
                            [
                                -68.13849,
                                -55.47549
                            ],
                            [
                                -68.11816,
                                -55.40722
                            ],
                            [
                                -68.27035,
                                -55.39125
                            ],
                            [
                                -68.31372,
                                -55.35162
                            ],
                            [
                                -68.53811,
                                -55.33727
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -72.44119,
                                -53.95555
                            ],
                            [
                                -72.36682,
                                -53.95054
                            ],
                            [
                                -72.3104,
                                -53.8474
                            ],
                            [
                                -72.22646,
                                -53.85675
                            ],
                            [
                                -72.16289,
                                -53.77732
                            ],
                            [
                                -72.38877,
                                -53.63943
                            ],
                            [
                                -72.46505,
                                -53.57909
                            ],
                            [
                                -72.70674,
                                -53.60313
                            ],
                            [
                                -72.7256,
                                -53.51771
                            ],
                            [
                                -72.8347,
                                -53.45599
                            ],
                            [
                                -73.04508,
                                -53.37719
                            ],
                            [
                                -73.11875,
                                -53.39468
                            ],
                            [
                                -73.22818,
                                -53.50475
                            ],
                            [
                                -73.35224,
                                -53.46591
                            ],
                            [
                                -73.3522,
                                -53.54695
                            ],
                            [
                                -73.23454,
                                -53.63768
                            ],
                            [
                                -73.0039,
                                -53.64897
                            ],
                            [
                                -73.02178,
                                -53.69881
                            ],
                            [
                                -72.86462,
                                -53.74497
                            ],
                            [
                                -73.012,
                                -53.8166
                            ],
                            [
                                -72.99007,
                                -53.89191
                            ],
                            [
                                -72.80531,
                                -54.03319
                            ],
                            [
                                -72.9261,
                                -54.04266
                            ],
                            [
                                -73.04049,
                                -54.10401
                            ],
                            [
                                -72.81172,
                                -54.10057
                            ],
                            [
                                -72.71704,
                                -54.08579
                            ],
                            [
                                -72.53302,
                                -54.0939
                            ],
                            [
                                -72.34088,
                                -54.03449
                            ],
                            [
                                -72.44119,
                                -53.95555
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -67.15528,
                                -54.98796
                            ],
                            [
                                -67.21845,
                                -54.9503
                            ],
                            [
                                -67.34485,
                                -54.92719
                            ],
                            [
                                -67.52909,
                                -54.92484
                            ],
                            [
                                -67.70347,
                                -54.94015
                            ],
                            [
                                -67.97423,
                                -54.89513
                            ],
                            [
                                -68.15475,
                                -54.89894
                            ],
                            [
                                -68.35322,
                                -54.92844
                            ],
                            [
                                -68.3094,
                                -54.99847
                            ],
                            [
                                -68.17557,
                                -55.00704
                            ],
                            [
                                -68.16805,
                                -55.10133
                            ],
                            [
                                -68.11502,
                                -55.21264
                            ],
                            [
                                -68.02767,
                                -55.23669
                            ],
                            [
                                -67.86763,
                                -55.19077
                            ],
                            [
                                -67.86821,
                                -55.24306
                            ],
                            [
                                -67.60953,
                                -55.27228
                            ],
                            [
                                -67.59579,
                                -55.19765
                            ],
                            [
                                -67.50097,
                                -55.17794
                            ],
                            [
                                -67.43762,
                                -55.31338
                            ],
                            [
                                -67.2904,
                                -55.33017
                            ],
                            [
                                -67.08767,
                                -55.20792
                            ],
                            [
                                -67.04651,
                                -55.12991
                            ],
                            [
                                -67.15528,
                                -54.98796
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -73.25394,
                                -44.92903
                            ],
                            [
                                -73.21013,
                                -44.93618
                            ],
                            [
                                -73.04227,
                                -44.8789
                            ],
                            [
                                -72.95318,
                                -44.79038
                            ],
                            [
                                -72.81968,
                                -44.7329
                            ],
                            [
                                -72.80462,
                                -44.64571
                            ],
                            [
                                -72.69155,
                                -44.54237
                            ],
                            [
                                -72.78638,
                                -44.45473
                            ],
                            [
                                -72.91244,
                                -44.4169
                            ],
                            [
                                -72.9637,
                                -44.3738
                            ],
                            [
                                -73.0859,
                                -44.37875
                            ],
                            [
                                -73.24531,
                                -44.43776
                            ],
                            [
                                -73.21934,
                                -44.52302
                            ],
                            [
                                -73.26663,
                                -44.58735
                            ],
                            [
                                -73.33673,
                                -44.60939
                            ],
                            [
                                -73.40719,
                                -44.58961
                            ],
                            [
                                -73.43359,
                                -44.65654
                            ],
                            [
                                -73.38948,
                                -44.74869
                            ],
                            [
                                -73.38786,
                                -44.83482
                            ],
                            [
                                -73.25394,
                                -44.92903
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -70.37578,
                                -53.95507
                            ],
                            [
                                -70.44212,
                                -53.89974
                            ],
                            [
                                -70.44435,
                                -53.78166
                            ],
                            [
                                -70.48036,
                                -53.67459
                            ],
                            [
                                -70.54338,
                                -53.59547
                            ],
                            [
                                -70.70994,
                                -53.69873
                            ],
                            [
                                -70.67704,
                                -53.8514
                            ],
                            [
                                -70.7786,
                                -53.82505
                            ],
                            [
                                -70.90514,
                                -53.88477
                            ],
                            [
                                -70.83896,
                                -54.12203
                            ],
                            [
                                -70.69431,
                                -54.19257
                            ],
                            [
                                -70.49679,
                                -54.25002
                            ],
                            [
                                -70.25287,
                                -54.28201
                            ],
                            [
                                -70.21941,
                                -54.23674
                            ],
                            [
                                -70.56488,
                                -54.12142
                            ],
                            [
                                -70.56529,
                                -54.03635
                            ],
                            [
                                -70.66663,
                                -53.96377
                            ],
                            [
                                -70.64096,
                                -53.94062
                            ],
                            [
                                -70.4441,
                                -54.05809
                            ],
                            [
                                -70.33319,
                                -54.0118
                            ],
                            [
                                -70.37578,
                                -53.95507
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -73.53098,
                                -53.3129
                            ],
                            [
                                -73.41847,
                                -53.31963
                            ],
                            [
                                -73.25912,
                                -53.37953
                            ],
                            [
                                -73.12559,
                                -53.37986
                            ],
                            [
                                -73.09155,
                                -53.35354
                            ],
                            [
                                -73.27137,
                                -53.29041
                            ],
                            [
                                -73.43576,
                                -53.15662
                            ],
                            [
                                -73.5154,
                                -53.17918
                            ],
                            [
                                -73.56002,
                                -53.11682
                            ],
                            [
                                -73.79354,
                                -53.06633
                            ],
                            [
                                -73.87846,
                                -53.02115
                            ],
                            [
                                -74.04512,
                                -52.97037
                            ],
                            [
                                -74.23864,
                                -52.97509
                            ],
                            [
                                -74.4453,
                                -52.82449
                            ],
                            [
                                -74.61969,
                                -52.76901
                            ],
                            [
                                -74.72261,
                                -52.76571
                            ],
                            [
                                -74.56633,
                                -52.95841
                            ],
                            [
                                -74.42162,
                                -53.00193
                            ],
                            [
                                -74.39732,
                                -53.05462
                            ],
                            [
                                -74.29902,
                                -53.12872
                            ],
                            [
                                -74.12509,
                                -53.11806
                            ],
                            [
                                -74.00385,
                                -53.12732
                            ],
                            [
                                -73.87373,
                                -53.07982
                            ],
                            [
                                -73.75256,
                                -53.18577
                            ],
                            [
                                -73.68189,
                                -53.1895
                            ],
                            [
                                -73.53098,
                                -53.3129
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -71.3629,
                                -53.97075
                            ],
                            [
                                -71.57169,
                                -53.94888
                            ],
                            [
                                -71.6479,
                                -53.98386
                            ],
                            [
                                -71.60828,
                                -54.09225
                            ],
                            [
                                -71.69481,
                                -54.14606
                            ],
                            [
                                -71.66892,
                                -54.22417
                            ],
                            [
                                -71.53425,
                                -54.28096
                            ],
                            [
                                -71.45803,
                                -54.3356
                            ],
                            [
                                -71.3462,
                                -54.31825
                            ],
                            [
                                -71.15471,
                                -54.39579
                            ],
                            [
                                -70.97457,
                                -54.27691
                            ],
                            [
                                -70.96704,
                                -54.17912
                            ],
                            [
                                -71.00197,
                                -54.09328
                            ],
                            [
                                -71.07336,
                                -54.0626
                            ],
                            [
                                -71.21195,
                                -54.13484
                            ],
                            [
                                -71.27661,
                                -54.00061
                            ],
                            [
                                -71.3629,
                                -53.97075
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -75.3264,
                                -50.12956
                            ],
                            [
                                -75.19489,
                                -50.15183
                            ],
                            [
                                -75.1476,
                                -50.1861
                            ],
                            [
                                -75.20045,
                                -50.26288
                            ],
                            [
                                -75.28763,
                                -50.21982
                            ],
                            [
                                -75.25541,
                                -50.17492
                            ],
                            [
                                -75.36687,
                                -50.14477
                            ],
                            [
                                -75.47645,
                                -50.3223
                            ],
                            [
                                -75.47148,
                                -50.39851
                            ],
                            [
                                -75.3092,
                                -50.35657
                            ],
                            [
                                -75.33285,
                                -50.44145
                            ],
                            [
                                -75.1525,
                                -50.4746
                            ],
                            [
                                -75.09544,
                                -50.40434
                            ],
                            [
                                -74.96477,
                                -50.41266
                            ],
                            [
                                -74.8842,
                                -50.31105
                            ],
                            [
                                -74.936,
                                -50.25005
                            ],
                            [
                                -74.84019,
                                -50.23835
                            ],
                            [
                                -74.77721,
                                -50.14654
                            ],
                            [
                                -75.03172,
                                -50.1129
                            ],
                            [
                                -75.13599,
                                -50.02088
                            ],
                            [
                                -75.37306,
                                -50.00081
                            ],
                            [
                                -75.40774,
                                -50.03311
                            ],
                            [
                                -75.3264,
                                -50.12956
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -71.66714,
                                -53.95507
                            ],
                            [
                                -71.68439,
                                -53.9141
                            ],
                            [
                                -71.92417,
                                -53.84677
                            ],
                            [
                                -72.06388,
                                -53.94609
                            ],
                            [
                                -72.27884,
                                -53.91846
                            ],
                            [
                                -72.27209,
                                -53.98451
                            ],
                            [
                                -72.21544,
                                -54.02921
                            ],
                            [
                                -72.24768,
                                -54.07377
                            ],
                            [
                                -72.06855,
                                -54.19818
                            ],
                            [
                                -71.92752,
                                -54.24795
                            ],
                            [
                                -71.96563,
                                -54.33474
                            ],
                            [
                                -71.85837,
                                -54.3425
                            ],
                            [
                                -71.8015,
                                -54.26107
                            ],
                            [
                                -71.73184,
                                -54.2479
                            ],
                            [
                                -71.80965,
                                -54.1392
                            ],
                            [
                                -71.71387,
                                -54.14881
                            ],
                            [
                                -71.62087,
                                -54.09038
                            ],
                            [
                                -71.68582,
                                -54.03333
                            ],
                            [
                                -71.66714,
                                -53.95507
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.72973,
                                -51.05562
                            ],
                            [
                                -74.69092,
                                -51.11527
                            ],
                            [
                                -74.75381,
                                -51.16525
                            ],
                            [
                                -74.53977,
                                -51.1622
                            ],
                            [
                                -74.39286,
                                -51.22208
                            ],
                            [
                                -74.35846,
                                -51.15623
                            ],
                            [
                                -74.38831,
                                -51.08474
                            ],
                            [
                                -74.3552,
                                -51.0517
                            ],
                            [
                                -74.3903,
                                -50.91492
                            ],
                            [
                                -74.37657,
                                -50.86312
                            ],
                            [
                                -74.42869,
                                -50.77523
                            ],
                            [
                                -74.60069,
                                -50.7201
                            ],
                            [
                                -74.66382,
                                -50.73077
                            ],
                            [
                                -74.59135,
                                -50.81712
                            ],
                            [
                                -74.67078,
                                -50.90779
                            ],
                            [
                                -74.92688,
                                -50.88168
                            ],
                            [
                                -74.94636,
                                -50.99076
                            ],
                            [
                                -74.88615,
                                -51.05057
                            ],
                            [
                                -74.79326,
                                -51.07899
                            ],
                            [
                                -74.72973,
                                -51.05562
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -75.3264,
                                -48.3862
                            ],
                            [
                                -75.20684,
                                -48.40719
                            ],
                            [
                                -75.25336,
                                -48.4692
                            ],
                            [
                                -75.22109,
                                -48.55669
                            ],
                            [
                                -75.20894,
                                -48.642
                            ],
                            [
                                -75.17046,
                                -48.68598
                            ],
                            [
                                -75.01215,
                                -48.59502
                            ],
                            [
                                -75.02826,
                                -48.44875
                            ],
                            [
                                -75.09666,
                                -48.37466
                            ],
                            [
                                -75.1733,
                                -48.24946
                            ],
                            [
                                -75.22234,
                                -48.20978
                            ],
                            [
                                -75.21219,
                                -48.132
                            ],
                            [
                                -75.27606,
                                -48.03436
                            ],
                            [
                                -75.34997,
                                -48.01045
                            ],
                            [
                                -75.52449,
                                -48.08886
                            ],
                            [
                                -75.44925,
                                -48.23817
                            ],
                            [
                                -75.42578,
                                -48.41399
                            ],
                            [
                                -75.3264,
                                -48.3862
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -71.3629,
                                -54.81786
                            ],
                            [
                                -71.47675,
                                -54.86619
                            ],
                            [
                                -71.44835,
                                -54.92658
                            ],
                            [
                                -71.33286,
                                -54.94294
                            ],
                            [
                                -71.30087,
                                -54.89688
                            ],
                            [
                                -70.97751,
                                -54.99659
                            ],
                            [
                                -71.02794,
                                -55.06099
                            ],
                            [
                                -70.94552,
                                -55.09004
                            ],
                            [
                                -70.78759,
                                -55.05796
                            ],
                            [
                                -70.70774,
                                -55.12506
                            ],
                            [
                                -70.5706,
                                -55.11698
                            ],
                            [
                                -70.3655,
                                -55.13915
                            ],
                            [
                                -70.27764,
                                -55.1181
                            ],
                            [
                                -70.32216,
                                -55.05255
                            ],
                            [
                                -70.46406,
                                -55.0731
                            ],
                            [
                                -70.521,
                                -55.00585
                            ],
                            [
                                -70.50322,
                                -54.91126
                            ],
                            [
                                -70.69581,
                                -54.97656
                            ],
                            [
                                -70.94579,
                                -54.90311
                            ],
                            [
                                -70.99202,
                                -54.8611
                            ],
                            [
                                -71.08156,
                                -54.87491
                            ],
                            [
                                -71.3629,
                                -54.81786
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.7405,
                                -48.62947
                            ],
                            [
                                -74.67661,
                                -48.62831
                            ],
                            [
                                -74.5514,
                                -48.68894
                            ],
                            [
                                -74.45702,
                                -48.67224
                            ],
                            [
                                -74.44004,
                                -48.58181
                            ],
                            [
                                -74.51943,
                                -48.59497
                            ],
                            [
                                -74.56277,
                                -48.53706
                            ],
                            [
                                -74.55439,
                                -48.34801
                            ],
                            [
                                -74.62488,
                                -48.27122
                            ],
                            [
                                -74.63811,
                                -48.16317
                            ],
                            [
                                -74.75389,
                                -48.25553
                            ],
                            [
                                -74.76757,
                                -48.38301
                            ],
                            [
                                -74.88198,
                                -48.41274
                            ],
                            [
                                -74.96826,
                                -48.48108
                            ],
                            [
                                -74.94991,
                                -48.58172
                            ],
                            [
                                -74.87005,
                                -48.61671
                            ],
                            [
                                -74.7405,
                                -48.62947
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.74771,
                                -50.41472
                            ],
                            [
                                -74.71203,
                                -50.48339
                            ],
                            [
                                -74.48301,
                                -50.51421
                            ],
                            [
                                -74.44065,
                                -50.55304
                            ],
                            [
                                -74.51717,
                                -50.59478
                            ],
                            [
                                -74.5637,
                                -50.65831
                            ],
                            [
                                -74.34288,
                                -50.84192
                            ],
                            [
                                -74.24856,
                                -50.78456
                            ],
                            [
                                -74.15379,
                                -50.77682
                            ],
                            [
                                -74.23604,
                                -50.64437
                            ],
                            [
                                -74.29864,
                                -50.60689
                            ],
                            [
                                -74.35893,
                                -50.46176
                            ],
                            [
                                -74.46452,
                                -50.47178
                            ],
                            [
                                -74.54002,
                                -50.38563
                            ],
                            [
                                -74.69328,
                                -50.35187
                            ],
                            [
                                -74.74771,
                                -50.41472
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -73.8309,
                                -52.72299
                            ],
                            [
                                -73.71638,
                                -52.63999
                            ],
                            [
                                -73.72188,
                                -52.55346
                            ],
                            [
                                -73.6531,
                                -52.49145
                            ],
                            [
                                -73.72046,
                                -52.42208
                            ],
                            [
                                -73.75547,
                                -52.27445
                            ],
                            [
                                -73.89349,
                                -52.19705
                            ],
                            [
                                -73.99887,
                                -52.16635
                            ],
                            [
                                -74.10093,
                                -52.08861
                            ],
                            [
                                -74.13333,
                                -52.13953
                            ],
                            [
                                -73.98159,
                                -52.27282
                            ],
                            [
                                -73.81655,
                                -52.34433
                            ],
                            [
                                -73.87985,
                                -52.38426
                            ],
                            [
                                -73.82737,
                                -52.44451
                            ],
                            [
                                -73.86806,
                                -52.49259
                            ],
                            [
                                -73.99627,
                                -52.53402
                            ],
                            [
                                -74.06028,
                                -52.63281
                            ],
                            [
                                -73.9125,
                                -52.66615
                            ],
                            [
                                -73.93937,
                                -52.73014
                            ],
                            [
                                -73.8309,
                                -52.72299
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.14469,
                                -45.07002
                            ],
                            [
                                -74.14131,
                                -45.14528
                            ],
                            [
                                -74.00006,
                                -45.20768
                            ],
                            [
                                -73.97446,
                                -45.25421
                            ],
                            [
                                -73.80771,
                                -45.24001
                            ],
                            [
                                -73.76009,
                                -45.28273
                            ],
                            [
                                -73.6731,
                                -45.17409
                            ],
                            [
                                -73.71155,
                                -45.05741
                            ],
                            [
                                -73.83117,
                                -44.98997
                            ],
                            [
                                -73.97439,
                                -45.02281
                            ],
                            [
                                -74.16728,
                                -45.03111
                            ],
                            [
                                -74.23231,
                                -45.08374
                            ],
                            [
                                -74.20331,
                                -45.17351
                            ],
                            [
                                -74.15121,
                                -45.16057
                            ],
                            [
                                -74.14469,
                                -45.07002
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -75.3264,
                                -48.83472
                            ],
                            [
                                -75.35838,
                                -48.7989
                            ],
                            [
                                -75.49607,
                                -48.78337
                            ],
                            [
                                -75.6271,
                                -48.85852
                            ],
                            [
                                -75.60451,
                                -48.93348
                            ],
                            [
                                -75.44916,
                                -49.03611
                            ],
                            [
                                -75.3264,
                                -48.93286
                            ],
                            [
                                -75.27152,
                                -48.9414
                            ],
                            [
                                -75.25516,
                                -49.02116
                            ],
                            [
                                -75.18937,
                                -49.04602
                            ],
                            [
                                -75.01744,
                                -48.87187
                            ],
                            [
                                -75.0547,
                                -48.83245
                            ],
                            [
                                -75.19276,
                                -48.77472
                            ],
                            [
                                -75.23366,
                                -48.82357
                            ],
                            [
                                -75.3264,
                                -48.83472
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -73.92396,
                                -51.96181
                            ],
                            [
                                -74.209,
                                -51.81995
                            ],
                            [
                                -74.2921,
                                -51.81969
                            ],
                            [
                                -74.36339,
                                -51.74107
                            ],
                            [
                                -74.46285,
                                -51.75475
                            ],
                            [
                                -74.36917,
                                -51.8881
                            ],
                            [
                                -74.07945,
                                -51.99549
                            ],
                            [
                                -74.0879,
                                -52.02756
                            ],
                            [
                                -73.88189,
                                -52.10242
                            ],
                            [
                                -73.8309,
                                -52.14833
                            ],
                            [
                                -73.68356,
                                -52.21728
                            ],
                            [
                                -73.75402,
                                -52.06964
                            ],
                            [
                                -73.92396,
                                -51.96181
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -75.04718,
                                -48.31987
                            ],
                            [
                                -74.96201,
                                -48.44808
                            ],
                            [
                                -74.83904,
                                -48.36477
                            ],
                            [
                                -74.77944,
                                -48.3658
                            ],
                            [
                                -74.78072,
                                -48.27168
                            ],
                            [
                                -74.73197,
                                -48.2014
                            ],
                            [
                                -74.84114,
                                -48.16298
                            ],
                            [
                                -74.97923,
                                -48.08472
                            ],
                            [
                                -75.08532,
                                -48.09998
                            ],
                            [
                                -75.17056,
                                -48.0675
                            ],
                            [
                                -75.14072,
                                -48.21089
                            ],
                            [
                                -75.04718,
                                -48.31987
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -69.94316,
                                -54.96867
                            ],
                            [
                                -69.87718,
                                -55.07076
                            ],
                            [
                                -69.49737,
                                -55.03581
                            ],
                            [
                                -69.27524,
                                -54.9909
                            ],
                            [
                                -69.21652,
                                -54.94036
                            ],
                            [
                                -69.46262,
                                -54.92094
                            ],
                            [
                                -69.59399,
                                -54.88451
                            ],
                            [
                                -69.85717,
                                -54.89148
                            ],
                            [
                                -69.93696,
                                -54.92043
                            ],
                            [
                                -69.94316,
                                -54.96867
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -75.3264,
                                -48.47707
                            ],
                            [
                                -75.35432,
                                -48.41063
                            ],
                            [
                                -75.47243,
                                -48.44922
                            ],
                            [
                                -75.59169,
                                -48.4533
                            ],
                            [
                                -75.57436,
                                -48.59257
                            ],
                            [
                                -75.57661,
                                -48.75324
                            ],
                            [
                                -75.52234,
                                -48.7702
                            ],
                            [
                                -75.35873,
                                -48.71178
                            ],
                            [
                                -75.25095,
                                -48.61734
                            ],
                            [
                                -75.22736,
                                -48.55879
                            ],
                            [
                                -75.2712,
                                -48.47153
                            ],
                            [
                                -75.3264,
                                -48.47707
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -75.03731,
                                -48.06407
                            ],
                            [
                                -74.99691,
                                -48.06411
                            ],
                            [
                                -74.83349,
                                -48.1531
                            ],
                            [
                                -74.7621,
                                -48.08781
                            ],
                            [
                                -74.7647,
                                -47.81709
                            ],
                            [
                                -74.83957,
                                -47.79633
                            ],
                            [
                                -74.92691,
                                -47.87696
                            ],
                            [
                                -75.19518,
                                -47.96563
                            ],
                            [
                                -75.19574,
                                -48.05085
                            ],
                            [
                                -75.03731,
                                -48.06407
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -75.62189,
                                -49.789
                            ],
                            [
                                -75.54493,
                                -49.80901
                            ],
                            [
                                -75.38248,
                                -49.74504
                            ],
                            [
                                -75.37238,
                                -49.8296
                            ],
                            [
                                -75.27487,
                                -49.88612
                            ],
                            [
                                -75.15896,
                                -49.83762
                            ],
                            [
                                -75.32804,
                                -49.59242
                            ],
                            [
                                -75.54938,
                                -49.59502
                            ],
                            [
                                -75.60222,
                                -49.63774
                            ],
                            [
                                -75.57563,
                                -49.73788
                            ],
                            [
                                -75.62189,
                                -49.789
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.43527,
                                -47.90351
                            ],
                            [
                                -74.32299,
                                -47.92184
                            ],
                            [
                                -74.26852,
                                -47.96285
                            ],
                            [
                                -74.08579,
                                -47.92745
                            ],
                            [
                                -73.96028,
                                -47.94226
                            ],
                            [
                                -73.77177,
                                -47.91937
                            ],
                            [
                                -73.74925,
                                -47.86166
                            ],
                            [
                                -73.85569,
                                -47.86718
                            ],
                            [
                                -74.06034,
                                -47.7766
                            ],
                            [
                                -74.16483,
                                -47.79098
                            ],
                            [
                                -74.24116,
                                -47.78
                            ],
                            [
                                -74.34932,
                                -47.81367
                            ],
                            [
                                -74.43527,
                                -47.90351
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.14469,
                                -44.73037
                            ],
                            [
                                -74.34934,
                                -44.71327
                            ],
                            [
                                -74.3359,
                                -44.77614
                            ],
                            [
                                -74.23643,
                                -44.80535
                            ],
                            [
                                -74.07239,
                                -44.76345
                            ],
                            [
                                -73.92953,
                                -44.70008
                            ],
                            [
                                -73.87097,
                                -44.64761
                            ],
                            [
                                -73.95993,
                                -44.60131
                            ],
                            [
                                -74.11807,
                                -44.59109
                            ],
                            [
                                -74.40075,
                                -44.61659
                            ],
                            [
                                -74.39841,
                                -44.6935
                            ],
                            [
                                -74.27483,
                                -44.69628
                            ],
                            [
                                -74.14469,
                                -44.73037
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.46695,
                                -45.53002
                            ],
                            [
                                -74.41089,
                                -45.44382
                            ],
                            [
                                -74.50766,
                                -45.45562
                            ],
                            [
                                -74.541,
                                -45.54183
                            ],
                            [
                                -74.49992,
                                -45.5739
                            ],
                            [
                                -74.43121,
                                -45.69195
                            ],
                            [
                                -74.48297,
                                -45.73213
                            ],
                            [
                                -74.45071,
                                -45.77855
                            ],
                            [
                                -74.35959,
                                -45.77088
                            ],
                            [
                                -74.17902,
                                -45.62464
                            ],
                            [
                                -74.21891,
                                -45.54341
                            ],
                            [
                                -74.31783,
                                -45.46134
                            ],
                            [
                                -74.39903,
                                -45.45232
                            ],
                            [
                                -74.46695,
                                -45.53002
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.79875,
                                -51.44213
                            ],
                            [
                                -74.73704,
                                -51.40244
                            ],
                            [
                                -74.68847,
                                -51.31376
                            ],
                            [
                                -74.60977,
                                -51.40441
                            ],
                            [
                                -74.52437,
                                -51.35778
                            ],
                            [
                                -74.50226,
                                -51.27766
                            ],
                            [
                                -74.55199,
                                -51.21448
                            ],
                            [
                                -74.70564,
                                -51.19194
                            ],
                            [
                                -74.79406,
                                -51.21267
                            ],
                            [
                                -74.97825,
                                -51.34117
                            ],
                            [
                                -74.93769,
                                -51.40486
                            ],
                            [
                                -75.02842,
                                -51.43076
                            ],
                            [
                                -74.97743,
                                -51.48014
                            ],
                            [
                                -74.79875,
                                -51.44213
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -75.3264,
                                -50.78261
                            ],
                            [
                                -75.27006,
                                -50.79443
                            ],
                            [
                                -75.23566,
                                -50.62502
                            ],
                            [
                                -75.08025,
                                -50.52534
                            ],
                            [
                                -75.39915,
                                -50.46475
                            ],
                            [
                                -75.47038,
                                -50.50698
                            ],
                            [
                                -75.42163,
                                -50.56356
                            ],
                            [
                                -75.44734,
                                -50.73454
                            ],
                            [
                                -75.3264,
                                -50.78261
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.12081,
                                -52.17409
                            ],
                            [
                                -74.25649,
                                -52.09836
                            ],
                            [
                                -74.3974,
                                -52.13179
                            ],
                            [
                                -74.30568,
                                -52.22265
                            ],
                            [
                                -74.22784,
                                -52.1964
                            ],
                            [
                                -74.16054,
                                -52.30683
                            ],
                            [
                                -74.22211,
                                -52.33452
                            ],
                            [
                                -74.19269,
                                -52.39901
                            ],
                            [
                                -74.09409,
                                -52.41742
                            ],
                            [
                                -73.95726,
                                -52.37667
                            ],
                            [
                                -73.95652,
                                -52.31234
                            ],
                            [
                                -74.12081,
                                -52.17409
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.81173,
                                -51.96181
                            ],
                            [
                                -74.75473,
                                -51.82878
                            ],
                            [
                                -74.77028,
                                -51.65799
                            ],
                            [
                                -74.85394,
                                -51.62905
                            ],
                            [
                                -74.91496,
                                -51.67454
                            ],
                            [
                                -74.84221,
                                -51.75913
                            ],
                            [
                                -74.93956,
                                -51.81038
                            ],
                            [
                                -75.05787,
                                -52.02312
                            ],
                            [
                                -74.94402,
                                -52.1288
                            ],
                            [
                                -74.87241,
                                -52.08928
                            ],
                            [
                                -74.81173,
                                -51.96181
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -73.8309,
                                -51.97181
                            ],
                            [
                                -73.74576,
                                -52.022
                            ],
                            [
                                -73.69289,
                                -51.98306
                            ],
                            [
                                -73.78785,
                                -51.87684
                            ],
                            [
                                -73.90008,
                                -51.79489
                            ],
                            [
                                -74.01822,
                                -51.63857
                            ],
                            [
                                -74.04062,
                                -51.53873
                            ],
                            [
                                -74.14417,
                                -51.60445
                            ],
                            [
                                -74.12711,
                                -51.66399
                            ],
                            [
                                -74.22796,
                                -51.67787
                            ],
                            [
                                -74.22522,
                                -51.73541
                            ],
                            [
                                -74.14761,
                                -51.75259
                            ],
                            [
                                -73.93837,
                                -51.84487
                            ],
                            [
                                -73.95034,
                                -51.89139
                            ],
                            [
                                -73.81065,
                                -51.92723
                            ],
                            [
                                -73.8309,
                                -51.97181
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.14469,
                                -45.28229
                            ],
                            [
                                -74.03184,
                                -45.41724
                            ],
                            [
                                -73.90026,
                                -45.45147
                            ],
                            [
                                -73.78785,
                                -45.41255
                            ],
                            [
                                -73.75364,
                                -45.33194
                            ],
                            [
                                -73.80815,
                                -45.25123
                            ],
                            [
                                -73.97872,
                                -45.26269
                            ],
                            [
                                -74.02055,
                                -45.20974
                            ],
                            [
                                -74.12299,
                                -45.21948
                            ],
                            [
                                -74.14469,
                                -45.28229
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -75.2032,
                                -49.12592
                            ],
                            [
                                -75.00493,
                                -49.17723
                            ],
                            [
                                -74.95686,
                                -49.23725
                            ],
                            [
                                -74.8701,
                                -49.28284
                            ],
                            [
                                -74.82393,
                                -49.08643
                            ],
                            [
                                -75.06516,
                                -48.98915
                            ],
                            [
                                -75.17715,
                                -49.07969
                            ],
                            [
                                -75.2032,
                                -49.12592
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -73.38499,
                                -53.63628
                            ],
                            [
                                -73.2541,
                                -53.66108
                            ],
                            [
                                -73.4242,
                                -53.48338
                            ],
                            [
                                -73.40188,
                                -53.40256
                            ],
                            [
                                -73.58534,
                                -53.38589
                            ],
                            [
                                -73.57225,
                                -53.45984
                            ],
                            [
                                -73.69974,
                                -53.49118
                            ],
                            [
                                -73.65317,
                                -53.55488
                            ],
                            [
                                -73.58117,
                                -53.55508
                            ],
                            [
                                -73.47428,
                                -53.64294
                            ],
                            [
                                -73.38499,
                                -53.63628
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -73.56953,
                                -45.53002
                            ],
                            [
                                -73.54911,
                                -45.46808
                            ],
                            [
                                -73.67239,
                                -45.43422
                            ],
                            [
                                -73.75069,
                                -45.51721
                            ],
                            [
                                -73.79333,
                                -45.60464
                            ],
                            [
                                -73.76908,
                                -45.67041
                            ],
                            [
                                -73.62043,
                                -45.7653
                            ],
                            [
                                -73.55731,
                                -45.63522
                            ],
                            [
                                -73.56953,
                                -45.53002
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -75.3264,
                                -51.60457
                            ],
                            [
                                -75.21696,
                                -51.62438
                            ],
                            [
                                -75.1663,
                                -51.59114
                            ],
                            [
                                -75.05397,
                                -51.38044
                            ],
                            [
                                -75.08985,
                                -51.30536
                            ],
                            [
                                -75.21609,
                                -51.3347
                            ],
                            [
                                -75.19051,
                                -51.36885
                            ],
                            [
                                -75.22857,
                                -51.44536
                            ],
                            [
                                -75.19492,
                                -51.49145
                            ],
                            [
                                -75.30052,
                                -51.53017
                            ],
                            [
                                -75.3264,
                                -51.60457
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -75.3264,
                                -49.01662
                            ],
                            [
                                -75.57343,
                                -49.11778
                            ],
                            [
                                -75.62654,
                                -49.18885
                            ],
                            [
                                -75.47363,
                                -49.24163
                            ],
                            [
                                -75.36959,
                                -49.17511
                            ],
                            [
                                -75.32989,
                                -49.11446
                            ],
                            [
                                -75.24279,
                                -49.07414
                            ],
                            [
                                -75.3264,
                                -49.01662
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.14469,
                                -45.00953
                            ],
                            [
                                -74.05348,
                                -45.00822
                            ],
                            [
                                -73.89232,
                                -44.96353
                            ],
                            [
                                -73.95451,
                                -44.89534
                            ],
                            [
                                -74.17417,
                                -44.86686
                            ],
                            [
                                -74.38345,
                                -45.00172
                            ],
                            [
                                -74.27739,
                                -45.0361
                            ],
                            [
                                -74.14469,
                                -45.00953
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.43963,
                                -44.53266
                            ],
                            [
                                -74.30692,
                                -44.57478
                            ],
                            [
                                -74.13432,
                                -44.52781
                            ],
                            [
                                -74.24735,
                                -44.40517
                            ],
                            [
                                -74.3026,
                                -44.39013
                            ],
                            [
                                -74.38288,
                                -44.43799
                            ],
                            [
                                -74.49282,
                                -44.42088
                            ],
                            [
                                -74.55535,
                                -44.47768
                            ],
                            [
                                -74.43963,
                                -44.53266
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.73443,
                                -52.08458
                            ],
                            [
                                -74.64373,
                                -51.92608
                            ],
                            [
                                -74.62883,
                                -51.79199
                            ],
                            [
                                -74.72198,
                                -51.79213
                            ],
                            [
                                -74.78051,
                                -51.90963
                            ],
                            [
                                -74.82565,
                                -52.06008
                            ],
                            [
                                -74.88548,
                                -52.14942
                            ],
                            [
                                -74.82157,
                                -52.15922
                            ],
                            [
                                -74.73443,
                                -52.08458
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -73.77338,
                                -44.34394
                            ],
                            [
                                -73.7824,
                                -44.26931
                            ],
                            [
                                -73.89111,
                                -44.30262
                            ],
                            [
                                -73.80451,
                                -44.18186
                            ],
                            [
                                -73.84244,
                                -44.12708
                            ],
                            [
                                -73.92408,
                                -44.09775
                            ],
                            [
                                -74.0028,
                                -44.15679
                            ],
                            [
                                -74.09363,
                                -44.18569
                            ],
                            [
                                -74.05923,
                                -44.29345
                            ],
                            [
                                -74.00958,
                                -44.33516
                            ],
                            [
                                -73.94049,
                                -44.32693
                            ],
                            [
                                -73.77338,
                                -44.34394
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.72973,
                                -50.818
                            ],
                            [
                                -74.72055,
                                -50.69477
                            ],
                            [
                                -74.82211,
                                -50.65643
                            ],
                            [
                                -74.9148,
                                -50.6866
                            ],
                            [
                                -74.94507,
                                -50.74701
                            ],
                            [
                                -74.86952,
                                -50.86596
                            ],
                            [
                                -74.69222,
                                -50.90204
                            ],
                            [
                                -74.64006,
                                -50.82073
                            ],
                            [
                                -74.72973,
                                -50.818
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -73.83696,
                                -45.98247
                            ],
                            [
                                -73.69658,
                                -46.03376
                            ],
                            [
                                -73.65735,
                                -46.01931
                            ],
                            [
                                -73.67855,
                                -45.82806
                            ],
                            [
                                -73.83215,
                                -45.76571
                            ],
                            [
                                -73.88314,
                                -45.80979
                            ],
                            [
                                -73.86554,
                                -45.85607
                            ],
                            [
                                -73.92054,
                                -45.94563
                            ],
                            [
                                -73.83696,
                                -45.98247
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.13683,
                                -48.4257
                            ],
                            [
                                -74.21219,
                                -48.39007
                            ],
                            [
                                -74.23635,
                                -48.29943
                            ],
                            [
                                -74.30965,
                                -48.27994
                            ],
                            [
                                -74.36472,
                                -48.33177
                            ],
                            [
                                -74.33479,
                                -48.40007
                            ],
                            [
                                -74.23126,
                                -48.46592
                            ],
                            [
                                -74.14084,
                                -48.44279
                            ],
                            [
                                -73.99403,
                                -48.49551
                            ],
                            [
                                -73.99397,
                                -48.4214
                            ],
                            [
                                -74.0516,
                                -48.39902
                            ],
                            [
                                -74.1173,
                                -48.353
                            ],
                            [
                                -74.13683,
                                -48.4257
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -73.85163,
                                -44.62571
                            ],
                            [
                                -73.74485,
                                -44.74881
                            ],
                            [
                                -73.56719,
                                -44.70718
                            ],
                            [
                                -73.60942,
                                -44.65248
                            ],
                            [
                                -73.58344,
                                -44.60923
                            ],
                            [
                                -73.67978,
                                -44.53217
                            ],
                            [
                                -73.8778,
                                -44.59532
                            ],
                            [
                                -73.85163,
                                -44.62571
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.09522,
                                -45.59969
                            ],
                            [
                                -74.0468,
                                -45.7066
                            ],
                            [
                                -73.97493,
                                -45.7342
                            ],
                            [
                                -73.88063,
                                -45.70748
                            ],
                            [
                                -73.86075,
                                -45.60889
                            ],
                            [
                                -73.97962,
                                -45.53722
                            ],
                            [
                                -74.09522,
                                -45.59969
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -72.44119,
                                -54.27743
                            ],
                            [
                                -72.32741,
                                -54.26292
                            ],
                            [
                                -72.2676,
                                -54.19944
                            ],
                            [
                                -72.26991,
                                -54.08826
                            ],
                            [
                                -72.32828,
                                -54.05891
                            ],
                            [
                                -72.42286,
                                -54.12937
                            ],
                            [
                                -72.39816,
                                -54.17969
                            ],
                            [
                                -72.49738,
                                -54.19679
                            ],
                            [
                                -72.51067,
                                -54.2584
                            ],
                            [
                                -72.44119,
                                -54.27743
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.40078,
                                -48.32164
                            ],
                            [
                                -74.30841,
                                -48.26398
                            ],
                            [
                                -74.43682,
                                -48.15118
                            ],
                            [
                                -74.54242,
                                -48.12963
                            ],
                            [
                                -74.54719,
                                -48.25345
                            ],
                            [
                                -74.46002,
                                -48.34338
                            ],
                            [
                                -74.40078,
                                -48.32164
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -67.57874,
                                -55.72742
                            ],
                            [
                                -67.34951,
                                -55.79285
                            ],
                            [
                                -67.25752,
                                -55.72029
                            ],
                            [
                                -67.55055,
                                -55.64722
                            ],
                            [
                                -67.57874,
                                -55.72742
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -73.65905,
                                -46.11069
                            ],
                            [
                                -73.68,
                                -46.05804
                            ],
                            [
                                -73.9012,
                                -46.00555
                            ],
                            [
                                -73.91369,
                                -46.08953
                            ],
                            [
                                -73.86492,
                                -46.0992
                            ],
                            [
                                -73.78746,
                                -46.18701
                            ],
                            [
                                -73.72925,
                                -46.20604
                            ],
                            [
                                -73.65905,
                                -46.11069
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -73.88674,
                                -45.53002
                            ],
                            [
                                -73.83266,
                                -45.56513
                            ],
                            [
                                -73.77813,
                                -45.46582
                            ],
                            [
                                -73.91822,
                                -45.46276
                            ],
                            [
                                -74.02965,
                                -45.42738
                            ],
                            [
                                -74.09484,
                                -45.49399
                            ],
                            [
                                -74.08993,
                                -45.5588
                            ],
                            [
                                -73.99656,
                                -45.52264
                            ],
                            [
                                -73.88674,
                                -45.53002
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.14469,
                                -43.87477
                            ],
                            [
                                -74.02077,
                                -43.90365
                            ],
                            [
                                -73.93738,
                                -43.95033
                            ],
                            [
                                -73.93819,
                                -43.85683
                            ],
                            [
                                -74.06394,
                                -43.80758
                            ],
                            [
                                -74.14469,
                                -43.87477
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.43746,
                                -49.4953
                            ],
                            [
                                -74.40014,
                                -49.53564
                            ],
                            [
                                -74.42268,
                                -49.59426
                            ],
                            [
                                -74.37488,
                                -49.6338
                            ],
                            [
                                -74.23356,
                                -49.55053
                            ],
                            [
                                -74.31159,
                                -49.45653
                            ],
                            [
                                -74.40334,
                                -49.42204
                            ],
                            [
                                -74.43746,
                                -49.4953
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -75.03731,
                                -48.81011
                            ],
                            [
                                -74.99149,
                                -48.66931
                            ],
                            [
                                -75.0273,
                                -48.61103
                            ],
                            [
                                -75.21091,
                                -48.76267
                            ],
                            [
                                -75.03731,
                                -48.81011
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.28379,
                                -50.93709
                            ],
                            [
                                -74.34177,
                                -50.91812
                            ],
                            [
                                -74.24864,
                                -51.25136
                            ],
                            [
                                -74.16803,
                                -51.20339
                            ],
                            [
                                -74.28379,
                                -50.93709
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -75.32655,
                                -47.72638
                            ],
                            [
                                -75.33278,
                                -47.75449
                            ],
                            [
                                -75.16132,
                                -47.78599
                            ],
                            [
                                -75.12691,
                                -47.83975
                            ],
                            [
                                -75.01727,
                                -47.78953
                            ],
                            [
                                -75.05698,
                                -47.71028
                            ],
                            [
                                -75.10739,
                                -47.68402
                            ],
                            [
                                -75.18557,
                                -47.73818
                            ],
                            [
                                -75.32655,
                                -47.72638
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.39572,
                                -45.19738
                            ],
                            [
                                -74.37654,
                                -45.27221
                            ],
                            [
                                -74.23561,
                                -45.34692
                            ],
                            [
                                -74.19151,
                                -45.33613
                            ],
                            [
                                -74.18348,
                                -45.24221
                            ],
                            [
                                -74.33747,
                                -45.16446
                            ],
                            [
                                -74.39572,
                                -45.19738
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -72.95819,
                                -51.90224
                            ],
                            [
                                -73.08427,
                                -51.9504
                            ],
                            [
                                -73.13018,
                                -52.02881
                            ],
                            [
                                -73.10872,
                                -52.08532
                            ],
                            [
                                -73.00047,
                                -52.05402
                            ],
                            [
                                -72.95819,
                                -51.90224
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.43963,
                                -45.38463
                            ],
                            [
                                -74.34186,
                                -45.42475
                            ],
                            [
                                -74.26415,
                                -45.40864
                            ],
                            [
                                -74.31448,
                                -45.31916
                            ],
                            [
                                -74.4046,
                                -45.28245
                            ],
                            [
                                -74.51696,
                                -45.31247
                            ],
                            [
                                -74.43963,
                                -45.38463
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.74341,
                                -43.55125
                            ],
                            [
                                -74.81103,
                                -43.62747
                            ],
                            [
                                -74.76753,
                                -43.67686
                            ],
                            [
                                -74.68949,
                                -43.64336
                            ],
                            [
                                -74.57615,
                                -43.63351
                            ],
                            [
                                -74.64977,
                                -43.55592
                            ],
                            [
                                -74.74341,
                                -43.55125
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.10575,
                                -51.2889
                            ],
                            [
                                -74.03135,
                                -51.38557
                            ],
                            [
                                -73.90879,
                                -51.3216
                            ],
                            [
                                -73.95518,
                                -51.23392
                            ],
                            [
                                -74.09649,
                                -51.23301
                            ],
                            [
                                -74.10575,
                                -51.2889
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -67.06094,
                                -55.27658
                            ],
                            [
                                -67.0135,
                                -55.34625
                            ],
                            [
                                -66.8612,
                                -55.33173
                            ],
                            [
                                -66.86589,
                                -55.2274
                            ],
                            [
                                -66.99591,
                                -55.23226
                            ],
                            [
                                -67.06094,
                                -55.27658
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -75.03118,
                                -51.72787
                            ],
                            [
                                -75.06665,
                                -51.74953
                            ],
                            [
                                -75.06668,
                                -51.85321
                            ],
                            [
                                -75.0003,
                                -51.8976
                            ],
                            [
                                -74.95556,
                                -51.79939
                            ],
                            [
                                -75.03118,
                                -51.72787
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.6819,
                                -45.71752
                            ],
                            [
                                -74.65457,
                                -45.75747
                            ],
                            [
                                -74.57236,
                                -45.75317
                            ],
                            [
                                -74.50946,
                                -45.58406
                            ],
                            [
                                -74.58708,
                                -45.59452
                            ],
                            [
                                -74.66253,
                                -45.66394
                            ],
                            [
                                -74.6819,
                                -45.71752
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.73443,
                                -52.26079
                            ],
                            [
                                -74.87121,
                                -52.1991
                            ],
                            [
                                -74.90176,
                                -52.22816
                            ],
                            [
                                -74.76271,
                                -52.30582
                            ],
                            [
                                -74.61952,
                                -52.30471
                            ],
                            [
                                -74.6098,
                                -52.20957
                            ],
                            [
                                -74.73443,
                                -52.26079
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -70.6484,
                                -54.90745
                            ],
                            [
                                -70.57954,
                                -54.91455
                            ],
                            [
                                -70.38255,
                                -54.88468
                            ],
                            [
                                -70.40896,
                                -54.85605
                            ],
                            [
                                -70.593,
                                -54.82408
                            ],
                            [
                                -70.6484,
                                -54.90745
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.57909,
                                -52.06944
                            ],
                            [
                                -74.49888,
                                -52.03262
                            ],
                            [
                                -74.4443,
                                -51.9681
                            ],
                            [
                                -74.53302,
                                -51.9342
                            ],
                            [
                                -74.69006,
                                -52.04807
                            ],
                            [
                                -74.57909,
                                -52.06944
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -67.61781,
                                -55.91194
                            ],
                            [
                                -67.57546,
                                -55.83635
                            ],
                            [
                                -67.82522,
                                -55.81667
                            ],
                            [
                                -67.88355,
                                -55.88176
                            ],
                            [
                                -67.62863,
                                -55.84788
                            ],
                            [
                                -67.61781,
                                -55.91194
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -73.75267,
                                -44.9448
                            ],
                            [
                                -73.72694,
                                -44.91319
                            ],
                            [
                                -73.82796,
                                -44.77471
                            ],
                            [
                                -73.91418,
                                -44.86471
                            ],
                            [
                                -73.8233,
                                -44.95914
                            ],
                            [
                                -73.75267,
                                -44.9448
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.09849,
                                -45.77761
                            ],
                            [
                                -74.01181,
                                -45.84744
                            ],
                            [
                                -73.9324,
                                -45.86399
                            ],
                            [
                                -73.92157,
                                -45.76873
                            ],
                            [
                                -74.03101,
                                -45.73972
                            ],
                            [
                                -74.09849,
                                -45.77761
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.12081,
                                -51.43565
                            ],
                            [
                                -74.14536,
                                -51.28643
                            ],
                            [
                                -74.2472,
                                -51.28934
                            ],
                            [
                                -74.22513,
                                -51.43193
                            ],
                            [
                                -74.12081,
                                -51.43565
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -73.48115,
                                -54.07503
                            ],
                            [
                                -73.37778,
                                -54.07197
                            ],
                            [
                                -73.21255,
                                -54.13152
                            ],
                            [
                                -73.18718,
                                -54.06542
                            ],
                            [
                                -73.38735,
                                -53.99711
                            ],
                            [
                                -73.48115,
                                -54.07503
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -75.20246,
                                -44.8129
                            ],
                            [
                                -75.15305,
                                -44.86519
                            ],
                            [
                                -75.15683,
                                -44.92694
                            ],
                            [
                                -75.03067,
                                -44.90173
                            ],
                            [
                                -75.02201,
                                -44.84739
                            ],
                            [
                                -75.10935,
                                -44.76818
                            ],
                            [
                                -75.20246,
                                -44.8129
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.43527,
                                -48.44584
                            ],
                            [
                                -74.35629,
                                -48.53716
                            ],
                            [
                                -74.23895,
                                -48.47016
                            ],
                            [
                                -74.46517,
                                -48.37406
                            ],
                            [
                                -74.43527,
                                -48.44584
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -66.65641,
                                -55.2345
                            ],
                            [
                                -66.64198,
                                -55.28697
                            ],
                            [
                                -66.51846,
                                -55.27479
                            ],
                            [
                                -66.43232,
                                -55.19363
                            ],
                            [
                                -66.53026,
                                -55.17381
                            ],
                            [
                                -66.65641,
                                -55.2345
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.43963,
                                -44.83636
                            ],
                            [
                                -74.38223,
                                -44.85944
                            ],
                            [
                                -74.3011,
                                -44.84098
                            ],
                            [
                                -74.43051,
                                -44.71367
                            ],
                            [
                                -74.53294,
                                -44.74248
                            ],
                            [
                                -74.43963,
                                -44.83636
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.14469,
                                -44.44683
                            ],
                            [
                                -74.09007,
                                -44.5443
                            ],
                            [
                                -74.03898,
                                -44.56099
                            ],
                            [
                                -73.93065,
                                -44.54331
                            ],
                            [
                                -73.97063,
                                -44.45089
                            ],
                            [
                                -74.14469,
                                -44.44683
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -73.26321,
                                -43.97026
                            ],
                            [
                                -73.19409,
                                -44.03522
                            ],
                            [
                                -73.1432,
                                -44.0289
                            ],
                            [
                                -73.11587,
                                -43.90356
                            ],
                            [
                                -73.24002,
                                -43.91594
                            ],
                            [
                                -73.26321,
                                -43.97026
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -73.82682,
                                -51.36959
                            ],
                            [
                                -73.73258,
                                -51.37713
                            ],
                            [
                                -73.75131,
                                -51.27217
                            ],
                            [
                                -73.83402,
                                -51.25396
                            ],
                            [
                                -73.89801,
                                -51.29437
                            ],
                            [
                                -73.82682,
                                -51.36959
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -109.44987,
                                -27.17797
                            ],
                            [
                                -109.35129,
                                -27.16501
                            ],
                            [
                                -109.23322,
                                -27.11916
                            ],
                            [
                                -109.38437,
                                -27.05622
                            ],
                            [
                                -109.44987,
                                -27.17797
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -73.73417,
                                -43.99066
                            ],
                            [
                                -73.59369,
                                -44.11654
                            ],
                            [
                                -73.60097,
                                -44.00225
                            ],
                            [
                                -73.69182,
                                -43.93647
                            ],
                            [
                                -73.73417,
                                -43.99066
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -70.51003,
                                -54.06436
                            ],
                            [
                                -70.45436,
                                -54.12351
                            ],
                            [
                                -70.36592,
                                -54.15654
                            ],
                            [
                                -70.2808,
                                -54.08133
                            ],
                            [
                                -70.51003,
                                -54.06436
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -73.24123,
                                -53.83397
                            ],
                            [
                                -73.1881,
                                -53.90358
                            ],
                            [
                                -73.07315,
                                -53.89311
                            ],
                            [
                                -73.07685,
                                -53.83009
                            ],
                            [
                                -73.24123,
                                -53.83397
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.45424,
                                -47.09071
                            ],
                            [
                                -74.40134,
                                -47.15729
                            ],
                            [
                                -74.28263,
                                -47.09178
                            ],
                            [
                                -74.29557,
                                -47.02819
                            ],
                            [
                                -74.42717,
                                -47.06066
                            ],
                            [
                                -74.45424,
                                -47.09071
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.98759,
                                -48.73637
                            ],
                            [
                                -74.86606,
                                -48.71543
                            ],
                            [
                                -74.76971,
                                -48.6461
                            ],
                            [
                                -74.96415,
                                -48.62198
                            ],
                            [
                                -74.98759,
                                -48.73637
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -73.55267,
                                -42.47169
                            ],
                            [
                                -73.51604,
                                -42.40291
                            ],
                            [
                                -73.65367,
                                -42.3897
                            ],
                            [
                                -73.55267,
                                -42.47169
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.43963,
                                -44.68974
                            ],
                            [
                                -74.46056,
                                -44.6319
                            ],
                            [
                                -74.61107,
                                -44.60926
                            ],
                            [
                                -74.67521,
                                -44.67086
                            ],
                            [
                                -74.61164,
                                -44.68969
                            ],
                            [
                                -74.43963,
                                -44.68974
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.13683,
                                -45.79928
                            ],
                            [
                                -74.12539,
                                -45.76161
                            ],
                            [
                                -74.27115,
                                -45.7091
                            ],
                            [
                                -74.32289,
                                -45.76238
                            ],
                            [
                                -74.27123,
                                -45.8203
                            ],
                            [
                                -74.13683,
                                -45.79928
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.41834,
                                -45.09774
                            ],
                            [
                                -74.37098,
                                -45.14325
                            ],
                            [
                                -74.25547,
                                -45.16975
                            ],
                            [
                                -74.24989,
                                -45.1186
                            ],
                            [
                                -74.30028,
                                -45.06327
                            ],
                            [
                                -74.37078,
                                -45.04318
                            ],
                            [
                                -74.41834,
                                -45.09774
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -73.99605,
                                -44.34394
                            ],
                            [
                                -74.05345,
                                -44.38846
                            ],
                            [
                                -73.90349,
                                -44.44154
                            ],
                            [
                                -73.91925,
                                -44.34394
                            ],
                            [
                                -73.99605,
                                -44.34394
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -75.02371,
                                -50.81351
                            ],
                            [
                                -74.97602,
                                -50.78381
                            ],
                            [
                                -74.97156,
                                -50.65279
                            ],
                            [
                                -75.0454,
                                -50.6552
                            ],
                            [
                                -75.09714,
                                -50.71467
                            ],
                            [
                                -75.02371,
                                -50.81351
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.14469,
                                -44.83186
                            ],
                            [
                                -74.01451,
                                -44.86239
                            ],
                            [
                                -73.93031,
                                -44.83353
                            ],
                            [
                                -73.99324,
                                -44.77069
                            ],
                            [
                                -74.14469,
                                -44.83186
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -73.73785,
                                -44.76641
                            ],
                            [
                                -73.71545,
                                -44.82201
                            ],
                            [
                                -73.59733,
                                -44.82988
                            ],
                            [
                                -73.61702,
                                -44.73199
                            ],
                            [
                                -73.73785,
                                -44.76641
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -67.05801,
                                -54.99796
                            ],
                            [
                                -67.04984,
                                -55.024
                            ],
                            [
                                -66.88742,
                                -55.09369
                            ],
                            [
                                -66.8597,
                                -55.02934
                            ],
                            [
                                -67.05801,
                                -54.99796
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -75.0573,
                                -47.68043
                            ],
                            [
                                -75.02489,
                                -47.74005
                            ],
                            [
                                -74.92956,
                                -47.77465
                            ],
                            [
                                -74.85235,
                                -47.74397
                            ],
                            [
                                -74.91476,
                                -47.69596
                            ],
                            [
                                -75.0573,
                                -47.68043
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -70.20651,
                                -55.0235
                            ],
                            [
                                -70.01109,
                                -55.00141
                            ],
                            [
                                -69.9929,
                                -54.93759
                            ],
                            [
                                -70.13825,
                                -54.95748
                            ],
                            [
                                -70.20651,
                                -55.0235
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -73.82682,
                                -51.8027
                            ],
                            [
                                -73.74893,
                                -51.76686
                            ],
                            [
                                -73.83734,
                                -51.68461
                            ],
                            [
                                -73.92249,
                                -51.70351
                            ],
                            [
                                -73.82682,
                                -51.8027
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -72.21614,
                                -53.87999
                            ],
                            [
                                -72.09409,
                                -53.90836
                            ],
                            [
                                -72.05817,
                                -53.82421
                            ],
                            [
                                -72.15119,
                                -53.8289
                            ],
                            [
                                -72.21614,
                                -53.87999
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -75.01842,
                                -51.16376
                            ],
                            [
                                -74.83437,
                                -51.15583
                            ],
                            [
                                -74.85572,
                                -51.09783
                            ],
                            [
                                -74.94962,
                                -51.09532
                            ],
                            [
                                -75.01842,
                                -51.16376
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.70687,
                                -52.21312
                            ],
                            [
                                -74.63475,
                                -52.19175
                            ],
                            [
                                -74.64887,
                                -52.11165
                            ],
                            [
                                -74.78835,
                                -52.17232
                            ],
                            [
                                -74.70687,
                                -52.21312
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -73.82203,
                                -53.22895
                            ],
                            [
                                -73.77897,
                                -53.20583
                            ],
                            [
                                -73.86344,
                                -53.10171
                            ],
                            [
                                -73.966,
                                -53.12397
                            ],
                            [
                                -73.82203,
                                -53.22895
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -73.55267,
                                -42.70466
                            ],
                            [
                                -73.59571,
                                -42.57026
                            ],
                            [
                                -73.72024,
                                -42.59637
                            ],
                            [
                                -73.74207,
                                -42.62941
                            ],
                            [
                                -73.59945,
                                -42.65222
                            ],
                            [
                                -73.55267,
                                -42.70466
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -70.46924,
                                -54.99158
                            ],
                            [
                                -70.45441,
                                -55.0144
                            ],
                            [
                                -70.25248,
                                -54.98014
                            ],
                            [
                                -70.31374,
                                -54.93528
                            ],
                            [
                                -70.46924,
                                -54.99158
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.2323,
                                -44.30232
                            ],
                            [
                                -74.31478,
                                -44.22544
                            ],
                            [
                                -74.40937,
                                -44.24786
                            ],
                            [
                                -74.33826,
                                -44.30722
                            ],
                            [
                                -74.2323,
                                -44.30232
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -72.95819,
                                -53.73091
                            ],
                            [
                                -73.05711,
                                -53.71337
                            ],
                            [
                                -73.10829,
                                -53.76904
                            ],
                            [
                                -73.01869,
                                -53.78906
                            ],
                            [
                                -72.95819,
                                -53.73091
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -73.74655,
                                -47.92644
                            ],
                            [
                                -73.66796,
                                -47.99534
                            ],
                            [
                                -73.62235,
                                -47.9693
                            ],
                            [
                                -73.62583,
                                -47.90354
                            ],
                            [
                                -73.70519,
                                -47.86582
                            ],
                            [
                                -73.74655,
                                -47.92644
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -75.21764,
                                -49.18138
                            ],
                            [
                                -75.15455,
                                -49.24101
                            ],
                            [
                                -75.03918,
                                -49.23121
                            ],
                            [
                                -75.08624,
                                -49.17374
                            ],
                            [
                                -75.21764,
                                -49.18138
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.74341,
                                -44.55444
                            ],
                            [
                                -74.81622,
                                -44.6006
                            ],
                            [
                                -74.75947,
                                -44.66452
                            ],
                            [
                                -74.71683,
                                -44.5745
                            ],
                            [
                                -74.74341,
                                -44.55444
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -69.80075,
                                -55.37526
                            ],
                            [
                                -69.70083,
                                -55.46763
                            ],
                            [
                                -69.63465,
                                -55.40288
                            ],
                            [
                                -69.80075,
                                -55.37526
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -73.85163,
                                -44.4603
                            ],
                            [
                                -73.74952,
                                -44.44127
                            ],
                            [
                                -73.82352,
                                -44.37393
                            ],
                            [
                                -73.89405,
                                -44.41529
                            ],
                            [
                                -73.85163,
                                -44.4603
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -73.65053,
                                -44.34394
                            ],
                            [
                                -73.78231,
                                -44.36653
                            ],
                            [
                                -73.71824,
                                -44.42889
                            ],
                            [
                                -73.65731,
                                -44.43851
                            ],
                            [
                                -73.65053,
                                -44.34394
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -73.25394,
                                -44.39773
                            ],
                            [
                                -73.15226,
                                -44.38272
                            ],
                            [
                                -73.18958,
                                -44.32396
                            ],
                            [
                                -73.28529,
                                -44.33964
                            ],
                            [
                                -73.25394,
                                -44.39773
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -73.11519,
                                -41.80608
                            ],
                            [
                                -73.03117,
                                -41.86269
                            ],
                            [
                                -72.98934,
                                -41.82879
                            ],
                            [
                                -73.05482,
                                -41.73329
                            ],
                            [
                                -73.11519,
                                -41.80608
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -72.60898,
                                -42.12976
                            ],
                            [
                                -72.50872,
                                -42.16968
                            ],
                            [
                                -72.50589,
                                -42.07307
                            ],
                            [
                                -72.57776,
                                -42.08478
                            ],
                            [
                                -72.60898,
                                -42.12976
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.72734,
                                -45.7167
                            ],
                            [
                                -74.79741,
                                -45.60406
                            ],
                            [
                                -74.86222,
                                -45.64662
                            ],
                            [
                                -74.72734,
                                -45.7167
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -73.85144,
                                -43.85867
                            ],
                            [
                                -73.8478,
                                -43.90116
                            ],
                            [
                                -73.73683,
                                -43.89617
                            ],
                            [
                                -73.76885,
                                -43.82736
                            ],
                            [
                                -73.85144,
                                -43.85867
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -74.57569,
                                -45.79252
                            ],
                            [
                                -74.46729,
                                -45.81237
                            ],
                            [
                                -74.48301,
                                -45.74303
                            ],
                            [
                                -74.57569,
                                -45.79252
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -73.95993,
                                -38.32068
                            ],
                            [
                                -73.93031,
                                -38.41083
                            ],
                            [
                                -73.86825,
                                -38.38981
                            ],
                            [
                                -73.95993,
                                -38.32068
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -73.17542,
                                -42.27554
                            ],
                            [
                                -73.11304,
                                -42.33582
                            ],
                            [
                                -73.05898,
                                -42.27282
                            ],
                            [
                                -73.17542,
                                -42.27554
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "CHN",
                "Country": "China",
                "Total_3GHG": 12.67,
                "Total_3GHG_timeseries": [
                    0.0001,
                    0.0002,
                    0.0003,
                    0.0004,
                    0.0005,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0033,
                    0.0034,
                    0.0036,
                    0.0037,
                    0.0039,
                    0.004,
                    0.0042,
                    0.0043,
                    0.0045,
                    0.0047,
                    0.0049,
                    0.0051,
                    0.0053,
                    0.0055,
                    0.0058,
                    0.006,
                    0.0063,
                    0.0065,
                    0.0068,
                    0.007,
                    0.0073,
                    0.0076,
                    0.0079,
                    0.0082,
                    0.0084,
                    0.0087,
                    0.009,
                    0.0093,
                    0.0095,
                    0.0098,
                    0.0101,
                    0.0104,
                    0.0106,
                    0.0109,
                    0.0111,
                    0.0114,
                    0.0117,
                    0.012,
                    0.0122,
                    0.0125,
                    0.0128,
                    0.0131,
                    0.0134,
                    0.0138,
                    0.0141,
                    0.0144,
                    0.0147,
                    0.015,
                    0.0153,
                    0.0156,
                    0.0159,
                    0.0163,
                    0.0168,
                    0.0173,
                    0.0178,
                    0.0183,
                    0.0188,
                    0.0194,
                    0.02,
                    0.0208,
                    0.0219,
                    0.0229,
                    0.0237,
                    0.0245,
                    0.0252,
                    0.0261,
                    0.0269,
                    0.0279,
                    0.0288,
                    0.0298,
                    0.0308,
                    0.0321,
                    0.0334,
                    0.0347,
                    0.0361,
                    0.0374,
                    0.0389,
                    0.0405,
                    0.0421,
                    0.0437,
                    0.0453,
                    0.0468,
                    0.0486,
                    0.0505,
                    0.0525,
                    0.0547,
                    0.0569,
                    0.059,
                    0.0612,
                    0.0636,
                    0.066,
                    0.0683,
                    0.0706,
                    0.0729,
                    0.0753,
                    0.0778,
                    0.0805,
                    0.0832,
                    0.0858,
                    0.0883,
                    0.0908,
                    0.0934,
                    0.096,
                    0.0987,
                    0.1018,
                    0.1053,
                    0.1091,
                    0.1133,
                    0.1177,
                    0.1223,
                    0.1272,
                    0.1323,
                    0.1381,
                    0.144,
                    0.15,
                    0.1561,
                    0.162,
                    0.1678,
                    0.1737,
                    0.18,
                    0.1865,
                    0.1931,
                    0.1999,
                    0.207
                ],
                "Fossil_3GHG": 16.01,
                "Fossil_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    7.4463e-06,
                    -0.0000025671,
                    0,
                    0,
                    0,
                    0,
                    0,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    0,
                    0,
                    0,
                    0,
                    0,
                    -0.0000044898,
                    9.1546e-06,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0043,
                    0.0045,
                    0.0046,
                    0.0049,
                    0.0051,
                    0.0054,
                    0.0057,
                    0.0063,
                    0.007,
                    0.0077,
                    0.0083,
                    0.0088,
                    0.0093,
                    0.0099,
                    0.0104,
                    0.0111,
                    0.0116,
                    0.0123,
                    0.013,
                    0.0138,
                    0.0147,
                    0.0157,
                    0.0166,
                    0.0176,
                    0.0187,
                    0.0197,
                    0.0209,
                    0.0222,
                    0.0233,
                    0.0245,
                    0.0257,
                    0.027,
                    0.0284,
                    0.0299,
                    0.0314,
                    0.0331,
                    0.0348,
                    0.0366,
                    0.0385,
                    0.0403,
                    0.0421,
                    0.044,
                    0.0459,
                    0.048,
                    0.0502,
                    0.0524,
                    0.0545,
                    0.0565,
                    0.0586,
                    0.0607,
                    0.0629,
                    0.0653,
                    0.0682,
                    0.0713,
                    0.0748,
                    0.0787,
                    0.0829,
                    0.0873,
                    0.0919,
                    0.0968,
                    0.1025,
                    0.1082,
                    0.1141,
                    0.12,
                    0.1257,
                    0.1314,
                    0.1372,
                    0.1432,
                    0.1495,
                    0.156,
                    0.1626,
                    0.1695
                ],
                "Land_3GHG": 6.51,
                "Land_3GHG_timeseries": [
                    0.0001,
                    0.0002,
                    0.0003,
                    0.0004,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0043,
                    0.0044,
                    0.0046,
                    0.0048,
                    0.005,
                    0.0052,
                    0.0054,
                    0.0056,
                    0.0058,
                    0.006,
                    0.0062,
                    0.0064,
                    0.0066,
                    0.0068,
                    0.007,
                    0.0072,
                    0.0074,
                    0.0076,
                    0.0078,
                    0.008,
                    0.0081,
                    0.0083,
                    0.0085,
                    0.0087,
                    0.0089,
                    0.0091,
                    0.0092,
                    0.0094,
                    0.0096,
                    0.0098,
                    0.01,
                    0.0102,
                    0.0104,
                    0.0106,
                    0.0108,
                    0.0111,
                    0.0113,
                    0.0115,
                    0.0117,
                    0.0119,
                    0.0122,
                    0.0125,
                    0.0128,
                    0.0131,
                    0.0134,
                    0.0137,
                    0.014,
                    0.0143,
                    0.0146,
                    0.0149,
                    0.0152,
                    0.0154,
                    0.0157,
                    0.0159,
                    0.0162,
                    0.0165,
                    0.0168,
                    0.0172,
                    0.0175,
                    0.0179,
                    0.0182,
                    0.0186,
                    0.019,
                    0.0195,
                    0.0199,
                    0.0203,
                    0.0207,
                    0.0211,
                    0.0215,
                    0.0219,
                    0.0224,
                    0.0229,
                    0.0235,
                    0.0242,
                    0.0249,
                    0.0254,
                    0.0259,
                    0.0264,
                    0.027,
                    0.0275,
                    0.028,
                    0.0285,
                    0.0289,
                    0.0294,
                    0.0298,
                    0.0303,
                    0.0308,
                    0.0313,
                    0.0318,
                    0.0323,
                    0.0327,
                    0.033,
                    0.0334,
                    0.0337,
                    0.034,
                    0.0343,
                    0.0346,
                    0.0348,
                    0.0351,
                    0.0353,
                    0.0355,
                    0.0357,
                    0.0358,
                    0.036,
                    0.0362,
                    0.0363,
                    0.0364,
                    0.0366,
                    0.0368,
                    0.0369,
                    0.0371,
                    0.0373,
                    0.0376
                ],
                "Total_CO2": 11.88,
                "Total_CO2_timeseries": [
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0004,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0043,
                    0.0044,
                    0.0046,
                    0.0047,
                    0.0049,
                    0.005,
                    0.0052,
                    0.0053,
                    0.0055,
                    0.0056,
                    0.0057,
                    0.0059,
                    0.006,
                    0.0061,
                    0.0063,
                    0.0064,
                    0.0066,
                    0.0067,
                    0.0069,
                    0.007,
                    0.0072,
                    0.0073,
                    0.0075,
                    0.0077,
                    0.0079,
                    0.0081,
                    0.0083,
                    0.0085,
                    0.0086,
                    0.0088,
                    0.009,
                    0.0091,
                    0.0094,
                    0.0096,
                    0.0099,
                    0.0102,
                    0.0104,
                    0.0107,
                    0.011,
                    0.0113,
                    0.0117,
                    0.0122,
                    0.0127,
                    0.0131,
                    0.0134,
                    0.0137,
                    0.014,
                    0.0143,
                    0.0147,
                    0.0149,
                    0.0153,
                    0.0156,
                    0.0161,
                    0.0166,
                    0.0171,
                    0.0177,
                    0.0183,
                    0.0189,
                    0.0196,
                    0.0203,
                    0.0211,
                    0.0219,
                    0.0227,
                    0.0236,
                    0.0246,
                    0.0258,
                    0.0271,
                    0.0283,
                    0.0295,
                    0.0308,
                    0.0321,
                    0.0335,
                    0.0349,
                    0.0363,
                    0.0377,
                    0.0392,
                    0.0408,
                    0.0425,
                    0.0442,
                    0.046,
                    0.0477,
                    0.0494,
                    0.0511,
                    0.0529,
                    0.0547,
                    0.0569,
                    0.0593,
                    0.062,
                    0.0649,
                    0.0681,
                    0.0714,
                    0.075,
                    0.0789,
                    0.0831,
                    0.0875,
                    0.0919,
                    0.0965,
                    0.1009,
                    0.1053,
                    0.1098,
                    0.1146,
                    0.1195,
                    0.1245,
                    0.1297,
                    0.1349
                ],
                "Fossil_CO2": 15.12,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    8.9588e-06,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0016,
                    0.0018,
                    0.0021,
                    0.0025,
                    0.0027,
                    0.0029,
                    0.0031,
                    0.0034,
                    0.0036,
                    0.0038,
                    0.004,
                    0.0043,
                    0.0045,
                    0.0049,
                    0.0053,
                    0.0057,
                    0.0062,
                    0.0067,
                    0.0072,
                    0.0077,
                    0.0083,
                    0.009,
                    0.0097,
                    0.0104,
                    0.011,
                    0.0118,
                    0.0125,
                    0.0134,
                    0.0143,
                    0.0152,
                    0.0162,
                    0.0173,
                    0.0184,
                    0.0195,
                    0.0207,
                    0.0219,
                    0.0233,
                    0.0247,
                    0.0262,
                    0.0278,
                    0.0293,
                    0.0309,
                    0.0325,
                    0.0341,
                    0.0358,
                    0.0376,
                    0.0398,
                    0.0422,
                    0.0448,
                    0.0477,
                    0.0509,
                    0.0543,
                    0.0578,
                    0.0617,
                    0.066,
                    0.0704,
                    0.0749,
                    0.0794,
                    0.0838,
                    0.0882,
                    0.0927,
                    0.0974,
                    0.1022,
                    0.1071,
                    0.1122,
                    0.1174
                ],
                "Land_CO2": 4.88,
                "Land_CO2_timeseries": [
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0004,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.005,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0055,
                    0.0056,
                    0.0057,
                    0.0059,
                    0.006,
                    0.0061,
                    0.0062,
                    0.0063,
                    0.0064,
                    0.0066,
                    0.0067,
                    0.0068,
                    0.007,
                    0.0071,
                    0.0072,
                    0.0074,
                    0.0075,
                    0.0077,
                    0.0079,
                    0.008,
                    0.0081,
                    0.0084,
                    0.0086,
                    0.0088,
                    0.009,
                    0.0092,
                    0.0093,
                    0.0095,
                    0.0097,
                    0.0099,
                    0.0101,
                    0.0102,
                    0.0103,
                    0.0104,
                    0.0105,
                    0.0106,
                    0.0107,
                    0.0108,
                    0.0109,
                    0.011,
                    0.0111,
                    0.0112,
                    0.0113,
                    0.0114,
                    0.0115,
                    0.0116,
                    0.0117,
                    0.0118,
                    0.012,
                    0.0121,
                    0.0122,
                    0.0123,
                    0.0126,
                    0.0129,
                    0.0133,
                    0.0137,
                    0.014,
                    0.0143,
                    0.0145,
                    0.0148,
                    0.0151,
                    0.0154,
                    0.0155,
                    0.0157,
                    0.0159,
                    0.0161,
                    0.0163,
                    0.0165,
                    0.0167,
                    0.0168,
                    0.017,
                    0.017,
                    0.0171,
                    0.0171,
                    0.0171,
                    0.0172,
                    0.0172,
                    0.0172,
                    0.0172,
                    0.0172,
                    0.0172,
                    0.0172,
                    0.0172,
                    0.0171,
                    0.0171,
                    0.0171,
                    0.0171,
                    0.0171,
                    0.0171,
                    0.0172,
                    0.0173,
                    0.0173,
                    0.0175,
                    0.0176
                ],
                "Total_CH4": 15.11,
                "Total_CH4_timeseries": [
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0,
                    0,
                    0,
                    0,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    0,
                    -0.0000064003,
                    0,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0056,
                    0.0057,
                    0.0058,
                    0.0059,
                    0.006,
                    0.0061,
                    0.0063,
                    0.0064,
                    0.0066,
                    0.0068,
                    0.007,
                    0.0073,
                    0.0075,
                    0.0078,
                    0.0082,
                    0.0087,
                    0.0092,
                    0.0096,
                    0.01,
                    0.0104,
                    0.0109,
                    0.0114,
                    0.012,
                    0.0125,
                    0.0131,
                    0.0138,
                    0.0145,
                    0.0152,
                    0.016,
                    0.0167,
                    0.0174,
                    0.0182,
                    0.019,
                    0.0198,
                    0.0206,
                    0.0213,
                    0.0219,
                    0.0226,
                    0.0234,
                    0.0242,
                    0.025,
                    0.0258,
                    0.0266,
                    0.0275,
                    0.0283,
                    0.0292,
                    0.03,
                    0.0308,
                    0.0316,
                    0.0323,
                    0.0331,
                    0.0339,
                    0.0347,
                    0.0354,
                    0.036,
                    0.0366,
                    0.0373,
                    0.038,
                    0.0387,
                    0.0394,
                    0.0403,
                    0.0413,
                    0.0424,
                    0.0434,
                    0.0445,
                    0.0456,
                    0.0467,
                    0.048,
                    0.0493,
                    0.0507,
                    0.0521,
                    0.0533,
                    0.0545,
                    0.0557,
                    0.057,
                    0.0584,
                    0.0598,
                    0.0613,
                    0.0629
                ],
                "Fossil_CH4": 19.11,
                "Fossil_CH4_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    9.0937e-06,
                    1.4262e-07,
                    -0.0000097551,
                    0,
                    0,
                    0,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    0,
                    0,
                    -0.0000072186,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0032,
                    0.0033,
                    0.0035,
                    0.0036,
                    0.0038,
                    0.0041,
                    0.0045,
                    0.0049,
                    0.0052,
                    0.0055,
                    0.0058,
                    0.0061,
                    0.0064,
                    0.0068,
                    0.0072,
                    0.0076,
                    0.008,
                    0.0085,
                    0.0089,
                    0.0094,
                    0.0099,
                    0.0104,
                    0.0109,
                    0.0114,
                    0.012,
                    0.0125,
                    0.013,
                    0.0134,
                    0.0139,
                    0.0145,
                    0.0151,
                    0.0157,
                    0.0164,
                    0.017,
                    0.0177,
                    0.0184,
                    0.0191,
                    0.0198,
                    0.0204,
                    0.021,
                    0.0216,
                    0.0222,
                    0.0229,
                    0.0235,
                    0.024,
                    0.0244,
                    0.0249,
                    0.0253,
                    0.0258,
                    0.0263,
                    0.0269,
                    0.0277,
                    0.0285,
                    0.0294,
                    0.0304,
                    0.0313,
                    0.0323,
                    0.0333,
                    0.0346,
                    0.0359,
                    0.0372,
                    0.0386,
                    0.0398,
                    0.041,
                    0.0422,
                    0.0436,
                    0.045,
                    0.0464,
                    0.0479,
                    0.0496
                ],
                "Land_CH4": 8.49,
                "Land_CH4_timeseries": [
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0,
                    0,
                    0,
                    0,
                    -0.0000026368,
                    0,
                    0,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    0,
                    0,
                    8.1829e-07,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0048,
                    0.005,
                    0.0052,
                    0.0054,
                    0.0056,
                    0.0058,
                    0.006,
                    0.0063,
                    0.0065,
                    0.0068,
                    0.0071,
                    0.0073,
                    0.0076,
                    0.0078,
                    0.008,
                    0.0083,
                    0.0085,
                    0.0087,
                    0.0089,
                    0.0091,
                    0.0093,
                    0.0094,
                    0.0096,
                    0.0097,
                    0.0099,
                    0.0101,
                    0.0103,
                    0.0104,
                    0.0105,
                    0.0107,
                    0.0108,
                    0.011,
                    0.0112,
                    0.0114,
                    0.0116,
                    0.0118,
                    0.012,
                    0.0122,
                    0.0124,
                    0.0125,
                    0.0127,
                    0.0128,
                    0.013,
                    0.0131,
                    0.0132,
                    0.0133,
                    0.0133,
                    0.0134,
                    0.0134,
                    0.0135,
                    0.0135,
                    0.0135,
                    0.0134,
                    0.0135,
                    0.0134,
                    0.0134,
                    0.0133,
                    0.0133,
                    0.0133
                ],
                "Total_N2O": 11.1,
                "Total_N2O_timeseries": [
                    2.6098e-06,
                    5.2592e-06,
                    7.9471e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0034,
                    0.0035,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.0041,
                    0.0043,
                    0.0044,
                    0.0046,
                    0.0048,
                    0.0049,
                    0.0051,
                    0.0053,
                    0.0054,
                    0.0056,
                    0.0058,
                    0.006,
                    0.0062,
                    0.0064,
                    0.0066,
                    0.0068,
                    0.007,
                    0.0072,
                    0.0074,
                    0.0076,
                    0.0078,
                    0.008,
                    0.0082,
                    0.0084,
                    0.0086,
                    0.0088,
                    0.009,
                    0.0092
                ],
                "Fossil_N2O": 10.99,
                "Fossil_N2O_timeseries": [
                    1.5245e-06,
                    3.0669e-06,
                    4.627e-06,
                    6.2044e-06,
                    7.7988e-06,
                    9.4095e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0025
                ],
                "Land_N2O": 11.15,
                "Land_N2O_timeseries": [
                    1.0853e-06,
                    2.1923e-06,
                    3.32e-06,
                    4.4673e-06,
                    5.6324e-06,
                    6.8133e-06,
                    8.0077e-06,
                    9.2128e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0046,
                    0.0047,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0053,
                    0.0054,
                    0.0056,
                    0.0057,
                    0.0059,
                    0.006,
                    0.0062,
                    0.0063,
                    0.0064,
                    0.0065,
                    0.0067
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                130.63393,
                                42.41417
                            ],
                            [
                                130.5893,
                                42.44655
                            ],
                            [
                                130.56751,
                                42.5364
                            ],
                            [
                                130.6266,
                                42.58457
                            ],
                            [
                                130.59039,
                                42.65752
                            ],
                            [
                                130.52325,
                                42.69746
                            ],
                            [
                                130.45223,
                                42.68293
                            ],
                            [
                                130.39715,
                                42.72396
                            ],
                            [
                                130.66026,
                                42.84108
                            ],
                            [
                                130.7652,
                                42.83348
                            ],
                            [
                                130.82307,
                                42.87735
                            ],
                            [
                                130.88509,
                                42.85202
                            ],
                            [
                                131.03464,
                                42.86696
                            ],
                            [
                                131.14596,
                                42.95805
                            ],
                            [
                                131.09222,
                                43.02335
                            ],
                            [
                                131.20441,
                                43.1325
                            ],
                            [
                                131.20524,
                                43.23455
                            ],
                            [
                                131.24775,
                                43.26464
                            ],
                            [
                                131.26869,
                                43.37097
                            ],
                            [
                                131.30679,
                                43.39538
                            ],
                            [
                                131.31051,
                                43.48251
                            ],
                            [
                                131.19514,
                                43.53827
                            ],
                            [
                                131.22117,
                                43.66355
                            ],
                            [
                                131.20049,
                                43.8327
                            ],
                            [
                                131.2532,
                                43.91981
                            ],
                            [
                                131.23112,
                                43.96143
                            ],
                            [
                                131.29799,
                                44.05048
                            ],
                            [
                                131.09999,
                                44.7061
                            ],
                            [
                                131.01535,
                                44.77843
                            ],
                            [
                                130.97862,
                                44.86419
                            ],
                            [
                                131.0902,
                                44.89515
                            ],
                            [
                                131.13746,
                                44.94302
                            ],
                            [
                                131.20143,
                                44.91712
                            ],
                            [
                                131.29315,
                                44.93968
                            ],
                            [
                                131.33873,
                                44.98253
                            ],
                            [
                                131.46562,
                                44.96076
                            ],
                            [
                                131.67812,
                                45.11834
                            ],
                            [
                                131.6447,
                                45.16319
                            ],
                            [
                                131.67431,
                                45.21263
                            ],
                            [
                                131.78162,
                                45.24745
                            ],
                            [
                                131.82475,
                                45.31337
                            ],
                            [
                                131.91374,
                                45.33486
                            ],
                            [
                                131.93342,
                                45.28319
                            ],
                            [
                                132.00453,
                                45.24861
                            ],
                            [
                                132.84186,
                                45.06071
                            ],
                            [
                                132.93441,
                                45.01889
                            ],
                            [
                                133.02594,
                                45.05552
                            ],
                            [
                                133.12508,
                                45.13705
                            ],
                            [
                                133.08607,
                                45.25327
                            ],
                            [
                                133.09207,
                                45.3113
                            ],
                            [
                                133.19411,
                                45.51436
                            ],
                            [
                                133.29485,
                                45.53941
                            ],
                            [
                                133.46912,
                                45.6566
                            ],
                            [
                                133.456,
                                45.83119
                            ],
                            [
                                133.51471,
                                45.8908
                            ],
                            [
                                133.5807,
                                45.86911
                            ],
                            [
                                133.61656,
                                45.94166
                            ],
                            [
                                133.73265,
                                46.05875
                            ],
                            [
                                133.68068,
                                46.12948
                            ],
                            [
                                133.81606,
                                46.2257
                            ],
                            [
                                133.90456,
                                46.25301
                            ],
                            [
                                133.93809,
                                46.3953
                            ],
                            [
                                133.83937,
                                46.47093
                            ],
                            [
                                133.90648,
                                46.58381
                            ],
                            [
                                134.01078,
                                46.6455
                            ],
                            [
                                134.04429,
                                46.78442
                            ],
                            [
                                134.01742,
                                46.81313
                            ],
                            [
                                134.11298,
                                47.06296
                            ],
                            [
                                134.22546,
                                47.10877
                            ],
                            [
                                134.21942,
                                47.19108
                            ],
                            [
                                134.15057,
                                47.25893
                            ],
                            [
                                134.17473,
                                47.32696
                            ],
                            [
                                134.24331,
                                47.35482
                            ],
                            [
                                134.31799,
                                47.43361
                            ],
                            [
                                134.49124,
                                47.43995
                            ],
                            [
                                134.68276,
                                47.59754
                            ],
                            [
                                134.67997,
                                47.62901
                            ],
                            [
                                134.77837,
                                47.7237
                            ],
                            [
                                134.68049,
                                47.81974
                            ],
                            [
                                134.67263,
                                47.88661
                            ],
                            [
                                134.60484,
                                47.92348
                            ],
                            [
                                134.54862,
                                48.01998
                            ],
                            [
                                134.66047,
                                48.13917
                            ],
                            [
                                134.67864,
                                48.25518
                            ],
                            [
                                134.72405,
                                48.27641
                            ],
                            [
                                134.72998,
                                48.37816
                            ],
                            [
                                134.6913,
                                48.40408
                            ],
                            [
                                134.44149,
                                48.4038
                            ],
                            [
                                134.34808,
                                48.36797
                            ],
                            [
                                134.19611,
                                48.37968
                            ],
                            [
                                134.06222,
                                48.33551
                            ],
                            [
                                133.73328,
                                48.25196
                            ],
                            [
                                133.68581,
                                48.18533
                            ],
                            [
                                133.59538,
                                48.19251
                            ],
                            [
                                133.50319,
                                48.11273
                            ],
                            [
                                133.39529,
                                48.12147
                            ],
                            [
                                133.29646,
                                48.10103
                            ],
                            [
                                133.21076,
                                48.12948
                            ],
                            [
                                133.09252,
                                48.12608
                            ],
                            [
                                132.97375,
                                48.02964
                            ],
                            [
                                132.87635,
                                48.00012
                            ],
                            [
                                132.81231,
                                47.93559
                            ],
                            [
                                132.7128,
                                47.96048
                            ],
                            [
                                132.65452,
                                47.94209
                            ],
                            [
                                132.67838,
                                47.88155
                            ],
                            [
                                132.61588,
                                47.82736
                            ],
                            [
                                132.59054,
                                47.73482
                            ],
                            [
                                132.46483,
                                47.72194
                            ],
                            [
                                132.37553,
                                47.75603
                            ],
                            [
                                132.29665,
                                47.75066
                            ],
                            [
                                132.24497,
                                47.70829
                            ],
                            [
                                131.99434,
                                47.70364
                            ],
                            [
                                131.95575,
                                47.66816
                            ],
                            [
                                131.82293,
                                47.67235
                            ],
                            [
                                131.68054,
                                47.70274
                            ],
                            [
                                131.5894,
                                47.66163
                            ],
                            [
                                131.5202,
                                47.73832
                            ],
                            [
                                131.26162,
                                47.73714
                            ],
                            [
                                131.16972,
                                47.69822
                            ],
                            [
                                131.04114,
                                47.6894
                            ],
                            [
                                130.95901,
                                47.7321
                            ],
                            [
                                130.95485,
                                47.82215
                            ],
                            [
                                130.88306,
                                47.92508
                            ],
                            [
                                130.69657,
                                48.04006
                            ],
                            [
                                130.67087,
                                48.13041
                            ],
                            [
                                130.75661,
                                48.18675
                            ],
                            [
                                130.77375,
                                48.2493
                            ],
                            [
                                130.83562,
                                48.29245
                            ],
                            [
                                130.77133,
                                48.36012
                            ],
                            [
                                130.70665,
                                48.50849
                            ],
                            [
                                130.61301,
                                48.50469
                            ],
                            [
                                130.60982,
                                48.56967
                            ],
                            [
                                130.53335,
                                48.60731
                            ],
                            [
                                130.6339,
                                48.80597
                            ],
                            [
                                130.63662,
                                48.88306
                            ],
                            [
                                130.53447,
                                48.8544
                            ],
                            [
                                130.46576,
                                48.90138
                            ],
                            [
                                130.29323,
                                48.86905
                            ],
                            [
                                130.05584,
                                48.97315
                            ],
                            [
                                130.01864,
                                49.015
                            ],
                            [
                                129.92479,
                                49.04118
                            ],
                            [
                                129.85536,
                                49.1629
                            ],
                            [
                                129.74239,
                                49.21499
                            ],
                            [
                                129.70316,
                                49.29435
                            ],
                            [
                                129.58013,
                                49.2771
                            ],
                            [
                                129.5387,
                                49.38945
                            ],
                            [
                                129.43522,
                                49.44144
                            ],
                            [
                                129.36929,
                                49.41332
                            ],
                            [
                                129.36961,
                                49.35913
                            ],
                            [
                                129.20675,
                                49.39662
                            ],
                            [
                                129.11429,
                                49.35223
                            ],
                            [
                                129.05381,
                                49.3725
                            ],
                            [
                                129.01699,
                                49.44611
                            ],
                            [
                                128.7494,
                                49.50634
                            ],
                            [
                                128.78798,
                                49.58371
                            ],
                            [
                                128.6707,
                                49.56962
                            ],
                            [
                                128.53106,
                                49.60227
                            ],
                            [
                                128.37486,
                                49.58417
                            ],
                            [
                                128.21011,
                                49.54192
                            ],
                            [
                                128.07966,
                                49.55218
                            ],
                            [
                                127.94784,
                                49.59945
                            ],
                            [
                                127.81749,
                                49.59099
                            ],
                            [
                                127.67485,
                                49.6965
                            ],
                            [
                                127.66512,
                                49.77026
                            ],
                            [
                                127.57425,
                                49.78522
                            ],
                            [
                                127.52057,
                                49.85679
                            ],
                            [
                                127.53848,
                                49.93354
                            ],
                            [
                                127.48357,
                                49.99976
                            ],
                            [
                                127.511,
                                50.08028
                            ],
                            [
                                127.57044,
                                50.13037
                            ],
                            [
                                127.59871,
                                50.23112
                            ],
                            [
                                127.37528,
                                50.28303
                            ],
                            [
                                127.32066,
                                50.3327
                            ],
                            [
                                127.35777,
                                50.40785
                            ],
                            [
                                127.28452,
                                50.46147
                            ],
                            [
                                127.35876,
                                50.58608
                            ],
                            [
                                127.28601,
                                50.66455
                            ],
                            [
                                127.28674,
                                50.75294
                            ],
                            [
                                127.23405,
                                50.77466
                            ],
                            [
                                127.13415,
                                50.90688
                            ],
                            [
                                127.03486,
                                50.95879
                            ],
                            [
                                126.91107,
                                51.06115
                            ],
                            [
                                126.88967,
                                51.21005
                            ],
                            [
                                126.81309,
                                51.26563
                            ],
                            [
                                126.8045,
                                51.32494
                            ],
                            [
                                126.90921,
                                51.35888
                            ],
                            [
                                126.88448,
                                51.40836
                            ],
                            [
                                126.76921,
                                51.446
                            ],
                            [
                                126.82448,
                                51.53504
                            ],
                            [
                                126.6845,
                                51.57842
                            ],
                            [
                                126.7272,
                                51.65005
                            ],
                            [
                                126.70013,
                                51.73007
                            ],
                            [
                                126.6043,
                                51.77678
                            ],
                            [
                                126.54817,
                                51.86143
                            ],
                            [
                                126.45681,
                                51.94024
                            ],
                            [
                                126.43748,
                                52.00752
                            ],
                            [
                                126.51074,
                                52.03737
                            ],
                            [
                                126.55252,
                                52.12116
                            ],
                            [
                                126.50079,
                                52.15451
                            ],
                            [
                                126.3108,
                                52.19809
                            ],
                            [
                                126.33923,
                                52.38524
                            ],
                            [
                                126.19804,
                                52.52603
                            ],
                            [
                                126.06913,
                                52.60215
                            ],
                            [
                                125.96441,
                                52.61678
                            ],
                            [
                                125.99106,
                                52.67816
                            ],
                            [
                                126.05849,
                                52.69608
                            ],
                            [
                                126.01092,
                                52.79138
                            ],
                            [
                                125.94609,
                                52.76365
                            ],
                            [
                                125.83654,
                                52.88368
                            ],
                            [
                                125.65161,
                                52.91577
                            ],
                            [
                                125.73279,
                                52.98522
                            ],
                            [
                                125.58798,
                                53.08058
                            ],
                            [
                                125.303,
                                53.14343
                            ],
                            [
                                125.1562,
                                53.20108
                            ],
                            [
                                124.96528,
                                53.19568
                            ],
                            [
                                124.82373,
                                53.1447
                            ],
                            [
                                124.73169,
                                53.14296
                            ],
                            [
                                124.6524,
                                53.20566
                            ],
                            [
                                124.50508,
                                53.20279
                            ],
                            [
                                124.35689,
                                53.27008
                            ],
                            [
                                124.23965,
                                53.37439
                            ],
                            [
                                124.11326,
                                53.34521
                            ],
                            [
                                123.87533,
                                53.48163
                            ],
                            [
                                123.6891,
                                53.4982
                            ],
                            [
                                123.66063,
                                53.53255
                            ],
                            [
                                123.53068,
                                53.55434
                            ],
                            [
                                123.38866,
                                53.53578
                            ],
                            [
                                123.29512,
                                53.55761
                            ],
                            [
                                123.1697,
                                53.5066
                            ],
                            [
                                123.04993,
                                53.50527
                            ],
                            [
                                122.85745,
                                53.45734
                            ],
                            [
                                122.59429,
                                53.46224
                            ],
                            [
                                122.46116,
                                53.4435
                            ],
                            [
                                122.31601,
                                53.49396
                            ],
                            [
                                122.25385,
                                53.45902
                            ],
                            [
                                122.16096,
                                53.46805
                            ],
                            [
                                122.11901,
                                53.429
                            ],
                            [
                                121.87081,
                                53.42367
                            ],
                            [
                                121.45434,
                                53.32275
                            ],
                            [
                                121.34869,
                                53.32202
                            ],
                            [
                                121.23484,
                                53.27836
                            ],
                            [
                                120.88068,
                                53.29104
                            ],
                            [
                                120.73864,
                                53.20751
                            ],
                            [
                                120.63986,
                                53.10661
                            ],
                            [
                                120.55309,
                                53.07684
                            ],
                            [
                                120.3468,
                                52.90964
                            ],
                            [
                                120.18249,
                                52.8108
                            ],
                            [
                                120.02958,
                                52.77688
                            ],
                            [
                                120.06189,
                                52.70427
                            ],
                            [
                                120.05304,
                                52.59552
                            ],
                            [
                                120.19381,
                                52.58262
                            ],
                            [
                                120.28465,
                                52.6235
                            ],
                            [
                                120.47658,
                                52.63701
                            ],
                            [
                                120.66196,
                                52.56562
                            ],
                            [
                                120.68919,
                                52.51993
                            ],
                            [
                                120.68035,
                                52.4252
                            ],
                            [
                                120.62779,
                                52.32185
                            ],
                            [
                                120.74972,
                                52.25025
                            ],
                            [
                                120.7782,
                                52.16486
                            ],
                            [
                                120.68778,
                                52.05737
                            ],
                            [
                                120.71012,
                                52.01189
                            ],
                            [
                                120.655,
                                51.92985
                            ],
                            [
                                120.31409,
                                51.78377
                            ],
                            [
                                120.18109,
                                51.68331
                            ],
                            [
                                120.05816,
                                51.63502
                            ],
                            [
                                120.04287,
                                51.55344
                            ],
                            [
                                119.97834,
                                51.50308
                            ],
                            [
                                119.99368,
                                51.45661
                            ],
                            [
                                119.76039,
                                51.21303
                            ],
                            [
                                119.75881,
                                51.09032
                            ],
                            [
                                119.67889,
                                51.01896
                            ],
                            [
                                119.58742,
                                50.98111
                            ],
                            [
                                119.49029,
                                50.88058
                            ],
                            [
                                119.50693,
                                50.8018
                            ],
                            [
                                119.42976,
                                50.68643
                            ],
                            [
                                119.28336,
                                50.61196
                            ],
                            [
                                119.2532,
                                50.46877
                            ],
                            [
                                119.15634,
                                50.35867
                            ],
                            [
                                119.35269,
                                50.35619
                            ],
                            [
                                119.28716,
                                50.11286
                            ],
                            [
                                119.08326,
                                49.99499
                            ],
                            [
                                118.92542,
                                49.99413
                            ],
                            [
                                118.73232,
                                49.95195
                            ],
                            [
                                118.56153,
                                49.93449
                            ],
                            [
                                118.54967,
                                49.90347
                            ],
                            [
                                118.41752,
                                49.82852
                            ],
                            [
                                118.37438,
                                49.78296
                            ],
                            [
                                118.22986,
                                49.74018
                            ],
                            [
                                118.19268,
                                49.68646
                            ],
                            [
                                118.11483,
                                49.67307
                            ],
                            [
                                118.07275,
                                49.61957
                            ],
                            [
                                117.97767,
                                49.62458
                            ],
                            [
                                117.86714,
                                49.59614
                            ],
                            [
                                117.80308,
                                49.51991
                            ],
                            [
                                117.47809,
                                49.63041
                            ],
                            [
                                117.27115,
                                49.63486
                            ],
                            [
                                117.06505,
                                49.6925
                            ],
                            [
                                116.72094,
                                49.84979
                            ],
                            [
                                116.0411,
                                48.86377
                            ],
                            [
                                116.07276,
                                48.81483
                            ],
                            [
                                115.78434,
                                48.51517
                            ],
                            [
                                115.81217,
                                48.25769
                            ],
                            [
                                115.5299,
                                48.13809
                            ],
                            [
                                115.5291,
                                48.05285
                            ],
                            [
                                115.55958,
                                47.92707
                            ],
                            [
                                115.94237,
                                47.68537
                            ],
                            [
                                116.11726,
                                47.83557
                            ],
                            [
                                116.24688,
                                47.88495
                            ],
                            [
                                116.42794,
                                47.84997
                            ],
                            [
                                116.67895,
                                47.90141
                            ],
                            [
                                116.84355,
                                47.90346
                            ],
                            [
                                117.06576,
                                47.83557
                            ],
                            [
                                117.36616,
                                47.65451
                            ],
                            [
                                117.47726,
                                47.76561
                            ],
                            [
                                117.79,
                                48.0228
                            ],
                            [
                                117.8723,
                                48.03514
                            ],
                            [
                                118.03896,
                                48.0228
                            ],
                            [
                                118.17064,
                                48.06395
                            ],
                            [
                                118.27737,
                                48.01946
                            ],
                            [
                                118.41316,
                                48.02254
                            ],
                            [
                                118.46563,
                                47.99168
                            ],
                            [
                                118.5613,
                                47.99477
                            ],
                            [
                                118.76897,
                                47.77242
                            ],
                            [
                                119.12061,
                                47.65679
                            ],
                            [
                                119.14512,
                                47.52145
                            ],
                            [
                                119.35927,
                                47.47938
                            ],
                            [
                                119.3787,
                                47.3906
                            ],
                            [
                                119.54322,
                                47.30108
                            ],
                            [
                                119.70876,
                                47.18439
                            ],
                            [
                                119.76766,
                                47.1105
                            ],
                            [
                                119.77873,
                                47.00398
                            ],
                            [
                                119.90489,
                                46.87997
                            ],
                            [
                                119.93029,
                                46.80085
                            ],
                            [
                                119.90681,
                                46.68953
                            ],
                            [
                                119.80767,
                                46.6857
                            ],
                            [
                                119.70813,
                                46.61026
                            ],
                            [
                                119.66183,
                                46.64073
                            ],
                            [
                                119.55443,
                                46.64447
                            ],
                            [
                                119.30537,
                                46.6248
                            ],
                            [
                                119.22877,
                                46.65721
                            ],
                            [
                                119.08844,
                                46.66047
                            ],
                            [
                                119.01015,
                                46.74859
                            ],
                            [
                                118.92808,
                                46.73295
                            ],
                            [
                                118.83478,
                                46.77345
                            ],
                            [
                                118.73784,
                                46.6957
                            ],
                            [
                                118.6255,
                                46.72419
                            ],
                            [
                                118.54569,
                                46.69716
                            ],
                            [
                                118.41763,
                                46.70615
                            ],
                            [
                                118.30402,
                                46.74747
                            ],
                            [
                                118.04589,
                                46.64167
                            ],
                            [
                                117.90073,
                                46.61358
                            ],
                            [
                                117.81892,
                                46.55105
                            ],
                            [
                                117.68789,
                                46.5217
                            ],
                            [
                                117.5802,
                                46.59968
                            ],
                            [
                                117.43706,
                                46.58756
                            ],
                            [
                                117.4289,
                                46.53669
                            ],
                            [
                                117.32553,
                                46.36101
                            ],
                            [
                                116.99891,
                                46.36369
                            ],
                            [
                                116.82345,
                                46.38214
                            ],
                            [
                                116.75748,
                                46.32477
                            ],
                            [
                                116.59867,
                                46.307
                            ],
                            [
                                116.40043,
                                46.12317
                            ],
                            [
                                116.27824,
                                45.98116
                            ],
                            [
                                116.24164,
                                45.87355
                            ],
                            [
                                116.2718,
                                45.77379
                            ],
                            [
                                116.18089,
                                45.69874
                            ],
                            [
                                116.06044,
                                45.68735
                            ],
                            [
                                115.94443,
                                45.637
                            ],
                            [
                                115.67801,
                                45.46094
                            ],
                            [
                                115.34171,
                                45.39072
                            ],
                            [
                                115.22789,
                                45.397
                            ],
                            [
                                114.91987,
                                45.37987
                            ],
                            [
                                114.73075,
                                45.43619
                            ],
                            [
                                114.53187,
                                45.37744
                            ],
                            [
                                114.51533,
                                45.29728
                            ],
                            [
                                114.45204,
                                45.21744
                            ],
                            [
                                114.31691,
                                45.11883
                            ],
                            [
                                114.16664,
                                45.03765
                            ],
                            [
                                114.13667,
                                44.98892
                            ],
                            [
                                114.04508,
                                44.93553
                            ],
                            [
                                113.8864,
                                44.91783
                            ],
                            [
                                113.84509,
                                44.86753
                            ],
                            [
                                113.75377,
                                44.8414
                            ],
                            [
                                113.6178,
                                44.74392
                            ],
                            [
                                113.49686,
                                44.77793
                            ],
                            [
                                113.11845,
                                44.7931
                            ],
                            [
                                112.94819,
                                44.83975
                            ],
                            [
                                112.86306,
                                44.83747
                            ],
                            [
                                112.70995,
                                44.88204
                            ],
                            [
                                112.59924,
                                44.93102
                            ],
                            [
                                112.42505,
                                45.08844
                            ],
                            [
                                112.31919,
                                45.06052
                            ],
                            [
                                112.11437,
                                45.07521
                            ],
                            [
                                112.05307,
                                45.10048
                            ],
                            [
                                111.95827,
                                45.08272
                            ],
                            [
                                111.78498,
                                44.98815
                            ],
                            [
                                111.74363,
                                44.94714
                            ],
                            [
                                111.56268,
                                44.6704
                            ],
                            [
                                111.56663,
                                44.57466
                            ],
                            [
                                111.53408,
                                44.55881
                            ],
                            [
                                111.42287,
                                44.39848
                            ],
                            [
                                111.41153,
                                44.34785
                            ],
                            [
                                111.51522,
                                44.27372
                            ],
                            [
                                111.53872,
                                44.19225
                            ],
                            [
                                111.60061,
                                44.1117
                            ],
                            [
                                111.70944,
                                44.02818
                            ],
                            [
                                111.8044,
                                43.98083
                            ],
                            [
                                111.90577,
                                43.89051
                            ],
                            [
                                111.95245,
                                43.82191
                            ],
                            [
                                111.97077,
                                43.74
                            ],
                            [
                                111.919,
                                43.67811
                            ],
                            [
                                111.78886,
                                43.66494
                            ],
                            [
                                111.59282,
                                43.50348
                            ],
                            [
                                111.41965,
                                43.47855
                            ],
                            [
                                111.36025,
                                43.44028
                            ],
                            [
                                111.10558,
                                43.36697
                            ],
                            [
                                110.9684,
                                43.29168
                            ],
                            [
                                110.76229,
                                43.09448
                            ],
                            [
                                110.67087,
                                43.0271
                            ],
                            [
                                110.62892,
                                42.93829
                            ],
                            [
                                110.46419,
                                42.83178
                            ],
                            [
                                110.43057,
                                42.77689
                            ],
                            [
                                110.33946,
                                42.73382
                            ],
                            [
                                110.14304,
                                42.67769
                            ],
                            [
                                110.11045,
                                42.6394
                            ],
                            [
                                109.91322,
                                42.63424
                            ],
                            [
                                109.67849,
                                42.55491
                            ],
                            [
                                109.53026,
                                42.46372
                            ],
                            [
                                109.30876,
                                42.43559
                            ],
                            [
                                109.0214,
                                42.45488
                            ],
                            [
                                108.85995,
                                42.39678
                            ],
                            [
                                108.53903,
                                42.44
                            ],
                            [
                                108.29184,
                                42.4389
                            ],
                            [
                                108.24042,
                                42.45713
                            ],
                            [
                                108.01616,
                                42.43526
                            ],
                            [
                                107.93262,
                                42.4021
                            ],
                            [
                                107.59727,
                                42.41237
                            ],
                            [
                                107.44421,
                                42.45458
                            ],
                            [
                                107.28726,
                                42.41125
                            ],
                            [
                                107.24432,
                                42.36202
                            ],
                            [
                                107.04064,
                                42.31861
                            ],
                            [
                                106.76758,
                                42.29179
                            ],
                            [
                                106.34232,
                                42.16476
                            ],
                            [
                                106.05127,
                                42.05815
                            ],
                            [
                                105.69879,
                                41.94293
                            ],
                            [
                                105.27544,
                                41.75258
                            ],
                            [
                                105.20796,
                                41.7498
                            ],
                            [
                                104.98484,
                                41.5873
                            ],
                            [
                                104.91387,
                                41.662
                            ],
                            [
                                104.66565,
                                41.64292
                            ],
                            [
                                104.5189,
                                41.66783
                            ],
                            [
                                104.51566,
                                41.87928
                            ],
                            [
                                104.07021,
                                41.80125
                            ],
                            [
                                103.85586,
                                41.79885
                            ],
                            [
                                103.41681,
                                41.88088
                            ],
                            [
                                103.01922,
                                42.02335
                            ],
                            [
                                102.71888,
                                42.15538
                            ],
                            [
                                102.62273,
                                42.14786
                            ],
                            [
                                102.53171,
                                42.16796
                            ],
                            [
                                102.46806,
                                42.1453
                            ],
                            [
                                102.07115,
                                42.23327
                            ],
                            [
                                101.79759,
                                42.50648
                            ],
                            [
                                101.58462,
                                42.52352
                            ],
                            [
                                100.84091,
                                42.67417
                            ],
                            [
                                100.3174,
                                42.69041
                            ],
                            [
                                100.26974,
                                42.64024
                            ],
                            [
                                99.97809,
                                42.65149
                            ],
                            [
                                99.50352,
                                42.56604
                            ],
                            [
                                98.98998,
                                42.60047
                            ],
                            [
                                98.1968,
                                42.65361
                            ],
                            [
                                97.19016,
                                42.79646
                            ],
                            [
                                97.02158,
                                42.76632
                            ],
                            [
                                96.71868,
                                42.76425
                            ],
                            [
                                96.40052,
                                42.73553
                            ],
                            [
                                96.38049,
                                42.90596
                            ],
                            [
                                95.91896,
                                43.2515
                            ],
                            [
                                95.86784,
                                43.39627
                            ],
                            [
                                95.75587,
                                43.57412
                            ],
                            [
                                95.64345,
                                43.77996
                            ],
                            [
                                95.62924,
                                43.8596
                            ],
                            [
                                95.53687,
                                44.00178
                            ],
                            [
                                95.33934,
                                44.03855
                            ],
                            [
                                95.36739,
                                44.22772
                            ],
                            [
                                95.41272,
                                44.30431
                            ],
                            [
                                95.009,
                                44.26483
                            ],
                            [
                                94.94523,
                                44.30683
                            ],
                            [
                                94.73921,
                                44.34888
                            ],
                            [
                                94.61612,
                                44.45678
                            ],
                            [
                                94.41155,
                                44.53781
                            ],
                            [
                                94.2134,
                                44.68686
                            ],
                            [
                                94.08359,
                                44.74946
                            ],
                            [
                                93.75151,
                                44.87561
                            ],
                            [
                                93.55542,
                                44.96773
                            ],
                            [
                                93.44315,
                                44.96917
                            ],
                            [
                                93.35513,
                                45.00637
                            ],
                            [
                                92.78912,
                                45.05438
                            ],
                            [
                                92.48726,
                                45.01311
                            ],
                            [
                                92.2379,
                                45.03701
                            ],
                            [
                                92.1089,
                                45.09765
                            ],
                            [
                                91.85933,
                                45.10026
                            ],
                            [
                                91.70654,
                                45.07824
                            ],
                            [
                                91.55424,
                                45.10872
                            ],
                            [
                                91.47467,
                                45.16169
                            ],
                            [
                                91.41893,
                                45.1264
                            ],
                            [
                                91.28644,
                                45.13954
                            ],
                            [
                                91.16816,
                                45.20805
                            ],
                            [
                                90.89472,
                                45.20146
                            ],
                            [
                                90.91417,
                                45.25336
                            ],
                            [
                                90.82604,
                                45.32455
                            ],
                            [
                                90.77253,
                                45.40535
                            ],
                            [
                                90.67133,
                                45.50785
                            ],
                            [
                                90.68687,
                                45.61673
                            ],
                            [
                                90.73133,
                                45.73356
                            ],
                            [
                                90.87753,
                                45.90892
                            ],
                            [
                                91.03193,
                                46.01254
                            ],
                            [
                                91.01978,
                                46.12725
                            ],
                            [
                                90.97226,
                                46.1644
                            ],
                            [
                                90.89883,
                                46.29008
                            ],
                            [
                                90.96354,
                                46.34206
                            ],
                            [
                                91.06695,
                                46.56647
                            ],
                            [
                                91.00841,
                                46.57546
                            ],
                            [
                                91.04607,
                                46.70843
                            ],
                            [
                                90.94094,
                                46.81914
                            ],
                            [
                                90.91626,
                                46.93213
                            ],
                            [
                                90.76499,
                                46.98546
                            ],
                            [
                                90.53176,
                                47.20576
                            ],
                            [
                                90.47302,
                                47.30803
                            ],
                            [
                                90.50679,
                                47.36536
                            ],
                            [
                                90.44817,
                                47.40415
                            ],
                            [
                                90.46395,
                                47.48116
                            ],
                            [
                                90.33754,
                                47.6059
                            ],
                            [
                                90.34382,
                                47.64857
                            ],
                            [
                                90.24884,
                                47.69729
                            ],
                            [
                                90.12904,
                                47.70806
                            ],
                            [
                                90.0648,
                                47.78169
                            ],
                            [
                                90.07821,
                                47.83697
                            ],
                            [
                                89.98213,
                                47.89148
                            ],
                            [
                                89.85092,
                                47.81819
                            ],
                            [
                                89.74758,
                                47.82376
                            ],
                            [
                                89.70782,
                                47.89477
                            ],
                            [
                                89.64401,
                                47.89646
                            ],
                            [
                                89.57552,
                                47.96082
                            ],
                            [
                                89.59643,
                                48.00867
                            ],
                            [
                                89.48047,
                                48.01303
                            ],
                            [
                                89.38107,
                                48.04018
                            ],
                            [
                                89.21359,
                                47.9724
                            ],
                            [
                                89.06976,
                                47.9744
                            ],
                            [
                                88.91092,
                                48.10866
                            ],
                            [
                                88.78943,
                                48.10988
                            ],
                            [
                                88.62602,
                                48.1717
                            ],
                            [
                                88.56649,
                                48.2819
                            ],
                            [
                                88.59501,
                                48.33624
                            ],
                            [
                                88.49441,
                                48.40691
                            ],
                            [
                                88.4467,
                                48.38509
                            ],
                            [
                                88.34443,
                                48.46523
                            ],
                            [
                                88.17489,
                                48.50152
                            ],
                            [
                                87.98216,
                                48.57424
                            ],
                            [
                                87.96535,
                                48.60405
                            ],
                            [
                                88.07142,
                                48.68958
                            ],
                            [
                                88.02514,
                                48.75454
                            ],
                            [
                                87.91799,
                                48.7751
                            ],
                            [
                                87.76477,
                                48.87763
                            ],
                            [
                                87.79046,
                                48.94046
                            ],
                            [
                                87.90867,
                                48.99666
                            ],
                            [
                                87.88199,
                                49.10613
                            ],
                            [
                                87.82497,
                                49.18332
                            ],
                            [
                                87.66824,
                                49.1538
                            ],
                            [
                                87.52915,
                                49.14487
                            ],
                            [
                                87.43458,
                                49.0727
                            ],
                            [
                                87.31258,
                                49.09969
                            ],
                            [
                                87.13495,
                                49.15043
                            ],
                            [
                                86.9879,
                                49.10373
                            ],
                            [
                                86.85552,
                                49.10749
                            ],
                            [
                                86.82941,
                                49.05094
                            ],
                            [
                                86.75318,
                                49.01834
                            ],
                            [
                                86.73786,
                                48.90791
                            ],
                            [
                                86.80974,
                                48.85084
                            ],
                            [
                                86.74772,
                                48.77183
                            ],
                            [
                                86.76353,
                                48.71619
                            ],
                            [
                                86.63428,
                                48.62418
                            ],
                            [
                                86.58728,
                                48.54264
                            ],
                            [
                                86.43438,
                                48.49502
                            ],
                            [
                                86.31711,
                                48.50051
                            ],
                            [
                                86.21454,
                                48.43575
                            ],
                            [
                                86.01548,
                                48.44912
                            ],
                            [
                                85.84355,
                                48.42634
                            ],
                            [
                                85.73714,
                                48.37185
                            ],
                            [
                                85.61102,
                                48.15772
                            ],
                            [
                                85.61147,
                                48.08223
                            ],
                            [
                                85.54172,
                                47.94135
                            ],
                            [
                                85.62089,
                                47.60944
                            ],
                            [
                                85.60383,
                                47.51948
                            ],
                            [
                                85.7066,
                                47.37789
                            ],
                            [
                                85.69119,
                                47.21903
                            ],
                            [
                                85.57777,
                                47.19177
                            ],
                            [
                                85.52909,
                                47.06001
                            ],
                            [
                                85.21824,
                                47.04958
                            ],
                            [
                                85.18876,
                                47.0059
                            ],
                            [
                                84.96148,
                                46.87135
                            ],
                            [
                                84.80551,
                                46.82695
                            ],
                            [
                                84.705,
                                46.83433
                            ],
                            [
                                84.78485,
                                46.90803
                            ],
                            [
                                84.7045,
                                46.99602
                            ],
                            [
                                84.50699,
                                46.97819
                            ],
                            [
                                84.42191,
                                47.01074
                            ],
                            [
                                84.19882,
                                46.99825
                            ],
                            [
                                84.03973,
                                46.96537
                            ],
                            [
                                83.5574,
                                47.06753
                            ],
                            [
                                83.45942,
                                47.13111
                            ],
                            [
                                83.34072,
                                47.17611
                            ],
                            [
                                83.23521,
                                47.18124
                            ],
                            [
                                83.177,
                                47.22293
                            ],
                            [
                                83.05176,
                                47.22182
                            ],
                            [
                                83.02279,
                                47.1919
                            ],
                            [
                                82.99334,
                                47.05531
                            ],
                            [
                                82.93593,
                                47.01081
                            ],
                            [
                                82.88981,
                                46.87618
                            ],
                            [
                                82.80659,
                                46.74779
                            ],
                            [
                                82.73855,
                                46.51682
                            ],
                            [
                                82.57881,
                                46.28214
                            ],
                            [
                                82.52936,
                                46.18451
                            ],
                            [
                                82.50416,
                                45.98322
                            ],
                            [
                                82.41841,
                                45.86561
                            ],
                            [
                                82.28904,
                                45.63177
                            ],
                            [
                                82.27542,
                                45.54657
                            ],
                            [
                                82.43196,
                                45.4683
                            ],
                            [
                                82.58856,
                                45.44575
                            ],
                            [
                                82.63063,
                                45.36019
                            ],
                            [
                                82.59211,
                                45.23148
                            ],
                            [
                                82.48675,
                                45.12159
                            ],
                            [
                                82.32697,
                                45.21558
                            ],
                            [
                                82.23893,
                                45.23503
                            ],
                            [
                                82.11515,
                                45.20808
                            ],
                            [
                                82.03178,
                                45.16588
                            ],
                            [
                                81.92576,
                                45.1687
                            ],
                            [
                                81.81922,
                                45.20467
                            ],
                            [
                                81.78755,
                                45.30713
                            ],
                            [
                                81.69007,
                                45.36596
                            ],
                            [
                                81.45375,
                                45.26898
                            ],
                            [
                                81.10711,
                                45.21916
                            ],
                            [
                                81.07764,
                                45.17553
                            ],
                            [
                                80.95161,
                                45.16672
                            ],
                            [
                                80.85408,
                                45.12833
                            ],
                            [
                                80.75293,
                                45.1574
                            ],
                            [
                                80.60455,
                                45.11019
                            ],
                            [
                                80.44496,
                                45.10199
                            ],
                            [
                                80.37926,
                                45.04443
                            ],
                            [
                                80.29812,
                                45.06538
                            ],
                            [
                                80.17723,
                                45.02909
                            ],
                            [
                                80.08152,
                                45.049
                            ],
                            [
                                79.99434,
                                44.96877
                            ],
                            [
                                79.87533,
                                44.90923
                            ],
                            [
                                79.96036,
                                44.8784
                            ],
                            [
                                79.98983,
                                44.8172
                            ],
                            [
                                80.05499,
                                44.8017
                            ],
                            [
                                80.24595,
                                44.83876
                            ],
                            [
                                80.48226,
                                44.73239
                            ],
                            [
                                80.47879,
                                44.70215
                            ],
                            [
                                80.36128,
                                44.65581
                            ],
                            [
                                80.40332,
                                44.6086
                            ],
                            [
                                80.34356,
                                44.48096
                            ],
                            [
                                80.40083,
                                44.28608
                            ],
                            [
                                80.41728,
                                44.13036
                            ],
                            [
                                80.45462,
                                44.00327
                            ],
                            [
                                80.50604,
                                43.9203
                            ],
                            [
                                80.52004,
                                43.83411
                            ],
                            [
                                80.59023,
                                43.74103
                            ],
                            [
                                80.74535,
                                43.45971
                            ],
                            [
                                80.73415,
                                43.40701
                            ],
                            [
                                80.66172,
                                43.31408
                            ],
                            [
                                80.74334,
                                43.29781
                            ],
                            [
                                80.79944,
                                43.17674
                            ],
                            [
                                80.7223,
                                43.13276
                            ],
                            [
                                80.59379,
                                43.13181
                            ],
                            [
                                80.50291,
                                43.07724
                            ],
                            [
                                80.39022,
                                43.04128
                            ],
                            [
                                80.40388,
                                42.98627
                            ],
                            [
                                80.58951,
                                42.89731
                            ],
                            [
                                80.399,
                                42.82818
                            ],
                            [
                                80.25783,
                                42.82671
                            ],
                            [
                                80.21322,
                                42.69689
                            ],
                            [
                                80.16753,
                                42.6365
                            ],
                            [
                                80.22171,
                                42.53624
                            ],
                            [
                                80.20897,
                                42.42841
                            ],
                            [
                                80.22862,
                                42.35164
                            ],
                            [
                                80.27412,
                                42.32771
                            ],
                            [
                                80.28854,
                                42.25929
                            ],
                            [
                                80.24563,
                                42.22089
                            ],
                            [
                                80.2804,
                                42.05873
                            ],
                            [
                                80.12928,
                                42.03497
                            ],
                            [
                                80.032,
                                42.05135
                            ],
                            [
                                79.87946,
                                42.03723
                            ],
                            [
                                79.76778,
                                41.89192
                            ],
                            [
                                79.67044,
                                41.79037
                            ],
                            [
                                79.51324,
                                41.78634
                            ],
                            [
                                79.45207,
                                41.84898
                            ],
                            [
                                79.36055,
                                41.80179
                            ],
                            [
                                79.26539,
                                41.78464
                            ],
                            [
                                79.22681,
                                41.73901
                            ],
                            [
                                79.13621,
                                41.72362
                            ],
                            [
                                79.01039,
                                41.65814
                            ],
                            [
                                78.93626,
                                41.64498
                            ],
                            [
                                78.83505,
                                41.57509
                            ],
                            [
                                78.70656,
                                41.54966
                            ],
                            [
                                78.64348,
                                41.47212
                            ],
                            [
                                78.53378,
                                41.4565
                            ],
                            [
                                78.40337,
                                41.41297
                            ],
                            [
                                78.3842,
                                41.26989
                            ],
                            [
                                78.27322,
                                41.21387
                            ],
                            [
                                78.18825,
                                41.07804
                            ],
                            [
                                78.06025,
                                41.03418
                            ],
                            [
                                77.98484,
                                41.07676
                            ],
                            [
                                77.87615,
                                41.07237
                            ],
                            [
                                77.66604,
                                40.99991
                            ],
                            [
                                77.47135,
                                41.00158
                            ],
                            [
                                77.35955,
                                41.0324
                            ],
                            [
                                77.27109,
                                41.00747
                            ],
                            [
                                77.16704,
                                41.01606
                            ],
                            [
                                77.04755,
                                41.05923
                            ],
                            [
                                76.86567,
                                41.02095
                            ],
                            [
                                76.7856,
                                40.95818
                            ],
                            [
                                76.77847,
                                40.84415
                            ],
                            [
                                76.63472,
                                40.75707
                            ],
                            [
                                76.63848,
                                40.62218
                            ],
                            [
                                76.54012,
                                40.53648
                            ],
                            [
                                76.52253,
                                40.46507
                            ],
                            [
                                76.43629,
                                40.40144
                            ],
                            [
                                76.32487,
                                40.37247
                            ],
                            [
                                76.31024,
                                40.45253
                            ],
                            [
                                76.22138,
                                40.39788
                            ],
                            [
                                76.06727,
                                40.40281
                            ],
                            [
                                75.9604,
                                40.37074
                            ],
                            [
                                75.88269,
                                40.30765
                            ],
                            [
                                75.81626,
                                40.33377
                            ],
                            [
                                75.70315,
                                40.27951
                            ],
                            [
                                75.65024,
                                40.38962
                            ],
                            [
                                75.7127,
                                40.43619
                            ],
                            [
                                75.71329,
                                40.48656
                            ],
                            [
                                75.64195,
                                40.50796
                            ],
                            [
                                75.59291,
                                40.65703
                            ],
                            [
                                75.46298,
                                40.60944
                            ],
                            [
                                75.21647,
                                40.44153
                            ],
                            [
                                74.98842,
                                40.45135
                            ],
                            [
                                74.83907,
                                40.52163
                            ],
                            [
                                74.79129,
                                40.44587
                            ],
                            [
                                74.90309,
                                40.34964
                            ],
                            [
                                74.70276,
                                40.34482
                            ],
                            [
                                74.67712,
                                40.26536
                            ],
                            [
                                74.58277,
                                40.27197
                            ],
                            [
                                74.52644,
                                40.20738
                            ],
                            [
                                74.34285,
                                40.08643
                            ],
                            [
                                74.22407,
                                40.12286
                            ],
                            [
                                74.1065,
                                40.07922
                            ],
                            [
                                74.02619,
                                40.07952
                            ],
                            [
                                73.95562,
                                40.02877
                            ],
                            [
                                73.97748,
                                39.99596
                            ],
                            [
                                73.91334,
                                39.91651
                            ],
                            [
                                73.83239,
                                39.77254
                            ],
                            [
                                73.90969,
                                39.72539
                            ],
                            [
                                73.94031,
                                39.60661
                            ],
                            [
                                73.86311,
                                39.48017
                            ],
                            [
                                73.81392,
                                39.45899
                            ],
                            [
                                73.65824,
                                39.46508
                            ],
                            [
                                73.6698,
                                39.39065
                            ],
                            [
                                73.56731,
                                39.24017
                            ],
                            [
                                73.61747,
                                39.23655
                            ],
                            [
                                73.68344,
                                39.16685
                            ],
                            [
                                73.74504,
                                39.03096
                            ],
                            [
                                73.81892,
                                39.03301
                            ],
                            [
                                73.84544,
                                38.94864
                            ],
                            [
                                73.74711,
                                38.93261
                            ],
                            [
                                73.70724,
                                38.88604
                            ],
                            [
                                73.75587,
                                38.77864
                            ],
                            [
                                73.79041,
                                38.60509
                            ],
                            [
                                73.88105,
                                38.57781
                            ],
                            [
                                73.92438,
                                38.53649
                            ],
                            [
                                74.06891,
                                38.53125
                            ],
                            [
                                74.13286,
                                38.66786
                            ],
                            [
                                74.3416,
                                38.65516
                            ],
                            [
                                74.5065,
                                38.62941
                            ],
                            [
                                74.64295,
                                38.57818
                            ],
                            [
                                74.7172,
                                38.52314
                            ],
                            [
                                74.83824,
                                38.4857
                            ],
                            [
                                74.86931,
                                38.4053
                            ],
                            [
                                74.7875,
                                38.35397
                            ],
                            [
                                74.80196,
                                38.22482
                            ],
                            [
                                74.78638,
                                38.18404
                            ],
                            [
                                74.86042,
                                38.03057
                            ],
                            [
                                74.91402,
                                38.00942
                            ],
                            [
                                74.91353,
                                37.82973
                            ],
                            [
                                74.99337,
                                37.76178
                            ],
                            [
                                74.89673,
                                37.65826
                            ],
                            [
                                74.92878,
                                37.5562
                            ],
                            [
                                75.05475,
                                37.52716
                            ],
                            [
                                75.13345,
                                37.43759
                            ],
                            [
                                75.1012,
                                37.37335
                            ],
                            [
                                75.12349,
                                37.32782
                            ],
                            [
                                75.00396,
                                37.2911
                            ],
                            [
                                74.93372,
                                37.28884
                            ],
                            [
                                74.88986,
                                37.23409
                            ],
                            [
                                74.80962,
                                37.21517
                            ],
                            [
                                74.75011,
                                37.28346
                            ],
                            [
                                74.65997,
                                37.23514
                            ],
                            [
                                74.63089,
                                37.26356
                            ],
                            [
                                74.50229,
                                37.23938
                            ],
                            [
                                74.45663,
                                37.1424
                            ],
                            [
                                74.56463,
                                37.03085
                            ],
                            [
                                74.70569,
                                37.08477
                            ],
                            [
                                74.73893,
                                37.02782
                            ],
                            [
                                74.8415,
                                37.01457
                            ],
                            [
                                74.92496,
                                36.97541
                            ],
                            [
                                75.02982,
                                37.01667
                            ],
                            [
                                75.16792,
                                37.01407
                            ],
                            [
                                75.23486,
                                36.96506
                            ],
                            [
                                75.40434,
                                36.95635
                            ],
                            [
                                75.42658,
                                36.87334
                            ],
                            [
                                75.42068,
                                36.78559
                            ],
                            [
                                75.45518,
                                36.72204
                            ],
                            [
                                75.53548,
                                36.77303
                            ],
                            [
                                75.72122,
                                36.75047
                            ],
                            [
                                75.85528,
                                36.67178
                            ],
                            [
                                75.93977,
                                36.59996
                            ],
                            [
                                76.03132,
                                36.40814
                            ],
                            [
                                75.9892,
                                36.35383
                            ],
                            [
                                76.05252,
                                36.25253
                            ],
                            [
                                76.01299,
                                36.1669
                            ],
                            [
                                75.94074,
                                36.1386
                            ],
                            [
                                75.98246,
                                36.03091
                            ],
                            [
                                76.10013,
                                36.0195
                            ],
                            [
                                76.16026,
                                35.91579
                            ],
                            [
                                76.17257,
                                35.82311
                            ],
                            [
                                76.29012,
                                35.84192
                            ],
                            [
                                76.36075,
                                35.82585
                            ],
                            [
                                76.54781,
                                35.92051
                            ],
                            [
                                76.59432,
                                35.89643
                            ],
                            [
                                76.56445,
                                35.81927
                            ],
                            [
                                76.59179,
                                35.77307
                            ],
                            [
                                76.68988,
                                35.7482
                            ],
                            [
                                76.75968,
                                35.6568
                            ],
                            [
                                76.84682,
                                35.66815
                            ],
                            [
                                76.95541,
                                35.59387
                            ],
                            [
                                76.99806,
                                35.61172
                            ],
                            [
                                77.19353,
                                35.52026
                            ],
                            [
                                77.30636,
                                35.54061
                            ],
                            [
                                77.39486,
                                35.46879
                            ],
                            [
                                77.51561,
                                35.48268
                            ],
                            [
                                77.69007,
                                35.44961
                            ],
                            [
                                77.81381,
                                35.51865
                            ],
                            [
                                77.85326,
                                35.48962
                            ],
                            [
                                77.91373,
                                35.46861
                            ],
                            [
                                78.00638,
                                35.49209
                            ],
                            [
                                78.13445,
                                35.49538
                            ],
                            [
                                78.10351,
                                35.43737
                            ],
                            [
                                78.01143,
                                35.36638
                            ],
                            [
                                78.01206,
                                35.23813
                            ],
                            [
                                78.05682,
                                35.18288
                            ],
                            [
                                78.0601,
                                35.11695
                            ],
                            [
                                78.12041,
                                35.10892
                            ],
                            [
                                78.12138,
                                35.03706
                            ],
                            [
                                78.18879,
                                34.98351
                            ],
                            [
                                78.18056,
                                34.93874
                            ],
                            [
                                78.23549,
                                34.88079
                            ],
                            [
                                78.21336,
                                34.71857
                            ],
                            [
                                78.25658,
                                34.71173
                            ],
                            [
                                78.28302,
                                34.62272
                            ],
                            [
                                78.54066,
                                34.57618
                            ],
                            [
                                78.56101,
                                34.51657
                            ],
                            [
                                78.64813,
                                34.53908
                            ],
                            [
                                78.70688,
                                34.52325
                            ],
                            [
                                78.74311,
                                34.45456
                            ],
                            [
                                78.85274,
                                34.41395
                            ],
                            [
                                78.88063,
                                34.36389
                            ],
                            [
                                78.95592,
                                34.38783
                            ],
                            [
                                78.98208,
                                34.32017
                            ],
                            [
                                78.92386,
                                34.15806
                            ],
                            [
                                78.8763,
                                34.16445
                            ],
                            [
                                78.73304,
                                34.09169
                            ],
                            [
                                78.66041,
                                34.08899
                            ],
                            [
                                78.65354,
                                34.03384
                            ],
                            [
                                78.74338,
                                33.98475
                            ],
                            [
                                78.75949,
                                33.91157
                            ],
                            [
                                78.7563,
                                33.79131
                            ],
                            [
                                78.77811,
                                33.7382
                            ],
                            [
                                78.69014,
                                33.67831
                            ],
                            [
                                78.73884,
                                33.55817
                            ],
                            [
                                78.81345,
                                33.48481
                            ],
                            [
                                78.83985,
                                33.42786
                            ],
                            [
                                78.94793,
                                33.37869
                            ],
                            [
                                79.03365,
                                33.31298
                            ],
                            [
                                79.07612,
                                33.22384
                            ],
                            [
                                79.14666,
                                33.18827
                            ],
                            [
                                79.37734,
                                33.1899
                            ],
                            [
                                79.41071,
                                33.13563
                            ],
                            [
                                79.36617,
                                33.05977
                            ],
                            [
                                79.36507,
                                32.95691
                            ],
                            [
                                79.45693,
                                32.87155
                            ],
                            [
                                79.46451,
                                32.81688
                            ],
                            [
                                79.54056,
                                32.74859
                            ],
                            [
                                79.56425,
                                32.67093
                            ],
                            [
                                79.54525,
                                32.60732
                            ],
                            [
                                79.46433,
                                32.59265
                            ],
                            [
                                79.34723,
                                32.52681
                            ],
                            [
                                79.18984,
                                32.51384
                            ],
                            [
                                79.13367,
                                32.47415
                            ],
                            [
                                79.08927,
                                32.37306
                            ],
                            [
                                79.0045,
                                32.37767
                            ],
                            [
                                78.96913,
                                32.33524
                            ],
                            [
                                78.80829,
                                32.44
                            ],
                            [
                                78.75873,
                                32.56603
                            ],
                            [
                                78.77916,
                                32.60969
                            ],
                            [
                                78.68472,
                                32.68228
                            ],
                            [
                                78.62617,
                                32.63346
                            ],
                            [
                                78.51745,
                                32.60876
                            ],
                            [
                                78.39431,
                                32.53748
                            ],
                            [
                                78.46899,
                                32.44091
                            ],
                            [
                                78.45847,
                                32.38209
                            ],
                            [
                                78.50527,
                                32.29939
                            ],
                            [
                                78.47358,
                                32.23952
                            ],
                            [
                                78.54612,
                                32.20865
                            ],
                            [
                                78.60857,
                                32.13454
                            ],
                            [
                                78.67138,
                                32.12023
                            ],
                            [
                                78.70111,
                                32.02592
                            ],
                            [
                                78.77496,
                                31.98584
                            ],
                            [
                                78.69747,
                                31.77417
                            ],
                            [
                                78.75742,
                                31.67521
                            ],
                            [
                                78.8419,
                                31.61403
                            ],
                            [
                                78.73843,
                                31.53468
                            ],
                            [
                                78.78879,
                                31.4374
                            ],
                            [
                                78.75219,
                                31.36724
                            ],
                            [
                                78.78203,
                                31.31402
                            ],
                            [
                                78.88294,
                                31.28031
                            ],
                            [
                                78.93674,
                                31.35733
                            ],
                            [
                                79.07261,
                                31.45384
                            ],
                            [
                                79.22593,
                                31.32943
                            ],
                            [
                                79.23148,
                                31.27215
                            ],
                            [
                                79.29688,
                                31.2124
                            ],
                            [
                                79.31757,
                                31.1296
                            ],
                            [
                                79.39033,
                                31.11499
                            ],
                            [
                                79.42539,
                                31.02128
                            ],
                            [
                                79.49954,
                                31.03282
                            ],
                            [
                                79.58991,
                                30.94335
                            ],
                            [
                                79.76019,
                                30.99702
                            ],
                            [
                                79.88038,
                                30.96952
                            ],
                            [
                                79.93429,
                                30.88495
                            ],
                            [
                                79.99197,
                                30.87962
                            ],
                            [
                                80.04525,
                                30.81296
                            ],
                            [
                                80.13902,
                                30.78442
                            ],
                            [
                                80.19455,
                                30.79827
                            ],
                            [
                                80.25455,
                                30.71758
                            ],
                            [
                                80.19283,
                                30.67426
                            ],
                            [
                                80.21762,
                                30.58303
                            ],
                            [
                                80.2728,
                                30.55433
                            ],
                            [
                                80.33772,
                                30.56597
                            ],
                            [
                                80.39173,
                                30.51697
                            ],
                            [
                                80.45042,
                                30.51067
                            ],
                            [
                                80.53833,
                                30.44661
                            ],
                            [
                                80.63141,
                                30.46161
                            ],
                            [
                                80.74078,
                                30.40019
                            ],
                            [
                                80.8159,
                                30.32426
                            ],
                            [
                                80.91021,
                                30.30518
                            ],
                            [
                                80.93168,
                                30.27022
                            ],
                            [
                                81.03142,
                                30.24945
                            ],
                            [
                                81.03692,
                                30.20276
                            ],
                            [
                                81.08057,
                                30.15108
                            ],
                            [
                                81.09701,
                                30.05094
                            ],
                            [
                                81.13146,
                                30.01886
                            ],
                            [
                                81.22605,
                                30.00953
                            ],
                            [
                                81.33199,
                                30.1561
                            ],
                            [
                                81.39477,
                                30.20938
                            ],
                            [
                                81.41595,
                                30.27557
                            ],
                            [
                                81.39789,
                                30.32482
                            ],
                            [
                                81.41614,
                                30.42206
                            ],
                            [
                                81.55058,
                                30.37335
                            ],
                            [
                                81.56417,
                                30.43032
                            ],
                            [
                                81.6295,
                                30.44776
                            ],
                            [
                                81.75055,
                                30.39066
                            ],
                            [
                                81.86718,
                                30.37546
                            ],
                            [
                                81.99337,
                                30.32547
                            ],
                            [
                                82.07885,
                                30.35374
                            ],
                            [
                                82.12777,
                                30.30765
                            ],
                            [
                                82.10819,
                                30.23483
                            ],
                            [
                                82.20469,
                                30.15416
                            ],
                            [
                                82.17616,
                                30.07222
                            ],
                            [
                                82.24629,
                                30.07308
                            ],
                            [
                                82.50775,
                                29.95172
                            ],
                            [
                                82.55601,
                                29.95888
                            ],
                            [
                                82.6455,
                                29.83496
                            ],
                            [
                                82.70503,
                                29.84736
                            ],
                            [
                                82.76966,
                                29.73285
                            ],
                            [
                                82.82927,
                                29.69197
                            ],
                            [
                                82.94217,
                                29.70995
                            ],
                            [
                                83.08015,
                                29.60989
                            ],
                            [
                                83.12261,
                                29.62486
                            ],
                            [
                                83.26425,
                                29.57274
                            ],
                            [
                                83.27522,
                                29.50948
                            ],
                            [
                                83.32283,
                                29.50387
                            ],
                            [
                                83.46799,
                                29.28527
                            ],
                            [
                                83.52457,
                                29.22497
                            ],
                            [
                                83.63266,
                                29.1686
                            ],
                            [
                                83.71431,
                                29.2414
                            ],
                            [
                                83.7934,
                                29.25236
                            ],
                            [
                                83.82047,
                                29.29765
                            ],
                            [
                                83.91127,
                                29.32597
                            ],
                            [
                                83.99893,
                                29.29877
                            ],
                            [
                                84.103,
                                29.29472
                            ],
                            [
                                84.20217,
                                29.12116
                            ],
                            [
                                84.19063,
                                29.05294
                            ],
                            [
                                84.24609,
                                29.02809
                            ],
                            [
                                84.22563,
                                28.90258
                            ],
                            [
                                84.38175,
                                28.86376
                            ],
                            [
                                84.43145,
                                28.81951
                            ],
                            [
                                84.42096,
                                28.74032
                            ],
                            [
                                84.51342,
                                28.71935
                            ],
                            [
                                84.59896,
                                28.73564
                            ],
                            [
                                84.69621,
                                28.67197
                            ],
                            [
                                84.70166,
                                28.6356
                            ],
                            [
                                84.85378,
                                28.57455
                            ],
                            [
                                84.98678,
                                28.59795
                            ],
                            [
                                85.05808,
                                28.67606
                            ],
                            [
                                85.11638,
                                28.68107
                            ],
                            [
                                85.19237,
                                28.62083
                            ],
                            [
                                85.18545,
                                28.54825
                            ],
                            [
                                85.10815,
                                28.46589
                            ],
                            [
                                85.12415,
                                28.33703
                            ],
                            [
                                85.20708,
                                28.33645
                            ],
                            [
                                85.24506,
                                28.28921
                            ],
                            [
                                85.37899,
                                28.28707
                            ],
                            [
                                85.42305,
                                28.33075
                            ],
                            [
                                85.49725,
                                28.33704
                            ],
                            [
                                85.64613,
                                28.28667
                            ],
                            [
                                85.68356,
                                28.37685
                            ],
                            [
                                85.72378,
                                28.35511
                            ],
                            [
                                85.75413,
                                28.22924
                            ],
                            [
                                85.84964,
                                28.17627
                            ],
                            [
                                85.90238,
                                28.05492
                            ],
                            [
                                85.97096,
                                27.99499
                            ],
                            [
                                85.95141,
                                27.94127
                            ],
                            [
                                86.04232,
                                27.9031
                            ],
                            [
                                86.12114,
                                27.93256
                            ],
                            [
                                86.08312,
                                28.01552
                            ],
                            [
                                86.08237,
                                28.08526
                            ],
                            [
                                86.17561,
                                28.15365
                            ],
                            [
                                86.20882,
                                28.10054
                            ],
                            [
                                86.20518,
                                28.01094
                            ],
                            [
                                86.23716,
                                27.97933
                            ],
                            [
                                86.4502,
                                27.91571
                            ],
                            [
                                86.51206,
                                27.96134
                            ],
                            [
                                86.56661,
                                28.10084
                            ],
                            [
                                86.64494,
                                28.07482
                            ],
                            [
                                86.70718,
                                28.1035
                            ],
                            [
                                86.78418,
                                28.02574
                            ],
                            [
                                86.85978,
                                28.02443
                            ],
                            [
                                86.93646,
                                27.96023
                            ],
                            [
                                87.03496,
                                27.94683
                            ],
                            [
                                87.11905,
                                27.84265
                            ],
                            [
                                87.2235,
                                27.81908
                            ],
                            [
                                87.29195,
                                27.84432
                            ],
                            [
                                87.35394,
                                27.82771
                            ],
                            [
                                87.42144,
                                27.86075
                            ],
                            [
                                87.45366,
                                27.82569
                            ],
                            [
                                87.565,
                                27.8658
                            ],
                            [
                                87.72171,
                                27.8083
                            ],
                            [
                                87.83413,
                                27.94953
                            ],
                            [
                                87.88091,
                                27.91292
                            ],
                            [
                                87.97995,
                                27.89006
                            ],
                            [
                                88.03365,
                                27.90253
                            ],
                            [
                                88.13508,
                                27.88193
                            ],
                            [
                                88.15407,
                                27.96128
                            ],
                            [
                                88.25576,
                                27.94429
                            ],
                            [
                                88.35519,
                                27.98952
                            ],
                            [
                                88.39919,
                                27.98041
                            ],
                            [
                                88.56198,
                                28.0815
                            ],
                            [
                                88.64477,
                                28.11288
                            ],
                            [
                                88.67498,
                                28.07221
                            ],
                            [
                                88.75996,
                                28.07253
                            ],
                            [
                                88.84291,
                                27.99999
                            ],
                            [
                                88.84159,
                                27.92713
                            ],
                            [
                                88.88617,
                                27.85582
                            ],
                            [
                                88.86035,
                                27.81228
                            ],
                            [
                                88.84951,
                                27.67559
                            ],
                            [
                                88.79023,
                                27.57714
                            ],
                            [
                                88.78116,
                                27.46964
                            ],
                            [
                                88.83654,
                                27.38221
                            ],
                            [
                                88.89969,
                                27.33152
                            ],
                            [
                                88.92332,
                                27.27284
                            ],
                            [
                                88.97992,
                                27.21501
                            ],
                            [
                                89.05222,
                                27.2376
                            ],
                            [
                                89.07324,
                                27.288
                            ],
                            [
                                89.14985,
                                27.32355
                            ],
                            [
                                89.17921,
                                27.37718
                            ],
                            [
                                89.09392,
                                27.47688
                            ],
                            [
                                89.10308,
                                27.53746
                            ],
                            [
                                89.15896,
                                27.57659
                            ],
                            [
                                89.12968,
                                27.63538
                            ],
                            [
                                89.22486,
                                27.73104
                            ],
                            [
                                89.23618,
                                27.79879
                            ],
                            [
                                89.29636,
                                27.85284
                            ],
                            [
                                89.36569,
                                27.87367
                            ],
                            [
                                89.43615,
                                27.96382
                            ],
                            [
                                89.4611,
                                28.03611
                            ],
                            [
                                89.60406,
                                28.16471
                            ],
                            [
                                89.72492,
                                28.17502
                            ],
                            [
                                89.79684,
                                28.2476
                            ],
                            [
                                89.90187,
                                28.18593
                            ],
                            [
                                89.97936,
                                28.18997
                            ],
                            [
                                90.02664,
                                28.14529
                            ],
                            [
                                90.12645,
                                28.19369
                            ],
                            [
                                90.22213,
                                28.14976
                            ],
                            [
                                90.29267,
                                28.15723
                            ],
                            [
                                90.37745,
                                28.06641
                            ],
                            [
                                90.51409,
                                28.06462
                            ],
                            [
                                90.59243,
                                28.02647
                            ],
                            [
                                90.70003,
                                28.07905
                            ],
                            [
                                90.80247,
                                28.03894
                            ],
                            [
                                90.84608,
                                27.97328
                            ],
                            [
                                90.96197,
                                27.95472
                            ],
                            [
                                90.96376,
                                27.9054
                            ],
                            [
                                91.03525,
                                27.85792
                            ],
                            [
                                91.11143,
                                27.85284
                            ],
                            [
                                91.14824,
                                27.89271
                            ],
                            [
                                91.1639,
                                27.97058
                            ],
                            [
                                91.25302,
                                27.97631
                            ],
                            [
                                91.31026,
                                28.06138
                            ],
                            [
                                91.46242,
                                28.00566
                            ],
                            [
                                91.48548,
                                27.94254
                            ],
                            [
                                91.61045,
                                27.89439
                            ],
                            [
                                91.64209,
                                27.75846
                            ],
                            [
                                91.82399,
                                27.76664
                            ],
                            [
                                91.89436,
                                27.72231
                            ],
                            [
                                92.03837,
                                27.74268
                            ],
                            [
                                92.10471,
                                27.80067
                            ],
                            [
                                92.28166,
                                27.871
                            ],
                            [
                                92.30799,
                                27.80932
                            ],
                            [
                                92.45541,
                                27.82719
                            ],
                            [
                                92.57287,
                                27.87582
                            ],
                            [
                                92.70417,
                                27.948
                            ],
                            [
                                92.72268,
                                28.02049
                            ],
                            [
                                92.66995,
                                28.07386
                            ],
                            [
                                92.74662,
                                28.15984
                            ],
                            [
                                92.86551,
                                28.18421
                            ],
                            [
                                92.95559,
                                28.26116
                            ],
                            [
                                93.01477,
                                28.26284
                            ],
                            [
                                93.0297,
                                28.32102
                            ],
                            [
                                93.12187,
                                28.35737
                            ],
                            [
                                93.23179,
                                28.37069
                            ],
                            [
                                93.2443,
                                28.44924
                            ],
                            [
                                93.2216,
                                28.52631
                            ],
                            [
                                93.30036,
                                28.63592
                            ],
                            [
                                93.34659,
                                28.66035
                            ],
                            [
                                93.56519,
                                28.68547
                            ],
                            [
                                93.67338,
                                28.67493
                            ],
                            [
                                93.76612,
                                28.70837
                            ],
                            [
                                93.82433,
                                28.762
                            ],
                            [
                                93.92704,
                                28.76721
                            ],
                            [
                                93.93361,
                                28.83098
                            ],
                            [
                                94.05589,
                                28.87667
                            ],
                            [
                                94.03419,
                                28.96501
                            ],
                            [
                                94.12418,
                                28.95661
                            ],
                            [
                                94.27782,
                                29.13028
                            ],
                            [
                                94.36244,
                                29.1481
                            ],
                            [
                                94.42429,
                                29.21347
                            ],
                            [
                                94.55268,
                                29.22957
                            ],
                            [
                                94.62329,
                                29.2934
                            ],
                            [
                                94.68131,
                                29.31159
                            ],
                            [
                                94.72718,
                                29.28441
                            ],
                            [
                                94.79726,
                                29.17535
                            ],
                            [
                                94.91232,
                                29.15909
                            ],
                            [
                                95.00531,
                                29.16584
                            ],
                            [
                                95.09704,
                                29.14125
                            ],
                            [
                                95.12328,
                                29.09056
                            ],
                            [
                                95.21375,
                                29.10826
                            ],
                            [
                                95.2606,
                                29.07352
                            ],
                            [
                                95.29948,
                                29.13825
                            ],
                            [
                                95.38474,
                                29.1369
                            ],
                            [
                                95.41777,
                                29.17547
                            ],
                            [
                                95.50356,
                                29.13262
                            ],
                            [
                                95.56417,
                                29.17712
                            ],
                            [
                                95.68694,
                                29.2273
                            ],
                            [
                                95.75847,
                                29.31807
                            ],
                            [
                                95.84514,
                                29.3183
                            ],
                            [
                                95.99868,
                                29.36712
                            ],
                            [
                                96.06102,
                                29.44876
                            ],
                            [
                                96.10791,
                                29.44727
                            ],
                            [
                                96.17964,
                                29.35555
                            ],
                            [
                                96.19103,
                                29.30489
                            ],
                            [
                                96.25185,
                                29.23627
                            ],
                            [
                                96.37529,
                                29.28241
                            ],
                            [
                                96.39625,
                                29.25094
                            ],
                            [
                                96.3443,
                                29.17386
                            ],
                            [
                                96.25688,
                                29.16524
                            ],
                            [
                                96.19881,
                                29.09444
                            ],
                            [
                                96.13124,
                                29.08156
                            ],
                            [
                                96.19223,
                                28.9875
                            ],
                            [
                                96.15559,
                                28.95354
                            ],
                            [
                                96.18907,
                                28.90104
                            ],
                            [
                                96.35213,
                                29.03598
                            ],
                            [
                                96.44292,
                                29.03903
                            ],
                            [
                                96.54114,
                                28.91652
                            ],
                            [
                                96.54305,
                                28.87797
                            ],
                            [
                                96.62241,
                                28.77916
                            ],
                            [
                                96.60385,
                                28.72748
                            ],
                            [
                                96.53255,
                                28.71395
                            ],
                            [
                                96.4884,
                                28.62892
                            ],
                            [
                                96.33538,
                                28.51862
                            ],
                            [
                                96.36709,
                                28.47757
                            ],
                            [
                                96.27872,
                                28.41518
                            ],
                            [
                                96.4282,
                                28.34937
                            ],
                            [
                                96.46201,
                                28.41387
                            ],
                            [
                                96.58028,
                                28.45588
                            ],
                            [
                                96.66981,
                                28.45223
                            ],
                            [
                                96.75565,
                                28.40341
                            ],
                            [
                                96.76501,
                                28.37057
                            ],
                            [
                                97.02477,
                                28.32179
                            ],
                            [
                                97.08993,
                                28.36782
                            ],
                            [
                                97.15703,
                                28.33697
                            ],
                            [
                                97.34711,
                                28.20807
                            ],
                            [
                                97.50797,
                                28.30341
                            ],
                            [
                                97.49324,
                                28.36561
                            ],
                            [
                                97.5381,
                                28.52248
                            ],
                            [
                                97.65948,
                                28.53939
                            ],
                            [
                                97.72138,
                                28.49529
                            ],
                            [
                                97.73677,
                                28.39929
                            ],
                            [
                                97.79777,
                                28.33109
                            ],
                            [
                                97.90927,
                                28.36675
                            ],
                            [
                                97.95377,
                                28.30534
                            ],
                            [
                                98.14195,
                                28.14107
                            ],
                            [
                                98.14146,
                                27.95481
                            ],
                            [
                                98.20165,
                                27.90598
                            ],
                            [
                                98.1787,
                                27.83399
                            ],
                            [
                                98.2243,
                                27.81137
                            ],
                            [
                                98.22364,
                                27.71644
                            ],
                            [
                                98.30055,
                                27.63287
                            ],
                            [
                                98.31907,
                                27.52318
                            ],
                            [
                                98.37636,
                                27.51167
                            ],
                            [
                                98.42906,
                                27.55406
                            ],
                            [
                                98.4316,
                                27.65984
                            ],
                            [
                                98.58612,
                                27.59277
                            ],
                            [
                                98.70554,
                                27.56067
                            ],
                            [
                                98.68653,
                                27.49093
                            ],
                            [
                                98.70127,
                                27.38186
                            ],
                            [
                                98.74005,
                                27.32935
                            ],
                            [
                                98.70723,
                                27.17872
                            ],
                            [
                                98.76199,
                                26.80402
                            ],
                            [
                                98.74441,
                                26.71407
                            ],
                            [
                                98.78079,
                                26.62439
                            ],
                            [
                                98.75511,
                                26.56413
                            ],
                            [
                                98.75123,
                                26.42746
                            ],
                            [
                                98.73239,
                                26.35419
                            ],
                            [
                                98.68519,
                                26.31038
                            ],
                            [
                                98.67511,
                                26.24519
                            ],
                            [
                                98.73349,
                                26.18536
                            ],
                            [
                                98.71596,
                                26.13013
                            ],
                            [
                                98.63153,
                                26.14939
                            ],
                            [
                                98.57591,
                                26.11996
                            ],
                            [
                                98.61778,
                                25.97721
                            ],
                            [
                                98.68468,
                                25.93771
                            ],
                            [
                                98.7052,
                                25.85701
                            ],
                            [
                                98.63331,
                                25.80225
                            ],
                            [
                                98.54004,
                                25.84651
                            ],
                            [
                                98.49559,
                                25.81081
                            ],
                            [
                                98.45986,
                                25.69414
                            ],
                            [
                                98.41256,
                                25.66337
                            ],
                            [
                                98.40495,
                                25.60603
                            ],
                            [
                                98.31499,
                                25.55266
                            ],
                            [
                                98.24975,
                                25.60721
                            ],
                            [
                                98.18582,
                                25.57886
                            ],
                            [
                                98.12913,
                                25.51103
                            ],
                            [
                                98.15522,
                                25.45775
                            ],
                            [
                                98.0674,
                                25.31476
                            ],
                            [
                                98.01308,
                                25.30448
                            ],
                            [
                                97.9404,
                                25.21834
                            ],
                            [
                                97.83996,
                                25.26778
                            ],
                            [
                                97.79749,
                                25.16297
                            ],
                            [
                                97.71966,
                                25.01637
                            ],
                            [
                                97.73174,
                                24.91546
                            ],
                            [
                                97.7955,
                                24.85389
                            ],
                            [
                                97.69989,
                                24.83992
                            ],
                            [
                                97.5545,
                                24.74786
                            ],
                            [
                                97.57258,
                                24.66194
                            ],
                            [
                                97.55521,
                                24.49932
                            ],
                            [
                                97.53696,
                                24.44084
                            ],
                            [
                                97.66687,
                                24.4514
                            ],
                            [
                                97.7111,
                                24.37718
                            ],
                            [
                                97.67262,
                                24.30097
                            ],
                            [
                                97.76298,
                                24.26621
                            ],
                            [
                                97.72911,
                                24.22214
                            ],
                            [
                                97.75014,
                                24.16889
                            ],
                            [
                                97.72727,
                                24.11598
                            ],
                            [
                                97.63675,
                                24.04659
                            ],
                            [
                                97.53129,
                                23.93356
                            ],
                            [
                                97.62769,
                                23.8839
                            ],
                            [
                                97.64725,
                                23.85066
                            ],
                            [
                                97.76086,
                                23.91264
                            ],
                            [
                                97.79818,
                                23.95438
                            ],
                            [
                                97.89175,
                                23.97899
                            ],
                            [
                                97.90597,
                                24.01689
                            ],
                            [
                                98.03929,
                                24.07201
                            ],
                            [
                                98.22751,
                                24.11489
                            ],
                            [
                                98.35242,
                                24.10238
                            ],
                            [
                                98.53797,
                                24.12961
                            ],
                            [
                                98.60045,
                                24.08705
                            ],
                            [
                                98.71938,
                                24.12881
                            ],
                            [
                                98.84445,
                                24.13201
                            ],
                            [
                                98.8629,
                                24.06803
                            ],
                            [
                                98.75256,
                                23.9844
                            ],
                            [
                                98.70064,
                                23.98432
                            ],
                            [
                                98.68125,
                                23.91267
                            ],
                            [
                                98.69869,
                                23.78924
                            ],
                            [
                                98.80227,
                                23.77244
                            ],
                            [
                                98.84912,
                                23.64011
                            ],
                            [
                                98.88941,
                                23.61383
                            ],
                            [
                                98.8041,
                                23.53496
                            ],
                            [
                                98.82268,
                                23.48415
                            ],
                            [
                                98.87796,
                                23.48434
                            ],
                            [
                                98.91823,
                                23.41851
                            ],
                            [
                                98.91545,
                                23.33094
                            ],
                            [
                                98.94016,
                                23.30787
                            ],
                            [
                                98.88689,
                                23.19272
                            ],
                            [
                                99.00531,
                                23.164
                            ],
                            [
                                99.10643,
                                23.09421
                            ],
                            [
                                99.19985,
                                23.10877
                            ],
                            [
                                99.24378,
                                23.08414
                            ],
                            [
                                99.34304,
                                23.13515
                            ],
                            [
                                99.39153,
                                23.10067
                            ],
                            [
                                99.51264,
                                23.08158
                            ],
                            [
                                99.53208,
                                22.90295
                            ],
                            [
                                99.44348,
                                22.93721
                            ],
                            [
                                99.45805,
                                22.85014
                            ],
                            [
                                99.40028,
                                22.82564
                            ],
                            [
                                99.38348,
                                22.76902
                            ],
                            [
                                99.32083,
                                22.7295
                            ],
                            [
                                99.35948,
                                22.66185
                            ],
                            [
                                99.38246,
                                22.57169
                            ],
                            [
                                99.37923,
                                22.49872
                            ],
                            [
                                99.29447,
                                22.41404
                            ],
                            [
                                99.23655,
                                22.30058
                            ],
                            [
                                99.23074,
                                22.24746
                            ],
                            [
                                99.16948,
                                22.1508
                            ],
                            [
                                99.26781,
                                22.10535
                            ],
                            [
                                99.43313,
                                22.10765
                            ],
                            [
                                99.47623,
                                22.13439
                            ],
                            [
                                99.52218,
                                22.10196
                            ],
                            [
                                99.64554,
                                22.10364
                            ],
                            [
                                99.71679,
                                22.04608
                            ],
                            [
                                99.74547,
                                22.0729
                            ],
                            [
                                99.83777,
                                22.03048
                            ],
                            [
                                99.88004,
                                22.06869
                            ],
                            [
                                99.96693,
                                22.05444
                            ],
                            [
                                99.99681,
                                21.97353
                            ],
                            [
                                99.94518,
                                21.82669
                            ],
                            [
                                99.98589,
                                21.71638
                            ],
                            [
                                100.04737,
                                21.67294
                            ],
                            [
                                100.0955,
                                21.70358
                            ],
                            [
                                100.16695,
                                21.66692
                            ],
                            [
                                100.1097,
                                21.59481
                            ],
                            [
                                100.1271,
                                21.51304
                            ],
                            [
                                100.23435,
                                21.47239
                            ],
                            [
                                100.29868,
                                21.48281
                            ],
                            [
                                100.34875,
                                21.52941
                            ],
                            [
                                100.42902,
                                21.53985
                            ],
                            [
                                100.48062,
                                21.46028
                            ],
                            [
                                100.58284,
                                21.45314
                            ],
                            [
                                100.72522,
                                21.51579
                            ],
                            [
                                100.88366,
                                21.68468
                            ],
                            [
                                101.00962,
                                21.70922
                            ],
                            [
                                101.08723,
                                21.77394
                            ],
                            [
                                101.16862,
                                21.60519
                            ],
                            [
                                101.14319,
                                21.56406
                            ],
                            [
                                101.20713,
                                21.56072
                            ],
                            [
                                101.21469,
                                21.49166
                            ],
                            [
                                101.18777,
                                21.41868
                            ],
                            [
                                101.24608,
                                21.37684
                            ],
                            [
                                101.24363,
                                21.27316
                            ],
                            [
                                101.28533,
                                21.17659
                            ],
                            [
                                101.40001,
                                21.23266
                            ],
                            [
                                101.5337,
                                21.25616
                            ],
                            [
                                101.68384,
                                21.20361
                            ],
                            [
                                101.70934,
                                21.14592
                            ],
                            [
                                101.81613,
                                21.14256
                            ],
                            [
                                101.86834,
                                21.1901
                            ],
                            [
                                101.84427,
                                21.2519
                            ],
                            [
                                101.75639,
                                21.29334
                            ],
                            [
                                101.72708,
                                21.35409
                            ],
                            [
                                101.77619,
                                21.51758
                            ],
                            [
                                101.76258,
                                21.5637
                            ],
                            [
                                101.83192,
                                21.61565
                            ],
                            [
                                101.76938,
                                21.66068
                            ],
                            [
                                101.74703,
                                21.73161
                            ],
                            [
                                101.77157,
                                21.83695
                            ],
                            [
                                101.67078,
                                21.93366
                            ],
                            [
                                101.59844,
                                21.97262
                            ],
                            [
                                101.62192,
                                22.0212
                            ],
                            [
                                101.57999,
                                22.06345
                            ],
                            [
                                101.59873,
                                22.13403
                            ],
                            [
                                101.56053,
                                22.27823
                            ],
                            [
                                101.62686,
                                22.28917
                            ],
                            [
                                101.66872,
                                22.37015
                            ],
                            [
                                101.64583,
                                22.41582
                            ],
                            [
                                101.73825,
                                22.49901
                            ],
                            [
                                101.82789,
                                22.45959
                            ],
                            [
                                101.8495,
                                22.38851
                            ],
                            [
                                101.91382,
                                22.44084
                            ],
                            [
                                101.9968,
                                22.43536
                            ],
                            [
                                102.04594,
                                22.45833
                            ],
                            [
                                102.12778,
                                22.43403
                            ],
                            [
                                102.14389,
                                22.40069
                            ],
                            [
                                102.15769,
                                22.43962
                            ],
                            [
                                102.25031,
                                22.4682
                            ],
                            [
                                102.40053,
                                22.62891
                            ],
                            [
                                102.47093,
                                22.77643
                            ],
                            [
                                102.54165,
                                22.7648
                            ],
                            [
                                102.6542,
                                22.69378
                            ],
                            [
                                102.69572,
                                22.69911
                            ],
                            [
                                102.79035,
                                22.62636
                            ],
                            [
                                102.85856,
                                22.60421
                            ],
                            [
                                102.92533,
                                22.47722
                            ],
                            [
                                102.98541,
                                22.47884
                            ],
                            [
                                103.0248,
                                22.43957
                            ],
                            [
                                103.06968,
                                22.48935
                            ],
                            [
                                103.17828,
                                22.55664
                            ],
                            [
                                103.15837,
                                22.58926
                            ],
                            [
                                103.19551,
                                22.64898
                            ],
                            [
                                103.28026,
                                22.68335
                            ],
                            [
                                103.32344,
                                22.81114
                            ],
                            [
                                103.44083,
                                22.7558
                            ],
                            [
                                103.43007,
                                22.7044
                            ],
                            [
                                103.52687,
                                22.59591
                            ],
                            [
                                103.57773,
                                22.66754
                            ],
                            [
                                103.56632,
                                22.70786
                            ],
                            [
                                103.64134,
                                22.79601
                            ],
                            [
                                103.76983,
                                22.68762
                            ],
                            [
                                103.82544,
                                22.6174
                            ],
                            [
                                103.96213,
                                22.50739
                            ],
                            [
                                104.01153,
                                22.52273
                            ],
                            [
                                104.04201,
                                22.72531
                            ],
                            [
                                104.11612,
                                22.81006
                            ],
                            [
                                104.24318,
                                22.83786
                            ],
                            [
                                104.27201,
                                22.74249
                            ],
                            [
                                104.39411,
                                22.69273
                            ],
                            [
                                104.53444,
                                22.82272
                            ],
                            [
                                104.60071,
                                22.84328
                            ],
                            [
                                104.72291,
                                22.82095
                            ],
                            [
                                104.77516,
                                22.89683
                            ],
                            [
                                104.86342,
                                22.95388
                            ],
                            [
                                104.81638,
                                23.0868
                            ],
                            [
                                104.88304,
                                23.16694
                            ],
                            [
                                105.02563,
                                23.22057
                            ],
                            [
                                105.07956,
                                23.26571
                            ],
                            [
                                105.17248,
                                23.28834
                            ],
                            [
                                105.22996,
                                23.27547
                            ],
                            [
                                105.26124,
                                23.34322
                            ],
                            [
                                105.32431,
                                23.38979
                            ],
                            [
                                105.37366,
                                23.31869
                            ],
                            [
                                105.43651,
                                23.29967
                            ],
                            [
                                105.50068,
                                23.20347
                            ],
                            [
                                105.55259,
                                23.18296
                            ],
                            [
                                105.57233,
                                23.07825
                            ],
                            [
                                105.7352,
                                23.05862
                            ],
                            [
                                105.82857,
                                22.9841
                            ],
                            [
                                105.87587,
                                22.92183
                            ],
                            [
                                105.99357,
                                22.94474
                            ],
                            [
                                106.00699,
                                22.99167
                            ],
                            [
                                106.1301,
                                22.99415
                            ],
                            [
                                106.23455,
                                22.95248
                            ],
                            [
                                106.25632,
                                22.8844
                            ],
                            [
                                106.34931,
                                22.86083
                            ],
                            [
                                106.49705,
                                22.90893
                            ],
                            [
                                106.52279,
                                22.94743
                            ],
                            [
                                106.67112,
                                22.89166
                            ],
                            [
                                106.82327,
                                22.77997
                            ],
                            [
                                106.72437,
                                22.64192
                            ],
                            [
                                106.71448,
                                22.58205
                            ],
                            [
                                106.6165,
                                22.60389
                            ],
                            [
                                106.56427,
                                22.46313
                            ],
                            [
                                106.57666,
                                22.34278
                            ],
                            [
                                106.65173,
                                22.33747
                            ],
                            [
                                106.69737,
                                22.21467
                            ],
                            [
                                106.67662,
                                22.17839
                            ],
                            [
                                106.74528,
                                22.01237
                            ],
                            [
                                106.81702,
                                21.9766
                            ],
                            [
                                106.91666,
                                21.97299
                            ],
                            [
                                106.99174,
                                21.94886
                            ],
                            [
                                107.06198,
                                21.89728
                            ],
                            [
                                107.01056,
                                21.85185
                            ],
                            [
                                107.03896,
                                21.81654
                            ],
                            [
                                107.11729,
                                21.79219
                            ],
                            [
                                107.24388,
                                21.70779
                            ],
                            [
                                107.30417,
                                21.73872
                            ],
                            [
                                107.35909,
                                21.66192
                            ],
                            [
                                107.36482,
                                21.59985
                            ],
                            [
                                107.46561,
                                21.66278
                            ],
                            [
                                107.49093,
                                21.60064
                            ],
                            [
                                107.57523,
                                21.61659
                            ],
                            [
                                107.64494,
                                21.60458
                            ],
                            [
                                107.8069,
                                21.65775
                            ],
                            [
                                107.86059,
                                21.6528
                            ],
                            [
                                107.95578,
                                21.53702
                            ],
                            [
                                108.02358,
                                21.54887
                            ],
                            [
                                108.17037,
                                21.57828
                            ],
                            [
                                108.21957,
                                21.6219
                            ],
                            [
                                108.28872,
                                21.5466
                            ],
                            [
                                108.32741,
                                21.6934
                            ],
                            [
                                108.41976,
                                21.65963
                            ],
                            [
                                108.39634,
                                21.56048
                            ],
                            [
                                108.46356,
                                21.56454
                            ],
                            [
                                108.55927,
                                21.67522
                            ],
                            [
                                108.54507,
                                21.73639
                            ],
                            [
                                108.47273,
                                21.85854
                            ],
                            [
                                108.5358,
                                21.89416
                            ],
                            [
                                108.60449,
                                21.84322
                            ],
                            [
                                108.55955,
                                21.78751
                            ],
                            [
                                108.59366,
                                21.72871
                            ],
                            [
                                108.64407,
                                21.74497
                            ],
                            [
                                108.68732,
                                21.71088
                            ],
                            [
                                108.73979,
                                21.61508
                            ],
                            [
                                108.8334,
                                21.62697
                            ],
                            [
                                108.98482,
                                21.60608
                            ],
                            [
                                109.06637,
                                21.64057
                            ],
                            [
                                109.087,
                                21.59635
                            ],
                            [
                                109.14588,
                                21.58825
                            ],
                            [
                                109.16367,
                                21.54316
                            ],
                            [
                                109.06896,
                                21.43908
                            ],
                            [
                                109.14872,
                                21.40722
                            ],
                            [
                                109.31635,
                                21.45465
                            ],
                            [
                                109.42554,
                                21.45833
                            ],
                            [
                                109.5523,
                                21.52609
                            ],
                            [
                                109.57212,
                                21.59011
                            ],
                            [
                                109.50472,
                                21.70877
                            ],
                            [
                                109.54021,
                                21.7437
                            ],
                            [
                                109.57984,
                                21.63901
                            ],
                            [
                                109.66198,
                                21.52325
                            ],
                            [
                                109.73487,
                                21.47161
                            ],
                            [
                                109.76396,
                                21.48866
                            ],
                            [
                                109.9159,
                                21.46549
                            ],
                            [
                                109.93781,
                                21.43218
                            ],
                            [
                                109.90645,
                                21.36432
                            ],
                            [
                                109.76728,
                                21.33623
                            ],
                            [
                                109.77327,
                                21.25078
                            ],
                            [
                                109.742,
                                21.17608
                            ],
                            [
                                109.67934,
                                21.12702
                            ],
                            [
                                109.70604,
                                21.05783
                            ],
                            [
                                109.66715,
                                20.94525
                            ],
                            [
                                109.68878,
                                20.84869
                            ],
                            [
                                109.76259,
                                20.7834
                            ],
                            [
                                109.77045,
                                20.6939
                            ],
                            [
                                109.74471,
                                20.65733
                            ],
                            [
                                109.80525,
                                20.61587
                            ],
                            [
                                109.84276,
                                20.55487
                            ],
                            [
                                109.84549,
                                20.49852
                            ],
                            [
                                109.92383,
                                20.44646
                            ],
                            [
                                109.87671,
                                20.402
                            ],
                            [
                                109.93552,
                                20.29478
                            ],
                            [
                                110.05216,
                                20.29362
                            ],
                            [
                                110.13605,
                                20.24341
                            ],
                            [
                                110.20498,
                                20.27044
                            ],
                            [
                                110.28564,
                                20.25473
                            ],
                            [
                                110.41193,
                                20.30853
                            ],
                            [
                                110.51633,
                                20.42927
                            ],
                            [
                                110.5303,
                                20.47552
                            ],
                            [
                                110.48121,
                                20.5696
                            ],
                            [
                                110.40848,
                                20.59815
                            ],
                            [
                                110.31128,
                                20.68385
                            ],
                            [
                                110.4068,
                                20.78948
                            ],
                            [
                                110.33548,
                                20.85997
                            ],
                            [
                                110.18415,
                                20.85974
                            ],
                            [
                                110.15855,
                                20.98226
                            ],
                            [
                                110.2625,
                                21.04508
                            ],
                            [
                                110.26469,
                                21.07644
                            ],
                            [
                                110.34205,
                                21.11491
                            ],
                            [
                                110.3893,
                                21.1677
                            ],
                            [
                                110.4845,
                                21.22055
                            ],
                            [
                                110.625,
                                21.22825
                            ],
                            [
                                110.62296,
                                21.36332
                            ],
                            [
                                110.65608,
                                21.39005
                            ],
                            [
                                110.7456,
                                21.42248
                            ],
                            [
                                110.77358,
                                21.4624
                            ],
                            [
                                110.79617,
                                21.42571
                            ],
                            [
                                110.80253,
                                21.40056
                            ],
                            [
                                110.88801,
                                21.38973
                            ],
                            [
                                110.98901,
                                21.42776
                            ],
                            [
                                111.03017,
                                21.52603
                            ],
                            [
                                111.10143,
                                21.46685
                            ],
                            [
                                111.15139,
                                21.46847
                            ],
                            [
                                111.22606,
                                21.51558
                            ],
                            [
                                111.30029,
                                21.48187
                            ],
                            [
                                111.43523,
                                21.53168
                            ],
                            [
                                111.54609,
                                21.51305
                            ],
                            [
                                111.6475,
                                21.52573
                            ],
                            [
                                111.69417,
                                21.59472
                            ],
                            [
                                111.77112,
                                21.62142
                            ],
                            [
                                111.77556,
                                21.7528
                            ],
                            [
                                111.84575,
                                21.67577
                            ],
                            [
                                111.89782,
                                21.68052
                            ],
                            [
                                111.94999,
                                21.73051
                            ],
                            [
                                112.07607,
                                21.7875
                            ],
                            [
                                112.18738,
                                21.79987
                            ],
                            [
                                112.19596,
                                21.75097
                            ],
                            [
                                112.28218,
                                21.70209
                            ],
                            [
                                112.39664,
                                21.73762
                            ],
                            [
                                112.42362,
                                21.84513
                            ],
                            [
                                112.58534,
                                21.76156
                            ],
                            [
                                112.64264,
                                21.79116
                            ],
                            [
                                112.65772,
                                21.8471
                            ],
                            [
                                112.77059,
                                21.93995
                            ],
                            [
                                112.84491,
                                21.96821
                            ],
                            [
                                112.87556,
                                21.89662
                            ],
                            [
                                112.91999,
                                21.85856
                            ],
                            [
                                113.01883,
                                21.94155
                            ],
                            [
                                112.99958,
                                22.09413
                            ],
                            [
                                113.08416,
                                22.20936
                            ],
                            [
                                113.12128,
                                22.20345
                            ],
                            [
                                113.12145,
                                22.07517
                            ],
                            [
                                113.22557,
                                22.04201
                            ],
                            [
                                113.31334,
                                22.06665
                            ],
                            [
                                113.3913,
                                22.18131
                            ],
                            [
                                113.50615,
                                22.17236
                            ],
                            [
                                113.53219,
                                22.20792
                            ],
                            [
                                113.55089,
                                22.21452
                            ],
                            [
                                113.58638,
                                22.24816
                            ],
                            [
                                113.59607,
                                22.369
                            ],
                            [
                                113.53682,
                                22.40051
                            ],
                            [
                                113.56933,
                                22.49759
                            ],
                            [
                                113.56104,
                                22.59378
                            ],
                            [
                                113.43913,
                                22.74429
                            ],
                            [
                                113.49408,
                                22.78833
                            ],
                            [
                                113.56517,
                                22.74428
                            ],
                            [
                                113.61099,
                                22.76225
                            ],
                            [
                                113.5204,
                                22.8469
                            ],
                            [
                                113.4948,
                                22.93362
                            ],
                            [
                                113.52355,
                                23.03202
                            ],
                            [
                                113.60147,
                                22.8481
                            ],
                            [
                                113.65256,
                                22.82547
                            ],
                            [
                                113.67373,
                                22.74668
                            ],
                            [
                                113.76472,
                                22.7479
                            ],
                            [
                                113.77021,
                                22.69315
                            ],
                            [
                                113.83615,
                                22.58032
                            ],
                            [
                                113.90532,
                                22.53156
                            ],
                            [
                                114.03762,
                                22.5037
                            ],
                            [
                                114.16106,
                                22.56447
                            ],
                            [
                                114.23484,
                                22.55576
                            ],
                            [
                                114.27251,
                                22.58387
                            ],
                            [
                                114.40627,
                                22.60513
                            ],
                            [
                                114.47797,
                                22.53676
                            ],
                            [
                                114.48042,
                                22.46977
                            ],
                            [
                                114.60888,
                                22.49645
                            ],
                            [
                                114.54278,
                                22.56441
                            ],
                            [
                                114.5882,
                                22.64403
                            ],
                            [
                                114.50852,
                                22.67922
                            ],
                            [
                                114.57305,
                                22.73877
                            ],
                            [
                                114.7132,
                                22.79076
                            ],
                            [
                                114.75766,
                                22.78291
                            ],
                            [
                                114.72521,
                                22.6513
                            ],
                            [
                                114.74959,
                                22.58135
                            ],
                            [
                                114.85847,
                                22.59425
                            ],
                            [
                                114.89033,
                                22.57166
                            ],
                            [
                                114.96482,
                                22.67934
                            ],
                            [
                                115.02682,
                                22.71013
                            ],
                            [
                                115.04633,
                                22.78473
                            ],
                            [
                                115.19991,
                                22.83264
                            ],
                            [
                                115.22934,
                                22.80226
                            ],
                            [
                                115.33782,
                                22.7807
                            ],
                            [
                                115.37646,
                                22.69155
                            ],
                            [
                                115.46148,
                                22.70117
                            ],
                            [
                                115.53171,
                                22.67007
                            ],
                            [
                                115.51458,
                                22.75618
                            ],
                            [
                                115.61593,
                                22.86794
                            ],
                            [
                                115.70117,
                                22.85379
                            ],
                            [
                                115.79108,
                                22.8144
                            ],
                            [
                                115.79611,
                                22.75707
                            ],
                            [
                                116.03252,
                                22.84791
                            ],
                            [
                                116.09617,
                                22.82451
                            ],
                            [
                                116.14348,
                                22.84783
                            ],
                            [
                                116.23799,
                                22.93528
                            ],
                            [
                                116.29818,
                                22.96446
                            ],
                            [
                                116.37732,
                                22.93261
                            ],
                            [
                                116.5008,
                                22.95281
                            ],
                            [
                                116.55695,
                                23.0191
                            ],
                            [
                                116.54123,
                                23.1465
                            ],
                            [
                                116.59703,
                                23.19259
                            ],
                            [
                                116.73743,
                                23.24478
                            ],
                            [
                                116.76276,
                                23.29007
                            ],
                            [
                                116.66668,
                                23.33968
                            ],
                            [
                                116.59409,
                                23.30721
                            ],
                            [
                                116.53897,
                                23.35496
                            ],
                            [
                                116.5659,
                                23.3942
                            ],
                            [
                                116.66549,
                                23.3508
                            ],
                            [
                                116.75328,
                                23.34866
                            ],
                            [
                                116.80292,
                                23.38229
                            ],
                            [
                                116.85841,
                                23.47545
                            ],
                            [
                                116.90313,
                                23.62901
                            ],
                            [
                                116.95521,
                                23.61558
                            ],
                            [
                                117.0399,
                                23.65969
                            ],
                            [
                                117.08406,
                                23.57827
                            ],
                            [
                                117.12027,
                                23.56848
                            ],
                            [
                                117.27359,
                                23.73867
                            ],
                            [
                                117.38691,
                                23.78938
                            ],
                            [
                                117.43671,
                                23.76598
                            ],
                            [
                                117.49446,
                                23.8699
                            ],
                            [
                                117.55887,
                                23.91501
                            ],
                            [
                                117.59188,
                                23.88131
                            ],
                            [
                                117.69752,
                                23.9595
                            ],
                            [
                                117.70769,
                                24.01924
                            ],
                            [
                                117.77446,
                                24.04181
                            ],
                            [
                                117.80939,
                                23.99773
                            ],
                            [
                                117.90132,
                                24.03211
                            ],
                            [
                                117.90636,
                                24.09502
                            ],
                            [
                                117.98146,
                                24.19876
                            ],
                            [
                                118.13705,
                                24.26927
                            ],
                            [
                                118.06046,
                                24.40585
                            ],
                            [
                                117.94407,
                                24.39416
                            ],
                            [
                                117.88041,
                                24.43731
                            ],
                            [
                                117.93176,
                                24.47265
                            ],
                            [
                                118.01504,
                                24.46917
                            ],
                            [
                                118.05897,
                                24.49987
                            ],
                            [
                                118.1459,
                                24.6557
                            ],
                            [
                                118.19077,
                                24.68021
                            ],
                            [
                                118.24475,
                                24.54664
                            ],
                            [
                                118.28213,
                                24.57507
                            ],
                            [
                                118.36646,
                                24.58363
                            ],
                            [
                                118.4518,
                                24.63278
                            ],
                            [
                                118.64813,
                                24.55804
                            ],
                            [
                                118.71288,
                                24.67894
                            ],
                            [
                                118.75998,
                                24.73318
                            ],
                            [
                                118.70541,
                                24.85065
                            ],
                            [
                                118.7779,
                                24.85463
                            ],
                            [
                                118.91352,
                                24.91468
                            ],
                            [
                                118.94922,
                                25.00666
                            ],
                            [
                                118.89316,
                                25.03443
                            ],
                            [
                                118.87892,
                                25.11008
                            ],
                            [
                                118.9426,
                                25.1102
                            ],
                            [
                                118.97436,
                                25.17473
                            ],
                            [
                                118.90504,
                                25.26573
                            ],
                            [
                                118.98761,
                                25.29186
                            ],
                            [
                                118.98904,
                                25.22498
                            ],
                            [
                                119.06379,
                                25.24213
                            ],
                            [
                                119.17832,
                                25.18588
                            ],
                            [
                                119.28009,
                                25.17199
                            ],
                            [
                                119.29218,
                                25.22641
                            ],
                            [
                                119.36639,
                                25.25069
                            ],
                            [
                                119.29838,
                                25.32277
                            ],
                            [
                                119.2273,
                                25.31426
                            ],
                            [
                                119.13647,
                                25.38972
                            ],
                            [
                                119.16415,
                                25.45379
                            ],
                            [
                                119.22564,
                                25.47783
                            ],
                            [
                                119.28895,
                                25.57305
                            ],
                            [
                                119.3624,
                                25.58337
                            ],
                            [
                                119.36685,
                                25.52926
                            ],
                            [
                                119.49436,
                                25.45183
                            ],
                            [
                                119.57962,
                                25.45122
                            ],
                            [
                                119.59912,
                                25.50562
                            ],
                            [
                                119.55717,
                                25.57304
                            ],
                            [
                                119.50921,
                                25.56004
                            ],
                            [
                                119.46746,
                                25.67487
                            ],
                            [
                                119.62848,
                                25.75932
                            ],
                            [
                                119.58754,
                                25.82728
                            ],
                            [
                                119.63242,
                                25.90869
                            ],
                            [
                                119.68415,
                                25.91027
                            ],
                            [
                                119.719,
                                26.00045
                            ],
                            [
                                119.66184,
                                26.00848
                            ],
                            [
                                119.6007,
                                26.16826
                            ],
                            [
                                119.72415,
                                26.27548
                            ],
                            [
                                119.89895,
                                26.34353
                            ],
                            [
                                119.82573,
                                26.41762
                            ],
                            [
                                119.71637,
                                26.30955
                            ],
                            [
                                119.6602,
                                26.35543
                            ],
                            [
                                119.68195,
                                26.46563
                            ],
                            [
                                119.79003,
                                26.41516
                            ],
                            [
                                119.81303,
                                26.45903
                            ],
                            [
                                119.73219,
                                26.60929
                            ],
                            [
                                119.66936,
                                26.61361
                            ],
                            [
                                119.60413,
                                26.57018
                            ],
                            [
                                119.55369,
                                26.63137
                            ],
                            [
                                119.59853,
                                26.65259
                            ],
                            [
                                119.55442,
                                26.72096
                            ],
                            [
                                119.57781,
                                26.78675
                            ],
                            [
                                119.68153,
                                26.75896
                            ],
                            [
                                119.69259,
                                26.80688
                            ],
                            [
                                119.79904,
                                26.7933
                            ],
                            [
                                119.79739,
                                26.75003
                            ],
                            [
                                119.88226,
                                26.65441
                            ],
                            [
                                119.92819,
                                26.74065
                            ],
                            [
                                119.97765,
                                26.78283
                            ],
                            [
                                120.07874,
                                26.79815
                            ],
                            [
                                119.94534,
                                26.61143
                            ],
                            [
                                119.85414,
                                26.58853
                            ],
                            [
                                119.88441,
                                26.51887
                            ],
                            [
                                119.95074,
                                26.60012
                            ],
                            [
                                120.00648,
                                26.60357
                            ],
                            [
                                120.08365,
                                26.64768
                            ],
                            [
                                120.14554,
                                26.71531
                            ],
                            [
                                120.10111,
                                26.75461
                            ],
                            [
                                120.04903,
                                26.89332
                            ],
                            [
                                120.11093,
                                26.91551
                            ],
                            [
                                120.22524,
                                26.91689
                            ],
                            [
                                120.26666,
                                26.99395
                            ],
                            [
                                120.2811,
                                27.09932
                            ],
                            [
                                120.37764,
                                27.09353
                            ],
                            [
                                120.43374,
                                27.20732
                            ],
                            [
                                120.51314,
                                27.1946
                            ],
                            [
                                120.55443,
                                27.29451
                            ],
                            [
                                120.52143,
                                27.32946
                            ],
                            [
                                120.55308,
                                27.40165
                            ],
                            [
                                120.64267,
                                27.36853
                            ],
                            [
                                120.65029,
                                27.44203
                            ],
                            [
                                120.5905,
                                27.56953
                            ],
                            [
                                120.67351,
                                27.64024
                            ],
                            [
                                120.68119,
                                27.72094
                            ],
                            [
                                120.84584,
                                27.87308
                            ],
                            [
                                120.87712,
                                27.9982
                            ],
                            [
                                120.94371,
                                27.98177
                            ],
                            [
                                120.99256,
                                28.046
                            ],
                            [
                                121.02431,
                                28.14495
                            ],
                            [
                                121.1014,
                                28.17973
                            ],
                            [
                                121.10577,
                                28.27562
                            ],
                            [
                                121.17613,
                                28.35145
                            ],
                            [
                                121.26508,
                                28.27797
                            ],
                            [
                                121.27941,
                                28.19453
                            ],
                            [
                                121.36035,
                                28.14262
                            ],
                            [
                                121.47039,
                                28.33115
                            ],
                            [
                                121.58859,
                                28.35967
                            ],
                            [
                                121.57776,
                                28.48172
                            ],
                            [
                                121.49824,
                                28.65224
                            ],
                            [
                                121.52847,
                                28.69342
                            ],
                            [
                                121.62045,
                                28.71986
                            ],
                            [
                                121.64856,
                                28.80362
                            ],
                            [
                                121.61627,
                                28.89471
                            ],
                            [
                                121.53978,
                                28.90871
                            ],
                            [
                                121.55289,
                                28.96161
                            ],
                            [
                                121.66303,
                                28.91684
                            ],
                            [
                                121.72032,
                                28.94306
                            ],
                            [
                                121.63482,
                                29.10369
                            ],
                            [
                                121.46863,
                                29.10137
                            ],
                            [
                                121.46697,
                                29.16102
                            ],
                            [
                                121.52691,
                                29.18444
                            ],
                            [
                                121.54306,
                                29.23813
                            ],
                            [
                                121.69294,
                                29.1868
                            ],
                            [
                                121.76821,
                                29.22983
                            ],
                            [
                                121.83256,
                                29.23885
                            ],
                            [
                                121.84866,
                                29.16504
                            ],
                            [
                                121.93368,
                                29.19719
                            ],
                            [
                                121.96063,
                                29.24725
                            ],
                            [
                                121.91536,
                                29.29064
                            ],
                            [
                                121.94643,
                                29.47825
                            ],
                            [
                                121.92941,
                                29.53919
                            ],
                            [
                                121.99511,
                                29.59436
                            ],
                            [
                                121.92286,
                                29.637
                            ],
                            [
                                121.79358,
                                29.59858
                            ],
                            [
                                121.81138,
                                29.48428
                            ],
                            [
                                121.71457,
                                29.5335
                            ],
                            [
                                121.65929,
                                29.49556
                            ],
                            [
                                121.51444,
                                29.45494
                            ],
                            [
                                121.42452,
                                29.4644
                            ],
                            [
                                121.47937,
                                29.53803
                            ],
                            [
                                121.52202,
                                29.50774
                            ],
                            [
                                121.69943,
                                29.55989
                            ],
                            [
                                121.77881,
                                29.65343
                            ],
                            [
                                121.846,
                                29.69347
                            ],
                            [
                                121.87878,
                                29.76197
                            ],
                            [
                                122.13078,
                                29.87651
                            ],
                            [
                                121.94675,
                                29.88869
                            ],
                            [
                                121.83292,
                                29.92259
                            ],
                            [
                                121.7679,
                                29.96756
                            ],
                            [
                                121.67622,
                                29.96485
                            ],
                            [
                                121.58991,
                                30.05509
                            ],
                            [
                                121.49266,
                                30.18692
                            ],
                            [
                                121.38627,
                                30.27453
                            ],
                            [
                                121.30702,
                                30.30511
                            ],
                            [
                                121.18581,
                                30.30845
                            ],
                            [
                                121.08329,
                                30.26564
                            ],
                            [
                                121.00976,
                                30.21022
                            ],
                            [
                                120.85733,
                                30.13367
                            ],
                            [
                                120.62859,
                                30.10664
                            ],
                            [
                                120.58427,
                                30.16225
                            ],
                            [
                                120.55552,
                                30.28171
                            ],
                            [
                                120.50304,
                                30.31555
                            ],
                            [
                                120.40355,
                                30.28636
                            ],
                            [
                                120.36957,
                                30.22162
                            ],
                            [
                                120.30684,
                                30.23022
                            ],
                            [
                                120.26452,
                                30.27379
                            ],
                            [
                                120.35989,
                                30.30866
                            ],
                            [
                                120.38468,
                                30.37433
                            ],
                            [
                                120.49303,
                                30.39646
                            ],
                            [
                                120.69181,
                                30.38914
                            ],
                            [
                                120.75116,
                                30.34903
                            ],
                            [
                                120.83329,
                                30.34744
                            ],
                            [
                                120.93946,
                                30.41421
                            ],
                            [
                                120.93117,
                                30.47525
                            ],
                            [
                                120.9932,
                                30.55367
                            ],
                            [
                                121.06343,
                                30.58855
                            ],
                            [
                                121.14015,
                                30.59669
                            ],
                            [
                                121.1666,
                                30.63673
                            ],
                            [
                                121.29568,
                                30.70484
                            ],
                            [
                                121.36335,
                                30.71806
                            ],
                            [
                                121.44137,
                                30.80193
                            ],
                            [
                                121.56241,
                                30.84766
                            ],
                            [
                                121.74297,
                                30.87247
                            ],
                            [
                                121.85171,
                                30.86089
                            ],
                            [
                                121.89035,
                                30.90311
                            ],
                            [
                                121.89623,
                                30.97217
                            ],
                            [
                                121.8561,
                                31.0656
                            ],
                            [
                                121.72599,
                                31.27176
                            ],
                            [
                                121.58018,
                                31.37608
                            ],
                            [
                                121.50957,
                                31.389
                            ],
                            [
                                121.43241,
                                31.45475
                            ],
                            [
                                121.31086,
                                31.51156
                            ],
                            [
                                121.22537,
                                31.62261
                            ],
                            [
                                121.08741,
                                31.71427
                            ],
                            [
                                120.99727,
                                31.75573
                            ],
                            [
                                120.83617,
                                31.7646
                            ],
                            [
                                120.78025,
                                31.82716
                            ],
                            [
                                120.79876,
                                31.85845
                            ],
                            [
                                120.74954,
                                31.96157
                            ],
                            [
                                120.70508,
                                31.99012
                            ],
                            [
                                120.57425,
                                31.99025
                            ],
                            [
                                120.46739,
                                32.02
                            ],
                            [
                                120.43237,
                                31.96705
                            ],
                            [
                                120.28232,
                                31.93651
                            ],
                            [
                                120.41061,
                                32.05133
                            ],
                            [
                                120.51979,
                                32.08809
                            ],
                            [
                                120.6051,
                                32.07684
                            ],
                            [
                                120.78273,
                                32.01867
                            ],
                            [
                                120.88048,
                                31.9361
                            ],
                            [
                                120.92566,
                                31.87302
                            ],
                            [
                                120.92575,
                                31.81726
                            ],
                            [
                                120.98268,
                                31.80627
                            ],
                            [
                                121.08824,
                                31.84879
                            ],
                            [
                                121.15216,
                                31.8372
                            ],
                            [
                                121.29411,
                                31.8834
                            ],
                            [
                                121.44479,
                                31.83803
                            ],
                            [
                                121.63808,
                                31.73237
                            ],
                            [
                                121.86582,
                                31.69555
                            ],
                            [
                                121.87867,
                                31.78413
                            ],
                            [
                                121.82201,
                                31.91246
                            ],
                            [
                                121.70679,
                                32.03957
                            ],
                            [
                                121.51412,
                                32.1146
                            ],
                            [
                                121.42455,
                                32.12024
                            ],
                            [
                                121.4144,
                                32.16156
                            ],
                            [
                                121.34194,
                                32.21517
                            ],
                            [
                                121.34732,
                                32.40148
                            ],
                            [
                                121.07989,
                                32.52062
                            ],
                            [
                                120.99197,
                                32.53983
                            ],
                            [
                                120.84585,
                                32.63551
                            ],
                            [
                                120.89907,
                                32.66206
                            ],
                            [
                                120.82066,
                                32.75729
                            ],
                            [
                                120.81892,
                                32.81303
                            ],
                            [
                                120.86124,
                                32.85799
                            ],
                            [
                                120.83358,
                                32.97204
                            ],
                            [
                                120.72588,
                                33.10358
                            ],
                            [
                                120.70054,
                                33.17116
                            ],
                            [
                                120.72079,
                                33.24703
                            ],
                            [
                                120.66842,
                                33.3003
                            ],
                            [
                                120.64852,
                                33.38659
                            ],
                            [
                                120.59114,
                                33.41497
                            ],
                            [
                                120.58794,
                                33.504
                            ],
                            [
                                120.54121,
                                33.52738
                            ],
                            [
                                120.5035,
                                33.61378
                            ],
                            [
                                120.53834,
                                33.63288
                            ],
                            [
                                120.46374,
                                33.75074
                            ],
                            [
                                120.47259,
                                33.8287
                            ],
                            [
                                120.42137,
                                33.91223
                            ],
                            [
                                120.33318,
                                34.12475
                            ],
                            [
                                120.32559,
                                34.17658
                            ],
                            [
                                120.26375,
                                34.31766
                            ],
                            [
                                120.11738,
                                34.36985
                            ],
                            [
                                120.01812,
                                34.42728
                            ],
                            [
                                119.79494,
                                34.47197
                            ],
                            [
                                119.71841,
                                34.52855
                            ],
                            [
                                119.55823,
                                34.60114
                            ],
                            [
                                119.45945,
                                34.67042
                            ],
                            [
                                119.46362,
                                34.72906
                            ],
                            [
                                119.35116,
                                34.7642
                            ],
                            [
                                119.27479,
                                34.74315
                            ],
                            [
                                119.20295,
                                34.79781
                            ],
                            [
                                119.17257,
                                34.85591
                            ],
                            [
                                119.20846,
                                35.04458
                            ],
                            [
                                119.36173,
                                35.10506
                            ],
                            [
                                119.40162,
                                35.2593
                            ],
                            [
                                119.46078,
                                35.32539
                            ],
                            [
                                119.55135,
                                35.38369
                            ],
                            [
                                119.63291,
                                35.581
                            ],
                            [
                                119.73138,
                                35.6351
                            ],
                            [
                                119.86327,
                                35.61814
                            ],
                            [
                                119.94259,
                                35.765
                            ],
                            [
                                120.00518,
                                35.72988
                            ],
                            [
                                120.06263,
                                35.8842
                            ],
                            [
                                120.20164,
                                35.94051
                            ],
                            [
                                120.17099,
                                36.00482
                            ],
                            [
                                120.18407,
                                36.06283
                            ],
                            [
                                120.09685,
                                36.1076
                            ],
                            [
                                120.11292,
                                36.19622
                            ],
                            [
                                120.22378,
                                36.19649
                            ],
                            [
                                120.3334,
                                36.23022
                            ],
                            [
                                120.36176,
                                36.14941
                            ],
                            [
                                120.30323,
                                36.07182
                            ],
                            [
                                120.34275,
                                36.04779
                            ],
                            [
                                120.54657,
                                36.11578
                            ],
                            [
                                120.70544,
                                36.13544
                            ],
                            [
                                120.64489,
                                36.27701
                            ],
                            [
                                120.70209,
                                36.4369
                            ],
                            [
                                120.74668,
                                36.46363
                            ],
                            [
                                120.83697,
                                36.45817
                            ],
                            [
                                120.85478,
                                36.38599
                            ],
                            [
                                120.95632,
                                36.47408
                            ],
                            [
                                120.95708,
                                36.58755
                            ],
                            [
                                121.0852,
                                36.62347
                            ],
                            [
                                121.17204,
                                36.68926
                            ],
                            [
                                121.24067,
                                36.69371
                            ],
                            [
                                121.48424,
                                36.77448
                            ],
                            [
                                121.59765,
                                36.77378
                            ],
                            [
                                121.63477,
                                36.81318
                            ],
                            [
                                121.7198,
                                36.83445
                            ],
                            [
                                121.75515,
                                36.87662
                            ],
                            [
                                121.94708,
                                36.9444
                            ],
                            [
                                121.9936,
                                36.99029
                            ],
                            [
                                122.08172,
                                36.92117
                            ],
                            [
                                122.13531,
                                36.95875
                            ],
                            [
                                122.18709,
                                36.89487
                            ],
                            [
                                122.17967,
                                36.85325
                            ],
                            [
                                122.3362,
                                36.83451
                            ],
                            [
                                122.41022,
                                36.86451
                            ],
                            [
                                122.41561,
                                36.91571
                            ],
                            [
                                122.52276,
                                36.94755
                            ],
                            [
                                122.5305,
                                36.99682
                            ],
                            [
                                122.46271,
                                37.02934
                            ],
                            [
                                122.45066,
                                37.1417
                            ],
                            [
                                122.61718,
                                37.20124
                            ],
                            [
                                122.55522,
                                37.27188
                            ],
                            [
                                122.56019,
                                37.39389
                            ],
                            [
                                122.303,
                                37.41016
                            ],
                            [
                                122.24448,
                                37.45293
                            ],
                            [
                                122.15924,
                                37.42582
                            ],
                            [
                                122.13693,
                                37.5469
                            ],
                            [
                                122.02158,
                                37.51956
                            ],
                            [
                                121.93858,
                                37.46353
                            ],
                            [
                                121.73074,
                                37.44623
                            ],
                            [
                                121.68047,
                                37.45453
                            ],
                            [
                                121.56876,
                                37.42362
                            ],
                            [
                                121.46802,
                                37.46834
                            ],
                            [
                                121.43947,
                                37.52007
                            ],
                            [
                                121.37293,
                                37.55199
                            ],
                            [
                                121.16684,
                                37.58557
                            ],
                            [
                                121.13481,
                                37.61782
                            ],
                            [
                                121.13236,
                                37.70256
                            ],
                            [
                                121.01717,
                                37.71499
                            ],
                            [
                                120.93533,
                                37.7748
                            ],
                            [
                                120.9308,
                                37.8181
                            ],
                            [
                                120.81277,
                                37.81188
                            ],
                            [
                                120.74137,
                                37.83368
                            ],
                            [
                                120.58217,
                                37.75701
                            ],
                            [
                                120.45302,
                                37.74136
                            ],
                            [
                                120.34224,
                                37.68824
                            ],
                            [
                                120.31229,
                                37.6078
                            ],
                            [
                                120.21767,
                                37.52085
                            ],
                            [
                                120.07017,
                                37.43857
                            ],
                            [
                                120.00792,
                                37.43178
                            ],
                            [
                                119.92303,
                                37.38133
                            ],
                            [
                                119.84714,
                                37.36528
                            ],
                            [
                                119.90044,
                                37.30208
                            ],
                            [
                                119.88033,
                                37.23814
                            ],
                            [
                                119.69773,
                                37.14072
                            ],
                            [
                                119.55958,
                                37.14114
                            ],
                            [
                                119.26532,
                                37.16298
                            ],
                            [
                                119.11887,
                                37.21013
                            ],
                            [
                                118.99045,
                                37.30115
                            ],
                            [
                                118.96241,
                                37.37829
                            ],
                            [
                                118.94851,
                                37.49615
                            ],
                            [
                                118.96728,
                                37.60507
                            ],
                            [
                                119.06722,
                                37.70205
                            ],
                            [
                                119.06564,
                                37.75469
                            ],
                            [
                                118.99813,
                                37.78551
                            ],
                            [
                                119.02152,
                                37.86712
                            ],
                            [
                                118.94008,
                                38.06303
                            ],
                            [
                                118.84163,
                                38.07843
                            ],
                            [
                                118.83792,
                                38.20812
                            ],
                            [
                                118.70772,
                                38.1827
                            ],
                            [
                                118.66486,
                                38.14239
                            ],
                            [
                                118.58204,
                                38.14233
                            ],
                            [
                                118.52802,
                                38.08224
                            ],
                            [
                                118.45962,
                                38.12331
                            ],
                            [
                                118.3377,
                                38.14371
                            ],
                            [
                                118.17297,
                                38.14741
                            ],
                            [
                                118.09174,
                                38.1305
                            ],
                            [
                                117.92704,
                                38.23616
                            ],
                            [
                                117.81687,
                                38.27458
                            ],
                            [
                                117.70279,
                                38.36936
                            ],
                            [
                                117.60428,
                                38.51295
                            ],
                            [
                                117.52748,
                                38.67731
                            ],
                            [
                                117.60939,
                                38.84154
                            ],
                            [
                                117.75828,
                                38.99274
                            ],
                            [
                                117.72934,
                                39.09037
                            ],
                            [
                                117.8357,
                                39.17814
                            ],
                            [
                                117.90656,
                                39.20599
                            ],
                            [
                                118.0572,
                                39.22649
                            ],
                            [
                                118.13053,
                                39.20316
                            ],
                            [
                                118.26517,
                                39.06272
                            ],
                            [
                                118.32418,
                                39.04004
                            ],
                            [
                                118.39448,
                                39.06368
                            ],
                            [
                                118.53752,
                                39.15913
                            ],
                            [
                                118.61106,
                                39.1892
                            ],
                            [
                                118.73977,
                                39.14391
                            ],
                            [
                                118.87613,
                                39.15846
                            ],
                            [
                                119.00729,
                                39.20442
                            ],
                            [
                                119.10845,
                                39.29009
                            ],
                            [
                                119.19178,
                                39.38339
                            ],
                            [
                                119.28617,
                                39.41869
                            ],
                            [
                                119.2565,
                                39.52479
                            ],
                            [
                                119.33794,
                                39.71065
                            ],
                            [
                                119.41544,
                                39.78246
                            ],
                            [
                                119.52487,
                                39.80829
                            ],
                            [
                                119.53416,
                                39.88795
                            ],
                            [
                                119.64613,
                                39.92864
                            ],
                            [
                                119.77663,
                                39.9543
                            ],
                            [
                                119.9104,
                                40.00017
                            ],
                            [
                                119.94173,
                                40.04129
                            ],
                            [
                                120.10261,
                                40.08505
                            ],
                            [
                                120.42146,
                                40.18837
                            ],
                            [
                                120.49152,
                                40.24091
                            ],
                            [
                                120.50137,
                                40.31206
                            ],
                            [
                                120.58529,
                                40.36084
                            ],
                            [
                                120.59192,
                                40.45706
                            ],
                            [
                                120.79743,
                                40.60328
                            ],
                            [
                                120.82762,
                                40.6612
                            ],
                            [
                                120.92303,
                                40.68683
                            ],
                            [
                                120.92735,
                                40.75969
                            ],
                            [
                                121.00689,
                                40.83061
                            ],
                            [
                                121.07252,
                                40.82285
                            ],
                            [
                                121.18557,
                                40.92829
                            ],
                            [
                                121.30733,
                                40.90406
                            ],
                            [
                                121.33256,
                                40.92602
                            ],
                            [
                                121.45198,
                                40.88323
                            ],
                            [
                                121.51381,
                                40.89025
                            ],
                            [
                                121.59883,
                                40.83071
                            ],
                            [
                                121.74729,
                                40.83788
                            ],
                            [
                                121.82953,
                                40.88097
                            ],
                            [
                                121.86981,
                                40.80796
                            ],
                            [
                                122.05102,
                                40.7305
                            ],
                            [
                                122.11538,
                                40.6813
                            ],
                            [
                                122.16586,
                                40.58507
                            ],
                            [
                                122.28275,
                                40.48518
                            ],
                            [
                                122.21549,
                                40.41466
                            ],
                            [
                                122.18497,
                                40.34415
                            ],
                            [
                                122.10945,
                                40.29149
                            ],
                            [
                                122.09997,
                                40.22679
                            ],
                            [
                                121.99651,
                                40.17444
                            ],
                            [
                                122.00077,
                                40.11816
                            ],
                            [
                                121.84701,
                                40.00306
                            ],
                            [
                                121.77652,
                                39.91222
                            ],
                            [
                                121.69987,
                                39.91659
                            ],
                            [
                                121.61002,
                                39.85979
                            ],
                            [
                                121.54274,
                                39.85007
                            ],
                            [
                                121.47907,
                                39.79562
                            ],
                            [
                                121.46498,
                                39.73292
                            ],
                            [
                                121.54755,
                                39.672
                            ],
                            [
                                121.54053,
                                39.54733
                            ],
                            [
                                121.39761,
                                39.47891
                            ],
                            [
                                121.47125,
                                39.43629
                            ],
                            [
                                121.50616,
                                39.36946
                            ],
                            [
                                121.65143,
                                39.35866
                            ],
                            [
                                121.75564,
                                39.3802
                            ],
                            [
                                121.75106,
                                39.31624
                            ],
                            [
                                121.67669,
                                39.27249
                            ],
                            [
                                121.58672,
                                39.18602
                            ],
                            [
                                121.6792,
                                39.13351
                            ],
                            [
                                121.65077,
                                39.07631
                            ],
                            [
                                121.44659,
                                39.01293
                            ],
                            [
                                121.38049,
                                39.05269
                            ],
                            [
                                121.33651,
                                38.9712
                            ],
                            [
                                121.22055,
                                38.93101
                            ],
                            [
                                121.0991,
                                38.92122
                            ],
                            [
                                121.11667,
                                38.77109
                            ],
                            [
                                121.14411,
                                38.72198
                            ],
                            [
                                121.20565,
                                38.72625
                            ],
                            [
                                121.26726,
                                38.78945
                            ],
                            [
                                121.35284,
                                38.81605
                            ],
                            [
                                121.49759,
                                38.81411
                            ],
                            [
                                121.57529,
                                38.87634
                            ],
                            [
                                121.69115,
                                38.86268
                            ],
                            [
                                121.71268,
                                38.89191
                            ],
                            [
                                121.59753,
                                38.95677
                            ],
                            [
                                121.65247,
                                39.00978
                            ],
                            [
                                121.7853,
                                39.01718
                            ],
                            [
                                121.91113,
                                39.06391
                            ],
                            [
                                121.95719,
                                39.03287
                            ],
                            [
                                122.09495,
                                39.12527
                            ],
                            [
                                122.12532,
                                39.21919
                            ],
                            [
                                122.23869,
                                39.27785
                            ],
                            [
                                122.30891,
                                39.36866
                            ],
                            [
                                122.38091,
                                39.40323
                            ],
                            [
                                122.50074,
                                39.42113
                            ],
                            [
                                122.62476,
                                39.48802
                            ],
                            [
                                122.66093,
                                39.53053
                            ],
                            [
                                122.87839,
                                39.60891
                            ],
                            [
                                122.96668,
                                39.62382
                            ],
                            [
                                123.00692,
                                39.6743
                            ],
                            [
                                123.14292,
                                39.65579
                            ],
                            [
                                123.27089,
                                39.6952
                            ],
                            [
                                123.23692,
                                39.74408
                            ],
                            [
                                123.30202,
                                39.78097
                            ],
                            [
                                123.38156,
                                39.78242
                            ],
                            [
                                123.45763,
                                39.74213
                            ],
                            [
                                123.63913,
                                39.82496
                            ],
                            [
                                123.7922,
                                39.82245
                            ],
                            [
                                123.82509,
                                39.84165
                            ],
                            [
                                123.97085,
                                39.80633
                            ],
                            [
                                124.20274,
                                39.86444
                            ],
                            [
                                124.22765,
                                39.91678
                            ],
                            [
                                124.35829,
                                40.0
                            ],
                            [
                                124.34821,
                                40.07885
                            ],
                            [
                                124.52222,
                                40.22825
                            ],
                            [
                                124.61184,
                                40.28417
                            ],
                            [
                                124.71904,
                                40.32017
                            ],
                            [
                                124.76035,
                                40.38457
                            ],
                            [
                                125.03436,
                                40.48666
                            ],
                            [
                                125.00848,
                                40.52394
                            ],
                            [
                                125.27009,
                                40.64601
                            ],
                            [
                                125.32649,
                                40.63855
                            ],
                            [
                                125.44805,
                                40.6698
                            ],
                            [
                                125.54889,
                                40.75857
                            ],
                            [
                                125.67039,
                                40.76217
                            ],
                            [
                                125.64243,
                                40.8155
                            ],
                            [
                                125.71061,
                                40.86746
                            ],
                            [
                                125.87125,
                                40.903
                            ],
                            [
                                125.93273,
                                40.87729
                            ],
                            [
                                126.03173,
                                40.92688
                            ],
                            [
                                126.06372,
                                40.98946
                            ],
                            [
                                126.16499,
                                41.09244
                            ],
                            [
                                126.26821,
                                41.15303
                            ],
                            [
                                126.31591,
                                41.22592
                            ],
                            [
                                126.43321,
                                41.35115
                            ],
                            [
                                126.49261,
                                41.37158
                            ],
                            [
                                126.50269,
                                41.43236
                            ],
                            [
                                126.58487,
                                41.56625
                            ],
                            [
                                126.58862,
                                41.61797
                            ],
                            [
                                126.72427,
                                41.70735
                            ],
                            [
                                126.79622,
                                41.69696
                            ],
                            [
                                126.88328,
                                41.78897
                            ],
                            [
                                126.94178,
                                41.80542
                            ],
                            [
                                127.05084,
                                41.70413
                            ],
                            [
                                127.0348,
                                41.66896
                            ],
                            [
                                127.14261,
                                41.58267
                            ],
                            [
                                127.16221,
                                41.53851
                            ],
                            [
                                127.33725,
                                41.46313
                            ],
                            [
                                127.4956,
                                41.47466
                            ],
                            [
                                127.64793,
                                41.40373
                            ],
                            [
                                127.74054,
                                41.42386
                            ],
                            [
                                127.86764,
                                41.41486
                            ],
                            [
                                127.92627,
                                41.44305
                            ],
                            [
                                128.03433,
                                41.39123
                            ],
                            [
                                128.20279,
                                41.41053
                            ],
                            [
                                128.3107,
                                41.58662
                            ],
                            [
                                128.26215,
                                41.66387
                            ],
                            [
                                128.16284,
                                41.71282
                            ],
                            [
                                128.10593,
                                41.79269
                            ],
                            [
                                128.09814,
                                41.89555
                            ],
                            [
                                128.06783,
                                41.96053
                            ],
                            [
                                128.23959,
                                42.03066
                            ],
                            [
                                128.44146,
                                42.02856
                            ],
                            [
                                128.49042,
                                41.99849
                            ],
                            [
                                128.68452,
                                42.01333
                            ],
                            [
                                128.73132,
                                42.04726
                            ],
                            [
                                128.91455,
                                42.01064
                            ],
                            [
                                128.96031,
                                42.09047
                            ],
                            [
                                129.11148,
                                42.13964
                            ],
                            [
                                129.18666,
                                42.18991
                            ],
                            [
                                129.24902,
                                42.33627
                            ],
                            [
                                129.30867,
                                42.42089
                            ],
                            [
                                129.44634,
                                42.44024
                            ],
                            [
                                129.55123,
                                42.36517
                            ],
                            [
                                129.5935,
                                42.41264
                            ],
                            [
                                129.69478,
                                42.42703
                            ],
                            [
                                129.74197,
                                42.46856
                            ],
                            [
                                129.73767,
                                42.57422
                            ],
                            [
                                129.78023,
                                42.68792
                            ],
                            [
                                129.76072,
                                42.70906
                            ],
                            [
                                129.83709,
                                42.86747
                            ],
                            [
                                129.85218,
                                42.96041
                            ],
                            [
                                129.90745,
                                43.00618
                            ],
                            [
                                129.98525,
                                42.97203
                            ],
                            [
                                130.117,
                                42.98634
                            ],
                            [
                                130.1381,
                                42.9042
                            ],
                            [
                                130.25971,
                                42.90283
                            ],
                            [
                                130.22944,
                                42.78781
                            ],
                            [
                                130.25234,
                                42.71009
                            ],
                            [
                                130.38066,
                                42.60191
                            ],
                            [
                                130.51205,
                                42.61446
                            ],
                            [
                                130.57848,
                                42.43282
                            ],
                            [
                                130.63393,
                                42.41417
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                121.65705,
                                25.21206
                            ],
                            [
                                121.57348,
                                25.29519
                            ],
                            [
                                121.44551,
                                25.24742
                            ],
                            [
                                121.37158,
                                25.14395
                            ],
                            [
                                121.2314,
                                25.11607
                            ],
                            [
                                121.04306,
                                25.03348
                            ],
                            [
                                120.91239,
                                24.82638
                            ],
                            [
                                120.89681,
                                24.75474
                            ],
                            [
                                120.83457,
                                24.6848
                            ],
                            [
                                120.71149,
                                24.59951
                            ],
                            [
                                120.66505,
                                24.49175
                            ],
                            [
                                120.60505,
                                24.42274
                            ],
                            [
                                120.44885,
                                24.15313
                            ],
                            [
                                120.42618,
                                24.08813
                            ],
                            [
                                120.35447,
                                24.01726
                            ],
                            [
                                120.25761,
                                23.84496
                            ],
                            [
                                120.19059,
                                23.76547
                            ],
                            [
                                120.18043,
                                23.71128
                            ],
                            [
                                120.12467,
                                23.61204
                            ],
                            [
                                120.14985,
                                23.49122
                            ],
                            [
                                120.13158,
                                23.37536
                            ],
                            [
                                120.09125,
                                23.24169
                            ],
                            [
                                120.08348,
                                23.12206
                            ],
                            [
                                120.05474,
                                23.05001
                            ],
                            [
                                120.15354,
                                22.96893
                            ],
                            [
                                120.20079,
                                22.82058
                            ],
                            [
                                120.25073,
                                22.70876
                            ],
                            [
                                120.26643,
                                22.59917
                            ],
                            [
                                120.35324,
                                22.50371
                            ],
                            [
                                120.42084,
                                22.48569
                            ],
                            [
                                120.46805,
                                22.43366
                            ],
                            [
                                120.57149,
                                22.37711
                            ],
                            [
                                120.63009,
                                22.30717
                            ],
                            [
                                120.70696,
                                22.10518
                            ],
                            [
                                120.68298,
                                22.02495
                            ],
                            [
                                120.71027,
                                21.93337
                            ],
                            [
                                120.84032,
                                21.97963
                            ],
                            [
                                120.89068,
                                22.0422
                            ],
                            [
                                120.88855,
                                22.32802
                            ],
                            [
                                120.96995,
                                22.54772
                            ],
                            [
                                121.02848,
                                22.66196
                            ],
                            [
                                121.12738,
                                22.72352
                            ],
                            [
                                121.3108,
                                22.98259
                            ],
                            [
                                121.35278,
                                23.08355
                            ],
                            [
                                121.40176,
                                23.1215
                            ],
                            [
                                121.39517,
                                23.20104
                            ],
                            [
                                121.45794,
                                23.32253
                            ],
                            [
                                121.50681,
                                23.48098
                            ],
                            [
                                121.52424,
                                23.59263
                            ],
                            [
                                121.59258,
                                23.86287
                            ],
                            [
                                121.60306,
                                23.96077
                            ],
                            [
                                121.63834,
                                24.00545
                            ],
                            [
                                121.61017,
                                24.07699
                            ],
                            [
                                121.65268,
                                24.131
                            ],
                            [
                                121.67418,
                                24.2113
                            ],
                            [
                                121.73721,
                                24.2635
                            ],
                            [
                                121.79233,
                                24.42753
                            ],
                            [
                                121.84591,
                                24.4829
                            ],
                            [
                                121.86791,
                                24.60912
                            ],
                            [
                                121.83947,
                                24.65031
                            ],
                            [
                                121.81296,
                                24.76323
                            ],
                            [
                                121.82587,
                                24.8517
                            ],
                            [
                                121.88814,
                                24.93583
                            ],
                            [
                                121.99509,
                                25.0115
                            ],
                            [
                                121.93461,
                                25.02696
                            ],
                            [
                                121.91093,
                                25.1222
                            ],
                            [
                                121.82047,
                                25.12813
                            ],
                            [
                                121.73843,
                                25.15568
                            ],
                            [
                                121.65705,
                                25.21206
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                110.6981,
                                20.13132
                            ],
                            [
                                110.57346,
                                20.08703
                            ],
                            [
                                110.52844,
                                20.01351
                            ],
                            [
                                110.34023,
                                20.07525
                            ],
                            [
                                110.27997,
                                20.02205
                            ],
                            [
                                110.19282,
                                20.05634
                            ],
                            [
                                110.12358,
                                19.9715
                            ],
                            [
                                110.0603,
                                19.97494
                            ],
                            [
                                109.9824,
                                19.94134
                            ],
                            [
                                109.94296,
                                19.98957
                            ],
                            [
                                109.88512,
                                19.98436
                            ],
                            [
                                109.85196,
                                19.94267
                            ],
                            [
                                109.68534,
                                20.00627
                            ],
                            [
                                109.58891,
                                19.98379
                            ],
                            [
                                109.52102,
                                19.90278
                            ],
                            [
                                109.53721,
                                19.84604
                            ],
                            [
                                109.33074,
                                19.8889
                            ],
                            [
                                109.29853,
                                19.91604
                            ],
                            [
                                109.16091,
                                19.79182
                            ],
                            [
                                109.17451,
                                19.652
                            ],
                            [
                                109.00927,
                                19.58052
                            ],
                            [
                                108.87015,
                                19.46089
                            ],
                            [
                                108.74883,
                                19.38177
                            ],
                            [
                                108.68546,
                                19.37072
                            ],
                            [
                                108.63093,
                                19.21859
                            ],
                            [
                                108.67902,
                                19.17639
                            ],
                            [
                                108.62062,
                                19.09208
                            ],
                            [
                                108.65959,
                                18.93819
                            ],
                            [
                                108.63032,
                                18.8346
                            ],
                            [
                                108.69608,
                                18.73699
                            ],
                            [
                                108.70278,
                                18.63415
                            ],
                            [
                                108.67982,
                                18.55732
                            ],
                            [
                                108.7047,
                                18.50017
                            ],
                            [
                                108.80332,
                                18.48074
                            ],
                            [
                                109.0003,
                                18.36919
                            ],
                            [
                                109.10689,
                                18.36324
                            ],
                            [
                                109.19494,
                                18.2908
                            ],
                            [
                                109.3086,
                                18.30644
                            ],
                            [
                                109.45784,
                                18.28019
                            ],
                            [
                                109.61324,
                                18.18085
                            ],
                            [
                                109.63357,
                                18.22708
                            ],
                            [
                                109.72863,
                                18.222
                            ],
                            [
                                109.72515,
                                18.29891
                            ],
                            [
                                109.75746,
                                18.39717
                            ],
                            [
                                109.82739,
                                18.3829
                            ],
                            [
                                109.9853,
                                18.43285
                            ],
                            [
                                110.04704,
                                18.38663
                            ],
                            [
                                110.08926,
                                18.50865
                            ],
                            [
                                110.20051,
                                18.62171
                            ],
                            [
                                110.26633,
                                18.66568
                            ],
                            [
                                110.42786,
                                18.68608
                            ],
                            [
                                110.46542,
                                18.76546
                            ],
                            [
                                110.43836,
                                18.82934
                            ],
                            [
                                110.51173,
                                18.89514
                            ],
                            [
                                110.51839,
                                18.98712
                            ],
                            [
                                110.56798,
                                19.05475
                            ],
                            [
                                110.58547,
                                19.15841
                            ],
                            [
                                110.67695,
                                19.32448
                            ],
                            [
                                110.68127,
                                19.39129
                            ],
                            [
                                110.73326,
                                19.40568
                            ],
                            [
                                110.80356,
                                19.49142
                            ],
                            [
                                110.97936,
                                19.64053
                            ],
                            [
                                111.00747,
                                19.69466
                            ],
                            [
                                110.99145,
                                19.82601
                            ],
                            [
                                110.92965,
                                20.0099
                            ],
                            [
                                110.86169,
                                19.9956
                            ],
                            [
                                110.78177,
                                20.01466
                            ],
                            [
                                110.71909,
                                20.07103
                            ],
                            [
                                110.6981,
                                20.13132
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                121.373,
                                31.82947
                            ],
                            [
                                121.22313,
                                31.84279
                            ],
                            [
                                121.19074,
                                31.7923
                            ],
                            [
                                121.26549,
                                31.72912
                            ],
                            [
                                121.27194,
                                31.69204
                            ],
                            [
                                121.38229,
                                31.6167
                            ],
                            [
                                121.60839,
                                31.52454
                            ],
                            [
                                121.82428,
                                31.46706
                            ],
                            [
                                121.887,
                                31.55366
                            ],
                            [
                                121.59455,
                                31.66452
                            ],
                            [
                                121.52786,
                                31.71708
                            ],
                            [
                                121.44261,
                                31.74793
                            ],
                            [
                                121.373,
                                31.82947
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                121.99185,
                                30.15192
                            ],
                            [
                                121.98397,
                                30.04816
                            ],
                            [
                                122.06485,
                                30.00778
                            ],
                            [
                                122.31393,
                                29.94642
                            ],
                            [
                                122.32701,
                                30.02087
                            ],
                            [
                                122.22276,
                                30.09381
                            ],
                            [
                                122.14688,
                                30.11071
                            ],
                            [
                                122.093,
                                30.15463
                            ],
                            [
                                121.99185,
                                30.15192
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                110.39393,
                                21.09579
                            ],
                            [
                                110.30407,
                                21.0816
                            ],
                            [
                                110.19911,
                                20.98251
                            ],
                            [
                                110.21478,
                                20.95856
                            ],
                            [
                                110.34663,
                                21.00321
                            ],
                            [
                                110.4608,
                                20.99926
                            ],
                            [
                                110.504,
                                20.93377
                            ],
                            [
                                110.54749,
                                21.06934
                            ],
                            [
                                110.51844,
                                21.08144
                            ],
                            [
                                110.41519,
                                21.05003
                            ],
                            [
                                110.39393,
                                21.09579
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                121.45661,
                                39.64468
                            ],
                            [
                                121.4062,
                                39.59763
                            ],
                            [
                                121.31768,
                                39.58783
                            ],
                            [
                                121.22965,
                                39.50834
                            ],
                            [
                                121.38355,
                                39.51727
                            ],
                            [
                                121.42584,
                                39.50364
                            ],
                            [
                                121.52215,
                                39.55493
                            ],
                            [
                                121.52215,
                                39.619
                            ],
                            [
                                121.45661,
                                39.64468
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                119.77292,
                                25.64338
                            ],
                            [
                                119.68799,
                                25.59934
                            ],
                            [
                                119.77418,
                                25.50684
                            ],
                            [
                                119.85149,
                                25.56412
                            ],
                            [
                                119.77292,
                                25.64338
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                117.42374,
                                23.7638
                            ],
                            [
                                117.33888,
                                23.68807
                            ],
                            [
                                117.41433,
                                23.67794
                            ],
                            [
                                117.31457,
                                23.57691
                            ],
                            [
                                117.41624,
                                23.58958
                            ],
                            [
                                117.50883,
                                23.75424
                            ],
                            [
                                117.42374,
                                23.7638
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                121.2846,
                                28.18401
                            ],
                            [
                                121.24483,
                                28.2085
                            ],
                            [
                                121.15547,
                                28.13745
                            ],
                            [
                                121.15436,
                                28.04079
                            ],
                            [
                                121.2155,
                                28.05581
                            ],
                            [
                                121.26242,
                                28.1135
                            ],
                            [
                                121.2846,
                                28.18401
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                112.87484,
                                21.76257
                            ],
                            [
                                112.79251,
                                21.75968
                            ],
                            [
                                112.73114,
                                21.67336
                            ],
                            [
                                112.73365,
                                21.6071
                            ],
                            [
                                112.77163,
                                21.56697
                            ],
                            [
                                112.82854,
                                21.73648
                            ],
                            [
                                112.87484,
                                21.76257
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                118.46127,
                                24.46722
                            ],
                            [
                                118.42361,
                                24.52482
                            ],
                            [
                                118.36883,
                                24.46296
                            ],
                            [
                                118.29488,
                                24.47988
                            ],
                            [
                                118.32431,
                                24.38593
                            ],
                            [
                                118.37151,
                                24.42945
                            ],
                            [
                                118.45021,
                                24.41396
                            ],
                            [
                                118.46127,
                                24.46722
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                118.14004,
                                24.53944
                            ],
                            [
                                118.06694,
                                24.4562
                            ],
                            [
                                118.13309,
                                24.42377
                            ],
                            [
                                118.19556,
                                24.48481
                            ],
                            [
                                118.14004,
                                24.53944
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                110.49378,
                                21.18322
                            ],
                            [
                                110.53496,
                                21.09762
                            ],
                            [
                                110.60021,
                                21.17395
                            ],
                            [
                                110.57179,
                                21.19859
                            ],
                            [
                                110.49378,
                                21.18322
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                117.13447,
                                23.46321
                            ],
                            [
                                117.05346,
                                23.47655
                            ],
                            [
                                117.02005,
                                23.41956
                            ],
                            [
                                117.11886,
                                23.39936
                            ],
                            [
                                117.13447,
                                23.46321
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                110.79598,
                                21.42094
                            ],
                            [
                                110.76931,
                                21.43854
                            ],
                            [
                                110.75148,
                                21.41142
                            ],
                            [
                                110.70502,
                                21.40328
                            ],
                            [
                                110.6317,
                                21.36489
                            ],
                            [
                                110.67172,
                                21.30067
                            ],
                            [
                                110.74417,
                                21.38254
                            ],
                            [
                                110.78895,
                                21.40003
                            ],
                            [
                                110.79598,
                                21.42094
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                122.127,
                                29.78351
                            ],
                            [
                                122.087,
                                29.72803
                            ],
                            [
                                122.1903,
                                29.65533
                            ],
                            [
                                122.19516,
                                29.71123
                            ],
                            [
                                122.127,
                                29.78351
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                122.18921,
                                30.33046
                            ],
                            [
                                122.09271,
                                30.30123
                            ],
                            [
                                122.14187,
                                30.25084
                            ],
                            [
                                122.2182,
                                30.23581
                            ],
                            [
                                122.18921,
                                30.33046
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                112.66232,
                                21.71791
                            ],
                            [
                                112.58756,
                                21.69436
                            ],
                            [
                                112.53712,
                                21.63803
                            ],
                            [
                                112.61355,
                                21.61031
                            ],
                            [
                                112.66232,
                                21.71791
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                113.60019,
                                22.63515
                            ],
                            [
                                113.60019,
                                22.67307
                            ],
                            [
                                113.54096,
                                22.74175
                            ],
                            [
                                113.46546,
                                22.72336
                            ],
                            [
                                113.60019,
                                22.63515
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                121.88467,
                                30.08172
                            ],
                            [
                                121.84864,
                                30.07968
                            ],
                            [
                                121.83308,
                                29.99375
                            ],
                            [
                                121.92194,
                                30.00273
                            ],
                            [
                                121.88467,
                                30.08172
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                113.38404,
                                22.0767
                            ],
                            [
                                113.31149,
                                22.05132
                            ],
                            [
                                113.31149,
                                22.00951
                            ],
                            [
                                113.40491,
                                22.01889
                            ],
                            [
                                113.38404,
                                22.0767
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                110.5854,
                                20.95902
                            ],
                            [
                                110.54602,
                                20.91163
                            ],
                            [
                                110.60599,
                                20.87703
                            ],
                            [
                                110.63498,
                                20.94045
                            ],
                            [
                                110.5854,
                                20.95902
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "CXR",
                "Country": "Christmas Island",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    3.135e-08,
                    6.93e-08,
                    1.0725e-07,
                    1.386e-07,
                    1.947e-07,
                    2.5575e-07,
                    3.1185e-07,
                    3.531e-07,
                    3.9435e-07,
                    4.389e-07,
                    4.8345e-07,
                    5.2965e-07,
                    5.6265e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    3.135e-08,
                    6.93e-08,
                    1.0725e-07,
                    1.386e-07,
                    1.947e-07,
                    2.5575e-07,
                    3.1185e-07,
                    3.531e-07,
                    3.9435e-07,
                    4.389e-07,
                    4.8345e-07,
                    5.2965e-07,
                    5.6265e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    3.135e-08,
                    6.93e-08,
                    1.0725e-07,
                    1.386e-07,
                    1.947e-07,
                    2.5575e-07,
                    3.1185e-07,
                    3.531e-07,
                    3.9435e-07,
                    4.389e-07,
                    4.8345e-07,
                    5.2965e-07,
                    5.6265e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    3.135e-08,
                    6.93e-08,
                    1.0725e-07,
                    1.386e-07,
                    1.947e-07,
                    2.5575e-07,
                    3.1185e-07,
                    3.531e-07,
                    3.9435e-07,
                    4.389e-07,
                    4.8345e-07,
                    5.2965e-07,
                    5.6265e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07,
                    5.9895e-07
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": []
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            105.5337,
                            -10.5112
                        ],
                        [
                            105.62729,
                            -10.51578
                        ],
                        [
                            105.64787,
                            -10.45138
                        ],
                        [
                            105.57719,
                            -10.45827
                        ],
                        [
                            105.5337,
                            -10.5112
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "COL",
                "Country": "Colombia",
                "Total_3GHG": 0.88,
                "Total_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0049,
                    0.005,
                    0.0052,
                    0.0053,
                    0.0055,
                    0.0057,
                    0.0058,
                    0.006,
                    0.0062,
                    0.0064,
                    0.0066,
                    0.0068,
                    0.007,
                    0.0072,
                    0.0074,
                    0.0075,
                    0.0077,
                    0.0079,
                    0.008,
                    0.0081,
                    0.0082,
                    0.0083,
                    0.0086,
                    0.0087,
                    0.0088,
                    0.0089,
                    0.009,
                    0.0091,
                    0.0092,
                    0.0093,
                    0.0094,
                    0.0095,
                    0.0096,
                    0.0097,
                    0.0098,
                    0.0099,
                    0.01,
                    0.0101,
                    0.0102,
                    0.0103,
                    0.0103,
                    0.0104,
                    0.0105,
                    0.0106,
                    0.0107,
                    0.0108,
                    0.011,
                    0.0111,
                    0.0112,
                    0.0114,
                    0.0115,
                    0.0116,
                    0.0117,
                    0.0118,
                    0.012,
                    0.0121,
                    0.0122,
                    0.0123,
                    0.0125,
                    0.0126,
                    0.0127,
                    0.0128,
                    0.0129,
                    0.013,
                    0.0133,
                    0.0134,
                    0.0135,
                    0.0136,
                    0.0138,
                    0.0139,
                    0.014,
                    0.0141,
                    0.0142,
                    0.0143,
                    0.0144
                ],
                "Fossil_3GHG": 0.32,
                "Fossil_3GHG_timeseries": [
                    3.3494e-07,
                    6.6555e-07,
                    9.9188e-07,
                    1.3139e-06,
                    1.6318e-06,
                    1.9454e-06,
                    2.2548e-06,
                    2.56e-06,
                    2.8611e-06,
                    3.158e-06,
                    3.4484e-06,
                    3.7323e-06,
                    4.0098e-06,
                    4.2809e-06,
                    4.5457e-06,
                    4.8041e-06,
                    5.0564e-06,
                    5.3024e-06,
                    5.5423e-06,
                    5.7762e-06,
                    6.0246e-06,
                    6.2879e-06,
                    6.5662e-06,
                    6.86e-06,
                    7.1694e-06,
                    7.4946e-06,
                    7.8356e-06,
                    8.1925e-06,
                    8.5651e-06,
                    8.9535e-06,
                    9.3577e-06,
                    9.7777e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034
                ],
                "Land_3GHG": 1.92,
                "Land_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.0051,
                    0.0052,
                    0.0054,
                    0.0055,
                    0.0057,
                    0.0059,
                    0.0061,
                    0.0063,
                    0.0065,
                    0.0066,
                    0.0068,
                    0.0069,
                    0.0071,
                    0.0073,
                    0.0074,
                    0.0075,
                    0.0076,
                    0.0076,
                    0.0077,
                    0.0079,
                    0.008,
                    0.0081,
                    0.0082,
                    0.0083,
                    0.0084,
                    0.0084,
                    0.0085,
                    0.0086,
                    0.0087,
                    0.0087,
                    0.0088,
                    0.0088,
                    0.0089,
                    0.0089,
                    0.009,
                    0.009,
                    0.0091,
                    0.0091,
                    0.0092,
                    0.0092,
                    0.0093,
                    0.0093,
                    0.0094,
                    0.0094,
                    0.0095,
                    0.0096,
                    0.0097,
                    0.0098,
                    0.0098,
                    0.0099,
                    0.0099,
                    0.01,
                    0.0101,
                    0.0101,
                    0.0102,
                    0.0102,
                    0.0103,
                    0.0103,
                    0.0103,
                    0.0104,
                    0.0105,
                    0.0106,
                    0.0107,
                    0.0107,
                    0.0107,
                    0.0108,
                    0.0108,
                    0.0108,
                    0.0109,
                    0.0109,
                    0.011,
                    0.011
                ],
                "Total_CO2": 0.88,
                "Total_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0049,
                    0.005,
                    0.0052,
                    0.0053,
                    0.0055,
                    0.0057,
                    0.0058,
                    0.006,
                    0.0061,
                    0.0062,
                    0.0064,
                    0.0065,
                    0.0065,
                    0.0066,
                    0.0067,
                    0.0067,
                    0.0069,
                    0.007,
                    0.007,
                    0.0071,
                    0.0071,
                    0.0072,
                    0.0072,
                    0.0073,
                    0.0073,
                    0.0074,
                    0.0074,
                    0.0074,
                    0.0075,
                    0.0075,
                    0.0076,
                    0.0076,
                    0.0076,
                    0.0077,
                    0.0077,
                    0.0078,
                    0.0078,
                    0.0078,
                    0.0079,
                    0.008,
                    0.008,
                    0.0081,
                    0.0082,
                    0.0083,
                    0.0084,
                    0.0084,
                    0.0085,
                    0.0085,
                    0.0086,
                    0.0087,
                    0.0087,
                    0.0088,
                    0.0088,
                    0.0089,
                    0.009,
                    0.009,
                    0.009,
                    0.0091,
                    0.0093,
                    0.0094,
                    0.0095,
                    0.0096,
                    0.0096,
                    0.0097,
                    0.0098,
                    0.0098,
                    0.0099,
                    0.01,
                    0.01
                ],
                "Fossil_CO2": 0.21,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.32e-08,
                    7.755e-08,
                    1.617e-07,
                    2.508e-07,
                    4.5045e-07,
                    8.316e-07,
                    1.2029e-06,
                    1.81e-06,
                    2.3909e-06,
                    2.6845e-06,
                    2.833e-06,
                    2.8693e-06,
                    3.1102e-06,
                    3.4418e-06,
                    4.524e-06,
                    5.7778e-06,
                    7.0316e-06,
                    8.3844e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016
                ],
                "Land_CO2": 2.34,
                "Land_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.005,
                    0.0051,
                    0.0053,
                    0.0054,
                    0.0056,
                    0.0057,
                    0.0059,
                    0.006,
                    0.0061,
                    0.0062,
                    0.0063,
                    0.0064,
                    0.0064,
                    0.0065,
                    0.0065,
                    0.0067,
                    0.0068,
                    0.0068,
                    0.0069,
                    0.0069,
                    0.0069,
                    0.007,
                    0.007,
                    0.007,
                    0.007,
                    0.007,
                    0.0071,
                    0.0071,
                    0.0071,
                    0.0071,
                    0.0071,
                    0.0072,
                    0.0072,
                    0.0072,
                    0.0072,
                    0.0072,
                    0.0072,
                    0.0073,
                    0.0073,
                    0.0073,
                    0.0074,
                    0.0074,
                    0.0075,
                    0.0075,
                    0.0076,
                    0.0076,
                    0.0076,
                    0.0077,
                    0.0077,
                    0.0078,
                    0.0078,
                    0.0078,
                    0.0079,
                    0.0079,
                    0.0079,
                    0.0079,
                    0.008,
                    0.0081,
                    0.0082,
                    0.0082,
                    0.0082,
                    0.0083,
                    0.0083,
                    0.0083,
                    0.0083,
                    0.0083,
                    0.0084,
                    0.0084
                ],
                "Total_CH4": 0.94,
                "Total_CH4_timeseries": [
                    2.6396e-06,
                    5.2401e-06,
                    7.8014e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039
                ],
                "Fossil_CH4": 0.66,
                "Fossil_CH4_timeseries": [
                    3.1293e-07,
                    6.2124e-07,
                    9.2495e-07,
                    1.2241e-06,
                    1.5187e-06,
                    1.8089e-06,
                    2.0946e-06,
                    2.376e-06,
                    2.6529e-06,
                    2.9256e-06,
                    3.1916e-06,
                    3.451e-06,
                    3.7038e-06,
                    3.9501e-06,
                    4.1898e-06,
                    4.4232e-06,
                    4.6502e-06,
                    4.8709e-06,
                    5.0853e-06,
                    5.2936e-06,
                    5.516e-06,
                    5.7528e-06,
                    6.0039e-06,
                    6.2695e-06,
                    6.5497e-06,
                    6.8447e-06,
                    7.1545e-06,
                    7.4794e-06,
                    7.8193e-06,
                    8.1745e-06,
                    8.5452e-06,
                    8.9314e-06,
                    9.3333e-06,
                    9.751e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017
                ],
                "Land_CH4": 1.39,
                "Land_CH4_timeseries": [
                    2.3267e-06,
                    4.6188e-06,
                    6.8765e-06,
                    9.0996e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022
                ],
                "Total_N2O": 0.62,
                "Total_N2O_timeseries": [
                    7.0873e-08,
                    1.4303e-07,
                    2.1643e-07,
                    2.91e-07,
                    3.6664e-07,
                    4.4326e-07,
                    5.2073e-07,
                    5.989e-07,
                    6.7761e-07,
                    7.5667e-07,
                    8.3597e-07,
                    9.1547e-07,
                    9.9517e-07,
                    1.075e-06,
                    1.1551e-06,
                    1.2353e-06,
                    1.3157e-06,
                    1.3962e-06,
                    1.477e-06,
                    1.5581e-06,
                    1.6403e-06,
                    1.7255e-06,
                    1.8149e-06,
                    1.9094e-06,
                    2.0094e-06,
                    2.1153e-06,
                    2.2266e-06,
                    2.3427e-06,
                    2.4626e-06,
                    2.5848e-06,
                    2.7085e-06,
                    2.8333e-06,
                    2.9591e-06,
                    3.0858e-06,
                    3.2133e-06,
                    3.3416e-06,
                    3.4706e-06,
                    3.6005e-06,
                    3.7313e-06,
                    3.9116e-06,
                    4.0945e-06,
                    4.2822e-06,
                    4.4769e-06,
                    4.6803e-06,
                    4.8941e-06,
                    5.1198e-06,
                    5.3585e-06,
                    5.6111e-06,
                    5.8784e-06,
                    6.1608e-06,
                    6.4641e-06,
                    6.7978e-06,
                    7.1688e-06,
                    7.5816e-06,
                    8.038e-06,
                    8.5375e-06,
                    9.0768e-06,
                    9.6502e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Fossil_N2O": 0.22,
                "Fossil_N2O_timeseries": [
                    2.2005e-08,
                    4.4319e-08,
                    6.6936e-08,
                    8.9843e-08,
                    1.1303e-07,
                    1.3647e-07,
                    1.6016e-07,
                    1.8406e-07,
                    2.0816e-07,
                    2.3242e-07,
                    2.5682e-07,
                    2.8137e-07,
                    3.0605e-07,
                    3.3087e-07,
                    3.5582e-07,
                    3.809e-07,
                    4.0612e-07,
                    4.3148e-07,
                    4.5698e-07,
                    4.8263e-07,
                    5.0857e-07,
                    5.3509e-07,
                    5.6237e-07,
                    5.9055e-07,
                    6.1973e-07,
                    6.4992e-07,
                    6.8107e-07,
                    7.1309e-07,
                    7.4581e-07,
                    7.7901e-07,
                    8.1253e-07,
                    8.4634e-07,
                    8.8042e-07,
                    9.1475e-07,
                    9.4931e-07,
                    9.841e-07,
                    1.0191e-06,
                    1.0544e-06,
                    1.0899e-06,
                    1.1265e-06,
                    1.1636e-06,
                    1.2012e-06,
                    1.2394e-06,
                    1.2781e-06,
                    1.3174e-06,
                    1.3574e-06,
                    1.3979e-06,
                    1.4391e-06,
                    1.4811e-06,
                    1.5237e-06,
                    1.5671e-06,
                    1.6113e-06,
                    1.6565e-06,
                    1.7027e-06,
                    1.7499e-06,
                    1.7981e-06,
                    1.8474e-06,
                    1.8977e-06,
                    1.9489e-06,
                    2.0011e-06,
                    2.0543e-06,
                    2.1083e-06,
                    2.1631e-06,
                    2.2189e-06,
                    2.2755e-06,
                    2.3329e-06,
                    2.3912e-06,
                    2.4504e-06,
                    2.5104e-06,
                    2.5713e-06,
                    2.6331e-06,
                    2.6957e-06,
                    2.7592e-06,
                    2.8236e-06,
                    2.8888e-06,
                    2.9549e-06,
                    3.0219e-06,
                    3.0898e-06,
                    3.1585e-06,
                    3.2283e-06,
                    3.299e-06,
                    3.3709e-06,
                    3.444e-06,
                    3.5186e-06,
                    3.5947e-06,
                    3.6724e-06,
                    3.7517e-06,
                    3.8329e-06,
                    3.9158e-06,
                    4.0005e-06,
                    4.0875e-06,
                    4.1775e-06,
                    4.2709e-06,
                    4.3684e-06,
                    4.4703e-06,
                    4.5768e-06,
                    4.688e-06,
                    4.8039e-06,
                    4.9244e-06,
                    5.0494e-06,
                    5.1798e-06,
                    5.3183e-06,
                    5.4668e-06,
                    5.6269e-06,
                    5.7999e-06,
                    5.9865e-06,
                    6.1873e-06,
                    6.4022e-06,
                    6.6309e-06,
                    6.8727e-06,
                    7.1268e-06,
                    7.3928e-06,
                    7.6706e-06,
                    7.9606e-06,
                    8.2633e-06,
                    8.5799e-06,
                    8.9115e-06,
                    9.2597e-06,
                    9.6266e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.77,
                "Land_N2O_timeseries": [
                    4.8869e-08,
                    9.8715e-08,
                    1.495e-07,
                    2.0116e-07,
                    2.5362e-07,
                    3.0679e-07,
                    3.6057e-07,
                    4.1484e-07,
                    4.6945e-07,
                    5.2425e-07,
                    5.7914e-07,
                    6.3411e-07,
                    6.8912e-07,
                    7.4417e-07,
                    7.9926e-07,
                    8.5438e-07,
                    9.0954e-07,
                    9.6475e-07,
                    1.02e-06,
                    1.0754e-06,
                    1.1317e-06,
                    1.1904e-06,
                    1.2525e-06,
                    1.3188e-06,
                    1.3897e-06,
                    1.4654e-06,
                    1.5455e-06,
                    1.6296e-06,
                    1.7168e-06,
                    1.8058e-06,
                    1.8959e-06,
                    1.9869e-06,
                    2.0787e-06,
                    2.171e-06,
                    2.264e-06,
                    2.3575e-06,
                    2.4515e-06,
                    2.5461e-06,
                    2.6414e-06,
                    2.7851e-06,
                    2.9309e-06,
                    3.081e-06,
                    3.2374e-06,
                    3.4022e-06,
                    3.5767e-06,
                    3.7625e-06,
                    3.9606e-06,
                    4.172e-06,
                    4.3974e-06,
                    4.6371e-06,
                    4.897e-06,
                    5.1865e-06,
                    5.5123e-06,
                    5.8789e-06,
                    6.2881e-06,
                    6.7394e-06,
                    7.2294e-06,
                    7.7525e-06,
                    8.3006e-06,
                    8.8628e-06,
                    9.4329e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -71.32407,
                            11.84566
                        ],
                        [
                            -71.29459,
                            11.90922
                        ],
                        [
                            -71.13601,
                            12.00455
                        ],
                        [
                            -71.11737,
                            12.08907
                        ],
                        [
                            -71.21836,
                            12.2588
                        ],
                        [
                            -71.22762,
                            12.29694
                        ],
                        [
                            -71.32289,
                            12.34921
                        ],
                        [
                            -71.52344,
                            12.43525
                        ],
                        [
                            -71.66849,
                            12.45759
                        ],
                        [
                            -71.73488,
                            12.41389
                        ],
                        [
                            -71.74187,
                            12.34854
                        ],
                        [
                            -71.83061,
                            12.3209
                        ],
                        [
                            -71.86084,
                            12.35494
                        ],
                        [
                            -71.92782,
                            12.29705
                        ],
                        [
                            -71.86167,
                            12.21139
                        ],
                        [
                            -71.96299,
                            12.14693
                        ],
                        [
                            -71.99882,
                            12.18716
                        ],
                        [
                            -71.97402,
                            12.25539
                        ],
                        [
                            -72.08274,
                            12.2328
                        ],
                        [
                            -72.13968,
                            12.23873
                        ],
                        [
                            -72.13938,
                            12.10332
                        ],
                        [
                            -72.21547,
                            11.92987
                        ],
                        [
                            -72.29714,
                            11.85618
                        ],
                        [
                            -72.45867,
                            11.77608
                        ],
                        [
                            -72.51809,
                            11.77454
                        ],
                        [
                            -72.62422,
                            11.72096
                        ],
                        [
                            -72.72008,
                            11.70021
                        ],
                        [
                            -72.83287,
                            11.62917
                        ],
                        [
                            -72.88073,
                            11.56698
                        ],
                        [
                            -73.03214,
                            11.48808
                        ],
                        [
                            -73.14342,
                            11.4055
                        ],
                        [
                            -73.26699,
                            11.29154
                        ],
                        [
                            -73.35549,
                            11.26325
                        ],
                        [
                            -73.59045,
                            11.26251
                        ],
                        [
                            -73.65973,
                            11.25273
                        ],
                        [
                            -73.8593,
                            11.27525
                        ],
                        [
                            -73.97845,
                            11.33834
                        ],
                        [
                            -74.04558,
                            11.34663
                        ],
                        [
                            -74.07908,
                            11.32065
                        ],
                        [
                            -74.14438,
                            11.33229
                        ],
                        [
                            -74.1915,
                            11.29999
                        ],
                        [
                            -74.23601,
                            11.21926
                        ],
                        [
                            -74.21767,
                            11.06963
                        ],
                        [
                            -74.31069,
                            10.98442
                        ],
                        [
                            -74.43991,
                            10.97603
                        ],
                        [
                            -74.60353,
                            11.01031
                        ],
                        [
                            -74.84898,
                            11.1035
                        ],
                        [
                            -74.84648,
                            11.06809
                        ],
                        [
                            -74.91686,
                            11.04318
                        ],
                        [
                            -74.96196,
                            10.9906
                        ],
                        [
                            -75.02265,
                            10.96784
                        ],
                        [
                            -75.05475,
                            10.89513
                        ],
                        [
                            -75.22475,
                            10.7991
                        ],
                        [
                            -75.26043,
                            10.79556
                        ],
                        [
                            -75.28149,
                            10.71234
                        ],
                        [
                            -75.38988,
                            10.68073
                        ],
                        [
                            -75.50881,
                            10.57066
                        ],
                        [
                            -75.4952,
                            10.48382
                        ],
                        [
                            -75.54906,
                            10.42204
                        ],
                        [
                            -75.51173,
                            10.37569
                        ],
                        [
                            -75.50697,
                            10.30484
                        ],
                        [
                            -75.56193,
                            10.26731
                        ],
                        [
                            -75.52392,
                            10.18228
                        ],
                        [
                            -75.57813,
                            10.11964
                        ],
                        [
                            -75.57711,
                            9.96996
                        ],
                        [
                            -75.6466,
                            9.75946
                        ],
                        [
                            -75.69201,
                            9.70995
                        ],
                        [
                            -75.61517,
                            9.69072
                        ],
                        [
                            -75.57304,
                            9.58135
                        ],
                        [
                            -75.6042,
                            9.4775
                        ],
                        [
                            -75.67497,
                            9.40768
                        ],
                        [
                            -75.92463,
                            9.44409
                        ],
                        [
                            -75.97062,
                            9.38473
                        ],
                        [
                            -76.08083,
                            9.33189
                        ],
                        [
                            -76.12426,
                            9.25263
                        ],
                        [
                            -76.16658,
                            9.22733
                        ],
                        [
                            -76.18882,
                            9.12049
                        ],
                        [
                            -76.25219,
                            9.05305
                        ],
                        [
                            -76.2689,
                            8.99813
                        ],
                        [
                            -76.33526,
                            8.9243
                        ],
                        [
                            -76.56146,
                            8.75446
                        ],
                        [
                            -76.62526,
                            8.7308
                        ],
                        [
                            -76.65146,
                            8.67266
                        ],
                        [
                            -76.77229,
                            8.63558
                        ],
                        [
                            -76.88061,
                            8.62128
                        ],
                        [
                            -76.93302,
                            8.55453
                        ],
                        [
                            -76.82714,
                            8.49619
                        ],
                        [
                            -76.76022,
                            8.39388
                        ],
                        [
                            -76.77164,
                            8.26459
                        ],
                        [
                            -76.74114,
                            8.17246
                        ],
                        [
                            -76.75202,
                            8.12102
                        ],
                        [
                            -76.71729,
                            8.05862
                        ],
                        [
                            -76.75358,
                            7.92073
                        ],
                        [
                            -76.80776,
                            7.90457
                        ],
                        [
                            -76.90669,
                            7.91185
                        ],
                        [
                            -76.93175,
                            7.9454
                        ],
                        [
                            -76.92262,
                            8.02402
                        ],
                        [
                            -76.86744,
                            8.06899
                        ],
                        [
                            -76.8404,
                            8.13758
                        ],
                        [
                            -76.94991,
                            8.12742
                        ],
                        [
                            -76.97018,
                            8.25624
                        ],
                        [
                            -77.03759,
                            8.25719
                        ],
                        [
                            -77.13304,
                            8.4109
                        ],
                        [
                            -77.24752,
                            8.4724
                        ],
                        [
                            -77.28534,
                            8.56627
                        ],
                        [
                            -77.36751,
                            8.67285
                        ],
                        [
                            -77.45504,
                            8.50775
                        ],
                        [
                            -77.39582,
                            8.45882
                        ],
                        [
                            -77.3572,
                            8.38997
                        ],
                        [
                            -77.33673,
                            8.27561
                        ],
                        [
                            -77.26586,
                            8.21539
                        ],
                        [
                            -77.21858,
                            8.08808
                        ],
                        [
                            -77.22661,
                            8.03028
                        ],
                        [
                            -77.16627,
                            7.9689
                        ],
                        [
                            -77.1886,
                            7.92464
                        ],
                        [
                            -77.33516,
                            7.89439
                        ],
                        [
                            -77.39097,
                            7.75794
                        ],
                        [
                            -77.56574,
                            7.50646
                        ],
                        [
                            -77.60994,
                            7.54257
                        ],
                        [
                            -77.6472,
                            7.65378
                        ],
                        [
                            -77.71862,
                            7.69547
                        ],
                        [
                            -77.74741,
                            7.6136
                        ],
                        [
                            -77.70441,
                            7.52106
                        ],
                        [
                            -77.74671,
                            7.46097
                        ],
                        [
                            -77.79321,
                            7.4775
                        ],
                        [
                            -77.893,
                            7.22175
                        ],
                        [
                            -77.70969,
                            7.07687
                        ],
                        [
                            -77.66261,
                            6.99337
                        ],
                        [
                            -77.70797,
                            6.87773
                        ],
                        [
                            -77.62187,
                            6.84343
                        ],
                        [
                            -77.57057,
                            6.7927
                        ],
                        [
                            -77.53613,
                            6.70107
                        ],
                        [
                            -77.44736,
                            6.7036
                        ],
                        [
                            -77.4075,
                            6.68378
                        ],
                        [
                            -77.39653,
                            6.62285
                        ],
                        [
                            -77.32865,
                            6.55173
                        ],
                        [
                            -77.36902,
                            6.42713
                        ],
                        [
                            -77.39824,
                            6.23947
                        ],
                        [
                            -77.46487,
                            6.27923
                        ],
                        [
                            -77.4792,
                            6.19022
                        ],
                        [
                            -77.4531,
                            6.13377
                        ],
                        [
                            -77.3346,
                            5.99324
                        ],
                        [
                            -77.30308,
                            5.8785
                        ],
                        [
                            -77.24746,
                            5.78927
                        ],
                        [
                            -77.26521,
                            5.71735
                        ],
                        [
                            -77.34097,
                            5.62177
                        ],
                        [
                            -77.424,
                            5.62148
                        ],
                        [
                            -77.49289,
                            5.59822
                        ],
                        [
                            -77.53104,
                            5.48796
                        ],
                        [
                            -77.45554,
                            5.48432
                        ],
                        [
                            -77.40881,
                            5.39871
                        ],
                        [
                            -77.38713,
                            5.27877
                        ],
                        [
                            -77.37504,
                            4.97262
                        ],
                        [
                            -77.32524,
                            4.72951
                        ],
                        [
                            -77.32623,
                            4.52432
                        ],
                        [
                            -77.34755,
                            4.42215
                        ],
                        [
                            -77.40528,
                            4.35429
                        ],
                        [
                            -77.42397,
                            4.2999
                        ],
                        [
                            -77.52361,
                            4.25149
                        ],
                        [
                            -77.52329,
                            4.13741
                        ],
                        [
                            -77.42856,
                            4.05295
                        ],
                        [
                            -77.43091,
                            4.01223
                        ],
                        [
                            -77.34548,
                            3.94168
                        ],
                        [
                            -77.29335,
                            4.04658
                        ],
                        [
                            -77.21448,
                            4.06282
                        ],
                        [
                            -77.21338,
                            4.01069
                        ],
                        [
                            -77.31304,
                            3.94726
                        ],
                        [
                            -77.29788,
                            3.86759
                        ],
                        [
                            -77.24673,
                            3.83255
                        ],
                        [
                            -77.10437,
                            3.84418
                        ],
                        [
                            -77.194,
                            3.73796
                        ],
                        [
                            -77.17091,
                            3.68668
                        ],
                        [
                            -77.19976,
                            3.61056
                        ],
                        [
                            -77.31203,
                            3.55129
                        ],
                        [
                            -77.36342,
                            3.48201
                        ],
                        [
                            -77.41132,
                            3.36769
                        ],
                        [
                            -77.44319,
                            3.35069
                        ],
                        [
                            -77.5379,
                            3.24249
                        ],
                        [
                            -77.57685,
                            3.14195
                        ],
                        [
                            -77.67037,
                            3.03569
                        ],
                        [
                            -77.69577,
                            2.98076
                        ],
                        [
                            -77.65985,
                            2.9489
                        ],
                        [
                            -77.7197,
                            2.82745
                        ],
                        [
                            -77.78682,
                            2.75721
                        ],
                        [
                            -77.78603,
                            2.68821
                        ],
                        [
                            -77.83937,
                            2.69923
                        ],
                        [
                            -77.90751,
                            2.67239
                        ],
                        [
                            -78.11905,
                            2.63034
                        ],
                        [
                            -78.15107,
                            2.67864
                        ],
                        [
                            -78.34211,
                            2.6481
                        ],
                        [
                            -78.4452,
                            2.59487
                        ],
                        [
                            -78.54537,
                            2.48846
                        ],
                        [
                            -78.61408,
                            2.38389
                        ],
                        [
                            -78.62156,
                            2.33988
                        ],
                        [
                            -78.70561,
                            2.18606
                        ],
                        [
                            -78.67025,
                            2.04024
                        ],
                        [
                            -78.58959,
                            1.96813
                        ],
                        [
                            -78.59698,
                            1.90156
                        ],
                        [
                            -78.54295,
                            1.86277
                        ],
                        [
                            -78.5641,
                            1.75765
                        ],
                        [
                            -78.60496,
                            1.79172
                        ],
                        [
                            -78.69879,
                            1.77791
                        ],
                        [
                            -78.76209,
                            1.80742
                        ],
                        [
                            -78.83671,
                            1.81357
                        ],
                        [
                            -79.00373,
                            1.6514
                        ],
                        [
                            -78.98865,
                            1.6041
                        ],
                        [
                            -78.81405,
                            1.47333
                        ],
                        [
                            -78.7509,
                            1.38882
                        ],
                        [
                            -78.67383,
                            1.2951
                        ],
                        [
                            -78.55028,
                            1.19503
                        ],
                        [
                            -78.4355,
                            1.14822
                        ],
                        [
                            -78.35581,
                            1.05077
                        ],
                        [
                            -78.19952,
                            0.99312
                        ],
                        [
                            -78.12071,
                            0.91335
                        ],
                        [
                            -77.96029,
                            0.81242
                        ],
                        [
                            -77.8429,
                            0.7972
                        ],
                        [
                            -77.70622,
                            0.83733
                        ],
                        [
                            -77.65611,
                            0.80177
                        ],
                        [
                            -77.69818,
                            0.75069
                        ],
                        [
                            -77.59839,
                            0.667
                        ],
                        [
                            -77.50217,
                            0.63187
                        ],
                        [
                            -77.4654,
                            0.3987
                        ],
                        [
                            -77.40216,
                            0.36191
                        ],
                        [
                            -77.37358,
                            0.38618
                        ],
                        [
                            -77.2539,
                            0.35242
                        ],
                        [
                            -77.12863,
                            0.37313
                        ],
                        [
                            -77.07955,
                            0.28793
                        ],
                        [
                            -76.90574,
                            0.24913
                        ],
                        [
                            -76.7804,
                            0.25286
                        ],
                        [
                            -76.72748,
                            0.2847
                        ],
                        [
                            -76.59594,
                            0.23407
                        ],
                        [
                            -76.55792,
                            0.25387
                        ],
                        [
                            -76.40438,
                            0.24925
                        ],
                        [
                            -76.40397,
                            0.3657
                        ],
                        [
                            -76.38474,
                            0.39667
                        ],
                        [
                            -76.27016,
                            0.44038
                        ],
                        [
                            -76.20984,
                            0.39866
                        ],
                        [
                            -76.13968,
                            0.39482
                        ],
                        [
                            -76.10136,
                            0.35312
                        ],
                        [
                            -76.01456,
                            0.32578
                        ],
                        [
                            -75.8822,
                            0.15625
                        ],
                        [
                            -75.80002,
                            0.09192
                        ],
                        [
                            -75.73361,
                            0.06471
                        ],
                        [
                            -75.61993,
                            0.07291
                        ],
                        [
                            -75.53287,
                            -0.01448
                        ],
                        [
                            -75.41445,
                            -0.07726
                        ],
                        [
                            -75.2882,
                            -0.09369
                        ],
                        [
                            -75.20623,
                            -0.0134
                        ],
                        [
                            -75.1143,
                            -0.03924
                        ],
                        [
                            -75.02044,
                            -0.09991
                        ],
                        [
                            -74.95709,
                            -0.16656
                        ],
                        [
                            -74.87524,
                            -0.1876
                        ],
                        [
                            -74.80442,
                            -0.16256
                        ],
                        [
                            -74.77738,
                            -0.26511
                        ],
                        [
                            -74.79912,
                            -0.29114
                        ],
                        [
                            -74.66081,
                            -0.3314
                        ],
                        [
                            -74.57432,
                            -0.40093
                        ],
                        [
                            -74.53328,
                            -0.46374
                        ],
                        [
                            -74.42173,
                            -0.51629
                        ],
                        [
                            -74.34152,
                            -0.69995
                        ],
                        [
                            -74.37756,
                            -0.74552
                        ],
                        [
                            -74.29179,
                            -0.83345
                        ],
                        [
                            -74.26095,
                            -0.84219
                        ],
                        [
                            -74.27121,
                            -1.00231
                        ],
                        [
                            -74.15848,
                            -1.03637
                        ],
                        [
                            -74.01272,
                            -1.12146
                        ],
                        [
                            -73.9014,
                            -1.1568
                        ],
                        [
                            -73.86222,
                            -1.24866
                        ],
                        [
                            -73.8106,
                            -1.26582
                        ],
                        [
                            -73.68264,
                            -1.25871
                        ],
                        [
                            -73.62191,
                            -1.29445
                        ],
                        [
                            -73.52547,
                            -1.4946
                        ],
                        [
                            -73.49037,
                            -1.51683
                        ],
                        [
                            -73.50396,
                            -1.65788
                        ],
                        [
                            -73.5315,
                            -1.73316
                        ],
                        [
                            -73.50025,
                            -1.76145
                        ],
                        [
                            -73.32885,
                            -1.83419
                        ],
                        [
                            -73.21328,
                            -1.77835
                        ],
                        [
                            -73.14375,
                            -1.83399
                        ],
                        [
                            -73.14115,
                            -1.89325
                        ],
                        [
                            -73.10055,
                            -1.92439
                        ],
                        [
                            -73.11266,
                            -2.03187
                        ],
                        [
                            -73.08652,
                            -2.06555
                        ],
                        [
                            -73.10031,
                            -2.16843
                        ],
                        [
                            -73.15558,
                            -2.24553
                        ],
                        [
                            -73.11052,
                            -2.36018
                        ],
                        [
                            -73.01274,
                            -2.35745
                        ],
                        [
                            -72.96099,
                            -2.38453
                        ],
                        [
                            -72.90469,
                            -2.49421
                        ],
                        [
                            -72.75317,
                            -2.42602
                        ],
                        [
                            -72.69232,
                            -2.42507
                        ],
                        [
                            -72.65644,
                            -2.47193
                        ],
                        [
                            -72.58786,
                            -2.39763
                        ],
                        [
                            -72.55727,
                            -2.425
                        ],
                        [
                            -72.44197,
                            -2.43163
                        ],
                        [
                            -72.38445,
                            -2.41716
                        ],
                        [
                            -72.34462,
                            -2.4895
                        ],
                        [
                            -72.23983,
                            -2.43892
                        ],
                        [
                            -72.11523,
                            -2.42515
                        ],
                        [
                            -72.03383,
                            -2.33162
                        ],
                        [
                            -71.98367,
                            -2.363
                        ],
                        [
                            -71.93255,
                            -2.35324
                        ],
                        [
                            -71.85233,
                            -2.27932
                        ],
                        [
                            -71.8223,
                            -2.18878
                        ],
                        [
                            -71.79413,
                            -2.19354
                        ],
                        [
                            -71.70994,
                            -2.13587
                        ],
                        [
                            -71.69162,
                            -2.21627
                        ],
                        [
                            -71.62941,
                            -2.19134
                        ],
                        [
                            -71.44482,
                            -2.26332
                        ],
                        [
                            -71.37712,
                            -2.34587
                        ],
                        [
                            -71.36536,
                            -2.39704
                        ],
                        [
                            -71.26481,
                            -2.33839
                        ],
                        [
                            -71.15252,
                            -2.34553
                        ],
                        [
                            -71.1142,
                            -2.28343
                        ],
                        [
                            -71.04861,
                            -2.26409
                        ],
                        [
                            -70.9598,
                            -2.20895
                        ],
                        [
                            -70.92526,
                            -2.24506
                        ],
                        [
                            -70.87963,
                            -2.21678
                        ],
                        [
                            -70.82767,
                            -2.2742
                        ],
                        [
                            -70.76584,
                            -2.28789
                        ],
                        [
                            -70.67523,
                            -2.34077
                        ],
                        [
                            -70.62793,
                            -2.45545
                        ],
                        [
                            -70.58176,
                            -2.48339
                        ],
                        [
                            -70.5211,
                            -2.45314
                        ],
                        [
                            -70.46146,
                            -2.45712
                        ],
                        [
                            -70.41908,
                            -2.52379
                        ],
                        [
                            -70.36676,
                            -2.49426
                        ],
                        [
                            -70.31472,
                            -2.57478
                        ],
                        [
                            -70.23251,
                            -2.56496
                        ],
                        [
                            -70.22427,
                            -2.62414
                        ],
                        [
                            -70.16158,
                            -2.69196
                        ],
                        [
                            -70.07219,
                            -2.67206
                        ],
                        [
                            -70.03665,
                            -2.76463
                        ],
                        [
                            -70.7023,
                            -3.79344
                        ],
                        [
                            -70.61356,
                            -3.84254
                        ],
                        [
                            -70.56648,
                            -3.83697
                        ],
                        [
                            -70.5216,
                            -3.87879
                        ],
                        [
                            -70.46236,
                            -3.87962
                        ],
                        [
                            -70.35802,
                            -3.80699
                        ],
                        [
                            -70.29578,
                            -3.81282
                        ],
                        [
                            -70.24281,
                            -3.87035
                        ],
                        [
                            -70.18701,
                            -3.89182
                        ],
                        [
                            -70.15172,
                            -3.98481
                        ],
                        [
                            -70.09081,
                            -4.03228
                        ],
                        [
                            -69.95342,
                            -4.23049
                        ],
                        [
                            -69.92876,
                            -4.20042
                        ],
                        [
                            -69.73771,
                            -3.12712
                        ],
                        [
                            -69.45331,
                            -1.55315
                        ],
                        [
                            -69.45837,
                            -1.4898
                        ],
                        [
                            -69.43587,
                            -1.40967
                        ],
                        [
                            -69.39947,
                            -1.3616
                        ],
                        [
                            -69.42886,
                            -1.22518
                        ],
                        [
                            -69.3965,
                            -1.12832
                        ],
                        [
                            -69.42733,
                            -1.07465
                        ],
                        [
                            -69.43818,
                            -0.9963
                        ],
                        [
                            -69.52516,
                            -0.92379
                        ],
                        [
                            -69.52702,
                            -0.8698
                        ],
                        [
                            -69.61913,
                            -0.74436
                        ],
                        [
                            -69.56635,
                            -0.63806
                        ],
                        [
                            -69.59932,
                            -0.59538
                        ],
                        [
                            -69.61191,
                            -0.50271
                        ],
                        [
                            -69.72587,
                            -0.44429
                        ],
                        [
                            -69.82649,
                            -0.37086
                        ],
                        [
                            -69.91539,
                            -0.32765
                        ],
                        [
                            -70.05304,
                            -0.175
                        ],
                        [
                            -70.04402,
                            -0.10128
                        ],
                        [
                            -70.04339,
                            0.55565
                        ],
                        [
                            -69.91272,
                            0.58574
                        ],
                        [
                            -69.80238,
                            0.57534
                        ],
                        [
                            -69.72664,
                            0.61473
                        ],
                        [
                            -69.67619,
                            0.66513
                        ],
                        [
                            -69.60371,
                            0.63202
                        ],
                        [
                            -69.56561,
                            0.67828
                        ],
                        [
                            -69.47417,
                            0.73436
                        ],
                        [
                            -69.35457,
                            0.61771
                        ],
                        [
                            -69.29077,
                            0.64797
                        ],
                        [
                            -69.2754,
                            0.60288
                        ],
                        [
                            -69.20269,
                            0.60833
                        ],
                        [
                            -69.18609,
                            0.65095
                        ],
                        [
                            -69.11922,
                            0.65486
                        ],
                        [
                            -69.18727,
                            0.73867
                        ],
                        [
                            -69.14876,
                            0.76899
                        ],
                        [
                            -69.16604,
                            0.82024
                        ],
                        [
                            -69.14072,
                            0.87965
                        ],
                        [
                            -69.24658,
                            1.05518
                        ],
                        [
                            -69.32159,
                            1.08669
                        ],
                        [
                            -69.38257,
                            1.07359
                        ],
                        [
                            -69.56289,
                            1.07205
                        ],
                        [
                            -69.59984,
                            1.09415
                        ],
                        [
                            -69.6816,
                            1.07094
                        ],
                        [
                            -69.74141,
                            1.11384
                        ],
                        [
                            -69.8193,
                            1.06612
                        ],
                        [
                            -69.84487,
                            1.08026
                        ],
                        [
                            -69.84337,
                            1.71353
                        ],
                        [
                            -69.81548,
                            1.69625
                        ],
                        [
                            -69.73256,
                            1.73146
                        ],
                        [
                            -69.63172,
                            1.72346
                        ],
                        [
                            -69.53858,
                            1.7757
                        ],
                        [
                            -69.38815,
                            1.72898
                        ],
                        [
                            -68.64918,
                            1.72907
                        ],
                        [
                            -68.19005,
                            1.72913
                        ],
                        [
                            -68.28019,
                            1.848
                        ],
                        [
                            -68.21529,
                            1.9676
                        ],
                        [
                            -68.12889,
                            1.96937
                        ],
                        [
                            -68.014,
                            1.774
                        ],
                        [
                            -67.96986,
                            1.74717
                        ],
                        [
                            -67.88677,
                            1.75397
                        ],
                        [
                            -67.8168,
                            1.78286
                        ],
                        [
                            -67.69854,
                            1.91897
                        ],
                        [
                            -67.64167,
                            2.00874
                        ],
                        [
                            -67.50812,
                            2.11532
                        ],
                        [
                            -67.4326,
                            2.14709
                        ],
                        [
                            -67.34672,
                            2.1109
                        ],
                        [
                            -67.29632,
                            1.99513
                        ],
                        [
                            -67.15705,
                            1.80575
                        ],
                        [
                            -67.11352,
                            1.73154
                        ],
                        [
                            -67.0624,
                            1.52912
                        ],
                        [
                            -67.09807,
                            1.29131
                        ],
                        [
                            -67.08658,
                            1.16886
                        ],
                        [
                            -66.86983,
                            1.22565
                        ],
                        [
                            -66.8936,
                            1.27432
                        ],
                        [
                            -66.88521,
                            1.35961
                        ],
                        [
                            -66.92564,
                            1.41832
                        ],
                        [
                            -66.93046,
                            1.48053
                        ],
                        [
                            -66.97465,
                            1.58725
                        ],
                        [
                            -66.97757,
                            1.6475
                        ],
                        [
                            -67.07852,
                            1.9283
                        ],
                        [
                            -67.11834,
                            1.9751
                        ],
                        [
                            -67.11346,
                            2.11056
                        ],
                        [
                            -67.15722,
                            2.12218
                        ],
                        [
                            -67.21041,
                            2.24794
                        ],
                        [
                            -67.17378,
                            2.34107
                        ],
                        [
                            -67.19235,
                            2.38697
                        ],
                        [
                            -67.27688,
                            2.43706
                        ],
                        [
                            -67.39246,
                            2.56661
                        ],
                        [
                            -67.47825,
                            2.62137
                        ],
                        [
                            -67.49527,
                            2.6708
                        ],
                        [
                            -67.57115,
                            2.68348
                        ],
                        [
                            -67.56827,
                            2.72909
                        ],
                        [
                            -67.61587,
                            2.81121
                        ],
                        [
                            -67.7135,
                            2.81289
                        ],
                        [
                            -67.74182,
                            2.8396
                        ],
                        [
                            -67.82493,
                            2.82598
                        ],
                        [
                            -67.85192,
                            2.87171
                        ],
                        [
                            -67.38492,
                            3.28881
                        ],
                        [
                            -67.30981,
                            3.3796
                        ],
                        [
                            -67.31079,
                            3.4339
                        ],
                        [
                            -67.38883,
                            3.4949
                        ],
                        [
                            -67.44797,
                            3.65857
                        ],
                        [
                            -67.51628,
                            3.74605
                        ],
                        [
                            -67.5888,
                            3.73873
                        ],
                        [
                            -67.62564,
                            3.77768
                        ],
                        [
                            -67.67914,
                            3.919
                        ],
                        [
                            -67.73494,
                            4.11414
                        ],
                        [
                            -67.80625,
                            4.22276
                        ],
                        [
                            -67.78382,
                            4.34118
                        ],
                        [
                            -67.83348,
                            4.49025
                        ],
                        [
                            -67.87712,
                            4.53273
                        ],
                        [
                            -67.82706,
                            4.73292
                        ],
                        [
                            -67.82881,
                            4.90932
                        ],
                        [
                            -67.79509,
                            5.04083
                        ],
                        [
                            -67.79729,
                            5.10139
                        ],
                        [
                            -67.84903,
                            5.27714
                        ],
                        [
                            -67.77577,
                            5.39329
                        ],
                        [
                            -67.65945,
                            5.46447
                        ],
                        [
                            -67.61455,
                            5.5334
                        ],
                        [
                            -67.63743,
                            5.59465
                        ],
                        [
                            -67.64197,
                            5.70686
                        ],
                        [
                            -67.57765,
                            5.8495
                        ],
                        [
                            -67.46355,
                            5.94877
                        ],
                        [
                            -67.42296,
                            6.00468
                        ],
                        [
                            -67.48334,
                            6.08888
                        ],
                        [
                            -67.47528,
                            6.19105
                        ],
                        [
                            -67.55298,
                            6.24951
                        ],
                        [
                            -67.63372,
                            6.27952
                        ],
                        [
                            -67.83806,
                            6.30099
                        ],
                        [
                            -67.97165,
                            6.21147
                        ],
                        [
                            -68.14504,
                            6.22322
                        ],
                        [
                            -68.30282,
                            6.17141
                        ],
                        [
                            -68.45797,
                            6.18948
                        ],
                        [
                            -68.67125,
                            6.13532
                        ],
                        [
                            -68.83235,
                            6.1817
                        ],
                        [
                            -68.92854,
                            6.17604
                        ],
                        [
                            -69.0484,
                            6.21172
                        ],
                        [
                            -69.10807,
                            6.1859
                        ],
                        [
                            -69.21758,
                            6.08906
                        ],
                        [
                            -69.28082,
                            6.09608
                        ],
                        [
                            -69.31724,
                            6.1432
                        ],
                        [
                            -69.4482,
                            6.11797
                        ],
                        [
                            -69.95808,
                            6.83005
                        ],
                        [
                            -70.08043,
                            6.99372
                        ],
                        [
                            -70.22496,
                            6.9706
                        ],
                        [
                            -70.3181,
                            6.93375
                        ],
                        [
                            -70.38663,
                            6.98006
                        ],
                        [
                            -70.49992,
                            7.00671
                        ],
                        [
                            -70.55951,
                            7.07482
                        ],
                        [
                            -70.63531,
                            7.06484
                        ],
                        [
                            -70.69208,
                            7.09078
                        ],
                        [
                            -70.88699,
                            7.057
                        ],
                        [
                            -70.95356,
                            6.98647
                        ],
                        [
                            -71.09482,
                            6.98417
                        ],
                        [
                            -71.13346,
                            7.02465
                        ],
                        [
                            -71.33265,
                            7.01321
                        ],
                        [
                            -71.42253,
                            7.03293
                        ],
                        [
                            -71.46349,
                            7.01251
                        ],
                        [
                            -71.6524,
                            7.05044
                        ],
                        [
                            -71.79687,
                            7.05682
                        ],
                        [
                            -71.83991,
                            7.00829
                        ],
                        [
                            -72.00805,
                            7.00918
                        ],
                        [
                            -72.03153,
                            7.02215
                        ],
                        [
                            -72.1713,
                            7.24865
                        ],
                        [
                            -72.16652,
                            7.3268
                        ],
                        [
                            -72.20279,
                            7.37961
                        ],
                        [
                            -72.43632,
                            7.40054
                        ],
                        [
                            -72.47947,
                            7.48629
                        ],
                        [
                            -72.45733,
                            7.56008
                        ],
                        [
                            -72.47893,
                            7.6276
                        ],
                        [
                            -72.47045,
                            7.7928
                        ],
                        [
                            -72.44967,
                            7.83108
                        ],
                        [
                            -72.48562,
                            7.93522
                        ],
                        [
                            -72.42096,
                            7.99378
                        ],
                        [
                            -72.41139,
                            8.03746
                        ],
                        [
                            -72.34622,
                            8.04967
                        ],
                        [
                            -72.37271,
                            8.10929
                        ],
                        [
                            -72.35544,
                            8.1689
                        ],
                        [
                            -72.39024,
                            8.26134
                        ],
                        [
                            -72.39442,
                            8.36342
                        ],
                        [
                            -72.42842,
                            8.39018
                        ],
                        [
                            -72.58519,
                            8.56849
                        ],
                        [
                            -72.65191,
                            8.62444
                        ],
                        [
                            -72.74255,
                            9.01063
                        ],
                        [
                            -72.77952,
                            9.11531
                        ],
                        [
                            -72.8777,
                            9.13464
                        ],
                        [
                            -72.92563,
                            9.0883
                        ],
                        [
                            -72.96938,
                            9.13874
                        ],
                        [
                            -72.96372,
                            9.20499
                        ],
                        [
                            -73.00236,
                            9.29115
                        ],
                        [
                            -73.17204,
                            9.18478
                        ],
                        [
                            -73.2527,
                            9.1651
                        ],
                        [
                            -73.37267,
                            9.18101
                        ],
                        [
                            -73.31561,
                            9.24006
                        ],
                        [
                            -73.23332,
                            9.41228
                        ],
                        [
                            -73.19477,
                            9.44165
                        ],
                        [
                            -73.14668,
                            9.54363
                        ],
                        [
                            -73.08116,
                            9.56735
                        ],
                        [
                            -73.05029,
                            9.68296
                        ],
                        [
                            -72.94791,
                            9.84188
                        ],
                        [
                            -72.98912,
                            9.88192
                        ],
                        [
                            -72.98912,
                            9.93118
                        ],
                        [
                            -72.9482,
                            10.06161
                        ],
                        [
                            -72.91455,
                            10.10901
                        ],
                        [
                            -72.90318,
                            10.34082
                        ],
                        [
                            -72.88995,
                            10.45389
                        ],
                        [
                            -72.84373,
                            10.49293
                        ],
                        [
                            -72.82199,
                            10.57278
                        ],
                        [
                            -72.75061,
                            10.6426
                        ],
                        [
                            -72.68082,
                            10.77462
                        ],
                        [
                            -72.64322,
                            10.88151
                        ],
                        [
                            -72.5612,
                            10.93656
                        ],
                        [
                            -72.46744,
                            11.1109
                        ],
                        [
                            -72.34198,
                            11.15711
                        ],
                        [
                            -72.23779,
                            11.15236
                        ],
                        [
                            -71.966,
                            11.65005
                        ],
                        [
                            -71.77776,
                            11.69445
                        ],
                        [
                            -71.38615,
                            11.81418
                        ],
                        [
                            -71.38483,
                            11.83033
                        ],
                        [
                            -71.32407,
                            11.84566
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "COM",
                "Country": "Comoros",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    1.696e-08,
                    3.3984e-08,
                    5.1066e-08,
                    6.8204e-08,
                    8.5393e-08,
                    1.0263e-07,
                    1.1991e-07,
                    1.3724e-07,
                    1.5459e-07,
                    1.7218e-07,
                    1.9003e-07,
                    2.081e-07,
                    2.2637e-07,
                    2.4482e-07,
                    2.6346e-07,
                    2.8227e-07,
                    3.0126e-07,
                    3.2041e-07,
                    3.3973e-07,
                    3.5946e-07,
                    3.795e-07,
                    3.998e-07,
                    4.2036e-07,
                    4.4117e-07,
                    4.6223e-07,
                    4.8356e-07,
                    5.0512e-07,
                    5.2692e-07,
                    5.4893e-07,
                    5.7137e-07,
                    5.9396e-07,
                    6.1666e-07,
                    6.3945e-07,
                    6.6232e-07,
                    6.8526e-07,
                    7.0824e-07,
                    7.3127e-07,
                    7.5437e-07,
                    7.7751e-07,
                    8.0099e-07,
                    8.2462e-07,
                    8.4837e-07,
                    8.722e-07,
                    8.9612e-07,
                    9.2012e-07,
                    9.4419e-07,
                    9.6834e-07,
                    9.9254e-07,
                    1.0168e-06,
                    1.0414e-06,
                    1.0658e-06,
                    1.09e-06,
                    1.114e-06,
                    1.1376e-06,
                    1.161e-06,
                    1.1841e-06,
                    1.207e-06,
                    1.2295e-06,
                    1.2518e-06,
                    1.274e-06,
                    1.2985e-06,
                    1.3252e-06,
                    1.3541e-06,
                    1.3852e-06,
                    1.4185e-06,
                    1.4541e-06,
                    1.4919e-06,
                    1.532e-06,
                    1.5744e-06,
                    1.6193e-06,
                    1.6675e-06,
                    1.7191e-06,
                    1.774e-06,
                    1.8322e-06,
                    1.8937e-06,
                    1.9586e-06,
                    2.0269e-06,
                    2.0985e-06,
                    2.1734e-06,
                    2.2519e-06,
                    2.3323e-06,
                    2.4145e-06,
                    2.4985e-06,
                    2.5842e-06,
                    2.6717e-06,
                    2.7614e-06,
                    2.8533e-06,
                    2.9479e-06,
                    3.0449e-06,
                    3.1448e-06,
                    3.2484e-06,
                    3.3562e-06,
                    3.4688e-06,
                    3.5867e-06,
                    3.7099e-06,
                    3.8384e-06,
                    3.9721e-06,
                    4.1104e-06,
                    4.253e-06,
                    4.4119e-06,
                    4.5802e-06,
                    4.7536e-06,
                    4.9301e-06,
                    5.1093e-06,
                    5.2907e-06,
                    5.4739e-06,
                    5.6584e-06,
                    5.8447e-06,
                    6.0382e-06,
                    6.2192e-06,
                    6.3649e-06,
                    6.5112e-06,
                    6.6763e-06,
                    6.8455e-06,
                    7.0467e-06,
                    7.2696e-06,
                    7.4711e-06,
                    7.6424e-06,
                    7.8132e-06,
                    7.9949e-06,
                    8.1772e-06,
                    8.3602e-06,
                    8.5461e-06,
                    8.7385e-06,
                    8.9356e-06,
                    9.1502e-06,
                    9.43e-06,
                    9.6822e-06,
                    9.9359e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    1.9459e-09,
                    3.8951e-09,
                    5.8476e-09,
                    7.8033e-09,
                    9.7621e-09,
                    1.1724e-08,
                    1.3689e-08,
                    1.5657e-08,
                    1.7628e-08,
                    1.9601e-08,
                    2.1606e-08,
                    2.3641e-08,
                    2.5708e-08,
                    2.7805e-08,
                    2.9934e-08,
                    3.2093e-08,
                    3.4284e-08,
                    3.6506e-08,
                    3.8759e-08,
                    4.1043e-08,
                    4.3375e-08,
                    4.5741e-08,
                    4.8141e-08,
                    5.0575e-08,
                    5.3045e-08,
                    5.555e-08,
                    5.8089e-08,
                    6.0664e-08,
                    6.3272e-08,
                    6.5912e-08,
                    6.856e-08,
                    7.1213e-08,
                    7.3872e-08,
                    7.6538e-08,
                    7.9209e-08,
                    8.1887e-08,
                    8.457e-08,
                    8.7259e-08,
                    8.9954e-08,
                    9.2659e-08,
                    9.5358e-08,
                    9.8064e-08,
                    1.0078e-07,
                    1.035e-07,
                    1.0623e-07,
                    1.0897e-07,
                    1.1172e-07,
                    1.1447e-07,
                    1.1724e-07,
                    1.2001e-07,
                    1.2284e-07,
                    1.2572e-07,
                    1.2867e-07,
                    1.3167e-07,
                    1.3473e-07,
                    1.3784e-07,
                    1.4101e-07,
                    1.4423e-07,
                    1.4751e-07,
                    1.5084e-07,
                    1.5472e-07,
                    1.5917e-07,
                    1.6417e-07,
                    1.6975e-07,
                    1.7591e-07,
                    1.8268e-07,
                    1.9005e-07,
                    1.9803e-07,
                    2.0664e-07,
                    2.1588e-07,
                    2.2591e-07,
                    2.3676e-07,
                    2.4844e-07,
                    2.6099e-07,
                    2.7441e-07,
                    2.8875e-07,
                    3.0401e-07,
                    3.2022e-07,
                    3.3741e-07,
                    3.556e-07,
                    3.745e-07,
                    3.9415e-07,
                    4.1456e-07,
                    4.3577e-07,
                    4.5779e-07,
                    4.8064e-07,
                    5.0434e-07,
                    5.2918e-07,
                    5.5501e-07,
                    5.8185e-07,
                    6.0995e-07,
                    6.3936e-07,
                    6.7011e-07,
                    7.0225e-07,
                    7.3565e-07,
                    7.7028e-07,
                    8.0615e-07,
                    8.4316e-07,
                    8.8129e-07,
                    9.2052e-07,
                    9.6151e-07,
                    1.0035e-06,
                    1.0462e-06,
                    1.0895e-06,
                    1.1331e-06,
                    1.1771e-06,
                    1.2212e-06,
                    1.2653e-06,
                    1.3148e-06,
                    1.3643e-06,
                    1.4131e-06,
                    1.4611e-06,
                    1.5084e-06,
                    1.5549e-06,
                    1.6026e-06,
                    1.6517e-06,
                    1.7006e-06,
                    1.7495e-06,
                    1.7983e-06,
                    1.86e-06,
                    1.9258e-06,
                    1.9933e-06,
                    2.0629e-06,
                    2.1345e-06,
                    2.2131e-06,
                    2.3023e-06,
                    2.3973e-06,
                    2.4936e-06,
                    2.5922e-06,
                    2.7088e-06,
                    2.8318e-06,
                    2.961e-06,
                    3.0963e-06,
                    3.2379e-06,
                    3.3865e-06,
                    3.5407e-06,
                    3.7049e-06,
                    3.8782e-06,
                    4.061e-06,
                    4.2844e-06,
                    4.51e-06,
                    4.745e-06,
                    4.9889e-06,
                    5.2373e-06,
                    5.4957e-06,
                    5.758e-06,
                    6.0254e-06,
                    6.2987e-06,
                    6.583e-06,
                    6.8799e-06,
                    7.1804e-06,
                    7.4863e-06,
                    7.8109e-06,
                    8.1468e-06,
                    8.4871e-06,
                    8.8387e-06,
                    9.1657e-06,
                    9.4989e-06,
                    9.8487e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [
                    1.5014e-08,
                    3.0089e-08,
                    4.5218e-08,
                    6.0401e-08,
                    7.563e-08,
                    9.0905e-08,
                    1.0622e-07,
                    1.2158e-07,
                    1.3697e-07,
                    1.5258e-07,
                    1.6842e-07,
                    1.8446e-07,
                    2.0066e-07,
                    2.1702e-07,
                    2.3353e-07,
                    2.5018e-07,
                    2.6698e-07,
                    2.8391e-07,
                    3.0097e-07,
                    3.1842e-07,
                    3.3613e-07,
                    3.5406e-07,
                    3.7222e-07,
                    3.906e-07,
                    4.0919e-07,
                    4.2801e-07,
                    4.4703e-07,
                    4.6625e-07,
                    4.8566e-07,
                    5.0545e-07,
                    5.254e-07,
                    5.4545e-07,
                    5.6558e-07,
                    5.8578e-07,
                    6.0605e-07,
                    6.2635e-07,
                    6.467e-07,
                    6.6711e-07,
                    6.8755e-07,
                    7.0833e-07,
                    7.2926e-07,
                    7.503e-07,
                    7.7142e-07,
                    7.9262e-07,
                    8.1389e-07,
                    8.3522e-07,
                    8.5662e-07,
                    8.7807e-07,
                    8.9958e-07,
                    9.2141e-07,
                    9.43e-07,
                    9.643e-07,
                    9.853e-07,
                    1.006e-06,
                    1.0263e-06,
                    1.0463e-06,
                    1.0659e-06,
                    1.0853e-06,
                    1.1043e-06,
                    1.1232e-06,
                    1.1438e-06,
                    1.166e-06,
                    1.1899e-06,
                    1.2154e-06,
                    1.2426e-06,
                    1.2714e-06,
                    1.3019e-06,
                    1.334e-06,
                    1.3677e-06,
                    1.4034e-06,
                    1.4416e-06,
                    1.4823e-06,
                    1.5255e-06,
                    1.5712e-06,
                    1.6193e-06,
                    1.6699e-06,
                    1.7229e-06,
                    1.7783e-06,
                    1.836e-06,
                    1.8963e-06,
                    1.9578e-06,
                    2.0204e-06,
                    2.0839e-06,
                    2.1484e-06,
                    2.2139e-06,
                    2.2807e-06,
                    2.349e-06,
                    2.4187e-06,
                    2.4899e-06,
                    2.563e-06,
                    2.6384e-06,
                    2.7168e-06,
                    2.7987e-06,
                    2.8844e-06,
                    2.9742e-06,
                    3.0681e-06,
                    3.1659e-06,
                    3.2673e-06,
                    3.3717e-06,
                    3.4914e-06,
                    3.6186e-06,
                    3.7501e-06,
                    3.8839e-06,
                    4.0198e-06,
                    4.1576e-06,
                    4.2968e-06,
                    4.4372e-06,
                    4.5794e-06,
                    4.7234e-06,
                    4.8549e-06,
                    4.9518e-06,
                    5.05e-06,
                    5.1679e-06,
                    5.2907e-06,
                    5.4441e-06,
                    5.6179e-06,
                    5.7705e-06,
                    5.8929e-06,
                    6.015e-06,
                    6.1349e-06,
                    6.2514e-06,
                    6.3668e-06,
                    6.4832e-06,
                    6.604e-06,
                    6.7225e-06,
                    6.8479e-06,
                    7.0327e-06,
                    7.1887e-06,
                    7.3437e-06,
                    7.4855e-06,
                    7.6441e-06,
                    7.7885e-06,
                    8.0162e-06,
                    8.1838e-06,
                    8.2835e-06,
                    8.3791e-06,
                    8.4708e-06,
                    8.5745e-06,
                    8.6742e-06,
                    8.768e-06,
                    8.8704e-06,
                    8.9694e-06,
                    9.1258e-06,
                    9.2662e-06,
                    9.4065e-06,
                    9.5401e-06,
                    9.6967e-06,
                    9.8453e-06,
                    9.9662e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    6.963e-09,
                    1.3965e-08,
                    2.0999e-08,
                    2.8066e-08,
                    3.5162e-08,
                    4.2284e-08,
                    4.9434e-08,
                    5.6606e-08,
                    6.38e-08,
                    7.1214e-08,
                    7.8727e-08,
                    8.6323e-08,
                    9.3962e-08,
                    1.0164e-07,
                    1.0935e-07,
                    1.1708e-07,
                    1.2484e-07,
                    1.3261e-07,
                    1.404e-07,
                    1.4845e-07,
                    1.5662e-07,
                    1.6486e-07,
                    1.7315e-07,
                    1.8146e-07,
                    1.8979e-07,
                    1.9815e-07,
                    2.0651e-07,
                    2.149e-07,
                    2.2329e-07,
                    2.3191e-07,
                    2.4066e-07,
                    2.4946e-07,
                    2.5832e-07,
                    2.6722e-07,
                    2.7615e-07,
                    2.851e-07,
                    2.9406e-07,
                    3.0305e-07,
                    3.1205e-07,
                    3.2128e-07,
                    3.3062e-07,
                    3.4004e-07,
                    3.495e-07,
                    3.59e-07,
                    3.6853e-07,
                    3.7809e-07,
                    3.8767e-07,
                    3.9726e-07,
                    4.0687e-07,
                    4.1676e-07,
                    4.2677e-07,
                    4.3687e-07,
                    4.4702e-07,
                    4.5721e-07,
                    4.6743e-07,
                    4.7768e-07,
                    4.8793e-07,
                    4.9821e-07,
                    5.0852e-07,
                    5.1911e-07,
                    5.2983e-07,
                    5.4064e-07,
                    5.515e-07,
                    5.6242e-07,
                    5.7335e-07,
                    5.843e-07,
                    5.9528e-07,
                    6.0626e-07,
                    6.1726e-07,
                    6.2857e-07,
                    6.4002e-07,
                    6.5155e-07,
                    6.6316e-07,
                    6.7479e-07,
                    6.8645e-07,
                    6.9814e-07,
                    7.0985e-07,
                    7.2158e-07,
                    7.3333e-07,
                    7.4539e-07,
                    7.5761e-07,
                    7.6992e-07,
                    7.8228e-07,
                    7.9471e-07,
                    8.0714e-07,
                    8.1959e-07,
                    8.3209e-07,
                    8.4459e-07,
                    8.5711e-07,
                    8.7001e-07,
                    8.8306e-07,
                    8.9621e-07,
                    9.0941e-07,
                    9.2266e-07,
                    9.3595e-07,
                    9.4927e-07,
                    9.6263e-07,
                    9.7601e-07,
                    9.8941e-07,
                    1.0156e-06,
                    1.0465e-06,
                    1.0794e-06,
                    1.1129e-06,
                    1.1471e-06,
                    1.1819e-06,
                    1.2172e-06,
                    1.2527e-06,
                    1.2888e-06,
                    1.3301e-06,
                    1.3572e-06,
                    1.3777e-06,
                    1.3945e-06,
                    1.4089e-06,
                    1.4217e-06,
                    1.4351e-06,
                    1.4493e-06,
                    1.4627e-06,
                    1.4756e-06,
                    1.4879e-06,
                    1.5048e-06,
                    1.5213e-06,
                    1.5375e-06,
                    1.5533e-06,
                    1.569e-06,
                    1.5861e-06,
                    1.6063e-06,
                    1.6844e-06,
                    1.7267e-06,
                    1.7538e-06,
                    1.7868e-06,
                    1.8167e-06,
                    1.8447e-06,
                    1.9868e-06,
                    2.0669e-06,
                    2.1231e-06,
                    2.2007e-06,
                    2.2669e-06,
                    2.3177e-06,
                    2.3604e-06,
                    2.4051e-06,
                    2.4584e-06,
                    2.5052e-06,
                    2.608e-06,
                    2.7011e-06,
                    2.7928e-06,
                    2.8853e-06,
                    3.0032e-06,
                    3.111e-06,
                    3.2027e-06,
                    3.3028e-06,
                    3.3825e-06,
                    3.4531e-06,
                    3.5313e-06,
                    3.604e-06,
                    3.674e-06,
                    3.7531e-06,
                    3.8052e-06,
                    3.8592e-06,
                    3.9238e-06,
                    4.002e-06,
                    4.0725e-06,
                    4.1536e-06,
                    4.2425e-06,
                    4.3198e-06,
                    4.3991e-06,
                    4.492e-06,
                    4.6109e-06,
                    4.7416e-06,
                    4.8782e-06,
                    5.0437e-06,
                    5.2231e-06,
                    5.4005e-06
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    4.95e-09,
                    9.9e-09,
                    1.485e-08,
                    1.98e-08,
                    2.475e-08,
                    2.97e-08,
                    3.63e-08,
                    4.455e-08,
                    5.28e-08,
                    6.105e-08,
                    6.93e-08,
                    8.25e-08,
                    9.57e-08,
                    1.089e-07,
                    1.221e-07,
                    1.353e-07,
                    1.5015e-07,
                    1.683e-07,
                    1.8645e-07,
                    1.9965e-07,
                    2.0955e-07,
                    2.31e-07,
                    2.5245e-07,
                    2.739e-07,
                    2.9535e-07,
                    3.168e-07,
                    3.3825e-07,
                    3.5805e-07,
                    3.795e-07,
                    4.026e-07,
                    4.257e-07,
                    4.554e-07,
                    4.851e-07,
                    5.1645e-07,
                    5.4945e-07,
                    5.8245e-07,
                    6.171e-07,
                    6.534e-07,
                    6.9135e-07,
                    7.326e-07,
                    7.755e-07,
                    8.217e-07,
                    8.6955e-07,
                    9.174e-07,
                    9.7845e-07,
                    1.0445e-06,
                    1.1088e-06,
                    1.1831e-06,
                    1.2309e-06,
                    1.2804e-06,
                    1.3415e-06,
                    1.4141e-06,
                    1.4784e-06,
                    1.5477e-06,
                    1.6302e-06,
                    1.7028e-06,
                    1.7837e-06,
                    1.881e-06,
                    2.0015e-06,
                    2.1334e-06,
                    2.2737e-06,
                    2.4453e-06,
                    2.6322e-06,
                    2.8181e-06
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [
                    6.963e-09,
                    1.3965e-08,
                    2.0999e-08,
                    2.8066e-08,
                    3.5162e-08,
                    4.2284e-08,
                    4.9434e-08,
                    5.6606e-08,
                    6.38e-08,
                    7.1214e-08,
                    7.8727e-08,
                    8.6323e-08,
                    9.3962e-08,
                    1.0164e-07,
                    1.0935e-07,
                    1.1708e-07,
                    1.2484e-07,
                    1.3261e-07,
                    1.404e-07,
                    1.4845e-07,
                    1.5662e-07,
                    1.6486e-07,
                    1.7315e-07,
                    1.8146e-07,
                    1.8979e-07,
                    1.9815e-07,
                    2.0651e-07,
                    2.149e-07,
                    2.2329e-07,
                    2.3191e-07,
                    2.4066e-07,
                    2.4946e-07,
                    2.5832e-07,
                    2.6722e-07,
                    2.7615e-07,
                    2.851e-07,
                    2.9406e-07,
                    3.0305e-07,
                    3.1205e-07,
                    3.2128e-07,
                    3.3062e-07,
                    3.4004e-07,
                    3.495e-07,
                    3.59e-07,
                    3.6853e-07,
                    3.7809e-07,
                    3.8767e-07,
                    3.9726e-07,
                    4.0687e-07,
                    4.1676e-07,
                    4.2677e-07,
                    4.3687e-07,
                    4.4702e-07,
                    4.5721e-07,
                    4.6743e-07,
                    4.7768e-07,
                    4.8793e-07,
                    4.9821e-07,
                    5.0852e-07,
                    5.1911e-07,
                    5.2983e-07,
                    5.4064e-07,
                    5.515e-07,
                    5.6242e-07,
                    5.7335e-07,
                    5.843e-07,
                    5.9528e-07,
                    6.0626e-07,
                    6.1726e-07,
                    6.2857e-07,
                    6.4002e-07,
                    6.5155e-07,
                    6.6316e-07,
                    6.7479e-07,
                    6.8645e-07,
                    6.9814e-07,
                    7.0985e-07,
                    7.2158e-07,
                    7.3333e-07,
                    7.4539e-07,
                    7.5761e-07,
                    7.6992e-07,
                    7.8228e-07,
                    7.9471e-07,
                    8.0714e-07,
                    8.1959e-07,
                    8.3209e-07,
                    8.4459e-07,
                    8.5711e-07,
                    8.7001e-07,
                    8.8306e-07,
                    8.9621e-07,
                    9.0941e-07,
                    9.2266e-07,
                    9.3595e-07,
                    9.4927e-07,
                    9.6263e-07,
                    9.7601e-07,
                    9.8941e-07,
                    1.0156e-06,
                    1.0465e-06,
                    1.0794e-06,
                    1.1129e-06,
                    1.1471e-06,
                    1.1819e-06,
                    1.2172e-06,
                    1.2527e-06,
                    1.2888e-06,
                    1.3252e-06,
                    1.3473e-06,
                    1.3629e-06,
                    1.3747e-06,
                    1.3841e-06,
                    1.392e-06,
                    1.3988e-06,
                    1.4047e-06,
                    1.4099e-06,
                    1.4145e-06,
                    1.4186e-06,
                    1.4223e-06,
                    1.4256e-06,
                    1.4286e-06,
                    1.4312e-06,
                    1.4337e-06,
                    1.4359e-06,
                    1.438e-06,
                    1.498e-06,
                    1.5271e-06,
                    1.5443e-06,
                    1.5558e-06,
                    1.5642e-06,
                    1.5708e-06,
                    1.6915e-06,
                    1.7501e-06,
                    1.7848e-06,
                    1.8427e-06,
                    1.8874e-06,
                    1.9151e-06,
                    1.9347e-06,
                    1.9497e-06,
                    1.9733e-06,
                    1.9888e-06,
                    2.0586e-06,
                    2.1186e-06,
                    2.1757e-06,
                    2.2319e-06,
                    2.3118e-06,
                    2.3784e-06,
                    2.4272e-06,
                    2.4811e-06,
                    2.5129e-06,
                    2.5357e-06,
                    2.5528e-06,
                    2.5595e-06,
                    2.5652e-06,
                    2.5701e-06,
                    2.5743e-06,
                    2.5788e-06,
                    2.5823e-06,
                    2.5879e-06,
                    2.5941e-06,
                    2.6059e-06,
                    2.6123e-06,
                    2.617e-06,
                    2.6155e-06,
                    2.611e-06,
                    2.6094e-06,
                    2.6082e-06,
                    2.6045e-06,
                    2.5984e-06,
                    2.5908e-06,
                    2.5824e-06
                ],
                "Total_CH4": 0.01,
                "Total_CH4_timeseries": [
                    9.0763e-09,
                    1.816e-08,
                    2.7252e-08,
                    3.6352e-08,
                    4.5459e-08,
                    5.4575e-08,
                    6.3698e-08,
                    7.2829e-08,
                    8.1968e-08,
                    9.1114e-08,
                    1.0041e-07,
                    1.0985e-07,
                    1.1945e-07,
                    1.2919e-07,
                    1.3908e-07,
                    1.4912e-07,
                    1.593e-07,
                    1.6964e-07,
                    1.8013e-07,
                    1.9076e-07,
                    2.0156e-07,
                    2.1252e-07,
                    2.2362e-07,
                    2.3488e-07,
                    2.4629e-07,
                    2.5786e-07,
                    2.6957e-07,
                    2.8144e-07,
                    2.9346e-07,
                    3.0563e-07,
                    3.1783e-07,
                    3.3005e-07,
                    3.4229e-07,
                    3.5456e-07,
                    3.6686e-07,
                    3.7918e-07,
                    3.9152e-07,
                    4.0389e-07,
                    4.1628e-07,
                    4.287e-07,
                    4.4113e-07,
                    4.5358e-07,
                    4.6606e-07,
                    4.7856e-07,
                    4.9109e-07,
                    5.0365e-07,
                    5.1623e-07,
                    5.2884e-07,
                    5.4147e-07,
                    5.5413e-07,
                    5.6645e-07,
                    5.7845e-07,
                    5.9011e-07,
                    6.0143e-07,
                    6.1242e-07,
                    6.2308e-07,
                    6.334e-07,
                    6.4338e-07,
                    6.5303e-07,
                    6.6235e-07,
                    6.7369e-07,
                    6.8705e-07,
                    7.0245e-07,
                    7.1989e-07,
                    7.3939e-07,
                    7.6096e-07,
                    7.846e-07,
                    8.1033e-07,
                    8.3815e-07,
                    8.6808e-07,
                    9.0106e-07,
                    9.3711e-07,
                    9.7627e-07,
                    1.0185e-06,
                    1.064e-06,
                    1.1126e-06,
                    1.1643e-06,
                    1.2193e-06,
                    1.2775e-06,
                    1.339e-06,
                    1.4022e-06,
                    1.4672e-06,
                    1.534e-06,
                    1.6025e-06,
                    1.6729e-06,
                    1.7455e-06,
                    1.8205e-06,
                    1.8981e-06,
                    1.9782e-06,
                    2.0608e-06,
                    2.1465e-06,
                    2.2352e-06,
                    2.327e-06,
                    2.422e-06,
                    2.5201e-06,
                    2.6213e-06,
                    2.7255e-06,
                    2.8328e-06,
                    2.9431e-06,
                    3.0564e-06,
                    3.1744e-06,
                    3.2962e-06,
                    3.4212e-06,
                    3.549e-06,
                    3.6796e-06,
                    3.8123e-06,
                    3.9472e-06,
                    4.0838e-06,
                    4.223e-06,
                    4.364e-06,
                    4.4758e-06,
                    4.591e-06,
                    4.7266e-06,
                    4.867e-06,
                    5.0379e-06,
                    5.229e-06,
                    5.3994e-06,
                    5.54e-06,
                    5.6803e-06,
                    5.8265e-06,
                    5.9736e-06,
                    6.1214e-06,
                    6.2719e-06,
                    6.4286e-06,
                    6.5883e-06,
                    6.7618e-06,
                    6.9423e-06,
                    7.1306e-06,
                    7.3361e-06,
                    7.5406e-06,
                    7.7719e-06,
                    7.9973e-06,
                    8.1985e-06,
                    8.4083e-06,
                    8.5819e-06,
                    8.7357e-06,
                    8.9074e-06,
                    9.1152e-06,
                    9.3359e-06,
                    9.5892e-06,
                    9.8445e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [
                    1.8281e-09,
                    3.658e-09,
                    5.4895e-09,
                    7.3228e-09,
                    9.1578e-09,
                    1.0995e-08,
                    1.2833e-08,
                    1.4673e-08,
                    1.6515e-08,
                    1.8359e-08,
                    2.0233e-08,
                    2.2138e-08,
                    2.4072e-08,
                    2.6037e-08,
                    2.8032e-08,
                    3.0057e-08,
                    3.2112e-08,
                    3.4198e-08,
                    3.6314e-08,
                    3.846e-08,
                    4.0653e-08,
                    4.2877e-08,
                    4.5131e-08,
                    4.7416e-08,
                    4.9731e-08,
                    5.2076e-08,
                    5.4452e-08,
                    5.6859e-08,
                    5.9296e-08,
                    6.1763e-08,
                    6.4235e-08,
                    6.6712e-08,
                    6.9193e-08,
                    7.1679e-08,
                    7.417e-08,
                    7.6665e-08,
                    7.9165e-08,
                    8.167e-08,
                    8.418e-08,
                    8.6694e-08,
                    8.9199e-08,
                    9.171e-08,
                    9.4225e-08,
                    9.6746e-08,
                    9.9273e-08,
                    1.018e-07,
                    1.0434e-07,
                    1.0688e-07,
                    1.0943e-07,
                    1.1198e-07,
                    1.1459e-07,
                    1.1725e-07,
                    1.1996e-07,
                    1.2273e-07,
                    1.2554e-07,
                    1.2841e-07,
                    1.3133e-07,
                    1.3429e-07,
                    1.3731e-07,
                    1.4038e-07,
                    1.44e-07,
                    1.4817e-07,
                    1.529e-07,
                    1.582e-07,
                    1.6409e-07,
                    1.7057e-07,
                    1.7766e-07,
                    1.8535e-07,
                    1.9367e-07,
                    2.0262e-07,
                    2.1235e-07,
                    2.229e-07,
                    2.3429e-07,
                    2.4653e-07,
                    2.5964e-07,
                    2.7367e-07,
                    2.8861e-07,
                    3.0451e-07,
                    3.2137e-07,
                    3.3924e-07,
                    3.5781e-07,
                    3.7713e-07,
                    3.972e-07,
                    4.1807e-07,
                    4.3973e-07,
                    4.6222e-07,
                    4.8556e-07,
                    5.1003e-07,
                    5.3547e-07,
                    5.6192e-07,
                    5.8963e-07,
                    6.1862e-07,
                    6.4895e-07,
                    6.8064e-07,
                    7.1358e-07,
                    7.4772e-07,
                    7.8309e-07,
                    8.1957e-07,
                    8.5716e-07,
                    8.9583e-07,
                    9.3625e-07,
                    9.7763e-07,
                    1.0198e-06,
                    1.0624e-06,
                    1.1054e-06,
                    1.1487e-06,
                    1.1921e-06,
                    1.2355e-06,
                    1.2794e-06,
                    1.3232e-06,
                    1.3663e-06,
                    1.4086e-06,
                    1.4501e-06,
                    1.4909e-06,
                    1.5312e-06,
                    1.5712e-06,
                    1.611e-06,
                    1.6508e-06,
                    1.6904e-06,
                    1.7379e-06,
                    1.7894e-06,
                    1.8426e-06,
                    1.8979e-06,
                    1.955e-06,
                    2.0175e-06,
                    2.0871e-06,
                    2.1624e-06,
                    2.244e-06,
                    2.331e-06,
                    2.4244e-06,
                    2.5242e-06,
                    2.6301e-06,
                    2.742e-06,
                    2.8601e-06,
                    2.9852e-06,
                    3.1175e-06,
                    3.2579e-06,
                    3.4059e-06,
                    3.5631e-06,
                    3.754e-06,
                    3.9467e-06,
                    4.1474e-06,
                    4.3551e-06,
                    4.5673e-06,
                    4.7876e-06,
                    5.0101e-06,
                    5.236e-06,
                    5.4643e-06,
                    5.7017e-06,
                    5.9473e-06,
                    6.1947e-06,
                    6.4474e-06,
                    6.7051e-06,
                    6.9689e-06,
                    7.2386e-06,
                    7.5093e-06,
                    7.7821e-06,
                    8.0591e-06,
                    8.3408e-06,
                    8.5981e-06,
                    8.864e-06,
                    9.1361e-06,
                    9.4142e-06,
                    9.7005e-06,
                    9.9861e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CH4": 0.01,
                "Land_CH4_timeseries": [
                    7.2481e-09,
                    1.4502e-08,
                    2.1763e-08,
                    2.9029e-08,
                    3.6302e-08,
                    4.358e-08,
                    5.0865e-08,
                    5.8155e-08,
                    6.5452e-08,
                    7.2755e-08,
                    8.0177e-08,
                    8.7716e-08,
                    9.5375e-08,
                    1.0315e-07,
                    1.1105e-07,
                    1.1906e-07,
                    1.2719e-07,
                    1.3544e-07,
                    1.4381e-07,
                    1.523e-07,
                    1.6091e-07,
                    1.6964e-07,
                    1.7849e-07,
                    1.8747e-07,
                    1.9656e-07,
                    2.0578e-07,
                    2.1512e-07,
                    2.2458e-07,
                    2.3416e-07,
                    2.4387e-07,
                    2.5359e-07,
                    2.6334e-07,
                    2.731e-07,
                    2.8289e-07,
                    2.9269e-07,
                    3.0251e-07,
                    3.1236e-07,
                    3.2222e-07,
                    3.321e-07,
                    3.42e-07,
                    3.5193e-07,
                    3.6187e-07,
                    3.7183e-07,
                    3.8182e-07,
                    3.9182e-07,
                    4.0185e-07,
                    4.1189e-07,
                    4.2195e-07,
                    4.3204e-07,
                    4.4214e-07,
                    4.5186e-07,
                    4.612e-07,
                    4.7014e-07,
                    4.7871e-07,
                    4.8688e-07,
                    4.9467e-07,
                    5.0207e-07,
                    5.0909e-07,
                    5.1572e-07,
                    5.2197e-07,
                    5.2969e-07,
                    5.3888e-07,
                    5.4955e-07,
                    5.6169e-07,
                    5.753e-07,
                    5.9038e-07,
                    6.0694e-07,
                    6.2498e-07,
                    6.4448e-07,
                    6.6546e-07,
                    6.887e-07,
                    7.1421e-07,
                    7.4198e-07,
                    7.7202e-07,
                    8.0432e-07,
                    8.3889e-07,
                    8.7572e-07,
                    9.1481e-07,
                    9.5617e-07,
                    9.998e-07,
                    1.0444e-06,
                    1.0901e-06,
                    1.1368e-06,
                    1.1844e-06,
                    1.2331e-06,
                    1.2833e-06,
                    1.3349e-06,
                    1.3881e-06,
                    1.4427e-06,
                    1.4989e-06,
                    1.5568e-06,
                    1.6166e-06,
                    1.6781e-06,
                    1.7414e-06,
                    1.8065e-06,
                    1.8736e-06,
                    1.9425e-06,
                    2.0132e-06,
                    2.0859e-06,
                    2.1605e-06,
                    2.2382e-06,
                    2.3185e-06,
                    2.4014e-06,
                    2.4866e-06,
                    2.5742e-06,
                    2.6636e-06,
                    2.755e-06,
                    2.8484e-06,
                    2.9437e-06,
                    3.0409e-06,
                    3.1095e-06,
                    3.1824e-06,
                    3.2764e-06,
                    3.3762e-06,
                    3.5067e-06,
                    3.6578e-06,
                    3.7884e-06,
                    3.8893e-06,
                    3.9899e-06,
                    4.0886e-06,
                    4.1842e-06,
                    4.2787e-06,
                    4.374e-06,
                    4.4736e-06,
                    4.5708e-06,
                    4.6747e-06,
                    4.7798e-06,
                    4.8866e-06,
                    5.0051e-06,
                    5.1162e-06,
                    5.2477e-06,
                    5.3672e-06,
                    5.4565e-06,
                    5.5482e-06,
                    5.5966e-06,
                    5.6182e-06,
                    5.6495e-06,
                    5.7094e-06,
                    5.7728e-06,
                    5.8353e-06,
                    5.8977e-06,
                    5.9648e-06,
                    6.0347e-06,
                    6.098e-06,
                    6.164e-06,
                    6.224e-06,
                    6.2828e-06,
                    6.3458e-06,
                    6.3976e-06,
                    6.409e-06,
                    6.4507e-06,
                    6.5052e-06,
                    6.5531e-06,
                    6.5962e-06,
                    6.6565e-06,
                    6.7535e-06,
                    6.8109e-06,
                    6.9132e-06,
                    7.0148e-06,
                    7.1404e-06,
                    7.297e-06,
                    7.4615e-06,
                    7.6271e-06,
                    7.8065e-06,
                    7.9884e-06,
                    8.1568e-06,
                    8.3335e-06,
                    8.4964e-06,
                    8.6562e-06,
                    8.8571e-06,
                    9.0312e-06,
                    9.1976e-06
                ],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [
                    9.2081e-10,
                    1.8593e-09,
                    2.8146e-09,
                    3.7859e-09,
                    4.7718e-09,
                    5.7708e-09,
                    6.781e-09,
                    7.8003e-09,
                    8.8263e-09,
                    9.8564e-09,
                    1.0889e-08,
                    1.1923e-08,
                    1.2959e-08,
                    1.3997e-08,
                    1.5036e-08,
                    1.6076e-08,
                    1.7118e-08,
                    1.8161e-08,
                    1.9206e-08,
                    2.0254e-08,
                    2.1319e-08,
                    2.2425e-08,
                    2.3591e-08,
                    2.483e-08,
                    2.615e-08,
                    2.7552e-08,
                    2.9033e-08,
                    3.0583e-08,
                    3.2186e-08,
                    3.3823e-08,
                    3.5479e-08,
                    3.7151e-08,
                    3.8836e-08,
                    4.0533e-08,
                    4.2241e-08,
                    4.396e-08,
                    4.5688e-08,
                    4.7427e-08,
                    4.9178e-08,
                    5.1016e-08,
                    5.2873e-08,
                    5.4748e-08,
                    5.6644e-08,
                    5.8559e-08,
                    6.0497e-08,
                    6.2456e-08,
                    6.4438e-08,
                    6.6443e-08,
                    6.8473e-08,
                    7.0528e-08,
                    7.2607e-08,
                    7.4711e-08,
                    7.684e-08,
                    7.8993e-08,
                    8.1174e-08,
                    8.3383e-08,
                    8.5624e-08,
                    8.7899e-08,
                    9.0213e-08,
                    9.257e-08,
                    9.4988e-08,
                    9.7498e-08,
                    1.0012e-07,
                    1.0288e-07,
                    1.0578e-07,
                    1.0885e-07,
                    1.1206e-07,
                    1.1544e-07,
                    1.1897e-07,
                    1.2264e-07,
                    1.2644e-07,
                    1.3041e-07,
                    1.3454e-07,
                    1.3885e-07,
                    1.4332e-07,
                    1.4795e-07,
                    1.5271e-07,
                    1.5758e-07,
                    1.6251e-07,
                    1.6749e-07,
                    1.7245e-07,
                    1.7736e-07,
                    1.8221e-07,
                    1.8698e-07,
                    1.9166e-07,
                    1.9625e-07,
                    2.0076e-07,
                    2.052e-07,
                    2.0961e-07,
                    2.14e-07,
                    2.1882e-07,
                    2.2477e-07,
                    2.3238e-07,
                    2.42e-07,
                    2.5382e-07,
                    2.6783e-07,
                    2.8388e-07,
                    3.0162e-07,
                    3.2054e-07,
                    3.3993e-07,
                    3.5919e-07,
                    3.7798e-07,
                    3.9602e-07,
                    4.1315e-07,
                    4.2928e-07,
                    4.444e-07,
                    4.5861e-07,
                    4.7207e-07,
                    4.8506e-07,
                    4.9793e-07,
                    5.1141e-07,
                    5.257e-07,
                    5.4082e-07,
                    5.5678e-07,
                    5.7368e-07,
                    5.9137e-07,
                    6.0896e-07,
                    6.268e-07,
                    6.4501e-07,
                    6.6356e-07,
                    6.8232e-07,
                    7.0137e-07,
                    7.2087e-07,
                    7.4088e-07,
                    7.6123e-07,
                    7.8213e-07,
                    8.0328e-07,
                    8.2489e-07,
                    8.4595e-07,
                    8.6681e-07,
                    8.8739e-07,
                    9.0761e-07,
                    9.2724e-07,
                    9.4653e-07,
                    9.6511e-07,
                    9.8338e-07,
                    1.0014e-06,
                    1.0198e-06,
                    1.0389e-06,
                    1.0581e-06,
                    1.0775e-06,
                    1.097e-06,
                    1.1169e-06,
                    1.1371e-06,
                    1.1577e-06,
                    1.1788e-06,
                    1.2002e-06,
                    1.2229e-06,
                    1.2472e-06,
                    1.2703e-06,
                    1.2942e-06,
                    1.3185e-06,
                    1.3414e-06,
                    1.3646e-06,
                    1.3891e-06,
                    1.4139e-06,
                    1.4384e-06,
                    1.4638e-06,
                    1.4892e-06,
                    1.5153e-06,
                    1.542e-06,
                    1.5688e-06,
                    1.5963e-06,
                    1.6239e-06,
                    1.6519e-06,
                    1.6804e-06,
                    1.7098e-06,
                    1.7394e-06,
                    1.7696e-06,
                    1.7999e-06,
                    1.8306e-06,
                    1.8616e-06
                ],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [
                    1.1779e-10,
                    2.3717e-10,
                    3.5808e-10,
                    4.805e-10,
                    6.0435e-10,
                    7.2955e-10,
                    8.5603e-10,
                    9.8367e-10,
                    1.1124e-09,
                    1.242e-09,
                    1.3724e-09,
                    1.5037e-09,
                    1.6358e-09,
                    1.7686e-09,
                    1.9023e-09,
                    2.0367e-09,
                    2.172e-09,
                    2.308e-09,
                    2.4449e-09,
                    2.5826e-09,
                    2.7218e-09,
                    2.8638e-09,
                    3.0094e-09,
                    3.1593e-09,
                    3.3139e-09,
                    3.4731e-09,
                    3.6369e-09,
                    3.8048e-09,
                    3.976e-09,
                    4.1495e-09,
                    4.3247e-09,
                    4.5014e-09,
                    4.6795e-09,
                    4.8589e-09,
                    5.0395e-09,
                    5.2213e-09,
                    5.4044e-09,
                    5.5887e-09,
                    5.7743e-09,
                    5.9653e-09,
                    6.1587e-09,
                    6.3546e-09,
                    6.5531e-09,
                    6.7543e-09,
                    6.9583e-09,
                    7.1652e-09,
                    7.3752e-09,
                    7.5883e-09,
                    7.8046e-09,
                    8.0243e-09,
                    8.2476e-09,
                    8.4751e-09,
                    8.7071e-09,
                    8.9437e-09,
                    9.1852e-09,
                    9.4315e-09,
                    9.6825e-09,
                    9.938e-09,
                    1.0198e-08,
                    1.0461e-08,
                    1.0727e-08,
                    1.0997e-08,
                    1.127e-08,
                    1.1545e-08,
                    1.1824e-08,
                    1.2105e-08,
                    1.2389e-08,
                    1.2676e-08,
                    1.2966e-08,
                    1.3259e-08,
                    1.3555e-08,
                    1.3854e-08,
                    1.4156e-08,
                    1.4461e-08,
                    1.4769e-08,
                    1.508e-08,
                    1.5395e-08,
                    1.5713e-08,
                    1.6034e-08,
                    1.6359e-08,
                    1.6688e-08,
                    1.7023e-08,
                    1.7362e-08,
                    1.7707e-08,
                    1.8059e-08,
                    1.8418e-08,
                    1.8784e-08,
                    1.9158e-08,
                    1.9539e-08,
                    1.9928e-08,
                    2.0326e-08,
                    2.0738e-08,
                    2.1166e-08,
                    2.1611e-08,
                    2.2076e-08,
                    2.256e-08,
                    2.3065e-08,
                    2.3589e-08,
                    2.4131e-08,
                    2.4689e-08,
                    2.5264e-08,
                    2.5856e-08,
                    2.6465e-08,
                    2.7093e-08,
                    2.7739e-08,
                    2.8404e-08,
                    2.9087e-08,
                    2.9787e-08,
                    3.0503e-08,
                    3.1234e-08,
                    3.198e-08,
                    3.274e-08,
                    3.3516e-08,
                    3.4309e-08,
                    3.5119e-08,
                    3.5947e-08,
                    3.6794e-08,
                    3.7661e-08,
                    3.855e-08,
                    3.9604e-08,
                    4.0689e-08,
                    4.1815e-08,
                    4.2975e-08,
                    4.4153e-08,
                    4.5432e-08,
                    4.6844e-08,
                    4.8363e-08,
                    4.9961e-08,
                    5.1649e-08,
                    5.3398e-08,
                    5.5192e-08,
                    5.7076e-08,
                    5.9011e-08,
                    6.1021e-08,
                    6.306e-08,
                    6.5125e-08,
                    6.7426e-08,
                    6.9731e-08,
                    7.2202e-08,
                    7.5095e-08,
                    7.8136e-08,
                    8.1177e-08,
                    8.4295e-08,
                    8.7553e-08,
                    9.0973e-08,
                    9.4514e-08,
                    9.809e-08,
                    1.018e-07,
                    1.0576e-07,
                    1.1089e-07,
                    1.1615e-07,
                    1.2156e-07,
                    1.2735e-07,
                    1.3341e-07,
                    1.3969e-07,
                    1.4628e-07,
                    1.5273e-07,
                    1.5936e-07,
                    1.6639e-07,
                    1.7381e-07,
                    1.8135e-07,
                    1.8919e-07,
                    1.9742e-07,
                    2.0575e-07,
                    2.1444e-07,
                    2.2368e-07,
                    2.337e-07,
                    2.4401e-07,
                    2.5445e-07,
                    2.6518e-07,
                    2.7645e-07,
                    2.8788e-07
                ],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": [
                    8.0302e-10,
                    1.6221e-09,
                    2.4565e-09,
                    3.3054e-09,
                    4.1675e-09,
                    5.0412e-09,
                    5.9249e-09,
                    6.8166e-09,
                    7.714e-09,
                    8.6145e-09,
                    9.5165e-09,
                    1.042e-08,
                    1.1324e-08,
                    1.2228e-08,
                    1.3133e-08,
                    1.4039e-08,
                    1.4946e-08,
                    1.5853e-08,
                    1.6761e-08,
                    1.7671e-08,
                    1.8597e-08,
                    1.9561e-08,
                    2.0581e-08,
                    2.1671e-08,
                    2.2836e-08,
                    2.4079e-08,
                    2.5396e-08,
                    2.6778e-08,
                    2.821e-08,
                    2.9674e-08,
                    3.1154e-08,
                    3.2649e-08,
                    3.4157e-08,
                    3.5675e-08,
                    3.7202e-08,
                    3.8738e-08,
                    4.0284e-08,
                    4.1838e-08,
                    4.3404e-08,
                    4.5051e-08,
                    4.6714e-08,
                    4.8394e-08,
                    5.0091e-08,
                    5.1805e-08,
                    5.3538e-08,
                    5.5291e-08,
                    5.7063e-08,
                    5.8855e-08,
                    6.0669e-08,
                    6.2504e-08,
                    6.436e-08,
                    6.6236e-08,
                    6.8132e-08,
                    7.005e-08,
                    7.1988e-08,
                    7.3951e-08,
                    7.5941e-08,
                    7.7961e-08,
                    8.0015e-08,
                    8.2109e-08,
                    8.4261e-08,
                    8.6501e-08,
                    8.8852e-08,
                    9.1334e-08,
                    9.3961e-08,
                    9.674e-08,
                    9.9676e-08,
                    1.0277e-07,
                    1.06e-07,
                    1.0938e-07,
                    1.1289e-07,
                    1.1656e-07,
                    1.2039e-07,
                    1.2439e-07,
                    1.2855e-07,
                    1.3287e-07,
                    1.3731e-07,
                    1.4186e-07,
                    1.4648e-07,
                    1.5113e-07,
                    1.5576e-07,
                    1.6034e-07,
                    1.6485e-07,
                    1.6928e-07,
                    1.736e-07,
                    1.7783e-07,
                    1.8197e-07,
                    1.8604e-07,
                    1.9007e-07,
                    1.9408e-07,
                    1.985e-07,
                    2.0403e-07,
                    2.1121e-07,
                    2.2039e-07,
                    2.3174e-07,
                    2.4527e-07,
                    2.6082e-07,
                    2.7803e-07,
                    2.964e-07,
                    3.1524e-07,
                    3.3393e-07,
                    3.5212e-07,
                    3.6956e-07,
                    3.8606e-07,
                    4.0154e-07,
                    4.16e-07,
                    4.2952e-07,
                    4.4229e-07,
                    4.5456e-07,
                    4.667e-07,
                    4.7943e-07,
                    4.9296e-07,
                    5.073e-07,
                    5.2247e-07,
                    5.3857e-07,
                    5.5542e-07,
                    5.7217e-07,
                    5.8914e-07,
                    6.0647e-07,
                    6.2396e-07,
                    6.4163e-07,
                    6.5955e-07,
                    6.7789e-07,
                    6.9673e-07,
                    7.158e-07,
                    7.3528e-07,
                    7.5491e-07,
                    7.7493e-07,
                    7.943e-07,
                    8.1341e-07,
                    8.3219e-07,
                    8.5054e-07,
                    8.6823e-07,
                    8.8551e-07,
                    9.0205e-07,
                    9.1825e-07,
                    9.3393e-07,
                    9.5007e-07,
                    9.6667e-07,
                    9.83e-07,
                    9.994e-07,
                    1.0159e-06,
                    1.0326e-06,
                    1.0495e-06,
                    1.0668e-06,
                    1.0843e-06,
                    1.1021e-06,
                    1.1211e-06,
                    1.1414e-06,
                    1.1595e-06,
                    1.178e-06,
                    1.1969e-06,
                    1.214e-06,
                    1.2312e-06,
                    1.2494e-06,
                    1.2676e-06,
                    1.2857e-06,
                    1.3045e-06,
                    1.3228e-06,
                    1.3415e-06,
                    1.3606e-06,
                    1.3796e-06,
                    1.3988e-06,
                    1.4181e-06,
                    1.4374e-06,
                    1.4567e-06,
                    1.4761e-06,
                    1.4954e-06,
                    1.5152e-06,
                    1.5347e-06,
                    1.5542e-06,
                    1.5737e-06
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                43.45298,
                                -11.7434
                            ],
                            [
                                43.39172,
                                -11.611
                            ],
                            [
                                43.41575,
                                -11.43577
                            ],
                            [
                                43.39455,
                                -11.376
                            ],
                            [
                                43.3422,
                                -11.36626
                            ],
                            [
                                43.27935,
                                -11.39696
                            ],
                            [
                                43.26093,
                                -11.59881
                            ],
                            [
                                43.2657,
                                -11.67267
                            ],
                            [
                                43.22929,
                                -11.73607
                            ],
                            [
                                43.24054,
                                -11.78064
                            ],
                            [
                                43.31271,
                                -11.85786
                            ],
                            [
                                43.38347,
                                -11.86308
                            ],
                            [
                                43.45942,
                                -11.93689
                            ],
                            [
                                43.51691,
                                -11.89476
                            ],
                            [
                                43.46858,
                                -11.82256
                            ],
                            [
                                43.45298,
                                -11.7434
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                44.20553,
                                -12.17009
                            ],
                            [
                                44.31718,
                                -12.23842
                            ],
                            [
                                44.38619,
                                -12.25427
                            ],
                            [
                                44.52106,
                                -12.38392
                            ],
                            [
                                44.53557,
                                -12.34822
                            ],
                            [
                                44.52069,
                                -12.19772
                            ],
                            [
                                44.47148,
                                -12.06972
                            ],
                            [
                                44.42086,
                                -12.09215
                            ],
                            [
                                44.42153,
                                -12.14626
                            ],
                            [
                                44.30775,
                                -12.19714
                            ],
                            [
                                44.20553,
                                -12.17009
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                43.62251,
                                -12.28565
                            ],
                            [
                                43.67459,
                                -12.36371
                            ],
                            [
                                43.74924,
                                -12.35969
                            ],
                            [
                                43.86468,
                                -12.39112
                            ],
                            [
                                43.86092,
                                -12.35168
                            ],
                            [
                                43.67376,
                                -12.25421
                            ],
                            [
                                43.62251,
                                -12.28565
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "COG",
                "Country": "Congo",
                "Total_3GHG": 0.11,
                "Total_3GHG_timeseries": [
                    9.7977e-07,
                    2.0551e-06,
                    3.0082e-06,
                    3.9247e-06,
                    4.816e-06,
                    5.9534e-06,
                    7.1186e-06,
                    8.2281e-06,
                    9.2557e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019
                ],
                "Fossil_3GHG": 0.07,
                "Fossil_3GHG_timeseries": [
                    1.4094e-08,
                    2.8931e-08,
                    4.4517e-08,
                    6.0854e-08,
                    7.7947e-08,
                    9.58e-08,
                    1.1441e-07,
                    1.3379e-07,
                    1.5394e-07,
                    1.7486e-07,
                    1.9666e-07,
                    2.1935e-07,
                    2.4294e-07,
                    2.6743e-07,
                    2.9284e-07,
                    3.1915e-07,
                    3.4639e-07,
                    3.7456e-07,
                    4.0366e-07,
                    4.337e-07,
                    4.6405e-07,
                    4.9473e-07,
                    5.2578e-07,
                    5.5723e-07,
                    5.8907e-07,
                    6.2132e-07,
                    6.5398e-07,
                    6.8702e-07,
                    7.2044e-07,
                    7.5418e-07,
                    7.8816e-07,
                    8.2235e-07,
                    8.5676e-07,
                    8.9139e-07,
                    9.2623e-07,
                    9.6129e-07,
                    9.9657e-07,
                    1.0321e-06,
                    1.0678e-06,
                    1.1038e-06,
                    1.1401e-06,
                    1.1766e-06,
                    1.2134e-06,
                    1.2504e-06,
                    1.2877e-06,
                    1.3252e-06,
                    1.363e-06,
                    1.4011e-06,
                    1.4395e-06,
                    1.4781e-06,
                    1.5257e-06,
                    1.5824e-06,
                    1.6484e-06,
                    1.7238e-06,
                    1.8087e-06,
                    1.9033e-06,
                    2.0077e-06,
                    2.1221e-06,
                    2.2466e-06,
                    2.3815e-06,
                    2.5284e-06,
                    2.6875e-06,
                    2.8591e-06,
                    3.0433e-06,
                    3.2402e-06,
                    3.4501e-06,
                    3.6729e-06,
                    3.909e-06,
                    4.1586e-06,
                    4.4216e-06,
                    4.6695e-06,
                    4.9317e-06,
                    5.2095e-06,
                    5.5037e-06,
                    5.8155e-06,
                    6.146e-06,
                    6.473e-06,
                    6.7961e-06,
                    7.1148e-06,
                    7.4286e-06,
                    7.7358e-06,
                    8.0422e-06,
                    8.3629e-06,
                    8.6986e-06,
                    9.0503e-06,
                    9.4189e-06,
                    9.7746e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Land_3GHG": 0.19,
                "Land_3GHG_timeseries": [
                    9.6568e-07,
                    2.0261e-06,
                    2.9637e-06,
                    3.8638e-06,
                    4.738e-06,
                    5.8576e-06,
                    7.0041e-06,
                    8.0943e-06,
                    9.1017e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011
                ],
                "Total_CO2": 0.1,
                "Total_CO2_timeseries": [
                    9.3969e-07,
                    1.9737e-06,
                    2.8843e-06,
                    3.7571e-06,
                    4.6035e-06,
                    5.6951e-06,
                    6.8132e-06,
                    7.8747e-06,
                    8.8534e-06,
                    9.945e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011
                ],
                "Fossil_CO2": 0.01,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    3.9992e-08,
                    9.3315e-08,
                    1.6247e-07,
                    2.2079e-07,
                    2.8244e-07,
                    3.4327e-07,
                    4.2242e-07,
                    5.074e-07,
                    6.0488e-07,
                    6.8903e-07,
                    7.8968e-07,
                    9.1013e-07,
                    1.0174e-06,
                    1.123e-06,
                    1.2434e-06,
                    1.354e-06,
                    1.4926e-06,
                    1.6378e-06,
                    1.8407e-06,
                    2.0668e-06,
                    2.3242e-06,
                    2.6327e-06,
                    2.9314e-06,
                    3.4808e-06,
                    4.2118e-06,
                    4.7068e-06,
                    5.2628e-06,
                    5.479e-06,
                    5.6242e-06,
                    5.7809e-06,
                    5.9636e-06,
                    6.1755e-06,
                    6.7804e-06,
                    7.2948e-06,
                    7.808e-06,
                    8.3823e-06,
                    8.8607e-06,
                    9.4552e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CO2": 0.28,
                "Land_CO2_timeseries": [
                    9.3969e-07,
                    1.9737e-06,
                    2.8843e-06,
                    3.7571e-06,
                    4.6035e-06,
                    5.6951e-06,
                    6.8132e-06,
                    7.8747e-06,
                    8.8534e-06,
                    9.945e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001
                ],
                "Total_CH4": 0.17,
                "Total_CH4_timeseries": [
                    1.4784e-08,
                    3.0284e-08,
                    4.6507e-08,
                    6.3458e-08,
                    8.1143e-08,
                    9.9567e-08,
                    1.1874e-07,
                    1.3866e-07,
                    1.5933e-07,
                    1.8078e-07,
                    2.0313e-07,
                    2.2642e-07,
                    2.5063e-07,
                    2.7578e-07,
                    3.0187e-07,
                    3.289e-07,
                    3.569e-07,
                    3.8585e-07,
                    4.1577e-07,
                    4.4667e-07,
                    4.7788e-07,
                    5.094e-07,
                    5.4123e-07,
                    5.7337e-07,
                    6.0584e-07,
                    6.3862e-07,
                    6.7171e-07,
                    7.0513e-07,
                    7.3887e-07,
                    7.7293e-07,
                    8.0719e-07,
                    8.4165e-07,
                    8.7632e-07,
                    9.1118e-07,
                    9.4625e-07,
                    9.8153e-07,
                    1.017e-06,
                    1.0527e-06,
                    1.0886e-06,
                    1.1247e-06,
                    1.1611e-06,
                    1.1976e-06,
                    1.2344e-06,
                    1.2713e-06,
                    1.3085e-06,
                    1.346e-06,
                    1.3836e-06,
                    1.4215e-06,
                    1.4596e-06,
                    1.4979e-06,
                    1.5451e-06,
                    1.6013e-06,
                    1.6667e-06,
                    1.7415e-06,
                    1.8256e-06,
                    1.9194e-06,
                    2.0229e-06,
                    2.1364e-06,
                    2.2598e-06,
                    2.3935e-06,
                    2.5398e-06,
                    2.6988e-06,
                    2.8708e-06,
                    3.0559e-06,
                    3.2543e-06,
                    3.4661e-06,
                    3.6915e-06,
                    3.9306e-06,
                    4.1837e-06,
                    4.4508e-06,
                    4.7033e-06,
                    4.9709e-06,
                    5.2547e-06,
                    5.5555e-06,
                    5.8746e-06,
                    6.213e-06,
                    6.5486e-06,
                    6.8809e-06,
                    7.2094e-06,
                    7.5337e-06,
                    7.8517e-06,
                    8.169e-06,
                    8.5009e-06,
                    8.848e-06,
                    9.2114e-06,
                    9.6329e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Fossil_CH4": 0.25,
                "Fossil_CH4_timeseries": [
                    1.2524e-08,
                    2.5763e-08,
                    3.9722e-08,
                    5.4407e-08,
                    6.9824e-08,
                    8.5979e-08,
                    1.0288e-07,
                    1.2052e-07,
                    1.3893e-07,
                    1.5809e-07,
                    1.7814e-07,
                    1.9907e-07,
                    2.2089e-07,
                    2.4362e-07,
                    2.6724e-07,
                    2.9178e-07,
                    3.1724e-07,
                    3.4362e-07,
                    3.7094e-07,
                    3.9919e-07,
                    4.2771e-07,
                    4.565e-07,
                    4.8558e-07,
                    5.1492e-07,
                    5.4455e-07,
                    5.7446e-07,
                    6.0464e-07,
                    6.3511e-07,
                    6.6586e-07,
                    6.969e-07,
                    7.2813e-07,
                    7.5955e-07,
                    7.9117e-07,
                    8.2298e-07,
                    8.55e-07,
                    8.8721e-07,
                    9.1962e-07,
                    9.5224e-07,
                    9.8506e-07,
                    1.0181e-06,
                    1.0513e-06,
                    1.0848e-06,
                    1.1184e-06,
                    1.1523e-06,
                    1.1864e-06,
                    1.2207e-06,
                    1.2552e-06,
                    1.2899e-06,
                    1.3248e-06,
                    1.36e-06,
                    1.4041e-06,
                    1.4572e-06,
                    1.5194e-06,
                    1.5909e-06,
                    1.6719e-06,
                    1.7625e-06,
                    1.8629e-06,
                    1.9731e-06,
                    2.0933e-06,
                    2.2238e-06,
                    2.3662e-06,
                    2.5209e-06,
                    2.688e-06,
                    2.8675e-06,
                    3.0597e-06,
                    3.2648e-06,
                    3.4828e-06,
                    3.7141e-06,
                    3.9586e-06,
                    4.2167e-06,
                    4.4594e-06,
                    4.7166e-06,
                    4.9891e-06,
                    5.278e-06,
                    5.5844e-06,
                    5.9095e-06,
                    6.231e-06,
                    6.5485e-06,
                    6.8615e-06,
                    7.1696e-06,
                    7.471e-06,
                    7.7715e-06,
                    8.0862e-06,
                    8.4158e-06,
                    8.7613e-06,
                    9.1236e-06,
                    9.4729e-06,
                    9.8086e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007
                ],
                "Land_CH4": 0.04,
                "Land_CH4_timeseries": [
                    2.2599e-09,
                    4.5216e-09,
                    6.7853e-09,
                    9.0509e-09,
                    1.1318e-08,
                    1.3588e-08,
                    1.5859e-08,
                    1.8132e-08,
                    2.0407e-08,
                    2.2684e-08,
                    2.4998e-08,
                    2.7349e-08,
                    2.9737e-08,
                    3.2161e-08,
                    3.4623e-08,
                    3.7121e-08,
                    3.9657e-08,
                    4.2229e-08,
                    4.4839e-08,
                    4.7485e-08,
                    5.0169e-08,
                    5.2891e-08,
                    5.5651e-08,
                    5.8449e-08,
                    6.1285e-08,
                    6.4159e-08,
                    6.7071e-08,
                    7.0021e-08,
                    7.3009e-08,
                    7.6035e-08,
                    7.9067e-08,
                    8.2105e-08,
                    8.5149e-08,
                    8.82e-08,
                    9.1257e-08,
                    9.4319e-08,
                    9.7388e-08,
                    1.0046e-07,
                    1.0354e-07,
                    1.0663e-07,
                    1.0973e-07,
                    1.1283e-07,
                    1.1593e-07,
                    1.1905e-07,
                    1.2216e-07,
                    1.2529e-07,
                    1.2842e-07,
                    1.3156e-07,
                    1.347e-07,
                    1.3785e-07,
                    1.4101e-07,
                    1.4418e-07,
                    1.4735e-07,
                    1.5052e-07,
                    1.537e-07,
                    1.5689e-07,
                    1.6009e-07,
                    1.6329e-07,
                    1.665e-07,
                    1.6971e-07,
                    1.7352e-07,
                    1.779e-07,
                    1.8288e-07,
                    1.8843e-07,
                    1.9458e-07,
                    2.0131e-07,
                    2.0863e-07,
                    2.1653e-07,
                    2.2502e-07,
                    2.341e-07,
                    2.4389e-07,
                    2.5439e-07,
                    2.6561e-07,
                    2.7754e-07,
                    2.9019e-07,
                    3.0355e-07,
                    3.1762e-07,
                    3.3241e-07,
                    3.4791e-07,
                    3.6413e-07,
                    3.8067e-07,
                    3.9753e-07,
                    4.1472e-07,
                    4.3223e-07,
                    4.5007e-07,
                    5.0929e-07,
                    6.1136e-07,
                    7.5774e-07,
                    9.4991e-07,
                    1.1893e-06,
                    1.4784e-06,
                    1.8189e-06,
                    2.2126e-06,
                    2.6612e-06,
                    3.1665e-06,
                    3.7303e-06,
                    4.3543e-06,
                    5.0402e-06,
                    5.7899e-06,
                    6.6051e-06,
                    7.4908e-06,
                    8.4501e-06,
                    9.4865e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_N2O": 0.05,
                "Total_N2O_timeseries": [
                    2.5303e-08,
                    5.1108e-08,
                    7.7396e-08,
                    1.0414e-07,
                    1.3129e-07,
                    1.5881e-07,
                    1.8664e-07,
                    2.1473e-07,
                    2.4299e-07,
                    2.7136e-07,
                    2.9977e-07,
                    3.2823e-07,
                    3.5671e-07,
                    3.8521e-07,
                    4.1374e-07,
                    4.4228e-07,
                    4.7085e-07,
                    4.9945e-07,
                    5.2809e-07,
                    5.5678e-07,
                    5.8595e-07,
                    6.1633e-07,
                    6.4847e-07,
                    6.8276e-07,
                    7.1942e-07,
                    7.585e-07,
                    7.9989e-07,
                    8.4331e-07,
                    8.8831e-07,
                    9.3426e-07,
                    9.8076e-07,
                    1.0277e-06,
                    1.0751e-06,
                    1.1227e-06,
                    1.1707e-06,
                    1.219e-06,
                    1.2675e-06,
                    1.3163e-06,
                    1.3655e-06,
                    1.4172e-06,
                    1.4693e-06,
                    1.5221e-06,
                    1.5753e-06,
                    1.6291e-06,
                    1.6836e-06,
                    1.7386e-06,
                    1.7943e-06,
                    1.8506e-06,
                    1.9076e-06,
                    1.9654e-06,
                    2.0238e-06,
                    2.0828e-06,
                    2.1426e-06,
                    2.2031e-06,
                    2.2643e-06,
                    2.3263e-06,
                    2.3892e-06,
                    2.4531e-06,
                    2.5181e-06,
                    2.5843e-06,
                    2.6524e-06,
                    2.7231e-06,
                    2.7971e-06,
                    2.8751e-06,
                    2.9574e-06,
                    3.0443e-06,
                    3.1359e-06,
                    3.2321e-06,
                    3.3328e-06,
                    3.4375e-06,
                    3.5464e-06,
                    3.6599e-06,
                    3.7784e-06,
                    3.9019e-06,
                    4.0304e-06,
                    4.1633e-06,
                    4.3002e-06,
                    4.4402e-06,
                    4.5824e-06,
                    4.7254e-06,
                    4.8681e-06,
                    5.0094e-06,
                    5.1488e-06,
                    5.2856e-06,
                    5.4196e-06,
                    5.551e-06,
                    5.6798e-06,
                    5.8067e-06,
                    5.9323e-06,
                    6.0576e-06,
                    6.1954e-06,
                    6.3665e-06,
                    6.5866e-06,
                    6.8663e-06,
                    7.2108e-06,
                    7.6204e-06,
                    8.0901e-06,
                    8.6098e-06,
                    9.1641e-06,
                    9.7325e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_N2O": 0.01,
                "Fossil_N2O_timeseries": [
                    1.5701e-09,
                    3.1688e-09,
                    4.7949e-09,
                    6.4471e-09,
                    8.1232e-09,
                    9.8209e-09,
                    1.1537e-08,
                    1.3269e-08,
                    1.5013e-08,
                    1.6765e-08,
                    1.8522e-08,
                    2.0284e-08,
                    2.2049e-08,
                    2.3819e-08,
                    2.5592e-08,
                    2.7368e-08,
                    2.9148e-08,
                    3.0933e-08,
                    3.2722e-08,
                    3.4517e-08,
                    3.6339e-08,
                    3.8226e-08,
                    4.0206e-08,
                    4.2301e-08,
                    4.452e-08,
                    4.6867e-08,
                    4.9337e-08,
                    5.1913e-08,
                    5.4574e-08,
                    5.7287e-08,
                    6.0031e-08,
                    6.2801e-08,
                    6.5593e-08,
                    6.8405e-08,
                    7.1235e-08,
                    7.4082e-08,
                    7.6947e-08,
                    7.9829e-08,
                    8.2731e-08,
                    8.572e-08,
                    8.8748e-08,
                    9.1817e-08,
                    9.493e-08,
                    9.8087e-08,
                    1.0129e-07,
                    1.0455e-07,
                    1.0785e-07,
                    1.1122e-07,
                    1.1464e-07,
                    1.1812e-07,
                    1.2167e-07,
                    1.2529e-07,
                    1.2901e-07,
                    1.3282e-07,
                    1.3673e-07,
                    1.4074e-07,
                    1.4484e-07,
                    1.4904e-07,
                    1.5332e-07,
                    1.5768e-07,
                    1.6212e-07,
                    1.6662e-07,
                    1.7118e-07,
                    1.7582e-07,
                    1.8051e-07,
                    1.8527e-07,
                    1.9009e-07,
                    1.9498e-07,
                    1.9993e-07,
                    2.0495e-07,
                    2.1003e-07,
                    2.1519e-07,
                    2.2042e-07,
                    2.2571e-07,
                    2.3108e-07,
                    2.3651e-07,
                    2.4202e-07,
                    2.476e-07,
                    2.5326e-07,
                    2.5899e-07,
                    2.648e-07,
                    2.7069e-07,
                    2.7668e-07,
                    2.8277e-07,
                    2.8897e-07,
                    2.9529e-07,
                    3.0173e-07,
                    3.0831e-07,
                    3.1503e-07,
                    3.219e-07,
                    3.2901e-07,
                    3.3647e-07,
                    3.444e-07,
                    3.5287e-07,
                    3.6193e-07,
                    3.716e-07,
                    3.8188e-07,
                    3.9273e-07,
                    4.041e-07,
                    4.1591e-07,
                    4.2808e-07,
                    4.4064e-07,
                    4.5356e-07,
                    4.6686e-07,
                    4.8052e-07,
                    4.9455e-07,
                    5.0895e-07,
                    5.2372e-07,
                    5.3886e-07,
                    5.5436e-07,
                    5.7027e-07,
                    5.8667e-07,
                    6.036e-07,
                    6.2112e-07,
                    6.3926e-07,
                    6.5804e-07,
                    6.7747e-07,
                    6.9753e-07,
                    7.1821e-07,
                    7.3166e-07,
                    7.4614e-07,
                    7.615e-07,
                    7.8898e-07,
                    8.2369e-07,
                    8.5071e-07,
                    8.7757e-07,
                    8.9501e-07,
                    9.1202e-07,
                    9.29e-07,
                    9.4732e-07,
                    9.6614e-07,
                    9.9447e-07,
                    1.0277e-06,
                    1.0627e-06,
                    1.0902e-06,
                    1.1177e-06,
                    1.1609e-06,
                    1.2026e-06,
                    1.2341e-06,
                    1.2652e-06,
                    1.2977e-06,
                    1.3297e-06,
                    1.3616e-06,
                    1.3912e-06,
                    1.4233e-06,
                    1.4564e-06,
                    1.4896e-06,
                    1.5257e-06,
                    1.5624e-06,
                    1.5982e-06,
                    1.636e-06,
                    1.6711e-06,
                    1.7107e-06,
                    1.7532e-06,
                    1.7984e-06,
                    1.855e-06,
                    1.9047e-06,
                    1.9594e-06,
                    2.0191e-06,
                    2.0837e-06,
                    2.165e-06,
                    2.2599e-06,
                    2.3608e-06,
                    2.4641e-06,
                    2.5681e-06,
                    2.6693e-06,
                    2.7624e-06,
                    2.8577e-06,
                    2.9602e-06,
                    3.0648e-06,
                    3.1713e-06,
                    3.2879e-06
                ],
                "Land_N2O": 0.07,
                "Land_N2O_timeseries": [
                    2.3732e-08,
                    4.794e-08,
                    7.2601e-08,
                    9.7688e-08,
                    1.2317e-07,
                    1.4899e-07,
                    1.7511e-07,
                    2.0146e-07,
                    2.2798e-07,
                    2.5459e-07,
                    2.8125e-07,
                    3.0794e-07,
                    3.3466e-07,
                    3.614e-07,
                    3.8815e-07,
                    4.1492e-07,
                    4.417e-07,
                    4.6852e-07,
                    4.9537e-07,
                    5.2226e-07,
                    5.4961e-07,
                    5.7811e-07,
                    6.0826e-07,
                    6.4046e-07,
                    6.749e-07,
                    7.1163e-07,
                    7.5055e-07,
                    7.914e-07,
                    8.3373e-07,
                    8.7698e-07,
                    9.2073e-07,
                    9.6492e-07,
                    1.0095e-06,
                    1.0543e-06,
                    1.0995e-06,
                    1.1449e-06,
                    1.1905e-06,
                    1.2365e-06,
                    1.2828e-06,
                    1.3314e-06,
                    1.3806e-06,
                    1.4302e-06,
                    1.4804e-06,
                    1.5311e-06,
                    1.5823e-06,
                    1.6341e-06,
                    1.6864e-06,
                    1.7394e-06,
                    1.793e-06,
                    1.8472e-06,
                    1.9021e-06,
                    1.9576e-06,
                    2.0136e-06,
                    2.0703e-06,
                    2.1276e-06,
                    2.1856e-06,
                    2.2444e-06,
                    2.3041e-06,
                    2.3648e-06,
                    2.4267e-06,
                    2.4903e-06,
                    2.5565e-06,
                    2.6259e-06,
                    2.6993e-06,
                    2.7769e-06,
                    2.8591e-06,
                    2.9458e-06,
                    3.0372e-06,
                    3.1328e-06,
                    3.2325e-06,
                    3.3363e-06,
                    3.4447e-06,
                    3.558e-06,
                    3.6762e-06,
                    3.7993e-06,
                    3.9268e-06,
                    4.0582e-06,
                    4.1926e-06,
                    4.3291e-06,
                    4.4664e-06,
                    4.6033e-06,
                    4.7388e-06,
                    4.8721e-06,
                    5.0028e-06,
                    5.1307e-06,
                    5.2557e-06,
                    5.3781e-06,
                    5.4984e-06,
                    5.6173e-06,
                    5.7357e-06,
                    5.8664e-06,
                    6.0301e-06,
                    6.2423e-06,
                    6.5134e-06,
                    6.8489e-06,
                    7.2488e-06,
                    7.7083e-06,
                    8.2171e-06,
                    8.76e-06,
                    9.3166e-06,
                    9.869e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            11.98925,
                            -4.99932
                        ],
                        [
                            12.1618,
                            -4.86981
                        ],
                        [
                            12.21408,
                            -4.75795
                        ],
                        [
                            12.26117,
                            -4.79821
                        ],
                        [
                            12.32324,
                            -4.79657
                        ],
                        [
                            12.39711,
                            -4.66724
                        ],
                        [
                            12.39262,
                            -4.61015
                        ],
                        [
                            12.56315,
                            -4.56374
                        ],
                        [
                            12.64308,
                            -4.5621
                        ],
                        [
                            12.77129,
                            -4.39055
                        ],
                        [
                            12.88661,
                            -4.45553
                        ],
                        [
                            12.97033,
                            -4.53501
                        ],
                        [
                            12.98401,
                            -4.58519
                        ],
                        [
                            13.10176,
                            -4.68505
                        ],
                        [
                            13.10641,
                            -4.59735
                        ],
                        [
                            13.14083,
                            -4.59527
                        ],
                        [
                            13.30767,
                            -4.7835
                        ],
                        [
                            13.3792,
                            -4.80027
                        ],
                        [
                            13.40154,
                            -4.86743
                        ],
                        [
                            13.57769,
                            -4.80271
                        ],
                        [
                            13.72297,
                            -4.70514
                        ],
                        [
                            13.73231,
                            -4.50357
                        ],
                        [
                            13.72431,
                            -4.4558
                        ],
                        [
                            13.82131,
                            -4.42623
                        ],
                        [
                            13.85667,
                            -4.49499
                        ],
                        [
                            13.94886,
                            -4.51362
                        ],
                        [
                            14.05157,
                            -4.41133
                        ],
                        [
                            14.16364,
                            -4.39868
                        ],
                        [
                            14.24871,
                            -4.36418
                        ],
                        [
                            14.28688,
                            -4.3229
                        ],
                        [
                            14.39184,
                            -4.3344
                        ],
                        [
                            14.42549,
                            -4.39675
                        ],
                        [
                            14.47888,
                            -4.43483
                        ],
                        [
                            14.4321,
                            -4.50946
                        ],
                        [
                            14.35276,
                            -4.55329
                        ],
                        [
                            14.41821,
                            -4.64918
                        ],
                        [
                            14.39727,
                            -4.80444
                        ],
                        [
                            14.4141,
                            -4.89074
                        ],
                        [
                            14.47495,
                            -4.84653
                        ],
                        [
                            14.55866,
                            -4.86417
                        ],
                        [
                            14.58827,
                            -4.9015
                        ],
                        [
                            14.68962,
                            -4.91143
                        ],
                        [
                            14.84467,
                            -4.81064
                        ],
                        [
                            14.90352,
                            -4.68184
                        ],
                        [
                            15.02829,
                            -4.54249
                        ],
                        [
                            15.10475,
                            -4.48292
                        ],
                        [
                            15.17393,
                            -4.38987
                        ],
                        [
                            15.19562,
                            -4.32604
                        ],
                        [
                            15.3279,
                            -4.27052
                        ],
                        [
                            15.40048,
                            -4.28472
                        ],
                        [
                            15.47662,
                            -4.22949
                        ],
                        [
                            15.4749,
                            -4.14936
                        ],
                        [
                            15.51967,
                            -4.07337
                        ],
                        [
                            15.57362,
                            -4.02918
                        ],
                        [
                            15.68029,
                            -3.99585
                        ],
                        [
                            15.88079,
                            -3.95675
                        ],
                        [
                            16.05041,
                            -3.60592
                        ],
                        [
                            16.09098,
                            -3.55725
                        ],
                        [
                            16.12342,
                            -3.47288
                        ],
                        [
                            16.1948,
                            -3.36837
                        ],
                        [
                            16.21499,
                            -3.30864
                        ],
                        [
                            16.17963,
                            -3.25398
                        ],
                        [
                            16.1872,
                            -3.19188
                        ],
                        [
                            16.1721,
                            -3.07788
                        ],
                        [
                            16.19274,
                            -3.01332
                        ],
                        [
                            16.17384,
                            -2.92409
                        ],
                        [
                            16.20288,
                            -2.71154
                        ],
                        [
                            16.23354,
                            -2.60016
                        ],
                        [
                            16.18121,
                            -2.4042
                        ],
                        [
                            16.17564,
                            -2.26611
                        ],
                        [
                            16.18844,
                            -2.18702
                        ],
                        [
                            16.22184,
                            -2.12612
                        ],
                        [
                            16.33989,
                            -2.05059
                        ],
                        [
                            16.41812,
                            -1.94267
                        ],
                        [
                            16.55654,
                            -1.84036
                        ],
                        [
                            16.57384,
                            -1.73341
                        ],
                        [
                            16.63706,
                            -1.62858
                        ],
                        [
                            16.71878,
                            -1.44577
                        ],
                        [
                            16.84082,
                            -1.26017
                        ],
                        [
                            17.10876,
                            -1.06524
                        ],
                        [
                            17.19697,
                            -1.04929
                        ],
                        [
                            17.28358,
                            -0.99091
                        ],
                        [
                            17.35374,
                            -0.98394
                        ],
                        [
                            17.43641,
                            -0.82404
                        ],
                        [
                            17.49909,
                            -0.75462
                        ],
                        [
                            17.58407,
                            -0.68871
                        ],
                        [
                            17.65994,
                            -0.65691
                        ],
                        [
                            17.70364,
                            -0.58127
                        ],
                        [
                            17.71836,
                            -0.36563
                        ],
                        [
                            17.66973,
                            -0.28387
                        ],
                        [
                            17.67392,
                            -0.17787
                        ],
                        [
                            17.75072,
                            -0.06691
                        ],
                        [
                            17.77699,
                            0.14787
                        ],
                        [
                            17.82477,
                            0.24099
                        ],
                        [
                            17.91537,
                            0.30499
                        ],
                        [
                            17.96234,
                            0.38749
                        ],
                        [
                            17.94346,
                            0.52331
                        ],
                        [
                            17.87305,
                            0.57965
                        ],
                        [
                            17.86636,
                            0.70533
                        ],
                        [
                            17.87531,
                            0.8515
                        ],
                        [
                            17.84739,
                            0.89332
                        ],
                        [
                            17.84211,
                            0.96715
                        ],
                        [
                            17.86238,
                            1.05886
                        ],
                        [
                            17.91639,
                            1.12821
                        ],
                        [
                            17.95255,
                            1.31735
                        ],
                        [
                            18.04404,
                            1.4506
                        ],
                        [
                            18.07435,
                            1.55733
                        ],
                        [
                            18.07429,
                            1.75274
                        ],
                        [
                            18.05304,
                            1.82662
                        ],
                        [
                            18.09088,
                            1.93063
                        ],
                        [
                            18.07846,
                            1.98048
                        ],
                        [
                            18.07758,
                            2.14296
                        ],
                        [
                            18.09465,
                            2.27084
                        ],
                        [
                            18.18559,
                            2.3445
                        ],
                        [
                            18.18364,
                            2.37025
                        ],
                        [
                            18.2662,
                            2.53163
                        ],
                        [
                            18.32228,
                            2.59207
                        ],
                        [
                            18.34382,
                            2.6524
                        ],
                        [
                            18.42233,
                            2.75818
                        ],
                        [
                            18.45061,
                            2.88598
                        ],
                        [
                            18.52229,
                            3.0457
                        ],
                        [
                            18.59086,
                            3.10312
                        ],
                        [
                            18.64654,
                            3.24243
                        ],
                        [
                            18.62508,
                            3.47165
                        ],
                        [
                            18.59516,
                            3.47824
                        ],
                        [
                            18.54091,
                            3.60121
                        ],
                        [
                            18.48923,
                            3.65152
                        ],
                        [
                            18.4084,
                            3.57922
                        ],
                        [
                            18.34472,
                            3.60661
                        ],
                        [
                            18.26465,
                            3.5851
                        ],
                        [
                            18.22746,
                            3.4897
                        ],
                        [
                            18.17547,
                            3.49034
                        ],
                        [
                            18.11951,
                            3.56718
                        ],
                        [
                            17.94378,
                            3.59815
                        ],
                        [
                            17.86198,
                            3.53376
                        ],
                        [
                            17.82886,
                            3.62572
                        ],
                        [
                            17.73478,
                            3.65011
                        ],
                        [
                            17.60485,
                            3.64192
                        ],
                        [
                            17.54065,
                            3.68663
                        ],
                        [
                            17.47552,
                            3.7029
                        ],
                        [
                            17.396,
                            3.66254
                        ],
                        [
                            17.36728,
                            3.61302
                        ],
                        [
                            17.29556,
                            3.62865
                        ],
                        [
                            17.24094,
                            3.58031
                        ],
                        [
                            17.06,
                            3.54708
                        ],
                        [
                            16.95622,
                            3.5588
                        ],
                        [
                            16.87036,
                            3.55069
                        ],
                        [
                            16.85518,
                            3.51142
                        ],
                        [
                            16.75364,
                            3.55638
                        ],
                        [
                            16.67094,
                            3.54083
                        ],
                        [
                            16.59703,
                            3.4771
                        ],
                        [
                            16.55721,
                            3.25259
                        ],
                        [
                            16.5068,
                            3.16246
                        ],
                        [
                            16.54347,
                            3.0688
                        ],
                        [
                            16.49337,
                            3.00055
                        ],
                        [
                            16.49059,
                            2.91218
                        ],
                        [
                            16.51902,
                            2.84091
                        ],
                        [
                            16.19199,
                            2.22051
                        ],
                        [
                            16.14129,
                            2.17672
                        ],
                        [
                            16.08498,
                            2.18552
                        ],
                        [
                            16.08287,
                            2.0476
                        ],
                        [
                            16.05649,
                            2.0021
                        ],
                        [
                            16.11293,
                            1.86914
                        ],
                        [
                            16.15242,
                            1.70349
                        ],
                        [
                            16.03162,
                            1.65845
                        ],
                        [
                            16.02349,
                            1.76536
                        ],
                        [
                            15.88707,
                            1.7805
                        ],
                        [
                            15.87021,
                            1.82281
                        ],
                        [
                            15.8069,
                            1.85342
                        ],
                        [
                            15.76914,
                            1.90438
                        ],
                        [
                            15.68899,
                            1.93223
                        ],
                        [
                            15.52691,
                            1.95368
                        ],
                        [
                            15.49048,
                            1.97537
                        ],
                        [
                            15.34564,
                            1.91173
                        ],
                        [
                            15.25043,
                            2.02606
                        ],
                        [
                            15.19603,
                            2.0334
                        ],
                        [
                            15.0508,
                            1.97975
                        ],
                        [
                            14.98727,
                            2.0321
                        ],
                        [
                            14.86639,
                            2.08003
                        ],
                        [
                            14.80978,
                            2.05907
                        ],
                        [
                            14.72968,
                            2.12163
                        ],
                        [
                            14.65165,
                            2.12924
                        ],
                        [
                            14.61047,
                            2.19259
                        ],
                        [
                            14.55655,
                            2.21026
                        ],
                        [
                            14.43165,
                            2.15605
                        ],
                        [
                            14.39575,
                            2.18266
                        ],
                        [
                            14.30992,
                            2.19023
                        ],
                        [
                            14.24567,
                            2.17169
                        ],
                        [
                            13.86248,
                            2.17255
                        ],
                        [
                            13.29897,
                            2.17056
                        ],
                        [
                            13.29407,
                            2.062
                        ],
                        [
                            13.21032,
                            1.98025
                        ],
                        [
                            13.1633,
                            1.90065
                        ],
                        [
                            13.19995,
                            1.80499
                        ],
                        [
                            13.13826,
                            1.70117
                        ],
                        [
                            13.1392,
                            1.5613
                        ],
                        [
                            13.19635,
                            1.51266
                        ],
                        [
                            13.25562,
                            1.38958
                        ],
                        [
                            13.25647,
                            1.31655
                        ],
                        [
                            13.18862,
                            1.29094
                        ],
                        [
                            13.19685,
                            1.21936
                        ],
                        [
                            13.29021,
                            1.22896
                        ],
                        [
                            13.32454,
                            1.26157
                        ],
                        [
                            13.43205,
                            1.29891
                        ],
                        [
                            13.48789,
                            1.27091
                        ],
                        [
                            13.57112,
                            1.28793
                        ],
                        [
                            13.63506,
                            1.34327
                        ],
                        [
                            13.7602,
                            1.35408
                        ],
                        [
                            13.80176,
                            1.42496
                        ],
                        [
                            13.99706,
                            1.4203
                        ],
                        [
                            14.06914,
                            1.38083
                        ],
                        [
                            14.18657,
                            1.39391
                        ],
                        [
                            14.27814,
                            1.34009
                        ],
                        [
                            14.30546,
                            1.29425
                        ],
                        [
                            14.29778,
                            1.23394
                        ],
                        [
                            14.39694,
                            1.09081
                        ],
                        [
                            14.43936,
                            0.96904
                        ],
                        [
                            14.49578,
                            0.9278
                        ],
                        [
                            14.48556,
                            0.82302
                        ],
                        [
                            14.3667,
                            0.69296
                        ],
                        [
                            14.38045,
                            0.63663
                        ],
                        [
                            14.2369,
                            0.5381
                        ],
                        [
                            14.12056,
                            0.5572
                        ],
                        [
                            14.07295,
                            0.49762
                        ],
                        [
                            14.05212,
                            0.40892
                        ],
                        [
                            13.98793,
                            0.37339
                        ],
                        [
                            13.89183,
                            0.20024
                        ],
                        [
                            13.92625,
                            0.12849
                        ],
                        [
                            13.92981,
                            -0.06745
                        ],
                        [
                            13.88947,
                            -0.15482
                        ],
                        [
                            13.89945,
                            -0.21687
                        ],
                        [
                            14.01781,
                            -0.23568
                        ],
                        [
                            14.1466,
                            -0.31018
                        ],
                        [
                            14.18049,
                            -0.43958
                        ],
                        [
                            14.25161,
                            -0.43354
                        ],
                        [
                            14.39518,
                            -0.47464
                        ],
                        [
                            14.46215,
                            -0.55127
                        ],
                        [
                            14.49752,
                            -0.6832
                        ],
                        [
                            14.41136,
                            -0.90877
                        ],
                        [
                            14.42462,
                            -1.00755
                        ],
                        [
                            14.48456,
                            -1.25787
                        ],
                        [
                            14.45468,
                            -1.33786
                        ],
                        [
                            14.49653,
                            -1.40871
                        ],
                        [
                            14.46534,
                            -1.47861
                        ],
                        [
                            14.4719,
                            -1.5533
                        ],
                        [
                            14.38271,
                            -1.59829
                        ],
                        [
                            14.38024,
                            -1.62726
                        ],
                        [
                            14.44978,
                            -1.69258
                        ],
                        [
                            14.42079,
                            -1.73098
                        ],
                        [
                            14.39934,
                            -1.87291
                        ],
                        [
                            14.25613,
                            -1.98644
                        ],
                        [
                            14.2522,
                            -2.10557
                        ],
                        [
                            14.15999,
                            -2.20022
                        ],
                        [
                            14.21558,
                            -2.28327
                        ],
                        [
                            14.10235,
                            -2.47308
                        ],
                        [
                            13.96988,
                            -2.44703
                        ],
                        [
                            13.92264,
                            -2.46401
                        ],
                        [
                            13.86952,
                            -2.42697
                        ],
                        [
                            13.91419,
                            -2.36026
                        ],
                        [
                            13.87912,
                            -2.26017
                        ],
                        [
                            13.81491,
                            -2.15581
                        ],
                        [
                            13.7525,
                            -2.11554
                        ],
                        [
                            13.72654,
                            -2.15982
                        ],
                        [
                            13.58345,
                            -2.3252
                        ],
                        [
                            13.50241,
                            -2.43116
                        ],
                        [
                            13.37377,
                            -2.42032
                        ],
                        [
                            13.26452,
                            -2.37929
                        ],
                        [
                            13.20785,
                            -2.34185
                        ],
                        [
                            13.16627,
                            -2.37844
                        ],
                        [
                            13.04642,
                            -2.33588
                        ],
                        [
                            13.00068,
                            -2.19689
                        ],
                        [
                            12.92983,
                            -2.15417
                        ],
                        [
                            12.88618,
                            -2.10047
                        ],
                        [
                            12.86839,
                            -2.01046
                        ],
                        [
                            12.82732,
                            -1.925
                        ],
                        [
                            12.73257,
                            -1.86498
                        ],
                        [
                            12.64914,
                            -1.88179
                        ],
                        [
                            12.5641,
                            -1.85918
                        ],
                        [
                            12.52409,
                            -1.9012
                        ],
                        [
                            12.44487,
                            -1.87654
                        ],
                        [
                            12.47605,
                            -2.02112
                        ],
                        [
                            12.51913,
                            -2.08602
                        ],
                        [
                            12.51122,
                            -2.15937
                        ],
                        [
                            12.53171,
                            -2.21395
                        ],
                        [
                            12.49886,
                            -2.28029
                        ],
                        [
                            12.52864,
                            -2.32648
                        ],
                        [
                            12.46611,
                            -2.42125
                        ],
                        [
                            12.17813,
                            -2.42134
                        ],
                        [
                            12.09352,
                            -2.43906
                        ],
                        [
                            12.0056,
                            -2.34278
                        ],
                        [
                            11.90534,
                            -2.37804
                        ],
                        [
                            11.81955,
                            -2.38967
                        ],
                        [
                            11.77632,
                            -2.45506
                        ],
                        [
                            11.73101,
                            -2.42822
                        ],
                        [
                            11.67896,
                            -2.35368
                        ],
                        [
                            11.64925,
                            -2.41871
                        ],
                        [
                            11.63669,
                            -2.52154
                        ],
                        [
                            11.70138,
                            -2.68505
                        ],
                        [
                            11.64307,
                            -2.69762
                        ],
                        [
                            11.61716,
                            -2.7859
                        ],
                        [
                            11.67251,
                            -2.8292
                        ],
                        [
                            11.79704,
                            -2.8617
                        ],
                        [
                            12.0087,
                            -2.94781
                        ],
                        [
                            12.06577,
                            -2.98578
                        ],
                        [
                            12.01366,
                            -3.13314
                        ],
                        [
                            11.94682,
                            -3.17253
                        ],
                        [
                            12.00219,
                            -3.24317
                        ],
                        [
                            12.04551,
                            -3.35169
                        ],
                        [
                            11.95952,
                            -3.47726
                        ],
                        [
                            11.89858,
                            -3.51084
                        ],
                        [
                            11.87945,
                            -3.57868
                        ],
                        [
                            11.94733,
                            -3.62578
                        ],
                        [
                            11.8807,
                            -3.74859
                        ],
                        [
                            11.6963,
                            -3.67041
                        ],
                        [
                            11.63146,
                            -3.57049
                        ],
                        [
                            11.53668,
                            -3.51399
                        ],
                        [
                            11.45681,
                            -3.58436
                        ],
                        [
                            11.33344,
                            -3.61514
                        ],
                        [
                            11.24986,
                            -3.71808
                        ],
                        [
                            11.24964,
                            -3.82342
                        ],
                        [
                            11.20103,
                            -3.99158
                        ],
                        [
                            11.28477,
                            -4.05499
                        ],
                        [
                            11.37328,
                            -4.14626
                        ],
                        [
                            11.39434,
                            -4.21228
                        ],
                        [
                            11.70874,
                            -4.47189
                        ],
                        [
                            11.79824,
                            -4.56452
                        ],
                        [
                            11.82455,
                            -4.62708
                        ],
                        [
                            11.79104,
                            -4.69022
                        ],
                        [
                            11.8359,
                            -4.72949
                        ],
                        [
                            11.82484,
                            -4.78843
                        ],
                        [
                            11.98925,
                            -4.99932
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "COK",
                "Country": "Cook Islands",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    2.5489e-09,
                    5.1365e-09,
                    7.7683e-09,
                    1.0439e-08,
                    1.3153e-08,
                    1.5905e-08,
                    1.87e-08,
                    2.1539e-08,
                    2.4414e-08,
                    2.7332e-08,
                    3.0284e-08,
                    3.3271e-08,
                    3.6286e-08,
                    3.9335e-08,
                    4.2424e-08,
                    4.5547e-08,
                    4.8704e-08,
                    5.1896e-08,
                    5.5127e-08,
                    5.8392e-08,
                    6.1699e-08,
                    6.5046e-08,
                    6.8435e-08,
                    7.1874e-08,
                    7.5359e-08,
                    7.8895e-08,
                    8.2481e-08,
                    8.6117e-08,
                    8.98e-08,
                    9.3521e-08,
                    9.7297e-08,
                    1.0112e-07,
                    1.0499e-07,
                    1.0891e-07,
                    1.1288e-07,
                    1.1689e-07,
                    1.2096e-07,
                    1.2508e-07,
                    1.2924e-07,
                    1.3349e-07,
                    1.3777e-07,
                    1.4209e-07,
                    1.4645e-07,
                    1.5085e-07,
                    1.5529e-07,
                    1.5979e-07,
                    1.6433e-07,
                    1.6892e-07,
                    1.7355e-07,
                    1.7823e-07,
                    1.8296e-07,
                    1.8775e-07,
                    1.9258e-07,
                    1.9748e-07,
                    2.0243e-07,
                    2.0744e-07,
                    2.1252e-07,
                    2.1767e-07,
                    2.2288e-07,
                    2.2816e-07,
                    2.3352e-07,
                    2.3894e-07,
                    2.4444e-07,
                    2.5002e-07,
                    2.5569e-07,
                    2.6145e-07,
                    2.673e-07,
                    2.7326e-07,
                    2.7933e-07,
                    2.8551e-07,
                    2.9181e-07,
                    2.9825e-07,
                    3.0484e-07,
                    3.1157e-07,
                    3.1845e-07,
                    3.2549e-07,
                    3.327e-07,
                    3.4008e-07,
                    3.4762e-07,
                    3.5535e-07,
                    3.6325e-07,
                    3.7135e-07,
                    3.7964e-07,
                    3.8814e-07,
                    3.9684e-07,
                    4.0604e-07,
                    4.1573e-07,
                    4.2594e-07,
                    4.3667e-07,
                    4.4792e-07,
                    4.5968e-07,
                    4.7197e-07,
                    4.848e-07,
                    4.9818e-07,
                    5.1231e-07,
                    5.272e-07,
                    5.4285e-07,
                    5.5926e-07,
                    5.7643e-07,
                    5.9437e-07,
                    6.1333e-07,
                    6.3327e-07,
                    6.5422e-07,
                    6.7618e-07,
                    6.992e-07,
                    7.2308e-07,
                    7.478e-07,
                    7.7334e-07,
                    8.0022e-07,
                    8.28e-07,
                    8.5519e-07,
                    8.8172e-07,
                    9.073e-07,
                    9.3052e-07,
                    9.5281e-07,
                    9.6731e-07,
                    9.8445e-07,
                    1.0007e-06,
                    1.0211e-06,
                    1.0404e-06,
                    1.0585e-06,
                    1.0722e-06,
                    1.0865e-06,
                    1.1022e-06,
                    1.1192e-06,
                    1.1491e-06,
                    1.1836e-06,
                    1.2169e-06,
                    1.2459e-06,
                    1.2746e-06,
                    1.3191e-06,
                    1.3555e-06,
                    1.3902e-06,
                    1.4101e-06,
                    1.4278e-06,
                    1.4502e-06,
                    1.4689e-06,
                    1.4875e-06,
                    1.5056e-06,
                    1.5343e-06,
                    1.5616e-06,
                    1.5935e-06,
                    1.6314e-06,
                    1.6696e-06,
                    1.7095e-06,
                    1.7444e-06,
                    1.7829e-06,
                    1.8222e-06,
                    1.8572e-06,
                    1.8917e-06,
                    1.9205e-06,
                    1.9444e-06,
                    1.9716e-06,
                    2.0044e-06,
                    2.0412e-06,
                    2.0795e-06,
                    2.117e-06,
                    2.1539e-06,
                    2.19e-06,
                    2.2284e-06,
                    2.2707e-06,
                    2.3138e-06,
                    2.3507e-06,
                    2.3848e-06,
                    2.4157e-06,
                    2.4374e-06,
                    2.4594e-06,
                    2.4797e-06,
                    2.5075e-06,
                    2.527e-06,
                    2.5504e-06,
                    2.5721e-06
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    1.6432e-10,
                    3.2965e-10,
                    4.96e-10,
                    6.6335e-10,
                    8.317e-10,
                    1.001e-09,
                    1.1713e-09,
                    1.3426e-09,
                    1.5148e-09,
                    1.6879e-09,
                    1.86e-09,
                    2.0311e-09,
                    2.2012e-09,
                    2.3703e-09,
                    2.5384e-09,
                    2.7054e-09,
                    2.8714e-09,
                    3.0364e-09,
                    3.2004e-09,
                    3.3634e-09,
                    3.5254e-09,
                    3.6864e-09,
                    3.8467e-09,
                    4.0062e-09,
                    4.1651e-09,
                    4.3234e-09,
                    4.4811e-09,
                    4.638e-09,
                    4.7941e-09,
                    4.9492e-09,
                    5.1049e-09,
                    5.2613e-09,
                    5.4182e-09,
                    5.5756e-09,
                    5.7336e-09,
                    5.8921e-09,
                    6.0512e-09,
                    6.2108e-09,
                    6.371e-09,
                    6.5318e-09,
                    6.6933e-09,
                    6.8553e-09,
                    7.0179e-09,
                    7.1811e-09,
                    7.345e-09,
                    7.5094e-09,
                    7.6744e-09,
                    7.8401e-09,
                    8.0063e-09,
                    8.1733e-09,
                    8.3383e-09,
                    8.5015e-09,
                    8.6628e-09,
                    8.8223e-09,
                    8.98e-09,
                    9.1359e-09,
                    9.2899e-09,
                    9.4422e-09,
                    9.5926e-09,
                    9.7411e-09,
                    9.8868e-09,
                    1.003e-08,
                    1.017e-08,
                    1.0307e-08,
                    1.0441e-08,
                    1.0573e-08,
                    1.0702e-08,
                    1.0828e-08,
                    1.0951e-08,
                    1.1071e-08,
                    1.12e-08,
                    1.1336e-08,
                    1.1481e-08,
                    1.1634e-08,
                    1.1794e-08,
                    1.1963e-08,
                    1.2139e-08,
                    1.2324e-08,
                    1.2516e-08,
                    1.2716e-08,
                    1.2925e-08,
                    1.3142e-08,
                    1.3369e-08,
                    1.3605e-08,
                    1.385e-08,
                    1.4104e-08,
                    1.4367e-08,
                    1.464e-08,
                    1.4922e-08,
                    1.5215e-08,
                    1.5508e-08,
                    1.5801e-08,
                    1.6095e-08,
                    1.639e-08,
                    1.6873e-08,
                    1.7545e-08,
                    1.8404e-08,
                    1.9449e-08,
                    2.068e-08,
                    2.2095e-08,
                    2.3751e-08,
                    2.5636e-08,
                    2.7752e-08,
                    3.0109e-08,
                    3.2727e-08,
                    3.5629e-08,
                    3.8836e-08,
                    4.2361e-08,
                    4.6204e-08,
                    5.0345e-08,
                    5.4758e-08,
                    5.9421e-08,
                    6.4331e-08,
                    6.9515e-08,
                    7.4849e-08,
                    8.0401e-08,
                    8.6231e-08,
                    9.2367e-08,
                    1.0378e-07,
                    1.1469e-07,
                    1.2537e-07,
                    1.3579e-07,
                    1.4599e-07,
                    1.5596e-07,
                    1.6724e-07,
                    1.7808e-07,
                    1.9507e-07,
                    2.1156e-07,
                    2.2592e-07,
                    2.4149e-07,
                    2.7378e-07,
                    2.9929e-07,
                    3.2459e-07,
                    3.3638e-07,
                    3.4794e-07,
                    3.5896e-07,
                    3.6974e-07,
                    3.8017e-07,
                    3.902e-07,
                    4.1098e-07,
                    4.312e-07,
                    4.5194e-07,
                    4.7458e-07,
                    4.9751e-07,
                    5.2075e-07,
                    5.4598e-07,
                    5.7157e-07,
                    5.9576e-07,
                    6.2186e-07,
                    6.4837e-07,
                    6.7325e-07,
                    6.9479e-07,
                    7.1988e-07,
                    7.489e-07,
                    7.8197e-07,
                    8.1677e-07,
                    8.5131e-07,
                    8.8577e-07,
                    9.1993e-07,
                    9.5706e-07,
                    9.9795e-07,
                    1.0402e-06,
                    1.0814e-06,
                    1.1206e-06,
                    1.1594e-06,
                    1.1948e-06,
                    1.2333e-06,
                    1.2718e-06,
                    1.3118e-06,
                    1.343e-06,
                    1.3753e-06,
                    1.407e-06
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [
                    2.3845e-09,
                    4.8068e-09,
                    7.2723e-09,
                    9.7752e-09,
                    1.2321e-08,
                    1.4904e-08,
                    1.7529e-08,
                    2.0196e-08,
                    2.29e-08,
                    2.5644e-08,
                    2.8424e-08,
                    3.124e-08,
                    3.4085e-08,
                    3.6965e-08,
                    3.9886e-08,
                    4.2842e-08,
                    4.5833e-08,
                    4.8859e-08,
                    5.1927e-08,
                    5.5029e-08,
                    5.8174e-08,
                    6.136e-08,
                    6.4588e-08,
                    6.7868e-08,
                    7.1194e-08,
                    7.4571e-08,
                    7.8e-08,
                    8.1479e-08,
                    8.5006e-08,
                    8.8572e-08,
                    9.2192e-08,
                    9.5859e-08,
                    9.9573e-08,
                    1.0333e-07,
                    1.0714e-07,
                    1.11e-07,
                    1.1491e-07,
                    1.1887e-07,
                    1.2287e-07,
                    1.2696e-07,
                    1.3107e-07,
                    1.3523e-07,
                    1.3943e-07,
                    1.4367e-07,
                    1.4795e-07,
                    1.5228e-07,
                    1.5665e-07,
                    1.6108e-07,
                    1.6554e-07,
                    1.7006e-07,
                    1.7462e-07,
                    1.7925e-07,
                    1.8392e-07,
                    1.8865e-07,
                    1.9345e-07,
                    1.9831e-07,
                    2.0323e-07,
                    2.0823e-07,
                    2.1329e-07,
                    2.1842e-07,
                    2.2363e-07,
                    2.2891e-07,
                    2.3427e-07,
                    2.3971e-07,
                    2.4524e-07,
                    2.5088e-07,
                    2.566e-07,
                    2.6244e-07,
                    2.6838e-07,
                    2.7444e-07,
                    2.8061e-07,
                    2.8692e-07,
                    2.9336e-07,
                    2.9993e-07,
                    3.0666e-07,
                    3.1353e-07,
                    3.2056e-07,
                    3.2775e-07,
                    3.3511e-07,
                    3.4263e-07,
                    3.5033e-07,
                    3.5821e-07,
                    3.6627e-07,
                    3.7453e-07,
                    3.8299e-07,
                    3.9193e-07,
                    4.0137e-07,
                    4.113e-07,
                    4.2175e-07,
                    4.3271e-07,
                    4.4418e-07,
                    4.5617e-07,
                    4.6871e-07,
                    4.8179e-07,
                    4.9544e-07,
                    5.0965e-07,
                    5.2444e-07,
                    5.3981e-07,
                    5.5575e-07,
                    5.7227e-07,
                    5.8958e-07,
                    6.0764e-07,
                    6.2646e-07,
                    6.4607e-07,
                    6.6648e-07,
                    6.8745e-07,
                    7.0896e-07,
                    7.3098e-07,
                    7.5402e-07,
                    7.7765e-07,
                    8.0044e-07,
                    8.223e-07,
                    8.4297e-07,
                    8.6101e-07,
                    8.7796e-07,
                    8.8691e-07,
                    8.9822e-07,
                    9.083e-07,
                    9.1734e-07,
                    9.2566e-07,
                    9.3315e-07,
                    9.3636e-07,
                    9.4054e-07,
                    9.462e-07,
                    9.5199e-07,
                    9.7103e-07,
                    9.8853e-07,
                    1.0053e-06,
                    1.02e-06,
                    1.0331e-06,
                    1.0453e-06,
                    1.0562e-06,
                    1.0656e-06,
                    1.0737e-06,
                    1.0798e-06,
                    1.0912e-06,
                    1.0992e-06,
                    1.1073e-06,
                    1.1154e-06,
                    1.1233e-06,
                    1.1304e-06,
                    1.1415e-06,
                    1.1569e-06,
                    1.1721e-06,
                    1.1888e-06,
                    1.1984e-06,
                    1.2113e-06,
                    1.2264e-06,
                    1.2354e-06,
                    1.2433e-06,
                    1.2473e-06,
                    1.2496e-06,
                    1.2517e-06,
                    1.2555e-06,
                    1.2592e-06,
                    1.2627e-06,
                    1.2657e-06,
                    1.2681e-06,
                    1.27e-06,
                    1.2714e-06,
                    1.2727e-06,
                    1.2736e-06,
                    1.2694e-06,
                    1.2642e-06,
                    1.2563e-06,
                    1.2426e-06,
                    1.226e-06,
                    1.2079e-06,
                    1.1957e-06,
                    1.184e-06,
                    1.1751e-06,
                    1.165e-06
                ],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    1.8425e-09,
                    3.718e-09,
                    5.632e-09,
                    7.579e-09,
                    9.5645e-09,
                    1.1583e-08,
                    1.364e-08,
                    1.5735e-08,
                    1.7864e-08,
                    2.0031e-08,
                    2.2236e-08,
                    2.448e-08,
                    2.6757e-08,
                    2.9073e-08,
                    3.1433e-08,
                    3.383e-08,
                    3.6267e-08,
                    3.8742e-08,
                    4.1261e-08,
                    4.3819e-08,
                    4.642e-08,
                    4.906e-08,
                    5.1739e-08,
                    5.4461e-08,
                    5.7222e-08,
                    6.0027e-08,
                    6.2876e-08,
                    6.5769e-08,
                    6.8706e-08,
                    7.1682e-08,
                    7.4707e-08,
                    7.7776e-08,
                    8.0889e-08,
                    8.4046e-08,
                    8.7247e-08,
                    9.0497e-08,
                    9.3792e-08,
                    9.7136e-08,
                    1.0052e-07,
                    1.0396e-07,
                    1.0744e-07,
                    1.1097e-07,
                    1.1455e-07,
                    1.1818e-07,
                    1.2185e-07,
                    1.2558e-07,
                    1.2935e-07,
                    1.3317e-07,
                    1.3704e-07,
                    1.4095e-07,
                    1.4491e-07,
                    1.4892e-07,
                    1.5298e-07,
                    1.5708e-07,
                    1.6123e-07,
                    1.6543e-07,
                    1.6969e-07,
                    1.74e-07,
                    1.7838e-07,
                    1.8281e-07,
                    1.8732e-07,
                    1.9191e-07,
                    1.9656e-07,
                    2.0131e-07,
                    2.0613e-07,
                    2.1106e-07,
                    2.1608e-07,
                    2.2122e-07,
                    2.2645e-07,
                    2.318e-07,
                    2.3727e-07,
                    2.4286e-07,
                    2.4859e-07,
                    2.5445e-07,
                    2.6045e-07,
                    2.666e-07,
                    2.729e-07,
                    2.7936e-07,
                    2.8599e-07,
                    2.9278e-07,
                    2.9975e-07,
                    3.069e-07,
                    3.1424e-07,
                    3.2177e-07,
                    3.2949e-07,
                    3.3743e-07,
                    3.4557e-07,
                    3.5393e-07,
                    3.6251e-07,
                    3.7131e-07,
                    3.8035e-07,
                    3.8962e-07,
                    3.9913e-07,
                    4.089e-07,
                    4.1892e-07,
                    4.292e-07,
                    4.3976e-07,
                    4.506e-07,
                    4.6171e-07,
                    4.7312e-07,
                    4.8485e-07,
                    4.9691e-07,
                    5.0932e-07,
                    5.2207e-07,
                    5.3513e-07,
                    5.4848e-07,
                    5.6205e-07,
                    5.7577e-07,
                    5.9017e-07,
                    6.049e-07,
                    6.192e-07,
                    6.3265e-07,
                    6.4501e-07,
                    6.5544e-07,
                    6.6418e-07,
                    6.7146e-07,
                    6.7756e-07,
                    6.8278e-07,
                    6.9219e-07,
                    7.0106e-07,
                    7.094e-07,
                    7.1718e-07,
                    7.2455e-07,
                    7.3163e-07,
                    7.401e-07,
                    7.4836e-07,
                    7.6299e-07,
                    7.7745e-07,
                    7.9015e-07,
                    8.0442e-07,
                    8.3514e-07,
                    8.5915e-07,
                    8.8301e-07,
                    8.9355e-07,
                    9.0407e-07,
                    9.1464e-07,
                    9.2524e-07,
                    9.3582e-07,
                    9.4637e-07,
                    9.6639e-07,
                    9.8581e-07,
                    1.0052e-06,
                    1.0257e-06,
                    1.0451e-06,
                    1.0639e-06,
                    1.0842e-06,
                    1.1043e-06,
                    1.1226e-06,
                    1.1424e-06,
                    1.162e-06,
                    1.1794e-06,
                    1.1919e-06,
                    1.2064e-06,
                    1.2231e-06,
                    1.242e-06,
                    1.2619e-06,
                    1.2811e-06,
                    1.2997e-06,
                    1.3178e-06,
                    1.3389e-06,
                    1.3634e-06,
                    1.3898e-06,
                    1.417e-06,
                    1.4441e-06,
                    1.4715e-06,
                    1.4955e-06,
                    1.523e-06,
                    1.5508e-06,
                    1.5804e-06,
                    1.602e-06,
                    1.6251e-06,
                    1.648e-06
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    4.95e-09,
                    9.9e-09,
                    1.485e-08,
                    1.98e-08,
                    2.475e-08,
                    2.97e-08,
                    3.63e-08,
                    4.29e-08,
                    5.61e-08,
                    6.93e-08,
                    8.085e-08,
                    9.405e-08,
                    1.2375e-07,
                    1.4685e-07,
                    1.6995e-07,
                    1.7985e-07,
                    1.8975e-07,
                    1.9965e-07,
                    2.0955e-07,
                    2.1945e-07,
                    2.2935e-07,
                    2.4915e-07,
                    2.6895e-07,
                    2.8875e-07,
                    3.102e-07,
                    3.3165e-07,
                    3.531e-07,
                    3.762e-07,
                    3.993e-07,
                    4.2075e-07,
                    4.4385e-07,
                    4.6695e-07,
                    4.884e-07,
                    5.0655e-07,
                    5.28e-07,
                    5.5275e-07,
                    5.808e-07,
                    6.105e-07,
                    6.402e-07,
                    6.699e-07,
                    6.996e-07,
                    7.326e-07,
                    7.689e-07,
                    8.0685e-07,
                    8.448e-07,
                    8.811e-07,
                    9.174e-07,
                    9.504e-07,
                    9.867e-07,
                    1.023e-06,
                    1.0609e-06,
                    1.0907e-06,
                    1.1216e-06,
                    1.1523e-06
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [
                    1.8425e-09,
                    3.718e-09,
                    5.632e-09,
                    7.579e-09,
                    9.5645e-09,
                    1.1583e-08,
                    1.364e-08,
                    1.5735e-08,
                    1.7864e-08,
                    2.0031e-08,
                    2.2236e-08,
                    2.448e-08,
                    2.6757e-08,
                    2.9073e-08,
                    3.1433e-08,
                    3.383e-08,
                    3.6267e-08,
                    3.8742e-08,
                    4.1261e-08,
                    4.3819e-08,
                    4.642e-08,
                    4.906e-08,
                    5.1739e-08,
                    5.4461e-08,
                    5.7222e-08,
                    6.0027e-08,
                    6.2876e-08,
                    6.5769e-08,
                    6.8706e-08,
                    7.1682e-08,
                    7.4707e-08,
                    7.7776e-08,
                    8.0889e-08,
                    8.4046e-08,
                    8.7247e-08,
                    9.0497e-08,
                    9.3792e-08,
                    9.7136e-08,
                    1.0052e-07,
                    1.0396e-07,
                    1.0744e-07,
                    1.1097e-07,
                    1.1455e-07,
                    1.1818e-07,
                    1.2185e-07,
                    1.2558e-07,
                    1.2935e-07,
                    1.3317e-07,
                    1.3704e-07,
                    1.4095e-07,
                    1.4491e-07,
                    1.4892e-07,
                    1.5298e-07,
                    1.5708e-07,
                    1.6123e-07,
                    1.6543e-07,
                    1.6969e-07,
                    1.74e-07,
                    1.7838e-07,
                    1.8281e-07,
                    1.8732e-07,
                    1.9191e-07,
                    1.9656e-07,
                    2.0131e-07,
                    2.0613e-07,
                    2.1106e-07,
                    2.1608e-07,
                    2.2122e-07,
                    2.2645e-07,
                    2.318e-07,
                    2.3727e-07,
                    2.4286e-07,
                    2.4859e-07,
                    2.5445e-07,
                    2.6045e-07,
                    2.666e-07,
                    2.729e-07,
                    2.7936e-07,
                    2.8599e-07,
                    2.9278e-07,
                    2.9975e-07,
                    3.069e-07,
                    3.1424e-07,
                    3.2177e-07,
                    3.2949e-07,
                    3.3743e-07,
                    3.4557e-07,
                    3.5393e-07,
                    3.6251e-07,
                    3.7131e-07,
                    3.8035e-07,
                    3.8962e-07,
                    3.9913e-07,
                    4.089e-07,
                    4.1892e-07,
                    4.292e-07,
                    4.3976e-07,
                    4.506e-07,
                    4.6171e-07,
                    4.7312e-07,
                    4.8485e-07,
                    4.9691e-07,
                    5.0932e-07,
                    5.2207e-07,
                    5.3513e-07,
                    5.4848e-07,
                    5.6205e-07,
                    5.7577e-07,
                    5.9017e-07,
                    6.049e-07,
                    6.192e-07,
                    6.3265e-07,
                    6.4501e-07,
                    6.5544e-07,
                    6.6418e-07,
                    6.7146e-07,
                    6.7756e-07,
                    6.8278e-07,
                    6.8724e-07,
                    6.9116e-07,
                    6.9455e-07,
                    6.9738e-07,
                    6.998e-07,
                    7.0193e-07,
                    7.038e-07,
                    7.0546e-07,
                    7.0689e-07,
                    7.0815e-07,
                    7.093e-07,
                    7.1037e-07,
                    7.1139e-07,
                    7.123e-07,
                    7.1306e-07,
                    7.137e-07,
                    7.1432e-07,
                    7.1499e-07,
                    7.1569e-07,
                    7.1637e-07,
                    7.1702e-07,
                    7.1724e-07,
                    7.1686e-07,
                    7.1649e-07,
                    7.155e-07,
                    7.1347e-07,
                    7.1081e-07,
                    7.0798e-07,
                    7.05e-07,
                    7.0184e-07,
                    6.9851e-07,
                    6.9508e-07,
                    6.91e-07,
                    6.8531e-07,
                    6.7841e-07,
                    6.7032e-07,
                    6.612e-07,
                    6.5137e-07,
                    6.4088e-07,
                    6.2979e-07,
                    6.1823e-07,
                    6.0635e-07,
                    5.945e-07,
                    5.8294e-07,
                    5.7219e-07,
                    5.63e-07,
                    5.5413e-07,
                    5.4511e-07,
                    5.3629e-07,
                    5.2777e-07,
                    5.1948e-07,
                    5.1135e-07,
                    5.0344e-07,
                    4.9574e-07
                ],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [
                    5.5837e-10,
                    1.1198e-09,
                    1.6842e-09,
                    2.2516e-09,
                    2.8221e-09,
                    3.3956e-09,
                    3.9721e-09,
                    4.5516e-09,
                    5.1341e-09,
                    5.7196e-09,
                    6.3006e-09,
                    6.8768e-09,
                    7.4485e-09,
                    8.0155e-09,
                    8.5778e-09,
                    9.1355e-09,
                    9.6886e-09,
                    1.0237e-08,
                    1.0781e-08,
                    1.132e-08,
                    1.1854e-08,
                    1.2383e-08,
                    1.2906e-08,
                    1.3425e-08,
                    1.3938e-08,
                    1.4446e-08,
                    1.4949e-08,
                    1.5447e-08,
                    1.5939e-08,
                    1.6427e-08,
                    1.6915e-08,
                    1.7406e-08,
                    1.7898e-08,
                    1.8391e-08,
                    1.8886e-08,
                    1.9383e-08,
                    1.9881e-08,
                    2.0381e-08,
                    2.0882e-08,
                    2.1385e-08,
                    2.1889e-08,
                    2.2395e-08,
                    2.2903e-08,
                    2.3412e-08,
                    2.3922e-08,
                    2.4435e-08,
                    2.4948e-08,
                    2.5464e-08,
                    2.598e-08,
                    2.6499e-08,
                    2.7016e-08,
                    2.7533e-08,
                    2.8048e-08,
                    2.8562e-08,
                    2.9076e-08,
                    2.9588e-08,
                    3.01e-08,
                    3.061e-08,
                    3.112e-08,
                    3.1628e-08,
                    3.2132e-08,
                    3.2631e-08,
                    3.3125e-08,
                    3.3614e-08,
                    3.4098e-08,
                    3.4578e-08,
                    3.5053e-08,
                    3.5523e-08,
                    3.5988e-08,
                    3.6449e-08,
                    3.6915e-08,
                    3.7388e-08,
                    3.7867e-08,
                    3.8351e-08,
                    3.8842e-08,
                    3.9338e-08,
                    3.9841e-08,
                    4.0349e-08,
                    4.0863e-08,
                    4.1383e-08,
                    4.1912e-08,
                    4.245e-08,
                    4.2996e-08,
                    4.3552e-08,
                    4.4116e-08,
                    4.4972e-08,
                    4.6119e-08,
                    4.7561e-08,
                    4.9298e-08,
                    5.1334e-08,
                    5.3643e-08,
                    5.6223e-08,
                    5.9075e-08,
                    6.2198e-08,
                    6.5779e-08,
                    6.9818e-08,
                    7.4313e-08,
                    7.9264e-08,
                    8.467e-08,
                    9.053e-08,
                    9.7083e-08,
                    1.0427e-07,
                    1.1209e-07,
                    1.2058e-07,
                    1.298e-07,
                    1.3958e-07,
                    1.4996e-07,
                    1.61e-07,
                    1.7267e-07,
                    1.8491e-07,
                    1.9696e-07,
                    2.0918e-07,
                    2.2153e-07,
                    2.3347e-07,
                    2.4612e-07,
                    2.5267e-07,
                    2.6292e-07,
                    2.7313e-07,
                    2.8336e-07,
                    2.9288e-07,
                    3.0185e-07,
                    3.0699e-07,
                    3.1318e-07,
                    3.2079e-07,
                    3.2837e-07,
                    3.4825e-07,
                    3.6637e-07,
                    3.8344e-07,
                    3.9817e-07,
                    4.1101e-07,
                    4.2308e-07,
                    4.3385e-07,
                    4.4303e-07,
                    4.5095e-07,
                    4.5671e-07,
                    4.6726e-07,
                    4.7403e-07,
                    4.8061e-07,
                    4.8685e-07,
                    4.9408e-07,
                    5.0075e-07,
                    5.1164e-07,
                    5.2743e-07,
                    5.4431e-07,
                    5.6347e-07,
                    5.7599e-07,
                    5.9213e-07,
                    6.1085e-07,
                    6.2406e-07,
                    6.3687e-07,
                    6.4655e-07,
                    6.5641e-07,
                    6.6753e-07,
                    6.8195e-07,
                    6.9789e-07,
                    7.1431e-07,
                    7.3077e-07,
                    7.4704e-07,
                    7.6316e-07,
                    7.7859e-07,
                    7.9441e-07,
                    8.0907e-07,
                    8.1683e-07,
                    8.2171e-07,
                    8.232e-07,
                    8.1882e-07,
                    8.1139e-07,
                    8.0206e-07,
                    7.9815e-07,
                    7.9426e-07,
                    7.9279e-07,
                    7.8979e-07
                ],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [
                    1.3788e-10,
                    2.7645e-10,
                    4.1573e-10,
                    5.557e-10,
                    6.9637e-10,
                    8.3773e-10,
                    9.7979e-10,
                    1.1225e-09,
                    1.266e-09,
                    1.4101e-09,
                    1.5531e-09,
                    1.6948e-09,
                    1.8352e-09,
                    1.9745e-09,
                    2.1125e-09,
                    2.2493e-09,
                    2.3848e-09,
                    2.5192e-09,
                    2.6523e-09,
                    2.7842e-09,
                    2.9147e-09,
                    3.0438e-09,
                    3.1716e-09,
                    3.298e-09,
                    3.423e-09,
                    3.5466e-09,
                    3.6688e-09,
                    3.7897e-09,
                    3.9092e-09,
                    4.0273e-09,
                    4.1456e-09,
                    4.2643e-09,
                    4.3832e-09,
                    4.5024e-09,
                    4.6219e-09,
                    4.7417e-09,
                    4.8617e-09,
                    4.982e-09,
                    5.1025e-09,
                    5.2234e-09,
                    5.3444e-09,
                    5.4658e-09,
                    5.5873e-09,
                    5.7092e-09,
                    5.8312e-09,
                    5.9535e-09,
                    6.0761e-09,
                    6.1988e-09,
                    6.3219e-09,
                    6.4451e-09,
                    6.566e-09,
                    6.6846e-09,
                    6.8008e-09,
                    6.9147e-09,
                    7.0263e-09,
                    7.1354e-09,
                    7.2422e-09,
                    7.3467e-09,
                    7.4487e-09,
                    7.5484e-09,
                    7.6448e-09,
                    7.7379e-09,
                    7.8276e-09,
                    7.9141e-09,
                    7.9973e-09,
                    8.0772e-09,
                    8.1538e-09,
                    8.2272e-09,
                    8.2974e-09,
                    8.3643e-09,
                    8.4388e-09,
                    8.5211e-09,
                    8.6109e-09,
                    8.7084e-09,
                    8.8135e-09,
                    8.9261e-09,
                    9.0462e-09,
                    9.1737e-09,
                    9.3088e-09,
                    9.4512e-09,
                    9.6017e-09,
                    9.7602e-09,
                    9.9267e-09,
                    1.0101e-08,
                    1.0283e-08,
                    1.0473e-08,
                    1.067e-08,
                    1.0875e-08,
                    1.1088e-08,
                    1.131e-08,
                    1.1531e-08,
                    1.1749e-08,
                    1.1964e-08,
                    1.2177e-08,
                    1.2574e-08,
                    1.3156e-08,
                    1.3922e-08,
                    1.4871e-08,
                    1.6002e-08,
                    1.7316e-08,
                    1.8868e-08,
                    2.0649e-08,
                    2.2658e-08,
                    2.4908e-08,
                    2.7417e-08,
                    3.0208e-08,
                    3.3304e-08,
                    3.6717e-08,
                    4.0445e-08,
                    4.4469e-08,
                    4.8762e-08,
                    5.33e-08,
                    5.8076e-08,
                    6.3117e-08,
                    6.8299e-08,
                    7.369e-08,
                    7.935e-08,
                    8.5307e-08,
                    9.1586e-08,
                    9.7331e-08,
                    1.0284e-07,
                    1.0808e-07,
                    1.1308e-07,
                    1.1785e-07,
                    1.2226e-07,
                    1.2623e-07,
                    1.2971e-07,
                    1.3271e-07,
                    1.3522e-07,
                    1.3729e-07,
                    1.3937e-07,
                    1.4126e-07,
                    1.4295e-07,
                    1.4436e-07,
                    1.4548e-07,
                    1.4615e-07,
                    1.4656e-07,
                    1.4662e-07,
                    1.4631e-07,
                    1.4684e-07,
                    1.469e-07,
                    1.4734e-07,
                    1.4803e-07,
                    1.49e-07,
                    1.5026e-07,
                    1.5184e-07,
                    1.5374e-07,
                    1.5585e-07,
                    1.5823e-07,
                    1.6102e-07,
                    1.6384e-07,
                    1.6683e-07,
                    1.7009e-07,
                    1.7381e-07,
                    1.7804e-07,
                    1.8235e-07,
                    1.8645e-07,
                    1.9045e-07,
                    1.9428e-07,
                    1.9764e-07,
                    2.014e-07,
                    2.0481e-07,
                    2.0717e-07,
                    2.092e-07,
                    2.1092e-07,
                    2.1243e-07,
                    2.1384e-07,
                    2.152e-07,
                    2.1639e-07,
                    2.1713e-07,
                    2.176e-07,
                    2.1786e-07
                ],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [
                    4.205e-10,
                    8.4332e-10,
                    1.2685e-09,
                    1.6959e-09,
                    2.1257e-09,
                    2.5578e-09,
                    2.9923e-09,
                    3.429e-09,
                    3.8681e-09,
                    4.3095e-09,
                    4.7475e-09,
                    5.1821e-09,
                    5.6132e-09,
                    6.041e-09,
                    6.4653e-09,
                    6.8863e-09,
                    7.3038e-09,
                    7.7179e-09,
                    8.1286e-09,
                    8.5358e-09,
                    8.9393e-09,
                    9.339e-09,
                    9.7348e-09,
                    1.0127e-08,
                    1.0515e-08,
                    1.09e-08,
                    1.128e-08,
                    1.1657e-08,
                    1.203e-08,
                    1.2399e-08,
                    1.277e-08,
                    1.3142e-08,
                    1.3515e-08,
                    1.3889e-08,
                    1.4265e-08,
                    1.4641e-08,
                    1.502e-08,
                    1.5399e-08,
                    1.578e-08,
                    1.6162e-08,
                    1.6545e-08,
                    1.6929e-08,
                    1.7315e-08,
                    1.7703e-08,
                    1.8091e-08,
                    1.8481e-08,
                    1.8872e-08,
                    1.9265e-08,
                    1.9658e-08,
                    2.0054e-08,
                    2.045e-08,
                    2.0848e-08,
                    2.1247e-08,
                    2.1648e-08,
                    2.205e-08,
                    2.2453e-08,
                    2.2858e-08,
                    2.3264e-08,
                    2.3671e-08,
                    2.408e-08,
                    2.4487e-08,
                    2.4893e-08,
                    2.5297e-08,
                    2.57e-08,
                    2.6101e-08,
                    2.6501e-08,
                    2.6899e-08,
                    2.7296e-08,
                    2.7691e-08,
                    2.8085e-08,
                    2.8477e-08,
                    2.8867e-08,
                    2.9256e-08,
                    2.9643e-08,
                    3.0028e-08,
                    3.0412e-08,
                    3.0795e-08,
                    3.1175e-08,
                    3.1554e-08,
                    3.1932e-08,
                    3.231e-08,
                    3.2689e-08,
                    3.307e-08,
                    3.3451e-08,
                    3.3833e-08,
                    3.4499e-08,
                    3.5449e-08,
                    3.6686e-08,
                    3.821e-08,
                    4.0024e-08,
                    4.2112e-08,
                    4.4474e-08,
                    4.7111e-08,
                    5.0021e-08,
                    5.3205e-08,
                    5.6661e-08,
                    6.0391e-08,
                    6.4393e-08,
                    6.8668e-08,
                    7.3215e-08,
                    7.8215e-08,
                    8.3623e-08,
                    8.9433e-08,
                    9.5672e-08,
                    1.0239e-07,
                    1.0937e-07,
                    1.1666e-07,
                    1.2429e-07,
                    1.3223e-07,
                    1.4044e-07,
                    1.482e-07,
                    1.5588e-07,
                    1.6345e-07,
                    1.7035e-07,
                    1.7783e-07,
                    1.7898e-07,
                    1.8357e-07,
                    1.8782e-07,
                    1.9177e-07,
                    1.9555e-07,
                    1.9901e-07,
                    1.989e-07,
                    2.001e-07,
                    2.0294e-07,
                    2.0612e-07,
                    2.2202e-07,
                    2.3666e-07,
                    2.5073e-07,
                    2.6295e-07,
                    2.7373e-07,
                    2.8371e-07,
                    2.9258e-07,
                    3.0008e-07,
                    3.0659e-07,
                    3.1123e-07,
                    3.2111e-07,
                    3.2747e-07,
                    3.3399e-07,
                    3.4054e-07,
                    3.4724e-07,
                    3.5385e-07,
                    3.6429e-07,
                    3.794e-07,
                    3.9531e-07,
                    4.1321e-07,
                    4.2415e-07,
                    4.384e-07,
                    4.55e-07,
                    4.6582e-07,
                    4.7585e-07,
                    4.8271e-07,
                    4.8958e-07,
                    4.9745e-07,
                    5.0814e-07,
                    5.1984e-07,
                    5.3196e-07,
                    5.4432e-07,
                    5.5659e-07,
                    5.6888e-07,
                    5.8094e-07,
                    5.9301e-07,
                    6.0427e-07,
                    6.0967e-07,
                    6.1251e-07,
                    6.1228e-07,
                    6.0639e-07,
                    5.9755e-07,
                    5.8686e-07,
                    5.8176e-07,
                    5.7713e-07,
                    5.752e-07,
                    5.7193e-07
                ],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [
                    1.4798e-10,
                    2.9872e-10,
                    4.5209e-10,
                    6.0795e-10,
                    7.661e-10,
                    9.2632e-10,
                    1.0883e-09,
                    1.2518e-09,
                    1.4164e-09,
                    1.5816e-09,
                    1.7474e-09,
                    1.9135e-09,
                    2.0799e-09,
                    2.2467e-09,
                    2.4137e-09,
                    2.581e-09,
                    2.7487e-09,
                    2.9167e-09,
                    3.0851e-09,
                    3.254e-09,
                    3.4255e-09,
                    3.6033e-09,
                    3.7902e-09,
                    3.9883e-09,
                    4.1986e-09,
                    4.4214e-09,
                    4.6561e-09,
                    4.9013e-09,
                    5.1548e-09,
                    5.4132e-09,
                    5.6747e-09,
                    5.9387e-09,
                    6.2048e-09,
                    6.4728e-09,
                    6.7425e-09,
                    7.0138e-09,
                    7.2867e-09,
                    7.5613e-09,
                    7.8379e-09,
                    8.1422e-09,
                    8.4349e-09,
                    8.7175e-09,
                    8.9916e-09,
                    9.2585e-09,
                    9.5195e-09,
                    9.7761e-09,
                    1.0029e-08,
                    1.028e-08,
                    1.053e-08,
                    1.078e-08,
                    1.1033e-08,
                    1.129e-08,
                    1.1557e-08,
                    1.1833e-08,
                    1.2121e-08,
                    1.2421e-08,
                    1.2732e-08,
                    1.3054e-08,
                    1.3384e-08,
                    1.372e-08,
                    1.406e-08,
                    1.4404e-08,
                    1.4751e-08,
                    1.5101e-08,
                    1.5453e-08,
                    1.5808e-08,
                    1.6166e-08,
                    1.6526e-08,
                    1.689e-08,
                    1.7256e-08,
                    1.7627e-08,
                    1.8002e-08,
                    1.8383e-08,
                    1.8769e-08,
                    1.9161e-08,
                    1.9558e-08,
                    1.9959e-08,
                    2.0365e-08,
                    2.0772e-08,
                    2.1181e-08,
                    2.1591e-08,
                    2.2e-08,
                    2.2409e-08,
                    2.2818e-08,
                    2.3227e-08,
                    2.3636e-08,
                    2.4045e-08,
                    2.4454e-08,
                    2.4865e-08,
                    2.5276e-08,
                    2.5695e-08,
                    2.6131e-08,
                    2.6593e-08,
                    2.7085e-08,
                    2.7612e-08,
                    2.8174e-08,
                    2.877e-08,
                    2.9397e-08,
                    3.0049e-08,
                    3.0718e-08,
                    3.14e-08,
                    3.2095e-08,
                    3.2804e-08,
                    3.3527e-08,
                    3.4265e-08,
                    3.5018e-08,
                    3.5788e-08,
                    3.6574e-08,
                    3.7376e-08,
                    3.8196e-08,
                    3.9041e-08,
                    3.9892e-08,
                    4.0764e-08,
                    4.1619e-08,
                    4.2509e-08,
                    4.3174e-08,
                    4.3972e-08,
                    4.4765e-08,
                    4.5576e-08,
                    4.6405e-08,
                    4.7261e-08,
                    4.7987e-08,
                    4.8798e-08,
                    4.9747e-08,
                    5.0755e-08,
                    5.2507e-08,
                    5.4245e-08,
                    5.5956e-08,
                    5.759e-08,
                    5.9178e-08,
                    6.0889e-08,
                    6.2536e-08,
                    6.4105e-08,
                    6.555e-08,
                    6.697e-08,
                    6.8286e-08,
                    6.9628e-08,
                    7.102e-08,
                    7.2378e-08,
                    7.3779e-08,
                    7.5076e-08,
                    7.6583e-08,
                    7.8311e-08,
                    8.0192e-08,
                    8.217e-08,
                    8.4256e-08,
                    8.6429e-08,
                    8.8766e-08,
                    9.0807e-08,
                    9.2784e-08,
                    9.4561e-08,
                    9.6128e-08,
                    9.7641e-08,
                    9.9341e-08,
                    1.0132e-07,
                    1.0331e-07,
                    1.052e-07,
                    1.0716e-07,
                    1.0897e-07,
                    1.1088e-07,
                    1.1286e-07,
                    1.149e-07,
                    1.1692e-07,
                    1.1898e-07,
                    1.21e-07,
                    1.2307e-07,
                    1.25e-07,
                    1.269e-07,
                    1.2889e-07,
                    1.3073e-07,
                    1.3254e-07,
                    1.3426e-07
                ],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [
                    2.6441e-11,
                    5.32e-11,
                    8.0273e-11,
                    1.0765e-10,
                    1.3533e-10,
                    1.633e-10,
                    1.9154e-10,
                    2.2004e-10,
                    2.4879e-10,
                    2.7777e-10,
                    3.0697e-10,
                    3.3638e-10,
                    3.66e-10,
                    3.9583e-10,
                    4.2587e-10,
                    4.5613e-10,
                    4.8659e-10,
                    5.1726e-10,
                    5.4815e-10,
                    5.7926e-10,
                    6.1068e-10,
                    6.4258e-10,
                    6.7508e-10,
                    7.0826e-10,
                    7.4218e-10,
                    7.7685e-10,
                    8.1225e-10,
                    8.483e-10,
                    8.8491e-10,
                    9.2195e-10,
                    9.5931e-10,
                    9.9697e-10,
                    1.0349e-09,
                    1.0732e-09,
                    1.1117e-09,
                    1.1505e-09,
                    1.1895e-09,
                    1.2288e-09,
                    1.2684e-09,
                    1.3085e-09,
                    1.3488e-09,
                    1.3896e-09,
                    1.4306e-09,
                    1.472e-09,
                    1.5137e-09,
                    1.5559e-09,
                    1.5983e-09,
                    1.6412e-09,
                    1.6845e-09,
                    1.7282e-09,
                    1.7723e-09,
                    1.8168e-09,
                    1.8619e-09,
                    1.9076e-09,
                    1.9537e-09,
                    2.0004e-09,
                    2.0477e-09,
                    2.0955e-09,
                    2.1438e-09,
                    2.1927e-09,
                    2.242e-09,
                    2.2918e-09,
                    2.342e-09,
                    2.3928e-09,
                    2.444e-09,
                    2.4957e-09,
                    2.5479e-09,
                    2.6005e-09,
                    2.6535e-09,
                    2.707e-09,
                    2.761e-09,
                    2.8153e-09,
                    2.8701e-09,
                    2.9253e-09,
                    2.9808e-09,
                    3.0368e-09,
                    3.0932e-09,
                    3.15e-09,
                    3.2073e-09,
                    3.2649e-09,
                    3.323e-09,
                    3.3821e-09,
                    3.4422e-09,
                    3.5036e-09,
                    3.5665e-09,
                    3.6309e-09,
                    3.6969e-09,
                    3.7646e-09,
                    3.8339e-09,
                    3.9047e-09,
                    3.9775e-09,
                    4.0528e-09,
                    4.1313e-09,
                    4.2133e-09,
                    4.299e-09,
                    4.3885e-09,
                    4.4817e-09,
                    4.5782e-09,
                    4.6775e-09,
                    4.7792e-09,
                    4.8825e-09,
                    4.9875e-09,
                    5.0938e-09,
                    5.2014e-09,
                    5.3102e-09,
                    5.4203e-09,
                    5.5317e-09,
                    5.6446e-09,
                    5.7592e-09,
                    5.8757e-09,
                    5.9957e-09,
                    6.1216e-09,
                    6.2552e-09,
                    6.3977e-09,
                    6.5497e-09,
                    6.7113e-09,
                    6.8817e-09,
                    7.0599e-09,
                    7.2439e-09,
                    7.4586e-09,
                    7.6754e-09,
                    7.9098e-09,
                    8.155e-09,
                    8.4159e-09,
                    8.6859e-09,
                    8.9507e-09,
                    9.2621e-09,
                    9.5465e-09,
                    9.8414e-09,
                    1.015e-08,
                    1.0656e-08,
                    1.1172e-08,
                    1.1684e-08,
                    1.217e-08,
                    1.2718e-08,
                    1.3161e-08,
                    1.363e-08,
                    1.41e-08,
                    1.4535e-08,
                    1.499e-08,
                    1.5353e-08,
                    1.5852e-08,
                    1.635e-08,
                    1.6866e-08,
                    1.7394e-08,
                    1.7943e-08,
                    1.853e-08,
                    1.9158e-08,
                    1.9774e-08,
                    2.0398e-08,
                    2.1007e-08,
                    2.1406e-08,
                    2.1788e-08,
                    2.2333e-08,
                    2.3128e-08,
                    2.3919e-08,
                    2.4663e-08,
                    2.5414e-08,
                    2.6048e-08,
                    2.6812e-08,
                    2.7649e-08,
                    2.8523e-08,
                    2.9391e-08,
                    3.0295e-08,
                    3.1122e-08,
                    3.2001e-08,
                    3.2807e-08,
                    3.3588e-08,
                    3.4475e-08,
                    3.5258e-08,
                    3.6067e-08,
                    3.689e-08
                ],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": [
                    1.2154e-10,
                    2.4552e-10,
                    3.7181e-10,
                    5.0029e-10,
                    6.3077e-10,
                    7.6302e-10,
                    8.9678e-10,
                    1.0317e-09,
                    1.1676e-09,
                    1.3039e-09,
                    1.4404e-09,
                    1.5771e-09,
                    1.7139e-09,
                    1.8508e-09,
                    1.9878e-09,
                    2.1249e-09,
                    2.2621e-09,
                    2.3994e-09,
                    2.5369e-09,
                    2.6747e-09,
                    2.8148e-09,
                    2.9607e-09,
                    3.1151e-09,
                    3.28e-09,
                    3.4564e-09,
                    3.6445e-09,
                    3.8438e-09,
                    4.053e-09,
                    4.2698e-09,
                    4.4913e-09,
                    4.7154e-09,
                    4.9417e-09,
                    5.1698e-09,
                    5.3996e-09,
                    5.6308e-09,
                    5.8633e-09,
                    6.0972e-09,
                    6.3325e-09,
                    6.5694e-09,
                    6.8337e-09,
                    7.0861e-09,
                    7.328e-09,
                    7.561e-09,
                    7.7865e-09,
                    8.0058e-09,
                    8.2202e-09,
                    8.4309e-09,
                    8.6391e-09,
                    8.8459e-09,
                    9.0521e-09,
                    9.2602e-09,
                    9.4736e-09,
                    9.6949e-09,
                    9.9259e-09,
                    1.0168e-08,
                    1.0421e-08,
                    1.0685e-08,
                    1.0958e-08,
                    1.124e-08,
                    1.1527e-08,
                    1.1818e-08,
                    1.2112e-08,
                    1.2409e-08,
                    1.2708e-08,
                    1.3009e-08,
                    1.3312e-08,
                    1.3618e-08,
                    1.3926e-08,
                    1.4236e-08,
                    1.4549e-08,
                    1.4866e-08,
                    1.5187e-08,
                    1.5513e-08,
                    1.5844e-08,
                    1.618e-08,
                    1.6521e-08,
                    1.6866e-08,
                    1.7215e-08,
                    1.7565e-08,
                    1.7916e-08,
                    1.8268e-08,
                    1.8618e-08,
                    1.8967e-08,
                    1.9314e-08,
                    1.966e-08,
                    2.0005e-08,
                    2.0348e-08,
                    2.069e-08,
                    2.1031e-08,
                    2.1371e-08,
                    2.1717e-08,
                    2.2078e-08,
                    2.2461e-08,
                    2.2872e-08,
                    2.3313e-08,
                    2.3786e-08,
                    2.4289e-08,
                    2.4819e-08,
                    2.5372e-08,
                    2.5939e-08,
                    2.6517e-08,
                    2.7107e-08,
                    2.771e-08,
                    2.8325e-08,
                    2.8955e-08,
                    2.9598e-08,
                    3.0256e-08,
                    3.0929e-08,
                    3.1617e-08,
                    3.232e-08,
                    3.3045e-08,
                    3.3771e-08,
                    3.4508e-08,
                    3.5221e-08,
                    3.5959e-08,
                    3.6463e-08,
                    3.709e-08,
                    3.7705e-08,
                    3.8332e-08,
                    3.8947e-08,
                    3.9586e-08,
                    4.0078e-08,
                    4.0643e-08,
                    4.1332e-08,
                    4.2069e-08,
                    4.3557e-08,
                    4.4983e-08,
                    4.6409e-08,
                    4.7749e-08,
                    4.9028e-08,
                    5.0232e-08,
                    5.1363e-08,
                    5.2421e-08,
                    5.338e-08,
                    5.4253e-08,
                    5.5125e-08,
                    5.5998e-08,
                    5.692e-08,
                    5.7842e-08,
                    5.8789e-08,
                    5.9723e-08,
                    6.0731e-08,
                    6.1961e-08,
                    6.3325e-08,
                    6.4776e-08,
                    6.6313e-08,
                    6.7899e-08,
                    6.9608e-08,
                    7.1034e-08,
                    7.2386e-08,
                    7.3554e-08,
                    7.4722e-08,
                    7.5853e-08,
                    7.7009e-08,
                    7.8189e-08,
                    7.9394e-08,
                    8.0537e-08,
                    8.1742e-08,
                    8.2922e-08,
                    8.4065e-08,
                    8.5209e-08,
                    8.6377e-08,
                    8.7532e-08,
                    8.8688e-08,
                    8.988e-08,
                    9.1073e-08,
                    9.2192e-08,
                    9.331e-08,
                    9.4417e-08,
                    9.5474e-08,
                    9.647e-08,
                    9.7372e-08
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -159.83139,
                            -21.21986
                        ],
                        [
                            -159.7557,
                            -21.27301
                        ],
                        [
                            -159.75208,
                            -21.20397
                        ],
                        [
                            -159.83139,
                            -21.21986
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "CRI",
                "Country": "Costa Rica",
                "Total_3GHG": 0.07,
                "Total_3GHG_timeseries": [
                    9.16e-07,
                    1.8362e-06,
                    2.858e-06,
                    3.7616e-06,
                    4.7934e-06,
                    5.6961e-06,
                    6.6219e-06,
                    7.6509e-06,
                    8.6454e-06,
                    9.7843e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011
                ],
                "Fossil_3GHG": 0.02,
                "Fossil_3GHG_timeseries": [
                    2.3531e-08,
                    4.7169e-08,
                    7.0917e-08,
                    9.4782e-08,
                    1.1877e-07,
                    1.4288e-07,
                    1.6712e-07,
                    1.9149e-07,
                    2.1601e-07,
                    2.4066e-07,
                    2.6587e-07,
                    2.9164e-07,
                    3.1798e-07,
                    3.4488e-07,
                    3.7272e-07,
                    4.0149e-07,
                    4.3124e-07,
                    4.6196e-07,
                    4.9369e-07,
                    5.2645e-07,
                    5.6056e-07,
                    5.9606e-07,
                    6.3299e-07,
                    6.7137e-07,
                    7.1122e-07,
                    7.5256e-07,
                    7.9539e-07,
                    8.3973e-07,
                    8.8558e-07,
                    9.3293e-07,
                    9.8141e-07,
                    1.031e-06,
                    1.0818e-06,
                    1.1353e-06,
                    1.1912e-06,
                    1.2482e-06,
                    1.3064e-06,
                    1.3657e-06,
                    1.4271e-06,
                    1.4912e-06,
                    1.5581e-06,
                    1.6279e-06,
                    1.6997e-06,
                    1.7734e-06,
                    1.8491e-06,
                    1.9264e-06,
                    2.0052e-06,
                    2.0858e-06,
                    2.1672e-06,
                    2.2485e-06,
                    2.3338e-06,
                    2.4223e-06,
                    2.5111e-06,
                    2.6016e-06,
                    2.6939e-06,
                    2.7861e-06,
                    2.8813e-06,
                    2.9765e-06,
                    3.0735e-06,
                    3.1702e-06,
                    3.2659e-06,
                    3.3608e-06,
                    3.4557e-06,
                    3.555e-06,
                    3.6535e-06,
                    3.7544e-06,
                    3.855e-06,
                    3.9578e-06,
                    4.064e-06,
                    4.1713e-06,
                    4.2776e-06,
                    4.3806e-06,
                    4.4863e-06,
                    4.5918e-06,
                    4.6972e-06,
                    4.8051e-06,
                    4.9097e-06,
                    5.017e-06,
                    5.124e-06,
                    5.2328e-06,
                    5.346e-06,
                    5.4636e-06,
                    5.5857e-06,
                    5.7081e-06,
                    5.8358e-06,
                    5.9662e-06,
                    6.1054e-06,
                    6.2474e-06,
                    6.3954e-06,
                    6.5491e-06,
                    6.7118e-06,
                    6.89e-06,
                    7.0776e-06,
                    7.278e-06,
                    7.4936e-06,
                    7.7223e-06,
                    7.9706e-06,
                    8.2362e-06,
                    8.5195e-06,
                    8.9752e-06,
                    9.4588e-06,
                    9.996e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_3GHG": 0.16,
                "Land_3GHG_timeseries": [
                    8.9247e-07,
                    1.789e-06,
                    2.7871e-06,
                    3.6668e-06,
                    4.6746e-06,
                    5.5532e-06,
                    6.4548e-06,
                    7.4594e-06,
                    8.4294e-06,
                    9.5437e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009
                ],
                "Total_CO2": 0.08,
                "Total_CO2_timeseries": [
                    7.9254e-07,
                    1.5886e-06,
                    2.4857e-06,
                    3.2639e-06,
                    4.1697e-06,
                    4.9457e-06,
                    5.7443e-06,
                    6.6453e-06,
                    7.5113e-06,
                    8.521e-06,
                    9.7562e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009
                ],
                "Fossil_CO2": 0.02,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.287e-07,
                    2.6895e-07,
                    4.4385e-07,
                    6.3855e-07,
                    8.217e-07,
                    9.7845e-07,
                    1.1962e-06,
                    1.4041e-06,
                    1.6055e-06,
                    1.7787e-06,
                    1.9998e-06,
                    2.2209e-06,
                    2.4684e-06,
                    2.739e-06,
                    3.0425e-06,
                    3.4235e-06,
                    3.8704e-06,
                    4.2646e-06,
                    4.7313e-06,
                    5.2474e-06,
                    5.8097e-06,
                    6.4974e-06,
                    7.2906e-06,
                    8.2108e-06,
                    9.0682e-06,
                    9.985e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CO2": 0.21,
                "Land_CO2_timeseries": [
                    7.9254e-07,
                    1.5886e-06,
                    2.4857e-06,
                    3.2639e-06,
                    4.1697e-06,
                    4.9457e-06,
                    5.7443e-06,
                    6.6453e-06,
                    7.5113e-06,
                    8.521e-06,
                    9.7562e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Total_CH4": 0.05,
                "Total_CH4_timeseries": [
                    1.1487e-07,
                    2.3026e-07,
                    3.4616e-07,
                    4.6258e-07,
                    5.7954e-07,
                    6.9703e-07,
                    8.1506e-07,
                    9.3364e-07,
                    1.0528e-06,
                    1.1725e-06,
                    1.2976e-06,
                    1.4282e-06,
                    1.5642e-06,
                    1.7057e-06,
                    1.853e-06,
                    2.0062e-06,
                    2.1652e-06,
                    2.3301e-06,
                    2.5008e-06,
                    2.6775e-06,
                    2.8634e-06,
                    3.0585e-06,
                    3.2629e-06,
                    3.4765e-06,
                    3.6994e-06,
                    3.9315e-06,
                    4.173e-06,
                    4.4237e-06,
                    4.6838e-06,
                    4.9533e-06,
                    5.2274e-06,
                    5.5062e-06,
                    5.7898e-06,
                    6.0795e-06,
                    6.3753e-06,
                    6.6758e-06,
                    6.981e-06,
                    7.2908e-06,
                    7.6064e-06,
                    7.928e-06,
                    8.2601e-06,
                    8.6027e-06,
                    8.9548e-06,
                    9.3165e-06,
                    9.6877e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_CH4": 0.04,
                "Fossil_CH4_timeseries": [
                    1.8138e-08,
                    3.6322e-08,
                    5.4556e-08,
                    7.2847e-08,
                    9.12e-08,
                    1.0962e-07,
                    1.2812e-07,
                    1.467e-07,
                    1.6536e-07,
                    1.8412e-07,
                    2.0338e-07,
                    2.2316e-07,
                    2.4346e-07,
                    2.6428e-07,
                    2.8598e-07,
                    3.0858e-07,
                    3.3209e-07,
                    3.5655e-07,
                    3.8196e-07,
                    4.0835e-07,
                    4.3603e-07,
                    4.6503e-07,
                    4.9535e-07,
                    5.2701e-07,
                    5.6003e-07,
                    5.9441e-07,
                    6.3018e-07,
                    6.6735e-07,
                    7.0593e-07,
                    7.4595e-07,
                    7.8703e-07,
                    8.2918e-07,
                    8.7244e-07,
                    9.1831e-07,
                    9.6662e-07,
                    1.016e-06,
                    1.0664e-06,
                    1.1179e-06,
                    1.1715e-06,
                    1.2276e-06,
                    1.2865e-06,
                    1.3481e-06,
                    1.4117e-06,
                    1.4772e-06,
                    1.5446e-06,
                    1.6135e-06,
                    1.6837e-06,
                    1.7558e-06,
                    1.8285e-06,
                    1.901e-06,
                    1.9774e-06,
                    2.057e-06,
                    2.1367e-06,
                    2.2181e-06,
                    2.301e-06,
                    2.3839e-06,
                    2.4695e-06,
                    2.5551e-06,
                    2.6424e-06,
                    2.7292e-06,
                    2.815e-06,
                    2.8999e-06,
                    2.9846e-06,
                    3.0737e-06,
                    3.1618e-06,
                    3.2522e-06,
                    3.3423e-06,
                    3.4345e-06,
                    3.5299e-06,
                    3.6263e-06,
                    3.7216e-06,
                    3.8136e-06,
                    3.9081e-06,
                    4.0024e-06,
                    4.0964e-06,
                    4.1928e-06,
                    4.2859e-06,
                    4.3814e-06,
                    4.4767e-06,
                    4.5736e-06,
                    4.6748e-06,
                    4.7803e-06,
                    4.8901e-06,
                    5e-06,
                    5.115e-06,
                    5.2325e-06,
                    5.3586e-06,
                    5.4874e-06,
                    5.6219e-06,
                    5.7618e-06,
                    5.9106e-06,
                    6.0745e-06,
                    6.2474e-06,
                    6.4329e-06,
                    6.6331e-06,
                    6.8459e-06,
                    7.0779e-06,
                    7.3266e-06,
                    7.5927e-06,
                    7.9021e-06,
                    8.2272e-06,
                    8.5703e-06,
                    8.932e-06,
                    9.313e-06,
                    9.7141e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CH4": 0.08,
                "Land_CH4_timeseries": [
                    9.6734e-08,
                    1.9393e-07,
                    2.916e-07,
                    3.8974e-07,
                    4.8834e-07,
                    5.8741e-07,
                    6.8694e-07,
                    7.8695e-07,
                    8.8742e-07,
                    9.8835e-07,
                    1.0942e-06,
                    1.205e-06,
                    1.3208e-06,
                    1.4415e-06,
                    1.5671e-06,
                    1.6976e-06,
                    1.8331e-06,
                    1.9735e-06,
                    2.1189e-06,
                    2.2692e-06,
                    2.4274e-06,
                    2.5935e-06,
                    2.7675e-06,
                    2.9495e-06,
                    3.1393e-06,
                    3.3371e-06,
                    3.5428e-06,
                    3.7564e-06,
                    3.9779e-06,
                    4.2073e-06,
                    4.4404e-06,
                    4.677e-06,
                    4.9173e-06,
                    5.1612e-06,
                    5.4087e-06,
                    5.6598e-06,
                    5.9146e-06,
                    6.1729e-06,
                    6.4349e-06,
                    6.7004e-06,
                    6.9737e-06,
                    7.2545e-06,
                    7.5431e-06,
                    7.8393e-06,
                    8.1432e-06,
                    8.4547e-06,
                    8.7739e-06,
                    9.1007e-06,
                    9.4352e-06,
                    9.7774e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_N2O": 0.05,
                "Total_N2O_timeseries": [
                    8.5884e-09,
                    1.7302e-08,
                    2.6136e-08,
                    3.5087e-08,
                    4.415e-08,
                    5.3315e-08,
                    6.2575e-08,
                    7.1921e-08,
                    8.134e-08,
                    9.0821e-08,
                    1.0036e-07,
                    1.0994e-07,
                    1.1958e-07,
                    1.2926e-07,
                    1.39e-07,
                    1.4878e-07,
                    1.5861e-07,
                    1.6849e-07,
                    1.7843e-07,
                    1.8842e-07,
                    1.9853e-07,
                    2.0887e-07,
                    2.1954e-07,
                    2.3059e-07,
                    2.4206e-07,
                    2.5396e-07,
                    2.6626e-07,
                    2.7893e-07,
                    2.919e-07,
                    3.0506e-07,
                    3.1835e-07,
                    3.3176e-07,
                    3.4528e-07,
                    3.5889e-07,
                    3.726e-07,
                    3.8639e-07,
                    4.0028e-07,
                    4.1425e-07,
                    4.2833e-07,
                    4.4569e-07,
                    4.6326e-07,
                    4.8118e-07,
                    4.9959e-07,
                    5.1863e-07,
                    5.3838e-07,
                    5.5895e-07,
                    5.8041e-07,
                    6.0282e-07,
                    6.2624e-07,
                    6.5068e-07,
                    6.7654e-07,
                    7.0442e-07,
                    7.3479e-07,
                    7.6794e-07,
                    8.0398e-07,
                    8.4288e-07,
                    8.8444e-07,
                    9.2827e-07,
                    9.7384e-07,
                    1.0204e-06,
                    1.0677e-06,
                    1.1155e-06,
                    1.1638e-06,
                    1.2127e-06,
                    1.262e-06,
                    1.3117e-06,
                    1.3618e-06,
                    1.4122e-06,
                    1.4629e-06,
                    1.5137e-06,
                    1.5646e-06,
                    1.6153e-06,
                    1.6658e-06,
                    1.7158e-06,
                    1.7654e-06,
                    1.8145e-06,
                    1.8632e-06,
                    1.9116e-06,
                    1.9598e-06,
                    2.008e-06,
                    2.0566e-06,
                    2.106e-06,
                    2.1565e-06,
                    2.2083e-06,
                    2.2617e-06,
                    2.3169e-06,
                    2.3739e-06,
                    2.4327e-06,
                    2.4933e-06,
                    2.5556e-06,
                    2.6213e-06,
                    2.6934e-06,
                    2.7745e-06,
                    2.8662e-06,
                    2.9695e-06,
                    3.0846e-06,
                    3.2112e-06,
                    3.3481e-06,
                    3.4935e-06,
                    3.6448e-06,
                    3.8022e-06,
                    3.9683e-06,
                    4.1454e-06,
                    4.3348e-06,
                    4.5376e-06,
                    4.7539e-06,
                    4.9834e-06,
                    5.2252e-06,
                    5.4777e-06,
                    5.7387e-06,
                    6.0057e-06,
                    6.2924e-06,
                    6.6249e-06,
                    6.9811e-06,
                    7.3179e-06,
                    7.6905e-06,
                    8.07e-06,
                    8.4927e-06,
                    8.9605e-06,
                    9.4367e-06,
                    9.9041e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_N2O": 0.03,
                "Fossil_N2O_timeseries": [
                    5.3931e-09,
                    1.0847e-08,
                    1.6361e-08,
                    2.1935e-08,
                    2.7567e-08,
                    3.3256e-08,
                    3.8999e-08,
                    4.4797e-08,
                    5.0646e-08,
                    5.6543e-08,
                    6.2488e-08,
                    6.848e-08,
                    7.4519e-08,
                    8.0605e-08,
                    8.6737e-08,
                    9.2916e-08,
                    9.9141e-08,
                    1.0541e-07,
                    1.1173e-07,
                    1.181e-07,
                    1.2453e-07,
                    1.3104e-07,
                    1.3764e-07,
                    1.4436e-07,
                    1.5119e-07,
                    1.5814e-07,
                    1.6521e-07,
                    1.7238e-07,
                    1.7965e-07,
                    1.8698e-07,
                    1.9438e-07,
                    2.0185e-07,
                    2.0936e-07,
                    2.1694e-07,
                    2.2456e-07,
                    2.3225e-07,
                    2.3998e-07,
                    2.4778e-07,
                    2.5562e-07,
                    2.6359e-07,
                    2.7162e-07,
                    2.7973e-07,
                    2.8791e-07,
                    2.9618e-07,
                    3.0452e-07,
                    3.1294e-07,
                    3.2145e-07,
                    3.3004e-07,
                    3.3872e-07,
                    3.4748e-07,
                    3.5634e-07,
                    3.653e-07,
                    3.7437e-07,
                    3.8354e-07,
                    3.9283e-07,
                    4.0223e-07,
                    4.1175e-07,
                    4.2137e-07,
                    4.3111e-07,
                    4.4095e-07,
                    4.509e-07,
                    4.6095e-07,
                    4.711e-07,
                    4.8135e-07,
                    4.9171e-07,
                    5.0216e-07,
                    5.1272e-07,
                    5.2337e-07,
                    5.3413e-07,
                    5.4499e-07,
                    5.5595e-07,
                    5.6701e-07,
                    5.7817e-07,
                    5.8944e-07,
                    6.0081e-07,
                    6.1228e-07,
                    6.2385e-07,
                    6.3553e-07,
                    6.4731e-07,
                    6.5919e-07,
                    6.712e-07,
                    6.8334e-07,
                    6.9564e-07,
                    7.0812e-07,
                    7.208e-07,
                    7.3367e-07,
                    7.4675e-07,
                    7.6004e-07,
                    7.7355e-07,
                    7.8727e-07,
                    8.0124e-07,
                    8.155e-07,
                    8.3012e-07,
                    8.4512e-07,
                    8.6055e-07,
                    8.7642e-07,
                    8.9275e-07,
                    9.0953e-07,
                    9.2676e-07,
                    9.4444e-07,
                    9.6271e-07,
                    9.8188e-07,
                    1.0022e-06,
                    1.0239e-06,
                    1.0471e-06,
                    1.0719e-06,
                    1.0985e-06,
                    1.1267e-06,
                    1.1566e-06,
                    1.1881e-06,
                    1.221e-06,
                    1.2555e-06,
                    1.2914e-06,
                    1.329e-06,
                    1.3681e-06,
                    1.4089e-06,
                    1.4516e-06,
                    1.4962e-06,
                    1.543e-06,
                    1.5908e-06,
                    1.6407e-06,
                    1.6953e-06,
                    1.7499e-06,
                    1.8141e-06,
                    1.8832e-06,
                    1.953e-06,
                    2.027e-06,
                    2.107e-06,
                    2.1898e-06,
                    2.2698e-06,
                    2.3467e-06,
                    2.4196e-06,
                    2.4901e-06,
                    2.5656e-06,
                    2.6403e-06,
                    2.7144e-06,
                    2.7703e-06,
                    2.8393e-06,
                    2.921e-06,
                    3.0172e-06,
                    3.1191e-06,
                    3.2579e-06,
                    3.4092e-06,
                    3.5677e-06,
                    3.7118e-06,
                    3.8857e-06,
                    4.1033e-06,
                    4.2974e-06,
                    4.4851e-06,
                    4.5949e-06,
                    4.6846e-06,
                    4.7731e-06,
                    4.8641e-06,
                    4.9584e-06,
                    5.0556e-06,
                    5.1612e-06,
                    5.2724e-06,
                    5.3799e-06,
                    5.4862e-06,
                    5.5949e-06,
                    5.7028e-06,
                    5.8115e-06,
                    5.9255e-06,
                    6.0404e-06,
                    6.1523e-06,
                    6.2709e-06,
                    6.39e-06,
                    6.5058e-06,
                    6.6228e-06,
                    6.7359e-06,
                    6.8576e-06,
                    6.9867e-06
                ],
                "Land_N2O": 0.06,
                "Land_N2O_timeseries": [
                    3.1953e-09,
                    6.4545e-09,
                    9.7748e-09,
                    1.3153e-08,
                    1.6583e-08,
                    2.006e-08,
                    2.3576e-08,
                    2.7124e-08,
                    3.0695e-08,
                    3.4278e-08,
                    3.7867e-08,
                    4.1461e-08,
                    4.5058e-08,
                    4.8658e-08,
                    5.2259e-08,
                    5.5863e-08,
                    5.947e-08,
                    6.308e-08,
                    6.6695e-08,
                    7.0317e-08,
                    7.3999e-08,
                    7.7835e-08,
                    8.1895e-08,
                    8.623e-08,
                    9.0867e-08,
                    9.5813e-08,
                    1.0105e-07,
                    1.0655e-07,
                    1.1225e-07,
                    1.1807e-07,
                    1.2397e-07,
                    1.2991e-07,
                    1.3591e-07,
                    1.4195e-07,
                    1.4803e-07,
                    1.5414e-07,
                    1.6029e-07,
                    1.6648e-07,
                    1.7271e-07,
                    1.8211e-07,
                    1.9164e-07,
                    2.0145e-07,
                    2.1168e-07,
                    2.2245e-07,
                    2.3386e-07,
                    2.4601e-07,
                    2.5896e-07,
                    2.7279e-07,
                    2.8752e-07,
                    3.032e-07,
                    3.2019e-07,
                    3.3912e-07,
                    3.6042e-07,
                    3.8439e-07,
                    4.1115e-07,
                    4.4065e-07,
                    4.7269e-07,
                    5.069e-07,
                    5.4273e-07,
                    5.795e-07,
                    6.1677e-07,
                    6.5452e-07,
                    6.9271e-07,
                    7.3131e-07,
                    7.7027e-07,
                    8.0954e-07,
                    8.4908e-07,
                    8.8884e-07,
                    9.2874e-07,
                    9.6873e-07,
                    1.0087e-06,
                    1.0483e-06,
                    1.0876e-06,
                    1.1264e-06,
                    1.1646e-06,
                    1.2022e-06,
                    1.2393e-06,
                    1.276e-06,
                    1.3125e-06,
                    1.3488e-06,
                    1.3854e-06,
                    1.4227e-06,
                    1.4608e-06,
                    1.5002e-06,
                    1.5409e-06,
                    1.5832e-06,
                    1.6271e-06,
                    1.6726e-06,
                    1.7197e-06,
                    1.7683e-06,
                    1.82e-06,
                    1.8779e-06,
                    1.9444e-06,
                    2.0211e-06,
                    2.1089e-06,
                    2.2082e-06,
                    2.3184e-06,
                    2.4386e-06,
                    2.5667e-06,
                    2.7004e-06,
                    2.8395e-06,
                    2.9865e-06,
                    3.1432e-06,
                    3.3109e-06,
                    3.4905e-06,
                    3.6819e-06,
                    3.885e-06,
                    4.0985e-06,
                    4.3211e-06,
                    4.5507e-06,
                    4.7847e-06,
                    5.0369e-06,
                    5.3335e-06,
                    5.6521e-06,
                    5.9498e-06,
                    6.2816e-06,
                    6.6184e-06,
                    6.9964e-06,
                    7.4175e-06,
                    7.8459e-06,
                    8.2634e-06,
                    8.6966e-06,
                    9.1708e-06,
                    9.6425e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -83.69285,
                            10.9389
                        ],
                        [
                            -83.67195,
                            10.88015
                        ],
                        [
                            -83.67767,
                            10.79499
                        ],
                        [
                            -83.79333,
                            10.76666
                        ],
                        [
                            -83.86712,
                            10.71933
                        ],
                        [
                            -83.9298,
                            10.70823
                        ],
                        [
                            -84.03463,
                            10.78702
                        ],
                        [
                            -84.07212,
                            10.76386
                        ],
                        [
                            -84.136,
                            10.78771
                        ],
                        [
                            -84.20274,
                            10.78156
                        ],
                        [
                            -84.23874,
                            10.81389
                        ],
                        [
                            -84.2241,
                            10.86477
                        ],
                        [
                            -84.32884,
                            10.91606
                        ],
                        [
                            -84.35935,
                            10.99208
                        ],
                        [
                            -84.41928,
                            10.95793
                        ],
                        [
                            -84.48898,
                            11.001
                        ],
                        [
                            -84.60873,
                            11.03924
                        ],
                        [
                            -84.6803,
                            11.07885
                        ],
                        [
                            -84.91425,
                            10.94139
                        ],
                        [
                            -85.20742,
                            11.05012
                        ],
                        [
                            -85.35611,
                            11.12346
                        ],
                        [
                            -85.41627,
                            11.12478
                        ],
                        [
                            -85.5196,
                            11.16228
                        ],
                        [
                            -85.55876,
                            11.20817
                        ],
                        [
                            -85.60969,
                            11.2168
                        ],
                        [
                            -85.69482,
                            11.08033
                        ],
                        [
                            -85.6756,
                            11.03639
                        ],
                        [
                            -85.73032,
                            10.9349
                        ],
                        [
                            -85.87087,
                            10.94696
                        ],
                        [
                            -85.9234,
                            10.89956
                        ],
                        [
                            -85.8467,
                            10.85579
                        ],
                        [
                            -85.78906,
                            10.85271
                        ],
                        [
                            -85.76489,
                            10.80777
                        ],
                        [
                            -85.6845,
                            10.8001
                        ],
                        [
                            -85.66093,
                            10.76447
                        ],
                        [
                            -85.63292,
                            10.62012
                        ],
                        [
                            -85.70041,
                            10.55503
                        ],
                        [
                            -85.80027,
                            10.51556
                        ],
                        [
                            -85.77678,
                            10.46451
                        ],
                        [
                            -85.80113,
                            10.40864
                        ],
                        [
                            -85.8698,
                            10.3546
                        ],
                        [
                            -85.84295,
                            10.32017
                        ],
                        [
                            -85.84917,
                            10.25203
                        ],
                        [
                            -85.78834,
                            10.09896
                        ],
                        [
                            -85.68182,
                            9.97088
                        ],
                        [
                            -85.66253,
                            9.9077
                        ],
                        [
                            -85.34412,
                            9.83409
                        ],
                        [
                            -85.2922,
                            9.80657
                        ],
                        [
                            -85.2292,
                            9.73441
                        ],
                        [
                            -85.13793,
                            9.58173
                        ],
                        [
                            -85.09317,
                            9.57765
                        ],
                        [
                            -85.07381,
                            9.63781
                        ],
                        [
                            -84.99413,
                            9.74431
                        ],
                        [
                            -84.95785,
                            9.73328
                        ],
                        [
                            -84.90646,
                            9.8121
                        ],
                        [
                            -84.9292,
                            9.92535
                        ],
                        [
                            -85.10655,
                            9.97856
                        ],
                        [
                            -85.17395,
                            10.03153
                        ],
                        [
                            -85.23535,
                            10.10756
                        ],
                        [
                            -85.2125,
                            10.18484
                        ],
                        [
                            -85.09393,
                            10.16949
                        ],
                        [
                            -84.95758,
                            10.06429
                        ],
                        [
                            -84.8379,
                            9.99054
                        ],
                        [
                            -84.7447,
                            9.96562
                        ],
                        [
                            -84.72371,
                            9.89169
                        ],
                        [
                            -84.65351,
                            9.8072
                        ],
                        [
                            -84.63628,
                            9.74085
                        ],
                        [
                            -84.67357,
                            9.65803
                        ],
                        [
                            -84.61104,
                            9.57845
                        ],
                        [
                            -84.5342,
                            9.52331
                        ],
                        [
                            -84.4662,
                            9.52589
                        ],
                        [
                            -84.20529,
                            9.46154
                        ],
                        [
                            -84.168,
                            9.39656
                        ],
                        [
                            -83.96417,
                            9.3192
                        ],
                        [
                            -83.78257,
                            9.19355
                        ],
                        [
                            -83.64912,
                            9.0597
                        ],
                        [
                            -83.62067,
                            8.92579
                        ],
                        [
                            -83.5777,
                            8.84897
                        ],
                        [
                            -83.64088,
                            8.80176
                        ],
                        [
                            -83.65444,
                            8.70448
                        ],
                        [
                            -83.70882,
                            8.68077
                        ],
                        [
                            -83.72523,
                            8.5906
                        ],
                        [
                            -83.55786,
                            8.44297
                        ],
                        [
                            -83.44266,
                            8.43571
                        ],
                        [
                            -83.29931,
                            8.38051
                        ],
                        [
                            -83.27613,
                            8.46857
                        ],
                        [
                            -83.32737,
                            8.56612
                        ],
                        [
                            -83.42079,
                            8.61564
                        ],
                        [
                            -83.47951,
                            8.70292
                        ],
                        [
                            -83.3779,
                            8.74201
                        ],
                        [
                            -83.32503,
                            8.6829
                        ],
                        [
                            -83.23736,
                            8.63502
                        ],
                        [
                            -83.17061,
                            8.63655
                        ],
                        [
                            -83.12594,
                            8.60029
                        ],
                        [
                            -83.1339,
                            8.51509
                        ],
                        [
                            -83.09738,
                            8.45215
                        ],
                        [
                            -83.14172,
                            8.36862
                        ],
                        [
                            -82.99526,
                            8.2604
                        ],
                        [
                            -82.9054,
                            8.11469
                        ],
                        [
                            -82.90039,
                            8.03978
                        ],
                        [
                            -82.8869,
                            8.10703
                        ],
                        [
                            -82.93529,
                            8.20969
                        ],
                        [
                            -82.9415,
                            8.26878
                        ],
                        [
                            -83.04501,
                            8.31904
                        ],
                        [
                            -82.9305,
                            8.43411
                        ],
                        [
                            -82.86797,
                            8.44028
                        ],
                        [
                            -82.83183,
                            8.50319
                        ],
                        [
                            -82.83033,
                            8.63281
                        ],
                        [
                            -82.91704,
                            8.74372
                        ],
                        [
                            -82.86653,
                            8.80467
                        ],
                        [
                            -82.85467,
                            8.85542
                        ],
                        [
                            -82.78052,
                            8.87598
                        ],
                        [
                            -82.71292,
                            8.92344
                        ],
                        [
                            -82.75017,
                            8.99013
                        ],
                        [
                            -82.80051,
                            9.00447
                        ],
                        [
                            -82.93598,
                            9.08434
                        ],
                        [
                            -82.93559,
                            9.47303
                        ],
                        [
                            -82.84233,
                            9.49731
                        ],
                        [
                            -82.8834,
                            9.5654
                        ],
                        [
                            -82.85464,
                            9.61913
                        ],
                        [
                            -82.76473,
                            9.58925
                        ],
                        [
                            -82.69506,
                            9.54345
                        ],
                        [
                            -82.68516,
                            9.50792
                        ],
                        [
                            -82.60407,
                            9.50928
                        ],
                        [
                            -82.56464,
                            9.57195
                        ],
                        [
                            -82.61873,
                            9.61441
                        ],
                        [
                            -82.77807,
                            9.66253
                        ],
                        [
                            -82.85183,
                            9.74334
                        ],
                        [
                            -83.02406,
                            9.96283
                        ],
                        [
                            -83.02614,
                            10.0012
                        ],
                        [
                            -83.10355,
                            10.00698
                        ],
                        [
                            -83.3994,
                            10.36893
                        ],
                        [
                            -83.52314,
                            10.58779
                        ],
                        [
                            -83.58735,
                            10.79989
                        ],
                        [
                            -83.63856,
                            10.90714
                        ],
                        [
                            -83.69285,
                            10.9389
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "HRV",
                "Country": "Croatia",
                "Total_3GHG": 0.06,
                "Total_3GHG_timeseries": [
                    1.2305e-06,
                    2.4927e-06,
                    3.7456e-06,
                    4.9454e-06,
                    6.1503e-06,
                    7.3627e-06,
                    8.5937e-06,
                    9.7991e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001
                ],
                "Fossil_3GHG": 0.07,
                "Fossil_3GHG_timeseries": [
                    7.4778e-08,
                    1.501e-07,
                    2.2598e-07,
                    3.0239e-07,
                    3.7934e-07,
                    4.5683e-07,
                    5.3485e-07,
                    6.1339e-07,
                    6.9246e-07,
                    7.7203e-07,
                    8.5349e-07,
                    9.3683e-07,
                    1.022e-06,
                    1.1091e-06,
                    1.1981e-06,
                    1.289e-06,
                    1.3817e-06,
                    1.4763e-06,
                    1.5727e-06,
                    1.6711e-06,
                    1.7715e-06,
                    1.8742e-06,
                    1.9791e-06,
                    2.0862e-06,
                    2.1956e-06,
                    2.3073e-06,
                    2.4213e-06,
                    2.5375e-06,
                    2.6559e-06,
                    2.7765e-06,
                    2.8981e-06,
                    3.0209e-06,
                    3.1446e-06,
                    3.2695e-06,
                    3.3979e-06,
                    3.5248e-06,
                    3.6529e-06,
                    3.7819e-06,
                    3.912e-06,
                    4.0508e-06,
                    4.1919e-06,
                    4.3351e-06,
                    4.4869e-06,
                    4.6553e-06,
                    4.8249e-06,
                    4.9994e-06,
                    5.167e-06,
                    5.3503e-06,
                    5.5419e-06,
                    5.7523e-06,
                    5.9649e-06,
                    6.1689e-06,
                    6.3745e-06,
                    6.5809e-06,
                    6.7896e-06,
                    7.0111e-06,
                    7.23e-06,
                    7.4524e-06,
                    7.6731e-06,
                    7.8871e-06,
                    8.107e-06,
                    8.3263e-06,
                    8.7654e-06,
                    8.8462e-06,
                    8.9229e-06,
                    8.995e-06,
                    9.0636e-06,
                    9.1263e-06,
                    9.4367e-06,
                    9.8233e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Land_3GHG": 0.05,
                "Land_3GHG_timeseries": [
                    1.1557e-06,
                    2.3426e-06,
                    3.5196e-06,
                    4.643e-06,
                    5.7709e-06,
                    6.9059e-06,
                    8.0588e-06,
                    9.1857e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Total_CO2": 0.06,
                "Total_CO2_timeseries": [
                    8.8443e-07,
                    1.798e-06,
                    2.6997e-06,
                    3.5457e-06,
                    4.3943e-06,
                    5.2481e-06,
                    6.118e-06,
                    6.9601e-06,
                    7.7409e-06,
                    8.6804e-06,
                    9.6067e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Fossil_CO2": 0.07,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2.2107e-09,
                    2.2107e-09,
                    2.2107e-09,
                    2.2107e-09,
                    2.2107e-09,
                    8.8422e-09,
                    1.6579e-08,
                    2.5145e-08,
                    4.0343e-08,
                    6.9357e-08,
                    9.837e-08,
                    1.307e-07,
                    1.5585e-07,
                    1.9398e-07,
                    2.3847e-07,
                    2.987e-07,
                    3.6447e-07,
                    4.2609e-07,
                    4.9296e-07,
                    5.6425e-07,
                    6.4162e-07,
                    7.3419e-07,
                    8.2841e-07,
                    9.2982e-07,
                    1.034e-06,
                    1.1371e-06,
                    1.2487e-06,
                    1.3631e-06,
                    1.6773e-06,
                    1.6773e-06,
                    1.6773e-06,
                    1.6773e-06,
                    1.6773e-06,
                    1.6773e-06,
                    1.9025e-06,
                    2.2015e-06,
                    2.5198e-06,
                    2.9823e-06,
                    3.4869e-06,
                    4.0042e-06,
                    4.572e-06,
                    5.1249e-06,
                    5.7497e-06,
                    6.4499e-06,
                    7.2238e-06,
                    7.9522e-06,
                    8.6153e-06,
                    9.2214e-06,
                    9.7818e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Land_CO2": 0.04,
                "Land_CO2_timeseries": [
                    8.8443e-07,
                    1.798e-06,
                    2.6997e-06,
                    3.5457e-06,
                    4.3943e-06,
                    5.2481e-06,
                    6.118e-06,
                    6.9601e-06,
                    7.7409e-06,
                    8.6804e-06,
                    9.6067e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Total_CH4": 0.05,
                "Total_CH4_timeseries": [
                    2.861e-07,
                    5.7389e-07,
                    8.6335e-07,
                    1.1545e-06,
                    1.4473e-06,
                    1.7419e-06,
                    2.0381e-06,
                    2.3359e-06,
                    2.6355e-06,
                    2.9367e-06,
                    3.2484e-06,
                    3.5704e-06,
                    3.9029e-06,
                    4.2457e-06,
                    4.5989e-06,
                    4.9625e-06,
                    5.3365e-06,
                    5.721e-06,
                    6.1157e-06,
                    6.5209e-06,
                    6.938e-06,
                    7.3671e-06,
                    7.808e-06,
                    8.2609e-06,
                    8.7258e-06,
                    9.2025e-06,
                    9.6912e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_CH4": 0.05,
                "Fossil_CH4_timeseries": [
                    4.4735e-08,
                    8.9701e-08,
                    1.349e-07,
                    1.8032e-07,
                    2.2597e-07,
                    2.7185e-07,
                    3.1796e-07,
                    3.643e-07,
                    4.1086e-07,
                    4.5765e-07,
                    5.0604e-07,
                    5.5603e-07,
                    6.0763e-07,
                    6.6082e-07,
                    7.1561e-07,
                    7.7199e-07,
                    8.2996e-07,
                    8.8953e-07,
                    9.5069e-07,
                    1.0134e-06,
                    1.078e-06,
                    1.1444e-06,
                    1.2126e-06,
                    1.2826e-06,
                    1.3544e-06,
                    1.428e-06,
                    1.5034e-06,
                    1.5807e-06,
                    1.6597e-06,
                    1.7405e-06,
                    1.8221e-06,
                    1.9045e-06,
                    1.9876e-06,
                    2.0714e-06,
                    2.1563e-06,
                    2.2417e-06,
                    2.3278e-06,
                    2.4147e-06,
                    2.5023e-06,
                    2.5915e-06,
                    2.6816e-06,
                    2.7726e-06,
                    2.8652e-06,
                    2.9604e-06,
                    3.0563e-06,
                    3.1534e-06,
                    3.2504e-06,
                    3.3498e-06,
                    3.4508e-06,
                    3.5544e-06,
                    3.6544e-06,
                    3.7494e-06,
                    3.8404e-06,
                    3.9273e-06,
                    4.0099e-06,
                    4.0898e-06,
                    4.165e-06,
                    4.236e-06,
                    4.3022e-06,
                    4.3623e-06,
                    4.4194e-06,
                    4.4728e-06,
                    4.5458e-06,
                    4.5743e-06,
                    4.5983e-06,
                    4.6174e-06,
                    4.6326e-06,
                    4.6415e-06,
                    4.6725e-06,
                    4.7056e-06,
                    4.7455e-06,
                    4.8154e-06,
                    4.8947e-06,
                    5.0851e-06,
                    5.2963e-06,
                    5.518e-06,
                    5.7634e-06,
                    6.0291e-06,
                    6.3208e-06,
                    6.6254e-06,
                    6.9226e-06,
                    7.2302e-06,
                    7.5214e-06,
                    7.8645e-06,
                    8.2235e-06,
                    8.5998e-06,
                    8.998e-06,
                    9.3928e-06,
                    9.7805e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CH4": 0.05,
                "Land_CH4_timeseries": [
                    2.4137e-07,
                    4.8418e-07,
                    7.2846e-07,
                    9.7418e-07,
                    1.2214e-06,
                    1.47e-06,
                    1.7201e-06,
                    1.9716e-06,
                    2.2246e-06,
                    2.4791e-06,
                    2.7423e-06,
                    3.0144e-06,
                    3.2952e-06,
                    3.5849e-06,
                    3.8833e-06,
                    4.1905e-06,
                    4.5066e-06,
                    4.8314e-06,
                    5.1651e-06,
                    5.5075e-06,
                    5.86e-06,
                    6.2227e-06,
                    6.5955e-06,
                    6.9784e-06,
                    7.3714e-06,
                    7.7745e-06,
                    8.1877e-06,
                    8.6111e-06,
                    9.0446e-06,
                    9.4882e-06,
                    9.9365e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_N2O": 0.12,
                "Total_N2O_timeseries": [
                    5.9953e-08,
                    1.2082e-07,
                    1.8258e-07,
                    2.4519e-07,
                    3.086e-07,
                    3.7275e-07,
                    4.3758e-07,
                    5.03e-07,
                    5.6892e-07,
                    6.3525e-07,
                    7.0191e-07,
                    7.689e-07,
                    8.362e-07,
                    9.038e-07,
                    9.717e-07,
                    1.0399e-06,
                    1.1084e-06,
                    1.1772e-06,
                    1.2464e-06,
                    1.3158e-06,
                    1.3862e-06,
                    1.4584e-06,
                    1.5331e-06,
                    1.6108e-06,
                    1.6918e-06,
                    1.7762e-06,
                    1.8638e-06,
                    1.9543e-06,
                    2.047e-06,
                    2.1412e-06,
                    2.2364e-06,
                    2.3325e-06,
                    2.4293e-06,
                    2.5269e-06,
                    2.625e-06,
                    2.7238e-06,
                    2.8233e-06,
                    2.9234e-06,
                    3.0242e-06,
                    3.1319e-06,
                    3.2357e-06,
                    3.3359e-06,
                    3.4328e-06,
                    3.5265e-06,
                    3.6174e-06,
                    3.7061e-06,
                    3.7929e-06,
                    3.8785e-06,
                    3.9634e-06,
                    4.0484e-06,
                    4.1337e-06,
                    4.2197e-06,
                    4.3064e-06,
                    4.3939e-06,
                    4.4824e-06,
                    4.5719e-06,
                    4.6626e-06,
                    4.7545e-06,
                    4.8477e-06,
                    4.9423e-06,
                    5.0395e-06,
                    5.1415e-06,
                    5.2502e-06,
                    5.3672e-06,
                    5.4936e-06,
                    5.6306e-06,
                    5.7788e-06,
                    5.9385e-06,
                    6.1098e-06,
                    6.2923e-06,
                    6.4881e-06,
                    6.7004e-06,
                    6.9316e-06,
                    7.1828e-06,
                    7.4541e-06,
                    7.7444e-06,
                    8.0515e-06,
                    8.3722e-06,
                    8.7019e-06,
                    9.0352e-06,
                    9.3657e-06,
                    9.688e-06,
                    9.9981e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_N2O": 0.18,
                "Fossil_N2O_timeseries": [
                    3.0043e-08,
                    6.0404e-08,
                    9.1081e-08,
                    1.2207e-07,
                    1.5337e-07,
                    1.8498e-07,
                    2.1689e-07,
                    2.491e-07,
                    2.816e-07,
                    3.1438e-07,
                    3.4745e-07,
                    3.8079e-07,
                    4.1442e-07,
                    4.4833e-07,
                    4.8251e-07,
                    5.1697e-07,
                    5.5172e-07,
                    5.8674e-07,
                    6.2204e-07,
                    6.5763e-07,
                    6.9353e-07,
                    7.2981e-07,
                    7.665e-07,
                    8.0364e-07,
                    8.4125e-07,
                    8.7933e-07,
                    9.1787e-07,
                    9.5685e-07,
                    9.9623e-07,
                    1.036e-06,
                    1.076e-06,
                    1.1164e-06,
                    1.1571e-06,
                    1.1981e-06,
                    1.2394e-06,
                    1.2809e-06,
                    1.3228e-06,
                    1.365e-06,
                    1.4075e-06,
                    1.4504e-06,
                    1.4937e-06,
                    1.5373e-06,
                    1.5813e-06,
                    1.6256e-06,
                    1.6703e-06,
                    1.7153e-06,
                    1.7607e-06,
                    1.8065e-06,
                    1.8526e-06,
                    1.8992e-06,
                    1.9461e-06,
                    1.9934e-06,
                    2.0412e-06,
                    2.0894e-06,
                    2.138e-06,
                    2.1871e-06,
                    2.2366e-06,
                    2.2866e-06,
                    2.3369e-06,
                    2.3877e-06,
                    2.4388e-06,
                    2.4904e-06,
                    2.5423e-06,
                    2.5946e-06,
                    2.6473e-06,
                    2.7003e-06,
                    2.7537e-06,
                    2.8075e-06,
                    2.8617e-06,
                    2.9162e-06,
                    2.9712e-06,
                    3.0266e-06,
                    3.0824e-06,
                    3.1386e-06,
                    3.1953e-06,
                    3.2524e-06,
                    3.3099e-06,
                    3.3679e-06,
                    3.4263e-06,
                    3.4851e-06,
                    3.5448e-06,
                    3.6063e-06,
                    3.6703e-06,
                    3.7375e-06,
                    3.8082e-06,
                    3.8827e-06,
                    3.9612e-06,
                    4.0436e-06,
                    4.1297e-06,
                    4.2192e-06,
                    4.3118e-06,
                    4.4076e-06,
                    4.5066e-06,
                    4.6089e-06,
                    4.7147e-06,
                    4.8243e-06,
                    4.9381e-06,
                    5.0564e-06,
                    5.1796e-06,
                    5.3085e-06,
                    5.4453e-06,
                    5.5942e-06,
                    5.7585e-06,
                    5.9413e-06,
                    6.145e-06,
                    6.3714e-06,
                    6.6219e-06,
                    6.8972e-06,
                    7.1976e-06,
                    7.5229e-06,
                    7.8744e-06,
                    8.255e-06,
                    8.6672e-06,
                    9.1129e-06,
                    9.5934e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.1,
                "Land_N2O_timeseries": [
                    2.991e-08,
                    6.0419e-08,
                    9.15e-08,
                    1.2312e-07,
                    1.5523e-07,
                    1.8777e-07,
                    2.2069e-07,
                    2.539e-07,
                    2.8733e-07,
                    3.2087e-07,
                    3.5447e-07,
                    3.8811e-07,
                    4.2178e-07,
                    4.5547e-07,
                    4.8919e-07,
                    5.2292e-07,
                    5.5668e-07,
                    5.9048e-07,
                    6.2432e-07,
                    6.5822e-07,
                    6.9269e-07,
                    7.2859e-07,
                    7.666e-07,
                    8.0718e-07,
                    8.5058e-07,
                    8.9688e-07,
                    9.4593e-07,
                    9.9741e-07,
                    1.0508e-06,
                    1.1053e-06,
                    1.1604e-06,
                    1.2161e-06,
                    1.2722e-06,
                    1.3288e-06,
                    1.3857e-06,
                    1.4429e-06,
                    1.5005e-06,
                    1.5584e-06,
                    1.6167e-06,
                    1.6814e-06,
                    1.742e-06,
                    1.7986e-06,
                    1.8515e-06,
                    1.9009e-06,
                    1.9472e-06,
                    1.9908e-06,
                    2.0322e-06,
                    2.072e-06,
                    2.1108e-06,
                    2.1492e-06,
                    2.1876e-06,
                    2.2263e-06,
                    2.2652e-06,
                    2.3046e-06,
                    2.3444e-06,
                    2.3848e-06,
                    2.426e-06,
                    2.468e-06,
                    2.5108e-06,
                    2.5546e-06,
                    2.6007e-06,
                    2.6511e-06,
                    2.7079e-06,
                    2.7726e-06,
                    2.8464e-06,
                    2.9303e-06,
                    3.0251e-06,
                    3.131e-06,
                    3.2481e-06,
                    3.3761e-06,
                    3.5169e-06,
                    3.6738e-06,
                    3.8492e-06,
                    4.0442e-06,
                    4.2588e-06,
                    4.492e-06,
                    4.7416e-06,
                    5.0043e-06,
                    5.2756e-06,
                    5.5501e-06,
                    5.8209e-06,
                    6.0817e-06,
                    6.3278e-06,
                    6.5559e-06,
                    6.7646e-06,
                    6.9537e-06,
                    7.125e-06,
                    7.2814e-06,
                    7.4279e-06,
                    7.5707e-06,
                    7.7241e-06,
                    7.9065e-06,
                    8.1319e-06,
                    8.4101e-06,
                    8.7464e-06,
                    9.1419e-06,
                    9.5935e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                16.59681,
                                46.4759
                            ],
                            [
                                16.51161,
                                46.47962
                            ],
                            [
                                16.46292,
                                46.52064
                            ],
                            [
                                16.34313,
                                46.54103
                            ],
                            [
                                16.24163,
                                46.49835
                            ],
                            [
                                16.30155,
                                46.37829
                            ],
                            [
                                16.18963,
                                46.37835
                            ],
                            [
                                16.14148,
                                46.40506
                            ],
                            [
                                16.00315,
                                46.30764
                            ],
                            [
                                15.79148,
                                46.25933
                            ],
                            [
                                15.78642,
                                46.2174
                            ],
                            [
                                15.67485,
                                46.22712
                            ],
                            [
                                15.60831,
                                46.16763
                            ],
                            [
                                15.60455,
                                46.11225
                            ],
                            [
                                15.71465,
                                46.05942
                            ],
                            [
                                15.69257,
                                45.84335
                            ],
                            [
                                15.57831,
                                45.84946
                            ],
                            [
                                15.29901,
                                45.75348
                            ],
                            [
                                15.39949,
                                45.65081
                            ],
                            [
                                15.30147,
                                45.62848
                            ],
                            [
                                15.29907,
                                45.54701
                            ],
                            [
                                15.38454,
                                45.48848
                            ],
                            [
                                15.32893,
                                45.45295
                            ],
                            [
                                15.15752,
                                45.42489
                            ],
                            [
                                15.04978,
                                45.49309
                            ],
                            [
                                14.98692,
                                45.49667
                            ],
                            [
                                14.8173,
                                45.46156
                            ],
                            [
                                14.6772,
                                45.58911
                            ],
                            [
                                14.59671,
                                45.62756
                            ],
                            [
                                14.51354,
                                45.60734
                            ],
                            [
                                14.48835,
                                45.53685
                            ],
                            [
                                14.32278,
                                45.47041
                            ],
                            [
                                14.24499,
                                45.50538
                            ],
                            [
                                14.14147,
                                45.47519
                            ],
                            [
                                14.01101,
                                45.51988
                            ],
                            [
                                13.98581,
                                45.45735
                            ],
                            [
                                13.81494,
                                45.43433
                            ],
                            [
                                13.78616,
                                45.46643
                            ],
                            [
                                13.6513,
                                45.45405
                            ],
                            [
                                13.61147,
                                45.4632
                            ],
                            [
                                13.51019,
                                45.50446
                            ],
                            [
                                13.54125,
                                45.32905
                            ],
                            [
                                13.58894,
                                45.29793
                            ],
                            [
                                13.58867,
                                45.20301
                            ],
                            [
                                13.63594,
                                45.06996
                            ],
                            [
                                13.68818,
                                45.05009
                            ],
                            [
                                13.80166,
                                44.93014
                            ],
                            [
                                13.80041,
                                44.89299
                            ],
                            [
                                13.87546,
                                44.8076
                            ],
                            [
                                13.97877,
                                44.8419
                            ],
                            [
                                14.06529,
                                44.97516
                            ],
                            [
                                14.16874,
                                44.97979
                            ],
                            [
                                14.1577,
                                45.05889
                            ],
                            [
                                14.22379,
                                45.1383
                            ],
                            [
                                14.28202,
                                45.30545
                            ],
                            [
                                14.32641,
                                45.35458
                            ],
                            [
                                14.54855,
                                45.27798
                            ],
                            [
                                14.73921,
                                45.13956
                            ],
                            [
                                14.83176,
                                45.11485
                            ],
                            [
                                14.92715,
                                44.9525
                            ],
                            [
                                14.88478,
                                44.85727
                            ],
                            [
                                14.89779,
                                44.69536
                            ],
                            [
                                14.99086,
                                44.57358
                            ],
                            [
                                15.10713,
                                44.50582
                            ],
                            [
                                15.28001,
                                44.36499
                            ],
                            [
                                15.33013,
                                44.29202
                            ],
                            [
                                15.14117,
                                44.27835
                            ],
                            [
                                15.15795,
                                44.17954
                            ],
                            [
                                15.44411,
                                43.93338
                            ],
                            [
                                15.58944,
                                43.84914
                            ],
                            [
                                15.62555,
                                43.77539
                            ],
                            [
                                15.78156,
                                43.75762
                            ],
                            [
                                15.93616,
                                43.66881
                            ],
                            [
                                15.93466,
                                43.54627
                            ],
                            [
                                15.99589,
                                43.49958
                            ],
                            [
                                16.11251,
                                43.47136
                            ],
                            [
                                16.24257,
                                43.51562
                            ],
                            [
                                16.49688,
                                43.50197
                            ],
                            [
                                16.75165,
                                43.40782
                            ],
                            [
                                16.86914,
                                43.39764
                            ],
                            [
                                16.94703,
                                43.35798
                            ],
                            [
                                17.07844,
                                43.2336
                            ],
                            [
                                17.16611,
                                43.17815
                            ],
                            [
                                17.2597,
                                43.15062
                            ],
                            [
                                17.46772,
                                43.01153
                            ],
                            [
                                17.53641,
                                42.94192
                            ],
                            [
                                17.58134,
                                42.93842
                            ],
                            [
                                17.71095,
                                42.97308
                            ],
                            [
                                17.64027,
                                43.08967
                            ],
                            [
                                17.43067,
                                43.18033
                            ],
                            [
                                17.42159,
                                43.23007
                            ],
                            [
                                17.34191,
                                43.25392
                            ],
                            [
                                17.25154,
                                43.40224
                            ],
                            [
                                17.26744,
                                43.47911
                            ],
                            [
                                17.15213,
                                43.49487
                            ],
                            [
                                17.00961,
                                43.57513
                            ],
                            [
                                16.80065,
                                43.76273
                            ],
                            [
                                16.75159,
                                43.77136
                            ],
                            [
                                16.70889,
                                43.85573
                            ],
                            [
                                16.54976,
                                43.9552
                            ],
                            [
                                16.50224,
                                44.02437
                            ],
                            [
                                16.44215,
                                44.02879
                            ],
                            [
                                16.2111,
                                44.21784
                            ],
                            [
                                16.18827,
                                44.30586
                            ],
                            [
                                16.21759,
                                44.3488
                            ],
                            [
                                16.12957,
                                44.39518
                            ],
                            [
                                16.14046,
                                44.4796
                            ],
                            [
                                16.10914,
                                44.5256
                            ],
                            [
                                16.01997,
                                44.56369
                            ],
                            [
                                16.05464,
                                44.62326
                            ],
                            [
                                15.87821,
                                44.729
                            ],
                            [
                                15.78245,
                                44.74969
                            ],
                            [
                                15.72976,
                                44.8245
                            ],
                            [
                                15.76116,
                                44.8692
                            ],
                            [
                                15.74041,
                                44.93236
                            ],
                            [
                                15.78452,
                                44.99517
                            ],
                            [
                                15.75199,
                                45.05328
                            ],
                            [
                                15.79039,
                                45.11557
                            ],
                            [
                                15.76533,
                                45.16462
                            ],
                            [
                                15.84002,
                                45.22447
                            ],
                            [
                                16.02944,
                                45.19983
                            ],
                            [
                                16.10885,
                                45.09329
                            ],
                            [
                                16.19368,
                                45.0316
                            ],
                            [
                                16.28903,
                                44.99654
                            ],
                            [
                                16.35303,
                                45.00302
                            ],
                            [
                                16.39468,
                                45.11215
                            ],
                            [
                                16.47823,
                                45.16167
                            ],
                            [
                                16.49162,
                                45.208
                            ],
                            [
                                16.59828,
                                45.23107
                            ],
                            [
                                16.79863,
                                45.18674
                            ],
                            [
                                16.93253,
                                45.27516
                            ],
                            [
                                16.98433,
                                45.22938
                            ],
                            [
                                17.16432,
                                45.15164
                            ],
                            [
                                17.3395,
                                45.14477
                            ],
                            [
                                17.59274,
                                45.10693
                            ],
                            [
                                17.67581,
                                45.13138
                            ],
                            [
                                17.83395,
                                45.04812
                            ],
                            [
                                17.93573,
                                45.08125
                            ],
                            [
                                17.98645,
                                45.14438
                            ],
                            [
                                18.05983,
                                45.14336
                            ],
                            [
                                18.11832,
                                45.08076
                            ],
                            [
                                18.1935,
                                45.07803
                            ],
                            [
                                18.23625,
                                45.13603
                            ],
                            [
                                18.32088,
                                45.10186
                            ],
                            [
                                18.41767,
                                45.10964
                            ],
                            [
                                18.47766,
                                45.06231
                            ],
                            [
                                18.58532,
                                45.09199
                            ],
                            [
                                18.71743,
                                45.03527
                            ],
                            [
                                18.80379,
                                44.93927
                            ],
                            [
                                18.76544,
                                44.90432
                            ],
                            [
                                18.8502,
                                44.85456
                            ],
                            [
                                19.02207,
                                44.85535
                            ],
                            [
                                18.98989,
                                44.90611
                            ],
                            [
                                19.14216,
                                44.94088
                            ],
                            [
                                19.09187,
                                44.99497
                            ],
                            [
                                19.14341,
                                45.13108
                            ],
                            [
                                19.23776,
                                45.17601
                            ],
                            [
                                19.41769,
                                45.16624
                            ],
                            [
                                19.42013,
                                45.23318
                            ],
                            [
                                19.26204,
                                45.24232
                            ],
                            [
                                19.11122,
                                45.29466
                            ],
                            [
                                19.09169,
                                45.33511
                            ],
                            [
                                19.00221,
                                45.35862
                            ],
                            [
                                18.99207,
                                45.48039
                            ],
                            [
                                19.09478,
                                45.51951
                            ],
                            [
                                18.9269,
                                45.54408
                            ],
                            [
                                18.92848,
                                45.68941
                            ],
                            [
                                18.97665,
                                45.73908
                            ],
                            [
                                18.85679,
                                45.86003
                            ],
                            [
                                18.88973,
                                45.92118
                            ],
                            [
                                18.7889,
                                45.87908
                            ],
                            [
                                18.70462,
                                45.91804
                            ],
                            [
                                18.5539,
                                45.79439
                            ],
                            [
                                18.40809,
                                45.73953
                            ],
                            [
                                18.1237,
                                45.78889
                            ],
                            [
                                18.07765,
                                45.76521
                            ],
                            [
                                17.99469,
                                45.79509
                            ],
                            [
                                17.90043,
                                45.79112
                            ],
                            [
                                17.67235,
                                45.83501
                            ],
                            [
                                17.57212,
                                45.93478
                            ],
                            [
                                17.44122,
                                45.95009
                            ],
                            [
                                17.25824,
                                46.01161
                            ],
                            [
                                17.23894,
                                46.07586
                            ],
                            [
                                17.12649,
                                46.16882
                            ],
                            [
                                16.97457,
                                46.22471
                            ],
                            [
                                16.88583,
                                46.28141
                            ],
                            [
                                16.87888,
                                46.33581
                            ],
                            [
                                16.80137,
                                46.38431
                            ],
                            [
                                16.71778,
                                46.39242
                            ],
                            [
                                16.66335,
                                46.45945
                            ],
                            [
                                16.59681,
                                46.4759
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                17.64916,
                                42.88892
                            ],
                            [
                                17.30426,
                                43.00143
                            ],
                            [
                                17.21443,
                                42.98174
                            ],
                            [
                                17.45262,
                                42.86766
                            ],
                            [
                                17.78205,
                                42.78766
                            ],
                            [
                                17.80595,
                                42.8066
                            ],
                            [
                                18.11916,
                                42.63961
                            ],
                            [
                                18.2301,
                                42.59952
                            ],
                            [
                                18.28051,
                                42.52872
                            ],
                            [
                                18.52521,
                                42.42046
                            ],
                            [
                                18.43499,
                                42.48403
                            ],
                            [
                                18.4381,
                                42.5557
                            ],
                            [
                                18.36668,
                                42.6155
                            ],
                            [
                                18.24622,
                                42.60288
                            ],
                            [
                                18.10315,
                                42.71336
                            ],
                            [
                                17.94929,
                                42.79898
                            ],
                            [
                                17.8885,
                                42.81694
                            ],
                            [
                                17.84165,
                                42.90353
                            ],
                            [
                                17.79109,
                                42.89257
                            ],
                            [
                                17.67781,
                                42.91985
                            ],
                            [
                                17.64916,
                                42.88892
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.42641,
                                44.98332
                            ],
                            [
                                14.40017,
                                44.92177
                            ],
                            [
                                14.3042,
                                44.93621
                            ],
                            [
                                14.39177,
                                44.69768
                            ],
                            [
                                14.45687,
                                44.62797
                            ],
                            [
                                14.51082,
                                44.64543
                            ],
                            [
                                14.44768,
                                44.86644
                            ],
                            [
                                14.46936,
                                44.94961
                            ],
                            [
                                14.42641,
                                44.98332
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.56577,
                                45.24075
                            ],
                            [
                                14.53211,
                                45.21662
                            ],
                            [
                                14.52643,
                                45.1254
                            ],
                            [
                                14.43239,
                                45.08745
                            ],
                            [
                                14.48927,
                                45.02687
                            ],
                            [
                                14.62256,
                                45.00984
                            ],
                            [
                                14.7091,
                                44.94225
                            ],
                            [
                                14.80974,
                                44.99078
                            ],
                            [
                                14.71766,
                                45.07158
                            ],
                            [
                                14.67509,
                                45.07859
                            ],
                            [
                                14.64577,
                                45.15891
                            ],
                            [
                                14.56577,
                                45.24075
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                16.49873,
                                43.38466
                            ],
                            [
                                16.44049,
                                43.39209
                            ],
                            [
                                16.44037,
                                43.30563
                            ],
                            [
                                16.532,
                                43.27024
                            ],
                            [
                                16.78112,
                                43.26212
                            ],
                            [
                                16.87847,
                                43.28213
                            ],
                            [
                                16.88941,
                                43.31984
                            ],
                            [
                                16.77912,
                                43.35755
                            ],
                            [
                                16.49873,
                                43.38466
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                16.57314,
                                43.22704
                            ],
                            [
                                16.40719,
                                43.18297
                            ],
                            [
                                16.541,
                                43.14054
                            ],
                            [
                                16.68124,
                                43.12119
                            ],
                            [
                                16.93731,
                                43.11241
                            ],
                            [
                                16.96879,
                                43.15057
                            ],
                            [
                                16.7091,
                                43.16107
                            ],
                            [
                                16.65086,
                                43.21679
                            ],
                            [
                                16.57314,
                                43.22704
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.88034,
                                44.57525
                            ],
                            [
                                14.95568,
                                44.4669
                            ],
                            [
                                15.08158,
                                44.39704
                            ],
                            [
                                15.10065,
                                44.32728
                            ],
                            [
                                15.21393,
                                44.31402
                            ],
                            [
                                15.24683,
                                44.34908
                            ],
                            [
                                15.11508,
                                44.44111
                            ],
                            [
                                14.97675,
                                44.50311
                            ],
                            [
                                14.98623,
                                44.53608
                            ],
                            [
                                14.88034,
                                44.57525
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                16.6939,
                                42.99299
                            ],
                            [
                                16.66533,
                                42.92597
                            ],
                            [
                                16.89326,
                                42.89732
                            ],
                            [
                                16.97391,
                                42.92669
                            ],
                            [
                                17.12007,
                                42.90823
                            ],
                            [
                                17.13363,
                                42.96146
                            ],
                            [
                                17.04267,
                                42.97942
                            ],
                            [
                                16.8507,
                                42.95763
                            ],
                            [
                                16.6939,
                                42.99299
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                16.1973,
                                43.07383
                            ],
                            [
                                16.08291,
                                43.07004
                            ],
                            [
                                16.11179,
                                43.00731
                            ],
                            [
                                16.21224,
                                43.01803
                            ],
                            [
                                16.1973,
                                43.07383
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.72408,
                                44.84982
                            ],
                            [
                                14.70173,
                                44.75776
                            ],
                            [
                                14.83081,
                                44.75354
                            ],
                            [
                                14.72408,
                                44.84982
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "CUB",
                "Country": "Cuba",
                "Total_3GHG": 0.19,
                "Total_3GHG_timeseries": [
                    5.7066e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031
                ],
                "Fossil_3GHG": 0.1,
                "Fossil_3GHG_timeseries": [
                    3.2388e-06,
                    6.4041e-06,
                    9.4966e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011
                ],
                "Land_3GHG": 0.34,
                "Land_3GHG_timeseries": [
                    2.4678e-06,
                    4.8529e-06,
                    7.1761e-06,
                    9.4493e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002
                ],
                "Total_CO2": 0.19,
                "Total_CO2_timeseries": [
                    1.2775e-06,
                    2.4985e-06,
                    3.6837e-06,
                    4.8451e-06,
                    5.9888e-06,
                    7.1204e-06,
                    8.2428e-06,
                    9.3592e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022
                ],
                "Fossil_CO2": 0.1,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    3.4369e-08,
                    7.2011e-08,
                    1.0965e-07,
                    1.4893e-07,
                    1.9803e-07,
                    2.7345e-07,
                    3.5874e-07,
                    4.4072e-07,
                    5.2266e-07,
                    3.0466e-06,
                    5.9598e-06,
                    8.7888e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Land_CO2": 0.4,
                "Land_CO2_timeseries": [
                    1.2775e-06,
                    2.4985e-06,
                    3.6837e-06,
                    4.8451e-06,
                    5.9888e-06,
                    7.1204e-06,
                    8.2428e-06,
                    9.3592e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0014
                ],
                "Total_CH4": 0.16,
                "Total_CH4_timeseries": [
                    4.3624e-06,
                    8.6243e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Fossil_CH4": 0.11,
                "Fossil_CH4_timeseries": [
                    3.1939e-06,
                    6.3137e-06,
                    9.3603e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Land_CH4": 0.25,
                "Land_CH4_timeseries": [
                    1.1686e-06,
                    2.3106e-06,
                    3.4261e-06,
                    4.515e-06,
                    5.5774e-06,
                    6.6132e-06,
                    7.6225e-06,
                    8.6052e-06,
                    9.5613e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Total_N2O": 0.21,
                "Total_N2O_timeseries": [
                    6.6607e-08,
                    1.3415e-07,
                    2.0261e-07,
                    2.7194e-07,
                    3.4212e-07,
                    4.1308e-07,
                    4.8477e-07,
                    5.5712e-07,
                    6.3005e-07,
                    7.0348e-07,
                    7.7735e-07,
                    8.5164e-07,
                    9.2636e-07,
                    1.0015e-06,
                    1.077e-06,
                    1.1529e-06,
                    1.2293e-06,
                    1.306e-06,
                    1.3832e-06,
                    1.4609e-06,
                    1.5394e-06,
                    1.6197e-06,
                    1.7022e-06,
                    1.7876e-06,
                    1.8758e-06,
                    1.9672e-06,
                    2.0614e-06,
                    2.1582e-06,
                    2.2572e-06,
                    2.3576e-06,
                    2.459e-06,
                    2.5612e-06,
                    2.6643e-06,
                    2.7681e-06,
                    2.8726e-06,
                    2.9778e-06,
                    3.0838e-06,
                    3.1904e-06,
                    3.2978e-06,
                    3.4279e-06,
                    3.5596e-06,
                    3.694e-06,
                    3.8319e-06,
                    3.9742e-06,
                    4.1217e-06,
                    4.2749e-06,
                    4.4344e-06,
                    4.6006e-06,
                    4.7739e-06,
                    4.9544e-06,
                    5.1448e-06,
                    5.3492e-06,
                    5.5708e-06,
                    5.8116e-06,
                    6.0724e-06,
                    6.3529e-06,
                    6.6517e-06,
                    6.9663e-06,
                    7.293e-06,
                    7.627e-06,
                    7.9655e-06,
                    8.3082e-06,
                    8.6549e-06,
                    9.0053e-06,
                    9.3591e-06,
                    9.716e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_N2O": 0.19,
                "Fossil_N2O_timeseries": [
                    4.4932e-08,
                    9.0367e-08,
                    1.363e-07,
                    1.8272e-07,
                    2.2963e-07,
                    2.7701e-07,
                    3.2484e-07,
                    3.7312e-07,
                    4.2184e-07,
                    4.7096e-07,
                    5.2048e-07,
                    5.7039e-07,
                    6.207e-07,
                    6.7141e-07,
                    7.225e-07,
                    7.7399e-07,
                    8.2587e-07,
                    8.7814e-07,
                    9.3081e-07,
                    9.8388e-07,
                    1.0375e-06,
                    1.0917e-06,
                    1.1467e-06,
                    1.2026e-06,
                    1.2594e-06,
                    1.3172e-06,
                    1.3759e-06,
                    1.4354e-06,
                    1.4957e-06,
                    1.5566e-06,
                    1.618e-06,
                    1.6799e-06,
                    1.7423e-06,
                    1.8052e-06,
                    1.8685e-06,
                    1.9322e-06,
                    1.9964e-06,
                    2.0611e-06,
                    2.1262e-06,
                    2.1926e-06,
                    2.2597e-06,
                    2.3275e-06,
                    2.396e-06,
                    2.4652e-06,
                    2.5353e-06,
                    2.6061e-06,
                    2.6777e-06,
                    2.7502e-06,
                    2.8235e-06,
                    2.8977e-06,
                    2.9727e-06,
                    3.0488e-06,
                    3.1259e-06,
                    3.2041e-06,
                    3.2833e-06,
                    3.3637e-06,
                    3.4451e-06,
                    3.5277e-06,
                    3.6113e-06,
                    3.696e-06,
                    3.7816e-06,
                    3.8683e-06,
                    3.9559e-06,
                    4.0444e-06,
                    4.1339e-06,
                    4.2244e-06,
                    4.3158e-06,
                    4.4082e-06,
                    4.5015e-06,
                    4.5958e-06,
                    4.6911e-06,
                    4.7873e-06,
                    4.8844e-06,
                    4.9825e-06,
                    5.0816e-06,
                    5.1816e-06,
                    5.2825e-06,
                    5.3845e-06,
                    5.4874e-06,
                    5.5914e-06,
                    5.6966e-06,
                    5.8031e-06,
                    5.9113e-06,
                    6.0212e-06,
                    6.133e-06,
                    6.2469e-06,
                    6.3628e-06,
                    6.4808e-06,
                    6.601e-06,
                    6.7232e-06,
                    6.8477e-06,
                    6.9747e-06,
                    7.1045e-06,
                    7.2373e-06,
                    7.3734e-06,
                    7.5129e-06,
                    7.656e-06,
                    7.8029e-06,
                    7.9537e-06,
                    8.1085e-06,
                    8.2691e-06,
                    8.4389e-06,
                    8.6204e-06,
                    8.8158e-06,
                    9.0268e-06,
                    9.2545e-06,
                    9.4993e-06,
                    9.7613e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.22,
                "Land_N2O_timeseries": [
                    2.1675e-08,
                    4.3784e-08,
                    6.6308e-08,
                    8.9221e-08,
                    1.1249e-07,
                    1.3607e-07,
                    1.5993e-07,
                    1.84e-07,
                    2.0822e-07,
                    2.3253e-07,
                    2.5687e-07,
                    2.8125e-07,
                    3.0565e-07,
                    3.3007e-07,
                    3.545e-07,
                    3.7895e-07,
                    4.0342e-07,
                    4.2791e-07,
                    4.5243e-07,
                    4.7699e-07,
                    5.0197e-07,
                    5.28e-07,
                    5.5554e-07,
                    5.8494e-07,
                    6.164e-07,
                    6.4995e-07,
                    6.855e-07,
                    7.228e-07,
                    7.6147e-07,
                    8.0096e-07,
                    8.4093e-07,
                    8.8128e-07,
                    9.2197e-07,
                    9.6294e-07,
                    1.0042e-06,
                    1.0456e-06,
                    1.0873e-06,
                    1.1293e-06,
                    1.1716e-06,
                    1.2353e-06,
                    1.3e-06,
                    1.3665e-06,
                    1.4359e-06,
                    1.509e-06,
                    1.5864e-06,
                    1.6688e-06,
                    1.7567e-06,
                    1.8505e-06,
                    1.9504e-06,
                    2.0568e-06,
                    2.172e-06,
                    2.3004e-06,
                    2.4449e-06,
                    2.6075e-06,
                    2.789e-06,
                    2.9892e-06,
                    3.2065e-06,
                    3.4386e-06,
                    3.6817e-06,
                    3.931e-06,
                    4.1839e-06,
                    4.4399e-06,
                    4.699e-06,
                    4.9608e-06,
                    5.2251e-06,
                    5.4916e-06,
                    5.7598e-06,
                    6.0295e-06,
                    6.3001e-06,
                    6.5714e-06,
                    6.8423e-06,
                    7.1114e-06,
                    7.3777e-06,
                    7.6407e-06,
                    7.8998e-06,
                    8.1551e-06,
                    8.407e-06,
                    8.656e-06,
                    8.9032e-06,
                    9.1499e-06,
                    9.3981e-06,
                    9.6506e-06,
                    9.9095e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -76.89724,
                                21.43508
                            ],
                            [
                                -76.94815,
                                21.45944
                            ],
                            [
                                -77.06382,
                                21.59133
                            ],
                            [
                                -77.33294,
                                21.75401
                            ],
                            [
                                -77.39729,
                                21.77445
                            ],
                            [
                                -77.46714,
                                21.74699
                            ],
                            [
                                -77.57714,
                                21.77111
                            ],
                            [
                                -77.66464,
                                21.77262
                            ],
                            [
                                -77.74596,
                                21.8021
                            ],
                            [
                                -77.77208,
                                21.87206
                            ],
                            [
                                -77.89464,
                                21.86412
                            ],
                            [
                                -77.95296,
                                21.95065
                            ],
                            [
                                -78.05471,
                                22.069
                            ],
                            [
                                -78.17575,
                                22.15015
                            ],
                            [
                                -78.23399,
                                22.12939
                            ],
                            [
                                -78.38156,
                                22.23251
                            ],
                            [
                                -78.50082,
                                22.2608
                            ],
                            [
                                -78.54859,
                                22.30376
                            ],
                            [
                                -78.64021,
                                22.33424
                            ],
                            [
                                -78.69512,
                                22.37943
                            ],
                            [
                                -78.76851,
                                22.37307
                            ],
                            [
                                -78.88358,
                                22.40043
                            ],
                            [
                                -79.00414,
                                22.40168
                            ],
                            [
                                -79.07092,
                                22.37973
                            ],
                            [
                                -79.13931,
                                22.39447
                            ],
                            [
                                -79.24672,
                                22.37378
                            ],
                            [
                                -79.36151,
                                22.42144
                            ],
                            [
                                -79.45977,
                                22.52483
                            ],
                            [
                                -79.50279,
                                22.52955
                            ],
                            [
                                -79.61332,
                                22.66186
                            ],
                            [
                                -79.64931,
                                22.76027
                            ],
                            [
                                -79.70373,
                                22.74819
                            ],
                            [
                                -79.78039,
                                22.79166
                            ],
                            [
                                -79.85246,
                                22.80193
                            ],
                            [
                                -79.97471,
                                22.87439
                            ],
                            [
                                -80.01417,
                                22.93999
                            ],
                            [
                                -80.14832,
                                22.96006
                            ],
                            [
                                -80.25306,
                                22.90258
                            ],
                            [
                                -80.28568,
                                23.00405
                            ],
                            [
                                -80.41312,
                                22.94322
                            ],
                            [
                                -80.53243,
                                22.99178
                            ],
                            [
                                -80.62121,
                                23.08512
                            ],
                            [
                                -80.74702,
                                23.092
                            ],
                            [
                                -80.9388,
                                23.05193
                            ],
                            [
                                -80.98685,
                                23.09944
                            ],
                            [
                                -81.07341,
                                23.08459
                            ],
                            [
                                -81.11907,
                                23.02504
                            ],
                            [
                                -81.17109,
                                23.02854
                            ],
                            [
                                -81.26482,
                                23.14231
                            ],
                            [
                                -81.43943,
                                23.0901
                            ],
                            [
                                -81.49857,
                                23.05036
                            ],
                            [
                                -81.54218,
                                23.12697
                            ],
                            [
                                -81.60349,
                                23.15175
                            ],
                            [
                                -81.77861,
                                23.14509
                            ],
                            [
                                -81.97418,
                                23.16489
                            ],
                            [
                                -82.02317,
                                23.18557
                            ],
                            [
                                -82.14301,
                                23.17137
                            ],
                            [
                                -82.22783,
                                23.18005
                            ],
                            [
                                -82.39333,
                                23.14445
                            ],
                            [
                                -82.45549,
                                23.09696
                            ],
                            [
                                -82.60702,
                                23.04008
                            ],
                            [
                                -82.71842,
                                23.0217
                            ],
                            [
                                -82.95068,
                                23.01641
                            ],
                            [
                                -83.19795,
                                22.99334
                            ],
                            [
                                -83.27915,
                                22.96843
                            ],
                            [
                                -83.38842,
                                22.86824
                            ],
                            [
                                -83.44128,
                                22.90979
                            ],
                            [
                                -83.47655,
                                22.86
                            ],
                            [
                                -83.56517,
                                22.82237
                            ],
                            [
                                -83.85269,
                                22.74909
                            ],
                            [
                                -84.15927,
                                22.57823
                            ],
                            [
                                -84.21698,
                                22.56722
                            ],
                            [
                                -84.20729,
                                22.51258
                            ],
                            [
                                -84.28024,
                                22.47348
                            ],
                            [
                                -84.38721,
                                22.34783
                            ],
                            [
                                -84.42428,
                                22.203
                            ],
                            [
                                -84.40189,
                                22.14232
                            ],
                            [
                                -84.30307,
                                22.01602
                            ],
                            [
                                -84.39892,
                                22.03512
                            ],
                            [
                                -84.43816,
                                22.00981
                            ],
                            [
                                -84.51849,
                                22.03857
                            ],
                            [
                                -84.5855,
                                21.99694
                            ],
                            [
                                -84.70115,
                                21.9573
                            ],
                            [
                                -84.79981,
                                21.90359
                            ],
                            [
                                -84.95088,
                                21.87012
                            ],
                            [
                                -84.91756,
                                21.82999
                            ],
                            [
                                -84.81391,
                                21.81233
                            ],
                            [
                                -84.72304,
                                21.87783
                            ],
                            [
                                -84.555,
                                21.93304
                            ],
                            [
                                -84.46922,
                                21.91158
                            ],
                            [
                                -84.46012,
                                21.86277
                            ],
                            [
                                -84.51175,
                                21.80193
                            ],
                            [
                                -84.43304,
                                21.77204
                            ],
                            [
                                -84.26183,
                                21.89415
                            ],
                            [
                                -84.08756,
                                21.93038
                            ],
                            [
                                -84.03567,
                                21.90858
                            ],
                            [
                                -83.962,
                                22.02933
                            ],
                            [
                                -83.97612,
                                22.09313
                            ],
                            [
                                -83.95244,
                                22.14276
                            ],
                            [
                                -83.88498,
                                22.17385
                            ],
                            [
                                -83.65525,
                                22.16802
                            ],
                            [
                                -83.57015,
                                22.23858
                            ],
                            [
                                -83.47921,
                                22.17279
                            ],
                            [
                                -83.37882,
                                22.20076
                            ],
                            [
                                -83.31614,
                                22.24726
                            ],
                            [
                                -83.28684,
                                22.32399
                            ],
                            [
                                -83.24406,
                                22.34869
                            ],
                            [
                                -83.16999,
                                22.33485
                            ],
                            [
                                -83.06233,
                                22.49346
                            ],
                            [
                                -82.91091,
                                22.55019
                            ],
                            [
                                -82.78884,
                                22.6291
                            ],
                            [
                                -82.777,
                                22.68866
                            ],
                            [
                                -82.73501,
                                22.70582
                            ],
                            [
                                -82.63471,
                                22.68162
                            ],
                            [
                                -82.57158,
                                22.6893
                            ],
                            [
                                -82.34244,
                                22.67867
                            ],
                            [
                                -82.19456,
                                22.68512
                            ],
                            [
                                -82.09843,
                                22.65708
                            ],
                            [
                                -81.86963,
                                22.67745
                            ],
                            [
                                -81.73302,
                                22.62684
                            ],
                            [
                                -81.64287,
                                22.54539
                            ],
                            [
                                -81.65296,
                                22.48882
                            ],
                            [
                                -81.70056,
                                22.45588
                            ],
                            [
                                -81.83521,
                                22.42873
                            ],
                            [
                                -82.11686,
                                22.4297
                            ],
                            [
                                -82.1555,
                                22.396
                            ],
                            [
                                -82.09616,
                                22.34171
                            ],
                            [
                                -81.95728,
                                22.27701
                            ],
                            [
                                -81.86966,
                                22.25639
                            ],
                            [
                                -81.84653,
                                22.20183
                            ],
                            [
                                -81.76196,
                                22.16703
                            ],
                            [
                                -81.72192,
                                22.19273
                            ],
                            [
                                -81.56537,
                                22.17316
                            ],
                            [
                                -81.51324,
                                22.19643
                            ],
                            [
                                -81.41553,
                                22.17935
                            ],
                            [
                                -81.39687,
                                22.09902
                            ],
                            [
                                -81.29631,
                                22.07917
                            ],
                            [
                                -81.27035,
                                22.12154
                            ],
                            [
                                -81.20696,
                                22.14523
                            ],
                            [
                                -81.1896,
                                22.27839
                            ],
                            [
                                -81.14409,
                                22.22288
                            ],
                            [
                                -81.10959,
                                22.10422
                            ],
                            [
                                -81.05558,
                                22.07036
                            ],
                            [
                                -80.8834,
                                22.0389
                            ],
                            [
                                -80.75035,
                                22.05743
                            ],
                            [
                                -80.6032,
                                22.04592
                            ],
                            [
                                -80.46722,
                                22.08177
                            ],
                            [
                                -80.54617,
                                22.16524
                            ],
                            [
                                -80.49073,
                                22.1766
                            ],
                            [
                                -80.40722,
                                22.09732
                            ],
                            [
                                -80.44136,
                                22.03675
                            ],
                            [
                                -80.3405,
                                21.95876
                            ],
                            [
                                -80.2893,
                                21.90017
                            ],
                            [
                                -80.14574,
                                21.82621
                            ],
                            [
                                -80.04296,
                                21.80323
                            ],
                            [
                                -80.02138,
                                21.75021
                            ],
                            [
                                -79.91857,
                                21.73757
                            ],
                            [
                                -79.8226,
                                21.67702
                            ],
                            [
                                -79.76732,
                                21.71021
                            ],
                            [
                                -79.71433,
                                21.67837
                            ],
                            [
                                -79.63182,
                                21.68009
                            ],
                            [
                                -79.53903,
                                21.61896
                            ],
                            [
                                -79.35998,
                                21.59941
                            ],
                            [
                                -79.2171,
                                21.54375
                            ],
                            [
                                -79.05821,
                                21.58883
                            ],
                            [
                                -78.89673,
                                21.59481
                            ],
                            [
                                -78.84334,
                                21.6225
                            ],
                            [
                                -78.74141,
                                21.62614
                            ],
                            [
                                -78.76663,
                                21.56914
                            ],
                            [
                                -78.68009,
                                21.55231
                            ],
                            [
                                -78.60672,
                                21.48531
                            ],
                            [
                                -78.55972,
                                21.38748
                            ],
                            [
                                -78.52197,
                                21.20182
                            ],
                            [
                                -78.4997,
                                21.15647
                            ],
                            [
                                -78.48634,
                                21.03376
                            ],
                            [
                                -78.26493,
                                20.89994
                            ],
                            [
                                -78.24036,
                                20.83161
                            ],
                            [
                                -78.17044,
                                20.81076
                            ],
                            [
                                -78.1386,
                                20.75934
                            ],
                            [
                                -78.03936,
                                20.70079
                            ],
                            [
                                -77.9239,
                                20.69514
                            ],
                            [
                                -77.85028,
                                20.72401
                            ],
                            [
                                -77.77237,
                                20.69307
                            ],
                            [
                                -77.57086,
                                20.69404
                            ],
                            [
                                -77.47986,
                                20.67045
                            ],
                            [
                                -77.35849,
                                20.71425
                            ],
                            [
                                -77.26724,
                                20.64707
                            ],
                            [
                                -77.20244,
                                20.63356
                            ],
                            [
                                -77.2406,
                                20.54595
                            ],
                            [
                                -77.11117,
                                20.50784
                            ],
                            [
                                -77.08273,
                                20.45906
                            ],
                            [
                                -77.12289,
                                20.34932
                            ],
                            [
                                -77.18211,
                                20.28709
                            ],
                            [
                                -77.24989,
                                20.28928
                            ],
                            [
                                -77.26914,
                                20.24747
                            ],
                            [
                                -77.38396,
                                20.20557
                            ],
                            [
                                -77.50162,
                                20.10624
                            ],
                            [
                                -77.60404,
                                20.04273
                            ],
                            [
                                -77.67688,
                                19.93649
                            ],
                            [
                                -77.73854,
                                19.87534
                            ],
                            [
                                -77.67421,
                                19.82797
                            ],
                            [
                                -77.59228,
                                19.85041
                            ],
                            [
                                -77.51047,
                                19.84355
                            ],
                            [
                                -77.44387,
                                19.86155
                            ],
                            [
                                -77.35137,
                                19.85572
                            ],
                            [
                                -77.30277,
                                19.91211
                            ],
                            [
                                -76.99498,
                                19.88569
                            ],
                            [
                                -76.86432,
                                19.93784
                            ],
                            [
                                -76.78773,
                                19.93479
                            ],
                            [
                                -76.66692,
                                19.96094
                            ],
                            [
                                -76.57739,
                                19.94645
                            ],
                            [
                                -76.41283,
                                19.968
                            ],
                            [
                                -76.35308,
                                19.95866
                            ],
                            [
                                -76.27164,
                                19.98873
                            ],
                            [
                                -76.1456,
                                19.98702
                            ],
                            [
                                -76.09842,
                                19.96801
                            ],
                            [
                                -75.96773,
                                19.95719
                            ],
                            [
                                -75.8775,
                                19.97112
                            ],
                            [
                                -75.70695,
                                19.95808
                            ],
                            [
                                -75.59876,
                                19.8954
                            ],
                            [
                                -75.49307,
                                19.88436
                            ],
                            [
                                -75.30098,
                                19.88298
                            ],
                            [
                                -75.19691,
                                19.90712
                            ],
                            [
                                -75.1185,
                                20.05067
                            ],
                            [
                                -75.08358,
                                20.0316
                            ],
                            [
                                -75.10492,
                                19.959
                            ],
                            [
                                -75.15787,
                                19.89291
                            ],
                            [
                                -75.01918,
                                19.90923
                            ],
                            [
                                -74.95165,
                                19.97254
                            ],
                            [
                                -74.88284,
                                19.99035
                            ],
                            [
                                -74.83638,
                                20.0333
                            ],
                            [
                                -74.71115,
                                20.05303
                            ],
                            [
                                -74.65214,
                                20.0429
                            ],
                            [
                                -74.36405,
                                20.0805
                            ],
                            [
                                -74.26909,
                                20.07016
                            ],
                            [
                                -74.22466,
                                20.13259
                            ],
                            [
                                -74.15028,
                                20.17644
                            ],
                            [
                                -74.15036,
                                20.25867
                            ],
                            [
                                -74.22325,
                                20.3144
                            ],
                            [
                                -74.31108,
                                20.2944
                            ],
                            [
                                -74.3866,
                                20.29955
                            ],
                            [
                                -74.50416,
                                20.35293
                            ],
                            [
                                -74.59562,
                                20.48046
                            ],
                            [
                                -74.69983,
                                20.53754
                            ],
                            [
                                -74.75384,
                                20.62469
                            ],
                            [
                                -74.84504,
                                20.62492
                            ],
                            [
                                -74.9495,
                                20.68489
                            ],
                            [
                                -75.10429,
                                20.68595
                            ],
                            [
                                -75.43207,
                                20.74395
                            ],
                            [
                                -75.5007,
                                20.68546
                            ],
                            [
                                -75.58187,
                                20.69528
                            ],
                            [
                                -75.6001,
                                20.76185
                            ],
                            [
                                -75.65378,
                                20.76007
                            ],
                            [
                                -75.71261,
                                20.69145
                            ],
                            [
                                -75.78045,
                                20.74654
                            ],
                            [
                                -75.75293,
                                20.8362
                            ],
                            [
                                -75.69927,
                                20.8222
                            ],
                            [
                                -75.62422,
                                20.8449
                            ],
                            [
                                -75.61779,
                                20.91675
                            ],
                            [
                                -75.57642,
                                21.00313
                            ],
                            [
                                -75.61952,
                                21.06969
                            ],
                            [
                                -75.67069,
                                21.07016
                            ],
                            [
                                -75.71749,
                                21.12471
                            ],
                            [
                                -75.8118,
                                21.13125
                            ],
                            [
                                -76.02158,
                                21.08243
                            ],
                            [
                                -76.12745,
                                21.11278
                            ],
                            [
                                -76.15047,
                                21.16876
                            ],
                            [
                                -76.37553,
                                21.27487
                            ],
                            [
                                -76.5313,
                                21.26789
                            ],
                            [
                                -76.63099,
                                21.30304
                            ],
                            [
                                -76.65456,
                                21.35099
                            ],
                            [
                                -76.8159,
                                21.38155
                            ],
                            [
                                -76.89724,
                                21.43508
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -83.17524,
                                21.61135
                            ],
                            [
                                -83.14229,
                                21.53161
                            ],
                            [
                                -83.07253,
                                21.4695
                            ],
                            [
                                -82.88594,
                                21.43932
                            ],
                            [
                                -82.71609,
                                21.48341
                            ],
                            [
                                -82.54028,
                                21.56104
                            ],
                            [
                                -82.56668,
                                21.63893
                            ],
                            [
                                -82.60208,
                                21.66346
                            ],
                            [
                                -82.57808,
                                21.7382
                            ],
                            [
                                -82.67803,
                                21.80124
                            ],
                            [
                                -82.68837,
                                21.87807
                            ],
                            [
                                -82.84092,
                                21.92757
                            ],
                            [
                                -82.9433,
                                21.93606
                            ],
                            [
                                -83.05507,
                                21.84664
                            ],
                            [
                                -83.08717,
                                21.78149
                            ],
                            [
                                -82.97837,
                                21.61462
                            ],
                            [
                                -82.97407,
                                21.56942
                            ],
                            [
                                -83.02623,
                                21.5423
                            ],
                            [
                                -83.09163,
                                21.55017
                            ],
                            [
                                -83.17524,
                                21.61135
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -78.35091,
                                22.53379
                            ],
                            [
                                -78.42239,
                                22.55217
                            ],
                            [
                                -78.47048,
                                22.52454
                            ],
                            [
                                -78.57944,
                                22.53182
                            ],
                            [
                                -78.67244,
                                22.60666
                            ],
                            [
                                -78.71615,
                                22.56759
                            ],
                            [
                                -78.69063,
                                22.49263
                            ],
                            [
                                -78.47006,
                                22.43291
                            ],
                            [
                                -78.31086,
                                22.4092
                            ],
                            [
                                -78.22135,
                                22.30144
                            ],
                            [
                                -78.06843,
                                22.27948
                            ],
                            [
                                -78.07257,
                                22.20964
                            ],
                            [
                                -78.01015,
                                22.12719
                            ],
                            [
                                -77.95473,
                                22.11285
                            ],
                            [
                                -77.93683,
                                22.04019
                            ],
                            [
                                -77.78949,
                                21.96259
                            ],
                            [
                                -77.67079,
                                21.93916
                            ],
                            [
                                -77.62414,
                                22.00729
                            ],
                            [
                                -77.66254,
                                22.06098
                            ],
                            [
                                -77.74322,
                                22.06613
                            ],
                            [
                                -77.83088,
                                22.10205
                            ],
                            [
                                -77.97603,
                                22.28742
                            ],
                            [
                                -78.06497,
                                22.29555
                            ],
                            [
                                -78.07214,
                                22.37692
                            ],
                            [
                                -78.10565,
                                22.40737
                            ],
                            [
                                -78.20286,
                                22.43526
                            ],
                            [
                                -78.26814,
                                22.42929
                            ],
                            [
                                -78.35091,
                                22.53379
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -77.63082,
                                21.86688
                            ],
                            [
                                -77.6029,
                                21.88641
                            ],
                            [
                                -77.52542,
                                21.81018
                            ],
                            [
                                -77.47452,
                                21.82886
                            ],
                            [
                                -77.57482,
                                21.92447
                            ],
                            [
                                -77.63082,
                                21.86688
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -80.86875,
                                23.21838
                            ],
                            [
                                -80.73998,
                                23.18091
                            ],
                            [
                                -80.5818,
                                23.17269
                            ],
                            [
                                -80.61848,
                                23.22221
                            ],
                            [
                                -80.69576,
                                23.20208
                            ],
                            [
                                -80.86875,
                                23.21838
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -79.28667,
                                22.53827
                            ],
                            [
                                -79.20184,
                                22.52428
                            ],
                            [
                                -79.12743,
                                22.55168
                            ],
                            [
                                -79.13493,
                                22.63848
                            ],
                            [
                                -79.21779,
                                22.61304
                            ],
                            [
                                -79.28667,
                                22.53827
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -79.10653,
                                22.64063
                            ],
                            [
                                -78.99635,
                                22.61496
                            ],
                            [
                                -78.96534,
                                22.66435
                            ],
                            [
                                -79.08863,
                                22.66719
                            ],
                            [
                                -79.10653,
                                22.64063
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -80.33036,
                                23.12501
                            ],
                            [
                                -80.15739,
                                23.05126
                            ],
                            [
                                -80.23457,
                                23.13738
                            ],
                            [
                                -80.33036,
                                23.12501
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -79.63243,
                                22.78251
                            ],
                            [
                                -79.56846,
                                22.78931
                            ],
                            [
                                -79.52854,
                                22.71659
                            ],
                            [
                                -79.44588,
                                22.71615
                            ],
                            [
                                -79.57554,
                                22.80688
                            ],
                            [
                                -79.63243,
                                22.78251
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "CUW",
                "Country": "Cura\xe7ao",
                "Total_3GHG": 0.02,
                "Total_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2.2633e-07,
                    4.6868e-07,
                    1.0295e-06,
                    1.7304e-06,
                    2.6424e-06,
                    3.4e-06,
                    4.1412e-06,
                    4.9343e-06,
                    5.8114e-06,
                    6.7941e-06,
                    7.862e-06,
                    9.1091e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_3GHG": 0.02,
                "Fossil_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2.2633e-07,
                    4.6868e-07,
                    1.0295e-06,
                    1.7304e-06,
                    2.6424e-06,
                    3.4e-06,
                    4.1412e-06,
                    4.9343e-06,
                    5.8114e-06,
                    6.7941e-06,
                    7.862e-06,
                    9.1091e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [],
                "Total_CO2": 0.02,
                "Total_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2.2633e-07,
                    4.6868e-07,
                    1.0295e-06,
                    1.7304e-06,
                    2.6424e-06,
                    3.4e-06,
                    4.1412e-06,
                    4.9343e-06,
                    5.8114e-06,
                    6.7941e-06,
                    7.862e-06,
                    9.1091e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_CO2": 0.03,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2.2633e-07,
                    4.6868e-07,
                    1.0295e-06,
                    1.7304e-06,
                    2.6424e-06,
                    3.4e-06,
                    4.1412e-06,
                    4.9343e-06,
                    5.8114e-06,
                    6.7941e-06,
                    7.862e-06,
                    9.1091e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": []
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -69.16164,
                            12.38064
                        ],
                        [
                            -69.13875,
                            12.27023
                        ],
                        [
                            -69.0772,
                            12.19487
                        ],
                        [
                            -69.02669,
                            12.19433
                        ],
                        [
                            -68.9605,
                            12.11307
                        ],
                        [
                            -68.79115,
                            12.0346
                        ],
                        [
                            -68.75938,
                            12.06387
                        ],
                        [
                            -68.85287,
                            12.17419
                        ],
                        [
                            -68.98003,
                            12.20003
                        ],
                        [
                            -69.02823,
                            12.24058
                        ],
                        [
                            -69.07294,
                            12.35206
                        ],
                        [
                            -69.16164,
                            12.38064
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "CYP",
                "Country": "Cyprus",
                "Total_3GHG": 0.01,
                "Total_3GHG_timeseries": [
                    2.0723e-07,
                    4.1986e-07,
                    6.3708e-07,
                    8.5841e-07,
                    1.0835e-06,
                    1.312e-06,
                    1.5437e-06,
                    1.7783e-06,
                    2.0157e-06,
                    2.2569e-06,
                    2.4974e-06,
                    2.7369e-06,
                    2.9752e-06,
                    3.2121e-06,
                    3.4476e-06,
                    3.6815e-06,
                    3.9138e-06,
                    4.1443e-06,
                    4.373e-06,
                    4.6131e-06,
                    4.8551e-06,
                    5.0968e-06,
                    5.3374e-06,
                    5.5766e-06,
                    5.8143e-06,
                    6.05e-06,
                    6.2837e-06,
                    6.5151e-06,
                    6.7438e-06,
                    6.9571e-06,
                    7.1665e-06,
                    7.3741e-06,
                    7.5803e-06,
                    7.7855e-06,
                    7.9897e-06,
                    8.1931e-06,
                    8.3958e-06,
                    8.5979e-06,
                    8.7995e-06,
                    8.9995e-06,
                    9.1986e-06,
                    9.3973e-06,
                    9.5958e-06,
                    9.7943e-06,
                    9.9928e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_3GHG": 0.02,
                "Fossil_3GHG_timeseries": [
                    2.4611e-08,
                    4.9527e-08,
                    7.4753e-08,
                    1.0029e-07,
                    1.2613e-07,
                    1.5229e-07,
                    1.7876e-07,
                    2.0553e-07,
                    2.3262e-07,
                    2.6002e-07,
                    2.8672e-07,
                    3.1271e-07,
                    3.38e-07,
                    3.6259e-07,
                    3.8648e-07,
                    4.0966e-07,
                    4.3215e-07,
                    4.5393e-07,
                    4.7502e-07,
                    4.9541e-07,
                    5.1498e-07,
                    5.3373e-07,
                    5.5168e-07,
                    5.6884e-07,
                    5.8519e-07,
                    6.0075e-07,
                    6.1552e-07,
                    6.2949e-07,
                    6.4264e-07,
                    6.5498e-07,
                    6.6735e-07,
                    6.7977e-07,
                    6.9222e-07,
                    7.047e-07,
                    7.1722e-07,
                    7.2978e-07,
                    7.4237e-07,
                    7.55e-07,
                    7.6768e-07,
                    7.8039e-07,
                    7.9314e-07,
                    8.0593e-07,
                    8.1876e-07,
                    8.3163e-07,
                    8.4453e-07,
                    8.5748e-07,
                    8.7047e-07,
                    8.835e-07,
                    8.9657e-07,
                    9.0968e-07,
                    9.2436e-07,
                    9.406e-07,
                    9.5841e-07,
                    9.7778e-07,
                    9.9873e-07,
                    1.0213e-06,
                    1.0454e-06,
                    1.071e-06,
                    1.0983e-06,
                    1.1271e-06,
                    1.1576e-06,
                    1.1896e-06,
                    1.2234e-06,
                    1.2587e-06,
                    1.2957e-06,
                    1.3343e-06,
                    1.3746e-06,
                    1.4165e-06,
                    1.4601e-06,
                    1.5053e-06,
                    1.551e-06,
                    1.5968e-06,
                    1.6431e-06,
                    1.6893e-06,
                    1.7355e-06,
                    1.782e-06,
                    1.8287e-06,
                    1.8757e-06,
                    1.9229e-06,
                    1.9704e-06,
                    2.018e-06,
                    2.0658e-06,
                    2.1139e-06,
                    2.1624e-06,
                    2.2113e-06,
                    2.2605e-06,
                    2.3101e-06,
                    2.36e-06,
                    2.4103e-06,
                    2.461e-06,
                    2.5307e-06,
                    2.6203e-06,
                    2.7303e-06,
                    2.862e-06,
                    3.011e-06,
                    3.1771e-06,
                    3.36e-06,
                    3.5598e-06,
                    3.7757e-06,
                    4.1284e-06,
                    4.4994e-06,
                    4.8964e-06,
                    5.3276e-06,
                    5.8047e-06,
                    6.2961e-06,
                    6.9e-06,
                    7.5794e-06,
                    8.2447e-06,
                    8.9476e-06,
                    9.6802e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [
                    1.8262e-07,
                    3.7033e-07,
                    5.6233e-07,
                    7.5813e-07,
                    9.5737e-07,
                    1.1597e-06,
                    1.365e-06,
                    1.5728e-06,
                    1.7831e-06,
                    1.9969e-06,
                    2.2107e-06,
                    2.4242e-06,
                    2.6372e-06,
                    2.8495e-06,
                    3.0611e-06,
                    3.2718e-06,
                    3.4816e-06,
                    3.6904e-06,
                    3.898e-06,
                    4.1177e-06,
                    4.3402e-06,
                    4.563e-06,
                    4.7857e-06,
                    5.0078e-06,
                    5.2291e-06,
                    5.4493e-06,
                    5.6682e-06,
                    5.8856e-06,
                    6.1012e-06,
                    6.3022e-06,
                    6.4992e-06,
                    6.6943e-06,
                    6.8881e-06,
                    7.0808e-06,
                    7.2725e-06,
                    7.4633e-06,
                    7.6534e-06,
                    7.8429e-06,
                    8.0318e-06,
                    8.2191e-06,
                    8.4055e-06,
                    8.5914e-06,
                    8.7771e-06,
                    8.9627e-06,
                    9.1482e-06,
                    9.3339e-06,
                    9.5196e-06,
                    9.7055e-06,
                    9.8915e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_CO2": 0.01,
                "Total_CO2_timeseries": [
                    1.2461e-07,
                    2.536e-07,
                    3.8619e-07,
                    5.2188e-07,
                    6.6034e-07,
                    8.0125e-07,
                    9.4434e-07,
                    1.0894e-06,
                    1.2363e-06,
                    1.3861e-06,
                    1.5377e-06,
                    1.6907e-06,
                    1.8451e-06,
                    2.0007e-06,
                    2.1574e-06,
                    2.3151e-06,
                    2.4736e-06,
                    2.6329e-06,
                    2.7928e-06,
                    2.9667e-06,
                    3.1454e-06,
                    3.3263e-06,
                    3.5086e-06,
                    3.6921e-06,
                    3.8764e-06,
                    4.0613e-06,
                    4.2464e-06,
                    4.4317e-06,
                    4.617e-06,
                    4.7895e-06,
                    4.958e-06,
                    5.1244e-06,
                    5.2895e-06,
                    5.4533e-06,
                    5.6161e-06,
                    5.778e-06,
                    5.939e-06,
                    6.0993e-06,
                    6.259e-06,
                    6.4167e-06,
                    6.5733e-06,
                    6.7295e-06,
                    6.8853e-06,
                    7.0411e-06,
                    7.1967e-06,
                    7.3524e-06,
                    7.5081e-06,
                    7.6639e-06,
                    7.8198e-06,
                    8.0126e-06,
                    8.2206e-06,
                    8.4375e-06,
                    8.6609e-06,
                    8.8908e-06,
                    9.1262e-06,
                    9.3665e-06,
                    9.6101e-06,
                    9.8574e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_CO2": 0.02,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.2045e-07,
                    2.475e-07,
                    3.894e-07,
                    5.544e-07,
                    7.5405e-07,
                    9.57e-07,
                    1.2605e-06,
                    1.6284e-06,
                    1.9731e-06,
                    2.3475e-06,
                    2.7466e-06,
                    3.1358e-06,
                    3.5432e-06,
                    3.9869e-06,
                    4.4372e-06,
                    4.9551e-06,
                    5.5143e-06,
                    6.1278e-06,
                    6.8583e-06,
                    7.6103e-06,
                    8.377e-06,
                    9.2252e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [
                    1.2461e-07,
                    2.536e-07,
                    3.8619e-07,
                    5.2188e-07,
                    6.6034e-07,
                    8.0125e-07,
                    9.4434e-07,
                    1.0894e-06,
                    1.2363e-06,
                    1.3861e-06,
                    1.5377e-06,
                    1.6907e-06,
                    1.8451e-06,
                    2.0007e-06,
                    2.1574e-06,
                    2.3151e-06,
                    2.4736e-06,
                    2.6329e-06,
                    2.7928e-06,
                    2.9667e-06,
                    3.1454e-06,
                    3.3263e-06,
                    3.5086e-06,
                    3.6921e-06,
                    3.8764e-06,
                    4.0613e-06,
                    4.2464e-06,
                    4.4317e-06,
                    4.617e-06,
                    4.7895e-06,
                    4.958e-06,
                    5.1244e-06,
                    5.2895e-06,
                    5.4533e-06,
                    5.6161e-06,
                    5.778e-06,
                    5.939e-06,
                    6.0993e-06,
                    6.259e-06,
                    6.4167e-06,
                    6.5733e-06,
                    6.7295e-06,
                    6.8853e-06,
                    7.0411e-06,
                    7.1967e-06,
                    7.3524e-06,
                    7.5081e-06,
                    7.6639e-06,
                    7.8198e-06,
                    8.0126e-06,
                    8.2206e-06,
                    8.4375e-06,
                    8.6609e-06,
                    8.8908e-06,
                    9.1262e-06,
                    9.3665e-06,
                    9.6101e-06,
                    9.8574e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    9.7674e-06,
                    9.4389e-06,
                    9.1767e-06,
                    8.7395e-06,
                    8.2627e-06,
                    7.7714e-06,
                    7.2377e-06,
                    6.7332e-06,
                    6.6129e-06,
                    6.2359e-06,
                    6.1129e-06,
                    5.914e-06,
                    5.6956e-06,
                    5.4923e-06,
                    5.4144e-06,
                    5.2942e-06,
                    5.1685e-06
                ],
                "Total_CH4": 0.01,
                "Total_CH4_timeseries": [
                    7.5204e-08,
                    1.5129e-07,
                    2.2826e-07,
                    3.0611e-07,
                    3.8486e-07,
                    4.6448e-07,
                    5.45e-07,
                    6.264e-07,
                    7.087e-07,
                    7.919e-07,
                    8.7254e-07,
                    9.5061e-07,
                    1.0261e-06,
                    1.0991e-06,
                    1.1695e-06,
                    1.2374e-06,
                    1.3027e-06,
                    1.3655e-06,
                    1.4257e-06,
                    1.4833e-06,
                    1.5381e-06,
                    1.5899e-06,
                    1.6388e-06,
                    1.6848e-06,
                    1.7279e-06,
                    1.768e-06,
                    1.8053e-06,
                    1.8396e-06,
                    1.871e-06,
                    1.8995e-06,
                    1.928e-06,
                    1.9565e-06,
                    1.9851e-06,
                    2.0137e-06,
                    2.0423e-06,
                    2.0709e-06,
                    2.0996e-06,
                    2.1283e-06,
                    2.1571e-06,
                    2.1858e-06,
                    2.2146e-06,
                    2.2435e-06,
                    2.2723e-06,
                    2.3012e-06,
                    2.3301e-06,
                    2.359e-06,
                    2.388e-06,
                    2.417e-06,
                    2.446e-06,
                    2.4751e-06,
                    2.5092e-06,
                    2.5484e-06,
                    2.5927e-06,
                    2.6421e-06,
                    2.6966e-06,
                    2.7561e-06,
                    2.8207e-06,
                    2.8905e-06,
                    2.9653e-06,
                    3.0452e-06,
                    3.1303e-06,
                    3.2207e-06,
                    3.3164e-06,
                    3.4174e-06,
                    3.5236e-06,
                    3.6351e-06,
                    3.7518e-06,
                    3.8739e-06,
                    4.0012e-06,
                    4.1338e-06,
                    4.2672e-06,
                    4.4012e-06,
                    4.5359e-06,
                    4.671e-06,
                    4.8063e-06,
                    4.9423e-06,
                    5.0789e-06,
                    5.2161e-06,
                    5.3539e-06,
                    5.4923e-06,
                    5.6311e-06,
                    5.7703e-06,
                    5.91e-06,
                    6.0501e-06,
                    6.1907e-06,
                    6.323e-06,
                    6.447e-06,
                    6.5623e-06,
                    6.6688e-06,
                    6.7664e-06,
                    6.8804e-06,
                    7.0109e-06,
                    7.1581e-06,
                    7.3226e-06,
                    7.4995e-06,
                    7.6879e-06,
                    7.8872e-06,
                    8.097e-06,
                    8.3159e-06,
                    8.5437e-06,
                    8.7721e-06,
                    9e-06,
                    9.2274e-06,
                    9.4548e-06,
                    9.6821e-06,
                    9.9184e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_CH4": 0.01,
                "Fossil_CH4_timeseries": [
                    2.1943e-08,
                    4.4163e-08,
                    6.6662e-08,
                    8.944e-08,
                    1.125e-07,
                    1.3584e-07,
                    1.5947e-07,
                    1.8337e-07,
                    2.0757e-07,
                    2.3206e-07,
                    2.5582e-07,
                    2.7884e-07,
                    3.0115e-07,
                    3.2273e-07,
                    3.4358e-07,
                    3.6371e-07,
                    3.8311e-07,
                    4.018e-07,
                    4.1976e-07,
                    4.37e-07,
                    4.5339e-07,
                    4.6893e-07,
                    4.8361e-07,
                    4.9744e-07,
                    5.1042e-07,
                    5.2254e-07,
                    5.3381e-07,
                    5.4423e-07,
                    5.5379e-07,
                    5.6249e-07,
                    5.712e-07,
                    5.7992e-07,
                    5.8865e-07,
                    5.9739e-07,
                    6.0613e-07,
                    6.1489e-07,
                    6.2365e-07,
                    6.3243e-07,
                    6.4122e-07,
                    6.5001e-07,
                    6.5882e-07,
                    6.6763e-07,
                    6.7645e-07,
                    6.8528e-07,
                    6.9411e-07,
                    7.0295e-07,
                    7.1181e-07,
                    7.2067e-07,
                    7.2954e-07,
                    7.3842e-07,
                    7.4882e-07,
                    7.6075e-07,
                    7.742e-07,
                    7.8918e-07,
                    8.0569e-07,
                    8.2373e-07,
                    8.4331e-07,
                    8.6441e-07,
                    8.8705e-07,
                    9.1122e-07,
                    9.3699e-07,
                    9.6433e-07,
                    9.9327e-07,
                    1.0238e-06,
                    1.0559e-06,
                    1.0897e-06,
                    1.125e-06,
                    1.1619e-06,
                    1.2005e-06,
                    1.2406e-06,
                    1.2811e-06,
                    1.3219e-06,
                    1.3629e-06,
                    1.4039e-06,
                    1.4449e-06,
                    1.486e-06,
                    1.5274e-06,
                    1.569e-06,
                    1.6108e-06,
                    1.6527e-06,
                    1.6948e-06,
                    1.7369e-06,
                    1.7792e-06,
                    1.8215e-06,
                    1.864e-06,
                    1.9066e-06,
                    1.9493e-06,
                    1.992e-06,
                    2.0349e-06,
                    2.0779e-06,
                    2.1396e-06,
                    2.2209e-06,
                    2.3222e-06,
                    2.4449e-06,
                    2.5845e-06,
                    2.7408e-06,
                    2.9135e-06,
                    3.1028e-06,
                    3.3079e-06,
                    3.5292e-06,
                    3.762e-06,
                    4.0058e-06,
                    4.2605e-06,
                    4.5263e-06,
                    4.8029e-06,
                    5.0913e-06,
                    5.3907e-06,
                    5.699e-06,
                    6.0149e-06,
                    6.3355e-06,
                    6.64e-06,
                    6.9257e-06,
                    7.1901e-06,
                    7.4315e-06,
                    7.6552e-06,
                    7.8616e-06,
                    8.0512e-06,
                    8.2245e-06,
                    8.3804e-06,
                    8.5249e-06,
                    8.6731e-06,
                    8.828e-06,
                    8.9818e-06,
                    9.123e-06,
                    9.2609e-06,
                    9.4013e-06,
                    9.5437e-06,
                    9.6903e-06,
                    9.8427e-06,
                    9.9997e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [
                    5.3261e-08,
                    1.0713e-07,
                    1.616e-07,
                    2.1667e-07,
                    2.7236e-07,
                    3.2864e-07,
                    3.8553e-07,
                    4.4303e-07,
                    5.0113e-07,
                    5.5984e-07,
                    6.1672e-07,
                    6.7177e-07,
                    7.2499e-07,
                    7.7638e-07,
                    8.2595e-07,
                    8.7368e-07,
                    9.1959e-07,
                    9.6366e-07,
                    1.0059e-06,
                    1.0463e-06,
                    1.0847e-06,
                    1.121e-06,
                    1.1552e-06,
                    1.1874e-06,
                    1.2175e-06,
                    1.2455e-06,
                    1.2715e-06,
                    1.2954e-06,
                    1.3172e-06,
                    1.337e-06,
                    1.3568e-06,
                    1.3766e-06,
                    1.3964e-06,
                    1.4163e-06,
                    1.4361e-06,
                    1.456e-06,
                    1.476e-06,
                    1.4959e-06,
                    1.5158e-06,
                    1.5358e-06,
                    1.5558e-06,
                    1.5758e-06,
                    1.5959e-06,
                    1.6159e-06,
                    1.636e-06,
                    1.6561e-06,
                    1.6762e-06,
                    1.6963e-06,
                    1.7165e-06,
                    1.7367e-06,
                    1.7604e-06,
                    1.7877e-06,
                    1.8185e-06,
                    1.8529e-06,
                    1.8909e-06,
                    1.9324e-06,
                    1.9774e-06,
                    2.026e-06,
                    2.0782e-06,
                    2.1339e-06,
                    2.1933e-06,
                    2.2564e-06,
                    2.3231e-06,
                    2.3936e-06,
                    2.4677e-06,
                    2.5454e-06,
                    2.6269e-06,
                    2.712e-06,
                    2.8008e-06,
                    2.8932e-06,
                    2.9861e-06,
                    3.0793e-06,
                    3.173e-06,
                    3.267e-06,
                    3.3614e-06,
                    3.4563e-06,
                    3.5515e-06,
                    3.6471e-06,
                    3.7432e-06,
                    3.8396e-06,
                    3.9363e-06,
                    4.0334e-06,
                    4.1308e-06,
                    4.2286e-06,
                    4.3267e-06,
                    4.4164e-06,
                    4.4977e-06,
                    4.5702e-06,
                    4.6339e-06,
                    4.6886e-06,
                    4.7408e-06,
                    4.7901e-06,
                    4.8359e-06,
                    4.8777e-06,
                    4.9149e-06,
                    4.9471e-06,
                    4.9737e-06,
                    4.9942e-06,
                    5.008e-06,
                    5.0146e-06,
                    5.0101e-06,
                    4.9942e-06,
                    4.9669e-06,
                    4.9285e-06,
                    4.8792e-06,
                    4.8271e-06,
                    4.7723e-06,
                    4.714e-06,
                    4.6514e-06,
                    4.5832e-06,
                    4.509e-06,
                    4.4352e-06,
                    4.3684e-06,
                    4.312e-06,
                    4.2561e-06,
                    4.2211e-06,
                    4.1999e-06,
                    4.191e-06,
                    4.2016e-06,
                    4.2317e-06,
                    4.2758e-06,
                    4.3306e-06,
                    4.402e-06,
                    4.4479e-06,
                    4.3474e-06,
                    4.2607e-06,
                    4.2043e-06,
                    4.1762e-06,
                    4.1514e-06,
                    4.1387e-06,
                    4.141e-06,
                    4.1546e-06,
                    4.1759e-06,
                    4.2056e-06,
                    4.2456e-06,
                    4.2634e-06,
                    4.2802e-06,
                    4.2909e-06,
                    4.2858e-06,
                    4.2757e-06,
                    4.2629e-06,
                    4.2548e-06,
                    4.2493e-06,
                    4.2787e-06,
                    4.466e-06,
                    4.6605e-06,
                    4.832e-06,
                    4.9863e-06,
                    5.1441e-06,
                    5.3171e-06,
                    5.5102e-06,
                    5.7195e-06,
                    5.8917e-06,
                    6.0406e-06,
                    6.1487e-06,
                    6.2673e-06,
                    6.3714e-06,
                    6.4721e-06,
                    6.5661e-06,
                    6.6687e-06,
                    6.7689e-06,
                    6.8457e-06,
                    6.8864e-06,
                    6.9278e-06,
                    6.9479e-06,
                    6.972e-06,
                    7.0116e-06,
                    7.0518e-06,
                    7.1025e-06,
                    7.1637e-06,
                    7.2127e-06,
                    7.2502e-06
                ],
                "Total_N2O": 0.01,
                "Total_N2O_timeseries": [
                    7.421e-09,
                    1.4967e-08,
                    2.2634e-08,
                    3.0416e-08,
                    3.8305e-08,
                    4.6291e-08,
                    5.4364e-08,
                    6.251e-08,
                    7.0715e-08,
                    7.8962e-08,
                    8.7243e-08,
                    9.5553e-08,
                    1.0389e-07,
                    1.1226e-07,
                    1.2065e-07,
                    1.2906e-07,
                    1.3751e-07,
                    1.4598e-07,
                    1.5449e-07,
                    1.6302e-07,
                    1.7168e-07,
                    1.806e-07,
                    1.8991e-07,
                    1.9968e-07,
                    2.0996e-07,
                    2.2076e-07,
                    2.3205e-07,
                    2.4378e-07,
                    2.5586e-07,
                    2.6815e-07,
                    2.8058e-07,
                    2.9313e-07,
                    3.0577e-07,
                    3.185e-07,
                    3.3132e-07,
                    3.4422e-07,
                    3.572e-07,
                    3.7026e-07,
                    3.8341e-07,
                    3.9703e-07,
                    4.107e-07,
                    4.2442e-07,
                    4.3819e-07,
                    4.5203e-07,
                    4.6594e-07,
                    4.7992e-07,
                    4.9398e-07,
                    5.0811e-07,
                    5.2233e-07,
                    5.3664e-07,
                    5.5104e-07,
                    5.6554e-07,
                    5.8017e-07,
                    5.9492e-07,
                    6.098e-07,
                    6.2482e-07,
                    6.3999e-07,
                    6.5529e-07,
                    6.7074e-07,
                    6.8632e-07,
                    7.0204e-07,
                    7.1787e-07,
                    7.3382e-07,
                    7.4989e-07,
                    7.6608e-07,
                    7.8239e-07,
                    7.9885e-07,
                    8.1548e-07,
                    8.3228e-07,
                    8.4929e-07,
                    8.6664e-07,
                    8.8458e-07,
                    9.0329e-07,
                    9.229e-07,
                    9.4352e-07,
                    9.6519e-07,
                    9.8792e-07,
                    1.0117e-06,
                    1.0364e-06,
                    1.0619e-06,
                    1.0882e-06,
                    1.1152e-06,
                    1.143e-06,
                    1.1717e-06,
                    1.2012e-06,
                    1.2315e-06,
                    1.2627e-06,
                    1.2948e-06,
                    1.3277e-06,
                    1.3616e-06,
                    1.3968e-06,
                    1.4339e-06,
                    1.4735e-06,
                    1.516e-06,
                    1.5614e-06,
                    1.61e-06,
                    1.6615e-06,
                    1.7157e-06,
                    1.7721e-06,
                    1.8302e-06,
                    1.8898e-06,
                    1.9511e-06,
                    2.0142e-06,
                    2.0794e-06,
                    2.1465e-06,
                    2.2156e-06,
                    2.2865e-06,
                    2.3589e-06,
                    2.4327e-06,
                    2.5073e-06,
                    2.5818e-06,
                    2.6613e-06,
                    2.7487e-06,
                    2.8245e-06,
                    2.9163e-06,
                    3.0089e-06,
                    3.1071e-06,
                    3.2252e-06,
                    3.3449e-06,
                    3.4719e-06,
                    3.6015e-06,
                    3.7381e-06,
                    3.8812e-06,
                    3.9926e-06,
                    4.0745e-06,
                    4.1646e-06,
                    4.2521e-06,
                    4.349e-06,
                    4.4489e-06,
                    4.5471e-06,
                    4.6499e-06,
                    4.7624e-06,
                    4.8753e-06,
                    4.9937e-06,
                    5.1137e-06,
                    5.2345e-06,
                    5.3645e-06,
                    5.4989e-06,
                    5.6378e-06,
                    5.777e-06,
                    5.9179e-06,
                    6.0769e-06,
                    6.2375e-06,
                    6.3984e-06,
                    6.5592e-06,
                    6.7269e-06,
                    6.8859e-06,
                    7.0497e-06,
                    7.2149e-06,
                    7.3741e-06,
                    7.5413e-06,
                    7.7176e-06,
                    7.8961e-06,
                    8.0668e-06,
                    8.2314e-06,
                    8.3959e-06,
                    8.5603e-06,
                    8.7195e-06,
                    8.8829e-06,
                    9.0518e-06,
                    9.2163e-06,
                    9.3783e-06,
                    9.525e-06,
                    9.6692e-06,
                    9.822e-06,
                    9.975e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_N2O": 0.01,
                "Fossil_N2O_timeseries": [
                    2.6672e-09,
                    5.3645e-09,
                    8.0917e-09,
                    1.0848e-08,
                    1.3634e-08,
                    1.6447e-08,
                    1.9288e-08,
                    2.2156e-08,
                    2.5048e-08,
                    2.7965e-08,
                    3.0905e-08,
                    3.3869e-08,
                    3.6856e-08,
                    3.9865e-08,
                    4.2898e-08,
                    4.5954e-08,
                    4.9032e-08,
                    5.2134e-08,
                    5.5259e-08,
                    5.8407e-08,
                    6.1586e-08,
                    6.4805e-08,
                    6.8073e-08,
                    7.1395e-08,
                    7.4776e-08,
                    7.8215e-08,
                    8.1711e-08,
                    8.526e-08,
                    8.8856e-08,
                    9.2488e-08,
                    9.6151e-08,
                    9.9843e-08,
                    1.0356e-07,
                    1.0731e-07,
                    1.1109e-07,
                    1.1489e-07,
                    1.1872e-07,
                    1.2258e-07,
                    1.2646e-07,
                    1.3038e-07,
                    1.3433e-07,
                    1.383e-07,
                    1.4231e-07,
                    1.4635e-07,
                    1.5042e-07,
                    1.5453e-07,
                    1.5866e-07,
                    1.6283e-07,
                    1.6703e-07,
                    1.7127e-07,
                    1.7554e-07,
                    1.7986e-07,
                    1.8421e-07,
                    1.886e-07,
                    1.9304e-07,
                    1.9752e-07,
                    2.0205e-07,
                    2.0662e-07,
                    2.1123e-07,
                    2.1588e-07,
                    2.2058e-07,
                    2.2532e-07,
                    2.3009e-07,
                    2.3491e-07,
                    2.3978e-07,
                    2.4468e-07,
                    2.4963e-07,
                    2.5461e-07,
                    2.5964e-07,
                    2.6471e-07,
                    2.6982e-07,
                    2.7497e-07,
                    2.8016e-07,
                    2.8539e-07,
                    2.9067e-07,
                    2.9598e-07,
                    3.0134e-07,
                    3.0674e-07,
                    3.1217e-07,
                    3.1765e-07,
                    3.232e-07,
                    3.2889e-07,
                    3.3477e-07,
                    3.4087e-07,
                    3.4723e-07,
                    3.5387e-07,
                    3.6078e-07,
                    3.6798e-07,
                    3.7545e-07,
                    3.8316e-07,
                    3.9113e-07,
                    3.9941e-07,
                    4.0805e-07,
                    4.1708e-07,
                    4.2649e-07,
                    4.363e-07,
                    4.4647e-07,
                    4.5698e-07,
                    4.6777e-07,
                    4.7876e-07,
                    4.8993e-07,
                    5.0126e-07,
                    5.1274e-07,
                    5.2439e-07,
                    5.3619e-07,
                    5.4817e-07,
                    5.6032e-07,
                    5.7268e-07,
                    5.8526e-07,
                    5.9809e-07,
                    6.1138e-07,
                    6.255e-07,
                    6.4086e-07,
                    6.5785e-07,
                    6.7683e-07,
                    6.9822e-07,
                    7.2239e-07,
                    7.4973e-07,
                    7.8063e-07,
                    8.0842e-07,
                    8.3649e-07,
                    8.6609e-07,
                    8.9674e-07,
                    9.2428e-07,
                    9.5061e-07,
                    9.7841e-07,
                    1.0072e-06,
                    1.037e-06,
                    1.0678e-06,
                    1.0991e-06,
                    1.1304e-06,
                    1.1623e-06,
                    1.1951e-06,
                    1.2291e-06,
                    1.2641e-06,
                    1.3001e-06,
                    1.3397e-06,
                    1.3793e-06,
                    1.4206e-06,
                    1.4627e-06,
                    1.507e-06,
                    1.5526e-06,
                    1.5993e-06,
                    1.648e-06,
                    1.6971e-06,
                    1.7476e-06,
                    1.7992e-06,
                    1.8526e-06,
                    1.9071e-06,
                    1.9627e-06,
                    2.0187e-06,
                    2.0752e-06,
                    2.1344e-06,
                    2.1941e-06,
                    2.2578e-06,
                    2.3213e-06,
                    2.3863e-06,
                    2.4511e-06,
                    2.5148e-06,
                    2.5778e-06,
                    2.6403e-06,
                    2.7004e-06,
                    2.7572e-06,
                    2.8145e-06,
                    2.8738e-06,
                    2.9345e-06,
                    2.9961e-06,
                    3.0579e-06,
                    3.1186e-06,
                    3.1783e-06,
                    3.2405e-06,
                    3.3034e-06
                ],
                "Land_N2O": 0.01,
                "Land_N2O_timeseries": [
                    4.7538e-09,
                    9.6027e-09,
                    1.4543e-08,
                    1.9568e-08,
                    2.4671e-08,
                    2.9844e-08,
                    3.5075e-08,
                    4.0354e-08,
                    4.5666e-08,
                    5.0997e-08,
                    5.6337e-08,
                    6.1684e-08,
                    6.7036e-08,
                    7.2391e-08,
                    7.7749e-08,
                    8.3111e-08,
                    8.8477e-08,
                    9.3848e-08,
                    9.9226e-08,
                    1.0461e-07,
                    1.1009e-07,
                    1.158e-07,
                    1.2184e-07,
                    1.2829e-07,
                    1.3519e-07,
                    1.4255e-07,
                    1.5034e-07,
                    1.5852e-07,
                    1.67e-07,
                    1.7567e-07,
                    1.8443e-07,
                    1.9328e-07,
                    2.0221e-07,
                    2.1119e-07,
                    2.2023e-07,
                    2.2933e-07,
                    2.3848e-07,
                    2.4768e-07,
                    2.5695e-07,
                    2.6665e-07,
                    2.7637e-07,
                    2.8611e-07,
                    2.9588e-07,
                    3.0568e-07,
                    3.1551e-07,
                    3.2539e-07,
                    3.3531e-07,
                    3.4528e-07,
                    3.553e-07,
                    3.6537e-07,
                    3.7549e-07,
                    3.8569e-07,
                    3.9596e-07,
                    4.0631e-07,
                    4.1676e-07,
                    4.273e-07,
                    4.3794e-07,
                    4.4868e-07,
                    4.5951e-07,
                    4.7044e-07,
                    4.8146e-07,
                    4.9255e-07,
                    5.0373e-07,
                    5.1497e-07,
                    5.263e-07,
                    5.3771e-07,
                    5.4923e-07,
                    5.6086e-07,
                    5.7264e-07,
                    5.8458e-07,
                    5.9683e-07,
                    6.0961e-07,
                    6.2313e-07,
                    6.3751e-07,
                    6.5285e-07,
                    6.692e-07,
                    6.8658e-07,
                    7.0494e-07,
                    7.242e-07,
                    7.4424e-07,
                    7.6495e-07,
                    7.863e-07,
                    8.0826e-07,
                    8.308e-07,
                    8.5393e-07,
                    8.7763e-07,
                    9.0191e-07,
                    9.2679e-07,
                    9.5229e-07,
                    9.7846e-07,
                    1.0057e-06,
                    1.0345e-06,
                    1.0655e-06,
                    1.0989e-06,
                    1.135e-06,
                    1.1737e-06,
                    1.215e-06,
                    1.2587e-06,
                    1.3044e-06,
                    1.3515e-06,
                    1.3999e-06,
                    1.4498e-06,
                    1.5015e-06,
                    1.555e-06,
                    1.6103e-06,
                    1.6674e-06,
                    1.7261e-06,
                    1.7862e-06,
                    1.8474e-06,
                    1.9092e-06,
                    1.9704e-06,
                    2.0358e-06,
                    2.1078e-06,
                    2.1666e-06,
                    2.2395e-06,
                    2.3106e-06,
                    2.3847e-06,
                    2.4754e-06,
                    2.5643e-06,
                    2.6635e-06,
                    2.765e-06,
                    2.872e-06,
                    2.9844e-06,
                    3.0683e-06,
                    3.1239e-06,
                    3.1862e-06,
                    3.2449e-06,
                    3.312e-06,
                    3.3811e-06,
                    3.448e-06,
                    3.5195e-06,
                    3.6001e-06,
                    3.6803e-06,
                    3.7646e-06,
                    3.8497e-06,
                    3.9343e-06,
                    4.0249e-06,
                    4.1197e-06,
                    4.2173e-06,
                    4.3143e-06,
                    4.4109e-06,
                    4.5244e-06,
                    4.6382e-06,
                    4.7504e-06,
                    4.8621e-06,
                    4.9793e-06,
                    5.0867e-06,
                    5.1971e-06,
                    5.3077e-06,
                    5.4113e-06,
                    5.5227e-06,
                    5.6424e-06,
                    5.7616e-06,
                    5.8728e-06,
                    5.9736e-06,
                    6.0746e-06,
                    6.174e-06,
                    6.2683e-06,
                    6.3682e-06,
                    6.4741e-06,
                    6.5761e-06,
                    6.6778e-06,
                    6.7678e-06,
                    6.8547e-06,
                    6.9483e-06,
                    7.0405e-06,
                    7.1354e-06,
                    7.231e-06,
                    7.3285e-06,
                    7.4299e-06,
                    7.5296e-06,
                    7.6319e-06
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            34.58451,
                            35.69436
                        ],
                        [
                            34.34839,
                            35.62132
                        ],
                        [
                            34.28828,
                            35.57584
                        ],
                        [
                            34.1734,
                            35.55911
                        ],
                        [
                            34.12855,
                            35.50783
                        ],
                        [
                            33.98077,
                            35.44791
                        ],
                        [
                            33.85042,
                            35.41305
                        ],
                        [
                            33.77194,
                            35.41335
                        ],
                        [
                            33.6526,
                            35.35919
                        ],
                        [
                            33.48237,
                            35.33241
                        ],
                        [
                            33.09508,
                            35.35381
                        ],
                        [
                            32.99316,
                            35.36846
                        ],
                        [
                            32.92147,
                            35.40285
                        ],
                        [
                            32.93491,
                            35.2684
                        ],
                        [
                            32.8952,
                            35.17285
                        ],
                        [
                            32.82498,
                            35.14118
                        ],
                        [
                            32.64953,
                            35.19533
                        ],
                        [
                            32.55102,
                            35.175
                        ],
                        [
                            32.48892,
                            35.08523
                        ],
                        [
                            32.31302,
                            34.99573
                        ],
                        [
                            32.31784,
                            34.89789
                        ],
                        [
                            32.38924,
                            34.83763
                        ],
                        [
                            32.40592,
                            34.76582
                        ],
                        [
                            32.49484,
                            34.70363
                        ],
                        [
                            32.55711,
                            34.69622
                        ],
                        [
                            32.70456,
                            34.64097
                        ],
                        [
                            32.87453,
                            34.66654
                        ],
                        [
                            32.93666,
                            34.56839
                        ],
                        [
                            33.00917,
                            34.5946
                        ],
                        [
                            33.03016,
                            34.66566
                        ],
                        [
                            33.14827,
                            34.71225
                        ],
                        [
                            33.2581,
                            34.70546
                        ],
                        [
                            33.60197,
                            34.81619
                        ],
                        [
                            33.63834,
                            34.86614
                        ],
                        [
                            33.64189,
                            34.93426
                        ],
                        [
                            33.69803,
                            34.97774
                        ],
                        [
                            33.77721,
                            34.97917
                        ],
                        [
                            33.84844,
                            34.94792
                        ],
                        [
                            33.97075,
                            34.9875
                        ],
                        [
                            34.07654,
                            34.98803
                        ],
                        [
                            33.91519,
                            35.1598
                        ],
                        [
                            33.90656,
                            35.25627
                        ],
                        [
                            33.9647,
                            35.32019
                        ],
                        [
                            34.06317,
                            35.32757
                        ],
                        [
                            34.08034,
                            35.36697
                        ],
                        [
                            34.17303,
                            35.43854
                        ],
                        [
                            34.28192,
                            35.48002
                        ],
                        [
                            34.40873,
                            35.55882
                        ],
                        [
                            34.46725,
                            35.6159
                        ],
                        [
                            34.56207,
                            35.64273
                        ],
                        [
                            34.58451,
                            35.69436
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "CZE",
                "Country": "Czechia",
                "Total_3GHG": 0.36,
                "Total_3GHG_timeseries": [
                    6.6931e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0046,
                    0.0047,
                    0.0047,
                    0.0048,
                    0.0048,
                    0.0049,
                    0.0049,
                    0.005,
                    0.005,
                    0.005,
                    0.0051,
                    0.0051,
                    0.0051,
                    0.0052,
                    0.0052,
                    0.0052,
                    0.0053,
                    0.0053,
                    0.0053,
                    0.0054,
                    0.0054,
                    0.0055,
                    0.0055,
                    0.0055,
                    0.0056,
                    0.0056,
                    0.0056,
                    0.0057,
                    0.0057,
                    0.0058,
                    0.0058,
                    0.0058
                ],
                "Fossil_3GHG": 0.57,
                "Fossil_3GHG_timeseries": [
                    1.7292e-06,
                    3.4239e-06,
                    5.0845e-06,
                    6.7116e-06,
                    8.3057e-06,
                    9.8671e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0046,
                    0.0047,
                    0.0047,
                    0.0048,
                    0.0048,
                    0.0049,
                    0.0049,
                    0.005,
                    0.005,
                    0.0051,
                    0.0051,
                    0.0052,
                    0.0052,
                    0.0053,
                    0.0053,
                    0.0054,
                    0.0054,
                    0.0055,
                    0.0055,
                    0.0056,
                    0.0056,
                    0.0057,
                    0.0057,
                    0.0058,
                    0.0058,
                    0.0059,
                    0.0059,
                    0.006,
                    0.006,
                    0.0061
                ],
                "Land_3GHG": -0.04,
                "Land_3GHG_timeseries": [
                    4.964e-06,
                    9.8607e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0,
                    0,
                    0,
                    0,
                    -0.00000098428,
                    0,
                    0,
                    0,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002
                ],
                "Total_CO2": 0.44,
                "Total_CO2_timeseries": [
                    3.0827e-06,
                    6.1319e-06,
                    9.1297e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.004,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0045,
                    0.0046,
                    0.0046,
                    0.0046,
                    0.0047,
                    0.0047,
                    0.0048,
                    0.0048,
                    0.0048,
                    0.0049,
                    0.0049,
                    0.005,
                    0.005,
                    0.005
                ],
                "Fossil_CO2": 0.71,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    9.114e-08,
                    3.9078e-07,
                    9.0017e-07,
                    1.6193e-06,
                    2.5482e-06,
                    3.6868e-06,
                    5.0352e-06,
                    6.5921e-06,
                    8.3587e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.004,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0045,
                    0.0046,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0048,
                    0.0049,
                    0.0049,
                    0.005,
                    0.005,
                    0.0051,
                    0.0051,
                    0.0052,
                    0.0052,
                    0.0053,
                    0.0053,
                    0.0054,
                    0.0054,
                    0.0054,
                    0.0055
                ],
                "Land_CO2": -0.13,
                "Land_CO2_timeseries": [
                    3.0827e-06,
                    6.1319e-06,
                    9.1297e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    3.5569e-06,
                    -0.000001904,
                    -0.0000087555,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004
                ],
                "Total_CH4": 0.13,
                "Total_CH4_timeseries": [
                    3.4143e-06,
                    6.7577e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Fossil_CH4": 0.17,
                "Fossil_CH4_timeseries": [
                    1.5908e-06,
                    3.1455e-06,
                    4.6648e-06,
                    6.149e-06,
                    7.5987e-06,
                    9.0143e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Land_CH4": 0.07,
                "Land_CH4_timeseries": [
                    1.8235e-06,
                    3.6122e-06,
                    5.366e-06,
                    7.0851e-06,
                    8.7694e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_N2O": 0.32,
                "Total_N2O_timeseries": [
                    1.9615e-07,
                    3.9497e-07,
                    5.9638e-07,
                    8.003e-07,
                    1.0066e-06,
                    1.2152e-06,
                    1.426e-06,
                    1.6386e-06,
                    1.853e-06,
                    2.069e-06,
                    2.2863e-06,
                    2.5049e-06,
                    2.7249e-06,
                    2.9461e-06,
                    3.1686e-06,
                    3.3925e-06,
                    3.6176e-06,
                    3.844e-06,
                    4.0718e-06,
                    4.301e-06,
                    4.5327e-06,
                    4.7692e-06,
                    5.0118e-06,
                    5.2618e-06,
                    5.5197e-06,
                    5.7857e-06,
                    6.0595e-06,
                    6.3403e-06,
                    6.6268e-06,
                    6.9172e-06,
                    7.2104e-06,
                    7.5062e-06,
                    7.8042e-06,
                    8.1045e-06,
                    8.4068e-06,
                    8.7111e-06,
                    9.0175e-06,
                    9.326e-06,
                    9.6366e-06,
                    9.9632e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_N2O": 0.55,
                "Fossil_N2O_timeseries": [
                    1.3841e-07,
                    2.7833e-07,
                    4.1974e-07,
                    5.6263e-07,
                    7.0697e-07,
                    8.5275e-07,
                    9.9993e-07,
                    1.1485e-06,
                    1.2984e-06,
                    1.4495e-06,
                    1.602e-06,
                    1.7557e-06,
                    1.9106e-06,
                    2.0668e-06,
                    2.2243e-06,
                    2.383e-06,
                    2.5429e-06,
                    2.7041e-06,
                    2.8666e-06,
                    3.0303e-06,
                    3.1955e-06,
                    3.3626e-06,
                    3.5319e-06,
                    3.7035e-06,
                    3.8776e-06,
                    4.0543e-06,
                    4.2334e-06,
                    4.4148e-06,
                    4.5983e-06,
                    4.7835e-06,
                    4.9703e-06,
                    5.1585e-06,
                    5.3482e-06,
                    5.5393e-06,
                    5.7318e-06,
                    5.9256e-06,
                    6.1209e-06,
                    6.3175e-06,
                    6.5156e-06,
                    6.7172e-06,
                    6.9207e-06,
                    7.1263e-06,
                    7.3338e-06,
                    7.5435e-06,
                    7.7554e-06,
                    7.9694e-06,
                    8.1857e-06,
                    8.4042e-06,
                    8.6251e-06,
                    8.8484e-06,
                    9.0741e-06,
                    9.3026e-06,
                    9.5339e-06,
                    9.7681e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_N2O": 0.24,
                "Land_N2O_timeseries": [
                    5.7742e-08,
                    1.1664e-07,
                    1.7664e-07,
                    2.3768e-07,
                    2.9966e-07,
                    3.6249e-07,
                    4.2604e-07,
                    4.9015e-07,
                    5.5468e-07,
                    6.1943e-07,
                    6.8429e-07,
                    7.4923e-07,
                    8.1424e-07,
                    8.7928e-07,
                    9.4437e-07,
                    1.0095e-06,
                    1.0747e-06,
                    1.1399e-06,
                    1.2052e-06,
                    1.2707e-06,
                    1.3372e-06,
                    1.4065e-06,
                    1.4799e-06,
                    1.5582e-06,
                    1.642e-06,
                    1.7314e-06,
                    1.8261e-06,
                    1.9255e-06,
                    2.0285e-06,
                    2.1337e-06,
                    2.2402e-06,
                    2.3477e-06,
                    2.4561e-06,
                    2.5652e-06,
                    2.675e-06,
                    2.7855e-06,
                    2.8966e-06,
                    3.0084e-06,
                    3.121e-06,
                    3.246e-06,
                    3.3629e-06,
                    3.4722e-06,
                    3.5742e-06,
                    3.6696e-06,
                    3.759e-06,
                    3.8432e-06,
                    3.9232e-06,
                    4e-06,
                    4.0748e-06,
                    4.149e-06,
                    4.2232e-06,
                    4.2978e-06,
                    4.373e-06,
                    4.4489e-06,
                    4.5258e-06,
                    4.6039e-06,
                    4.6834e-06,
                    4.7644e-06,
                    4.8471e-06,
                    4.9317e-06,
                    5.0206e-06,
                    5.118e-06,
                    5.2276e-06,
                    5.3524e-06,
                    5.4949e-06,
                    5.657e-06,
                    5.8399e-06,
                    6.0443e-06,
                    6.2704e-06,
                    6.5175e-06,
                    6.7893e-06,
                    7.0923e-06,
                    7.4308e-06,
                    7.8072e-06,
                    8.2215e-06,
                    8.6717e-06,
                    9.1536e-06,
                    9.6607e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            14.82336,
                            50.87055
                        ],
                        [
                            14.76753,
                            50.81977
                        ],
                        [
                            14.6188,
                            50.8578
                        ],
                        [
                            14.64732,
                            50.93153
                        ],
                        [
                            14.59879,
                            50.98624
                        ],
                        [
                            14.45429,
                            51.03562
                        ],
                        [
                            14.30141,
                            51.05442
                        ],
                        [
                            14.25853,
                            50.98799
                        ],
                        [
                            14.40214,
                            50.92407
                        ],
                        [
                            14.3045,
                            50.88423
                        ],
                        [
                            14.03068,
                            50.80443
                        ],
                        [
                            13.99004,
                            50.81917
                        ],
                        [
                            13.8569,
                            50.72843
                        ],
                        [
                            13.66731,
                            50.73129
                        ],
                        [
                            13.52572,
                            50.70307
                        ],
                        [
                            13.54057,
                            50.6696
                        ],
                        [
                            13.46272,
                            50.60183
                        ],
                        [
                            13.40537,
                            50.63372
                        ],
                        [
                            13.25441,
                            50.59488
                        ],
                        [
                            13.19336,
                            50.50317
                        ],
                        [
                            13.03169,
                            50.50884
                        ],
                        [
                            13.02223,
                            50.4514
                        ],
                        [
                            12.94272,
                            50.4114
                        ],
                        [
                            12.82329,
                            50.45796
                        ],
                        [
                            12.70837,
                            50.4083
                        ],
                        [
                            12.51423,
                            50.39734
                        ],
                        [
                            12.33334,
                            50.24168
                        ],
                        [
                            12.29142,
                            50.22105
                        ],
                        [
                            12.14692,
                            50.32155
                        ],
                        [
                            12.10975,
                            50.23826
                        ],
                        [
                            12.21513,
                            50.16645
                        ],
                        [
                            12.20157,
                            50.10889
                        ],
                        [
                            12.27992,
                            50.05568
                        ],
                        [
                            12.49933,
                            49.97198
                        ],
                        [
                            12.55099,
                            49.90509
                        ],
                        [
                            12.40483,
                            49.76231
                        ],
                        [
                            12.44149,
                            49.70509
                        ],
                        [
                            12.5216,
                            49.68585
                        ],
                        [
                            12.58988,
                            49.53805
                        ],
                        [
                            12.64418,
                            49.52306
                        ],
                        [
                            12.65589,
                            49.43455
                        ],
                        [
                            12.75729,
                            49.39443
                        ],
                        [
                            12.80208,
                            49.34184
                        ],
                        [
                            12.94581,
                            49.34364
                        ],
                        [
                            13.02864,
                            49.30377
                        ],
                        [
                            13.23595,
                            49.11373
                        ],
                        [
                            13.34378,
                            49.08862
                        ],
                        [
                            13.40301,
                            48.98817
                        ],
                        [
                            13.58304,
                            48.96967
                        ],
                        [
                            13.67385,
                            48.87985
                        ],
                        [
                            13.75012,
                            48.86677
                        ],
                        [
                            13.83951,
                            48.7716
                        ],
                        [
                            14.00445,
                            48.70777
                        ],
                        [
                            14.05465,
                            48.60525
                        ],
                        [
                            14.18293,
                            48.59353
                        ],
                        [
                            14.34141,
                            48.55468
                        ],
                        [
                            14.42934,
                            48.58898
                        ],
                        [
                            14.46916,
                            48.64647
                        ],
                        [
                            14.55488,
                            48.60576
                        ],
                        [
                            14.61344,
                            48.62621
                        ],
                        [
                            14.72031,
                            48.60225
                        ],
                        [
                            14.73668,
                            48.69879
                        ],
                        [
                            14.80895,
                            48.77796
                        ],
                        [
                            14.95326,
                            48.78978
                        ],
                        [
                            14.99156,
                            48.89731
                        ],
                        [
                            15.00538,
                            49.01277
                        ],
                        [
                            15.13292,
                            48.99996
                        ],
                        [
                            15.19048,
                            48.9437
                        ],
                        [
                            15.29186,
                            48.98429
                        ],
                        [
                            15.46853,
                            48.95114
                        ],
                        [
                            15.51294,
                            48.91473
                        ],
                        [
                            15.61356,
                            48.89763
                        ],
                        [
                            15.68683,
                            48.85733
                        ],
                        [
                            15.7802,
                            48.87451
                        ],
                        [
                            15.87811,
                            48.85807
                        ],
                        [
                            15.99551,
                            48.77899
                        ],
                        [
                            16.08034,
                            48.7498
                        ],
                        [
                            16.38081,
                            48.72971
                        ],
                        [
                            16.4487,
                            48.79938
                        ],
                        [
                            16.54075,
                            48.81428
                        ],
                        [
                            16.67575,
                            48.76966
                        ],
                        [
                            16.77514,
                            48.71246
                        ],
                        [
                            16.90216,
                            48.71705
                        ],
                        [
                            16.94028,
                            48.61725
                        ],
                        [
                            17.04594,
                            48.76618
                        ],
                        [
                            17.19345,
                            48.87503
                        ],
                        [
                            17.3618,
                            48.81362
                        ],
                        [
                            17.45177,
                            48.84588
                        ],
                        [
                            17.52041,
                            48.8129
                        ],
                        [
                            17.70321,
                            48.86023
                        ],
                        [
                            17.78295,
                            48.92496
                        ],
                        [
                            17.88491,
                            48.92775
                        ],
                        [
                            17.91258,
                            49.00724
                        ],
                        [
                            18.0689,
                            49.03726
                        ],
                        [
                            18.11545,
                            49.09266
                        ],
                        [
                            18.14706,
                            49.24637
                        ],
                        [
                            18.18419,
                            49.28672
                        ],
                        [
                            18.379,
                            49.33098
                        ],
                        [
                            18.40838,
                            49.38979
                        ],
                        [
                            18.47584,
                            49.40926
                        ],
                        [
                            18.54568,
                            49.50026
                        ],
                        [
                            18.85155,
                            49.51719
                        ],
                        [
                            18.80699,
                            49.65114
                        ],
                        [
                            18.62647,
                            49.7228
                        ],
                        [
                            18.56958,
                            49.83365
                        ],
                        [
                            18.60292,
                            49.85723
                        ],
                        [
                            18.42999,
                            49.93782
                        ],
                        [
                            18.03374,
                            50.01079
                        ],
                        [
                            17.86174,
                            49.97976
                        ],
                        [
                            17.77877,
                            50.02017
                        ],
                        [
                            17.73092,
                            50.09717
                        ],
                        [
                            17.61036,
                            50.14083
                        ],
                        [
                            17.60434,
                            50.17048
                        ],
                        [
                            17.75778,
                            50.20701
                        ],
                        [
                            17.7184,
                            50.32095
                        ],
                        [
                            17.61732,
                            50.26695
                        ],
                        [
                            17.34241,
                            50.28044
                        ],
                        [
                            17.18497,
                            50.3895
                        ],
                        [
                            16.97457,
                            50.41846
                        ],
                        [
                            16.91019,
                            50.38933
                        ],
                        [
                            16.94736,
                            50.31518
                        ],
                        [
                            17.01927,
                            50.27818
                        ],
                        [
                            16.99735,
                            50.21759
                        ],
                        [
                            16.91792,
                            50.22594
                        ],
                        [
                            16.80107,
                            50.17998
                        ],
                        [
                            16.72028,
                            50.10295
                        ],
                        [
                            16.63419,
                            50.11187
                        ],
                        [
                            16.562,
                            50.16408
                        ],
                        [
                            16.55656,
                            50.22028
                        ],
                        [
                            16.36099,
                            50.37924
                        ],
                        [
                            16.22186,
                            50.40692
                        ],
                        [
                            16.20505,
                            50.44842
                        ],
                        [
                            16.34415,
                            50.49689
                        ],
                        [
                            16.44492,
                            50.57957
                        ],
                        [
                            16.34087,
                            50.66205
                        ],
                        [
                            16.23347,
                            50.67039
                        ],
                        [
                            16.00208,
                            50.6445
                        ],
                        [
                            15.96675,
                            50.69151
                        ],
                        [
                            15.86285,
                            50.68115
                        ],
                        [
                            15.81601,
                            50.75472
                        ],
                        [
                            15.74013,
                            50.73614
                        ],
                        [
                            15.60374,
                            50.77619
                        ],
                        [
                            15.52438,
                            50.77761
                        ],
                        [
                            15.37416,
                            50.82147
                        ],
                        [
                            15.26737,
                            50.92024
                        ],
                        [
                            15.23706,
                            50.99826
                        ],
                        [
                            15.10463,
                            50.9921
                        ],
                        [
                            14.985,
                            51.01091
                        ],
                        [
                            15.01433,
                            50.93981
                        ],
                        [
                            15.00195,
                            50.87018
                        ],
                        [
                            14.82336,
                            50.87055
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "CIV",
                "Country": "C\xf4te D\u2019Ivoire",
                "Total_3GHG": 0.3,
                "Total_3GHG_timeseries": [
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.004,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0045,
                    0.0046,
                    0.0046,
                    0.0047,
                    0.0047,
                    0.0047,
                    0.0048,
                    0.0048,
                    0.0049
                ],
                "Fossil_3GHG": 0.06,
                "Fossil_3GHG_timeseries": [
                    -0.000000016628,
                    -0.000000028774,
                    -0.000000036421,
                    -0.000000039555,
                    -0.000000038164,
                    -0.000000032237,
                    -0.000000021763,
                    -0.000000006736,
                    1.2851e-08,
                    3.7001e-08,
                    6.8138e-08,
                    1.0627e-07,
                    4.377e-07,
                    7.7737e-07,
                    1.1253e-06,
                    1.4814e-06,
                    1.8457e-06,
                    2.2182e-06,
                    2.5989e-06,
                    2.9878e-06,
                    3.3814e-06,
                    3.7798e-06,
                    4.183e-06,
                    4.591e-06,
                    5.0038e-06,
                    5.4215e-06,
                    5.8439e-06,
                    6.271e-06,
                    6.7028e-06,
                    7.1391e-06,
                    7.5781e-06,
                    8.0199e-06,
                    8.196e-06,
                    8.3736e-06,
                    8.5527e-06,
                    8.7333e-06,
                    8.9155e-06,
                    9.0991e-06,
                    9.2843e-06,
                    9.4712e-06,
                    9.6599e-06,
                    9.8504e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    9.8451e-06,
                    9.6416e-06,
                    9.4213e-06,
                    9.1848e-06,
                    8.9837e-06,
                    8.8234e-06,
                    8.6884e-06,
                    8.5808e-06,
                    8.5064e-06,
                    8.4563e-06,
                    8.4317e-06,
                    8.434e-06,
                    8.4598e-06,
                    8.5888e-06,
                    8.8131e-06,
                    9.1258e-06,
                    9.5212e-06,
                    9.9943e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006
                ],
                "Land_3GHG": 0.73,
                "Land_3GHG_timeseries": [
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.004,
                    0.004,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0042,
                    0.0042
                ],
                "Total_CO2": 0.37,
                "Total_CO2_timeseries": [
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.004,
                    0.004,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0041,
                    0.0041,
                    0.0042
                ],
                "Fossil_CO2": 0.02,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2.4824e-07,
                    4.5581e-07,
                    6.8793e-07,
                    8.8077e-07,
                    1.108e-06,
                    1.3345e-06,
                    1.5967e-06,
                    1.8653e-06,
                    2.0897e-06,
                    2.3356e-06,
                    2.5435e-06,
                    2.7926e-06,
                    3.0566e-06,
                    3.3371e-06,
                    3.6803e-06,
                    4.2083e-06,
                    4.766e-06,
                    5.3782e-06,
                    6.0976e-06,
                    6.949e-06,
                    7.9588e-06,
                    9.0643e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_CO2": 1.11,
                "Land_CO2_timeseries": [
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.004,
                    0.004,
                    0.004
                ],
                "Total_CH4": 0.15,
                "Total_CH4_timeseries": [
                    -0.000000034354,
                    -0.000000064191,
                    -0.000000089492,
                    -0.00000011024,
                    -0.00000012642,
                    -0.00000013801,
                    -0.00000014499,
                    -0.00000014737,
                    -0.00000014511,
                    -0.0000001382,
                    -0.00000012083,
                    -0.000000092987,
                    2.3163e-07,
                    5.6797e-07,
                    9.1601e-07,
                    1.2757e-06,
                    1.6472e-06,
                    2.0303e-06,
                    2.4251e-06,
                    2.8315e-06,
                    3.2462e-06,
                    3.6692e-06,
                    4.1003e-06,
                    4.5397e-06,
                    4.9872e-06,
                    5.4428e-06,
                    5.9065e-06,
                    6.3783e-06,
                    6.8582e-06,
                    7.3462e-06,
                    7.8374e-06,
                    8.3318e-06,
                    8.561e-06,
                    8.7923e-06,
                    9.0257e-06,
                    9.2611e-06,
                    9.4985e-06,
                    9.738e-06,
                    9.9795e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006
                ],
                "Fossil_CH4": 0.17,
                "Fossil_CH4_timeseries": [
                    -0.000000019583,
                    -0.000000034742,
                    -0.000000045458,
                    -0.000000051714,
                    -0.000000053492,
                    -0.000000050776,
                    -0.000000043551,
                    -0.000000031801,
                    -0.000000015513,
                    5.3267e-09,
                    3.3146e-08,
                    6.7958e-08,
                    3.9606e-07,
                    7.324e-07,
                    1.077e-06,
                    1.4297e-06,
                    1.7907e-06,
                    2.1599e-06,
                    2.5372e-06,
                    2.9228e-06,
                    3.313e-06,
                    3.7078e-06,
                    4.1073e-06,
                    4.5113e-06,
                    4.9198e-06,
                    5.3329e-06,
                    5.7505e-06,
                    6.1726e-06,
                    6.5991e-06,
                    7.0301e-06,
                    7.4638e-06,
                    7.9001e-06,
                    8.0707e-06,
                    8.2427e-06,
                    8.4163e-06,
                    8.5913e-06,
                    8.7678e-06,
                    8.9458e-06,
                    9.1252e-06,
                    9.3062e-06,
                    9.4887e-06,
                    9.6728e-06,
                    9.8586e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    9.9591e-06,
                    9.7825e-06,
                    9.5879e-06,
                    9.3758e-06,
                    9.1467e-06,
                    8.9011e-06,
                    8.6905e-06,
                    8.5206e-06,
                    8.3756e-06,
                    8.258e-06,
                    8.1732e-06,
                    8.1127e-06,
                    8.0775e-06,
                    8.0689e-06,
                    8.0838e-06,
                    8.2017e-06,
                    8.4148e-06,
                    8.7162e-06,
                    9.1001e-06,
                    9.5615e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Land_CH4": 0.1,
                "Land_CH4_timeseries": [
                    -0.000000014771,
                    -0.000000029448,
                    -0.000000044033,
                    -0.000000058525,
                    -0.000000072924,
                    -0.000000087231,
                    -0.00000010144,
                    -0.00000011556,
                    -0.00000012959,
                    -0.00000014353,
                    -0.00000015398,
                    -0.00000016094,
                    -0.00000016443,
                    -0.00000016443,
                    -0.00000016094,
                    -0.00000015398,
                    -0.00000014353,
                    -0.00000012959,
                    -0.00000011217,
                    -0.000000091272,
                    -0.000000066764,
                    -0.000000038651,
                    -0.0000000069325,
                    2.8392e-08,
                    6.7322e-08,
                    1.0986e-07,
                    1.56e-07,
                    2.0574e-07,
                    2.591e-07,
                    3.1605e-07,
                    3.7358e-07,
                    4.3168e-07,
                    4.9034e-07,
                    5.4958e-07,
                    6.0939e-07,
                    6.6976e-07,
                    7.3071e-07,
                    7.9222e-07,
                    8.543e-07,
                    9.1696e-07,
                    9.8024e-07,
                    1.0441e-06,
                    1.1087e-06,
                    1.1738e-06,
                    1.2396e-06,
                    1.306e-06,
                    1.3731e-06,
                    1.4407e-06,
                    1.509e-06,
                    1.578e-06,
                    1.6484e-06,
                    1.7203e-06,
                    1.7938e-06,
                    1.8687e-06,
                    1.9452e-06,
                    2.0232e-06,
                    2.1027e-06,
                    2.1837e-06,
                    2.2662e-06,
                    2.3502e-06,
                    2.4409e-06,
                    2.5382e-06,
                    2.6421e-06,
                    2.7527e-06,
                    2.8698e-06,
                    2.9936e-06,
                    3.1241e-06,
                    3.2611e-06,
                    3.4048e-06,
                    3.5552e-06,
                    3.7132e-06,
                    3.8789e-06,
                    4.0523e-06,
                    4.2335e-06,
                    4.4223e-06,
                    4.6188e-06,
                    4.8231e-06,
                    5.035e-06,
                    5.2547e-06,
                    5.482e-06,
                    5.7147e-06,
                    5.9526e-06,
                    6.1959e-06,
                    6.4445e-06,
                    6.6984e-06,
                    6.997e-06,
                    7.3421e-06,
                    7.7353e-06,
                    8.1785e-06,
                    8.6734e-06,
                    9.2242e-06,
                    9.8331e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Total_N2O": 0.1,
                "Total_N2O_timeseries": [
                    3.2475e-08,
                    6.5598e-08,
                    9.9342e-08,
                    1.3367e-07,
                    1.6853e-07,
                    2.0386e-07,
                    2.396e-07,
                    2.7565e-07,
                    3.1194e-07,
                    3.4835e-07,
                    3.8483e-07,
                    4.2135e-07,
                    4.5791e-07,
                    4.9449e-07,
                    5.311e-07,
                    5.6773e-07,
                    6.0439e-07,
                    6.4108e-07,
                    6.7783e-07,
                    7.1464e-07,
                    7.5207e-07,
                    7.9106e-07,
                    8.3232e-07,
                    8.7636e-07,
                    9.2346e-07,
                    9.7371e-07,
                    1.0269e-06,
                    1.0828e-06,
                    1.1407e-06,
                    1.1998e-06,
                    1.2596e-06,
                    1.32e-06,
                    1.3809e-06,
                    1.4423e-06,
                    1.504e-06,
                    1.5661e-06,
                    1.6285e-06,
                    1.6913e-06,
                    1.7546e-06,
                    1.8212e-06,
                    1.8885e-06,
                    1.9565e-06,
                    2.0253e-06,
                    2.0949e-06,
                    2.1653e-06,
                    2.2366e-06,
                    2.3088e-06,
                    2.3818e-06,
                    2.4559e-06,
                    2.5309e-06,
                    2.6069e-06,
                    2.6839e-06,
                    2.7618e-06,
                    2.8409e-06,
                    2.921e-06,
                    3.0023e-06,
                    3.0848e-06,
                    3.1688e-06,
                    3.2542e-06,
                    3.3413e-06,
                    3.4307e-06,
                    3.5235e-06,
                    3.6206e-06,
                    3.7226e-06,
                    3.8301e-06,
                    3.9433e-06,
                    4.0625e-06,
                    4.1874e-06,
                    4.318e-06,
                    4.4536e-06,
                    4.5946e-06,
                    4.7414e-06,
                    4.8945e-06,
                    5.0539e-06,
                    5.2194e-06,
                    5.3907e-06,
                    5.5669e-06,
                    5.7472e-06,
                    5.9302e-06,
                    6.1144e-06,
                    6.2983e-06,
                    6.4808e-06,
                    6.6609e-06,
                    6.8382e-06,
                    7.0123e-06,
                    7.1833e-06,
                    7.3515e-06,
                    7.5176e-06,
                    7.6825e-06,
                    7.8473e-06,
                    8.0279e-06,
                    8.2505e-06,
                    8.5344e-06,
                    8.8929e-06,
                    9.3327e-06,
                    9.854e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_N2O": 0.05,
                "Fossil_N2O_timeseries": [
                    2.955e-09,
                    5.9682e-09,
                    9.0371e-09,
                    1.2158e-08,
                    1.5328e-08,
                    1.8539e-08,
                    2.1788e-08,
                    2.5065e-08,
                    2.8364e-08,
                    3.1675e-08,
                    3.4992e-08,
                    3.8314e-08,
                    4.164e-08,
                    4.4969e-08,
                    4.8301e-08,
                    5.1636e-08,
                    5.4974e-08,
                    5.8316e-08,
                    6.1664e-08,
                    6.5018e-08,
                    6.8428e-08,
                    7.1976e-08,
                    7.5726e-08,
                    7.9723e-08,
                    8.3991e-08,
                    8.8538e-08,
                    9.335e-08,
                    9.8394e-08,
                    1.0362e-07,
                    1.0895e-07,
                    1.1435e-07,
                    1.198e-07,
                    1.253e-07,
                    1.3083e-07,
                    1.364e-07,
                    1.42e-07,
                    1.4764e-07,
                    1.5331e-07,
                    1.5902e-07,
                    1.6506e-07,
                    1.7122e-07,
                    1.7751e-07,
                    1.8392e-07,
                    1.9048e-07,
                    1.9718e-07,
                    2.0404e-07,
                    2.1107e-07,
                    2.1826e-07,
                    2.2563e-07,
                    2.3318e-07,
                    2.4095e-07,
                    2.4895e-07,
                    2.5722e-07,
                    2.6578e-07,
                    2.7462e-07,
                    2.8375e-07,
                    2.9316e-07,
                    3.0284e-07,
                    3.1275e-07,
                    3.2288e-07,
                    3.3318e-07,
                    3.4365e-07,
                    3.5427e-07,
                    3.6505e-07,
                    3.7598e-07,
                    3.8705e-07,
                    3.9827e-07,
                    4.0964e-07,
                    4.2116e-07,
                    4.3284e-07,
                    4.4468e-07,
                    4.5668e-07,
                    4.6884e-07,
                    4.8117e-07,
                    4.9365e-07,
                    5.0631e-07,
                    5.1915e-07,
                    5.3217e-07,
                    5.4538e-07,
                    5.5881e-07,
                    5.7248e-07,
                    5.8643e-07,
                    6.0073e-07,
                    6.1539e-07,
                    6.3047e-07,
                    6.4598e-07,
                    6.6196e-07,
                    6.7841e-07,
                    6.9537e-07,
                    7.1284e-07,
                    7.3094e-07,
                    7.4991e-07,
                    7.6994e-07,
                    7.9115e-07,
                    8.1364e-07,
                    8.3748e-07,
                    8.6265e-07,
                    8.8914e-07,
                    9.1685e-07,
                    9.4567e-07,
                    9.7556e-07,
                    1.0066e-06,
                    1.0389e-06,
                    1.0724e-06,
                    1.1073e-06,
                    1.1434e-06,
                    1.1807e-06,
                    1.2192e-06,
                    1.2588e-06,
                    1.2994e-06,
                    1.3409e-06,
                    1.3834e-06,
                    1.427e-06,
                    1.4716e-06,
                    1.5174e-06,
                    1.5644e-06,
                    1.6127e-06,
                    1.6623e-06,
                    1.7133e-06,
                    1.7777e-06,
                    1.843e-06,
                    1.9112e-06,
                    1.9793e-06,
                    2.0515e-06,
                    2.1275e-06,
                    2.2094e-06,
                    2.2952e-06,
                    2.3871e-06,
                    2.4832e-06,
                    2.5832e-06,
                    2.6858e-06,
                    2.8177e-06,
                    2.9474e-06,
                    3.0661e-06,
                    3.1937e-06,
                    3.3271e-06,
                    3.4648e-06,
                    3.6042e-06,
                    3.752e-06,
                    3.9061e-06,
                    4.0648e-06,
                    4.2264e-06,
                    4.3916e-06,
                    4.5616e-06,
                    4.7402e-06,
                    4.9248e-06,
                    5.1179e-06,
                    5.3096e-06,
                    5.5144e-06,
                    5.7206e-06,
                    5.9287e-06,
                    6.1412e-06,
                    6.35e-06,
                    6.6e-06,
                    6.8591e-06,
                    7.1224e-06,
                    7.3959e-06,
                    7.6743e-06,
                    7.946e-06,
                    8.2329e-06,
                    8.5524e-06,
                    8.8956e-06,
                    9.2509e-06,
                    9.6149e-06,
                    9.9581e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.12,
                "Land_N2O_timeseries": [
                    2.952e-08,
                    5.963e-08,
                    9.0305e-08,
                    1.2151e-07,
                    1.532e-07,
                    1.8532e-07,
                    2.1781e-07,
                    2.5059e-07,
                    2.8357e-07,
                    3.1668e-07,
                    3.4984e-07,
                    3.8304e-07,
                    4.1627e-07,
                    4.4953e-07,
                    4.828e-07,
                    5.161e-07,
                    5.4941e-07,
                    5.8277e-07,
                    6.1616e-07,
                    6.4962e-07,
                    6.8364e-07,
                    7.1908e-07,
                    7.5659e-07,
                    7.9664e-07,
                    8.3947e-07,
                    8.8517e-07,
                    9.3358e-07,
                    9.8439e-07,
                    1.037e-06,
                    1.0908e-06,
                    1.1453e-06,
                    1.2002e-06,
                    1.2556e-06,
                    1.3114e-06,
                    1.3676e-06,
                    1.4241e-06,
                    1.4809e-06,
                    1.538e-06,
                    1.5956e-06,
                    1.6561e-06,
                    1.7173e-06,
                    1.779e-06,
                    1.8414e-06,
                    1.9044e-06,
                    1.9681e-06,
                    2.0325e-06,
                    2.0977e-06,
                    2.1636e-06,
                    2.2302e-06,
                    2.2977e-06,
                    2.3659e-06,
                    2.4349e-06,
                    2.5046e-06,
                    2.5751e-06,
                    2.6464e-06,
                    2.7185e-06,
                    2.7917e-06,
                    2.8659e-06,
                    2.9415e-06,
                    3.0184e-06,
                    3.0975e-06,
                    3.1799e-06,
                    3.2663e-06,
                    3.3575e-06,
                    3.4541e-06,
                    3.5563e-06,
                    3.6642e-06,
                    3.7778e-06,
                    3.8968e-06,
                    4.0208e-06,
                    4.1499e-06,
                    4.2847e-06,
                    4.4256e-06,
                    4.5727e-06,
                    4.7258e-06,
                    4.8844e-06,
                    5.0478e-06,
                    5.215e-06,
                    5.3848e-06,
                    5.5556e-06,
                    5.7258e-06,
                    5.8943e-06,
                    6.0602e-06,
                    6.2228e-06,
                    6.3818e-06,
                    6.5373e-06,
                    6.6896e-06,
                    6.8392e-06,
                    6.9871e-06,
                    7.1344e-06,
                    7.297e-06,
                    7.5005e-06,
                    7.7645e-06,
                    8.1018e-06,
                    8.519e-06,
                    9.0165e-06,
                    9.588e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -7.52313,
                            4.36173
                        ],
                        [
                            -7.40561,
                            4.38377
                        ],
                        [
                            -7.25128,
                            4.46645
                        ],
                        [
                            -7.18366,
                            4.52069
                        ],
                        [
                            -7.06044,
                            4.53828
                        ],
                        [
                            -6.90999,
                            4.66409
                        ],
                        [
                            -6.70892,
                            4.69452
                        ],
                        [
                            -6.58454,
                            4.76451
                        ],
                        [
                            -6.45156,
                            4.79236
                        ],
                        [
                            -6.11566,
                            4.92713
                        ],
                        [
                            -6.07299,
                            4.96146
                        ],
                        [
                            -5.83227,
                            5.03928
                        ],
                        [
                            -5.58028,
                            5.08051
                        ],
                        [
                            -5.17014,
                            5.12533
                        ],
                        [
                            -4.76034,
                            5.15416
                        ],
                        [
                            -4.54775,
                            5.18651
                        ],
                        [
                            -4.21475,
                            5.2204
                        ],
                        [
                            -3.97777,
                            5.25494
                        ],
                        [
                            -3.7996,
                            5.20644
                        ],
                        [
                            -3.41952,
                            5.15062
                        ],
                        [
                            -3.10583,
                            5.09086
                        ],
                        [
                            -2.93756,
                            5.12488
                        ],
                        [
                            -2.75853,
                            5.10449
                        ],
                        [
                            -2.72542,
                            5.13965
                        ],
                        [
                            -2.78414,
                            5.28705
                        ],
                        [
                            -2.7283,
                            5.34392
                        ],
                        [
                            -2.78769,
                            5.62579
                        ],
                        [
                            -2.85705,
                            5.6496
                        ],
                        [
                            -2.93245,
                            5.61643
                        ],
                        [
                            -2.96427,
                            5.64203
                        ],
                        [
                            -2.95617,
                            5.71369
                        ],
                        [
                            -3.02566,
                            5.71334
                        ],
                        [
                            -3.02079,
                            5.85446
                        ],
                        [
                            -3.07224,
                            5.98918
                        ],
                        [
                            -3.10258,
                            6.15191
                        ],
                        [
                            -3.17208,
                            6.30149
                        ],
                        [
                            -3.2337,
                            6.53766
                        ],
                        [
                            -3.24872,
                            6.64389
                        ],
                        [
                            -3.19689,
                            6.71848
                        ],
                        [
                            -3.22696,
                            6.82205
                        ],
                        [
                            -3.09077,
                            7.048
                        ],
                        [
                            -3.03254,
                            7.07386
                        ],
                        [
                            -3.02232,
                            7.14336
                        ],
                        [
                            -2.95696,
                            7.23336
                        ],
                        [
                            -2.97113,
                            7.32967
                        ],
                        [
                            -2.9313,
                            7.50001
                        ],
                        [
                            -2.91984,
                            7.61213
                        ],
                        [
                            -2.82646,
                            7.82345
                        ],
                        [
                            -2.67465,
                            8.02526
                        ],
                        [
                            -2.59735,
                            8.04161
                        ],
                        [
                            -2.61185,
                            8.13377
                        ],
                        [
                            -2.4943,
                            8.20866
                        ],
                        [
                            -2.58588,
                            8.78191
                        ],
                        [
                            -2.67372,
                            9.02327
                        ],
                        [
                            -2.75347,
                            9.03433
                        ],
                        [
                            -2.77272,
                            9.13665
                        ],
                        [
                            -2.66027,
                            9.26142
                        ],
                        [
                            -2.71878,
                            9.33331
                        ],
                        [
                            -2.67464,
                            9.38004
                        ],
                        [
                            -2.68692,
                            9.49074
                        ],
                        [
                            -2.75285,
                            9.41057
                        ],
                        [
                            -2.79746,
                            9.41826
                        ],
                        [
                            -2.90204,
                            9.53236
                        ],
                        [
                            -3.01762,
                            9.74191
                        ],
                        [
                            -3.06266,
                            9.72185
                        ],
                        [
                            -3.12356,
                            9.84179
                        ],
                        [
                            -3.18251,
                            9.84334
                        ],
                        [
                            -3.21179,
                            9.9218
                        ],
                        [
                            -3.28014,
                            9.85374
                        ],
                        [
                            -3.39473,
                            9.91525
                        ],
                        [
                            -3.59788,
                            9.92057
                        ],
                        [
                            -3.64271,
                            9.95598
                        ],
                        [
                            -3.75428,
                            9.93045
                        ],
                        [
                            -3.81171,
                            9.88877
                        ],
                        [
                            -3.89971,
                            9.89927
                        ],
                        [
                            -3.9719,
                            9.86868
                        ],
                        [
                            -4.04747,
                            9.80132
                        ],
                        [
                            -4.13212,
                            9.83032
                        ],
                        [
                            -4.18364,
                            9.77397
                        ],
                        [
                            -4.26698,
                            9.732
                        ],
                        [
                            -4.29104,
                            9.63932
                        ],
                        [
                            -4.40438,
                            9.60777
                        ],
                        [
                            -4.43354,
                            9.66136
                        ],
                        [
                            -4.50384,
                            9.64785
                        ],
                        [
                            -4.61607,
                            9.72106
                        ],
                        [
                            -4.69177,
                            9.67826
                        ],
                        [
                            -4.7422,
                            9.74921
                        ],
                        [
                            -4.78374,
                            9.74284
                        ],
                        [
                            -4.78929,
                            9.82943
                        ],
                        [
                            -4.83424,
                            9.86414
                        ],
                        [
                            -4.96597,
                            9.89218
                        ],
                        [
                            -4.98576,
                            9.98465
                        ],
                        [
                            -4.97275,
                            10.0408
                        ],
                        [
                            -5.01463,
                            10.06532
                        ],
                        [
                            -5.11875,
                            10.252
                        ],
                        [
                            -5.1313,
                            10.30459
                        ],
                        [
                            -5.20911,
                            10.31964
                        ],
                        [
                            -5.36897,
                            10.287
                        ],
                        [
                            -5.46872,
                            10.34836
                        ],
                        [
                            -5.51892,
                            10.43327
                        ],
                        [
                            -5.56816,
                            10.46413
                        ],
                        [
                            -5.67622,
                            10.46184
                        ],
                        [
                            -5.77974,
                            10.43899
                        ],
                        [
                            -5.88449,
                            10.37205
                        ],
                        [
                            -5.90936,
                            10.28181
                        ],
                        [
                            -5.97297,
                            10.27695
                        ],
                        [
                            -6.01163,
                            10.20458
                        ],
                        [
                            -6.11987,
                            10.20506
                        ],
                        [
                            -6.1908,
                            10.23576
                        ],
                        [
                            -6.23631,
                            10.29656
                        ],
                        [
                            -6.17007,
                            10.36348
                        ],
                        [
                            -6.19003,
                            10.3893
                        ],
                        [
                            -6.2117,
                            10.57383
                        ],
                        [
                            -6.25677,
                            10.73582
                        ],
                        [
                            -6.34784,
                            10.69642
                        ],
                        [
                            -6.41534,
                            10.70034
                        ],
                        [
                            -6.40212,
                            10.59849
                        ],
                        [
                            -6.4631,
                            10.56582
                        ],
                        [
                            -6.53965,
                            10.58727
                        ],
                        [
                            -6.64253,
                            10.67009
                        ],
                        [
                            -6.66743,
                            10.62941
                        ],
                        [
                            -6.68339,
                            10.49088
                        ],
                        [
                            -6.63751,
                            10.4154
                        ],
                        [
                            -6.67201,
                            10.36654
                        ],
                        [
                            -6.764,
                            10.39035
                        ],
                        [
                            -6.85696,
                            10.36295
                        ],
                        [
                            -6.95047,
                            10.36698
                        ],
                        [
                            -6.99638,
                            10.30428
                        ],
                        [
                            -6.96569,
                            10.22081
                        ],
                        [
                            -7.0509,
                            10.16605
                        ],
                        [
                            -7.08918,
                            10.22361
                        ],
                        [
                            -7.29759,
                            10.28712
                        ],
                        [
                            -7.37903,
                            10.27624
                        ],
                        [
                            -7.36579,
                            10.36086
                        ],
                        [
                            -7.42769,
                            10.39289
                        ],
                        [
                            -7.44874,
                            10.46094
                        ],
                        [
                            -7.50997,
                            10.47839
                        ],
                        [
                            -7.55168,
                            10.44511
                        ],
                        [
                            -7.64815,
                            10.48358
                        ],
                        [
                            -7.72502,
                            10.42657
                        ],
                        [
                            -7.73497,
                            10.34647
                        ],
                        [
                            -7.76683,
                            10.29213
                        ],
                        [
                            -7.85622,
                            10.20572
                        ],
                        [
                            -7.92757,
                            10.17102
                        ],
                        [
                            -7.97855,
                            10.17511
                        ],
                        [
                            -8.02025,
                            10.09357
                        ],
                        [
                            -8.10059,
                            10.05118
                        ],
                        [
                            -8.16392,
                            9.92558
                        ],
                        [
                            -8.10274,
                            9.82932
                        ],
                        [
                            -8.12771,
                            9.75852
                        ],
                        [
                            -8.1286,
                            9.65423
                        ],
                        [
                            -8.14855,
                            9.53486
                        ],
                        [
                            -8.05854,
                            9.40226
                        ],
                        [
                            -7.97092,
                            9.39586
                        ],
                        [
                            -7.85035,
                            9.4347
                        ],
                        [
                            -7.88735,
                            9.34404
                        ],
                        [
                            -7.88812,
                            9.28958
                        ],
                        [
                            -7.92478,
                            9.21791
                        ],
                        [
                            -7.85382,
                            9.17679
                        ],
                        [
                            -7.7873,
                            9.10641
                        ],
                        [
                            -7.91887,
                            8.9995
                        ],
                        [
                            -7.96105,
                            8.81213
                        ],
                        [
                            -7.9165,
                            8.7663
                        ],
                        [
                            -7.7688,
                            8.76246
                        ],
                        [
                            -7.68792,
                            8.54699
                        ],
                        [
                            -7.66178,
                            8.50605
                        ],
                        [
                            -7.6805,
                            8.44531
                        ],
                        [
                            -7.65222,
                            8.37489
                        ],
                        [
                            -7.74664,
                            8.37533
                        ],
                        [
                            -7.78873,
                            8.463
                        ],
                        [
                            -7.88373,
                            8.41866
                        ],
                        [
                            -7.91571,
                            8.48456
                        ],
                        [
                            -8.09408,
                            8.50349
                        ],
                        [
                            -8.19316,
                            8.50131
                        ],
                        [
                            -8.24352,
                            8.44393
                        ],
                        [
                            -8.23115,
                            8.2812
                        ],
                        [
                            -8.17793,
                            8.19999
                        ],
                        [
                            -8.08863,
                            8.16809
                        ],
                        [
                            -8.03931,
                            8.20296
                        ],
                        [
                            -8.0085,
                            8.16064
                        ],
                        [
                            -8.01244,
                            8.10023
                        ],
                        [
                            -7.94984,
                            8.04218
                        ],
                        [
                            -8.04265,
                            8.03086
                        ],
                        [
                            -8.11156,
                            7.8429
                        ],
                        [
                            -8.07401,
                            7.80914
                        ],
                        [
                            -8.09629,
                            7.72146
                        ],
                        [
                            -8.13832,
                            7.69335
                        ],
                        [
                            -8.17499,
                            7.57866
                        ],
                        [
                            -8.2145,
                            7.5359
                        ],
                        [
                            -8.29115,
                            7.57944
                        ],
                        [
                            -8.4192,
                            7.60611
                        ],
                        [
                            -8.47218,
                            7.55459
                        ],
                        [
                            -8.41414,
                            7.49378
                        ],
                        [
                            -8.38596,
                            7.3195
                        ],
                        [
                            -8.36009,
                            7.24263
                        ],
                        [
                            -8.28992,
                            7.18214
                        ],
                        [
                            -8.29936,
                            7.08529
                        ],
                        [
                            -8.28671,
                            6.98643
                        ],
                        [
                            -8.32302,
                            6.96155
                        ],
                        [
                            -8.30764,
                            6.84969
                        ],
                        [
                            -8.34004,
                            6.75934
                        ],
                        [
                            -8.40504,
                            6.70563
                        ],
                        [
                            -8.44985,
                            6.63715
                        ],
                        [
                            -8.50175,
                            6.61266
                        ],
                        [
                            -8.58559,
                            6.49672
                        ],
                        [
                            -8.54125,
                            6.49169
                        ],
                        [
                            -8.47091,
                            6.43466
                        ],
                        [
                            -8.40418,
                            6.43089
                        ],
                        [
                            -8.38464,
                            6.37865
                        ],
                        [
                            -8.16911,
                            6.27541
                        ],
                        [
                            -8.00618,
                            6.31466
                        ],
                        [
                            -7.90148,
                            6.27887
                        ],
                        [
                            -7.85307,
                            6.22819
                        ],
                        [
                            -7.83235,
                            6.15997
                        ],
                        [
                            -7.84811,
                            6.0956
                        ],
                        [
                            -7.78734,
                            6.07239
                        ],
                        [
                            -7.78584,
                            5.98239
                        ],
                        [
                            -7.68283,
                            5.90099
                        ],
                        [
                            -7.57596,
                            5.89737
                        ],
                        [
                            -7.51975,
                            5.85791
                        ],
                        [
                            -7.42333,
                            5.84276
                        ],
                        [
                            -7.44042,
                            5.75266
                        ],
                        [
                            -7.37956,
                            5.62384
                        ],
                        [
                            -7.38082,
                            5.52938
                        ],
                        [
                            -7.42127,
                            5.47726
                        ],
                        [
                            -7.42063,
                            5.37753
                        ],
                        [
                            -7.36577,
                            5.32733
                        ],
                        [
                            -7.47101,
                            5.26649
                        ],
                        [
                            -7.47122,
                            5.1506
                        ],
                        [
                            -7.5011,
                            5.09642
                        ],
                        [
                            -7.55531,
                            5.06923
                        ],
                        [
                            -7.52545,
                            4.92846
                        ],
                        [
                            -7.58399,
                            4.90987
                        ],
                        [
                            -7.59172,
                            4.82006
                        ],
                        [
                            -7.56238,
                            4.76806
                        ],
                        [
                            -7.54701,
                            4.60882
                        ],
                        [
                            -7.56045,
                            4.46825
                        ],
                        [
                            -7.52313,
                            4.36173
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "COD",
                "Country": "Democratic Republic of The Congo",
                "Total_3GHG": 0.71,
                "Total_3GHG_timeseries": [
                    4.9634e-06,
                    9.8846e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.005,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0055,
                    0.0056,
                    0.0058,
                    0.0059,
                    0.006,
                    0.0061,
                    0.0062,
                    0.0064,
                    0.0065,
                    0.0066,
                    0.0067,
                    0.0069,
                    0.007,
                    0.0072,
                    0.0074,
                    0.0077,
                    0.008,
                    0.0084,
                    0.0087,
                    0.0091,
                    0.0094,
                    0.0097,
                    0.0101,
                    0.0104,
                    0.0106,
                    0.0109,
                    0.0113,
                    0.0116
                ],
                "Fossil_3GHG": 0.13,
                "Fossil_3GHG_timeseries": [
                    1.8782e-07,
                    3.8955e-07,
                    6.054e-07,
                    8.3556e-07,
                    1.0802e-06,
                    1.3396e-06,
                    1.614e-06,
                    1.9034e-06,
                    2.2083e-06,
                    2.5286e-06,
                    2.8665e-06,
                    3.2221e-06,
                    3.5956e-06,
                    3.9874e-06,
                    4.3977e-06,
                    4.8268e-06,
                    5.2748e-06,
                    5.7421e-06,
                    6.229e-06,
                    6.7357e-06,
                    7.2501e-06,
                    7.7725e-06,
                    8.3032e-06,
                    8.8424e-06,
                    9.3904e-06,
                    9.9471e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014
                ],
                "Land_3GHG": 1.76,
                "Land_3GHG_timeseries": [
                    4.7756e-06,
                    9.4951e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.004,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0055,
                    0.0056,
                    0.0057,
                    0.0058,
                    0.0059,
                    0.0061,
                    0.0062,
                    0.0063,
                    0.0066,
                    0.0068,
                    0.0071,
                    0.0074,
                    0.0078,
                    0.0081,
                    0.0083,
                    0.0086,
                    0.0089,
                    0.0091,
                    0.0094,
                    0.0096,
                    0.0099,
                    0.0101
                ],
                "Total_CO2": 0.81,
                "Total_CO2_timeseries": [
                    4.4997e-06,
                    8.9391e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0056,
                    0.0058,
                    0.006,
                    0.0063,
                    0.0066,
                    0.0069,
                    0.0072,
                    0.0075,
                    0.0078,
                    0.008,
                    0.0083,
                    0.0085,
                    0.0087,
                    0.009,
                    0.0092
                ],
                "Fossil_CO2": 0.01,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.65e-09,
                    4.95e-09,
                    4.125e-08,
                    1.1385e-07,
                    2.112e-07,
                    2.8875e-07,
                    3.96e-07,
                    4.9995e-07,
                    6.2692e-07,
                    7.6376e-07,
                    9.3854e-07,
                    1.0507e-06,
                    1.0737e-06,
                    1.0754e-06,
                    1.0836e-06,
                    1.0984e-06,
                    1.1166e-06,
                    1.1628e-06,
                    1.2172e-06,
                    1.2567e-06,
                    1.2913e-06,
                    1.3375e-06,
                    1.4017e-06,
                    1.5006e-06,
                    1.578e-06,
                    1.6554e-06,
                    1.7955e-06,
                    1.9421e-06,
                    2.1102e-06,
                    2.3244e-06,
                    2.9907e-06,
                    3.7774e-06,
                    4.7158e-06,
                    5.7466e-06,
                    7.0148e-06,
                    8.5403e-06,
                    9.97e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CO2": 2.54,
                "Land_CO2_timeseries": [
                    4.4997e-06,
                    8.9391e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.005,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0055,
                    0.0057,
                    0.0059,
                    0.0062,
                    0.0065,
                    0.0069,
                    0.0071,
                    0.0074,
                    0.0077,
                    0.0079,
                    0.0082,
                    0.0084,
                    0.0086,
                    0.0089,
                    0.0091
                ],
                "Total_CH4": 0.46,
                "Total_CH4_timeseries": [
                    2.3933e-07,
                    4.9243e-07,
                    7.5952e-07,
                    1.0408e-06,
                    1.3365e-06,
                    1.6468e-06,
                    1.972e-06,
                    2.3123e-06,
                    2.6678e-06,
                    3.039e-06,
                    3.4286e-06,
                    3.8369e-06,
                    4.2641e-06,
                    4.7106e-06,
                    5.1766e-06,
                    5.6623e-06,
                    6.168e-06,
                    6.6939e-06,
                    7.2404e-06,
                    7.8077e-06,
                    8.3836e-06,
                    8.968e-06,
                    9.5612e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019
                ],
                "Fossil_CH4": 0.49,
                "Fossil_CH4_timeseries": [
                    1.7714e-07,
                    3.6801e-07,
                    5.7281e-07,
                    7.9175e-07,
                    1.0251e-06,
                    1.2729e-06,
                    1.5356e-06,
                    1.8133e-06,
                    2.1063e-06,
                    2.4148e-06,
                    2.7407e-06,
                    3.0843e-06,
                    3.4459e-06,
                    3.8257e-06,
                    4.2239e-06,
                    4.6408e-06,
                    5.0767e-06,
                    5.5319e-06,
                    6.0066e-06,
                    6.5011e-06,
                    7.0031e-06,
                    7.5126e-06,
                    8.0299e-06,
                    8.5549e-06,
                    9.0879e-06,
                    9.6288e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013
                ],
                "Land_CH4": 0.41,
                "Land_CH4_timeseries": [
                    6.2184e-08,
                    1.2442e-07,
                    1.8671e-07,
                    2.4905e-07,
                    3.1144e-07,
                    3.7389e-07,
                    4.3639e-07,
                    4.9894e-07,
                    5.6154e-07,
                    6.2419e-07,
                    6.8786e-07,
                    7.5255e-07,
                    8.1825e-07,
                    8.8497e-07,
                    9.5271e-07,
                    1.0215e-06,
                    1.0912e-06,
                    1.162e-06,
                    1.2338e-06,
                    1.3066e-06,
                    1.3805e-06,
                    1.4554e-06,
                    1.5313e-06,
                    1.6083e-06,
                    1.6864e-06,
                    1.7655e-06,
                    1.8456e-06,
                    1.9268e-06,
                    2.009e-06,
                    2.0922e-06,
                    2.1757e-06,
                    2.2593e-06,
                    2.343e-06,
                    2.427e-06,
                    2.5111e-06,
                    2.5954e-06,
                    2.6798e-06,
                    2.7644e-06,
                    2.8492e-06,
                    2.9342e-06,
                    3.0193e-06,
                    3.1046e-06,
                    3.1901e-06,
                    3.2758e-06,
                    3.3616e-06,
                    3.4476e-06,
                    3.5338e-06,
                    3.6201e-06,
                    3.7066e-06,
                    3.7933e-06,
                    3.8802e-06,
                    3.9672e-06,
                    4.0545e-06,
                    4.1419e-06,
                    4.2294e-06,
                    4.3172e-06,
                    4.4051e-06,
                    4.4932e-06,
                    4.5815e-06,
                    4.67e-06,
                    4.7746e-06,
                    4.8953e-06,
                    5.0321e-06,
                    5.1851e-06,
                    5.3542e-06,
                    5.5394e-06,
                    5.7408e-06,
                    5.9583e-06,
                    6.1919e-06,
                    6.4416e-06,
                    6.711e-06,
                    7e-06,
                    7.3087e-06,
                    7.637e-06,
                    7.985e-06,
                    8.3526e-06,
                    8.7399e-06,
                    9.1468e-06,
                    9.5733e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006
                ],
                "Total_N2O": 0.52,
                "Total_N2O_timeseries": [
                    2.2435e-07,
                    4.5315e-07,
                    6.8623e-07,
                    9.2332e-07,
                    1.1641e-06,
                    1.4081e-06,
                    1.6549e-06,
                    1.9039e-06,
                    2.1545e-06,
                    2.406e-06,
                    2.658e-06,
                    2.9102e-06,
                    3.1628e-06,
                    3.4155e-06,
                    3.6684e-06,
                    3.9215e-06,
                    4.1748e-06,
                    4.4284e-06,
                    4.6823e-06,
                    4.9367e-06,
                    5.1954e-06,
                    5.4647e-06,
                    5.7497e-06,
                    6.0537e-06,
                    6.3787e-06,
                    6.7252e-06,
                    7.0923e-06,
                    7.4772e-06,
                    7.8762e-06,
                    8.2837e-06,
                    8.6959e-06,
                    9.1123e-06,
                    9.532e-06,
                    9.9547e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Fossil_N2O": 0.15,
                "Fossil_N2O_timeseries": [
                    1.0677e-08,
                    2.1542e-08,
                    3.2589e-08,
                    4.3808e-08,
                    5.5187e-08,
                    6.6709e-08,
                    7.8358e-08,
                    9.0112e-08,
                    1.0195e-07,
                    1.1384e-07,
                    1.2578e-07,
                    1.3775e-07,
                    1.4975e-07,
                    1.6178e-07,
                    1.7384e-07,
                    1.8594e-07,
                    1.9806e-07,
                    2.1022e-07,
                    2.2241e-07,
                    2.3465e-07,
                    2.4707e-07,
                    2.599e-07,
                    2.7334e-07,
                    2.8751e-07,
                    3.0247e-07,
                    3.1826e-07,
                    3.3483e-07,
                    3.5208e-07,
                    3.6988e-07,
                    3.8802e-07,
                    4.0635e-07,
                    4.2486e-07,
                    4.4353e-07,
                    4.6232e-07,
                    4.8123e-07,
                    5.0026e-07,
                    5.1941e-07,
                    5.3867e-07,
                    5.5808e-07,
                    5.7875e-07,
                    5.9985e-07,
                    6.2141e-07,
                    6.4345e-07,
                    6.6601e-07,
                    6.891e-07,
                    7.1275e-07,
                    7.37e-07,
                    7.6185e-07,
                    7.8735e-07,
                    8.1351e-07,
                    8.4041e-07,
                    8.6816e-07,
                    8.9684e-07,
                    9.2651e-07,
                    9.5719e-07,
                    9.8887e-07,
                    1.0215e-06,
                    1.0551e-06,
                    1.0894e-06,
                    1.1245e-06,
                    1.1601e-06,
                    1.1963e-06,
                    1.233e-06,
                    1.2702e-06,
                    1.3078e-06,
                    1.3459e-06,
                    1.3845e-06,
                    1.4235e-06,
                    1.4631e-06,
                    1.5031e-06,
                    1.5436e-06,
                    1.5847e-06,
                    1.6263e-06,
                    1.6683e-06,
                    1.7109e-06,
                    1.7541e-06,
                    1.7978e-06,
                    1.8421e-06,
                    1.8871e-06,
                    1.9328e-06,
                    1.9793e-06,
                    2.027e-06,
                    2.0758e-06,
                    2.1261e-06,
                    2.1778e-06,
                    2.2313e-06,
                    2.2864e-06,
                    2.3433e-06,
                    2.4021e-06,
                    2.4626e-06,
                    2.5253e-06,
                    2.5907e-06,
                    2.6591e-06,
                    2.7309e-06,
                    2.8065e-06,
                    2.8858e-06,
                    2.9691e-06,
                    3.0561e-06,
                    3.1469e-06,
                    3.2412e-06,
                    3.3391e-06,
                    3.4411e-06,
                    3.5473e-06,
                    3.6581e-06,
                    3.7735e-06,
                    3.8934e-06,
                    4.0177e-06,
                    4.1461e-06,
                    4.2783e-06,
                    4.4137e-06,
                    4.5519e-06,
                    4.6929e-06,
                    4.8365e-06,
                    4.9829e-06,
                    5.1321e-06,
                    5.2844e-06,
                    5.4401e-06,
                    5.5995e-06,
                    5.7631e-06,
                    5.9359e-06,
                    6.1103e-06,
                    6.288e-06,
                    6.4721e-06,
                    6.6614e-06,
                    6.8546e-06,
                    7.0534e-06,
                    7.2544e-06,
                    7.4597e-06,
                    7.6717e-06,
                    7.8901e-06,
                    8.1172e-06,
                    8.4469e-06,
                    8.7954e-06,
                    9.1902e-06,
                    9.5387e-06,
                    9.9205e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.67,
                "Land_N2O_timeseries": [
                    2.1367e-07,
                    4.3161e-07,
                    6.5364e-07,
                    8.7951e-07,
                    1.1089e-06,
                    1.3414e-06,
                    1.5765e-06,
                    1.8138e-06,
                    2.0526e-06,
                    2.2922e-06,
                    2.5322e-06,
                    2.7725e-06,
                    3.013e-06,
                    3.2537e-06,
                    3.4946e-06,
                    3.7356e-06,
                    3.9768e-06,
                    4.2182e-06,
                    4.4599e-06,
                    4.7021e-06,
                    4.9483e-06,
                    5.2048e-06,
                    5.4763e-06,
                    5.7662e-06,
                    6.0763e-06,
                    6.407e-06,
                    6.7574e-06,
                    7.1251e-06,
                    7.5063e-06,
                    7.8956e-06,
                    8.2896e-06,
                    8.6874e-06,
                    9.0885e-06,
                    9.4924e-06,
                    9.8988e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                23.99953,
                                -10.88725
                            ],
                            [
                                24.11586,
                                -10.90519
                            ],
                            [
                                24.14211,
                                -10.96744
                            ],
                            [
                                24.13213,
                                -11.02326
                            ],
                            [
                                24.32276,
                                -11.05421
                            ],
                            [
                                24.38233,
                                -11.09227
                            ],
                            [
                                24.39816,
                                -11.26368
                            ],
                            [
                                24.35031,
                                -11.36476
                            ],
                            [
                                24.38185,
                                -11.40938
                            ],
                            [
                                24.47412,
                                -11.4607
                            ],
                            [
                                24.57575,
                                -11.45532
                            ],
                            [
                                24.66603,
                                -11.35902
                            ],
                            [
                                24.73827,
                                -11.30697
                            ],
                            [
                                24.85125,
                                -11.29252
                            ],
                            [
                                24.8734,
                                -11.26335
                            ],
                            [
                                25.10063,
                                -11.25074
                            ],
                            [
                                25.22481,
                                -11.22723
                            ],
                            [
                                25.30125,
                                -11.19267
                            ],
                            [
                                25.34834,
                                -11.19715
                            ],
                            [
                                25.27979,
                                -11.36839
                            ],
                            [
                                25.3005,
                                -11.4138
                            ],
                            [
                                25.2967,
                                -11.51058
                            ],
                            [
                                25.33799,
                                -11.62677
                            ],
                            [
                                25.49247,
                                -11.70951
                            ],
                            [
                                25.50733,
                                -11.78461
                            ],
                            [
                                25.59793,
                                -11.73572
                            ],
                            [
                                25.65666,
                                -11.73736
                            ],
                            [
                                25.71912,
                                -11.81466
                            ],
                            [
                                25.82228,
                                -11.82764
                            ],
                            [
                                25.88894,
                                -11.81074
                            ],
                            [
                                25.91752,
                                -11.87246
                            ],
                            [
                                25.98507,
                                -11.89647
                            ],
                            [
                                25.98967,
                                -11.94002
                            ],
                            [
                                26.18639,
                                -11.9389
                            ],
                            [
                                26.2112,
                                -11.9282
                            ],
                            [
                                26.32773,
                                -11.96559
                            ],
                            [
                                26.40781,
                                -11.92082
                            ],
                            [
                                26.46686,
                                -11.92002
                            ],
                            [
                                26.56223,
                                -11.97986
                            ],
                            [
                                26.6022,
                                -11.97245
                            ],
                            [
                                26.72004,
                                -12.00664
                            ],
                            [
                                26.79695,
                                -11.96716
                            ],
                            [
                                26.88324,
                                -11.98368
                            ],
                            [
                                27.00185,
                                -11.8528
                            ],
                            [
                                27.00878,
                                -11.76622
                            ],
                            [
                                27.04784,
                                -11.70274
                            ],
                            [
                                27.0253,
                                -11.65066
                            ],
                            [
                                27.04487,
                                -11.60346
                            ],
                            [
                                27.15779,
                                -11.59902
                            ],
                            [
                                27.21048,
                                -11.57844
                            ],
                            [
                                27.22794,
                                -11.77221
                            ],
                            [
                                27.46181,
                                -11.92671
                            ],
                            [
                                27.46484,
                                -12.01276
                            ],
                            [
                                27.50929,
                                -12.13912
                            ],
                            [
                                27.56582,
                                -12.21014
                            ],
                            [
                                27.65473,
                                -12.28619
                            ],
                            [
                                27.7586,
                                -12.28808
                            ],
                            [
                                27.86434,
                                -12.24352
                            ],
                            [
                                27.91803,
                                -12.24153
                            ],
                            [
                                27.96342,
                                -12.35182
                            ],
                            [
                                28.08872,
                                -12.36319
                            ],
                            [
                                28.1167,
                                -12.42716
                            ],
                            [
                                28.19059,
                                -12.40076
                            ],
                            [
                                28.32603,
                                -12.42548
                            ],
                            [
                                28.52194,
                                -12.63427
                            ],
                            [
                                28.45582,
                                -12.71063
                            ],
                            [
                                28.58729,
                                -12.88477
                            ],
                            [
                                28.65422,
                                -12.82013
                            ],
                            [
                                28.73291,
                                -12.88764
                            ],
                            [
                                28.83375,
                                -13.02865
                            ],
                            [
                                28.84851,
                                -13.14623
                            ],
                            [
                                28.90399,
                                -13.1642
                            ],
                            [
                                28.94693,
                                -13.30691
                            ],
                            [
                                29.02092,
                                -13.41652
                            ],
                            [
                                29.1081,
                                -13.37024
                            ],
                            [
                                29.18694,
                                -13.44098
                            ],
                            [
                                29.36639,
                                -13.32716
                            ],
                            [
                                29.44142,
                                -13.31331
                            ],
                            [
                                29.52567,
                                -13.22993
                            ],
                            [
                                29.58505,
                                -13.21395
                            ],
                            [
                                29.67652,
                                -13.23542
                            ],
                            [
                                29.6785,
                                -13.26967
                            ],
                            [
                                29.61234,
                                -13.40941
                            ],
                            [
                                29.71091,
                                -13.45461
                            ],
                            [
                                29.80814,
                                -13.45247
                            ],
                            [
                                29.8089,
                                -12.9964
                            ],
                            [
                                29.81016,
                                -12.19379
                            ],
                            [
                                29.76164,
                                -12.16136
                            ],
                            [
                                29.66785,
                                -12.20669
                            ],
                            [
                                29.57635,
                                -12.19333
                            ],
                            [
                                29.4889,
                                -12.23973
                            ],
                            [
                                29.45673,
                                -12.33288
                            ],
                            [
                                29.53507,
                                -12.42952
                            ],
                            [
                                29.47251,
                                -12.46982
                            ],
                            [
                                29.36751,
                                -12.41373
                            ],
                            [
                                29.30253,
                                -12.41259
                            ],
                            [
                                29.26687,
                                -12.36535
                            ],
                            [
                                29.1293,
                                -12.39456
                            ],
                            [
                                29.03511,
                                -12.3731
                            ],
                            [
                                28.94729,
                                -12.21266
                            ],
                            [
                                28.85689,
                                -12.13895
                            ],
                            [
                                28.77897,
                                -12.05499
                            ],
                            [
                                28.7639,
                                -11.99786
                            ],
                            [
                                28.63885,
                                -11.95043
                            ],
                            [
                                28.61293,
                                -11.91267
                            ],
                            [
                                28.50703,
                                -11.88057
                            ],
                            [
                                28.44375,
                                -11.83097
                            ],
                            [
                                28.41824,
                                -11.73191
                            ],
                            [
                                28.42406,
                                -11.63445
                            ],
                            [
                                28.38131,
                                -11.57566
                            ],
                            [
                                28.39517,
                                -11.47441
                            ],
                            [
                                28.41842,
                                -11.44577
                            ],
                            [
                                28.44911,
                                -11.32481
                            ],
                            [
                                28.48649,
                                -11.24382
                            ],
                            [
                                28.49521,
                                -11.14816
                            ],
                            [
                                28.47662,
                                -11.10496
                            ],
                            [
                                28.53835,
                                -10.94061
                            ],
                            [
                                28.55382,
                                -10.83233
                            ],
                            [
                                28.68955,
                                -10.6788
                            ],
                            [
                                28.6724,
                                -10.56907
                            ],
                            [
                                28.63436,
                                -10.51902
                            ],
                            [
                                28.64268,
                                -10.45034
                            ],
                            [
                                28.6219,
                                -10.37531
                            ],
                            [
                                28.63639,
                                -10.31667
                            ],
                            [
                                28.57762,
                                -10.23005
                            ],
                            [
                                28.62153,
                                -10.15639
                            ],
                            [
                                28.63586,
                                -10.02158
                            ],
                            [
                                28.6257,
                                -9.95562
                            ],
                            [
                                28.67215,
                                -9.81995
                            ],
                            [
                                28.66856,
                                -9.75739
                            ],
                            [
                                28.6241,
                                -9.72931
                            ],
                            [
                                28.61528,
                                -9.60372
                            ],
                            [
                                28.57404,
                                -9.54654
                            ],
                            [
                                28.56945,
                                -9.49089
                            ],
                            [
                                28.5152,
                                -9.43333
                            ],
                            [
                                28.53365,
                                -9.38233
                            ],
                            [
                                28.49664,
                                -9.32697
                            ],
                            [
                                28.38453,
                                -9.25852
                            ],
                            [
                                28.48228,
                                -9.17152
                            ],
                            [
                                28.69557,
                                -9.03421
                            ],
                            [
                                28.8642,
                                -8.84235
                            ],
                            [
                                28.9413,
                                -8.71432
                            ],
                            [
                                28.96019,
                                -8.57402
                            ],
                            [
                                29.00335,
                                -8.45973
                            ],
                            [
                                29.59474,
                                -8.37651
                            ],
                            [
                                29.63785,
                                -8.4004
                            ],
                            [
                                29.74052,
                                -8.35556
                            ],
                            [
                                29.99963,
                                -8.31677
                            ],
                            [
                                30.12231,
                                -8.31243
                            ],
                            [
                                30.54407,
                                -8.2555
                            ],
                            [
                                30.58084,
                                -8.27435
                            ],
                            [
                                30.77124,
                                -8.19225
                            ],
                            [
                                30.70722,
                                -7.995
                            ],
                            [
                                30.65055,
                                -7.88042
                            ],
                            [
                                30.50972,
                                -7.67945
                            ],
                            [
                                30.43972,
                                -7.53
                            ],
                            [
                                30.40944,
                                -7.36431
                            ],
                            [
                                30.315,
                                -7.14375
                            ],
                            [
                                30.18833,
                                -6.9625
                            ],
                            [
                                30.03715,
                                -6.82264
                            ],
                            [
                                29.88542,
                                -6.75083
                            ],
                            [
                                29.73916,
                                -6.63458
                            ],
                            [
                                29.70389,
                                -6.58639
                            ],
                            [
                                29.54083,
                                -6.26306
                            ],
                            [
                                29.49833,
                                -6.05639
                            ],
                            [
                                29.50472,
                                -5.94583
                            ],
                            [
                                29.60875,
                                -5.80722
                            ],
                            [
                                29.63,
                                -5.75486
                            ],
                            [
                                29.5975,
                                -5.57917
                            ],
                            [
                                29.53444,
                                -5.44806
                            ],
                            [
                                29.4543,
                                -5.17667
                            ],
                            [
                                29.41416,
                                -5.12528
                            ],
                            [
                                29.36305,
                                -4.99528
                            ],
                            [
                                29.34194,
                                -4.88389
                            ],
                            [
                                29.35875,
                                -4.72972
                            ],
                            [
                                29.42972,
                                -4.54507
                            ],
                            [
                                29.42333,
                                -4.4475
                            ],
                            [
                                29.3978,
                                -4.29794
                            ],
                            [
                                29.39253,
                                -4.19179
                            ],
                            [
                                29.34686,
                                -4.05643
                            ],
                            [
                                29.23934,
                                -3.92142
                            ],
                            [
                                29.22397,
                                -3.78935
                            ],
                            [
                                29.24681,
                                -3.59194
                            ],
                            [
                                29.23784,
                                -3.462
                            ],
                            [
                                29.21169,
                                -3.3043
                            ],
                            [
                                29.23989,
                                -3.27532
                            ],
                            [
                                29.22335,
                                -3.19703
                            ],
                            [
                                29.25835,
                                -3.06903
                            ],
                            [
                                29.18582,
                                -3.00746
                            ],
                            [
                                29.16765,
                                -2.95953
                            ],
                            [
                                29.09938,
                                -2.921
                            ],
                            [
                                29.09191,
                                -2.87337
                            ],
                            [
                                29.00293,
                                -2.78336
                            ],
                            [
                                29.04064,
                                -2.74384
                            ],
                            [
                                28.99732,
                                -2.70042
                            ],
                            [
                                28.91907,
                                -2.67962
                            ],
                            [
                                28.89281,
                                -2.56174
                            ],
                            [
                                28.89221,
                                -2.48663
                            ],
                            [
                                28.86549,
                                -2.40474
                            ],
                            [
                                28.89892,
                                -2.36375
                            ],
                            [
                                28.95732,
                                -2.36163
                            ],
                            [
                                29.01979,
                                -2.27856
                            ],
                            [
                                29.11505,
                                -2.24768
                            ],
                            [
                                29.16814,
                                -2.12509
                            ],
                            [
                                29.13542,
                                -1.97652
                            ],
                            [
                                29.1276,
                                -1.85937
                            ],
                            [
                                29.15032,
                                -1.80436
                            ],
                            [
                                29.24329,
                                -1.69948
                            ],
                            [
                                29.25511,
                                -1.65925
                            ],
                            [
                                29.36117,
                                -1.50721
                            ],
                            [
                                29.45129,
                                -1.50547
                            ],
                            [
                                29.52667,
                                -1.41286
                            ],
                            [
                                29.58951,
                                -1.38662
                            ],
                            [
                                29.64309,
                                -1.26056
                            ],
                            [
                                29.5746,
                                -1.18584
                            ],
                            [
                                29.6136,
                                -1.1019
                            ],
                            [
                                29.58966,
                                -1.04049
                            ],
                            [
                                29.58628,
                                -0.91205
                            ],
                            [
                                29.61738,
                                -0.90597
                            ],
                            [
                                29.63979,
                                -0.82648
                            ],
                            [
                                29.62628,
                                -0.72041
                            ],
                            [
                                29.66179,
                                -0.62694
                            ],
                            [
                                29.65132,
                                -0.59692
                            ],
                            [
                                29.68087,
                                -0.4967
                            ],
                            [
                                29.72824,
                                -0.04882
                            ],
                            [
                                29.71981,
                                0.06934
                            ],
                            [
                                29.78045,
                                0.16741
                            ],
                            [
                                29.82016,
                                0.16805
                            ],
                            [
                                29.87072,
                                0.37806
                            ],
                            [
                                29.9484,
                                0.44757
                            ],
                            [
                                29.94406,
                                0.52002
                            ],
                            [
                                29.97023,
                                0.55292
                            ],
                            [
                                29.95844,
                                0.65243
                            ],
                            [
                                29.98845,
                                0.84236
                            ],
                            [
                                30.17316,
                                0.91041
                            ],
                            [
                                30.22634,
                                0.98623
                            ],
                            [
                                30.23558,
                                1.12589
                            ],
                            [
                                30.29108,
                                1.1713
                            ],
                            [
                                30.33683,
                                1.15214
                            ],
                            [
                                30.36552,
                                1.20703
                            ],
                            [
                                30.44312,
                                1.2417
                            ],
                            [
                                30.71224,
                                1.50074
                            ],
                            [
                                31.0303,
                                1.75109
                            ],
                            [
                                31.23229,
                                1.99808
                            ],
                            [
                                31.3104,
                                2.11631
                            ],
                            [
                                31.29685,
                                2.164
                            ],
                            [
                                31.20398,
                                2.22925
                            ],
                            [
                                31.19543,
                                2.30401
                            ],
                            [
                                31.12086,
                                2.27876
                            ],
                            [
                                30.98697,
                                2.4078
                            ],
                            [
                                30.92419,
                                2.35483
                            ],
                            [
                                30.86795,
                                2.34621
                            ],
                            [
                                30.8245,
                                2.44137
                            ],
                            [
                                30.73069,
                                2.45035
                            ],
                            [
                                30.75523,
                                2.51584
                            ],
                            [
                                30.75536,
                                2.59788
                            ],
                            [
                                30.80423,
                                2.69689
                            ],
                            [
                                30.81665,
                                2.76608
                            ],
                            [
                                30.8532,
                                2.78729
                            ],
                            [
                                30.87881,
                                2.89119
                            ],
                            [
                                30.85351,
                                2.96056
                            ],
                            [
                                30.77281,
                                3.02887
                            ],
                            [
                                30.76411,
                                3.06694
                            ],
                            [
                                30.82477,
                                3.22818
                            ],
                            [
                                30.91125,
                                3.366
                            ],
                            [
                                30.93455,
                                3.42822
                            ],
                            [
                                30.92776,
                                3.50454
                            ],
                            [
                                30.85453,
                                3.48747
                            ],
                            [
                                30.85574,
                                3.56956
                            ],
                            [
                                30.79085,
                                3.60529
                            ],
                            [
                                30.78496,
                                3.65802
                            ],
                            [
                                30.71263,
                                3.62328
                            ],
                            [
                                30.67324,
                                3.63806
                            ],
                            [
                                30.59528,
                                3.59598
                            ],
                            [
                                30.55238,
                                3.86353
                            ],
                            [
                                30.49519,
                                3.85819
                            ],
                            [
                                30.26529,
                                3.95651
                            ],
                            [
                                30.22482,
                                3.93927
                            ],
                            [
                                30.15902,
                                4.09285
                            ],
                            [
                                30.0786,
                                4.11632
                            ],
                            [
                                30.03821,
                                4.19
                            ],
                            [
                                29.94458,
                                4.24386
                            ],
                            [
                                29.96386,
                                4.28065
                            ],
                            [
                                29.89764,
                                4.34688
                            ],
                            [
                                29.84194,
                                4.33781
                            ],
                            [
                                29.80021,
                                4.36714
                            ],
                            [
                                29.79316,
                                4.50977
                            ],
                            [
                                29.81769,
                                4.56203
                            ],
                            [
                                29.73211,
                                4.57869
                            ],
                            [
                                29.70857,
                                4.61721
                            ],
                            [
                                29.61129,
                                4.66011
                            ],
                            [
                                29.4634,
                                4.66328
                            ],
                            [
                                29.47299,
                                4.59358
                            ],
                            [
                                29.40844,
                                4.4833
                            ],
                            [
                                29.36849,
                                4.46837
                            ],
                            [
                                29.34157,
                                4.40633
                            ],
                            [
                                29.2658,
                                4.39278
                            ],
                            [
                                29.20427,
                                4.34114
                            ],
                            [
                                29.13387,
                                4.40875
                            ],
                            [
                                29.07882,
                                4.43066
                            ],
                            [
                                29.03732,
                                4.48124
                            ],
                            [
                                28.90244,
                                4.47282
                            ],
                            [
                                28.8057,
                                4.49285
                            ],
                            [
                                28.78918,
                                4.55692
                            ],
                            [
                                28.71349,
                                4.53184
                            ],
                            [
                                28.66258,
                                4.42051
                            ],
                            [
                                28.5999,
                                4.41346
                            ],
                            [
                                28.57966,
                                4.37595
                            ],
                            [
                                28.51195,
                                4.36916
                            ],
                            [
                                28.48557,
                                4.31245
                            ],
                            [
                                28.41241,
                                4.27353
                            ],
                            [
                                28.36733,
                                4.28661
                            ],
                            [
                                28.35158,
                                4.34942
                            ],
                            [
                                28.20338,
                                4.34844
                            ],
                            [
                                28.04118,
                                4.45565
                            ],
                            [
                                28.04268,
                                4.54369
                            ],
                            [
                                27.94129,
                                4.56783
                            ],
                            [
                                27.86922,
                                4.54912
                            ],
                            [
                                27.78735,
                                4.62618
                            ],
                            [
                                27.76767,
                                4.78561
                            ],
                            [
                                27.72748,
                                4.78625
                            ],
                            [
                                27.65715,
                                4.89237
                            ],
                            [
                                27.58069,
                                4.88695
                            ],
                            [
                                27.52007,
                                4.97545
                            ],
                            [
                                27.44361,
                                5.01944
                            ],
                            [
                                27.42592,
                                5.0821
                            ],
                            [
                                27.23022,
                                5.15317
                            ],
                            [
                                27.14906,
                                5.20145
                            ],
                            [
                                27.09389,
                                5.20837
                            ],
                            [
                                26.92999,
                                5.1424
                            ],
                            [
                                26.8543,
                                5.04104
                            ],
                            [
                                26.80387,
                                5.05154
                            ],
                            [
                                26.76839,
                                5.10279
                            ],
                            [
                                26.66578,
                                5.08248
                            ],
                            [
                                26.58359,
                                5.08639
                            ],
                            [
                                26.52088,
                                5.05
                            ],
                            [
                                26.38608,
                                5.1493
                            ],
                            [
                                26.2506,
                                5.17725
                            ],
                            [
                                26.20782,
                                5.23725
                            ],
                            [
                                26.13221,
                                5.26606
                            ],
                            [
                                26.09155,
                                5.21368
                            ],
                            [
                                25.95675,
                                5.21525
                            ],
                            [
                                25.8287,
                                5.1944
                            ],
                            [
                                25.77615,
                                5.25635
                            ],
                            [
                                25.70464,
                                5.30065
                            ],
                            [
                                25.59705,
                                5.32645
                            ],
                            [
                                25.56818,
                                5.38075
                            ],
                            [
                                25.50013,
                                5.34592
                            ],
                            [
                                25.38621,
                                5.31932
                            ],
                            [
                                25.34304,
                                5.27322
                            ],
                            [
                                25.30968,
                                5.1893
                            ],
                            [
                                25.34176,
                                5.10888
                            ],
                            [
                                25.30916,
                                5.03148
                            ],
                            [
                                25.16808,
                                5.00433
                            ],
                            [
                                25.12373,
                                5.0115
                            ],
                            [
                                25.06151,
                                4.92832
                            ],
                            [
                                24.95646,
                                4.98662
                            ],
                            [
                                24.86304,
                                4.95228
                            ],
                            [
                                24.77784,
                                4.89616
                            ],
                            [
                                24.67735,
                                4.91006
                            ],
                            [
                                24.65862,
                                4.9757
                            ],
                            [
                                24.53743,
                                5.07709
                            ],
                            [
                                24.37786,
                                5.11199
                            ],
                            [
                                24.33312,
                                5.01093
                            ],
                            [
                                24.27985,
                                4.99098
                            ],
                            [
                                24.13805,
                                4.89684
                            ],
                            [
                                24.11041,
                                4.91599
                            ],
                            [
                                24.04108,
                                4.86641
                            ],
                            [
                                23.97236,
                                4.87544
                            ],
                            [
                                23.95337,
                                4.81187
                            ],
                            [
                                23.8886,
                                4.83447
                            ],
                            [
                                23.81945,
                                4.82205
                            ],
                            [
                                23.77633,
                                4.78576
                            ],
                            [
                                23.59265,
                                4.76126
                            ],
                            [
                                23.53589,
                                4.69783
                            ],
                            [
                                23.45688,
                                4.67424
                            ],
                            [
                                23.42939,
                                4.60238
                            ],
                            [
                                23.3814,
                                4.59617
                            ],
                            [
                                23.27473,
                                4.63458
                            ],
                            [
                                23.19457,
                                4.72663
                            ],
                            [
                                23.11195,
                                4.71335
                            ],
                            [
                                23.00865,
                                4.75853
                            ],
                            [
                                22.98082,
                                4.82757
                            ],
                            [
                                22.90682,
                                4.81969
                            ],
                            [
                                22.89677,
                                4.75848
                            ],
                            [
                                22.8379,
                                4.70435
                            ],
                            [
                                22.7983,
                                4.72658
                            ],
                            [
                                22.73438,
                                4.62693
                            ],
                            [
                                22.72877,
                                4.55952
                            ],
                            [
                                22.67836,
                                4.47736
                            ],
                            [
                                22.60167,
                                4.47669
                            ],
                            [
                                22.57732,
                                4.34402
                            ],
                            [
                                22.54055,
                                4.27426
                            ],
                            [
                                22.54146,
                                4.2137
                            ],
                            [
                                22.48314,
                                4.15491
                            ],
                            [
                                22.37193,
                                4.1169
                            ],
                            [
                                22.27761,
                                4.11929
                            ],
                            [
                                22.19299,
                                4.14844
                            ],
                            [
                                22.09983,
                                4.21041
                            ],
                            [
                                21.99663,
                                4.2453
                            ],
                            [
                                21.85726,
                                4.2486
                            ],
                            [
                                21.73116,
                                4.30878
                            ],
                            [
                                21.64164,
                                4.30874
                            ],
                            [
                                21.56796,
                                4.25641
                            ],
                            [
                                21.40113,
                                4.27646
                            ],
                            [
                                21.33541,
                                4.29603
                            ],
                            [
                                21.29189,
                                4.33701
                            ],
                            [
                                21.21398,
                                4.29532
                            ],
                            [
                                21.11665,
                                4.34865
                            ],
                            [
                                21.07616,
                                4.39704
                            ],
                            [
                                20.86025,
                                4.4464
                            ],
                            [
                                20.80573,
                                4.42555
                            ],
                            [
                                20.58196,
                                4.41671
                            ],
                            [
                                20.4629,
                                4.51346
                            ],
                            [
                                20.45226,
                                4.62836
                            ],
                            [
                                20.33832,
                                4.76321
                            ],
                            [
                                20.26112,
                                4.78925
                            ],
                            [
                                20.16389,
                                4.8793
                            ],
                            [
                                20.10753,
                                4.90068
                            ],
                            [
                                20.01238,
                                4.97429
                            ],
                            [
                                19.90136,
                                4.99579
                            ],
                            [
                                19.85241,
                                5.07231
                            ],
                            [
                                19.80754,
                                5.10368
                            ],
                            [
                                19.68874,
                                5.14209
                            ],
                            [
                                19.61213,
                                5.13347
                            ],
                            [
                                19.53283,
                                5.14847
                            ],
                            [
                                19.47961,
                                5.12187
                            ],
                            [
                                19.39453,
                                5.11687
                            ],
                            [
                                19.34662,
                                5.06437
                            ],
                            [
                                19.25067,
                                5.01629
                            ],
                            [
                                19.18682,
                                4.94289
                            ],
                            [
                                19.094,
                                4.92453
                            ],
                            [
                                19.00181,
                                4.74794
                            ],
                            [
                                18.9378,
                                4.69859
                            ],
                            [
                                18.82774,
                                4.57171
                            ],
                            [
                                18.80034,
                                4.46339
                            ],
                            [
                                18.75569,
                                4.39701
                            ],
                            [
                                18.7005,
                                4.36509
                            ],
                            [
                                18.60021,
                                4.36969
                            ],
                            [
                                18.54293,
                                4.31945
                            ],
                            [
                                18.6,
                                4.22168
                            ],
                            [
                                18.64325,
                                4.10503
                            ],
                            [
                                18.65192,
                                3.99433
                            ],
                            [
                                18.61697,
                                3.91627
                            ],
                            [
                                18.61474,
                                3.81832
                            ],
                            [
                                18.59108,
                                3.76899
                            ],
                            [
                                18.60605,
                                3.5339
                            ],
                            [
                                18.62508,
                                3.47165
                            ],
                            [
                                18.64654,
                                3.24243
                            ],
                            [
                                18.59086,
                                3.10312
                            ],
                            [
                                18.52229,
                                3.0457
                            ],
                            [
                                18.45061,
                                2.88598
                            ],
                            [
                                18.42233,
                                2.75818
                            ],
                            [
                                18.34382,
                                2.6524
                            ],
                            [
                                18.32228,
                                2.59207
                            ],
                            [
                                18.2662,
                                2.53163
                            ],
                            [
                                18.18364,
                                2.37025
                            ],
                            [
                                18.18559,
                                2.3445
                            ],
                            [
                                18.09465,
                                2.27084
                            ],
                            [
                                18.07758,
                                2.14296
                            ],
                            [
                                18.07846,
                                1.98048
                            ],
                            [
                                18.09088,
                                1.93063
                            ],
                            [
                                18.05304,
                                1.82662
                            ],
                            [
                                18.07429,
                                1.75274
                            ],
                            [
                                18.07435,
                                1.55733
                            ],
                            [
                                18.04404,
                                1.4506
                            ],
                            [
                                17.95255,
                                1.31735
                            ],
                            [
                                17.91639,
                                1.12821
                            ],
                            [
                                17.86238,
                                1.05886
                            ],
                            [
                                17.84211,
                                0.96715
                            ],
                            [
                                17.84739,
                                0.89332
                            ],
                            [
                                17.87531,
                                0.8515
                            ],
                            [
                                17.86636,
                                0.70533
                            ],
                            [
                                17.87305,
                                0.57965
                            ],
                            [
                                17.94346,
                                0.52331
                            ],
                            [
                                17.96234,
                                0.38749
                            ],
                            [
                                17.91537,
                                0.30499
                            ],
                            [
                                17.82477,
                                0.24099
                            ],
                            [
                                17.77699,
                                0.14787
                            ],
                            [
                                17.75072,
                                -0.06691
                            ],
                            [
                                17.67392,
                                -0.17787
                            ],
                            [
                                17.66973,
                                -0.28387
                            ],
                            [
                                17.71836,
                                -0.36563
                            ],
                            [
                                17.70364,
                                -0.58127
                            ],
                            [
                                17.65994,
                                -0.65691
                            ],
                            [
                                17.58407,
                                -0.68871
                            ],
                            [
                                17.49909,
                                -0.75462
                            ],
                            [
                                17.43641,
                                -0.82404
                            ],
                            [
                                17.35374,
                                -0.98394
                            ],
                            [
                                17.28358,
                                -0.99091
                            ],
                            [
                                17.19697,
                                -1.04929
                            ],
                            [
                                17.10876,
                                -1.06524
                            ],
                            [
                                16.84082,
                                -1.26017
                            ],
                            [
                                16.71878,
                                -1.44577
                            ],
                            [
                                16.63706,
                                -1.62858
                            ],
                            [
                                16.57384,
                                -1.73341
                            ],
                            [
                                16.55654,
                                -1.84036
                            ],
                            [
                                16.41812,
                                -1.94267
                            ],
                            [
                                16.33989,
                                -2.05059
                            ],
                            [
                                16.22184,
                                -2.12612
                            ],
                            [
                                16.18844,
                                -2.18702
                            ],
                            [
                                16.17564,
                                -2.26611
                            ],
                            [
                                16.18121,
                                -2.4042
                            ],
                            [
                                16.23354,
                                -2.60016
                            ],
                            [
                                16.20288,
                                -2.71154
                            ],
                            [
                                16.17384,
                                -2.92409
                            ],
                            [
                                16.19274,
                                -3.01332
                            ],
                            [
                                16.1721,
                                -3.07788
                            ],
                            [
                                16.1872,
                                -3.19188
                            ],
                            [
                                16.17963,
                                -3.25398
                            ],
                            [
                                16.21499,
                                -3.30864
                            ],
                            [
                                16.1948,
                                -3.36837
                            ],
                            [
                                16.12342,
                                -3.47288
                            ],
                            [
                                16.09098,
                                -3.55725
                            ],
                            [
                                16.05041,
                                -3.60592
                            ],
                            [
                                15.88079,
                                -3.95675
                            ],
                            [
                                15.68029,
                                -3.99585
                            ],
                            [
                                15.57362,
                                -4.02918
                            ],
                            [
                                15.51967,
                                -4.07337
                            ],
                            [
                                15.4749,
                                -4.14936
                            ],
                            [
                                15.47662,
                                -4.22949
                            ],
                            [
                                15.40048,
                                -4.28472
                            ],
                            [
                                15.3279,
                                -4.27052
                            ],
                            [
                                15.19562,
                                -4.32604
                            ],
                            [
                                15.17393,
                                -4.38987
                            ],
                            [
                                15.10475,
                                -4.48292
                            ],
                            [
                                15.02829,
                                -4.54249
                            ],
                            [
                                14.90352,
                                -4.68184
                            ],
                            [
                                14.84467,
                                -4.81064
                            ],
                            [
                                14.68962,
                                -4.91143
                            ],
                            [
                                14.58827,
                                -4.9015
                            ],
                            [
                                14.55866,
                                -4.86417
                            ],
                            [
                                14.47495,
                                -4.84653
                            ],
                            [
                                14.4141,
                                -4.89074
                            ],
                            [
                                14.39727,
                                -4.80444
                            ],
                            [
                                14.41821,
                                -4.64918
                            ],
                            [
                                14.35276,
                                -4.55329
                            ],
                            [
                                14.4321,
                                -4.50946
                            ],
                            [
                                14.47888,
                                -4.43483
                            ],
                            [
                                14.42549,
                                -4.39675
                            ],
                            [
                                14.39184,
                                -4.3344
                            ],
                            [
                                14.28688,
                                -4.3229
                            ],
                            [
                                14.24871,
                                -4.36418
                            ],
                            [
                                14.16364,
                                -4.39868
                            ],
                            [
                                14.05157,
                                -4.41133
                            ],
                            [
                                13.94886,
                                -4.51362
                            ],
                            [
                                13.85667,
                                -4.49499
                            ],
                            [
                                13.82131,
                                -4.42623
                            ],
                            [
                                13.72431,
                                -4.4558
                            ],
                            [
                                13.73231,
                                -4.50357
                            ],
                            [
                                13.72297,
                                -4.70514
                            ],
                            [
                                13.57769,
                                -4.80271
                            ],
                            [
                                13.40154,
                                -4.86743
                            ],
                            [
                                13.3792,
                                -4.80027
                            ],
                            [
                                13.30767,
                                -4.7835
                            ],
                            [
                                13.14083,
                                -4.59527
                            ],
                            [
                                13.10641,
                                -4.59735
                            ],
                            [
                                13.10176,
                                -4.68505
                            ],
                            [
                                13.05093,
                                -4.67609
                            ],
                            [
                                12.92191,
                                -4.74749
                            ],
                            [
                                12.85762,
                                -4.75249
                            ],
                            [
                                12.81446,
                                -4.84101
                            ],
                            [
                                12.75962,
                                -4.87543
                            ],
                            [
                                12.72052,
                                -4.95001
                            ],
                            [
                                12.64471,
                                -4.94609
                            ],
                            [
                                12.60175,
                                -5.02614
                            ],
                            [
                                12.50338,
                                -5.04836
                            ],
                            [
                                12.46209,
                                -5.10004
                            ],
                            [
                                12.53667,
                                -5.18787
                            ],
                            [
                                12.53618,
                                -5.73648
                            ],
                            [
                                12.28812,
                                -5.7377
                            ],
                            [
                                12.19545,
                                -5.76388
                            ],
                            [
                                12.29483,
                                -5.89155
                            ],
                            [
                                12.40298,
                                -5.98737
                            ],
                            [
                                12.60109,
                                -5.90459
                            ],
                            [
                                12.65199,
                                -5.97511
                            ],
                            [
                                12.70037,
                                -5.99639
                            ],
                            [
                                12.76214,
                                -5.90873
                            ],
                            [
                                12.8911,
                                -5.84794
                            ],
                            [
                                13.08292,
                                -5.86404
                            ],
                            [
                                13.09929,
                                -5.88629
                            ],
                            [
                                13.22118,
                                -5.86208
                            ],
                            [
                                13.36213,
                                -5.90605
                            ],
                            [
                                13.37747,
                                -5.87294
                            ],
                            [
                                13.45674,
                                -5.84871
                            ],
                            [
                                13.54249,
                                -5.8647
                            ],
                            [
                                13.75972,
                                -5.8625
                            ],
                            [
                                13.97328,
                                -5.83642
                            ],
                            [
                                14.08119,
                                -5.86645
                            ],
                            [
                                14.24294,
                                -5.88554
                            ],
                            [
                                14.59434,
                                -5.90789
                            ],
                            [
                                14.71503,
                                -5.88038
                            ],
                            [
                                15.08111,
                                -5.86276
                            ],
                            [
                                15.67936,
                                -5.85718
                            ],
                            [
                                15.81473,
                                -5.86935
                            ],
                            [
                                16.21848,
                                -5.85261
                            ],
                            [
                                16.35981,
                                -5.85315
                            ],
                            [
                                16.44432,
                                -5.86705
                            ],
                            [
                                16.49129,
                                -5.84546
                            ],
                            [
                                16.58434,
                                -5.89024
                            ],
                            [
                                16.60607,
                                -6.06096
                            ],
                            [
                                16.64167,
                                -6.06596
                            ],
                            [
                                16.72749,
                                -6.16463
                            ],
                            [
                                16.70544,
                                -6.20626
                            ],
                            [
                                16.71854,
                                -6.32771
                            ],
                            [
                                16.6923,
                                -6.35188
                            ],
                            [
                                16.70955,
                                -6.47999
                            ],
                            [
                                16.74922,
                                -6.52199
                            ],
                            [
                                16.76356,
                                -6.70558
                            ],
                            [
                                16.84043,
                                -6.82519
                            ],
                            [
                                16.84017,
                                -6.87685
                            ],
                            [
                                16.90847,
                                -6.90925
                            ],
                            [
                                16.90457,
                                -7.01935
                            ],
                            [
                                16.96561,
                                -7.06663
                            ],
                            [
                                16.9181,
                                -7.10704
                            ],
                            [
                                16.94291,
                                -7.22704
                            ],
                            [
                                16.98177,
                                -7.29166
                            ],
                            [
                                17.02185,
                                -7.29542
                            ],
                            [
                                17.10472,
                                -7.34949
                            ],
                            [
                                17.10852,
                                -7.39537
                            ],
                            [
                                17.17825,
                                -7.42993
                            ],
                            [
                                17.2175,
                                -7.57695
                            ],
                            [
                                17.29029,
                                -7.62196
                            ],
                            [
                                17.29384,
                                -7.69031
                            ],
                            [
                                17.33679,
                                -7.77875
                            ],
                            [
                                17.44583,
                                -7.87077
                            ],
                            [
                                17.43873,
                                -7.90661
                            ],
                            [
                                17.48357,
                                -7.99817
                            ],
                            [
                                17.52752,
                                -8.04034
                            ],
                            [
                                17.54684,
                                -8.11632
                            ],
                            [
                                17.61657,
                                -8.12879
                            ],
                            [
                                17.683,
                                -8.10213
                            ],
                            [
                                17.7972,
                                -8.11059
                            ],
                            [
                                17.86633,
                                -8.07969
                            ],
                            [
                                17.96625,
                                -8.09595
                            ],
                            [
                                18.09789,
                                -8.09569
                            ],
                            [
                                18.18738,
                                -7.99773
                            ],
                            [
                                18.52767,
                                -7.99822
                            ],
                            [
                                18.53821,
                                -7.91618
                            ],
                            [
                                18.76978,
                                -7.91689
                            ],
                            [
                                18.80254,
                                -7.99896
                            ],
                            [
                                19.37946,
                                -7.99694
                            ],
                            [
                                19.34354,
                                -7.90024
                            ],
                            [
                                19.3655,
                                -7.85975
                            ],
                            [
                                19.40931,
                                -7.69427
                            ],
                            [
                                19.36944,
                                -7.59034
                            ],
                            [
                                19.47773,
                                -7.56891
                            ],
                            [
                                19.48729,
                                -7.50347
                            ],
                            [
                                19.54392,
                                -7.45675
                            ],
                            [
                                19.4866,
                                -7.31147
                            ],
                            [
                                19.52366,
                                -7.11079
                            ],
                            [
                                19.5618,
                                -7.05274
                            ],
                            [
                                19.55119,
                                -7.00232
                            ],
                            [
                                20.29848,
                                -6.99982
                            ],
                            [
                                20.32479,
                                -6.91675
                            ],
                            [
                                20.62542,
                                -6.91657
                            ],
                            [
                                20.59484,
                                -7.0617
                            ],
                            [
                                20.54648,
                                -7.14747
                            ],
                            [
                                20.55715,
                                -7.28211
                            ],
                            [
                                21.78607,
                                -7.28289
                            ],
                            [
                                21.82716,
                                -7.33803
                            ],
                            [
                                21.85836,
                                -7.42822
                            ],
                            [
                                21.8446,
                                -7.50835
                            ],
                            [
                                21.85068,
                                -7.60849
                            ],
                            [
                                21.77623,
                                -7.77337
                            ],
                            [
                                21.7764,
                                -7.9079
                            ],
                            [
                                21.75173,
                                -7.94044
                            ],
                            [
                                21.77595,
                                -8.02744
                            ],
                            [
                                21.82373,
                                -8.07111
                            ],
                            [
                                21.87248,
                                -8.1944
                            ],
                            [
                                21.89331,
                                -8.29202
                            ],
                            [
                                21.92495,
                                -8.30857
                            ],
                            [
                                21.91931,
                                -8.39223
                            ],
                            [
                                21.9519,
                                -8.50308
                            ],
                            [
                                21.89261,
                                -8.70451
                            ],
                            [
                                21.89754,
                                -8.76452
                            ],
                            [
                                21.86722,
                                -8.87514
                            ],
                            [
                                21.83602,
                                -9.063
                            ],
                            [
                                21.85784,
                                -9.22741
                            ],
                            [
                                21.80924,
                                -9.3315
                            ],
                            [
                                21.79143,
                                -9.41505
                            ],
                            [
                                21.82981,
                                -9.45793
                            ],
                            [
                                21.86463,
                                -9.56115
                            ],
                            [
                                21.87513,
                                -9.64836
                            ],
                            [
                                21.93365,
                                -9.68527
                            ],
                            [
                                22.01514,
                                -9.82139
                            ],
                            [
                                22.07007,
                                -9.87372
                            ],
                            [
                                22.14892,
                                -9.88768
                            ],
                            [
                                22.18691,
                                -9.92476
                            ],
                            [
                                22.21709,
                                -10.06717
                            ],
                            [
                                22.21641,
                                -10.15841
                            ],
                            [
                                22.27662,
                                -10.26172
                            ],
                            [
                                22.32696,
                                -10.38575
                            ],
                            [
                                22.27306,
                                -10.50739
                            ],
                            [
                                22.30658,
                                -10.53168
                            ],
                            [
                                22.32952,
                                -10.7513
                            ],
                            [
                                22.19568,
                                -10.83144
                            ],
                            [
                                22.16963,
                                -10.87546
                            ],
                            [
                                22.20453,
                                -10.93592
                            ],
                            [
                                22.21234,
                                -11.07956
                            ],
                            [
                                22.24929,
                                -11.13658
                            ],
                            [
                                22.27645,
                                -11.26119
                            ],
                            [
                                22.35005,
                                -11.17796
                            ],
                            [
                                22.4233,
                                -11.17845
                            ],
                            [
                                22.48704,
                                -11.13134
                            ],
                            [
                                22.51061,
                                -11.04312
                            ],
                            [
                                22.58526,
                                -11.03642
                            ],
                            [
                                22.65484,
                                -11.08304
                            ],
                            [
                                22.79259,
                                -11.11094
                            ],
                            [
                                22.85778,
                                -11.06303
                            ],
                            [
                                23.07198,
                                -11.12233
                            ],
                            [
                                23.14995,
                                -11.09379
                            ],
                            [
                                23.19088,
                                -11.10357
                            ],
                            [
                                23.43637,
                                -10.93838
                            ],
                            [
                                23.50853,
                                -10.9474
                            ],
                            [
                                23.58578,
                                -10.99306
                            ],
                            [
                                23.67235,
                                -11.00788
                            ],
                            [
                                23.73693,
                                -10.99345
                            ],
                            [
                                23.81545,
                                -11.02758
                            ],
                            [
                                23.87297,
                                -11.01642
                            ],
                            [
                                23.99953,
                                -10.88725
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.97755,
                                -5.89206
                            ],
                            [
                                12.87784,
                                -5.86069
                            ],
                            [
                                12.76918,
                                -5.92028
                            ],
                            [
                                12.79614,
                                -5.96557
                            ],
                            [
                                12.87574,
                                -5.90166
                            ],
                            [
                                12.97755,
                                -5.89206
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "DNK",
                "Country": "Denmark",
                "Total_3GHG": 0.18,
                "Total_3GHG_timeseries": [
                    3.8313e-06,
                    7.7601e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029
                ],
                "Fossil_3GHG": 0.2,
                "Fossil_3GHG_timeseries": [
                    3.0984e-07,
                    6.3456e-07,
                    9.7456e-07,
                    1.3632e-06,
                    1.7549e-06,
                    2.2393e-06,
                    2.7347e-06,
                    3.1548e-06,
                    3.6398e-06,
                    4.0896e-06,
                    4.6499e-06,
                    5.1623e-06,
                    5.7094e-06,
                    6.2063e-06,
                    6.869e-06,
                    7.4941e-06,
                    8.1076e-06,
                    8.7952e-06,
                    9.4173e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021
                ],
                "Land_3GHG": 0.15,
                "Land_3GHG_timeseries": [
                    3.5215e-06,
                    7.1255e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008
                ],
                "Total_CO2": 0.19,
                "Total_CO2_timeseries": [
                    2.655e-06,
                    5.3676e-06,
                    8.1249e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022
                ],
                "Fossil_CO2": 0.24,
                "Fossil_CO2_timeseries": [
                    1.4025e-07,
                    2.904e-07,
                    4.521e-07,
                    6.5835e-07,
                    8.6295e-07,
                    1.155e-06,
                    1.4537e-06,
                    1.6747e-06,
                    1.9569e-06,
                    2.2011e-06,
                    2.5542e-06,
                    2.8595e-06,
                    3.1994e-06,
                    3.4914e-06,
                    3.9485e-06,
                    4.3708e-06,
                    4.7833e-06,
                    5.2717e-06,
                    5.6974e-06,
                    6.2122e-06,
                    6.7468e-06,
                    7.26e-06,
                    7.7781e-06,
                    8.3374e-06,
                    8.9941e-06,
                    9.6888e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019
                ],
                "Land_CO2": 0.09,
                "Land_CO2_timeseries": [
                    2.5147e-06,
                    5.0772e-06,
                    7.6728e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Total_CH4": 0.11,
                "Total_CH4_timeseries": [
                    9.4124e-07,
                    1.9181e-06,
                    2.9294e-06,
                    3.9755e-06,
                    5.0571e-06,
                    6.1747e-06,
                    7.3275e-06,
                    8.5135e-06,
                    9.7341e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Fossil_CH4": 0.05,
                "Fossil_CH4_timeseries": [
                    8.9171e-08,
                    1.8232e-07,
                    2.7822e-07,
                    3.7722e-07,
                    4.7998e-07,
                    5.8722e-07,
                    6.9792e-07,
                    8.1007e-07,
                    9.2529e-07,
                    1.0427e-06,
                    1.161e-06,
                    1.2787e-06,
                    1.3958e-06,
                    1.5098e-06,
                    1.6242e-06,
                    1.7349e-06,
                    1.8434e-06,
                    1.9494e-06,
                    2.0521e-06,
                    2.1517e-06,
                    2.245e-06,
                    2.3313e-06,
                    2.4122e-06,
                    2.488e-06,
                    2.5585e-06,
                    2.6226e-06,
                    2.6814e-06,
                    2.7362e-06,
                    2.7855e-06,
                    2.8293e-06,
                    2.8665e-06,
                    2.8984e-06,
                    2.9245e-06,
                    2.9474e-06,
                    2.9647e-06,
                    2.9796e-06,
                    2.9906e-06,
                    2.9976e-06,
                    3.0011e-06,
                    2.9987e-06,
                    2.9931e-06,
                    2.9841e-06,
                    2.9699e-06,
                    2.9535e-06,
                    2.9346e-06,
                    2.9165e-06,
                    2.8971e-06,
                    2.8765e-06,
                    2.8553e-06,
                    2.8315e-06,
                    2.8054e-06,
                    2.7763e-06,
                    2.7445e-06,
                    2.7109e-06,
                    2.6722e-06,
                    2.6321e-06,
                    2.5862e-06,
                    2.5429e-06,
                    2.5007e-06,
                    2.4556e-06,
                    2.4117e-06,
                    2.3731e-06,
                    2.3363e-06,
                    2.298e-06,
                    2.2602e-06,
                    2.2178e-06,
                    2.1627e-06,
                    2.1107e-06,
                    2.0549e-06,
                    1.9961e-06,
                    1.935e-06,
                    1.8848e-06,
                    1.8373e-06,
                    1.7956e-06,
                    1.7488e-06,
                    1.6988e-06,
                    1.6619e-06,
                    1.6146e-06,
                    1.5733e-06,
                    1.5292e-06,
                    1.4851e-06,
                    1.4328e-06,
                    1.3794e-06,
                    1.3298e-06,
                    1.2801e-06,
                    1.2329e-06,
                    1.1976e-06,
                    1.1519e-06,
                    1.1142e-06,
                    1.0752e-06,
                    1.1197e-06,
                    1.2262e-06,
                    1.4192e-06,
                    1.6846e-06,
                    2.0417e-06,
                    2.5203e-06,
                    3.1157e-06,
                    3.8256e-06,
                    4.6526e-06,
                    5.6515e-06,
                    6.7962e-06,
                    8.0973e-06,
                    9.5551e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CH4": 0.2,
                "Land_CH4_timeseries": [
                    8.5207e-07,
                    1.7358e-06,
                    2.6512e-06,
                    3.5983e-06,
                    4.5771e-06,
                    5.5875e-06,
                    6.6296e-06,
                    7.7034e-06,
                    8.8088e-06,
                    9.946e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Total_N2O": 0.33,
                "Total_N2O_timeseries": [
                    2.3511e-07,
                    4.7432e-07,
                    7.1748e-07,
                    9.6438e-07,
                    1.2148e-06,
                    1.4683e-06,
                    1.7246e-06,
                    1.9832e-06,
                    2.2436e-06,
                    2.5054e-06,
                    2.768e-06,
                    3.0315e-06,
                    3.2958e-06,
                    3.5608e-06,
                    3.8265e-06,
                    4.0929e-06,
                    4.36e-06,
                    4.628e-06,
                    4.8967e-06,
                    5.1665e-06,
                    5.4402e-06,
                    5.7228e-06,
                    6.0185e-06,
                    6.3297e-06,
                    6.6581e-06,
                    7.0041e-06,
                    7.3669e-06,
                    7.7445e-06,
                    8.1336e-06,
                    8.5301e-06,
                    8.931e-06,
                    9.3356e-06,
                    9.7435e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_N2O": 0.34,
                "Fossil_N2O_timeseries": [
                    8.0415e-08,
                    1.6184e-07,
                    2.4424e-07,
                    3.2762e-07,
                    4.1192e-07,
                    4.9712e-07,
                    5.8316e-07,
                    6.7e-07,
                    7.5758e-07,
                    8.4583e-07,
                    9.3471e-07,
                    1.0242e-06,
                    1.1143e-06,
                    1.205e-06,
                    1.2964e-06,
                    1.3883e-06,
                    1.4808e-06,
                    1.574e-06,
                    1.6678e-06,
                    1.7622e-06,
                    1.8576e-06,
                    1.9545e-06,
                    2.0536e-06,
                    2.155e-06,
                    2.2589e-06,
                    2.3655e-06,
                    2.4745e-06,
                    2.5858e-06,
                    2.6991e-06,
                    2.8137e-06,
                    2.9293e-06,
                    3.0459e-06,
                    3.1634e-06,
                    3.2818e-06,
                    3.401e-06,
                    3.521e-06,
                    3.6419e-06,
                    3.7636e-06,
                    3.8861e-06,
                    4.0145e-06,
                    4.145e-06,
                    4.2777e-06,
                    4.4127e-06,
                    4.5502e-06,
                    4.6903e-06,
                    4.833e-06,
                    4.9785e-06,
                    5.1268e-06,
                    5.2781e-06,
                    5.4323e-06,
                    5.5898e-06,
                    5.751e-06,
                    5.9161e-06,
                    6.0854e-06,
                    6.2589e-06,
                    6.4365e-06,
                    6.6181e-06,
                    6.8036e-06,
                    6.9924e-06,
                    7.1842e-06,
                    7.3786e-06,
                    7.5752e-06,
                    7.774e-06,
                    7.9749e-06,
                    8.1776e-06,
                    8.3824e-06,
                    8.5891e-06,
                    8.7979e-06,
                    9.009e-06,
                    9.2225e-06,
                    9.4388e-06,
                    9.6585e-06,
                    9.8819e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_N2O": 0.33,
                "Land_N2O_timeseries": [
                    1.547e-07,
                    3.1249e-07,
                    4.7324e-07,
                    6.3677e-07,
                    8.0284e-07,
                    9.7116e-07,
                    1.1414e-06,
                    1.3132e-06,
                    1.4861e-06,
                    1.6595e-06,
                    1.8333e-06,
                    2.0073e-06,
                    2.1814e-06,
                    2.3557e-06,
                    2.5301e-06,
                    2.7046e-06,
                    2.8792e-06,
                    3.054e-06,
                    3.229e-06,
                    3.4043e-06,
                    3.5826e-06,
                    3.7683e-06,
                    3.9649e-06,
                    4.1747e-06,
                    4.3992e-06,
                    4.6387e-06,
                    4.8924e-06,
                    5.1586e-06,
                    5.4346e-06,
                    5.7165e-06,
                    6.0017e-06,
                    6.2897e-06,
                    6.5801e-06,
                    6.8725e-06,
                    7.1668e-06,
                    7.4627e-06,
                    7.7604e-06,
                    8.0599e-06,
                    8.3615e-06,
                    8.6271e-06,
                    8.9298e-06,
                    9.2673e-06,
                    9.6369e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                9.42015,
                                54.83196
                            ],
                            [
                                9.60661,
                                54.91059
                            ],
                            [
                                9.63879,
                                54.86095
                            ],
                            [
                                9.88787,
                                54.90665
                            ],
                            [
                                10.01272,
                                54.86902
                            ],
                            [
                                10.04458,
                                54.93106
                            ],
                            [
                                9.96541,
                                55.00576
                            ],
                            [
                                9.75921,
                                55.08304
                            ],
                            [
                                9.60678,
                                55.03559
                            ],
                            [
                                9.50197,
                                55.15775
                            ],
                            [
                                9.59002,
                                55.19281
                            ],
                            [
                                9.69286,
                                55.19657
                            ],
                            [
                                9.59657,
                                55.42437
                            ],
                            [
                                9.69339,
                                55.46047
                            ],
                            [
                                9.79604,
                                55.59436
                            ],
                            [
                                9.73806,
                                55.65807
                            ],
                            [
                                10.00999,
                                55.70055
                            ],
                            [
                                10.06186,
                                55.81002
                            ],
                            [
                                9.8918,
                                55.84299
                            ],
                            [
                                10.0731,
                                55.88413
                            ],
                            [
                                10.16348,
                                55.84503
                            ],
                            [
                                10.25834,
                                55.91217
                            ],
                            [
                                10.27162,
                                56.04643
                            ],
                            [
                                10.21842,
                                56.15835
                            ],
                            [
                                10.44624,
                                56.29147
                            ],
                            [
                                10.50468,
                                56.27461
                            ],
                            [
                                10.44499,
                                56.18099
                            ],
                            [
                                10.71501,
                                56.14314
                            ],
                            [
                                10.74187,
                                56.22331
                            ],
                            [
                                10.91479,
                                56.34445
                            ],
                            [
                                10.95955,
                                56.44173
                            ],
                            [
                                10.79629,
                                56.53786
                            ],
                            [
                                10.49654,
                                56.51423
                            ],
                            [
                                10.40557,
                                56.53292
                            ],
                            [
                                10.30308,
                                56.61078
                            ],
                            [
                                10.35304,
                                56.69144
                            ],
                            [
                                10.27738,
                                56.80096
                            ],
                            [
                                10.26303,
                                56.90023
                            ],
                            [
                                10.30565,
                                56.98235
                            ],
                            [
                                10.19134,
                                56.98732
                            ],
                            [
                                9.99916,
                                57.07839
                            ],
                            [
                                9.94242,
                                57.04855
                            ],
                            [
                                9.69656,
                                57.04059
                            ],
                            [
                                9.61895,
                                56.96962
                            ],
                            [
                                9.50136,
                                57.01472
                            ],
                            [
                                9.29583,
                                56.99846
                            ],
                            [
                                9.17992,
                                56.91883
                            ],
                            [
                                9.21024,
                                56.86312
                            ],
                            [
                                9.16868,
                                56.80721
                            ],
                            [
                                9.22249,
                                56.7166
                            ],
                            [
                                9.32512,
                                56.65933
                            ],
                            [
                                9.04566,
                                56.58488
                            ],
                            [
                                9.09624,
                                56.66559
                            ],
                            [
                                9.1781,
                                56.70742
                            ],
                            [
                                9.06563,
                                56.80262
                            ],
                            [
                                8.96396,
                                56.80181
                            ],
                            [
                                8.85383,
                                56.74333
                            ],
                            [
                                8.70303,
                                56.58487
                            ],
                            [
                                8.76303,
                                56.55247
                            ],
                            [
                                8.73246,
                                56.47877
                            ],
                            [
                                8.61473,
                                56.48067
                            ],
                            [
                                8.57634,
                                56.54362
                            ],
                            [
                                8.38454,
                                56.57851
                            ],
                            [
                                8.28635,
                                56.57636
                            ],
                            [
                                8.16687,
                                56.65638
                            ],
                            [
                                8.12474,
                                56.56349
                            ],
                            [
                                8.11591,
                                56.37937
                            ],
                            [
                                8.12996,
                                56.22888
                            ],
                            [
                                8.16767,
                                56.10574
                            ],
                            [
                                8.30045,
                                56.06022
                            ],
                            [
                                8.37416,
                                55.94874
                            ],
                            [
                                8.31281,
                                55.8647
                            ],
                            [
                                8.16847,
                                55.90636
                            ],
                            [
                                8.16367,
                                55.71822
                            ],
                            [
                                8.077,
                                55.55731
                            ],
                            [
                                8.17887,
                                55.53086
                            ],
                            [
                                8.29598,
                                55.5637
                            ],
                            [
                                8.46744,
                                55.45089
                            ],
                            [
                                8.62015,
                                55.42868
                            ],
                            [
                                8.67128,
                                55.33231
                            ],
                            [
                                8.65826,
                                55.23329
                            ],
                            [
                                8.56213,
                                55.15008
                            ],
                            [
                                8.68453,
                                55.14444
                            ],
                            [
                                8.63405,
                                55.03153
                            ],
                            [
                                8.63593,
                                54.91168
                            ],
                            [
                                8.72106,
                                54.89481
                            ],
                            [
                                8.9483,
                                54.90246
                            ],
                            [
                                9.04854,
                                54.87213
                            ],
                            [
                                9.24028,
                                54.84994
                            ],
                            [
                                9.25009,
                                54.80971
                            ],
                            [
                                9.42015,
                                54.83196
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.42451,
                                56.09483
                            ],
                            [
                                12.28701,
                                56.12947
                            ],
                            [
                                12.19473,
                                56.11302
                            ],
                            [
                                11.84272,
                                55.9662
                            ],
                            [
                                11.891,
                                55.94146
                            ],
                            [
                                12.00703,
                                55.96653
                            ],
                            [
                                12.02302,
                                55.9012
                            ],
                            [
                                11.88079,
                                55.81381
                            ],
                            [
                                11.83621,
                                55.68432
                            ],
                            [
                                11.74657,
                                55.73888
                            ],
                            [
                                11.7298,
                                55.83721
                            ],
                            [
                                11.75088,
                                55.96986
                            ],
                            [
                                11.63223,
                                55.93931
                            ],
                            [
                                11.52303,
                                55.95156
                            ],
                            [
                                11.51466,
                                55.86333
                            ],
                            [
                                11.37277,
                                55.83309
                            ],
                            [
                                11.37989,
                                55.77739
                            ],
                            [
                                11.26996,
                                55.73167
                            ],
                            [
                                11.17701,
                                55.75429
                            ],
                            [
                                10.99151,
                                55.72433
                            ],
                            [
                                11.07017,
                                55.67643
                            ],
                            [
                                11.15618,
                                55.55376
                            ],
                            [
                                11.12756,
                                55.52581
                            ],
                            [
                                11.20416,
                                55.44611
                            ],
                            [
                                11.20577,
                                55.34368
                            ],
                            [
                                11.24627,
                                55.2067
                            ],
                            [
                                11.43242,
                                55.21793
                            ],
                            [
                                11.71344,
                                55.15908
                            ],
                            [
                                11.75165,
                                55.08204
                            ],
                            [
                                11.89721,
                                54.99463
                            ],
                            [
                                12.02534,
                                54.96308
                            ],
                            [
                                12.17085,
                                55.00403
                            ],
                            [
                                12.12952,
                                55.04792
                            ],
                            [
                                12.18212,
                                55.11028
                            ],
                            [
                                12.04867,
                                55.12594
                            ],
                            [
                                12.02879,
                                55.16483
                            ],
                            [
                                12.27255,
                                55.24181
                            ],
                            [
                                12.35238,
                                55.23607
                            ],
                            [
                                12.45419,
                                55.28408
                            ],
                            [
                                12.44487,
                                55.34909
                            ],
                            [
                                12.36734,
                                55.39621
                            ],
                            [
                                12.20028,
                                55.44175
                            ],
                            [
                                12.19509,
                                55.4877
                            ],
                            [
                                12.31279,
                                55.57997
                            ],
                            [
                                12.51019,
                                55.63508
                            ],
                            [
                                12.59532,
                                55.68012
                            ],
                            [
                                12.57544,
                                55.84312
                            ],
                            [
                                12.51888,
                                55.91938
                            ],
                            [
                                12.62364,
                                56.04006
                            ],
                            [
                                12.49932,
                                56.09195
                            ],
                            [
                                12.42451,
                                56.09483
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                10.43242,
                                57.60333
                            ],
                            [
                                10.51423,
                                57.68027
                            ],
                            [
                                10.18691,
                                57.59846
                            ],
                            [
                                9.95744,
                                57.59462
                            ],
                            [
                                9.79339,
                                57.47592
                            ],
                            [
                                9.73046,
                                57.3958
                            ],
                            [
                                9.54628,
                                57.2314
                            ],
                            [
                                9.36256,
                                57.1561
                            ],
                            [
                                9.14831,
                                57.13865
                            ],
                            [
                                8.97002,
                                57.15712
                            ],
                            [
                                8.87512,
                                57.12029
                            ],
                            [
                                8.736,
                                57.10109
                            ],
                            [
                                8.62025,
                                57.12621
                            ],
                            [
                                8.36312,
                                56.95867
                            ],
                            [
                                8.22886,
                                56.78528
                            ],
                            [
                                8.30264,
                                56.75254
                            ],
                            [
                                8.35622,
                                56.67726
                            ],
                            [
                                8.48447,
                                56.63346
                            ],
                            [
                                8.60779,
                                56.63622
                            ],
                            [
                                8.4787,
                                56.72255
                            ],
                            [
                                8.47769,
                                56.79024
                            ],
                            [
                                8.63192,
                                56.86399
                            ],
                            [
                                8.6263,
                                56.88935
                            ],
                            [
                                8.66822,
                                56.95007
                            ],
                            [
                                8.75032,
                                56.94553
                            ],
                            [
                                8.99129,
                                57.01836
                            ],
                            [
                                9.13415,
                                57.0392
                            ],
                            [
                                9.24029,
                                56.99071
                            ],
                            [
                                9.48716,
                                57.04399
                            ],
                            [
                                9.57768,
                                57.04153
                            ],
                            [
                                9.78945,
                                57.10602
                            ],
                            [
                                9.93415,
                                57.054
                            ],
                            [
                                10.01606,
                                57.08703
                            ],
                            [
                                10.22571,
                                56.98881
                            ],
                            [
                                10.33113,
                                56.98927
                            ],
                            [
                                10.44224,
                                57.17039
                            ],
                            [
                                10.54571,
                                57.22746
                            ],
                            [
                                10.51911,
                                57.35734
                            ],
                            [
                                10.53591,
                                57.46722
                            ],
                            [
                                10.44392,
                                57.53834
                            ],
                            [
                                10.43242,
                                57.60333
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                10.41432,
                                55.58972
                            ],
                            [
                                10.32455,
                                55.61985
                            ],
                            [
                                10.03515,
                                55.55613
                            ],
                            [
                                9.93975,
                                55.51181
                            ],
                            [
                                9.78209,
                                55.5432
                            ],
                            [
                                9.74101,
                                55.47563
                            ],
                            [
                                9.80375,
                                55.45085
                            ],
                            [
                                9.93131,
                                55.21862
                            ],
                            [
                                10.01903,
                                55.18288
                            ],
                            [
                                10.10769,
                                55.19004
                            ],
                            [
                                10.21229,
                                55.06621
                            ],
                            [
                                10.51567,
                                55.02668
                            ],
                            [
                                10.74436,
                                55.07035
                            ],
                            [
                                10.81456,
                                55.23124
                            ],
                            [
                                10.8179,
                                55.31261
                            ],
                            [
                                10.76345,
                                55.38766
                            ],
                            [
                                10.62599,
                                55.49036
                            ],
                            [
                                10.52242,
                                55.46633
                            ],
                            [
                                10.41432,
                                55.58972
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                11.25606,
                                54.95765
                            ],
                            [
                                11.08011,
                                54.94287
                            ],
                            [
                                11.01596,
                                54.88862
                            ],
                            [
                                11.07738,
                                54.84766
                            ],
                            [
                                10.97305,
                                54.79515
                            ],
                            [
                                11.0029,
                                54.76257
                            ],
                            [
                                11.24354,
                                54.70735
                            ],
                            [
                                11.45988,
                                54.60915
                            ],
                            [
                                11.5809,
                                54.65725
                            ],
                            [
                                11.80629,
                                54.64575
                            ],
                            [
                                11.81741,
                                54.7326
                            ],
                            [
                                11.85105,
                                54.77362
                            ],
                            [
                                11.65956,
                                54.90101
                            ],
                            [
                                11.55494,
                                54.82885
                            ],
                            [
                                11.37842,
                                54.88545
                            ],
                            [
                                11.25606,
                                54.95765
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.92447,
                                55.21945
                            ],
                            [
                                14.78021,
                                55.29044
                            ],
                            [
                                14.71328,
                                55.22429
                            ],
                            [
                                14.69178,
                                55.09167
                            ],
                            [
                                14.77606,
                                55.0529
                            ],
                            [
                                15.08266,
                                54.98814
                            ],
                            [
                                15.15474,
                                55.07747
                            ],
                            [
                                15.15452,
                                55.13207
                            ],
                            [
                                14.92447,
                                55.21945
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                11.84223,
                                54.95897
                            ],
                            [
                                11.74305,
                                54.96031
                            ],
                            [
                                11.75605,
                                54.8563
                            ],
                            [
                                11.86026,
                                54.77545
                            ],
                            [
                                11.91081,
                                54.71604
                            ],
                            [
                                11.98092,
                                54.70164
                            ],
                            [
                                12.16633,
                                54.83518
                            ],
                            [
                                12.1195,
                                54.88729
                            ],
                            [
                                11.89133,
                                54.92187
                            ],
                            [
                                11.84223,
                                54.95897
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.91085,
                                56.95493
                            ],
                            [
                                8.81672,
                                56.90411
                            ],
                            [
                                8.63772,
                                56.88605
                            ],
                            [
                                8.64739,
                                56.85587
                            ],
                            [
                                8.54269,
                                56.78793
                            ],
                            [
                                8.64551,
                                56.66973
                            ],
                            [
                                8.77428,
                                56.69386
                            ],
                            [
                                8.87868,
                                56.79408
                            ],
                            [
                                8.91085,
                                56.95493
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                10.88769,
                                54.9879
                            ],
                            [
                                10.93539,
                                55.08337
                            ],
                            [
                                10.8766,
                                55.10219
                            ],
                            [
                                10.80912,
                                54.9956
                            ],
                            [
                                10.67473,
                                54.90827
                            ],
                            [
                                10.64161,
                                54.81384
                            ],
                            [
                                10.73292,
                                54.74112
                            ],
                            [
                                10.84315,
                                54.95064
                            ],
                            [
                                10.88769,
                                54.9879
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.27222,
                                55.0549
                            ],
                            [
                                12.27857,
                                54.98929
                            ],
                            [
                                12.12204,
                                54.95782
                            ],
                            [
                                12.14332,
                                54.88189
                            ],
                            [
                                12.2078,
                                54.88238
                            ],
                            [
                                12.31279,
                                54.95199
                            ],
                            [
                                12.50961,
                                54.9435
                            ],
                            [
                                12.52406,
                                55.00718
                            ],
                            [
                                12.3164,
                                55.02788
                            ],
                            [
                                12.27222,
                                55.0549
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                11.19877,
                                57.32062
                            ],
                            [
                                11.03019,
                                57.31902
                            ],
                            [
                                10.87286,
                                57.26456
                            ],
                            [
                                10.99592,
                                57.21679
                            ],
                            [
                                11.11316,
                                57.29755
                            ],
                            [
                                11.19877,
                                57.32062
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                10.58594,
                                55.94287
                            ],
                            [
                                10.52971,
                                55.85198
                            ],
                            [
                                10.5297,
                                55.79113
                            ],
                            [
                                10.6215,
                                55.76647
                            ],
                            [
                                10.64525,
                                55.84399
                            ],
                            [
                                10.58594,
                                55.94287
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.6287,
                                55.69528
                            ],
                            [
                                12.50716,
                                55.60787
                            ],
                            [
                                12.59238,
                                55.55487
                            ],
                            [
                                12.67941,
                                55.58826
                            ],
                            [
                                12.6287,
                                55.69528
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "DJI",
                "Country": "Djibouti",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    1.3531e-08,
                    2.7093e-08,
                    4.0681e-08,
                    5.4292e-08,
                    6.7924e-08,
                    8.1574e-08,
                    9.525e-08,
                    1.0894e-07,
                    1.2264e-07,
                    1.3631e-07,
                    1.5005e-07,
                    1.6382e-07,
                    1.7766e-07,
                    1.9156e-07,
                    2.0552e-07,
                    2.1955e-07,
                    2.3365e-07,
                    2.4783e-07,
                    2.6209e-07,
                    2.7643e-07,
                    2.9087e-07,
                    3.0542e-07,
                    3.2014e-07,
                    3.3506e-07,
                    3.5018e-07,
                    3.6551e-07,
                    3.8106e-07,
                    3.968e-07,
                    4.1271e-07,
                    4.2875e-07,
                    4.4482e-07,
                    4.6088e-07,
                    4.7694e-07,
                    4.9301e-07,
                    5.0908e-07,
                    5.2517e-07,
                    5.4127e-07,
                    5.5739e-07,
                    5.7353e-07,
                    5.8987e-07,
                    6.0622e-07,
                    6.2256e-07,
                    6.3891e-07,
                    6.5526e-07,
                    6.7163e-07,
                    6.8803e-07,
                    7.0446e-07,
                    7.2092e-07,
                    7.3742e-07,
                    7.5399e-07,
                    7.7066e-07,
                    7.8722e-07,
                    8.0383e-07,
                    8.2051e-07,
                    8.3723e-07,
                    8.5394e-07,
                    8.7072e-07,
                    8.8754e-07,
                    9.0454e-07,
                    9.2155e-07,
                    9.3986e-07,
                    9.594e-07,
                    9.802e-07,
                    1.0024e-06,
                    1.0259e-06,
                    1.0508e-06,
                    1.0772e-06,
                    1.1049e-06,
                    1.1341e-06,
                    1.1648e-06,
                    1.1971e-06,
                    1.2311e-06,
                    1.2668e-06,
                    1.3041e-06,
                    1.3433e-06,
                    1.3842e-06,
                    1.4268e-06,
                    1.471e-06,
                    1.517e-06,
                    1.5647e-06,
                    1.613e-06,
                    1.6616e-06,
                    1.7103e-06,
                    1.7594e-06,
                    1.8088e-06,
                    1.86e-06,
                    1.9132e-06,
                    1.9683e-06,
                    2.0256e-06,
                    2.086e-06,
                    2.1489e-06,
                    2.2149e-06,
                    2.2853e-06,
                    2.3609e-06,
                    2.4428e-06,
                    2.5311e-06,
                    2.6258e-06,
                    2.727e-06,
                    2.8336e-06,
                    2.9494e-06,
                    3.076e-06,
                    3.2066e-06,
                    3.3421e-06,
                    3.4831e-06,
                    3.6294e-06,
                    3.7756e-06,
                    3.9327e-06,
                    4.0961e-06,
                    4.2602e-06,
                    4.4316e-06,
                    4.6177e-06,
                    4.8182e-06,
                    5.0425e-06,
                    5.2871e-06,
                    5.5615e-06,
                    5.8649e-06,
                    6.1595e-06,
                    6.4941e-06,
                    6.828e-06,
                    7.2328e-06,
                    7.6764e-06,
                    8.1479e-06,
                    8.6268e-06,
                    9.143e-06,
                    9.708e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    1.4254e-09,
                    2.8609e-09,
                    4.3066e-09,
                    5.7623e-09,
                    7.228e-09,
                    8.7036e-09,
                    1.0189e-08,
                    1.1684e-08,
                    1.3188e-08,
                    1.4701e-08,
                    1.6231e-08,
                    1.7778e-08,
                    1.9342e-08,
                    2.0923e-08,
                    2.2521e-08,
                    2.4136e-08,
                    2.5767e-08,
                    2.7416e-08,
                    2.9082e-08,
                    3.0765e-08,
                    3.2466e-08,
                    3.4187e-08,
                    3.5931e-08,
                    3.7697e-08,
                    3.9487e-08,
                    4.13e-08,
                    4.3137e-08,
                    4.4997e-08,
                    4.6878e-08,
                    4.8779e-08,
                    5.0691e-08,
                    5.2614e-08,
                    5.4548e-08,
                    5.6492e-08,
                    5.8447e-08,
                    6.0413e-08,
                    6.2389e-08,
                    6.4375e-08,
                    6.6373e-08,
                    6.8393e-08,
                    7.0428e-08,
                    7.2477e-08,
                    7.4541e-08,
                    7.6619e-08,
                    7.8713e-08,
                    8.0822e-08,
                    8.2947e-08,
                    8.5087e-08,
                    8.7244e-08,
                    8.9417e-08,
                    9.1628e-08,
                    9.3878e-08,
                    9.6166e-08,
                    9.8493e-08,
                    1.0086e-07,
                    1.0326e-07,
                    1.057e-07,
                    1.0817e-07,
                    1.1068e-07,
                    1.1322e-07,
                    1.1592e-07,
                    1.1879e-07,
                    1.2182e-07,
                    1.2501e-07,
                    1.2836e-07,
                    1.3188e-07,
                    1.3555e-07,
                    1.3938e-07,
                    1.4338e-07,
                    1.4753e-07,
                    1.5193e-07,
                    1.5657e-07,
                    1.6147e-07,
                    1.6665e-07,
                    1.7212e-07,
                    1.7788e-07,
                    1.8391e-07,
                    1.9023e-07,
                    1.9684e-07,
                    2.0376e-07,
                    2.1091e-07,
                    2.1828e-07,
                    2.2589e-07,
                    2.3376e-07,
                    2.419e-07,
                    2.5032e-07,
                    2.5905e-07,
                    2.6815e-07,
                    2.7759e-07,
                    2.8737e-07,
                    2.9761e-07,
                    3.0831e-07,
                    3.1949e-07,
                    3.3117e-07,
                    3.4384e-07,
                    3.5753e-07,
                    3.7232e-07,
                    3.8821e-07,
                    4.0525e-07,
                    4.288e-07,
                    4.6081e-07,
                    4.942e-07,
                    5.3082e-07,
                    5.7073e-07,
                    6.1398e-07,
                    6.5523e-07,
                    7.0543e-07,
                    7.5957e-07,
                    8.1097e-07,
                    8.671e-07,
                    9.2861e-07,
                    9.9607e-07,
                    1.0769e-06,
                    1.1718e-06,
                    1.2896e-06,
                    1.4217e-06,
                    1.5352e-06,
                    1.6707e-06,
                    1.7961e-06,
                    1.981e-06,
                    2.1947e-06,
                    2.4325e-06,
                    2.6776e-06,
                    2.9452e-06,
                    3.2359e-06,
                    3.5542e-06,
                    3.9048e-06,
                    4.2904e-06,
                    4.782e-06,
                    5.2951e-06,
                    5.8017e-06,
                    6.3423e-06,
                    6.8899e-06,
                    7.45e-06,
                    8.0331e-06,
                    8.6534e-06,
                    9.3183e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [
                    1.2105e-08,
                    2.4232e-08,
                    3.6374e-08,
                    4.853e-08,
                    6.0696e-08,
                    7.2871e-08,
                    8.5061e-08,
                    9.7254e-08,
                    1.0945e-07,
                    1.2161e-07,
                    1.3381e-07,
                    1.4605e-07,
                    1.5831e-07,
                    1.7063e-07,
                    1.83e-07,
                    1.9541e-07,
                    2.0788e-07,
                    2.2042e-07,
                    2.3301e-07,
                    2.4567e-07,
                    2.584e-07,
                    2.7124e-07,
                    2.8421e-07,
                    2.9736e-07,
                    3.1069e-07,
                    3.2421e-07,
                    3.3792e-07,
                    3.518e-07,
                    3.6583e-07,
                    3.7997e-07,
                    3.9412e-07,
                    4.0826e-07,
                    4.2239e-07,
                    4.3652e-07,
                    4.5064e-07,
                    4.6476e-07,
                    4.7888e-07,
                    4.9301e-07,
                    5.0715e-07,
                    5.2147e-07,
                    5.3579e-07,
                    5.5009e-07,
                    5.6437e-07,
                    5.7864e-07,
                    5.9292e-07,
                    6.0721e-07,
                    6.2151e-07,
                    6.3583e-07,
                    6.5018e-07,
                    6.6458e-07,
                    6.7904e-07,
                    6.9334e-07,
                    7.0766e-07,
                    7.2201e-07,
                    7.3637e-07,
                    7.5068e-07,
                    7.6502e-07,
                    7.7937e-07,
                    7.9386e-07,
                    8.0833e-07,
                    8.2394e-07,
                    8.4061e-07,
                    8.5838e-07,
                    8.7737e-07,
                    8.9752e-07,
                    9.1896e-07,
                    9.4163e-07,
                    9.6551e-07,
                    9.907e-07,
                    1.0172e-06,
                    1.0452e-06,
                    1.0745e-06,
                    1.1053e-06,
                    1.1375e-06,
                    1.1711e-06,
                    1.2063e-06,
                    1.2429e-06,
                    1.2808e-06,
                    1.3202e-06,
                    1.361e-06,
                    1.4021e-06,
                    1.4433e-06,
                    1.4844e-06,
                    1.5256e-06,
                    1.5669e-06,
                    1.6097e-06,
                    1.6541e-06,
                    1.7002e-06,
                    1.748e-06,
                    1.7986e-06,
                    1.8513e-06,
                    1.9066e-06,
                    1.9658e-06,
                    2.0297e-06,
                    2.0989e-06,
                    2.1735e-06,
                    2.2535e-06,
                    2.3387e-06,
                    2.4283e-06,
                    2.5206e-06,
                    2.6152e-06,
                    2.7124e-06,
                    2.8113e-06,
                    2.9123e-06,
                    3.0154e-06,
                    3.1204e-06,
                    3.2273e-06,
                    3.3365e-06,
                    3.4492e-06,
                    3.5645e-06,
                    3.6891e-06,
                    3.8221e-06,
                    3.9656e-06,
                    4.1153e-06,
                    4.2719e-06,
                    4.4432e-06,
                    4.6243e-06,
                    4.8234e-06,
                    5.0319e-06,
                    5.2519e-06,
                    5.4817e-06,
                    5.7154e-06,
                    5.9492e-06,
                    6.1979e-06,
                    6.4722e-06,
                    6.7533e-06,
                    7.0896e-06,
                    7.4459e-06,
                    7.7973e-06,
                    8.1766e-06,
                    8.5364e-06,
                    8.892e-06,
                    9.2957e-06,
                    9.7293e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    6.622e-09,
                    1.3233e-08,
                    1.9828e-08,
                    2.6406e-08,
                    3.2967e-08,
                    3.9512e-08,
                    4.6052e-08,
                    5.2575e-08,
                    5.9092e-08,
                    6.556e-08,
                    7.2001e-08,
                    7.8403e-08,
                    8.4777e-08,
                    9.1135e-08,
                    9.7471e-08,
                    1.0379e-07,
                    1.101e-07,
                    1.164e-07,
                    1.2269e-07,
                    1.2899e-07,
                    1.3526e-07,
                    1.415e-07,
                    1.4771e-07,
                    1.5389e-07,
                    1.6005e-07,
                    1.6619e-07,
                    1.7232e-07,
                    1.7843e-07,
                    1.8453e-07,
                    1.9062e-07,
                    1.9668e-07,
                    2.0269e-07,
                    2.0865e-07,
                    2.1458e-07,
                    2.2047e-07,
                    2.2634e-07,
                    2.3219e-07,
                    2.3801e-07,
                    2.4381e-07,
                    2.4963e-07,
                    2.5541e-07,
                    2.6113e-07,
                    2.6679e-07,
                    2.724e-07,
                    2.7796e-07,
                    2.8349e-07,
                    2.8899e-07,
                    2.9446e-07,
                    2.999e-07,
                    3.0534e-07,
                    3.108e-07,
                    3.1605e-07,
                    3.2127e-07,
                    3.2647e-07,
                    3.3163e-07,
                    3.3668e-07,
                    3.417e-07,
                    3.4666e-07,
                    3.517e-07,
                    3.5663e-07,
                    3.6155e-07,
                    3.6633e-07,
                    3.7096e-07,
                    3.7554e-07,
                    3.7997e-07,
                    3.8436e-07,
                    3.8866e-07,
                    3.9285e-07,
                    3.9704e-07,
                    4.0129e-07,
                    4.054e-07,
                    4.0938e-07,
                    4.1322e-07,
                    4.1689e-07,
                    4.2047e-07,
                    4.24e-07,
                    4.2744e-07,
                    4.308e-07,
                    4.3416e-07,
                    4.3769e-07,
                    4.4096e-07,
                    4.4381e-07,
                    4.4613e-07,
                    4.4813e-07,
                    4.4985e-07,
                    4.5132e-07,
                    4.526e-07,
                    4.5368e-07,
                    4.546e-07,
                    4.5618e-07,
                    4.5689e-07,
                    4.5572e-07,
                    4.5315e-07,
                    4.4908e-07,
                    4.439e-07,
                    4.3754e-07,
                    4.3018e-07,
                    4.2242e-07,
                    4.1413e-07,
                    4.0979e-07,
                    4.1149e-07,
                    4.1298e-07,
                    4.1538e-07,
                    4.1907e-07,
                    4.2373e-07,
                    4.2501e-07,
                    4.3188e-07,
                    4.3812e-07,
                    4.3625e-07,
                    4.2923e-07,
                    4.2332e-07,
                    4.2434e-07,
                    4.3759e-07,
                    4.6271e-07,
                    5.0806e-07,
                    5.6671e-07,
                    6.0561e-07,
                    6.6239e-07,
                    7.0485e-07,
                    7.74e-07,
                    8.5505e-07,
                    9.5065e-07,
                    1.0426e-06,
                    1.1427e-06,
                    1.2456e-06,
                    1.3496e-06,
                    1.4549e-06,
                    1.5632e-06,
                    1.7453e-06,
                    1.9221e-06,
                    2.0789e-06,
                    2.2584e-06,
                    2.439e-06,
                    2.6222e-06,
                    2.8105e-06,
                    3.009e-06,
                    3.214e-06,
                    3.4028e-06,
                    3.6124e-06,
                    3.7835e-06,
                    3.9535e-06,
                    4.1195e-06,
                    4.2776e-06,
                    4.4319e-06,
                    4.5855e-06,
                    4.7294e-06,
                    4.8808e-06,
                    5.0575e-06,
                    5.2333e-06,
                    5.3935e-06,
                    5.5383e-06,
                    5.6859e-06,
                    5.8446e-06,
                    6.0014e-06,
                    6.1681e-06,
                    6.3411e-06,
                    6.5406e-06,
                    6.7627e-06,
                    6.9649e-06,
                    7.205e-06,
                    7.4285e-06,
                    7.6607e-06,
                    7.9256e-06,
                    8.1151e-06,
                    8.325e-06,
                    8.5136e-06,
                    8.7086e-06,
                    8.9242e-06,
                    9.1465e-06,
                    9.3399e-06,
                    9.5661e-06,
                    9.7926e-06
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    4.95e-09,
                    1.65e-08,
                    2.805e-08,
                    4.125e-08,
                    5.61e-08,
                    7.26e-08,
                    8.58e-08,
                    1.056e-07,
                    1.2705e-07,
                    1.4355e-07,
                    1.617e-07,
                    1.815e-07,
                    2.0295e-07,
                    2.3265e-07,
                    2.706e-07,
                    3.2505e-07,
                    3.8775e-07,
                    4.2735e-07,
                    4.818e-07,
                    5.1975e-07,
                    5.8245e-07,
                    6.5505e-07,
                    7.4085e-07,
                    8.217e-07,
                    9.0915e-07,
                    9.9825e-07,
                    1.0874e-06,
                    1.1764e-06,
                    1.2672e-06,
                    1.4306e-06,
                    1.5873e-06,
                    1.7226e-06,
                    1.8794e-06,
                    2.0361e-06,
                    2.1945e-06,
                    2.3562e-06,
                    2.5261e-06,
                    2.7011e-06,
                    2.8578e-06,
                    3.0327e-06,
                    3.1664e-06,
                    3.3016e-06,
                    3.4386e-06,
                    3.5756e-06,
                    3.7108e-06,
                    3.8511e-06,
                    3.9897e-06,
                    4.1398e-06,
                    4.3131e-06,
                    4.4863e-06,
                    4.6513e-06,
                    4.8164e-06,
                    4.9962e-06,
                    5.1859e-06,
                    5.3691e-06,
                    5.5555e-06,
                    5.742e-06,
                    5.9499e-06,
                    6.1743e-06,
                    6.374e-06,
                    6.6066e-06,
                    6.8195e-06,
                    7.0389e-06,
                    7.2896e-06,
                    7.4645e-06,
                    7.6588e-06,
                    7.83e-06,
                    8.0064e-06,
                    8.2023e-06,
                    8.4043e-06,
                    8.5765e-06,
                    8.7814e-06,
                    8.9854e-06
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [
                    6.622e-09,
                    1.3233e-08,
                    1.9828e-08,
                    2.6406e-08,
                    3.2967e-08,
                    3.9512e-08,
                    4.6052e-08,
                    5.2575e-08,
                    5.9092e-08,
                    6.556e-08,
                    7.2001e-08,
                    7.8403e-08,
                    8.4777e-08,
                    9.1135e-08,
                    9.7471e-08,
                    1.0379e-07,
                    1.101e-07,
                    1.164e-07,
                    1.2269e-07,
                    1.2899e-07,
                    1.3526e-07,
                    1.415e-07,
                    1.4771e-07,
                    1.5389e-07,
                    1.6005e-07,
                    1.6619e-07,
                    1.7232e-07,
                    1.7843e-07,
                    1.8453e-07,
                    1.9062e-07,
                    1.9668e-07,
                    2.0269e-07,
                    2.0865e-07,
                    2.1458e-07,
                    2.2047e-07,
                    2.2634e-07,
                    2.3219e-07,
                    2.3801e-07,
                    2.4381e-07,
                    2.4963e-07,
                    2.5541e-07,
                    2.6113e-07,
                    2.6679e-07,
                    2.724e-07,
                    2.7796e-07,
                    2.8349e-07,
                    2.8899e-07,
                    2.9446e-07,
                    2.999e-07,
                    3.0534e-07,
                    3.108e-07,
                    3.1605e-07,
                    3.2127e-07,
                    3.2647e-07,
                    3.3163e-07,
                    3.3668e-07,
                    3.417e-07,
                    3.4666e-07,
                    3.517e-07,
                    3.5663e-07,
                    3.6155e-07,
                    3.6633e-07,
                    3.7096e-07,
                    3.7554e-07,
                    3.7997e-07,
                    3.8436e-07,
                    3.8866e-07,
                    3.9285e-07,
                    3.9704e-07,
                    4.0129e-07,
                    4.054e-07,
                    4.0938e-07,
                    4.1322e-07,
                    4.1689e-07,
                    4.2047e-07,
                    4.24e-07,
                    4.2744e-07,
                    4.308e-07,
                    4.3416e-07,
                    4.3769e-07,
                    4.4096e-07,
                    4.4381e-07,
                    4.4613e-07,
                    4.4813e-07,
                    4.4985e-07,
                    4.5132e-07,
                    4.526e-07,
                    4.5368e-07,
                    4.546e-07,
                    4.5618e-07,
                    4.5689e-07,
                    4.5572e-07,
                    4.5315e-07,
                    4.4908e-07,
                    4.439e-07,
                    4.3754e-07,
                    4.3018e-07,
                    4.2242e-07,
                    4.1413e-07,
                    4.0484e-07,
                    3.9499e-07,
                    3.8493e-07,
                    3.7413e-07,
                    3.6297e-07,
                    3.5113e-07,
                    3.3921e-07,
                    3.2628e-07,
                    3.1107e-07,
                    2.927e-07,
                    2.6753e-07,
                    2.4182e-07,
                    2.2139e-07,
                    2.0494e-07,
                    1.9211e-07,
                    1.8301e-07,
                    1.7896e-07,
                    1.7826e-07,
                    1.8059e-07,
                    1.851e-07,
                    1.9155e-07,
                    2e-07,
                    2.098e-07,
                    2.2088e-07,
                    2.3356e-07,
                    2.4735e-07,
                    2.6226e-07,
                    2.7847e-07,
                    2.9596e-07,
                    3.1479e-07,
                    3.3482e-07,
                    3.5629e-07,
                    3.7908e-07,
                    4.0292e-07,
                    4.2772e-07,
                    4.5427e-07,
                    4.8284e-07,
                    5.1294e-07,
                    5.4496e-07,
                    5.7975e-07,
                    6.1717e-07,
                    6.5185e-07,
                    6.8088e-07,
                    7.0206e-07,
                    7.2106e-07,
                    7.3444e-07,
                    7.3972e-07,
                    7.4093e-07,
                    7.4445e-07,
                    7.4698e-07,
                    7.4218e-07,
                    7.2191e-07,
                    6.8973e-07,
                    6.5866e-07,
                    6.3226e-07,
                    6.1256e-07,
                    5.9913e-07,
                    5.9071e-07,
                    5.884e-07,
                    5.9091e-07,
                    5.9838e-07,
                    6.0908e-07,
                    6.2179e-07,
                    6.3603e-07,
                    6.5064e-07,
                    6.662e-07,
                    6.8357e-07,
                    7.022e-07,
                    7.2196e-07,
                    7.4217e-07,
                    7.6335e-07,
                    7.8473e-07,
                    8.0724e-07
                ],
                "Total_CH4": 0.01,
                "Total_CH4_timeseries": [
                    4.5309e-09,
                    9.0656e-09,
                    1.3604e-08,
                    1.8147e-08,
                    2.2693e-08,
                    2.7243e-08,
                    3.1798e-08,
                    3.6356e-08,
                    4.0918e-08,
                    4.5483e-08,
                    5.0123e-08,
                    5.4838e-08,
                    5.9626e-08,
                    6.4488e-08,
                    6.9425e-08,
                    7.4436e-08,
                    7.9521e-08,
                    8.468e-08,
                    8.9913e-08,
                    9.5221e-08,
                    1.006e-07,
                    1.0606e-07,
                    1.116e-07,
                    1.1721e-07,
                    1.229e-07,
                    1.2866e-07,
                    1.345e-07,
                    1.4042e-07,
                    1.4641e-07,
                    1.5248e-07,
                    1.5856e-07,
                    1.6466e-07,
                    1.7076e-07,
                    1.7688e-07,
                    1.8301e-07,
                    1.8916e-07,
                    1.9531e-07,
                    2.0148e-07,
                    2.0766e-07,
                    2.1385e-07,
                    2.2006e-07,
                    2.2628e-07,
                    2.3251e-07,
                    2.3875e-07,
                    2.4501e-07,
                    2.5128e-07,
                    2.5756e-07,
                    2.6385e-07,
                    2.7016e-07,
                    2.7648e-07,
                    2.8283e-07,
                    2.8922e-07,
                    2.9564e-07,
                    3.0209e-07,
                    3.0857e-07,
                    3.1509e-07,
                    3.2163e-07,
                    3.282e-07,
                    3.348e-07,
                    3.4143e-07,
                    3.4925e-07,
                    3.5826e-07,
                    3.6847e-07,
                    3.7986e-07,
                    3.9244e-07,
                    4.0622e-07,
                    4.2118e-07,
                    4.3733e-07,
                    4.5467e-07,
                    4.7319e-07,
                    4.9322e-07,
                    5.1474e-07,
                    5.3779e-07,
                    5.6236e-07,
                    5.8847e-07,
                    6.1614e-07,
                    6.4533e-07,
                    6.7606e-07,
                    7.0834e-07,
                    7.4218e-07,
                    7.768e-07,
                    8.1221e-07,
                    8.4841e-07,
                    8.8542e-07,
                    9.2325e-07,
                    9.6324e-07,
                    1.0055e-06,
                    1.05e-06,
                    1.0969e-06,
                    1.1463e-06,
                    1.1983e-06,
                    1.2531e-06,
                    1.3108e-06,
                    1.3713e-06,
                    1.4353e-06,
                    1.5029e-06,
                    1.5741e-06,
                    1.6491e-06,
                    1.728e-06,
                    1.8111e-06,
                    1.8993e-06,
                    1.9925e-06,
                    2.0911e-06,
                    2.1955e-06,
                    2.306e-06,
                    2.4217e-06,
                    2.5443e-06,
                    2.6751e-06,
                    2.8157e-06,
                    2.969e-06,
                    3.1318e-06,
                    3.3014e-06,
                    3.4816e-06,
                    3.6694e-06,
                    3.8662e-06,
                    4.0774e-06,
                    4.2984e-06,
                    4.5395e-06,
                    4.7932e-06,
                    5.0896e-06,
                    5.4117e-06,
                    5.7464e-06,
                    6.0918e-06,
                    6.4643e-06,
                    6.8798e-06,
                    7.3252e-06,
                    7.8528e-06,
                    8.4301e-06,
                    9.0328e-06,
                    9.6866e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_CH4": 0.01,
                "Fossil_CH4_timeseries": [
                    5.1754e-10,
                    1.0356e-09,
                    1.5542e-09,
                    2.0732e-09,
                    2.5928e-09,
                    3.1129e-09,
                    3.6336e-09,
                    4.1547e-09,
                    4.6764e-09,
                    5.1986e-09,
                    5.7294e-09,
                    6.2687e-09,
                    6.8166e-09,
                    7.3731e-09,
                    7.9382e-09,
                    8.5118e-09,
                    9.094e-09,
                    9.6848e-09,
                    1.0284e-08,
                    1.0892e-08,
                    1.1509e-08,
                    1.2134e-08,
                    1.2768e-08,
                    1.3411e-08,
                    1.4063e-08,
                    1.4723e-08,
                    1.5392e-08,
                    1.607e-08,
                    1.6757e-08,
                    1.7452e-08,
                    1.8149e-08,
                    1.8847e-08,
                    1.9546e-08,
                    2.0247e-08,
                    2.095e-08,
                    2.1654e-08,
                    2.2359e-08,
                    2.3066e-08,
                    2.3775e-08,
                    2.4484e-08,
                    2.5196e-08,
                    2.5908e-08,
                    2.6623e-08,
                    2.7338e-08,
                    2.8056e-08,
                    2.8774e-08,
                    2.9494e-08,
                    3.0216e-08,
                    3.0939e-08,
                    3.1664e-08,
                    3.2411e-08,
                    3.318e-08,
                    3.397e-08,
                    3.478e-08,
                    3.5611e-08,
                    3.646e-08,
                    3.7327e-08,
                    3.8213e-08,
                    3.9115e-08,
                    4.0035e-08,
                    4.1105e-08,
                    4.2326e-08,
                    4.3697e-08,
                    4.5218e-08,
                    4.6888e-08,
                    4.8707e-08,
                    5.0674e-08,
                    5.2789e-08,
                    5.505e-08,
                    5.7457e-08,
                    6.0097e-08,
                    6.2968e-08,
                    6.6091e-08,
                    6.9475e-08,
                    7.313e-08,
                    7.7067e-08,
                    8.1267e-08,
                    8.5737e-08,
                    9.0487e-08,
                    9.5526e-08,
                    1.0077e-07,
                    1.0623e-07,
                    1.1191e-07,
                    1.1782e-07,
                    1.2397e-07,
                    1.3038e-07,
                    1.3708e-07,
                    1.4412e-07,
                    1.5146e-07,
                    1.5913e-07,
                    1.6721e-07,
                    1.7574e-07,
                    1.8471e-07,
                    1.9413e-07,
                    2.0451e-07,
                    2.1588e-07,
                    2.2829e-07,
                    2.4178e-07,
                    2.5636e-07,
                    2.7247e-07,
                    2.9039e-07,
                    3.0964e-07,
                    3.3042e-07,
                    3.5279e-07,
                    3.7678e-07,
                    4.0202e-07,
                    4.2956e-07,
                    4.5933e-07,
                    4.9127e-07,
                    5.2625e-07,
                    5.6493e-07,
                    6.0788e-07,
                    6.5592e-07,
                    7.0978e-07,
                    7.6998e-07,
                    8.3621e-07,
                    9.0689e-07,
                    9.8466e-07,
                    1.0689e-06,
                    1.1874e-06,
                    1.3247e-06,
                    1.4728e-06,
                    1.6331e-06,
                    1.8087e-06,
                    2.0052e-06,
                    2.2282e-06,
                    2.4828e-06,
                    2.7703e-06,
                    3.0901e-06,
                    3.4371e-06,
                    3.8008e-06,
                    4.1764e-06,
                    4.5598e-06,
                    4.9547e-06,
                    5.3691e-06,
                    5.8124e-06,
                    6.2939e-06,
                    6.8139e-06,
                    7.3758e-06,
                    7.9505e-06,
                    8.522e-06,
                    9.1267e-06,
                    9.7599e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CH4": 0.01,
                "Land_CH4_timeseries": [
                    4.0133e-09,
                    8.03e-09,
                    1.205e-08,
                    1.6074e-08,
                    2.01e-08,
                    2.413e-08,
                    2.8164e-08,
                    3.2201e-08,
                    3.6241e-08,
                    4.0285e-08,
                    4.4394e-08,
                    4.8569e-08,
                    5.2809e-08,
                    5.7115e-08,
                    6.1487e-08,
                    6.5924e-08,
                    7.0427e-08,
                    7.4995e-08,
                    7.9629e-08,
                    8.4329e-08,
                    8.9095e-08,
                    9.393e-08,
                    9.8831e-08,
                    1.038e-07,
                    1.0884e-07,
                    1.1394e-07,
                    1.1911e-07,
                    1.2435e-07,
                    1.2966e-07,
                    1.3503e-07,
                    1.4042e-07,
                    1.4581e-07,
                    1.5122e-07,
                    1.5663e-07,
                    1.6206e-07,
                    1.675e-07,
                    1.7295e-07,
                    1.7841e-07,
                    1.8389e-07,
                    1.8937e-07,
                    1.9486e-07,
                    2.0037e-07,
                    2.0589e-07,
                    2.1141e-07,
                    2.1695e-07,
                    2.225e-07,
                    2.2807e-07,
                    2.3364e-07,
                    2.3922e-07,
                    2.4482e-07,
                    2.5042e-07,
                    2.5604e-07,
                    2.6167e-07,
                    2.6731e-07,
                    2.7296e-07,
                    2.7863e-07,
                    2.843e-07,
                    2.8999e-07,
                    2.9569e-07,
                    3.014e-07,
                    3.0815e-07,
                    3.1594e-07,
                    3.2477e-07,
                    3.3464e-07,
                    3.4556e-07,
                    3.5751e-07,
                    3.7051e-07,
                    3.8454e-07,
                    3.9962e-07,
                    4.1574e-07,
                    4.3312e-07,
                    4.5178e-07,
                    4.717e-07,
                    4.9289e-07,
                    5.1535e-07,
                    5.3907e-07,
                    5.6406e-07,
                    5.9033e-07,
                    6.1785e-07,
                    6.4665e-07,
                    6.7603e-07,
                    7.0597e-07,
                    7.365e-07,
                    7.676e-07,
                    7.9928e-07,
                    8.3286e-07,
                    8.6838e-07,
                    9.0591e-07,
                    9.4548e-07,
                    9.8714e-07,
                    1.0311e-06,
                    1.0774e-06,
                    1.126e-06,
                    1.1772e-06,
                    1.2308e-06,
                    1.287e-06,
                    1.3459e-06,
                    1.4074e-06,
                    1.4716e-06,
                    1.5387e-06,
                    1.6089e-06,
                    1.6828e-06,
                    1.7607e-06,
                    1.8427e-06,
                    1.9292e-06,
                    2.0197e-06,
                    2.1148e-06,
                    2.2158e-06,
                    2.3244e-06,
                    2.4427e-06,
                    2.5669e-06,
                    2.6936e-06,
                    2.8257e-06,
                    2.9597e-06,
                    3.0963e-06,
                    3.2412e-06,
                    3.3915e-06,
                    3.5548e-06,
                    3.7243e-06,
                    3.9022e-06,
                    4.087e-06,
                    4.2736e-06,
                    4.4587e-06,
                    4.6556e-06,
                    4.8747e-06,
                    5.0971e-06,
                    5.37e-06,
                    5.6598e-06,
                    5.9427e-06,
                    6.2495e-06,
                    6.5378e-06,
                    6.8211e-06,
                    7.1456e-06,
                    7.4961e-06,
                    7.8777e-06,
                    8.2687e-06,
                    8.6898e-06,
                    9.1386e-06,
                    9.6142e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_N2O": 0.01,
                "Total_N2O_timeseries": [
                    2.3778e-09,
                    4.7946e-09,
                    7.2492e-09,
                    9.7398e-09,
                    1.2264e-08,
                    1.4819e-08,
                    1.7401e-08,
                    2.0007e-08,
                    2.2632e-08,
                    2.5271e-08,
                    2.7922e-08,
                    3.0583e-08,
                    3.3254e-08,
                    3.5934e-08,
                    3.8624e-08,
                    4.1323e-08,
                    4.4032e-08,
                    4.6751e-08,
                    4.948e-08,
                    5.2221e-08,
                    5.4999e-08,
                    5.786e-08,
                    6.0837e-08,
                    6.3955e-08,
                    6.7226e-08,
                    7.0655e-08,
                    7.4234e-08,
                    7.7945e-08,
                    8.1762e-08,
                    8.5646e-08,
                    8.9571e-08,
                    9.3533e-08,
                    9.7526e-08,
                    1.0155e-07,
                    1.056e-07,
                    1.0967e-07,
                    1.1377e-07,
                    1.179e-07,
                    1.2205e-07,
                    1.2638e-07,
                    1.3075e-07,
                    1.3516e-07,
                    1.3961e-07,
                    1.4411e-07,
                    1.4866e-07,
                    1.5326e-07,
                    1.5791e-07,
                    1.6261e-07,
                    1.6736e-07,
                    1.7217e-07,
                    1.7703e-07,
                    1.8195e-07,
                    1.8692e-07,
                    1.9194e-07,
                    1.9703e-07,
                    2.0217e-07,
                    2.0739e-07,
                    2.1267e-07,
                    2.1804e-07,
                    2.2349e-07,
                    2.2906e-07,
                    2.348e-07,
                    2.4077e-07,
                    2.4698e-07,
                    2.5347e-07,
                    2.6025e-07,
                    2.6734e-07,
                    2.7471e-07,
                    2.8237e-07,
                    2.9029e-07,
                    2.9848e-07,
                    3.0696e-07,
                    3.1576e-07,
                    3.2488e-07,
                    3.3431e-07,
                    3.4403e-07,
                    3.54e-07,
                    3.6418e-07,
                    3.745e-07,
                    3.8488e-07,
                    3.9525e-07,
                    4.0556e-07,
                    4.1575e-07,
                    4.2581e-07,
                    4.3571e-07,
                    4.4546e-07,
                    4.5508e-07,
                    4.646e-07,
                    4.7405e-07,
                    4.8351e-07,
                    4.9375e-07,
                    5.0607e-07,
                    5.2142e-07,
                    5.4047e-07,
                    5.6354e-07,
                    5.9064e-07,
                    6.2146e-07,
                    6.5539e-07,
                    6.9147e-07,
                    7.2844e-07,
                    7.6519e-07,
                    8.0109e-07,
                    8.3564e-07,
                    8.6854e-07,
                    8.9963e-07,
                    9.2891e-07,
                    9.5652e-07,
                    9.8281e-07,
                    1.0082e-06,
                    1.0335e-06,
                    1.0625e-06,
                    1.0924e-06,
                    1.1233e-06,
                    1.1549e-06,
                    1.1872e-06,
                    1.2208e-06,
                    1.2556e-06,
                    1.2922e-06,
                    1.33e-06,
                    1.3692e-06,
                    1.4096e-06,
                    1.4508e-06,
                    1.4925e-06,
                    1.536e-06,
                    1.5826e-06,
                    1.6326e-06,
                    1.6866e-06,
                    1.7431e-06,
                    1.8012e-06,
                    1.863e-06,
                    1.9206e-06,
                    1.9785e-06,
                    2.0412e-06,
                    2.1064e-06,
                    2.1755e-06,
                    2.2468e-06,
                    2.3232e-06,
                    2.4029e-06,
                    2.4905e-06,
                    2.5836e-06,
                    2.6797e-06,
                    2.7746e-06,
                    2.8711e-06,
                    2.9708e-06,
                    3.077e-06,
                    3.1874e-06,
                    3.2988e-06,
                    3.4119e-06,
                    3.5296e-06,
                    3.643e-06,
                    3.7568e-06,
                    3.871e-06,
                    3.9856e-06,
                    4.101e-06,
                    4.2166e-06,
                    4.3311e-06,
                    4.4465e-06,
                    4.5629e-06,
                    4.679e-06,
                    4.7961e-06,
                    4.912e-06,
                    5.0305e-06,
                    5.1494e-06,
                    5.2692e-06,
                    5.3889e-06,
                    5.5089e-06,
                    5.6305e-06,
                    5.7521e-06,
                    5.8737e-06,
                    5.9959e-06,
                    6.119e-06,
                    6.2423e-06
                ],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [
                    9.0781e-10,
                    1.8253e-09,
                    2.7524e-09,
                    3.6891e-09,
                    4.6352e-09,
                    5.5906e-09,
                    6.5552e-09,
                    7.5288e-09,
                    8.5111e-09,
                    9.5021e-09,
                    1.0501e-08,
                    1.1509e-08,
                    1.2525e-08,
                    1.355e-08,
                    1.4583e-08,
                    1.5624e-08,
                    1.6673e-08,
                    1.7731e-08,
                    1.8798e-08,
                    1.9873e-08,
                    2.0957e-08,
                    2.2053e-08,
                    2.3162e-08,
                    2.4286e-08,
                    2.5424e-08,
                    2.6577e-08,
                    2.7745e-08,
                    2.8927e-08,
                    3.0122e-08,
                    3.1327e-08,
                    3.2542e-08,
                    3.3767e-08,
                    3.5001e-08,
                    3.6245e-08,
                    3.7497e-08,
                    3.8759e-08,
                    4.0029e-08,
                    4.1309e-08,
                    4.2598e-08,
                    4.3909e-08,
                    4.5233e-08,
                    4.6569e-08,
                    4.7918e-08,
                    4.9281e-08,
                    5.0657e-08,
                    5.2048e-08,
                    5.3452e-08,
                    5.4871e-08,
                    5.6305e-08,
                    5.7753e-08,
                    5.9217e-08,
                    6.0698e-08,
                    6.2196e-08,
                    6.3713e-08,
                    6.5248e-08,
                    6.6801e-08,
                    6.8372e-08,
                    6.996e-08,
                    7.1564e-08,
                    7.3182e-08,
                    7.4815e-08,
                    7.646e-08,
                    7.8119e-08,
                    7.979e-08,
                    8.1473e-08,
                    8.3168e-08,
                    8.4876e-08,
                    8.6595e-08,
                    8.8328e-08,
                    9.0073e-08,
                    9.183e-08,
                    9.3601e-08,
                    9.5384e-08,
                    9.718e-08,
                    9.8988e-08,
                    1.0081e-07,
                    1.0265e-07,
                    1.0449e-07,
                    1.0636e-07,
                    1.0824e-07,
                    1.1013e-07,
                    1.1205e-07,
                    1.1398e-07,
                    1.1594e-07,
                    1.1792e-07,
                    1.1993e-07,
                    1.2197e-07,
                    1.2403e-07,
                    1.2613e-07,
                    1.2824e-07,
                    1.3039e-07,
                    1.3257e-07,
                    1.3479e-07,
                    1.3704e-07,
                    1.3933e-07,
                    1.4165e-07,
                    1.4403e-07,
                    1.4644e-07,
                    1.4889e-07,
                    1.5138e-07,
                    1.5392e-07,
                    1.5651e-07,
                    1.5915e-07,
                    1.6185e-07,
                    1.646e-07,
                    1.6741e-07,
                    1.7027e-07,
                    1.7319e-07,
                    1.7615e-07,
                    1.7915e-07,
                    1.8218e-07,
                    1.8524e-07,
                    1.8833e-07,
                    1.9145e-07,
                    1.9459e-07,
                    1.9776e-07,
                    2.0097e-07,
                    2.0421e-07,
                    2.075e-07,
                    2.1115e-07,
                    2.1488e-07,
                    2.1877e-07,
                    2.2286e-07,
                    2.2728e-07,
                    2.3245e-07,
                    2.387e-07,
                    2.455e-07,
                    2.529e-07,
                    2.6135e-07,
                    2.7065e-07,
                    2.7832e-07,
                    2.866e-07,
                    2.9406e-07,
                    3.0089e-07,
                    3.0778e-07,
                    3.1488e-07,
                    3.2336e-07,
                    3.3123e-07,
                    3.4331e-07,
                    3.5702e-07,
                    3.7324e-07,
                    3.8804e-07,
                    4.027e-07,
                    4.1782e-07,
                    4.3342e-07,
                    4.4917e-07,
                    4.6498e-07,
                    4.8087e-07,
                    4.9747e-07,
                    5.0992e-07,
                    5.225e-07,
                    5.354e-07,
                    5.4875e-07,
                    5.6219e-07,
                    5.7565e-07,
                    5.8919e-07,
                    6.0334e-07,
                    6.1857e-07,
                    6.3338e-07,
                    6.4915e-07,
                    6.6385e-07,
                    6.8036e-07,
                    6.9732e-07,
                    7.147e-07,
                    7.3166e-07,
                    7.4856e-07,
                    7.6627e-07,
                    7.8448e-07,
                    8.0256e-07,
                    8.2101e-07,
                    8.4006e-07,
                    8.5932e-07
                ],
                "Land_N2O": 0.01,
                "Land_N2O_timeseries": [
                    1.47e-09,
                    2.9693e-09,
                    4.4968e-09,
                    6.0507e-09,
                    7.6287e-09,
                    9.2282e-09,
                    1.0846e-08,
                    1.2478e-08,
                    1.4121e-08,
                    1.5769e-08,
                    1.742e-08,
                    1.9074e-08,
                    2.0728e-08,
                    2.2384e-08,
                    2.4041e-08,
                    2.5699e-08,
                    2.7358e-08,
                    2.9019e-08,
                    3.0682e-08,
                    3.2348e-08,
                    3.4042e-08,
                    3.5807e-08,
                    3.7675e-08,
                    3.9669e-08,
                    4.1802e-08,
                    4.4077e-08,
                    4.6488e-08,
                    4.9018e-08,
                    5.164e-08,
                    5.4319e-08,
                    5.7029e-08,
                    5.9766e-08,
                    6.2525e-08,
                    6.5304e-08,
                    6.81e-08,
                    7.0912e-08,
                    7.3741e-08,
                    7.6587e-08,
                    7.9452e-08,
                    8.2468e-08,
                    8.5513e-08,
                    8.8587e-08,
                    9.1693e-08,
                    9.4831e-08,
                    9.8004e-08,
                    1.0121e-07,
                    1.0446e-07,
                    1.0774e-07,
                    1.1106e-07,
                    1.1442e-07,
                    1.1781e-07,
                    1.2125e-07,
                    1.2472e-07,
                    1.2823e-07,
                    1.3178e-07,
                    1.3537e-07,
                    1.3901e-07,
                    1.4271e-07,
                    1.4647e-07,
                    1.503e-07,
                    1.5424e-07,
                    1.5834e-07,
                    1.6265e-07,
                    1.6719e-07,
                    1.72e-07,
                    1.7709e-07,
                    1.8246e-07,
                    1.8812e-07,
                    1.9404e-07,
                    2.0022e-07,
                    2.0665e-07,
                    2.1336e-07,
                    2.2038e-07,
                    2.277e-07,
                    2.3532e-07,
                    2.4322e-07,
                    2.5136e-07,
                    2.5969e-07,
                    2.6814e-07,
                    2.7664e-07,
                    2.8512e-07,
                    2.9351e-07,
                    3.0177e-07,
                    3.0987e-07,
                    3.1779e-07,
                    3.2553e-07,
                    3.3311e-07,
                    3.4056e-07,
                    3.4793e-07,
                    3.5526e-07,
                    3.6336e-07,
                    3.7349e-07,
                    3.8664e-07,
                    4.0343e-07,
                    4.2421e-07,
                    4.4898e-07,
                    4.7744e-07,
                    5.0895e-07,
                    5.4258e-07,
                    5.7706e-07,
                    6.1127e-07,
                    6.4458e-07,
                    6.7649e-07,
                    7.067e-07,
                    7.3503e-07,
                    7.615e-07,
                    7.8625e-07,
                    8.0962e-07,
                    8.3209e-07,
                    8.5431e-07,
                    8.8036e-07,
                    9.0712e-07,
                    9.35e-07,
                    9.635e-07,
                    9.9265e-07,
                    1.0231e-06,
                    1.0546e-06,
                    1.088e-06,
                    1.1225e-06,
                    1.1581e-06,
                    1.1947e-06,
                    1.232e-06,
                    1.2696e-06,
                    1.3087e-06,
                    1.3502e-06,
                    1.3939e-06,
                    1.4411e-06,
                    1.4901e-06,
                    1.5398e-06,
                    1.5923e-06,
                    1.6423e-06,
                    1.6919e-06,
                    1.7472e-06,
                    1.8055e-06,
                    1.8677e-06,
                    1.9319e-06,
                    1.9998e-06,
                    2.0717e-06,
                    2.1472e-06,
                    2.2265e-06,
                    2.3065e-06,
                    2.3865e-06,
                    2.4684e-06,
                    2.5529e-06,
                    2.6436e-06,
                    2.7382e-06,
                    2.8338e-06,
                    2.9311e-06,
                    3.0321e-06,
                    3.1331e-06,
                    3.2343e-06,
                    3.3356e-06,
                    3.4368e-06,
                    3.5388e-06,
                    3.6409e-06,
                    3.7419e-06,
                    3.8431e-06,
                    3.9443e-06,
                    4.0456e-06,
                    4.1469e-06,
                    4.2482e-06,
                    4.3501e-06,
                    4.4521e-06,
                    4.5545e-06,
                    4.6572e-06,
                    4.7604e-06,
                    4.8642e-06,
                    4.9676e-06,
                    5.0711e-06,
                    5.1749e-06,
                    5.2789e-06,
                    5.383e-06
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            43.26032,
                            11.46059
                        ],
                        [
                            43.19536,
                            11.51392
                        ],
                        [
                            43.15342,
                            11.59267
                        ],
                        [
                            43.10269,
                            11.57903
                        ],
                        [
                            42.94372,
                            11.59428
                        ],
                        [
                            42.80301,
                            11.58593
                        ],
                        [
                            42.69702,
                            11.54219
                        ],
                        [
                            42.68281,
                            11.4764
                        ],
                        [
                            42.59915,
                            11.4689
                        ],
                        [
                            42.52604,
                            11.52373
                        ],
                        [
                            42.58427,
                            11.56443
                        ],
                        [
                            42.67987,
                            11.55737
                        ],
                        [
                            42.69906,
                            11.63359
                        ],
                        [
                            42.7836,
                            11.7475
                        ],
                        [
                            42.87279,
                            11.785
                        ],
                        [
                            42.94466,
                            11.77197
                        ],
                        [
                            42.9789,
                            11.80444
                        ],
                        [
                            43.05389,
                            11.81073
                        ],
                        [
                            43.18289,
                            11.94975
                        ],
                        [
                            43.36724,
                            11.98023
                        ],
                        [
                            43.41644,
                            12.09218
                        ],
                        [
                            43.40755,
                            12.21824
                        ],
                        [
                            43.37429,
                            12.27447
                        ],
                        [
                            43.35604,
                            12.3809
                        ],
                        [
                            43.15911,
                            12.64449
                        ],
                        [
                            43.12605,
                            12.71006
                        ],
                        [
                            42.88463,
                            12.61712
                        ],
                        [
                            42.85915,
                            12.55265
                        ],
                        [
                            42.8025,
                            12.50812
                        ],
                        [
                            42.82374,
                            12.43315
                        ],
                        [
                            42.69896,
                            12.35605
                        ],
                        [
                            42.53994,
                            12.49317
                        ],
                        [
                            42.46372,
                            12.52244
                        ],
                        [
                            42.40428,
                            12.46864
                        ],
                        [
                            42.33998,
                            12.38055
                        ],
                        [
                            42.31544,
                            12.30732
                        ],
                        [
                            42.22311,
                            12.21558
                        ],
                        [
                            42.09471,
                            12.0112
                        ],
                        [
                            41.95767,
                            11.81478
                        ],
                        [
                            41.89361,
                            11.75558
                        ],
                        [
                            41.83413,
                            11.73053
                        ],
                        [
                            41.80907,
                            11.65954
                        ],
                        [
                            41.80421,
                            11.57254
                        ],
                        [
                            41.77224,
                            11.49409
                        ],
                        [
                            41.80332,
                            11.36029
                        ],
                        [
                            41.80334,
                            11.01133
                        ],
                        [
                            41.82476,
                            10.96586
                        ],
                        [
                            41.97446,
                            10.92766
                        ],
                        [
                            42.06781,
                            10.92568
                        ],
                        [
                            42.11059,
                            10.97046
                        ],
                        [
                            42.2614,
                            10.97119
                        ],
                        [
                            42.34802,
                            11.00182
                        ],
                        [
                            42.42403,
                            10.98349
                        ],
                        [
                            42.50647,
                            11.03975
                        ],
                        [
                            42.62991,
                            11.09556
                        ],
                        [
                            42.68991,
                            11.05771
                        ],
                        [
                            42.76003,
                            11.0742
                        ],
                        [
                            42.79052,
                            10.99026
                        ],
                        [
                            42.91598,
                            10.97667
                        ],
                        [
                            42.96806,
                            10.99743
                        ],
                        [
                            43.26032,
                            11.46059
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "DMA",
                "Country": "Dominica",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    2.0353e-08,
                    4.1482e-08,
                    6.3173e-08,
                    8.4541e-08,
                    1.0479e-07,
                    1.2725e-07,
                    1.4964e-07,
                    1.7026e-07,
                    1.9295e-07,
                    2.1187e-07,
                    2.3212e-07,
                    2.5036e-07,
                    2.6786e-07,
                    2.8343e-07,
                    3.0166e-07,
                    3.1691e-07,
                    3.3354e-07,
                    3.4934e-07,
                    3.6515e-07,
                    3.7965e-07,
                    3.9413e-07,
                    4.039e-07,
                    4.1315e-07,
                    4.2305e-07,
                    4.3327e-07,
                    4.4297e-07,
                    4.5115e-07,
                    4.5894e-07,
                    4.6649e-07,
                    4.7079e-07,
                    4.7273e-07,
                    4.7323e-07,
                    4.7209e-07,
                    4.6764e-07,
                    4.6183e-07,
                    4.5461e-07,
                    4.4559e-07,
                    4.3514e-07,
                    4.2306e-07,
                    4.2484e-07,
                    4.3157e-07,
                    4.4199e-07,
                    4.5577e-07,
                    4.7313e-07,
                    4.9271e-07,
                    5.117e-07,
                    5.3216e-07,
                    5.5513e-07,
                    5.7934e-07,
                    6.0348e-07,
                    6.271e-07,
                    6.5045e-07,
                    6.7505e-07,
                    7.0134e-07,
                    7.2941e-07,
                    7.5886e-07,
                    7.8879e-07,
                    8.208e-07,
                    8.543e-07,
                    8.8026e-07,
                    9.0514e-07,
                    9.3072e-07,
                    9.5551e-07,
                    9.804e-07,
                    1.0051e-06,
                    1.0299e-06,
                    1.0545e-06,
                    1.0792e-06,
                    1.1037e-06,
                    1.125e-06,
                    1.1439e-06,
                    1.1609e-06,
                    1.1758e-06,
                    1.189e-06,
                    1.2003e-06,
                    1.2097e-06,
                    1.2176e-06,
                    1.2239e-06,
                    1.2288e-06,
                    1.2573e-06,
                    1.2966e-06,
                    1.3421e-06,
                    1.3919e-06,
                    1.4465e-06,
                    1.5051e-06,
                    1.5672e-06,
                    1.6338e-06,
                    1.7044e-06,
                    1.7795e-06,
                    1.8345e-06,
                    1.8833e-06,
                    1.9309e-06,
                    1.9788e-06,
                    2.0281e-06,
                    2.0792e-06,
                    2.1327e-06,
                    2.1895e-06,
                    2.2494e-06,
                    2.3125e-06,
                    2.3823e-06,
                    2.4531e-06,
                    2.5359e-06,
                    2.6349e-06,
                    2.7287e-06,
                    2.817e-06,
                    2.9063e-06,
                    2.9951e-06,
                    3.085e-06,
                    3.1789e-06,
                    3.2622e-06,
                    3.4146e-06,
                    3.5139e-06,
                    3.5999e-06,
                    3.6937e-06,
                    3.8491e-06,
                    3.9499e-06,
                    4.0185e-06,
                    4.0748e-06,
                    4.1223e-06,
                    4.1656e-06,
                    4.2034e-06,
                    4.2389e-06,
                    4.2726e-06,
                    4.3141e-06,
                    4.3505e-06,
                    4.3898e-06,
                    4.4298e-06,
                    4.4853e-06,
                    4.5302e-06,
                    4.5782e-06,
                    4.6257e-06,
                    4.6833e-06,
                    4.7437e-06,
                    4.8107e-06,
                    4.8767e-06,
                    4.9508e-06,
                    5.0299e-06,
                    5.1145e-06,
                    5.2075e-06,
                    5.3039e-06,
                    5.3984e-06,
                    5.4936e-06,
                    5.6018e-06,
                    5.7036e-06,
                    5.8086e-06,
                    5.9105e-06,
                    6.0143e-06,
                    6.1677e-06,
                    6.3121e-06,
                    6.4669e-06,
                    6.6043e-06,
                    6.7178e-06,
                    6.8254e-06,
                    6.9372e-06,
                    7.0434e-06,
                    7.1699e-06,
                    7.2698e-06,
                    7.3741e-06,
                    7.4632e-06,
                    7.5565e-06,
                    7.6511e-06,
                    7.7527e-06,
                    7.8387e-06,
                    7.9241e-06,
                    8.0103e-06,
                    8.0993e-06,
                    8.1783e-06,
                    8.2591e-06,
                    8.3455e-06,
                    8.4274e-06,
                    8.5058e-06,
                    8.5875e-06
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    2.199e-09,
                    4.4229e-09,
                    6.6949e-09,
                    9.0148e-09,
                    1.1382e-08,
                    1.3833e-08,
                    1.6369e-08,
                    1.8991e-08,
                    2.1702e-08,
                    2.4502e-08,
                    2.732e-08,
                    3.0152e-08,
                    3.3003e-08,
                    3.587e-08,
                    3.8731e-08,
                    4.1586e-08,
                    4.4436e-08,
                    4.7281e-08,
                    5.011e-08,
                    5.2924e-08,
                    5.5671e-08,
                    5.8342e-08,
                    6.0917e-08,
                    6.3395e-08,
                    6.5775e-08,
                    6.8022e-08,
                    7.0136e-08,
                    7.2111e-08,
                    7.3946e-08,
                    7.5638e-08,
                    7.6958e-08,
                    7.7944e-08,
                    7.8575e-08,
                    7.8834e-08,
                    7.8736e-08,
                    7.8283e-08,
                    7.7485e-08,
                    7.6338e-08,
                    7.4859e-08,
                    7.3083e-08,
                    7.1552e-08,
                    7.0276e-08,
                    6.9258e-08,
                    6.8498e-08,
                    6.7996e-08,
                    6.7751e-08,
                    6.7765e-08,
                    6.8042e-08,
                    6.8584e-08,
                    6.9338e-08,
                    7.076e-08,
                    7.2828e-08,
                    7.5563e-08,
                    7.8992e-08,
                    8.313e-08,
                    8.7982e-08,
                    9.3547e-08,
                    9.9833e-08,
                    1.0684e-07,
                    1.1455e-07,
                    1.2239e-07,
                    1.3036e-07,
                    1.3845e-07,
                    1.4664e-07,
                    1.549e-07,
                    1.6324e-07,
                    1.7166e-07,
                    1.8015e-07,
                    1.8871e-07,
                    1.9739e-07,
                    2.0576e-07,
                    2.1392e-07,
                    2.2181e-07,
                    2.2938e-07,
                    2.3663e-07,
                    2.4363e-07,
                    2.5034e-07,
                    2.5676e-07,
                    2.629e-07,
                    2.6877e-07,
                    2.7557e-07,
                    2.8327e-07,
                    2.9186e-07,
                    3.0135e-07,
                    3.1175e-07,
                    3.231e-07,
                    3.3536e-07,
                    3.4867e-07,
                    3.6313e-07,
                    3.7868e-07,
                    3.9458e-07,
                    4.108e-07,
                    4.2699e-07,
                    4.4339e-07,
                    4.5999e-07,
                    4.7704e-07,
                    4.9451e-07,
                    5.123e-07,
                    5.304e-07,
                    5.4862e-07,
                    5.6804e-07,
                    5.8846e-07,
                    6.0623e-07,
                    6.2303e-07,
                    6.3875e-07,
                    6.5334e-07,
                    6.668e-07,
                    6.8074e-07,
                    6.9502e-07,
                    7.0797e-07,
                    7.2042e-07,
                    7.3237e-07,
                    7.4611e-07,
                    7.5996e-07,
                    7.7413e-07,
                    7.8857e-07,
                    8.0692e-07,
                    8.2615e-07,
                    8.4498e-07,
                    8.6603e-07,
                    8.8896e-07,
                    9.1175e-07,
                    9.3508e-07,
                    9.6056e-07,
                    9.866e-07,
                    1.0134e-06,
                    1.0398e-06,
                    1.0671e-06,
                    1.0991e-06,
                    1.1334e-06,
                    1.1689e-06,
                    1.2072e-06,
                    1.2459e-06,
                    1.287e-06,
                    1.3303e-06,
                    1.3737e-06,
                    1.4168e-06,
                    1.4631e-06,
                    1.5105e-06,
                    1.5625e-06,
                    1.6126e-06,
                    1.6628e-06,
                    1.7145e-06,
                    1.7697e-06,
                    1.83e-06,
                    1.8862e-06,
                    1.9448e-06,
                    2.0007e-06,
                    2.0571e-06,
                    2.1236e-06,
                    2.1929e-06,
                    2.2578e-06,
                    2.3294e-06,
                    2.4129e-06,
                    2.4986e-06,
                    2.581e-06,
                    2.6774e-06,
                    2.7716e-06,
                    2.8738e-06,
                    2.9667e-06,
                    3.0544e-06,
                    3.1464e-06,
                    3.2351e-06,
                    3.328e-06,
                    3.4257e-06,
                    3.5223e-06,
                    3.6097e-06,
                    3.7009e-06,
                    3.7984e-06,
                    3.8889e-06,
                    3.9768e-06,
                    4.0652e-06
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [
                    1.8154e-08,
                    3.7059e-08,
                    5.6478e-08,
                    7.5526e-08,
                    9.341e-08,
                    1.1342e-07,
                    1.3327e-07,
                    1.5127e-07,
                    1.7125e-07,
                    1.8736e-07,
                    2.048e-07,
                    2.2021e-07,
                    2.3486e-07,
                    2.4756e-07,
                    2.6293e-07,
                    2.7532e-07,
                    2.8911e-07,
                    3.0206e-07,
                    3.1504e-07,
                    3.2673e-07,
                    3.3846e-07,
                    3.4556e-07,
                    3.5224e-07,
                    3.5966e-07,
                    3.6749e-07,
                    3.7495e-07,
                    3.8101e-07,
                    3.8683e-07,
                    3.9255e-07,
                    3.9515e-07,
                    3.9577e-07,
                    3.9529e-07,
                    3.9351e-07,
                    3.888e-07,
                    3.8309e-07,
                    3.7632e-07,
                    3.6811e-07,
                    3.588e-07,
                    3.482e-07,
                    3.5176e-07,
                    3.6002e-07,
                    3.7171e-07,
                    3.8651e-07,
                    4.0464e-07,
                    4.2471e-07,
                    4.4395e-07,
                    4.6439e-07,
                    4.8709e-07,
                    5.1075e-07,
                    5.3414e-07,
                    5.5634e-07,
                    5.7762e-07,
                    5.9948e-07,
                    6.2235e-07,
                    6.4628e-07,
                    6.7088e-07,
                    6.9524e-07,
                    7.2096e-07,
                    7.4746e-07,
                    7.6571e-07,
                    7.8275e-07,
                    8.0036e-07,
                    8.1705e-07,
                    8.3376e-07,
                    8.5021e-07,
                    8.6664e-07,
                    8.8288e-07,
                    8.9904e-07,
                    9.1503e-07,
                    9.2765e-07,
                    9.3811e-07,
                    9.4697e-07,
                    9.5397e-07,
                    9.5959e-07,
                    9.6364e-07,
                    9.6609e-07,
                    9.6728e-07,
                    9.6711e-07,
                    9.659e-07,
                    9.8855e-07,
                    1.021e-06,
                    1.0588e-06,
                    1.1e-06,
                    1.1451e-06,
                    1.1933e-06,
                    1.2441e-06,
                    1.2984e-06,
                    1.3557e-06,
                    1.4163e-06,
                    1.4558e-06,
                    1.4888e-06,
                    1.5201e-06,
                    1.5518e-06,
                    1.5847e-06,
                    1.6192e-06,
                    1.6557e-06,
                    1.695e-06,
                    1.7371e-06,
                    1.7821e-06,
                    1.8337e-06,
                    1.8851e-06,
                    1.9475e-06,
                    2.0287e-06,
                    2.1057e-06,
                    2.1783e-06,
                    2.2529e-06,
                    2.3283e-06,
                    2.4042e-06,
                    2.4839e-06,
                    2.5542e-06,
                    2.6942e-06,
                    2.7815e-06,
                    2.8538e-06,
                    2.9337e-06,
                    3.075e-06,
                    3.1613e-06,
                    3.2115e-06,
                    3.2486e-06,
                    3.2773e-06,
                    3.2995e-06,
                    3.3145e-06,
                    3.3271e-06,
                    3.3375e-06,
                    3.3535e-06,
                    3.3639e-06,
                    3.3763e-06,
                    3.39e-06,
                    3.4182e-06,
                    3.4311e-06,
                    3.4448e-06,
                    3.4568e-06,
                    3.4761e-06,
                    3.4977e-06,
                    3.5237e-06,
                    3.5464e-06,
                    3.5771e-06,
                    3.6131e-06,
                    3.6514e-06,
                    3.697e-06,
                    3.7414e-06,
                    3.7858e-06,
                    3.8308e-06,
                    3.8873e-06,
                    3.9339e-06,
                    3.9786e-06,
                    4.0243e-06,
                    4.0694e-06,
                    4.167e-06,
                    4.255e-06,
                    4.3433e-06,
                    4.4114e-06,
                    4.46e-06,
                    4.496e-06,
                    4.5243e-06,
                    4.5449e-06,
                    4.5889e-06,
                    4.5924e-06,
                    4.6025e-06,
                    4.5893e-06,
                    4.5897e-06,
                    4.5967e-06,
                    4.6063e-06,
                    4.6036e-06,
                    4.5961e-06,
                    4.5846e-06,
                    4.577e-06,
                    4.5686e-06,
                    4.5581e-06,
                    4.5471e-06,
                    4.5386e-06,
                    4.529e-06,
                    4.5223e-06
                ],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    1.6742e-08,
                    3.4199e-08,
                    5.2135e-08,
                    6.9663e-08,
                    8.5993e-08,
                    1.0441e-07,
                    1.2264e-07,
                    1.3897e-07,
                    1.5726e-07,
                    1.7164e-07,
                    1.8735e-07,
                    2.0103e-07,
                    2.1396e-07,
                    2.2494e-07,
                    2.386e-07,
                    2.4927e-07,
                    2.6134e-07,
                    2.7259e-07,
                    2.8386e-07,
                    2.9384e-07,
                    3.0393e-07,
                    3.0946e-07,
                    3.1463e-07,
                    3.2062e-07,
                    3.2707e-07,
                    3.3322e-07,
                    3.3804e-07,
                    3.4268e-07,
                    3.4728e-07,
                    3.4884e-07,
                    3.4864e-07,
                    3.4756e-07,
                    3.454e-07,
                    3.4054e-07,
                    3.349e-07,
                    3.2843e-07,
                    3.2073e-07,
                    3.1216e-07,
                    3.0253e-07,
                    3.0725e-07,
                    3.1651e-07,
                    3.2905e-07,
                    3.4452e-07,
                    3.6315e-07,
                    3.8357e-07,
                    4.0298e-07,
                    4.2343e-07,
                    4.4597e-07,
                    4.693e-07,
                    4.9219e-07,
                    5.136e-07,
                    5.3379e-07,
                    5.5426e-07,
                    5.7542e-07,
                    5.9734e-07,
                    6.1964e-07,
                    6.4138e-07,
                    6.6419e-07,
                    6.8747e-07,
                    7.0222e-07,
                    7.1584e-07,
                    7.3012e-07,
                    7.4358e-07,
                    7.5715e-07,
                    7.7054e-07,
                    7.84e-07,
                    7.9737e-07,
                    8.1075e-07,
                    8.2405e-07,
                    8.3408e-07,
                    8.4209e-07,
                    8.4867e-07,
                    8.5355e-07,
                    8.5721e-07,
                    8.5946e-07,
                    8.6027e-07,
                    8.5998e-07,
                    8.5848e-07,
                    8.5612e-07,
                    8.7777e-07,
                    9.0887e-07,
                    9.4502e-07,
                    9.8427e-07,
                    1.027e-06,
                    1.0725e-06,
                    1.1202e-06,
                    1.1708e-06,
                    1.2238e-06,
                    1.2796e-06,
                    1.3137e-06,
                    1.341e-06,
                    1.3664e-06,
                    1.392e-06,
                    1.4185e-06,
                    1.4462e-06,
                    1.4756e-06,
                    1.5076e-06,
                    1.542e-06,
                    1.5791e-06,
                    1.6226e-06,
                    1.6674e-06,
                    1.7248e-06,
                    1.7993e-06,
                    1.8694e-06,
                    1.935e-06,
                    2.0025e-06,
                    2.0706e-06,
                    2.1408e-06,
                    2.2164e-06,
                    2.2826e-06,
                    2.416e-06,
                    2.4981e-06,
                    2.5678e-06,
                    2.6462e-06,
                    2.787e-06,
                    2.874e-06,
                    2.9293e-06,
                    2.9722e-06,
                    3.0057e-06,
                    3.0369e-06,
                    3.0597e-06,
                    3.079e-06,
                    3.095e-06,
                    3.1172e-06,
                    3.1323e-06,
                    3.144e-06,
                    3.1536e-06,
                    3.1774e-06,
                    3.1906e-06,
                    3.204e-06,
                    3.2164e-06,
                    3.2348e-06,
                    3.2549e-06,
                    3.2781e-06,
                    3.2951e-06,
                    3.3153e-06,
                    3.3301e-06,
                    3.3489e-06,
                    3.3688e-06,
                    3.388e-06,
                    3.4088e-06,
                    3.4327e-06,
                    3.4708e-06,
                    3.5042e-06,
                    3.5444e-06,
                    3.5841e-06,
                    3.6277e-06,
                    3.7238e-06,
                    3.8132e-06,
                    3.9145e-06,
                    3.9999e-06,
                    4.0658e-06,
                    4.1265e-06,
                    4.1927e-06,
                    4.2574e-06,
                    4.3462e-06,
                    4.4148e-06,
                    4.4903e-06,
                    4.5554e-06,
                    4.6254e-06,
                    4.6919e-06,
                    4.765e-06,
                    4.8227e-06,
                    4.8794e-06,
                    4.9361e-06,
                    4.996e-06,
                    5.047e-06,
                    5.0986e-06,
                    5.1538e-06,
                    5.2049e-06,
                    5.2523e-06,
                    5.303e-06
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.65e-09,
                    4.95e-09,
                    6.6e-09,
                    8.25e-09,
                    9.9e-09,
                    1.155e-08,
                    1.32e-08,
                    1.65e-08,
                    2.145e-08,
                    2.64e-08,
                    3.135e-08,
                    3.63e-08,
                    4.29e-08,
                    4.95e-08,
                    5.61e-08,
                    6.27e-08,
                    7.26e-08,
                    8.25e-08,
                    9.075e-08,
                    1.023e-07,
                    1.1385e-07,
                    1.254e-07,
                    1.3695e-07,
                    1.5015e-07,
                    1.6335e-07,
                    1.7655e-07,
                    1.881e-07,
                    1.9965e-07,
                    2.145e-07,
                    2.31e-07,
                    2.475e-07,
                    2.6565e-07,
                    2.838e-07,
                    3.036e-07,
                    3.2505e-07,
                    3.465e-07,
                    3.6795e-07,
                    3.927e-07,
                    4.191e-07,
                    4.455e-07,
                    4.719e-07,
                    4.983e-07,
                    5.2635e-07,
                    5.577e-07,
                    5.94e-07,
                    6.27e-07,
                    6.633e-07,
                    6.9795e-07,
                    7.3425e-07,
                    7.8045e-07,
                    8.2995e-07,
                    8.7615e-07,
                    9.2895e-07,
                    9.933e-07,
                    1.0609e-06,
                    1.1253e-06,
                    1.2029e-06,
                    1.2788e-06,
                    1.3629e-06,
                    1.4404e-06,
                    1.5098e-06,
                    1.584e-06,
                    1.6549e-06,
                    1.7292e-06,
                    1.8084e-06,
                    1.8859e-06,
                    1.9553e-06,
                    2.0278e-06,
                    2.1054e-06,
                    2.1763e-06,
                    2.2447e-06,
                    2.3137e-06
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [
                    1.6742e-08,
                    3.4199e-08,
                    5.2135e-08,
                    6.9663e-08,
                    8.5993e-08,
                    1.0441e-07,
                    1.2264e-07,
                    1.3897e-07,
                    1.5726e-07,
                    1.7164e-07,
                    1.8735e-07,
                    2.0103e-07,
                    2.1396e-07,
                    2.2494e-07,
                    2.386e-07,
                    2.4927e-07,
                    2.6134e-07,
                    2.7259e-07,
                    2.8386e-07,
                    2.9384e-07,
                    3.0393e-07,
                    3.0946e-07,
                    3.1463e-07,
                    3.2062e-07,
                    3.2707e-07,
                    3.3322e-07,
                    3.3804e-07,
                    3.4268e-07,
                    3.4728e-07,
                    3.4884e-07,
                    3.4864e-07,
                    3.4756e-07,
                    3.454e-07,
                    3.4054e-07,
                    3.349e-07,
                    3.2843e-07,
                    3.2073e-07,
                    3.1216e-07,
                    3.0253e-07,
                    3.0725e-07,
                    3.1651e-07,
                    3.2905e-07,
                    3.4452e-07,
                    3.6315e-07,
                    3.8357e-07,
                    4.0298e-07,
                    4.2343e-07,
                    4.4597e-07,
                    4.693e-07,
                    4.9219e-07,
                    5.136e-07,
                    5.3379e-07,
                    5.5426e-07,
                    5.7542e-07,
                    5.9734e-07,
                    6.1964e-07,
                    6.4138e-07,
                    6.6419e-07,
                    6.8747e-07,
                    7.0222e-07,
                    7.1584e-07,
                    7.3012e-07,
                    7.4358e-07,
                    7.5715e-07,
                    7.7054e-07,
                    7.84e-07,
                    7.9737e-07,
                    8.1075e-07,
                    8.2405e-07,
                    8.3408e-07,
                    8.4209e-07,
                    8.4867e-07,
                    8.5355e-07,
                    8.5721e-07,
                    8.5946e-07,
                    8.6027e-07,
                    8.5998e-07,
                    8.5848e-07,
                    8.5612e-07,
                    8.7777e-07,
                    9.0887e-07,
                    9.4502e-07,
                    9.8427e-07,
                    1.027e-06,
                    1.0725e-06,
                    1.1202e-06,
                    1.1708e-06,
                    1.2238e-06,
                    1.2796e-06,
                    1.3137e-06,
                    1.341e-06,
                    1.3664e-06,
                    1.392e-06,
                    1.4185e-06,
                    1.4462e-06,
                    1.4756e-06,
                    1.5076e-06,
                    1.542e-06,
                    1.5791e-06,
                    1.6226e-06,
                    1.6658e-06,
                    1.7199e-06,
                    1.7927e-06,
                    1.8612e-06,
                    1.9251e-06,
                    1.9909e-06,
                    2.0574e-06,
                    2.1243e-06,
                    2.195e-06,
                    2.2562e-06,
                    2.3847e-06,
                    2.4618e-06,
                    2.5249e-06,
                    2.5967e-06,
                    2.7309e-06,
                    2.8113e-06,
                    2.8567e-06,
                    2.8897e-06,
                    2.9149e-06,
                    2.9346e-06,
                    2.9458e-06,
                    2.9536e-06,
                    2.958e-06,
                    2.967e-06,
                    2.969e-06,
                    2.9675e-06,
                    2.9655e-06,
                    2.9778e-06,
                    2.9761e-06,
                    2.973e-06,
                    2.9689e-06,
                    2.9692e-06,
                    2.9711e-06,
                    2.9745e-06,
                    2.97e-06,
                    2.9688e-06,
                    2.9622e-06,
                    2.9562e-06,
                    2.9497e-06,
                    2.9425e-06,
                    2.9369e-06,
                    2.9344e-06,
                    2.9444e-06,
                    2.9465e-06,
                    2.9504e-06,
                    2.9571e-06,
                    2.9644e-06,
                    3.0258e-06,
                    3.079e-06,
                    3.1341e-06,
                    3.17e-06,
                    3.1897e-06,
                    3.1976e-06,
                    3.1994e-06,
                    3.1965e-06,
                    3.2209e-06,
                    3.2119e-06,
                    3.2116e-06,
                    3.1925e-06,
                    3.1849e-06,
                    3.1822e-06,
                    3.181e-06,
                    3.1678e-06,
                    3.1502e-06,
                    3.1277e-06,
                    3.1101e-06,
                    3.0917e-06,
                    3.0707e-06,
                    3.0484e-06,
                    3.0286e-06,
                    3.0076e-06,
                    2.9893e-06
                ],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [
                    3.4437e-09,
                    6.9456e-09,
                    1.0529e-08,
                    1.4194e-08,
                    1.794e-08,
                    2.1803e-08,
                    2.5784e-08,
                    2.9885e-08,
                    3.4109e-08,
                    3.8456e-08,
                    4.2816e-08,
                    4.7188e-08,
                    5.1573e-08,
                    5.5972e-08,
                    6.036e-08,
                    6.4739e-08,
                    6.9109e-08,
                    7.347e-08,
                    7.7812e-08,
                    8.2134e-08,
                    8.632e-08,
                    9.0361e-08,
                    9.4234e-08,
                    9.794e-08,
                    1.0148e-07,
                    1.0481e-07,
                    1.0794e-07,
                    1.1086e-07,
                    1.1356e-07,
                    1.1606e-07,
                    1.1796e-07,
                    1.1929e-07,
                    1.2005e-07,
                    1.2021e-07,
                    1.1979e-07,
                    1.1878e-07,
                    1.1721e-07,
                    1.1506e-07,
                    1.1236e-07,
                    1.0913e-07,
                    1.063e-07,
                    1.0389e-07,
                    1.0189e-07,
                    1.0031e-07,
                    9.9152e-08,
                    9.8406e-08,
                    9.8078e-08,
                    9.8171e-08,
                    9.8687e-08,
                    9.9575e-08,
                    1.0141e-07,
                    1.0417e-07,
                    1.0788e-07,
                    1.1256e-07,
                    1.1824e-07,
                    1.249e-07,
                    1.3256e-07,
                    1.4122e-07,
                    1.5088e-07,
                    1.6152e-07,
                    1.7219e-07,
                    1.829e-07,
                    1.9364e-07,
                    2.0437e-07,
                    2.1508e-07,
                    2.2577e-07,
                    2.3645e-07,
                    2.471e-07,
                    2.5773e-07,
                    2.6837e-07,
                    2.7855e-07,
                    2.8836e-07,
                    2.9774e-07,
                    3.0664e-07,
                    3.1506e-07,
                    3.2307e-07,
                    3.3063e-07,
                    3.3775e-07,
                    3.4442e-07,
                    3.5066e-07,
                    3.5817e-07,
                    3.6688e-07,
                    3.7681e-07,
                    3.8796e-07,
                    4.0035e-07,
                    4.1417e-07,
                    4.2943e-07,
                    4.4627e-07,
                    4.648e-07,
                    4.8497e-07,
                    5.057e-07,
                    5.2695e-07,
                    5.4837e-07,
                    5.702e-07,
                    5.9243e-07,
                    6.1529e-07,
                    6.3877e-07,
                    6.6275e-07,
                    6.8724e-07,
                    7.1204e-07,
                    7.3637e-07,
                    7.6006e-07,
                    7.8276e-07,
                    8.0451e-07,
                    8.2529e-07,
                    8.4488e-07,
                    8.6333e-07,
                    8.8061e-07,
                    8.9658e-07,
                    9.1119e-07,
                    9.274e-07,
                    9.4199e-07,
                    9.5558e-07,
                    9.6848e-07,
                    9.8057e-07,
                    9.9182e-07,
                    1.0027e-06,
                    1.0137e-06,
                    1.0253e-06,
                    1.0349e-06,
                    1.0474e-06,
                    1.0609e-06,
                    1.076e-06,
                    1.0926e-06,
                    1.111e-06,
                    1.1315e-06,
                    1.1542e-06,
                    1.179e-06,
                    1.2062e-06,
                    1.235e-06,
                    1.264e-06,
                    1.2963e-06,
                    1.3311e-06,
                    1.3692e-06,
                    1.4121e-06,
                    1.4594e-06,
                    1.5164e-06,
                    1.5748e-06,
                    1.6377e-06,
                    1.7044e-06,
                    1.7669e-06,
                    1.828e-06,
                    1.8879e-06,
                    1.9464e-06,
                    2.0029e-06,
                    2.0574e-06,
                    2.1094e-06,
                    2.1588e-06,
                    2.2056e-06,
                    2.2511e-06,
                    2.2949e-06,
                    2.3365e-06,
                    2.3771e-06,
                    2.416e-06,
                    2.4505e-06,
                    2.482e-06,
                    2.5056e-06,
                    2.5278e-06,
                    2.5452e-06,
                    2.5618e-06,
                    2.5829e-06,
                    2.6046e-06,
                    2.6256e-06,
                    2.6477e-06,
                    2.6697e-06,
                    2.6919e-06,
                    2.7132e-06,
                    2.7358e-06,
                    2.7597e-06,
                    2.7833e-06,
                    2.8071e-06,
                    2.8308e-06
                ],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [
                    2.0577e-09,
                    4.1387e-09,
                    6.2661e-09,
                    8.4398e-09,
                    1.066e-08,
                    1.2961e-08,
                    1.5346e-08,
                    1.7816e-08,
                    2.0373e-08,
                    2.3019e-08,
                    2.5681e-08,
                    2.8356e-08,
                    3.1048e-08,
                    3.3756e-08,
                    3.6456e-08,
                    3.915e-08,
                    4.1837e-08,
                    4.4518e-08,
                    4.7181e-08,
                    4.9829e-08,
                    5.2408e-08,
                    5.4909e-08,
                    5.731e-08,
                    5.9612e-08,
                    6.1811e-08,
                    6.3874e-08,
                    6.5801e-08,
                    6.7586e-08,
                    6.9227e-08,
                    7.0724e-08,
                    7.1847e-08,
                    7.2634e-08,
                    7.3065e-08,
                    7.3122e-08,
                    7.2821e-08,
                    7.2164e-08,
                    7.116e-08,
                    6.9805e-08,
                    6.8117e-08,
                    6.6129e-08,
                    6.4383e-08,
                    6.289e-08,
                    6.1654e-08,
                    6.0673e-08,
                    5.9948e-08,
                    5.9478e-08,
                    5.9264e-08,
                    5.931e-08,
                    5.9619e-08,
                    6.0138e-08,
                    6.1322e-08,
                    6.3149e-08,
                    6.5639e-08,
                    6.8821e-08,
                    7.2708e-08,
                    7.7306e-08,
                    8.2612e-08,
                    8.8638e-08,
                    9.5382e-08,
                    1.0282e-07,
                    1.1039e-07,
                    1.1809e-07,
                    1.259e-07,
                    1.3381e-07,
                    1.4178e-07,
                    1.4984e-07,
                    1.5797e-07,
                    1.6617e-07,
                    1.7444e-07,
                    1.8281e-07,
                    1.9088e-07,
                    1.9874e-07,
                    2.0633e-07,
                    2.1359e-07,
                    2.2052e-07,
                    2.2721e-07,
                    2.3359e-07,
                    2.397e-07,
                    2.4551e-07,
                    2.5105e-07,
                    2.5752e-07,
                    2.6489e-07,
                    2.7314e-07,
                    2.8229e-07,
                    2.9234e-07,
                    3.0334e-07,
                    3.1525e-07,
                    3.2821e-07,
                    3.4231e-07,
                    3.575e-07,
                    3.7303e-07,
                    3.8887e-07,
                    4.0468e-07,
                    4.2068e-07,
                    4.3687e-07,
                    4.535e-07,
                    4.7054e-07,
                    4.8788e-07,
                    5.0553e-07,
                    5.2327e-07,
                    5.4056e-07,
                    5.5719e-07,
                    5.7282e-07,
                    5.8744e-07,
                    6.0098e-07,
                    6.1337e-07,
                    6.2461e-07,
                    6.3467e-07,
                    6.4341e-07,
                    6.508e-07,
                    6.5766e-07,
                    6.6403e-07,
                    6.7051e-07,
                    6.7708e-07,
                    6.8397e-07,
                    6.9111e-07,
                    6.9884e-07,
                    7.0742e-07,
                    7.1722e-07,
                    7.2589e-07,
                    7.3645e-07,
                    7.4692e-07,
                    7.5793e-07,
                    7.6945e-07,
                    7.8152e-07,
                    7.9444e-07,
                    8.0848e-07,
                    8.235e-07,
                    8.3986e-07,
                    8.5682e-07,
                    8.7494e-07,
                    8.9421e-07,
                    9.1406e-07,
                    9.3453e-07,
                    9.5552e-07,
                    9.7672e-07,
                    9.9749e-07,
                    1.0181e-06,
                    1.0381e-06,
                    1.0627e-06,
                    1.0853e-06,
                    1.108e-06,
                    1.1306e-06,
                    1.1533e-06,
                    1.1759e-06,
                    1.1978e-06,
                    1.2187e-06,
                    1.2385e-06,
                    1.2572e-06,
                    1.276e-06,
                    1.2943e-06,
                    1.3116e-06,
                    1.3288e-06,
                    1.3462e-06,
                    1.3624e-06,
                    1.3787e-06,
                    1.3955e-06,
                    1.4119e-06,
                    1.4278e-06,
                    1.4409e-06,
                    1.4569e-06,
                    1.4724e-06,
                    1.4879e-06,
                    1.5043e-06,
                    1.5203e-06,
                    1.537e-06,
                    1.5528e-06,
                    1.5693e-06,
                    1.5868e-06,
                    1.6038e-06,
                    1.6207e-06,
                    1.6373e-06
                ],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [
                    1.3859e-09,
                    2.8069e-09,
                    4.263e-09,
                    5.7541e-09,
                    7.2802e-09,
                    8.8414e-09,
                    1.0438e-08,
                    1.2069e-08,
                    1.3735e-08,
                    1.5437e-08,
                    1.7135e-08,
                    1.8831e-08,
                    2.0525e-08,
                    2.2216e-08,
                    2.3904e-08,
                    2.5589e-08,
                    2.7272e-08,
                    2.8952e-08,
                    3.063e-08,
                    3.2305e-08,
                    3.3912e-08,
                    3.5452e-08,
                    3.6924e-08,
                    3.8328e-08,
                    3.9665e-08,
                    4.0934e-08,
                    4.2135e-08,
                    4.3269e-08,
                    4.4335e-08,
                    4.5334e-08,
                    4.6108e-08,
                    4.6659e-08,
                    4.6985e-08,
                    4.7088e-08,
                    4.6966e-08,
                    4.662e-08,
                    4.6051e-08,
                    4.5257e-08,
                    4.4239e-08,
                    4.2997e-08,
                    4.1916e-08,
                    4.0996e-08,
                    4.0238e-08,
                    3.964e-08,
                    3.9204e-08,
                    3.8928e-08,
                    3.8814e-08,
                    3.886e-08,
                    3.9068e-08,
                    3.9437e-08,
                    4.0089e-08,
                    4.1024e-08,
                    4.2242e-08,
                    4.3743e-08,
                    4.5527e-08,
                    4.7595e-08,
                    4.9945e-08,
                    5.2579e-08,
                    5.5495e-08,
                    5.8695e-08,
                    6.1801e-08,
                    6.4814e-08,
                    6.7733e-08,
                    7.0559e-08,
                    7.3292e-08,
                    7.5931e-08,
                    7.8477e-08,
                    8.093e-08,
                    8.3289e-08,
                    8.5555e-08,
                    8.7664e-08,
                    8.9617e-08,
                    9.1414e-08,
                    9.3054e-08,
                    9.4539e-08,
                    9.5866e-08,
                    9.7038e-08,
                    9.8053e-08,
                    9.8912e-08,
                    9.9615e-08,
                    1.0064e-07,
                    1.02e-07,
                    1.0367e-07,
                    1.0567e-07,
                    1.08e-07,
                    1.1083e-07,
                    1.1418e-07,
                    1.1806e-07,
                    1.2249e-07,
                    1.2747e-07,
                    1.3267e-07,
                    1.3808e-07,
                    1.4369e-07,
                    1.4952e-07,
                    1.5555e-07,
                    1.6179e-07,
                    1.6823e-07,
                    1.7487e-07,
                    1.8172e-07,
                    1.8876e-07,
                    1.9581e-07,
                    2.0286e-07,
                    2.0994e-07,
                    2.1707e-07,
                    2.2431e-07,
                    2.3151e-07,
                    2.3872e-07,
                    2.4594e-07,
                    2.5317e-07,
                    2.6039e-07,
                    2.6973e-07,
                    2.7796e-07,
                    2.8507e-07,
                    2.9139e-07,
                    2.966e-07,
                    3.0071e-07,
                    3.0386e-07,
                    3.0625e-07,
                    3.0807e-07,
                    3.0897e-07,
                    3.1097e-07,
                    3.1402e-07,
                    3.1808e-07,
                    3.2311e-07,
                    3.2945e-07,
                    3.3702e-07,
                    3.4573e-07,
                    3.5553e-07,
                    3.6634e-07,
                    3.7818e-07,
                    3.8908e-07,
                    4.0212e-07,
                    4.1705e-07,
                    4.3465e-07,
                    4.5658e-07,
                    4.8265e-07,
                    5.189e-07,
                    5.5679e-07,
                    5.9961e-07,
                    6.4165e-07,
                    6.8158e-07,
                    7.1998e-07,
                    7.5726e-07,
                    7.9313e-07,
                    8.2699e-07,
                    8.5962e-07,
                    8.9072e-07,
                    9.2029e-07,
                    9.484e-07,
                    9.7504e-07,
                    1.0006e-06,
                    1.0249e-06,
                    1.0484e-06,
                    1.0699e-06,
                    1.0882e-06,
                    1.1033e-06,
                    1.1101e-06,
                    1.1159e-06,
                    1.1174e-06,
                    1.1209e-06,
                    1.1259e-06,
                    1.1321e-06,
                    1.1377e-06,
                    1.1434e-06,
                    1.1494e-06,
                    1.1549e-06,
                    1.1603e-06,
                    1.1664e-06,
                    1.1729e-06,
                    1.1795e-06,
                    1.1864e-06,
                    1.1935e-06
                ],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [
                    1.6776e-10,
                    3.377e-10,
                    5.0978e-10,
                    6.8393e-10,
                    8.6009e-10,
                    1.0381e-09,
                    1.218e-09,
                    1.3995e-09,
                    1.5825e-09,
                    1.7669e-09,
                    1.9525e-09,
                    2.1394e-09,
                    2.3274e-09,
                    2.5167e-09,
                    2.7071e-09,
                    2.8987e-09,
                    3.0915e-09,
                    3.2855e-09,
                    3.4807e-09,
                    3.6772e-09,
                    3.8758e-09,
                    4.0781e-09,
                    4.2851e-09,
                    4.4977e-09,
                    4.7164e-09,
                    4.9412e-09,
                    5.1719e-09,
                    5.408e-09,
                    5.6485e-09,
                    5.892e-09,
                    6.1379e-09,
                    6.3858e-09,
                    6.6357e-09,
                    6.8874e-09,
                    7.1409e-09,
                    7.3961e-09,
                    7.653e-09,
                    7.9116e-09,
                    8.1721e-09,
                    8.4624e-09,
                    8.7557e-09,
                    9.0535e-09,
                    9.3569e-09,
                    9.667e-09,
                    9.9846e-09,
                    1.0311e-08,
                    1.0646e-08,
                    1.0991e-08,
                    1.1346e-08,
                    1.1711e-08,
                    1.209e-08,
                    1.2488e-08,
                    1.2908e-08,
                    1.3355e-08,
                    1.3827e-08,
                    1.4326e-08,
                    1.4849e-08,
                    1.5394e-08,
                    1.5955e-08,
                    1.6527e-08,
                    1.7107e-08,
                    1.7693e-08,
                    1.8286e-08,
                    1.8886e-08,
                    1.9492e-08,
                    2.0103e-08,
                    2.0719e-08,
                    2.134e-08,
                    2.1966e-08,
                    2.2595e-08,
                    2.3227e-08,
                    2.3859e-08,
                    2.4491e-08,
                    2.5122e-08,
                    2.5752e-08,
                    2.638e-08,
                    2.7007e-08,
                    2.7633e-08,
                    2.826e-08,
                    2.889e-08,
                    2.9525e-08,
                    3.0168e-08,
                    3.0822e-08,
                    3.1488e-08,
                    3.217e-08,
                    3.2868e-08,
                    3.3582e-08,
                    3.4313e-08,
                    3.5062e-08,
                    3.5826e-08,
                    3.6623e-08,
                    3.7478e-08,
                    3.8414e-08,
                    3.9446e-08,
                    4.0582e-08,
                    4.1826e-08,
                    4.3173e-08,
                    4.4614e-08,
                    4.6134e-08,
                    4.7709e-08,
                    4.934e-08,
                    5.1048e-08,
                    5.285e-08,
                    5.4758e-08,
                    5.6778e-08,
                    5.8913e-08,
                    6.1159e-08,
                    6.351e-08,
                    6.595e-08,
                    6.8464e-08,
                    7.1181e-08,
                    7.3851e-08,
                    7.6462e-08,
                    7.9038e-08,
                    8.1569e-08,
                    8.4055e-08,
                    8.65e-08,
                    8.893e-08,
                    9.136e-08,
                    9.3809e-08,
                    9.633e-08,
                    9.891e-08,
                    1.0159e-07,
                    1.0437e-07,
                    1.0726e-07,
                    1.1429e-07,
                    1.2202e-07,
                    1.2884e-07,
                    1.3347e-07,
                    1.3923e-07,
                    1.4532e-07,
                    1.5215e-07,
                    1.5765e-07,
                    1.6335e-07,
                    1.6952e-07,
                    1.7617e-07,
                    1.8342e-07,
                    1.9077e-07,
                    2.009e-07,
                    2.1154e-07,
                    2.2271e-07,
                    2.3293e-07,
                    2.4313e-07,
                    2.5301e-07,
                    2.6123e-07,
                    2.6908e-07,
                    2.7709e-07,
                    2.8516e-07,
                    2.9322e-07,
                    3.0131e-07,
                    3.0948e-07,
                    3.154e-07,
                    3.2172e-07,
                    3.2853e-07,
                    3.3547e-07,
                    3.4173e-07,
                    3.4949e-07,
                    3.5606e-07,
                    3.6255e-07,
                    3.693e-07,
                    3.7628e-07,
                    3.8311e-07,
                    3.9034e-07,
                    3.9705e-07,
                    4.0453e-07,
                    4.1141e-07,
                    4.1812e-07,
                    4.2472e-07,
                    4.3207e-07,
                    4.3918e-07,
                    4.4636e-07,
                    4.5363e-07
                ],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [
                    1.413e-10,
                    2.8424e-10,
                    4.2883e-10,
                    5.7501e-10,
                    7.2276e-10,
                    8.7202e-10,
                    1.0227e-09,
                    1.1749e-09,
                    1.3283e-09,
                    1.483e-09,
                    1.6389e-09,
                    1.796e-09,
                    1.9543e-09,
                    2.1137e-09,
                    2.2743e-09,
                    2.436e-09,
                    2.599e-09,
                    2.7631e-09,
                    2.9284e-09,
                    3.0949e-09,
                    3.263e-09,
                    3.4335e-09,
                    3.6069e-09,
                    3.7836e-09,
                    3.9639e-09,
                    4.1477e-09,
                    4.335e-09,
                    4.5256e-09,
                    4.7188e-09,
                    4.9142e-09,
                    5.1112e-09,
                    5.3099e-09,
                    5.5101e-09,
                    5.7118e-09,
                    5.9149e-09,
                    6.1195e-09,
                    6.3255e-09,
                    6.5329e-09,
                    6.7418e-09,
                    6.9542e-09,
                    7.1686e-09,
                    7.3852e-09,
                    7.6038e-09,
                    7.8247e-09,
                    8.0478e-09,
                    8.2733e-09,
                    8.5012e-09,
                    8.7315e-09,
                    8.9644e-09,
                    9.1998e-09,
                    9.4381e-09,
                    9.6792e-09,
                    9.9236e-09,
                    1.0171e-08,
                    1.0422e-08,
                    1.0677e-08,
                    1.0934e-08,
                    1.1196e-08,
                    1.146e-08,
                    1.1728e-08,
                    1.1999e-08,
                    1.2273e-08,
                    1.255e-08,
                    1.283e-08,
                    1.3112e-08,
                    1.3398e-08,
                    1.3687e-08,
                    1.3979e-08,
                    1.4274e-08,
                    1.4572e-08,
                    1.4873e-08,
                    1.5177e-08,
                    1.5484e-08,
                    1.5794e-08,
                    1.6107e-08,
                    1.6424e-08,
                    1.6743e-08,
                    1.7065e-08,
                    1.7391e-08,
                    1.7719e-08,
                    1.8051e-08,
                    1.8386e-08,
                    1.8724e-08,
                    1.9064e-08,
                    1.9408e-08,
                    1.9756e-08,
                    2.0107e-08,
                    2.0461e-08,
                    2.0819e-08,
                    2.1182e-08,
                    2.155e-08,
                    2.1926e-08,
                    2.2311e-08,
                    2.2708e-08,
                    2.3117e-08,
                    2.3538e-08,
                    2.3972e-08,
                    2.4419e-08,
                    2.4877e-08,
                    2.5345e-08,
                    2.5824e-08,
                    2.6315e-08,
                    2.6819e-08,
                    2.7337e-08,
                    2.7871e-08,
                    2.842e-08,
                    2.8985e-08,
                    2.9567e-08,
                    3.0164e-08,
                    3.0777e-08,
                    3.1404e-08,
                    3.2045e-08,
                    3.2701e-08,
                    3.3372e-08,
                    3.4058e-08,
                    3.4762e-08,
                    3.5486e-08,
                    3.6232e-08,
                    3.7002e-08,
                    3.7841e-08,
                    3.8665e-08,
                    3.9426e-08,
                    4.0204e-08,
                    4.0963e-08,
                    4.1725e-08,
                    4.2423e-08,
                    4.32e-08,
                    4.3976e-08,
                    4.4782e-08,
                    4.5596e-08,
                    4.645e-08,
                    4.7297e-08,
                    4.8066e-08,
                    4.8866e-08,
                    4.9681e-08,
                    5.0516e-08,
                    5.1406e-08,
                    5.2348e-08,
                    5.3307e-08,
                    5.4308e-08,
                    5.5363e-08,
                    5.6455e-08,
                    5.7485e-08,
                    5.8666e-08,
                    6.0048e-08,
                    6.1439e-08,
                    6.2808e-08,
                    6.4242e-08,
                    6.5652e-08,
                    6.709e-08,
                    6.8607e-08,
                    7.0028e-08,
                    7.1633e-08,
                    7.3462e-08,
                    7.526e-08,
                    7.7027e-08,
                    7.9089e-08,
                    8.1027e-08,
                    8.3086e-08,
                    8.5402e-08,
                    8.7708e-08,
                    8.9983e-08,
                    9.2219e-08,
                    9.4543e-08,
                    9.6971e-08,
                    9.937e-08,
                    1.0158e-07,
                    1.0378e-07,
                    1.0626e-07,
                    1.0874e-07,
                    1.114e-07,
                    1.1414e-07
                ],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": [
                    2.6462e-11,
                    5.3454e-11,
                    8.0952e-11,
                    1.0893e-10,
                    1.3733e-10,
                    1.6613e-10,
                    1.9525e-10,
                    2.2463e-10,
                    2.542e-10,
                    2.8388e-10,
                    3.136e-10,
                    3.4337e-10,
                    3.7316e-10,
                    4.0297e-10,
                    4.328e-10,
                    4.6264e-10,
                    4.9251e-10,
                    5.2241e-10,
                    5.5235e-10,
                    5.8234e-10,
                    6.1284e-10,
                    6.446e-10,
                    6.7823e-10,
                    7.1413e-10,
                    7.5253e-10,
                    7.9349e-10,
                    8.3689e-10,
                    8.8243e-10,
                    9.2964e-10,
                    9.7786e-10,
                    1.0266e-09,
                    1.0759e-09,
                    1.1256e-09,
                    1.1756e-09,
                    1.2259e-09,
                    1.2766e-09,
                    1.3275e-09,
                    1.3787e-09,
                    1.4303e-09,
                    1.5081e-09,
                    1.5871e-09,
                    1.6683e-09,
                    1.7531e-09,
                    1.8423e-09,
                    1.9368e-09,
                    2.0374e-09,
                    2.1447e-09,
                    2.2591e-09,
                    2.3812e-09,
                    2.511e-09,
                    2.6517e-09,
                    2.8085e-09,
                    2.9849e-09,
                    3.1834e-09,
                    3.405e-09,
                    3.6493e-09,
                    3.9147e-09,
                    4.198e-09,
                    4.4948e-09,
                    4.7992e-09,
                    5.1079e-09,
                    5.4205e-09,
                    5.7368e-09,
                    6.0565e-09,
                    6.3791e-09,
                    6.7044e-09,
                    7.0319e-09,
                    7.3611e-09,
                    7.6915e-09,
                    8.0227e-09,
                    8.3534e-09,
                    8.6819e-09,
                    9.0071e-09,
                    9.3281e-09,
                    9.6445e-09,
                    9.9562e-09,
                    1.0264e-08,
                    1.0568e-08,
                    1.087e-08,
                    1.1171e-08,
                    1.1474e-08,
                    1.1782e-08,
                    1.2098e-08,
                    1.2424e-08,
                    1.2762e-08,
                    1.3112e-08,
                    1.3475e-08,
                    1.3852e-08,
                    1.4242e-08,
                    1.4645e-08,
                    1.5073e-08,
                    1.5553e-08,
                    1.6103e-08,
                    1.6738e-08,
                    1.7465e-08,
                    1.8287e-08,
                    1.9201e-08,
                    2.0195e-08,
                    2.1257e-08,
                    2.2364e-08,
                    2.3516e-08,
                    2.4733e-08,
                    2.6031e-08,
                    2.742e-08,
                    2.8907e-08,
                    3.0493e-08,
                    3.2174e-08,
                    3.3943e-08,
                    3.5786e-08,
                    3.7687e-08,
                    3.9777e-08,
                    4.1806e-08,
                    4.3761e-08,
                    4.5666e-08,
                    4.751e-08,
                    4.9293e-08,
                    5.1014e-08,
                    5.2698e-08,
                    5.4358e-08,
                    5.5968e-08,
                    5.7665e-08,
                    5.9485e-08,
                    6.139e-08,
                    6.3406e-08,
                    6.5533e-08,
                    7.1865e-08,
                    7.8823e-08,
                    8.4859e-08,
                    8.8683e-08,
                    9.3637e-08,
                    9.8874e-08,
                    1.0485e-07,
                    1.0958e-07,
                    1.1449e-07,
                    1.1984e-07,
                    1.2565e-07,
                    1.3202e-07,
                    1.3842e-07,
                    1.476e-07,
                    1.5723e-07,
                    1.6735e-07,
                    1.7647e-07,
                    1.8564e-07,
                    1.9435e-07,
                    2.0118e-07,
                    2.0764e-07,
                    2.1428e-07,
                    2.2092e-07,
                    2.2757e-07,
                    2.3422e-07,
                    2.4087e-07,
                    2.4537e-07,
                    2.5009e-07,
                    2.5507e-07,
                    2.6021e-07,
                    2.6471e-07,
                    2.704e-07,
                    2.7503e-07,
                    2.7946e-07,
                    2.839e-07,
                    2.8857e-07,
                    2.9313e-07,
                    2.9812e-07,
                    3.0251e-07,
                    3.0756e-07,
                    3.1204e-07,
                    3.1654e-07,
                    3.2094e-07,
                    3.2581e-07,
                    3.3044e-07,
                    3.3495e-07,
                    3.3949e-07
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -61.47876,
                            15.53656
                        ],
                        [
                            -61.39594,
                            15.35783
                        ],
                        [
                            -61.35482,
                            15.20841
                        ],
                        [
                            -61.25837,
                            15.25648
                        ],
                        [
                            -61.24187,
                            15.33007
                        ],
                        [
                            -61.25816,
                            15.51577
                        ],
                        [
                            -61.30577,
                            15.58521
                        ],
                        [
                            -61.4661,
                            15.61917
                        ],
                        [
                            -61.47876,
                            15.53656
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "DOM",
                "Country": "Dominican Republic",
                "Total_3GHG": 0.09,
                "Total_3GHG_timeseries": [
                    4.5342e-07,
                    9.2291e-07,
                    1.4005e-06,
                    1.8917e-06,
                    2.3933e-06,
                    2.9124e-06,
                    3.4329e-06,
                    3.96e-06,
                    4.4932e-06,
                    5.2128e-06,
                    6.0076e-06,
                    6.861e-06,
                    7.7449e-06,
                    8.6527e-06,
                    9.588e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014
                ],
                "Fossil_3GHG": 0.06,
                "Fossil_3GHG_timeseries": [
                    8.1785e-08,
                    1.6532e-07,
                    2.5065e-07,
                    3.3783e-07,
                    4.269e-07,
                    5.1794e-07,
                    6.1099e-07,
                    7.061e-07,
                    8.0332e-07,
                    9.0272e-07,
                    1.0042e-06,
                    1.1079e-06,
                    1.2139e-06,
                    1.3221e-06,
                    1.4328e-06,
                    1.5459e-06,
                    1.6615e-06,
                    1.7798e-06,
                    1.9008e-06,
                    2.0246e-06,
                    2.151e-06,
                    2.2801e-06,
                    2.412e-06,
                    2.5467e-06,
                    2.6844e-06,
                    2.8251e-06,
                    2.9688e-06,
                    3.1155e-06,
                    3.2652e-06,
                    3.418e-06,
                    3.5746e-06,
                    3.7352e-06,
                    3.8996e-06,
                    4.0679e-06,
                    4.2403e-06,
                    4.4168e-06,
                    4.5974e-06,
                    4.7823e-06,
                    4.9714e-06,
                    5.1651e-06,
                    5.3638e-06,
                    5.5676e-06,
                    5.7766e-06,
                    5.9907e-06,
                    6.2101e-06,
                    6.435e-06,
                    6.6654e-06,
                    6.9014e-06,
                    7.143e-06,
                    7.3904e-06,
                    7.6489e-06,
                    7.9193e-06,
                    8.2017e-06,
                    8.4963e-06,
                    8.8039e-06,
                    9.1249e-06,
                    9.4597e-06,
                    9.8082e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006
                ],
                "Land_3GHG": 0.14,
                "Land_3GHG_timeseries": [
                    3.7164e-07,
                    7.5759e-07,
                    1.1499e-06,
                    1.5539e-06,
                    1.9664e-06,
                    2.3945e-06,
                    2.8219e-06,
                    3.2539e-06,
                    3.6898e-06,
                    4.3101e-06,
                    5.0034e-06,
                    5.7531e-06,
                    6.531e-06,
                    7.3306e-06,
                    8.1553e-06,
                    9.0092e-06,
                    9.8771e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008
                ],
                "Total_CO2": 0.07,
                "Total_CO2_timeseries": [
                    2.6875e-07,
                    5.4932e-07,
                    8.3372e-07,
                    1.1274e-06,
                    1.4271e-06,
                    1.7398e-06,
                    2.0495e-06,
                    2.3613e-06,
                    2.6746e-06,
                    3.1698e-06,
                    3.7349e-06,
                    4.3535e-06,
                    4.9973e-06,
                    5.6597e-06,
                    6.3442e-06,
                    7.0549e-06,
                    7.7767e-06,
                    8.524e-06,
                    9.2716e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008
                ],
                "Fossil_CO2": 0.05,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    3.2734e-09,
                    1.3093e-08,
                    2.455e-08,
                    1.8117e-07,
                    3.4268e-07,
                    6.0972e-07,
                    8.8833e-07,
                    1.1702e-06,
                    1.5823e-06,
                    2.0257e-06,
                    2.4904e-06,
                    2.9701e-06,
                    3.4714e-06,
                    3.9396e-06,
                    4.4029e-06,
                    4.9618e-06,
                    5.524e-06,
                    6.3105e-06,
                    7.0064e-06,
                    7.7583e-06,
                    8.464e-06,
                    9.521e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004
                ],
                "Land_CO2": 0.13,
                "Land_CO2_timeseries": [
                    2.6875e-07,
                    5.4932e-07,
                    8.3372e-07,
                    1.1274e-06,
                    1.4271e-06,
                    1.7398e-06,
                    2.0495e-06,
                    2.3613e-06,
                    2.6746e-06,
                    3.1698e-06,
                    3.7349e-06,
                    4.3535e-06,
                    4.9973e-06,
                    5.6597e-06,
                    6.3442e-06,
                    7.0549e-06,
                    7.7767e-06,
                    8.524e-06,
                    9.2716e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Total_CH4": 0.12,
                "Total_CH4_timeseries": [
                    1.5166e-07,
                    3.0717e-07,
                    4.6658e-07,
                    6.2995e-07,
                    7.9732e-07,
                    9.6877e-07,
                    1.1443e-06,
                    1.3241e-06,
                    1.5081e-06,
                    1.6965e-06,
                    1.8896e-06,
                    2.0877e-06,
                    2.2909e-06,
                    2.499e-06,
                    2.7123e-06,
                    2.9309e-06,
                    3.1547e-06,
                    3.3838e-06,
                    3.6184e-06,
                    3.8586e-06,
                    4.1049e-06,
                    4.3572e-06,
                    4.6157e-06,
                    4.8804e-06,
                    5.1513e-06,
                    5.4285e-06,
                    5.712e-06,
                    6.0019e-06,
                    6.2982e-06,
                    6.6009e-06,
                    6.9142e-06,
                    7.2382e-06,
                    7.5729e-06,
                    7.9184e-06,
                    8.2746e-06,
                    8.6418e-06,
                    9.0199e-06,
                    9.409e-06,
                    9.8091e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Fossil_CH4": 0.08,
                "Fossil_CH4_timeseries": [
                    5.276e-08,
                    1.0696e-07,
                    1.6265e-07,
                    2.1988e-07,
                    2.7871e-07,
                    3.392e-07,
                    4.0141e-07,
                    4.6539e-07,
                    5.3122e-07,
                    5.9893e-07,
                    6.6849e-07,
                    7.3996e-07,
                    8.1343e-07,
                    8.8893e-07,
                    9.6655e-07,
                    1.0464e-06,
                    1.1285e-06,
                    1.2129e-06,
                    1.2998e-06,
                    1.3892e-06,
                    1.4809e-06,
                    1.575e-06,
                    1.6714e-06,
                    1.7703e-06,
                    1.8716e-06,
                    1.9754e-06,
                    2.0818e-06,
                    2.1907e-06,
                    2.3023e-06,
                    2.4166e-06,
                    2.5344e-06,
                    2.6558e-06,
                    2.7808e-06,
                    2.9094e-06,
                    3.0418e-06,
                    3.178e-06,
                    3.318e-06,
                    3.462e-06,
                    3.6099e-06,
                    3.7619e-06,
                    3.9185e-06,
                    4.0798e-06,
                    4.2458e-06,
                    4.4167e-06,
                    4.5924e-06,
                    4.7732e-06,
                    4.9591e-06,
                    5.1501e-06,
                    5.3464e-06,
                    5.548e-06,
                    5.7603e-06,
                    5.9839e-06,
                    6.2191e-06,
                    6.466e-06,
                    6.7253e-06,
                    6.9976e-06,
                    7.283e-06,
                    7.5818e-06,
                    7.8947e-06,
                    8.2223e-06,
                    8.5666e-06,
                    8.9282e-06,
                    9.3074e-06,
                    9.7019e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_CH4": 0.18,
                "Land_CH4_timeseries": [
                    9.8898e-08,
                    2.0021e-07,
                    3.0393e-07,
                    4.1006e-07,
                    5.1861e-07,
                    6.2957e-07,
                    7.4294e-07,
                    8.5872e-07,
                    9.7692e-07,
                    1.0975e-06,
                    1.2211e-06,
                    1.3478e-06,
                    1.4774e-06,
                    1.6101e-06,
                    1.7458e-06,
                    1.8845e-06,
                    2.0262e-06,
                    2.1709e-06,
                    2.3187e-06,
                    2.4694e-06,
                    2.624e-06,
                    2.7823e-06,
                    2.9443e-06,
                    3.1102e-06,
                    3.2798e-06,
                    3.4531e-06,
                    3.6303e-06,
                    3.8112e-06,
                    3.9959e-06,
                    4.1843e-06,
                    4.3799e-06,
                    4.5825e-06,
                    4.7922e-06,
                    5.009e-06,
                    5.2328e-06,
                    5.4638e-06,
                    5.7019e-06,
                    5.947e-06,
                    6.1992e-06,
                    6.4585e-06,
                    6.7269e-06,
                    7.0045e-06,
                    7.2912e-06,
                    7.5871e-06,
                    7.892e-06,
                    8.2061e-06,
                    8.5294e-06,
                    8.8617e-06,
                    9.2032e-06,
                    9.5539e-06,
                    9.9106e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Total_N2O": 0.08,
                "Total_N2O_timeseries": [
                    3.3017e-08,
                    6.6422e-08,
                    1.0021e-07,
                    1.3438e-07,
                    1.6891e-07,
                    2.038e-07,
                    2.3903e-07,
                    2.7458e-07,
                    3.1045e-07,
                    3.4661e-07,
                    3.8304e-07,
                    4.1975e-07,
                    4.5673e-07,
                    4.9399e-07,
                    5.3151e-07,
                    5.6931e-07,
                    6.0737e-07,
                    6.4571e-07,
                    6.8432e-07,
                    7.2321e-07,
                    7.6249e-07,
                    8.0232e-07,
                    8.4286e-07,
                    8.8418e-07,
                    9.2636e-07,
                    9.6939e-07,
                    1.0133e-06,
                    1.0579e-06,
                    1.1032e-06,
                    1.1489e-06,
                    1.1951e-06,
                    1.2417e-06,
                    1.2886e-06,
                    1.3358e-06,
                    1.3834e-06,
                    1.4314e-06,
                    1.4797e-06,
                    1.5283e-06,
                    1.5772e-06,
                    1.6307e-06,
                    1.6847e-06,
                    1.7395e-06,
                    1.7952e-06,
                    1.8519e-06,
                    1.9098e-06,
                    1.9691e-06,
                    2.0298e-06,
                    2.092e-06,
                    2.1558e-06,
                    2.2211e-06,
                    2.2886e-06,
                    2.359e-06,
                    2.4328e-06,
                    2.5105e-06,
                    2.5922e-06,
                    2.6778e-06,
                    2.7671e-06,
                    2.8596e-06,
                    2.9547e-06,
                    3.0515e-06,
                    3.1493e-06,
                    3.2483e-06,
                    3.3482e-06,
                    3.4492e-06,
                    3.551e-06,
                    3.6537e-06,
                    3.7573e-06,
                    3.8615e-06,
                    3.9664e-06,
                    4.0719e-06,
                    4.1778e-06,
                    4.2839e-06,
                    4.3899e-06,
                    4.4957e-06,
                    4.6013e-06,
                    4.7067e-06,
                    4.8119e-06,
                    4.9171e-06,
                    5.0224e-06,
                    5.1281e-06,
                    5.2346e-06,
                    5.3424e-06,
                    5.4518e-06,
                    5.5633e-06,
                    5.677e-06,
                    5.7932e-06,
                    5.912e-06,
                    6.0333e-06,
                    6.1572e-06,
                    6.2836e-06,
                    6.4146e-06,
                    6.5542e-06,
                    6.7054e-06,
                    6.8705e-06,
                    7.0507e-06,
                    7.2464e-06,
                    7.4571e-06,
                    7.6813e-06,
                    7.9168e-06,
                    8.1603e-06,
                    8.4119e-06,
                    8.6749e-06,
                    8.9519e-06,
                    9.2447e-06,
                    9.5543e-06,
                    9.881e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_N2O": 0.07,
                "Fossil_N2O_timeseries": [
                    2.9025e-08,
                    5.8359e-08,
                    8.8001e-08,
                    1.1795e-07,
                    1.4819e-07,
                    1.7874e-07,
                    2.0958e-07,
                    2.407e-07,
                    2.7211e-07,
                    3.0379e-07,
                    3.3574e-07,
                    3.6796e-07,
                    4.0045e-07,
                    4.3321e-07,
                    4.6623e-07,
                    4.9952e-07,
                    5.3308e-07,
                    5.6691e-07,
                    6.0101e-07,
                    6.3537e-07,
                    6.7005e-07,
                    7.0509e-07,
                    7.4055e-07,
                    7.7647e-07,
                    8.1285e-07,
                    8.497e-07,
                    8.8702e-07,
                    9.2477e-07,
                    9.6293e-07,
                    1.0014e-06,
                    1.0403e-06,
                    1.0794e-06,
                    1.1188e-06,
                    1.1585e-06,
                    1.1985e-06,
                    1.2388e-06,
                    1.2794e-06,
                    1.3203e-06,
                    1.3615e-06,
                    1.4032e-06,
                    1.4454e-06,
                    1.4879e-06,
                    1.5307e-06,
                    1.574e-06,
                    1.6177e-06,
                    1.6618e-06,
                    1.7063e-06,
                    1.7512e-06,
                    1.7966e-06,
                    1.8424e-06,
                    1.8886e-06,
                    1.9354e-06,
                    1.9826e-06,
                    2.0303e-06,
                    2.0786e-06,
                    2.1273e-06,
                    2.1766e-06,
                    2.2264e-06,
                    2.2767e-06,
                    2.3276e-06,
                    2.3789e-06,
                    2.4306e-06,
                    2.4829e-06,
                    2.5356e-06,
                    2.5888e-06,
                    2.6425e-06,
                    2.6966e-06,
                    2.7512e-06,
                    2.8063e-06,
                    2.8618e-06,
                    2.9178e-06,
                    2.9743e-06,
                    3.0312e-06,
                    3.0887e-06,
                    3.1465e-06,
                    3.2049e-06,
                    3.2637e-06,
                    3.323e-06,
                    3.3828e-06,
                    3.4431e-06,
                    3.5039e-06,
                    3.5652e-06,
                    3.627e-06,
                    3.6893e-06,
                    3.7521e-06,
                    3.8155e-06,
                    3.8794e-06,
                    3.9439e-06,
                    4.0089e-06,
                    4.0746e-06,
                    4.141e-06,
                    4.2083e-06,
                    4.2765e-06,
                    4.3458e-06,
                    4.4163e-06,
                    4.488e-06,
                    4.5609e-06,
                    4.6351e-06,
                    4.7104e-06,
                    4.787e-06,
                    4.8648e-06,
                    4.9443e-06,
                    5.0255e-06,
                    5.1087e-06,
                    5.194e-06,
                    5.2815e-06,
                    5.3713e-06,
                    5.4632e-06,
                    5.5572e-06,
                    5.6533e-06,
                    5.7511e-06,
                    5.8506e-06,
                    5.9514e-06,
                    6.0538e-06,
                    6.1577e-06,
                    6.2633e-06,
                    6.3711e-06,
                    6.4814e-06,
                    6.5949e-06,
                    6.7064e-06,
                    6.8182e-06,
                    6.9352e-06,
                    7.053e-06,
                    7.1763e-06,
                    7.3013e-06,
                    7.4297e-06,
                    7.5601e-06,
                    7.6929e-06,
                    7.8295e-06,
                    7.9619e-06,
                    8.1054e-06,
                    8.2715e-06,
                    8.4364e-06,
                    8.617e-06,
                    8.7377e-06,
                    8.8601e-06,
                    8.99e-06,
                    9.1052e-06,
                    9.2255e-06,
                    9.3333e-06,
                    9.4444e-06,
                    9.5637e-06,
                    9.686e-06,
                    9.8214e-06,
                    9.962e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.09,
                "Land_N2O_timeseries": [
                    3.9915e-09,
                    8.0629e-09,
                    1.2211e-08,
                    1.643e-08,
                    2.0715e-08,
                    2.5058e-08,
                    2.9451e-08,
                    3.3883e-08,
                    3.8344e-08,
                    4.282e-08,
                    4.7303e-08,
                    5.1793e-08,
                    5.6286e-08,
                    6.0783e-08,
                    6.5282e-08,
                    6.9784e-08,
                    7.4289e-08,
                    7.8799e-08,
                    8.3315e-08,
                    8.7839e-08,
                    9.2439e-08,
                    9.7231e-08,
                    1.023e-07,
                    1.0772e-07,
                    1.1351e-07,
                    1.1969e-07,
                    1.2623e-07,
                    1.331e-07,
                    1.4022e-07,
                    1.475e-07,
                    1.5486e-07,
                    1.6229e-07,
                    1.6978e-07,
                    1.7733e-07,
                    1.8492e-07,
                    1.9255e-07,
                    2.0024e-07,
                    2.0796e-07,
                    2.1574e-07,
                    2.2748e-07,
                    2.3939e-07,
                    2.5165e-07,
                    2.6443e-07,
                    2.7788e-07,
                    2.9214e-07,
                    3.0731e-07,
                    3.2349e-07,
                    3.4076e-07,
                    3.5917e-07,
                    3.7875e-07,
                    3.9998e-07,
                    4.2362e-07,
                    4.5023e-07,
                    4.8018e-07,
                    5.136e-07,
                    5.5046e-07,
                    5.9048e-07,
                    6.3321e-07,
                    6.7798e-07,
                    7.239e-07,
                    7.7046e-07,
                    8.1762e-07,
                    8.6533e-07,
                    9.1354e-07,
                    9.6221e-07,
                    1.0113e-06,
                    1.0607e-06,
                    1.1103e-06,
                    1.1602e-06,
                    1.2101e-06,
                    1.26e-06,
                    1.3096e-06,
                    1.3586e-06,
                    1.407e-06,
                    1.4548e-06,
                    1.5018e-06,
                    1.5482e-06,
                    1.594e-06,
                    1.6395e-06,
                    1.6849e-06,
                    1.7307e-06,
                    1.7772e-06,
                    1.8248e-06,
                    1.874e-06,
                    1.9249e-06,
                    1.9778e-06,
                    2.0326e-06,
                    2.0895e-06,
                    2.1483e-06,
                    2.2089e-06,
                    2.2736e-06,
                    2.3459e-06,
                    2.4289e-06,
                    2.5247e-06,
                    2.6344e-06,
                    2.7584e-06,
                    2.8962e-06,
                    3.0462e-06,
                    3.2063e-06,
                    3.3733e-06,
                    3.5471e-06,
                    3.7307e-06,
                    3.9264e-06,
                    4.136e-06,
                    4.3603e-06,
                    4.5994e-06,
                    4.853e-06,
                    5.1198e-06,
                    5.3979e-06,
                    5.6847e-06,
                    6.0491e-06,
                    6.4045e-06,
                    6.7541e-06,
                    7.1088e-06,
                    7.4695e-06,
                    7.8406e-06,
                    8.2142e-06,
                    8.5826e-06,
                    8.9585e-06,
                    9.3375e-06,
                    9.79e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -71.75362,
                                18.03074
                            ],
                            [
                                -71.67236,
                                17.97187
                            ],
                            [
                                -71.62916,
                                17.82593
                            ],
                            [
                                -71.67292,
                                17.76012
                            ],
                            [
                                -71.55267,
                                17.76513
                            ],
                            [
                                -71.50187,
                                17.73087
                            ],
                            [
                                -71.42226,
                                17.60727
                            ],
                            [
                                -71.37201,
                                17.6797
                            ],
                            [
                                -71.3089,
                                17.82116
                            ],
                            [
                                -71.20205,
                                17.92866
                            ],
                            [
                                -71.09462,
                                18.07101
                            ],
                            [
                                -71.05896,
                                18.15706
                            ],
                            [
                                -71.10788,
                                18.2601
                            ],
                            [
                                -71.05949,
                                18.3149
                            ],
                            [
                                -70.99811,
                                18.29906
                            ],
                            [
                                -70.96349,
                                18.25136
                            ],
                            [
                                -70.91518,
                                18.26523
                            ],
                            [
                                -70.86047,
                                18.33312
                            ],
                            [
                                -70.74715,
                                18.34762
                            ],
                            [
                                -70.6663,
                                18.43095
                            ],
                            [
                                -70.58361,
                                18.40744
                            ],
                            [
                                -70.57229,
                                18.31535
                            ],
                            [
                                -70.5901,
                                18.27842
                            ],
                            [
                                -70.50385,
                                18.19478
                            ],
                            [
                                -70.39411,
                                18.23635
                            ],
                            [
                                -70.23688,
                                18.2245
                            ],
                            [
                                -70.15501,
                                18.23253
                            ],
                            [
                                -70.08507,
                                18.31333
                            ],
                            [
                                -70.01875,
                                18.41974
                            ],
                            [
                                -69.88248,
                                18.47033
                            ],
                            [
                                -69.74611,
                                18.46289
                            ],
                            [
                                -69.66869,
                                18.41146
                            ],
                            [
                                -69.58998,
                                18.44442
                            ],
                            [
                                -69.51939,
                                18.40472
                            ],
                            [
                                -69.33447,
                                18.42601
                            ],
                            [
                                -69.21219,
                                18.45058
                            ],
                            [
                                -69.18276,
                                18.42134
                            ],
                            [
                                -69.08406,
                                18.3945
                            ],
                            [
                                -68.95749,
                                18.41273
                            ],
                            [
                                -68.84598,
                                18.37374
                            ],
                            [
                                -68.75613,
                                18.2325
                            ],
                            [
                                -68.64155,
                                18.22011
                            ],
                            [
                                -68.59396,
                                18.37817
                            ],
                            [
                                -68.49233,
                                18.33921
                            ],
                            [
                                -68.4515,
                                18.36646
                            ],
                            [
                                -68.44287,
                                18.42574
                            ],
                            [
                                -68.33261,
                                18.57211
                            ],
                            [
                                -68.34661,
                                18.64337
                            ],
                            [
                                -68.5551,
                                18.7882
                            ],
                            [
                                -68.70237,
                                18.9308
                            ],
                            [
                                -68.77985,
                                18.97524
                            ],
                            [
                                -68.97064,
                                19.02919
                            ],
                            [
                                -69.01209,
                                18.98999
                            ],
                            [
                                -69.11476,
                                19.01401
                            ],
                            [
                                -69.26331,
                                19.01858
                            ],
                            [
                                -69.30982,
                                19.04619
                            ],
                            [
                                -69.44188,
                                19.07865
                            ],
                            [
                                -69.62475,
                                19.08243
                            ],
                            [
                                -69.62557,
                                19.21777
                            ],
                            [
                                -69.47094,
                                19.20697
                            ],
                            [
                                -69.41008,
                                19.18819
                            ],
                            [
                                -69.33085,
                                19.20126
                            ],
                            [
                                -69.2311,
                                19.18176
                            ],
                            [
                                -69.20785,
                                19.23189
                            ],
                            [
                                -69.24971,
                                19.34614
                            ],
                            [
                                -69.35743,
                                19.30156
                            ],
                            [
                                -69.44117,
                                19.32412
                            ],
                            [
                                -69.54977,
                                19.3244
                            ],
                            [
                                -69.59466,
                                19.29777
                            ],
                            [
                                -69.70512,
                                19.27743
                            ],
                            [
                                -69.78615,
                                19.3087
                            ],
                            [
                                -69.84174,
                                19.37362
                            ],
                            [
                                -69.90247,
                                19.54488
                            ],
                            [
                                -69.90275,
                                19.64461
                            ],
                            [
                                -69.97184,
                                19.68143
                            ],
                            [
                                -70.04495,
                                19.67686
                            ],
                            [
                                -70.09447,
                                19.63187
                            ],
                            [
                                -70.17086,
                                19.62225
                            ],
                            [
                                -70.30301,
                                19.65433
                            ],
                            [
                                -70.44777,
                                19.7812
                            ],
                            [
                                -70.52673,
                                19.75514
                            ],
                            [
                                -70.6318,
                                19.76608
                            ],
                            [
                                -70.78196,
                                19.84535
                            ],
                            [
                                -70.84337,
                                19.90379
                            ],
                            [
                                -71.05873,
                                19.91826
                            ],
                            [
                                -71.13532,
                                19.85751
                            ],
                            [
                                -71.25231,
                                19.83128
                            ],
                            [
                                -71.37779,
                                19.85808
                            ],
                            [
                                -71.4871,
                                19.90722
                            ],
                            [
                                -71.58241,
                                19.90842
                            ],
                            [
                                -71.74309,
                                19.81372
                            ],
                            [
                                -71.75791,
                                19.70198
                            ],
                            [
                                -71.73883,
                                19.58611
                            ],
                            [
                                -71.67535,
                                19.44255
                            ],
                            [
                                -71.71433,
                                19.36611
                            ],
                            [
                                -71.76492,
                                19.31533
                            ],
                            [
                                -71.69699,
                                19.24227
                            ],
                            [
                                -71.61394,
                                19.20248
                            ],
                            [
                                -71.65458,
                                19.10548
                            ],
                            [
                                -71.71084,
                                19.0781
                            ],
                            [
                                -71.7778,
                                19.01033
                            ],
                            [
                                -71.77592,
                                18.94497
                            ],
                            [
                                -71.72124,
                                18.87466
                            ],
                            [
                                -71.73785,
                                18.73086
                            ],
                            [
                                -71.79572,
                                18.69249
                            ],
                            [
                                -71.81227,
                                18.63419
                            ],
                            [
                                -71.96515,
                                18.65327
                            ],
                            [
                                -71.9974,
                                18.63253
                            ],
                            [
                                -71.87851,
                                18.50502
                            ],
                            [
                                -71.89934,
                                18.45816
                            ],
                            [
                                -71.78676,
                                18.37928
                            ],
                            [
                                -71.69391,
                                18.34057
                            ],
                            [
                                -71.77902,
                                18.17621
                            ],
                            [
                                -71.73349,
                                18.0729
                            ],
                            [
                                -71.75362,
                                18.03074
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -68.78454,
                                18.17283
                            ],
                            [
                                -68.68877,
                                18.11418
                            ],
                            [
                                -68.58789,
                                18.15244
                            ],
                            [
                                -68.78454,
                                18.17283
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "EU27",
                "Country": "EU27",
                "Total_3GHG": 10.32,
                "Total_3GHG_timeseries": [
                    0.0002,
                    0.0004,
                    0.0006,
                    0.0009,
                    0.0011,
                    0.0013,
                    0.0015,
                    0.0017,
                    0.002,
                    0.0022,
                    0.0024,
                    0.0026,
                    0.0028,
                    0.0031,
                    0.0033,
                    0.0036,
                    0.0038,
                    0.0041,
                    0.0044,
                    0.0046,
                    0.0049,
                    0.0052,
                    0.0055,
                    0.0058,
                    0.0061,
                    0.0064,
                    0.0067,
                    0.007,
                    0.0074,
                    0.0077,
                    0.0081,
                    0.0085,
                    0.0088,
                    0.0092,
                    0.0096,
                    0.01,
                    0.0104,
                    0.0108,
                    0.0112,
                    0.0117,
                    0.0121,
                    0.0126,
                    0.013,
                    0.0135,
                    0.014,
                    0.0145,
                    0.015,
                    0.0156,
                    0.0161,
                    0.0167,
                    0.0173,
                    0.0179,
                    0.0185,
                    0.0191,
                    0.0197,
                    0.0204,
                    0.0211,
                    0.0219,
                    0.0226,
                    0.0233,
                    0.0241,
                    0.0249,
                    0.0257,
                    0.0264,
                    0.027,
                    0.0276,
                    0.0283,
                    0.0289,
                    0.0293,
                    0.0299,
                    0.0305,
                    0.0311,
                    0.0316,
                    0.0323,
                    0.033,
                    0.0336,
                    0.0343,
                    0.035,
                    0.0358,
                    0.0365,
                    0.0371,
                    0.0377,
                    0.0382,
                    0.0388,
                    0.0394,
                    0.0401,
                    0.0409,
                    0.0416,
                    0.0425,
                    0.0433,
                    0.0441,
                    0.0449,
                    0.0457,
                    0.0464,
                    0.0466,
                    0.0471,
                    0.0477,
                    0.0484,
                    0.0492,
                    0.05,
                    0.051,
                    0.0521,
                    0.0532,
                    0.0543,
                    0.0556,
                    0.057,
                    0.0584,
                    0.0598,
                    0.0612,
                    0.0628,
                    0.0644,
                    0.0662,
                    0.068,
                    0.07,
                    0.0721,
                    0.0742,
                    0.0763,
                    0.0785,
                    0.0808,
                    0.0831,
                    0.0855,
                    0.0878,
                    0.0902,
                    0.0926,
                    0.095,
                    0.0974,
                    0.0998,
                    0.1022,
                    0.1047,
                    0.1071,
                    0.1093,
                    0.1115,
                    0.1135,
                    0.1156,
                    0.1177,
                    0.1198,
                    0.1218,
                    0.1237,
                    0.1255,
                    0.1274,
                    0.1291,
                    0.1307,
                    0.1322,
                    0.1337,
                    0.1352,
                    0.1367,
                    0.1382,
                    0.1395,
                    0.1409,
                    0.1422,
                    0.1435,
                    0.1448,
                    0.1461,
                    0.1475,
                    0.1488,
                    0.1501,
                    0.1514,
                    0.1527,
                    0.1538,
                    0.155,
                    0.1562,
                    0.1574,
                    0.1586,
                    0.1598,
                    0.1609,
                    0.1621,
                    0.1633,
                    0.1645,
                    0.1656,
                    0.1666,
                    0.1677,
                    0.1688
                ],
                "Fossil_3GHG": 14.29,
                "Fossil_3GHG_timeseries": [
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0018,
                    0.0019,
                    0.0021,
                    0.0022,
                    0.0024,
                    0.0026,
                    0.0028,
                    0.0029,
                    0.0031,
                    0.0033,
                    0.0035,
                    0.0037,
                    0.0039,
                    0.0041,
                    0.0043,
                    0.0046,
                    0.0048,
                    0.0051,
                    0.0053,
                    0.0056,
                    0.0058,
                    0.0061,
                    0.0064,
                    0.0067,
                    0.007,
                    0.0073,
                    0.0077,
                    0.008,
                    0.0083,
                    0.0087,
                    0.0091,
                    0.0095,
                    0.0099,
                    0.0103,
                    0.0108,
                    0.0112,
                    0.0116,
                    0.0121,
                    0.0126,
                    0.0131,
                    0.0137,
                    0.0143,
                    0.0148,
                    0.0154,
                    0.016,
                    0.0167,
                    0.0172,
                    0.0177,
                    0.0182,
                    0.0187,
                    0.0192,
                    0.0195,
                    0.0199,
                    0.0204,
                    0.0209,
                    0.0213,
                    0.0218,
                    0.0224,
                    0.0229,
                    0.0235,
                    0.024,
                    0.0247,
                    0.0253,
                    0.0258,
                    0.0262,
                    0.0266,
                    0.0271,
                    0.0277,
                    0.0282,
                    0.0289,
                    0.0295,
                    0.0302,
                    0.0309,
                    0.0316,
                    0.0323,
                    0.033,
                    0.0335,
                    0.0337,
                    0.034,
                    0.0345,
                    0.0351,
                    0.0357,
                    0.0364,
                    0.0372,
                    0.0381,
                    0.039,
                    0.04,
                    0.041,
                    0.0422,
                    0.0434,
                    0.0446,
                    0.0459,
                    0.0473,
                    0.0487,
                    0.0503,
                    0.0519,
                    0.0537,
                    0.0556,
                    0.0576,
                    0.0595,
                    0.0615,
                    0.0636,
                    0.0658,
                    0.0679,
                    0.0701,
                    0.0724,
                    0.0746,
                    0.0768,
                    0.0791,
                    0.0813,
                    0.0836,
                    0.0859,
                    0.0882,
                    0.0903,
                    0.0923,
                    0.0942,
                    0.0962,
                    0.0981,
                    0.1001,
                    0.102,
                    0.1038,
                    0.1055,
                    0.1073,
                    0.109,
                    0.1106,
                    0.1122,
                    0.1137,
                    0.1153,
                    0.1168,
                    0.1184,
                    0.1198,
                    0.1213,
                    0.1227,
                    0.1242,
                    0.1256,
                    0.1271,
                    0.1286,
                    0.13,
                    0.1315,
                    0.133,
                    0.1344,
                    0.1356,
                    0.137,
                    0.1383,
                    0.1396,
                    0.1409,
                    0.1421,
                    0.1433,
                    0.1445,
                    0.1457,
                    0.1469,
                    0.1481,
                    0.1491,
                    0.1502,
                    0.1513
                ],
                "Land_3GHG": 3.01,
                "Land_3GHG_timeseries": [
                    0.0002,
                    0.0003,
                    0.0004,
                    0.0006,
                    0.0007,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.004,
                    0.0041,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0047,
                    0.0048,
                    0.005,
                    0.0051,
                    0.0053,
                    0.0054,
                    0.0055,
                    0.0057,
                    0.0058,
                    0.006,
                    0.0062,
                    0.0063,
                    0.0065,
                    0.0066,
                    0.0068,
                    0.007,
                    0.0071,
                    0.0073,
                    0.0075,
                    0.0077,
                    0.0078,
                    0.008,
                    0.0082,
                    0.0084,
                    0.0085,
                    0.0087,
                    0.0088,
                    0.009,
                    0.0091,
                    0.0093,
                    0.0094,
                    0.0096,
                    0.0097,
                    0.0098,
                    0.0099,
                    0.0101,
                    0.0102,
                    0.0103,
                    0.0105,
                    0.0106,
                    0.0107,
                    0.0108,
                    0.011,
                    0.0111,
                    0.0112,
                    0.0113,
                    0.0114,
                    0.0116,
                    0.0117,
                    0.0118,
                    0.0119,
                    0.012,
                    0.0121,
                    0.0122,
                    0.0124,
                    0.0125,
                    0.0126,
                    0.0127,
                    0.0128,
                    0.013,
                    0.0131,
                    0.0132,
                    0.0134,
                    0.0135,
                    0.0137,
                    0.0138,
                    0.014,
                    0.0142,
                    0.0144,
                    0.0146,
                    0.0148,
                    0.015,
                    0.0152,
                    0.0154,
                    0.0156,
                    0.0157,
                    0.0159,
                    0.0161,
                    0.0163,
                    0.0165,
                    0.0166,
                    0.0168,
                    0.017,
                    0.0172,
                    0.0174,
                    0.0175,
                    0.0177,
                    0.0178,
                    0.018,
                    0.0182,
                    0.0183,
                    0.0185,
                    0.0186,
                    0.0188,
                    0.0189,
                    0.019,
                    0.0192,
                    0.0193,
                    0.0195,
                    0.0196,
                    0.0197,
                    0.0198,
                    0.0199,
                    0.02,
                    0.0201,
                    0.0201,
                    0.0201,
                    0.0201,
                    0.02,
                    0.0199,
                    0.0199,
                    0.0198,
                    0.0197,
                    0.0196,
                    0.0195,
                    0.0193,
                    0.0192,
                    0.019,
                    0.0189,
                    0.0187,
                    0.0186,
                    0.0184,
                    0.0183,
                    0.0182,
                    0.018,
                    0.0179,
                    0.0178,
                    0.0177,
                    0.0177,
                    0.0176,
                    0.0176,
                    0.0176,
                    0.0175,
                    0.0175,
                    0.0175,
                    0.0175,
                    0.0175
                ],
                "Total_CO2": 11.9,
                "Total_CO2_timeseries": [
                    0.0001,
                    0.0003,
                    0.0004,
                    0.0005,
                    0.0007,
                    0.0008,
                    0.0009,
                    0.0011,
                    0.0012,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0018,
                    0.0019,
                    0.0021,
                    0.0022,
                    0.0024,
                    0.0025,
                    0.0027,
                    0.0029,
                    0.003,
                    0.0032,
                    0.0034,
                    0.0036,
                    0.0038,
                    0.004,
                    0.0042,
                    0.0044,
                    0.0046,
                    0.0048,
                    0.005,
                    0.0052,
                    0.0055,
                    0.0057,
                    0.006,
                    0.0062,
                    0.0065,
                    0.0067,
                    0.007,
                    0.0073,
                    0.0076,
                    0.0079,
                    0.0082,
                    0.0085,
                    0.0088,
                    0.0092,
                    0.0095,
                    0.0099,
                    0.0103,
                    0.0107,
                    0.0111,
                    0.0115,
                    0.0119,
                    0.0124,
                    0.0128,
                    0.0133,
                    0.0138,
                    0.0143,
                    0.0148,
                    0.0154,
                    0.0159,
                    0.0164,
                    0.017,
                    0.0175,
                    0.018,
                    0.0185,
                    0.019,
                    0.0194,
                    0.0198,
                    0.0202,
                    0.0207,
                    0.0212,
                    0.0216,
                    0.0221,
                    0.0226,
                    0.0231,
                    0.0237,
                    0.0242,
                    0.0248,
                    0.0254,
                    0.0259,
                    0.0263,
                    0.0268,
                    0.0273,
                    0.0278,
                    0.0283,
                    0.0289,
                    0.0294,
                    0.03,
                    0.0306,
                    0.0312,
                    0.0318,
                    0.0324,
                    0.033,
                    0.0332,
                    0.0336,
                    0.034,
                    0.0345,
                    0.035,
                    0.0356,
                    0.0362,
                    0.0369,
                    0.0376,
                    0.0383,
                    0.0391,
                    0.04,
                    0.0408,
                    0.0417,
                    0.0426,
                    0.0435,
                    0.0444,
                    0.0455,
                    0.0466,
                    0.0477,
                    0.0489,
                    0.0501,
                    0.0513,
                    0.0526,
                    0.054,
                    0.0554,
                    0.0569,
                    0.0585,
                    0.0601,
                    0.0617,
                    0.0632,
                    0.0649,
                    0.0666,
                    0.0683,
                    0.0701,
                    0.0719,
                    0.0735,
                    0.0751,
                    0.0767,
                    0.0784,
                    0.08,
                    0.0817,
                    0.0833,
                    0.085,
                    0.0866,
                    0.0883,
                    0.0899,
                    0.0915,
                    0.0931,
                    0.0946,
                    0.0962,
                    0.0978,
                    0.0994,
                    0.101,
                    0.1025,
                    0.104,
                    0.1056,
                    0.1072,
                    0.1088,
                    0.1104,
                    0.112,
                    0.1136,
                    0.1152,
                    0.1167,
                    0.1182,
                    0.1196,
                    0.1211,
                    0.1225,
                    0.1238,
                    0.1251,
                    0.1264,
                    0.1277,
                    0.1291,
                    0.1304,
                    0.1316,
                    0.1327,
                    0.134,
                    0.1351
                ],
                "Fossil_CO2": 17.12,
                "Fossil_CO2_timeseries": [
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0022,
                    0.0023,
                    0.0025,
                    0.0026,
                    0.0028,
                    0.0029,
                    0.0031,
                    0.0033,
                    0.0035,
                    0.0037,
                    0.0039,
                    0.0041,
                    0.0043,
                    0.0045,
                    0.0048,
                    0.005,
                    0.0052,
                    0.0055,
                    0.0058,
                    0.0061,
                    0.0064,
                    0.0067,
                    0.007,
                    0.0073,
                    0.0077,
                    0.008,
                    0.0084,
                    0.0087,
                    0.0091,
                    0.0096,
                    0.01,
                    0.0104,
                    0.0109,
                    0.0114,
                    0.0119,
                    0.0123,
                    0.0127,
                    0.0132,
                    0.0136,
                    0.014,
                    0.0143,
                    0.0147,
                    0.0151,
                    0.0155,
                    0.0159,
                    0.0163,
                    0.0168,
                    0.0172,
                    0.0177,
                    0.0182,
                    0.0188,
                    0.0193,
                    0.0197,
                    0.0201,
                    0.0205,
                    0.021,
                    0.0215,
                    0.0219,
                    0.0225,
                    0.023,
                    0.0236,
                    0.0242,
                    0.0248,
                    0.0254,
                    0.026,
                    0.0265,
                    0.0267,
                    0.0271,
                    0.0276,
                    0.0281,
                    0.0286,
                    0.0292,
                    0.0298,
                    0.0305,
                    0.0312,
                    0.0319,
                    0.0327,
                    0.0335,
                    0.0344,
                    0.0352,
                    0.0361,
                    0.0371,
                    0.0381,
                    0.0391,
                    0.0402,
                    0.0414,
                    0.0426,
                    0.0439,
                    0.0452,
                    0.0465,
                    0.0479,
                    0.0494,
                    0.051,
                    0.0526,
                    0.0543,
                    0.0559,
                    0.0576,
                    0.0593,
                    0.0611,
                    0.0629,
                    0.0647,
                    0.0666,
                    0.0683,
                    0.07,
                    0.0717,
                    0.0734,
                    0.0751,
                    0.0768,
                    0.0785,
                    0.0803,
                    0.082,
                    0.0837,
                    0.0854,
                    0.0871,
                    0.0887,
                    0.0903,
                    0.092,
                    0.0936,
                    0.0953,
                    0.0969,
                    0.0986,
                    0.1002,
                    0.1018,
                    0.1035,
                    0.1052,
                    0.1068,
                    0.1085,
                    0.1102,
                    0.1119,
                    0.1135,
                    0.115,
                    0.1166,
                    0.1181,
                    0.1195,
                    0.121,
                    0.1223,
                    0.1237,
                    0.1251,
                    0.1265,
                    0.1279,
                    0.1292,
                    0.1304,
                    0.1317,
                    0.1329
                ],
                "Land_CO2": 0.6,
                "Land_CO2_timeseries": [
                    0.0001,
                    0.0002,
                    0.0003,
                    0.0004,
                    0.0005,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0048,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0053,
                    0.0054,
                    0.0054,
                    0.0055,
                    0.0056,
                    0.0056,
                    0.0057,
                    0.0057,
                    0.0058,
                    0.0059,
                    0.0059,
                    0.006,
                    0.006,
                    0.0061,
                    0.0061,
                    0.0062,
                    0.0062,
                    0.0062,
                    0.0063,
                    0.0063,
                    0.0063,
                    0.0064,
                    0.0064,
                    0.0064,
                    0.0064,
                    0.0064,
                    0.0064,
                    0.0065,
                    0.0065,
                    0.0065,
                    0.0065,
                    0.0064,
                    0.0064,
                    0.0064,
                    0.0064,
                    0.0064,
                    0.0064,
                    0.0064,
                    0.0064,
                    0.0064,
                    0.0064,
                    0.0064,
                    0.0064,
                    0.0064,
                    0.0064,
                    0.0064,
                    0.0064,
                    0.0063,
                    0.0063,
                    0.0062,
                    0.0062,
                    0.0062,
                    0.0061,
                    0.0061,
                    0.006,
                    0.0059,
                    0.0059,
                    0.0058,
                    0.0057,
                    0.0057,
                    0.0056,
                    0.0055,
                    0.0054,
                    0.0054,
                    0.0053,
                    0.0052,
                    0.0051,
                    0.0051,
                    0.005,
                    0.0049,
                    0.0049,
                    0.0048,
                    0.0047,
                    0.0046,
                    0.0046,
                    0.0045,
                    0.0044,
                    0.0044,
                    0.0043,
                    0.0042,
                    0.0041,
                    0.0041,
                    0.004,
                    0.004,
                    0.0039,
                    0.0038,
                    0.0037,
                    0.0036,
                    0.0035,
                    0.0035,
                    0.0034,
                    0.0033,
                    0.0032,
                    0.0032,
                    0.0031,
                    0.003,
                    0.0029,
                    0.0029,
                    0.0028,
                    0.0027,
                    0.0026,
                    0.0025,
                    0.0025,
                    0.0024,
                    0.0024,
                    0.0023,
                    0.0023
                ],
                "Total_CH4": 5.26,
                "Total_CH4_timeseries": [
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0042,
                    0.0043,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0049,
                    0.0051,
                    0.0052,
                    0.0054,
                    0.0055,
                    0.0057,
                    0.0059,
                    0.006,
                    0.0062,
                    0.0064,
                    0.0066,
                    0.0068,
                    0.007,
                    0.0072,
                    0.0073,
                    0.0075,
                    0.0078,
                    0.0079,
                    0.0081,
                    0.0082,
                    0.0083,
                    0.0084,
                    0.0085,
                    0.0086,
                    0.0087,
                    0.0088,
                    0.0089,
                    0.0091,
                    0.0092,
                    0.0093,
                    0.0094,
                    0.0095,
                    0.0097,
                    0.0098,
                    0.0099,
                    0.0099,
                    0.01,
                    0.0101,
                    0.0102,
                    0.0103,
                    0.0105,
                    0.0106,
                    0.0109,
                    0.011,
                    0.0112,
                    0.0113,
                    0.0115,
                    0.0116,
                    0.0116,
                    0.0117,
                    0.0118,
                    0.0119,
                    0.0121,
                    0.0123,
                    0.0125,
                    0.0128,
                    0.0132,
                    0.0135,
                    0.0139,
                    0.0144,
                    0.0148,
                    0.0153,
                    0.0157,
                    0.0163,
                    0.0168,
                    0.0174,
                    0.0181,
                    0.0187,
                    0.0195,
                    0.0203,
                    0.021,
                    0.0218,
                    0.0226,
                    0.0233,
                    0.024,
                    0.0246,
                    0.0253,
                    0.0259,
                    0.0265,
                    0.0271,
                    0.0276,
                    0.0281,
                    0.0287,
                    0.0291,
                    0.0295,
                    0.0299,
                    0.0302,
                    0.0305,
                    0.0308,
                    0.031,
                    0.0312,
                    0.0313,
                    0.0313,
                    0.0313,
                    0.0313,
                    0.0312,
                    0.031,
                    0.0308,
                    0.0306,
                    0.0303,
                    0.03,
                    0.0297,
                    0.0294,
                    0.029,
                    0.0286,
                    0.0283,
                    0.0279,
                    0.0275,
                    0.027,
                    0.0266,
                    0.0262,
                    0.0258,
                    0.0254,
                    0.0251,
                    0.0247,
                    0.0244,
                    0.0242,
                    0.0239,
                    0.0236,
                    0.0234,
                    0.0231,
                    0.0229,
                    0.0227,
                    0.0224,
                    0.0222,
                    0.022
                ],
                "Fossil_CH4": 5.27,
                "Fossil_CH4_timeseries": [
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0047,
                    0.0048,
                    0.0048,
                    0.0048,
                    0.0049,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0053,
                    0.0054,
                    0.0055,
                    0.0055,
                    0.0055,
                    0.0055,
                    0.0056,
                    0.0056,
                    0.0057,
                    0.0058,
                    0.0058,
                    0.006,
                    0.006,
                    0.0061,
                    0.0062,
                    0.0063,
                    0.0063,
                    0.0062,
                    0.0062,
                    0.0062,
                    0.0062,
                    0.0063,
                    0.0063,
                    0.0065,
                    0.0067,
                    0.0069,
                    0.0071,
                    0.0074,
                    0.0077,
                    0.008,
                    0.0083,
                    0.0086,
                    0.009,
                    0.0094,
                    0.0099,
                    0.0103,
                    0.0109,
                    0.0115,
                    0.0122,
                    0.0127,
                    0.0133,
                    0.014,
                    0.0145,
                    0.0151,
                    0.0156,
                    0.0161,
                    0.0166,
                    0.017,
                    0.0175,
                    0.0179,
                    0.0183,
                    0.0187,
                    0.019,
                    0.0193,
                    0.0196,
                    0.0198,
                    0.0199,
                    0.0201,
                    0.0202,
                    0.0203,
                    0.0204,
                    0.0203,
                    0.0203,
                    0.0202,
                    0.0201,
                    0.02,
                    0.0199,
                    0.0197,
                    0.0196,
                    0.0194,
                    0.0192,
                    0.0189,
                    0.0187,
                    0.0185,
                    0.0182,
                    0.018,
                    0.0177,
                    0.0175,
                    0.0172,
                    0.0169,
                    0.0167,
                    0.0164,
                    0.0162,
                    0.016,
                    0.0158,
                    0.0156,
                    0.0153,
                    0.0151,
                    0.0149,
                    0.0147,
                    0.0145,
                    0.0143,
                    0.0141,
                    0.0139,
                    0.0137
                ],
                "Land_CH4": 5.25,
                "Land_CH4_timeseries": [
                    0,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.004,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0055,
                    0.0056,
                    0.0057,
                    0.0058,
                    0.0059,
                    0.006,
                    0.0061,
                    0.0063,
                    0.0064,
                    0.0065,
                    0.0067,
                    0.0068,
                    0.0069,
                    0.0071,
                    0.0072,
                    0.0074,
                    0.0076,
                    0.0077,
                    0.0079,
                    0.008,
                    0.0081,
                    0.0083,
                    0.0085,
                    0.0086,
                    0.0087,
                    0.0089,
                    0.009,
                    0.0092,
                    0.0093,
                    0.0095,
                    0.0096,
                    0.0097,
                    0.0099,
                    0.01,
                    0.0101,
                    0.0102,
                    0.0103,
                    0.0104,
                    0.0106,
                    0.0107,
                    0.0108,
                    0.0109,
                    0.0109,
                    0.011,
                    0.011,
                    0.0111,
                    0.0111,
                    0.011,
                    0.0109,
                    0.0108,
                    0.0108,
                    0.0107,
                    0.0106,
                    0.0104,
                    0.0103,
                    0.0102,
                    0.01,
                    0.0099,
                    0.0098,
                    0.0096,
                    0.0094,
                    0.0093,
                    0.0092,
                    0.009,
                    0.0089,
                    0.0088,
                    0.0087,
                    0.0086,
                    0.0086,
                    0.0085,
                    0.0085,
                    0.0085,
                    0.0084,
                    0.0084,
                    0.0083,
                    0.0083,
                    0.0083
                ],
                "Total_N2O": 14.09,
                "Total_N2O_timeseries": [
                    8.6532e-06,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0037,
                    0.0038,
                    0.004,
                    0.0041,
                    0.0043,
                    0.0044,
                    0.0046,
                    0.0047,
                    0.0049,
                    0.0051,
                    0.0052,
                    0.0054,
                    0.0056,
                    0.0057,
                    0.0059,
                    0.0061,
                    0.0063,
                    0.0064,
                    0.0066,
                    0.0068,
                    0.0069,
                    0.0071,
                    0.0073,
                    0.0074,
                    0.0076,
                    0.0077,
                    0.0079,
                    0.008,
                    0.0082,
                    0.0083,
                    0.0085,
                    0.0086,
                    0.0087,
                    0.0089,
                    0.009,
                    0.0091,
                    0.0092,
                    0.0094,
                    0.0095,
                    0.0096,
                    0.0097,
                    0.0099,
                    0.01,
                    0.0101,
                    0.0102,
                    0.0103,
                    0.0104,
                    0.0105,
                    0.0106,
                    0.0108,
                    0.0109,
                    0.011,
                    0.0111,
                    0.0112,
                    0.0113,
                    0.0114,
                    0.0115,
                    0.0116
                ],
                "Fossil_N2O": 20.5,
                "Fossil_N2O_timeseries": [
                    4.0148e-06,
                    8.0774e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.004,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0043,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0045,
                    0.0045,
                    0.0046,
                    0.0046,
                    0.0046,
                    0.0047,
                    0.0047
                ],
                "Land_N2O": 11.62,
                "Land_N2O_timeseries": [
                    4.6384e-06,
                    9.3696e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.005,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0054,
                    0.0055,
                    0.0056,
                    0.0057,
                    0.0057,
                    0.0058,
                    0.0059,
                    0.006,
                    0.006,
                    0.0061,
                    0.0062,
                    0.0063,
                    0.0063,
                    0.0064,
                    0.0065,
                    0.0066,
                    0.0066,
                    0.0067,
                    0.0068,
                    0.0069,
                    0.0069
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                12.42451,
                                56.09483
                            ],
                            [
                                12.28701,
                                56.12947
                            ],
                            [
                                12.19473,
                                56.11302
                            ],
                            [
                                11.84272,
                                55.9662
                            ],
                            [
                                11.891,
                                55.94146
                            ],
                            [
                                12.00703,
                                55.96653
                            ],
                            [
                                12.02302,
                                55.9012
                            ],
                            [
                                11.88079,
                                55.81381
                            ],
                            [
                                11.83621,
                                55.68432
                            ],
                            [
                                11.74657,
                                55.73888
                            ],
                            [
                                11.7298,
                                55.83721
                            ],
                            [
                                11.75088,
                                55.96986
                            ],
                            [
                                11.63223,
                                55.93931
                            ],
                            [
                                11.52303,
                                55.95156
                            ],
                            [
                                11.51466,
                                55.86333
                            ],
                            [
                                11.37277,
                                55.83309
                            ],
                            [
                                11.37989,
                                55.77739
                            ],
                            [
                                11.26996,
                                55.73167
                            ],
                            [
                                11.17701,
                                55.75429
                            ],
                            [
                                10.99151,
                                55.72433
                            ],
                            [
                                11.07017,
                                55.67643
                            ],
                            [
                                11.15618,
                                55.55376
                            ],
                            [
                                11.12756,
                                55.52581
                            ],
                            [
                                11.20416,
                                55.44611
                            ],
                            [
                                11.20577,
                                55.34368
                            ],
                            [
                                11.24627,
                                55.2067
                            ],
                            [
                                11.43242,
                                55.21793
                            ],
                            [
                                11.71344,
                                55.15908
                            ],
                            [
                                11.75165,
                                55.08204
                            ],
                            [
                                11.89721,
                                54.99463
                            ],
                            [
                                12.02534,
                                54.96308
                            ],
                            [
                                12.17085,
                                55.00403
                            ],
                            [
                                12.12952,
                                55.04792
                            ],
                            [
                                12.18212,
                                55.11028
                            ],
                            [
                                12.04867,
                                55.12594
                            ],
                            [
                                12.02879,
                                55.16483
                            ],
                            [
                                12.27255,
                                55.24181
                            ],
                            [
                                12.35238,
                                55.23607
                            ],
                            [
                                12.45419,
                                55.28408
                            ],
                            [
                                12.44487,
                                55.34909
                            ],
                            [
                                12.36734,
                                55.39621
                            ],
                            [
                                12.20028,
                                55.44175
                            ],
                            [
                                12.19509,
                                55.4877
                            ],
                            [
                                12.31279,
                                55.57997
                            ],
                            [
                                12.51019,
                                55.63508
                            ],
                            [
                                12.59532,
                                55.68012
                            ],
                            [
                                12.57544,
                                55.84312
                            ],
                            [
                                12.51888,
                                55.91938
                            ],
                            [
                                12.62364,
                                56.04006
                            ],
                            [
                                12.49932,
                                56.09195
                            ],
                            [
                                12.42451,
                                56.09483
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                10.43242,
                                57.60333
                            ],
                            [
                                10.51423,
                                57.68027
                            ],
                            [
                                10.18691,
                                57.59846
                            ],
                            [
                                9.95744,
                                57.59462
                            ],
                            [
                                9.79339,
                                57.47592
                            ],
                            [
                                9.73046,
                                57.3958
                            ],
                            [
                                9.54628,
                                57.2314
                            ],
                            [
                                9.36256,
                                57.1561
                            ],
                            [
                                9.14831,
                                57.13865
                            ],
                            [
                                8.97002,
                                57.15712
                            ],
                            [
                                8.87512,
                                57.12029
                            ],
                            [
                                8.736,
                                57.10109
                            ],
                            [
                                8.62025,
                                57.12621
                            ],
                            [
                                8.36312,
                                56.95867
                            ],
                            [
                                8.22886,
                                56.78528
                            ],
                            [
                                8.30264,
                                56.75254
                            ],
                            [
                                8.35622,
                                56.67726
                            ],
                            [
                                8.48447,
                                56.63346
                            ],
                            [
                                8.60779,
                                56.63622
                            ],
                            [
                                8.4787,
                                56.72255
                            ],
                            [
                                8.47769,
                                56.79024
                            ],
                            [
                                8.63192,
                                56.86399
                            ],
                            [
                                8.6263,
                                56.88935
                            ],
                            [
                                8.66822,
                                56.95007
                            ],
                            [
                                8.75032,
                                56.94553
                            ],
                            [
                                8.99129,
                                57.01836
                            ],
                            [
                                9.13415,
                                57.0392
                            ],
                            [
                                9.24029,
                                56.99071
                            ],
                            [
                                9.48716,
                                57.04399
                            ],
                            [
                                9.57768,
                                57.04153
                            ],
                            [
                                9.78945,
                                57.10602
                            ],
                            [
                                9.93415,
                                57.054
                            ],
                            [
                                10.01606,
                                57.08703
                            ],
                            [
                                10.22571,
                                56.98881
                            ],
                            [
                                10.33113,
                                56.98927
                            ],
                            [
                                10.44224,
                                57.17039
                            ],
                            [
                                10.54571,
                                57.22746
                            ],
                            [
                                10.51911,
                                57.35734
                            ],
                            [
                                10.53591,
                                57.46722
                            ],
                            [
                                10.44392,
                                57.53834
                            ],
                            [
                                10.43242,
                                57.60333
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                10.41432,
                                55.58972
                            ],
                            [
                                10.32455,
                                55.61985
                            ],
                            [
                                10.03515,
                                55.55613
                            ],
                            [
                                9.93975,
                                55.51181
                            ],
                            [
                                9.78209,
                                55.5432
                            ],
                            [
                                9.74101,
                                55.47563
                            ],
                            [
                                9.80375,
                                55.45085
                            ],
                            [
                                9.93131,
                                55.21862
                            ],
                            [
                                10.01903,
                                55.18288
                            ],
                            [
                                10.10769,
                                55.19004
                            ],
                            [
                                10.21229,
                                55.06621
                            ],
                            [
                                10.51567,
                                55.02668
                            ],
                            [
                                10.74436,
                                55.07035
                            ],
                            [
                                10.81456,
                                55.23124
                            ],
                            [
                                10.8179,
                                55.31261
                            ],
                            [
                                10.76345,
                                55.38766
                            ],
                            [
                                10.62599,
                                55.49036
                            ],
                            [
                                10.52242,
                                55.46633
                            ],
                            [
                                10.41432,
                                55.58972
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                11.25606,
                                54.95765
                            ],
                            [
                                11.08011,
                                54.94287
                            ],
                            [
                                11.01596,
                                54.88862
                            ],
                            [
                                11.07738,
                                54.84766
                            ],
                            [
                                10.97305,
                                54.79515
                            ],
                            [
                                11.0029,
                                54.76257
                            ],
                            [
                                11.24354,
                                54.70735
                            ],
                            [
                                11.45988,
                                54.60915
                            ],
                            [
                                11.5809,
                                54.65725
                            ],
                            [
                                11.80629,
                                54.64575
                            ],
                            [
                                11.81741,
                                54.7326
                            ],
                            [
                                11.85105,
                                54.77362
                            ],
                            [
                                11.65956,
                                54.90101
                            ],
                            [
                                11.55494,
                                54.82885
                            ],
                            [
                                11.37842,
                                54.88545
                            ],
                            [
                                11.25606,
                                54.95765
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.92447,
                                55.21945
                            ],
                            [
                                14.78021,
                                55.29044
                            ],
                            [
                                14.71328,
                                55.22429
                            ],
                            [
                                14.69178,
                                55.09167
                            ],
                            [
                                14.77606,
                                55.0529
                            ],
                            [
                                15.08266,
                                54.98814
                            ],
                            [
                                15.15474,
                                55.07747
                            ],
                            [
                                15.15452,
                                55.13207
                            ],
                            [
                                14.92447,
                                55.21945
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                11.84223,
                                54.95897
                            ],
                            [
                                11.74305,
                                54.96031
                            ],
                            [
                                11.75605,
                                54.8563
                            ],
                            [
                                11.86026,
                                54.77545
                            ],
                            [
                                11.91081,
                                54.71604
                            ],
                            [
                                11.98092,
                                54.70164
                            ],
                            [
                                12.16633,
                                54.83518
                            ],
                            [
                                12.1195,
                                54.88729
                            ],
                            [
                                11.89133,
                                54.92187
                            ],
                            [
                                11.84223,
                                54.95897
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.91085,
                                56.95493
                            ],
                            [
                                8.81672,
                                56.90411
                            ],
                            [
                                8.63772,
                                56.88605
                            ],
                            [
                                8.64739,
                                56.85587
                            ],
                            [
                                8.54269,
                                56.78793
                            ],
                            [
                                8.64551,
                                56.66973
                            ],
                            [
                                8.77428,
                                56.69386
                            ],
                            [
                                8.87868,
                                56.79408
                            ],
                            [
                                8.91085,
                                56.95493
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                10.88769,
                                54.9879
                            ],
                            [
                                10.93539,
                                55.08337
                            ],
                            [
                                10.8766,
                                55.10219
                            ],
                            [
                                10.80912,
                                54.9956
                            ],
                            [
                                10.67473,
                                54.90827
                            ],
                            [
                                10.64161,
                                54.81384
                            ],
                            [
                                10.73292,
                                54.74112
                            ],
                            [
                                10.84315,
                                54.95064
                            ],
                            [
                                10.88769,
                                54.9879
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.27222,
                                55.0549
                            ],
                            [
                                12.27857,
                                54.98929
                            ],
                            [
                                12.12204,
                                54.95782
                            ],
                            [
                                12.14332,
                                54.88189
                            ],
                            [
                                12.2078,
                                54.88238
                            ],
                            [
                                12.31279,
                                54.95199
                            ],
                            [
                                12.50961,
                                54.9435
                            ],
                            [
                                12.52406,
                                55.00718
                            ],
                            [
                                12.3164,
                                55.02788
                            ],
                            [
                                12.27222,
                                55.0549
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                11.19877,
                                57.32062
                            ],
                            [
                                11.03019,
                                57.31902
                            ],
                            [
                                10.87286,
                                57.26456
                            ],
                            [
                                10.99592,
                                57.21679
                            ],
                            [
                                11.11316,
                                57.29755
                            ],
                            [
                                11.19877,
                                57.32062
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                10.58594,
                                55.94287
                            ],
                            [
                                10.52971,
                                55.85198
                            ],
                            [
                                10.5297,
                                55.79113
                            ],
                            [
                                10.6215,
                                55.76647
                            ],
                            [
                                10.64525,
                                55.84399
                            ],
                            [
                                10.58594,
                                55.94287
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.6287,
                                55.69528
                            ],
                            [
                                12.50716,
                                55.60787
                            ],
                            [
                                12.59238,
                                55.55487
                            ],
                            [
                                12.67941,
                                55.58826
                            ],
                            [
                                12.6287,
                                55.69528
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                23.84296,
                                35.52782
                            ],
                            [
                                23.77983,
                                35.54584
                            ],
                            [
                                23.77276,
                                35.66891
                            ],
                            [
                                23.70939,
                                35.66021
                            ],
                            [
                                23.72842,
                                35.54636
                            ],
                            [
                                23.65466,
                                35.50169
                            ],
                            [
                                23.56988,
                                35.52934
                            ],
                            [
                                23.56656,
                                35.42844
                            ],
                            [
                                23.53385,
                                35.37632
                            ],
                            [
                                23.54212,
                                35.27122
                            ],
                            [
                                23.58844,
                                35.23202
                            ],
                            [
                                23.78507,
                                35.23265
                            ],
                            [
                                23.82621,
                                35.24889
                            ],
                            [
                                23.92352,
                                35.2218
                            ],
                            [
                                23.97896,
                                35.2312
                            ],
                            [
                                24.05056,
                                35.1944
                            ],
                            [
                                24.19961,
                                35.20053
                            ],
                            [
                                24.28752,
                                35.17601
                            ],
                            [
                                24.38596,
                                35.19399
                            ],
                            [
                                24.45492,
                                35.15061
                            ],
                            [
                                24.52012,
                                35.14349
                            ],
                            [
                                24.56031,
                                35.10187
                            ],
                            [
                                24.73859,
                                35.08214
                            ],
                            [
                                24.75154,
                                34.9566
                            ],
                            [
                                24.79359,
                                34.92419
                            ],
                            [
                                25.19281,
                                34.94632
                            ],
                            [
                                25.37275,
                                34.9973
                            ],
                            [
                                25.49997,
                                34.98226
                            ],
                            [
                                25.69046,
                                35.01395
                            ],
                            [
                                25.81312,
                                34.99998
                            ],
                            [
                                25.97635,
                                35.03894
                            ],
                            [
                                26.09684,
                                34.9985
                            ],
                            [
                                26.23142,
                                35.03611
                            ],
                            [
                                26.2842,
                                35.13187
                            ],
                            [
                                26.26516,
                                35.26459
                            ],
                            [
                                26.13673,
                                35.19703
                            ],
                            [
                                26.02787,
                                35.22831
                            ],
                            [
                                25.94712,
                                35.18267
                            ],
                            [
                                25.89663,
                                35.18479
                            ],
                            [
                                25.81369,
                                35.11032
                            ],
                            [
                                25.72765,
                                35.13058
                            ],
                            [
                                25.71018,
                                35.17543
                            ],
                            [
                                25.7276,
                                35.30284
                            ],
                            [
                                25.65968,
                                35.34809
                            ],
                            [
                                25.43114,
                                35.2943
                            ],
                            [
                                25.38441,
                                35.33767
                            ],
                            [
                                25.19925,
                                35.33259
                            ],
                            [
                                25.04674,
                                35.34524
                            ],
                            [
                                25.01798,
                                35.41998
                            ],
                            [
                                24.91861,
                                35.40425
                            ],
                            [
                                24.70044,
                                35.42623
                            ],
                            [
                                24.55169,
                                35.37588
                            ],
                            [
                                24.35671,
                                35.3522
                            ],
                            [
                                24.25805,
                                35.37968
                            ],
                            [
                                24.25831,
                                35.4532
                            ],
                            [
                                24.20013,
                                35.44989
                            ],
                            [
                                24.15667,
                                35.49518
                            ],
                            [
                                24.20046,
                                35.53866
                            ],
                            [
                                24.16901,
                                35.58889
                            ],
                            [
                                23.99428,
                                35.51247
                            ],
                            [
                                23.84296,
                                35.52782
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                26.36478,
                                39.37632
                            ],
                            [
                                26.16905,
                                39.37034
                            ],
                            [
                                26.12056,
                                39.3073
                            ],
                            [
                                25.85998,
                                39.25598
                            ],
                            [
                                25.84532,
                                39.17629
                            ],
                            [
                                25.95815,
                                39.10699
                            ],
                            [
                                26.07253,
                                39.08862
                            ],
                            [
                                26.16914,
                                39.19556
                            ],
                            [
                                26.24735,
                                39.20562
                            ],
                            [
                                26.2806,
                                39.15627
                            ],
                            [
                                26.18777,
                                39.12469
                            ],
                            [
                                26.11778,
                                39.06277
                            ],
                            [
                                26.169,
                                39.00772
                            ],
                            [
                                26.23089,
                                39.01615
                            ],
                            [
                                26.39988,
                                38.96358
                            ],
                            [
                                26.60399,
                                39.00941
                            ],
                            [
                                26.5342,
                                39.1698
                            ],
                            [
                                26.38282,
                                39.27062
                            ],
                            [
                                26.4224,
                                39.33356
                            ],
                            [
                                26.36478,
                                39.37632
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                28.22957,
                                36.44442
                            ],
                            [
                                28.05505,
                                36.39873
                            ],
                            [
                                27.8784,
                                36.32239
                            ],
                            [
                                27.80575,
                                36.26984
                            ],
                            [
                                27.71208,
                                36.11306
                            ],
                            [
                                27.75828,
                                36.09532
                            ],
                            [
                                27.75499,
                                36.01379
                            ],
                            [
                                27.71967,
                                35.94041
                            ],
                            [
                                27.77126,
                                35.88764
                            ],
                            [
                                27.86248,
                                35.92811
                            ],
                            [
                                27.95543,
                                36.04579
                            ],
                            [
                                28.07584,
                                36.07381
                            ],
                            [
                                28.07748,
                                36.14532
                            ],
                            [
                                28.13819,
                                36.18749
                            ],
                            [
                                28.17468,
                                36.28094
                            ],
                            [
                                28.24581,
                                36.38715
                            ],
                            [
                                28.22957,
                                36.44442
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                26.00329,
                                38.60409
                            ],
                            [
                                25.85057,
                                38.57424
                            ],
                            [
                                25.86484,
                                38.49188
                            ],
                            [
                                25.95664,
                                38.43989
                            ],
                            [
                                25.99356,
                                38.34328
                            ],
                            [
                                25.95351,
                                38.29469
                            ],
                            [
                                25.87608,
                                38.27142
                            ],
                            [
                                25.88956,
                                38.2214
                            ],
                            [
                                26.01187,
                                38.14998
                            ],
                            [
                                26.09937,
                                38.21211
                            ],
                            [
                                26.10477,
                                38.2724
                            ],
                            [
                                26.157,
                                38.30966
                            ],
                            [
                                26.13443,
                                38.41558
                            ],
                            [
                                26.16092,
                                38.54915
                            ],
                            [
                                26.08973,
                                38.55761
                            ],
                            [
                                26.00329,
                                38.60409
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                20.56169,
                                38.47485
                            ],
                            [
                                20.53387,
                                38.34125
                            ],
                            [
                                20.4892,
                                38.31197
                            ],
                            [
                                20.39741,
                                38.35097
                            ],
                            [
                                20.38828,
                                38.27754
                            ],
                            [
                                20.33792,
                                38.18868
                            ],
                            [
                                20.43978,
                                38.1624
                            ],
                            [
                                20.56445,
                                38.09091
                            ],
                            [
                                20.60645,
                                38.11714
                            ],
                            [
                                20.70333,
                                38.06944
                            ],
                            [
                                20.79353,
                                38.06444
                            ],
                            [
                                20.8136,
                                38.11013
                            ],
                            [
                                20.67521,
                                38.27024
                            ],
                            [
                                20.62638,
                                38.2592
                            ],
                            [
                                20.61032,
                                38.40144
                            ],
                            [
                                20.56169,
                                38.47485
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                19.89531,
                                39.79506
                            ],
                            [
                                19.67235,
                                39.79481
                            ],
                            [
                                19.63506,
                                39.75207
                            ],
                            [
                                19.67485,
                                39.68204
                            ],
                            [
                                19.83014,
                                39.57305
                            ],
                            [
                                19.87133,
                                39.45589
                            ],
                            [
                                20.0853,
                                39.36737
                            ],
                            [
                                20.03376,
                                39.43644
                            ],
                            [
                                19.93923,
                                39.47322
                            ],
                            [
                                19.91014,
                                39.56622
                            ],
                            [
                                19.92296,
                                39.61574
                            ],
                            [
                                19.84594,
                                39.65652
                            ],
                            [
                                19.84406,
                                39.70386
                            ],
                            [
                                19.92973,
                                39.73587
                            ],
                            [
                                19.89531,
                                39.79506
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                25.4381,
                                40.00914
                            ],
                            [
                                25.36803,
                                40.00137
                            ],
                            [
                                25.30198,
                                39.94804
                            ],
                            [
                                25.23105,
                                40.00312
                            ],
                            [
                                25.05457,
                                39.98566
                            ],
                            [
                                25.0525,
                                39.86433
                            ],
                            [
                                25.15539,
                                39.83096
                            ],
                            [
                                25.24416,
                                39.85898
                            ],
                            [
                                25.30241,
                                39.79578
                            ],
                            [
                                25.36978,
                                39.81106
                            ],
                            [
                                25.34241,
                                39.87663
                            ],
                            [
                                25.44245,
                                39.98081
                            ],
                            [
                                25.4381,
                                40.00914
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                26.95446,
                                37.75858
                            ],
                            [
                                26.85032,
                                37.80456
                            ],
                            [
                                26.73526,
                                37.81188
                            ],
                            [
                                26.5994,
                                37.76284
                            ],
                            [
                                26.5909,
                                37.67845
                            ],
                            [
                                26.70687,
                                37.70995
                            ],
                            [
                                26.81364,
                                37.6384
                            ],
                            [
                                26.91172,
                                37.68247
                            ],
                            [
                                27.0364,
                                37.70633
                            ],
                            [
                                27.0281,
                                37.75468
                            ],
                            [
                                26.95446,
                                37.75858
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                25.54928,
                                37.18373
                            ],
                            [
                                25.49363,
                                37.18749
                            ],
                            [
                                25.37575,
                                37.10859
                            ],
                            [
                                25.36743,
                                37.02406
                            ],
                            [
                                25.45,
                                36.91818
                            ],
                            [
                                25.54875,
                                36.95746
                            ],
                            [
                                25.5986,
                                37.1165
                            ],
                            [
                                25.54928,
                                37.18373
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                20.76957,
                                37.84226
                            ],
                            [
                                20.68087,
                                37.92396
                            ],
                            [
                                20.62998,
                                37.87985
                            ],
                            [
                                20.63227,
                                37.81257
                            ],
                            [
                                20.71218,
                                37.72607
                            ],
                            [
                                20.83403,
                                37.64552
                            ],
                            [
                                20.87003,
                                37.72553
                            ],
                            [
                                20.91969,
                                37.73562
                            ],
                            [
                                20.90243,
                                37.80471
                            ],
                            [
                                20.76957,
                                37.84226
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                24.6742,
                                40.78245
                            ],
                            [
                                24.56301,
                                40.76219
                            ],
                            [
                                24.51115,
                                40.66127
                            ],
                            [
                                24.64279,
                                40.56865
                            ],
                            [
                                24.78216,
                                40.62513
                            ],
                            [
                                24.76319,
                                40.73149
                            ],
                            [
                                24.6742,
                                40.78245
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                24.86931,
                                37.90745
                            ],
                            [
                                24.78821,
                                37.99623
                            ],
                            [
                                24.68677,
                                37.95048
                            ],
                            [
                                24.71172,
                                37.87551
                            ],
                            [
                                24.79942,
                                37.82487
                            ],
                            [
                                24.95418,
                                37.70387
                            ],
                            [
                                24.99798,
                                37.76896
                            ],
                            [
                                24.94248,
                                37.83783
                            ],
                            [
                                24.95287,
                                37.89818
                            ],
                            [
                                24.86931,
                                37.90745
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                20.68034,
                                38.83913
                            ],
                            [
                                20.59973,
                                38.78055
                            ],
                            [
                                20.55656,
                                38.68006
                            ],
                            [
                                20.55469,
                                38.61121
                            ],
                            [
                                20.61577,
                                38.60046
                            ],
                            [
                                20.72422,
                                38.63643
                            ],
                            [
                                20.71939,
                                38.82397
                            ],
                            [
                                20.68034,
                                38.83913
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                27.23252,
                                35.81453
                            ],
                            [
                                27.16491,
                                35.80008
                            ],
                            [
                                27.16255,
                                35.72742
                            ],
                            [
                                27.11976,
                                35.6445
                            ],
                            [
                                27.06792,
                                35.60597
                            ],
                            [
                                27.11147,
                                35.54771
                            ],
                            [
                                27.15341,
                                35.42545
                            ],
                            [
                                27.20303,
                                35.48073
                            ],
                            [
                                27.20242,
                                35.57306
                            ],
                            [
                                27.15142,
                                35.61307
                            ],
                            [
                                27.21658,
                                35.72885
                            ],
                            [
                                27.23252,
                                35.81453
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                27.28034,
                                36.9158
                            ],
                            [
                                27.07527,
                                36.84949
                            ],
                            [
                                26.9946,
                                36.77156
                            ],
                            [
                                27.10094,
                                36.75665
                            ],
                            [
                                27.17095,
                                36.80736
                            ],
                            [
                                27.32534,
                                36.84602
                            ],
                            [
                                27.28034,
                                36.9158
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                23.09876,
                                36.24936
                            ],
                            [
                                23.00194,
                                36.30978
                            ],
                            [
                                22.95077,
                                36.38256
                            ],
                            [
                                22.89213,
                                36.32125
                            ],
                            [
                                22.9225,
                                36.28868
                            ],
                            [
                                22.90947,
                                36.20052
                            ],
                            [
                                22.94338,
                                36.15739
                            ],
                            [
                                23.04654,
                                36.13156
                            ],
                            [
                                23.05492,
                                36.21759
                            ],
                            [
                                23.09876,
                                36.24936
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                26.3641,
                                37.6892
                            ],
                            [
                                26.29647,
                                37.67959
                            ],
                            [
                                26.20007,
                                37.62756
                            ],
                            [
                                26.06401,
                                37.62669
                            ],
                            [
                                25.97919,
                                37.53642
                            ],
                            [
                                26.06294,
                                37.51698
                            ],
                            [
                                26.10926,
                                37.55394
                            ],
                            [
                                26.21438,
                                37.56808
                            ],
                            [
                                26.32212,
                                37.63299
                            ],
                            [
                                26.3641,
                                37.6892
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                24.57623,
                                38.8843
                            ],
                            [
                                24.57688,
                                38.9267
                            ],
                            [
                                24.49031,
                                38.97633
                            ],
                            [
                                24.43462,
                                38.88326
                            ],
                            [
                                24.56717,
                                38.83365
                            ],
                            [
                                24.60876,
                                38.77076
                            ],
                            [
                                24.67827,
                                38.81103
                            ],
                            [
                                24.57623,
                                38.8843
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                25.02721,
                                37.67789
                            ],
                            [
                                24.99629,
                                37.63907
                            ],
                            [
                                25.18788,
                                37.52507
                            ],
                            [
                                25.2324,
                                37.53789
                            ],
                            [
                                25.25146,
                                37.6102
                            ],
                            [
                                25.20517,
                                37.63355
                            ],
                            [
                                25.0505,
                                37.65382
                            ],
                            [
                                25.02721,
                                37.67789
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                25.22569,
                                37.15446
                            ],
                            [
                                25.15909,
                                37.12186
                            ],
                            [
                                25.10808,
                                37.06235
                            ],
                            [
                                25.11788,
                                36.99438
                            ],
                            [
                                25.17977,
                                36.97542
                            ],
                            [
                                25.24825,
                                37.01334
                            ],
                            [
                                25.282,
                                37.12276
                            ],
                            [
                                25.22569,
                                37.15446
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                25.58882,
                                40.50472
                            ],
                            [
                                25.49466,
                                40.49501
                            ],
                            [
                                25.45884,
                                40.45812
                            ],
                            [
                                25.55923,
                                40.39605
                            ],
                            [
                                25.6968,
                                40.4226
                            ],
                            [
                                25.69957,
                                40.46408
                            ],
                            [
                                25.58882,
                                40.50472
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                24.44052,
                                36.7548
                            ],
                            [
                                24.3414,
                                36.74256
                            ],
                            [
                                24.33955,
                                36.65274
                            ],
                            [
                                24.53407,
                                36.6777
                            ],
                            [
                                24.53159,
                                36.74142
                            ],
                            [
                                24.44052,
                                36.7548
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                24.34721,
                                37.68562
                            ],
                            [
                                24.26898,
                                37.61086
                            ],
                            [
                                24.295,
                                37.52575
                            ],
                            [
                                24.3867,
                                37.60706
                            ],
                            [
                                24.40864,
                                37.6541
                            ],
                            [
                                24.34721,
                                37.68562
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                26.01715,
                                36.93408
                            ],
                            [
                                25.91054,
                                36.86788
                            ],
                            [
                                25.846,
                                36.85069
                            ],
                            [
                                25.87145,
                                36.79133
                            ],
                            [
                                26.00931,
                                36.89302
                            ],
                            [
                                26.01715,
                                36.93408
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                26.89056,
                                37.07886
                            ],
                            [
                                26.93901,
                                37.04305
                            ],
                            [
                                26.91106,
                                36.95121
                            ],
                            [
                                27.0186,
                                36.94724
                            ],
                            [
                                27.04978,
                                36.99889
                            ],
                            [
                                26.89056,
                                37.07886
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                25.38739,
                                36.72843
                            ],
                            [
                                25.27404,
                                36.78586
                            ],
                            [
                                25.25617,
                                36.73028
                            ],
                            [
                                25.35595,
                                36.6469
                            ],
                            [
                                25.38739,
                                36.72843
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                24.48396,
                                37.40087
                            ],
                            [
                                24.38122,
                                37.44359
                            ],
                            [
                                24.3957,
                                37.30834
                            ],
                            [
                                24.48396,
                                37.40087
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                20.67225,
                                38.46957
                            ],
                            [
                                20.61596,
                                38.46607
                            ],
                            [
                                20.68472,
                                38.34722
                            ],
                            [
                                20.74962,
                                38.36916
                            ],
                            [
                                20.67225,
                                38.46957
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                23.53701,
                                37.98297
                            ],
                            [
                                23.48317,
                                38.00173
                            ],
                            [
                                23.4027,
                                37.8937
                            ],
                            [
                                23.51365,
                                37.89686
                            ],
                            [
                                23.53701,
                                37.98297
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                23.50572,
                                37.77453
                            ],
                            [
                                23.41837,
                                37.76095
                            ],
                            [
                                23.47981,
                                37.67391
                            ],
                            [
                                23.52431,
                                37.69334
                            ],
                            [
                                23.50572,
                                37.77453
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                24.65933,
                                37.03693
                            ],
                            [
                                24.65677,
                                36.98063
                            ],
                            [
                                24.69994,
                                36.90243
                            ],
                            [
                                24.76477,
                                36.94957
                            ],
                            [
                                24.65933,
                                37.03693
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                24.49724,
                                37.20771
                            ],
                            [
                                24.41972,
                                37.15648
                            ],
                            [
                                24.5175,
                                37.12211
                            ],
                            [
                                24.49724,
                                37.20771
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                23.86519,
                                39.13858
                            ],
                            [
                                23.97593,
                                39.25484
                            ],
                            [
                                23.93676,
                                39.27652
                            ],
                            [
                                23.87671,
                                39.20673
                            ],
                            [
                                23.86519,
                                39.13858
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                27.85855,
                                36.66545
                            ],
                            [
                                27.78607,
                                36.58458
                            ],
                            [
                                27.84707,
                                36.56259
                            ],
                            [
                                27.88045,
                                36.60664
                            ],
                            [
                                27.85855,
                                36.66545
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                27.34973,
                                36.48247
                            ],
                            [
                                27.39444,
                                36.37656
                            ],
                            [
                                27.43762,
                                36.39291
                            ],
                            [
                                27.34973,
                                36.48247
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                26.80888,
                                37.20204
                            ],
                            [
                                26.76568,
                                37.17423
                            ],
                            [
                                26.85222,
                                37.09656
                            ],
                            [
                                26.8831,
                                37.12524
                            ],
                            [
                                26.80888,
                                37.20204
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                23.39925,
                                37.63648
                            ],
                            [
                                23.30845,
                                37.61861
                            ],
                            [
                                23.37571,
                                37.55658
                            ],
                            [
                                23.39925,
                                37.63648
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                34.58451,
                                35.69436
                            ],
                            [
                                34.34839,
                                35.62132
                            ],
                            [
                                34.28828,
                                35.57584
                            ],
                            [
                                34.1734,
                                35.55911
                            ],
                            [
                                34.12855,
                                35.50783
                            ],
                            [
                                33.98077,
                                35.44791
                            ],
                            [
                                33.85042,
                                35.41305
                            ],
                            [
                                33.77194,
                                35.41335
                            ],
                            [
                                33.6526,
                                35.35919
                            ],
                            [
                                33.48237,
                                35.33241
                            ],
                            [
                                33.09508,
                                35.35381
                            ],
                            [
                                32.99316,
                                35.36846
                            ],
                            [
                                32.92147,
                                35.40285
                            ],
                            [
                                32.93491,
                                35.2684
                            ],
                            [
                                32.8952,
                                35.17285
                            ],
                            [
                                32.82498,
                                35.14118
                            ],
                            [
                                32.64953,
                                35.19533
                            ],
                            [
                                32.55102,
                                35.175
                            ],
                            [
                                32.48892,
                                35.08523
                            ],
                            [
                                32.31302,
                                34.99573
                            ],
                            [
                                32.31784,
                                34.89789
                            ],
                            [
                                32.38924,
                                34.83763
                            ],
                            [
                                32.40592,
                                34.76582
                            ],
                            [
                                32.49484,
                                34.70363
                            ],
                            [
                                32.55711,
                                34.69622
                            ],
                            [
                                32.70456,
                                34.64097
                            ],
                            [
                                32.87453,
                                34.66654
                            ],
                            [
                                32.93666,
                                34.56839
                            ],
                            [
                                33.00917,
                                34.5946
                            ],
                            [
                                33.03016,
                                34.66566
                            ],
                            [
                                33.14827,
                                34.71225
                            ],
                            [
                                33.2581,
                                34.70546
                            ],
                            [
                                33.60197,
                                34.81619
                            ],
                            [
                                33.63834,
                                34.86614
                            ],
                            [
                                33.64189,
                                34.93426
                            ],
                            [
                                33.69803,
                                34.97774
                            ],
                            [
                                33.77721,
                                34.97917
                            ],
                            [
                                33.84844,
                                34.94792
                            ],
                            [
                                33.97075,
                                34.9875
                            ],
                            [
                                34.07654,
                                34.98803
                            ],
                            [
                                33.91519,
                                35.1598
                            ],
                            [
                                33.90656,
                                35.25627
                            ],
                            [
                                33.9647,
                                35.32019
                            ],
                            [
                                34.06317,
                                35.32757
                            ],
                            [
                                34.08034,
                                35.36697
                            ],
                            [
                                34.17303,
                                35.43854
                            ],
                            [
                                34.28192,
                                35.48002
                            ],
                            [
                                34.40873,
                                35.55882
                            ],
                            [
                                34.46725,
                                35.6159
                            ],
                            [
                                34.56207,
                                35.64273
                            ],
                            [
                                34.58451,
                                35.69436
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                3.17671,
                                39.95323
                            ],
                            [
                                3.06268,
                                39.92127
                            ],
                            [
                                2.94949,
                                39.91853
                            ],
                            [
                                2.84401,
                                39.86192
                            ],
                            [
                                2.779,
                                39.85533
                            ],
                            [
                                2.66953,
                                39.79237
                            ],
                            [
                                2.58698,
                                39.71759
                            ],
                            [
                                2.52762,
                                39.70104
                            ],
                            [
                                2.34486,
                                39.58795
                            ],
                            [
                                2.36765,
                                39.53706
                            ],
                            [
                                2.53938,
                                39.52261
                            ],
                            [
                                2.64151,
                                39.56787
                            ],
                            [
                                2.72032,
                                39.53439
                            ],
                            [
                                2.73963,
                                39.41106
                            ],
                            [
                                2.78767,
                                39.36346
                            ],
                            [
                                2.95876,
                                39.36181
                            ],
                            [
                                3.06967,
                                39.26766
                            ],
                            [
                                3.11904,
                                39.31221
                            ],
                            [
                                3.22946,
                                39.36021
                            ],
                            [
                                3.29642,
                                39.49905
                            ],
                            [
                                3.37416,
                                39.55885
                            ],
                            [
                                3.40363,
                                39.63541
                            ],
                            [
                                3.45567,
                                39.65747
                            ],
                            [
                                3.43424,
                                39.74468
                            ],
                            [
                                3.34717,
                                39.78818
                            ],
                            [
                                3.25249,
                                39.72985
                            ],
                            [
                                3.1449,
                                39.77385
                            ],
                            [
                                3.08636,
                                39.90858
                            ],
                            [
                                3.17671,
                                39.95323
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -16.12726,
                                28.5703
                            ],
                            [
                                -16.3324,
                                28.5717
                            ],
                            [
                                -16.52321,
                                28.4176
                            ],
                            [
                                -16.60298,
                                28.39431
                            ],
                            [
                                -16.67373,
                                28.4003
                            ],
                            [
                                -16.75123,
                                28.37163
                            ],
                            [
                                -16.8298,
                                28.39234
                            ],
                            [
                                -16.90565,
                                28.33791
                            ],
                            [
                                -16.83849,
                                28.25724
                            ],
                            [
                                -16.83579,
                                28.2075
                            ],
                            [
                                -16.73846,
                                28.08756
                            ],
                            [
                                -16.70724,
                                28.01051
                            ],
                            [
                                -16.64457,
                                28.00394
                            ],
                            [
                                -16.54094,
                                28.0418
                            ],
                            [
                                -16.42676,
                                28.15163
                            ],
                            [
                                -16.42406,
                                28.20531
                            ],
                            [
                                -16.36252,
                                28.30469
                            ],
                            [
                                -16.35995,
                                28.3786
                            ],
                            [
                                -16.24976,
                                28.45585
                            ],
                            [
                                -16.23504,
                                28.48583
                            ],
                            [
                                -16.12921,
                                28.53695
                            ],
                            [
                                -16.12726,
                                28.5703
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -13.87753,
                                28.75074
                            ],
                            [
                                -13.97792,
                                28.7332
                            ],
                            [
                                -14.10114,
                                28.47537
                            ],
                            [
                                -14.14588,
                                28.43852
                            ],
                            [
                                -14.20086,
                                28.33107
                            ],
                            [
                                -14.2156,
                                28.22807
                            ],
                            [
                                -14.31095,
                                28.14717
                            ],
                            [
                                -14.49349,
                                28.08538
                            ],
                            [
                                -14.33075,
                                28.04518
                            ],
                            [
                                -14.22141,
                                28.16296
                            ],
                            [
                                -14.01155,
                                28.20831
                            ],
                            [
                                -13.91504,
                                28.25779
                            ],
                            [
                                -13.85066,
                                28.42046
                            ],
                            [
                                -13.86725,
                                28.48069
                            ],
                            [
                                -13.82604,
                                28.55347
                            ],
                            [
                                -13.84326,
                                28.72598
                            ],
                            [
                                -13.87753,
                                28.75074
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -15.42884,
                                28.12927
                            ],
                            [
                                -15.52525,
                                28.15408
                            ],
                            [
                                -15.69709,
                                28.151
                            ],
                            [
                                -15.70924,
                                28.08671
                            ],
                            [
                                -15.81831,
                                28.00385
                            ],
                            [
                                -15.83356,
                                27.91209
                            ],
                            [
                                -15.78811,
                                27.8357
                            ],
                            [
                                -15.67307,
                                27.74974
                            ],
                            [
                                -15.6003,
                                27.73541
                            ],
                            [
                                -15.44169,
                                27.79997
                            ],
                            [
                                -15.38597,
                                27.85795
                            ],
                            [
                                -15.38255,
                                27.97277
                            ],
                            [
                                -15.42884,
                                28.12927
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -13.46423,
                                29.12811
                            ],
                            [
                                -13.41999,
                                29.20144
                            ],
                            [
                                -13.49622,
                                29.21815
                            ],
                            [
                                -13.54113,
                                29.1232
                            ],
                            [
                                -13.60422,
                                29.13519
                            ],
                            [
                                -13.70766,
                                29.08018
                            ],
                            [
                                -13.75223,
                                29.07881
                            ],
                            [
                                -13.82923,
                                29.00827
                            ],
                            [
                                -13.83013,
                                28.92887
                            ],
                            [
                                -13.87165,
                                28.8557
                            ],
                            [
                                -13.79186,
                                28.85152
                            ],
                            [
                                -13.73897,
                                28.90433
                            ],
                            [
                                -13.64298,
                                28.91982
                            ],
                            [
                                -13.47808,
                                29.0043
                            ],
                            [
                                -13.44844,
                                29.08952
                            ],
                            [
                                -13.46423,
                                29.12811
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                4.09361,
                                40.06178
                            ],
                            [
                                3.82214,
                                40.05018
                            ],
                            [
                                3.82036,
                                39.92802
                            ],
                            [
                                4.02072,
                                39.92179
                            ],
                            [
                                4.20709,
                                39.82582
                            ],
                            [
                                4.2726,
                                39.80931
                            ],
                            [
                                4.31256,
                                39.88165
                            ],
                            [
                                4.25713,
                                39.96461
                            ],
                            [
                                4.09361,
                                40.06178
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -17.90411,
                                28.84816
                            ],
                            [
                                -18.00303,
                                28.78611
                            ],
                            [
                                -17.96342,
                                28.66764
                            ],
                            [
                                -17.83379,
                                28.45776
                            ],
                            [
                                -17.75948,
                                28.57382
                            ],
                            [
                                -17.77028,
                                28.67604
                            ],
                            [
                                -17.7246,
                                28.74111
                            ],
                            [
                                -17.77803,
                                28.83872
                            ],
                            [
                                -17.90411,
                                28.84816
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                1.54109,
                                39.11581
                            ],
                            [
                                1.35926,
                                39.07417
                            ],
                            [
                                1.29207,
                                39.02876
                            ],
                            [
                                1.30673,
                                38.97756
                            ],
                            [
                                1.21605,
                                38.95823
                            ],
                            [
                                1.21411,
                                38.89885
                            ],
                            [
                                1.34393,
                                38.87011
                            ],
                            [
                                1.52639,
                                38.94606
                            ],
                            [
                                1.61845,
                                39.03323
                            ],
                            [
                                1.60213,
                                39.09076
                            ],
                            [
                                1.54109,
                                39.11581
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -17.25067,
                                28.20501
                            ],
                            [
                                -17.31725,
                                28.20433
                            ],
                            [
                                -17.34846,
                                28.09986
                            ],
                            [
                                -17.24547,
                                28.02046
                            ],
                            [
                                -17.16776,
                                28.04107
                            ],
                            [
                                -17.09959,
                                28.09495
                            ],
                            [
                                -17.11899,
                                28.15144
                            ],
                            [
                                -17.1958,
                                28.19867
                            ],
                            [
                                -17.25067,
                                28.20501
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -17.90513,
                                27.84169
                            ],
                            [
                                -17.95807,
                                27.84125
                            ],
                            [
                                -17.99612,
                                27.79261
                            ],
                            [
                                -18.06871,
                                27.75373
                            ],
                            [
                                -18.15097,
                                27.75971
                            ],
                            [
                                -18.15836,
                                27.7129
                            ],
                            [
                                -18.0509,
                                27.69271
                            ],
                            [
                                -17.9715,
                                27.64815
                            ],
                            [
                                -17.88385,
                                27.81221
                            ],
                            [
                                -17.90513,
                                27.84169
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                22.54204,
                                58.64155
                            ],
                            [
                                22.45383,
                                58.57763
                            ],
                            [
                                22.36152,
                                58.57656
                            ],
                            [
                                22.11876,
                                58.4818
                            ],
                            [
                                21.91831,
                                58.51603
                            ],
                            [
                                21.88002,
                                58.47371
                            ],
                            [
                                21.98762,
                                58.3971
                            ],
                            [
                                21.99842,
                                58.35178
                            ],
                            [
                                21.86381,
                                58.26369
                            ],
                            [
                                22.019,
                                58.23971
                            ],
                            [
                                22.06269,
                                58.17857
                            ],
                            [
                                22.21555,
                                58.15555
                            ],
                            [
                                22.16993,
                                58.06971
                            ],
                            [
                                22.07926,
                                58.07389
                            ],
                            [
                                21.98508,
                                57.95232
                            ],
                            [
                                22.05764,
                                57.91179
                            ],
                            [
                                22.18562,
                                58.00785
                            ],
                            [
                                22.26537,
                                58.13011
                            ],
                            [
                                22.26393,
                                58.18467
                            ],
                            [
                                22.45434,
                                58.23912
                            ],
                            [
                                22.73983,
                                58.23971
                            ],
                            [
                                22.92318,
                                58.30277
                            ],
                            [
                                23.17385,
                                58.45235
                            ],
                            [
                                23.30033,
                                58.47569
                            ],
                            [
                                22.94449,
                                58.6167
                            ],
                            [
                                22.80244,
                                58.62531
                            ],
                            [
                                22.75904,
                                58.58017
                            ],
                            [
                                22.62498,
                                58.5841
                            ],
                            [
                                22.54204,
                                58.64155
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                22.61014,
                                59.08346
                            ],
                            [
                                22.57876,
                                59.04004
                            ],
                            [
                                22.39093,
                                58.93632
                            ],
                            [
                                22.20413,
                                58.9343
                            ],
                            [
                                22.17589,
                                58.88235
                            ],
                            [
                                22.36503,
                                58.89702
                            ],
                            [
                                22.42981,
                                58.86749
                            ],
                            [
                                22.50127,
                                58.73191
                            ],
                            [
                                22.64016,
                                58.69285
                            ],
                            [
                                22.71617,
                                58.76326
                            ],
                            [
                                22.87817,
                                58.79456
                            ],
                            [
                                22.96459,
                                58.84804
                            ],
                            [
                                23.06741,
                                58.83827
                            ],
                            [
                                22.95307,
                                58.95622
                            ],
                            [
                                22.8618,
                                58.99674
                            ],
                            [
                                22.69558,
                                59.01739
                            ],
                            [
                                22.61014,
                                59.08346
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                23.21744,
                                58.67767
                            ],
                            [
                                23.15231,
                                58.67884
                            ],
                            [
                                23.15312,
                                58.5771
                            ],
                            [
                                23.22057,
                                58.52613
                            ],
                            [
                                23.40493,
                                58.55075
                            ],
                            [
                                23.34552,
                                58.64754
                            ],
                            [
                                23.21744,
                                58.67767
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                23.20458,
                                59.03978
                            ],
                            [
                                23.16805,
                                58.98101
                            ],
                            [
                                23.29105,
                                58.97202
                            ],
                            [
                                23.33352,
                                59.03202
                            ],
                            [
                                23.20458,
                                59.03978
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                15.56231,
                                38.21138
                            ],
                            [
                                15.60562,
                                38.27575
                            ],
                            [
                                15.51642,
                                38.2952
                            ],
                            [
                                15.35683,
                                38.21856
                            ],
                            [
                                15.22584,
                                38.20657
                            ],
                            [
                                15.17076,
                                38.1516
                            ],
                            [
                                15.08741,
                                38.12015
                            ],
                            [
                                15.04445,
                                38.15169
                            ],
                            [
                                14.89072,
                                38.17246
                            ],
                            [
                                14.74766,
                                38.16524
                            ],
                            [
                                14.63108,
                                38.07084
                            ],
                            [
                                14.47497,
                                38.0334
                            ],
                            [
                                14.31099,
                                38.0082
                            ],
                            [
                                13.95001,
                                38.03063
                            ],
                            [
                                13.85728,
                                37.98968
                            ],
                            [
                                13.74536,
                                37.97049
                            ],
                            [
                                13.66411,
                                37.99456
                            ],
                            [
                                13.54109,
                                38.05827
                            ],
                            [
                                13.53271,
                                38.11088
                            ],
                            [
                                13.3855,
                                38.10821
                            ],
                            [
                                13.35861,
                                38.19101
                            ],
                            [
                                13.31594,
                                38.22349
                            ],
                            [
                                13.19081,
                                38.16943
                            ],
                            [
                                13.10583,
                                38.19032
                            ],
                            [
                                13.05327,
                                38.13793
                            ],
                            [
                                13.07794,
                                38.09062
                            ],
                            [
                                12.97726,
                                38.04021
                            ],
                            [
                                12.89312,
                                38.02465
                            ],
                            [
                                12.7905,
                                38.1104
                            ],
                            [
                                12.71111,
                                38.10961
                            ],
                            [
                                12.57596,
                                38.07021
                            ],
                            [
                                12.50765,
                                38.00971
                            ],
                            [
                                12.4593,
                                37.90751
                            ],
                            [
                                12.47197,
                                37.70349
                            ],
                            [
                                12.56828,
                                37.65991
                            ],
                            [
                                12.67885,
                                37.55959
                            ],
                            [
                                12.85626,
                                37.58265
                            ],
                            [
                                12.96147,
                                37.56354
                            ],
                            [
                                13.01957,
                                37.49626
                            ],
                            [
                                13.15374,
                                37.49673
                            ],
                            [
                                13.21781,
                                37.45862
                            ],
                            [
                                13.27359,
                                37.38921
                            ],
                            [
                                13.48116,
                                37.28631
                            ],
                            [
                                13.55073,
                                37.28695
                            ],
                            [
                                13.66326,
                                37.1935
                            ],
                            [
                                13.75147,
                                37.14967
                            ],
                            [
                                13.81721,
                                37.14542
                            ],
                            [
                                13.90481,
                                37.09576
                            ],
                            [
                                14.07219,
                                37.1102
                            ],
                            [
                                14.17027,
                                37.09109
                            ],
                            [
                                14.29826,
                                37.03511
                            ],
                            [
                                14.36076,
                                36.98067
                            ],
                            [
                                14.49409,
                                36.78704
                            ],
                            [
                                14.62911,
                                36.76485
                            ],
                            [
                                14.70423,
                                36.71725
                            ],
                            [
                                14.783,
                                36.70368
                            ],
                            [
                                14.89401,
                                36.72935
                            ],
                            [
                                14.95585,
                                36.69501
                            ],
                            [
                                15.01755,
                                36.70205
                            ],
                            [
                                15.08216,
                                36.64958
                            ],
                            [
                                15.13832,
                                36.68258
                            ],
                            [
                                15.09492,
                                36.77874
                            ],
                            [
                                15.1533,
                                36.9139
                            ],
                            [
                                15.31423,
                                37.03705
                            ],
                            [
                                15.30112,
                                37.0815
                            ],
                            [
                                15.22071,
                                37.12938
                            ],
                            [
                                15.18211,
                                37.21133
                            ],
                            [
                                15.24049,
                                37.26003
                            ],
                            [
                                15.10408,
                                37.31175
                            ],
                            [
                                15.09139,
                                37.49937
                            ],
                            [
                                15.17692,
                                37.57836
                            ],
                            [
                                15.20473,
                                37.73737
                            ],
                            [
                                15.30431,
                                37.87567
                            ],
                            [
                                15.49381,
                                38.0751
                            ],
                            [
                                15.57127,
                                38.18932
                            ],
                            [
                                15.56231,
                                38.21138
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.23908,
                                41.24668
                            ],
                            [
                                9.16476,
                                41.23543
                            ],
                            [
                                9.17133,
                                41.17691
                            ],
                            [
                                9.10808,
                                41.13415
                            ],
                            [
                                9.00693,
                                41.11932
                            ],
                            [
                                8.789,
                                40.92164
                            ],
                            [
                                8.71157,
                                40.91769
                            ],
                            [
                                8.55982,
                                40.8312
                            ],
                            [
                                8.4589,
                                40.8195
                            ],
                            [
                                8.31334,
                                40.84494
                            ],
                            [
                                8.23456,
                                40.90823
                            ],
                            [
                                8.13764,
                                40.72865
                            ],
                            [
                                8.20309,
                                40.68791
                            ],
                            [
                                8.21854,
                                40.60182
                            ],
                            [
                                8.29473,
                                40.59279
                            ],
                            [
                                8.37397,
                                40.49038
                            ],
                            [
                                8.39979,
                                40.40004
                            ],
                            [
                                8.37915,
                                40.35958
                            ],
                            [
                                8.48295,
                                40.28462
                            ],
                            [
                                8.45924,
                                40.15385
                            ],
                            [
                                8.49223,
                                40.08744
                            ],
                            [
                                8.41846,
                                40.04253
                            ],
                            [
                                8.39846,
                                39.9094
                            ],
                            [
                                8.50469,
                                39.90755
                            ],
                            [
                                8.55405,
                                39.86008
                            ],
                            [
                                8.54454,
                                39.79327
                            ],
                            [
                                8.49645,
                                39.72177
                            ],
                            [
                                8.47001,
                                39.59959
                            ],
                            [
                                8.38338,
                                39.45671
                            ],
                            [
                                8.38007,
                                39.38321
                            ],
                            [
                                8.43646,
                                39.29078
                            ],
                            [
                                8.36799,
                                39.22866
                            ],
                            [
                                8.49721,
                                39.06285
                            ],
                            [
                                8.56689,
                                39.0437
                            ],
                            [
                                8.56623,
                                38.99706
                            ],
                            [
                                8.66855,
                                38.89708
                            ],
                            [
                                8.72278,
                                38.93619
                            ],
                            [
                                8.85673,
                                38.87739
                            ],
                            [
                                9.0109,
                                38.98744
                            ],
                            [
                                9.04524,
                                39.05682
                            ],
                            [
                                9.00883,
                                39.1213
                            ],
                            [
                                9.0603,
                                39.19256
                            ],
                            [
                                9.14481,
                                39.18443
                            ],
                            [
                                9.22558,
                                39.22782
                            ],
                            [
                                9.32105,
                                39.20401
                            ],
                            [
                                9.43781,
                                39.12288
                            ],
                            [
                                9.56873,
                                39.15316
                            ],
                            [
                                9.57024,
                                39.23844
                            ],
                            [
                                9.60054,
                                39.28892
                            ],
                            [
                                9.60254,
                                39.37363
                            ],
                            [
                                9.6456,
                                39.46285
                            ],
                            [
                                9.64908,
                                39.65832
                            ],
                            [
                                9.67657,
                                39.71184
                            ],
                            [
                                9.6868,
                                39.94893
                            ],
                            [
                                9.73442,
                                40.07551
                            ],
                            [
                                9.65401,
                                40.14367
                            ],
                            [
                                9.6233,
                                40.24809
                            ],
                            [
                                9.66537,
                                40.31913
                            ],
                            [
                                9.75462,
                                40.38196
                            ],
                            [
                                9.82777,
                                40.52881
                            ],
                            [
                                9.75308,
                                40.59921
                            ],
                            [
                                9.75255,
                                40.67355
                            ],
                            [
                                9.6703,
                                40.79258
                            ],
                            [
                                9.6858,
                                40.858
                            ],
                            [
                                9.56114,
                                40.91858
                            ],
                            [
                                9.61047,
                                41.00261
                            ],
                            [
                                9.52967,
                                41.02827
                            ],
                            [
                                9.56357,
                                41.11738
                            ],
                            [
                                9.52833,
                                41.14583
                            ],
                            [
                                9.43094,
                                41.14376
                            ],
                            [
                                9.41849,
                                41.17852
                            ],
                            [
                                9.29911,
                                41.19134
                            ],
                            [
                                9.23908,
                                41.24668
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                10.43665,
                                42.79972
                            ],
                            [
                                10.28666,
                                42.82317
                            ],
                            [
                                10.24311,
                                42.78797
                            ],
                            [
                                10.13812,
                                42.80771
                            ],
                            [
                                10.13643,
                                42.73315
                            ],
                            [
                                10.33831,
                                42.76387
                            ],
                            [
                                10.43665,
                                42.79972
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.37849,
                                39.10163
                            ],
                            [
                                8.35026,
                                39.07962
                            ],
                            [
                                8.40503,
                                38.96131
                            ],
                            [
                                8.47078,
                                39.0581
                            ],
                            [
                                8.37849,
                                39.10163
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                11.99183,
                                36.82218
                            ],
                            [
                                11.92854,
                                36.80169
                            ],
                            [
                                11.99324,
                                36.73792
                            ],
                            [
                                12.04999,
                                36.7989
                            ],
                            [
                                11.99183,
                                36.82218
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.30933,
                                39.18765
                            ],
                            [
                                8.226,
                                39.16157
                            ],
                            [
                                8.24761,
                                39.10858
                            ],
                            [
                                8.31016,
                                39.11329
                            ],
                            [
                                8.30933,
                                39.18765
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                22.15531,
                                48.4034
                            ],
                            [
                                22.16099,
                                48.56725
                            ],
                            [
                                22.18958,
                                48.60933
                            ],
                            [
                                22.34082,
                                48.68707
                            ],
                            [
                                22.34594,
                                48.7659
                            ],
                            [
                                22.42826,
                                48.93181
                            ],
                            [
                                22.47959,
                                48.99268
                            ],
                            [
                                22.54477,
                                49.00827
                            ],
                            [
                                22.56684,
                                49.08838
                            ],
                            [
                                22.6825,
                                49.03891
                            ],
                            [
                                22.86811,
                                49.07683
                            ],
                            [
                                22.74112,
                                49.21846
                            ],
                            [
                                22.7443,
                                49.36916
                            ],
                            [
                                22.70006,
                                49.48885
                            ],
                            [
                                22.64151,
                                49.52921
                            ],
                            [
                                23.03327,
                                49.88133
                            ],
                            [
                                23.27859,
                                50.08627
                            ],
                            [
                                23.47043,
                                50.21778
                            ],
                            [
                                23.58121,
                                50.26647
                            ],
                            [
                                23.70343,
                                50.37534
                            ],
                            [
                                23.80338,
                                50.40476
                            ],
                            [
                                23.99708,
                                50.41266
                            ],
                            [
                                24.0911,
                                50.56212
                            ],
                            [
                                24.07433,
                                50.71013
                            ],
                            [
                                24.01872,
                                50.72431
                            ],
                            [
                                23.95854,
                                50.79404
                            ],
                            [
                                24.02177,
                                50.84121
                            ],
                            [
                                24.13209,
                                50.8493
                            ],
                            [
                                23.97014,
                                50.95167
                            ],
                            [
                                23.87287,
                                51.0836
                            ],
                            [
                                23.86184,
                                51.15662
                            ],
                            [
                                23.74287,
                                51.21396
                            ],
                            [
                                23.63788,
                                51.33039
                            ],
                            [
                                23.70018,
                                51.4034
                            ],
                            [
                                23.61744,
                                51.50954
                            ],
                            [
                                23.54133,
                                51.60191
                            ],
                            [
                                23.55969,
                                51.76105
                            ],
                            [
                                23.63036,
                                51.78054
                            ],
                            [
                                23.6076,
                                51.87584
                            ],
                            [
                                23.68858,
                                51.99107
                            ],
                            [
                                23.59605,
                                52.1174
                            ],
                            [
                                23.39317,
                                52.20025
                            ],
                            [
                                23.20421,
                                52.22664
                            ],
                            [
                                23.21635,
                                52.33047
                            ],
                            [
                                23.35672,
                                52.46889
                            ],
                            [
                                23.46692,
                                52.54914
                            ],
                            [
                                23.64273,
                                52.60755
                            ],
                            [
                                23.76604,
                                52.61834
                            ],
                            [
                                23.93835,
                                52.71346
                            ],
                            [
                                23.91688,
                                52.93862
                            ],
                            [
                                23.9255,
                                53.02348
                            ],
                            [
                                23.87233,
                                53.0834
                            ],
                            [
                                23.91491,
                                53.14282
                            ],
                            [
                                23.818,
                                53.24527
                            ],
                            [
                                23.65965,
                                53.52176
                            ],
                            [
                                23.54901,
                                53.76883
                            ],
                            [
                                23.51465,
                                53.95656
                            ],
                            [
                                23.60653,
                                53.92252
                            ],
                            [
                                23.88555,
                                53.94364
                            ],
                            [
                                23.98501,
                                53.92428
                            ],
                            [
                                24.20162,
                                53.96995
                            ],
                            [
                                24.35333,
                                53.89702
                            ],
                            [
                                24.43173,
                                53.90437
                            ],
                            [
                                24.61674,
                                54.007
                            ],
                            [
                                24.84211,
                                54.03393
                            ],
                            [
                                24.7786,
                                54.10078
                            ],
                            [
                                24.95661,
                                54.17152
                            ],
                            [
                                25.06863,
                                54.13416
                            ],
                            [
                                25.2039,
                                54.2242
                            ],
                            [
                                25.21591,
                                54.25615
                            ],
                            [
                                25.35364,
                                54.26421
                            ],
                            [
                                25.51053,
                                54.30836
                            ],
                            [
                                25.57024,
                                54.24665
                            ],
                            [
                                25.54822,
                                54.15274
                            ],
                            [
                                25.6849,
                                54.14147
                            ],
                            [
                                25.78115,
                                54.15994
                            ],
                            [
                                25.78423,
                                54.23326
                            ],
                            [
                                25.67753,
                                54.32343
                            ],
                            [
                                25.55516,
                                54.31552
                            ],
                            [
                                25.63143,
                                54.42085
                            ],
                            [
                                25.61807,
                                54.45872
                            ],
                            [
                                25.67955,
                                54.53378
                            ],
                            [
                                25.7616,
                                54.5771
                            ],
                            [
                                25.73117,
                                54.6825
                            ],
                            [
                                25.73429,
                                54.80214
                            ],
                            [
                                25.85966,
                                54.92769
                            ],
                            [
                                26.07929,
                                54.95484
                            ],
                            [
                                26.20797,
                                54.99768
                            ],
                            [
                                26.35955,
                                55.15016
                            ],
                            [
                                26.46216,
                                55.1292
                            ],
                            [
                                26.61831,
                                55.14709
                            ],
                            [
                                26.68648,
                                55.17865
                            ],
                            [
                                26.79072,
                                55.32044
                            ],
                            [
                                26.4526,
                                55.34062
                            ],
                            [
                                26.55139,
                                55.38961
                            ],
                            [
                                26.52676,
                                55.51294
                            ],
                            [
                                26.62074,
                                55.56534
                            ],
                            [
                                26.63037,
                                55.68067
                            ],
                            [
                                26.65324,
                                55.70727
                            ],
                            [
                                26.8691,
                                55.71244
                            ],
                            [
                                26.92003,
                                55.78688
                            ],
                            [
                                27.01483,
                                55.82828
                            ],
                            [
                                27.15405,
                                55.85163
                            ],
                            [
                                27.28512,
                                55.78581
                            ],
                            [
                                27.3567,
                                55.81172
                            ],
                            [
                                27.6136,
                                55.78676
                            ],
                            [
                                27.65309,
                                55.92959
                            ],
                            [
                                27.78534,
                                55.97625
                            ],
                            [
                                27.99238,
                                56.12553
                            ],
                            [
                                28.15456,
                                56.16984
                            ],
                            [
                                28.24058,
                                56.27606
                            ],
                            [
                                28.16383,
                                56.37865
                            ],
                            [
                                28.19356,
                                56.44074
                            ],
                            [
                                28.10014,
                                56.50971
                            ],
                            [
                                28.12591,
                                56.58215
                            ],
                            [
                                28.0429,
                                56.59097
                            ],
                            [
                                28.01224,
                                56.67242
                            ],
                            [
                                27.89947,
                                56.75271
                            ],
                            [
                                27.8719,
                                56.86661
                            ],
                            [
                                27.65944,
                                56.83437
                            ],
                            [
                                27.73776,
                                56.92159
                            ],
                            [
                                27.76808,
                                57.00292
                            ],
                            [
                                27.75794,
                                57.13075
                            ],
                            [
                                27.81777,
                                57.1434
                            ],
                            [
                                27.86722,
                                57.29686
                            ],
                            [
                                27.78326,
                                57.32124
                            ],
                            [
                                27.6709,
                                57.3948
                            ],
                            [
                                27.51821,
                                57.42741
                            ],
                            [
                                27.56647,
                                57.51375
                            ],
                            [
                                27.5041,
                                57.54
                            ],
                            [
                                27.35158,
                                57.51824
                            ],
                            [
                                27.32008,
                                57.57898
                            ],
                            [
                                27.4042,
                                57.61284
                            ],
                            [
                                27.37785,
                                57.67202
                            ],
                            [
                                27.56487,
                                57.83146
                            ],
                            [
                                27.77569,
                                57.83436
                            ],
                            [
                                27.81772,
                                57.89052
                            ],
                            [
                                27.68118,
                                57.92423
                            ],
                            [
                                27.62105,
                                58.00511
                            ],
                            [
                                27.63412,
                                58.0973
                            ],
                            [
                                27.49075,
                                58.22512
                            ],
                            [
                                27.55321,
                                58.36598
                            ],
                            [
                                27.35705,
                                58.78714
                            ],
                            [
                                27.72762,
                                58.97157
                            ],
                            [
                                27.80822,
                                59.12874
                            ],
                            [
                                27.957,
                                59.27157
                            ],
                            [
                                28.12187,
                                59.28979
                            ],
                            [
                                28.20959,
                                59.37058
                            ],
                            [
                                28.04192,
                                59.47012
                            ],
                            [
                                27.91546,
                                59.40214
                            ],
                            [
                                27.59417,
                                59.41456
                            ],
                            [
                                27.37599,
                                59.44645
                            ],
                            [
                                26.93598,
                                59.43862
                            ],
                            [
                                26.61448,
                                59.55115
                            ],
                            [
                                26.49205,
                                59.51743
                            ],
                            [
                                26.26638,
                                59.58546
                            ],
                            [
                                26.10431,
                                59.58611
                            ],
                            [
                                26.0501,
                                59.61768
                            ],
                            [
                                25.93749,
                                59.57834
                            ],
                            [
                                25.78179,
                                59.58943
                            ],
                            [
                                25.55307,
                                59.54638
                            ],
                            [
                                25.42444,
                                59.49019
                            ],
                            [
                                25.27345,
                                59.5115
                            ],
                            [
                                25.1497,
                                59.47699
                            ],
                            [
                                25.07801,
                                59.50234
                            ],
                            [
                                24.93094,
                                59.49566
                            ],
                            [
                                24.79051,
                                59.44402
                            ],
                            [
                                24.65394,
                                59.43048
                            ],
                            [
                                24.36354,
                                59.47147
                            ],
                            [
                                24.33847,
                                59.42413
                            ],
                            [
                                24.22348,
                                59.39376
                            ],
                            [
                                24.20394,
                                59.34095
                            ],
                            [
                                23.94767,
                                59.27076
                            ],
                            [
                                23.7864,
                                59.28364
                            ],
                            [
                                23.49137,
                                59.20782
                            ],
                            [
                                23.54054,
                                59.09249
                            ],
                            [
                                23.43539,
                                59.07608
                            ],
                            [
                                23.45757,
                                58.98284
                            ],
                            [
                                23.42502,
                                58.9062
                            ],
                            [
                                23.52661,
                                58.83
                            ],
                            [
                                23.46064,
                                58.77861
                            ],
                            [
                                23.65746,
                                58.74452
                            ],
                            [
                                23.49596,
                                58.68817
                            ],
                            [
                                23.56802,
                                58.56399
                            ],
                            [
                                23.69152,
                                58.50385
                            ],
                            [
                                23.67965,
                                58.44334
                            ],
                            [
                                23.74406,
                                58.36045
                            ],
                            [
                                23.87609,
                                58.32445
                            ],
                            [
                                24.01115,
                                58.31872
                            ],
                            [
                                24.12172,
                                58.24073
                            ],
                            [
                                24.26776,
                                58.2786
                            ],
                            [
                                24.29294,
                                58.36514
                            ],
                            [
                                24.45127,
                                58.38495
                            ],
                            [
                                24.54671,
                                58.35707
                            ],
                            [
                                24.58692,
                                58.30461
                            ],
                            [
                                24.48932,
                                58.25728
                            ],
                            [
                                24.45725,
                                58.20228
                            ],
                            [
                                24.48039,
                                58.07674
                            ],
                            [
                                24.35282,
                                57.87656
                            ],
                            [
                                24.34332,
                                57.70116
                            ],
                            [
                                24.38624,
                                57.61503
                            ],
                            [
                                24.36359,
                                57.57819
                            ],
                            [
                                24.41066,
                                57.26745
                            ],
                            [
                                24.33949,
                                57.19579
                            ],
                            [
                                24.16081,
                                57.10163
                            ],
                            [
                                23.97581,
                                57.02548
                            ],
                            [
                                23.75286,
                                56.96967
                            ],
                            [
                                23.62539,
                                56.96445
                            ],
                            [
                                23.49373,
                                57.031
                            ],
                            [
                                23.30491,
                                57.0642
                            ],
                            [
                                23.23752,
                                57.10921
                            ],
                            [
                                23.13223,
                                57.35933
                            ],
                            [
                                22.94604,
                                57.41421
                            ],
                            [
                                22.8459,
                                57.49195
                            ],
                            [
                                22.66009,
                                57.5695
                            ],
                            [
                                22.60596,
                                57.61281
                            ],
                            [
                                22.51879,
                                57.74616
                            ],
                            [
                                22.04943,
                                57.61577
                            ],
                            [
                                21.72236,
                                57.57639
                            ],
                            [
                                21.59386,
                                57.43101
                            ],
                            [
                                21.41178,
                                57.2683
                            ],
                            [
                                21.40927,
                                57.05
                            ],
                            [
                                21.35343,
                                56.98504
                            ],
                            [
                                21.05237,
                                56.82376
                            ],
                            [
                                21.05805,
                                56.70331
                            ],
                            [
                                20.98527,
                                56.51768
                            ],
                            [
                                20.97291,
                                56.37312
                            ],
                            [
                                20.98517,
                                56.2121
                            ],
                            [
                                21.06424,
                                56.06914
                            ],
                            [
                                21.04903,
                                55.91872
                            ],
                            [
                                21.08337,
                                55.72991
                            ],
                            [
                                21.25119,
                                55.46631
                            ],
                            [
                                21.23252,
                                55.35018
                            ],
                            [
                                21.29662,
                                55.29765
                            ],
                            [
                                21.27351,
                                55.24565
                            ],
                            [
                                21.38282,
                                55.29441
                            ],
                            [
                                21.50239,
                                55.18677
                            ],
                            [
                                21.65107,
                                55.17998
                            ],
                            [
                                21.72084,
                                55.13396
                            ],
                            [
                                22.03126,
                                55.05391
                            ],
                            [
                                22.29129,
                                55.06474
                            ],
                            [
                                22.46304,
                                55.04444
                            ],
                            [
                                22.58897,
                                55.07025
                            ],
                            [
                                22.64298,
                                54.98319
                            ],
                            [
                                22.85403,
                                54.88754
                            ],
                            [
                                22.87254,
                                54.79743
                            ],
                            [
                                22.77536,
                                54.75105
                            ],
                            [
                                22.72449,
                                54.68594
                            ],
                            [
                                22.75638,
                                54.65324
                            ],
                            [
                                22.68519,
                                54.58916
                            ],
                            [
                                22.70276,
                                54.45354
                            ],
                            [
                                22.7921,
                                54.36336
                            ],
                            [
                                22.31591,
                                54.34062
                            ],
                            [
                                21.49542,
                                54.32384
                            ],
                            [
                                21.27454,
                                54.32862
                            ],
                            [
                                21.00608,
                                54.35357
                            ],
                            [
                                20.51337,
                                54.38099
                            ],
                            [
                                19.80377,
                                54.44241
                            ],
                            [
                                19.75426,
                                54.43288
                            ],
                            [
                                19.64577,
                                54.34523
                            ],
                            [
                                19.50226,
                                54.32159
                            ],
                            [
                                19.39936,
                                54.26243
                            ],
                            [
                                19.27769,
                                54.27777
                            ],
                            [
                                19.24795,
                                54.32867
                            ],
                            [
                                19.5925,
                                54.42463
                            ],
                            [
                                19.64852,
                                54.45334
                            ],
                            [
                                19.63903,
                                54.45829
                            ],
                            [
                                19.38366,
                                54.37541
                            ],
                            [
                                19.22746,
                                54.35461
                            ],
                            [
                                18.88064,
                                54.34811
                            ],
                            [
                                18.73729,
                                54.37453
                            ],
                            [
                                18.59116,
                                54.43019
                            ],
                            [
                                18.54173,
                                54.58448
                            ],
                            [
                                18.47885,
                                54.63056
                            ],
                            [
                                18.47215,
                                54.69439
                            ],
                            [
                                18.39414,
                                54.73074
                            ],
                            [
                                18.42423,
                                54.78808
                            ],
                            [
                                18.32803,
                                54.8346
                            ],
                            [
                                17.96782,
                                54.83083
                            ],
                            [
                                17.61322,
                                54.77445
                            ],
                            [
                                17.25398,
                                54.73236
                            ],
                            [
                                17.0463,
                                54.66778
                            ],
                            [
                                16.95094,
                                54.61215
                            ],
                            [
                                16.76295,
                                54.5696
                            ],
                            [
                                16.52969,
                                54.54042
                            ],
                            [
                                16.43186,
                                54.48719
                            ],
                            [
                                16.31437,
                                54.38392
                            ],
                            [
                                16.09074,
                                54.27145
                            ],
                            [
                                15.85815,
                                54.24244
                            ],
                            [
                                15.48547,
                                54.16645
                            ],
                            [
                                15.28646,
                                54.14696
                            ],
                            [
                                14.50031,
                                53.96365
                            ],
                            [
                                14.34216,
                                53.87347
                            ],
                            [
                                14.54343,
                                53.85808
                            ],
                            [
                                14.60712,
                                53.82043
                            ],
                            [
                                14.5065,
                                53.66628
                            ],
                            [
                                14.34792,
                                53.71137
                            ],
                            [
                                14.26754,
                                53.69781
                            ],
                            [
                                14.27124,
                                53.73886
                            ],
                            [
                                14.12522,
                                53.73743
                            ],
                            [
                                13.97286,
                                53.77259
                            ],
                            [
                                13.81915,
                                53.84194
                            ],
                            [
                                13.90853,
                                53.92994
                            ],
                            [
                                13.76097,
                                54.01577
                            ],
                            [
                                13.80462,
                                54.10311
                            ],
                            [
                                13.70163,
                                54.14892
                            ],
                            [
                                13.47814,
                                54.11917
                            ],
                            [
                                13.34925,
                                54.16725
                            ],
                            [
                                13.2903,
                                54.23353
                            ],
                            [
                                13.1337,
                                54.26902
                            ],
                            [
                                12.99995,
                                54.43591
                            ],
                            [
                                12.88366,
                                54.37083
                            ],
                            [
                                12.72548,
                                54.37257
                            ],
                            [
                                12.70738,
                                54.41028
                            ],
                            [
                                12.40843,
                                54.27775
                            ],
                            [
                                12.43614,
                                54.37909
                            ],
                            [
                                12.52373,
                                54.37871
                            ],
                            [
                                12.64033,
                                54.42438
                            ],
                            [
                                12.8012,
                                54.40984
                            ],
                            [
                                12.81763,
                                54.44015
                            ],
                            [
                                12.55853,
                                54.45514
                            ],
                            [
                                12.46728,
                                54.42154
                            ],
                            [
                                12.31149,
                                54.28433
                            ],
                            [
                                12.22115,
                                54.2535
                            ],
                            [
                                12.13083,
                                54.1885
                            ],
                            [
                                11.83566,
                                54.14455
                            ],
                            [
                                11.68173,
                                54.15252
                            ],
                            [
                                11.56178,
                                54.02809
                            ],
                            [
                                11.5079,
                                54.01035
                            ],
                            [
                                11.44559,
                                53.91178
                            ],
                            [
                                11.3382,
                                53.9571
                            ],
                            [
                                11.28652,
                                53.93128
                            ],
                            [
                                11.18109,
                                54.0147
                            ],
                            [
                                11.0271,
                                54.00283
                            ],
                            [
                                10.93405,
                                53.96525
                            ],
                            [
                                10.79973,
                                53.9927
                            ],
                            [
                                10.75178,
                                54.03759
                            ],
                            [
                                10.7998,
                                54.08415
                            ],
                            [
                                10.88535,
                                54.09164
                            ],
                            [
                                11.09339,
                                54.19974
                            ],
                            [
                                11.07198,
                                54.33735
                            ],
                            [
                                10.93143,
                                54.38173
                            ],
                            [
                                10.76976,
                                54.3076
                            ],
                            [
                                10.32884,
                                54.43572
                            ],
                            [
                                10.22829,
                                54.41381
                            ],
                            [
                                10.12547,
                                54.48508
                            ],
                            [
                                9.86422,
                                54.44852
                            ],
                            [
                                10.02698,
                                54.554
                            ],
                            [
                                10.0337,
                                54.65706
                            ],
                            [
                                9.95688,
                                54.77948
                            ],
                            [
                                9.87366,
                                54.75218
                            ],
                            [
                                9.79257,
                                54.79698
                            ],
                            [
                                9.59091,
                                54.84417
                            ],
                            [
                                9.42015,
                                54.83196
                            ],
                            [
                                9.60661,
                                54.91059
                            ],
                            [
                                9.63879,
                                54.86095
                            ],
                            [
                                9.88787,
                                54.90665
                            ],
                            [
                                10.01272,
                                54.86902
                            ],
                            [
                                10.04458,
                                54.93106
                            ],
                            [
                                9.96541,
                                55.00576
                            ],
                            [
                                9.75921,
                                55.08304
                            ],
                            [
                                9.60678,
                                55.03559
                            ],
                            [
                                9.50197,
                                55.15775
                            ],
                            [
                                9.59002,
                                55.19281
                            ],
                            [
                                9.69286,
                                55.19657
                            ],
                            [
                                9.59657,
                                55.42437
                            ],
                            [
                                9.69339,
                                55.46047
                            ],
                            [
                                9.79604,
                                55.59436
                            ],
                            [
                                9.73806,
                                55.65807
                            ],
                            [
                                10.00999,
                                55.70055
                            ],
                            [
                                10.06186,
                                55.81002
                            ],
                            [
                                9.8918,
                                55.84299
                            ],
                            [
                                10.0731,
                                55.88413
                            ],
                            [
                                10.16348,
                                55.84503
                            ],
                            [
                                10.25834,
                                55.91217
                            ],
                            [
                                10.27162,
                                56.04643
                            ],
                            [
                                10.21842,
                                56.15835
                            ],
                            [
                                10.44624,
                                56.29147
                            ],
                            [
                                10.50468,
                                56.27461
                            ],
                            [
                                10.44499,
                                56.18099
                            ],
                            [
                                10.71501,
                                56.14314
                            ],
                            [
                                10.74187,
                                56.22331
                            ],
                            [
                                10.91479,
                                56.34445
                            ],
                            [
                                10.95955,
                                56.44173
                            ],
                            [
                                10.79629,
                                56.53786
                            ],
                            [
                                10.49654,
                                56.51423
                            ],
                            [
                                10.40557,
                                56.53292
                            ],
                            [
                                10.30308,
                                56.61078
                            ],
                            [
                                10.35304,
                                56.69144
                            ],
                            [
                                10.27738,
                                56.80096
                            ],
                            [
                                10.26303,
                                56.90023
                            ],
                            [
                                10.30565,
                                56.98235
                            ],
                            [
                                10.19134,
                                56.98732
                            ],
                            [
                                9.99916,
                                57.07839
                            ],
                            [
                                9.94242,
                                57.04855
                            ],
                            [
                                9.69656,
                                57.04059
                            ],
                            [
                                9.61895,
                                56.96962
                            ],
                            [
                                9.50136,
                                57.01472
                            ],
                            [
                                9.29583,
                                56.99846
                            ],
                            [
                                9.17992,
                                56.91883
                            ],
                            [
                                9.21024,
                                56.86312
                            ],
                            [
                                9.16868,
                                56.80721
                            ],
                            [
                                9.22249,
                                56.7166
                            ],
                            [
                                9.32512,
                                56.65933
                            ],
                            [
                                9.04566,
                                56.58488
                            ],
                            [
                                9.09624,
                                56.66559
                            ],
                            [
                                9.1781,
                                56.70742
                            ],
                            [
                                9.06563,
                                56.80262
                            ],
                            [
                                8.96396,
                                56.80181
                            ],
                            [
                                8.85383,
                                56.74333
                            ],
                            [
                                8.70303,
                                56.58487
                            ],
                            [
                                8.76303,
                                56.55247
                            ],
                            [
                                8.73246,
                                56.47877
                            ],
                            [
                                8.61473,
                                56.48067
                            ],
                            [
                                8.57634,
                                56.54362
                            ],
                            [
                                8.38454,
                                56.57851
                            ],
                            [
                                8.28635,
                                56.57636
                            ],
                            [
                                8.16687,
                                56.65638
                            ],
                            [
                                8.12474,
                                56.56349
                            ],
                            [
                                8.11591,
                                56.37937
                            ],
                            [
                                8.12996,
                                56.22888
                            ],
                            [
                                8.16767,
                                56.10574
                            ],
                            [
                                8.30045,
                                56.06022
                            ],
                            [
                                8.37416,
                                55.94874
                            ],
                            [
                                8.31281,
                                55.8647
                            ],
                            [
                                8.16847,
                                55.90636
                            ],
                            [
                                8.16367,
                                55.71822
                            ],
                            [
                                8.077,
                                55.55731
                            ],
                            [
                                8.17887,
                                55.53086
                            ],
                            [
                                8.29598,
                                55.5637
                            ],
                            [
                                8.46744,
                                55.45089
                            ],
                            [
                                8.62015,
                                55.42868
                            ],
                            [
                                8.67128,
                                55.33231
                            ],
                            [
                                8.65826,
                                55.23329
                            ],
                            [
                                8.56213,
                                55.15008
                            ],
                            [
                                8.68453,
                                55.14444
                            ],
                            [
                                8.63405,
                                55.03153
                            ],
                            [
                                8.63593,
                                54.91168
                            ],
                            [
                                8.60818,
                                54.84122
                            ],
                            [
                                8.70045,
                                54.77509
                            ],
                            [
                                8.75409,
                                54.68193
                            ],
                            [
                                8.89222,
                                54.59801
                            ],
                            [
                                8.87167,
                                54.52901
                            ],
                            [
                                8.98318,
                                54.52468
                            ],
                            [
                                9.01453,
                                54.47407
                            ],
                            [
                                8.91217,
                                54.41664
                            ],
                            [
                                8.67313,
                                54.39951
                            ],
                            [
                                8.69078,
                                54.35497
                            ],
                            [
                                8.60238,
                                54.3145
                            ],
                            [
                                8.67367,
                                54.27909
                            ],
                            [
                                8.84214,
                                54.27747
                            ],
                            [
                                8.80777,
                                54.17518
                            ],
                            [
                                8.92504,
                                54.13228
                            ],
                            [
                                8.98523,
                                54.05892
                            ],
                            [
                                8.84922,
                                54.03863
                            ],
                            [
                                8.68717,
                                53.89191
                            ],
                            [
                                8.61382,
                                53.88139
                            ],
                            [
                                8.54215,
                                53.80729
                            ],
                            [
                                8.4833,
                                53.6936
                            ],
                            [
                                8.52041,
                                53.6062
                            ],
                            [
                                8.46188,
                                53.55296
                            ],
                            [
                                8.308,
                                53.61615
                            ],
                            [
                                8.24368,
                                53.5828
                            ],
                            [
                                8.2313,
                                53.52155
                            ],
                            [
                                8.31491,
                                53.51627
                            ],
                            [
                                8.29722,
                                53.43068
                            ],
                            [
                                8.20232,
                                53.40372
                            ],
                            [
                                8.08573,
                                53.50187
                            ],
                            [
                                8.16871,
                                53.54284
                            ],
                            [
                                8.02782,
                                53.70743
                            ],
                            [
                                7.91298,
                                53.71772
                            ],
                            [
                                7.70328,
                                53.70322
                            ],
                            [
                                7.52169,
                                53.67154
                            ],
                            [
                                7.2916,
                                53.67971
                            ],
                            [
                                7.15249,
                                53.62375
                            ],
                            [
                                7.03376,
                                53.53313
                            ],
                            [
                                6.99945,
                                53.35989
                            ],
                            [
                                7.03223,
                                53.33635
                            ],
                            [
                                7.23587,
                                53.33196
                            ],
                            [
                                7.20894,
                                53.24306
                            ],
                            [
                                7.10454,
                                53.25267
                            ],
                            [
                                7.08459,
                                53.29481
                            ],
                            [
                                6.93247,
                                53.32719
                            ],
                            [
                                6.81673,
                                53.46251
                            ],
                            [
                                6.65825,
                                53.45742
                            ],
                            [
                                6.36694,
                                53.41526
                            ],
                            [
                                6.01561,
                                53.40348
                            ],
                            [
                                5.88345,
                                53.38497
                            ],
                            [
                                5.58552,
                                53.30039
                            ],
                            [
                                5.43696,
                                53.21016
                            ],
                            [
                                5.4082,
                                53.13169
                            ],
                            [
                                5.04155,
                                52.93351
                            ],
                            [
                                4.87432,
                                52.88985
                            ],
                            [
                                4.73366,
                                52.96242
                            ],
                            [
                                4.6396,
                                52.72812
                            ],
                            [
                                4.60876,
                                52.5664
                            ],
                            [
                                4.55119,
                                52.41584
                            ],
                            [
                                4.44524,
                                52.26425
                            ],
                            [
                                4.36557,
                                52.17865
                            ],
                            [
                                4.12779,
                                52.00054
                            ],
                            [
                                3.98339,
                                51.98384
                            ],
                            [
                                3.98234,
                                51.92443
                            ],
                            [
                                4.05451,
                                51.91556
                            ],
                            [
                                4.03296,
                                51.82643
                            ],
                            [
                                3.95924,
                                51.84222
                            ],
                            [
                                3.86772,
                                51.81788
                            ],
                            [
                                3.81321,
                                51.69565
                            ],
                            [
                                3.89236,
                                51.63337
                            ],
                            [
                                3.97141,
                                51.61449
                            ],
                            [
                                4.07361,
                                51.52775
                            ],
                            [
                                4.16377,
                                51.52233
                            ],
                            [
                                4.22252,
                                51.43877
                            ],
                            [
                                4.13322,
                                51.43269
                            ],
                            [
                                4.05231,
                                51.50245
                            ],
                            [
                                3.94018,
                                51.52666
                            ],
                            [
                                3.8741,
                                51.59111
                            ],
                            [
                                3.55602,
                                51.58944
                            ],
                            [
                                3.43373,
                                51.5283
                            ],
                            [
                                3.57406,
                                51.43965
                            ],
                            [
                                3.66157,
                                51.45799
                            ],
                            [
                                3.81631,
                                51.38499
                            ],
                            [
                                3.89919,
                                51.39455
                            ],
                            [
                                3.97545,
                                51.46115
                            ],
                            [
                                4.07919,
                                51.40784
                            ],
                            [
                                4.24367,
                                51.37473
                            ],
                            [
                                4.23482,
                                51.34825
                            ],
                            [
                                4.1127,
                                51.35312
                            ],
                            [
                                4.02093,
                                51.39819
                            ],
                            [
                                3.86572,
                                51.33661
                            ],
                            [
                                3.72411,
                                51.35006
                            ],
                            [
                                3.51666,
                                51.40764
                            ],
                            [
                                3.36579,
                                51.36984
                            ],
                            [
                                3.0759,
                                51.30151
                            ],
                            [
                                2.76482,
                                51.16684
                            ],
                            [
                                2.54601,
                                51.08938
                            ],
                            [
                                2.37138,
                                51.04471
                            ],
                            [
                                1.91231,
                                50.98275
                            ],
                            [
                                1.72659,
                                50.93721
                            ],
                            [
                                1.58169,
                                50.8691
                            ],
                            [
                                1.60377,
                                50.80185
                            ],
                            [
                                1.56226,
                                50.69218
                            ],
                            [
                                1.58434,
                                50.53478
                            ],
                            [
                                1.53823,
                                50.28104
                            ],
                            [
                                1.54278,
                                50.21332
                            ],
                            [
                                1.44339,
                                50.10072
                            ],
                            [
                                1.20474,
                                49.9732
                            ],
                            [
                                1.02573,
                                49.9166
                            ],
                            [
                                0.76389,
                                49.87164
                            ],
                            [
                                0.58248,
                                49.85234
                            ],
                            [
                                0.32378,
                                49.74228
                            ],
                            [
                                0.20644,
                                49.71367
                            ],
                            [
                                0.07785,
                                49.54011
                            ],
                            [
                                0.12286,
                                49.46474
                            ],
                            [
                                0.11112,
                                49.39468
                            ],
                            [
                                0.04311,
                                49.347
                            ],
                            [
                                -0.10468,
                                49.29596
                            ],
                            [
                                -0.20755,
                                49.2861
                            ],
                            [
                                -0.39747,
                                49.33336
                            ],
                            [
                                -0.82729,
                                49.35797
                            ],
                            [
                                -0.92535,
                                49.39245
                            ],
                            [
                                -1.07929,
                                49.38777
                            ],
                            [
                                -1.11784,
                                49.36032
                            ],
                            [
                                -1.3065,
                                49.53897
                            ],
                            [
                                -1.23964,
                                49.6538
                            ],
                            [
                                -1.29983,
                                49.69369
                            ],
                            [
                                -1.43587,
                                49.70041
                            ],
                            [
                                -1.52126,
                                49.65729
                            ],
                            [
                                -1.62422,
                                49.64599
                            ],
                            [
                                -1.94158,
                                49.72539
                            ],
                            [
                                -1.94582,
                                49.67581
                            ],
                            [
                                -1.8603,
                                49.64916
                            ],
                            [
                                -1.85107,
                                49.50868
                            ],
                            [
                                -1.824,
                                49.40317
                            ],
                            [
                                -1.70758,
                                49.31948
                            ],
                            [
                                -1.59501,
                                49.13056
                            ],
                            [
                                -1.60953,
                                49.10237
                            ],
                            [
                                -1.56133,
                                48.94024
                            ],
                            [
                                -1.59185,
                                48.83259
                            ],
                            [
                                -1.5704,
                                48.74331
                            ],
                            [
                                -1.44875,
                                48.62371
                            ],
                            [
                                -1.54946,
                                48.63026
                            ],
                            [
                                -1.77441,
                                48.60371
                            ],
                            [
                                -1.84207,
                                48.61463
                            ],
                            [
                                -1.87472,
                                48.69558
                            ],
                            [
                                -2.13217,
                                48.63786
                            ],
                            [
                                -2.20575,
                                48.57957
                            ],
                            [
                                -2.28606,
                                48.66663
                            ],
                            [
                                -2.32898,
                                48.67269
                            ],
                            [
                                -2.55427,
                                48.59089
                            ],
                            [
                                -2.65561,
                                48.52557
                            ],
                            [
                                -2.82442,
                                48.59887
                            ],
                            [
                                -2.82735,
                                48.6553
                            ],
                            [
                                -2.92435,
                                48.70733
                            ],
                            [
                                -3.01944,
                                48.822
                            ],
                            [
                                -3.12784,
                                48.86458
                            ],
                            [
                                -3.20395,
                                48.83496
                            ],
                            [
                                -3.32103,
                                48.83779
                            ],
                            [
                                -3.43177,
                                48.7975
                            ],
                            [
                                -3.51227,
                                48.83417
                            ],
                            [
                                -3.58544,
                                48.77791
                            ],
                            [
                                -3.5497,
                                48.74565
                            ],
                            [
                                -3.6165,
                                48.68305
                            ],
                            [
                                -3.8157,
                                48.7154
                            ],
                            [
                                -3.84668,
                                48.6302
                            ],
                            [
                                -3.94117,
                                48.65797
                            ],
                            [
                                -3.99207,
                                48.72301
                            ],
                            [
                                -4.18674,
                                48.6861
                            ],
                            [
                                -4.27497,
                                48.64914
                            ],
                            [
                                -4.34912,
                                48.67638
                            ],
                            [
                                -4.46278,
                                48.6271
                            ],
                            [
                                -4.60013,
                                48.60616
                            ],
                            [
                                -4.70204,
                                48.56945
                            ],
                            [
                                -4.77782,
                                48.5042
                            ],
                            [
                                -4.7948,
                                48.41421
                            ],
                            [
                                -4.77507,
                                48.33672
                            ],
                            [
                                -4.6278,
                                48.33813
                            ],
                            [
                                -4.43369,
                                48.39595
                            ],
                            [
                                -4.45128,
                                48.32893
                            ],
                            [
                                -4.31413,
                                48.3353
                            ],
                            [
                                -4.36723,
                                48.27781
                            ],
                            [
                                -4.46121,
                                48.2938
                            ],
                            [
                                -4.61281,
                                48.28105
                            ],
                            [
                                -4.55038,
                                48.19573
                            ],
                            [
                                -4.46478,
                                48.23895
                            ],
                            [
                                -4.30339,
                                48.19484
                            ],
                            [
                                -4.28719,
                                48.10284
                            ],
                            [
                                -4.41574,
                                48.10651
                            ],
                            [
                                -4.67368,
                                48.06151
                            ],
                            [
                                -4.42273,
                                47.9621
                            ],
                            [
                                -4.36279,
                                47.88905
                            ],
                            [
                                -4.37295,
                                47.79784
                            ],
                            [
                                -4.19332,
                                47.79653
                            ],
                            [
                                -4.11433,
                                47.86969
                            ],
                            [
                                -4.03996,
                                47.84545
                            ],
                            [
                                -3.95412,
                                47.89495
                            ],
                            [
                                -3.85518,
                                47.80367
                            ],
                            [
                                -3.73253,
                                47.80456
                            ],
                            [
                                -3.68058,
                                47.77684
                            ],
                            [
                                -3.53192,
                                47.76927
                            ],
                            [
                                -3.45022,
                                47.6965
                            ],
                            [
                                -3.36817,
                                47.71577
                            ],
                            [
                                -3.21754,
                                47.66682
                            ],
                            [
                                -3.197,
                                47.62376
                            ],
                            [
                                -3.10345,
                                47.58373
                            ],
                            [
                                -2.93879,
                                47.55459
                            ],
                            [
                                -2.9213,
                                47.58445
                            ],
                            [
                                -2.75727,
                                47.63041
                            ],
                            [
                                -2.73397,
                                47.55256
                            ],
                            [
                                -2.87068,
                                47.55021
                            ],
                            [
                                -2.84947,
                                47.49899
                            ],
                            [
                                -2.68474,
                                47.49648
                            ],
                            [
                                -2.61264,
                                47.5414
                            ],
                            [
                                -2.46694,
                                47.51176
                            ],
                            [
                                -2.44626,
                                47.43644
                            ],
                            [
                                -2.55181,
                                47.3695
                            ],
                            [
                                -2.54403,
                                47.29008
                            ],
                            [
                                -2.43114,
                                47.25866
                            ],
                            [
                                -2.35762,
                                47.27269
                            ],
                            [
                                -2.29673,
                                47.23442
                            ],
                            [
                                -2.18052,
                                47.23413
                            ],
                            [
                                -2.16681,
                                47.16759
                            ],
                            [
                                -2.24638,
                                47.13479
                            ],
                            [
                                -2.05355,
                                47.09454
                            ],
                            [
                                -1.98362,
                                47.02946
                            ],
                            [
                                -2.05814,
                                46.95131
                            ],
                            [
                                -2.15447,
                                46.88917
                            ],
                            [
                                -2.14192,
                                46.81901
                            ],
                            [
                                -1.94399,
                                46.69323
                            ],
                            [
                                -1.85684,
                                46.60918
                            ],
                            [
                                -1.81181,
                                46.49356
                            ],
                            [
                                -1.62278,
                                46.41318
                            ],
                            [
                                -1.50074,
                                46.39591
                            ],
                            [
                                -1.47094,
                                46.34628
                            ],
                            [
                                -1.36101,
                                46.34795
                            ],
                            [
                                -1.2064,
                                46.2669
                            ],
                            [
                                -1.11144,
                                46.26126
                            ],
                            [
                                -1.21855,
                                46.17933
                            ],
                            [
                                -1.12817,
                                46.12588
                            ],
                            [
                                -1.05325,
                                46.00387
                            ],
                            [
                                -1.07485,
                                45.9106
                            ],
                            [
                                -1.15236,
                                45.86134
                            ],
                            [
                                -1.13324,
                                45.79681
                            ],
                            [
                                -1.23661,
                                45.78805
                            ],
                            [
                                -1.23633,
                                45.69686
                            ],
                            [
                                -0.99459,
                                45.59785
                            ],
                            [
                                -0.77375,
                                45.44921
                            ],
                            [
                                -0.69904,
                                45.28502
                            ],
                            [
                                -0.74732,
                                45.20572
                            ],
                            [
                                -0.80352,
                                45.34418
                            ],
                            [
                                -0.93362,
                                45.44036
                            ],
                            [
                                -1.06059,
                                45.50743
                            ],
                            [
                                -1.15456,
                                45.48068
                            ],
                            [
                                -1.16451,
                                45.28507
                            ],
                            [
                                -1.20271,
                                44.99996
                            ],
                            [
                                -1.22323,
                                44.70892
                            ],
                            [
                                -1.14943,
                                44.76311
                            ],
                            [
                                -1.03693,
                                44.69405
                            ],
                            [
                                -1.09374,
                                44.64194
                            ],
                            [
                                -1.19433,
                                44.65781
                            ],
                            [
                                -1.25943,
                                44.54417
                            ],
                            [
                                -1.25097,
                                44.50496
                            ],
                            [
                                -1.31634,
                                44.12883
                            ],
                            [
                                -1.46031,
                                43.61984
                            ],
                            [
                                -1.59717,
                                43.43604
                            ],
                            [
                                -1.76296,
                                43.37572
                            ],
                            [
                                -1.78598,
                                43.35048
                            ],
                            [
                                -1.88483,
                                43.35002
                            ],
                            [
                                -2.17732,
                                43.28821
                            ],
                            [
                                -2.28505,
                                43.29472
                            ],
                            [
                                -2.464,
                                43.33868
                            ],
                            [
                                -2.50835,
                                43.37601
                            ],
                            [
                                -2.80537,
                                43.43132
                            ],
                            [
                                -2.94518,
                                43.43482
                            ],
                            [
                                -3.03739,
                                43.37272
                            ],
                            [
                                -3.16291,
                                43.3519
                            ],
                            [
                                -3.22523,
                                43.39476
                            ],
                            [
                                -3.42155,
                                43.4131
                            ],
                            [
                                -3.43559,
                                43.46435
                            ],
                            [
                                -3.59431,
                                43.51319
                            ],
                            [
                                -3.71926,
                                43.47468
                            ],
                            [
                                -3.94585,
                                43.46931
                            ],
                            [
                                -4.17356,
                                43.40246
                            ],
                            [
                                -4.32448,
                                43.38925
                            ],
                            [
                                -4.61815,
                                43.39641
                            ],
                            [
                                -5.12324,
                                43.48426
                            ],
                            [
                                -5.21487,
                                43.47371
                            ],
                            [
                                -5.29374,
                                43.53458
                            ],
                            [
                                -5.41022,
                                43.55583
                            ],
                            [
                                -5.64989,
                                43.54263
                            ],
                            [
                                -5.75801,
                                43.58555
                            ],
                            [
                                -5.81143,
                                43.64153
                            ],
                            [
                                -5.91362,
                                43.62364
                            ],
                            [
                                -6.12129,
                                43.55569
                            ],
                            [
                                -6.24671,
                                43.58446
                            ],
                            [
                                -6.35523,
                                43.55107
                            ],
                            [
                                -6.53576,
                                43.54653
                            ],
                            [
                                -6.94443,
                                43.57388
                            ],
                            [
                                -7.03184,
                                43.54447
                            ],
                            [
                                -7.24382,
                                43.56553
                            ],
                            [
                                -7.35715,
                                43.67065
                            ],
                            [
                                -7.55303,
                                43.72967
                            ],
                            [
                                -7.71475,
                                43.76492
                            ],
                            [
                                -7.82751,
                                43.70991
                            ],
                            [
                                -7.86642,
                                43.76922
                            ],
                            [
                                -8.07439,
                                43.65964
                            ],
                            [
                                -8.1869,
                                43.61888
                            ],
                            [
                                -8.32492,
                                43.52211
                            ],
                            [
                                -8.32606,
                                43.4832
                            ],
                            [
                                -8.25725,
                                43.42082
                            ],
                            [
                                -8.33808,
                                43.37847
                            ],
                            [
                                -8.4397,
                                43.38069
                            ],
                            [
                                -8.54768,
                                43.31169
                            ],
                            [
                                -8.70915,
                                43.28994
                            ],
                            [
                                -8.82799,
                                43.32884
                            ],
                            [
                                -8.95637,
                                43.2931
                            ],
                            [
                                -8.9377,
                                43.23272
                            ],
                            [
                                -9.08032,
                                43.18127
                            ],
                            [
                                -9.17461,
                                43.18515
                            ],
                            [
                                -9.21351,
                                43.10275
                            ],
                            [
                                -9.28575,
                                43.04116
                            ],
                            [
                                -9.25712,
                                43.00249
                            ],
                            [
                                -9.297,
                                42.92362
                            ],
                            [
                                -9.13314,
                                42.91013
                            ],
                            [
                                -9.10998,
                                42.84039
                            ],
                            [
                                -9.15008,
                                42.79966
                            ],
                            [
                                -9.10007,
                                42.75417
                            ],
                            [
                                -8.9527,
                                42.78299
                            ],
                            [
                                -9.02885,
                                42.70117
                            ],
                            [
                                -9.05827,
                                42.57709
                            ],
                            [
                                -8.99098,
                                42.55691
                            ],
                            [
                                -8.89913,
                                42.64028
                            ],
                            [
                                -8.80427,
                                42.63812
                            ],
                            [
                                -8.7674,
                                42.60305
                            ],
                            [
                                -8.83788,
                                42.55299
                            ],
                            [
                                -8.81985,
                                42.45878
                            ],
                            [
                                -8.87973,
                                42.41605
                            ],
                            [
                                -8.77625,
                                42.3892
                            ],
                            [
                                -8.75286,
                                42.3438
                            ],
                            [
                                -8.81923,
                                42.31323
                            ],
                            [
                                -8.79285,
                                42.2485
                            ],
                            [
                                -8.81908,
                                42.13089
                            ],
                            [
                                -8.89567,
                                42.11229
                            ],
                            [
                                -8.86319,
                                41.87207
                            ],
                            [
                                -8.88056,
                                41.752
                            ],
                            [
                                -8.8264,
                                41.64807
                            ],
                            [
                                -8.77732,
                                41.47958
                            ],
                            [
                                -8.78901,
                                41.41631
                            ],
                            [
                                -8.70651,
                                41.18735
                            ],
                            [
                                -8.66785,
                                41.13912
                            ],
                            [
                                -8.64497,
                                41.01597
                            ],
                            [
                                -8.66845,
                                40.90011
                            ],
                            [
                                -8.75492,
                                40.6465
                            ],
                            [
                                -8.84633,
                                40.32688
                            ],
                            [
                                -8.90808,
                                40.19004
                            ],
                            [
                                -8.86313,
                                40.13718
                            ],
                            [
                                -8.89493,
                                40.0455
                            ],
                            [
                                -9.03061,
                                39.76711
                            ],
                            [
                                -9.08532,
                                39.61502
                            ],
                            [
                                -9.07798,
                                39.58985
                            ],
                            [
                                -9.22663,
                                39.43684
                            ],
                            [
                                -9.36594,
                                39.34838
                            ],
                            [
                                -9.33582,
                                39.27359
                            ],
                            [
                                -9.3604,
                                39.1705
                            ],
                            [
                                -9.42145,
                                39.07474
                            ],
                            [
                                -9.41663,
                                38.95274
                            ],
                            [
                                -9.49992,
                                38.78071
                            ],
                            [
                                -9.48594,
                                38.71047
                            ],
                            [
                                -9.31837,
                                38.67578
                            ],
                            [
                                -9.13137,
                                38.7076
                            ],
                            [
                                -9.09096,
                                38.75934
                            ],
                            [
                                -9.05891,
                                38.85914
                            ],
                            [
                                -8.98824,
                                38.91403
                            ],
                            [
                                -8.93122,
                                38.7687
                            ],
                            [
                                -9.04503,
                                38.71507
                            ],
                            [
                                -9.01297,
                                38.67192
                            ],
                            [
                                -9.25772,
                                38.66447
                            ],
                            [
                                -9.18782,
                                38.55032
                            ],
                            [
                                -9.1848,
                                38.48803
                            ],
                            [
                                -9.22153,
                                38.41356
                            ],
                            [
                                -9.06543,
                                38.43533
                            ],
                            [
                                -8.88786,
                                38.52048
                            ],
                            [
                                -8.8315,
                                38.49359
                            ],
                            [
                                -8.74829,
                                38.55123
                            ],
                            [
                                -8.7198,
                                38.44091
                            ],
                            [
                                -8.79819,
                                38.39483
                            ],
                            [
                                -8.77582,
                                38.245
                            ],
                            [
                                -8.78259,
                                38.17278
                            ],
                            [
                                -8.82562,
                                38.04929
                            ],
                            [
                                -8.88302,
                                37.95045
                            ],
                            [
                                -8.81047,
                                37.92769
                            ],
                            [
                                -8.79068,
                                37.83778
                            ],
                            [
                                -8.81153,
                                37.74646
                            ],
                            [
                                -8.78666,
                                37.71455
                            ],
                            [
                                -8.81839,
                                37.5978
                            ],
                            [
                                -8.79295,
                                37.5588
                            ],
                            [
                                -8.80719,
                                37.41877
                            ],
                            [
                                -8.86953,
                                37.32441
                            ],
                            [
                                -8.86078,
                                37.26815
                            ],
                            [
                                -8.90325,
                                37.16897
                            ],
                            [
                                -8.99451,
                                37.02379
                            ],
                            [
                                -8.94889,
                                37.00698
                            ],
                            [
                                -8.82242,
                                37.06476
                            ],
                            [
                                -8.68553,
                                37.08515
                            ],
                            [
                                -8.60226,
                                37.12299
                            ],
                            [
                                -8.44391,
                                37.08664
                            ],
                            [
                                -8.36936,
                                37.10168
                            ],
                            [
                                -8.3089,
                                37.07553
                            ],
                            [
                                -8.1848,
                                37.09034
                            ],
                            [
                                -8.09663,
                                37.06444
                            ],
                            [
                                -7.97937,
                                36.9975
                            ],
                            [
                                -7.89784,
                                36.96982
                            ],
                            [
                                -7.85669,
                                37.02096
                            ],
                            [
                                -7.79791,
                                37.01308
                            ],
                            [
                                -7.57036,
                                37.14804
                            ],
                            [
                                -7.40192,
                                37.17483
                            ],
                            [
                                -7.28481,
                                37.20061
                            ],
                            [
                                -7.02771,
                                37.20318
                            ],
                            [
                                -6.76021,
                                37.10538
                            ],
                            [
                                -6.5092,
                                36.96765
                            ],
                            [
                                -6.44778,
                                36.90544
                            ],
                            [
                                -6.39551,
                                36.80626
                            ],
                            [
                                -6.43945,
                                36.71997
                            ],
                            [
                                -6.38837,
                                36.62925
                            ],
                            [
                                -6.29905,
                                36.61755
                            ],
                            [
                                -6.22443,
                                36.56089
                            ],
                            [
                                -6.24995,
                                36.45074
                            ],
                            [
                                -6.14263,
                                36.2967
                            ],
                            [
                                -6.05483,
                                36.20578
                            ],
                            [
                                -5.97757,
                                36.17737
                            ],
                            [
                                -5.91506,
                                36.18458
                            ],
                            [
                                -5.79699,
                                36.07884
                            ],
                            [
                                -5.64446,
                                36.04809
                            ],
                            [
                                -5.6082,
                                36.00846
                            ],
                            [
                                -5.42744,
                                36.0757
                            ],
                            [
                                -5.44661,
                                36.14052
                            ],
                            [
                                -5.35152,
                                36.15257
                            ],
                            [
                                -5.33922,
                                36.15203
                            ],
                            [
                                -5.3127,
                                36.23605
                            ],
                            [
                                -5.17591,
                                36.4147
                            ],
                            [
                                -5.00559,
                                36.45956
                            ],
                            [
                                -4.93511,
                                36.49939
                            ],
                            [
                                -4.85564,
                                36.50665
                            ],
                            [
                                -4.75864,
                                36.48609
                            ],
                            [
                                -4.63964,
                                36.50702
                            ],
                            [
                                -4.58992,
                                36.57134
                            ],
                            [
                                -4.50951,
                                36.59935
                            ],
                            [
                                -4.43317,
                                36.70171
                            ],
                            [
                                -4.39106,
                                36.7221
                            ],
                            [
                                -4.2505,
                                36.71025
                            ],
                            [
                                -4.11039,
                                36.72503
                            ],
                            [
                                -4.07961,
                                36.74672
                            ],
                            [
                                -3.95728,
                                36.7261
                            ],
                            [
                                -3.83565,
                                36.75359
                            ],
                            [
                                -3.76692,
                                36.72922
                            ],
                            [
                                -3.60172,
                                36.74382
                            ],
                            [
                                -3.55074,
                                36.71491
                            ],
                            [
                                -3.42038,
                                36.69458
                            ],
                            [
                                -3.3384,
                                36.7384
                            ],
                            [
                                -3.24951,
                                36.75455
                            ],
                            [
                                -2.97679,
                                36.73844
                            ],
                            [
                                -2.91612,
                                36.74889
                            ],
                            [
                                -2.85789,
                                36.69928
                            ],
                            [
                                -2.77216,
                                36.68164
                            ],
                            [
                                -2.64636,
                                36.70259
                            ],
                            [
                                -2.56215,
                                36.81602
                            ],
                            [
                                -2.47298,
                                36.83655
                            ],
                            [
                                -2.42793,
                                36.81074
                            ],
                            [
                                -2.36766,
                                36.84133
                            ],
                            [
                                -2.25982,
                                36.79425
                            ],
                            [
                                -2.19346,
                                36.72266
                            ],
                            [
                                -2.13542,
                                36.72977
                            ],
                            [
                                -1.9454,
                                36.93225
                            ],
                            [
                                -1.84985,
                                37.0684
                            ],
                            [
                                -1.8031,
                                37.22102
                            ],
                            [
                                -1.67416,
                                37.35499
                            ],
                            [
                                -1.51753,
                                37.4317
                            ],
                            [
                                -1.45364,
                                37.491
                            ],
                            [
                                -1.3256,
                                37.56198
                            ],
                            [
                                -1.20285,
                                37.57338
                            ],
                            [
                                -1.16489,
                                37.54233
                            ],
                            [
                                -1.07351,
                                37.58274
                            ],
                            [
                                -0.9209,
                                37.55654
                            ],
                            [
                                -0.72074,
                                37.60651
                            ],
                            [
                                -0.85998,
                                37.72145
                            ],
                            [
                                -0.77588,
                                37.8189
                            ],
                            [
                                -0.75026,
                                37.89757
                            ],
                            [
                                -0.64773,
                                38.0021
                            ],
                            [
                                -0.6369,
                                38.13592
                            ],
                            [
                                -0.58876,
                                38.18943
                            ],
                            [
                                -0.50754,
                                38.21087
                            ],
                            [
                                -0.50992,
                                38.32672
                            ],
                            [
                                -0.44565,
                                38.36208
                            ],
                            [
                                -0.37408,
                                38.44233
                            ],
                            [
                                -0.1544,
                                38.53355
                            ],
                            [
                                -0.09688,
                                38.5248
                            ],
                            [
                                -0.02931,
                                38.61804
                            ],
                            [
                                0.06828,
                                38.63933
                            ],
                            [
                                0.15416,
                                38.68645
                            ],
                            [
                                0.22247,
                                38.76235
                            ],
                            [
                                0.19758,
                                38.80354
                            ],
                            [
                                0.09276,
                                38.85459
                            ],
                            [
                                -0.02303,
                                38.87625
                            ],
                            [
                                -0.14687,
                                38.9834
                            ],
                            [
                                -0.23688,
                                39.13908
                            ],
                            [
                                -0.21965,
                                39.18128
                            ],
                            [
                                -0.29075,
                                39.3061
                            ],
                            [
                                -0.33443,
                                39.42324
                            ],
                            [
                                -0.32095,
                                39.50799
                            ],
                            [
                                -0.25882,
                                39.61493
                            ],
                            [
                                -0.21081,
                                39.65443
                            ],
                            [
                                -0.17747,
                                39.74031
                            ],
                            [
                                -0.07866,
                                39.86066
                            ],
                            [
                                -0.01002,
                                39.91104
                            ],
                            [
                                0.0518,
                                40.03737
                            ],
                            [
                                0.12017,
                                40.06271
                            ],
                            [
                                0.20122,
                                40.18075
                            ],
                            [
                                0.2646,
                                40.21052
                            ],
                            [
                                0.40416,
                                40.36226
                            ],
                            [
                                0.53858,
                                40.56732
                            ],
                            [
                                0.60314,
                                40.62191
                            ],
                            [
                                0.74604,
                                40.63618
                            ],
                            [
                                0.84914,
                                40.67958
                            ],
                            [
                                0.83488,
                                40.73148
                            ],
                            [
                                0.70042,
                                40.80341
                            ],
                            [
                                0.79232,
                                40.86735
                            ],
                            [
                                0.9656,
                                41.02757
                            ],
                            [
                                1.04936,
                                41.06393
                            ],
                            [
                                1.18049,
                                41.06298
                            ],
                            [
                                1.21818,
                                41.10523
                            ],
                            [
                                1.40739,
                                41.14078
                            ],
                            [
                                1.52722,
                                41.18085
                            ],
                            [
                                1.67315,
                                41.19825
                            ],
                            [
                                1.92235,
                                41.26001
                            ],
                            [
                                2.11957,
                                41.29206
                            ],
                            [
                                2.25368,
                                41.4487
                            ],
                            [
                                2.53216,
                                41.57
                            ],
                            [
                                2.77851,
                                41.64881
                            ],
                            [
                                2.854,
                                41.69955
                            ],
                            [
                                2.93361,
                                41.71579
                            ],
                            [
                                3.0562,
                                41.78754
                            ],
                            [
                                3.10002,
                                41.84308
                            ],
                            [
                                3.17742,
                                41.86787
                            ],
                            [
                                3.23136,
                                41.96727
                            ],
                            [
                                3.17598,
                                42.11112
                            ],
                            [
                                3.1245,
                                42.12841
                            ],
                            [
                                3.11749,
                                42.2226
                            ],
                            [
                                3.28062,
                                42.25492
                            ],
                            [
                                3.30479,
                                42.32682
                            ],
                            [
                                3.16417,
                                42.36062
                            ],
                            [
                                3.1748,
                                42.43537
                            ],
                            [
                                3.13671,
                                42.51634
                            ],
                            [
                                3.0512,
                                42.54593
                            ],
                            [
                                3.0357,
                                42.64076
                            ],
                            [
                                3.04288,
                                42.96015
                            ],
                            [
                                3.08445,
                                43.05619
                            ],
                            [
                                3.14379,
                                43.1323
                            ],
                            [
                                3.27112,
                                43.23378
                            ],
                            [
                                3.42897,
                                43.29018
                            ],
                            [
                                3.51549,
                                43.27565
                            ],
                            [
                                3.65287,
                                43.38822
                            ],
                            [
                                3.79589,
                                43.44074
                            ],
                            [
                                3.90798,
                                43.5171
                            ],
                            [
                                4.00621,
                                43.5514
                            ],
                            [
                                4.10108,
                                43.55471
                            ],
                            [
                                4.16562,
                                43.47196
                            ],
                            [
                                4.42139,
                                43.44804
                            ],
                            [
                                4.54718,
                                43.44858
                            ],
                            [
                                4.59385,
                                43.35644
                            ],
                            [
                                4.77328,
                                43.34891
                            ],
                            [
                                4.85044,
                                43.39846
                            ],
                            [
                                4.96307,
                                43.42661
                            ],
                            [
                                5.05221,
                                43.32504
                            ],
                            [
                                5.22202,
                                43.32834
                            ],
                            [
                                5.31371,
                                43.3589
                            ],
                            [
                                5.40444,
                                43.2119
                            ],
                            [
                                5.57227,
                                43.17321
                            ],
                            [
                                5.62343,
                                43.18642
                            ],
                            [
                                5.77254,
                                43.11725
                            ],
                            [
                                5.86033,
                                43.04846
                            ],
                            [
                                5.90854,
                                43.09429
                            ],
                            [
                                6.00723,
                                43.10337
                            ],
                            [
                                6.12504,
                                43.07765
                            ],
                            [
                                6.19943,
                                43.11486
                            ],
                            [
                                6.36816,
                                43.13597
                            ],
                            [
                                6.54183,
                                43.18238
                            ],
                            [
                                6.64348,
                                43.18678
                            ],
                            [
                                6.66452,
                                43.26529
                            ],
                            [
                                6.748,
                                43.41928
                            ],
                            [
                                6.85525,
                                43.41158
                            ],
                            [
                                6.91992,
                                43.44956
                            ],
                            [
                                6.95991,
                                43.5403
                            ],
                            [
                                7.0414,
                                43.54104
                            ],
                            [
                                7.12583,
                                43.57414
                            ],
                            [
                                7.13753,
                                43.63575
                            ],
                            [
                                7.26095,
                                43.69416
                            ],
                            [
                                7.419602937661709,
                                43.725346905646397
                            ],
                            [
                                7.52983,
                                43.78401
                            ],
                            [
                                7.6728,
                                43.77662
                            ],
                            [
                                7.80657,
                                43.82296
                            ],
                            [
                                7.96567,
                                43.85206
                            ],
                            [
                                8.07131,
                                43.89063
                            ],
                            [
                                8.22611,
                                44.04505
                            ],
                            [
                                8.26921,
                                44.13914
                            ],
                            [
                                8.40601,
                                44.18158
                            ],
                            [
                                8.45505,
                                44.29046
                            ],
                            [
                                8.50932,
                                44.3285
                            ],
                            [
                                8.74753,
                                44.42621
                            ],
                            [
                                9.23084,
                                44.34782
                            ],
                            [
                                9.48127,
                                44.24013
                            ],
                            [
                                9.56949,
                                44.18239
                            ],
                            [
                                9.71668,
                                44.11809
                            ],
                            [
                                9.82268,
                                44.09663
                            ],
                            [
                                9.9631,
                                44.0381
                            ],
                            [
                                10.05992,
                                44.0289
                            ],
                            [
                                10.14348,
                                43.97542
                            ],
                            [
                                10.22773,
                                43.88764
                            ],
                            [
                                10.26827,
                                43.78621
                            ],
                            [
                                10.29918,
                                43.53434
                            ],
                            [
                                10.34195,
                                43.46501
                            ],
                            [
                                10.42472,
                                43.3988
                            ],
                            [
                                10.52825,
                                43.2316
                            ],
                            [
                                10.53943,
                                43.12025
                            ],
                            [
                                10.49818,
                                42.93799
                            ],
                            [
                                10.67479,
                                42.94996
                            ],
                            [
                                10.78636,
                                42.88897
                            ],
                            [
                                10.76076,
                                42.81107
                            ],
                            [
                                10.78609,
                                42.77445
                            ],
                            [
                                10.89856,
                                42.75709
                            ],
                            [
                                10.97767,
                                42.71866
                            ],
                            [
                                11.01484,
                                42.65633
                            ],
                            [
                                11.08389,
                                42.62786
                            ],
                            [
                                11.1231,
                                42.55757
                            ],
                            [
                                11.19077,
                                42.51544
                            ],
                            [
                                11.15682,
                                42.43405
                            ],
                            [
                                11.18908,
                                42.36417
                            ],
                            [
                                11.27054,
                                42.41886
                            ],
                            [
                                11.44994,
                                42.37767
                            ],
                            [
                                11.63239,
                                42.29535
                            ],
                            [
                                11.69622,
                                42.2345
                            ],
                            [
                                11.75497,
                                42.12607
                            ],
                            [
                                11.83613,
                                42.02936
                            ],
                            [
                                11.9158,
                                42.03896
                            ],
                            [
                                12.12475,
                                41.92643
                            ],
                            [
                                12.19009,
                                41.85545
                            ],
                            [
                                12.23121,
                                41.74105
                            ],
                            [
                                12.36567,
                                41.68932
                            ],
                            [
                                12.55283,
                                41.53404
                            ],
                            [
                                12.61842,
                                41.44802
                            ],
                            [
                                12.66659,
                                41.45669
                            ],
                            [
                                12.76336,
                                41.41089
                            ],
                            [
                                12.84493,
                                41.41406
                            ],
                            [
                                12.982,
                                41.33351
                            ],
                            [
                                13.04644,
                                41.22709
                            ],
                            [
                                13.28151,
                                41.29756
                            ],
                            [
                                13.39644,
                                41.27387
                            ],
                            [
                                13.54859,
                                41.20804
                            ],
                            [
                                13.61691,
                                41.25949
                            ],
                            [
                                13.73021,
                                41.24336
                            ],
                            [
                                13.81375,
                                41.18438
                            ],
                            [
                                13.88747,
                                41.10078
                            ],
                            [
                                13.92268,
                                41.02519
                            ],
                            [
                                13.99556,
                                40.95687
                            ],
                            [
                                14.08869,
                                40.83044
                            ],
                            [
                                14.15922,
                                40.81684
                            ],
                            [
                                14.28896,
                                40.83839
                            ],
                            [
                                14.48067,
                                40.69901
                            ],
                            [
                                14.35118,
                                40.63394
                            ],
                            [
                                14.32427,
                                40.57015
                            ],
                            [
                                14.48856,
                                40.62729
                            ],
                            [
                                14.56944,
                                40.61513
                            ],
                            [
                                14.63358,
                                40.64854
                            ],
                            [
                                14.69225,
                                40.63478
                            ],
                            [
                                14.7601,
                                40.67682
                            ],
                            [
                                14.88293,
                                40.58
                            ],
                            [
                                14.98446,
                                40.4218
                            ],
                            [
                                14.99619,
                                40.35621
                            ],
                            [
                                14.9454,
                                40.33539
                            ],
                            [
                                14.9271,
                                40.23175
                            ],
                            [
                                15.02535,
                                40.17841
                            ],
                            [
                                15.11595,
                                40.17652
                            ],
                            [
                                15.35336,
                                40.00055
                            ],
                            [
                                15.4254,
                                39.99523
                            ],
                            [
                                15.50377,
                                40.06351
                            ],
                            [
                                15.63195,
                                40.06787
                            ],
                            [
                                15.77966,
                                39.89263
                            ],
                            [
                                15.81594,
                                39.68028
                            ],
                            [
                                15.87381,
                                39.55498
                            ],
                            [
                                15.99175,
                                39.44682
                            ],
                            [
                                16.0539,
                                39.28048
                            ],
                            [
                                16.0685,
                                39.1291
                            ],
                            [
                                16.09883,
                                39.02852
                            ],
                            [
                                16.15775,
                                38.95062
                            ],
                            [
                                16.21545,
                                38.92621
                            ],
                            [
                                16.22164,
                                38.84884
                            ],
                            [
                                16.18577,
                                38.75206
                            ],
                            [
                                16.10416,
                                38.7121
                            ],
                            [
                                15.98579,
                                38.72254
                            ],
                            [
                                15.85155,
                                38.66133
                            ],
                            [
                                15.846,
                                38.61219
                            ],
                            [
                                15.928,
                                38.55012
                            ],
                            [
                                15.90356,
                                38.44083
                            ],
                            [
                                15.83579,
                                38.36205
                            ],
                            [
                                15.82509,
                                38.31486
                            ],
                            [
                                15.74997,
                                38.25723
                            ],
                            [
                                15.63631,
                                38.231
                            ],
                            [
                                15.65442,
                                38.15436
                            ],
                            [
                                15.63454,
                                38.01792
                            ],
                            [
                                15.67779,
                                37.9548
                            ],
                            [
                                15.76341,
                                37.91674
                            ],
                            [
                                16.06438,
                                37.92524
                            ],
                            [
                                16.14393,
                                38.0316
                            ],
                            [
                                16.16181,
                                38.12803
                            ],
                            [
                                16.33577,
                                38.30035
                            ],
                            [
                                16.46211,
                                38.33727
                            ],
                            [
                                16.5709,
                                38.42672
                            ],
                            [
                                16.58208,
                                38.46979
                            ],
                            [
                                16.55877,
                                38.68059
                            ],
                            [
                                16.5369,
                                38.71757
                            ],
                            [
                                16.61048,
                                38.81509
                            ],
                            [
                                16.76236,
                                38.88959
                            ],
                            [
                                16.87655,
                                38.92561
                            ],
                            [
                                16.98403,
                                38.93766
                            ],
                            [
                                17.10113,
                                38.90435
                            ],
                            [
                                17.16906,
                                38.95442
                            ],
                            [
                                17.19009,
                                39.02084
                            ],
                            [
                                17.10933,
                                39.10608
                            ],
                            [
                                17.14778,
                                39.20967
                            ],
                            [
                                17.1047,
                                39.26623
                            ],
                            [
                                17.15707,
                                39.39997
                            ],
                            [
                                17.05289,
                                39.4394
                            ],
                            [
                                17.02506,
                                39.48358
                            ],
                            [
                                16.87504,
                                39.53459
                            ],
                            [
                                16.77073,
                                39.62111
                            ],
                            [
                                16.62982,
                                39.62041
                            ],
                            [
                                16.54288,
                                39.65486
                            ],
                            [
                                16.48883,
                                39.75869
                            ],
                            [
                                16.4966,
                                39.81782
                            ],
                            [
                                16.62968,
                                39.96451
                            ],
                            [
                                16.60697,
                                40.08293
                            ],
                            [
                                16.68667,
                                40.14624
                            ],
                            [
                                16.78657,
                                40.30272
                            ],
                            [
                                16.90156,
                                40.43515
                            ],
                            [
                                17.0231,
                                40.50586
                            ],
                            [
                                17.1271,
                                40.51762
                            ],
                            [
                                17.25033,
                                40.45285
                            ],
                            [
                                17.22372,
                                40.40779
                            ],
                            [
                                17.51152,
                                40.29496
                            ],
                            [
                                17.69783,
                                40.30352
                            ],
                            [
                                17.85955,
                                40.28359
                            ],
                            [
                                17.90357,
                                40.25552
                            ],
                            [
                                17.93748,
                                40.17128
                            ],
                            [
                                18.01073,
                                40.10128
                            ],
                            [
                                18.01281,
                                39.97081
                            ],
                            [
                                18.15067,
                                39.8618
                            ],
                            [
                                18.36907,
                                39.79374
                            ],
                            [
                                18.39015,
                                39.81686
                            ],
                            [
                                18.40303,
                                39.96006
                            ],
                            [
                                18.43566,
                                40.02455
                            ],
                            [
                                18.51931,
                                40.10612
                            ],
                            [
                                18.42301,
                                40.29323
                            ],
                            [
                                18.24829,
                                40.43796
                            ],
                            [
                                18.12747,
                                40.49313
                            ],
                            [
                                18.03489,
                                40.57163
                            ],
                            [
                                18.01952,
                                40.64146
                            ],
                            [
                                17.84522,
                                40.68997
                            ],
                            [
                                17.67692,
                                40.76854
                            ],
                            [
                                17.47302,
                                40.83233
                            ],
                            [
                                17.27706,
                                40.97258
                            ],
                            [
                                17.05549,
                                41.07732
                            ],
                            [
                                16.8101,
                                41.14058
                            ],
                            [
                                16.58324,
                                41.20833
                            ],
                            [
                                16.35444,
                                41.30612
                            ],
                            [
                                16.26238,
                                41.32848
                            ],
                            [
                                15.99364,
                                41.43892
                            ],
                            [
                                15.92396,
                                41.49635
                            ],
                            [
                                15.9027,
                                41.61689
                            ],
                            [
                                16.06453,
                                41.69356
                            ],
                            [
                                16.18577,
                                41.77175
                            ],
                            [
                                16.19903,
                                41.82528
                            ],
                            [
                                16.15121,
                                41.90935
                            ],
                            [
                                16.06006,
                                41.94769
                            ],
                            [
                                15.68458,
                                41.91455
                            ],
                            [
                                15.63853,
                                41.92727
                            ],
                            [
                                15.40364,
                                41.90063
                            ],
                            [
                                15.17483,
                                41.92154
                            ],
                            [
                                15.08164,
                                41.94206
                            ],
                            [
                                14.99814,
                                42.00506
                            ],
                            [
                                14.90023,
                                42.0214
                            ],
                            [
                                14.71857,
                                42.10596
                            ],
                            [
                                14.71583,
                                42.17267
                            ],
                            [
                                14.51144,
                                42.25033
                            ],
                            [
                                14.39243,
                                42.3719
                            ],
                            [
                                14.18616,
                                42.49389
                            ],
                            [
                                14.10996,
                                42.56235
                            ],
                            [
                                14.0058,
                                42.69345
                            ],
                            [
                                13.94025,
                                42.81425
                            ],
                            [
                                13.86548,
                                43.0101
                            ],
                            [
                                13.84555,
                                43.09444
                            ],
                            [
                                13.77836,
                                43.23436
                            ],
                            [
                                13.62387,
                                43.50102
                            ],
                            [
                                13.62767,
                                43.54608
                            ],
                            [
                                13.53073,
                                43.61983
                            ],
                            [
                                13.4813,
                                43.60713
                            ],
                            [
                                13.3003,
                                43.67223
                            ],
                            [
                                13.00058,
                                43.85704
                            ],
                            [
                                12.90685,
                                43.92317
                            ],
                            [
                                12.73787,
                                43.9681
                            ],
                            [
                                12.50373,
                                44.11558
                            ],
                            [
                                12.36255,
                                44.2592
                            ],
                            [
                                12.28227,
                                44.49572
                            ],
                            [
                                12.28317,
                                44.59556
                            ],
                            [
                                12.24042,
                                44.68737
                            ],
                            [
                                12.28522,
                                44.81635
                            ],
                            [
                                12.39196,
                                44.7862
                            ],
                            [
                                12.40409,
                                44.89352
                            ],
                            [
                                12.48548,
                                44.8961
                            ],
                            [
                                12.4942,
                                44.97035
                            ],
                            [
                                12.41056,
                                45.00887
                            ],
                            [
                                12.30215,
                                45.01453
                            ],
                            [
                                12.26858,
                                45.11061
                            ],
                            [
                                12.32923,
                                45.16796
                            ],
                            [
                                12.24638,
                                45.18484
                            ],
                            [
                                12.20728,
                                45.25679
                            ],
                            [
                                12.1294,
                                45.26422
                            ],
                            [
                                12.14161,
                                45.35628
                            ],
                            [
                                12.19365,
                                45.4125
                            ],
                            [
                                12.4159,
                                45.54445
                            ],
                            [
                                12.53798,
                                45.57531
                            ],
                            [
                                12.62224,
                                45.53682
                            ],
                            [
                                12.56964,
                                45.50039
                            ],
                            [
                                12.48759,
                                45.49904
                            ],
                            [
                                12.45538,
                                45.4396
                            ],
                            [
                                12.71959,
                                45.52506
                            ],
                            [
                                12.91989,
                                45.61337
                            ],
                            [
                                13.09603,
                                45.63584
                            ],
                            [
                                13.08682,
                                45.71906
                            ],
                            [
                                13.14467,
                                45.75132
                            ],
                            [
                                13.31293,
                                45.74844
                            ],
                            [
                                13.47597,
                                45.70412
                            ],
                            [
                                13.63077,
                                45.76952
                            ],
                            [
                                13.75057,
                                45.68215
                            ],
                            [
                                13.78412,
                                45.59955
                            ],
                            [
                                13.72282,
                                45.59473
                            ],
                            [
                                13.71911,
                                45.5436
                            ],
                            [
                                13.60218,
                                45.53637
                            ],
                            [
                                13.58553,
                                45.49768
                            ],
                            [
                                13.60136,
                                45.46792
                            ],
                            [
                                13.6513,
                                45.45405
                            ],
                            [
                                13.61147,
                                45.4632
                            ],
                            [
                                13.51019,
                                45.50446
                            ],
                            [
                                13.54125,
                                45.32905
                            ],
                            [
                                13.58894,
                                45.29793
                            ],
                            [
                                13.58867,
                                45.20301
                            ],
                            [
                                13.63594,
                                45.06996
                            ],
                            [
                                13.68818,
                                45.05009
                            ],
                            [
                                13.80166,
                                44.93014
                            ],
                            [
                                13.80041,
                                44.89299
                            ],
                            [
                                13.87546,
                                44.8076
                            ],
                            [
                                13.97877,
                                44.8419
                            ],
                            [
                                14.06529,
                                44.97516
                            ],
                            [
                                14.16874,
                                44.97979
                            ],
                            [
                                14.1577,
                                45.05889
                            ],
                            [
                                14.22379,
                                45.1383
                            ],
                            [
                                14.28202,
                                45.30545
                            ],
                            [
                                14.32641,
                                45.35458
                            ],
                            [
                                14.54855,
                                45.27798
                            ],
                            [
                                14.73921,
                                45.13956
                            ],
                            [
                                14.83176,
                                45.11485
                            ],
                            [
                                14.92715,
                                44.9525
                            ],
                            [
                                14.88478,
                                44.85727
                            ],
                            [
                                14.89779,
                                44.69536
                            ],
                            [
                                14.99086,
                                44.57358
                            ],
                            [
                                15.10713,
                                44.50582
                            ],
                            [
                                15.28001,
                                44.36499
                            ],
                            [
                                15.33013,
                                44.29202
                            ],
                            [
                                15.14117,
                                44.27835
                            ],
                            [
                                15.15795,
                                44.17954
                            ],
                            [
                                15.44411,
                                43.93338
                            ],
                            [
                                15.58944,
                                43.84914
                            ],
                            [
                                15.62555,
                                43.77539
                            ],
                            [
                                15.78156,
                                43.75762
                            ],
                            [
                                15.93616,
                                43.66881
                            ],
                            [
                                15.93466,
                                43.54627
                            ],
                            [
                                15.99589,
                                43.49958
                            ],
                            [
                                16.11251,
                                43.47136
                            ],
                            [
                                16.24257,
                                43.51562
                            ],
                            [
                                16.49688,
                                43.50197
                            ],
                            [
                                16.75165,
                                43.40782
                            ],
                            [
                                16.86914,
                                43.39764
                            ],
                            [
                                16.94703,
                                43.35798
                            ],
                            [
                                17.07844,
                                43.2336
                            ],
                            [
                                17.16611,
                                43.17815
                            ],
                            [
                                17.2597,
                                43.15062
                            ],
                            [
                                17.46772,
                                43.01153
                            ],
                            [
                                17.53641,
                                42.94192
                            ],
                            [
                                17.58134,
                                42.93842
                            ],
                            [
                                17.71095,
                                42.97308
                            ],
                            [
                                17.64027,
                                43.08967
                            ],
                            [
                                17.43067,
                                43.18033
                            ],
                            [
                                17.42159,
                                43.23007
                            ],
                            [
                                17.34191,
                                43.25392
                            ],
                            [
                                17.25154,
                                43.40224
                            ],
                            [
                                17.26744,
                                43.47911
                            ],
                            [
                                17.15213,
                                43.49487
                            ],
                            [
                                17.00961,
                                43.57513
                            ],
                            [
                                16.80065,
                                43.76273
                            ],
                            [
                                16.75159,
                                43.77136
                            ],
                            [
                                16.70889,
                                43.85573
                            ],
                            [
                                16.54976,
                                43.9552
                            ],
                            [
                                16.50224,
                                44.02437
                            ],
                            [
                                16.44215,
                                44.02879
                            ],
                            [
                                16.2111,
                                44.21784
                            ],
                            [
                                16.18827,
                                44.30586
                            ],
                            [
                                16.21759,
                                44.3488
                            ],
                            [
                                16.12957,
                                44.39518
                            ],
                            [
                                16.14046,
                                44.4796
                            ],
                            [
                                16.10914,
                                44.5256
                            ],
                            [
                                16.01997,
                                44.56369
                            ],
                            [
                                16.05464,
                                44.62326
                            ],
                            [
                                15.87821,
                                44.729
                            ],
                            [
                                15.78245,
                                44.74969
                            ],
                            [
                                15.72976,
                                44.8245
                            ],
                            [
                                15.76116,
                                44.8692
                            ],
                            [
                                15.74041,
                                44.93236
                            ],
                            [
                                15.78452,
                                44.99517
                            ],
                            [
                                15.75199,
                                45.05328
                            ],
                            [
                                15.79039,
                                45.11557
                            ],
                            [
                                15.76533,
                                45.16462
                            ],
                            [
                                15.84002,
                                45.22447
                            ],
                            [
                                16.02944,
                                45.19983
                            ],
                            [
                                16.10885,
                                45.09329
                            ],
                            [
                                16.19368,
                                45.0316
                            ],
                            [
                                16.28903,
                                44.99654
                            ],
                            [
                                16.35303,
                                45.00302
                            ],
                            [
                                16.39468,
                                45.11215
                            ],
                            [
                                16.47823,
                                45.16167
                            ],
                            [
                                16.49162,
                                45.208
                            ],
                            [
                                16.59828,
                                45.23107
                            ],
                            [
                                16.79863,
                                45.18674
                            ],
                            [
                                16.93253,
                                45.27516
                            ],
                            [
                                16.98433,
                                45.22938
                            ],
                            [
                                17.16432,
                                45.15164
                            ],
                            [
                                17.3395,
                                45.14477
                            ],
                            [
                                17.59274,
                                45.10693
                            ],
                            [
                                17.67581,
                                45.13138
                            ],
                            [
                                17.83395,
                                45.04812
                            ],
                            [
                                17.93573,
                                45.08125
                            ],
                            [
                                17.98645,
                                45.14438
                            ],
                            [
                                18.05983,
                                45.14336
                            ],
                            [
                                18.11832,
                                45.08076
                            ],
                            [
                                18.1935,
                                45.07803
                            ],
                            [
                                18.23625,
                                45.13603
                            ],
                            [
                                18.32088,
                                45.10186
                            ],
                            [
                                18.41767,
                                45.10964
                            ],
                            [
                                18.47766,
                                45.06231
                            ],
                            [
                                18.58532,
                                45.09199
                            ],
                            [
                                18.71743,
                                45.03527
                            ],
                            [
                                18.80379,
                                44.93927
                            ],
                            [
                                18.76544,
                                44.90432
                            ],
                            [
                                18.8502,
                                44.85456
                            ],
                            [
                                19.02207,
                                44.85535
                            ],
                            [
                                18.98989,
                                44.90611
                            ],
                            [
                                19.14216,
                                44.94088
                            ],
                            [
                                19.09187,
                                44.99497
                            ],
                            [
                                19.14341,
                                45.13108
                            ],
                            [
                                19.23776,
                                45.17601
                            ],
                            [
                                19.41769,
                                45.16624
                            ],
                            [
                                19.42013,
                                45.23318
                            ],
                            [
                                19.26204,
                                45.24232
                            ],
                            [
                                19.11122,
                                45.29466
                            ],
                            [
                                19.09169,
                                45.33511
                            ],
                            [
                                19.00221,
                                45.35862
                            ],
                            [
                                18.99207,
                                45.48039
                            ],
                            [
                                19.09478,
                                45.51951
                            ],
                            [
                                18.9269,
                                45.54408
                            ],
                            [
                                18.92848,
                                45.68941
                            ],
                            [
                                18.97665,
                                45.73908
                            ],
                            [
                                18.85679,
                                45.86003
                            ],
                            [
                                18.88973,
                                45.92118
                            ],
                            [
                                18.98695,
                                45.93172
                            ],
                            [
                                19.10458,
                                46.03998
                            ],
                            [
                                19.14773,
                                45.9961
                            ],
                            [
                                19.28534,
                                45.99676
                            ],
                            [
                                19.36417,
                                46.05216
                            ],
                            [
                                19.41475,
                                46.04585
                            ],
                            [
                                19.50354,
                                46.14177
                            ],
                            [
                                19.56694,
                                46.17825
                            ],
                            [
                                19.6981,
                                46.18793
                            ],
                            [
                                19.81723,
                                46.12854
                            ],
                            [
                                19.93704,
                                46.17621
                            ],
                            [
                                20.06374,
                                46.14366
                            ],
                            [
                                20.18215,
                                46.15931
                            ],
                            [
                                20.2643,
                                46.12637
                            ],
                            [
                                20.34588,
                                46.04742
                            ],
                            [
                                20.34974,
                                45.99894
                            ],
                            [
                                20.48291,
                                45.95284
                            ],
                            [
                                20.51556,
                                45.89296
                            ],
                            [
                                20.65864,
                                45.83037
                            ],
                            [
                                20.70073,
                                45.75131
                            ],
                            [
                                20.80289,
                                45.73784
                            ],
                            [
                                20.80499,
                                45.65723
                            ],
                            [
                                20.76573,
                                45.61257
                            ],
                            [
                                20.83163,
                                45.53637
                            ],
                            [
                                20.83412,
                                45.4793
                            ],
                            [
                                20.95836,
                                45.36846
                            ],
                            [
                                21.09716,
                                45.29668
                            ],
                            [
                                21.18002,
                                45.31258
                            ],
                            [
                                21.21899,
                                45.25058
                            ],
                            [
                                21.4044,
                                45.22839
                            ],
                            [
                                21.5156,
                                45.1699
                            ],
                            [
                                21.45461,
                                45.04037
                            ],
                            [
                                21.36023,
                                45.02043
                            ],
                            [
                                21.43594,
                                44.96178
                            ],
                            [
                                21.54668,
                                44.93052
                            ],
                            [
                                21.55945,
                                44.88947
                            ],
                            [
                                21.37034,
                                44.866
                            ],
                            [
                                21.39832,
                                44.77851
                            ],
                            [
                                21.58779,
                                44.75842
                            ],
                            [
                                21.63827,
                                44.65971
                            ],
                            [
                                21.79175,
                                44.66371
                            ],
                            [
                                21.99785,
                                44.62913
                            ],
                            [
                                22.03653,
                                44.54303
                            ],
                            [
                                22.1277,
                                44.47436
                            ],
                            [
                                22.18243,
                                44.48239
                            ],
                            [
                                22.27544,
                                44.62631
                            ],
                            [
                                22.3325,
                                44.6754
                            ],
                            [
                                22.48297,
                                44.70814
                            ],
                            [
                                22.62075,
                                44.61521
                            ],
                            [
                                22.66842,
                                44.61868
                            ],
                            [
                                22.75787,
                                44.56055
                            ],
                            [
                                22.6986,
                                44.51699
                            ],
                            [
                                22.61784,
                                44.55218
                            ],
                            [
                                22.54935,
                                44.48215
                            ],
                            [
                                22.45787,
                                44.46642
                            ],
                            [
                                22.5593,
                                44.30881
                            ],
                            [
                                22.6826,
                                44.2744
                            ],
                            [
                                22.67516,
                                44.21566
                            ],
                            [
                                22.61427,
                                44.165
                            ],
                            [
                                22.62121,
                                44.06338
                            ],
                            [
                                22.53106,
                                44.02083
                            ],
                            [
                                22.41103,
                                44.0047
                            ],
                            [
                                22.40847,
                                43.94116
                            ],
                            [
                                22.3575,
                                43.81003
                            ],
                            [
                                22.40784,
                                43.69597
                            ],
                            [
                                22.4787,
                                43.65602
                            ],
                            [
                                22.48817,
                                43.56743
                            ],
                            [
                                22.5349,
                                43.47127
                            ],
                            [
                                22.68034,
                                43.39447
                            ],
                            [
                                22.76843,
                                43.37533
                            ],
                            [
                                22.82621,
                                43.3304
                            ],
                            [
                                22.89768,
                                43.22652
                            ],
                            [
                                22.98371,
                                43.20193
                            ],
                            [
                                22.98264,
                                43.11165
                            ],
                            [
                                22.89704,
                                43.03563
                            ],
                            [
                                22.78545,
                                42.98139
                            ],
                            [
                                22.74431,
                                42.88658
                            ],
                            [
                                22.67518,
                                42.86678
                            ],
                            [
                                22.6172,
                                42.8957
                            ],
                            [
                                22.53745,
                                42.88128
                            ],
                            [
                                22.44091,
                                42.80688
                            ],
                            [
                                22.50092,
                                42.73918
                            ],
                            [
                                22.47642,
                                42.71056
                            ],
                            [
                                22.43914,
                                42.56646
                            ],
                            [
                                22.54632,
                                42.50821
                            ],
                            [
                                22.51809,
                                42.39666
                            ],
                            [
                                22.45553,
                                42.33366
                            ],
                            [
                                22.36021,
                                42.31116
                            ],
                            [
                                22.50086,
                                42.19621
                            ],
                            [
                                22.5288,
                                42.13993
                            ],
                            [
                                22.67777,
                                42.06437
                            ],
                            [
                                22.86721,
                                42.0222
                            ],
                            [
                                22.87345,
                                41.9361
                            ],
                            [
                                22.96867,
                                41.77099
                            ],
                            [
                                23.03412,
                                41.70944
                            ],
                            [
                                22.94931,
                                41.59866
                            ],
                            [
                                22.97257,
                                41.56086
                            ],
                            [
                                22.92759,
                                41.33854
                            ],
                            [
                                22.76867,
                                41.32523
                            ],
                            [
                                22.74686,
                                41.16298
                            ],
                            [
                                22.66647,
                                41.18634
                            ],
                            [
                                22.61767,
                                41.13392
                            ],
                            [
                                22.46525,
                                41.11743
                            ],
                            [
                                22.3265,
                                41.12337
                            ],
                            [
                                22.21622,
                                41.17046
                            ],
                            [
                                22.12906,
                                41.12335
                            ],
                            [
                                22.07839,
                                41.15301
                            ],
                            [
                                21.9089,
                                41.09085
                            ],
                            [
                                21.91178,
                                41.04942
                            ],
                            [
                                21.79982,
                                40.97543
                            ],
                            [
                                21.75645,
                                40.92566
                            ],
                            [
                                21.68449,
                                40.94028
                            ],
                            [
                                21.56701,
                                40.86698
                            ],
                            [
                                21.53137,
                                40.90751
                            ],
                            [
                                21.41725,
                                40.9177
                            ],
                            [
                                21.36295,
                                40.8796
                            ],
                            [
                                21.25947,
                                40.8595
                            ],
                            [
                                20.9802,
                                40.85566
                            ],
                            [
                                20.96026,
                                40.77087
                            ],
                            [
                                21.05673,
                                40.6675
                            ],
                            [
                                21.04158,
                                40.55823
                            ],
                            [
                                20.95378,
                                40.46897
                            ],
                            [
                                20.84495,
                                40.47938
                            ],
                            [
                                20.78584,
                                40.42467
                            ],
                            [
                                20.79029,
                                40.36348
                            ],
                            [
                                20.71414,
                                40.28276
                            ],
                            [
                                20.72411,
                                40.22355
                            ],
                            [
                                20.67861,
                                40.1888
                            ],
                            [
                                20.6778,
                                40.09705
                            ],
                            [
                                20.55092,
                                40.06383
                            ],
                            [
                                20.44901,
                                40.07288
                            ],
                            [
                                20.39246,
                                39.99593
                            ],
                            [
                                20.313,
                                39.99022
                            ],
                            [
                                20.33951,
                                39.92327
                            ],
                            [
                                20.41635,
                                39.84071
                            ],
                            [
                                20.39131,
                                39.78848
                            ],
                            [
                                20.30561,
                                39.81558
                            ],
                            [
                                20.32045,
                                39.72848
                            ],
                            [
                                20.19362,
                                39.64495
                            ],
                            [
                                20.00881,
                                39.69129
                            ],
                            [
                                20.18181,
                                39.62476
                            ],
                            [
                                20.16124,
                                39.55403
                            ],
                            [
                                20.26045,
                                39.50947
                            ],
                            [
                                20.21777,
                                39.44403
                            ],
                            [
                                20.34125,
                                39.28393
                            ],
                            [
                                20.47079,
                                39.26264
                            ],
                            [
                                20.47564,
                                39.2178
                            ],
                            [
                                20.70407,
                                39.04934
                            ],
                            [
                                20.79049,
                                39.07501
                            ],
                            [
                                21.04353,
                                39.00339
                            ],
                            [
                                21.08329,
                                39.05144
                            ],
                            [
                                21.16052,
                                38.98685
                            ],
                            [
                                21.13881,
                                38.89221
                            ],
                            [
                                21.02225,
                                38.89719
                            ],
                            [
                                20.97799,
                                38.944
                            ],
                            [
                                20.89166,
                                38.92154
                            ],
                            [
                                20.74877,
                                38.92522
                            ],
                            [
                                20.73196,
                                38.85022
                            ],
                            [
                                20.76418,
                                38.76078
                            ],
                            [
                                20.87101,
                                38.79309
                            ],
                            [
                                20.91916,
                                38.67172
                            ],
                            [
                                20.98773,
                                38.66825
                            ],
                            [
                                21.02204,
                                38.60577
                            ],
                            [
                                21.01088,
                                38.53327
                            ],
                            [
                                21.10864,
                                38.45147
                            ],
                            [
                                21.10459,
                                38.36088
                            ],
                            [
                                21.16966,
                                38.29996
                            ],
                            [
                                21.26444,
                                38.34113
                            ],
                            [
                                21.36273,
                                38.411
                            ],
                            [
                                21.41046,
                                38.36419
                            ],
                            [
                                21.48153,
                                38.35159
                            ],
                            [
                                21.50795,
                                38.29956
                            ],
                            [
                                21.64005,
                                38.35679
                            ],
                            [
                                21.76611,
                                38.32877
                            ],
                            [
                                21.83239,
                                38.39204
                            ],
                            [
                                21.93613,
                                38.40592
                            ],
                            [
                                22.0511,
                                38.39435
                            ],
                            [
                                22.19417,
                                38.33807
                            ],
                            [
                                22.3919,
                                38.34716
                            ],
                            [
                                22.45567,
                                38.42541
                            ],
                            [
                                22.53409,
                                38.34693
                            ],
                            [
                                22.67855,
                                38.37318
                            ],
                            [
                                22.68522,
                                38.32547
                            ],
                            [
                                22.8863,
                                38.23022
                            ],
                            [
                                22.9146,
                                38.19296
                            ],
                            [
                                23.0244,
                                38.21282
                            ],
                            [
                                23.10721,
                                38.20518
                            ],
                            [
                                23.22079,
                                38.15676
                            ],
                            [
                                23.21442,
                                38.10029
                            ],
                            [
                                23.0555,
                                38.05259
                            ],
                            [
                                22.95494,
                                38.07892
                            ],
                            [
                                22.8875,
                                38.05211
                            ],
                            [
                                22.97399,
                                37.97072
                            ],
                            [
                                22.89933,
                                37.93235
                            ],
                            [
                                22.7922,
                                37.97101
                            ],
                            [
                                22.72454,
                                38.03659
                            ],
                            [
                                22.49162,
                                38.13529
                            ],
                            [
                                22.41315,
                                38.13119
                            ],
                            [
                                22.33516,
                                38.17608
                            ],
                            [
                                22.21488,
                                38.18153
                            ],
                            [
                                22.07832,
                                38.25521
                            ],
                            [
                                22.01166,
                                38.3126
                            ],
                            [
                                21.94763,
                                38.32789
                            ],
                            [
                                21.7806,
                                38.31168
                            ],
                            [
                                21.67075,
                                38.16765
                            ],
                            [
                                21.60522,
                                38.14289
                            ],
                            [
                                21.452,
                                38.19883
                            ],
                            [
                                21.36422,
                                38.18032
                            ],
                            [
                                21.368,
                                38.1308
                            ],
                            [
                                21.30388,
                                38.02678
                            ],
                            [
                                21.19643,
                                37.93489
                            ],
                            [
                                21.12713,
                                37.93826
                            ],
                            [
                                21.11742,
                                37.83969
                            ],
                            [
                                21.25924,
                                37.79549
                            ],
                            [
                                21.30285,
                                37.75857
                            ],
                            [
                                21.30309,
                                37.66844
                            ],
                            [
                                21.37752,
                                37.65757
                            ],
                            [
                                21.5526,
                                37.55234
                            ],
                            [
                                21.66048,
                                37.41921
                            ],
                            [
                                21.69815,
                                37.31282
                            ],
                            [
                                21.66973,
                                37.25843
                            ],
                            [
                                21.56619,
                                37.16397
                            ],
                            [
                                21.57507,
                                37.05885
                            ],
                            [
                                21.63835,
                                37.00634
                            ],
                            [
                                21.70385,
                                36.81398
                            ],
                            [
                                21.8092,
                                36.80659
                            ],
                            [
                                21.87684,
                                36.72097
                            ],
                            [
                                21.93169,
                                36.75829
                            ],
                            [
                                21.9219,
                                36.86577
                            ],
                            [
                                21.93727,
                                36.98746
                            ],
                            [
                                22.02053,
                                37.02179
                            ],
                            [
                                22.14713,
                                37.01896
                            ],
                            [
                                22.16979,
                                36.89065
                            ],
                            [
                                22.22884,
                                36.89098
                            ],
                            [
                                22.29488,
                                36.81442
                            ],
                            [
                                22.36271,
                                36.66636
                            ],
                            [
                                22.38806,
                                36.54248
                            ],
                            [
                                22.37215,
                                36.47665
                            ],
                            [
                                22.50086,
                                36.44405
                            ],
                            [
                                22.47355,
                                36.5286
                            ],
                            [
                                22.47627,
                                36.60967
                            ],
                            [
                                22.5237,
                                36.62928
                            ],
                            [
                                22.52356,
                                36.7054
                            ],
                            [
                                22.56447,
                                36.77081
                            ],
                            [
                                22.62253,
                                36.80557
                            ],
                            [
                                22.78133,
                                36.79899
                            ],
                            [
                                22.81997,
                                36.71364
                            ],
                            [
                                22.94403,
                                36.57181
                            ],
                            [
                                22.96863,
                                36.52228
                            ],
                            [
                                23.03893,
                                36.5237
                            ],
                            [
                                23.08398,
                                36.44484
                            ],
                            [
                                23.13086,
                                36.5025
                            ],
                            [
                                23.12596,
                                36.55901
                            ],
                            [
                                23.03265,
                                36.62835
                            ],
                            [
                                23.02611,
                                36.7265
                            ],
                            [
                                23.10113,
                                36.76613
                            ],
                            [
                                23.01326,
                                36.93602
                            ],
                            [
                                22.95662,
                                37.11507
                            ],
                            [
                                22.83934,
                                37.27987
                            ],
                            [
                                22.72789,
                                37.48671
                            ],
                            [
                                22.71763,
                                37.55949
                            ],
                            [
                                22.76984,
                                37.58979
                            ],
                            [
                                22.85099,
                                37.51441
                            ],
                            [
                                22.97951,
                                37.51378
                            ],
                            [
                                23.00473,
                                37.46296
                            ],
                            [
                                23.11972,
                                37.44946
                            ],
                            [
                                23.10596,
                                37.35073
                            ],
                            [
                                23.1468,
                                37.29787
                            ],
                            [
                                23.25112,
                                37.38393
                            ],
                            [
                                23.33627,
                                37.4129
                            ],
                            [
                                23.49722,
                                37.42312
                            ],
                            [
                                23.51818,
                                37.45549
                            ],
                            [
                                23.37005,
                                37.55485
                            ],
                            [
                                23.31808,
                                37.53365
                            ],
                            [
                                23.15657,
                                37.62274
                            ],
                            [
                                23.17149,
                                37.70067
                            ],
                            [
                                23.12695,
                                37.73424
                            ],
                            [
                                23.17839,
                                37.80094
                            ],
                            [
                                23.11174,
                                37.84771
                            ],
                            [
                                23.01353,
                                37.84413
                            ],
                            [
                                23.01575,
                                37.89998
                            ],
                            [
                                23.13464,
                                37.92078
                            ],
                            [
                                23.27397,
                                37.97757
                            ],
                            [
                                23.38872,
                                37.97412
                            ],
                            [
                                23.45256,
                                38.0233
                            ],
                            [
                                23.56724,
                                38.04598
                            ],
                            [
                                23.55277,
                                37.97963
                            ],
                            [
                                23.63565,
                                37.92708
                            ],
                            [
                                23.67223,
                                37.94182
                            ],
                            [
                                23.76921,
                                37.83298
                            ],
                            [
                                23.8989,
                                37.7727
                            ],
                            [
                                23.94032,
                                37.67383
                            ],
                            [
                                24.02721,
                                37.65069
                            ],
                            [
                                24.07078,
                                37.68542
                            ],
                            [
                                24.08478,
                                37.77936
                            ],
                            [
                                24.04703,
                                37.82141
                            ],
                            [
                                24.04562,
                                37.90247
                            ],
                            [
                                24.00702,
                                37.96746
                            ],
                            [
                                23.98739,
                                38.11445
                            ],
                            [
                                24.05644,
                                38.14173
                            ],
                            [
                                24.04992,
                                38.20807
                            ],
                            [
                                23.95664,
                                38.28284
                            ],
                            [
                                23.77012,
                                38.33805
                            ],
                            [
                                23.67756,
                                38.34008
                            ],
                            [
                                23.67568,
                                38.41065
                            ],
                            [
                                23.89446,
                                38.38441
                            ],
                            [
                                24.04988,
                                38.39339
                            ],
                            [
                                24.11257,
                                38.25253
                            ],
                            [
                                24.20646,
                                38.18031
                            ],
                            [
                                24.21005,
                                38.09059
                            ],
                            [
                                24.30741,
                                38.06867
                            ],
                            [
                                24.33941,
                                37.98789
                            ],
                            [
                                24.44958,
                                38.00489
                            ],
                            [
                                24.50024,
                                37.94908
                            ],
                            [
                                24.55624,
                                37.97971
                            ],
                            [
                                24.58693,
                                38.06711
                            ],
                            [
                                24.55485,
                                38.14172
                            ],
                            [
                                24.42545,
                                38.1462
                            ],
                            [
                                24.27248,
                                38.19912
                            ],
                            [
                                24.25677,
                                38.28048
                            ],
                            [
                                24.18397,
                                38.39462
                            ],
                            [
                                24.18814,
                                38.48597
                            ],
                            [
                                24.22009,
                                38.52953
                            ],
                            [
                                24.12373,
                                38.59578
                            ],
                            [
                                24.12283,
                                38.66671
                            ],
                            [
                                24.04388,
                                38.68586
                            ],
                            [
                                23.95517,
                                38.66111
                            ],
                            [
                                23.75623,
                                38.70605
                            ],
                            [
                                23.68367,
                                38.75424
                            ],
                            [
                                23.5921,
                                38.76575
                            ],
                            [
                                23.47043,
                                38.83582
                            ],
                            [
                                23.37607,
                                39.00688
                            ],
                            [
                                23.27934,
                                39.03782
                            ],
                            [
                                23.20538,
                                39.00498
                            ],
                            [
                                23.13121,
                                39.00786
                            ],
                            [
                                23.08736,
                                38.94854
                            ],
                            [
                                22.85057,
                                38.86988
                            ],
                            [
                                22.94154,
                                38.83451
                            ],
                            [
                                23.03157,
                                38.88119
                            ],
                            [
                                23.13401,
                                38.85202
                            ],
                            [
                                23.32223,
                                38.76188
                            ],
                            [
                                23.38656,
                                38.69838
                            ],
                            [
                                23.49012,
                                38.63425
                            ],
                            [
                                23.51148,
                                38.58748
                            ],
                            [
                                23.59567,
                                38.57296
                            ],
                            [
                                23.63402,
                                38.50792
                            ],
                            [
                                23.59003,
                                38.47358
                            ],
                            [
                                23.36854,
                                38.50986
                            ],
                            [
                                23.30713,
                                38.5875
                            ],
                            [
                                23.32185,
                                38.63643
                            ],
                            [
                                23.16713,
                                38.64305
                            ],
                            [
                                23.10665,
                                38.62617
                            ],
                            [
                                23.03665,
                                38.75264
                            ],
                            [
                                22.96914,
                                38.74582
                            ],
                            [
                                22.89922,
                                38.77675
                            ],
                            [
                                22.77895,
                                38.77832
                            ],
                            [
                                22.6854,
                                38.8417
                            ],
                            [
                                22.6073,
                                38.82226
                            ],
                            [
                                22.5483,
                                38.87751
                            ],
                            [
                                22.61732,
                                38.9113
                            ],
                            [
                                22.75525,
                                38.87054
                            ],
                            [
                                22.99101,
                                38.94705
                            ],
                            [
                                23.02901,
                                39.0157
                            ],
                            [
                                22.91143,
                                39.15777
                            ],
                            [
                                22.83272,
                                39.18766
                            ],
                            [
                                22.82215,
                                39.27683
                            ],
                            [
                                22.9359,
                                39.29526
                            ],
                            [
                                22.94305,
                                39.34279
                            ],
                            [
                                23.11864,
                                39.30525
                            ],
                            [
                                23.17973,
                                39.24994
                            ],
                            [
                                23.21331,
                                39.14934
                            ],
                            [
                                23.30349,
                                39.14113
                            ],
                            [
                                23.35007,
                                39.18859
                            ],
                            [
                                23.27295,
                                39.31602
                            ],
                            [
                                23.20754,
                                39.3643
                            ],
                            [
                                23.09568,
                                39.49845
                            ],
                            [
                                22.93653,
                                39.57442
                            ],
                            [
                                22.90376,
                                39.6269
                            ],
                            [
                                22.8514,
                                39.79986
                            ],
                            [
                                22.73592,
                                39.86996
                            ],
                            [
                                22.70871,
                                39.95235
                            ],
                            [
                                22.59572,
                                40.01138
                            ],
                            [
                                22.54808,
                                40.14593
                            ],
                            [
                                22.60012,
                                40.27205
                            ],
                            [
                                22.65897,
                                40.35463
                            ],
                            [
                                22.59456,
                                40.47261
                            ],
                            [
                                22.65375,
                                40.5182
                            ],
                            [
                                22.73524,
                                40.51011
                            ],
                            [
                                22.74432,
                                40.55818
                            ],
                            [
                                22.85448,
                                40.59372
                            ],
                            [
                                22.90021,
                                40.64406
                            ],
                            [
                                22.97918,
                                40.5415
                            ],
                            [
                                22.91285,
                                40.50617
                            ],
                            [
                                22.82622,
                                40.50667
                            ],
                            [
                                22.90206,
                                40.39784
                            ],
                            [
                                22.98598,
                                40.36637
                            ],
                            [
                                23.0224,
                                40.32345
                            ],
                            [
                                23.14183,
                                40.27481
                            ],
                            [
                                23.29118,
                                40.23675
                            ],
                            [
                                23.32622,
                                40.18401
                            ],
                            [
                                23.30958,
                                40.08397
                            ],
                            [
                                23.38101,
                                40.0015
                            ],
                            [
                                23.59591,
                                39.9211
                            ],
                            [
                                23.68484,
                                39.91697
                            ],
                            [
                                23.67844,
                                39.97194
                            ],
                            [
                                23.49291,
                                40.0349
                            ],
                            [
                                23.331,
                                40.2054
                            ],
                            [
                                23.3892,
                                40.27419
                            ],
                            [
                                23.52876,
                                40.23778
                            ],
                            [
                                23.6555,
                                40.22197
                            ],
                            [
                                23.77085,
                                40.11769
                            ],
                            [
                                23.78877,
                                40.06333
                            ],
                            [
                                23.90146,
                                39.98195
                            ],
                            [
                                23.98993,
                                39.95185
                            ],
                            [
                                24.0153,
                                40.03592
                            ],
                            [
                                23.99175,
                                40.1118
                            ],
                            [
                                23.91194,
                                40.15705
                            ],
                            [
                                23.7772,
                                40.19346
                            ],
                            [
                                23.69728,
                                40.28544
                            ],
                            [
                                23.7366,
                                40.35357
                            ],
                            [
                                23.91943,
                                40.36467
                            ],
                            [
                                24.04369,
                                40.29335
                            ],
                            [
                                24.15801,
                                40.28208
                            ],
                            [
                                24.28037,
                                40.16141
                            ],
                            [
                                24.30339,
                                40.1145
                            ],
                            [
                                24.39926,
                                40.14038
                            ],
                            [
                                24.37044,
                                40.19501
                            ],
                            [
                                24.2865,
                                40.24668
                            ],
                            [
                                24.19243,
                                40.34011
                            ],
                            [
                                24.01099,
                                40.38943
                            ],
                            [
                                23.88936,
                                40.39538
                            ],
                            [
                                23.82089,
                                40.48154
                            ],
                            [
                                23.83252,
                                40.55821
                            ],
                            [
                                23.69624,
                                40.69099
                            ],
                            [
                                23.73927,
                                40.75564
                            ],
                            [
                                23.83381,
                                40.78366
                            ],
                            [
                                24.04425,
                                40.71917
                            ],
                            [
                                24.13652,
                                40.73602
                            ],
                            [
                                24.31505,
                                40.82452
                            ],
                            [
                                24.3207,
                                40.88246
                            ],
                            [
                                24.39517,
                                40.93351
                            ],
                            [
                                24.54892,
                                40.95422
                            ],
                            [
                                24.62796,
                                40.85914
                            ],
                            [
                                24.79873,
                                40.846
                            ],
                            [
                                24.87159,
                                40.90507
                            ],
                            [
                                24.98666,
                                40.93122
                            ],
                            [
                                25.06816,
                                41.004
                            ],
                            [
                                25.13062,
                                40.95583
                            ],
                            [
                                25.37837,
                                40.91148
                            ],
                            [
                                25.56177,
                                40.85773
                            ],
                            [
                                25.9514,
                                40.84079
                            ],
                            [
                                26.02049,
                                40.79447
                            ],
                            [
                                26.03276,
                                40.73026
                            ],
                            [
                                26.12338,
                                40.74477
                            ],
                            [
                                26.20935,
                                40.86042
                            ],
                            [
                                26.35526,
                                40.9479
                            ],
                            [
                                26.36378,
                                41.01038
                            ],
                            [
                                26.31366,
                                41.07568
                            ],
                            [
                                26.31106,
                                41.18049
                            ],
                            [
                                26.33328,
                                41.25837
                            ],
                            [
                                26.40633,
                                41.25517
                            ],
                            [
                                26.53209,
                                41.34195
                            ],
                            [
                                26.62845,
                                41.34644
                            ],
                            [
                                26.59236,
                                41.52985
                            ],
                            [
                                26.59979,
                                41.59728
                            ],
                            [
                                26.44349,
                                41.68575
                            ],
                            [
                                26.35788,
                                41.7111
                            ],
                            [
                                26.32843,
                                41.73698
                            ],
                            [
                                26.36906,
                                41.82068
                            ],
                            [
                                26.53861,
                                41.82348
                            ],
                            [
                                26.6176,
                                41.96533
                            ],
                            [
                                26.75382,
                                41.95843
                            ],
                            [
                                26.78741,
                                41.9896
                            ],
                            [
                                26.96411,
                                41.99707
                            ],
                            [
                                27.06709,
                                42.09318
                            ],
                            [
                                27.15962,
                                42.06566
                            ],
                            [
                                27.27067,
                                42.10432
                            ],
                            [
                                27.37642,
                                42.04614
                            ],
                            [
                                27.44835,
                                41.96724
                            ],
                            [
                                27.57497,
                                41.93682
                            ],
                            [
                                27.70215,
                                41.9766
                            ],
                            [
                                27.83516,
                                41.95035
                            ],
                            [
                                28.03551,
                                41.98308
                            ],
                            [
                                27.94685,
                                42.10317
                            ],
                            [
                                27.75661,
                                42.2455
                            ],
                            [
                                27.7121,
                                42.4071
                            ],
                            [
                                27.64868,
                                42.45007
                            ],
                            [
                                27.5133,
                                42.42915
                            ],
                            [
                                27.45365,
                                42.48491
                            ],
                            [
                                27.52711,
                                42.55894
                            ],
                            [
                                27.63359,
                                42.57825
                            ],
                            [
                                27.64662,
                                42.63852
                            ],
                            [
                                27.72156,
                                42.65687
                            ],
                            [
                                27.72214,
                                42.70229
                            ],
                            [
                                27.89907,
                                42.70025
                            ],
                            [
                                27.88262,
                                42.83841
                            ],
                            [
                                27.9068,
                                42.92957
                            ],
                            [
                                27.89002,
                                43.04213
                            ],
                            [
                                27.94658,
                                43.1675
                            ],
                            [
                                28.01383,
                                43.22759
                            ],
                            [
                                28.09268,
                                43.37632
                            ],
                            [
                                28.15078,
                                43.40473
                            ],
                            [
                                28.30944,
                                43.41797
                            ],
                            [
                                28.47096,
                                43.38279
                            ],
                            [
                                28.5295,
                                43.42354
                            ],
                            [
                                28.60746,
                                43.53937
                            ],
                            [
                                28.5679,
                                43.60175
                            ],
                            [
                                28.57888,
                                43.73874
                            ],
                            [
                                28.57753,
                                43.79672
                            ],
                            [
                                28.66723,
                                43.98738
                            ],
                            [
                                28.64186,
                                44.05519
                            ],
                            [
                                28.65704,
                                44.19953
                            ],
                            [
                                28.62205,
                                44.27257
                            ],
                            [
                                28.63811,
                                44.32184
                            ],
                            [
                                28.86741,
                                44.52351
                            ],
                            [
                                28.93837,
                                44.62251
                            ],
                            [
                                29.10634,
                                44.75966
                            ],
                            [
                                29.24537,
                                44.79678
                            ],
                            [
                                29.5529,
                                44.82392
                            ],
                            [
                                29.62196,
                                44.8849
                            ],
                            [
                                29.65352,
                                45.09621
                            ],
                            [
                                29.70747,
                                45.16656
                            ],
                            [
                                29.67964,
                                45.21184
                            ],
                            [
                                29.6549,
                                45.33589
                            ],
                            [
                                29.55278,
                                45.40695
                            ],
                            [
                                29.42641,
                                45.442
                            ],
                            [
                                29.28227,
                                45.42701
                            ],
                            [
                                28.96416,
                                45.32947
                            ],
                            [
                                28.93392,
                                45.28081
                            ],
                            [
                                28.84207,
                                45.31878
                            ],
                            [
                                28.75084,
                                45.28186
                            ],
                            [
                                28.70008,
                                45.2254
                            ],
                            [
                                28.56838,
                                45.24799
                            ],
                            [
                                28.34494,
                                45.32255
                            ],
                            [
                                28.26195,
                                45.45492
                            ],
                            [
                                28.21136,
                                45.46728
                            ],
                            [
                                28.16514,
                                45.54254
                            ],
                            [
                                28.09343,
                                45.59767
                            ],
                            [
                                28.17305,
                                45.64703
                            ],
                            [
                                28.16629,
                                45.73585
                            ],
                            [
                                28.11195,
                                45.82133
                            ],
                            [
                                28.13144,
                                45.87552
                            ],
                            [
                                28.08707,
                                46.00791
                            ],
                            [
                                28.1415,
                                46.19035
                            ],
                            [
                                28.11142,
                                46.23182
                            ],
                            [
                                28.20674,
                                46.31799
                            ],
                            [
                                28.1932,
                                46.35612
                            ],
                            [
                                28.26003,
                                46.4375
                            ],
                            [
                                28.22275,
                                46.51216
                            ],
                            [
                                28.25115,
                                46.61188
                            ],
                            [
                                28.17524,
                                46.77778
                            ],
                            [
                                28.11546,
                                46.82134
                            ],
                            [
                                28.11143,
                                46.92011
                            ],
                            [
                                28.0807,
                                46.98997
                            ],
                            [
                                27.89756,
                                47.07378
                            ],
                            [
                                27.79569,
                                47.14872
                            ],
                            [
                                27.8014,
                                47.18889
                            ],
                            [
                                27.72849,
                                47.29445
                            ],
                            [
                                27.60067,
                                47.32931
                            ],
                            [
                                27.55818,
                                47.44647
                            ],
                            [
                                27.47337,
                                47.48684
                            ],
                            [
                                27.40291,
                                47.58332
                            ],
                            [
                                27.31659,
                                47.64151
                            ],
                            [
                                27.26669,
                                47.71179
                            ],
                            [
                                27.2782,
                                47.76367
                            ],
                            [
                                27.21433,
                                47.82285
                            ],
                            [
                                27.17814,
                                47.94693
                            ],
                            [
                                27.03977,
                                48.10736
                            ],
                            [
                                26.93922,
                                48.1977
                            ],
                            [
                                26.80742,
                                48.25446
                            ],
                            [
                                26.63056,
                                48.25975
                            ],
                            [
                                26.53025,
                                48.21032
                            ],
                            [
                                26.47193,
                                48.21944
                            ],
                            [
                                26.33883,
                                48.18322
                            ],
                            [
                                26.19002,
                                47.99756
                            ],
                            [
                                25.86123,
                                47.9699
                            ],
                            [
                                25.77463,
                                47.93937
                            ],
                            [
                                25.59327,
                                47.93881
                            ],
                            [
                                25.31089,
                                47.91432
                            ],
                            [
                                25.22158,
                                47.85919
                            ],
                            [
                                25.11498,
                                47.75512
                            ],
                            [
                                25.03908,
                                47.72593
                            ],
                            [
                                24.88314,
                                47.72435
                            ],
                            [
                                24.82719,
                                47.82
                            ],
                            [
                                24.67089,
                                47.86528
                            ],
                            [
                                24.62275,
                                47.9514
                            ],
                            [
                                24.43414,
                                47.96971
                            ],
                            [
                                24.38029,
                                47.92646
                            ],
                            [
                                24.21928,
                                47.89797
                            ],
                            [
                                24.1097,
                                47.91657
                            ],
                            [
                                24.00891,
                                47.96683
                            ],
                            [
                                23.84459,
                                47.94173
                            ],
                            [
                                23.77079,
                                47.99467
                            ],
                            [
                                23.66833,
                                47.98421
                            ],
                            [
                                23.54213,
                                48.00942
                            ],
                            [
                                23.49361,
                                47.96781
                            ],
                            [
                                23.33963,
                                48.01879
                            ],
                            [
                                23.24602,
                                48.09262
                            ],
                            [
                                23.14647,
                                48.10057
                            ],
                            [
                                23.08969,
                                48.00545
                            ],
                            [
                                22.99423,
                                48.00236
                            ],
                            [
                                22.89627,
                                47.95412
                            ],
                            [
                                22.8379,
                                47.99208
                            ],
                            [
                                22.88098,
                                48.05407
                            ],
                            [
                                22.81951,
                                48.11843
                            ],
                            [
                                22.67421,
                                48.09195
                            ],
                            [
                                22.59113,
                                48.10807
                            ],
                            [
                                22.56947,
                                48.19575
                            ],
                            [
                                22.48811,
                                48.25317
                            ],
                            [
                                22.38398,
                                48.23561
                            ],
                            [
                                22.26562,
                                48.40873
                            ],
                            [
                                22.15531,
                                48.4034
                            ]
                        ],
                        [
                            [
                                1.7258,
                                42.5044
                            ],
                            [
                                1.6627,
                                42.49326
                            ],
                            [
                                1.5519,
                                42.43343
                            ],
                            [
                                1.44945,
                                42.43839
                            ],
                            [
                                1.46726,
                                42.51108
                            ],
                            [
                                1.44257,
                                42.60367
                            ],
                            [
                                1.47935,
                                42.65092
                            ],
                            [
                                1.73788,
                                42.61152
                            ],
                            [
                                1.7258,
                                42.5044
                            ]
                        ],
                        [
                            [
                                9.55872,
                                47.54189
                            ],
                            [
                                9.5658,
                                47.49237
                            ],
                            [
                                9.64434,
                                47.43516
                            ],
                            [
                                9.62448,
                                47.36614
                            ],
                            [
                                9.53075,
                                47.27058
                            ],
                            [
                                9.62498,
                                47.14572
                            ],
                            [
                                9.60708,
                                47.06077
                            ],
                            [
                                9.78334,
                                47.03846
                            ],
                            [
                                9.89167,
                                46.98948
                            ],
                            [
                                9.87615,
                                46.93464
                            ],
                            [
                                9.97789,
                                46.91589
                            ],
                            [
                                10.15781,
                                46.84857
                            ],
                            [
                                10.29361,
                                46.92181
                            ],
                            [
                                10.34898,
                                46.99061
                            ],
                            [
                                10.48935,
                                46.93779
                            ],
                            [
                                10.46965,
                                46.85491
                            ],
                            [
                                10.39374,
                                46.69015
                            ],
                            [
                                10.40321,
                                46.63669
                            ],
                            [
                                10.48582,
                                46.61668
                            ],
                            [
                                10.47159,
                                46.54399
                            ],
                            [
                                10.29707,
                                46.54972
                            ],
                            [
                                10.25795,
                                46.61043
                            ],
                            [
                                10.12934,
                                46.60586
                            ],
                            [
                                10.05214,
                                46.53202
                            ],
                            [
                                10.04264,
                                46.45298
                            ],
                            [
                                10.16553,
                                46.40885
                            ],
                            [
                                10.10508,
                                46.33331
                            ],
                            [
                                10.17652,
                                46.25828
                            ],
                            [
                                10.1232,
                                46.22424
                            ],
                            [
                                10.04462,
                                46.23054
                            ],
                            [
                                9.9955,
                                46.34261
                            ],
                            [
                                9.90783,
                                46.38051
                            ],
                            [
                                9.77027,
                                46.33599
                            ],
                            [
                                9.71415,
                                46.29271
                            ],
                            [
                                9.5345,
                                46.31172
                            ],
                            [
                                9.46786,
                                46.38953
                            ],
                            [
                                9.46504,
                                46.46945
                            ],
                            [
                                9.28274,
                                46.49669
                            ],
                            [
                                9.27453,
                                46.41885
                            ],
                            [
                                9.30014,
                                46.32646
                            ],
                            [
                                9.18352,
                                46.17053
                            ],
                            [
                                9.07252,
                                46.1181
                            ],
                            [
                                9.01782,
                                46.04977
                            ],
                            [
                                9.02204,
                                45.93809
                            ],
                            [
                                9.07645,
                                45.91076
                            ],
                            [
                                9.0318,
                                45.82514
                            ],
                            [
                                8.93141,
                                45.8598
                            ],
                            [
                                8.92484,
                                45.9037
                            ],
                            [
                                8.79309,
                                46.00811
                            ],
                            [
                                8.85459,
                                46.06159
                            ],
                            [
                                8.80791,
                                46.1004
                            ],
                            [
                                8.71394,
                                46.09727
                            ],
                            [
                                8.61379,
                                46.12173
                            ],
                            [
                                8.53682,
                                46.2037
                            ],
                            [
                                8.46868,
                                46.23289
                            ],
                            [
                                8.42774,
                                46.2983
                            ],
                            [
                                8.46396,
                                46.33301
                            ],
                            [
                                8.4658,
                                46.44263
                            ],
                            [
                                8.36365,
                                46.45046
                            ],
                            [
                                8.31874,
                                46.38613
                            ],
                            [
                                8.21145,
                                46.30958
                            ],
                            [
                                8.0813,
                                46.26028
                            ],
                            [
                                8.16455,
                                46.1829
                            ],
                            [
                                8.10823,
                                46.11163
                            ],
                            [
                                8.03476,
                                46.10084
                            ],
                            [
                                7.98909,
                                45.99593
                            ],
                            [
                                7.90868,
                                45.99694
                            ],
                            [
                                7.86408,
                                45.91675
                            ],
                            [
                                7.7351,
                                45.92399
                            ],
                            [
                                7.66506,
                                45.97521
                            ],
                            [
                                7.49882,
                                45.96169
                            ],
                            [
                                7.38248,
                                45.89697
                            ],
                            [
                                7.29444,
                                45.92178
                            ],
                            [
                                7.1181,
                                45.85976
                            ],
                            [
                                7.04489,
                                45.92241
                            ],
                            [
                                6.94974,
                                46.05173
                            ],
                            [
                                6.79827,
                                46.13709
                            ],
                            [
                                6.80356,
                                46.20314
                            ],
                            [
                                6.86418,
                                46.28032
                            ],
                            [
                                6.77076,
                                46.35474
                            ],
                            [
                                6.82106,
                                46.42715
                            ],
                            [
                                6.68186,
                                46.45433
                            ],
                            [
                                6.5191,
                                46.45637
                            ],
                            [
                                6.33519,
                                46.40372
                            ],
                            [
                                6.21955,
                                46.31188
                            ],
                            [
                                6.29446,
                                46.22493
                            ],
                            [
                                6.12662,
                                46.14047
                            ],
                            [
                                5.96514,
                                46.1452
                            ],
                            [
                                6.03372,
                                46.23843
                            ],
                            [
                                6.17014,
                                46.36644
                            ],
                            [
                                6.09682,
                                46.40875
                            ],
                            [
                                6.07358,
                                46.46527
                            ],
                            [
                                6.15646,
                                46.54526
                            ],
                            [
                                6.11096,
                                46.57666
                            ],
                            [
                                6.35242,
                                46.71514
                            ],
                            [
                                6.43463,
                                46.80204
                            ],
                            [
                                6.46393,
                                46.89098
                            ],
                            [
                                6.43275,
                                46.92846
                            ],
                            [
                                6.64216,
                                47.0048
                            ],
                            [
                                6.70426,
                                47.08194
                            ],
                            [
                                6.95514,
                                47.24317
                            ],
                            [
                                6.94714,
                                47.29089
                            ],
                            [
                                7.04618,
                                47.32728
                            ],
                            [
                                7.01234,
                                47.37279
                            ],
                            [
                                6.92108,
                                47.35564
                            ],
                            [
                                6.98291,
                                47.49427
                            ],
                            [
                                7.19119,
                                47.48768
                            ],
                            [
                                7.17042,
                                47.44345
                            ],
                            [
                                7.38089,
                                47.43189
                            ],
                            [
                                7.50996,
                                47.49683
                            ],
                            [
                                7.50789,
                                47.54476
                            ],
                            [
                                7.58904,
                                47.58988
                            ],
                            [
                                7.67303,
                                47.59212
                            ],
                            [
                                7.69704,
                                47.53316
                            ],
                            [
                                7.89411,
                                47.58637
                            ],
                            [
                                7.91659,
                                47.54827
                            ],
                            [
                                8.01956,
                                47.55059
                            ],
                            [
                                8.19753,
                                47.61857
                            ],
                            [
                                8.32519,
                                47.57251
                            ],
                            [
                                8.46412,
                                47.57221
                            ],
                            [
                                8.46507,
                                47.64542
                            ],
                            [
                                8.40641,
                                47.67548
                            ],
                            [
                                8.48754,
                                47.77217
                            ],
                            [
                                8.60161,
                                47.80269
                            ],
                            [
                                8.73629,
                                47.71615
                            ],
                            [
                                8.80644,
                                47.73831
                            ],
                            [
                                8.87489,
                                47.65467
                            ],
                            [
                                9.02157,
                                47.68643
                            ],
                            [
                                9.1708,
                                47.65528
                            ],
                            [
                                9.25656,
                                47.65871
                            ],
                            [
                                9.39471,
                                47.62033
                            ],
                            [
                                9.4956,
                                47.55145
                            ],
                            [
                                9.55872,
                                47.54189
                            ]
                        ],
                        [
                            [
                                12.44806,
                                41.90082
                            ],
                            [
                                12.45125,
                                41.90628
                            ],
                            [
                                12.45784,
                                41.90155
                            ],
                            [
                                12.44806,
                                41.90082
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.36876,
                                35.99715
                            ],
                            [
                                14.33262,
                                35.98641
                            ],
                            [
                                14.33805,
                                35.87853
                            ],
                            [
                                14.41721,
                                35.82861
                            ],
                            [
                                14.51642,
                                35.80686
                            ],
                            [
                                14.57432,
                                35.86772
                            ],
                            [
                                14.36876,
                                35.99715
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                4.87824,
                                53.1578
                            ],
                            [
                                4.75149,
                                53.09889
                            ],
                            [
                                4.70911,
                                53.02785
                            ],
                            [
                                4.78457,
                                53.00173
                            ],
                            [
                                4.89668,
                                53.0775
                            ],
                            [
                                4.87824,
                                53.1578
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                5.5474,
                                53.43931
                            ],
                            [
                                5.49049,
                                53.4442
                            ],
                            [
                                5.19952,
                                53.39552
                            ],
                            [
                                5.29287,
                                53.37028
                            ],
                            [
                                5.5474,
                                53.43931
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -25.76603,
                                37.90617
                            ],
                            [
                                -25.85359,
                                37.86027
                            ],
                            [
                                -25.84102,
                                37.82901
                            ],
                            [
                                -25.69684,
                                37.73617
                            ],
                            [
                                -25.63007,
                                37.75004
                            ],
                            [
                                -25.48374,
                                37.71788
                            ],
                            [
                                -25.3688,
                                37.71401
                            ],
                            [
                                -25.14979,
                                37.75874
                            ],
                            [
                                -25.14993,
                                37.85027
                            ],
                            [
                                -25.26194,
                                37.862
                            ],
                            [
                                -25.45566,
                                37.82319
                            ],
                            [
                                -25.50049,
                                37.84297
                            ],
                            [
                                -25.58528,
                                37.81414
                            ],
                            [
                                -25.69064,
                                37.84295
                            ],
                            [
                                -25.76603,
                                37.90617
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -17.1936,
                                32.87035
                            ],
                            [
                                -17.26489,
                                32.81473
                            ],
                            [
                                -17.2118,
                                32.737
                            ],
                            [
                                -17.01964,
                                32.65364
                            ],
                            [
                                -16.94354,
                                32.63321
                            ],
                            [
                                -16.83189,
                                32.64153
                            ],
                            [
                                -16.7734,
                                32.69204
                            ],
                            [
                                -16.74507,
                                32.75513
                            ],
                            [
                                -16.82231,
                                32.76844
                            ],
                            [
                                -16.9072,
                                32.83645
                            ],
                            [
                                -17.05103,
                                32.80889
                            ],
                            [
                                -17.1936,
                                32.87035
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -28.39031,
                                38.55814
                            ],
                            [
                                -28.47558,
                                38.56035
                            ],
                            [
                                -28.53477,
                                38.53272
                            ],
                            [
                                -28.51613,
                                38.45266
                            ],
                            [
                                -28.41134,
                                38.42762
                            ],
                            [
                                -28.08178,
                                38.40023
                            ],
                            [
                                -28.05826,
                                38.44293
                            ],
                            [
                                -28.19124,
                                38.46298
                            ],
                            [
                                -28.39031,
                                38.55814
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -27.2567,
                                38.80249
                            ],
                            [
                                -27.33284,
                                38.79339
                            ],
                            [
                                -27.37905,
                                38.7475
                            ],
                            [
                                -27.35137,
                                38.68739
                            ],
                            [
                                -27.27683,
                                38.65301
                            ],
                            [
                                -27.07995,
                                38.64409
                            ],
                            [
                                -27.06838,
                                38.76559
                            ],
                            [
                                -27.2567,
                                38.80249
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -28.08982,
                                38.6874
                            ],
                            [
                                -28.19055,
                                38.66702
                            ],
                            [
                                -28.02578,
                                38.60236
                            ],
                            [
                                -27.94371,
                                38.58951
                            ],
                            [
                                -27.82792,
                                38.53384
                            ],
                            [
                                -27.82269,
                                38.57971
                            ],
                            [
                                -28.02492,
                                38.67202
                            ],
                            [
                                -28.08982,
                                38.6874
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -28.62162,
                                38.61113
                            ],
                            [
                                -28.71477,
                                38.64369
                            ],
                            [
                                -28.81361,
                                38.58094
                            ],
                            [
                                -28.72085,
                                38.51779
                            ],
                            [
                                -28.62752,
                                38.52543
                            ],
                            [
                                -28.62162,
                                38.61113
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -31.20754,
                                39.52349
                            ],
                            [
                                -31.26791,
                                39.4519
                            ],
                            [
                                -31.24811,
                                39.37615
                            ],
                            [
                                -31.17596,
                                39.37535
                            ],
                            [
                                -31.12837,
                                39.44851
                            ],
                            [
                                -31.20754,
                                39.52349
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -25.08718,
                                37.01588
                            ],
                            [
                                -25.18492,
                                36.98499
                            ],
                            [
                                -25.16669,
                                36.945
                            ],
                            [
                                -25.01953,
                                36.96327
                            ],
                            [
                                -25.08718,
                                37.01588
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                18.78365,
                                57.84635
                            ],
                            [
                                18.69753,
                                57.92101
                            ],
                            [
                                18.56162,
                                57.84468
                            ],
                            [
                                18.46059,
                                57.81897
                            ],
                            [
                                18.33088,
                                57.67036
                            ],
                            [
                                18.10708,
                                57.53378
                            ],
                            [
                                18.11885,
                                57.44195
                            ],
                            [
                                18.18799,
                                57.38523
                            ],
                            [
                                18.16971,
                                57.3223
                            ],
                            [
                                18.10337,
                                57.28825
                            ],
                            [
                                18.14979,
                                57.16617
                            ],
                            [
                                18.21619,
                                57.09907
                            ],
                            [
                                18.21689,
                                57.02913
                            ],
                            [
                                18.12586,
                                56.91807
                            ],
                            [
                                18.2918,
                                56.93137
                            ],
                            [
                                18.38697,
                                56.99396
                            ],
                            [
                                18.34023,
                                57.06843
                            ],
                            [
                                18.40024,
                                57.13841
                            ],
                            [
                                18.70936,
                                57.24457
                            ],
                            [
                                18.66227,
                                57.29315
                            ],
                            [
                                18.75484,
                                57.36278
                            ],
                            [
                                18.91793,
                                57.40475
                            ],
                            [
                                18.76302,
                                57.4705
                            ],
                            [
                                18.81354,
                                57.55911
                            ],
                            [
                                18.76494,
                                57.61832
                            ],
                            [
                                18.83686,
                                57.73077
                            ],
                            [
                                18.89751,
                                57.7172
                            ],
                            [
                                19.0348,
                                57.76778
                            ],
                            [
                                19.02493,
                                57.90818
                            ],
                            [
                                18.84598,
                                57.91987
                            ],
                            [
                                18.78365,
                                57.84635
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                17.10066,
                                57.33602
                            ],
                            [
                                16.96066,
                                57.28922
                            ],
                            [
                                16.95807,
                                57.23183
                            ],
                            [
                                16.88383,
                                57.09748
                            ],
                            [
                                16.73363,
                                56.93044
                            ],
                            [
                                16.63292,
                                56.87565
                            ],
                            [
                                16.51601,
                                56.74474
                            ],
                            [
                                16.45915,
                                56.63519
                            ],
                            [
                                16.37107,
                                56.52749
                            ],
                            [
                                16.40651,
                                56.41144
                            ],
                            [
                                16.39218,
                                56.27083
                            ],
                            [
                                16.47894,
                                56.2376
                            ],
                            [
                                16.56749,
                                56.36996
                            ],
                            [
                                16.65095,
                                56.56289
                            ],
                            [
                                16.68436,
                                56.57694
                            ],
                            [
                                16.77387,
                                56.78265
                            ],
                            [
                                16.86272,
                                56.84313
                            ],
                            [
                                16.97579,
                                57.08318
                            ],
                            [
                                17.07054,
                                57.17911
                            ],
                            [
                                17.05913,
                                57.27765
                            ],
                            [
                                17.10066,
                                57.33602
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                11.70256,
                                58.30225
                            ],
                            [
                                11.6206,
                                58.24835
                            ],
                            [
                                11.49854,
                                58.20251
                            ],
                            [
                                11.41047,
                                58.14369
                            ],
                            [
                                11.54942,
                                58.08913
                            ],
                            [
                                11.62251,
                                58.13156
                            ],
                            [
                                11.73844,
                                58.11196
                            ],
                            [
                                11.84627,
                                58.15943
                            ],
                            [
                                11.83742,
                                58.23638
                            ],
                            [
                                11.70256,
                                58.30225
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                11.68952,
                                58.06623
                            ],
                            [
                                11.51196,
                                58.05163
                            ],
                            [
                                11.53683,
                                57.96125
                            ],
                            [
                                11.6663,
                                57.96359
                            ],
                            [
                                11.68952,
                                58.06623
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                17.3802,
                                62.47952
                            ],
                            [
                                17.42587,
                                62.35464
                            ],
                            [
                                17.52605,
                                62.36373
                            ],
                            [
                                17.45678,
                                62.46831
                            ],
                            [
                                17.3802,
                                62.47952
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                18.67942,
                                59.56136
                            ],
                            [
                                18.51409,
                                59.49138
                            ],
                            [
                                18.60628,
                                59.46148
                            ],
                            [
                                18.67942,
                                59.56136
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -51.65546,
                                4.05599
                            ],
                            [
                                -51.6342,
                                4.2013
                            ],
                            [
                                -51.70227,
                                4.29579
                            ],
                            [
                                -51.71178,
                                4.38889
                            ],
                            [
                                -51.75215,
                                4.41924
                            ],
                            [
                                -51.79791,
                                4.61126
                            ],
                            [
                                -51.86429,
                                4.67179
                            ],
                            [
                                -51.91812,
                                4.6697
                            ],
                            [
                                -52.00457,
                                4.70134
                            ],
                            [
                                -52.11049,
                                4.78435
                            ],
                            [
                                -52.22819,
                                4.85983
                            ],
                            [
                                -52.30134,
                                4.95022
                            ],
                            [
                                -52.35693,
                                4.91883
                            ],
                            [
                                -52.55774,
                                5.10601
                            ],
                            [
                                -52.63052,
                                5.14855
                            ],
                            [
                                -52.85553,
                                5.37721
                            ],
                            [
                                -52.95482,
                                5.45512
                            ],
                            [
                                -53.07233,
                                5.46816
                            ],
                            [
                                -53.13052,
                                5.50721
                            ],
                            [
                                -53.2589,
                                5.54836
                            ],
                            [
                                -53.3159,
                                5.53965
                            ],
                            [
                                -53.46936,
                                5.56525
                            ],
                            [
                                -53.62942,
                                5.6324
                            ],
                            [
                                -53.78947,
                                5.71973
                            ],
                            [
                                -53.96837,
                                5.74518
                            ],
                            [
                                -54.01197,
                                5.66349
                            ],
                            [
                                -54.00565,
                                5.60254
                            ],
                            [
                                -54.01813,
                                5.52295
                            ],
                            [
                                -54.11733,
                                5.41725
                            ],
                            [
                                -54.18335,
                                5.32468
                            ],
                            [
                                -54.27815,
                                5.26314
                            ],
                            [
                                -54.36966,
                                5.13052
                            ],
                            [
                                -54.41555,
                                5.08374
                            ],
                            [
                                -54.46711,
                                4.87206
                            ],
                            [
                                -54.46579,
                                4.73928
                            ],
                            [
                                -54.42808,
                                4.71621
                            ],
                            [
                                -54.43757,
                                4.64055
                            ],
                            [
                                -54.41568,
                                4.60567
                            ],
                            [
                                -54.4495,
                                4.52596
                            ],
                            [
                                -54.432,
                                4.41227
                            ],
                            [
                                -54.38739,
                                4.35402
                            ],
                            [
                                -54.39489,
                                4.19931
                            ],
                            [
                                -54.32405,
                                4.14841
                            ],
                            [
                                -54.35643,
                                4.0515
                            ],
                            [
                                -54.29556,
                                3.94888
                            ],
                            [
                                -54.24988,
                                3.90853
                            ],
                            [
                                -54.20119,
                                3.82324
                            ],
                            [
                                -54.12267,
                                3.7933
                            ],
                            [
                                -54.08284,
                                3.67655
                            ],
                            [
                                -53.98159,
                                3.60555
                            ],
                            [
                                -54.00797,
                                3.53854
                            ],
                            [
                                -54.0216,
                                3.41217
                            ],
                            [
                                -54.05827,
                                3.38321
                            ],
                            [
                                -54.06566,
                                3.31084
                            ],
                            [
                                -54.13808,
                                3.26333
                            ],
                            [
                                -54.21235,
                                3.15205
                            ],
                            [
                                -54.17505,
                                3.1068
                            ],
                            [
                                -54.1932,
                                3.06304
                            ],
                            [
                                -54.17362,
                                2.9397
                            ],
                            [
                                -54.18051,
                                2.85921
                            ],
                            [
                                -54.22504,
                                2.75363
                            ],
                            [
                                -54.26376,
                                2.72314
                            ],
                            [
                                -54.31731,
                                2.6286
                            ],
                            [
                                -54.35077,
                                2.52278
                            ],
                            [
                                -54.4202,
                                2.438
                            ],
                            [
                                -54.47514,
                                2.43418
                            ],
                            [
                                -54.50825,
                                2.33845
                            ],
                            [
                                -54.58789,
                                2.32207
                            ],
                            [
                                -54.47667,
                                2.2141
                            ],
                            [
                                -54.36124,
                                2.2093
                            ],
                            [
                                -54.34034,
                                2.15366
                            ],
                            [
                                -54.27124,
                                2.14535
                            ],
                            [
                                -54.19398,
                                2.16928
                            ],
                            [
                                -54.14199,
                                2.11528
                            ],
                            [
                                -54.10462,
                                2.12256
                            ],
                            [
                                -54.06419,
                                2.19594
                            ],
                            [
                                -53.94362,
                                2.21745
                            ],
                            [
                                -53.93456,
                                2.279
                            ],
                            [
                                -53.81569,
                                2.31193
                            ],
                            [
                                -53.8085,
                                2.35208
                            ],
                            [
                                -53.73854,
                                2.37236
                            ],
                            [
                                -53.72223,
                                2.31139
                            ],
                            [
                                -53.53193,
                                2.25245
                            ],
                            [
                                -53.46187,
                                2.25387
                            ],
                            [
                                -53.34007,
                                2.35039
                            ],
                            [
                                -53.25608,
                                2.27135
                            ],
                            [
                                -53.22112,
                                2.20233
                            ],
                            [
                                -53.13307,
                                2.22441
                            ],
                            [
                                -52.98111,
                                2.16861
                            ],
                            [
                                -52.90472,
                                2.19023
                            ],
                            [
                                -52.85634,
                                2.28009
                            ],
                            [
                                -52.66143,
                                2.37441
                            ],
                            [
                                -52.61929,
                                2.47311
                            ],
                            [
                                -52.5527,
                                2.52082
                            ],
                            [
                                -52.5277,
                                2.58322
                            ],
                            [
                                -52.52918,
                                2.65421
                            ],
                            [
                                -52.47279,
                                2.79438
                            ],
                            [
                                -52.32704,
                                3.07646
                            ],
                            [
                                -52.34942,
                                3.12302
                            ],
                            [
                                -52.29243,
                                3.22356
                            ],
                            [
                                -52.22707,
                                3.24935
                            ],
                            [
                                -52.08794,
                                3.48613
                            ],
                            [
                                -51.98899,
                                3.62721
                            ],
                            [
                                -51.97218,
                                3.70513
                            ],
                            [
                                -51.79867,
                                3.88731
                            ],
                            [
                                -51.78213,
                                3.96384
                            ],
                            [
                                -51.65546,
                                4.05599
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.42712,
                                43.0094
                            ],
                            [
                                9.34364,
                                42.99772
                            ],
                            [
                                9.35357,
                                42.91653
                            ],
                            [
                                9.31014,
                                42.83301
                            ],
                            [
                                9.34276,
                                42.73305
                            ],
                            [
                                9.25688,
                                42.71778
                            ],
                            [
                                9.1632,
                                42.73628
                            ],
                            [
                                9.08603,
                                42.71446
                            ],
                            [
                                9.01758,
                                42.64257
                            ],
                            [
                                8.91973,
                                42.63793
                            ],
                            [
                                8.72222,
                                42.55602
                            ],
                            [
                                8.66658,
                                42.51394
                            ],
                            [
                                8.65569,
                                42.41589
                            ],
                            [
                                8.5545,
                                42.37246
                            ],
                            [
                                8.56389,
                                42.33416
                            ],
                            [
                                8.68716,
                                42.28192
                            ],
                            [
                                8.57088,
                                42.23876
                            ],
                            [
                                8.62527,
                                42.12356
                            ],
                            [
                                8.70983,
                                42.09634
                            ],
                            [
                                8.72281,
                                42.03319
                            ],
                            [
                                8.65978,
                                42.01179
                            ],
                            [
                                8.6106,
                                41.91188
                            ],
                            [
                                8.78039,
                                41.92377
                            ],
                            [
                                8.7713,
                                41.81124
                            ],
                            [
                                8.68383,
                                41.7477
                            ],
                            [
                                8.77191,
                                41.71244
                            ],
                            [
                                8.91199,
                                41.69096
                            ],
                            [
                                8.79443,
                                41.63104
                            ],
                            [
                                8.78816,
                                41.56479
                            ],
                            [
                                8.94048,
                                41.49009
                            ],
                            [
                                9.07983,
                                41.44148
                            ],
                            [
                                9.09271,
                                41.40171
                            ],
                            [
                                9.22022,
                                41.37042
                            ],
                            [
                                9.22511,
                                41.44037
                            ],
                            [
                                9.28243,
                                41.47765
                            ],
                            [
                                9.29796,
                                41.54181
                            ],
                            [
                                9.36745,
                                41.59485
                            ],
                            [
                                9.40772,
                                41.76619
                            ],
                            [
                                9.4118,
                                41.94674
                            ],
                            [
                                9.54967,
                                42.10431
                            ],
                            [
                                9.55932,
                                42.2828
                            ],
                            [
                                9.53262,
                                42.36876
                            ],
                            [
                                9.54342,
                                42.42794
                            ],
                            [
                                9.52769,
                                42.565
                            ],
                            [
                                9.44921,
                                42.66225
                            ],
                            [
                                9.49146,
                                42.79757
                            ],
                            [
                                9.46221,
                                42.98651
                            ],
                            [
                                9.42712,
                                43.0094
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                55.45117,
                                -20.87174
                            ],
                            [
                                55.39505,
                                -20.88183
                            ],
                            [
                                55.32262,
                                -20.93368
                            ],
                            [
                                55.27584,
                                -21.00157
                            ],
                            [
                                55.21708,
                                -21.03923
                            ],
                            [
                                55.22173,
                                -21.07824
                            ],
                            [
                                55.28698,
                                -21.16199
                            ],
                            [
                                55.29423,
                                -21.2305
                            ],
                            [
                                55.33977,
                                -21.28041
                            ],
                            [
                                55.46139,
                                -21.34181
                            ],
                            [
                                55.64671,
                                -21.38885
                            ],
                            [
                                55.75665,
                                -21.3637
                            ],
                            [
                                55.80844,
                                -21.3333
                            ],
                            [
                                55.80195,
                                -21.26081
                            ],
                            [
                                55.83578,
                                -21.18318
                            ],
                            [
                                55.70679,
                                -21.02626
                            ],
                            [
                                55.68322,
                                -20.94434
                            ],
                            [
                                55.64774,
                                -20.9156
                            ],
                            [
                                55.45117,
                                -20.87174
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -61.14808,
                                14.87878
                            ],
                            [
                                -61.22907,
                                14.8214
                            ],
                            [
                                -61.17934,
                                14.74925
                            ],
                            [
                                -61.15085,
                                14.64897
                            ],
                            [
                                -61.09078,
                                14.60018
                            ],
                            [
                                -61.08177,
                                14.47136
                            ],
                            [
                                -61.02077,
                                14.48003
                            ],
                            [
                                -60.91162,
                                14.46117
                            ],
                            [
                                -60.87489,
                                14.39698
                            ],
                            [
                                -60.81106,
                                14.48038
                            ],
                            [
                                -60.88435,
                                14.66556
                            ],
                            [
                                -61.01871,
                                14.80944
                            ],
                            [
                                -61.14808,
                                14.87878
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -61.67367,
                                16.32474
                            ],
                            [
                                -61.77664,
                                16.34867
                            ],
                            [
                                -61.80605,
                                16.26801
                            ],
                            [
                                -61.78272,
                                16.21392
                            ],
                            [
                                -61.76962,
                                16.05947
                            ],
                            [
                                -61.7068,
                                15.94915
                            ],
                            [
                                -61.61962,
                                15.97245
                            ],
                            [
                                -61.55664,
                                16.05209
                            ],
                            [
                                -61.59001,
                                16.19484
                            ],
                            [
                                -61.58527,
                                16.27054
                            ],
                            [
                                -61.67367,
                                16.32474
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -61.40527,
                                16.39338
                            ],
                            [
                                -61.41232,
                                16.46926
                            ],
                            [
                                -61.47175,
                                16.5098
                            ],
                            [
                                -61.53571,
                                16.45294
                            ],
                            [
                                -61.49763,
                                16.35582
                            ],
                            [
                                -61.53478,
                                16.33196
                            ],
                            [
                                -61.54884,
                                16.25311
                            ],
                            [
                                -61.46545,
                                16.19788
                            ],
                            [
                                -61.3666,
                                16.23358
                            ],
                            [
                                -61.2513,
                                16.25486
                            ],
                            [
                                -61.25913,
                                16.30158
                            ],
                            [
                                -61.37646,
                                16.34147
                            ],
                            [
                                -61.40527,
                                16.39338
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                45.12769,
                                -12.72734
                            ],
                            [
                                45.08947,
                                -12.66909
                            ],
                            [
                                45.04408,
                                -12.74239
                            ],
                            [
                                45.10169,
                                -12.77759
                            ],
                            [
                                45.10265,
                                -12.8445
                            ],
                            [
                                45.17019,
                                -12.94687
                            ],
                            [
                                45.21292,
                                -12.87171
                            ],
                            [
                                45.18619,
                                -12.83908
                            ],
                            [
                                45.23584,
                                -12.78349
                            ],
                            [
                                45.20498,
                                -12.73164
                            ],
                            [
                                45.12769,
                                -12.72734
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -1.2027,
                                45.90045
                            ],
                            [
                                -1.24623,
                                45.98885
                            ],
                            [
                                -1.37081,
                                46.03091
                            ],
                            [
                                -1.38762,
                                45.95508
                            ],
                            [
                                -1.19676,
                                45.82933
                            ],
                            [
                                -1.2027,
                                45.90045
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -61.25944,
                                15.87121
                            ],
                            [
                                -61.19839,
                                15.93946
                            ],
                            [
                                -61.27644,
                                16.00635
                            ],
                            [
                                -61.33717,
                                15.93946
                            ],
                            [
                                -61.32172,
                                15.88555
                            ],
                            [
                                -61.25944,
                                15.87121
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -3.19412,
                                47.36593
                            ],
                            [
                                -3.2192,
                                47.29384
                            ],
                            [
                                -3.09941,
                                47.3158
                            ],
                            [
                                -3.19412,
                                47.36593
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                28.92968,
                                69.0519
                            ],
                            [
                                28.80628,
                                69.11107
                            ],
                            [
                                28.83217,
                                69.22409
                            ],
                            [
                                29.22032,
                                69.39803
                            ],
                            [
                                29.33593,
                                69.47765
                            ],
                            [
                                29.13254,
                                69.69557
                            ],
                            [
                                28.40418,
                                69.81865
                            ],
                            [
                                28.34536,
                                69.88079
                            ],
                            [
                                28.16107,
                                69.9211
                            ],
                            [
                                27.98464,
                                70.01432
                            ],
                            [
                                27.96056,
                                70.08996
                            ],
                            [
                                27.66927,
                                70.07723
                            ],
                            [
                                27.42676,
                                70.01857
                            ],
                            [
                                27.30524,
                                69.95754
                            ],
                            [
                                26.98692,
                                69.93458
                            ],
                            [
                                26.67652,
                                69.96424
                            ],
                            [
                                26.46678,
                                69.9397
                            ],
                            [
                                26.38556,
                                69.8554
                            ],
                            [
                                26.10873,
                                69.73018
                            ],
                            [
                                25.89971,
                                69.65838
                            ],
                            [
                                25.97623,
                                69.61052
                            ],
                            [
                                25.79696,
                                69.41943
                            ],
                            [
                                25.69309,
                                69.19717
                            ],
                            [
                                25.77717,
                                69.01799
                            ],
                            [
                                25.62719,
                                68.89321
                            ],
                            [
                                25.4807,
                                68.90489
                            ],
                            [
                                25.24372,
                                68.84137
                            ],
                            [
                                25.12195,
                                68.74633
                            ],
                            [
                                25.11586,
                                68.6396
                            ],
                            [
                                24.91875,
                                68.60538
                            ],
                            [
                                24.60752,
                                68.68197
                            ],
                            [
                                24.29653,
                                68.71845
                            ],
                            [
                                23.98335,
                                68.82692
                            ],
                            [
                                23.77541,
                                68.81845
                            ],
                            [
                                23.67334,
                                68.70578
                            ],
                            [
                                23.44031,
                                68.69201
                            ],
                            [
                                23.16901,
                                68.62893
                            ],
                            [
                                23.04562,
                                68.68914
                            ],
                            [
                                22.7989,
                                68.68795
                            ],
                            [
                                22.53534,
                                68.74425
                            ],
                            [
                                22.375,
                                68.71706
                            ],
                            [
                                22.34061,
                                68.82707
                            ],
                            [
                                22.17589,
                                68.95584
                            ],
                            [
                                21.62709,
                                69.27659
                            ],
                            [
                                21.27882,
                                69.31188
                            ],
                            [
                                21.09714,
                                69.26116
                            ],
                            [
                                20.9881,
                                69.19166
                            ],
                            [
                                21.10809,
                                69.1036
                            ],
                            [
                                21.05772,
                                69.03686
                            ],
                            [
                                20.71671,
                                69.1194
                            ],
                            [
                                20.54864,
                                69.05997
                            ],
                            [
                                20.06005,
                                69.04576
                            ],
                            [
                                20.30612,
                                68.92618
                            ],
                            [
                                20.33527,
                                68.8018
                            ],
                            [
                                20.20328,
                                68.66645
                            ],
                            [
                                19.9375,
                                68.55794
                            ],
                            [
                                20.22654,
                                68.49081
                            ],
                            [
                                19.92026,
                                68.35633
                            ],
                            [
                                18.98545,
                                68.51666
                            ],
                            [
                                18.62103,
                                68.50723
                            ],
                            [
                                18.40555,
                                68.5816
                            ],
                            [
                                18.12592,
                                68.53652
                            ],
                            [
                                18.10109,
                                68.40604
                            ],
                            [
                                18.15135,
                                68.19879
                            ],
                            [
                                17.89976,
                                67.96937
                            ],
                            [
                                17.66475,
                                68.03838
                            ],
                            [
                                17.28152,
                                68.11881
                            ],
                            [
                                17.18051,
                                68.05046
                            ],
                            [
                                16.74003,
                                67.91482
                            ],
                            [
                                16.55628,
                                67.64719
                            ],
                            [
                                16.40767,
                                67.5341
                            ],
                            [
                                16.15859,
                                67.51898
                            ],
                            [
                                16.09041,
                                67.43577
                            ],
                            [
                                16.40334,
                                67.20547
                            ],
                            [
                                16.38763,
                                67.04601
                            ],
                            [
                                16.03992,
                                66.91294
                            ],
                            [
                                15.62209,
                                66.59494
                            ],
                            [
                                15.37776,
                                66.48413
                            ],
                            [
                                15.48167,
                                66.28177
                            ],
                            [
                                15.03577,
                                66.15399
                            ],
                            [
                                14.51737,
                                66.13243
                            ],
                            [
                                14.62506,
                                65.81153
                            ],
                            [
                                14.54129,
                                65.69987
                            ],
                            [
                                14.499,
                                65.52218
                            ],
                            [
                                14.5065,
                                65.31002
                            ],
                            [
                                14.379,
                                65.24742
                            ],
                            [
                                14.32599,
                                65.11892
                            ],
                            [
                                14.07755,
                                64.93912
                            ],
                            [
                                13.70608,
                                64.64042
                            ],
                            [
                                13.65503,
                                64.58054
                            ],
                            [
                                13.89091,
                                64.5073
                            ],
                            [
                                14.11391,
                                64.46173
                            ],
                            [
                                14.15638,
                                64.19494
                            ],
                            [
                                13.96787,
                                64.00906
                            ],
                            [
                                13.71279,
                                64.04655
                            ],
                            [
                                13.21111,
                                64.09537
                            ],
                            [
                                12.92679,
                                64.05784
                            ],
                            [
                                12.68357,
                                63.97422
                            ],
                            [
                                12.3315,
                                63.71568
                            ],
                            [
                                12.14977,
                                63.59395
                            ],
                            [
                                12.2123,
                                63.47834
                            ],
                            [
                                11.97458,
                                63.26923
                            ],
                            [
                                12.21757,
                                63.00067
                            ],
                            [
                                12.07469,
                                62.90254
                            ],
                            [
                                12.13638,
                                62.74792
                            ],
                            [
                                12.05663,
                                62.6115
                            ],
                            [
                                12.29937,
                                62.26749
                            ],
                            [
                                12.13804,
                                61.72458
                            ],
                            [
                                12.41971,
                                61.56339
                            ],
                            [
                                12.56958,
                                61.56828
                            ],
                            [
                                12.87085,
                                61.35649
                            ],
                            [
                                12.79003,
                                61.19699
                            ],
                            [
                                12.70736,
                                61.14321
                            ],
                            [
                                12.68264,
                                61.06165
                            ],
                            [
                                12.44797,
                                61.05067
                            ],
                            [
                                12.22399,
                                61.01308
                            ],
                            [
                                12.33263,
                                60.88986
                            ],
                            [
                                12.39533,
                                60.73423
                            ],
                            [
                                12.51084,
                                60.64216
                            ],
                            [
                                12.60684,
                                60.51158
                            ],
                            [
                                12.60583,
                                60.4062
                            ],
                            [
                                12.49928,
                                60.32346
                            ],
                            [
                                12.54156,
                                60.19319
                            ],
                            [
                                12.44962,
                                60.0403
                            ],
                            [
                                12.34077,
                                59.96572
                            ],
                            [
                                12.17124,
                                59.88932
                            ],
                            [
                                11.98422,
                                59.90028
                            ],
                            [
                                11.83973,
                                59.84077
                            ],
                            [
                                11.92548,
                                59.79393
                            ],
                            [
                                11.93794,
                                59.69459
                            ],
                            [
                                11.85658,
                                59.64898
                            ],
                            [
                                11.71845,
                                59.62387
                            ],
                            [
                                11.69153,
                                59.58894
                            ],
                            [
                                11.81613,
                                59.34445
                            ],
                            [
                                11.82959,
                                59.24317
                            ],
                            [
                                11.78349,
                                59.20718
                            ],
                            [
                                11.77524,
                                59.08705
                            ],
                            [
                                11.71051,
                                59.03368
                            ],
                            [
                                11.63175,
                                58.90834
                            ],
                            [
                                11.45745,
                                58.88844
                            ],
                            [
                                11.46083,
                                58.98866
                            ],
                            [
                                11.34069,
                                59.11057
                            ],
                            [
                                11.18938,
                                59.07554
                            ],
                            [
                                11.12122,
                                58.96485
                            ],
                            [
                                11.24659,
                                58.81083
                            ],
                            [
                                11.17491,
                                58.71917
                            ],
                            [
                                11.25814,
                                58.67746
                            ],
                            [
                                11.27633,
                                58.58826
                            ],
                            [
                                11.23659,
                                58.54918
                            ],
                            [
                                11.32394,
                                58.46476
                            ],
                            [
                                11.22229,
                                58.41234
                            ],
                            [
                                11.36986,
                                58.36256
                            ],
                            [
                                11.3968,
                                58.31809
                            ],
                            [
                                11.56196,
                                58.26168
                            ],
                            [
                                11.63875,
                                58.26277
                            ],
                            [
                                11.7206,
                                58.3381
                            ],
                            [
                                11.81006,
                                58.32413
                            ],
                            [
                                11.89308,
                                58.20354
                            ],
                            [
                                11.81453,
                                58.07626
                            ],
                            [
                                11.78456,
                                57.92084
                            ],
                            [
                                11.69248,
                                57.86125
                            ],
                            [
                                11.74658,
                                57.79876
                            ],
                            [
                                11.70508,
                                57.70683
                            ],
                            [
                                11.85538,
                                57.67718
                            ],
                            [
                                11.93362,
                                57.57384
                            ],
                            [
                                11.90565,
                                57.43895
                            ],
                            [
                                11.94421,
                                57.36587
                            ],
                            [
                                12.02339,
                                57.37459
                            ],
                            [
                                12.10509,
                                57.43444
                            ],
                            [
                                12.16278,
                                57.28581
                            ],
                            [
                                12.09594,
                                57.23403
                            ],
                            [
                                12.22486,
                                57.15477
                            ],
                            [
                                12.20437,
                                57.11681
                            ],
                            [
                                12.33934,
                                57.01751
                            ],
                            [
                                12.36213,
                                56.91951
                            ],
                            [
                                12.47014,
                                56.89434
                            ],
                            [
                                12.59371,
                                56.83121
                            ],
                            [
                                12.62548,
                                56.74233
                            ],
                            [
                                12.72984,
                                56.65816
                            ],
                            [
                                12.88032,
                                56.64894
                            ],
                            [
                                12.93614,
                                56.58735
                            ],
                            [
                                12.94021,
                                56.50659
                            ],
                            [
                                12.85098,
                                56.4311
                            ],
                            [
                                12.74683,
                                56.46796
                            ],
                            [
                                12.65698,
                                56.45495
                            ],
                            [
                                12.6382,
                                56.38939
                            ],
                            [
                                12.73525,
                                56.36185
                            ],
                            [
                                12.82603,
                                56.28277
                            ],
                            [
                                12.78267,
                                56.21934
                            ],
                            [
                                12.5155,
                                56.2946
                            ],
                            [
                                12.56773,
                                56.14567
                            ],
                            [
                                12.74769,
                                55.98965
                            ],
                            [
                                12.813,
                                55.87631
                            ],
                            [
                                12.91298,
                                55.83493
                            ],
                            [
                                12.9692,
                                55.7253
                            ],
                            [
                                13.04903,
                                55.69798
                            ],
                            [
                                13.00909,
                                55.63701
                            ],
                            [
                                12.89408,
                                55.56722
                            ],
                            [
                                12.96818,
                                55.45632
                            ],
                            [
                                12.96448,
                                55.40142
                            ],
                            [
                                13.07608,
                                55.3679
                            ],
                            [
                                13.36277,
                                55.33771
                            ],
                            [
                                13.50976,
                                55.38587
                            ],
                            [
                                13.71525,
                                55.427
                            ],
                            [
                                13.92068,
                                55.43442
                            ],
                            [
                                14.05427,
                                55.38135
                            ],
                            [
                                14.19745,
                                55.38574
                            ],
                            [
                                14.36043,
                                55.55386
                            ],
                            [
                                14.20442,
                                55.70205
                            ],
                            [
                                14.22033,
                                55.83061
                            ],
                            [
                                14.33984,
                                55.95781
                            ],
                            [
                                14.55399,
                                56.04988
                            ],
                            [
                                14.67043,
                                55.99144
                            ],
                            [
                                14.72593,
                                56.06273
                            ],
                            [
                                14.67379,
                                56.14648
                            ],
                            [
                                14.86845,
                                56.16205
                            ],
                            [
                                15.21639,
                                56.15552
                            ],
                            [
                                15.30749,
                                56.17651
                            ],
                            [
                                15.54366,
                                56.18836
                            ],
                            [
                                15.72524,
                                56.16807
                            ],
                            [
                                15.83478,
                                56.08546
                            ],
                            [
                                16.03986,
                                56.25599
                            ],
                            [
                                16.09364,
                                56.41694
                            ],
                            [
                                16.22451,
                                56.60282
                            ],
                            [
                                16.29838,
                                56.65866
                            ],
                            [
                                16.3692,
                                56.66241
                            ],
                            [
                                16.39875,
                                56.78582
                            ],
                            [
                                16.51599,
                                57.05879
                            ],
                            [
                                16.4641,
                                57.16508
                            ],
                            [
                                16.50445,
                                57.23136
                            ],
                            [
                                16.48732,
                                57.28726
                            ],
                            [
                                16.72075,
                                57.44405
                            ],
                            [
                                16.62701,
                                57.55095
                            ],
                            [
                                16.63938,
                                57.67665
                            ],
                            [
                                16.71457,
                                57.7091
                            ],
                            [
                                16.52277,
                                57.82393
                            ],
                            [
                                16.52228,
                                57.90139
                            ],
                            [
                                16.75352,
                                57.86695
                            ],
                            [
                                16.76688,
                                57.96151
                            ],
                            [
                                16.65998,
                                57.97395
                            ],
                            [
                                16.80956,
                                58.06577
                            ],
                            [
                                16.77294,
                                58.10894
                            ],
                            [
                                16.85306,
                                58.19223
                            ],
                            [
                                16.80965,
                                58.23613
                            ],
                            [
                                16.79088,
                                58.35898
                            ],
                            [
                                16.70259,
                                58.4019
                            ],
                            [
                                16.84842,
                                58.44618
                            ],
                            [
                                16.87754,
                                58.51524
                            ],
                            [
                                16.79468,
                                58.59683
                            ],
                            [
                                16.55483,
                                58.63254
                            ],
                            [
                                16.35074,
                                58.63025
                            ],
                            [
                                16.34677,
                                58.66526
                            ],
                            [
                                16.90874,
                                58.61067
                            ],
                            [
                                17.01913,
                                58.62621
                            ],
                            [
                                17.11311,
                                58.72576
                            ],
                            [
                                17.26036,
                                58.72223
                            ],
                            [
                                17.39258,
                                58.76006
                            ],
                            [
                                17.61725,
                                58.94955
                            ],
                            [
                                17.61403,
                                59.03531
                            ],
                            [
                                17.74512,
                                59.05731
                            ],
                            [
                                17.73458,
                                58.93105
                            ],
                            [
                                17.89208,
                                58.83082
                            ],
                            [
                                17.96911,
                                58.92179
                            ],
                            [
                                18.02534,
                                59.04352
                            ],
                            [
                                18.43339,
                                59.14196
                            ],
                            [
                                18.3783,
                                59.18566
                            ],
                            [
                                18.70114,
                                59.27614
                            ],
                            [
                                18.62836,
                                59.36629
                            ],
                            [
                                18.53557,
                                59.3825
                            ],
                            [
                                18.41673,
                                59.35211
                            ],
                            [
                                18.30186,
                                59.36195
                            ],
                            [
                                18.15153,
                                59.33051
                            ],
                            [
                                18.15353,
                                59.39972
                            ],
                            [
                                18.28741,
                                59.38698
                            ],
                            [
                                18.29776,
                                59.45607
                            ],
                            [
                                18.41001,
                                59.47999
                            ],
                            [
                                18.66512,
                                59.57766
                            ],
                            [
                                18.76968,
                                59.68408
                            ],
                            [
                                19.06948,
                                59.71775
                            ],
                            [
                                19.07167,
                                59.76416
                            ],
                            [
                                18.87281,
                                59.79048
                            ],
                            [
                                18.94582,
                                59.86081
                            ],
                            [
                                18.9476,
                                59.91524
                            ],
                            [
                                18.81898,
                                60.09565
                            ],
                            [
                                18.44392,
                                60.17763
                            ],
                            [
                                18.61562,
                                60.23181
                            ],
                            [
                                18.4561,
                                60.33703
                            ],
                            [
                                18.24637,
                                60.35885
                            ],
                            [
                                18.01598,
                                60.5029
                            ],
                            [
                                17.98677,
                                60.60182
                            ],
                            [
                                17.77732,
                                60.5684
                            ],
                            [
                                17.67355,
                                60.50836
                            ],
                            [
                                17.59214,
                                60.58137
                            ],
                            [
                                17.61222,
                                60.64453
                            ],
                            [
                                17.43274,
                                60.63684
                            ],
                            [
                                17.2226,
                                60.68749
                            ],
                            [
                                17.35063,
                                60.75326
                            ],
                            [
                                17.26016,
                                60.8789
                            ],
                            [
                                17.13947,
                                60.95449
                            ],
                            [
                                17.24527,
                                61.00783
                            ],
                            [
                                17.15745,
                                61.14762
                            ],
                            [
                                17.25266,
                                61.30351
                            ],
                            [
                                17.12402,
                                61.36378
                            ],
                            [
                                17.08653,
                                61.41367
                            ],
                            [
                                17.15167,
                                61.51692
                            ],
                            [
                                17.06202,
                                61.54785
                            ],
                            [
                                17.1574,
                                61.61138
                            ],
                            [
                                17.19077,
                                61.70011
                            ],
                            [
                                17.35099,
                                61.70278
                            ],
                            [
                                17.44148,
                                61.62272
                            ],
                            [
                                17.50158,
                                61.7154
                            ],
                            [
                                17.37865,
                                61.73893
                            ],
                            [
                                17.39659,
                                61.8172
                            ],
                            [
                                17.33862,
                                61.90787
                            ],
                            [
                                17.46515,
                                62.04298
                            ],
                            [
                                17.47426,
                                62.12347
                            ],
                            [
                                17.65654,
                                62.23351
                            ],
                            [
                                17.45937,
                                62.26563
                            ],
                            [
                                17.37181,
                                62.31933
                            ],
                            [
                                17.386,
                                62.44323
                            ],
                            [
                                17.33398,
                                62.48379
                            ],
                            [
                                17.4235,
                                62.50277
                            ],
                            [
                                17.63648,
                                62.43107
                            ],
                            [
                                17.72356,
                                62.50716
                            ],
                            [
                                17.88323,
                                62.51409
                            ],
                            [
                                17.96851,
                                62.74516
                            ],
                            [
                                17.88799,
                                62.83311
                            ],
                            [
                                18.02278,
                                62.85252
                            ],
                            [
                                18.07256,
                                62.78442
                            ],
                            [
                                18.22307,
                                62.79849
                            ],
                            [
                                18.45128,
                                62.87575
                            ],
                            [
                                18.50751,
                                62.9299
                            ],
                            [
                                18.3891,
                                62.95897
                            ],
                            [
                                18.58793,
                                63.17355
                            ],
                            [
                                18.73293,
                                63.18196
                            ],
                            [
                                18.89586,
                                63.23108
                            ],
                            [
                                19.01204,
                                63.18883
                            ],
                            [
                                19.12089,
                                63.25731
                            ],
                            [
                                19.13286,
                                63.30533
                            ],
                            [
                                19.25064,
                                63.33275
                            ],
                            [
                                19.26188,
                                63.45406
                            ],
                            [
                                19.41605,
                                63.46231
                            ],
                            [
                                19.4521,
                                63.5717
                            ],
                            [
                                19.5803,
                                63.52524
                            ],
                            [
                                19.66269,
                                63.43322
                            ],
                            [
                                19.76303,
                                63.466
                            ],
                            [
                                19.72753,
                                63.51115
                            ],
                            [
                                20.00255,
                                63.66029
                            ],
                            [
                                20.30263,
                                63.65693
                            ],
                            [
                                20.4208,
                                63.69683
                            ],
                            [
                                20.439,
                                63.75769
                            ],
                            [
                                20.77235,
                                63.87517
                            ],
                            [
                                20.95699,
                                64.08018
                            ],
                            [
                                20.96434,
                                64.14297
                            ],
                            [
                                21.24812,
                                64.29358
                            ],
                            [
                                21.33759,
                                64.29576
                            ],
                            [
                                21.51041,
                                64.41045
                            ],
                            [
                                21.43463,
                                64.55857
                            ],
                            [
                                21.36723,
                                64.60316
                            ],
                            [
                                21.2455,
                                64.60699
                            ],
                            [
                                21.28663,
                                64.68448
                            ],
                            [
                                21.1318,
                                64.77636
                            ],
                            [
                                21.16281,
                                64.8621
                            ],
                            [
                                21.25027,
                                64.92224
                            ],
                            [
                                21.4626,
                                65.01761
                            ],
                            [
                                21.58607,
                                65.15277
                            ],
                            [
                                21.5368,
                                65.23216
                            ],
                            [
                                21.67531,
                                65.28784
                            ],
                            [
                                21.47387,
                                65.35966
                            ],
                            [
                                21.58516,
                                65.42109
                            ],
                            [
                                21.79389,
                                65.39902
                            ],
                            [
                                21.98846,
                                65.41425
                            ],
                            [
                                21.99735,
                                65.51372
                            ],
                            [
                                22.37276,
                                65.57802
                            ],
                            [
                                22.31474,
                                65.76847
                            ],
                            [
                                22.34365,
                                65.83321
                            ],
                            [
                                22.71124,
                                65.7885
                            ],
                            [
                                22.82757,
                                65.80801
                            ],
                            [
                                23.00841,
                                65.7518
                            ],
                            [
                                23.23052,
                                65.77113
                            ],
                            [
                                23.2508,
                                65.80564
                            ],
                            [
                                24.01066,
                                65.7958
                            ],
                            [
                                24.15513,
                                65.81603
                            ],
                            [
                                24.32987,
                                65.79351
                            ],
                            [
                                24.42622,
                                65.74444
                            ],
                            [
                                24.54892,
                                65.74055
                            ],
                            [
                                24.67756,
                                65.65919
                            ],
                            [
                                24.88945,
                                65.66468
                            ],
                            [
                                25.05199,
                                65.62054
                            ],
                            [
                                25.08418,
                                65.57202
                            ],
                            [
                                25.20498,
                                65.56176
                            ],
                            [
                                25.31611,
                                65.48603
                            ],
                            [
                                25.3413,
                                65.42138
                            ],
                            [
                                25.24025,
                                65.3339
                            ],
                            [
                                25.31497,
                                65.29015
                            ],
                            [
                                25.23061,
                                65.12865
                            ],
                            [
                                25.36584,
                                65.10489
                            ],
                            [
                                25.42275,
                                65.03957
                            ],
                            [
                                25.22339,
                                64.94662
                            ],
                            [
                                25.39037,
                                64.89529
                            ],
                            [
                                25.33898,
                                64.83903
                            ],
                            [
                                25.12717,
                                64.91722
                            ],
                            [
                                24.69845,
                                64.86897
                            ],
                            [
                                24.58009,
                                64.78566
                            ],
                            [
                                24.54996,
                                64.72127
                            ],
                            [
                                24.40703,
                                64.6668
                            ],
                            [
                                24.34899,
                                64.53338
                            ],
                            [
                                24.03146,
                                64.41388
                            ],
                            [
                                23.98264,
                                64.35334
                            ],
                            [
                                23.80854,
                                64.23708
                            ],
                            [
                                23.58584,
                                64.11721
                            ],
                            [
                                23.56012,
                                64.04204
                            ],
                            [
                                23.38491,
                                64.063
                            ],
                            [
                                23.40427,
                                63.9411
                            ],
                            [
                                22.95477,
                                63.84563
                            ],
                            [
                                22.93805,
                                63.89122
                            ],
                            [
                                22.73043,
                                63.847
                            ],
                            [
                                22.59376,
                                63.66747
                            ],
                            [
                                22.4597,
                                63.60421
                            ],
                            [
                                22.49799,
                                63.57212
                            ],
                            [
                                22.41445,
                                63.48501
                            ],
                            [
                                22.2046,
                                63.45323
                            ],
                            [
                                22.39067,
                                63.33084
                            ],
                            [
                                22.09274,
                                63.23512
                            ],
                            [
                                21.99044,
                                63.26374
                            ],
                            [
                                21.8168,
                                63.25691
                            ],
                            [
                                21.51941,
                                63.22179
                            ],
                            [
                                21.61271,
                                63.0833
                            ],
                            [
                                21.46659,
                                63.0548
                            ],
                            [
                                21.48759,
                                63.0052
                            ],
                            [
                                21.40129,
                                62.8822
                            ],
                            [
                                21.12411,
                                62.79749
                            ],
                            [
                                21.17483,
                                62.73095
                            ],
                            [
                                21.08261,
                                62.68595
                            ],
                            [
                                21.15736,
                                62.56844
                            ],
                            [
                                21.13293,
                                62.49245
                            ],
                            [
                                21.23856,
                                62.39707
                            ],
                            [
                                21.36006,
                                62.36983
                            ],
                            [
                                21.32214,
                                62.24708
                            ],
                            [
                                21.4128,
                                62.2005
                            ],
                            [
                                21.31296,
                                62.15065
                            ],
                            [
                                21.29245,
                                62.00099
                            ],
                            [
                                21.40463,
                                61.93915
                            ],
                            [
                                21.56998,
                                61.73875
                            ],
                            [
                                21.50019,
                                61.59748
                            ],
                            [
                                21.54089,
                                61.53368
                            ],
                            [
                                21.48934,
                                61.43682
                            ],
                            [
                                21.56405,
                                61.33126
                            ],
                            [
                                21.44367,
                                61.18949
                            ],
                            [
                                21.46866,
                                61.13629
                            ],
                            [
                                21.32271,
                                61.03668
                            ],
                            [
                                21.35288,
                                60.96349
                            ],
                            [
                                21.17938,
                                60.8813
                            ],
                            [
                                21.24882,
                                60.80687
                            ],
                            [
                                21.37815,
                                60.82653
                            ],
                            [
                                21.40063,
                                60.75797
                            ],
                            [
                                21.34629,
                                60.68331
                            ],
                            [
                                21.47968,
                                60.58364
                            ],
                            [
                                21.56711,
                                60.56541
                            ],
                            [
                                21.76603,
                                60.47449
                            ],
                            [
                                21.95718,
                                60.53773
                            ],
                            [
                                22.01464,
                                60.46571
                            ],
                            [
                                22.29658,
                                60.38452
                            ],
                            [
                                22.55403,
                                60.38529
                            ],
                            [
                                22.55163,
                                60.32807
                            ],
                            [
                                22.47313,
                                60.28384
                            ],
                            [
                                22.62381,
                                60.23716
                            ],
                            [
                                22.79338,
                                60.25756
                            ],
                            [
                                22.98894,
                                60.33256
                            ],
                            [
                                23.03157,
                                60.31287
                            ],
                            [
                                22.87345,
                                60.19667
                            ],
                            [
                                22.91223,
                                60.14171
                            ],
                            [
                                23.03166,
                                60.12497
                            ],
                            [
                                22.98931,
                                60.0334
                            ],
                            [
                                22.88012,
                                59.97847
                            ],
                            [
                                22.96536,
                                59.90611
                            ],
                            [
                                23.16341,
                                59.94004
                            ],
                            [
                                23.16031,
                                59.88915
                            ],
                            [
                                23.53544,
                                59.93644
                            ],
                            [
                                23.68846,
                                59.93745
                            ],
                            [
                                23.93343,
                                59.99447
                            ],
                            [
                                23.99799,
                                60.03065
                            ],
                            [
                                24.35951,
                                60.03769
                            ],
                            [
                                24.45694,
                                59.98656
                            ],
                            [
                                24.64741,
                                60.10317
                            ],
                            [
                                24.98308,
                                60.20818
                            ],
                            [
                                25.16822,
                                60.19595
                            ],
                            [
                                25.23226,
                                60.24883
                            ],
                            [
                                25.36189,
                                60.27013
                            ],
                            [
                                25.43699,
                                60.22413
                            ],
                            [
                                25.55246,
                                60.31246
                            ],
                            [
                                25.63723,
                                60.3297
                            ],
                            [
                                25.75336,
                                60.24644
                            ],
                            [
                                25.87459,
                                60.26714
                            ],
                            [
                                25.86626,
                                60.32402
                            ],
                            [
                                25.99303,
                                60.35286
                            ],
                            [
                                26.05402,
                                60.4252
                            ],
                            [
                                26.15517,
                                60.40013
                            ],
                            [
                                26.28275,
                                60.42255
                            ],
                            [
                                26.40319,
                                60.35802
                            ],
                            [
                                26.45364,
                                60.42046
                            ],
                            [
                                26.65877,
                                60.41766
                            ],
                            [
                                26.98815,
                                60.49709
                            ],
                            [
                                27.06495,
                                60.53463
                            ],
                            [
                                27.59424,
                                60.48283
                            ],
                            [
                                27.74173,
                                60.50286
                            ],
                            [
                                27.80357,
                                60.54862
                            ],
                            [
                                27.87349,
                                60.60446
                            ],
                            [
                                28.13488,
                                60.74072
                            ],
                            [
                                28.52405,
                                60.95555
                            ],
                            [
                                28.65564,
                                60.95072
                            ],
                            [
                                28.71513,
                                61.04435
                            ],
                            [
                                28.8197,
                                61.12147
                            ],
                            [
                                29.24365,
                                61.27028
                            ],
                            [
                                29.32498,
                                61.34934
                            ],
                            [
                                29.50236,
                                61.46102
                            ],
                            [
                                29.74073,
                                61.57612
                            ],
                            [
                                29.82001,
                                61.65591
                            ],
                            [
                                30.03728,
                                61.76498
                            ],
                            [
                                30.306,
                                61.96426
                            ],
                            [
                                30.60312,
                                62.1421
                            ],
                            [
                                31.13809,
                                62.44198
                            ],
                            [
                                31.22247,
                                62.49952
                            ],
                            [
                                31.34699,
                                62.643
                            ],
                            [
                                31.43834,
                                62.78352
                            ],
                            [
                                31.58601,
                                62.90847
                            ],
                            [
                                31.46144,
                                63.02497
                            ],
                            [
                                31.2653,
                                63.11565
                            ],
                            [
                                31.23894,
                                63.21813
                            ],
                            [
                                30.78667,
                                63.4054
                            ],
                            [
                                30.48478,
                                63.46662
                            ],
                            [
                                30.3846,
                                63.54527
                            ],
                            [
                                30.24267,
                                63.60802
                            ],
                            [
                                29.97192,
                                63.75717
                            ],
                            [
                                30.26131,
                                63.82331
                            ],
                            [
                                30.32145,
                                63.9098
                            ],
                            [
                                30.52687,
                                64.04786
                            ],
                            [
                                30.5529,
                                64.13233
                            ],
                            [
                                30.46722,
                                64.20381
                            ],
                            [
                                30.48263,
                                64.26172
                            ],
                            [
                                30.04572,
                                64.40174
                            ],
                            [
                                30.05785,
                                64.45159
                            ],
                            [
                                29.9898,
                                64.58715
                            ],
                            [
                                30.13511,
                                64.64944
                            ],
                            [
                                30.04194,
                                64.74013
                            ],
                            [
                                30.04142,
                                64.79275
                            ],
                            [
                                29.74051,
                                64.78993
                            ],
                            [
                                29.64496,
                                64.8668
                            ],
                            [
                                29.59977,
                                64.99508
                            ],
                            [
                                29.62796,
                                65.06072
                            ],
                            [
                                29.73173,
                                65.09089
                            ],
                            [
                                29.89311,
                                65.1933
                            ],
                            [
                                29.60181,
                                65.25994
                            ],
                            [
                                29.7466,
                                65.34741
                            ],
                            [
                                29.73307,
                                65.4725
                            ],
                            [
                                29.86392,
                                65.56045
                            ],
                            [
                                29.72189,
                                65.63709
                            ],
                            [
                                30.01636,
                                65.69615
                            ],
                            [
                                30.13398,
                                65.70002
                            ],
                            [
                                30.06827,
                                65.89527
                            ],
                            [
                                29.99719,
                                65.97937
                            ],
                            [
                                29.92368,
                                66.12643
                            ],
                            [
                                29.71116,
                                66.26713
                            ],
                            [
                                29.5197,
                                66.4961
                            ],
                            [
                                29.35482,
                                66.64108
                            ],
                            [
                                29.11796,
                                66.80159
                            ],
                            [
                                29.03362,
                                66.92462
                            ],
                            [
                                29.07402,
                                66.99661
                            ],
                            [
                                29.51492,
                                67.27962
                            ],
                            [
                                29.52334,
                                67.30969
                            ],
                            [
                                29.71064,
                                67.38964
                            ],
                            [
                                29.93022,
                                67.52253
                            ],
                            [
                                30.01704,
                                67.67356
                            ],
                            [
                                29.6594,
                                67.80296
                            ],
                            [
                                29.32661,
                                68.07446
                            ],
                            [
                                28.64614,
                                68.1963
                            ],
                            [
                                28.43392,
                                68.53967
                            ],
                            [
                                28.70617,
                                68.7322
                            ],
                            [
                                28.80016,
                                68.86872
                            ],
                            [
                                28.47003,
                                68.88548
                            ],
                            [
                                28.49577,
                                68.93013
                            ],
                            [
                                28.92968,
                                69.0519
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                19.91096,
                                60.42198
                            ],
                            [
                                19.7634,
                                60.40415
                            ],
                            [
                                19.87249,
                                60.32892
                            ],
                            [
                                19.88728,
                                60.27348
                            ],
                            [
                                19.79623,
                                60.21965
                            ],
                            [
                                19.72009,
                                60.29551
                            ],
                            [
                                19.6428,
                                60.2971
                            ],
                            [
                                19.73311,
                                60.11592
                            ],
                            [
                                19.76562,
                                60.09143
                            ],
                            [
                                19.96231,
                                60.08454
                            ],
                            [
                                20.08129,
                                60.18763
                            ],
                            [
                                20.2175,
                                60.19884
                            ],
                            [
                                20.2709,
                                60.28307
                            ],
                            [
                                20.1873,
                                60.3438
                            ],
                            [
                                19.98423,
                                60.37497
                            ],
                            [
                                19.91096,
                                60.42198
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                22.9758,
                                60.3143
                            ],
                            [
                                22.84341,
                                60.2383
                            ],
                            [
                                22.45912,
                                60.20322
                            ],
                            [
                                22.48849,
                                60.15834
                            ],
                            [
                                22.36998,
                                60.08988
                            ],
                            [
                                22.39008,
                                60.00389
                            ],
                            [
                                22.58243,
                                60.03597
                            ],
                            [
                                22.66267,
                                59.99721
                            ],
                            [
                                22.78547,
                                60.0305
                            ],
                            [
                                22.77992,
                                60.07879
                            ],
                            [
                                22.87349,
                                60.13521
                            ],
                            [
                                22.83754,
                                60.1787
                            ],
                            [
                                22.9758,
                                60.3143
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                24.88062,
                                65.08534
                            ],
                            [
                                24.64784,
                                65.08172
                            ],
                            [
                                24.55869,
                                65.03835
                            ],
                            [
                                24.65604,
                                64.95975
                            ],
                            [
                                24.76995,
                                64.93538
                            ],
                            [
                                24.87711,
                                64.96819
                            ],
                            [
                                24.8187,
                                65.03954
                            ],
                            [
                                24.88062,
                                65.08534
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                22.4417,
                                60.35017
                            ],
                            [
                                22.10619,
                                60.32585
                            ],
                            [
                                22.11933,
                                60.24005
                            ],
                            [
                                22.19843,
                                60.19678
                            ],
                            [
                                22.40886,
                                60.24862
                            ],
                            [
                                22.50956,
                                60.33639
                            ],
                            [
                                22.4417,
                                60.35017
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                21.16849,
                                63.30348
                            ],
                            [
                                21.08826,
                                63.28377
                            ],
                            [
                                21.1757,
                                63.18545
                            ],
                            [
                                21.2711,
                                63.1587
                            ],
                            [
                                21.4598,
                                63.20762
                            ],
                            [
                                21.38723,
                                63.27967
                            ],
                            [
                                21.26658,
                                63.24137
                            ],
                            [
                                21.16849,
                                63.30348
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                21.87894,
                                60.4797
                            ],
                            [
                                21.82148,
                                60.48397
                            ],
                            [
                                21.82955,
                                60.35884
                            ],
                            [
                                22.04525,
                                60.35564
                            ],
                            [
                                21.87894,
                                60.4797
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                21.28731,
                                60.67036
                            ],
                            [
                                21.22962,
                                60.64261
                            ],
                            [
                                21.33677,
                                60.54336
                            ],
                            [
                                21.43081,
                                60.55596
                            ],
                            [
                                21.28731,
                                60.67036
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                19.64589,
                                60.25024
                            ],
                            [
                                19.53348,
                                60.23261
                            ],
                            [
                                19.51854,
                                60.17686
                            ],
                            [
                                19.668,
                                60.17701
                            ],
                            [
                                19.64589,
                                60.25024
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                20.11165,
                                60.10092
                            ],
                            [
                                20.11681,
                                60.0002
                            ],
                            [
                                20.20096,
                                59.98185
                            ],
                            [
                                20.22071,
                                60.07784
                            ],
                            [
                                20.11165,
                                60.10092
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                21.88783,
                                60.2188
                            ],
                            [
                                21.73097,
                                60.2005
                            ],
                            [
                                21.70025,
                                60.13494
                            ],
                            [
                                21.92452,
                                60.18187
                            ],
                            [
                                21.88783,
                                60.2188
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                22.23022,
                                63.34797
                            ],
                            [
                                21.9982,
                                63.32572
                            ],
                            [
                                21.96964,
                                63.28609
                            ],
                            [
                                22.11459,
                                63.2579
                            ],
                            [
                                22.23768,
                                63.30236
                            ],
                            [
                                22.23022,
                                63.34797
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                21.6738,
                                60.14916
                            ],
                            [
                                21.5805,
                                60.18517
                            ],
                            [
                                21.50068,
                                60.10457
                            ],
                            [
                                21.64235,
                                60.11262
                            ],
                            [
                                21.6738,
                                60.14916
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                13.38928,
                                54.68316
                            ],
                            [
                                13.249,
                                54.65961
                            ],
                            [
                                13.33263,
                                54.58259
                            ],
                            [
                                13.36906,
                                54.61431
                            ],
                            [
                                13.39611,
                                54.57272
                            ],
                            [
                                13.44602,
                                54.55195
                            ],
                            [
                                13.50239,
                                54.54742
                            ],
                            [
                                13.4716,
                                54.45729
                            ],
                            [
                                13.35647,
                                54.58085
                            ],
                            [
                                13.29757,
                                54.55225
                            ],
                            [
                                13.17015,
                                54.54566
                            ],
                            [
                                13.14579,
                                54.47866
                            ],
                            [
                                13.23691,
                                54.40682
                            ],
                            [
                                13.13061,
                                54.37227
                            ],
                            [
                                13.11535,
                                54.33205
                            ],
                            [
                                13.32168,
                                54.23892
                            ],
                            [
                                13.50735,
                                54.34374
                            ],
                            [
                                13.75366,
                                54.3436
                            ],
                            [
                                13.61694,
                                54.40183
                            ],
                            [
                                13.57181,
                                54.4728
                            ],
                            [
                                13.66715,
                                54.52038
                            ],
                            [
                                13.63459,
                                54.5852
                            ],
                            [
                                13.45964,
                                54.57081
                            ],
                            [
                                13.39611,
                                54.59614
                            ],
                            [
                                13.38928,
                                54.68316
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.2263,
                                53.92865
                            ],
                            [
                                14.01478,
                                54.05423
                            ],
                            [
                                13.83909,
                                54.12606
                            ],
                            [
                                13.79069,
                                54.04986
                            ],
                            [
                                13.92487,
                                54.06311
                            ],
                            [
                                14.04708,
                                53.99698
                            ],
                            [
                                13.90834,
                                53.98993
                            ],
                            [
                                13.93787,
                                53.91293
                            ],
                            [
                                13.8987,
                                53.84042
                            ],
                            [
                                14.08521,
                                53.87451
                            ],
                            [
                                14.21308,
                                53.86648
                            ],
                            [
                                14.2263,
                                53.92865
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                11.19997,
                                54.50914
                            ],
                            [
                                11.06931,
                                54.5339
                            ],
                            [
                                11.01191,
                                54.44231
                            ],
                            [
                                11.09733,
                                54.41254
                            ],
                            [
                                11.31125,
                                54.40448
                            ],
                            [
                                11.19997,
                                54.50914
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.51379,
                                54.75397
                            ],
                            [
                                8.40265,
                                54.70044
                            ],
                            [
                                8.56724,
                                54.68076
                            ],
                            [
                                8.51379,
                                54.75397
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -7.25607,
                                55.06703
                            ],
                            [
                                -7.16639,
                                55.14392
                            ],
                            [
                                -6.9513,
                                55.21024
                            ],
                            [
                                -6.95676,
                                55.25368
                            ],
                            [
                                -7.15678,
                                55.2972
                            ],
                            [
                                -7.1901,
                                55.34533
                            ],
                            [
                                -7.33187,
                                55.36837
                            ],
                            [
                                -7.38326,
                                55.29327
                            ],
                            [
                                -7.48017,
                                55.28178
                            ],
                            [
                                -7.54811,
                                55.20144
                            ],
                            [
                                -7.70177,
                                55.24846
                            ],
                            [
                                -7.86505,
                                55.2268
                            ],
                            [
                                -7.95804,
                                55.18632
                            ],
                            [
                                -8.17766,
                                55.14722
                            ],
                            [
                                -8.28415,
                                55.1582
                            ],
                            [
                                -8.31537,
                                55.0762
                            ],
                            [
                                -8.45609,
                                54.99891
                            ],
                            [
                                -8.37909,
                                54.9397
                            ],
                            [
                                -8.49902,
                                54.84545
                            ],
                            [
                                -8.53726,
                                54.76531
                            ],
                            [
                                -8.60359,
                                54.77868
                            ],
                            [
                                -8.74316,
                                54.73726
                            ],
                            [
                                -8.76988,
                                54.65691
                            ],
                            [
                                -8.67747,
                                54.6199
                            ],
                            [
                                -8.34223,
                                54.63069
                            ],
                            [
                                -8.22101,
                                54.56844
                            ],
                            [
                                -8.28817,
                                54.47905
                            ],
                            [
                                -8.45143,
                                54.46086
                            ],
                            [
                                -8.48968,
                                54.41882
                            ],
                            [
                                -8.66423,
                                54.36282
                            ],
                            [
                                -8.5556,
                                54.34165
                            ],
                            [
                                -8.59363,
                                54.28267
                            ],
                            [
                                -8.82347,
                                54.25333
                            ],
                            [
                                -8.94785,
                                54.29431
                            ],
                            [
                                -9.05305,
                                54.2941
                            ],
                            [
                                -9.10036,
                                54.21213
                            ],
                            [
                                -9.2145,
                                54.21234
                            ],
                            [
                                -9.20772,
                                54.27657
                            ],
                            [
                                -9.34658,
                                54.3191
                            ],
                            [
                                -9.66107,
                                54.3137
                            ],
                            [
                                -9.807,
                                54.34161
                            ],
                            [
                                -9.87718,
                                54.25562
                            ],
                            [
                                -9.99514,
                                54.30374
                            ],
                            [
                                -10.0769,
                                54.26946
                            ],
                            [
                                -10.043,
                                54.19283
                            ],
                            [
                                -9.95285,
                                54.19566
                            ],
                            [
                                -9.92877,
                                54.11989
                            ],
                            [
                                -9.98212,
                                54.10576
                            ],
                            [
                                -9.84938,
                                53.96977
                            ],
                            [
                                -9.90588,
                                53.95374
                            ],
                            [
                                -9.90365,
                                53.86365
                            ],
                            [
                                -9.68458,
                                53.89993
                            ],
                            [
                                -9.57778,
                                53.86562
                            ],
                            [
                                -9.61724,
                                53.81378
                            ],
                            [
                                -9.70731,
                                53.77788
                            ],
                            [
                                -9.90041,
                                53.76352
                            ],
                            [
                                -9.91888,
                                53.68977
                            ],
                            [
                                -9.87431,
                                53.63245
                            ],
                            [
                                -9.9945,
                                53.61028
                            ],
                            [
                                -10.14658,
                                53.54131
                            ],
                            [
                                -10.01175,
                                53.38174
                            ],
                            [
                                -9.86504,
                                53.38975
                            ],
                            [
                                -9.90409,
                                53.32525
                            ],
                            [
                                -9.73134,
                                53.31126
                            ],
                            [
                                -9.63807,
                                53.3869
                            ],
                            [
                                -9.59984,
                                53.28224
                            ],
                            [
                                -9.52548,
                                53.22263
                            ],
                            [
                                -9.04318,
                                53.26875
                            ],
                            [
                                -8.94472,
                                53.19206
                            ],
                            [
                                -9.00931,
                                53.14082
                            ],
                            [
                                -9.13909,
                                53.12121
                            ],
                            [
                                -9.26378,
                                53.15387
                            ],
                            [
                                -9.40732,
                                53.02031
                            ],
                            [
                                -9.43251,
                                52.96661
                            ],
                            [
                                -9.35323,
                                52.91816
                            ],
                            [
                                -9.43332,
                                52.8823
                            ],
                            [
                                -9.49828,
                                52.75053
                            ],
                            [
                                -9.62606,
                                52.73219
                            ],
                            [
                                -9.67606,
                                52.68025
                            ],
                            [
                                -9.81538,
                                52.60167
                            ],
                            [
                                -9.55332,
                                52.63632
                            ],
                            [
                                -9.31311,
                                52.5874
                            ],
                            [
                                -9.11791,
                                52.64629
                            ],
                            [
                                -8.97522,
                                52.7601
                            ],
                            [
                                -8.93507,
                                52.65498
                            ],
                            [
                                -9.29029,
                                52.57153
                            ],
                            [
                                -9.62154,
                                52.58032
                            ],
                            [
                                -9.68928,
                                52.48325
                            ],
                            [
                                -9.83804,
                                52.38883
                            ],
                            [
                                -9.84899,
                                52.27933
                            ],
                            [
                                -9.90315,
                                52.22917
                            ],
                            [
                                -10.03484,
                                52.28181
                            ],
                            [
                                -10.08303,
                                52.24963
                            ],
                            [
                                -10.25577,
                                52.27194
                            ],
                            [
                                -10.47088,
                                52.1818
                            ],
                            [
                                -10.45155,
                                52.09723
                            ],
                            [
                                -9.86431,
                                52.15931
                            ],
                            [
                                -9.98024,
                                52.0521
                            ],
                            [
                                -10.25368,
                                51.9902
                            ],
                            [
                                -10.28581,
                                51.90317
                            ],
                            [
                                -10.38491,
                                51.88373
                            ],
                            [
                                -10.27525,
                                51.80689
                            ],
                            [
                                -10.09969,
                                51.75598
                            ],
                            [
                                -9.8813,
                                51.8172
                            ],
                            [
                                -9.8891,
                                51.74336
                            ],
                            [
                                -10.05778,
                                51.65119
                            ],
                            [
                                -10.03911,
                                51.58927
                            ],
                            [
                                -9.90752,
                                51.65193
                            ],
                            [
                                -9.62524,
                                51.68118
                            ],
                            [
                                -9.53077,
                                51.73018
                            ],
                            [
                                -9.44626,
                                51.69132
                            ],
                            [
                                -9.78387,
                                51.57959
                            ],
                            [
                                -9.68671,
                                51.53207
                            ],
                            [
                                -9.83764,
                                51.48207
                            ],
                            [
                                -9.7959,
                                51.45062
                            ],
                            [
                                -9.6521,
                                51.51409
                            ],
                            [
                                -9.5869,
                                51.49785
                            ],
                            [
                                -9.42518,
                                51.50512
                            ],
                            [
                                -9.3447,
                                51.46953
                            ],
                            [
                                -9.26651,
                                51.50026
                            ],
                            [
                                -8.99912,
                                51.56637
                            ],
                            [
                                -8.92102,
                                51.54076
                            ],
                            [
                                -8.86992,
                                51.59507
                            ],
                            [
                                -8.69797,
                                51.58145
                            ],
                            [
                                -8.65943,
                                51.63522
                            ],
                            [
                                -8.55086,
                                51.64282
                            ],
                            [
                                -8.29724,
                                51.7554
                            ],
                            [
                                -8.25374,
                                51.79282
                            ],
                            [
                                -8.15828,
                                51.78873
                            ],
                            [
                                -8.02401,
                                51.81934
                            ],
                            [
                                -7.91604,
                                51.87303
                            ],
                            [
                                -7.8677,
                                51.92881
                            ],
                            [
                                -7.58629,
                                51.99217
                            ],
                            [
                                -7.63572,
                                52.08145
                            ],
                            [
                                -7.36651,
                                52.13874
                            ],
                            [
                                -7.02393,
                                52.13395
                            ],
                            [
                                -6.9019,
                                52.15575
                            ],
                            [
                                -6.78552,
                                52.20485
                            ],
                            [
                                -6.68292,
                                52.21854
                            ],
                            [
                                -6.58905,
                                52.1747
                            ],
                            [
                                -6.49111,
                                52.19078
                            ],
                            [
                                -6.36175,
                                52.17384
                            ],
                            [
                                -6.31486,
                                52.24036
                            ],
                            [
                                -6.44614,
                                52.30741
                            ],
                            [
                                -6.3586,
                                52.34851
                            ],
                            [
                                -6.34695,
                                52.41532
                            ],
                            [
                                -6.19419,
                                52.56351
                            ],
                            [
                                -6.2293,
                                52.62611
                            ],
                            [
                                -6.1422,
                                52.73303
                            ],
                            [
                                -6.13875,
                                52.8022
                            ],
                            [
                                -6.06436,
                                52.86764
                            ],
                            [
                                -6.00764,
                                52.9722
                            ],
                            [
                                -6.04681,
                                52.99122
                            ],
                            [
                                -6.04222,
                                53.11981
                            ],
                            [
                                -6.10162,
                                53.2078
                            ],
                            [
                                -6.09205,
                                53.2729
                            ],
                            [
                                -6.21066,
                                53.33275
                            ],
                            [
                                -6.11406,
                                53.40652
                            ],
                            [
                                -6.13379,
                                53.46846
                            ],
                            [
                                -6.07978,
                                53.54894
                            ],
                            [
                                -6.23194,
                                53.66612
                            ],
                            [
                                -6.25133,
                                53.73115
                            ],
                            [
                                -6.23887,
                                53.86103
                            ],
                            [
                                -6.3305,
                                53.87601
                            ],
                            [
                                -6.36527,
                                53.98041
                            ],
                            [
                                -6.30204,
                                54.00986
                            ],
                            [
                                -6.16538,
                                53.97721
                            ],
                            [
                                -6.104,
                                54.00011
                            ],
                            [
                                -6.26802,
                                54.10234
                            ],
                            [
                                -6.36625,
                                54.1122
                            ],
                            [
                                -6.456,
                                54.07162
                            ],
                            [
                                -6.62378,
                                54.03655
                            ],
                            [
                                -6.66091,
                                54.06293
                            ],
                            [
                                -6.63175,
                                54.14802
                            ],
                            [
                                -6.81539,
                                54.22329
                            ],
                            [
                                -6.87662,
                                54.34616
                            ],
                            [
                                -7.02864,
                                54.42131
                            ],
                            [
                                -7.15384,
                                54.33527
                            ],
                            [
                                -7.14582,
                                54.22494
                            ],
                            [
                                -7.24898,
                                54.20341
                            ],
                            [
                                -7.33645,
                                54.11685
                            ],
                            [
                                -7.44366,
                                54.15276
                            ],
                            [
                                -7.56591,
                                54.12717
                            ],
                            [
                                -7.69328,
                                54.20501
                            ],
                            [
                                -7.85953,
                                54.21745
                            ],
                            [
                                -7.88697,
                                54.29935
                            ],
                            [
                                -7.94658,
                                54.30429
                            ],
                            [
                                -8.15599,
                                54.43795
                            ],
                            [
                                -8.04336,
                                54.48838
                            ],
                            [
                                -8.006,
                                54.54595
                            ],
                            [
                                -7.85749,
                                54.53632
                            ],
                            [
                                -7.7522,
                                54.61868
                            ],
                            [
                                -7.89245,
                                54.65663
                            ],
                            [
                                -7.85552,
                                54.72603
                            ],
                            [
                                -7.74717,
                                54.70452
                            ],
                            [
                                -7.54889,
                                54.78959
                            ],
                            [
                                -7.4423,
                                54.87416
                            ],
                            [
                                -7.44501,
                                54.93701
                            ],
                            [
                                -7.344,
                                55.05054
                            ],
                            [
                                -7.25607,
                                55.06703
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -9.96008,
                                54.01886
                            ],
                            [
                                -10.10116,
                                54.00142
                            ],
                            [
                                -9.96021,
                                53.87451
                            ],
                            [
                                -9.92514,
                                53.95474
                            ],
                            [
                                -9.96008,
                                54.01886
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                17.64916,
                                42.88892
                            ],
                            [
                                17.30426,
                                43.00143
                            ],
                            [
                                17.21443,
                                42.98174
                            ],
                            [
                                17.45262,
                                42.86766
                            ],
                            [
                                17.78205,
                                42.78766
                            ],
                            [
                                17.80595,
                                42.8066
                            ],
                            [
                                18.11916,
                                42.63961
                            ],
                            [
                                18.2301,
                                42.59952
                            ],
                            [
                                18.28051,
                                42.52872
                            ],
                            [
                                18.52521,
                                42.42046
                            ],
                            [
                                18.43499,
                                42.48403
                            ],
                            [
                                18.4381,
                                42.5557
                            ],
                            [
                                18.36668,
                                42.6155
                            ],
                            [
                                18.24622,
                                42.60288
                            ],
                            [
                                18.10315,
                                42.71336
                            ],
                            [
                                17.94929,
                                42.79898
                            ],
                            [
                                17.8885,
                                42.81694
                            ],
                            [
                                17.84165,
                                42.90353
                            ],
                            [
                                17.79109,
                                42.89257
                            ],
                            [
                                17.67781,
                                42.91985
                            ],
                            [
                                17.64916,
                                42.88892
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.42641,
                                44.98332
                            ],
                            [
                                14.40017,
                                44.92177
                            ],
                            [
                                14.3042,
                                44.93621
                            ],
                            [
                                14.39177,
                                44.69768
                            ],
                            [
                                14.45687,
                                44.62797
                            ],
                            [
                                14.51082,
                                44.64543
                            ],
                            [
                                14.44768,
                                44.86644
                            ],
                            [
                                14.46936,
                                44.94961
                            ],
                            [
                                14.42641,
                                44.98332
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.56577,
                                45.24075
                            ],
                            [
                                14.53211,
                                45.21662
                            ],
                            [
                                14.52643,
                                45.1254
                            ],
                            [
                                14.43239,
                                45.08745
                            ],
                            [
                                14.48927,
                                45.02687
                            ],
                            [
                                14.62256,
                                45.00984
                            ],
                            [
                                14.7091,
                                44.94225
                            ],
                            [
                                14.80974,
                                44.99078
                            ],
                            [
                                14.71766,
                                45.07158
                            ],
                            [
                                14.67509,
                                45.07859
                            ],
                            [
                                14.64577,
                                45.15891
                            ],
                            [
                                14.56577,
                                45.24075
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                16.49873,
                                43.38466
                            ],
                            [
                                16.44049,
                                43.39209
                            ],
                            [
                                16.44037,
                                43.30563
                            ],
                            [
                                16.532,
                                43.27024
                            ],
                            [
                                16.78112,
                                43.26212
                            ],
                            [
                                16.87847,
                                43.28213
                            ],
                            [
                                16.88941,
                                43.31984
                            ],
                            [
                                16.77912,
                                43.35755
                            ],
                            [
                                16.49873,
                                43.38466
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                16.57314,
                                43.22704
                            ],
                            [
                                16.40719,
                                43.18297
                            ],
                            [
                                16.541,
                                43.14054
                            ],
                            [
                                16.68124,
                                43.12119
                            ],
                            [
                                16.93731,
                                43.11241
                            ],
                            [
                                16.96879,
                                43.15057
                            ],
                            [
                                16.7091,
                                43.16107
                            ],
                            [
                                16.65086,
                                43.21679
                            ],
                            [
                                16.57314,
                                43.22704
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.88034,
                                44.57525
                            ],
                            [
                                14.95568,
                                44.4669
                            ],
                            [
                                15.08158,
                                44.39704
                            ],
                            [
                                15.10065,
                                44.32728
                            ],
                            [
                                15.21393,
                                44.31402
                            ],
                            [
                                15.24683,
                                44.34908
                            ],
                            [
                                15.11508,
                                44.44111
                            ],
                            [
                                14.97675,
                                44.50311
                            ],
                            [
                                14.98623,
                                44.53608
                            ],
                            [
                                14.88034,
                                44.57525
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                16.6939,
                                42.99299
                            ],
                            [
                                16.66533,
                                42.92597
                            ],
                            [
                                16.89326,
                                42.89732
                            ],
                            [
                                16.97391,
                                42.92669
                            ],
                            [
                                17.12007,
                                42.90823
                            ],
                            [
                                17.13363,
                                42.96146
                            ],
                            [
                                17.04267,
                                42.97942
                            ],
                            [
                                16.8507,
                                42.95763
                            ],
                            [
                                16.6939,
                                42.99299
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                16.1973,
                                43.07383
                            ],
                            [
                                16.08291,
                                43.07004
                            ],
                            [
                                16.11179,
                                43.00731
                            ],
                            [
                                16.21224,
                                43.01803
                            ],
                            [
                                16.1973,
                                43.07383
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.72408,
                                44.84982
                            ],
                            [
                                14.70173,
                                44.75776
                            ],
                            [
                                14.83081,
                                44.75354
                            ],
                            [
                                14.72408,
                                44.84982
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "ECU",
                "Country": "Ecuador",
                "Total_3GHG": 0.24,
                "Total_3GHG_timeseries": [
                    3.729e-06,
                    6.6689e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.004
                ],
                "Fossil_3GHG": 0.11,
                "Fossil_3GHG_timeseries": [
                    1.3767e-07,
                    2.8291e-07,
                    4.3572e-07,
                    5.9611e-07,
                    7.6407e-07,
                    9.6283e-07,
                    1.1508e-06,
                    1.3283e-06,
                    1.5037e-06,
                    1.6768e-06,
                    1.8471e-06,
                    2.0146e-06,
                    2.1793e-06,
                    2.3412e-06,
                    2.5003e-06,
                    2.6565e-06,
                    2.81e-06,
                    2.9607e-06,
                    3.1086e-06,
                    3.2537e-06,
                    3.3837e-06,
                    3.4985e-06,
                    3.5985e-06,
                    3.684e-06,
                    3.7552e-06,
                    3.8048e-06,
                    3.8719e-06,
                    3.9563e-06,
                    4.0453e-06,
                    4.1386e-06,
                    4.2356e-06,
                    4.3362e-06,
                    4.4404e-06,
                    4.5483e-06,
                    4.6599e-06,
                    4.7768e-06,
                    4.8992e-06,
                    5.0272e-06,
                    5.1606e-06,
                    5.3001e-06,
                    5.4518e-06,
                    5.6154e-06,
                    5.791e-06,
                    5.9784e-06,
                    6.1774e-06,
                    6.3746e-06,
                    6.57e-06,
                    6.7751e-06,
                    6.9956e-06,
                    7.2325e-06,
                    7.4762e-06,
                    7.7271e-06,
                    7.985e-06,
                    8.2501e-06,
                    8.5227e-06,
                    8.8009e-06,
                    9.0849e-06,
                    9.3746e-06,
                    9.6701e-06,
                    9.9711e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012
                ],
                "Land_3GHG": 0.48,
                "Land_3GHG_timeseries": [
                    3.5914e-06,
                    6.386e-06,
                    9.7868e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028
                ],
                "Total_CO2": 0.25,
                "Total_CO2_timeseries": [
                    3.2196e-06,
                    5.64e-06,
                    8.6641e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028
                ],
                "Fossil_CO2": 0.08,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.155e-08,
                    2.31e-08,
                    3.465e-08,
                    4.62e-08,
                    5.775e-08,
                    6.93e-08,
                    8.58e-08,
                    1.056e-07,
                    1.3695e-07,
                    1.782e-07,
                    2.838e-07,
                    4.9665e-07,
                    7.6725e-07,
                    1.0725e-06,
                    1.4174e-06,
                    1.7374e-06,
                    2.0641e-06,
                    2.3942e-06,
                    2.7472e-06,
                    3.1416e-06,
                    3.5805e-06,
                    4.0441e-06,
                    4.5259e-06,
                    5.0159e-06,
                    5.3442e-06,
                    5.8178e-06,
                    6.2929e-06,
                    6.8901e-06,
                    7.4428e-06,
                    7.9394e-06,
                    8.4607e-06,
                    9.0398e-06,
                    9.6255e-06,
                    9.9587e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006
                ],
                "Land_CO2": 0.62,
                "Land_CO2_timeseries": [
                    3.2196e-06,
                    5.64e-06,
                    8.6641e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022
                ],
                "Total_CH4": 0.25,
                "Total_CH4_timeseries": [
                    4.9063e-07,
                    9.9103e-07,
                    1.5012e-06,
                    2.0211e-06,
                    2.5508e-06,
                    3.1136e-06,
                    3.6677e-06,
                    4.2136e-06,
                    4.7596e-06,
                    5.3056e-06,
                    5.8491e-06,
                    6.3902e-06,
                    6.9289e-06,
                    7.4651e-06,
                    7.9989e-06,
                    8.5302e-06,
                    9.0591e-06,
                    9.5856e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011
                ],
                "Fossil_CH4": 0.23,
                "Fossil_CH4_timeseries": [
                    1.2686e-07,
                    2.6115e-07,
                    4.0289e-07,
                    5.5207e-07,
                    7.087e-07,
                    8.9601e-07,
                    1.0724e-06,
                    1.2383e-06,
                    1.4018e-06,
                    1.5631e-06,
                    1.7215e-06,
                    1.877e-06,
                    2.0295e-06,
                    2.1792e-06,
                    2.326e-06,
                    2.4699e-06,
                    2.611e-06,
                    2.7491e-06,
                    2.8844e-06,
                    3.0168e-06,
                    3.134e-06,
                    3.2357e-06,
                    3.3225e-06,
                    3.3943e-06,
                    3.4516e-06,
                    3.4868e-06,
                    3.5393e-06,
                    3.6088e-06,
                    3.6826e-06,
                    3.7605e-06,
                    3.842e-06,
                    3.927e-06,
                    4.0155e-06,
                    4.1075e-06,
                    4.2031e-06,
                    4.3039e-06,
                    4.4101e-06,
                    4.5217e-06,
                    4.6388e-06,
                    4.7614e-06,
                    4.896e-06,
                    5.0425e-06,
                    5.2007e-06,
                    5.3704e-06,
                    5.5516e-06,
                    5.7308e-06,
                    5.9078e-06,
                    6.0944e-06,
                    6.2961e-06,
                    6.514e-06,
                    6.7384e-06,
                    6.9696e-06,
                    7.2076e-06,
                    7.4524e-06,
                    7.7043e-06,
                    7.9616e-06,
                    8.2243e-06,
                    8.4922e-06,
                    8.7657e-06,
                    9.0443e-06,
                    9.3271e-06,
                    9.6139e-06,
                    9.9046e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006
                ],
                "Land_CH4": 0.29,
                "Land_CH4_timeseries": [
                    3.6378e-07,
                    7.2988e-07,
                    1.0983e-06,
                    1.4691e-06,
                    1.8421e-06,
                    2.2176e-06,
                    2.5953e-06,
                    2.9754e-06,
                    3.3578e-06,
                    3.7425e-06,
                    4.1276e-06,
                    4.5133e-06,
                    4.8993e-06,
                    5.2859e-06,
                    5.6728e-06,
                    6.0603e-06,
                    6.4482e-06,
                    6.8365e-06,
                    7.2253e-06,
                    7.6145e-06,
                    8.0118e-06,
                    8.4173e-06,
                    8.8309e-06,
                    9.2525e-06,
                    9.6823e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Total_N2O": 0.14,
                "Total_N2O_timeseries": [
                    1.878e-08,
                    3.7854e-08,
                    5.7212e-08,
                    7.6843e-08,
                    9.6729e-08,
                    1.1685e-07,
                    1.3719e-07,
                    1.5771e-07,
                    1.7838e-07,
                    1.9918e-07,
                    2.2008e-07,
                    2.4107e-07,
                    2.6216e-07,
                    2.8333e-07,
                    3.046e-07,
                    3.2594e-07,
                    3.4738e-07,
                    3.6891e-07,
                    3.9054e-07,
                    4.1227e-07,
                    4.3428e-07,
                    4.5688e-07,
                    4.8032e-07,
                    5.0475e-07,
                    5.3028e-07,
                    5.5691e-07,
                    5.8462e-07,
                    6.1327e-07,
                    6.4267e-07,
                    6.7255e-07,
                    7.0275e-07,
                    7.3323e-07,
                    7.6394e-07,
                    7.9488e-07,
                    8.2603e-07,
                    8.5737e-07,
                    8.8891e-07,
                    9.2066e-07,
                    9.5263e-07,
                    9.9288e-07,
                    1.0337e-06,
                    1.0753e-06,
                    1.1183e-06,
                    1.1627e-06,
                    1.209e-06,
                    1.2574e-06,
                    1.308e-06,
                    1.361e-06,
                    1.4166e-06,
                    1.4747e-06,
                    1.5364e-06,
                    1.6033e-06,
                    1.6763e-06,
                    1.7564e-06,
                    1.8438e-06,
                    1.9384e-06,
                    2.0396e-06,
                    2.1466e-06,
                    2.258e-06,
                    2.3721e-06,
                    2.4877e-06,
                    2.6048e-06,
                    2.7234e-06,
                    2.8432e-06,
                    2.9643e-06,
                    3.0865e-06,
                    3.2096e-06,
                    3.3335e-06,
                    3.4581e-06,
                    3.5833e-06,
                    3.7085e-06,
                    3.8335e-06,
                    3.9577e-06,
                    4.081e-06,
                    4.2032e-06,
                    4.3243e-06,
                    4.4444e-06,
                    4.5638e-06,
                    4.6828e-06,
                    4.802e-06,
                    4.9221e-06,
                    5.044e-06,
                    5.1687e-06,
                    5.2966e-06,
                    5.4284e-06,
                    5.5643e-06,
                    5.7047e-06,
                    5.8494e-06,
                    5.9986e-06,
                    6.1519e-06,
                    6.3136e-06,
                    6.4916e-06,
                    6.6919e-06,
                    6.9188e-06,
                    7.1748e-06,
                    7.4607e-06,
                    7.7752e-06,
                    8.1157e-06,
                    8.4775e-06,
                    8.8541e-06,
                    9.2455e-06,
                    9.658e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_N2O": 0.07,
                "Fossil_N2O_timeseries": [
                    1.0811e-08,
                    2.1756e-08,
                    3.2833e-08,
                    4.4039e-08,
                    5.537e-08,
                    6.6821e-08,
                    7.8386e-08,
                    9.0057e-08,
                    1.0183e-07,
                    1.1369e-07,
                    1.2564e-07,
                    1.3767e-07,
                    1.4978e-07,
                    1.6198e-07,
                    1.7426e-07,
                    1.8662e-07,
                    1.9906e-07,
                    2.1159e-07,
                    2.242e-07,
                    2.3689e-07,
                    2.4972e-07,
                    2.6276e-07,
                    2.7607e-07,
                    2.8969e-07,
                    3.0365e-07,
                    3.1795e-07,
                    3.3258e-07,
                    3.4752e-07,
                    3.627e-07,
                    3.7807e-07,
                    3.9357e-07,
                    4.0921e-07,
                    4.2497e-07,
                    4.4084e-07,
                    4.5683e-07,
                    4.7292e-07,
                    4.8913e-07,
                    5.0545e-07,
                    5.2188e-07,
                    5.387e-07,
                    5.5571e-07,
                    5.7291e-07,
                    5.9032e-07,
                    6.0793e-07,
                    6.2577e-07,
                    6.4384e-07,
                    6.6213e-07,
                    6.8068e-07,
                    6.9947e-07,
                    7.1852e-07,
                    7.3784e-07,
                    7.5747e-07,
                    7.7742e-07,
                    7.9771e-07,
                    8.1834e-07,
                    8.3933e-07,
                    8.6068e-07,
                    8.8237e-07,
                    9.0441e-07,
                    9.2677e-07,
                    9.4944e-07,
                    9.7243e-07,
                    9.9572e-07,
                    1.0193e-06,
                    1.0432e-06,
                    1.0674e-06,
                    1.0919e-06,
                    1.1167e-06,
                    1.1418e-06,
                    1.1672e-06,
                    1.1929e-06,
                    1.2189e-06,
                    1.2452e-06,
                    1.2718e-06,
                    1.2987e-06,
                    1.3259e-06,
                    1.3534e-06,
                    1.3813e-06,
                    1.4094e-06,
                    1.4379e-06,
                    1.4667e-06,
                    1.4958e-06,
                    1.5253e-06,
                    1.555e-06,
                    1.5852e-06,
                    1.6156e-06,
                    1.6465e-06,
                    1.6777e-06,
                    1.7094e-06,
                    1.7416e-06,
                    1.7743e-06,
                    1.8079e-06,
                    1.8424e-06,
                    1.8781e-06,
                    1.9151e-06,
                    1.9533e-06,
                    1.9929e-06,
                    2.0338e-06,
                    2.0759e-06,
                    2.1191e-06,
                    2.1636e-06,
                    2.2096e-06,
                    2.2572e-06,
                    2.3068e-06,
                    2.3583e-06,
                    2.4119e-06,
                    2.4676e-06,
                    2.5254e-06,
                    2.5853e-06,
                    2.6472e-06,
                    2.7109e-06,
                    2.7763e-06,
                    2.8433e-06,
                    2.912e-06,
                    2.9825e-06,
                    3.055e-06,
                    3.1299e-06,
                    3.2074e-06,
                    3.2881e-06,
                    3.3804e-06,
                    3.4717e-06,
                    3.5653e-06,
                    3.665e-06,
                    3.7726e-06,
                    3.8876e-06,
                    4.0096e-06,
                    4.1404e-06,
                    4.2795e-06,
                    4.4226e-06,
                    4.5735e-06,
                    4.7379e-06,
                    4.912e-06,
                    5.0845e-06,
                    5.2728e-06,
                    5.4635e-06,
                    5.6557e-06,
                    5.8533e-06,
                    6.0807e-06,
                    6.2857e-06,
                    6.4836e-06,
                    6.6899e-06,
                    6.9001e-06,
                    7.1066e-06,
                    7.3226e-06,
                    7.5545e-06,
                    7.8231e-06,
                    8.1026e-06,
                    8.3915e-06,
                    8.6487e-06,
                    8.8744e-06,
                    9.1078e-06,
                    9.3433e-06,
                    9.5783e-06,
                    9.8287e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.16,
                "Land_N2O_timeseries": [
                    7.9693e-09,
                    1.6098e-08,
                    2.4379e-08,
                    3.2803e-08,
                    4.1359e-08,
                    5.003e-08,
                    5.88e-08,
                    6.765e-08,
                    7.6555e-08,
                    8.5492e-08,
                    9.4444e-08,
                    1.0341e-07,
                    1.1238e-07,
                    1.2136e-07,
                    1.3034e-07,
                    1.3933e-07,
                    1.4832e-07,
                    1.5733e-07,
                    1.6634e-07,
                    1.7537e-07,
                    1.8456e-07,
                    1.9413e-07,
                    2.0425e-07,
                    2.1506e-07,
                    2.2663e-07,
                    2.3896e-07,
                    2.5203e-07,
                    2.6575e-07,
                    2.7997e-07,
                    2.9449e-07,
                    3.0918e-07,
                    3.2402e-07,
                    3.3898e-07,
                    3.5404e-07,
                    3.692e-07,
                    3.8445e-07,
                    3.9978e-07,
                    4.1521e-07,
                    4.3075e-07,
                    4.5419e-07,
                    4.7796e-07,
                    5.0243e-07,
                    5.2795e-07,
                    5.5481e-07,
                    5.8327e-07,
                    6.1356e-07,
                    6.4587e-07,
                    6.8035e-07,
                    7.171e-07,
                    7.562e-07,
                    7.9859e-07,
                    8.4578e-07,
                    8.9892e-07,
                    9.587e-07,
                    1.0254e-06,
                    1.099e-06,
                    1.1789e-06,
                    1.2642e-06,
                    1.3536e-06,
                    1.4453e-06,
                    1.5383e-06,
                    1.6324e-06,
                    1.7277e-06,
                    1.8239e-06,
                    1.9211e-06,
                    2.0191e-06,
                    2.1177e-06,
                    2.2168e-06,
                    2.3163e-06,
                    2.4161e-06,
                    2.5157e-06,
                    2.6146e-06,
                    2.7125e-06,
                    2.8092e-06,
                    2.9045e-06,
                    2.9984e-06,
                    3.091e-06,
                    3.1825e-06,
                    3.2734e-06,
                    3.3641e-06,
                    3.4554e-06,
                    3.5482e-06,
                    3.6434e-06,
                    3.7416e-06,
                    3.8432e-06,
                    3.9487e-06,
                    4.0582e-06,
                    4.1717e-06,
                    4.2892e-06,
                    4.4103e-06,
                    4.5393e-06,
                    4.6837e-06,
                    4.8495e-06,
                    5.0407e-06,
                    5.2598e-06,
                    5.5074e-06,
                    5.7824e-06,
                    6.0819e-06,
                    6.4016e-06,
                    6.735e-06,
                    7.0819e-06,
                    7.4485e-06,
                    7.8393e-06,
                    8.2577e-06,
                    8.7055e-06,
                    9.183e-06,
                    9.6894e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -80.21999,
                                -3.44066
                            ],
                            [
                                -80.21537,
                                -3.57487
                            ],
                            [
                                -80.19184,
                                -3.6015
                            ],
                            [
                                -80.18929,
                                -3.77112
                            ],
                            [
                                -80.16257,
                                -3.80756
                            ],
                            [
                                -80.16322,
                                -3.92097
                            ],
                            [
                                -80.23108,
                                -3.95005
                            ],
                            [
                                -80.28751,
                                -4.01733
                            ],
                            [
                                -80.36292,
                                -3.98425
                            ],
                            [
                                -80.42997,
                                -3.99227
                            ],
                            [
                                -80.48085,
                                -4.08343
                            ],
                            [
                                -80.44473,
                                -4.1225
                            ],
                            [
                                -80.44259,
                                -4.19433
                            ],
                            [
                                -80.36726,
                                -4.19761
                            ],
                            [
                                -80.33217,
                                -4.22938
                            ],
                            [
                                -80.4428,
                                -4.3704
                            ],
                            [
                                -80.44233,
                                -4.43782
                            ],
                            [
                                -80.38821,
                                -4.48217
                            ],
                            [
                                -80.33515,
                                -4.46962
                            ],
                            [
                                -80.24568,
                                -4.39731
                            ],
                            [
                                -80.15509,
                                -4.30273
                            ],
                            [
                                -80.06045,
                                -4.30685
                            ],
                            [
                                -79.9909,
                                -4.37583
                            ],
                            [
                                -79.91458,
                                -4.3826
                            ],
                            [
                                -79.86794,
                                -4.411
                            ],
                            [
                                -79.81053,
                                -4.48635
                            ],
                            [
                                -79.61548,
                                -4.44152
                            ],
                            [
                                -79.54055,
                                -4.52653
                            ],
                            [
                                -79.50723,
                                -4.51395
                            ],
                            [
                                -79.41558,
                                -4.79887
                            ],
                            [
                                -79.29821,
                                -4.90013
                            ],
                            [
                                -79.2587,
                                -4.96711
                            ],
                            [
                                -79.07115,
                                -4.97033
                            ],
                            [
                                -79.03589,
                                -4.99791
                            ],
                            [
                                -78.9868,
                                -4.96034
                            ],
                            [
                                -78.96297,
                                -4.88527
                            ],
                            [
                                -78.91322,
                                -4.82555
                            ],
                            [
                                -78.88425,
                                -4.72537
                            ],
                            [
                                -78.83773,
                                -4.68065
                            ],
                            [
                                -78.7328,
                                -4.65031
                            ],
                            [
                                -78.61901,
                                -4.4918
                            ],
                            [
                                -78.62648,
                                -4.31654
                            ],
                            [
                                -78.56867,
                                -4.23493
                            ],
                            [
                                -78.57505,
                                -4.15876
                            ],
                            [
                                -78.5501,
                                -4.06624
                            ],
                            [
                                -78.47368,
                                -3.9071
                            ],
                            [
                                -78.37657,
                                -3.78495
                            ],
                            [
                                -78.35054,
                                -3.67764
                            ],
                            [
                                -78.33686,
                                -3.46522
                            ],
                            [
                                -78.29798,
                                -3.41433
                            ],
                            [
                                -78.24088,
                                -3.45455
                            ],
                            [
                                -78.24341,
                                -3.51481
                            ],
                            [
                                -78.14023,
                                -3.52361
                            ],
                            [
                                -78.13122,
                                -3.46626
                            ],
                            [
                                -78.19036,
                                -3.35717
                            ],
                            [
                                -78.13996,
                                -3.31737
                            ],
                            [
                                -77.99495,
                                -3.13441
                            ],
                            [
                                -77.83613,
                                -3.00532
                            ],
                            [
                                -77.75898,
                                -2.97265
                            ],
                            [
                                -77.09918,
                                -2.75358
                            ],
                            [
                                -76.63384,
                                -2.59343
                            ],
                            [
                                -76.04376,
                                -2.12652
                            ],
                            [
                                -75.61937,
                                -1.5867
                            ],
                            [
                                -75.53855,
                                -1.53599
                            ],
                            [
                                -75.36497,
                                -0.9581
                            ],
                            [
                                -75.30127,
                                -0.97975
                            ],
                            [
                                -75.19871,
                                -0.97594
                            ],
                            [
                                -75.25157,
                                -0.7529
                            ],
                            [
                                -75.27979,
                                -0.71216
                            ],
                            [
                                -75.24497,
                                -0.53624
                            ],
                            [
                                -75.35751,
                                -0.44281
                            ],
                            [
                                -75.41355,
                                -0.42415
                            ],
                            [
                                -75.44909,
                                -0.32933
                            ],
                            [
                                -75.53546,
                                -0.32636
                            ],
                            [
                                -75.62583,
                                -0.24941
                            ],
                            [
                                -75.62064,
                                -0.10969
                            ],
                            [
                                -75.47864,
                                -0.11898
                            ],
                            [
                                -75.41206,
                                -0.14819
                            ],
                            [
                                -75.30445,
                                -0.13307
                            ],
                            [
                                -75.2882,
                                -0.09369
                            ],
                            [
                                -75.41445,
                                -0.07726
                            ],
                            [
                                -75.53287,
                                -0.01448
                            ],
                            [
                                -75.61993,
                                0.07291
                            ],
                            [
                                -75.73361,
                                0.06471
                            ],
                            [
                                -75.80002,
                                0.09192
                            ],
                            [
                                -75.8822,
                                0.15625
                            ],
                            [
                                -76.01456,
                                0.32578
                            ],
                            [
                                -76.10136,
                                0.35312
                            ],
                            [
                                -76.13968,
                                0.39482
                            ],
                            [
                                -76.20984,
                                0.39866
                            ],
                            [
                                -76.27016,
                                0.44038
                            ],
                            [
                                -76.38474,
                                0.39667
                            ],
                            [
                                -76.40397,
                                0.3657
                            ],
                            [
                                -76.40438,
                                0.24925
                            ],
                            [
                                -76.55792,
                                0.25387
                            ],
                            [
                                -76.59594,
                                0.23407
                            ],
                            [
                                -76.72748,
                                0.2847
                            ],
                            [
                                -76.7804,
                                0.25286
                            ],
                            [
                                -76.90574,
                                0.24913
                            ],
                            [
                                -77.07955,
                                0.28793
                            ],
                            [
                                -77.12863,
                                0.37313
                            ],
                            [
                                -77.2539,
                                0.35242
                            ],
                            [
                                -77.37358,
                                0.38618
                            ],
                            [
                                -77.40216,
                                0.36191
                            ],
                            [
                                -77.4654,
                                0.3987
                            ],
                            [
                                -77.50217,
                                0.63187
                            ],
                            [
                                -77.59839,
                                0.667
                            ],
                            [
                                -77.69818,
                                0.75069
                            ],
                            [
                                -77.65611,
                                0.80177
                            ],
                            [
                                -77.70622,
                                0.83733
                            ],
                            [
                                -77.8429,
                                0.7972
                            ],
                            [
                                -77.96029,
                                0.81242
                            ],
                            [
                                -78.12071,
                                0.91335
                            ],
                            [
                                -78.19952,
                                0.99312
                            ],
                            [
                                -78.35581,
                                1.05077
                            ],
                            [
                                -78.4355,
                                1.14822
                            ],
                            [
                                -78.55028,
                                1.19503
                            ],
                            [
                                -78.67383,
                                1.2951
                            ],
                            [
                                -78.7509,
                                1.38882
                            ],
                            [
                                -78.80563,
                                1.41929
                            ],
                            [
                                -78.87102,
                                1.35378
                            ],
                            [
                                -78.91153,
                                1.3689
                            ],
                            [
                                -78.98155,
                                1.28147
                            ],
                            [
                                -79.04395,
                                1.23993
                            ],
                            [
                                -79.1254,
                                1.12653
                            ],
                            [
                                -79.24265,
                                1.07613
                            ],
                            [
                                -79.40838,
                                1.0773
                            ],
                            [
                                -79.54938,
                                0.99711
                            ],
                            [
                                -79.6597,
                                0.99034
                            ],
                            [
                                -79.73726,
                                0.96271
                            ],
                            [
                                -79.80906,
                                0.89682
                            ],
                            [
                                -79.97152,
                                0.82172
                            ],
                            [
                                -80.0533,
                                0.81807
                            ],
                            [
                                -80.09494,
                                0.7597
                            ],
                            [
                                -80.08719,
                                0.65624
                            ],
                            [
                                -80.0308,
                                0.62755
                            ],
                            [
                                -80.00289,
                                0.5546
                            ],
                            [
                                -80.04394,
                                0.49245
                            ],
                            [
                                -80.03311,
                                0.42667
                            ],
                            [
                                -79.98193,
                                0.36418
                            ],
                            [
                                -80.04012,
                                0.34842
                            ],
                            [
                                -80.03153,
                                0.22724
                            ],
                            [
                                -80.04359,
                                0.11747
                            ],
                            [
                                -80.14431,
                                -0.049
                            ],
                            [
                                -80.29494,
                                -0.18338
                            ],
                            [
                                -80.37781,
                                -0.2344
                            ],
                            [
                                -80.40912,
                                -0.30979
                            ],
                            [
                                -80.48431,
                                -0.36908
                            ],
                            [
                                -80.43617,
                                -0.56051
                            ],
                            [
                                -80.47139,
                                -0.64553
                            ],
                            [
                                -80.54302,
                                -0.87197
                            ],
                            [
                                -80.57893,
                                -0.92017
                            ],
                            [
                                -80.82415,
                                -0.95863
                            ],
                            [
                                -80.90774,
                                -1.05429
                            ],
                            [
                                -80.85667,
                                -1.19325
                            ],
                            [
                                -80.74094,
                                -1.35724
                            ],
                            [
                                -80.76831,
                                -1.47175
                            ],
                            [
                                -80.81285,
                                -1.51096
                            ],
                            [
                                -80.84976,
                                -1.60145
                            ],
                            [
                                -80.77451,
                                -1.75079
                            ],
                            [
                                -80.73301,
                                -1.89416
                            ],
                            [
                                -80.73848,
                                -2.02704
                            ],
                            [
                                -80.76157,
                                -2.12248
                            ],
                            [
                                -80.90905,
                                -2.21747
                            ],
                            [
                                -80.98789,
                                -2.21052
                            ],
                            [
                                -80.86954,
                                -2.32823
                            ],
                            [
                                -80.77894,
                                -2.38688
                            ],
                            [
                                -80.64692,
                                -2.43028
                            ],
                            [
                                -80.44516,
                                -2.63187
                            ],
                            [
                                -80.39146,
                                -2.64541
                            ],
                            [
                                -80.31704,
                                -2.7126
                            ],
                            [
                                -80.24436,
                                -2.71564
                            ],
                            [
                                -80.2556,
                                -2.64867
                            ],
                            [
                                -80.11033,
                                -2.52994
                            ],
                            [
                                -80.02085,
                                -2.35095
                            ],
                            [
                                -79.98991,
                                -2.47453
                            ],
                            [
                                -79.94596,
                                -2.49987
                            ],
                            [
                                -79.97252,
                                -2.51554
                            ],
                            [
                                -79.97223,
                                -2.53622
                            ],
                            [
                                -79.94648,
                                -2.55155
                            ],
                            [
                                -79.93239,
                                -2.58223
                            ],
                            [
                                -79.8936,
                                -2.55549
                            ],
                            [
                                -79.85989,
                                -2.44193
                            ],
                            [
                                -79.80245,
                                -2.43676
                            ],
                            [
                                -79.7774,
                                -2.50981
                            ],
                            [
                                -79.73012,
                                -2.50582
                            ],
                            [
                                -79.7158,
                                -2.56852
                            ],
                            [
                                -79.72009,
                                -2.61025
                            ],
                            [
                                -79.73592,
                                -2.64157
                            ],
                            [
                                -79.78523,
                                -2.6739
                            ],
                            [
                                -79.80227,
                                -2.77764
                            ],
                            [
                                -79.8508,
                                -2.88944
                            ],
                            [
                                -79.84763,
                                -3.02026
                            ],
                            [
                                -79.89291,
                                -3.07466
                            ],
                            [
                                -79.90936,
                                -3.15638
                            ],
                            [
                                -79.99464,
                                -3.23141
                            ],
                            [
                                -80.04341,
                                -3.22871
                            ],
                            [
                                -80.10565,
                                -3.32285
                            ],
                            [
                                -80.21865,
                                -3.35336
                            ],
                            [
                                -80.21999,
                                -3.44066
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -90.79293,
                                -0.77255
                            ],
                            [
                                -90.89505,
                                -0.60833
                            ],
                            [
                                -90.95964,
                                -0.60197
                            ],
                            [
                                -90.94274,
                                -0.47253
                            ],
                            [
                                -90.99989,
                                -0.38276
                            ],
                            [
                                -91.10905,
                                -0.30795
                            ],
                            [
                                -91.17601,
                                -0.22112
                            ],
                            [
                                -91.19944,
                                -0.0227
                            ],
                            [
                                -91.2737,
                                0.04377
                            ],
                            [
                                -91.31264,
                                0.13309
                            ],
                            [
                                -91.48864,
                                0.0983
                            ],
                            [
                                -91.52153,
                                0.0364
                            ],
                            [
                                -91.58646,
                                0.00468
                            ],
                            [
                                -91.54798,
                                -0.0505
                            ],
                            [
                                -91.47222,
                                -0.01594
                            ],
                            [
                                -91.40567,
                                -0.06105
                            ],
                            [
                                -91.38687,
                                -0.2603
                            ],
                            [
                                -91.34601,
                                -0.31947
                            ],
                            [
                                -91.22498,
                                -0.39552
                            ],
                            [
                                -91.21197,
                                -0.4886
                            ],
                            [
                                -91.08637,
                                -0.58663
                            ],
                            [
                                -91.09573,
                                -0.64185
                            ],
                            [
                                -91.17068,
                                -0.68793
                            ],
                            [
                                -91.21659,
                                -0.66883
                            ],
                            [
                                -91.32936,
                                -0.71579
                            ],
                            [
                                -91.40231,
                                -0.76705
                            ],
                            [
                                -91.49855,
                                -0.86066
                            ],
                            [
                                -91.51233,
                                -0.90311
                            ],
                            [
                                -91.4494,
                                -0.956
                            ],
                            [
                                -91.44573,
                                -0.99169
                            ],
                            [
                                -91.38094,
                                -1.02232
                            ],
                            [
                                -91.29468,
                                -1.01915
                            ],
                            [
                                -91.17089,
                                -1.05363
                            ],
                            [
                                -91.13684,
                                -1.0228
                            ],
                            [
                                -91.01745,
                                -0.98828
                            ],
                            [
                                -90.99384,
                                -0.96012
                            ],
                            [
                                -90.90883,
                                -0.95537
                            ],
                            [
                                -90.85109,
                                -0.88413
                            ],
                            [
                                -90.82398,
                                -0.7909
                            ],
                            [
                                -90.79293,
                                -0.77255
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -90.54886,
                                -0.6271
                            ],
                            [
                                -90.53424,
                                -0.69691
                            ],
                            [
                                -90.39645,
                                -0.77389
                            ],
                            [
                                -90.24818,
                                -0.7475
                            ],
                            [
                                -90.17721,
                                -0.66663
                            ],
                            [
                                -90.16927,
                                -0.57422
                            ],
                            [
                                -90.22693,
                                -0.53357
                            ],
                            [
                                -90.25079,
                                -0.48331
                            ],
                            [
                                -90.40532,
                                -0.5047
                            ],
                            [
                                -90.51282,
                                -0.53479
                            ],
                            [
                                -90.54886,
                                -0.6271
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -80.27028,
                                -2.99959
                            ],
                            [
                                -80.19674,
                                -3.0408
                            ],
                            [
                                -80.12447,
                                -3.01907
                            ],
                            [
                                -79.99686,
                                -2.81163
                            ],
                            [
                                -79.93155,
                                -2.79161
                            ],
                            [
                                -79.90494,
                                -2.73851
                            ],
                            [
                                -80.03765,
                                -2.67651
                            ],
                            [
                                -80.21588,
                                -2.73955
                            ],
                            [
                                -80.26167,
                                -2.86355
                            ],
                            [
                                -80.27028,
                                -2.99959
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -91.66076,
                                -0.31542
                            ],
                            [
                                -91.64981,
                                -0.39852
                            ],
                            [
                                -91.59892,
                                -0.4863
                            ],
                            [
                                -91.50604,
                                -0.50662
                            ],
                            [
                                -91.42991,
                                -0.49502
                            ],
                            [
                                -91.38801,
                                -0.45531
                            ],
                            [
                                -91.38099,
                                -0.35031
                            ],
                            [
                                -91.44785,
                                -0.26536
                            ],
                            [
                                -91.66076,
                                -0.31542
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -90.79293,
                                -0.3287
                            ],
                            [
                                -90.7406,
                                -0.35997
                            ],
                            [
                                -90.58224,
                                -0.37024
                            ],
                            [
                                -90.54679,
                                -0.31684
                            ],
                            [
                                -90.58316,
                                -0.23895
                            ],
                            [
                                -90.7492,
                                -0.15189
                            ],
                            [
                                -90.81671,
                                -0.1572
                            ],
                            [
                                -90.8702,
                                -0.26568
                            ],
                            [
                                -90.79293,
                                -0.3287
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -89.62731,
                                -0.91749
                            ],
                            [
                                -89.52699,
                                -0.95532
                            ],
                            [
                                -89.39955,
                                -0.91354
                            ],
                            [
                                -89.36467,
                                -0.85555
                            ],
                            [
                                -89.24218,
                                -0.72129
                            ],
                            [
                                -89.25951,
                                -0.69453
                            ],
                            [
                                -89.35447,
                                -0.68822
                            ],
                            [
                                -89.46077,
                                -0.75593
                            ],
                            [
                                -89.51976,
                                -0.82437
                            ],
                            [
                                -89.62731,
                                -0.91749
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -90.51121,
                                -1.31558
                            ],
                            [
                                -90.43129,
                                -1.35922
                            ],
                            [
                                -90.35371,
                                -1.27522
                            ],
                            [
                                -90.4202,
                                -1.23336
                            ],
                            [
                                -90.47497,
                                -1.23066
                            ],
                            [
                                -90.51121,
                                -1.31558
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -80.06744,
                                -2.58841
                            ],
                            [
                                -79.9923,
                                -2.65053
                            ],
                            [
                                -79.93804,
                                -2.6564
                            ],
                            [
                                -79.93155,
                                -2.59555
                            ],
                            [
                                -79.94734,
                                -2.55373
                            ],
                            [
                                -79.98013,
                                -2.53884
                            ],
                            [
                                -80.01297,
                                -2.50396
                            ],
                            [
                                -80.06744,
                                -2.58841
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -90.54246,
                                0.34476
                            ],
                            [
                                -90.47843,
                                0.27669
                            ],
                            [
                                -90.40187,
                                0.31583
                            ],
                            [
                                -90.46185,
                                0.38451
                            ],
                            [
                                -90.54246,
                                0.34476
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -79.88867,
                                -2.63856
                            ],
                            [
                                -79.83648,
                                -2.65529
                            ],
                            [
                                -79.8158,
                                -2.55032
                            ],
                            [
                                -79.86383,
                                -2.54204
                            ],
                            [
                                -79.88867,
                                -2.63856
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -79.80265,
                                -2.61427
                            ],
                            [
                                -79.78587,
                                -2.64324
                            ],
                            [
                                -79.75131,
                                -2.63551
                            ],
                            [
                                -79.72682,
                                -2.61046
                            ],
                            [
                                -79.73444,
                                -2.52524
                            ],
                            [
                                -79.78275,
                                -2.54164
                            ],
                            [
                                -79.80265,
                                -2.61427
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "EGY",
                "Country": "Egypt",
                "Total_3GHG": 0.43,
                "Total_3GHG_timeseries": [
                    1.0447e-06,
                    2.1375e-06,
                    3.2797e-06,
                    4.4748e-06,
                    5.7235e-06,
                    6.9347e-06,
                    8.2009e-06,
                    9.5245e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0042,
                    0.0043,
                    0.0045,
                    0.0047,
                    0.0048,
                    0.005,
                    0.0052,
                    0.0053,
                    0.0055,
                    0.0056,
                    0.0058,
                    0.0059,
                    0.0061,
                    0.0063,
                    0.0064,
                    0.0066,
                    0.0068,
                    0.0069,
                    0.0071
                ],
                "Fossil_3GHG": 0.55,
                "Fossil_3GHG_timeseries": [
                    6.0274e-07,
                    1.2639e-06,
                    1.9833e-06,
                    2.7629e-06,
                    3.6026e-06,
                    4.4107e-06,
                    5.279e-06,
                    6.2096e-06,
                    7.202e-06,
                    8.2575e-06,
                    9.3889e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0037,
                    0.0038,
                    0.004,
                    0.0041,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0047,
                    0.0048,
                    0.005,
                    0.0051,
                    0.0053,
                    0.0055,
                    0.0056,
                    0.0058
                ],
                "Land_3GHG": 0.22,
                "Land_3GHG_timeseries": [
                    4.4199e-07,
                    8.7357e-07,
                    1.2965e-06,
                    1.7119e-06,
                    2.1209e-06,
                    2.524e-06,
                    2.9219e-06,
                    3.315e-06,
                    3.7036e-06,
                    4.1211e-06,
                    4.5863e-06,
                    5.0945e-06,
                    5.6427e-06,
                    6.2293e-06,
                    6.853e-06,
                    7.5129e-06,
                    8.2084e-06,
                    8.9388e-06,
                    9.7037e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013
                ],
                "Total_CO2": 0.3,
                "Total_CO2_timeseries": [
                    -0.0000000035145,
                    -0.000000020587,
                    -0.000000049406,
                    -0.000000088633,
                    -0.0000001372,
                    -0.00000019425,
                    -0.00000025902,
                    -0.00000033086,
                    -0.00000040919,
                    -0.0000004604,
                    -0.00000049458,
                    -0.00000051641,
                    -0.00000052869,
                    -0.00000053318,
                    -0.00000053111,
                    -0.00000052337,
                    -0.00000051066,
                    -0.00000049358,
                    -0.00000047263,
                    -0.00000044395,
                    -0.00000040984,
                    -0.00000037146,
                    -0.0000003296,
                    -0.00000028482,
                    -0.00000023758,
                    -0.00000018823,
                    -0.00000013709,
                    -0.000000084453,
                    -0.000000030575,
                    8.8594e-08,
                    2.4442e-07,
                    4.245e-07,
                    6.2208e-07,
                    8.3313e-07,
                    1.055e-06,
                    1.2858e-06,
                    1.5242e-06,
                    1.7689e-06,
                    2.019e-06,
                    2.2531e-06,
                    2.4797e-06,
                    2.702e-06,
                    2.9214e-06,
                    3.1386e-06,
                    3.3537e-06,
                    3.5726e-06,
                    3.799e-06,
                    4.0361e-06,
                    4.2875e-06,
                    4.5555e-06,
                    4.847e-06,
                    5.1697e-06,
                    5.5296e-06,
                    5.9288e-06,
                    6.3694e-06,
                    6.8546e-06,
                    7.3902e-06,
                    7.9786e-06,
                    8.6214e-06,
                    9.3295e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034
                ],
                "Fossil_CO2": 0.4,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    4.95e-09,
                    4.29e-08,
                    6.105e-08,
                    1.9965e-07,
                    2.409e-07,
                    3.2175e-07,
                    5.115e-07,
                    9.009e-07,
                    1.2111e-06,
                    1.4157e-06,
                    1.6682e-06,
                    1.9074e-06,
                    2.1186e-06,
                    2.343e-06,
                    2.5921e-06,
                    2.8314e-06,
                    3.0872e-06,
                    3.478e-06,
                    3.8935e-06,
                    4.3533e-06,
                    4.8066e-06,
                    5.2352e-06,
                    5.6274e-06,
                    5.9981e-06,
                    6.334e-06,
                    6.6617e-06,
                    6.9713e-06,
                    7.3666e-06,
                    8.3692e-06,
                    9.733e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031
                ],
                "Land_CO2": 0.08,
                "Land_CO2_timeseries": [
                    -0.0000000035145,
                    -0.000000020587,
                    -0.000000049406,
                    -0.000000088633,
                    -0.0000001372,
                    -0.00000019425,
                    -0.00000025902,
                    -0.00000033086,
                    -0.00000040919,
                    -0.0000004604,
                    -0.00000049458,
                    -0.00000051641,
                    -0.00000052869,
                    -0.00000053318,
                    -0.00000053111,
                    -0.00000052337,
                    -0.00000051066,
                    -0.00000049358,
                    -0.00000047263,
                    -0.00000044395,
                    -0.00000040984,
                    -0.00000037146,
                    -0.0000003296,
                    -0.00000028482,
                    -0.00000023758,
                    -0.00000018823,
                    -0.00000013709,
                    -0.000000084453,
                    -0.000000030575,
                    8.8594e-08,
                    2.4442e-07,
                    4.245e-07,
                    6.2208e-07,
                    8.3313e-07,
                    1.055e-06,
                    1.2858e-06,
                    1.5242e-06,
                    1.7689e-06,
                    2.019e-06,
                    2.2531e-06,
                    2.4797e-06,
                    2.702e-06,
                    2.9214e-06,
                    3.1386e-06,
                    3.3537e-06,
                    3.5726e-06,
                    3.799e-06,
                    4.0361e-06,
                    4.2875e-06,
                    4.5555e-06,
                    4.847e-06,
                    5.1697e-06,
                    5.5296e-06,
                    5.9288e-06,
                    6.3694e-06,
                    6.8546e-06,
                    7.3902e-06,
                    7.9786e-06,
                    8.6214e-06,
                    9.3295e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Total_CH4": 0.77,
                "Total_CH4_timeseries": [
                    9.2532e-07,
                    1.91e-06,
                    2.9537e-06,
                    4.0587e-06,
                    5.2247e-06,
                    6.3601e-06,
                    7.5566e-06,
                    8.8165e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032
                ],
                "Fossil_CH4": 0.96,
                "Fossil_CH4_timeseries": [
                    5.6617e-07,
                    1.1903e-06,
                    1.872e-06,
                    2.6137e-06,
                    3.4148e-06,
                    4.184e-06,
                    5.0129e-06,
                    5.9038e-06,
                    6.8562e-06,
                    7.8714e-06,
                    8.9623e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025
                ],
                "Land_CH4": 0.45,
                "Land_CH4_timeseries": [
                    3.5914e-07,
                    7.197e-07,
                    1.0817e-06,
                    1.4451e-06,
                    1.8099e-06,
                    2.1761e-06,
                    2.5437e-06,
                    2.9127e-06,
                    3.2832e-06,
                    3.6551e-06,
                    4.0574e-06,
                    4.4902e-06,
                    4.9536e-06,
                    5.4474e-06,
                    5.9717e-06,
                    6.5264e-06,
                    7.1117e-06,
                    7.7274e-06,
                    8.3736e-06,
                    9.0504e-06,
                    9.7629e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Total_N2O": 0.56,
                "Total_N2O_timeseries": [
                    1.2293e-07,
                    2.481e-07,
                    3.7542e-07,
                    5.0477e-07,
                    6.3599e-07,
                    7.689e-07,
                    9.0329e-07,
                    1.0389e-06,
                    1.1754e-06,
                    1.3126e-06,
                    1.4501e-06,
                    1.588e-06,
                    1.7263e-06,
                    1.8648e-06,
                    2.0036e-06,
                    2.1427e-06,
                    2.2821e-06,
                    2.4219e-06,
                    2.562e-06,
                    2.7025e-06,
                    2.8452e-06,
                    2.993e-06,
                    3.148e-06,
                    3.3119e-06,
                    3.4856e-06,
                    3.6693e-06,
                    3.8625e-06,
                    4.0641e-06,
                    4.2722e-06,
                    4.4844e-06,
                    4.699e-06,
                    4.9157e-06,
                    5.1341e-06,
                    5.3541e-06,
                    5.5754e-06,
                    5.7981e-06,
                    6.0222e-06,
                    6.2477e-06,
                    6.4747e-06,
                    6.7112e-06,
                    6.9499e-06,
                    7.1909e-06,
                    7.4343e-06,
                    7.6801e-06,
                    7.9285e-06,
                    8.1795e-06,
                    8.4333e-06,
                    8.6899e-06,
                    8.9494e-06,
                    9.2119e-06,
                    9.4775e-06,
                    9.746e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005
                ],
                "Fossil_N2O": 0.67,
                "Fossil_N2O_timeseries": [
                    3.6569e-08,
                    7.3648e-08,
                    1.1122e-07,
                    1.4928e-07,
                    1.8779e-07,
                    2.2673e-07,
                    2.6607e-07,
                    3.0577e-07,
                    3.4579e-07,
                    3.8609e-07,
                    4.2663e-07,
                    4.6742e-07,
                    5.0843e-07,
                    5.4967e-07,
                    5.9115e-07,
                    6.3285e-07,
                    6.7478e-07,
                    7.1694e-07,
                    7.5935e-07,
                    8.02e-07,
                    8.4515e-07,
                    8.8921e-07,
                    9.3452e-07,
                    9.8129e-07,
                    1.0297e-06,
                    1.0796e-06,
                    1.1312e-06,
                    1.1841e-06,
                    1.2382e-06,
                    1.2931e-06,
                    1.3484e-06,
                    1.4043e-06,
                    1.4606e-06,
                    1.5173e-06,
                    1.5744e-06,
                    1.6319e-06,
                    1.6898e-06,
                    1.748e-06,
                    1.8067e-06,
                    1.866e-06,
                    1.9259e-06,
                    1.9862e-06,
                    2.0471e-06,
                    2.1086e-06,
                    2.1706e-06,
                    2.2331e-06,
                    2.2963e-06,
                    2.3601e-06,
                    2.4246e-06,
                    2.4898e-06,
                    2.5557e-06,
                    2.6224e-06,
                    2.6901e-06,
                    2.7588e-06,
                    2.8285e-06,
                    2.8992e-06,
                    2.971e-06,
                    3.0438e-06,
                    3.1176e-06,
                    3.1923e-06,
                    3.2679e-06,
                    3.3444e-06,
                    3.4217e-06,
                    3.5e-06,
                    3.5791e-06,
                    3.659e-06,
                    3.7398e-06,
                    3.8215e-06,
                    3.9041e-06,
                    3.9876e-06,
                    4.0719e-06,
                    4.1572e-06,
                    4.2434e-06,
                    4.3305e-06,
                    4.4186e-06,
                    4.5076e-06,
                    4.5975e-06,
                    4.6884e-06,
                    4.7801e-06,
                    4.8727e-06,
                    4.9704e-06,
                    5.0809e-06,
                    5.2105e-06,
                    5.3642e-06,
                    5.5456e-06,
                    5.757e-06,
                    5.9994e-06,
                    6.2726e-06,
                    6.5747e-06,
                    6.9028e-06,
                    7.2574e-06,
                    7.6423e-06,
                    8.0601e-06,
                    8.5121e-06,
                    8.9983e-06,
                    9.5174e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002
                ],
                "Land_N2O": 0.51,
                "Land_N2O_timeseries": [
                    8.6363e-08,
                    1.7445e-07,
                    2.642e-07,
                    3.5549e-07,
                    4.482e-07,
                    5.4217e-07,
                    6.3722e-07,
                    7.3312e-07,
                    8.2962e-07,
                    9.2647e-07,
                    1.0235e-06,
                    1.1206e-06,
                    1.2178e-06,
                    1.3151e-06,
                    1.4125e-06,
                    1.5099e-06,
                    1.6074e-06,
                    1.7049e-06,
                    1.8026e-06,
                    1.9005e-06,
                    2.0001e-06,
                    2.1037e-06,
                    2.2135e-06,
                    2.3306e-06,
                    2.456e-06,
                    2.5896e-06,
                    2.7313e-06,
                    2.8799e-06,
                    3.034e-06,
                    3.1913e-06,
                    3.3506e-06,
                    3.5114e-06,
                    3.6735e-06,
                    3.8367e-06,
                    4.001e-06,
                    4.1662e-06,
                    4.3324e-06,
                    4.4996e-06,
                    4.668e-06,
                    4.8452e-06,
                    5.024e-06,
                    5.2047e-06,
                    5.3872e-06,
                    5.5715e-06,
                    5.7579e-06,
                    5.9464e-06,
                    6.137e-06,
                    6.3298e-06,
                    6.5248e-06,
                    6.7222e-06,
                    6.9218e-06,
                    7.1236e-06,
                    7.3275e-06,
                    7.5337e-06,
                    7.7422e-06,
                    7.9533e-06,
                    8.1673e-06,
                    8.3846e-06,
                    8.6055e-06,
                    8.8307e-06,
                    9.0621e-06,
                    9.303e-06,
                    9.5559e-06,
                    9.8228e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            34.08653,
                            22.00251
                        ],
                        [
                            34.23122,
                            22.00264
                        ],
                        [
                            35.16307,
                            22.00352
                        ],
                        [
                            35.78326,
                            22.0041
                        ],
                        [
                            36.38683,
                            22.00467
                        ],
                        [
                            36.8825,
                            22.00513
                        ],
                        [
                            36.89219,
                            22.06382
                        ],
                        [
                            36.84185,
                            22.0878
                        ],
                        [
                            36.7742,
                            22.16747
                        ],
                        [
                            36.7375,
                            22.15877
                        ],
                        [
                            36.5517,
                            22.30599
                        ],
                        [
                            36.44708,
                            22.35432
                        ],
                        [
                            36.42268,
                            22.42172
                        ],
                        [
                            36.34441,
                            22.46415
                        ],
                        [
                            36.29717,
                            22.51862
                        ],
                        [
                            36.25552,
                            22.6107
                        ],
                        [
                            36.17967,
                            22.66152
                        ],
                        [
                            35.92511,
                            22.69542
                        ],
                        [
                            35.80895,
                            22.80543
                        ],
                        [
                            35.77841,
                            22.87072
                        ],
                        [
                            35.73023,
                            22.8811
                        ],
                        [
                            35.66747,
                            22.95142
                        ],
                        [
                            35.65549,
                            23.06658
                        ],
                        [
                            35.57211,
                            23.21502
                        ],
                        [
                            35.55025,
                            23.37085
                        ],
                        [
                            35.48773,
                            23.49834
                        ],
                        [
                            35.5107,
                            23.67592
                        ],
                        [
                            35.47493,
                            23.78975
                        ],
                        [
                            35.47756,
                            23.92489
                        ],
                        [
                            35.50163,
                            23.96834
                        ],
                        [
                            35.68483,
                            23.91309
                        ],
                        [
                            35.74937,
                            23.93524
                        ],
                        [
                            35.72634,
                            23.98629
                        ],
                        [
                            35.60711,
                            24.0153
                        ],
                        [
                            35.58786,
                            24.07678
                        ],
                        [
                            35.49615,
                            24.11245
                        ],
                        [
                            35.43337,
                            24.1843
                        ],
                        [
                            35.40703,
                            24.25222
                        ],
                        [
                            35.31635,
                            24.35794
                        ],
                        [
                            35.2245,
                            24.41343
                        ],
                        [
                            35.13826,
                            24.52258
                        ],
                        [
                            35.16247,
                            24.56615
                        ],
                        [
                            35.10164,
                            24.63683
                        ],
                        [
                            35.07247,
                            24.74926
                        ],
                        [
                            34.9962,
                            24.82802
                        ],
                        [
                            34.94344,
                            24.99577
                        ],
                        [
                            34.84998,
                            25.1654
                        ],
                        [
                            34.80219,
                            25.2196
                        ],
                        [
                            34.70365,
                            25.39533
                        ],
                        [
                            34.63509,
                            25.57546
                        ],
                        [
                            34.58827,
                            25.6282
                        ],
                        [
                            34.53898,
                            25.74656
                        ],
                        [
                            34.434,
                            25.83831
                        ],
                        [
                            34.41142,
                            25.90565
                        ],
                        [
                            34.34302,
                            25.98768
                        ],
                        [
                            34.28545,
                            26.11544
                        ],
                        [
                            34.21785,
                            26.21118
                        ],
                        [
                            34.18718,
                            26.30669
                        ],
                        [
                            34.10861,
                            26.4109
                        ],
                        [
                            34.01581,
                            26.61139
                        ],
                        [
                            33.93367,
                            26.67873
                        ],
                        [
                            33.93731,
                            26.79239
                        ],
                        [
                            33.97113,
                            26.89208
                        ],
                        [
                            33.93693,
                            26.93555
                        ],
                        [
                            33.89844,
                            27.06036
                        ],
                        [
                            33.82866,
                            27.11133
                        ],
                        [
                            33.85037,
                            27.20123
                        ],
                        [
                            33.83106,
                            27.25896
                        ],
                        [
                            33.69561,
                            27.3354
                        ],
                        [
                            33.67636,
                            27.41873
                        ],
                        [
                            33.62064,
                            27.49608
                        ],
                        [
                            33.55883,
                            27.52786
                        ],
                        [
                            33.55837,
                            27.58651
                        ],
                        [
                            33.4949,
                            27.64583
                        ],
                        [
                            33.53943,
                            27.7061
                        ],
                        [
                            33.47117,
                            27.81097
                        ],
                        [
                            33.57972,
                            27.80246
                        ],
                        [
                            33.58359,
                            27.84454
                        ],
                        [
                            33.47934,
                            27.98914
                        ],
                        [
                            33.34141,
                            28.05455
                        ],
                        [
                            33.33289,
                            28.08708
                        ],
                        [
                            33.18567,
                            28.21988
                        ],
                        [
                            33.12692,
                            28.29227
                        ],
                        [
                            33.10968,
                            28.35503
                        ],
                        [
                            33.05289,
                            28.39924
                        ],
                        [
                            33.02056,
                            28.46308
                        ],
                        [
                            32.92903,
                            28.55112
                        ],
                        [
                            32.8663,
                            28.57382
                        ],
                        [
                            32.83037,
                            28.72999
                        ],
                        [
                            32.68084,
                            28.88262
                        ],
                        [
                            32.62105,
                            28.99809
                        ],
                        [
                            32.66482,
                            29.10976
                        ],
                        [
                            32.59248,
                            29.34304
                        ],
                        [
                            32.56319,
                            29.38553
                        ],
                        [
                            32.37257,
                            29.53773
                        ],
                        [
                            32.34474,
                            29.59064
                        ],
                        [
                            32.36427,
                            29.68258
                        ],
                        [
                            32.42259,
                            29.76937
                        ],
                        [
                            32.50715,
                            29.85662
                        ],
                        [
                            32.47739,
                            29.93513
                        ],
                        [
                            32.56242,
                            29.92596
                        ],
                        [
                            32.6329,
                            29.86762
                        ],
                        [
                            32.61258,
                            29.82117
                        ],
                        [
                            32.69582,
                            29.71024
                        ],
                        [
                            32.68218,
                            29.59961
                        ],
                        [
                            32.71021,
                            29.58239
                        ],
                        [
                            32.73814,
                            29.46448
                        ],
                        [
                            32.81642,
                            29.40317
                        ],
                        [
                            32.83017,
                            29.32063
                        ],
                        [
                            32.8869,
                            29.23467
                        ],
                        [
                            32.94951,
                            29.20233
                        ],
                        [
                            33.17798,
                            29.0011
                        ],
                        [
                            33.17512,
                            28.85371
                        ],
                        [
                            33.22944,
                            28.76747
                        ],
                        [
                            33.20019,
                            28.67193
                        ],
                        [
                            33.22471,
                            28.58858
                        ],
                        [
                            33.43179,
                            28.36713
                        ],
                        [
                            33.56665,
                            28.29192
                        ],
                        [
                            33.62072,
                            28.22909
                        ],
                        [
                            33.71159,
                            28.07141
                        ],
                        [
                            33.87643,
                            27.93464
                        ],
                        [
                            33.91362,
                            27.93481
                        ],
                        [
                            34.09096,
                            27.79067
                        ],
                        [
                            34.19044,
                            27.78122
                        ],
                        [
                            34.24589,
                            27.72597
                        ],
                        [
                            34.27651,
                            27.85307
                        ],
                        [
                            34.33122,
                            27.91102
                        ],
                        [
                            34.41935,
                            27.96767
                        ],
                        [
                            34.44884,
                            28.16946
                        ],
                        [
                            34.41294,
                            28.23019
                        ],
                        [
                            34.41103,
                            28.32038
                        ],
                        [
                            34.45729,
                            28.43155
                        ],
                        [
                            34.51911,
                            28.49964
                        ],
                        [
                            34.5195,
                            28.5508
                        ],
                        [
                            34.62454,
                            28.72829
                        ],
                        [
                            34.62254,
                            28.83882
                        ],
                        [
                            34.64757,
                            28.86398
                        ],
                        [
                            34.65195,
                            28.9676
                        ],
                        [
                            34.6927,
                            29.16117
                        ],
                        [
                            34.73804,
                            29.20956
                        ],
                        [
                            34.74393,
                            29.31064
                        ],
                        [
                            34.86179,
                            29.47332
                        ],
                        [
                            34.9051,
                            29.49315
                        ],
                        [
                            34.86739,
                            29.5984
                        ],
                        [
                            34.88032,
                            29.64185
                        ],
                        [
                            34.82865,
                            29.80336
                        ],
                        [
                            34.61354,
                            30.36806
                        ],
                        [
                            34.54434,
                            30.4105
                        ],
                        [
                            34.5586,
                            30.4929
                        ],
                        [
                            34.5196,
                            30.52963
                        ],
                        [
                            34.50139,
                            30.67453
                        ],
                        [
                            34.40748,
                            30.85356
                        ],
                        [
                            34.26884,
                            31.22053
                        ],
                        [
                            34.2198,
                            31.32169
                        ],
                        [
                            34.01424,
                            31.20857
                        ],
                        [
                            33.87512,
                            31.16125
                        ],
                        [
                            33.72691,
                            31.12651
                        ],
                        [
                            33.58294,
                            31.11393
                        ],
                        [
                            33.48003,
                            31.12598
                        ],
                        [
                            33.454,
                            31.08639
                        ],
                        [
                            33.35245,
                            31.10751
                        ],
                        [
                            33.2095,
                            31.07068
                        ],
                        [
                            33.14294,
                            31.07739
                        ],
                        [
                            33.08834,
                            31.17567
                        ],
                        [
                            33.03099,
                            31.15159
                        ],
                        [
                            32.97574,
                            31.08321
                        ],
                        [
                            32.86484,
                            31.08585
                        ],
                        [
                            32.78646,
                            31.04604
                        ],
                        [
                            32.56907,
                            31.07097
                        ],
                        [
                            32.44093,
                            31.18376
                        ],
                        [
                            32.32144,
                            31.27176
                        ],
                        [
                            32.20601,
                            31.29032
                        ],
                        [
                            32.057,
                            31.37134
                        ],
                        [
                            32.00103,
                            31.4167
                        ],
                        [
                            31.93637,
                            31.51416
                        ],
                        [
                            31.84247,
                            31.52213
                        ],
                        [
                            31.76813,
                            31.48323
                        ],
                        [
                            31.5655,
                            31.4447
                        ],
                        [
                            31.44961,
                            31.48023
                        ],
                        [
                            31.33355,
                            31.53642
                        ],
                        [
                            31.12308,
                            31.59788
                        ],
                        [
                            30.97566,
                            31.58396
                        ],
                        [
                            30.65658,
                            31.48964
                        ],
                        [
                            30.53166,
                            31.4591
                        ],
                        [
                            30.37087,
                            31.46325
                        ],
                        [
                            30.30986,
                            31.35014
                        ],
                        [
                            30.23582,
                            31.29223
                        ],
                        [
                            30.1712,
                            31.2715
                        ],
                        [
                            30.05025,
                            31.31579
                        ],
                        [
                            29.83284,
                            31.14556
                        ],
                        [
                            29.74596,
                            31.10671
                        ],
                        [
                            29.54358,
                            30.97214
                        ],
                        [
                            29.33325,
                            30.87539
                        ],
                        [
                            29.22132,
                            30.84027
                        ],
                        [
                            29.07474,
                            30.82063
                        ],
                        [
                            28.98948,
                            30.83183
                        ],
                        [
                            28.84454,
                            30.91734
                        ],
                        [
                            28.82499,
                            30.9517
                        ],
                        [
                            28.70502,
                            31.0015
                        ],
                        [
                            28.61459,
                            31.01469
                        ],
                        [
                            28.55804,
                            31.0495
                        ],
                        [
                            28.43563,
                            31.08555
                        ],
                        [
                            28.31586,
                            31.06869
                        ],
                        [
                            28.1542,
                            31.09096
                        ],
                        [
                            27.92873,
                            31.09856
                        ],
                        [
                            27.8955,
                            31.12266
                        ],
                        [
                            27.86694,
                            31.23379
                        ],
                        [
                            27.67616,
                            31.17875
                        ],
                        [
                            27.44516,
                            31.21788
                        ],
                        [
                            27.39011,
                            31.25866
                        ],
                        [
                            27.33835,
                            31.37006
                        ],
                        [
                            27.25753,
                            31.35976
                        ],
                        [
                            27.07978,
                            31.38381
                        ],
                        [
                            26.9764,
                            31.4413
                        ],
                        [
                            26.84021,
                            31.44289
                        ],
                        [
                            26.74617,
                            31.48245
                        ],
                        [
                            26.49338,
                            31.49695
                        ],
                        [
                            26.32844,
                            31.52789
                        ],
                        [
                            26.08783,
                            31.59311
                        ],
                        [
                            25.91072,
                            31.6266
                        ],
                        [
                            25.79924,
                            31.60801
                        ],
                        [
                            25.49952,
                            31.51923
                        ],
                        [
                            25.30912,
                            31.50444
                        ],
                        [
                            25.16964,
                            31.53893
                        ],
                        [
                            25.14715,
                            31.64969
                        ],
                        [
                            25.09036,
                            31.61968
                        ],
                        [
                            25.06192,
                            31.54172
                        ],
                        [
                            24.86331,
                            31.40735
                        ],
                        [
                            24.88689,
                            31.30286
                        ],
                        [
                            24.87786,
                            31.16919
                        ],
                        [
                            25.01794,
                            30.7774
                        ],
                        [
                            24.95458,
                            30.5967
                        ],
                        [
                            24.92701,
                            30.48283
                        ],
                        [
                            24.83455,
                            30.36909
                        ],
                        [
                            24.78312,
                            30.33132
                        ],
                        [
                            24.69816,
                            30.14895
                        ],
                        [
                            24.75306,
                            30.09587
                        ],
                        [
                            24.81381,
                            29.91587
                        ],
                        [
                            24.81972,
                            29.78884
                        ],
                        [
                            24.89723,
                            29.62494
                        ],
                        [
                            24.85877,
                            29.55062
                        ],
                        [
                            24.88273,
                            29.48202
                        ],
                        [
                            24.99937,
                            29.24849
                        ],
                        [
                            24.99945,
                            29.02699
                        ],
                        [
                            24.99995,
                            27.73058
                        ],
                        [
                            25.0,
                            27.60221
                        ],
                        [
                            25.0,
                            25.52677
                        ],
                        [
                            25.0,
                            24.98755
                        ],
                        [
                            25.0,
                            22.0
                        ],
                        [
                            25.39306,
                            22.0
                        ],
                        [
                            26.18588,
                            22.0
                        ],
                        [
                            27.48027,
                            22.0
                        ],
                        [
                            29.61829,
                            22.0
                        ],
                        [
                            30.23152,
                            22.0
                        ],
                        [
                            30.80672,
                            22.00011
                        ],
                        [
                            31.31441,
                            22.0002
                        ],
                        [
                            31.35782,
                            22.11605
                        ],
                        [
                            31.47426,
                            22.22439
                        ],
                        [
                            31.51234,
                            22.18007
                        ],
                        [
                            31.43444,
                            22.07908
                        ],
                        [
                            31.41624,
                            22.00021
                        ],
                        [
                            31.89442,
                            22.00059
                        ],
                        [
                            32.98994,
                            22.00148
                        ],
                        [
                            33.18263,
                            22.00166
                        ],
                        [
                            34.08653,
                            22.00251
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "SLV",
                "Country": "El Salvador",
                "Total_3GHG": 0.04,
                "Total_3GHG_timeseries": [
                    1.565e-06,
                    3.1202e-06,
                    4.6629e-06,
                    6.1554e-06,
                    7.6181e-06,
                    9.0786e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Fossil_3GHG": 0.02,
                "Fossil_3GHG_timeseries": [
                    6.0717e-08,
                    1.2283e-07,
                    1.8637e-07,
                    2.5137e-07,
                    3.1784e-07,
                    3.8581e-07,
                    4.5532e-07,
                    5.2638e-07,
                    5.9902e-07,
                    6.7327e-07,
                    7.4916e-07,
                    8.2673e-07,
                    9.064e-07,
                    9.8781e-07,
                    1.071e-06,
                    1.156e-06,
                    1.2429e-06,
                    1.3316e-06,
                    1.4222e-06,
                    1.5149e-06,
                    1.6092e-06,
                    1.7053e-06,
                    1.8032e-06,
                    1.903e-06,
                    2.0046e-06,
                    2.1082e-06,
                    2.2137e-06,
                    2.3211e-06,
                    2.4303e-06,
                    2.5414e-06,
                    2.6543e-06,
                    2.7691e-06,
                    2.8853e-06,
                    3.0034e-06,
                    3.1233e-06,
                    3.2451e-06,
                    3.3688e-06,
                    3.4944e-06,
                    3.6219e-06,
                    3.7515e-06,
                    3.8824e-06,
                    4.0145e-06,
                    4.1479e-06,
                    4.2826e-06,
                    4.4186e-06,
                    4.556e-06,
                    4.6948e-06,
                    4.8349e-06,
                    4.9764e-06,
                    5.1194e-06,
                    5.2694e-06,
                    5.4267e-06,
                    5.5913e-06,
                    5.7635e-06,
                    5.9429e-06,
                    6.1298e-06,
                    6.3245e-06,
                    6.5269e-06,
                    6.7371e-06,
                    6.9551e-06,
                    7.1854e-06,
                    7.4283e-06,
                    7.6836e-06,
                    7.9517e-06,
                    8.2325e-06,
                    8.526e-06,
                    8.8329e-06,
                    9.1526e-06,
                    9.4856e-06,
                    9.832e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_3GHG": 0.08,
                "Land_3GHG_timeseries": [
                    1.5043e-06,
                    2.9974e-06,
                    4.4765e-06,
                    5.9041e-06,
                    7.3003e-06,
                    8.6928e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Total_CO2": 0.04,
                "Total_CO2_timeseries": [
                    1.3986e-06,
                    2.7832e-06,
                    4.1512e-06,
                    5.4648e-06,
                    6.7443e-06,
                    8.0175e-06,
                    9.2747e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Fossil_CO2": 0.01,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.2045e-07,
                    2.6565e-07,
                    4.4055e-07,
                    6.2858e-07,
                    8.3969e-07,
                    1.0475e-06,
                    1.285e-06,
                    1.5538e-06,
                    1.8225e-06,
                    2.0946e-06,
                    2.3733e-06,
                    2.6355e-06,
                    2.9275e-06,
                    3.4339e-06,
                    3.9881e-06,
                    4.4566e-06,
                    5.0437e-06,
                    5.5649e-06,
                    6.1322e-06,
                    6.6682e-06,
                    7.3114e-06,
                    7.9908e-06,
                    8.7461e-06,
                    9.6318e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CO2": 0.1,
                "Land_CO2_timeseries": [
                    1.3986e-06,
                    2.7832e-06,
                    4.1512e-06,
                    5.4648e-06,
                    6.7443e-06,
                    8.0175e-06,
                    9.2747e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Total_CH4": 0.05,
                "Total_CH4_timeseries": [
                    1.5139e-07,
                    3.0672e-07,
                    4.6602e-07,
                    6.2933e-07,
                    7.9666e-07,
                    9.6805e-07,
                    1.1435e-06,
                    1.3231e-06,
                    1.5069e-06,
                    1.6948e-06,
                    1.8869e-06,
                    2.0833e-06,
                    2.2844e-06,
                    2.4898e-06,
                    2.6996e-06,
                    2.9138e-06,
                    3.1323e-06,
                    3.3554e-06,
                    3.5829e-06,
                    3.815e-06,
                    4.0525e-06,
                    4.2956e-06,
                    4.5442e-06,
                    4.7983e-06,
                    5.0579e-06,
                    5.323e-06,
                    5.5938e-06,
                    5.87e-06,
                    6.1519e-06,
                    6.4393e-06,
                    6.7324e-06,
                    7.031e-06,
                    7.3349e-06,
                    7.6445e-06,
                    7.9597e-06,
                    8.2805e-06,
                    8.607e-06,
                    8.9392e-06,
                    9.2771e-06,
                    9.6207e-06,
                    9.966e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_CH4": 0.04,
                "Fossil_CH4_timeseries": [
                    5.0011e-08,
                    1.013e-07,
                    1.5389e-07,
                    2.0781e-07,
                    2.6309e-07,
                    3.1976e-07,
                    3.7785e-07,
                    4.3739e-07,
                    4.9841e-07,
                    5.6094e-07,
                    6.2502e-07,
                    6.9069e-07,
                    7.5837e-07,
                    8.2771e-07,
                    8.9873e-07,
                    9.7148e-07,
                    1.046e-06,
                    1.1223e-06,
                    1.2004e-06,
                    1.2804e-06,
                    1.362e-06,
                    1.4451e-06,
                    1.5299e-06,
                    1.6163e-06,
                    1.7044e-06,
                    1.7941e-06,
                    1.8854e-06,
                    1.9784e-06,
                    2.0731e-06,
                    2.1694e-06,
                    2.2675e-06,
                    2.3673e-06,
                    2.4684e-06,
                    2.5713e-06,
                    2.6759e-06,
                    2.7823e-06,
                    2.8904e-06,
                    3.0003e-06,
                    3.1121e-06,
                    3.2256e-06,
                    3.3402e-06,
                    3.4559e-06,
                    3.5727e-06,
                    3.6906e-06,
                    3.8096e-06,
                    3.9298e-06,
                    4.0511e-06,
                    4.1737e-06,
                    4.2974e-06,
                    4.4223e-06,
                    4.554e-06,
                    4.6927e-06,
                    4.8385e-06,
                    4.9916e-06,
                    5.1516e-06,
                    5.3188e-06,
                    5.4935e-06,
                    5.6757e-06,
                    5.8652e-06,
                    6.0624e-06,
                    6.2717e-06,
                    6.4932e-06,
                    6.7269e-06,
                    6.9731e-06,
                    7.2318e-06,
                    7.503e-06,
                    7.7872e-06,
                    8.0841e-06,
                    8.394e-06,
                    8.7171e-06,
                    9.0378e-06,
                    9.3587e-06,
                    9.677e-06,
                    9.9952e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CH4": 0.06,
                "Land_CH4_timeseries": [
                    1.0138e-07,
                    2.0542e-07,
                    3.1214e-07,
                    4.2152e-07,
                    5.3357e-07,
                    6.4829e-07,
                    7.6568e-07,
                    8.8574e-07,
                    1.0085e-06,
                    1.1339e-06,
                    1.2619e-06,
                    1.3927e-06,
                    1.5261e-06,
                    1.6621e-06,
                    1.8009e-06,
                    1.9423e-06,
                    2.0864e-06,
                    2.2331e-06,
                    2.3825e-06,
                    2.5346e-06,
                    2.6906e-06,
                    2.8505e-06,
                    3.0142e-06,
                    3.1819e-06,
                    3.3535e-06,
                    3.529e-06,
                    3.7084e-06,
                    3.8916e-06,
                    4.0788e-06,
                    4.2699e-06,
                    4.4649e-06,
                    4.6637e-06,
                    4.8665e-06,
                    5.0732e-06,
                    5.2838e-06,
                    5.4982e-06,
                    5.7166e-06,
                    5.9389e-06,
                    6.1651e-06,
                    6.3951e-06,
                    6.6258e-06,
                    6.8571e-06,
                    7.0891e-06,
                    7.3216e-06,
                    7.5548e-06,
                    7.7886e-06,
                    8.023e-06,
                    8.258e-06,
                    8.4937e-06,
                    8.73e-06,
                    8.9844e-06,
                    9.2568e-06,
                    9.5474e-06,
                    9.8561e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_N2O": 0.05,
                "Total_N2O_timeseries": [
                    1.5019e-08,
                    3.0248e-08,
                    4.5681e-08,
                    6.1313e-08,
                    7.7133e-08,
                    9.3131e-08,
                    1.0929e-07,
                    1.256e-07,
                    1.4204e-07,
                    1.586e-07,
                    1.7525e-07,
                    1.92e-07,
                    2.0885e-07,
                    2.2579e-07,
                    2.4282e-07,
                    2.5994e-07,
                    2.7716e-07,
                    2.9447e-07,
                    3.1188e-07,
                    3.2939e-07,
                    3.471e-07,
                    3.652e-07,
                    3.8381e-07,
                    4.0304e-07,
                    4.2292e-07,
                    4.4349e-07,
                    4.6471e-07,
                    4.8651e-07,
                    5.0878e-07,
                    5.3137e-07,
                    5.5418e-07,
                    5.7719e-07,
                    6.0038e-07,
                    6.2374e-07,
                    6.4726e-07,
                    6.7094e-07,
                    6.9477e-07,
                    7.1877e-07,
                    7.4293e-07,
                    7.717e-07,
                    8.0083e-07,
                    8.3051e-07,
                    8.6094e-07,
                    8.9228e-07,
                    9.2469e-07,
                    9.5829e-07,
                    9.9318e-07,
                    1.0295e-06,
                    1.0672e-06,
                    1.1064e-06,
                    1.1477e-06,
                    1.1918e-06,
                    1.2393e-06,
                    1.2908e-06,
                    1.3463e-06,
                    1.4058e-06,
                    1.4691e-06,
                    1.5355e-06,
                    1.6045e-06,
                    1.6749e-06,
                    1.7463e-06,
                    1.8186e-06,
                    1.8918e-06,
                    1.9657e-06,
                    2.0404e-06,
                    2.1158e-06,
                    2.1918e-06,
                    2.2683e-06,
                    2.3453e-06,
                    2.4226e-06,
                    2.5001e-06,
                    2.5775e-06,
                    2.6546e-06,
                    2.7313e-06,
                    2.8075e-06,
                    2.8832e-06,
                    2.9584e-06,
                    3.0334e-06,
                    3.1082e-06,
                    3.1832e-06,
                    3.2588e-06,
                    3.3355e-06,
                    3.4138e-06,
                    3.4939e-06,
                    3.5762e-06,
                    3.6609e-06,
                    3.7481e-06,
                    3.8378e-06,
                    3.93e-06,
                    4.0245e-06,
                    4.1237e-06,
                    4.2319e-06,
                    4.3522e-06,
                    4.4872e-06,
                    4.638e-06,
                    4.8052e-06,
                    4.988e-06,
                    5.1851e-06,
                    5.3939e-06,
                    5.611e-06,
                    5.8363e-06,
                    6.0734e-06,
                    6.3249e-06,
                    6.5928e-06,
                    6.878e-06,
                    7.181e-06,
                    7.5012e-06,
                    7.8373e-06,
                    8.1871e-06,
                    8.5477e-06,
                    8.9052e-06,
                    9.2787e-06,
                    9.6883e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_N2O": 0.03,
                "Fossil_N2O_timeseries": [
                    1.0705e-08,
                    2.1535e-08,
                    3.2487e-08,
                    4.3559e-08,
                    5.4749e-08,
                    6.6053e-08,
                    7.7468e-08,
                    8.8988e-08,
                    1.0061e-07,
                    1.1233e-07,
                    1.2414e-07,
                    1.3604e-07,
                    1.4802e-07,
                    1.601e-07,
                    1.7227e-07,
                    1.8453e-07,
                    1.9688e-07,
                    2.0932e-07,
                    2.2185e-07,
                    2.3447e-07,
                    2.4722e-07,
                    2.6013e-07,
                    2.7326e-07,
                    2.8664e-07,
                    3.0027e-07,
                    3.1416e-07,
                    3.283e-07,
                    3.4268e-07,
                    3.5725e-07,
                    3.7198e-07,
                    3.8684e-07,
                    4.0182e-07,
                    4.1692e-07,
                    4.3213e-07,
                    4.4744e-07,
                    4.6287e-07,
                    4.784e-07,
                    4.9404e-07,
                    5.098e-07,
                    5.2589e-07,
                    5.4214e-07,
                    5.5858e-07,
                    5.752e-07,
                    5.92e-07,
                    6.0901e-07,
                    6.2621e-07,
                    6.4362e-07,
                    6.6124e-07,
                    6.7908e-07,
                    6.9715e-07,
                    7.1545e-07,
                    7.34e-07,
                    7.5283e-07,
                    7.7194e-07,
                    7.9134e-07,
                    8.1103e-07,
                    8.3101e-07,
                    8.5128e-07,
                    8.7184e-07,
                    8.9266e-07,
                    9.1375e-07,
                    9.351e-07,
                    9.567e-07,
                    9.7855e-07,
                    1.0007e-06,
                    1.023e-06,
                    1.0456e-06,
                    1.0685e-06,
                    1.0916e-06,
                    1.1149e-06,
                    1.1386e-06,
                    1.1624e-06,
                    1.1865e-06,
                    1.2109e-06,
                    1.2355e-06,
                    1.2604e-06,
                    1.2855e-06,
                    1.3109e-06,
                    1.3365e-06,
                    1.3625e-06,
                    1.3887e-06,
                    1.4151e-06,
                    1.4419e-06,
                    1.4689e-06,
                    1.4962e-06,
                    1.5238e-06,
                    1.5517e-06,
                    1.58e-06,
                    1.6085e-06,
                    1.6375e-06,
                    1.6669e-06,
                    1.6969e-06,
                    1.7276e-06,
                    1.759e-06,
                    1.7913e-06,
                    1.8244e-06,
                    1.8585e-06,
                    1.8934e-06,
                    1.9292e-06,
                    1.9659e-06,
                    2.0034e-06,
                    2.0421e-06,
                    2.0821e-06,
                    2.1235e-06,
                    2.1664e-06,
                    2.2109e-06,
                    2.2571e-06,
                    2.3048e-06,
                    2.3541e-06,
                    2.4049e-06,
                    2.4569e-06,
                    2.5101e-06,
                    2.5644e-06,
                    2.6198e-06,
                    2.6763e-06,
                    2.7341e-06,
                    2.7935e-06,
                    2.8549e-06,
                    2.9185e-06,
                    2.9792e-06,
                    3.0401e-06,
                    3.1044e-06,
                    3.1714e-06,
                    3.2419e-06,
                    3.3166e-06,
                    3.394e-06,
                    3.4749e-06,
                    3.5593e-06,
                    3.6446e-06,
                    3.7228e-06,
                    3.8013e-06,
                    3.8815e-06,
                    3.9648e-06,
                    4.0486e-06,
                    4.1347e-06,
                    4.212e-06,
                    4.2952e-06,
                    4.3746e-06,
                    4.4551e-06,
                    4.5394e-06,
                    4.6325e-06,
                    4.7299e-06,
                    4.8298e-06,
                    4.933e-06,
                    5.0448e-06,
                    5.1541e-06,
                    5.2715e-06,
                    5.3943e-06,
                    5.5218e-06,
                    5.6175e-06,
                    5.7191e-06,
                    5.8214e-06,
                    5.9273e-06,
                    6.035e-06,
                    6.1444e-06,
                    6.2589e-06,
                    6.3695e-06,
                    6.4756e-06,
                    6.5832e-06,
                    6.6874e-06,
                    6.7915e-06,
                    6.8919e-06,
                    6.9897e-06,
                    7.0858e-06,
                    7.1865e-06,
                    7.2919e-06,
                    7.3914e-06,
                    7.4917e-06,
                    7.5934e-06,
                    7.6912e-06,
                    7.7953e-06,
                    7.903e-06
                ],
                "Land_N2O": 0.05,
                "Land_N2O_timeseries": [
                    4.3132e-09,
                    8.7127e-09,
                    1.3195e-08,
                    1.7754e-08,
                    2.2384e-08,
                    2.7078e-08,
                    3.1824e-08,
                    3.6614e-08,
                    4.1434e-08,
                    4.627e-08,
                    5.1115e-08,
                    5.5967e-08,
                    6.0822e-08,
                    6.5681e-08,
                    7.0543e-08,
                    7.5408e-08,
                    8.0276e-08,
                    8.5149e-08,
                    9.0029e-08,
                    9.4918e-08,
                    9.9888e-08,
                    1.0507e-07,
                    1.1055e-07,
                    1.164e-07,
                    1.2266e-07,
                    1.2933e-07,
                    1.3641e-07,
                    1.4383e-07,
                    1.5152e-07,
                    1.5938e-07,
                    1.6734e-07,
                    1.7537e-07,
                    1.8346e-07,
                    1.9162e-07,
                    1.9982e-07,
                    2.0807e-07,
                    2.1637e-07,
                    2.2472e-07,
                    2.3313e-07,
                    2.4582e-07,
                    2.5868e-07,
                    2.7193e-07,
                    2.8574e-07,
                    3.0028e-07,
                    3.1568e-07,
                    3.3208e-07,
                    3.4956e-07,
                    3.6822e-07,
                    3.8811e-07,
                    4.0928e-07,
                    4.3222e-07,
                    4.5776e-07,
                    4.8652e-07,
                    5.1887e-07,
                    5.5499e-07,
                    5.9482e-07,
                    6.3807e-07,
                    6.8424e-07,
                    7.3262e-07,
                    7.8224e-07,
                    8.3255e-07,
                    8.8351e-07,
                    9.3506e-07,
                    9.8716e-07,
                    1.0398e-06,
                    1.0928e-06,
                    1.1461e-06,
                    1.1998e-06,
                    1.2537e-06,
                    1.3076e-06,
                    1.3615e-06,
                    1.4151e-06,
                    1.4681e-06,
                    1.5204e-06,
                    1.572e-06,
                    1.6228e-06,
                    1.6729e-06,
                    1.7225e-06,
                    1.7717e-06,
                    1.8207e-06,
                    1.8701e-06,
                    1.9204e-06,
                    1.9719e-06,
                    2.025e-06,
                    2.0801e-06,
                    2.1371e-06,
                    2.1964e-06,
                    2.2578e-06,
                    2.3214e-06,
                    2.387e-06,
                    2.4568e-06,
                    2.535e-06,
                    2.6247e-06,
                    2.7282e-06,
                    2.8467e-06,
                    2.9807e-06,
                    3.1296e-06,
                    3.2917e-06,
                    3.4647e-06,
                    3.6451e-06,
                    3.8329e-06,
                    4.0313e-06,
                    4.2429e-06,
                    4.4693e-06,
                    4.7116e-06,
                    4.9701e-06,
                    5.2441e-06,
                    5.5325e-06,
                    5.833e-06,
                    6.1428e-06,
                    6.4482e-06,
                    6.7686e-06,
                    7.1239e-06,
                    7.4841e-06,
                    7.8249e-06,
                    8.2052e-06,
                    8.5732e-06,
                    8.9569e-06,
                    9.3457e-06,
                    9.7655e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -87.81666,
                            13.40716
                        ],
                        [
                            -87.72075,
                            13.44874
                        ],
                        [
                            -87.72046,
                            13.5038
                        ],
                        [
                            -87.77805,
                            13.51064
                        ],
                        [
                            -87.75343,
                            13.68642
                        ],
                        [
                            -87.7141,
                            13.81677
                        ],
                        [
                            -87.79773,
                            13.88892
                        ],
                        [
                            -87.95991,
                            13.89801
                        ],
                        [
                            -88.01298,
                            13.87343
                        ],
                        [
                            -88.07376,
                            13.99139
                        ],
                        [
                            -88.16419,
                            13.98244
                        ],
                        [
                            -88.31885,
                            13.88955
                        ],
                        [
                            -88.49333,
                            13.86393
                        ],
                        [
                            -88.50235,
                            13.9705
                        ],
                        [
                            -88.72859,
                            14.04856
                        ],
                        [
                            -88.73688,
                            14.11946
                        ],
                        [
                            -88.82975,
                            14.10726
                        ],
                        [
                            -88.87275,
                            14.18443
                        ],
                        [
                            -88.97158,
                            14.21421
                        ],
                        [
                            -89.0252,
                            14.27265
                        ],
                        [
                            -89.03609,
                            14.33299
                        ],
                        [
                            -89.14924,
                            14.35299
                        ],
                        [
                            -89.29881,
                            14.41426
                        ],
                        [
                            -89.35319,
                            14.41849
                        ],
                        [
                            -89.48417,
                            14.41476
                        ],
                        [
                            -89.52131,
                            14.38246
                        ],
                        [
                            -89.57191,
                            14.40566
                        ],
                        [
                            -89.58201,
                            14.31273
                        ],
                        [
                            -89.54801,
                            14.29886
                        ],
                        [
                            -89.51966,
                            14.22424
                        ],
                        [
                            -89.66173,
                            14.18325
                        ],
                        [
                            -89.77685,
                            14.03102
                        ],
                        [
                            -89.82277,
                            14.06138
                        ],
                        [
                            -90.02606,
                            13.93473
                        ],
                        [
                            -90.0434,
                            13.89041
                        ],
                        [
                            -90.11042,
                            13.83024
                        ],
                        [
                            -90.12432,
                            13.74091
                        ],
                        [
                            -89.94398,
                            13.66115
                        ],
                        [
                            -89.84709,
                            13.60432
                        ],
                        [
                            -89.80799,
                            13.5263
                        ],
                        [
                            -89.67777,
                            13.53217
                        ],
                        [
                            -89.52744,
                            13.49527
                        ],
                        [
                            -89.29536,
                            13.48285
                        ],
                        [
                            -88.83447,
                            13.25929
                        ],
                        [
                            -88.75096,
                            13.23148
                        ],
                        [
                            -88.4062,
                            13.16193
                        ],
                        [
                            -88.35924,
                            13.1763
                        ],
                        [
                            -88.22162,
                            13.16171
                        ],
                        [
                            -88.10656,
                            13.17236
                        ],
                        [
                            -87.90366,
                            13.1577
                        ],
                        [
                            -87.90986,
                            13.20356
                        ],
                        [
                            -87.83114,
                            13.24088
                        ],
                        [
                            -87.78472,
                            13.29458
                        ],
                        [
                            -87.867,
                            13.36177
                        ],
                        [
                            -87.81666,
                            13.40716
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "GNQ",
                "Country": "Equatorial Guinea",
                "Total_3GHG": 0.04,
                "Total_3GHG_timeseries": [
                    5.4302e-08,
                    7.856e-08,
                    1.3443e-07,
                    1.8286e-07,
                    6.8569e-08,
                    1.2612e-07,
                    9.2131e-08,
                    1.6872e-08,
                    -0.0000001164,
                    -0.00000017588,
                    -0.00000010887,
                    -0.0000000024709,
                    1.1639e-07,
                    2.9826e-07,
                    4.4e-07,
                    4.3855e-07,
                    6.2059e-07,
                    7.2708e-07,
                    8.0808e-07,
                    9.2819e-07,
                    9.6902e-07,
                    1.1664e-06,
                    1.2888e-06,
                    1.4832e-06,
                    1.6185e-06,
                    1.7027e-06,
                    1.7186e-06,
                    1.7363e-06,
                    1.7111e-06,
                    1.7106e-06,
                    1.8149e-06,
                    1.8108e-06,
                    1.8615e-06,
                    1.7965e-06,
                    1.83e-06,
                    1.8946e-06,
                    1.9474e-06,
                    2.2003e-06,
                    2.4292e-06,
                    2.6198e-06,
                    2.7384e-06,
                    2.7907e-06,
                    2.914e-06,
                    3.0672e-06,
                    3.2462e-06,
                    3.422e-06,
                    3.6087e-06,
                    3.7593e-06,
                    3.9029e-06,
                    4.1178e-06,
                    4.4009e-06,
                    4.681e-06,
                    4.9263e-06,
                    5.3048e-06,
                    5.666e-06,
                    6.0712e-06,
                    6.5692e-06,
                    7.0352e-06,
                    7.636e-06,
                    8.1539e-06,
                    8.4099e-06,
                    8.7287e-06,
                    8.9283e-06,
                    9.2208e-06,
                    9.6352e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006
                ],
                "Fossil_3GHG": 0.05,
                "Fossil_3GHG_timeseries": [
                    7.4793e-09,
                    1.4131e-08,
                    1.9964e-08,
                    2.4986e-08,
                    2.9208e-08,
                    3.2635e-08,
                    3.5278e-08,
                    3.7145e-08,
                    3.8242e-08,
                    3.8578e-08,
                    3.8214e-08,
                    3.7158e-08,
                    3.7081e-08,
                    3.633e-08,
                    3.4912e-08,
                    3.2835e-08,
                    3.0106e-08,
                    2.6734e-08,
                    2.2725e-08,
                    1.8086e-08,
                    1.3617e-08,
                    9.3199e-09,
                    5.1959e-09,
                    1.2459e-09,
                    -0.0000000025304,
                    -0.0000000061341,
                    -0.0000000095669,
                    -0.000000012832,
                    -0.000000015932,
                    -0.000000018872,
                    -0.000000021702,
                    -0.000000024422,
                    -0.000000028593,
                    -0.00000003266,
                    -0.000000036624,
                    -0.000000040486,
                    -0.000000044246,
                    -0.000000047906,
                    -0.000000051467,
                    -0.000000054926,
                    -0.000000058286,
                    -0.000000061548,
                    -0.000000064712,
                    -0.000000067779,
                    -0.000000070751,
                    -0.000000073626,
                    -0.000000076407,
                    -0.000000079093,
                    -0.000000081685,
                    -0.000000084183,
                    -0.00000008643,
                    -0.000000088429,
                    -0.000000090184,
                    -0.000000091698,
                    -0.000000092976,
                    -0.000000094021,
                    -0.000000094837,
                    -0.000000095429,
                    -0.0000000958,
                    -0.000000089624,
                    -0.000000086099,
                    -0.000000084987,
                    -0.000000086064,
                    -0.000000086683,
                    -0.000000086849,
                    -0.000000086567,
                    -0.000000085841,
                    -0.000000084676,
                    -0.000000083077,
                    -0.000000081047,
                    -0.000000078615,
                    -0.000000075781,
                    -0.000000072543,
                    -0.000000068899,
                    -0.00000006485,
                    -0.000000060393,
                    -0.000000055567,
                    -0.000000050372,
                    -0.000000044812,
                    -0.000000043863,
                    -0.00000003889,
                    -0.000000030099,
                    -0.000000017685,
                    -0.0000000041158,
                    1.0627e-08,
                    2.6563e-08,
                    4.3606e-08,
                    6.1761e-08,
                    8.1185e-08,
                    1.019e-07,
                    1.2423e-07,
                    1.4821e-07,
                    1.7387e-07,
                    2.0125e-07,
                    2.2875e-07,
                    2.5632e-07,
                    2.8526e-07,
                    3.1554e-07,
                    3.4567e-07,
                    3.8626e-07,
                    4.2619e-07,
                    4.6492e-07,
                    5.021e-07,
                    5.5125e-07,
                    6.0415e-07,
                    6.5554e-07,
                    7.0288e-07,
                    7.5986e-07,
                    8.1544e-07,
                    8.5049e-07,
                    8.8377e-07,
                    9.1469e-07,
                    9.4599e-07,
                    9.7508e-07,
                    1.0065e-06,
                    1.0356e-06,
                    1.0638e-06,
                    1.0942e-06,
                    1.1355e-06,
                    1.1766e-06,
                    1.2401e-06,
                    1.3138e-06,
                    1.3546e-06,
                    1.4018e-06,
                    1.4536e-06,
                    1.5152e-06,
                    1.5818e-06,
                    1.6527e-06,
                    1.7263e-06,
                    1.8332e-06,
                    1.9343e-06,
                    2.0611e-06,
                    2.1942e-06,
                    2.3544e-06,
                    2.5251e-06,
                    2.7196e-06,
                    2.9414e-06,
                    3.1925e-06,
                    3.4619e-06,
                    3.7169e-06,
                    4.9132e-06,
                    7.1364e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Land_3GHG": 0.02,
                "Land_3GHG_timeseries": [
                    4.6823e-08,
                    6.4429e-08,
                    1.1446e-07,
                    1.5788e-07,
                    3.9362e-08,
                    9.3483e-08,
                    5.6852e-08,
                    -0.000000020273,
                    -0.00000015464,
                    -0.00000021446,
                    -0.00000014709,
                    -0.000000039629,
                    7.9308e-08,
                    2.6193e-07,
                    4.0509e-07,
                    4.0572e-07,
                    5.9049e-07,
                    7.0035e-07,
                    7.8536e-07,
                    9.1011e-07,
                    9.554e-07,
                    1.157e-06,
                    1.2836e-06,
                    1.4819e-06,
                    1.6211e-06,
                    1.7089e-06,
                    1.7282e-06,
                    1.7491e-06,
                    1.727e-06,
                    1.7295e-06,
                    1.8366e-06,
                    1.8352e-06,
                    1.8901e-06,
                    1.8292e-06,
                    1.8667e-06,
                    1.9351e-06,
                    1.9916e-06,
                    2.2482e-06,
                    2.4807e-06,
                    2.6747e-06,
                    2.7967e-06,
                    2.8522e-06,
                    2.9787e-06,
                    3.135e-06,
                    3.317e-06,
                    3.4957e-06,
                    3.6851e-06,
                    3.8384e-06,
                    3.9846e-06,
                    4.202e-06,
                    4.4873e-06,
                    4.7694e-06,
                    5.0165e-06,
                    5.3965e-06,
                    5.759e-06,
                    6.1652e-06,
                    6.664e-06,
                    7.1306e-06,
                    7.7318e-06,
                    8.2436e-06,
                    8.496e-06,
                    8.8137e-06,
                    9.0143e-06,
                    9.3074e-06,
                    9.7221e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_CO2": 0.02,
                "Total_CO2_timeseries": [
                    4.5848e-08,
                    6.2475e-08,
                    1.1152e-07,
                    1.5395e-07,
                    3.4441e-08,
                    8.7566e-08,
                    4.9935e-08,
                    -0.000000028193,
                    -0.00000016356,
                    -0.00000022439,
                    -0.00000015804,
                    -0.000000051612,
                    6.628e-08,
                    2.4784e-07,
                    3.8993e-07,
                    3.8948e-07,
                    5.7316e-07,
                    6.8191e-07,
                    7.658e-07,
                    8.8941e-07,
                    9.3355e-07,
                    1.134e-06,
                    1.2594e-06,
                    1.4565e-06,
                    1.5944e-06,
                    1.6809e-06,
                    1.6988e-06,
                    1.7184e-06,
                    1.6949e-06,
                    1.696e-06,
                    1.8017e-06,
                    1.7989e-06,
                    1.8523e-06,
                    1.79e-06,
                    1.826e-06,
                    1.8931e-06,
                    1.9481e-06,
                    2.2033e-06,
                    2.4343e-06,
                    2.6268e-06,
                    2.7473e-06,
                    2.8014e-06,
                    2.9263e-06,
                    3.0811e-06,
                    3.2616e-06,
                    3.4388e-06,
                    3.6267e-06,
                    3.7785e-06,
                    3.9231e-06,
                    4.139e-06,
                    4.4227e-06,
                    4.7033e-06,
                    4.9487e-06,
                    5.3272e-06,
                    5.6881e-06,
                    6.0927e-06,
                    6.5899e-06,
                    7.0549e-06,
                    7.6545e-06,
                    8.1646e-06,
                    8.4153e-06,
                    8.7313e-06,
                    8.9301e-06,
                    9.2213e-06,
                    9.6339e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_CO2": 0.01,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    4.95e-09,
                    9.9e-09,
                    1.485e-08,
                    1.98e-08,
                    3.3e-08,
                    4.95e-08,
                    6.6e-08,
                    8.085e-08,
                    1.023e-07,
                    1.2375e-07,
                    1.3365e-07,
                    1.4355e-07,
                    1.5345e-07,
                    1.65e-07,
                    1.7655e-07,
                    1.8975e-07,
                    2.013e-07,
                    2.1285e-07,
                    2.2605e-07,
                    2.4585e-07,
                    2.6235e-07,
                    2.9205e-07,
                    3.3165e-07,
                    3.4485e-07,
                    3.6795e-07,
                    3.96e-07,
                    4.2405e-07,
                    4.521e-07,
                    4.8345e-07,
                    5.115e-07,
                    5.379e-07,
                    5.6925e-07,
                    6.0225e-07,
                    6.303e-07,
                    6.666e-07,
                    6.963e-07,
                    7.326e-07,
                    7.7715e-07,
                    8.25e-07,
                    8.778e-07,
                    9.0585e-07,
                    9.3555e-07,
                    9.6525e-07,
                    9.966e-07,
                    1.5158e-06,
                    2.0684e-06,
                    2.6788e-06,
                    3.5681e-06,
                    4.6049e-06,
                    5.7358e-06,
                    6.9514e-06,
                    8.345e-06,
                    9.5885e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CO2": 0.03,
                "Land_CO2_timeseries": [
                    4.5848e-08,
                    6.2475e-08,
                    1.1152e-07,
                    1.5395e-07,
                    3.4441e-08,
                    8.7566e-08,
                    4.9935e-08,
                    -0.000000028193,
                    -0.00000016356,
                    -0.00000022439,
                    -0.00000015804,
                    -0.000000051612,
                    6.628e-08,
                    2.4784e-07,
                    3.8993e-07,
                    3.8948e-07,
                    5.7316e-07,
                    6.8191e-07,
                    7.658e-07,
                    8.8941e-07,
                    9.3355e-07,
                    1.134e-06,
                    1.2594e-06,
                    1.4565e-06,
                    1.5944e-06,
                    1.6809e-06,
                    1.6988e-06,
                    1.7184e-06,
                    1.6949e-06,
                    1.696e-06,
                    1.8017e-06,
                    1.7989e-06,
                    1.8523e-06,
                    1.79e-06,
                    1.826e-06,
                    1.8931e-06,
                    1.9481e-06,
                    2.2033e-06,
                    2.4343e-06,
                    2.6268e-06,
                    2.7473e-06,
                    2.8014e-06,
                    2.9263e-06,
                    3.0811e-06,
                    3.2616e-06,
                    3.4388e-06,
                    3.6267e-06,
                    3.7785e-06,
                    3.9231e-06,
                    4.139e-06,
                    4.4227e-06,
                    4.7033e-06,
                    4.9487e-06,
                    5.3272e-06,
                    5.6881e-06,
                    6.0927e-06,
                    6.5899e-06,
                    7.0549e-06,
                    7.6545e-06,
                    8.1646e-06,
                    8.4153e-06,
                    8.7313e-06,
                    8.9301e-06,
                    9.2213e-06,
                    9.6339e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_CH4": 0.1,
                "Total_CH4_timeseries": [
                    7.9652e-09,
                    1.5099e-08,
                    2.1411e-08,
                    2.691e-08,
                    3.1604e-08,
                    3.5502e-08,
                    3.8613e-08,
                    4.0945e-08,
                    4.2506e-08,
                    4.3305e-08,
                    4.3415e-08,
                    4.2843e-08,
                    4.3261e-08,
                    4.3016e-08,
                    4.2115e-08,
                    4.0566e-08,
                    3.8377e-08,
                    3.5554e-08,
                    3.2106e-08,
                    2.8039e-08,
                    2.415e-08,
                    2.0438e-08,
                    1.6901e-08,
                    1.3539e-08,
                    1.0349e-08,
                    7.3305e-09,
                    4.4819e-09,
                    1.8021e-09,
                    -0.00000000071023,
                    -0.0000000030562,
                    -0.0000000052935,
                    -0.0000000074232,
                    -0.000000011006,
                    -0.000000014485,
                    -0.000000017861,
                    -0.000000021137,
                    -0.000000024312,
                    -0.000000027387,
                    -0.000000030364,
                    -0.000000033244,
                    -0.000000036027,
                    -0.000000038714,
                    -0.000000041305,
                    -0.000000043802,
                    -0.000000046206,
                    -0.000000048517,
                    -0.000000050735,
                    -0.000000052863,
                    -0.0000000549,
                    -0.000000056846,
                    -0.000000058547,
                    -0.000000060004,
                    -0.000000061223,
                    -0.000000062209,
                    -0.000000062964,
                    -0.000000063494,
                    -0.000000063802,
                    -0.000000063893,
                    -0.000000063769,
                    -0.000000057104,
                    -0.000000053055,
                    -0.000000051382,
                    -0.000000051863,
                    -0.00000005185,
                    -0.000000051348,
                    -0.000000050362,
                    -0.000000048896,
                    -0.000000046956,
                    -0.000000044544,
                    -0.000000041667,
                    -0.000000038353,
                    -0.000000034601,
                    -0.000000030411,
                    -0.00000002578,
                    -0.000000020708,
                    -0.000000015194,
                    -0.0000000092751,
                    -0.0000000029534,
                    3.769e-09,
                    5.9165e-09,
                    1.2084e-08,
                    2.2065e-08,
                    3.5667e-08,
                    5.042e-08,
                    6.6344e-08,
                    8.3399e-08,
                    1.015e-07,
                    1.2065e-07,
                    1.4101e-07,
                    1.6259e-07,
                    1.857e-07,
                    2.1037e-07,
                    2.3663e-07,
                    2.6449e-07,
                    2.9235e-07,
                    3.2015e-07,
                    3.4921e-07,
                    3.7949e-07,
                    4.095e-07,
                    4.4493e-07,
                    4.798e-07,
                    5.1346e-07,
                    5.4552e-07,
                    5.8122e-07,
                    6.1733e-07,
                    6.5194e-07,
                    6.842e-07,
                    7.1956e-07,
                    7.5359e-07,
                    7.7872e-07,
                    8.0357e-07,
                    8.2558e-07,
                    8.4576e-07,
                    8.6333e-07,
                    8.8274e-07,
                    9.0186e-07,
                    9.2055e-07,
                    9.3947e-07,
                    9.6307e-07,
                    9.9145e-07,
                    1.0293e-06,
                    1.0676e-06,
                    1.0995e-06,
                    1.1288e-06,
                    1.1586e-06,
                    1.1973e-06,
                    1.2415e-06,
                    1.2865e-06,
                    1.3373e-06,
                    1.4234e-06,
                    1.4978e-06,
                    1.5922e-06,
                    1.7012e-06,
                    1.8265e-06,
                    1.972e-06,
                    2.1339e-06,
                    2.3074e-06,
                    2.5123e-06,
                    2.7316e-06,
                    2.9623e-06,
                    4.1323e-06,
                    6.3294e-06,
                    9.6041e-06,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Fossil_CH4": 0.17,
                "Fossil_CH4_timeseries": [
                    7.2022e-09,
                    1.3573e-08,
                    1.912e-08,
                    2.3854e-08,
                    2.7782e-08,
                    3.0914e-08,
                    3.3258e-08,
                    3.4823e-08,
                    3.5616e-08,
                    3.5646e-08,
                    3.4974e-08,
                    3.3609e-08,
                    3.3221e-08,
                    3.2157e-08,
                    3.0425e-08,
                    2.8032e-08,
                    2.4987e-08,
                    2.1295e-08,
                    1.6966e-08,
                    1.2005e-08,
                    7.2103e-09,
                    2.5793e-09,
                    -0.0000000018891,
                    -0.0000000061964,
                    -0.000000010344,
                    -0.000000014333,
                    -0.000000018165,
                    -0.000000021841,
                    -0.000000025362,
                    -0.000000028729,
                    -0.00000003199,
                    -0.000000035146,
                    -0.000000039756,
                    -0.000000044265,
                    -0.000000048674,
                    -0.000000052983,
                    -0.000000057195,
                    -0.000000061309,
                    -0.000000065326,
                    -0.000000069248,
                    -0.000000073076,
                    -0.000000076809,
                    -0.00000008045,
                    -0.000000083998,
                    -0.000000087455,
                    -0.000000090821,
                    -0.000000094097,
                    -0.000000097284,
                    -0.00000010038,
                    -0.00000010339,
                    -0.00000010616,
                    -0.00000010868,
                    -0.00000011097,
                    -0.00000011303,
                    -0.00000011486,
                    -0.00000011647,
                    -0.00000011786,
                    -0.00000011903,
                    -0.00000011999,
                    -0.00000011441,
                    -0.00000011149,
                    -0.00000011099,
                    -0.00000011268,
                    -0.00000011393,
                    -0.00000011473,
                    -0.00000011509,
                    -0.00000011501,
                    -0.0000001145,
                    -0.00000011357,
                    -0.00000011221,
                    -0.00000011045,
                    -0.00000010831,
                    -0.00000010576,
                    -0.00000010282,
                    -0.000000099483,
                    -0.000000095745,
                    -0.000000091645,
                    -0.000000087185,
                    -0.000000082367,
                    -0.000000082167,
                    -0.000000077951,
                    -0.000000069924,
                    -0.000000058281,
                    -0.000000045491,
                    -0.000000031535,
                    -0.000000016394,
                    -0.0000000001553,
                    1.7186e-08,
                    3.5785e-08,
                    5.5665e-08,
                    7.7134e-08,
                    1.0022e-07,
                    1.2494e-07,
                    1.5133e-07,
                    1.7776e-07,
                    2.042e-07,
                    2.3195e-07,
                    2.6099e-07,
                    2.8982e-07,
                    3.2412e-07,
                    3.5774e-07,
                    3.9011e-07,
                    4.2092e-07,
                    4.554e-07,
                    4.9033e-07,
                    5.237e-07,
                    5.5465e-07,
                    5.8861e-07,
                    6.2114e-07,
                    6.4466e-07,
                    6.6637e-07,
                    6.8566e-07,
                    7.0362e-07,
                    7.1931e-07,
                    7.3564e-07,
                    7.5113e-07,
                    7.6577e-07,
                    7.8079e-07,
                    8.001e-07,
                    8.2281e-07,
                    8.5467e-07,
                    8.8674e-07,
                    9.1213e-07,
                    9.3387e-07,
                    9.5559e-07,
                    9.8677e-07,
                    1.0231e-06,
                    1.0602e-06,
                    1.103e-06,
                    1.1809e-06,
                    1.2485e-06,
                    1.3352e-06,
                    1.436e-06,
                    1.5524e-06,
                    1.69e-06,
                    1.8443e-06,
                    2.0105e-06,
                    2.2078e-06,
                    2.4195e-06,
                    2.6428e-06,
                    3.8054e-06,
                    5.9952e-06,
                    9.2626e-06,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [
                    7.6304e-10,
                    1.5267e-09,
                    2.2911e-09,
                    3.056e-09,
                    3.8216e-09,
                    4.5879e-09,
                    5.3548e-09,
                    6.1223e-09,
                    6.8905e-09,
                    7.6593e-09,
                    8.4405e-09,
                    9.2343e-09,
                    1.0041e-08,
                    1.0859e-08,
                    1.169e-08,
                    1.2534e-08,
                    1.339e-08,
                    1.4259e-08,
                    1.514e-08,
                    1.6033e-08,
                    1.694e-08,
                    1.7859e-08,
                    1.8791e-08,
                    1.9735e-08,
                    2.0693e-08,
                    2.1663e-08,
                    2.2647e-08,
                    2.3643e-08,
                    2.4651e-08,
                    2.5673e-08,
                    2.6697e-08,
                    2.7723e-08,
                    2.8751e-08,
                    2.9781e-08,
                    3.0813e-08,
                    3.1847e-08,
                    3.2883e-08,
                    3.3921e-08,
                    3.4962e-08,
                    3.6004e-08,
                    3.7049e-08,
                    3.8096e-08,
                    3.9145e-08,
                    4.0196e-08,
                    4.1249e-08,
                    4.2304e-08,
                    4.3362e-08,
                    4.4421e-08,
                    4.5483e-08,
                    4.6547e-08,
                    4.7612e-08,
                    4.8681e-08,
                    4.9751e-08,
                    5.0823e-08,
                    5.1898e-08,
                    5.2975e-08,
                    5.4054e-08,
                    5.5135e-08,
                    5.6218e-08,
                    5.7304e-08,
                    5.8433e-08,
                    5.9605e-08,
                    6.082e-08,
                    6.2079e-08,
                    6.3381e-08,
                    6.4726e-08,
                    6.6114e-08,
                    6.7546e-08,
                    6.9021e-08,
                    7.054e-08,
                    7.2101e-08,
                    7.3705e-08,
                    7.5353e-08,
                    7.7043e-08,
                    7.8775e-08,
                    8.0551e-08,
                    8.237e-08,
                    8.4231e-08,
                    8.6136e-08,
                    8.8083e-08,
                    9.0034e-08,
                    9.1989e-08,
                    9.3949e-08,
                    9.5912e-08,
                    9.7879e-08,
                    9.9794e-08,
                    1.0166e-07,
                    1.0346e-07,
                    1.0522e-07,
                    1.0692e-07,
                    1.0857e-07,
                    1.1016e-07,
                    1.1169e-07,
                    1.1317e-07,
                    1.1459e-07,
                    1.1595e-07,
                    1.1725e-07,
                    1.185e-07,
                    1.1968e-07,
                    1.2081e-07,
                    1.2206e-07,
                    1.2335e-07,
                    1.246e-07,
                    1.2582e-07,
                    1.2701e-07,
                    1.2824e-07,
                    1.2954e-07,
                    1.3095e-07,
                    1.3245e-07,
                    1.3405e-07,
                    1.3721e-07,
                    1.3993e-07,
                    1.4214e-07,
                    1.4402e-07,
                    1.471e-07,
                    1.5073e-07,
                    1.5478e-07,
                    1.5868e-07,
                    1.6297e-07,
                    1.6864e-07,
                    1.7464e-07,
                    1.8085e-07,
                    1.8736e-07,
                    1.9492e-07,
                    2.0305e-07,
                    2.1055e-07,
                    2.1847e-07,
                    2.2631e-07,
                    2.3432e-07,
                    2.4245e-07,
                    2.4939e-07,
                    2.5693e-07,
                    2.6524e-07,
                    2.7414e-07,
                    2.8202e-07,
                    2.8956e-07,
                    2.9691e-07,
                    3.0455e-07,
                    3.1203e-07,
                    3.1948e-07,
                    3.2688e-07,
                    3.3426e-07,
                    3.4153e-07,
                    3.4794e-07,
                    3.5403e-07,
                    3.6078e-07,
                    3.672e-07,
                    3.7365e-07,
                    3.8013e-07,
                    3.8661e-07,
                    3.9312e-07,
                    3.995e-07,
                    4.0578e-07,
                    4.1198e-07,
                    4.1819e-07,
                    4.2442e-07,
                    4.3076e-07,
                    4.3699e-07,
                    4.4311e-07,
                    4.4864e-07,
                    4.5386e-07,
                    4.5929e-07,
                    4.6473e-07,
                    4.7009e-07,
                    4.7548e-07,
                    4.8078e-07,
                    4.8617e-07,
                    4.9174e-07,
                    4.9715e-07,
                    5.0255e-07,
                    5.0783e-07,
                    5.1319e-07
                ],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [
                    4.8897e-10,
                    9.8626e-10,
                    1.4916e-09,
                    2.0045e-09,
                    2.5245e-09,
                    3.0509e-09,
                    3.5831e-09,
                    4.12e-09,
                    4.6609e-09,
                    5.2045e-09,
                    5.7503e-09,
                    6.2979e-09,
                    6.8474e-09,
                    7.3986e-09,
                    7.9514e-09,
                    8.5059e-09,
                    9.0621e-09,
                    9.6202e-09,
                    1.018e-08,
                    1.0742e-08,
                    1.1312e-08,
                    1.1901e-08,
                    1.2514e-08,
                    1.3159e-08,
                    1.3837e-08,
                    1.4551e-08,
                    1.5297e-08,
                    1.6073e-08,
                    1.6871e-08,
                    1.7685e-08,
                    1.8507e-08,
                    1.9336e-08,
                    2.0173e-08,
                    2.1015e-08,
                    2.1863e-08,
                    2.2717e-08,
                    2.3575e-08,
                    2.4439e-08,
                    2.5309e-08,
                    2.6207e-08,
                    2.7113e-08,
                    2.8027e-08,
                    2.8951e-08,
                    2.9884e-08,
                    3.0827e-08,
                    3.178e-08,
                    3.2743e-08,
                    3.3717e-08,
                    3.4702e-08,
                    3.5698e-08,
                    3.6707e-08,
                    3.7728e-08,
                    3.8763e-08,
                    3.9813e-08,
                    4.0876e-08,
                    4.1956e-08,
                    4.3052e-08,
                    4.4164e-08,
                    4.5295e-08,
                    4.6443e-08,
                    4.7615e-08,
                    4.8818e-08,
                    5.0058e-08,
                    5.1339e-08,
                    5.2666e-08,
                    5.404e-08,
                    5.5463e-08,
                    5.6934e-08,
                    5.8452e-08,
                    6.0013e-08,
                    6.1618e-08,
                    6.3272e-08,
                    6.4978e-08,
                    6.6736e-08,
                    6.8545e-08,
                    7.0401e-08,
                    7.23e-08,
                    7.4235e-08,
                    7.6195e-08,
                    7.817e-08,
                    8.0148e-08,
                    8.2122e-08,
                    8.4083e-08,
                    8.6029e-08,
                    8.7957e-08,
                    8.9868e-08,
                    9.1765e-08,
                    9.3652e-08,
                    9.5538e-08,
                    9.7432e-08,
                    9.9457e-08,
                    1.0181e-07,
                    1.0465e-07,
                    1.0807e-07,
                    1.1212e-07,
                    1.1681e-07,
                    1.221e-07,
                    1.2789e-07,
                    1.3403e-07,
                    1.4034e-07,
                    1.4664e-07,
                    1.5284e-07,
                    1.5887e-07,
                    1.6468e-07,
                    1.7025e-07,
                    1.7558e-07,
                    1.8068e-07,
                    1.8562e-07,
                    1.9046e-07,
                    1.9529e-07,
                    2.0023e-07,
                    2.0535e-07,
                    2.105e-07,
                    2.1571e-07,
                    2.2115e-07,
                    2.2548e-07,
                    2.325e-07,
                    2.3956e-07,
                    2.4675e-07,
                    2.5419e-07,
                    2.6171e-07,
                    2.6947e-07,
                    2.7462e-07,
                    2.7993e-07,
                    2.8516e-07,
                    2.9062e-07,
                    2.9604e-07,
                    3.0161e-07,
                    3.0746e-07,
                    3.1333e-07,
                    3.1854e-07,
                    3.2858e-07,
                    3.3602e-07,
                    3.4672e-07,
                    3.5322e-07,
                    3.6036e-07,
                    3.747e-07,
                    3.84e-07,
                    3.9214e-07,
                    3.9932e-07,
                    4.0664e-07,
                    4.1399e-07,
                    4.2139e-07,
                    4.3011e-07,
                    4.3908e-07,
                    4.4841e-07,
                    4.5897e-07,
                    4.7033e-07,
                    4.8233e-07,
                    4.955e-07,
                    5.1071e-07,
                    5.2679e-07,
                    5.4396e-07,
                    5.6375e-07,
                    5.8555e-07,
                    6.0873e-07,
                    6.2937e-07,
                    6.5368e-07,
                    6.7795e-07,
                    7.0282e-07,
                    7.2828e-07,
                    7.5242e-07,
                    7.7615e-07,
                    7.9896e-07,
                    8.2102e-07,
                    8.4241e-07,
                    8.6314e-07,
                    8.8338e-07,
                    9.0496e-07,
                    9.2663e-07,
                    9.4889e-07,
                    9.7018e-07
                ],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [
                    2.7714e-10,
                    5.5836e-10,
                    8.4355e-10,
                    1.1325e-09,
                    1.4251e-09,
                    1.7211e-09,
                    2.0201e-09,
                    2.3219e-09,
                    2.626e-09,
                    2.9321e-09,
                    3.2399e-09,
                    3.5493e-09,
                    3.8603e-09,
                    4.1728e-09,
                    4.4869e-09,
                    4.8025e-09,
                    5.1196e-09,
                    5.4383e-09,
                    5.7587e-09,
                    6.0807e-09,
                    6.4068e-09,
                    6.7405e-09,
                    7.085e-09,
                    7.4423e-09,
                    7.8134e-09,
                    8.1988e-09,
                    8.5978e-09,
                    9.0088e-09,
                    9.4296e-09,
                    9.8569e-09,
                    1.0288e-08,
                    1.0724e-08,
                    1.1163e-08,
                    1.1605e-08,
                    1.205e-08,
                    1.2498e-08,
                    1.2949e-08,
                    1.3402e-08,
                    1.3859e-08,
                    1.4322e-08,
                    1.479e-08,
                    1.5262e-08,
                    1.5738e-08,
                    1.6219e-08,
                    1.6704e-08,
                    1.7194e-08,
                    1.769e-08,
                    1.8191e-08,
                    1.8698e-08,
                    1.921e-08,
                    1.9729e-08,
                    2.0256e-08,
                    2.0791e-08,
                    2.1334e-08,
                    2.1887e-08,
                    2.2448e-08,
                    2.3019e-08,
                    2.3599e-08,
                    2.4187e-08,
                    2.4784e-08,
                    2.5388e-08,
                    2.6e-08,
                    2.6619e-08,
                    2.7246e-08,
                    2.788e-08,
                    2.8521e-08,
                    2.917e-08,
                    2.9826e-08,
                    3.0489e-08,
                    3.116e-08,
                    3.1839e-08,
                    3.2526e-08,
                    3.322e-08,
                    3.3923e-08,
                    3.4633e-08,
                    3.5352e-08,
                    3.6078e-08,
                    3.6812e-08,
                    3.7554e-08,
                    3.8304e-08,
                    3.9061e-08,
                    3.9825e-08,
                    4.0597e-08,
                    4.1375e-08,
                    4.2162e-08,
                    4.2957e-08,
                    4.3761e-08,
                    4.4575e-08,
                    4.54e-08,
                    4.6237e-08,
                    4.7095e-08,
                    4.7989e-08,
                    4.8931e-08,
                    4.9929e-08,
                    5.099e-08,
                    5.2114e-08,
                    5.3301e-08,
                    5.4547e-08,
                    5.5844e-08,
                    5.7183e-08,
                    5.8554e-08,
                    5.9956e-08,
                    6.1387e-08,
                    6.2845e-08,
                    6.4329e-08,
                    6.5841e-08,
                    6.738e-08,
                    6.8947e-08,
                    7.0547e-08,
                    7.218e-08,
                    7.3854e-08,
                    7.5581e-08,
                    7.7368e-08,
                    7.9222e-08,
                    8.1145e-08,
                    8.314e-08,
                    8.5207e-08,
                    8.7341e-08,
                    8.9538e-08,
                    9.142e-08,
                    9.3334e-08,
                    9.5411e-08,
                    9.7653e-08,
                    9.994e-08,
                    1.0202e-07,
                    1.0439e-07,
                    1.0668e-07,
                    1.091e-07,
                    1.1177e-07,
                    1.1443e-07,
                    1.166e-07,
                    1.2358e-07,
                    1.2791e-07,
                    1.3544e-07,
                    1.3875e-07,
                    1.4266e-07,
                    1.5374e-07,
                    1.5974e-07,
                    1.6453e-07,
                    1.6831e-07,
                    1.7219e-07,
                    1.7604e-07,
                    1.799e-07,
                    1.8506e-07,
                    1.9042e-07,
                    1.9612e-07,
                    2.0301e-07,
                    2.1066e-07,
                    2.1891e-07,
                    2.2828e-07,
                    2.3966e-07,
                    2.513e-07,
                    2.6408e-07,
                    2.7896e-07,
                    2.9622e-07,
                    3.1467e-07,
                    3.3066e-07,
                    3.502e-07,
                    3.697e-07,
                    3.8962e-07,
                    4.1001e-07,
                    4.2916e-07,
                    4.4762e-07,
                    4.6512e-07,
                    4.8153e-07,
                    4.9754e-07,
                    5.1254e-07,
                    5.2723e-07,
                    5.4322e-07,
                    5.5914e-07,
                    5.756e-07,
                    5.9106e-07
                ],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": [
                    2.1183e-10,
                    4.2789e-10,
                    6.4801e-10,
                    8.7194e-10,
                    1.0993e-09,
                    1.3298e-09,
                    1.5629e-09,
                    1.7982e-09,
                    2.0349e-09,
                    2.2724e-09,
                    2.5104e-09,
                    2.7486e-09,
                    2.9871e-09,
                    3.2257e-09,
                    3.4645e-09,
                    3.7034e-09,
                    3.9425e-09,
                    4.1818e-09,
                    4.4215e-09,
                    4.6616e-09,
                    4.9057e-09,
                    5.16e-09,
                    5.4292e-09,
                    5.7165e-09,
                    6.0239e-09,
                    6.3518e-09,
                    6.6992e-09,
                    7.0638e-09,
                    7.4417e-09,
                    7.8276e-09,
                    8.2182e-09,
                    8.6126e-09,
                    9.0102e-09,
                    9.4106e-09,
                    9.8136e-09,
                    1.0219e-08,
                    1.0626e-08,
                    1.1037e-08,
                    1.145e-08,
                    1.1884e-08,
                    1.2323e-08,
                    1.2766e-08,
                    1.3213e-08,
                    1.3666e-08,
                    1.4123e-08,
                    1.4585e-08,
                    1.5053e-08,
                    1.5525e-08,
                    1.6004e-08,
                    1.6488e-08,
                    1.6978e-08,
                    1.7473e-08,
                    1.7973e-08,
                    1.8478e-08,
                    1.899e-08,
                    1.9508e-08,
                    2.0033e-08,
                    2.0565e-08,
                    2.1107e-08,
                    2.166e-08,
                    2.2227e-08,
                    2.2818e-08,
                    2.3438e-08,
                    2.4093e-08,
                    2.4786e-08,
                    2.5519e-08,
                    2.6294e-08,
                    2.7109e-08,
                    2.7963e-08,
                    2.8853e-08,
                    2.9779e-08,
                    3.0746e-08,
                    3.1758e-08,
                    3.2813e-08,
                    3.3911e-08,
                    3.5049e-08,
                    3.6222e-08,
                    3.7422e-08,
                    3.864e-08,
                    3.9866e-08,
                    4.1088e-08,
                    4.2297e-08,
                    4.3487e-08,
                    4.4654e-08,
                    4.5795e-08,
                    4.6911e-08,
                    4.8003e-08,
                    4.9077e-08,
                    5.0138e-08,
                    5.1196e-08,
                    5.2362e-08,
                    5.3823e-08,
                    5.5716e-08,
                    5.8137e-08,
                    6.1131e-08,
                    6.4701e-08,
                    6.8802e-08,
                    7.3343e-08,
                    7.8189e-08,
                    8.3157e-08,
                    8.8088e-08,
                    9.2887e-08,
                    9.7486e-08,
                    1.0184e-07,
                    1.0592e-07,
                    1.0974e-07,
                    1.133e-07,
                    1.1667e-07,
                    1.1991e-07,
                    1.2311e-07,
                    1.2638e-07,
                    1.2977e-07,
                    1.3313e-07,
                    1.3649e-07,
                    1.4e-07,
                    1.4234e-07,
                    1.4729e-07,
                    1.5222e-07,
                    1.5721e-07,
                    1.6277e-07,
                    1.6838e-07,
                    1.7406e-07,
                    1.7697e-07,
                    1.7999e-07,
                    1.8314e-07,
                    1.8623e-07,
                    1.8936e-07,
                    1.9251e-07,
                    1.9569e-07,
                    1.989e-07,
                    2.0194e-07,
                    2.05e-07,
                    2.0811e-07,
                    2.1128e-07,
                    2.1447e-07,
                    2.177e-07,
                    2.2096e-07,
                    2.2426e-07,
                    2.2761e-07,
                    2.3101e-07,
                    2.3446e-07,
                    2.3795e-07,
                    2.4149e-07,
                    2.4505e-07,
                    2.4866e-07,
                    2.523e-07,
                    2.5596e-07,
                    2.5967e-07,
                    2.6342e-07,
                    2.6722e-07,
                    2.7106e-07,
                    2.7549e-07,
                    2.7988e-07,
                    2.8479e-07,
                    2.8934e-07,
                    2.9406e-07,
                    2.987e-07,
                    3.0347e-07,
                    3.0826e-07,
                    3.132e-07,
                    3.1826e-07,
                    3.2327e-07,
                    3.2853e-07,
                    3.3384e-07,
                    3.3948e-07,
                    3.4487e-07,
                    3.506e-07,
                    3.5614e-07,
                    3.6174e-07,
                    3.6749e-07,
                    3.7329e-07,
                    3.7911e-07
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                9.82147,
                                2.34785
                            ],
                            [
                                9.77861,
                                2.32643
                            ],
                            [
                                9.79327,
                                2.1456
                            ],
                            [
                                9.76505,
                                2.09279
                            ],
                            [
                                9.81052,
                                1.9163
                            ],
                            [
                                9.74351,
                                1.84443
                            ],
                            [
                                9.72553,
                                1.77751
                            ],
                            [
                                9.61067,
                                1.66891
                            ],
                            [
                                9.59682,
                                1.57371
                            ],
                            [
                                9.56191,
                                1.48936
                            ],
                            [
                                9.46103,
                                1.39521
                            ],
                            [
                                9.45636,
                                1.32206
                            ],
                            [
                                9.39666,
                                1.27276
                            ],
                            [
                                9.36929,
                                1.18635
                            ],
                            [
                                9.38543,
                                1.10954
                            ],
                            [
                                9.47928,
                                1.13696
                            ],
                            [
                                9.53326,
                                1.12952
                            ],
                            [
                                9.58006,
                                1.04081
                            ],
                            [
                                9.66198,
                                1.05985
                            ],
                            [
                                9.74602,
                                1.06657
                            ],
                            [
                                9.79132,
                                0.99878
                            ],
                            [
                                9.87642,
                                0.98314
                            ],
                            [
                                9.95098,
                                0.92144
                            ],
                            [
                                9.98807,
                                0.92769
                            ],
                            [
                                9.99853,
                                0.99735
                            ],
                            [
                                10.2954,
                                0.99902
                            ],
                            [
                                11.02294,
                                0.99651
                            ],
                            [
                                11.33428,
                                1.00045
                            ],
                            [
                                11.33363,
                                1.52931
                            ],
                            [
                                11.33461,
                                2.17389
                            ],
                            [
                                10.79315,
                                2.17398
                            ],
                            [
                                10.1938,
                                2.17256
                            ],
                            [
                                10.03896,
                                2.16273
                            ],
                            [
                                9.92555,
                                2.20031
                            ],
                            [
                                9.84719,
                                2.24875
                            ],
                            [
                                9.82147,
                                2.34785
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.416,
                                3.36067
                            ],
                            [
                                8.44168,
                                3.28039
                            ],
                            [
                                8.67873,
                                3.21208
                            ],
                            [
                                8.76312,
                                3.31704
                            ],
                            [
                                8.77251,
                                3.39732
                            ],
                            [
                                8.80588,
                                3.42259
                            ],
                            [
                                8.85897,
                                3.53997
                            ],
                            [
                                8.93099,
                                3.63612
                            ],
                            [
                                8.93384,
                                3.71221
                            ],
                            [
                                8.88711,
                                3.76687
                            ],
                            [
                                8.73389,
                                3.75946
                            ],
                            [
                                8.69178,
                                3.77558
                            ],
                            [
                                8.61052,
                                3.66539
                            ],
                            [
                                8.60838,
                                3.56836
                            ],
                            [
                                8.57552,
                                3.47251
                            ],
                            [
                                8.47793,
                                3.47276
                            ],
                            [
                                8.44025,
                                3.43942
                            ],
                            [
                                8.416,
                                3.36067
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "ERI",
                "Country": "Eritrea",
                "Total_3GHG": 0.02,
                "Total_3GHG_timeseries": [
                    7.267e-08,
                    1.4304e-07,
                    2.1261e-07,
                    2.8389e-07,
                    3.5787e-07,
                    4.3467e-07,
                    5.0889e-07,
                    5.8419e-07,
                    6.6373e-07,
                    7.4922e-07,
                    8.3091e-07,
                    9.1356e-07,
                    9.9559e-07,
                    1.0826e-06,
                    1.1698e-06,
                    1.2543e-06,
                    1.3398e-06,
                    1.4269e-06,
                    1.5156e-06,
                    1.605e-06,
                    1.6956e-06,
                    1.7934e-06,
                    1.9049e-06,
                    2.0093e-06,
                    2.113e-06,
                    2.2204e-06,
                    2.329e-06,
                    2.4413e-06,
                    2.5566e-06,
                    2.6732e-06,
                    2.791e-06,
                    2.9149e-06,
                    3.0403e-06,
                    3.1638e-06,
                    3.2866e-06,
                    3.4098e-06,
                    3.5394e-06,
                    3.6759e-06,
                    3.8078e-06,
                    3.9434e-06,
                    4.0824e-06,
                    4.2247e-06,
                    4.3752e-06,
                    4.5222e-06,
                    4.6666e-06,
                    4.811e-06,
                    4.9585e-06,
                    5.1055e-06,
                    5.2579e-06,
                    5.4125e-06,
                    5.5816e-06,
                    5.7495e-06,
                    5.9191e-06,
                    6.0955e-06,
                    6.2783e-06,
                    6.4611e-06,
                    6.6489e-06,
                    6.8404e-06,
                    7.0349e-06,
                    7.2389e-06,
                    7.4567e-06,
                    7.6822e-06,
                    7.9347e-06,
                    8.1878e-06,
                    8.4516e-06,
                    8.7269e-06,
                    9.0107e-06,
                    9.3163e-06,
                    9.6252e-06,
                    9.9604e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_3GHG": 0.01,
                "Fossil_3GHG_timeseries": [
                    1.2003e-08,
                    2.472e-08,
                    3.8163e-08,
                    5.2343e-08,
                    6.7271e-08,
                    8.2956e-08,
                    9.941e-08,
                    1.1664e-07,
                    1.3467e-07,
                    1.5349e-07,
                    1.734e-07,
                    1.9442e-07,
                    2.1693e-07,
                    2.4057e-07,
                    2.6536e-07,
                    2.913e-07,
                    3.1842e-07,
                    3.4673e-07,
                    3.7624e-07,
                    4.0696e-07,
                    4.3832e-07,
                    4.7035e-07,
                    5.0306e-07,
                    5.3652e-07,
                    5.708e-07,
                    6.059e-07,
                    6.4184e-07,
                    6.7862e-07,
                    7.1624e-07,
                    7.5471e-07,
                    7.9377e-07,
                    8.3344e-07,
                    8.7338e-07,
                    9.1396e-07,
                    9.5519e-07,
                    9.9708e-07,
                    1.0396e-06,
                    1.0829e-06,
                    1.1269e-06,
                    1.1717e-06,
                    1.2172e-06,
                    1.2635e-06,
                    1.3107e-06,
                    1.3586e-06,
                    1.4072e-06,
                    1.4567e-06,
                    1.5069e-06,
                    1.5579e-06,
                    1.6097e-06,
                    1.6623e-06,
                    1.7176e-06,
                    1.7755e-06,
                    1.8363e-06,
                    1.8999e-06,
                    1.9666e-06,
                    2.0363e-06,
                    2.1092e-06,
                    2.1854e-06,
                    2.265e-06,
                    2.348e-06,
                    2.4372e-06,
                    2.5326e-06,
                    2.6344e-06,
                    2.7427e-06,
                    2.8576e-06,
                    2.9793e-06,
                    3.108e-06,
                    3.2435e-06,
                    3.386e-06,
                    3.5356e-06,
                    3.6907e-06,
                    3.8512e-06,
                    4.0174e-06,
                    4.1892e-06,
                    4.3667e-06,
                    4.5498e-06,
                    4.7385e-06,
                    4.9328e-06,
                    5.1328e-06,
                    5.3383e-06,
                    5.5482e-06,
                    5.7625e-06,
                    5.9811e-06,
                    6.2038e-06,
                    6.4308e-06,
                    6.6619e-06,
                    6.8971e-06,
                    7.1357e-06,
                    7.3847e-06,
                    7.6344e-06,
                    7.888e-06,
                    8.1506e-06,
                    8.4204e-06,
                    8.6973e-06,
                    8.9727e-06,
                    9.2549e-06,
                    9.544e-06,
                    9.8401e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_3GHG": 0.04,
                "Land_3GHG_timeseries": [
                    6.0667e-08,
                    1.1832e-07,
                    1.7445e-07,
                    2.3154e-07,
                    2.906e-07,
                    3.5172e-07,
                    4.0948e-07,
                    4.6755e-07,
                    5.2906e-07,
                    5.9573e-07,
                    6.575e-07,
                    7.1914e-07,
                    7.7866e-07,
                    8.4199e-07,
                    9.0445e-07,
                    9.6298e-07,
                    1.0214e-06,
                    1.0801e-06,
                    1.1393e-06,
                    1.1981e-06,
                    1.2572e-06,
                    1.323e-06,
                    1.4019e-06,
                    1.4728e-06,
                    1.5422e-06,
                    1.6145e-06,
                    1.6872e-06,
                    1.7627e-06,
                    1.8404e-06,
                    1.9185e-06,
                    1.9972e-06,
                    2.0815e-06,
                    2.167e-06,
                    2.2498e-06,
                    2.3314e-06,
                    2.4127e-06,
                    2.4998e-06,
                    2.593e-06,
                    2.6809e-06,
                    2.7718e-06,
                    2.8652e-06,
                    2.9612e-06,
                    3.0646e-06,
                    3.1637e-06,
                    3.2594e-06,
                    3.3543e-06,
                    3.4516e-06,
                    3.5477e-06,
                    3.6482e-06,
                    3.7501e-06,
                    3.864e-06,
                    3.974e-06,
                    4.0828e-06,
                    4.1956e-06,
                    4.3118e-06,
                    4.4249e-06,
                    4.5398e-06,
                    4.655e-06,
                    4.7699e-06,
                    4.8909e-06,
                    5.0194e-06,
                    5.1496e-06,
                    5.3004e-06,
                    5.4451e-06,
                    5.594e-06,
                    5.7476e-06,
                    5.9028e-06,
                    6.0729e-06,
                    6.2392e-06,
                    6.4248e-06,
                    6.6276e-06,
                    6.8461e-06,
                    7.0621e-06,
                    7.2813e-06,
                    7.507e-06,
                    7.7386e-06,
                    7.9826e-06,
                    8.2229e-06,
                    8.4798e-06,
                    8.7685e-06,
                    9.0786e-06,
                    9.3948e-06,
                    9.7209e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    3.6273e-08,
                    6.9047e-08,
                    9.982e-08,
                    1.3113e-07,
                    1.64e-07,
                    1.9857e-07,
                    2.2949e-07,
                    2.6047e-07,
                    2.9472e-07,
                    3.3404e-07,
                    3.6841e-07,
                    4.0261e-07,
                    4.3467e-07,
                    4.7051e-07,
                    5.0547e-07,
                    5.3649e-07,
                    5.6735e-07,
                    5.9854e-07,
                    6.3016e-07,
                    6.6125e-07,
                    6.9228e-07,
                    7.2881e-07,
                    7.7663e-07,
                    8.1447e-07,
                    8.4845e-07,
                    8.8305e-07,
                    9.157e-07,
                    9.4922e-07,
                    9.8338e-07,
                    1.017e-06,
                    1.0508e-06,
                    1.0896e-06,
                    1.1293e-06,
                    1.1661e-06,
                    1.2013e-06,
                    1.2359e-06,
                    1.276e-06,
                    1.322e-06,
                    1.3623e-06,
                    1.4032e-06,
                    1.4461e-06,
                    1.4911e-06,
                    1.5429e-06,
                    1.5899e-06,
                    1.6329e-06,
                    1.6746e-06,
                    1.7181e-06,
                    1.7597e-06,
                    1.8051e-06,
                    1.8513e-06,
                    1.9088e-06,
                    1.9619e-06,
                    2.0131e-06,
                    2.0676e-06,
                    2.1249e-06,
                    2.1783e-06,
                    2.2328e-06,
                    2.2866e-06,
                    2.3391e-06,
                    2.3965e-06,
                    2.4597e-06,
                    2.5218e-06,
                    2.6011e-06,
                    2.6705e-06,
                    2.7396e-06,
                    2.8088e-06,
                    2.8747e-06,
                    2.951e-06,
                    3.019e-06,
                    3.1021e-06,
                    3.1982e-06,
                    3.3053e-06,
                    3.4049e-06,
                    3.5025e-06,
                    3.6017e-06,
                    3.7022e-06,
                    3.8112e-06,
                    3.9133e-06,
                    4.03e-06,
                    4.1774e-06,
                    4.3469e-06,
                    4.5238e-06,
                    4.7129e-06,
                    4.9026e-06,
                    5.0911e-06,
                    5.2843e-06,
                    5.4897e-06,
                    5.6894e-06,
                    5.8914e-06,
                    6.322e-06,
                    6.8611e-06,
                    7.4575e-06,
                    8.0801e-06,
                    8.7323e-06,
                    9.3787e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    6.5464e-09,
                    9.8198e-09,
                    1.1456e-08,
                    1.6366e-08,
                    2.2913e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.1096e-08,
                    3.6606e-07,
                    7.3659e-07,
                    1.1412e-06,
                    1.5053e-06,
                    1.7692e-06,
                    2.0464e-06,
                    2.3186e-06,
                    2.6006e-06,
                    2.8711e-06,
                    3.1911e-06,
                    3.5374e-06,
                    3.8837e-06,
                    4.1309e-06,
                    4.3846e-06,
                    4.5689e-06,
                    4.7929e-06,
                    5.0168e-06,
                    5.277e-06,
                    5.5509e-06,
                    5.8074e-06,
                    6.0637e-06,
                    6.3133e-06,
                    6.5644e-06,
                    6.8152e-06,
                    7.0958e-06,
                    7.3877e-06,
                    7.6763e-06,
                    7.9917e-06,
                    8.3055e-06
                ],
                "Land_CO2": 0.01,
                "Land_CO2_timeseries": [
                    3.6273e-08,
                    6.9047e-08,
                    9.982e-08,
                    1.3113e-07,
                    1.64e-07,
                    1.9857e-07,
                    2.2949e-07,
                    2.6047e-07,
                    2.9472e-07,
                    3.3404e-07,
                    3.6841e-07,
                    4.0261e-07,
                    4.3467e-07,
                    4.7051e-07,
                    5.0547e-07,
                    5.3649e-07,
                    5.6735e-07,
                    5.9854e-07,
                    6.3016e-07,
                    6.6125e-07,
                    6.9228e-07,
                    7.2881e-07,
                    7.7663e-07,
                    8.1447e-07,
                    8.4845e-07,
                    8.8305e-07,
                    9.157e-07,
                    9.4922e-07,
                    9.8338e-07,
                    1.017e-06,
                    1.0508e-06,
                    1.0896e-06,
                    1.1293e-06,
                    1.1661e-06,
                    1.2013e-06,
                    1.2359e-06,
                    1.276e-06,
                    1.322e-06,
                    1.3623e-06,
                    1.4032e-06,
                    1.4461e-06,
                    1.4911e-06,
                    1.5429e-06,
                    1.5899e-06,
                    1.6329e-06,
                    1.6746e-06,
                    1.7181e-06,
                    1.7597e-06,
                    1.8051e-06,
                    1.8513e-06,
                    1.9088e-06,
                    1.9619e-06,
                    2.0131e-06,
                    2.0676e-06,
                    2.1249e-06,
                    2.1783e-06,
                    2.2328e-06,
                    2.2866e-06,
                    2.3391e-06,
                    2.3965e-06,
                    2.4597e-06,
                    2.5218e-06,
                    2.6011e-06,
                    2.6705e-06,
                    2.7396e-06,
                    2.8088e-06,
                    2.8747e-06,
                    2.951e-06,
                    3.019e-06,
                    3.1021e-06,
                    3.1982e-06,
                    3.3053e-06,
                    3.4049e-06,
                    3.5025e-06,
                    3.6017e-06,
                    3.7022e-06,
                    3.8112e-06,
                    3.9133e-06,
                    4.03e-06,
                    4.1774e-06,
                    4.3469e-06,
                    4.5238e-06,
                    4.7129e-06,
                    4.9026e-06,
                    5.0911e-06,
                    5.2843e-06,
                    5.4897e-06,
                    5.6894e-06,
                    5.8848e-06,
                    6.3122e-06,
                    6.8496e-06,
                    7.4411e-06,
                    8.0572e-06,
                    8.7012e-06,
                    9.3476e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_CH4": 0.05,
                "Total_CH4_timeseries": [
                    8.4697e-09,
                    1.7613e-08,
                    2.7441e-08,
                    3.7965e-08,
                    4.9197e-08,
                    6.115e-08,
                    7.3834e-08,
                    8.7262e-08,
                    1.0145e-07,
                    1.164e-07,
                    1.3242e-07,
                    1.4951e-07,
                    1.6806e-07,
                    1.8772e-07,
                    2.0849e-07,
                    2.3039e-07,
                    2.5343e-07,
                    2.7764e-07,
                    3.0301e-07,
                    3.2957e-07,
                    3.5673e-07,
                    3.845e-07,
                    4.1288e-07,
                    4.4191e-07,
                    4.7168e-07,
                    5.0217e-07,
                    5.3342e-07,
                    5.6543e-07,
                    5.9821e-07,
                    6.3178e-07,
                    6.659e-07,
                    7.0059e-07,
                    7.3552e-07,
                    7.7104e-07,
                    8.0718e-07,
                    8.4394e-07,
                    8.8134e-07,
                    9.194e-07,
                    9.5814e-07,
                    9.9758e-07,
                    1.0377e-06,
                    1.0786e-06,
                    1.1202e-06,
                    1.1626e-06,
                    1.2056e-06,
                    1.2494e-06,
                    1.2938e-06,
                    1.339e-06,
                    1.3849e-06,
                    1.4316e-06,
                    1.4808e-06,
                    1.5327e-06,
                    1.5872e-06,
                    1.6446e-06,
                    1.7048e-06,
                    1.7681e-06,
                    1.8344e-06,
                    1.904e-06,
                    1.9768e-06,
                    2.0531e-06,
                    2.1353e-06,
                    2.2238e-06,
                    2.3186e-06,
                    2.4198e-06,
                    2.5276e-06,
                    2.6421e-06,
                    2.7635e-06,
                    2.8917e-06,
                    3.0268e-06,
                    3.169e-06,
                    3.3166e-06,
                    3.4695e-06,
                    3.628e-06,
                    3.7921e-06,
                    3.9618e-06,
                    4.1371e-06,
                    4.3179e-06,
                    4.5043e-06,
                    4.6962e-06,
                    4.8936e-06,
                    5.0953e-06,
                    5.3013e-06,
                    5.5115e-06,
                    5.7257e-06,
                    5.9441e-06,
                    6.1664e-06,
                    6.3927e-06,
                    6.6223e-06,
                    6.8556e-06,
                    7.0927e-06,
                    7.3353e-06,
                    7.5833e-06,
                    7.8365e-06,
                    8.095e-06,
                    8.3599e-06,
                    8.6311e-06,
                    8.909e-06,
                    9.1935e-06,
                    9.4848e-06,
                    9.7831e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_CH4": 0.02,
                "Fossil_CH4_timeseries": [
                    8.4697e-09,
                    1.7613e-08,
                    2.7441e-08,
                    3.7965e-08,
                    4.9197e-08,
                    6.115e-08,
                    7.3834e-08,
                    8.7262e-08,
                    1.0145e-07,
                    1.164e-07,
                    1.3242e-07,
                    1.4951e-07,
                    1.6806e-07,
                    1.8772e-07,
                    2.0849e-07,
                    2.3039e-07,
                    2.5343e-07,
                    2.7764e-07,
                    3.0301e-07,
                    3.2957e-07,
                    3.5673e-07,
                    3.845e-07,
                    4.1288e-07,
                    4.4191e-07,
                    4.7168e-07,
                    5.0217e-07,
                    5.3342e-07,
                    5.6543e-07,
                    5.9821e-07,
                    6.3178e-07,
                    6.659e-07,
                    7.0059e-07,
                    7.3552e-07,
                    7.7104e-07,
                    8.0718e-07,
                    8.4394e-07,
                    8.8134e-07,
                    9.194e-07,
                    9.5814e-07,
                    9.9758e-07,
                    1.0377e-06,
                    1.0786e-06,
                    1.1202e-06,
                    1.1626e-06,
                    1.2056e-06,
                    1.2494e-06,
                    1.2938e-06,
                    1.339e-06,
                    1.3849e-06,
                    1.4316e-06,
                    1.4808e-06,
                    1.5327e-06,
                    1.5872e-06,
                    1.6446e-06,
                    1.7048e-06,
                    1.7681e-06,
                    1.8344e-06,
                    1.904e-06,
                    1.9768e-06,
                    2.0531e-06,
                    2.1353e-06,
                    2.2238e-06,
                    2.3186e-06,
                    2.4198e-06,
                    2.5276e-06,
                    2.6421e-06,
                    2.7635e-06,
                    2.8917e-06,
                    3.0268e-06,
                    3.169e-06,
                    3.3166e-06,
                    3.4695e-06,
                    3.628e-06,
                    3.7921e-06,
                    3.9618e-06,
                    4.1371e-06,
                    4.3179e-06,
                    4.5043e-06,
                    4.6962e-06,
                    4.8936e-06,
                    5.0953e-06,
                    5.3013e-06,
                    5.5115e-06,
                    5.7257e-06,
                    5.9441e-06,
                    6.1664e-06,
                    6.3927e-06,
                    6.6223e-06,
                    6.8556e-06,
                    7.0927e-06,
                    7.3353e-06,
                    7.5833e-06,
                    7.8365e-06,
                    8.095e-06,
                    8.3599e-06,
                    8.6311e-06,
                    8.909e-06,
                    9.1935e-06,
                    9.4848e-06,
                    9.7831e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CH4": 0.09,
                "Land_CH4_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    4.0779e-06,
                    8.1871e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_N2O": 0.06,
                "Total_N2O_timeseries": [
                    2.7927e-08,
                    5.6384e-08,
                    8.5349e-08,
                    1.1479e-07,
                    1.4467e-07,
                    1.7495e-07,
                    2.0557e-07,
                    2.3646e-07,
                    2.6756e-07,
                    2.9878e-07,
                    3.3008e-07,
                    3.6145e-07,
                    3.9287e-07,
                    4.2434e-07,
                    4.5585e-07,
                    4.8741e-07,
                    5.1901e-07,
                    5.5068e-07,
                    5.8241e-07,
                    6.1422e-07,
                    6.4654e-07,
                    6.8008e-07,
                    7.1542e-07,
                    7.5293e-07,
                    7.9284e-07,
                    8.3521e-07,
                    8.7991e-07,
                    9.2667e-07,
                    9.7503e-07,
                    1.0244e-06,
                    1.0743e-06,
                    1.1247e-06,
                    1.1755e-06,
                    1.2267e-06,
                    1.2782e-06,
                    1.33e-06,
                    1.3821e-06,
                    1.4345e-06,
                    1.4873e-06,
                    1.5427e-06,
                    1.5986e-06,
                    1.6551e-06,
                    1.7121e-06,
                    1.7698e-06,
                    1.828e-06,
                    1.887e-06,
                    1.9465e-06,
                    2.0068e-06,
                    2.0678e-06,
                    2.1295e-06,
                    2.1919e-06,
                    2.255e-06,
                    2.3188e-06,
                    2.3834e-06,
                    2.4486e-06,
                    2.5148e-06,
                    2.5818e-06,
                    2.6498e-06,
                    2.7189e-06,
                    2.7893e-06,
                    2.8616e-06,
                    2.9366e-06,
                    3.015e-06,
                    3.0975e-06,
                    3.1844e-06,
                    3.276e-06,
                    3.3725e-06,
                    3.4737e-06,
                    3.5794e-06,
                    3.6893e-06,
                    3.8035e-06,
                    3.9225e-06,
                    4.0466e-06,
                    4.1758e-06,
                    4.3101e-06,
                    4.449e-06,
                    4.5919e-06,
                    4.7381e-06,
                    4.8865e-06,
                    5.0357e-06,
                    5.1846e-06,
                    5.3322e-06,
                    5.4776e-06,
                    5.6205e-06,
                    5.7605e-06,
                    5.8978e-06,
                    6.0325e-06,
                    6.1652e-06,
                    6.2965e-06,
                    6.4276e-06,
                    6.5714e-06,
                    6.7493e-06,
                    6.9773e-06,
                    7.2663e-06,
                    7.6217e-06,
                    8.0438e-06,
                    8.5272e-06,
                    9.0618e-06,
                    9.6318e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_N2O": 0.01,
                "Fossil_N2O_timeseries": [
                    3.5329e-09,
                    7.1073e-09,
                    1.0723e-08,
                    1.4378e-08,
                    1.8073e-08,
                    2.1806e-08,
                    2.5576e-08,
                    2.938e-08,
                    3.3218e-08,
                    3.7087e-08,
                    4.0985e-08,
                    4.4913e-08,
                    4.8871e-08,
                    5.2857e-08,
                    5.6872e-08,
                    6.0916e-08,
                    6.4989e-08,
                    6.9091e-08,
                    7.3223e-08,
                    7.7385e-08,
                    8.1588e-08,
                    8.585e-08,
                    9.0187e-08,
                    9.4609e-08,
                    9.9121e-08,
                    1.0372e-07,
                    1.0842e-07,
                    1.1319e-07,
                    1.1803e-07,
                    1.2293e-07,
                    1.2787e-07,
                    1.3285e-07,
                    1.3787e-07,
                    1.4292e-07,
                    1.4801e-07,
                    1.5314e-07,
                    1.583e-07,
                    1.635e-07,
                    1.6874e-07,
                    1.7408e-07,
                    1.7947e-07,
                    1.8492e-07,
                    1.9043e-07,
                    1.9599e-07,
                    2.0162e-07,
                    2.073e-07,
                    2.1306e-07,
                    2.1888e-07,
                    2.2476e-07,
                    2.3072e-07,
                    2.3675e-07,
                    2.4286e-07,
                    2.4906e-07,
                    2.5535e-07,
                    2.6174e-07,
                    2.6821e-07,
                    2.7478e-07,
                    2.8143e-07,
                    2.8817e-07,
                    2.9498e-07,
                    3.0186e-07,
                    3.088e-07,
                    3.1581e-07,
                    3.2288e-07,
                    3.3002e-07,
                    3.3721e-07,
                    3.4447e-07,
                    3.5179e-07,
                    3.5917e-07,
                    3.6661e-07,
                    3.7412e-07,
                    3.817e-07,
                    3.8934e-07,
                    3.9704e-07,
                    4.0481e-07,
                    4.1265e-07,
                    4.2056e-07,
                    4.2853e-07,
                    4.3658e-07,
                    4.447e-07,
                    4.529e-07,
                    4.612e-07,
                    4.696e-07,
                    4.7811e-07,
                    4.8673e-07,
                    4.9548e-07,
                    5.0437e-07,
                    5.1338e-07,
                    5.2253e-07,
                    5.3183e-07,
                    5.4129e-07,
                    5.5098e-07,
                    5.6094e-07,
                    5.712e-07,
                    5.8177e-07,
                    5.9269e-07,
                    6.0393e-07,
                    6.1551e-07,
                    6.2739e-07,
                    6.3954e-07,
                    6.5197e-07,
                    6.6468e-07,
                    6.7769e-07,
                    6.9101e-07,
                    7.0463e-07,
                    7.1857e-07,
                    7.328e-07,
                    7.4733e-07,
                    7.6213e-07,
                    7.7717e-07,
                    7.9246e-07,
                    8.0801e-07,
                    8.2383e-07,
                    8.3992e-07,
                    8.5631e-07,
                    8.7301e-07,
                    8.9003e-07,
                    9.0738e-07,
                    9.2509e-07,
                    9.439e-07,
                    9.6285e-07,
                    9.823e-07,
                    1.0021e-06,
                    1.0224e-06,
                    1.0428e-06,
                    1.0632e-06,
                    1.0838e-06,
                    1.1049e-06,
                    1.1274e-06,
                    1.1508e-06,
                    1.1744e-06,
                    1.1985e-06,
                    1.2236e-06,
                    1.2485e-06,
                    1.2739e-06,
                    1.2998e-06,
                    1.3265e-06,
                    1.3543e-06,
                    1.3826e-06,
                    1.4114e-06,
                    1.4417e-06,
                    1.4738e-06,
                    1.5068e-06,
                    1.5578e-06,
                    1.6108e-06,
                    1.6656e-06,
                    1.7213e-06,
                    1.7589e-06,
                    1.7977e-06,
                    1.8423e-06,
                    1.8902e-06,
                    1.9393e-06,
                    1.9901e-06,
                    2.0308e-06,
                    2.0721e-06,
                    2.1139e-06,
                    2.1567e-06,
                    2.2e-06,
                    2.2447e-06,
                    2.2909e-06,
                    2.3395e-06,
                    2.3893e-06,
                    2.4399e-06,
                    2.4916e-06,
                    2.5447e-06,
                    2.5995e-06,
                    2.6559e-06,
                    2.714e-06,
                    2.7725e-06,
                    2.832e-06,
                    2.8927e-06,
                    2.9539e-06
                ],
                "Land_N2O": 0.08,
                "Land_N2O_timeseries": [
                    2.4395e-08,
                    4.9277e-08,
                    7.4626e-08,
                    1.0041e-07,
                    1.266e-07,
                    1.5315e-07,
                    1.7999e-07,
                    2.0708e-07,
                    2.3434e-07,
                    2.617e-07,
                    2.891e-07,
                    3.1654e-07,
                    3.44e-07,
                    3.7148e-07,
                    3.9898e-07,
                    4.2649e-07,
                    4.5403e-07,
                    4.8159e-07,
                    5.0919e-07,
                    5.3683e-07,
                    5.6495e-07,
                    5.9423e-07,
                    6.2523e-07,
                    6.5832e-07,
                    6.9372e-07,
                    7.3148e-07,
                    7.7149e-07,
                    8.1348e-07,
                    8.5699e-07,
                    9.0144e-07,
                    9.4642e-07,
                    9.9184e-07,
                    1.0376e-06,
                    1.0837e-06,
                    1.1301e-06,
                    1.1768e-06,
                    1.2238e-06,
                    1.271e-06,
                    1.3185e-06,
                    1.3686e-06,
                    1.4191e-06,
                    1.4701e-06,
                    1.5217e-06,
                    1.5738e-06,
                    1.6264e-06,
                    1.6797e-06,
                    1.7335e-06,
                    1.7879e-06,
                    1.843e-06,
                    1.8988e-06,
                    1.9552e-06,
                    2.0122e-06,
                    2.0698e-06,
                    2.128e-06,
                    2.1869e-06,
                    2.2465e-06,
                    2.307e-06,
                    2.3684e-06,
                    2.4308e-06,
                    2.4944e-06,
                    2.5597e-06,
                    2.6278e-06,
                    2.6992e-06,
                    2.7746e-06,
                    2.8544e-06,
                    2.9388e-06,
                    3.028e-06,
                    3.1219e-06,
                    3.2202e-06,
                    3.3227e-06,
                    3.4294e-06,
                    3.5408e-06,
                    3.6572e-06,
                    3.7788e-06,
                    3.9053e-06,
                    4.0364e-06,
                    4.1714e-06,
                    4.3096e-06,
                    4.4499e-06,
                    4.591e-06,
                    4.7317e-06,
                    4.871e-06,
                    5.008e-06,
                    5.1424e-06,
                    5.2738e-06,
                    5.4023e-06,
                    5.5281e-06,
                    5.6518e-06,
                    5.774e-06,
                    5.8958e-06,
                    6.0301e-06,
                    6.1983e-06,
                    6.4164e-06,
                    6.6951e-06,
                    7.04e-06,
                    7.4511e-06,
                    7.9233e-06,
                    8.4463e-06,
                    9.0044e-06,
                    9.5765e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                43.12605,
                                12.71006
                            ],
                            [
                                43.08089,
                                12.81966
                            ],
                            [
                                42.99481,
                                12.88637
                            ],
                            [
                                42.98255,
                                12.81863
                            ],
                            [
                                42.88954,
                                12.80743
                            ],
                            [
                                42.8379,
                                12.85923
                            ],
                            [
                                42.79607,
                                12.84244
                            ],
                            [
                                42.73279,
                                12.96543
                            ],
                            [
                                42.74725,
                                13.01566
                            ],
                            [
                                42.67271,
                                13.05685
                            ],
                            [
                                42.63734,
                                13.11469
                            ],
                            [
                                42.5319,
                                13.22251
                            ],
                            [
                                42.49289,
                                13.18461
                            ],
                            [
                                42.39793,
                                13.20407
                            ],
                            [
                                42.35312,
                                13.41073
                            ],
                            [
                                42.30846,
                                13.47843
                            ],
                            [
                                42.29236,
                                13.5579
                            ],
                            [
                                42.25162,
                                13.60102
                            ],
                            [
                                42.18732,
                                13.60294
                            ],
                            [
                                42.10748,
                                13.64292
                            ],
                            [
                                42.07671,
                                13.71604
                            ],
                            [
                                42.00065,
                                13.818
                            ],
                            [
                                41.91681,
                                13.87066
                            ],
                            [
                                41.86312,
                                13.86546
                            ],
                            [
                                41.80766,
                                13.92278
                            ],
                            [
                                41.69188,
                                13.93558
                            ],
                            [
                                41.64942,
                                14.03039
                            ],
                            [
                                41.54779,
                                14.13513
                            ],
                            [
                                41.49132,
                                14.23966
                            ],
                            [
                                41.42229,
                                14.3018
                            ],
                            [
                                41.39077,
                                14.36829
                            ],
                            [
                                41.34081,
                                14.41201
                            ],
                            [
                                41.30935,
                                14.495
                            ],
                            [
                                41.22102,
                                14.56491
                            ],
                            [
                                41.18486,
                                14.62316
                            ],
                            [
                                41.03065,
                                14.66993
                            ],
                            [
                                40.98524,
                                14.66601
                            ],
                            [
                                40.89535,
                                14.72436
                            ],
                            [
                                40.7814,
                                14.70824
                            ],
                            [
                                40.73035,
                                14.76513
                            ],
                            [
                                40.7467,
                                14.80899
                            ],
                            [
                                40.6395,
                                14.93019
                            ],
                            [
                                40.45,
                                14.97556
                            ],
                            [
                                40.29542,
                                14.90756
                            ],
                            [
                                40.16857,
                                14.98229
                            ],
                            [
                                40.14151,
                                15.05085
                            ],
                            [
                                40.02699,
                                15.24219
                            ],
                            [
                                40.07989,
                                15.30484
                            ],
                            [
                                40.0572,
                                15.35949
                            ],
                            [
                                39.90105,
                                15.46554
                            ],
                            [
                                39.88038,
                                15.49842
                            ],
                            [
                                39.8088,
                                15.44497
                            ],
                            [
                                39.77851,
                                15.39451
                            ],
                            [
                                39.78587,
                                15.26797
                            ],
                            [
                                39.82035,
                                15.26907
                            ],
                            [
                                39.84992,
                                15.16433
                            ],
                            [
                                39.8099,
                                15.07323
                            ],
                            [
                                39.77133,
                                15.06365
                            ],
                            [
                                39.69642,
                                15.12985
                            ],
                            [
                                39.71275,
                                15.25835
                            ],
                            [
                                39.66029,
                                15.3362
                            ],
                            [
                                39.63448,
                                15.443
                            ],
                            [
                                39.5952,
                                15.52066
                            ],
                            [
                                39.46463,
                                15.5289
                            ],
                            [
                                39.44371,
                                15.59479
                            ],
                            [
                                39.47635,
                                15.64704
                            ],
                            [
                                39.42721,
                                15.74666
                            ],
                            [
                                39.42846,
                                15.81045
                            ],
                            [
                                39.30772,
                                15.89994
                            ],
                            [
                                39.24119,
                                16.07732
                            ],
                            [
                                39.1978,
                                16.29525
                            ],
                            [
                                39.19216,
                                16.43398
                            ],
                            [
                                39.15127,
                                16.51947
                            ],
                            [
                                39.14718,
                                16.68784
                            ],
                            [
                                39.06496,
                                16.89465
                            ],
                            [
                                39.04104,
                                17.00149
                            ],
                            [
                                38.97047,
                                17.22099
                            ],
                            [
                                38.93671,
                                17.37567
                            ],
                            [
                                38.82033,
                                17.61527
                            ],
                            [
                                38.60646,
                                17.92862
                            ],
                            [
                                38.56955,
                                18.00504
                            ],
                            [
                                38.45238,
                                17.89829
                            ],
                            [
                                38.34152,
                                17.64959
                            ],
                            [
                                38.28066,
                                17.62563
                            ],
                            [
                                38.26005,
                                17.5586
                            ],
                            [
                                38.1661,
                                17.57298
                            ],
                            [
                                38.00386,
                                17.55702
                            ],
                            [
                                37.97687,
                                17.49115
                            ],
                            [
                                37.87187,
                                17.45273
                            ],
                            [
                                37.83938,
                                17.49881
                            ],
                            [
                                37.78855,
                                17.49602
                            ],
                            [
                                37.76412,
                                17.38418
                            ],
                            [
                                37.61442,
                                17.37444
                            ],
                            [
                                37.51667,
                                17.33716
                            ],
                            [
                                37.48537,
                                17.18844
                            ],
                            [
                                37.39424,
                                17.04821
                            ],
                            [
                                37.31271,
                                17.09389
                            ],
                            [
                                37.13105,
                                17.05755
                            ],
                            [
                                37.03256,
                                17.10017
                            ],
                            [
                                36.98374,
                                16.97294
                            ],
                            [
                                37.00466,
                                16.93612
                            ],
                            [
                                36.99132,
                                16.72873
                            ],
                            [
                                36.90223,
                                16.67505
                            ],
                            [
                                36.88792,
                                16.54868
                            ],
                            [
                                36.89906,
                                16.4994
                            ],
                            [
                                36.96496,
                                16.42938
                            ],
                            [
                                36.93405,
                                16.35032
                            ],
                            [
                                36.95597,
                                16.27918
                            ],
                            [
                                36.8928,
                                16.21393
                            ],
                            [
                                36.81546,
                                15.95598
                            ],
                            [
                                36.76844,
                                15.83155
                            ],
                            [
                                36.6997,
                                15.71252
                            ],
                            [
                                36.61337,
                                15.41353
                            ],
                            [
                                36.54779,
                                15.23869
                            ],
                            [
                                36.4782,
                                15.20369
                            ],
                            [
                                36.43937,
                                15.15644
                            ],
                            [
                                36.46828,
                                14.94534
                            ],
                            [
                                36.51018,
                                14.46501
                            ],
                            [
                                36.52633,
                                14.33341
                            ],
                            [
                                36.56034,
                                14.25771
                            ],
                            [
                                36.62873,
                                14.3152
                            ],
                            [
                                36.69239,
                                14.30122
                            ],
                            [
                                36.743,
                                14.32245
                            ],
                            [
                                36.89589,
                                14.31597
                            ],
                            [
                                36.9707,
                                14.29228
                            ],
                            [
                                37.01307,
                                14.25357
                            ],
                            [
                                37.09231,
                                14.27291
                            ],
                            [
                                37.13492,
                                14.40706
                            ],
                            [
                                37.23002,
                                14.44375
                            ],
                            [
                                37.30815,
                                14.44687
                            ],
                            [
                                37.38929,
                                14.36508
                            ],
                            [
                                37.3976,
                                14.29796
                            ],
                            [
                                37.46842,
                                14.25231
                            ],
                            [
                                37.52714,
                                14.18682
                            ],
                            [
                                37.90632,
                                14.88232
                            ],
                            [
                                37.94241,
                                14.86219
                            ],
                            [
                                38.0446,
                                14.72053
                            ],
                            [
                                38.14502,
                                14.67899
                            ],
                            [
                                38.23599,
                                14.68946
                            ],
                            [
                                38.27181,
                                14.61961
                            ],
                            [
                                38.37059,
                                14.49007
                            ],
                            [
                                38.42252,
                                14.46721
                            ],
                            [
                                38.45657,
                                14.41508
                            ],
                            [
                                38.52092,
                                14.41155
                            ],
                            [
                                38.70439,
                                14.46875
                            ],
                            [
                                38.79945,
                                14.46979
                            ],
                            [
                                38.97866,
                                14.54822
                            ],
                            [
                                39.0308,
                                14.63577
                            ],
                            [
                                39.15338,
                                14.65139
                            ],
                            [
                                39.16246,
                                14.60432
                            ],
                            [
                                39.23827,
                                14.56045
                            ],
                            [
                                39.26309,
                                14.48447
                            ],
                            [
                                39.35733,
                                14.48699
                            ],
                            [
                                39.3603,
                                14.52517
                            ],
                            [
                                39.48885,
                                14.50175
                            ],
                            [
                                39.5368,
                                14.58373
                            ],
                            [
                                39.58686,
                                14.60408
                            ],
                            [
                                39.68318,
                                14.5914
                            ],
                            [
                                39.76804,
                                14.54494
                            ],
                            [
                                39.93222,
                                14.41657
                            ],
                            [
                                40.04201,
                                14.49252
                            ],
                            [
                                40.07073,
                                14.53951
                            ],
                            [
                                40.14939,
                                14.53452
                            ],
                            [
                                40.21331,
                                14.38911
                            ],
                            [
                                40.26218,
                                14.40972
                            ],
                            [
                                40.45198,
                                14.30754
                            ],
                            [
                                40.57328,
                                14.26893
                            ],
                            [
                                40.80865,
                                14.17244
                            ],
                            [
                                40.94195,
                                14.08181
                            ],
                            [
                                41.11581,
                                13.8278
                            ],
                            [
                                41.16996,
                                13.7289
                            ],
                            [
                                41.30725,
                                13.57968
                            ],
                            [
                                41.4017,
                                13.50252
                            ],
                            [
                                41.64366,
                                13.38556
                            ],
                            [
                                41.66728,
                                13.32391
                            ],
                            [
                                41.73566,
                                13.23658
                            ],
                            [
                                41.89106,
                                13.07342
                            ],
                            [
                                41.96631,
                                12.92464
                            ],
                            [
                                42.02702,
                                12.86745
                            ],
                            [
                                42.0564,
                                12.80129
                            ],
                            [
                                42.21838,
                                12.76485
                            ],
                            [
                                42.27874,
                                12.6353
                            ],
                            [
                                42.40428,
                                12.46864
                            ],
                            [
                                42.46372,
                                12.52244
                            ],
                            [
                                42.53994,
                                12.49317
                            ],
                            [
                                42.69896,
                                12.35605
                            ],
                            [
                                42.82374,
                                12.43315
                            ],
                            [
                                42.8025,
                                12.50812
                            ],
                            [
                                42.85915,
                                12.55265
                            ],
                            [
                                42.88463,
                                12.61712
                            ],
                            [
                                43.12605,
                                12.71006
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                40.21829,
                                15.61897
                            ],
                            [
                                40.15649,
                                15.64831
                            ],
                            [
                                40.13612,
                                15.72254
                            ],
                            [
                                40.14398,
                                15.80379
                            ],
                            [
                                40.03399,
                                15.86526
                            ],
                            [
                                39.95728,
                                15.72312
                            ],
                            [
                                40.01555,
                                15.72997
                            ],
                            [
                                40.07751,
                                15.66644
                            ],
                            [
                                39.98348,
                                15.60711
                            ],
                            [
                                40.06241,
                                15.57793
                            ],
                            [
                                40.1263,
                                15.59948
                            ],
                            [
                                40.22348,
                                15.59236
                            ],
                            [
                                40.31358,
                                15.5624
                            ],
                            [
                                40.42313,
                                15.56427
                            ],
                            [
                                40.41219,
                                15.62923
                            ],
                            [
                                40.34113,
                                15.64702
                            ],
                            [
                                40.32416,
                                15.68638
                            ],
                            [
                                40.25693,
                                15.69801
                            ],
                            [
                                40.21829,
                                15.61897
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                40.26534,
                                14.98756
                            ],
                            [
                                40.3508,
                                15.01206
                            ],
                            [
                                40.29553,
                                15.05681
                            ],
                            [
                                40.26534,
                                14.98756
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "EST",
                "Country": "Estonia",
                "Total_3GHG": 0.07,
                "Total_3GHG_timeseries": [
                    4.1271e-06,
                    8.2085e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011
                ],
                "Fossil_3GHG": 0.08,
                "Fossil_3GHG_timeseries": [
                    3.705e-08,
                    7.4627e-08,
                    1.1272e-07,
                    1.5136e-07,
                    1.9271e-07,
                    2.3241e-07,
                    2.7265e-07,
                    3.1647e-07,
                    3.6099e-07,
                    4.0704e-07,
                    4.5449e-07,
                    5.0165e-07,
                    5.4926e-07,
                    5.978e-07,
                    6.464e-07,
                    7.0708e-07,
                    7.706e-07,
                    8.3072e-07,
                    8.9667e-07,
                    9.6429e-07,
                    1.0402e-06,
                    1.1174e-06,
                    1.1929e-06,
                    1.2754e-06,
                    1.3633e-06,
                    1.4623e-06,
                    1.5624e-06,
                    1.6787e-06,
                    1.7969e-06,
                    1.9276e-06,
                    2.0623e-06,
                    2.2018e-06,
                    2.3542e-06,
                    2.5063e-06,
                    2.6668e-06,
                    2.8267e-06,
                    2.9906e-06,
                    3.1602e-06,
                    3.3389e-06,
                    3.5338e-06,
                    3.7433e-06,
                    3.9619e-06,
                    4.2101e-06,
                    4.4618e-06,
                    4.739e-06,
                    5.0183e-06,
                    5.3346e-06,
                    5.6803e-06,
                    6.0775e-06,
                    6.5184e-06,
                    6.9658e-06,
                    7.3988e-06,
                    7.823e-06,
                    8.2941e-06,
                    8.7225e-06,
                    9.2057e-06,
                    9.7445e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009
                ],
                "Land_3GHG": 0.05,
                "Land_3GHG_timeseries": [
                    4.0901e-06,
                    8.1339e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Total_CO2": 0.08,
                "Total_CO2_timeseries": [
                    3.7633e-06,
                    7.4768e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009
                ],
                "Fossil_CO2": 0.1,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    1.568e-09,
                    1.568e-09,
                    1.568e-09,
                    3.7697e-09,
                    6.1046e-09,
                    9.1903e-09,
                    1.311e-08,
                    1.6646e-08,
                    2.0348e-08,
                    2.4501e-08,
                    2.8471e-08,
                    4.1014e-08,
                    5.5408e-08,
                    6.7383e-08,
                    8.3629e-08,
                    1.0126e-07,
                    1.2506e-07,
                    1.4949e-07,
                    1.7243e-07,
                    2.0027e-07,
                    2.3231e-07,
                    2.7209e-07,
                    3.1268e-07,
                    3.6574e-07,
                    4.2018e-07,
                    4.8404e-07,
                    5.5131e-07,
                    6.2216e-07,
                    7.0281e-07,
                    7.8469e-07,
                    8.7387e-07,
                    9.6534e-07,
                    1.0621e-06,
                    1.1631e-06,
                    1.2721e-06,
                    1.3956e-06,
                    1.5315e-06,
                    1.6755e-06,
                    1.8441e-06,
                    2.0159e-06,
                    2.2133e-06,
                    2.4143e-06,
                    2.6466e-06,
                    2.9072e-06,
                    3.2095e-06,
                    3.5519e-06,
                    3.9035e-06,
                    4.243e-06,
                    4.5752e-06,
                    4.9447e-06,
                    5.2746e-06,
                    5.6508e-06,
                    6.0723e-06,
                    6.4963e-06,
                    6.9439e-06,
                    7.3828e-06,
                    7.838e-06,
                    8.3535e-06,
                    8.9135e-06,
                    9.419e-06,
                    9.8829e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Land_CO2": 0.04,
                "Land_CO2_timeseries": [
                    3.7633e-06,
                    7.4768e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Total_CH4": 0.03,
                "Total_CH4_timeseries": [
                    2.4646e-07,
                    4.9467e-07,
                    7.446e-07,
                    9.9631e-07,
                    1.2504e-06,
                    1.5056e-06,
                    1.7626e-06,
                    2.0221e-06,
                    2.2835e-06,
                    2.5469e-06,
                    2.8093e-06,
                    3.0703e-06,
                    3.33e-06,
                    3.5887e-06,
                    3.8461e-06,
                    4.1055e-06,
                    4.3644e-06,
                    4.6207e-06,
                    4.8771e-06,
                    5.1322e-06,
                    5.3877e-06,
                    5.642e-06,
                    5.8944e-06,
                    6.147e-06,
                    6.399e-06,
                    6.6525e-06,
                    6.9046e-06,
                    7.1585e-06,
                    7.4111e-06,
                    7.665e-06,
                    7.9203e-06,
                    8.1775e-06,
                    8.4384e-06,
                    8.6986e-06,
                    8.9605e-06,
                    9.2203e-06,
                    9.4795e-06,
                    9.7408e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_CH4": 0.04,
                "Fossil_CH4_timeseries": [
                    2.8228e-08,
                    5.6886e-08,
                    8.5959e-08,
                    1.1549e-07,
                    1.4607e-07,
                    1.7647e-07,
                    2.0732e-07,
                    2.3946e-07,
                    2.7209e-07,
                    3.0542e-07,
                    3.3923e-07,
                    3.7304e-07,
                    4.0708e-07,
                    4.4151e-07,
                    4.7611e-07,
                    5.1414e-07,
                    5.5307e-07,
                    5.9095e-07,
                    6.3031e-07,
                    6.6987e-07,
                    7.1146e-07,
                    7.5358e-07,
                    7.9536e-07,
                    8.3907e-07,
                    8.8377e-07,
                    9.3166e-07,
                    9.7974e-07,
                    1.0313e-06,
                    1.0833e-06,
                    1.1382e-06,
                    1.1936e-06,
                    1.2502e-06,
                    1.3097e-06,
                    1.3677e-06,
                    1.4266e-06,
                    1.4826e-06,
                    1.5372e-06,
                    1.5932e-06,
                    1.6501e-06,
                    1.7087e-06,
                    1.7692e-06,
                    1.8309e-06,
                    1.8971e-06,
                    1.9637e-06,
                    2.0301e-06,
                    2.0949e-06,
                    2.1652e-06,
                    2.2365e-06,
                    2.3174e-06,
                    2.4018e-06,
                    2.4835e-06,
                    2.5626e-06,
                    2.6401e-06,
                    2.727e-06,
                    2.8107e-06,
                    2.9028e-06,
                    3.005e-06,
                    3.1074e-06,
                    3.2115e-06,
                    3.3106e-06,
                    3.4139e-06,
                    3.5322e-06,
                    3.6606e-06,
                    3.775e-06,
                    3.8771e-06,
                    3.9958e-06,
                    4.1163e-06,
                    4.1946e-06,
                    4.2703e-06,
                    4.3561e-06,
                    4.4671e-06,
                    4.6071e-06,
                    4.7498e-06,
                    4.8946e-06,
                    5.0401e-06,
                    5.202e-06,
                    5.3721e-06,
                    5.5537e-06,
                    5.7349e-06,
                    5.9381e-06,
                    6.155e-06,
                    6.3851e-06,
                    6.6274e-06,
                    6.9232e-06,
                    7.2626e-06,
                    7.6251e-06,
                    7.9826e-06,
                    8.3885e-06,
                    8.7897e-06,
                    9.2341e-06,
                    9.6018e-06,
                    9.8187e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CH4": 0.02,
                "Land_CH4_timeseries": [
                    2.1823e-07,
                    4.3778e-07,
                    6.5864e-07,
                    8.8082e-07,
                    1.1043e-06,
                    1.3291e-06,
                    1.5552e-06,
                    1.7827e-06,
                    2.0114e-06,
                    2.2415e-06,
                    2.4701e-06,
                    2.6973e-06,
                    2.923e-06,
                    3.1472e-06,
                    3.37e-06,
                    3.5914e-06,
                    3.8113e-06,
                    4.0297e-06,
                    4.2467e-06,
                    4.4623e-06,
                    4.6762e-06,
                    4.8884e-06,
                    5.099e-06,
                    5.308e-06,
                    5.5152e-06,
                    5.7209e-06,
                    5.9248e-06,
                    6.1272e-06,
                    6.3278e-06,
                    6.5269e-06,
                    6.7267e-06,
                    6.9273e-06,
                    7.1287e-06,
                    7.3309e-06,
                    7.5339e-06,
                    7.7377e-06,
                    7.9422e-06,
                    8.1476e-06,
                    8.3538e-06,
                    8.5608e-06,
                    8.7686e-06,
                    8.9772e-06,
                    9.1867e-06,
                    9.397e-06,
                    9.6081e-06,
                    9.82e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_N2O": 0.11,
                "Total_N2O_timeseries": [
                    1.174e-07,
                    2.3707e-07,
                    3.5891e-07,
                    4.828e-07,
                    6.0857e-07,
                    7.3601e-07,
                    8.6489e-07,
                    9.9493e-07,
                    1.1258e-06,
                    1.2572e-06,
                    1.3889e-06,
                    1.5208e-06,
                    1.6529e-06,
                    1.7852e-06,
                    1.9176e-06,
                    2.0502e-06,
                    2.1829e-06,
                    2.3159e-06,
                    2.4491e-06,
                    2.5826e-06,
                    2.7182e-06,
                    2.8592e-06,
                    3.008e-06,
                    3.1662e-06,
                    3.3349e-06,
                    3.5143e-06,
                    3.7039e-06,
                    3.9024e-06,
                    4.1078e-06,
                    4.3176e-06,
                    4.5298e-06,
                    4.744e-06,
                    4.96e-06,
                    5.1775e-06,
                    5.3964e-06,
                    5.6166e-06,
                    5.8381e-06,
                    6.0609e-06,
                    6.2853e-06,
                    6.5146e-06,
                    6.7474e-06,
                    6.9837e-06,
                    7.2235e-06,
                    7.4663e-06,
                    7.7122e-06,
                    7.9606e-06,
                    8.2113e-06,
                    8.4638e-06,
                    8.7178e-06,
                    8.9726e-06,
                    9.228e-06,
                    9.4838e-06,
                    9.74e-06,
                    9.9965e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_N2O": 0.03,
                "Fossil_N2O_timeseries": [
                    8.8219e-09,
                    1.7741e-08,
                    2.6758e-08,
                    3.5869e-08,
                    4.5075e-08,
                    5.4373e-08,
                    6.3761e-08,
                    7.3236e-08,
                    8.2796e-08,
                    9.2436e-08,
                    1.0216e-07,
                    1.1196e-07,
                    1.2183e-07,
                    1.3179e-07,
                    1.4182e-07,
                    1.5193e-07,
                    1.6212e-07,
                    1.7239e-07,
                    1.8274e-07,
                    1.9316e-07,
                    2.0368e-07,
                    2.1433e-07,
                    2.2513e-07,
                    2.3609e-07,
                    2.4723e-07,
                    2.5854e-07,
                    2.7002e-07,
                    2.8166e-07,
                    2.9344e-07,
                    3.0534e-07,
                    3.1734e-07,
                    3.2943e-07,
                    3.4162e-07,
                    3.539e-07,
                    3.6627e-07,
                    3.7872e-07,
                    3.9126e-07,
                    4.039e-07,
                    4.1662e-07,
                    4.295e-07,
                    4.4249e-07,
                    4.5559e-07,
                    4.6881e-07,
                    4.8213e-07,
                    4.9558e-07,
                    5.0915e-07,
                    5.2283e-07,
                    5.3664e-07,
                    5.5058e-07,
                    5.6465e-07,
                    5.7885e-07,
                    5.9319e-07,
                    6.0769e-07,
                    6.2234e-07,
                    6.3715e-07,
                    6.5212e-07,
                    6.6725e-07,
                    6.8254e-07,
                    6.9798e-07,
                    7.1357e-07,
                    7.2929e-07,
                    7.4515e-07,
                    7.6114e-07,
                    7.7726e-07,
                    7.9351e-07,
                    8.099e-07,
                    8.2641e-07,
                    8.4306e-07,
                    8.5986e-07,
                    8.7682e-07,
                    8.9396e-07,
                    9.1134e-07,
                    9.2902e-07,
                    9.4704e-07,
                    9.6544e-07,
                    9.8426e-07,
                    1.0035e-06,
                    1.0233e-06,
                    1.0435e-06,
                    1.0642e-06,
                    1.0855e-06,
                    1.1076e-06,
                    1.1306e-06,
                    1.1546e-06,
                    1.1796e-06,
                    1.2057e-06,
                    1.2329e-06,
                    1.2612e-06,
                    1.2906e-06,
                    1.321e-06,
                    1.3523e-06,
                    1.3847e-06,
                    1.418e-06,
                    1.4525e-06,
                    1.488e-06,
                    1.5248e-06,
                    1.5627e-06,
                    1.6019e-06,
                    1.6424e-06,
                    1.6842e-06,
                    1.7276e-06,
                    1.7733e-06,
                    1.8214e-06,
                    1.8723e-06,
                    1.926e-06,
                    1.9823e-06,
                    2.0411e-06,
                    2.1019e-06,
                    2.1641e-06,
                    2.2272e-06,
                    2.2904e-06,
                    2.3535e-06,
                    2.4162e-06,
                    2.4786e-06,
                    2.5404e-06,
                    2.6016e-06,
                    2.6624e-06,
                    2.7229e-06,
                    2.7832e-06,
                    2.846e-06,
                    2.9096e-06,
                    2.9764e-06,
                    3.0468e-06,
                    3.1206e-06,
                    3.2029e-06,
                    3.288e-06,
                    3.3744e-06,
                    3.4642e-06,
                    3.5557e-06,
                    3.6503e-06,
                    3.7445e-06,
                    3.8392e-06,
                    3.9347e-06,
                    4.0309e-06,
                    4.1278e-06,
                    4.2272e-06,
                    4.3294e-06,
                    4.4323e-06,
                    4.5354e-06,
                    4.6461e-06,
                    4.7522e-06,
                    4.8361e-06,
                    4.9124e-06,
                    4.9882e-06,
                    5.0629e-06,
                    5.1461e-06,
                    5.2285e-06,
                    5.3083e-06,
                    5.3838e-06,
                    5.4599e-06,
                    5.5448e-06,
                    5.6319e-06,
                    5.7227e-06,
                    5.8116e-06,
                    5.9031e-06,
                    5.9887e-06,
                    6.0859e-06,
                    6.1779e-06,
                    6.2659e-06,
                    6.3638e-06,
                    6.4574e-06,
                    6.5493e-06,
                    6.6458e-06,
                    6.7389e-06,
                    6.8303e-06,
                    6.9221e-06,
                    7.0174e-06,
                    7.1143e-06,
                    7.2034e-06,
                    7.2909e-06,
                    7.3783e-06,
                    7.4607e-06
                ],
                "Land_N2O": 0.14,
                "Land_N2O_timeseries": [
                    1.0858e-07,
                    2.1933e-07,
                    3.3215e-07,
                    4.4693e-07,
                    5.6349e-07,
                    6.8163e-07,
                    8.0112e-07,
                    9.2169e-07,
                    1.043e-06,
                    1.1648e-06,
                    1.2867e-06,
                    1.4089e-06,
                    1.5311e-06,
                    1.6534e-06,
                    1.7758e-06,
                    1.8983e-06,
                    2.0208e-06,
                    2.1435e-06,
                    2.2663e-06,
                    2.3894e-06,
                    2.5145e-06,
                    2.6449e-06,
                    2.7828e-06,
                    2.9301e-06,
                    3.0877e-06,
                    3.2558e-06,
                    3.4338e-06,
                    3.6207e-06,
                    3.8144e-06,
                    4.0122e-06,
                    4.2124e-06,
                    4.4146e-06,
                    4.6184e-06,
                    4.8236e-06,
                    5.0302e-06,
                    5.2379e-06,
                    5.4468e-06,
                    5.657e-06,
                    5.8687e-06,
                    6.085e-06,
                    6.3049e-06,
                    6.5281e-06,
                    6.7547e-06,
                    6.9842e-06,
                    7.2166e-06,
                    7.4514e-06,
                    7.6885e-06,
                    7.9272e-06,
                    8.1672e-06,
                    8.4079e-06,
                    8.6491e-06,
                    8.8906e-06,
                    9.1323e-06,
                    9.3741e-06,
                    9.6162e-06,
                    9.8583e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                28.04192,
                                59.47012
                            ],
                            [
                                27.91546,
                                59.40214
                            ],
                            [
                                27.59417,
                                59.41456
                            ],
                            [
                                27.37599,
                                59.44645
                            ],
                            [
                                26.93598,
                                59.43862
                            ],
                            [
                                26.61448,
                                59.55115
                            ],
                            [
                                26.49205,
                                59.51743
                            ],
                            [
                                26.26638,
                                59.58546
                            ],
                            [
                                26.10431,
                                59.58611
                            ],
                            [
                                26.0501,
                                59.61768
                            ],
                            [
                                25.93749,
                                59.57834
                            ],
                            [
                                25.78179,
                                59.58943
                            ],
                            [
                                25.55307,
                                59.54638
                            ],
                            [
                                25.42444,
                                59.49019
                            ],
                            [
                                25.27345,
                                59.5115
                            ],
                            [
                                25.1497,
                                59.47699
                            ],
                            [
                                25.07801,
                                59.50234
                            ],
                            [
                                24.93094,
                                59.49566
                            ],
                            [
                                24.79051,
                                59.44402
                            ],
                            [
                                24.65394,
                                59.43048
                            ],
                            [
                                24.36354,
                                59.47147
                            ],
                            [
                                24.33847,
                                59.42413
                            ],
                            [
                                24.22348,
                                59.39376
                            ],
                            [
                                24.20394,
                                59.34095
                            ],
                            [
                                23.94767,
                                59.27076
                            ],
                            [
                                23.7864,
                                59.28364
                            ],
                            [
                                23.49137,
                                59.20782
                            ],
                            [
                                23.54054,
                                59.09249
                            ],
                            [
                                23.43539,
                                59.07608
                            ],
                            [
                                23.45757,
                                58.98284
                            ],
                            [
                                23.42502,
                                58.9062
                            ],
                            [
                                23.52661,
                                58.83
                            ],
                            [
                                23.46064,
                                58.77861
                            ],
                            [
                                23.65746,
                                58.74452
                            ],
                            [
                                23.49596,
                                58.68817
                            ],
                            [
                                23.56802,
                                58.56399
                            ],
                            [
                                23.69152,
                                58.50385
                            ],
                            [
                                23.67965,
                                58.44334
                            ],
                            [
                                23.74406,
                                58.36045
                            ],
                            [
                                23.87609,
                                58.32445
                            ],
                            [
                                24.01115,
                                58.31872
                            ],
                            [
                                24.12172,
                                58.24073
                            ],
                            [
                                24.26776,
                                58.2786
                            ],
                            [
                                24.29294,
                                58.36514
                            ],
                            [
                                24.45127,
                                58.38495
                            ],
                            [
                                24.54671,
                                58.35707
                            ],
                            [
                                24.58692,
                                58.30461
                            ],
                            [
                                24.48932,
                                58.25728
                            ],
                            [
                                24.45725,
                                58.20228
                            ],
                            [
                                24.48039,
                                58.07674
                            ],
                            [
                                24.35282,
                                57.87656
                            ],
                            [
                                24.58642,
                                57.96136
                            ],
                            [
                                24.83066,
                                57.97326
                            ],
                            [
                                25.01856,
                                58.01736
                            ],
                            [
                                25.10933,
                                58.07792
                            ],
                            [
                                25.21525,
                                58.07432
                            ],
                            [
                                25.30291,
                                58.03537
                            ],
                            [
                                25.45121,
                                58.01525
                            ],
                            [
                                25.48585,
                                57.97481
                            ],
                            [
                                25.82156,
                                57.86496
                            ],
                            [
                                26.05821,
                                57.83688
                            ],
                            [
                                26.02559,
                                57.78374
                            ],
                            [
                                26.20489,
                                57.71494
                            ],
                            [
                                26.28707,
                                57.59197
                            ],
                            [
                                26.46809,
                                57.57548
                            ],
                            [
                                26.49989,
                                57.52507
                            ],
                            [
                                26.61523,
                                57.52943
                            ],
                            [
                                26.67604,
                                57.56632
                            ],
                            [
                                26.86204,
                                57.59273
                            ],
                            [
                                26.90553,
                                57.63258
                            ],
                            [
                                27.10268,
                                57.56594
                            ],
                            [
                                27.35158,
                                57.51824
                            ],
                            [
                                27.32008,
                                57.57898
                            ],
                            [
                                27.4042,
                                57.61284
                            ],
                            [
                                27.37785,
                                57.67202
                            ],
                            [
                                27.56487,
                                57.83146
                            ],
                            [
                                27.77569,
                                57.83436
                            ],
                            [
                                27.81772,
                                57.89052
                            ],
                            [
                                27.68118,
                                57.92423
                            ],
                            [
                                27.62105,
                                58.00511
                            ],
                            [
                                27.63412,
                                58.0973
                            ],
                            [
                                27.49075,
                                58.22512
                            ],
                            [
                                27.55321,
                                58.36598
                            ],
                            [
                                27.35705,
                                58.78714
                            ],
                            [
                                27.72762,
                                58.97157
                            ],
                            [
                                27.80822,
                                59.12874
                            ],
                            [
                                27.957,
                                59.27157
                            ],
                            [
                                28.12187,
                                59.28979
                            ],
                            [
                                28.20959,
                                59.37058
                            ],
                            [
                                28.04192,
                                59.47012
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                22.54204,
                                58.64155
                            ],
                            [
                                22.45383,
                                58.57763
                            ],
                            [
                                22.36152,
                                58.57656
                            ],
                            [
                                22.11876,
                                58.4818
                            ],
                            [
                                21.91831,
                                58.51603
                            ],
                            [
                                21.88002,
                                58.47371
                            ],
                            [
                                21.98762,
                                58.3971
                            ],
                            [
                                21.99842,
                                58.35178
                            ],
                            [
                                21.86381,
                                58.26369
                            ],
                            [
                                22.019,
                                58.23971
                            ],
                            [
                                22.06269,
                                58.17857
                            ],
                            [
                                22.21555,
                                58.15555
                            ],
                            [
                                22.16993,
                                58.06971
                            ],
                            [
                                22.07926,
                                58.07389
                            ],
                            [
                                21.98508,
                                57.95232
                            ],
                            [
                                22.05764,
                                57.91179
                            ],
                            [
                                22.18562,
                                58.00785
                            ],
                            [
                                22.26537,
                                58.13011
                            ],
                            [
                                22.26393,
                                58.18467
                            ],
                            [
                                22.45434,
                                58.23912
                            ],
                            [
                                22.73983,
                                58.23971
                            ],
                            [
                                22.92318,
                                58.30277
                            ],
                            [
                                23.17385,
                                58.45235
                            ],
                            [
                                23.30033,
                                58.47569
                            ],
                            [
                                22.94449,
                                58.6167
                            ],
                            [
                                22.80244,
                                58.62531
                            ],
                            [
                                22.75904,
                                58.58017
                            ],
                            [
                                22.62498,
                                58.5841
                            ],
                            [
                                22.54204,
                                58.64155
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                22.61014,
                                59.08346
                            ],
                            [
                                22.57876,
                                59.04004
                            ],
                            [
                                22.39093,
                                58.93632
                            ],
                            [
                                22.20413,
                                58.9343
                            ],
                            [
                                22.17589,
                                58.88235
                            ],
                            [
                                22.36503,
                                58.89702
                            ],
                            [
                                22.42981,
                                58.86749
                            ],
                            [
                                22.50127,
                                58.73191
                            ],
                            [
                                22.64016,
                                58.69285
                            ],
                            [
                                22.71617,
                                58.76326
                            ],
                            [
                                22.87817,
                                58.79456
                            ],
                            [
                                22.96459,
                                58.84804
                            ],
                            [
                                23.06741,
                                58.83827
                            ],
                            [
                                22.95307,
                                58.95622
                            ],
                            [
                                22.8618,
                                58.99674
                            ],
                            [
                                22.69558,
                                59.01739
                            ],
                            [
                                22.61014,
                                59.08346
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                23.21744,
                                58.67767
                            ],
                            [
                                23.15231,
                                58.67884
                            ],
                            [
                                23.15312,
                                58.5771
                            ],
                            [
                                23.22057,
                                58.52613
                            ],
                            [
                                23.40493,
                                58.55075
                            ],
                            [
                                23.34552,
                                58.64754
                            ],
                            [
                                23.21744,
                                58.67767
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                23.20458,
                                59.03978
                            ],
                            [
                                23.16805,
                                58.98101
                            ],
                            [
                                23.29105,
                                58.97202
                            ],
                            [
                                23.33352,
                                59.03202
                            ],
                            [
                                23.20458,
                                59.03978
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "ETH",
                "Country": "Ethiopia",
                "Total_3GHG": 0.49,
                "Total_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.004,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0045,
                    0.0046,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0048,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0054,
                    0.0055,
                    0.0056,
                    0.0058,
                    0.0059,
                    0.0061,
                    0.0062,
                    0.0064,
                    0.0065,
                    0.0067,
                    0.0069,
                    0.0071,
                    0.0073,
                    0.0075,
                    0.0077,
                    0.0079,
                    0.0081
                ],
                "Fossil_3GHG": 0.15,
                "Fossil_3GHG_timeseries": [
                    1.2033e-06,
                    2.3942e-06,
                    3.5724e-06,
                    4.7381e-06,
                    5.891e-06,
                    7.0313e-06,
                    8.1587e-06,
                    9.2732e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016
                ],
                "Land_3GHG": 1.13,
                "Land_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.004,
                    0.004,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0056,
                    0.0057,
                    0.0059,
                    0.006,
                    0.0062,
                    0.0064,
                    0.0065
                ],
                "Total_CO2": 0.25,
                "Total_CO2_timeseries": [
                    8.6732e-06,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029
                ],
                "Fossil_CO2": 0.02,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    4.9099e-09,
                    9.8198e-09,
                    1.473e-08,
                    1.473e-08,
                    1.473e-08,
                    1.473e-08,
                    1.473e-08,
                    1.6366e-08,
                    1.8003e-08,
                    5.759e-08,
                    8.5626e-08,
                    1.3016e-07,
                    2.1265e-07,
                    3.347e-07,
                    4.3694e-07,
                    5.4579e-07,
                    6.9095e-07,
                    8.3444e-07,
                    9.862e-07,
                    1.1446e-06,
                    1.2979e-06,
                    1.4761e-06,
                    1.6658e-06,
                    1.8488e-06,
                    2.139e-06,
                    2.5101e-06,
                    2.9933e-06,
                    3.7701e-06,
                    4.5206e-06,
                    5.2644e-06,
                    6.0972e-06,
                    6.7305e-06,
                    7.519e-06,
                    8.3009e-06,
                    8.8451e-06,
                    9.3741e-06,
                    9.8455e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CO2": 0.76,
                "Land_CO2_timeseries": [
                    8.6732e-06,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027
                ],
                "Total_CH4": 1.01,
                "Total_CH4_timeseries": [
                    7.4187e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.004,
                    0.0041,
                    0.0042
                ],
                "Fossil_CH4": 0.53,
                "Fossil_CH4_timeseries": [
                    1.1652e-06,
                    2.3174e-06,
                    3.4566e-06,
                    4.5826e-06,
                    5.6954e-06,
                    6.7951e-06,
                    7.8815e-06,
                    8.9547e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014
                ],
                "Land_CH4": 1.82,
                "Land_CH4_timeseries": [
                    6.2535e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029
                ],
                "Total_N2O": 1.21,
                "Total_N2O_timeseries": [
                    4.8591e-07,
                    9.8131e-07,
                    1.4858e-06,
                    1.9988e-06,
                    2.5197e-06,
                    3.0475e-06,
                    3.5814e-06,
                    4.12e-06,
                    4.6621e-06,
                    5.2063e-06,
                    5.7516e-06,
                    6.2977e-06,
                    6.8446e-06,
                    7.392e-06,
                    7.94e-06,
                    8.4885e-06,
                    9.0377e-06,
                    9.5875e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001
                ],
                "Fossil_N2O": 0.34,
                "Fossil_N2O_timeseries": [
                    3.8089e-08,
                    7.6711e-08,
                    1.1585e-07,
                    1.5549e-07,
                    1.9561e-07,
                    2.3618e-07,
                    2.7717e-07,
                    3.1853e-07,
                    3.6023e-07,
                    4.0221e-07,
                    4.4444e-07,
                    4.8692e-07,
                    5.2964e-07,
                    5.726e-07,
                    6.1579e-07,
                    6.5922e-07,
                    7.0289e-07,
                    7.4679e-07,
                    7.9095e-07,
                    8.3536e-07,
                    8.8029e-07,
                    9.2618e-07,
                    9.7338e-07,
                    1.0221e-06,
                    1.0726e-06,
                    1.1247e-06,
                    1.1785e-06,
                    1.2338e-06,
                    1.2902e-06,
                    1.3475e-06,
                    1.4053e-06,
                    1.4637e-06,
                    1.5225e-06,
                    1.5817e-06,
                    1.6413e-06,
                    1.7013e-06,
                    1.7617e-06,
                    1.8226e-06,
                    1.8838e-06,
                    1.9476e-06,
                    2.0123e-06,
                    2.0781e-06,
                    2.1449e-06,
                    2.2128e-06,
                    2.2819e-06,
                    2.3522e-06,
                    2.4238e-06,
                    2.4967e-06,
                    2.5709e-06,
                    2.6465e-06,
                    2.7237e-06,
                    2.8026e-06,
                    2.8835e-06,
                    2.9663e-06,
                    3.0511e-06,
                    3.138e-06,
                    3.2268e-06,
                    3.3175e-06,
                    3.4099e-06,
                    3.5037e-06,
                    3.5988e-06,
                    3.695e-06,
                    3.7924e-06,
                    3.8909e-06,
                    3.9905e-06,
                    4.0911e-06,
                    4.1927e-06,
                    4.2954e-06,
                    4.3991e-06,
                    4.504e-06,
                    4.6101e-06,
                    4.7172e-06,
                    4.8255e-06,
                    4.9349e-06,
                    5.0455e-06,
                    5.1573e-06,
                    5.2703e-06,
                    5.3846e-06,
                    5.5003e-06,
                    5.6175e-06,
                    5.7365e-06,
                    5.8575e-06,
                    5.9811e-06,
                    6.1073e-06,
                    6.2366e-06,
                    6.369e-06,
                    6.5048e-06,
                    6.6439e-06,
                    6.7866e-06,
                    6.9329e-06,
                    7.0832e-06,
                    7.2386e-06,
                    7.4e-06,
                    7.5681e-06,
                    7.7431e-06,
                    7.9256e-06,
                    8.1156e-06,
                    8.3129e-06,
                    8.5173e-06,
                    8.7284e-06,
                    8.9464e-06,
                    9.1719e-06,
                    9.4056e-06,
                    9.6477e-06,
                    9.8984e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_N2O": 1.54,
                "Land_N2O_timeseries": [
                    4.4782e-07,
                    9.046e-07,
                    1.37e-06,
                    1.8433e-06,
                    2.3241e-06,
                    2.8114e-06,
                    3.3042e-06,
                    3.8015e-06,
                    4.3019e-06,
                    4.8041e-06,
                    5.3071e-06,
                    5.8108e-06,
                    6.3149e-06,
                    6.8194e-06,
                    7.3242e-06,
                    7.8293e-06,
                    8.3348e-06,
                    8.8407e-06,
                    9.3474e-06,
                    9.8549e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            41.91012,
                            3.98232
                        ],
                        [
                            41.94735,
                            4.05561
                        ],
                        [
                            42.08755,
                            4.17897
                        ],
                        [
                            42.19704,
                            4.179
                        ],
                        [
                            42.55075,
                            4.20581
                        ],
                        [
                            42.70786,
                            4.26122
                        ],
                        [
                            42.81607,
                            4.26498
                        ],
                        [
                            42.89779,
                            4.31845
                        ],
                        [
                            43.00731,
                            4.46833
                        ],
                        [
                            43.04524,
                            4.57287
                        ],
                        [
                            43.17062,
                            4.66019
                        ],
                        [
                            43.43513,
                            4.79469
                        ],
                        [
                            43.65893,
                            4.86799
                        ],
                        [
                            44.01521,
                            4.96043
                        ],
                        [
                            44.75004,
                            4.9285
                        ],
                        [
                            44.98487,
                            4.92081
                        ],
                        [
                            45.47467,
                            5.4241
                        ],
                        [
                            46.11145,
                            6.07779
                        ],
                        [
                            46.75709,
                            6.73976
                        ],
                        [
                            47.17975,
                            7.17262
                        ],
                        [
                            47.6747,
                            7.68201
                        ],
                        [
                            47.97214,
                            7.98785
                        ],
                        [
                            47.6747,
                            7.99822
                        ],
                        [
                            46.99187,
                            8.00059
                        ],
                        [
                            46.57755,
                            8.14643
                        ],
                        [
                            45.93109,
                            8.35875
                        ],
                        [
                            45.60838,
                            8.46884
                        ],
                        [
                            45.23622,
                            8.58765
                        ],
                        [
                            44.87246,
                            8.70888
                        ],
                        [
                            44.51871,
                            8.83072
                        ],
                        [
                            44.0054,
                            8.99716
                        ],
                        [
                            43.65502,
                            9.3514
                        ],
                        [
                            43.51976,
                            9.38727
                        ],
                        [
                            43.44554,
                            9.4449
                        ],
                        [
                            43.39812,
                            9.55287
                        ],
                        [
                            43.29921,
                            9.6112
                        ],
                        [
                            43.25682,
                            9.84261
                        ],
                        [
                            43.14993,
                            9.89936
                        ],
                        [
                            43.08583,
                            9.90899
                        ],
                        [
                            43.01747,
                            10.0806
                        ],
                        [
                            42.88104,
                            10.20724
                        ],
                        [
                            42.83269,
                            10.27778
                        ],
                        [
                            42.74646,
                            10.51192
                        ],
                        [
                            42.6837,
                            10.59139
                        ],
                        [
                            42.76652,
                            10.72181
                        ],
                        [
                            42.96806,
                            10.99743
                        ],
                        [
                            42.91598,
                            10.97667
                        ],
                        [
                            42.79052,
                            10.99026
                        ],
                        [
                            42.76003,
                            11.0742
                        ],
                        [
                            42.68991,
                            11.05771
                        ],
                        [
                            42.62991,
                            11.09556
                        ],
                        [
                            42.50647,
                            11.03975
                        ],
                        [
                            42.42403,
                            10.98349
                        ],
                        [
                            42.34802,
                            11.00182
                        ],
                        [
                            42.2614,
                            10.97119
                        ],
                        [
                            42.11059,
                            10.97046
                        ],
                        [
                            42.06781,
                            10.92568
                        ],
                        [
                            41.97446,
                            10.92766
                        ],
                        [
                            41.82476,
                            10.96586
                        ],
                        [
                            41.80334,
                            11.01133
                        ],
                        [
                            41.80332,
                            11.36029
                        ],
                        [
                            41.77224,
                            11.49409
                        ],
                        [
                            41.80421,
                            11.57254
                        ],
                        [
                            41.80907,
                            11.65954
                        ],
                        [
                            41.83413,
                            11.73053
                        ],
                        [
                            41.89361,
                            11.75558
                        ],
                        [
                            41.95767,
                            11.81478
                        ],
                        [
                            42.09471,
                            12.0112
                        ],
                        [
                            42.22311,
                            12.21558
                        ],
                        [
                            42.31544,
                            12.30732
                        ],
                        [
                            42.33998,
                            12.38055
                        ],
                        [
                            42.40428,
                            12.46864
                        ],
                        [
                            42.27874,
                            12.6353
                        ],
                        [
                            42.21838,
                            12.76485
                        ],
                        [
                            42.0564,
                            12.80129
                        ],
                        [
                            42.02702,
                            12.86745
                        ],
                        [
                            41.96631,
                            12.92464
                        ],
                        [
                            41.89106,
                            13.07342
                        ],
                        [
                            41.73566,
                            13.23658
                        ],
                        [
                            41.66728,
                            13.32391
                        ],
                        [
                            41.64366,
                            13.38556
                        ],
                        [
                            41.4017,
                            13.50252
                        ],
                        [
                            41.30725,
                            13.57968
                        ],
                        [
                            41.16996,
                            13.7289
                        ],
                        [
                            41.11581,
                            13.8278
                        ],
                        [
                            40.94195,
                            14.08181
                        ],
                        [
                            40.80865,
                            14.17244
                        ],
                        [
                            40.57328,
                            14.26893
                        ],
                        [
                            40.45198,
                            14.30754
                        ],
                        [
                            40.26218,
                            14.40972
                        ],
                        [
                            40.21331,
                            14.38911
                        ],
                        [
                            40.14939,
                            14.53452
                        ],
                        [
                            40.07073,
                            14.53951
                        ],
                        [
                            40.04201,
                            14.49252
                        ],
                        [
                            39.93222,
                            14.41657
                        ],
                        [
                            39.76804,
                            14.54494
                        ],
                        [
                            39.68318,
                            14.5914
                        ],
                        [
                            39.58686,
                            14.60408
                        ],
                        [
                            39.5368,
                            14.58373
                        ],
                        [
                            39.48885,
                            14.50175
                        ],
                        [
                            39.3603,
                            14.52517
                        ],
                        [
                            39.35733,
                            14.48699
                        ],
                        [
                            39.26309,
                            14.48447
                        ],
                        [
                            39.23827,
                            14.56045
                        ],
                        [
                            39.16246,
                            14.60432
                        ],
                        [
                            39.15338,
                            14.65139
                        ],
                        [
                            39.0308,
                            14.63577
                        ],
                        [
                            38.97866,
                            14.54822
                        ],
                        [
                            38.79945,
                            14.46979
                        ],
                        [
                            38.70439,
                            14.46875
                        ],
                        [
                            38.52092,
                            14.41155
                        ],
                        [
                            38.45657,
                            14.41508
                        ],
                        [
                            38.42252,
                            14.46721
                        ],
                        [
                            38.37059,
                            14.49007
                        ],
                        [
                            38.27181,
                            14.61961
                        ],
                        [
                            38.23599,
                            14.68946
                        ],
                        [
                            38.14502,
                            14.67899
                        ],
                        [
                            38.0446,
                            14.72053
                        ],
                        [
                            37.94241,
                            14.86219
                        ],
                        [
                            37.90632,
                            14.88232
                        ],
                        [
                            37.52714,
                            14.18682
                        ],
                        [
                            37.46842,
                            14.25231
                        ],
                        [
                            37.3976,
                            14.29796
                        ],
                        [
                            37.38929,
                            14.36508
                        ],
                        [
                            37.30815,
                            14.44687
                        ],
                        [
                            37.23002,
                            14.44375
                        ],
                        [
                            37.13492,
                            14.40706
                        ],
                        [
                            37.09231,
                            14.27291
                        ],
                        [
                            37.01307,
                            14.25357
                        ],
                        [
                            36.9707,
                            14.29228
                        ],
                        [
                            36.89589,
                            14.31597
                        ],
                        [
                            36.743,
                            14.32245
                        ],
                        [
                            36.69239,
                            14.30122
                        ],
                        [
                            36.62873,
                            14.3152
                        ],
                        [
                            36.56034,
                            14.25771
                        ],
                        [
                            36.49795,
                            14.06382
                        ],
                        [
                            36.45231,
                            13.97755
                        ],
                        [
                            36.50018,
                            13.83228
                        ],
                        [
                            36.42214,
                            13.72757
                        ],
                        [
                            36.37538,
                            13.5821
                        ],
                        [
                            36.37346,
                            13.52891
                        ],
                        [
                            36.29208,
                            13.32392
                        ],
                        [
                            36.24705,
                            13.27192
                        ],
                        [
                            36.18034,
                            13.01357
                        ],
                        [
                            36.1506,
                            12.94105
                        ],
                        [
                            36.18202,
                            12.88794
                        ],
                        [
                            36.17349,
                            12.74078
                        ],
                        [
                            36.15249,
                            12.6814
                        ],
                        [
                            36.07729,
                            12.72343
                        ],
                        [
                            36.01939,
                            12.72491
                        ],
                        [
                            35.78603,
                            12.66438
                        ],
                        [
                            35.71311,
                            12.67167
                        ],
                        [
                            35.68195,
                            12.60756
                        ],
                        [
                            35.64177,
                            12.60188
                        ],
                        [
                            35.42854,
                            12.24779
                        ],
                        [
                            35.30232,
                            12.01235
                        ],
                        [
                            35.27515,
                            11.93593
                        ],
                        [
                            35.10967,
                            11.81589
                        ],
                        [
                            35.05483,
                            11.7346
                        ],
                        [
                            35.0924,
                            11.62338
                        ],
                        [
                            35.08955,
                            11.54633
                        ],
                        [
                            35.05933,
                            11.43764
                        ],
                        [
                            34.95572,
                            11.25391
                        ],
                        [
                            35.00692,
                            11.15981
                        ],
                        [
                            34.95253,
                            10.96768
                        ],
                        [
                            34.97222,
                            10.9005
                        ],
                        [
                            34.85473,
                            10.74559
                        ],
                        [
                            34.77734,
                            10.71287
                        ],
                        [
                            34.6991,
                            10.8284
                        ],
                        [
                            34.60204,
                            10.90406
                        ],
                        [
                            34.47214,
                            10.81603
                        ],
                        [
                            34.38438,
                            10.67234
                        ],
                        [
                            34.29982,
                            10.58758
                        ],
                        [
                            34.28296,
                            10.52722
                        ],
                        [
                            34.32539,
                            10.47539
                        ],
                        [
                            34.29593,
                            10.39453
                        ],
                        [
                            34.34985,
                            10.20939
                        ],
                        [
                            34.33065,
                            10.12358
                        ],
                        [
                            34.24978,
                            10.06127
                        ],
                        [
                            34.22148,
                            9.98346
                        ],
                        [
                            34.2227,
                            9.89366
                        ],
                        [
                            34.1086,
                            9.5745
                        ],
                        [
                            34.11325,
                            9.49864
                        ],
                        [
                            34.14273,
                            9.04435
                        ],
                        [
                            34.14425,
                            8.70757
                        ],
                        [
                            34.13902,
                            8.5951
                        ],
                        [
                            34.01225,
                            8.48609
                        ],
                        [
                            33.89875,
                            8.47943
                        ],
                        [
                            33.76792,
                            8.36335
                        ],
                        [
                            33.6927,
                            8.37824
                        ],
                        [
                            33.67639,
                            8.43917
                        ],
                        [
                            33.62577,
                            8.46523
                        ],
                        [
                            33.49023,
                            8.46751
                        ],
                        [
                            33.39335,
                            8.42258
                        ],
                        [
                            33.31143,
                            8.45716
                        ],
                        [
                            33.24921,
                            8.44311
                        ],
                        [
                            33.18827,
                            8.38028
                        ],
                        [
                            33.17004,
                            8.2932
                        ],
                        [
                            33.18741,
                            8.12709
                        ],
                        [
                            33.08598,
                            8.07078
                        ],
                        [
                            33.0015,
                            7.93804
                        ],
                        [
                            33.00277,
                            7.8702
                        ],
                        [
                            33.04805,
                            7.79014
                        ],
                        [
                            33.16214,
                            7.79281
                        ],
                        [
                            33.23797,
                            7.7714
                        ],
                        [
                            33.32315,
                            7.70532
                        ],
                        [
                            33.43117,
                            7.74915
                        ],
                        [
                            33.51406,
                            7.72895
                        ],
                        [
                            33.57063,
                            7.68869
                        ],
                        [
                            33.67077,
                            7.69116
                        ],
                        [
                            33.74295,
                            7.6224
                        ],
                        [
                            33.79664,
                            7.60129
                        ],
                        [
                            33.87494,
                            7.51557
                        ],
                        [
                            33.94395,
                            7.50391
                        ],
                        [
                            33.95876,
                            7.44667
                        ],
                        [
                            34.03097,
                            7.35985
                        ],
                        [
                            34.01253,
                            7.25639
                        ],
                        [
                            34.10334,
                            7.1705
                        ],
                        [
                            34.19074,
                            7.11994
                        ],
                        [
                            34.19412,
                            7.04079
                        ],
                        [
                            34.30546,
                            6.96065
                        ],
                        [
                            34.4634,
                            6.92345
                        ],
                        [
                            34.53866,
                            6.81872
                        ],
                        [
                            34.52895,
                            6.75215
                        ],
                        [
                            34.70615,
                            6.68549
                        ],
                        [
                            34.7684,
                            6.59493
                        ],
                        [
                            34.86131,
                            6.60425
                        ],
                        [
                            34.93824,
                            6.55047
                        ],
                        [
                            35.01314,
                            6.46179
                        ],
                        [
                            34.98583,
                            6.29849
                        ],
                        [
                            34.95246,
                            6.24323
                        ],
                        [
                            34.97397,
                            6.18432
                        ],
                        [
                            34.96939,
                            6.09225
                        ],
                        [
                            34.99988,
                            6.07208
                        ],
                        [
                            35.00169,
                            5.89697
                        ],
                        [
                            35.12906,
                            5.6926
                        ],
                        [
                            35.13933,
                            5.61241
                        ],
                        [
                            35.30905,
                            5.49783
                        ],
                        [
                            35.30275,
                            5.34795
                        ],
                        [
                            35.33968,
                            5.33105
                        ],
                        [
                            35.47242,
                            5.40665
                        ],
                        [
                            35.58732,
                            5.41325
                        ],
                        [
                            35.62698,
                            5.37836
                        ],
                        [
                            35.71767,
                            5.38919
                        ],
                        [
                            35.83934,
                            5.32974
                        ],
                        [
                            35.86095,
                            5.28962
                        ],
                        [
                            35.82928,
                            5.23693
                        ],
                        [
                            35.86338,
                            5.17599
                        ],
                        [
                            35.81828,
                            5.1048
                        ],
                        [
                            35.81718,
                            4.77921
                        ],
                        [
                            35.9477,
                            4.62
                        ],
                        [
                            35.94221,
                            4.54727
                        ],
                        [
                            36.05223,
                            4.4541
                        ],
                        [
                            36.68098,
                            4.44147
                        ],
                        [
                            36.84308,
                            4.44883
                        ],
                        [
                            37.03119,
                            4.38383
                        ],
                        [
                            37.1402,
                            4.29266
                        ],
                        [
                            37.41658,
                            4.11287
                        ],
                        [
                            37.73652,
                            3.89267
                        ],
                        [
                            37.91946,
                            3.77231
                        ],
                        [
                            38.00601,
                            3.7285
                        ],
                        [
                            38.04505,
                            3.67525
                        ],
                        [
                            38.12736,
                            3.60861
                        ],
                        [
                            38.1844,
                            3.62163
                        ],
                        [
                            38.44667,
                            3.60437
                        ],
                        [
                            38.54856,
                            3.64349
                        ],
                        [
                            38.55761,
                            3.61673
                        ],
                        [
                            38.66368,
                            3.59584
                        ],
                        [
                            38.90333,
                            3.51422
                        ],
                        [
                            39.1054,
                            3.52441
                        ],
                        [
                            39.19358,
                            3.48055
                        ],
                        [
                            39.46107,
                            3.45702
                        ],
                        [
                            39.55303,
                            3.40187
                        ],
                        [
                            39.58948,
                            3.48863
                        ],
                        [
                            39.77323,
                            3.66753
                        ],
                        [
                            39.86842,
                            3.86812
                        ],
                        [
                            40.1829,
                            4.03301
                        ],
                        [
                            40.74444,
                            4.26333
                        ],
                        [
                            40.75792,
                            4.28145
                        ],
                        [
                            40.88602,
                            4.21273
                        ],
                        [
                            40.90834,
                            4.15746
                        ],
                        [
                            40.95724,
                            4.14369
                        ],
                        [
                            41.04122,
                            4.07501
                        ],
                        [
                            41.13827,
                            3.9656
                        ],
                        [
                            41.20769,
                            3.9356
                        ],
                        [
                            41.26817,
                            3.9553
                        ],
                        [
                            41.33113,
                            3.93962
                        ],
                        [
                            41.42415,
                            3.94824
                        ],
                        [
                            41.55244,
                            3.98069
                        ],
                        [
                            41.78162,
                            3.97877
                        ],
                        [
                            41.82491,
                            3.94944
                        ],
                        [
                            41.91012,
                            3.98232
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "FRO",
                "Country": "Faroes",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.815e-08,
                    3.63e-08,
                    6.105e-08,
                    9.9e-08,
                    1.3365e-07,
                    1.782e-07,
                    2.2935e-07,
                    2.7225e-07,
                    3.2505e-07,
                    3.696e-07,
                    3.96e-07,
                    4.4715e-07,
                    4.9995e-07,
                    5.5605e-07,
                    6.105e-07,
                    6.7155e-07,
                    7.3425e-07,
                    8.1015e-07,
                    8.9265e-07,
                    9.8835e-07,
                    1.1039e-06,
                    1.221e-06,
                    1.3266e-06,
                    1.4404e-06,
                    1.5757e-06,
                    1.7325e-06,
                    1.881e-06,
                    2.0641e-06,
                    2.244e-06,
                    2.4602e-06,
                    2.6499e-06,
                    2.8479e-06,
                    3.0541e-06,
                    3.2736e-06,
                    3.498e-06,
                    3.7307e-06,
                    3.9517e-06,
                    4.1761e-06,
                    4.4137e-06,
                    4.6744e-06,
                    4.9912e-06,
                    5.2866e-06,
                    5.5787e-06,
                    5.841e-06,
                    6.1001e-06,
                    6.3574e-06,
                    6.6281e-06,
                    6.8937e-06,
                    7.1742e-06,
                    7.458e-06,
                    7.7682e-06,
                    8.1114e-06,
                    8.4381e-06,
                    8.7681e-06,
                    9.1047e-06,
                    9.4298e-06,
                    9.735e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.815e-08,
                    3.63e-08,
                    6.105e-08,
                    9.9e-08,
                    1.3365e-07,
                    1.782e-07,
                    2.2935e-07,
                    2.7225e-07,
                    3.2505e-07,
                    3.696e-07,
                    3.96e-07,
                    4.4715e-07,
                    4.9995e-07,
                    5.5605e-07,
                    6.105e-07,
                    6.7155e-07,
                    7.3425e-07,
                    8.1015e-07,
                    8.9265e-07,
                    9.8835e-07,
                    1.1039e-06,
                    1.221e-06,
                    1.3266e-06,
                    1.4404e-06,
                    1.5757e-06,
                    1.7325e-06,
                    1.881e-06,
                    2.0641e-06,
                    2.244e-06,
                    2.4602e-06,
                    2.6499e-06,
                    2.8479e-06,
                    3.0541e-06,
                    3.2736e-06,
                    3.498e-06,
                    3.7307e-06,
                    3.9517e-06,
                    4.1761e-06,
                    4.4137e-06,
                    4.6744e-06,
                    4.9912e-06,
                    5.2866e-06,
                    5.5787e-06,
                    5.841e-06,
                    6.1001e-06,
                    6.3574e-06,
                    6.6281e-06,
                    6.8937e-06,
                    7.1742e-06,
                    7.458e-06,
                    7.7682e-06,
                    8.1114e-06,
                    8.4381e-06,
                    8.7681e-06,
                    9.1047e-06,
                    9.4298e-06,
                    9.735e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.815e-08,
                    3.63e-08,
                    6.105e-08,
                    9.9e-08,
                    1.3365e-07,
                    1.782e-07,
                    2.2935e-07,
                    2.7225e-07,
                    3.2505e-07,
                    3.696e-07,
                    3.96e-07,
                    4.4715e-07,
                    4.9995e-07,
                    5.5605e-07,
                    6.105e-07,
                    6.7155e-07,
                    7.3425e-07,
                    8.1015e-07,
                    8.9265e-07,
                    9.8835e-07,
                    1.1039e-06,
                    1.221e-06,
                    1.3266e-06,
                    1.4404e-06,
                    1.5757e-06,
                    1.7325e-06,
                    1.881e-06,
                    2.0641e-06,
                    2.244e-06,
                    2.4602e-06,
                    2.6499e-06,
                    2.8479e-06,
                    3.0541e-06,
                    3.2736e-06,
                    3.498e-06,
                    3.7307e-06,
                    3.9517e-06,
                    4.1761e-06,
                    4.4137e-06,
                    4.6744e-06,
                    4.9912e-06,
                    5.2866e-06,
                    5.5787e-06,
                    5.841e-06,
                    6.1001e-06,
                    6.3574e-06,
                    6.6281e-06,
                    6.8937e-06,
                    7.1742e-06,
                    7.458e-06,
                    7.7682e-06,
                    8.1114e-06,
                    8.4381e-06,
                    8.7681e-06,
                    9.1047e-06,
                    9.4298e-06,
                    9.735e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.815e-08,
                    3.63e-08,
                    6.105e-08,
                    9.9e-08,
                    1.3365e-07,
                    1.782e-07,
                    2.2935e-07,
                    2.7225e-07,
                    3.2505e-07,
                    3.696e-07,
                    3.96e-07,
                    4.4715e-07,
                    4.9995e-07,
                    5.5605e-07,
                    6.105e-07,
                    6.7155e-07,
                    7.3425e-07,
                    8.1015e-07,
                    8.9265e-07,
                    9.8835e-07,
                    1.1039e-06,
                    1.221e-06,
                    1.3266e-06,
                    1.4404e-06,
                    1.5757e-06,
                    1.7325e-06,
                    1.881e-06,
                    2.0641e-06,
                    2.244e-06,
                    2.4602e-06,
                    2.6499e-06,
                    2.8479e-06,
                    3.0541e-06,
                    3.2736e-06,
                    3.498e-06,
                    3.7307e-06,
                    3.9517e-06,
                    4.1761e-06,
                    4.4137e-06,
                    4.6744e-06,
                    4.9912e-06,
                    5.2866e-06,
                    5.5787e-06,
                    5.841e-06,
                    6.1001e-06,
                    6.3574e-06,
                    6.6281e-06,
                    6.8937e-06,
                    7.1742e-06,
                    7.458e-06,
                    7.7682e-06,
                    8.1114e-06,
                    8.4381e-06,
                    8.7681e-06,
                    9.1047e-06,
                    9.4298e-06,
                    9.735e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": []
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -7.14704,
                                62.30188
                            ],
                            [
                                -7.22462,
                                62.29863
                            ],
                            [
                                -7.26031,
                                62.17636
                            ],
                            [
                                -7.13057,
                                62.11449
                            ],
                            [
                                -7.0436,
                                62.117
                            ],
                            [
                                -6.9765,
                                62.03695
                            ],
                            [
                                -6.80089,
                                61.9534
                            ],
                            [
                                -6.75528,
                                62.03043
                            ],
                            [
                                -6.88362,
                                62.13861
                            ],
                            [
                                -6.93776,
                                62.15368
                            ],
                            [
                                -7.14704,
                                62.30188
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -6.96556,
                                62.33885
                            ],
                            [
                                -7.08848,
                                62.2991
                            ],
                            [
                                -6.99154,
                                62.19213
                            ],
                            [
                                -6.68876,
                                62.07301
                            ],
                            [
                                -6.62638,
                                62.10944
                            ],
                            [
                                -6.74883,
                                62.18162
                            ],
                            [
                                -6.76371,
                                62.2558
                            ],
                            [
                                -6.96556,
                                62.33885
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -7.24404,
                                62.14917
                            ],
                            [
                                -7.46447,
                                62.12153
                            ],
                            [
                                -7.38565,
                                62.05829
                            ],
                            [
                                -7.20533,
                                62.0222
                            ],
                            [
                                -7.08301,
                                62.04864
                            ],
                            [
                                -7.07778,
                                62.09531
                            ],
                            [
                                -7.24404,
                                62.14917
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -6.57548,
                                62.3946
                            ],
                            [
                                -6.61417,
                                62.34887
                            ],
                            [
                                -6.61531,
                                62.21559
                            ],
                            [
                                -6.45706,
                                62.17775
                            ],
                            [
                                -6.40569,
                                62.30277
                            ],
                            [
                                -6.57548,
                                62.3946
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -6.90251,
                                61.64668
                            ],
                            [
                                -7.00224,
                                61.62376
                            ],
                            [
                                -6.87308,
                                61.47469
                            ],
                            [
                                -6.72563,
                                61.46155
                            ],
                            [
                                -6.75402,
                                61.57281
                            ],
                            [
                                -6.82774,
                                61.58019
                            ],
                            [
                                -6.90251,
                                61.64668
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "FJI",
                "Country": "Fiji",
                "Total_3GHG": 0.01,
                "Total_3GHG_timeseries": [
                    2.1487e-07,
                    4.1145e-07,
                    5.6914e-07,
                    6.9812e-07,
                    7.9967e-07,
                    9.228e-07,
                    1.1079e-06,
                    1.2545e-06,
                    1.3692e-06,
                    1.4999e-06,
                    1.6218e-06,
                    1.7399e-06,
                    1.8628e-06,
                    1.9847e-06,
                    2.1435e-06,
                    2.2978e-06,
                    2.4423e-06,
                    2.5892e-06,
                    2.7552e-06,
                    2.9198e-06,
                    3.0812e-06,
                    3.179e-06,
                    3.3211e-06,
                    3.423e-06,
                    3.5195e-06,
                    3.6309e-06,
                    3.7488e-06,
                    3.8795e-06,
                    4.0057e-06,
                    4.1206e-06,
                    4.2478e-06,
                    4.3489e-06,
                    4.5004e-06,
                    4.6648e-06,
                    4.7888e-06,
                    4.9425e-06,
                    5.0705e-06,
                    5.1668e-06,
                    5.3175e-06,
                    5.4305e-06,
                    5.5077e-06,
                    5.5991e-06,
                    5.6934e-06,
                    5.8183e-06,
                    5.9501e-06,
                    6.0859e-06,
                    6.2389e-06,
                    6.404e-06,
                    6.6049e-06,
                    6.8433e-06,
                    7.1015e-06,
                    7.335e-06,
                    7.6157e-06,
                    7.8494e-06,
                    8.1107e-06,
                    8.3545e-06,
                    8.5531e-06,
                    8.816e-06,
                    9.0794e-06,
                    9.3617e-06,
                    9.64e-06,
                    9.9237e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    7.4568e-09,
                    1.5149e-08,
                    2.3083e-08,
                    3.1267e-08,
                    3.9707e-08,
                    4.8412e-08,
                    5.7389e-08,
                    6.6646e-08,
                    7.6191e-08,
                    8.6033e-08,
                    9.6067e-08,
                    1.063e-07,
                    1.1674e-07,
                    1.2739e-07,
                    1.3826e-07,
                    1.4936e-07,
                    1.607e-07,
                    1.7227e-07,
                    1.841e-07,
                    1.9619e-07,
                    2.0838e-07,
                    2.2066e-07,
                    2.3305e-07,
                    2.4555e-07,
                    2.5817e-07,
                    2.7091e-07,
                    2.8377e-07,
                    2.9675e-07,
                    3.0984e-07,
                    3.2306e-07,
                    3.3598e-07,
                    3.4933e-07,
                    3.6314e-07,
                    3.7741e-07,
                    3.9216e-07,
                    4.074e-07,
                    4.2314e-07,
                    4.3941e-07,
                    4.5622e-07,
                    4.7362e-07,
                    4.9088e-07,
                    5.0798e-07,
                    5.2493e-07,
                    5.4171e-07,
                    5.5833e-07,
                    5.7484e-07,
                    5.9124e-07,
                    6.0753e-07,
                    6.237e-07,
                    6.3972e-07,
                    6.5603e-07,
                    6.7234e-07,
                    6.8862e-07,
                    7.0486e-07,
                    7.2104e-07,
                    7.3717e-07,
                    7.5322e-07,
                    7.6917e-07,
                    7.8498e-07,
                    8.0064e-07,
                    8.1633e-07,
                    8.3206e-07,
                    8.4784e-07,
                    8.6366e-07,
                    8.7953e-07,
                    8.9529e-07,
                    9.1094e-07,
                    9.2648e-07,
                    9.4191e-07,
                    9.5725e-07,
                    9.7263e-07,
                    9.874e-07,
                    1.0017e-06,
                    1.0155e-06,
                    1.0289e-06,
                    1.0415e-06,
                    1.0535e-06,
                    1.0651e-06,
                    1.0758e-06,
                    1.0861e-06,
                    1.0976e-06,
                    1.1099e-06,
                    1.1232e-06,
                    1.1373e-06,
                    1.1523e-06,
                    1.1682e-06,
                    1.1849e-06,
                    1.2025e-06,
                    1.221e-06,
                    1.2403e-06,
                    1.2612e-06,
                    1.2841e-06,
                    1.3088e-06,
                    1.3353e-06,
                    1.3645e-06,
                    1.3971e-06,
                    1.432e-06,
                    1.4694e-06,
                    1.5099e-06,
                    1.6097e-06,
                    1.7184e-06,
                    1.8441e-06,
                    1.9806e-06,
                    2.118e-06,
                    2.2688e-06,
                    2.4369e-06,
                    2.5992e-06,
                    2.7747e-06,
                    2.9688e-06,
                    3.1707e-06,
                    3.3705e-06,
                    3.6092e-06,
                    3.8639e-06,
                    4.2136e-06,
                    4.5372e-06,
                    4.8613e-06,
                    5.2117e-06,
                    5.5917e-06,
                    5.9997e-06,
                    6.4464e-06,
                    6.9246e-06,
                    7.4192e-06,
                    7.9418e-06,
                    8.4859e-06,
                    9.0102e-06,
                    9.4751e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_3GHG": 0.02,
                "Land_3GHG_timeseries": [
                    2.0741e-07,
                    3.963e-07,
                    5.4605e-07,
                    6.6685e-07,
                    7.5996e-07,
                    8.7438e-07,
                    1.0506e-06,
                    1.1879e-06,
                    1.2931e-06,
                    1.4138e-06,
                    1.5257e-06,
                    1.6336e-06,
                    1.746e-06,
                    1.8573e-06,
                    2.0052e-06,
                    2.1484e-06,
                    2.2816e-06,
                    2.4169e-06,
                    2.5711e-06,
                    2.7236e-06,
                    2.8728e-06,
                    2.9584e-06,
                    3.0881e-06,
                    3.1774e-06,
                    3.2614e-06,
                    3.36e-06,
                    3.465e-06,
                    3.5828e-06,
                    3.6959e-06,
                    3.7976e-06,
                    3.9118e-06,
                    3.9996e-06,
                    4.1372e-06,
                    4.2874e-06,
                    4.3967e-06,
                    4.5351e-06,
                    4.6473e-06,
                    4.7274e-06,
                    4.8613e-06,
                    4.9569e-06,
                    5.0168e-06,
                    5.0911e-06,
                    5.1684e-06,
                    5.2765e-06,
                    5.3917e-06,
                    5.5111e-06,
                    5.6477e-06,
                    5.7964e-06,
                    5.9812e-06,
                    6.2035e-06,
                    6.4454e-06,
                    6.6627e-06,
                    6.9271e-06,
                    7.1446e-06,
                    7.3897e-06,
                    7.6173e-06,
                    7.7999e-06,
                    8.0468e-06,
                    8.2944e-06,
                    8.5611e-06,
                    8.8237e-06,
                    9.0917e-06,
                    9.4118e-06,
                    9.6658e-06,
                    9.9459e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_CO2": 0.01,
                "Total_CO2_timeseries": [
                    1.6555e-07,
                    3.1222e-07,
                    4.1941e-07,
                    4.9732e-07,
                    5.4721e-07,
                    6.1811e-07,
                    7.5047e-07,
                    8.4369e-07,
                    9.0457e-07,
                    9.8079e-07,
                    1.0484e-06,
                    1.1122e-06,
                    1.1809e-06,
                    1.2487e-06,
                    1.3534e-06,
                    1.4536e-06,
                    1.5441e-06,
                    1.637e-06,
                    1.749e-06,
                    1.8596e-06,
                    1.9671e-06,
                    2.0107e-06,
                    2.0983e-06,
                    2.1451e-06,
                    2.186e-06,
                    2.2411e-06,
                    2.3021e-06,
                    2.3755e-06,
                    2.444e-06,
                    2.5011e-06,
                    2.5701e-06,
                    2.612e-06,
                    2.7033e-06,
                    2.8065e-06,
                    2.8683e-06,
                    2.9587e-06,
                    3.0223e-06,
                    3.0532e-06,
                    3.1374e-06,
                    3.181e-06,
                    3.1894e-06,
                    3.2123e-06,
                    3.2385e-06,
                    3.2955e-06,
                    3.3597e-06,
                    3.4279e-06,
                    3.5132e-06,
                    3.6103e-06,
                    3.7432e-06,
                    3.9133e-06,
                    4.1027e-06,
                    4.267e-06,
                    4.4779e-06,
                    4.6411e-06,
                    4.8311e-06,
                    5.0028e-06,
                    5.1286e-06,
                    5.3181e-06,
                    5.5075e-06,
                    5.7156e-06,
                    5.9194e-06,
                    6.1282e-06,
                    6.389e-06,
                    6.5832e-06,
                    6.8036e-06,
                    7.0335e-06,
                    7.2864e-06,
                    7.4822e-06,
                    7.7401e-06,
                    7.9632e-06,
                    8.2224e-06,
                    8.4812e-06,
                    8.7434e-06,
                    9.0058e-06,
                    9.2611e-06,
                    9.5211e-06,
                    9.8186e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    5.445e-08,
                    1.1385e-07,
                    1.848e-07,
                    2.607e-07,
                    3.3165e-07,
                    4.092e-07,
                    4.9665e-07,
                    5.709e-07,
                    6.501e-07,
                    7.392e-07,
                    8.2665e-07,
                    9.0255e-07,
                    1.0065e-06,
                    1.1154e-06,
                    1.3067e-06,
                    1.4618e-06,
                    1.6069e-06,
                    1.7669e-06,
                    1.945e-06,
                    2.1396e-06,
                    2.3738e-06,
                    2.6211e-06,
                    2.8817e-06,
                    3.1653e-06,
                    3.4671e-06,
                    3.7475e-06,
                    3.965e-06,
                    4.3093e-06,
                    4.6286e-06,
                    5.0053e-06,
                    5.3622e-06,
                    5.8472e-06,
                    6.2233e-06,
                    6.5426e-06,
                    6.8025e-06,
                    7.0605e-06,
                    7.3299e-06,
                    7.5424e-06,
                    7.79e-06,
                    8.0715e-06,
                    8.4324e-06,
                    8.7273e-06,
                    9.0562e-06,
                    9.3843e-06,
                    9.71e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CO2": 0.02,
                "Land_CO2_timeseries": [
                    1.6555e-07,
                    3.1222e-07,
                    4.1941e-07,
                    4.9732e-07,
                    5.4721e-07,
                    6.1811e-07,
                    7.5047e-07,
                    8.4369e-07,
                    9.0457e-07,
                    9.8079e-07,
                    1.0484e-06,
                    1.1122e-06,
                    1.1809e-06,
                    1.2487e-06,
                    1.3534e-06,
                    1.4536e-06,
                    1.5441e-06,
                    1.637e-06,
                    1.749e-06,
                    1.8596e-06,
                    1.9671e-06,
                    2.0107e-06,
                    2.0983e-06,
                    2.1451e-06,
                    2.186e-06,
                    2.2411e-06,
                    2.3021e-06,
                    2.3755e-06,
                    2.444e-06,
                    2.5011e-06,
                    2.5701e-06,
                    2.612e-06,
                    2.7033e-06,
                    2.8065e-06,
                    2.8683e-06,
                    2.9587e-06,
                    3.0223e-06,
                    3.0532e-06,
                    3.1374e-06,
                    3.181e-06,
                    3.1894e-06,
                    3.2123e-06,
                    3.2385e-06,
                    3.2955e-06,
                    3.3597e-06,
                    3.4279e-06,
                    3.5132e-06,
                    3.6103e-06,
                    3.7432e-06,
                    3.9133e-06,
                    4.1027e-06,
                    4.267e-06,
                    4.4779e-06,
                    4.6411e-06,
                    4.8311e-06,
                    5.0028e-06,
                    5.1286e-06,
                    5.3181e-06,
                    5.5075e-06,
                    5.7156e-06,
                    5.9194e-06,
                    6.1282e-06,
                    6.389e-06,
                    6.5832e-06,
                    6.8036e-06,
                    7.0335e-06,
                    7.2864e-06,
                    7.4822e-06,
                    7.7401e-06,
                    7.9632e-06,
                    8.2224e-06,
                    8.4812e-06,
                    8.7434e-06,
                    9.0058e-06,
                    9.2611e-06,
                    9.5211e-06,
                    9.8186e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_CH4": 0.01,
                "Total_CH4_timeseries": [
                    3.7944e-08,
                    7.6276e-08,
                    1.15e-07,
                    1.5413e-07,
                    1.9367e-07,
                    2.3363e-07,
                    2.7401e-07,
                    3.1483e-07,
                    3.561e-07,
                    3.9781e-07,
                    4.3942e-07,
                    4.8093e-07,
                    5.2234e-07,
                    5.6366e-07,
                    6.049e-07,
                    6.4607e-07,
                    6.8718e-07,
                    7.2823e-07,
                    7.6923e-07,
                    8.1018e-07,
                    8.509e-07,
                    8.9137e-07,
                    9.316e-07,
                    9.7159e-07,
                    1.0113e-06,
                    1.0509e-06,
                    1.0901e-06,
                    1.1292e-06,
                    1.168e-06,
                    1.2066e-06,
                    1.2453e-06,
                    1.2849e-06,
                    1.3253e-06,
                    1.3667e-06,
                    1.4089e-06,
                    1.452e-06,
                    1.496e-06,
                    1.541e-06,
                    1.587e-06,
                    1.6339e-06,
                    1.6811e-06,
                    1.7285e-06,
                    1.7761e-06,
                    1.8239e-06,
                    1.872e-06,
                    1.9204e-06,
                    1.969e-06,
                    2.0179e-06,
                    2.067e-06,
                    2.1164e-06,
                    2.1661e-06,
                    2.2158e-06,
                    2.2656e-06,
                    2.3153e-06,
                    2.365e-06,
                    2.4146e-06,
                    2.4642e-06,
                    2.5137e-06,
                    2.5631e-06,
                    2.6124e-06,
                    2.6617e-06,
                    2.7111e-06,
                    2.7606e-06,
                    2.8102e-06,
                    2.8598e-06,
                    2.9093e-06,
                    2.9587e-06,
                    3.0081e-06,
                    3.0574e-06,
                    3.1066e-06,
                    3.1559e-06,
                    3.2046e-06,
                    3.2528e-06,
                    3.3007e-06,
                    3.3481e-06,
                    3.3948e-06,
                    3.4409e-06,
                    3.4866e-06,
                    3.5315e-06,
                    3.576e-06,
                    3.6275e-06,
                    3.6853e-06,
                    3.7498e-06,
                    3.8208e-06,
                    3.8983e-06,
                    3.9822e-06,
                    4.0726e-06,
                    4.1693e-06,
                    4.2724e-06,
                    4.3819e-06,
                    4.4978e-06,
                    4.6206e-06,
                    4.75e-06,
                    4.8861e-06,
                    5.0296e-06,
                    5.1814e-06,
                    5.3402e-06,
                    5.5064e-06,
                    5.6804e-06,
                    5.8642e-06,
                    6.0559e-06,
                    6.259e-06,
                    6.4753e-06,
                    6.7058e-06,
                    6.9518e-06,
                    7.2144e-06,
                    7.494e-06,
                    7.7923e-06,
                    8.1105e-06,
                    8.4505e-06,
                    8.8468e-06,
                    9.2466e-06,
                    9.6502e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_CH4": 0.01,
                "Fossil_CH4_timeseries": [
                    4.3887e-09,
                    8.9798e-09,
                    1.378e-08,
                    1.8798e-08,
                    2.4041e-08,
                    2.9516e-08,
                    3.5232e-08,
                    4.1199e-08,
                    4.7423e-08,
                    5.3916e-08,
                    6.0572e-08,
                    6.7399e-08,
                    7.4404e-08,
                    8.1593e-08,
                    8.8974e-08,
                    9.6555e-08,
                    1.0434e-07,
                    1.1235e-07,
                    1.2057e-07,
                    1.2903e-07,
                    1.3755e-07,
                    1.4613e-07,
                    1.5477e-07,
                    1.6347e-07,
                    1.7224e-07,
                    1.8108e-07,
                    1.8999e-07,
                    1.9896e-07,
                    2.0802e-07,
                    2.1716e-07,
                    2.2597e-07,
                    2.3517e-07,
                    2.448e-07,
                    2.5486e-07,
                    2.6538e-07,
                    2.7634e-07,
                    2.8779e-07,
                    2.9972e-07,
                    3.1217e-07,
                    3.2516e-07,
                    3.3796e-07,
                    3.5057e-07,
                    3.6299e-07,
                    3.752e-07,
                    3.8721e-07,
                    3.9907e-07,
                    4.1078e-07,
                    4.2234e-07,
                    4.3373e-07,
                    4.4493e-07,
                    4.5638e-07,
                    4.6777e-07,
                    4.7909e-07,
                    4.9032e-07,
                    5.0144e-07,
                    5.1245e-07,
                    5.2334e-07,
                    5.3407e-07,
                    5.4462e-07,
                    5.5496e-07,
                    5.653e-07,
                    5.7564e-07,
                    5.8598e-07,
                    5.9632e-07,
                    6.0666e-07,
                    6.1685e-07,
                    6.2689e-07,
                    6.3678e-07,
                    6.4653e-07,
                    6.5614e-07,
                    6.6576e-07,
                    6.7475e-07,
                    6.8323e-07,
                    6.9123e-07,
                    6.9875e-07,
                    7.0539e-07,
                    7.1149e-07,
                    7.1706e-07,
                    7.218e-07,
                    7.2603e-07,
                    7.315e-07,
                    7.3772e-07,
                    7.4477e-07,
                    7.5265e-07,
                    7.6136e-07,
                    7.7087e-07,
                    7.8115e-07,
                    7.9221e-07,
                    8.0406e-07,
                    8.167e-07,
                    8.3087e-07,
                    8.4685e-07,
                    8.6452e-07,
                    8.8393e-07,
                    9.058e-07,
                    9.3094e-07,
                    9.5821e-07,
                    9.8787e-07,
                    1.0205e-06,
                    1.0578e-06,
                    1.099e-06,
                    1.1456e-06,
                    1.1979e-06,
                    1.256e-06,
                    1.3208e-06,
                    1.3928e-06,
                    1.4722e-06,
                    1.5597e-06,
                    1.6559e-06,
                    1.7614e-06,
                    1.8762e-06,
                    2.0016e-06,
                    2.1378e-06,
                    2.2863e-06,
                    2.4448e-06,
                    2.6133e-06,
                    2.793e-06,
                    2.9839e-06,
                    3.186e-06,
                    3.3895e-06,
                    3.611e-06,
                    3.8343e-06,
                    4.0609e-06,
                    4.2899e-06,
                    4.5197e-06,
                    4.753e-06,
                    4.9951e-06,
                    5.2372e-06,
                    5.4927e-06,
                    5.7426e-06,
                    6.0008e-06,
                    6.2606e-06,
                    6.498e-06,
                    6.7527e-06,
                    6.9917e-06,
                    7.2456e-06,
                    7.4868e-06,
                    7.7208e-06,
                    7.9629e-06,
                    8.2088e-06,
                    8.4396e-06,
                    8.686e-06,
                    8.9424e-06,
                    9.2204e-06,
                    9.5072e-06,
                    9.8024e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CH4": 0.01,
                "Land_CH4_timeseries": [
                    3.3555e-08,
                    6.7296e-08,
                    1.0122e-07,
                    1.3533e-07,
                    1.6963e-07,
                    2.0411e-07,
                    2.3878e-07,
                    2.7363e-07,
                    3.0867e-07,
                    3.439e-07,
                    3.7885e-07,
                    4.1353e-07,
                    4.4793e-07,
                    4.8207e-07,
                    5.1593e-07,
                    5.4952e-07,
                    5.8284e-07,
                    6.1588e-07,
                    6.4865e-07,
                    6.8115e-07,
                    7.1335e-07,
                    7.4524e-07,
                    7.7683e-07,
                    8.0812e-07,
                    8.391e-07,
                    8.6978e-07,
                    9.0015e-07,
                    9.3023e-07,
                    9.5999e-07,
                    9.8946e-07,
                    1.0194e-06,
                    1.0497e-06,
                    1.0805e-06,
                    1.1118e-06,
                    1.1435e-06,
                    1.1756e-06,
                    1.2082e-06,
                    1.2413e-06,
                    1.2748e-06,
                    1.3087e-06,
                    1.3431e-06,
                    1.3779e-06,
                    1.4131e-06,
                    1.4487e-06,
                    1.4848e-06,
                    1.5213e-06,
                    1.5582e-06,
                    1.5955e-06,
                    1.6333e-06,
                    1.6715e-06,
                    1.7097e-06,
                    1.7481e-06,
                    1.7865e-06,
                    1.825e-06,
                    1.8635e-06,
                    1.9022e-06,
                    1.9409e-06,
                    1.9796e-06,
                    2.0185e-06,
                    2.0574e-06,
                    2.0964e-06,
                    2.1355e-06,
                    2.1746e-06,
                    2.2138e-06,
                    2.2531e-06,
                    2.2924e-06,
                    2.3318e-06,
                    2.3713e-06,
                    2.4108e-06,
                    2.4504e-06,
                    2.4901e-06,
                    2.5298e-06,
                    2.5696e-06,
                    2.6095e-06,
                    2.6494e-06,
                    2.6894e-06,
                    2.7294e-06,
                    2.7696e-06,
                    2.8097e-06,
                    2.85e-06,
                    2.896e-06,
                    2.9476e-06,
                    3.005e-06,
                    3.0681e-06,
                    3.1369e-06,
                    3.2114e-06,
                    3.2914e-06,
                    3.3771e-06,
                    3.4683e-06,
                    3.5651e-06,
                    3.667e-06,
                    3.7737e-06,
                    3.8855e-06,
                    4.0022e-06,
                    4.1239e-06,
                    4.2505e-06,
                    4.382e-06,
                    4.5185e-06,
                    4.66e-06,
                    4.8064e-06,
                    4.9568e-06,
                    5.1134e-06,
                    5.2774e-06,
                    5.4498e-06,
                    5.631e-06,
                    5.8215e-06,
                    6.0218e-06,
                    6.2326e-06,
                    6.4546e-06,
                    6.6891e-06,
                    6.9706e-06,
                    7.245e-06,
                    7.5124e-06,
                    7.7895e-06,
                    8.0503e-06,
                    8.3076e-06,
                    8.6303e-06,
                    8.964e-06,
                    9.3338e-06,
                    9.721e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_N2O": 0.01,
                "Total_N2O_timeseries": [
                    1.1377e-08,
                    2.2952e-08,
                    3.472e-08,
                    4.6668e-08,
                    5.8785e-08,
                    7.1055e-08,
                    8.3459e-08,
                    9.5976e-08,
                    1.0858e-07,
                    1.2125e-07,
                    1.3396e-07,
                    1.4671e-07,
                    1.595e-07,
                    1.7232e-07,
                    1.8517e-07,
                    1.9806e-07,
                    2.1099e-07,
                    2.2395e-07,
                    2.3696e-07,
                    2.5e-07,
                    2.6324e-07,
                    2.7692e-07,
                    2.9123e-07,
                    3.063e-07,
                    3.222e-07,
                    3.3897e-07,
                    3.5654e-07,
                    3.7484e-07,
                    3.9371e-07,
                    4.1292e-07,
                    4.3236e-07,
                    4.5197e-07,
                    4.7174e-07,
                    4.9166e-07,
                    5.117e-07,
                    5.3186e-07,
                    5.5215e-07,
                    5.7257e-07,
                    5.9313e-07,
                    6.1561e-07,
                    6.3731e-07,
                    6.5834e-07,
                    6.788e-07,
                    6.9879e-07,
                    7.1839e-07,
                    7.377e-07,
                    7.5679e-07,
                    7.7576e-07,
                    7.9467e-07,
                    8.1358e-07,
                    8.3267e-07,
                    8.5217e-07,
                    8.7226e-07,
                    8.9306e-07,
                    9.1465e-07,
                    9.3706e-07,
                    9.6027e-07,
                    9.842e-07,
                    1.0087e-06,
                    1.0337e-06,
                    1.0589e-06,
                    1.0844e-06,
                    1.1101e-06,
                    1.136e-06,
                    1.1622e-06,
                    1.1885e-06,
                    1.215e-06,
                    1.2416e-06,
                    1.2685e-06,
                    1.2957e-06,
                    1.3231e-06,
                    1.3508e-06,
                    1.3789e-06,
                    1.4074e-06,
                    1.4363e-06,
                    1.4655e-06,
                    1.495e-06,
                    1.5248e-06,
                    1.5547e-06,
                    1.5848e-06,
                    1.6149e-06,
                    1.6449e-06,
                    1.6749e-06,
                    1.7049e-06,
                    1.7349e-06,
                    1.7648e-06,
                    1.7947e-06,
                    1.8246e-06,
                    1.8545e-06,
                    1.8845e-06,
                    1.9149e-06,
                    1.9465e-06,
                    1.9797e-06,
                    2.0149e-06,
                    2.0524e-06,
                    2.0921e-06,
                    2.1341e-06,
                    2.1781e-06,
                    2.2238e-06,
                    2.2706e-06,
                    2.3182e-06,
                    2.3667e-06,
                    2.4162e-06,
                    2.4667e-06,
                    2.5181e-06,
                    2.5707e-06,
                    2.6243e-06,
                    2.6791e-06,
                    2.735e-06,
                    2.792e-06,
                    2.851e-06,
                    2.9151e-06,
                    2.9819e-06,
                    3.0551e-06,
                    3.1252e-06,
                    3.1934e-06,
                    3.2669e-06,
                    3.3453e-06,
                    3.4257e-06,
                    3.5045e-06,
                    3.588e-06,
                    3.6775e-06,
                    3.7686e-06,
                    3.8695e-06,
                    3.9681e-06,
                    4.0728e-06,
                    4.1851e-06,
                    4.292e-06,
                    4.4138e-06,
                    4.5364e-06,
                    4.6696e-06,
                    4.7992e-06,
                    4.9219e-06,
                    5.053e-06,
                    5.1824e-06,
                    5.3254e-06,
                    5.4671e-06,
                    5.6087e-06,
                    5.7602e-06,
                    5.9131e-06,
                    6.062e-06,
                    6.2118e-06,
                    6.3727e-06,
                    6.5406e-06,
                    6.7176e-06,
                    6.8941e-06,
                    7.0715e-06,
                    7.2434e-06,
                    7.4087e-06,
                    7.5641e-06,
                    7.7274e-06,
                    7.8949e-06,
                    8.0451e-06,
                    8.2147e-06,
                    8.3759e-06,
                    8.5325e-06,
                    8.6889e-06,
                    8.8464e-06,
                    8.9914e-06,
                    9.1377e-06,
                    9.2888e-06,
                    9.4375e-06,
                    9.5886e-06,
                    9.6724e-06,
                    9.766e-06,
                    9.8532e-06,
                    9.9499e-06,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_N2O": 0.01,
                "Fossil_N2O_timeseries": [
                    3.0681e-09,
                    6.1691e-09,
                    9.3027e-09,
                    1.2469e-08,
                    1.5667e-08,
                    1.8896e-08,
                    2.2156e-08,
                    2.5447e-08,
                    2.8768e-08,
                    3.2117e-08,
                    3.5495e-08,
                    3.8901e-08,
                    4.2335e-08,
                    4.5798e-08,
                    4.9288e-08,
                    5.2807e-08,
                    5.6354e-08,
                    5.9929e-08,
                    6.3533e-08,
                    6.7165e-08,
                    7.0829e-08,
                    7.4534e-08,
                    7.8283e-08,
                    8.2081e-08,
                    8.593e-08,
                    8.9831e-08,
                    9.3782e-08,
                    9.7781e-08,
                    1.0182e-07,
                    1.059e-07,
                    1.1002e-07,
                    1.1416e-07,
                    1.1834e-07,
                    1.2255e-07,
                    1.2678e-07,
                    1.3105e-07,
                    1.3535e-07,
                    1.3968e-07,
                    1.4405e-07,
                    1.4846e-07,
                    1.5292e-07,
                    1.5741e-07,
                    1.6194e-07,
                    1.6651e-07,
                    1.7112e-07,
                    1.7577e-07,
                    1.8046e-07,
                    1.852e-07,
                    1.8997e-07,
                    1.9479e-07,
                    1.9965e-07,
                    2.0456e-07,
                    2.0953e-07,
                    2.1454e-07,
                    2.196e-07,
                    2.2472e-07,
                    2.2988e-07,
                    2.351e-07,
                    2.4036e-07,
                    2.4567e-07,
                    2.5103e-07,
                    2.5642e-07,
                    2.6186e-07,
                    2.6735e-07,
                    2.7287e-07,
                    2.7844e-07,
                    2.8405e-07,
                    2.897e-07,
                    2.9539e-07,
                    3.0111e-07,
                    3.0686e-07,
                    3.1265e-07,
                    3.1847e-07,
                    3.2432e-07,
                    3.302e-07,
                    3.361e-07,
                    3.4204e-07,
                    3.48e-07,
                    3.54e-07,
                    3.6003e-07,
                    3.661e-07,
                    3.7222e-07,
                    3.7839e-07,
                    3.8463e-07,
                    3.9094e-07,
                    3.9732e-07,
                    4.0377e-07,
                    4.103e-07,
                    4.1691e-07,
                    4.2359e-07,
                    4.3036e-07,
                    4.3725e-07,
                    4.4426e-07,
                    4.5141e-07,
                    4.5871e-07,
                    4.6617e-07,
                    4.7378e-07,
                    4.8153e-07,
                    4.8942e-07,
                    4.9741e-07,
                    5.0551e-07,
                    5.137e-07,
                    5.2199e-07,
                    5.3037e-07,
                    5.3884e-07,
                    5.474e-07,
                    5.5606e-07,
                    5.6482e-07,
                    5.7368e-07,
                    5.8265e-07,
                    5.9176e-07,
                    6.0109e-07,
                    6.1067e-07,
                    6.2053e-07,
                    6.3069e-07,
                    6.4114e-07,
                    6.5187e-07,
                    6.6285e-07,
                    6.7403e-07,
                    6.8316e-07,
                    6.9245e-07,
                    7.0329e-07,
                    7.1554e-07,
                    7.2892e-07,
                    7.4304e-07,
                    7.5712e-07,
                    7.7449e-07,
                    7.9024e-07,
                    8.0718e-07,
                    8.2509e-07,
                    8.4403e-07,
                    8.6324e-07,
                    8.7978e-07,
                    8.949e-07,
                    9.1164e-07,
                    9.3057e-07,
                    9.4781e-07,
                    9.6506e-07,
                    9.832e-07,
                    1.0044e-06,
                    1.0241e-06,
                    1.0456e-06,
                    1.0682e-06,
                    1.0911e-06,
                    1.1141e-06,
                    1.1381e-06,
                    1.1614e-06,
                    1.1841e-06,
                    1.2096e-06,
                    1.2339e-06,
                    1.2583e-06,
                    1.2811e-06,
                    1.3057e-06,
                    1.3349e-06,
                    1.3612e-06,
                    1.3885e-06,
                    1.4144e-06,
                    1.4349e-06,
                    1.453e-06,
                    1.4734e-06,
                    1.4963e-06,
                    1.5155e-06,
                    1.5365e-06,
                    1.5608e-06,
                    1.5872e-06,
                    1.6121e-06,
                    1.639e-06,
                    1.6658e-06,
                    1.6912e-06,
                    1.7149e-06,
                    1.7391e-06,
                    1.7636e-06
                ],
                "Land_N2O": 0.01,
                "Land_N2O_timeseries": [
                    8.3085e-09,
                    1.6783e-08,
                    2.5417e-08,
                    3.42e-08,
                    4.3119e-08,
                    5.2159e-08,
                    6.1303e-08,
                    7.0529e-08,
                    7.9813e-08,
                    8.913e-08,
                    9.8463e-08,
                    1.0781e-07,
                    1.1716e-07,
                    1.2652e-07,
                    1.3589e-07,
                    1.4526e-07,
                    1.5464e-07,
                    1.6402e-07,
                    1.7342e-07,
                    1.8284e-07,
                    1.9241e-07,
                    2.0239e-07,
                    2.1295e-07,
                    2.2422e-07,
                    2.3627e-07,
                    2.4914e-07,
                    2.6276e-07,
                    2.7706e-07,
                    2.9188e-07,
                    3.0702e-07,
                    3.2234e-07,
                    3.3781e-07,
                    3.5341e-07,
                    3.6911e-07,
                    3.8491e-07,
                    4.0081e-07,
                    4.168e-07,
                    4.3288e-07,
                    4.4908e-07,
                    4.6715e-07,
                    4.844e-07,
                    5.0093e-07,
                    5.1686e-07,
                    5.3227e-07,
                    5.4727e-07,
                    5.6193e-07,
                    5.7633e-07,
                    5.9056e-07,
                    6.0469e-07,
                    6.1879e-07,
                    6.3302e-07,
                    6.4761e-07,
                    6.6273e-07,
                    6.7852e-07,
                    6.9505e-07,
                    7.1235e-07,
                    7.3039e-07,
                    7.491e-07,
                    7.6836e-07,
                    7.88e-07,
                    8.0788e-07,
                    8.2797e-07,
                    8.4825e-07,
                    8.6869e-07,
                    8.8929e-07,
                    9.1002e-07,
                    9.3091e-07,
                    9.5195e-07,
                    9.7316e-07,
                    9.9457e-07,
                    1.0162e-06,
                    1.0382e-06,
                    1.0605e-06,
                    1.0831e-06,
                    1.1061e-06,
                    1.1294e-06,
                    1.153e-06,
                    1.1768e-06,
                    1.2007e-06,
                    1.2248e-06,
                    1.2487e-06,
                    1.2727e-06,
                    1.2966e-06,
                    1.3203e-06,
                    1.344e-06,
                    1.3675e-06,
                    1.391e-06,
                    1.4143e-06,
                    1.4376e-06,
                    1.4609e-06,
                    1.4846e-06,
                    1.5093e-06,
                    1.5354e-06,
                    1.5635e-06,
                    1.5936e-06,
                    1.626e-06,
                    1.6603e-06,
                    1.6966e-06,
                    1.7344e-06,
                    1.7732e-06,
                    1.8127e-06,
                    1.853e-06,
                    1.8942e-06,
                    1.9363e-06,
                    1.9793e-06,
                    2.0233e-06,
                    2.0683e-06,
                    2.1143e-06,
                    2.1613e-06,
                    2.2094e-06,
                    2.2592e-06,
                    2.314e-06,
                    2.3712e-06,
                    2.4346e-06,
                    2.4945e-06,
                    2.5523e-06,
                    2.6151e-06,
                    2.6824e-06,
                    2.7517e-06,
                    2.8213e-06,
                    2.8956e-06,
                    2.9743e-06,
                    3.053e-06,
                    3.1406e-06,
                    3.2251e-06,
                    3.3157e-06,
                    3.4106e-06,
                    3.5018e-06,
                    3.6066e-06,
                    3.7113e-06,
                    3.8255e-06,
                    3.9359e-06,
                    4.0422e-06,
                    4.1581e-06,
                    4.2707e-06,
                    4.3948e-06,
                    4.5192e-06,
                    4.6436e-06,
                    4.777e-06,
                    4.9087e-06,
                    5.0379e-06,
                    5.1662e-06,
                    5.3045e-06,
                    5.4495e-06,
                    5.6034e-06,
                    5.756e-06,
                    5.9101e-06,
                    6.0593e-06,
                    6.1991e-06,
                    6.3302e-06,
                    6.469e-06,
                    6.6138e-06,
                    6.7394e-06,
                    6.8798e-06,
                    7.0147e-06,
                    7.144e-06,
                    7.2745e-06,
                    7.4115e-06,
                    7.5383e-06,
                    7.6643e-06,
                    7.7924e-06,
                    7.9221e-06,
                    8.0521e-06,
                    8.1116e-06,
                    8.1788e-06,
                    8.2411e-06,
                    8.3109e-06,
                    8.3764e-06,
                    8.4532e-06,
                    8.5268e-06,
                    8.5846e-06,
                    8.6437e-06
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                177.29754,
                                -18.02932
                            ],
                            [
                                177.34268,
                                -18.11647
                            ],
                            [
                                177.4142,
                                -18.12793
                            ],
                            [
                                177.46682,
                                -18.16448
                            ],
                            [
                                177.52015,
                                -18.15877
                            ],
                            [
                                177.70343,
                                -18.20062
                            ],
                            [
                                177.8992,
                                -18.26789
                            ],
                            [
                                177.97889,
                                -18.25372
                            ],
                            [
                                178.14779,
                                -18.25721
                            ],
                            [
                                178.26492,
                                -18.15899
                            ],
                            [
                                178.32972,
                                -18.12231
                            ],
                            [
                                178.42137,
                                -18.11413
                            ],
                            [
                                178.44119,
                                -18.1553
                            ],
                            [
                                178.50951,
                                -18.09401
                            ],
                            [
                                178.59273,
                                -18.12236
                            ],
                            [
                                178.67659,
                                -18.05672
                            ],
                            [
                                178.57619,
                                -17.92097
                            ],
                            [
                                178.61802,
                                -17.8603
                            ],
                            [
                                178.58279,
                                -17.79857
                            ],
                            [
                                178.53806,
                                -17.77629
                            ],
                            [
                                178.583,
                                -17.67484
                            ],
                            [
                                178.35227,
                                -17.5094
                            ],
                            [
                                178.33426,
                                -17.45521
                            ],
                            [
                                178.20984,
                                -17.32313
                            ],
                            [
                                178.01116,
                                -17.40003
                            ],
                            [
                                177.90067,
                                -17.42503
                            ],
                            [
                                177.82581,
                                -17.39178
                            ],
                            [
                                177.76176,
                                -17.43644
                            ],
                            [
                                177.62399,
                                -17.45801
                            ],
                            [
                                177.42332,
                                -17.6389
                            ],
                            [
                                177.43809,
                                -17.7581
                            ],
                            [
                                177.37748,
                                -17.77338
                            ],
                            [
                                177.36351,
                                -17.83545
                            ],
                            [
                                177.28421,
                                -17.86174
                            ],
                            [
                                177.25738,
                                -17.95889
                            ],
                            [
                                177.29754,
                                -18.02932
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                178.67394,
                                -16.94392
                            ],
                            [
                                178.71939,
                                -17.00758
                            ],
                            [
                                178.79365,
                                -16.98911
                            ],
                            [
                                178.80855,
                                -16.91576
                            ],
                            [
                                178.87413,
                                -16.86071
                            ],
                            [
                                179.02411,
                                -16.91928
                            ],
                            [
                                179.05688,
                                -16.80666
                            ],
                            [
                                179.2125,
                                -16.70033
                            ],
                            [
                                179.2809,
                                -16.6998
                            ],
                            [
                                179.36061,
                                -16.73821
                            ],
                            [
                                179.37163,
                                -16.79955
                            ],
                            [
                                179.45706,
                                -16.80909
                            ],
                            [
                                179.59813,
                                -16.79461
                            ],
                            [
                                179.71964,
                                -16.71853
                            ],
                            [
                                179.85179,
                                -16.74734
                            ],
                            [
                                179.87273,
                                -16.63124
                            ],
                            [
                                179.93322,
                                -16.48573
                            ],
                            [
                                179.81861,
                                -16.52846
                            ],
                            [
                                179.72044,
                                -16.60965
                            ],
                            [
                                179.69554,
                                -16.65581
                            ],
                            [
                                179.5576,
                                -16.76546
                            ],
                            [
                                179.49063,
                                -16.76754
                            ],
                            [
                                179.47954,
                                -16.70281
                            ],
                            [
                                179.56119,
                                -16.61993
                            ],
                            [
                                179.5834,
                                -16.55127
                            ],
                            [
                                179.73867,
                                -16.45998
                            ],
                            [
                                179.8129,
                                -16.3491
                            ],
                            [
                                179.84539,
                                -16.27483
                            ],
                            [
                                179.91606,
                                -16.2151
                            ],
                            [
                                179.88789,
                                -16.18608
                            ],
                            [
                                179.77077,
                                -16.23439
                            ],
                            [
                                179.73051,
                                -16.19789
                            ],
                            [
                                179.54758,
                                -16.28467
                            ],
                            [
                                179.45766,
                                -16.29468
                            ],
                            [
                                179.40948,
                                -16.36578
                            ],
                            [
                                179.30443,
                                -16.42813
                            ],
                            [
                                179.20676,
                                -16.41111
                            ],
                            [
                                179.03772,
                                -16.47312
                            ],
                            [
                                178.93617,
                                -16.47466
                            ],
                            [
                                178.89458,
                                -16.53954
                            ],
                            [
                                178.70787,
                                -16.65987
                            ],
                            [
                                178.6122,
                                -16.65967
                            ],
                            [
                                178.48502,
                                -16.75795
                            ],
                            [
                                178.49668,
                                -16.81168
                            ],
                            [
                                178.59163,
                                -16.79245
                            ],
                            [
                                178.67394,
                                -16.94392
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                177.96143,
                                -19.12097
                            ],
                            [
                                177.9773,
                                -19.14832
                            ],
                            [
                                178.08935,
                                -19.16553
                            ],
                            [
                                178.15899,
                                -19.12977
                            ],
                            [
                                178.18393,
                                -19.04948
                            ],
                            [
                                178.31067,
                                -19.00542
                            ],
                            [
                                178.3538,
                                -19.05235
                            ],
                            [
                                178.48932,
                                -19.00197
                            ],
                            [
                                178.44735,
                                -18.9582
                            ],
                            [
                                178.31729,
                                -18.93836
                            ],
                            [
                                178.27052,
                                -18.97363
                            ],
                            [
                                178.17955,
                                -18.98421
                            ],
                            [
                                178.16398,
                                -19.05221
                            ],
                            [
                                178.03488,
                                -19.0815
                            ],
                            [
                                177.96143,
                                -19.12097
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -180,
                                -16.79726
                            ],
                            [
                                -180,
                                -16.97275
                            ],
                            [
                                -179.98515,
                                -16.94943
                            ],
                            [
                                -179.87477,
                                -16.87138
                            ],
                            [
                                -179.85139,
                                -16.7545
                            ],
                            [
                                -179.87383,
                                -16.68658
                            ],
                            [
                                -180,
                                -16.79726
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                179.24171,
                                -18.00293
                            ],
                            [
                                179.37126,
                                -18.09608
                            ],
                            [
                                179.34677,
                                -17.99821
                            ],
                            [
                                179.28415,
                                -17.94387
                            ],
                            [
                                179.24171,
                                -18.00293
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                179.89321,
                                -16.95097
                            ],
                            [
                                179.93026,
                                -17.00954
                            ],
                            [
                                179.99999,
                                -16.97276
                            ],
                            [
                                179.95845,
                                -16.88546
                            ],
                            [
                                179.89321,
                                -16.95097
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                179.3524,
                                -17.26218
                            ],
                            [
                                179.38233,
                                -17.36983
                            ],
                            [
                                179.44597,
                                -17.31951
                            ],
                            [
                                179.43596,
                                -17.24974
                            ],
                            [
                                179.3524,
                                -17.26218
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                178.74106,
                                -17.66582
                            ],
                            [
                                178.77847,
                                -17.74784
                            ],
                            [
                                178.83415,
                                -17.7193
                            ],
                            [
                                178.8139,
                                -17.62784
                            ],
                            [
                                178.74106,
                                -17.66582
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -180,
                                -16.4934
                            ],
                            [
                                -180,
                                -16.52888
                            ],
                            [
                                -179.93163,
                                -16.52843
                            ],
                            [
                                -179.93124,
                                -16.45055
                            ],
                            [
                                -180,
                                -16.4934
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "FIN",
                "Country": "Finland",
                "Total_3GHG": 0.22,
                "Total_3GHG_timeseries": [
                    7.5442e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0035,
                    0.0035,
                    0.0035,
                    0.0035
                ],
                "Fossil_3GHG": 0.22,
                "Fossil_3GHG_timeseries": [
                    2.114e-07,
                    4.2673e-07,
                    6.4632e-07,
                    8.6986e-07,
                    1.0974e-06,
                    1.3285e-06,
                    1.5639e-06,
                    1.8038e-06,
                    2.0479e-06,
                    2.3138e-06,
                    2.5993e-06,
                    2.8883e-06,
                    3.1827e-06,
                    3.4666e-06,
                    3.7612e-06,
                    4.059e-06,
                    4.3479e-06,
                    4.6287e-06,
                    4.8847e-06,
                    5.1559e-06,
                    5.4448e-06,
                    5.7329e-06,
                    6.029e-06,
                    6.3531e-06,
                    6.6666e-06,
                    6.9959e-06,
                    7.344e-06,
                    7.7076e-06,
                    8.0573e-06,
                    8.4268e-06,
                    8.8021e-06,
                    9.1938e-06,
                    9.5915e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023
                ],
                "Land_3GHG": 0.21,
                "Land_3GHG_timeseries": [
                    7.3328e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012
                ],
                "Total_CO2": 0.21,
                "Total_CO2_timeseries": [
                    6.5774e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024
                ],
                "Fossil_CO2": 0.19,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.65e-08,
                    4.95e-08,
                    8.25e-08,
                    1.1715e-07,
                    1.386e-07,
                    1.6665e-07,
                    1.98e-07,
                    2.2605e-07,
                    2.6565e-07,
                    2.97e-07,
                    3.3825e-07,
                    3.894e-07,
                    4.3065e-07,
                    4.7025e-07,
                    5.2635e-07,
                    5.643e-07,
                    6.072e-07,
                    6.5835e-07,
                    7.161e-07,
                    7.5075e-07,
                    7.953e-07,
                    8.3985e-07,
                    8.943e-07,
                    9.471e-07,
                    1.0115e-06,
                    1.1105e-06,
                    1.1682e-06,
                    1.226e-06,
                    1.2804e-06,
                    1.353e-06,
                    1.447e-06,
                    1.5461e-06,
                    1.6335e-06,
                    1.721e-06,
                    1.82e-06,
                    1.9256e-06,
                    2.0592e-06,
                    2.2918e-06,
                    2.5113e-06,
                    2.843e-06,
                    3.1136e-06,
                    3.3033e-06,
                    3.4831e-06,
                    3.7141e-06,
                    3.9517e-06,
                    4.2158e-06,
                    4.4929e-06,
                    4.8922e-06,
                    5.5258e-06,
                    6.1033e-06,
                    6.5819e-06,
                    7.1742e-06,
                    7.8424e-06,
                    8.5916e-06,
                    8.9017e-06,
                    8.9496e-06,
                    9.0304e-06,
                    9.0849e-06,
                    9.1179e-06,
                    9.2251e-06,
                    9.3489e-06,
                    9.476e-06,
                    9.796e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015
                ],
                "Land_CO2": 0.25,
                "Land_CO2_timeseries": [
                    6.5774e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009
                ],
                "Total_CH4": 0.21,
                "Total_CH4_timeseries": [
                    7.4075e-07,
                    1.4864e-06,
                    2.2373e-06,
                    2.9932e-06,
                    3.7541e-06,
                    4.5197e-06,
                    5.2908e-06,
                    6.0675e-06,
                    6.8497e-06,
                    7.6385e-06,
                    8.4213e-06,
                    9.1986e-06,
                    9.9706e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009
                ],
                "Fossil_CH4": 0.29,
                "Fossil_CH4_timeseries": [
                    1.291e-07,
                    2.611e-07,
                    3.9633e-07,
                    5.3453e-07,
                    6.7573e-07,
                    8.1966e-07,
                    9.6697e-07,
                    1.118e-06,
                    1.2725e-06,
                    1.4315e-06,
                    1.593e-06,
                    1.7574e-06,
                    1.9249e-06,
                    2.0946e-06,
                    2.2677e-06,
                    2.44e-06,
                    2.6061e-06,
                    2.752e-06,
                    2.8808e-06,
                    3.014e-06,
                    3.1542e-06,
                    3.3018e-06,
                    3.4569e-06,
                    3.6212e-06,
                    3.7902e-06,
                    3.9675e-06,
                    4.1527e-06,
                    4.3445e-06,
                    4.5435e-06,
                    4.7509e-06,
                    4.9632e-06,
                    5.1809e-06,
                    5.4053e-06,
                    5.6389e-06,
                    5.8805e-06,
                    6.13e-06,
                    6.3964e-06,
                    6.6936e-06,
                    7.0191e-06,
                    7.3523e-06,
                    7.6889e-06,
                    8.0385e-06,
                    8.374e-06,
                    8.7305e-06,
                    9.0736e-06,
                    9.4225e-06,
                    9.781e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0007
                ],
                "Land_CH4": 0.07,
                "Land_CH4_timeseries": [
                    6.1166e-07,
                    1.2253e-06,
                    1.841e-06,
                    2.4587e-06,
                    3.0784e-06,
                    3.7001e-06,
                    4.3238e-06,
                    4.9495e-06,
                    5.5772e-06,
                    6.207e-06,
                    6.8283e-06,
                    7.4412e-06,
                    8.0457e-06,
                    8.6417e-06,
                    9.2294e-06,
                    9.8086e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_N2O": 0.34,
                "Total_N2O_timeseries": [
                    2.2603e-07,
                    4.5596e-07,
                    6.8965e-07,
                    9.2692e-07,
                    1.1675e-06,
                    1.4111e-06,
                    1.6573e-06,
                    1.9058e-06,
                    2.1561e-06,
                    2.4076e-06,
                    2.66e-06,
                    2.9133e-06,
                    3.1673e-06,
                    3.422e-06,
                    3.6775e-06,
                    3.9337e-06,
                    4.1906e-06,
                    4.4483e-06,
                    4.7069e-06,
                    4.9664e-06,
                    5.2296e-06,
                    5.5014e-06,
                    5.7854e-06,
                    6.0842e-06,
                    6.3992e-06,
                    6.7309e-06,
                    7.0783e-06,
                    7.4397e-06,
                    7.8122e-06,
                    8.1915e-06,
                    8.575e-06,
                    8.9621e-06,
                    9.3524e-06,
                    9.7454e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_N2O": 0.45,
                "Fossil_N2O_timeseries": [
                    8.2303e-08,
                    1.6564e-07,
                    2.4999e-07,
                    3.3532e-07,
                    4.2162e-07,
                    5.0883e-07,
                    5.969e-07,
                    6.858e-07,
                    7.7544e-07,
                    8.6578e-07,
                    9.5675e-07,
                    1.0484e-06,
                    1.1406e-06,
                    1.2334e-06,
                    1.3269e-06,
                    1.421e-06,
                    1.5157e-06,
                    1.611e-06,
                    1.707e-06,
                    1.8036e-06,
                    1.9012e-06,
                    2.0004e-06,
                    2.1018e-06,
                    2.2056e-06,
                    2.3121e-06,
                    2.4213e-06,
                    2.533e-06,
                    2.6471e-06,
                    2.7631e-06,
                    2.8806e-06,
                    2.9991e-06,
                    3.1186e-06,
                    3.2391e-06,
                    3.3604e-06,
                    3.4826e-06,
                    3.6057e-06,
                    3.7296e-06,
                    3.8543e-06,
                    3.9799e-06,
                    4.1118e-06,
                    4.2458e-06,
                    4.3822e-06,
                    4.5211e-06,
                    4.6625e-06,
                    4.8067e-06,
                    4.9536e-06,
                    5.1035e-06,
                    5.2564e-06,
                    5.4124e-06,
                    5.5715e-06,
                    5.7341e-06,
                    5.9006e-06,
                    6.0712e-06,
                    6.2463e-06,
                    6.4257e-06,
                    6.6096e-06,
                    6.7977e-06,
                    6.9899e-06,
                    7.1856e-06,
                    7.3844e-06,
                    7.5859e-06,
                    7.7898e-06,
                    7.996e-06,
                    8.2043e-06,
                    8.4146e-06,
                    8.6269e-06,
                    8.8414e-06,
                    9.0579e-06,
                    9.2769e-06,
                    9.4984e-06,
                    9.7229e-06,
                    9.9509e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_N2O": 0.3,
                "Land_N2O_timeseries": [
                    1.4372e-07,
                    2.9032e-07,
                    4.3967e-07,
                    5.9159e-07,
                    7.4588e-07,
                    9.0227e-07,
                    1.0604e-06,
                    1.22e-06,
                    1.3806e-06,
                    1.5418e-06,
                    1.7032e-06,
                    1.8649e-06,
                    2.0267e-06,
                    2.1886e-06,
                    2.3506e-06,
                    2.5127e-06,
                    2.6749e-06,
                    2.8373e-06,
                    2.9999e-06,
                    3.1628e-06,
                    3.3284e-06,
                    3.501e-06,
                    3.6836e-06,
                    3.8786e-06,
                    4.0871e-06,
                    4.3096e-06,
                    4.5453e-06,
                    4.7927e-06,
                    5.049e-06,
                    5.3109e-06,
                    5.5759e-06,
                    5.8435e-06,
                    6.1133e-06,
                    6.385e-06,
                    6.6583e-06,
                    6.9333e-06,
                    7.2099e-06,
                    7.4881e-06,
                    7.7683e-06,
                    8.015e-06,
                    8.2963e-06,
                    8.6099e-06,
                    8.9533e-06,
                    9.3236e-06,
                    9.7176e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                28.92968,
                                69.0519
                            ],
                            [
                                28.80628,
                                69.11107
                            ],
                            [
                                28.83217,
                                69.22409
                            ],
                            [
                                29.22032,
                                69.39803
                            ],
                            [
                                29.33593,
                                69.47765
                            ],
                            [
                                29.13254,
                                69.69557
                            ],
                            [
                                28.40418,
                                69.81865
                            ],
                            [
                                28.34536,
                                69.88079
                            ],
                            [
                                28.16107,
                                69.9211
                            ],
                            [
                                27.98464,
                                70.01432
                            ],
                            [
                                27.96056,
                                70.08996
                            ],
                            [
                                27.66927,
                                70.07723
                            ],
                            [
                                27.42676,
                                70.01857
                            ],
                            [
                                27.30524,
                                69.95754
                            ],
                            [
                                26.98692,
                                69.93458
                            ],
                            [
                                26.67652,
                                69.96424
                            ],
                            [
                                26.46678,
                                69.9397
                            ],
                            [
                                26.38556,
                                69.8554
                            ],
                            [
                                26.10873,
                                69.73018
                            ],
                            [
                                25.89971,
                                69.65838
                            ],
                            [
                                25.97623,
                                69.61052
                            ],
                            [
                                25.79696,
                                69.41943
                            ],
                            [
                                25.69309,
                                69.19717
                            ],
                            [
                                25.77717,
                                69.01799
                            ],
                            [
                                25.62719,
                                68.89321
                            ],
                            [
                                25.4807,
                                68.90489
                            ],
                            [
                                25.24372,
                                68.84137
                            ],
                            [
                                25.12195,
                                68.74633
                            ],
                            [
                                25.11586,
                                68.6396
                            ],
                            [
                                24.91875,
                                68.60538
                            ],
                            [
                                24.60752,
                                68.68197
                            ],
                            [
                                24.29653,
                                68.71845
                            ],
                            [
                                23.98335,
                                68.82692
                            ],
                            [
                                23.77541,
                                68.81845
                            ],
                            [
                                23.67334,
                                68.70578
                            ],
                            [
                                23.44031,
                                68.69201
                            ],
                            [
                                23.16901,
                                68.62893
                            ],
                            [
                                23.04562,
                                68.68914
                            ],
                            [
                                22.7989,
                                68.68795
                            ],
                            [
                                22.53534,
                                68.74425
                            ],
                            [
                                22.375,
                                68.71706
                            ],
                            [
                                22.34061,
                                68.82707
                            ],
                            [
                                22.17589,
                                68.95584
                            ],
                            [
                                21.62709,
                                69.27659
                            ],
                            [
                                21.27882,
                                69.31188
                            ],
                            [
                                21.09714,
                                69.26116
                            ],
                            [
                                20.9881,
                                69.19166
                            ],
                            [
                                21.10809,
                                69.1036
                            ],
                            [
                                21.05772,
                                69.03686
                            ],
                            [
                                20.71671,
                                69.1194
                            ],
                            [
                                20.54864,
                                69.05997
                            ],
                            [
                                20.77368,
                                69.03262
                            ],
                            [
                                20.91147,
                                68.96815
                            ],
                            [
                                20.84476,
                                68.93622
                            ],
                            [
                                21.38929,
                                68.76377
                            ],
                            [
                                21.42935,
                                68.69249
                            ],
                            [
                                21.61948,
                                68.66315
                            ],
                            [
                                21.71653,
                                68.59161
                            ],
                            [
                                21.90027,
                                68.5795
                            ],
                            [
                                22.04317,
                                68.48088
                            ],
                            [
                                22.34364,
                                68.48143
                            ],
                            [
                                22.64508,
                                68.41843
                            ],
                            [
                                23.06864,
                                68.29863
                            ],
                            [
                                23.14243,
                                68.24602
                            ],
                            [
                                23.14138,
                                68.15468
                            ],
                            [
                                23.28408,
                                68.1556
                            ],
                            [
                                23.40128,
                                68.04311
                            ],
                            [
                                23.6358,
                                67.96608
                            ],
                            [
                                23.64348,
                                67.91743
                            ],
                            [
                                23.47801,
                                67.84253
                            ],
                            [
                                23.49144,
                                67.66648
                            ],
                            [
                                23.54435,
                                67.58305
                            ],
                            [
                                23.40598,
                                67.5011
                            ],
                            [
                                23.41262,
                                67.46691
                            ],
                            [
                                23.75954,
                                67.43348
                            ],
                            [
                                23.72202,
                                67.2827
                            ],
                            [
                                23.57814,
                                67.26909
                            ],
                            [
                                23.55177,
                                67.17127
                            ],
                            [
                                23.99448,
                                66.8225
                            ],
                            [
                                23.87701,
                                66.75385
                            ],
                            [
                                23.85617,
                                66.55702
                            ],
                            [
                                23.65074,
                                66.45497
                            ],
                            [
                                23.6854,
                                66.37729
                            ],
                            [
                                23.64593,
                                66.30207
                            ],
                            [
                                23.7295,
                                66.19475
                            ],
                            [
                                23.92788,
                                66.15066
                            ],
                            [
                                23.93898,
                                66.07815
                            ],
                            [
                                24.04517,
                                66.00137
                            ],
                            [
                                24.14976,
                                65.86469
                            ],
                            [
                                24.15513,
                                65.81603
                            ],
                            [
                                24.32987,
                                65.79351
                            ],
                            [
                                24.42622,
                                65.74444
                            ],
                            [
                                24.54892,
                                65.74055
                            ],
                            [
                                24.67756,
                                65.65919
                            ],
                            [
                                24.88945,
                                65.66468
                            ],
                            [
                                25.05199,
                                65.62054
                            ],
                            [
                                25.08418,
                                65.57202
                            ],
                            [
                                25.20498,
                                65.56176
                            ],
                            [
                                25.31611,
                                65.48603
                            ],
                            [
                                25.3413,
                                65.42138
                            ],
                            [
                                25.24025,
                                65.3339
                            ],
                            [
                                25.31497,
                                65.29015
                            ],
                            [
                                25.23061,
                                65.12865
                            ],
                            [
                                25.36584,
                                65.10489
                            ],
                            [
                                25.42275,
                                65.03957
                            ],
                            [
                                25.22339,
                                64.94662
                            ],
                            [
                                25.39037,
                                64.89529
                            ],
                            [
                                25.33898,
                                64.83903
                            ],
                            [
                                25.12717,
                                64.91722
                            ],
                            [
                                24.69845,
                                64.86897
                            ],
                            [
                                24.58009,
                                64.78566
                            ],
                            [
                                24.54996,
                                64.72127
                            ],
                            [
                                24.40703,
                                64.6668
                            ],
                            [
                                24.34899,
                                64.53338
                            ],
                            [
                                24.03146,
                                64.41388
                            ],
                            [
                                23.98264,
                                64.35334
                            ],
                            [
                                23.80854,
                                64.23708
                            ],
                            [
                                23.58584,
                                64.11721
                            ],
                            [
                                23.56012,
                                64.04204
                            ],
                            [
                                23.38491,
                                64.063
                            ],
                            [
                                23.40427,
                                63.9411
                            ],
                            [
                                22.95477,
                                63.84563
                            ],
                            [
                                22.93805,
                                63.89122
                            ],
                            [
                                22.73043,
                                63.847
                            ],
                            [
                                22.59376,
                                63.66747
                            ],
                            [
                                22.4597,
                                63.60421
                            ],
                            [
                                22.49799,
                                63.57212
                            ],
                            [
                                22.41445,
                                63.48501
                            ],
                            [
                                22.2046,
                                63.45323
                            ],
                            [
                                22.39067,
                                63.33084
                            ],
                            [
                                22.09274,
                                63.23512
                            ],
                            [
                                21.99044,
                                63.26374
                            ],
                            [
                                21.8168,
                                63.25691
                            ],
                            [
                                21.51941,
                                63.22179
                            ],
                            [
                                21.61271,
                                63.0833
                            ],
                            [
                                21.46659,
                                63.0548
                            ],
                            [
                                21.48759,
                                63.0052
                            ],
                            [
                                21.40129,
                                62.8822
                            ],
                            [
                                21.12411,
                                62.79749
                            ],
                            [
                                21.17483,
                                62.73095
                            ],
                            [
                                21.08261,
                                62.68595
                            ],
                            [
                                21.15736,
                                62.56844
                            ],
                            [
                                21.13293,
                                62.49245
                            ],
                            [
                                21.23856,
                                62.39707
                            ],
                            [
                                21.36006,
                                62.36983
                            ],
                            [
                                21.32214,
                                62.24708
                            ],
                            [
                                21.4128,
                                62.2005
                            ],
                            [
                                21.31296,
                                62.15065
                            ],
                            [
                                21.29245,
                                62.00099
                            ],
                            [
                                21.40463,
                                61.93915
                            ],
                            [
                                21.56998,
                                61.73875
                            ],
                            [
                                21.50019,
                                61.59748
                            ],
                            [
                                21.54089,
                                61.53368
                            ],
                            [
                                21.48934,
                                61.43682
                            ],
                            [
                                21.56405,
                                61.33126
                            ],
                            [
                                21.44367,
                                61.18949
                            ],
                            [
                                21.46866,
                                61.13629
                            ],
                            [
                                21.32271,
                                61.03668
                            ],
                            [
                                21.35288,
                                60.96349
                            ],
                            [
                                21.17938,
                                60.8813
                            ],
                            [
                                21.24882,
                                60.80687
                            ],
                            [
                                21.37815,
                                60.82653
                            ],
                            [
                                21.40063,
                                60.75797
                            ],
                            [
                                21.34629,
                                60.68331
                            ],
                            [
                                21.47968,
                                60.58364
                            ],
                            [
                                21.56711,
                                60.56541
                            ],
                            [
                                21.76603,
                                60.47449
                            ],
                            [
                                21.95718,
                                60.53773
                            ],
                            [
                                22.01464,
                                60.46571
                            ],
                            [
                                22.29658,
                                60.38452
                            ],
                            [
                                22.55403,
                                60.38529
                            ],
                            [
                                22.55163,
                                60.32807
                            ],
                            [
                                22.47313,
                                60.28384
                            ],
                            [
                                22.62381,
                                60.23716
                            ],
                            [
                                22.79338,
                                60.25756
                            ],
                            [
                                22.98894,
                                60.33256
                            ],
                            [
                                23.03157,
                                60.31287
                            ],
                            [
                                22.87345,
                                60.19667
                            ],
                            [
                                22.91223,
                                60.14171
                            ],
                            [
                                23.03166,
                                60.12497
                            ],
                            [
                                22.98931,
                                60.0334
                            ],
                            [
                                22.88012,
                                59.97847
                            ],
                            [
                                22.96536,
                                59.90611
                            ],
                            [
                                23.16341,
                                59.94004
                            ],
                            [
                                23.16031,
                                59.88915
                            ],
                            [
                                23.53544,
                                59.93644
                            ],
                            [
                                23.68846,
                                59.93745
                            ],
                            [
                                23.93343,
                                59.99447
                            ],
                            [
                                23.99799,
                                60.03065
                            ],
                            [
                                24.35951,
                                60.03769
                            ],
                            [
                                24.45694,
                                59.98656
                            ],
                            [
                                24.64741,
                                60.10317
                            ],
                            [
                                24.98308,
                                60.20818
                            ],
                            [
                                25.16822,
                                60.19595
                            ],
                            [
                                25.23226,
                                60.24883
                            ],
                            [
                                25.36189,
                                60.27013
                            ],
                            [
                                25.43699,
                                60.22413
                            ],
                            [
                                25.55246,
                                60.31246
                            ],
                            [
                                25.63723,
                                60.3297
                            ],
                            [
                                25.75336,
                                60.24644
                            ],
                            [
                                25.87459,
                                60.26714
                            ],
                            [
                                25.86626,
                                60.32402
                            ],
                            [
                                25.99303,
                                60.35286
                            ],
                            [
                                26.05402,
                                60.4252
                            ],
                            [
                                26.15517,
                                60.40013
                            ],
                            [
                                26.28275,
                                60.42255
                            ],
                            [
                                26.40319,
                                60.35802
                            ],
                            [
                                26.45364,
                                60.42046
                            ],
                            [
                                26.65877,
                                60.41766
                            ],
                            [
                                26.98815,
                                60.49709
                            ],
                            [
                                27.06495,
                                60.53463
                            ],
                            [
                                27.59424,
                                60.48283
                            ],
                            [
                                27.74173,
                                60.50286
                            ],
                            [
                                27.80357,
                                60.54862
                            ],
                            [
                                27.87349,
                                60.60446
                            ],
                            [
                                28.13488,
                                60.74072
                            ],
                            [
                                28.52405,
                                60.95555
                            ],
                            [
                                28.65564,
                                60.95072
                            ],
                            [
                                28.71513,
                                61.04435
                            ],
                            [
                                28.8197,
                                61.12147
                            ],
                            [
                                29.24365,
                                61.27028
                            ],
                            [
                                29.32498,
                                61.34934
                            ],
                            [
                                29.50236,
                                61.46102
                            ],
                            [
                                29.74073,
                                61.57612
                            ],
                            [
                                29.82001,
                                61.65591
                            ],
                            [
                                30.03728,
                                61.76498
                            ],
                            [
                                30.306,
                                61.96426
                            ],
                            [
                                30.60312,
                                62.1421
                            ],
                            [
                                31.13809,
                                62.44198
                            ],
                            [
                                31.22247,
                                62.49952
                            ],
                            [
                                31.34699,
                                62.643
                            ],
                            [
                                31.43834,
                                62.78352
                            ],
                            [
                                31.58601,
                                62.90847
                            ],
                            [
                                31.46144,
                                63.02497
                            ],
                            [
                                31.2653,
                                63.11565
                            ],
                            [
                                31.23894,
                                63.21813
                            ],
                            [
                                30.78667,
                                63.4054
                            ],
                            [
                                30.48478,
                                63.46662
                            ],
                            [
                                30.3846,
                                63.54527
                            ],
                            [
                                30.24267,
                                63.60802
                            ],
                            [
                                29.97192,
                                63.75717
                            ],
                            [
                                30.26131,
                                63.82331
                            ],
                            [
                                30.32145,
                                63.9098
                            ],
                            [
                                30.52687,
                                64.04786
                            ],
                            [
                                30.5529,
                                64.13233
                            ],
                            [
                                30.46722,
                                64.20381
                            ],
                            [
                                30.48263,
                                64.26172
                            ],
                            [
                                30.04572,
                                64.40174
                            ],
                            [
                                30.05785,
                                64.45159
                            ],
                            [
                                29.9898,
                                64.58715
                            ],
                            [
                                30.13511,
                                64.64944
                            ],
                            [
                                30.04194,
                                64.74013
                            ],
                            [
                                30.04142,
                                64.79275
                            ],
                            [
                                29.74051,
                                64.78993
                            ],
                            [
                                29.64496,
                                64.8668
                            ],
                            [
                                29.59977,
                                64.99508
                            ],
                            [
                                29.62796,
                                65.06072
                            ],
                            [
                                29.73173,
                                65.09089
                            ],
                            [
                                29.89311,
                                65.1933
                            ],
                            [
                                29.60181,
                                65.25994
                            ],
                            [
                                29.7466,
                                65.34741
                            ],
                            [
                                29.73307,
                                65.4725
                            ],
                            [
                                29.86392,
                                65.56045
                            ],
                            [
                                29.72189,
                                65.63709
                            ],
                            [
                                30.01636,
                                65.69615
                            ],
                            [
                                30.13398,
                                65.70002
                            ],
                            [
                                30.06827,
                                65.89527
                            ],
                            [
                                29.99719,
                                65.97937
                            ],
                            [
                                29.92368,
                                66.12643
                            ],
                            [
                                29.71116,
                                66.26713
                            ],
                            [
                                29.5197,
                                66.4961
                            ],
                            [
                                29.35482,
                                66.64108
                            ],
                            [
                                29.11796,
                                66.80159
                            ],
                            [
                                29.03362,
                                66.92462
                            ],
                            [
                                29.07402,
                                66.99661
                            ],
                            [
                                29.51492,
                                67.27962
                            ],
                            [
                                29.52334,
                                67.30969
                            ],
                            [
                                29.71064,
                                67.38964
                            ],
                            [
                                29.93022,
                                67.52253
                            ],
                            [
                                30.01704,
                                67.67356
                            ],
                            [
                                29.6594,
                                67.80296
                            ],
                            [
                                29.32661,
                                68.07446
                            ],
                            [
                                28.64614,
                                68.1963
                            ],
                            [
                                28.43392,
                                68.53967
                            ],
                            [
                                28.70617,
                                68.7322
                            ],
                            [
                                28.80016,
                                68.86872
                            ],
                            [
                                28.47003,
                                68.88548
                            ],
                            [
                                28.49577,
                                68.93013
                            ],
                            [
                                28.92968,
                                69.0519
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                19.91096,
                                60.42198
                            ],
                            [
                                19.7634,
                                60.40415
                            ],
                            [
                                19.87249,
                                60.32892
                            ],
                            [
                                19.88728,
                                60.27348
                            ],
                            [
                                19.79623,
                                60.21965
                            ],
                            [
                                19.72009,
                                60.29551
                            ],
                            [
                                19.6428,
                                60.2971
                            ],
                            [
                                19.73311,
                                60.11592
                            ],
                            [
                                19.76562,
                                60.09143
                            ],
                            [
                                19.96231,
                                60.08454
                            ],
                            [
                                20.08129,
                                60.18763
                            ],
                            [
                                20.2175,
                                60.19884
                            ],
                            [
                                20.2709,
                                60.28307
                            ],
                            [
                                20.1873,
                                60.3438
                            ],
                            [
                                19.98423,
                                60.37497
                            ],
                            [
                                19.91096,
                                60.42198
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                22.9758,
                                60.3143
                            ],
                            [
                                22.84341,
                                60.2383
                            ],
                            [
                                22.45912,
                                60.20322
                            ],
                            [
                                22.48849,
                                60.15834
                            ],
                            [
                                22.36998,
                                60.08988
                            ],
                            [
                                22.39008,
                                60.00389
                            ],
                            [
                                22.58243,
                                60.03597
                            ],
                            [
                                22.66267,
                                59.99721
                            ],
                            [
                                22.78547,
                                60.0305
                            ],
                            [
                                22.77992,
                                60.07879
                            ],
                            [
                                22.87349,
                                60.13521
                            ],
                            [
                                22.83754,
                                60.1787
                            ],
                            [
                                22.9758,
                                60.3143
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                24.88062,
                                65.08534
                            ],
                            [
                                24.64784,
                                65.08172
                            ],
                            [
                                24.55869,
                                65.03835
                            ],
                            [
                                24.65604,
                                64.95975
                            ],
                            [
                                24.76995,
                                64.93538
                            ],
                            [
                                24.87711,
                                64.96819
                            ],
                            [
                                24.8187,
                                65.03954
                            ],
                            [
                                24.88062,
                                65.08534
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                22.4417,
                                60.35017
                            ],
                            [
                                22.10619,
                                60.32585
                            ],
                            [
                                22.11933,
                                60.24005
                            ],
                            [
                                22.19843,
                                60.19678
                            ],
                            [
                                22.40886,
                                60.24862
                            ],
                            [
                                22.50956,
                                60.33639
                            ],
                            [
                                22.4417,
                                60.35017
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                21.16849,
                                63.30348
                            ],
                            [
                                21.08826,
                                63.28377
                            ],
                            [
                                21.1757,
                                63.18545
                            ],
                            [
                                21.2711,
                                63.1587
                            ],
                            [
                                21.4598,
                                63.20762
                            ],
                            [
                                21.38723,
                                63.27967
                            ],
                            [
                                21.26658,
                                63.24137
                            ],
                            [
                                21.16849,
                                63.30348
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                21.87894,
                                60.4797
                            ],
                            [
                                21.82148,
                                60.48397
                            ],
                            [
                                21.82955,
                                60.35884
                            ],
                            [
                                22.04525,
                                60.35564
                            ],
                            [
                                21.87894,
                                60.4797
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                21.28731,
                                60.67036
                            ],
                            [
                                21.22962,
                                60.64261
                            ],
                            [
                                21.33677,
                                60.54336
                            ],
                            [
                                21.43081,
                                60.55596
                            ],
                            [
                                21.28731,
                                60.67036
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                19.64589,
                                60.25024
                            ],
                            [
                                19.53348,
                                60.23261
                            ],
                            [
                                19.51854,
                                60.17686
                            ],
                            [
                                19.668,
                                60.17701
                            ],
                            [
                                19.64589,
                                60.25024
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                20.11165,
                                60.10092
                            ],
                            [
                                20.11681,
                                60.0002
                            ],
                            [
                                20.20096,
                                59.98185
                            ],
                            [
                                20.22071,
                                60.07784
                            ],
                            [
                                20.11165,
                                60.10092
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                21.88783,
                                60.2188
                            ],
                            [
                                21.73097,
                                60.2005
                            ],
                            [
                                21.70025,
                                60.13494
                            ],
                            [
                                21.92452,
                                60.18187
                            ],
                            [
                                21.88783,
                                60.2188
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                22.23022,
                                63.34797
                            ],
                            [
                                21.9982,
                                63.32572
                            ],
                            [
                                21.96964,
                                63.28609
                            ],
                            [
                                22.11459,
                                63.2579
                            ],
                            [
                                22.23768,
                                63.30236
                            ],
                            [
                                22.23022,
                                63.34797
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                21.6738,
                                60.14916
                            ],
                            [
                                21.5805,
                                60.18517
                            ],
                            [
                                21.50068,
                                60.10457
                            ],
                            [
                                21.64235,
                                60.11262
                            ],
                            [
                                21.6738,
                                60.14916
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "FRA",
                "Country": "France",
                "Total_3GHG": 1.31,
                "Total_3GHG_timeseries": [
                    0,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0049,
                    0.0049,
                    0.005,
                    0.005,
                    0.0051,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0053,
                    0.0054,
                    0.0056,
                    0.0057,
                    0.0059,
                    0.006,
                    0.0061,
                    0.0063,
                    0.0065,
                    0.0066,
                    0.0068,
                    0.0069,
                    0.007,
                    0.0071,
                    0.0073,
                    0.0074,
                    0.0076,
                    0.0077,
                    0.0078,
                    0.0079,
                    0.008,
                    0.008,
                    0.008,
                    0.008,
                    0.008,
                    0.0081,
                    0.0081,
                    0.0082,
                    0.0083,
                    0.0084,
                    0.0085,
                    0.0086,
                    0.0087,
                    0.0088,
                    0.0089,
                    0.0091,
                    0.0093,
                    0.0094,
                    0.0096,
                    0.0098,
                    0.01,
                    0.0102,
                    0.0104,
                    0.0107,
                    0.0109,
                    0.0111,
                    0.0114,
                    0.0116,
                    0.0118,
                    0.0121,
                    0.0123,
                    0.0126,
                    0.0129,
                    0.0131,
                    0.0134,
                    0.0136,
                    0.0138,
                    0.0141,
                    0.0144,
                    0.0146,
                    0.0148,
                    0.015,
                    0.0152,
                    0.0154,
                    0.0156,
                    0.0158,
                    0.0159,
                    0.0161,
                    0.0163,
                    0.0164,
                    0.0166,
                    0.0168,
                    0.0169,
                    0.0171,
                    0.0173,
                    0.0174,
                    0.0176,
                    0.0178,
                    0.018,
                    0.0181,
                    0.0183,
                    0.0185,
                    0.0186,
                    0.0188,
                    0.019,
                    0.0191,
                    0.0193,
                    0.0195,
                    0.0196,
                    0.0198,
                    0.02,
                    0.0201,
                    0.0203,
                    0.0204,
                    0.0206,
                    0.0207,
                    0.0208,
                    0.021,
                    0.0211,
                    0.0212,
                    0.0213,
                    0.0215
                ],
                "Fossil_3GHG": 1.89,
                "Fossil_3GHG_timeseries": [
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0046,
                    0.0047,
                    0.0049,
                    0.005,
                    0.0052,
                    0.0053,
                    0.0055,
                    0.0056,
                    0.0058,
                    0.0059,
                    0.0061,
                    0.0062,
                    0.0063,
                    0.0065,
                    0.0066,
                    0.0067,
                    0.0069,
                    0.007,
                    0.0072,
                    0.0072,
                    0.0073,
                    0.0073,
                    0.0074,
                    0.0073,
                    0.0073,
                    0.0074,
                    0.0074,
                    0.0075,
                    0.0076,
                    0.0077,
                    0.0078,
                    0.0079,
                    0.0079,
                    0.008,
                    0.0082,
                    0.0083,
                    0.0084,
                    0.0086,
                    0.0087,
                    0.0088,
                    0.009,
                    0.0092,
                    0.0094,
                    0.0097,
                    0.0099,
                    0.0101,
                    0.0103,
                    0.0105,
                    0.0107,
                    0.0109,
                    0.0111,
                    0.0114,
                    0.0116,
                    0.0119,
                    0.0121,
                    0.0123,
                    0.0125,
                    0.0127,
                    0.0129,
                    0.0132,
                    0.0133,
                    0.0135,
                    0.0137,
                    0.0139,
                    0.014,
                    0.0142,
                    0.0143,
                    0.0145,
                    0.0146,
                    0.0148,
                    0.0149,
                    0.0151,
                    0.0153,
                    0.0154,
                    0.0156,
                    0.0158,
                    0.016,
                    0.0162,
                    0.0163,
                    0.0165,
                    0.0167,
                    0.0169,
                    0.0171,
                    0.0172,
                    0.0174,
                    0.0176,
                    0.0178,
                    0.018,
                    0.0181,
                    0.0183,
                    0.0185,
                    0.0186,
                    0.0188,
                    0.0189,
                    0.0191,
                    0.0192,
                    0.0194,
                    0.0195,
                    0.0196,
                    0.0198,
                    0.0199,
                    0.02
                ],
                "Land_3GHG": 0.24,
                "Land_3GHG_timeseries": [
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0014,
                    0.0014,
                    0.0014
                ],
                "Total_CO2": 1.45,
                "Total_CO2_timeseries": [
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0056,
                    0.0057,
                    0.0058,
                    0.0059,
                    0.006,
                    0.0062,
                    0.0063,
                    0.0065,
                    0.0066,
                    0.0068,
                    0.007,
                    0.0071,
                    0.0073,
                    0.0075,
                    0.0077,
                    0.0079,
                    0.0082,
                    0.0084,
                    0.0086,
                    0.0088,
                    0.009,
                    0.0092,
                    0.0095,
                    0.0097,
                    0.0099,
                    0.0101,
                    0.0103,
                    0.0104,
                    0.0106,
                    0.0108,
                    0.0109,
                    0.0111,
                    0.0113,
                    0.0115,
                    0.0116,
                    0.0118,
                    0.012,
                    0.0121,
                    0.0123,
                    0.0125,
                    0.0127,
                    0.0128,
                    0.013,
                    0.0132,
                    0.0134,
                    0.0135,
                    0.0137,
                    0.0139,
                    0.0141,
                    0.0142,
                    0.0144,
                    0.0146,
                    0.0147,
                    0.0149,
                    0.015,
                    0.0152,
                    0.0153,
                    0.0154,
                    0.0156,
                    0.0157,
                    0.0159,
                    0.016,
                    0.0161,
                    0.0162,
                    0.0164,
                    0.0165
                ],
                "Fossil_CO2": 2.26,
                "Fossil_CO2_timeseries": [
                    9.0239e-06,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0046,
                    0.0047,
                    0.0047,
                    0.0048,
                    0.0048,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0055,
                    0.0056,
                    0.0057,
                    0.0058,
                    0.006,
                    0.0061,
                    0.0062,
                    0.0063,
                    0.0065,
                    0.0066,
                    0.0068,
                    0.0069,
                    0.0071,
                    0.0073,
                    0.0075,
                    0.0076,
                    0.0078,
                    0.008,
                    0.0083,
                    0.0085,
                    0.0087,
                    0.009,
                    0.0092,
                    0.0094,
                    0.0097,
                    0.0099,
                    0.0101,
                    0.0104,
                    0.0106,
                    0.0108,
                    0.011,
                    0.0112,
                    0.0113,
                    0.0115,
                    0.0117,
                    0.0119,
                    0.012,
                    0.0122,
                    0.0124,
                    0.0126,
                    0.0128,
                    0.0129,
                    0.0131,
                    0.0133,
                    0.0135,
                    0.0137,
                    0.0138,
                    0.014,
                    0.0142,
                    0.0144,
                    0.0146,
                    0.0148,
                    0.0149,
                    0.0151,
                    0.0153,
                    0.0155,
                    0.0157,
                    0.0158,
                    0.016,
                    0.0161,
                    0.0163,
                    0.0165,
                    0.0166,
                    0.0168,
                    0.0169,
                    0.017,
                    0.0172,
                    0.0173,
                    0.0175,
                    0.0176
                ],
                "Land_CO2": -0.31,
                "Land_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0,
                    0,
                    0,
                    2.2342e-06,
                    -0.0000087996,
                    0,
                    0,
                    0,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0008,
                    -0.0008,
                    -0.0008,
                    -0.0008,
                    -0.0008,
                    -0.0008,
                    -0.0008,
                    -0.0008,
                    -0.0008,
                    -0.0008,
                    -0.0008,
                    -0.0008,
                    -0.0008,
                    -0.0008,
                    -0.0009,
                    -0.0009,
                    -0.0009,
                    -0.0009,
                    -0.0009,
                    -0.0009,
                    -0.0009,
                    -0.0009,
                    -0.001,
                    -0.001,
                    -0.001,
                    -0.001,
                    -0.001,
                    -0.001,
                    -0.001,
                    -0.001,
                    -0.0011,
                    -0.0011,
                    -0.0011,
                    -0.0011,
                    -0.0011
                ],
                "Total_CH4": 0.71,
                "Total_CH4_timeseries": [
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0033,
                    0.0033,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0035,
                    0.0035,
                    0.0035,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0033,
                    0.0033,
                    0.0033,
                    0.0033,
                    0.0033,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.003,
                    0.003,
                    0.003
                ],
                "Fossil_CH4": 0.61,
                "Fossil_CH4_timeseries": [
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0025,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.002,
                    0.002,
                    0.002,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016
                ],
                "Land_CH4": 0.89,
                "Land_CH4_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014
                ],
                "Total_N2O": 2.39,
                "Total_N2O_timeseries": [
                    1.3949e-06,
                    2.8124e-06,
                    4.2516e-06,
                    5.7117e-06,
                    7.1911e-06,
                    8.6885e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002
                ],
                "Fossil_N2O": 3.68,
                "Fossil_N2O_timeseries": [
                    6.8752e-07,
                    1.3834e-06,
                    2.0876e-06,
                    2.7999e-06,
                    3.5199e-06,
                    4.2476e-06,
                    4.9824e-06,
                    5.7241e-06,
                    6.4721e-06,
                    7.2259e-06,
                    7.9853e-06,
                    8.7502e-06,
                    9.5205e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008
                ],
                "Land_N2O": 1.89,
                "Land_N2O_timeseries": [
                    7.074e-07,
                    1.4289e-06,
                    2.164e-06,
                    2.9118e-06,
                    3.6712e-06,
                    4.4409e-06,
                    5.2194e-06,
                    6.0049e-06,
                    6.7954e-06,
                    7.5887e-06,
                    8.3833e-06,
                    9.1789e-06,
                    9.9753e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                5.81812,
                                49.54631
                            ],
                            [
                                5.70124,
                                49.53955
                            ],
                            [
                                5.47663,
                                49.49904
                            ],
                            [
                                5.43094,
                                49.59241
                            ],
                            [
                                5.26717,
                                49.69583
                            ],
                            [
                                5.16617,
                                49.69294
                            ],
                            [
                                5.09657,
                                49.75981
                            ],
                            [
                                4.99626,
                                49.80018
                            ],
                            [
                                4.86171,
                                49.78929
                            ],
                            [
                                4.88905,
                                49.9093
                            ],
                            [
                                4.79087,
                                49.95842
                            ],
                            [
                                4.87692,
                                50.1535
                            ],
                            [
                                4.80565,
                                50.15313
                            ],
                            [
                                4.70145,
                                50.09452
                            ],
                            [
                                4.68565,
                                50.00775
                            ],
                            [
                                4.44576,
                                49.93718
                            ],
                            [
                                4.31041,
                                49.9684
                            ],
                            [
                                4.20661,
                                49.95744
                            ],
                            [
                                4.13743,
                                50.02177
                            ],
                            [
                                4.2275,
                                50.07968
                            ],
                            [
                                4.15348,
                                50.16092
                            ],
                            [
                                4.22137,
                                50.25568
                            ],
                            [
                                4.13581,
                                50.27362
                            ],
                            [
                                4.03757,
                                50.34291
                            ],
                            [
                                3.90343,
                                50.32769
                            ],
                            [
                                3.85259,
                                50.35131
                            ],
                            [
                                3.67363,
                                50.33491
                            ],
                            [
                                3.66339,
                                50.45396
                            ],
                            [
                                3.6067,
                                50.49666
                            ],
                            [
                                3.43941,
                                50.50722
                            ],
                            [
                                3.37723,
                                50.49097
                            ],
                            [
                                3.28649,
                                50.52757
                            ],
                            [
                                3.24523,
                                50.64054
                            ],
                            [
                                3.2604,
                                50.70103
                            ],
                            [
                                3.19291,
                                50.72454
                            ],
                            [
                                3.15017,
                                50.7897
                            ],
                            [
                                2.9401,
                                50.74535
                            ],
                            [
                                2.9004,
                                50.69327
                            ],
                            [
                                2.78279,
                                50.75051
                            ],
                            [
                                2.7082,
                                50.81351
                            ],
                            [
                                2.63495,
                                50.81274
                            ],
                            [
                                2.54601,
                                51.08938
                            ],
                            [
                                2.37138,
                                51.04471
                            ],
                            [
                                1.91231,
                                50.98275
                            ],
                            [
                                1.72659,
                                50.93721
                            ],
                            [
                                1.58169,
                                50.8691
                            ],
                            [
                                1.60377,
                                50.80185
                            ],
                            [
                                1.56226,
                                50.69218
                            ],
                            [
                                1.58434,
                                50.53478
                            ],
                            [
                                1.53823,
                                50.28104
                            ],
                            [
                                1.54278,
                                50.21332
                            ],
                            [
                                1.44339,
                                50.10072
                            ],
                            [
                                1.20474,
                                49.9732
                            ],
                            [
                                1.02573,
                                49.9166
                            ],
                            [
                                0.76389,
                                49.87164
                            ],
                            [
                                0.58248,
                                49.85234
                            ],
                            [
                                0.32378,
                                49.74228
                            ],
                            [
                                0.20644,
                                49.71367
                            ],
                            [
                                0.07785,
                                49.54011
                            ],
                            [
                                0.12286,
                                49.46474
                            ],
                            [
                                0.11112,
                                49.39468
                            ],
                            [
                                0.04311,
                                49.347
                            ],
                            [
                                -0.10468,
                                49.29596
                            ],
                            [
                                -0.20755,
                                49.2861
                            ],
                            [
                                -0.39747,
                                49.33336
                            ],
                            [
                                -0.82729,
                                49.35797
                            ],
                            [
                                -0.92535,
                                49.39245
                            ],
                            [
                                -1.07929,
                                49.38777
                            ],
                            [
                                -1.11784,
                                49.36032
                            ],
                            [
                                -1.3065,
                                49.53897
                            ],
                            [
                                -1.23964,
                                49.6538
                            ],
                            [
                                -1.29983,
                                49.69369
                            ],
                            [
                                -1.43587,
                                49.70041
                            ],
                            [
                                -1.52126,
                                49.65729
                            ],
                            [
                                -1.62422,
                                49.64599
                            ],
                            [
                                -1.94158,
                                49.72539
                            ],
                            [
                                -1.94582,
                                49.67581
                            ],
                            [
                                -1.8603,
                                49.64916
                            ],
                            [
                                -1.85107,
                                49.50868
                            ],
                            [
                                -1.824,
                                49.40317
                            ],
                            [
                                -1.70758,
                                49.31948
                            ],
                            [
                                -1.59501,
                                49.13056
                            ],
                            [
                                -1.60953,
                                49.10237
                            ],
                            [
                                -1.56133,
                                48.94024
                            ],
                            [
                                -1.59185,
                                48.83259
                            ],
                            [
                                -1.5704,
                                48.74331
                            ],
                            [
                                -1.44875,
                                48.62371
                            ],
                            [
                                -1.54946,
                                48.63026
                            ],
                            [
                                -1.77441,
                                48.60371
                            ],
                            [
                                -1.84207,
                                48.61463
                            ],
                            [
                                -1.87472,
                                48.69558
                            ],
                            [
                                -2.13217,
                                48.63786
                            ],
                            [
                                -2.20575,
                                48.57957
                            ],
                            [
                                -2.28606,
                                48.66663
                            ],
                            [
                                -2.32898,
                                48.67269
                            ],
                            [
                                -2.55427,
                                48.59089
                            ],
                            [
                                -2.65561,
                                48.52557
                            ],
                            [
                                -2.82442,
                                48.59887
                            ],
                            [
                                -2.82735,
                                48.6553
                            ],
                            [
                                -2.92435,
                                48.70733
                            ],
                            [
                                -3.01944,
                                48.822
                            ],
                            [
                                -3.12784,
                                48.86458
                            ],
                            [
                                -3.20395,
                                48.83496
                            ],
                            [
                                -3.32103,
                                48.83779
                            ],
                            [
                                -3.43177,
                                48.7975
                            ],
                            [
                                -3.51227,
                                48.83417
                            ],
                            [
                                -3.58544,
                                48.77791
                            ],
                            [
                                -3.5497,
                                48.74565
                            ],
                            [
                                -3.6165,
                                48.68305
                            ],
                            [
                                -3.8157,
                                48.7154
                            ],
                            [
                                -3.84668,
                                48.6302
                            ],
                            [
                                -3.94117,
                                48.65797
                            ],
                            [
                                -3.99207,
                                48.72301
                            ],
                            [
                                -4.18674,
                                48.6861
                            ],
                            [
                                -4.27497,
                                48.64914
                            ],
                            [
                                -4.34912,
                                48.67638
                            ],
                            [
                                -4.46278,
                                48.6271
                            ],
                            [
                                -4.60013,
                                48.60616
                            ],
                            [
                                -4.70204,
                                48.56945
                            ],
                            [
                                -4.77782,
                                48.5042
                            ],
                            [
                                -4.7948,
                                48.41421
                            ],
                            [
                                -4.77507,
                                48.33672
                            ],
                            [
                                -4.6278,
                                48.33813
                            ],
                            [
                                -4.43369,
                                48.39595
                            ],
                            [
                                -4.45128,
                                48.32893
                            ],
                            [
                                -4.31413,
                                48.3353
                            ],
                            [
                                -4.36723,
                                48.27781
                            ],
                            [
                                -4.46121,
                                48.2938
                            ],
                            [
                                -4.61281,
                                48.28105
                            ],
                            [
                                -4.55038,
                                48.19573
                            ],
                            [
                                -4.46478,
                                48.23895
                            ],
                            [
                                -4.30339,
                                48.19484
                            ],
                            [
                                -4.28719,
                                48.10284
                            ],
                            [
                                -4.41574,
                                48.10651
                            ],
                            [
                                -4.67368,
                                48.06151
                            ],
                            [
                                -4.42273,
                                47.9621
                            ],
                            [
                                -4.36279,
                                47.88905
                            ],
                            [
                                -4.37295,
                                47.79784
                            ],
                            [
                                -4.19332,
                                47.79653
                            ],
                            [
                                -4.11433,
                                47.86969
                            ],
                            [
                                -4.03996,
                                47.84545
                            ],
                            [
                                -3.95412,
                                47.89495
                            ],
                            [
                                -3.85518,
                                47.80367
                            ],
                            [
                                -3.73253,
                                47.80456
                            ],
                            [
                                -3.68058,
                                47.77684
                            ],
                            [
                                -3.53192,
                                47.76927
                            ],
                            [
                                -3.45022,
                                47.6965
                            ],
                            [
                                -3.36817,
                                47.71577
                            ],
                            [
                                -3.21754,
                                47.66682
                            ],
                            [
                                -3.197,
                                47.62376
                            ],
                            [
                                -3.10345,
                                47.58373
                            ],
                            [
                                -2.93879,
                                47.55459
                            ],
                            [
                                -2.9213,
                                47.58445
                            ],
                            [
                                -2.75727,
                                47.63041
                            ],
                            [
                                -2.73397,
                                47.55256
                            ],
                            [
                                -2.87068,
                                47.55021
                            ],
                            [
                                -2.84947,
                                47.49899
                            ],
                            [
                                -2.68474,
                                47.49648
                            ],
                            [
                                -2.61264,
                                47.5414
                            ],
                            [
                                -2.46694,
                                47.51176
                            ],
                            [
                                -2.44626,
                                47.43644
                            ],
                            [
                                -2.55181,
                                47.3695
                            ],
                            [
                                -2.54403,
                                47.29008
                            ],
                            [
                                -2.43114,
                                47.25866
                            ],
                            [
                                -2.35762,
                                47.27269
                            ],
                            [
                                -2.29673,
                                47.23442
                            ],
                            [
                                -2.18052,
                                47.23413
                            ],
                            [
                                -2.16681,
                                47.16759
                            ],
                            [
                                -2.24638,
                                47.13479
                            ],
                            [
                                -2.05355,
                                47.09454
                            ],
                            [
                                -1.98362,
                                47.02946
                            ],
                            [
                                -2.05814,
                                46.95131
                            ],
                            [
                                -2.15447,
                                46.88917
                            ],
                            [
                                -2.14192,
                                46.81901
                            ],
                            [
                                -1.94399,
                                46.69323
                            ],
                            [
                                -1.85684,
                                46.60918
                            ],
                            [
                                -1.81181,
                                46.49356
                            ],
                            [
                                -1.62278,
                                46.41318
                            ],
                            [
                                -1.50074,
                                46.39591
                            ],
                            [
                                -1.47094,
                                46.34628
                            ],
                            [
                                -1.36101,
                                46.34795
                            ],
                            [
                                -1.2064,
                                46.2669
                            ],
                            [
                                -1.11144,
                                46.26126
                            ],
                            [
                                -1.21855,
                                46.17933
                            ],
                            [
                                -1.12817,
                                46.12588
                            ],
                            [
                                -1.05325,
                                46.00387
                            ],
                            [
                                -1.07485,
                                45.9106
                            ],
                            [
                                -1.15236,
                                45.86134
                            ],
                            [
                                -1.13324,
                                45.79681
                            ],
                            [
                                -1.23661,
                                45.78805
                            ],
                            [
                                -1.23633,
                                45.69686
                            ],
                            [
                                -0.99459,
                                45.59785
                            ],
                            [
                                -0.77375,
                                45.44921
                            ],
                            [
                                -0.69904,
                                45.28502
                            ],
                            [
                                -0.74732,
                                45.20572
                            ],
                            [
                                -0.80352,
                                45.34418
                            ],
                            [
                                -0.93362,
                                45.44036
                            ],
                            [
                                -1.06059,
                                45.50743
                            ],
                            [
                                -1.15456,
                                45.48068
                            ],
                            [
                                -1.16451,
                                45.28507
                            ],
                            [
                                -1.20271,
                                44.99996
                            ],
                            [
                                -1.22323,
                                44.70892
                            ],
                            [
                                -1.14943,
                                44.76311
                            ],
                            [
                                -1.03693,
                                44.69405
                            ],
                            [
                                -1.09374,
                                44.64194
                            ],
                            [
                                -1.19433,
                                44.65781
                            ],
                            [
                                -1.25943,
                                44.54417
                            ],
                            [
                                -1.25097,
                                44.50496
                            ],
                            [
                                -1.31634,
                                44.12883
                            ],
                            [
                                -1.46031,
                                43.61984
                            ],
                            [
                                -1.59717,
                                43.43604
                            ],
                            [
                                -1.76296,
                                43.37572
                            ],
                            [
                                -1.78598,
                                43.35048
                            ],
                            [
                                -1.7289,
                                43.29609
                            ],
                            [
                                -1.66629,
                                43.31418
                            ],
                            [
                                -1.57477,
                                43.25042
                            ],
                            [
                                -1.53544,
                                43.29435
                            ],
                            [
                                -1.38451,
                                43.25337
                            ],
                            [
                                -1.38235,
                                43.18902
                            ],
                            [
                                -1.4719,
                                43.08126
                            ],
                            [
                                -1.35373,
                                43.02798
                            ],
                            [
                                -1.34563,
                                43.092
                            ],
                            [
                                -1.24777,
                                43.0429
                            ],
                            [
                                -1.1147,
                                43.02313
                            ],
                            [
                                -0.94518,
                                42.95384
                            ],
                            [
                                -0.75354,
                                42.96733
                            ],
                            [
                                -0.73232,
                                42.89744
                            ],
                            [
                                -0.679,
                                42.88383
                            ],
                            [
                                -0.57514,
                                42.80778
                            ],
                            [
                                -0.51018,
                                42.82502
                            ],
                            [
                                -0.3943,
                                42.79961
                            ],
                            [
                                -0.27811,
                                42.83581
                            ],
                            [
                                -0.15466,
                                42.78212
                            ],
                            [
                                -0.06158,
                                42.69468
                            ],
                            [
                                -0.01009,
                                42.68477
                            ],
                            [
                                0.1769,
                                42.73652
                            ],
                            [
                                0.25991,
                                42.71601
                            ],
                            [
                                0.36013,
                                42.72435
                            ],
                            [
                                0.43631,
                                42.6897
                            ],
                            [
                                0.52637,
                                42.70252
                            ],
                            [
                                0.66948,
                                42.68959
                            ],
                            [
                                0.66254,
                                42.84124
                            ],
                            [
                                0.70843,
                                42.86125
                            ],
                            [
                                1.07207,
                                42.7828
                            ],
                            [
                                1.17077,
                                42.70814
                            ],
                            [
                                1.3573,
                                42.71942
                            ],
                            [
                                1.44257,
                                42.60367
                            ],
                            [
                                1.47935,
                                42.65092
                            ],
                            [
                                1.73788,
                                42.61152
                            ],
                            [
                                1.7258,
                                42.5044
                            ],
                            [
                                1.94286,
                                42.44443
                            ],
                            [
                                2.01171,
                                42.3527
                            ],
                            [
                                2.1154,
                                42.38292
                            ],
                            [
                                2.13309,
                                42.41455
                            ],
                            [
                                2.25711,
                                42.43867
                            ],
                            [
                                2.43188,
                                42.39359
                            ],
                            [
                                2.48271,
                                42.34035
                            ],
                            [
                                2.65427,
                                42.38602
                            ],
                            [
                                2.84002,
                                42.45875
                            ],
                            [
                                3.0402,
                                42.47353
                            ],
                            [
                                3.08597,
                                42.42578
                            ],
                            [
                                3.1748,
                                42.43537
                            ],
                            [
                                3.13671,
                                42.51634
                            ],
                            [
                                3.0512,
                                42.54593
                            ],
                            [
                                3.0357,
                                42.64076
                            ],
                            [
                                3.04288,
                                42.96015
                            ],
                            [
                                3.08445,
                                43.05619
                            ],
                            [
                                3.14379,
                                43.1323
                            ],
                            [
                                3.27112,
                                43.23378
                            ],
                            [
                                3.42897,
                                43.29018
                            ],
                            [
                                3.51549,
                                43.27565
                            ],
                            [
                                3.65287,
                                43.38822
                            ],
                            [
                                3.79589,
                                43.44074
                            ],
                            [
                                3.90798,
                                43.5171
                            ],
                            [
                                4.00621,
                                43.5514
                            ],
                            [
                                4.10108,
                                43.55471
                            ],
                            [
                                4.16562,
                                43.47196
                            ],
                            [
                                4.42139,
                                43.44804
                            ],
                            [
                                4.54718,
                                43.44858
                            ],
                            [
                                4.59385,
                                43.35644
                            ],
                            [
                                4.77328,
                                43.34891
                            ],
                            [
                                4.85044,
                                43.39846
                            ],
                            [
                                4.96307,
                                43.42661
                            ],
                            [
                                5.05221,
                                43.32504
                            ],
                            [
                                5.22202,
                                43.32834
                            ],
                            [
                                5.31371,
                                43.3589
                            ],
                            [
                                5.40444,
                                43.2119
                            ],
                            [
                                5.57227,
                                43.17321
                            ],
                            [
                                5.62343,
                                43.18642
                            ],
                            [
                                5.77254,
                                43.11725
                            ],
                            [
                                5.86033,
                                43.04846
                            ],
                            [
                                5.90854,
                                43.09429
                            ],
                            [
                                6.00723,
                                43.10337
                            ],
                            [
                                6.12504,
                                43.07765
                            ],
                            [
                                6.19943,
                                43.11486
                            ],
                            [
                                6.36816,
                                43.13597
                            ],
                            [
                                6.54183,
                                43.18238
                            ],
                            [
                                6.64348,
                                43.18678
                            ],
                            [
                                6.66452,
                                43.26529
                            ],
                            [
                                6.748,
                                43.41928
                            ],
                            [
                                6.85525,
                                43.41158
                            ],
                            [
                                6.91992,
                                43.44956
                            ],
                            [
                                6.95991,
                                43.5403
                            ],
                            [
                                7.0414,
                                43.54104
                            ],
                            [
                                7.12583,
                                43.57414
                            ],
                            [
                                7.13753,
                                43.63575
                            ],
                            [
                                7.26095,
                                43.69416
                            ],
                            [
                                7.419602937661709,
                                43.725346905646397
                            ],
                            [
                                7.52983,
                                43.78401
                            ],
                            [
                                7.49819,
                                43.87084
                            ],
                            [
                                7.55955,
                                43.8974
                            ],
                            [
                                7.58747,
                                43.95479
                            ],
                            [
                                7.65161,
                                43.97418
                            ],
                            [
                                7.7176,
                                44.08282
                            ],
                            [
                                7.67124,
                                44.15665
                            ],
                            [
                                7.57122,
                                44.15268
                            ],
                            [
                                7.35825,
                                44.11682
                            ],
                            [
                                7.26237,
                                44.14816
                            ],
                            [
                                7.16334,
                                44.2075
                            ],
                            [
                                7.00805,
                                44.23621
                            ],
                            [
                                6.89655,
                                44.37528
                            ],
                            [
                                6.85389,
                                44.52808
                            ],
                            [
                                6.93259,
                                44.57397
                            ],
                            [
                                6.94844,
                                44.65474
                            ],
                            [
                                7.03054,
                                44.72945
                            ],
                            [
                                7.02415,
                                44.82304
                            ],
                            [
                                6.93137,
                                44.86368
                            ],
                            [
                                6.86409,
                                44.85068
                            ],
                            [
                                6.74952,
                                44.92299
                            ],
                            [
                                6.76362,
                                44.97018
                            ],
                            [
                                6.67293,
                                45.02088
                            ],
                            [
                                6.62743,
                                45.10254
                            ],
                            [
                                6.76826,
                                45.15944
                            ],
                            [
                                6.85222,
                                45.12776
                            ],
                            [
                                7.00237,
                                45.21977
                            ],
                            [
                                7.13601,
                                45.25499
                            ],
                            [
                                7.10984,
                                45.32694
                            ],
                            [
                                7.18404,
                                45.40691
                            ],
                            [
                                7.10472,
                                45.46845
                            ],
                            [
                                7.00002,
                                45.50467
                            ],
                            [
                                6.99953,
                                45.63947
                            ],
                            [
                                6.93093,
                                45.64632
                            ],
                            [
                                6.80908,
                                45.7254
                            ],
                            [
                                6.81959,
                                45.8362
                            ],
                            [
                                6.91339,
                                45.84135
                            ],
                            [
                                6.99831,
                                45.87353
                            ],
                            [
                                7.04489,
                                45.92241
                            ],
                            [
                                6.94974,
                                46.05173
                            ],
                            [
                                6.79827,
                                46.13709
                            ],
                            [
                                6.80356,
                                46.20314
                            ],
                            [
                                6.86418,
                                46.28032
                            ],
                            [
                                6.77076,
                                46.35474
                            ],
                            [
                                6.82106,
                                46.42715
                            ],
                            [
                                6.68186,
                                46.45433
                            ],
                            [
                                6.5191,
                                46.45637
                            ],
                            [
                                6.33519,
                                46.40372
                            ],
                            [
                                6.21955,
                                46.31188
                            ],
                            [
                                6.29446,
                                46.22493
                            ],
                            [
                                6.12662,
                                46.14047
                            ],
                            [
                                5.96514,
                                46.1452
                            ],
                            [
                                6.03372,
                                46.23843
                            ],
                            [
                                6.17014,
                                46.36644
                            ],
                            [
                                6.09682,
                                46.40875
                            ],
                            [
                                6.07358,
                                46.46527
                            ],
                            [
                                6.15646,
                                46.54526
                            ],
                            [
                                6.11096,
                                46.57666
                            ],
                            [
                                6.35242,
                                46.71514
                            ],
                            [
                                6.43463,
                                46.80204
                            ],
                            [
                                6.46393,
                                46.89098
                            ],
                            [
                                6.43275,
                                46.92846
                            ],
                            [
                                6.64216,
                                47.0048
                            ],
                            [
                                6.70426,
                                47.08194
                            ],
                            [
                                6.95514,
                                47.24317
                            ],
                            [
                                6.94714,
                                47.29089
                            ],
                            [
                                7.04618,
                                47.32728
                            ],
                            [
                                7.01234,
                                47.37279
                            ],
                            [
                                6.92108,
                                47.35564
                            ],
                            [
                                6.98291,
                                47.49427
                            ],
                            [
                                7.19119,
                                47.48768
                            ],
                            [
                                7.17042,
                                47.44345
                            ],
                            [
                                7.38089,
                                47.43189
                            ],
                            [
                                7.50996,
                                47.49683
                            ],
                            [
                                7.50789,
                                47.54476
                            ],
                            [
                                7.58904,
                                47.58988
                            ],
                            [
                                7.52108,
                                47.66385
                            ],
                            [
                                7.55546,
                                47.87051
                            ],
                            [
                                7.62165,
                                47.97651
                            ],
                            [
                                7.56885,
                                48.03561
                            ],
                            [
                                7.57792,
                                48.12139
                            ],
                            [
                                7.6651,
                                48.22015
                            ],
                            [
                                7.80086,
                                48.58545
                            ],
                            [
                                7.8481,
                                48.64691
                            ],
                            [
                                7.95963,
                                48.71858
                            ],
                            [
                                7.97362,
                                48.75881
                            ],
                            [
                                8.10383,
                                48.82012
                            ],
                            [
                                8.14655,
                                48.90229
                            ],
                            [
                                8.2237,
                                48.97534
                            ],
                            [
                                8.0705,
                                48.99682
                            ],
                            [
                                7.93351,
                                49.05758
                            ],
                            [
                                7.86737,
                                49.03301
                            ],
                            [
                                7.79572,
                                49.06509
                            ],
                            [
                                7.67347,
                                49.0454
                            ],
                            [
                                7.52868,
                                49.09709
                            ],
                            [
                                7.4363,
                                49.1795
                            ],
                            [
                                7.29318,
                                49.11491
                            ],
                            [
                                7.15875,
                                49.12063
                            ],
                            [
                                6.92252,
                                49.22306
                            ],
                            [
                                6.8603,
                                49.22245
                            ],
                            [
                                6.83457,
                                49.15131
                            ],
                            [
                                6.73833,
                                49.16415
                            ],
                            [
                                6.66897,
                                49.27997
                            ],
                            [
                                6.56563,
                                49.34859
                            ],
                            [
                                6.55699,
                                49.41921
                            ],
                            [
                                6.46495,
                                49.46549
                            ],
                            [
                                6.36711,
                                49.46951
                            ],
                            [
                                6.25518,
                                49.50922
                            ],
                            [
                                5.98582,
                                49.45617
                            ],
                            [
                                5.86641,
                                49.50029
                            ],
                            [
                                5.81812,
                                49.54631
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -51.65546,
                                4.05599
                            ],
                            [
                                -51.6342,
                                4.2013
                            ],
                            [
                                -51.70227,
                                4.29579
                            ],
                            [
                                -51.71178,
                                4.38889
                            ],
                            [
                                -51.75215,
                                4.41924
                            ],
                            [
                                -51.79791,
                                4.61126
                            ],
                            [
                                -51.86429,
                                4.67179
                            ],
                            [
                                -51.91812,
                                4.6697
                            ],
                            [
                                -52.00457,
                                4.70134
                            ],
                            [
                                -52.11049,
                                4.78435
                            ],
                            [
                                -52.22819,
                                4.85983
                            ],
                            [
                                -52.30134,
                                4.95022
                            ],
                            [
                                -52.35693,
                                4.91883
                            ],
                            [
                                -52.55774,
                                5.10601
                            ],
                            [
                                -52.63052,
                                5.14855
                            ],
                            [
                                -52.85553,
                                5.37721
                            ],
                            [
                                -52.95482,
                                5.45512
                            ],
                            [
                                -53.07233,
                                5.46816
                            ],
                            [
                                -53.13052,
                                5.50721
                            ],
                            [
                                -53.2589,
                                5.54836
                            ],
                            [
                                -53.3159,
                                5.53965
                            ],
                            [
                                -53.46936,
                                5.56525
                            ],
                            [
                                -53.62942,
                                5.6324
                            ],
                            [
                                -53.78947,
                                5.71973
                            ],
                            [
                                -53.96837,
                                5.74518
                            ],
                            [
                                -54.01197,
                                5.66349
                            ],
                            [
                                -54.00565,
                                5.60254
                            ],
                            [
                                -54.01813,
                                5.52295
                            ],
                            [
                                -54.11733,
                                5.41725
                            ],
                            [
                                -54.18335,
                                5.32468
                            ],
                            [
                                -54.27815,
                                5.26314
                            ],
                            [
                                -54.36966,
                                5.13052
                            ],
                            [
                                -54.41555,
                                5.08374
                            ],
                            [
                                -54.46711,
                                4.87206
                            ],
                            [
                                -54.46579,
                                4.73928
                            ],
                            [
                                -54.42808,
                                4.71621
                            ],
                            [
                                -54.43757,
                                4.64055
                            ],
                            [
                                -54.41568,
                                4.60567
                            ],
                            [
                                -54.4495,
                                4.52596
                            ],
                            [
                                -54.432,
                                4.41227
                            ],
                            [
                                -54.38739,
                                4.35402
                            ],
                            [
                                -54.39489,
                                4.19931
                            ],
                            [
                                -54.32405,
                                4.14841
                            ],
                            [
                                -54.35643,
                                4.0515
                            ],
                            [
                                -54.29556,
                                3.94888
                            ],
                            [
                                -54.24988,
                                3.90853
                            ],
                            [
                                -54.20119,
                                3.82324
                            ],
                            [
                                -54.12267,
                                3.7933
                            ],
                            [
                                -54.08284,
                                3.67655
                            ],
                            [
                                -53.98159,
                                3.60555
                            ],
                            [
                                -54.00797,
                                3.53854
                            ],
                            [
                                -54.0216,
                                3.41217
                            ],
                            [
                                -54.05827,
                                3.38321
                            ],
                            [
                                -54.06566,
                                3.31084
                            ],
                            [
                                -54.13808,
                                3.26333
                            ],
                            [
                                -54.21235,
                                3.15205
                            ],
                            [
                                -54.17505,
                                3.1068
                            ],
                            [
                                -54.1932,
                                3.06304
                            ],
                            [
                                -54.17362,
                                2.9397
                            ],
                            [
                                -54.18051,
                                2.85921
                            ],
                            [
                                -54.22504,
                                2.75363
                            ],
                            [
                                -54.26376,
                                2.72314
                            ],
                            [
                                -54.31731,
                                2.6286
                            ],
                            [
                                -54.35077,
                                2.52278
                            ],
                            [
                                -54.4202,
                                2.438
                            ],
                            [
                                -54.47514,
                                2.43418
                            ],
                            [
                                -54.50825,
                                2.33845
                            ],
                            [
                                -54.58789,
                                2.32207
                            ],
                            [
                                -54.47667,
                                2.2141
                            ],
                            [
                                -54.36124,
                                2.2093
                            ],
                            [
                                -54.34034,
                                2.15366
                            ],
                            [
                                -54.27124,
                                2.14535
                            ],
                            [
                                -54.19398,
                                2.16928
                            ],
                            [
                                -54.14199,
                                2.11528
                            ],
                            [
                                -54.10462,
                                2.12256
                            ],
                            [
                                -54.06419,
                                2.19594
                            ],
                            [
                                -53.94362,
                                2.21745
                            ],
                            [
                                -53.93456,
                                2.279
                            ],
                            [
                                -53.81569,
                                2.31193
                            ],
                            [
                                -53.8085,
                                2.35208
                            ],
                            [
                                -53.73854,
                                2.37236
                            ],
                            [
                                -53.72223,
                                2.31139
                            ],
                            [
                                -53.53193,
                                2.25245
                            ],
                            [
                                -53.46187,
                                2.25387
                            ],
                            [
                                -53.34007,
                                2.35039
                            ],
                            [
                                -53.25608,
                                2.27135
                            ],
                            [
                                -53.22112,
                                2.20233
                            ],
                            [
                                -53.13307,
                                2.22441
                            ],
                            [
                                -52.98111,
                                2.16861
                            ],
                            [
                                -52.90472,
                                2.19023
                            ],
                            [
                                -52.85634,
                                2.28009
                            ],
                            [
                                -52.66143,
                                2.37441
                            ],
                            [
                                -52.61929,
                                2.47311
                            ],
                            [
                                -52.5527,
                                2.52082
                            ],
                            [
                                -52.5277,
                                2.58322
                            ],
                            [
                                -52.52918,
                                2.65421
                            ],
                            [
                                -52.47279,
                                2.79438
                            ],
                            [
                                -52.32704,
                                3.07646
                            ],
                            [
                                -52.34942,
                                3.12302
                            ],
                            [
                                -52.29243,
                                3.22356
                            ],
                            [
                                -52.22707,
                                3.24935
                            ],
                            [
                                -52.08794,
                                3.48613
                            ],
                            [
                                -51.98899,
                                3.62721
                            ],
                            [
                                -51.97218,
                                3.70513
                            ],
                            [
                                -51.79867,
                                3.88731
                            ],
                            [
                                -51.78213,
                                3.96384
                            ],
                            [
                                -51.65546,
                                4.05599
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.42712,
                                43.0094
                            ],
                            [
                                9.34364,
                                42.99772
                            ],
                            [
                                9.35357,
                                42.91653
                            ],
                            [
                                9.31014,
                                42.83301
                            ],
                            [
                                9.34276,
                                42.73305
                            ],
                            [
                                9.25688,
                                42.71778
                            ],
                            [
                                9.1632,
                                42.73628
                            ],
                            [
                                9.08603,
                                42.71446
                            ],
                            [
                                9.01758,
                                42.64257
                            ],
                            [
                                8.91973,
                                42.63793
                            ],
                            [
                                8.72222,
                                42.55602
                            ],
                            [
                                8.66658,
                                42.51394
                            ],
                            [
                                8.65569,
                                42.41589
                            ],
                            [
                                8.5545,
                                42.37246
                            ],
                            [
                                8.56389,
                                42.33416
                            ],
                            [
                                8.68716,
                                42.28192
                            ],
                            [
                                8.57088,
                                42.23876
                            ],
                            [
                                8.62527,
                                42.12356
                            ],
                            [
                                8.70983,
                                42.09634
                            ],
                            [
                                8.72281,
                                42.03319
                            ],
                            [
                                8.65978,
                                42.01179
                            ],
                            [
                                8.6106,
                                41.91188
                            ],
                            [
                                8.78039,
                                41.92377
                            ],
                            [
                                8.7713,
                                41.81124
                            ],
                            [
                                8.68383,
                                41.7477
                            ],
                            [
                                8.77191,
                                41.71244
                            ],
                            [
                                8.91199,
                                41.69096
                            ],
                            [
                                8.79443,
                                41.63104
                            ],
                            [
                                8.78816,
                                41.56479
                            ],
                            [
                                8.94048,
                                41.49009
                            ],
                            [
                                9.07983,
                                41.44148
                            ],
                            [
                                9.09271,
                                41.40171
                            ],
                            [
                                9.22022,
                                41.37042
                            ],
                            [
                                9.22511,
                                41.44037
                            ],
                            [
                                9.28243,
                                41.47765
                            ],
                            [
                                9.29796,
                                41.54181
                            ],
                            [
                                9.36745,
                                41.59485
                            ],
                            [
                                9.40772,
                                41.76619
                            ],
                            [
                                9.4118,
                                41.94674
                            ],
                            [
                                9.54967,
                                42.10431
                            ],
                            [
                                9.55932,
                                42.2828
                            ],
                            [
                                9.53262,
                                42.36876
                            ],
                            [
                                9.54342,
                                42.42794
                            ],
                            [
                                9.52769,
                                42.565
                            ],
                            [
                                9.44921,
                                42.66225
                            ],
                            [
                                9.49146,
                                42.79757
                            ],
                            [
                                9.46221,
                                42.98651
                            ],
                            [
                                9.42712,
                                43.0094
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                55.45117,
                                -20.87174
                            ],
                            [
                                55.39505,
                                -20.88183
                            ],
                            [
                                55.32262,
                                -20.93368
                            ],
                            [
                                55.27584,
                                -21.00157
                            ],
                            [
                                55.21708,
                                -21.03923
                            ],
                            [
                                55.22173,
                                -21.07824
                            ],
                            [
                                55.28698,
                                -21.16199
                            ],
                            [
                                55.29423,
                                -21.2305
                            ],
                            [
                                55.33977,
                                -21.28041
                            ],
                            [
                                55.46139,
                                -21.34181
                            ],
                            [
                                55.64671,
                                -21.38885
                            ],
                            [
                                55.75665,
                                -21.3637
                            ],
                            [
                                55.80844,
                                -21.3333
                            ],
                            [
                                55.80195,
                                -21.26081
                            ],
                            [
                                55.83578,
                                -21.18318
                            ],
                            [
                                55.70679,
                                -21.02626
                            ],
                            [
                                55.68322,
                                -20.94434
                            ],
                            [
                                55.64774,
                                -20.9156
                            ],
                            [
                                55.45117,
                                -20.87174
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -61.14808,
                                14.87878
                            ],
                            [
                                -61.22907,
                                14.8214
                            ],
                            [
                                -61.17934,
                                14.74925
                            ],
                            [
                                -61.15085,
                                14.64897
                            ],
                            [
                                -61.09078,
                                14.60018
                            ],
                            [
                                -61.08177,
                                14.47136
                            ],
                            [
                                -61.02077,
                                14.48003
                            ],
                            [
                                -60.91162,
                                14.46117
                            ],
                            [
                                -60.87489,
                                14.39698
                            ],
                            [
                                -60.81106,
                                14.48038
                            ],
                            [
                                -60.88435,
                                14.66556
                            ],
                            [
                                -61.01871,
                                14.80944
                            ],
                            [
                                -61.14808,
                                14.87878
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -61.67367,
                                16.32474
                            ],
                            [
                                -61.77664,
                                16.34867
                            ],
                            [
                                -61.80605,
                                16.26801
                            ],
                            [
                                -61.78272,
                                16.21392
                            ],
                            [
                                -61.76962,
                                16.05947
                            ],
                            [
                                -61.7068,
                                15.94915
                            ],
                            [
                                -61.61962,
                                15.97245
                            ],
                            [
                                -61.55664,
                                16.05209
                            ],
                            [
                                -61.59001,
                                16.19484
                            ],
                            [
                                -61.58527,
                                16.27054
                            ],
                            [
                                -61.67367,
                                16.32474
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -61.40527,
                                16.39338
                            ],
                            [
                                -61.41232,
                                16.46926
                            ],
                            [
                                -61.47175,
                                16.5098
                            ],
                            [
                                -61.53571,
                                16.45294
                            ],
                            [
                                -61.49763,
                                16.35582
                            ],
                            [
                                -61.53478,
                                16.33196
                            ],
                            [
                                -61.54884,
                                16.25311
                            ],
                            [
                                -61.46545,
                                16.19788
                            ],
                            [
                                -61.3666,
                                16.23358
                            ],
                            [
                                -61.2513,
                                16.25486
                            ],
                            [
                                -61.25913,
                                16.30158
                            ],
                            [
                                -61.37646,
                                16.34147
                            ],
                            [
                                -61.40527,
                                16.39338
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                45.12769,
                                -12.72734
                            ],
                            [
                                45.08947,
                                -12.66909
                            ],
                            [
                                45.04408,
                                -12.74239
                            ],
                            [
                                45.10169,
                                -12.77759
                            ],
                            [
                                45.10265,
                                -12.8445
                            ],
                            [
                                45.17019,
                                -12.94687
                            ],
                            [
                                45.21292,
                                -12.87171
                            ],
                            [
                                45.18619,
                                -12.83908
                            ],
                            [
                                45.23584,
                                -12.78349
                            ],
                            [
                                45.20498,
                                -12.73164
                            ],
                            [
                                45.12769,
                                -12.72734
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -1.2027,
                                45.90045
                            ],
                            [
                                -1.24623,
                                45.98885
                            ],
                            [
                                -1.37081,
                                46.03091
                            ],
                            [
                                -1.38762,
                                45.95508
                            ],
                            [
                                -1.19676,
                                45.82933
                            ],
                            [
                                -1.2027,
                                45.90045
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -61.25944,
                                15.87121
                            ],
                            [
                                -61.19839,
                                15.93946
                            ],
                            [
                                -61.27644,
                                16.00635
                            ],
                            [
                                -61.33717,
                                15.93946
                            ],
                            [
                                -61.32172,
                                15.88555
                            ],
                            [
                                -61.25944,
                                15.87121
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -3.19412,
                                47.36593
                            ],
                            [
                                -3.2192,
                                47.29384
                            ],
                            [
                                -3.09941,
                                47.3158
                            ],
                            [
                                -3.19412,
                                47.36593
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "PYF",
                "Country": "French Polynesia",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.98e-08,
                    3.96e-08,
                    6.27e-08,
                    8.58e-08,
                    9.9e-08,
                    1.155e-07,
                    1.419e-07,
                    1.6335e-07,
                    1.9305e-07,
                    2.2275e-07,
                    2.607e-07,
                    3.1515e-07,
                    3.7785e-07,
                    4.4715e-07,
                    5.1975e-07,
                    6.072e-07,
                    7.095e-07,
                    8.0685e-07,
                    9.009e-07,
                    9.9825e-07,
                    1.0939e-06,
                    1.2127e-06,
                    1.3365e-06,
                    1.4768e-06,
                    1.6038e-06,
                    1.7358e-06,
                    1.8843e-06,
                    2.0361e-06,
                    2.2259e-06,
                    2.4338e-06,
                    2.6994e-06,
                    2.9733e-06,
                    3.2488e-06,
                    3.5079e-06,
                    3.7521e-06,
                    3.9633e-06,
                    4.1745e-06,
                    4.3758e-06,
                    4.587e-06,
                    4.8031e-06,
                    5.016e-06,
                    5.2272e-06,
                    5.4483e-06,
                    5.6678e-06,
                    5.9103e-06,
                    6.1859e-06,
                    6.5126e-06,
                    6.8392e-06,
                    7.1907e-06,
                    7.5372e-06,
                    7.9101e-06,
                    8.2797e-06,
                    8.646e-06,
                    9.0222e-06,
                    9.4e-06,
                    9.8159e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.98e-08,
                    3.96e-08,
                    6.27e-08,
                    8.58e-08,
                    9.9e-08,
                    1.155e-07,
                    1.419e-07,
                    1.6335e-07,
                    1.9305e-07,
                    2.2275e-07,
                    2.607e-07,
                    3.1515e-07,
                    3.7785e-07,
                    4.4715e-07,
                    5.1975e-07,
                    6.072e-07,
                    7.095e-07,
                    8.0685e-07,
                    9.009e-07,
                    9.9825e-07,
                    1.0939e-06,
                    1.2127e-06,
                    1.3365e-06,
                    1.4768e-06,
                    1.6038e-06,
                    1.7358e-06,
                    1.8843e-06,
                    2.0361e-06,
                    2.2259e-06,
                    2.4338e-06,
                    2.6994e-06,
                    2.9733e-06,
                    3.2488e-06,
                    3.5079e-06,
                    3.7521e-06,
                    3.9633e-06,
                    4.1745e-06,
                    4.3758e-06,
                    4.587e-06,
                    4.8031e-06,
                    5.016e-06,
                    5.2272e-06,
                    5.4483e-06,
                    5.6678e-06,
                    5.9103e-06,
                    6.1859e-06,
                    6.5126e-06,
                    6.8392e-06,
                    7.1907e-06,
                    7.5372e-06,
                    7.9101e-06,
                    8.2797e-06,
                    8.646e-06,
                    9.0222e-06,
                    9.4e-06,
                    9.8159e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.98e-08,
                    3.96e-08,
                    6.27e-08,
                    8.58e-08,
                    9.9e-08,
                    1.155e-07,
                    1.419e-07,
                    1.6335e-07,
                    1.9305e-07,
                    2.2275e-07,
                    2.607e-07,
                    3.1515e-07,
                    3.7785e-07,
                    4.4715e-07,
                    5.1975e-07,
                    6.072e-07,
                    7.095e-07,
                    8.0685e-07,
                    9.009e-07,
                    9.9825e-07,
                    1.0939e-06,
                    1.2127e-06,
                    1.3365e-06,
                    1.4768e-06,
                    1.6038e-06,
                    1.7358e-06,
                    1.8843e-06,
                    2.0361e-06,
                    2.2259e-06,
                    2.4338e-06,
                    2.6994e-06,
                    2.9733e-06,
                    3.2488e-06,
                    3.5079e-06,
                    3.7521e-06,
                    3.9633e-06,
                    4.1745e-06,
                    4.3758e-06,
                    4.587e-06,
                    4.8031e-06,
                    5.016e-06,
                    5.2272e-06,
                    5.4483e-06,
                    5.6678e-06,
                    5.9103e-06,
                    6.1859e-06,
                    6.5126e-06,
                    6.8392e-06,
                    7.1907e-06,
                    7.5372e-06,
                    7.9101e-06,
                    8.2797e-06,
                    8.646e-06,
                    9.0222e-06,
                    9.4e-06,
                    9.8159e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.98e-08,
                    3.96e-08,
                    6.27e-08,
                    8.58e-08,
                    9.9e-08,
                    1.155e-07,
                    1.419e-07,
                    1.6335e-07,
                    1.9305e-07,
                    2.2275e-07,
                    2.607e-07,
                    3.1515e-07,
                    3.7785e-07,
                    4.4715e-07,
                    5.1975e-07,
                    6.072e-07,
                    7.095e-07,
                    8.0685e-07,
                    9.009e-07,
                    9.9825e-07,
                    1.0939e-06,
                    1.2127e-06,
                    1.3365e-06,
                    1.4768e-06,
                    1.6038e-06,
                    1.7358e-06,
                    1.8843e-06,
                    2.0361e-06,
                    2.2259e-06,
                    2.4338e-06,
                    2.6994e-06,
                    2.9733e-06,
                    3.2488e-06,
                    3.5079e-06,
                    3.7521e-06,
                    3.9633e-06,
                    4.1745e-06,
                    4.3758e-06,
                    4.587e-06,
                    4.8031e-06,
                    5.016e-06,
                    5.2272e-06,
                    5.4483e-06,
                    5.6678e-06,
                    5.9103e-06,
                    6.1859e-06,
                    6.5126e-06,
                    6.8392e-06,
                    7.1907e-06,
                    7.5372e-06,
                    7.9101e-06,
                    8.2797e-06,
                    8.646e-06,
                    9.0222e-06,
                    9.4e-06,
                    9.8159e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": []
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -149.6201,
                                -17.57243
                            ],
                            [
                                -149.61541,
                                -17.63429
                            ],
                            [
                                -149.57742,
                                -17.74017
                            ],
                            [
                                -149.47402,
                                -17.77829
                            ],
                            [
                                -149.33207,
                                -17.74526
                            ],
                            [
                                -149.29621,
                                -17.8193
                            ],
                            [
                                -149.24908,
                                -17.86114
                            ],
                            [
                                -149.14625,
                                -17.87184
                            ],
                            [
                                -149.12859,
                                -17.78086
                            ],
                            [
                                -149.15705,
                                -17.75477
                            ],
                            [
                                -149.29919,
                                -17.72706
                            ],
                            [
                                -149.2998,
                                -17.6095
                            ],
                            [
                                -149.34138,
                                -17.54403
                            ],
                            [
                                -149.49457,
                                -17.49518
                            ],
                            [
                                -149.6201,
                                -17.57243
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -140.25155,
                                -8.83148
                            ],
                            [
                                -140.18705,
                                -8.96257
                            ],
                            [
                                -140.00989,
                                -8.90349
                            ],
                            [
                                -140.01567,
                                -8.84749
                            ],
                            [
                                -140.06822,
                                -8.80491
                            ],
                            [
                                -140.24669,
                                -8.80071
                            ],
                            [
                                -140.25155,
                                -8.83148
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -139.16305,
                                -9.77511
                            ],
                            [
                                -139.13471,
                                -9.82694
                            ],
                            [
                                -139.06753,
                                -9.85158
                            ],
                            [
                                -139.04067,
                                -9.80732
                            ],
                            [
                                -138.89906,
                                -9.80566
                            ],
                            [
                                -138.90586,
                                -9.73728
                            ],
                            [
                                -138.97043,
                                -9.70725
                            ],
                            [
                                -139.03984,
                                -9.70631
                            ],
                            [
                                -139.16305,
                                -9.77511
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -151.4924,
                                -16.76862
                            ],
                            [
                                -151.46953,
                                -16.90579
                            ],
                            [
                                -151.39586,
                                -16.89119
                            ],
                            [
                                -151.39067,
                                -16.82726
                            ],
                            [
                                -151.44858,
                                -16.72302
                            ],
                            [
                                -151.4924,
                                -16.76862
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -149.91588,
                                -17.50272
                            ],
                            [
                                -149.85077,
                                -17.58586
                            ],
                            [
                                -149.80841,
                                -17.59228
                            ],
                            [
                                -149.7687,
                                -17.4767
                            ],
                            [
                                -149.91588,
                                -17.50272
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -140.13224,
                                -9.38289
                            ],
                            [
                                -140.07309,
                                -9.46219
                            ],
                            [
                                -140.03744,
                                -9.44775
                            ],
                            [
                                -140.02393,
                                -9.36504
                            ],
                            [
                                -140.07424,
                                -9.33674
                            ],
                            [
                                -140.13224,
                                -9.38289
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -151.54908,
                                -16.62254
                            ],
                            [
                                -151.48225,
                                -16.68293
                            ],
                            [
                                -151.43489,
                                -16.61837
                            ],
                            [
                                -151.51291,
                                -16.57839
                            ],
                            [
                                -151.54908,
                                -16.62254
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -139.6144,
                                -8.922
                            ],
                            [
                                -139.59117,
                                -8.95049
                            ],
                            [
                                -139.4871,
                                -8.912
                            ],
                            [
                                -139.55057,
                                -8.86536
                            ],
                            [
                                -139.6144,
                                -8.922
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -138.69218,
                                -10.52005
                            ],
                            [
                                -138.63638,
                                -10.54114
                            ],
                            [
                                -138.61388,
                                -10.45886
                            ],
                            [
                                -138.65907,
                                -10.42082
                            ],
                            [
                                -138.69218,
                                -10.52005
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -151.04627,
                                -16.75507
                            ],
                            [
                                -150.98311,
                                -16.80743
                            ],
                            [
                                -150.98316,
                                -16.69433
                            ],
                            [
                                -151.03124,
                                -16.69141
                            ],
                            [
                                -151.04627,
                                -16.75507
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -139.13168,
                                -9.98795
                            ],
                            [
                                -139.03532,
                                -9.93178
                            ],
                            [
                                -139.09754,
                                -9.89436
                            ],
                            [
                                -139.13168,
                                -9.98795
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "GAB",
                "Country": "Gabon",
                "Total_3GHG": 0.09,
                "Total_3GHG_timeseries": [
                    5.3374e-07,
                    1.414e-06,
                    2.3236e-06,
                    3.0157e-06,
                    3.5234e-06,
                    4.2846e-06,
                    4.9434e-06,
                    5.5232e-06,
                    6.0061e-06,
                    6.5339e-06,
                    7.3672e-06,
                    8.2475e-06,
                    9.1204e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014
                ],
                "Fossil_3GHG": 0.07,
                "Fossil_3GHG_timeseries": [
                    5.9078e-09,
                    1.1928e-08,
                    1.8063e-08,
                    2.4312e-08,
                    3.0675e-08,
                    3.7153e-08,
                    4.3746e-08,
                    5.0453e-08,
                    5.7274e-08,
                    6.4208e-08,
                    7.1439e-08,
                    7.8968e-08,
                    8.6796e-08,
                    9.4925e-08,
                    1.0336e-07,
                    1.1209e-07,
                    1.2113e-07,
                    1.3048e-07,
                    1.4014e-07,
                    1.5011e-07,
                    1.6033e-07,
                    1.7083e-07,
                    1.8162e-07,
                    1.927e-07,
                    2.041e-07,
                    2.1581e-07,
                    2.2783e-07,
                    2.4014e-07,
                    2.5275e-07,
                    2.6562e-07,
                    2.786e-07,
                    2.9168e-07,
                    3.0485e-07,
                    3.1812e-07,
                    3.3149e-07,
                    3.4495e-07,
                    3.5852e-07,
                    3.7218e-07,
                    3.8594e-07,
                    3.999e-07,
                    4.14e-07,
                    4.2823e-07,
                    4.426e-07,
                    4.571e-07,
                    4.7176e-07,
                    4.8655e-07,
                    5.015e-07,
                    5.166e-07,
                    5.3185e-07,
                    5.4727e-07,
                    5.6287e-07,
                    5.7868e-07,
                    5.947e-07,
                    6.1093e-07,
                    6.2738e-07,
                    6.4405e-07,
                    6.6031e-07,
                    6.7684e-07,
                    6.9362e-07,
                    7.1065e-07,
                    7.2889e-07,
                    7.4867e-07,
                    7.7e-07,
                    7.929e-07,
                    8.1739e-07,
                    8.4351e-07,
                    8.7128e-07,
                    9.0072e-07,
                    9.3187e-07,
                    9.6476e-07,
                    1.0002e-06,
                    1.0374e-06,
                    1.0763e-06,
                    1.117e-06,
                    1.1594e-06,
                    1.2036e-06,
                    1.2503e-06,
                    1.2987e-06,
                    1.3489e-06,
                    1.4009e-06,
                    1.4542e-06,
                    1.5087e-06,
                    1.5645e-06,
                    1.6216e-06,
                    1.68e-06,
                    1.7397e-06,
                    1.7993e-06,
                    1.86e-06,
                    1.9219e-06,
                    1.9851e-06,
                    2.0504e-06,
                    2.1186e-06,
                    2.19e-06,
                    2.2645e-06,
                    2.3477e-06,
                    2.4401e-06,
                    2.5419e-06,
                    2.6536e-06,
                    2.7757e-06,
                    2.9606e-06,
                    3.1807e-06,
                    3.432e-06,
                    3.683e-06,
                    3.9548e-06,
                    4.2352e-06,
                    4.5672e-06,
                    4.9266e-06,
                    5.3267e-06,
                    5.6341e-06,
                    6.3684e-06,
                    7.2448e-06,
                    7.8435e-06,
                    8.403e-06,
                    9.4851e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008
                ],
                "Land_3GHG": 0.1,
                "Land_3GHG_timeseries": [
                    5.2783e-07,
                    1.4021e-06,
                    2.3055e-06,
                    2.9914e-06,
                    3.4927e-06,
                    4.2475e-06,
                    4.8996e-06,
                    5.4728e-06,
                    5.9489e-06,
                    6.4697e-06,
                    7.2958e-06,
                    8.1685e-06,
                    9.0336e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006
                ],
                "Total_CO2": 0.06,
                "Total_CO2_timeseries": [
                    5.2458e-07,
                    1.3955e-06,
                    2.2956e-06,
                    2.9781e-06,
                    3.476e-06,
                    4.2273e-06,
                    4.876e-06,
                    5.4457e-06,
                    5.9182e-06,
                    6.4355e-06,
                    7.258e-06,
                    8.1271e-06,
                    8.9885e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Fossil_CO2": 0.02,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    4.705e-09,
                    1.0978e-08,
                    1.9114e-08,
                    2.5975e-08,
                    3.3228e-08,
                    4.0384e-08,
                    4.9695e-08,
                    5.9694e-08,
                    7.1162e-08,
                    8.1062e-08,
                    1.4046e-07,
                    2.1471e-07,
                    2.5431e-07,
                    2.8731e-07,
                    3.7311e-07,
                    4.7046e-07,
                    6.4206e-07,
                    1.0975e-06,
                    1.9802e-06,
                    2.6254e-06,
                    3.5626e-06,
                    4.843e-06,
                    6.0755e-06,
                    8.4664e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CO2": 0.16,
                "Land_CO2_timeseries": [
                    5.2458e-07,
                    1.3955e-06,
                    2.2956e-06,
                    2.9781e-06,
                    3.476e-06,
                    4.2273e-06,
                    4.876e-06,
                    5.4457e-06,
                    5.9182e-06,
                    6.4355e-06,
                    7.258e-06,
                    8.1271e-06,
                    8.9885e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006
                ],
                "Total_CH4": 0.16,
                "Total_CH4_timeseries": [
                    5.4793e-09,
                    1.1051e-08,
                    1.6715e-08,
                    2.2475e-08,
                    2.8331e-08,
                    3.4284e-08,
                    4.0336e-08,
                    4.6489e-08,
                    5.2744e-08,
                    5.9102e-08,
                    6.5798e-08,
                    7.2835e-08,
                    8.0214e-08,
                    8.7936e-08,
                    9.6003e-08,
                    1.0442e-07,
                    1.1318e-07,
                    1.2229e-07,
                    1.3175e-07,
                    1.4157e-07,
                    1.5167e-07,
                    1.6206e-07,
                    1.7274e-07,
                    1.8371e-07,
                    1.9497e-07,
                    2.0652e-07,
                    2.1835e-07,
                    2.3048e-07,
                    2.429e-07,
                    2.5561e-07,
                    2.6841e-07,
                    2.813e-07,
                    2.9428e-07,
                    3.0734e-07,
                    3.205e-07,
                    3.3375e-07,
                    3.4709e-07,
                    3.6052e-07,
                    3.7404e-07,
                    3.8766e-07,
                    4.0137e-07,
                    4.1518e-07,
                    4.2909e-07,
                    4.431e-07,
                    4.5721e-07,
                    4.7142e-07,
                    4.8572e-07,
                    5.0013e-07,
                    5.1465e-07,
                    5.2926e-07,
                    5.4402e-07,
                    5.5891e-07,
                    5.7394e-07,
                    5.891e-07,
                    6.0441e-07,
                    6.1986e-07,
                    6.3483e-07,
                    6.4999e-07,
                    6.6535e-07,
                    6.8091e-07,
                    6.9791e-07,
                    7.1667e-07,
                    7.3722e-07,
                    7.5958e-07,
                    7.8377e-07,
                    8.0982e-07,
                    8.3776e-07,
                    8.6762e-07,
                    8.9942e-07,
                    9.3319e-07,
                    9.6983e-07,
                    1.0085e-06,
                    1.0492e-06,
                    1.0919e-06,
                    1.1367e-06,
                    1.1836e-06,
                    1.2331e-06,
                    1.2847e-06,
                    1.3384e-06,
                    1.3942e-06,
                    1.4514e-06,
                    1.5098e-06,
                    1.5696e-06,
                    1.6308e-06,
                    1.6932e-06,
                    1.7595e-06,
                    1.828e-06,
                    1.9003e-06,
                    1.9765e-06,
                    2.0568e-06,
                    2.142e-06,
                    2.2332e-06,
                    2.3305e-06,
                    2.4341e-06,
                    2.5496e-06,
                    2.6775e-06,
                    2.8183e-06,
                    2.9726e-06,
                    3.1408e-06,
                    3.3708e-06,
                    3.6372e-06,
                    3.9356e-06,
                    4.2376e-06,
                    4.5625e-06,
                    4.8986e-06,
                    5.2848e-06,
                    5.6983e-06,
                    6.1517e-06,
                    6.5147e-06,
                    7.2561e-06,
                    8.1157e-06,
                    8.7295e-06,
                    9.3071e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Fossil_CH4": 0.25,
                "Fossil_CH4_timeseries": [
                    4.408e-09,
                    8.9072e-09,
                    1.3499e-08,
                    1.8184e-08,
                    2.2965e-08,
                    2.7843e-08,
                    3.2818e-08,
                    3.7893e-08,
                    4.307e-08,
                    4.8348e-08,
                    5.3914e-08,
                    5.977e-08,
                    6.5915e-08,
                    7.2353e-08,
                    7.9084e-08,
                    8.6111e-08,
                    9.3434e-08,
                    1.0106e-07,
                    1.0898e-07,
                    1.172e-07,
                    1.2566e-07,
                    1.3435e-07,
                    1.4328e-07,
                    1.5244e-07,
                    1.6183e-07,
                    1.7146e-07,
                    1.8133e-07,
                    1.9143e-07,
                    2.0177e-07,
                    2.1235e-07,
                    2.2301e-07,
                    2.3375e-07,
                    2.4456e-07,
                    2.5545e-07,
                    2.6643e-07,
                    2.7748e-07,
                    2.8862e-07,
                    2.9984e-07,
                    3.1114e-07,
                    3.2253e-07,
                    3.34e-07,
                    3.4556e-07,
                    3.5721e-07,
                    3.6894e-07,
                    3.8076e-07,
                    3.9268e-07,
                    4.0468e-07,
                    4.1678e-07,
                    4.2897e-07,
                    4.4125e-07,
                    4.5365e-07,
                    4.6617e-07,
                    4.7881e-07,
                    4.9158e-07,
                    5.0446e-07,
                    5.1747e-07,
                    5.2999e-07,
                    5.4267e-07,
                    5.5554e-07,
                    5.6859e-07,
                    5.8279e-07,
                    5.9848e-07,
                    6.1566e-07,
                    6.3438e-07,
                    6.5464e-07,
                    6.7648e-07,
                    6.9992e-07,
                    7.2499e-07,
                    7.5172e-07,
                    7.8014e-07,
                    8.1108e-07,
                    8.4368e-07,
                    8.7797e-07,
                    9.1397e-07,
                    9.5169e-07,
                    9.9116e-07,
                    1.033e-06,
                    1.0765e-06,
                    1.1217e-06,
                    1.1687e-06,
                    1.2169e-06,
                    1.2662e-06,
                    1.3167e-06,
                    1.3683e-06,
                    1.4211e-06,
                    1.4751e-06,
                    1.5287e-06,
                    1.5834e-06,
                    1.6391e-06,
                    1.6958e-06,
                    1.7545e-06,
                    1.8159e-06,
                    1.8801e-06,
                    1.9472e-06,
                    2.0227e-06,
                    2.107e-06,
                    2.2004e-06,
                    2.3035e-06,
                    2.4165e-06,
                    2.5874e-06,
                    2.7916e-06,
                    3.0246e-06,
                    3.2584e-06,
                    3.5121e-06,
                    3.774e-06,
                    4.085e-06,
                    4.4224e-06,
                    4.7986e-06,
                    5.0832e-06,
                    5.745e-06,
                    6.5339e-06,
                    7.0794e-06,
                    7.5921e-06,
                    8.5744e-06,
                    9.6893e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0006
                ],
                "Land_CH4": 0.01,
                "Land_CH4_timeseries": [
                    1.0713e-09,
                    2.1435e-09,
                    3.2165e-09,
                    4.2905e-09,
                    5.3654e-09,
                    6.4412e-09,
                    7.5178e-09,
                    8.5954e-09,
                    9.6739e-09,
                    1.0753e-08,
                    1.1884e-08,
                    1.3066e-08,
                    1.4299e-08,
                    1.5583e-08,
                    1.6919e-08,
                    1.8306e-08,
                    1.9744e-08,
                    2.1233e-08,
                    2.2774e-08,
                    2.4366e-08,
                    2.6012e-08,
                    2.7712e-08,
                    2.9466e-08,
                    3.1274e-08,
                    3.3137e-08,
                    3.5053e-08,
                    3.7024e-08,
                    3.9048e-08,
                    4.1127e-08,
                    4.326e-08,
                    4.5403e-08,
                    4.7555e-08,
                    4.9718e-08,
                    5.189e-08,
                    5.4072e-08,
                    5.6264e-08,
                    5.8466e-08,
                    6.0678e-08,
                    6.2899e-08,
                    6.5131e-08,
                    6.7373e-08,
                    6.9625e-08,
                    7.1888e-08,
                    7.416e-08,
                    7.6444e-08,
                    7.8737e-08,
                    8.1041e-08,
                    8.3355e-08,
                    8.568e-08,
                    8.8015e-08,
                    9.0367e-08,
                    9.2737e-08,
                    9.5124e-08,
                    9.7528e-08,
                    9.995e-08,
                    1.0239e-07,
                    1.0485e-07,
                    1.0732e-07,
                    1.0981e-07,
                    1.1232e-07,
                    1.1511e-07,
                    1.1819e-07,
                    1.2155e-07,
                    1.252e-07,
                    1.2913e-07,
                    1.3335e-07,
                    1.3785e-07,
                    1.4263e-07,
                    1.477e-07,
                    1.5306e-07,
                    1.5875e-07,
                    1.6479e-07,
                    1.7118e-07,
                    1.7791e-07,
                    1.8499e-07,
                    1.924e-07,
                    2.0017e-07,
                    2.0827e-07,
                    2.1672e-07,
                    2.2552e-07,
                    2.3449e-07,
                    2.4363e-07,
                    2.5294e-07,
                    2.6243e-07,
                    2.721e-07,
                    2.8434e-07,
                    2.9927e-07,
                    3.1695e-07,
                    3.3747e-07,
                    3.6093e-07,
                    3.875e-07,
                    4.1727e-07,
                    4.5036e-07,
                    4.8686e-07,
                    5.2688e-07,
                    5.7052e-07,
                    6.179e-07,
                    6.691e-07,
                    7.2423e-07,
                    7.8341e-07,
                    8.4568e-07,
                    9.1094e-07,
                    9.7917e-07,
                    1.0504e-06,
                    1.1246e-06,
                    1.1998e-06,
                    1.2759e-06,
                    1.3531e-06,
                    1.4315e-06,
                    1.5111e-06,
                    1.5819e-06,
                    1.6501e-06,
                    1.7151e-06,
                    1.7788e-06,
                    1.841e-06,
                    1.9017e-06,
                    1.9588e-06,
                    2.0122e-06,
                    2.0547e-06,
                    2.1548e-06,
                    2.1719e-06,
                    2.1969e-06,
                    2.2266e-06,
                    2.2364e-06,
                    2.2628e-06,
                    2.2865e-06,
                    2.3288e-06,
                    2.3809e-06,
                    2.4708e-06,
                    2.5265e-06,
                    2.5691e-06,
                    2.628e-06,
                    2.6852e-06,
                    2.7111e-06,
                    2.7501e-06,
                    2.8024e-06,
                    2.9017e-06,
                    2.9631e-06,
                    3.053e-06,
                    3.2601e-06,
                    3.5522e-06,
                    3.8413e-06,
                    4.1264e-06,
                    4.4279e-06,
                    4.7106e-06,
                    4.8783e-06,
                    5.0501e-06,
                    5.2172e-06,
                    5.3479e-06,
                    5.4813e-06,
                    5.6147e-06,
                    5.7811e-06,
                    5.9865e-06,
                    6.3039e-06,
                    6.5398e-06,
                    6.8321e-06,
                    7.0623e-06,
                    7.4229e-06,
                    7.6228e-06,
                    7.6921e-06,
                    7.8381e-06,
                    7.9552e-06,
                    8.1066e-06,
                    8.1575e-06,
                    8.2268e-06,
                    8.4398e-06,
                    8.6529e-06,
                    8.7639e-06,
                    8.9925e-06,
                    9.1604e-06,
                    9.2983e-06,
                    9.3916e-06
                ],
                "Total_N2O": 0.01,
                "Total_N2O_timeseries": [
                    3.6843e-09,
                    7.4341e-09,
                    1.1247e-08,
                    1.5119e-08,
                    1.9047e-08,
                    2.3024e-08,
                    2.7045e-08,
                    3.1103e-08,
                    3.5189e-08,
                    3.9294e-08,
                    4.3413e-08,
                    4.7544e-08,
                    5.1686e-08,
                    5.5838e-08,
                    6.0001e-08,
                    6.4173e-08,
                    6.8356e-08,
                    7.255e-08,
                    7.6756e-08,
                    8.0976e-08,
                    8.5259e-08,
                    8.9688e-08,
                    9.4327e-08,
                    9.922e-08,
                    1.0439e-07,
                    1.0985e-07,
                    1.1558e-07,
                    1.2155e-07,
                    1.2772e-07,
                    1.3399e-07,
                    1.4034e-07,
                    1.4675e-07,
                    1.5321e-07,
                    1.5972e-07,
                    1.6627e-07,
                    1.7285e-07,
                    1.7948e-07,
                    1.8615e-07,
                    1.9287e-07,
                    1.9993e-07,
                    2.0708e-07,
                    2.1432e-07,
                    2.2166e-07,
                    2.2909e-07,
                    2.3664e-07,
                    2.4429e-07,
                    2.5205e-07,
                    2.5993e-07,
                    2.6793e-07,
                    2.7605e-07,
                    2.8431e-07,
                    2.927e-07,
                    3.0123e-07,
                    3.0991e-07,
                    3.1875e-07,
                    3.2775e-07,
                    3.3692e-07,
                    3.4625e-07,
                    3.5575e-07,
                    3.6543e-07,
                    3.7532e-07,
                    3.8551e-07,
                    3.9604e-07,
                    4.0699e-07,
                    4.1837e-07,
                    4.3021e-07,
                    4.4252e-07,
                    4.553e-07,
                    4.6852e-07,
                    4.8217e-07,
                    4.9624e-07,
                    5.1079e-07,
                    5.2583e-07,
                    5.4138e-07,
                    5.5743e-07,
                    5.7394e-07,
                    5.9085e-07,
                    6.0812e-07,
                    6.2563e-07,
                    6.4328e-07,
                    6.6098e-07,
                    6.7865e-07,
                    6.9625e-07,
                    7.1373e-07,
                    7.311e-07,
                    7.4837e-07,
                    7.6555e-07,
                    7.8271e-07,
                    7.9991e-07,
                    8.1725e-07,
                    8.359e-07,
                    8.5781e-07,
                    8.8446e-07,
                    9.1683e-07,
                    9.5544e-07,
                    1.0003e-06,
                    1.051e-06,
                    1.1065e-06,
                    1.1655e-06,
                    1.2261e-06,
                    1.2866e-06,
                    1.3461e-06,
                    1.404e-06,
                    1.4597e-06,
                    1.5131e-06,
                    1.5641e-06,
                    1.613e-06,
                    1.6602e-06,
                    1.7064e-06,
                    1.7525e-06,
                    1.8019e-06,
                    1.8516e-06,
                    1.902e-06,
                    1.953e-06,
                    2.0047e-06,
                    2.0572e-06,
                    2.1101e-06,
                    2.1637e-06,
                    2.2172e-06,
                    2.283e-06,
                    2.3337e-06,
                    2.3871e-06,
                    2.4478e-06,
                    2.5064e-06,
                    2.573e-06,
                    2.6415e-06,
                    2.7161e-06,
                    2.7962e-06,
                    2.8834e-06,
                    2.9633e-06,
                    3.0428e-06,
                    3.1396e-06,
                    3.2378e-06,
                    3.3765e-06,
                    3.4707e-06,
                    3.5677e-06,
                    3.7182e-06,
                    3.8874e-06,
                    3.9865e-06,
                    4.1209e-06,
                    4.2577e-06,
                    4.3968e-06,
                    4.5391e-06,
                    4.6799e-06,
                    4.8203e-06,
                    4.9428e-06,
                    5.0741e-06,
                    5.2095e-06,
                    5.3458e-06,
                    5.4769e-06,
                    5.6061e-06,
                    5.7574e-06,
                    5.9288e-06,
                    6.1292e-06,
                    6.3278e-06,
                    6.5514e-06,
                    6.7836e-06,
                    7.0463e-06,
                    7.2905e-06,
                    7.5553e-06,
                    7.8032e-06,
                    8.0335e-06,
                    8.3249e-06,
                    8.5891e-06,
                    8.8661e-06,
                    9.1489e-06,
                    9.4388e-06,
                    9.7049e-06,
                    1e-05,
                    0,
                    0,
                    0
                ],
                "Fossil_N2O": 0.02,
                "Fossil_N2O_timeseries": [
                    1.4998e-09,
                    3.0213e-09,
                    4.5641e-09,
                    6.1272e-09,
                    7.7097e-09,
                    9.3102e-09,
                    1.0927e-08,
                    1.2559e-08,
                    1.4204e-08,
                    1.586e-08,
                    1.7525e-08,
                    1.9199e-08,
                    2.0881e-08,
                    2.2573e-08,
                    2.4273e-08,
                    2.5981e-08,
                    2.7698e-08,
                    2.9424e-08,
                    3.1159e-08,
                    3.2903e-08,
                    3.4668e-08,
                    3.6475e-08,
                    3.8338e-08,
                    4.0267e-08,
                    4.227e-08,
                    4.4348e-08,
                    4.6496e-08,
                    4.8709e-08,
                    5.0972e-08,
                    5.327e-08,
                    5.5591e-08,
                    5.7932e-08,
                    6.0292e-08,
                    6.2669e-08,
                    6.5062e-08,
                    6.747e-08,
                    6.9895e-08,
                    7.2335e-08,
                    7.4793e-08,
                    7.7374e-08,
                    7.9998e-08,
                    8.267e-08,
                    8.5391e-08,
                    8.8163e-08,
                    9.099e-08,
                    9.3874e-08,
                    9.6816e-08,
                    9.982e-08,
                    1.0289e-07,
                    1.0602e-07,
                    1.0922e-07,
                    1.1251e-07,
                    1.1588e-07,
                    1.1935e-07,
                    1.2292e-07,
                    1.2658e-07,
                    1.3033e-07,
                    1.3417e-07,
                    1.3808e-07,
                    1.4206e-07,
                    1.461e-07,
                    1.5019e-07,
                    1.5433e-07,
                    1.5852e-07,
                    1.6276e-07,
                    1.6704e-07,
                    1.7136e-07,
                    1.7573e-07,
                    1.8015e-07,
                    1.8462e-07,
                    1.8914e-07,
                    1.9371e-07,
                    1.9833e-07,
                    2.0299e-07,
                    2.0771e-07,
                    2.1248e-07,
                    2.1731e-07,
                    2.2219e-07,
                    2.2714e-07,
                    2.3216e-07,
                    2.3726e-07,
                    2.4246e-07,
                    2.4778e-07,
                    2.5324e-07,
                    2.5884e-07,
                    2.6459e-07,
                    2.7051e-07,
                    2.766e-07,
                    2.8286e-07,
                    2.8928e-07,
                    2.959e-07,
                    3.0276e-07,
                    3.0988e-07,
                    3.1729e-07,
                    3.2501e-07,
                    3.3306e-07,
                    3.4144e-07,
                    3.5015e-07,
                    3.5919e-07,
                    3.6853e-07,
                    3.782e-07,
                    3.8823e-07,
                    3.9866e-07,
                    4.095e-07,
                    4.2077e-07,
                    4.3245e-07,
                    4.4454e-07,
                    4.57e-07,
                    4.698e-07,
                    4.8289e-07,
                    4.9622e-07,
                    5.0979e-07,
                    5.2357e-07,
                    5.3758e-07,
                    5.5181e-07,
                    5.6629e-07,
                    5.8105e-07,
                    5.9613e-07,
                    6.1156e-07,
                    6.2665e-07,
                    6.426e-07,
                    6.5898e-07,
                    6.8049e-07,
                    7.0262e-07,
                    7.2741e-07,
                    7.5424e-07,
                    7.8306e-07,
                    8.144e-07,
                    8.4454e-07,
                    8.7436e-07,
                    9.0642e-07,
                    9.5455e-07,
                    1.0037e-06,
                    1.0988e-06,
                    1.1464e-06,
                    1.193e-06,
                    1.2841e-06,
                    1.4029e-06,
                    1.4469e-06,
                    1.4916e-06,
                    1.5361e-06,
                    1.5811e-06,
                    1.6276e-06,
                    1.6737e-06,
                    1.7226e-06,
                    1.7741e-06,
                    1.826e-06,
                    1.8812e-06,
                    1.9359e-06,
                    1.9909e-06,
                    2.0469e-06,
                    2.1141e-06,
                    2.1941e-06,
                    2.2845e-06,
                    2.3869e-06,
                    2.4995e-06,
                    2.6242e-06,
                    2.7603e-06,
                    2.9064e-06,
                    3.0674e-06,
                    3.1945e-06,
                    3.306e-06,
                    3.4714e-06,
                    3.6283e-06,
                    3.7878e-06,
                    3.9475e-06,
                    4.099e-06,
                    4.2493e-06,
                    4.4057e-06,
                    4.5633e-06,
                    4.7212e-06,
                    4.8838e-06
                ],
                "Land_N2O": 0.01,
                "Land_N2O_timeseries": [
                    2.1845e-09,
                    4.4127e-09,
                    6.6827e-09,
                    8.992e-09,
                    1.1337e-08,
                    1.3714e-08,
                    1.6118e-08,
                    1.8544e-08,
                    2.0985e-08,
                    2.3435e-08,
                    2.5889e-08,
                    2.8346e-08,
                    3.0805e-08,
                    3.3266e-08,
                    3.5728e-08,
                    3.8192e-08,
                    4.0658e-08,
                    4.3126e-08,
                    4.5597e-08,
                    4.8073e-08,
                    5.0591e-08,
                    5.3213e-08,
                    5.5989e-08,
                    5.8953e-08,
                    6.2123e-08,
                    6.5504e-08,
                    6.9087e-08,
                    7.2846e-08,
                    7.6743e-08,
                    8.0724e-08,
                    8.4751e-08,
                    8.8819e-08,
                    9.2919e-08,
                    9.7049e-08,
                    1.012e-07,
                    1.0538e-07,
                    1.0959e-07,
                    1.1382e-07,
                    1.1807e-07,
                    1.2256e-07,
                    1.2708e-07,
                    1.3165e-07,
                    1.3627e-07,
                    1.4093e-07,
                    1.4564e-07,
                    1.5041e-07,
                    1.5523e-07,
                    1.6011e-07,
                    1.6504e-07,
                    1.7003e-07,
                    1.7508e-07,
                    1.8019e-07,
                    1.8535e-07,
                    1.9056e-07,
                    1.9584e-07,
                    2.0118e-07,
                    2.0659e-07,
                    2.1208e-07,
                    2.1767e-07,
                    2.2337e-07,
                    2.2922e-07,
                    2.3532e-07,
                    2.4171e-07,
                    2.4846e-07,
                    2.5561e-07,
                    2.6317e-07,
                    2.7116e-07,
                    2.7956e-07,
                    2.8837e-07,
                    2.9755e-07,
                    3.071e-07,
                    3.1708e-07,
                    3.275e-07,
                    3.3839e-07,
                    3.4972e-07,
                    3.6145e-07,
                    3.7355e-07,
                    3.8592e-07,
                    3.9849e-07,
                    4.1112e-07,
                    4.2372e-07,
                    4.3619e-07,
                    4.4846e-07,
                    4.605e-07,
                    4.7227e-07,
                    4.8377e-07,
                    4.9504e-07,
                    5.0611e-07,
                    5.1706e-07,
                    5.2796e-07,
                    5.3999e-07,
                    5.5505e-07,
                    5.7458e-07,
                    5.9955e-07,
                    6.3043e-07,
                    6.6724e-07,
                    7.0953e-07,
                    7.5636e-07,
                    8.0634e-07,
                    8.5757e-07,
                    9.0842e-07,
                    9.5791e-07,
                    1.0053e-06,
                    1.0502e-06,
                    1.0923e-06,
                    1.1317e-06,
                    1.1685e-06,
                    1.2032e-06,
                    1.2366e-06,
                    1.2696e-06,
                    1.3056e-06,
                    1.3418e-06,
                    1.3784e-06,
                    1.4154e-06,
                    1.4529e-06,
                    1.4909e-06,
                    1.5291e-06,
                    1.5676e-06,
                    1.6056e-06,
                    1.6564e-06,
                    1.6911e-06,
                    1.7282e-06,
                    1.7673e-06,
                    1.8038e-06,
                    1.8456e-06,
                    1.8873e-06,
                    1.933e-06,
                    1.9818e-06,
                    2.0388e-06,
                    2.0889e-06,
                    2.1364e-06,
                    2.185e-06,
                    2.234e-06,
                    2.2778e-06,
                    2.3243e-06,
                    2.3748e-06,
                    2.4341e-06,
                    2.4844e-06,
                    2.5395e-06,
                    2.6293e-06,
                    2.7216e-06,
                    2.8157e-06,
                    2.9115e-06,
                    3.0061e-06,
                    3.0977e-06,
                    3.1687e-06,
                    3.2481e-06,
                    3.3284e-06,
                    3.4099e-06,
                    3.4861e-06,
                    3.5592e-06,
                    3.6433e-06,
                    3.7346e-06,
                    3.8447e-06,
                    3.9409e-06,
                    4.0519e-06,
                    4.1594e-06,
                    4.286e-06,
                    4.3841e-06,
                    4.488e-06,
                    4.6087e-06,
                    4.7274e-06,
                    4.8535e-06,
                    4.9608e-06,
                    5.0784e-06,
                    5.2014e-06,
                    5.3398e-06,
                    5.4557e-06,
                    5.5942e-06,
                    5.7079e-06,
                    5.8147e-06,
                    5.9219e-06
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            11.20103,
                            -3.99158
                        ],
                        [
                            11.24964,
                            -3.82342
                        ],
                        [
                            11.24986,
                            -3.71808
                        ],
                        [
                            11.33344,
                            -3.61514
                        ],
                        [
                            11.45681,
                            -3.58436
                        ],
                        [
                            11.53668,
                            -3.51399
                        ],
                        [
                            11.63146,
                            -3.57049
                        ],
                        [
                            11.6963,
                            -3.67041
                        ],
                        [
                            11.8807,
                            -3.74859
                        ],
                        [
                            11.94733,
                            -3.62578
                        ],
                        [
                            11.87945,
                            -3.57868
                        ],
                        [
                            11.89858,
                            -3.51084
                        ],
                        [
                            11.95952,
                            -3.47726
                        ],
                        [
                            12.04551,
                            -3.35169
                        ],
                        [
                            12.00219,
                            -3.24317
                        ],
                        [
                            11.94682,
                            -3.17253
                        ],
                        [
                            12.01366,
                            -3.13314
                        ],
                        [
                            12.06577,
                            -2.98578
                        ],
                        [
                            12.0087,
                            -2.94781
                        ],
                        [
                            11.79704,
                            -2.8617
                        ],
                        [
                            11.67251,
                            -2.8292
                        ],
                        [
                            11.61716,
                            -2.7859
                        ],
                        [
                            11.64307,
                            -2.69762
                        ],
                        [
                            11.70138,
                            -2.68505
                        ],
                        [
                            11.63669,
                            -2.52154
                        ],
                        [
                            11.64925,
                            -2.41871
                        ],
                        [
                            11.67896,
                            -2.35368
                        ],
                        [
                            11.73101,
                            -2.42822
                        ],
                        [
                            11.77632,
                            -2.45506
                        ],
                        [
                            11.81955,
                            -2.38967
                        ],
                        [
                            11.90534,
                            -2.37804
                        ],
                        [
                            12.0056,
                            -2.34278
                        ],
                        [
                            12.09352,
                            -2.43906
                        ],
                        [
                            12.17813,
                            -2.42134
                        ],
                        [
                            12.46611,
                            -2.42125
                        ],
                        [
                            12.52864,
                            -2.32648
                        ],
                        [
                            12.49886,
                            -2.28029
                        ],
                        [
                            12.53171,
                            -2.21395
                        ],
                        [
                            12.51122,
                            -2.15937
                        ],
                        [
                            12.51913,
                            -2.08602
                        ],
                        [
                            12.47605,
                            -2.02112
                        ],
                        [
                            12.44487,
                            -1.87654
                        ],
                        [
                            12.52409,
                            -1.9012
                        ],
                        [
                            12.5641,
                            -1.85918
                        ],
                        [
                            12.64914,
                            -1.88179
                        ],
                        [
                            12.73257,
                            -1.86498
                        ],
                        [
                            12.82732,
                            -1.925
                        ],
                        [
                            12.86839,
                            -2.01046
                        ],
                        [
                            12.88618,
                            -2.10047
                        ],
                        [
                            12.92983,
                            -2.15417
                        ],
                        [
                            13.00068,
                            -2.19689
                        ],
                        [
                            13.04642,
                            -2.33588
                        ],
                        [
                            13.16627,
                            -2.37844
                        ],
                        [
                            13.20785,
                            -2.34185
                        ],
                        [
                            13.26452,
                            -2.37929
                        ],
                        [
                            13.37377,
                            -2.42032
                        ],
                        [
                            13.50241,
                            -2.43116
                        ],
                        [
                            13.58345,
                            -2.3252
                        ],
                        [
                            13.72654,
                            -2.15982
                        ],
                        [
                            13.7525,
                            -2.11554
                        ],
                        [
                            13.81491,
                            -2.15581
                        ],
                        [
                            13.87912,
                            -2.26017
                        ],
                        [
                            13.91419,
                            -2.36026
                        ],
                        [
                            13.86952,
                            -2.42697
                        ],
                        [
                            13.92264,
                            -2.46401
                        ],
                        [
                            13.96988,
                            -2.44703
                        ],
                        [
                            14.10235,
                            -2.47308
                        ],
                        [
                            14.21558,
                            -2.28327
                        ],
                        [
                            14.15999,
                            -2.20022
                        ],
                        [
                            14.2522,
                            -2.10557
                        ],
                        [
                            14.25613,
                            -1.98644
                        ],
                        [
                            14.39934,
                            -1.87291
                        ],
                        [
                            14.42079,
                            -1.73098
                        ],
                        [
                            14.44978,
                            -1.69258
                        ],
                        [
                            14.38024,
                            -1.62726
                        ],
                        [
                            14.38271,
                            -1.59829
                        ],
                        [
                            14.4719,
                            -1.5533
                        ],
                        [
                            14.46534,
                            -1.47861
                        ],
                        [
                            14.49653,
                            -1.40871
                        ],
                        [
                            14.45468,
                            -1.33786
                        ],
                        [
                            14.48456,
                            -1.25787
                        ],
                        [
                            14.42462,
                            -1.00755
                        ],
                        [
                            14.41136,
                            -0.90877
                        ],
                        [
                            14.49752,
                            -0.6832
                        ],
                        [
                            14.46215,
                            -0.55127
                        ],
                        [
                            14.39518,
                            -0.47464
                        ],
                        [
                            14.25161,
                            -0.43354
                        ],
                        [
                            14.18049,
                            -0.43958
                        ],
                        [
                            14.1466,
                            -0.31018
                        ],
                        [
                            14.01781,
                            -0.23568
                        ],
                        [
                            13.89945,
                            -0.21687
                        ],
                        [
                            13.88947,
                            -0.15482
                        ],
                        [
                            13.92981,
                            -0.06745
                        ],
                        [
                            13.92625,
                            0.12849
                        ],
                        [
                            13.89183,
                            0.20024
                        ],
                        [
                            13.98793,
                            0.37339
                        ],
                        [
                            14.05212,
                            0.40892
                        ],
                        [
                            14.07295,
                            0.49762
                        ],
                        [
                            14.12056,
                            0.5572
                        ],
                        [
                            14.2369,
                            0.5381
                        ],
                        [
                            14.38045,
                            0.63663
                        ],
                        [
                            14.3667,
                            0.69296
                        ],
                        [
                            14.48556,
                            0.82302
                        ],
                        [
                            14.49578,
                            0.9278
                        ],
                        [
                            14.43936,
                            0.96904
                        ],
                        [
                            14.39694,
                            1.09081
                        ],
                        [
                            14.29778,
                            1.23394
                        ],
                        [
                            14.30546,
                            1.29425
                        ],
                        [
                            14.27814,
                            1.34009
                        ],
                        [
                            14.18657,
                            1.39391
                        ],
                        [
                            14.06914,
                            1.38083
                        ],
                        [
                            13.99706,
                            1.4203
                        ],
                        [
                            13.80176,
                            1.42496
                        ],
                        [
                            13.7602,
                            1.35408
                        ],
                        [
                            13.63506,
                            1.34327
                        ],
                        [
                            13.57112,
                            1.28793
                        ],
                        [
                            13.48789,
                            1.27091
                        ],
                        [
                            13.43205,
                            1.29891
                        ],
                        [
                            13.32454,
                            1.26157
                        ],
                        [
                            13.29021,
                            1.22896
                        ],
                        [
                            13.19685,
                            1.21936
                        ],
                        [
                            13.18862,
                            1.29094
                        ],
                        [
                            13.25647,
                            1.31655
                        ],
                        [
                            13.25562,
                            1.38958
                        ],
                        [
                            13.19635,
                            1.51266
                        ],
                        [
                            13.1392,
                            1.5613
                        ],
                        [
                            13.13826,
                            1.70117
                        ],
                        [
                            13.19995,
                            1.80499
                        ],
                        [
                            13.1633,
                            1.90065
                        ],
                        [
                            13.21032,
                            1.98025
                        ],
                        [
                            13.29407,
                            2.062
                        ],
                        [
                            13.29897,
                            2.17056
                        ],
                        [
                            13.28632,
                            2.24846
                        ],
                        [
                            13.1605,
                            2.28296
                        ],
                        [
                            13.07641,
                            2.24842
                        ],
                        [
                            12.93491,
                            2.25236
                        ],
                        [
                            12.87347,
                            2.23077
                        ],
                        [
                            12.79657,
                            2.24759
                        ],
                        [
                            12.7457,
                            2.22381
                        ],
                        [
                            12.68702,
                            2.24229
                        ],
                        [
                            12.49488,
                            2.26035
                        ],
                        [
                            12.45339,
                            2.25281
                        ],
                        [
                            12.32756,
                            2.27636
                        ],
                        [
                            12.24312,
                            2.25075
                        ],
                        [
                            12.1523,
                            2.27332
                        ],
                        [
                            11.97994,
                            2.29001
                        ],
                        [
                            11.75378,
                            2.27449
                        ],
                        [
                            11.69633,
                            2.32228
                        ],
                        [
                            11.6111,
                            2.30012
                        ],
                        [
                            11.39178,
                            2.3028
                        ],
                        [
                            11.33461,
                            2.17389
                        ],
                        [
                            11.33363,
                            1.52931
                        ],
                        [
                            11.33428,
                            1.00045
                        ],
                        [
                            11.02294,
                            0.99651
                        ],
                        [
                            10.2954,
                            0.99902
                        ],
                        [
                            9.99853,
                            0.99735
                        ],
                        [
                            9.98807,
                            0.92769
                        ],
                        [
                            9.95098,
                            0.92144
                        ],
                        [
                            9.87642,
                            0.98314
                        ],
                        [
                            9.79132,
                            0.99878
                        ],
                        [
                            9.74602,
                            1.06657
                        ],
                        [
                            9.66198,
                            1.05985
                        ],
                        [
                            9.64661,
                            1.01994
                        ],
                        [
                            9.58166,
                            1.00125
                        ],
                        [
                            9.55465,
                            0.94327
                        ],
                        [
                            9.58561,
                            0.82811
                        ],
                        [
                            9.62519,
                            0.76511
                        ],
                        [
                            9.62477,
                            0.63482
                        ],
                        [
                            9.68892,
                            0.4189
                        ],
                        [
                            9.53401,
                            0.45042
                        ],
                        [
                            9.48941,
                            0.55467
                        ],
                        [
                            9.40432,
                            0.64056
                        ],
                        [
                            9.32175,
                            0.6118
                        ],
                        [
                            9.3093,
                            0.52332
                        ],
                        [
                            9.38103,
                            0.49344
                        ],
                        [
                            9.49983,
                            0.29301
                        ],
                        [
                            9.57505,
                            0.28751
                        ],
                        [
                            9.67192,
                            0.21654
                        ],
                        [
                            9.79334,
                            0.17021
                        ],
                        [
                            9.74065,
                            0.10983
                        ],
                        [
                            9.63449,
                            0.14443
                        ],
                        [
                            9.60545,
                            0.13126
                        ],
                        [
                            9.52565,
                            0.16519
                        ],
                        [
                            9.49961,
                            0.14701
                        ],
                        [
                            9.38526,
                            0.22893
                        ],
                        [
                            9.37314,
                            0.31113
                        ],
                        [
                            9.30463,
                            0.29117
                        ],
                        [
                            9.34606,
                            0.0109
                        ],
                        [
                            9.32485,
                            -0.15566
                        ],
                        [
                            9.30548,
                            -0.21981
                        ],
                        [
                            9.30042,
                            -0.34604
                        ],
                        [
                            9.25244,
                            -0.46994
                        ],
                        [
                            9.11301,
                            -0.64951
                        ],
                        [
                            9.12305,
                            -0.72349
                        ],
                        [
                            9.05636,
                            -0.69656
                        ],
                        [
                            9.00276,
                            -0.64754
                        ],
                        [
                            8.87134,
                            -0.76141
                        ],
                        [
                            8.85685,
                            -0.82718
                        ],
                        [
                            8.80238,
                            -0.78601
                        ],
                        [
                            8.77418,
                            -0.68354
                        ],
                        [
                            8.70868,
                            -0.69026
                        ],
                        [
                            8.79636,
                            -0.86733
                        ],
                        [
                            8.89781,
                            -1.02055
                        ],
                        [
                            8.89544,
                            -1.05759
                        ],
                        [
                            8.97773,
                            -1.18965
                        ],
                        [
                            8.98863,
                            -1.28043
                        ],
                        [
                            9.01699,
                            -1.34178
                        ],
                        [
                            9.18867,
                            -1.56088
                        ],
                        [
                            9.24535,
                            -1.67087
                        ],
                        [
                            9.26,
                            -1.81177
                        ],
                        [
                            9.28904,
                            -1.91009
                        ],
                        [
                            9.40062,
                            -2.04536
                        ],
                        [
                            9.52553,
                            -2.17273
                        ],
                        [
                            9.58638,
                            -2.2611
                        ],
                        [
                            9.58994,
                            -2.34228
                        ],
                        [
                            9.62887,
                            -2.40676
                        ],
                        [
                            9.86903,
                            -2.64547
                        ],
                        [
                            9.90033,
                            -2.70611
                        ],
                        [
                            10.37534,
                            -3.05805
                        ],
                        [
                            10.52962,
                            -3.22059
                        ],
                        [
                            10.54959,
                            -3.2592
                        ],
                        [
                            10.6526,
                            -3.33556
                        ],
                        [
                            10.64677,
                            -3.44061
                        ],
                        [
                            10.88603,
                            -3.63338
                        ],
                        [
                            11.01233,
                            -3.77693
                        ],
                        [
                            11.02594,
                            -3.86156
                        ],
                        [
                            11.20103,
                            -3.99158
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "GMB",
                "Country": "Gambia",
                "Total_3GHG": 0.01,
                "Total_3GHG_timeseries": [
                    4.5861e-08,
                    9.2331e-08,
                    1.3921e-07,
                    1.8636e-07,
                    2.3371e-07,
                    2.8122e-07,
                    3.2882e-07,
                    3.7648e-07,
                    4.2413e-07,
                    4.7716e-07,
                    5.3319e-07,
                    5.9159e-07,
                    6.5129e-07,
                    7.1214e-07,
                    7.74e-07,
                    8.3677e-07,
                    9.008e-07,
                    9.6526e-07,
                    1.0303e-06,
                    1.1005e-06,
                    1.1735e-06,
                    1.2488e-06,
                    1.3253e-06,
                    1.403e-06,
                    1.4818e-06,
                    1.5618e-06,
                    1.6432e-06,
                    1.727e-06,
                    1.8109e-06,
                    1.9019e-06,
                    1.9965e-06,
                    2.0963e-06,
                    2.1967e-06,
                    2.2972e-06,
                    2.4005e-06,
                    2.5046e-06,
                    2.608e-06,
                    2.7116e-06,
                    2.8194e-06,
                    2.9414e-06,
                    3.0686e-06,
                    3.2033e-06,
                    3.3487e-06,
                    3.4882e-06,
                    3.6384e-06,
                    3.7969e-06,
                    3.9433e-06,
                    4.0996e-06,
                    4.2462e-06,
                    4.4446e-06,
                    4.6558e-06,
                    4.8961e-06,
                    5.1296e-06,
                    5.3702e-06,
                    5.6169e-06,
                    5.8804e-06,
                    6.1451e-06,
                    6.3968e-06,
                    6.6805e-06,
                    6.9156e-06,
                    7.1303e-06,
                    7.3553e-06,
                    7.5665e-06,
                    7.7746e-06,
                    8.0086e-06,
                    8.2515e-06,
                    8.4857e-06,
                    8.7217e-06,
                    8.9884e-06,
                    9.2932e-06,
                    9.6321e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    2.9176e-09,
                    5.8428e-09,
                    8.7756e-09,
                    1.1716e-08,
                    1.4663e-08,
                    1.7616e-08,
                    2.0576e-08,
                    2.3541e-08,
                    2.6511e-08,
                    2.9486e-08,
                    3.2504e-08,
                    3.5566e-08,
                    3.8706e-08,
                    4.1889e-08,
                    4.5116e-08,
                    4.8386e-08,
                    5.17e-08,
                    5.5057e-08,
                    5.8457e-08,
                    6.1901e-08,
                    6.5393e-08,
                    6.8939e-08,
                    7.2545e-08,
                    7.6212e-08,
                    7.9943e-08,
                    8.3738e-08,
                    8.7597e-08,
                    9.1516e-08,
                    9.5493e-08,
                    9.9522e-08,
                    1.0356e-07,
                    1.0762e-07,
                    1.1165e-07,
                    1.1569e-07,
                    1.1975e-07,
                    1.24e-07,
                    1.2858e-07,
                    1.3351e-07,
                    1.3883e-07,
                    1.4458e-07,
                    1.4872e-07,
                    1.5484e-07,
                    1.6115e-07,
                    1.6766e-07,
                    1.7438e-07,
                    1.8131e-07,
                    1.8846e-07,
                    1.9583e-07,
                    2.0344e-07,
                    2.1128e-07,
                    2.1919e-07,
                    2.2785e-07,
                    2.3697e-07,
                    2.4657e-07,
                    2.5668e-07,
                    2.6716e-07,
                    2.779e-07,
                    2.8893e-07,
                    3.0024e-07,
                    3.1185e-07,
                    3.2706e-07,
                    3.4087e-07,
                    3.5561e-07,
                    3.7136e-07,
                    3.8815e-07,
                    4.0599e-07,
                    4.2491e-07,
                    4.4491e-07,
                    4.6604e-07,
                    4.8831e-07,
                    5.1595e-07,
                    5.4082e-07,
                    5.6702e-07,
                    5.9457e-07,
                    6.2348e-07,
                    6.5378e-07,
                    6.8549e-07,
                    7.1744e-07,
                    7.496e-07,
                    7.8196e-07,
                    8.1359e-07,
                    8.4659e-07,
                    8.8047e-07,
                    9.1501e-07,
                    9.5045e-07,
                    9.8664e-07,
                    1.0237e-06,
                    1.0617e-06,
                    1.0982e-06,
                    1.1379e-06,
                    1.1752e-06,
                    1.2172e-06,
                    1.2602e-06,
                    1.3045e-06,
                    1.3466e-06,
                    1.3941e-06,
                    1.4423e-06,
                    1.492e-06,
                    1.5435e-06,
                    1.6041e-06,
                    1.6652e-06,
                    1.7254e-06,
                    1.7872e-06,
                    1.853e-06,
                    1.9214e-06,
                    1.9949e-06,
                    2.0734e-06,
                    2.157e-06,
                    2.2425e-06,
                    2.3284e-06,
                    2.4171e-06,
                    2.5081e-06,
                    2.6011e-06,
                    2.6941e-06,
                    2.7904e-06,
                    2.8847e-06,
                    2.9799e-06,
                    3.078e-06,
                    3.1823e-06,
                    3.2999e-06,
                    3.4255e-06,
                    3.5616e-06,
                    3.7008e-06,
                    3.841e-06,
                    4.005e-06,
                    4.1722e-06,
                    4.3497e-06,
                    4.5456e-06,
                    4.7468e-06,
                    4.9624e-06,
                    5.1841e-06,
                    5.4157e-06,
                    5.659e-06,
                    5.9184e-06,
                    6.1925e-06,
                    6.4775e-06,
                    6.7896e-06,
                    7.1204e-06,
                    7.4679e-06,
                    7.8812e-06,
                    8.3102e-06,
                    8.7554e-06,
                    9.2158e-06,
                    9.6803e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_3GHG": 0.02,
                "Land_3GHG_timeseries": [
                    4.2944e-08,
                    8.6488e-08,
                    1.3043e-07,
                    1.7464e-07,
                    2.1905e-07,
                    2.636e-07,
                    3.0825e-07,
                    3.5294e-07,
                    3.9762e-07,
                    4.4768e-07,
                    5.0068e-07,
                    5.5603e-07,
                    6.1259e-07,
                    6.7025e-07,
                    7.2888e-07,
                    7.8838e-07,
                    8.491e-07,
                    9.102e-07,
                    9.7183e-07,
                    1.0386e-06,
                    1.1081e-06,
                    1.1798e-06,
                    1.2527e-06,
                    1.3268e-06,
                    1.4019e-06,
                    1.478e-06,
                    1.5556e-06,
                    1.6355e-06,
                    1.7154e-06,
                    1.8023e-06,
                    1.893e-06,
                    1.9887e-06,
                    2.0851e-06,
                    2.1815e-06,
                    2.2807e-06,
                    2.3806e-06,
                    2.4794e-06,
                    2.5781e-06,
                    2.6805e-06,
                    2.7968e-06,
                    2.9198e-06,
                    3.0484e-06,
                    3.1876e-06,
                    3.3206e-06,
                    3.4641e-06,
                    3.6156e-06,
                    3.7548e-06,
                    3.9038e-06,
                    4.0428e-06,
                    4.2334e-06,
                    4.4367e-06,
                    4.6683e-06,
                    4.8926e-06,
                    5.1236e-06,
                    5.3602e-06,
                    5.6132e-06,
                    5.8672e-06,
                    6.1079e-06,
                    6.3802e-06,
                    6.6037e-06,
                    6.8032e-06,
                    7.0145e-06,
                    7.2109e-06,
                    7.4033e-06,
                    7.6204e-06,
                    7.8456e-06,
                    8.0608e-06,
                    8.2768e-06,
                    8.5223e-06,
                    8.8049e-06,
                    9.1161e-06,
                    9.465e-06,
                    9.8173e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    1.8876e-08,
                    3.8269e-08,
                    5.7981e-08,
                    7.788e-08,
                    9.79e-08,
                    1.18e-07,
                    1.3814e-07,
                    1.5828e-07,
                    1.7836e-07,
                    2.0378e-07,
                    2.3181e-07,
                    2.6184e-07,
                    2.9274e-07,
                    3.244e-07,
                    3.5669e-07,
                    3.895e-07,
                    4.2319e-07,
                    4.5693e-07,
                    4.9085e-07,
                    5.296e-07,
                    5.7058e-07,
                    6.1335e-07,
                    6.5667e-07,
                    7.0052e-07,
                    7.4479e-07,
                    7.8938e-07,
                    8.3479e-07,
                    8.8184e-07,
                    9.284e-07,
                    9.815e-07,
                    1.0382e-06,
                    1.0998e-06,
                    1.162e-06,
                    1.2241e-06,
                    1.2889e-06,
                    1.3544e-06,
                    1.4186e-06,
                    1.4826e-06,
                    1.5502e-06,
                    1.6313e-06,
                    1.7191e-06,
                    1.8122e-06,
                    1.9158e-06,
                    2.0131e-06,
                    2.1208e-06,
                    2.2363e-06,
                    2.3395e-06,
                    2.4522e-06,
                    2.5548e-06,
                    2.7088e-06,
                    2.8764e-06,
                    3.073e-06,
                    3.2632e-06,
                    3.4608e-06,
                    3.6649e-06,
                    3.886e-06,
                    4.109e-06,
                    4.3193e-06,
                    4.5621e-06,
                    4.7567e-06,
                    4.9226e-06,
                    5.0955e-06,
                    5.2486e-06,
                    5.3928e-06,
                    5.5566e-06,
                    5.7233e-06,
                    5.8751e-06,
                    6.0225e-06,
                    6.1945e-06,
                    6.3984e-06,
                    6.624e-06,
                    6.88e-06,
                    7.1323e-06,
                    7.3948e-06,
                    7.6885e-06,
                    8.0105e-06,
                    8.3237e-06,
                    8.6171e-06,
                    8.9072e-06,
                    9.217e-06,
                    9.5707e-06,
                    9.8801e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    6.6e-09,
                    1.32e-08,
                    1.815e-08,
                    2.31e-08,
                    2.97e-08,
                    3.63e-08,
                    4.455e-08,
                    5.445e-08,
                    6.6e-08,
                    7.425e-08,
                    8.25e-08,
                    9.24e-08,
                    1.0395e-07,
                    1.1715e-07,
                    1.3035e-07,
                    1.4355e-07,
                    1.584e-07,
                    1.7325e-07,
                    1.8975e-07,
                    2.112e-07,
                    2.3265e-07,
                    2.574e-07,
                    2.871e-07,
                    3.1515e-07,
                    3.432e-07,
                    3.8775e-07,
                    4.323e-07,
                    4.8345e-07,
                    5.4615e-07,
                    6.1215e-07,
                    6.831e-07,
                    7.5405e-07,
                    8.2665e-07,
                    8.9925e-07,
                    9.768e-07,
                    1.0543e-06,
                    1.127e-06,
                    1.2078e-06,
                    1.2903e-06,
                    1.3711e-06,
                    1.4602e-06,
                    1.5494e-06,
                    1.6384e-06,
                    1.7325e-06,
                    1.8265e-06,
                    1.9239e-06,
                    2.0229e-06,
                    2.1236e-06,
                    2.2325e-06,
                    2.3562e-06,
                    2.4799e-06,
                    2.6153e-06,
                    2.7489e-06,
                    2.8826e-06,
                    3.0261e-06,
                    3.1713e-06,
                    3.328e-06,
                    3.4848e-06,
                    3.6481e-06,
                    3.8164e-06,
                    4.0079e-06,
                    4.2075e-06,
                    4.4088e-06,
                    4.6002e-06,
                    4.8279e-06,
                    5.0903e-06,
                    5.3559e-06,
                    5.6232e-06,
                    5.9152e-06,
                    6.2354e-06,
                    6.5505e-06,
                    6.8914e-06,
                    7.2384e-06
                ],
                "Land_CO2": 0.01,
                "Land_CO2_timeseries": [
                    1.8876e-08,
                    3.8269e-08,
                    5.7981e-08,
                    7.788e-08,
                    9.79e-08,
                    1.18e-07,
                    1.3814e-07,
                    1.5828e-07,
                    1.7836e-07,
                    2.0378e-07,
                    2.3181e-07,
                    2.6184e-07,
                    2.9274e-07,
                    3.244e-07,
                    3.5669e-07,
                    3.895e-07,
                    4.2319e-07,
                    4.5693e-07,
                    4.9085e-07,
                    5.296e-07,
                    5.7058e-07,
                    6.1335e-07,
                    6.5667e-07,
                    7.0052e-07,
                    7.4479e-07,
                    7.8938e-07,
                    8.3479e-07,
                    8.8184e-07,
                    9.284e-07,
                    9.815e-07,
                    1.0382e-06,
                    1.0998e-06,
                    1.162e-06,
                    1.2241e-06,
                    1.2889e-06,
                    1.3544e-06,
                    1.4186e-06,
                    1.4826e-06,
                    1.5502e-06,
                    1.6313e-06,
                    1.7191e-06,
                    1.8122e-06,
                    1.9158e-06,
                    2.0131e-06,
                    2.1208e-06,
                    2.2363e-06,
                    2.3395e-06,
                    2.4522e-06,
                    2.5548e-06,
                    2.7088e-06,
                    2.8764e-06,
                    3.073e-06,
                    3.2632e-06,
                    3.4608e-06,
                    3.6649e-06,
                    3.886e-06,
                    4.109e-06,
                    4.3193e-06,
                    4.5621e-06,
                    4.7567e-06,
                    4.9226e-06,
                    5.0955e-06,
                    5.2486e-06,
                    5.3928e-06,
                    5.5566e-06,
                    5.7233e-06,
                    5.8751e-06,
                    6.0225e-06,
                    6.1945e-06,
                    6.3984e-06,
                    6.624e-06,
                    6.88e-06,
                    7.1323e-06,
                    7.3948e-06,
                    7.6885e-06,
                    8.0105e-06,
                    8.3237e-06,
                    8.6171e-06,
                    8.9072e-06,
                    9.217e-06,
                    9.5707e-06,
                    9.8801e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_CH4": 0.01,
                "Total_CH4_timeseries": [
                    2.3251e-08,
                    4.652e-08,
                    6.9809e-08,
                    9.3118e-08,
                    1.1644e-07,
                    1.3979e-07,
                    1.6316e-07,
                    1.8654e-07,
                    2.0995e-07,
                    2.3337e-07,
                    2.5717e-07,
                    2.8136e-07,
                    3.0595e-07,
                    3.3093e-07,
                    3.5629e-07,
                    3.8203e-07,
                    4.0815e-07,
                    4.3464e-07,
                    4.6152e-07,
                    4.8878e-07,
                    5.1643e-07,
                    5.4447e-07,
                    5.729e-07,
                    6.0172e-07,
                    6.3093e-07,
                    6.6053e-07,
                    6.9052e-07,
                    7.209e-07,
                    7.5168e-07,
                    7.8284e-07,
                    8.1406e-07,
                    8.4535e-07,
                    8.7667e-07,
                    9.0806e-07,
                    9.395e-07,
                    9.7119e-07,
                    1.0033e-06,
                    1.0358e-06,
                    1.0687e-06,
                    1.1021e-06,
                    1.1339e-06,
                    1.1677e-06,
                    1.2018e-06,
                    1.2362e-06,
                    1.2708e-06,
                    1.3056e-06,
                    1.3407e-06,
                    1.3761e-06,
                    1.4118e-06,
                    1.4477e-06,
                    1.4828e-06,
                    1.5178e-06,
                    1.5523e-06,
                    1.5865e-06,
                    1.6202e-06,
                    1.6534e-06,
                    1.686e-06,
                    1.718e-06,
                    1.7494e-06,
                    1.7802e-06,
                    1.819e-06,
                    1.8608e-06,
                    1.908e-06,
                    1.9606e-06,
                    2.0187e-06,
                    2.0823e-06,
                    2.1514e-06,
                    2.226e-06,
                    2.3062e-06,
                    2.3919e-06,
                    2.4895e-06,
                    2.5907e-06,
                    2.6998e-06,
                    2.8167e-06,
                    2.9415e-06,
                    3.0741e-06,
                    3.2146e-06,
                    3.3617e-06,
                    3.5156e-06,
                    3.6762e-06,
                    3.8389e-06,
                    4.0059e-06,
                    4.1767e-06,
                    4.351e-06,
                    4.5291e-06,
                    4.7117e-06,
                    4.8991e-06,
                    5.0912e-06,
                    5.2856e-06,
                    5.4873e-06,
                    5.6911e-06,
                    5.9041e-06,
                    6.1228e-06,
                    6.3473e-06,
                    6.5743e-06,
                    6.8114e-06,
                    7.0539e-06,
                    7.3027e-06,
                    7.5581e-06,
                    7.8208e-06,
                    8.0809e-06,
                    8.3446e-06,
                    8.6183e-06,
                    8.9084e-06,
                    9.2199e-06,
                    9.556e-06,
                    9.9187e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_CH4": 0.01,
                "Fossil_CH4_timeseries": [
                    2.5313e-09,
                    5.0644e-09,
                    7.5993e-09,
                    1.0136e-08,
                    1.2674e-08,
                    1.5215e-08,
                    1.7757e-08,
                    2.03e-08,
                    2.2846e-08,
                    2.5393e-08,
                    2.7982e-08,
                    3.0612e-08,
                    3.3318e-08,
                    3.6066e-08,
                    3.8856e-08,
                    4.1686e-08,
                    4.4559e-08,
                    4.7472e-08,
                    5.0427e-08,
                    5.3423e-08,
                    5.6462e-08,
                    5.9544e-08,
                    6.2667e-08,
                    6.5834e-08,
                    6.9043e-08,
                    7.2294e-08,
                    7.5588e-08,
                    7.8924e-08,
                    8.2303e-08,
                    8.5724e-08,
                    8.9151e-08,
                    9.2585e-08,
                    9.5993e-08,
                    9.9407e-08,
                    1.0283e-07,
                    1.0644e-07,
                    1.1038e-07,
                    1.1467e-07,
                    1.1934e-07,
                    1.2441e-07,
                    1.2787e-07,
                    1.333e-07,
                    1.3891e-07,
                    1.4471e-07,
                    1.507e-07,
                    1.5689e-07,
                    1.6329e-07,
                    1.6991e-07,
                    1.7674e-07,
                    1.838e-07,
                    1.909e-07,
                    1.9874e-07,
                    2.0702e-07,
                    2.1576e-07,
                    2.2499e-07,
                    2.3456e-07,
                    2.4439e-07,
                    2.5447e-07,
                    2.6483e-07,
                    2.7546e-07,
                    2.8968e-07,
                    3.0249e-07,
                    3.1622e-07,
                    3.3094e-07,
                    3.4669e-07,
                    3.6348e-07,
                    3.8133e-07,
                    4.0026e-07,
                    4.203e-07,
                    4.4147e-07,
                    4.6799e-07,
                    4.9174e-07,
                    5.168e-07,
                    5.432e-07,
                    5.7095e-07,
                    6.0007e-07,
                    6.3058e-07,
                    6.6132e-07,
                    6.9226e-07,
                    7.2338e-07,
                    7.5375e-07,
                    7.8548e-07,
                    8.1806e-07,
                    8.5127e-07,
                    8.8536e-07,
                    9.2017e-07,
                    9.5585e-07,
                    9.9242e-07,
                    1.0274e-06,
                    1.0656e-06,
                    1.1013e-06,
                    1.1417e-06,
                    1.1831e-06,
                    1.2255e-06,
                    1.2658e-06,
                    1.3112e-06,
                    1.3574e-06,
                    1.4049e-06,
                    1.4542e-06,
                    1.5058e-06,
                    1.5579e-06,
                    1.6107e-06,
                    1.665e-06,
                    1.7215e-06,
                    1.7806e-06,
                    1.843e-06,
                    1.9087e-06,
                    1.9778e-06,
                    2.052e-06,
                    2.1265e-06,
                    2.2022e-06,
                    2.2783e-06,
                    2.3547e-06,
                    2.4311e-06,
                    2.5107e-06,
                    2.5866e-06,
                    2.6632e-06,
                    2.741e-06,
                    2.8199e-06,
                    2.9116e-06,
                    3.0078e-06,
                    3.1096e-06,
                    3.2159e-06,
                    3.3232e-06,
                    3.4378e-06,
                    3.5554e-06,
                    3.6766e-06,
                    3.804e-06,
                    3.9336e-06,
                    4.0725e-06,
                    4.2172e-06,
                    4.3687e-06,
                    4.5318e-06,
                    4.7062e-06,
                    4.8947e-06,
                    5.0986e-06,
                    5.3211e-06,
                    5.5605e-06,
                    5.818e-06,
                    6.1321e-06,
                    6.4616e-06,
                    6.8072e-06,
                    7.1629e-06,
                    7.5225e-06,
                    7.8928e-06,
                    8.2697e-06,
                    8.6553e-06,
                    9.0478e-06,
                    9.4675e-06,
                    9.9211e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CH4": 0.02,
                "Land_CH4_timeseries": [
                    2.0719e-08,
                    4.1456e-08,
                    6.221e-08,
                    8.2982e-08,
                    1.0377e-07,
                    1.2458e-07,
                    1.454e-07,
                    1.6624e-07,
                    1.871e-07,
                    2.0798e-07,
                    2.2919e-07,
                    2.5074e-07,
                    2.7264e-07,
                    2.9487e-07,
                    3.1743e-07,
                    3.4034e-07,
                    3.6359e-07,
                    3.8717e-07,
                    4.111e-07,
                    4.3536e-07,
                    4.5997e-07,
                    4.8493e-07,
                    5.1023e-07,
                    5.3588e-07,
                    5.6189e-07,
                    5.8824e-07,
                    6.1493e-07,
                    6.4198e-07,
                    6.6937e-07,
                    6.9711e-07,
                    7.2491e-07,
                    7.5277e-07,
                    7.8068e-07,
                    8.0865e-07,
                    8.3667e-07,
                    8.6475e-07,
                    8.9289e-07,
                    9.2109e-07,
                    9.4934e-07,
                    9.7765e-07,
                    1.006e-06,
                    1.0344e-06,
                    1.0629e-06,
                    1.0915e-06,
                    1.1201e-06,
                    1.1487e-06,
                    1.1774e-06,
                    1.2062e-06,
                    1.235e-06,
                    1.2639e-06,
                    1.2919e-06,
                    1.3191e-06,
                    1.3453e-06,
                    1.3707e-06,
                    1.3952e-06,
                    1.4189e-06,
                    1.4416e-06,
                    1.4635e-06,
                    1.4846e-06,
                    1.5047e-06,
                    1.5293e-06,
                    1.5583e-06,
                    1.5918e-06,
                    1.6297e-06,
                    1.6721e-06,
                    1.7188e-06,
                    1.7701e-06,
                    1.8258e-06,
                    1.8859e-06,
                    1.9504e-06,
                    2.0215e-06,
                    2.099e-06,
                    2.183e-06,
                    2.2735e-06,
                    2.3705e-06,
                    2.474e-06,
                    2.584e-06,
                    2.7004e-06,
                    2.8234e-06,
                    2.9528e-06,
                    3.0852e-06,
                    3.2204e-06,
                    3.3586e-06,
                    3.4997e-06,
                    3.6437e-06,
                    3.7915e-06,
                    3.9432e-06,
                    4.0988e-06,
                    4.2583e-06,
                    4.4217e-06,
                    4.5897e-06,
                    4.7624e-06,
                    4.9397e-06,
                    5.1218e-06,
                    5.3085e-06,
                    5.5001e-06,
                    5.6965e-06,
                    5.8977e-06,
                    6.1039e-06,
                    6.315e-06,
                    6.523e-06,
                    6.7339e-06,
                    6.9534e-06,
                    7.1869e-06,
                    7.4393e-06,
                    7.713e-06,
                    8.01e-06,
                    8.3302e-06,
                    8.6717e-06,
                    9.0307e-06,
                    9.3333e-06,
                    9.6591e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_N2O": 0.01,
                "Total_N2O_timeseries": [
                    3.7345e-09,
                    7.5418e-09,
                    1.1419e-08,
                    1.5362e-08,
                    1.9365e-08,
                    2.3421e-08,
                    2.7524e-08,
                    3.1663e-08,
                    3.5829e-08,
                    4.0011e-08,
                    4.4202e-08,
                    4.8399e-08,
                    5.2602e-08,
                    5.681e-08,
                    6.1021e-08,
                    6.5237e-08,
                    6.9457e-08,
                    7.3684e-08,
                    7.7917e-08,
                    8.216e-08,
                    8.6472e-08,
                    9.0956e-08,
                    9.5692e-08,
                    1.0073e-07,
                    1.0612e-07,
                    1.1184e-07,
                    1.179e-07,
                    1.2424e-07,
                    1.3082e-07,
                    1.3752e-07,
                    1.4431e-07,
                    1.5117e-07,
                    1.5807e-07,
                    1.6503e-07,
                    1.7204e-07,
                    1.7908e-07,
                    1.8616e-07,
                    1.9329e-07,
                    2.0047e-07,
                    2.0801e-07,
                    2.1563e-07,
                    2.2332e-07,
                    2.311e-07,
                    2.3896e-07,
                    2.4691e-07,
                    2.5495e-07,
                    2.6309e-07,
                    2.7132e-07,
                    2.7966e-07,
                    2.881e-07,
                    2.9664e-07,
                    3.0528e-07,
                    3.1403e-07,
                    3.2288e-07,
                    3.3185e-07,
                    3.4094e-07,
                    3.5015e-07,
                    3.5952e-07,
                    3.6904e-07,
                    3.7875e-07,
                    3.8871e-07,
                    3.9905e-07,
                    4.0987e-07,
                    4.2124e-07,
                    4.3323e-07,
                    4.4587e-07,
                    4.5918e-07,
                    4.7314e-07,
                    4.8773e-07,
                    5.0289e-07,
                    5.1865e-07,
                    5.3507e-07,
                    5.5219e-07,
                    5.7002e-07,
                    5.8855e-07,
                    6.0772e-07,
                    6.2745e-07,
                    6.4762e-07,
                    6.681e-07,
                    6.8871e-07,
                    7.0928e-07,
                    7.2967e-07,
                    7.4978e-07,
                    7.6954e-07,
                    7.8893e-07,
                    8.0795e-07,
                    8.2663e-07,
                    8.4505e-07,
                    8.633e-07,
                    8.8152e-07,
                    9.0152e-07,
                    9.2622e-07,
                    9.5785e-07,
                    9.9789e-07,
                    1.0471e-06,
                    1.1055e-06,
                    1.1724e-06,
                    1.2463e-06,
                    1.3252e-06,
                    1.4061e-06,
                    1.4864e-06,
                    1.5648e-06,
                    1.64e-06,
                    1.7115e-06,
                    1.7788e-06,
                    1.8419e-06,
                    1.9011e-06,
                    1.9573e-06,
                    2.0116e-06,
                    2.0653e-06,
                    2.1259e-06,
                    2.1891e-06,
                    2.2549e-06,
                    2.3229e-06,
                    2.3929e-06,
                    2.4652e-06,
                    2.5388e-06,
                    2.6165e-06,
                    2.697e-06,
                    2.7836e-06,
                    2.8722e-06,
                    2.9626e-06,
                    3.0567e-06,
                    3.1443e-06,
                    3.2349e-06,
                    3.3274e-06,
                    3.4266e-06,
                    3.5235e-06,
                    3.6239e-06,
                    3.7314e-06,
                    3.8329e-06,
                    3.9432e-06,
                    4.0502e-06,
                    4.1553e-06,
                    4.2666e-06,
                    4.3801e-06,
                    4.4919e-06,
                    4.6017e-06,
                    4.7176e-06,
                    4.8362e-06,
                    4.9608e-06,
                    5.0847e-06,
                    5.209e-06,
                    5.334e-06,
                    5.46e-06,
                    5.5953e-06,
                    5.7245e-06,
                    5.8633e-06,
                    5.9928e-06,
                    6.1343e-06,
                    6.2584e-06,
                    6.3837e-06,
                    6.5208e-06,
                    6.6667e-06,
                    6.8167e-06,
                    6.9759e-06,
                    7.1342e-06,
                    7.2933e-06,
                    7.464e-06,
                    7.6371e-06,
                    7.8006e-06,
                    7.9486e-06,
                    8.1047e-06,
                    8.267e-06,
                    8.4299e-06,
                    8.5927e-06,
                    8.7498e-06,
                    8.9155e-06,
                    9.0783e-06,
                    9.2454e-06,
                    9.4111e-06,
                    9.577e-06
                ],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [
                    3.8624e-10,
                    7.784e-10,
                    1.1763e-09,
                    1.5797e-09,
                    1.9882e-09,
                    2.4016e-09,
                    2.8193e-09,
                    3.2408e-09,
                    3.6656e-09,
                    4.0929e-09,
                    4.5224e-09,
                    4.954e-09,
                    5.3876e-09,
                    5.8231e-09,
                    6.2605e-09,
                    6.6999e-09,
                    7.1411e-09,
                    7.5844e-09,
                    8.0298e-09,
                    8.4774e-09,
                    8.9307e-09,
                    9.3957e-09,
                    9.877e-09,
                    1.0378e-08,
                    1.09e-08,
                    1.1444e-08,
                    1.2009e-08,
                    1.2592e-08,
                    1.3191e-08,
                    1.3798e-08,
                    1.4413e-08,
                    1.5032e-08,
                    1.5657e-08,
                    1.6286e-08,
                    1.6919e-08,
                    1.7557e-08,
                    1.8198e-08,
                    1.8844e-08,
                    1.9494e-08,
                    2.0166e-08,
                    2.0848e-08,
                    2.154e-08,
                    2.2242e-08,
                    2.2955e-08,
                    2.3679e-08,
                    2.4415e-08,
                    2.5163e-08,
                    2.5924e-08,
                    2.6698e-08,
                    2.7486e-08,
                    2.8289e-08,
                    2.9109e-08,
                    2.9949e-08,
                    3.0809e-08,
                    3.169e-08,
                    3.2591e-08,
                    3.3513e-08,
                    3.4454e-08,
                    3.5413e-08,
                    3.6388e-08,
                    3.7377e-08,
                    3.8379e-08,
                    3.9394e-08,
                    4.0421e-08,
                    4.146e-08,
                    4.2511e-08,
                    4.3574e-08,
                    4.465e-08,
                    4.5738e-08,
                    4.6838e-08,
                    4.7952e-08,
                    4.9079e-08,
                    5.0218e-08,
                    5.1371e-08,
                    5.2537e-08,
                    5.3717e-08,
                    5.4911e-08,
                    5.6119e-08,
                    5.7342e-08,
                    5.8581e-08,
                    5.9837e-08,
                    6.1113e-08,
                    6.2413e-08,
                    6.3737e-08,
                    6.5089e-08,
                    6.6469e-08,
                    6.788e-08,
                    6.9324e-08,
                    7.0801e-08,
                    7.2312e-08,
                    7.3867e-08,
                    7.5486e-08,
                    7.7181e-08,
                    7.8964e-08,
                    8.0843e-08,
                    8.2819e-08,
                    8.4895e-08,
                    8.7066e-08,
                    8.9325e-08,
                    9.1662e-08,
                    9.4073e-08,
                    9.6561e-08,
                    9.9131e-08,
                    1.0178e-07,
                    1.0452e-07,
                    1.0733e-07,
                    1.1023e-07,
                    1.1321e-07,
                    1.1626e-07,
                    1.1938e-07,
                    1.2257e-07,
                    1.2583e-07,
                    1.2917e-07,
                    1.326e-07,
                    1.3612e-07,
                    1.3973e-07,
                    1.4344e-07,
                    1.4725e-07,
                    1.5116e-07,
                    1.5565e-07,
                    1.6024e-07,
                    1.6491e-07,
                    1.6976e-07,
                    1.7456e-07,
                    1.7947e-07,
                    1.8454e-07,
                    1.897e-07,
                    1.9543e-07,
                    2.0106e-07,
                    2.0679e-07,
                    2.129e-07,
                    2.2042e-07,
                    2.2798e-07,
                    2.3536e-07,
                    2.4344e-07,
                    2.5203e-07,
                    2.607e-07,
                    2.6958e-07,
                    2.7877e-07,
                    2.8877e-07,
                    2.9925e-07,
                    3.0976e-07,
                    3.204e-07,
                    3.313e-07,
                    3.4256e-07,
                    3.5391e-07,
                    3.6549e-07,
                    3.7741e-07,
                    3.9008e-07,
                    4.0482e-07,
                    4.2e-07,
                    4.3556e-07,
                    4.5148e-07,
                    4.6794e-07,
                    4.8488e-07,
                    5.0237e-07,
                    5.205e-07,
                    5.3936e-07,
                    5.5921e-07,
                    5.799e-07,
                    6.0152e-07,
                    6.2347e-07,
                    6.4566e-07,
                    6.687e-07,
                    6.9233e-07,
                    7.1678e-07,
                    7.4198e-07,
                    7.6773e-07,
                    7.9418e-07,
                    8.213e-07,
                    8.4917e-07,
                    8.7743e-07
                ],
                "Land_N2O": 0.01,
                "Land_N2O_timeseries": [
                    3.3482e-09,
                    6.7634e-09,
                    1.0243e-08,
                    1.3782e-08,
                    1.7376e-08,
                    2.102e-08,
                    2.4704e-08,
                    2.8422e-08,
                    3.2164e-08,
                    3.5919e-08,
                    3.968e-08,
                    4.3445e-08,
                    4.7215e-08,
                    5.0987e-08,
                    5.4761e-08,
                    5.8537e-08,
                    6.2316e-08,
                    6.6099e-08,
                    6.9887e-08,
                    7.3682e-08,
                    7.7541e-08,
                    8.156e-08,
                    8.5815e-08,
                    9.0357e-08,
                    9.5216e-08,
                    1.004e-07,
                    1.0589e-07,
                    1.1165e-07,
                    1.1762e-07,
                    1.2373e-07,
                    1.299e-07,
                    1.3613e-07,
                    1.4242e-07,
                    1.4875e-07,
                    1.5512e-07,
                    1.6152e-07,
                    1.6796e-07,
                    1.7445e-07,
                    1.8097e-07,
                    1.8784e-07,
                    1.9478e-07,
                    2.0178e-07,
                    2.0886e-07,
                    2.16e-07,
                    2.2323e-07,
                    2.3054e-07,
                    2.3793e-07,
                    2.454e-07,
                    2.5296e-07,
                    2.6061e-07,
                    2.6835e-07,
                    2.7618e-07,
                    2.8408e-07,
                    2.9208e-07,
                    3.0016e-07,
                    3.0834e-07,
                    3.1664e-07,
                    3.2506e-07,
                    3.3363e-07,
                    3.4236e-07,
                    3.5133e-07,
                    3.6067e-07,
                    3.7047e-07,
                    3.8082e-07,
                    3.9177e-07,
                    4.0336e-07,
                    4.156e-07,
                    4.2849e-07,
                    4.4199e-07,
                    4.5605e-07,
                    4.7069e-07,
                    4.8599e-07,
                    5.0197e-07,
                    5.1865e-07,
                    5.3601e-07,
                    5.54e-07,
                    5.7254e-07,
                    5.915e-07,
                    6.1076e-07,
                    6.3013e-07,
                    6.4944e-07,
                    6.6855e-07,
                    6.8736e-07,
                    7.0581e-07,
                    7.2385e-07,
                    7.4148e-07,
                    7.5875e-07,
                    7.7572e-07,
                    7.925e-07,
                    8.0921e-07,
                    8.2765e-07,
                    8.5074e-07,
                    8.8067e-07,
                    9.1893e-07,
                    9.6626e-07,
                    1.0227e-06,
                    1.0875e-06,
                    1.1593e-06,
                    1.2359e-06,
                    1.3144e-06,
                    1.3923e-06,
                    1.4682e-06,
                    1.5409e-06,
                    1.6097e-06,
                    1.6742e-06,
                    1.7345e-06,
                    1.7909e-06,
                    1.8441e-06,
                    1.8953e-06,
                    1.9459e-06,
                    2.0034e-06,
                    2.0633e-06,
                    2.1258e-06,
                    2.1903e-06,
                    2.2568e-06,
                    2.3254e-06,
                    2.3953e-06,
                    2.4693e-06,
                    2.5459e-06,
                    2.6279e-06,
                    2.712e-06,
                    2.7977e-06,
                    2.8869e-06,
                    2.9698e-06,
                    3.0554e-06,
                    3.1429e-06,
                    3.2369e-06,
                    3.3281e-06,
                    3.4229e-06,
                    3.5246e-06,
                    3.62e-06,
                    3.7227e-06,
                    3.8223e-06,
                    3.92e-06,
                    4.0232e-06,
                    4.1281e-06,
                    4.2312e-06,
                    4.3321e-06,
                    4.4389e-06,
                    4.5474e-06,
                    4.6616e-06,
                    4.7749e-06,
                    4.8886e-06,
                    5.0027e-06,
                    5.1174e-06,
                    5.2414e-06,
                    5.359e-06,
                    5.4859e-06,
                    5.6028e-06,
                    5.7295e-06,
                    5.8384e-06,
                    5.9481e-06,
                    6.0693e-06,
                    6.1988e-06,
                    6.3318e-06,
                    6.4735e-06,
                    6.6137e-06,
                    6.7539e-06,
                    6.9048e-06,
                    7.0572e-06,
                    7.1991e-06,
                    7.3251e-06,
                    7.4591e-06,
                    7.5983e-06,
                    7.7375e-06,
                    7.8759e-06,
                    8.0078e-06,
                    8.1477e-06,
                    8.2841e-06,
                    8.4241e-06,
                    8.562e-06,
                    8.6996e-06
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -16.74704,
                            13.06367
                        ],
                        [
                            -16.67247,
                            13.16669
                        ],
                        [
                            -15.80431,
                            13.16703
                        ],
                        [
                            -15.80247,
                            13.34642
                        ],
                        [
                            -15.67276,
                            13.37453
                        ],
                        [
                            -15.62901,
                            13.35975
                        ],
                        [
                            -15.52075,
                            13.40144
                        ],
                        [
                            -15.37508,
                            13.34787
                        ],
                        [
                            -15.32873,
                            13.34751
                        ],
                        [
                            -15.23881,
                            13.39666
                        ],
                        [
                            -15.215,
                            13.4451
                        ],
                        [
                            -15.21732,
                            13.538
                        ],
                        [
                            -15.07213,
                            13.59749
                        ],
                        [
                            -15.00411,
                            13.49621
                        ],
                        [
                            -14.90663,
                            13.45551
                        ],
                        [
                            -14.75635,
                            13.43329
                        ],
                        [
                            -14.6817,
                            13.3505
                        ],
                        [
                            -14.57642,
                            13.36581
                        ],
                        [
                            -14.54876,
                            13.32794
                        ],
                        [
                            -14.45821,
                            13.29406
                        ],
                        [
                            -14.36005,
                            13.23557
                        ],
                        [
                            -14.27216,
                            13.24385
                        ],
                        [
                            -14.20634,
                            13.22556
                        ],
                        [
                            -14.12119,
                            13.28398
                        ],
                        [
                            -14.00955,
                            13.30137
                        ],
                        [
                            -13.95367,
                            13.33079
                        ],
                        [
                            -13.83786,
                            13.33585
                        ],
                        [
                            -13.80266,
                            13.39923
                        ],
                        [
                            -13.81034,
                            13.44532
                        ],
                        [
                            -13.87613,
                            13.53146
                        ],
                        [
                            -13.93783,
                            13.56536
                        ],
                        [
                            -14.03189,
                            13.54009
                        ],
                        [
                            -14.10036,
                            13.54165
                        ],
                        [
                            -14.17718,
                            13.51338
                        ],
                        [
                            -14.24685,
                            13.45469
                        ],
                        [
                            -14.33315,
                            13.44671
                        ],
                        [
                            -14.42533,
                            13.49883
                        ],
                        [
                            -14.50051,
                            13.6133
                        ],
                        [
                            -14.57826,
                            13.65545
                        ],
                        [
                            -14.6817,
                            13.62161
                        ],
                        [
                            -14.80044,
                            13.65507
                        ],
                        [
                            -14.82189,
                            13.75351
                        ],
                        [
                            -14.89388,
                            13.79779
                        ],
                        [
                            -15.04125,
                            13.81561
                        ],
                        [
                            -15.11102,
                            13.80467
                        ],
                        [
                            -15.22426,
                            13.74609
                        ],
                        [
                            -15.30667,
                            13.78427
                        ],
                        [
                            -15.38613,
                            13.76269
                        ],
                        [
                            -15.45146,
                            13.67838
                        ],
                        [
                            -15.47965,
                            13.58296
                        ],
                        [
                            -15.72535,
                            13.5919
                        ],
                        [
                            -16.50677,
                            13.59091
                        ],
                        [
                            -16.51517,
                            13.59091
                        ],
                        [
                            -16.54667,
                            13.59091
                        ],
                        [
                            -16.53646,
                            13.50338
                        ],
                        [
                            -16.57014,
                            13.45895
                        ],
                        [
                            -16.65682,
                            13.4746
                        ],
                        [
                            -16.72269,
                            13.44999
                        ],
                        [
                            -16.79406,
                            13.37941
                        ],
                        [
                            -16.80676,
                            13.27618
                        ],
                        [
                            -16.78703,
                            13.15946
                        ],
                        [
                            -16.74704,
                            13.06367
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "GEO",
                "Country": "Georgia",
                "Total_3GHG": 0.03,
                "Total_3GHG_timeseries": [
                    2.7232e-06,
                    5.4307e-06,
                    8.1119e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Fossil_3GHG": 0.04,
                "Fossil_3GHG_timeseries": [
                    8.1962e-08,
                    1.7081e-07,
                    2.6664e-07,
                    3.6957e-07,
                    4.8043e-07,
                    5.9789e-07,
                    7.2279e-07,
                    8.5623e-07,
                    9.9516e-07,
                    1.1399e-06,
                    1.2931e-06,
                    1.4542e-06,
                    1.6235e-06,
                    1.8046e-06,
                    1.9972e-06,
                    2.2055e-06,
                    2.4266e-06,
                    2.6592e-06,
                    2.9065e-06,
                    3.1672e-06,
                    3.4379e-06,
                    3.7176e-06,
                    4.0058e-06,
                    4.3054e-06,
                    4.6163e-06,
                    4.9404e-06,
                    5.2748e-06,
                    5.6246e-06,
                    5.9873e-06,
                    6.3666e-06,
                    6.7582e-06,
                    7.1641e-06,
                    7.5873e-06,
                    8.0219e-06,
                    8.4708e-06,
                    8.9138e-06,
                    9.353e-06,
                    9.7872e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Land_3GHG": 0.02,
                "Land_3GHG_timeseries": [
                    2.6412e-06,
                    5.2599e-06,
                    7.8453e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_CO2": 0.03,
                "Total_CO2_timeseries": [
                    2.4867e-06,
                    4.9499e-06,
                    7.3789e-06,
                    9.8516e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_CO2": 0.04,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    6.3676e-10,
                    6.3676e-10,
                    6.3676e-10,
                    1.5311e-09,
                    2.4795e-09,
                    3.7328e-09,
                    5.3247e-09,
                    6.7608e-09,
                    8.2649e-09,
                    9.9518e-09,
                    1.1564e-08,
                    1.6658e-08,
                    2.2504e-08,
                    2.7368e-08,
                    3.3966e-08,
                    4.1127e-08,
                    5.0794e-08,
                    6.0718e-08,
                    7.0033e-08,
                    8.1339e-08,
                    9.4353e-08,
                    1.1051e-07,
                    1.27e-07,
                    1.4855e-07,
                    1.7066e-07,
                    1.966e-07,
                    2.2392e-07,
                    2.527e-07,
                    2.8545e-07,
                    3.187e-07,
                    3.5493e-07,
                    3.9208e-07,
                    4.3139e-07,
                    4.7239e-07,
                    5.1668e-07,
                    5.6683e-07,
                    6.2204e-07,
                    6.8049e-07,
                    7.49e-07,
                    8.1878e-07,
                    8.9895e-07,
                    9.8057e-07,
                    1.0749e-06,
                    1.1808e-06,
                    1.3035e-06,
                    1.4426e-06,
                    1.5854e-06,
                    1.7233e-06,
                    1.8582e-06,
                    2.0083e-06,
                    2.1423e-06,
                    2.2951e-06,
                    2.4663e-06,
                    2.6385e-06,
                    2.8203e-06,
                    2.9986e-06,
                    3.1834e-06,
                    3.3928e-06,
                    3.6203e-06,
                    3.8256e-06,
                    4.014e-06,
                    4.2148e-06,
                    4.3996e-06,
                    4.4734e-06,
                    4.5363e-06,
                    4.5937e-06,
                    4.656e-06,
                    4.7319e-06,
                    4.8158e-06,
                    4.9157e-06,
                    5.0144e-06,
                    5.1573e-06,
                    5.335e-06,
                    5.5301e-06,
                    5.7404e-06,
                    6.0273e-06,
                    6.3722e-06,
                    6.7605e-06,
                    7.195e-06,
                    7.7202e-06,
                    8.3138e-06,
                    8.9934e-06,
                    9.689e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [
                    2.4867e-06,
                    4.9499e-06,
                    7.3789e-06,
                    9.8516e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    7.3037e-06
                ],
                "Total_CH4": 0.03,
                "Total_CH4_timeseries": [
                    1.8392e-07,
                    3.7472e-07,
                    5.7252e-07,
                    7.7742e-07,
                    9.8962e-07,
                    1.2091e-06,
                    1.436e-06,
                    1.6706e-06,
                    1.9106e-06,
                    2.1562e-06,
                    2.4186e-06,
                    2.6977e-06,
                    2.9938e-06,
                    3.31e-06,
                    3.6466e-06,
                    4.0041e-06,
                    4.3825e-06,
                    4.7819e-06,
                    5.203e-06,
                    5.6457e-06,
                    6.1052e-06,
                    6.583e-06,
                    7.0791e-06,
                    7.594e-06,
                    8.1278e-06,
                    8.681e-06,
                    9.2533e-06,
                    9.8454e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_CH4": 0.03,
                "Fossil_CH4_timeseries": [
                    6.9597e-08,
                    1.4593e-07,
                    2.2911e-07,
                    3.1926e-07,
                    4.1656e-07,
                    5.2097e-07,
                    6.3268e-07,
                    7.5193e-07,
                    8.7649e-07,
                    1.0065e-06,
                    1.1444e-06,
                    1.2903e-06,
                    1.4443e-06,
                    1.6097e-06,
                    1.7866e-06,
                    1.9757e-06,
                    2.1767e-06,
                    2.3901e-06,
                    2.6163e-06,
                    2.8553e-06,
                    3.1015e-06,
                    3.3565e-06,
                    3.6201e-06,
                    3.893e-06,
                    4.1751e-06,
                    4.4671e-06,
                    4.7686e-06,
                    5.0803e-06,
                    5.4041e-06,
                    5.7405e-06,
                    6.0877e-06,
                    6.4475e-06,
                    6.8206e-06,
                    7.2044e-06,
                    7.5994e-06,
                    7.9875e-06,
                    8.3695e-06,
                    8.7446e-06,
                    9.1123e-06,
                    9.4735e-06,
                    9.8504e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CH4": 0.03,
                "Land_CH4_timeseries": [
                    1.1432e-07,
                    2.2879e-07,
                    3.434e-07,
                    4.5816e-07,
                    5.7306e-07,
                    6.8811e-07,
                    8.033e-07,
                    9.1863e-07,
                    1.0341e-06,
                    1.1497e-06,
                    1.2742e-06,
                    1.4074e-06,
                    1.5495e-06,
                    1.7003e-06,
                    1.86e-06,
                    2.0284e-06,
                    2.2057e-06,
                    2.3918e-06,
                    2.5867e-06,
                    2.7904e-06,
                    3.0037e-06,
                    3.2266e-06,
                    3.459e-06,
                    3.701e-06,
                    3.9527e-06,
                    4.2139e-06,
                    4.4847e-06,
                    4.7651e-06,
                    5.055e-06,
                    5.3546e-06,
                    5.6564e-06,
                    5.9606e-06,
                    6.2671e-06,
                    6.5758e-06,
                    6.8869e-06,
                    7.2003e-06,
                    7.516e-06,
                    7.834e-06,
                    8.1543e-06,
                    8.4769e-06,
                    8.8019e-06,
                    9.1295e-06,
                    9.4595e-06,
                    9.7921e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_N2O": 0.09,
                "Total_N2O_timeseries": [
                    5.2564e-08,
                    1.0608e-07,
                    1.605e-07,
                    2.1578e-07,
                    2.7185e-07,
                    3.2865e-07,
                    3.8607e-07,
                    4.4401e-07,
                    5.0236e-07,
                    5.6097e-07,
                    6.1976e-07,
                    6.7872e-07,
                    7.3782e-07,
                    7.9706e-07,
                    8.5643e-07,
                    9.1593e-07,
                    9.7557e-07,
                    1.0354e-06,
                    1.0953e-06,
                    1.1555e-06,
                    1.2165e-06,
                    1.2797e-06,
                    1.3459e-06,
                    1.4159e-06,
                    1.49e-06,
                    1.5682e-06,
                    1.6505e-06,
                    1.7362e-06,
                    1.8247e-06,
                    1.915e-06,
                    2.0062e-06,
                    2.0983e-06,
                    2.1912e-06,
                    2.2847e-06,
                    2.3788e-06,
                    2.4735e-06,
                    2.5688e-06,
                    2.6646e-06,
                    2.7611e-06,
                    2.8596e-06,
                    2.9596e-06,
                    3.061e-06,
                    3.1638e-06,
                    3.2678e-06,
                    3.3731e-06,
                    3.4795e-06,
                    3.5869e-06,
                    3.6951e-06,
                    3.804e-06,
                    3.9133e-06,
                    4.023e-06,
                    4.1331e-06,
                    4.2435e-06,
                    4.3542e-06,
                    4.4652e-06,
                    4.5765e-06,
                    4.6882e-06,
                    4.8002e-06,
                    4.9126e-06,
                    5.0253e-06,
                    5.1395e-06,
                    5.2569e-06,
                    5.3787e-06,
                    5.5059e-06,
                    5.6391e-06,
                    5.7784e-06,
                    5.9236e-06,
                    6.0739e-06,
                    6.2284e-06,
                    6.3856e-06,
                    6.5447e-06,
                    6.7056e-06,
                    6.8685e-06,
                    7.0332e-06,
                    7.1997e-06,
                    7.368e-06,
                    7.5378e-06,
                    7.709e-06,
                    7.8815e-06,
                    8.055e-06,
                    8.2292e-06,
                    8.4038e-06,
                    8.5786e-06,
                    8.7537e-06,
                    8.929e-06,
                    9.1048e-06,
                    9.2814e-06,
                    9.4595e-06,
                    9.6394e-06,
                    9.8221e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_N2O": 0.15,
                "Fossil_N2O_timeseries": [
                    1.2365e-08,
                    2.4873e-08,
                    3.7522e-08,
                    5.0309e-08,
                    6.3232e-08,
                    7.6286e-08,
                    8.9468e-08,
                    1.0277e-07,
                    1.1619e-07,
                    1.2972e-07,
                    1.4336e-07,
                    1.5711e-07,
                    1.7095e-07,
                    1.8491e-07,
                    1.9896e-07,
                    2.1312e-07,
                    2.2739e-07,
                    2.4176e-07,
                    2.5623e-07,
                    2.7082e-07,
                    2.8554e-07,
                    3.0046e-07,
                    3.1563e-07,
                    3.3106e-07,
                    3.4679e-07,
                    3.6282e-07,
                    3.7913e-07,
                    3.957e-07,
                    4.1251e-07,
                    4.2949e-07,
                    4.4662e-07,
                    4.6388e-07,
                    4.8128e-07,
                    4.9881e-07,
                    5.1647e-07,
                    5.3425e-07,
                    5.5215e-07,
                    5.7018e-07,
                    5.8834e-07,
                    6.0675e-07,
                    6.2532e-07,
                    6.4406e-07,
                    6.6297e-07,
                    6.8205e-07,
                    7.0131e-07,
                    7.2075e-07,
                    7.4038e-07,
                    7.602e-07,
                    7.8021e-07,
                    8.0043e-07,
                    8.2085e-07,
                    8.4151e-07,
                    8.6241e-07,
                    8.8356e-07,
                    9.0496e-07,
                    9.2663e-07,
                    9.4855e-07,
                    9.7073e-07,
                    9.9316e-07,
                    1.0158e-06,
                    1.0387e-06,
                    1.0618e-06,
                    1.0851e-06,
                    1.1086e-06,
                    1.1323e-06,
                    1.1562e-06,
                    1.1804e-06,
                    1.2047e-06,
                    1.2293e-06,
                    1.2541e-06,
                    1.2793e-06,
                    1.3048e-06,
                    1.3309e-06,
                    1.3575e-06,
                    1.3848e-06,
                    1.4128e-06,
                    1.4416e-06,
                    1.4713e-06,
                    1.5018e-06,
                    1.5331e-06,
                    1.5658e-06,
                    1.6006e-06,
                    1.6382e-06,
                    1.679e-06,
                    1.7234e-06,
                    1.7716e-06,
                    1.8238e-06,
                    1.8798e-06,
                    1.9395e-06,
                    2.0026e-06,
                    2.0687e-06,
                    2.1378e-06,
                    2.2099e-06,
                    2.2851e-06,
                    2.3634e-06,
                    2.4451e-06,
                    2.5304e-06,
                    2.6197e-06,
                    2.7134e-06,
                    2.8119e-06,
                    2.9179e-06,
                    3.0356e-06,
                    3.1686e-06,
                    3.3197e-06,
                    3.4912e-06,
                    3.6848e-06,
                    3.9013e-06,
                    4.141e-06,
                    4.4036e-06,
                    4.6878e-06,
                    4.9981e-06,
                    5.3426e-06,
                    5.727e-06,
                    6.1545e-06,
                    6.6257e-06,
                    7.1386e-06,
                    7.6887e-06,
                    8.2689e-06,
                    8.8695e-06,
                    9.4006e-06,
                    9.9511e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.07,
                "Land_N2O_timeseries": [
                    4.0199e-08,
                    8.1202e-08,
                    1.2297e-07,
                    1.6547e-07,
                    2.0862e-07,
                    2.5236e-07,
                    2.966e-07,
                    3.4124e-07,
                    3.8616e-07,
                    4.3124e-07,
                    4.764e-07,
                    5.2161e-07,
                    5.6686e-07,
                    6.1215e-07,
                    6.5746e-07,
                    7.028e-07,
                    7.4818e-07,
                    7.9359e-07,
                    8.3907e-07,
                    8.8463e-07,
                    9.3096e-07,
                    9.7922e-07,
                    1.0303e-06,
                    1.0848e-06,
                    1.1432e-06,
                    1.2054e-06,
                    1.2713e-06,
                    1.3405e-06,
                    1.4122e-06,
                    1.4855e-06,
                    1.5596e-06,
                    1.6344e-06,
                    1.7099e-06,
                    1.7859e-06,
                    1.8623e-06,
                    1.9392e-06,
                    2.0166e-06,
                    2.0944e-06,
                    2.1728e-06,
                    2.2529e-06,
                    2.3343e-06,
                    2.4169e-06,
                    2.5008e-06,
                    2.5858e-06,
                    2.6718e-06,
                    2.7588e-06,
                    2.8465e-06,
                    2.9349e-06,
                    3.0238e-06,
                    3.1129e-06,
                    3.2022e-06,
                    3.2916e-06,
                    3.3811e-06,
                    3.4706e-06,
                    3.5602e-06,
                    3.6499e-06,
                    3.7396e-06,
                    3.8294e-06,
                    3.9194e-06,
                    4.0095e-06,
                    4.1008e-06,
                    4.1951e-06,
                    4.2936e-06,
                    4.3973e-06,
                    4.5068e-06,
                    4.6222e-06,
                    4.7432e-06,
                    4.8692e-06,
                    4.9991e-06,
                    5.1315e-06,
                    5.2654e-06,
                    5.4008e-06,
                    5.5376e-06,
                    5.6757e-06,
                    5.8149e-06,
                    5.9551e-06,
                    6.0961e-06,
                    6.2377e-06,
                    6.3797e-06,
                    6.5219e-06,
                    6.6634e-06,
                    6.8032e-06,
                    6.9404e-06,
                    7.0747e-06,
                    7.2055e-06,
                    7.3331e-06,
                    7.4576e-06,
                    7.5796e-06,
                    7.6999e-06,
                    7.8196e-06,
                    7.9409e-06,
                    8.067e-06,
                    8.2002e-06,
                    8.3422e-06,
                    8.4941e-06,
                    8.6565e-06,
                    8.829e-06,
                    9.0111e-06,
                    9.2013e-06,
                    9.3974e-06,
                    9.5986e-06,
                    9.8053e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            46.4205,
                            41.90428
                        ],
                        [
                            46.39798,
                            41.94031
                        ],
                        [
                            46.28671,
                            41.94491
                        ],
                        [
                            46.22633,
                            42.01471
                        ],
                        [
                            46.10761,
                            41.98709
                        ],
                        [
                            45.89759,
                            42.10518
                        ],
                        [
                            45.78548,
                            42.10268
                        ],
                        [
                            45.74561,
                            42.14865
                        ],
                        [
                            45.60948,
                            42.21144
                        ],
                        [
                            45.65075,
                            42.29091
                        ],
                        [
                            45.75163,
                            42.30773
                        ],
                        [
                            45.73561,
                            42.37765
                        ],
                        [
                            45.78073,
                            42.44807
                        ],
                        [
                            45.68543,
                            42.50588
                        ],
                        [
                            45.57242,
                            42.54791
                        ],
                        [
                            45.40482,
                            42.54892
                        ],
                        [
                            45.35386,
                            42.52243
                        ],
                        [
                            45.28345,
                            42.60611
                        ],
                        [
                            45.15924,
                            42.70729
                        ],
                        [
                            45.03691,
                            42.6932
                        ],
                        [
                            44.98003,
                            42.74434
                        ],
                        [
                            44.88739,
                            42.74622
                        ],
                        [
                            44.85711,
                            42.67837
                        ],
                        [
                            44.7669,
                            42.64294
                        ],
                        [
                            44.75004,
                            42.71644
                        ],
                        [
                            44.67879,
                            42.75624
                        ],
                        [
                            44.41877,
                            42.71908
                        ],
                        [
                            44.31494,
                            42.72215
                        ],
                        [
                            44.22358,
                            42.63052
                        ],
                        [
                            44.00869,
                            42.58954
                        ],
                        [
                            43.96335,
                            42.54747
                        ],
                        [
                            43.83933,
                            42.59683
                        ],
                        [
                            43.76833,
                            42.59012
                        ],
                        [
                            43.71743,
                            42.63207
                        ],
                        [
                            43.80316,
                            42.71595
                        ],
                        [
                            43.77642,
                            42.75941
                        ],
                        [
                            43.61109,
                            42.81395
                        ],
                        [
                            43.56121,
                            42.86678
                        ],
                        [
                            43.18685,
                            42.93837
                        ],
                        [
                            43.03686,
                            43.02972
                        ],
                        [
                            42.99162,
                            43.11766
                        ],
                        [
                            42.85861,
                            43.17774
                        ],
                        [
                            42.68073,
                            43.17098
                        ],
                        [
                            42.67152,
                            43.1361
                        ],
                        [
                            42.45962,
                            43.21286
                        ],
                        [
                            42.44212,
                            43.25009
                        ],
                        [
                            42.25939,
                            43.21281
                        ],
                        [
                            42.21264,
                            43.22952
                        ],
                        [
                            42.09262,
                            43.21218
                        ],
                        [
                            41.86588,
                            43.24171
                        ],
                        [
                            41.80679,
                            43.20395
                        ],
                        [
                            41.72305,
                            43.23996
                        ],
                        [
                            41.62137,
                            43.22284
                        ],
                        [
                            41.42415,
                            43.31422
                        ],
                        [
                            41.36565,
                            43.36886
                        ],
                        [
                            41.2916,
                            43.33872
                        ],
                        [
                            41.15071,
                            43.40313
                        ],
                        [
                            41.04442,
                            43.39755
                        ],
                        [
                            40.95174,
                            43.41982
                        ],
                        [
                            40.87573,
                            43.48554
                        ],
                        [
                            40.69487,
                            43.5348
                        ],
                        [
                            40.66426,
                            43.56225
                        ],
                        [
                            40.56718,
                            43.52004
                        ],
                        [
                            40.47953,
                            43.54759
                        ],
                        [
                            40.25687,
                            43.58548
                        ],
                        [
                            40.1077,
                            43.56858
                        ],
                        [
                            40.0103,
                            43.38529
                        ],
                        [
                            40.07964,
                            43.37708
                        ],
                        [
                            40.24175,
                            43.317
                        ],
                        [
                            40.2792,
                            43.18732
                        ],
                        [
                            40.34335,
                            43.14621
                        ],
                        [
                            40.40594,
                            43.17079
                        ],
                        [
                            40.50738,
                            43.14412
                        ],
                        [
                            40.58111,
                            43.09132
                        ],
                        [
                            40.86413,
                            43.07253
                        ],
                        [
                            40.96852,
                            42.98177
                        ],
                        [
                            41.04944,
                            42.98999
                        ],
                        [
                            41.10586,
                            42.84444
                        ],
                        [
                            41.14929,
                            42.79713
                        ],
                        [
                            41.22396,
                            42.80164
                        ],
                        [
                            41.39934,
                            42.75814
                        ],
                        [
                            41.45302,
                            42.72344
                        ],
                        [
                            41.51525,
                            42.58881
                        ],
                        [
                            41.54683,
                            42.4176
                        ],
                        [
                            41.59527,
                            42.36589
                        ],
                        [
                            41.63936,
                            42.24627
                        ],
                        [
                            41.66028,
                            42.1326
                        ],
                        [
                            41.753,
                            42.01431
                        ],
                        [
                            41.77748,
                            41.86147
                        ],
                        [
                            41.71713,
                            41.70582
                        ],
                        [
                            41.57101,
                            41.60222
                        ],
                        [
                            41.54713,
                            41.52038
                        ],
                        [
                            41.63507,
                            41.48681
                        ],
                        [
                            41.78439,
                            41.46113
                        ],
                        [
                            41.82198,
                            41.43211
                        ],
                        [
                            41.9612,
                            41.52402
                        ],
                        [
                            42.28271,
                            41.49268
                        ],
                        [
                            42.46992,
                            41.43551
                        ],
                        [
                            42.57164,
                            41.50953
                        ],
                        [
                            42.60137,
                            41.58464
                        ],
                        [
                            42.69721,
                            41.60038
                        ],
                        [
                            42.77942,
                            41.57771
                        ],
                        [
                            42.79792,
                            41.51745
                        ],
                        [
                            42.96798,
                            41.45032
                        ],
                        [
                            43.02022,
                            41.3808
                        ],
                        [
                            43.21231,
                            41.28994
                        ],
                        [
                            43.19476,
                            41.25303
                        ],
                        [
                            43.23618,
                            41.18556
                        ],
                        [
                            43.37844,
                            41.20196
                        ],
                        [
                            43.4481,
                            41.17607
                        ],
                        [
                            43.47383,
                            41.1233
                        ],
                        [
                            43.5674,
                            41.14422
                        ],
                        [
                            43.75147,
                            41.11039
                        ],
                        [
                            43.83969,
                            41.16031
                        ],
                        [
                            43.96206,
                            41.16557
                        ],
                        [
                            44.05443,
                            41.1906
                        ],
                        [
                            44.1598,
                            41.18924
                        ],
                        [
                            44.18127,
                            41.22813
                        ],
                        [
                            44.27218,
                            41.2136
                        ],
                        [
                            44.35682,
                            41.23064
                        ],
                        [
                            44.46832,
                            41.18161
                        ],
                        [
                            44.54777,
                            41.1952
                        ],
                        [
                            44.61255,
                            41.24057
                        ],
                        [
                            44.84105,
                            41.21578
                        ],
                        [
                            44.80657,
                            41.28769
                        ],
                        [
                            44.9597,
                            41.25837
                        ],
                        [
                            45.01315,
                            41.29661
                        ],
                        [
                            45.16743,
                            41.40825
                        ],
                        [
                            45.31341,
                            41.46946
                        ],
                        [
                            45.39721,
                            41.42797
                        ],
                        [
                            45.45903,
                            41.45444
                        ],
                        [
                            45.73651,
                            41.33913
                        ],
                        [
                            45.7048,
                            41.29807
                        ],
                        [
                            45.80669,
                            41.22444
                        ],
                        [
                            45.94892,
                            41.18067
                        ],
                        [
                            46.13132,
                            41.19997
                        ],
                        [
                            46.27558,
                            41.18804
                        ],
                        [
                            46.37301,
                            41.10637
                        ],
                        [
                            46.45544,
                            41.09876
                        ],
                        [
                            46.65737,
                            41.1309
                        ],
                        [
                            46.66005,
                            41.20511
                        ],
                        [
                            46.72663,
                            41.29058
                        ],
                        [
                            46.63742,
                            41.37928
                        ],
                        [
                            46.50917,
                            41.41565
                        ],
                        [
                            46.41399,
                            41.47843
                        ],
                        [
                            46.33488,
                            41.5011
                        ],
                        [
                            46.30003,
                            41.57096
                        ],
                        [
                            46.20734,
                            41.61616
                        ],
                        [
                            46.1795,
                            41.71722
                        ],
                        [
                            46.20265,
                            41.7671
                        ],
                        [
                            46.29853,
                            41.77697
                        ],
                        [
                            46.3985,
                            41.84419
                        ],
                        [
                            46.4205,
                            41.90428
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "DEU",
                "Country": "Germany",
                "Total_3GHG": 2.91,
                "Total_3GHG_timeseries": [
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0034,
                    0.0035,
                    0.0037,
                    0.0039,
                    0.0041,
                    0.0043,
                    0.0045,
                    0.0047,
                    0.0049,
                    0.0051,
                    0.0054,
                    0.0056,
                    0.0058,
                    0.0061,
                    0.0064,
                    0.0067,
                    0.007,
                    0.0073,
                    0.0076,
                    0.0079,
                    0.0082,
                    0.0085,
                    0.0088,
                    0.0091,
                    0.0094,
                    0.0096,
                    0.0098,
                    0.0101,
                    0.0103,
                    0.0105,
                    0.0107,
                    0.011,
                    0.0112,
                    0.0114,
                    0.0117,
                    0.0119,
                    0.0122,
                    0.0123,
                    0.0125,
                    0.0126,
                    0.0128,
                    0.013,
                    0.0133,
                    0.0136,
                    0.0139,
                    0.0142,
                    0.0146,
                    0.015,
                    0.0153,
                    0.0157,
                    0.0161,
                    0.0161,
                    0.0162,
                    0.0164,
                    0.0166,
                    0.0168,
                    0.0171,
                    0.0175,
                    0.0179,
                    0.0183,
                    0.0187,
                    0.0192,
                    0.0197,
                    0.0202,
                    0.0206,
                    0.0211,
                    0.0216,
                    0.0221,
                    0.0226,
                    0.0232,
                    0.0238,
                    0.0244,
                    0.0251,
                    0.0257,
                    0.0264,
                    0.027,
                    0.0277,
                    0.0283,
                    0.0289,
                    0.0295,
                    0.0301,
                    0.0306,
                    0.0312,
                    0.0317,
                    0.0323,
                    0.0328,
                    0.0334,
                    0.0339,
                    0.0344,
                    0.0349,
                    0.0354,
                    0.0358,
                    0.0363,
                    0.0368,
                    0.0372,
                    0.0377,
                    0.0381,
                    0.0385,
                    0.0389,
                    0.0393,
                    0.0397,
                    0.04,
                    0.0404,
                    0.0407,
                    0.0411,
                    0.0414,
                    0.0417,
                    0.042,
                    0.0422,
                    0.0425,
                    0.0428,
                    0.0431,
                    0.0433,
                    0.0436,
                    0.0439,
                    0.0441,
                    0.0444,
                    0.0446,
                    0.0449,
                    0.0452,
                    0.0454,
                    0.0457,
                    0.046,
                    0.0463,
                    0.0466,
                    0.0468,
                    0.0471,
                    0.0473,
                    0.0476
                ],
                "Fossil_3GHG": 4.31,
                "Fossil_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0029,
                    0.003,
                    0.0032,
                    0.0034,
                    0.0035,
                    0.0037,
                    0.0039,
                    0.0041,
                    0.0043,
                    0.0045,
                    0.0047,
                    0.0049,
                    0.0052,
                    0.0054,
                    0.0057,
                    0.0059,
                    0.0062,
                    0.0065,
                    0.0068,
                    0.007,
                    0.0073,
                    0.0076,
                    0.0079,
                    0.008,
                    0.0083,
                    0.0085,
                    0.0087,
                    0.0089,
                    0.0091,
                    0.0093,
                    0.0095,
                    0.0098,
                    0.01,
                    0.0103,
                    0.0105,
                    0.0107,
                    0.0108,
                    0.0109,
                    0.0111,
                    0.0113,
                    0.0115,
                    0.0118,
                    0.0121,
                    0.0124,
                    0.0128,
                    0.0131,
                    0.0135,
                    0.0139,
                    0.0142,
                    0.0142,
                    0.0143,
                    0.0144,
                    0.0146,
                    0.0148,
                    0.0151,
                    0.0154,
                    0.0158,
                    0.0162,
                    0.0166,
                    0.017,
                    0.0175,
                    0.018,
                    0.0184,
                    0.0189,
                    0.0193,
                    0.0198,
                    0.0203,
                    0.0209,
                    0.0215,
                    0.0221,
                    0.0228,
                    0.0234,
                    0.024,
                    0.0247,
                    0.0253,
                    0.0259,
                    0.0264,
                    0.027,
                    0.0276,
                    0.0281,
                    0.0287,
                    0.0292,
                    0.0297,
                    0.0303,
                    0.0308,
                    0.0313,
                    0.0318,
                    0.0323,
                    0.0327,
                    0.0332,
                    0.0336,
                    0.0341,
                    0.0345,
                    0.035,
                    0.0354,
                    0.0358,
                    0.0362,
                    0.0366,
                    0.037,
                    0.0374,
                    0.0378,
                    0.0382,
                    0.0385,
                    0.0389,
                    0.0392,
                    0.0395,
                    0.0398,
                    0.0402,
                    0.0405,
                    0.0408,
                    0.0411,
                    0.0414,
                    0.0417,
                    0.042,
                    0.0423,
                    0.0425,
                    0.0428,
                    0.0431,
                    0.0434,
                    0.0437,
                    0.044,
                    0.0443,
                    0.0446,
                    0.0449,
                    0.0451,
                    0.0454,
                    0.0456
                ],
                "Land_3GHG": 0.34,
                "Land_3GHG_timeseries": [
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0023,
                    0.0023,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0019
                ],
                "Total_CO2": 3.65,
                "Total_CO2_timeseries": [
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0028,
                    0.0029,
                    0.0031,
                    0.0032,
                    0.0034,
                    0.0036,
                    0.0037,
                    0.0039,
                    0.0041,
                    0.0043,
                    0.0045,
                    0.0047,
                    0.005,
                    0.0052,
                    0.0054,
                    0.0057,
                    0.0059,
                    0.0061,
                    0.0063,
                    0.0066,
                    0.0068,
                    0.007,
                    0.0072,
                    0.0074,
                    0.0076,
                    0.0077,
                    0.0079,
                    0.0082,
                    0.0083,
                    0.0086,
                    0.0088,
                    0.009,
                    0.0092,
                    0.0094,
                    0.0096,
                    0.0097,
                    0.0099,
                    0.0101,
                    0.0103,
                    0.0106,
                    0.0108,
                    0.0111,
                    0.0114,
                    0.0117,
                    0.012,
                    0.0123,
                    0.0126,
                    0.0126,
                    0.0127,
                    0.0129,
                    0.013,
                    0.0132,
                    0.0134,
                    0.0137,
                    0.0139,
                    0.0142,
                    0.0145,
                    0.0148,
                    0.0151,
                    0.0155,
                    0.0158,
                    0.0161,
                    0.0165,
                    0.0168,
                    0.0172,
                    0.0176,
                    0.018,
                    0.0184,
                    0.0188,
                    0.0192,
                    0.0197,
                    0.0201,
                    0.0206,
                    0.021,
                    0.0215,
                    0.0219,
                    0.0224,
                    0.0228,
                    0.0233,
                    0.0237,
                    0.0242,
                    0.0247,
                    0.0252,
                    0.0256,
                    0.0261,
                    0.0265,
                    0.0269,
                    0.0274,
                    0.0278,
                    0.0283,
                    0.0287,
                    0.0292,
                    0.0296,
                    0.0301,
                    0.0305,
                    0.0309,
                    0.0313,
                    0.0317,
                    0.0321,
                    0.0325,
                    0.0329,
                    0.0333,
                    0.0337,
                    0.0341,
                    0.0345,
                    0.0349,
                    0.0353,
                    0.0356,
                    0.036,
                    0.0364,
                    0.0368,
                    0.0371,
                    0.0375,
                    0.0378,
                    0.0382,
                    0.0385,
                    0.0389,
                    0.0392,
                    0.0396,
                    0.0399,
                    0.0402,
                    0.0405,
                    0.0408,
                    0.0411,
                    0.0414
                ],
                "Fossil_CO2": 5.44,
                "Fossil_CO2_timeseries": [
                    7.5966e-06,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0028,
                    0.0029,
                    0.0031,
                    0.0032,
                    0.0034,
                    0.0035,
                    0.0037,
                    0.0039,
                    0.0041,
                    0.0043,
                    0.0045,
                    0.0047,
                    0.0049,
                    0.0052,
                    0.0054,
                    0.0056,
                    0.0058,
                    0.0061,
                    0.0063,
                    0.0065,
                    0.0067,
                    0.0069,
                    0.0071,
                    0.0072,
                    0.0074,
                    0.0076,
                    0.0078,
                    0.008,
                    0.0083,
                    0.0085,
                    0.0087,
                    0.0089,
                    0.0091,
                    0.0092,
                    0.0094,
                    0.0096,
                    0.0098,
                    0.0101,
                    0.0104,
                    0.0106,
                    0.0109,
                    0.0112,
                    0.0115,
                    0.0118,
                    0.0121,
                    0.0122,
                    0.0123,
                    0.0124,
                    0.0126,
                    0.0128,
                    0.013,
                    0.0133,
                    0.0136,
                    0.0138,
                    0.0141,
                    0.0145,
                    0.0148,
                    0.0152,
                    0.0155,
                    0.0158,
                    0.0162,
                    0.0166,
                    0.017,
                    0.0174,
                    0.0178,
                    0.0183,
                    0.0187,
                    0.0191,
                    0.0196,
                    0.02,
                    0.0205,
                    0.021,
                    0.0214,
                    0.0219,
                    0.0224,
                    0.0229,
                    0.0234,
                    0.0238,
                    0.0243,
                    0.0248,
                    0.0253,
                    0.0258,
                    0.0262,
                    0.0267,
                    0.0272,
                    0.0276,
                    0.0281,
                    0.0286,
                    0.029,
                    0.0295,
                    0.03,
                    0.0304,
                    0.0309,
                    0.0313,
                    0.0317,
                    0.0321,
                    0.0326,
                    0.033,
                    0.0334,
                    0.0338,
                    0.0342,
                    0.0346,
                    0.035,
                    0.0354,
                    0.0358,
                    0.0362,
                    0.0366,
                    0.037,
                    0.0374,
                    0.0377,
                    0.0381,
                    0.0385,
                    0.0388,
                    0.0392,
                    0.0396,
                    0.0399,
                    0.0403,
                    0.0407,
                    0.041,
                    0.0413,
                    0.0416,
                    0.0419,
                    0.0422
                ],
                "Land_CO2": -0.23,
                "Land_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0,
                    0,
                    -0.0000094331,
                    0,
                    0,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0008,
                    -0.0008,
                    -0.0008,
                    -0.0008,
                    -0.0008
                ],
                "Total_CH4": 0.93,
                "Total_CH4_timeseries": [
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.005,
                    0.0052,
                    0.0055,
                    0.0056,
                    0.0058,
                    0.006,
                    0.0062,
                    0.0063,
                    0.0064,
                    0.0065,
                    0.0066,
                    0.0067,
                    0.0067,
                    0.0068,
                    0.0068,
                    0.0069,
                    0.0069,
                    0.007,
                    0.007,
                    0.007,
                    0.007,
                    0.007,
                    0.007,
                    0.007,
                    0.0069,
                    0.0069,
                    0.0069,
                    0.0068,
                    0.0068,
                    0.0067,
                    0.0066,
                    0.0066,
                    0.0065,
                    0.0064,
                    0.0063,
                    0.0062,
                    0.0061,
                    0.006,
                    0.0058,
                    0.0057,
                    0.0056,
                    0.0055,
                    0.0053,
                    0.0052,
                    0.0051,
                    0.0049,
                    0.0048,
                    0.0047,
                    0.0046,
                    0.0045,
                    0.0044,
                    0.0043,
                    0.0043,
                    0.0042,
                    0.0041,
                    0.0041,
                    0.004,
                    0.0039,
                    0.0039
                ],
                "Fossil_CH4": 0.9,
                "Fossil_CH4_timeseries": [
                    6.3547e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0033,
                    0.0035,
                    0.0037,
                    0.0039,
                    0.004,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0046,
                    0.0047,
                    0.0047,
                    0.0048,
                    0.0048,
                    0.0048,
                    0.0049,
                    0.0049,
                    0.0049,
                    0.0049,
                    0.0048,
                    0.0048,
                    0.0048,
                    0.0048,
                    0.0047,
                    0.0047,
                    0.0046,
                    0.0046,
                    0.0045,
                    0.0045,
                    0.0044,
                    0.0044,
                    0.0043,
                    0.0043,
                    0.0042,
                    0.0041,
                    0.004,
                    0.0039,
                    0.0038,
                    0.0038,
                    0.0037,
                    0.0036,
                    0.0035,
                    0.0034,
                    0.0033,
                    0.0032,
                    0.0031,
                    0.0031,
                    0.003,
                    0.0029,
                    0.0028,
                    0.0027,
                    0.0027,
                    0.0026,
                    0.0025,
                    0.0025,
                    0.0024,
                    0.0024,
                    0.0023
                ],
                "Land_CH4": 0.98,
                "Land_CH4_timeseries": [
                    8.9504e-06,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.002,
                    0.002,
                    0.002,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0015
                ],
                "Total_N2O": 2.75,
                "Total_N2O_timeseries": [
                    1.9679e-06,
                    3.9668e-06,
                    5.9956e-06,
                    8.0529e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023
                ],
                "Fossil_N2O": 4.64,
                "Fossil_N2O_timeseries": [
                    1.0562e-06,
                    2.1251e-06,
                    3.2065e-06,
                    4.3002e-06,
                    5.4057e-06,
                    6.5227e-06,
                    7.6507e-06,
                    8.7892e-06,
                    9.9375e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011
                ],
                "Land_N2O": 2.02,
                "Land_N2O_timeseries": [
                    9.1171e-07,
                    1.8416e-06,
                    2.789e-06,
                    3.7528e-06,
                    4.7315e-06,
                    5.7236e-06,
                    6.7269e-06,
                    7.7393e-06,
                    8.7581e-06,
                    9.7805e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                10.45444,
                                47.5558
                            ],
                            [
                                10.57378,
                                47.53482
                            ],
                            [
                                10.69062,
                                47.5581
                            ],
                            [
                                10.77835,
                                47.51482
                            ],
                            [
                                10.89024,
                                47.53622
                            ],
                            [
                                10.98235,
                                47.43084
                            ],
                            [
                                11.10025,
                                47.39476
                            ],
                            [
                                11.20602,
                                47.43341
                            ],
                            [
                                11.27085,
                                47.39777
                            ],
                            [
                                11.44932,
                                47.50723
                            ],
                            [
                                11.57179,
                                47.51459
                            ],
                            [
                                11.60697,
                                47.58099
                            ],
                            [
                                11.77517,
                                47.59039
                            ],
                            [
                                12.00893,
                                47.62459
                            ],
                            [
                                12.20772,
                                47.61457
                            ],
                            [
                                12.18324,
                                47.70073
                            ],
                            [
                                12.36556,
                                47.68412
                            ],
                            [
                                12.42732,
                                47.69585
                            ],
                            [
                                12.49962,
                                47.62527
                            ],
                            [
                                12.60463,
                                47.67316
                            ],
                            [
                                12.73313,
                                47.67899
                            ],
                            [
                                12.80742,
                                47.61008
                            ],
                            [
                                12.77926,
                                47.57929
                            ],
                            [
                                12.90872,
                                47.49699
                            ],
                            [
                                13.00237,
                                47.46409
                            ],
                            [
                                13.04647,
                                47.49214
                            ],
                            [
                                13.04424,
                                47.58278
                            ],
                            [
                                13.09599,
                                47.62872
                            ],
                            [
                                13.07959,
                                47.68749
                            ],
                            [
                                12.90527,
                                47.72434
                            ],
                            [
                                13.00139,
                                47.85439
                            ],
                            [
                                12.93686,
                                47.94331
                            ],
                            [
                                12.76258,
                                48.07233
                            ],
                            [
                                12.74931,
                                48.10837
                            ],
                            [
                                12.87124,
                                48.20177
                            ],
                            [
                                12.96581,
                                48.2141
                            ],
                            [
                                13.01293,
                                48.25287
                            ],
                            [
                                13.17704,
                                48.29439
                            ],
                            [
                                13.25369,
                                48.29316
                            ],
                            [
                                13.40784,
                                48.37216
                            ],
                            [
                                13.45711,
                                48.51144
                            ],
                            [
                                13.43843,
                                48.54889
                            ],
                            [
                                13.5284,
                                48.58651
                            ],
                            [
                                13.72709,
                                48.51302
                            ],
                            [
                                13.82576,
                                48.61862
                            ],
                            [
                                13.79611,
                                48.7136
                            ],
                            [
                                13.83951,
                                48.7716
                            ],
                            [
                                13.75012,
                                48.86677
                            ],
                            [
                                13.67385,
                                48.87985
                            ],
                            [
                                13.58304,
                                48.96967
                            ],
                            [
                                13.40301,
                                48.98817
                            ],
                            [
                                13.34378,
                                49.08862
                            ],
                            [
                                13.23595,
                                49.11373
                            ],
                            [
                                13.02864,
                                49.30377
                            ],
                            [
                                12.94581,
                                49.34364
                            ],
                            [
                                12.80208,
                                49.34184
                            ],
                            [
                                12.75729,
                                49.39443
                            ],
                            [
                                12.65589,
                                49.43455
                            ],
                            [
                                12.64418,
                                49.52306
                            ],
                            [
                                12.58988,
                                49.53805
                            ],
                            [
                                12.5216,
                                49.68585
                            ],
                            [
                                12.44149,
                                49.70509
                            ],
                            [
                                12.40483,
                                49.76231
                            ],
                            [
                                12.55099,
                                49.90509
                            ],
                            [
                                12.49933,
                                49.97198
                            ],
                            [
                                12.27992,
                                50.05568
                            ],
                            [
                                12.20157,
                                50.10889
                            ],
                            [
                                12.21513,
                                50.16645
                            ],
                            [
                                12.10975,
                                50.23826
                            ],
                            [
                                12.14692,
                                50.32155
                            ],
                            [
                                12.29142,
                                50.22105
                            ],
                            [
                                12.33334,
                                50.24168
                            ],
                            [
                                12.51423,
                                50.39734
                            ],
                            [
                                12.70837,
                                50.4083
                            ],
                            [
                                12.82329,
                                50.45796
                            ],
                            [
                                12.94272,
                                50.4114
                            ],
                            [
                                13.02223,
                                50.4514
                            ],
                            [
                                13.03169,
                                50.50884
                            ],
                            [
                                13.19336,
                                50.50317
                            ],
                            [
                                13.25441,
                                50.59488
                            ],
                            [
                                13.40537,
                                50.63372
                            ],
                            [
                                13.46272,
                                50.60183
                            ],
                            [
                                13.54057,
                                50.6696
                            ],
                            [
                                13.52572,
                                50.70307
                            ],
                            [
                                13.66731,
                                50.73129
                            ],
                            [
                                13.8569,
                                50.72843
                            ],
                            [
                                13.99004,
                                50.81917
                            ],
                            [
                                14.03068,
                                50.80443
                            ],
                            [
                                14.3045,
                                50.88423
                            ],
                            [
                                14.40214,
                                50.92407
                            ],
                            [
                                14.25853,
                                50.98799
                            ],
                            [
                                14.30141,
                                51.05442
                            ],
                            [
                                14.45429,
                                51.03562
                            ],
                            [
                                14.59879,
                                50.98624
                            ],
                            [
                                14.64732,
                                50.93153
                            ],
                            [
                                14.6188,
                                50.8578
                            ],
                            [
                                14.76753,
                                50.81977
                            ],
                            [
                                14.82336,
                                50.87055
                            ],
                            [
                                14.89534,
                                50.93948
                            ],
                            [
                                14.97886,
                                51.07783
                            ],
                            [
                                15.03268,
                                51.29359
                            ],
                            [
                                14.9814,
                                51.33552
                            ],
                            [
                                14.94801,
                                51.47126
                            ],
                            [
                                14.73669,
                                51.52598
                            ],
                            [
                                14.76504,
                                51.6082
                            ],
                            [
                                14.73714,
                                51.68768
                            ],
                            [
                                14.66772,
                                51.72681
                            ],
                            [
                                14.61126,
                                51.85622
                            ],
                            [
                                14.69284,
                                51.90128
                            ],
                            [
                                14.74481,
                                52.08229
                            ],
                            [
                                14.68278,
                                52.1138
                            ],
                            [
                                14.69269,
                                52.25574
                            ],
                            [
                                14.59328,
                                52.2746
                            ],
                            [
                                14.53436,
                                52.39501
                            ],
                            [
                                14.63,
                                52.48708
                            ],
                            [
                                14.63754,
                                52.56666
                            ],
                            [
                                14.59668,
                                52.61001
                            ],
                            [
                                14.46825,
                                52.65974
                            ],
                            [
                                14.35084,
                                52.75131
                            ],
                            [
                                14.21555,
                                52.81713
                            ],
                            [
                                14.1423,
                                52.82416
                            ],
                            [
                                14.14366,
                                52.96137
                            ],
                            [
                                14.3442,
                                53.05088
                            ],
                            [
                                14.38648,
                                53.14253
                            ],
                            [
                                14.37775,
                                53.20156
                            ],
                            [
                                14.4502,
                                53.26154
                            ],
                            [
                                14.3903,
                                53.35375
                            ],
                            [
                                14.37106,
                                53.45532
                            ],
                            [
                                14.30344,
                                53.55424
                            ],
                            [
                                14.31659,
                                53.61717
                            ],
                            [
                                14.26754,
                                53.69781
                            ],
                            [
                                14.27124,
                                53.73886
                            ],
                            [
                                14.12522,
                                53.73743
                            ],
                            [
                                13.97286,
                                53.77259
                            ],
                            [
                                13.81915,
                                53.84194
                            ],
                            [
                                13.90853,
                                53.92994
                            ],
                            [
                                13.76097,
                                54.01577
                            ],
                            [
                                13.80462,
                                54.10311
                            ],
                            [
                                13.70163,
                                54.14892
                            ],
                            [
                                13.47814,
                                54.11917
                            ],
                            [
                                13.34925,
                                54.16725
                            ],
                            [
                                13.2903,
                                54.23353
                            ],
                            [
                                13.1337,
                                54.26902
                            ],
                            [
                                12.99995,
                                54.43591
                            ],
                            [
                                12.88366,
                                54.37083
                            ],
                            [
                                12.72548,
                                54.37257
                            ],
                            [
                                12.70738,
                                54.41028
                            ],
                            [
                                12.40843,
                                54.27775
                            ],
                            [
                                12.43614,
                                54.37909
                            ],
                            [
                                12.52373,
                                54.37871
                            ],
                            [
                                12.64033,
                                54.42438
                            ],
                            [
                                12.8012,
                                54.40984
                            ],
                            [
                                12.81763,
                                54.44015
                            ],
                            [
                                12.55853,
                                54.45514
                            ],
                            [
                                12.46728,
                                54.42154
                            ],
                            [
                                12.31149,
                                54.28433
                            ],
                            [
                                12.22115,
                                54.2535
                            ],
                            [
                                12.13083,
                                54.1885
                            ],
                            [
                                11.83566,
                                54.14455
                            ],
                            [
                                11.68173,
                                54.15252
                            ],
                            [
                                11.56178,
                                54.02809
                            ],
                            [
                                11.5079,
                                54.01035
                            ],
                            [
                                11.44559,
                                53.91178
                            ],
                            [
                                11.3382,
                                53.9571
                            ],
                            [
                                11.28652,
                                53.93128
                            ],
                            [
                                11.18109,
                                54.0147
                            ],
                            [
                                11.0271,
                                54.00283
                            ],
                            [
                                10.93405,
                                53.96525
                            ],
                            [
                                10.79973,
                                53.9927
                            ],
                            [
                                10.75178,
                                54.03759
                            ],
                            [
                                10.7998,
                                54.08415
                            ],
                            [
                                10.88535,
                                54.09164
                            ],
                            [
                                11.09339,
                                54.19974
                            ],
                            [
                                11.07198,
                                54.33735
                            ],
                            [
                                10.93143,
                                54.38173
                            ],
                            [
                                10.76976,
                                54.3076
                            ],
                            [
                                10.32884,
                                54.43572
                            ],
                            [
                                10.22829,
                                54.41381
                            ],
                            [
                                10.12547,
                                54.48508
                            ],
                            [
                                9.86422,
                                54.44852
                            ],
                            [
                                10.02698,
                                54.554
                            ],
                            [
                                10.0337,
                                54.65706
                            ],
                            [
                                9.95688,
                                54.77948
                            ],
                            [
                                9.87366,
                                54.75218
                            ],
                            [
                                9.79257,
                                54.79698
                            ],
                            [
                                9.59091,
                                54.84417
                            ],
                            [
                                9.42015,
                                54.83196
                            ],
                            [
                                9.25009,
                                54.80971
                            ],
                            [
                                9.24028,
                                54.84994
                            ],
                            [
                                9.04854,
                                54.87213
                            ],
                            [
                                8.9483,
                                54.90246
                            ],
                            [
                                8.72106,
                                54.89481
                            ],
                            [
                                8.63593,
                                54.91168
                            ],
                            [
                                8.60818,
                                54.84122
                            ],
                            [
                                8.70045,
                                54.77509
                            ],
                            [
                                8.75409,
                                54.68193
                            ],
                            [
                                8.89222,
                                54.59801
                            ],
                            [
                                8.87167,
                                54.52901
                            ],
                            [
                                8.98318,
                                54.52468
                            ],
                            [
                                9.01453,
                                54.47407
                            ],
                            [
                                8.91217,
                                54.41664
                            ],
                            [
                                8.67313,
                                54.39951
                            ],
                            [
                                8.69078,
                                54.35497
                            ],
                            [
                                8.60238,
                                54.3145
                            ],
                            [
                                8.67367,
                                54.27909
                            ],
                            [
                                8.84214,
                                54.27747
                            ],
                            [
                                8.80777,
                                54.17518
                            ],
                            [
                                8.92504,
                                54.13228
                            ],
                            [
                                8.98523,
                                54.05892
                            ],
                            [
                                8.84922,
                                54.03863
                            ],
                            [
                                8.68717,
                                53.89191
                            ],
                            [
                                8.61382,
                                53.88139
                            ],
                            [
                                8.54215,
                                53.80729
                            ],
                            [
                                8.4833,
                                53.6936
                            ],
                            [
                                8.52041,
                                53.6062
                            ],
                            [
                                8.46188,
                                53.55296
                            ],
                            [
                                8.308,
                                53.61615
                            ],
                            [
                                8.24368,
                                53.5828
                            ],
                            [
                                8.2313,
                                53.52155
                            ],
                            [
                                8.31491,
                                53.51627
                            ],
                            [
                                8.29722,
                                53.43068
                            ],
                            [
                                8.20232,
                                53.40372
                            ],
                            [
                                8.08573,
                                53.50187
                            ],
                            [
                                8.16871,
                                53.54284
                            ],
                            [
                                8.02782,
                                53.70743
                            ],
                            [
                                7.91298,
                                53.71772
                            ],
                            [
                                7.70328,
                                53.70322
                            ],
                            [
                                7.52169,
                                53.67154
                            ],
                            [
                                7.2916,
                                53.67971
                            ],
                            [
                                7.15249,
                                53.62375
                            ],
                            [
                                7.03376,
                                53.53313
                            ],
                            [
                                6.99945,
                                53.35989
                            ],
                            [
                                7.03223,
                                53.33635
                            ],
                            [
                                7.23587,
                                53.33196
                            ],
                            [
                                7.20894,
                                53.24306
                            ],
                            [
                                7.2128,
                                53.01096
                            ],
                            [
                                7.18157,
                                52.9413
                            ],
                            [
                                7.07205,
                                52.81087
                            ],
                            [
                                7.05492,
                                52.64361
                            ],
                            [
                                6.74576,
                                52.64604
                            ],
                            [
                                6.69787,
                                52.48629
                            ],
                            [
                                6.93827,
                                52.43613
                            ],
                            [
                                6.99344,
                                52.46557
                            ],
                            [
                                7.07244,
                                52.37312
                            ],
                            [
                                6.99031,
                                52.22672
                            ],
                            [
                                6.84664,
                                52.11944
                            ],
                            [
                                6.76047,
                                52.11857
                            ],
                            [
                                6.68773,
                                52.0399
                            ],
                            [
                                6.82657,
                                51.99353
                            ],
                            [
                                6.77092,
                                51.917
                            ],
                            [
                                6.68259,
                                51.91721
                            ],
                            [
                                6.38954,
                                51.83327
                            ],
                            [
                                6.29894,
                                51.8679
                            ],
                            [
                                6.16641,
                                51.84083
                            ],
                            [
                                5.96283,
                                51.83617
                            ],
                            [
                                6.03197,
                                51.67618
                            ],
                            [
                                6.11714,
                                51.65599
                            ],
                            [
                                6.09243,
                                51.60554
                            ],
                            [
                                6.21148,
                                51.51454
                            ],
                            [
                                6.20569,
                                51.40071
                            ],
                            [
                                6.16978,
                                51.33218
                            ],
                            [
                                6.07266,
                                51.24259
                            ],
                            [
                                6.09252,
                                51.13457
                            ],
                            [
                                5.99657,
                                51.08327
                            ],
                            [
                                5.95482,
                                50.98836
                            ],
                            [
                                6.09047,
                                50.9178
                            ],
                            [
                                6.01999,
                                50.84613
                            ],
                            [
                                6.021,
                                50.7543
                            ],
                            [
                                6.11631,
                                50.72076
                            ],
                            [
                                6.21771,
                                50.63188
                            ],
                            [
                                6.17542,
                                50.55708
                            ],
                            [
                                6.22522,
                                50.49548
                            ],
                            [
                                6.33536,
                                50.4895
                            ],
                            [
                                6.37457,
                                50.45145
                            ],
                            [
                                6.34312,
                                50.38038
                            ],
                            [
                                6.35586,
                                50.30939
                            ],
                            [
                                6.17879,
                                50.23618
                            ],
                            [
                                6.18435,
                                50.17858
                            ],
                            [
                                6.13766,
                                50.12995
                            ],
                            [
                                6.11293,
                                50.05973
                            ],
                            [
                                6.25911,
                                49.88359
                            ],
                            [
                                6.40138,
                                49.82023
                            ],
                            [
                                6.51482,
                                49.80407
                            ],
                            [
                                6.50702,
                                49.71264
                            ],
                            [
                                6.35812,
                                49.57232
                            ],
                            [
                                6.36711,
                                49.46951
                            ],
                            [
                                6.46495,
                                49.46549
                            ],
                            [
                                6.55699,
                                49.41921
                            ],
                            [
                                6.56563,
                                49.34859
                            ],
                            [
                                6.66897,
                                49.27997
                            ],
                            [
                                6.73833,
                                49.16415
                            ],
                            [
                                6.83457,
                                49.15131
                            ],
                            [
                                6.8603,
                                49.22245
                            ],
                            [
                                6.92252,
                                49.22306
                            ],
                            [
                                7.15875,
                                49.12063
                            ],
                            [
                                7.29318,
                                49.11491
                            ],
                            [
                                7.4363,
                                49.1795
                            ],
                            [
                                7.52868,
                                49.09709
                            ],
                            [
                                7.67347,
                                49.0454
                            ],
                            [
                                7.79572,
                                49.06509
                            ],
                            [
                                7.86737,
                                49.03301
                            ],
                            [
                                7.93351,
                                49.05758
                            ],
                            [
                                8.0705,
                                48.99682
                            ],
                            [
                                8.2237,
                                48.97534
                            ],
                            [
                                8.14655,
                                48.90229
                            ],
                            [
                                8.10383,
                                48.82012
                            ],
                            [
                                7.97362,
                                48.75881
                            ],
                            [
                                7.95963,
                                48.71858
                            ],
                            [
                                7.8481,
                                48.64691
                            ],
                            [
                                7.80086,
                                48.58545
                            ],
                            [
                                7.6651,
                                48.22015
                            ],
                            [
                                7.57792,
                                48.12139
                            ],
                            [
                                7.56885,
                                48.03561
                            ],
                            [
                                7.62165,
                                47.97651
                            ],
                            [
                                7.55546,
                                47.87051
                            ],
                            [
                                7.52108,
                                47.66385
                            ],
                            [
                                7.58904,
                                47.58988
                            ],
                            [
                                7.67303,
                                47.59212
                            ],
                            [
                                7.69704,
                                47.53316
                            ],
                            [
                                7.89411,
                                47.58637
                            ],
                            [
                                7.91659,
                                47.54827
                            ],
                            [
                                8.01956,
                                47.55059
                            ],
                            [
                                8.19753,
                                47.61857
                            ],
                            [
                                8.32519,
                                47.57251
                            ],
                            [
                                8.46412,
                                47.57221
                            ],
                            [
                                8.46507,
                                47.64542
                            ],
                            [
                                8.40641,
                                47.67548
                            ],
                            [
                                8.48754,
                                47.77217
                            ],
                            [
                                8.60161,
                                47.80269
                            ],
                            [
                                8.73629,
                                47.71615
                            ],
                            [
                                8.80644,
                                47.73831
                            ],
                            [
                                8.87489,
                                47.65467
                            ],
                            [
                                9.02157,
                                47.68643
                            ],
                            [
                                9.1708,
                                47.65528
                            ],
                            [
                                9.25656,
                                47.65871
                            ],
                            [
                                9.39471,
                                47.62033
                            ],
                            [
                                9.4956,
                                47.55145
                            ],
                            [
                                9.55872,
                                47.54189
                            ],
                            [
                                9.68036,
                                47.52336
                            ],
                            [
                                9.80275,
                                47.59534
                            ],
                            [
                                9.87449,
                                47.52854
                            ],
                            [
                                9.96112,
                                47.53522
                            ],
                            [
                                10.10459,
                                47.42824
                            ],
                            [
                                10.11932,
                                47.375
                            ],
                            [
                                10.23601,
                                47.37245
                            ],
                            [
                                10.17209,
                                47.27908
                            ],
                            [
                                10.23452,
                                47.27111
                            ],
                            [
                                10.32962,
                                47.30486
                            ],
                            [
                                10.47486,
                                47.43307
                            ],
                            [
                                10.43203,
                                47.50357
                            ],
                            [
                                10.45444,
                                47.5558
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                13.38928,
                                54.68316
                            ],
                            [
                                13.249,
                                54.65961
                            ],
                            [
                                13.33263,
                                54.58259
                            ],
                            [
                                13.36906,
                                54.61431
                            ],
                            [
                                13.39611,
                                54.57272
                            ],
                            [
                                13.44602,
                                54.55195
                            ],
                            [
                                13.50239,
                                54.54742
                            ],
                            [
                                13.4716,
                                54.45729
                            ],
                            [
                                13.35647,
                                54.58085
                            ],
                            [
                                13.29757,
                                54.55225
                            ],
                            [
                                13.17015,
                                54.54566
                            ],
                            [
                                13.14579,
                                54.47866
                            ],
                            [
                                13.23691,
                                54.40682
                            ],
                            [
                                13.13061,
                                54.37227
                            ],
                            [
                                13.11535,
                                54.33205
                            ],
                            [
                                13.32168,
                                54.23892
                            ],
                            [
                                13.50735,
                                54.34374
                            ],
                            [
                                13.75366,
                                54.3436
                            ],
                            [
                                13.61694,
                                54.40183
                            ],
                            [
                                13.57181,
                                54.4728
                            ],
                            [
                                13.66715,
                                54.52038
                            ],
                            [
                                13.63459,
                                54.5852
                            ],
                            [
                                13.45964,
                                54.57081
                            ],
                            [
                                13.39611,
                                54.59614
                            ],
                            [
                                13.38928,
                                54.68316
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.2263,
                                53.92865
                            ],
                            [
                                14.01478,
                                54.05423
                            ],
                            [
                                13.83909,
                                54.12606
                            ],
                            [
                                13.79069,
                                54.04986
                            ],
                            [
                                13.92487,
                                54.06311
                            ],
                            [
                                14.04708,
                                53.99698
                            ],
                            [
                                13.90834,
                                53.98993
                            ],
                            [
                                13.93787,
                                53.91293
                            ],
                            [
                                13.8987,
                                53.84042
                            ],
                            [
                                14.08521,
                                53.87451
                            ],
                            [
                                14.21308,
                                53.86648
                            ],
                            [
                                14.2263,
                                53.92865
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                11.19997,
                                54.50914
                            ],
                            [
                                11.06931,
                                54.5339
                            ],
                            [
                                11.01191,
                                54.44231
                            ],
                            [
                                11.09733,
                                54.41254
                            ],
                            [
                                11.31125,
                                54.40448
                            ],
                            [
                                11.19997,
                                54.50914
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.51379,
                                54.75397
                            ],
                            [
                                8.40265,
                                54.70044
                            ],
                            [
                                8.56724,
                                54.68076
                            ],
                            [
                                8.51379,
                                54.75397
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "GHA",
                "Country": "Ghana",
                "Total_3GHG": 0.12,
                "Total_3GHG_timeseries": [
                    7.3673e-07,
                    1.5194e-06,
                    2.3025e-06,
                    3.1787e-06,
                    3.9912e-06,
                    4.8057e-06,
                    5.5952e-06,
                    6.3896e-06,
                    7.1781e-06,
                    7.8927e-06,
                    8.5606e-06,
                    9.243e-06,
                    9.9411e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019
                ],
                "Fossil_3GHG": 0.06,
                "Fossil_3GHG_timeseries": [
                    6.8487e-08,
                    1.3714e-07,
                    2.0596e-07,
                    2.7493e-07,
                    3.4406e-07,
                    4.1333e-07,
                    4.8275e-07,
                    5.5228e-07,
                    6.2193e-07,
                    6.9168e-07,
                    7.6248e-07,
                    8.3434e-07,
                    9.0725e-07,
                    9.8121e-07,
                    1.0562e-06,
                    1.1323e-06,
                    1.2094e-06,
                    1.2876e-06,
                    1.3668e-06,
                    1.4471e-06,
                    1.5275e-06,
                    1.6103e-06,
                    1.6956e-06,
                    1.7837e-06,
                    1.8746e-06,
                    1.9686e-06,
                    2.0755e-06,
                    2.2052e-06,
                    2.3595e-06,
                    2.5402e-06,
                    2.7488e-06,
                    2.9874e-06,
                    3.2587e-06,
                    3.5655e-06,
                    3.9109e-06,
                    4.2982e-06,
                    4.6904e-06,
                    5.0875e-06,
                    5.4896e-06,
                    5.8973e-06,
                    6.3102e-06,
                    6.7222e-06,
                    7.1332e-06,
                    7.5432e-06,
                    7.9521e-06,
                    8.3597e-06,
                    8.7579e-06,
                    9.1374e-06,
                    9.4966e-06,
                    9.8334e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007
                ],
                "Land_3GHG": 0.22,
                "Land_3GHG_timeseries": [
                    6.6824e-07,
                    1.3823e-06,
                    2.0965e-06,
                    2.9037e-06,
                    3.6471e-06,
                    4.3923e-06,
                    5.1125e-06,
                    5.8374e-06,
                    6.5562e-06,
                    7.2011e-06,
                    7.7981e-06,
                    8.4087e-06,
                    9.0338e-06,
                    9.6081e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013
                ],
                "Total_CO2": 0.1,
                "Total_CO2_timeseries": [
                    5.6746e-07,
                    1.1798e-06,
                    1.7914e-06,
                    2.4951e-06,
                    3.1343e-06,
                    3.7745e-06,
                    4.3891e-06,
                    5.0079e-06,
                    5.6204e-06,
                    6.1586e-06,
                    6.648e-06,
                    7.15e-06,
                    7.6656e-06,
                    8.1293e-06,
                    8.6116e-06,
                    9.0636e-06,
                    9.5204e-06,
                    9.9584e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011
                ],
                "Fossil_CO2": 0.02,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2.871e-07,
                    6.8145e-07,
                    1.0725e-06,
                    1.5312e-06,
                    1.9833e-06,
                    2.5179e-06,
                    3.003e-06,
                    3.5855e-06,
                    4.1992e-06,
                    4.7949e-06,
                    5.4532e-06,
                    6.0588e-06,
                    6.704e-06,
                    7.4795e-06,
                    8.222e-06,
                    8.9892e-06,
                    9.6377e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_CO2": 0.26,
                "Land_CO2_timeseries": [
                    5.6746e-07,
                    1.1798e-06,
                    1.7914e-06,
                    2.4951e-06,
                    3.1343e-06,
                    3.7745e-06,
                    4.3891e-06,
                    5.0079e-06,
                    5.6204e-06,
                    6.1586e-06,
                    6.648e-06,
                    7.15e-06,
                    7.6656e-06,
                    8.1293e-06,
                    8.6116e-06,
                    9.0636e-06,
                    9.5204e-06,
                    9.9584e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009
                ],
                "Total_CH4": 0.17,
                "Total_CH4_timeseries": [
                    1.1914e-07,
                    2.3839e-07,
                    3.5775e-07,
                    4.7723e-07,
                    5.9682e-07,
                    7.1653e-07,
                    8.3636e-07,
                    9.563e-07,
                    1.0764e-06,
                    1.1966e-06,
                    1.3187e-06,
                    1.4428e-06,
                    1.5688e-06,
                    1.6969e-06,
                    1.8268e-06,
                    1.9587e-06,
                    2.0926e-06,
                    2.2285e-06,
                    2.3663e-06,
                    2.506e-06,
                    2.6468e-06,
                    2.7906e-06,
                    2.9375e-06,
                    3.0878e-06,
                    3.2414e-06,
                    3.3985e-06,
                    3.569e-06,
                    3.7629e-06,
                    3.9821e-06,
                    4.2284e-06,
                    4.5026e-06,
                    4.8069e-06,
                    5.1441e-06,
                    5.5168e-06,
                    5.9281e-06,
                    6.3814e-06,
                    6.8397e-06,
                    7.3031e-06,
                    7.7715e-06,
                    8.2451e-06,
                    8.7239e-06,
                    9.2017e-06,
                    9.6785e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Fossil_CH4": 0.19,
                "Fossil_CH4_timeseries": [
                    6.3037e-08,
                    1.2614e-07,
                    1.8931e-07,
                    2.5255e-07,
                    3.1585e-07,
                    3.7923e-07,
                    4.4267e-07,
                    5.0619e-07,
                    5.6978e-07,
                    6.3344e-07,
                    6.9814e-07,
                    7.6388e-07,
                    8.3066e-07,
                    8.9848e-07,
                    9.6734e-07,
                    1.0372e-06,
                    1.1082e-06,
                    1.1802e-06,
                    1.2532e-06,
                    1.3273e-06,
                    1.4014e-06,
                    1.4776e-06,
                    1.556e-06,
                    1.6368e-06,
                    1.72e-06,
                    1.8058e-06,
                    1.904e-06,
                    2.0247e-06,
                    2.1697e-06,
                    2.3409e-06,
                    2.5398e-06,
                    2.7688e-06,
                    3.0303e-06,
                    3.3273e-06,
                    3.6627e-06,
                    4.04e-06,
                    4.4221e-06,
                    4.8092e-06,
                    5.2011e-06,
                    5.5981e-06,
                    6e-06,
                    6.4009e-06,
                    6.8006e-06,
                    7.1989e-06,
                    7.5959e-06,
                    7.9914e-06,
                    8.3772e-06,
                    8.744e-06,
                    9.0902e-06,
                    9.4138e-06,
                    9.7145e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005
                ],
                "Land_CH4": 0.14,
                "Land_CH4_timeseries": [
                    5.6099e-08,
                    1.1225e-07,
                    1.6844e-07,
                    2.2468e-07,
                    2.8097e-07,
                    3.373e-07,
                    3.9368e-07,
                    4.5011e-07,
                    5.0659e-07,
                    5.6311e-07,
                    6.2055e-07,
                    6.7891e-07,
                    7.3818e-07,
                    7.9837e-07,
                    8.5948e-07,
                    9.215e-07,
                    9.8444e-07,
                    1.0483e-06,
                    1.1131e-06,
                    1.1788e-06,
                    1.2454e-06,
                    1.313e-06,
                    1.3815e-06,
                    1.4509e-06,
                    1.5214e-06,
                    1.5927e-06,
                    1.665e-06,
                    1.7382e-06,
                    1.8124e-06,
                    1.8875e-06,
                    1.9628e-06,
                    2.0382e-06,
                    2.1138e-06,
                    2.1895e-06,
                    2.2654e-06,
                    2.3414e-06,
                    2.4176e-06,
                    2.4939e-06,
                    2.5704e-06,
                    2.6471e-06,
                    2.7239e-06,
                    2.8008e-06,
                    2.8779e-06,
                    2.9552e-06,
                    3.0326e-06,
                    3.1102e-06,
                    3.188e-06,
                    3.2658e-06,
                    3.3439e-06,
                    3.4221e-06,
                    3.4988e-06,
                    3.574e-06,
                    3.6477e-06,
                    3.7199e-06,
                    3.7906e-06,
                    3.8598e-06,
                    3.9275e-06,
                    3.9937e-06,
                    4.0584e-06,
                    4.1216e-06,
                    4.1977e-06,
                    4.2867e-06,
                    4.3885e-06,
                    4.5033e-06,
                    4.6309e-06,
                    4.7715e-06,
                    4.9249e-06,
                    5.0912e-06,
                    5.2704e-06,
                    5.4624e-06,
                    5.6721e-06,
                    5.8995e-06,
                    6.1444e-06,
                    6.407e-06,
                    6.6871e-06,
                    6.9849e-06,
                    7.3003e-06,
                    7.6334e-06,
                    7.984e-06,
                    8.3523e-06,
                    8.7285e-06,
                    9.1127e-06,
                    9.5048e-06,
                    9.9049e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Total_N2O": 0.15,
                "Total_N2O_timeseries": [
                    5.0132e-08,
                    1.0126e-07,
                    1.5334e-07,
                    2.0631e-07,
                    2.601e-07,
                    3.1462e-07,
                    3.6976e-07,
                    4.2539e-07,
                    4.8139e-07,
                    5.3758e-07,
                    5.9387e-07,
                    6.5024e-07,
                    7.0668e-07,
                    7.6315e-07,
                    8.1967e-07,
                    8.7623e-07,
                    9.3284e-07,
                    9.8951e-07,
                    1.0463e-06,
                    1.1031e-06,
                    1.1609e-06,
                    1.2211e-06,
                    1.2848e-06,
                    1.3527e-06,
                    1.4253e-06,
                    1.5026e-06,
                    1.5846e-06,
                    1.6705e-06,
                    1.7595e-06,
                    1.8504e-06,
                    1.9424e-06,
                    2.0353e-06,
                    2.129e-06,
                    2.2233e-06,
                    2.3182e-06,
                    2.4137e-06,
                    2.5097e-06,
                    2.6063e-06,
                    2.7036e-06,
                    2.806e-06,
                    2.9095e-06,
                    3.0141e-06,
                    3.1199e-06,
                    3.2269e-06,
                    3.3352e-06,
                    3.4448e-06,
                    3.5559e-06,
                    3.6683e-06,
                    3.7822e-06,
                    3.8976e-06,
                    4.0145e-06,
                    4.133e-06,
                    4.253e-06,
                    4.3746e-06,
                    4.498e-06,
                    4.6232e-06,
                    4.7503e-06,
                    4.8795e-06,
                    5.0111e-06,
                    5.1452e-06,
                    5.2828e-06,
                    5.4256e-06,
                    5.5749e-06,
                    5.7317e-06,
                    5.8968e-06,
                    6.0706e-06,
                    6.2534e-06,
                    6.4451e-06,
                    6.6452e-06,
                    6.8531e-06,
                    7.0689e-06,
                    7.2938e-06,
                    7.5281e-06,
                    7.772e-06,
                    8.0252e-06,
                    8.2871e-06,
                    8.5566e-06,
                    8.8322e-06,
                    9.112e-06,
                    9.3936e-06,
                    9.6749e-06,
                    9.9539e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_N2O": 0.07,
                "Fossil_N2O_timeseries": [
                    5.4494e-09,
                    1.1e-08,
                    1.6647e-08,
                    2.2386e-08,
                    2.821e-08,
                    3.4109e-08,
                    4.0074e-08,
                    4.6093e-08,
                    5.2152e-08,
                    5.8238e-08,
                    6.434e-08,
                    7.0457e-08,
                    7.6586e-08,
                    8.2727e-08,
                    8.8878e-08,
                    9.5041e-08,
                    1.0122e-07,
                    1.074e-07,
                    1.136e-07,
                    1.1982e-07,
                    1.2614e-07,
                    1.3269e-07,
                    1.3957e-07,
                    1.4686e-07,
                    1.546e-07,
                    1.628e-07,
                    1.7144e-07,
                    1.8046e-07,
                    1.8978e-07,
                    1.9929e-07,
                    2.0891e-07,
                    2.1862e-07,
                    2.2841e-07,
                    2.3827e-07,
                    2.4819e-07,
                    2.5817e-07,
                    2.6821e-07,
                    2.7831e-07,
                    2.8849e-07,
                    2.9922e-07,
                    3.1016e-07,
                    3.2131e-07,
                    3.3268e-07,
                    3.443e-07,
                    3.5616e-07,
                    3.6828e-07,
                    3.8068e-07,
                    3.9337e-07,
                    4.0636e-07,
                    4.1966e-07,
                    4.3331e-07,
                    4.4736e-07,
                    4.6186e-07,
                    4.7683e-07,
                    4.9229e-07,
                    5.0823e-07,
                    5.2464e-07,
                    5.4149e-07,
                    5.5874e-07,
                    5.7633e-07,
                    5.9423e-07,
                    6.1241e-07,
                    6.3085e-07,
                    6.4955e-07,
                    6.685e-07,
                    6.8769e-07,
                    7.0712e-07,
                    7.268e-07,
                    7.4674e-07,
                    7.6695e-07,
                    7.8743e-07,
                    8.0817e-07,
                    8.2919e-07,
                    8.5048e-07,
                    8.7204e-07,
                    8.9389e-07,
                    9.1603e-07,
                    9.3848e-07,
                    9.6126e-07,
                    9.8439e-07,
                    1.0079e-06,
                    1.032e-06,
                    1.0565e-06,
                    1.0818e-06,
                    1.1077e-06,
                    1.1343e-06,
                    1.1617e-06,
                    1.1899e-06,
                    1.219e-06,
                    1.2489e-06,
                    1.2798e-06,
                    1.3122e-06,
                    1.3463e-06,
                    1.3823e-06,
                    1.4205e-06,
                    1.4608e-06,
                    1.5033e-06,
                    1.548e-06,
                    1.5946e-06,
                    1.6431e-06,
                    1.6934e-06,
                    1.7456e-06,
                    1.7998e-06,
                    1.8562e-06,
                    1.9146e-06,
                    1.9752e-06,
                    2.0378e-06,
                    2.1023e-06,
                    2.1687e-06,
                    2.2367e-06,
                    2.3063e-06,
                    2.3774e-06,
                    2.4503e-06,
                    2.5249e-06,
                    2.6014e-06,
                    2.6798e-06,
                    2.7603e-06,
                    2.8429e-06,
                    2.9279e-06,
                    3.0189e-06,
                    3.1125e-06,
                    3.2093e-06,
                    3.3091e-06,
                    3.4116e-06,
                    3.5139e-06,
                    3.6183e-06,
                    3.7227e-06,
                    3.8276e-06,
                    3.9322e-06,
                    4.0383e-06,
                    4.1495e-06,
                    4.2929e-06,
                    4.4319e-06,
                    4.5623e-06,
                    4.7068e-06,
                    4.8641e-06,
                    5.0191e-06,
                    5.1673e-06,
                    5.3378e-06,
                    5.5144e-06,
                    5.6984e-06,
                    5.8946e-06,
                    6.097e-06,
                    6.3099e-06,
                    6.5326e-06,
                    6.7644e-06,
                    7.0027e-06,
                    7.2632e-06,
                    7.5331e-06,
                    7.7904e-06,
                    8.0464e-06,
                    8.2952e-06,
                    8.5404e-06,
                    8.7864e-06,
                    9.0371e-06,
                    9.3005e-06,
                    9.569e-06,
                    9.843e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.18,
                "Land_N2O_timeseries": [
                    4.4683e-08,
                    9.0259e-08,
                    1.3669e-07,
                    1.8392e-07,
                    2.3189e-07,
                    2.8051e-07,
                    3.2969e-07,
                    3.793e-07,
                    4.2923e-07,
                    4.7934e-07,
                    5.2953e-07,
                    5.7979e-07,
                    6.3009e-07,
                    6.8043e-07,
                    7.3079e-07,
                    7.8119e-07,
                    8.3162e-07,
                    8.8211e-07,
                    9.3266e-07,
                    9.833e-07,
                    1.0348e-06,
                    1.0884e-06,
                    1.1452e-06,
                    1.2058e-06,
                    1.2707e-06,
                    1.3398e-06,
                    1.4131e-06,
                    1.49e-06,
                    1.5697e-06,
                    1.6511e-06,
                    1.7335e-06,
                    1.8167e-06,
                    1.9006e-06,
                    1.9851e-06,
                    2.0701e-06,
                    2.1555e-06,
                    2.2415e-06,
                    2.328e-06,
                    2.4151e-06,
                    2.5068e-06,
                    2.5994e-06,
                    2.6928e-06,
                    2.7872e-06,
                    2.8826e-06,
                    2.9791e-06,
                    3.0766e-06,
                    3.1752e-06,
                    3.2749e-06,
                    3.3758e-06,
                    3.4779e-06,
                    3.5812e-06,
                    3.6856e-06,
                    3.7911e-06,
                    3.8978e-06,
                    4.0057e-06,
                    4.1149e-06,
                    4.2256e-06,
                    4.338e-06,
                    4.4523e-06,
                    4.5688e-06,
                    4.6886e-06,
                    4.8132e-06,
                    4.9441e-06,
                    5.0822e-06,
                    5.2283e-06,
                    5.383e-06,
                    5.5463e-06,
                    5.7183e-06,
                    5.8984e-06,
                    6.0861e-06,
                    6.2815e-06,
                    6.4856e-06,
                    6.6989e-06,
                    6.9215e-06,
                    7.1532e-06,
                    7.3933e-06,
                    7.6406e-06,
                    7.8937e-06,
                    8.1507e-06,
                    8.4092e-06,
                    8.6669e-06,
                    8.922e-06,
                    9.173e-06,
                    9.4191e-06,
                    9.6599e-06,
                    9.8952e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            1.19961,
                            6.11242
                        ],
                        [
                            1.2002,
                            6.16851
                        ],
                        [
                            1.08535,
                            6.16824
                        ],
                        [
                            1.02438,
                            6.25414
                        ],
                        [
                            1.00528,
                            6.33264
                        ],
                        [
                            0.89396,
                            6.33329
                        ],
                        [
                            0.85667,
                            6.38367
                        ],
                        [
                            0.74903,
                            6.44342
                        ],
                        [
                            0.71329,
                            6.5294
                        ],
                        [
                            0.74321,
                            6.55878
                        ],
                        [
                            0.63857,
                            6.63626
                        ],
                        [
                            0.64276,
                            6.72271
                        ],
                        [
                            0.58001,
                            6.76448
                        ],
                        [
                            0.53526,
                            6.8764
                        ],
                        [
                            0.56485,
                            6.9202
                        ],
                        [
                            0.52347,
                            6.97386
                        ],
                        [
                            0.601,
                            7.02637
                        ],
                        [
                            0.59299,
                            7.11422
                        ],
                        [
                            0.63731,
                            7.22555
                        ],
                        [
                            0.65842,
                            7.31871
                        ],
                        [
                            0.64268,
                            7.39982
                        ],
                        [
                            0.5677,
                            7.39565
                        ],
                        [
                            0.53837,
                            7.42485
                        ],
                        [
                            0.52081,
                            7.51608
                        ],
                        [
                            0.53004,
                            7.58398
                        ],
                        [
                            0.58719,
                            7.62718
                        ],
                        [
                            0.61966,
                            7.74649
                        ],
                        [
                            0.62392,
                            7.86632
                        ],
                        [
                            0.58361,
                            8.09393
                        ],
                        [
                            0.63863,
                            8.25825
                        ],
                        [
                            0.73104,
                            8.29182
                        ],
                        [
                            0.73043,
                            8.3458
                        ],
                        [
                            0.62633,
                            8.50859
                        ],
                        [
                            0.56941,
                            8.52594
                        ],
                        [
                            0.47152,
                            8.59588
                        ],
                        [
                            0.38199,
                            8.73909
                        ],
                        [
                            0.38161,
                            8.79077
                        ],
                        [
                            0.49713,
                            8.81469
                        ],
                        [
                            0.51982,
                            8.85721
                        ],
                        [
                            0.51072,
                            8.93721
                        ],
                        [
                            0.45533,
                            9.03687
                        ],
                        [
                            0.47581,
                            9.1447
                        ],
                        [
                            0.52992,
                            9.20526
                        ],
                        [
                            0.50386,
                            9.25493
                        ],
                        [
                            0.5548,
                            9.31677
                        ],
                        [
                            0.56382,
                            9.40264
                        ],
                        [
                            0.49902,
                            9.43781
                        ],
                        [
                            0.4872,
                            9.48619
                        ],
                        [
                            0.35963,
                            9.49776
                        ],
                        [
                            0.2848,
                            9.42932
                        ],
                        [
                            0.23184,
                            9.4627
                        ],
                        [
                            0.24364,
                            9.57111
                        ],
                        [
                            0.35682,
                            9.56927
                        ],
                        [
                            0.38175,
                            9.6408
                        ],
                        [
                            0.32121,
                            9.72518
                        ],
                        [
                            0.35702,
                            9.84327
                        ],
                        [
                            0.35158,
                            9.89737
                        ],
                        [
                            0.3848,
                            9.94812
                        ],
                        [
                            0.36034,
                            10.0288
                        ],
                        [
                            0.35163,
                            10.16646
                        ],
                        [
                            0.36234,
                            10.25832
                        ],
                        [
                            0.29487,
                            10.37483
                        ],
                        [
                            0.21892,
                            10.42271
                        ],
                        [
                            0.19464,
                            10.40138
                        ],
                        [
                            0.14325,
                            10.52471
                        ],
                        [
                            0.06286,
                            10.56025
                        ],
                        [
                            0.03896,
                            10.60033
                        ],
                        [
                            -0.05969,
                            10.6325
                        ],
                        [
                            -0.08994,
                            10.70936
                        ],
                        [
                            -0.0226,
                            10.82025
                        ],
                        [
                            -0.00579,
                            10.95874
                        ],
                        [
                            0.0327,
                            10.97987
                        ],
                        [
                            0.02268,
                            11.08069
                        ],
                        [
                            -0.03635,
                            11.10499
                        ],
                        [
                            -0.11177,
                            11.09053
                        ],
                        [
                            -0.14201,
                            11.13898
                        ],
                        [
                            -0.28279,
                            11.16443
                        ],
                        [
                            -0.27843,
                            11.12267
                        ],
                        [
                            -0.421,
                            11.09968
                        ],
                        [
                            -0.41668,
                            11.03113
                        ],
                        [
                            -0.50394,
                            10.99012
                        ],
                        [
                            -0.56876,
                            10.99376
                        ],
                        [
                            -0.61477,
                            10.90457
                        ],
                        [
                            -0.65523,
                            10.98742
                        ],
                        [
                            -0.68609,
                            10.99817
                        ],
                        [
                            -1.11339,
                            11.00381
                        ],
                        [
                            -1.11892,
                            10.98555
                        ],
                        [
                            -1.38981,
                            10.98771
                        ],
                        [
                            -1.43625,
                            11.03006
                        ],
                        [
                            -1.58399,
                            11.0201
                        ],
                        [
                            -1.58819,
                            11.0007
                        ],
                        [
                            -2.58752,
                            10.99935
                        ],
                        [
                            -2.69806,
                            10.9872
                        ],
                        [
                            -2.8336,
                            10.99856
                        ],
                        [
                            -2.81775,
                            10.92452
                        ],
                        [
                            -2.8582,
                            10.89117
                        ],
                        [
                            -2.89568,
                            10.76446
                        ],
                        [
                            -2.93752,
                            10.72103
                        ],
                        [
                            -2.91261,
                            10.66826
                        ],
                        [
                            -2.94053,
                            10.61597
                        ],
                        [
                            -2.86461,
                            10.45463
                        ],
                        [
                            -2.77996,
                            10.42612
                        ],
                        [
                            -2.84122,
                            10.36554
                        ],
                        [
                            -2.83309,
                            10.29644
                        ],
                        [
                            -2.76676,
                            10.26578
                        ],
                        [
                            -2.79677,
                            10.19367
                        ],
                        [
                            -2.79009,
                            10.07177
                        ],
                        [
                            -2.74522,
                            9.9484
                        ],
                        [
                            -2.76127,
                            9.88541
                        ],
                        [
                            -2.73084,
                            9.83889
                        ],
                        [
                            -2.78811,
                            9.74721
                        ],
                        [
                            -2.74679,
                            9.64156
                        ],
                        [
                            -2.76806,
                            9.56948
                        ],
                        [
                            -2.68692,
                            9.49074
                        ],
                        [
                            -2.67464,
                            9.38004
                        ],
                        [
                            -2.71878,
                            9.33331
                        ],
                        [
                            -2.66027,
                            9.26142
                        ],
                        [
                            -2.77272,
                            9.13665
                        ],
                        [
                            -2.75347,
                            9.03433
                        ],
                        [
                            -2.67372,
                            9.02327
                        ],
                        [
                            -2.58588,
                            8.78191
                        ],
                        [
                            -2.4943,
                            8.20866
                        ],
                        [
                            -2.61185,
                            8.13377
                        ],
                        [
                            -2.59735,
                            8.04161
                        ],
                        [
                            -2.67465,
                            8.02526
                        ],
                        [
                            -2.82646,
                            7.82345
                        ],
                        [
                            -2.91984,
                            7.61213
                        ],
                        [
                            -2.9313,
                            7.50001
                        ],
                        [
                            -2.97113,
                            7.32967
                        ],
                        [
                            -2.95696,
                            7.23336
                        ],
                        [
                            -3.02232,
                            7.14336
                        ],
                        [
                            -3.03254,
                            7.07386
                        ],
                        [
                            -3.09077,
                            7.048
                        ],
                        [
                            -3.22696,
                            6.82205
                        ],
                        [
                            -3.19689,
                            6.71848
                        ],
                        [
                            -3.24872,
                            6.64389
                        ],
                        [
                            -3.2337,
                            6.53766
                        ],
                        [
                            -3.17208,
                            6.30149
                        ],
                        [
                            -3.10258,
                            6.15191
                        ],
                        [
                            -3.07224,
                            5.98918
                        ],
                        [
                            -3.02079,
                            5.85446
                        ],
                        [
                            -3.02566,
                            5.71334
                        ],
                        [
                            -2.95617,
                            5.71369
                        ],
                        [
                            -2.96427,
                            5.64203
                        ],
                        [
                            -2.93245,
                            5.61643
                        ],
                        [
                            -2.85705,
                            5.6496
                        ],
                        [
                            -2.78769,
                            5.62579
                        ],
                        [
                            -2.7283,
                            5.34392
                        ],
                        [
                            -2.78414,
                            5.28705
                        ],
                        [
                            -2.72542,
                            5.13965
                        ],
                        [
                            -2.75853,
                            5.10449
                        ],
                        [
                            -2.93756,
                            5.12488
                        ],
                        [
                            -3.10583,
                            5.09086
                        ],
                        [
                            -2.4833,
                            4.96578
                        ],
                        [
                            -2.26848,
                            4.89991
                        ],
                        [
                            -2.2449,
                            4.85564
                        ],
                        [
                            -2.11044,
                            4.75573
                        ],
                        [
                            -2.05524,
                            4.74365
                        ],
                        [
                            -1.97559,
                            4.76014
                        ],
                        [
                            -1.91372,
                            4.82512
                        ],
                        [
                            -1.80956,
                            4.8725
                        ],
                        [
                            -1.74707,
                            4.88078
                        ],
                        [
                            -1.73781,
                            4.92128
                        ],
                        [
                            -1.64567,
                            4.9714
                        ],
                        [
                            -1.59073,
                            5.03258
                        ],
                        [
                            -1.24218,
                            5.10304
                        ],
                        [
                            -1.08729,
                            5.19543
                        ],
                        [
                            -0.81339,
                            5.21413
                        ],
                        [
                            -0.72567,
                            5.29913
                        ],
                        [
                            -0.60556,
                            5.35203
                        ],
                        [
                            -0.49929,
                            5.37794
                        ],
                        [
                            -0.4597,
                            5.43357
                        ],
                        [
                            -0.33004,
                            5.50642
                        ],
                        [
                            -0.21153,
                            5.53238
                        ],
                        [
                            0.00646,
                            5.62438
                        ],
                        [
                            0.06935,
                            5.69414
                        ],
                        [
                            0.18753,
                            5.74424
                        ],
                        [
                            0.3209,
                            5.78179
                        ],
                        [
                            0.44279,
                            5.78886
                        ],
                        [
                            0.66556,
                            5.76966
                        ],
                        [
                            0.80373,
                            5.7712
                        ],
                        [
                            0.91986,
                            5.78536
                        ],
                        [
                            0.97242,
                            5.82759
                        ],
                        [
                            0.99866,
                            5.93437
                        ],
                        [
                            1.07994,
                            6.0445
                        ],
                        [
                            1.19961,
                            6.11242
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "GRC",
                "Country": "Greece",
                "Total_3GHG": 0.18,
                "Total_3GHG_timeseries": [
                    3.2589e-06,
                    6.5271e-06,
                    9.806e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.003
                ],
                "Fossil_3GHG": 0.22,
                "Fossil_3GHG_timeseries": [
                    3.8464e-07,
                    7.7368e-07,
                    1.1672e-06,
                    1.5651e-06,
                    1.9674e-06,
                    2.3742e-06,
                    2.7854e-06,
                    3.2008e-06,
                    3.6208e-06,
                    4.0451e-06,
                    4.474e-06,
                    4.9074e-06,
                    5.3454e-06,
                    5.788e-06,
                    6.2352e-06,
                    6.6871e-06,
                    7.2388e-06,
                    7.7476e-06,
                    8.3231e-06,
                    8.9077e-06,
                    9.5528e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023
                ],
                "Land_3GHG": 0.11,
                "Land_3GHG_timeseries": [
                    2.8742e-06,
                    5.7534e-06,
                    8.6389e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Total_CO2": 0.19,
                "Total_CO2_timeseries": [
                    1.9165e-06,
                    3.8277e-06,
                    5.735e-06,
                    7.6395e-06,
                    9.5413e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022
                ],
                "Fossil_CO2": 0.24,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    7.59e-08,
                    1.1385e-07,
                    2.013e-07,
                    2.9205e-07,
                    4.257e-07,
                    5.049e-07,
                    5.9235e-07,
                    6.6e-07,
                    7.3425e-07,
                    7.3425e-07,
                    7.3425e-07,
                    7.3425e-07,
                    7.359e-07,
                    7.359e-07,
                    7.359e-07,
                    7.359e-07,
                    7.3755e-07,
                    7.3755e-07,
                    7.3755e-07,
                    7.3755e-07,
                    7.3755e-07,
                    7.392e-07,
                    7.392e-07,
                    7.392e-07,
                    7.392e-07,
                    9.0585e-07,
                    1.0527e-06,
                    1.2029e-06,
                    1.3431e-06,
                    1.5114e-06,
                    1.6747e-06,
                    1.8827e-06,
                    1.9916e-06,
                    2.1796e-06,
                    2.3677e-06,
                    2.5179e-06,
                    2.6978e-06,
                    2.8578e-06,
                    2.9832e-06,
                    3.1003e-06,
                    3.2934e-06,
                    3.6218e-06,
                    3.8742e-06,
                    4.1976e-06,
                    4.6052e-06,
                    4.6052e-06,
                    5.2074e-06,
                    5.2124e-06,
                    5.2222e-06,
                    5.2519e-06,
                    5.2932e-06,
                    5.3493e-06,
                    5.3971e-06,
                    5.7024e-06,
                    6.0373e-06,
                    6.3426e-06,
                    6.7568e-06,
                    7.3409e-06,
                    8.2318e-06,
                    9.0519e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019
                ],
                "Land_CO2": 0.08,
                "Land_CO2_timeseries": [
                    1.9165e-06,
                    3.8277e-06,
                    5.735e-06,
                    7.6395e-06,
                    9.5413e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Total_CH4": 0.14,
                "Total_CH4_timeseries": [
                    1.1829e-06,
                    2.3775e-06,
                    3.5841e-06,
                    4.8025e-06,
                    6.0328e-06,
                    7.275e-06,
                    8.5291e-06,
                    9.7951e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006
                ],
                "Fossil_CH4": 0.14,
                "Fossil_CH4_timeseries": [
                    3.3519e-07,
                    6.7412e-07,
                    1.0169e-06,
                    1.3634e-06,
                    1.7138e-06,
                    2.068e-06,
                    2.4261e-06,
                    2.788e-06,
                    3.154e-06,
                    3.5239e-06,
                    3.898e-06,
                    4.2764e-06,
                    4.6589e-06,
                    5.0457e-06,
                    5.4368e-06,
                    5.8322e-06,
                    6.2512e-06,
                    6.665e-06,
                    7.0956e-06,
                    7.5316e-06,
                    7.9845e-06,
                    8.4299e-06,
                    8.8835e-06,
                    9.3382e-06,
                    9.8008e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Land_CH4": 0.13,
                "Land_CH4_timeseries": [
                    8.4767e-07,
                    1.7034e-06,
                    2.5672e-06,
                    3.4391e-06,
                    4.319e-06,
                    5.207e-06,
                    6.103e-06,
                    7.0071e-06,
                    7.9193e-06,
                    8.8395e-06,
                    9.7687e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Total_N2O": 0.27,
                "Total_N2O_timeseries": [
                    1.595e-07,
                    3.2186e-07,
                    4.8697e-07,
                    6.5467e-07,
                    8.2479e-07,
                    9.9707e-07,
                    1.1713e-06,
                    1.347e-06,
                    1.524e-06,
                    1.7018e-06,
                    1.8802e-06,
                    2.0591e-06,
                    2.2384e-06,
                    2.4181e-06,
                    2.5983e-06,
                    2.7789e-06,
                    2.9599e-06,
                    3.1413e-06,
                    3.3233e-06,
                    3.5059e-06,
                    3.6912e-06,
                    3.8829e-06,
                    4.0839e-06,
                    4.296e-06,
                    4.5205e-06,
                    4.7575e-06,
                    5.0066e-06,
                    5.2662e-06,
                    5.5341e-06,
                    5.8072e-06,
                    6.0834e-06,
                    6.3622e-06,
                    6.6432e-06,
                    6.9263e-06,
                    7.2111e-06,
                    7.4977e-06,
                    7.786e-06,
                    8.0762e-06,
                    8.3683e-06,
                    8.6387e-06,
                    8.9369e-06,
                    9.2614e-06,
                    9.6102e-06,
                    9.9812e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_N2O": 0.31,
                "Fossil_N2O_timeseries": [
                    4.9448e-08,
                    9.9554e-08,
                    1.503e-07,
                    2.0168e-07,
                    2.5365e-07,
                    3.0619e-07,
                    3.5926e-07,
                    4.1282e-07,
                    4.6683e-07,
                    5.2122e-07,
                    5.7597e-07,
                    6.3106e-07,
                    6.865e-07,
                    7.4228e-07,
                    7.9839e-07,
                    8.5484e-07,
                    9.1162e-07,
                    9.6875e-07,
                    1.0262e-06,
                    1.0841e-06,
                    1.1425e-06,
                    1.2022e-06,
                    1.2633e-06,
                    1.3261e-06,
                    1.3909e-06,
                    1.4576e-06,
                    1.5261e-06,
                    1.5964e-06,
                    1.668e-06,
                    1.7406e-06,
                    1.8138e-06,
                    1.8877e-06,
                    1.9622e-06,
                    2.0372e-06,
                    2.1127e-06,
                    2.1887e-06,
                    2.2653e-06,
                    2.3424e-06,
                    2.42e-06,
                    2.5015e-06,
                    2.5843e-06,
                    2.6686e-06,
                    2.7545e-06,
                    2.8419e-06,
                    2.9311e-06,
                    3.022e-06,
                    3.1147e-06,
                    3.2093e-06,
                    3.3059e-06,
                    3.4045e-06,
                    3.5052e-06,
                    3.6085e-06,
                    3.7144e-06,
                    3.8231e-06,
                    3.9347e-06,
                    4.0492e-06,
                    4.1663e-06,
                    4.2861e-06,
                    4.4082e-06,
                    4.5324e-06,
                    4.6582e-06,
                    4.7857e-06,
                    4.9147e-06,
                    5.0451e-06,
                    5.1768e-06,
                    5.3099e-06,
                    5.4444e-06,
                    5.5803e-06,
                    5.7177e-06,
                    5.8569e-06,
                    5.998e-06,
                    6.1414e-06,
                    6.2873e-06,
                    6.4359e-06,
                    6.5871e-06,
                    6.7409e-06,
                    6.8971e-06,
                    7.0554e-06,
                    7.2155e-06,
                    7.3768e-06,
                    7.5398e-06,
                    7.7059e-06,
                    7.8762e-06,
                    8.0515e-06,
                    8.2325e-06,
                    8.4195e-06,
                    8.6127e-06,
                    8.8119e-06,
                    9.0168e-06,
                    9.2269e-06,
                    9.4417e-06,
                    9.661e-06,
                    9.8847e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_N2O": 0.26,
                "Land_N2O_timeseries": [
                    1.1005e-07,
                    2.223e-07,
                    3.3666e-07,
                    4.53e-07,
                    5.7114e-07,
                    6.9088e-07,
                    8.12e-07,
                    9.342e-07,
                    1.0572e-06,
                    1.1806e-06,
                    1.3042e-06,
                    1.428e-06,
                    1.5519e-06,
                    1.6759e-06,
                    1.7999e-06,
                    1.924e-06,
                    2.0482e-06,
                    2.1726e-06,
                    2.2971e-06,
                    2.4218e-06,
                    2.5487e-06,
                    2.6808e-06,
                    2.8206e-06,
                    2.9699e-06,
                    3.1296e-06,
                    3.2999e-06,
                    3.4804e-06,
                    3.6698e-06,
                    3.8662e-06,
                    4.0667e-06,
                    4.2696e-06,
                    4.4745e-06,
                    4.6811e-06,
                    4.8891e-06,
                    5.0984e-06,
                    5.309e-06,
                    5.5207e-06,
                    5.7338e-06,
                    5.9483e-06,
                    6.1373e-06,
                    6.3526e-06,
                    6.5928e-06,
                    6.8557e-06,
                    7.1393e-06,
                    7.441e-06,
                    7.7582e-06,
                    8.0878e-06,
                    8.4267e-06,
                    8.7713e-06,
                    9.1179e-06,
                    9.4625e-06,
                    9.8017e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                26.35788,
                                41.7111
                            ],
                            [
                                26.17272,
                                41.74881
                            ],
                            [
                                26.07019,
                                41.70907
                            ],
                            [
                                26.07092,
                                41.65041
                            ],
                            [
                                26.15353,
                                41.60488
                            ],
                            [
                                26.18445,
                                41.51978
                            ],
                            [
                                26.17322,
                                41.4323
                            ],
                            [
                                26.132,
                                41.3553
                            ],
                            [
                                26.03575,
                                41.35004
                            ],
                            [
                                25.88554,
                                41.30467
                            ],
                            [
                                25.81565,
                                41.33726
                            ],
                            [
                                25.68347,
                                41.30672
                            ],
                            [
                                25.57336,
                                41.31821
                            ],
                            [
                                25.52905,
                                41.27719
                            ],
                            [
                                25.28729,
                                41.23581
                            ],
                            [
                                25.2351,
                                41.24722
                            ],
                            [
                                25.17938,
                                41.31019
                            ],
                            [
                                25.05523,
                                41.36492
                            ],
                            [
                                24.60822,
                                41.42771
                            ],
                            [
                                24.52517,
                                41.5688
                            ],
                            [
                                24.36836,
                                41.51805
                            ],
                            [
                                24.26184,
                                41.57359
                            ],
                            [
                                24.17406,
                                41.52265
                            ],
                            [
                                24.07847,
                                41.54183
                            ],
                            [
                                24.07269,
                                41.46605
                            ],
                            [
                                23.97364,
                                41.43858
                            ],
                            [
                                23.90583,
                                41.45758
                            ],
                            [
                                23.80093,
                                41.4371
                            ],
                            [
                                23.76755,
                                41.39687
                            ],
                            [
                                23.67424,
                                41.4107
                            ],
                            [
                                23.63777,
                                41.37604
                            ],
                            [
                                23.52509,
                                41.4052
                            ],
                            [
                                23.32236,
                                41.39877
                            ],
                            [
                                23.23275,
                                41.37544
                            ],
                            [
                                23.19873,
                                41.32271
                            ],
                            [
                                23.08007,
                                41.31978
                            ],
                            [
                                22.92759,
                                41.33854
                            ],
                            [
                                22.76867,
                                41.32523
                            ],
                            [
                                22.74686,
                                41.16298
                            ],
                            [
                                22.66647,
                                41.18634
                            ],
                            [
                                22.61767,
                                41.13392
                            ],
                            [
                                22.46525,
                                41.11743
                            ],
                            [
                                22.3265,
                                41.12337
                            ],
                            [
                                22.21622,
                                41.17046
                            ],
                            [
                                22.12906,
                                41.12335
                            ],
                            [
                                22.07839,
                                41.15301
                            ],
                            [
                                21.9089,
                                41.09085
                            ],
                            [
                                21.91178,
                                41.04942
                            ],
                            [
                                21.79982,
                                40.97543
                            ],
                            [
                                21.75645,
                                40.92566
                            ],
                            [
                                21.68449,
                                40.94028
                            ],
                            [
                                21.56701,
                                40.86698
                            ],
                            [
                                21.53137,
                                40.90751
                            ],
                            [
                                21.41725,
                                40.9177
                            ],
                            [
                                21.36295,
                                40.8796
                            ],
                            [
                                21.25947,
                                40.8595
                            ],
                            [
                                20.9802,
                                40.85566
                            ],
                            [
                                20.96026,
                                40.77087
                            ],
                            [
                                21.05673,
                                40.6675
                            ],
                            [
                                21.04158,
                                40.55823
                            ],
                            [
                                20.95378,
                                40.46897
                            ],
                            [
                                20.84495,
                                40.47938
                            ],
                            [
                                20.78584,
                                40.42467
                            ],
                            [
                                20.79029,
                                40.36348
                            ],
                            [
                                20.71414,
                                40.28276
                            ],
                            [
                                20.72411,
                                40.22355
                            ],
                            [
                                20.67861,
                                40.1888
                            ],
                            [
                                20.6778,
                                40.09705
                            ],
                            [
                                20.55092,
                                40.06383
                            ],
                            [
                                20.44901,
                                40.07288
                            ],
                            [
                                20.39246,
                                39.99593
                            ],
                            [
                                20.313,
                                39.99022
                            ],
                            [
                                20.33951,
                                39.92327
                            ],
                            [
                                20.41635,
                                39.84071
                            ],
                            [
                                20.39131,
                                39.78848
                            ],
                            [
                                20.30561,
                                39.81558
                            ],
                            [
                                20.32045,
                                39.72848
                            ],
                            [
                                20.19362,
                                39.64495
                            ],
                            [
                                20.00881,
                                39.69129
                            ],
                            [
                                20.18181,
                                39.62476
                            ],
                            [
                                20.16124,
                                39.55403
                            ],
                            [
                                20.26045,
                                39.50947
                            ],
                            [
                                20.21777,
                                39.44403
                            ],
                            [
                                20.34125,
                                39.28393
                            ],
                            [
                                20.47079,
                                39.26264
                            ],
                            [
                                20.47564,
                                39.2178
                            ],
                            [
                                20.70407,
                                39.04934
                            ],
                            [
                                20.79049,
                                39.07501
                            ],
                            [
                                21.04353,
                                39.00339
                            ],
                            [
                                21.08329,
                                39.05144
                            ],
                            [
                                21.16052,
                                38.98685
                            ],
                            [
                                21.13881,
                                38.89221
                            ],
                            [
                                21.02225,
                                38.89719
                            ],
                            [
                                20.97799,
                                38.944
                            ],
                            [
                                20.89166,
                                38.92154
                            ],
                            [
                                20.74877,
                                38.92522
                            ],
                            [
                                20.73196,
                                38.85022
                            ],
                            [
                                20.76418,
                                38.76078
                            ],
                            [
                                20.87101,
                                38.79309
                            ],
                            [
                                20.91916,
                                38.67172
                            ],
                            [
                                20.98773,
                                38.66825
                            ],
                            [
                                21.02204,
                                38.60577
                            ],
                            [
                                21.01088,
                                38.53327
                            ],
                            [
                                21.10864,
                                38.45147
                            ],
                            [
                                21.10459,
                                38.36088
                            ],
                            [
                                21.16966,
                                38.29996
                            ],
                            [
                                21.26444,
                                38.34113
                            ],
                            [
                                21.36273,
                                38.411
                            ],
                            [
                                21.41046,
                                38.36419
                            ],
                            [
                                21.48153,
                                38.35159
                            ],
                            [
                                21.50795,
                                38.29956
                            ],
                            [
                                21.64005,
                                38.35679
                            ],
                            [
                                21.76611,
                                38.32877
                            ],
                            [
                                21.83239,
                                38.39204
                            ],
                            [
                                21.93613,
                                38.40592
                            ],
                            [
                                22.0511,
                                38.39435
                            ],
                            [
                                22.19417,
                                38.33807
                            ],
                            [
                                22.3919,
                                38.34716
                            ],
                            [
                                22.45567,
                                38.42541
                            ],
                            [
                                22.53409,
                                38.34693
                            ],
                            [
                                22.67855,
                                38.37318
                            ],
                            [
                                22.68522,
                                38.32547
                            ],
                            [
                                22.8863,
                                38.23022
                            ],
                            [
                                22.9146,
                                38.19296
                            ],
                            [
                                23.0244,
                                38.21282
                            ],
                            [
                                23.10721,
                                38.20518
                            ],
                            [
                                23.22079,
                                38.15676
                            ],
                            [
                                23.21442,
                                38.10029
                            ],
                            [
                                23.0555,
                                38.05259
                            ],
                            [
                                22.95494,
                                38.07892
                            ],
                            [
                                22.8875,
                                38.05211
                            ],
                            [
                                22.97399,
                                37.97072
                            ],
                            [
                                22.89933,
                                37.93235
                            ],
                            [
                                22.7922,
                                37.97101
                            ],
                            [
                                22.72454,
                                38.03659
                            ],
                            [
                                22.49162,
                                38.13529
                            ],
                            [
                                22.41315,
                                38.13119
                            ],
                            [
                                22.33516,
                                38.17608
                            ],
                            [
                                22.21488,
                                38.18153
                            ],
                            [
                                22.07832,
                                38.25521
                            ],
                            [
                                22.01166,
                                38.3126
                            ],
                            [
                                21.94763,
                                38.32789
                            ],
                            [
                                21.7806,
                                38.31168
                            ],
                            [
                                21.67075,
                                38.16765
                            ],
                            [
                                21.60522,
                                38.14289
                            ],
                            [
                                21.452,
                                38.19883
                            ],
                            [
                                21.36422,
                                38.18032
                            ],
                            [
                                21.368,
                                38.1308
                            ],
                            [
                                21.30388,
                                38.02678
                            ],
                            [
                                21.19643,
                                37.93489
                            ],
                            [
                                21.12713,
                                37.93826
                            ],
                            [
                                21.11742,
                                37.83969
                            ],
                            [
                                21.25924,
                                37.79549
                            ],
                            [
                                21.30285,
                                37.75857
                            ],
                            [
                                21.30309,
                                37.66844
                            ],
                            [
                                21.37752,
                                37.65757
                            ],
                            [
                                21.5526,
                                37.55234
                            ],
                            [
                                21.66048,
                                37.41921
                            ],
                            [
                                21.69815,
                                37.31282
                            ],
                            [
                                21.66973,
                                37.25843
                            ],
                            [
                                21.56619,
                                37.16397
                            ],
                            [
                                21.57507,
                                37.05885
                            ],
                            [
                                21.63835,
                                37.00634
                            ],
                            [
                                21.70385,
                                36.81398
                            ],
                            [
                                21.8092,
                                36.80659
                            ],
                            [
                                21.87684,
                                36.72097
                            ],
                            [
                                21.93169,
                                36.75829
                            ],
                            [
                                21.9219,
                                36.86577
                            ],
                            [
                                21.93727,
                                36.98746
                            ],
                            [
                                22.02053,
                                37.02179
                            ],
                            [
                                22.14713,
                                37.01896
                            ],
                            [
                                22.16979,
                                36.89065
                            ],
                            [
                                22.22884,
                                36.89098
                            ],
                            [
                                22.29488,
                                36.81442
                            ],
                            [
                                22.36271,
                                36.66636
                            ],
                            [
                                22.38806,
                                36.54248
                            ],
                            [
                                22.37215,
                                36.47665
                            ],
                            [
                                22.50086,
                                36.44405
                            ],
                            [
                                22.47355,
                                36.5286
                            ],
                            [
                                22.47627,
                                36.60967
                            ],
                            [
                                22.5237,
                                36.62928
                            ],
                            [
                                22.52356,
                                36.7054
                            ],
                            [
                                22.56447,
                                36.77081
                            ],
                            [
                                22.62253,
                                36.80557
                            ],
                            [
                                22.78133,
                                36.79899
                            ],
                            [
                                22.81997,
                                36.71364
                            ],
                            [
                                22.94403,
                                36.57181
                            ],
                            [
                                22.96863,
                                36.52228
                            ],
                            [
                                23.03893,
                                36.5237
                            ],
                            [
                                23.08398,
                                36.44484
                            ],
                            [
                                23.13086,
                                36.5025
                            ],
                            [
                                23.12596,
                                36.55901
                            ],
                            [
                                23.03265,
                                36.62835
                            ],
                            [
                                23.02611,
                                36.7265
                            ],
                            [
                                23.10113,
                                36.76613
                            ],
                            [
                                23.01326,
                                36.93602
                            ],
                            [
                                22.95662,
                                37.11507
                            ],
                            [
                                22.83934,
                                37.27987
                            ],
                            [
                                22.72789,
                                37.48671
                            ],
                            [
                                22.71763,
                                37.55949
                            ],
                            [
                                22.76984,
                                37.58979
                            ],
                            [
                                22.85099,
                                37.51441
                            ],
                            [
                                22.97951,
                                37.51378
                            ],
                            [
                                23.00473,
                                37.46296
                            ],
                            [
                                23.11972,
                                37.44946
                            ],
                            [
                                23.10596,
                                37.35073
                            ],
                            [
                                23.1468,
                                37.29787
                            ],
                            [
                                23.25112,
                                37.38393
                            ],
                            [
                                23.33627,
                                37.4129
                            ],
                            [
                                23.49722,
                                37.42312
                            ],
                            [
                                23.51818,
                                37.45549
                            ],
                            [
                                23.37005,
                                37.55485
                            ],
                            [
                                23.31808,
                                37.53365
                            ],
                            [
                                23.15657,
                                37.62274
                            ],
                            [
                                23.17149,
                                37.70067
                            ],
                            [
                                23.12695,
                                37.73424
                            ],
                            [
                                23.17839,
                                37.80094
                            ],
                            [
                                23.11174,
                                37.84771
                            ],
                            [
                                23.01353,
                                37.84413
                            ],
                            [
                                23.01575,
                                37.89998
                            ],
                            [
                                23.13464,
                                37.92078
                            ],
                            [
                                23.27397,
                                37.97757
                            ],
                            [
                                23.38872,
                                37.97412
                            ],
                            [
                                23.45256,
                                38.0233
                            ],
                            [
                                23.56724,
                                38.04598
                            ],
                            [
                                23.55277,
                                37.97963
                            ],
                            [
                                23.63565,
                                37.92708
                            ],
                            [
                                23.67223,
                                37.94182
                            ],
                            [
                                23.76921,
                                37.83298
                            ],
                            [
                                23.8989,
                                37.7727
                            ],
                            [
                                23.94032,
                                37.67383
                            ],
                            [
                                24.02721,
                                37.65069
                            ],
                            [
                                24.07078,
                                37.68542
                            ],
                            [
                                24.08478,
                                37.77936
                            ],
                            [
                                24.04703,
                                37.82141
                            ],
                            [
                                24.04562,
                                37.90247
                            ],
                            [
                                24.00702,
                                37.96746
                            ],
                            [
                                23.98739,
                                38.11445
                            ],
                            [
                                24.05644,
                                38.14173
                            ],
                            [
                                24.04992,
                                38.20807
                            ],
                            [
                                23.95664,
                                38.28284
                            ],
                            [
                                23.77012,
                                38.33805
                            ],
                            [
                                23.67756,
                                38.34008
                            ],
                            [
                                23.67568,
                                38.41065
                            ],
                            [
                                23.89446,
                                38.38441
                            ],
                            [
                                24.04988,
                                38.39339
                            ],
                            [
                                24.11257,
                                38.25253
                            ],
                            [
                                24.20646,
                                38.18031
                            ],
                            [
                                24.21005,
                                38.09059
                            ],
                            [
                                24.30741,
                                38.06867
                            ],
                            [
                                24.33941,
                                37.98789
                            ],
                            [
                                24.44958,
                                38.00489
                            ],
                            [
                                24.50024,
                                37.94908
                            ],
                            [
                                24.55624,
                                37.97971
                            ],
                            [
                                24.58693,
                                38.06711
                            ],
                            [
                                24.55485,
                                38.14172
                            ],
                            [
                                24.42545,
                                38.1462
                            ],
                            [
                                24.27248,
                                38.19912
                            ],
                            [
                                24.25677,
                                38.28048
                            ],
                            [
                                24.18397,
                                38.39462
                            ],
                            [
                                24.18814,
                                38.48597
                            ],
                            [
                                24.22009,
                                38.52953
                            ],
                            [
                                24.12373,
                                38.59578
                            ],
                            [
                                24.12283,
                                38.66671
                            ],
                            [
                                24.04388,
                                38.68586
                            ],
                            [
                                23.95517,
                                38.66111
                            ],
                            [
                                23.75623,
                                38.70605
                            ],
                            [
                                23.68367,
                                38.75424
                            ],
                            [
                                23.5921,
                                38.76575
                            ],
                            [
                                23.47043,
                                38.83582
                            ],
                            [
                                23.37607,
                                39.00688
                            ],
                            [
                                23.27934,
                                39.03782
                            ],
                            [
                                23.20538,
                                39.00498
                            ],
                            [
                                23.13121,
                                39.00786
                            ],
                            [
                                23.08736,
                                38.94854
                            ],
                            [
                                22.85057,
                                38.86988
                            ],
                            [
                                22.94154,
                                38.83451
                            ],
                            [
                                23.03157,
                                38.88119
                            ],
                            [
                                23.13401,
                                38.85202
                            ],
                            [
                                23.32223,
                                38.76188
                            ],
                            [
                                23.38656,
                                38.69838
                            ],
                            [
                                23.49012,
                                38.63425
                            ],
                            [
                                23.51148,
                                38.58748
                            ],
                            [
                                23.59567,
                                38.57296
                            ],
                            [
                                23.63402,
                                38.50792
                            ],
                            [
                                23.59003,
                                38.47358
                            ],
                            [
                                23.36854,
                                38.50986
                            ],
                            [
                                23.30713,
                                38.5875
                            ],
                            [
                                23.32185,
                                38.63643
                            ],
                            [
                                23.16713,
                                38.64305
                            ],
                            [
                                23.10665,
                                38.62617
                            ],
                            [
                                23.03665,
                                38.75264
                            ],
                            [
                                22.96914,
                                38.74582
                            ],
                            [
                                22.89922,
                                38.77675
                            ],
                            [
                                22.77895,
                                38.77832
                            ],
                            [
                                22.6854,
                                38.8417
                            ],
                            [
                                22.6073,
                                38.82226
                            ],
                            [
                                22.5483,
                                38.87751
                            ],
                            [
                                22.61732,
                                38.9113
                            ],
                            [
                                22.75525,
                                38.87054
                            ],
                            [
                                22.99101,
                                38.94705
                            ],
                            [
                                23.02901,
                                39.0157
                            ],
                            [
                                22.91143,
                                39.15777
                            ],
                            [
                                22.83272,
                                39.18766
                            ],
                            [
                                22.82215,
                                39.27683
                            ],
                            [
                                22.9359,
                                39.29526
                            ],
                            [
                                22.94305,
                                39.34279
                            ],
                            [
                                23.11864,
                                39.30525
                            ],
                            [
                                23.17973,
                                39.24994
                            ],
                            [
                                23.21331,
                                39.14934
                            ],
                            [
                                23.30349,
                                39.14113
                            ],
                            [
                                23.35007,
                                39.18859
                            ],
                            [
                                23.27295,
                                39.31602
                            ],
                            [
                                23.20754,
                                39.3643
                            ],
                            [
                                23.09568,
                                39.49845
                            ],
                            [
                                22.93653,
                                39.57442
                            ],
                            [
                                22.90376,
                                39.6269
                            ],
                            [
                                22.8514,
                                39.79986
                            ],
                            [
                                22.73592,
                                39.86996
                            ],
                            [
                                22.70871,
                                39.95235
                            ],
                            [
                                22.59572,
                                40.01138
                            ],
                            [
                                22.54808,
                                40.14593
                            ],
                            [
                                22.60012,
                                40.27205
                            ],
                            [
                                22.65897,
                                40.35463
                            ],
                            [
                                22.59456,
                                40.47261
                            ],
                            [
                                22.65375,
                                40.5182
                            ],
                            [
                                22.73524,
                                40.51011
                            ],
                            [
                                22.74432,
                                40.55818
                            ],
                            [
                                22.85448,
                                40.59372
                            ],
                            [
                                22.90021,
                                40.64406
                            ],
                            [
                                22.97918,
                                40.5415
                            ],
                            [
                                22.91285,
                                40.50617
                            ],
                            [
                                22.82622,
                                40.50667
                            ],
                            [
                                22.90206,
                                40.39784
                            ],
                            [
                                22.98598,
                                40.36637
                            ],
                            [
                                23.0224,
                                40.32345
                            ],
                            [
                                23.14183,
                                40.27481
                            ],
                            [
                                23.29118,
                                40.23675
                            ],
                            [
                                23.32622,
                                40.18401
                            ],
                            [
                                23.30958,
                                40.08397
                            ],
                            [
                                23.38101,
                                40.0015
                            ],
                            [
                                23.59591,
                                39.9211
                            ],
                            [
                                23.68484,
                                39.91697
                            ],
                            [
                                23.67844,
                                39.97194
                            ],
                            [
                                23.49291,
                                40.0349
                            ],
                            [
                                23.331,
                                40.2054
                            ],
                            [
                                23.3892,
                                40.27419
                            ],
                            [
                                23.52876,
                                40.23778
                            ],
                            [
                                23.6555,
                                40.22197
                            ],
                            [
                                23.77085,
                                40.11769
                            ],
                            [
                                23.78877,
                                40.06333
                            ],
                            [
                                23.90146,
                                39.98195
                            ],
                            [
                                23.98993,
                                39.95185
                            ],
                            [
                                24.0153,
                                40.03592
                            ],
                            [
                                23.99175,
                                40.1118
                            ],
                            [
                                23.91194,
                                40.15705
                            ],
                            [
                                23.7772,
                                40.19346
                            ],
                            [
                                23.69728,
                                40.28544
                            ],
                            [
                                23.7366,
                                40.35357
                            ],
                            [
                                23.91943,
                                40.36467
                            ],
                            [
                                24.04369,
                                40.29335
                            ],
                            [
                                24.15801,
                                40.28208
                            ],
                            [
                                24.28037,
                                40.16141
                            ],
                            [
                                24.30339,
                                40.1145
                            ],
                            [
                                24.39926,
                                40.14038
                            ],
                            [
                                24.37044,
                                40.19501
                            ],
                            [
                                24.2865,
                                40.24668
                            ],
                            [
                                24.19243,
                                40.34011
                            ],
                            [
                                24.01099,
                                40.38943
                            ],
                            [
                                23.88936,
                                40.39538
                            ],
                            [
                                23.82089,
                                40.48154
                            ],
                            [
                                23.83252,
                                40.55821
                            ],
                            [
                                23.69624,
                                40.69099
                            ],
                            [
                                23.73927,
                                40.75564
                            ],
                            [
                                23.83381,
                                40.78366
                            ],
                            [
                                24.04425,
                                40.71917
                            ],
                            [
                                24.13652,
                                40.73602
                            ],
                            [
                                24.31505,
                                40.82452
                            ],
                            [
                                24.3207,
                                40.88246
                            ],
                            [
                                24.39517,
                                40.93351
                            ],
                            [
                                24.54892,
                                40.95422
                            ],
                            [
                                24.62796,
                                40.85914
                            ],
                            [
                                24.79873,
                                40.846
                            ],
                            [
                                24.87159,
                                40.90507
                            ],
                            [
                                24.98666,
                                40.93122
                            ],
                            [
                                25.06816,
                                41.004
                            ],
                            [
                                25.13062,
                                40.95583
                            ],
                            [
                                25.37837,
                                40.91148
                            ],
                            [
                                25.56177,
                                40.85773
                            ],
                            [
                                25.9514,
                                40.84079
                            ],
                            [
                                26.02049,
                                40.79447
                            ],
                            [
                                26.03276,
                                40.73026
                            ],
                            [
                                26.12338,
                                40.74477
                            ],
                            [
                                26.20935,
                                40.86042
                            ],
                            [
                                26.35526,
                                40.9479
                            ],
                            [
                                26.36378,
                                41.01038
                            ],
                            [
                                26.31366,
                                41.07568
                            ],
                            [
                                26.31106,
                                41.18049
                            ],
                            [
                                26.33328,
                                41.25837
                            ],
                            [
                                26.40633,
                                41.25517
                            ],
                            [
                                26.53209,
                                41.34195
                            ],
                            [
                                26.62845,
                                41.34644
                            ],
                            [
                                26.59236,
                                41.52985
                            ],
                            [
                                26.59979,
                                41.59728
                            ],
                            [
                                26.44349,
                                41.68575
                            ],
                            [
                                26.35788,
                                41.7111
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                23.84296,
                                35.52782
                            ],
                            [
                                23.77983,
                                35.54584
                            ],
                            [
                                23.77276,
                                35.66891
                            ],
                            [
                                23.70939,
                                35.66021
                            ],
                            [
                                23.72842,
                                35.54636
                            ],
                            [
                                23.65466,
                                35.50169
                            ],
                            [
                                23.56988,
                                35.52934
                            ],
                            [
                                23.56656,
                                35.42844
                            ],
                            [
                                23.53385,
                                35.37632
                            ],
                            [
                                23.54212,
                                35.27122
                            ],
                            [
                                23.58844,
                                35.23202
                            ],
                            [
                                23.78507,
                                35.23265
                            ],
                            [
                                23.82621,
                                35.24889
                            ],
                            [
                                23.92352,
                                35.2218
                            ],
                            [
                                23.97896,
                                35.2312
                            ],
                            [
                                24.05056,
                                35.1944
                            ],
                            [
                                24.19961,
                                35.20053
                            ],
                            [
                                24.28752,
                                35.17601
                            ],
                            [
                                24.38596,
                                35.19399
                            ],
                            [
                                24.45492,
                                35.15061
                            ],
                            [
                                24.52012,
                                35.14349
                            ],
                            [
                                24.56031,
                                35.10187
                            ],
                            [
                                24.73859,
                                35.08214
                            ],
                            [
                                24.75154,
                                34.9566
                            ],
                            [
                                24.79359,
                                34.92419
                            ],
                            [
                                25.19281,
                                34.94632
                            ],
                            [
                                25.37275,
                                34.9973
                            ],
                            [
                                25.49997,
                                34.98226
                            ],
                            [
                                25.69046,
                                35.01395
                            ],
                            [
                                25.81312,
                                34.99998
                            ],
                            [
                                25.97635,
                                35.03894
                            ],
                            [
                                26.09684,
                                34.9985
                            ],
                            [
                                26.23142,
                                35.03611
                            ],
                            [
                                26.2842,
                                35.13187
                            ],
                            [
                                26.26516,
                                35.26459
                            ],
                            [
                                26.13673,
                                35.19703
                            ],
                            [
                                26.02787,
                                35.22831
                            ],
                            [
                                25.94712,
                                35.18267
                            ],
                            [
                                25.89663,
                                35.18479
                            ],
                            [
                                25.81369,
                                35.11032
                            ],
                            [
                                25.72765,
                                35.13058
                            ],
                            [
                                25.71018,
                                35.17543
                            ],
                            [
                                25.7276,
                                35.30284
                            ],
                            [
                                25.65968,
                                35.34809
                            ],
                            [
                                25.43114,
                                35.2943
                            ],
                            [
                                25.38441,
                                35.33767
                            ],
                            [
                                25.19925,
                                35.33259
                            ],
                            [
                                25.04674,
                                35.34524
                            ],
                            [
                                25.01798,
                                35.41998
                            ],
                            [
                                24.91861,
                                35.40425
                            ],
                            [
                                24.70044,
                                35.42623
                            ],
                            [
                                24.55169,
                                35.37588
                            ],
                            [
                                24.35671,
                                35.3522
                            ],
                            [
                                24.25805,
                                35.37968
                            ],
                            [
                                24.25831,
                                35.4532
                            ],
                            [
                                24.20013,
                                35.44989
                            ],
                            [
                                24.15667,
                                35.49518
                            ],
                            [
                                24.20046,
                                35.53866
                            ],
                            [
                                24.16901,
                                35.58889
                            ],
                            [
                                23.99428,
                                35.51247
                            ],
                            [
                                23.84296,
                                35.52782
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                26.36478,
                                39.37632
                            ],
                            [
                                26.16905,
                                39.37034
                            ],
                            [
                                26.12056,
                                39.3073
                            ],
                            [
                                25.85998,
                                39.25598
                            ],
                            [
                                25.84532,
                                39.17629
                            ],
                            [
                                25.95815,
                                39.10699
                            ],
                            [
                                26.07253,
                                39.08862
                            ],
                            [
                                26.16914,
                                39.19556
                            ],
                            [
                                26.24735,
                                39.20562
                            ],
                            [
                                26.2806,
                                39.15627
                            ],
                            [
                                26.18777,
                                39.12469
                            ],
                            [
                                26.11778,
                                39.06277
                            ],
                            [
                                26.169,
                                39.00772
                            ],
                            [
                                26.23089,
                                39.01615
                            ],
                            [
                                26.39988,
                                38.96358
                            ],
                            [
                                26.60399,
                                39.00941
                            ],
                            [
                                26.5342,
                                39.1698
                            ],
                            [
                                26.38282,
                                39.27062
                            ],
                            [
                                26.4224,
                                39.33356
                            ],
                            [
                                26.36478,
                                39.37632
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                28.22957,
                                36.44442
                            ],
                            [
                                28.05505,
                                36.39873
                            ],
                            [
                                27.8784,
                                36.32239
                            ],
                            [
                                27.80575,
                                36.26984
                            ],
                            [
                                27.71208,
                                36.11306
                            ],
                            [
                                27.75828,
                                36.09532
                            ],
                            [
                                27.75499,
                                36.01379
                            ],
                            [
                                27.71967,
                                35.94041
                            ],
                            [
                                27.77126,
                                35.88764
                            ],
                            [
                                27.86248,
                                35.92811
                            ],
                            [
                                27.95543,
                                36.04579
                            ],
                            [
                                28.07584,
                                36.07381
                            ],
                            [
                                28.07748,
                                36.14532
                            ],
                            [
                                28.13819,
                                36.18749
                            ],
                            [
                                28.17468,
                                36.28094
                            ],
                            [
                                28.24581,
                                36.38715
                            ],
                            [
                                28.22957,
                                36.44442
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                26.00329,
                                38.60409
                            ],
                            [
                                25.85057,
                                38.57424
                            ],
                            [
                                25.86484,
                                38.49188
                            ],
                            [
                                25.95664,
                                38.43989
                            ],
                            [
                                25.99356,
                                38.34328
                            ],
                            [
                                25.95351,
                                38.29469
                            ],
                            [
                                25.87608,
                                38.27142
                            ],
                            [
                                25.88956,
                                38.2214
                            ],
                            [
                                26.01187,
                                38.14998
                            ],
                            [
                                26.09937,
                                38.21211
                            ],
                            [
                                26.10477,
                                38.2724
                            ],
                            [
                                26.157,
                                38.30966
                            ],
                            [
                                26.13443,
                                38.41558
                            ],
                            [
                                26.16092,
                                38.54915
                            ],
                            [
                                26.08973,
                                38.55761
                            ],
                            [
                                26.00329,
                                38.60409
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                20.56169,
                                38.47485
                            ],
                            [
                                20.53387,
                                38.34125
                            ],
                            [
                                20.4892,
                                38.31197
                            ],
                            [
                                20.39741,
                                38.35097
                            ],
                            [
                                20.38828,
                                38.27754
                            ],
                            [
                                20.33792,
                                38.18868
                            ],
                            [
                                20.43978,
                                38.1624
                            ],
                            [
                                20.56445,
                                38.09091
                            ],
                            [
                                20.60645,
                                38.11714
                            ],
                            [
                                20.70333,
                                38.06944
                            ],
                            [
                                20.79353,
                                38.06444
                            ],
                            [
                                20.8136,
                                38.11013
                            ],
                            [
                                20.67521,
                                38.27024
                            ],
                            [
                                20.62638,
                                38.2592
                            ],
                            [
                                20.61032,
                                38.40144
                            ],
                            [
                                20.56169,
                                38.47485
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                19.89531,
                                39.79506
                            ],
                            [
                                19.67235,
                                39.79481
                            ],
                            [
                                19.63506,
                                39.75207
                            ],
                            [
                                19.67485,
                                39.68204
                            ],
                            [
                                19.83014,
                                39.57305
                            ],
                            [
                                19.87133,
                                39.45589
                            ],
                            [
                                20.0853,
                                39.36737
                            ],
                            [
                                20.03376,
                                39.43644
                            ],
                            [
                                19.93923,
                                39.47322
                            ],
                            [
                                19.91014,
                                39.56622
                            ],
                            [
                                19.92296,
                                39.61574
                            ],
                            [
                                19.84594,
                                39.65652
                            ],
                            [
                                19.84406,
                                39.70386
                            ],
                            [
                                19.92973,
                                39.73587
                            ],
                            [
                                19.89531,
                                39.79506
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                25.4381,
                                40.00914
                            ],
                            [
                                25.36803,
                                40.00137
                            ],
                            [
                                25.30198,
                                39.94804
                            ],
                            [
                                25.23105,
                                40.00312
                            ],
                            [
                                25.05457,
                                39.98566
                            ],
                            [
                                25.0525,
                                39.86433
                            ],
                            [
                                25.15539,
                                39.83096
                            ],
                            [
                                25.24416,
                                39.85898
                            ],
                            [
                                25.30241,
                                39.79578
                            ],
                            [
                                25.36978,
                                39.81106
                            ],
                            [
                                25.34241,
                                39.87663
                            ],
                            [
                                25.44245,
                                39.98081
                            ],
                            [
                                25.4381,
                                40.00914
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                26.95446,
                                37.75858
                            ],
                            [
                                26.85032,
                                37.80456
                            ],
                            [
                                26.73526,
                                37.81188
                            ],
                            [
                                26.5994,
                                37.76284
                            ],
                            [
                                26.5909,
                                37.67845
                            ],
                            [
                                26.70687,
                                37.70995
                            ],
                            [
                                26.81364,
                                37.6384
                            ],
                            [
                                26.91172,
                                37.68247
                            ],
                            [
                                27.0364,
                                37.70633
                            ],
                            [
                                27.0281,
                                37.75468
                            ],
                            [
                                26.95446,
                                37.75858
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                25.54928,
                                37.18373
                            ],
                            [
                                25.49363,
                                37.18749
                            ],
                            [
                                25.37575,
                                37.10859
                            ],
                            [
                                25.36743,
                                37.02406
                            ],
                            [
                                25.45,
                                36.91818
                            ],
                            [
                                25.54875,
                                36.95746
                            ],
                            [
                                25.5986,
                                37.1165
                            ],
                            [
                                25.54928,
                                37.18373
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                20.76957,
                                37.84226
                            ],
                            [
                                20.68087,
                                37.92396
                            ],
                            [
                                20.62998,
                                37.87985
                            ],
                            [
                                20.63227,
                                37.81257
                            ],
                            [
                                20.71218,
                                37.72607
                            ],
                            [
                                20.83403,
                                37.64552
                            ],
                            [
                                20.87003,
                                37.72553
                            ],
                            [
                                20.91969,
                                37.73562
                            ],
                            [
                                20.90243,
                                37.80471
                            ],
                            [
                                20.76957,
                                37.84226
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                24.6742,
                                40.78245
                            ],
                            [
                                24.56301,
                                40.76219
                            ],
                            [
                                24.51115,
                                40.66127
                            ],
                            [
                                24.64279,
                                40.56865
                            ],
                            [
                                24.78216,
                                40.62513
                            ],
                            [
                                24.76319,
                                40.73149
                            ],
                            [
                                24.6742,
                                40.78245
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                24.86931,
                                37.90745
                            ],
                            [
                                24.78821,
                                37.99623
                            ],
                            [
                                24.68677,
                                37.95048
                            ],
                            [
                                24.71172,
                                37.87551
                            ],
                            [
                                24.79942,
                                37.82487
                            ],
                            [
                                24.95418,
                                37.70387
                            ],
                            [
                                24.99798,
                                37.76896
                            ],
                            [
                                24.94248,
                                37.83783
                            ],
                            [
                                24.95287,
                                37.89818
                            ],
                            [
                                24.86931,
                                37.90745
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                20.68034,
                                38.83913
                            ],
                            [
                                20.59973,
                                38.78055
                            ],
                            [
                                20.55656,
                                38.68006
                            ],
                            [
                                20.55469,
                                38.61121
                            ],
                            [
                                20.61577,
                                38.60046
                            ],
                            [
                                20.72422,
                                38.63643
                            ],
                            [
                                20.71939,
                                38.82397
                            ],
                            [
                                20.68034,
                                38.83913
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                27.23252,
                                35.81453
                            ],
                            [
                                27.16491,
                                35.80008
                            ],
                            [
                                27.16255,
                                35.72742
                            ],
                            [
                                27.11976,
                                35.6445
                            ],
                            [
                                27.06792,
                                35.60597
                            ],
                            [
                                27.11147,
                                35.54771
                            ],
                            [
                                27.15341,
                                35.42545
                            ],
                            [
                                27.20303,
                                35.48073
                            ],
                            [
                                27.20242,
                                35.57306
                            ],
                            [
                                27.15142,
                                35.61307
                            ],
                            [
                                27.21658,
                                35.72885
                            ],
                            [
                                27.23252,
                                35.81453
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                27.28034,
                                36.9158
                            ],
                            [
                                27.07527,
                                36.84949
                            ],
                            [
                                26.9946,
                                36.77156
                            ],
                            [
                                27.10094,
                                36.75665
                            ],
                            [
                                27.17095,
                                36.80736
                            ],
                            [
                                27.32534,
                                36.84602
                            ],
                            [
                                27.28034,
                                36.9158
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                23.09876,
                                36.24936
                            ],
                            [
                                23.00194,
                                36.30978
                            ],
                            [
                                22.95077,
                                36.38256
                            ],
                            [
                                22.89213,
                                36.32125
                            ],
                            [
                                22.9225,
                                36.28868
                            ],
                            [
                                22.90947,
                                36.20052
                            ],
                            [
                                22.94338,
                                36.15739
                            ],
                            [
                                23.04654,
                                36.13156
                            ],
                            [
                                23.05492,
                                36.21759
                            ],
                            [
                                23.09876,
                                36.24936
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                26.3641,
                                37.6892
                            ],
                            [
                                26.29647,
                                37.67959
                            ],
                            [
                                26.20007,
                                37.62756
                            ],
                            [
                                26.06401,
                                37.62669
                            ],
                            [
                                25.97919,
                                37.53642
                            ],
                            [
                                26.06294,
                                37.51698
                            ],
                            [
                                26.10926,
                                37.55394
                            ],
                            [
                                26.21438,
                                37.56808
                            ],
                            [
                                26.32212,
                                37.63299
                            ],
                            [
                                26.3641,
                                37.6892
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                24.57623,
                                38.8843
                            ],
                            [
                                24.57688,
                                38.9267
                            ],
                            [
                                24.49031,
                                38.97633
                            ],
                            [
                                24.43462,
                                38.88326
                            ],
                            [
                                24.56717,
                                38.83365
                            ],
                            [
                                24.60876,
                                38.77076
                            ],
                            [
                                24.67827,
                                38.81103
                            ],
                            [
                                24.57623,
                                38.8843
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                25.02721,
                                37.67789
                            ],
                            [
                                24.99629,
                                37.63907
                            ],
                            [
                                25.18788,
                                37.52507
                            ],
                            [
                                25.2324,
                                37.53789
                            ],
                            [
                                25.25146,
                                37.6102
                            ],
                            [
                                25.20517,
                                37.63355
                            ],
                            [
                                25.0505,
                                37.65382
                            ],
                            [
                                25.02721,
                                37.67789
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                25.22569,
                                37.15446
                            ],
                            [
                                25.15909,
                                37.12186
                            ],
                            [
                                25.10808,
                                37.06235
                            ],
                            [
                                25.11788,
                                36.99438
                            ],
                            [
                                25.17977,
                                36.97542
                            ],
                            [
                                25.24825,
                                37.01334
                            ],
                            [
                                25.282,
                                37.12276
                            ],
                            [
                                25.22569,
                                37.15446
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                25.58882,
                                40.50472
                            ],
                            [
                                25.49466,
                                40.49501
                            ],
                            [
                                25.45884,
                                40.45812
                            ],
                            [
                                25.55923,
                                40.39605
                            ],
                            [
                                25.6968,
                                40.4226
                            ],
                            [
                                25.69957,
                                40.46408
                            ],
                            [
                                25.58882,
                                40.50472
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                24.44052,
                                36.7548
                            ],
                            [
                                24.3414,
                                36.74256
                            ],
                            [
                                24.33955,
                                36.65274
                            ],
                            [
                                24.53407,
                                36.6777
                            ],
                            [
                                24.53159,
                                36.74142
                            ],
                            [
                                24.44052,
                                36.7548
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                24.34721,
                                37.68562
                            ],
                            [
                                24.26898,
                                37.61086
                            ],
                            [
                                24.295,
                                37.52575
                            ],
                            [
                                24.3867,
                                37.60706
                            ],
                            [
                                24.40864,
                                37.6541
                            ],
                            [
                                24.34721,
                                37.68562
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                26.01715,
                                36.93408
                            ],
                            [
                                25.91054,
                                36.86788
                            ],
                            [
                                25.846,
                                36.85069
                            ],
                            [
                                25.87145,
                                36.79133
                            ],
                            [
                                26.00931,
                                36.89302
                            ],
                            [
                                26.01715,
                                36.93408
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                26.89056,
                                37.07886
                            ],
                            [
                                26.93901,
                                37.04305
                            ],
                            [
                                26.91106,
                                36.95121
                            ],
                            [
                                27.0186,
                                36.94724
                            ],
                            [
                                27.04978,
                                36.99889
                            ],
                            [
                                26.89056,
                                37.07886
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                25.38739,
                                36.72843
                            ],
                            [
                                25.27404,
                                36.78586
                            ],
                            [
                                25.25617,
                                36.73028
                            ],
                            [
                                25.35595,
                                36.6469
                            ],
                            [
                                25.38739,
                                36.72843
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                24.48396,
                                37.40087
                            ],
                            [
                                24.38122,
                                37.44359
                            ],
                            [
                                24.3957,
                                37.30834
                            ],
                            [
                                24.48396,
                                37.40087
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                20.67225,
                                38.46957
                            ],
                            [
                                20.61596,
                                38.46607
                            ],
                            [
                                20.68472,
                                38.34722
                            ],
                            [
                                20.74962,
                                38.36916
                            ],
                            [
                                20.67225,
                                38.46957
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                23.53701,
                                37.98297
                            ],
                            [
                                23.48317,
                                38.00173
                            ],
                            [
                                23.4027,
                                37.8937
                            ],
                            [
                                23.51365,
                                37.89686
                            ],
                            [
                                23.53701,
                                37.98297
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                23.50572,
                                37.77453
                            ],
                            [
                                23.41837,
                                37.76095
                            ],
                            [
                                23.47981,
                                37.67391
                            ],
                            [
                                23.52431,
                                37.69334
                            ],
                            [
                                23.50572,
                                37.77453
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                24.65933,
                                37.03693
                            ],
                            [
                                24.65677,
                                36.98063
                            ],
                            [
                                24.69994,
                                36.90243
                            ],
                            [
                                24.76477,
                                36.94957
                            ],
                            [
                                24.65933,
                                37.03693
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                24.49724,
                                37.20771
                            ],
                            [
                                24.41972,
                                37.15648
                            ],
                            [
                                24.5175,
                                37.12211
                            ],
                            [
                                24.49724,
                                37.20771
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                23.86519,
                                39.13858
                            ],
                            [
                                23.97593,
                                39.25484
                            ],
                            [
                                23.93676,
                                39.27652
                            ],
                            [
                                23.87671,
                                39.20673
                            ],
                            [
                                23.86519,
                                39.13858
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                27.85855,
                                36.66545
                            ],
                            [
                                27.78607,
                                36.58458
                            ],
                            [
                                27.84707,
                                36.56259
                            ],
                            [
                                27.88045,
                                36.60664
                            ],
                            [
                                27.85855,
                                36.66545
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                27.34973,
                                36.48247
                            ],
                            [
                                27.39444,
                                36.37656
                            ],
                            [
                                27.43762,
                                36.39291
                            ],
                            [
                                27.34973,
                                36.48247
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                26.80888,
                                37.20204
                            ],
                            [
                                26.76568,
                                37.17423
                            ],
                            [
                                26.85222,
                                37.09656
                            ],
                            [
                                26.8831,
                                37.12524
                            ],
                            [
                                26.80888,
                                37.20204
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                23.39925,
                                37.63648
                            ],
                            [
                                23.30845,
                                37.61861
                            ],
                            [
                                23.37571,
                                37.55658
                            ],
                            [
                                23.39925,
                                37.63648
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "GRL",
                "Country": "Greenland",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    4.455e-08,
                    8.91e-08,
                    1.3695e-07,
                    1.914e-07,
                    2.376e-07,
                    3.3165e-07,
                    3.96e-07,
                    4.686e-07,
                    5.709e-07,
                    6.765e-07,
                    7.7715e-07,
                    9.0915e-07,
                    1.028e-06,
                    1.1764e-06,
                    1.3184e-06,
                    1.4735e-06,
                    1.6484e-06,
                    1.8365e-06,
                    2.0807e-06,
                    2.2638e-06,
                    2.4354e-06,
                    2.6466e-06,
                    2.8958e-06,
                    3.1465e-06,
                    3.3974e-06,
                    3.6251e-06,
                    3.724e-06,
                    4.0491e-06,
                    4.2256e-06,
                    4.4831e-06,
                    4.7372e-06,
                    4.9748e-06,
                    5.2074e-06,
                    5.3708e-06,
                    5.6265e-06,
                    5.8559e-06,
                    6.0027e-06,
                    6.1083e-06,
                    6.3541e-06,
                    6.567e-06,
                    6.8483e-06,
                    7.123e-06,
                    7.3913e-06,
                    7.6371e-06,
                    7.8605e-06,
                    8.1011e-06,
                    8.3699e-06,
                    8.6481e-06,
                    8.9171e-06,
                    9.185e-06,
                    9.4857e-06,
                    9.7641e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    4.455e-08,
                    8.91e-08,
                    1.3695e-07,
                    1.914e-07,
                    2.376e-07,
                    3.3165e-07,
                    3.96e-07,
                    4.686e-07,
                    5.709e-07,
                    6.765e-07,
                    7.7715e-07,
                    9.0915e-07,
                    1.028e-06,
                    1.1764e-06,
                    1.3184e-06,
                    1.4735e-06,
                    1.6484e-06,
                    1.8365e-06,
                    2.0807e-06,
                    2.2638e-06,
                    2.4354e-06,
                    2.6466e-06,
                    2.8958e-06,
                    3.1465e-06,
                    3.3974e-06,
                    3.6251e-06,
                    3.724e-06,
                    4.0491e-06,
                    4.2256e-06,
                    4.4831e-06,
                    4.7372e-06,
                    4.9748e-06,
                    5.2074e-06,
                    5.3708e-06,
                    5.6265e-06,
                    5.8559e-06,
                    6.0027e-06,
                    6.1083e-06,
                    6.3541e-06,
                    6.567e-06,
                    6.8483e-06,
                    7.123e-06,
                    7.3913e-06,
                    7.6371e-06,
                    7.8605e-06,
                    8.1011e-06,
                    8.3699e-06,
                    8.6481e-06,
                    8.9171e-06,
                    9.185e-06,
                    9.4857e-06,
                    9.7641e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    4.455e-08,
                    8.91e-08,
                    1.3695e-07,
                    1.914e-07,
                    2.376e-07,
                    3.3165e-07,
                    3.96e-07,
                    4.686e-07,
                    5.709e-07,
                    6.765e-07,
                    7.7715e-07,
                    9.0915e-07,
                    1.028e-06,
                    1.1764e-06,
                    1.3184e-06,
                    1.4735e-06,
                    1.6484e-06,
                    1.8365e-06,
                    2.0807e-06,
                    2.2638e-06,
                    2.4354e-06,
                    2.6466e-06,
                    2.8958e-06,
                    3.1465e-06,
                    3.3974e-06,
                    3.6251e-06,
                    3.724e-06,
                    4.0491e-06,
                    4.2256e-06,
                    4.4831e-06,
                    4.7372e-06,
                    4.9748e-06,
                    5.2074e-06,
                    5.3708e-06,
                    5.6265e-06,
                    5.8559e-06,
                    6.0027e-06,
                    6.1083e-06,
                    6.3541e-06,
                    6.567e-06,
                    6.8483e-06,
                    7.123e-06,
                    7.3913e-06,
                    7.6371e-06,
                    7.8605e-06,
                    8.1011e-06,
                    8.3699e-06,
                    8.6481e-06,
                    8.9171e-06,
                    9.185e-06,
                    9.4857e-06,
                    9.7641e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    4.455e-08,
                    8.91e-08,
                    1.3695e-07,
                    1.914e-07,
                    2.376e-07,
                    3.3165e-07,
                    3.96e-07,
                    4.686e-07,
                    5.709e-07,
                    6.765e-07,
                    7.7715e-07,
                    9.0915e-07,
                    1.028e-06,
                    1.1764e-06,
                    1.3184e-06,
                    1.4735e-06,
                    1.6484e-06,
                    1.8365e-06,
                    2.0807e-06,
                    2.2638e-06,
                    2.4354e-06,
                    2.6466e-06,
                    2.8958e-06,
                    3.1465e-06,
                    3.3974e-06,
                    3.6251e-06,
                    3.724e-06,
                    4.0491e-06,
                    4.2256e-06,
                    4.4831e-06,
                    4.7372e-06,
                    4.9748e-06,
                    5.2074e-06,
                    5.3708e-06,
                    5.6265e-06,
                    5.8559e-06,
                    6.0027e-06,
                    6.1083e-06,
                    6.3541e-06,
                    6.567e-06,
                    6.8483e-06,
                    7.123e-06,
                    7.3913e-06,
                    7.6371e-06,
                    7.8605e-06,
                    8.1011e-06,
                    8.3699e-06,
                    8.6481e-06,
                    8.9171e-06,
                    9.185e-06,
                    9.4857e-06,
                    9.7641e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": []
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -33.25139,
                                83.65157
                            ],
                            [
                                -33.8591,
                                83.6586
                            ],
                            [
                                -35.0955,
                                83.61082
                            ],
                            [
                                -35.60923,
                                83.627
                            ],
                            [
                                -35.87479,
                                83.5762
                            ],
                            [
                                -36.38843,
                                83.61215
                            ],
                            [
                                -37.21084,
                                83.59284
                            ],
                            [
                                -37.76354,
                                83.52782
                            ],
                            [
                                -37.52759,
                                83.4491
                            ],
                            [
                                -38.66984,
                                83.54437
                            ],
                            [
                                -38.93518,
                                83.4555
                            ],
                            [
                                -39.34502,
                                83.42583
                            ],
                            [
                                -39.79907,
                                83.44016
                            ],
                            [
                                -39.55333,
                                83.31196
                            ],
                            [
                                -39.67361,
                                83.25028
                            ],
                            [
                                -39.36139,
                                83.19178
                            ],
                            [
                                -38.67264,
                                83.19106
                            ],
                            [
                                -38.48716,
                                83.11702
                            ],
                            [
                                -39.43607,
                                83.05768
                            ],
                            [
                                -39.41242,
                                83.02305
                            ],
                            [
                                -39.81483,
                                82.94619
                            ],
                            [
                                -39.44349,
                                82.87682
                            ],
                            [
                                -39.46126,
                                82.78859
                            ],
                            [
                                -40.13768,
                                82.92896
                            ],
                            [
                                -41.34607,
                                82.9361
                            ],
                            [
                                -41.56478,
                                82.98981
                            ],
                            [
                                -42.31799,
                                83.09339
                            ],
                            [
                                -42.54697,
                                83.14992
                            ],
                            [
                                -43.47686,
                                83.2339
                            ],
                            [
                                -44.10951,
                                83.22051
                            ],
                            [
                                -44.21079,
                                83.12004
                            ],
                            [
                                -44.74627,
                                83.08548
                            ],
                            [
                                -45.47589,
                                83.11274
                            ],
                            [
                                -45.95621,
                                83.10331
                            ],
                            [
                                -46.22349,
                                83.05126
                            ],
                            [
                                -45.88602,
                                82.97246
                            ],
                            [
                                -45.32429,
                                82.92707
                            ],
                            [
                                -45.77812,
                                82.87171
                            ],
                            [
                                -45.47322,
                                82.80266
                            ],
                            [
                                -44.75588,
                                82.77792
                            ],
                            [
                                -43.29677,
                                82.80047
                            ],
                            [
                                -42.41765,
                                82.78311
                            ],
                            [
                                -41.67528,
                                82.72672
                            ],
                            [
                                -41.20492,
                                82.66268
                            ],
                            [
                                -40.63412,
                                82.6602
                            ],
                            [
                                -40.38496,
                                82.55564
                            ],
                            [
                                -40.44399,
                                82.48234
                            ],
                            [
                                -41.17328,
                                82.50922
                            ],
                            [
                                -41.86223,
                                82.6506
                            ],
                            [
                                -43.27007,
                                82.71898
                            ],
                            [
                                -45.24543,
                                82.70161
                            ],
                            [
                                -46.39453,
                                82.7137
                            ],
                            [
                                -46.35398,
                                82.66152
                            ],
                            [
                                -45.6749,
                                82.53378
                            ],
                            [
                                -45.31907,
                                82.48814
                            ],
                            [
                                -44.99858,
                                82.3773
                            ],
                            [
                                -44.36636,
                                82.30405
                            ],
                            [
                                -44.48771,
                                82.21526
                            ],
                            [
                                -44.96924,
                                82.20512
                            ],
                            [
                                -45.46799,
                                82.14521
                            ],
                            [
                                -45.57776,
                                82.06878
                            ],
                            [
                                -45.33804,
                                81.9712
                            ],
                            [
                                -45.79737,
                                81.90232
                            ],
                            [
                                -45.61576,
                                81.74992
                            ],
                            [
                                -45.20154,
                                81.70758
                            ],
                            [
                                -45.38542,
                                81.67117
                            ],
                            [
                                -46.38175,
                                81.82693
                            ],
                            [
                                -46.41665,
                                81.75965
                            ],
                            [
                                -46.93178,
                                81.81931
                            ],
                            [
                                -46.95844,
                                81.89867
                            ],
                            [
                                -47.3351,
                                81.9893
                            ],
                            [
                                -48.31865,
                                82.0816
                            ],
                            [
                                -48.9453,
                                82.20361
                            ],
                            [
                                -49.61149,
                                82.28208
                            ],
                            [
                                -49.66659,
                                82.33782
                            ],
                            [
                                -50.19117,
                                82.42887
                            ],
                            [
                                -50.90509,
                                82.46111
                            ],
                            [
                                -51.76477,
                                82.45684
                            ],
                            [
                                -51.81196,
                                82.38546
                            ],
                            [
                                -51.58742,
                                82.31266
                            ],
                            [
                                -51.62893,
                                82.15524
                            ],
                            [
                                -51.51864,
                                82.09515
                            ],
                            [
                                -51.03951,
                                81.9589
                            ],
                            [
                                -50.74978,
                                81.90179
                            ],
                            [
                                -51.12458,
                                81.8512
                            ],
                            [
                                -51.54318,
                                81.83256
                            ],
                            [
                                -51.64978,
                                81.77401
                            ],
                            [
                                -52.38766,
                                81.84062
                            ],
                            [
                                -52.80735,
                                81.85731
                            ],
                            [
                                -53.55344,
                                81.95704
                            ],
                            [
                                -53.88492,
                                81.95003
                            ],
                            [
                                -53.89009,
                                81.78467
                            ],
                            [
                                -54.77194,
                                81.56376
                            ],
                            [
                                -54.82062,
                                81.65693
                            ],
                            [
                                -54.41433,
                                81.83158
                            ],
                            [
                                -54.50774,
                                81.98065
                            ],
                            [
                                -54.44518,
                                82.07547
                            ],
                            [
                                -54.87723,
                                82.2831
                            ],
                            [
                                -55.24884,
                                82.33757
                            ],
                            [
                                -56.09433,
                                82.28357
                            ],
                            [
                                -56.1544,
                                82.19862
                            ],
                            [
                                -56.69788,
                                82.24801
                            ],
                            [
                                -57.25392,
                                82.20468
                            ],
                            [
                                -59.30452,
                                82.10243
                            ],
                            [
                                -60.28762,
                                81.98122
                            ],
                            [
                                -59.71871,
                                81.93013
                            ],
                            [
                                -59.24348,
                                81.85817
                            ],
                            [
                                -59.06796,
                                81.74127
                            ],
                            [
                                -58.81771,
                                81.66738
                            ],
                            [
                                -58.42645,
                                81.63302
                            ],
                            [
                                -58.64398,
                                81.58269
                            ],
                            [
                                -59.28266,
                                81.6526
                            ],
                            [
                                -59.46252,
                                81.69592
                            ],
                            [
                                -59.51413,
                                81.82223
                            ],
                            [
                                -59.65899,
                                81.84872
                            ],
                            [
                                -60.80682,
                                81.91026
                            ],
                            [
                                -61.74342,
                                81.80089
                            ],
                            [
                                -61.95317,
                                81.73054
                            ],
                            [
                                -61.88455,
                                81.68002
                            ],
                            [
                                -61.33434,
                                81.51983
                            ],
                            [
                                -61.4825,
                                81.42917
                            ],
                            [
                                -61.86043,
                                81.33966
                            ],
                            [
                                -61.59146,
                                81.19698
                            ],
                            [
                                -62.22995,
                                81.14097
                            ],
                            [
                                -62.74198,
                                81.17429
                            ],
                            [
                                -63.52041,
                                81.19584
                            ],
                            [
                                -63.86324,
                                81.09065
                            ],
                            [
                                -64.1883,
                                81.09359
                            ],
                            [
                                -64.29355,
                                81.0331
                            ],
                            [
                                -64.89607,
                                80.97635
                            ],
                            [
                                -64.92522,
                                80.90202
                            ],
                            [
                                -65.19474,
                                80.87606
                            ],
                            [
                                -65.11724,
                                80.8227
                            ],
                            [
                                -65.30313,
                                80.76005
                            ],
                            [
                                -65.75614,
                                80.71772
                            ],
                            [
                                -66.43205,
                                80.56049
                            ],
                            [
                                -66.78264,
                                80.53632
                            ],
                            [
                                -66.68148,
                                80.49125
                            ],
                            [
                                -66.99531,
                                80.40909
                            ],
                            [
                                -67.48028,
                                80.34061
                            ],
                            [
                                -67.38766,
                                80.17067
                            ],
                            [
                                -67.174,
                                80.15437
                            ],
                            [
                                -67.01092,
                                80.05547
                            ],
                            [
                                -66.46933,
                                80.08307
                            ],
                            [
                                -66.17721,
                                80.06704
                            ],
                            [
                                -65.81232,
                                80.01012
                            ],
                            [
                                -65.49733,
                                80.04725
                            ],
                            [
                                -65.33394,
                                80.10011
                            ],
                            [
                                -64.87053,
                                80.06916
                            ],
                            [
                                -65.0648,
                                80.00831
                            ],
                            [
                                -64.63817,
                                79.98727
                            ],
                            [
                                -64.22289,
                                79.93189
                            ],
                            [
                                -64.29999,
                                79.89411
                            ],
                            [
                                -65.01899,
                                79.81669
                            ],
                            [
                                -64.98775,
                                79.72294
                            ],
                            [
                                -64.66026,
                                79.70357
                            ],
                            [
                                -64.56204,
                                79.59512
                            ],
                            [
                                -64.78151,
                                79.50526
                            ],
                            [
                                -65.02696,
                                79.45515
                            ],
                            [
                                -65.12141,
                                79.35902
                            ],
                            [
                                -65.43864,
                                79.30785
                            ],
                            [
                                -65.94156,
                                79.12618
                            ],
                            [
                                -66.26363,
                                79.09753
                            ],
                            [
                                -66.60633,
                                79.13482
                            ],
                            [
                                -67.01251,
                                79.11963
                            ],
                            [
                                -67.13216,
                                79.14428
                            ],
                            [
                                -67.65174,
                                79.09572
                            ],
                            [
                                -67.81483,
                                79.04792
                            ],
                            [
                                -68.12277,
                                79.0753
                            ],
                            [
                                -68.53608,
                                79.04322
                            ],
                            [
                                -69.05421,
                                78.95805
                            ],
                            [
                                -68.86674,
                                78.89121
                            ],
                            [
                                -69.31698,
                                78.79829
                            ],
                            [
                                -69.78654,
                                78.80219
                            ],
                            [
                                -70.10646,
                                78.73881
                            ],
                            [
                                -70.60322,
                                78.69898
                            ],
                            [
                                -70.81872,
                                78.606
                            ],
                            [
                                -71.18164,
                                78.63684
                            ],
                            [
                                -71.44731,
                                78.62475
                            ],
                            [
                                -71.73498,
                                78.55454
                            ],
                            [
                                -72.3751,
                                78.52962
                            ],
                            [
                                -72.56192,
                                78.45398
                            ],
                            [
                                -72.49727,
                                78.41786
                            ],
                            [
                                -72.77312,
                                78.35944
                            ],
                            [
                                -72.57377,
                                78.29867
                            ],
                            [
                                -72.75952,
                                78.21584
                            ],
                            [
                                -72.80875,
                                78.14262
                            ],
                            [
                                -72.56225,
                                78.05696
                            ],
                            [
                                -72.30147,
                                78.00191
                            ],
                            [
                                -72.21952,
                                77.93996
                            ],
                            [
                                -71.58943,
                                77.85862
                            ],
                            [
                                -71.22303,
                                77.76289
                            ],
                            [
                                -70.63693,
                                77.78339
                            ],
                            [
                                -70.48141,
                                77.83188
                            ],
                            [
                                -70.17056,
                                77.82454
                            ],
                            [
                                -70.47088,
                                77.73482
                            ],
                            [
                                -70.44206,
                                77.67098
                            ],
                            [
                                -70.0461,
                                77.67209
                            ],
                            [
                                -69.7055,
                                77.69883
                            ],
                            [
                                -69.62337,
                                77.66652
                            ],
                            [
                                -70.28007,
                                77.57316
                            ],
                            [
                                -69.5935,
                                77.51689
                            ],
                            [
                                -69.17103,
                                77.45841
                            ],
                            [
                                -68.61384,
                                77.5097
                            ],
                            [
                                -67.69026,
                                77.51673
                            ],
                            [
                                -67.2196,
                                77.57145
                            ],
                            [
                                -67.05526,
                                77.67458
                            ],
                            [
                                -66.63045,
                                77.7086
                            ],
                            [
                                -66.56844,
                                77.64326
                            ],
                            [
                                -66.16583,
                                77.60345
                            ],
                            [
                                -66.01413,
                                77.50223
                            ],
                            [
                                -66.03015,
                                77.44777
                            ],
                            [
                                -66.62071,
                                77.41978
                            ],
                            [
                                -66.69234,
                                77.35759
                            ],
                            [
                                -67.49362,
                                77.38903
                            ],
                            [
                                -68.44538,
                                77.36544
                            ],
                            [
                                -69.08332,
                                77.28011
                            ],
                            [
                                -68.97361,
                                77.25182
                            ],
                            [
                                -68.50297,
                                77.21103
                            ],
                            [
                                -68.35777,
                                77.16831
                            ],
                            [
                                -69.22837,
                                77.20985
                            ],
                            [
                                -69.4222,
                                77.22786
                            ],
                            [
                                -70.16029,
                                77.24244
                            ],
                            [
                                -70.90854,
                                77.18669
                            ],
                            [
                                -71.14513,
                                77.1342
                            ],
                            [
                                -71.36143,
                                77.01289
                            ],
                            [
                                -70.78095,
                                76.928
                            ],
                            [
                                -70.8842,
                                76.86929
                            ],
                            [
                                -70.60594,
                                76.79718
                            ],
                            [
                                -70.0325,
                                76.82744
                            ],
                            [
                                -69.98934,
                                76.77129
                            ],
                            [
                                -69.36749,
                                76.71021
                            ],
                            [
                                -69.2478,
                                76.68159
                            ],
                            [
                                -68.74316,
                                76.66392
                            ],
                            [
                                -68.40367,
                                76.67053
                            ],
                            [
                                -68.04204,
                                76.71247
                            ],
                            [
                                -67.97571,
                                76.58831
                            ],
                            [
                                -68.36412,
                                76.57523
                            ],
                            [
                                -68.71171,
                                76.58787
                            ],
                            [
                                -68.99241,
                                76.49125
                            ],
                            [
                                -69.53251,
                                76.44056
                            ],
                            [
                                -69.6185,
                                76.3748
                            ],
                            [
                                -69.41786,
                                76.32637
                            ],
                            [
                                -68.97637,
                                76.26955
                            ],
                            [
                                -68.7895,
                                76.16187
                            ],
                            [
                                -68.48805,
                                76.08636
                            ],
                            [
                                -66.67464,
                                75.95345
                            ],
                            [
                                -66.68345,
                                76.01635
                            ],
                            [
                                -67.04833,
                                76.07119
                            ],
                            [
                                -66.99777,
                                76.1334
                            ],
                            [
                                -67.27548,
                                76.15964
                            ],
                            [
                                -67.22752,
                                76.20085
                            ],
                            [
                                -66.93404,
                                76.27412
                            ],
                            [
                                -66.43702,
                                76.08668
                            ],
                            [
                                -66.37262,
                                76.16831
                            ],
                            [
                                -66.17056,
                                76.23415
                            ],
                            [
                                -65.72729,
                                76.27553
                            ],
                            [
                                -65.7243,
                                76.14464
                            ],
                            [
                                -65.8593,
                                76.1001
                            ],
                            [
                                -65.59194,
                                76.02454
                            ],
                            [
                                -65.31953,
                                76.03195
                            ],
                            [
                                -65.19283,
                                76.18265
                            ],
                            [
                                -64.64363,
                                76.16185
                            ],
                            [
                                -64.66548,
                                76.26002
                            ],
                            [
                                -64.41959,
                                76.23943
                            ],
                            [
                                -64.32759,
                                76.35697
                            ],
                            [
                                -64.1296,
                                76.31839
                            ],
                            [
                                -64.18117,
                                76.24893
                            ],
                            [
                                -64.09909,
                                76.14706
                            ],
                            [
                                -63.93757,
                                76.13037
                            ],
                            [
                                -63.67474,
                                76.17917
                            ],
                            [
                                -63.39816,
                                76.38061
                            ],
                            [
                                -62.80919,
                                76.3078
                            ],
                            [
                                -62.79605,
                                76.22125
                            ],
                            [
                                -62.49395,
                                76.26226
                            ],
                            [
                                -61.46052,
                                76.15918
                            ],
                            [
                                -61.3735,
                                76.17513
                            ],
                            [
                                -60.90515,
                                76.16473
                            ],
                            [
                                -60.77497,
                                76.02338
                            ],
                            [
                                -60.50742,
                                76.04363
                            ],
                            [
                                -60.10495,
                                76.03123
                            ],
                            [
                                -60.09859,
                                75.98602
                            ],
                            [
                                -59.88768,
                                75.92533
                            ],
                            [
                                -59.57148,
                                75.90844
                            ],
                            [
                                -59.52738,
                                75.85461
                            ],
                            [
                                -59.138,
                                75.87189
                            ],
                            [
                                -59.17241,
                                75.79422
                            ],
                            [
                                -58.79578,
                                75.71269
                            ],
                            [
                                -58.4114,
                                75.72782
                            ],
                            [
                                -58.55817,
                                75.66492
                            ],
                            [
                                -58.26193,
                                75.64462
                            ],
                            [
                                -58.39801,
                                75.57618
                            ],
                            [
                                -58.13904,
                                75.53393
                            ],
                            [
                                -58.19868,
                                75.43705
                            ],
                            [
                                -58.55584,
                                75.40116
                            ],
                            [
                                -58.67049,
                                75.34716
                            ],
                            [
                                -58.40294,
                                75.30078
                            ],
                            [
                                -58.20558,
                                75.20363
                            ],
                            [
                                -57.97712,
                                75.19746
                            ],
                            [
                                -57.96618,
                                75.13507
                            ],
                            [
                                -58.11477,
                                75.10347
                            ],
                            [
                                -57.82187,
                                75.01919
                            ],
                            [
                                -57.59017,
                                75.00508
                            ],
                            [
                                -57.37151,
                                74.95842
                            ],
                            [
                                -57.2929,
                                74.90665
                            ],
                            [
                                -57.00891,
                                74.91913
                            ],
                            [
                                -56.98667,
                                74.87362
                            ],
                            [
                                -56.78323,
                                74.83493
                            ],
                            [
                                -56.95633,
                                74.76075
                            ],
                            [
                                -56.96954,
                                74.69748
                            ],
                            [
                                -56.46572,
                                74.64866
                            ],
                            [
                                -56.58965,
                                74.59325
                            ],
                            [
                                -56.2312,
                                74.47879
                            ],
                            [
                                -56.48698,
                                74.45054
                            ],
                            [
                                -56.52934,
                                74.40121
                            ],
                            [
                                -56.15641,
                                74.41019
                            ],
                            [
                                -56.10406,
                                74.37102
                            ],
                            [
                                -56.6361,
                                74.33157
                            ],
                            [
                                -56.23754,
                                74.29584
                            ],
                            [
                                -56.5236,
                                74.25543
                            ],
                            [
                                -56.68429,
                                74.19719
                            ],
                            [
                                -56.91012,
                                74.18769
                            ],
                            [
                                -57.26736,
                                74.13114
                            ],
                            [
                                -57.11567,
                                74.10188
                            ],
                            [
                                -56.52507,
                                74.16142
                            ],
                            [
                                -56.07374,
                                74.27915
                            ],
                            [
                                -56.12708,
                                74.20158
                            ],
                            [
                                -56.25155,
                                74.17588
                            ],
                            [
                                -56.30759,
                                74.04921
                            ],
                            [
                                -55.97044,
                                74.03803
                            ],
                            [
                                -56.08398,
                                73.97447
                            ],
                            [
                                -55.6307,
                                73.89098
                            ],
                            [
                                -55.6777,
                                73.83929
                            ],
                            [
                                -55.87882,
                                73.80846
                            ],
                            [
                                -55.7513,
                                73.71467
                            ],
                            [
                                -55.8117,
                                73.68189
                            ],
                            [
                                -55.7482,
                                73.58283
                            ],
                            [
                                -55.57463,
                                73.55789
                            ],
                            [
                                -55.50472,
                                73.47823
                            ],
                            [
                                -55.20907,
                                73.41566
                            ],
                            [
                                -55.40935,
                                73.27778
                            ],
                            [
                                -55.26553,
                                73.1843
                            ],
                            [
                                -55.43536,
                                73.11169
                            ],
                            [
                                -55.62845,
                                73.11862
                            ],
                            [
                                -55.66102,
                                73.05483
                            ],
                            [
                                -55.42238,
                                73.06689
                            ],
                            [
                                -55.33321,
                                73.03957
                            ],
                            [
                                -55.0732,
                                73.03644
                            ],
                            [
                                -54.91717,
                                72.99783
                            ],
                            [
                                -54.73998,
                                72.99697
                            ],
                            [
                                -54.74762,
                                72.93434
                            ],
                            [
                                -54.523,
                                72.95532
                            ],
                            [
                                -54.5245,
                                72.89489
                            ],
                            [
                                -54.38378,
                                72.83806
                            ],
                            [
                                -54.60995,
                                72.80993
                            ],
                            [
                                -54.76154,
                                72.68402
                            ],
                            [
                                -54.76618,
                                72.51955
                            ],
                            [
                                -54.89264,
                                72.47574
                            ],
                            [
                                -55.43091,
                                72.52545
                            ],
                            [
                                -55.62742,
                                72.45205
                            ],
                            [
                                -55.49607,
                                72.39033
                            ],
                            [
                                -55.10024,
                                72.40177
                            ],
                            [
                                -54.89039,
                                72.37861
                            ],
                            [
                                -54.91336,
                                72.2474
                            ],
                            [
                                -55.57964,
                                72.02778
                            ],
                            [
                                -55.23372,
                                71.92849
                            ],
                            [
                                -55.40712,
                                71.81095
                            ],
                            [
                                -55.59113,
                                71.75057
                            ],
                            [
                                -55.73142,
                                71.75419
                            ],
                            [
                                -55.85474,
                                71.69512
                            ],
                            [
                                -55.66484,
                                71.66755
                            ],
                            [
                                -55.51059,
                                71.47236
                            ],
                            [
                                -55.3671,
                                71.41194
                            ],
                            [
                                -55.17394,
                                71.38995
                            ],
                            [
                                -54.9876,
                                71.43974
                            ],
                            [
                                -54.82838,
                                71.36045
                            ],
                            [
                                -54.40017,
                                71.37169
                            ],
                            [
                                -53.91051,
                                71.44548
                            ],
                            [
                                -53.87602,
                                71.577
                            ],
                            [
                                -54.07936,
                                71.6238
                            ],
                            [
                                -54.05341,
                                71.66003
                            ],
                            [
                                -53.74146,
                                71.64754
                            ],
                            [
                                -53.75326,
                                71.7253
                            ],
                            [
                                -53.484,
                                71.79642
                            ],
                            [
                                -53.39719,
                                71.85627
                            ],
                            [
                                -53.49209,
                                71.93476
                            ],
                            [
                                -53.53182,
                                72.05091
                            ],
                            [
                                -53.38851,
                                72.04406
                            ],
                            [
                                -53.39702,
                                71.94188
                            ],
                            [
                                -53.16419,
                                71.83072
                            ],
                            [
                                -53.03922,
                                71.84108
                            ],
                            [
                                -52.99139,
                                71.93618
                            ],
                            [
                                -52.79237,
                                72.01313
                            ],
                            [
                                -52.69743,
                                71.9946
                            ],
                            [
                                -52.88351,
                                71.91427
                            ],
                            [
                                -52.89138,
                                71.83524
                            ],
                            [
                                -53.26768,
                                71.71624
                            ],
                            [
                                -52.7069,
                                71.68306
                            ],
                            [
                                -52.59193,
                                71.63972
                            ],
                            [
                                -52.14937,
                                71.62059
                            ],
                            [
                                -51.87564,
                                71.67093
                            ],
                            [
                                -51.80324,
                                71.72962
                            ],
                            [
                                -51.63505,
                                71.71579
                            ],
                            [
                                -51.72236,
                                71.6361
                            ],
                            [
                                -51.84809,
                                71.5967
                            ],
                            [
                                -52.27937,
                                71.57818
                            ],
                            [
                                -52.68154,
                                71.52529
                            ],
                            [
                                -52.9282,
                                71.40736
                            ],
                            [
                                -52.6408,
                                71.3795
                            ],
                            [
                                -52.27704,
                                71.3961
                            ],
                            [
                                -51.98945,
                                71.46654
                            ],
                            [
                                -51.77536,
                                71.49905
                            ],
                            [
                                -51.53166,
                                71.50921
                            ],
                            [
                                -51.35425,
                                71.46428
                            ],
                            [
                                -51.96486,
                                71.42796
                            ],
                            [
                                -52.27492,
                                71.35674
                            ],
                            [
                                -52.24661,
                                71.27656
                            ],
                            [
                                -52.48752,
                                71.2165
                            ],
                            [
                                -52.47949,
                                71.14798
                            ],
                            [
                                -52.19259,
                                71.19393
                            ],
                            [
                                -51.76998,
                                71.3484
                            ],
                            [
                                -51.51586,
                                71.30936
                            ],
                            [
                                -51.54291,
                                71.24684
                            ],
                            [
                                -51.81145,
                                71.25659
                            ],
                            [
                                -52.05428,
                                71.20054
                            ],
                            [
                                -52.21551,
                                71.13428
                            ],
                            [
                                -52.04689,
                                71.0925
                            ],
                            [
                                -51.8219,
                                71.13192
                            ],
                            [
                                -51.66378,
                                71.10594
                            ],
                            [
                                -51.40572,
                                71.1098
                            ],
                            [
                                -51.47908,
                                71.05212
                            ],
                            [
                                -51.22354,
                                71.00781
                            ],
                            [
                                -50.95988,
                                71.02013
                            ],
                            [
                                -50.96973,
                                70.97732
                            ],
                            [
                                -51.1627,
                                70.96241
                            ],
                            [
                                -51.59569,
                                71.01777
                            ],
                            [
                                -51.82234,
                                71.07296
                            ],
                            [
                                -51.95625,
                                71.02489
                            ],
                            [
                                -51.6882,
                                70.97231
                            ],
                            [
                                -51.61904,
                                70.93218
                            ],
                            [
                                -51.2544,
                                70.89297
                            ],
                            [
                                -51.20268,
                                70.86408
                            ],
                            [
                                -50.95289,
                                70.8439
                            ],
                            [
                                -50.89734,
                                70.80094
                            ],
                            [
                                -50.65716,
                                70.74087
                            ],
                            [
                                -50.79803,
                                70.71191
                            ],
                            [
                                -51.05706,
                                70.78914
                            ],
                            [
                                -51.28202,
                                70.80847
                            ],
                            [
                                -51.21816,
                                70.69729
                            ],
                            [
                                -51.06535,
                                70.66061
                            ],
                            [
                                -50.91904,
                                70.68806
                            ],
                            [
                                -50.92771,
                                70.52026
                            ],
                            [
                                -51.05734,
                                70.43336
                            ],
                            [
                                -50.64571,
                                70.40263
                            ],
                            [
                                -50.56177,
                                70.36477
                            ],
                            [
                                -50.73028,
                                70.32448
                            ],
                            [
                                -51.05391,
                                70.35672
                            ],
                            [
                                -51.22306,
                                70.40398
                            ],
                            [
                                -51.61688,
                                70.4446
                            ],
                            [
                                -51.82885,
                                70.4863
                            ],
                            [
                                -52.14789,
                                70.60589
                            ],
                            [
                                -52.31224,
                                70.62834
                            ],
                            [
                                -52.65858,
                                70.74034
                            ],
                            [
                                -53.10251,
                                70.77739
                            ],
                            [
                                -53.32768,
                                70.75436
                            ],
                            [
                                -53.78417,
                                70.78703
                            ],
                            [
                                -54.01672,
                                70.83297
                            ],
                            [
                                -54.2487,
                                70.80878
                            ],
                            [
                                -54.58043,
                                70.71824
                            ],
                            [
                                -54.57861,
                                70.67292
                            ],
                            [
                                -54.18549,
                                70.50933
                            ],
                            [
                                -54.04762,
                                70.41714
                            ],
                            [
                                -53.85449,
                                70.38949
                            ],
                            [
                                -53.49628,
                                70.36685
                            ],
                            [
                                -53.02245,
                                70.31765
                            ],
                            [
                                -52.67398,
                                70.21932
                            ],
                            [
                                -52.39211,
                                70.07314
                            ],
                            [
                                -51.96728,
                                70.00996
                            ],
                            [
                                -51.63093,
                                70.00778
                            ],
                            [
                                -51.46672,
                                69.96852
                            ],
                            [
                                -51.29291,
                                70.05607
                            ],
                            [
                                -51.06122,
                                70.04038
                            ],
                            [
                                -51.1589,
                                69.96276
                            ],
                            [
                                -50.92912,
                                69.97489
                            ],
                            [
                                -50.51073,
                                70.03849
                            ],
                            [
                                -50.25859,
                                70.05117
                            ],
                            [
                                -50.28114,
                                69.98275
                            ],
                            [
                                -50.56484,
                                69.97445
                            ],
                            [
                                -50.62257,
                                69.92922
                            ],
                            [
                                -50.40736,
                                69.90234
                            ],
                            [
                                -50.31086,
                                69.86394
                            ],
                            [
                                -50.32994,
                                69.75362
                            ],
                            [
                                -50.62334,
                                69.78163
                            ],
                            [
                                -50.82901,
                                69.7092
                            ],
                            [
                                -50.87379,
                                69.62674
                            ],
                            [
                                -50.81099,
                                69.55992
                            ],
                            [
                                -50.8826,
                                69.46518
                            ],
                            [
                                -50.89754,
                                69.35859
                            ],
                            [
                                -51.01368,
                                69.32443
                            ],
                            [
                                -51.09926,
                                69.22339
                            ],
                            [
                                -50.917,
                                69.16958
                            ],
                            [
                                -50.7259,
                                69.21715
                            ],
                            [
                                -50.46262,
                                69.19124
                            ],
                            [
                                -50.25168,
                                69.20562
                            ],
                            [
                                -50.1875,
                                69.2489
                            ],
                            [
                                -50.00164,
                                69.21094
                            ],
                            [
                                -49.99518,
                                69.15656
                            ],
                            [
                                -50.2414,
                                69.13484
                            ],
                            [
                                -50.69066,
                                69.12435
                            ],
                            [
                                -50.81098,
                                69.0837
                            ],
                            [
                                -51.0844,
                                69.13752
                            ],
                            [
                                -51.09619,
                                68.98394
                            ],
                            [
                                -51.20806,
                                68.84683
                            ],
                            [
                                -51.14085,
                                68.72767
                            ],
                            [
                                -50.873,
                                68.7986
                            ],
                            [
                                -50.81343,
                                68.76627
                            ],
                            [
                                -50.99549,
                                68.71968
                            ],
                            [
                                -50.86865,
                                68.62611
                            ],
                            [
                                -51.03102,
                                68.57675
                            ],
                            [
                                -51.24887,
                                68.566
                            ],
                            [
                                -51.84357,
                                68.50382
                            ],
                            [
                                -51.95958,
                                68.52245
                            ],
                            [
                                -52.00405,
                                68.61223
                            ],
                            [
                                -52.25006,
                                68.64597
                            ],
                            [
                                -52.31487,
                                68.71111
                            ],
                            [
                                -52.58948,
                                68.7062
                            ],
                            [
                                -52.80313,
                                68.66344
                            ],
                            [
                                -52.96762,
                                68.60448
                            ],
                            [
                                -52.50739,
                                68.63687
                            ],
                            [
                                -52.34046,
                                68.57586
                            ],
                            [
                                -52.64832,
                                68.5231
                            ],
                            [
                                -52.46614,
                                68.47061
                            ],
                            [
                                -52.65066,
                                68.44889
                            ],
                            [
                                -53.11242,
                                68.31734
                            ],
                            [
                                -53.24653,
                                68.3618
                            ],
                            [
                                -53.34207,
                                68.29871
                            ],
                            [
                                -52.9444,
                                68.27663
                            ],
                            [
                                -52.72514,
                                68.22054
                            ],
                            [
                                -52.59806,
                                68.2888
                            ],
                            [
                                -52.46408,
                                68.17046
                            ],
                            [
                                -52.17332,
                                68.19534
                            ],
                            [
                                -52.06126,
                                68.23241
                            ],
                            [
                                -51.83296,
                                68.23433
                            ],
                            [
                                -51.62783,
                                68.27095
                            ],
                            [
                                -51.36498,
                                68.2702
                            ],
                            [
                                -51.41283,
                                68.17888
                            ],
                            [
                                -51.13297,
                                68.09434
                            ],
                            [
                                -51.04633,
                                68.09478
                            ],
                            [
                                -50.84037,
                                68.02337
                            ],
                            [
                                -50.71336,
                                68.01731
                            ],
                            [
                                -50.45669,
                                67.94615
                            ],
                            [
                                -50.63264,
                                67.89844
                            ],
                            [
                                -51.17245,
                                68.05663
                            ],
                            [
                                -51.491,
                                68.03611
                            ],
                            [
                                -51.85962,
                                68.03408
                            ],
                            [
                                -52.17842,
                                68.07808
                            ],
                            [
                                -52.57989,
                                68.19223
                            ],
                            [
                                -52.67791,
                                68.09845
                            ],
                            [
                                -52.9516,
                                68.14101
                            ],
                            [
                                -53.1012,
                                68.19173
                            ],
                            [
                                -53.45913,
                                68.16441
                            ],
                            [
                                -53.17389,
                                68.1017
                            ],
                            [
                                -53.30856,
                                67.88021
                            ],
                            [
                                -53.46961,
                                67.88663
                            ],
                            [
                                -53.67086,
                                67.78195
                            ],
                            [
                                -53.55868,
                                67.71132
                            ],
                            [
                                -53.66219,
                                67.61319
                            ],
                            [
                                -53.77447,
                                67.5797
                            ],
                            [
                                -53.66707,
                                67.48097
                            ],
                            [
                                -53.44036,
                                67.54288
                            ],
                            [
                                -53.19805,
                                67.6421
                            ],
                            [
                                -53.00219,
                                67.75323
                            ],
                            [
                                -52.60908,
                                67.78481
                            ],
                            [
                                -52.23348,
                                67.8941
                            ],
                            [
                                -52.07321,
                                67.89035
                            ],
                            [
                                -51.79328,
                                67.94377
                            ],
                            [
                                -51.60976,
                                67.9484
                            ],
                            [
                                -51.38707,
                                67.91347
                            ],
                            [
                                -51.06956,
                                67.96596
                            ],
                            [
                                -51.02415,
                                67.92668
                            ],
                            [
                                -51.34924,
                                67.85981
                            ],
                            [
                                -51.20198,
                                67.80495
                            ],
                            [
                                -51.18639,
                                67.75121
                            ],
                            [
                                -50.9465,
                                67.7953
                            ],
                            [
                                -50.81071,
                                67.76226
                            ],
                            [
                                -51.25111,
                                67.71118
                            ],
                            [
                                -51.43549,
                                67.65569
                            ],
                            [
                                -51.76641,
                                67.63175
                            ],
                            [
                                -52.04717,
                                67.70136
                            ],
                            [
                                -52.54712,
                                67.76748
                            ],
                            [
                                -52.75076,
                                67.71957
                            ],
                            [
                                -53.03906,
                                67.70525
                            ],
                            [
                                -53.11914,
                                67.62382
                            ],
                            [
                                -53.4408,
                                67.51122
                            ],
                            [
                                -53.70194,
                                67.45226
                            ],
                            [
                                -53.86273,
                                67.33709
                            ],
                            [
                                -53.88005,
                                67.22047
                            ],
                            [
                                -53.66241,
                                67.20792
                            ],
                            [
                                -53.90473,
                                67.12552
                            ],
                            [
                                -53.81047,
                                67.0771
                            ],
                            [
                                -53.78316,
                                66.96468
                            ],
                            [
                                -53.66645,
                                66.92229
                            ],
                            [
                                -53.4347,
                                66.91183
                            ],
                            [
                                -53.21752,
                                66.92956
                            ],
                            [
                                -52.79836,
                                66.89061
                            ],
                            [
                                -52.38297,
                                66.91179
                            ],
                            [
                                -52.43286,
                                66.8495
                            ],
                            [
                                -52.58911,
                                66.87592
                            ],
                            [
                                -52.97974,
                                66.85697
                            ],
                            [
                                -52.80733,
                                66.75699
                            ],
                            [
                                -53.01377,
                                66.75146
                            ],
                            [
                                -52.99245,
                                66.70498
                            ],
                            [
                                -52.76297,
                                66.74561
                            ],
                            [
                                -52.61525,
                                66.7177
                            ],
                            [
                                -53.00181,
                                66.67734
                            ],
                            [
                                -53.28161,
                                66.70347
                            ],
                            [
                                -53.46578,
                                66.64866
                            ],
                            [
                                -53.43282,
                                66.56801
                            ],
                            [
                                -53.12139,
                                66.53908
                            ],
                            [
                                -53.15499,
                                66.51046
                            ],
                            [
                                -53.40252,
                                66.53762
                            ],
                            [
                                -53.63758,
                                66.50067
                            ],
                            [
                                -53.69062,
                                66.34449
                            ],
                            [
                                -53.58809,
                                66.20429
                            ],
                            [
                                -53.66186,
                                66.10091
                            ],
                            [
                                -53.33441,
                                66.10029
                            ],
                            [
                                -53.01393,
                                66.18757
                            ],
                            [
                                -52.80413,
                                66.26597
                            ],
                            [
                                -52.71777,
                                66.34151
                            ],
                            [
                                -52.41328,
                                66.44952
                            ],
                            [
                                -52.14401,
                                66.50991
                            ],
                            [
                                -52.03592,
                                66.57816
                            ],
                            [
                                -51.98177,
                                66.65369
                            ],
                            [
                                -51.84545,
                                66.67684
                            ],
                            [
                                -51.52698,
                                66.8096
                            ],
                            [
                                -51.26662,
                                66.84195
                            ],
                            [
                                -51.51983,
                                66.73332
                            ],
                            [
                                -51.91294,
                                66.62607
                            ],
                            [
                                -52.08262,
                                66.48621
                            ],
                            [
                                -52.41341,
                                66.41757
                            ],
                            [
                                -52.69765,
                                66.32293
                            ],
                            [
                                -52.74888,
                                66.25505
                            ],
                            [
                                -53.00085,
                                66.16237
                            ],
                            [
                                -53.34225,
                                66.08302
                            ],
                            [
                                -53.46777,
                                66.03544
                            ],
                            [
                                -53.41724,
                                65.92386
                            ],
                            [
                                -53.24927,
                                65.92102
                            ],
                            [
                                -53.18806,
                                65.84008
                            ],
                            [
                                -53.05713,
                                65.8381
                            ],
                            [
                                -53.14475,
                                65.7208
                            ],
                            [
                                -53.07258,
                                65.65326
                            ],
                            [
                                -52.79257,
                                65.66722
                            ],
                            [
                                -52.77153,
                                65.51493
                            ],
                            [
                                -52.60563,
                                65.47689
                            ],
                            [
                                -52.5163,
                                65.40186
                            ],
                            [
                                -52.54193,
                                65.28398
                            ],
                            [
                                -52.4213,
                                65.25948
                            ],
                            [
                                -52.17053,
                                65.30548
                            ],
                            [
                                -52.15882,
                                65.11593
                            ],
                            [
                                -52.26047,
                                65.06389
                            ],
                            [
                                -52.14986,
                                64.99119
                            ],
                            [
                                -52.225,
                                64.88606
                            ],
                            [
                                -52.12354,
                                64.84174
                            ],
                            [
                                -51.97684,
                                64.83951
                            ],
                            [
                                -51.69895,
                                64.92004
                            ],
                            [
                                -51.64949,
                                64.87961
                            ],
                            [
                                -51.89092,
                                64.81292
                            ],
                            [
                                -51.99959,
                                64.72524
                            ],
                            [
                                -52.11903,
                                64.72774
                            ],
                            [
                                -52.15653,
                                64.65061
                            ],
                            [
                                -52.0643,
                                64.57602
                            ],
                            [
                                -52.10941,
                                64.50145
                            ],
                            [
                                -52.12277,
                                64.36384
                            ],
                            [
                                -52.06123,
                                64.16795
                            ],
                            [
                                -51.7938,
                                64.22087
                            ],
                            [
                                -51.6875,
                                64.29176
                            ],
                            [
                                -51.67031,
                                64.35834
                            ],
                            [
                                -51.48702,
                                64.47187
                            ],
                            [
                                -51.44219,
                                64.58702
                            ],
                            [
                                -51.34801,
                                64.62454
                            ],
                            [
                                -51.29973,
                                64.7103
                            ],
                            [
                                -51.19843,
                                64.7638
                            ],
                            [
                                -51.09375,
                                64.7212
                            ],
                            [
                                -51.19327,
                                64.67548
                            ],
                            [
                                -51.17302,
                                64.60819
                            ],
                            [
                                -50.89248,
                                64.66899
                            ],
                            [
                                -50.83375,
                                64.72076
                            ],
                            [
                                -50.67048,
                                64.76414
                            ],
                            [
                                -50.55955,
                                64.73974
                            ],
                            [
                                -50.31069,
                                64.72719
                            ],
                            [
                                -50.1751,
                                64.67554
                            ],
                            [
                                -50.10105,
                                64.51613
                            ],
                            [
                                -49.89481,
                                64.44543
                            ],
                            [
                                -49.82072,
                                64.35153
                            ],
                            [
                                -50.18366,
                                64.46978
                            ],
                            [
                                -50.32434,
                                64.65555
                            ],
                            [
                                -50.49607,
                                64.69215
                            ],
                            [
                                -50.68252,
                                64.67542
                            ],
                            [
                                -50.92632,
                                64.58871
                            ],
                            [
                                -50.77675,
                                64.5801
                            ],
                            [
                                -50.60832,
                                64.4414
                            ],
                            [
                                -50.91725,
                                64.40446
                            ],
                            [
                                -51.05193,
                                64.24167
                            ],
                            [
                                -51.25308,
                                64.17002
                            ],
                            [
                                -51.40272,
                                64.21819
                            ],
                            [
                                -51.7261,
                                64.19127
                            ],
                            [
                                -51.57185,
                                64.08369
                            ],
                            [
                                -51.45594,
                                64.07456
                            ],
                            [
                                -50.81093,
                                64.17126
                            ],
                            [
                                -50.85605,
                                64.09981
                            ],
                            [
                                -50.96531,
                                64.10604
                            ],
                            [
                                -51.24473,
                                64.07691
                            ],
                            [
                                -51.42417,
                                64.03673
                            ],
                            [
                                -51.55903,
                                64.04449
                            ],
                            [
                                -51.61813,
                                63.98489
                            ],
                            [
                                -51.36817,
                                63.88999
                            ],
                            [
                                -51.45878,
                                63.85032
                            ],
                            [
                                -51.4027,
                                63.77822
                            ],
                            [
                                -51.55408,
                                63.74294
                            ],
                            [
                                -51.55939,
                                63.70706
                            ],
                            [
                                -51.41944,
                                63.54696
                            ],
                            [
                                -51.11767,
                                63.50101
                            ],
                            [
                                -51.18329,
                                63.4625
                            ],
                            [
                                -51.11655,
                                63.35585
                            ],
                            [
                                -51.02274,
                                63.13878
                            ],
                            [
                                -50.72462,
                                63.19861
                            ],
                            [
                                -50.56108,
                                63.21588
                            ],
                            [
                                -50.42821,
                                63.17337
                            ],
                            [
                                -50.41308,
                                63.13274
                            ],
                            [
                                -50.61777,
                                63.07831
                            ],
                            [
                                -50.53631,
                                62.9637
                            ],
                            [
                                -50.39849,
                                62.93032
                            ],
                            [
                                -50.37948,
                                62.86725
                            ],
                            [
                                -50.26297,
                                62.81187
                            ],
                            [
                                -50.3168,
                                62.73389
                            ],
                            [
                                -50.2533,
                                62.69111
                            ],
                            [
                                -50.14727,
                                62.76509
                            ],
                            [
                                -50.0666,
                                62.73476
                            ],
                            [
                                -50.22174,
                                62.65789
                            ],
                            [
                                -50.31246,
                                62.49271
                            ],
                            [
                                -50.19745,
                                62.39648
                            ],
                            [
                                -50.05217,
                                62.35744
                            ],
                            [
                                -49.97867,
                                62.29556
                            ],
                            [
                                -49.79321,
                                62.25039
                            ],
                            [
                                -49.52882,
                                62.24594
                            ],
                            [
                                -49.59863,
                                62.17059
                            ],
                            [
                                -49.57622,
                                62.04827
                            ],
                            [
                                -49.38453,
                                61.97326
                            ],
                            [
                                -49.12695,
                                62.03825
                            ],
                            [
                                -49.08655,
                                62.16434
                            ],
                            [
                                -48.90722,
                                62.04428
                            ],
                            [
                                -49.22557,
                                61.97247
                            ],
                            [
                                -49.36651,
                                61.92634
                            ],
                            [
                                -49.42316,
                                61.83033
                            ],
                            [
                                -49.28202,
                                61.71724
                            ],
                            [
                                -49.1709,
                                61.77274
                            ],
                            [
                                -49.18889,
                                61.82725
                            ],
                            [
                                -48.89669,
                                61.97994
                            ],
                            [
                                -48.88072,
                                61.94612
                            ],
                            [
                                -49.10929,
                                61.81867
                            ],
                            [
                                -49.14022,
                                61.70995
                            ],
                            [
                                -49.03568,
                                61.61063
                            ],
                            [
                                -48.93301,
                                61.59853
                            ],
                            [
                                -48.68211,
                                61.62772
                            ],
                            [
                                -48.67112,
                                61.60245
                            ],
                            [
                                -48.94035,
                                61.57249
                            ],
                            [
                                -49.20323,
                                61.59977
                            ],
                            [
                                -49.23612,
                                61.53173
                            ],
                            [
                                -49.10927,
                                61.48388
                            ],
                            [
                                -48.88122,
                                61.47383
                            ],
                            [
                                -48.73356,
                                61.4921
                            ],
                            [
                                -48.38998,
                                61.5788
                            ],
                            [
                                -48.25399,
                                61.52153
                            ],
                            [
                                -48.55331,
                                61.50491
                            ],
                            [
                                -48.74743,
                                61.4502
                            ],
                            [
                                -48.96156,
                                61.4302
                            ],
                            [
                                -48.91063,
                                61.37833
                            ],
                            [
                                -48.78842,
                                61.37356
                            ],
                            [
                                -48.70602,
                                61.40397
                            ],
                            [
                                -48.46267,
                                61.36329
                            ],
                            [
                                -48.57172,
                                61.2803
                            ],
                            [
                                -48.53887,
                                61.188
                            ],
                            [
                                -48.4402,
                                61.173
                            ],
                            [
                                -48.21204,
                                61.19206
                            ],
                            [
                                -48.09279,
                                61.07737
                            ],
                            [
                                -48.01705,
                                61.09622
                            ],
                            [
                                -47.86547,
                                61.07112
                            ],
                            [
                                -47.7816,
                                61.00251
                            ],
                            [
                                -47.78808,
                                60.95806
                            ],
                            [
                                -47.91844,
                                60.93374
                            ],
                            [
                                -47.9415,
                                60.86472
                            ],
                            [
                                -47.80817,
                                60.81491
                            ],
                            [
                                -47.58269,
                                60.81311
                            ],
                            [
                                -47.34873,
                                60.84578
                            ],
                            [
                                -47.34108,
                                60.93321
                            ],
                            [
                                -47.21757,
                                60.89437
                            ],
                            [
                                -47.07026,
                                60.92212
                            ],
                            [
                                -46.72438,
                                60.92545
                            ],
                            [
                                -46.56924,
                                60.89912
                            ],
                            [
                                -46.57284,
                                60.99193
                            ],
                            [
                                -46.44213,
                                60.98868
                            ],
                            [
                                -46.3388,
                                61.06904
                            ],
                            [
                                -46.25773,
                                61.03573
                            ],
                            [
                                -46.24462,
                                60.96535
                            ],
                            [
                                -45.8181,
                                61.1217
                            ],
                            [
                                -45.86472,
                                61.17433
                            ],
                            [
                                -45.65328,
                                61.15372
                            ],
                            [
                                -45.76537,
                                61.09265
                            ],
                            [
                                -45.70448,
                                61.06036
                            ],
                            [
                                -45.90423,
                                61.02452
                            ],
                            [
                                -46.10429,
                                60.96885
                            ],
                            [
                                -46.02158,
                                60.89527
                            ],
                            [
                                -45.88329,
                                60.94562
                            ],
                            [
                                -45.76863,
                                60.95124
                            ],
                            [
                                -45.61009,
                                61.00645
                            ],
                            [
                                -45.43321,
                                61.13428
                            ],
                            [
                                -45.3953,
                                61.08868
                            ],
                            [
                                -45.48869,
                                60.9815
                            ],
                            [
                                -45.63473,
                                60.94298
                            ],
                            [
                                -45.89904,
                                60.91646
                            ],
                            [
                                -46.19957,
                                60.81298
                            ],
                            [
                                -46.22788,
                                60.7635
                            ],
                            [
                                -46.17329,
                                60.71335
                            ],
                            [
                                -46.00539,
                                60.72465
                            ],
                            [
                                -45.96492,
                                60.80875
                            ],
                            [
                                -45.81346,
                                60.73985
                            ],
                            [
                                -45.7285,
                                60.73198
                            ],
                            [
                                -45.78444,
                                60.63196
                            ],
                            [
                                -45.9952,
                                60.56703
                            ],
                            [
                                -45.80064,
                                60.55268
                            ],
                            [
                                -45.74293,
                                60.57415
                            ],
                            [
                                -45.56086,
                                60.47484
                            ],
                            [
                                -45.45832,
                                60.62381
                            ],
                            [
                                -45.36556,
                                60.63414
                            ],
                            [
                                -45.43678,
                                60.48746
                            ],
                            [
                                -45.27443,
                                60.49447
                            ],
                            [
                                -45.22792,
                                60.42578
                            ],
                            [
                                -44.95925,
                                60.4697
                            ],
                            [
                                -44.88747,
                                60.43674
                            ],
                            [
                                -44.9659,
                                60.3116
                            ],
                            [
                                -45.09207,
                                60.27441
                            ],
                            [
                                -45.20868,
                                60.18506
                            ],
                            [
                                -45.14812,
                                60.12899
                            ],
                            [
                                -44.73578,
                                59.98851
                            ],
                            [
                                -44.61322,
                                59.97481
                            ],
                            [
                                -44.52098,
                                60.03747
                            ],
                            [
                                -44.45452,
                                60.14747
                            ],
                            [
                                -44.29127,
                                60.14446
                            ],
                            [
                                -44.26162,
                                60.19078
                            ],
                            [
                                -44.06777,
                                60.18159
                            ],
                            [
                                -43.82012,
                                60.1471
                            ],
                            [
                                -43.63485,
                                60.15026
                            ],
                            [
                                -43.25598,
                                60.07683
                            ],
                            [
                                -43.15312,
                                60.11873
                            ],
                            [
                                -43.23808,
                                60.20449
                            ],
                            [
                                -43.11581,
                                60.23099
                            ],
                            [
                                -43.09417,
                                60.30265
                            ],
                            [
                                -43.45078,
                                60.37122
                            ],
                            [
                                -43.09172,
                                60.49248
                            ],
                            [
                                -42.83502,
                                60.59548
                            ],
                            [
                                -42.80931,
                                60.67672
                            ],
                            [
                                -42.74949,
                                60.72148
                            ],
                            [
                                -42.91478,
                                60.78225
                            ],
                            [
                                -42.787,
                                60.81955
                            ],
                            [
                                -43.05562,
                                60.87801
                            ],
                            [
                                -42.85309,
                                60.91116
                            ],
                            [
                                -42.7382,
                                61.06077
                            ],
                            [
                                -42.66987,
                                61.0937
                            ],
                            [
                                -42.79161,
                                61.14883
                            ],
                            [
                                -42.75996,
                                61.17962
                            ],
                            [
                                -42.60334,
                                61.18372
                            ],
                            [
                                -42.67783,
                                61.25822
                            ],
                            [
                                -42.50371,
                                61.34747
                            ],
                            [
                                -42.43456,
                                61.45267
                            ],
                            [
                                -42.52734,
                                61.46075
                            ],
                            [
                                -42.58571,
                                61.51799
                            ],
                            [
                                -42.89395,
                                61.52603
                            ],
                            [
                                -43.06155,
                                61.58282
                            ],
                            [
                                -42.61375,
                                61.53974
                            ],
                            [
                                -42.45117,
                                61.54295
                            ],
                            [
                                -42.30656,
                                61.63636
                            ],
                            [
                                -42.50882,
                                61.72352
                            ],
                            [
                                -42.27867,
                                61.77435
                            ],
                            [
                                -42.19874,
                                61.8493
                            ],
                            [
                                -42.22181,
                                61.90268
                            ],
                            [
                                -42.11057,
                                62.00114
                            ],
                            [
                                -42.41186,
                                62.01177
                            ],
                            [
                                -42.3851,
                                62.08097
                            ],
                            [
                                -42.25104,
                                62.2275
                            ],
                            [
                                -42.27769,
                                62.29722
                            ],
                            [
                                -42.4074,
                                62.32772
                            ],
                            [
                                -42.62415,
                                62.32034
                            ],
                            [
                                -42.70722,
                                62.40083
                            ],
                            [
                                -42.92403,
                                62.4592
                            ],
                            [
                                -42.89651,
                                62.49052
                            ],
                            [
                                -42.71188,
                                62.48965
                            ],
                            [
                                -42.67849,
                                62.45355
                            ],
                            [
                                -42.32652,
                                62.35141
                            ],
                            [
                                -42.25525,
                                62.42261
                            ],
                            [
                                -42.37522,
                                62.55542
                            ],
                            [
                                -42.61315,
                                62.62414
                            ],
                            [
                                -42.99215,
                                62.67932
                            ],
                            [
                                -43.00603,
                                62.72131
                            ],
                            [
                                -42.71738,
                                62.67818
                            ],
                            [
                                -42.58204,
                                62.68963
                            ],
                            [
                                -42.42541,
                                62.79329
                            ],
                            [
                                -42.44837,
                                62.90479
                            ],
                            [
                                -42.37913,
                                62.91379
                            ],
                            [
                                -42.34853,
                                62.80364
                            ],
                            [
                                -42.22609,
                                62.81208
                            ],
                            [
                                -42.05151,
                                62.77717
                            ],
                            [
                                -41.99127,
                                62.83781
                            ],
                            [
                                -41.83432,
                                62.80912
                            ],
                            [
                                -41.60499,
                                62.93458
                            ],
                            [
                                -41.6151,
                                62.9817
                            ],
                            [
                                -42.02465,
                                63.04989
                            ],
                            [
                                -42.15012,
                                63.09271
                            ],
                            [
                                -42.06453,
                                63.12882
                            ],
                            [
                                -41.97637,
                                63.06173
                            ],
                            [
                                -41.75139,
                                63.02807
                            ],
                            [
                                -41.55014,
                                63.03907
                            ],
                            [
                                -41.56408,
                                63.08844
                            ],
                            [
                                -41.42386,
                                63.11799
                            ],
                            [
                                -41.2431,
                                63.10198
                            ],
                            [
                                -41.2245,
                                63.15423
                            ],
                            [
                                -41.49089,
                                63.21008
                            ],
                            [
                                -41.62072,
                                63.2935
                            ],
                            [
                                -41.77057,
                                63.33274
                            ],
                            [
                                -41.93288,
                                63.46975
                            ],
                            [
                                -41.69333,
                                63.53412
                            ],
                            [
                                -41.56257,
                                63.42877
                            ],
                            [
                                -41.4319,
                                63.41997
                            ],
                            [
                                -41.3965,
                                63.3654
                            ],
                            [
                                -41.17838,
                                63.38294
                            ],
                            [
                                -41.06493,
                                63.49346
                            ],
                            [
                                -40.77689,
                                63.53463
                            ],
                            [
                                -40.87237,
                                63.57833
                            ],
                            [
                                -40.68552,
                                63.61639
                            ],
                            [
                                -41.10768,
                                63.68598
                            ],
                            [
                                -41.21143,
                                63.67778
                            ],
                            [
                                -41.46437,
                                63.75897
                            ],
                            [
                                -41.5713,
                                63.74009
                            ],
                            [
                                -41.68541,
                                63.76536
                            ],
                            [
                                -41.65737,
                                63.8138
                            ],
                            [
                                -41.38998,
                                63.7803
                            ],
                            [
                                -40.88397,
                                63.67984
                            ],
                            [
                                -40.71465,
                                63.66613
                            ],
                            [
                                -40.54038,
                                63.68168
                            ],
                            [
                                -40.59488,
                                63.74306
                            ],
                            [
                                -40.60164,
                                63.87254
                            ],
                            [
                                -40.71988,
                                63.96812
                            ],
                            [
                                -40.55321,
                                64.05223
                            ],
                            [
                                -40.59767,
                                64.11517
                            ],
                            [
                                -40.77608,
                                64.16193
                            ],
                            [
                                -41.06245,
                                64.13632
                            ],
                            [
                                -41.21191,
                                64.16119
                            ],
                            [
                                -41.4076,
                                64.16063
                            ],
                            [
                                -41.53942,
                                64.27802
                            ],
                            [
                                -41.515,
                                64.31182
                            ],
                            [
                                -41.30737,
                                64.32442
                            ],
                            [
                                -41.07493,
                                64.30138
                            ],
                            [
                                -40.84582,
                                64.32114
                            ],
                            [
                                -40.86555,
                                64.35952
                            ],
                            [
                                -40.61893,
                                64.38656
                            ],
                            [
                                -40.56111,
                                64.32959
                            ],
                            [
                                -40.34933,
                                64.35058
                            ],
                            [
                                -40.37243,
                                64.40199
                            ],
                            [
                                -40.62167,
                                64.455
                            ],
                            [
                                -40.55716,
                                64.49432
                            ],
                            [
                                -40.58558,
                                64.6649
                            ],
                            [
                                -40.67854,
                                64.71816
                            ],
                            [
                                -40.87783,
                                64.7844
                            ],
                            [
                                -40.88553,
                                64.85539
                            ],
                            [
                                -41.07995,
                                64.88194
                            ],
                            [
                                -41.17252,
                                64.95208
                            ],
                            [
                                -41.13039,
                                64.99161
                            ],
                            [
                                -40.96955,
                                64.96718
                            ],
                            [
                                -41.05835,
                                65.07287
                            ],
                            [
                                -41.01219,
                                65.09938
                            ],
                            [
                                -40.81662,
                                65.06746
                            ],
                            [
                                -40.55276,
                                65.12415
                            ],
                            [
                                -40.4167,
                                65.05484
                            ],
                            [
                                -40.20774,
                                65.04706
                            ],
                            [
                                -39.85095,
                                65.16561
                            ],
                            [
                                -39.79334,
                                65.42702
                            ],
                            [
                                -40.089,
                                65.48597
                            ],
                            [
                                -39.62938,
                                65.56202
                            ],
                            [
                                -39.6486,
                                65.61856
                            ],
                            [
                                -39.56766,
                                65.67307
                            ],
                            [
                                -39.41008,
                                65.59389
                            ],
                            [
                                -39.38154,
                                65.53918
                            ],
                            [
                                -39.24503,
                                65.53928
                            ],
                            [
                                -39.20331,
                                65.67234
                            ],
                            [
                                -39.01663,
                                65.61989
                            ],
                            [
                                -38.98842,
                                65.5698
                            ],
                            [
                                -38.52973,
                                65.56908
                            ],
                            [
                                -38.3927,
                                65.59234
                            ],
                            [
                                -38.33013,
                                65.64975
                            ],
                            [
                                -38.14671,
                                65.64598
                            ],
                            [
                                -38.04277,
                                65.79101
                            ],
                            [
                                -38.18938,
                                65.82391
                            ],
                            [
                                -38.10454,
                                65.91918
                            ],
                            [
                                -37.9408,
                                65.94796
                            ],
                            [
                                -37.923,
                                66.1254
                            ],
                            [
                                -37.8547,
                                66.17234
                            ],
                            [
                                -37.97969,
                                66.23333
                            ],
                            [
                                -37.67932,
                                66.25308
                            ],
                            [
                                -37.77533,
                                66.29496
                            ],
                            [
                                -38.05889,
                                66.32607
                            ],
                            [
                                -38.00261,
                                66.37429
                            ],
                            [
                                -37.84565,
                                66.36628
                            ],
                            [
                                -37.60927,
                                66.31192
                            ],
                            [
                                -37.36733,
                                66.308
                            ],
                            [
                                -37.17857,
                                66.33981
                            ],
                            [
                                -37.53887,
                                66.16009
                            ],
                            [
                                -37.52915,
                                66.11701
                            ],
                            [
                                -37.64592,
                                66.05995
                            ],
                            [
                                -37.76804,
                                66.04364
                            ],
                            [
                                -37.76452,
                                65.97074
                            ],
                            [
                                -37.5342,
                                65.89667
                            ],
                            [
                                -37.18346,
                                65.75564
                            ],
                            [
                                -37.08583,
                                65.8043
                            ],
                            [
                                -36.83318,
                                65.87094
                            ],
                            [
                                -36.80669,
                                65.90751
                            ],
                            [
                                -36.51467,
                                65.97635
                            ],
                            [
                                -36.39437,
                                66.03127
                            ],
                            [
                                -36.18748,
                                65.92616
                            ],
                            [
                                -35.91903,
                                66.01052
                            ],
                            [
                                -35.93077,
                                66.04928
                            ],
                            [
                                -35.59913,
                                66.16757
                            ],
                            [
                                -35.55734,
                                66.25153
                            ],
                            [
                                -35.46528,
                                66.29514
                            ],
                            [
                                -35.17061,
                                66.24514
                            ],
                            [
                                -35.16558,
                                66.3324
                            ],
                            [
                                -34.96354,
                                66.28948
                            ],
                            [
                                -34.69191,
                                66.3698
                            ],
                            [
                                -34.56551,
                                66.49225
                            ],
                            [
                                -34.44425,
                                66.5431
                            ],
                            [
                                -34.54864,
                                66.58353
                            ],
                            [
                                -34.15989,
                                66.65469
                            ],
                            [
                                -34.1102,
                                66.74263
                            ],
                            [
                                -34.01271,
                                66.78329
                            ],
                            [
                                -34.05928,
                                66.89979
                            ],
                            [
                                -33.86977,
                                66.98646
                            ],
                            [
                                -33.75508,
                                67.01311
                            ],
                            [
                                -33.70164,
                                67.09992
                            ],
                            [
                                -33.60162,
                                67.08196
                            ],
                            [
                                -33.56212,
                                67.20015
                            ],
                            [
                                -33.43192,
                                67.26113
                            ],
                            [
                                -33.46288,
                                67.31174
                            ],
                            [
                                -33.635,
                                67.36841
                            ],
                            [
                                -33.34518,
                                67.4118
                            ],
                            [
                                -33.31696,
                                67.47899
                            ],
                            [
                                -33.37889,
                                67.56282
                            ],
                            [
                                -33.23012,
                                67.55426
                            ],
                            [
                                -33.15443,
                                67.65077
                            ],
                            [
                                -32.89207,
                                67.70121
                            ],
                            [
                                -32.71679,
                                67.76898
                            ],
                            [
                                -32.71073,
                                67.80943
                            ],
                            [
                                -32.55132,
                                67.82965
                            ],
                            [
                                -32.33844,
                                67.89367
                            ],
                            [
                                -32.2597,
                                67.86285
                            ],
                            [
                                -32.10606,
                                67.97788
                            ],
                            [
                                -32.15688,
                                68.04254
                            ],
                            [
                                -32.02536,
                                68.08556
                            ],
                            [
                                -32.25851,
                                68.35652
                            ],
                            [
                                -32.48157,
                                68.38688
                            ],
                            [
                                -32.63181,
                                68.49385
                            ],
                            [
                                -32.77159,
                                68.52345
                            ],
                            [
                                -32.72706,
                                68.57409
                            ],
                            [
                                -32.58053,
                                68.5679
                            ],
                            [
                                -32.46936,
                                68.60363
                            ],
                            [
                                -32.32561,
                                68.4277
                            ],
                            [
                                -32.12313,
                                68.37468
                            ],
                            [
                                -32.08406,
                                68.31235
                            ],
                            [
                                -31.97804,
                                68.27418
                            ],
                            [
                                -31.56617,
                                68.27547
                            ],
                            [
                                -31.68693,
                                68.19282
                            ],
                            [
                                -31.71504,
                                68.1158
                            ],
                            [
                                -31.57804,
                                68.08266
                            ],
                            [
                                -31.43614,
                                68.12461
                            ],
                            [
                                -31.11821,
                                68.06547
                            ],
                            [
                                -30.62293,
                                68.11058
                            ],
                            [
                                -30.46419,
                                68.09066
                            ],
                            [
                                -30.38195,
                                68.1281
                            ],
                            [
                                -30.14639,
                                68.1309
                            ],
                            [
                                -30.07981,
                                68.18228
                            ],
                            [
                                -30.17364,
                                68.29553
                            ],
                            [
                                -30.03017,
                                68.35898
                            ],
                            [
                                -30.0311,
                                68.41565
                            ],
                            [
                                -29.85956,
                                68.43261
                            ],
                            [
                                -29.79822,
                                68.33543
                            ],
                            [
                                -29.52134,
                                68.2336
                            ],
                            [
                                -29.36067,
                                68.27015
                            ],
                            [
                                -29.35302,
                                68.33026
                            ],
                            [
                                -28.84832,
                                68.39698
                            ],
                            [
                                -28.66613,
                                68.37997
                            ],
                            [
                                -28.61853,
                                68.43251
                            ],
                            [
                                -28.46036,
                                68.47489
                            ],
                            [
                                -28.30885,
                                68.43888
                            ],
                            [
                                -28.03315,
                                68.49976
                            ],
                            [
                                -28.06212,
                                68.57353
                            ],
                            [
                                -27.77629,
                                68.49227
                            ],
                            [
                                -27.66294,
                                68.52513
                            ],
                            [
                                -27.59428,
                                68.60527
                            ],
                            [
                                -27.47045,
                                68.5563
                            ],
                            [
                                -27.24532,
                                68.56885
                            ],
                            [
                                -26.90219,
                                68.67265
                            ],
                            [
                                -26.43092,
                                68.70019
                            ],
                            [
                                -26.34653,
                                68.73426
                            ],
                            [
                                -26.32885,
                                68.80608
                            ],
                            [
                                -26.09225,
                                68.80489
                            ],
                            [
                                -25.89814,
                                68.8878
                            ],
                            [
                                -25.76298,
                                68.86639
                            ],
                            [
                                -25.53114,
                                68.95727
                            ],
                            [
                                -25.63473,
                                69.08561
                            ],
                            [
                                -25.34914,
                                69.01068
                            ],
                            [
                                -25.24271,
                                69.05042
                            ],
                            [
                                -25.32373,
                                69.10579
                            ],
                            [
                                -25.01329,
                                69.14644
                            ],
                            [
                                -24.99465,
                                69.20091
                            ],
                            [
                                -25.18282,
                                69.21106
                            ],
                            [
                                -25.1398,
                                69.29039
                            ],
                            [
                                -24.82056,
                                69.23385
                            ],
                            [
                                -24.6321,
                                69.24764
                            ],
                            [
                                -24.61665,
                                69.394
                            ],
                            [
                                -24.44163,
                                69.3492
                            ],
                            [
                                -24.31291,
                                69.43226
                            ],
                            [
                                -24.08511,
                                69.42486
                            ],
                            [
                                -24.00578,
                                69.57266
                            ],
                            [
                                -23.82499,
                                69.52024
                            ],
                            [
                                -23.61858,
                                69.57589
                            ],
                            [
                                -23.55344,
                                69.63137
                            ],
                            [
                                -23.59827,
                                69.7255
                            ],
                            [
                                -23.17091,
                                69.79718
                            ],
                            [
                                -23.0214,
                                69.76239
                            ],
                            [
                                -22.89102,
                                69.82388
                            ],
                            [
                                -23.0559,
                                69.93834
                            ],
                            [
                                -22.79193,
                                69.96217
                            ],
                            [
                                -22.58584,
                                69.94538
                            ],
                            [
                                -22.54044,
                                69.98523
                            ],
                            [
                                -22.36388,
                                69.98134
                            ],
                            [
                                -22.09571,
                                70.09058
                            ],
                            [
                                -22.29977,
                                70.12072
                            ],
                            [
                                -22.79797,
                                70.08954
                            ],
                            [
                                -23.23587,
                                70.10051
                            ],
                            [
                                -23.80308,
                                70.14884
                            ],
                            [
                                -24.464,
                                70.24258
                            ],
                            [
                                -25.03047,
                                70.36601
                            ],
                            [
                                -25.19012,
                                70.27953
                            ],
                            [
                                -25.32398,
                                70.32269
                            ],
                            [
                                -25.26834,
                                70.41096
                            ],
                            [
                                -26.19352,
                                70.22069
                            ],
                            [
                                -26.44616,
                                70.19893
                            ],
                            [
                                -26.70668,
                                70.249
                            ],
                            [
                                -26.85394,
                                70.24775
                            ],
                            [
                                -27.14381,
                                70.15667
                            ],
                            [
                                -27.1526,
                                70.08666
                            ],
                            [
                                -27.26484,
                                69.97257
                            ],
                            [
                                -27.40884,
                                69.96131
                            ],
                            [
                                -27.53301,
                                70.05811
                            ],
                            [
                                -27.91873,
                                70.00564
                            ],
                            [
                                -28.01721,
                                70.06494
                            ],
                            [
                                -28.322,
                                70.09609
                            ],
                            [
                                -28.11786,
                                70.1461
                            ],
                            [
                                -27.81985,
                                70.09621
                            ],
                            [
                                -27.38199,
                                70.17592
                            ],
                            [
                                -27.26444,
                                70.24193
                            ],
                            [
                                -26.95677,
                                70.31175
                            ],
                            [
                                -26.6873,
                                70.29023
                            ],
                            [
                                -26.53983,
                                70.30315
                            ],
                            [
                                -26.30499,
                                70.38256
                            ],
                            [
                                -26.50524,
                                70.4646
                            ],
                            [
                                -26.72751,
                                70.47245
                            ],
                            [
                                -26.90309,
                                70.43557
                            ],
                            [
                                -27.11988,
                                70.44316
                            ],
                            [
                                -27.5524,
                                70.41442
                            ],
                            [
                                -27.94995,
                                70.36241
                            ],
                            [
                                -28.15597,
                                70.3528
                            ],
                            [
                                -28.26353,
                                70.41536
                            ],
                            [
                                -28.28024,
                                70.47921
                            ],
                            [
                                -28.48398,
                                70.45114
                            ],
                            [
                                -28.74927,
                                70.44163
                            ],
                            [
                                -28.89401,
                                70.39269
                            ],
                            [
                                -29.08548,
                                70.38384
                            ],
                            [
                                -29.08886,
                                70.44844
                            ],
                            [
                                -28.67461,
                                70.50214
                            ],
                            [
                                -28.35371,
                                70.51515
                            ],
                            [
                                -28.18815,
                                70.5763
                            ],
                            [
                                -27.994,
                                70.68345
                            ],
                            [
                                -27.87574,
                                70.85647
                            ],
                            [
                                -28.03693,
                                70.86835
                            ],
                            [
                                -28.18478,
                                70.93855
                            ],
                            [
                                -28.0531,
                                70.96711
                            ],
                            [
                                -27.63958,
                                70.91788
                            ],
                            [
                                -27.62847,
                                70.9503
                            ],
                            [
                                -27.81849,
                                71.02267
                            ],
                            [
                                -27.93449,
                                71.12432
                            ],
                            [
                                -27.81567,
                                71.13535
                            ],
                            [
                                -27.53172,
                                70.96229
                            ],
                            [
                                -27.4949,
                                70.91859
                            ],
                            [
                                -27.14488,
                                70.93428
                            ],
                            [
                                -26.73108,
                                70.92529
                            ],
                            [
                                -26.4839,
                                70.95516
                            ],
                            [
                                -26.2407,
                                71.03796
                            ],
                            [
                                -26.03175,
                                71.05449
                            ],
                            [
                                -25.95289,
                                71.0915
                            ],
                            [
                                -25.65052,
                                71.14518
                            ],
                            [
                                -25.41016,
                                71.2711
                            ],
                            [
                                -25.41541,
                                71.3243
                            ],
                            [
                                -25.75374,
                                71.46666
                            ],
                            [
                                -26.02616,
                                71.48331
                            ],
                            [
                                -26.1867,
                                71.46982
                            ],
                            [
                                -26.46329,
                                71.48929
                            ],
                            [
                                -26.68967,
                                71.4614
                            ],
                            [
                                -27.17799,
                                71.52458
                            ],
                            [
                                -27.4303,
                                71.61222
                            ],
                            [
                                -27.38914,
                                71.68216
                            ],
                            [
                                -28.07958,
                                71.87151
                            ],
                            [
                                -28.53238,
                                71.89224
                            ],
                            [
                                -28.57321,
                                71.93877
                            ],
                            [
                                -28.28435,
                                71.96638
                            ],
                            [
                                -27.81594,
                                71.91852
                            ],
                            [
                                -27.65353,
                                71.87488
                            ],
                            [
                                -27.67801,
                                71.83494
                            ],
                            [
                                -27.2418,
                                71.70446
                            ],
                            [
                                -27.22654,
                                71.65132
                            ],
                            [
                                -27.03438,
                                71.57607
                            ],
                            [
                                -26.7407,
                                71.52177
                            ],
                            [
                                -26.49778,
                                71.55318
                            ],
                            [
                                -26.24564,
                                71.55236
                            ],
                            [
                                -26.11703,
                                71.57744
                            ],
                            [
                                -25.61419,
                                71.5277
                            ],
                            [
                                -25.39333,
                                71.44367
                            ],
                            [
                                -25.24808,
                                71.35086
                            ],
                            [
                                -25.07782,
                                71.2885
                            ],
                            [
                                -24.69059,
                                71.30047
                            ],
                            [
                                -24.59293,
                                71.21128
                            ],
                            [
                                -24.30583,
                                71.08843
                            ],
                            [
                                -24.21236,
                                70.97894
                            ],
                            [
                                -24.2264,
                                70.89742
                            ],
                            [
                                -24.06053,
                                70.67585
                            ],
                            [
                                -23.97356,
                                70.62813
                            ],
                            [
                                -23.35291,
                                70.45645
                            ],
                            [
                                -23.09672,
                                70.4406
                            ],
                            [
                                -22.69221,
                                70.43575
                            ],
                            [
                                -22.61669,
                                70.4543
                            ],
                            [
                                -22.57648,
                                70.57471
                            ],
                            [
                                -22.64556,
                                70.67923
                            ],
                            [
                                -22.60152,
                                70.82716
                            ],
                            [
                                -22.43755,
                                70.83519
                            ],
                            [
                                -22.47525,
                                70.68143
                            ],
                            [
                                -22.38348,
                                70.46242
                            ],
                            [
                                -22.2696,
                                70.45686
                            ],
                            [
                                -21.97179,
                                70.49714
                            ],
                            [
                                -21.97354,
                                70.41446
                            ],
                            [
                                -21.63871,
                                70.44966
                            ],
                            [
                                -21.49735,
                                70.52679
                            ],
                            [
                                -21.70711,
                                70.64759
                            ],
                            [
                                -21.59007,
                                70.73197
                            ],
                            [
                                -21.78892,
                                70.78603
                            ],
                            [
                                -21.78681,
                                70.87102
                            ],
                            [
                                -21.67834,
                                70.94282
                            ],
                            [
                                -21.67916,
                                71.02317
                            ],
                            [
                                -21.78103,
                                71.10956
                            ],
                            [
                                -21.6632,
                                71.18555
                            ],
                            [
                                -21.91747,
                                71.26471
                            ],
                            [
                                -21.6957,
                                71.39718
                            ],
                            [
                                -21.83016,
                                71.49181
                            ],
                            [
                                -22.09778,
                                71.49675
                            ],
                            [
                                -22.27091,
                                71.44159
                            ],
                            [
                                -22.37074,
                                71.34491
                            ],
                            [
                                -22.47094,
                                71.33875
                            ],
                            [
                                -22.56442,
                                71.49273
                            ],
                            [
                                -22.45004,
                                71.58655
                            ],
                            [
                                -22.20247,
                                71.59318
                            ],
                            [
                                -22.24814,
                                71.63759
                            ],
                            [
                                -22.03846,
                                71.70433
                            ],
                            [
                                -22.31415,
                                71.73019
                            ],
                            [
                                -22.39882,
                                71.62615
                            ],
                            [
                                -22.67346,
                                71.6556
                            ],
                            [
                                -22.41075,
                                71.75243
                            ],
                            [
                                -22.47449,
                                71.785
                            ],
                            [
                                -22.8702,
                                71.69103
                            ],
                            [
                                -23.01593,
                                71.62191
                            ],
                            [
                                -23.1383,
                                71.6753
                            ],
                            [
                                -22.75414,
                                71.81176
                            ],
                            [
                                -22.79599,
                                71.86669
                            ],
                            [
                                -22.5655,
                                71.88823
                            ],
                            [
                                -22.56936,
                                71.9277
                            ],
                            [
                                -23.02971,
                                72.01962
                            ],
                            [
                                -23.14027,
                                72.07382
                            ],
                            [
                                -23.60747,
                                72.1473
                            ],
                            [
                                -23.81735,
                                72.25293
                            ],
                            [
                                -24.05068,
                                72.26506
                            ],
                            [
                                -24.17523,
                                72.31175
                            ],
                            [
                                -24.38578,
                                72.33765
                            ],
                            [
                                -24.55608,
                                72.41609
                            ],
                            [
                                -24.8338,
                                72.4346
                            ],
                            [
                                -25.14053,
                                72.37318
                            ],
                            [
                                -25.50961,
                                72.23072
                            ],
                            [
                                -25.22348,
                                72.43281
                            ],
                            [
                                -24.71427,
                                72.49668
                            ],
                            [
                                -24.65548,
                                72.52319
                            ],
                            [
                                -24.75172,
                                72.66416
                            ],
                            [
                                -25.04092,
                                72.72722
                            ],
                            [
                                -25.2776,
                                72.79996
                            ],
                            [
                                -25.60502,
                                72.82583
                            ],
                            [
                                -25.9269,
                                72.7279
                            ],
                            [
                                -26.22304,
                                72.718
                            ],
                            [
                                -26.62026,
                                72.79951
                            ],
                            [
                                -26.53126,
                                72.82046
                            ],
                            [
                                -26.25863,
                                72.77427
                            ],
                            [
                                -25.88322,
                                72.82365
                            ],
                            [
                                -25.65176,
                                72.89291
                            ],
                            [
                                -25.44228,
                                72.89132
                            ],
                            [
                                -25.16399,
                                72.92768
                            ],
                            [
                                -24.99761,
                                73.00561
                            ],
                            [
                                -25.1216,
                                73.07227
                            ],
                            [
                                -25.45005,
                                73.08692
                            ],
                            [
                                -25.69431,
                                73.11592
                            ],
                            [
                                -25.91635,
                                73.18363
                            ],
                            [
                                -26.09947,
                                73.19693
                            ],
                            [
                                -26.46599,
                                73.18387
                            ],
                            [
                                -26.46976,
                                73.28652
                            ],
                            [
                                -26.74264,
                                73.29489
                            ],
                            [
                                -27.06098,
                                73.34386
                            ],
                            [
                                -27.41297,
                                73.46427
                            ],
                            [
                                -27.19477,
                                73.49636
                            ],
                            [
                                -26.9839,
                                73.3808
                            ],
                            [
                                -26.7779,
                                73.33101
                            ],
                            [
                                -26.46893,
                                73.34917
                            ],
                            [
                                -26.1715,
                                73.2393
                            ],
                            [
                                -25.74856,
                                73.25638
                            ],
                            [
                                -25.4567,
                                73.35049
                            ],
                            [
                                -25.50979,
                                73.40275
                            ],
                            [
                                -25.38529,
                                73.45306
                            ],
                            [
                                -24.72086,
                                73.49945
                            ],
                            [
                                -24.70881,
                                73.53054
                            ],
                            [
                                -24.92747,
                                73.60341
                            ],
                            [
                                -24.39725,
                                73.55289
                            ],
                            [
                                -24.50525,
                                73.70711
                            ],
                            [
                                -24.30394,
                                73.78117
                            ],
                            [
                                -24.07539,
                                73.82955
                            ],
                            [
                                -23.99597,
                                73.77265
                            ],
                            [
                                -24.08489,
                                73.66122
                            ],
                            [
                                -23.98048,
                                73.58517
                            ],
                            [
                                -23.41659,
                                73.42435
                            ],
                            [
                                -23.0815,
                                73.35186
                            ],
                            [
                                -22.62497,
                                73.30272
                            ],
                            [
                                -22.51325,
                                73.26742
                            ],
                            [
                                -22.20973,
                                73.24851
                            ],
                            [
                                -21.99878,
                                73.32897
                            ],
                            [
                                -21.58542,
                                73.3887
                            ],
                            [
                                -21.56975,
                                73.48832
                            ],
                            [
                                -21.30352,
                                73.45211
                            ],
                            [
                                -20.81425,
                                73.45929
                            ],
                            [
                                -20.5577,
                                73.44841
                            ],
                            [
                                -20.38345,
                                73.51017
                            ],
                            [
                                -20.50168,
                                73.55679
                            ],
                            [
                                -20.46165,
                                73.64148
                            ],
                            [
                                -20.53736,
                                73.71344
                            ],
                            [
                                -20.48567,
                                73.77207
                            ],
                            [
                                -20.3002,
                                73.79024
                            ],
                            [
                                -20.30291,
                                73.88678
                            ],
                            [
                                -20.61619,
                                73.87904
                            ],
                            [
                                -21.10929,
                                73.93875
                            ],
                            [
                                -21.49491,
                                74.02839
                            ],
                            [
                                -21.72951,
                                74.06095
                            ],
                            [
                                -21.99279,
                                73.98763
                            ],
                            [
                                -22.43682,
                                74.05698
                            ],
                            [
                                -22.17136,
                                74.11853
                            ],
                            [
                                -22.29521,
                                74.17797
                            ],
                            [
                                -22.08027,
                                74.22079
                            ],
                            [
                                -22.08685,
                                74.31742
                            ],
                            [
                                -21.92405,
                                74.31324
                            ],
                            [
                                -21.96882,
                                74.2214
                            ],
                            [
                                -21.41099,
                                74.13601
                            ],
                            [
                                -21.32319,
                                74.10226
                            ],
                            [
                                -21.08405,
                                74.09446
                            ],
                            [
                                -20.55785,
                                74.14623
                            ],
                            [
                                -20.19521,
                                74.16275
                            ],
                            [
                                -20.1136,
                                74.21212
                            ],
                            [
                                -20.35085,
                                74.24108
                            ],
                            [
                                -20.47956,
                                74.38065
                            ],
                            [
                                -20.25166,
                                74.38319
                            ],
                            [
                                -20.22628,
                                74.2998
                            ],
                            [
                                -19.63245,
                                74.24068
                            ],
                            [
                                -19.3676,
                                74.27634
                            ],
                            [
                                -19.18456,
                                74.34354
                            ],
                            [
                                -19.16596,
                                74.38989
                            ],
                            [
                                -18.97465,
                                74.48186
                            ],
                            [
                                -19.22486,
                                74.50793
                            ],
                            [
                                -19.30466,
                                74.56419
                            ],
                            [
                                -19.31116,
                                74.66214
                            ],
                            [
                                -19.45472,
                                74.6815
                            ],
                            [
                                -19.796,
                                74.58003
                            ],
                            [
                                -20.20967,
                                74.67841
                            ],
                            [
                                -20.80868,
                                74.66822
                            ],
                            [
                                -20.60595,
                                74.73772
                            ],
                            [
                                -20.75715,
                                74.8536
                            ],
                            [
                                -20.68263,
                                74.88908
                            ],
                            [
                                -20.71751,
                                74.97545
                            ],
                            [
                                -20.62555,
                                75.02359
                            ],
                            [
                                -21.16915,
                                75.07469
                            ],
                            [
                                -21.16713,
                                75.11555
                            ],
                            [
                                -20.90811,
                                75.13712
                            ],
                            [
                                -20.6896,
                                75.1107
                            ],
                            [
                                -20.50302,
                                75.13705
                            ],
                            [
                                -20.56562,
                                75.1878
                            ],
                            [
                                -20.8925,
                                75.25266
                            ],
                            [
                                -21.07899,
                                75.32173
                            ],
                            [
                                -21.33108,
                                75.35685
                            ],
                            [
                                -21.50148,
                                75.49878
                            ],
                            [
                                -21.8824,
                                75.5854
                            ],
                            [
                                -22.17556,
                                75.62981
                            ],
                            [
                                -22.09421,
                                75.66821
                            ],
                            [
                                -21.64054,
                                75.58681
                            ],
                            [
                                -21.22597,
                                75.46074
                            ],
                            [
                                -21.12646,
                                75.3929
                            ],
                            [
                                -20.62781,
                                75.28849
                            ],
                            [
                                -20.32194,
                                75.33236
                            ],
                            [
                                -20.14443,
                                75.33358
                            ],
                            [
                                -19.96499,
                                75.28561
                            ],
                            [
                                -20.04197,
                                75.21131
                            ],
                            [
                                -19.88422,
                                75.1447
                            ],
                            [
                                -19.60849,
                                75.13045
                            ],
                            [
                                -19.46117,
                                75.19486
                            ],
                            [
                                -19.35723,
                                75.29886
                            ],
                            [
                                -19.3407,
                                75.45398
                            ],
                            [
                                -19.37831,
                                75.53902
                            ],
                            [
                                -19.59325,
                                75.67859
                            ],
                            [
                                -19.5283,
                                75.75764
                            ],
                            [
                                -19.77546,
                                75.89568
                            ],
                            [
                                -19.96379,
                                75.93986
                            ],
                            [
                                -20.36141,
                                75.9202
                            ],
                            [
                                -20.39629,
                                75.97776
                            ],
                            [
                                -20.10128,
                                76.05257
                            ],
                            [
                                -19.76126,
                                76.06389
                            ],
                            [
                                -19.77903,
                                76.16259
                            ],
                            [
                                -19.95667,
                                76.247
                            ],
                            [
                                -20.53656,
                                76.21553
                            ],
                            [
                                -20.84189,
                                76.28719
                            ],
                            [
                                -21.07491,
                                76.30114
                            ],
                            [
                                -21.30544,
                                76.2549
                            ],
                            [
                                -21.47545,
                                76.26474
                            ],
                            [
                                -21.75619,
                                76.20332
                            ],
                            [
                                -21.57752,
                                76.38842
                            ],
                            [
                                -21.70023,
                                76.4322
                            ],
                            [
                                -21.95158,
                                76.41088
                            ],
                            [
                                -22.44005,
                                76.42605
                            ],
                            [
                                -22.34777,
                                76.46358
                            ],
                            [
                                -21.8977,
                                76.42455
                            ],
                            [
                                -21.74733,
                                76.44172
                            ],
                            [
                                -21.69294,
                                76.51868
                            ],
                            [
                                -21.86416,
                                76.59911
                            ],
                            [
                                -22.13769,
                                76.63686
                            ],
                            [
                                -22.36462,
                                76.61156
                            ],
                            [
                                -22.46166,
                                76.66301
                            ],
                            [
                                -22.7278,
                                76.7
                            ],
                            [
                                -22.30703,
                                76.7511
                            ],
                            [
                                -22.37525,
                                76.8109
                            ],
                            [
                                -22.15162,
                                76.88307
                            ],
                            [
                                -21.73711,
                                76.64244
                            ],
                            [
                                -21.37958,
                                76.70137
                            ],
                            [
                                -21.28673,
                                76.77978
                            ],
                            [
                                -20.97675,
                                76.78154
                            ],
                            [
                                -20.81308,
                                76.8454
                            ],
                            [
                                -20.28798,
                                76.92861
                            ],
                            [
                                -19.8668,
                                76.92507
                            ],
                            [
                                -19.35297,
                                76.81958
                            ],
                            [
                                -18.9087,
                                76.80629
                            ],
                            [
                                -18.80343,
                                76.76072
                            ],
                            [
                                -18.51395,
                                76.75757
                            ],
                            [
                                -18.28689,
                                76.8199
                            ],
                            [
                                -18.17336,
                                77.02909
                            ],
                            [
                                -18.207,
                                77.20017
                            ],
                            [
                                -18.34435,
                                77.25907
                            ],
                            [
                                -18.93305,
                                77.30626
                            ],
                            [
                                -19.04516,
                                77.26991
                            ],
                            [
                                -18.96198,
                                77.20182
                            ],
                            [
                                -19.13439,
                                77.18214
                            ],
                            [
                                -19.46759,
                                77.28247
                            ],
                            [
                                -19.80529,
                                77.34955
                            ],
                            [
                                -20.27908,
                                77.33198
                            ],
                            [
                                -20.24838,
                                77.40961
                            ],
                            [
                                -20.3766,
                                77.44644
                            ],
                            [
                                -20.14713,
                                77.50081
                            ],
                            [
                                -20.29142,
                                77.55476
                            ],
                            [
                                -20.57875,
                                77.57111
                            ],
                            [
                                -20.77014,
                                77.62339
                            ],
                            [
                                -20.22917,
                                77.67202
                            ],
                            [
                                -19.93893,
                                77.66613
                            ],
                            [
                                -19.48028,
                                77.55327
                            ],
                            [
                                -19.21431,
                                77.51792
                            ],
                            [
                                -18.89875,
                                77.55973
                            ],
                            [
                                -19.07023,
                                77.6769
                            ],
                            [
                                -19.2423,
                                77.7214
                            ],
                            [
                                -19.7349,
                                77.74531
                            ],
                            [
                                -20.46833,
                                77.86409
                            ],
                            [
                                -20.52468,
                                77.9171
                            ],
                            [
                                -20.78666,
                                77.95964
                            ],
                            [
                                -20.98994,
                                77.90314
                            ],
                            [
                                -21.30563,
                                77.73276
                            ],
                            [
                                -21.27467,
                                77.59611
                            ],
                            [
                                -21.94588,
                                77.57538
                            ],
                            [
                                -21.76057,
                                77.74643
                            ],
                            [
                                -21.50304,
                                77.89313
                            ],
                            [
                                -21.59558,
                                77.95416
                            ],
                            [
                                -21.10112,
                                78.06807
                            ],
                            [
                                -21.26714,
                                78.12107
                            ],
                            [
                                -21.1977,
                                78.16573
                            ],
                            [
                                -21.29382,
                                78.24798
                            ],
                            [
                                -21.05713,
                                78.45496
                            ],
                            [
                                -21.13097,
                                78.48926
                            ],
                            [
                                -20.90853,
                                78.54005
                            ],
                            [
                                -20.90456,
                                78.58714
                            ],
                            [
                                -21.08973,
                                78.71992
                            ],
                            [
                                -21.067,
                                78.78104
                            ],
                            [
                                -20.67588,
                                78.85741
                            ],
                            [
                                -20.31551,
                                78.77246
                            ],
                            [
                                -19.92776,
                                78.81524
                            ],
                            [
                                -19.51802,
                                78.67639
                            ],
                            [
                                -19.28839,
                                78.68487
                            ],
                            [
                                -19.19439,
                                78.76778
                            ],
                            [
                                -19.357,
                                78.80352
                            ],
                            [
                                -19.15409,
                                78.84893
                            ],
                            [
                                -19.17973,
                                79.01587
                            ],
                            [
                                -18.72564,
                                79.08273
                            ],
                            [
                                -18.93615,
                                79.10243
                            ],
                            [
                                -19.25127,
                                79.06087
                            ],
                            [
                                -19.33663,
                                79.14194
                            ],
                            [
                                -19.12304,
                                79.22394
                            ],
                            [
                                -19.14879,
                                79.27381
                            ],
                            [
                                -19.57918,
                                79.28483
                            ],
                            [
                                -19.58398,
                                79.43905
                            ],
                            [
                                -19.34787,
                                79.49719
                            ],
                            [
                                -19.31543,
                                79.55359
                            ],
                            [
                                -19.57895,
                                79.60247
                            ],
                            [
                                -19.33953,
                                79.69223
                            ],
                            [
                                -19.07157,
                                79.73915
                            ],
                            [
                                -18.69878,
                                79.73256
                            ],
                            [
                                -18.24126,
                                79.68316
                            ],
                            [
                                -17.99057,
                                79.69522
                            ],
                            [
                                -17.71918,
                                79.76451
                            ],
                            [
                                -17.1991,
                                80.02112
                            ],
                            [
                                -17.58579,
                                80.07902
                            ],
                            [
                                -18.04391,
                                80.07749
                            ],
                            [
                                -18.68629,
                                80.02562
                            ],
                            [
                                -19.04397,
                                80.04021
                            ],
                            [
                                -19.74241,
                                79.94253
                            ],
                            [
                                -19.98965,
                                79.79968
                            ],
                            [
                                -20.42346,
                                79.75363
                            ],
                            [
                                -20.52596,
                                79.84138
                            ],
                            [
                                -20.13407,
                                79.97338
                            ],
                            [
                                -19.95505,
                                80.10715
                            ],
                            [
                                -19.39815,
                                80.25626
                            ],
                            [
                                -18.53353,
                                80.20473
                            ],
                            [
                                -18.0405,
                                80.16075
                            ],
                            [
                                -17.60198,
                                80.17757
                            ],
                            [
                                -17.02076,
                                80.16512
                            ],
                            [
                                -16.66651,
                                80.18186
                            ],
                            [
                                -16.33311,
                                80.22769
                            ],
                            [
                                -16.23249,
                                80.30826
                            ],
                            [
                                -15.82888,
                                80.36927
                            ],
                            [
                                -15.68671,
                                80.41867
                            ],
                            [
                                -16.23545,
                                80.47552
                            ],
                            [
                                -16.58828,
                                80.4867
                            ],
                            [
                                -16.99383,
                                80.53979
                            ],
                            [
                                -17.35241,
                                80.49205
                            ],
                            [
                                -18.0936,
                                80.48956
                            ],
                            [
                                -18.7318,
                                80.53182
                            ],
                            [
                                -18.99227,
                                80.58406
                            ],
                            [
                                -19.39159,
                                80.61402
                            ],
                            [
                                -19.78226,
                                80.54426
                            ],
                            [
                                -19.98007,
                                80.56082
                            ],
                            [
                                -19.44414,
                                80.64937
                            ],
                            [
                                -18.19026,
                                80.55417
                            ],
                            [
                                -17.41411,
                                80.64003
                            ],
                            [
                                -17.05847,
                                80.6578
                            ],
                            [
                                -16.44863,
                                80.64762
                            ],
                            [
                                -16.08397,
                                80.60688
                            ],
                            [
                                -15.47304,
                                80.61581
                            ],
                            [
                                -15.28516,
                                80.7136
                            ],
                            [
                                -14.38304,
                                80.74404
                            ],
                            [
                                -14.11074,
                                80.80447
                            ],
                            [
                                -14.38079,
                                80.90019
                            ],
                            [
                                -14.2342,
                                80.97689
                            ],
                            [
                                -13.5564,
                                80.96256
                            ],
                            [
                                -13.04087,
                                81.04593
                            ],
                            [
                                -13.04441,
                                81.08108
                            ],
                            [
                                -12.29954,
                                81.20572
                            ],
                            [
                                -11.63818,
                                81.29078
                            ],
                            [
                                -11.48386,
                                81.3545
                            ],
                            [
                                -11.78018,
                                81.52303
                            ],
                            [
                                -12.73246,
                                81.63855
                            ],
                            [
                                -13.31121,
                                81.73059
                            ],
                            [
                                -13.74515,
                                81.75101
                            ],
                            [
                                -14.24133,
                                81.73844
                            ],
                            [
                                -14.72708,
                                81.68426
                            ],
                            [
                                -15.00662,
                                81.76217
                            ],
                            [
                                -15.49259,
                                81.75027
                            ],
                            [
                                -15.52883,
                                81.68828
                            ],
                            [
                                -16.34499,
                                81.74768
                            ],
                            [
                                -16.23854,
                                81.62716
                            ],
                            [
                                -16.71096,
                                81.60067
                            ],
                            [
                                -16.91509,
                                81.54469
                            ],
                            [
                                -16.74453,
                                81.4959
                            ],
                            [
                                -17.12391,
                                81.45527
                            ],
                            [
                                -17.1315,
                                81.41178
                            ],
                            [
                                -17.90124,
                                81.40633
                            ],
                            [
                                -18.10695,
                                81.46098
                            ],
                            [
                                -18.44745,
                                81.48989
                            ],
                            [
                                -19.29683,
                                81.42457
                            ],
                            [
                                -19.29417,
                                81.55816
                            ],
                            [
                                -19.78625,
                                81.54002
                            ],
                            [
                                -20.57567,
                                81.38073
                            ],
                            [
                                -20.6979,
                                81.28099
                            ],
                            [
                                -20.97057,
                                81.25383
                            ],
                            [
                                -21.95952,
                                81.03937
                            ],
                            [
                                -22.02777,
                                80.98725
                            ],
                            [
                                -22.42212,
                                80.92476
                            ],
                            [
                                -22.8866,
                                80.89279
                            ],
                            [
                                -22.8435,
                                80.81173
                            ],
                            [
                                -23.23193,
                                80.67631
                            ],
                            [
                                -23.55651,
                                80.68456
                            ],
                            [
                                -23.13347,
                                80.82298
                            ],
                            [
                                -23.26789,
                                80.89467
                            ],
                            [
                                -22.74726,
                                81.01354
                            ],
                            [
                                -22.26482,
                                81.14736
                            ],
                            [
                                -22.15539,
                                81.20956
                            ],
                            [
                                -21.64891,
                                81.32393
                            ],
                            [
                                -21.31575,
                                81.46124
                            ],
                            [
                                -21.03137,
                                81.706
                            ],
                            [
                                -21.00009,
                                81.90968
                            ],
                            [
                                -21.27278,
                                82.05238
                            ],
                            [
                                -22.32641,
                                82.04421
                            ],
                            [
                                -23.14816,
                                82.00431
                            ],
                            [
                                -23.34415,
                                81.8528
                            ],
                            [
                                -23.32352,
                                81.71383
                            ],
                            [
                                -24.17459,
                                81.68638
                            ],
                            [
                                -24.66651,
                                81.60857
                            ],
                            [
                                -25.97489,
                                81.49687
                            ],
                            [
                                -26.22404,
                                81.44141
                            ],
                            [
                                -26.65786,
                                81.49112
                            ],
                            [
                                -26.20824,
                                81.5167
                            ],
                            [
                                -26.30488,
                                81.57773
                            ],
                            [
                                -25.4376,
                                81.66649
                            ],
                            [
                                -24.63242,
                                81.77957
                            ],
                            [
                                -24.5753,
                                81.9953
                            ],
                            [
                                -27.58256,
                                82.03164
                            ],
                            [
                                -28.81336,
                                81.99125
                            ],
                            [
                                -29.23752,
                                81.94957
                            ],
                            [
                                -29.6883,
                                81.93873
                            ],
                            [
                                -31.33366,
                                81.82653
                            ],
                            [
                                -32.08234,
                                81.70337
                            ],
                            [
                                -32.63395,
                                81.64796
                            ],
                            [
                                -32.61997,
                                81.7469
                            ],
                            [
                                -32.78733,
                                81.80254
                            ],
                            [
                                -31.79886,
                                81.93218
                            ],
                            [
                                -29.93781,
                                82.09166
                            ],
                            [
                                -29.90432,
                                82.1312
                            ],
                            [
                                -28.90581,
                                82.15326
                            ],
                            [
                                -28.5544,
                                82.17595
                            ],
                            [
                                -27.62881,
                                82.19513
                            ],
                            [
                                -26.68636,
                                82.18556
                            ],
                            [
                                -25.29665,
                                82.14993
                            ],
                            [
                                -24.41643,
                                82.14963
                            ],
                            [
                                -23.80783,
                                82.19574
                            ],
                            [
                                -23.33439,
                                82.26097
                            ],
                            [
                                -22.7919,
                                82.29859
                            ],
                            [
                                -21.90808,
                                82.28221
                            ],
                            [
                                -21.38882,
                                82.3179
                            ],
                            [
                                -20.97857,
                                82.39061
                            ],
                            [
                                -21.0982,
                                82.43442
                            ],
                            [
                                -20.44913,
                                82.47779
                            ],
                            [
                                -19.90606,
                                82.54849
                            ],
                            [
                                -19.79752,
                                82.59534
                            ],
                            [
                                -20.35601,
                                82.71026
                            ],
                            [
                                -21.07987,
                                82.81924
                            ],
                            [
                                -21.89349,
                                82.83287
                            ],
                            [
                                -22.40135,
                                82.91083
                            ],
                            [
                                -22.76775,
                                82.86798
                            ],
                            [
                                -23.5357,
                                82.94218
                            ],
                            [
                                -24.10284,
                                82.90548
                            ],
                            [
                                -24.48134,
                                82.96139
                            ],
                            [
                                -24.11935,
                                83.05471
                            ],
                            [
                                -24.37527,
                                83.1283
                            ],
                            [
                                -24.4731,
                                83.23771
                            ],
                            [
                                -24.73785,
                                83.25272
                            ],
                            [
                                -25.85994,
                                83.19552
                            ],
                            [
                                -26.59501,
                                83.1235
                            ],
                            [
                                -28.40079,
                                83.14331
                            ],
                            [
                                -29.87114,
                                83.17998
                            ],
                            [
                                -30.59626,
                                83.16213
                            ],
                            [
                                -30.89843,
                                83.11465
                            ],
                            [
                                -31.32683,
                                83.11252
                            ],
                            [
                                -32.08934,
                                83.01438
                            ],
                            [
                                -33.58379,
                                82.9805
                            ],
                            [
                                -34.05904,
                                82.95507
                            ],
                            [
                                -34.21444,
                                82.90642
                            ],
                            [
                                -34.69699,
                                82.91977
                            ],
                            [
                                -33.98847,
                                83.00576
                            ],
                            [
                                -33.22062,
                                83.03507
                            ],
                            [
                                -32.66812,
                                83.08112
                            ],
                            [
                                -32.33011,
                                83.0802
                            ],
                            [
                                -31.29904,
                                83.15591
                            ],
                            [
                                -31.03283,
                                83.20475
                            ],
                            [
                                -29.67877,
                                83.23551
                            ],
                            [
                                -28.12723,
                                83.20484
                            ],
                            [
                                -27.00115,
                                83.21748
                            ],
                            [
                                -25.70072,
                                83.33511
                            ],
                            [
                                -25.56411,
                                83.41818
                            ],
                            [
                                -27.1581,
                                83.54613
                            ],
                            [
                                -28.31374,
                                83.58566
                            ],
                            [
                                -28.74768,
                                83.54371
                            ],
                            [
                                -29.00537,
                                83.61101
                            ],
                            [
                                -29.92335,
                                83.59187
                            ],
                            [
                                -30.65744,
                                83.64223
                            ],
                            [
                                -31.40721,
                                83.65399
                            ],
                            [
                                -31.8049,
                                83.61181
                            ],
                            [
                                -33.25139,
                                83.65157
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -54.23237,
                                70.31214
                            ],
                            [
                                -54.37084,
                                70.32931
                            ],
                            [
                                -54.75204,
                                70.2485
                            ],
                            [
                                -54.83764,
                                70.19719
                            ],
                            [
                                -54.78526,
                                70.04921
                            ],
                            [
                                -54.70194,
                                69.96085
                            ],
                            [
                                -54.83974,
                                69.94505
                            ],
                            [
                                -54.78292,
                                69.88792
                            ],
                            [
                                -54.9104,
                                69.85676
                            ],
                            [
                                -54.86936,
                                69.80132
                            ],
                            [
                                -54.97726,
                                69.71055
                            ],
                            [
                                -54.8004,
                                69.60155
                            ],
                            [
                                -54.51461,
                                69.55892
                            ],
                            [
                                -54.31721,
                                69.57067
                            ],
                            [
                                -53.98839,
                                69.51785
                            ],
                            [
                                -53.78736,
                                69.4565
                            ],
                            [
                                -53.78282,
                                69.42256
                            ],
                            [
                                -54.23171,
                                69.43992
                            ],
                            [
                                -54.27223,
                                69.39707
                            ],
                            [
                                -54.06129,
                                69.32066
                            ],
                            [
                                -53.87296,
                                69.30717
                            ],
                            [
                                -53.84624,
                                69.26527
                            ],
                            [
                                -53.52323,
                                69.24969
                            ],
                            [
                                -52.99584,
                                69.34926
                            ],
                            [
                                -52.79709,
                                69.3665
                            ],
                            [
                                -52.16675,
                                69.4793
                            ],
                            [
                                -51.85533,
                                69.63882
                            ],
                            [
                                -51.97448,
                                69.67279
                            ],
                            [
                                -51.92833,
                                69.7362
                            ],
                            [
                                -51.98283,
                                69.7959
                            ],
                            [
                                -52.25116,
                                69.84087
                            ],
                            [
                                -52.51396,
                                69.86486
                            ],
                            [
                                -52.73246,
                                69.92588
                            ],
                            [
                                -53.06185,
                                70.12028
                            ],
                            [
                                -53.29108,
                                70.19617
                            ],
                            [
                                -53.51017,
                                70.24519
                            ],
                            [
                                -54.23237,
                                70.31214
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -47.34567,
                                82.60823
                            ],
                            [
                                -48.31634,
                                82.57619
                            ],
                            [
                                -47.93969,
                                82.41846
                            ],
                            [
                                -47.69743,
                                82.27592
                            ],
                            [
                                -47.27209,
                                82.20253
                            ],
                            [
                                -46.13863,
                                82.03545
                            ],
                            [
                                -45.95618,
                                81.93395
                            ],
                            [
                                -45.5449,
                                81.9494
                            ],
                            [
                                -45.88992,
                                82.10597
                            ],
                            [
                                -45.73323,
                                82.15663
                            ],
                            [
                                -45.13065,
                                82.2288
                            ],
                            [
                                -45.11872,
                                82.29125
                            ],
                            [
                                -45.50449,
                                82.36109
                            ],
                            [
                                -45.70118,
                                82.44368
                            ],
                            [
                                -46.84099,
                                82.58807
                            ],
                            [
                                -47.34567,
                                82.60823
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -24.07796,
                                72.88161
                            ],
                            [
                                -24.52509,
                                72.83947
                            ],
                            [
                                -24.37618,
                                72.58858
                            ],
                            [
                                -24.1566,
                                72.55313
                            ],
                            [
                                -23.88598,
                                72.44863
                            ],
                            [
                                -23.4696,
                                72.39035
                            ],
                            [
                                -23.14092,
                                72.32741
                            ],
                            [
                                -22.97123,
                                72.24758
                            ],
                            [
                                -22.69114,
                                72.17444
                            ],
                            [
                                -22.45116,
                                72.133
                            ],
                            [
                                -22.21317,
                                72.13188
                            ],
                            [
                                -22.101,
                                72.26606
                            ],
                            [
                                -22.67894,
                                72.35867
                            ],
                            [
                                -22.76501,
                                72.39112
                            ],
                            [
                                -22.66239,
                                72.46088
                            ],
                            [
                                -22.39033,
                                72.42679
                            ],
                            [
                                -22.23031,
                                72.43007
                            ],
                            [
                                -21.98466,
                                72.39613
                            ],
                            [
                                -21.98127,
                                72.49102
                            ],
                            [
                                -22.12799,
                                72.49702
                            ],
                            [
                                -22.33277,
                                72.57106
                            ],
                            [
                                -22.70245,
                                72.62072
                            ],
                            [
                                -22.74742,
                                72.66196
                            ],
                            [
                                -23.01595,
                                72.73681
                            ],
                            [
                                -23.15294,
                                72.83302
                            ],
                            [
                                -23.5445,
                                72.83314
                            ],
                            [
                                -24.07796,
                                72.88161
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -25.71195,
                                70.98754
                            ],
                            [
                                -25.6986,
                                71.08412
                            ],
                            [
                                -26.47188,
                                70.89499
                            ],
                            [
                                -26.76374,
                                70.86858
                            ],
                            [
                                -27.05167,
                                70.87585
                            ],
                            [
                                -27.24532,
                                70.77833
                            ],
                            [
                                -27.39863,
                                70.75294
                            ],
                            [
                                -27.68363,
                                70.62631
                            ],
                            [
                                -27.86778,
                                70.62601
                            ],
                            [
                                -28.00462,
                                70.56859
                            ],
                            [
                                -27.93373,
                                70.52172
                            ],
                            [
                                -28.05654,
                                70.46417
                            ],
                            [
                                -27.99324,
                                70.41735
                            ],
                            [
                                -27.78098,
                                70.41981
                            ],
                            [
                                -27.00796,
                                70.48812
                            ],
                            [
                                -26.77914,
                                70.52185
                            ],
                            [
                                -26.60633,
                                70.51469
                            ],
                            [
                                -26.27385,
                                70.57605
                            ],
                            [
                                -26.04331,
                                70.51737
                            ],
                            [
                                -25.5499,
                                70.62161
                            ],
                            [
                                -25.27025,
                                70.65777
                            ],
                            [
                                -25.29362,
                                70.74751
                            ],
                            [
                                -25.3797,
                                70.83093
                            ],
                            [
                                -25.36744,
                                70.90229
                            ],
                            [
                                -25.53244,
                                70.96681
                            ],
                            [
                                -25.71195,
                                70.98754
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -24.68744,
                                73.4282
                            ],
                            [
                                -25.25108,
                                73.40851
                            ],
                            [
                                -25.28633,
                                73.32514
                            ],
                            [
                                -25.43283,
                                73.30164
                            ],
                            [
                                -25.75153,
                                73.19711
                            ],
                            [
                                -25.4082,
                                73.11064
                            ],
                            [
                                -25.11482,
                                73.1129
                            ],
                            [
                                -24.70976,
                                73.04283
                            ],
                            [
                                -24.41015,
                                73.02264
                            ],
                            [
                                -23.01814,
                                73.09401
                            ],
                            [
                                -22.92617,
                                73.14574
                            ],
                            [
                                -23.42785,
                                73.19599
                            ],
                            [
                                -23.68807,
                                73.18917
                            ],
                            [
                                -24.31305,
                                73.25696
                            ],
                            [
                                -24.23295,
                                73.29736
                            ],
                            [
                                -23.89625,
                                73.24144
                            ],
                            [
                                -23.58282,
                                73.22099
                            ],
                            [
                                -23.38629,
                                73.27042
                            ],
                            [
                                -23.78247,
                                73.35682
                            ],
                            [
                                -24.68744,
                                73.4282
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -23.2132,
                                73.06448
                            ],
                            [
                                -23.61078,
                                73.02678
                            ],
                            [
                                -24.55989,
                                72.9835
                            ],
                            [
                                -24.5323,
                                72.89141
                            ],
                            [
                                -23.9549,
                                72.90861
                            ],
                            [
                                -23.5854,
                                72.86312
                            ],
                            [
                                -23.14559,
                                72.87017
                            ],
                            [
                                -22.7967,
                                72.81121
                            ],
                            [
                                -22.74327,
                                72.74329
                            ],
                            [
                                -22.53421,
                                72.7028
                            ],
                            [
                                -21.89043,
                                72.71012
                            ],
                            [
                                -22.04215,
                                72.84151
                            ],
                            [
                                -21.92183,
                                72.91578
                            ],
                            [
                                -22.16247,
                                72.93305
                            ],
                            [
                                -22.21838,
                                72.96653
                            ],
                            [
                                -22.83105,
                                73.03737
                            ],
                            [
                                -23.2132,
                                73.06448
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -17.81052,
                                75.312
                            ],
                            [
                                -18.04115,
                                75.42573
                            ],
                            [
                                -18.11869,
                                75.33767
                            ],
                            [
                                -18.32078,
                                75.30696
                            ],
                            [
                                -18.49987,
                                75.37146
                            ],
                            [
                                -18.68581,
                                75.3605
                            ],
                            [
                                -18.8432,
                                75.30204
                            ],
                            [
                                -18.82122,
                                75.20972
                            ],
                            [
                                -18.89319,
                                75.01065
                            ],
                            [
                                -18.44893,
                                74.96726
                            ],
                            [
                                -18.24737,
                                75.00781
                            ],
                            [
                                -17.83942,
                                75.02721
                            ],
                            [
                                -17.52084,
                                74.95419
                            ],
                            [
                                -17.34728,
                                75.025
                            ],
                            [
                                -17.36404,
                                75.08421
                            ],
                            [
                                -17.5643,
                                75.10765
                            ],
                            [
                                -17.84195,
                                75.09158
                            ],
                            [
                                -18.0183,
                                75.15532
                            ],
                            [
                                -18.03908,
                                75.25376
                            ],
                            [
                                -17.81052,
                                75.312
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -52.21683,
                                81.91315
                            ],
                            [
                                -52.12407,
                                81.92915
                            ],
                            [
                                -52.76852,
                                82.08383
                            ],
                            [
                                -53.37693,
                                82.16923
                            ],
                            [
                                -53.41645,
                                82.23093
                            ],
                            [
                                -53.84872,
                                82.2941
                            ],
                            [
                                -54.24306,
                                82.19612
                            ],
                            [
                                -54.04201,
                                82.06647
                            ],
                            [
                                -53.36696,
                                81.99999
                            ],
                            [
                                -52.89732,
                                81.92816
                            ],
                            [
                                -52.21683,
                                81.91315
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -46.51182,
                                83.00257
                            ],
                            [
                                -47.29422,
                                82.9924
                            ],
                            [
                                -47.54396,
                                82.89569
                            ],
                            [
                                -47.18078,
                                82.81488
                            ],
                            [
                                -46.83185,
                                82.78673
                            ],
                            [
                                -45.57356,
                                82.79973
                            ],
                            [
                                -45.89301,
                                82.87756
                            ],
                            [
                                -45.75944,
                                82.91018
                            ],
                            [
                                -46.51182,
                                83.00257
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -20.137,
                                74.8971
                            ],
                            [
                                -19.96387,
                                74.98223
                            ],
                            [
                                -20.21844,
                                75.03506
                            ],
                            [
                                -20.38349,
                                75.04107
                            ],
                            [
                                -20.58958,
                                74.98532
                            ],
                            [
                                -20.5301,
                                74.94177
                            ],
                            [
                                -20.66259,
                                74.81455
                            ],
                            [
                                -20.46004,
                                74.73713
                            ],
                            [
                                -20.05917,
                                74.70678
                            ],
                            [
                                -19.85939,
                                74.78458
                            ],
                            [
                                -19.74761,
                                74.86593
                            ],
                            [
                                -20.02875,
                                74.92438
                            ],
                            [
                                -20.137,
                                74.8971
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -19.00677,
                                76.72021
                            ],
                            [
                                -19.13736,
                                76.6918
                            ],
                            [
                                -19.03293,
                                76.58572
                            ],
                            [
                                -19.1507,
                                76.48936
                            ],
                            [
                                -18.83154,
                                76.25455
                            ],
                            [
                                -18.56703,
                                76.0014
                            ],
                            [
                                -18.47667,
                                76.09808
                            ],
                            [
                                -18.55872,
                                76.16708
                            ],
                            [
                                -18.75125,
                                76.50377
                            ],
                            [
                                -18.75675,
                                76.64242
                            ],
                            [
                                -19.00677,
                                76.72021
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -18.65627,
                                81.91075
                            ],
                            [
                                -19.27045,
                                82.12947
                            ],
                            [
                                -19.51016,
                                82.09925
                            ],
                            [
                                -19.59152,
                                82.02371
                            ],
                            [
                                -19.04394,
                                81.82048
                            ],
                            [
                                -18.57045,
                                81.8076
                            ],
                            [
                                -18.65627,
                                81.91075
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -41.18421,
                                83.32079
                            ],
                            [
                                -41.55252,
                                83.30123
                            ],
                            [
                                -41.56756,
                                83.24692
                            ],
                            [
                                -40.87353,
                                83.23196
                            ],
                            [
                                -40.37482,
                                83.14448
                            ],
                            [
                                -39.5357,
                                83.08987
                            ],
                            [
                                -39.52449,
                                83.15865
                            ],
                            [
                                -40.3491,
                                83.21688
                            ],
                            [
                                -40.52351,
                                83.27066
                            ],
                            [
                                -41.18421,
                                83.32079
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -51.57761,
                                67.93127
                            ],
                            [
                                -51.81007,
                                67.92432
                            ],
                            [
                                -51.94348,
                                67.87847
                            ],
                            [
                                -52.15773,
                                67.8906
                            ],
                            [
                                -52.36082,
                                67.823
                            ],
                            [
                                -52.19346,
                                67.77078
                            ],
                            [
                                -51.99575,
                                67.76009
                            ],
                            [
                                -51.74728,
                                67.68469
                            ],
                            [
                                -51.56791,
                                67.74114
                            ],
                            [
                                -51.46292,
                                67.72675
                            ],
                            [
                                -51.31335,
                                67.79861
                            ],
                            [
                                -51.57761,
                                67.93127
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -51.06228,
                                69.92689
                            ],
                            [
                                -51.21065,
                                69.90657
                            ],
                            [
                                -51.32635,
                                69.68816
                            ],
                            [
                                -51.23343,
                                69.52566
                            ],
                            [
                                -51.10863,
                                69.50983
                            ],
                            [
                                -50.96361,
                                69.56079
                            ],
                            [
                                -50.985,
                                69.73498
                            ],
                            [
                                -50.68914,
                                69.84389
                            ],
                            [
                                -51.06228,
                                69.92689
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -37.55272,
                                65.88165
                            ],
                            [
                                -37.76206,
                                65.87351
                            ],
                            [
                                -37.90898,
                                65.79254
                            ],
                            [
                                -37.94855,
                                65.69867
                            ],
                            [
                                -37.90463,
                                65.60483
                            ],
                            [
                                -37.66792,
                                65.57293
                            ],
                            [
                                -37.4865,
                                65.59947
                            ],
                            [
                                -37.30466,
                                65.68745
                            ],
                            [
                                -37.39634,
                                65.73436
                            ],
                            [
                                -37.33915,
                                65.77295
                            ],
                            [
                                -37.55272,
                                65.88165
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -52.88198,
                                71.37732
                            ],
                            [
                                -53.1757,
                                71.33206
                            ],
                            [
                                -53.1499,
                                71.23931
                            ],
                            [
                                -52.97453,
                                71.15482
                            ],
                            [
                                -52.6297,
                                71.16637
                            ],
                            [
                                -52.50177,
                                71.25563
                            ],
                            [
                                -52.35809,
                                71.27005
                            ],
                            [
                                -52.40105,
                                71.33995
                            ],
                            [
                                -52.88198,
                                71.37732
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -39.9613,
                                83.04084
                            ],
                            [
                                -40.01744,
                                83.07328
                            ],
                            [
                                -40.83913,
                                83.13707
                            ],
                            [
                                -41.35242,
                                83.14364
                            ],
                            [
                                -41.14286,
                                83.06307
                            ],
                            [
                                -40.15968,
                                82.976
                            ],
                            [
                                -39.9613,
                                83.04084
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -41.96587,
                                83.14364
                            ],
                            [
                                -42.28052,
                                83.11981
                            ],
                            [
                                -41.27809,
                                82.96468
                            ],
                            [
                                -40.56663,
                                82.94493
                            ],
                            [
                                -40.83239,
                                83.0242
                            ],
                            [
                                -41.1014,
                                83.03154
                            ],
                            [
                                -41.96587,
                                83.14364
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -44.08467,
                                60.16725
                            ],
                            [
                                -44.125,
                                60.09969
                            ],
                            [
                                -43.98394,
                                60.06301
                            ],
                            [
                                -43.92378,
                                60.00147
                            ],
                            [
                                -43.8145,
                                59.95567
                            ],
                            [
                                -43.52526,
                                59.93856
                            ],
                            [
                                -43.47839,
                                60.03995
                            ],
                            [
                                -43.3413,
                                60.02413
                            ],
                            [
                                -43.21556,
                                59.97973
                            ],
                            [
                                -43.132,
                                60.04639
                            ],
                            [
                                -43.24194,
                                60.06872
                            ],
                            [
                                -43.58576,
                                60.10017
                            ],
                            [
                                -43.75627,
                                60.13647
                            ],
                            [
                                -44.08467,
                                60.16725
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -72.19169,
                                77.45479
                            ],
                            [
                                -72.51768,
                                77.412
                            ],
                            [
                                -72.35719,
                                77.36401
                            ],
                            [
                                -72.10707,
                                77.35095
                            ],
                            [
                                -72.01281,
                                77.30694
                            ],
                            [
                                -71.68124,
                                77.31106
                            ],
                            [
                                -71.34412,
                                77.35458
                            ],
                            [
                                -72.19169,
                                77.45479
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -53.56554,
                                71.03449
                            ],
                            [
                                -53.42361,
                                71.06886
                            ],
                            [
                                -53.41233,
                                71.12146
                            ],
                            [
                                -53.6224,
                                71.30304
                            ],
                            [
                                -53.85726,
                                71.22971
                            ],
                            [
                                -53.99634,
                                71.13788
                            ],
                            [
                                -53.97379,
                                71.10536
                            ],
                            [
                                -53.70131,
                                71.0329
                            ],
                            [
                                -53.56554,
                                71.03449
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -17.6085,
                                77.86138
                            ],
                            [
                                -17.8298,
                                77.83001
                            ],
                            [
                                -17.83636,
                                77.75804
                            ],
                            [
                                -18.0287,
                                77.6954
                            ],
                            [
                                -18.10158,
                                77.6225
                            ],
                            [
                                -17.69814,
                                77.61921
                            ],
                            [
                                -17.44986,
                                77.7891
                            ],
                            [
                                -17.6085,
                                77.86138
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -19.22389,
                                80.21225
                            ],
                            [
                                -19.49038,
                                80.16944
                            ],
                            [
                                -19.7017,
                                80.02352
                            ],
                            [
                                -19.41966,
                                80.03587
                            ],
                            [
                                -18.66522,
                                80.13063
                            ],
                            [
                                -19.22389,
                                80.21225
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -55.16266,
                                72.852
                            ],
                            [
                                -55.81204,
                                72.64684
                            ],
                            [
                                -55.54562,
                                72.60033
                            ],
                            [
                                -55.33653,
                                72.61415
                            ],
                            [
                                -55.21535,
                                72.71162
                            ],
                            [
                                -55.11631,
                                72.71877
                            ],
                            [
                                -54.93162,
                                72.82055
                            ],
                            [
                                -55.16266,
                                72.852
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -40.73488,
                                64.93362
                            ],
                            [
                                -40.85228,
                                64.9233
                            ],
                            [
                                -40.8223,
                                64.84285
                            ],
                            [
                                -40.56328,
                                64.67528
                            ],
                            [
                                -40.48373,
                                64.53578
                            ],
                            [
                                -40.50932,
                                64.48172
                            ],
                            [
                                -40.21113,
                                64.42813
                            ],
                            [
                                -40.17635,
                                64.48505
                            ],
                            [
                                -40.44895,
                                64.55123
                            ],
                            [
                                -40.35532,
                                64.63353
                            ],
                            [
                                -40.49969,
                                64.67467
                            ],
                            [
                                -40.50683,
                                64.83087
                            ],
                            [
                                -40.73488,
                                64.93362
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -48.81247,
                                82.82489
                            ],
                            [
                                -49.15795,
                                82.79875
                            ],
                            [
                                -49.00925,
                                82.72032
                            ],
                            [
                                -48.39008,
                                82.70904
                            ],
                            [
                                -48.18917,
                                82.76307
                            ],
                            [
                                -48.81247,
                                82.82489
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -20.12456,
                                77.91066
                            ],
                            [
                                -20.33683,
                                77.8764
                            ],
                            [
                                -19.65346,
                                77.76979
                            ],
                            [
                                -19.19261,
                                77.74695
                            ],
                            [
                                -19.24301,
                                77.83198
                            ],
                            [
                                -19.62624,
                                77.83505
                            ],
                            [
                                -19.76975,
                                77.88132
                            ],
                            [
                                -20.12456,
                                77.91066
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -41.76143,
                                63.48936
                            ],
                            [
                                -41.88847,
                                63.46418
                            ],
                            [
                                -41.81726,
                                63.39325
                            ],
                            [
                                -41.61772,
                                63.32627
                            ],
                            [
                                -41.46067,
                                63.23023
                            ],
                            [
                                -41.17476,
                                63.2142
                            ],
                            [
                                -41.12684,
                                63.24732
                            ],
                            [
                                -41.24312,
                                63.32371
                            ],
                            [
                                -41.61242,
                                63.41282
                            ],
                            [
                                -41.76143,
                                63.48936
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -17.83221,
                                81.72216
                            ],
                            [
                                -18.15333,
                                81.70055
                            ],
                            [
                                -17.63089,
                                81.56962
                            ],
                            [
                                -17.37029,
                                81.60284
                            ],
                            [
                                -17.60702,
                                81.70672
                            ],
                            [
                                -17.83221,
                                81.72216
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -70.9929,
                                77.46702
                            ],
                            [
                                -71.25405,
                                77.45052
                            ],
                            [
                                -70.95951,
                                77.37219
                            ],
                            [
                                -70.07056,
                                77.39641
                            ],
                            [
                                -70.71202,
                                77.46455
                            ],
                            [
                                -70.9929,
                                77.46702
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -54.97872,
                                72.3755
                            ],
                            [
                                -55.50551,
                                72.26922
                            ],
                            [
                                -55.68268,
                                72.20957
                            ],
                            [
                                -55.41379,
                                72.16498
                            ],
                            [
                                -55.11799,
                                72.26518
                            ],
                            [
                                -54.97872,
                                72.3755
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -17.69321,
                                79.15594
                            ],
                            [
                                -17.82055,
                                79.17218
                            ],
                            [
                                -18.10648,
                                79.02553
                            ],
                            [
                                -18.07621,
                                78.9669
                            ],
                            [
                                -17.70881,
                                79.0108
                            ],
                            [
                                -17.58239,
                                79.07681
                            ],
                            [
                                -17.69321,
                                79.15594
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -53.15438,
                                71.67181
                            ],
                            [
                                -53.4564,
                                71.66355
                            ],
                            [
                                -53.45939,
                                71.58009
                            ],
                            [
                                -53.1081,
                                71.55054
                            ],
                            [
                                -53.08804,
                                71.58401
                            ],
                            [
                                -52.8636,
                                71.62201
                            ],
                            [
                                -52.8971,
                                71.66238
                            ],
                            [
                                -53.15438,
                                71.67181
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -40.17221,
                                83.40458
                            ],
                            [
                                -40.50668,
                                83.33166
                            ],
                            [
                                -39.96572,
                                83.27607
                            ],
                            [
                                -39.71887,
                                83.29064
                            ],
                            [
                                -40.17221,
                                83.40458
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -56.39364,
                                73.8944
                            ],
                            [
                                -56.60765,
                                73.92672
                            ],
                            [
                                -56.72757,
                                73.88509
                            ],
                            [
                                -56.60577,
                                73.81103
                            ],
                            [
                                -56.32686,
                                73.78783
                            ],
                            [
                                -55.93398,
                                73.85396
                            ],
                            [
                                -56.39364,
                                73.8944
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -51.49571,
                                68.25498
                            ],
                            [
                                -51.8649,
                                68.21693
                            ],
                            [
                                -52.03264,
                                68.21469
                            ],
                            [
                                -52.32649,
                                68.15346
                            ],
                            [
                                -52.21097,
                                68.11157
                            ],
                            [
                                -51.88649,
                                68.1278
                            ],
                            [
                                -51.80189,
                                68.16841
                            ],
                            [
                                -51.54824,
                                68.19489
                            ],
                            [
                                -51.49571,
                                68.25498
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -50.95528,
                                64.54105
                            ],
                            [
                                -51.0497,
                                64.53826
                            ],
                            [
                                -51.08373,
                                64.43368
                            ],
                            [
                                -51.18851,
                                64.39186
                            ],
                            [
                                -51.28008,
                                64.26163
                            ],
                            [
                                -51.16693,
                                64.24515
                            ],
                            [
                                -50.99536,
                                64.40625
                            ],
                            [
                                -50.878,
                                64.4498
                            ],
                            [
                                -50.82543,
                                64.50957
                            ],
                            [
                                -50.95528,
                                64.54105
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -43.88795,
                                59.92852
                            ],
                            [
                                -43.97472,
                                59.97335
                            ],
                            [
                                -44.11846,
                                59.87403
                            ],
                            [
                                -44.11953,
                                59.80381
                            ],
                            [
                                -43.90749,
                                59.77864
                            ],
                            [
                                -43.76733,
                                59.8094
                            ],
                            [
                                -43.64686,
                                59.86302
                            ],
                            [
                                -43.80968,
                                59.92967
                            ],
                            [
                                -43.88795,
                                59.92852
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -56.47691,
                                74.52757
                            ],
                            [
                                -56.72392,
                                74.5583
                            ],
                            [
                                -56.88469,
                                74.53028
                            ],
                            [
                                -57.3304,
                                74.51421
                            ],
                            [
                                -57.10599,
                                74.47138
                            ],
                            [
                                -56.76726,
                                74.49359
                            ],
                            [
                                -56.54487,
                                74.47945
                            ],
                            [
                                -56.47691,
                                74.52757
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -27.33253,
                                70.87211
                            ],
                            [
                                -27.58068,
                                70.87565
                            ],
                            [
                                -27.72357,
                                70.84038
                            ],
                            [
                                -27.67357,
                                70.71523
                            ],
                            [
                                -27.33577,
                                70.79496
                            ],
                            [
                                -27.33253,
                                70.87211
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -18.86326,
                                74.674
                            ],
                            [
                                -19.22741,
                                74.5815
                            ],
                            [
                                -19.1405,
                                74.54509
                            ],
                            [
                                -18.80928,
                                74.53558
                            ],
                            [
                                -18.72652,
                                74.58395
                            ],
                            [
                                -18.86326,
                                74.674
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -52.02904,
                                70.98213
                            ],
                            [
                                -52.13246,
                                70.9664
                            ],
                            [
                                -52.1672,
                                70.88905
                            ],
                            [
                                -51.67119,
                                70.84237
                            ],
                            [
                                -51.71309,
                                70.90068
                            ],
                            [
                                -52.02904,
                                70.98213
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -47.9492,
                                60.82653
                            ],
                            [
                                -48.15343,
                                60.79396
                            ],
                            [
                                -48.17117,
                                60.73136
                            ],
                            [
                                -48.06005,
                                60.6816
                            ],
                            [
                                -47.9682,
                                60.67922
                            ],
                            [
                                -47.79136,
                                60.73799
                            ],
                            [
                                -47.85169,
                                60.8114
                            ],
                            [
                                -47.9492,
                                60.82653
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -42.24545,
                                62.80112
                            ],
                            [
                                -42.38688,
                                62.7795
                            ],
                            [
                                -42.43643,
                                62.71621
                            ],
                            [
                                -42.37409,
                                62.69058
                            ],
                            [
                                -42.04339,
                                62.6691
                            ],
                            [
                                -41.99407,
                                62.75721
                            ],
                            [
                                -42.24545,
                                62.80112
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -19.88029,
                                81.67794
                            ],
                            [
                                -19.9076,
                                81.56081
                            ],
                            [
                                -19.45715,
                                81.55948
                            ],
                            [
                                -19.60892,
                                81.65154
                            ],
                            [
                                -19.88029,
                                81.67794
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -24.81836,
                                72.88051
                            ],
                            [
                                -24.91352,
                                72.90711
                            ],
                            [
                                -25.13757,
                                72.88364
                            ],
                            [
                                -25.1771,
                                72.8198
                            ],
                            [
                                -24.86942,
                                72.77513
                            ],
                            [
                                -24.91884,
                                72.86363
                            ],
                            [
                                -24.81836,
                                72.88051
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -55.71625,
                                72.76497
                            ],
                            [
                                -55.95266,
                                72.75366
                            ],
                            [
                                -56.18347,
                                72.70511
                            ],
                            [
                                -56.06473,
                                72.66221
                            ],
                            [
                                -55.86927,
                                72.66639
                            ],
                            [
                                -55.68512,
                                72.70872
                            ],
                            [
                                -55.71625,
                                72.76497
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -51.40513,
                                68.14005
                            ],
                            [
                                -51.70141,
                                68.12266
                            ],
                            [
                                -51.92648,
                                68.0652
                            ],
                            [
                                -51.30025,
                                68.08554
                            ],
                            [
                                -51.40513,
                                68.14005
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -21.35259,
                                76.63897
                            ],
                            [
                                -21.58742,
                                76.59884
                            ],
                            [
                                -21.21666,
                                76.5433
                            ],
                            [
                                -21.07502,
                                76.63183
                            ],
                            [
                                -21.35259,
                                76.63897
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -52.99086,
                                65.6479
                            ],
                            [
                                -53.16449,
                                65.62501
                            ],
                            [
                                -53.24106,
                                65.5883
                            ],
                            [
                                -53.0601,
                                65.5232
                            ],
                            [
                                -52.90727,
                                65.56209
                            ],
                            [
                                -52.82959,
                                65.63556
                            ],
                            [
                                -52.99086,
                                65.6479
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -20.75081,
                                76.49543
                            ],
                            [
                                -20.91803,
                                76.51293
                            ],
                            [
                                -21.06187,
                                76.44072
                            ],
                            [
                                -21.01029,
                                76.39208
                            ],
                            [
                                -20.77468,
                                76.39019
                            ],
                            [
                                -20.75081,
                                76.49543
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -44.39199,
                                60.13517
                            ],
                            [
                                -44.4482,
                                60.12802
                            ],
                            [
                                -44.51015,
                                60.01162
                            ],
                            [
                                -44.3052,
                                59.9741
                            ],
                            [
                                -44.19865,
                                60.03408
                            ],
                            [
                                -44.31919,
                                60.12376
                            ],
                            [
                                -44.39199,
                                60.13517
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -45.31798,
                                60.38317
                            ],
                            [
                                -45.37164,
                                60.36875
                            ],
                            [
                                -45.337,
                                60.18886
                            ],
                            [
                                -45.18111,
                                60.25438
                            ],
                            [
                                -45.1415,
                                60.355
                            ],
                            [
                                -45.31798,
                                60.38317
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -51.1039,
                                64.54991
                            ],
                            [
                                -51.34272,
                                64.48376
                            ],
                            [
                                -51.45459,
                                64.37429
                            ],
                            [
                                -51.29789,
                                64.36079
                            ],
                            [
                                -51.1039,
                                64.54991
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -44.16583,
                                60.01434
                            ],
                            [
                                -44.24251,
                                60.00015
                            ],
                            [
                                -44.37215,
                                59.89023
                            ],
                            [
                                -44.31057,
                                59.85792
                            ],
                            [
                                -44.1171,
                                59.90521
                            ],
                            [
                                -44.02811,
                                60.01
                            ],
                            [
                                -44.16583,
                                60.01434
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -69.51515,
                                76.61027
                            ],
                            [
                                -69.95515,
                                76.5947
                            ],
                            [
                                -69.95726,
                                76.54992
                            ],
                            [
                                -69.54085,
                                76.54688
                            ],
                            [
                                -69.51515,
                                76.61027
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -46.22219,
                                60.91321
                            ],
                            [
                                -46.27118,
                                60.93143
                            ],
                            [
                                -46.66888,
                                60.81311
                            ],
                            [
                                -46.61157,
                                60.76477
                            ],
                            [
                                -46.45488,
                                60.81942
                            ],
                            [
                                -46.3585,
                                60.82902
                            ],
                            [
                                -46.22219,
                                60.91321
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -40.74498,
                                64.29199
                            ],
                            [
                                -40.90062,
                                64.29552
                            ],
                            [
                                -41.07827,
                                64.22266
                            ],
                            [
                                -41.00846,
                                64.19841
                            ],
                            [
                                -40.75066,
                                64.19959
                            ],
                            [
                                -40.74498,
                                64.29199
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -55.47914,
                                71.93335
                            ],
                            [
                                -55.76395,
                                71.90173
                            ],
                            [
                                -55.6028,
                                71.82756
                            ],
                            [
                                -55.47022,
                                71.8474
                            ],
                            [
                                -55.47914,
                                71.93335
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -46.87183,
                                60.917
                            ],
                            [
                                -47.06899,
                                60.85946
                            ],
                            [
                                -47.05332,
                                60.82142
                            ],
                            [
                                -46.87952,
                                60.78871
                            ],
                            [
                                -46.71148,
                                60.84098
                            ],
                            [
                                -46.71421,
                                60.88491
                            ],
                            [
                                -46.87183,
                                60.917
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -23.27712,
                                69.75577
                            ],
                            [
                                -23.58004,
                                69.71245
                            ],
                            [
                                -23.53618,
                                69.67702
                            ],
                            [
                                -23.29601,
                                69.64824
                            ],
                            [
                                -23.19291,
                                69.6823
                            ],
                            [
                                -23.27712,
                                69.75577
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -52.93902,
                                68.46016
                            ],
                            [
                                -53.01116,
                                68.50302
                            ],
                            [
                                -53.23542,
                                68.4131
                            ],
                            [
                                -53.12485,
                                68.37056
                            ],
                            [
                                -52.96115,
                                68.36898
                            ],
                            [
                                -52.87341,
                                68.41789
                            ],
                            [
                                -52.93902,
                                68.46016
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -56.39037,
                                73.70251
                            ],
                            [
                                -56.84373,
                                73.65176
                            ],
                            [
                                -56.5905,
                                73.6214
                            ],
                            [
                                -56.32245,
                                73.66579
                            ],
                            [
                                -56.39037,
                                73.70251
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -54.88799,
                                70.47284
                            ],
                            [
                                -55.03626,
                                70.44143
                            ],
                            [
                                -54.94862,
                                70.38427
                            ],
                            [
                                -54.6829,
                                70.37835
                            ],
                            [
                                -54.72329,
                                70.42819
                            ],
                            [
                                -54.88799,
                                70.47284
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -51.83107,
                                70.73683
                            ],
                            [
                                -51.93102,
                                70.6658
                            ],
                            [
                                -51.47798,
                                70.6665
                            ],
                            [
                                -51.83107,
                                70.73683
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -19.00593,
                                78.26609
                            ],
                            [
                                -19.28424,
                                78.24261
                            ],
                            [
                                -19.15139,
                                78.17822
                            ],
                            [
                                -18.83313,
                                78.24551
                            ],
                            [
                                -19.00593,
                                78.26609
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -52.92322,
                                66.902
                            ],
                            [
                                -53.1927,
                                66.90101
                            ],
                            [
                                -53.4051,
                                66.87098
                            ],
                            [
                                -53.39538,
                                66.81537
                            ],
                            [
                                -53.18172,
                                66.82714
                            ],
                            [
                                -52.92322,
                                66.902
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -37.05713,
                                65.71628
                            ],
                            [
                                -37.2031,
                                65.68495
                            ],
                            [
                                -37.10333,
                                65.59359
                            ],
                            [
                                -36.92085,
                                65.6318
                            ],
                            [
                                -37.05713,
                                65.71628
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -36.52695,
                                65.89307
                            ],
                            [
                                -36.62998,
                                65.93942
                            ],
                            [
                                -36.73922,
                                65.90325
                            ],
                            [
                                -36.65778,
                                65.83167
                            ],
                            [
                                -36.52695,
                                65.89307
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -55.65031,
                                73.49116
                            ],
                            [
                                -55.70331,
                                73.41195
                            ],
                            [
                                -55.45043,
                                73.43949
                            ],
                            [
                                -55.65031,
                                73.49116
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -26.15969,
                                70.5252
                            ],
                            [
                                -26.3222,
                                70.53854
                            ],
                            [
                                -26.36799,
                                70.48661
                            ],
                            [
                                -26.26724,
                                70.44626
                            ],
                            [
                                -26.09707,
                                70.48381
                            ],
                            [
                                -26.15969,
                                70.5252
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -56.01311,
                                73.41198
                            ],
                            [
                                -56.1026,
                                73.31526
                            ],
                            [
                                -55.9025,
                                73.3083
                            ],
                            [
                                -55.81979,
                                73.38059
                            ],
                            [
                                -56.01311,
                                73.41198
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -29.86297,
                                68.24519
                            ],
                            [
                                -30.02057,
                                68.24957
                            ],
                            [
                                -30.02537,
                                68.19695
                            ],
                            [
                                -29.80877,
                                68.18191
                            ],
                            [
                                -29.86297,
                                68.24519
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -55.00421,
                                72.59557
                            ],
                            [
                                -55.25143,
                                72.58085
                            ],
                            [
                                -55.33846,
                                72.53493
                            ],
                            [
                                -55.01283,
                                72.53096
                            ],
                            [
                                -55.00421,
                                72.59557
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -53.36963,
                                68.10625
                            ],
                            [
                                -53.53494,
                                68.04565
                            ],
                            [
                                -53.36367,
                                67.99917
                            ],
                            [
                                -53.24697,
                                68.03727
                            ],
                            [
                                -53.36963,
                                68.10625
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -18.54272,
                                74.70834
                            ],
                            [
                                -18.49014,
                                74.62309
                            ],
                            [
                                -18.32386,
                                74.63763
                            ],
                            [
                                -18.54272,
                                74.70834
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -55.05463,
                                72.69483
                            ],
                            [
                                -55.19467,
                                72.67711
                            ],
                            [
                                -55.04678,
                                72.60898
                            ],
                            [
                                -54.88401,
                                72.67577
                            ],
                            [
                                -55.05463,
                                72.69483
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -47.95278,
                                60.90478
                            ],
                            [
                                -48.19287,
                                60.85879
                            ],
                            [
                                -48.20577,
                                60.80111
                            ],
                            [
                                -48.02237,
                                60.82273
                            ],
                            [
                                -47.95278,
                                60.90478
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -51.38708,
                                64.33019
                            ],
                            [
                                -51.46048,
                                64.34018
                            ],
                            [
                                -51.59838,
                                64.27599
                            ],
                            [
                                -51.55741,
                                64.24023
                            ],
                            [
                                -51.40968,
                                64.25757
                            ],
                            [
                                -51.38708,
                                64.33019
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -36.76181,
                                65.82243
                            ],
                            [
                                -36.84887,
                                65.85104
                            ],
                            [
                                -36.92931,
                                65.76759
                            ],
                            [
                                -36.79673,
                                65.7427
                            ],
                            [
                                -36.76181,
                                65.82243
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -50.54995,
                                63.18497
                            ],
                            [
                                -50.68441,
                                63.1211
                            ],
                            [
                                -50.49087,
                                63.11832
                            ],
                            [
                                -50.54995,
                                63.18497
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -18.76421,
                                78.11473
                            ],
                            [
                                -19.1326,
                                78.07543
                            ],
                            [
                                -19.00354,
                                78.01606
                            ],
                            [
                                -18.76421,
                                78.11473
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -48.50791,
                                61.33935
                            ],
                            [
                                -48.70507,
                                61.36558
                            ],
                            [
                                -48.66297,
                                61.30219
                            ],
                            [
                                -48.50791,
                                61.33935
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -55.73984,
                                73.36814
                            ],
                            [
                                -55.78048,
                                73.28304
                            ],
                            [
                                -55.59689,
                                73.29911
                            ],
                            [
                                -55.73984,
                                73.36814
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -53.68597,
                                67.76944
                            ],
                            [
                                -53.79127,
                                67.74541
                            ],
                            [
                                -53.71731,
                                67.66439
                            ],
                            [
                                -53.58147,
                                67.70054
                            ],
                            [
                                -53.68597,
                                67.76944
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -52.87555,
                                65.47884
                            ],
                            [
                                -52.96181,
                                65.51968
                            ],
                            [
                                -53.08277,
                                65.48554
                            ],
                            [
                                -52.91412,
                                65.40384
                            ],
                            [
                                -52.87555,
                                65.47884
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -43.41183,
                                60.01735
                            ],
                            [
                                -43.4971,
                                59.94341
                            ],
                            [
                                -43.39064,
                                59.93122
                            ],
                            [
                                -43.33953,
                                60.00217
                            ],
                            [
                                -43.41183,
                                60.01735
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -42.16514,
                                62.56813
                            ],
                            [
                                -42.30437,
                                62.54911
                            ],
                            [
                                -42.26296,
                                62.48482
                            ],
                            [
                                -42.1375,
                                62.49722
                            ],
                            [
                                -42.16514,
                                62.56813
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -41.37548,
                                63.10034
                            ],
                            [
                                -41.48925,
                                63.09812
                            ],
                            [
                                -41.50598,
                                63.04438
                            ],
                            [
                                -41.34709,
                                63.04648
                            ],
                            [
                                -41.37548,
                                63.10034
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -45.92511,
                                60.69239
                            ],
                            [
                                -46.1942,
                                60.66825
                            ],
                            [
                                -46.0874,
                                60.62555
                            ],
                            [
                                -45.92511,
                                60.69239
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "GRD",
                "Country": "Grenada",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    9.7615e-09,
                    1.9278e-08,
                    2.8704e-08,
                    3.8048e-08,
                    4.7301e-08,
                    5.673e-08,
                    6.6293e-08,
                    7.5951e-08,
                    8.5809e-08,
                    9.5925e-08,
                    1.0626e-07,
                    1.1667e-07,
                    1.2721e-07,
                    1.3781e-07,
                    1.4849e-07,
                    1.5912e-07,
                    1.6981e-07,
                    1.8049e-07,
                    1.9115e-07,
                    2.0184e-07,
                    2.1278e-07,
                    2.2382e-07,
                    2.3491e-07,
                    2.4609e-07,
                    2.5732e-07,
                    2.6843e-07,
                    2.7939e-07,
                    2.902e-07,
                    3.0086e-07,
                    3.1139e-07,
                    3.2184e-07,
                    3.3238e-07,
                    3.4293e-07,
                    3.5334e-07,
                    3.6371e-07,
                    3.7405e-07,
                    3.8439e-07,
                    3.9471e-07,
                    4.051e-07,
                    4.159e-07,
                    4.267e-07,
                    4.3757e-07,
                    4.4855e-07,
                    4.5963e-07,
                    4.708e-07,
                    4.8198e-07,
                    4.9324e-07,
                    5.0462e-07,
                    5.1611e-07,
                    5.2756e-07,
                    5.3909e-07,
                    5.5051e-07,
                    5.6193e-07,
                    5.7345e-07,
                    5.8509e-07,
                    5.9685e-07,
                    6.0866e-07,
                    6.2056e-07,
                    6.3248e-07,
                    6.4219e-07,
                    6.5095e-07,
                    6.5908e-07,
                    6.6667e-07,
                    6.7373e-07,
                    6.8032e-07,
                    6.8646e-07,
                    6.9218e-07,
                    6.975e-07,
                    7.024e-07,
                    7.0763e-07,
                    7.1277e-07,
                    7.1784e-07,
                    7.2278e-07,
                    7.2753e-07,
                    7.321e-07,
                    7.3657e-07,
                    7.409e-07,
                    7.4513e-07,
                    7.4924e-07,
                    7.5337e-07,
                    7.5765e-07,
                    7.62e-07,
                    7.664e-07,
                    7.709e-07,
                    7.7549e-07,
                    7.8025e-07,
                    7.8519e-07,
                    7.9037e-07,
                    7.958e-07,
                    8.014e-07,
                    8.0742e-07,
                    8.1383e-07,
                    8.2057e-07,
                    8.2775e-07,
                    8.3588e-07,
                    8.4502e-07,
                    8.5519e-07,
                    8.6638e-07,
                    8.7858e-07,
                    8.945e-07,
                    9.1852e-07,
                    9.5097e-07,
                    9.9196e-07,
                    1.0401e-06,
                    1.0957e-06,
                    1.1575e-06,
                    1.2242e-06,
                    1.2959e-06,
                    1.3696e-06,
                    1.4324e-06,
                    1.4867e-06,
                    1.5398e-06,
                    1.5918e-06,
                    1.6469e-06,
                    1.703e-06,
                    1.7632e-06,
                    1.8248e-06,
                    1.8892e-06,
                    1.9548e-06,
                    2.0191e-06,
                    2.0818e-06,
                    2.1394e-06,
                    2.1994e-06,
                    2.2477e-06,
                    2.296e-06,
                    2.3458e-06,
                    2.3908e-06,
                    2.4376e-06,
                    2.4683e-06,
                    2.4963e-06,
                    2.532e-06,
                    2.5718e-06,
                    2.6082e-06,
                    2.6346e-06,
                    2.6583e-06,
                    2.6756e-06,
                    2.6952e-06,
                    2.7232e-06,
                    2.7546e-06,
                    2.783e-06,
                    2.8107e-06,
                    2.8475e-06,
                    2.8871e-06,
                    2.9362e-06,
                    2.9939e-06,
                    3.0526e-06,
                    3.1188e-06,
                    3.2246e-06,
                    3.3219e-06,
                    3.4494e-06,
                    3.556e-06,
                    3.6553e-06,
                    3.7578e-06,
                    3.8304e-06,
                    3.9121e-06,
                    4.0047e-06,
                    4.1023e-06,
                    4.2419e-06,
                    4.3662e-06,
                    4.4899e-06,
                    4.6099e-06,
                    4.7396e-06,
                    4.8833e-06,
                    4.9951e-06,
                    5.1187e-06,
                    5.2467e-06,
                    5.3796e-06,
                    5.526e-06,
                    5.6833e-06,
                    5.8219e-06,
                    5.9801e-06,
                    6.1449e-06
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    2.7069e-09,
                    5.2754e-09,
                    7.8288e-09,
                    1.0367e-08,
                    1.289e-08,
                    1.5574e-08,
                    1.8423e-08,
                    2.1442e-08,
                    2.4635e-08,
                    2.8008e-08,
                    3.1491e-08,
                    3.5077e-08,
                    3.8776e-08,
                    4.2583e-08,
                    4.6394e-08,
                    5.021e-08,
                    5.4032e-08,
                    5.7861e-08,
                    6.165e-08,
                    6.5402e-08,
                    6.9363e-08,
                    7.3477e-08,
                    7.7632e-08,
                    8.183e-08,
                    8.6054e-08,
                    9.0142e-08,
                    9.409e-08,
                    9.7877e-08,
                    1.015e-07,
                    1.0495e-07,
                    1.0829e-07,
                    1.1169e-07,
                    1.1507e-07,
                    1.1832e-07,
                    1.2152e-07,
                    1.2466e-07,
                    1.278e-07,
                    1.3091e-07,
                    1.3407e-07,
                    1.375e-07,
                    1.4092e-07,
                    1.4439e-07,
                    1.4793e-07,
                    1.5153e-07,
                    1.5519e-07,
                    1.589e-07,
                    1.6268e-07,
                    1.6653e-07,
                    1.7048e-07,
                    1.7425e-07,
                    1.7805e-07,
                    1.8173e-07,
                    1.8536e-07,
                    1.8903e-07,
                    1.9277e-07,
                    1.9659e-07,
                    2.0043e-07,
                    2.0432e-07,
                    2.0821e-07,
                    2.1189e-07,
                    2.1548e-07,
                    2.189e-07,
                    2.2216e-07,
                    2.2519e-07,
                    2.28e-07,
                    2.306e-07,
                    2.3297e-07,
                    2.3513e-07,
                    2.3705e-07,
                    2.3899e-07,
                    2.4077e-07,
                    2.425e-07,
                    2.4412e-07,
                    2.4561e-07,
                    2.4696e-07,
                    2.4826e-07,
                    2.4948e-07,
                    2.5065e-07,
                    2.5175e-07,
                    2.5282e-07,
                    2.5399e-07,
                    2.5519e-07,
                    2.5642e-07,
                    2.577e-07,
                    2.5903e-07,
                    2.6042e-07,
                    2.6187e-07,
                    2.6342e-07,
                    2.6512e-07,
                    2.6691e-07,
                    2.6901e-07,
                    2.7133e-07,
                    2.7378e-07,
                    2.7647e-07,
                    2.799e-07,
                    2.8413e-07,
                    2.892e-07,
                    2.9506e-07,
                    3.0174e-07,
                    3.1261e-07,
                    3.2589e-07,
                    3.4014e-07,
                    3.5558e-07,
                    3.7242e-07,
                    3.9084e-07,
                    4.1097e-07,
                    4.3292e-07,
                    4.5842e-07,
                    4.858e-07,
                    5.1847e-07,
                    5.5118e-07,
                    5.8891e-07,
                    6.2342e-07,
                    6.6296e-07,
                    7.0366e-07,
                    7.4865e-07,
                    7.9785e-07,
                    8.4952e-07,
                    9.0525e-07,
                    9.5858e-07,
                    1.017e-06,
                    1.0744e-06,
                    1.1338e-06,
                    1.1833e-06,
                    1.236e-06,
                    1.2864e-06,
                    1.3345e-06,
                    1.3816e-06,
                    1.425e-06,
                    1.4668e-06,
                    1.513e-06,
                    1.5609e-06,
                    1.6092e-06,
                    1.6578e-06,
                    1.7059e-06,
                    1.7545e-06,
                    1.8046e-06,
                    1.8625e-06,
                    1.9214e-06,
                    1.9818e-06,
                    2.0407e-06,
                    2.1038e-06,
                    2.1694e-06,
                    2.2466e-06,
                    2.3287e-06,
                    2.4145e-06,
                    2.5093e-06,
                    2.6097e-06,
                    2.7197e-06,
                    2.8293e-06,
                    2.9397e-06,
                    3.0538e-06,
                    3.1725e-06,
                    3.2844e-06,
                    3.4022e-06,
                    3.5264e-06,
                    3.655e-06,
                    3.7918e-06,
                    3.9289e-06,
                    4.0701e-06,
                    4.2079e-06,
                    4.3533e-06,
                    4.5143e-06,
                    4.6434e-06,
                    4.7841e-06,
                    4.9277e-06,
                    5.0753e-06,
                    5.2357e-06,
                    5.4047e-06,
                    5.5544e-06,
                    5.7236e-06,
                    5.8988e-06
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [
                    7.0547e-09,
                    1.4002e-08,
                    2.0876e-08,
                    2.7681e-08,
                    3.4411e-08,
                    4.1156e-08,
                    4.787e-08,
                    5.4509e-08,
                    6.1173e-08,
                    6.7917e-08,
                    7.4764e-08,
                    8.1595e-08,
                    8.843e-08,
                    9.5225e-08,
                    1.021e-07,
                    1.0891e-07,
                    1.1578e-07,
                    1.2263e-07,
                    1.295e-07,
                    1.3644e-07,
                    1.4342e-07,
                    1.5034e-07,
                    1.5728e-07,
                    1.6426e-07,
                    1.7126e-07,
                    1.7829e-07,
                    1.853e-07,
                    1.9232e-07,
                    1.9936e-07,
                    2.0644e-07,
                    2.1355e-07,
                    2.2069e-07,
                    2.2786e-07,
                    2.3501e-07,
                    2.4219e-07,
                    2.4939e-07,
                    2.5659e-07,
                    2.638e-07,
                    2.7103e-07,
                    2.784e-07,
                    2.8578e-07,
                    2.9319e-07,
                    3.0063e-07,
                    3.0811e-07,
                    3.1561e-07,
                    3.2308e-07,
                    3.3056e-07,
                    3.3809e-07,
                    3.4563e-07,
                    3.5331e-07,
                    3.6104e-07,
                    3.6878e-07,
                    3.7657e-07,
                    3.8442e-07,
                    3.9232e-07,
                    4.0026e-07,
                    4.0822e-07,
                    4.1624e-07,
                    4.2427e-07,
                    4.303e-07,
                    4.3547e-07,
                    4.4018e-07,
                    4.4451e-07,
                    4.4854e-07,
                    4.5232e-07,
                    4.5586e-07,
                    4.5921e-07,
                    4.6237e-07,
                    4.6535e-07,
                    4.6864e-07,
                    4.72e-07,
                    4.7535e-07,
                    4.7866e-07,
                    4.8192e-07,
                    4.8514e-07,
                    4.8831e-07,
                    4.9142e-07,
                    4.9448e-07,
                    4.9749e-07,
                    5.0055e-07,
                    5.0366e-07,
                    5.0681e-07,
                    5.0999e-07,
                    5.132e-07,
                    5.1645e-07,
                    5.1983e-07,
                    5.2333e-07,
                    5.2695e-07,
                    5.3069e-07,
                    5.3448e-07,
                    5.3841e-07,
                    5.425e-07,
                    5.4679e-07,
                    5.5127e-07,
                    5.5598e-07,
                    5.6089e-07,
                    5.66e-07,
                    5.7132e-07,
                    5.7683e-07,
                    5.819e-07,
                    5.9263e-07,
                    6.1083e-07,
                    6.3639e-07,
                    6.6772e-07,
                    7.0482e-07,
                    7.4652e-07,
                    7.9127e-07,
                    8.3747e-07,
                    8.8377e-07,
                    9.1395e-07,
                    9.355e-07,
                    9.5093e-07,
                    9.6834e-07,
                    9.8394e-07,
                    9.9936e-07,
                    1.0145e-06,
                    1.0269e-06,
                    1.0396e-06,
                    1.0495e-06,
                    1.0605e-06,
                    1.0648e-06,
                    1.065e-06,
                    1.0656e-06,
                    1.0644e-06,
                    1.06e-06,
                    1.0594e-06,
                    1.0563e-06,
                    1.056e-06,
                    1.0433e-06,
                    1.0295e-06,
                    1.0189e-06,
                    1.0109e-06,
                    9.9898e-07,
                    9.7686e-07,
                    9.5243e-07,
                    9.2111e-07,
                    8.9061e-07,
                    8.6073e-07,
                    8.3321e-07,
                    8.012e-07,
                    7.7001e-07,
                    7.4369e-07,
                    7.1776e-07,
                    6.8964e-07,
                    6.6521e-07,
                    6.3816e-07,
                    6.0944e-07,
                    6.1489e-07,
                    6.0223e-07,
                    6.2004e-07,
                    6.1638e-07,
                    6.0145e-07,
                    5.8533e-07,
                    5.46e-07,
                    5.0989e-07,
                    4.7833e-07,
                    4.4732e-07,
                    4.5014e-07,
                    4.3727e-07,
                    4.1978e-07,
                    4.0202e-07,
                    3.8627e-07,
                    3.6893e-07,
                    3.5177e-07,
                    3.3457e-07,
                    3.1901e-07,
                    3.0427e-07,
                    2.9021e-07,
                    2.7863e-07,
                    2.6756e-07,
                    2.5649e-07,
                    2.461e-07
                ],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    4.686e-09,
                    9.2565e-09,
                    1.3744e-08,
                    1.8156e-08,
                    2.2484e-08,
                    2.6818e-08,
                    3.1114e-08,
                    3.5327e-08,
                    3.9556e-08,
                    4.3857e-08,
                    4.8252e-08,
                    5.2619e-08,
                    5.698e-08,
                    6.1292e-08,
                    6.567e-08,
                    6.9982e-08,
                    7.4332e-08,
                    7.8661e-08,
                    8.299e-08,
                    8.7384e-08,
                    9.1812e-08,
                    9.6162e-08,
                    1.0052e-07,
                    1.049e-07,
                    1.093e-07,
                    1.137e-07,
                    1.1807e-07,
                    1.2244e-07,
                    1.2682e-07,
                    1.3122e-07,
                    1.3564e-07,
                    1.4009e-07,
                    1.4456e-07,
                    1.4899e-07,
                    1.5345e-07,
                    1.5791e-07,
                    1.6237e-07,
                    1.6683e-07,
                    1.713e-07,
                    1.7587e-07,
                    1.8043e-07,
                    1.8501e-07,
                    1.8961e-07,
                    1.9424e-07,
                    1.9887e-07,
                    2.0346e-07,
                    2.0803e-07,
                    2.1264e-07,
                    2.1723e-07,
                    2.2195e-07,
                    2.2669e-07,
                    2.3142e-07,
                    2.3616e-07,
                    2.4092e-07,
                    2.457e-07,
                    2.5047e-07,
                    2.5524e-07,
                    2.6002e-07,
                    2.648e-07,
                    2.6755e-07,
                    2.695e-07,
                    2.7105e-07,
                    2.7228e-07,
                    2.7328e-07,
                    2.7409e-07,
                    2.7472e-07,
                    2.7523e-07,
                    2.756e-07,
                    2.7587e-07,
                    2.765e-07,
                    2.7728e-07,
                    2.7811e-07,
                    2.7899e-07,
                    2.7988e-07,
                    2.8081e-07,
                    2.8175e-07,
                    2.8272e-07,
                    2.8371e-07,
                    2.8472e-07,
                    2.8585e-07,
                    2.8702e-07,
                    2.8823e-07,
                    2.8945e-07,
                    2.907e-07,
                    2.9198e-07,
                    2.9327e-07,
                    2.9457e-07,
                    2.959e-07,
                    2.9723e-07,
                    2.9852e-07,
                    2.9981e-07,
                    3.0112e-07,
                    3.0243e-07,
                    3.0376e-07,
                    3.051e-07,
                    3.0643e-07,
                    3.0775e-07,
                    3.091e-07,
                    3.1046e-07,
                    3.1453e-07,
                    3.2579e-07,
                    3.4418e-07,
                    3.6943e-07,
                    3.9981e-07,
                    4.3523e-07,
                    4.7451e-07,
                    5.1611e-07,
                    5.6007e-07,
                    6.0344e-07,
                    6.3335e-07,
                    6.5526e-07,
                    6.7732e-07,
                    6.9263e-07,
                    7.0979e-07,
                    7.2601e-07,
                    7.4469e-07,
                    7.6576e-07,
                    7.879e-07,
                    8.129e-07,
                    8.3584e-07,
                    8.5331e-07,
                    8.7061e-07,
                    8.9073e-07,
                    9.0291e-07,
                    9.2003e-07,
                    9.3703e-07,
                    9.4966e-07,
                    9.6429e-07,
                    9.6589e-07,
                    9.6809e-07,
                    9.7667e-07,
                    9.8752e-07,
                    9.9892e-07,
                    1.0017e-06,
                    1.0054e-06,
                    1.0066e-06,
                    1.0118e-06,
                    1.0291e-06,
                    1.05e-06,
                    1.0691e-06,
                    1.0912e-06,
                    1.1181e-06,
                    1.148e-06,
                    1.184e-06,
                    1.2245e-06,
                    1.2682e-06,
                    1.3191e-06,
                    1.4103e-06,
                    1.491e-06,
                    1.6001e-06,
                    1.6891e-06,
                    1.7704e-06,
                    1.8546e-06,
                    1.9093e-06,
                    1.9702e-06,
                    2.0398e-06,
                    2.112e-06,
                    2.2232e-06,
                    2.3186e-06,
                    2.4135e-06,
                    2.5051e-06,
                    2.6064e-06,
                    2.7213e-06,
                    2.805e-06,
                    2.9003e-06,
                    3.0005e-06,
                    3.1064e-06,
                    3.226e-06,
                    3.3581e-06,
                    3.4721e-06,
                    3.6047e-06,
                    3.7427e-06
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    3.3e-09,
                    8.25e-09,
                    1.32e-08,
                    1.815e-08,
                    2.31e-08,
                    2.805e-08,
                    3.3e-08,
                    3.795e-08,
                    4.455e-08,
                    5.115e-08,
                    6.105e-08,
                    6.93e-08,
                    8.085e-08,
                    8.745e-08,
                    9.735e-08,
                    1.0725e-07,
                    1.2045e-07,
                    1.3695e-07,
                    1.551e-07,
                    1.7655e-07,
                    1.9635e-07,
                    2.178e-07,
                    2.3925e-07,
                    2.64e-07,
                    2.805e-07,
                    3.0195e-07,
                    3.234e-07,
                    3.4485e-07,
                    3.6795e-07,
                    3.894e-07,
                    4.1085e-07,
                    4.3725e-07,
                    4.653e-07,
                    4.9335e-07,
                    5.214e-07,
                    5.4945e-07,
                    5.7915e-07,
                    6.1215e-07,
                    6.5505e-07,
                    7.0125e-07,
                    7.491e-07,
                    7.986e-07,
                    8.514e-07,
                    9.0585e-07,
                    9.702e-07,
                    1.0378e-06,
                    1.1072e-06,
                    1.1831e-06,
                    1.2623e-06,
                    1.3497e-06,
                    1.4355e-06,
                    1.5229e-06,
                    1.6153e-06,
                    1.7127e-06,
                    1.8051e-06,
                    1.9025e-06,
                    2.0064e-06,
                    2.1137e-06,
                    2.2275e-06,
                    2.3414e-06,
                    2.4585e-06,
                    2.5724e-06,
                    2.6945e-06,
                    2.8314e-06,
                    2.937e-06,
                    3.0541e-06,
                    3.1746e-06,
                    3.3e-06,
                    3.4386e-06,
                    3.5871e-06,
                    3.7174e-06,
                    3.866e-06,
                    4.0193e-06
                ],
                "Land_CO2": -0,
                "Land_CO2_timeseries": [
                    4.686e-09,
                    9.2565e-09,
                    1.3744e-08,
                    1.8156e-08,
                    2.2484e-08,
                    2.6818e-08,
                    3.1114e-08,
                    3.5327e-08,
                    3.9556e-08,
                    4.3857e-08,
                    4.8252e-08,
                    5.2619e-08,
                    5.698e-08,
                    6.1292e-08,
                    6.567e-08,
                    6.9982e-08,
                    7.4332e-08,
                    7.8661e-08,
                    8.299e-08,
                    8.7384e-08,
                    9.1812e-08,
                    9.6162e-08,
                    1.0052e-07,
                    1.049e-07,
                    1.093e-07,
                    1.137e-07,
                    1.1807e-07,
                    1.2244e-07,
                    1.2682e-07,
                    1.3122e-07,
                    1.3564e-07,
                    1.4009e-07,
                    1.4456e-07,
                    1.4899e-07,
                    1.5345e-07,
                    1.5791e-07,
                    1.6237e-07,
                    1.6683e-07,
                    1.713e-07,
                    1.7587e-07,
                    1.8043e-07,
                    1.8501e-07,
                    1.8961e-07,
                    1.9424e-07,
                    1.9887e-07,
                    2.0346e-07,
                    2.0803e-07,
                    2.1264e-07,
                    2.1723e-07,
                    2.2195e-07,
                    2.2669e-07,
                    2.3142e-07,
                    2.3616e-07,
                    2.4092e-07,
                    2.457e-07,
                    2.5047e-07,
                    2.5524e-07,
                    2.6002e-07,
                    2.648e-07,
                    2.6755e-07,
                    2.695e-07,
                    2.7105e-07,
                    2.7228e-07,
                    2.7328e-07,
                    2.7409e-07,
                    2.7472e-07,
                    2.7523e-07,
                    2.756e-07,
                    2.7587e-07,
                    2.765e-07,
                    2.7728e-07,
                    2.7811e-07,
                    2.7899e-07,
                    2.7988e-07,
                    2.8081e-07,
                    2.8175e-07,
                    2.8272e-07,
                    2.8371e-07,
                    2.8472e-07,
                    2.8585e-07,
                    2.8702e-07,
                    2.8823e-07,
                    2.8945e-07,
                    2.907e-07,
                    2.9198e-07,
                    2.9327e-07,
                    2.9457e-07,
                    2.959e-07,
                    2.9723e-07,
                    2.9852e-07,
                    2.9981e-07,
                    3.0112e-07,
                    3.0243e-07,
                    3.0376e-07,
                    3.051e-07,
                    3.0643e-07,
                    3.0775e-07,
                    3.091e-07,
                    3.1046e-07,
                    3.1123e-07,
                    3.1754e-07,
                    3.3098e-07,
                    3.5128e-07,
                    3.7671e-07,
                    4.0718e-07,
                    4.4151e-07,
                    4.7816e-07,
                    5.1552e-07,
                    5.5229e-07,
                    5.723e-07,
                    5.8596e-07,
                    5.9647e-07,
                    6.0518e-07,
                    6.1244e-07,
                    6.1876e-07,
                    6.2424e-07,
                    6.2881e-07,
                    6.328e-07,
                    6.3635e-07,
                    6.3949e-07,
                    6.3551e-07,
                    6.3136e-07,
                    6.2673e-07,
                    6.2241e-07,
                    6.1808e-07,
                    6.1363e-07,
                    6.0481e-07,
                    5.9634e-07,
                    5.7649e-07,
                    5.5724e-07,
                    5.3942e-07,
                    5.2222e-07,
                    5.0557e-07,
                    4.8035e-07,
                    4.559e-07,
                    4.2743e-07,
                    3.9966e-07,
                    3.741e-07,
                    3.4871e-07,
                    3.2003e-07,
                    2.926e-07,
                    2.6668e-07,
                    2.4219e-07,
                    2.1379e-07,
                    1.867e-07,
                    1.6107e-07,
                    1.3606e-07,
                    1.4803e-07,
                    1.4127e-07,
                    1.6463e-07,
                    1.6617e-07,
                    1.5507e-07,
                    1.4186e-07,
                    1.0419e-07,
                    6.7744e-08,
                    3.3385e-08,
                    -0.000000001606,
                    -0.0000000042955,
                    -0.000000022748,
                    -0.000000045034,
                    -0.000000067281,
                    -0.000000088022,
                    -0.00000011013,
                    -0.00000013204,
                    -0.00000015384,
                    -0.00000017409,
                    -0.00000019357,
                    -0.00000021256,
                    -0.00000022901,
                    -0.00000024536,
                    -0.00000026131,
                    -0.00000027655
                ],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [
                    4.9278e-09,
                    9.7235e-09,
                    1.451e-08,
                    1.9289e-08,
                    2.4058e-08,
                    2.8995e-08,
                    3.4103e-08,
                    3.9388e-08,
                    4.4854e-08,
                    5.0506e-08,
                    5.6278e-08,
                    6.2162e-08,
                    6.8169e-08,
                    7.4293e-08,
                    8.0431e-08,
                    8.6583e-08,
                    9.275e-08,
                    9.8934e-08,
                    1.0509e-07,
                    1.1121e-07,
                    1.1756e-07,
                    1.2406e-07,
                    1.3062e-07,
                    1.3722e-07,
                    1.4386e-07,
                    1.5037e-07,
                    1.5674e-07,
                    1.6296e-07,
                    1.6902e-07,
                    1.7493e-07,
                    1.8072e-07,
                    1.8659e-07,
                    1.9244e-07,
                    1.9817e-07,
                    2.0386e-07,
                    2.095e-07,
                    2.1514e-07,
                    2.2076e-07,
                    2.2644e-07,
                    2.3239e-07,
                    2.3835e-07,
                    2.4436e-07,
                    2.5045e-07,
                    2.5661e-07,
                    2.6283e-07,
                    2.6913e-07,
                    2.7548e-07,
                    2.8193e-07,
                    2.8847e-07,
                    2.9485e-07,
                    3.0126e-07,
                    3.0757e-07,
                    3.1382e-07,
                    3.2012e-07,
                    3.2651e-07,
                    3.3298e-07,
                    3.3948e-07,
                    3.4603e-07,
                    3.5259e-07,
                    3.5895e-07,
                    3.6515e-07,
                    3.7112e-07,
                    3.7685e-07,
                    3.8228e-07,
                    3.8743e-07,
                    3.9229e-07,
                    3.9687e-07,
                    4.0116e-07,
                    4.0515e-07,
                    4.0909e-07,
                    4.1279e-07,
                    4.1637e-07,
                    4.1978e-07,
                    4.2298e-07,
                    4.2598e-07,
                    4.2886e-07,
                    4.3158e-07,
                    4.3418e-07,
                    4.3664e-07,
                    4.39e-07,
                    4.4145e-07,
                    4.4394e-07,
                    4.4646e-07,
                    4.4902e-07,
                    4.5164e-07,
                    4.544e-07,
                    4.573e-07,
                    4.604e-07,
                    4.6373e-07,
                    4.6725e-07,
                    4.7115e-07,
                    4.7536e-07,
                    4.7977e-07,
                    4.845e-07,
                    4.9004e-07,
                    4.9646e-07,
                    5.0378e-07,
                    5.1198e-07,
                    5.2108e-07,
                    5.3113e-07,
                    5.4201e-07,
                    5.5411e-07,
                    5.6779e-07,
                    5.834e-07,
                    6.0119e-07,
                    6.2128e-07,
                    6.4381e-07,
                    6.6887e-07,
                    6.9639e-07,
                    7.2645e-07,
                    7.5597e-07,
                    7.8438e-07,
                    8.1807e-07,
                    8.5311e-07,
                    8.8998e-07,
                    9.2838e-07,
                    9.6586e-07,
                    1.0049e-06,
                    1.0424e-06,
                    1.0804e-06,
                    1.1223e-06,
                    1.1593e-06,
                    1.1959e-06,
                    1.2288e-06,
                    1.2569e-06,
                    1.2864e-06,
                    1.3151e-06,
                    1.3435e-06,
                    1.3687e-06,
                    1.3907e-06,
                    1.4139e-06,
                    1.4391e-06,
                    1.4603e-06,
                    1.4802e-06,
                    1.4966e-06,
                    1.509e-06,
                    1.5197e-06,
                    1.5265e-06,
                    1.5333e-06,
                    1.5385e-06,
                    1.5401e-06,
                    1.5458e-06,
                    1.5514e-06,
                    1.5602e-06,
                    1.5729e-06,
                    1.5835e-06,
                    1.5939e-06,
                    1.604e-06,
                    1.6161e-06,
                    1.6302e-06,
                    1.6435e-06,
                    1.6564e-06,
                    1.6697e-06,
                    1.6828e-06,
                    1.6987e-06,
                    1.7164e-06,
                    1.7365e-06,
                    1.7594e-06,
                    1.7825e-06,
                    1.8051e-06,
                    1.8276e-06,
                    1.8497e-06,
                    1.8717e-06,
                    1.8935e-06,
                    1.9154e-06,
                    1.9368e-06,
                    1.9581e-06,
                    1.9793e-06,
                    1.998e-06,
                    2.0162e-06,
                    2.0353e-06,
                    2.0554e-06
                ],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [
                    2.5924e-09,
                    5.045e-09,
                    7.481e-09,
                    9.9005e-09,
                    1.2303e-08,
                    1.4866e-08,
                    1.7593e-08,
                    2.0488e-08,
                    2.3556e-08,
                    2.6803e-08,
                    3.0159e-08,
                    3.3618e-08,
                    3.7189e-08,
                    4.0867e-08,
                    4.4548e-08,
                    4.8233e-08,
                    5.1923e-08,
                    5.5619e-08,
                    5.9276e-08,
                    6.2893e-08,
                    6.6719e-08,
                    7.0695e-08,
                    7.4709e-08,
                    7.8761e-08,
                    8.2837e-08,
                    8.6772e-08,
                    9.0563e-08,
                    9.419e-08,
                    9.7649e-08,
                    1.0094e-07,
                    1.0411e-07,
                    1.0734e-07,
                    1.1055e-07,
                    1.1363e-07,
                    1.1666e-07,
                    1.1963e-07,
                    1.2259e-07,
                    1.2552e-07,
                    1.285e-07,
                    1.3176e-07,
                    1.35e-07,
                    1.3828e-07,
                    1.4164e-07,
                    1.4506e-07,
                    1.4853e-07,
                    1.5206e-07,
                    1.5565e-07,
                    1.5931e-07,
                    1.6307e-07,
                    1.6665e-07,
                    1.7025e-07,
                    1.7374e-07,
                    1.7716e-07,
                    1.8063e-07,
                    1.8417e-07,
                    1.8779e-07,
                    1.9142e-07,
                    1.9509e-07,
                    1.9877e-07,
                    2.0223e-07,
                    2.056e-07,
                    2.0881e-07,
                    2.1184e-07,
                    2.1464e-07,
                    2.1722e-07,
                    2.1959e-07,
                    2.2173e-07,
                    2.2365e-07,
                    2.2534e-07,
                    2.2704e-07,
                    2.2858e-07,
                    2.3006e-07,
                    2.3144e-07,
                    2.3267e-07,
                    2.3378e-07,
                    2.3483e-07,
                    2.3579e-07,
                    2.367e-07,
                    2.3754e-07,
                    2.3835e-07,
                    2.3925e-07,
                    2.4018e-07,
                    2.4114e-07,
                    2.4215e-07,
                    2.4321e-07,
                    2.4433e-07,
                    2.455e-07,
                    2.4677e-07,
                    2.4819e-07,
                    2.497e-07,
                    2.5151e-07,
                    2.5353e-07,
                    2.5567e-07,
                    2.5804e-07,
                    2.6113e-07,
                    2.65e-07,
                    2.6969e-07,
                    2.7516e-07,
                    2.8144e-07,
                    2.8859e-07,
                    2.965e-07,
                    3.0538e-07,
                    3.1543e-07,
                    3.2688e-07,
                    3.399e-07,
                    3.5463e-07,
                    3.7118e-07,
                    3.8961e-07,
                    4.0992e-07,
                    4.3221e-07,
                    4.5618e-07,
                    4.8185e-07,
                    5.0924e-07,
                    5.3833e-07,
                    5.6858e-07,
                    5.9979e-07,
                    6.3189e-07,
                    6.6479e-07,
                    6.9844e-07,
                    7.3124e-07,
                    7.6747e-07,
                    8.0264e-07,
                    8.3647e-07,
                    8.6873e-07,
                    8.9911e-07,
                    9.2727e-07,
                    9.53e-07,
                    9.762e-07,
                    9.9726e-07,
                    1.0168e-06,
                    1.0357e-06,
                    1.0546e-06,
                    1.074e-06,
                    1.0935e-06,
                    1.1126e-06,
                    1.1303e-06,
                    1.1461e-06,
                    1.1596e-06,
                    1.1708e-06,
                    1.1818e-06,
                    1.1894e-06,
                    1.1979e-06,
                    1.2072e-06,
                    1.2181e-06,
                    1.2306e-06,
                    1.2449e-06,
                    1.2613e-06,
                    1.2802e-06,
                    1.3006e-06,
                    1.3223e-06,
                    1.343e-06,
                    1.3626e-06,
                    1.3814e-06,
                    1.3985e-06,
                    1.4163e-06,
                    1.4338e-06,
                    1.4524e-06,
                    1.4724e-06,
                    1.4926e-06,
                    1.5131e-06,
                    1.5336e-06,
                    1.5534e-06,
                    1.5735e-06,
                    1.5935e-06,
                    1.6136e-06,
                    1.6331e-06,
                    1.6526e-06,
                    1.6718e-06,
                    1.6887e-06,
                    1.7045e-06,
                    1.7214e-06,
                    1.7393e-06
                ],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [
                    2.3354e-09,
                    4.6785e-09,
                    7.0294e-09,
                    9.3881e-09,
                    1.1754e-08,
                    1.4129e-08,
                    1.6511e-08,
                    1.89e-08,
                    2.1298e-08,
                    2.3703e-08,
                    2.6118e-08,
                    2.8544e-08,
                    3.098e-08,
                    3.3427e-08,
                    3.5883e-08,
                    3.835e-08,
                    4.0827e-08,
                    4.3315e-08,
                    4.5812e-08,
                    4.8321e-08,
                    5.0839e-08,
                    5.3369e-08,
                    5.5909e-08,
                    5.846e-08,
                    6.1021e-08,
                    6.3594e-08,
                    6.6176e-08,
                    6.877e-08,
                    7.1375e-08,
                    7.399e-08,
                    7.6614e-08,
                    7.9247e-08,
                    8.1889e-08,
                    8.454e-08,
                    8.72e-08,
                    8.9869e-08,
                    9.2548e-08,
                    9.5235e-08,
                    9.7931e-08,
                    1.0064e-07,
                    1.0335e-07,
                    1.0607e-07,
                    1.0881e-07,
                    1.1155e-07,
                    1.143e-07,
                    1.1706e-07,
                    1.1983e-07,
                    1.2261e-07,
                    1.254e-07,
                    1.282e-07,
                    1.3101e-07,
                    1.3383e-07,
                    1.3666e-07,
                    1.3949e-07,
                    1.4234e-07,
                    1.452e-07,
                    1.4806e-07,
                    1.5094e-07,
                    1.5382e-07,
                    1.5672e-07,
                    1.5955e-07,
                    1.6231e-07,
                    1.6501e-07,
                    1.6764e-07,
                    1.7021e-07,
                    1.7271e-07,
                    1.7514e-07,
                    1.7751e-07,
                    1.7981e-07,
                    1.8205e-07,
                    1.8421e-07,
                    1.8631e-07,
                    1.8834e-07,
                    1.9031e-07,
                    1.922e-07,
                    1.9403e-07,
                    1.9579e-07,
                    1.9748e-07,
                    1.991e-07,
                    2.0065e-07,
                    2.0221e-07,
                    2.0376e-07,
                    2.0531e-07,
                    2.0687e-07,
                    2.0842e-07,
                    2.1007e-07,
                    2.118e-07,
                    2.1363e-07,
                    2.1554e-07,
                    2.1755e-07,
                    2.1964e-07,
                    2.2182e-07,
                    2.241e-07,
                    2.2646e-07,
                    2.2892e-07,
                    2.3146e-07,
                    2.3409e-07,
                    2.3682e-07,
                    2.3963e-07,
                    2.4254e-07,
                    2.4551e-07,
                    2.4874e-07,
                    2.5237e-07,
                    2.5652e-07,
                    2.6129e-07,
                    2.6665e-07,
                    2.7264e-07,
                    2.7925e-07,
                    2.8647e-07,
                    2.9424e-07,
                    2.9979e-07,
                    3.0253e-07,
                    3.0883e-07,
                    3.1477e-07,
                    3.214e-07,
                    3.2859e-07,
                    3.3397e-07,
                    3.4012e-07,
                    3.4396e-07,
                    3.4919e-07,
                    3.5482e-07,
                    3.5666e-07,
                    3.5938e-07,
                    3.6003e-07,
                    3.5779e-07,
                    3.591e-07,
                    3.6209e-07,
                    3.6732e-07,
                    3.7146e-07,
                    3.7392e-07,
                    3.782e-07,
                    3.8446e-07,
                    3.8629e-07,
                    3.8661e-07,
                    3.8399e-07,
                    3.7868e-07,
                    3.7359e-07,
                    3.6693e-07,
                    3.6247e-07,
                    3.5676e-07,
                    3.5066e-07,
                    3.4797e-07,
                    3.4422e-07,
                    3.4211e-07,
                    3.4234e-07,
                    3.3856e-07,
                    3.3255e-07,
                    3.2378e-07,
                    3.1556e-07,
                    3.079e-07,
                    3.0055e-07,
                    2.9381e-07,
                    2.8824e-07,
                    2.8432e-07,
                    2.8243e-07,
                    2.8258e-07,
                    2.8419e-07,
                    2.8702e-07,
                    2.899e-07,
                    2.9191e-07,
                    2.9402e-07,
                    2.9623e-07,
                    2.9818e-07,
                    3.0006e-07,
                    3.018e-07,
                    3.0362e-07,
                    3.0549e-07,
                    3.0748e-07,
                    3.0936e-07,
                    3.1166e-07,
                    3.1389e-07,
                    3.1608e-07
                ],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [
                    1.4774e-10,
                    2.9761e-10,
                    4.4957e-10,
                    6.0353e-10,
                    7.5939e-10,
                    9.1703e-10,
                    1.0763e-09,
                    1.237e-09,
                    1.399e-09,
                    1.5621e-09,
                    1.7261e-09,
                    1.891e-09,
                    2.0567e-09,
                    2.2233e-09,
                    2.3908e-09,
                    2.5591e-09,
                    2.7282e-09,
                    2.8983e-09,
                    3.0692e-09,
                    3.241e-09,
                    3.415e-09,
                    3.5929e-09,
                    3.7764e-09,
                    3.9664e-09,
                    4.1636e-09,
                    4.368e-09,
                    4.5794e-09,
                    4.797e-09,
                    5.0196e-09,
                    5.2456e-09,
                    5.4739e-09,
                    5.7041e-09,
                    5.9362e-09,
                    6.1699e-09,
                    6.4053e-09,
                    6.6422e-09,
                    6.8806e-09,
                    7.1206e-09,
                    7.3623e-09,
                    7.6385e-09,
                    7.9173e-09,
                    8.2006e-09,
                    8.4895e-09,
                    8.7855e-09,
                    9.0897e-09,
                    9.403e-09,
                    9.7262e-09,
                    1.006e-08,
                    1.0405e-08,
                    1.0762e-08,
                    1.1134e-08,
                    1.1528e-08,
                    1.195e-08,
                    1.2401e-08,
                    1.2884e-08,
                    1.3398e-08,
                    1.3941e-08,
                    1.4509e-08,
                    1.5096e-08,
                    1.5696e-08,
                    1.6303e-08,
                    1.6917e-08,
                    1.7538e-08,
                    1.8166e-08,
                    1.8799e-08,
                    1.9439e-08,
                    2.0083e-08,
                    2.0732e-08,
                    2.1385e-08,
                    2.2041e-08,
                    2.2698e-08,
                    2.3356e-08,
                    2.4011e-08,
                    2.4664e-08,
                    2.5314e-08,
                    2.596e-08,
                    2.6603e-08,
                    2.7244e-08,
                    2.7884e-08,
                    2.8526e-08,
                    2.9172e-08,
                    2.9827e-08,
                    3.0493e-08,
                    3.1174e-08,
                    3.187e-08,
                    3.2585e-08,
                    3.3318e-08,
                    3.407e-08,
                    3.4841e-08,
                    3.563e-08,
                    3.6457e-08,
                    3.7358e-08,
                    3.8361e-08,
                    3.9485e-08,
                    4.0741e-08,
                    4.2134e-08,
                    4.3657e-08,
                    4.5298e-08,
                    4.7036e-08,
                    4.8842e-08,
                    5.0713e-08,
                    5.2672e-08,
                    5.4739e-08,
                    5.6927e-08,
                    5.9243e-08,
                    6.1689e-08,
                    6.4262e-08,
                    6.6951e-08,
                    6.9741e-08,
                    7.2613e-08,
                    7.5452e-08,
                    7.8134e-08,
                    8.1066e-08,
                    8.4004e-08,
                    8.7035e-08,
                    9.0123e-08,
                    9.3169e-08,
                    9.6344e-08,
                    9.9461e-08,
                    1.028e-07,
                    1.062e-07,
                    1.095e-07,
                    1.1285e-07,
                    1.1601e-07,
                    1.1908e-07,
                    1.2241e-07,
                    1.2602e-07,
                    1.2982e-07,
                    1.3367e-07,
                    1.3747e-07,
                    1.4137e-07,
                    1.4522e-07,
                    1.4898e-07,
                    1.5274e-07,
                    1.564e-07,
                    1.6002e-07,
                    1.6376e-07,
                    1.6757e-07,
                    1.714e-07,
                    1.7535e-07,
                    1.7942e-07,
                    1.8355e-07,
                    1.8767e-07,
                    1.9204e-07,
                    1.9648e-07,
                    2.0095e-07,
                    2.0576e-07,
                    2.1032e-07,
                    2.1484e-07,
                    2.1905e-07,
                    2.2338e-07,
                    2.2846e-07,
                    2.3359e-07,
                    2.3835e-07,
                    2.4321e-07,
                    2.4853e-07,
                    2.5371e-07,
                    2.5935e-07,
                    2.6513e-07,
                    2.7137e-07,
                    2.772e-07,
                    2.8348e-07,
                    2.903e-07,
                    2.9663e-07,
                    3.0304e-07,
                    3.0945e-07,
                    3.1503e-07,
                    3.2065e-07,
                    3.2717e-07,
                    3.3367e-07,
                    3.4014e-07,
                    3.4674e-07
                ],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [
                    1.1445e-10,
                    2.3038e-10,
                    3.4775e-10,
                    4.6653e-10,
                    5.8665e-10,
                    7.0807e-10,
                    8.3071e-10,
                    9.5448e-10,
                    1.0793e-09,
                    1.205e-09,
                    1.3316e-09,
                    1.4591e-09,
                    1.5874e-09,
                    1.7165e-09,
                    1.8464e-09,
                    1.9772e-09,
                    2.1088e-09,
                    2.2412e-09,
                    2.3744e-09,
                    2.5086e-09,
                    2.6442e-09,
                    2.7822e-09,
                    2.9233e-09,
                    3.0682e-09,
                    3.217e-09,
                    3.3699e-09,
                    3.5268e-09,
                    3.6871e-09,
                    3.8503e-09,
                    4.0157e-09,
                    4.1826e-09,
                    4.3508e-09,
                    4.5204e-09,
                    4.6913e-09,
                    4.8633e-09,
                    5.0365e-09,
                    5.2109e-09,
                    5.3865e-09,
                    5.5633e-09,
                    5.7415e-09,
                    5.9212e-09,
                    6.1021e-09,
                    6.2845e-09,
                    6.4684e-09,
                    6.6536e-09,
                    6.8404e-09,
                    7.0287e-09,
                    7.2186e-09,
                    7.4102e-09,
                    7.6035e-09,
                    7.7987e-09,
                    7.9959e-09,
                    8.1953e-09,
                    8.3971e-09,
                    8.6012e-09,
                    8.8079e-09,
                    9.0171e-09,
                    9.2287e-09,
                    9.4428e-09,
                    9.6593e-09,
                    9.878e-09,
                    1.0099e-08,
                    1.0322e-08,
                    1.0548e-08,
                    1.0776e-08,
                    1.1006e-08,
                    1.1239e-08,
                    1.1473e-08,
                    1.171e-08,
                    1.195e-08,
                    1.2192e-08,
                    1.2436e-08,
                    1.2682e-08,
                    1.2932e-08,
                    1.3183e-08,
                    1.3437e-08,
                    1.3693e-08,
                    1.3952e-08,
                    1.4213e-08,
                    1.4476e-08,
                    1.4741e-08,
                    1.5008e-08,
                    1.5277e-08,
                    1.5547e-08,
                    1.5819e-08,
                    1.6093e-08,
                    1.6369e-08,
                    1.6647e-08,
                    1.6927e-08,
                    1.721e-08,
                    1.7499e-08,
                    1.7797e-08,
                    1.8107e-08,
                    1.8432e-08,
                    1.8774e-08,
                    1.9132e-08,
                    1.9507e-08,
                    1.9897e-08,
                    2.03e-08,
                    2.0713e-08,
                    2.1135e-08,
                    2.1563e-08,
                    2.1998e-08,
                    2.2438e-08,
                    2.2884e-08,
                    2.3336e-08,
                    2.3794e-08,
                    2.4258e-08,
                    2.473e-08,
                    2.521e-08,
                    2.5702e-08,
                    2.6208e-08,
                    2.673e-08,
                    2.7271e-08,
                    2.7831e-08,
                    2.841e-08,
                    2.901e-08,
                    2.9627e-08,
                    3.0262e-08,
                    3.099e-08,
                    3.1717e-08,
                    3.2539e-08,
                    3.3321e-08,
                    3.4052e-08,
                    3.4921e-08,
                    3.5715e-08,
                    3.661e-08,
                    3.7467e-08,
                    3.8293e-08,
                    3.9119e-08,
                    4.006e-08,
                    4.0971e-08,
                    4.185e-08,
                    4.2833e-08,
                    4.3861e-08,
                    4.5014e-08,
                    4.6395e-08,
                    4.7864e-08,
                    4.9356e-08,
                    5.0939e-08,
                    5.2676e-08,
                    5.4506e-08,
                    5.6308e-08,
                    5.8301e-08,
                    6.0298e-08,
                    6.2424e-08,
                    6.4938e-08,
                    6.7244e-08,
                    6.9432e-08,
                    7.1537e-08,
                    7.3721e-08,
                    7.5884e-08,
                    7.8358e-08,
                    8.0854e-08,
                    8.3491e-08,
                    8.6169e-08,
                    8.8971e-08,
                    9.1929e-08,
                    9.5012e-08,
                    9.847e-08,
                    1.0192e-07,
                    1.0541e-07,
                    1.0942e-07,
                    1.1287e-07,
                    1.1642e-07,
                    1.1998e-07,
                    1.2268e-07,
                    1.2536e-07,
                    1.2889e-07,
                    1.3241e-07,
                    1.3622e-07,
                    1.4017e-07
                ],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": [
                    3.3284e-11,
                    6.7233e-11,
                    1.0182e-10,
                    1.37e-10,
                    1.7273e-10,
                    2.0895e-10,
                    2.4558e-10,
                    2.8254e-10,
                    3.1973e-10,
                    3.5706e-10,
                    3.9445e-10,
                    4.3188e-10,
                    4.6935e-10,
                    5.0685e-10,
                    5.4436e-10,
                    5.819e-10,
                    6.1947e-10,
                    6.5708e-10,
                    6.9473e-10,
                    7.3246e-10,
                    7.7082e-10,
                    8.1077e-10,
                    8.5307e-10,
                    8.9822e-10,
                    9.4652e-10,
                    9.9804e-10,
                    1.0526e-09,
                    1.1099e-09,
                    1.1693e-09,
                    1.2299e-09,
                    1.2913e-09,
                    1.3533e-09,
                    1.4157e-09,
                    1.4787e-09,
                    1.542e-09,
                    1.6056e-09,
                    1.6697e-09,
                    1.7341e-09,
                    1.799e-09,
                    1.8969e-09,
                    1.9962e-09,
                    2.0984e-09,
                    2.205e-09,
                    2.3172e-09,
                    2.436e-09,
                    2.5626e-09,
                    2.6975e-09,
                    2.8415e-09,
                    2.995e-09,
                    3.1583e-09,
                    3.3353e-09,
                    3.5324e-09,
                    3.7543e-09,
                    4.004e-09,
                    4.2828e-09,
                    4.5901e-09,
                    4.9238e-09,
                    5.2802e-09,
                    5.6534e-09,
                    6.0364e-09,
                    6.4246e-09,
                    6.8178e-09,
                    7.2156e-09,
                    7.6177e-09,
                    8.0235e-09,
                    8.4327e-09,
                    8.8445e-09,
                    9.2586e-09,
                    9.6743e-09,
                    1.0091e-08,
                    1.0507e-08,
                    1.092e-08,
                    1.1329e-08,
                    1.1733e-08,
                    1.2131e-08,
                    1.2523e-08,
                    1.291e-08,
                    1.3292e-08,
                    1.3671e-08,
                    1.405e-08,
                    1.4431e-08,
                    1.4819e-08,
                    1.5217e-08,
                    1.5627e-08,
                    1.6051e-08,
                    1.6492e-08,
                    1.6949e-08,
                    1.7423e-08,
                    1.7914e-08,
                    1.842e-08,
                    1.8958e-08,
                    1.9562e-08,
                    2.0254e-08,
                    2.1053e-08,
                    2.1968e-08,
                    2.3002e-08,
                    2.415e-08,
                    2.5401e-08,
                    2.6736e-08,
                    2.8129e-08,
                    2.9578e-08,
                    3.1109e-08,
                    3.2741e-08,
                    3.4489e-08,
                    3.6359e-08,
                    3.8353e-08,
                    4.0468e-08,
                    4.2693e-08,
                    4.5012e-08,
                    4.7403e-08,
                    4.9751e-08,
                    5.1927e-08,
                    5.4336e-08,
                    5.6734e-08,
                    5.9205e-08,
                    6.1713e-08,
                    6.4159e-08,
                    6.6716e-08,
                    6.92e-08,
                    7.1806e-08,
                    7.4486e-08,
                    7.6957e-08,
                    7.9527e-08,
                    8.1961e-08,
                    8.4161e-08,
                    8.6694e-08,
                    8.9411e-08,
                    9.2349e-08,
                    9.5373e-08,
                    9.8349e-08,
                    1.0131e-07,
                    1.0425e-07,
                    1.0713e-07,
                    1.099e-07,
                    1.1254e-07,
                    1.1501e-07,
                    1.1737e-07,
                    1.197e-07,
                    1.2204e-07,
                    1.2441e-07,
                    1.2675e-07,
                    1.2905e-07,
                    1.3136e-07,
                    1.3374e-07,
                    1.3618e-07,
                    1.3853e-07,
                    1.4082e-07,
                    1.4307e-07,
                    1.4541e-07,
                    1.4751e-07,
                    1.4966e-07,
                    1.5258e-07,
                    1.5523e-07,
                    1.5749e-07,
                    1.5972e-07,
                    1.6236e-07,
                    1.6474e-07,
                    1.6742e-07,
                    1.7012e-07,
                    1.729e-07,
                    1.7528e-07,
                    1.7806e-07,
                    1.8088e-07,
                    1.8375e-07,
                    1.8662e-07,
                    1.8947e-07,
                    1.9235e-07,
                    1.953e-07,
                    1.9829e-07,
                    2.0126e-07,
                    2.0392e-07,
                    2.0657e-07
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -61.79825,
                            12.00439
                        ],
                        [
                            -61.71907,
                            12.00237
                        ],
                        [
                            -61.65597,
                            12.0266
                        ],
                        [
                            -61.61894,
                            12.07726
                        ],
                        [
                            -61.60243,
                            12.16999
                        ],
                        [
                            -61.66045,
                            12.23448
                        ],
                        [
                            -61.72347,
                            12.18354
                        ],
                        [
                            -61.7524,
                            12.12104
                        ],
                        [
                            -61.75532,
                            12.02983
                        ],
                        [
                            -61.79825,
                            12.00439
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "GTM",
                "Country": "Guatemala",
                "Total_3GHG": 0.16,
                "Total_3GHG_timeseries": [
                    4.2288e-06,
                    8.0089e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026
                ],
                "Fossil_3GHG": 0.06,
                "Fossil_3GHG_timeseries": [
                    1.3403e-07,
                    2.7004e-07,
                    4.0805e-07,
                    5.4811e-07,
                    6.9024e-07,
                    8.3449e-07,
                    9.8087e-07,
                    1.1294e-06,
                    1.2802e-06,
                    1.4331e-06,
                    1.5879e-06,
                    1.7444e-06,
                    1.9027e-06,
                    2.0629e-06,
                    2.2249e-06,
                    2.3889e-06,
                    2.5549e-06,
                    2.723e-06,
                    2.8931e-06,
                    3.0653e-06,
                    3.2365e-06,
                    3.4066e-06,
                    3.5758e-06,
                    3.744e-06,
                    3.9112e-06,
                    4.0774e-06,
                    4.2427e-06,
                    4.4068e-06,
                    4.5699e-06,
                    4.7317e-06,
                    4.8914e-06,
                    5.0489e-06,
                    5.2042e-06,
                    5.3574e-06,
                    5.5083e-06,
                    5.6569e-06,
                    5.8033e-06,
                    5.9474e-06,
                    6.0891e-06,
                    6.2288e-06,
                    6.3686e-06,
                    6.5084e-06,
                    6.6483e-06,
                    6.7883e-06,
                    6.9284e-06,
                    7.0686e-06,
                    7.209e-06,
                    7.3495e-06,
                    7.4903e-06,
                    7.6312e-06,
                    7.779e-06,
                    7.9339e-06,
                    8.0961e-06,
                    8.2655e-06,
                    8.4421e-06,
                    8.626e-06,
                    8.8171e-06,
                    9.0158e-06,
                    9.2217e-06,
                    9.4352e-06,
                    9.6558e-06,
                    9.8831e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007
                ],
                "Land_3GHG": 0.34,
                "Land_3GHG_timeseries": [
                    4.0948e-06,
                    7.7388e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002
                ],
                "Total_CO2": 0.16,
                "Total_CO2_timeseries": [
                    3.8588e-06,
                    7.263e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019
                ],
                "Fossil_CO2": 0.03,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    4.9099e-09,
                    9.8198e-09,
                    1.473e-08,
                    1.964e-08,
                    2.6186e-08,
                    3.2733e-08,
                    3.9279e-08,
                    4.5825e-08,
                    5.4008e-08,
                    3.3278e-07,
                    6.1977e-07,
                    9.1006e-07,
                    1.2169e-06,
                    1.5517e-06,
                    1.9641e-06,
                    2.4045e-06,
                    2.8481e-06,
                    3.3561e-06,
                    3.9136e-06,
                    4.519e-06,
                    5.1523e-06,
                    5.7742e-06,
                    6.4586e-06,
                    7.2552e-06,
                    8.1442e-06,
                    8.9276e-06,
                    9.8198e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_CO2": 0.46,
                "Land_CO2_timeseries": [
                    3.8588e-06,
                    7.263e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016
                ],
                "Total_CH4": 0.16,
                "Total_CH4_timeseries": [
                    3.4964e-07,
                    7.0483e-07,
                    1.0656e-06,
                    1.432e-06,
                    1.804e-06,
                    2.1817e-06,
                    2.5651e-06,
                    2.9543e-06,
                    3.3492e-06,
                    3.75e-06,
                    4.1552e-06,
                    4.5647e-06,
                    4.9787e-06,
                    5.3971e-06,
                    5.82e-06,
                    6.2475e-06,
                    6.6795e-06,
                    7.1162e-06,
                    7.5576e-06,
                    8.0037e-06,
                    8.447e-06,
                    8.8876e-06,
                    9.3253e-06,
                    9.7602e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007
                ],
                "Fossil_CH4": 0.16,
                "Fossil_CH4_timeseries": [
                    1.1868e-07,
                    2.3915e-07,
                    3.6145e-07,
                    4.8563e-07,
                    6.117e-07,
                    7.3972e-07,
                    8.6971e-07,
                    1.0017e-06,
                    1.1358e-06,
                    1.272e-06,
                    1.4097e-06,
                    1.5492e-06,
                    1.6903e-06,
                    1.8331e-06,
                    1.9778e-06,
                    2.1242e-06,
                    2.2725e-06,
                    2.4227e-06,
                    2.5749e-06,
                    2.729e-06,
                    2.882e-06,
                    3.0336e-06,
                    3.1839e-06,
                    3.3328e-06,
                    3.4804e-06,
                    3.6266e-06,
                    3.7714e-06,
                    3.9148e-06,
                    4.0568e-06,
                    4.1972e-06,
                    4.3354e-06,
                    4.4712e-06,
                    4.6047e-06,
                    4.7358e-06,
                    4.8645e-06,
                    4.9908e-06,
                    5.1147e-06,
                    5.2361e-06,
                    5.3551e-06,
                    5.4715e-06,
                    5.5877e-06,
                    5.7038e-06,
                    5.8196e-06,
                    5.9352e-06,
                    6.0507e-06,
                    6.166e-06,
                    6.2812e-06,
                    6.3962e-06,
                    6.5111e-06,
                    6.6259e-06,
                    6.7471e-06,
                    6.8752e-06,
                    7.01e-06,
                    7.1517e-06,
                    7.3002e-06,
                    7.4555e-06,
                    7.6176e-06,
                    7.7868e-06,
                    7.9628e-06,
                    8.146e-06,
                    8.3359e-06,
                    8.5322e-06,
                    8.7355e-06,
                    8.9455e-06,
                    9.1626e-06,
                    9.3872e-06,
                    9.6194e-06,
                    9.8591e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Land_CH4": 0.17,
                "Land_CH4_timeseries": [
                    2.3097e-07,
                    4.6568e-07,
                    7.0413e-07,
                    9.4633e-07,
                    1.1923e-06,
                    1.4419e-06,
                    1.6954e-06,
                    1.9525e-06,
                    2.2134e-06,
                    2.4781e-06,
                    2.7455e-06,
                    3.0156e-06,
                    3.2884e-06,
                    3.564e-06,
                    3.8423e-06,
                    4.1233e-06,
                    4.407e-06,
                    4.6935e-06,
                    4.9827e-06,
                    5.2746e-06,
                    5.5651e-06,
                    5.854e-06,
                    6.1414e-06,
                    6.4274e-06,
                    6.7118e-06,
                    6.9947e-06,
                    7.2761e-06,
                    7.556e-06,
                    7.8345e-06,
                    8.1114e-06,
                    8.3835e-06,
                    8.651e-06,
                    8.9136e-06,
                    9.1715e-06,
                    9.4247e-06,
                    9.6731e-06,
                    9.9168e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003
                ],
                "Total_N2O": 0.1,
                "Total_N2O_timeseries": [
                    2.0389e-08,
                    4.1059e-08,
                    6.2006e-08,
                    8.3218e-08,
                    1.0468e-07,
                    1.2639e-07,
                    1.4832e-07,
                    1.7045e-07,
                    1.9276e-07,
                    2.1522e-07,
                    2.3782e-07,
                    2.6055e-07,
                    2.8342e-07,
                    3.0642e-07,
                    3.2954e-07,
                    3.5279e-07,
                    3.7617e-07,
                    3.9969e-07,
                    4.2334e-07,
                    4.4712e-07,
                    4.7119e-07,
                    4.9575e-07,
                    5.2101e-07,
                    5.4706e-07,
                    5.74e-07,
                    6.0183e-07,
                    6.3052e-07,
                    6.5997e-07,
                    6.9005e-07,
                    7.2056e-07,
                    7.5137e-07,
                    7.8244e-07,
                    8.1375e-07,
                    8.453e-07,
                    8.7706e-07,
                    9.0903e-07,
                    9.4121e-07,
                    9.7361e-07,
                    1.0062e-06,
                    1.0443e-06,
                    1.0829e-06,
                    1.1222e-06,
                    1.1624e-06,
                    1.2037e-06,
                    1.2463e-06,
                    1.2904e-06,
                    1.336e-06,
                    1.3833e-06,
                    1.4324e-06,
                    1.4833e-06,
                    1.5366e-06,
                    1.5933e-06,
                    1.6542e-06,
                    1.7197e-06,
                    1.79e-06,
                    1.8651e-06,
                    1.9447e-06,
                    2.028e-06,
                    2.1144e-06,
                    2.2026e-06,
                    2.292e-06,
                    2.3826e-06,
                    2.4742e-06,
                    2.5669e-06,
                    2.6605e-06,
                    2.7549e-06,
                    2.8502e-06,
                    2.9461e-06,
                    3.0427e-06,
                    3.1398e-06,
                    3.2372e-06,
                    3.3345e-06,
                    3.4316e-06,
                    3.5282e-06,
                    3.6244e-06,
                    3.72e-06,
                    3.8152e-06,
                    3.9102e-06,
                    4.0051e-06,
                    4.1002e-06,
                    4.1962e-06,
                    4.2935e-06,
                    4.3928e-06,
                    4.4943e-06,
                    4.5984e-06,
                    4.7054e-06,
                    4.8154e-06,
                    4.9284e-06,
                    5.0445e-06,
                    5.1634e-06,
                    5.2879e-06,
                    5.4232e-06,
                    5.573e-06,
                    5.7402e-06,
                    5.9263e-06,
                    6.1319e-06,
                    6.3563e-06,
                    6.5976e-06,
                    6.853e-06,
                    7.1184e-06,
                    7.3938e-06,
                    7.6832e-06,
                    7.9899e-06,
                    8.3162e-06,
                    8.6632e-06,
                    9.0314e-06,
                    9.4202e-06,
                    9.8281e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_N2O": 0.08,
                "Fossil_N2O_timeseries": [
                    1.5352e-08,
                    3.0886e-08,
                    4.6598e-08,
                    6.2487e-08,
                    7.8546e-08,
                    9.4772e-08,
                    1.1116e-07,
                    1.2769e-07,
                    1.4437e-07,
                    1.6119e-07,
                    1.7813e-07,
                    1.952e-07,
                    2.124e-07,
                    2.2972e-07,
                    2.4717e-07,
                    2.6474e-07,
                    2.8243e-07,
                    3.0026e-07,
                    3.1821e-07,
                    3.3629e-07,
                    3.5455e-07,
                    3.7307e-07,
                    3.9192e-07,
                    4.1115e-07,
                    4.3077e-07,
                    4.5081e-07,
                    4.7123e-07,
                    4.9202e-07,
                    5.1312e-07,
                    5.3445e-07,
                    5.5597e-07,
                    5.7766e-07,
                    5.9952e-07,
                    6.2155e-07,
                    6.4373e-07,
                    6.6606e-07,
                    6.8855e-07,
                    7.112e-07,
                    7.3401e-07,
                    7.5731e-07,
                    7.8085e-07,
                    8.0465e-07,
                    8.2871e-07,
                    8.5305e-07,
                    8.7768e-07,
                    9.0259e-07,
                    9.2781e-07,
                    9.5334e-07,
                    9.7919e-07,
                    1.0054e-06,
                    1.0319e-06,
                    1.0588e-06,
                    1.0861e-06,
                    1.1138e-06,
                    1.142e-06,
                    1.1706e-06,
                    1.1996e-06,
                    1.229e-06,
                    1.2589e-06,
                    1.2892e-06,
                    1.3199e-06,
                    1.3509e-06,
                    1.3823e-06,
                    1.4142e-06,
                    1.4463e-06,
                    1.4789e-06,
                    1.5118e-06,
                    1.5451e-06,
                    1.5788e-06,
                    1.6129e-06,
                    1.6473e-06,
                    1.6821e-06,
                    1.7173e-06,
                    1.7528e-06,
                    1.7888e-06,
                    1.8251e-06,
                    1.8617e-06,
                    1.8988e-06,
                    1.9363e-06,
                    1.9742e-06,
                    2.0124e-06,
                    2.0511e-06,
                    2.0902e-06,
                    2.1296e-06,
                    2.1695e-06,
                    2.2099e-06,
                    2.2507e-06,
                    2.292e-06,
                    2.3338e-06,
                    2.3761e-06,
                    2.4191e-06,
                    2.4631e-06,
                    2.5081e-06,
                    2.5545e-06,
                    2.6022e-06,
                    2.6513e-06,
                    2.7019e-06,
                    2.7539e-06,
                    2.8073e-06,
                    2.862e-06,
                    2.9181e-06,
                    2.9759e-06,
                    3.0356e-06,
                    3.0974e-06,
                    3.1614e-06,
                    3.2279e-06,
                    3.2966e-06,
                    3.3678e-06,
                    3.4413e-06,
                    3.517e-06,
                    3.5946e-06,
                    3.674e-06,
                    3.7552e-06,
                    3.8381e-06,
                    3.9229e-06,
                    4.0097e-06,
                    4.0991e-06,
                    4.1914e-06,
                    4.2872e-06,
                    4.3815e-06,
                    4.4759e-06,
                    4.575e-06,
                    4.6793e-06,
                    4.7852e-06,
                    4.9068e-06,
                    5.0308e-06,
                    5.161e-06,
                    5.2951e-06,
                    5.4325e-06,
                    5.5621e-06,
                    5.6963e-06,
                    5.8484e-06,
                    6e-06,
                    6.1368e-06,
                    6.2807e-06,
                    6.4288e-06,
                    6.5834e-06,
                    6.7443e-06,
                    6.9027e-06,
                    7.0789e-06,
                    7.2631e-06,
                    7.4569e-06,
                    7.6597e-06,
                    7.8626e-06,
                    8.0834e-06,
                    8.3058e-06,
                    8.5383e-06,
                    8.8061e-06,
                    9.0863e-06,
                    9.349e-06,
                    9.6143e-06,
                    9.9088e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.11,
                "Land_N2O_timeseries": [
                    5.0365e-09,
                    1.0174e-08,
                    1.5407e-08,
                    2.0731e-08,
                    2.6138e-08,
                    3.1619e-08,
                    3.7161e-08,
                    4.2754e-08,
                    4.8382e-08,
                    5.403e-08,
                    5.9687e-08,
                    6.5352e-08,
                    7.1022e-08,
                    7.6696e-08,
                    8.2373e-08,
                    8.8054e-08,
                    9.3739e-08,
                    9.9429e-08,
                    1.0513e-07,
                    1.1084e-07,
                    1.1664e-07,
                    1.2269e-07,
                    1.2909e-07,
                    1.3592e-07,
                    1.4323e-07,
                    1.5102e-07,
                    1.5928e-07,
                    1.6795e-07,
                    1.7694e-07,
                    1.8611e-07,
                    1.954e-07,
                    2.0478e-07,
                    2.1423e-07,
                    2.2375e-07,
                    2.3333e-07,
                    2.4297e-07,
                    2.5266e-07,
                    2.6241e-07,
                    2.7223e-07,
                    2.8704e-07,
                    3.0206e-07,
                    3.1753e-07,
                    3.3366e-07,
                    3.5063e-07,
                    3.6862e-07,
                    3.8777e-07,
                    4.0819e-07,
                    4.2997e-07,
                    4.532e-07,
                    4.7791e-07,
                    5.047e-07,
                    5.3453e-07,
                    5.6811e-07,
                    6.0589e-07,
                    6.4807e-07,
                    6.9457e-07,
                    7.4508e-07,
                    7.9899e-07,
                    8.5548e-07,
                    9.1342e-07,
                    9.7217e-07,
                    1.0317e-06,
                    1.0919e-06,
                    1.1527e-06,
                    1.2141e-06,
                    1.276e-06,
                    1.3384e-06,
                    1.401e-06,
                    1.4639e-06,
                    1.5269e-06,
                    1.5899e-06,
                    1.6524e-06,
                    1.7143e-06,
                    1.7754e-06,
                    1.8356e-06,
                    1.8949e-06,
                    1.9535e-06,
                    2.0113e-06,
                    2.0688e-06,
                    2.1261e-06,
                    2.1838e-06,
                    2.2424e-06,
                    2.3026e-06,
                    2.3646e-06,
                    2.4289e-06,
                    2.4955e-06,
                    2.5647e-06,
                    2.6365e-06,
                    2.7107e-06,
                    2.7873e-06,
                    2.8688e-06,
                    2.9601e-06,
                    3.0648e-06,
                    3.1857e-06,
                    3.3241e-06,
                    3.4806e-06,
                    3.6544e-06,
                    3.8437e-06,
                    4.0457e-06,
                    4.2564e-06,
                    4.4757e-06,
                    4.7074e-06,
                    4.9544e-06,
                    5.2188e-06,
                    5.5018e-06,
                    5.8036e-06,
                    6.1236e-06,
                    6.4602e-06,
                    6.8111e-06,
                    7.1729e-06,
                    7.5516e-06,
                    7.9433e-06,
                    8.3535e-06,
                    8.7698e-06,
                    9.1906e-06,
                    9.6232e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -88.91278,
                            15.90013
                        ],
                        [
                            -89.04181,
                            15.91005
                        ],
                        [
                            -89.08015,
                            15.8948
                        ],
                        [
                            -89.22465,
                            15.92644
                        ],
                        [
                            -89.18488,
                            16.47232
                        ],
                        [
                            -89.14585,
                            17.04706
                        ],
                        [
                            -89.14696,
                            17.8095
                        ],
                        [
                            -89.60937,
                            17.81094
                        ],
                        [
                            -90.45564,
                            17.81343
                        ],
                        [
                            -90.98027,
                            17.81483
                        ],
                        [
                            -90.99194,
                            17.25975
                        ],
                        [
                            -91.42319,
                            17.25155
                        ],
                        [
                            -91.34268,
                            17.16883
                        ],
                        [
                            -91.31688,
                            17.18323
                        ],
                        [
                            -91.23226,
                            17.10357
                        ],
                        [
                            -91.17241,
                            17.02051
                        ],
                        [
                            -91.05879,
                            16.89484
                        ],
                        [
                            -90.9692,
                            16.8925
                        ],
                        [
                            -90.91733,
                            16.81494
                        ],
                        [
                            -90.80135,
                            16.79065
                        ],
                        [
                            -90.71113,
                            16.7193
                        ],
                        [
                            -90.65739,
                            16.63515
                        ],
                        [
                            -90.64236,
                            16.51422
                        ],
                        [
                            -90.58034,
                            16.46467
                        ],
                        [
                            -90.54476,
                            16.47478
                        ],
                        [
                            -90.4808,
                            16.41884
                        ],
                        [
                            -90.41626,
                            16.41742
                        ],
                        [
                            -90.39177,
                            16.3722
                        ],
                        [
                            -90.45016,
                            16.24433
                        ],
                        [
                            -90.45564,
                            16.06908
                        ],
                        [
                            -91.07188,
                            16.07393
                        ],
                        [
                            -91.72529,
                            16.07907
                        ],
                        [
                            -92.1009,
                            15.44424
                        ],
                        [
                            -92.21231,
                            15.26436
                        ],
                        [
                            -92.06157,
                            15.07046
                        ],
                        [
                            -92.0937,
                            15.01297
                        ],
                        [
                            -92.14554,
                            14.98333
                        ],
                        [
                            -92.14159,
                            14.88412
                        ],
                        [
                            -92.18181,
                            14.83286
                        ],
                        [
                            -92.14961,
                            14.71545
                        ],
                        [
                            -92.15158,
                            14.65791
                        ],
                        [
                            -92.19032,
                            14.56396
                        ],
                        [
                            -92.23132,
                            14.53332
                        ],
                        [
                            -92.05938,
                            14.40859
                        ],
                        [
                            -91.79153,
                            14.19331
                        ],
                        [
                            -91.54115,
                            14.04544
                        ],
                        [
                            -91.30942,
                            13.95219
                        ],
                        [
                            -91.08718,
                            13.91598
                        ],
                        [
                            -90.9076,
                            13.91109
                        ],
                        [
                            -90.69952,
                            13.92815
                        ],
                        [
                            -90.50746,
                            13.89694
                        ],
                        [
                            -90.41805,
                            13.86687
                        ],
                        [
                            -90.12432,
                            13.74091
                        ],
                        [
                            -90.11042,
                            13.83024
                        ],
                        [
                            -90.0434,
                            13.89041
                        ],
                        [
                            -90.02606,
                            13.93473
                        ],
                        [
                            -89.82277,
                            14.06138
                        ],
                        [
                            -89.77685,
                            14.03102
                        ],
                        [
                            -89.66173,
                            14.18325
                        ],
                        [
                            -89.51966,
                            14.22424
                        ],
                        [
                            -89.54801,
                            14.29886
                        ],
                        [
                            -89.58201,
                            14.31273
                        ],
                        [
                            -89.57191,
                            14.40566
                        ],
                        [
                            -89.52131,
                            14.38246
                        ],
                        [
                            -89.48417,
                            14.41476
                        ],
                        [
                            -89.35319,
                            14.41849
                        ],
                        [
                            -89.24859,
                            14.56746
                        ],
                        [
                            -89.16812,
                            14.57022
                        ],
                        [
                            -89.1354,
                            14.69741
                        ],
                        [
                            -89.16883,
                            14.77237
                        ],
                        [
                            -89.22052,
                            14.83199
                        ],
                        [
                            -89.15981,
                            14.97858
                        ],
                        [
                            -89.15396,
                            15.06448
                        ],
                        [
                            -88.96632,
                            15.13817
                        ],
                        [
                            -88.82861,
                            15.25305
                        ],
                        [
                            -88.68454,
                            15.33655
                        ],
                        [
                            -88.35532,
                            15.60375
                        ],
                        [
                            -88.30706,
                            15.6651
                        ],
                        [
                            -88.22132,
                            15.72049
                        ],
                        [
                            -88.44203,
                            15.85422
                        ],
                        [
                            -88.54922,
                            15.94216
                        ],
                        [
                            -88.55426,
                            15.81132
                        ],
                        [
                            -88.60434,
                            15.735
                        ],
                        [
                            -88.7961,
                            15.86109
                        ],
                        [
                            -88.88168,
                            15.86277
                        ],
                        [
                            -88.91278,
                            15.90013
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "GIN",
                "Country": "Guinea",
                "Total_3GHG": 0.13,
                "Total_3GHG_timeseries": [
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021
                ],
                "Fossil_3GHG": 0.02,
                "Fossil_3GHG_timeseries": [
                    5.3509e-08,
                    1.0885e-07,
                    1.6603e-07,
                    2.2505e-07,
                    2.8593e-07,
                    3.4867e-07,
                    4.1327e-07,
                    4.7973e-07,
                    5.4807e-07,
                    6.1828e-07,
                    6.9072e-07,
                    7.6539e-07,
                    8.4232e-07,
                    9.2151e-07,
                    1.003e-06,
                    1.0867e-06,
                    1.1728e-06,
                    1.2611e-06,
                    1.3518e-06,
                    1.4449e-06,
                    1.5387e-06,
                    1.6335e-06,
                    1.7293e-06,
                    1.8261e-06,
                    1.9241e-06,
                    2.0231e-06,
                    2.1232e-06,
                    2.2243e-06,
                    2.3265e-06,
                    2.4295e-06,
                    2.5331e-06,
                    2.6372e-06,
                    2.7418e-06,
                    2.847e-06,
                    2.9527e-06,
                    3.0588e-06,
                    3.1655e-06,
                    3.2728e-06,
                    3.3805e-06,
                    3.4894e-06,
                    3.5989e-06,
                    3.7092e-06,
                    3.8202e-06,
                    3.9319e-06,
                    4.0444e-06,
                    4.1576e-06,
                    4.2716e-06,
                    4.3864e-06,
                    4.502e-06,
                    4.6185e-06,
                    4.7417e-06,
                    4.8719e-06,
                    5.0091e-06,
                    5.1533e-06,
                    5.3048e-06,
                    5.4634e-06,
                    5.6293e-06,
                    5.8025e-06,
                    5.9829e-06,
                    6.1707e-06,
                    6.3715e-06,
                    6.5854e-06,
                    6.8124e-06,
                    7.0401e-06,
                    7.278e-06,
                    7.526e-06,
                    7.7842e-06,
                    8.0611e-06,
                    8.3569e-06,
                    8.6719e-06,
                    9.004e-06,
                    9.3538e-06,
                    9.7214e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003
                ],
                "Land_3GHG": 0.31,
                "Land_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018
                ],
                "Total_CO2": 0.11,
                "Total_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012
                ],
                "Fossil_CO2": 0.01,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    8.2139e-08,
                    1.5082e-07,
                    2.2762e-07,
                    2.9143e-07,
                    3.6661e-07,
                    4.4156e-07,
                    5.2834e-07,
                    6.172e-07,
                    6.9145e-07,
                    7.624e-07,
                    9.472e-07,
                    1.2244e-06,
                    1.5214e-06,
                    1.8349e-06,
                    2.1501e-06,
                    2.4636e-06,
                    2.787e-06,
                    3.1137e-06,
                    3.4503e-06,
                    3.7869e-06,
                    4.1433e-06,
                    4.5096e-06,
                    4.8841e-06,
                    5.2455e-06,
                    5.6233e-06,
                    6.0028e-06,
                    6.4021e-06,
                    6.808e-06,
                    7.2139e-06,
                    7.6396e-06,
                    8.0736e-06,
                    8.5191e-06,
                    8.9613e-06,
                    9.3903e-06,
                    9.8308e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CO2": 0.33,
                "Land_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012
                ],
                "Total_CH4": 0.17,
                "Total_CH4_timeseries": [
                    1.3116e-07,
                    2.6412e-07,
                    3.9892e-07,
                    5.3554e-07,
                    6.7402e-07,
                    8.1435e-07,
                    9.5655e-07,
                    1.1006e-06,
                    1.2466e-06,
                    1.3945e-06,
                    1.5459e-06,
                    1.701e-06,
                    1.8596e-06,
                    2.0218e-06,
                    2.1876e-06,
                    2.357e-06,
                    2.5301e-06,
                    2.7068e-06,
                    2.8872e-06,
                    3.0712e-06,
                    3.2574e-06,
                    3.4457e-06,
                    3.6362e-06,
                    3.8288e-06,
                    4.0235e-06,
                    4.2204e-06,
                    4.4195e-06,
                    4.6207e-06,
                    4.824e-06,
                    5.0296e-06,
                    5.2357e-06,
                    5.4426e-06,
                    5.6501e-06,
                    5.8584e-06,
                    6.0672e-06,
                    6.2768e-06,
                    6.4871e-06,
                    6.698e-06,
                    6.9097e-06,
                    7.122e-06,
                    7.3351e-06,
                    7.5488e-06,
                    7.7633e-06,
                    7.9784e-06,
                    8.1943e-06,
                    8.4109e-06,
                    8.6282e-06,
                    8.8462e-06,
                    9.0649e-06,
                    9.2844e-06,
                    9.5165e-06,
                    9.7614e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007
                ],
                "Fossil_CH4": 0.08,
                "Fossil_CH4_timeseries": [
                    4.7994e-08,
                    9.7731e-08,
                    1.4922e-07,
                    2.0248e-07,
                    2.5751e-07,
                    3.1433e-07,
                    3.7295e-07,
                    4.3339e-07,
                    4.9564e-07,
                    5.5974e-07,
                    6.2604e-07,
                    6.9455e-07,
                    7.6528e-07,
                    8.3826e-07,
                    9.1348e-07,
                    9.9097e-07,
                    1.0707e-06,
                    1.1528e-06,
                    1.2371e-06,
                    1.3238e-06,
                    1.4112e-06,
                    1.4994e-06,
                    1.5883e-06,
                    1.6779e-06,
                    1.7683e-06,
                    1.8594e-06,
                    1.9513e-06,
                    2.044e-06,
                    2.1374e-06,
                    2.2315e-06,
                    2.3261e-06,
                    2.4212e-06,
                    2.5167e-06,
                    2.6127e-06,
                    2.7091e-06,
                    2.8059e-06,
                    2.9033e-06,
                    3.001e-06,
                    3.0993e-06,
                    3.198e-06,
                    3.2972e-06,
                    3.3969e-06,
                    3.497e-06,
                    3.5976e-06,
                    3.6987e-06,
                    3.8003e-06,
                    3.9023e-06,
                    4.0049e-06,
                    4.1079e-06,
                    4.2114e-06,
                    4.3214e-06,
                    4.4379e-06,
                    4.5609e-06,
                    4.6906e-06,
                    4.8269e-06,
                    4.9699e-06,
                    5.1198e-06,
                    5.2764e-06,
                    5.44e-06,
                    5.6105e-06,
                    5.7938e-06,
                    5.99e-06,
                    6.1991e-06,
                    6.4086e-06,
                    6.6281e-06,
                    6.8575e-06,
                    7.0969e-06,
                    7.3547e-06,
                    7.6312e-06,
                    7.9268e-06,
                    8.2392e-06,
                    8.569e-06,
                    8.9165e-06,
                    9.282e-06,
                    9.6659e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_CH4": 0.31,
                "Land_CH4_timeseries": [
                    8.3162e-08,
                    1.6639e-07,
                    2.4969e-07,
                    3.3307e-07,
                    4.1651e-07,
                    5.0002e-07,
                    5.836e-07,
                    6.6725e-07,
                    7.5097e-07,
                    8.3476e-07,
                    9.1991e-07,
                    1.0064e-06,
                    1.0943e-06,
                    1.1835e-06,
                    1.2741e-06,
                    1.366e-06,
                    1.4593e-06,
                    1.554e-06,
                    1.65e-06,
                    1.7474e-06,
                    1.8462e-06,
                    1.9464e-06,
                    2.0479e-06,
                    2.1509e-06,
                    2.2553e-06,
                    2.361e-06,
                    2.4682e-06,
                    2.5767e-06,
                    2.6867e-06,
                    2.798e-06,
                    2.9096e-06,
                    3.0214e-06,
                    3.1334e-06,
                    3.2457e-06,
                    3.3582e-06,
                    3.4709e-06,
                    3.5838e-06,
                    3.697e-06,
                    3.8104e-06,
                    3.924e-06,
                    4.0379e-06,
                    4.1519e-06,
                    4.2663e-06,
                    4.3808e-06,
                    4.4956e-06,
                    4.6106e-06,
                    4.7258e-06,
                    4.8413e-06,
                    4.957e-06,
                    5.073e-06,
                    5.1951e-06,
                    5.3235e-06,
                    5.4582e-06,
                    5.599e-06,
                    5.7461e-06,
                    5.8994e-06,
                    6.0589e-06,
                    6.2247e-06,
                    6.3967e-06,
                    6.5749e-06,
                    6.7807e-06,
                    7.0141e-06,
                    7.275e-06,
                    7.5634e-06,
                    7.8794e-06,
                    8.223e-06,
                    8.5942e-06,
                    8.9929e-06,
                    9.4191e-06,
                    9.873e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Total_N2O": 0.15,
                "Total_N2O_timeseries": [
                    5.6513e-08,
                    1.1413e-07,
                    1.7282e-07,
                    2.3249e-07,
                    2.9309e-07,
                    3.545e-07,
                    4.166e-07,
                    4.7926e-07,
                    5.4233e-07,
                    6.0563e-07,
                    6.6906e-07,
                    7.3258e-07,
                    7.9619e-07,
                    8.5986e-07,
                    9.2358e-07,
                    9.8737e-07,
                    1.0512e-06,
                    1.1152e-06,
                    1.1792e-06,
                    1.2434e-06,
                    1.3086e-06,
                    1.3764e-06,
                    1.4481e-06,
                    1.5245e-06,
                    1.6061e-06,
                    1.6929e-06,
                    1.7847e-06,
                    1.881e-06,
                    1.9807e-06,
                    2.0825e-06,
                    2.1855e-06,
                    2.2895e-06,
                    2.3944e-06,
                    2.5e-06,
                    2.6062e-06,
                    2.7131e-06,
                    2.8206e-06,
                    2.9288e-06,
                    3.0377e-06,
                    3.1525e-06,
                    3.2685e-06,
                    3.3858e-06,
                    3.5044e-06,
                    3.6244e-06,
                    3.7458e-06,
                    3.8687e-06,
                    3.9932e-06,
                    4.1193e-06,
                    4.2471e-06,
                    4.3765e-06,
                    4.5077e-06,
                    4.6405e-06,
                    4.7751e-06,
                    4.9115e-06,
                    5.0497e-06,
                    5.19e-06,
                    5.3324e-06,
                    5.4772e-06,
                    5.6246e-06,
                    5.7747e-06,
                    5.9289e-06,
                    6.0889e-06,
                    6.2562e-06,
                    6.432e-06,
                    6.6172e-06,
                    6.8123e-06,
                    7.0176e-06,
                    7.2329e-06,
                    7.4577e-06,
                    7.6914e-06,
                    7.9342e-06,
                    8.187e-06,
                    8.4506e-06,
                    8.7251e-06,
                    9.0102e-06,
                    9.3051e-06,
                    9.6086e-06,
                    9.9189e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_N2O": 0.05,
                "Fossil_N2O_timeseries": [
                    5.5143e-09,
                    1.1117e-08,
                    1.6805e-08,
                    2.2574e-08,
                    2.842e-08,
                    3.4335e-08,
                    4.0314e-08,
                    4.6348e-08,
                    5.2426e-08,
                    5.8539e-08,
                    6.468e-08,
                    7.0848e-08,
                    7.7041e-08,
                    8.3257e-08,
                    8.9498e-08,
                    9.5762e-08,
                    1.0205e-07,
                    1.0837e-07,
                    1.1471e-07,
                    1.2108e-07,
                    1.2753e-07,
                    1.3417e-07,
                    1.4106e-07,
                    1.4826e-07,
                    1.5579e-07,
                    1.6367e-07,
                    1.7188e-07,
                    1.8038e-07,
                    1.8911e-07,
                    1.9799e-07,
                    2.0697e-07,
                    2.1602e-07,
                    2.2515e-07,
                    2.3434e-07,
                    2.436e-07,
                    2.5291e-07,
                    2.6228e-07,
                    2.7171e-07,
                    2.8121e-07,
                    2.9137e-07,
                    3.0174e-07,
                    3.1234e-07,
                    3.2319e-07,
                    3.3429e-07,
                    3.4567e-07,
                    3.5732e-07,
                    3.6928e-07,
                    3.8154e-07,
                    3.9412e-07,
                    4.0703e-07,
                    4.203e-07,
                    4.3399e-07,
                    4.4813e-07,
                    4.6276e-07,
                    4.7787e-07,
                    4.9347e-07,
                    5.0954e-07,
                    5.2604e-07,
                    5.4292e-07,
                    5.6013e-07,
                    5.7761e-07,
                    5.9534e-07,
                    6.1331e-07,
                    6.315e-07,
                    6.4991e-07,
                    6.6851e-07,
                    6.8733e-07,
                    7.0636e-07,
                    7.256e-07,
                    7.4509e-07,
                    7.648e-07,
                    7.8475e-07,
                    8.0493e-07,
                    8.2533e-07,
                    8.4597e-07,
                    8.6685e-07,
                    8.88e-07,
                    9.0944e-07,
                    9.3118e-07,
                    9.5327e-07,
                    9.7577e-07,
                    9.9881e-07,
                    1.0225e-06,
                    1.0469e-06,
                    1.072e-06,
                    1.098e-06,
                    1.1249e-06,
                    1.1527e-06,
                    1.1813e-06,
                    1.2109e-06,
                    1.2415e-06,
                    1.2732e-06,
                    1.3062e-06,
                    1.3407e-06,
                    1.3766e-06,
                    1.414e-06,
                    1.453e-06,
                    1.4937e-06,
                    1.5359e-06,
                    1.5798e-06,
                    1.6253e-06,
                    1.6727e-06,
                    1.7222e-06,
                    1.774e-06,
                    1.8281e-06,
                    1.8844e-06,
                    1.9429e-06,
                    2.0034e-06,
                    2.0656e-06,
                    2.1293e-06,
                    2.1943e-06,
                    2.2603e-06,
                    2.3272e-06,
                    2.3951e-06,
                    2.464e-06,
                    2.534e-06,
                    2.6052e-06,
                    2.6779e-06,
                    2.7523e-06,
                    2.8294e-06,
                    2.9065e-06,
                    2.9846e-06,
                    3.0633e-06,
                    3.1414e-06,
                    3.2221e-06,
                    3.3032e-06,
                    3.3849e-06,
                    3.4672e-06,
                    3.5515e-06,
                    3.6371e-06,
                    3.7238e-06,
                    3.8311e-06,
                    3.9405e-06,
                    4.0478e-06,
                    4.1595e-06,
                    4.2745e-06,
                    4.3893e-06,
                    4.5033e-06,
                    4.6252e-06,
                    4.7598e-06,
                    4.8984e-06,
                    5.0268e-06,
                    5.1579e-06,
                    5.2946e-06,
                    5.4488e-06,
                    5.6071e-06,
                    5.7477e-06,
                    5.8887e-06,
                    6.0502e-06,
                    6.2173e-06,
                    6.3853e-06,
                    6.5555e-06,
                    6.7286e-06,
                    6.9062e-06,
                    7.0882e-06,
                    7.2725e-06,
                    7.4601e-06,
                    7.6505e-06,
                    7.8458e-06,
                    8.0472e-06,
                    8.252e-06,
                    8.459e-06,
                    8.6653e-06,
                    8.8777e-06,
                    9.0972e-06,
                    9.3255e-06,
                    9.5568e-06,
                    9.791e-06,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.19,
                "Land_N2O_timeseries": [
                    5.0998e-08,
                    1.0302e-07,
                    1.5601e-07,
                    2.0992e-07,
                    2.6467e-07,
                    3.2016e-07,
                    3.7628e-07,
                    4.3291e-07,
                    4.899e-07,
                    5.4709e-07,
                    6.0438e-07,
                    6.6174e-07,
                    7.1915e-07,
                    7.766e-07,
                    8.3408e-07,
                    8.9161e-07,
                    9.4917e-07,
                    1.0068e-06,
                    1.0645e-06,
                    1.1223e-06,
                    1.1811e-06,
                    1.2423e-06,
                    1.3071e-06,
                    1.3763e-06,
                    1.4503e-06,
                    1.5292e-06,
                    1.6129e-06,
                    1.7006e-06,
                    1.7916e-06,
                    1.8845e-06,
                    1.9786e-06,
                    2.0735e-06,
                    2.1692e-06,
                    2.2656e-06,
                    2.3626e-06,
                    2.4602e-06,
                    2.5583e-06,
                    2.6571e-06,
                    2.7565e-06,
                    2.8611e-06,
                    2.9668e-06,
                    3.0734e-06,
                    3.1812e-06,
                    3.2901e-06,
                    3.4001e-06,
                    3.5114e-06,
                    3.624e-06,
                    3.7378e-06,
                    3.853e-06,
                    3.9695e-06,
                    4.0874e-06,
                    4.2066e-06,
                    4.327e-06,
                    4.4487e-06,
                    4.5719e-06,
                    4.6965e-06,
                    4.8229e-06,
                    4.9512e-06,
                    5.0817e-06,
                    5.2146e-06,
                    5.3513e-06,
                    5.4935e-06,
                    5.6429e-06,
                    5.8005e-06,
                    5.9673e-06,
                    6.1438e-06,
                    6.3302e-06,
                    6.5265e-06,
                    6.7321e-06,
                    6.9463e-06,
                    7.1694e-06,
                    7.4023e-06,
                    7.6457e-06,
                    7.8998e-06,
                    8.1642e-06,
                    8.4382e-06,
                    8.7206e-06,
                    9.0095e-06,
                    9.3028e-06,
                    9.5978e-06,
                    9.8919e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -8.47218,
                                7.55459
                            ],
                            [
                                -8.4192,
                                7.60611
                            ],
                            [
                                -8.29115,
                                7.57944
                            ],
                            [
                                -8.2145,
                                7.5359
                            ],
                            [
                                -8.17499,
                                7.57866
                            ],
                            [
                                -8.13832,
                                7.69335
                            ],
                            [
                                -8.09629,
                                7.72146
                            ],
                            [
                                -8.07401,
                                7.80914
                            ],
                            [
                                -8.11156,
                                7.8429
                            ],
                            [
                                -8.04265,
                                8.03086
                            ],
                            [
                                -7.94984,
                                8.04218
                            ],
                            [
                                -8.01244,
                                8.10023
                            ],
                            [
                                -8.0085,
                                8.16064
                            ],
                            [
                                -8.03931,
                                8.20296
                            ],
                            [
                                -8.08863,
                                8.16809
                            ],
                            [
                                -8.17793,
                                8.19999
                            ],
                            [
                                -8.23115,
                                8.2812
                            ],
                            [
                                -8.24352,
                                8.44393
                            ],
                            [
                                -8.19316,
                                8.50131
                            ],
                            [
                                -8.09408,
                                8.50349
                            ],
                            [
                                -7.91571,
                                8.48456
                            ],
                            [
                                -7.88373,
                                8.41866
                            ],
                            [
                                -7.78873,
                                8.463
                            ],
                            [
                                -7.74664,
                                8.37533
                            ],
                            [
                                -7.65222,
                                8.37489
                            ],
                            [
                                -7.6805,
                                8.44531
                            ],
                            [
                                -7.66178,
                                8.50605
                            ],
                            [
                                -7.68792,
                                8.54699
                            ],
                            [
                                -7.7688,
                                8.76246
                            ],
                            [
                                -7.9165,
                                8.7663
                            ],
                            [
                                -7.96105,
                                8.81213
                            ],
                            [
                                -7.91887,
                                8.9995
                            ],
                            [
                                -7.7873,
                                9.10641
                            ],
                            [
                                -7.85382,
                                9.17679
                            ],
                            [
                                -7.92478,
                                9.21791
                            ],
                            [
                                -7.88812,
                                9.28958
                            ],
                            [
                                -7.88735,
                                9.34404
                            ],
                            [
                                -7.85035,
                                9.4347
                            ],
                            [
                                -7.97092,
                                9.39586
                            ],
                            [
                                -8.05854,
                                9.40226
                            ],
                            [
                                -8.14855,
                                9.53486
                            ],
                            [
                                -8.1286,
                                9.65423
                            ],
                            [
                                -8.12771,
                                9.75852
                            ],
                            [
                                -8.10274,
                                9.82932
                            ],
                            [
                                -8.16392,
                                9.92558
                            ],
                            [
                                -8.10059,
                                10.05118
                            ],
                            [
                                -8.02025,
                                10.09357
                            ],
                            [
                                -7.97855,
                                10.17511
                            ],
                            [
                                -7.94757,
                                10.24164
                            ],
                            [
                                -7.97161,
                                10.31675
                            ],
                            [
                                -8.09115,
                                10.3582
                            ],
                            [
                                -8.11834,
                                10.4179
                            ],
                            [
                                -8.22434,
                                10.40978
                            ],
                            [
                                -8.27698,
                                10.52374
                            ],
                            [
                                -8.30125,
                                10.63703
                            ],
                            [
                                -8.29629,
                                10.75166
                            ],
                            [
                                -8.32648,
                                10.77668
                            ],
                            [
                                -8.2759,
                                10.85357
                            ],
                            [
                                -8.28743,
                                10.99511
                            ],
                            [
                                -8.34779,
                                11.06767
                            ],
                            [
                                -8.48261,
                                11.06398
                            ],
                            [
                                -8.51479,
                                10.97301
                            ],
                            [
                                -8.58966,
                                10.9509
                            ],
                            [
                                -8.68037,
                                10.96488
                            ],
                            [
                                -8.61049,
                                11.12764
                            ],
                            [
                                -8.5649,
                                11.15482
                            ],
                            [
                                -8.55507,
                                11.21142
                            ],
                            [
                                -8.49715,
                                11.21655
                            ],
                            [
                                -8.48039,
                                11.28808
                            ],
                            [
                                -8.41985,
                                11.27037
                            ],
                            [
                                -8.39658,
                                11.38183
                            ],
                            [
                                -8.50001,
                                11.39817
                            ],
                            [
                                -8.53341,
                                11.4768
                            ],
                            [
                                -8.58242,
                                11.44436
                            ],
                            [
                                -8.65323,
                                11.49826
                            ],
                            [
                                -8.69025,
                                11.5882
                            ],
                            [
                                -8.85345,
                                11.6292
                            ],
                            [
                                -8.79532,
                                11.9219
                            ],
                            [
                                -8.80615,
                                12.00546
                            ],
                            [
                                -8.85628,
                                12.04123
                            ],
                            [
                                -8.91254,
                                12.04251
                            ],
                            [
                                -8.8963,
                                12.14655
                            ],
                            [
                                -8.92661,
                                12.19747
                            ],
                            [
                                -8.99267,
                                12.22474
                            ],
                            [
                                -8.96884,
                                12.34753
                            ],
                            [
                                -9.03532,
                                12.4229
                            ],
                            [
                                -9.15715,
                                12.48441
                            ],
                            [
                                -9.25329,
                                12.50179
                            ],
                            [
                                -9.3602,
                                12.49439
                            ],
                            [
                                -9.40143,
                                12.46311
                            ],
                            [
                                -9.29831,
                                12.35734
                            ],
                            [
                                -9.32106,
                                12.27279
                            ],
                            [
                                -9.36847,
                                12.24603
                            ],
                            [
                                -9.47939,
                                12.24524
                            ],
                            [
                                -9.54168,
                                12.19353
                            ],
                            [
                                -9.62932,
                                12.17287
                            ],
                            [
                                -9.67754,
                                12.12285
                            ],
                            [
                                -9.7013,
                                12.02426
                            ],
                            [
                                -9.81287,
                                12.0571
                            ],
                            [
                                -9.8817,
                                12.05693
                            ],
                            [
                                -9.91732,
                                12.09951
                            ],
                            [
                                -10.06668,
                                12.13963
                            ],
                            [
                                -10.09,
                                12.17907
                            ],
                            [
                                -10.34056,
                                12.21802
                            ],
                            [
                                -10.37196,
                                12.16824
                            ],
                            [
                                -10.45427,
                                12.11763
                            ],
                            [
                                -10.51797,
                                12.10642
                            ],
                            [
                                -10.52315,
                                12.04251
                            ],
                            [
                                -10.61728,
                                11.97165
                            ],
                            [
                                -10.64375,
                                11.9112
                            ],
                            [
                                -10.73503,
                                11.92156
                            ],
                            [
                                -10.79243,
                                12.03363
                            ],
                            [
                                -10.78969,
                                12.10729
                            ],
                            [
                                -10.87575,
                                12.16074
                            ],
                            [
                                -10.93154,
                                12.2221
                            ],
                            [
                                -11.04552,
                                12.21857
                            ],
                            [
                                -11.07291,
                                12.1368
                            ],
                            [
                                -11.13319,
                                12.09473
                            ],
                            [
                                -11.18382,
                                12.01807
                            ],
                            [
                                -11.26356,
                                11.99584
                            ],
                            [
                                -11.3587,
                                12.05795
                            ],
                            [
                                -11.376,
                                12.1031
                            ],
                            [
                                -11.46358,
                                12.13409
                            ],
                            [
                                -11.49557,
                                12.2116
                            ],
                            [
                                -11.43434,
                                12.29641
                            ],
                            [
                                -11.43865,
                                12.37839
                            ],
                            [
                                -11.37946,
                                12.41356
                            ],
                            [
                                -11.45984,
                                12.441
                            ],
                            [
                                -11.66249,
                                12.42318
                            ],
                            [
                                -11.75896,
                                12.38843
                            ],
                            [
                                -11.86154,
                                12.40258
                            ],
                            [
                                -11.89476,
                                12.42731
                            ],
                            [
                                -12.01259,
                                12.39666
                            ],
                            [
                                -12.09592,
                                12.4212
                            ],
                            [
                                -12.15948,
                                12.36864
                            ],
                            [
                                -12.23536,
                                12.35467
                            ],
                            [
                                -12.33139,
                                12.31138
                            ],
                            [
                                -12.40217,
                                12.36705
                            ],
                            [
                                -12.50521,
                                12.39713
                            ],
                            [
                                -12.56218,
                                12.36847
                            ],
                            [
                                -12.63257,
                                12.43064
                            ],
                            [
                                -12.73616,
                                12.42958
                            ],
                            [
                                -12.83274,
                                12.48634
                            ],
                            [
                                -12.88783,
                                12.54011
                            ],
                            [
                                -12.92992,
                                12.53112
                            ],
                            [
                                -12.96782,
                                12.46265
                            ],
                            [
                                -13.0711,
                                12.49185
                            ],
                            [
                                -13.05133,
                                12.58512
                            ],
                            [
                                -13.07429,
                                12.63854
                            ],
                            [
                                -13.18662,
                                12.62809
                            ],
                            [
                                -13.28782,
                                12.65209
                            ],
                            [
                                -13.57843,
                                12.67492
                            ],
                            [
                                -13.70827,
                                12.67621
                            ],
                            [
                                -13.71018,
                                12.59706
                            ],
                            [
                                -13.63318,
                                12.4594
                            ],
                            [
                                -13.66498,
                                12.40557
                            ],
                            [
                                -13.66791,
                                12.31655
                            ],
                            [
                                -13.73097,
                                12.24964
                            ],
                            [
                                -13.86224,
                                12.27386
                            ],
                            [
                                -13.95666,
                                12.17932
                            ],
                            [
                                -13.81855,
                                12.08266
                            ],
                            [
                                -13.81073,
                                12.05181
                            ],
                            [
                                -13.70436,
                                12.00613
                            ],
                            [
                                -13.7213,
                                11.8877
                            ],
                            [
                                -13.71564,
                                11.70787
                            ],
                            [
                                -13.77284,
                                11.68243
                            ],
                            [
                                -13.84675,
                                11.71917
                            ],
                            [
                                -13.87136,
                                11.66481
                            ],
                            [
                                -13.92618,
                                11.67634
                            ],
                            [
                                -14.08298,
                                11.62649
                            ],
                            [
                                -14.14038,
                                11.65843
                            ],
                            [
                                -14.26489,
                                11.66611
                            ],
                            [
                                -14.32436,
                                11.60161
                            ],
                            [
                                -14.51739,
                                11.49351
                            ],
                            [
                                -14.67118,
                                11.49157
                            ],
                            [
                                -14.77972,
                                11.35343
                            ],
                            [
                                -14.8414,
                                11.19939
                            ],
                            [
                                -14.90279,
                                11.09278
                            ],
                            [
                                -14.84672,
                                11.08496
                            ],
                            [
                                -14.72331,
                                11.027
                            ],
                            [
                                -14.73845,
                                10.95732
                            ],
                            [
                                -14.70521,
                                10.90432
                            ],
                            [
                                -14.70319,
                                10.81468
                            ],
                            [
                                -14.59278,
                                10.89113
                            ],
                            [
                                -14.51921,
                                10.84593
                            ],
                            [
                                -14.56469,
                                10.74917
                            ],
                            [
                                -14.60564,
                                10.70168
                            ],
                            [
                                -14.61499,
                                10.57898
                            ],
                            [
                                -14.66512,
                                10.51243
                            ],
                            [
                                -14.65295,
                                10.45611
                            ],
                            [
                                -14.56394,
                                10.46745
                            ],
                            [
                                -14.49694,
                                10.4249
                            ],
                            [
                                -14.45503,
                                10.29864
                            ],
                            [
                                -14.45005,
                                10.21246
                            ],
                            [
                                -14.38627,
                                10.23395
                            ],
                            [
                                -14.32275,
                                10.20591
                            ],
                            [
                                -14.2698,
                                10.22612
                            ],
                            [
                                -14.14492,
                                10.21686
                            ],
                            [
                                -13.99401,
                                10.11654
                            ],
                            [
                                -13.94349,
                                10.10424
                            ],
                            [
                                -13.91463,
                                10.05614
                            ],
                            [
                                -13.97061,
                                9.97857
                            ],
                            [
                                -13.78835,
                                9.84259
                            ],
                            [
                                -13.75255,
                                9.77681
                            ],
                            [
                                -13.70585,
                                9.74551
                            ],
                            [
                                -13.60885,
                                9.76423
                            ],
                            [
                                -13.62785,
                                9.63968
                            ],
                            [
                                -13.67351,
                                9.55452
                            ],
                            [
                                -13.55984,
                                9.5894
                            ],
                            [
                                -13.39182,
                                9.56793
                            ],
                            [
                                -13.4084,
                                9.50316
                            ],
                            [
                                -13.39051,
                                9.43254
                            ],
                            [
                                -13.41783,
                                9.39222
                            ],
                            [
                                -13.40755,
                                9.28459
                            ],
                            [
                                -13.28959,
                                9.30516
                            ],
                            [
                                -13.23606,
                                9.29064
                            ],
                            [
                                -13.25135,
                                9.17049
                            ],
                            [
                                -13.31402,
                                9.07107
                            ],
                            [
                                -13.30266,
                                9.04041
                            ],
                            [
                                -13.17755,
                                9.09058
                            ],
                            [
                                -13.08599,
                                9.04896
                            ],
                            [
                                -13.00622,
                                9.09492
                            ],
                            [
                                -12.9559,
                                9.18569
                            ],
                            [
                                -12.94436,
                                9.2734
                            ],
                            [
                                -12.87254,
                                9.29696
                            ],
                            [
                                -12.81403,
                                9.28756
                            ],
                            [
                                -12.75455,
                                9.39252
                            ],
                            [
                                -12.68779,
                                9.40939
                            ],
                            [
                                -12.62105,
                                9.59982
                            ],
                            [
                                -12.53634,
                                9.71879
                            ],
                            [
                                -12.4912,
                                9.8158
                            ],
                            [
                                -12.43029,
                                9.88146
                            ],
                            [
                                -12.22723,
                                9.92399
                            ],
                            [
                                -12.12482,
                                9.87227
                            ],
                            [
                                -11.90746,
                                9.93632
                            ],
                            [
                                -11.88126,
                                9.99727
                            ],
                            [
                                -11.21438,
                                10.00031
                            ],
                            [
                                -11.17401,
                                9.97226
                            ],
                            [
                                -11.16077,
                                9.89452
                            ],
                            [
                                -11.03989,
                                9.79866
                            ],
                            [
                                -10.86101,
                                9.55877
                            ],
                            [
                                -10.8424,
                                9.44246
                            ],
                            [
                                -10.81559,
                                9.39382
                            ],
                            [
                                -10.73067,
                                9.37893
                            ],
                            [
                                -10.66997,
                                9.31001
                            ],
                            [
                                -10.67052,
                                9.20221
                            ],
                            [
                                -10.72286,
                                9.18319
                            ],
                            [
                                -10.73257,
                                9.08397
                            ],
                            [
                                -10.6599,
                                9.08111
                            ],
                            [
                                -10.58556,
                                9.04386
                            ],
                            [
                                -10.59811,
                                8.97485
                            ],
                            [
                                -10.58401,
                                8.82285
                            ],
                            [
                                -10.47033,
                                8.67416
                            ],
                            [
                                -10.48173,
                                8.63832
                            ],
                            [
                                -10.58071,
                                8.59363
                            ],
                            [
                                -10.64953,
                                8.47466
                            ],
                            [
                                -10.6722,
                                8.34019
                            ],
                            [
                                -10.5593,
                                8.30586
                            ],
                            [
                                -10.44569,
                                8.40359
                            ],
                            [
                                -10.38598,
                                8.49278
                            ],
                            [
                                -10.28204,
                                8.48795
                            ],
                            [
                                -10.21323,
                                8.48102
                            ],
                            [
                                -10.1647,
                                8.51484
                            ],
                            [
                                -10.0867,
                                8.51755
                            ],
                            [
                                -10.05251,
                                8.49181
                            ],
                            [
                                -10.06717,
                                8.42979
                            ],
                            [
                                -9.99577,
                                8.44102
                            ],
                            [
                                -9.93368,
                                8.49176
                            ],
                            [
                                -9.80371,
                                8.50327
                            ],
                            [
                                -9.77801,
                                8.54839
                            ],
                            [
                                -9.7048,
                                8.47979
                            ],
                            [
                                -9.66725,
                                8.49176
                            ],
                            [
                                -9.53496,
                                8.38463
                            ],
                            [
                                -9.48873,
                                8.38097
                            ],
                            [
                                -9.5159,
                                8.24244
                            ],
                            [
                                -9.51546,
                                8.17681
                            ],
                            [
                                -9.46365,
                                8.16478
                            ],
                            [
                                -9.43052,
                                8.02445
                            ],
                            [
                                -9.42323,
                                7.86285
                            ],
                            [
                                -9.34481,
                                7.74807
                            ],
                            [
                                -9.36762,
                                7.69686
                            ],
                            [
                                -9.35542,
                                7.626
                            ],
                            [
                                -9.4185,
                                7.47281
                            ],
                            [
                                -9.39487,
                                7.38909
                            ],
                            [
                                -9.35068,
                                7.42836
                            ],
                            [
                                -9.27555,
                                7.38037
                            ],
                            [
                                -9.20343,
                                7.38084
                            ],
                            [
                                -9.20084,
                                7.32097
                            ],
                            [
                                -9.12077,
                                7.27647
                            ],
                            [
                                -9.06589,
                                7.20106
                            ],
                            [
                                -9.01688,
                                7.24359
                            ],
                            [
                                -8.83348,
                                7.28377
                            ],
                            [
                                -8.84577,
                                7.34356
                            ],
                            [
                                -8.70849,
                                7.50996
                            ],
                            [
                                -8.7223,
                                7.55186
                            ],
                            [
                                -8.7067,
                                7.63876
                            ],
                            [
                                -8.65686,
                                7.69596
                            ],
                            [
                                -8.56043,
                                7.69196
                            ],
                            [
                                -8.56397,
                                7.62499
                            ],
                            [
                                -8.47218,
                                7.55459
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -15.07476,
                                10.87519
                            ],
                            [
                                -15.01814,
                                10.78395
                            ],
                            [
                                -14.90409,
                                10.91773
                            ],
                            [
                                -14.95541,
                                10.97418
                            ],
                            [
                                -15.00236,
                                10.95102
                            ],
                            [
                                -15.07476,
                                10.87519
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "GNB",
                "Country": "Guinea-Bissau",
                "Total_3GHG": 0.01,
                "Total_3GHG_timeseries": [
                    1.0645e-07,
                    2.2012e-07,
                    3.3538e-07,
                    4.5237e-07,
                    5.7586e-07,
                    7.0239e-07,
                    8.3133e-07,
                    9.5705e-07,
                    1.0822e-06,
                    1.1977e-06,
                    1.3074e-06,
                    1.4134e-06,
                    1.5789e-06,
                    1.7502e-06,
                    1.9168e-06,
                    2.0815e-06,
                    2.2461e-06,
                    2.42e-06,
                    2.588e-06,
                    2.7556e-06,
                    2.9238e-06,
                    3.0948e-06,
                    3.2658e-06,
                    3.4376e-06,
                    3.619e-06,
                    3.796e-06,
                    3.9724e-06,
                    4.1497e-06,
                    4.3292e-06,
                    4.5127e-06,
                    4.7047e-06,
                    4.8944e-06,
                    5.0354e-06,
                    5.178e-06,
                    5.3165e-06,
                    5.4518e-06,
                    5.5797e-06,
                    5.7018e-06,
                    5.8202e-06,
                    5.9428e-06,
                    6.0729e-06,
                    6.1962e-06,
                    6.3179e-06,
                    6.4442e-06,
                    6.5634e-06,
                    6.6813e-06,
                    6.8008e-06,
                    6.9161e-06,
                    7.0339e-06,
                    7.1609e-06,
                    7.301e-06,
                    7.4392e-06,
                    7.5856e-06,
                    7.7427e-06,
                    7.8957e-06,
                    8.0631e-06,
                    8.2295e-06,
                    8.4044e-06,
                    8.5933e-06,
                    8.791e-06,
                    8.9994e-06,
                    9.2234e-06,
                    9.4527e-06,
                    9.7149e-06,
                    9.9827e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    5.0428e-09,
                    1.0112e-08,
                    1.5208e-08,
                    2.033e-08,
                    2.548e-08,
                    3.0657e-08,
                    3.5861e-08,
                    4.1093e-08,
                    4.6352e-08,
                    5.1638e-08,
                    5.7019e-08,
                    6.2494e-08,
                    1.2952e-07,
                    1.9671e-07,
                    2.6408e-07,
                    3.3162e-07,
                    3.9934e-07,
                    4.6722e-07,
                    5.3528e-07,
                    6.0351e-07,
                    6.7191e-07,
                    7.4048e-07,
                    8.0924e-07,
                    8.7819e-07,
                    9.4732e-07,
                    1.0167e-06,
                    1.0862e-06,
                    1.1559e-06,
                    1.226e-06,
                    1.2965e-06,
                    1.3673e-06,
                    1.4385e-06,
                    1.4532e-06,
                    1.4688e-06,
                    1.4856e-06,
                    1.4967e-06,
                    1.5029e-06,
                    1.5046e-06,
                    1.5021e-06,
                    1.496e-06,
                    1.4866e-06,
                    1.4742e-06,
                    1.4591e-06,
                    1.4414e-06,
                    1.4216e-06,
                    1.3997e-06,
                    1.3761e-06,
                    1.3507e-06,
                    1.3237e-06,
                    1.2951e-06,
                    1.2652e-06,
                    1.2356e-06,
                    1.2056e-06,
                    1.1752e-06,
                    1.1444e-06,
                    1.1192e-06,
                    1.0994e-06,
                    1.0843e-06,
                    1.0736e-06,
                    1.0669e-06,
                    1.0653e-06,
                    1.0685e-06,
                    1.0762e-06,
                    1.0882e-06,
                    1.1043e-06,
                    1.1243e-06,
                    1.1481e-06,
                    1.1755e-06,
                    1.2063e-06,
                    1.2405e-06,
                    1.2779e-06,
                    1.3171e-06,
                    1.358e-06,
                    1.4008e-06,
                    1.4453e-06,
                    1.4917e-06,
                    1.5398e-06,
                    1.5898e-06,
                    1.6416e-06,
                    1.6952e-06,
                    1.7498e-06,
                    1.8053e-06,
                    1.8611e-06,
                    1.9174e-06,
                    1.9743e-06,
                    2.0316e-06,
                    2.0895e-06,
                    2.1478e-06,
                    2.2066e-06,
                    2.2658e-06,
                    2.326e-06,
                    2.3872e-06,
                    2.4494e-06,
                    2.5127e-06,
                    2.5829e-06,
                    2.66e-06,
                    2.7444e-06,
                    2.8361e-06,
                    2.9353e-06,
                    3.0512e-06,
                    3.1725e-06,
                    3.3042e-06,
                    3.4418e-06,
                    3.5868e-06,
                    3.7411e-06,
                    3.9034e-06,
                    4.0736e-06,
                    4.252e-06,
                    4.4402e-06,
                    4.6381e-06,
                    4.8487e-06,
                    5.0718e-06,
                    5.306e-06,
                    5.5483e-06,
                    5.795e-06,
                    6.0431e-06,
                    6.2864e-06,
                    6.5417e-06,
                    6.7998e-06,
                    7.0878e-06,
                    7.3819e-06,
                    7.6793e-06,
                    8.0021e-06,
                    8.3283e-06,
                    8.6762e-06,
                    9.0298e-06,
                    9.4068e-06,
                    9.7921e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_3GHG": 0.03,
                "Land_3GHG_timeseries": [
                    1.014e-07,
                    2.1001e-07,
                    3.2017e-07,
                    4.3204e-07,
                    5.5038e-07,
                    6.7173e-07,
                    7.9547e-07,
                    9.1596e-07,
                    1.0358e-06,
                    1.1461e-06,
                    1.2504e-06,
                    1.3509e-06,
                    1.4494e-06,
                    1.5535e-06,
                    1.6527e-06,
                    1.7499e-06,
                    1.8468e-06,
                    1.9528e-06,
                    2.0527e-06,
                    2.1521e-06,
                    2.2519e-06,
                    2.3543e-06,
                    2.4565e-06,
                    2.5594e-06,
                    2.6717e-06,
                    2.7794e-06,
                    2.8862e-06,
                    2.9939e-06,
                    3.1032e-06,
                    3.2162e-06,
                    3.3373e-06,
                    3.4559e-06,
                    3.5822e-06,
                    3.7091e-06,
                    3.831e-06,
                    3.9551e-06,
                    4.0768e-06,
                    4.1972e-06,
                    4.3181e-06,
                    4.4468e-06,
                    4.5863e-06,
                    4.722e-06,
                    4.8589e-06,
                    5.0027e-06,
                    5.1418e-06,
                    5.2815e-06,
                    5.4247e-06,
                    5.5654e-06,
                    5.7102e-06,
                    5.8658e-06,
                    6.0358e-06,
                    6.2036e-06,
                    6.38e-06,
                    6.5675e-06,
                    6.7513e-06,
                    6.9438e-06,
                    7.1301e-06,
                    7.3202e-06,
                    7.5197e-06,
                    7.7241e-06,
                    7.9341e-06,
                    8.155e-06,
                    8.3765e-06,
                    8.6267e-06,
                    8.8784e-06,
                    9.1367e-06,
                    9.3939e-06,
                    9.6652e-06,
                    9.9403e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Total_CO2": 0.01,
                "Total_CO2_timeseries": [
                    7.7017e-08,
                    1.6104e-07,
                    2.4644e-07,
                    3.3338e-07,
                    4.2664e-07,
                    5.2275e-07,
                    6.2114e-07,
                    7.1617e-07,
                    8.1049e-07,
                    8.952e-07,
                    9.7366e-07,
                    1.048e-06,
                    1.1201e-06,
                    1.1976e-06,
                    1.2699e-06,
                    1.34e-06,
                    1.4094e-06,
                    1.4878e-06,
                    1.5597e-06,
                    1.6308e-06,
                    1.702e-06,
                    1.7751e-06,
                    1.8471e-06,
                    1.9187e-06,
                    1.9987e-06,
                    2.0729e-06,
                    2.1452e-06,
                    2.2173e-06,
                    2.2904e-06,
                    2.3665e-06,
                    2.4504e-06,
                    2.5316e-06,
                    2.6204e-06,
                    2.7096e-06,
                    2.7936e-06,
                    2.8798e-06,
                    2.9633e-06,
                    3.0455e-06,
                    3.128e-06,
                    3.2173e-06,
                    3.3171e-06,
                    3.4131e-06,
                    3.5099e-06,
                    3.6135e-06,
                    3.712e-06,
                    3.8109e-06,
                    3.9131e-06,
                    4.0125e-06,
                    4.1157e-06,
                    4.2294e-06,
                    4.3567e-06,
                    4.4809e-06,
                    4.613e-06,
                    4.7553e-06,
                    4.8931e-06,
                    5.0387e-06,
                    5.1772e-06,
                    5.3185e-06,
                    5.4684e-06,
                    5.622e-06,
                    5.776e-06,
                    5.9353e-06,
                    6.0895e-06,
                    6.2663e-06,
                    6.4384e-06,
                    6.6109e-06,
                    6.7759e-06,
                    6.9487e-06,
                    7.1191e-06,
                    7.3316e-06,
                    7.5644e-06,
                    7.812e-06,
                    8.0724e-06,
                    8.3328e-06,
                    8.6016e-06,
                    8.896e-06,
                    9.1956e-06,
                    9.4873e-06,
                    9.7768e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    3.3e-09,
                    4.95e-09,
                    9.9e-09,
                    1.32e-08,
                    1.65e-08,
                    2.145e-08,
                    2.64e-08,
                    3.135e-08,
                    3.63e-08,
                    4.29e-08,
                    5.115e-08,
                    6.435e-08,
                    8.25e-08,
                    1.0395e-07,
                    1.3035e-07,
                    1.6005e-07,
                    1.8975e-07,
                    2.112e-07,
                    2.3925e-07,
                    2.6565e-07,
                    2.97e-07,
                    3.3e-07,
                    3.597e-07,
                    4.092e-07,
                    4.554e-07,
                    5.0655e-07,
                    5.4945e-07,
                    5.9565e-07,
                    6.4185e-07,
                    6.9135e-07,
                    7.5735e-07,
                    8.217e-07,
                    8.8605e-07,
                    9.504e-07,
                    1.023e-06,
                    1.1005e-06,
                    1.1831e-06,
                    1.2705e-06,
                    1.3678e-06,
                    1.4718e-06,
                    1.5494e-06,
                    1.6286e-06,
                    1.7094e-06,
                    1.7919e-06,
                    1.8744e-06,
                    1.9569e-06,
                    2.0493e-06,
                    2.14e-06,
                    2.2176e-06,
                    2.3051e-06,
                    2.371e-06,
                    2.4387e-06,
                    2.508e-06,
                    2.5954e-06,
                    2.6862e-06,
                    2.7819e-06,
                    2.8793e-06,
                    2.9832e-06,
                    3.0855e-06,
                    3.1911e-06,
                    3.2983e-06,
                    3.4072e-06,
                    3.5178e-06,
                    3.6284e-06,
                    3.7455e-06,
                    3.8709e-06,
                    4.0079e-06,
                    4.1448e-06,
                    4.285e-06,
                    4.4302e-06,
                    4.5639e-06,
                    4.7085e-06,
                    4.8556e-06
                ],
                "Land_CO2": 0.03,
                "Land_CO2_timeseries": [
                    7.7017e-08,
                    1.6104e-07,
                    2.4644e-07,
                    3.3338e-07,
                    4.2664e-07,
                    5.2275e-07,
                    6.2114e-07,
                    7.1617e-07,
                    8.1049e-07,
                    8.952e-07,
                    9.7366e-07,
                    1.048e-06,
                    1.1201e-06,
                    1.1976e-06,
                    1.2699e-06,
                    1.34e-06,
                    1.4094e-06,
                    1.4878e-06,
                    1.5597e-06,
                    1.6308e-06,
                    1.702e-06,
                    1.7751e-06,
                    1.8471e-06,
                    1.9187e-06,
                    1.9987e-06,
                    2.0729e-06,
                    2.1452e-06,
                    2.2173e-06,
                    2.2904e-06,
                    2.3665e-06,
                    2.4504e-06,
                    2.5316e-06,
                    2.6204e-06,
                    2.7096e-06,
                    2.7936e-06,
                    2.8798e-06,
                    2.9633e-06,
                    3.0455e-06,
                    3.128e-06,
                    3.2173e-06,
                    3.3171e-06,
                    3.4131e-06,
                    3.5099e-06,
                    3.6135e-06,
                    3.712e-06,
                    3.8109e-06,
                    3.9131e-06,
                    4.0125e-06,
                    4.1157e-06,
                    4.2294e-06,
                    4.3567e-06,
                    4.4809e-06,
                    4.613e-06,
                    4.7553e-06,
                    4.8931e-06,
                    5.0387e-06,
                    5.1772e-06,
                    5.3185e-06,
                    5.4684e-06,
                    5.622e-06,
                    5.776e-06,
                    5.9353e-06,
                    6.0895e-06,
                    6.2663e-06,
                    6.4384e-06,
                    6.6109e-06,
                    6.7759e-06,
                    6.9487e-06,
                    7.1191e-06,
                    7.3316e-06,
                    7.5644e-06,
                    7.812e-06,
                    8.0724e-06,
                    8.3328e-06,
                    8.6016e-06,
                    8.896e-06,
                    9.1956e-06,
                    9.4873e-06,
                    9.7768e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_CH4": 0.02,
                "Total_CH4_timeseries": [
                    1.9859e-08,
                    3.9747e-08,
                    5.9664e-08,
                    7.9611e-08,
                    9.9589e-08,
                    1.196e-07,
                    1.3964e-07,
                    1.5972e-07,
                    1.7982e-07,
                    1.9997e-07,
                    2.2046e-07,
                    2.4129e-07,
                    3.2392e-07,
                    4.0697e-07,
                    4.9044e-07,
                    5.7434e-07,
                    6.5866e-07,
                    7.434e-07,
                    8.2856e-07,
                    9.1415e-07,
                    1.0002e-06,
                    1.0866e-06,
                    1.1734e-06,
                    1.2607e-06,
                    1.3483e-06,
                    1.4364e-06,
                    1.5249e-06,
                    1.6139e-06,
                    1.7034e-06,
                    1.7936e-06,
                    1.8842e-06,
                    1.9752e-06,
                    2.0096e-06,
                    2.0451e-06,
                    2.0817e-06,
                    2.1128e-06,
                    2.1389e-06,
                    2.1605e-06,
                    2.1781e-06,
                    2.192e-06,
                    2.2026e-06,
                    2.2102e-06,
                    2.2151e-06,
                    2.2176e-06,
                    2.2178e-06,
                    2.216e-06,
                    2.2125e-06,
                    2.2073e-06,
                    2.2003e-06,
                    2.1919e-06,
                    2.1827e-06,
                    2.1744e-06,
                    2.1663e-06,
                    2.1582e-06,
                    2.1503e-06,
                    2.1487e-06,
                    2.1528e-06,
                    2.1624e-06,
                    2.1769e-06,
                    2.196e-06,
                    2.2247e-06,
                    2.2627e-06,
                    2.3099e-06,
                    2.3659e-06,
                    2.4306e-06,
                    2.5038e-06,
                    2.5853e-06,
                    2.675e-06,
                    2.7728e-06,
                    2.8784e-06,
                    2.9922e-06,
                    3.1127e-06,
                    3.2399e-06,
                    3.3738e-06,
                    3.5144e-06,
                    3.6618e-06,
                    3.8159e-06,
                    3.9767e-06,
                    4.1443e-06,
                    4.3186e-06,
                    4.4961e-06,
                    4.6767e-06,
                    4.8598e-06,
                    5.0457e-06,
                    5.2343e-06,
                    5.4405e-06,
                    5.6651e-06,
                    5.9084e-06,
                    6.1711e-06,
                    6.4536e-06,
                    6.7578e-06,
                    7.0843e-06,
                    7.4339e-06,
                    7.8071e-06,
                    8.2105e-06,
                    8.6448e-06,
                    9.1109e-06,
                    9.6095e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_CH4": 0.01,
                "Fossil_CH4_timeseries": [
                    4.3016e-09,
                    8.6188e-09,
                    1.2952e-08,
                    1.7303e-08,
                    2.1671e-08,
                    2.6057e-08,
                    3.0463e-08,
                    3.4889e-08,
                    3.9336e-08,
                    4.3804e-08,
                    4.8362e-08,
                    5.3011e-08,
                    1.192e-07,
                    1.8556e-07,
                    2.5209e-07,
                    3.1879e-07,
                    3.8565e-07,
                    4.5268e-07,
                    5.1988e-07,
                    5.8725e-07,
                    6.5477e-07,
                    7.2246e-07,
                    7.9029e-07,
                    8.5829e-07,
                    9.2644e-07,
                    9.9474e-07,
                    1.0632e-06,
                    1.1318e-06,
                    1.2008e-06,
                    1.2702e-06,
                    1.3399e-06,
                    1.41e-06,
                    1.4235e-06,
                    1.438e-06,
                    1.4535e-06,
                    1.4635e-06,
                    1.4685e-06,
                    1.4689e-06,
                    1.4653e-06,
                    1.4579e-06,
                    1.4472e-06,
                    1.4335e-06,
                    1.417e-06,
                    1.398e-06,
                    1.3768e-06,
                    1.3535e-06,
                    1.3284e-06,
                    1.3016e-06,
                    1.273e-06,
                    1.2428e-06,
                    1.2114e-06,
                    1.1802e-06,
                    1.1485e-06,
                    1.1164e-06,
                    1.0838e-06,
                    1.0568e-06,
                    1.0351e-06,
                    1.0181e-06,
                    1.0055e-06,
                    9.9683e-07,
                    9.9321e-07,
                    9.9436e-07,
                    1e-06,
                    1.0099e-06,
                    1.024e-06,
                    1.0419e-06,
                    1.0635e-06,
                    1.0887e-06,
                    1.1174e-06,
                    1.1494e-06,
                    1.1845e-06,
                    1.2214e-06,
                    1.2601e-06,
                    1.3005e-06,
                    1.3427e-06,
                    1.3867e-06,
                    1.4325e-06,
                    1.48e-06,
                    1.5294e-06,
                    1.5805e-06,
                    1.6326e-06,
                    1.6855e-06,
                    1.7387e-06,
                    1.7923e-06,
                    1.8464e-06,
                    1.9008e-06,
                    1.9557e-06,
                    2.011e-06,
                    2.0667e-06,
                    2.1227e-06,
                    2.1796e-06,
                    2.2374e-06,
                    2.2961e-06,
                    2.3557e-06,
                    2.422e-06,
                    2.4953e-06,
                    2.5755e-06,
                    2.6629e-06,
                    2.7576e-06,
                    2.8656e-06,
                    2.9806e-06,
                    3.1024e-06,
                    3.2315e-06,
                    3.3679e-06,
                    3.5117e-06,
                    3.6632e-06,
                    3.8225e-06,
                    3.9898e-06,
                    4.165e-06,
                    4.3482e-06,
                    4.539e-06,
                    4.7372e-06,
                    4.9431e-06,
                    5.1522e-06,
                    5.3621e-06,
                    5.5735e-06,
                    5.7881e-06,
                    6.0079e-06,
                    6.232e-06,
                    6.4799e-06,
                    6.7319e-06,
                    6.9904e-06,
                    7.2538e-06,
                    7.5239e-06,
                    7.8097e-06,
                    8.1083e-06,
                    8.4264e-06,
                    8.7519e-06,
                    9.0921e-06,
                    9.4649e-06,
                    9.8402e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CH4": 0.03,
                "Land_CH4_timeseries": [
                    1.5558e-08,
                    3.1128e-08,
                    4.6712e-08,
                    6.2309e-08,
                    7.7919e-08,
                    9.3541e-08,
                    1.0918e-07,
                    1.2483e-07,
                    1.4049e-07,
                    1.5616e-07,
                    1.7209e-07,
                    1.8828e-07,
                    2.0471e-07,
                    2.2141e-07,
                    2.3835e-07,
                    2.5555e-07,
                    2.7301e-07,
                    2.9072e-07,
                    3.0868e-07,
                    3.269e-07,
                    3.4538e-07,
                    3.6412e-07,
                    3.8312e-07,
                    4.0238e-07,
                    4.2191e-07,
                    4.4169e-07,
                    4.6174e-07,
                    4.8205e-07,
                    5.0261e-07,
                    5.2345e-07,
                    5.4432e-07,
                    5.6523e-07,
                    5.8619e-07,
                    6.0719e-07,
                    6.2824e-07,
                    6.4932e-07,
                    6.7045e-07,
                    6.9162e-07,
                    7.1283e-07,
                    7.3409e-07,
                    7.5539e-07,
                    7.7673e-07,
                    7.9812e-07,
                    8.1954e-07,
                    8.4102e-07,
                    8.6253e-07,
                    8.8409e-07,
                    9.0569e-07,
                    9.2734e-07,
                    9.4903e-07,
                    9.7132e-07,
                    9.9422e-07,
                    1.0177e-06,
                    1.0418e-06,
                    1.0665e-06,
                    1.0918e-06,
                    1.1178e-06,
                    1.1443e-06,
                    1.1714e-06,
                    1.1991e-06,
                    1.2315e-06,
                    1.2684e-06,
                    1.3099e-06,
                    1.356e-06,
                    1.4067e-06,
                    1.462e-06,
                    1.5219e-06,
                    1.5863e-06,
                    1.6554e-06,
                    1.7291e-06,
                    1.8077e-06,
                    1.8913e-06,
                    1.9798e-06,
                    2.0733e-06,
                    2.1717e-06,
                    2.2751e-06,
                    2.3834e-06,
                    2.4966e-06,
                    2.6149e-06,
                    2.738e-06,
                    2.8635e-06,
                    2.9912e-06,
                    3.1212e-06,
                    3.2534e-06,
                    3.3879e-06,
                    3.5397e-06,
                    3.7093e-06,
                    3.8974e-06,
                    4.1044e-06,
                    4.3309e-06,
                    4.5782e-06,
                    4.8469e-06,
                    5.1378e-06,
                    5.4514e-06,
                    5.7884e-06,
                    6.1496e-06,
                    6.5354e-06,
                    6.9466e-06,
                    7.3839e-06,
                    7.8479e-06,
                    8.3376e-06,
                    8.8527e-06,
                    9.3933e-06,
                    9.9599e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_N2O": 0.02,
                "Total_N2O_timeseries": [
                    9.5722e-09,
                    1.9332e-08,
                    2.927e-08,
                    3.9377e-08,
                    4.9639e-08,
                    6.0038e-08,
                    7.0555e-08,
                    8.1167e-08,
                    9.1848e-08,
                    1.0257e-07,
                    1.1331e-07,
                    1.2407e-07,
                    1.3484e-07,
                    1.4563e-07,
                    1.5642e-07,
                    1.6723e-07,
                    1.7804e-07,
                    1.8887e-07,
                    1.9972e-07,
                    2.106e-07,
                    2.2165e-07,
                    2.3314e-07,
                    2.4528e-07,
                    2.5821e-07,
                    2.7201e-07,
                    2.8671e-07,
                    3.0224e-07,
                    3.1853e-07,
                    3.3539e-07,
                    3.5261e-07,
                    3.7003e-07,
                    3.8762e-07,
                    4.0535e-07,
                    4.2321e-07,
                    4.4118e-07,
                    4.5926e-07,
                    4.7744e-07,
                    4.9573e-07,
                    5.1415e-07,
                    5.3354e-07,
                    5.5312e-07,
                    5.7291e-07,
                    5.929e-07,
                    6.1313e-07,
                    6.3358e-07,
                    6.5427e-07,
                    6.7521e-07,
                    6.9641e-07,
                    7.1787e-07,
                    7.3959e-07,
                    7.6159e-07,
                    7.8385e-07,
                    8.0637e-07,
                    8.2917e-07,
                    8.5226e-07,
                    8.7566e-07,
                    8.994e-07,
                    9.2352e-07,
                    9.4805e-07,
                    9.7305e-07,
                    9.9872e-07,
                    1.0254e-06,
                    1.0533e-06,
                    1.0827e-06,
                    1.1136e-06,
                    1.1463e-06,
                    1.1808e-06,
                    1.2169e-06,
                    1.2547e-06,
                    1.294e-06,
                    1.3349e-06,
                    1.3775e-06,
                    1.4219e-06,
                    1.4682e-06,
                    1.5163e-06,
                    1.5661e-06,
                    1.6174e-06,
                    1.6698e-06,
                    1.7231e-06,
                    1.7767e-06,
                    1.8301e-06,
                    1.8831e-06,
                    1.9353e-06,
                    1.9867e-06,
                    2.037e-06,
                    2.0864e-06,
                    2.1349e-06,
                    2.1827e-06,
                    2.2301e-06,
                    2.2773e-06,
                    2.3293e-06,
                    2.3936e-06,
                    2.4761e-06,
                    2.5806e-06,
                    2.7093e-06,
                    2.8621e-06,
                    3.0372e-06,
                    3.2308e-06,
                    3.4373e-06,
                    3.649e-06,
                    3.8593e-06,
                    4.0643e-06,
                    4.2612e-06,
                    4.448e-06,
                    4.6238e-06,
                    4.7885e-06,
                    4.9433e-06,
                    5.0898e-06,
                    5.2312e-06,
                    5.3711e-06,
                    5.5246e-06,
                    5.6785e-06,
                    5.8327e-06,
                    5.9879e-06,
                    6.1424e-06,
                    6.2968e-06,
                    6.451e-06,
                    6.6052e-06,
                    6.7595e-06,
                    6.9212e-06,
                    7.0811e-06,
                    7.2413e-06,
                    7.4152e-06,
                    7.5614e-06,
                    7.7206e-06,
                    7.889e-06,
                    8.0812e-06,
                    8.2544e-06,
                    8.4407e-06,
                    8.6625e-06,
                    8.8635e-06,
                    9.0937e-06,
                    9.3125e-06,
                    9.5289e-06,
                    9.7304e-06,
                    9.9383e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_N2O": 0.01,
                "Fossil_N2O_timeseries": [
                    7.4125e-10,
                    1.4931e-09,
                    2.2553e-09,
                    3.0274e-09,
                    3.8089e-09,
                    4.5994e-09,
                    5.3979e-09,
                    6.2038e-09,
                    7.0161e-09,
                    7.8338e-09,
                    8.6563e-09,
                    9.4834e-09,
                    1.0315e-08,
                    1.1151e-08,
                    1.1991e-08,
                    1.2836e-08,
                    1.3685e-08,
                    1.4539e-08,
                    1.5397e-08,
                    1.626e-08,
                    1.7133e-08,
                    1.8026e-08,
                    1.8946e-08,
                    1.9898e-08,
                    2.0884e-08,
                    2.1906e-08,
                    2.2961e-08,
                    2.4047e-08,
                    2.5157e-08,
                    2.6284e-08,
                    2.7422e-08,
                    2.857e-08,
                    2.9727e-08,
                    3.0892e-08,
                    3.2066e-08,
                    3.3247e-08,
                    3.4435e-08,
                    3.5632e-08,
                    3.6837e-08,
                    3.8106e-08,
                    3.9397e-08,
                    4.0711e-08,
                    4.2051e-08,
                    4.3417e-08,
                    4.481e-08,
                    4.6232e-08,
                    4.7684e-08,
                    4.9167e-08,
                    5.0682e-08,
                    5.223e-08,
                    5.3814e-08,
                    5.544e-08,
                    5.711e-08,
                    5.8828e-08,
                    6.0594e-08,
                    6.2408e-08,
                    6.4268e-08,
                    6.617e-08,
                    6.8112e-08,
                    7.0086e-08,
                    7.2088e-08,
                    7.4117e-08,
                    7.617e-08,
                    7.8246e-08,
                    8.0345e-08,
                    8.2465e-08,
                    8.4608e-08,
                    8.6772e-08,
                    8.896e-08,
                    9.1173e-08,
                    9.341e-08,
                    9.5671e-08,
                    9.7956e-08,
                    1.0027e-07,
                    1.026e-07,
                    1.0496e-07,
                    1.0735e-07,
                    1.0976e-07,
                    1.1221e-07,
                    1.1469e-07,
                    1.1721e-07,
                    1.1979e-07,
                    1.2242e-07,
                    1.2513e-07,
                    1.2791e-07,
                    1.3077e-07,
                    1.3371e-07,
                    1.3674e-07,
                    1.3986e-07,
                    1.4306e-07,
                    1.4636e-07,
                    1.4977e-07,
                    1.5331e-07,
                    1.5699e-07,
                    1.6081e-07,
                    1.6478e-07,
                    1.6891e-07,
                    1.732e-07,
                    1.7764e-07,
                    1.8224e-07,
                    1.8699e-07,
                    1.9194e-07,
                    1.9708e-07,
                    2.0243e-07,
                    2.08e-07,
                    2.1377e-07,
                    2.1976e-07,
                    2.2593e-07,
                    2.3228e-07,
                    2.3876e-07,
                    2.4537e-07,
                    2.5208e-07,
                    2.5889e-07,
                    2.6579e-07,
                    2.728e-07,
                    2.7991e-07,
                    2.8715e-07,
                    2.9454e-07,
                    3.0209e-07,
                    3.1089e-07,
                    3.1999e-07,
                    3.2929e-07,
                    3.3905e-07,
                    3.4908e-07,
                    3.6003e-07,
                    3.7199e-07,
                    3.8471e-07,
                    3.9839e-07,
                    4.1249e-07,
                    4.2757e-07,
                    4.4351e-07,
                    4.6452e-07,
                    4.8599e-07,
                    5.0671e-07,
                    5.274e-07,
                    5.5007e-07,
                    5.7307e-07,
                    5.9392e-07,
                    6.1693e-07,
                    6.4134e-07,
                    6.663e-07,
                    6.9063e-07,
                    7.1499e-07,
                    7.3982e-07,
                    7.6555e-07,
                    7.9109e-07,
                    8.166e-07,
                    8.4292e-07,
                    8.7146e-07,
                    9.0079e-07,
                    9.3045e-07,
                    9.6067e-07,
                    9.9181e-07,
                    1.0239e-06,
                    1.057e-06,
                    1.0907e-06,
                    1.1254e-06,
                    1.1606e-06,
                    1.1968e-06,
                    1.2337e-06,
                    1.2715e-06,
                    1.3103e-06,
                    1.3498e-06,
                    1.39e-06,
                    1.431e-06,
                    1.473e-06,
                    1.5153e-06,
                    1.5584e-06,
                    1.6021e-06,
                    1.6471e-06,
                    1.6928e-06,
                    1.7403e-06
                ],
                "Land_N2O": 0.03,
                "Land_N2O_timeseries": [
                    8.8309e-09,
                    1.7838e-08,
                    2.7015e-08,
                    3.635e-08,
                    4.583e-08,
                    5.5439e-08,
                    6.5158e-08,
                    7.4964e-08,
                    8.4832e-08,
                    9.4735e-08,
                    1.0465e-07,
                    1.1459e-07,
                    1.2453e-07,
                    1.3448e-07,
                    1.4443e-07,
                    1.5439e-07,
                    1.6436e-07,
                    1.7434e-07,
                    1.8433e-07,
                    1.9434e-07,
                    2.0451e-07,
                    2.1511e-07,
                    2.2634e-07,
                    2.3832e-07,
                    2.5113e-07,
                    2.648e-07,
                    2.7928e-07,
                    2.9448e-07,
                    3.1023e-07,
                    3.2633e-07,
                    3.4261e-07,
                    3.5905e-07,
                    3.7563e-07,
                    3.9232e-07,
                    4.0912e-07,
                    4.2601e-07,
                    4.43e-07,
                    4.601e-07,
                    4.7732e-07,
                    4.9544e-07,
                    5.1373e-07,
                    5.322e-07,
                    5.5085e-07,
                    5.6971e-07,
                    5.8877e-07,
                    6.0804e-07,
                    6.2753e-07,
                    6.4724e-07,
                    6.6718e-07,
                    6.8736e-07,
                    7.0778e-07,
                    7.2841e-07,
                    7.4926e-07,
                    7.7035e-07,
                    7.9167e-07,
                    8.1326e-07,
                    8.3514e-07,
                    8.5735e-07,
                    8.7994e-07,
                    9.0297e-07,
                    9.2663e-07,
                    9.5126e-07,
                    9.7712e-07,
                    1.0044e-06,
                    1.0333e-06,
                    1.0639e-06,
                    1.0961e-06,
                    1.1301e-06,
                    1.1657e-06,
                    1.2028e-06,
                    1.2415e-06,
                    1.2818e-06,
                    1.3239e-06,
                    1.3679e-06,
                    1.4137e-06,
                    1.4612e-06,
                    1.5101e-06,
                    1.5601e-06,
                    1.6109e-06,
                    1.662e-06,
                    1.7129e-06,
                    1.7633e-06,
                    1.8129e-06,
                    1.8616e-06,
                    1.9091e-06,
                    1.9557e-06,
                    2.0012e-06,
                    2.046e-06,
                    2.0902e-06,
                    2.1343e-06,
                    2.1829e-06,
                    2.2438e-06,
                    2.3228e-06,
                    2.4237e-06,
                    2.5485e-06,
                    2.6973e-06,
                    2.8683e-06,
                    3.0576e-06,
                    3.2596e-06,
                    3.4667e-06,
                    3.6723e-06,
                    3.8724e-06,
                    4.0641e-06,
                    4.2456e-06,
                    4.4158e-06,
                    4.5748e-06,
                    4.7235e-06,
                    4.8639e-06,
                    4.9989e-06,
                    5.1323e-06,
                    5.2792e-06,
                    5.4264e-06,
                    5.5738e-06,
                    5.7221e-06,
                    5.8696e-06,
                    6.0169e-06,
                    6.1639e-06,
                    6.3107e-06,
                    6.4574e-06,
                    6.6103e-06,
                    6.7611e-06,
                    6.912e-06,
                    7.0761e-06,
                    7.2123e-06,
                    7.3606e-06,
                    7.517e-06,
                    7.6965e-06,
                    7.856e-06,
                    8.0282e-06,
                    8.235e-06,
                    8.42e-06,
                    8.6292e-06,
                    8.8265e-06,
                    9.0222e-06,
                    9.203e-06,
                    9.3882e-06,
                    9.5841e-06,
                    9.7732e-06,
                    9.9821e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -16.70743,
                                12.33864
                            ],
                            [
                                -16.68173,
                                12.3431
                            ],
                            [
                                -16.49724,
                                12.25551
                            ],
                            [
                                -16.44568,
                                12.31954
                            ],
                            [
                                -16.36526,
                                12.3204
                            ],
                            [
                                -16.2415,
                                12.345
                            ],
                            [
                                -16.17476,
                                12.38612
                            ],
                            [
                                -16.01132,
                                12.36833
                            ],
                            [
                                -15.78954,
                                12.27802
                            ],
                            [
                                -15.72636,
                                12.24104
                            ],
                            [
                                -15.81062,
                                12.2073
                            ],
                            [
                                -15.90337,
                                12.26701
                            ],
                            [
                                -15.98402,
                                12.25726
                            ],
                            [
                                -16.04705,
                                12.27835
                            ],
                            [
                                -16.13783,
                                12.27563
                            ],
                            [
                                -16.22834,
                                12.23705
                            ],
                            [
                                -16.25222,
                                12.18002
                            ],
                            [
                                -16.15262,
                                12.19653
                            ],
                            [
                                -16.10439,
                                12.11747
                            ],
                            [
                                -16.24182,
                                12.11571
                            ],
                            [
                                -16.32168,
                                12.14481
                            ],
                            [
                                -16.33239,
                                12.02514
                            ],
                            [
                                -16.23166,
                                12.05471
                            ],
                            [
                                -16.16128,
                                12.01775
                            ],
                            [
                                -16.23848,
                                11.97029
                            ],
                            [
                                -16.2132,
                                11.92723
                            ],
                            [
                                -16.08627,
                                11.88714
                            ],
                            [
                                -16.05247,
                                11.91724
                            ],
                            [
                                -15.97806,
                                11.91656
                            ],
                            [
                                -15.93215,
                                11.96218
                            ],
                            [
                                -15.8396,
                                11.97837
                            ],
                            [
                                -15.919,
                                11.88174
                            ],
                            [
                                -15.9647,
                                11.77536
                            ],
                            [
                                -15.95363,
                                11.73952
                            ],
                            [
                                -15.84265,
                                11.77438
                            ],
                            [
                                -15.79353,
                                11.74933
                            ],
                            [
                                -15.71485,
                                11.79514
                            ],
                            [
                                -15.65035,
                                11.8016
                            ],
                            [
                                -15.48536,
                                11.93376
                            ],
                            [
                                -15.39658,
                                11.97005
                            ],
                            [
                                -15.32103,
                                11.95815
                            ],
                            [
                                -15.29008,
                                11.92623
                            ],
                            [
                                -15.16306,
                                11.87609
                            ],
                            [
                                -15.30587,
                                11.86303
                            ],
                            [
                                -15.37563,
                                11.88439
                            ],
                            [
                                -15.50963,
                                11.78009
                            ],
                            [
                                -15.5342,
                                11.68594
                            ],
                            [
                                -15.39722,
                                11.61156
                            ],
                            [
                                -15.23188,
                                11.66805
                            ],
                            [
                                -15.2861,
                                11.4889
                            ],
                            [
                                -15.2817,
                                11.39181
                            ],
                            [
                                -15.31585,
                                11.34219
                            ],
                            [
                                -15.17032,
                                11.26911
                            ],
                            [
                                -15.16089,
                                11.2183
                            ],
                            [
                                -15.20337,
                                11.1832
                            ],
                            [
                                -15.15388,
                                11.10609
                            ],
                            [
                                -15.10732,
                                11.16495
                            ],
                            [
                                -15.05059,
                                11.13997
                            ],
                            [
                                -14.98979,
                                11.24757
                            ],
                            [
                                -14.94342,
                                11.25845
                            ],
                            [
                                -14.97034,
                                11.10132
                            ],
                            [
                                -15.01802,
                                11.12176
                            ],
                            [
                                -15.08346,
                                11.05055
                            ],
                            [
                                -15.09016,
                                10.96254
                            ],
                            [
                                -15.00937,
                                10.99779
                            ],
                            [
                                -14.97183,
                                11.06947
                            ],
                            [
                                -14.91006,
                                11.08015
                            ],
                            [
                                -14.90658,
                                11.0862
                            ],
                            [
                                -14.90279,
                                11.09278
                            ],
                            [
                                -14.8414,
                                11.19939
                            ],
                            [
                                -14.77972,
                                11.35343
                            ],
                            [
                                -14.67118,
                                11.49157
                            ],
                            [
                                -14.51739,
                                11.49351
                            ],
                            [
                                -14.32436,
                                11.60161
                            ],
                            [
                                -14.26489,
                                11.66611
                            ],
                            [
                                -14.14038,
                                11.65843
                            ],
                            [
                                -14.08298,
                                11.62649
                            ],
                            [
                                -13.92618,
                                11.67634
                            ],
                            [
                                -13.87136,
                                11.66481
                            ],
                            [
                                -13.84675,
                                11.71917
                            ],
                            [
                                -13.77284,
                                11.68243
                            ],
                            [
                                -13.71564,
                                11.70787
                            ],
                            [
                                -13.7213,
                                11.8877
                            ],
                            [
                                -13.70436,
                                12.00613
                            ],
                            [
                                -13.81073,
                                12.05181
                            ],
                            [
                                -13.81855,
                                12.08266
                            ],
                            [
                                -13.95666,
                                12.17932
                            ],
                            [
                                -13.86224,
                                12.27386
                            ],
                            [
                                -13.73097,
                                12.24964
                            ],
                            [
                                -13.66791,
                                12.31655
                            ],
                            [
                                -13.66498,
                                12.40557
                            ],
                            [
                                -13.63318,
                                12.4594
                            ],
                            [
                                -13.71018,
                                12.59706
                            ],
                            [
                                -13.70827,
                                12.67621
                            ],
                            [
                                -14.38088,
                                12.67721
                            ],
                            [
                                -14.94283,
                                12.67746
                            ],
                            [
                                -15.17882,
                                12.68045
                            ],
                            [
                                -15.32897,
                                12.612
                            ],
                            [
                                -15.43457,
                                12.53232
                            ],
                            [
                                -15.63493,
                                12.43822
                            ],
                            [
                                -15.69041,
                                12.42412
                            ],
                            [
                                -15.86137,
                                12.44387
                            ],
                            [
                                -15.95786,
                                12.44045
                            ],
                            [
                                -16.06272,
                                12.46929
                            ],
                            [
                                -16.21484,
                                12.45637
                            ],
                            [
                                -16.39011,
                                12.36058
                            ],
                            [
                                -16.59481,
                                12.34637
                            ],
                            [
                                -16.67242,
                                12.35589
                            ],
                            [
                                -16.70743,
                                12.33864
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -16.16216,
                                11.85727
                            ],
                            [
                                -16.15229,
                                11.80641
                            ],
                            [
                                -16.08166,
                                11.75793
                            ],
                            [
                                -16.04112,
                                11.76
                            ],
                            [
                                -15.98487,
                                11.87782
                            ],
                            [
                                -16.16216,
                                11.85727
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -16.09341,
                                11.13371
                            ],
                            [
                                -16.11694,
                                11.18046
                            ],
                            [
                                -16.2323,
                                11.07183
                            ],
                            [
                                -16.15157,
                                11.02393
                            ],
                            [
                                -16.1362,
                                11.0895
                            ],
                            [
                                -16.09341,
                                11.13371
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -16.08003,
                                11.45225
                            ],
                            [
                                -16.02785,
                                11.4251
                            ],
                            [
                                -15.94034,
                                11.4303
                            ],
                            [
                                -15.90838,
                                11.50554
                            ],
                            [
                                -16.02215,
                                11.51144
                            ],
                            [
                                -16.08003,
                                11.45225
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -16.24827,
                                11.54129
                            ],
                            [
                                -16.28351,
                                11.59209
                            ],
                            [
                                -16.34788,
                                11.54419
                            ],
                            [
                                -16.30884,
                                11.48576
                            ],
                            [
                                -16.24827,
                                11.54129
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -16.24827,
                                11.92653
                            ],
                            [
                                -16.31565,
                                11.86584
                            ],
                            [
                                -16.25487,
                                11.83838
                            ],
                            [
                                -16.17793,
                                11.88651
                            ],
                            [
                                -16.24827,
                                11.92653
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -15.54957,
                                11.52648
                            ],
                            [
                                -15.46549,
                                11.55658
                            ],
                            [
                                -15.52079,
                                11.61021
                            ],
                            [
                                -15.58673,
                                11.57019
                            ],
                            [
                                -15.54957,
                                11.52648
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -16.24827,
                                11.21435
                            ],
                            [
                                -16.15583,
                                11.24907
                            ],
                            [
                                -16.20872,
                                11.30595
                            ],
                            [
                                -16.2603,
                                11.2866
                            ],
                            [
                                -16.24827,
                                11.21435
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "GUY",
                "Country": "Guyana",
                "Total_3GHG": 0.04,
                "Total_3GHG_timeseries": [
                    1.3738e-06,
                    3.0364e-06,
                    4.4624e-06,
                    6.0257e-06,
                    7.7325e-06,
                    9.0449e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006
                ],
                "Fossil_3GHG": 0.01,
                "Fossil_3GHG_timeseries": [
                    6.8753e-08,
                    1.386e-07,
                    2.0955e-07,
                    2.816e-07,
                    3.5476e-07,
                    4.2874e-07,
                    5.0354e-07,
                    5.7917e-07,
                    6.5563e-07,
                    7.3292e-07,
                    8.1227e-07,
                    8.9399e-07,
                    9.781e-07,
                    1.0646e-06,
                    1.1536e-06,
                    1.2448e-06,
                    1.3383e-06,
                    1.4341e-06,
                    1.5322e-06,
                    1.6331e-06,
                    1.7366e-06,
                    1.8426e-06,
                    1.9512e-06,
                    2.0624e-06,
                    2.1761e-06,
                    2.2926e-06,
                    2.4118e-06,
                    2.5339e-06,
                    2.6589e-06,
                    2.7868e-06,
                    2.9172e-06,
                    3.0491e-06,
                    3.1827e-06,
                    3.3177e-06,
                    3.454e-06,
                    3.5913e-06,
                    3.7295e-06,
                    3.8685e-06,
                    4.0083e-06,
                    4.1489e-06,
                    4.2903e-06,
                    4.4322e-06,
                    4.5745e-06,
                    4.7172e-06,
                    4.8608e-06,
                    5.0052e-06,
                    5.1499e-06,
                    5.2948e-06,
                    5.44e-06,
                    5.5853e-06,
                    5.7294e-06,
                    5.8718e-06,
                    6.0115e-06,
                    6.1488e-06,
                    6.2841e-06,
                    6.418e-06,
                    6.5675e-06,
                    6.7146e-06,
                    6.842e-06,
                    6.9677e-06,
                    7.0959e-06,
                    7.2276e-06,
                    7.3629e-06,
                    7.5018e-06,
                    7.6446e-06,
                    7.7897e-06,
                    7.9374e-06,
                    8.0873e-06,
                    8.2384e-06,
                    8.3899e-06,
                    8.5462e-06,
                    8.7089e-06,
                    8.8787e-06,
                    9.0556e-06,
                    9.2397e-06,
                    9.4304e-06,
                    9.6116e-06,
                    9.7996e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_3GHG": 0.09,
                "Land_3GHG_timeseries": [
                    1.3051e-06,
                    2.8978e-06,
                    4.2528e-06,
                    5.7441e-06,
                    7.3777e-06,
                    8.6162e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Total_CO2": 0.05,
                "Total_CO2_timeseries": [
                    8.1051e-07,
                    1.9032e-06,
                    2.7528e-06,
                    3.7331e-06,
                    4.8504e-06,
                    5.5671e-06,
                    6.6338e-06,
                    7.7302e-06,
                    8.3856e-06,
                    9.1632e-06,
                    9.834e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Fossil_CO2": 0.01,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.1715e-07,
                    2.4585e-07,
                    3.9765e-07,
                    6.006e-07,
                    8.1345e-07,
                    1.0461e-06,
                    1.2936e-06,
                    1.5345e-06,
                    1.7408e-06,
                    1.9899e-06,
                    2.2869e-06,
                    2.6186e-06,
                    2.9238e-06,
                    3.201e-06,
                    3.493e-06,
                    3.9782e-06,
                    4.5094e-06,
                    5.1051e-06,
                    5.7041e-06,
                    6.3195e-06,
                    7.0307e-06,
                    7.7055e-06,
                    8.4084e-06,
                    9.2202e-06,
                    9.9198e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CO2": 0.13,
                "Land_CO2_timeseries": [
                    8.1051e-07,
                    1.9032e-06,
                    2.7528e-06,
                    3.7331e-06,
                    4.8504e-06,
                    5.5671e-06,
                    6.6338e-06,
                    7.7302e-06,
                    8.3856e-06,
                    9.1632e-06,
                    9.834e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Total_CH4": 0.02,
                "Total_CH4_timeseries": [
                    5.6084e-07,
                    1.1282e-06,
                    1.702e-06,
                    2.2824e-06,
                    2.8692e-06,
                    3.4623e-06,
                    4.0616e-06,
                    4.6672e-06,
                    5.279e-06,
                    5.897e-06,
                    6.5303e-06,
                    7.1791e-06,
                    7.8434e-06,
                    8.5233e-06,
                    9.2189e-06,
                    9.9298e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_CH4": 0.01,
                "Fossil_CH4_timeseries": [
                    6.7826e-08,
                    1.3673e-07,
                    2.0672e-07,
                    2.7781e-07,
                    3.4999e-07,
                    4.2297e-07,
                    4.9677e-07,
                    5.7139e-07,
                    6.4683e-07,
                    7.231e-07,
                    8.0141e-07,
                    8.821e-07,
                    9.6518e-07,
                    1.0507e-06,
                    1.1386e-06,
                    1.2287e-06,
                    1.3212e-06,
                    1.4159e-06,
                    1.5129e-06,
                    1.6128e-06,
                    1.7152e-06,
                    1.8201e-06,
                    1.9275e-06,
                    2.0375e-06,
                    2.15e-06,
                    2.2651e-06,
                    2.383e-06,
                    2.5037e-06,
                    2.6273e-06,
                    2.7537e-06,
                    2.8826e-06,
                    3.0131e-06,
                    3.1452e-06,
                    3.2786e-06,
                    3.4135e-06,
                    3.5493e-06,
                    3.6859e-06,
                    3.8233e-06,
                    3.9615e-06,
                    4.1006e-06,
                    4.2403e-06,
                    4.3805e-06,
                    4.5211e-06,
                    4.6621e-06,
                    4.8038e-06,
                    4.9464e-06,
                    5.0892e-06,
                    5.2322e-06,
                    5.3754e-06,
                    5.5188e-06,
                    5.6608e-06,
                    5.8011e-06,
                    5.9387e-06,
                    6.0738e-06,
                    6.2068e-06,
                    6.3384e-06,
                    6.4855e-06,
                    6.6301e-06,
                    6.755e-06,
                    6.8782e-06,
                    7.0037e-06,
                    7.1327e-06,
                    7.2653e-06,
                    7.4014e-06,
                    7.5414e-06,
                    7.6836e-06,
                    7.8284e-06,
                    7.9752e-06,
                    8.1233e-06,
                    8.2717e-06,
                    8.4249e-06,
                    8.5843e-06,
                    8.7509e-06,
                    8.9246e-06,
                    9.1053e-06,
                    9.2925e-06,
                    9.4704e-06,
                    9.6548e-06,
                    9.8621e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    9.6957e-06,
                    9.3602e-06,
                    9.0358e-06,
                    8.7244e-06,
                    8.4269e-06,
                    8.2164e-06,
                    8.0958e-06,
                    8.0621e-06,
                    8.1277e-06,
                    8.2537e-06,
                    8.4474e-06,
                    8.719e-06,
                    9.0789e-06,
                    9.5399e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CH4": 0.03,
                "Land_CH4_timeseries": [
                    4.9301e-07,
                    9.9144e-07,
                    1.4953e-06,
                    2.0046e-06,
                    2.5192e-06,
                    3.0393e-06,
                    3.5649e-06,
                    4.0958e-06,
                    4.6321e-06,
                    5.1739e-06,
                    5.7289e-06,
                    6.297e-06,
                    6.8782e-06,
                    7.4727e-06,
                    8.0803e-06,
                    8.7011e-06,
                    9.335e-06,
                    9.9821e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_N2O": 0.02,
                "Total_N2O_timeseries": [
                    2.4813e-09,
                    5.0077e-09,
                    7.5776e-09,
                    1.0188e-08,
                    1.2837e-08,
                    1.552e-08,
                    1.8233e-08,
                    2.097e-08,
                    2.3726e-08,
                    2.6494e-08,
                    2.9271e-08,
                    3.2054e-08,
                    3.4845e-08,
                    3.7641e-08,
                    4.0443e-08,
                    4.325e-08,
                    4.6064e-08,
                    4.8884e-08,
                    5.1712e-08,
                    5.4549e-08,
                    5.7428e-08,
                    6.041e-08,
                    6.354e-08,
                    6.6849e-08,
                    7.0356e-08,
                    7.4065e-08,
                    7.7966e-08,
                    8.2037e-08,
                    8.624e-08,
                    9.0526e-08,
                    9.4861e-08,
                    9.9237e-08,
                    1.0365e-07,
                    1.0809e-07,
                    1.1256e-07,
                    1.1706e-07,
                    1.2158e-07,
                    1.2614e-07,
                    1.3072e-07,
                    1.3693e-07,
                    1.4322e-07,
                    1.4969e-07,
                    1.5638e-07,
                    1.6338e-07,
                    1.7072e-07,
                    1.7845e-07,
                    1.8662e-07,
                    1.9525e-07,
                    2.0437e-07,
                    2.1399e-07,
                    2.2429e-07,
                    2.3559e-07,
                    2.481e-07,
                    2.6197e-07,
                    2.7725e-07,
                    2.9394e-07,
                    3.1192e-07,
                    3.3102e-07,
                    3.5097e-07,
                    3.7142e-07,
                    3.9218e-07,
                    4.1323e-07,
                    4.3454e-07,
                    4.561e-07,
                    4.7789e-07,
                    4.9988e-07,
                    5.2205e-07,
                    5.4438e-07,
                    5.6683e-07,
                    5.8937e-07,
                    6.1194e-07,
                    6.3443e-07,
                    6.5677e-07,
                    6.7892e-07,
                    7.0085e-07,
                    7.2256e-07,
                    7.4407e-07,
                    7.6543e-07,
                    7.8671e-07,
                    8.0801e-07,
                    8.2948e-07,
                    8.5132e-07,
                    8.7367e-07,
                    8.9667e-07,
                    9.2041e-07,
                    9.4497e-07,
                    9.7037e-07,
                    9.9664e-07,
                    1.0238e-06,
                    1.0517e-06,
                    1.0812e-06,
                    1.1139e-06,
                    1.151e-06,
                    1.1932e-06,
                    1.241e-06,
                    1.2946e-06,
                    1.3538e-06,
                    1.418e-06,
                    1.4863e-06,
                    1.5576e-06,
                    1.6317e-06,
                    1.7099e-06,
                    1.7933e-06,
                    1.8825e-06,
                    1.9778e-06,
                    2.0794e-06,
                    2.187e-06,
                    2.3003e-06,
                    2.4184e-06,
                    2.5403e-06,
                    2.6525e-06,
                    2.7743e-06,
                    2.8962e-06,
                    3.0327e-06,
                    3.1843e-06,
                    3.339e-06,
                    3.4897e-06,
                    3.6405e-06,
                    3.7919e-06,
                    3.9417e-06,
                    4.0885e-06,
                    4.245e-06,
                    4.4076e-06,
                    4.5805e-06,
                    4.7513e-06,
                    4.917e-06,
                    5.0781e-06,
                    5.2526e-06,
                    5.3945e-06,
                    5.5382e-06,
                    5.6942e-06,
                    5.8509e-06,
                    6.004e-06,
                    6.1487e-06,
                    6.28e-06,
                    6.4249e-06,
                    6.5661e-06,
                    6.7115e-06,
                    6.8566e-06,
                    6.9895e-06,
                    7.14e-06,
                    7.2893e-06,
                    7.4521e-06,
                    7.6144e-06,
                    7.7999e-06,
                    7.9845e-06,
                    8.1815e-06,
                    8.3781e-06,
                    8.5854e-06,
                    8.7706e-06,
                    8.9605e-06,
                    9.1632e-06,
                    9.3754e-06,
                    9.6121e-06,
                    9.81e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_N2O": 0.01,
                "Fossil_N2O_timeseries": [
                    9.2709e-10,
                    1.8683e-09,
                    2.8232e-09,
                    3.7911e-09,
                    4.7715e-09,
                    5.7633e-09,
                    6.7655e-09,
                    7.7769e-09,
                    8.7961e-09,
                    9.8215e-09,
                    1.0852e-08,
                    1.1888e-08,
                    1.2929e-08,
                    1.3974e-08,
                    1.5024e-08,
                    1.6079e-08,
                    1.7138e-08,
                    1.8203e-08,
                    1.9272e-08,
                    2.0347e-08,
                    2.1435e-08,
                    2.2552e-08,
                    2.3706e-08,
                    2.4907e-08,
                    2.6159e-08,
                    2.7462e-08,
                    2.8814e-08,
                    3.021e-08,
                    3.1641e-08,
                    3.3095e-08,
                    3.4564e-08,
                    3.6047e-08,
                    3.7541e-08,
                    3.9045e-08,
                    4.056e-08,
                    4.2085e-08,
                    4.3619e-08,
                    4.5164e-08,
                    4.6719e-08,
                    4.8351e-08,
                    5.0011e-08,
                    5.1701e-08,
                    5.3423e-08,
                    5.5179e-08,
                    5.6969e-08,
                    5.8797e-08,
                    6.0664e-08,
                    6.2571e-08,
                    6.452e-08,
                    6.6512e-08,
                    6.8551e-08,
                    7.0643e-08,
                    7.2792e-08,
                    7.5001e-08,
                    7.7272e-08,
                    7.9606e-08,
                    8.2004e-08,
                    8.4463e-08,
                    8.6983e-08,
                    8.9559e-08,
                    9.219e-08,
                    9.4874e-08,
                    9.761e-08,
                    1.004e-07,
                    1.0324e-07,
                    1.0612e-07,
                    1.0906e-07,
                    1.1205e-07,
                    1.151e-07,
                    1.1819e-07,
                    1.2133e-07,
                    1.2453e-07,
                    1.2777e-07,
                    1.3107e-07,
                    1.3442e-07,
                    1.3782e-07,
                    1.4127e-07,
                    1.4477e-07,
                    1.4833e-07,
                    1.5194e-07,
                    1.5562e-07,
                    1.5935e-07,
                    1.6314e-07,
                    1.6699e-07,
                    1.7091e-07,
                    1.7489e-07,
                    1.7895e-07,
                    1.8308e-07,
                    1.8729e-07,
                    1.9158e-07,
                    1.9598e-07,
                    2.0053e-07,
                    2.0524e-07,
                    2.1014e-07,
                    2.1524e-07,
                    2.2057e-07,
                    2.2612e-07,
                    2.319e-07,
                    2.379e-07,
                    2.4412e-07,
                    2.5057e-07,
                    2.5735e-07,
                    2.6448e-07,
                    2.7203e-07,
                    2.8002e-07,
                    2.8847e-07,
                    2.9739e-07,
                    3.0678e-07,
                    3.1661e-07,
                    3.2686e-07,
                    3.3747e-07,
                    3.484e-07,
                    3.5962e-07,
                    3.7113e-07,
                    3.8295e-07,
                    3.9514e-07,
                    4.0777e-07,
                    4.2093e-07,
                    4.3477e-07,
                    4.4799e-07,
                    4.6107e-07,
                    4.7534e-07,
                    4.9465e-07,
                    5.1548e-07,
                    5.3773e-07,
                    5.5942e-07,
                    5.7986e-07,
                    6.0204e-07,
                    6.2399e-07,
                    6.4689e-07,
                    6.7309e-07,
                    7.0256e-07,
                    7.3595e-07,
                    7.7005e-07,
                    8.0097e-07,
                    8.3048e-07,
                    8.625e-07,
                    8.9215e-07,
                    9.1882e-07,
                    9.463e-07,
                    9.7105e-07,
                    9.9618e-07,
                    1.0209e-06,
                    1.0495e-06,
                    1.0803e-06,
                    1.1132e-06,
                    1.1485e-06,
                    1.1857e-06,
                    1.2274e-06,
                    1.2647e-06,
                    1.303e-06,
                    1.3429e-06,
                    1.3773e-06,
                    1.4144e-06,
                    1.452e-06,
                    1.4844e-06,
                    1.5202e-06,
                    1.5553e-06,
                    1.5859e-06,
                    1.6221e-06,
                    1.6628e-06,
                    1.707e-06,
                    1.7496e-06,
                    1.7935e-06,
                    1.8376e-06,
                    1.8832e-06,
                    1.9253e-06,
                    1.9651e-06,
                    2.0094e-06,
                    2.0492e-06,
                    2.0942e-06,
                    2.1382e-06
                ],
                "Land_N2O": 0.02,
                "Land_N2O_timeseries": [
                    1.5542e-09,
                    3.1394e-09,
                    4.7544e-09,
                    6.3973e-09,
                    8.0658e-09,
                    9.7569e-09,
                    1.1467e-08,
                    1.3193e-08,
                    1.493e-08,
                    1.6673e-08,
                    1.8418e-08,
                    2.0166e-08,
                    2.1916e-08,
                    2.3667e-08,
                    2.5419e-08,
                    2.7172e-08,
                    2.8926e-08,
                    3.0682e-08,
                    3.244e-08,
                    3.4202e-08,
                    3.5993e-08,
                    3.7859e-08,
                    3.9833e-08,
                    4.1942e-08,
                    4.4197e-08,
                    4.6603e-08,
                    4.9152e-08,
                    5.1826e-08,
                    5.4599e-08,
                    5.7431e-08,
                    6.0296e-08,
                    6.319e-08,
                    6.6107e-08,
                    6.9045e-08,
                    7.2001e-08,
                    7.4975e-08,
                    7.7965e-08,
                    8.0974e-08,
                    8.4004e-08,
                    8.8575e-08,
                    9.3211e-08,
                    9.7984e-08,
                    1.0296e-07,
                    1.082e-07,
                    1.1375e-07,
                    1.1966e-07,
                    1.2596e-07,
                    1.3268e-07,
                    1.3985e-07,
                    1.4747e-07,
                    1.5574e-07,
                    1.6494e-07,
                    1.7531e-07,
                    1.8697e-07,
                    1.9998e-07,
                    2.1433e-07,
                    2.2992e-07,
                    2.4655e-07,
                    2.6398e-07,
                    2.8186e-07,
                    2.9999e-07,
                    3.1835e-07,
                    3.3693e-07,
                    3.557e-07,
                    3.7465e-07,
                    3.9376e-07,
                    4.1299e-07,
                    4.3233e-07,
                    4.5173e-07,
                    4.7118e-07,
                    4.9061e-07,
                    5.099e-07,
                    5.29e-07,
                    5.4785e-07,
                    5.6643e-07,
                    5.8474e-07,
                    6.028e-07,
                    6.2066e-07,
                    6.3838e-07,
                    6.5607e-07,
                    6.7387e-07,
                    6.9197e-07,
                    7.1054e-07,
                    7.2968e-07,
                    7.4951e-07,
                    7.7007e-07,
                    7.9143e-07,
                    8.1357e-07,
                    8.3647e-07,
                    8.6009e-07,
                    8.8525e-07,
                    9.1342e-07,
                    9.4575e-07,
                    9.8304e-07,
                    1.0258e-06,
                    1.074e-06,
                    1.1277e-06,
                    1.1861e-06,
                    1.2484e-06,
                    1.3135e-06,
                    1.3811e-06,
                    1.4526e-06,
                    1.5288e-06,
                    1.6104e-06,
                    1.6977e-06,
                    1.7909e-06,
                    1.8896e-06,
                    1.9935e-06,
                    2.1018e-06,
                    2.2134e-06,
                    2.315e-06,
                    2.4259e-06,
                    2.5366e-06,
                    2.6616e-06,
                    2.8014e-06,
                    2.9439e-06,
                    3.0819e-06,
                    3.2195e-06,
                    3.3571e-06,
                    3.4937e-06,
                    3.6274e-06,
                    3.7697e-06,
                    3.913e-06,
                    4.065e-06,
                    4.2136e-06,
                    4.3576e-06,
                    4.4983e-06,
                    4.6506e-06,
                    4.7705e-06,
                    4.8913e-06,
                    5.0211e-06,
                    5.1484e-06,
                    5.268e-06,
                    5.3786e-06,
                    5.479e-06,
                    5.5944e-06,
                    5.7036e-06,
                    5.8193e-06,
                    5.9378e-06,
                    6.0432e-06,
                    6.169e-06,
                    6.2931e-06,
                    6.4312e-06,
                    6.5648e-06,
                    6.7196e-06,
                    6.8713e-06,
                    7.033e-06,
                    7.1924e-06,
                    7.3581e-06,
                    7.5059e-06,
                    7.6576e-06,
                    7.8203e-06,
                    7.998e-06,
                    8.1977e-06,
                    8.358e-06,
                    8.5195e-06,
                    8.6839e-06,
                    8.8741e-06,
                    9.045e-06,
                    9.2332e-06,
                    9.4016e-06,
                    9.5919e-06,
                    9.7979e-06,
                    9.9957e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -56.47737,
                            1.94594
                        ],
                        [
                            -56.54043,
                            2.01736
                        ],
                        [
                            -56.68156,
                            2.01671
                        ],
                        [
                            -56.81177,
                            2.21532
                        ],
                        [
                            -56.80774,
                            2.26183
                        ],
                        [
                            -56.87392,
                            2.29384
                        ],
                        [
                            -56.86891,
                            2.33964
                        ],
                        [
                            -56.92762,
                            2.39451
                        ],
                        [
                            -56.91726,
                            2.43305
                        ],
                        [
                            -56.98858,
                            2.50514
                        ],
                        [
                            -57.01818,
                            2.57434
                        ],
                        [
                            -57.01926,
                            2.64293
                        ],
                        [
                            -57.16886,
                            2.81219
                        ],
                        [
                            -57.21854,
                            2.89845
                        ],
                        [
                            -57.22126,
                            2.97596
                        ],
                        [
                            -57.19349,
                            3.02668
                        ],
                        [
                            -57.25719,
                            3.09816
                        ],
                        [
                            -57.29936,
                            3.17936
                        ],
                        [
                            -57.28326,
                            3.33218
                        ],
                        [
                            -57.3056,
                            3.38667
                        ],
                        [
                            -57.38949,
                            3.36701
                        ],
                        [
                            -57.41838,
                            3.38496
                        ],
                        [
                            -57.48292,
                            3.34287
                        ],
                        [
                            -57.56878,
                            3.35698
                        ],
                        [
                            -57.67835,
                            3.39585
                        ],
                        [
                            -57.62318,
                            3.4602
                        ],
                        [
                            -57.64774,
                            3.54934
                        ],
                        [
                            -57.71441,
                            3.5777
                        ],
                        [
                            -57.74381,
                            3.62689
                        ],
                        [
                            -57.83593,
                            3.68408
                        ],
                        [
                            -57.85408,
                            3.81574
                        ],
                        [
                            -57.89156,
                            3.84412
                        ],
                        [
                            -57.9925,
                            3.98144
                        ],
                        [
                            -58.02702,
                            3.98589
                        ],
                        [
                            -58.02375,
                            4.10933
                        ],
                        [
                            -58.04868,
                            4.15363
                        ],
                        [
                            -58.01996,
                            4.23413
                        ],
                        [
                            -57.94771,
                            4.31552
                        ],
                        [
                            -57.95997,
                            4.39496
                        ],
                        [
                            -57.9188,
                            4.44829
                        ],
                        [
                            -57.82766,
                            4.66431
                        ],
                        [
                            -57.88678,
                            4.77695
                        ],
                        [
                            -57.92333,
                            4.80566
                        ],
                        [
                            -57.83856,
                            4.92302
                        ],
                        [
                            -57.75126,
                            4.94947
                        ],
                        [
                            -57.67257,
                            5.00844
                        ],
                        [
                            -57.60993,
                            4.99194
                        ],
                        [
                            -57.52229,
                            5.00864
                        ],
                        [
                            -57.41446,
                            4.98949
                        ],
                        [
                            -57.38196,
                            5.0144
                        ],
                        [
                            -57.30284,
                            5.01514
                        ],
                        [
                            -57.32148,
                            5.09289
                        ],
                        [
                            -57.29645,
                            5.16755
                        ],
                        [
                            -57.18152,
                            5.16066
                        ],
                        [
                            -57.18161,
                            5.19619
                        ],
                        [
                            -57.2403,
                            5.27501
                        ],
                        [
                            -57.32306,
                            5.34822
                        ],
                        [
                            -57.27273,
                            5.38322
                        ],
                        [
                            -57.26104,
                            5.4813
                        ],
                        [
                            -57.16165,
                            5.6059
                        ],
                        [
                            -57.13782,
                            5.69648
                        ],
                        [
                            -57.134,
                            5.83738
                        ],
                        [
                            -57.14503,
                            5.991
                        ],
                        [
                            -57.1724,
                            6.09816
                        ],
                        [
                            -57.27434,
                            6.21876
                        ],
                        [
                            -57.39559,
                            6.30378
                        ],
                        [
                            -57.4814,
                            6.31859
                        ],
                        [
                            -57.53621,
                            6.28191
                        ],
                        [
                            -57.57938,
                            6.38019
                        ],
                        [
                            -57.62672,
                            6.44661
                        ],
                        [
                            -57.7972,
                            6.59516
                        ],
                        [
                            -57.82037,
                            6.62689
                        ],
                        [
                            -58.02217,
                            6.79789
                        ],
                        [
                            -58.12306,
                            6.82602
                        ],
                        [
                            -58.17912,
                            6.80988
                        ],
                        [
                            -58.27665,
                            6.87151
                        ],
                        [
                            -58.32866,
                            6.8856
                        ],
                        [
                            -58.33482,
                            6.95653
                        ],
                        [
                            -58.4721,
                            7.10961
                        ],
                        [
                            -58.48738,
                            7.19115
                        ],
                        [
                            -58.48331,
                            7.33986
                        ],
                        [
                            -58.67643,
                            7.59731
                        ],
                        [
                            -58.76919,
                            7.63025
                        ],
                        [
                            -58.83016,
                            7.72997
                        ],
                        [
                            -58.86925,
                            7.75415
                        ],
                        [
                            -59.08526,
                            7.99272
                        ],
                        [
                            -59.15969,
                            8.05685
                        ],
                        [
                            -59.45508,
                            8.23461
                        ],
                        [
                            -59.60129,
                            8.30962
                        ],
                        [
                            -59.74001,
                            8.39377
                        ],
                        [
                            -59.79845,
                            8.40291
                        ],
                        [
                            -59.844,
                            8.3631
                        ],
                        [
                            -59.93619,
                            8.48766
                        ],
                        [
                            -59.99402,
                            8.53343
                        ],
                        [
                            -59.82444,
                            8.31939
                        ],
                        [
                            -59.84235,
                            8.23421
                        ],
                        [
                            -59.9349,
                            8.21698
                        ],
                        [
                            -59.97984,
                            8.17221
                        ],
                        [
                            -59.99831,
                            8.06875
                        ],
                        [
                            -60.04635,
                            8.02583
                        ],
                        [
                            -60.1122,
                            8.02943
                        ],
                        [
                            -60.22431,
                            7.96617
                        ],
                        [
                            -60.35325,
                            7.84074
                        ],
                        [
                            -60.52286,
                            7.82792
                        ],
                        [
                            -60.57689,
                            7.73556
                        ],
                        [
                            -60.57083,
                            7.70902
                        ],
                        [
                            -60.64651,
                            7.57203
                        ],
                        [
                            -60.71206,
                            7.5366
                        ],
                        [
                            -60.69516,
                            7.47359
                        ],
                        [
                            -60.65137,
                            7.44934
                        ],
                        [
                            -60.58672,
                            7.331
                        ],
                        [
                            -60.63084,
                            7.23248
                        ],
                        [
                            -60.52577,
                            7.13536
                        ],
                        [
                            -60.44702,
                            7.20122
                        ],
                        [
                            -60.2803,
                            7.11981
                        ],
                        [
                            -60.30237,
                            7.05706
                        ],
                        [
                            -60.39909,
                            6.96388
                        ],
                        [
                            -60.49633,
                            6.89702
                        ],
                        [
                            -60.63894,
                            6.84922
                        ],
                        [
                            -60.73241,
                            6.77612
                        ],
                        [
                            -60.79388,
                            6.81504
                        ],
                        [
                            -60.83555,
                            6.80181
                        ],
                        [
                            -60.91508,
                            6.82256
                        ],
                        [
                            -60.90907,
                            6.76309
                        ],
                        [
                            -60.94523,
                            6.73838
                        ],
                        [
                            -61.06436,
                            6.74629
                        ],
                        [
                            -61.1448,
                            6.7155
                        ],
                        [
                            -61.21269,
                            6.58537
                        ],
                        [
                            -61.14484,
                            6.43887
                        ],
                        [
                            -61.16905,
                            6.32559
                        ],
                        [
                            -61.12205,
                            6.26456
                        ],
                        [
                            -61.11674,
                            6.20258
                        ],
                        [
                            -61.19476,
                            6.1448
                        ],
                        [
                            -61.25876,
                            6.1224
                        ],
                        [
                            -61.38373,
                            5.9789
                        ],
                        [
                            -61.37058,
                            5.91734
                        ],
                        [
                            -60.73177,
                            5.19614
                        ],
                        [
                            -60.6664,
                            5.22119
                        ],
                        [
                            -60.56775,
                            5.18899
                        ],
                        [
                            -60.43731,
                            5.1776
                        ],
                        [
                            -60.39621,
                            5.21127
                        ],
                        [
                            -60.32998,
                            5.19906
                        ],
                        [
                            -60.21198,
                            5.26422
                        ],
                        [
                            -60.12192,
                            5.22171
                        ],
                        [
                            -60.08395,
                            5.1475
                        ],
                        [
                            -59.96976,
                            5.06815
                        ],
                        [
                            -60.03148,
                            4.8055
                        ],
                        [
                            -60.02998,
                            4.70522
                        ],
                        [
                            -60.07451,
                            4.66063
                        ],
                        [
                            -60.09301,
                            4.59561
                        ],
                        [
                            -60.15861,
                            4.5699
                        ],
                        [
                            -60.16258,
                            4.52113
                        ],
                        [
                            -60.06619,
                            4.49442
                        ],
                        [
                            -59.92644,
                            4.50849
                        ],
                        [
                            -59.90528,
                            4.4695
                        ],
                        [
                            -59.78168,
                            4.43939
                        ],
                        [
                            -59.67891,
                            4.34508
                        ],
                        [
                            -59.72671,
                            4.29005
                        ],
                        [
                            -59.71327,
                            4.16994
                        ],
                        [
                            -59.64495,
                            4.14829
                        ],
                        [
                            -59.61914,
                            4.0593
                        ],
                        [
                            -59.51703,
                            3.94047
                        ],
                        [
                            -59.57871,
                            3.88997
                        ],
                        [
                            -59.5935,
                            3.79734
                        ],
                        [
                            -59.6657,
                            3.77634
                        ],
                        [
                            -59.66208,
                            3.71044
                        ],
                        [
                            -59.84983,
                            3.59861
                        ],
                        [
                            -59.86403,
                            3.55841
                        ],
                        [
                            -59.80519,
                            3.49637
                        ],
                        [
                            -59.83284,
                            3.44494
                        ],
                        [
                            -59.7995,
                            3.35521
                        ],
                        [
                            -59.86908,
                            3.27011
                        ],
                        [
                            -59.90987,
                            3.18244
                        ],
                        [
                            -59.90274,
                            3.12254
                        ],
                        [
                            -59.95848,
                            3.06239
                        ],
                        [
                            -59.96239,
                            2.94604
                        ],
                        [
                            -59.99152,
                            2.82581
                        ],
                        [
                            -59.98952,
                            2.68283
                        ],
                        [
                            -59.96311,
                            2.58852
                        ],
                        [
                            -59.90747,
                            2.46473
                        ],
                        [
                            -59.89619,
                            2.36284
                        ],
                        [
                            -59.8009,
                            2.29125
                        ],
                        [
                            -59.72511,
                            2.27842
                        ],
                        [
                            -59.73939,
                            2.17702
                        ],
                        [
                            -59.72087,
                            2.02639
                        ],
                        [
                            -59.75641,
                            1.92085
                        ],
                        [
                            -59.74655,
                            1.84655
                        ],
                        [
                            -59.64243,
                            1.82842
                        ],
                        [
                            -59.67941,
                            1.78498
                        ],
                        [
                            -59.62065,
                            1.7301
                        ],
                        [
                            -59.54793,
                            1.72752
                        ],
                        [
                            -59.47936,
                            1.6297
                        ],
                        [
                            -59.44244,
                            1.60827
                        ],
                        [
                            -59.38117,
                            1.5202
                        ],
                        [
                            -59.34545,
                            1.51905
                        ],
                        [
                            -59.2507,
                            1.39626
                        ],
                        [
                            -59.15511,
                            1.34835
                        ],
                        [
                            -58.93996,
                            1.30882
                        ],
                        [
                            -58.90262,
                            1.23331
                        ],
                        [
                            -58.79748,
                            1.17533
                        ],
                        [
                            -58.74804,
                            1.19764
                        ],
                        [
                            -58.69733,
                            1.28774
                        ],
                        [
                            -58.50655,
                            1.26511
                        ],
                        [
                            -58.47419,
                            1.29866
                        ],
                        [
                            -58.48278,
                            1.46317
                        ],
                        [
                            -58.38311,
                            1.47023
                        ],
                        [
                            -58.38204,
                            1.52871
                        ],
                        [
                            -58.32423,
                            1.58966
                        ],
                        [
                            -58.23294,
                            1.55211
                        ],
                        [
                            -58.16749,
                            1.55791
                        ],
                        [
                            -58.14304,
                            1.5097
                        ],
                        [
                            -58.00873,
                            1.50102
                        ],
                        [
                            -57.99946,
                            1.66413
                        ],
                        [
                            -57.93337,
                            1.64522
                        ],
                        [
                            -57.81772,
                            1.67882
                        ],
                        [
                            -57.77088,
                            1.71791
                        ],
                        [
                            -57.63802,
                            1.68965
                        ],
                        [
                            -57.54606,
                            1.70008
                        ],
                        [
                            -57.45398,
                            1.83796
                        ],
                        [
                            -57.44126,
                            1.88266
                        ],
                        [
                            -57.30391,
                            1.98958
                        ],
                        [
                            -57.23519,
                            1.94671
                        ],
                        [
                            -57.1228,
                            2.01372
                        ],
                        [
                            -57.08038,
                            2.0175
                        ],
                        [
                            -57.06014,
                            1.9585
                        ],
                        [
                            -56.98492,
                            1.9109
                        ],
                        [
                            -56.91529,
                            1.91794
                        ],
                        [
                            -56.79856,
                            1.86392
                        ],
                        [
                            -56.72658,
                            1.91812
                        ],
                        [
                            -56.63645,
                            1.93862
                        ],
                        [
                            -56.59181,
                            1.91542
                        ],
                        [
                            -56.47737,
                            1.94594
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "HTI",
                "Country": "Haiti",
                "Total_3GHG": 0.05,
                "Total_3GHG_timeseries": [
                    1.2747e-06,
                    2.5653e-06,
                    3.899e-06,
                    5.2389e-06,
                    6.6116e-06,
                    7.9801e-06,
                    9.3577e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008
                ],
                "Fossil_3GHG": 0.03,
                "Fossil_3GHG_timeseries": [
                    9.302e-08,
                    1.8849e-07,
                    2.8644e-07,
                    3.8687e-07,
                    4.8981e-07,
                    5.9528e-07,
                    7.033e-07,
                    8.1387e-07,
                    9.2702e-07,
                    1.0428e-06,
                    1.1609e-06,
                    1.2816e-06,
                    1.4047e-06,
                    1.5303e-06,
                    1.6585e-06,
                    1.7892e-06,
                    1.9224e-06,
                    2.0583e-06,
                    2.1968e-06,
                    2.338e-06,
                    2.4792e-06,
                    2.6206e-06,
                    2.762e-06,
                    2.9037e-06,
                    3.0456e-06,
                    3.1878e-06,
                    3.3301e-06,
                    3.4727e-06,
                    3.6154e-06,
                    3.7583e-06,
                    3.9034e-06,
                    4.0508e-06,
                    4.2006e-06,
                    4.3525e-06,
                    4.5068e-06,
                    4.6634e-06,
                    4.8222e-06,
                    4.9834e-06,
                    5.1468e-06,
                    5.3128e-06,
                    5.4824e-06,
                    5.6557e-06,
                    5.8328e-06,
                    6.0136e-06,
                    6.1981e-06,
                    6.3864e-06,
                    6.5785e-06,
                    6.7743e-06,
                    6.974e-06,
                    7.1775e-06,
                    7.3946e-06,
                    7.6258e-06,
                    7.8713e-06,
                    8.1313e-06,
                    8.4063e-06,
                    8.6965e-06,
                    9.0021e-06,
                    9.3237e-06,
                    9.6613e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Land_3GHG": 0.07,
                "Land_3GHG_timeseries": [
                    1.1817e-06,
                    2.3768e-06,
                    3.6126e-06,
                    4.852e-06,
                    6.1218e-06,
                    7.3849e-06,
                    8.6544e-06,
                    9.989e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Total_CO2": 0.03,
                "Total_CO2_timeseries": [
                    1.0158e-06,
                    2.0403e-06,
                    3.1008e-06,
                    4.1601e-06,
                    5.2451e-06,
                    6.3185e-06,
                    7.3937e-06,
                    8.5293e-06,
                    9.6296e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    5.115e-08,
                    1.1055e-07,
                    1.7655e-07,
                    2.475e-07,
                    3.4485e-07,
                    4.6525e-07,
                    5.8397e-07,
                    6.9776e-07,
                    8.2145e-07,
                    9.3523e-07,
                    1.0638e-06,
                    1.1974e-06,
                    1.3342e-06,
                    1.4464e-06,
                    1.5815e-06,
                    1.7184e-06,
                    1.8553e-06,
                    1.9724e-06,
                    2.0911e-06,
                    2.2329e-06,
                    2.4061e-06,
                    2.5874e-06,
                    2.7638e-06,
                    2.9534e-06,
                    3.166e-06,
                    3.3835e-06,
                    3.6862e-06,
                    4.0033e-06,
                    4.3413e-06,
                    4.679e-06,
                    5.0145e-06,
                    5.3563e-06,
                    5.7244e-06,
                    6.1234e-06,
                    6.5301e-06,
                    6.9487e-06,
                    7.3225e-06,
                    7.7273e-06,
                    8.1811e-06,
                    8.6418e-06,
                    9.0899e-06,
                    9.5295e-06,
                    9.9296e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CO2": 0.07,
                "Land_CO2_timeseries": [
                    1.0158e-06,
                    2.0403e-06,
                    3.1008e-06,
                    4.1601e-06,
                    5.2451e-06,
                    6.3185e-06,
                    7.3937e-06,
                    8.5293e-06,
                    9.6296e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Total_CH4": 0.1,
                "Total_CH4_timeseries": [
                    2.4426e-07,
                    4.9552e-07,
                    7.538e-07,
                    1.0191e-06,
                    1.2915e-06,
                    1.571e-06,
                    1.8575e-06,
                    2.1512e-06,
                    2.4521e-06,
                    2.7601e-06,
                    3.0748e-06,
                    3.3962e-06,
                    3.7243e-06,
                    4.0592e-06,
                    4.4008e-06,
                    4.7492e-06,
                    5.1044e-06,
                    5.4664e-06,
                    5.8353e-06,
                    6.2112e-06,
                    6.5847e-06,
                    6.956e-06,
                    7.3251e-06,
                    7.6919e-06,
                    8.0565e-06,
                    8.4189e-06,
                    8.779e-06,
                    9.1369e-06,
                    9.4925e-06,
                    9.846e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Fossil_CH4": 0.11,
                "Fossil_CH4_timeseries": [
                    8.3077e-08,
                    1.6848e-07,
                    2.5624e-07,
                    3.4637e-07,
                    4.389e-07,
                    5.3384e-07,
                    6.3122e-07,
                    7.3107e-07,
                    8.334e-07,
                    9.3823e-07,
                    1.0454e-06,
                    1.155e-06,
                    1.267e-06,
                    1.3814e-06,
                    1.4982e-06,
                    1.6176e-06,
                    1.7394e-06,
                    1.8638e-06,
                    1.9907e-06,
                    2.1202e-06,
                    2.2496e-06,
                    2.3789e-06,
                    2.5082e-06,
                    2.6373e-06,
                    2.7664e-06,
                    2.8954e-06,
                    3.0244e-06,
                    3.1533e-06,
                    3.2821e-06,
                    3.4109e-06,
                    3.5418e-06,
                    3.6749e-06,
                    3.8102e-06,
                    3.9476e-06,
                    4.0873e-06,
                    4.2291e-06,
                    4.3731e-06,
                    4.5193e-06,
                    4.6677e-06,
                    4.8183e-06,
                    4.9724e-06,
                    5.1301e-06,
                    5.2913e-06,
                    5.4561e-06,
                    5.6245e-06,
                    5.7964e-06,
                    5.9719e-06,
                    6.1511e-06,
                    6.3338e-06,
                    6.5201e-06,
                    6.7198e-06,
                    6.9334e-06,
                    7.161e-06,
                    7.4029e-06,
                    7.6595e-06,
                    7.931e-06,
                    8.2176e-06,
                    8.5199e-06,
                    8.8379e-06,
                    9.1723e-06,
                    9.5242e-06,
                    9.894e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Land_CH4": 0.09,
                "Land_CH4_timeseries": [
                    1.6119e-07,
                    3.2704e-07,
                    4.9756e-07,
                    6.7275e-07,
                    8.526e-07,
                    1.0371e-06,
                    1.2263e-06,
                    1.4202e-06,
                    1.6187e-06,
                    1.8219e-06,
                    2.0294e-06,
                    2.2412e-06,
                    2.4574e-06,
                    2.6778e-06,
                    2.9025e-06,
                    3.1316e-06,
                    3.365e-06,
                    3.6027e-06,
                    3.8447e-06,
                    4.091e-06,
                    4.3351e-06,
                    4.5771e-06,
                    4.817e-06,
                    5.0546e-06,
                    5.2901e-06,
                    5.5234e-06,
                    5.7546e-06,
                    5.9836e-06,
                    6.2104e-06,
                    6.4351e-06,
                    6.665e-06,
                    6.9002e-06,
                    7.1407e-06,
                    7.3864e-06,
                    7.6373e-06,
                    7.8935e-06,
                    8.155e-06,
                    8.4217e-06,
                    8.6937e-06,
                    8.971e-06,
                    9.2579e-06,
                    9.5545e-06,
                    9.8608e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_N2O": 0.05,
                "Total_N2O_timeseries": [
                    1.4598e-08,
                    2.9411e-08,
                    4.4434e-08,
                    5.9658e-08,
                    7.5073e-08,
                    9.0666e-08,
                    1.0642e-07,
                    1.2232e-07,
                    1.3834e-07,
                    1.5447e-07,
                    1.7068e-07,
                    1.8698e-07,
                    2.0336e-07,
                    2.1982e-07,
                    2.3636e-07,
                    2.5299e-07,
                    2.6969e-07,
                    2.8647e-07,
                    3.0334e-07,
                    3.203e-07,
                    3.3746e-07,
                    3.5504e-07,
                    3.732e-07,
                    3.9202e-07,
                    4.116e-07,
                    4.3192e-07,
                    4.5298e-07,
                    4.7467e-07,
                    4.9689e-07,
                    5.1945e-07,
                    5.4223e-07,
                    5.6522e-07,
                    5.8839e-07,
                    6.1173e-07,
                    6.3523e-07,
                    6.5888e-07,
                    6.8268e-07,
                    7.0664e-07,
                    7.3077e-07,
                    7.598e-07,
                    7.8918e-07,
                    8.1913e-07,
                    8.4986e-07,
                    8.8154e-07,
                    9.1434e-07,
                    9.484e-07,
                    9.8382e-07,
                    1.0207e-06,
                    1.0591e-06,
                    1.0991e-06,
                    1.1412e-06,
                    1.1864e-06,
                    1.2353e-06,
                    1.2884e-06,
                    1.3458e-06,
                    1.4075e-06,
                    1.4732e-06,
                    1.5423e-06,
                    1.6141e-06,
                    1.6874e-06,
                    1.7618e-06,
                    1.8371e-06,
                    1.9134e-06,
                    1.9904e-06,
                    2.0682e-06,
                    2.1468e-06,
                    2.226e-06,
                    2.3057e-06,
                    2.3859e-06,
                    2.4664e-06,
                    2.5472e-06,
                    2.6278e-06,
                    2.708e-06,
                    2.7878e-06,
                    2.867e-06,
                    2.9456e-06,
                    3.0238e-06,
                    3.1016e-06,
                    3.1792e-06,
                    3.257e-06,
                    3.3354e-06,
                    3.415e-06,
                    3.4962e-06,
                    3.5794e-06,
                    3.6648e-06,
                    3.7528e-06,
                    3.8434e-06,
                    3.9367e-06,
                    4.0326e-06,
                    4.1309e-06,
                    4.2344e-06,
                    4.3476e-06,
                    4.4741e-06,
                    4.6166e-06,
                    4.7764e-06,
                    4.954e-06,
                    5.1488e-06,
                    5.3592e-06,
                    5.5823e-06,
                    5.8143e-06,
                    6.0552e-06,
                    6.3086e-06,
                    6.5775e-06,
                    6.8636e-06,
                    7.1683e-06,
                    7.4918e-06,
                    7.8335e-06,
                    8.192e-06,
                    8.5651e-06,
                    8.9497e-06,
                    9.3413e-06,
                    9.7401e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_N2O": 0.04,
                "Fossil_N2O_timeseries": [
                    9.9425e-09,
                    2.0008e-08,
                    3.0193e-08,
                    4.0496e-08,
                    5.0914e-08,
                    6.1441e-08,
                    7.2072e-08,
                    8.2802e-08,
                    9.3624e-08,
                    1.0453e-07,
                    1.1551e-07,
                    1.2658e-07,
                    1.3772e-07,
                    1.4893e-07,
                    1.6023e-07,
                    1.716e-07,
                    1.8304e-07,
                    1.9457e-07,
                    2.0617e-07,
                    2.1785e-07,
                    2.2966e-07,
                    2.4165e-07,
                    2.5388e-07,
                    2.664e-07,
                    2.7921e-07,
                    2.9233e-07,
                    3.0575e-07,
                    3.1944e-07,
                    3.3335e-07,
                    3.4742e-07,
                    3.6163e-07,
                    3.7595e-07,
                    3.9038e-07,
                    4.0492e-07,
                    4.1956e-07,
                    4.343e-07,
                    4.4915e-07,
                    4.6409e-07,
                    4.7915e-07,
                    4.9449e-07,
                    5.0998e-07,
                    5.2564e-07,
                    5.4146e-07,
                    5.5746e-07,
                    5.7363e-07,
                    5.8999e-07,
                    6.0653e-07,
                    6.2327e-07,
                    6.4022e-07,
                    6.5737e-07,
                    6.7474e-07,
                    6.9236e-07,
                    7.1023e-07,
                    7.2838e-07,
                    7.4681e-07,
                    7.6552e-07,
                    7.8452e-07,
                    8.038e-07,
                    8.2336e-07,
                    8.4318e-07,
                    8.6325e-07,
                    8.8358e-07,
                    9.0415e-07,
                    9.2498e-07,
                    9.4605e-07,
                    9.6736e-07,
                    9.8892e-07,
                    1.0107e-06,
                    1.0328e-06,
                    1.0551e-06,
                    1.0776e-06,
                    1.1004e-06,
                    1.1235e-06,
                    1.1468e-06,
                    1.1704e-06,
                    1.1942e-06,
                    1.2182e-06,
                    1.2425e-06,
                    1.2671e-06,
                    1.2919e-06,
                    1.317e-06,
                    1.3423e-06,
                    1.3679e-06,
                    1.3938e-06,
                    1.4198e-06,
                    1.4462e-06,
                    1.4728e-06,
                    1.4998e-06,
                    1.5271e-06,
                    1.5547e-06,
                    1.5828e-06,
                    1.6116e-06,
                    1.6413e-06,
                    1.6721e-06,
                    1.7039e-06,
                    1.7369e-06,
                    1.7711e-06,
                    1.8064e-06,
                    1.8428e-06,
                    1.8801e-06,
                    1.9184e-06,
                    1.9577e-06,
                    1.9982e-06,
                    2.0399e-06,
                    2.083e-06,
                    2.1275e-06,
                    2.1735e-06,
                    2.2209e-06,
                    2.2696e-06,
                    2.3198e-06,
                    2.3713e-06,
                    2.4241e-06,
                    2.4782e-06,
                    2.5337e-06,
                    2.5907e-06,
                    2.6492e-06,
                    2.7096e-06,
                    2.7719e-06,
                    2.8366e-06,
                    2.9016e-06,
                    2.9668e-06,
                    3.0332e-06,
                    3.1005e-06,
                    3.1696e-06,
                    3.2401e-06,
                    3.3123e-06,
                    3.3852e-06,
                    3.4612e-06,
                    3.5394e-06,
                    3.6187e-06,
                    3.6954e-06,
                    3.7732e-06,
                    3.8532e-06,
                    3.9339e-06,
                    4.0153e-06,
                    4.0935e-06,
                    4.1736e-06,
                    4.2535e-06,
                    4.3331e-06,
                    4.4191e-06,
                    4.5053e-06,
                    4.5913e-06,
                    4.6772e-06,
                    4.7613e-06,
                    4.8537e-06,
                    4.9525e-06,
                    5.0543e-06,
                    5.1618e-06,
                    5.2702e-06,
                    5.3747e-06,
                    5.482e-06,
                    5.5925e-06,
                    5.7022e-06,
                    5.8154e-06,
                    5.9546e-06,
                    6.0978e-06,
                    6.2485e-06,
                    6.3997e-06,
                    6.5557e-06,
                    6.7162e-06,
                    6.8818e-06,
                    7.0552e-06,
                    7.2287e-06,
                    7.4083e-06,
                    7.5948e-06,
                    7.7856e-06,
                    7.9792e-06,
                    8.1734e-06,
                    8.3775e-06,
                    8.5829e-06,
                    8.7911e-06,
                    9.0009e-06
                ],
                "Land_N2O": 0.06,
                "Land_N2O_timeseries": [
                    4.6552e-09,
                    9.4035e-09,
                    1.4241e-08,
                    1.9162e-08,
                    2.4159e-08,
                    2.9225e-08,
                    3.4348e-08,
                    3.9517e-08,
                    4.4719e-08,
                    4.9939e-08,
                    5.5169e-08,
                    6.0404e-08,
                    6.5645e-08,
                    7.0889e-08,
                    7.6137e-08,
                    8.1387e-08,
                    8.6642e-08,
                    9.1901e-08,
                    9.7168e-08,
                    1.0244e-07,
                    1.0781e-07,
                    1.134e-07,
                    1.1931e-07,
                    1.2563e-07,
                    1.3238e-07,
                    1.3959e-07,
                    1.4722e-07,
                    1.5524e-07,
                    1.6354e-07,
                    1.7202e-07,
                    1.8061e-07,
                    1.8927e-07,
                    1.9801e-07,
                    2.0681e-07,
                    2.1567e-07,
                    2.2457e-07,
                    2.3353e-07,
                    2.4254e-07,
                    2.5162e-07,
                    2.6531e-07,
                    2.7919e-07,
                    2.9349e-07,
                    3.084e-07,
                    3.2409e-07,
                    3.4071e-07,
                    3.5841e-07,
                    3.7728e-07,
                    3.9742e-07,
                    4.1889e-07,
                    4.4173e-07,
                    4.6649e-07,
                    4.9406e-07,
                    5.251e-07,
                    5.6002e-07,
                    5.99e-07,
                    6.4199e-07,
                    6.8867e-07,
                    7.385e-07,
                    7.9071e-07,
                    8.4427e-07,
                    8.9857e-07,
                    9.5357e-07,
                    1.0092e-06,
                    1.0654e-06,
                    1.1222e-06,
                    1.1794e-06,
                    1.237e-06,
                    1.2949e-06,
                    1.3531e-06,
                    1.4113e-06,
                    1.4695e-06,
                    1.5273e-06,
                    1.5845e-06,
                    1.641e-06,
                    1.6966e-06,
                    1.7515e-06,
                    1.8056e-06,
                    1.8591e-06,
                    1.9121e-06,
                    1.9651e-06,
                    2.0184e-06,
                    2.0727e-06,
                    2.1283e-06,
                    2.1856e-06,
                    2.245e-06,
                    2.3066e-06,
                    2.3706e-06,
                    2.4369e-06,
                    2.5055e-06,
                    2.5762e-06,
                    2.6516e-06,
                    2.736e-06,
                    2.8328e-06,
                    2.9445e-06,
                    3.0725e-06,
                    3.2171e-06,
                    3.3777e-06,
                    3.5527e-06,
                    3.7394e-06,
                    3.9342e-06,
                    4.1369e-06,
                    4.351e-06,
                    4.5793e-06,
                    4.8237e-06,
                    5.0853e-06,
                    5.3642e-06,
                    5.66e-06,
                    5.9712e-06,
                    6.2955e-06,
                    6.6299e-06,
                    6.97e-06,
                    7.316e-06,
                    7.6679e-06,
                    8.0277e-06,
                    8.3964e-06,
                    8.7702e-06,
                    9.1541e-06,
                    9.5473e-06,
                    9.9469e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -71.75791,
                                19.70198
                            ],
                            [
                                -71.97662,
                                19.73242
                            ],
                            [
                                -72.04896,
                                19.73104
                            ],
                            [
                                -72.19354,
                                19.77974
                            ],
                            [
                                -72.33779,
                                19.7657
                            ],
                            [
                                -72.3834,
                                19.81037
                            ],
                            [
                                -72.49552,
                                19.82629
                            ],
                            [
                                -72.58235,
                                19.89426
                            ],
                            [
                                -72.7807,
                                19.94988
                            ],
                            [
                                -73.05046,
                                19.91794
                            ],
                            [
                                -73.16603,
                                19.92776
                            ],
                            [
                                -73.24211,
                                19.87879
                            ],
                            [
                                -73.38124,
                                19.82028
                            ],
                            [
                                -73.45246,
                                19.75572
                            ],
                            [
                                -73.43694,
                                19.66846
                            ],
                            [
                                -73.36141,
                                19.6248
                            ],
                            [
                                -73.23787,
                                19.63021
                            ],
                            [
                                -73.20949,
                                19.65942
                            ],
                            [
                                -73.13499,
                                19.62444
                            ],
                            [
                                -73.05705,
                                19.63046
                            ],
                            [
                                -72.85123,
                                19.5304
                            ],
                            [
                                -72.7712,
                                19.45623
                            ],
                            [
                                -72.7006,
                                19.45515
                            ],
                            [
                                -72.68599,
                                19.41376
                            ],
                            [
                                -72.73327,
                                19.36756
                            ],
                            [
                                -72.72983,
                                19.32173
                            ],
                            [
                                -72.7945,
                                19.21781
                            ],
                            [
                                -72.72615,
                                19.09127
                            ],
                            [
                                -72.82054,
                                19.06395
                            ],
                            [
                                -72.71944,
                                18.95013
                            ],
                            [
                                -72.64545,
                                18.91455
                            ],
                            [
                                -72.53911,
                                18.77712
                            ],
                            [
                                -72.47111,
                                18.75884
                            ],
                            [
                                -72.44539,
                                18.71964
                            ],
                            [
                                -72.32506,
                                18.67861
                            ],
                            [
                                -72.34008,
                                18.58291
                            ],
                            [
                                -72.37806,
                                18.53616
                            ],
                            [
                                -72.62522,
                                18.54993
                            ],
                            [
                                -72.67316,
                                18.4656
                            ],
                            [
                                -72.73868,
                                18.42723
                            ],
                            [
                                -72.98444,
                                18.46627
                            ],
                            [
                                -73.09605,
                                18.4457
                            ],
                            [
                                -73.19459,
                                18.48714
                            ],
                            [
                                -73.25022,
                                18.47843
                            ],
                            [
                                -73.45139,
                                18.52655
                            ],
                            [
                                -73.65723,
                                18.5017
                            ],
                            [
                                -73.70272,
                                18.57515
                            ],
                            [
                                -73.78233,
                                18.53866
                            ],
                            [
                                -73.96503,
                                18.59979
                            ],
                            [
                                -74.06391,
                                18.61065
                            ],
                            [
                                -74.13736,
                                18.66131
                            ],
                            [
                                -74.20218,
                                18.67482
                            ],
                            [
                                -74.38659,
                                18.64086
                            ],
                            [
                                -74.47655,
                                18.42784
                            ],
                            [
                                -74.44648,
                                18.35062
                            ],
                            [
                                -74.36837,
                                18.29759
                            ],
                            [
                                -74.25923,
                                18.31001
                            ],
                            [
                                -74.18841,
                                18.29479
                            ],
                            [
                                -74.09447,
                                18.24739
                            ],
                            [
                                -73.94756,
                                18.12583
                            ],
                            [
                                -73.90178,
                                18.03263
                            ],
                            [
                                -73.78301,
                                18.0428
                            ],
                            [
                                -73.83979,
                                18.10406
                            ],
                            [
                                -73.8167,
                                18.15263
                            ],
                            [
                                -73.60994,
                                18.25383
                            ],
                            [
                                -73.60343,
                                18.21322
                            ],
                            [
                                -73.38942,
                                18.27653
                            ],
                            [
                                -73.26385,
                                18.21616
                            ],
                            [
                                -73.17219,
                                18.21014
                            ],
                            [
                                -72.85759,
                                18.14413
                            ],
                            [
                                -72.78883,
                                18.14706
                            ],
                            [
                                -72.75029,
                                18.18237
                            ],
                            [
                                -72.64073,
                                18.19001
                            ],
                            [
                                -72.54823,
                                18.17414
                            ],
                            [
                                -72.51492,
                                18.21479
                            ],
                            [
                                -72.37225,
                                18.23408
                            ],
                            [
                                -72.21881,
                                18.22143
                            ],
                            [
                                -72.05357,
                                18.23645
                            ],
                            [
                                -71.92258,
                                18.18703
                            ],
                            [
                                -71.75362,
                                18.03074
                            ],
                            [
                                -71.73349,
                                18.0729
                            ],
                            [
                                -71.77902,
                                18.17621
                            ],
                            [
                                -71.69391,
                                18.34057
                            ],
                            [
                                -71.78676,
                                18.37928
                            ],
                            [
                                -71.89934,
                                18.45816
                            ],
                            [
                                -71.87851,
                                18.50502
                            ],
                            [
                                -71.9974,
                                18.63253
                            ],
                            [
                                -71.96515,
                                18.65327
                            ],
                            [
                                -71.81227,
                                18.63419
                            ],
                            [
                                -71.79572,
                                18.69249
                            ],
                            [
                                -71.73785,
                                18.73086
                            ],
                            [
                                -71.72124,
                                18.87466
                            ],
                            [
                                -71.77592,
                                18.94497
                            ],
                            [
                                -71.7778,
                                19.01033
                            ],
                            [
                                -71.71084,
                                19.0781
                            ],
                            [
                                -71.65458,
                                19.10548
                            ],
                            [
                                -71.61394,
                                19.20248
                            ],
                            [
                                -71.69699,
                                19.24227
                            ],
                            [
                                -71.76492,
                                19.31533
                            ],
                            [
                                -71.71433,
                                19.36611
                            ],
                            [
                                -71.67535,
                                19.44255
                            ],
                            [
                                -71.73883,
                                19.58611
                            ],
                            [
                                -71.75791,
                                19.70198
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -73.30042,
                                18.92626
                            ],
                            [
                                -73.23835,
                                18.85079
                            ],
                            [
                                -73.12512,
                                18.81912
                            ],
                            [
                                -73.03564,
                                18.75917
                            ],
                            [
                                -72.83988,
                                18.72311
                            ],
                            [
                                -72.79458,
                                18.73737
                            ],
                            [
                                -72.85105,
                                18.83121
                            ],
                            [
                                -72.99294,
                                18.88335
                            ],
                            [
                                -73.05611,
                                18.92375
                            ],
                            [
                                -73.19827,
                                18.96903
                            ],
                            [
                                -73.30042,
                                18.92626
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -72.96976,
                                20.06411
                            ],
                            [
                                -72.87954,
                                20.03372
                            ],
                            [
                                -72.64191,
                                19.99318
                            ],
                            [
                                -72.67687,
                                20.04344
                            ],
                            [
                                -72.80522,
                                20.08937
                            ],
                            [
                                -72.96976,
                                20.06411
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "HND",
                "Country": "Honduras",
                "Total_3GHG": 0.1,
                "Total_3GHG_timeseries": [
                    3.428e-06,
                    6.7583e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016
                ],
                "Fossil_3GHG": 0.03,
                "Fossil_3GHG_timeseries": [
                    6.3247e-08,
                    1.2486e-07,
                    1.8483e-07,
                    2.4317e-07,
                    2.9987e-07,
                    3.5585e-07,
                    4.1109e-07,
                    4.656e-07,
                    5.1937e-07,
                    5.724e-07,
                    6.2409e-07,
                    6.7443e-07,
                    7.2344e-07,
                    7.711e-07,
                    8.1743e-07,
                    8.6267e-07,
                    9.0685e-07,
                    9.4996e-07,
                    9.9781e-07,
                    1.0508e-06,
                    1.1015e-06,
                    1.1498e-06,
                    1.196e-06,
                    1.2401e-06,
                    1.2822e-06,
                    1.3215e-06,
                    1.3581e-06,
                    1.392e-06,
                    1.4232e-06,
                    1.4518e-06,
                    1.4782e-06,
                    1.5056e-06,
                    1.5341e-06,
                    1.5637e-06,
                    1.5944e-06,
                    1.626e-06,
                    1.6585e-06,
                    1.6952e-06,
                    1.7309e-06,
                    1.7656e-06,
                    1.8042e-06,
                    1.8468e-06,
                    1.8932e-06,
                    1.9434e-06,
                    1.9973e-06,
                    2.0547e-06,
                    2.1155e-06,
                    2.1798e-06,
                    2.259e-06,
                    2.3545e-06,
                    2.4563e-06,
                    2.5613e-06,
                    2.6695e-06,
                    2.7811e-06,
                    2.8958e-06,
                    3.014e-06,
                    3.1357e-06,
                    3.2577e-06,
                    3.38e-06,
                    3.5024e-06,
                    3.6296e-06,
                    3.762e-06,
                    3.8994e-06,
                    4.0401e-06,
                    4.1845e-06,
                    4.3326e-06,
                    4.4847e-06,
                    4.6404e-06,
                    4.7891e-06,
                    4.9296e-06,
                    5.0772e-06,
                    5.2348e-06,
                    5.4023e-06,
                    5.5766e-06,
                    5.7608e-06,
                    5.9548e-06,
                    6.1528e-06,
                    6.3577e-06,
                    6.5693e-06,
                    6.7876e-06,
                    7.012e-06,
                    7.2422e-06,
                    7.4783e-06,
                    7.719e-06,
                    7.9668e-06,
                    8.2223e-06,
                    8.4854e-06,
                    8.7563e-06,
                    9.0347e-06,
                    9.3234e-06,
                    9.6151e-06,
                    9.9099e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Land_3GHG": 0.23,
                "Land_3GHG_timeseries": [
                    3.3647e-06,
                    6.6334e-06,
                    9.8817e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013
                ],
                "Total_CO2": 0.11,
                "Total_CO2_timeseries": [
                    3.136e-06,
                    6.176e-06,
                    9.1955e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012
                ],
                "Fossil_CO2": 0.02,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.353e-07,
                    2.9205e-07,
                    4.5375e-07,
                    6.039e-07,
                    7.7385e-07,
                    9.702e-07,
                    1.1748e-06,
                    1.4339e-06,
                    1.6978e-06,
                    1.9618e-06,
                    2.239e-06,
                    2.5705e-06,
                    2.8856e-06,
                    3.2056e-06,
                    3.5305e-06,
                    3.8686e-06,
                    4.2314e-06,
                    4.6255e-06,
                    5.1764e-06,
                    5.7058e-06,
                    6.3309e-06,
                    6.9293e-06,
                    7.6197e-06,
                    8.2979e-06,
                    8.9974e-06,
                    9.7453e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CO2": 0.3,
                "Land_CO2_timeseries": [
                    3.136e-06,
                    6.176e-06,
                    9.1955e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011
                ],
                "Total_CH4": 0.09,
                "Total_CH4_timeseries": [
                    2.7946e-07,
                    5.5709e-07,
                    8.3289e-07,
                    1.1069e-06,
                    1.379e-06,
                    1.6503e-06,
                    1.9207e-06,
                    2.1901e-06,
                    2.4586e-06,
                    2.7262e-06,
                    2.989e-06,
                    3.2469e-06,
                    3.4999e-06,
                    3.7481e-06,
                    3.9914e-06,
                    4.2301e-06,
                    4.4642e-06,
                    4.6937e-06,
                    4.9244e-06,
                    5.1568e-06,
                    5.3857e-06,
                    5.6112e-06,
                    5.8333e-06,
                    6.0522e-06,
                    6.2679e-06,
                    6.4795e-06,
                    6.6873e-06,
                    6.8912e-06,
                    7.0913e-06,
                    7.2877e-06,
                    7.4831e-06,
                    7.6808e-06,
                    7.8809e-06,
                    8.0833e-06,
                    8.2882e-06,
                    8.4952e-06,
                    8.7045e-06,
                    8.9193e-06,
                    9.1344e-06,
                    9.3495e-06,
                    9.57e-06,
                    9.7957e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Fossil_CH4": 0.07,
                "Fossil_CH4_timeseries": [
                    5.6146e-08,
                    1.1057e-07,
                    1.6328e-07,
                    2.1426e-07,
                    2.6354e-07,
                    3.1201e-07,
                    3.5967e-07,
                    4.0653e-07,
                    4.5258e-07,
                    4.9783e-07,
                    5.4168e-07,
                    5.8412e-07,
                    6.2517e-07,
                    6.6483e-07,
                    7.0308e-07,
                    7.402e-07,
                    7.7619e-07,
                    8.1106e-07,
                    8.5062e-07,
                    8.9527e-07,
                    9.3746e-07,
                    9.7725e-07,
                    1.0147e-06,
                    1.0499e-06,
                    1.0829e-06,
                    1.1129e-06,
                    1.14e-06,
                    1.1643e-06,
                    1.1857e-06,
                    1.2045e-06,
                    1.2208e-06,
                    1.2382e-06,
                    1.2565e-06,
                    1.2759e-06,
                    1.2963e-06,
                    1.3175e-06,
                    1.3396e-06,
                    1.3658e-06,
                    1.3909e-06,
                    1.4148e-06,
                    1.4424e-06,
                    1.4739e-06,
                    1.5091e-06,
                    1.5479e-06,
                    1.5904e-06,
                    1.6361e-06,
                    1.6852e-06,
                    1.7374e-06,
                    1.8046e-06,
                    1.8878e-06,
                    1.9772e-06,
                    2.0696e-06,
                    2.1649e-06,
                    2.2635e-06,
                    2.365e-06,
                    2.4696e-06,
                    2.5777e-06,
                    2.6857e-06,
                    2.7939e-06,
                    2.9021e-06,
                    3.0148e-06,
                    3.1324e-06,
                    3.2549e-06,
                    3.3806e-06,
                    3.5097e-06,
                    3.6424e-06,
                    3.7788e-06,
                    3.9187e-06,
                    4.0515e-06,
                    4.1757e-06,
                    4.307e-06,
                    4.448e-06,
                    4.5987e-06,
                    4.7561e-06,
                    4.9233e-06,
                    5.1e-06,
                    5.2804e-06,
                    5.4676e-06,
                    5.6614e-06,
                    5.8616e-06,
                    6.0677e-06,
                    6.2795e-06,
                    6.4968e-06,
                    6.7186e-06,
                    6.9473e-06,
                    7.1835e-06,
                    7.4271e-06,
                    7.6781e-06,
                    7.9365e-06,
                    8.2049e-06,
                    8.4758e-06,
                    8.7495e-06,
                    9.0205e-06,
                    9.2969e-06,
                    9.5843e-06,
                    9.8859e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_CH4": 0.13,
                "Land_CH4_timeseries": [
                    2.2331e-07,
                    4.4652e-07,
                    6.6962e-07,
                    8.9261e-07,
                    1.1155e-06,
                    1.3383e-06,
                    1.561e-06,
                    1.7836e-06,
                    2.006e-06,
                    2.2284e-06,
                    2.4473e-06,
                    2.6628e-06,
                    2.8747e-06,
                    3.0833e-06,
                    3.2883e-06,
                    3.4899e-06,
                    3.688e-06,
                    3.8826e-06,
                    4.0738e-06,
                    4.2615e-06,
                    4.4482e-06,
                    4.6339e-06,
                    4.8186e-06,
                    5.0023e-06,
                    5.185e-06,
                    5.3666e-06,
                    5.5473e-06,
                    5.7269e-06,
                    5.9056e-06,
                    6.0832e-06,
                    6.2622e-06,
                    6.4426e-06,
                    6.6243e-06,
                    6.8074e-06,
                    6.9919e-06,
                    7.1777e-06,
                    7.3649e-06,
                    7.5535e-06,
                    7.7434e-06,
                    7.9347e-06,
                    8.1275e-06,
                    8.3218e-06,
                    8.5175e-06,
                    8.7147e-06,
                    8.9133e-06,
                    9.1135e-06,
                    9.3151e-06,
                    9.5181e-06,
                    9.7227e-06,
                    9.9287e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Total_N2O": 0.07,
                "Total_N2O_timeseries": [
                    1.2522e-08,
                    2.5237e-08,
                    3.8139e-08,
                    5.1221e-08,
                    6.447e-08,
                    7.7876e-08,
                    9.1424e-08,
                    1.0509e-07,
                    1.1887e-07,
                    1.3273e-07,
                    1.4666e-07,
                    1.6065e-07,
                    1.7471e-07,
                    1.8883e-07,
                    2.0301e-07,
                    2.1725e-07,
                    2.3155e-07,
                    2.4592e-07,
                    2.6035e-07,
                    2.7485e-07,
                    2.8954e-07,
                    3.0462e-07,
                    3.2023e-07,
                    3.3648e-07,
                    3.5344e-07,
                    3.7112e-07,
                    3.8948e-07,
                    4.0846e-07,
                    4.2792e-07,
                    4.4769e-07,
                    4.6767e-07,
                    4.8784e-07,
                    5.0816e-07,
                    5.2863e-07,
                    5.4924e-07,
                    5.6997e-07,
                    5.9084e-07,
                    6.1185e-07,
                    6.3301e-07,
                    6.5979e-07,
                    6.8692e-07,
                    7.1465e-07,
                    7.4322e-07,
                    7.7285e-07,
                    8.037e-07,
                    8.3595e-07,
                    8.6971e-07,
                    9.0511e-07,
                    9.4221e-07,
                    9.8107e-07,
                    1.0223e-06,
                    1.0671e-06,
                    1.116e-06,
                    1.1697e-06,
                    1.2284e-06,
                    1.2919e-06,
                    1.36e-06,
                    1.4319e-06,
                    1.5068e-06,
                    1.5835e-06,
                    1.6612e-06,
                    1.74e-06,
                    1.8197e-06,
                    1.9002e-06,
                    1.9816e-06,
                    2.0637e-06,
                    2.1464e-06,
                    2.2296e-06,
                    2.3133e-06,
                    2.3974e-06,
                    2.4815e-06,
                    2.5654e-06,
                    2.6487e-06,
                    2.7314e-06,
                    2.8133e-06,
                    2.8945e-06,
                    2.975e-06,
                    3.0549e-06,
                    3.1346e-06,
                    3.2144e-06,
                    3.2948e-06,
                    3.3764e-06,
                    3.4598e-06,
                    3.5455e-06,
                    3.6338e-06,
                    3.7248e-06,
                    3.8189e-06,
                    3.9159e-06,
                    4.0159e-06,
                    4.1186e-06,
                    4.2271e-06,
                    4.3465e-06,
                    4.4809e-06,
                    4.6332e-06,
                    4.8052e-06,
                    4.9972e-06,
                    5.2086e-06,
                    5.4374e-06,
                    5.6805e-06,
                    5.9336e-06,
                    6.1966e-06,
                    6.4739e-06,
                    6.7687e-06,
                    7.0833e-06,
                    7.4192e-06,
                    7.7765e-06,
                    8.1547e-06,
                    8.552e-06,
                    8.9659e-06,
                    9.3927e-06,
                    9.8225e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_N2O": 0.04,
                "Fossil_N2O_timeseries": [
                    7.101e-09,
                    1.4287e-08,
                    2.1556e-08,
                    2.8906e-08,
                    3.6337e-08,
                    4.3844e-08,
                    5.1425e-08,
                    5.9077e-08,
                    6.6795e-08,
                    7.4574e-08,
                    8.2413e-08,
                    9.031e-08,
                    9.8264e-08,
                    1.0628e-07,
                    1.1434e-07,
                    1.2247e-07,
                    1.3065e-07,
                    1.389e-07,
                    1.472e-07,
                    1.5556e-07,
                    1.64e-07,
                    1.7256e-07,
                    1.8129e-07,
                    1.9019e-07,
                    1.9928e-07,
                    2.0857e-07,
                    2.1804e-07,
                    2.2768e-07,
                    2.3747e-07,
                    2.4737e-07,
                    2.5736e-07,
                    2.6743e-07,
                    2.7758e-07,
                    2.878e-07,
                    2.9809e-07,
                    3.0846e-07,
                    3.189e-07,
                    3.2941e-07,
                    3.4e-07,
                    3.5083e-07,
                    3.6179e-07,
                    3.7288e-07,
                    3.8409e-07,
                    3.9545e-07,
                    4.0694e-07,
                    4.1858e-07,
                    4.3036e-07,
                    4.4231e-07,
                    4.5441e-07,
                    4.6667e-07,
                    4.7911e-07,
                    4.9174e-07,
                    5.0456e-07,
                    5.176e-07,
                    5.3085e-07,
                    5.4432e-07,
                    5.5801e-07,
                    5.7192e-07,
                    5.8603e-07,
                    6.0035e-07,
                    6.1486e-07,
                    6.2956e-07,
                    6.4445e-07,
                    6.5952e-07,
                    6.7478e-07,
                    6.9023e-07,
                    7.0586e-07,
                    7.2167e-07,
                    7.3768e-07,
                    7.5386e-07,
                    7.7024e-07,
                    7.868e-07,
                    8.0354e-07,
                    8.2047e-07,
                    8.3759e-07,
                    8.5489e-07,
                    8.7238e-07,
                    8.9006e-07,
                    9.0794e-07,
                    9.2601e-07,
                    9.4429e-07,
                    9.6277e-07,
                    9.8146e-07,
                    1.0004e-06,
                    1.0195e-06,
                    1.0388e-06,
                    1.0584e-06,
                    1.0782e-06,
                    1.0982e-06,
                    1.1186e-06,
                    1.1393e-06,
                    1.1604e-06,
                    1.1821e-06,
                    1.2044e-06,
                    1.2273e-06,
                    1.2509e-06,
                    1.2752e-06,
                    1.3002e-06,
                    1.3259e-06,
                    1.3522e-06,
                    1.3792e-06,
                    1.4071e-06,
                    1.4361e-06,
                    1.4661e-06,
                    1.4973e-06,
                    1.5298e-06,
                    1.5636e-06,
                    1.5986e-06,
                    1.6348e-06,
                    1.6722e-06,
                    1.7105e-06,
                    1.7498e-06,
                    1.7899e-06,
                    1.8309e-06,
                    1.8727e-06,
                    1.9157e-06,
                    1.9598e-06,
                    2.0055e-06,
                    2.0529e-06,
                    2.1047e-06,
                    2.1563e-06,
                    2.2092e-06,
                    2.2646e-06,
                    2.3206e-06,
                    2.3787e-06,
                    2.4386e-06,
                    2.5007e-06,
                    2.5645e-06,
                    2.6297e-06,
                    2.6983e-06,
                    2.7686e-06,
                    2.8458e-06,
                    2.9271e-06,
                    3.0095e-06,
                    3.0868e-06,
                    3.17e-06,
                    3.256e-06,
                    3.3442e-06,
                    3.4302e-06,
                    3.5199e-06,
                    3.6102e-06,
                    3.7049e-06,
                    3.8037e-06,
                    3.9089e-06,
                    4.0252e-06,
                    4.1417e-06,
                    4.2698e-06,
                    4.4115e-06,
                    4.5433e-06,
                    4.6714e-06,
                    4.8082e-06,
                    4.9527e-06,
                    5.1065e-06,
                    5.2774e-06,
                    5.4532e-06,
                    5.6229e-06,
                    5.8283e-06,
                    6.0288e-06,
                    6.2259e-06,
                    6.4146e-06,
                    6.6163e-06,
                    6.8237e-06,
                    7.0349e-06,
                    7.2671e-06,
                    7.4983e-06,
                    7.7245e-06,
                    7.9418e-06,
                    8.1598e-06,
                    8.3917e-06,
                    8.6214e-06,
                    8.8649e-06,
                    9.1153e-06
                ],
                "Land_N2O": 0.08,
                "Land_N2O_timeseries": [
                    5.421e-09,
                    1.095e-08,
                    1.6584e-08,
                    2.2314e-08,
                    2.8134e-08,
                    3.4032e-08,
                    3.9998e-08,
                    4.6018e-08,
                    5.2076e-08,
                    5.8155e-08,
                    6.4244e-08,
                    7.0341e-08,
                    7.6444e-08,
                    8.2551e-08,
                    8.8662e-08,
                    9.4776e-08,
                    1.0089e-07,
                    1.0702e-07,
                    1.1315e-07,
                    1.193e-07,
                    1.2554e-07,
                    1.3205e-07,
                    1.3894e-07,
                    1.4629e-07,
                    1.5416e-07,
                    1.6255e-07,
                    1.7144e-07,
                    1.8077e-07,
                    1.9044e-07,
                    2.0032e-07,
                    2.1032e-07,
                    2.2041e-07,
                    2.3059e-07,
                    2.4083e-07,
                    2.5114e-07,
                    2.6152e-07,
                    2.7195e-07,
                    2.8244e-07,
                    2.9301e-07,
                    3.0895e-07,
                    3.2512e-07,
                    3.4177e-07,
                    3.5913e-07,
                    3.774e-07,
                    3.9676e-07,
                    4.1737e-07,
                    4.3935e-07,
                    4.628e-07,
                    4.878e-07,
                    5.144e-07,
                    5.4323e-07,
                    5.7533e-07,
                    6.1148e-07,
                    6.5214e-07,
                    6.9754e-07,
                    7.476e-07,
                    8.0196e-07,
                    8.5999e-07,
                    9.2079e-07,
                    9.8316e-07,
                    1.0464e-06,
                    1.1104e-06,
                    1.1752e-06,
                    1.2407e-06,
                    1.3068e-06,
                    1.3734e-06,
                    1.4405e-06,
                    1.508e-06,
                    1.5757e-06,
                    1.6435e-06,
                    1.7113e-06,
                    1.7786e-06,
                    1.8452e-06,
                    1.9109e-06,
                    1.9757e-06,
                    2.0396e-06,
                    2.1026e-06,
                    2.1649e-06,
                    2.2267e-06,
                    2.2884e-06,
                    2.3505e-06,
                    2.4136e-06,
                    2.4784e-06,
                    2.5452e-06,
                    2.6143e-06,
                    2.6861e-06,
                    2.7605e-06,
                    2.8378e-06,
                    2.9177e-06,
                    3e-06,
                    3.0878e-06,
                    3.186e-06,
                    3.2988e-06,
                    3.4289e-06,
                    3.5779e-06,
                    3.7463e-06,
                    3.9334e-06,
                    4.1372e-06,
                    4.3546e-06,
                    4.5814e-06,
                    4.8174e-06,
                    5.0667e-06,
                    5.3326e-06,
                    5.6172e-06,
                    5.9218e-06,
                    6.2467e-06,
                    6.5911e-06,
                    6.9534e-06,
                    7.3311e-06,
                    7.7205e-06,
                    8.112e-06,
                    8.5125e-06,
                    8.9209e-06,
                    9.3359e-06,
                    9.7584e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -89.35319,
                                14.41849
                            ],
                            [
                                -89.29881,
                                14.41426
                            ],
                            [
                                -89.14924,
                                14.35299
                            ],
                            [
                                -89.03609,
                                14.33299
                            ],
                            [
                                -89.0252,
                                14.27265
                            ],
                            [
                                -88.97158,
                                14.21421
                            ],
                            [
                                -88.87275,
                                14.18443
                            ],
                            [
                                -88.82975,
                                14.10726
                            ],
                            [
                                -88.73688,
                                14.11946
                            ],
                            [
                                -88.72859,
                                14.04856
                            ],
                            [
                                -88.50235,
                                13.9705
                            ],
                            [
                                -88.49333,
                                13.86393
                            ],
                            [
                                -88.31885,
                                13.88955
                            ],
                            [
                                -88.16419,
                                13.98244
                            ],
                            [
                                -88.07376,
                                13.99139
                            ],
                            [
                                -88.01298,
                                13.87343
                            ],
                            [
                                -87.95991,
                                13.89801
                            ],
                            [
                                -87.79773,
                                13.88892
                            ],
                            [
                                -87.7141,
                                13.81677
                            ],
                            [
                                -87.75343,
                                13.68642
                            ],
                            [
                                -87.77805,
                                13.51064
                            ],
                            [
                                -87.72046,
                                13.5038
                            ],
                            [
                                -87.72075,
                                13.44874
                            ],
                            [
                                -87.81666,
                                13.40716
                            ],
                            [
                                -87.74726,
                                13.35904
                            ],
                            [
                                -87.68385,
                                13.37266
                            ],
                            [
                                -87.65294,
                                13.4226
                            ],
                            [
                                -87.60487,
                                13.40128
                            ],
                            [
                                -87.65186,
                                13.32805
                            ],
                            [
                                -87.56645,
                                13.33844
                            ],
                            [
                                -87.44415,
                                13.37766
                            ],
                            [
                                -87.51148,
                                13.27522
                            ],
                            [
                                -87.45877,
                                13.23236
                            ],
                            [
                                -87.42508,
                                13.11861
                            ],
                            [
                                -87.32185,
                                13.03
                            ],
                            [
                                -87.31081,
                                12.98272
                            ],
                            [
                                -87.12162,
                                12.9979
                            ],
                            [
                                -87.03182,
                                12.98828
                            ],
                            [
                                -86.96323,
                                13.02946
                            ],
                            [
                                -86.921,
                                13.08844
                            ],
                            [
                                -86.9283,
                                13.17867
                            ],
                            [
                                -86.90413,
                                13.25814
                            ],
                            [
                                -86.81256,
                                13.30231
                            ],
                            [
                                -86.75498,
                                13.26826
                            ],
                            [
                                -86.70749,
                                13.29645
                            ],
                            [
                                -86.71047,
                                13.36654
                            ],
                            [
                                -86.75339,
                                13.63577
                            ],
                            [
                                -86.78312,
                                13.66937
                            ],
                            [
                                -86.76022,
                                13.77215
                            ],
                            [
                                -86.5358,
                                13.79766
                            ],
                            [
                                -86.4986,
                                13.76969
                            ],
                            [
                                -86.34812,
                                13.76157
                            ],
                            [
                                -86.29951,
                                13.84522
                            ],
                            [
                                -86.13834,
                                14.00163
                            ],
                            [
                                -86.09198,
                                14.06328
                            ],
                            [
                                -86.01468,
                                14.07551
                            ],
                            [
                                -86.01245,
                                13.98804
                            ],
                            [
                                -85.91543,
                                13.90655
                            ],
                            [
                                -85.85507,
                                13.91449
                            ],
                            [
                                -85.81645,
                                13.84363
                            ],
                            [
                                -85.77076,
                                13.84344
                            ],
                            [
                                -85.75504,
                                13.9615
                            ],
                            [
                                -85.67896,
                                13.98194
                            ],
                            [
                                -85.58346,
                                14.0468
                            ],
                            [
                                -85.39721,
                                14.13937
                            ],
                            [
                                -85.37548,
                                14.20751
                            ],
                            [
                                -85.33441,
                                14.24607
                            ],
                            [
                                -85.1839,
                                14.25129
                            ],
                            [
                                -85.16003,
                                14.29589
                            ],
                            [
                                -85.20683,
                                14.39028
                            ],
                            [
                                -85.13918,
                                14.51413
                            ],
                            [
                                -85.02671,
                                14.60111
                            ],
                            [
                                -85.02572,
                                14.69965
                            ],
                            [
                                -84.92872,
                                14.7588
                            ],
                            [
                                -84.90249,
                                14.80783
                            ],
                            [
                                -84.82137,
                                14.82268
                            ],
                            [
                                -84.75463,
                                14.76534
                            ],
                            [
                                -84.7125,
                                14.6878
                            ],
                            [
                                -84.49576,
                                14.62096
                            ],
                            [
                                -84.34579,
                                14.67513
                            ],
                            [
                                -84.25647,
                                14.67415
                            ],
                            [
                                -84.22504,
                                14.72943
                            ],
                            [
                                -84.17726,
                                14.70844
                            ],
                            [
                                -84.10052,
                                14.73713
                            ],
                            [
                                -83.93487,
                                14.76732
                            ],
                            [
                                -83.85138,
                                14.76812
                            ],
                            [
                                -83.78446,
                                14.8124
                            ],
                            [
                                -83.70679,
                                14.82733
                            ],
                            [
                                -83.68836,
                                14.86214
                            ],
                            [
                                -83.56615,
                                14.90709
                            ],
                            [
                                -83.50737,
                                14.99715
                            ],
                            [
                                -83.46551,
                                14.97604
                            ],
                            [
                                -83.40238,
                                15.02479
                            ],
                            [
                                -83.27118,
                                14.98362
                            ],
                            [
                                -83.14499,
                                14.99813
                            ],
                            [
                                -83.24322,
                                15.03853
                            ],
                            [
                                -83.30239,
                                15.08513
                            ],
                            [
                                -83.3816,
                                15.24524
                            ],
                            [
                                -83.41911,
                                15.26823
                            ],
                            [
                                -83.60091,
                                15.32655
                            ],
                            [
                                -83.64988,
                                15.26375
                            ],
                            [
                                -83.76959,
                                15.20848
                            ],
                            [
                                -83.76709,
                                15.25755
                            ],
                            [
                                -83.97144,
                                15.39368
                            ],
                            [
                                -84.0479,
                                15.3859
                            ],
                            [
                                -84.10202,
                                15.34309
                            ],
                            [
                                -84.13663,
                                15.39742
                            ],
                            [
                                -84.11568,
                                15.46234
                            ],
                            [
                                -84.04249,
                                15.52379
                            ],
                            [
                                -83.9271,
                                15.49537
                            ],
                            [
                                -84.07936,
                                15.63239
                            ],
                            [
                                -84.30376,
                                15.81459
                            ],
                            [
                                -84.44869,
                                15.82611
                            ],
                            [
                                -84.77032,
                                15.89428
                            ],
                            [
                                -85.00573,
                                15.98224
                            ],
                            [
                                -85.0674,
                                15.98149
                            ],
                            [
                                -85.17548,
                                15.91063
                            ],
                            [
                                -85.28511,
                                15.87955
                            ],
                            [
                                -85.48078,
                                15.86158
                            ],
                            [
                                -85.57081,
                                15.88899
                            ],
                            [
                                -85.69698,
                                15.95829
                            ],
                            [
                                -85.8607,
                                16.0062
                            ],
                            [
                                -85.91685,
                                15.99923
                            ],
                            [
                                -85.9395,
                                15.9293
                            ],
                            [
                                -86.00367,
                                15.90302
                            ],
                            [
                                -86.12125,
                                15.90194
                            ],
                            [
                                -86.22302,
                                15.86803
                            ],
                            [
                                -86.28664,
                                15.81357
                            ],
                            [
                                -86.40896,
                                15.77952
                            ],
                            [
                                -86.50023,
                                15.81412
                            ],
                            [
                                -86.71068,
                                15.78783
                            ],
                            [
                                -86.77559,
                                15.79781
                            ],
                            [
                                -86.91461,
                                15.75669
                            ],
                            [
                                -87.22238,
                                15.8047
                            ],
                            [
                                -87.36707,
                                15.84322
                            ],
                            [
                                -87.46882,
                                15.78259
                            ],
                            [
                                -87.51982,
                                15.78923
                            ],
                            [
                                -87.70963,
                                15.91554
                            ],
                            [
                                -87.74866,
                                15.89432
                            ],
                            [
                                -87.87092,
                                15.88741
                            ],
                            [
                                -87.95173,
                                15.8083
                            ],
                            [
                                -88.04293,
                                15.78083
                            ],
                            [
                                -88.12321,
                                15.68721
                            ],
                            [
                                -88.22132,
                                15.72049
                            ],
                            [
                                -88.30706,
                                15.6651
                            ],
                            [
                                -88.35532,
                                15.60375
                            ],
                            [
                                -88.68454,
                                15.33655
                            ],
                            [
                                -88.82861,
                                15.25305
                            ],
                            [
                                -88.96632,
                                15.13817
                            ],
                            [
                                -89.15396,
                                15.06448
                            ],
                            [
                                -89.15981,
                                14.97858
                            ],
                            [
                                -89.22052,
                                14.83199
                            ],
                            [
                                -89.16883,
                                14.77237
                            ],
                            [
                                -89.1354,
                                14.69741
                            ],
                            [
                                -89.16812,
                                14.57022
                            ],
                            [
                                -89.24859,
                                14.56746
                            ],
                            [
                                -89.35319,
                                14.41849
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -86.60197,
                                16.26696
                            ],
                            [
                                -86.54942,
                                16.31384
                            ],
                            [
                                -86.32438,
                                16.39341
                            ],
                            [
                                -86.35256,
                                16.42024
                            ],
                            [
                                -86.54386,
                                16.34608
                            ],
                            [
                                -86.60197,
                                16.26696
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -85.95093,
                                16.40319
                            ],
                            [
                                -85.83067,
                                16.48532
                            ],
                            [
                                -85.88072,
                                16.50332
                            ],
                            [
                                -85.95093,
                                16.40319
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "HKG",
                "Country": "Hong Kong",
                "Total_3GHG": 0.06,
                "Total_3GHG_timeseries": [
                    1.4432e-08,
                    3.0501e-08,
                    4.8211e-08,
                    6.7564e-08,
                    8.8565e-08,
                    1.1122e-07,
                    1.3552e-07,
                    1.6149e-07,
                    1.8912e-07,
                    2.1841e-07,
                    2.4943e-07,
                    2.8199e-07,
                    3.161e-07,
                    3.5176e-07,
                    3.8897e-07,
                    4.2773e-07,
                    4.6805e-07,
                    5.0994e-07,
                    5.534e-07,
                    5.9843e-07,
                    6.4372e-07,
                    6.8934e-07,
                    7.3537e-07,
                    7.8185e-07,
                    8.2881e-07,
                    8.7625e-07,
                    9.2415e-07,
                    9.7246e-07,
                    1.0211e-06,
                    1.07e-06,
                    1.119e-06,
                    1.1684e-06,
                    1.218e-06,
                    1.268e-06,
                    1.3183e-06,
                    1.3689e-06,
                    1.4198e-06,
                    1.4709e-06,
                    1.5222e-06,
                    1.5739e-06,
                    1.6275e-06,
                    1.6831e-06,
                    1.7407e-06,
                    1.8002e-06,
                    1.8617e-06,
                    1.9251e-06,
                    1.9906e-06,
                    2.0582e-06,
                    2.1279e-06,
                    2.1997e-06,
                    2.2763e-06,
                    2.3578e-06,
                    2.4442e-06,
                    2.5356e-06,
                    2.6318e-06,
                    2.7329e-06,
                    2.839e-06,
                    2.95e-06,
                    3.0659e-06,
                    3.1868e-06,
                    3.3103e-06,
                    3.4368e-06,
                    3.5668e-06,
                    3.6996e-06,
                    3.8353e-06,
                    3.9736e-06,
                    4.1147e-06,
                    4.2584e-06,
                    4.4047e-06,
                    4.5537e-06,
                    4.7025e-06,
                    4.8516e-06,
                    5.0009e-06,
                    5.151e-06,
                    5.2938e-06,
                    5.4366e-06,
                    5.5794e-06,
                    5.7221e-06,
                    5.8649e-06,
                    6.0076e-06,
                    6.1783e-06,
                    6.3767e-06,
                    6.602e-06,
                    6.8549e-06,
                    7.1352e-06,
                    7.4443e-06,
                    7.7823e-06,
                    8.1738e-06,
                    8.5944e-06,
                    9.0215e-06,
                    9.4911e-06,
                    9.9544e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001
                ],
                "Fossil_3GHG": 0.1,
                "Fossil_3GHG_timeseries": [
                    1.2861e-08,
                    2.7073e-08,
                    4.264e-08,
                    5.9566e-08,
                    7.7856e-08,
                    9.7513e-08,
                    1.1854e-07,
                    1.4095e-07,
                    1.6475e-07,
                    1.8993e-07,
                    2.1656e-07,
                    2.4445e-07,
                    2.736e-07,
                    3.0403e-07,
                    3.3572e-07,
                    3.6868e-07,
                    4.0292e-07,
                    4.3845e-07,
                    4.7527e-07,
                    5.1338e-07,
                    5.5171e-07,
                    5.9032e-07,
                    6.2927e-07,
                    6.6861e-07,
                    7.0835e-07,
                    7.4849e-07,
                    7.8901e-07,
                    8.2988e-07,
                    8.7102e-07,
                    9.1234e-07,
                    9.5377e-07,
                    9.9551e-07,
                    1.0375e-06,
                    1.0798e-06,
                    1.1224e-06,
                    1.1653e-06,
                    1.2084e-06,
                    1.2517e-06,
                    1.2952e-06,
                    1.3389e-06,
                    1.3843e-06,
                    1.4312e-06,
                    1.4797e-06,
                    1.5298e-06,
                    1.5815e-06,
                    1.6348e-06,
                    1.6898e-06,
                    1.7465e-06,
                    1.805e-06,
                    1.8651e-06,
                    1.9291e-06,
                    1.9971e-06,
                    2.069e-06,
                    2.1448e-06,
                    2.2246e-06,
                    2.3083e-06,
                    2.3959e-06,
                    2.4876e-06,
                    2.5831e-06,
                    2.6826e-06,
                    2.7843e-06,
                    2.8882e-06,
                    2.9952e-06,
                    3.1043e-06,
                    3.2156e-06,
                    3.3291e-06,
                    3.4447e-06,
                    3.5623e-06,
                    3.682e-06,
                    3.8037e-06,
                    3.9251e-06,
                    4.0467e-06,
                    4.1684e-06,
                    4.2908e-06,
                    4.4057e-06,
                    4.5206e-06,
                    4.6353e-06,
                    4.7499e-06,
                    4.8643e-06,
                    4.9786e-06,
                    5.1152e-06,
                    5.2739e-06,
                    5.4538e-06,
                    5.6557e-06,
                    5.8794e-06,
                    6.1248e-06,
                    6.3919e-06,
                    6.7051e-06,
                    7.0398e-06,
                    7.3732e-06,
                    7.7468e-06,
                    8.1118e-06,
                    8.4932e-06,
                    8.8911e-06,
                    9.3382e-06,
                    9.8299e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [
                    1.5712e-09,
                    3.4284e-09,
                    5.5709e-09,
                    7.9983e-09,
                    1.0709e-08,
                    1.3703e-08,
                    1.6979e-08,
                    2.0534e-08,
                    2.4368e-08,
                    2.8479e-08,
                    3.2871e-08,
                    3.7545e-08,
                    4.25e-08,
                    4.7736e-08,
                    5.3253e-08,
                    5.9051e-08,
                    6.513e-08,
                    7.1491e-08,
                    7.8133e-08,
                    8.5057e-08,
                    9.2015e-08,
                    9.9023e-08,
                    1.0609e-07,
                    1.1324e-07,
                    1.2046e-07,
                    1.2776e-07,
                    1.3514e-07,
                    1.4258e-07,
                    1.5009e-07,
                    1.5764e-07,
                    1.6523e-07,
                    1.7285e-07,
                    1.805e-07,
                    1.8818e-07,
                    1.9589e-07,
                    2.0363e-07,
                    2.1139e-07,
                    2.1919e-07,
                    2.2702e-07,
                    2.3496e-07,
                    2.4326e-07,
                    2.5193e-07,
                    2.6096e-07,
                    2.7037e-07,
                    2.8014e-07,
                    2.9028e-07,
                    3.008e-07,
                    3.1168e-07,
                    3.2294e-07,
                    3.3457e-07,
                    3.4717e-07,
                    3.6073e-07,
                    3.7526e-07,
                    3.9075e-07,
                    4.0722e-07,
                    4.2465e-07,
                    4.4306e-07,
                    4.6244e-07,
                    4.828e-07,
                    5.0414e-07,
                    5.2605e-07,
                    5.4856e-07,
                    5.7165e-07,
                    5.9533e-07,
                    6.1961e-07,
                    6.4449e-07,
                    6.6997e-07,
                    6.9605e-07,
                    7.2273e-07,
                    7.5001e-07,
                    7.774e-07,
                    8.049e-07,
                    8.3251e-07,
                    8.6023e-07,
                    8.8806e-07,
                    9.1601e-07,
                    9.4408e-07,
                    9.7226e-07,
                    1.0006e-06,
                    1.029e-06,
                    1.0631e-06,
                    1.1028e-06,
                    1.1482e-06,
                    1.1992e-06,
                    1.2558e-06,
                    1.3195e-06,
                    1.3904e-06,
                    1.4687e-06,
                    1.5546e-06,
                    1.6483e-06,
                    1.7442e-06,
                    1.8426e-06,
                    1.9434e-06,
                    2.0469e-06,
                    2.1532e-06,
                    2.2622e-06,
                    2.3741e-06,
                    2.4887e-06,
                    2.6062e-06,
                    2.7265e-06,
                    2.8481e-06,
                    2.9742e-06,
                    3.1066e-06,
                    3.2458e-06,
                    3.3921e-06,
                    3.5439e-06,
                    3.7008e-06,
                    3.863e-06,
                    4.0312e-06,
                    4.207e-06,
                    4.374e-06,
                    4.5343e-06,
                    4.7021e-06,
                    4.8299e-06,
                    4.9224e-06,
                    5.0199e-06,
                    5.0856e-06,
                    5.2034e-06,
                    5.3318e-06,
                    5.4596e-06,
                    5.5981e-06,
                    5.7211e-06,
                    5.7649e-06,
                    5.7651e-06,
                    5.766e-06,
                    5.7732e-06,
                    5.7671e-06,
                    5.7542e-06,
                    5.7442e-06,
                    5.7155e-06,
                    5.662e-06,
                    5.6067e-06,
                    5.56e-06,
                    5.5405e-06,
                    5.5451e-06,
                    5.4955e-06,
                    5.4673e-06,
                    5.3877e-06,
                    5.2947e-06,
                    5.186e-06,
                    5.0378e-06,
                    4.8736e-06,
                    4.7398e-06,
                    4.6305e-06,
                    4.511e-06,
                    4.3764e-06,
                    4.2611e-06,
                    4.1464e-06,
                    4.0287e-06,
                    3.9208e-06,
                    3.8431e-06,
                    3.7699e-06,
                    3.6735e-06,
                    3.5784e-06,
                    3.4847e-06,
                    3.4336e-06,
                    3.3719e-06,
                    3.3116e-06,
                    3.2598e-06,
                    3.226e-06,
                    3.2158e-06,
                    3.2249e-06,
                    3.258e-06,
                    3.2929e-06,
                    3.301e-06,
                    3.3099e-06,
                    3.3103e-06,
                    3.307e-06,
                    3.2942e-06,
                    3.2802e-06,
                    3.2595e-06,
                    3.2427e-06
                ],
                "Total_CO2": 0.07,
                "Total_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2.4549e-08,
                    4.9098e-08,
                    4.9098e-08,
                    7.3647e-08,
                    7.3647e-08,
                    7.3647e-08,
                    7.3647e-08,
                    7.3647e-08,
                    7.3647e-08,
                    8.183e-08,
                    9.3287e-08,
                    1.0638e-07,
                    7.0026e-07,
                    1.4014e-06,
                    2.0926e-06,
                    2.8713e-06,
                    3.6812e-06,
                    4.5275e-06,
                    5.4826e-06,
                    6.5467e-06,
                    7.6156e-06,
                    8.833e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008
                ],
                "Fossil_CO2": 0.1,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2.4549e-08,
                    4.9098e-08,
                    4.9098e-08,
                    7.3647e-08,
                    7.3647e-08,
                    7.3647e-08,
                    7.3647e-08,
                    7.3647e-08,
                    7.3647e-08,
                    8.183e-08,
                    9.3287e-08,
                    1.0638e-07,
                    7.0026e-07,
                    1.4014e-06,
                    2.0926e-06,
                    2.8713e-06,
                    3.6812e-06,
                    4.5275e-06,
                    5.4826e-06,
                    6.5467e-06,
                    7.6156e-06,
                    8.833e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [],
                "Total_CH4": 0.06,
                "Total_CH4_timeseries": [
                    5.3953e-09,
                    1.2301e-08,
                    2.0725e-08,
                    3.0674e-08,
                    4.2158e-08,
                    5.5186e-08,
                    6.977e-08,
                    8.5923e-08,
                    1.0366e-07,
                    1.23e-07,
                    1.4399e-07,
                    1.6648e-07,
                    1.9046e-07,
                    2.1592e-07,
                    2.4288e-07,
                    2.7133e-07,
                    3.0129e-07,
                    3.3277e-07,
                    3.6575e-07,
                    4.0024e-07,
                    4.3487e-07,
                    4.696e-07,
                    5.0443e-07,
                    5.3935e-07,
                    5.7436e-07,
                    6.0944e-07,
                    6.446e-07,
                    6.7982e-07,
                    7.151e-07,
                    7.5041e-07,
                    7.8574e-07,
                    8.2128e-07,
                    8.5703e-07,
                    8.9299e-07,
                    9.2918e-07,
                    9.6558e-07,
                    1.0021e-06,
                    1.0388e-06,
                    1.0757e-06,
                    1.1126e-06,
                    1.1514e-06,
                    1.1921e-06,
                    1.2345e-06,
                    1.2788e-06,
                    1.3249e-06,
                    1.3728e-06,
                    1.4226e-06,
                    1.4744e-06,
                    1.528e-06,
                    1.5836e-06,
                    1.6438e-06,
                    1.7088e-06,
                    1.7784e-06,
                    1.8527e-06,
                    1.9317e-06,
                    2.0153e-06,
                    2.1036e-06,
                    2.1966e-06,
                    2.2943e-06,
                    2.3966e-06,
                    2.5014e-06,
                    2.6089e-06,
                    2.7197e-06,
                    2.833e-06,
                    2.9489e-06,
                    3.0672e-06,
                    3.188e-06,
                    3.3111e-06,
                    3.4367e-06,
                    3.5645e-06,
                    3.6921e-06,
                    3.8195e-06,
                    3.9469e-06,
                    4.0749e-06,
                    4.1952e-06,
                    4.3153e-06,
                    4.4351e-06,
                    4.5546e-06,
                    4.6738e-06,
                    4.7927e-06,
                    4.9394e-06,
                    5.1134e-06,
                    5.3141e-06,
                    5.5422e-06,
                    5.7975e-06,
                    6.0812e-06,
                    6.3935e-06,
                    6.7345e-06,
                    7.1042e-06,
                    7.5046e-06,
                    7.9222e-06,
                    8.357e-06,
                    8.8092e-06,
                    9.2786e-06,
                    9.7981e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_CH4": 0.09,
                "Fossil_CH4_timeseries": [
                    4.4067e-09,
                    1.005e-08,
                    1.6936e-08,
                    2.5074e-08,
                    3.4472e-08,
                    4.514e-08,
                    5.7089e-08,
                    7.0334e-08,
                    8.4889e-08,
                    1.0077e-07,
                    1.1803e-07,
                    1.3649e-07,
                    1.5617e-07,
                    1.7706e-07,
                    1.9916e-07,
                    2.2247e-07,
                    2.4701e-07,
                    2.7278e-07,
                    2.9977e-07,
                    3.28e-07,
                    3.5634e-07,
                    3.8477e-07,
                    4.1326e-07,
                    4.4183e-07,
                    4.7046e-07,
                    4.9915e-07,
                    5.2788e-07,
                    5.5666e-07,
                    5.8547e-07,
                    6.1429e-07,
                    6.4311e-07,
                    6.7212e-07,
                    7.0131e-07,
                    7.307e-07,
                    7.6028e-07,
                    7.9006e-07,
                    8.1996e-07,
                    8.4998e-07,
                    8.8012e-07,
                    9.1038e-07,
                    9.4214e-07,
                    9.7539e-07,
                    1.0101e-06,
                    1.0463e-06,
                    1.084e-06,
                    1.1232e-06,
                    1.164e-06,
                    1.2063e-06,
                    1.2502e-06,
                    1.2958e-06,
                    1.345e-06,
                    1.398e-06,
                    1.4548e-06,
                    1.5153e-06,
                    1.5796e-06,
                    1.6475e-06,
                    1.7193e-06,
                    1.7948e-06,
                    1.874e-06,
                    1.957e-06,
                    2.042e-06,
                    2.129e-06,
                    2.2189e-06,
                    2.3108e-06,
                    2.4047e-06,
                    2.5006e-06,
                    2.5983e-06,
                    2.6979e-06,
                    2.7994e-06,
                    2.9027e-06,
                    3.0057e-06,
                    3.1084e-06,
                    3.2112e-06,
                    3.3145e-06,
                    3.41e-06,
                    3.5053e-06,
                    3.6003e-06,
                    3.695e-06,
                    3.7893e-06,
                    3.8833e-06,
                    3.9995e-06,
                    4.1376e-06,
                    4.2968e-06,
                    4.4778e-06,
                    4.6805e-06,
                    4.9048e-06,
                    5.1506e-06,
                    5.4178e-06,
                    5.7063e-06,
                    6.0179e-06,
                    6.3446e-06,
                    6.6865e-06,
                    7.0436e-06,
                    7.4158e-06,
                    7.836e-06,
                    8.2991e-06,
                    8.8074e-06,
                    9.3628e-06,
                    9.9677e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [
                    9.8868e-10,
                    2.2516e-09,
                    3.7889e-09,
                    5.6004e-09,
                    7.6862e-09,
                    1.0046e-08,
                    1.2681e-08,
                    1.5589e-08,
                    1.8772e-08,
                    2.2229e-08,
                    2.5967e-08,
                    2.9986e-08,
                    3.4285e-08,
                    3.8865e-08,
                    4.3725e-08,
                    4.8866e-08,
                    5.4288e-08,
                    5.9991e-08,
                    6.5974e-08,
                    7.2238e-08,
                    7.8524e-08,
                    8.4833e-08,
                    9.1164e-08,
                    9.7518e-08,
                    1.0389e-07,
                    1.1029e-07,
                    1.1672e-07,
                    1.2316e-07,
                    1.2963e-07,
                    1.3612e-07,
                    1.4263e-07,
                    1.4916e-07,
                    1.5572e-07,
                    1.623e-07,
                    1.689e-07,
                    1.7552e-07,
                    1.8217e-07,
                    1.8884e-07,
                    1.9553e-07,
                    2.0225e-07,
                    2.093e-07,
                    2.1668e-07,
                    2.244e-07,
                    2.3246e-07,
                    2.4085e-07,
                    2.4958e-07,
                    2.5865e-07,
                    2.6805e-07,
                    2.7778e-07,
                    2.8786e-07,
                    2.9886e-07,
                    3.1078e-07,
                    3.2364e-07,
                    3.3742e-07,
                    3.5213e-07,
                    3.6777e-07,
                    3.8433e-07,
                    4.0183e-07,
                    4.2025e-07,
                    4.396e-07,
                    4.5947e-07,
                    4.7986e-07,
                    5.0077e-07,
                    5.2221e-07,
                    5.4417e-07,
                    5.6665e-07,
                    5.8966e-07,
                    6.1318e-07,
                    6.3723e-07,
                    6.618e-07,
                    6.8641e-07,
                    7.1105e-07,
                    7.3572e-07,
                    7.6044e-07,
                    7.8518e-07,
                    8.0996e-07,
                    8.3478e-07,
                    8.5963e-07,
                    8.8452e-07,
                    9.0945e-07,
                    9.399e-07,
                    9.7587e-07,
                    1.0174e-06,
                    1.0644e-06,
                    1.117e-06,
                    1.1764e-06,
                    1.2429e-06,
                    1.3167e-06,
                    1.3979e-06,
                    1.4868e-06,
                    1.5776e-06,
                    1.6706e-06,
                    1.7656e-06,
                    1.8628e-06,
                    1.9621e-06,
                    2.0636e-06,
                    2.1674e-06,
                    2.2735e-06,
                    2.3818e-06,
                    2.4925e-06,
                    2.6042e-06,
                    2.7199e-06,
                    2.8415e-06,
                    2.9696e-06,
                    3.1042e-06,
                    3.2439e-06,
                    3.3884e-06,
                    3.5376e-06,
                    3.6924e-06,
                    3.8543e-06,
                    4.0065e-06,
                    4.1502e-06,
                    4.2999e-06,
                    4.4127e-06,
                    4.4924e-06,
                    4.577e-06,
                    4.6295e-06,
                    4.7314e-06,
                    4.8407e-06,
                    4.9458e-06,
                    5.0592e-06,
                    5.1563e-06,
                    5.1796e-06,
                    5.1624e-06,
                    5.1462e-06,
                    5.1346e-06,
                    5.1066e-06,
                    5.0706e-06,
                    5.0352e-06,
                    4.9806e-06,
                    4.9038e-06,
                    4.8247e-06,
                    4.7531e-06,
                    4.7102e-06,
                    4.6921e-06,
                    4.6227e-06,
                    4.5737e-06,
                    4.4745e-06,
                    4.3628e-06,
                    4.2368e-06,
                    4.0733e-06,
                    3.8959e-06,
                    3.7524e-06,
                    3.6336e-06,
                    3.5042e-06,
                    3.3604e-06,
                    3.2355e-06,
                    3.1121e-06,
                    2.9871e-06,
                    2.8716e-06,
                    2.7861e-06,
                    2.7025e-06,
                    2.5963e-06,
                    2.4913e-06,
                    2.3878e-06,
                    2.3269e-06,
                    2.2563e-06,
                    2.1871e-06,
                    2.126e-06,
                    2.083e-06,
                    2.0633e-06,
                    2.063e-06,
                    2.0866e-06,
                    2.1121e-06,
                    2.1085e-06,
                    2.1058e-06,
                    2.0942e-06,
                    2.0788e-06,
                    2.0541e-06,
                    2.0283e-06,
                    1.9973e-06,
                    1.9704e-06
                ],
                "Total_N2O": 0.02,
                "Total_N2O_timeseries": [
                    9.0371e-09,
                    1.82e-08,
                    2.7486e-08,
                    3.689e-08,
                    4.6407e-08,
                    5.6031e-08,
                    6.5753e-08,
                    7.5564e-08,
                    8.5455e-08,
                    9.5414e-08,
                    1.0543e-07,
                    1.1551e-07,
                    1.2565e-07,
                    1.3584e-07,
                    1.4609e-07,
                    1.5639e-07,
                    1.6675e-07,
                    1.7717e-07,
                    1.8765e-07,
                    1.9819e-07,
                    2.0886e-07,
                    2.1974e-07,
                    2.3094e-07,
                    2.425e-07,
                    2.5445e-07,
                    2.6681e-07,
                    2.7955e-07,
                    2.9264e-07,
                    3.0601e-07,
                    3.1957e-07,
                    3.3326e-07,
                    3.4707e-07,
                    3.6099e-07,
                    3.7501e-07,
                    3.8913e-07,
                    4.0334e-07,
                    4.1764e-07,
                    4.3204e-07,
                    4.4655e-07,
                    4.6124e-07,
                    4.7607e-07,
                    4.9104e-07,
                    5.0614e-07,
                    5.2138e-07,
                    5.3677e-07,
                    5.5231e-07,
                    5.68e-07,
                    5.8385e-07,
                    5.9987e-07,
                    6.1606e-07,
                    6.3244e-07,
                    6.4902e-07,
                    6.6582e-07,
                    6.8284e-07,
                    7.0011e-07,
                    7.1762e-07,
                    7.3538e-07,
                    7.5339e-07,
                    7.7165e-07,
                    7.9015e-07,
                    8.089e-07,
                    8.2789e-07,
                    8.4713e-07,
                    8.6663e-07,
                    8.8639e-07,
                    9.0642e-07,
                    9.267e-07,
                    9.4725e-07,
                    9.6806e-07,
                    9.8914e-07,
                    1.0105e-06,
                    1.0321e-06,
                    1.054e-06,
                    1.0761e-06,
                    1.0986e-06,
                    1.1213e-06,
                    1.1443e-06,
                    1.1675e-06,
                    1.1911e-06,
                    1.2149e-06,
                    1.2389e-06,
                    1.2633e-06,
                    1.2878e-06,
                    1.3127e-06,
                    1.3378e-06,
                    1.3631e-06,
                    1.3888e-06,
                    1.4147e-06,
                    1.4411e-06,
                    1.4678e-06,
                    1.4952e-06,
                    1.5237e-06,
                    1.5538e-06,
                    1.5857e-06,
                    1.6197e-06,
                    1.6556e-06,
                    1.6937e-06,
                    1.7336e-06,
                    1.7752e-06,
                    1.8182e-06,
                    1.8622e-06,
                    1.9073e-06,
                    1.9534e-06,
                    2.0004e-06,
                    2.0484e-06,
                    2.0974e-06,
                    2.1474e-06,
                    2.1985e-06,
                    2.2507e-06,
                    2.3042e-06,
                    2.3596e-06,
                    2.418e-06,
                    2.4794e-06,
                    2.5395e-06,
                    2.599e-06,
                    2.6604e-06,
                    2.7237e-06,
                    2.7914e-06,
                    2.8639e-06,
                    2.9653e-06,
                    3.0691e-06,
                    3.1781e-06,
                    3.282e-06,
                    3.3841e-06,
                    3.487e-06,
                    3.5989e-06,
                    3.7192e-06,
                    3.8455e-06,
                    3.9863e-06,
                    4.1226e-06,
                    4.264e-06,
                    4.4214e-06,
                    4.5999e-06,
                    4.7868e-06,
                    4.976e-06,
                    5.1889e-06,
                    5.4045e-06,
                    5.6403e-06,
                    5.8784e-06,
                    6.1284e-06,
                    6.4456e-06,
                    6.7888e-06,
                    7.1505e-06,
                    7.4959e-06,
                    7.8322e-06,
                    8.1172e-06,
                    8.3908e-06,
                    8.7717e-06,
                    9.2143e-06,
                    9.5456e-06,
                    9.8467e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_N2O": 0.06,
                "Fossil_N2O_timeseries": [
                    8.4546e-09,
                    1.7023e-08,
                    2.5704e-08,
                    3.4492e-08,
                    4.3384e-08,
                    5.2374e-08,
                    6.1455e-08,
                    7.0619e-08,
                    7.9859e-08,
                    8.9165e-08,
                    9.853e-08,
                    1.0795e-07,
                    1.1743e-07,
                    1.2697e-07,
                    1.3656e-07,
                    1.4621e-07,
                    1.5591e-07,
                    1.6567e-07,
                    1.7549e-07,
                    1.8537e-07,
                    1.9536e-07,
                    2.0555e-07,
                    2.1601e-07,
                    2.2678e-07,
                    2.3789e-07,
                    2.4934e-07,
                    2.6113e-07,
                    2.7322e-07,
                    2.8554e-07,
                    2.9804e-07,
                    3.1066e-07,
                    3.2339e-07,
                    3.3621e-07,
                    3.4913e-07,
                    3.6214e-07,
                    3.7524e-07,
                    3.8842e-07,
                    4.0169e-07,
                    4.1506e-07,
                    4.2853e-07,
                    4.4211e-07,
                    4.5579e-07,
                    4.6958e-07,
                    4.8348e-07,
                    4.9749e-07,
                    5.1161e-07,
                    5.2585e-07,
                    5.4022e-07,
                    5.5472e-07,
                    5.6935e-07,
                    5.8413e-07,
                    5.9908e-07,
                    6.142e-07,
                    6.2951e-07,
                    6.4503e-07,
                    6.6074e-07,
                    6.7666e-07,
                    6.9278e-07,
                    7.091e-07,
                    7.2561e-07,
                    7.4231e-07,
                    7.5919e-07,
                    7.7626e-07,
                    7.9351e-07,
                    8.1095e-07,
                    8.2858e-07,
                    8.4639e-07,
                    8.6438e-07,
                    8.8256e-07,
                    9.0093e-07,
                    9.195e-07,
                    9.3825e-07,
                    9.572e-07,
                    9.7635e-07,
                    9.957e-07,
                    1.0152e-06,
                    1.035e-06,
                    1.0549e-06,
                    1.075e-06,
                    1.0953e-06,
                    1.1157e-06,
                    1.1363e-06,
                    1.157e-06,
                    1.1779e-06,
                    1.1989e-06,
                    1.22e-06,
                    1.2413e-06,
                    1.2627e-06,
                    1.2844e-06,
                    1.3063e-06,
                    1.3286e-06,
                    1.3517e-06,
                    1.376e-06,
                    1.4016e-06,
                    1.4286e-06,
                    1.4571e-06,
                    1.487e-06,
                    1.5183e-06,
                    1.5508e-06,
                    1.5842e-06,
                    1.6183e-06,
                    1.653e-06,
                    1.6883e-06,
                    1.7241e-06,
                    1.7605e-06,
                    1.7975e-06,
                    1.835e-06,
                    1.8731e-06,
                    1.9119e-06,
                    1.9515e-06,
                    1.9921e-06,
                    2.0339e-06,
                    2.0773e-06,
                    2.1222e-06,
                    2.169e-06,
                    2.2174e-06,
                    2.2676e-06,
                    2.3195e-06,
                    2.3728e-06,
                    2.4515e-06,
                    2.5302e-06,
                    2.6133e-06,
                    2.6966e-06,
                    2.7814e-06,
                    2.8672e-06,
                    2.9603e-06,
                    3.0587e-06,
                    3.1619e-06,
                    3.2773e-06,
                    3.3877e-06,
                    3.5058e-06,
                    3.6394e-06,
                    3.793e-06,
                    3.9565e-06,
                    4.123e-06,
                    4.3162e-06,
                    4.5108e-06,
                    4.7271e-06,
                    4.9466e-06,
                    5.1792e-06,
                    5.481e-06,
                    5.811e-06,
                    6.163e-06,
                    6.4989e-06,
                    6.8254e-06,
                    7.1011e-06,
                    7.3651e-06,
                    7.7374e-06,
                    8.1727e-06,
                    8.4963e-06,
                    8.7897e-06,
                    9.0549e-06,
                    9.3352e-06,
                    9.5707e-06,
                    9.8177e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": [
                    5.8253e-10,
                    1.1767e-09,
                    1.7821e-09,
                    2.3978e-09,
                    3.0232e-09,
                    3.6571e-09,
                    4.2981e-09,
                    4.945e-09,
                    5.596e-09,
                    6.2492e-09,
                    6.9036e-09,
                    7.5588e-09,
                    8.2145e-09,
                    8.8708e-09,
                    9.5274e-09,
                    1.0184e-08,
                    1.0842e-08,
                    1.15e-08,
                    1.2159e-08,
                    1.2819e-08,
                    1.3491e-08,
                    1.419e-08,
                    1.493e-08,
                    1.5721e-08,
                    1.6566e-08,
                    1.7468e-08,
                    1.8423e-08,
                    1.9426e-08,
                    2.0465e-08,
                    2.1526e-08,
                    2.26e-08,
                    2.3685e-08,
                    2.4778e-08,
                    2.5879e-08,
                    2.6987e-08,
                    2.8102e-08,
                    2.9223e-08,
                    3.0351e-08,
                    3.1486e-08,
                    3.271e-08,
                    3.3962e-08,
                    3.5245e-08,
                    3.6559e-08,
                    3.7906e-08,
                    3.9285e-08,
                    4.0699e-08,
                    4.2148e-08,
                    4.3633e-08,
                    4.5154e-08,
                    4.6713e-08,
                    4.831e-08,
                    4.9944e-08,
                    5.1618e-08,
                    5.3331e-08,
                    5.5085e-08,
                    5.6882e-08,
                    5.8724e-08,
                    6.0612e-08,
                    6.255e-08,
                    6.454e-08,
                    6.6587e-08,
                    6.8697e-08,
                    7.0873e-08,
                    7.3121e-08,
                    7.5442e-08,
                    7.784e-08,
                    8.0315e-08,
                    8.2869e-08,
                    8.55e-08,
                    8.8209e-08,
                    9.0994e-08,
                    9.3853e-08,
                    9.6786e-08,
                    9.9795e-08,
                    1.0288e-07,
                    1.0605e-07,
                    1.0929e-07,
                    1.1263e-07,
                    1.1605e-07,
                    1.1958e-07,
                    1.232e-07,
                    1.2694e-07,
                    1.3079e-07,
                    1.3476e-07,
                    1.3887e-07,
                    1.431e-07,
                    1.4748e-07,
                    1.52e-07,
                    1.5667e-07,
                    1.6151e-07,
                    1.6656e-07,
                    1.7197e-07,
                    1.7781e-07,
                    1.8417e-07,
                    1.9108e-07,
                    1.9857e-07,
                    2.0665e-07,
                    2.1527e-07,
                    2.2441e-07,
                    2.3398e-07,
                    2.4394e-07,
                    2.5431e-07,
                    2.6509e-07,
                    2.7629e-07,
                    2.8791e-07,
                    2.9997e-07,
                    3.1247e-07,
                    3.2542e-07,
                    3.3882e-07,
                    3.5268e-07,
                    3.6751e-07,
                    3.8411e-07,
                    4.0213e-07,
                    4.1722e-07,
                    4.3008e-07,
                    4.4293e-07,
                    4.5608e-07,
                    4.7194e-07,
                    4.9109e-07,
                    5.138e-07,
                    5.3888e-07,
                    5.6484e-07,
                    5.8535e-07,
                    6.0273e-07,
                    6.1976e-07,
                    6.3862e-07,
                    6.605e-07,
                    6.8359e-07,
                    7.0899e-07,
                    7.3497e-07,
                    7.582e-07,
                    7.8205e-07,
                    8.0687e-07,
                    8.3029e-07,
                    8.53e-07,
                    8.7276e-07,
                    8.9368e-07,
                    9.1322e-07,
                    9.3182e-07,
                    9.4919e-07,
                    9.6452e-07,
                    9.7774e-07,
                    9.8742e-07,
                    9.9698e-07,
                    1.0068e-06,
                    1.016e-06,
                    1.0257e-06,
                    1.0343e-06,
                    1.0416e-06,
                    1.0492e-06,
                    1.057e-06,
                    1.0673e-06,
                    1.0772e-06,
                    1.0871e-06,
                    1.097e-06,
                    1.1067e-06,
                    1.1155e-06,
                    1.1245e-06,
                    1.1337e-06,
                    1.143e-06,
                    1.1525e-06,
                    1.1619e-06,
                    1.1714e-06,
                    1.1809e-06,
                    1.1924e-06,
                    1.2041e-06,
                    1.2161e-06,
                    1.2282e-06,
                    1.2401e-06,
                    1.2519e-06,
                    1.2622e-06,
                    1.2723e-06
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                114.23484,
                                22.55576
                            ],
                            [
                                114.16106,
                                22.56447
                            ],
                            [
                                114.03762,
                                22.5037
                            ],
                            [
                                113.90341,
                                22.40432
                            ],
                            [
                                114.02185,
                                22.35017
                            ],
                            [
                                114.10438,
                                22.36198
                            ],
                            [
                                114.16942,
                                22.29051
                            ],
                            [
                                114.20663,
                                22.31297
                            ],
                            [
                                114.27863,
                                22.26346
                            ],
                            [
                                114.28112,
                                22.38689
                            ],
                            [
                                114.37202,
                                22.36081
                            ],
                            [
                                114.39537,
                                22.43274
                            ],
                            [
                                114.27766,
                                22.44258
                            ],
                            [
                                114.24178,
                                22.48199
                            ],
                            [
                                114.23484,
                                22.55576
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                113.9632,
                                22.23461
                            ],
                            [
                                114.01962,
                                22.30751
                            ],
                            [
                                113.90283,
                                22.28903
                            ],
                            [
                                113.83877,
                                22.22453
                            ],
                            [
                                113.9632,
                                22.23461
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "HUN",
                "Country": "Hungary",
                "Total_3GHG": 0.18,
                "Total_3GHG_timeseries": [
                    7.4628e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.003,
                    0.003
                ],
                "Fossil_3GHG": 0.25,
                "Fossil_3GHG_timeseries": [
                    1.4772e-06,
                    2.9856e-06,
                    4.4908e-06,
                    6.0421e-06,
                    7.6009e-06,
                    9.1647e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027
                ],
                "Land_3GHG": 0.06,
                "Land_3GHG_timeseries": [
                    5.9856e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Total_CO2": 0.21,
                "Total_CO2_timeseries": [
                    4.0839e-06,
                    8.0621e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024
                ],
                "Fossil_CO2": 0.3,
                "Fossil_CO2_timeseries": [
                    1.2375e-07,
                    2.7885e-07,
                    4.3395e-07,
                    6.303e-07,
                    8.349e-07,
                    1.0494e-06,
                    1.2953e-06,
                    1.4668e-06,
                    1.8133e-06,
                    2.2209e-06,
                    2.6532e-06,
                    3.1746e-06,
                    3.7191e-06,
                    4.2636e-06,
                    4.8296e-06,
                    5.4731e-06,
                    6.2337e-06,
                    7.0471e-06,
                    7.9316e-06,
                    8.8869e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023
                ],
                "Land_CO2": 0.02,
                "Land_CO2_timeseries": [
                    3.9602e-06,
                    7.7833e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_CH4": 0.07,
                "Total_CH4_timeseries": [
                    3.2317e-06,
                    6.4174e-06,
                    9.5542e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_CH4": 0.1,
                "Fossil_CH4_timeseries": [
                    1.282e-06,
                    2.5632e-06,
                    3.8403e-06,
                    5.1214e-06,
                    6.4012e-06,
                    7.6752e-06,
                    8.954e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Land_CH4": 0.04,
                "Land_CH4_timeseries": [
                    1.9497e-06,
                    3.8543e-06,
                    5.7138e-06,
                    7.5284e-06,
                    9.2979e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_N2O": 0.39,
                "Total_N2O_timeseries": [
                    1.4714e-07,
                    2.9659e-07,
                    4.4829e-07,
                    6.0214e-07,
                    7.58e-07,
                    9.1571e-07,
                    1.0751e-06,
                    1.2359e-06,
                    1.398e-06,
                    1.561e-06,
                    1.7248e-06,
                    1.8893e-06,
                    2.0545e-06,
                    2.2204e-06,
                    2.387e-06,
                    2.5542e-06,
                    2.7221e-06,
                    2.8907e-06,
                    3.0601e-06,
                    3.2302e-06,
                    3.4026e-06,
                    3.5797e-06,
                    3.7634e-06,
                    3.955e-06,
                    4.1554e-06,
                    4.3646e-06,
                    4.5823e-06,
                    4.8075e-06,
                    5.0387e-06,
                    5.2737e-06,
                    5.5113e-06,
                    5.751e-06,
                    5.9926e-06,
                    6.2359e-06,
                    6.4809e-06,
                    6.7274e-06,
                    6.9755e-06,
                    7.2252e-06,
                    7.4766e-06,
                    7.7462e-06,
                    8.0064e-06,
                    8.2575e-06,
                    8.5002e-06,
                    8.7353e-06,
                    8.9637e-06,
                    9.1865e-06,
                    9.4049e-06,
                    9.6205e-06,
                    9.8347e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_N2O": 0.54,
                "Fossil_N2O_timeseries": [
                    7.1388e-08,
                    1.4358e-07,
                    2.1657e-07,
                    2.9034e-07,
                    3.6489e-07,
                    4.4018e-07,
                    5.1621e-07,
                    5.9294e-07,
                    6.7035e-07,
                    7.4841e-07,
                    8.2711e-07,
                    9.0642e-07,
                    9.8636e-07,
                    1.0669e-06,
                    1.1481e-06,
                    1.2299e-06,
                    1.3123e-06,
                    1.3953e-06,
                    1.479e-06,
                    1.5633e-06,
                    1.6484e-06,
                    1.7345e-06,
                    1.822e-06,
                    1.9109e-06,
                    2.0013e-06,
                    2.0932e-06,
                    2.1867e-06,
                    2.2815e-06,
                    2.3776e-06,
                    2.4747e-06,
                    2.5725e-06,
                    2.6712e-06,
                    2.7706e-06,
                    2.8708e-06,
                    2.9716e-06,
                    3.0732e-06,
                    3.1756e-06,
                    3.2786e-06,
                    3.3824e-06,
                    3.4881e-06,
                    3.5948e-06,
                    3.7025e-06,
                    3.8114e-06,
                    3.9214e-06,
                    4.0325e-06,
                    4.1448e-06,
                    4.2584e-06,
                    4.3731e-06,
                    4.4891e-06,
                    4.6065e-06,
                    4.7251e-06,
                    4.8453e-06,
                    4.9671e-06,
                    5.0905e-06,
                    5.2155e-06,
                    5.3423e-06,
                    5.4706e-06,
                    5.6006e-06,
                    5.732e-06,
                    5.8647e-06,
                    5.9987e-06,
                    6.1339e-06,
                    6.2702e-06,
                    6.4076e-06,
                    6.5462e-06,
                    6.6858e-06,
                    6.8265e-06,
                    6.9684e-06,
                    7.1115e-06,
                    7.2558e-06,
                    7.4015e-06,
                    7.5486e-06,
                    7.6972e-06,
                    7.8473e-06,
                    7.999e-06,
                    8.1524e-06,
                    8.3073e-06,
                    8.4639e-06,
                    8.6219e-06,
                    8.7815e-06,
                    8.944e-06,
                    9.1123e-06,
                    9.2888e-06,
                    9.4753e-06,
                    9.6732e-06,
                    9.8833e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_N2O": 0.33,
                "Land_N2O_timeseries": [
                    7.5748e-08,
                    1.5301e-07,
                    2.3172e-07,
                    3.1179e-07,
                    3.9311e-07,
                    4.7553e-07,
                    5.5889e-07,
                    6.43e-07,
                    7.2765e-07,
                    8.1259e-07,
                    8.9768e-07,
                    9.8287e-07,
                    1.0681e-06,
                    1.1535e-06,
                    1.2389e-06,
                    1.3243e-06,
                    1.4098e-06,
                    1.4954e-06,
                    1.5811e-06,
                    1.6669e-06,
                    1.7542e-06,
                    1.8452e-06,
                    1.9414e-06,
                    2.0442e-06,
                    2.1541e-06,
                    2.2713e-06,
                    2.3956e-06,
                    2.5259e-06,
                    2.6611e-06,
                    2.7991e-06,
                    2.9387e-06,
                    3.0798e-06,
                    3.222e-06,
                    3.3651e-06,
                    3.5092e-06,
                    3.6541e-06,
                    3.7999e-06,
                    3.9465e-06,
                    4.0942e-06,
                    4.2582e-06,
                    4.4116e-06,
                    4.555e-06,
                    4.6888e-06,
                    4.8139e-06,
                    4.9312e-06,
                    5.0416e-06,
                    5.1466e-06,
                    5.2473e-06,
                    5.3455e-06,
                    5.4428e-06,
                    5.5402e-06,
                    5.638e-06,
                    5.7366e-06,
                    5.8363e-06,
                    5.9372e-06,
                    6.0396e-06,
                    6.1438e-06,
                    6.2501e-06,
                    6.3586e-06,
                    6.4696e-06,
                    6.5862e-06,
                    6.7139e-06,
                    6.8577e-06,
                    7.0214e-06,
                    7.2084e-06,
                    7.421e-06,
                    7.661e-06,
                    7.9292e-06,
                    8.2257e-06,
                    8.5499e-06,
                    8.9064e-06,
                    9.3039e-06,
                    9.748e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            22.15531,
                            48.4034
                        ],
                        [
                            22.02818,
                            48.39183
                        ],
                        [
                            21.7656,
                            48.33906
                        ],
                        [
                            21.6695,
                            48.38955
                        ],
                        [
                            21.61135,
                            48.51008
                        ],
                        [
                            21.42147,
                            48.5641
                        ],
                        [
                            21.23928,
                            48.53967
                        ],
                        [
                            21.13348,
                            48.49555
                        ],
                        [
                            21.01552,
                            48.53182
                        ],
                        [
                            20.95837,
                            48.52144
                        ],
                        [
                            20.84939,
                            48.57922
                        ],
                        [
                            20.7085,
                            48.56945
                        ],
                        [
                            20.50294,
                            48.52931
                        ],
                        [
                            20.50525,
                            48.48901
                        ],
                        [
                            20.41773,
                            48.41993
                        ],
                        [
                            20.41182,
                            48.36974
                        ],
                        [
                            20.28619,
                            48.26199
                        ],
                        [
                            20.24042,
                            48.28023
                        ],
                        [
                            20.02919,
                            48.17718
                        ],
                        [
                            19.89874,
                            48.16632
                        ],
                        [
                            19.76118,
                            48.2131
                        ],
                        [
                            19.69217,
                            48.20446
                        ],
                        [
                            19.63082,
                            48.25008
                        ],
                        [
                            19.52657,
                            48.20313
                        ],
                        [
                            19.4858,
                            48.09971
                        ],
                        [
                            19.30033,
                            48.08799
                        ],
                        [
                            19.24636,
                            48.05674
                        ],
                        [
                            19.13517,
                            48.07399
                        ],
                        [
                            18.8207,
                            48.03854
                        ],
                        [
                            18.75865,
                            47.92031
                        ],
                        [
                            18.82088,
                            47.85089
                        ],
                        [
                            18.67026,
                            47.76316
                        ],
                        [
                            18.43067,
                            47.75614
                        ],
                        [
                            18.29298,
                            47.7314
                        ],
                        [
                            18.0875,
                            47.75636
                        ],
                        [
                            17.89392,
                            47.73946
                        ],
                        [
                            17.71231,
                            47.75551
                        ],
                        [
                            17.52684,
                            47.86544
                        ],
                        [
                            17.45134,
                            47.888
                        ],
                        [
                            17.3368,
                            47.99168
                        ],
                        [
                            17.1608,
                            48.00666
                        ],
                        [
                            17.10314,
                            47.89808
                        ],
                        [
                            17.01276,
                            47.85667
                        ],
                        [
                            17.09307,
                            47.70824
                        ],
                        [
                            16.74903,
                            47.68142
                        ],
                        [
                            16.72094,
                            47.73533
                        ],
                        [
                            16.63426,
                            47.75905
                        ],
                        [
                            16.42154,
                            47.6653
                        ],
                        [
                            16.59025,
                            47.61746
                        ],
                        [
                            16.65208,
                            47.6229
                        ],
                        [
                            16.71451,
                            47.53963
                        ],
                        [
                            16.65234,
                            47.50034
                        ],
                        [
                            16.65988,
                            47.45478
                        ],
                        [
                            16.58079,
                            47.41839
                        ],
                        [
                            16.44569,
                            47.40592
                        ],
                        [
                            16.48736,
                            47.28394
                        ],
                        [
                            16.42905,
                            47.18517
                        ],
                        [
                            16.51677,
                            47.14932
                        ],
                        [
                            16.46425,
                            47.09458
                        ],
                        [
                            16.4926,
                            47.01076
                        ],
                        [
                            16.2831,
                            47.00464
                        ],
                        [
                            16.27637,
                            46.96361
                        ],
                        [
                            16.11385,
                            46.86907
                        ],
                        [
                            16.24176,
                            46.87629
                        ],
                        [
                            16.3472,
                            46.84044
                        ],
                        [
                            16.31873,
                            46.75561
                        ],
                        [
                            16.42662,
                            46.69188
                        ],
                        [
                            16.4198,
                            46.65848
                        ],
                        [
                            16.52522,
                            46.50455
                        ],
                        [
                            16.59681,
                            46.4759
                        ],
                        [
                            16.66335,
                            46.45945
                        ],
                        [
                            16.71778,
                            46.39242
                        ],
                        [
                            16.80137,
                            46.38431
                        ],
                        [
                            16.87888,
                            46.33581
                        ],
                        [
                            16.88583,
                            46.28141
                        ],
                        [
                            16.97457,
                            46.22471
                        ],
                        [
                            17.12649,
                            46.16882
                        ],
                        [
                            17.23894,
                            46.07586
                        ],
                        [
                            17.25824,
                            46.01161
                        ],
                        [
                            17.44122,
                            45.95009
                        ],
                        [
                            17.57212,
                            45.93478
                        ],
                        [
                            17.67235,
                            45.83501
                        ],
                        [
                            17.90043,
                            45.79112
                        ],
                        [
                            17.99469,
                            45.79509
                        ],
                        [
                            18.07765,
                            45.76521
                        ],
                        [
                            18.1237,
                            45.78889
                        ],
                        [
                            18.40809,
                            45.73953
                        ],
                        [
                            18.5539,
                            45.79439
                        ],
                        [
                            18.70462,
                            45.91804
                        ],
                        [
                            18.7889,
                            45.87908
                        ],
                        [
                            18.88973,
                            45.92118
                        ],
                        [
                            18.98695,
                            45.93172
                        ],
                        [
                            19.10458,
                            46.03998
                        ],
                        [
                            19.14773,
                            45.9961
                        ],
                        [
                            19.28534,
                            45.99676
                        ],
                        [
                            19.36417,
                            46.05216
                        ],
                        [
                            19.41475,
                            46.04585
                        ],
                        [
                            19.50354,
                            46.14177
                        ],
                        [
                            19.56694,
                            46.17825
                        ],
                        [
                            19.6981,
                            46.18793
                        ],
                        [
                            19.81723,
                            46.12854
                        ],
                        [
                            19.93704,
                            46.17621
                        ],
                        [
                            20.06374,
                            46.14366
                        ],
                        [
                            20.18215,
                            46.15931
                        ],
                        [
                            20.2643,
                            46.12637
                        ],
                        [
                            20.35565,
                            46.1696
                        ],
                        [
                            20.45954,
                            46.14347
                        ],
                        [
                            20.50153,
                            46.18994
                        ],
                        [
                            20.63409,
                            46.12668
                        ],
                        [
                            20.71455,
                            46.16767
                        ],
                        [
                            20.74938,
                            46.25041
                        ],
                        [
                            20.87341,
                            46.28742
                        ],
                        [
                            20.92223,
                            46.26176
                        ],
                        [
                            21.02477,
                            46.26578
                        ],
                        [
                            21.17955,
                            46.3043
                        ],
                        [
                            21.20625,
                            46.40219
                        ],
                        [
                            21.31748,
                            46.45066
                        ],
                        [
                            21.26087,
                            46.50214
                        ],
                        [
                            21.32758,
                            46.63
                        ],
                        [
                            21.41641,
                            46.64183
                        ],
                        [
                            21.52865,
                            46.72052
                        ],
                        [
                            21.48348,
                            46.76464
                        ],
                        [
                            21.52112,
                            46.83742
                        ],
                        [
                            21.59505,
                            46.86093
                        ],
                        [
                            21.60604,
                            46.93235
                        ],
                        [
                            21.6686,
                            46.97093
                        ],
                        [
                            21.72614,
                            47.09861
                        ],
                        [
                            21.79284,
                            47.10724
                        ],
                        [
                            21.85196,
                            47.23892
                        ],
                        [
                            21.93933,
                            47.37281
                        ],
                        [
                            22.01212,
                            47.37672
                        ],
                        [
                            22.02297,
                            47.51781
                        ],
                        [
                            22.17131,
                            47.59184
                        ],
                        [
                            22.23321,
                            47.69366
                        ],
                        [
                            22.34778,
                            47.7523
                        ],
                        [
                            22.42646,
                            47.7523
                        ],
                        [
                            22.48143,
                            47.81091
                        ],
                        [
                            22.54954,
                            47.77266
                        ],
                        [
                            22.6825,
                            47.79033
                        ],
                        [
                            22.76039,
                            47.89483
                        ],
                        [
                            22.84747,
                            47.90884
                        ],
                        [
                            22.89627,
                            47.95412
                        ],
                        [
                            22.8379,
                            47.99208
                        ],
                        [
                            22.88098,
                            48.05407
                        ],
                        [
                            22.81951,
                            48.11843
                        ],
                        [
                            22.67421,
                            48.09195
                        ],
                        [
                            22.59113,
                            48.10807
                        ],
                        [
                            22.56947,
                            48.19575
                        ],
                        [
                            22.48811,
                            48.25317
                        ],
                        [
                            22.38398,
                            48.23561
                        ],
                        [
                            22.26562,
                            48.40873
                        ],
                        [
                            22.15531,
                            48.4034
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "ISL",
                "Country": "Iceland",
                "Total_3GHG": 0.01,
                "Total_3GHG_timeseries": [
                    4.2633e-07,
                    8.5026e-07,
                    1.2716e-06,
                    1.6904e-06,
                    2.1065e-06,
                    2.5198e-06,
                    2.9302e-06,
                    3.3375e-06,
                    3.7417e-06,
                    4.1266e-06,
                    4.4988e-06,
                    4.8611e-06,
                    5.2146e-06,
                    5.56e-06,
                    5.8978e-06,
                    6.2287e-06,
                    6.5528e-06,
                    6.8705e-06,
                    7.182e-06,
                    7.4886e-06,
                    7.7901e-06,
                    8.0871e-06,
                    8.3801e-06,
                    8.6694e-06,
                    8.9549e-06,
                    9.2369e-06,
                    9.5153e-06,
                    9.7901e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_3GHG": 0.01,
                "Fossil_3GHG_timeseries": [
                    3.9945e-09,
                    8.0693e-09,
                    1.2223e-08,
                    1.6453e-08,
                    2.0756e-08,
                    2.508e-08,
                    2.9421e-08,
                    3.3772e-08,
                    3.817e-08,
                    4.2609e-08,
                    4.703e-08,
                    5.1433e-08,
                    5.5814e-08,
                    6.0174e-08,
                    6.4506e-08,
                    6.8809e-08,
                    7.3083e-08,
                    7.7327e-08,
                    8.156e-08,
                    8.5783e-08,
                    8.9975e-08,
                    9.418e-08,
                    9.843e-08,
                    1.0275e-07,
                    1.0714e-07,
                    1.1166e-07,
                    1.163e-07,
                    1.2104e-07,
                    1.2582e-07,
                    1.306e-07,
                    1.3539e-07,
                    1.4018e-07,
                    1.4497e-07,
                    1.4975e-07,
                    1.5454e-07,
                    1.5932e-07,
                    1.641e-07,
                    1.6888e-07,
                    1.7364e-07,
                    1.7883e-07,
                    1.8414e-07,
                    1.8959e-07,
                    1.9517e-07,
                    2.009e-07,
                    2.0679e-07,
                    2.1285e-07,
                    2.191e-07,
                    2.2553e-07,
                    2.3216e-07,
                    2.3899e-07,
                    2.4607e-07,
                    2.5343e-07,
                    2.6107e-07,
                    2.6901e-07,
                    2.7725e-07,
                    2.8573e-07,
                    2.9459e-07,
                    3.0374e-07,
                    3.1315e-07,
                    3.2269e-07,
                    3.3255e-07,
                    3.4268e-07,
                    3.531e-07,
                    3.638e-07,
                    3.7479e-07,
                    3.8604e-07,
                    3.9757e-07,
                    4.0939e-07,
                    4.2151e-07,
                    4.3397e-07,
                    4.4665e-07,
                    4.5957e-07,
                    4.7278e-07,
                    4.8633e-07,
                    5.0018e-07,
                    5.1441e-07,
                    5.2886e-07,
                    5.4356e-07,
                    5.5849e-07,
                    5.7363e-07,
                    5.8875e-07,
                    6.0389e-07,
                    6.1906e-07,
                    6.3425e-07,
                    6.4947e-07,
                    6.7477e-07,
                    6.9842e-07,
                    7.1369e-07,
                    7.2897e-07,
                    9.3585e-07,
                    1.1409e-06,
                    1.3614e-06,
                    1.6018e-06,
                    1.838e-06,
                    2.0707e-06,
                    2.3448e-06,
                    2.6664e-06,
                    3.0506e-06,
                    3.4527e-06,
                    3.8665e-06,
                    4.2468e-06,
                    4.6983e-06,
                    5.2255e-06,
                    5.7043e-06,
                    6.2577e-06,
                    6.8431e-06,
                    7.452e-06,
                    8.1371e-06,
                    8.9076e-06,
                    9.6862e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_3GHG": 0.02,
                "Land_3GHG_timeseries": [
                    4.2233e-07,
                    8.4219e-07,
                    1.2594e-06,
                    1.674e-06,
                    2.0857e-06,
                    2.4947e-06,
                    2.9007e-06,
                    3.3037e-06,
                    3.7035e-06,
                    4.084e-06,
                    4.4518e-06,
                    4.8097e-06,
                    5.1588e-06,
                    5.4998e-06,
                    5.8333e-06,
                    6.1599e-06,
                    6.4798e-06,
                    6.7932e-06,
                    7.1004e-06,
                    7.4028e-06,
                    7.7001e-06,
                    7.9929e-06,
                    8.2817e-06,
                    8.5667e-06,
                    8.8478e-06,
                    9.1252e-06,
                    9.399e-06,
                    9.669e-06,
                    9.9349e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_CO2": 0.01,
                "Total_CO2_timeseries": [
                    3.7516e-07,
                    7.4721e-07,
                    1.116e-06,
                    1.4816e-06,
                    1.8437e-06,
                    2.2024e-06,
                    2.5577e-06,
                    2.9094e-06,
                    3.2575e-06,
                    3.5857e-06,
                    3.9026e-06,
                    4.2107e-06,
                    4.5112e-06,
                    4.8049e-06,
                    5.0924e-06,
                    5.3741e-06,
                    5.6503e-06,
                    5.9213e-06,
                    6.1874e-06,
                    6.4498e-06,
                    6.7084e-06,
                    6.9633e-06,
                    7.2147e-06,
                    7.4629e-06,
                    7.7075e-06,
                    7.9487e-06,
                    8.1867e-06,
                    8.4214e-06,
                    8.6527e-06,
                    8.8795e-06,
                    9.1023e-06,
                    9.3211e-06,
                    9.536e-06,
                    9.7468e-06,
                    9.9535e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_CO2": 0.01,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    9.9e-09,
                    1.815e-08,
                    1.815e-08,
                    1.815e-08,
                    2.0954e-07,
                    3.9518e-07,
                    5.9221e-07,
                    8.0477e-07,
                    1.0088e-06,
                    1.2035e-06,
                    1.4331e-06,
                    1.7032e-06,
                    2.0282e-06,
                    2.3627e-06,
                    2.696e-06,
                    2.9864e-06,
                    3.3362e-06,
                    3.7487e-06,
                    4.1002e-06,
                    4.511e-06,
                    4.9384e-06,
                    5.3723e-06,
                    5.864e-06,
                    6.4215e-06,
                    6.9675e-06,
                    7.4591e-06,
                    7.9985e-06,
                    8.5857e-06,
                    9.1745e-06,
                    9.803e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CO2": 0.02,
                "Land_CO2_timeseries": [
                    3.7516e-07,
                    7.4721e-07,
                    1.116e-06,
                    1.4816e-06,
                    1.8437e-06,
                    2.2024e-06,
                    2.5577e-06,
                    2.9094e-06,
                    3.2575e-06,
                    3.5857e-06,
                    3.9026e-06,
                    4.2107e-06,
                    4.5112e-06,
                    4.8049e-06,
                    5.0924e-06,
                    5.3741e-06,
                    5.6503e-06,
                    5.9213e-06,
                    6.1874e-06,
                    6.4498e-06,
                    6.7084e-06,
                    6.9633e-06,
                    7.2147e-06,
                    7.4629e-06,
                    7.7075e-06,
                    7.9487e-06,
                    8.1867e-06,
                    8.4214e-06,
                    8.6527e-06,
                    8.8795e-06,
                    9.1023e-06,
                    9.3211e-06,
                    9.536e-06,
                    9.7468e-06,
                    9.9535e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_CH4": 0.01,
                "Total_CH4_timeseries": [
                    3.691e-08,
                    7.4263e-08,
                    1.1206e-07,
                    1.503e-07,
                    1.8898e-07,
                    2.2806e-07,
                    2.6753e-07,
                    3.0738e-07,
                    3.4767e-07,
                    3.8838e-07,
                    4.2782e-07,
                    4.6598e-07,
                    5.0287e-07,
                    5.3848e-07,
                    5.728e-07,
                    6.0584e-07,
                    6.376e-07,
                    6.6807e-07,
                    6.9727e-07,
                    7.2521e-07,
                    7.5167e-07,
                    7.7666e-07,
                    8.0017e-07,
                    8.2221e-07,
                    8.4278e-07,
                    8.6191e-07,
                    8.7961e-07,
                    8.9587e-07,
                    9.1067e-07,
                    9.24e-07,
                    9.373e-07,
                    9.5058e-07,
                    9.6382e-07,
                    9.7704e-07,
                    9.9025e-07,
                    1.0034e-06,
                    1.0166e-06,
                    1.0297e-06,
                    1.0428e-06,
                    1.0559e-06,
                    1.0691e-06,
                    1.0822e-06,
                    1.0954e-06,
                    1.1085e-06,
                    1.1217e-06,
                    1.1349e-06,
                    1.1481e-06,
                    1.1613e-06,
                    1.1745e-06,
                    1.1878e-06,
                    1.2011e-06,
                    1.2144e-06,
                    1.2277e-06,
                    1.241e-06,
                    1.2543e-06,
                    1.2676e-06,
                    1.281e-06,
                    1.2943e-06,
                    1.3078e-06,
                    1.3211e-06,
                    1.3514e-06,
                    1.3987e-06,
                    1.4629e-06,
                    1.5442e-06,
                    1.6424e-06,
                    1.7575e-06,
                    1.8897e-06,
                    2.0388e-06,
                    2.2049e-06,
                    2.3881e-06,
                    2.5763e-06,
                    2.7696e-06,
                    2.9681e-06,
                    3.1717e-06,
                    3.3804e-06,
                    3.5943e-06,
                    3.8133e-06,
                    4.0374e-06,
                    4.2667e-06,
                    4.5011e-06,
                    4.7253e-06,
                    4.9393e-06,
                    5.143e-06,
                    5.3366e-06,
                    5.5199e-06,
                    5.6959e-06,
                    5.8646e-06,
                    6.0259e-06,
                    6.1799e-06,
                    6.327e-06,
                    6.4841e-06,
                    6.6513e-06,
                    6.8291e-06,
                    7.0175e-06,
                    7.2183e-06,
                    7.4321e-06,
                    7.6595e-06,
                    7.9013e-06,
                    8.1582e-06,
                    8.4349e-06,
                    8.7281e-06,
                    9.0421e-06,
                    9.3797e-06,
                    9.7413e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_CH4": 0.01,
                "Fossil_CH4_timeseries": [
                    8.5257e-10,
                    1.7393e-09,
                    2.6598e-09,
                    3.6137e-09,
                    4.6006e-09,
                    5.5698e-09,
                    6.5202e-09,
                    7.4508e-09,
                    8.401e-09,
                    9.3699e-09,
                    1.0302e-08,
                    1.1197e-08,
                    1.2053e-08,
                    1.287e-08,
                    1.3641e-08,
                    1.4366e-08,
                    1.5044e-08,
                    1.5674e-08,
                    1.6275e-08,
                    1.6846e-08,
                    1.7343e-08,
                    1.7763e-08,
                    1.8108e-08,
                    1.8376e-08,
                    1.8564e-08,
                    1.8717e-08,
                    1.8836e-08,
                    1.8922e-08,
                    1.8936e-08,
                    1.8878e-08,
                    1.8778e-08,
                    1.8637e-08,
                    1.8456e-08,
                    1.8236e-08,
                    1.7983e-08,
                    1.7692e-08,
                    1.7364e-08,
                    1.7001e-08,
                    1.6587e-08,
                    1.6195e-08,
                    1.5794e-08,
                    1.5387e-08,
                    1.4971e-08,
                    1.4549e-08,
                    1.4125e-08,
                    1.3705e-08,
                    1.3288e-08,
                    1.2876e-08,
                    1.2471e-08,
                    1.2071e-08,
                    1.1702e-08,
                    1.1364e-08,
                    1.1055e-08,
                    1.0751e-08,
                    1.0476e-08,
                    1.0152e-08,
                    9.9447e-09,
                    9.7694e-09,
                    9.6301e-09,
                    9.4275e-09,
                    9.3866e-09,
                    9.481e-09,
                    9.7262e-09,
                    1.0135e-08,
                    1.0707e-08,
                    1.1439e-08,
                    1.2324e-08,
                    1.3379e-08,
                    1.4586e-08,
                    1.5989e-08,
                    1.7434e-08,
                    1.8893e-08,
                    2.0401e-08,
                    2.1981e-08,
                    2.3605e-08,
                    2.5361e-08,
                    2.7097e-08,
                    2.8887e-08,
                    3.0745e-08,
                    3.2703e-08,
                    3.4566e-08,
                    3.6359e-08,
                    3.8069e-08,
                    3.9698e-08,
                    4.1229e-08,
                    4.2835e-08,
                    4.4326e-08,
                    4.5578e-08,
                    4.6746e-08,
                    4.8032e-08,
                    5.321e-08,
                    6.2337e-08,
                    7.5816e-08,
                    9.3652e-08,
                    1.1734e-07,
                    1.4745e-07,
                    1.8455e-07,
                    2.293e-07,
                    2.823e-07,
                    3.4811e-07,
                    4.2315e-07,
                    5.0963e-07,
                    6.0865e-07,
                    7.1976e-07,
                    8.4552e-07,
                    9.8624e-07,
                    1.1431e-06,
                    1.3178e-06,
                    1.5114e-06,
                    1.7239e-06,
                    1.9536e-06,
                    2.2012e-06,
                    2.4678e-06,
                    2.7541e-06,
                    3.0602e-06,
                    3.3859e-06,
                    3.7312e-06,
                    4.0964e-06,
                    4.4813e-06,
                    4.8314e-06,
                    5.1975e-06,
                    5.557e-06,
                    5.9115e-06,
                    6.2526e-06,
                    6.5817e-06,
                    6.8969e-06,
                    7.1975e-06,
                    7.4839e-06,
                    7.7542e-06,
                    8.0058e-06,
                    8.2382e-06,
                    8.4472e-06,
                    8.6356e-06,
                    8.805e-06,
                    8.9507e-06,
                    9.0731e-06,
                    9.1725e-06,
                    9.2485e-06,
                    9.2988e-06,
                    9.3565e-06,
                    9.3861e-06,
                    9.4197e-06,
                    9.4724e-06,
                    9.5504e-06,
                    9.6478e-06,
                    9.7576e-06,
                    9.872e-06,
                    9.9967e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CH4": 0.01,
                "Land_CH4_timeseries": [
                    3.6057e-08,
                    7.2524e-08,
                    1.094e-07,
                    1.4669e-07,
                    1.8438e-07,
                    2.2249e-07,
                    2.61e-07,
                    2.9993e-07,
                    3.3927e-07,
                    3.7901e-07,
                    4.1752e-07,
                    4.5479e-07,
                    4.9082e-07,
                    5.2561e-07,
                    5.5916e-07,
                    5.9148e-07,
                    6.2256e-07,
                    6.524e-07,
                    6.81e-07,
                    7.0836e-07,
                    7.3433e-07,
                    7.5889e-07,
                    7.8206e-07,
                    8.0384e-07,
                    8.2421e-07,
                    8.4319e-07,
                    8.6077e-07,
                    8.7695e-07,
                    8.9174e-07,
                    9.0512e-07,
                    9.1852e-07,
                    9.3194e-07,
                    9.4537e-07,
                    9.5881e-07,
                    9.7226e-07,
                    9.8573e-07,
                    9.9921e-07,
                    1.0127e-06,
                    1.0262e-06,
                    1.0397e-06,
                    1.0533e-06,
                    1.0668e-06,
                    1.0804e-06,
                    1.094e-06,
                    1.1076e-06,
                    1.1212e-06,
                    1.1348e-06,
                    1.1484e-06,
                    1.1621e-06,
                    1.1757e-06,
                    1.1894e-06,
                    1.203e-06,
                    1.2166e-06,
                    1.2302e-06,
                    1.2438e-06,
                    1.2574e-06,
                    1.271e-06,
                    1.2846e-06,
                    1.2981e-06,
                    1.3117e-06,
                    1.342e-06,
                    1.3892e-06,
                    1.4532e-06,
                    1.534e-06,
                    1.6317e-06,
                    1.7461e-06,
                    1.8774e-06,
                    2.0255e-06,
                    2.1904e-06,
                    2.3721e-06,
                    2.5589e-06,
                    2.7507e-06,
                    2.9477e-06,
                    3.1497e-06,
                    3.3568e-06,
                    3.569e-06,
                    3.7862e-06,
                    4.0085e-06,
                    4.2359e-06,
                    4.4684e-06,
                    4.6907e-06,
                    4.9029e-06,
                    5.105e-06,
                    5.2969e-06,
                    5.4787e-06,
                    5.6531e-06,
                    5.8203e-06,
                    5.9803e-06,
                    6.1332e-06,
                    6.279e-06,
                    6.4309e-06,
                    6.5889e-06,
                    6.7532e-06,
                    6.9239e-06,
                    7.101e-06,
                    7.2846e-06,
                    7.4749e-06,
                    7.672e-06,
                    7.8759e-06,
                    8.0868e-06,
                    8.305e-06,
                    8.5325e-06,
                    8.771e-06,
                    9.0216e-06,
                    9.285e-06,
                    9.559e-06,
                    9.844e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_N2O": 0.02,
                "Total_N2O_timeseries": [
                    1.4257e-08,
                    2.8782e-08,
                    4.3565e-08,
                    5.8591e-08,
                    7.384e-08,
                    8.9289e-08,
                    1.0491e-07,
                    1.2067e-07,
                    1.3654e-07,
                    1.5248e-07,
                    1.6845e-07,
                    1.8446e-07,
                    2.005e-07,
                    2.1656e-07,
                    2.3265e-07,
                    2.4877e-07,
                    2.6491e-07,
                    2.8108e-07,
                    2.9729e-07,
                    3.1354e-07,
                    3.3004e-07,
                    3.4717e-07,
                    3.652e-07,
                    3.8433e-07,
                    4.0466e-07,
                    4.2623e-07,
                    4.4898e-07,
                    4.7276e-07,
                    4.9736e-07,
                    5.2245e-07,
                    5.4783e-07,
                    5.7346e-07,
                    5.9929e-07,
                    6.2531e-07,
                    6.5149e-07,
                    6.7783e-07,
                    7.0432e-07,
                    7.3098e-07,
                    7.5782e-07,
                    7.8249e-07,
                    8.0995e-07,
                    8.4006e-07,
                    8.7261e-07,
                    9.074e-07,
                    9.4419e-07,
                    9.8271e-07,
                    1.0227e-06,
                    1.0637e-06,
                    1.1056e-06,
                    1.1478e-06,
                    1.1901e-06,
                    1.232e-06,
                    1.2734e-06,
                    1.3142e-06,
                    1.3541e-06,
                    1.3933e-06,
                    1.4318e-06,
                    1.4697e-06,
                    1.5073e-06,
                    1.5449e-06,
                    1.5827e-06,
                    1.6207e-06,
                    1.6589e-06,
                    1.6974e-06,
                    1.7361e-06,
                    1.7752e-06,
                    1.8145e-06,
                    1.8542e-06,
                    1.8943e-06,
                    1.9347e-06,
                    1.9756e-06,
                    2.0171e-06,
                    2.0593e-06,
                    2.1023e-06,
                    2.1461e-06,
                    2.1908e-06,
                    2.2363e-06,
                    2.2826e-06,
                    2.3297e-06,
                    2.3774e-06,
                    2.4258e-06,
                    2.475e-06,
                    2.5251e-06,
                    2.5759e-06,
                    2.6277e-06,
                    2.6802e-06,
                    2.7334e-06,
                    2.7872e-06,
                    2.8414e-06,
                    2.8958e-06,
                    2.9525e-06,
                    3.0156e-06,
                    3.088e-06,
                    3.1718e-06,
                    3.2679e-06,
                    3.3765e-06,
                    3.4967e-06,
                    3.6266e-06,
                    3.7635e-06,
                    3.9034e-06,
                    4.0444e-06,
                    4.1865e-06,
                    4.3299e-06,
                    4.4747e-06,
                    4.6211e-06,
                    4.7692e-06,
                    4.919e-06,
                    5.0707e-06,
                    5.2242e-06,
                    5.3797e-06,
                    5.541e-06,
                    5.7077e-06,
                    5.8745e-06,
                    6.0418e-06,
                    6.2114e-06,
                    6.3869e-06,
                    6.5643e-06,
                    6.7425e-06,
                    6.9202e-06,
                    7.0937e-06,
                    7.2691e-06,
                    7.4528e-06,
                    7.6439e-06,
                    7.8389e-06,
                    8.0397e-06,
                    8.239e-06,
                    8.4413e-06,
                    8.6495e-06,
                    8.8551e-06,
                    9.0498e-06,
                    9.2483e-06,
                    9.4398e-06,
                    9.6323e-06,
                    9.8256e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_N2O": 0.01,
                "Fossil_N2O_timeseries": [
                    3.142e-09,
                    6.3301e-09,
                    9.563e-09,
                    1.2839e-08,
                    1.6156e-08,
                    1.9511e-08,
                    2.29e-08,
                    2.6321e-08,
                    2.9769e-08,
                    3.3239e-08,
                    3.6728e-08,
                    4.0236e-08,
                    4.3761e-08,
                    4.7304e-08,
                    5.0865e-08,
                    5.4443e-08,
                    5.8039e-08,
                    6.1652e-08,
                    6.5285e-08,
                    6.8936e-08,
                    7.2633e-08,
                    7.6417e-08,
                    8.0322e-08,
                    8.4371e-08,
                    8.8577e-08,
                    9.2943e-08,
                    9.7462e-08,
                    1.0212e-07,
                    1.0688e-07,
                    1.1172e-07,
                    1.1661e-07,
                    1.2154e-07,
                    1.2651e-07,
                    1.3152e-07,
                    1.3656e-07,
                    1.4163e-07,
                    1.4674e-07,
                    1.5188e-07,
                    1.5705e-07,
                    1.6264e-07,
                    1.6835e-07,
                    1.742e-07,
                    1.802e-07,
                    1.8635e-07,
                    1.9266e-07,
                    1.9915e-07,
                    2.0581e-07,
                    2.1266e-07,
                    2.1969e-07,
                    2.2692e-07,
                    2.3437e-07,
                    2.4206e-07,
                    2.5002e-07,
                    2.5825e-07,
                    2.6677e-07,
                    2.7558e-07,
                    2.8465e-07,
                    2.9397e-07,
                    3.0352e-07,
                    3.1326e-07,
                    3.2316e-07,
                    3.332e-07,
                    3.4337e-07,
                    3.5367e-07,
                    3.6408e-07,
                    3.746e-07,
                    3.8525e-07,
                    3.9601e-07,
                    4.0692e-07,
                    4.1798e-07,
                    4.2922e-07,
                    4.4068e-07,
                    4.5238e-07,
                    4.6435e-07,
                    4.7657e-07,
                    4.8905e-07,
                    5.0176e-07,
                    5.1468e-07,
                    5.2775e-07,
                    5.4092e-07,
                    5.5418e-07,
                    5.6753e-07,
                    5.8099e-07,
                    5.9456e-07,
                    6.0824e-07,
                    6.2204e-07,
                    6.3595e-07,
                    6.4996e-07,
                    6.6408e-07,
                    6.7828e-07,
                    6.9254e-07,
                    7.0685e-07,
                    7.2118e-07,
                    7.3552e-07,
                    7.4988e-07,
                    7.6426e-07,
                    7.7868e-07,
                    7.9315e-07,
                    8.0771e-07,
                    8.2239e-07,
                    8.3728e-07,
                    8.525e-07,
                    8.6816e-07,
                    8.8434e-07,
                    9.0111e-07,
                    9.1852e-07,
                    9.3659e-07,
                    9.5532e-07,
                    9.7472e-07,
                    9.9474e-07,
                    1.0154e-06,
                    1.0369e-06,
                    1.0592e-06,
                    1.0823e-06,
                    1.1063e-06,
                    1.1311e-06,
                    1.1567e-06,
                    1.183e-06,
                    1.2098e-06,
                    1.2335e-06,
                    1.2576e-06,
                    1.2852e-06,
                    1.3156e-06,
                    1.3497e-06,
                    1.386e-06,
                    1.4214e-06,
                    1.4587e-06,
                    1.4984e-06,
                    1.5358e-06,
                    1.57e-06,
                    1.605e-06,
                    1.6376e-06,
                    1.6709e-06,
                    1.7067e-06,
                    1.7462e-06,
                    1.7874e-06,
                    1.8318e-06,
                    1.877e-06,
                    1.9218e-06,
                    1.9434e-06,
                    1.9639e-06,
                    1.9853e-06,
                    2.0069e-06,
                    2.029e-06,
                    2.0489e-06,
                    2.0704e-06,
                    2.0884e-06,
                    2.1056e-06,
                    2.1239e-06,
                    2.1445e-06,
                    2.166e-06,
                    2.1873e-06,
                    2.2086e-06,
                    2.2303e-06,
                    2.2515e-06,
                    2.2747e-06,
                    2.2967e-06,
                    2.3196e-06,
                    2.3412e-06,
                    2.3624e-06,
                    2.3829e-06,
                    2.4029e-06,
                    2.4239e-06,
                    2.445e-06,
                    2.4665e-06,
                    2.4876e-06,
                    2.5091e-06,
                    2.5307e-06,
                    2.5521e-06,
                    2.5717e-06,
                    2.5913e-06,
                    2.6149e-06
                ],
                "Land_N2O": 0.02,
                "Land_N2O_timeseries": [
                    1.1115e-08,
                    2.2452e-08,
                    3.4002e-08,
                    4.5752e-08,
                    5.7684e-08,
                    6.9778e-08,
                    8.201e-08,
                    9.4352e-08,
                    1.0677e-07,
                    1.1924e-07,
                    1.3172e-07,
                    1.4422e-07,
                    1.5674e-07,
                    1.6926e-07,
                    1.8179e-07,
                    1.9432e-07,
                    2.0687e-07,
                    2.1943e-07,
                    2.32e-07,
                    2.446e-07,
                    2.5741e-07,
                    2.7075e-07,
                    2.8488e-07,
                    2.9995e-07,
                    3.1608e-07,
                    3.3329e-07,
                    3.5152e-07,
                    3.7065e-07,
                    3.9047e-07,
                    4.1073e-07,
                    4.3122e-07,
                    4.5191e-07,
                    4.7278e-07,
                    4.9379e-07,
                    5.1493e-07,
                    5.362e-07,
                    5.5758e-07,
                    5.791e-07,
                    6.0077e-07,
                    6.1985e-07,
                    6.416e-07,
                    6.6586e-07,
                    6.9241e-07,
                    7.2105e-07,
                    7.5153e-07,
                    7.8356e-07,
                    8.1686e-07,
                    8.5108e-07,
                    8.8589e-07,
                    9.2089e-07,
                    9.557e-07,
                    9.8996e-07,
                    1.0234e-06,
                    1.0559e-06,
                    1.0873e-06,
                    1.1177e-06,
                    1.1471e-06,
                    1.1757e-06,
                    1.2038e-06,
                    1.2317e-06,
                    1.2595e-06,
                    1.2875e-06,
                    1.3155e-06,
                    1.3437e-06,
                    1.372e-06,
                    1.4006e-06,
                    1.4293e-06,
                    1.4582e-06,
                    1.4873e-06,
                    1.5167e-06,
                    1.5464e-06,
                    1.5764e-06,
                    1.6069e-06,
                    1.638e-06,
                    1.6695e-06,
                    1.7017e-06,
                    1.7345e-06,
                    1.7679e-06,
                    1.8019e-06,
                    1.8365e-06,
                    1.8717e-06,
                    1.9075e-06,
                    1.9441e-06,
                    1.9814e-06,
                    2.0194e-06,
                    2.0582e-06,
                    2.0975e-06,
                    2.1372e-06,
                    2.1773e-06,
                    2.2175e-06,
                    2.26e-06,
                    2.3088e-06,
                    2.3669e-06,
                    2.4363e-06,
                    2.518e-06,
                    2.6123e-06,
                    2.718e-06,
                    2.8335e-06,
                    2.9558e-06,
                    3.081e-06,
                    3.2071e-06,
                    3.334e-06,
                    3.4617e-06,
                    3.5904e-06,
                    3.72e-06,
                    3.8507e-06,
                    3.9824e-06,
                    4.1154e-06,
                    4.2495e-06,
                    4.385e-06,
                    4.5256e-06,
                    4.6708e-06,
                    4.8153e-06,
                    4.9595e-06,
                    5.1052e-06,
                    5.2558e-06,
                    5.4077e-06,
                    5.5596e-06,
                    5.7104e-06,
                    5.8603e-06,
                    6.0115e-06,
                    6.1676e-06,
                    6.3283e-06,
                    6.4891e-06,
                    6.6537e-06,
                    6.8175e-06,
                    6.9826e-06,
                    7.1511e-06,
                    7.3193e-06,
                    7.4799e-06,
                    7.6432e-06,
                    7.8022e-06,
                    7.9614e-06,
                    8.1189e-06,
                    8.2752e-06,
                    8.4294e-06,
                    8.5775e-06,
                    8.7256e-06,
                    8.8742e-06,
                    9.0243e-06,
                    9.1724e-06,
                    9.3157e-06,
                    9.4615e-06,
                    9.6055e-06,
                    9.7451e-06,
                    9.8893e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -16.01684,
                            66.53358
                        ],
                        [
                            -16.20455,
                            66.52967
                        ],
                        [
                            -16.33232,
                            66.4873
                        ],
                        [
                            -16.43887,
                            66.51708
                        ],
                        [
                            -16.56869,
                            66.48064
                        ],
                        [
                            -16.5001,
                            66.41819
                        ],
                        [
                            -16.5068,
                            66.35376
                        ],
                        [
                            -16.41766,
                            66.27692
                        ],
                        [
                            -16.49758,
                            66.19725
                        ],
                        [
                            -16.81097,
                            66.12868
                        ],
                        [
                            -16.94743,
                            66.12719
                        ],
                        [
                            -17.03457,
                            66.20527
                        ],
                        [
                            -17.22446,
                            66.18893
                        ],
                        [
                            -17.4136,
                            65.99235
                        ],
                        [
                            -17.63653,
                            65.98885
                        ],
                        [
                            -17.72677,
                            66.06488
                        ],
                        [
                            -17.93438,
                            66.14768
                        ],
                        [
                            -18.26964,
                            66.17419
                        ],
                        [
                            -18.32313,
                            66.12066
                        ],
                        [
                            -18.2809,
                            66.02015
                        ],
                        [
                            -18.08586,
                            65.87912
                        ],
                        [
                            -18.05356,
                            65.8178
                        ],
                        [
                            -18.19133,
                            65.79955
                        ],
                        [
                            -18.32606,
                            65.94402
                        ],
                        [
                            -18.52829,
                            65.98026
                        ],
                        [
                            -18.5283,
                            66.06911
                        ],
                        [
                            -18.68105,
                            66.16193
                        ],
                        [
                            -18.78552,
                            66.19339
                        ],
                        [
                            -19.05364,
                            66.15662
                        ],
                        [
                            -19.09499,
                            66.09368
                        ],
                        [
                            -19.35599,
                            66.07793
                        ],
                        [
                            -19.49663,
                            65.97201
                        ],
                        [
                            -19.36298,
                            65.83685
                        ],
                        [
                            -19.40203,
                            65.75401
                        ],
                        [
                            -19.62351,
                            65.74478
                        ],
                        [
                            -19.7077,
                            65.86314
                        ],
                        [
                            -19.91906,
                            65.94549
                        ],
                        [
                            -20.03592,
                            66.08118
                        ],
                        [
                            -20.16929,
                            66.12472
                        ],
                        [
                            -20.3083,
                            66.1049
                        ],
                        [
                            -20.43131,
                            66.01874
                        ],
                        [
                            -20.31015,
                            65.86277
                        ],
                        [
                            -20.26404,
                            65.72535
                        ],
                        [
                            -20.32546,
                            65.62486
                        ],
                        [
                            -20.50623,
                            65.59481
                        ],
                        [
                            -20.63567,
                            65.60342
                        ],
                        [
                            -20.67236,
                            65.68653
                        ],
                        [
                            -20.93348,
                            65.58005
                        ],
                        [
                            -20.98969,
                            65.47565
                        ],
                        [
                            -20.91319,
                            65.3576
                        ],
                        [
                            -21.19648,
                            65.30848
                        ],
                        [
                            -21.19793,
                            65.42642
                        ],
                        [
                            -21.30933,
                            65.5237
                        ],
                        [
                            -21.2982,
                            65.59413
                        ],
                        [
                            -21.4021,
                            65.631
                        ],
                        [
                            -21.6382,
                            65.64582
                        ],
                        [
                            -21.6639,
                            65.70769
                        ],
                        [
                            -21.43533,
                            65.68997
                        ],
                        [
                            -21.40453,
                            65.7658
                        ],
                        [
                            -21.27978,
                            65.8578
                        ],
                        [
                            -21.32914,
                            66.00566
                        ],
                        [
                            -21.50017,
                            66.01283
                        ],
                        [
                            -21.55091,
                            66.08758
                        ],
                        [
                            -21.7261,
                            66.06233
                        ],
                        [
                            -21.74627,
                            66.18087
                        ],
                        [
                            -21.86776,
                            66.18965
                        ],
                        [
                            -21.96434,
                            66.2696
                        ],
                        [
                            -22.0586,
                            66.25393
                        ],
                        [
                            -22.23373,
                            66.31283
                        ],
                        [
                            -22.23959,
                            66.35625
                        ],
                        [
                            -22.57572,
                            66.46492
                        ],
                        [
                            -22.65871,
                            66.41822
                        ],
                        [
                            -22.84067,
                            66.45984
                        ],
                        [
                            -23.13457,
                            66.42854
                        ],
                        [
                            -22.96441,
                            66.2968
                        ],
                        [
                            -22.67254,
                            66.33056
                        ],
                        [
                            -22.60063,
                            66.24002
                        ],
                        [
                            -22.81554,
                            66.26128
                        ],
                        [
                            -22.96151,
                            66.23401
                        ],
                        [
                            -22.8378,
                            66.14948
                        ],
                        [
                            -22.44057,
                            66.06993
                        ],
                        [
                            -22.39839,
                            65.98493
                        ],
                        [
                            -22.44453,
                            65.93488
                        ],
                        [
                            -22.57948,
                            65.94732
                        ],
                        [
                            -22.62281,
                            66.01309
                        ],
                        [
                            -22.78927,
                            66.00276
                        ],
                        [
                            -22.98895,
                            66.01982
                        ],
                        [
                            -22.99256,
                            66.08065
                        ],
                        [
                            -23.1086,
                            66.09966
                        ],
                        [
                            -23.26903,
                            66.17651
                        ],
                        [
                            -23.46854,
                            66.1969
                        ],
                        [
                            -23.60009,
                            66.15215
                        ],
                        [
                            -23.64478,
                            66.09967
                        ],
                        [
                            -23.81868,
                            66.03485
                        ],
                        [
                            -23.63681,
                            65.89502
                        ],
                        [
                            -23.78739,
                            65.92178
                        ],
                        [
                            -23.86807,
                            65.88674
                        ],
                        [
                            -23.73351,
                            65.78811
                        ],
                        [
                            -23.59963,
                            65.76338
                        ],
                        [
                            -23.60481,
                            65.69743
                        ],
                        [
                            -24.07871,
                            65.80656
                        ],
                        [
                            -24.06074,
                            65.69811
                        ],
                        [
                            -24.10692,
                            65.57979
                        ],
                        [
                            -24.30055,
                            65.6396
                        ],
                        [
                            -24.47208,
                            65.48919
                        ],
                        [
                            -24.17778,
                            65.49927
                        ],
                        [
                            -23.94961,
                            65.46667
                        ],
                        [
                            -23.94824,
                            65.41591
                        ],
                        [
                            -23.72858,
                            65.4169
                        ],
                        [
                            -23.63659,
                            65.46536
                        ],
                        [
                            -23.35535,
                            65.49349
                        ],
                        [
                            -23.24449,
                            65.48471
                        ],
                        [
                            -23.1968,
                            65.54988
                        ],
                        [
                            -22.86663,
                            65.53712
                        ],
                        [
                            -22.71169,
                            65.50313
                        ],
                        [
                            -22.47823,
                            65.55892
                        ],
                        [
                            -22.45042,
                            65.50702
                        ],
                        [
                            -22.27899,
                            65.44218
                        ],
                        [
                            -22.1882,
                            65.43524
                        ],
                        [
                            -22.109,
                            65.49848
                        ],
                        [
                            -21.98102,
                            65.50273
                        ],
                        [
                            -21.89977,
                            65.41991
                        ],
                        [
                            -22.17491,
                            65.31989
                        ],
                        [
                            -22.3362,
                            65.29563
                        ],
                        [
                            -22.50626,
                            65.20947
                        ],
                        [
                            -22.5321,
                            65.16001
                        ],
                        [
                            -22.24403,
                            65.12495
                        ],
                        [
                            -22.01286,
                            65.11231
                        ],
                        [
                            -21.85555,
                            65.15869
                        ],
                        [
                            -21.71093,
                            65.15861
                        ],
                        [
                            -21.82402,
                            65.0656
                        ],
                        [
                            -21.81134,
                            65.02606
                        ],
                        [
                            -22.12572,
                            65.02713
                        ],
                        [
                            -22.32796,
                            65.0627
                        ],
                        [
                            -22.52915,
                            65.05079
                        ],
                        [
                            -22.67043,
                            65.0027
                        ],
                        [
                            -22.72332,
                            65.07805
                        ],
                        [
                            -22.84058,
                            65.00442
                        ],
                        [
                            -23.18694,
                            65.01086
                        ],
                        [
                            -23.20972,
                            64.92875
                        ],
                        [
                            -23.35477,
                            64.97138
                        ],
                        [
                            -23.47735,
                            64.95197
                        ],
                        [
                            -23.64148,
                            64.88961
                        ],
                        [
                            -23.8397,
                            64.92636
                        ],
                        [
                            -23.98704,
                            64.88179
                        ],
                        [
                            -24.00881,
                            64.82678
                        ],
                        [
                            -23.90295,
                            64.75152
                        ],
                        [
                            -23.66053,
                            64.73909
                        ],
                        [
                            -23.5936,
                            64.80075
                        ],
                        [
                            -23.43511,
                            64.79122
                        ],
                        [
                            -23.26358,
                            64.82619
                        ],
                        [
                            -23.02608,
                            64.79653
                        ],
                        [
                            -22.58606,
                            64.7821
                        ],
                        [
                            -22.52511,
                            64.80645
                        ],
                        [
                            -22.31245,
                            64.75381
                        ],
                        [
                            -22.37832,
                            64.69843
                        ],
                        [
                            -22.34585,
                            64.56582
                        ],
                        [
                            -22.2199,
                            64.54832
                        ],
                        [
                            -22.18133,
                            64.47192
                        ],
                        [
                            -22.04573,
                            64.52745
                        ],
                        [
                            -21.96926,
                            64.49378
                        ],
                        [
                            -22.03588,
                            64.40368
                        ],
                        [
                            -21.90597,
                            64.30793
                        ],
                        [
                            -21.63937,
                            64.40282
                        ],
                        [
                            -21.58351,
                            64.37586
                        ],
                        [
                            -21.83459,
                            64.28932
                        ],
                        [
                            -21.8409,
                            64.23891
                        ],
                        [
                            -21.76553,
                            64.15761
                        ],
                        [
                            -21.96609,
                            64.14021
                        ],
                        [
                            -21.92664,
                            64.09634
                        ],
                        [
                            -22.01499,
                            64.04987
                        ],
                        [
                            -22.18399,
                            64.01421
                        ],
                        [
                            -22.27007,
                            64.02822
                        ],
                        [
                            -22.51373,
                            63.98137
                        ],
                        [
                            -22.64649,
                            64.07578
                        ],
                        [
                            -22.70915,
                            64.06163
                        ],
                        [
                            -22.73731,
                            63.8188
                        ],
                        [
                            -22.55205,
                            63.81011
                        ],
                        [
                            -22.34861,
                            63.85482
                        ],
                        [
                            -22.23246,
                            63.83406
                        ],
                        [
                            -21.91478,
                            63.83774
                        ],
                        [
                            -21.73568,
                            63.8587
                        ],
                        [
                            -21.65024,
                            63.82114
                        ],
                        [
                            -21.19678,
                            63.87435
                        ],
                        [
                            -20.9478,
                            63.81907
                        ],
                        [
                            -20.68073,
                            63.73659
                        ],
                        [
                            -20.18001,
                            63.5348
                        ],
                        [
                            -19.92009,
                            63.53682
                        ],
                        [
                            -19.67614,
                            63.51428
                        ],
                        [
                            -19.12656,
                            63.40035
                        ],
                        [
                            -19.01743,
                            63.41338
                        ],
                        [
                            -18.74331,
                            63.39459
                        ],
                        [
                            -18.1774,
                            63.45889
                        ],
                        [
                            -17.9114,
                            63.54533
                        ],
                        [
                            -17.7894,
                            63.66551
                        ],
                        [
                            -17.54692,
                            63.74451
                        ],
                        [
                            -17.32574,
                            63.77482
                        ],
                        [
                            -17.04178,
                            63.77741
                        ],
                        [
                            -16.64444,
                            63.79976
                        ],
                        [
                            -16.53794,
                            63.8732
                        ],
                        [
                            -16.27776,
                            64.00532
                        ],
                        [
                            -15.99359,
                            64.12193
                        ],
                        [
                            -15.66132,
                            64.20659
                        ],
                        [
                            -15.39909,
                            64.24349
                        ],
                        [
                            -15.35909,
                            64.28974
                        ],
                        [
                            -15.04045,
                            64.27611
                        ],
                        [
                            -14.904,
                            64.32311
                        ],
                        [
                            -14.69295,
                            64.42594
                        ],
                        [
                            -14.54216,
                            64.405
                        ],
                        [
                            -14.46884,
                            64.49808
                        ],
                        [
                            -14.58432,
                            64.57585
                        ],
                        [
                            -14.40804,
                            64.60088
                        ],
                        [
                            -14.40109,
                            64.65822
                        ],
                        [
                            -14.08133,
                            64.70189
                        ],
                        [
                            -14.07142,
                            64.77804
                        ],
                        [
                            -13.83588,
                            64.80578
                        ],
                        [
                            -13.76211,
                            64.85637
                        ],
                        [
                            -13.78101,
                            64.98752
                        ],
                        [
                            -13.60862,
                            64.99699
                        ],
                        [
                            -13.50259,
                            65.08236
                        ],
                        [
                            -13.6734,
                            65.10687
                        ],
                        [
                            -13.64907,
                            65.21864
                        ],
                        [
                            -13.57863,
                            65.26972
                        ],
                        [
                            -13.76859,
                            65.30852
                        ],
                        [
                            -13.65149,
                            65.3868
                        ],
                        [
                            -13.60846,
                            65.51107
                        ],
                        [
                            -13.6761,
                            65.55052
                        ],
                        [
                            -14.15082,
                            65.62938
                        ],
                        [
                            -14.35916,
                            65.70049
                        ],
                        [
                            -14.33302,
                            65.78907
                        ],
                        [
                            -14.69824,
                            65.74936
                        ],
                        [
                            -14.85003,
                            65.77272
                        ],
                        [
                            -14.79229,
                            65.83688
                        ],
                        [
                            -14.61919,
                            65.92238
                        ],
                        [
                            -14.61485,
                            65.99192
                        ],
                        [
                            -14.7308,
                            66.05717
                        ],
                        [
                            -14.83051,
                            66.01627
                        ],
                        [
                            -14.99152,
                            66.03319
                        ],
                        [
                            -15.1514,
                            66.09104
                        ],
                        [
                            -15.14858,
                            66.13176
                        ],
                        [
                            -14.94256,
                            66.18523
                        ],
                        [
                            -14.96644,
                            66.28247
                        ],
                        [
                            -14.67609,
                            66.3478
                        ],
                        [
                            -14.85787,
                            66.38609
                        ],
                        [
                            -14.99949,
                            66.34898
                        ],
                        [
                            -15.11682,
                            66.26978
                        ],
                        [
                            -15.33592,
                            66.25714
                        ],
                        [
                            -15.33186,
                            66.18232
                        ],
                        [
                            -15.42977,
                            66.16203
                        ],
                        [
                            -15.53348,
                            66.21543
                        ],
                        [
                            -15.69038,
                            66.22389
                        ],
                        [
                            -15.75876,
                            66.28323
                        ],
                        [
                            -15.67914,
                            66.34476
                        ],
                        [
                            -15.70732,
                            66.39755
                        ],
                        [
                            -15.93434,
                            66.41851
                        ],
                        [
                            -16.01684,
                            66.53358
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "IND",
                "Country": "India",
                "Total_3GHG": 4.78,
                "Total_3GHG_timeseries": [
                    0.0001,
                    0.0002,
                    0.0003,
                    0.0004,
                    0.0005,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0048,
                    0.0049,
                    0.005,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0056,
                    0.0057,
                    0.0058,
                    0.0059,
                    0.006,
                    0.0061,
                    0.0062,
                    0.0063,
                    0.0064,
                    0.0065,
                    0.0066,
                    0.0067,
                    0.0068,
                    0.0069,
                    0.007,
                    0.0071,
                    0.0072,
                    0.0073,
                    0.0074,
                    0.0076,
                    0.0077,
                    0.0079,
                    0.0081,
                    0.0083,
                    0.0085,
                    0.0087,
                    0.0089,
                    0.0091,
                    0.0094,
                    0.0096,
                    0.0099,
                    0.0101,
                    0.0104,
                    0.0107,
                    0.011,
                    0.0113,
                    0.0116,
                    0.0119,
                    0.0123,
                    0.0126,
                    0.013,
                    0.0133,
                    0.0137,
                    0.0141,
                    0.0145,
                    0.0148,
                    0.0152,
                    0.0156,
                    0.016,
                    0.0165,
                    0.0169,
                    0.0174,
                    0.0179,
                    0.0184,
                    0.0189,
                    0.0195,
                    0.02,
                    0.0206,
                    0.0211,
                    0.0217,
                    0.0222,
                    0.0228,
                    0.0233,
                    0.0238,
                    0.0243,
                    0.0248,
                    0.0254,
                    0.0259,
                    0.0265,
                    0.027,
                    0.0276,
                    0.0281,
                    0.0287,
                    0.0292,
                    0.0298,
                    0.0303,
                    0.0309,
                    0.0314,
                    0.032,
                    0.0326,
                    0.0332,
                    0.0338,
                    0.0345,
                    0.0352,
                    0.0359,
                    0.0367,
                    0.0375,
                    0.0383,
                    0.0391,
                    0.04,
                    0.0408,
                    0.0417,
                    0.0425,
                    0.0434,
                    0.0443,
                    0.0453,
                    0.0462,
                    0.0472,
                    0.0482,
                    0.0491,
                    0.0501,
                    0.051,
                    0.052,
                    0.0531,
                    0.0542,
                    0.0553,
                    0.0565,
                    0.0577,
                    0.0591,
                    0.0604,
                    0.0619,
                    0.0633,
                    0.0648,
                    0.0663,
                    0.0679,
                    0.0695,
                    0.0712,
                    0.0729,
                    0.0745,
                    0.0762,
                    0.0781
                ],
                "Fossil_3GHG": 3.9,
                "Fossil_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0046,
                    0.0047,
                    0.0049,
                    0.0051,
                    0.0053,
                    0.0055,
                    0.0057,
                    0.0059,
                    0.0061,
                    0.0063,
                    0.0066,
                    0.0068,
                    0.0071,
                    0.0074,
                    0.0076,
                    0.0079,
                    0.0082,
                    0.0085,
                    0.0089,
                    0.0092,
                    0.0096,
                    0.01,
                    0.0104,
                    0.0109,
                    0.0114,
                    0.0119,
                    0.0123,
                    0.0128,
                    0.0133,
                    0.0138,
                    0.0144,
                    0.015,
                    0.0156,
                    0.0162,
                    0.0169,
                    0.0175,
                    0.0182,
                    0.0189,
                    0.0196,
                    0.0203,
                    0.0211,
                    0.0219,
                    0.0227,
                    0.0236,
                    0.0245,
                    0.0256,
                    0.0267,
                    0.0278,
                    0.029,
                    0.0302,
                    0.0314,
                    0.0328,
                    0.0341,
                    0.0355,
                    0.037,
                    0.0383,
                    0.0398,
                    0.0413
                ],
                "Land_3GHG": 6.38,
                "Land_3GHG_timeseries": [
                    0.0001,
                    0.0002,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.005,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0052,
                    0.0053,
                    0.0053,
                    0.0054,
                    0.0055,
                    0.0055,
                    0.0056,
                    0.0057,
                    0.0057,
                    0.0058,
                    0.0059,
                    0.006,
                    0.0061,
                    0.0063,
                    0.0064,
                    0.0065,
                    0.0067,
                    0.0069,
                    0.0071,
                    0.0072,
                    0.0074,
                    0.0076,
                    0.0078,
                    0.008,
                    0.0083,
                    0.0085,
                    0.0087,
                    0.009,
                    0.0092,
                    0.0095,
                    0.0098,
                    0.0101,
                    0.0104,
                    0.0107,
                    0.011,
                    0.0113,
                    0.0116,
                    0.0119,
                    0.0122,
                    0.0126,
                    0.0129,
                    0.0133,
                    0.0137,
                    0.0141,
                    0.0145,
                    0.0149,
                    0.0154,
                    0.0158,
                    0.0163,
                    0.0168,
                    0.0172,
                    0.0177,
                    0.0181,
                    0.0184,
                    0.0188,
                    0.0192,
                    0.0196,
                    0.0199,
                    0.0203,
                    0.0206,
                    0.021,
                    0.0213,
                    0.0217,
                    0.022,
                    0.0223,
                    0.0226,
                    0.0229,
                    0.0232,
                    0.0235,
                    0.0238,
                    0.0241,
                    0.0243,
                    0.0246,
                    0.025,
                    0.0253,
                    0.0256,
                    0.026,
                    0.0263,
                    0.0266,
                    0.0269,
                    0.0273,
                    0.0276,
                    0.028,
                    0.0283,
                    0.0287,
                    0.029,
                    0.0294,
                    0.0297,
                    0.03,
                    0.0303,
                    0.0306,
                    0.0309,
                    0.0312,
                    0.0315,
                    0.0317,
                    0.032,
                    0.0323,
                    0.0326,
                    0.0329,
                    0.0332,
                    0.0335,
                    0.0338,
                    0.0341,
                    0.0343,
                    0.0346,
                    0.0349,
                    0.0351,
                    0.0354,
                    0.0357,
                    0.0359,
                    0.0362,
                    0.0365,
                    0.0368
                ],
                "Total_CO2": 3.28,
                "Total_CO2_timeseries": [
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0047,
                    0.0048,
                    0.005,
                    0.0051,
                    0.0053,
                    0.0054,
                    0.0055,
                    0.0057,
                    0.0058,
                    0.006,
                    0.0061,
                    0.0063,
                    0.0065,
                    0.0067,
                    0.0069,
                    0.0071,
                    0.0073,
                    0.0076,
                    0.0078,
                    0.008,
                    0.0082,
                    0.0084,
                    0.0087,
                    0.0088,
                    0.009,
                    0.0092,
                    0.0093,
                    0.0095,
                    0.0097,
                    0.0098,
                    0.01,
                    0.0102,
                    0.0103,
                    0.0105,
                    0.0107,
                    0.0109,
                    0.0111,
                    0.0112,
                    0.0115,
                    0.0116,
                    0.0118,
                    0.012,
                    0.0122,
                    0.0124,
                    0.0127,
                    0.0129,
                    0.0132,
                    0.0134,
                    0.0137,
                    0.0139,
                    0.0142,
                    0.0146,
                    0.0149,
                    0.0152,
                    0.0156,
                    0.0159,
                    0.0163,
                    0.0167,
                    0.0171,
                    0.0175,
                    0.018,
                    0.0185,
                    0.019,
                    0.0194,
                    0.0199,
                    0.0205,
                    0.021,
                    0.0216,
                    0.0223,
                    0.023,
                    0.0237,
                    0.0245,
                    0.0253,
                    0.0262,
                    0.0272,
                    0.0282,
                    0.0292,
                    0.0303,
                    0.0314,
                    0.0326,
                    0.0337,
                    0.0348,
                    0.036,
                    0.0373
                ],
                "Fossil_CO2": 3.47,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.7765e-07,
                    4.6428e-07,
                    7.5389e-07,
                    9.7782e-07,
                    1.2256e-06,
                    1.5003e-06,
                    1.7601e-06,
                    2.0153e-06,
                    2.3035e-06,
                    2.3035e-06,
                    2.3035e-06,
                    2.3035e-06,
                    2.3035e-06,
                    2.3035e-06,
                    2.3035e-06,
                    2.3035e-06,
                    2.3035e-06,
                    2.3035e-06,
                    2.3035e-06,
                    2.3035e-06,
                    3.0992e-06,
                    3.8577e-06,
                    4.7073e-06,
                    5.5356e-06,
                    6.5247e-06,
                    7.6239e-06,
                    8.8533e-06,
                    9.9608e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0032,
                    0.0033,
                    0.0035,
                    0.0037,
                    0.0038,
                    0.004,
                    0.0042,
                    0.0045,
                    0.0047,
                    0.005,
                    0.0052,
                    0.0055,
                    0.0058,
                    0.0062,
                    0.0065,
                    0.0069,
                    0.0073,
                    0.0076,
                    0.0081,
                    0.0085,
                    0.009,
                    0.0094,
                    0.0099,
                    0.0104,
                    0.0109,
                    0.0115,
                    0.0122,
                    0.0128,
                    0.0135,
                    0.0143,
                    0.0151,
                    0.016,
                    0.0169,
                    0.0178,
                    0.0188,
                    0.0199,
                    0.021,
                    0.0222,
                    0.0233,
                    0.0244,
                    0.0256,
                    0.0269
                ],
                "Land_CO2": 2.89,
                "Land_CO2_timeseries": [
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0048,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0053,
                    0.0054,
                    0.0056,
                    0.0058,
                    0.0059,
                    0.0061,
                    0.0063,
                    0.0065,
                    0.0067,
                    0.0068,
                    0.007,
                    0.0072,
                    0.0073,
                    0.0074,
                    0.0075,
                    0.0076,
                    0.0077,
                    0.0078,
                    0.008,
                    0.008,
                    0.0081,
                    0.0082,
                    0.0083,
                    0.0084,
                    0.0085,
                    0.0085,
                    0.0086,
                    0.0087,
                    0.0088,
                    0.0089,
                    0.0089,
                    0.009,
                    0.0091,
                    0.0091,
                    0.0092,
                    0.0093,
                    0.0093,
                    0.0094,
                    0.0094,
                    0.0095,
                    0.0095,
                    0.0096,
                    0.0096,
                    0.0097,
                    0.0097,
                    0.0098,
                    0.0098,
                    0.0098,
                    0.0099,
                    0.0099,
                    0.0099,
                    0.01,
                    0.01,
                    0.01,
                    0.01,
                    0.0101,
                    0.0101,
                    0.0101,
                    0.0101,
                    0.0102,
                    0.0102,
                    0.0102,
                    0.0102,
                    0.0103,
                    0.0103,
                    0.0103,
                    0.0103,
                    0.0104,
                    0.0104,
                    0.0104,
                    0.0104,
                    0.0104,
                    0.0104,
                    0.0104
                ],
                "Total_CH4": 8.23,
                "Total_CH4_timeseries": [
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.004,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0054,
                    0.0055,
                    0.0057,
                    0.0059,
                    0.0061,
                    0.0063,
                    0.0065,
                    0.0067,
                    0.0069,
                    0.0071,
                    0.0073,
                    0.0075,
                    0.0077,
                    0.0079,
                    0.0081,
                    0.0084,
                    0.0086,
                    0.0089,
                    0.0092,
                    0.0094,
                    0.0097,
                    0.01,
                    0.0103,
                    0.0107,
                    0.011,
                    0.0113,
                    0.0116,
                    0.0119,
                    0.0123,
                    0.0126,
                    0.0129,
                    0.0132,
                    0.0136,
                    0.0139,
                    0.0143,
                    0.0146,
                    0.0149,
                    0.0153,
                    0.0156,
                    0.0159,
                    0.0162,
                    0.0165,
                    0.0169,
                    0.0172,
                    0.0175,
                    0.0178,
                    0.0182,
                    0.0186,
                    0.019,
                    0.0194,
                    0.0198,
                    0.0203,
                    0.0208,
                    0.0212,
                    0.0217,
                    0.0221,
                    0.0225,
                    0.0229,
                    0.0234,
                    0.0238,
                    0.0243,
                    0.0247,
                    0.0251,
                    0.0256,
                    0.026,
                    0.0263,
                    0.0267,
                    0.0271,
                    0.0275,
                    0.0279,
                    0.0283,
                    0.0287,
                    0.0291,
                    0.0295,
                    0.0299,
                    0.0304,
                    0.0308,
                    0.0311,
                    0.0315,
                    0.0319,
                    0.0323,
                    0.0327,
                    0.033,
                    0.0334,
                    0.0339,
                    0.0343
                ],
                "Fossil_CH4": 5.14,
                "Fossil_CH4_timeseries": [
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0044,
                    0.0045,
                    0.0047,
                    0.0048,
                    0.005,
                    0.0052,
                    0.0053,
                    0.0055,
                    0.0058,
                    0.006,
                    0.0063,
                    0.0064,
                    0.0066,
                    0.0068,
                    0.007,
                    0.0072,
                    0.0074,
                    0.0076,
                    0.0078,
                    0.008,
                    0.0082,
                    0.0084,
                    0.0086,
                    0.0088,
                    0.009,
                    0.0092,
                    0.0095,
                    0.0097,
                    0.0099,
                    0.01,
                    0.0102,
                    0.0105,
                    0.0108,
                    0.011,
                    0.0113,
                    0.0115,
                    0.0117,
                    0.0119,
                    0.0122,
                    0.0124,
                    0.0126,
                    0.0128,
                    0.0131,
                    0.0133
                ],
                "Land_CH4": 13.36,
                "Land_CH4_timeseries": [
                    0,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0044,
                    0.0045,
                    0.0047,
                    0.0048,
                    0.005,
                    0.0052,
                    0.0053,
                    0.0055,
                    0.0057,
                    0.0059,
                    0.0061,
                    0.0063,
                    0.0065,
                    0.0067,
                    0.0069,
                    0.0072,
                    0.0074,
                    0.0077,
                    0.0079,
                    0.0082,
                    0.0085,
                    0.0087,
                    0.009,
                    0.0093,
                    0.0095,
                    0.0097,
                    0.01,
                    0.0102,
                    0.0105,
                    0.0107,
                    0.0109,
                    0.0111,
                    0.0113,
                    0.0115,
                    0.0117,
                    0.0119,
                    0.0121,
                    0.0123,
                    0.0125,
                    0.0126,
                    0.0128,
                    0.013,
                    0.0132,
                    0.0134,
                    0.0136,
                    0.0139,
                    0.0141,
                    0.0143,
                    0.0145,
                    0.0148,
                    0.015,
                    0.0153,
                    0.0155,
                    0.0158,
                    0.016,
                    0.0162,
                    0.0165,
                    0.0167,
                    0.0169,
                    0.0171,
                    0.0173,
                    0.0175,
                    0.0177,
                    0.0179,
                    0.018,
                    0.0182,
                    0.0184,
                    0.0187,
                    0.0188,
                    0.019,
                    0.0192,
                    0.0193,
                    0.0195,
                    0.0196,
                    0.0198,
                    0.0199,
                    0.0201,
                    0.0203,
                    0.0204,
                    0.0206,
                    0.0208,
                    0.021
                ],
                "Total_N2O": 7.82,
                "Total_N2O_timeseries": [
                    9.45e-06,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0047,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0055,
                    0.0056,
                    0.0057,
                    0.0058,
                    0.006,
                    0.0061,
                    0.0062,
                    0.0063,
                    0.0065
                ],
                "Fossil_N2O": 4.71,
                "Fossil_N2O_timeseries": [
                    9.1676e-07,
                    1.8451e-06,
                    2.7847e-06,
                    3.7354e-06,
                    4.6968e-06,
                    5.6684e-06,
                    6.6496e-06,
                    7.64e-06,
                    8.6387e-06,
                    9.6451e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011
                ],
                "Land_N2O": 9.01,
                "Land_N2O_timeseries": [
                    8.5332e-06,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0054
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                89.07635,
                                22.19867
                            ],
                            [
                                89.00798,
                                22.28213
                            ],
                            [
                                89.00015,
                                22.4689
                            ],
                            [
                                88.95098,
                                22.56061
                            ],
                            [
                                88.93931,
                                22.63115
                            ],
                            [
                                88.96731,
                                22.68883
                            ],
                            [
                                88.92519,
                                22.75805
                            ],
                            [
                                88.97087,
                                22.84292
                            ],
                            [
                                88.87272,
                                22.95319
                            ],
                            [
                                88.89177,
                                23.03834
                            ],
                            [
                                88.87501,
                                23.07881
                            ],
                            [
                                88.94691,
                                23.17122
                            ],
                            [
                                88.91762,
                                23.23223
                            ],
                            [
                                88.73058,
                                23.25708
                            ],
                            [
                                88.71768,
                                23.28822
                            ],
                            [
                                88.7947,
                                23.44915
                            ],
                            [
                                88.66575,
                                23.55293
                            ],
                            [
                                88.60262,
                                23.63489
                            ],
                            [
                                88.57824,
                                23.7844
                            ],
                            [
                                88.59959,
                                23.86128
                            ],
                            [
                                88.6682,
                                23.86635
                            ],
                            [
                                88.74787,
                                23.93504
                            ],
                            [
                                88.77076,
                                23.99419
                            ],
                            [
                                88.69914,
                                24.10971
                            ],
                            [
                                88.73252,
                                24.20823
                            ],
                            [
                                88.72988,
                                24.27467
                            ],
                            [
                                88.64887,
                                24.30616
                            ],
                            [
                                88.49383,
                                24.3303
                            ],
                            [
                                88.37784,
                                24.39755
                            ],
                            [
                                88.33633,
                                24.43861
                            ],
                            [
                                88.2087,
                                24.47366
                            ],
                            [
                                88.12554,
                                24.5197
                            ],
                            [
                                88.08559,
                                24.61908
                            ],
                            [
                                88.0327,
                                24.68836
                            ],
                            [
                                88.16379,
                                24.85522
                            ],
                            [
                                88.13958,
                                24.92288
                            ],
                            [
                                88.226,
                                24.95666
                            ],
                            [
                                88.27451,
                                24.89528
                            ],
                            [
                                88.38859,
                                24.95035
                            ],
                            [
                                88.4419,
                                25.03441
                            ],
                            [
                                88.44078,
                                25.19631
                            ],
                            [
                                88.48215,
                                25.2145
                            ],
                            [
                                88.55854,
                                25.18051
                            ],
                            [
                                88.61325,
                                25.20464
                            ],
                            [
                                88.71379,
                                25.20643
                            ],
                            [
                                88.79766,
                                25.17578
                            ],
                            [
                                88.85692,
                                25.20659
                            ],
                            [
                                88.9208,
                                25.17369
                            ],
                            [
                                88.94919,
                                25.25392
                            ],
                            [
                                88.99617,
                                25.31746
                            ],
                            [
                                88.90929,
                                25.32078
                            ],
                            [
                                88.83654,
                                25.37037
                            ],
                            [
                                88.83722,
                                25.46108
                            ],
                            [
                                88.80079,
                                25.51675
                            ],
                            [
                                88.71036,
                                25.50008
                            ],
                            [
                                88.55162,
                                25.51612
                            ],
                            [
                                88.44561,
                                25.60451
                            ],
                            [
                                88.44596,
                                25.66614
                            ],
                            [
                                88.2738,
                                25.78253
                            ],
                            [
                                88.26151,
                                25.81231
                            ],
                            [
                                88.15184,
                                25.7817
                            ],
                            [
                                88.11752,
                                25.80351
                            ],
                            [
                                88.08952,
                                25.9318
                            ],
                            [
                                88.18062,
                                26.02579
                            ],
                            [
                                88.16173,
                                26.08285
                            ],
                            [
                                88.18314,
                                26.14578
                            ],
                            [
                                88.34897,
                                26.21857
                            ],
                            [
                                88.34701,
                                26.27684
                            ],
                            [
                                88.45112,
                                26.36988
                            ],
                            [
                                88.52244,
                                26.37144
                            ],
                            [
                                88.47913,
                                26.46033
                            ],
                            [
                                88.33267,
                                26.48679
                            ],
                            [
                                88.37503,
                                26.58365
                            ],
                            [
                                88.47946,
                                26.54205
                            ],
                            [
                                88.5239,
                                26.48672
                            ],
                            [
                                88.67891,
                                26.40353
                            ],
                            [
                                88.73349,
                                26.32668
                            ],
                            [
                                88.79535,
                                26.31113
                            ],
                            [
                                88.83628,
                                26.2382
                            ],
                            [
                                88.90806,
                                26.28827
                            ],
                            [
                                88.96341,
                                26.23544
                            ],
                            [
                                89.064,
                                26.25862
                            ],
                            [
                                88.98094,
                                26.34863
                            ],
                            [
                                88.91561,
                                26.36766
                            ],
                            [
                                88.95416,
                                26.4589
                            ],
                            [
                                89.04858,
                                26.39809
                            ],
                            [
                                89.09815,
                                26.39487
                            ],
                            [
                                89.10542,
                                26.28581
                            ],
                            [
                                89.14095,
                                26.18552
                            ],
                            [
                                89.2632,
                                26.06222
                            ],
                            [
                                89.35688,
                                26.00965
                            ],
                            [
                                89.41143,
                                26.03652
                            ],
                            [
                                89.469,
                                26.00243
                            ],
                            [
                                89.53786,
                                25.99704
                            ],
                            [
                                89.60822,
                                26.05692
                            ],
                            [
                                89.59277,
                                26.15489
                            ],
                            [
                                89.67921,
                                26.16882
                            ],
                            [
                                89.74645,
                                26.15304
                            ],
                            [
                                89.78364,
                                26.0943
                            ],
                            [
                                89.77893,
                                26.04314
                            ],
                            [
                                89.82767,
                                25.98673
                            ],
                            [
                                89.83694,
                                25.87861
                            ],
                            [
                                89.82409,
                                25.73509
                            ],
                            [
                                89.86793,
                                25.66426
                            ],
                            [
                                89.86852,
                                25.5837
                            ],
                            [
                                89.81638,
                                25.37555
                            ],
                            [
                                89.83447,
                                25.29984
                            ],
                            [
                                89.95267,
                                25.30065
                            ],
                            [
                                90.1103,
                                25.22649
                            ],
                            [
                                90.31403,
                                25.18763
                            ],
                            [
                                90.43921,
                                25.14688
                            ],
                            [
                                90.53254,
                                25.17357
                            ],
                            [
                                90.64801,
                                25.18351
                            ],
                            [
                                90.72485,
                                25.1577
                            ],
                            [
                                90.76065,
                                25.17787
                            ],
                            [
                                90.83473,
                                25.15478
                            ],
                            [
                                90.95451,
                                25.16003
                            ],
                            [
                                91.07458,
                                25.1949
                            ],
                            [
                                91.25803,
                                25.20176
                            ],
                            [
                                91.48072,
                                25.13504
                            ],
                            [
                                91.58388,
                                25.16451
                            ],
                            [
                                91.63702,
                                25.1234
                            ],
                            [
                                91.78699,
                                25.16523
                            ],
                            [
                                92.0546,
                                25.18492
                            ],
                            [
                                92.20721,
                                25.12404
                            ],
                            [
                                92.21848,
                                25.10145
                            ],
                            [
                                92.40046,
                                25.03226
                            ],
                            [
                                92.46186,
                                24.96129
                            ],
                            [
                                92.48934,
                                24.86886
                            ],
                            [
                                92.42951,
                                24.85292
                            ],
                            [
                                92.27925,
                                24.85319
                            ],
                            [
                                92.27385,
                                24.78573
                            ],
                            [
                                92.18254,
                                24.55539
                            ],
                            [
                                92.12929,
                                24.51365
                            ],
                            [
                                92.13683,
                                24.39804
                            ],
                            [
                                92.0869,
                                24.374
                            ],
                            [
                                91.96599,
                                24.37012
                            ],
                            [
                                91.92213,
                                24.32774
                            ],
                            [
                                91.92815,
                                24.23859
                            ],
                            [
                                91.90596,
                                24.14509
                            ],
                            [
                                91.83816,
                                24.19985
                            ],
                            [
                                91.75829,
                                24.23561
                            ],
                            [
                                91.75926,
                                24.15758
                            ],
                            [
                                91.68449,
                                24.16926
                            ],
                            [
                                91.63764,
                                24.10595
                            ],
                            [
                                91.53733,
                                24.07129
                            ],
                            [
                                91.41081,
                                24.10851
                            ],
                            [
                                91.37002,
                                23.9789
                            ],
                            [
                                91.30339,
                                23.9872
                            ],
                            [
                                91.26322,
                                23.95888
                            ],
                            [
                                91.22838,
                                23.87788
                            ],
                            [
                                91.24576,
                                23.83425
                            ],
                            [
                                91.21175,
                                23.73944
                            ],
                            [
                                91.15154,
                                23.7153
                            ],
                            [
                                91.16261,
                                23.59651
                            ],
                            [
                                91.24334,
                                23.48269
                            ],
                            [
                                91.31829,
                                23.24834
                            ],
                            [
                                91.34899,
                                23.08798
                            ],
                            [
                                91.4015,
                                23.08746
                            ],
                            [
                                91.38003,
                                23.17478
                            ],
                            [
                                91.3928,
                                23.25753
                            ],
                            [
                                91.42817,
                                23.2584
                            ],
                            [
                                91.49628,
                                23.18643
                            ],
                            [
                                91.54485,
                                22.99383
                            ],
                            [
                                91.62621,
                                22.95389
                            ],
                            [
                                91.71688,
                                22.98532
                            ],
                            [
                                91.77456,
                                23.05958
                            ],
                            [
                                91.81222,
                                23.06745
                            ],
                            [
                                91.80475,
                                23.16796
                            ],
                            [
                                91.77124,
                                23.2676
                            ],
                            [
                                91.84132,
                                23.3976
                            ],
                            [
                                91.93624,
                                23.43104
                            ],
                            [
                                91.96603,
                                23.48668
                            ],
                            [
                                91.93828,
                                23.67844
                            ],
                            [
                                91.97813,
                                23.72176
                            ],
                            [
                                92.03091,
                                23.64032
                            ],
                            [
                                92.16939,
                                23.73354
                            ],
                            [
                                92.20989,
                                23.69609
                            ],
                            [
                                92.28895,
                                23.69342
                            ],
                            [
                                92.27383,
                                23.64217
                            ],
                            [
                                92.3027,
                                23.57782
                            ],
                            [
                                92.32773,
                                23.42485
                            ],
                            [
                                92.37595,
                                23.34894
                            ],
                            [
                                92.38549,
                                23.26722
                            ],
                            [
                                92.34901,
                                23.23355
                            ],
                            [
                                92.38833,
                                23.04843
                            ],
                            [
                                92.37339,
                                22.95475
                            ],
                            [
                                92.44251,
                                22.88459
                            ],
                            [
                                92.47475,
                                22.74741
                            ],
                            [
                                92.5146,
                                22.71788
                            ],
                            [
                                92.53552,
                                22.5876
                            ],
                            [
                                92.52531,
                                22.55517
                            ],
                            [
                                92.57848,
                                22.32328
                            ],
                            [
                                92.60654,
                                22.13471
                            ],
                            [
                                92.60676,
                                21.9712
                            ],
                            [
                                92.6771,
                                22.01547
                            ],
                            [
                                92.69582,
                                22.14814
                            ],
                            [
                                92.86392,
                                22.0586
                            ],
                            [
                                92.92853,
                                22.01137
                            ],
                            [
                                93.05213,
                                22.10277
                            ],
                            [
                                93.04884,
                                22.1972
                            ],
                            [
                                93.10834,
                                22.20282
                            ],
                            [
                                93.18575,
                                22.24701
                            ],
                            [
                                93.20126,
                                22.29939
                            ],
                            [
                                93.17925,
                                22.41962
                            ],
                            [
                                93.13323,
                                22.46564
                            ],
                            [
                                93.11217,
                                22.53391
                            ],
                            [
                                93.13767,
                                22.59051
                            ],
                            [
                                93.10591,
                                22.64613
                            ],
                            [
                                93.10119,
                                22.78177
                            ],
                            [
                                93.12187,
                                22.86513
                            ],
                            [
                                93.1626,
                                22.91074
                            ],
                            [
                                93.13159,
                                23.04115
                            ],
                            [
                                93.20555,
                                23.04612
                            ],
                            [
                                93.29295,
                                23.00519
                            ],
                            [
                                93.34653,
                                23.06858
                            ],
                            [
                                93.38348,
                                23.21893
                            ],
                            [
                                93.36146,
                                23.34667
                            ],
                            [
                                93.41788,
                                23.53805
                            ],
                            [
                                93.4358,
                                23.68132
                            ],
                            [
                                93.40024,
                                23.75196
                            ],
                            [
                                93.39193,
                                23.91837
                            ],
                            [
                                93.33319,
                                23.98176
                            ],
                            [
                                93.34079,
                                24.08526
                            ],
                            [
                                93.40551,
                                24.0749
                            ],
                            [
                                93.49989,
                                23.95353
                            ],
                            [
                                93.6221,
                                23.99954
                            ],
                            [
                                93.75544,
                                23.99954
                            ],
                            [
                                93.80892,
                                23.93373
                            ],
                            [
                                93.90561,
                                23.94974
                            ],
                            [
                                94.02265,
                                23.92192
                            ],
                            [
                                94.15981,
                                23.85605
                            ],
                            [
                                94.25234,
                                24.07218
                            ],
                            [
                                94.25598,
                                24.14876
                            ],
                            [
                                94.31376,
                                24.26403
                            ],
                            [
                                94.32174,
                                24.31599
                            ],
                            [
                                94.37225,
                                24.36946
                            ],
                            [
                                94.39842,
                                24.47065
                            ],
                            [
                                94.45133,
                                24.55585
                            ],
                            [
                                94.51475,
                                24.60413
                            ],
                            [
                                94.54576,
                                24.69382
                            ],
                            [
                                94.60361,
                                24.71112
                            ],
                            [
                                94.64459,
                                24.83605
                            ],
                            [
                                94.70035,
                                24.92053
                            ],
                            [
                                94.69501,
                                24.96751
                            ],
                            [
                                94.74273,
                                25.04303
                            ],
                            [
                                94.70937,
                                25.14417
                            ],
                            [
                                94.61036,
                                25.17043
                            ],
                            [
                                94.58298,
                                25.24975
                            ],
                            [
                                94.63124,
                                25.38619
                            ],
                            [
                                94.67988,
                                25.45348
                            ],
                            [
                                94.7793,
                                25.48376
                            ],
                            [
                                94.88091,
                                25.56337
                            ],
                            [
                                94.92594,
                                25.64572
                            ],
                            [
                                95.04269,
                                25.76587
                            ],
                            [
                                95.02403,
                                25.92248
                            ],
                            [
                                95.09276,
                                25.95744
                            ],
                            [
                                95.18208,
                                26.06318
                            ],
                            [
                                95.11642,
                                26.11261
                            ],
                            [
                                95.12245,
                                26.19
                            ],
                            [
                                95.08829,
                                26.23678
                            ],
                            [
                                95.07299,
                                26.33917
                            ],
                            [
                                95.0977,
                                26.40576
                            ],
                            [
                                95.07279,
                                26.45818
                            ],
                            [
                                95.15083,
                                26.58087
                            ],
                            [
                                95.15422,
                                26.62061
                            ],
                            [
                                95.23994,
                                26.67951
                            ],
                            [
                                95.27687,
                                26.64423
                            ],
                            [
                                95.42587,
                                26.69405
                            ],
                            [
                                95.50014,
                                26.80057
                            ],
                            [
                                95.59947,
                                26.81009
                            ],
                            [
                                95.67055,
                                26.89564
                            ],
                            [
                                95.74756,
                                26.91127
                            ],
                            [
                                95.80148,
                                27.00682
                            ],
                            [
                                95.92299,
                                27.03259
                            ],
                            [
                                96.02548,
                                27.17741
                            ],
                            [
                                96.09492,
                                27.22452
                            ],
                            [
                                96.23189,
                                27.27527
                            ],
                            [
                                96.38377,
                                27.28429
                            ],
                            [
                                96.43689,
                                27.30212
                            ],
                            [
                                96.56318,
                                27.30338
                            ],
                            [
                                96.62933,
                                27.36516
                            ],
                            [
                                96.78371,
                                27.34866
                            ],
                            [
                                96.84911,
                                27.27045
                            ],
                            [
                                96.85524,
                                27.20806
                            ],
                            [
                                96.91022,
                                27.15948
                            ],
                            [
                                97.13751,
                                27.09015
                            ],
                            [
                                97.16504,
                                27.12304
                            ],
                            [
                                96.96539,
                                27.36898
                            ],
                            [
                                96.90157,
                                27.46115
                            ],
                            [
                                96.92296,
                                27.5056
                            ],
                            [
                                96.89049,
                                27.61221
                            ],
                            [
                                96.97682,
                                27.67112
                            ],
                            [
                                97.01892,
                                27.73834
                            ],
                            [
                                97.09139,
                                27.74302
                            ],
                            [
                                97.25461,
                                27.89509
                            ],
                            [
                                97.38517,
                                27.89144
                            ],
                            [
                                97.3801,
                                27.96973
                            ],
                            [
                                97.41005,
                                28.01213
                            ],
                            [
                                97.32163,
                                28.05724
                            ],
                            [
                                97.35823,
                                28.16401
                            ],
                            [
                                97.34711,
                                28.20807
                            ],
                            [
                                97.15703,
                                28.33697
                            ],
                            [
                                97.08993,
                                28.36782
                            ],
                            [
                                97.02477,
                                28.32179
                            ],
                            [
                                96.76501,
                                28.37057
                            ],
                            [
                                96.75565,
                                28.40341
                            ],
                            [
                                96.66981,
                                28.45223
                            ],
                            [
                                96.58028,
                                28.45588
                            ],
                            [
                                96.46201,
                                28.41387
                            ],
                            [
                                96.4282,
                                28.34937
                            ],
                            [
                                96.27872,
                                28.41518
                            ],
                            [
                                96.36709,
                                28.47757
                            ],
                            [
                                96.33538,
                                28.51862
                            ],
                            [
                                96.4884,
                                28.62892
                            ],
                            [
                                96.53255,
                                28.71395
                            ],
                            [
                                96.60385,
                                28.72748
                            ],
                            [
                                96.62241,
                                28.77916
                            ],
                            [
                                96.54305,
                                28.87797
                            ],
                            [
                                96.54114,
                                28.91652
                            ],
                            [
                                96.44292,
                                29.03903
                            ],
                            [
                                96.35213,
                                29.03598
                            ],
                            [
                                96.18907,
                                28.90104
                            ],
                            [
                                96.15559,
                                28.95354
                            ],
                            [
                                96.19223,
                                28.9875
                            ],
                            [
                                96.13124,
                                29.08156
                            ],
                            [
                                96.19881,
                                29.09444
                            ],
                            [
                                96.25688,
                                29.16524
                            ],
                            [
                                96.3443,
                                29.17386
                            ],
                            [
                                96.39625,
                                29.25094
                            ],
                            [
                                96.37529,
                                29.28241
                            ],
                            [
                                96.25185,
                                29.23627
                            ],
                            [
                                96.19103,
                                29.30489
                            ],
                            [
                                96.17964,
                                29.35555
                            ],
                            [
                                96.10791,
                                29.44727
                            ],
                            [
                                96.06102,
                                29.44876
                            ],
                            [
                                95.99868,
                                29.36712
                            ],
                            [
                                95.84514,
                                29.3183
                            ],
                            [
                                95.75847,
                                29.31807
                            ],
                            [
                                95.68694,
                                29.2273
                            ],
                            [
                                95.56417,
                                29.17712
                            ],
                            [
                                95.50356,
                                29.13262
                            ],
                            [
                                95.41777,
                                29.17547
                            ],
                            [
                                95.38474,
                                29.1369
                            ],
                            [
                                95.29948,
                                29.13825
                            ],
                            [
                                95.2606,
                                29.07352
                            ],
                            [
                                95.21375,
                                29.10826
                            ],
                            [
                                95.12328,
                                29.09056
                            ],
                            [
                                95.09704,
                                29.14125
                            ],
                            [
                                95.00531,
                                29.16584
                            ],
                            [
                                94.91232,
                                29.15909
                            ],
                            [
                                94.79726,
                                29.17535
                            ],
                            [
                                94.72718,
                                29.28441
                            ],
                            [
                                94.68131,
                                29.31159
                            ],
                            [
                                94.62329,
                                29.2934
                            ],
                            [
                                94.55268,
                                29.22957
                            ],
                            [
                                94.42429,
                                29.21347
                            ],
                            [
                                94.36244,
                                29.1481
                            ],
                            [
                                94.27782,
                                29.13028
                            ],
                            [
                                94.12418,
                                28.95661
                            ],
                            [
                                94.03419,
                                28.96501
                            ],
                            [
                                94.05589,
                                28.87667
                            ],
                            [
                                93.93361,
                                28.83098
                            ],
                            [
                                93.92704,
                                28.76721
                            ],
                            [
                                93.82433,
                                28.762
                            ],
                            [
                                93.76612,
                                28.70837
                            ],
                            [
                                93.67338,
                                28.67493
                            ],
                            [
                                93.56519,
                                28.68547
                            ],
                            [
                                93.34659,
                                28.66035
                            ],
                            [
                                93.30036,
                                28.63592
                            ],
                            [
                                93.2216,
                                28.52631
                            ],
                            [
                                93.2443,
                                28.44924
                            ],
                            [
                                93.23179,
                                28.37069
                            ],
                            [
                                93.12187,
                                28.35737
                            ],
                            [
                                93.0297,
                                28.32102
                            ],
                            [
                                93.01477,
                                28.26284
                            ],
                            [
                                92.95559,
                                28.26116
                            ],
                            [
                                92.86551,
                                28.18421
                            ],
                            [
                                92.74662,
                                28.15984
                            ],
                            [
                                92.66995,
                                28.07386
                            ],
                            [
                                92.72268,
                                28.02049
                            ],
                            [
                                92.70417,
                                27.948
                            ],
                            [
                                92.57287,
                                27.87582
                            ],
                            [
                                92.45541,
                                27.82719
                            ],
                            [
                                92.30799,
                                27.80932
                            ],
                            [
                                92.28166,
                                27.871
                            ],
                            [
                                92.10471,
                                27.80067
                            ],
                            [
                                92.03837,
                                27.74268
                            ],
                            [
                                91.89436,
                                27.72231
                            ],
                            [
                                91.82399,
                                27.76664
                            ],
                            [
                                91.64209,
                                27.75846
                            ],
                            [
                                91.62271,
                                27.69827
                            ],
                            [
                                91.57122,
                                27.65562
                            ],
                            [
                                91.56451,
                                27.57963
                            ],
                            [
                                91.62559,
                                27.51351
                            ],
                            [
                                91.75287,
                                27.46652
                            ],
                            [
                                91.83794,
                                27.49297
                            ],
                            [
                                91.94668,
                                27.46795
                            ],
                            [
                                92.0127,
                                27.47693
                            ],
                            [
                                92.12361,
                                27.27647
                            ],
                            [
                                92.07022,
                                27.24045
                            ],
                            [
                                92.03165,
                                27.17163
                            ],
                            [
                                92.02847,
                                27.08344
                            ],
                            [
                                92.12316,
                                26.96322
                            ],
                            [
                                92.10793,
                                26.85827
                            ],
                            [
                                91.83776,
                                26.86073
                            ],
                            [
                                91.71265,
                                26.79656
                            ],
                            [
                                91.5342,
                                26.81788
                            ],
                            [
                                91.51652,
                                26.86073
                            ],
                            [
                                91.43753,
                                26.87272
                            ],
                            [
                                91.33362,
                                26.77779
                            ],
                            [
                                91.25719,
                                26.80785
                            ],
                            [
                                91.09093,
                                26.81543
                            ],
                            [
                                91.0453,
                                26.78733
                            ],
                            [
                                90.74913,
                                26.78216
                            ],
                            [
                                90.69714,
                                26.77227
                            ],
                            [
                                90.53509,
                                26.82282
                            ],
                            [
                                90.41864,
                                26.90177
                            ],
                            [
                                90.36107,
                                26.90055
                            ],
                            [
                                90.30199,
                                26.85529
                            ],
                            [
                                90.23557,
                                26.86039
                            ],
                            [
                                90.16926,
                                26.76526
                            ],
                            [
                                90.06185,
                                26.74125
                            ],
                            [
                                89.92,
                                26.72892
                            ],
                            [
                                89.85694,
                                26.70832
                            ],
                            [
                                89.6231,
                                26.7378
                            ],
                            [
                                89.63625,
                                26.7815
                            ],
                            [
                                89.54234,
                                26.81414
                            ],
                            [
                                89.48652,
                                26.8087
                            ],
                            [
                                89.37377,
                                26.85963
                            ],
                            [
                                89.26448,
                                26.82212
                            ],
                            [
                                89.13693,
                                26.81208
                            ],
                            [
                                89.08982,
                                26.89186
                            ],
                            [
                                89.0237,
                                26.93544
                            ],
                            [
                                88.9488,
                                26.93982
                            ],
                            [
                                88.87676,
                                27.06759
                            ],
                            [
                                88.77215,
                                27.10514
                            ],
                            [
                                88.82565,
                                27.21627
                            ],
                            [
                                88.88386,
                                27.22557
                            ],
                            [
                                88.92332,
                                27.27284
                            ],
                            [
                                88.89969,
                                27.33152
                            ],
                            [
                                88.83654,
                                27.38221
                            ],
                            [
                                88.78116,
                                27.46964
                            ],
                            [
                                88.79023,
                                27.57714
                            ],
                            [
                                88.84951,
                                27.67559
                            ],
                            [
                                88.86035,
                                27.81228
                            ],
                            [
                                88.88617,
                                27.85582
                            ],
                            [
                                88.84159,
                                27.92713
                            ],
                            [
                                88.84291,
                                27.99999
                            ],
                            [
                                88.75996,
                                28.07253
                            ],
                            [
                                88.67498,
                                28.07221
                            ],
                            [
                                88.64477,
                                28.11288
                            ],
                            [
                                88.56198,
                                28.0815
                            ],
                            [
                                88.39919,
                                27.98041
                            ],
                            [
                                88.35519,
                                27.98952
                            ],
                            [
                                88.25576,
                                27.94429
                            ],
                            [
                                88.15407,
                                27.96128
                            ],
                            [
                                88.13508,
                                27.88193
                            ],
                            [
                                88.1968,
                                27.85301
                            ],
                            [
                                88.19502,
                                27.79003
                            ],
                            [
                                88.15268,
                                27.69201
                            ],
                            [
                                88.08584,
                                27.59103
                            ],
                            [
                                88.04492,
                                27.48492
                            ],
                            [
                                88.07433,
                                27.43072
                            ],
                            [
                                88.04424,
                                27.37069
                            ],
                            [
                                87.99673,
                                27.10381
                            ],
                            [
                                88.0394,
                                27.03639
                            ],
                            [
                                88.08052,
                                27.03332
                            ],
                            [
                                88.17245,
                                26.86448
                            ],
                            [
                                88.18828,
                                26.77067
                            ],
                            [
                                88.16494,
                                26.64486
                            ],
                            [
                                88.09621,
                                26.51092
                            ],
                            [
                                88.09275,
                                26.42881
                            ],
                            [
                                87.99751,
                                26.3648
                            ],
                            [
                                87.91829,
                                26.42943
                            ],
                            [
                                87.79065,
                                26.46553
                            ],
                            [
                                87.7653,
                                26.4083
                            ],
                            [
                                87.68182,
                                26.43249
                            ],
                            [
                                87.60649,
                                26.38129
                            ],
                            [
                                87.46401,
                                26.4391
                            ],
                            [
                                87.36923,
                                26.4056
                            ],
                            [
                                87.35686,
                                26.35944
                            ],
                            [
                                87.27042,
                                26.37499
                            ],
                            [
                                87.25028,
                                26.41315
                            ],
                            [
                                87.15665,
                                26.40741
                            ],
                            [
                                87.0931,
                                26.45497
                            ],
                            [
                                87.07277,
                                26.58398
                            ],
                            [
                                87.01631,
                                26.53267
                            ],
                            [
                                86.8416,
                                26.44348
                            ],
                            [
                                86.76798,
                                26.46043
                            ],
                            [
                                86.73287,
                                26.42497
                            ],
                            [
                                86.57604,
                                26.49408
                            ],
                            [
                                86.50106,
                                26.54365
                            ],
                            [
                                86.34139,
                                26.61893
                            ],
                            [
                                86.23538,
                                26.59385
                            ],
                            [
                                86.03611,
                                26.66537
                            ],
                            [
                                85.86531,
                                26.57233
                            ],
                            [
                                85.85364,
                                26.60885
                            ],
                            [
                                85.73992,
                                26.65338
                            ],
                            [
                                85.73784,
                                26.79316
                            ],
                            [
                                85.7052,
                                26.83555
                            ],
                            [
                                85.62708,
                                26.87137
                            ],
                            [
                                85.57876,
                                26.85902
                            ],
                            [
                                85.45639,
                                26.78591
                            ],
                            [
                                85.40707,
                                26.79204
                            ],
                            [
                                85.33434,
                                26.74525
                            ],
                            [
                                85.21178,
                                26.76217
                            ],
                            [
                                85.17866,
                                26.80845
                            ],
                            [
                                85.18756,
                                26.86956
                            ],
                            [
                                85.10469,
                                26.87175
                            ],
                            [
                                84.97306,
                                26.91913
                            ],
                            [
                                84.95951,
                                26.9597
                            ],
                            [
                                84.89206,
                                26.97089
                            ],
                            [
                                84.82873,
                                27.02105
                            ],
                            [
                                84.79471,
                                26.99769
                            ],
                            [
                                84.64931,
                                27.04635
                            ],
                            [
                                84.67554,
                                27.10011
                            ],
                            [
                                84.68658,
                                27.23517
                            ],
                            [
                                84.62416,
                                27.33512
                            ],
                            [
                                84.27948,
                                27.39664
                            ],
                            [
                                84.25601,
                                27.44604
                            ],
                            [
                                84.10601,
                                27.51742
                            ],
                            [
                                84.05591,
                                27.44692
                            ],
                            [
                                83.93764,
                                27.45098
                            ],
                            [
                                83.83782,
                                27.42532
                            ],
                            [
                                83.82566,
                                27.37681
                            ],
                            [
                                83.61992,
                                27.46791
                            ],
                            [
                                83.39591,
                                27.47811
                            ],
                            [
                                83.40808,
                                27.41341
                            ],
                            [
                                83.3571,
                                27.34228
                            ],
                            [
                                83.30533,
                                27.33432
                            ],
                            [
                                83.2688,
                                27.38737
                            ],
                            [
                                83.18442,
                                27.45376
                            ],
                            [
                                83.03172,
                                27.45036
                            ],
                            [
                                82.92648,
                                27.50043
                            ],
                            [
                                82.7645,
                                27.50264
                            ],
                            [
                                82.75516,
                                27.58746
                            ],
                            [
                                82.70656,
                                27.7171
                            ],
                            [
                                82.47542,
                                27.68091
                            ],
                            [
                                82.40033,
                                27.70875
                            ],
                            [
                                82.20487,
                                27.84424
                            ],
                            [
                                82.12363,
                                27.86588
                            ],
                            [
                                82.06514,
                                27.92151
                            ],
                            [
                                81.97295,
                                27.92588
                            ],
                            [
                                81.89168,
                                27.85606
                            ],
                            [
                                81.70319,
                                27.98519
                            ],
                            [
                                81.65139,
                                27.99274
                            ],
                            [
                                81.48594,
                                28.08188
                            ],
                            [
                                81.44689,
                                28.15854
                            ],
                            [
                                81.32025,
                                28.19655
                            ],
                            [
                                81.2386,
                                28.28314
                            ],
                            [
                                81.20151,
                                28.36913
                            ],
                            [
                                81.02542,
                                28.41636
                            ],
                            [
                                80.71299,
                                28.57163
                            ],
                            [
                                80.66778,
                                28.63918
                            ],
                            [
                                80.5866,
                                28.67964
                            ],
                            [
                                80.50773,
                                28.66471
                            ],
                            [
                                80.52291,
                                28.583
                            ],
                            [
                                80.47359,
                                28.58496
                            ],
                            [
                                80.42209,
                                28.63603
                            ],
                            [
                                80.37673,
                                28.62908
                            ],
                            [
                                80.31699,
                                28.6971
                            ],
                            [
                                80.26168,
                                28.72199
                            ],
                            [
                                80.12216,
                                28.82576
                            ],
                            [
                                80.06655,
                                28.84376
                            ],
                            [
                                80.06199,
                                28.91799
                            ],
                            [
                                80.13231,
                                29.00209
                            ],
                            [
                                80.14567,
                                29.10014
                            ],
                            [
                                80.18332,
                                29.13314
                            ],
                            [
                                80.26927,
                                29.14262
                            ],
                            [
                                80.31777,
                                29.31462
                            ],
                            [
                                80.28358,
                                29.3443
                            ],
                            [
                                80.25097,
                                29.4476
                            ],
                            [
                                80.34624,
                                29.51303
                            ],
                            [
                                80.41008,
                                29.59525
                            ],
                            [
                                80.3682,
                                29.74743
                            ],
                            [
                                80.43502,
                                29.80291
                            ],
                            [
                                80.49437,
                                29.79686
                            ],
                            [
                                80.55445,
                                29.85299
                            ],
                            [
                                80.60076,
                                29.95564
                            ],
                            [
                                80.67405,
                                29.95683
                            ],
                            [
                                80.77384,
                                30.05681
                            ],
                            [
                                80.87773,
                                30.12955
                            ],
                            [
                                80.90351,
                                30.21548
                            ],
                            [
                                80.96029,
                                30.18192
                            ],
                            [
                                81.03692,
                                30.20276
                            ],
                            [
                                81.03142,
                                30.24945
                            ],
                            [
                                80.93168,
                                30.27022
                            ],
                            [
                                80.91021,
                                30.30518
                            ],
                            [
                                80.8159,
                                30.32426
                            ],
                            [
                                80.74078,
                                30.40019
                            ],
                            [
                                80.63141,
                                30.46161
                            ],
                            [
                                80.53833,
                                30.44661
                            ],
                            [
                                80.45042,
                                30.51067
                            ],
                            [
                                80.39173,
                                30.51697
                            ],
                            [
                                80.33772,
                                30.56597
                            ],
                            [
                                80.2728,
                                30.55433
                            ],
                            [
                                80.21762,
                                30.58303
                            ],
                            [
                                80.19283,
                                30.67426
                            ],
                            [
                                80.25455,
                                30.71758
                            ],
                            [
                                80.19455,
                                30.79827
                            ],
                            [
                                80.13902,
                                30.78442
                            ],
                            [
                                80.04525,
                                30.81296
                            ],
                            [
                                79.99197,
                                30.87962
                            ],
                            [
                                79.93429,
                                30.88495
                            ],
                            [
                                79.88038,
                                30.96952
                            ],
                            [
                                79.76019,
                                30.99702
                            ],
                            [
                                79.58991,
                                30.94335
                            ],
                            [
                                79.49954,
                                31.03282
                            ],
                            [
                                79.42539,
                                31.02128
                            ],
                            [
                                79.39033,
                                31.11499
                            ],
                            [
                                79.31757,
                                31.1296
                            ],
                            [
                                79.29688,
                                31.2124
                            ],
                            [
                                79.23148,
                                31.27215
                            ],
                            [
                                79.22593,
                                31.32943
                            ],
                            [
                                79.07261,
                                31.45384
                            ],
                            [
                                78.93674,
                                31.35733
                            ],
                            [
                                78.88294,
                                31.28031
                            ],
                            [
                                78.78203,
                                31.31402
                            ],
                            [
                                78.75219,
                                31.36724
                            ],
                            [
                                78.78879,
                                31.4374
                            ],
                            [
                                78.73843,
                                31.53468
                            ],
                            [
                                78.8419,
                                31.61403
                            ],
                            [
                                78.75742,
                                31.67521
                            ],
                            [
                                78.69747,
                                31.77417
                            ],
                            [
                                78.77496,
                                31.98584
                            ],
                            [
                                78.70111,
                                32.02592
                            ],
                            [
                                78.67138,
                                32.12023
                            ],
                            [
                                78.60857,
                                32.13454
                            ],
                            [
                                78.54612,
                                32.20865
                            ],
                            [
                                78.47358,
                                32.23952
                            ],
                            [
                                78.50527,
                                32.29939
                            ],
                            [
                                78.45847,
                                32.38209
                            ],
                            [
                                78.46899,
                                32.44091
                            ],
                            [
                                78.39431,
                                32.53748
                            ],
                            [
                                78.51745,
                                32.60876
                            ],
                            [
                                78.62617,
                                32.63346
                            ],
                            [
                                78.68472,
                                32.68228
                            ],
                            [
                                78.77916,
                                32.60969
                            ],
                            [
                                78.75873,
                                32.56603
                            ],
                            [
                                78.80829,
                                32.44
                            ],
                            [
                                78.96913,
                                32.33524
                            ],
                            [
                                79.0045,
                                32.37767
                            ],
                            [
                                79.08927,
                                32.37306
                            ],
                            [
                                79.13367,
                                32.47415
                            ],
                            [
                                79.18984,
                                32.51384
                            ],
                            [
                                79.34723,
                                32.52681
                            ],
                            [
                                79.46433,
                                32.59265
                            ],
                            [
                                79.54525,
                                32.60732
                            ],
                            [
                                79.56425,
                                32.67093
                            ],
                            [
                                79.54056,
                                32.74859
                            ],
                            [
                                79.46451,
                                32.81688
                            ],
                            [
                                79.45693,
                                32.87155
                            ],
                            [
                                79.36507,
                                32.95691
                            ],
                            [
                                79.36617,
                                33.05977
                            ],
                            [
                                79.41071,
                                33.13563
                            ],
                            [
                                79.37734,
                                33.1899
                            ],
                            [
                                79.14666,
                                33.18827
                            ],
                            [
                                79.07612,
                                33.22384
                            ],
                            [
                                79.03365,
                                33.31298
                            ],
                            [
                                78.94793,
                                33.37869
                            ],
                            [
                                78.83985,
                                33.42786
                            ],
                            [
                                78.81345,
                                33.48481
                            ],
                            [
                                78.73884,
                                33.55817
                            ],
                            [
                                78.69014,
                                33.67831
                            ],
                            [
                                78.77811,
                                33.7382
                            ],
                            [
                                78.7563,
                                33.79131
                            ],
                            [
                                78.75949,
                                33.91157
                            ],
                            [
                                78.74338,
                                33.98475
                            ],
                            [
                                78.65354,
                                34.03384
                            ],
                            [
                                78.66041,
                                34.08899
                            ],
                            [
                                78.73304,
                                34.09169
                            ],
                            [
                                78.8763,
                                34.16445
                            ],
                            [
                                78.92386,
                                34.15806
                            ],
                            [
                                78.98208,
                                34.32017
                            ],
                            [
                                78.95592,
                                34.38783
                            ],
                            [
                                78.88063,
                                34.36389
                            ],
                            [
                                78.85274,
                                34.41395
                            ],
                            [
                                78.74311,
                                34.45456
                            ],
                            [
                                78.70688,
                                34.52325
                            ],
                            [
                                78.64813,
                                34.53908
                            ],
                            [
                                78.56101,
                                34.51657
                            ],
                            [
                                78.54066,
                                34.57618
                            ],
                            [
                                78.28302,
                                34.62272
                            ],
                            [
                                78.25658,
                                34.71173
                            ],
                            [
                                78.21336,
                                34.71857
                            ],
                            [
                                78.23549,
                                34.88079
                            ],
                            [
                                78.18056,
                                34.93874
                            ],
                            [
                                78.18879,
                                34.98351
                            ],
                            [
                                78.12138,
                                35.03706
                            ],
                            [
                                78.12041,
                                35.10892
                            ],
                            [
                                78.0601,
                                35.11695
                            ],
                            [
                                78.05682,
                                35.18288
                            ],
                            [
                                78.01206,
                                35.23813
                            ],
                            [
                                78.01143,
                                35.36638
                            ],
                            [
                                78.10351,
                                35.43737
                            ],
                            [
                                78.13445,
                                35.49538
                            ],
                            [
                                78.00638,
                                35.49209
                            ],
                            [
                                77.91373,
                                35.46861
                            ],
                            [
                                77.85326,
                                35.48962
                            ],
                            [
                                77.823537740956311,
                                35.511491664893249
                            ],
                            [
                                77.557034615450874,
                                35.292578383228069
                            ],
                            [
                                77.110198130932531,
                                35.039371042001008
                            ],
                            [
                                77.035725383512812,
                                35.024476492517067
                            ],
                            [
                                77.005936284544916,
                                34.9351091956134
                            ],
                            [
                                76.901674438157315,
                                34.964898294581289
                            ],
                            [
                                76.782518042285744,
                                34.920214646129452
                            ],
                            [
                                76.708045294866025,
                                34.756374601806066
                            ],
                            [
                                76.559099800026587,
                                34.756374601806066
                            ],
                            [
                                76.484627052606854,
                                34.801058250257896
                            ],
                            [
                                76.156946963960081,
                                34.637218205934509
                            ],
                            [
                                76.097368766024303,
                                34.681901854386339
                            ],
                            [
                                75.784583226861457,
                                34.532956359546894
                            ],
                            [
                                75.382430390794966,
                                34.547850909030842
                            ],
                            [
                                75.293063093891291,
                                34.65211275541845
                            ],
                            [
                                75.129223049567898,
                                34.681901854386339
                            ],
                            [
                                75.084539401116061,
                                34.637218205934509
                            ],
                            [
                                74.920699356792682,
                                34.681901854386339
                            ],
                            [
                                74.712175664017451,
                                34.696796403870287
                            ],
                            [
                                74.593019268145895,
                                34.756374601806066
                            ],
                            [
                                74.369601025886723,
                                34.801058250257896
                            ],
                            [
                                74.161077333111507,
                                34.696796403870287
                            ],
                            [
                                73.967448189820217,
                                34.711690953354228
                            ],
                            [
                                73.967448189820217,
                                34.592534557482672
                            ],
                            [
                                73.892975442400498,
                                34.547850909030842
                            ],
                            [
                                73.878080892916557,
                                34.488272711095057
                            ],
                            [
                                73.803608145496838,
                                34.443589062643227
                            ],
                            [
                                73.773819046528942,
                                34.35422176573956
                            ],
                            [
                                73.892975442400498,
                                34.369116315223501
                            ],
                            [
                                73.967448189820217,
                                34.264854468835892
                            ],
                            [
                                73.878080892916557,
                                34.07122532554461
                            ],
                            [
                                74.027026387755996,
                                34.011647127608832
                            ],
                            [
                                74.11639368465967,
                                34.041436226576721
                            ],
                            [
                                74.220655531047285,
                                34.02654167709278
                            ],
                            [
                                74.250444630015167,
                                33.922279830705165
                            ],
                            [
                                74.161077333111507,
                                33.847807083285446
                            ],
                            [
                                74.086604585691774,
                                33.832912533801498
                            ],
                            [
                                73.967448189820217,
                                33.758439786381771
                            ],
                            [
                                74.027026387755996,
                                33.594599742058385
                            ],
                            [
                                74.11639368465967,
                                33.564810643090496
                            ],
                            [
                                74.190866432079389,
                                33.460548796702881
                            ],
                            [
                                74.161077333111507,
                                33.326497851347384
                            ],
                            [
                                74.086604585691774,
                                33.266919653411605
                            ],
                            [
                                74.027026387755996,
                                33.266919653411605
                            ],
                            [
                                74.012131838272055,
                                33.207341455475827
                            ],
                            [
                                74.146182783627552,
                                33.147763257540049
                            ],
                            [
                                74.20576098156333,
                                33.043501411152434
                            ],
                            [
                                74.339811926918841,
                                33.013712312184545
                            ],
                            [
                                74.310022827950945,
                                32.90945046579693
                            ],
                            [
                                74.399390124854619,
                                32.924345015280878
                            ],
                            [
                                74.45725561909687,
                                32.791915165784467
                            ],
                            [
                                74.4611,
                                32.79057
                            ],
                            [
                                74.53112,
                                32.74211
                            ],
                            [
                                74.61303,
                                32.75829
                            ],
                            [
                                74.64128,
                                32.82104
                            ],
                            [
                                74.69509,
                                32.81143
                            ],
                            [
                                74.65079,
                                32.71894
                            ],
                            [
                                74.67532,
                                32.65785
                            ],
                            [
                                74.64267,
                                32.60846
                            ],
                            [
                                74.70237,
                                32.48456
                            ],
                            [
                                74.81924,
                                32.49541
                            ],
                            [
                                74.97647,
                                32.44818
                            ],
                            [
                                75.03071,
                                32.491
                            ],
                            [
                                75.08532,
                                32.47736
                            ],
                            [
                                75.13288,
                                32.41849
                            ],
                            [
                                75.18717,
                                32.42383
                            ],
                            [
                                75.32601,
                                32.3346
                            ],
                            [
                                75.38074,
                                32.26454
                            ],
                            [
                                75.31355,
                                32.15883
                            ],
                            [
                                75.23944,
                                32.08751
                            ],
                            [
                                75.12763,
                                32.07366
                            ],
                            [
                                75.00416,
                                32.02887
                            ],
                            [
                                74.92129,
                                32.05656
                            ],
                            [
                                74.83143,
                                31.9989
                            ],
                            [
                                74.80422,
                                31.94699
                            ],
                            [
                                74.70166,
                                31.92398
                            ],
                            [
                                74.57231,
                                31.82308
                            ],
                            [
                                74.51771,
                                31.72253
                            ],
                            [
                                74.57921,
                                31.6218
                            ],
                            [
                                74.64073,
                                31.46536
                            ],
                            [
                                74.55102,
                                31.29634
                            ],
                            [
                                74.53389,
                                31.19423
                            ],
                            [
                                74.54599,
                                31.13317
                            ],
                            [
                                74.67176,
                                31.09967
                            ],
                            [
                                74.61792,
                                31.02749
                            ],
                            [
                                74.47126,
                                30.96591
                            ],
                            [
                                74.4163,
                                30.90713
                            ],
                            [
                                74.32103,
                                30.84428
                            ],
                            [
                                74.28146,
                                30.73101
                            ],
                            [
                                74.23214,
                                30.71912
                            ],
                            [
                                74.18693,
                                30.66057
                            ],
                            [
                                74.1035,
                                30.61167
                            ],
                            [
                                74.09661,
                                30.56479
                            ],
                            [
                                73.98218,
                                30.49883
                            ],
                            [
                                73.87575,
                                30.3617
                            ],
                            [
                                73.9442,
                                30.30462
                            ],
                            [
                                73.96365,
                                30.19016
                            ],
                            [
                                73.80228,
                                30.06934
                            ],
                            [
                                73.61714,
                                30.02217
                            ],
                            [
                                73.39724,
                                29.93917
                            ],
                            [
                                73.27232,
                                29.55188
                            ],
                            [
                                73.09641,
                                29.25581
                            ],
                            [
                                73.00172,
                                29.1513
                            ],
                            [
                                72.94406,
                                29.03464
                            ],
                            [
                                72.7309,
                                28.95025
                            ],
                            [
                                72.47587,
                                28.80734
                            ],
                            [
                                72.41169,
                                28.78562
                            ],
                            [
                                72.30173,
                                28.66343
                            ],
                            [
                                72.21011,
                                28.40363
                            ],
                            [
                                72.18553,
                                28.36029
                            ],
                            [
                                71.99276,
                                28.20398
                            ],
                            [
                                71.92325,
                                28.11508
                            ],
                            [
                                71.89978,
                                27.96663
                            ],
                            [
                                71.67419,
                                27.88555
                            ],
                            [
                                71.35287,
                                27.86605
                            ],
                            [
                                71.21782,
                                27.8414
                            ],
                            [
                                70.88874,
                                27.70666
                            ],
                            [
                                70.75716,
                                27.71835
                            ],
                            [
                                70.67896,
                                27.83826
                            ],
                            [
                                70.67067,
                                27.91628
                            ],
                            [
                                70.5624,
                                28.01963
                            ],
                            [
                                70.47678,
                                28.03322
                            ],
                            [
                                70.36786,
                                28.00851
                            ],
                            [
                                70.20763,
                                27.88511
                            ],
                            [
                                70.1076,
                                27.76614
                            ],
                            [
                                70.0163,
                                27.5565
                            ],
                            [
                                69.9371,
                                27.50251
                            ],
                            [
                                69.86183,
                                27.4029
                            ],
                            [
                                69.66524,
                                27.25074
                            ],
                            [
                                69.57723,
                                27.1635
                            ],
                            [
                                69.5133,
                                27.01639
                            ],
                            [
                                69.48395,
                                26.80734
                            ],
                            [
                                69.51711,
                                26.73916
                            ],
                            [
                                69.699,
                                26.66495
                            ],
                            [
                                69.77206,
                                26.61368
                            ],
                            [
                                69.85542,
                                26.58295
                            ],
                            [
                                70.02492,
                                26.59871
                            ],
                            [
                                70.10695,
                                26.58948
                            ],
                            [
                                70.16784,
                                26.55043
                            ],
                            [
                                70.18388,
                                26.48691
                            ],
                            [
                                70.17264,
                                26.24502
                            ],
                            [
                                70.14528,
                                26.16633
                            ],
                            [
                                70.08071,
                                26.05858
                            ],
                            [
                                70.09131,
                                25.96519
                            ],
                            [
                                70.1451,
                                25.86846
                            ],
                            [
                                70.22511,
                                25.79242
                            ],
                            [
                                70.2755,
                                25.7113
                            ],
                            [
                                70.37449,
                                25.68133
                            ],
                            [
                                70.52651,
                                25.68856
                            ],
                            [
                                70.63984,
                                25.71545
                            ],
                            [
                                70.67241,
                                25.66128
                            ],
                            [
                                70.6659,
                                25.39603
                            ],
                            [
                                70.73709,
                                25.32581
                            ],
                            [
                                70.7526,
                                25.27163
                            ],
                            [
                                70.88117,
                                25.14603
                            ],
                            [
                                70.91786,
                                24.98666
                            ],
                            [
                                70.96257,
                                24.88726
                            ],
                            [
                                71.08603,
                                24.69326
                            ],
                            [
                                70.99048,
                                24.60555
                            ],
                            [
                                70.9944,
                                24.47477
                            ],
                            [
                                71.02195,
                                24.43352
                            ],
                            [
                                71.0924,
                                24.4357
                            ],
                            [
                                71.051,
                                24.36302
                            ],
                            [
                                70.98087,
                                24.36332
                            ],
                            [
                                70.87274,
                                24.30493
                            ],
                            [
                                70.89918,
                                24.26119
                            ],
                            [
                                70.99794,
                                24.21604
                            ],
                            [
                                71.03175,
                                24.26691
                            ],
                            [
                                71.15183,
                                24.2114
                            ],
                            [
                                71.12025,
                                24.12549
                            ],
                            [
                                71.21602,
                                24.11649
                            ],
                            [
                                71.25849,
                                24.05723
                            ],
                            [
                                71.26727,
                                23.99676
                            ],
                            [
                                71.09821,
                                23.90889
                            ],
                            [
                                71.04289,
                                23.79663
                            ],
                            [
                                71.07296,
                                23.68407
                            ],
                            [
                                71.05432,
                                23.62527
                            ],
                            [
                                71.1782,
                                23.60123
                            ],
                            [
                                71.2972,
                                23.53861
                            ],
                            [
                                71.23737,
                                23.43736
                            ],
                            [
                                71.27602,
                                23.34208
                            ],
                            [
                                71.35068,
                                23.31833
                            ],
                            [
                                71.23152,
                                23.24991
                            ],
                            [
                                71.23925,
                                23.16069
                            ],
                            [
                                71.10603,
                                23.21939
                            ],
                            [
                                71.04313,
                                23.17391
                            ],
                            [
                                70.95482,
                                23.14585
                            ],
                            [
                                70.89706,
                                23.15794
                            ],
                            [
                                70.85714,
                                23.12366
                            ],
                            [
                                70.72132,
                                23.18815
                            ],
                            [
                                70.69537,
                                23.1313
                            ],
                            [
                                70.60934,
                                23.08257
                            ],
                            [
                                70.48958,
                                22.91871
                            ],
                            [
                                70.46403,
                                22.82485
                            ],
                            [
                                70.38211,
                                22.76609
                            ],
                            [
                                70.3784,
                                22.72445
                            ],
                            [
                                70.28348,
                                22.71987
                            ],
                            [
                                70.20224,
                                22.61587
                            ],
                            [
                                70.17218,
                                22.5438
                            ],
                            [
                                70.09974,
                                22.54285
                            ],
                            [
                                69.9191,
                                22.48469
                            ],
                            [
                                69.81075,
                                22.40071
                            ],
                            [
                                69.7041,
                                22.41669
                            ],
                            [
                                69.57779,
                                22.31215
                            ],
                            [
                                69.5145,
                                22.36828
                            ],
                            [
                                69.46524,
                                22.30306
                            ],
                            [
                                69.34602,
                                22.29967
                            ],
                            [
                                69.26949,
                                22.25608
                            ],
                            [
                                69.19274,
                                22.2526
                            ],
                            [
                                69.16034,
                                22.31351
                            ],
                            [
                                69.1919,
                                22.41745
                            ],
                            [
                                69.07795,
                                22.38907
                            ],
                            [
                                69.01102,
                                22.44129
                            ],
                            [
                                68.93763,
                                22.30968
                            ],
                            [
                                68.95802,
                                22.24063
                            ],
                            [
                                69.0514,
                                22.13319
                            ],
                            [
                                69.28068,
                                21.89759
                            ],
                            [
                                69.5714,
                                21.6476
                            ],
                            [
                                69.61138,
                                21.6287
                            ],
                            [
                                69.70874,
                                21.53359
                            ],
                            [
                                70.0639,
                                21.14056
                            ],
                            [
                                70.26262,
                                20.97016
                            ],
                            [
                                70.44456,
                                20.85137
                            ],
                            [
                                70.5927,
                                20.78097
                            ],
                            [
                                70.82553,
                                20.69348
                            ],
                            [
                                70.92724,
                                20.74514
                            ],
                            [
                                71.06643,
                                20.73631
                            ],
                            [
                                71.38339,
                                20.87222
                            ],
                            [
                                71.46546,
                                20.88502
                            ],
                            [
                                71.57009,
                                20.99579
                            ],
                            [
                                71.65017,
                                20.99282
                            ],
                            [
                                71.76765,
                                21.02728
                            ],
                            [
                                71.81429,
                                21.06687
                            ],
                            [
                                71.97184,
                                21.12747
                            ],
                            [
                                72.10316,
                                21.19993
                            ],
                            [
                                72.08444,
                                21.24569
                            ],
                            [
                                72.11905,
                                21.32037
                            ],
                            [
                                72.22293,
                                21.4398
                            ],
                            [
                                72.29974,
                                21.64432
                            ],
                            [
                                72.25557,
                                21.7348
                            ],
                            [
                                72.25518,
                                21.87415
                            ],
                            [
                                72.21026,
                                21.94151
                            ],
                            [
                                72.10322,
                                21.92244
                            ],
                            [
                                72.10251,
                                21.99673
                            ],
                            [
                                72.15,
                                22.04869
                            ],
                            [
                                72.20511,
                                22.0452
                            ],
                            [
                                72.24837,
                                22.1297
                            ],
                            [
                                72.29086,
                                22.1506
                            ],
                            [
                                72.30081,
                                22.22409
                            ],
                            [
                                72.41772,
                                22.27983
                            ],
                            [
                                72.48392,
                                22.33066
                            ],
                            [
                                72.5702,
                                22.34979
                            ],
                            [
                                72.67651,
                                22.25741
                            ],
                            [
                                72.75263,
                                22.23625
                            ],
                            [
                                72.75256,
                                22.17697
                            ],
                            [
                                72.64251,
                                22.21527
                            ],
                            [
                                72.55882,
                                22.16804
                            ],
                            [
                                72.52268,
                                22.04684
                            ],
                            [
                                72.51051,
                                21.91568
                            ],
                            [
                                72.61526,
                                21.86509
                            ],
                            [
                                72.56546,
                                21.8047
                            ],
                            [
                                72.52722,
                                21.70353
                            ],
                            [
                                72.60448,
                                21.67981
                            ],
                            [
                                72.73756,
                                21.68709
                            ],
                            [
                                72.61522,
                                21.58404
                            ],
                            [
                                72.64085,
                                21.54301
                            ],
                            [
                                72.70866,
                                21.53812
                            ],
                            [
                                72.65695,
                                21.46372
                            ],
                            [
                                72.60325,
                                21.30742
                            ],
                            [
                                72.62336,
                                21.20159
                            ],
                            [
                                72.62321,
                                21.09768
                            ],
                            [
                                72.71631,
                                21.07719
                            ],
                            [
                                72.7514,
                                20.95364
                            ],
                            [
                                72.83607,
                                20.81239
                            ],
                            [
                                72.88236,
                                20.80002
                            ],
                            [
                                72.86066,
                                20.7109
                            ],
                            [
                                72.89206,
                                20.61929
                            ],
                            [
                                72.90183,
                                20.53079
                            ],
                            [
                                72.83523,
                                20.44645
                            ],
                            [
                                72.81903,
                                20.36937
                            ],
                            [
                                72.78521,
                                20.34254
                            ],
                            [
                                72.74446,
                                20.24519
                            ],
                            [
                                72.73893,
                                20.12148
                            ],
                            [
                                72.71109,
                                20.06855
                            ],
                            [
                                72.72616,
                                19.96269
                            ],
                            [
                                72.6727,
                                19.93692
                            ],
                            [
                                72.65757,
                                19.83515
                            ],
                            [
                                72.70431,
                                19.74125
                            ],
                            [
                                72.73704,
                                19.59519
                            ],
                            [
                                72.72864,
                                19.53495
                            ],
                            [
                                72.79259,
                                19.48929
                            ],
                            [
                                72.749,
                                19.44933
                            ],
                            [
                                72.78854,
                                19.30117
                            ],
                            [
                                72.78471,
                                19.15543
                            ],
                            [
                                72.81942,
                                19.11325
                            ],
                            [
                                72.81229,
                                18.9496
                            ],
                            [
                                72.86532,
                                18.99838
                            ],
                            [
                                72.90793,
                                18.99766
                            ],
                            [
                                72.95878,
                                19.04675
                            ],
                            [
                                73.01373,
                                18.97823
                            ],
                            [
                                72.95658,
                                18.96467
                            ],
                            [
                                72.93178,
                                18.85401
                            ],
                            [
                                72.99023,
                                18.85314
                            ],
                            [
                                73.00585,
                                18.79477
                            ],
                            [
                                72.87062,
                                18.79674
                            ],
                            [
                                72.8583,
                                18.68948
                            ],
                            [
                                72.92485,
                                18.54912
                            ],
                            [
                                72.89711,
                                18.46275
                            ],
                            [
                                72.91868,
                                18.35461
                            ],
                            [
                                72.99035,
                                18.28222
                            ],
                            [
                                73.05636,
                                18.28363
                            ],
                            [
                                73.05743,
                                18.21495
                            ],
                            [
                                72.97954,
                                18.2482
                            ],
                            [
                                72.9764,
                                18.12332
                            ],
                            [
                                73.03625,
                                17.94225
                            ],
                            [
                                73.08456,
                                17.85392
                            ],
                            [
                                73.13025,
                                17.72615
                            ],
                            [
                                73.11785,
                                17.68363
                            ],
                            [
                                73.16394,
                                17.58309
                            ],
                            [
                                73.20905,
                                17.37549
                            ],
                            [
                                73.23738,
                                17.30975
                            ],
                            [
                                73.19649,
                                17.29317
                            ],
                            [
                                73.23932,
                                17.22477
                            ],
                            [
                                73.3002,
                                16.98188
                            ],
                            [
                                73.28217,
                                16.90364
                            ],
                            [
                                73.31264,
                                16.79902
                            ],
                            [
                                73.32854,
                                16.67695
                            ],
                            [
                                73.31562,
                                16.52956
                            ],
                            [
                                73.37681,
                                16.38344
                            ],
                            [
                                73.45512,
                                16.13707
                            ],
                            [
                                73.46159,
                                16.05785
                            ],
                            [
                                73.50919,
                                15.94627
                            ],
                            [
                                73.58649,
                                15.90356
                            ],
                            [
                                73.65456,
                                15.78937
                            ],
                            [
                                73.7363,
                                15.60083
                            ],
                            [
                                73.76909,
                                15.49876
                            ],
                            [
                                73.8457,
                                15.44849
                            ],
                            [
                                73.81777,
                                15.3754
                            ],
                            [
                                73.87355,
                                15.36373
                            ],
                            [
                                73.9144,
                                15.26879
                            ],
                            [
                                73.94413,
                                15.15508
                            ],
                            [
                                73.92332,
                                15.08805
                            ],
                            [
                                74.0383,
                                14.98841
                            ],
                            [
                                74.04773,
                                14.92104
                            ],
                            [
                                74.09225,
                                14.8948
                            ],
                            [
                                74.12063,
                                14.77972
                            ],
                            [
                                74.20044,
                                14.7248
                            ],
                            [
                                74.2572,
                                14.72337
                            ],
                            [
                                74.2782,
                                14.61902
                            ],
                            [
                                74.31515,
                                14.52668
                            ],
                            [
                                74.35382,
                                14.51389
                            ],
                            [
                                74.3963,
                                14.40133
                            ],
                            [
                                74.44506,
                                14.22107
                            ],
                            [
                                74.46924,
                                14.18247
                            ],
                            [
                                74.51232,
                                13.99507
                            ],
                            [
                                74.57603,
                                13.93232
                            ],
                            [
                                74.60592,
                                13.87035
                            ],
                            [
                                74.67065,
                                13.61922
                            ],
                            [
                                74.69534,
                                13.41924
                            ],
                            [
                                74.82383,
                                12.85086
                            ],
                            [
                                74.97966,
                                12.48824
                            ],
                            [
                                75.04222,
                                12.38146
                            ],
                            [
                                75.19902,
                                12.01506
                            ],
                            [
                                75.24634,
                                12.00778
                            ],
                            [
                                75.35663,
                                11.86197
                            ],
                            [
                                75.38389,
                                11.85325
                            ],
                            [
                                75.5276,
                                11.70492
                            ],
                            [
                                75.61951,
                                11.47919
                            ],
                            [
                                75.67972,
                                11.448
                            ],
                            [
                                75.71669,
                                11.38838
                            ],
                            [
                                75.79805,
                                11.17247
                            ],
                            [
                                75.83235,
                                11.10543
                            ],
                            [
                                75.91395,
                                10.78308
                            ],
                            [
                                75.99909,
                                10.58654
                            ],
                            [
                                76.06443,
                                10.45804
                            ],
                            [
                                76.12086,
                                10.31593
                            ],
                            [
                                76.22293,
                                9.98665
                            ],
                            [
                                76.24484,
                                9.96372
                            ],
                            [
                                76.28128,
                                9.76282
                            ],
                            [
                                76.29635,
                                9.61362
                            ],
                            [
                                76.32687,
                                9.45349
                            ],
                            [
                                76.35647,
                                9.36858
                            ],
                            [
                                76.51482,
                                9.02286
                            ],
                            [
                                76.54833,
                                8.90435
                            ],
                            [
                                76.61127,
                                8.85664
                            ],
                            [
                                76.70213,
                                8.73665
                            ],
                            [
                                76.95215,
                                8.43118
                            ],
                            [
                                76.98009,
                                8.38501
                            ],
                            [
                                77.31424,
                                8.12683
                            ],
                            [
                                77.53126,
                                8.07977
                            ],
                            [
                                77.58217,
                                8.13679
                            ],
                            [
                                77.70868,
                                8.16607
                            ],
                            [
                                77.80597,
                                8.23939
                            ],
                            [
                                77.87574,
                                8.26771
                            ],
                            [
                                78.05781,
                                8.37104
                            ],
                            [
                                78.06879,
                                8.42054
                            ],
                            [
                                78.12586,
                                8.49639
                            ],
                            [
                                78.1365,
                                8.68343
                            ],
                            [
                                78.16623,
                                8.73741
                            ],
                            [
                                78.17136,
                                8.87957
                            ],
                            [
                                78.22407,
                                8.97227
                            ],
                            [
                                78.40534,
                                9.10589
                            ],
                            [
                                78.64148,
                                9.15738
                            ],
                            [
                                78.6643,
                                9.19154
                            ],
                            [
                                78.86818,
                                9.25311
                            ],
                            [
                                79.07344,
                                9.29852
                            ],
                            [
                                78.988,
                                9.35662
                            ],
                            [
                                78.90155,
                                9.48328
                            ],
                            [
                                78.93336,
                                9.59834
                            ],
                            [
                                78.99104,
                                9.70214
                            ],
                            [
                                79.11726,
                                9.85129
                            ],
                            [
                                79.1592,
                                9.93372
                            ],
                            [
                                79.25685,
                                10.03617
                            ],
                            [
                                79.23091,
                                10.0935
                            ],
                            [
                                79.24414,
                                10.17794
                            ],
                            [
                                79.27775,
                                10.24142
                            ],
                            [
                                79.38835,
                                10.31341
                            ],
                            [
                                79.5312,
                                10.32389
                            ],
                            [
                                79.70004,
                                10.32275
                            ],
                            [
                                79.77827,
                                10.28694
                            ],
                            [
                                79.87849,
                                10.30108
                            ],
                            [
                                79.86629,
                                10.42892
                            ],
                            [
                                79.85121,
                                10.74938
                            ],
                            [
                                79.85747,
                                11.1047
                            ],
                            [
                                79.83619,
                                11.35376
                            ],
                            [
                                79.76608,
                                11.53055
                            ],
                            [
                                79.76231,
                                11.6266
                            ],
                            [
                                79.8428,
                                11.96001
                            ],
                            [
                                79.88653,
                                12.06379
                            ],
                            [
                                80.03167,
                                12.29738
                            ],
                            [
                                80.15418,
                                12.46803
                            ],
                            [
                                80.25076,
                                12.77258
                            ],
                            [
                                80.26583,
                                12.967
                            ],
                            [
                                80.30129,
                                13.14335
                            ],
                            [
                                80.34575,
                                13.28828
                            ],
                            [
                                80.32474,
                                13.44398
                            ],
                            [
                                80.23786,
                                13.63927
                            ],
                            [
                                80.24935,
                                13.79342
                            ],
                            [
                                80.15027,
                                14.0359
                            ],
                            [
                                80.13203,
                                14.22024
                            ],
                            [
                                80.167,
                                14.35139
                            ],
                            [
                                80.18925,
                                14.56596
                            ],
                            [
                                80.14288,
                                14.70153
                            ],
                            [
                                80.08478,
                                14.81116
                            ],
                            [
                                80.05007,
                                15.09164
                            ],
                            [
                                80.08388,
                                15.20418
                            ],
                            [
                                80.08526,
                                15.26456
                            ],
                            [
                                80.12733,
                                15.3738
                            ],
                            [
                                80.20219,
                                15.47142
                            ],
                            [
                                80.26869,
                                15.67197
                            ],
                            [
                                80.35504,
                                15.7557
                            ],
                            [
                                80.52805,
                                15.85699
                            ],
                            [
                                80.64645,
                                15.89619
                            ],
                            [
                                80.77457,
                                15.86416
                            ],
                            [
                                80.81765,
                                15.72378
                            ],
                            [
                                80.88266,
                                15.86141
                            ],
                            [
                                80.96176,
                                15.83983
                            ],
                            [
                                81.08606,
                                15.92973
                            ],
                            [
                                81.0954,
                                16.02609
                            ],
                            [
                                81.15147,
                                16.08315
                            ],
                            [
                                81.17055,
                                16.1445
                            ],
                            [
                                81.26317,
                                16.27619
                            ],
                            [
                                81.3868,
                                16.36905
                            ],
                            [
                                81.42449,
                                16.34795
                            ],
                            [
                                81.55307,
                                16.36298
                            ],
                            [
                                81.57187,
                                16.34508
                            ],
                            [
                                81.73063,
                                16.31622
                            ],
                            [
                                81.84978,
                                16.37127
                            ],
                            [
                                81.95693,
                                16.40168
                            ],
                            [
                                82.21094,
                                16.54059
                            ],
                            [
                                82.28795,
                                16.67141
                            ],
                            [
                                82.29704,
                                16.7755
                            ],
                            [
                                82.23984,
                                16.82586
                            ],
                            [
                                82.24493,
                                16.9074
                            ],
                            [
                                82.2971,
                                17.02672
                            ],
                            [
                                82.44844,
                                17.17828
                            ],
                            [
                                82.59574,
                                17.28316
                            ],
                            [
                                82.7605,
                                17.36968
                            ],
                            [
                                82.97973,
                                17.46803
                            ],
                            [
                                83.02637,
                                17.5083
                            ],
                            [
                                83.21155,
                                17.59229
                            ],
                            [
                                83.33947,
                                17.72414
                            ],
                            [
                                83.41025,
                                17.81496
                            ],
                            [
                                83.45703,
                                17.90165
                            ],
                            [
                                83.53335,
                                17.95469
                            ],
                            [
                                83.57862,
                                18.01675
                            ],
                            [
                                83.74115,
                                18.12334
                            ],
                            [
                                83.96326,
                                18.2227
                            ],
                            [
                                84.12212,
                                18.31001
                            ],
                            [
                                84.1579,
                                18.38008
                            ],
                            [
                                84.34758,
                                18.55078
                            ],
                            [
                                84.49439,
                                18.74159
                            ],
                            [
                                84.54677,
                                18.7881
                            ],
                            [
                                84.59574,
                                18.87919
                            ],
                            [
                                84.68385,
                                18.9694
                            ],
                            [
                                84.80634,
                                19.14959
                            ],
                            [
                                84.86821,
                                19.22016
                            ],
                            [
                                84.98739,
                                19.3189
                            ],
                            [
                                85.07611,
                                19.37547
                            ],
                            [
                                85.11424,
                                19.42112
                            ],
                            [
                                85.35632,
                                19.58966
                            ],
                            [
                                85.66843,
                                19.74121
                            ],
                            [
                                85.79775,
                                19.78582
                            ],
                            [
                                86.0563,
                                19.85027
                            ],
                            [
                                86.20993,
                                19.89571
                            ],
                            [
                                86.35586,
                                19.9545
                            ],
                            [
                                86.41891,
                                20.04781
                            ],
                            [
                                86.53641,
                                20.18122
                            ],
                            [
                                86.66588,
                                20.25639
                            ],
                            [
                                86.77109,
                                20.33369
                            ],
                            [
                                86.77638,
                                20.3874
                            ],
                            [
                                86.73153,
                                20.40978
                            ],
                            [
                                86.74581,
                                20.51759
                            ],
                            [
                                86.79825,
                                20.54332
                            ],
                            [
                                87.01962,
                                20.69682
                            ],
                            [
                                86.96547,
                                20.80849
                            ],
                            [
                                86.95752,
                                20.86398
                            ],
                            [
                                86.82125,
                                21.14119
                            ],
                            [
                                86.8352,
                                21.21905
                            ],
                            [
                                86.89476,
                                21.31521
                            ],
                            [
                                86.98044,
                                21.40764
                            ],
                            [
                                87.11918,
                                21.51437
                            ],
                            [
                                87.21111,
                                21.54612
                            ],
                            [
                                87.35755,
                                21.54958
                            ],
                            [
                                87.38702,
                                21.57429
                            ],
                            [
                                87.55047,
                                21.63316
                            ],
                            [
                                87.67944,
                                21.65501
                            ],
                            [
                                87.78755,
                                21.69532
                            ],
                            [
                                87.97485,
                                21.86192
                            ],
                            [
                                88.05303,
                                22.01207
                            ],
                            [
                                88.22392,
                                22.0897
                            ],
                            [
                                88.20587,
                                22.02066
                            ],
                            [
                                88.1595,
                                21.95566
                            ],
                            [
                                88.16767,
                                21.87754
                            ],
                            [
                                88.2195,
                                21.76797
                            ],
                            [
                                88.18398,
                                21.68171
                            ],
                            [
                                88.2043,
                                21.61325
                            ],
                            [
                                88.28579,
                                21.611
                            ],
                            [
                                88.28977,
                                21.71659
                            ],
                            [
                                88.38564,
                                21.68405
                            ],
                            [
                                88.3887,
                                21.62607
                            ],
                            [
                                88.45338,
                                21.62652
                            ],
                            [
                                88.47287,
                                21.78665
                            ],
                            [
                                88.60792,
                                21.92541
                            ],
                            [
                                88.60905,
                                22.00856
                            ],
                            [
                                88.64257,
                                22.02747
                            ],
                            [
                                88.70341,
                                22.01007
                            ],
                            [
                                88.79701,
                                22.03215
                            ],
                            [
                                88.87957,
                                22.01769
                            ],
                            [
                                88.88642,
                                22.06119
                            ],
                            [
                                88.96642,
                                22.08007
                            ],
                            [
                                88.98386,
                                22.12404
                            ],
                            [
                                88.961,
                                22.1874
                            ],
                            [
                                89.07635,
                                22.19867
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                69.92272,
                                22.88364
                            ],
                            [
                                70.11186,
                                22.92805
                            ],
                            [
                                70.10801,
                                22.97706
                            ],
                            [
                                70.16917,
                                23.05725
                            ],
                            [
                                70.25956,
                                23.16345
                            ],
                            [
                                70.33084,
                                23.19132
                            ],
                            [
                                70.42909,
                                23.20123
                            ],
                            [
                                70.50652,
                                23.17336
                            ],
                            [
                                70.62484,
                                23.17952
                            ],
                            [
                                70.66579,
                                23.21216
                            ],
                            [
                                70.73437,
                                23.20823
                            ],
                            [
                                70.81975,
                                23.27974
                            ],
                            [
                                70.82611,
                                23.33578
                            ],
                            [
                                70.89049,
                                23.36991
                            ],
                            [
                                70.98317,
                                23.37919
                            ],
                            [
                                71.03675,
                                23.44541
                            ],
                            [
                                71.11659,
                                23.43637
                            ],
                            [
                                71.07005,
                                23.56238
                            ],
                            [
                                70.96692,
                                23.71985
                            ],
                            [
                                70.86351,
                                23.74952
                            ],
                            [
                                70.91928,
                                23.83038
                            ],
                            [
                                70.91492,
                                23.86797
                            ],
                            [
                                70.62611,
                                23.95377
                            ],
                            [
                                70.55061,
                                23.93304
                            ],
                            [
                                70.57192,
                                23.84996
                            ],
                            [
                                70.62657,
                                23.80966
                            ],
                            [
                                70.61435,
                                23.74008
                            ],
                            [
                                70.55706,
                                23.76397
                            ],
                            [
                                70.52457,
                                23.67778
                            ],
                            [
                                70.47131,
                                23.6796
                            ],
                            [
                                70.43466,
                                23.63254
                            ],
                            [
                                70.29231,
                                23.5666
                            ],
                            [
                                70.21086,
                                23.46434
                            ],
                            [
                                70.1664,
                                23.50829
                            ],
                            [
                                70.1084,
                                23.46964
                            ],
                            [
                                70.04621,
                                23.6002
                            ],
                            [
                                69.98726,
                                23.58394
                            ],
                            [
                                69.91571,
                                23.6053
                            ],
                            [
                                69.90207,
                                23.6933
                            ],
                            [
                                69.96591,
                                23.74264
                            ],
                            [
                                69.93877,
                                23.81899
                            ],
                            [
                                69.96948,
                                23.87857
                            ],
                            [
                                69.935,
                                23.92528
                            ],
                            [
                                69.78221,
                                23.98072
                            ],
                            [
                                69.70275,
                                23.93943
                            ],
                            [
                                69.66219,
                                23.85559
                            ],
                            [
                                69.7064,
                                23.8273
                            ],
                            [
                                69.69179,
                                23.74966
                            ],
                            [
                                69.60144,
                                23.76094
                            ],
                            [
                                69.54868,
                                23.8228
                            ],
                            [
                                69.46181,
                                23.83383
                            ],
                            [
                                69.38419,
                                23.79221
                            ],
                            [
                                69.32398,
                                23.86917
                            ],
                            [
                                69.22541,
                                23.85496
                            ],
                            [
                                69.16926,
                                23.82656
                            ],
                            [
                                69.02031,
                                23.80493
                            ],
                            [
                                68.97644,
                                23.7817
                            ],
                            [
                                68.90288,
                                23.81595
                            ],
                            [
                                68.73199,
                                23.82909
                            ],
                            [
                                68.65933,
                                23.79685
                            ],
                            [
                                68.63833,
                                23.74782
                            ],
                            [
                                68.52934,
                                23.68217
                            ],
                            [
                                68.49433,
                                23.59751
                            ],
                            [
                                68.50273,
                                23.47917
                            ],
                            [
                                68.62705,
                                23.34822
                            ],
                            [
                                68.66859,
                                23.28558
                            ],
                            [
                                68.64568,
                                23.19247
                            ],
                            [
                                68.70969,
                                23.14988
                            ],
                            [
                                68.75711,
                                23.08462
                            ],
                            [
                                69.045,
                                22.92866
                            ],
                            [
                                69.19561,
                                22.83906
                            ],
                            [
                                69.31116,
                                22.83144
                            ],
                            [
                                69.45053,
                                22.77718
                            ],
                            [
                                69.53751,
                                22.78369
                            ],
                            [
                                69.70086,
                                22.7365
                            ],
                            [
                                69.76326,
                                22.82051
                            ],
                            [
                                69.92272,
                                22.88364
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                92.71254,
                                11.64981
                            ],
                            [
                                92.75468,
                                11.7129
                            ],
                            [
                                92.78406,
                                11.85514
                            ],
                            [
                                92.78424,
                                11.9265
                            ],
                            [
                                92.71862,
                                11.95166
                            ],
                            [
                                92.76267,
                                12.0616
                            ],
                            [
                                92.82483,
                                12.15804
                            ],
                            [
                                92.87433,
                                12.20114
                            ],
                            [
                                92.8849,
                                12.34515
                            ],
                            [
                                92.83847,
                                12.42071
                            ],
                            [
                                92.90005,
                                12.42617
                            ],
                            [
                                92.95083,
                                12.4669
                            ],
                            [
                                92.97277,
                                12.54473
                            ],
                            [
                                92.95752,
                                12.61536
                            ],
                            [
                                92.97207,
                                12.71703
                            ],
                            [
                                92.93867,
                                12.77712
                            ],
                            [
                                92.945,
                                12.83219
                            ],
                            [
                                92.88015,
                                12.9674
                            ],
                            [
                                93.03138,
                                13.08354
                            ],
                            [
                                93.03528,
                                13.18429
                            ],
                            [
                                93.05799,
                                13.25831
                            ],
                            [
                                92.97217,
                                13.32664
                            ],
                            [
                                93.0381,
                                13.35549
                            ],
                            [
                                93.04216,
                                13.52043
                            ],
                            [
                                93.02313,
                                13.5681
                            ],
                            [
                                92.92969,
                                13.53842
                            ],
                            [
                                92.8458,
                                13.40334
                            ],
                            [
                                92.79659,
                                13.07567
                            ],
                            [
                                92.79005,
                                12.87076
                            ],
                            [
                                92.69737,
                                12.79899
                            ],
                            [
                                92.73917,
                                12.72967
                            ],
                            [
                                92.74739,
                                12.66278
                            ],
                            [
                                92.70354,
                                12.61452
                            ],
                            [
                                92.70285,
                                12.33371
                            ],
                            [
                                92.76567,
                                12.30182
                            ],
                            [
                                92.75182,
                                12.24155
                            ],
                            [
                                92.65476,
                                12.19441
                            ],
                            [
                                92.58792,
                                11.88982
                            ],
                            [
                                92.52736,
                                11.89055
                            ],
                            [
                                92.55671,
                                11.77244
                            ],
                            [
                                92.58985,
                                11.71014
                            ],
                            [
                                92.61797,
                                11.56599
                            ],
                            [
                                92.65303,
                                11.51971
                            ],
                            [
                                92.72395,
                                11.5147
                            ],
                            [
                                92.74991,
                                11.60957
                            ],
                            [
                                92.71254,
                                11.64981
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                68.88792,
                                24.26189
                            ],
                            [
                                69.00874,
                                24.20385
                            ],
                            [
                                69.00233,
                                24.17271
                            ],
                            [
                                69.08516,
                                24.12911
                            ],
                            [
                                69.22974,
                                24.13966
                            ],
                            [
                                69.32131,
                                24.04444
                            ],
                            [
                                69.37951,
                                24.00944
                            ],
                            [
                                69.50034,
                                23.98096
                            ],
                            [
                                69.57503,
                                24.01961
                            ],
                            [
                                69.62026,
                                23.99168
                            ],
                            [
                                69.73033,
                                24.06264
                            ],
                            [
                                69.85307,
                                24.05109
                            ],
                            [
                                69.91231,
                                24.09552
                            ],
                            [
                                69.98817,
                                24.05427
                            ],
                            [
                                70.04238,
                                24.09576
                            ],
                            [
                                69.99969,
                                24.13122
                            ],
                            [
                                70.0622,
                                24.17202
                            ],
                            [
                                70.08288,
                                24.22552
                            ],
                            [
                                70.02418,
                                24.16941
                            ],
                            [
                                69.91251,
                                24.16421
                            ],
                            [
                                69.72605,
                                24.17516
                            ],
                            [
                                69.58931,
                                24.28644
                            ],
                            [
                                69.50203,
                                24.26298
                            ],
                            [
                                69.31004,
                                24.27665
                            ],
                            [
                                69.18811,
                                24.23639
                            ],
                            [
                                69.08508,
                                24.26808
                            ],
                            [
                                69.01284,
                                24.22898
                            ],
                            [
                                68.95822,
                                24.25881
                            ],
                            [
                                68.95753,
                                24.26084
                            ],
                            [
                                68.88792,
                                24.26189
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                93.65649,
                                7.11799
                            ],
                            [
                                93.6788,
                                7.0183
                            ],
                            [
                                93.72154,
                                6.99594
                            ],
                            [
                                93.74101,
                                6.92814
                            ],
                            [
                                93.83877,
                                6.7608
                            ],
                            [
                                93.85209,
                                6.81506
                            ],
                            [
                                93.90127,
                                6.8114
                            ],
                            [
                                93.89497,
                                6.90869
                            ],
                            [
                                93.92848,
                                6.95581
                            ],
                            [
                                93.91684,
                                7.04838
                            ],
                            [
                                93.88621,
                                7.10644
                            ],
                            [
                                93.8821,
                                7.197
                            ],
                            [
                                93.81955,
                                7.23548
                            ],
                            [
                                93.69117,
                                7.19057
                            ],
                            [
                                93.65649,
                                7.11799
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                92.37679,
                                10.77633
                            ],
                            [
                                92.38384,
                                10.67133
                            ],
                            [
                                92.41943,
                                10.61488
                            ],
                            [
                                92.38433,
                                10.54185
                            ],
                            [
                                92.52901,
                                10.51856
                            ],
                            [
                                92.56703,
                                10.57829
                            ],
                            [
                                92.54371,
                                10.62231
                            ],
                            [
                                92.59712,
                                10.69704
                            ],
                            [
                                92.55671,
                                10.86265
                            ],
                            [
                                92.51934,
                                10.89649
                            ],
                            [
                                92.45336,
                                10.86345
                            ],
                            [
                                92.4121,
                                10.78779
                            ],
                            [
                                92.37679,
                                10.77633
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                88.69758,
                                21.74508
                            ],
                            [
                                88.74711,
                                21.66174
                            ],
                            [
                                88.82193,
                                21.66636
                            ],
                            [
                                88.86314,
                                21.75563
                            ],
                            [
                                88.82324,
                                21.77882
                            ],
                            [
                                88.8377,
                                21.87701
                            ],
                            [
                                88.7993,
                                21.91695
                            ],
                            [
                                88.72319,
                                21.92732
                            ],
                            [
                                88.699,
                                21.83863
                            ],
                            [
                                88.69758,
                                21.74508
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                70.17106,
                                23.92443
                            ],
                            [
                                70.20465,
                                23.85184
                            ],
                            [
                                70.28858,
                                23.80494
                            ],
                            [
                                70.36894,
                                23.7847
                            ],
                            [
                                70.47843,
                                23.92682
                            ],
                            [
                                70.27993,
                                23.91771
                            ],
                            [
                                70.17106,
                                23.92443
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                88.9287,
                                21.95849
                            ],
                            [
                                88.99213,
                                21.90829
                            ],
                            [
                                89.06108,
                                21.93667
                            ],
                            [
                                89.07507,
                                21.99002
                            ],
                            [
                                89.03641,
                                22.05899
                            ],
                            [
                                89.0472,
                                22.12972
                            ],
                            [
                                88.93742,
                                22.05474
                            ],
                            [
                                88.9287,
                                21.95849
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                88.82391,
                                21.92264
                            ],
                            [
                                88.85048,
                                21.89249
                            ],
                            [
                                88.83691,
                                21.78394
                            ],
                            [
                                88.91352,
                                21.72681
                            ],
                            [
                                88.92444,
                                21.76473
                            ],
                            [
                                88.97128,
                                21.82146
                            ],
                            [
                                88.95404,
                                21.82666
                            ],
                            [
                                88.94787,
                                21.84022
                            ],
                            [
                                88.95268,
                                21.85464
                            ],
                            [
                                88.96963,
                                21.89722
                            ],
                            [
                                88.91922,
                                21.92331
                            ],
                            [
                                88.82391,
                                21.92264
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                88.03978,
                                21.67489
                            ],
                            [
                                88.10469,
                                21.62666
                            ],
                            [
                                88.14704,
                                21.63776
                            ],
                            [
                                88.17065,
                                21.81285
                            ],
                            [
                                88.10276,
                                21.83195
                            ],
                            [
                                88.03978,
                                21.67489
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                88.9246,
                                21.7598
                            ],
                            [
                                88.96222,
                                21.61711
                            ],
                            [
                                89.00483,
                                21.604
                            ],
                            [
                                89.08927,
                                21.6353
                            ],
                            [
                                89.08985,
                                21.66859
                            ],
                            [
                                89.02286,
                                21.75894
                            ],
                            [
                                88.9246,
                                21.7598
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                93.3116,
                                7.95505
                            ],
                            [
                                93.36923,
                                7.88407
                            ],
                            [
                                93.44752,
                                7.91558
                            ],
                            [
                                93.40875,
                                8.01704
                            ],
                            [
                                93.33996,
                                8.01436
                            ],
                            [
                                93.3116,
                                7.95505
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                88.72431,
                                21.94438
                            ],
                            [
                                88.78852,
                                21.92187
                            ],
                            [
                                88.90616,
                                21.92886
                            ],
                            [
                                88.9034,
                                22.00828
                            ],
                            [
                                88.76493,
                                22.01426
                            ],
                            [
                                88.72431,
                                21.94438
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                93.62333,
                                7.30852
                            ],
                            [
                                93.64626,
                                7.24446
                            ],
                            [
                                93.72459,
                                7.30996
                            ],
                            [
                                93.76115,
                                7.36852
                            ],
                            [
                                93.72152,
                                7.4006
                            ],
                            [
                                93.65001,
                                7.36978
                            ],
                            [
                                93.62333,
                                7.30852
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                93.45733,
                                8.16557
                            ],
                            [
                                93.48174,
                                8.08736
                            ],
                            [
                                93.54395,
                                8.20557
                            ],
                            [
                                93.45733,
                                8.16557
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                92.71838,
                                9.15893
                            ],
                            [
                                92.73149,
                                9.12327
                            ],
                            [
                                92.80291,
                                9.11995
                            ],
                            [
                                92.83139,
                                9.16256
                            ],
                            [
                                92.81423,
                                9.21952
                            ],
                            [
                                92.72009,
                                9.20831
                            ],
                            [
                                92.71838,
                                9.15893
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                88.50475,
                                21.75525
                            ],
                            [
                                88.53811,
                                21.64332
                            ],
                            [
                                88.60389,
                                21.68079
                            ],
                            [
                                88.56948,
                                21.79162
                            ],
                            [
                                88.50475,
                                21.75525
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                92.64916,
                                12.85984
                            ],
                            [
                                92.71873,
                                12.87383
                            ],
                            [
                                92.72017,
                                12.97578
                            ],
                            [
                                92.68457,
                                12.98654
                            ],
                            [
                                92.64916,
                                12.85984
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                80.86886,
                                15.81288
                            ],
                            [
                                80.93723,
                                15.71843
                            ],
                            [
                                81.00574,
                                15.75715
                            ],
                            [
                                80.87533,
                                15.84364
                            ],
                            [
                                80.86886,
                                15.81288
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                92.99594,
                                12.03435
                            ],
                            [
                                92.93559,
                                11.98625
                            ],
                            [
                                93.05337,
                                11.90221
                            ],
                            [
                                92.99594,
                                12.03435
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                70.1322,
                                22.98773
                            ],
                            [
                                70.2286,
                                22.96589
                            ],
                            [
                                70.21756,
                                23.04856
                            ],
                            [
                                70.17353,
                                23.05812
                            ],
                            [
                                70.1322,
                                22.98773
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                70.25001,
                                22.98833
                            ],
                            [
                                70.28248,
                                22.95318
                            ],
                            [
                                70.33991,
                                22.98846
                            ],
                            [
                                70.28681,
                                23.06259
                            ],
                            [
                                70.25001,
                                22.98833
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                88.94514,
                                21.78706
                            ],
                            [
                                88.97069,
                                21.77627
                            ],
                            [
                                89.02712,
                                21.82838
                            ],
                            [
                                88.97931,
                                21.86902
                            ],
                            [
                                88.95229,
                                21.8391
                            ],
                            [
                                88.97795,
                                21.82243
                            ],
                            [
                                88.97671,
                                21.80546
                            ],
                            [
                                88.94514,
                                21.78706
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                80.83172,
                                15.71199
                            ],
                            [
                                80.92775,
                                15.71995
                            ],
                            [
                                80.85993,
                                15.81226
                            ],
                            [
                                80.83172,
                                15.71199
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                93.50827,
                                7.98598
                            ],
                            [
                                93.56553,
                                7.93528
                            ],
                            [
                                93.5825,
                                7.99855
                            ],
                            [
                                93.50827,
                                7.98598
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                88.62851,
                                21.96321
                            ],
                            [
                                88.67739,
                                21.94419
                            ],
                            [
                                88.71433,
                                22.00056
                            ],
                            [
                                88.65817,
                                22.01978
                            ],
                            [
                                88.62851,
                                21.96321
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                92.2063,
                                11.53449
                            ],
                            [
                                92.27048,
                                11.52272
                            ],
                            [
                                92.27233,
                                11.58422
                            ],
                            [
                                92.2075,
                                11.58347
                            ],
                            [
                                92.2063,
                                11.53449
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "IDN",
                "Country": "Indonesia",
                "Total_3GHG": 3.65,
                "Total_3GHG_timeseries": [
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0003,
                    0.0004,
                    0.0005,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.0041,
                    0.0042,
                    0.0044,
                    0.0045,
                    0.0047,
                    0.0049,
                    0.0051,
                    0.0052,
                    0.0054,
                    0.0056,
                    0.0058,
                    0.0059,
                    0.0061,
                    0.0063,
                    0.0065,
                    0.0067,
                    0.0068,
                    0.007,
                    0.0072,
                    0.0074,
                    0.0076,
                    0.0078,
                    0.008,
                    0.0081,
                    0.0083,
                    0.0085,
                    0.0087,
                    0.0089,
                    0.0091,
                    0.0093,
                    0.0095,
                    0.0097,
                    0.0098,
                    0.01,
                    0.0102,
                    0.0104,
                    0.0106,
                    0.0108,
                    0.011,
                    0.0112,
                    0.0114,
                    0.0116,
                    0.0118,
                    0.012,
                    0.0122,
                    0.0125,
                    0.0127,
                    0.0129,
                    0.0131,
                    0.0134,
                    0.0136,
                    0.0138,
                    0.0141,
                    0.0143,
                    0.0145,
                    0.0147,
                    0.0149,
                    0.0152,
                    0.0154,
                    0.0157,
                    0.0159,
                    0.0162,
                    0.0164,
                    0.0167,
                    0.017,
                    0.0173,
                    0.0176,
                    0.0178,
                    0.0181,
                    0.0184,
                    0.0187,
                    0.019,
                    0.0192,
                    0.0195,
                    0.0198,
                    0.0201,
                    0.0204,
                    0.0207,
                    0.021,
                    0.0213,
                    0.0216,
                    0.0219,
                    0.0222,
                    0.0226,
                    0.0229,
                    0.0232,
                    0.0236,
                    0.0239,
                    0.0243,
                    0.0246,
                    0.025,
                    0.0254,
                    0.0257,
                    0.0264,
                    0.0271,
                    0.0279,
                    0.0286,
                    0.0292,
                    0.0299,
                    0.0306,
                    0.0312,
                    0.032,
                    0.0327,
                    0.0335,
                    0.0343,
                    0.0352,
                    0.0369,
                    0.0378,
                    0.0387,
                    0.0396,
                    0.0404,
                    0.0413,
                    0.042,
                    0.0428,
                    0.0435,
                    0.0445,
                    0.0451,
                    0.0458,
                    0.0467,
                    0.0474,
                    0.0483,
                    0.0493,
                    0.0502,
                    0.0512,
                    0.0524,
                    0.0533,
                    0.0542,
                    0.0552,
                    0.0564,
                    0.0575,
                    0.0585,
                    0.0597
                ],
                "Fossil_3GHG": 1.65,
                "Fossil_3GHG_timeseries": [
                    2.1286e-06,
                    4.3147e-06,
                    6.5588e-06,
                    8.8614e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0028,
                    0.0029,
                    0.0031,
                    0.0032,
                    0.0034,
                    0.0035,
                    0.0037,
                    0.0039,
                    0.004,
                    0.0042,
                    0.0044,
                    0.0045,
                    0.0047,
                    0.005,
                    0.0052,
                    0.0054,
                    0.0057,
                    0.0059,
                    0.0062,
                    0.0065,
                    0.0068,
                    0.007,
                    0.0073,
                    0.0076,
                    0.0079,
                    0.0082,
                    0.0085,
                    0.0089,
                    0.0092,
                    0.0096,
                    0.0099,
                    0.0103,
                    0.0107,
                    0.0112,
                    0.0117,
                    0.0122,
                    0.0127,
                    0.0132,
                    0.0137,
                    0.0143,
                    0.0149,
                    0.0155,
                    0.0162,
                    0.0168,
                    0.0175
                ],
                "Land_3GHG": 7.33,
                "Land_3GHG_timeseries": [
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0003,
                    0.0004,
                    0.0005,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.0041,
                    0.0042,
                    0.0044,
                    0.0045,
                    0.0047,
                    0.0049,
                    0.005,
                    0.0052,
                    0.0054,
                    0.0056,
                    0.0057,
                    0.0059,
                    0.0061,
                    0.0062,
                    0.0064,
                    0.0066,
                    0.0068,
                    0.0069,
                    0.0071,
                    0.0073,
                    0.0075,
                    0.0076,
                    0.0078,
                    0.008,
                    0.0082,
                    0.0083,
                    0.0085,
                    0.0087,
                    0.0089,
                    0.009,
                    0.0092,
                    0.0094,
                    0.0096,
                    0.0097,
                    0.0099,
                    0.0101,
                    0.0103,
                    0.0105,
                    0.0106,
                    0.0108,
                    0.011,
                    0.0112,
                    0.0114,
                    0.0116,
                    0.0117,
                    0.0119,
                    0.0121,
                    0.0123,
                    0.0125,
                    0.0127,
                    0.0129,
                    0.0131,
                    0.0133,
                    0.0135,
                    0.0138,
                    0.014,
                    0.0142,
                    0.0144,
                    0.0146,
                    0.0149,
                    0.0151,
                    0.0153,
                    0.0156,
                    0.0158,
                    0.0161,
                    0.0164,
                    0.0166,
                    0.0169,
                    0.0171,
                    0.0174,
                    0.0176,
                    0.0178,
                    0.0181,
                    0.0183,
                    0.0185,
                    0.0188,
                    0.019,
                    0.0192,
                    0.0194,
                    0.0197,
                    0.0199,
                    0.0201,
                    0.0203,
                    0.0205,
                    0.0207,
                    0.0209,
                    0.0212,
                    0.0214,
                    0.0216,
                    0.0218,
                    0.022,
                    0.0222,
                    0.0227,
                    0.0232,
                    0.0239,
                    0.0244,
                    0.0249,
                    0.0254,
                    0.0258,
                    0.0262,
                    0.0268,
                    0.0272,
                    0.0278,
                    0.0284,
                    0.029,
                    0.0304,
                    0.031,
                    0.0317,
                    0.0322,
                    0.0328,
                    0.0334,
                    0.0338,
                    0.0343,
                    0.0346,
                    0.0353,
                    0.0356,
                    0.0359,
                    0.0364,
                    0.0367,
                    0.0371,
                    0.0375,
                    0.0379,
                    0.0385,
                    0.0392,
                    0.0396,
                    0.04,
                    0.0403,
                    0.0409,
                    0.0413,
                    0.0417,
                    0.0422
                ],
                "Total_CO2": 3.87,
                "Total_CO2_timeseries": [
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0036,
                    0.0037,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0043,
                    0.0045,
                    0.0046,
                    0.0048,
                    0.0049,
                    0.0051,
                    0.0052,
                    0.0054,
                    0.0056,
                    0.0057,
                    0.0059,
                    0.006,
                    0.0062,
                    0.0064,
                    0.0065,
                    0.0067,
                    0.0069,
                    0.007,
                    0.0072,
                    0.0074,
                    0.0075,
                    0.0077,
                    0.0079,
                    0.008,
                    0.0082,
                    0.0084,
                    0.0085,
                    0.0087,
                    0.0089,
                    0.009,
                    0.0092,
                    0.0094,
                    0.0095,
                    0.0097,
                    0.0099,
                    0.0101,
                    0.0102,
                    0.0104,
                    0.0106,
                    0.0108,
                    0.0109,
                    0.0111,
                    0.0113,
                    0.0115,
                    0.0117,
                    0.0119,
                    0.0121,
                    0.0122,
                    0.0124,
                    0.0126,
                    0.0128,
                    0.013,
                    0.0132,
                    0.0134,
                    0.0136,
                    0.0138,
                    0.014,
                    0.0142,
                    0.0144,
                    0.0146,
                    0.0148,
                    0.015,
                    0.0153,
                    0.0155,
                    0.0157,
                    0.0159,
                    0.0161,
                    0.0163,
                    0.0165,
                    0.0166,
                    0.0168,
                    0.017,
                    0.0172,
                    0.0174,
                    0.0176,
                    0.0178,
                    0.0179,
                    0.0181,
                    0.0183,
                    0.0185,
                    0.0187,
                    0.0189,
                    0.0191,
                    0.0193,
                    0.0195,
                    0.0197,
                    0.02,
                    0.0202,
                    0.0207,
                    0.0212,
                    0.0218,
                    0.0223,
                    0.0228,
                    0.0233,
                    0.0238,
                    0.0242,
                    0.0247,
                    0.0252,
                    0.0258,
                    0.0264,
                    0.027,
                    0.0285,
                    0.0292,
                    0.0299,
                    0.0305,
                    0.0311,
                    0.0318,
                    0.0323,
                    0.0328,
                    0.0333,
                    0.034,
                    0.0345,
                    0.0349,
                    0.0355,
                    0.036,
                    0.0365,
                    0.0371,
                    0.0377,
                    0.0384,
                    0.0394,
                    0.04,
                    0.0405,
                    0.0411,
                    0.0419,
                    0.0426,
                    0.0432,
                    0.044
                ],
                "Fossil_CO2": 0.91,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.65e-09,
                    8.25e-09,
                    1.815e-08,
                    1.0405e-07,
                    2.8555e-07,
                    5.017e-07,
                    8.482e-07,
                    1.236e-06,
                    1.7343e-06,
                    2.3151e-06,
                    2.8216e-06,
                    3.3661e-06,
                    4.3759e-06,
                    5.0689e-06,
                    6.4203e-06,
                    7.9366e-06,
                    9.7978e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0027,
                    0.0028,
                    0.003,
                    0.0031,
                    0.0033,
                    0.0035,
                    0.0036,
                    0.0038,
                    0.004,
                    0.0042,
                    0.0045,
                    0.0047,
                    0.0049,
                    0.0051,
                    0.0054,
                    0.0056,
                    0.0059,
                    0.0062,
                    0.0065,
                    0.0067,
                    0.0071
                ],
                "Land_CO2": 10.28,
                "Land_CO2_timeseries": [
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0036,
                    0.0037,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0043,
                    0.0045,
                    0.0046,
                    0.0048,
                    0.0049,
                    0.0051,
                    0.0052,
                    0.0054,
                    0.0056,
                    0.0057,
                    0.0059,
                    0.006,
                    0.0062,
                    0.0063,
                    0.0065,
                    0.0067,
                    0.0068,
                    0.007,
                    0.0072,
                    0.0073,
                    0.0075,
                    0.0077,
                    0.0078,
                    0.008,
                    0.0081,
                    0.0083,
                    0.0085,
                    0.0086,
                    0.0088,
                    0.009,
                    0.0091,
                    0.0093,
                    0.0094,
                    0.0096,
                    0.0098,
                    0.0099,
                    0.0101,
                    0.0103,
                    0.0104,
                    0.0106,
                    0.0108,
                    0.011,
                    0.0111,
                    0.0113,
                    0.0115,
                    0.0117,
                    0.0118,
                    0.012,
                    0.0122,
                    0.0124,
                    0.0126,
                    0.0127,
                    0.0129,
                    0.0131,
                    0.0133,
                    0.0135,
                    0.0137,
                    0.0139,
                    0.0141,
                    0.0143,
                    0.0145,
                    0.0147,
                    0.0149,
                    0.0152,
                    0.0153,
                    0.0155,
                    0.0157,
                    0.0159,
                    0.0161,
                    0.0162,
                    0.0164,
                    0.0166,
                    0.0168,
                    0.0169,
                    0.0171,
                    0.0173,
                    0.0174,
                    0.0176,
                    0.0178,
                    0.0179,
                    0.0181,
                    0.0183,
                    0.0184,
                    0.0186,
                    0.0188,
                    0.0189,
                    0.0191,
                    0.0193,
                    0.0197,
                    0.0202,
                    0.0207,
                    0.0212,
                    0.0216,
                    0.0221,
                    0.0224,
                    0.0228,
                    0.0232,
                    0.0236,
                    0.0242,
                    0.0246,
                    0.0251,
                    0.0264,
                    0.027,
                    0.0276,
                    0.0281,
                    0.0286,
                    0.0291,
                    0.0295,
                    0.0298,
                    0.0302,
                    0.0307,
                    0.031,
                    0.0313,
                    0.0317,
                    0.032,
                    0.0323,
                    0.0327,
                    0.0331,
                    0.0335,
                    0.0342,
                    0.0346,
                    0.0349,
                    0.0352,
                    0.0357,
                    0.0361,
                    0.0365,
                    0.0369
                ],
                "Total_CH4": 3.45,
                "Total_CH4_timeseries": [
                    7.1612e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0047,
                    0.0048,
                    0.005,
                    0.0051,
                    0.0053,
                    0.0054,
                    0.0056,
                    0.0057,
                    0.0059,
                    0.0061,
                    0.0062,
                    0.0064,
                    0.0066,
                    0.0068,
                    0.007,
                    0.0072,
                    0.0075,
                    0.0077,
                    0.0079,
                    0.0081,
                    0.0083,
                    0.0085,
                    0.0087,
                    0.0089,
                    0.0091,
                    0.0093,
                    0.0095,
                    0.0098,
                    0.01,
                    0.0102,
                    0.0105,
                    0.0108,
                    0.0111,
                    0.0114,
                    0.0117,
                    0.0119,
                    0.0122,
                    0.0125,
                    0.0129,
                    0.0133,
                    0.0136,
                    0.014,
                    0.0144
                ],
                "Fossil_CH4": 3.93,
                "Fossil_CH4_timeseries": [
                    2.0065e-06,
                    4.0688e-06,
                    6.1876e-06,
                    8.3634e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0035,
                    0.0036,
                    0.0038,
                    0.0039,
                    0.0041,
                    0.0042,
                    0.0044,
                    0.0045,
                    0.0047,
                    0.0048,
                    0.005,
                    0.0051,
                    0.0053,
                    0.0054,
                    0.0056,
                    0.0058,
                    0.006,
                    0.0061,
                    0.0063,
                    0.0066,
                    0.0068,
                    0.0071,
                    0.0074,
                    0.0076,
                    0.0079,
                    0.0081,
                    0.0084,
                    0.0088,
                    0.0091,
                    0.0095,
                    0.0098,
                    0.0102
                ],
                "Land_CH4": 2.67,
                "Land_CH4_timeseries": [
                    5.1547e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.004,
                    0.004,
                    0.004,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0041,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0042
                ],
                "Total_N2O": 1.63,
                "Total_N2O_timeseries": [
                    3.7685e-07,
                    7.6038e-07,
                    1.1503e-06,
                    1.5464e-06,
                    1.9481e-06,
                    2.3549e-06,
                    2.7661e-06,
                    3.1811e-06,
                    3.599e-06,
                    4.0189e-06,
                    4.4402e-06,
                    4.8627e-06,
                    5.2863e-06,
                    5.711e-06,
                    6.1368e-06,
                    6.5636e-06,
                    6.9914e-06,
                    7.4204e-06,
                    7.8507e-06,
                    8.2825e-06,
                    8.7206e-06,
                    9.1736e-06,
                    9.648e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013
                ],
                "Fossil_N2O": 1.01,
                "Fossil_N2O_timeseries": [
                    1.2213e-07,
                    2.4585e-07,
                    3.7113e-07,
                    4.9792e-07,
                    6.2618e-07,
                    7.5581e-07,
                    8.8675e-07,
                    1.0189e-06,
                    1.1522e-06,
                    1.2864e-06,
                    1.4215e-06,
                    1.5576e-06,
                    1.6945e-06,
                    1.8322e-06,
                    1.9709e-06,
                    2.1103e-06,
                    2.2507e-06,
                    2.3919e-06,
                    2.534e-06,
                    2.6771e-06,
                    2.8217e-06,
                    2.9689e-06,
                    3.1196e-06,
                    3.2745e-06,
                    3.4337e-06,
                    3.5974e-06,
                    3.7655e-06,
                    3.9375e-06,
                    4.1127e-06,
                    4.2901e-06,
                    4.4692e-06,
                    4.6499e-06,
                    4.8319e-06,
                    5.0153e-06,
                    5.2e-06,
                    5.3859e-06,
                    5.5731e-06,
                    5.7615e-06,
                    5.9513e-06,
                    6.1466e-06,
                    6.3443e-06,
                    6.5445e-06,
                    6.7473e-06,
                    6.9528e-06,
                    7.1612e-06,
                    7.3726e-06,
                    7.587e-06,
                    7.8046e-06,
                    8.0255e-06,
                    8.2498e-06,
                    8.4778e-06,
                    8.7099e-06,
                    8.9465e-06,
                    9.1877e-06,
                    9.4338e-06,
                    9.6847e-06,
                    9.9404e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_N2O": 1.87,
                "Land_N2O_timeseries": [
                    2.5472e-07,
                    5.1453e-07,
                    7.7921e-07,
                    1.0485e-06,
                    1.3219e-06,
                    1.5991e-06,
                    1.8794e-06,
                    2.1622e-06,
                    2.4469e-06,
                    2.7325e-06,
                    3.0186e-06,
                    3.3051e-06,
                    3.5919e-06,
                    3.8788e-06,
                    4.1659e-06,
                    4.4532e-06,
                    4.7407e-06,
                    5.0285e-06,
                    5.3167e-06,
                    5.6054e-06,
                    5.8989e-06,
                    6.2047e-06,
                    6.5284e-06,
                    6.8739e-06,
                    7.2436e-06,
                    7.6378e-06,
                    8.0556e-06,
                    8.494e-06,
                    8.9483e-06,
                    9.4125e-06,
                    9.8821e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                109.64297,
                                2.07595
                            ],
                            [
                                109.57631,
                                1.99526
                            ],
                            [
                                109.46569,
                                1.98645
                            ],
                            [
                                109.41809,
                                1.95464
                            ],
                            [
                                109.31606,
                                1.92575
                            ],
                            [
                                109.32702,
                                1.84033
                            ],
                            [
                                109.29421,
                                1.79692
                            ],
                            [
                                109.27634,
                                1.7176
                            ],
                            [
                                109.23483,
                                1.64959
                            ],
                            [
                                109.15315,
                                1.60575
                            ],
                            [
                                109.05324,
                                1.52446
                            ],
                            [
                                109.03454,
                                1.45966
                            ],
                            [
                                109.04325,
                                1.371
                            ],
                            [
                                108.90796,
                                1.15731
                            ],
                            [
                                108.9711,
                                1.00203
                            ],
                            [
                                108.93512,
                                0.88689
                            ],
                            [
                                108.85078,
                                0.82751
                            ],
                            [
                                108.87264,
                                0.7141
                            ],
                            [
                                108.92356,
                                0.60865
                            ],
                            [
                                108.90875,
                                0.48163
                            ],
                            [
                                108.93707,
                                0.44274
                            ],
                            [
                                108.91672,
                                0.31947
                            ],
                            [
                                109.02356,
                                0.29013
                            ],
                            [
                                109.08381,
                                0.25026
                            ],
                            [
                                109.13946,
                                0.12944
                            ],
                            [
                                109.19609,
                                0.05093
                            ],
                            [
                                109.16722,
                                0.02526
                            ],
                            [
                                109.15707,
                                -0.06952
                            ],
                            [
                                109.12588,
                                -0.17053
                            ],
                            [
                                109.05172,
                                -0.2575
                            ],
                            [
                                109.09394,
                                -0.2817
                            ],
                            [
                                109.09689,
                                -0.37557
                            ],
                            [
                                109.12007,
                                -0.52223
                            ],
                            [
                                109.27587,
                                -0.59729
                            ],
                            [
                                109.37429,
                                -0.57906
                            ],
                            [
                                109.35811,
                                -0.6435
                            ],
                            [
                                109.40114,
                                -0.70986
                            ],
                            [
                                109.24379,
                                -0.69129
                            ],
                            [
                                109.25204,
                                -0.80655
                            ],
                            [
                                109.30103,
                                -0.88751
                            ],
                            [
                                109.38729,
                                -0.92433
                            ],
                            [
                                109.43136,
                                -0.85393
                            ],
                            [
                                109.58175,
                                -0.90346
                            ],
                            [
                                109.60491,
                                -0.96178
                            ],
                            [
                                109.67557,
                                -1.00437
                            ],
                            [
                                109.71298,
                                -0.96465
                            ],
                            [
                                109.76017,
                                -1.00157
                            ],
                            [
                                109.82016,
                                -1.08797
                            ],
                            [
                                109.93036,
                                -1.11878
                            ],
                            [
                                109.91435,
                                -1.2111
                            ],
                            [
                                109.96381,
                                -1.27131
                            ],
                            [
                                110.05512,
                                -1.32866
                            ],
                            [
                                110.0788,
                                -1.41079
                            ],
                            [
                                110.04623,
                                -1.51837
                            ],
                            [
                                110.02875,
                                -1.6749
                            ],
                            [
                                109.97436,
                                -1.75111
                            ],
                            [
                                109.9131,
                                -1.7871
                            ],
                            [
                                109.93109,
                                -1.87054
                            ],
                            [
                                110.0729,
                                -1.94145
                            ],
                            [
                                110.11857,
                                -2.03766
                            ],
                            [
                                110.11706,
                                -2.13366
                            ],
                            [
                                110.09149,
                                -2.22955
                            ],
                            [
                                110.13016,
                                -2.29261
                            ],
                            [
                                110.15321,
                                -2.42662
                            ],
                            [
                                110.19511,
                                -2.5361
                            ],
                            [
                                110.1505,
                                -2.62074
                            ],
                            [
                                110.20429,
                                -2.65277
                            ],
                            [
                                110.24051,
                                -2.83335
                            ],
                            [
                                110.20491,
                                -2.90209
                            ],
                            [
                                110.22996,
                                -2.96917
                            ],
                            [
                                110.27921,
                                -3.0102
                            ],
                            [
                                110.39074,
                                -2.92477
                            ],
                            [
                                110.52398,
                                -2.86761
                            ],
                            [
                                110.58927,
                                -2.87246
                            ],
                            [
                                110.61494,
                                -2.94012
                            ],
                            [
                                110.61123,
                                -3.04108
                            ],
                            [
                                110.66881,
                                -3.07257
                            ],
                            [
                                110.72885,
                                -3.02942
                            ],
                            [
                                110.78269,
                                -3.02207
                            ],
                            [
                                110.93095,
                                -3.09585
                            ],
                            [
                                111.09071,
                                -3.04666
                            ],
                            [
                                111.30727,
                                -2.92732
                            ],
                            [
                                111.41765,
                                -2.93024
                            ],
                            [
                                111.50642,
                                -2.98538
                            ],
                            [
                                111.54492,
                                -3.03356
                            ],
                            [
                                111.68997,
                                -2.95273
                            ],
                            [
                                111.66952,
                                -2.91315
                            ],
                            [
                                111.73294,
                                -2.88463
                            ],
                            [
                                111.80431,
                                -2.991
                            ],
                            [
                                111.82664,
                                -3.05934
                            ],
                            [
                                111.80742,
                                -3.20643
                            ],
                            [
                                111.83602,
                                -3.41471
                            ],
                            [
                                111.79045,
                                -3.5311
                            ],
                            [
                                111.87929,
                                -3.56786
                            ],
                            [
                                111.9447,
                                -3.54093
                            ],
                            [
                                112.16171,
                                -3.34159
                            ],
                            [
                                112.23669,
                                -3.31174
                            ],
                            [
                                112.34571,
                                -3.31929
                            ],
                            [
                                112.53581,
                                -3.43364
                            ],
                            [
                                112.62781,
                                -3.40974
                            ],
                            [
                                112.92619,
                                -3.21675
                            ],
                            [
                                112.99892,
                                -3.15467
                            ],
                            [
                                112.93811,
                                -3.11835
                            ],
                            [
                                112.97168,
                                -3.05323
                            ],
                            [
                                113.04925,
                                -2.99149
                            ],
                            [
                                113.10752,
                                -3.05131
                            ],
                            [
                                113.16273,
                                -3.07442
                            ],
                            [
                                113.33404,
                                -3.26707
                            ],
                            [
                                113.42446,
                                -3.23615
                            ],
                            [
                                113.465,
                                -3.1802
                            ],
                            [
                                113.51907,
                                -3.16745
                            ],
                            [
                                113.61043,
                                -3.18793
                            ],
                            [
                                113.63848,
                                -3.30941
                            ],
                            [
                                113.60004,
                                -3.44875
                            ],
                            [
                                113.74577,
                                -3.4701
                            ],
                            [
                                113.84327,
                                -3.44778
                            ],
                            [
                                113.96569,
                                -3.37547
                            ],
                            [
                                114.03518,
                                -3.3518
                            ],
                            [
                                114.05864,
                                -3.30947
                            ],
                            [
                                114.11778,
                                -3.37443
                            ],
                            [
                                114.26127,
                                -3.40777
                            ],
                            [
                                114.46747,
                                -3.49823
                            ],
                            [
                                114.56841,
                                -3.58684
                            ],
                            [
                                114.60942,
                                -3.70949
                            ],
                            [
                                114.59195,
                                -3.8021
                            ],
                            [
                                114.61377,
                                -4.02962
                            ],
                            [
                                114.60383,
                                -4.16166
                            ],
                            [
                                114.63367,
                                -4.18592
                            ],
                            [
                                114.71308,
                                -4.1698
                            ],
                            [
                                114.90616,
                                -4.06562
                            ],
                            [
                                115.32943,
                                -3.87262
                            ],
                            [
                                115.70585,
                                -3.7306
                            ],
                            [
                                115.82343,
                                -3.64192
                            ],
                            [
                                115.95065,
                                -3.61546
                            ],
                            [
                                115.98671,
                                -3.57407
                            ],
                            [
                                116.03373,
                                -3.38367
                            ],
                            [
                                116.10628,
                                -3.24709
                            ],
                            [
                                116.18265,
                                -3.22999
                            ],
                            [
                                116.16919,
                                -3.16632
                            ],
                            [
                                116.25175,
                                -3.1079
                            ],
                            [
                                116.19644,
                                -3.07767
                            ],
                            [
                                116.17602,
                                -3.01643
                            ],
                            [
                                116.10664,
                                -2.93273
                            ],
                            [
                                116.13542,
                                -2.85595
                            ],
                            [
                                116.19648,
                                -2.91321
                            ],
                            [
                                116.21953,
                                -3.00437
                            ],
                            [
                                116.27021,
                                -3.00928
                            ],
                            [
                                116.3671,
                                -2.8744
                            ],
                            [
                                116.36253,
                                -2.70693
                            ],
                            [
                                116.41155,
                                -2.50109
                            ],
                            [
                                116.51119,
                                -2.56498
                            ],
                            [
                                116.59071,
                                -2.28369
                            ],
                            [
                                116.59851,
                                -2.20392
                            ],
                            [
                                116.36294,
                                -2.10397
                            ],
                            [
                                116.45459,
                                -2.04917
                            ],
                            [
                                116.45266,
                                -1.92346
                            ],
                            [
                                116.41741,
                                -1.86726
                            ],
                            [
                                116.44259,
                                -1.77808
                            ],
                            [
                                116.37595,
                                -1.77315
                            ],
                            [
                                116.26384,
                                -1.81069
                            ],
                            [
                                116.27283,
                                -1.73423
                            ],
                            [
                                116.33161,
                                -1.69982
                            ],
                            [
                                116.49049,
                                -1.64319
                            ],
                            [
                                116.54662,
                                -1.60656
                            ],
                            [
                                116.53555,
                                -1.48063
                            ],
                            [
                                116.59327,
                                -1.42662
                            ],
                            [
                                116.75912,
                                -1.36305
                            ],
                            [
                                116.77333,
                                -1.24941
                            ],
                            [
                                116.73365,
                                -1.21389
                            ],
                            [
                                116.7819,
                                -1.16129
                            ],
                            [
                                116.8188,
                                -1.21645
                            ],
                            [
                                116.82478,
                                -1.28229
                            ],
                            [
                                116.89591,
                                -1.27372
                            ],
                            [
                                117.0067,
                                -1.20085
                            ],
                            [
                                117.1778,
                                -0.95384
                            ],
                            [
                                117.24646,
                                -0.90953
                            ],
                            [
                                117.25738,
                                -0.82038
                            ],
                            [
                                117.29822,
                                -0.79347
                            ],
                            [
                                117.35515,
                                -0.90002
                            ],
                            [
                                117.41243,
                                -0.88075
                            ],
                            [
                                117.4555,
                                -0.77525
                            ],
                            [
                                117.53223,
                                -0.81999
                            ],
                            [
                                117.61533,
                                -0.77831
                            ],
                            [
                                117.60681,
                                -0.74303
                            ],
                            [
                                117.51912,
                                -0.73852
                            ],
                            [
                                117.51765,
                                -0.66874
                            ],
                            [
                                117.56519,
                                -0.65563
                            ],
                            [
                                117.58433,
                                -0.52605
                            ],
                            [
                                117.63062,
                                -0.43064
                            ],
                            [
                                117.53112,
                                -0.42869
                            ],
                            [
                                117.42417,
                                -0.25317
                            ],
                            [
                                117.48143,
                                -0.07956
                            ],
                            [
                                117.51667,
                                -0.035
                            ],
                            [
                                117.47335,
                                0.05781
                            ],
                            [
                                117.50256,
                                0.14551
                            ],
                            [
                                117.51971,
                                0.30498
                            ],
                            [
                                117.55904,
                                0.38306
                            ],
                            [
                                117.60002,
                                0.41843
                            ],
                            [
                                117.60289,
                                0.47722
                            ],
                            [
                                117.71058,
                                0.69244
                            ],
                            [
                                117.75583,
                                0.76077
                            ],
                            [
                                117.80978,
                                0.79732
                            ],
                            [
                                117.91417,
                                0.83058
                            ],
                            [
                                117.97578,
                                0.7826
                            ],
                            [
                                118.02811,
                                0.7928
                            ],
                            [
                                118.01924,
                                0.86766
                            ],
                            [
                                117.98146,
                                0.9273
                            ],
                            [
                                118.31466,
                                0.84701
                            ],
                            [
                                118.35166,
                                0.811
                            ],
                            [
                                118.43302,
                                0.83539
                            ],
                            [
                                118.5787,
                                0.81246
                            ],
                            [
                                118.67372,
                                0.85026
                            ],
                            [
                                118.71004,
                                0.81869
                            ],
                            [
                                118.81212,
                                0.81253
                            ],
                            [
                                118.96904,
                                0.93672
                            ],
                            [
                                118.98716,
                                1.0348
                            ],
                            [
                                118.88233,
                                1.06737
                            ],
                            [
                                118.78713,
                                1.13199
                            ],
                            [
                                118.76018,
                                1.20485
                            ],
                            [
                                118.56821,
                                1.36156
                            ],
                            [
                                118.41555,
                                1.40437
                            ],
                            [
                                118.40653,
                                1.4815
                            ],
                            [
                                118.24555,
                                1.56417
                            ],
                            [
                                118.11723,
                                1.6459
                            ],
                            [
                                118.05303,
                                1.73045
                            ],
                            [
                                118.04964,
                                1.77711
                            ],
                            [
                                117.92953,
                                1.80488
                            ],
                            [
                                117.86134,
                                1.91135
                            ],
                            [
                                117.85041,
                                2.03035
                            ],
                            [
                                117.87428,
                                2.07296
                            ],
                            [
                                117.93946,
                                2.10756
                            ],
                            [
                                117.94499,
                                2.18019
                            ],
                            [
                                118.02319,
                                2.19999
                            ],
                            [
                                118.09248,
                                2.28062
                            ],
                            [
                                118.06047,
                                2.35686
                            ],
                            [
                                118.02802,
                                2.35999
                            ],
                            [
                                117.99114,
                                2.43046
                            ],
                            [
                                117.94443,
                                2.46037
                            ],
                            [
                                117.79955,
                                2.62651
                            ],
                            [
                                117.78572,
                                2.71946
                            ],
                            [
                                117.72633,
                                2.77792
                            ],
                            [
                                117.71577,
                                2.89603
                            ],
                            [
                                117.66384,
                                2.9888
                            ],
                            [
                                117.60156,
                                2.97685
                            ],
                            [
                                117.61522,
                                3.07857
                            ],
                            [
                                117.58843,
                                3.10292
                            ],
                            [
                                117.48833,
                                3.09543
                            ],
                            [
                                117.43311,
                                3.17449
                            ],
                            [
                                117.31311,
                                3.20311
                            ],
                            [
                                117.45347,
                                3.27932
                            ],
                            [
                                117.4343,
                                3.41475
                            ],
                            [
                                117.31213,
                                3.46294
                            ],
                            [
                                117.32176,
                                3.49427
                            ],
                            [
                                117.48411,
                                3.43858
                            ],
                            [
                                117.57917,
                                3.51977
                            ],
                            [
                                117.4965,
                                3.54813
                            ],
                            [
                                117.30171,
                                3.56459
                            ],
                            [
                                117.25263,
                                3.62297
                            ],
                            [
                                117.39462,
                                3.6422
                            ],
                            [
                                117.50656,
                                3.61022
                            ],
                            [
                                117.52316,
                                3.67704
                            ],
                            [
                                117.58215,
                                3.63887
                            ],
                            [
                                117.65792,
                                3.62386
                            ],
                            [
                                117.76167,
                                3.6493
                            ],
                            [
                                117.82948,
                                3.7068
                            ],
                            [
                                117.83323,
                                3.80895
                            ],
                            [
                                117.77868,
                                3.85806
                            ],
                            [
                                117.69005,
                                3.87467
                            ],
                            [
                                117.68919,
                                3.91318
                            ],
                            [
                                117.61236,
                                3.93967
                            ],
                            [
                                117.47158,
                                4.0839
                            ],
                            [
                                117.40062,
                                4.09917
                            ],
                            [
                                117.40252,
                                4.14536
                            ],
                            [
                                117.51988,
                                4.114
                            ],
                            [
                                117.586,
                                4.17764
                            ],
                            [
                                117.46501,
                                4.17872
                            ],
                            [
                                117.36431,
                                4.28578
                            ],
                            [
                                117.29019,
                                4.3171
                            ],
                            [
                                117.24498,
                                4.37215
                            ],
                            [
                                117.17703,
                                4.3287
                            ],
                            [
                                116.96628,
                                4.34099
                            ],
                            [
                                116.90875,
                                4.3687
                            ],
                            [
                                116.87102,
                                4.3413
                            ],
                            [
                                116.79008,
                                4.34332
                            ],
                            [
                                116.749,
                                4.38867
                            ],
                            [
                                116.70284,
                                4.34047
                            ],
                            [
                                116.61976,
                                4.34186
                            ],
                            [
                                116.56699,
                                4.40529
                            ],
                            [
                                116.53457,
                                4.32835
                            ],
                            [
                                116.42773,
                                4.3267
                            ],
                            [
                                116.35246,
                                4.38951
                            ],
                            [
                                116.27144,
                                4.36365
                            ],
                            [
                                116.16826,
                                4.38734
                            ],
                            [
                                116.08379,
                                4.28358
                            ],
                            [
                                115.97276,
                                4.3573
                            ],
                            [
                                115.87004,
                                4.37577
                            ],
                            [
                                115.86931,
                                4.28936
                            ],
                            [
                                115.80235,
                                4.22239
                            ],
                            [
                                115.76804,
                                4.24841
                            ],
                            [
                                115.68243,
                                4.15555
                            ],
                            [
                                115.63993,
                                3.96503
                            ],
                            [
                                115.56382,
                                3.91728
                            ],
                            [
                                115.61626,
                                3.8406
                            ],
                            [
                                115.57839,
                                3.74539
                            ],
                            [
                                115.57601,
                                3.61224
                            ],
                            [
                                115.61037,
                                3.55538
                            ],
                            [
                                115.60559,
                                3.45421
                            ],
                            [
                                115.54625,
                                3.36653
                            ],
                            [
                                115.51879,
                                3.20519
                            ],
                            [
                                115.55303,
                                3.15169
                            ],
                            [
                                115.51581,
                                3.10898
                            ],
                            [
                                115.48253,
                                3.01978
                            ],
                            [
                                115.33442,
                                2.97795
                            ],
                            [
                                115.2845,
                                3.04343
                            ],
                            [
                                115.24665,
                                2.96668
                            ],
                            [
                                115.16084,
                                2.9233
                            ],
                            [
                                115.10225,
                                2.81535
                            ],
                            [
                                115.15114,
                                2.79063
                            ],
                            [
                                115.10494,
                                2.7211
                            ],
                            [
                                115.13356,
                                2.58822
                            ],
                            [
                                115.17723,
                                2.60663
                            ],
                            [
                                115.2452,
                                2.50594
                            ],
                            [
                                115.14274,
                                2.47327
                            ],
                            [
                                115.09792,
                                2.40584
                            ],
                            [
                                114.95412,
                                2.34856
                            ],
                            [
                                114.96428,
                                2.2941
                            ],
                            [
                                114.91223,
                                2.2557
                            ],
                            [
                                114.80166,
                                2.24884
                            ],
                            [
                                114.75983,
                                2.16864
                            ],
                            [
                                114.80312,
                                2.10376
                            ],
                            [
                                114.8012,
                                2.02864
                            ],
                            [
                                114.87817,
                                2.03235
                            ],
                            [
                                114.85144,
                                1.96404
                            ],
                            [
                                114.88016,
                                1.91589
                            ],
                            [
                                114.79402,
                                1.85059
                            ],
                            [
                                114.7465,
                                1.86657
                            ],
                            [
                                114.70328,
                                1.8103
                            ],
                            [
                                114.71073,
                                1.65374
                            ],
                            [
                                114.68094,
                                1.60972
                            ],
                            [
                                114.60994,
                                1.57186
                            ],
                            [
                                114.61343,
                                1.5123
                            ],
                            [
                                114.58155,
                                1.44295
                            ],
                            [
                                114.53774,
                                1.43724
                            ],
                            [
                                114.40144,
                                1.52022
                            ],
                            [
                                114.3766,
                                1.49351
                            ],
                            [
                                114.21927,
                                1.41637
                            ],
                            [
                                114.14016,
                                1.46507
                            ],
                            [
                                113.97369,
                                1.44763
                            ],
                            [
                                113.93313,
                                1.41588
                            ],
                            [
                                113.82064,
                                1.37208
                            ],
                            [
                                113.80064,
                                1.30122
                            ],
                            [
                                113.63353,
                                1.22042
                            ],
                            [
                                113.5786,
                                1.30627
                            ],
                            [
                                113.50004,
                                1.31609
                            ],
                            [
                                113.42534,
                                1.28563
                            ],
                            [
                                113.35711,
                                1.35531
                            ],
                            [
                                113.23355,
                                1.39336
                            ],
                            [
                                113.14474,
                                1.38947
                            ],
                            [
                                113.1049,
                                1.44328
                            ],
                            [
                                113.01869,
                                1.40705
                            ],
                            [
                                113.05404,
                                1.55739
                            ],
                            [
                                112.89574,
                                1.58585
                            ],
                            [
                                112.84612,
                                1.54231
                            ],
                            [
                                112.72999,
                                1.56626
                            ],
                            [
                                112.4876,
                                1.57922
                            ],
                            [
                                112.43387,
                                1.52829
                            ],
                            [
                                112.32229,
                                1.50523
                            ],
                            [
                                112.21057,
                                1.44489
                            ],
                            [
                                112.23096,
                                1.39547
                            ],
                            [
                                112.18035,
                                1.30385
                            ],
                            [
                                112.15776,
                                1.19768
                            ],
                            [
                                112.1276,
                                1.13604
                            ],
                            [
                                111.95335,
                                1.12142
                            ],
                            [
                                111.87794,
                                1.06102
                            ],
                            [
                                111.82745,
                                0.98816
                            ],
                            [
                                111.72158,
                                1.00599
                            ],
                            [
                                111.66304,
                                1.03936
                            ],
                            [
                                111.51744,
                                0.97008
                            ],
                            [
                                111.48779,
                                1.0337
                            ],
                            [
                                111.44158,
                                1.01268
                            ],
                            [
                                111.25093,
                                1.06492
                            ],
                            [
                                111.07756,
                                1.051
                            ],
                            [
                                110.97762,
                                1.02758
                            ],
                            [
                                110.89948,
                                1.02785
                            ],
                            [
                                110.85947,
                                0.95523
                            ],
                            [
                                110.75272,
                                0.90406
                            ],
                            [
                                110.57421,
                                0.85564
                            ],
                            [
                                110.46375,
                                0.89281
                            ],
                            [
                                110.35824,
                                0.98367
                            ],
                            [
                                110.2723,
                                0.99949
                            ],
                            [
                                110.26092,
                                1.07363
                            ],
                            [
                                110.20962,
                                1.1205
                            ],
                            [
                                110.19133,
                                1.18327
                            ],
                            [
                                110.09462,
                                1.19723
                            ],
                            [
                                110.05297,
                                1.26387
                            ],
                            [
                                109.97772,
                                1.30046
                            ],
                            [
                                109.95477,
                                1.39996
                            ],
                            [
                                109.8469,
                                1.42678
                            ],
                            [
                                109.65842,
                                1.62205
                            ],
                            [
                                109.68144,
                                1.78378
                            ],
                            [
                                109.59971,
                                1.79806
                            ],
                            [
                                109.55177,
                                1.85784
                            ],
                            [
                                109.53767,
                                1.92286
                            ],
                            [
                                109.62039,
                                1.9859
                            ],
                            [
                                109.64297,
                                2.07595
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                105.47495,
                                -2.39878
                            ],
                            [
                                105.29466,
                                -2.37529
                            ],
                            [
                                105.21349,
                                -2.33877
                            ],
                            [
                                105.12141,
                                -2.37888
                            ],
                            [
                                105.04629,
                                -2.37474
                            ],
                            [
                                104.90729,
                                -2.30441
                            ],
                            [
                                104.83553,
                                -2.33754
                            ],
                            [
                                104.7546,
                                -2.41387
                            ],
                            [
                                104.75698,
                                -2.31599
                            ],
                            [
                                104.84123,
                                -2.24068
                            ],
                            [
                                104.88023,
                                -2.17079
                            ],
                            [
                                104.86496,
                                -2.07159
                            ],
                            [
                                104.80514,
                                -2.00216
                            ],
                            [
                                104.71668,
                                -1.9998
                            ],
                            [
                                104.60976,
                                -1.96076
                            ],
                            [
                                104.62359,
                                -1.90363
                            ],
                            [
                                104.46817,
                                -1.85886
                            ],
                            [
                                104.52795,
                                -1.80109
                            ],
                            [
                                104.52428,
                                -1.71104
                            ],
                            [
                                104.46955,
                                -1.62814
                            ],
                            [
                                104.43835,
                                -1.4687
                            ],
                            [
                                104.45306,
                                -1.39995
                            ],
                            [
                                104.44144,
                                -1.31027
                            ],
                            [
                                104.39145,
                                -1.19673
                            ],
                            [
                                104.40834,
                                -1.13034
                            ],
                            [
                                104.38367,
                                -1.04979
                            ],
                            [
                                104.26546,
                                -1.05117
                            ],
                            [
                                104.21093,
                                -1.06873
                            ],
                            [
                                104.08003,
                                -1.03554
                            ],
                            [
                                103.97169,
                                -0.99426
                            ],
                            [
                                103.84598,
                                -1.01015
                            ],
                            [
                                103.75962,
                                -0.99904
                            ],
                            [
                                103.60046,
                                -0.90874
                            ],
                            [
                                103.4689,
                                -0.76432
                            ],
                            [
                                103.37958,
                                -0.73057
                            ],
                            [
                                103.37841,
                                -0.65319
                            ],
                            [
                                103.41665,
                                -0.5302
                            ],
                            [
                                103.52583,
                                -0.50324
                            ],
                            [
                                103.58309,
                                -0.45873
                            ],
                            [
                                103.61072,
                                -0.39723
                            ],
                            [
                                103.68941,
                                -0.36073
                            ],
                            [
                                103.77031,
                                -0.34638
                            ],
                            [
                                103.70972,
                                -0.27457
                            ],
                            [
                                103.62404,
                                -0.23856
                            ],
                            [
                                103.43986,
                                -0.20325
                            ],
                            [
                                103.58727,
                                -0.1044
                            ],
                            [
                                103.61905,
                                -0.05144
                            ],
                            [
                                103.80208,
                                -0.00519
                            ],
                            [
                                103.75893,
                                0.23201
                            ],
                            [
                                103.65378,
                                0.33955
                            ],
                            [
                                103.60719,
                                0.34783
                            ],
                            [
                                103.584,
                                0.39813
                            ],
                            [
                                103.4127,
                                0.52565
                            ],
                            [
                                103.33989,
                                0.5418
                            ],
                            [
                                103.29045,
                                0.5017
                            ],
                            [
                                103.19751,
                                0.46943
                            ],
                            [
                                103.14129,
                                0.38773
                            ],
                            [
                                103.07253,
                                0.37024
                            ],
                            [
                                102.978,
                                0.30478
                            ],
                            [
                                102.86138,
                                0.24663
                            ],
                            [
                                102.83109,
                                0.30911
                            ],
                            [
                                102.91642,
                                0.33649
                            ],
                            [
                                102.95362,
                                0.37101
                            ],
                            [
                                103.10402,
                                0.44461
                            ],
                            [
                                103.09438,
                                0.49545
                            ],
                            [
                                103.04838,
                                0.52949
                            ],
                            [
                                103.02211,
                                0.58909
                            ],
                            [
                                102.9206,
                                0.7069
                            ],
                            [
                                102.85483,
                                0.73623
                            ],
                            [
                                102.77039,
                                0.72712
                            ],
                            [
                                102.69778,
                                0.75054
                            ],
                            [
                                102.60724,
                                0.73459
                            ],
                            [
                                102.52693,
                                0.74481
                            ],
                            [
                                102.40857,
                                0.81391
                            ],
                            [
                                102.3446,
                                0.89806
                            ],
                            [
                                102.22816,
                                1.0003
                            ],
                            [
                                102.19608,
                                1.08927
                            ],
                            [
                                102.21208,
                                1.16277
                            ],
                            [
                                102.15522,
                                1.26517
                            ],
                            [
                                102.15569,
                                1.36918
                            ],
                            [
                                102.00711,
                                1.45833
                            ],
                            [
                                101.92457,
                                1.53575
                            ],
                            [
                                101.75831,
                                1.66857
                            ],
                            [
                                101.67026,
                                1.66617
                            ],
                            [
                                101.55764,
                                1.63933
                            ],
                            [
                                101.40606,
                                1.70537
                            ],
                            [
                                101.36101,
                                1.78192
                            ],
                            [
                                101.36663,
                                1.83104
                            ],
                            [
                                101.33498,
                                1.90824
                            ],
                            [
                                101.32703,
                                1.99818
                            ],
                            [
                                101.27308,
                                2.07605
                            ],
                            [
                                101.18678,
                                2.11999
                            ],
                            [
                                101.08366,
                                2.20798
                            ],
                            [
                                101.04924,
                                2.28666
                            ],
                            [
                                100.95932,
                                2.29525
                            ],
                            [
                                100.83437,
                                2.28212
                            ],
                            [
                                100.7711,
                                2.2223
                            ],
                            [
                                100.79588,
                                2.11273
                            ],
                            [
                                100.87813,
                                2.04283
                            ],
                            [
                                100.87616,
                                1.95998
                            ],
                            [
                                100.7988,
                                2.05763
                            ],
                            [
                                100.6833,
                                2.11792
                            ],
                            [
                                100.57341,
                                2.14848
                            ],
                            [
                                100.5031,
                                2.20217
                            ],
                            [
                                100.40004,
                                2.32284
                            ],
                            [
                                100.3673,
                                2.39181
                            ],
                            [
                                100.32534,
                                2.54841
                            ],
                            [
                                100.28353,
                                2.58815
                            ],
                            [
                                100.22563,
                                2.69788
                            ],
                            [
                                100.14666,
                                2.69766
                            ],
                            [
                                100.12338,
                                2.6456
                            ],
                            [
                                100.03868,
                                2.74271
                            ],
                            [
                                99.97577,
                                2.71519
                            ],
                            [
                                99.99612,
                                2.81068
                            ],
                            [
                                99.99112,
                                2.93739
                            ],
                            [
                                99.91405,
                                2.98891
                            ],
                            [
                                99.79163,
                                3.11182
                            ],
                            [
                                99.75845,
                                3.16944
                            ],
                            [
                                99.681,
                                3.2091
                            ],
                            [
                                99.5514,
                                3.24689
                            ],
                            [
                                99.43687,
                                3.37728
                            ],
                            [
                                99.3762,
                                3.39953
                            ],
                            [
                                99.27607,
                                3.46637
                            ],
                            [
                                99.20968,
                                3.52819
                            ],
                            [
                                99.12282,
                                3.56785
                            ],
                            [
                                98.95851,
                                3.66891
                            ],
                            [
                                98.78946,
                                3.72145
                            ],
                            [
                                98.71352,
                                3.78614
                            ],
                            [
                                98.67942,
                                3.90633
                            ],
                            [
                                98.53938,
                                3.93615
                            ],
                            [
                                98.5403,
                                3.99242
                            ],
                            [
                                98.45024,
                                4.0302
                            ],
                            [
                                98.39312,
                                4.07429
                            ],
                            [
                                98.31516,
                                4.07488
                            ],
                            [
                                98.2447,
                                4.12888
                            ],
                            [
                                98.18256,
                                4.10491
                            ],
                            [
                                98.16389,
                                4.15999
                            ],
                            [
                                98.24913,
                                4.1977
                            ],
                            [
                                98.25158,
                                4.28097
                            ],
                            [
                                98.2802,
                                4.33874
                            ],
                            [
                                98.27502,
                                4.39372
                            ],
                            [
                                98.22538,
                                4.46217
                            ],
                            [
                                98.06106,
                                4.54569
                            ],
                            [
                                97.97981,
                                4.56503
                            ],
                            [
                                98.01171,
                                4.61684
                            ],
                            [
                                97.96258,
                                4.67194
                            ],
                            [
                                97.95779,
                                4.73437
                            ],
                            [
                                97.90358,
                                4.87961
                            ],
                            [
                                97.81029,
                                4.93175
                            ],
                            [
                                97.65441,
                                5.07125
                            ],
                            [
                                97.64602,
                                5.1194
                            ],
                            [
                                97.57712,
                                5.14117
                            ],
                            [
                                97.5665,
                                5.1892
                            ],
                            [
                                97.49289,
                                5.25005
                            ],
                            [
                                97.23142,
                                5.15243
                            ],
                            [
                                97.14953,
                                5.16053
                            ],
                            [
                                97.13874,
                                5.20228
                            ],
                            [
                                96.98675,
                                5.26322
                            ],
                            [
                                96.89119,
                                5.25372
                            ],
                            [
                                96.8385,
                                5.2772
                            ],
                            [
                                96.72185,
                                5.25543
                            ],
                            [
                                96.61812,
                                5.21597
                            ],
                            [
                                96.50854,
                                5.20188
                            ],
                            [
                                96.45354,
                                5.23439
                            ],
                            [
                                96.3885,
                                5.21589
                            ],
                            [
                                96.25647,
                                5.26284
                            ],
                            [
                                96.18592,
                                5.26392
                            ],
                            [
                                96.07762,
                                5.29247
                            ],
                            [
                                95.92872,
                                5.40513
                            ],
                            [
                                95.87943,
                                5.50391
                            ],
                            [
                                95.60949,
                                5.62616
                            ],
                            [
                                95.49727,
                                5.60099
                            ],
                            [
                                95.43252,
                                5.65445
                            ],
                            [
                                95.35685,
                                5.59246
                            ],
                            [
                                95.27853,
                                5.55201
                            ],
                            [
                                95.2108,
                                5.55906
                            ],
                            [
                                95.24719,
                                5.37462
                            ],
                            [
                                95.21237,
                                5.27345
                            ],
                            [
                                95.30178,
                                5.17152
                            ],
                            [
                                95.30856,
                                5.07756
                            ],
                            [
                                95.36004,
                                5.02174
                            ],
                            [
                                95.39936,
                                4.86816
                            ],
                            [
                                95.53754,
                                4.66775
                            ],
                            [
                                95.71436,
                                4.52307
                            ],
                            [
                                95.8762,
                                4.36318
                            ],
                            [
                                96.02313,
                                4.19751
                            ],
                            [
                                96.05592,
                                4.20358
                            ],
                            [
                                96.12482,
                                4.13069
                            ],
                            [
                                96.19666,
                                4.09939
                            ],
                            [
                                96.30787,
                                3.96517
                            ],
                            [
                                96.39005,
                                3.84704
                            ],
                            [
                                96.49341,
                                3.75418
                            ],
                            [
                                96.53801,
                                3.73584
                            ],
                            [
                                96.65693,
                                3.75111
                            ],
                            [
                                96.76476,
                                3.74417
                            ],
                            [
                                96.85977,
                                3.69873
                            ],
                            [
                                96.90551,
                                3.60107
                            ],
                            [
                                96.99939,
                                3.54511
                            ],
                            [
                                97.17021,
                                3.25818
                            ],
                            [
                                97.2572,
                                3.22041
                            ],
                            [
                                97.32395,
                                3.05331
                            ],
                            [
                                97.43771,
                                2.92418
                            ],
                            [
                                97.57765,
                                2.89276
                            ],
                            [
                                97.60812,
                                2.85905
                            ],
                            [
                                97.65137,
                                2.68562
                            ],
                            [
                                97.66528,
                                2.40496
                            ],
                            [
                                97.77873,
                                2.24813
                            ],
                            [
                                97.82533,
                                2.26337
                            ],
                            [
                                97.88017,
                                2.23651
                            ],
                            [
                                97.95791,
                                2.26521
                            ],
                            [
                                98.11226,
                                2.18209
                            ],
                            [
                                98.1974,
                                2.10902
                            ],
                            [
                                98.31099,
                                2.03417
                            ],
                            [
                                98.42934,
                                2.00641
                            ],
                            [
                                98.54469,
                                1.91147
                            ],
                            [
                                98.68653,
                                1.73685
                            ],
                            [
                                98.73324,
                                1.71901
                            ],
                            [
                                98.76702,
                                1.75896
                            ],
                            [
                                98.83948,
                                1.63488
                            ],
                            [
                                98.83079,
                                1.60202
                            ],
                            [
                                98.73641,
                                1.52371
                            ],
                            [
                                98.78384,
                                1.42366
                            ],
                            [
                                98.85161,
                                1.32135
                            ],
                            [
                                98.84613,
                                1.2748
                            ],
                            [
                                98.91041,
                                1.12173
                            ],
                            [
                                98.97076,
                                0.92654
                            ],
                            [
                                98.98105,
                                0.85912
                            ],
                            [
                                99.05423,
                                0.74497
                            ],
                            [
                                99.07203,
                                0.62857
                            ],
                            [
                                99.10023,
                                0.59819
                            ],
                            [
                                99.13968,
                                0.42926
                            ],
                            [
                                99.12098,
                                0.33472
                            ],
                            [
                                99.14364,
                                0.25826
                            ],
                            [
                                99.22134,
                                0.20716
                            ],
                            [
                                99.35661,
                                0.22645
                            ],
                            [
                                99.40138,
                                0.14807
                            ],
                            [
                                99.51559,
                                0.11438
                            ],
                            [
                                99.61994,
                                0.06388
                            ],
                            [
                                99.73124,
                                -0.03501
                            ],
                            [
                                99.76678,
                                -0.1102
                            ],
                            [
                                99.75064,
                                -0.13903
                            ],
                            [
                                99.79957,
                                -0.23574
                            ],
                            [
                                99.80711,
                                -0.30692
                            ],
                            [
                                99.8911,
                                -0.36715
                            ],
                            [
                                100.08271,
                                -0.56437
                            ],
                            [
                                100.12078,
                                -0.64693
                            ],
                            [
                                100.25832,
                                -0.77885
                            ],
                            [
                                100.32805,
                                -0.86727
                            ],
                            [
                                100.34525,
                                -0.96981
                            ],
                            [
                                100.40973,
                                -1.05004
                            ],
                            [
                                100.36518,
                                -1.08118
                            ],
                            [
                                100.38373,
                                -1.18481
                            ],
                            [
                                100.429,
                                -1.20694
                            ],
                            [
                                100.45214,
                                -1.26927
                            ],
                            [
                                100.56306,
                                -1.34541
                            ],
                            [
                                100.58168,
                                -1.40147
                            ],
                            [
                                100.56085,
                                -1.45026
                            ],
                            [
                                100.61772,
                                -1.5046
                            ],
                            [
                                100.64119,
                                -1.62846
                            ],
                            [
                                100.67848,
                                -1.66688
                            ],
                            [
                                100.77591,
                                -1.82204
                            ],
                            [
                                100.85038,
                                -1.91698
                            ],
                            [
                                100.87562,
                                -2.05633
                            ],
                            [
                                100.82051,
                                -2.1417
                            ],
                            [
                                100.82021,
                                -2.18303
                            ],
                            [
                                100.86942,
                                -2.25142
                            ],
                            [
                                100.88184,
                                -2.32448
                            ],
                            [
                                100.99154,
                                -2.44076
                            ],
                            [
                                101.14216,
                                -2.63748
                            ],
                            [
                                101.30765,
                                -2.73415
                            ],
                            [
                                101.38775,
                                -2.90828
                            ],
                            [
                                101.51388,
                                -3.08942
                            ],
                            [
                                101.5177,
                                -3.12078
                            ],
                            [
                                101.60916,
                                -3.24082
                            ],
                            [
                                101.7975,
                                -3.37962
                            ],
                            [
                                101.89417,
                                -3.43547
                            ],
                            [
                                101.91911,
                                -3.48125
                            ],
                            [
                                102.0833,
                                -3.56434
                            ],
                            [
                                102.21592,
                                -3.67124
                            ],
                            [
                                102.25521,
                                -3.76889
                            ],
                            [
                                102.24181,
                                -3.79861
                            ],
                            [
                                102.30754,
                                -3.88357
                            ],
                            [
                                102.28291,
                                -3.97527
                            ],
                            [
                                102.33648,
                                -4.02197
                            ],
                            [
                                102.70383,
                                -4.28379
                            ],
                            [
                                102.87562,
                                -4.43869
                            ],
                            [
                                102.89373,
                                -4.48381
                            ],
                            [
                                103.03566,
                                -4.53868
                            ],
                            [
                                103.14609,
                                -4.59847
                            ],
                            [
                                103.36907,
                                -4.80281
                            ],
                            [
                                103.41456,
                                -4.87116
                            ],
                            [
                                103.51002,
                                -4.88393
                            ],
                            [
                                103.53682,
                                -4.91561
                            ],
                            [
                                103.70432,
                                -4.96184
                            ],
                            [
                                103.9259,
                                -5.16177
                            ],
                            [
                                103.90349,
                                -5.23392
                            ],
                            [
                                104.00168,
                                -5.28145
                            ],
                            [
                                103.99255,
                                -5.31786
                            ],
                            [
                                104.11309,
                                -5.45594
                            ],
                            [
                                104.19223,
                                -5.49968
                            ],
                            [
                                104.30405,
                                -5.59528
                            ],
                            [
                                104.29065,
                                -5.64161
                            ],
                            [
                                104.40663,
                                -5.70965
                            ],
                            [
                                104.44228,
                                -5.76382
                            ],
                            [
                                104.54136,
                                -5.85343
                            ],
                            [
                                104.58991,
                                -5.93969
                            ],
                            [
                                104.70832,
                                -5.93676
                            ],
                            [
                                104.70409,
                                -5.83701
                            ],
                            [
                                104.63919,
                                -5.74192
                            ],
                            [
                                104.62315,
                                -5.67201
                            ],
                            [
                                104.56208,
                                -5.60818
                            ],
                            [
                                104.52858,
                                -5.52453
                            ],
                            [
                                104.5874,
                                -5.50004
                            ],
                            [
                                104.68987,
                                -5.52202
                            ],
                            [
                                104.77055,
                                -5.60939
                            ],
                            [
                                104.89404,
                                -5.66374
                            ],
                            [
                                104.9355,
                                -5.70402
                            ],
                            [
                                105.15872,
                                -5.80495
                            ],
                            [
                                105.18829,
                                -5.62603
                            ],
                            [
                                105.24062,
                                -5.58107
                            ],
                            [
                                105.25346,
                                -5.46672
                            ],
                            [
                                105.29002,
                                -5.44742
                            ],
                            [
                                105.40833,
                                -5.61848
                            ],
                            [
                                105.53779,
                                -5.67049
                            ],
                            [
                                105.58168,
                                -5.73411
                            ],
                            [
                                105.58489,
                                -5.80619
                            ],
                            [
                                105.70205,
                                -5.85113
                            ],
                            [
                                105.72644,
                                -5.89821
                            ],
                            [
                                105.7924,
                                -5.79304
                            ],
                            [
                                105.79006,
                                -5.71736
                            ],
                            [
                                105.81929,
                                -5.63937
                            ],
                            [
                                105.80999,
                                -5.5429
                            ],
                            [
                                105.82573,
                                -5.45991
                            ],
                            [
                                105.82262,
                                -5.32672
                            ],
                            [
                                105.8602,
                                -5.24211
                            ],
                            [
                                105.85739,
                                -5.02259
                            ],
                            [
                                105.90886,
                                -4.9348
                            ],
                            [
                                105.86263,
                                -4.80493
                            ],
                            [
                                105.87622,
                                -4.69511
                            ],
                            [
                                105.91337,
                                -4.66288
                            ],
                            [
                                105.88305,
                                -4.60747
                            ],
                            [
                                105.90158,
                                -4.45326
                            ],
                            [
                                105.82405,
                                -4.32476
                            ],
                            [
                                105.8184,
                                -4.25515
                            ],
                            [
                                105.84164,
                                -4.09249
                            ],
                            [
                                105.88463,
                                -3.97675
                            ],
                            [
                                105.95059,
                                -3.86115
                            ],
                            [
                                105.92379,
                                -3.78595
                            ],
                            [
                                105.85571,
                                -3.76059
                            ],
                            [
                                105.81841,
                                -3.70539
                            ],
                            [
                                105.81658,
                                -3.63373
                            ],
                            [
                                105.87748,
                                -3.43848
                            ],
                            [
                                105.96486,
                                -3.31981
                            ],
                            [
                                106.05374,
                                -3.26844
                            ],
                            [
                                106.07884,
                                -3.20871
                            ],
                            [
                                106.05321,
                                -3.13168
                            ],
                            [
                                106.0507,
                                -3.00663
                            ],
                            [
                                105.95525,
                                -2.94832
                            ],
                            [
                                105.87182,
                                -2.95898
                            ],
                            [
                                105.81794,
                                -2.92374
                            ],
                            [
                                105.78217,
                                -2.85983
                            ],
                            [
                                105.78176,
                                -2.70743
                            ],
                            [
                                105.65041,
                                -2.66255
                            ],
                            [
                                105.60823,
                                -2.5954
                            ],
                            [
                                105.60057,
                                -2.53261
                            ],
                            [
                                105.6245,
                                -2.43225
                            ],
                            [
                                105.47495,
                                -2.39878
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                141.0,
                                -2.6087
                            ],
                            [
                                140.92233,
                                -2.62627
                            ],
                            [
                                140.79842,
                                -2.59815
                            ],
                            [
                                140.78509,
                                -2.62922
                            ],
                            [
                                140.69993,
                                -2.61869
                            ],
                            [
                                140.75246,
                                -2.51884
                            ],
                            [
                                140.70727,
                                -2.4796
                            ],
                            [
                                140.49827,
                                -2.43807
                            ],
                            [
                                140.36491,
                                -2.40196
                            ],
                            [
                                140.37242,
                                -2.45302
                            ],
                            [
                                140.21298,
                                -2.40638
                            ],
                            [
                                140.1222,
                                -2.33043
                            ],
                            [
                                140.06384,
                                -2.35756
                            ],
                            [
                                139.82372,
                                -2.37644
                            ],
                            [
                                139.75631,
                                -2.35543
                            ],
                            [
                                139.6614,
                                -2.29001
                            ],
                            [
                                139.52742,
                                -2.23449
                            ],
                            [
                                139.35747,
                                -2.13683
                            ],
                            [
                                139.25755,
                                -2.10789
                            ],
                            [
                                138.99906,
                                -1.9703
                            ],
                            [
                                138.8577,
                                -1.96195
                            ],
                            [
                                138.66587,
                                -1.80164
                            ],
                            [
                                138.5134,
                                -1.76575
                            ],
                            [
                                138.29202,
                                -1.69199
                            ],
                            [
                                138.19288,
                                -1.64261
                            ],
                            [
                                138.08069,
                                -1.61329
                            ],
                            [
                                137.96844,
                                -1.53195
                            ],
                            [
                                137.9247,
                                -1.47631
                            ],
                            [
                                137.80433,
                                -1.47374
                            ],
                            [
                                137.66797,
                                -1.52376
                            ],
                            [
                                137.48726,
                                -1.6315
                            ],
                            [
                                137.31779,
                                -1.71439
                            ],
                            [
                                137.26651,
                                -1.75665
                            ],
                            [
                                137.18412,
                                -1.77504
                            ],
                            [
                                137.16007,
                                -1.84645
                            ],
                            [
                                137.1793,
                                -1.93196
                            ],
                            [
                                137.25638,
                                -2.01319
                            ],
                            [
                                137.24891,
                                -2.05177
                            ],
                            [
                                137.18163,
                                -2.08974
                            ],
                            [
                                137.05593,
                                -2.09942
                            ],
                            [
                                137.01198,
                                -2.13153
                            ],
                            [
                                136.95103,
                                -2.1186
                            ],
                            [
                                136.9185,
                                -2.17226
                            ],
                            [
                                136.83255,
                                -2.19397
                            ],
                            [
                                136.75082,
                                -2.25795
                            ],
                            [
                                136.54032,
                                -2.23587
                            ],
                            [
                                136.51677,
                                -2.19199
                            ],
                            [
                                136.407,
                                -2.21429
                            ],
                            [
                                136.33475,
                                -2.28047
                            ],
                            [
                                136.34481,
                                -2.36092
                            ],
                            [
                                136.3038,
                                -2.41477
                            ],
                            [
                                136.28109,
                                -2.52132
                            ],
                            [
                                136.23221,
                                -2.61418
                            ],
                            [
                                136.12445,
                                -2.66662
                            ],
                            [
                                136.03069,
                                -2.69127
                            ],
                            [
                                135.96713,
                                -2.77122
                            ],
                            [
                                135.92791,
                                -2.86277
                            ],
                            [
                                135.94364,
                                -2.88662
                            ],
                            [
                                135.92037,
                                -2.98474
                            ],
                            [
                                135.86993,
                                -2.98604
                            ],
                            [
                                135.73579,
                                -3.06036
                            ],
                            [
                                135.77563,
                                -3.09829
                            ],
                            [
                                135.69937,
                                -3.14972
                            ],
                            [
                                135.60784,
                                -3.18629
                            ],
                            [
                                135.56494,
                                -3.28745
                            ],
                            [
                                135.50583,
                                -3.35036
                            ],
                            [
                                135.36004,
                                -3.37851
                            ],
                            [
                                135.15792,
                                -3.35761
                            ],
                            [
                                135.11169,
                                -3.3669
                            ],
                            [
                                135.07219,
                                -3.32845
                            ],
                            [
                                134.98676,
                                -3.31733
                            ],
                            [
                                134.93697,
                                -3.26459
                            ],
                            [
                                134.87253,
                                -3.24406
                            ],
                            [
                                134.86819,
                                -3.16008
                            ],
                            [
                                134.82457,
                                -3.10441
                            ],
                            [
                                134.82532,
                                -3.02641
                            ],
                            [
                                134.8605,
                                -2.99733
                            ],
                            [
                                134.86045,
                                -2.89444
                            ],
                            [
                                134.78786,
                                -2.95206
                            ],
                            [
                                134.78004,
                                -2.99036
                            ],
                            [
                                134.69927,
                                -2.96813
                            ],
                            [
                                134.66774,
                                -2.83674
                            ],
                            [
                                134.65975,
                                -2.53641
                            ],
                            [
                                134.64046,
                                -2.4852
                            ],
                            [
                                134.57895,
                                -2.4603
                            ],
                            [
                                134.48884,
                                -2.52388
                            ],
                            [
                                134.47195,
                                -2.58233
                            ],
                            [
                                134.50426,
                                -2.66566
                            ],
                            [
                                134.53274,
                                -2.79945
                            ],
                            [
                                134.50542,
                                -2.86334
                            ],
                            [
                                134.41935,
                                -2.76856
                            ],
                            [
                                134.41529,
                                -2.72715
                            ],
                            [
                                134.34148,
                                -2.5895
                            ],
                            [
                                134.33101,
                                -2.51427
                            ],
                            [
                                134.22892,
                                -2.41398
                            ],
                            [
                                134.16959,
                                -2.29635
                            ],
                            [
                                134.15095,
                                -2.16086
                            ],
                            [
                                134.11855,
                                -2.05608
                            ],
                            [
                                134.15651,
                                -2.00112
                            ],
                            [
                                134.12503,
                                -1.86014
                            ],
                            [
                                134.10511,
                                -1.69598
                            ],
                            [
                                134.21952,
                                -1.55511
                            ],
                            [
                                134.23356,
                                -1.41115
                            ],
                            [
                                134.28469,
                                -1.34135
                            ],
                            [
                                134.20997,
                                -1.21038
                            ],
                            [
                                134.12162,
                                -1.1324
                            ],
                            [
                                134.0851,
                                -1.02722
                            ],
                            [
                                134.02715,
                                -0.95248
                            ],
                            [
                                134.10086,
                                -0.81436
                            ],
                            [
                                134.05404,
                                -0.79637
                            ],
                            [
                                133.97752,
                                -0.71702
                            ],
                            [
                                133.89772,
                                -0.718
                            ],
                            [
                                133.83893,
                                -0.74495
                            ],
                            [
                                133.76351,
                                -0.72224
                            ],
                            [
                                133.74176,
                                -0.7497
                            ],
                            [
                                133.60068,
                                -0.72186
                            ],
                            [
                                133.57222,
                                -0.74309
                            ],
                            [
                                133.42017,
                                -0.73446
                            ],
                            [
                                133.34423,
                                -0.68805
                            ],
                            [
                                133.25627,
                                -0.59655
                            ],
                            [
                                133.17274,
                                -0.53716
                            ],
                            [
                                132.97682,
                                -0.47883
                            ],
                            [
                                132.75599,
                                -0.38413
                            ],
                            [
                                132.64753,
                                -0.35783
                            ],
                            [
                                132.41076,
                                -0.34381
                            ],
                            [
                                132.33691,
                                -0.37914
                            ],
                            [
                                132.26257,
                                -0.37722
                            ],
                            [
                                132.18539,
                                -0.41139
                            ],
                            [
                                132.07284,
                                -0.48826
                            ],
                            [
                                132.05124,
                                -0.54046
                            ],
                            [
                                131.97853,
                                -0.56713
                            ],
                            [
                                131.83096,
                                -0.70963
                            ],
                            [
                                131.72034,
                                -0.74024
                            ],
                            [
                                131.55055,
                                -0.77139
                            ],
                            [
                                131.51733,
                                -0.73715
                            ],
                            [
                                131.25284,
                                -0.8266
                            ],
                            [
                                131.244,
                                -0.88097
                            ],
                            [
                                131.27436,
                                -0.99957
                            ],
                            [
                                131.24452,
                                -1.08613
                            ],
                            [
                                131.17039,
                                -1.22639
                            ],
                            [
                                131.07635,
                                -1.24878
                            ],
                            [
                                131.02659,
                                -1.29475
                            ],
                            [
                                131.00067,
                                -1.38003
                            ],
                            [
                                130.93968,
                                -1.42421
                            ],
                            [
                                130.99583,
                                -1.46212
                            ],
                            [
                                131.09241,
                                -1.45538
                            ],
                            [
                                131.16235,
                                -1.47363
                            ],
                            [
                                131.20942,
                                -1.52568
                            ],
                            [
                                131.28184,
                                -1.50797
                            ],
                            [
                                131.33437,
                                -1.45719
                            ],
                            [
                                131.38717,
                                -1.46088
                            ],
                            [
                                131.45347,
                                -1.50993
                            ],
                            [
                                131.54502,
                                -1.48793
                            ],
                            [
                                131.63806,
                                -1.4293
                            ],
                            [
                                131.70826,
                                -1.42662
                            ],
                            [
                                131.73728,
                                -1.44778
                            ],
                            [
                                131.73666,
                                -1.51104
                            ],
                            [
                                131.81837,
                                -1.60761
                            ],
                            [
                                131.85876,
                                -1.56769
                            ],
                            [
                                131.90728,
                                -1.7079
                            ],
                            [
                                132.00751,
                                -1.67132
                            ],
                            [
                                132.04108,
                                -1.71409
                            ],
                            [
                                131.92892,
                                -1.8084
                            ],
                            [
                                131.92504,
                                -1.87765
                            ],
                            [
                                131.98641,
                                -1.92015
                            ],
                            [
                                131.97444,
                                -1.96826
                            ],
                            [
                                132.0139,
                                -2.01377
                            ],
                            [
                                132.10465,
                                -2.00962
                            ],
                            [
                                132.04668,
                                -2.08563
                            ],
                            [
                                132.18544,
                                -2.16177
                            ],
                            [
                                132.30789,
                                -2.28842
                            ],
                            [
                                132.37829,
                                -2.27324
                            ],
                            [
                                132.45695,
                                -2.22643
                            ],
                            [
                                132.56583,
                                -2.1941
                            ],
                            [
                                132.62497,
                                -2.27393
                            ],
                            [
                                132.71974,
                                -2.29608
                            ],
                            [
                                132.83794,
                                -2.24887
                            ],
                            [
                                132.90092,
                                -2.28401
                            ],
                            [
                                132.9687,
                                -2.29244
                            ],
                            [
                                133.04908,
                                -2.24424
                            ],
                            [
                                133.17883,
                                -2.2028
                            ],
                            [
                                133.25063,
                                -2.21372
                            ],
                            [
                                133.40062,
                                -2.20997
                            ],
                            [
                                133.53994,
                                -2.23418
                            ],
                            [
                                133.59519,
                                -2.20756
                            ],
                            [
                                133.65047,
                                -2.2267
                            ],
                            [
                                133.73831,
                                -2.16664
                            ],
                            [
                                133.96394,
                                -2.11311
                            ],
                            [
                                133.9642,
                                -2.24124
                            ],
                            [
                                133.94564,
                                -2.29728
                            ],
                            [
                                134.02673,
                                -2.40021
                            ],
                            [
                                133.98813,
                                -2.46289
                            ],
                            [
                                133.94455,
                                -2.3987
                            ],
                            [
                                133.88121,
                                -2.38685
                            ],
                            [
                                133.84399,
                                -2.42031
                            ],
                            [
                                133.75452,
                                -2.42883
                            ],
                            [
                                133.79759,
                                -2.52211
                            ],
                            [
                                133.70954,
                                -2.52203
                            ],
                            [
                                133.61358,
                                -2.54595
                            ],
                            [
                                133.58168,
                                -2.60432
                            ],
                            [
                                133.53727,
                                -2.60919
                            ],
                            [
                                133.50333,
                                -2.53305
                            ],
                            [
                                133.39357,
                                -2.5296
                            ],
                            [
                                133.31665,
                                -2.44317
                            ],
                            [
                                133.24862,
                                -2.41234
                            ],
                            [
                                133.14798,
                                -2.42691
                            ],
                            [
                                133.06006,
                                -2.47297
                            ],
                            [
                                132.8292,
                                -2.73724
                            ],
                            [
                                132.72506,
                                -2.80904
                            ],
                            [
                                132.64844,
                                -2.77471
                            ],
                            [
                                132.56769,
                                -2.71025
                            ],
                            [
                                132.31558,
                                -2.67847
                            ],
                            [
                                132.19488,
                                -2.67157
                            ],
                            [
                                132.13079,
                                -2.68641
                            ],
                            [
                                132.1329,
                                -2.7306
                            ],
                            [
                                132.02806,
                                -2.79139
                            ],
                            [
                                132.00509,
                                -2.90729
                            ],
                            [
                                132.10787,
                                -2.94586
                            ],
                            [
                                132.2564,
                                -2.93695
                            ],
                            [
                                132.33799,
                                -2.95181
                            ],
                            [
                                132.42206,
                                -3.00434
                            ],
                            [
                                132.54762,
                                -3.10483
                            ],
                            [
                                132.59039,
                                -3.22706
                            ],
                            [
                                132.6611,
                                -3.31613
                            ],
                            [
                                132.72489,
                                -3.32411
                            ],
                            [
                                132.76661,
                                -3.25968
                            ],
                            [
                                132.82905,
                                -3.30204
                            ],
                            [
                                132.79591,
                                -3.36038
                            ],
                            [
                                132.813,
                                -3.44119
                            ],
                            [
                                132.87865,
                                -3.46289
                            ],
                            [
                                132.9232,
                                -3.55025
                            ],
                            [
                                132.88199,
                                -3.64444
                            ],
                            [
                                132.74396,
                                -3.63214
                            ],
                            [
                                132.73271,
                                -3.6879
                            ],
                            [
                                132.7865,
                                -3.84201
                            ],
                            [
                                132.82607,
                                -3.92119
                            ],
                            [
                                132.83141,
                                -3.98792
                            ],
                            [
                                132.8908,
                                -4.03889
                            ],
                            [
                                132.90235,
                                -4.08482
                            ],
                            [
                                133.00679,
                                -4.10546
                            ],
                            [
                                133.06188,
                                -4.05565
                            ],
                            [
                                133.24529,
                                -4.06765
                            ],
                            [
                                133.30975,
                                -4.01521
                            ],
                            [
                                133.41175,
                                -3.88594
                            ],
                            [
                                133.4512,
                                -3.8646
                            ],
                            [
                                133.40214,
                                -3.75194
                            ],
                            [
                                133.41829,
                                -3.68477
                            ],
                            [
                                133.4623,
                                -3.67313
                            ],
                            [
                                133.50901,
                                -3.61781
                            ],
                            [
                                133.58511,
                                -3.5679
                            ],
                            [
                                133.6026,
                                -3.51512
                            ],
                            [
                                133.55995,
                                -3.45323
                            ],
                            [
                                133.64074,
                                -3.40698
                            ],
                            [
                                133.67156,
                                -3.36669
                            ],
                            [
                                133.66515,
                                -3.11823
                            ],
                            [
                                133.73698,
                                -3.03584
                            ],
                            [
                                133.8051,
                                -3.01706
                            ],
                            [
                                133.83441,
                                -2.94429
                            ],
                            [
                                133.87316,
                                -2.95039
                            ],
                            [
                                133.87706,
                                -3.02748
                            ],
                            [
                                133.78698,
                                -3.11529
                            ],
                            [
                                133.77851,
                                -3.1724
                            ],
                            [
                                133.7256,
                                -3.16907
                            ],
                            [
                                133.67878,
                                -3.2431
                            ],
                            [
                                133.70531,
                                -3.40703
                            ],
                            [
                                133.6377,
                                -3.4732
                            ],
                            [
                                133.71512,
                                -3.59769
                            ],
                            [
                                133.76549,
                                -3.64716
                            ],
                            [
                                133.80402,
                                -3.58151
                            ],
                            [
                                133.92115,
                                -3.71213
                            ],
                            [
                                133.93421,
                                -3.78836
                            ],
                            [
                                133.99696,
                                -3.84969
                            ],
                            [
                                134.1839,
                                -3.77333
                            ],
                            [
                                134.20067,
                                -3.82359
                            ],
                            [
                                134.18345,
                                -3.89151
                            ],
                            [
                                134.20629,
                                -3.93695
                            ],
                            [
                                134.26688,
                                -3.96178
                            ],
                            [
                                134.44833,
                                -3.91016
                            ],
                            [
                                134.46374,
                                -3.9693
                            ],
                            [
                                134.5188,
                                -4.02186
                            ],
                            [
                                134.60415,
                                -3.98638
                            ],
                            [
                                134.67119,
                                -3.91774
                            ],
                            [
                                134.69259,
                                -3.96118
                            ],
                            [
                                134.64002,
                                -4.10996
                            ],
                            [
                                134.71648,
                                -4.13288
                            ],
                            [
                                134.73525,
                                -4.19003
                            ],
                            [
                                134.83013,
                                -4.24966
                            ],
                            [
                                134.90687,
                                -4.25993
                            ],
                            [
                                135.09762,
                                -4.39042
                            ],
                            [
                                135.19507,
                                -4.44155
                            ],
                            [
                                135.39169,
                                -4.42759
                            ],
                            [
                                135.5062,
                                -4.43649
                            ],
                            [
                                135.73433,
                                -4.48767
                            ],
                            [
                                135.93621,
                                -4.49243
                            ],
                            [
                                136.12002,
                                -4.61042
                            ],
                            [
                                136.25158,
                                -4.66027
                            ],
                            [
                                136.34762,
                                -4.66336
                            ],
                            [
                                136.46355,
                                -4.69991
                            ],
                            [
                                136.61003,
                                -4.80256
                            ],
                            [
                                136.69492,
                                -4.81579
                            ],
                            [
                                136.7434,
                                -4.86256
                            ],
                            [
                                136.77003,
                                -4.80504
                            ],
                            [
                                136.82686,
                                -4.89851
                            ],
                            [
                                136.88857,
                                -4.88322
                            ],
                            [
                                137.00449,
                                -4.93406
                            ],
                            [
                                137.05659,
                                -4.91529
                            ],
                            [
                                137.05263,
                                -4.84028
                            ],
                            [
                                137.1022,
                                -4.84557
                            ],
                            [
                                137.07009,
                                -4.93529
                            ],
                            [
                                137.18638,
                                -4.98771
                            ],
                            [
                                137.3003,
                                -4.99524
                            ],
                            [
                                137.35693,
                                -5.06972
                            ],
                            [
                                137.40541,
                                -5.10109
                            ],
                            [
                                137.4576,
                                -5.08384
                            ],
                            [
                                137.4915,
                                -5.13324
                            ],
                            [
                                137.55316,
                                -5.1071
                            ],
                            [
                                137.55931,
                                -5.17368
                            ],
                            [
                                137.69839,
                                -5.23849
                            ],
                            [
                                137.76871,
                                -5.29051
                            ],
                            [
                                137.79037,
                                -5.34326
                            ],
                            [
                                137.88173,
                                -5.36077
                            ],
                            [
                                137.99443,
                                -5.47285
                            ],
                            [
                                138.08399,
                                -5.52554
                            ],
                            [
                                138.03534,
                                -5.60247
                            ],
                            [
                                138.06429,
                                -5.72651
                            ],
                            [
                                138.16329,
                                -5.74978
                            ],
                            [
                                138.19293,
                                -5.8013
                            ],
                            [
                                138.2712,
                                -5.83049
                            ],
                            [
                                138.25589,
                                -5.90586
                            ],
                            [
                                138.31895,
                                -5.98551
                            ],
                            [
                                138.38089,
                                -6.13979
                            ],
                            [
                                138.37063,
                                -6.20264
                            ],
                            [
                                138.4041,
                                -6.33877
                            ],
                            [
                                138.65733,
                                -6.59982
                            ],
                            [
                                138.77467,
                                -6.66428
                            ],
                            [
                                138.85506,
                                -6.79394
                            ],
                            [
                                138.91815,
                                -6.78048
                            ],
                            [
                                138.94666,
                                -6.82316
                            ],
                            [
                                138.78613,
                                -6.85628
                            ],
                            [
                                138.74982,
                                -6.89199
                            ],
                            [
                                138.67003,
                                -6.90881
                            ],
                            [
                                138.6072,
                                -6.88657
                            ],
                            [
                                138.55091,
                                -6.90741
                            ],
                            [
                                138.55193,
                                -6.95571
                            ],
                            [
                                138.64072,
                                -7.016
                            ],
                            [
                                138.76435,
                                -7.1208
                            ],
                            [
                                138.83568,
                                -7.15009
                            ],
                            [
                                138.94807,
                                -7.16001
                            ],
                            [
                                139.05307,
                                -7.20378
                            ],
                            [
                                139.18052,
                                -7.2023
                            ],
                            [
                                139.18546,
                                -7.22619
                            ],
                            [
                                139.03165,
                                -7.23737
                            ],
                            [
                                138.91067,
                                -7.19242
                            ],
                            [
                                138.79938,
                                -7.20424
                            ],
                            [
                                138.69016,
                                -7.19554
                            ],
                            [
                                138.74446,
                                -7.27237
                            ],
                            [
                                138.83358,
                                -7.31033
                            ],
                            [
                                138.92984,
                                -7.40728
                            ],
                            [
                                138.96334,
                                -7.51332
                            ],
                            [
                                139.11821,
                                -7.53712
                            ],
                            [
                                139.12841,
                                -7.59144
                            ],
                            [
                                139.09205,
                                -7.62973
                            ],
                            [
                                139.04682,
                                -7.74269
                            ],
                            [
                                139.05109,
                                -7.83379
                            ],
                            [
                                138.96779,
                                -7.87921
                            ],
                            [
                                138.94773,
                                -8.06471
                            ],
                            [
                                138.87273,
                                -8.09724
                            ],
                            [
                                138.87485,
                                -8.14023
                            ],
                            [
                                138.95187,
                                -8.25675
                            ],
                            [
                                139.004,
                                -8.18504
                            ],
                            [
                                139.10483,
                                -8.10993
                            ],
                            [
                                139.24403,
                                -8.06611
                            ],
                            [
                                139.2976,
                                -8.12896
                            ],
                            [
                                139.35946,
                                -8.16127
                            ],
                            [
                                139.50594,
                                -8.13205
                            ],
                            [
                                139.57908,
                                -8.08159
                            ],
                            [
                                139.67203,
                                -8.07072
                            ],
                            [
                                139.76571,
                                -8.08206
                            ],
                            [
                                139.84228,
                                -8.11421
                            ],
                            [
                                139.93891,
                                -8.12881
                            ],
                            [
                                139.96162,
                                -8.18934
                            ],
                            [
                                140.04275,
                                -8.25823
                            ],
                            [
                                140.18938,
                                -8.34664
                            ],
                            [
                                140.30504,
                                -8.44931
                            ],
                            [
                                140.34596,
                                -8.46857
                            ],
                            [
                                140.49934,
                                -8.61358
                            ],
                            [
                                140.53632,
                                -8.68984
                            ],
                            [
                                140.62666,
                                -8.81634
                            ],
                            [
                                140.7957,
                                -8.94367
                            ],
                            [
                                140.91558,
                                -9.0841
                            ],
                            [
                                141.01944,
                                -9.12962
                            ],
                            [
                                141.01915,
                                -8.59413
                            ],
                            [
                                141.01843,
                                -7.2958
                            ],
                            [
                                141.01822,
                                -6.89888
                            ],
                            [
                                140.90171,
                                -6.84922
                            ],
                            [
                                140.89718,
                                -6.75302
                            ],
                            [
                                140.84935,
                                -6.71828
                            ],
                            [
                                140.8687,
                                -6.61808
                            ],
                            [
                                140.92742,
                                -6.56182
                            ],
                            [
                                140.92677,
                                -6.45858
                            ],
                            [
                                140.99982,
                                -6.3088
                            ],
                            [
                                141.0,
                                -2.6087
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                120.41432,
                                -3.6056
                            ],
                            [
                                120.37634,
                                -3.50694
                            ],
                            [
                                120.39767,
                                -3.4181
                            ],
                            [
                                120.39219,
                                -3.29327
                            ],
                            [
                                120.37096,
                                -3.20594
                            ],
                            [
                                120.25567,
                                -3.16032
                            ],
                            [
                                120.25614,
                                -3.07478
                            ],
                            [
                                120.19284,
                                -2.97099
                            ],
                            [
                                120.27078,
                                -2.93302
                            ],
                            [
                                120.34239,
                                -2.87456
                            ],
                            [
                                120.45587,
                                -2.82213
                            ],
                            [
                                120.57054,
                                -2.6945
                            ],
                            [
                                120.67389,
                                -2.65306
                            ],
                            [
                                120.80604,
                                -2.62687
                            ],
                            [
                                120.85143,
                                -2.65755
                            ],
                            [
                                120.98694,
                                -2.6783
                            ],
                            [
                                121.08246,
                                -2.71789
                            ],
                            [
                                120.99264,
                                -2.81869
                            ],
                            [
                                121.0837,
                                -2.9234
                            ],
                            [
                                121.08408,
                                -2.99942
                            ],
                            [
                                121.05564,
                                -3.0652
                            ],
                            [
                                121.05507,
                                -3.16366
                            ],
                            [
                                121.01491,
                                -3.23804
                            ],
                            [
                                120.97166,
                                -3.26314
                            ],
                            [
                                120.95118,
                                -3.32199
                            ],
                            [
                                120.86899,
                                -3.44295
                            ],
                            [
                                120.88158,
                                -3.52741
                            ],
                            [
                                120.94942,
                                -3.61781
                            ],
                            [
                                121.071,
                                -3.70085
                            ],
                            [
                                121.16691,
                                -3.81882
                            ],
                            [
                                121.24002,
                                -3.82632
                            ],
                            [
                                121.24985,
                                -3.87791
                            ],
                            [
                                121.29784,
                                -3.89321
                            ],
                            [
                                121.33576,
                                -3.97715
                            ],
                            [
                                121.56256,
                                -4.03824
                            ],
                            [
                                121.60302,
                                -4.06248
                            ],
                            [
                                121.61265,
                                -4.13239
                            ],
                            [
                                121.57724,
                                -4.23325
                            ],
                            [
                                121.52526,
                                -4.27896
                            ],
                            [
                                121.51918,
                                -4.40099
                            ],
                            [
                                121.47808,
                                -4.54117
                            ],
                            [
                                121.46689,
                                -4.67424
                            ],
                            [
                                121.53884,
                                -4.76473
                            ],
                            [
                                121.65829,
                                -4.80766
                            ],
                            [
                                121.71295,
                                -4.85111
                            ],
                            [
                                121.82587,
                                -4.83508
                            ],
                            [
                                121.86523,
                                -4.86532
                            ],
                            [
                                121.98466,
                                -4.89511
                            ],
                            [
                                122.07613,
                                -4.85039
                            ],
                            [
                                122.09227,
                                -4.79446
                            ],
                            [
                                122.04713,
                                -4.76212
                            ],
                            [
                                122.03489,
                                -4.67008
                            ],
                            [
                                122.08274,
                                -4.54435
                            ],
                            [
                                122.15772,
                                -4.52203
                            ],
                            [
                                122.21423,
                                -4.47028
                            ],
                            [
                                122.25648,
                                -4.48332
                            ],
                            [
                                122.38205,
                                -4.45037
                            ],
                            [
                                122.41613,
                                -4.42682
                            ],
                            [
                                122.50487,
                                -4.44671
                            ],
                            [
                                122.59356,
                                -4.39323
                            ],
                            [
                                122.74656,
                                -4.50122
                            ],
                            [
                                122.77127,
                                -4.40217
                            ],
                            [
                                122.83329,
                                -4.44169
                            ],
                            [
                                122.88988,
                                -4.39609
                            ],
                            [
                                122.87982,
                                -4.29181
                            ],
                            [
                                122.90119,
                                -4.23233
                            ],
                            [
                                122.88961,
                                -4.13624
                            ],
                            [
                                122.82776,
                                -4.14767
                            ],
                            [
                                122.66642,
                                -4.13288
                            ],
                            [
                                122.65623,
                                -4.00783
                            ],
                            [
                                122.59172,
                                -3.96926
                            ],
                            [
                                122.66261,
                                -3.91984
                            ],
                            [
                                122.63861,
                                -3.89028
                            ],
                            [
                                122.51826,
                                -3.88586
                            ],
                            [
                                122.43885,
                                -3.75031
                            ],
                            [
                                122.35228,
                                -3.74141
                            ],
                            [
                                122.29997,
                                -3.68378
                            ],
                            [
                                122.19811,
                                -3.6056
                            ],
                            [
                                122.19563,
                                -3.55682
                            ],
                            [
                                122.27303,
                                -3.53535
                            ],
                            [
                                122.29252,
                                -3.46083
                            ],
                            [
                                122.25822,
                                -3.42219
                            ],
                            [
                                122.27834,
                                -3.29826
                            ],
                            [
                                122.3223,
                                -3.23288
                            ],
                            [
                                122.39943,
                                -3.23507
                            ],
                            [
                                122.45753,
                                -3.14133
                            ],
                            [
                                122.37074,
                                -3.12887
                            ],
                            [
                                122.25215,
                                -3.02263
                            ],
                            [
                                122.31525,
                                -2.92106
                            ],
                            [
                                122.28892,
                                -2.88969
                            ],
                            [
                                122.17953,
                                -2.86605
                            ],
                            [
                                122.17376,
                                -2.8174
                            ],
                            [
                                122.07845,
                                -2.77928
                            ],
                            [
                                122.01088,
                                -2.71211
                            ],
                            [
                                122.03057,
                                -2.66044
                            ],
                            [
                                121.98844,
                                -2.60801
                            ],
                            [
                                121.9564,
                                -2.5236
                            ],
                            [
                                121.86586,
                                -2.39591
                            ],
                            [
                                121.82342,
                                -2.30365
                            ],
                            [
                                121.72334,
                                -2.20109
                            ],
                            [
                                121.67943,
                                -2.17801
                            ],
                            [
                                121.55155,
                                -2.16806
                            ],
                            [
                                121.52969,
                                -2.05221
                            ],
                            [
                                121.44709,
                                -1.99188
                            ],
                            [
                                121.40311,
                                -1.91116
                            ],
                            [
                                121.37003,
                                -1.97466
                            ],
                            [
                                121.31279,
                                -1.9246
                            ],
                            [
                                121.34818,
                                -1.86977
                            ],
                            [
                                121.29368,
                                -1.85188
                            ],
                            [
                                121.33783,
                                -1.77928
                            ],
                            [
                                121.37174,
                                -1.81175
                            ],
                            [
                                121.43973,
                                -1.81244
                            ],
                            [
                                121.44518,
                                -1.86238
                            ],
                            [
                                121.53426,
                                -1.91236
                            ],
                            [
                                121.5622,
                                -1.94938
                            ],
                            [
                                121.63217,
                                -1.95109
                            ],
                            [
                                121.69168,
                                -1.91882
                            ],
                            [
                                121.74109,
                                -1.85875
                            ],
                            [
                                121.79637,
                                -1.73561
                            ],
                            [
                                121.86023,
                                -1.6808
                            ],
                            [
                                121.89168,
                                -1.70021
                            ],
                            [
                                121.95908,
                                -1.67522
                            ],
                            [
                                122.02585,
                                -1.61949
                            ],
                            [
                                122.08384,
                                -1.62516
                            ],
                            [
                                122.21913,
                                -1.60423
                            ],
                            [
                                122.30717,
                                -1.53541
                            ],
                            [
                                122.36584,
                                -1.51496
                            ],
                            [
                                122.42667,
                                -1.43136
                            ],
                            [
                                122.55983,
                                -1.30564
                            ],
                            [
                                122.56557,
                                -1.26195
                            ],
                            [
                                122.62357,
                                -1.23379
                            ],
                            [
                                122.64032,
                                -1.16873
                            ],
                            [
                                122.71441,
                                -1.12504
                            ],
                            [
                                122.79091,
                                -0.99675
                            ],
                            [
                                122.80247,
                                -0.93967
                            ],
                            [
                                122.98784,
                                -0.89434
                            ],
                            [
                                123.05889,
                                -0.89481
                            ],
                            [
                                123.09927,
                                -0.83639
                            ],
                            [
                                123.14338,
                                -0.88487
                            ],
                            [
                                123.17159,
                                -0.9586
                            ],
                            [
                                123.26348,
                                -1.04419
                            ],
                            [
                                123.34773,
                                -1.03675
                            ],
                            [
                                123.39083,
                                -0.95448
                            ],
                            [
                                123.44516,
                                -0.76946
                            ],
                            [
                                123.38992,
                                -0.66924
                            ],
                            [
                                123.40491,
                                -0.64752
                            ],
                            [
                                123.26208,
                                -0.57768
                            ],
                            [
                                123.05597,
                                -0.56427
                            ],
                            [
                                122.95137,
                                -0.63882
                            ],
                            [
                                122.89814,
                                -0.61497
                            ],
                            [
                                122.8132,
                                -0.6309
                            ],
                            [
                                122.77267,
                                -0.69668
                            ],
                            [
                                122.86678,
                                -0.70927
                            ],
                            [
                                122.91401,
                                -0.76203
                            ],
                            [
                                122.78802,
                                -0.77321
                            ],
                            [
                                122.68539,
                                -0.80132
                            ],
                            [
                                122.62591,
                                -0.75912
                            ],
                            [
                                122.53366,
                                -0.77623
                            ],
                            [
                                122.46759,
                                -0.7497
                            ],
                            [
                                122.4105,
                                -0.77097
                            ],
                            [
                                122.19965,
                                -0.7763
                            ],
                            [
                                122.15788,
                                -0.80699
                            ],
                            [
                                122.13616,
                                -0.91184
                            ],
                            [
                                122.0924,
                                -0.94657
                            ],
                            [
                                122.01041,
                                -0.92728
                            ],
                            [
                                121.94753,
                                -0.97737
                            ],
                            [
                                121.70479,
                                -0.94221
                            ],
                            [
                                121.64359,
                                -0.89659
                            ],
                            [
                                121.65556,
                                -0.80794
                            ],
                            [
                                121.61241,
                                -0.80348
                            ],
                            [
                                121.57727,
                                -0.85526
                            ],
                            [
                                121.46369,
                                -0.89404
                            ],
                            [
                                121.4324,
                                -0.96275
                            ],
                            [
                                121.31726,
                                -1.06589
                            ],
                            [
                                121.26577,
                                -1.15533
                            ],
                            [
                                121.19865,
                                -1.22945
                            ],
                            [
                                121.15476,
                                -1.35782
                            ],
                            [
                                121.08983,
                                -1.42648
                            ],
                            [
                                120.97923,
                                -1.40048
                            ],
                            [
                                120.85461,
                                -1.40348
                            ],
                            [
                                120.80481,
                                -1.35169
                            ],
                            [
                                120.68707,
                                -1.41593
                            ],
                            [
                                120.64049,
                                -1.36504
                            ],
                            [
                                120.63056,
                                -1.30762
                            ],
                            [
                                120.56487,
                                -1.25469
                            ],
                            [
                                120.58076,
                                -1.10846
                            ],
                            [
                                120.50631,
                                -0.99061
                            ],
                            [
                                120.45361,
                                -0.98612
                            ],
                            [
                                120.40092,
                                -0.92237
                            ],
                            [
                                120.30338,
                                -0.95416
                            ],
                            [
                                120.11123,
                                -0.74236
                            ],
                            [
                                120.06178,
                                -0.63477
                            ],
                            [
                                120.0468,
                                -0.52874
                            ],
                            [
                                120.06795,
                                -0.44249
                            ],
                            [
                                120.00776,
                                -0.28286
                            ],
                            [
                                120.00734,
                                -0.17976
                            ],
                            [
                                120.03564,
                                -0.1399
                            ],
                            [
                                120.039,
                                -0.06473
                            ],
                            [
                                120.08463,
                                -0.03076
                            ],
                            [
                                120.10633,
                                0.09896
                            ],
                            [
                                120.14717,
                                0.20722
                            ],
                            [
                                120.21169,
                                0.27041
                            ],
                            [
                                120.25597,
                                0.34809
                            ],
                            [
                                120.34749,
                                0.44917
                            ],
                            [
                                120.44809,
                                0.47563
                            ],
                            [
                                120.51534,
                                0.52643
                            ],
                            [
                                120.69434,
                                0.52507
                            ],
                            [
                                120.75185,
                                0.48106
                            ],
                            [
                                120.79788,
                                0.48334
                            ],
                            [
                                120.88301,
                                0.41491
                            ],
                            [
                                121.00221,
                                0.44346
                            ],
                            [
                                121.05091,
                                0.40841
                            ],
                            [
                                121.13093,
                                0.41482
                            ],
                            [
                                121.16253,
                                0.4596
                            ],
                            [
                                121.28488,
                                0.4819
                            ],
                            [
                                121.43487,
                                0.46595
                            ],
                            [
                                121.50915,
                                0.49198
                            ],
                            [
                                121.5236,
                                0.55054
                            ],
                            [
                                121.71504,
                                0.5265
                            ],
                            [
                                121.79308,
                                0.41459
                            ],
                            [
                                122.10435,
                                0.49121
                            ],
                            [
                                122.14667,
                                0.46575
                            ],
                            [
                                122.21839,
                                0.48454
                            ],
                            [
                                122.34126,
                                0.48738
                            ],
                            [
                                122.39046,
                                0.50874
                            ],
                            [
                                122.53116,
                                0.50194
                            ],
                            [
                                122.63629,
                                0.46998
                            ],
                            [
                                122.7903,
                                0.4911
                            ],
                            [
                                122.93466,
                                0.47882
                            ],
                            [
                                123.07987,
                                0.50273
                            ],
                            [
                                123.15694,
                                0.4018
                            ],
                            [
                                123.26654,
                                0.31444
                            ],
                            [
                                123.33819,
                                0.29796
                            ],
                            [
                                123.49317,
                                0.29593
                            ],
                            [
                                123.57208,
                                0.30874
                            ],
                            [
                                123.632,
                                0.27392
                            ],
                            [
                                123.81249,
                                0.327
                            ],
                            [
                                124.05067,
                                0.35767
                            ],
                            [
                                124.14299,
                                0.39053
                            ],
                            [
                                124.22129,
                                0.38387
                            ],
                            [
                                124.49643,
                                0.48291
                            ],
                            [
                                124.50416,
                                0.5465
                            ],
                            [
                                124.57058,
                                0.61393
                            ],
                            [
                                124.63916,
                                0.79499
                            ],
                            [
                                124.68846,
                                0.83002
                            ],
                            [
                                124.7164,
                                0.88762
                            ],
                            [
                                124.76012,
                                0.89078
                            ],
                            [
                                124.79779,
                                0.94153
                            ],
                            [
                                124.89485,
                                0.97608
                            ],
                            [
                                125.01554,
                                1.14175
                            ],
                            [
                                125.0739,
                                1.36387
                            ],
                            [
                                125.13286,
                                1.43428
                            ],
                            [
                                125.22803,
                                1.46857
                            ],
                            [
                                125.24044,
                                1.51837
                            ],
                            [
                                125.15253,
                                1.58045
                            ],
                            [
                                125.16968,
                                1.67616
                            ],
                            [
                                124.96404,
                                1.68239
                            ],
                            [
                                124.92384,
                                1.66783
                            ],
                            [
                                124.80417,
                                1.5655
                            ],
                            [
                                124.83951,
                                1.52049
                            ],
                            [
                                124.81077,
                                1.46252
                            ],
                            [
                                124.76603,
                                1.46462
                            ],
                            [
                                124.67781,
                                1.40099
                            ],
                            [
                                124.61764,
                                1.41872
                            ],
                            [
                                124.51873,
                                1.32349
                            ],
                            [
                                124.59908,
                                1.26751
                            ],
                            [
                                124.58117,
                                1.19562
                            ],
                            [
                                124.4088,
                                1.19595
                            ],
                            [
                                124.34571,
                                1.15887
                            ],
                            [
                                124.30356,
                                1.02698
                            ],
                            [
                                124.19569,
                                0.99211
                            ],
                            [
                                124.12259,
                                0.92797
                            ],
                            [
                                124.07164,
                                0.92154
                            ],
                            [
                                123.87306,
                                0.83119
                            ],
                            [
                                123.75207,
                                0.82535
                            ],
                            [
                                123.60516,
                                0.8847
                            ],
                            [
                                123.54316,
                                0.87027
                            ],
                            [
                                123.43153,
                                0.88855
                            ],
                            [
                                123.3683,
                                0.91667
                            ],
                            [
                                123.29673,
                                0.9132
                            ],
                            [
                                123.20781,
                                0.94929
                            ],
                            [
                                123.06804,
                                0.93053
                            ],
                            [
                                122.95853,
                                0.93423
                            ],
                            [
                                122.92066,
                                0.86689
                            ],
                            [
                                122.86163,
                                0.82933
                            ],
                            [
                                122.79178,
                                0.83977
                            ],
                            [
                                122.77119,
                                0.87718
                            ],
                            [
                                122.68729,
                                0.89806
                            ],
                            [
                                122.6525,
                                0.9432
                            ],
                            [
                                122.51328,
                                0.97857
                            ],
                            [
                                122.45088,
                                1.02157
                            ],
                            [
                                122.41528,
                                0.99468
                            ],
                            [
                                122.29735,
                                1.00588
                            ],
                            [
                                122.22344,
                                0.99737
                            ],
                            [
                                122.15542,
                                1.03681
                            ],
                            [
                                122.06012,
                                1.06618
                            ],
                            [
                                121.97875,
                                1.02378
                            ],
                            [
                                121.9211,
                                1.09754
                            ],
                            [
                                121.82246,
                                1.08577
                            ],
                            [
                                121.65094,
                                1.04469
                            ],
                            [
                                121.49928,
                                1.09156
                            ],
                            [
                                121.42628,
                                1.16824
                            ],
                            [
                                121.47056,
                                1.28717
                            ],
                            [
                                121.40422,
                                1.25448
                            ],
                            [
                                121.3224,
                                1.25432
                            ],
                            [
                                121.25767,
                                1.23034
                            ],
                            [
                                121.10657,
                                1.32063
                            ],
                            [
                                120.95219,
                                1.35245
                            ],
                            [
                                120.91269,
                                1.31652
                            ],
                            [
                                120.81554,
                                1.32565
                            ],
                            [
                                120.82888,
                                1.1977
                            ],
                            [
                                120.79742,
                                1.16436
                            ],
                            [
                                120.81229,
                                1.0446
                            ],
                            [
                                120.74058,
                                0.99014
                            ],
                            [
                                120.646,
                                0.94787
                            ],
                            [
                                120.61018,
                                0.82664
                            ],
                            [
                                120.56274,
                                0.77074
                            ],
                            [
                                120.52024,
                                0.80545
                            ],
                            [
                                120.40182,
                                0.80156
                            ],
                            [
                                120.33639,
                                0.85189
                            ],
                            [
                                120.34239,
                                0.98082
                            ],
                            [
                                120.24654,
                                0.95221
                            ],
                            [
                                120.24061,
                                0.8047
                            ],
                            [
                                120.17951,
                                0.76004
                            ],
                            [
                                120.08203,
                                0.74234
                            ],
                            [
                                120.0257,
                                0.6575
                            ],
                            [
                                120.05177,
                                0.52579
                            ],
                            [
                                120.00131,
                                0.48726
                            ],
                            [
                                119.91241,
                                0.48641
                            ],
                            [
                                119.84597,
                                0.33549
                            ],
                            [
                                119.90162,
                                0.24117
                            ],
                            [
                                119.78226,
                                0.19636
                            ],
                            [
                                119.86511,
                                0.10841
                            ],
                            [
                                119.87838,
                                -0.02
                            ],
                            [
                                119.84112,
                                -0.1002
                            ],
                            [
                                119.78115,
                                -0.10731
                            ],
                            [
                                119.70677,
                                0.00145
                            ],
                            [
                                119.61422,
                                -0.01066
                            ],
                            [
                                119.663,
                                -0.09644
                            ],
                            [
                                119.7089,
                                -0.13526
                            ],
                            [
                                119.79539,
                                -0.12208
                            ],
                            [
                                119.81868,
                                -0.19431
                            ],
                            [
                                119.75688,
                                -0.37123
                            ],
                            [
                                119.77034,
                                -0.51871
                            ],
                            [
                                119.80967,
                                -0.65499
                            ],
                            [
                                119.85868,
                                -0.71541
                            ],
                            [
                                119.88087,
                                -0.82209
                            ],
                            [
                                119.84183,
                                -0.87862
                            ],
                            [
                                119.73698,
                                -0.64884
                            ],
                            [
                                119.66978,
                                -0.71688
                            ],
                            [
                                119.68244,
                                -0.7619
                            ],
                            [
                                119.55051,
                                -0.85225
                            ],
                            [
                                119.46832,
                                -1.01417
                            ],
                            [
                                119.43844,
                                -1.10096
                            ],
                            [
                                119.33306,
                                -1.17908
                            ],
                            [
                                119.29575,
                                -1.27832
                            ],
                            [
                                119.32868,
                                -1.34715
                            ],
                            [
                                119.29001,
                                -1.39599
                            ],
                            [
                                119.28495,
                                -1.46989
                            ],
                            [
                                119.32697,
                                -1.59434
                            ],
                            [
                                119.29363,
                                -1.67549
                            ],
                            [
                                119.31979,
                                -1.80352
                            ],
                            [
                                119.36608,
                                -1.85895
                            ],
                            [
                                119.33185,
                                -1.96129
                            ],
                            [
                                119.2381,
                                -1.97907
                            ],
                            [
                                119.207,
                                -2.02881
                            ],
                            [
                                119.18103,
                                -2.14931
                            ],
                            [
                                119.14081,
                                -2.20792
                            ],
                            [
                                119.12117,
                                -2.29004
                            ],
                            [
                                119.13607,
                                -2.3957
                            ],
                            [
                                119.1182,
                                -2.48559
                            ],
                            [
                                119.0431,
                                -2.51589
                            ],
                            [
                                118.99263,
                                -2.62584
                            ],
                            [
                                118.87467,
                                -2.68275
                            ],
                            [
                                118.82138,
                                -2.63052
                            ],
                            [
                                118.78228,
                                -2.68496
                            ],
                            [
                                118.75546,
                                -2.78209
                            ],
                            [
                                118.76767,
                                -2.86955
                            ],
                            [
                                118.84594,
                                -2.85979
                            ],
                            [
                                118.88192,
                                -2.90928
                            ],
                            [
                                118.8479,
                                -2.99745
                            ],
                            [
                                118.83868,
                                -3.0765
                            ],
                            [
                                118.77561,
                                -3.09957
                            ],
                            [
                                118.82795,
                                -3.17742
                            ],
                            [
                                118.85441,
                                -3.30265
                            ],
                            [
                                118.84638,
                                -3.3835
                            ],
                            [
                                118.87776,
                                -3.4716
                            ],
                            [
                                118.93358,
                                -3.5676
                            ],
                            [
                                119.02487,
                                -3.51793
                            ],
                            [
                                119.20106,
                                -3.49508
                            ],
                            [
                                119.29927,
                                -3.43039
                            ],
                            [
                                119.41538,
                                -3.46312
                            ],
                            [
                                119.48786,
                                -3.52684
                            ],
                            [
                                119.50563,
                                -3.57039
                            ],
                            [
                                119.45253,
                                -3.68474
                            ],
                            [
                                119.53425,
                                -3.89876
                            ],
                            [
                                119.5865,
                                -3.98525
                            ],
                            [
                                119.62889,
                                -3.98221
                            ],
                            [
                                119.59972,
                                -4.11114
                            ],
                            [
                                119.62941,
                                -4.17573
                            ],
                            [
                                119.58904,
                                -4.2398
                            ],
                            [
                                119.6259,
                                -4.31041
                            ],
                            [
                                119.5968,
                                -4.41521
                            ],
                            [
                                119.57902,
                                -4.59456
                            ],
                            [
                                119.48414,
                                -4.75437
                            ],
                            [
                                119.51746,
                                -4.93597
                            ],
                            [
                                119.46361,
                                -5.03251
                            ],
                            [
                                119.46619,
                                -5.07063
                            ],
                            [
                                119.40121,
                                -5.12576
                            ],
                            [
                                119.38282,
                                -5.18177
                            ],
                            [
                                119.35571,
                                -5.41545
                            ],
                            [
                                119.41795,
                                -5.502
                            ],
                            [
                                119.43504,
                                -5.59726
                            ],
                            [
                                119.49501,
                                -5.55692
                            ],
                            [
                                119.54194,
                                -5.62326
                            ],
                            [
                                119.6493,
                                -5.6328
                            ],
                            [
                                119.69305,
                                -5.70334
                            ],
                            [
                                119.77532,
                                -5.70393
                            ],
                            [
                                119.84416,
                                -5.6689
                            ],
                            [
                                119.84146,
                                -5.63616
                            ],
                            [
                                119.93009,
                                -5.55067
                            ],
                            [
                                120.11525,
                                -5.59084
                            ],
                            [
                                120.22288,
                                -5.542
                            ],
                            [
                                120.34478,
                                -5.52003
                            ],
                            [
                                120.42453,
                                -5.60963
                            ],
                            [
                                120.45691,
                                -5.6023
                            ],
                            [
                                120.40075,
                                -5.3524
                            ],
                            [
                                120.35727,
                                -5.32727
                            ],
                            [
                                120.26257,
                                -5.1459
                            ],
                            [
                                120.28065,
                                -5.12182
                            ],
                            [
                                120.30828,
                                -4.86017
                            ],
                            [
                                120.37831,
                                -4.8396
                            ],
                            [
                                120.4038,
                                -4.70835
                            ],
                            [
                                120.45216,
                                -4.65803
                            ],
                            [
                                120.39337,
                                -4.59703
                            ],
                            [
                                120.35166,
                                -4.42545
                            ],
                            [
                                120.38615,
                                -4.32342
                            ],
                            [
                                120.35985,
                                -4.29434
                            ],
                            [
                                120.37294,
                                -4.15301
                            ],
                            [
                                120.33032,
                                -4.11128
                            ],
                            [
                                120.35527,
                                -4.02549
                            ],
                            [
                                120.33375,
                                -3.94366
                            ],
                            [
                                120.35392,
                                -3.86565
                            ],
                            [
                                120.4372,
                                -3.73652
                            ],
                            [
                                120.40761,
                                -3.65727
                            ],
                            [
                                120.41432,
                                -3.6056
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                114.17743,
                                -7.71406
                            ],
                            [
                                114.13414,
                                -7.70989
                            ],
                            [
                                114.03766,
                                -7.61943
                            ],
                            [
                                113.93177,
                                -7.69145
                            ],
                            [
                                113.84267,
                                -7.68455
                            ],
                            [
                                113.79477,
                                -7.72104
                            ],
                            [
                                113.70995,
                                -7.71096
                            ],
                            [
                                113.66281,
                                -7.72742
                            ],
                            [
                                113.49698,
                                -7.70278
                            ],
                            [
                                113.29598,
                                -7.788
                            ],
                            [
                                113.224,
                                -7.73834
                            ],
                            [
                                113.15877,
                                -7.745
                            ],
                            [
                                113.03867,
                                -7.65785
                            ],
                            [
                                112.95207,
                                -7.64208
                            ],
                            [
                                112.85069,
                                -7.59443
                            ],
                            [
                                112.82333,
                                -7.53994
                            ],
                            [
                                112.75091,
                                -7.54044
                            ],
                            [
                                112.74372,
                                -7.44616
                            ],
                            [
                                112.8071,
                                -7.3995
                            ],
                            [
                                112.7924,
                                -7.36314
                            ],
                            [
                                112.82114,
                                -7.29302
                            ],
                            [
                                112.76904,
                                -7.20319
                            ],
                            [
                                112.70555,
                                -7.22882
                            ],
                            [
                                112.65839,
                                -7.2067
                            ],
                            [
                                112.66187,
                                -7.15643
                            ],
                            [
                                112.58793,
                                -7.08237
                            ],
                            [
                                112.56778,
                                -6.97473
                            ],
                            [
                                112.5871,
                                -6.90542
                            ],
                            [
                                112.48559,
                                -6.89864
                            ],
                            [
                                112.43922,
                                -6.87154
                            ],
                            [
                                112.31985,
                                -6.86436
                            ],
                            [
                                112.19203,
                                -6.89064
                            ],
                            [
                                112.08124,
                                -6.8905
                            ],
                            [
                                112.04265,
                                -6.86729
                            ],
                            [
                                111.96737,
                                -6.76822
                            ],
                            [
                                111.84348,
                                -6.79747
                            ],
                            [
                                111.72481,
                                -6.76499
                            ],
                            [
                                111.67011,
                                -6.73439
                            ],
                            [
                                111.56373,
                                -6.64217
                            ],
                            [
                                111.49472,
                                -6.62205
                            ],
                            [
                                111.44711,
                                -6.67316
                            ],
                            [
                                111.37938,
                                -6.70145
                            ],
                            [
                                111.28347,
                                -6.68558
                            ],
                            [
                                111.21093,
                                -6.69878
                            ],
                            [
                                111.14335,
                                -6.68431
                            ],
                            [
                                111.10246,
                                -6.63362
                            ],
                            [
                                111.0482,
                                -6.45788
                            ],
                            [
                                111.01131,
                                -6.41902
                            ],
                            [
                                110.84733,
                                -6.40413
                            ],
                            [
                                110.71845,
                                -6.4492
                            ],
                            [
                                110.67086,
                                -6.49672
                            ],
                            [
                                110.61732,
                                -6.73642
                            ],
                            [
                                110.53918,
                                -6.85362
                            ],
                            [
                                110.45802,
                                -6.94617
                            ],
                            [
                                110.36409,
                                -6.97234
                            ],
                            [
                                110.26701,
                                -6.92847
                            ],
                            [
                                110.16159,
                                -6.85614
                            ],
                            [
                                110.12289,
                                -6.88762
                            ],
                            [
                                110.00006,
                                -6.91798
                            ],
                            [
                                109.84587,
                                -6.9081
                            ],
                            [
                                109.68628,
                                -6.85386
                            ],
                            [
                                109.53988,
                                -6.82727
                            ],
                            [
                                109.48819,
                                -6.79711
                            ],
                            [
                                109.418,
                                -6.84486
                            ],
                            [
                                109.27319,
                                -6.86831
                            ],
                            [
                                109.12757,
                                -6.84546
                            ],
                            [
                                109.01972,
                                -6.78896
                            ],
                            [
                                108.9617,
                                -6.83575
                            ],
                            [
                                108.90274,
                                -6.83932
                            ],
                            [
                                108.82778,
                                -6.78355
                            ],
                            [
                                108.79479,
                                -6.80659
                            ],
                            [
                                108.70341,
                                -6.81217
                            ],
                            [
                                108.65989,
                                -6.76535
                            ],
                            [
                                108.59343,
                                -6.75637
                            ],
                            [
                                108.55735,
                                -6.6936
                            ],
                            [
                                108.53164,
                                -6.57035
                            ],
                            [
                                108.5318,
                                -6.48123
                            ],
                            [
                                108.42387,
                                -6.40962
                            ],
                            [
                                108.31745,
                                -6.26333
                            ],
                            [
                                108.23091,
                                -6.23939
                            ],
                            [
                                108.15929,
                                -6.32577
                            ],
                            [
                                108.10504,
                                -6.32651
                            ],
                            [
                                107.84306,
                                -6.19637
                            ],
                            [
                                107.76645,
                                -6.20382
                            ],
                            [
                                107.73265,
                                -6.23348
                            ],
                            [
                                107.65102,
                                -6.2499
                            ],
                            [
                                107.57971,
                                -6.1881
                            ],
                            [
                                107.4655,
                                -6.14009
                            ],
                            [
                                107.38041,
                                -6.00332
                            ],
                            [
                                107.34257,
                                -5.96907
                            ],
                            [
                                107.27553,
                                -5.95776
                            ],
                            [
                                107.16227,
                                -5.98222
                            ],
                            [
                                107.10133,
                                -5.93836
                            ],
                            [
                                107.02125,
                                -5.91741
                            ],
                            [
                                106.99816,
                                -6.02677
                            ],
                            [
                                107.01024,
                                -6.07627
                            ],
                            [
                                106.88106,
                                -6.09653
                            ],
                            [
                                106.83282,
                                -6.11974
                            ],
                            [
                                106.73773,
                                -6.1004
                            ],
                            [
                                106.68545,
                                -6.01694
                            ],
                            [
                                106.53724,
                                -6.01361
                            ],
                            [
                                106.47468,
                                -6.04423
                            ],
                            [
                                106.36263,
                                -6.00717
                            ],
                            [
                                106.26545,
                                -5.94174
                            ],
                            [
                                106.20118,
                                -6.02349
                            ],
                            [
                                106.11971,
                                -6.01032
                            ],
                            [
                                106.10738,
                                -5.92885
                            ],
                            [
                                106.03818,
                                -5.87644
                            ],
                            [
                                105.99617,
                                -5.92008
                            ],
                            [
                                105.96325,
                                -6.00857
                            ],
                            [
                                105.88259,
                                -6.06785
                            ],
                            [
                                105.82807,
                                -6.20919
                            ],
                            [
                                105.81221,
                                -6.44705
                            ],
                            [
                                105.76236,
                                -6.51267
                            ],
                            [
                                105.7103,
                                -6.52808
                            ],
                            [
                                105.64598,
                                -6.48174
                            ],
                            [
                                105.61599,
                                -6.53762
                            ],
                            [
                                105.60348,
                                -6.62567
                            ],
                            [
                                105.50244,
                                -6.72871
                            ],
                            [
                                105.46195,
                                -6.82059
                            ],
                            [
                                105.38606,
                                -6.74
                            ],
                            [
                                105.36228,
                                -6.64801
                            ],
                            [
                                105.25716,
                                -6.75652
                            ],
                            [
                                105.23488,
                                -6.83256
                            ],
                            [
                                105.344,
                                -6.80559
                            ],
                            [
                                105.47776,
                                -6.86243
                            ],
                            [
                                105.53246,
                                -6.86726
                            ],
                            [
                                105.62524,
                                -6.83861
                            ],
                            [
                                105.76898,
                                -6.84718
                            ],
                            [
                                105.90787,
                                -6.81366
                            ],
                            [
                                106.04932,
                                -6.82924
                            ],
                            [
                                106.10247,
                                -6.87946
                            ],
                            [
                                106.19559,
                                -6.91355
                            ],
                            [
                                106.30784,
                                -6.9897
                            ],
                            [
                                106.37078,
                                -6.9911
                            ],
                            [
                                106.4386,
                                -6.95608
                            ],
                            [
                                106.51422,
                                -6.9694
                            ],
                            [
                                106.5465,
                                -7.05401
                            ],
                            [
                                106.40667,
                                -7.1925
                            ],
                            [
                                106.37972,
                                -7.3086
                            ],
                            [
                                106.40301,
                                -7.36543
                            ],
                            [
                                106.48766,
                                -7.37591
                            ],
                            [
                                106.56066,
                                -7.41734
                            ],
                            [
                                106.8664,
                                -7.43398
                            ],
                            [
                                107.06555,
                                -7.45065
                            ],
                            [
                                107.25705,
                                -7.49121
                            ],
                            [
                                107.39421,
                                -7.49801
                            ],
                            [
                                107.59387,
                                -7.56911
                            ],
                            [
                                107.6895,
                                -7.66285
                            ],
                            [
                                107.80212,
                                -7.68345
                            ],
                            [
                                107.83543,
                                -7.72332
                            ],
                            [
                                108.00219,
                                -7.74033
                            ],
                            [
                                108.06219,
                                -7.76497
                            ],
                            [
                                108.29586,
                                -7.80908
                            ],
                            [
                                108.42183,
                                -7.81543
                            ],
                            [
                                108.49297,
                                -7.78414
                            ],
                            [
                                108.50035,
                                -7.71419
                            ],
                            [
                                108.58739,
                                -7.67919
                            ],
                            [
                                108.65915,
                                -7.69695
                            ],
                            [
                                108.69181,
                                -7.67516
                            ],
                            [
                                108.76855,
                                -7.68929
                            ],
                            [
                                108.81954,
                                -7.62486
                            ],
                            [
                                108.86776,
                                -7.62557
                            ],
                            [
                                108.88051,
                                -7.68518
                            ],
                            [
                                108.96517,
                                -7.70466
                            ],
                            [
                                109.0194,
                                -7.74349
                            ],
                            [
                                109.06608,
                                -7.69346
                            ],
                            [
                                109.25093,
                                -7.69374
                            ],
                            [
                                109.38771,
                                -7.71939
                            ],
                            [
                                109.41685,
                                -7.77288
                            ],
                            [
                                109.47433,
                                -7.7577
                            ],
                            [
                                109.6341,
                                -7.78154
                            ],
                            [
                                109.90996,
                                -7.84939
                            ],
                            [
                                110.34056,
                                -8.02838
                            ],
                            [
                                110.44328,
                                -8.10019
                            ],
                            [
                                110.61036,
                                -8.15094
                            ],
                            [
                                110.71425,
                                -8.1997
                            ],
                            [
                                110.79628,
                                -8.19426
                            ],
                            [
                                110.90908,
                                -8.21311
                            ],
                            [
                                110.9993,
                                -8.25306
                            ],
                            [
                                111.07399,
                                -8.24882
                            ],
                            [
                                111.15621,
                                -8.28448
                            ],
                            [
                                111.26111,
                                -8.25408
                            ],
                            [
                                111.37491,
                                -8.26588
                            ],
                            [
                                111.45437,
                                -8.29059
                            ],
                            [
                                111.51404,
                                -8.33457
                            ],
                            [
                                111.57603,
                                -8.33544
                            ],
                            [
                                111.67876,
                                -8.37471
                            ],
                            [
                                111.73128,
                                -8.29579
                            ],
                            [
                                111.77891,
                                -8.25986
                            ],
                            [
                                111.93251,
                                -8.30774
                            ],
                            [
                                111.95254,
                                -8.28166
                            ],
                            [
                                112.04247,
                                -8.32158
                            ],
                            [
                                112.11579,
                                -8.31564
                            ],
                            [
                                112.26,
                                -8.34874
                            ],
                            [
                                112.33178,
                                -8.3359
                            ],
                            [
                                112.44604,
                                -8.39739
                            ],
                            [
                                112.56561,
                                -8.40528
                            ],
                            [
                                112.65018,
                                -8.44533
                            ],
                            [
                                112.75828,
                                -8.42141
                            ],
                            [
                                112.78463,
                                -8.39055
                            ],
                            [
                                112.87706,
                                -8.40865
                            ],
                            [
                                112.93939,
                                -8.3846
                            ],
                            [
                                112.97888,
                                -8.32659
                            ],
                            [
                                113.08111,
                                -8.288
                            ],
                            [
                                113.24071,
                                -8.28514
                            ],
                            [
                                113.35399,
                                -8.34312
                            ],
                            [
                                113.39663,
                                -8.39921
                            ],
                            [
                                113.43945,
                                -8.38233
                            ],
                            [
                                113.49666,
                                -8.41875
                            ],
                            [
                                113.62151,
                                -8.44966
                            ],
                            [
                                113.65684,
                                -8.49541
                            ],
                            [
                                113.80817,
                                -8.50931
                            ],
                            [
                                113.81085,
                                -8.5482
                            ],
                            [
                                114.01484,
                                -8.5957
                            ],
                            [
                                114.04629,
                                -8.64177
                            ],
                            [
                                114.10258,
                                -8.61942
                            ],
                            [
                                114.21277,
                                -8.64327
                            ],
                            [
                                114.23313,
                                -8.59879
                            ],
                            [
                                114.34952,
                                -8.64968
                            ],
                            [
                                114.38653,
                                -8.75014
                            ],
                            [
                                114.53926,
                                -8.77912
                            ],
                            [
                                114.59695,
                                -8.71004
                            ],
                            [
                                114.56553,
                                -8.66204
                            ],
                            [
                                114.47844,
                                -8.62276
                            ],
                            [
                                114.43697,
                                -8.62657
                            ],
                            [
                                114.40593,
                                -8.5126
                            ],
                            [
                                114.36019,
                                -8.4879
                            ],
                            [
                                114.34226,
                                -8.42613
                            ],
                            [
                                114.38292,
                                -8.19845
                            ],
                            [
                                114.42966,
                                -8.05323
                            ],
                            [
                                114.4229,
                                -7.92968
                            ],
                            [
                                114.4601,
                                -7.88242
                            ],
                            [
                                114.45868,
                                -7.82478
                            ],
                            [
                                114.38043,
                                -7.76034
                            ],
                            [
                                114.30087,
                                -7.74402
                            ],
                            [
                                114.24208,
                                -7.70333
                            ],
                            [
                                114.17743,
                                -7.71406
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                128.1552,
                                -0.60253
                            ],
                            [
                                128.08636,
                                -0.50106
                            ],
                            [
                                127.98136,
                                -0.27489
                            ],
                            [
                                127.96336,
                                -0.16496
                            ],
                            [
                                127.88142,
                                0.00078
                            ],
                            [
                                127.88512,
                                0.09678
                            ],
                            [
                                127.91918,
                                0.11379
                            ],
                            [
                                127.91165,
                                0.27736
                            ],
                            [
                                127.86444,
                                0.30089
                            ],
                            [
                                127.90097,
                                0.36312
                            ],
                            [
                                127.89844,
                                0.43487
                            ],
                            [
                                127.96096,
                                0.4818
                            ],
                            [
                                128.12806,
                                0.4627
                            ],
                            [
                                128.27389,
                                0.39422
                            ],
                            [
                                128.4656,
                                0.39598
                            ],
                            [
                                128.55256,
                                0.32391
                            ],
                            [
                                128.85104,
                                0.25407
                            ],
                            [
                                128.8308,
                                0.2956
                            ],
                            [
                                128.69398,
                                0.32883
                            ],
                            [
                                128.66932,
                                0.50026
                            ],
                            [
                                128.67797,
                                0.55967
                            ],
                            [
                                128.55643,
                                0.56889
                            ],
                            [
                                128.40895,
                                0.62682
                            ],
                            [
                                128.30252,
                                0.65559
                            ],
                            [
                                128.18947,
                                0.78633
                            ],
                            [
                                128.32719,
                                0.9081
                            ],
                            [
                                128.37997,
                                0.90826
                            ],
                            [
                                128.53082,
                                0.96828
                            ],
                            [
                                128.61884,
                                1.04575
                            ],
                            [
                                128.70059,
                                1.07036
                            ],
                            [
                                128.69169,
                                1.19575
                            ],
                            [
                                128.7368,
                                1.31327
                            ],
                            [
                                128.7495,
                                1.4049
                            ],
                            [
                                128.67698,
                                1.46868
                            ],
                            [
                                128.71594,
                                1.58072
                            ],
                            [
                                128.66925,
                                1.59698
                            ],
                            [
                                128.54907,
                                1.57275
                            ],
                            [
                                128.5071,
                                1.53696
                            ],
                            [
                                128.46507,
                                1.55568
                            ],
                            [
                                128.36192,
                                1.50251
                            ],
                            [
                                128.33604,
                                1.46201
                            ],
                            [
                                128.24049,
                                1.41835
                            ],
                            [
                                128.16574,
                                1.3642
                            ],
                            [
                                128.09776,
                                1.24302
                            ],
                            [
                                128.15188,
                                1.2531
                            ],
                            [
                                128.1982,
                                1.20204
                            ],
                            [
                                128.17207,
                                1.13744
                            ],
                            [
                                128.07239,
                                1.12405
                            ],
                            [
                                127.98291,
                                1.08508
                            ],
                            [
                                127.92931,
                                0.98809
                            ],
                            [
                                127.92037,
                                0.86851
                            ],
                            [
                                127.87056,
                                0.81989
                            ],
                            [
                                127.79286,
                                0.79217
                            ],
                            [
                                127.74429,
                                0.81745
                            ],
                            [
                                127.63115,
                                0.925
                            ],
                            [
                                127.65047,
                                1.02429
                            ],
                            [
                                127.74707,
                                1.0646
                            ],
                            [
                                127.82215,
                                1.14365
                            ],
                            [
                                127.89601,
                                1.14977
                            ],
                            [
                                127.91674,
                                1.22213
                            ],
                            [
                                128.01215,
                                1.3145
                            ],
                            [
                                127.99044,
                                1.37426
                            ],
                            [
                                128.01373,
                                1.43211
                            ],
                            [
                                128.03312,
                                1.5833
                            ],
                            [
                                128.00065,
                                1.60228
                            ],
                            [
                                128.01657,
                                1.71451
                            ],
                            [
                                127.92571,
                                1.80775
                            ],
                            [
                                127.84547,
                                1.82789
                            ],
                            [
                                127.85057,
                                1.92363
                            ],
                            [
                                127.94272,
                                1.98761
                            ],
                            [
                                127.95188,
                                2.03556
                            ],
                            [
                                128.02926,
                                2.11906
                            ],
                            [
                                128.02999,
                                2.20243
                            ],
                            [
                                127.92749,
                                2.18151
                            ],
                            [
                                127.83618,
                                2.09057
                            ],
                            [
                                127.74869,
                                1.97485
                            ],
                            [
                                127.69785,
                                1.93703
                            ],
                            [
                                127.63685,
                                1.82358
                            ],
                            [
                                127.5707,
                                1.75624
                            ],
                            [
                                127.57716,
                                1.66676
                            ],
                            [
                                127.53853,
                                1.64567
                            ],
                            [
                                127.52166,
                                1.54813
                            ],
                            [
                                127.53246,
                                1.49943
                            ],
                            [
                                127.46787,
                                1.33227
                            ],
                            [
                                127.40195,
                                1.23101
                            ],
                            [
                                127.42578,
                                1.14113
                            ],
                            [
                                127.39288,
                                1.06124
                            ],
                            [
                                127.46679,
                                1.06333
                            ],
                            [
                                127.50748,
                                0.96522
                            ],
                            [
                                127.49131,
                                0.89122
                            ],
                            [
                                127.61825,
                                0.86309
                            ],
                            [
                                127.63187,
                                0.81489
                            ],
                            [
                                127.5515,
                                0.72983
                            ],
                            [
                                127.52793,
                                0.56127
                            ],
                            [
                                127.55847,
                                0.51882
                            ],
                            [
                                127.57269,
                                0.42119
                            ],
                            [
                                127.65404,
                                0.34966
                            ],
                            [
                                127.72655,
                                0.31165
                            ],
                            [
                                127.6846,
                                0.15114
                            ],
                            [
                                127.70952,
                                0.06826
                            ],
                            [
                                127.68755,
                                0.00092
                            ],
                            [
                                127.69084,
                                -0.09993
                            ],
                            [
                                127.66153,
                                -0.21216
                            ],
                            [
                                127.68902,
                                -0.27454
                            ],
                            [
                                127.76216,
                                -0.33172
                            ],
                            [
                                127.86842,
                                -0.38656
                            ],
                            [
                                128.01722,
                                -0.6936
                            ],
                            [
                                128.06951,
                                -0.7284
                            ],
                            [
                                128.2258,
                                -0.78649
                            ],
                            [
                                128.22685,
                                -0.859
                            ],
                            [
                                128.28288,
                                -0.88554
                            ],
                            [
                                128.36378,
                                -0.85368
                            ],
                            [
                                128.20842,
                                -0.70447
                            ],
                            [
                                128.1552,
                                -0.60253
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                130.72603,
                                -3.39915
                            ],
                            [
                                130.67039,
                                -3.4004
                            ],
                            [
                                130.63004,
                                -3.33335
                            ],
                            [
                                130.63237,
                                -3.2685
                            ],
                            [
                                130.59102,
                                -3.14615
                            ],
                            [
                                130.55245,
                                -3.10869
                            ],
                            [
                                130.48682,
                                -3.09808
                            ],
                            [
                                130.3986,
                                -3.00433
                            ],
                            [
                                130.3398,
                                -2.97532
                            ],
                            [
                                130.26028,
                                -2.97398
                            ],
                            [
                                130.19812,
                                -3.0017
                            ],
                            [
                                130.15354,
                                -2.98442
                            ],
                            [
                                130.02034,
                                -3.00206
                            ],
                            [
                                129.80821,
                                -2.92337
                            ],
                            [
                                129.77709,
                                -2.87752
                            ],
                            [
                                129.53505,
                                -2.78308
                            ],
                            [
                                129.37872,
                                -2.79005
                            ],
                            [
                                129.34071,
                                -2.86403
                            ],
                            [
                                129.1262,
                                -2.96457
                            ],
                            [
                                129.07458,
                                -2.91236
                            ],
                            [
                                129.05819,
                                -2.80886
                            ],
                            [
                                128.82854,
                                -2.86669
                            ],
                            [
                                128.66433,
                                -2.84327
                            ],
                            [
                                128.59392,
                                -2.85547
                            ],
                            [
                                128.50581,
                                -2.83809
                            ],
                            [
                                128.41581,
                                -2.86076
                            ],
                            [
                                128.17314,
                                -2.85944
                            ],
                            [
                                128.11118,
                                -2.94705
                            ],
                            [
                                128.07907,
                                -2.95343
                            ],
                            [
                                128.08813,
                                -3.06485
                            ],
                            [
                                127.98685,
                                -3.07676
                            ],
                            [
                                127.86439,
                                -3.19054
                            ],
                            [
                                127.87892,
                                -3.25638
                            ],
                            [
                                127.93351,
                                -3.3714
                            ],
                            [
                                127.89288,
                                -3.48668
                            ],
                            [
                                127.94105,
                                -3.47427
                            ],
                            [
                                127.98122,
                                -3.3867
                            ],
                            [
                                128.05124,
                                -3.33513
                            ],
                            [
                                128.0797,
                                -3.13784
                            ],
                            [
                                128.15477,
                                -3.06422
                            ],
                            [
                                128.18936,
                                -3.12789
                            ],
                            [
                                128.15566,
                                -3.19678
                            ],
                            [
                                128.26584,
                                -3.2038
                            ],
                            [
                                128.32948,
                                -3.32093
                            ],
                            [
                                128.40411,
                                -3.42399
                            ],
                            [
                                128.51472,
                                -3.45399
                            ],
                            [
                                128.68515,
                                -3.41366
                            ],
                            [
                                128.68416,
                                -3.35721
                            ],
                            [
                                128.78581,
                                -3.26182
                            ],
                            [
                                128.88027,
                                -3.19933
                            ],
                            [
                                128.96174,
                                -3.22911
                            ],
                            [
                                128.9627,
                                -3.2731
                            ],
                            [
                                128.91745,
                                -3.33192
                            ],
                            [
                                128.96998,
                                -3.35483
                            ],
                            [
                                129.07615,
                                -3.34012
                            ],
                            [
                                129.2197,
                                -3.399
                            ],
                            [
                                129.40536,
                                -3.41864
                            ],
                            [
                                129.52152,
                                -3.46986
                            ],
                            [
                                129.56371,
                                -3.43289
                            ],
                            [
                                129.49565,
                                -3.32358
                            ],
                            [
                                129.5159,
                                -3.29598
                            ],
                            [
                                129.74176,
                                -3.33149
                            ],
                            [
                                129.90722,
                                -3.33474
                            ],
                            [
                                129.94578,
                                -3.36249
                            ],
                            [
                                129.95827,
                                -3.43166
                            ],
                            [
                                130.00463,
                                -3.48595
                            ],
                            [
                                130.08479,
                                -3.50442
                            ],
                            [
                                130.12948,
                                -3.54057
                            ],
                            [
                                130.40529,
                                -3.62761
                            ],
                            [
                                130.47053,
                                -3.69982
                            ],
                            [
                                130.56035,
                                -3.72322
                            ],
                            [
                                130.61622,
                                -3.79349
                            ],
                            [
                                130.76709,
                                -3.83776
                            ],
                            [
                                130.81746,
                                -3.87314
                            ],
                            [
                                130.82047,
                                -3.6963
                            ],
                            [
                                130.87141,
                                -3.62193
                            ],
                            [
                                130.86421,
                                -3.56116
                            ],
                            [
                                130.82036,
                                -3.51885
                            ],
                            [
                                130.80157,
                                -3.4134
                            ],
                            [
                                130.72603,
                                -3.39915
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                118.4095,
                                -8.74386
                            ],
                            [
                                118.37598,
                                -8.7743
                            ],
                            [
                                118.38862,
                                -8.84285
                            ],
                            [
                                118.44507,
                                -8.87842
                            ],
                            [
                                118.4963,
                                -8.87706
                            ],
                            [
                                118.63404,
                                -8.81612
                            ],
                            [
                                118.74543,
                                -8.80533
                            ],
                            [
                                118.8804,
                                -8.85741
                            ],
                            [
                                118.94077,
                                -8.83146
                            ],
                            [
                                118.89662,
                                -8.78177
                            ],
                            [
                                118.73661,
                                -8.76997
                            ],
                            [
                                118.75448,
                                -8.70086
                            ],
                            [
                                118.83934,
                                -8.73828
                            ],
                            [
                                118.89878,
                                -8.69535
                            ],
                            [
                                118.96458,
                                -8.76222
                            ],
                            [
                                119.06296,
                                -8.74355
                            ],
                            [
                                119.13979,
                                -8.75544
                            ],
                            [
                                119.19111,
                                -8.61015
                            ],
                            [
                                119.05049,
                                -8.65997
                            ],
                            [
                                119.0159,
                                -8.58475
                            ],
                            [
                                119.05461,
                                -8.51949
                            ],
                            [
                                118.98505,
                                -8.31002
                            ],
                            [
                                118.81632,
                                -8.28731
                            ],
                            [
                                118.69054,
                                -8.38644
                            ],
                            [
                                118.64393,
                                -8.29779
                            ],
                            [
                                118.58091,
                                -8.27305
                            ],
                            [
                                118.46191,
                                -8.25483
                            ],
                            [
                                118.31382,
                                -8.37716
                            ],
                            [
                                118.23433,
                                -8.34211
                            ],
                            [
                                118.14584,
                                -8.20068
                            ],
                            [
                                118.1429,
                                -8.13859
                            ],
                            [
                                118.07773,
                                -8.10445
                            ],
                            [
                                117.95891,
                                -8.10911
                            ],
                            [
                                117.93073,
                                -8.08234
                            ],
                            [
                                117.83427,
                                -8.1284
                            ],
                            [
                                117.79208,
                                -8.12229
                            ],
                            [
                                117.71853,
                                -8.17837
                            ],
                            [
                                117.73906,
                                -8.27922
                            ],
                            [
                                117.90462,
                                -8.42833
                            ],
                            [
                                117.97775,
                                -8.47468
                            ],
                            [
                                118.06317,
                                -8.45689
                            ],
                            [
                                118.10657,
                                -8.50294
                            ],
                            [
                                118.23954,
                                -8.56326
                            ],
                            [
                                118.27846,
                                -8.60216
                            ],
                            [
                                118.22599,
                                -8.6695
                            ],
                            [
                                118.09136,
                                -8.65611
                            ],
                            [
                                117.98026,
                                -8.73704
                            ],
                            [
                                117.87764,
                                -8.70343
                            ],
                            [
                                117.7765,
                                -8.70874
                            ],
                            [
                                117.76081,
                                -8.60689
                            ],
                            [
                                117.63719,
                                -8.56304
                            ],
                            [
                                117.63823,
                                -8.46849
                            ],
                            [
                                117.56547,
                                -8.4124
                            ],
                            [
                                117.43902,
                                -8.42467
                            ],
                            [
                                117.3858,
                                -8.47345
                            ],
                            [
                                117.17382,
                                -8.36792
                            ],
                            [
                                117.12593,
                                -8.36624
                            ],
                            [
                                117.07293,
                                -8.4332
                            ],
                            [
                                116.91345,
                                -8.53187
                            ],
                            [
                                116.84486,
                                -8.53916
                            ],
                            [
                                116.77422,
                                -8.64763
                            ],
                            [
                                116.78666,
                                -8.74735
                            ],
                            [
                                116.81428,
                                -8.78767
                            ],
                            [
                                116.76396,
                                -8.86593
                            ],
                            [
                                116.73356,
                                -8.99894
                            ],
                            [
                                116.79614,
                                -9.039
                            ],
                            [
                                116.88721,
                                -9.06499
                            ],
                            [
                                116.96073,
                                -9.05786
                            ],
                            [
                                117.02878,
                                -9.11119
                            ],
                            [
                                117.14564,
                                -9.08782
                            ],
                            [
                                117.19994,
                                -9.01825
                            ],
                            [
                                117.34417,
                                -9.05017
                            ],
                            [
                                117.52683,
                                -9.00842
                            ],
                            [
                                117.6927,
                                -8.91617
                            ],
                            [
                                117.80319,
                                -8.90269
                            ],
                            [
                                117.88144,
                                -8.94128
                            ],
                            [
                                117.9779,
                                -8.89719
                            ],
                            [
                                118.01391,
                                -8.85709
                            ],
                            [
                                118.08641,
                                -8.84319
                            ],
                            [
                                118.1291,
                                -8.87612
                            ],
                            [
                                118.18472,
                                -8.8537
                            ],
                            [
                                118.32504,
                                -8.72705
                            ],
                            [
                                118.39756,
                                -8.67966
                            ],
                            [
                                118.4095,
                                -8.74386
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                122.53086,
                                -8.46124
                            ],
                            [
                                122.48141,
                                -8.46879
                            ],
                            [
                                122.49944,
                                -8.54872
                            ],
                            [
                                122.45711,
                                -8.60519
                            ],
                            [
                                122.37519,
                                -8.60591
                            ],
                            [
                                122.28101,
                                -8.63931
                            ],
                            [
                                122.22278,
                                -8.62647
                            ],
                            [
                                122.15132,
                                -8.55731
                            ],
                            [
                                122.09236,
                                -8.52782
                            ],
                            [
                                122.00006,
                                -8.5221
                            ],
                            [
                                122.01267,
                                -8.43731
                            ],
                            [
                                121.88983,
                                -8.50254
                            ],
                            [
                                121.69832,
                                -8.51593
                            ],
                            [
                                121.61001,
                                -8.49112
                            ],
                            [
                                121.5187,
                                -8.62229
                            ],
                            [
                                121.44764,
                                -8.57514
                            ],
                            [
                                121.41281,
                                -8.60122
                            ],
                            [
                                121.33373,
                                -8.55819
                            ],
                            [
                                121.30436,
                                -8.50423
                            ],
                            [
                                121.18712,
                                -8.45352
                            ],
                            [
                                121.02809,
                                -8.42296
                            ],
                            [
                                120.95759,
                                -8.3538
                            ],
                            [
                                120.73879,
                                -8.34459
                            ],
                            [
                                120.64767,
                                -8.27348
                            ],
                            [
                                120.49153,
                                -8.29149
                            ],
                            [
                                120.44946,
                                -8.24732
                            ],
                            [
                                120.36772,
                                -8.28708
                            ],
                            [
                                120.27389,
                                -8.27841
                            ],
                            [
                                120.21112,
                                -8.30402
                            ],
                            [
                                120.17047,
                                -8.37301
                            ],
                            [
                                120.09804,
                                -8.43223
                            ],
                            [
                                120.03566,
                                -8.38489
                            ],
                            [
                                119.99134,
                                -8.45344
                            ],
                            [
                                119.90931,
                                -8.47122
                            ],
                            [
                                119.80913,
                                -8.57436
                            ],
                            [
                                119.80697,
                                -8.76588
                            ],
                            [
                                119.89356,
                                -8.81301
                            ],
                            [
                                119.95415,
                                -8.81994
                            ],
                            [
                                120.08065,
                                -8.80349
                            ],
                            [
                                120.15104,
                                -8.77341
                            ],
                            [
                                120.22961,
                                -8.82553
                            ],
                            [
                                120.32513,
                                -8.83728
                            ],
                            [
                                120.38069,
                                -8.80239
                            ],
                            [
                                120.60221,
                                -8.80751
                            ],
                            [
                                120.63833,
                                -8.85166
                            ],
                            [
                                120.76488,
                                -8.87303
                            ],
                            [
                                120.82396,
                                -8.82695
                            ],
                            [
                                120.91224,
                                -8.93174
                            ],
                            [
                                120.99425,
                                -8.9606
                            ],
                            [
                                121.06461,
                                -8.94596
                            ],
                            [
                                121.16255,
                                -8.89752
                            ],
                            [
                                121.30789,
                                -8.92732
                            ],
                            [
                                121.3527,
                                -8.90292
                            ],
                            [
                                121.3802,
                                -8.8049
                            ],
                            [
                                121.59246,
                                -8.81726
                            ],
                            [
                                121.66891,
                                -8.86558
                            ],
                            [
                                121.75772,
                                -8.88977
                            ],
                            [
                                121.81982,
                                -8.88371
                            ],
                            [
                                121.88475,
                                -8.83388
                            ],
                            [
                                121.99415,
                                -8.80946
                            ],
                            [
                                122.11619,
                                -8.72632
                            ],
                            [
                                122.26502,
                                -8.74854
                            ],
                            [
                                122.44495,
                                -8.72941
                            ],
                            [
                                122.54131,
                                -8.67227
                            ],
                            [
                                122.71358,
                                -8.64192
                            ],
                            [
                                122.83332,
                                -8.58056
                            ],
                            [
                                122.83033,
                                -8.53349
                            ],
                            [
                                122.77942,
                                -8.48248
                            ],
                            [
                                122.77826,
                                -8.42837
                            ],
                            [
                                122.88006,
                                -8.45838
                            ],
                            [
                                122.88195,
                                -8.375
                            ],
                            [
                                123.01137,
                                -8.31727
                            ],
                            [
                                122.95316,
                                -8.20041
                            ],
                            [
                                122.96122,
                                -8.13689
                            ],
                            [
                                122.85572,
                                -8.06893
                            ],
                            [
                                122.77274,
                                -8.10843
                            ],
                            [
                                122.72082,
                                -8.22472
                            ],
                            [
                                122.79883,
                                -8.19719
                            ],
                            [
                                122.9102,
                                -8.19472
                            ],
                            [
                                122.88339,
                                -8.27886
                            ],
                            [
                                122.78224,
                                -8.3116
                            ],
                            [
                                122.75613,
                                -8.36373
                            ],
                            [
                                122.5846,
                                -8.39332
                            ],
                            [
                                122.53086,
                                -8.46124
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                124.04496,
                                -9.34296
                            ],
                            [
                                123.98906,
                                -9.34666
                            ],
                            [
                                123.8684,
                                -9.47531
                            ],
                            [
                                123.79587,
                                -9.49257
                            ],
                            [
                                123.78528,
                                -9.54356
                            ],
                            [
                                123.67449,
                                -9.62982
                            ],
                            [
                                123.68378,
                                -9.70054
                            ],
                            [
                                123.66427,
                                -9.86414
                            ],
                            [
                                123.60172,
                                -9.89817
                            ],
                            [
                                123.57896,
                                -9.94336
                            ],
                            [
                                123.5857,
                                -10.03269
                            ],
                            [
                                123.69592,
                                -10.01108
                            ],
                            [
                                123.76984,
                                -10.04512
                            ],
                            [
                                123.7413,
                                -10.09795
                            ],
                            [
                                123.64938,
                                -10.14519
                            ],
                            [
                                123.53348,
                                -10.17555
                            ],
                            [
                                123.48901,
                                -10.22663
                            ],
                            [
                                123.5415,
                                -10.32794
                            ],
                            [
                                123.61076,
                                -10.3691
                            ],
                            [
                                123.79953,
                                -10.35448
                            ],
                            [
                                123.91629,
                                -10.29743
                            ],
                            [
                                124.02274,
                                -10.26815
                            ],
                            [
                                124.10132,
                                -10.18029
                            ],
                            [
                                124.14681,
                                -10.15925
                            ],
                            [
                                124.39406,
                                -10.16953
                            ],
                            [
                                124.50931,
                                -10.08968
                            ],
                            [
                                124.53392,
                                -10.02884
                            ],
                            [
                                124.67141,
                                -9.9232
                            ],
                            [
                                124.74835,
                                -9.88213
                            ],
                            [
                                124.84576,
                                -9.74097
                            ],
                            [
                                124.98073,
                                -9.64206
                            ],
                            [
                                125.00991,
                                -9.5291
                            ],
                            [
                                125.0819,
                                -9.44619
                            ],
                            [
                                125.05042,
                                -9.32681
                            ],
                            [
                                125.00642,
                                -9.29482
                            ],
                            [
                                124.97787,
                                -9.2315
                            ],
                            [
                                124.99531,
                                -9.17317
                            ],
                            [
                                125.10306,
                                -9.1965
                            ],
                            [
                                125.17513,
                                -9.17254
                            ],
                            [
                                125.18565,
                                -9.02865
                            ],
                            [
                                125.12037,
                                -8.97179
                            ],
                            [
                                125.00316,
                                -9.06287
                            ],
                            [
                                124.9417,
                                -9.04783
                            ],
                            [
                                124.95001,
                                -8.9581
                            ],
                            [
                                124.80029,
                                -9.00943
                            ],
                            [
                                124.66985,
                                -9.11788
                            ],
                            [
                                124.52943,
                                -9.18592
                            ],
                            [
                                124.47717,
                                -9.175
                            ],
                            [
                                124.46158,
                                -9.29397
                            ],
                            [
                                124.38037,
                                -9.35821
                            ],
                            [
                                124.35037,
                                -9.48428
                            ],
                            [
                                124.28869,
                                -9.50375
                            ],
                            [
                                124.26046,
                                -9.39624
                            ],
                            [
                                124.21668,
                                -9.36657
                            ],
                            [
                                124.13393,
                                -9.42517
                            ],
                            [
                                124.04496,
                                -9.34296
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                137.6169,
                                -8.39754
                            ],
                            [
                                137.6819,
                                -8.40098
                            ],
                            [
                                137.87788,
                                -8.37202
                            ],
                            [
                                138.06399,
                                -8.40718
                            ],
                            [
                                138.20276,
                                -8.41503
                            ],
                            [
                                138.32335,
                                -8.40048
                            ],
                            [
                                138.50359,
                                -8.36
                            ],
                            [
                                138.65681,
                                -8.24923
                            ],
                            [
                                138.70042,
                                -8.16977
                            ],
                            [
                                138.73556,
                                -8.14497
                            ],
                            [
                                138.82464,
                                -8.13418
                            ],
                            [
                                138.84831,
                                -8.08058
                            ],
                            [
                                138.93527,
                                -8.0501
                            ],
                            [
                                138.92856,
                                -7.88457
                            ],
                            [
                                139.02985,
                                -7.81357
                            ],
                            [
                                139.02291,
                                -7.76246
                            ],
                            [
                                139.09969,
                                -7.56516
                            ],
                            [
                                138.99281,
                                -7.55674
                            ],
                            [
                                138.91546,
                                -7.51571
                            ],
                            [
                                138.88504,
                                -7.45655
                            ],
                            [
                                138.79711,
                                -7.39218
                            ],
                            [
                                138.66981,
                                -7.37307
                            ],
                            [
                                138.40801,
                                -7.41277
                            ],
                            [
                                138.28316,
                                -7.45623
                            ],
                            [
                                138.17821,
                                -7.52156
                            ],
                            [
                                138.05909,
                                -7.61838
                            ],
                            [
                                138.01354,
                                -7.71645
                            ],
                            [
                                137.95513,
                                -7.76221
                            ],
                            [
                                137.8364,
                                -7.99734
                            ],
                            [
                                137.74646,
                                -8.13136
                            ],
                            [
                                137.6169,
                                -8.39754
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                105.47495,
                                -1.56697
                            ],
                            [
                                105.34498,
                                -1.65951
                            ],
                            [
                                105.3326,
                                -1.70286
                            ],
                            [
                                105.3793,
                                -1.73531
                            ],
                            [
                                105.38665,
                                -1.79357
                            ],
                            [
                                105.34462,
                                -1.84805
                            ],
                            [
                                105.26875,
                                -1.89684
                            ],
                            [
                                105.13088,
                                -1.96215
                            ],
                            [
                                105.11066,
                                -2.02782
                            ],
                            [
                                105.13083,
                                -2.0819
                            ],
                            [
                                105.23014,
                                -2.07655
                            ],
                            [
                                105.29776,
                                -2.144
                            ],
                            [
                                105.43609,
                                -2.1352
                            ],
                            [
                                105.54194,
                                -2.08458
                            ],
                            [
                                105.58981,
                                -2.12609
                            ],
                            [
                                105.7069,
                                -2.13098
                            ],
                            [
                                105.78552,
                                -2.18406
                            ],
                            [
                                105.78454,
                                -2.25111
                            ],
                            [
                                105.82005,
                                -2.31734
                            ],
                            [
                                105.80478,
                                -2.37331
                            ],
                            [
                                105.83234,
                                -2.41563
                            ],
                            [
                                105.92934,
                                -2.48402
                            ],
                            [
                                105.93168,
                                -2.53519
                            ],
                            [
                                105.88859,
                                -2.64582
                            ],
                            [
                                105.94767,
                                -2.81164
                            ],
                            [
                                106.09524,
                                -2.84136
                            ],
                            [
                                106.14235,
                                -2.87711
                            ],
                            [
                                106.27841,
                                -2.90963
                            ],
                            [
                                106.33275,
                                -2.96713
                            ],
                            [
                                106.43216,
                                -2.98724
                            ],
                            [
                                106.48158,
                                -3.03687
                            ],
                            [
                                106.51409,
                                -3.11422
                            ],
                            [
                                106.58527,
                                -3.07926
                            ],
                            [
                                106.70127,
                                -3.09908
                            ],
                            [
                                106.73851,
                                -3.01735
                            ],
                            [
                                106.6058,
                                -2.96354
                            ],
                            [
                                106.5856,
                                -2.92872
                            ],
                            [
                                106.60143,
                                -2.85633
                            ],
                            [
                                106.65478,
                                -2.72348
                            ],
                            [
                                106.70295,
                                -2.64729
                            ],
                            [
                                106.79257,
                                -2.58581
                            ],
                            [
                                106.73405,
                                -2.55768
                            ],
                            [
                                106.36366,
                                -2.47426
                            ],
                            [
                                106.28656,
                                -2.41386
                            ],
                            [
                                106.22305,
                                -2.31494
                            ],
                            [
                                106.21409,
                                -2.25472
                            ],
                            [
                                106.15694,
                                -2.10164
                            ],
                            [
                                106.14234,
                                -1.98458
                            ],
                            [
                                106.1678,
                                -1.91108
                            ],
                            [
                                106.11023,
                                -1.80682
                            ],
                            [
                                106.02259,
                                -1.69259
                            ],
                            [
                                106.03651,
                                -1.60419
                            ],
                            [
                                105.90725,
                                -1.50546
                            ],
                            [
                                105.79867,
                                -1.53139
                            ],
                            [
                                105.70228,
                                -1.53355
                            ],
                            [
                                105.75182,
                                -1.65379
                            ],
                            [
                                105.74269,
                                -1.71368
                            ],
                            [
                                105.76443,
                                -1.77646
                            ],
                            [
                                105.70939,
                                -1.78604
                            ],
                            [
                                105.66341,
                                -1.75832
                            ],
                            [
                                105.65947,
                                -1.65386
                            ],
                            [
                                105.6252,
                                -1.63091
                            ],
                            [
                                105.59234,
                                -1.53638
                            ],
                            [
                                105.47495,
                                -1.56697
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                119.82205,
                                -9.38616
                            ],
                            [
                                119.78913,
                                -9.40004
                            ],
                            [
                                119.58627,
                                -9.35028
                            ],
                            [
                                119.52273,
                                -9.38179
                            ],
                            [
                                119.46567,
                                -9.36148
                            ],
                            [
                                119.38718,
                                -9.38525
                            ],
                            [
                                119.29995,
                                -9.36205
                            ],
                            [
                                119.22572,
                                -9.39375
                            ],
                            [
                                119.17287,
                                -9.38179
                            ],
                            [
                                119.10909,
                                -9.42212
                            ],
                            [
                                118.98938,
                                -9.46392
                            ],
                            [
                                118.94012,
                                -9.56826
                            ],
                            [
                                119.03827,
                                -9.68102
                            ],
                            [
                                119.19055,
                                -9.75558
                            ],
                            [
                                119.30354,
                                -9.74748
                            ],
                            [
                                119.39415,
                                -9.79605
                            ],
                            [
                                119.45877,
                                -9.74554
                            ],
                            [
                                119.54396,
                                -9.76078
                            ],
                            [
                                119.67525,
                                -9.83551
                            ],
                            [
                                119.71339,
                                -9.87099
                            ],
                            [
                                119.88165,
                                -9.95592
                            ],
                            [
                                119.95535,
                                -9.98057
                            ],
                            [
                                120.06573,
                                -10.14068
                            ],
                            [
                                120.16542,
                                -10.2391
                            ],
                            [
                                120.29419,
                                -10.25962
                            ],
                            [
                                120.35612,
                                -10.2529
                            ],
                            [
                                120.45181,
                                -10.31993
                            ],
                            [
                                120.53584,
                                -10.23589
                            ],
                            [
                                120.61303,
                                -10.24813
                            ],
                            [
                                120.73272,
                                -10.17994
                            ],
                            [
                                120.79058,
                                -10.12042
                            ],
                            [
                                120.82528,
                                -10.03118
                            ],
                            [
                                120.77723,
                                -9.95471
                            ],
                            [
                                120.64778,
                                -9.88296
                            ],
                            [
                                120.58824,
                                -9.76266
                            ],
                            [
                                120.50256,
                                -9.70978
                            ],
                            [
                                120.45313,
                                -9.63609
                            ],
                            [
                                120.32849,
                                -9.67601
                            ],
                            [
                                120.26026,
                                -9.65467
                            ],
                            [
                                120.22779,
                                -9.50306
                            ],
                            [
                                120.19236,
                                -9.47251
                            ],
                            [
                                120.09382,
                                -9.47269
                            ],
                            [
                                119.93605,
                                -9.28496
                            ],
                            [
                                119.82205,
                                -9.38616
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                127.0973,
                                -3.6808
                            ],
                            [
                                127.21975,
                                -3.66574
                            ],
                            [
                                127.25372,
                                -3.58673
                            ],
                            [
                                127.26086,
                                -3.37281
                            ],
                            [
                                127.15607,
                                -3.33352
                            ],
                            [
                                127.11152,
                                -3.38213
                            ],
                            [
                                127.04839,
                                -3.32966
                            ],
                            [
                                127.03663,
                                -3.27014
                            ],
                            [
                                127.10896,
                                -3.23777
                            ],
                            [
                                126.9958,
                                -3.14425
                            ],
                            [
                                126.93348,
                                -3.14345
                            ],
                            [
                                126.80604,
                                -3.06344
                            ],
                            [
                                126.72088,
                                -3.057
                            ],
                            [
                                126.41143,
                                -3.07437
                            ],
                            [
                                126.29665,
                                -3.09556
                            ],
                            [
                                126.227,
                                -3.172
                            ],
                            [
                                126.16305,
                                -3.16604
                            ],
                            [
                                126.08851,
                                -3.10387
                            ],
                            [
                                126.01663,
                                -3.1656
                            ],
                            [
                                126.0028,
                                -3.35407
                            ],
                            [
                                126.07403,
                                -3.4682
                            ],
                            [
                                126.13133,
                                -3.50064
                            ],
                            [
                                126.19588,
                                -3.61977
                            ],
                            [
                                126.5343,
                                -3.79259
                            ],
                            [
                                126.57091,
                                -3.79044
                            ],
                            [
                                126.68473,
                                -3.84124
                            ],
                            [
                                126.74476,
                                -3.83912
                            ],
                            [
                                126.7993,
                                -3.80338
                            ],
                            [
                                126.95418,
                                -3.76839
                            ],
                            [
                                127.00925,
                                -3.71444
                            ],
                            [
                                127.0973,
                                -3.6808
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                115.55858,
                                -8.22984
                            ],
                            [
                                115.44817,
                                -8.15745
                            ],
                            [
                                115.17996,
                                -8.05975
                            ],
                            [
                                115.11073,
                                -8.08434
                            ],
                            [
                                114.97786,
                                -8.18001
                            ],
                            [
                                114.81825,
                                -8.19086
                            ],
                            [
                                114.58817,
                                -8.12145
                            ],
                            [
                                114.53202,
                                -8.14938
                            ],
                            [
                                114.50166,
                                -8.10524
                            ],
                            [
                                114.43403,
                                -8.11589
                            ],
                            [
                                114.45016,
                                -8.22146
                            ],
                            [
                                114.58518,
                                -8.40088
                            ],
                            [
                                114.72874,
                                -8.39673
                            ],
                            [
                                114.90667,
                                -8.46501
                            ],
                            [
                                115.06825,
                                -8.59564
                            ],
                            [
                                115.14476,
                                -8.67636
                            ],
                            [
                                115.16421,
                                -8.84926
                            ],
                            [
                                115.21292,
                                -8.83238
                            ],
                            [
                                115.18199,
                                -8.74598
                            ],
                            [
                                115.25754,
                                -8.70949
                            ],
                            [
                                115.26094,
                                -8.67106
                            ],
                            [
                                115.37009,
                                -8.57775
                            ],
                            [
                                115.50844,
                                -8.54476
                            ],
                            [
                                115.52034,
                                -8.50967
                            ],
                            [
                                115.61235,
                                -8.50558
                            ],
                            [
                                115.71809,
                                -8.40035
                            ],
                            [
                                115.70565,
                                -8.35744
                            ],
                            [
                                115.63831,
                                -8.3242
                            ],
                            [
                                115.55858,
                                -8.22984
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                115.8385,
                                -8.76148
                            ],
                            [
                                115.84324,
                                -8.81598
                            ],
                            [
                                116.01992,
                                -8.8763
                            ],
                            [
                                116.16262,
                                -8.87334
                            ],
                            [
                                116.17373,
                                -8.91535
                            ],
                            [
                                116.35213,
                                -8.93342
                            ],
                            [
                                116.41254,
                                -8.90493
                            ],
                            [
                                116.52844,
                                -8.91734
                            ],
                            [
                                116.58265,
                                -8.8813
                            ],
                            [
                                116.5174,
                                -8.79298
                            ],
                            [
                                116.55651,
                                -8.75753
                            ],
                            [
                                116.63257,
                                -8.61018
                            ],
                            [
                                116.66863,
                                -8.57006
                            ],
                            [
                                116.67119,
                                -8.49518
                            ],
                            [
                                116.71714,
                                -8.44764
                            ],
                            [
                                116.7226,
                                -8.35102
                            ],
                            [
                                116.66129,
                                -8.29397
                            ],
                            [
                                116.37614,
                                -8.21319
                            ],
                            [
                                116.26977,
                                -8.25147
                            ],
                            [
                                116.18062,
                                -8.34341
                            ],
                            [
                                116.06642,
                                -8.40778
                            ],
                            [
                                116.04139,
                                -8.44684
                            ],
                            [
                                116.07445,
                                -8.53623
                            ],
                            [
                                116.08169,
                                -8.61226
                            ],
                            [
                                116.05953,
                                -8.73412
                            ],
                            [
                                115.98046,
                                -8.73943
                            ],
                            [
                                115.94192,
                                -8.77242
                            ],
                            [
                                115.85396,
                                -8.73601
                            ],
                            [
                                115.8385,
                                -8.76148
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                112.67493,
                                -7.05906
                            ],
                            [
                                112.72249,
                                -7.17669
                            ],
                            [
                                112.80582,
                                -7.16412
                            ],
                            [
                                113.09251,
                                -7.23223
                            ],
                            [
                                113.33292,
                                -7.21835
                            ],
                            [
                                113.55397,
                                -7.23137
                            ],
                            [
                                113.61533,
                                -7.12529
                            ],
                            [
                                113.67807,
                                -7.10868
                            ],
                            [
                                113.82413,
                                -7.13482
                            ],
                            [
                                113.8489,
                                -7.05626
                            ],
                            [
                                113.9463,
                                -7.05203
                            ],
                            [
                                114.00588,
                                -7.00726
                            ],
                            [
                                114.07344,
                                -6.99897
                            ],
                            [
                                114.09729,
                                -6.93102
                            ],
                            [
                                113.96397,
                                -6.86953
                            ],
                            [
                                113.89937,
                                -6.86209
                            ],
                            [
                                113.8019,
                                -6.88268
                            ],
                            [
                                113.51962,
                                -6.88972
                            ],
                            [
                                113.41636,
                                -6.88343
                            ],
                            [
                                113.11299,
                                -6.89124
                            ],
                            [
                                113.03941,
                                -6.87951
                            ],
                            [
                                112.86051,
                                -6.89106
                            ],
                            [
                                112.76584,
                                -7.00267
                            ],
                            [
                                112.67493,
                                -7.05906
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                122.56209,
                                -5.51185
                            ],
                            [
                                122.61851,
                                -5.65934
                            ],
                            [
                                122.64796,
                                -5.69975
                            ],
                            [
                                122.75373,
                                -5.64803
                            ],
                            [
                                122.81784,
                                -5.68903
                            ],
                            [
                                122.90164,
                                -5.55573
                            ],
                            [
                                122.85654,
                                -5.47759
                            ],
                            [
                                122.89993,
                                -5.43213
                            ],
                            [
                                122.98421,
                                -5.38585
                            ],
                            [
                                123.02221,
                                -5.42872
                            ],
                            [
                                123.12963,
                                -5.38754
                            ],
                            [
                                123.21583,
                                -5.29391
                            ],
                            [
                                123.04272,
                                -5.12927
                            ],
                            [
                                122.95751,
                                -5.20676
                            ],
                            [
                                122.92603,
                                -5.16965
                            ],
                            [
                                122.97643,
                                -5.10889
                            ],
                            [
                                122.95878,
                                -5.01961
                            ],
                            [
                                122.97088,
                                -4.94904
                            ],
                            [
                                123.01207,
                                -4.8996
                            ],
                            [
                                122.99569,
                                -4.82847
                            ],
                            [
                                123.09948,
                                -4.78298
                            ],
                            [
                                123.14344,
                                -4.72114
                            ],
                            [
                                123.18028,
                                -4.83662
                            ],
                            [
                                123.21441,
                                -4.83079
                            ],
                            [
                                123.20649,
                                -4.69367
                            ],
                            [
                                123.17958,
                                -4.65245
                            ],
                            [
                                123.20315,
                                -4.60511
                            ],
                            [
                                123.13507,
                                -4.47764
                            ],
                            [
                                123.07766,
                                -4.45295
                            ],
                            [
                                123.08278,
                                -4.37919
                            ],
                            [
                                123.04133,
                                -4.36593
                            ],
                            [
                                122.90752,
                                -4.45626
                            ],
                            [
                                122.86581,
                                -4.52268
                            ],
                            [
                                122.83292,
                                -4.6658
                            ],
                            [
                                122.85533,
                                -4.7837
                            ],
                            [
                                122.81033,
                                -4.85587
                            ],
                            [
                                122.8318,
                                -4.9085
                            ],
                            [
                                122.80391,
                                -5.03773
                            ],
                            [
                                122.7426,
                                -5.16833
                            ],
                            [
                                122.80575,
                                -5.1908
                            ],
                            [
                                122.7679,
                                -5.24786
                            ],
                            [
                                122.71792,
                                -5.25943
                            ],
                            [
                                122.65606,
                                -5.32482
                            ],
                            [
                                122.6229,
                                -5.39764
                            ],
                            [
                                122.63779,
                                -5.44895
                            ],
                            [
                                122.56209,
                                -5.51185
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                107.52705,
                                -2.93354
                            ],
                            [
                                107.60871,
                                -2.91735
                            ],
                            [
                                107.56067,
                                -3.00285
                            ],
                            [
                                107.58753,
                                -3.10345
                            ],
                            [
                                107.62411,
                                -3.14653
                            ],
                            [
                                107.58477,
                                -3.20274
                            ],
                            [
                                107.60751,
                                -3.23977
                            ],
                            [
                                107.672,
                                -3.20637
                            ],
                            [
                                107.82149,
                                -3.16337
                            ],
                            [
                                107.84146,
                                -3.06011
                            ],
                            [
                                107.88401,
                                -3.08827
                            ],
                            [
                                107.96261,
                                -3.18385
                            ],
                            [
                                107.97257,
                                -3.26289
                            ],
                            [
                                108.06647,
                                -3.23858
                            ],
                            [
                                108.06044,
                                -3.18633
                            ],
                            [
                                108.12758,
                                -3.16939
                            ],
                            [
                                108.20395,
                                -3.05235
                            ],
                            [
                                108.19093,
                                -3.01817
                            ],
                            [
                                108.28563,
                                -2.85515
                            ],
                            [
                                108.25567,
                                -2.7586
                            ],
                            [
                                108.12484,
                                -2.64595
                            ],
                            [
                                107.98395,
                                -2.57993
                            ],
                            [
                                107.89313,
                                -2.58003
                            ],
                            [
                                107.82592,
                                -2.55848
                            ],
                            [
                                107.65672,
                                -2.56528
                            ],
                            [
                                107.62686,
                                -2.60544
                            ],
                            [
                                107.62271,
                                -2.76253
                            ],
                            [
                                107.59281,
                                -2.86402
                            ],
                            [
                                107.52705,
                                -2.93354
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                97.05808,
                                1.40637
                            ],
                            [
                                97.1422,
                                1.36728
                            ],
                            [
                                97.20256,
                                1.2798
                            ],
                            [
                                97.25441,
                                1.24452
                            ],
                            [
                                97.37903,
                                1.03954
                            ],
                            [
                                97.40469,
                                0.94503
                            ],
                            [
                                97.49199,
                                0.90594
                            ],
                            [
                                97.6195,
                                0.80394
                            ],
                            [
                                97.70555,
                                0.56635
                            ],
                            [
                                97.79626,
                                0.56036
                            ],
                            [
                                97.88785,
                                0.62927
                            ],
                            [
                                97.87844,
                                0.74483
                            ],
                            [
                                97.89965,
                                0.79743
                            ],
                            [
                                97.89018,
                                0.88803
                            ],
                            [
                                97.93456,
                                0.94875
                            ],
                            [
                                97.90589,
                                1.02773
                            ],
                            [
                                97.83279,
                                1.07149
                            ],
                            [
                                97.79775,
                                1.13301
                            ],
                            [
                                97.67417,
                                1.18197
                            ],
                            [
                                97.60039,
                                1.30707
                            ],
                            [
                                97.4857,
                                1.44542
                            ],
                            [
                                97.35063,
                                1.53321
                            ],
                            [
                                97.33703,
                                1.47343
                            ],
                            [
                                97.26963,
                                1.41698
                            ],
                            [
                                97.17074,
                                1.3961
                            ],
                            [
                                97.13382,
                                1.42926
                            ],
                            [
                                97.05808,
                                1.40637
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                98.58518,
                                -1.21263
                            ],
                            [
                                98.78944,
                                -1.53148
                            ],
                            [
                                98.82047,
                                -1.63135
                            ],
                            [
                                98.87006,
                                -1.69015
                            ],
                            [
                                99.0378,
                                -1.78969
                            ],
                            [
                                99.09803,
                                -1.81471
                            ],
                            [
                                99.15577,
                                -1.78778
                            ],
                            [
                                99.22944,
                                -1.79746
                            ],
                            [
                                99.28301,
                                -1.75765
                            ],
                            [
                                99.28977,
                                -1.66208
                            ],
                            [
                                99.2548,
                                -1.60555
                            ],
                            [
                                99.19207,
                                -1.57753
                            ],
                            [
                                99.14335,
                                -1.49284
                            ],
                            [
                                99.15761,
                                -1.43971
                            ],
                            [
                                99.09068,
                                -1.37124
                            ],
                            [
                                99.05724,
                                -1.26671
                            ],
                            [
                                99.02341,
                                -1.22527
                            ],
                            [
                                98.98397,
                                -1.12234
                            ],
                            [
                                98.92874,
                                -1.07621
                            ],
                            [
                                98.91684,
                                -0.94704
                            ],
                            [
                                98.88432,
                                -0.91982
                            ],
                            [
                                98.78242,
                                -0.96361
                            ],
                            [
                                98.69465,
                                -0.95563
                            ],
                            [
                                98.65116,
                                -0.9879
                            ],
                            [
                                98.64363,
                                -1.10222
                            ],
                            [
                                98.58518,
                                -1.21263
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                131.08393,
                                -7.86222
                            ],
                            [
                                131.1186,
                                -7.90076
                            ],
                            [
                                131.10775,
                                -7.98241
                            ],
                            [
                                131.13681,
                                -7.99919
                            ],
                            [
                                131.28673,
                                -8.009
                            ],
                            [
                                131.34343,
                                -7.98188
                            ],
                            [
                                131.37211,
                                -7.86327
                            ],
                            [
                                131.46423,
                                -7.80124
                            ],
                            [
                                131.50795,
                                -7.72372
                            ],
                            [
                                131.5535,
                                -7.71209
                            ],
                            [
                                131.62616,
                                -7.63422
                            ],
                            [
                                131.67275,
                                -7.48542
                            ],
                            [
                                131.67369,
                                -7.37292
                            ],
                            [
                                131.63685,
                                -7.30103
                            ],
                            [
                                131.65266,
                                -7.22802
                            ],
                            [
                                131.7381,
                                -7.19943
                            ],
                            [
                                131.65113,
                                -7.11381
                            ],
                            [
                                131.52265,
                                -7.16942
                            ],
                            [
                                131.54308,
                                -7.22199
                            ],
                            [
                                131.47935,
                                -7.23915
                            ],
                            [
                                131.44514,
                                -7.30706
                            ],
                            [
                                131.32247,
                                -7.41926
                            ],
                            [
                                131.2485,
                                -7.46874
                            ],
                            [
                                131.16955,
                                -7.6617
                            ],
                            [
                                131.1106,
                                -7.72846
                            ],
                            [
                                131.1477,
                                -7.76765
                            ],
                            [
                                131.08393,
                                -7.86222
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                130.92419,
                                -0.3483
                            ],
                            [
                                130.87795,
                                -0.30952
                            ],
                            [
                                130.73306,
                                -0.29553
                            ],
                            [
                                130.71502,
                                -0.24258
                            ],
                            [
                                130.62181,
                                -0.13652
                            ],
                            [
                                130.61416,
                                -0.09761
                            ],
                            [
                                130.68616,
                                -0.0818
                            ],
                            [
                                130.72862,
                                -0.14549
                            ],
                            [
                                130.77427,
                                -0.16864
                            ],
                            [
                                130.79128,
                                -0.24015
                            ],
                            [
                                130.86393,
                                -0.24918
                            ],
                            [
                                130.93577,
                                -0.35023
                            ],
                            [
                                131.02092,
                                -0.36336
                            ],
                            [
                                131.08992,
                                -0.32109
                            ],
                            [
                                131.23956,
                                -0.38957
                            ],
                            [
                                131.32814,
                                -0.28443
                            ],
                            [
                                131.29056,
                                -0.24317
                            ],
                            [
                                131.29261,
                                -0.16762
                            ],
                            [
                                131.19976,
                                -0.14211
                            ],
                            [
                                131.1453,
                                -0.08288
                            ],
                            [
                                130.96616,
                                -0.0593
                            ],
                            [
                                130.8595,
                                -0.01512
                            ],
                            [
                                130.79342,
                                -0.00878
                            ],
                            [
                                130.6255,
                                -0.05561
                            ],
                            [
                                130.518,
                                -0.05183
                            ],
                            [
                                130.36837,
                                -0.11518
                            ],
                            [
                                130.28718,
                                -0.09885
                            ],
                            [
                                130.29261,
                                -0.1768
                            ],
                            [
                                130.39868,
                                -0.17264
                            ],
                            [
                                130.37136,
                                -0.24082
                            ],
                            [
                                130.43493,
                                -0.29007
                            ],
                            [
                                130.50594,
                                -0.25425
                            ],
                            [
                                130.51356,
                                -0.30458
                            ],
                            [
                                130.57873,
                                -0.32996
                            ],
                            [
                                130.67028,
                                -0.30195
                            ],
                            [
                                130.72641,
                                -0.449
                            ],
                            [
                                130.80809,
                                -0.44904
                            ],
                            [
                                130.91245,
                                -0.40442
                            ],
                            [
                                130.92419,
                                -0.3483
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                122.53086,
                                -5.31343
                            ],
                            [
                                122.52167,
                                -5.42307
                            ],
                            [
                                122.5971,
                                -5.42377
                            ],
                            [
                                122.59942,
                                -5.35611
                            ],
                            [
                                122.64105,
                                -5.34685
                            ],
                            [
                                122.64328,
                                -5.26375
                            ],
                            [
                                122.59077,
                                -5.23092
                            ],
                            [
                                122.59248,
                                -5.15864
                            ],
                            [
                                122.63844,
                                -5.05845
                            ],
                            [
                                122.76324,
                                -4.96012
                            ],
                            [
                                122.76757,
                                -4.89511
                            ],
                            [
                                122.73181,
                                -4.83241
                            ],
                            [
                                122.74758,
                                -4.78471
                            ],
                            [
                                122.72488,
                                -4.6929
                            ],
                            [
                                122.73647,
                                -4.64471
                            ],
                            [
                                122.67024,
                                -4.60706
                            ],
                            [
                                122.52305,
                                -4.70642
                            ],
                            [
                                122.45632,
                                -4.73541
                            ],
                            [
                                122.37128,
                                -4.73999
                            ],
                            [
                                122.31776,
                                -4.8342
                            ],
                            [
                                122.37894,
                                -4.95697
                            ],
                            [
                                122.38399,
                                -5.08367
                            ],
                            [
                                122.32687,
                                -5.10651
                            ],
                            [
                                122.31239,
                                -5.23864
                            ],
                            [
                                122.26935,
                                -5.30963
                            ],
                            [
                                122.27683,
                                -5.38313
                            ],
                            [
                                122.38082,
                                -5.3691
                            ],
                            [
                                122.46564,
                                -5.39613
                            ],
                            [
                                122.53086,
                                -5.31343
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                125.25943,
                                -1.88248
                            ],
                            [
                                125.31234,
                                -1.88829
                            ],
                            [
                                125.31632,
                                -1.79106
                            ],
                            [
                                125.28439,
                                -1.73661
                            ],
                            [
                                125.19694,
                                -1.73519
                            ],
                            [
                                125.10524,
                                -1.69777
                            ],
                            [
                                125.09611,
                                -1.75952
                            ],
                            [
                                125.04401,
                                -1.77195
                            ],
                            [
                                124.95795,
                                -1.70476
                            ],
                            [
                                124.89281,
                                -1.70873
                            ],
                            [
                                124.66195,
                                -1.64058
                            ],
                            [
                                124.61326,
                                -1.63445
                            ],
                            [
                                124.39635,
                                -1.66156
                            ],
                            [
                                124.35952,
                                -1.70835
                            ],
                            [
                                124.33443,
                                -1.88328
                            ],
                            [
                                124.38473,
                                -1.9572
                            ],
                            [
                                124.39272,
                                -2.01922
                            ],
                            [
                                124.52483,
                                -2.00876
                            ],
                            [
                                124.68186,
                                -1.97157
                            ],
                            [
                                124.77627,
                                -1.91117
                            ],
                            [
                                124.84778,
                                -1.89428
                            ],
                            [
                                124.88689,
                                -1.92497
                            ],
                            [
                                125.00048,
                                -1.94423
                            ],
                            [
                                125.01861,
                                -1.89792
                            ],
                            [
                                125.10235,
                                -1.89877
                            ],
                            [
                                125.13713,
                                -1.87313
                            ],
                            [
                                125.25943,
                                -1.88248
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                125.77836,
                                -8.00937
                            ],
                            [
                                125.86198,
                                -7.97843
                            ],
                            [
                                125.94383,
                                -7.91219
                            ],
                            [
                                126.06673,
                                -7.88569
                            ],
                            [
                                126.17095,
                                -7.92159
                            ],
                            [
                                126.27934,
                                -7.91455
                            ],
                            [
                                126.41855,
                                -7.9291
                            ],
                            [
                                126.47237,
                                -7.96788
                            ],
                            [
                                126.54984,
                                -7.82146
                            ],
                            [
                                126.71921,
                                -7.74495
                            ],
                            [
                                126.82832,
                                -7.755
                            ],
                            [
                                126.80709,
                                -7.65769
                            ],
                            [
                                126.72538,
                                -7.66688
                            ],
                            [
                                126.64176,
                                -7.60431
                            ],
                            [
                                126.638,
                                -7.56773
                            ],
                            [
                                126.46995,
                                -7.58665
                            ],
                            [
                                126.43322,
                                -7.63125
                            ],
                            [
                                126.38047,
                                -7.63555
                            ],
                            [
                                126.31773,
                                -7.693
                            ],
                            [
                                126.23829,
                                -7.68186
                            ],
                            [
                                126.1836,
                                -7.723
                            ],
                            [
                                125.94437,
                                -7.66357
                            ],
                            [
                                125.87213,
                                -7.79711
                            ],
                            [
                                125.80681,
                                -7.85289
                            ],
                            [
                                125.82265,
                                -7.9087
                            ],
                            [
                                125.77836,
                                -8.00937
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                127.99325,
                                -1.50715
                            ],
                            [
                                127.91927,
                                -1.44536
                            ],
                            [
                                127.82874,
                                -1.43583
                            ],
                            [
                                127.77925,
                                -1.38047
                            ],
                            [
                                127.70694,
                                -1.34071
                            ],
                            [
                                127.63301,
                                -1.33545
                            ],
                            [
                                127.50961,
                                -1.41471
                            ],
                            [
                                127.43512,
                                -1.42888
                            ],
                            [
                                127.40601,
                                -1.48064
                            ],
                            [
                                127.38046,
                                -1.62883
                            ],
                            [
                                127.39161,
                                -1.66446
                            ],
                            [
                                127.494,
                                -1.73229
                            ],
                            [
                                127.65275,
                                -1.733
                            ],
                            [
                                127.71244,
                                -1.69355
                            ],
                            [
                                127.81269,
                                -1.7049
                            ],
                            [
                                127.90842,
                                -1.69095
                            ],
                            [
                                128.01386,
                                -1.73151
                            ],
                            [
                                128.08427,
                                -1.7266
                            ],
                            [
                                128.14441,
                                -1.69073
                            ],
                            [
                                128.15869,
                                -1.6192
                            ],
                            [
                                128.08508,
                                -1.58339
                            ],
                            [
                                127.99325,
                                -1.50715
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                135.37642,
                                -0.64032
                            ],
                            [
                                135.4075,
                                -0.7319
                            ],
                            [
                                135.49206,
                                -0.80896
                            ],
                            [
                                135.54027,
                                -0.79425
                            ],
                            [
                                135.63638,
                                -0.88362
                            ],
                            [
                                135.66768,
                                -0.8892
                            ],
                            [
                                135.71533,
                                -0.81241
                            ],
                            [
                                135.78068,
                                -0.87095
                            ],
                            [
                                135.81352,
                                -1.01292
                            ],
                            [
                                135.83907,
                                -1.0469
                            ],
                            [
                                135.82039,
                                -1.12618
                            ],
                            [
                                135.8734,
                                -1.18631
                            ],
                            [
                                135.95339,
                                -1.16226
                            ],
                            [
                                136.04706,
                                -1.16756
                            ],
                            [
                                136.14661,
                                -1.21615
                            ],
                            [
                                136.31646,
                                -1.16301
                            ],
                            [
                                136.32127,
                                -1.1
                            ],
                            [
                                136.2674,
                                -1.04573
                            ],
                            [
                                136.20452,
                                -1.06496
                            ],
                            [
                                136.12182,
                                -0.98235
                            ],
                            [
                                136.07104,
                                -0.8753
                            ],
                            [
                                135.94358,
                                -0.79905
                            ],
                            [
                                135.88207,
                                -0.7165
                            ],
                            [
                                135.82398,
                                -0.70119
                            ],
                            [
                                135.78121,
                                -0.74332
                            ],
                            [
                                135.65149,
                                -0.67102
                            ],
                            [
                                135.54809,
                                -0.6773
                            ],
                            [
                                135.37642,
                                -0.64032
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                134.34494,
                                -6.7969
                            ],
                            [
                                134.38961,
                                -6.72565
                            ],
                            [
                                134.48858,
                                -6.64708
                            ],
                            [
                                134.47501,
                                -6.48325
                            ],
                            [
                                134.40033,
                                -6.39633
                            ],
                            [
                                134.34005,
                                -6.39078
                            ],
                            [
                                134.29189,
                                -6.35424
                            ],
                            [
                                134.30044,
                                -6.30207
                            ],
                            [
                                134.21329,
                                -6.21776
                            ],
                            [
                                134.09125,
                                -6.17642
                            ],
                            [
                                134.12969,
                                -6.30982
                            ],
                            [
                                134.11185,
                                -6.38275
                            ],
                            [
                                134.13907,
                                -6.45433
                            ],
                            [
                                134.09546,
                                -6.49508
                            ],
                            [
                                134.07722,
                                -6.69906
                            ],
                            [
                                134.05141,
                                -6.76543
                            ],
                            [
                                134.09143,
                                -6.83546
                            ],
                            [
                                134.1534,
                                -6.84651
                            ],
                            [
                                134.17195,
                                -6.90889
                            ],
                            [
                                134.3228,
                                -6.85143
                            ],
                            [
                                134.34494,
                                -6.7969
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                122.78866,
                                -1.45573
                            ],
                            [
                                122.82441,
                                -1.48906
                            ],
                            [
                                122.85517,
                                -1.58668
                            ],
                            [
                                122.89518,
                                -1.60885
                            ],
                            [
                                123.00504,
                                -1.51134
                            ],
                            [
                                123.11625,
                                -1.32354
                            ],
                            [
                                123.15291,
                                -1.34578
                            ],
                            [
                                123.18061,
                                -1.51764
                            ],
                            [
                                123.11131,
                                -1.56644
                            ],
                            [
                                123.15731,
                                -1.63845
                            ],
                            [
                                123.22406,
                                -1.60224
                            ],
                            [
                                123.25987,
                                -1.44871
                            ],
                            [
                                123.29373,
                                -1.41774
                            ],
                            [
                                123.36724,
                                -1.50662
                            ],
                            [
                                123.45484,
                                -1.51357
                            ],
                            [
                                123.50804,
                                -1.45366
                            ],
                            [
                                123.55171,
                                -1.32811
                            ],
                            [
                                123.5172,
                                -1.26581
                            ],
                            [
                                123.40723,
                                -1.25598
                            ],
                            [
                                123.37362,
                                -1.22084
                            ],
                            [
                                123.23785,
                                -1.39763
                            ],
                            [
                                123.18363,
                                -1.32077
                            ],
                            [
                                123.22888,
                                -1.23713
                            ],
                            [
                                123.18517,
                                -1.16093
                            ],
                            [
                                123.14348,
                                -1.2065
                            ],
                            [
                                123.10525,
                                -1.16582
                            ],
                            [
                                122.97498,
                                -1.21127
                            ],
                            [
                                122.90008,
                                -1.18963
                            ],
                            [
                                122.82729,
                                -1.28622
                            ],
                            [
                                122.78866,
                                -1.45573
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                128.59997,
                                2.60029
                            ],
                            [
                                128.54934,
                                2.63563
                            ],
                            [
                                128.52138,
                                2.58192
                            ],
                            [
                                128.4556,
                                2.59471
                            ],
                            [
                                128.40481,
                                2.53056
                            ],
                            [
                                128.29866,
                                2.44521
                            ],
                            [
                                128.25783,
                                2.34641
                            ],
                            [
                                128.21356,
                                2.31206
                            ],
                            [
                                128.24306,
                                2.24477
                            ],
                            [
                                128.24918,
                                2.09635
                            ],
                            [
                                128.28734,
                                2.02881
                            ],
                            [
                                128.38856,
                                2.0548
                            ],
                            [
                                128.51082,
                                2.06525
                            ],
                            [
                                128.61203,
                                2.21046
                            ],
                            [
                                128.64552,
                                2.30341
                            ],
                            [
                                128.64118,
                                2.35408
                            ],
                            [
                                128.68919,
                                2.42297
                            ],
                            [
                                128.68495,
                                2.49913
                            ],
                            [
                                128.63198,
                                2.5368
                            ],
                            [
                                128.59997,
                                2.60029
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                136.40937,
                                -1.72025
                            ],
                            [
                                136.33279,
                                -1.70484
                            ],
                            [
                                136.20146,
                                -1.65378
                            ],
                            [
                                135.87274,
                                -1.65896
                            ],
                            [
                                135.78732,
                                -1.63108
                            ],
                            [
                                135.63299,
                                -1.62733
                            ],
                            [
                                135.4788,
                                -1.60109
                            ],
                            [
                                135.47999,
                                -1.66889
                            ],
                            [
                                135.56235,
                                -1.673
                            ],
                            [
                                135.91937,
                                -1.76401
                            ],
                            [
                                135.99249,
                                -1.81971
                            ],
                            [
                                136.20427,
                                -1.86902
                            ],
                            [
                                136.2673,
                                -1.89774
                            ],
                            [
                                136.33876,
                                -1.8651
                            ],
                            [
                                136.47046,
                                -1.88834
                            ],
                            [
                                136.54518,
                                -1.86731
                            ],
                            [
                                136.64438,
                                -1.86725
                            ],
                            [
                                136.70899,
                                -1.82204
                            ],
                            [
                                136.84806,
                                -1.82207
                            ],
                            [
                                136.90101,
                                -1.79012
                            ],
                            [
                                136.79543,
                                -1.74132
                            ],
                            [
                                136.58441,
                                -1.7289
                            ],
                            [
                                136.46211,
                                -1.7037
                            ],
                            [
                                136.40937,
                                -1.72025
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                124.32974,
                                -8.42077
                            ],
                            [
                                124.41237,
                                -8.46436
                            ],
                            [
                                124.48757,
                                -8.42117
                            ],
                            [
                                124.53855,
                                -8.44456
                            ],
                            [
                                124.65622,
                                -8.39203
                            ],
                            [
                                124.79283,
                                -8.40084
                            ],
                            [
                                124.87905,
                                -8.36815
                            ],
                            [
                                125.1087,
                                -8.343
                            ],
                            [
                                125.12101,
                                -8.21456
                            ],
                            [
                                125.07528,
                                -8.14837
                            ],
                            [
                                124.99194,
                                -8.16203
                            ],
                            [
                                124.8139,
                                -8.1662
                            ],
                            [
                                124.76837,
                                -8.14658
                            ],
                            [
                                124.6604,
                                -8.16327
                            ],
                            [
                                124.60043,
                                -8.19624
                            ],
                            [
                                124.57026,
                                -8.12827
                            ],
                            [
                                124.51498,
                                -8.12008
                            ],
                            [
                                124.44396,
                                -8.14996
                            ],
                            [
                                124.39065,
                                -8.22392
                            ],
                            [
                                124.41378,
                                -8.29569
                            ],
                            [
                                124.32974,
                                -8.42077
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                116.00612,
                                -3.689
                            ],
                            [
                                116.06956,
                                -3.80225
                            ],
                            [
                                116.05957,
                                -3.90506
                            ],
                            [
                                116.07805,
                                -3.9354
                            ],
                            [
                                116.04382,
                                -4.02775
                            ],
                            [
                                116.08971,
                                -4.05941
                            ],
                            [
                                116.14453,
                                -4.03638
                            ],
                            [
                                116.31023,
                                -3.87222
                            ],
                            [
                                116.27199,
                                -3.81288
                            ],
                            [
                                116.2997,
                                -3.72264
                            ],
                            [
                                116.2911,
                                -3.57337
                            ],
                            [
                                116.30645,
                                -3.45052
                            ],
                            [
                                116.24801,
                                -3.38573
                            ],
                            [
                                116.28052,
                                -3.22435
                            ],
                            [
                                116.11483,
                                -3.31466
                            ],
                            [
                                116.04031,
                                -3.49153
                            ],
                            [
                                116.04295,
                                -3.55762
                            ],
                            [
                                116.00612,
                                -3.689
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                130.02905,
                                -2.02204
                            ],
                            [
                                130.12071,
                                -2.05881
                            ],
                            [
                                130.24945,
                                -2.05109
                            ],
                            [
                                130.31405,
                                -1.97243
                            ],
                            [
                                130.36243,
                                -1.94801
                            ],
                            [
                                130.43451,
                                -1.83336
                            ],
                            [
                                130.40353,
                                -1.77455
                            ],
                            [
                                130.33885,
                                -1.73781
                            ],
                            [
                                130.32602,
                                -1.67555
                            ],
                            [
                                130.24195,
                                -1.73019
                            ],
                            [
                                130.04879,
                                -1.73481
                            ],
                            [
                                129.89503,
                                -1.79198
                            ],
                            [
                                129.85168,
                                -1.83012
                            ],
                            [
                                129.74836,
                                -1.85556
                            ],
                            [
                                129.73117,
                                -1.90877
                            ],
                            [
                                129.85372,
                                -1.97931
                            ],
                            [
                                130.02905,
                                -2.02204
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                127.60557,
                                -0.60253
                            ],
                            [
                                127.69158,
                                -0.47283
                            ],
                            [
                                127.57268,
                                -0.33059
                            ],
                            [
                                127.5265,
                                -0.31176
                            ],
                            [
                                127.44714,
                                -0.42471
                            ],
                            [
                                127.37497,
                                -0.33218
                            ],
                            [
                                127.2896,
                                -0.44811
                            ],
                            [
                                127.29668,
                                -0.52185
                            ],
                            [
                                127.40729,
                                -0.63141
                            ],
                            [
                                127.47112,
                                -0.64576
                            ],
                            [
                                127.43471,
                                -0.75432
                            ],
                            [
                                127.45673,
                                -0.82022
                            ],
                            [
                                127.50521,
                                -0.81366
                            ],
                            [
                                127.62345,
                                -0.75764
                            ],
                            [
                                127.68219,
                                -0.85859
                            ],
                            [
                                127.74886,
                                -0.88744
                            ],
                            [
                                127.82166,
                                -0.87005
                            ],
                            [
                                127.88196,
                                -0.79691
                            ],
                            [
                                127.86197,
                                -0.72932
                            ],
                            [
                                127.79832,
                                -0.69777
                            ],
                            [
                                127.67915,
                                -0.72113
                            ],
                            [
                                127.60557,
                                -0.60253
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                95.69248,
                                2.7693
                            ],
                            [
                                95.7799,
                                2.66933
                            ],
                            [
                                95.78963,
                                2.62704
                            ],
                            [
                                95.85692,
                                2.62456
                            ],
                            [
                                95.93982,
                                2.56033
                            ],
                            [
                                96.01373,
                                2.58282
                            ],
                            [
                                96.07616,
                                2.56292
                            ],
                            [
                                96.22948,
                                2.43984
                            ],
                            [
                                96.31592,
                                2.40964
                            ],
                            [
                                96.31828,
                                2.35621
                            ],
                            [
                                96.44054,
                                2.32799
                            ],
                            [
                                96.49618,
                                2.36424
                            ],
                            [
                                96.4541,
                                2.47259
                            ],
                            [
                                96.34284,
                                2.55105
                            ],
                            [
                                96.25467,
                                2.58541
                            ],
                            [
                                96.20157,
                                2.64174
                            ],
                            [
                                96.10226,
                                2.64686
                            ],
                            [
                                96.12822,
                                2.7048
                            ],
                            [
                                96.09123,
                                2.75515
                            ],
                            [
                                96.02316,
                                2.75934
                            ],
                            [
                                95.92579,
                                2.82054
                            ],
                            [
                                95.87955,
                                2.81769
                            ],
                            [
                                95.87176,
                                2.90384
                            ],
                            [
                                95.77072,
                                2.89298
                            ],
                            [
                                95.76082,
                                2.84811
                            ],
                            [
                                95.69248,
                                2.7693
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                134.7534,
                                -6.06118
                            ],
                            [
                                134.62978,
                                -5.93895
                            ],
                            [
                                134.58927,
                                -5.94547
                            ],
                            [
                                134.5313,
                                -5.91838
                            ],
                            [
                                134.46332,
                                -5.96184
                            ],
                            [
                                134.42663,
                                -6.01638
                            ],
                            [
                                134.28398,
                                -6.04341
                            ],
                            [
                                134.26912,
                                -6.13581
                            ],
                            [
                                134.39268,
                                -6.25223
                            ],
                            [
                                134.45272,
                                -6.25914
                            ],
                            [
                                134.54765,
                                -6.34525
                            ],
                            [
                                134.61252,
                                -6.36193
                            ],
                            [
                                134.7158,
                                -6.30123
                            ],
                            [
                                134.74865,
                                -6.21962
                            ],
                            [
                                134.7534,
                                -6.06118
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                107.97133,
                                4.01094
                            ],
                            [
                                107.9942,
                                3.94345
                            ],
                            [
                                108.06409,
                                3.83549
                            ],
                            [
                                108.19276,
                                3.78245
                            ],
                            [
                                108.13989,
                                3.75066
                            ],
                            [
                                108.09056,
                                3.67858
                            ],
                            [
                                108.15665,
                                3.63119
                            ],
                            [
                                108.24083,
                                3.66483
                            ],
                            [
                                108.29751,
                                3.65925
                            ],
                            [
                                108.30914,
                                3.73087
                            ],
                            [
                                108.38342,
                                3.79544
                            ],
                            [
                                108.40604,
                                3.85853
                            ],
                            [
                                108.351,
                                3.99898
                            ],
                            [
                                108.24119,
                                4.13086
                            ],
                            [
                                108.21731,
                                4.23095
                            ],
                            [
                                108.15896,
                                4.15661
                            ],
                            [
                                108.06123,
                                4.06726
                            ],
                            [
                                107.97133,
                                4.01094
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                130.72603,
                                -0.94468
                            ],
                            [
                                130.64557,
                                -0.96801
                            ],
                            [
                                130.70497,
                                -1.05909
                            ],
                            [
                                130.71471,
                                -1.15104
                            ],
                            [
                                130.74831,
                                -1.23531
                            ],
                            [
                                130.80631,
                                -1.26926
                            ],
                            [
                                130.85871,
                                -1.35003
                            ],
                            [
                                130.90797,
                                -1.33073
                            ],
                            [
                                130.97069,
                                -1.36197
                            ],
                            [
                                131.05465,
                                -1.20852
                            ],
                            [
                                131.04361,
                                -1.17559
                            ],
                            [
                                131.08089,
                                -1.01829
                            ],
                            [
                                131.02872,
                                -0.9229
                            ],
                            [
                                130.92569,
                                -0.93937
                            ],
                            [
                                130.91622,
                                -0.89886
                            ],
                            [
                                130.8308,
                                -0.90768
                            ],
                            [
                                130.72603,
                                -0.94468
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                134.23485,
                                -5.73919
                            ],
                            [
                                134.39207,
                                -5.78542
                            ],
                            [
                                134.28774,
                                -5.90198
                            ],
                            [
                                134.32292,
                                -5.94317
                            ],
                            [
                                134.29972,
                                -6.01645
                            ],
                            [
                                134.4178,
                                -6.01526
                            ],
                            [
                                134.46011,
                                -5.95935
                            ],
                            [
                                134.52314,
                                -5.91509
                            ],
                            [
                                134.59509,
                                -5.93624
                            ],
                            [
                                134.66075,
                                -5.92213
                            ],
                            [
                                134.70979,
                                -5.97271
                            ],
                            [
                                134.76176,
                                -5.88871
                            ],
                            [
                                134.74253,
                                -5.77087
                            ],
                            [
                                134.71038,
                                -5.74112
                            ],
                            [
                                134.60834,
                                -5.71695
                            ],
                            [
                                134.5321,
                                -5.63045
                            ],
                            [
                                134.51945,
                                -5.56401
                            ],
                            [
                                134.43586,
                                -5.56311
                            ],
                            [
                                134.40606,
                                -5.62937
                            ],
                            [
                                134.32638,
                                -5.71786
                            ],
                            [
                                134.23982,
                                -5.65991
                            ],
                            [
                                134.23485,
                                -5.73919
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                102.85468,
                                0.95449
                            ],
                            [
                                102.72991,
                                1.01482
                            ],
                            [
                                102.64458,
                                0.97971
                            ],
                            [
                                102.619,
                                1.04541
                            ],
                            [
                                102.54684,
                                1.11835
                            ],
                            [
                                102.49221,
                                1.12961
                            ],
                            [
                                102.46261,
                                1.06877
                            ],
                            [
                                102.50682,
                                0.94539
                            ],
                            [
                                102.44696,
                                0.92714
                            ],
                            [
                                102.41192,
                                0.87643
                            ],
                            [
                                102.44223,
                                0.81983
                            ],
                            [
                                102.55136,
                                0.76747
                            ],
                            [
                                102.64497,
                                0.78334
                            ],
                            [
                                102.86426,
                                0.78621
                            ],
                            [
                                102.92578,
                                0.77171
                            ],
                            [
                                102.99735,
                                0.68509
                            ],
                            [
                                103.05624,
                                0.7112
                            ],
                            [
                                103.05488,
                                0.81517
                            ],
                            [
                                102.94997,
                                0.87879
                            ],
                            [
                                102.85468,
                                0.95449
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                101.38739,
                                1.90808
                            ],
                            [
                                101.45691,
                                1.72367
                            ],
                            [
                                101.62301,
                                1.68656
                            ],
                            [
                                101.7405,
                                1.76494
                            ],
                            [
                                101.783,
                                1.98568
                            ],
                            [
                                101.71369,
                                2.08808
                            ],
                            [
                                101.65704,
                                2.11897
                            ],
                            [
                                101.52472,
                                2.02913
                            ],
                            [
                                101.47782,
                                2.0612
                            ],
                            [
                                101.40008,
                                2.00323
                            ],
                            [
                                101.38739,
                                1.90808
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                122.80612,
                                -10.80181
                            ],
                            [
                                122.82388,
                                -10.91802
                            ],
                            [
                                122.91271,
                                -10.92231
                            ],
                            [
                                122.9919,
                                -10.8611
                            ],
                            [
                                123.08723,
                                -10.85573
                            ],
                            [
                                123.15805,
                                -10.81708
                            ],
                            [
                                123.22214,
                                -10.82608
                            ],
                            [
                                123.25243,
                                -10.73781
                            ],
                            [
                                123.33263,
                                -10.68086
                            ],
                            [
                                123.40522,
                                -10.68152
                            ],
                            [
                                123.42034,
                                -10.61474
                            ],
                            [
                                123.35808,
                                -10.59875
                            ],
                            [
                                123.39675,
                                -10.54158
                            ],
                            [
                                123.36568,
                                -10.47888
                            ],
                            [
                                123.26463,
                                -10.52236
                            ],
                            [
                                123.17528,
                                -10.63847
                            ],
                            [
                                123.12783,
                                -10.64654
                            ],
                            [
                                123.04229,
                                -10.72813
                            ],
                            [
                                122.86314,
                                -10.75821
                            ],
                            [
                                122.80612,
                                -10.80181
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                123.88187,
                                -8.21981
                            ],
                            [
                                123.75175,
                                -8.18227
                            ],
                            [
                                123.67868,
                                -8.2615
                            ],
                            [
                                123.64383,
                                -8.25878
                            ],
                            [
                                123.54108,
                                -8.37513
                            ],
                            [
                                123.48888,
                                -8.34506
                            ],
                            [
                                123.54413,
                                -8.25003
                            ],
                            [
                                123.45876,
                                -8.26879
                            ],
                            [
                                123.45723,
                                -8.34679
                            ],
                            [
                                123.32816,
                                -8.40944
                            ],
                            [
                                123.28656,
                                -8.46676
                            ],
                            [
                                123.19683,
                                -8.53185
                            ],
                            [
                                123.31141,
                                -8.53359
                            ],
                            [
                                123.38682,
                                -8.58705
                            ],
                            [
                                123.48222,
                                -8.52394
                            ],
                            [
                                123.54272,
                                -8.57615
                            ],
                            [
                                123.58052,
                                -8.53642
                            ],
                            [
                                123.54879,
                                -8.47768
                            ],
                            [
                                123.60902,
                                -8.41566
                            ],
                            [
                                123.68094,
                                -8.41872
                            ],
                            [
                                123.7537,
                                -8.29179
                            ],
                            [
                                123.90532,
                                -8.25883
                            ],
                            [
                                123.88187,
                                -8.21981
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                125.32505,
                                -1.83944
                            ],
                            [
                                125.43294,
                                -1.89026
                            ],
                            [
                                125.43509,
                                -1.92728
                            ],
                            [
                                125.519,
                                -1.94464
                            ],
                            [
                                125.58229,
                                -1.92584
                            ],
                            [
                                125.75086,
                                -1.92369
                            ],
                            [
                                125.83819,
                                -1.8923
                            ],
                            [
                                125.92115,
                                -1.93022
                            ],
                            [
                                126.06185,
                                -1.88111
                            ],
                            [
                                126.24596,
                                -1.87505
                            ],
                            [
                                126.33017,
                                -1.83151
                            ],
                            [
                                126.19859,
                                -1.80693
                            ],
                            [
                                126.11817,
                                -1.80913
                            ],
                            [
                                125.9139,
                                -1.79094
                            ],
                            [
                                125.65327,
                                -1.82338
                            ],
                            [
                                125.46163,
                                -1.78152
                            ],
                            [
                                125.421,
                                -1.80801
                            ],
                            [
                                125.36283,
                                -1.78396
                            ],
                            [
                                125.32505,
                                -1.83944
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                104.64495,
                                0.97053
                            ],
                            [
                                104.66265,
                                1.02005
                            ],
                            [
                                104.64116,
                                1.10158
                            ],
                            [
                                104.59133,
                                1.147
                            ],
                            [
                                104.59069,
                                1.21721
                            ],
                            [
                                104.51296,
                                1.16807
                            ],
                            [
                                104.40281,
                                1.19764
                            ],
                            [
                                104.33649,
                                1.13881
                            ],
                            [
                                104.25375,
                                1.11647
                            ],
                            [
                                104.22323,
                                1.06463
                            ],
                            [
                                104.27051,
                                0.99813
                            ],
                            [
                                104.38264,
                                1.00796
                            ],
                            [
                                104.42259,
                                0.97053
                            ],
                            [
                                104.48363,
                                0.84861
                            ],
                            [
                                104.59081,
                                0.80986
                            ],
                            [
                                104.66389,
                                0.87812
                            ],
                            [
                                104.64495,
                                0.97053
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                102.20945,
                                1.2729
                            ],
                            [
                                102.25684,
                                1.17774
                            ],
                            [
                                102.24174,
                                1.1006
                            ],
                            [
                                102.28723,
                                0.99015
                            ],
                            [
                                102.4024,
                                0.90723
                            ],
                            [
                                102.48972,
                                0.94822
                            ],
                            [
                                102.44379,
                                1.05569
                            ],
                            [
                                102.49075,
                                1.22714
                            ],
                            [
                                102.40198,
                                1.29781
                            ],
                            [
                                102.29325,
                                1.40993
                            ],
                            [
                                102.21873,
                                1.40793
                            ],
                            [
                                102.23098,
                                1.31888
                            ],
                            [
                                102.20945,
                                1.2729
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                109.40566,
                                -1.25567
                            ],
                            [
                                109.50352,
                                -1.31473
                            ],
                            [
                                109.54376,
                                -1.2711
                            ],
                            [
                                109.7674,
                                -1.15763
                            ],
                            [
                                109.75615,
                                -1.00401
                            ],
                            [
                                109.68425,
                                -1.01723
                            ],
                            [
                                109.62267,
                                -0.97965
                            ],
                            [
                                109.54688,
                                -0.99723
                            ],
                            [
                                109.47729,
                                -0.97664
                            ],
                            [
                                109.44095,
                                -1.01864
                            ],
                            [
                                109.45068,
                                -1.06856
                            ],
                            [
                                109.43129,
                                -1.21823
                            ],
                            [
                                109.40566,
                                -1.25567
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                101.99483,
                                1.60905
                            ],
                            [
                                102.03546,
                                1.53193
                            ],
                            [
                                102.10295,
                                1.46693
                            ],
                            [
                                102.17033,
                                1.43801
                            ],
                            [
                                102.27923,
                                1.43302
                            ],
                            [
                                102.40763,
                                1.315
                            ],
                            [
                                102.51293,
                                1.24462
                            ],
                            [
                                102.49719,
                                1.38874
                            ],
                            [
                                102.50122,
                                1.46678
                            ],
                            [
                                102.46558,
                                1.51763
                            ],
                            [
                                102.38389,
                                1.54181
                            ],
                            [
                                102.16044,
                                1.57458
                            ],
                            [
                                102.03435,
                                1.61474
                            ],
                            [
                                101.99483,
                                1.60905
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                103.10867,
                                0.95449
                            ],
                            [
                                102.99868,
                                1.07488
                            ],
                            [
                                102.8665,
                                1.13226
                            ],
                            [
                                102.75873,
                                1.15606
                            ],
                            [
                                102.69533,
                                1.11025
                            ],
                            [
                                102.64367,
                                1.00243
                            ],
                            [
                                102.73702,
                                1.03228
                            ],
                            [
                                102.81163,
                                0.98459
                            ],
                            [
                                102.89473,
                                0.95625
                            ],
                            [
                                102.9508,
                                0.90689
                            ],
                            [
                                103.12245,
                                0.82014
                            ],
                            [
                                103.17223,
                                0.88073
                            ],
                            [
                                103.10867,
                                0.95449
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                100.21982,
                                -2.78898
                            ],
                            [
                                100.16966,
                                -2.81386
                            ],
                            [
                                100.19371,
                                -2.93495
                            ],
                            [
                                100.18159,
                                -2.9953
                            ],
                            [
                                100.29281,
                                -3.08745
                            ],
                            [
                                100.33501,
                                -3.14535
                            ],
                            [
                                100.3376,
                                -3.24437
                            ],
                            [
                                100.44217,
                                -3.34396
                            ],
                            [
                                100.473,
                                -3.33161
                            ],
                            [
                                100.39263,
                                -3.20974
                            ],
                            [
                                100.39246,
                                -3.16149
                            ],
                            [
                                100.47277,
                                -3.14322
                            ],
                            [
                                100.46975,
                                -3.02597
                            ],
                            [
                                100.43646,
                                -3.00915
                            ],
                            [
                                100.34629,
                                -2.89923
                            ],
                            [
                                100.21982,
                                -2.78898
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                104.75449,
                                -0.26081
                            ],
                            [
                                104.84366,
                                -0.32328
                            ],
                            [
                                104.88773,
                                -0.33214
                            ],
                            [
                                104.92841,
                                -0.2898
                            ],
                            [
                                104.85064,
                                -0.16496
                            ],
                            [
                                104.78943,
                                -0.21185
                            ],
                            [
                                104.55554,
                                0.02201
                            ],
                            [
                                104.49329,
                                -0.01143
                            ],
                            [
                                104.49899,
                                -0.13159
                            ],
                            [
                                104.41996,
                                -0.20608
                            ],
                            [
                                104.42753,
                                -0.24198
                            ],
                            [
                                104.52534,
                                -0.27785
                            ],
                            [
                                104.69367,
                                -0.21256
                            ],
                            [
                                104.75449,
                                -0.26081
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                121.7915,
                                -5.26368
                            ],
                            [
                                121.87369,
                                -5.38369
                            ],
                            [
                                121.91958,
                                -5.40164
                            ],
                            [
                                121.94022,
                                -5.47768
                            ],
                            [
                                122.04528,
                                -5.45708
                            ],
                            [
                                122.05184,
                                -5.3104
                            ],
                            [
                                122.03682,
                                -5.23802
                            ],
                            [
                                122.06781,
                                -5.20288
                            ],
                            [
                                121.92892,
                                -5.10628
                            ],
                            [
                                121.85427,
                                -5.08525
                            ],
                            [
                                121.84435,
                                -5.14346
                            ],
                            [
                                121.7915,
                                -5.26368
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                126.67165,
                                4.00653
                            ],
                            [
                                126.7613,
                                3.99284
                            ],
                            [
                                126.81342,
                                4.03571
                            ],
                            [
                                126.80596,
                                4.14835
                            ],
                            [
                                126.91636,
                                4.27398
                            ],
                            [
                                126.85375,
                                4.38464
                            ],
                            [
                                126.85687,
                                4.4922
                            ],
                            [
                                126.74389,
                                4.54929
                            ],
                            [
                                126.73763,
                                4.46406
                            ],
                            [
                                126.69482,
                                4.40109
                            ],
                            [
                                126.68642,
                                4.34531
                            ],
                            [
                                126.72455,
                                4.27398
                            ],
                            [
                                126.79898,
                                4.24121
                            ],
                            [
                                126.73785,
                                4.11542
                            ],
                            [
                                126.68951,
                                4.07016
                            ],
                            [
                                126.67165,
                                4.00653
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                127.99325,
                                -3.61678
                            ],
                            [
                                127.91187,
                                -3.68656
                            ],
                            [
                                127.93318,
                                -3.78156
                            ],
                            [
                                127.98742,
                                -3.78617
                            ],
                            [
                                128.03207,
                                -3.73531
                            ],
                            [
                                128.08623,
                                -3.71526
                            ],
                            [
                                128.11717,
                                -3.74773
                            ],
                            [
                                128.24338,
                                -3.74027
                            ],
                            [
                                128.33586,
                                -3.64568
                            ],
                            [
                                128.31577,
                                -3.57487
                            ],
                            [
                                128.34051,
                                -3.5203
                            ],
                            [
                                128.24532,
                                -3.50287
                            ],
                            [
                                128.15796,
                                -3.5933
                            ],
                            [
                                128.07946,
                                -3.58511
                            ],
                            [
                                127.99325,
                                -3.61678
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                104.4181,
                                -0.59648
                            ],
                            [
                                104.48186,
                                -0.64909
                            ],
                            [
                                104.53166,
                                -0.54712
                            ],
                            [
                                104.57836,
                                -0.50182
                            ],
                            [
                                104.52807,
                                -0.3804
                            ],
                            [
                                104.43412,
                                -0.35073
                            ],
                            [
                                104.40921,
                                -0.41076
                            ],
                            [
                                104.32377,
                                -0.44756
                            ],
                            [
                                104.27724,
                                -0.40832
                            ],
                            [
                                104.24227,
                                -0.49872
                            ],
                            [
                                104.3172,
                                -0.54804
                            ],
                            [
                                104.34249,
                                -0.62985
                            ],
                            [
                                104.4181,
                                -0.59648
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                123.90518,
                                -8.43706
                            ],
                            [
                                124.01929,
                                -8.42055
                            ],
                            [
                                124.05295,
                                -8.49395
                            ],
                            [
                                124.05104,
                                -8.54742
                            ],
                            [
                                124.13374,
                                -8.53734
                            ],
                            [
                                124.19565,
                                -8.46567
                            ],
                            [
                                124.19785,
                                -8.4141
                            ],
                            [
                                124.2917,
                                -8.32799
                            ],
                            [
                                124.29653,
                                -8.17981
                            ],
                            [
                                124.23552,
                                -8.19852
                            ],
                            [
                                124.19042,
                                -8.27278
                            ],
                            [
                                124.11624,
                                -8.34819
                            ],
                            [
                                124.07413,
                                -8.35321
                            ],
                            [
                                124.04584,
                                -8.29537
                            ],
                            [
                                123.96461,
                                -8.33982
                            ],
                            [
                                123.90518,
                                -8.43706
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                122.93936,
                                -4.0709
                            ],
                            [
                                122.9921,
                                -4.19513
                            ],
                            [
                                123.11775,
                                -4.25671
                            ],
                            [
                                123.24679,
                                -4.12357
                            ],
                            [
                                123.25239,
                                -4.05798
                            ],
                            [
                                123.20658,
                                -4.01393
                            ],
                            [
                                123.08831,
                                -4.01806
                            ],
                            [
                                123.01415,
                                -3.98009
                            ],
                            [
                                122.93936,
                                -4.0709
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                138.59211,
                                -8.34256
                            ],
                            [
                                138.67535,
                                -8.37366
                            ],
                            [
                                138.78469,
                                -8.39054
                            ],
                            [
                                138.92764,
                                -8.38585
                            ],
                            [
                                138.95412,
                                -8.33233
                            ],
                            [
                                138.88345,
                                -8.24981
                            ],
                            [
                                138.85168,
                                -8.13726
                            ],
                            [
                                138.71541,
                                -8.17147
                            ],
                            [
                                138.69972,
                                -8.2341
                            ],
                            [
                                138.59211,
                                -8.34256
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                120.42485,
                                -6.18514
                            ],
                            [
                                120.44541,
                                -6.26742
                            ],
                            [
                                120.47471,
                                -6.28302
                            ],
                            [
                                120.46534,
                                -6.40319
                            ],
                            [
                                120.49634,
                                -6.42442
                            ],
                            [
                                120.53682,
                                -6.28863
                            ],
                            [
                                120.5248,
                                -6.21181
                            ],
                            [
                                120.56754,
                                -6.05666
                            ],
                            [
                                120.50011,
                                -5.78653
                            ],
                            [
                                120.4551,
                                -5.805
                            ],
                            [
                                120.44408,
                                -6.0364
                            ],
                            [
                                120.45937,
                                -6.09998
                            ],
                            [
                                120.42485,
                                -6.18514
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                129.58112,
                                -7.88969
                            ],
                            [
                                129.71628,
                                -8.05468
                            ],
                            [
                                129.77974,
                                -8.0506
                            ],
                            [
                                129.84793,
                                -7.93476
                            ],
                            [
                                129.85036,
                                -7.83996
                            ],
                            [
                                129.80473,
                                -7.81254
                            ],
                            [
                                129.67262,
                                -7.7857
                            ],
                            [
                                129.59205,
                                -7.81811
                            ],
                            [
                                129.58112,
                                -7.88969
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                100.21982,
                                -2.74964
                            ],
                            [
                                100.16416,
                                -2.64769
                            ],
                            [
                                100.05263,
                                -2.5721
                            ],
                            [
                                100.0173,
                                -2.5226
                            ],
                            [
                                99.96382,
                                -2.51201
                            ],
                            [
                                99.96599,
                                -2.62534
                            ],
                            [
                                100.00365,
                                -2.68421
                            ],
                            [
                                99.98784,
                                -2.77106
                            ],
                            [
                                100.02134,
                                -2.85686
                            ],
                            [
                                100.1371,
                                -2.81267
                            ],
                            [
                                100.21982,
                                -2.74964
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                99.51883,
                                -2.16027
                            ],
                            [
                                99.59346,
                                -2.28604
                            ],
                            [
                                99.65973,
                                -2.29322
                            ],
                            [
                                99.73169,
                                -2.34745
                            ],
                            [
                                99.82423,
                                -2.36949
                            ],
                            [
                                99.8408,
                                -2.33925
                            ],
                            [
                                99.71142,
                                -2.18186
                            ],
                            [
                                99.69386,
                                -2.09237
                            ],
                            [
                                99.62775,
                                -2.03942
                            ],
                            [
                                99.57693,
                                -2.02978
                            ],
                            [
                                99.53336,
                                -2.08089
                            ],
                            [
                                99.51883,
                                -2.16027
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                125.85268,
                                -2.07795
                            ],
                            [
                                125.88058,
                                -2.20409
                            ],
                            [
                                125.93668,
                                -2.29883
                            ],
                            [
                                125.94644,
                                -2.38878
                            ],
                            [
                                126.03461,
                                -2.48317
                            ],
                            [
                                126.07784,
                                -2.44618
                            ],
                            [
                                125.97057,
                                -2.20342
                            ],
                            [
                                125.95576,
                                -2.14338
                            ],
                            [
                                125.99011,
                                -2.01647
                            ],
                            [
                                125.90744,
                                -1.97131
                            ],
                            [
                                125.85268,
                                -2.07795
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                132.84336,
                                -5.98911
                            ],
                            [
                                132.8893,
                                -5.9526
                            ],
                            [
                                132.95193,
                                -5.86159
                            ],
                            [
                                132.96395,
                                -5.73885
                            ],
                            [
                                133.04833,
                                -5.64093
                            ],
                            [
                                133.09096,
                                -5.62128
                            ],
                            [
                                133.12846,
                                -5.5532
                            ],
                            [
                                133.17194,
                                -5.36447
                            ],
                            [
                                133.19573,
                                -5.30403
                            ],
                            [
                                133.12686,
                                -5.27901
                            ],
                            [
                                133.08109,
                                -5.3904
                            ],
                            [
                                133.00994,
                                -5.64079
                            ],
                            [
                                132.95475,
                                -5.65305
                            ],
                            [
                                132.92653,
                                -5.77613
                            ],
                            [
                                132.87918,
                                -5.84414
                            ],
                            [
                                132.84336,
                                -5.98911
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                125.39544,
                                3.68207
                            ],
                            [
                                125.48327,
                                3.58033
                            ],
                            [
                                125.4869,
                                3.47651
                            ],
                            [
                                125.52866,
                                3.41765
                            ],
                            [
                                125.60312,
                                3.37852
                            ],
                            [
                                125.64955,
                                3.39451
                            ],
                            [
                                125.66754,
                                3.49702
                            ],
                            [
                                125.57151,
                                3.59473
                            ],
                            [
                                125.57095,
                                3.64589
                            ],
                            [
                                125.50611,
                                3.72855
                            ],
                            [
                                125.41662,
                                3.73587
                            ],
                            [
                                125.39544,
                                3.68207
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                122.99008,
                                -8.40271
                            ],
                            [
                                123.06428,
                                -8.41441
                            ],
                            [
                                123.18382,
                                -8.38931
                            ],
                            [
                                123.29005,
                                -8.39225
                            ],
                            [
                                123.30478,
                                -8.29945
                            ],
                            [
                                123.24164,
                                -8.23159
                            ],
                            [
                                123.12259,
                                -8.24793
                            ],
                            [
                                123.02545,
                                -8.31279
                            ],
                            [
                                122.99008,
                                -8.40271
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                127.09604,
                                -0.43203
                            ],
                            [
                                127.1573,
                                -0.54102
                            ],
                            [
                                127.25598,
                                -0.49898
                            ],
                            [
                                127.2804,
                                -0.37778
                            ],
                            [
                                127.2486,
                                -0.33637
                            ],
                            [
                                127.23908,
                                -0.25507
                            ],
                            [
                                127.10099,
                                -0.28627
                            ],
                            [
                                127.12464,
                                -0.36432
                            ],
                            [
                                127.09604,
                                -0.43203
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                98.41387,
                                -0.59648
                            ],
                            [
                                98.41908,
                                -0.55311
                            ],
                            [
                                98.49352,
                                -0.55092
                            ],
                            [
                                98.50909,
                                -0.36653
                            ],
                            [
                                98.4367,
                                -0.25278
                            ],
                            [
                                98.35838,
                                -0.39883
                            ],
                            [
                                98.3621,
                                -0.46596
                            ],
                            [
                                98.33379,
                                -0.52737
                            ],
                            [
                                98.41387,
                                -0.59648
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                130.72603,
                                -0.82803
                            ],
                            [
                                130.6342,
                                -0.80931
                            ],
                            [
                                130.54085,
                                -0.84877
                            ],
                            [
                                130.45717,
                                -0.82049
                            ],
                            [
                                130.45878,
                                -0.91608
                            ],
                            [
                                130.62676,
                                -0.91917
                            ],
                            [
                                130.83518,
                                -0.86962
                            ],
                            [
                                130.81327,
                                -0.81484
                            ],
                            [
                                130.72603,
                                -0.82803
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                115.55858,
                                -6.90652
                            ],
                            [
                                115.40967,
                                -6.83687
                            ],
                            [
                                115.24715,
                                -6.82619
                            ],
                            [
                                115.20835,
                                -6.93923
                            ],
                            [
                                115.26005,
                                -6.99494
                            ],
                            [
                                115.39624,
                                -6.98867
                            ],
                            [
                                115.34646,
                                -6.93755
                            ],
                            [
                                115.46479,
                                -6.9297
                            ],
                            [
                                115.55858,
                                -6.90652
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                132.60893,
                                -5.6024
                            ],
                            [
                                132.65236,
                                -5.67034
                            ],
                            [
                                132.68189,
                                -5.8098
                            ],
                            [
                                132.6601,
                                -5.90596
                            ],
                            [
                                132.71686,
                                -5.94141
                            ],
                            [
                                132.7716,
                                -5.94297
                            ],
                            [
                                132.80767,
                                -5.84722
                            ],
                            [
                                132.76656,
                                -5.77131
                            ],
                            [
                                132.706,
                                -5.60345
                            ],
                            [
                                132.65518,
                                -5.62398
                            ],
                            [
                                132.60893,
                                -5.6024
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                104.02732,
                                0.97786
                            ],
                            [
                                104.14493,
                                1.0447
                            ],
                            [
                                104.14578,
                                1.16441
                            ],
                            [
                                104.08885,
                                1.18612
                            ],
                            [
                                104.06053,
                                1.13397
                            ],
                            [
                                104.0007,
                                1.11938
                            ],
                            [
                                103.92874,
                                1.1324
                            ],
                            [
                                103.94577,
                                1.00651
                            ],
                            [
                                104.02732,
                                0.97786
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                102.09309,
                                -5.34937
                            ],
                            [
                                102.25301,
                                -5.46511
                            ],
                            [
                                102.25636,
                                -5.49892
                            ],
                            [
                                102.36893,
                                -5.47121
                            ],
                            [
                                102.38866,
                                -5.38738
                            ],
                            [
                                102.29234,
                                -5.35484
                            ],
                            [
                                102.24103,
                                -5.31443
                            ],
                            [
                                102.15617,
                                -5.2868
                            ],
                            [
                                102.09309,
                                -5.34937
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                121.69384,
                                -10.57861
                            ],
                            [
                                121.83995,
                                -10.62494
                            ],
                            [
                                121.98656,
                                -10.54621
                            ],
                            [
                                122.0,
                                -10.45584
                            ],
                            [
                                121.90923,
                                -10.42653
                            ],
                            [
                                121.85336,
                                -10.45149
                            ],
                            [
                                121.83313,
                                -10.50313
                            ],
                            [
                                121.69384,
                                -10.57861
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                134.23485,
                                -6.22576
                            ],
                            [
                                134.34153,
                                -6.33636
                            ],
                            [
                                134.4129,
                                -6.27994
                            ],
                            [
                                134.32986,
                                -6.21949
                            ],
                            [
                                134.22992,
                                -6.11794
                            ],
                            [
                                134.22471,
                                -6.0155
                            ],
                            [
                                134.12175,
                                -6.03692
                            ],
                            [
                                134.11413,
                                -6.10047
                            ],
                            [
                                134.15991,
                                -6.17184
                            ],
                            [
                                134.23485,
                                -6.22576
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                134.59826,
                                -6.44117
                            ],
                            [
                                134.58884,
                                -6.38203
                            ],
                            [
                                134.45425,
                                -6.27597
                            ],
                            [
                                134.37348,
                                -6.31485
                            ],
                            [
                                134.35633,
                                -6.35294
                            ],
                            [
                                134.43531,
                                -6.42882
                            ],
                            [
                                134.48742,
                                -6.45234
                            ],
                            [
                                134.51292,
                                -6.51987
                            ],
                            [
                                134.55935,
                                -6.52045
                            ],
                            [
                                134.59826,
                                -6.44117
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                127.99325,
                                -8.14172
                            ],
                            [
                                127.93998,
                                -8.14508
                            ],
                            [
                                127.78994,
                                -8.10124
                            ],
                            [
                                127.78847,
                                -8.17712
                            ],
                            [
                                127.86593,
                                -8.21655
                            ],
                            [
                                127.94685,
                                -8.22309
                            ],
                            [
                                128.02318,
                                -8.26569
                            ],
                            [
                                128.10263,
                                -8.13855
                            ],
                            [
                                127.99325,
                                -8.14172
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                130.75613,
                                -8.3395
                            ],
                            [
                                130.81597,
                                -8.34204
                            ],
                            [
                                130.89727,
                                -8.2895
                            ],
                            [
                                130.92279,
                                -8.232
                            ],
                            [
                                130.98559,
                                -8.23719
                            ],
                            [
                                131.0233,
                                -8.20597
                            ],
                            [
                                131.13927,
                                -8.16489
                            ],
                            [
                                131.02855,
                                -8.07388
                            ],
                            [
                                130.93021,
                                -8.19624
                            ],
                            [
                                130.82035,
                                -8.26162
                            ],
                            [
                                130.75613,
                                -8.3395
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                98.31099,
                                -0.01504
                            ],
                            [
                                98.38092,
                                -0.14817
                            ],
                            [
                                98.49352,
                                -0.30279
                            ],
                            [
                                98.5443,
                                -0.2659
                            ],
                            [
                                98.4852,
                                -0.21277
                            ],
                            [
                                98.47192,
                                -0.10826
                            ],
                            [
                                98.40099,
                                -0.00614
                            ],
                            [
                                98.31099,
                                -0.01504
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                134.95751,
                                -1.00118
                            ],
                            [
                                134.89377,
                                -0.93114
                            ],
                            [
                                134.81629,
                                -0.95285
                            ],
                            [
                                134.80221,
                                -1.02722
                            ],
                            [
                                134.8459,
                                -1.10569
                            ],
                            [
                                134.90063,
                                -1.14085
                            ],
                            [
                                134.95751,
                                -1.12609
                            ],
                            [
                                134.95751,
                                -1.00118
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                117.47777,
                                -8.36053
                            ],
                            [
                                117.53418,
                                -8.39302
                            ],
                            [
                                117.57652,
                                -8.3356
                            ],
                            [
                                117.61668,
                                -8.23686
                            ],
                            [
                                117.68162,
                                -8.19322
                            ],
                            [
                                117.6681,
                                -8.15461
                            ],
                            [
                                117.55972,
                                -8.14791
                            ],
                            [
                                117.48306,
                                -8.19629
                            ],
                            [
                                117.5098,
                                -8.28282
                            ],
                            [
                                117.47777,
                                -8.36053
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                119.38203,
                                -8.58997
                            ],
                            [
                                119.41252,
                                -8.68384
                            ],
                            [
                                119.49029,
                                -8.63716
                            ],
                            [
                                119.50778,
                                -8.57489
                            ],
                            [
                                119.56678,
                                -8.58794
                            ],
                            [
                                119.57347,
                                -8.50401
                            ],
                            [
                                119.47237,
                                -8.48216
                            ],
                            [
                                119.38203,
                                -8.58997
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                98.52689,
                                0.13215
                            ],
                            [
                                98.53879,
                                0.09544
                            ],
                            [
                                98.75015,
                                0.072
                            ],
                            [
                                98.84209,
                                0.1298
                            ],
                            [
                                98.79737,
                                0.17092
                            ],
                            [
                                98.72086,
                                0.15862
                            ],
                            [
                                98.61576,
                                0.17904
                            ],
                            [
                                98.52689,
                                0.13215
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                103.26223,
                                0.52027
                            ],
                            [
                                103.29868,
                                0.53035
                            ],
                            [
                                103.30957,
                                0.60488
                            ],
                            [
                                103.27754,
                                0.66265
                            ],
                            [
                                103.21648,
                                0.7005
                            ],
                            [
                                103.18075,
                                0.67559
                            ],
                            [
                                103.14075,
                                0.57229
                            ],
                            [
                                103.15187,
                                0.52419
                            ],
                            [
                                103.26223,
                                0.52027
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                103.35331,
                                0.78961
                            ],
                            [
                                103.36576,
                                0.7211
                            ],
                            [
                                103.41192,
                                0.64255
                            ],
                            [
                                103.46615,
                                0.63032
                            ],
                            [
                                103.51397,
                                0.75248
                            ],
                            [
                                103.37999,
                                0.88181
                            ],
                            [
                                103.35331,
                                0.78961
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                134.59826,
                                -5.56667
                            ],
                            [
                                134.54963,
                                -5.55886
                            ],
                            [
                                134.52742,
                                -5.57546
                            ],
                            [
                                134.54609,
                                -5.64078
                            ],
                            [
                                134.60927,
                                -5.71051
                            ],
                            [
                                134.7089,
                                -5.73158
                            ],
                            [
                                134.74465,
                                -5.62295
                            ],
                            [
                                134.7081,
                                -5.59755
                            ],
                            [
                                134.63451,
                                -5.58413
                            ],
                            [
                                134.59826,
                                -5.56667
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                134.59826,
                                -5.43356
                            ],
                            [
                                134.49366,
                                -5.4173
                            ],
                            [
                                134.48764,
                                -5.49429
                            ],
                            [
                                134.5322,
                                -5.55707
                            ],
                            [
                                134.60096,
                                -5.55932
                            ],
                            [
                                134.61984,
                                -5.57195
                            ],
                            [
                                134.69852,
                                -5.5115
                            ],
                            [
                                134.62177,
                                -5.41792
                            ],
                            [
                                134.59826,
                                -5.43356
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                123.47242,
                                -1.65321
                            ],
                            [
                                123.48539,
                                -1.71154
                            ],
                            [
                                123.59708,
                                -1.70993
                            ],
                            [
                                123.61862,
                                -1.62518
                            ],
                            [
                                123.55639,
                                -1.59642
                            ],
                            [
                                123.54549,
                                -1.51523
                            ],
                            [
                                123.50399,
                                -1.49965
                            ],
                            [
                                123.47361,
                                -1.56574
                            ],
                            [
                                123.47242,
                                -1.65321
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                117.89587,
                                4.16674
                            ],
                            [
                                117.67835,
                                4.16687
                            ],
                            [
                                117.76437,
                                4.09019
                            ],
                            [
                                117.85852,
                                4.03412
                            ],
                            [
                                117.90219,
                                4.04282
                            ],
                            [
                                117.92113,
                                4.12547
                            ],
                            [
                                117.89587,
                                4.16674
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                117.51581,
                                3.38638
                            ],
                            [
                                117.54202,
                                3.32722
                            ],
                            [
                                117.64746,
                                3.24764
                            ],
                            [
                                117.66737,
                                3.40977
                            ],
                            [
                                117.61754,
                                3.44001
                            ],
                            [
                                117.55027,
                                3.44013
                            ],
                            [
                                117.51581,
                                3.38638
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                138.62776,
                                -6.64596
                            ],
                            [
                                138.65695,
                                -6.71755
                            ],
                            [
                                138.80499,
                                -6.77252
                            ],
                            [
                                138.78456,
                                -6.68418
                            ],
                            [
                                138.66734,
                                -6.62655
                            ],
                            [
                                138.62776,
                                -6.64596
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                121.64206,
                                -0.53496
                            ],
                            [
                                121.69028,
                                -0.5561
                            ],
                            [
                                121.72733,
                                -0.49219
                            ],
                            [
                                121.8165,
                                -0.51397
                            ],
                            [
                                121.90898,
                                -0.50949
                            ],
                            [
                                121.9061,
                                -0.44122
                            ],
                            [
                                121.83923,
                                -0.40901
                            ],
                            [
                                121.74969,
                                -0.42551
                            ],
                            [
                                121.69007,
                                -0.46905
                            ],
                            [
                                121.64206,
                                -0.53496
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                127.14889,
                                -0.76601
                            ],
                            [
                                127.23012,
                                -0.7809
                            ],
                            [
                                127.28011,
                                -0.81304
                            ],
                            [
                                127.29463,
                                -0.69593
                            ],
                            [
                                127.24483,
                                -0.65777
                            ],
                            [
                                127.16027,
                                -0.73016
                            ],
                            [
                                127.14889,
                                -0.76601
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                117.58788,
                                4.07216
                            ],
                            [
                                117.61096,
                                4.00565
                            ],
                            [
                                117.68641,
                                3.96776
                            ],
                            [
                                117.71962,
                                3.98586
                            ],
                            [
                                117.74554,
                                4.0666
                            ],
                            [
                                117.66698,
                                4.1426
                            ],
                            [
                                117.61965,
                                4.13041
                            ],
                            [
                                117.58788,
                                4.07216
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                123.30169,
                                -10.27345
                            ],
                            [
                                123.30593,
                                -10.3123
                            ],
                            [
                                123.41942,
                                -10.28938
                            ],
                            [
                                123.41226,
                                -10.24179
                            ],
                            [
                                123.46889,
                                -10.16107
                            ],
                            [
                                123.39726,
                                -10.13411
                            ],
                            [
                                123.34954,
                                -10.22596
                            ],
                            [
                                123.30169,
                                -10.27345
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                122.86013,
                                -8.5821
                            ],
                            [
                                122.90452,
                                -8.61508
                            ],
                            [
                                122.97275,
                                -8.51483
                            ],
                            [
                                123.13907,
                                -8.46647
                            ],
                            [
                                123.13632,
                                -8.42909
                            ],
                            [
                                123.01348,
                                -8.45334
                            ],
                            [
                                122.96466,
                                -8.44404
                            ],
                            [
                                122.93478,
                                -8.49904
                            ],
                            [
                                122.87188,
                                -8.5288
                            ],
                            [
                                122.86013,
                                -8.5821
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                131.7171,
                                -7.14878
                            ],
                            [
                                131.81969,
                                -7.15575
                            ],
                            [
                                131.89803,
                                -7.18169
                            ],
                            [
                                131.95532,
                                -7.24866
                            ],
                            [
                                131.98668,
                                -7.21405
                            ],
                            [
                                131.93177,
                                -7.10849
                            ],
                            [
                                131.74745,
                                -7.11185
                            ],
                            [
                                131.7171,
                                -7.14878
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                116.31148,
                                -3.55232
                            ],
                            [
                                116.36039,
                                -3.6503
                            ],
                            [
                                116.39532,
                                -3.6259
                            ],
                            [
                                116.4305,
                                -3.418
                            ],
                            [
                                116.35916,
                                -3.42883
                            ],
                            [
                                116.31148,
                                -3.55232
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                97.11334,
                                2.21693
                            ],
                            [
                                97.20358,
                                2.18316
                            ],
                            [
                                97.30877,
                                2.06338
                            ],
                            [
                                97.36009,
                                2.0973
                            ],
                            [
                                97.29887,
                                2.22856
                            ],
                            [
                                97.16855,
                                2.23621
                            ],
                            [
                                97.11334,
                                2.21693
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                106.7001,
                                -2.96735
                            ],
                            [
                                106.82083,
                                -3.03368
                            ],
                            [
                                106.87439,
                                -3.03217
                            ],
                            [
                                106.90411,
                                -2.94031
                            ],
                            [
                                106.81265,
                                -2.89316
                            ],
                            [
                                106.7001,
                                -2.96735
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                105.68162,
                                3.00934
                            ],
                            [
                                105.71502,
                                2.96248
                            ],
                            [
                                105.69669,
                                2.8785
                            ],
                            [
                                105.752,
                                2.82463
                            ],
                            [
                                105.77277,
                                2.89938
                            ],
                            [
                                105.82946,
                                2.92518
                            ],
                            [
                                105.7843,
                                2.97512
                            ],
                            [
                                105.68162,
                                3.00934
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                115.55858,
                                -8.67561
                            ],
                            [
                                115.49752,
                                -8.67562
                            ],
                            [
                                115.44547,
                                -8.72545
                            ],
                            [
                                115.53226,
                                -8.80121
                            ],
                            [
                                115.59683,
                                -8.81428
                            ],
                            [
                                115.62798,
                                -8.74819
                            ],
                            [
                                115.55858,
                                -8.67561
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                119.6115,
                                -8.75086
                            ],
                            [
                                119.6961,
                                -8.80722
                            ],
                            [
                                119.73175,
                                -8.76726
                            ],
                            [
                                119.69563,
                                -8.71814
                            ],
                            [
                                119.71754,
                                -8.68069
                            ],
                            [
                                119.79997,
                                -8.65513
                            ],
                            [
                                119.79471,
                                -8.61615
                            ],
                            [
                                119.64704,
                                -8.66192
                            ],
                            [
                                119.6115,
                                -8.75086
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                112.56224,
                                -5.80566
                            ],
                            [
                                112.58672,
                                -5.85519
                            ],
                            [
                                112.6749,
                                -5.85538
                            ],
                            [
                                112.73209,
                                -5.79151
                            ],
                            [
                                112.70004,
                                -5.73566
                            ],
                            [
                                112.62773,
                                -5.73328
                            ],
                            [
                                112.56224,
                                -5.80566
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                128.52026,
                                -7.14286
                            ],
                            [
                                128.61483,
                                -7.21942
                            ],
                            [
                                128.65338,
                                -7.20909
                            ],
                            [
                                128.69717,
                                -7.12047
                            ],
                            [
                                128.59309,
                                -7.06929
                            ],
                            [
                                128.52026,
                                -7.14286
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                130.44681,
                                -0.46546
                            ],
                            [
                                130.46208,
                                -0.53546
                            ],
                            [
                                130.54107,
                                -0.52262
                            ],
                            [
                                130.5933,
                                -0.48051
                            ],
                            [
                                130.6165,
                                -0.54112
                            ],
                            [
                                130.69063,
                                -0.46118
                            ],
                            [
                                130.61977,
                                -0.41631
                            ],
                            [
                                130.52192,
                                -0.48103
                            ],
                            [
                                130.44681,
                                -0.46546
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                128.56442,
                                -3.57487
                            ],
                            [
                                128.49581,
                                -3.51572
                            ],
                            [
                                128.40937,
                                -3.53186
                            ],
                            [
                                128.40213,
                                -3.64213
                            ],
                            [
                                128.52847,
                                -3.62165
                            ],
                            [
                                128.56442,
                                -3.57487
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                121.85355,
                                -0.37754
                            ],
                            [
                                121.86881,
                                -0.41108
                            ],
                            [
                                122.03886,
                                -0.41786
                            ],
                            [
                                121.95788,
                                -0.32045
                            ],
                            [
                                121.87328,
                                -0.34286
                            ],
                            [
                                121.85355,
                                -0.37754
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                108.78815,
                                -1.58416
                            ],
                            [
                                108.82466,
                                -1.66592
                            ],
                            [
                                108.86688,
                                -1.67291
                            ],
                            [
                                108.94717,
                                -1.63919
                            ],
                            [
                                108.96862,
                                -1.60337
                            ],
                            [
                                108.88451,
                                -1.54256
                            ],
                            [
                                108.78815,
                                -1.58416
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                127.32628,
                                -7.62767
                            ],
                            [
                                127.36796,
                                -7.65543
                            ],
                            [
                                127.41437,
                                -7.60373
                            ],
                            [
                                127.48083,
                                -7.5821
                            ],
                            [
                                127.48628,
                                -7.524
                            ],
                            [
                                127.3632,
                                -7.5041
                            ],
                            [
                                127.36833,
                                -7.57138
                            ],
                            [
                                127.32628,
                                -7.62767
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                127.45457,
                                -1.24354
                            ],
                            [
                                127.48765,
                                -1.27295
                            ],
                            [
                                127.55059,
                                -1.24819
                            ],
                            [
                                127.66417,
                                -1.29119
                            ],
                            [
                                127.68665,
                                -1.22693
                            ],
                            [
                                127.57808,
                                -1.2034
                            ],
                            [
                                127.5425,
                                -1.17438
                            ],
                            [
                                127.45457,
                                -1.24354
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                128.72858,
                                -3.57487
                            ],
                            [
                                128.56289,
                                -3.49797
                            ],
                            [
                                128.63576,
                                -3.6312
                            ],
                            [
                                128.72858,
                                -3.57487
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                120.60637,
                                -7.07664
                            ],
                            [
                                120.62302,
                                -7.12196
                            ],
                            [
                                120.69911,
                                -7.13922
                            ],
                            [
                                120.74628,
                                -7.0851
                            ],
                            [
                                120.67294,
                                -7.04804
                            ],
                            [
                                120.60637,
                                -7.07664
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                134.62226,
                                -6.74497
                            ],
                            [
                                134.67966,
                                -6.76529
                            ],
                            [
                                134.7277,
                                -6.69345
                            ],
                            [
                                134.74918,
                                -6.61391
                            ],
                            [
                                134.69593,
                                -6.57454
                            ],
                            [
                                134.62226,
                                -6.74497
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                119.00812,
                                -8.20094
                            ],
                            [
                                119.01993,
                                -8.24439
                            ],
                            [
                                119.09237,
                                -8.25583
                            ],
                            [
                                119.13033,
                                -8.19499
                            ],
                            [
                                119.09488,
                                -8.13311
                            ],
                            [
                                119.02257,
                                -8.15475
                            ],
                            [
                                119.00812,
                                -8.20094
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                133.53994,
                                -4.21724
                            ],
                            [
                                133.44005,
                                -4.18337
                            ],
                            [
                                133.35585,
                                -4.10643
                            ],
                            [
                                133.33592,
                                -4.17053
                            ],
                            [
                                133.4465,
                                -4.24596
                            ],
                            [
                                133.53994,
                                -4.21724
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                104.08782,
                                0.93574
                            ],
                            [
                                104.10111,
                                0.8668
                            ],
                            [
                                104.1503,
                                0.85264
                            ],
                            [
                                104.17433,
                                0.78715
                            ],
                            [
                                104.26482,
                                0.83679
                            ],
                            [
                                104.17344,
                                0.89202
                            ],
                            [
                                104.12724,
                                0.95307
                            ],
                            [
                                104.08782,
                                0.93574
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                129.52762,
                                -0.13335
                            ],
                            [
                                129.46635,
                                -0.09837
                            ],
                            [
                                129.39764,
                                -0.02903
                            ],
                            [
                                129.37951,
                                -0.08829
                            ],
                            [
                                129.45026,
                                -0.10981
                            ],
                            [
                                129.51568,
                                -0.21563
                            ],
                            [
                                129.56676,
                                -0.21213
                            ],
                            [
                                129.52762,
                                -0.13335
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                123.51784,
                                -5.26929
                            ],
                            [
                                123.57413,
                                -5.37212
                            ],
                            [
                                123.63269,
                                -5.3604
                            ],
                            [
                                123.63799,
                                -5.2884
                            ],
                            [
                                123.57826,
                                -5.2463
                            ],
                            [
                                123.51784,
                                -5.26929
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                129.7313,
                                -1.21049
                            ],
                            [
                                129.79067,
                                -1.20964
                            ],
                            [
                                129.84336,
                                -1.24931
                            ],
                            [
                                129.9661,
                                -1.17737
                            ],
                            [
                                129.85895,
                                -1.15158
                            ],
                            [
                                129.75576,
                                -1.17531
                            ],
                            [
                                129.7313,
                                -1.21049
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                130.97568,
                                -7.48345
                            ],
                            [
                                131.00964,
                                -7.49495
                            ],
                            [
                                131.13131,
                                -7.46296
                            ],
                            [
                                131.14791,
                                -7.40774
                            ],
                            [
                                131.01104,
                                -7.42217
                            ],
                            [
                                130.97568,
                                -7.48345
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                127.6376,
                                -3.22232
                            ],
                            [
                                127.68089,
                                -3.25402
                            ],
                            [
                                127.79093,
                                -3.24585
                            ],
                            [
                                127.78808,
                                -3.17453
                            ],
                            [
                                127.72033,
                                -3.15459
                            ],
                            [
                                127.6376,
                                -3.22232
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                108.7759,
                                2.88178
                            ],
                            [
                                108.81574,
                                2.84793
                            ],
                            [
                                108.88103,
                                2.88326
                            ],
                            [
                                108.89016,
                                2.99155
                            ],
                            [
                                108.83981,
                                2.99703
                            ],
                            [
                                108.82795,
                                2.94331
                            ],
                            [
                                108.7759,
                                2.88178
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                103.32005,
                                1.07389
                            ],
                            [
                                103.3435,
                                1.00932
                            ],
                            [
                                103.44846,
                                0.97458
                            ],
                            [
                                103.43201,
                                1.03718
                            ],
                            [
                                103.36237,
                                1.12329
                            ],
                            [
                                103.32005,
                                1.07389
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                114.27355,
                                -7.09593
                            ],
                            [
                                114.29947,
                                -7.15461
                            ],
                            [
                                114.40288,
                                -7.17707
                            ],
                            [
                                114.34311,
                                -7.06077
                            ],
                            [
                                114.27355,
                                -7.09593
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                133.78399,
                                -2.2413
                            ],
                            [
                                133.84683,
                                -2.29415
                            ],
                            [
                                133.94736,
                                -2.24365
                            ],
                            [
                                133.9473,
                                -2.17643
                            ],
                            [
                                133.78399,
                                -2.2413
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                127.99325,
                                -2.93091
                            ],
                            [
                                127.92287,
                                -2.92222
                            ],
                            [
                                127.8765,
                                -2.95955
                            ],
                            [
                                127.85925,
                                -3.03802
                            ],
                            [
                                127.95548,
                                -2.9997
                            ],
                            [
                                127.99325,
                                -2.93091
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                131.58301,
                                -1.48909
                            ],
                            [
                                131.63758,
                                -1.53945
                            ],
                            [
                                131.72335,
                                -1.51434
                            ],
                            [
                                131.71487,
                                -1.43297
                            ],
                            [
                                131.59435,
                                -1.46397
                            ],
                            [
                                131.58301,
                                -1.48909
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                95.34499,
                                5.82347
                            ],
                            [
                                95.33307,
                                5.89255
                            ],
                            [
                                95.25486,
                                5.84387
                            ],
                            [
                                95.26949,
                                5.79509
                            ],
                            [
                                95.32316,
                                5.76854
                            ],
                            [
                                95.34499,
                                5.82347
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                134.78877,
                                -6.38299
                            ],
                            [
                                134.80097,
                                -6.45426
                            ],
                            [
                                134.83522,
                                -6.46985
                            ],
                            [
                                134.89394,
                                -6.32743
                            ],
                            [
                                134.84212,
                                -6.28413
                            ],
                            [
                                134.78877,
                                -6.38299
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                117.75943,
                                3.54092
                            ],
                            [
                                117.78429,
                                3.49946
                            ],
                            [
                                117.8723,
                                3.44612
                            ],
                            [
                                117.86517,
                                3.52873
                            ],
                            [
                                117.81037,
                                3.58958
                            ],
                            [
                                117.75943,
                                3.54092
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                105.14506,
                                -6.59217
                            ],
                            [
                                105.21037,
                                -6.63774
                            ],
                            [
                                105.25452,
                                -6.60132
                            ],
                            [
                                105.24524,
                                -6.54612
                            ],
                            [
                                105.18023,
                                -6.53915
                            ],
                            [
                                105.14506,
                                -6.59217
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                127.39418,
                                0.62215
                            ],
                            [
                                127.44,
                                0.64902
                            ],
                            [
                                127.44047,
                                0.74324
                            ],
                            [
                                127.37801,
                                0.74329
                            ],
                            [
                                127.35824,
                                0.65411
                            ],
                            [
                                127.39418,
                                0.62215
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                128.07767,
                                -8.25937
                            ],
                            [
                                128.1645,
                                -8.2836
                            ],
                            [
                                128.23264,
                                -8.2725
                            ],
                            [
                                128.20143,
                                -8.20309
                            ],
                            [
                                128.0959,
                                -8.21947
                            ],
                            [
                                128.07767,
                                -8.25937
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                107.34619,
                                -2.89075
                            ],
                            [
                                107.41163,
                                -2.94784
                            ],
                            [
                                107.47723,
                                -2.91334
                            ],
                            [
                                107.47832,
                                -2.83441
                            ],
                            [
                                107.43116,
                                -2.83664
                            ],
                            [
                                107.34619,
                                -2.89075
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                108.78314,
                                -7.70096
                            ],
                            [
                                108.86297,
                                -7.73823
                            ],
                            [
                                108.98097,
                                -7.77055
                            ],
                            [
                                108.96294,
                                -7.71611
                            ],
                            [
                                108.87862,
                                -7.71161
                            ],
                            [
                                108.82234,
                                -7.68187
                            ],
                            [
                                108.78314,
                                -7.70096
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                125.35281,
                                2.7379
                            ],
                            [
                                125.44938,
                                2.76459
                            ],
                            [
                                125.41277,
                                2.8166
                            ],
                            [
                                125.36586,
                                2.79611
                            ],
                            [
                                125.35281,
                                2.7379
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                128.81966,
                                -8.19936
                            ],
                            [
                                128.91475,
                                -8.25213
                            ],
                            [
                                128.99616,
                                -8.2678
                            ],
                            [
                                129.01222,
                                -8.21471
                            ],
                            [
                                128.94871,
                                -8.18613
                            ],
                            [
                                128.81966,
                                -8.19936
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                127.48439,
                                -3.29699
                            ],
                            [
                                127.50318,
                                -3.32481
                            ],
                            [
                                127.64238,
                                -3.36377
                            ],
                            [
                                127.57954,
                                -3.27045
                            ],
                            [
                                127.52234,
                                -3.26498
                            ],
                            [
                                127.48439,
                                -3.29699
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                134.33069,
                                -2.09285
                            ],
                            [
                                134.38606,
                                -2.14389
                            ],
                            [
                                134.42656,
                                -2.02896
                            ],
                            [
                                134.36467,
                                -2.01767
                            ],
                            [
                                134.33069,
                                -2.09285
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                123.05592,
                                -1.90303
                            ],
                            [
                                123.14269,
                                -1.85399
                            ],
                            [
                                123.12931,
                                -1.77668
                            ],
                            [
                                123.09052,
                                -1.76707
                            ],
                            [
                                123.05592,
                                -1.90303
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                138.281,
                                -8.41848
                            ],
                            [
                                138.30055,
                                -8.44004
                            ],
                            [
                                138.41737,
                                -8.43216
                            ],
                            [
                                138.43443,
                                -8.38548
                            ],
                            [
                                138.281,
                                -8.41848
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                127.28409,
                                0.80554
                            ],
                            [
                                127.32726,
                                0.74858
                            ],
                            [
                                127.38006,
                                0.77442
                            ],
                            [
                                127.37929,
                                0.83234
                            ],
                            [
                                127.32092,
                                0.86627
                            ],
                            [
                                127.28409,
                                0.80554
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                106.1947,
                                3.23213
                            ],
                            [
                                106.21096,
                                3.12226
                            ],
                            [
                                106.28231,
                                3.11911
                            ],
                            [
                                106.25705,
                                3.21755
                            ],
                            [
                                106.1947,
                                3.23213
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                123.96073,
                                -5.9384
                            ],
                            [
                                124.04187,
                                -5.98167
                            ],
                            [
                                124.0366,
                                -5.90531
                            ],
                            [
                                123.98985,
                                -5.87824
                            ],
                            [
                                123.96073,
                                -5.9384
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                134.6325,
                                -6.47871
                            ],
                            [
                                134.67379,
                                -6.55603
                            ],
                            [
                                134.75235,
                                -6.52035
                            ],
                            [
                                134.68734,
                                -6.44192
                            ],
                            [
                                134.6325,
                                -6.47871
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                134.15247,
                                -1.91546
                            ],
                            [
                                134.21358,
                                -1.90358
                            ],
                            [
                                134.25375,
                                -1.77028
                            ],
                            [
                                134.22354,
                                -1.74907
                            ],
                            [
                                134.17043,
                                -1.83153
                            ],
                            [
                                134.15247,
                                -1.91546
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                103.96955,
                                0.95449
                            ],
                            [
                                103.88202,
                                1.02505
                            ],
                            [
                                103.84631,
                                0.96597
                            ],
                            [
                                103.9452,
                                0.90986
                            ],
                            [
                                103.96955,
                                0.95449
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                127.5944,
                                -8.21377
                            ],
                            [
                                127.63002,
                                -8.24082
                            ],
                            [
                                127.74741,
                                -8.20971
                            ],
                            [
                                127.6936,
                                -8.15479
                            ],
                            [
                                127.5944,
                                -8.21377
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                130.96563,
                                -7.72673
                            ],
                            [
                                131.03928,
                                -7.7159
                            ],
                            [
                                131.11422,
                                -7.67115
                            ],
                            [
                                131.07127,
                                -7.6397
                            ],
                            [
                                130.96704,
                                -7.68081
                            ],
                            [
                                130.96563,
                                -7.72673
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                132.73389,
                                -5.61625
                            ],
                            [
                                132.76146,
                                -5.68252
                            ],
                            [
                                132.8091,
                                -5.66906
                            ],
                            [
                                132.76454,
                                -5.54404
                            ],
                            [
                                132.73389,
                                -5.61625
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                138.65907,
                                -6.85594
                            ],
                            [
                                138.71458,
                                -6.88853
                            ],
                            [
                                138.78277,
                                -6.8306
                            ],
                            [
                                138.74383,
                                -6.78611
                            ],
                            [
                                138.65907,
                                -6.85594
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                123.03709,
                                -3.59244
                            ],
                            [
                                123.10743,
                                -3.63702
                            ],
                            [
                                123.17879,
                                -3.59524
                            ],
                            [
                                123.16112,
                                -3.55075
                            ],
                            [
                                123.03709,
                                -3.59244
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                126.75324,
                                3.83315
                            ],
                            [
                                126.79081,
                                3.75262
                            ],
                            [
                                126.85961,
                                3.7635
                            ],
                            [
                                126.81004,
                                3.83639
                            ],
                            [
                                126.75324,
                                3.83315
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                138.58649,
                                -6.75983
                            ],
                            [
                                138.65652,
                                -6.83691
                            ],
                            [
                                138.7147,
                                -6.76452
                            ],
                            [
                                138.58649,
                                -6.75983
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                127.39418,
                                0.28635
                            ],
                            [
                                127.42981,
                                0.33454
                            ],
                            [
                                127.3695,
                                0.38038
                            ],
                            [
                                127.33104,
                                0.33038
                            ],
                            [
                                127.39418,
                                0.28635
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                135.10075,
                                -1.50514
                            ],
                            [
                                135.25121,
                                -1.52764
                            ],
                            [
                                135.21931,
                                -1.48239
                            ],
                            [
                                135.14827,
                                -1.47851
                            ],
                            [
                                135.10075,
                                -1.50514
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                104.18016,
                                0.77823
                            ],
                            [
                                104.20346,
                                0.72549
                            ],
                            [
                                104.28731,
                                0.70967
                            ],
                            [
                                104.26397,
                                0.79956
                            ],
                            [
                                104.18016,
                                0.77823
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                133.53994,
                                -2.42864
                            ],
                            [
                                133.53353,
                                -2.48325
                            ],
                            [
                                133.60153,
                                -2.52326
                            ],
                            [
                                133.61626,
                                -2.46263
                            ],
                            [
                                133.53994,
                                -2.42864
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                106.22903,
                                3.26127
                            ],
                            [
                                106.29221,
                                3.26348
                            ],
                            [
                                106.29386,
                                3.35203
                            ],
                            [
                                106.24435,
                                3.34234
                            ],
                            [
                                106.22903,
                                3.26127
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                123.7699,
                                -1.93708
                            ],
                            [
                                123.81693,
                                -2.01474
                            ],
                            [
                                123.85748,
                                -1.97834
                            ],
                            [
                                123.80157,
                                -1.89191
                            ],
                            [
                                123.7699,
                                -1.93708
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                113.27037,
                                -8.48033
                            ],
                            [
                                113.31879,
                                -8.50351
                            ],
                            [
                                113.41702,
                                -8.48483
                            ],
                            [
                                113.40236,
                                -8.45145
                            ],
                            [
                                113.29684,
                                -8.44368
                            ],
                            [
                                113.27037,
                                -8.48033
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                130.83552,
                                -7.54782
                            ],
                            [
                                130.93,
                                -7.5621
                            ],
                            [
                                130.97883,
                                -7.52191
                            ],
                            [
                                130.85295,
                                -7.49806
                            ],
                            [
                                130.83552,
                                -7.54782
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                121.74252,
                                -7.39198
                            ],
                            [
                                121.82182,
                                -7.39959
                            ],
                            [
                                121.81759,
                                -7.3348
                            ],
                            [
                                121.76071,
                                -7.34823
                            ],
                            [
                                121.74252,
                                -7.39198
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                127.1435,
                                -8.04055
                            ],
                            [
                                127.15758,
                                -8.10805
                            ],
                            [
                                127.22211,
                                -8.11257
                            ],
                            [
                                127.2172,
                                -8.04652
                            ],
                            [
                                127.1435,
                                -8.04055
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                131.51816,
                                -6.75612
                            ],
                            [
                                131.58214,
                                -6.77185
                            ],
                            [
                                131.62814,
                                -6.6677
                            ],
                            [
                                131.58077,
                                -6.66062
                            ],
                            [
                                131.51816,
                                -6.75612
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                127.14545,
                                -3.85352
                            ],
                            [
                                127.23045,
                                -3.90318
                            ],
                            [
                                127.23566,
                                -3.83737
                            ],
                            [
                                127.14545,
                                -3.85352
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                123.68625,
                                -5.46284
                            ],
                            [
                                123.776,
                                -5.58103
                            ],
                            [
                                123.82172,
                                -5.55873
                            ],
                            [
                                123.75255,
                                -5.48836
                            ],
                            [
                                123.68625,
                                -5.46284
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                104.39164,
                                0.10661
                            ],
                            [
                                104.48041,
                                0.01402
                            ],
                            [
                                104.49192,
                                0.06883
                            ],
                            [
                                104.40765,
                                0.15817
                            ],
                            [
                                104.39164,
                                0.10661
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                127.26993,
                                -1.41212
                            ],
                            [
                                127.31367,
                                -1.45442
                            ],
                            [
                                127.38794,
                                -1.40725
                            ],
                            [
                                127.35822,
                                -1.37463
                            ],
                            [
                                127.26993,
                                -1.41212
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                95.00934,
                                5.725
                            ],
                            [
                                95.07847,
                                5.66504
                            ],
                            [
                                95.12956,
                                5.68272
                            ],
                            [
                                95.05943,
                                5.74848
                            ],
                            [
                                95.00934,
                                5.725
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                129.84255,
                                -0.46179
                            ],
                            [
                                129.8821,
                                -0.50567
                            ],
                            [
                                129.91933,
                                -0.4529
                            ],
                            [
                                129.88454,
                                -0.41235
                            ],
                            [
                                129.84255,
                                -0.46179
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                121.06331,
                                -7.37485
                            ],
                            [
                                121.0972,
                                -7.39622
                            ],
                            [
                                121.15603,
                                -7.36769
                            ],
                            [
                                121.08929,
                                -7.30544
                            ],
                            [
                                121.06331,
                                -7.37485
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                97.07408,
                                2.07363
                            ],
                            [
                                97.11486,
                                2.0358
                            ],
                            [
                                97.1609,
                                2.07477
                            ],
                            [
                                97.09455,
                                2.10886
                            ],
                            [
                                97.07408,
                                2.07363
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                122.53086,
                                -5.6995
                            ],
                            [
                                122.56269,
                                -5.65981
                            ],
                            [
                                122.51261,
                                -5.62432
                            ],
                            [
                                122.47747,
                                -5.67772
                            ],
                            [
                                122.53086,
                                -5.6995
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                110.03027,
                                -2.74399
                            ],
                            [
                                110.10908,
                                -2.74364
                            ],
                            [
                                110.08432,
                                -2.68148
                            ],
                            [
                                110.03027,
                                -2.74399
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                130.08472,
                                -0.00631
                            ],
                            [
                                130.11032,
                                -0.09768
                            ],
                            [
                                130.15029,
                                -0.05378
                            ],
                            [
                                130.08472,
                                -0.00631
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                131.60441,
                                -4.42392
                            ],
                            [
                                131.65002,
                                -4.53524
                            ],
                            [
                                131.67828,
                                -4.51022
                            ],
                            [
                                131.60441,
                                -4.42392
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                126.35589,
                                -1.82983
                            ],
                            [
                                126.45623,
                                -1.84186
                            ],
                            [
                                126.45531,
                                -1.80229
                            ],
                            [
                                126.35589,
                                -1.82983
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "IRN",
                "Country": "Iran",
                "Total_3GHG": 1.13,
                "Total_3GHG_timeseries": [
                    3.9627e-06,
                    7.9347e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0023,
                    0.0024,
                    0.0026,
                    0.0028,
                    0.003,
                    0.0032,
                    0.0035,
                    0.0037,
                    0.004,
                    0.0044,
                    0.0047,
                    0.0051,
                    0.0054,
                    0.0057,
                    0.006,
                    0.0062,
                    0.0063,
                    0.0063,
                    0.0064,
                    0.0066,
                    0.0067,
                    0.0068,
                    0.0068,
                    0.0069,
                    0.007,
                    0.0071,
                    0.0072,
                    0.0073,
                    0.0075,
                    0.0076,
                    0.0077,
                    0.0078,
                    0.008,
                    0.0081,
                    0.0083,
                    0.0085,
                    0.0089,
                    0.0093,
                    0.0096,
                    0.01,
                    0.0104,
                    0.0108,
                    0.0113,
                    0.0117,
                    0.0122,
                    0.0126,
                    0.0131,
                    0.0135,
                    0.0139,
                    0.0143,
                    0.0147,
                    0.0151,
                    0.0156,
                    0.0161,
                    0.0166,
                    0.0171,
                    0.0175,
                    0.018,
                    0.0185
                ],
                "Fossil_3GHG": 1.58,
                "Fossil_3GHG_timeseries": [
                    6.8867e-07,
                    1.3785e-06,
                    2.0694e-06,
                    2.7614e-06,
                    3.4544e-06,
                    4.1485e-06,
                    4.8435e-06,
                    5.5395e-06,
                    6.2363e-06,
                    6.934e-06,
                    7.6323e-06,
                    8.3313e-06,
                    9.031e-06,
                    9.7314e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0015,
                    0.0016,
                    0.0018,
                    0.002,
                    0.0022,
                    0.0024,
                    0.0027,
                    0.003,
                    0.0033,
                    0.0036,
                    0.0039,
                    0.0043,
                    0.0046,
                    0.0048,
                    0.005,
                    0.0051,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0055,
                    0.0055,
                    0.0056,
                    0.0056,
                    0.0057,
                    0.0058,
                    0.0059,
                    0.006,
                    0.0061,
                    0.0062,
                    0.0063,
                    0.0064,
                    0.0065,
                    0.0066,
                    0.0068,
                    0.0072,
                    0.0075,
                    0.0078,
                    0.0082,
                    0.0086,
                    0.009,
                    0.0094,
                    0.0099,
                    0.0103,
                    0.0107,
                    0.0112,
                    0.0116,
                    0.012,
                    0.0124,
                    0.0128,
                    0.0132,
                    0.0137,
                    0.0142,
                    0.0147,
                    0.0152,
                    0.0157,
                    0.0162,
                    0.0167
                ],
                "Land_3GHG": 0.32,
                "Land_3GHG_timeseries": [
                    3.274e-06,
                    6.5562e-06,
                    9.8468e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019
                ],
                "Total_CO2": 0.83,
                "Total_CO2_timeseries": [
                    1.8606e-06,
                    3.7236e-06,
                    5.5892e-06,
                    7.4577e-06,
                    9.3289e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0037,
                    0.0039,
                    0.004,
                    0.0042,
                    0.0044,
                    0.0046,
                    0.0048,
                    0.005,
                    0.0053,
                    0.0055,
                    0.0057,
                    0.006,
                    0.0062,
                    0.0065,
                    0.0068,
                    0.007,
                    0.0073,
                    0.0076,
                    0.0079,
                    0.0082,
                    0.0085,
                    0.0088,
                    0.0091,
                    0.0095
                ],
                "Fossil_CO2": 1.15,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    6.27e-08,
                    1.7655e-07,
                    5.61e-07,
                    1.089e-06,
                    1.721e-06,
                    2.6252e-06,
                    3.8858e-06,
                    5.4384e-06,
                    7.3838e-06,
                    9.8324e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.003,
                    0.0031,
                    0.0033,
                    0.0035,
                    0.0037,
                    0.0038,
                    0.004,
                    0.0043,
                    0.0045,
                    0.0047,
                    0.0049,
                    0.0052,
                    0.0054,
                    0.0057,
                    0.0059,
                    0.0062,
                    0.0065,
                    0.0068,
                    0.0071,
                    0.0074,
                    0.0077,
                    0.008,
                    0.0083,
                    0.0086,
                    0.0089
                ],
                "Land_CO2": 0.14,
                "Land_CO2_timeseries": [
                    1.8606e-06,
                    3.7236e-06,
                    5.5892e-06,
                    7.4577e-06,
                    9.3289e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Total_CH4": 2.03,
                "Total_CH4_timeseries": [
                    1.8645e-06,
                    3.7318e-06,
                    5.6019e-06,
                    7.4746e-06,
                    9.3502e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0018,
                    0.002,
                    0.0022,
                    0.0024,
                    0.0027,
                    0.0029,
                    0.0032,
                    0.0035,
                    0.0037,
                    0.004,
                    0.0042,
                    0.0043,
                    0.0043,
                    0.0043,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0044,
                    0.0044,
                    0.0044,
                    0.0044,
                    0.0044,
                    0.0044,
                    0.0044,
                    0.0044,
                    0.0044,
                    0.0044,
                    0.0044,
                    0.0044,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0047,
                    0.0049,
                    0.005,
                    0.0052,
                    0.0054,
                    0.0056,
                    0.0058,
                    0.006,
                    0.0062,
                    0.0064,
                    0.0066,
                    0.0068,
                    0.0069,
                    0.007,
                    0.0071,
                    0.0072,
                    0.0074,
                    0.0076,
                    0.0078,
                    0.008,
                    0.0081,
                    0.0083,
                    0.0084
                ],
                "Fossil_CH4": 2.89,
                "Fossil_CH4_timeseries": [
                    6.2309e-07,
                    1.2465e-06,
                    1.8702e-06,
                    2.4942e-06,
                    3.1185e-06,
                    3.7431e-06,
                    4.3679e-06,
                    4.9931e-06,
                    5.6185e-06,
                    6.2442e-06,
                    6.87e-06,
                    7.4961e-06,
                    8.1223e-06,
                    8.7487e-06,
                    9.3752e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0009,
                    0.001,
                    0.0012,
                    0.0013,
                    0.0015,
                    0.0017,
                    0.0019,
                    0.0021,
                    0.0024,
                    0.0027,
                    0.0029,
                    0.0032,
                    0.0034,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0035,
                    0.0036,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0042,
                    0.0044,
                    0.0046,
                    0.0048,
                    0.005,
                    0.0052,
                    0.0054,
                    0.0056,
                    0.0057,
                    0.0059,
                    0.006,
                    0.0061,
                    0.0062,
                    0.0064,
                    0.0066,
                    0.0068,
                    0.007,
                    0.0071,
                    0.0073,
                    0.0075
                ],
                "Land_CH4": 0.6,
                "Land_CH4_timeseries": [
                    1.2414e-06,
                    2.4853e-06,
                    3.7317e-06,
                    4.9805e-06,
                    6.2317e-06,
                    7.4854e-06,
                    8.7415e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0009,
                    0.0009
                ],
                "Total_N2O": 0.77,
                "Total_N2O_timeseries": [
                    2.3752e-07,
                    4.793e-07,
                    7.2517e-07,
                    9.7492e-07,
                    1.2282e-06,
                    1.4848e-06,
                    1.7442e-06,
                    2.0059e-06,
                    2.2695e-06,
                    2.5343e-06,
                    2.7999e-06,
                    3.0663e-06,
                    3.3333e-06,
                    3.601e-06,
                    3.8693e-06,
                    4.1382e-06,
                    4.4077e-06,
                    4.678e-06,
                    4.949e-06,
                    5.2209e-06,
                    5.4968e-06,
                    5.7823e-06,
                    6.0816e-06,
                    6.3975e-06,
                    6.7317e-06,
                    7.0847e-06,
                    7.4556e-06,
                    7.8422e-06,
                    8.2412e-06,
                    8.6478e-06,
                    9.059e-06,
                    9.4742e-06,
                    9.8927e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006
                ],
                "Fossil_N2O": 1.03,
                "Fossil_N2O_timeseries": [
                    6.5584e-08,
                    1.3199e-07,
                    1.9919e-07,
                    2.6718e-07,
                    3.3593e-07,
                    4.0541e-07,
                    4.7557e-07,
                    5.4639e-07,
                    6.1781e-07,
                    6.8978e-07,
                    7.6226e-07,
                    8.3525e-07,
                    9.0875e-07,
                    9.8273e-07,
                    1.0572e-06,
                    1.1322e-06,
                    1.2077e-06,
                    1.2837e-06,
                    1.3601e-06,
                    1.4371e-06,
                    1.515e-06,
                    1.594e-06,
                    1.6748e-06,
                    1.7575e-06,
                    1.8422e-06,
                    1.9291e-06,
                    2.0179e-06,
                    2.1086e-06,
                    2.2009e-06,
                    2.2943e-06,
                    2.3885e-06,
                    2.4835e-06,
                    2.5792e-06,
                    2.6757e-06,
                    2.7728e-06,
                    2.8706e-06,
                    2.9691e-06,
                    3.0682e-06,
                    3.1681e-06,
                    3.2688e-06,
                    3.3704e-06,
                    3.4727e-06,
                    3.5759e-06,
                    3.6799e-06,
                    3.7847e-06,
                    3.8904e-06,
                    3.997e-06,
                    4.1045e-06,
                    4.213e-06,
                    4.3224e-06,
                    4.433e-06,
                    4.5446e-06,
                    4.6576e-06,
                    4.7718e-06,
                    4.8874e-06,
                    5.0043e-06,
                    5.1227e-06,
                    5.2424e-06,
                    5.3635e-06,
                    5.486e-06,
                    5.6097e-06,
                    5.7347e-06,
                    5.8609e-06,
                    5.9885e-06,
                    6.1174e-06,
                    6.2475e-06,
                    6.379e-06,
                    6.5117e-06,
                    6.6457e-06,
                    6.781e-06,
                    6.9175e-06,
                    7.0554e-06,
                    7.1945e-06,
                    7.335e-06,
                    7.4767e-06,
                    7.6198e-06,
                    7.7641e-06,
                    7.9097e-06,
                    8.0565e-06,
                    8.2046e-06,
                    8.3556e-06,
                    8.5124e-06,
                    8.6775e-06,
                    8.8529e-06,
                    9.04e-06,
                    9.2397e-06,
                    9.4524e-06,
                    9.6779e-06,
                    9.9157e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_N2O": 0.68,
                "Land_N2O_timeseries": [
                    1.7194e-07,
                    3.4731e-07,
                    5.2598e-07,
                    7.0773e-07,
                    8.9231e-07,
                    1.0794e-06,
                    1.2686e-06,
                    1.4595e-06,
                    1.6517e-06,
                    1.8445e-06,
                    2.0376e-06,
                    2.231e-06,
                    2.4246e-06,
                    2.6183e-06,
                    2.8121e-06,
                    3.006e-06,
                    3.2001e-06,
                    3.3943e-06,
                    3.5888e-06,
                    3.7837e-06,
                    3.9819e-06,
                    4.1883e-06,
                    4.4068e-06,
                    4.64e-06,
                    4.8895e-06,
                    5.1556e-06,
                    5.4376e-06,
                    5.7335e-06,
                    6.0403e-06,
                    6.3535e-06,
                    6.6706e-06,
                    6.9907e-06,
                    7.3134e-06,
                    7.6384e-06,
                    7.9655e-06,
                    8.2944e-06,
                    8.6253e-06,
                    8.9582e-06,
                    9.2933e-06,
                    9.6443e-06,
                    9.9958e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                48.48442,
                                29.97912
                            ],
                            [
                                48.65985,
                                29.95495
                            ],
                            [
                                48.72032,
                                30.03718
                            ],
                            [
                                48.87491,
                                30.0123
                            ],
                            [
                                48.91633,
                                30.0246
                            ],
                            [
                                48.94713,
                                30.18077
                            ],
                            [
                                48.9268,
                                30.2404
                            ],
                            [
                                48.86623,
                                30.30177
                            ],
                            [
                                48.87456,
                                30.35405
                            ],
                            [
                                48.92665,
                                30.40902
                            ],
                            [
                                49.01414,
                                30.40646
                            ],
                            [
                                48.99745,
                                30.50546
                            ],
                            [
                                49.11183,
                                30.51212
                            ],
                            [
                                49.24304,
                                30.46863
                            ],
                            [
                                49.26579,
                                30.42813
                            ],
                            [
                                49.21504,
                                30.34652
                            ],
                            [
                                49.16147,
                                30.37104
                            ],
                            [
                                49.09723,
                                30.33808
                            ],
                            [
                                49.04257,
                                30.38629
                            ],
                            [
                                49.00604,
                                30.33828
                            ],
                            [
                                49.02227,
                                30.29448
                            ],
                            [
                                49.18638,
                                30.21302
                            ],
                            [
                                49.23695,
                                30.21754
                            ],
                            [
                                49.25612,
                                30.1377
                            ],
                            [
                                49.45417,
                                30.15975
                            ],
                            [
                                49.50826,
                                30.12772
                            ],
                            [
                                49.51044,
                                30.05209
                            ],
                            [
                                49.59784,
                                30.01219
                            ],
                            [
                                49.87683,
                                30.17942
                            ],
                            [
                                49.97194,
                                30.21312
                            ],
                            [
                                50.09617,
                                30.1745
                            ],
                            [
                                50.16168,
                                30.03725
                            ],
                            [
                                50.15403,
                                29.93156
                            ],
                            [
                                50.25758,
                                29.83303
                            ],
                            [
                                50.32776,
                                29.73389
                            ],
                            [
                                50.48149,
                                29.60767
                            ],
                            [
                                50.51924,
                                29.55173
                            ],
                            [
                                50.64562,
                                29.44316
                            ],
                            [
                                50.67019,
                                29.30321
                            ],
                            [
                                50.65557,
                                29.16189
                            ],
                            [
                                50.69435,
                                29.11329
                            ],
                            [
                                50.82826,
                                29.13039
                            ],
                            [
                                50.92289,
                                29.05939
                            ],
                            [
                                50.93388,
                                28.98809
                            ],
                            [
                                50.89239,
                                28.93396
                            ],
                            [
                                50.81976,
                                28.91724
                            ],
                            [
                                50.88222,
                                28.83238
                            ],
                            [
                                51.02783,
                                28.81571
                            ],
                            [
                                51.0749,
                                28.69183
                            ],
                            [
                                51.10461,
                                28.48647
                            ],
                            [
                                51.17916,
                                28.35521
                            ],
                            [
                                51.28794,
                                28.22719
                            ],
                            [
                                51.2797,
                                28.10229
                            ],
                            [
                                51.33638,
                                28.07484
                            ],
                            [
                                51.4087,
                                27.92904
                            ],
                            [
                                51.44812,
                                27.94656
                            ],
                            [
                                51.50713,
                                27.88628
                            ],
                            [
                                51.60049,
                                27.84813
                            ],
                            [
                                51.70549,
                                27.82823
                            ],
                            [
                                51.80067,
                                27.84211
                            ],
                            [
                                52.04539,
                                27.83756
                            ],
                            [
                                52.21046,
                                27.70007
                            ],
                            [
                                52.36634,
                                27.6498
                            ],
                            [
                                52.43413,
                                27.64232
                            ],
                            [
                                52.50933,
                                27.59566
                            ],
                            [
                                52.66956,
                                27.39617
                            ],
                            [
                                52.59034,
                                27.37272
                            ],
                            [
                                52.83608,
                                27.20027
                            ],
                            [
                                52.95861,
                                27.13918
                            ],
                            [
                                53.11406,
                                27.09004
                            ],
                            [
                                53.36236,
                                26.996
                            ],
                            [
                                53.45836,
                                26.97556
                            ],
                            [
                                53.49079,
                                26.84811
                            ],
                            [
                                53.58918,
                                26.78223
                            ],
                            [
                                53.68198,
                                26.7412
                            ],
                            [
                                53.83051,
                                26.71352
                            ],
                            [
                                53.92622,
                                26.72504
                            ],
                            [
                                54.00257,
                                26.75811
                            ],
                            [
                                54.18303,
                                26.70856
                            ],
                            [
                                54.28068,
                                26.72986
                            ],
                            [
                                54.37956,
                                26.61019
                            ],
                            [
                                54.45047,
                                26.58892
                            ],
                            [
                                54.51364,
                                26.60227
                            ],
                            [
                                54.57003,
                                26.57444
                            ],
                            [
                                54.59884,
                                26.51975
                            ],
                            [
                                54.78279,
                                26.49989
                            ],
                            [
                                54.84357,
                                26.52269
                            ],
                            [
                                54.96437,
                                26.61906
                            ],
                            [
                                55.05508,
                                26.64972
                            ],
                            [
                                55.09752,
                                26.69944
                            ],
                            [
                                55.20319,
                                26.73367
                            ],
                            [
                                55.25744,
                                26.78663
                            ],
                            [
                                55.45093,
                                26.75622
                            ],
                            [
                                55.55141,
                                26.81265
                            ],
                            [
                                55.57967,
                                26.93011
                            ],
                            [
                                55.64019,
                                26.98219
                            ],
                            [
                                55.7383,
                                26.9765
                            ],
                            [
                                55.93574,
                                27.02626
                            ],
                            [
                                55.96263,
                                27.06588
                            ],
                            [
                                56.06525,
                                27.10119
                            ],
                            [
                                56.11919,
                                27.14961
                            ],
                            [
                                56.22176,
                                27.15917
                            ],
                            [
                                56.35699,
                                27.19356
                            ],
                            [
                                56.44896,
                                27.16765
                            ],
                            [
                                56.65188,
                                27.16905
                            ],
                            [
                                56.78036,
                                27.13602
                            ],
                            [
                                56.83675,
                                27.09272
                            ],
                            [
                                56.86244,
                                27.03014
                            ],
                            [
                                56.92317,
                                27.0119
                            ],
                            [
                                56.93755,
                                26.91287
                            ],
                            [
                                57.00445,
                                26.8319
                            ],
                            [
                                57.06301,
                                26.67174
                            ],
                            [
                                57.07942,
                                26.53673
                            ],
                            [
                                57.05402,
                                26.46764
                            ],
                            [
                                57.07389,
                                26.38818
                            ],
                            [
                                57.11497,
                                26.33785
                            ],
                            [
                                57.14507,
                                26.23605
                            ],
                            [
                                57.21565,
                                26.16794
                            ],
                            [
                                57.18543,
                                26.0967
                            ],
                            [
                                57.19901,
                                26.01443
                            ],
                            [
                                57.26952,
                                25.9303
                            ],
                            [
                                57.29834,
                                25.81212
                            ],
                            [
                                57.32609,
                                25.78399
                            ],
                            [
                                57.49796,
                                25.7758
                            ],
                            [
                                57.54192,
                                25.74728
                            ],
                            [
                                57.7305,
                                25.74618
                            ],
                            [
                                57.7827,
                                25.70809
                            ],
                            [
                                57.93769,
                                25.70242
                            ],
                            [
                                58.08588,
                                25.56894
                            ],
                            [
                                58.17135,
                                25.57833
                            ],
                            [
                                58.36875,
                                25.62515
                            ],
                            [
                                58.44103,
                                25.59435
                            ],
                            [
                                58.56004,
                                25.60206
                            ],
                            [
                                58.66404,
                                25.57499
                            ],
                            [
                                58.78893,
                                25.574
                            ],
                            [
                                58.90789,
                                25.51754
                            ],
                            [
                                58.99235,
                                25.43219
                            ],
                            [
                                59.10149,
                                25.40932
                            ],
                            [
                                59.17318,
                                25.50794
                            ],
                            [
                                59.25051,
                                25.49873
                            ],
                            [
                                59.29238,
                                25.45659
                            ],
                            [
                                59.39221,
                                25.47337
                            ],
                            [
                                59.4789,
                                25.46704
                            ],
                            [
                                59.54407,
                                25.41328
                            ],
                            [
                                59.64553,
                                25.39555
                            ],
                            [
                                59.7747,
                                25.41214
                            ],
                            [
                                59.91368,
                                25.36857
                            ],
                            [
                                60.07333,
                                25.38305
                            ],
                            [
                                60.18928,
                                25.33371
                            ],
                            [
                                60.20696,
                                25.37788
                            ],
                            [
                                60.29603,
                                25.40145
                            ],
                            [
                                60.30816,
                                25.34325
                            ],
                            [
                                60.40623,
                                25.31921
                            ],
                            [
                                60.42781,
                                25.4152
                            ],
                            [
                                60.53556,
                                25.4438
                            ],
                            [
                                60.59201,
                                25.40955
                            ],
                            [
                                60.61523,
                                25.28827
                            ],
                            [
                                60.7406,
                                25.27186
                            ],
                            [
                                61.1294,
                                25.18229
                            ],
                            [
                                61.18876,
                                25.12523
                            ],
                            [
                                61.40179,
                                25.06865
                            ],
                            [
                                61.47307,
                                25.11444
                            ],
                            [
                                61.49778,
                                25.18224
                            ],
                            [
                                61.5687,
                                25.21745
                            ],
                            [
                                61.61045,
                                25.19495
                            ],
                            [
                                61.65561,
                                25.2975
                            ],
                            [
                                61.66982,
                                25.4219
                            ],
                            [
                                61.68072,
                                25.65421
                            ],
                            [
                                61.70216,
                                25.67105
                            ],
                            [
                                61.68955,
                                25.79771
                            ],
                            [
                                61.76591,
                                25.80134
                            ],
                            [
                                61.84794,
                                26.22724
                            ],
                            [
                                62.06058,
                                26.3149
                            ],
                            [
                                62.12037,
                                26.31704
                            ],
                            [
                                62.12817,
                                26.37881
                            ],
                            [
                                62.2825,
                                26.35917
                            ],
                            [
                                62.26546,
                                26.41243
                            ],
                            [
                                62.30723,
                                26.47462
                            ],
                            [
                                62.30501,
                                26.52264
                            ],
                            [
                                62.40272,
                                26.53942
                            ],
                            [
                                62.43691,
                                26.56874
                            ],
                            [
                                62.60748,
                                26.58514
                            ],
                            [
                                62.77869,
                                26.65211
                            ],
                            [
                                63.16155,
                                26.64412
                            ],
                            [
                                63.20011,
                                26.74132
                            ],
                            [
                                63.19281,
                                26.84293
                            ],
                            [
                                63.27369,
                                26.86451
                            ],
                            [
                                63.25683,
                                26.92971
                            ],
                            [
                                63.2561,
                                27.0817
                            ],
                            [
                                63.31685,
                                27.13892
                            ],
                            [
                                63.29723,
                                27.18022
                            ],
                            [
                                63.18532,
                                27.24068
                            ],
                            [
                                63.05661,
                                27.23217
                            ],
                            [
                                62.9781,
                                27.19564
                            ],
                            [
                                62.82054,
                                27.21282
                            ],
                            [
                                62.80812,
                                27.34125
                            ],
                            [
                                62.85526,
                                27.46715
                            ],
                            [
                                62.82019,
                                27.80243
                            ],
                            [
                                62.79009,
                                27.97703
                            ],
                            [
                                62.76854,
                                28.03159
                            ],
                            [
                                62.79634,
                                28.20782
                            ],
                            [
                                62.78378,
                                28.28071
                            ],
                            [
                                62.59281,
                                28.25572
                            ],
                            [
                                62.44134,
                                28.40534
                            ],
                            [
                                62.2957,
                                28.46337
                            ],
                            [
                                62.11239,
                                28.48639
                            ],
                            [
                                61.95664,
                                28.54944
                            ],
                            [
                                61.80465,
                                28.64089
                            ],
                            [
                                61.682,
                                28.77021
                            ],
                            [
                                61.50603,
                                29.00627
                            ],
                            [
                                61.5035,
                                29.05355
                            ],
                            [
                                61.42703,
                                29.19435
                            ],
                            [
                                61.35904,
                                29.28063
                            ],
                            [
                                61.37155,
                                29.34875
                            ],
                            [
                                61.19034,
                                29.50491
                            ],
                            [
                                60.87297,
                                29.85847
                            ],
                            [
                                61.49299,
                                30.51625
                            ],
                            [
                                61.80444,
                                30.83561
                            ],
                            [
                                61.78554,
                                30.94045
                            ],
                            [
                                61.83347,
                                30.97365
                            ],
                            [
                                61.83794,
                                31.03704
                            ],
                            [
                                61.80467,
                                31.16521
                            ],
                            [
                                61.77252,
                                31.20648
                            ],
                            [
                                61.77763,
                                31.3035
                            ],
                            [
                                61.707,
                                31.3755
                            ],
                            [
                                60.86493,
                                31.48548
                            ],
                            [
                                60.8136,
                                31.70865
                            ],
                            [
                                60.81692,
                                32.0244
                            ],
                            [
                                60.8821,
                                32.19945
                            ],
                            [
                                60.81502,
                                32.48024
                            ],
                            [
                                60.73272,
                                32.66549
                            ],
                            [
                                60.63019,
                                33.01893
                            ],
                            [
                                60.5843,
                                33.1302
                            ],
                            [
                                60.63653,
                                33.23011
                            ],
                            [
                                60.82073,
                                33.39651
                            ],
                            [
                                60.86494,
                                33.42174
                            ],
                            [
                                60.8543,
                                33.48417
                            ],
                            [
                                60.89832,
                                33.543
                            ],
                            [
                                60.65951,
                                33.53779
                            ],
                            [
                                60.54834,
                                33.7279
                            ],
                            [
                                60.58111,
                                33.80683
                            ],
                            [
                                60.47751,
                                34.08065
                            ],
                            [
                                60.67726,
                                34.30373
                            ],
                            [
                                60.91593,
                                34.30574
                            ],
                            [
                                60.8495,
                                34.37076
                            ],
                            [
                                60.80782,
                                34.47052
                            ],
                            [
                                60.74718,
                                34.52791
                            ],
                            [
                                60.85333,
                                34.5446
                            ],
                            [
                                60.92251,
                                34.62127
                            ],
                            [
                                60.98326,
                                34.62085
                            ],
                            [
                                61.00415,
                                34.71
                            ],
                            [
                                61.0675,
                                34.81225
                            ],
                            [
                                61.05887,
                                34.90062
                            ],
                            [
                                61.09713,
                                34.95404
                            ],
                            [
                                61.13,
                                35.13216
                            ],
                            [
                                61.09504,
                                35.18458
                            ],
                            [
                                61.09317,
                                35.2648
                            ],
                            [
                                61.18927,
                                35.29456
                            ],
                            [
                                61.1993,
                                35.41045
                            ],
                            [
                                61.27649,
                                35.52074
                            ],
                            [
                                61.27413,
                                35.60515
                            ],
                            [
                                61.21583,
                                35.67804
                            ],
                            [
                                61.2495,
                                35.72878
                            ],
                            [
                                61.26249,
                                35.81863
                            ],
                            [
                                61.23225,
                                35.91032
                            ],
                            [
                                61.18894,
                                35.94289
                            ],
                            [
                                61.16438,
                                36.0341
                            ],
                            [
                                61.22595,
                                36.11165
                            ],
                            [
                                61.22565,
                                36.16232
                            ],
                            [
                                61.15814,
                                36.2971
                            ],
                            [
                                61.14126,
                                36.39098
                            ],
                            [
                                61.17343,
                                36.46313
                            ],
                            [
                                61.18356,
                                36.56991
                            ],
                            [
                                61.14995,
                                36.63757
                            ],
                            [
                                61.1026,
                                36.6438
                            ],
                            [
                                60.65727,
                                36.62207
                            ],
                            [
                                60.35235,
                                36.62886
                            ],
                            [
                                60.26734,
                                36.75685
                            ],
                            [
                                60.1641,
                                36.85281
                            ],
                            [
                                60.04518,
                                37.0195
                            ],
                            [
                                59.93678,
                                37.04006
                            ],
                            [
                                59.76932,
                                37.12454
                            ],
                            [
                                59.66551,
                                37.14155
                            ],
                            [
                                59.55658,
                                37.13187
                            ],
                            [
                                59.54854,
                                37.17367
                            ],
                            [
                                59.40768,
                                37.30647
                            ],
                            [
                                59.42188,
                                37.36344
                            ],
                            [
                                59.38869,
                                37.41205
                            ],
                            [
                                59.39203,
                                37.48125
                            ],
                            [
                                59.33354,
                                37.53932
                            ],
                            [
                                59.22068,
                                37.51146
                            ],
                            [
                                59.05318,
                                37.61468
                            ],
                            [
                                58.88813,
                                37.65742
                            ],
                            [
                                58.73974,
                                37.63118
                            ],
                            [
                                58.6251,
                                37.65984
                            ],
                            [
                                58.56594,
                                37.70371
                            ],
                            [
                                58.47227,
                                37.63583
                            ],
                            [
                                58.25975,
                                37.67107
                            ],
                            [
                                58.21545,
                                37.75302
                            ],
                            [
                                58.10738,
                                37.80167
                            ],
                            [
                                57.93823,
                                37.80587
                            ],
                            [
                                57.88593,
                                37.86648
                            ],
                            [
                                57.71054,
                                37.91532
                            ],
                            [
                                57.48542,
                                37.9182
                            ],
                            [
                                57.36073,
                                38.00211
                            ],
                            [
                                57.36294,
                                38.10101
                            ],
                            [
                                57.29272,
                                38.15446
                            ],
                            [
                                57.29512,
                                38.19542
                            ],
                            [
                                57.23894,
                                38.27434
                            ],
                            [
                                57.15605,
                                38.27432
                            ],
                            [
                                57.06502,
                                38.18589
                            ],
                            [
                                56.99946,
                                38.21801
                            ],
                            [
                                56.91575,
                                38.21621
                            ],
                            [
                                56.76935,
                                38.26882
                            ],
                            [
                                56.67129,
                                38.26795
                            ],
                            [
                                56.60024,
                                38.23869
                            ],
                            [
                                56.55202,
                                38.26822
                            ],
                            [
                                56.40782,
                                38.24452
                            ],
                            [
                                56.32329,
                                38.17234
                            ],
                            [
                                56.33853,
                                38.07906
                            ],
                            [
                                56.20072,
                                38.07033
                            ],
                            [
                                56.17249,
                                38.08932
                            ],
                            [
                                55.99989,
                                38.07337
                            ],
                            [
                                55.87164,
                                38.09355
                            ],
                            [
                                55.80657,
                                38.12437
                            ],
                            [
                                55.68017,
                                38.10282
                            ],
                            [
                                55.45763,
                                38.08689
                            ],
                            [
                                55.40221,
                                38.03567
                            ],
                            [
                                55.11072,
                                37.93666
                            ],
                            [
                                54.95403,
                                37.79988
                            ],
                            [
                                54.86789,
                                37.76722
                            ],
                            [
                                54.78619,
                                37.64207
                            ],
                            [
                                54.81863,
                                37.59295
                            ],
                            [
                                54.79857,
                                37.52438
                            ],
                            [
                                54.666,
                                37.43629
                            ],
                            [
                                54.5979,
                                37.4587
                            ],
                            [
                                54.41363,
                                37.36991
                            ],
                            [
                                54.24604,
                                37.31565
                            ],
                            [
                                53.90682,
                                37.33994
                            ],
                            [
                                53.97379,
                                37.09098
                            ],
                            [
                                54.01498,
                                37.02089
                            ],
                            [
                                54.03342,
                                36.84738
                            ],
                            [
                                54.01735,
                                36.81618
                            ],
                            [
                                53.89084,
                                36.79193
                            ],
                            [
                                53.66745,
                                36.81987
                            ],
                            [
                                53.78507,
                                36.90525
                            ],
                            [
                                53.48774,
                                36.8842
                            ],
                            [
                                53.22378,
                                36.84624
                            ],
                            [
                                52.7991,
                                36.74004
                            ],
                            [
                                52.55068,
                                36.6916
                            ],
                            [
                                52.43291,
                                36.68357
                            ],
                            [
                                52.2524,
                                36.64309
                            ],
                            [
                                52.10479,
                                36.59728
                            ],
                            [
                                51.97441,
                                36.57802
                            ],
                            [
                                51.87283,
                                36.58234
                            ],
                            [
                                51.50566,
                                36.65234
                            ],
                            [
                                51.41486,
                                36.67888
                            ],
                            [
                                51.10018,
                                36.72707
                            ],
                            [
                                51.00027,
                                36.76405
                            ],
                            [
                                50.9111,
                                36.81933
                            ],
                            [
                                50.69166,
                                36.92071
                            ],
                            [
                                50.48582,
                                37.02682
                            ],
                            [
                                50.45,
                                37.06627
                            ],
                            [
                                50.31622,
                                37.14987
                            ],
                            [
                                50.2401,
                                37.27839
                            ],
                            [
                                50.22295,
                                37.36454
                            ],
                            [
                                50.17381,
                                37.39292
                            ],
                            [
                                49.9413,
                                37.44373
                            ],
                            [
                                49.91173,
                                37.47498
                            ],
                            [
                                49.83343,
                                37.44945
                            ],
                            [
                                49.6606,
                                37.47252
                            ],
                            [
                                49.42151,
                                37.49107
                            ],
                            [
                                49.28091,
                                37.5414
                            ],
                            [
                                49.14679,
                                37.60851
                            ],
                            [
                                49.07225,
                                37.66741
                            ],
                            [
                                48.99702,
                                37.76374
                            ],
                            [
                                48.95458,
                                37.87477
                            ],
                            [
                                48.94365,
                                37.97126
                            ],
                            [
                                48.86965,
                                38.29903
                            ],
                            [
                                48.88781,
                                38.44117
                            ],
                            [
                                48.79315,
                                38.44686
                            ],
                            [
                                48.66785,
                                38.39374
                            ],
                            [
                                48.58593,
                                38.45359
                            ],
                            [
                                48.4526,
                                38.60907
                            ],
                            [
                                48.31568,
                                38.60564
                            ],
                            [
                                48.25704,
                                38.6627
                            ],
                            [
                                48.24989,
                                38.72594
                            ],
                            [
                                48.11481,
                                38.77287
                            ],
                            [
                                48.02348,
                                38.84374
                            ],
                            [
                                48.01674,
                                38.89276
                            ],
                            [
                                48.08398,
                                38.93747
                            ],
                            [
                                48.27371,
                                38.96912
                            ],
                            [
                                48.34138,
                                39.0281
                            ],
                            [
                                48.3071,
                                39.1103
                            ],
                            [
                                48.24115,
                                39.12925
                            ],
                            [
                                48.14593,
                                39.20396
                            ],
                            [
                                48.13798,
                                39.27175
                            ],
                            [
                                48.20758,
                                39.32569
                            ],
                            [
                                48.36364,
                                39.37096
                            ],
                            [
                                48.34869,
                                39.4048
                            ],
                            [
                                48.14587,
                                39.59078
                            ],
                            [
                                47.98661,
                                39.70629
                            ],
                            [
                                47.91793,
                                39.66159
                            ],
                            [
                                47.80958,
                                39.65711
                            ],
                            [
                                47.75012,
                                39.60435
                            ],
                            [
                                47.67064,
                                39.57873
                            ],
                            [
                                47.53096,
                                39.49922
                            ],
                            [
                                47.38916,
                                39.46795
                            ],
                            [
                                47.31749,
                                39.37501
                            ],
                            [
                                47.08153,
                                39.26544
                            ],
                            [
                                47.05555,
                                39.19616
                            ],
                            [
                                46.95053,
                                39.14126
                            ],
                            [
                                46.87184,
                                39.13888
                            ],
                            [
                                46.6936,
                                39.01403
                            ],
                            [
                                46.65524,
                                38.9548
                            ],
                            [
                                46.5458,
                                38.8781
                            ],
                            [
                                46.36258,
                                38.9161
                            ],
                            [
                                46.26905,
                                38.8942
                            ],
                            [
                                46.18321,
                                38.84148
                            ],
                            [
                                46.14066,
                                38.84494
                            ],
                            [
                                46.0639,
                                38.88627
                            ],
                            [
                                45.89589,
                                38.87799
                            ],
                            [
                                45.84993,
                                38.90883
                            ],
                            [
                                45.69316,
                                38.9497
                            ],
                            [
                                45.61754,
                                38.9431
                            ],
                            [
                                45.45362,
                                38.99279
                            ],
                            [
                                45.45449,
                                39.05173
                            ],
                            [
                                45.33058,
                                39.16517
                            ],
                            [
                                45.17208,
                                39.21392
                            ],
                            [
                                45.08443,
                                39.35106
                            ],
                            [
                                44.94408,
                                39.45776
                            ],
                            [
                                44.91277,
                                39.56698
                            ],
                            [
                                44.81204,
                                39.63174
                            ],
                            [
                                44.7365,
                                39.7018
                            ],
                            [
                                44.60936,
                                39.77835
                            ],
                            [
                                44.47143,
                                39.69789
                            ],
                            [
                                44.47757,
                                39.63968
                            ],
                            [
                                44.42467,
                                39.43564
                            ],
                            [
                                44.30548,
                                39.38767
                            ],
                            [
                                44.20325,
                                39.41629
                            ],
                            [
                                44.07682,
                                39.41126
                            ],
                            [
                                44.03584,
                                39.37686
                            ],
                            [
                                44.21606,
                                39.13552
                            ],
                            [
                                44.16286,
                                39.00443
                            ],
                            [
                                44.21045,
                                38.8929
                            ],
                            [
                                44.28389,
                                38.86178
                            ],
                            [
                                44.30261,
                                38.80899
                            ],
                            [
                                44.26235,
                                38.72422
                            ],
                            [
                                44.31714,
                                38.61257
                            ],
                            [
                                44.30435,
                                38.44929
                            ],
                            [
                                44.32009,
                                38.38236
                            ],
                            [
                                44.43655,
                                38.39421
                            ],
                            [
                                44.47244,
                                38.31572
                            ],
                            [
                                44.24011,
                                37.96224
                            ],
                            [
                                44.22454,
                                37.89997
                            ],
                            [
                                44.57603,
                                37.76689
                            ],
                            [
                                44.61665,
                                37.7191
                            ],
                            [
                                44.58457,
                                37.61403
                            ],
                            [
                                44.58906,
                                37.44417
                            ],
                            [
                                44.64972,
                                37.4269
                            ],
                            [
                                44.8026,
                                37.32021
                            ],
                            [
                                44.82037,
                                37.26913
                            ],
                            [
                                44.79315,
                                37.17628
                            ],
                            [
                                44.75126,
                                37.11335
                            ],
                            [
                                44.80714,
                                37.04528
                            ],
                            [
                                44.90084,
                                37.02163
                            ],
                            [
                                44.88382,
                                36.95562
                            ],
                            [
                                44.89862,
                                36.8561
                            ],
                            [
                                44.83788,
                                36.7985
                            ],
                            [
                                44.94158,
                                36.78432
                            ],
                            [
                                45.02949,
                                36.74051
                            ],
                            [
                                45.06488,
                                36.6878
                            ],
                            [
                                45.01651,
                                36.51873
                            ],
                            [
                                45.05194,
                                36.50574
                            ],
                            [
                                45.11598,
                                36.40648
                            ],
                            [
                                45.23374,
                                36.4311
                            ],
                            [
                                45.27111,
                                36.3911
                            ],
                            [
                                45.2625,
                                36.30381
                            ],
                            [
                                45.33532,
                                36.20394
                            ],
                            [
                                45.32881,
                                36.14159
                            ],
                            [
                                45.38018,
                                36.08346
                            ],
                            [
                                45.3439,
                                36.00744
                            ],
                            [
                                45.55409,
                                35.99663
                            ],
                            [
                                45.66519,
                                35.9263
                            ],
                            [
                                45.75776,
                                35.80742
                            ],
                            [
                                46.02631,
                                35.8377
                            ],
                            [
                                46.08931,
                                35.86901
                            ],
                            [
                                46.15383,
                                35.80849
                            ],
                            [
                                46.21441,
                                35.79784
                            ],
                            [
                                46.29339,
                                35.83412
                            ],
                            [
                                46.34623,
                                35.78969
                            ],
                            [
                                46.2775,
                                35.73084
                            ],
                            [
                                46.16139,
                                35.69031
                            ],
                            [
                                46.0099,
                                35.67358
                            ],
                            [
                                46.0097,
                                35.5744
                            ],
                            [
                                45.98715,
                                35.49453
                            ],
                            [
                                46.06805,
                                35.37127
                            ],
                            [
                                46.1243,
                                35.33523
                            ],
                            [
                                46.19547,
                                35.18803
                            ],
                            [
                                46.18792,
                                35.11066
                            ],
                            [
                                46.05197,
                                35.05061
                            ],
                            [
                                45.94976,
                                35.08827
                            ],
                            [
                                45.87732,
                                35.03196
                            ],
                            [
                                45.89615,
                                34.95796
                            ],
                            [
                                45.86397,
                                34.89788
                            ],
                            [
                                45.72673,
                                34.83852
                            ],
                            [
                                45.65453,
                                34.72347
                            ],
                            [
                                45.70126,
                                34.6941
                            ],
                            [
                                45.73945,
                                34.58399
                            ],
                            [
                                45.60493,
                                34.55038
                            ],
                            [
                                45.53148,
                                34.60151
                            ],
                            [
                                45.50742,
                                34.47324
                            ],
                            [
                                45.44118,
                                34.45856
                            ],
                            [
                                45.49688,
                                34.33888
                            ],
                            [
                                45.54008,
                                34.35044
                            ],
                            [
                                45.58559,
                                34.29124
                            ],
                            [
                                45.55634,
                                34.1957
                            ],
                            [
                                45.57994,
                                34.14743
                            ],
                            [
                                45.47467,
                                34.07577
                            ],
                            [
                                45.47467,
                                34.02402
                            ],
                            [
                                45.41155,
                                33.97755
                            ],
                            [
                                45.50299,
                                33.95311
                            ],
                            [
                                45.63966,
                                33.74476
                            ],
                            [
                                45.77097,
                                33.63683
                            ],
                            [
                                45.86957,
                                33.63376
                            ],
                            [
                                45.95771,
                                33.56962
                            ],
                            [
                                46.04143,
                                33.45605
                            ],
                            [
                                46.07734,
                                33.35876
                            ],
                            [
                                46.1905,
                                33.26323
                            ],
                            [
                                46.19939,
                                33.19154
                            ],
                            [
                                46.12471,
                                33.11762
                            ],
                            [
                                46.15708,
                                33.07186
                            ],
                            [
                                46.09916,
                                32.98029
                            ],
                            [
                                46.1725,
                                32.95402
                            ],
                            [
                                46.31176,
                                32.9691
                            ],
                            [
                                46.40842,
                                32.94802
                            ],
                            [
                                46.52216,
                                32.89653
                            ],
                            [
                                46.6243,
                                32.82198
                            ],
                            [
                                46.7225,
                                32.78532
                            ],
                            [
                                46.88702,
                                32.63273
                            ],
                            [
                                46.99948,
                                32.57017
                            ],
                            [
                                47.09458,
                                32.4974
                            ],
                            [
                                47.17659,
                                32.45683
                            ],
                            [
                                47.28547,
                                32.49703
                            ],
                            [
                                47.38771,
                                32.46992
                            ],
                            [
                                47.46549,
                                32.39176
                            ],
                            [
                                47.46329,
                                32.3166
                            ],
                            [
                                47.57021,
                                32.21624
                            ],
                            [
                                47.533,
                                32.17048
                            ],
                            [
                                47.56052,
                                32.11935
                            ],
                            [
                                47.64927,
                                32.08236
                            ],
                            [
                                47.73466,
                                31.93757
                            ],
                            [
                                47.80792,
                                31.88224
                            ],
                            [
                                47.8642,
                                31.78292
                            ],
                            [
                                47.68383,
                                31.39581
                            ],
                            [
                                47.6821,
                                31.0007
                            ],
                            [
                                48.0314,
                                30.99499
                            ],
                            [
                                48.02508,
                                30.47781
                            ],
                            [
                                48.16627,
                                30.42453
                            ],
                            [
                                48.20296,
                                30.31924
                            ],
                            [
                                48.27537,
                                30.33319
                            ],
                            [
                                48.41283,
                                30.19799
                            ],
                            [
                                48.38749,
                                30.13369
                            ],
                            [
                                48.43228,
                                30.0837
                            ],
                            [
                                48.48442,
                                29.97912
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                55.25585,
                                26.6557
                            ],
                            [
                                55.2697,
                                26.55941
                            ],
                            [
                                55.31344,
                                26.5496
                            ],
                            [
                                55.61898,
                                26.64945
                            ],
                            [
                                55.68234,
                                26.6893
                            ],
                            [
                                55.75502,
                                26.68857
                            ],
                            [
                                55.85232,
                                26.74201
                            ],
                            [
                                55.90963,
                                26.69768
                            ],
                            [
                                56.06822,
                                26.78319
                            ],
                            [
                                56.12943,
                                26.84167
                            ],
                            [
                                56.16206,
                                26.90985
                            ],
                            [
                                56.26098,
                                26.92957
                            ],
                            [
                                56.2589,
                                26.97107
                            ],
                            [
                                56.14735,
                                26.99769
                            ],
                            [
                                55.97571,
                                26.94934
                            ],
                            [
                                55.86938,
                                26.89923
                            ],
                            [
                                55.75408,
                                26.95287
                            ],
                            [
                                55.72803,
                                26.92555
                            ],
                            [
                                55.77593,
                                26.8482
                            ],
                            [
                                55.76203,
                                26.80212
                            ],
                            [
                                55.64779,
                                26.77542
                            ],
                            [
                                55.55225,
                                26.71698
                            ],
                            [
                                55.34358,
                                26.64937
                            ],
                            [
                                55.25585,
                                26.6557
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                55.61963,
                                26.77929
                            ],
                            [
                                55.66485,
                                26.78888
                            ],
                            [
                                55.70519,
                                26.86932
                            ],
                            [
                                55.67075,
                                26.91767
                            ],
                            [
                                55.61963,
                                26.77929
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                53.89292,
                                26.55172
                            ],
                            [
                                53.91565,
                                26.51786
                            ],
                            [
                                53.99514,
                                26.49802
                            ],
                            [
                                54.01846,
                                26.56413
                            ],
                            [
                                53.94381,
                                26.57796
                            ],
                            [
                                53.89292,
                                26.55172
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "IRQ",
                "Country": "Iraq",
                "Total_3GHG": 0.46,
                "Total_3GHG_timeseries": [
                    4.9602e-07,
                    1.0011e-06,
                    1.515e-06,
                    2.0376e-06,
                    2.5686e-06,
                    3.1079e-06,
                    3.6554e-06,
                    4.2108e-06,
                    4.7739e-06,
                    5.4186e-06,
                    6.1219e-06,
                    6.8689e-06,
                    7.6522e-06,
                    8.4678e-06,
                    9.3135e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0026,
                    0.0027,
                    0.0029,
                    0.0031,
                    0.0033,
                    0.0035,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.0041,
                    0.0042,
                    0.0044,
                    0.0045,
                    0.0044,
                    0.0044,
                    0.0043,
                    0.0042,
                    0.0042,
                    0.0041,
                    0.004,
                    0.004,
                    0.0039,
                    0.0039,
                    0.004,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0043,
                    0.0043,
                    0.0043,
                    0.0043,
                    0.0043,
                    0.0045,
                    0.0048,
                    0.005,
                    0.0052,
                    0.0055,
                    0.0058,
                    0.0061,
                    0.0065,
                    0.0068,
                    0.007,
                    0.0073,
                    0.0076
                ],
                "Fossil_3GHG": 0.67,
                "Fossil_3GHG_timeseries": [
                    7.4694e-08,
                    1.5079e-07,
                    2.2829e-07,
                    3.0717e-07,
                    3.8743e-07,
                    4.6907e-07,
                    5.5207e-07,
                    6.3641e-07,
                    7.2209e-07,
                    8.0908e-07,
                    9.0133e-07,
                    9.9881e-07,
                    1.1015e-06,
                    1.2095e-06,
                    1.3226e-06,
                    1.441e-06,
                    1.5646e-06,
                    1.6934e-06,
                    1.8274e-06,
                    1.9666e-06,
                    2.111e-06,
                    2.2606e-06,
                    2.4156e-06,
                    2.5761e-06,
                    2.742e-06,
                    2.9135e-06,
                    3.0904e-06,
                    3.2726e-06,
                    3.4602e-06,
                    3.653e-06,
                    3.8481e-06,
                    4.0454e-06,
                    4.2451e-06,
                    4.4469e-06,
                    4.6511e-06,
                    4.8574e-06,
                    5.066e-06,
                    5.2768e-06,
                    5.4898e-06,
                    5.7051e-06,
                    5.9229e-06,
                    6.1432e-06,
                    6.3661e-06,
                    6.5914e-06,
                    6.8193e-06,
                    7.0496e-06,
                    7.2825e-06,
                    7.5179e-06,
                    7.7558e-06,
                    7.9962e-06,
                    8.2472e-06,
                    8.5085e-06,
                    8.7795e-06,
                    9.0597e-06,
                    9.3488e-06,
                    9.6461e-06,
                    9.9511e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0021,
                    0.0022,
                    0.0024,
                    0.0025,
                    0.0027,
                    0.0029,
                    0.0031,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0039,
                    0.004,
                    0.0041,
                    0.004,
                    0.004,
                    0.0039,
                    0.0039,
                    0.0038,
                    0.0037,
                    0.0037,
                    0.0036,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0041,
                    0.0044,
                    0.0046,
                    0.0048,
                    0.0051,
                    0.0054,
                    0.0057,
                    0.006,
                    0.0063,
                    0.0066,
                    0.0068,
                    0.0071
                ],
                "Land_3GHG": 0.08,
                "Land_3GHG_timeseries": [
                    4.2132e-07,
                    8.5032e-07,
                    1.2867e-06,
                    1.7304e-06,
                    2.1812e-06,
                    2.6388e-06,
                    3.1033e-06,
                    3.5744e-06,
                    4.0518e-06,
                    4.6095e-06,
                    5.2206e-06,
                    5.8701e-06,
                    6.5506e-06,
                    7.2583e-06,
                    7.9908e-06,
                    8.7468e-06,
                    9.5254e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005
                ],
                "Total_CO2": 0.2,
                "Total_CO2_timeseries": [
                    1.4078e-07,
                    2.8362e-07,
                    4.2832e-07,
                    5.7478e-07,
                    7.2298e-07,
                    8.7289e-07,
                    1.0245e-06,
                    1.1779e-06,
                    1.3329e-06,
                    1.5638e-06,
                    1.831e-06,
                    2.1196e-06,
                    2.4223e-06,
                    2.7351e-06,
                    3.0558e-06,
                    3.3829e-06,
                    3.7157e-06,
                    4.0534e-06,
                    4.3956e-06,
                    4.7588e-06,
                    5.1341e-06,
                    5.5179e-06,
                    5.9083e-06,
                    6.304e-06,
                    6.7044e-06,
                    7.109e-06,
                    7.5175e-06,
                    7.9295e-06,
                    8.345e-06,
                    8.7801e-06,
                    9.2257e-06,
                    9.6785e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023
                ],
                "Fossil_CO2": 0.28,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    6.27e-08,
                    1.9305e-07,
                    3.597e-07,
                    5.2635e-07,
                    6.9135e-07,
                    8.5965e-07,
                    1.018e-06,
                    2.3084e-06,
                    4.8857e-06,
                    7.4943e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022
                ],
                "Land_CO2": 0.04,
                "Land_CO2_timeseries": [
                    1.4078e-07,
                    2.8362e-07,
                    4.2832e-07,
                    5.7478e-07,
                    7.2298e-07,
                    8.7289e-07,
                    1.0245e-06,
                    1.1779e-06,
                    1.3329e-06,
                    1.5638e-06,
                    1.831e-06,
                    2.1196e-06,
                    2.4223e-06,
                    2.7351e-06,
                    3.0558e-06,
                    3.3829e-06,
                    3.7157e-06,
                    4.0534e-06,
                    4.3956e-06,
                    4.7588e-06,
                    5.1341e-06,
                    5.5179e-06,
                    5.9083e-06,
                    6.304e-06,
                    6.7044e-06,
                    7.109e-06,
                    7.5175e-06,
                    7.9295e-06,
                    8.345e-06,
                    8.7801e-06,
                    9.2257e-06,
                    9.6785e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_CH4": 1.22,
                "Total_CH4_timeseries": [
                    2.6721e-07,
                    5.3978e-07,
                    8.177e-07,
                    1.101e-06,
                    1.3896e-06,
                    1.6836e-06,
                    1.9829e-06,
                    2.2876e-06,
                    2.5976e-06,
                    2.913e-06,
                    3.2505e-06,
                    3.61e-06,
                    3.9916e-06,
                    4.3952e-06,
                    4.8209e-06,
                    5.2686e-06,
                    5.7384e-06,
                    6.2302e-06,
                    6.7441e-06,
                    7.2799e-06,
                    7.8374e-06,
                    8.4164e-06,
                    9.0169e-06,
                    9.639e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0025,
                    0.0026,
                    0.0028,
                    0.003,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0037,
                    0.0037,
                    0.0036,
                    0.0036,
                    0.0035,
                    0.0034,
                    0.0033,
                    0.0031,
                    0.0031,
                    0.003,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0028,
                    0.0027,
                    0.0027,
                    0.0029,
                    0.0031,
                    0.0032,
                    0.0034,
                    0.0036,
                    0.0039,
                    0.0041,
                    0.0043,
                    0.0045,
                    0.0047,
                    0.0049,
                    0.0051
                ],
                "Fossil_CH4": 1.88,
                "Fossil_CH4_timeseries": [
                    6.1005e-08,
                    1.2323e-07,
                    1.8667e-07,
                    2.5134e-07,
                    3.1721e-07,
                    3.843e-07,
                    4.5261e-07,
                    5.2212e-07,
                    5.9285e-07,
                    6.6478e-07,
                    7.4187e-07,
                    8.241e-07,
                    9.1147e-07,
                    1.004e-06,
                    1.1016e-06,
                    1.2044e-06,
                    1.3122e-06,
                    1.4252e-06,
                    1.5433e-06,
                    1.6665e-06,
                    1.7947e-06,
                    1.9278e-06,
                    2.0659e-06,
                    2.209e-06,
                    2.357e-06,
                    2.5099e-06,
                    2.6678e-06,
                    2.8307e-06,
                    2.9984e-06,
                    3.1711e-06,
                    3.3459e-06,
                    3.5228e-06,
                    3.7017e-06,
                    3.8828e-06,
                    4.066e-06,
                    4.2513e-06,
                    4.4387e-06,
                    4.6281e-06,
                    4.8197e-06,
                    5.0133e-06,
                    5.2092e-06,
                    5.4076e-06,
                    5.6082e-06,
                    5.8112e-06,
                    6.0165e-06,
                    6.2241e-06,
                    6.4341e-06,
                    6.6464e-06,
                    6.861e-06,
                    7.0779e-06,
                    7.3051e-06,
                    7.5423e-06,
                    7.789e-06,
                    8.0446e-06,
                    8.3088e-06,
                    8.5808e-06,
                    8.8602e-06,
                    9.1465e-06,
                    9.4389e-06,
                    9.7368e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0023,
                    0.0024,
                    0.0026,
                    0.0028,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0035,
                    0.0035,
                    0.0034,
                    0.0034,
                    0.0033,
                    0.0032,
                    0.0031,
                    0.003,
                    0.0029,
                    0.0028,
                    0.0027,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0027,
                    0.0027,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0029,
                    0.0031,
                    0.0032,
                    0.0034,
                    0.0037,
                    0.0039,
                    0.0041,
                    0.0043,
                    0.0045,
                    0.0047,
                    0.0049
                ],
                "Land_CH4": 0.13,
                "Land_CH4_timeseries": [
                    2.0621e-07,
                    4.1655e-07,
                    6.3103e-07,
                    8.4965e-07,
                    1.0724e-06,
                    1.2993e-06,
                    1.5303e-06,
                    1.7655e-06,
                    2.0048e-06,
                    2.2482e-06,
                    2.5086e-06,
                    2.7859e-06,
                    3.0801e-06,
                    3.3912e-06,
                    3.7193e-06,
                    4.0643e-06,
                    4.4262e-06,
                    4.805e-06,
                    5.2008e-06,
                    5.6134e-06,
                    6.0427e-06,
                    6.4885e-06,
                    6.951e-06,
                    7.43e-06,
                    7.9256e-06,
                    8.4378e-06,
                    8.9665e-06,
                    9.5119e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Total_N2O": 0.2,
                "Total_N2O_timeseries": [
                    8.8024e-08,
                    1.7772e-07,
                    2.6901e-07,
                    3.6181e-07,
                    4.56e-07,
                    5.5143e-07,
                    6.4793e-07,
                    7.453e-07,
                    8.4332e-07,
                    9.4174e-07,
                    1.0404e-06,
                    1.1393e-06,
                    1.2383e-06,
                    1.3375e-06,
                    1.4368e-06,
                    1.5363e-06,
                    1.6359e-06,
                    1.7357e-06,
                    1.8357e-06,
                    1.936e-06,
                    2.0378e-06,
                    2.1436e-06,
                    2.2549e-06,
                    2.3732e-06,
                    2.499e-06,
                    2.6325e-06,
                    2.7734e-06,
                    2.9208e-06,
                    3.0732e-06,
                    3.2288e-06,
                    3.3862e-06,
                    3.545e-06,
                    3.7052e-06,
                    3.8665e-06,
                    4.0288e-06,
                    4.1921e-06,
                    4.3563e-06,
                    4.5216e-06,
                    4.688e-06,
                    4.8614e-06,
                    5.0352e-06,
                    5.2096e-06,
                    5.3845e-06,
                    5.5601e-06,
                    5.7364e-06,
                    5.9136e-06,
                    6.0916e-06,
                    6.2706e-06,
                    6.4506e-06,
                    6.6316e-06,
                    6.8137e-06,
                    6.9971e-06,
                    7.182e-06,
                    7.3686e-06,
                    7.5569e-06,
                    7.7469e-06,
                    7.9389e-06,
                    8.1327e-06,
                    8.3283e-06,
                    8.5257e-06,
                    8.7248e-06,
                    8.9254e-06,
                    9.1275e-06,
                    9.331e-06,
                    9.5361e-06,
                    9.7429e-06,
                    9.9515e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_N2O": 0.24,
                "Fossil_N2O_timeseries": [
                    1.3689e-08,
                    2.7561e-08,
                    4.1611e-08,
                    5.5834e-08,
                    7.0223e-08,
                    8.4769e-08,
                    9.9463e-08,
                    1.1429e-07,
                    1.2924e-07,
                    1.443e-07,
                    1.5946e-07,
                    1.7471e-07,
                    1.9006e-07,
                    2.055e-07,
                    2.2104e-07,
                    2.3666e-07,
                    2.5238e-07,
                    2.682e-07,
                    2.8411e-07,
                    3.0012e-07,
                    3.1631e-07,
                    3.3281e-07,
                    3.4972e-07,
                    3.6713e-07,
                    3.8506e-07,
                    4.0354e-07,
                    4.2253e-07,
                    4.4198e-07,
                    4.6182e-07,
                    4.8193e-07,
                    5.0222e-07,
                    5.2269e-07,
                    5.4332e-07,
                    5.641e-07,
                    5.8502e-07,
                    6.0609e-07,
                    6.2729e-07,
                    6.4864e-07,
                    6.7015e-07,
                    6.9182e-07,
                    7.1366e-07,
                    7.3567e-07,
                    7.5785e-07,
                    7.8021e-07,
                    8.0275e-07,
                    8.2547e-07,
                    8.4838e-07,
                    8.715e-07,
                    8.9481e-07,
                    9.1835e-07,
                    9.4212e-07,
                    9.6615e-07,
                    9.9047e-07,
                    1.0151e-06,
                    1.04e-06,
                    1.0653e-06,
                    1.0908e-06,
                    1.1167e-06,
                    1.1429e-06,
                    1.1694e-06,
                    1.1963e-06,
                    1.2234e-06,
                    1.2508e-06,
                    1.2785e-06,
                    1.3064e-06,
                    1.3347e-06,
                    1.3633e-06,
                    1.3922e-06,
                    1.4214e-06,
                    1.4508e-06,
                    1.4806e-06,
                    1.5107e-06,
                    1.5411e-06,
                    1.5718e-06,
                    1.6028e-06,
                    1.6341e-06,
                    1.6658e-06,
                    1.6977e-06,
                    1.7299e-06,
                    1.7624e-06,
                    1.7956e-06,
                    1.8301e-06,
                    1.8664e-06,
                    1.905e-06,
                    1.9462e-06,
                    1.9902e-06,
                    2.0371e-06,
                    2.087e-06,
                    2.1396e-06,
                    2.1948e-06,
                    2.2528e-06,
                    2.3145e-06,
                    2.3803e-06,
                    2.4506e-06,
                    2.5256e-06,
                    2.6051e-06,
                    2.689e-06,
                    2.7766e-06,
                    2.8673e-06,
                    2.9602e-06,
                    3.0546e-06,
                    3.1503e-06,
                    3.247e-06,
                    3.3448e-06,
                    3.4435e-06,
                    3.5432e-06,
                    3.644e-06,
                    3.7461e-06,
                    3.8495e-06,
                    3.9548e-06,
                    4.0645e-06,
                    4.1839e-06,
                    4.318e-06,
                    4.4717e-06,
                    4.6497e-06,
                    4.8565e-06,
                    5.0968e-06,
                    5.3746e-06,
                    5.6943e-06,
                    5.9844e-06,
                    6.2906e-06,
                    6.6114e-06,
                    6.9442e-06,
                    7.2917e-06,
                    7.6622e-06,
                    8.071e-06,
                    8.4908e-06,
                    8.9349e-06,
                    9.4239e-06,
                    9.9188e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_N2O": 0.19,
                "Land_N2O_timeseries": [
                    7.4335e-08,
                    1.5016e-07,
                    2.274e-07,
                    3.0598e-07,
                    3.8578e-07,
                    4.6666e-07,
                    5.4847e-07,
                    6.3101e-07,
                    7.1408e-07,
                    7.9744e-07,
                    8.8094e-07,
                    9.6455e-07,
                    1.0482e-06,
                    1.132e-06,
                    1.2158e-06,
                    1.2996e-06,
                    1.3835e-06,
                    1.4675e-06,
                    1.5516e-06,
                    1.6358e-06,
                    1.7215e-06,
                    1.8107e-06,
                    1.9052e-06,
                    2.006e-06,
                    2.1139e-06,
                    2.229e-06,
                    2.3509e-06,
                    2.4788e-06,
                    2.6114e-06,
                    2.7469e-06,
                    2.8839e-06,
                    3.0223e-06,
                    3.1619e-06,
                    3.3024e-06,
                    3.4438e-06,
                    3.586e-06,
                    3.729e-06,
                    3.873e-06,
                    4.0179e-06,
                    4.1696e-06,
                    4.3216e-06,
                    4.4739e-06,
                    4.6266e-06,
                    4.7799e-06,
                    4.9337e-06,
                    5.0881e-06,
                    5.2433e-06,
                    5.3991e-06,
                    5.5558e-06,
                    5.7132e-06,
                    5.8715e-06,
                    6.0309e-06,
                    6.1915e-06,
                    6.3535e-06,
                    6.5168e-06,
                    6.6817e-06,
                    6.848e-06,
                    7.0159e-06,
                    7.1853e-06,
                    7.3562e-06,
                    7.5285e-06,
                    7.702e-06,
                    7.8767e-06,
                    8.0526e-06,
                    8.2297e-06,
                    8.4082e-06,
                    8.5882e-06,
                    8.7701e-06,
                    8.9543e-06,
                    9.141e-06,
                    9.3325e-06,
                    9.5325e-06,
                    9.7438e-06,
                    9.9686e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            48.48442,
                            29.97912
                        ],
                        [
                            48.43228,
                            30.0837
                        ],
                        [
                            48.38749,
                            30.13369
                        ],
                        [
                            48.41283,
                            30.19799
                        ],
                        [
                            48.27537,
                            30.33319
                        ],
                        [
                            48.20296,
                            30.31924
                        ],
                        [
                            48.16627,
                            30.42453
                        ],
                        [
                            48.02508,
                            30.47781
                        ],
                        [
                            48.0314,
                            30.99499
                        ],
                        [
                            47.6821,
                            31.0007
                        ],
                        [
                            47.68383,
                            31.39581
                        ],
                        [
                            47.8642,
                            31.78292
                        ],
                        [
                            47.80792,
                            31.88224
                        ],
                        [
                            47.73466,
                            31.93757
                        ],
                        [
                            47.64927,
                            32.08236
                        ],
                        [
                            47.56052,
                            32.11935
                        ],
                        [
                            47.533,
                            32.17048
                        ],
                        [
                            47.57021,
                            32.21624
                        ],
                        [
                            47.46329,
                            32.3166
                        ],
                        [
                            47.46549,
                            32.39176
                        ],
                        [
                            47.38771,
                            32.46992
                        ],
                        [
                            47.28547,
                            32.49703
                        ],
                        [
                            47.17659,
                            32.45683
                        ],
                        [
                            47.09458,
                            32.4974
                        ],
                        [
                            46.99948,
                            32.57017
                        ],
                        [
                            46.88702,
                            32.63273
                        ],
                        [
                            46.7225,
                            32.78532
                        ],
                        [
                            46.6243,
                            32.82198
                        ],
                        [
                            46.52216,
                            32.89653
                        ],
                        [
                            46.40842,
                            32.94802
                        ],
                        [
                            46.31176,
                            32.9691
                        ],
                        [
                            46.1725,
                            32.95402
                        ],
                        [
                            46.09916,
                            32.98029
                        ],
                        [
                            46.15708,
                            33.07186
                        ],
                        [
                            46.12471,
                            33.11762
                        ],
                        [
                            46.19939,
                            33.19154
                        ],
                        [
                            46.1905,
                            33.26323
                        ],
                        [
                            46.07734,
                            33.35876
                        ],
                        [
                            46.04143,
                            33.45605
                        ],
                        [
                            45.95771,
                            33.56962
                        ],
                        [
                            45.86957,
                            33.63376
                        ],
                        [
                            45.77097,
                            33.63683
                        ],
                        [
                            45.63966,
                            33.74476
                        ],
                        [
                            45.50299,
                            33.95311
                        ],
                        [
                            45.41155,
                            33.97755
                        ],
                        [
                            45.47467,
                            34.02402
                        ],
                        [
                            45.47467,
                            34.07577
                        ],
                        [
                            45.57994,
                            34.14743
                        ],
                        [
                            45.55634,
                            34.1957
                        ],
                        [
                            45.58559,
                            34.29124
                        ],
                        [
                            45.54008,
                            34.35044
                        ],
                        [
                            45.49688,
                            34.33888
                        ],
                        [
                            45.44118,
                            34.45856
                        ],
                        [
                            45.50742,
                            34.47324
                        ],
                        [
                            45.53148,
                            34.60151
                        ],
                        [
                            45.60493,
                            34.55038
                        ],
                        [
                            45.73945,
                            34.58399
                        ],
                        [
                            45.70126,
                            34.6941
                        ],
                        [
                            45.65453,
                            34.72347
                        ],
                        [
                            45.72673,
                            34.83852
                        ],
                        [
                            45.86397,
                            34.89788
                        ],
                        [
                            45.89615,
                            34.95796
                        ],
                        [
                            45.87732,
                            35.03196
                        ],
                        [
                            45.94976,
                            35.08827
                        ],
                        [
                            46.05197,
                            35.05061
                        ],
                        [
                            46.18792,
                            35.11066
                        ],
                        [
                            46.19547,
                            35.18803
                        ],
                        [
                            46.1243,
                            35.33523
                        ],
                        [
                            46.06805,
                            35.37127
                        ],
                        [
                            45.98715,
                            35.49453
                        ],
                        [
                            46.0097,
                            35.5744
                        ],
                        [
                            46.0099,
                            35.67358
                        ],
                        [
                            46.16139,
                            35.69031
                        ],
                        [
                            46.2775,
                            35.73084
                        ],
                        [
                            46.34623,
                            35.78969
                        ],
                        [
                            46.29339,
                            35.83412
                        ],
                        [
                            46.21441,
                            35.79784
                        ],
                        [
                            46.15383,
                            35.80849
                        ],
                        [
                            46.08931,
                            35.86901
                        ],
                        [
                            46.02631,
                            35.8377
                        ],
                        [
                            45.75776,
                            35.80742
                        ],
                        [
                            45.66519,
                            35.9263
                        ],
                        [
                            45.55409,
                            35.99663
                        ],
                        [
                            45.3439,
                            36.00744
                        ],
                        [
                            45.38018,
                            36.08346
                        ],
                        [
                            45.32881,
                            36.14159
                        ],
                        [
                            45.33532,
                            36.20394
                        ],
                        [
                            45.2625,
                            36.30381
                        ],
                        [
                            45.27111,
                            36.3911
                        ],
                        [
                            45.23374,
                            36.4311
                        ],
                        [
                            45.11598,
                            36.40648
                        ],
                        [
                            45.05194,
                            36.50574
                        ],
                        [
                            45.01651,
                            36.51873
                        ],
                        [
                            45.06488,
                            36.6878
                        ],
                        [
                            45.02949,
                            36.74051
                        ],
                        [
                            44.94158,
                            36.78432
                        ],
                        [
                            44.83788,
                            36.7985
                        ],
                        [
                            44.89862,
                            36.8561
                        ],
                        [
                            44.88382,
                            36.95562
                        ],
                        [
                            44.90084,
                            37.02163
                        ],
                        [
                            44.80714,
                            37.04528
                        ],
                        [
                            44.75126,
                            37.11335
                        ],
                        [
                            44.79315,
                            37.17628
                        ],
                        [
                            44.64409,
                            37.18814
                        ],
                        [
                            44.48767,
                            37.09011
                        ],
                        [
                            44.35037,
                            37.03807
                        ],
                        [
                            44.31824,
                            36.97179
                        ],
                        [
                            44.257,
                            36.98644
                        ],
                        [
                            44.19656,
                            37.0963
                        ],
                        [
                            44.26238,
                            37.16426
                        ],
                        [
                            44.23063,
                            37.27574
                        ],
                        [
                            44.11832,
                            37.3156
                        ],
                        [
                            44.01095,
                            37.31793
                        ],
                        [
                            43.9129,
                            37.2271
                        ],
                        [
                            43.62146,
                            37.23027
                        ],
                        [
                            43.49055,
                            37.25124
                        ],
                        [
                            43.15771,
                            37.37338
                        ],
                        [
                            42.95922,
                            37.32379
                        ],
                        [
                            42.78669,
                            37.38304
                        ],
                        [
                            42.72385,
                            37.35073
                        ],
                        [
                            42.57898,
                            37.15411
                        ],
                        [
                            42.35569,
                            37.10804
                        ],
                        [
                            42.3846,
                            37.06708
                        ],
                        [
                            42.24932,
                            36.95775
                        ],
                        [
                            41.93809,
                            36.67005
                        ],
                        [
                            41.82807,
                            36.59313
                        ],
                        [
                            41.70674,
                            36.56747
                        ],
                        [
                            41.41129,
                            36.52287
                        ],
                        [
                            41.29461,
                            36.35626
                        ],
                        [
                            41.29177,
                            36.26345
                        ],
                        [
                            41.25805,
                            36.05459
                        ],
                        [
                            41.38105,
                            35.83529
                        ],
                        [
                            41.39427,
                            35.63038
                        ],
                        [
                            41.28264,
                            35.48615
                        ],
                        [
                            41.2749,
                            35.38491
                        ],
                        [
                            41.24244,
                            35.28559
                        ],
                        [
                            41.21812,
                            35.13218
                        ],
                        [
                            41.23433,
                            34.77704
                        ],
                        [
                            41.13945,
                            34.66411
                        ],
                        [
                            41.01231,
                            34.41988
                        ],
                        [
                            40.63698,
                            34.24313
                        ],
                        [
                            39.90536,
                            33.89867
                        ],
                        [
                            39.19727,
                            33.56532
                        ],
                        [
                            38.7925,
                            33.37472
                        ],
                        [
                            39.08523,
                            32.50347
                        ],
                        [
                            38.98681,
                            32.47681
                        ],
                        [
                            39.04304,
                            32.30622
                        ],
                        [
                            39.25567,
                            32.35432
                        ],
                        [
                            39.30028,
                            32.23018
                        ],
                        [
                            39.20094,
                            32.15433
                        ],
                        [
                            39.79102,
                            32.05549
                        ],
                        [
                            40.41331,
                            31.94805
                        ],
                        [
                            40.93185,
                            31.65986
                        ],
                        [
                            41.44081,
                            31.37318
                        ],
                        [
                            42.08558,
                            31.11167
                        ],
                        [
                            42.7836,
                            30.61738
                        ],
                        [
                            43.30307,
                            30.24366
                        ],
                        [
                            43.81722,
                            29.86853
                        ],
                        [
                            44.42686,
                            29.41796
                        ],
                        [
                            44.72188,
                            29.19849
                        ],
                        [
                            45.58497,
                            29.13172
                        ],
                        [
                            46.42582,
                            29.06123
                        ],
                        [
                            46.55304,
                            29.10117
                        ],
                        [
                            46.67135,
                            29.20765
                        ],
                        [
                            46.78494,
                            29.35592
                        ],
                        [
                            46.86671,
                            29.43785
                        ],
                        [
                            46.90523,
                            29.52544
                        ],
                        [
                            46.99785,
                            29.66346
                        ],
                        [
                            47.0075,
                            29.72292
                        ],
                        [
                            47.08137,
                            29.8512
                        ],
                        [
                            47.13946,
                            29.98653
                        ],
                        [
                            47.1726,
                            30.01747
                        ],
                        [
                            47.37131,
                            30.1037
                        ],
                        [
                            47.70768,
                            30.1037
                        ],
                        [
                            47.95914,
                            30.00375
                        ],
                        [
                            48.01771,
                            30.00301
                        ],
                        [
                            48.09243,
                            30.04179
                        ],
                        [
                            48.23104,
                            30.02459
                        ],
                        [
                            48.40203,
                            29.92744
                        ],
                        [
                            48.48731,
                            29.90959
                        ],
                        [
                            48.48442,
                            29.97912
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "IRL",
                "Country": "Ireland",
                "Total_3GHG": 0.06,
                "Total_3GHG_timeseries": [
                    -0.0000052823,
                    0,
                    0,
                    0,
                    0,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    0,
                    -0.0000018003,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001
                ],
                "Fossil_3GHG": 0.09,
                "Fossil_3GHG_timeseries": [
                    -0.0000021952,
                    -0.0000047847,
                    -0.0000076936,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    -0.0000053822,
                    2.0447e-06,
                    9.8884e-06,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [
                    -0.0000030871,
                    -0.0000080094,
                    0,
                    0,
                    0,
                    0,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    -0.0000034476,
                    5.8649e-06,
                    0
                ],
                "Total_CO2": 0.1,
                "Total_CO2_timeseries": [
                    2.6533e-06,
                    4.957e-06,
                    7.2136e-06,
                    9.5524e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012
                ],
                "Fossil_CO2": 0.13,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.584e-07,
                    3.168e-07,
                    3.168e-07,
                    3.168e-07,
                    3.168e-07,
                    3.168e-07,
                    3.168e-07,
                    3.168e-07,
                    3.168e-07,
                    3.168e-07,
                    3.168e-07,
                    3.168e-07,
                    3.168e-07,
                    3.168e-07,
                    3.168e-07,
                    3.168e-07,
                    3.168e-07,
                    3.168e-07,
                    3.168e-07,
                    3.168e-07,
                    3.168e-07,
                    3.168e-07,
                    3.168e-07,
                    3.168e-07,
                    3.168e-07,
                    3.168e-07,
                    3.168e-07,
                    3.168e-07,
                    3.168e-07,
                    3.168e-07,
                    4.1415e-07,
                    4.1415e-07,
                    4.1415e-07,
                    5.148e-07,
                    6.27e-07,
                    7.293e-07,
                    8.382e-07,
                    9.537e-07,
                    1.0643e-06,
                    1.1764e-06,
                    1.3084e-06,
                    1.4157e-06,
                    1.4157e-06,
                    1.4157e-06,
                    4.427e-06,
                    7.1445e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001
                ],
                "Land_CO2": 0.04,
                "Land_CO2_timeseries": [
                    2.6533e-06,
                    4.957e-06,
                    7.2136e-06,
                    9.5524e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_CH4": -0.13,
                "Total_CH4_timeseries": [
                    -0.0000081396,
                    0,
                    0,
                    0,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0008,
                    -0.0008,
                    -0.0008,
                    -0.0008,
                    -0.0008,
                    -0.0008,
                    -0.0008,
                    -0.0008,
                    -0.0008,
                    -0.0008,
                    -0.0008,
                    -0.0008,
                    -0.0008,
                    -0.0008,
                    -0.0008,
                    -0.0008,
                    -0.0008,
                    -0.0008,
                    -0.0009,
                    -0.0009,
                    -0.0009,
                    -0.0009,
                    -0.0009,
                    -0.0009,
                    -0.0009,
                    -0.0009,
                    -0.0009,
                    -0.0008,
                    -0.0008,
                    -0.0008,
                    -0.0008,
                    -0.0008,
                    -0.0008,
                    -0.0008,
                    -0.0008,
                    -0.0008,
                    -0.0008,
                    -0.0008,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005
                ],
                "Fossil_CH4": -0.05,
                "Fossil_CH4_timeseries": [
                    -0.0000022215,
                    -0.0000048377,
                    -0.0000077735,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001
                ],
                "Land_CH4": -0.26,
                "Land_CH4_timeseries": [
                    -0.000005918,
                    0,
                    0,
                    0,
                    0,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0007,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0006,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0005,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004,
                    -0.0004
                ],
                "Total_N2O": 0.39,
                "Total_N2O_timeseries": [
                    2.0404e-07,
                    4.1195e-07,
                    6.2357e-07,
                    8.387e-07,
                    1.057e-06,
                    1.2783e-06,
                    1.502e-06,
                    1.7277e-06,
                    1.9549e-06,
                    2.1831e-06,
                    2.4118e-06,
                    2.6409e-06,
                    2.8705e-06,
                    3.1004e-06,
                    3.3306e-06,
                    3.5611e-06,
                    3.7921e-06,
                    4.0234e-06,
                    4.2551e-06,
                    4.4875e-06,
                    4.7236e-06,
                    4.9687e-06,
                    5.2269e-06,
                    5.501e-06,
                    5.7928e-06,
                    6.1025e-06,
                    6.4293e-06,
                    6.7712e-06,
                    7.1249e-06,
                    7.4858e-06,
                    7.8508e-06,
                    8.2194e-06,
                    8.591e-06,
                    8.9652e-06,
                    9.3418e-06,
                    9.7206e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_N2O": 0.16,
                "Fossil_N2O_timeseries": [
                    2.63e-08,
                    5.292e-08,
                    7.9855e-08,
                    1.071e-07,
                    1.3464e-07,
                    1.6247e-07,
                    1.9058e-07,
                    2.1894e-07,
                    2.4756e-07,
                    2.7639e-07,
                    3.0544e-07,
                    3.347e-07,
                    3.6416e-07,
                    3.9383e-07,
                    4.2371e-07,
                    4.5379e-07,
                    4.8408e-07,
                    5.1458e-07,
                    5.4529e-07,
                    5.7621e-07,
                    6.0745e-07,
                    6.3917e-07,
                    6.7152e-07,
                    7.0457e-07,
                    7.3839e-07,
                    7.7298e-07,
                    8.0832e-07,
                    8.4435e-07,
                    8.8094e-07,
                    9.1797e-07,
                    9.5533e-07,
                    9.93e-07,
                    1.031e-06,
                    1.0692e-06,
                    1.1077e-06,
                    1.1465e-06,
                    1.1855e-06,
                    1.2248e-06,
                    1.2644e-06,
                    1.3055e-06,
                    1.347e-06,
                    1.3892e-06,
                    1.432e-06,
                    1.4754e-06,
                    1.5195e-06,
                    1.5643e-06,
                    1.6098e-06,
                    1.6561e-06,
                    1.7031e-06,
                    1.7509e-06,
                    1.7995e-06,
                    1.8491e-06,
                    1.8997e-06,
                    1.9513e-06,
                    2.0041e-06,
                    2.0579e-06,
                    2.1127e-06,
                    2.1686e-06,
                    2.2253e-06,
                    2.2828e-06,
                    2.341e-06,
                    2.3999e-06,
                    2.4594e-06,
                    2.5195e-06,
                    2.5801e-06,
                    2.6413e-06,
                    2.703e-06,
                    2.7654e-06,
                    2.8284e-06,
                    2.892e-06,
                    2.9565e-06,
                    3.0218e-06,
                    3.088e-06,
                    3.1553e-06,
                    3.2236e-06,
                    3.2929e-06,
                    3.3631e-06,
                    3.4341e-06,
                    3.5058e-06,
                    3.578e-06,
                    3.6514e-06,
                    3.7271e-06,
                    3.8063e-06,
                    3.8896e-06,
                    3.9777e-06,
                    4.0709e-06,
                    4.1695e-06,
                    4.2732e-06,
                    4.3818e-06,
                    4.4948e-06,
                    4.6117e-06,
                    4.7322e-06,
                    4.8562e-06,
                    4.9839e-06,
                    5.1152e-06,
                    5.2505e-06,
                    5.3903e-06,
                    5.5351e-06,
                    5.6855e-06,
                    5.8423e-06,
                    6.0085e-06,
                    6.1886e-06,
                    6.3862e-06,
                    6.6044e-06,
                    6.8457e-06,
                    7.1117e-06,
                    7.4034e-06,
                    7.7212e-06,
                    8.0648e-06,
                    8.433e-06,
                    8.8267e-06,
                    9.2483e-06,
                    9.6998e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.48,
                "Land_N2O_timeseries": [
                    1.7774e-07,
                    3.5903e-07,
                    5.4372e-07,
                    7.316e-07,
                    9.224e-07,
                    1.1158e-06,
                    1.3114e-06,
                    1.5088e-06,
                    1.7074e-06,
                    1.9067e-06,
                    2.1063e-06,
                    2.3062e-06,
                    2.5063e-06,
                    2.7065e-06,
                    2.9069e-06,
                    3.1074e-06,
                    3.308e-06,
                    3.5088e-06,
                    3.7099e-06,
                    3.9113e-06,
                    4.1161e-06,
                    4.3295e-06,
                    4.5554e-06,
                    4.7965e-06,
                    5.0544e-06,
                    5.3295e-06,
                    5.621e-06,
                    5.9269e-06,
                    6.2439e-06,
                    6.5678e-06,
                    6.8955e-06,
                    7.2264e-06,
                    7.56e-06,
                    7.896e-06,
                    8.2341e-06,
                    8.5741e-06,
                    8.9161e-06,
                    9.2602e-06,
                    9.6067e-06,
                    9.9119e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -7.25607,
                                55.06703
                            ],
                            [
                                -7.16639,
                                55.14392
                            ],
                            [
                                -6.9513,
                                55.21024
                            ],
                            [
                                -6.95676,
                                55.25368
                            ],
                            [
                                -7.15678,
                                55.2972
                            ],
                            [
                                -7.1901,
                                55.34533
                            ],
                            [
                                -7.33187,
                                55.36837
                            ],
                            [
                                -7.38326,
                                55.29327
                            ],
                            [
                                -7.48017,
                                55.28178
                            ],
                            [
                                -7.54811,
                                55.20144
                            ],
                            [
                                -7.70177,
                                55.24846
                            ],
                            [
                                -7.86505,
                                55.2268
                            ],
                            [
                                -7.95804,
                                55.18632
                            ],
                            [
                                -8.17766,
                                55.14722
                            ],
                            [
                                -8.28415,
                                55.1582
                            ],
                            [
                                -8.31537,
                                55.0762
                            ],
                            [
                                -8.45609,
                                54.99891
                            ],
                            [
                                -8.37909,
                                54.9397
                            ],
                            [
                                -8.49902,
                                54.84545
                            ],
                            [
                                -8.53726,
                                54.76531
                            ],
                            [
                                -8.60359,
                                54.77868
                            ],
                            [
                                -8.74316,
                                54.73726
                            ],
                            [
                                -8.76988,
                                54.65691
                            ],
                            [
                                -8.67747,
                                54.6199
                            ],
                            [
                                -8.34223,
                                54.63069
                            ],
                            [
                                -8.22101,
                                54.56844
                            ],
                            [
                                -8.28817,
                                54.47905
                            ],
                            [
                                -8.45143,
                                54.46086
                            ],
                            [
                                -8.48968,
                                54.41882
                            ],
                            [
                                -8.66423,
                                54.36282
                            ],
                            [
                                -8.5556,
                                54.34165
                            ],
                            [
                                -8.59363,
                                54.28267
                            ],
                            [
                                -8.82347,
                                54.25333
                            ],
                            [
                                -8.94785,
                                54.29431
                            ],
                            [
                                -9.05305,
                                54.2941
                            ],
                            [
                                -9.10036,
                                54.21213
                            ],
                            [
                                -9.2145,
                                54.21234
                            ],
                            [
                                -9.20772,
                                54.27657
                            ],
                            [
                                -9.34658,
                                54.3191
                            ],
                            [
                                -9.66107,
                                54.3137
                            ],
                            [
                                -9.807,
                                54.34161
                            ],
                            [
                                -9.87718,
                                54.25562
                            ],
                            [
                                -9.99514,
                                54.30374
                            ],
                            [
                                -10.0769,
                                54.26946
                            ],
                            [
                                -10.043,
                                54.19283
                            ],
                            [
                                -9.95285,
                                54.19566
                            ],
                            [
                                -9.92877,
                                54.11989
                            ],
                            [
                                -9.98212,
                                54.10576
                            ],
                            [
                                -9.84938,
                                53.96977
                            ],
                            [
                                -9.90588,
                                53.95374
                            ],
                            [
                                -9.90365,
                                53.86365
                            ],
                            [
                                -9.68458,
                                53.89993
                            ],
                            [
                                -9.57778,
                                53.86562
                            ],
                            [
                                -9.61724,
                                53.81378
                            ],
                            [
                                -9.70731,
                                53.77788
                            ],
                            [
                                -9.90041,
                                53.76352
                            ],
                            [
                                -9.91888,
                                53.68977
                            ],
                            [
                                -9.87431,
                                53.63245
                            ],
                            [
                                -9.9945,
                                53.61028
                            ],
                            [
                                -10.14658,
                                53.54131
                            ],
                            [
                                -10.01175,
                                53.38174
                            ],
                            [
                                -9.86504,
                                53.38975
                            ],
                            [
                                -9.90409,
                                53.32525
                            ],
                            [
                                -9.73134,
                                53.31126
                            ],
                            [
                                -9.63807,
                                53.3869
                            ],
                            [
                                -9.59984,
                                53.28224
                            ],
                            [
                                -9.52548,
                                53.22263
                            ],
                            [
                                -9.04318,
                                53.26875
                            ],
                            [
                                -8.94472,
                                53.19206
                            ],
                            [
                                -9.00931,
                                53.14082
                            ],
                            [
                                -9.13909,
                                53.12121
                            ],
                            [
                                -9.26378,
                                53.15387
                            ],
                            [
                                -9.40732,
                                53.02031
                            ],
                            [
                                -9.43251,
                                52.96661
                            ],
                            [
                                -9.35323,
                                52.91816
                            ],
                            [
                                -9.43332,
                                52.8823
                            ],
                            [
                                -9.49828,
                                52.75053
                            ],
                            [
                                -9.62606,
                                52.73219
                            ],
                            [
                                -9.67606,
                                52.68025
                            ],
                            [
                                -9.81538,
                                52.60167
                            ],
                            [
                                -9.55332,
                                52.63632
                            ],
                            [
                                -9.31311,
                                52.5874
                            ],
                            [
                                -9.11791,
                                52.64629
                            ],
                            [
                                -8.97522,
                                52.7601
                            ],
                            [
                                -8.93507,
                                52.65498
                            ],
                            [
                                -9.29029,
                                52.57153
                            ],
                            [
                                -9.62154,
                                52.58032
                            ],
                            [
                                -9.68928,
                                52.48325
                            ],
                            [
                                -9.83804,
                                52.38883
                            ],
                            [
                                -9.84899,
                                52.27933
                            ],
                            [
                                -9.90315,
                                52.22917
                            ],
                            [
                                -10.03484,
                                52.28181
                            ],
                            [
                                -10.08303,
                                52.24963
                            ],
                            [
                                -10.25577,
                                52.27194
                            ],
                            [
                                -10.47088,
                                52.1818
                            ],
                            [
                                -10.45155,
                                52.09723
                            ],
                            [
                                -9.86431,
                                52.15931
                            ],
                            [
                                -9.98024,
                                52.0521
                            ],
                            [
                                -10.25368,
                                51.9902
                            ],
                            [
                                -10.28581,
                                51.90317
                            ],
                            [
                                -10.38491,
                                51.88373
                            ],
                            [
                                -10.27525,
                                51.80689
                            ],
                            [
                                -10.09969,
                                51.75598
                            ],
                            [
                                -9.8813,
                                51.8172
                            ],
                            [
                                -9.8891,
                                51.74336
                            ],
                            [
                                -10.05778,
                                51.65119
                            ],
                            [
                                -10.03911,
                                51.58927
                            ],
                            [
                                -9.90752,
                                51.65193
                            ],
                            [
                                -9.62524,
                                51.68118
                            ],
                            [
                                -9.53077,
                                51.73018
                            ],
                            [
                                -9.44626,
                                51.69132
                            ],
                            [
                                -9.78387,
                                51.57959
                            ],
                            [
                                -9.68671,
                                51.53207
                            ],
                            [
                                -9.83764,
                                51.48207
                            ],
                            [
                                -9.7959,
                                51.45062
                            ],
                            [
                                -9.6521,
                                51.51409
                            ],
                            [
                                -9.5869,
                                51.49785
                            ],
                            [
                                -9.42518,
                                51.50512
                            ],
                            [
                                -9.3447,
                                51.46953
                            ],
                            [
                                -9.26651,
                                51.50026
                            ],
                            [
                                -8.99912,
                                51.56637
                            ],
                            [
                                -8.92102,
                                51.54076
                            ],
                            [
                                -8.86992,
                                51.59507
                            ],
                            [
                                -8.69797,
                                51.58145
                            ],
                            [
                                -8.65943,
                                51.63522
                            ],
                            [
                                -8.55086,
                                51.64282
                            ],
                            [
                                -8.29724,
                                51.7554
                            ],
                            [
                                -8.25374,
                                51.79282
                            ],
                            [
                                -8.15828,
                                51.78873
                            ],
                            [
                                -8.02401,
                                51.81934
                            ],
                            [
                                -7.91604,
                                51.87303
                            ],
                            [
                                -7.8677,
                                51.92881
                            ],
                            [
                                -7.58629,
                                51.99217
                            ],
                            [
                                -7.63572,
                                52.08145
                            ],
                            [
                                -7.36651,
                                52.13874
                            ],
                            [
                                -7.02393,
                                52.13395
                            ],
                            [
                                -6.9019,
                                52.15575
                            ],
                            [
                                -6.78552,
                                52.20485
                            ],
                            [
                                -6.68292,
                                52.21854
                            ],
                            [
                                -6.58905,
                                52.1747
                            ],
                            [
                                -6.49111,
                                52.19078
                            ],
                            [
                                -6.36175,
                                52.17384
                            ],
                            [
                                -6.31486,
                                52.24036
                            ],
                            [
                                -6.44614,
                                52.30741
                            ],
                            [
                                -6.3586,
                                52.34851
                            ],
                            [
                                -6.34695,
                                52.41532
                            ],
                            [
                                -6.19419,
                                52.56351
                            ],
                            [
                                -6.2293,
                                52.62611
                            ],
                            [
                                -6.1422,
                                52.73303
                            ],
                            [
                                -6.13875,
                                52.8022
                            ],
                            [
                                -6.06436,
                                52.86764
                            ],
                            [
                                -6.00764,
                                52.9722
                            ],
                            [
                                -6.04681,
                                52.99122
                            ],
                            [
                                -6.04222,
                                53.11981
                            ],
                            [
                                -6.10162,
                                53.2078
                            ],
                            [
                                -6.09205,
                                53.2729
                            ],
                            [
                                -6.21066,
                                53.33275
                            ],
                            [
                                -6.11406,
                                53.40652
                            ],
                            [
                                -6.13379,
                                53.46846
                            ],
                            [
                                -6.07978,
                                53.54894
                            ],
                            [
                                -6.23194,
                                53.66612
                            ],
                            [
                                -6.25133,
                                53.73115
                            ],
                            [
                                -6.23887,
                                53.86103
                            ],
                            [
                                -6.3305,
                                53.87601
                            ],
                            [
                                -6.36527,
                                53.98041
                            ],
                            [
                                -6.30204,
                                54.00986
                            ],
                            [
                                -6.16538,
                                53.97721
                            ],
                            [
                                -6.104,
                                54.00011
                            ],
                            [
                                -6.26802,
                                54.10234
                            ],
                            [
                                -6.36625,
                                54.1122
                            ],
                            [
                                -6.456,
                                54.07162
                            ],
                            [
                                -6.62378,
                                54.03655
                            ],
                            [
                                -6.66091,
                                54.06293
                            ],
                            [
                                -6.63175,
                                54.14802
                            ],
                            [
                                -6.81539,
                                54.22329
                            ],
                            [
                                -6.87662,
                                54.34616
                            ],
                            [
                                -7.02864,
                                54.42131
                            ],
                            [
                                -7.15384,
                                54.33527
                            ],
                            [
                                -7.14582,
                                54.22494
                            ],
                            [
                                -7.24898,
                                54.20341
                            ],
                            [
                                -7.33645,
                                54.11685
                            ],
                            [
                                -7.44366,
                                54.15276
                            ],
                            [
                                -7.56591,
                                54.12717
                            ],
                            [
                                -7.69328,
                                54.20501
                            ],
                            [
                                -7.85953,
                                54.21745
                            ],
                            [
                                -7.88697,
                                54.29935
                            ],
                            [
                                -7.94658,
                                54.30429
                            ],
                            [
                                -8.15599,
                                54.43795
                            ],
                            [
                                -8.04336,
                                54.48838
                            ],
                            [
                                -8.006,
                                54.54595
                            ],
                            [
                                -7.85749,
                                54.53632
                            ],
                            [
                                -7.7522,
                                54.61868
                            ],
                            [
                                -7.89245,
                                54.65663
                            ],
                            [
                                -7.85552,
                                54.72603
                            ],
                            [
                                -7.74717,
                                54.70452
                            ],
                            [
                                -7.54889,
                                54.78959
                            ],
                            [
                                -7.4423,
                                54.87416
                            ],
                            [
                                -7.44501,
                                54.93701
                            ],
                            [
                                -7.344,
                                55.05054
                            ],
                            [
                                -7.25607,
                                55.06703
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -9.96008,
                                54.01886
                            ],
                            [
                                -10.10116,
                                54.00142
                            ],
                            [
                                -9.96021,
                                53.87451
                            ],
                            [
                                -9.92514,
                                53.95474
                            ],
                            [
                                -9.96008,
                                54.01886
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "ISR",
                "Country": "Israel",
                "Total_3GHG": 0.11,
                "Total_3GHG_timeseries": [
                    1.6244e-07,
                    3.2539e-07,
                    4.8879e-07,
                    6.5262e-07,
                    8.1683e-07,
                    9.8139e-07,
                    1.1463e-06,
                    1.3114e-06,
                    1.4767e-06,
                    1.6401e-06,
                    1.7991e-06,
                    1.9541e-06,
                    2.1053e-06,
                    2.2529e-06,
                    2.3968e-06,
                    2.5373e-06,
                    2.6743e-06,
                    2.808e-06,
                    2.9383e-06,
                    3.0664e-06,
                    3.192e-06,
                    3.3154e-06,
                    3.4369e-06,
                    3.5566e-06,
                    3.6746e-06,
                    3.7909e-06,
                    3.9056e-06,
                    4.0183e-06,
                    4.129e-06,
                    4.2368e-06,
                    4.3442e-06,
                    4.4511e-06,
                    4.5577e-06,
                    4.6638e-06,
                    4.7696e-06,
                    4.8751e-06,
                    4.9802e-06,
                    5.0849e-06,
                    5.1893e-06,
                    5.2938e-06,
                    5.3976e-06,
                    5.5009e-06,
                    5.6037e-06,
                    5.7062e-06,
                    5.8082e-06,
                    5.9099e-06,
                    6.0112e-06,
                    6.1122e-06,
                    6.2129e-06,
                    6.3118e-06,
                    6.4025e-06,
                    6.4853e-06,
                    6.561e-06,
                    6.6289e-06,
                    6.6898e-06,
                    6.7435e-06,
                    6.7906e-06,
                    6.8309e-06,
                    6.8645e-06,
                    6.913e-06,
                    6.9711e-06,
                    7.0349e-06,
                    7.1024e-06,
                    7.172e-06,
                    7.2432e-06,
                    7.3151e-06,
                    7.3877e-06,
                    7.4608e-06,
                    7.534e-06,
                    7.607e-06,
                    7.6881e-06,
                    7.7776e-06,
                    7.8759e-06,
                    7.9832e-06,
                    8.0997e-06,
                    8.2252e-06,
                    8.3594e-06,
                    8.5023e-06,
                    8.6535e-06,
                    8.8441e-06,
                    9.0463e-06,
                    9.2639e-06,
                    9.4973e-06,
                    9.7405e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0005,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0009,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0015,
                    0.0014,
                    0.0013,
                    0.0012,
                    0.0012,
                    0.0011,
                    0.001,
                    0.0009,
                    0.0008,
                    0.0008,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017
                ],
                "Fossil_3GHG": 0.16,
                "Fossil_3GHG_timeseries": [
                    8.0825e-08,
                    1.6188e-07,
                    2.4316e-07,
                    3.2467e-07,
                    4.0638e-07,
                    4.8831e-07,
                    5.7043e-07,
                    6.5273e-07,
                    7.3521e-07,
                    8.1786e-07,
                    8.9846e-07,
                    9.7703e-07,
                    1.0536e-06,
                    1.1281e-06,
                    1.2006e-06,
                    1.271e-06,
                    1.3395e-06,
                    1.406e-06,
                    1.4704e-06,
                    1.5329e-06,
                    1.5933e-06,
                    1.6517e-06,
                    1.7082e-06,
                    1.7628e-06,
                    1.8156e-06,
                    1.8665e-06,
                    1.9156e-06,
                    1.9628e-06,
                    2.0082e-06,
                    2.0515e-06,
                    2.0948e-06,
                    2.1379e-06,
                    2.1809e-06,
                    2.2238e-06,
                    2.2666e-06,
                    2.3092e-06,
                    2.3517e-06,
                    2.3941e-06,
                    2.4363e-06,
                    2.4784e-06,
                    2.5204e-06,
                    2.5623e-06,
                    2.604e-06,
                    2.6456e-06,
                    2.687e-06,
                    2.7283e-06,
                    2.7694e-06,
                    2.8105e-06,
                    2.8514e-06,
                    2.8922e-06,
                    2.9259e-06,
                    2.9528e-06,
                    2.9728e-06,
                    2.9862e-06,
                    2.9929e-06,
                    2.9932e-06,
                    2.9871e-06,
                    2.9747e-06,
                    2.9561e-06,
                    2.9314e-06,
                    2.9035e-06,
                    2.8725e-06,
                    2.8383e-06,
                    2.801e-06,
                    2.7606e-06,
                    2.717e-06,
                    2.6704e-06,
                    2.6207e-06,
                    2.5679e-06,
                    2.5122e-06,
                    2.4606e-06,
                    2.413e-06,
                    2.3695e-06,
                    2.33e-06,
                    2.2944e-06,
                    2.2627e-06,
                    2.2348e-06,
                    2.2107e-06,
                    2.1903e-06,
                    2.1916e-06,
                    2.1947e-06,
                    2.2055e-06,
                    2.2263e-06,
                    2.253e-06,
                    2.2942e-06,
                    2.3339e-06,
                    2.3805e-06,
                    2.4175e-06,
                    2.463e-06,
                    2.5263e-06,
                    2.6032e-06,
                    2.7238e-06,
                    2.8543e-06,
                    3.008e-06,
                    3.2073e-06,
                    3.4869e-06,
                    3.8376e-06,
                    4.2089e-06,
                    4.6583e-06,
                    8.9563e-06,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0005,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0015,
                    0.0015,
                    0.0014,
                    0.0013,
                    0.0012,
                    0.0011,
                    0.001,
                    0.001,
                    0.0009,
                    0.0008,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016
                ],
                "Land_3GHG": 0.01,
                "Land_3GHG_timeseries": [
                    8.1619e-08,
                    1.6351e-07,
                    2.4563e-07,
                    3.2795e-07,
                    4.1045e-07,
                    4.9308e-07,
                    5.7583e-07,
                    6.5865e-07,
                    7.4152e-07,
                    8.2223e-07,
                    9.0065e-07,
                    9.7711e-07,
                    1.0518e-06,
                    1.1248e-06,
                    1.1963e-06,
                    1.2662e-06,
                    1.3348e-06,
                    1.402e-06,
                    1.4679e-06,
                    1.5334e-06,
                    1.5986e-06,
                    1.6636e-06,
                    1.7286e-06,
                    1.7937e-06,
                    1.859e-06,
                    1.9244e-06,
                    1.99e-06,
                    2.0555e-06,
                    2.1208e-06,
                    2.1853e-06,
                    2.2494e-06,
                    2.3132e-06,
                    2.3767e-06,
                    2.44e-06,
                    2.5031e-06,
                    2.5659e-06,
                    2.6284e-06,
                    2.6908e-06,
                    2.753e-06,
                    2.8153e-06,
                    2.8771e-06,
                    2.9386e-06,
                    2.9997e-06,
                    3.0606e-06,
                    3.1212e-06,
                    3.1816e-06,
                    3.2418e-06,
                    3.3017e-06,
                    3.3615e-06,
                    3.4196e-06,
                    3.4765e-06,
                    3.5325e-06,
                    3.5882e-06,
                    3.6428e-06,
                    3.6968e-06,
                    3.7503e-06,
                    3.8035e-06,
                    3.8563e-06,
                    3.9084e-06,
                    3.9816e-06,
                    4.0675e-06,
                    4.1624e-06,
                    4.264e-06,
                    4.371e-06,
                    4.4827e-06,
                    4.598e-06,
                    4.7174e-06,
                    4.8401e-06,
                    4.9661e-06,
                    5.0948e-06,
                    5.2276e-06,
                    5.3646e-06,
                    5.5064e-06,
                    5.6531e-06,
                    5.8053e-06,
                    5.9625e-06,
                    6.1246e-06,
                    6.2916e-06,
                    6.4632e-06,
                    6.6525e-06,
                    6.8516e-06,
                    7.0584e-06,
                    7.271e-06,
                    7.4875e-06,
                    7.7079e-06,
                    7.9348e-06,
                    8.1681e-06,
                    8.4068e-06,
                    8.6517e-06,
                    8.8919e-06,
                    9.1332e-06,
                    9.3791e-06,
                    9.6317e-06,
                    9.8911e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_CO2": 0.1,
                "Total_CO2_timeseries": [
                    4.2443e-08,
                    8.4799e-08,
                    1.2703e-07,
                    1.6913e-07,
                    2.1107e-07,
                    2.5285e-07,
                    2.9446e-07,
                    3.3591e-07,
                    3.7717e-07,
                    4.1609e-07,
                    4.5335e-07,
                    4.8929e-07,
                    5.2408e-07,
                    5.5786e-07,
                    5.9073e-07,
                    6.2276e-07,
                    6.5402e-07,
                    6.8455e-07,
                    7.1441e-07,
                    7.4458e-07,
                    7.7487e-07,
                    8.0516e-07,
                    8.3535e-07,
                    8.6541e-07,
                    8.9531e-07,
                    9.2502e-07,
                    9.5455e-07,
                    9.8388e-07,
                    1.013e-06,
                    1.0416e-06,
                    1.0695e-06,
                    1.097e-06,
                    1.124e-06,
                    1.1505e-06,
                    1.1767e-06,
                    1.2025e-06,
                    1.228e-06,
                    1.2531e-06,
                    1.2779e-06,
                    1.3017e-06,
                    1.3251e-06,
                    1.348e-06,
                    1.3705e-06,
                    1.3926e-06,
                    1.4144e-06,
                    1.4359e-06,
                    1.457e-06,
                    1.4778e-06,
                    1.4982e-06,
                    1.5169e-06,
                    1.5342e-06,
                    1.5505e-06,
                    1.5662e-06,
                    1.5806e-06,
                    1.5943e-06,
                    1.6072e-06,
                    1.6195e-06,
                    1.6312e-06,
                    1.642e-06,
                    1.6736e-06,
                    1.7164e-06,
                    1.7665e-06,
                    1.8218e-06,
                    1.8808e-06,
                    1.9429e-06,
                    2.0071e-06,
                    2.0736e-06,
                    2.1419e-06,
                    2.2117e-06,
                    2.2824e-06,
                    2.3549e-06,
                    2.4289e-06,
                    2.5045e-06,
                    2.5815e-06,
                    2.6602e-06,
                    2.7401e-06,
                    2.8211e-06,
                    2.9032e-06,
                    2.9862e-06,
                    3.1016e-06,
                    3.2251e-06,
                    3.3592e-06,
                    3.504e-06,
                    3.6526e-06,
                    3.8133e-06,
                    3.9692e-06,
                    4.1283e-06,
                    4.2734e-06,
                    4.423e-06,
                    4.571e-06,
                    4.7075e-06,
                    4.8641e-06,
                    5.0073e-06,
                    5.1497e-06,
                    5.2854e-06,
                    5.4465e-06,
                    5.6211e-06,
                    5.7567e-06,
                    5.9089e-06,
                    6.8694e-06,
                    8.4253e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011
                ],
                "Fossil_CO2": 0.14,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.8003e-08,
                    3.6005e-08,
                    5.8918e-08,
                    8.8377e-08,
                    1.1947e-07,
                    1.6039e-07,
                    1.9476e-07,
                    2.3076e-07,
                    2.5204e-07,
                    2.7659e-07,
                    3.0932e-07,
                    3.3551e-07,
                    3.8461e-07,
                    4.2225e-07,
                    4.6153e-07,
                    4.9426e-07,
                    5.5318e-07,
                    6.2683e-07,
                    6.6283e-07,
                    7.1684e-07,
                    1.4685e-06,
                    2.7828e-06,
                    4.4303e-06,
                    6.2494e-06,
                    8.1971e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [
                    4.2443e-08,
                    8.4799e-08,
                    1.2703e-07,
                    1.6913e-07,
                    2.1107e-07,
                    2.5285e-07,
                    2.9446e-07,
                    3.3591e-07,
                    3.7717e-07,
                    4.1609e-07,
                    4.5335e-07,
                    4.8929e-07,
                    5.2408e-07,
                    5.5786e-07,
                    5.9073e-07,
                    6.2276e-07,
                    6.5402e-07,
                    6.8455e-07,
                    7.1441e-07,
                    7.4458e-07,
                    7.7487e-07,
                    8.0516e-07,
                    8.3535e-07,
                    8.6541e-07,
                    8.9531e-07,
                    9.2502e-07,
                    9.5455e-07,
                    9.8388e-07,
                    1.013e-06,
                    1.0416e-06,
                    1.0695e-06,
                    1.097e-06,
                    1.124e-06,
                    1.1505e-06,
                    1.1767e-06,
                    1.2025e-06,
                    1.228e-06,
                    1.2531e-06,
                    1.2779e-06,
                    1.3017e-06,
                    1.3251e-06,
                    1.348e-06,
                    1.3705e-06,
                    1.3926e-06,
                    1.4144e-06,
                    1.4359e-06,
                    1.457e-06,
                    1.4778e-06,
                    1.4982e-06,
                    1.5169e-06,
                    1.5342e-06,
                    1.5505e-06,
                    1.5662e-06,
                    1.5806e-06,
                    1.5943e-06,
                    1.6072e-06,
                    1.6195e-06,
                    1.6312e-06,
                    1.642e-06,
                    1.6736e-06,
                    1.7164e-06,
                    1.7665e-06,
                    1.8218e-06,
                    1.8808e-06,
                    1.9429e-06,
                    2.0071e-06,
                    2.0736e-06,
                    2.1419e-06,
                    2.2117e-06,
                    2.2824e-06,
                    2.3549e-06,
                    2.4289e-06,
                    2.5045e-06,
                    2.5815e-06,
                    2.6602e-06,
                    2.7401e-06,
                    2.8211e-06,
                    2.9032e-06,
                    2.9862e-06,
                    3.0836e-06,
                    3.1891e-06,
                    3.3003e-06,
                    3.4156e-06,
                    3.5331e-06,
                    3.6529e-06,
                    3.7744e-06,
                    3.8976e-06,
                    4.0214e-06,
                    4.1464e-06,
                    4.2616e-06,
                    4.372e-06,
                    4.4795e-06,
                    4.5851e-06,
                    4.6882e-06,
                    4.7911e-06,
                    4.8933e-06,
                    4.9943e-06,
                    5.0939e-06,
                    5.192e-06,
                    5.4009e-06,
                    5.6425e-06,
                    5.9082e-06,
                    6.1843e-06,
                    6.4439e-06,
                    6.6744e-06,
                    6.877e-06,
                    7.0571e-06,
                    7.2022e-06,
                    7.324e-06,
                    7.4946e-06,
                    7.5846e-06,
                    7.7762e-06,
                    7.9062e-06,
                    8.0005e-06,
                    8.1683e-06,
                    8.2609e-06,
                    8.3174e-06,
                    8.3748e-06,
                    8.4317e-06,
                    8.4985e-06,
                    8.5862e-06,
                    8.7616e-06,
                    8.9369e-06,
                    9.0213e-06,
                    9.0666e-06,
                    9.1097e-06,
                    9.1443e-06,
                    9.1737e-06,
                    9.2098e-06,
                    9.2833e-06,
                    9.3484e-06,
                    9.3761e-06,
                    9.4792e-06,
                    9.5861e-06,
                    9.7225e-06,
                    9.8659e-06,
                    9.968e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_CH4": 0.13,
                "Total_CH4_timeseries": [
                    9.2065e-08,
                    1.8431e-07,
                    2.7673e-07,
                    3.6932e-07,
                    4.6209e-07,
                    5.5502e-07,
                    6.4812e-07,
                    7.4138e-07,
                    8.348e-07,
                    9.2838e-07,
                    1.0191e-06,
                    1.107e-06,
                    1.1921e-06,
                    1.2743e-06,
                    1.3538e-06,
                    1.4304e-06,
                    1.5042e-06,
                    1.5752e-06,
                    1.6434e-06,
                    1.7088e-06,
                    1.7713e-06,
                    1.8308e-06,
                    1.8873e-06,
                    1.9409e-06,
                    1.9916e-06,
                    2.0393e-06,
                    2.0841e-06,
                    2.126e-06,
                    2.165e-06,
                    2.201e-06,
                    2.2368e-06,
                    2.2723e-06,
                    2.3075e-06,
                    2.3424e-06,
                    2.377e-06,
                    2.4113e-06,
                    2.4454e-06,
                    2.4791e-06,
                    2.5126e-06,
                    2.5457e-06,
                    2.5786e-06,
                    2.6111e-06,
                    2.6432e-06,
                    2.6751e-06,
                    2.7066e-06,
                    2.7378e-06,
                    2.7687e-06,
                    2.7992e-06,
                    2.8295e-06,
                    2.8593e-06,
                    2.882e-06,
                    2.8974e-06,
                    2.9058e-06,
                    2.9073e-06,
                    2.9019e-06,
                    2.8897e-06,
                    2.8708e-06,
                    2.8454e-06,
                    2.8136e-06,
                    2.7753e-06,
                    2.7351e-06,
                    2.6928e-06,
                    2.6484e-06,
                    2.6021e-06,
                    2.5538e-06,
                    2.5035e-06,
                    2.4513e-06,
                    2.3971e-06,
                    2.341e-06,
                    2.2831e-06,
                    2.2305e-06,
                    2.1833e-06,
                    2.1415e-06,
                    2.1048e-06,
                    2.0733e-06,
                    2.047e-06,
                    2.0257e-06,
                    2.0095e-06,
                    1.9983e-06,
                    1.9921e-06,
                    1.9872e-06,
                    1.9838e-06,
                    1.9818e-06,
                    1.9813e-06,
                    1.9824e-06,
                    1.9882e-06,
                    1.9988e-06,
                    2.0142e-06,
                    2.0347e-06,
                    2.0652e-06,
                    2.1162e-06,
                    2.1877e-06,
                    2.28e-06,
                    2.3933e-06,
                    2.5579e-06,
                    2.7763e-06,
                    3.0508e-06,
                    3.384e-06,
                    3.7784e-06,
                    7.3258e-06,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0014,
                    0.0014,
                    0.0013,
                    0.0012,
                    0.0012,
                    0.0011,
                    0.001,
                    0.0009,
                    0.0008,
                    0.0007,
                    0.0006,
                    0.0004,
                    0.0004,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Fossil_CH4": 0.19,
                "Fossil_CH4_timeseries": [
                    6.3713e-08,
                    1.2746e-07,
                    1.9124e-07,
                    2.5505e-07,
                    3.1888e-07,
                    3.8274e-07,
                    4.4662e-07,
                    5.1052e-07,
                    5.7443e-07,
                    6.3835e-07,
                    7.0008e-07,
                    7.5963e-07,
                    8.1701e-07,
                    8.7221e-07,
                    9.2525e-07,
                    9.7612e-07,
                    1.0248e-06,
                    1.0714e-06,
                    1.1159e-06,
                    1.1582e-06,
                    1.1982e-06,
                    1.236e-06,
                    1.2715e-06,
                    1.3047e-06,
                    1.3357e-06,
                    1.3645e-06,
                    1.391e-06,
                    1.4153e-06,
                    1.4374e-06,
                    1.4573e-06,
                    1.4769e-06,
                    1.4961e-06,
                    1.5151e-06,
                    1.5337e-06,
                    1.5521e-06,
                    1.5701e-06,
                    1.5879e-06,
                    1.6053e-06,
                    1.6224e-06,
                    1.6393e-06,
                    1.6557e-06,
                    1.6719e-06,
                    1.6876e-06,
                    1.7031e-06,
                    1.7182e-06,
                    1.7329e-06,
                    1.7474e-06,
                    1.7614e-06,
                    1.7751e-06,
                    1.7885e-06,
                    1.7946e-06,
                    1.7935e-06,
                    1.7854e-06,
                    1.7702e-06,
                    1.7482e-06,
                    1.7194e-06,
                    1.684e-06,
                    1.6419e-06,
                    1.5934e-06,
                    1.5385e-06,
                    1.4801e-06,
                    1.4183e-06,
                    1.3531e-06,
                    1.2844e-06,
                    1.2123e-06,
                    1.1369e-06,
                    1.058e-06,
                    9.7587e-07,
                    8.9038e-07,
                    8.0161e-07,
                    7.1671e-07,
                    6.3562e-07,
                    5.5829e-07,
                    4.8465e-07,
                    4.1466e-07,
                    3.4827e-07,
                    2.8543e-07,
                    2.2609e-07,
                    1.7023e-07,
                    1.1779e-07,
                    6.6338e-08,
                    1.5935e-08,
                    -0.000000033361,
                    -0.000000081489,
                    -0.00000012839,
                    -0.00000017399,
                    -0.00000021824,
                    -0.00000026107,
                    -0.00000030241,
                    -0.00000033728,
                    -0.00000035536,
                    -0.00000035653,
                    -0.00000034068,
                    -0.00000030766,
                    -0.00000022715,
                    -0.000000096787,
                    8.5824e-08,
                    3.2311e-07,
                    6.1753e-07,
                    4.0609e-06,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0005,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0013,
                    0.0012,
                    0.0011,
                    0.001,
                    0.0009,
                    0.0008,
                    0.0007,
                    0.0006,
                    0.0005,
                    0.0004,
                    0.0004,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Land_CH4": 0.02,
                "Land_CH4_timeseries": [
                    2.8352e-08,
                    5.6848e-08,
                    8.549e-08,
                    1.1428e-07,
                    1.4321e-07,
                    1.7228e-07,
                    2.015e-07,
                    2.3087e-07,
                    2.6037e-07,
                    2.9003e-07,
                    3.1903e-07,
                    3.4738e-07,
                    3.7507e-07,
                    4.0212e-07,
                    4.2851e-07,
                    4.5424e-07,
                    4.7933e-07,
                    5.0376e-07,
                    5.2754e-07,
                    5.5066e-07,
                    5.731e-07,
                    5.9483e-07,
                    6.1588e-07,
                    6.3623e-07,
                    6.5588e-07,
                    6.7484e-07,
                    6.9311e-07,
                    7.1068e-07,
                    7.2755e-07,
                    7.4374e-07,
                    7.5994e-07,
                    7.7615e-07,
                    7.9238e-07,
                    8.0863e-07,
                    8.249e-07,
                    8.4118e-07,
                    8.5747e-07,
                    8.7379e-07,
                    8.9012e-07,
                    9.0646e-07,
                    9.2283e-07,
                    9.3921e-07,
                    9.556e-07,
                    9.7201e-07,
                    9.8844e-07,
                    1.0049e-06,
                    1.0213e-06,
                    1.0378e-06,
                    1.0543e-06,
                    1.0708e-06,
                    1.0874e-06,
                    1.1039e-06,
                    1.1205e-06,
                    1.137e-06,
                    1.1536e-06,
                    1.1703e-06,
                    1.1869e-06,
                    1.2035e-06,
                    1.2202e-06,
                    1.2369e-06,
                    1.255e-06,
                    1.2745e-06,
                    1.2954e-06,
                    1.3177e-06,
                    1.3415e-06,
                    1.3666e-06,
                    1.3932e-06,
                    1.4212e-06,
                    1.4506e-06,
                    1.4815e-06,
                    1.5138e-06,
                    1.5477e-06,
                    1.5832e-06,
                    1.6201e-06,
                    1.6587e-06,
                    1.6987e-06,
                    1.7403e-06,
                    1.7834e-06,
                    1.8281e-06,
                    1.8743e-06,
                    1.9209e-06,
                    1.9678e-06,
                    2.0151e-06,
                    2.0628e-06,
                    2.1108e-06,
                    2.1622e-06,
                    2.217e-06,
                    2.2753e-06,
                    2.3371e-06,
                    2.4025e-06,
                    2.4715e-06,
                    2.5442e-06,
                    2.6207e-06,
                    2.701e-06,
                    2.7851e-06,
                    2.8731e-06,
                    2.965e-06,
                    3.0609e-06,
                    3.1609e-06,
                    3.2649e-06,
                    3.3959e-06,
                    3.5546e-06,
                    3.741e-06,
                    3.954e-06,
                    4.1924e-06,
                    4.4521e-06,
                    4.7323e-06,
                    5.0328e-06,
                    5.3544e-06,
                    5.699e-06,
                    6.0895e-06,
                    6.4906e-06,
                    6.8952e-06,
                    7.2276e-06,
                    7.5594e-06,
                    7.864e-06,
                    8.1819e-06,
                    8.5275e-06,
                    8.8788e-06,
                    9.2359e-06,
                    9.5576e-06,
                    9.8687e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_N2O": 0.07,
                "Total_N2O_timeseries": [
                    2.7936e-08,
                    5.6284e-08,
                    8.5035e-08,
                    1.1417e-07,
                    1.4367e-07,
                    1.7351e-07,
                    2.0367e-07,
                    2.3409e-07,
                    2.6476e-07,
                    2.9562e-07,
                    3.2665e-07,
                    3.5784e-07,
                    3.8919e-07,
                    4.2069e-07,
                    4.5235e-07,
                    4.8415e-07,
                    5.1611e-07,
                    5.4823e-07,
                    5.8051e-07,
                    6.1296e-07,
                    6.4581e-07,
                    6.7945e-07,
                    7.1419e-07,
                    7.5023e-07,
                    7.8769e-07,
                    8.2661e-07,
                    8.6692e-07,
                    9.0847e-07,
                    9.5101e-07,
                    9.9421e-07,
                    1.0378e-06,
                    1.0819e-06,
                    1.1262e-06,
                    1.1709e-06,
                    1.2159e-06,
                    1.2612e-06,
                    1.3068e-06,
                    1.3527e-06,
                    1.3989e-06,
                    1.4463e-06,
                    1.494e-06,
                    1.5419e-06,
                    1.59e-06,
                    1.6385e-06,
                    1.6872e-06,
                    1.7362e-06,
                    1.7855e-06,
                    1.8352e-06,
                    1.8852e-06,
                    1.9356e-06,
                    1.9863e-06,
                    2.0374e-06,
                    2.089e-06,
                    2.141e-06,
                    2.1936e-06,
                    2.2466e-06,
                    2.3002e-06,
                    2.3543e-06,
                    2.4089e-06,
                    2.464e-06,
                    2.5196e-06,
                    2.5757e-06,
                    2.6322e-06,
                    2.6891e-06,
                    2.7465e-06,
                    2.8044e-06,
                    2.8628e-06,
                    2.9218e-06,
                    2.9813e-06,
                    3.0415e-06,
                    3.1027e-06,
                    3.1654e-06,
                    3.23e-06,
                    3.2969e-06,
                    3.3662e-06,
                    3.4381e-06,
                    3.5126e-06,
                    3.5896e-06,
                    3.6689e-06,
                    3.7503e-06,
                    3.834e-06,
                    3.9209e-06,
                    4.0115e-06,
                    4.1066e-06,
                    4.2064e-06,
                    4.3113e-06,
                    4.4214e-06,
                    4.5367e-06,
                    4.657e-06,
                    4.782e-06,
                    4.9127e-06,
                    5.0511e-06,
                    5.1986e-06,
                    5.3561e-06,
                    5.5242e-06,
                    5.7028e-06,
                    5.8914e-06,
                    6.0889e-06,
                    6.2937e-06,
                    6.5039e-06,
                    6.7185e-06,
                    6.9379e-06,
                    7.1626e-06,
                    7.3926e-06,
                    7.6281e-06,
                    7.8689e-06,
                    8.1147e-06,
                    8.3653e-06,
                    8.6201e-06,
                    8.8785e-06,
                    9.1691e-06,
                    9.4659e-06,
                    9.7868e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_N2O": 0.14,
                "Fossil_N2O_timeseries": [
                    1.7112e-08,
                    3.4421e-08,
                    5.1924e-08,
                    6.9619e-08,
                    8.75e-08,
                    1.0556e-07,
                    1.238e-07,
                    1.4221e-07,
                    1.6079e-07,
                    1.7951e-07,
                    1.9838e-07,
                    2.174e-07,
                    2.3656e-07,
                    2.5587e-07,
                    2.7533e-07,
                    2.9492e-07,
                    3.1467e-07,
                    3.3455e-07,
                    3.5459e-07,
                    3.7477e-07,
                    3.9515e-07,
                    4.158e-07,
                    4.3678e-07,
                    4.5814e-07,
                    4.799e-07,
                    5.0206e-07,
                    5.2462e-07,
                    5.4753e-07,
                    5.7077e-07,
                    5.9424e-07,
                    6.1792e-07,
                    6.418e-07,
                    6.6585e-07,
                    6.9008e-07,
                    7.1449e-07,
                    7.3907e-07,
                    7.6383e-07,
                    7.8876e-07,
                    8.1386e-07,
                    8.3919e-07,
                    8.6471e-07,
                    8.9043e-07,
                    9.1635e-07,
                    9.4248e-07,
                    9.688e-07,
                    9.9534e-07,
                    1.0221e-06,
                    1.0491e-06,
                    1.0763e-06,
                    1.1037e-06,
                    1.1313e-06,
                    1.1593e-06,
                    1.1875e-06,
                    1.2159e-06,
                    1.2447e-06,
                    1.2738e-06,
                    1.3031e-06,
                    1.3328e-06,
                    1.3627e-06,
                    1.3929e-06,
                    1.4234e-06,
                    1.4542e-06,
                    1.4853e-06,
                    1.5166e-06,
                    1.5483e-06,
                    1.5802e-06,
                    1.6123e-06,
                    1.6448e-06,
                    1.6775e-06,
                    1.7106e-06,
                    1.7438e-06,
                    1.7774e-06,
                    1.8112e-06,
                    1.8454e-06,
                    1.8798e-06,
                    1.9144e-06,
                    1.9494e-06,
                    1.9846e-06,
                    2.0201e-06,
                    2.0558e-06,
                    2.0924e-06,
                    2.1306e-06,
                    2.1713e-06,
                    2.215e-06,
                    2.2622e-06,
                    2.3131e-06,
                    2.3679e-06,
                    2.4266e-06,
                    2.4888e-06,
                    2.5542e-06,
                    2.623e-06,
                    2.6957e-06,
                    2.7727e-06,
                    2.8542e-06,
                    2.9402e-06,
                    3.0305e-06,
                    3.125e-06,
                    3.223e-06,
                    3.3239e-06,
                    3.4269e-06,
                    3.5313e-06,
                    3.637e-06,
                    3.744e-06,
                    3.8522e-06,
                    3.9617e-06,
                    4.0724e-06,
                    4.1846e-06,
                    4.2984e-06,
                    4.4139e-06,
                    4.5316e-06,
                    4.6545e-06,
                    4.7888e-06,
                    4.9408e-06,
                    5.1163e-06,
                    5.3215e-06,
                    5.5624e-06,
                    5.8447e-06,
                    6.1744e-06,
                    6.5574e-06,
                    6.8555e-06,
                    7.1637e-06,
                    7.484e-06,
                    7.8284e-06,
                    8.1874e-06,
                    8.5448e-06,
                    8.9079e-06,
                    9.281e-06,
                    9.6609e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.04,
                "Land_N2O_timeseries": [
                    1.0824e-08,
                    2.1864e-08,
                    3.3111e-08,
                    4.4552e-08,
                    5.6172e-08,
                    6.7949e-08,
                    7.9861e-08,
                    9.1879e-08,
                    1.0397e-07,
                    1.1611e-07,
                    1.2827e-07,
                    1.4044e-07,
                    1.5263e-07,
                    1.6482e-07,
                    1.7702e-07,
                    1.8923e-07,
                    2.0145e-07,
                    2.1368e-07,
                    2.2592e-07,
                    2.3819e-07,
                    2.5066e-07,
                    2.6366e-07,
                    2.7741e-07,
                    2.9209e-07,
                    3.078e-07,
                    3.2455e-07,
                    3.423e-07,
                    3.6093e-07,
                    3.8024e-07,
                    3.9996e-07,
                    4.1992e-07,
                    4.4007e-07,
                    4.6039e-07,
                    4.8085e-07,
                    5.0143e-07,
                    5.2214e-07,
                    5.4297e-07,
                    5.6393e-07,
                    5.8502e-07,
                    6.0712e-07,
                    6.2925e-07,
                    6.5142e-07,
                    6.7366e-07,
                    6.9597e-07,
                    7.1837e-07,
                    7.4086e-07,
                    7.6345e-07,
                    7.8615e-07,
                    8.0895e-07,
                    8.3188e-07,
                    8.5493e-07,
                    8.7814e-07,
                    9.0153e-07,
                    9.251e-07,
                    9.4889e-07,
                    9.7289e-07,
                    9.9711e-07,
                    1.0216e-06,
                    1.0462e-06,
                    1.0711e-06,
                    1.0962e-06,
                    1.1215e-06,
                    1.1469e-06,
                    1.1725e-06,
                    1.1983e-06,
                    1.2243e-06,
                    1.2505e-06,
                    1.277e-06,
                    1.3038e-06,
                    1.331e-06,
                    1.3589e-06,
                    1.388e-06,
                    1.4187e-06,
                    1.4515e-06,
                    1.4864e-06,
                    1.5237e-06,
                    1.5632e-06,
                    1.605e-06,
                    1.6489e-06,
                    1.6945e-06,
                    1.7417e-06,
                    1.7903e-06,
                    1.8403e-06,
                    1.8916e-06,
                    1.9442e-06,
                    1.9982e-06,
                    2.0535e-06,
                    2.1101e-06,
                    2.1682e-06,
                    2.2278e-06,
                    2.2897e-06,
                    2.3554e-06,
                    2.4259e-06,
                    2.502e-06,
                    2.5841e-06,
                    2.6723e-06,
                    2.7664e-06,
                    2.8659e-06,
                    2.9698e-06,
                    3.077e-06,
                    3.1872e-06,
                    3.3009e-06,
                    3.4186e-06,
                    3.5404e-06,
                    3.6664e-06,
                    3.7964e-06,
                    3.9301e-06,
                    4.067e-06,
                    4.2062e-06,
                    4.3469e-06,
                    4.5146e-06,
                    4.6771e-06,
                    4.846e-06,
                    5.0132e-06,
                    5.1833e-06,
                    5.3489e-06,
                    5.5318e-06,
                    5.7139e-06,
                    5.9033e-06,
                    6.1e-06,
                    6.3072e-06,
                    6.5204e-06,
                    6.7315e-06,
                    6.9632e-06,
                    7.2319e-06,
                    7.5054e-06,
                    7.7933e-06,
                    8.0798e-06,
                    8.3636e-06,
                    8.6634e-06,
                    8.9251e-06,
                    9.2393e-06,
                    9.589e-06,
                    9.9358e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            35.47596,
                            31.49051
                        ],
                        [
                            35.40134,
                            31.49375
                        ],
                        [
                            35.22778,
                            31.37521
                        ],
                        [
                            35.14635,
                            31.35821
                        ],
                        [
                            34.92841,
                            31.34551
                        ],
                        [
                            34.87955,
                            31.39774
                        ],
                        [
                            34.94637,
                            31.50372
                        ],
                        [
                            34.9577,
                            31.58968
                        ],
                        [
                            34.99979,
                            31.65019
                        ],
                        [
                            35.11894,
                            31.70956
                        ],
                        [
                            35.1655,
                            31.80506
                        ],
                        [
                            35.05001,
                            31.84411
                        ],
                        [
                            34.99258,
                            31.93338
                        ],
                        [
                            35.00307,
                            32.0268
                        ],
                        [
                            34.98819,
                            32.14412
                        ],
                        [
                            34.961,
                            32.17567
                        ],
                        [
                            35.01956,
                            32.23669
                        ],
                        [
                            35.01613,
                            32.33341
                        ],
                        [
                            35.06855,
                            32.45284
                        ],
                        [
                            35.22439,
                            32.55068
                        ],
                        [
                            35.25086,
                            32.5248
                        ],
                        [
                            35.4009,
                            32.50144
                        ],
                        [
                            35.41296,
                            32.43138
                        ],
                        [
                            35.55512,
                            32.389
                        ],
                        [
                            35.57878,
                            32.4895
                        ],
                        [
                            35.56726,
                            32.64089
                        ],
                        [
                            35.67163,
                            32.69106
                        ],
                        [
                            35.62471,
                            32.91866
                        ],
                        [
                            35.63038,
                            33.01576
                        ],
                        [
                            35.67968,
                            33.24722
                        ],
                        [
                            35.62444,
                            33.24235
                        ],
                        [
                            35.56351,
                            33.2729
                        ],
                        [
                            35.50356,
                            33.08957
                        ],
                        [
                            35.35436,
                            33.05735
                        ],
                        [
                            35.31725,
                            33.10487
                        ],
                        [
                            35.19336,
                            33.08525
                        ],
                        [
                            35.10342,
                            33.0936
                        ],
                        [
                            35.05898,
                            32.8448
                        ],
                        [
                            34.95565,
                            32.82766
                        ],
                        [
                            34.94509,
                            32.71931
                        ],
                        [
                            34.82137,
                            32.23325
                        ],
                        [
                            34.70614,
                            31.93615
                        ],
                        [
                            34.5695,
                            31.69926
                        ],
                        [
                            34.49086,
                            31.59587
                        ],
                        [
                            34.56529,
                            31.54315
                        ],
                        [
                            34.38351,
                            31.39265
                        ],
                        [
                            34.37355,
                            31.30794
                        ],
                        [
                            34.26884,
                            31.22053
                        ],
                        [
                            34.40748,
                            30.85356
                        ],
                        [
                            34.50139,
                            30.67453
                        ],
                        [
                            34.5196,
                            30.52963
                        ],
                        [
                            34.5586,
                            30.4929
                        ],
                        [
                            34.54434,
                            30.4105
                        ],
                        [
                            34.61354,
                            30.36806
                        ],
                        [
                            34.82865,
                            29.80336
                        ],
                        [
                            34.88032,
                            29.64185
                        ],
                        [
                            34.86739,
                            29.5984
                        ],
                        [
                            34.9051,
                            29.49315
                        ],
                        [
                            34.97819,
                            29.54182
                        ],
                        [
                            35.01398,
                            29.63889
                        ],
                        [
                            35.03113,
                            29.77582
                        ],
                        [
                            35.08424,
                            29.88577
                        ],
                        [
                            35.10128,
                            30.01354
                        ],
                        [
                            35.14477,
                            30.06349
                        ],
                        [
                            35.14625,
                            30.28246
                        ],
                        [
                            35.19093,
                            30.34817
                        ],
                        [
                            35.16198,
                            30.43899
                        ],
                        [
                            35.20408,
                            30.58213
                        ],
                        [
                            35.336,
                            30.80111
                        ],
                        [
                            35.35272,
                            30.90637
                        ],
                        [
                            35.41433,
                            30.94984
                        ],
                        [
                            35.45124,
                            31.16263
                        ],
                        [
                            35.40494,
                            31.22779
                        ],
                        [
                            35.41331,
                            31.29145
                        ],
                        [
                            35.47361,
                            31.4134
                        ],
                        [
                            35.47596,
                            31.49051
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "ITA",
                "Country": "Italy",
                "Total_3GHG": 0.88,
                "Total_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0039,
                    0.004,
                    0.0042,
                    0.0044,
                    0.0046,
                    0.0048,
                    0.005,
                    0.0052,
                    0.0054,
                    0.0056,
                    0.0058,
                    0.006,
                    0.0062,
                    0.0064,
                    0.0066,
                    0.0068,
                    0.007,
                    0.0072,
                    0.0073,
                    0.0075,
                    0.0077,
                    0.0079,
                    0.0081,
                    0.0083,
                    0.0084,
                    0.0087,
                    0.0089,
                    0.0091,
                    0.0093,
                    0.0094,
                    0.0096,
                    0.0099,
                    0.0101,
                    0.0103,
                    0.0105,
                    0.0107,
                    0.0109,
                    0.0111,
                    0.0114,
                    0.0116,
                    0.0118,
                    0.012,
                    0.0122,
                    0.0124,
                    0.0126,
                    0.0128,
                    0.0129,
                    0.0131,
                    0.0133,
                    0.0134,
                    0.0135,
                    0.0137,
                    0.0138,
                    0.0139,
                    0.014,
                    0.0142,
                    0.0143,
                    0.0144
                ],
                "Fossil_3GHG": 1.23,
                "Fossil_3GHG_timeseries": [
                    2.2428e-06,
                    4.4997e-06,
                    6.7681e-06,
                    9.0465e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0026,
                    0.0028,
                    0.003,
                    0.0031,
                    0.0033,
                    0.0035,
                    0.0038,
                    0.004,
                    0.0042,
                    0.0044,
                    0.0046,
                    0.0048,
                    0.005,
                    0.0052,
                    0.0054,
                    0.0056,
                    0.0058,
                    0.0059,
                    0.0061,
                    0.0063,
                    0.0065,
                    0.0067,
                    0.0069,
                    0.0071,
                    0.0073,
                    0.0075,
                    0.0077,
                    0.008,
                    0.0082,
                    0.0084,
                    0.0086,
                    0.0088,
                    0.0091,
                    0.0093,
                    0.0095,
                    0.0098,
                    0.01,
                    0.0102,
                    0.0105,
                    0.0107,
                    0.0109,
                    0.0111,
                    0.0113,
                    0.0115,
                    0.0117,
                    0.0118,
                    0.012,
                    0.0121,
                    0.0123,
                    0.0124,
                    0.0126,
                    0.0127,
                    0.0128,
                    0.0129,
                    0.0131
                ],
                "Land_3GHG": 0.23,
                "Land_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014
                ],
                "Total_CO2": 1.0,
                "Total_CO2_timeseries": [
                    7.0311e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0035,
                    0.0036,
                    0.0038,
                    0.0039,
                    0.0041,
                    0.0043,
                    0.0044,
                    0.0046,
                    0.0047,
                    0.0049,
                    0.005,
                    0.0052,
                    0.0053,
                    0.0055,
                    0.0057,
                    0.0059,
                    0.006,
                    0.0062,
                    0.0064,
                    0.0066,
                    0.0068,
                    0.007,
                    0.0072,
                    0.0074,
                    0.0076,
                    0.0078,
                    0.008,
                    0.0082,
                    0.0084,
                    0.0086,
                    0.0088,
                    0.009,
                    0.0092,
                    0.0094,
                    0.0096,
                    0.0098,
                    0.0099,
                    0.0101,
                    0.0102,
                    0.0104,
                    0.0105,
                    0.0107,
                    0.0108,
                    0.0109,
                    0.0111,
                    0.0112,
                    0.0114
                ],
                "Fossil_CO2": 1.47,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.32e-08,
                    3.1515e-07,
                    8.679e-07,
                    1.3497e-06,
                    2.0724e-06,
                    2.6449e-06,
                    3.3099e-06,
                    3.9716e-06,
                    4.7355e-06,
                    5.5787e-06,
                    6.7848e-06,
                    7.8243e-06,
                    9.1641e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0022,
                    0.0023,
                    0.0025,
                    0.0026,
                    0.0028,
                    0.003,
                    0.0031,
                    0.0033,
                    0.0035,
                    0.0036,
                    0.0038,
                    0.004,
                    0.0041,
                    0.0043,
                    0.0045,
                    0.0046,
                    0.0048,
                    0.005,
                    0.0051,
                    0.0053,
                    0.0055,
                    0.0057,
                    0.0059,
                    0.0061,
                    0.0063,
                    0.0065,
                    0.0067,
                    0.0069,
                    0.0071,
                    0.0074,
                    0.0076,
                    0.0078,
                    0.008,
                    0.0082,
                    0.0085,
                    0.0087,
                    0.0089,
                    0.0091,
                    0.0093,
                    0.0095,
                    0.0097,
                    0.0099,
                    0.0101,
                    0.0102,
                    0.0104,
                    0.0105,
                    0.0107,
                    0.0109,
                    0.011,
                    0.0111,
                    0.0113,
                    0.0114
                ],
                "Land_CO2": -0.03,
                "Land_CO2_timeseries": [
                    7.0311e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0,
                    0,
                    0,
                    1.5875e-06,
                    0,
                    0,
                    0,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001
                ],
                "Total_CH4": 0.52,
                "Total_CH4_timeseries": [
                    5.4228e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022
                ],
                "Fossil_CH4": 0.47,
                "Fossil_CH4_timeseries": [
                    1.8528e-06,
                    3.7148e-06,
                    5.5837e-06,
                    7.4579e-06,
                    9.3351e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0012,
                    0.0012
                ],
                "Land_CH4": 0.6,
                "Land_CH4_timeseries": [
                    3.57e-06,
                    7.1636e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009
                ],
                "Total_N2O": 1.1,
                "Total_N2O_timeseries": [
                    7.5823e-07,
                    1.5286e-06,
                    2.3107e-06,
                    3.1039e-06,
                    3.9077e-06,
                    4.7211e-06,
                    5.5431e-06,
                    6.3727e-06,
                    7.2084e-06,
                    8.049e-06,
                    8.8934e-06,
                    9.7414e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009
                ],
                "Fossil_N2O": 1.81,
                "Fossil_N2O_timeseries": [
                    3.9009e-07,
                    7.8493e-07,
                    1.1845e-06,
                    1.5886e-06,
                    1.9971e-06,
                    2.4099e-06,
                    2.8268e-06,
                    3.2476e-06,
                    3.6719e-06,
                    4.0997e-06,
                    4.5305e-06,
                    4.9645e-06,
                    5.4015e-06,
                    5.8416e-06,
                    6.2848e-06,
                    6.731e-06,
                    7.1802e-06,
                    7.6326e-06,
                    8.088e-06,
                    8.5466e-06,
                    9.0099e-06,
                    9.4805e-06,
                    9.9602e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Land_N2O": 0.82,
                "Land_N2O_timeseries": [
                    3.6814e-07,
                    7.4365e-07,
                    1.1262e-06,
                    1.5154e-06,
                    1.9106e-06,
                    2.3111e-06,
                    2.7163e-06,
                    3.1251e-06,
                    3.5365e-06,
                    3.9493e-06,
                    4.3628e-06,
                    4.7769e-06,
                    5.1913e-06,
                    5.6061e-06,
                    6.021e-06,
                    6.4363e-06,
                    6.8518e-06,
                    7.2677e-06,
                    7.6842e-06,
                    8.1015e-06,
                    8.5257e-06,
                    8.9677e-06,
                    9.4355e-06,
                    9.9349e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                13.71419,
                                46.5227
                            ],
                            [
                                13.56976,
                                46.54016
                            ],
                            [
                                13.50425,
                                46.5663
                            ],
                            [
                                13.31874,
                                46.55241
                            ],
                            [
                                13.1686,
                                46.5889
                            ],
                            [
                                12.92945,
                                46.61022
                            ],
                            [
                                12.85343,
                                46.60491
                            ],
                            [
                                12.77838,
                                46.64618
                            ],
                            [
                                12.57007,
                                46.65145
                            ],
                            [
                                12.38406,
                                46.71633
                            ],
                            [
                                12.30547,
                                46.83414
                            ],
                            [
                                12.21851,
                                46.87395
                            ],
                            [
                                12.12134,
                                47.007
                            ],
                            [
                                12.20487,
                                47.02698
                            ],
                            [
                                12.18628,
                                47.09175
                            ],
                            [
                                11.91707,
                                47.03262
                            ],
                            [
                                11.83534,
                                46.99309
                            ],
                            [
                                11.72776,
                                46.97353
                            ],
                            [
                                11.6272,
                                47.0133
                            ],
                            [
                                11.53854,
                                46.98408
                            ],
                            [
                                11.48029,
                                47.01079
                            ],
                            [
                                11.40217,
                                46.96514
                            ],
                            [
                                11.35909,
                                46.9902
                            ],
                            [
                                11.17518,
                                46.96318
                            ],
                            [
                                11.11458,
                                46.93064
                            ],
                            [
                                11.02225,
                                46.76541
                            ],
                            [
                                10.81431,
                                46.77568
                            ],
                            [
                                10.66737,
                                46.87549
                            ],
                            [
                                10.56907,
                                46.84221
                            ],
                            [
                                10.46965,
                                46.85491
                            ],
                            [
                                10.39374,
                                46.69015
                            ],
                            [
                                10.40321,
                                46.63669
                            ],
                            [
                                10.48582,
                                46.61668
                            ],
                            [
                                10.47159,
                                46.54399
                            ],
                            [
                                10.29707,
                                46.54972
                            ],
                            [
                                10.25795,
                                46.61043
                            ],
                            [
                                10.12934,
                                46.60586
                            ],
                            [
                                10.05214,
                                46.53202
                            ],
                            [
                                10.04264,
                                46.45298
                            ],
                            [
                                10.16553,
                                46.40885
                            ],
                            [
                                10.10508,
                                46.33331
                            ],
                            [
                                10.17652,
                                46.25828
                            ],
                            [
                                10.1232,
                                46.22424
                            ],
                            [
                                10.04462,
                                46.23054
                            ],
                            [
                                9.9955,
                                46.34261
                            ],
                            [
                                9.90783,
                                46.38051
                            ],
                            [
                                9.77027,
                                46.33599
                            ],
                            [
                                9.71415,
                                46.29271
                            ],
                            [
                                9.5345,
                                46.31172
                            ],
                            [
                                9.46786,
                                46.38953
                            ],
                            [
                                9.46504,
                                46.46945
                            ],
                            [
                                9.28274,
                                46.49669
                            ],
                            [
                                9.27453,
                                46.41885
                            ],
                            [
                                9.30014,
                                46.32646
                            ],
                            [
                                9.18352,
                                46.17053
                            ],
                            [
                                9.07252,
                                46.1181
                            ],
                            [
                                9.01782,
                                46.04977
                            ],
                            [
                                9.02204,
                                45.93809
                            ],
                            [
                                9.07645,
                                45.91076
                            ],
                            [
                                9.0318,
                                45.82514
                            ],
                            [
                                8.93141,
                                45.8598
                            ],
                            [
                                8.92484,
                                45.9037
                            ],
                            [
                                8.79309,
                                46.00811
                            ],
                            [
                                8.85459,
                                46.06159
                            ],
                            [
                                8.80791,
                                46.1004
                            ],
                            [
                                8.71394,
                                46.09727
                            ],
                            [
                                8.61379,
                                46.12173
                            ],
                            [
                                8.53682,
                                46.2037
                            ],
                            [
                                8.46868,
                                46.23289
                            ],
                            [
                                8.42774,
                                46.2983
                            ],
                            [
                                8.46396,
                                46.33301
                            ],
                            [
                                8.4658,
                                46.44263
                            ],
                            [
                                8.36365,
                                46.45046
                            ],
                            [
                                8.31874,
                                46.38613
                            ],
                            [
                                8.21145,
                                46.30958
                            ],
                            [
                                8.0813,
                                46.26028
                            ],
                            [
                                8.16455,
                                46.1829
                            ],
                            [
                                8.10823,
                                46.11163
                            ],
                            [
                                8.03476,
                                46.10084
                            ],
                            [
                                7.98909,
                                45.99593
                            ],
                            [
                                7.90868,
                                45.99694
                            ],
                            [
                                7.86408,
                                45.91675
                            ],
                            [
                                7.7351,
                                45.92399
                            ],
                            [
                                7.66506,
                                45.97521
                            ],
                            [
                                7.49882,
                                45.96169
                            ],
                            [
                                7.38248,
                                45.89697
                            ],
                            [
                                7.29444,
                                45.92178
                            ],
                            [
                                7.1181,
                                45.85976
                            ],
                            [
                                7.04489,
                                45.92241
                            ],
                            [
                                6.99831,
                                45.87353
                            ],
                            [
                                6.91339,
                                45.84135
                            ],
                            [
                                6.81959,
                                45.8362
                            ],
                            [
                                6.80908,
                                45.7254
                            ],
                            [
                                6.93093,
                                45.64632
                            ],
                            [
                                6.99953,
                                45.63947
                            ],
                            [
                                7.00002,
                                45.50467
                            ],
                            [
                                7.10472,
                                45.46845
                            ],
                            [
                                7.18404,
                                45.40691
                            ],
                            [
                                7.10984,
                                45.32694
                            ],
                            [
                                7.13601,
                                45.25499
                            ],
                            [
                                7.00237,
                                45.21977
                            ],
                            [
                                6.85222,
                                45.12776
                            ],
                            [
                                6.76826,
                                45.15944
                            ],
                            [
                                6.62743,
                                45.10254
                            ],
                            [
                                6.67293,
                                45.02088
                            ],
                            [
                                6.76362,
                                44.97018
                            ],
                            [
                                6.74952,
                                44.92299
                            ],
                            [
                                6.86409,
                                44.85068
                            ],
                            [
                                6.93137,
                                44.86368
                            ],
                            [
                                7.02415,
                                44.82304
                            ],
                            [
                                7.03054,
                                44.72945
                            ],
                            [
                                6.94844,
                                44.65474
                            ],
                            [
                                6.93259,
                                44.57397
                            ],
                            [
                                6.85389,
                                44.52808
                            ],
                            [
                                6.89655,
                                44.37528
                            ],
                            [
                                7.00805,
                                44.23621
                            ],
                            [
                                7.16334,
                                44.2075
                            ],
                            [
                                7.26237,
                                44.14816
                            ],
                            [
                                7.35825,
                                44.11682
                            ],
                            [
                                7.57122,
                                44.15268
                            ],
                            [
                                7.67124,
                                44.15665
                            ],
                            [
                                7.7176,
                                44.08282
                            ],
                            [
                                7.65161,
                                43.97418
                            ],
                            [
                                7.58747,
                                43.95479
                            ],
                            [
                                7.55955,
                                43.8974
                            ],
                            [
                                7.49819,
                                43.87084
                            ],
                            [
                                7.52983,
                                43.78401
                            ],
                            [
                                7.6728,
                                43.77662
                            ],
                            [
                                7.80657,
                                43.82296
                            ],
                            [
                                7.96567,
                                43.85206
                            ],
                            [
                                8.07131,
                                43.89063
                            ],
                            [
                                8.22611,
                                44.04505
                            ],
                            [
                                8.26921,
                                44.13914
                            ],
                            [
                                8.40601,
                                44.18158
                            ],
                            [
                                8.45505,
                                44.29046
                            ],
                            [
                                8.50932,
                                44.3285
                            ],
                            [
                                8.74753,
                                44.42621
                            ],
                            [
                                9.23084,
                                44.34782
                            ],
                            [
                                9.48127,
                                44.24013
                            ],
                            [
                                9.56949,
                                44.18239
                            ],
                            [
                                9.71668,
                                44.11809
                            ],
                            [
                                9.82268,
                                44.09663
                            ],
                            [
                                9.9631,
                                44.0381
                            ],
                            [
                                10.05992,
                                44.0289
                            ],
                            [
                                10.14348,
                                43.97542
                            ],
                            [
                                10.22773,
                                43.88764
                            ],
                            [
                                10.26827,
                                43.78621
                            ],
                            [
                                10.29918,
                                43.53434
                            ],
                            [
                                10.34195,
                                43.46501
                            ],
                            [
                                10.42472,
                                43.3988
                            ],
                            [
                                10.52825,
                                43.2316
                            ],
                            [
                                10.53943,
                                43.12025
                            ],
                            [
                                10.49818,
                                42.93799
                            ],
                            [
                                10.67479,
                                42.94996
                            ],
                            [
                                10.78636,
                                42.88897
                            ],
                            [
                                10.76076,
                                42.81107
                            ],
                            [
                                10.78609,
                                42.77445
                            ],
                            [
                                10.89856,
                                42.75709
                            ],
                            [
                                10.97767,
                                42.71866
                            ],
                            [
                                11.01484,
                                42.65633
                            ],
                            [
                                11.08389,
                                42.62786
                            ],
                            [
                                11.1231,
                                42.55757
                            ],
                            [
                                11.19077,
                                42.51544
                            ],
                            [
                                11.15682,
                                42.43405
                            ],
                            [
                                11.18908,
                                42.36417
                            ],
                            [
                                11.27054,
                                42.41886
                            ],
                            [
                                11.44994,
                                42.37767
                            ],
                            [
                                11.63239,
                                42.29535
                            ],
                            [
                                11.69622,
                                42.2345
                            ],
                            [
                                11.75497,
                                42.12607
                            ],
                            [
                                11.83613,
                                42.02936
                            ],
                            [
                                11.9158,
                                42.03896
                            ],
                            [
                                12.12475,
                                41.92643
                            ],
                            [
                                12.19009,
                                41.85545
                            ],
                            [
                                12.23121,
                                41.74105
                            ],
                            [
                                12.36567,
                                41.68932
                            ],
                            [
                                12.55283,
                                41.53404
                            ],
                            [
                                12.61842,
                                41.44802
                            ],
                            [
                                12.66659,
                                41.45669
                            ],
                            [
                                12.76336,
                                41.41089
                            ],
                            [
                                12.84493,
                                41.41406
                            ],
                            [
                                12.982,
                                41.33351
                            ],
                            [
                                13.04644,
                                41.22709
                            ],
                            [
                                13.28151,
                                41.29756
                            ],
                            [
                                13.39644,
                                41.27387
                            ],
                            [
                                13.54859,
                                41.20804
                            ],
                            [
                                13.61691,
                                41.25949
                            ],
                            [
                                13.73021,
                                41.24336
                            ],
                            [
                                13.81375,
                                41.18438
                            ],
                            [
                                13.88747,
                                41.10078
                            ],
                            [
                                13.92268,
                                41.02519
                            ],
                            [
                                13.99556,
                                40.95687
                            ],
                            [
                                14.08869,
                                40.83044
                            ],
                            [
                                14.15922,
                                40.81684
                            ],
                            [
                                14.28896,
                                40.83839
                            ],
                            [
                                14.48067,
                                40.69901
                            ],
                            [
                                14.35118,
                                40.63394
                            ],
                            [
                                14.32427,
                                40.57015
                            ],
                            [
                                14.48856,
                                40.62729
                            ],
                            [
                                14.56944,
                                40.61513
                            ],
                            [
                                14.63358,
                                40.64854
                            ],
                            [
                                14.69225,
                                40.63478
                            ],
                            [
                                14.7601,
                                40.67682
                            ],
                            [
                                14.88293,
                                40.58
                            ],
                            [
                                14.98446,
                                40.4218
                            ],
                            [
                                14.99619,
                                40.35621
                            ],
                            [
                                14.9454,
                                40.33539
                            ],
                            [
                                14.9271,
                                40.23175
                            ],
                            [
                                15.02535,
                                40.17841
                            ],
                            [
                                15.11595,
                                40.17652
                            ],
                            [
                                15.35336,
                                40.00055
                            ],
                            [
                                15.4254,
                                39.99523
                            ],
                            [
                                15.50377,
                                40.06351
                            ],
                            [
                                15.63195,
                                40.06787
                            ],
                            [
                                15.77966,
                                39.89263
                            ],
                            [
                                15.81594,
                                39.68028
                            ],
                            [
                                15.87381,
                                39.55498
                            ],
                            [
                                15.99175,
                                39.44682
                            ],
                            [
                                16.0539,
                                39.28048
                            ],
                            [
                                16.0685,
                                39.1291
                            ],
                            [
                                16.09883,
                                39.02852
                            ],
                            [
                                16.15775,
                                38.95062
                            ],
                            [
                                16.21545,
                                38.92621
                            ],
                            [
                                16.22164,
                                38.84884
                            ],
                            [
                                16.18577,
                                38.75206
                            ],
                            [
                                16.10416,
                                38.7121
                            ],
                            [
                                15.98579,
                                38.72254
                            ],
                            [
                                15.85155,
                                38.66133
                            ],
                            [
                                15.846,
                                38.61219
                            ],
                            [
                                15.928,
                                38.55012
                            ],
                            [
                                15.90356,
                                38.44083
                            ],
                            [
                                15.83579,
                                38.36205
                            ],
                            [
                                15.82509,
                                38.31486
                            ],
                            [
                                15.74997,
                                38.25723
                            ],
                            [
                                15.63631,
                                38.231
                            ],
                            [
                                15.65442,
                                38.15436
                            ],
                            [
                                15.63454,
                                38.01792
                            ],
                            [
                                15.67779,
                                37.9548
                            ],
                            [
                                15.76341,
                                37.91674
                            ],
                            [
                                16.06438,
                                37.92524
                            ],
                            [
                                16.14393,
                                38.0316
                            ],
                            [
                                16.16181,
                                38.12803
                            ],
                            [
                                16.33577,
                                38.30035
                            ],
                            [
                                16.46211,
                                38.33727
                            ],
                            [
                                16.5709,
                                38.42672
                            ],
                            [
                                16.58208,
                                38.46979
                            ],
                            [
                                16.55877,
                                38.68059
                            ],
                            [
                                16.5369,
                                38.71757
                            ],
                            [
                                16.61048,
                                38.81509
                            ],
                            [
                                16.76236,
                                38.88959
                            ],
                            [
                                16.87655,
                                38.92561
                            ],
                            [
                                16.98403,
                                38.93766
                            ],
                            [
                                17.10113,
                                38.90435
                            ],
                            [
                                17.16906,
                                38.95442
                            ],
                            [
                                17.19009,
                                39.02084
                            ],
                            [
                                17.10933,
                                39.10608
                            ],
                            [
                                17.14778,
                                39.20967
                            ],
                            [
                                17.1047,
                                39.26623
                            ],
                            [
                                17.15707,
                                39.39997
                            ],
                            [
                                17.05289,
                                39.4394
                            ],
                            [
                                17.02506,
                                39.48358
                            ],
                            [
                                16.87504,
                                39.53459
                            ],
                            [
                                16.77073,
                                39.62111
                            ],
                            [
                                16.62982,
                                39.62041
                            ],
                            [
                                16.54288,
                                39.65486
                            ],
                            [
                                16.48883,
                                39.75869
                            ],
                            [
                                16.4966,
                                39.81782
                            ],
                            [
                                16.62968,
                                39.96451
                            ],
                            [
                                16.60697,
                                40.08293
                            ],
                            [
                                16.68667,
                                40.14624
                            ],
                            [
                                16.78657,
                                40.30272
                            ],
                            [
                                16.90156,
                                40.43515
                            ],
                            [
                                17.0231,
                                40.50586
                            ],
                            [
                                17.1271,
                                40.51762
                            ],
                            [
                                17.25033,
                                40.45285
                            ],
                            [
                                17.22372,
                                40.40779
                            ],
                            [
                                17.51152,
                                40.29496
                            ],
                            [
                                17.69783,
                                40.30352
                            ],
                            [
                                17.85955,
                                40.28359
                            ],
                            [
                                17.90357,
                                40.25552
                            ],
                            [
                                17.93748,
                                40.17128
                            ],
                            [
                                18.01073,
                                40.10128
                            ],
                            [
                                18.01281,
                                39.97081
                            ],
                            [
                                18.15067,
                                39.8618
                            ],
                            [
                                18.36907,
                                39.79374
                            ],
                            [
                                18.39015,
                                39.81686
                            ],
                            [
                                18.40303,
                                39.96006
                            ],
                            [
                                18.43566,
                                40.02455
                            ],
                            [
                                18.51931,
                                40.10612
                            ],
                            [
                                18.42301,
                                40.29323
                            ],
                            [
                                18.24829,
                                40.43796
                            ],
                            [
                                18.12747,
                                40.49313
                            ],
                            [
                                18.03489,
                                40.57163
                            ],
                            [
                                18.01952,
                                40.64146
                            ],
                            [
                                17.84522,
                                40.68997
                            ],
                            [
                                17.67692,
                                40.76854
                            ],
                            [
                                17.47302,
                                40.83233
                            ],
                            [
                                17.27706,
                                40.97258
                            ],
                            [
                                17.05549,
                                41.07732
                            ],
                            [
                                16.8101,
                                41.14058
                            ],
                            [
                                16.58324,
                                41.20833
                            ],
                            [
                                16.35444,
                                41.30612
                            ],
                            [
                                16.26238,
                                41.32848
                            ],
                            [
                                15.99364,
                                41.43892
                            ],
                            [
                                15.92396,
                                41.49635
                            ],
                            [
                                15.9027,
                                41.61689
                            ],
                            [
                                16.06453,
                                41.69356
                            ],
                            [
                                16.18577,
                                41.77175
                            ],
                            [
                                16.19903,
                                41.82528
                            ],
                            [
                                16.15121,
                                41.90935
                            ],
                            [
                                16.06006,
                                41.94769
                            ],
                            [
                                15.68458,
                                41.91455
                            ],
                            [
                                15.63853,
                                41.92727
                            ],
                            [
                                15.40364,
                                41.90063
                            ],
                            [
                                15.17483,
                                41.92154
                            ],
                            [
                                15.08164,
                                41.94206
                            ],
                            [
                                14.99814,
                                42.00506
                            ],
                            [
                                14.90023,
                                42.0214
                            ],
                            [
                                14.71857,
                                42.10596
                            ],
                            [
                                14.71583,
                                42.17267
                            ],
                            [
                                14.51144,
                                42.25033
                            ],
                            [
                                14.39243,
                                42.3719
                            ],
                            [
                                14.18616,
                                42.49389
                            ],
                            [
                                14.10996,
                                42.56235
                            ],
                            [
                                14.0058,
                                42.69345
                            ],
                            [
                                13.94025,
                                42.81425
                            ],
                            [
                                13.86548,
                                43.0101
                            ],
                            [
                                13.84555,
                                43.09444
                            ],
                            [
                                13.77836,
                                43.23436
                            ],
                            [
                                13.62387,
                                43.50102
                            ],
                            [
                                13.62767,
                                43.54608
                            ],
                            [
                                13.53073,
                                43.61983
                            ],
                            [
                                13.4813,
                                43.60713
                            ],
                            [
                                13.3003,
                                43.67223
                            ],
                            [
                                13.00058,
                                43.85704
                            ],
                            [
                                12.90685,
                                43.92317
                            ],
                            [
                                12.73787,
                                43.9681
                            ],
                            [
                                12.50373,
                                44.11558
                            ],
                            [
                                12.36255,
                                44.2592
                            ],
                            [
                                12.28227,
                                44.49572
                            ],
                            [
                                12.28317,
                                44.59556
                            ],
                            [
                                12.24042,
                                44.68737
                            ],
                            [
                                12.28522,
                                44.81635
                            ],
                            [
                                12.39196,
                                44.7862
                            ],
                            [
                                12.40409,
                                44.89352
                            ],
                            [
                                12.48548,
                                44.8961
                            ],
                            [
                                12.4942,
                                44.97035
                            ],
                            [
                                12.41056,
                                45.00887
                            ],
                            [
                                12.30215,
                                45.01453
                            ],
                            [
                                12.26858,
                                45.11061
                            ],
                            [
                                12.32923,
                                45.16796
                            ],
                            [
                                12.24638,
                                45.18484
                            ],
                            [
                                12.20728,
                                45.25679
                            ],
                            [
                                12.1294,
                                45.26422
                            ],
                            [
                                12.14161,
                                45.35628
                            ],
                            [
                                12.19365,
                                45.4125
                            ],
                            [
                                12.4159,
                                45.54445
                            ],
                            [
                                12.53798,
                                45.57531
                            ],
                            [
                                12.62224,
                                45.53682
                            ],
                            [
                                12.56964,
                                45.50039
                            ],
                            [
                                12.48759,
                                45.49904
                            ],
                            [
                                12.45538,
                                45.4396
                            ],
                            [
                                12.71959,
                                45.52506
                            ],
                            [
                                12.91989,
                                45.61337
                            ],
                            [
                                13.09603,
                                45.63584
                            ],
                            [
                                13.08682,
                                45.71906
                            ],
                            [
                                13.14467,
                                45.75132
                            ],
                            [
                                13.31293,
                                45.74844
                            ],
                            [
                                13.47597,
                                45.70412
                            ],
                            [
                                13.63077,
                                45.76952
                            ],
                            [
                                13.75057,
                                45.68215
                            ],
                            [
                                13.78412,
                                45.59955
                            ],
                            [
                                13.72282,
                                45.59473
                            ],
                            [
                                13.83876,
                                45.58228
                            ],
                            [
                                13.91808,
                                45.6332
                            ],
                            [
                                13.83388,
                                45.68726
                            ],
                            [
                                13.79568,
                                45.7432
                            ],
                            [
                                13.6248,
                                45.79681
                            ],
                            [
                                13.57605,
                                45.85353
                            ],
                            [
                                13.64206,
                                45.98275
                            ],
                            [
                                13.52912,
                                45.96715
                            ],
                            [
                                13.47711,
                                46.00625
                            ],
                            [
                                13.53024,
                                46.06738
                            ],
                            [
                                13.64376,
                                46.13735
                            ],
                            [
                                13.63361,
                                46.19179
                            ],
                            [
                                13.44404,
                                46.22543
                            ],
                            [
                                13.39141,
                                46.28294
                            ],
                            [
                                13.43747,
                                46.35437
                            ],
                            [
                                13.56616,
                                46.39886
                            ],
                            [
                                13.59709,
                                46.43855
                            ],
                            [
                                13.69277,
                                46.4432
                            ],
                            [
                                13.71419,
                                46.5227
                            ]
                        ],
                        [
                            [
                                12.44806,
                                41.90082
                            ],
                            [
                                12.45125,
                                41.90628
                            ],
                            [
                                12.45784,
                                41.90155
                            ],
                            [
                                12.44806,
                                41.90082
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                15.56231,
                                38.21138
                            ],
                            [
                                15.60562,
                                38.27575
                            ],
                            [
                                15.51642,
                                38.2952
                            ],
                            [
                                15.35683,
                                38.21856
                            ],
                            [
                                15.22584,
                                38.20657
                            ],
                            [
                                15.17076,
                                38.1516
                            ],
                            [
                                15.08741,
                                38.12015
                            ],
                            [
                                15.04445,
                                38.15169
                            ],
                            [
                                14.89072,
                                38.17246
                            ],
                            [
                                14.74766,
                                38.16524
                            ],
                            [
                                14.63108,
                                38.07084
                            ],
                            [
                                14.47497,
                                38.0334
                            ],
                            [
                                14.31099,
                                38.0082
                            ],
                            [
                                13.95001,
                                38.03063
                            ],
                            [
                                13.85728,
                                37.98968
                            ],
                            [
                                13.74536,
                                37.97049
                            ],
                            [
                                13.66411,
                                37.99456
                            ],
                            [
                                13.54109,
                                38.05827
                            ],
                            [
                                13.53271,
                                38.11088
                            ],
                            [
                                13.3855,
                                38.10821
                            ],
                            [
                                13.35861,
                                38.19101
                            ],
                            [
                                13.31594,
                                38.22349
                            ],
                            [
                                13.19081,
                                38.16943
                            ],
                            [
                                13.10583,
                                38.19032
                            ],
                            [
                                13.05327,
                                38.13793
                            ],
                            [
                                13.07794,
                                38.09062
                            ],
                            [
                                12.97726,
                                38.04021
                            ],
                            [
                                12.89312,
                                38.02465
                            ],
                            [
                                12.7905,
                                38.1104
                            ],
                            [
                                12.71111,
                                38.10961
                            ],
                            [
                                12.57596,
                                38.07021
                            ],
                            [
                                12.50765,
                                38.00971
                            ],
                            [
                                12.4593,
                                37.90751
                            ],
                            [
                                12.47197,
                                37.70349
                            ],
                            [
                                12.56828,
                                37.65991
                            ],
                            [
                                12.67885,
                                37.55959
                            ],
                            [
                                12.85626,
                                37.58265
                            ],
                            [
                                12.96147,
                                37.56354
                            ],
                            [
                                13.01957,
                                37.49626
                            ],
                            [
                                13.15374,
                                37.49673
                            ],
                            [
                                13.21781,
                                37.45862
                            ],
                            [
                                13.27359,
                                37.38921
                            ],
                            [
                                13.48116,
                                37.28631
                            ],
                            [
                                13.55073,
                                37.28695
                            ],
                            [
                                13.66326,
                                37.1935
                            ],
                            [
                                13.75147,
                                37.14967
                            ],
                            [
                                13.81721,
                                37.14542
                            ],
                            [
                                13.90481,
                                37.09576
                            ],
                            [
                                14.07219,
                                37.1102
                            ],
                            [
                                14.17027,
                                37.09109
                            ],
                            [
                                14.29826,
                                37.03511
                            ],
                            [
                                14.36076,
                                36.98067
                            ],
                            [
                                14.49409,
                                36.78704
                            ],
                            [
                                14.62911,
                                36.76485
                            ],
                            [
                                14.70423,
                                36.71725
                            ],
                            [
                                14.783,
                                36.70368
                            ],
                            [
                                14.89401,
                                36.72935
                            ],
                            [
                                14.95585,
                                36.69501
                            ],
                            [
                                15.01755,
                                36.70205
                            ],
                            [
                                15.08216,
                                36.64958
                            ],
                            [
                                15.13832,
                                36.68258
                            ],
                            [
                                15.09492,
                                36.77874
                            ],
                            [
                                15.1533,
                                36.9139
                            ],
                            [
                                15.31423,
                                37.03705
                            ],
                            [
                                15.30112,
                                37.0815
                            ],
                            [
                                15.22071,
                                37.12938
                            ],
                            [
                                15.18211,
                                37.21133
                            ],
                            [
                                15.24049,
                                37.26003
                            ],
                            [
                                15.10408,
                                37.31175
                            ],
                            [
                                15.09139,
                                37.49937
                            ],
                            [
                                15.17692,
                                37.57836
                            ],
                            [
                                15.20473,
                                37.73737
                            ],
                            [
                                15.30431,
                                37.87567
                            ],
                            [
                                15.49381,
                                38.0751
                            ],
                            [
                                15.57127,
                                38.18932
                            ],
                            [
                                15.56231,
                                38.21138
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.23908,
                                41.24668
                            ],
                            [
                                9.16476,
                                41.23543
                            ],
                            [
                                9.17133,
                                41.17691
                            ],
                            [
                                9.10808,
                                41.13415
                            ],
                            [
                                9.00693,
                                41.11932
                            ],
                            [
                                8.789,
                                40.92164
                            ],
                            [
                                8.71157,
                                40.91769
                            ],
                            [
                                8.55982,
                                40.8312
                            ],
                            [
                                8.4589,
                                40.8195
                            ],
                            [
                                8.31334,
                                40.84494
                            ],
                            [
                                8.23456,
                                40.90823
                            ],
                            [
                                8.13764,
                                40.72865
                            ],
                            [
                                8.20309,
                                40.68791
                            ],
                            [
                                8.21854,
                                40.60182
                            ],
                            [
                                8.29473,
                                40.59279
                            ],
                            [
                                8.37397,
                                40.49038
                            ],
                            [
                                8.39979,
                                40.40004
                            ],
                            [
                                8.37915,
                                40.35958
                            ],
                            [
                                8.48295,
                                40.28462
                            ],
                            [
                                8.45924,
                                40.15385
                            ],
                            [
                                8.49223,
                                40.08744
                            ],
                            [
                                8.41846,
                                40.04253
                            ],
                            [
                                8.39846,
                                39.9094
                            ],
                            [
                                8.50469,
                                39.90755
                            ],
                            [
                                8.55405,
                                39.86008
                            ],
                            [
                                8.54454,
                                39.79327
                            ],
                            [
                                8.49645,
                                39.72177
                            ],
                            [
                                8.47001,
                                39.59959
                            ],
                            [
                                8.38338,
                                39.45671
                            ],
                            [
                                8.38007,
                                39.38321
                            ],
                            [
                                8.43646,
                                39.29078
                            ],
                            [
                                8.36799,
                                39.22866
                            ],
                            [
                                8.49721,
                                39.06285
                            ],
                            [
                                8.56689,
                                39.0437
                            ],
                            [
                                8.56623,
                                38.99706
                            ],
                            [
                                8.66855,
                                38.89708
                            ],
                            [
                                8.72278,
                                38.93619
                            ],
                            [
                                8.85673,
                                38.87739
                            ],
                            [
                                9.0109,
                                38.98744
                            ],
                            [
                                9.04524,
                                39.05682
                            ],
                            [
                                9.00883,
                                39.1213
                            ],
                            [
                                9.0603,
                                39.19256
                            ],
                            [
                                9.14481,
                                39.18443
                            ],
                            [
                                9.22558,
                                39.22782
                            ],
                            [
                                9.32105,
                                39.20401
                            ],
                            [
                                9.43781,
                                39.12288
                            ],
                            [
                                9.56873,
                                39.15316
                            ],
                            [
                                9.57024,
                                39.23844
                            ],
                            [
                                9.60054,
                                39.28892
                            ],
                            [
                                9.60254,
                                39.37363
                            ],
                            [
                                9.6456,
                                39.46285
                            ],
                            [
                                9.64908,
                                39.65832
                            ],
                            [
                                9.67657,
                                39.71184
                            ],
                            [
                                9.6868,
                                39.94893
                            ],
                            [
                                9.73442,
                                40.07551
                            ],
                            [
                                9.65401,
                                40.14367
                            ],
                            [
                                9.6233,
                                40.24809
                            ],
                            [
                                9.66537,
                                40.31913
                            ],
                            [
                                9.75462,
                                40.38196
                            ],
                            [
                                9.82777,
                                40.52881
                            ],
                            [
                                9.75308,
                                40.59921
                            ],
                            [
                                9.75255,
                                40.67355
                            ],
                            [
                                9.6703,
                                40.79258
                            ],
                            [
                                9.6858,
                                40.858
                            ],
                            [
                                9.56114,
                                40.91858
                            ],
                            [
                                9.61047,
                                41.00261
                            ],
                            [
                                9.52967,
                                41.02827
                            ],
                            [
                                9.56357,
                                41.11738
                            ],
                            [
                                9.52833,
                                41.14583
                            ],
                            [
                                9.43094,
                                41.14376
                            ],
                            [
                                9.41849,
                                41.17852
                            ],
                            [
                                9.29911,
                                41.19134
                            ],
                            [
                                9.23908,
                                41.24668
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                10.43665,
                                42.79972
                            ],
                            [
                                10.28666,
                                42.82317
                            ],
                            [
                                10.24311,
                                42.78797
                            ],
                            [
                                10.13812,
                                42.80771
                            ],
                            [
                                10.13643,
                                42.73315
                            ],
                            [
                                10.33831,
                                42.76387
                            ],
                            [
                                10.43665,
                                42.79972
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.37849,
                                39.10163
                            ],
                            [
                                8.35026,
                                39.07962
                            ],
                            [
                                8.40503,
                                38.96131
                            ],
                            [
                                8.47078,
                                39.0581
                            ],
                            [
                                8.37849,
                                39.10163
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                11.99183,
                                36.82218
                            ],
                            [
                                11.92854,
                                36.80169
                            ],
                            [
                                11.99324,
                                36.73792
                            ],
                            [
                                12.04999,
                                36.7989
                            ],
                            [
                                11.99183,
                                36.82218
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.30933,
                                39.18765
                            ],
                            [
                                8.226,
                                39.16157
                            ],
                            [
                                8.24761,
                                39.10858
                            ],
                            [
                                8.31016,
                                39.11329
                            ],
                            [
                                8.30933,
                                39.18765
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "JAM",
                "Country": "Jamaica",
                "Total_3GHG": 0.03,
                "Total_3GHG_timeseries": [
                    2.1398e-07,
                    5.3812e-07,
                    8.0671e-07,
                    1.0389e-06,
                    1.3192e-06,
                    1.6173e-06,
                    1.9117e-06,
                    2.1722e-06,
                    2.448e-06,
                    2.8244e-06,
                    3.3877e-06,
                    3.8059e-06,
                    4.2509e-06,
                    4.7259e-06,
                    5.2335e-06,
                    5.7702e-06,
                    6.2861e-06,
                    6.8994e-06,
                    7.4762e-06,
                    8.0981e-06,
                    8.6646e-06,
                    9.2683e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Fossil_3GHG": 0.02,
                "Fossil_3GHG_timeseries": [
                    5.1203e-08,
                    9.3661e-08,
                    1.3484e-07,
                    1.7475e-07,
                    2.1338e-07,
                    2.6138e-07,
                    3.1901e-07,
                    3.8655e-07,
                    4.6425e-07,
                    5.5241e-07,
                    6.5276e-07,
                    7.6491e-07,
                    8.8959e-07,
                    1.0266e-06,
                    1.1695e-06,
                    1.3182e-06,
                    1.4729e-06,
                    1.6336e-06,
                    1.7972e-06,
                    1.9638e-06,
                    2.1495e-06,
                    2.351e-06,
                    2.5614e-06,
                    2.7808e-06,
                    3.008e-06,
                    3.2333e-06,
                    3.4563e-06,
                    3.6757e-06,
                    3.8912e-06,
                    4.1025e-06,
                    4.3083e-06,
                    4.5216e-06,
                    4.7356e-06,
                    4.9436e-06,
                    5.1488e-06,
                    5.351e-06,
                    5.5543e-06,
                    5.7566e-06,
                    5.9637e-06,
                    6.1937e-06,
                    6.4248e-06,
                    6.6619e-06,
                    6.907e-06,
                    7.159e-06,
                    7.4178e-06,
                    7.6836e-06,
                    7.9561e-06,
                    8.2375e-06,
                    8.5288e-06,
                    8.8061e-06,
                    9.1008e-06,
                    9.4019e-06,
                    9.714e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003
                ],
                "Land_3GHG": 0.03,
                "Land_3GHG_timeseries": [
                    1.6278e-07,
                    4.4446e-07,
                    6.7187e-07,
                    8.6415e-07,
                    1.1058e-06,
                    1.3559e-06,
                    1.5927e-06,
                    1.7856e-06,
                    1.9837e-06,
                    2.272e-06,
                    2.7349e-06,
                    3.0409e-06,
                    3.3613e-06,
                    3.6993e-06,
                    4.064e-06,
                    4.452e-06,
                    4.8132e-06,
                    5.2658e-06,
                    5.679e-06,
                    6.1344e-06,
                    6.515e-06,
                    6.9173e-06,
                    7.4582e-06,
                    7.9847e-06,
                    8.4757e-06,
                    8.9062e-06,
                    9.3706e-06,
                    9.8744e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Total_CO2": 0.03,
                "Total_CO2_timeseries": [
                    1.3446e-07,
                    3.8772e-07,
                    5.866e-07,
                    7.5026e-07,
                    9.6323e-07,
                    1.1845e-06,
                    1.3924e-06,
                    1.5563e-06,
                    1.7253e-06,
                    1.9844e-06,
                    2.4155e-06,
                    2.687e-06,
                    2.9701e-06,
                    3.2681e-06,
                    3.5901e-06,
                    3.9328e-06,
                    4.2459e-06,
                    4.6478e-06,
                    5.0074e-06,
                    5.4066e-06,
                    5.7279e-06,
                    6.0677e-06,
                    6.5428e-06,
                    7.0002e-06,
                    7.419e-06,
                    7.774e-06,
                    8.1595e-06,
                    8.5813e-06,
                    8.9898e-06,
                    9.4631e-06,
                    9.9147e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_CO2": 0.03,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.221e-07,
                    3.564e-07,
                    6.1037e-07,
                    8.8738e-07,
                    1.2436e-06,
                    1.6873e-06,
                    2.2546e-06,
                    2.977e-06,
                    3.5872e-06,
                    4.4152e-06,
                    5.0764e-06,
                    6.0347e-06,
                    6.988e-06,
                    8.0668e-06,
                    9.8961e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_CO2": 0.04,
                "Land_CO2_timeseries": [
                    1.3446e-07,
                    3.8772e-07,
                    5.866e-07,
                    7.5026e-07,
                    9.6323e-07,
                    1.1845e-06,
                    1.3924e-06,
                    1.5563e-06,
                    1.7253e-06,
                    1.9844e-06,
                    2.4155e-06,
                    2.687e-06,
                    2.9701e-06,
                    3.2681e-06,
                    3.5901e-06,
                    3.9328e-06,
                    4.2459e-06,
                    4.6478e-06,
                    5.0074e-06,
                    5.4066e-06,
                    5.7279e-06,
                    6.0677e-06,
                    6.5428e-06,
                    7.0002e-06,
                    7.419e-06,
                    7.774e-06,
                    8.1595e-06,
                    8.5813e-06,
                    8.9898e-06,
                    9.4631e-06,
                    9.9147e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_CH4": 0.01,
                "Total_CH4_timeseries": [
                    6.7863e-08,
                    1.2694e-07,
                    1.8469e-07,
                    2.4113e-07,
                    2.9625e-07,
                    3.6072e-07,
                    4.3478e-07,
                    5.1871e-07,
                    6.1279e-07,
                    7.173e-07,
                    8.3662e-07,
                    9.7036e-07,
                    1.1192e-06,
                    1.2831e-06,
                    1.4554e-06,
                    1.6362e-06,
                    1.8255e-06,
                    2.0235e-06,
                    2.227e-06,
                    2.436e-06,
                    2.6673e-06,
                    2.9173e-06,
                    3.1791e-06,
                    3.4527e-06,
                    3.7372e-06,
                    4.0226e-06,
                    4.3086e-06,
                    4.5939e-06,
                    4.8783e-06,
                    5.1615e-06,
                    5.4402e-06,
                    5.7273e-06,
                    6.0163e-06,
                    6.3003e-06,
                    6.5825e-06,
                    6.8628e-06,
                    7.1452e-06,
                    7.4276e-06,
                    7.7159e-06,
                    8.0279e-06,
                    8.3422e-06,
                    8.6636e-06,
                    8.9941e-06,
                    9.3327e-06,
                    9.6793e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_CH4": 0.01,
                "Fossil_CH4_timeseries": [
                    4.1028e-08,
                    7.3195e-08,
                    1.0397e-07,
                    1.3336e-07,
                    1.6136e-07,
                    1.9862e-07,
                    2.4542e-07,
                    3.0201e-07,
                    3.6867e-07,
                    4.457e-07,
                    5.3483e-07,
                    6.3568e-07,
                    7.4896e-07,
                    8.7452e-07,
                    1.0058e-06,
                    1.1429e-06,
                    1.2859e-06,
                    1.4347e-06,
                    1.5864e-06,
                    1.7409e-06,
                    1.9146e-06,
                    2.1038e-06,
                    2.3017e-06,
                    2.5084e-06,
                    2.7227e-06,
                    2.9348e-06,
                    3.1445e-06,
                    3.3503e-06,
                    3.552e-06,
                    3.7495e-06,
                    3.9412e-06,
                    4.1403e-06,
                    4.3401e-06,
                    4.5338e-06,
                    4.7245e-06,
                    4.9122e-06,
                    5.1008e-06,
                    5.2883e-06,
                    5.4806e-06,
                    5.6954e-06,
                    5.9112e-06,
                    6.1328e-06,
                    6.3623e-06,
                    6.5984e-06,
                    6.8413e-06,
                    7.0909e-06,
                    7.347e-06,
                    7.6119e-06,
                    7.8865e-06,
                    8.1469e-06,
                    8.4244e-06,
                    8.7081e-06,
                    9.0026e-06,
                    9.3158e-06,
                    9.6505e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CH4": 0.01,
                "Land_CH4_timeseries": [
                    2.6835e-08,
                    5.3742e-08,
                    8.0721e-08,
                    1.0777e-07,
                    1.349e-07,
                    1.6209e-07,
                    1.8936e-07,
                    2.167e-07,
                    2.4412e-07,
                    2.716e-07,
                    3.0179e-07,
                    3.3468e-07,
                    3.7027e-07,
                    4.0856e-07,
                    4.4956e-07,
                    4.9326e-07,
                    5.3966e-07,
                    5.8876e-07,
                    6.4056e-07,
                    6.9507e-07,
                    7.527e-07,
                    8.1346e-07,
                    8.7734e-07,
                    9.4435e-07,
                    1.0145e-06,
                    1.0877e-06,
                    1.1641e-06,
                    1.2436e-06,
                    1.3263e-06,
                    1.412e-06,
                    1.4989e-06,
                    1.587e-06,
                    1.6762e-06,
                    1.7665e-06,
                    1.858e-06,
                    1.9506e-06,
                    2.0444e-06,
                    2.1393e-06,
                    2.2353e-06,
                    2.3325e-06,
                    2.431e-06,
                    2.5308e-06,
                    2.6319e-06,
                    2.7343e-06,
                    2.8379e-06,
                    2.9429e-06,
                    3.0492e-06,
                    3.1568e-06,
                    3.2656e-06,
                    3.3758e-06,
                    3.4874e-06,
                    3.6005e-06,
                    3.715e-06,
                    3.8311e-06,
                    3.9486e-06,
                    4.0675e-06,
                    4.188e-06,
                    4.3099e-06,
                    4.4333e-06,
                    4.5581e-06,
                    4.6849e-06,
                    4.8135e-06,
                    4.9441e-06,
                    5.0767e-06,
                    5.2111e-06,
                    5.3475e-06,
                    5.4858e-06,
                    5.626e-06,
                    5.7681e-06,
                    5.9122e-06,
                    6.0585e-06,
                    6.2069e-06,
                    6.3576e-06,
                    6.5105e-06,
                    6.6657e-06,
                    6.823e-06,
                    6.9825e-06,
                    7.1443e-06,
                    7.3083e-06,
                    7.4745e-06,
                    7.643e-06,
                    7.8138e-06,
                    7.9869e-06,
                    8.1623e-06,
                    8.34e-06,
                    8.5223e-06,
                    8.7093e-06,
                    8.9009e-06,
                    9.0973e-06,
                    9.2985e-06,
                    9.5049e-06,
                    9.7166e-06,
                    9.9337e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_N2O": 0.02,
                "Total_N2O_timeseries": [
                    1.166e-08,
                    2.3465e-08,
                    3.5414e-08,
                    4.7502e-08,
                    5.9725e-08,
                    7.2078e-08,
                    8.4554e-08,
                    9.7145e-08,
                    1.0984e-07,
                    1.2264e-07,
                    1.3553e-07,
                    1.485e-07,
                    1.6157e-07,
                    1.7472e-07,
                    1.8796e-07,
                    2.0129e-07,
                    2.1471e-07,
                    2.2822e-07,
                    2.4182e-07,
                    2.5551e-07,
                    2.6934e-07,
                    2.834e-07,
                    2.9776e-07,
                    3.1246e-07,
                    3.2753e-07,
                    3.4298e-07,
                    3.5878e-07,
                    3.7492e-07,
                    3.9133e-07,
                    4.0794e-07,
                    4.247e-07,
                    4.4161e-07,
                    4.5864e-07,
                    4.758e-07,
                    4.9308e-07,
                    5.1048e-07,
                    5.2799e-07,
                    5.4563e-07,
                    5.634e-07,
                    5.8293e-07,
                    6.0267e-07,
                    6.227e-07,
                    6.431e-07,
                    6.6391e-07,
                    6.852e-07,
                    7.0701e-07,
                    7.2938e-07,
                    7.5235e-07,
                    7.7593e-07,
                    8.0015e-07,
                    8.2519e-07,
                    8.5135e-07,
                    8.7886e-07,
                    9.0785e-07,
                    9.384e-07,
                    9.7048e-07,
                    1.004e-06,
                    1.0388e-06,
                    1.0746e-06,
                    1.111e-06,
                    1.1479e-06,
                    1.1853e-06,
                    1.2231e-06,
                    1.2613e-06,
                    1.2999e-06,
                    1.3389e-06,
                    1.3782e-06,
                    1.4179e-06,
                    1.4578e-06,
                    1.498e-06,
                    1.5384e-06,
                    1.5789e-06,
                    1.6194e-06,
                    1.6599e-06,
                    1.7004e-06,
                    1.7408e-06,
                    1.7813e-06,
                    1.8217e-06,
                    1.8623e-06,
                    1.9031e-06,
                    1.9442e-06,
                    1.9859e-06,
                    2.0282e-06,
                    2.0713e-06,
                    2.1154e-06,
                    2.1604e-06,
                    2.2064e-06,
                    2.2535e-06,
                    2.3016e-06,
                    2.3507e-06,
                    2.4017e-06,
                    2.456e-06,
                    2.5149e-06,
                    2.5793e-06,
                    2.6495e-06,
                    2.7258e-06,
                    2.808e-06,
                    2.8955e-06,
                    2.9875e-06,
                    3.0828e-06,
                    3.1813e-06,
                    3.2845e-06,
                    3.3934e-06,
                    3.5085e-06,
                    3.6304e-06,
                    3.7592e-06,
                    3.8948e-06,
                    4.0366e-06,
                    4.1839e-06,
                    4.3356e-06,
                    4.4899e-06,
                    4.6442e-06,
                    4.8002e-06,
                    4.9623e-06,
                    5.1186e-06,
                    5.2723e-06,
                    5.4425e-06,
                    5.6107e-06,
                    5.7818e-06,
                    5.9532e-06,
                    6.128e-06,
                    6.3099e-06,
                    6.4814e-06,
                    6.6566e-06,
                    6.8242e-06,
                    6.99e-06,
                    7.1498e-06,
                    7.3151e-06,
                    7.4792e-06,
                    7.6521e-06,
                    7.8276e-06,
                    7.9863e-06,
                    8.1637e-06,
                    8.3497e-06,
                    8.5214e-06,
                    8.7001e-06,
                    8.8959e-06,
                    9.0976e-06,
                    9.3076e-06,
                    9.5159e-06,
                    9.7302e-06,
                    9.95e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_N2O": 0.03,
                "Fossil_N2O_timeseries": [
                    1.0175e-08,
                    2.0466e-08,
                    3.0872e-08,
                    4.139e-08,
                    5.2019e-08,
                    6.2756e-08,
                    7.3598e-08,
                    8.454e-08,
                    9.5579e-08,
                    1.0671e-07,
                    1.1793e-07,
                    1.2924e-07,
                    1.4063e-07,
                    1.5211e-07,
                    1.6368e-07,
                    1.7533e-07,
                    1.8708e-07,
                    1.9891e-07,
                    2.1082e-07,
                    2.2283e-07,
                    2.3495e-07,
                    2.4723e-07,
                    2.597e-07,
                    2.7239e-07,
                    2.853e-07,
                    2.9845e-07,
                    3.1182e-07,
                    3.254e-07,
                    3.3917e-07,
                    3.5307e-07,
                    3.671e-07,
                    3.8123e-07,
                    3.9548e-07,
                    4.0983e-07,
                    4.2429e-07,
                    4.3884e-07,
                    4.535e-07,
                    4.6827e-07,
                    4.8314e-07,
                    4.983e-07,
                    5.1361e-07,
                    5.2909e-07,
                    5.4473e-07,
                    5.6054e-07,
                    5.7652e-07,
                    5.9269e-07,
                    6.0904e-07,
                    6.2558e-07,
                    6.4231e-07,
                    6.5925e-07,
                    6.7639e-07,
                    6.9376e-07,
                    7.1137e-07,
                    7.2922e-07,
                    7.4733e-07,
                    7.657e-07,
                    7.8433e-07,
                    8.0321e-07,
                    8.2234e-07,
                    8.4171e-07,
                    8.6131e-07,
                    8.8113e-07,
                    9.0119e-07,
                    9.2147e-07,
                    9.4197e-07,
                    9.6269e-07,
                    9.8363e-07,
                    1.0048e-06,
                    1.0262e-06,
                    1.0478e-06,
                    1.0696e-06,
                    1.0917e-06,
                    1.114e-06,
                    1.1365e-06,
                    1.1592e-06,
                    1.1822e-06,
                    1.2053e-06,
                    1.2287e-06,
                    1.2524e-06,
                    1.2763e-06,
                    1.3004e-06,
                    1.3247e-06,
                    1.3493e-06,
                    1.3742e-06,
                    1.3993e-06,
                    1.4246e-06,
                    1.4503e-06,
                    1.4762e-06,
                    1.5024e-06,
                    1.529e-06,
                    1.5559e-06,
                    1.5833e-06,
                    1.6113e-06,
                    1.64e-06,
                    1.6694e-06,
                    1.6996e-06,
                    1.7305e-06,
                    1.7622e-06,
                    1.7947e-06,
                    1.8279e-06,
                    1.8618e-06,
                    1.8967e-06,
                    1.9327e-06,
                    1.9699e-06,
                    2.0084e-06,
                    2.0482e-06,
                    2.0894e-06,
                    2.1319e-06,
                    2.1758e-06,
                    2.2209e-06,
                    2.2671e-06,
                    2.3142e-06,
                    2.3623e-06,
                    2.4113e-06,
                    2.4613e-06,
                    2.5125e-06,
                    2.565e-06,
                    2.6191e-06,
                    2.6751e-06,
                    2.7289e-06,
                    2.7837e-06,
                    2.8386e-06,
                    2.8953e-06,
                    2.9521e-06,
                    3.0075e-06,
                    3.0567e-06,
                    3.1053e-06,
                    3.1566e-06,
                    3.2047e-06,
                    3.2514e-06,
                    3.2994e-06,
                    3.3448e-06,
                    3.3916e-06,
                    3.4365e-06,
                    3.4804e-06,
                    3.5232e-06,
                    3.5679e-06,
                    3.6125e-06,
                    3.6655e-06,
                    3.7283e-06,
                    3.7917e-06,
                    3.8629e-06,
                    3.9422e-06,
                    4.0175e-06,
                    4.1048e-06,
                    4.197e-06,
                    4.2963e-06,
                    4.4012e-06,
                    4.5126e-06,
                    4.6118e-06,
                    4.7108e-06,
                    4.8144e-06,
                    4.9211e-06,
                    5.024e-06,
                    5.1256e-06,
                    5.2392e-06,
                    5.3555e-06,
                    5.4473e-06,
                    5.5314e-06,
                    5.6088e-06,
                    5.6866e-06,
                    5.7643e-06,
                    5.8398e-06,
                    5.9152e-06,
                    5.989e-06,
                    6.064e-06,
                    6.1377e-06,
                    6.2204e-06,
                    6.2928e-06,
                    6.3596e-06,
                    6.4297e-06,
                    6.5011e-06
                ],
                "Land_N2O": 0.02,
                "Land_N2O_timeseries": [
                    1.4849e-09,
                    2.9995e-09,
                    4.5425e-09,
                    6.1122e-09,
                    7.7062e-09,
                    9.3219e-09,
                    1.0956e-08,
                    1.2605e-08,
                    1.4264e-08,
                    1.5929e-08,
                    1.7597e-08,
                    1.9267e-08,
                    2.0939e-08,
                    2.2612e-08,
                    2.4286e-08,
                    2.596e-08,
                    2.7637e-08,
                    2.9314e-08,
                    3.0994e-08,
                    3.2677e-08,
                    3.4388e-08,
                    3.6171e-08,
                    3.8058e-08,
                    4.0072e-08,
                    4.2227e-08,
                    4.4525e-08,
                    4.6961e-08,
                    4.9516e-08,
                    5.2165e-08,
                    5.4871e-08,
                    5.7609e-08,
                    6.0373e-08,
                    6.3161e-08,
                    6.5968e-08,
                    6.8792e-08,
                    7.1633e-08,
                    7.449e-08,
                    7.7365e-08,
                    8.026e-08,
                    8.4627e-08,
                    8.9056e-08,
                    9.3616e-08,
                    9.8371e-08,
                    1.0338e-07,
                    1.0868e-07,
                    1.1432e-07,
                    1.2034e-07,
                    1.2677e-07,
                    1.3362e-07,
                    1.409e-07,
                    1.488e-07,
                    1.5759e-07,
                    1.6749e-07,
                    1.7863e-07,
                    1.9107e-07,
                    2.0478e-07,
                    2.1967e-07,
                    2.3556e-07,
                    2.5222e-07,
                    2.693e-07,
                    2.8662e-07,
                    3.0416e-07,
                    3.2191e-07,
                    3.3985e-07,
                    3.5795e-07,
                    3.7621e-07,
                    3.9458e-07,
                    4.1305e-07,
                    4.316e-07,
                    4.5018e-07,
                    4.6874e-07,
                    4.8717e-07,
                    5.0542e-07,
                    5.2343e-07,
                    5.4119e-07,
                    5.5868e-07,
                    5.7593e-07,
                    5.9299e-07,
                    6.0993e-07,
                    6.2682e-07,
                    6.4383e-07,
                    6.6113e-07,
                    6.7886e-07,
                    6.9716e-07,
                    7.161e-07,
                    7.3575e-07,
                    7.5615e-07,
                    7.773e-07,
                    7.9919e-07,
                    8.2176e-07,
                    8.4579e-07,
                    8.727e-07,
                    9.0359e-07,
                    9.3922e-07,
                    9.8004e-07,
                    1.0262e-06,
                    1.0774e-06,
                    1.1332e-06,
                    1.1928e-06,
                    1.2549e-06,
                    1.3196e-06,
                    1.3879e-06,
                    1.4607e-06,
                    1.5386e-06,
                    1.6221e-06,
                    1.711e-06,
                    1.8054e-06,
                    1.9046e-06,
                    2.0081e-06,
                    2.1148e-06,
                    2.2229e-06,
                    2.33e-06,
                    2.4379e-06,
                    2.551e-06,
                    2.6572e-06,
                    2.7598e-06,
                    2.8775e-06,
                    2.9916e-06,
                    3.1067e-06,
                    3.2243e-06,
                    3.3443e-06,
                    3.4713e-06,
                    3.5861e-06,
                    3.7045e-06,
                    3.8166e-06,
                    3.9333e-06,
                    4.0445e-06,
                    4.1585e-06,
                    4.2744e-06,
                    4.4006e-06,
                    4.5282e-06,
                    4.6415e-06,
                    4.7721e-06,
                    4.9132e-06,
                    5.041e-06,
                    5.1769e-06,
                    5.328e-06,
                    5.4851e-06,
                    5.6421e-06,
                    5.7876e-06,
                    5.9384e-06,
                    6.087e-06,
                    6.24e-06,
                    6.395e-06,
                    6.5507e-06,
                    6.7036e-06,
                    6.8561e-06,
                    7.0083e-06,
                    7.1644e-06,
                    7.323e-06,
                    7.48e-06,
                    7.634e-06,
                    7.7982e-06,
                    7.9564e-06,
                    8.1073e-06,
                    8.2234e-06,
                    8.3316e-06,
                    8.4423e-06,
                    8.5512e-06,
                    8.6596e-06,
                    8.7677e-06,
                    8.8827e-06,
                    8.9937e-06,
                    9.1043e-06,
                    9.2081e-06,
                    9.3139e-06,
                    9.4217e-06,
                    9.5362e-06,
                    9.6469e-06,
                    9.7559e-06,
                    9.8649e-06,
                    9.9745e-06
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -76.89724,
                            17.89174
                        ],
                        [
                            -76.83168,
                            17.982
                        ],
                        [
                            -76.66056,
                            17.93356
                        ],
                        [
                            -76.59522,
                            17.86968
                        ],
                        [
                            -76.52905,
                            17.85274
                        ],
                        [
                            -76.40603,
                            17.87919
                        ],
                        [
                            -76.34445,
                            17.86364
                        ],
                        [
                            -76.21752,
                            17.90423
                        ],
                        [
                            -76.23497,
                            17.97432
                        ],
                        [
                            -76.3363,
                            18.14997
                        ],
                        [
                            -76.37329,
                            18.17171
                        ],
                        [
                            -76.64413,
                            18.22964
                        ],
                        [
                            -76.68988,
                            18.26659
                        ],
                        [
                            -76.78068,
                            18.27524
                        ],
                        [
                            -76.8093,
                            18.33021
                        ],
                        [
                            -76.95896,
                            18.40386
                        ],
                        [
                            -77.04541,
                            18.42188
                        ],
                        [
                            -77.11131,
                            18.40998
                        ],
                        [
                            -77.17901,
                            18.44192
                        ],
                        [
                            -77.31031,
                            18.47156
                        ],
                        [
                            -77.35455,
                            18.46199
                        ],
                        [
                            -77.55282,
                            18.49116
                        ],
                        [
                            -77.68659,
                            18.49021
                        ],
                        [
                            -77.82298,
                            18.52436
                        ],
                        [
                            -77.91999,
                            18.50196
                        ],
                        [
                            -77.93929,
                            18.44567
                        ],
                        [
                            -78.13959,
                            18.46106
                        ],
                        [
                            -78.21333,
                            18.45351
                        ],
                        [
                            -78.33849,
                            18.36433
                        ],
                        [
                            -78.35165,
                            18.24052
                        ],
                        [
                            -78.22866,
                            18.19763
                        ],
                        [
                            -78.16673,
                            18.21577
                        ],
                        [
                            -78.07587,
                            18.21191
                        ],
                        [
                            -78.03018,
                            18.17093
                        ],
                        [
                            -77.94174,
                            18.03767
                        ],
                        [
                            -77.83314,
                            17.999
                        ],
                        [
                            -77.83637,
                            17.94689
                        ],
                        [
                            -77.73814,
                            17.85788
                        ],
                        [
                            -77.55107,
                            17.86414
                        ],
                        [
                            -77.51278,
                            17.84399
                        ],
                        [
                            -77.40886,
                            17.86318
                        ],
                        [
                            -77.3261,
                            17.8216
                        ],
                        [
                            -77.2124,
                            17.72457
                        ],
                        [
                            -77.12818,
                            17.74395
                        ],
                        [
                            -77.17228,
                            17.81093
                        ],
                        [
                            -77.12087,
                            17.89559
                        ],
                        [
                            -77.03731,
                            17.84996
                        ],
                        [
                            -76.9499,
                            17.84098
                        ],
                        [
                            -76.89724,
                            17.89174
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "JPN",
                "Country": "Japan",
                "Total_3GHG": 2.12,
                "Total_3GHG_timeseries": [
                    8.0652e-06,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.005,
                    0.0051,
                    0.0053,
                    0.0054,
                    0.0056,
                    0.0058,
                    0.0059,
                    0.0062,
                    0.0064,
                    0.0066,
                    0.0069,
                    0.0071,
                    0.0074,
                    0.0078,
                    0.0081,
                    0.0085,
                    0.009,
                    0.0095,
                    0.0099,
                    0.0104,
                    0.0109,
                    0.0114,
                    0.0118,
                    0.0123,
                    0.0128,
                    0.0132,
                    0.0137,
                    0.0141,
                    0.0146,
                    0.015,
                    0.0154,
                    0.0158,
                    0.0163,
                    0.0167,
                    0.0171,
                    0.0175,
                    0.018,
                    0.0185,
                    0.019,
                    0.0195,
                    0.0201,
                    0.0206,
                    0.0212,
                    0.0217,
                    0.0222,
                    0.0228,
                    0.0233,
                    0.0238,
                    0.0244,
                    0.0249,
                    0.0254,
                    0.026,
                    0.0265,
                    0.0271,
                    0.0276,
                    0.0281,
                    0.0286,
                    0.0291,
                    0.0297,
                    0.0302,
                    0.0307,
                    0.0313,
                    0.0318,
                    0.0323,
                    0.0328,
                    0.0332,
                    0.0337,
                    0.0342,
                    0.0346
                ],
                "Fossil_3GHG": 3.04,
                "Fossil_3GHG_timeseries": [
                    9.6893e-07,
                    1.955e-06,
                    2.9582e-06,
                    3.9783e-06,
                    5.0153e-06,
                    6.0686e-06,
                    7.138e-06,
                    8.2233e-06,
                    9.3242e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0035,
                    0.0036,
                    0.0038,
                    0.004,
                    0.0042,
                    0.0045,
                    0.0047,
                    0.005,
                    0.0054,
                    0.0058,
                    0.0062,
                    0.0066,
                    0.0071,
                    0.0076,
                    0.0081,
                    0.0085,
                    0.009,
                    0.0095,
                    0.0099,
                    0.0104,
                    0.0108,
                    0.0113,
                    0.0117,
                    0.0122,
                    0.0126,
                    0.013,
                    0.0135,
                    0.0139,
                    0.0143,
                    0.0148,
                    0.0152,
                    0.0158,
                    0.0163,
                    0.0168,
                    0.0173,
                    0.0179,
                    0.0184,
                    0.019,
                    0.0195,
                    0.0201,
                    0.0206,
                    0.0211,
                    0.0217,
                    0.0222,
                    0.0228,
                    0.0234,
                    0.0239,
                    0.0245,
                    0.025,
                    0.0255,
                    0.026,
                    0.0265,
                    0.0271,
                    0.0277,
                    0.0282,
                    0.0288,
                    0.0293,
                    0.0298,
                    0.0303,
                    0.0308,
                    0.0312,
                    0.0317,
                    0.0322
                ],
                "Land_3GHG": 0.43,
                "Land_3GHG_timeseries": [
                    7.0963e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025
                ],
                "Total_CO2": 2.82,
                "Total_CO2_timeseries": [
                    5.8456e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0046,
                    0.0048,
                    0.0049,
                    0.0051,
                    0.0053,
                    0.0056,
                    0.0058,
                    0.0061,
                    0.0065,
                    0.0068,
                    0.0072,
                    0.0076,
                    0.0081,
                    0.0084,
                    0.0089,
                    0.0093,
                    0.0097,
                    0.0101,
                    0.0105,
                    0.0109,
                    0.0113,
                    0.0117,
                    0.0121,
                    0.0125,
                    0.0129,
                    0.0133,
                    0.0138,
                    0.0142,
                    0.0147,
                    0.0153,
                    0.0158,
                    0.0163,
                    0.0168,
                    0.0174,
                    0.0179,
                    0.0185,
                    0.019,
                    0.0196,
                    0.0201,
                    0.0207,
                    0.0212,
                    0.0218,
                    0.0224,
                    0.0229,
                    0.0235,
                    0.0241,
                    0.0246,
                    0.0251,
                    0.0257,
                    0.0262,
                    0.0268,
                    0.0274,
                    0.0279,
                    0.0285,
                    0.029,
                    0.0295,
                    0.0301,
                    0.0305,
                    0.031,
                    0.0315,
                    0.032
                ],
                "Fossil_CO2": 3.93,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    4.95e-09,
                    1.32e-08,
                    2.145e-08,
                    3.3e-08,
                    4.785e-08,
                    6.6e-08,
                    3.3e-07,
                    9.7845e-07,
                    1.6104e-06,
                    2.1912e-06,
                    3.0277e-06,
                    4.0706e-06,
                    5.1282e-06,
                    6.2156e-06,
                    7.3475e-06,
                    8.5684e-06,
                    9.9e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0029,
                    0.003,
                    0.0032,
                    0.0033,
                    0.0035,
                    0.0037,
                    0.004,
                    0.0043,
                    0.0046,
                    0.005,
                    0.0054,
                    0.0058,
                    0.0062,
                    0.0066,
                    0.007,
                    0.0074,
                    0.0078,
                    0.0083,
                    0.0087,
                    0.0091,
                    0.0095,
                    0.0099,
                    0.0103,
                    0.0107,
                    0.0111,
                    0.0116,
                    0.012,
                    0.0125,
                    0.013,
                    0.0135,
                    0.014,
                    0.0146,
                    0.0151,
                    0.0157,
                    0.0162,
                    0.0168,
                    0.0173,
                    0.0179,
                    0.0185,
                    0.019,
                    0.0196,
                    0.0202,
                    0.0208,
                    0.0213,
                    0.0219,
                    0.0225,
                    0.0231,
                    0.0236,
                    0.0241,
                    0.0247,
                    0.0253,
                    0.0259,
                    0.0264,
                    0.027,
                    0.0275,
                    0.0281,
                    0.0286,
                    0.0291,
                    0.0296,
                    0.03,
                    0.0305
                ],
                "Land_CO2": 0.4,
                "Land_CO2_timeseries": [
                    5.8456e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015
                ],
                "Total_CH4": 0.41,
                "Total_CH4_timeseries": [
                    1.4776e-06,
                    3.001e-06,
                    4.5701e-06,
                    6.1851e-06,
                    7.8458e-06,
                    9.5519e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0023,
                    0.0023,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0021,
                    0.0021,
                    0.002,
                    0.002,
                    0.002,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0017,
                    0.0017,
                    0.0017
                ],
                "Fossil_CH4": 0.38,
                "Fossil_CH4_timeseries": [
                    2.9964e-07,
                    6.089e-07,
                    9.2777e-07,
                    1.2562e-06,
                    1.5943e-06,
                    1.9416e-06,
                    2.2982e-06,
                    2.664e-06,
                    3.0392e-06,
                    3.4235e-06,
                    3.8168e-06,
                    4.219e-06,
                    4.6355e-06,
                    5.0609e-06,
                    5.4952e-06,
                    5.9382e-06,
                    6.3899e-06,
                    6.852e-06,
                    7.3239e-06,
                    7.8031e-06,
                    8.2994e-06,
                    8.8117e-06,
                    9.3395e-06,
                    9.9653e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0015,
                    0.0015,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.001,
                    0.001,
                    0.001,
                    0.001
                ],
                "Land_CH4": 0.44,
                "Land_CH4_timeseries": [
                    1.1779e-06,
                    2.3921e-06,
                    3.6424e-06,
                    4.9288e-06,
                    6.2515e-06,
                    7.6104e-06,
                    9.0054e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Total_N2O": 1.18,
                "Total_N2O_timeseries": [
                    7.4205e-07,
                    1.4931e-06,
                    2.253e-06,
                    3.0216e-06,
                    3.7986e-06,
                    4.5837e-06,
                    5.3766e-06,
                    6.1769e-06,
                    6.984e-06,
                    7.7975e-06,
                    8.617e-06,
                    9.4424e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001
                ],
                "Fossil_N2O": 2.89,
                "Fossil_N2O_timeseries": [
                    6.6929e-07,
                    1.3461e-06,
                    2.0304e-06,
                    2.7221e-06,
                    3.421e-06,
                    4.127e-06,
                    4.8398e-06,
                    5.5592e-06,
                    6.285e-06,
                    7.0169e-06,
                    7.7547e-06,
                    8.4983e-06,
                    9.2478e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Land_N2O": 0.51,
                "Land_N2O_timeseries": [
                    7.2759e-08,
                    1.4697e-07,
                    2.2258e-07,
                    2.9949e-07,
                    3.776e-07,
                    4.5677e-07,
                    5.3684e-07,
                    6.1764e-07,
                    6.9895e-07,
                    7.8054e-07,
                    8.6227e-07,
                    9.441e-07,
                    1.026e-06,
                    1.108e-06,
                    1.19e-06,
                    1.2721e-06,
                    1.3542e-06,
                    1.4364e-06,
                    1.5187e-06,
                    1.6012e-06,
                    1.685e-06,
                    1.7724e-06,
                    1.8648e-06,
                    1.9635e-06,
                    2.0691e-06,
                    2.1817e-06,
                    2.3011e-06,
                    2.4263e-06,
                    2.5561e-06,
                    2.6887e-06,
                    2.8228e-06,
                    2.9583e-06,
                    3.0948e-06,
                    3.2324e-06,
                    3.3708e-06,
                    3.51e-06,
                    3.65e-06,
                    3.7909e-06,
                    3.9327e-06,
                    4.0805e-06,
                    4.2288e-06,
                    4.3775e-06,
                    4.5268e-06,
                    4.6766e-06,
                    4.8269e-06,
                    4.9777e-06,
                    5.1291e-06,
                    5.2811e-06,
                    5.4338e-06,
                    5.587e-06,
                    5.7409e-06,
                    5.8957e-06,
                    6.0513e-06,
                    6.208e-06,
                    6.3656e-06,
                    6.5241e-06,
                    6.6833e-06,
                    6.8432e-06,
                    7.0035e-06,
                    7.1639e-06,
                    7.3243e-06,
                    7.4848e-06,
                    7.6452e-06,
                    7.8056e-06,
                    7.966e-06,
                    8.1265e-06,
                    8.2869e-06,
                    8.4473e-06,
                    8.6078e-06,
                    8.7682e-06,
                    8.929e-06,
                    9.091e-06,
                    9.2547e-06,
                    9.4206e-06,
                    9.5889e-06,
                    9.7599e-06,
                    9.9335e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                131.26288,
                                34.4173
                            ],
                            [
                                131.0237,
                                34.41037
                            ],
                            [
                                131.02824,
                                34.37056
                            ],
                            [
                                130.89642,
                                34.33451
                            ],
                            [
                                130.88078,
                                34.28391
                            ],
                            [
                                130.92047,
                                34.23294
                            ],
                            [
                                130.92673,
                                34.16483
                            ],
                            [
                                130.86741,
                                34.1063
                            ],
                            [
                                130.91479,
                                34.04551
                            ],
                            [
                                130.91629,
                                33.95985
                            ],
                            [
                                130.99564,
                                33.97996
                            ],
                            [
                                131.04477,
                                34.04808
                            ],
                            [
                                131.17212,
                                33.98346
                            ],
                            [
                                131.18098,
                                33.93258
                            ],
                            [
                                131.27168,
                                33.92146
                            ],
                            [
                                131.34854,
                                33.95705
                            ],
                            [
                                131.37357,
                                34.01312
                            ],
                            [
                                131.4412,
                                33.97984
                            ],
                            [
                                131.50534,
                                34.02942
                            ],
                            [
                                131.54202,
                                33.99429
                            ],
                            [
                                131.63809,
                                34.03586
                            ],
                            [
                                131.75151,
                                34.06137
                            ],
                            [
                                131.82223,
                                34.03054
                            ],
                            [
                                131.93651,
                                33.94571
                            ],
                            [
                                132.02756,
                                33.89871
                            ],
                            [
                                132.13839,
                                33.88422
                            ],
                            [
                                132.12339,
                                33.94932
                            ],
                            [
                                132.18924,
                                33.95551
                            ],
                            [
                                132.22011,
                                33.99649
                            ],
                            [
                                132.20507,
                                34.11354
                            ],
                            [
                                132.24966,
                                34.14996
                            ],
                            [
                                132.24292,
                                34.25338
                            ],
                            [
                                132.32996,
                                34.33727
                            ],
                            [
                                132.52069,
                                34.35767
                            ],
                            [
                                132.51793,
                                34.2555
                            ],
                            [
                                132.64379,
                                34.20028
                            ],
                            [
                                132.76583,
                                34.24046
                            ],
                            [
                                132.80316,
                                34.30335
                            ],
                            [
                                132.85826,
                                34.29184
                            ],
                            [
                                132.95463,
                                34.33409
                            ],
                            [
                                133.07731,
                                34.3407
                            ],
                            [
                                133.24603,
                                34.42897
                            ],
                            [
                                133.29663,
                                34.38464
                            ],
                            [
                                133.36874,
                                34.3672
                            ],
                            [
                                133.42788,
                                34.44848
                            ],
                            [
                                133.55303,
                                34.46121
                            ],
                            [
                                133.66789,
                                34.51636
                            ],
                            [
                                133.71254,
                                34.51236
                            ],
                            [
                                133.79427,
                                34.43673
                            ],
                            [
                                133.83861,
                                34.46921
                            ],
                            [
                                133.93927,
                                34.45296
                            ],
                            [
                                133.96945,
                                34.52137
                            ],
                            [
                                134.18111,
                                34.62215
                            ],
                            [
                                134.26322,
                                34.71808
                            ],
                            [
                                134.37171,
                                34.75407
                            ],
                            [
                                134.65583,
                                34.78626
                            ],
                            [
                                134.75768,
                                34.76727
                            ],
                            [
                                134.97027,
                                34.64746
                            ],
                            [
                                135.05137,
                                34.6296
                            ],
                            [
                                135.18424,
                                34.65548
                            ],
                            [
                                135.2236,
                                34.69774
                            ],
                            [
                                135.34264,
                                34.72394
                            ],
                            [
                                135.42868,
                                34.69428
                            ],
                            [
                                135.46634,
                                34.64626
                            ],
                            [
                                135.37863,
                                34.47522
                            ],
                            [
                                135.22632,
                                34.34918
                            ],
                            [
                                135.08058,
                                34.29634
                            ],
                            [
                                135.07351,
                                34.2558
                            ],
                            [
                                135.14091,
                                34.22526
                            ],
                            [
                                135.19609,
                                34.14696
                            ],
                            [
                                135.13632,
                                34.13151
                            ],
                            [
                                135.09603,
                                34.07253
                            ],
                            [
                                135.1746,
                                34.03136
                            ],
                            [
                                135.09901,
                                33.98835
                            ],
                            [
                                135.07003,
                                33.89997
                            ],
                            [
                                135.16088,
                                33.8704
                            ],
                            [
                                135.24522,
                                33.78459
                            ],
                            [
                                135.31948,
                                33.76413
                            ],
                            [
                                135.39615,
                                33.70451
                            ],
                            [
                                135.39525,
                                33.59799
                            ],
                            [
                                135.45313,
                                33.55049
                            ],
                            [
                                135.59702,
                                33.50045
                            ],
                            [
                                135.76777,
                                33.47386
                            ],
                            [
                                135.90618,
                                33.54339
                            ],
                            [
                                135.95037,
                                33.63854
                            ],
                            [
                                136.0295,
                                33.7459
                            ],
                            [
                                136.09405,
                                33.86869
                            ],
                            [
                                136.27192,
                                33.97362
                            ],
                            [
                                136.27825,
                                34.02225
                            ],
                            [
                                136.21719,
                                34.07087
                            ],
                            [
                                136.33708,
                                34.18223
                            ],
                            [
                                136.48479,
                                34.22486
                            ],
                            [
                                136.66203,
                                34.29082
                            ],
                            [
                                136.84382,
                                34.30615
                            ],
                            [
                                136.87172,
                                34.37124
                            ],
                            [
                                136.92928,
                                34.41879
                            ],
                            [
                                136.83738,
                                34.49991
                            ],
                            [
                                136.72324,
                                34.52779
                            ],
                            [
                                136.64266,
                                34.59171
                            ],
                            [
                                136.54069,
                                34.61402
                            ],
                            [
                                136.52756,
                                34.706
                            ],
                            [
                                136.5656,
                                34.79519
                            ],
                            [
                                136.65791,
                                34.91818
                            ],
                            [
                                136.6314,
                                34.97663
                            ],
                            [
                                136.73048,
                                35.03987
                            ],
                            [
                                136.78437,
                                35.03439
                            ],
                            [
                                136.89779,
                                35.06571
                            ],
                            [
                                136.8388,
                                34.968
                            ],
                            [
                                136.86421,
                                34.83862
                            ],
                            [
                                136.9217,
                                34.78207
                            ],
                            [
                                136.95203,
                                34.88427
                            ],
                            [
                                137.04074,
                                34.7849
                            ],
                            [
                                137.19114,
                                34.77886
                            ],
                            [
                                137.23199,
                                34.81982
                            ],
                            [
                                137.34576,
                                34.77958
                            ],
                            [
                                137.34941,
                                34.73301
                            ],
                            [
                                137.14033,
                                34.65611
                            ],
                            [
                                137.07942,
                                34.65882
                            ],
                            [
                                137.02906,
                                34.58778
                            ],
                            [
                                137.14681,
                                34.58846
                            ],
                            [
                                137.2884,
                                34.63139
                            ],
                            [
                                137.49678,
                                34.67441
                            ],
                            [
                                137.62614,
                                34.67674
                            ],
                            [
                                137.80846,
                                34.6485
                            ],
                            [
                                137.99259,
                                34.66353
                            ],
                            [
                                138.19103,
                                34.60442
                            ],
                            [
                                138.24115,
                                34.73152
                            ],
                            [
                                138.30138,
                                34.76633
                            ],
                            [
                                138.36841,
                                34.91093
                            ],
                            [
                                138.5326,
                                34.99033
                            ],
                            [
                                138.51806,
                                35.04309
                            ],
                            [
                                138.57638,
                                35.10075
                            ],
                            [
                                138.7154,
                                35.13261
                            ],
                            [
                                138.82532,
                                35.10829
                            ],
                            [
                                138.90741,
                                35.04401
                            ],
                            [
                                138.79628,
                                35.02349
                            ],
                            [
                                138.77135,
                                34.96527
                            ],
                            [
                                138.77505,
                                34.76421
                            ],
                            [
                                138.74984,
                                34.695
                            ],
                            [
                                138.8451,
                                34.6056
                            ],
                            [
                                138.91278,
                                34.63443
                            ],
                            [
                                139.05932,
                                34.77363
                            ],
                            [
                                139.09387,
                                34.84905
                            ],
                            [
                                139.14126,
                                34.88637
                            ],
                            [
                                139.15117,
                                34.95087
                            ],
                            [
                                139.0991,
                                35.0
                            ],
                            [
                                139.08542,
                                35.06534
                            ],
                            [
                                139.15267,
                                35.22378
                            ],
                            [
                                139.25647,
                                35.28711
                            ],
                            [
                                139.44116,
                                35.31547
                            ],
                            [
                                139.56874,
                                35.28727
                            ],
                            [
                                139.62812,
                                35.18459
                            ],
                            [
                                139.66937,
                                35.1876
                            ],
                            [
                                139.74492,
                                35.25145
                            ],
                            [
                                139.64427,
                                35.29779
                            ],
                            [
                                139.65823,
                                35.35315
                            ],
                            [
                                139.64425,
                                35.46398
                            ],
                            [
                                139.79694,
                                35.55295
                            ],
                            [
                                139.77333,
                                35.65473
                            ],
                            [
                                139.85331,
                                35.66581
                            ],
                            [
                                139.9001,
                                35.62316
                            ],
                            [
                                139.9927,
                                35.67621
                            ],
                            [
                                140.12079,
                                35.58857
                            ],
                            [
                                140.10024,
                                35.53937
                            ],
                            [
                                140.02086,
                                35.47567
                            ],
                            [
                                139.90777,
                                35.41951
                            ],
                            [
                                139.85249,
                                35.36445
                            ],
                            [
                                139.87284,
                                35.23573
                            ],
                            [
                                139.82443,
                                35.18172
                            ],
                            [
                                139.86433,
                                35.00006
                            ],
                            [
                                139.77271,
                                34.95633
                            ],
                            [
                                139.84879,
                                34.90503
                            ],
                            [
                                139.93012,
                                34.91015
                            ],
                            [
                                139.99358,
                                35.01372
                            ],
                            [
                                140.14303,
                                35.11641
                            ],
                            [
                                140.23153,
                                35.11371
                            ],
                            [
                                140.38744,
                                35.18753
                            ],
                            [
                                140.41958,
                                35.30393
                            ],
                            [
                                140.39385,
                                35.38529
                            ],
                            [
                                140.43688,
                                35.49863
                            ],
                            [
                                140.53875,
                                35.60871
                            ],
                            [
                                140.66517,
                                35.68936
                            ],
                            [
                                140.87763,
                                35.71844
                            ],
                            [
                                140.81011,
                                35.78773
                            ],
                            [
                                140.61576,
                                36.08449
                            ],
                            [
                                140.58013,
                                36.17431
                            ],
                            [
                                140.57083,
                                36.30103
                            ],
                            [
                                140.62804,
                                36.37139
                            ],
                            [
                                140.61712,
                                36.47062
                            ],
                            [
                                140.71794,
                                36.66339
                            ],
                            [
                                140.75567,
                                36.7887
                            ],
                            [
                                140.79916,
                                36.82942
                            ],
                            [
                                140.8098,
                                36.90395
                            ],
                            [
                                140.9258,
                                36.93873
                            ],
                            [
                                140.97074,
                                36.97631
                            ],
                            [
                                141.00858,
                                37.14329
                            ],
                            [
                                141.03854,
                                37.35938
                            ],
                            [
                                141.0422,
                                37.48911
                            ],
                            [
                                141.01218,
                                37.73924
                            ],
                            [
                                140.94098,
                                37.87569
                            ],
                            [
                                140.91379,
                                37.98707
                            ],
                            [
                                140.95386,
                                38.1684
                            ],
                            [
                                141.02002,
                                38.25407
                            ],
                            [
                                141.08782,
                                38.29639
                            ],
                            [
                                141.04918,
                                38.3409
                            ],
                            [
                                141.2502,
                                38.40271
                            ],
                            [
                                141.35939,
                                38.40871
                            ],
                            [
                                141.44434,
                                38.37085
                            ],
                            [
                                141.45976,
                                38.31102
                            ],
                            [
                                141.53622,
                                38.30928
                            ],
                            [
                                141.46145,
                                38.43663
                            ],
                            [
                                141.52665,
                                38.48912
                            ],
                            [
                                141.46931,
                                38.56853
                            ],
                            [
                                141.53068,
                                38.62577
                            ],
                            [
                                141.4591,
                                38.64511
                            ],
                            [
                                141.56422,
                                38.73293
                            ],
                            [
                                141.53278,
                                38.78867
                            ],
                            [
                                141.59506,
                                38.82492
                            ],
                            [
                                141.63645,
                                38.89509
                            ],
                            [
                                141.7585,
                                39.02198
                            ],
                            [
                                141.84054,
                                39.02641
                            ],
                            [
                                141.81937,
                                39.10535
                            ],
                            [
                                141.87702,
                                39.20024
                            ],
                            [
                                141.90263,
                                39.2985
                            ],
                            [
                                141.9716,
                                39.31757
                            ],
                            [
                                141.94535,
                                39.38401
                            ],
                            [
                                142.0382,
                                39.42315
                            ],
                            [
                                142.01137,
                                39.48039
                            ],
                            [
                                142.06949,
                                39.55706
                            ],
                            [
                                141.99075,
                                39.68098
                            ],
                            [
                                142.00404,
                                39.74808
                            ],
                            [
                                141.9792,
                                39.87078
                            ],
                            [
                                141.94514,
                                39.92602
                            ],
                            [
                                141.94568,
                                40.00011
                            ],
                            [
                                141.83994,
                                40.07821
                            ],
                            [
                                141.87818,
                                40.13881
                            ],
                            [
                                141.81765,
                                40.18036
                            ],
                            [
                                141.83691,
                                40.23572
                            ],
                            [
                                141.7759,
                                40.34259
                            ],
                            [
                                141.69211,
                                40.44489
                            ],
                            [
                                141.58227,
                                40.5383
                            ],
                            [
                                141.4963,
                                40.55899
                            ],
                            [
                                141.45047,
                                40.64446
                            ],
                            [
                                141.39512,
                                40.87961
                            ],
                            [
                                141.39888,
                                41.15051
                            ],
                            [
                                141.4597,
                                41.42368
                            ],
                            [
                                141.35075,
                                41.35764
                            ],
                            [
                                141.28324,
                                41.35141
                            ],
                            [
                                141.1994,
                                41.38689
                            ],
                            [
                                141.11592,
                                41.46328
                            ],
                            [
                                140.98967,
                                41.49166
                            ],
                            [
                                140.90162,
                                41.47536
                            ],
                            [
                                140.8405,
                                41.41453
                            ],
                            [
                                140.77371,
                                41.19177
                            ],
                            [
                                140.77076,
                                41.14284
                            ],
                            [
                                140.98351,
                                41.19223
                            ],
                            [
                                141.06216,
                                41.17893
                            ],
                            [
                                141.12795,
                                41.2111
                            ],
                            [
                                141.16654,
                                41.27179
                            ],
                            [
                                141.24862,
                                41.22652
                            ],
                            [
                                141.2819,
                                41.15289
                            ],
                            [
                                141.24656,
                                41.07778
                            ],
                            [
                                141.21894,
                                40.95073
                            ],
                            [
                                141.16985,
                                40.8898
                            ],
                            [
                                141.10651,
                                40.86988
                            ],
                            [
                                140.90095,
                                41.00459
                            ],
                            [
                                140.86208,
                                40.95523
                            ],
                            [
                                140.86009,
                                40.88286
                            ],
                            [
                                140.7981,
                                40.83397
                            ],
                            [
                                140.70643,
                                40.85158
                            ],
                            [
                                140.6723,
                                40.92964
                            ],
                            [
                                140.63853,
                                41.09255
                            ],
                            [
                                140.64988,
                                41.16352
                            ],
                            [
                                140.5571,
                                41.22137
                            ],
                            [
                                140.44104,
                                41.19282
                            ],
                            [
                                140.34451,
                                41.25396
                            ],
                            [
                                140.30547,
                                41.1299
                            ],
                            [
                                140.33107,
                                41.03336
                            ],
                            [
                                140.29289,
                                40.86831
                            ],
                            [
                                140.25514,
                                40.79844
                            ],
                            [
                                140.15215,
                                40.75089
                            ],
                            [
                                140.07188,
                                40.76362
                            ],
                            [
                                140.00146,
                                40.7356
                            ],
                            [
                                139.93288,
                                40.64712
                            ],
                            [
                                139.866,
                                40.6087
                            ],
                            [
                                139.94654,
                                40.54551
                            ],
                            [
                                139.94689,
                                40.4214
                            ],
                            [
                                140.02746,
                                40.34946
                            ],
                            [
                                140.01964,
                                40.24487
                            ],
                            [
                                139.97244,
                                40.10504
                            ],
                            [
                                139.89759,
                                40.00055
                            ],
                            [
                                139.81065,
                                39.95615
                            ],
                            [
                                139.72942,
                                39.98271
                            ],
                            [
                                139.70829,
                                39.94052
                            ],
                            [
                                139.75729,
                                39.85678
                            ],
                            [
                                139.87568,
                                39.89295
                            ],
                            [
                                139.97143,
                                39.88636
                            ],
                            [
                                140.05729,
                                39.75328
                            ],
                            [
                                140.06582,
                                39.60231
                            ],
                            [
                                140.03674,
                                39.43944
                            ],
                            [
                                139.97543,
                                39.3008
                            ],
                            [
                                139.92983,
                                39.28472
                            ],
                            [
                                139.89891,
                                39.20953
                            ],
                            [
                                139.86549,
                                39.02854
                            ],
                            [
                                139.76154,
                                38.79184
                            ],
                            [
                                139.62455,
                                38.67675
                            ],
                            [
                                139.54376,
                                38.56134
                            ],
                            [
                                139.46405,
                                38.40134
                            ],
                            [
                                139.44996,
                                38.23575
                            ],
                            [
                                139.41382,
                                38.15038
                            ],
                            [
                                139.34403,
                                38.07526
                            ],
                            [
                                139.23011,
                                37.99676
                            ],
                            [
                                139.0848,
                                37.95181
                            ],
                            [
                                138.89033,
                                37.84624
                            ],
                            [
                                138.81765,
                                37.78045
                            ],
                            [
                                138.77889,
                                37.65597
                            ],
                            [
                                138.71954,
                                37.56054
                            ],
                            [
                                138.62773,
                                37.48175
                            ],
                            [
                                138.54971,
                                37.36987
                            ],
                            [
                                138.44265,
                                37.32182
                            ],
                            [
                                138.27186,
                                37.19259
                            ],
                            [
                                138.1573,
                                37.16395
                            ],
                            [
                                138.10303,
                                37.17136
                            ],
                            [
                                138.04909,
                                37.12827
                            ],
                            [
                                137.91166,
                                37.06143
                            ],
                            [
                                137.67199,
                                36.98832
                            ],
                            [
                                137.51606,
                                36.95873
                            ],
                            [
                                137.42192,
                                36.91009
                            ],
                            [
                                137.38853,
                                36.8073
                            ],
                            [
                                137.3279,
                                36.76315
                            ],
                            [
                                137.18037,
                                36.75964
                            ],
                            [
                                137.09331,
                                36.78787
                            ],
                            [
                                136.99407,
                                36.87
                            ],
                            [
                                137.05738,
                                36.96423
                            ],
                            [
                                137.00968,
                                37.06204
                            ],
                            [
                                136.87435,
                                37.07562
                            ],
                            [
                                136.9203,
                                37.21764
                            ],
                            [
                                137.02449,
                                37.18668
                            ],
                            [
                                137.10517,
                                37.26994
                            ],
                            [
                                137.26047,
                                37.31815
                            ],
                            [
                                137.24617,
                                37.37458
                            ],
                            [
                                137.27888,
                                37.43364
                            ],
                            [
                                137.3612,
                                37.44693
                            ],
                            [
                                137.32952,
                                37.5222
                            ],
                            [
                                137.26339,
                                37.52535
                            ],
                            [
                                137.12603,
                                37.48751
                            ],
                            [
                                137.03119,
                                37.4316
                            ],
                            [
                                136.92966,
                                37.3959
                            ],
                            [
                                136.86141,
                                37.40087
                            ],
                            [
                                136.76567,
                                37.36212
                            ],
                            [
                                136.68756,
                                37.20576
                            ],
                            [
                                136.72401,
                                37.07681
                            ],
                            [
                                136.77038,
                                36.99034
                            ],
                            [
                                136.75443,
                                36.84139
                            ],
                            [
                                136.6712,
                                36.6937
                            ],
                            [
                                136.53006,
                                36.52925
                            ],
                            [
                                136.37593,
                                36.38035
                            ],
                            [
                                136.21622,
                                36.26817
                            ],
                            [
                                136.13559,
                                36.24566
                            ],
                            [
                                136.1179,
                                36.17529
                            ],
                            [
                                135.97061,
                                35.99793
                            ],
                            [
                                136.0201,
                                35.86814
                            ],
                            [
                                136.09922,
                                35.78127
                            ],
                            [
                                135.96208,
                                35.72103
                            ],
                            [
                                135.97779,
                                35.62968
                            ],
                            [
                                135.8747,
                                35.61353
                            ],
                            [
                                135.82958,
                                35.53889
                            ],
                            [
                                135.74681,
                                35.5651
                            ],
                            [
                                135.72358,
                                35.48927
                            ],
                            [
                                135.5303,
                                35.49332
                            ],
                            [
                                135.46086,
                                35.57349
                            ],
                            [
                                135.30654,
                                35.51239
                            ],
                            [
                                135.2474,
                                35.62251
                            ],
                            [
                                135.31079,
                                35.68938
                            ],
                            [
                                135.23074,
                                35.77291
                            ],
                            [
                                135.09618,
                                35.73987
                            ],
                            [
                                134.93192,
                                35.64791
                            ],
                            [
                                134.80781,
                                35.66522
                            ],
                            [
                                134.62553,
                                35.64441
                            ],
                            [
                                134.53854,
                                35.66579
                            ],
                            [
                                134.30135,
                                35.58673
                            ],
                            [
                                134.24734,
                                35.54874
                            ],
                            [
                                134.04197,
                                35.51907
                            ],
                            [
                                133.76119,
                                35.50082
                            ],
                            [
                                133.58498,
                                35.52949
                            ],
                            [
                                133.45515,
                                35.4938
                            ],
                            [
                                133.40624,
                                35.45297
                            ],
                            [
                                133.31997,
                                35.46842
                            ],
                            [
                                133.24968,
                                35.52988
                            ],
                            [
                                133.11116,
                                35.59693
                            ],
                            [
                                132.97303,
                                35.51442
                            ],
                            [
                                132.83683,
                                35.50322
                            ],
                            [
                                132.63264,
                                35.42952
                            ],
                            [
                                132.67579,
                                35.39806
                            ],
                            [
                                132.64563,
                                35.29616
                            ],
                            [
                                132.42305,
                                35.18476
                            ],
                            [
                                132.30882,
                                35.05162
                            ],
                            [
                                132.24457,
                                35.03199
                            ],
                            [
                                132.08892,
                                34.92848
                            ],
                            [
                                131.9476,
                                34.79244
                            ],
                            [
                                131.87181,
                                34.75345
                            ],
                            [
                                131.81139,
                                34.6894
                            ],
                            [
                                131.68091,
                                34.67499
                            ],
                            [
                                131.56508,
                                34.61491
                            ],
                            [
                                131.5483,
                                34.57049
                            ],
                            [
                                131.47163,
                                34.53281
                            ],
                            [
                                131.41445,
                                34.42556
                            ],
                            [
                                131.26288,
                                34.4173
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                145.09186,
                                43.84442
                            ],
                            [
                                145.09667,
                                43.89171
                            ],
                            [
                                145.16055,
                                43.98426
                            ],
                            [
                                145.23347,
                                44.0464
                            ],
                            [
                                145.26057,
                                44.12535
                            ],
                            [
                                145.34863,
                                44.21982
                            ],
                            [
                                145.34331,
                                44.33407
                            ],
                            [
                                145.23097,
                                44.24807
                            ],
                            [
                                145.19407,
                                44.19734
                            ],
                            [
                                145.01569,
                                44.09606
                            ],
                            [
                                144.90989,
                                44.00895
                            ],
                            [
                                144.78438,
                                43.93049
                            ],
                            [
                                144.58118,
                                43.92163
                            ],
                            [
                                144.44215,
                                43.9394
                            ],
                            [
                                144.30537,
                                43.98226
                            ],
                            [
                                144.24868,
                                44.10855
                            ],
                            [
                                144.19516,
                                44.10088
                            ],
                            [
                                143.97834,
                                44.13641
                            ],
                            [
                                143.78758,
                                44.17886
                            ],
                            [
                                143.53479,
                                44.25734
                            ],
                            [
                                143.38479,
                                44.32353
                            ],
                            [
                                143.35108,
                                44.36735
                            ],
                            [
                                143.24777,
                                44.41455
                            ],
                            [
                                143.01448,
                                44.54603
                            ],
                            [
                                142.93479,
                                44.62506
                            ],
                            [
                                142.7442,
                                44.76288
                            ],
                            [
                                142.53008,
                                45.02758
                            ],
                            [
                                142.34905,
                                45.16996
                            ],
                            [
                                142.16562,
                                45.33957
                            ],
                            [
                                142.04704,
                                45.40602
                            ],
                            [
                                141.93883,
                                45.52176
                            ],
                            [
                                141.87229,
                                45.44535
                            ],
                            [
                                141.65508,
                                45.36499
                            ],
                            [
                                141.57641,
                                45.23639
                            ],
                            [
                                141.57909,
                                45.17015
                            ],
                            [
                                141.74302,
                                44.87763
                            ],
                            [
                                141.77778,
                                44.75477
                            ],
                            [
                                141.78682,
                                44.57752
                            ],
                            [
                                141.74928,
                                44.43336
                            ],
                            [
                                141.64943,
                                44.30651
                            ],
                            [
                                141.66163,
                                44.01318
                            ],
                            [
                                141.59807,
                                43.88905
                            ],
                            [
                                141.38567,
                                43.80334
                            ],
                            [
                                141.33234,
                                43.705
                            ],
                            [
                                141.38429,
                                43.57388
                            ],
                            [
                                141.36229,
                                43.51381
                            ],
                            [
                                141.4291,
                                43.41268
                            ],
                            [
                                141.42223,
                                43.32269
                            ],
                            [
                                141.27507,
                                43.18721
                            ],
                            [
                                141.16099,
                                43.14409
                            ],
                            [
                                141.02674,
                                43.18383
                            ],
                            [
                                141.0186,
                                43.23326
                            ],
                            [
                                140.82221,
                                43.19194
                            ],
                            [
                                140.64676,
                                43.26299
                            ],
                            [
                                140.53064,
                                43.35419
                            ],
                            [
                                140.3593,
                                43.31308
                            ],
                            [
                                140.32759,
                                43.23052
                            ],
                            [
                                140.53032,
                                43.02375
                            ],
                            [
                                140.52307,
                                42.98948
                            ],
                            [
                                140.39643,
                                42.92138
                            ],
                            [
                                140.25948,
                                42.76396
                            ],
                            [
                                140.19059,
                                42.82157
                            ],
                            [
                                140.13123,
                                42.74579
                            ],
                            [
                                140.03236,
                                42.68869
                            ],
                            [
                                139.8697,
                                42.66143
                            ],
                            [
                                139.82462,
                                42.60056
                            ],
                            [
                                139.85359,
                                42.46256
                            ],
                            [
                                139.78356,
                                42.34779
                            ],
                            [
                                139.77773,
                                42.25619
                            ],
                            [
                                139.86465,
                                42.2113
                            ],
                            [
                                139.92758,
                                42.12832
                            ],
                            [
                                140.05366,
                                42.08392
                            ],
                            [
                                140.12295,
                                41.99375
                            ],
                            [
                                140.14539,
                                41.91338
                            ],
                            [
                                140.12217,
                                41.81354
                            ],
                            [
                                140.00847,
                                41.67395
                            ],
                            [
                                139.98899,
                                41.55012
                            ],
                            [
                                140.03244,
                                41.45789
                            ],
                            [
                                140.08297,
                                41.41849
                            ],
                            [
                                140.20601,
                                41.39331
                            ],
                            [
                                140.27129,
                                41.47631
                            ],
                            [
                                140.41909,
                                41.51873
                            ],
                            [
                                140.44453,
                                41.5494
                            ],
                            [
                                140.44239,
                                41.66139
                            ],
                            [
                                140.6074,
                                41.7391
                            ],
                            [
                                140.67371,
                                41.81965
                            ],
                            [
                                140.77877,
                                41.7723
                            ],
                            [
                                140.93175,
                                41.73335
                            ],
                            [
                                141.05699,
                                41.723
                            ],
                            [
                                141.10793,
                                41.77367
                            ],
                            [
                                141.19255,
                                41.80157
                            ],
                            [
                                141.1528,
                                41.85239
                            ],
                            [
                                140.96517,
                                41.91549
                            ],
                            [
                                140.90789,
                                41.98389
                            ],
                            [
                                140.71213,
                                42.13474
                            ],
                            [
                                140.59734,
                                42.10834
                            ],
                            [
                                140.51887,
                                42.12771
                            ],
                            [
                                140.3831,
                                42.22027
                            ],
                            [
                                140.29391,
                                42.2475
                            ],
                            [
                                140.30417,
                                42.38165
                            ],
                            [
                                140.34392,
                                42.45371
                            ],
                            [
                                140.4799,
                                42.58148
                            ],
                            [
                                140.5846,
                                42.56437
                            ],
                            [
                                140.70657,
                                42.57891
                            ],
                            [
                                140.87176,
                                42.4522
                            ],
                            [
                                140.93229,
                                42.3316
                            ],
                            [
                                141.00029,
                                42.29677
                            ],
                            [
                                141.14774,
                                42.4291
                            ],
                            [
                                141.21431,
                                42.45307
                            ],
                            [
                                141.36823,
                                42.54713
                            ],
                            [
                                141.57658,
                                42.62041
                            ],
                            [
                                141.69753,
                                42.62538
                            ],
                            [
                                141.89294,
                                42.57899
                            ],
                            [
                                142.03502,
                                42.48051
                            ],
                            [
                                142.18202,
                                42.44937
                            ],
                            [
                                142.30759,
                                42.35631
                            ],
                            [
                                142.49088,
                                42.26529
                            ],
                            [
                                142.82191,
                                42.13596
                            ],
                            [
                                142.95957,
                                42.11467
                            ],
                            [
                                143.13232,
                                42.0254
                            ],
                            [
                                143.2454,
                                41.92451
                            ],
                            [
                                143.31066,
                                42.04407
                            ],
                            [
                                143.34015,
                                42.18779
                            ],
                            [
                                143.32535,
                                42.29552
                            ],
                            [
                                143.41705,
                                42.44343
                            ],
                            [
                                143.57288,
                                42.61334
                            ],
                            [
                                143.87861,
                                42.84329
                            ],
                            [
                                144.04622,
                                42.93575
                            ],
                            [
                                144.19076,
                                42.9849
                            ],
                            [
                                144.34901,
                                42.99566
                            ],
                            [
                                144.47606,
                                42.93756
                            ],
                            [
                                144.61975,
                                42.9476
                            ],
                            [
                                144.7758,
                                42.93172
                            ],
                            [
                                144.72518,
                                42.98982
                            ],
                            [
                                144.78489,
                                43.04634
                            ],
                            [
                                144.9445,
                                43.03853
                            ],
                            [
                                144.97111,
                                42.98079
                            ],
                            [
                                145.1171,
                                43.06902
                            ],
                            [
                                145.11615,
                                43.11974
                            ],
                            [
                                145.29026,
                                43.16529
                            ],
                            [
                                145.51524,
                                43.18188
                            ],
                            [
                                145.56894,
                                43.27715
                            ],
                            [
                                145.62991,
                                43.31075
                            ],
                            [
                                145.75214,
                                43.33102
                            ],
                            [
                                145.76216,
                                43.3941
                            ],
                            [
                                145.65393,
                                43.38659
                            ],
                            [
                                145.53017,
                                43.3067
                            ],
                            [
                                145.49908,
                                43.26625
                            ],
                            [
                                145.3954,
                                43.26043
                            ],
                            [
                                145.30102,
                                43.28356
                            ],
                            [
                                145.3204,
                                43.34727
                            ],
                            [
                                145.26748,
                                43.43324
                            ],
                            [
                                145.21409,
                                43.61915
                            ],
                            [
                                145.14509,
                                43.64834
                            ],
                            [
                                145.07139,
                                43.75189
                            ],
                            [
                                145.09186,
                                43.84442
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                130.88832,
                                33.91861
                            ],
                            [
                                130.83734,
                                33.95568
                            ],
                            [
                                130.70285,
                                33.93483
                            ],
                            [
                                130.6613,
                                33.89265
                            ],
                            [
                                130.53151,
                                33.88329
                            ],
                            [
                                130.40221,
                                33.594
                            ],
                            [
                                130.32061,
                                33.59187
                            ],
                            [
                                130.16355,
                                33.62181
                            ],
                            [
                                130.12662,
                                33.50926
                            ],
                            [
                                130.05845,
                                33.4925
                            ],
                            [
                                129.99518,
                                33.44504
                            ],
                            [
                                129.93241,
                                33.54164
                            ],
                            [
                                129.8344,
                                33.50836
                            ],
                            [
                                129.79638,
                                33.43856
                            ],
                            [
                                129.79384,
                                33.35665
                            ],
                            [
                                129.71168,
                                33.34568
                            ],
                            [
                                129.68175,
                                33.3789
                            ],
                            [
                                129.58222,
                                33.36935
                            ],
                            [
                                129.60336,
                                33.30142
                            ],
                            [
                                129.56557,
                                33.2412
                            ],
                            [
                                129.64925,
                                33.1679
                            ],
                            [
                                129.72253,
                                33.15797
                            ],
                            [
                                129.7484,
                                33.06124
                            ],
                            [
                                129.89224,
                                33.04766
                            ],
                            [
                                129.94823,
                                32.98137
                            ],
                            [
                                129.93458,
                                32.91841
                            ],
                            [
                                129.85109,
                                32.82889
                            ],
                            [
                                129.79771,
                                32.86135
                            ],
                            [
                                129.8224,
                                32.97181
                            ],
                            [
                                129.69017,
                                33.08808
                            ],
                            [
                                129.63327,
                                32.94716
                            ],
                            [
                                129.68771,
                                32.84494
                            ],
                            [
                                129.79621,
                                32.76979
                            ],
                            [
                                129.89637,
                                32.65078
                            ],
                            [
                                129.96118,
                                32.75521
                            ],
                            [
                                130.01913,
                                32.74851
                            ],
                            [
                                130.10234,
                                32.78388
                            ],
                            [
                                130.18563,
                                32.78046
                            ],
                            [
                                130.20853,
                                32.72451
                            ],
                            [
                                130.13416,
                                32.66851
                            ],
                            [
                                130.17964,
                                32.59009
                            ],
                            [
                                130.35212,
                                32.67009
                            ],
                            [
                                130.38713,
                                32.7775
                            ],
                            [
                                130.34286,
                                32.85144
                            ],
                            [
                                130.25145,
                                32.86761
                            ],
                            [
                                130.17332,
                                32.83214
                            ],
                            [
                                130.09948,
                                32.85965
                            ],
                            [
                                130.19284,
                                32.90925
                            ],
                            [
                                130.23109,
                                32.96159
                            ],
                            [
                                130.13273,
                                33.09083
                            ],
                            [
                                130.24868,
                                33.18828
                            ],
                            [
                                130.31225,
                                33.14083
                            ],
                            [
                                130.35946,
                                33.14334
                            ],
                            [
                                130.42398,
                                33.09179
                            ],
                            [
                                130.42112,
                                33.01088
                            ],
                            [
                                130.44511,
                                32.92342
                            ],
                            [
                                130.57888,
                                32.84614
                            ],
                            [
                                130.61856,
                                32.78014
                            ],
                            [
                                130.60534,
                                32.70465
                            ],
                            [
                                130.46662,
                                32.62714
                            ],
                            [
                                130.51233,
                                32.60656
                            ],
                            [
                                130.64625,
                                32.63102
                            ],
                            [
                                130.55732,
                                32.53323
                            ],
                            [
                                130.57121,
                                32.43432
                            ],
                            [
                                130.50112,
                                32.36691
                            ],
                            [
                                130.34515,
                                32.11906
                            ],
                            [
                                130.23667,
                                32.12504
                            ],
                            [
                                130.18033,
                                32.08557
                            ],
                            [
                                130.20842,
                                32.03639
                            ],
                            [
                                130.2222,
                                31.89489
                            ],
                            [
                                130.17776,
                                31.78035
                            ],
                            [
                                130.33211,
                                31.62964
                            ],
                            [
                                130.3161,
                                31.47607
                            ],
                            [
                                130.21389,
                                31.38511
                            ],
                            [
                                130.22093,
                                31.24704
                            ],
                            [
                                130.29255,
                                31.26031
                            ],
                            [
                                130.46527,
                                31.2407
                            ],
                            [
                                130.53737,
                                31.1587
                            ],
                            [
                                130.63826,
                                31.18256
                            ],
                            [
                                130.66812,
                                31.25809
                            ],
                            [
                                130.56983,
                                31.31584
                            ],
                            [
                                130.55798,
                                31.40338
                            ],
                            [
                                130.51765,
                                31.46711
                            ],
                            [
                                130.5671,
                                31.58792
                            ],
                            [
                                130.63249,
                                31.70238
                            ],
                            [
                                130.69743,
                                31.72108
                            ],
                            [
                                130.79598,
                                31.69007
                            ],
                            [
                                130.82033,
                                31.64731
                            ],
                            [
                                130.78103,
                                31.5713
                            ],
                            [
                                130.72478,
                                31.55162
                            ],
                            [
                                130.69929,
                                31.61648
                            ],
                            [
                                130.62722,
                                31.61469
                            ],
                            [
                                130.59606,
                                31.57116
                            ],
                            [
                                130.70323,
                                31.54067
                            ],
                            [
                                130.70288,
                                31.46175
                            ],
                            [
                                130.75668,
                                31.41465
                            ],
                            [
                                130.80198,
                                31.32519
                            ],
                            [
                                130.79109,
                                31.24704
                            ],
                            [
                                130.73069,
                                31.11358
                            ],
                            [
                                130.66498,
                                31.06834
                            ],
                            [
                                130.7258,
                                31.03664
                            ],
                            [
                                130.91126,
                                31.10335
                            ],
                            [
                                130.97877,
                                31.14341
                            ],
                            [
                                131.02189,
                                31.21322
                            ],
                            [
                                131.06437,
                                31.21952
                            ],
                            [
                                131.10688,
                                31.32508
                            ],
                            [
                                131.01798,
                                31.35508
                            ],
                            [
                                131.03875,
                                31.41017
                            ],
                            [
                                131.12024,
                                31.46251
                            ],
                            [
                                131.21783,
                                31.4304
                            ],
                            [
                                131.25479,
                                31.37589
                            ],
                            [
                                131.33541,
                                31.38209
                            ],
                            [
                                131.38983,
                                31.4784
                            ],
                            [
                                131.38623,
                                31.54388
                            ],
                            [
                                131.46072,
                                31.6165
                            ],
                            [
                                131.48728,
                                31.77693
                            ],
                            [
                                131.45039,
                                31.80729
                            ],
                            [
                                131.47018,
                                31.9301
                            ],
                            [
                                131.54428,
                                32.11813
                            ],
                            [
                                131.5947,
                                32.28814
                            ],
                            [
                                131.63203,
                                32.34077
                            ],
                            [
                                131.71117,
                                32.57716
                            ],
                            [
                                131.77455,
                                32.65019
                            ],
                            [
                                131.88652,
                                32.73954
                            ],
                            [
                                131.89811,
                                32.79384
                            ],
                            [
                                132.01091,
                                32.88112
                            ],
                            [
                                132.00952,
                                32.92855
                            ],
                            [
                                131.90192,
                                32.98571
                            ],
                            [
                                131.93172,
                                33.03514
                            ],
                            [
                                131.81193,
                                33.12025
                            ],
                            [
                                131.8778,
                                33.19147
                            ],
                            [
                                131.88363,
                                33.25868
                            ],
                            [
                                131.76718,
                                33.23643
                            ],
                            [
                                131.68866,
                                33.26607
                            ],
                            [
                                131.5976,
                                33.24328
                            ],
                            [
                                131.51373,
                                33.26967
                            ],
                            [
                                131.51007,
                                33.35341
                            ],
                            [
                                131.61202,
                                33.36532
                            ],
                            [
                                131.70544,
                                33.40275
                            ],
                            [
                                131.75017,
                                33.53729
                            ],
                            [
                                131.69961,
                                33.63229
                            ],
                            [
                                131.59043,
                                33.68637
                            ],
                            [
                                131.50844,
                                33.6686
                            ],
                            [
                                131.43357,
                                33.56672
                            ],
                            [
                                131.28929,
                                33.57647
                            ],
                            [
                                131.20891,
                                33.61233
                            ],
                            [
                                131.10636,
                                33.61563
                            ],
                            [
                                131.02475,
                                33.72853
                            ],
                            [
                                131.01346,
                                33.80763
                            ],
                            [
                                130.96826,
                                33.81678
                            ],
                            [
                                131.02602,
                                33.95222
                            ],
                            [
                                130.88832,
                                33.91861
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                133.61909,
                                34.21536
                            ],
                            [
                                133.64885,
                                34.18598
                            ],
                            [
                                133.63305,
                                34.05352
                            ],
                            [
                                133.50222,
                                33.96555
                            ],
                            [
                                133.32707,
                                33.98993
                            ],
                            [
                                133.15751,
                                33.91865
                            ],
                            [
                                133.07805,
                                33.95833
                            ],
                            [
                                133.0422,
                                34.03529
                            ],
                            [
                                132.94917,
                                34.13201
                            ],
                            [
                                132.92409,
                                34.0645
                            ],
                            [
                                132.77358,
                                33.99707
                            ],
                            [
                                132.75843,
                                33.91111
                            ],
                            [
                                132.70713,
                                33.87882
                            ],
                            [
                                132.70158,
                                33.7606
                            ],
                            [
                                132.6539,
                                33.69464
                            ],
                            [
                                132.4838,
                                33.61209
                            ],
                            [
                                132.32347,
                                33.45603
                            ],
                            [
                                132.39632,
                                33.46658
                            ],
                            [
                                132.38576,
                                33.38021
                            ],
                            [
                                132.41835,
                                33.30184
                            ],
                            [
                                132.55522,
                                33.22408
                            ],
                            [
                                132.43432,
                                33.1536
                            ],
                            [
                                132.46668,
                                33.11987
                            ],
                            [
                                132.49964,
                                32.97453
                            ],
                            [
                                132.61143,
                                32.90817
                            ],
                            [
                                132.71814,
                                32.91049
                            ],
                            [
                                132.63983,
                                32.79003
                            ],
                            [
                                132.71807,
                                32.78694
                            ],
                            [
                                132.80254,
                                32.74325
                            ],
                            [
                                132.85796,
                                32.77644
                            ],
                            [
                                132.96213,
                                32.76441
                            ],
                            [
                                132.96003,
                                32.85292
                            ],
                            [
                                133.01288,
                                32.87995
                            ],
                            [
                                133.0083,
                                32.98706
                            ],
                            [
                                133.1008,
                                33.01965
                            ],
                            [
                                133.18973,
                                33.15304
                            ],
                            [
                                133.22585,
                                33.16169
                            ],
                            [
                                133.26541,
                                33.25472
                            ],
                            [
                                133.24481,
                                33.32055
                            ],
                            [
                                133.27488,
                                33.36493
                            ],
                            [
                                133.40843,
                                33.39763
                            ],
                            [
                                133.60028,
                                33.51285
                            ],
                            [
                                133.74449,
                                33.53048
                            ],
                            [
                                133.93301,
                                33.48119
                            ],
                            [
                                134.03164,
                                33.40681
                            ],
                            [
                                134.04584,
                                33.36798
                            ],
                            [
                                134.18405,
                                33.2485
                            ],
                            [
                                134.22565,
                                33.40863
                            ],
                            [
                                134.25371,
                                33.46478
                            ],
                            [
                                134.40129,
                                33.64903
                            ],
                            [
                                134.50551,
                                33.69194
                            ],
                            [
                                134.58659,
                                33.76229
                            ],
                            [
                                134.73354,
                                33.82548
                            ],
                            [
                                134.64256,
                                33.86503
                            ],
                            [
                                134.70253,
                                33.91587
                            ],
                            [
                                134.5956,
                                34.06114
                            ],
                            [
                                134.64083,
                                34.16973
                            ],
                            [
                                134.57311,
                                34.22077
                            ],
                            [
                                134.44787,
                                34.20902
                            ],
                            [
                                134.39151,
                                34.25415
                            ],
                            [
                                134.2692,
                                34.28684
                            ],
                            [
                                134.27163,
                                34.32471
                            ],
                            [
                                134.14205,
                                34.39542
                            ],
                            [
                                134.08598,
                                34.34332
                            ],
                            [
                                133.93593,
                                34.38366
                            ],
                            [
                                133.87707,
                                34.33135
                            ],
                            [
                                133.69584,
                                34.22909
                            ],
                            [
                                133.61909,
                                34.21536
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                128.16651,
                                26.62393
                            ],
                            [
                                128.23155,
                                26.627
                            ],
                            [
                                128.32364,
                                26.74309
                            ],
                            [
                                128.32286,
                                26.80704
                            ],
                            [
                                128.26917,
                                26.86192
                            ],
                            [
                                128.22722,
                                26.79061
                            ],
                            [
                                128.12192,
                                26.70048
                            ],
                            [
                                128.09406,
                                26.65403
                            ],
                            [
                                128.01696,
                                26.62831
                            ],
                            [
                                127.96778,
                                26.69917
                            ],
                            [
                                127.88558,
                                26.69975
                            ],
                            [
                                127.89054,
                                26.61503
                            ],
                            [
                                127.97953,
                                26.58234
                            ],
                            [
                                127.97345,
                                26.54886
                            ],
                            [
                                127.86372,
                                26.50482
                            ],
                            [
                                127.79818,
                                26.43436
                            ],
                            [
                                127.72,
                                26.39649
                            ],
                            [
                                127.75813,
                                26.31805
                            ],
                            [
                                127.68802,
                                26.21989
                            ],
                            [
                                127.65946,
                                26.08751
                            ],
                            [
                                127.72394,
                                26.08432
                            ],
                            [
                                127.77131,
                                26.12656
                            ],
                            [
                                127.76675,
                                26.20562
                            ],
                            [
                                127.81864,
                                26.29473
                            ],
                            [
                                127.87811,
                                26.3528
                            ],
                            [
                                127.84064,
                                26.40797
                            ],
                            [
                                127.87745,
                                26.45029
                            ],
                            [
                                127.94983,
                                26.43409
                            ],
                            [
                                128.00207,
                                26.50197
                            ],
                            [
                                128.15087,
                                26.56733
                            ],
                            [
                                128.16651,
                                26.62393
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                138.21175,
                                37.81815
                            ],
                            [
                                138.25237,
                                37.80158
                            ],
                            [
                                138.36369,
                                37.82678
                            ],
                            [
                                138.5052,
                                37.92023
                            ],
                            [
                                138.57456,
                                38.05552
                            ],
                            [
                                138.56196,
                                38.08739
                            ],
                            [
                                138.42667,
                                38.06493
                            ],
                            [
                                138.49768,
                                38.20751
                            ],
                            [
                                138.51585,
                                38.30642
                            ],
                            [
                                138.33282,
                                38.19678
                            ],
                            [
                                138.24394,
                                38.08474
                            ],
                            [
                                138.22587,
                                38.01996
                            ],
                            [
                                138.33346,
                                37.98897
                            ],
                            [
                                138.28521,
                                37.86793
                            ],
                            [
                                138.21175,
                                37.81815
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                129.14261,
                                28.24634
                            ],
                            [
                                129.25571,
                                28.20379
                            ],
                            [
                                129.29553,
                                28.14707
                            ],
                            [
                                129.36087,
                                28.12704
                            ],
                            [
                                129.45374,
                                28.19046
                            ],
                            [
                                129.43416,
                                28.23077
                            ],
                            [
                                129.53757,
                                28.30214
                            ],
                            [
                                129.6585,
                                28.42458
                            ],
                            [
                                129.60055,
                                28.46676
                            ],
                            [
                                129.52075,
                                28.43257
                            ],
                            [
                                129.49764,
                                28.38
                            ],
                            [
                                129.40525,
                                28.37685
                            ],
                            [
                                129.22292,
                                28.29579
                            ],
                            [
                                129.21158,
                                28.24896
                            ],
                            [
                                129.14261,
                                28.24634
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                134.90339,
                                34.4173
                            ],
                            [
                                134.98404,
                                34.49958
                            ],
                            [
                                135.02982,
                                34.58571
                            ],
                            [
                                134.99976,
                                34.60722
                            ],
                            [
                                134.79923,
                                34.44644
                            ],
                            [
                                134.74247,
                                34.34573
                            ],
                            [
                                134.69034,
                                34.3251
                            ],
                            [
                                134.66377,
                                34.26806
                            ],
                            [
                                134.73999,
                                34.18778
                            ],
                            [
                                134.79563,
                                34.19378
                            ],
                            [
                                134.95943,
                                34.26824
                            ],
                            [
                                134.90055,
                                34.35105
                            ],
                            [
                                134.90339,
                                34.4173
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                130.21037,
                                32.46085
                            ],
                            [
                                130.19296,
                                32.54318
                            ],
                            [
                                130.06521,
                                32.51231
                            ],
                            [
                                129.98152,
                                32.36226
                            ],
                            [
                                130.01903,
                                32.29135
                            ],
                            [
                                129.97724,
                                32.24557
                            ],
                            [
                                130.03824,
                                32.19342
                            ],
                            [
                                130.21734,
                                32.33165
                            ],
                            [
                                130.21037,
                                32.46085
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                130.38241,
                                30.36423
                            ],
                            [
                                130.42028,
                                30.26826
                            ],
                            [
                                130.45771,
                                30.23116
                            ],
                            [
                                130.53122,
                                30.22444
                            ],
                            [
                                130.60878,
                                30.25178
                            ],
                            [
                                130.66626,
                                30.31551
                            ],
                            [
                                130.67299,
                                30.37856
                            ],
                            [
                                130.5582,
                                30.43347
                            ],
                            [
                                130.47174,
                                30.44729
                            ],
                            [
                                130.38241,
                                30.36423
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                129.37728,
                                34.4173
                            ],
                            [
                                129.37674,
                                34.44783
                            ],
                            [
                                129.47691,
                                34.55487
                            ],
                            [
                                129.49722,
                                34.66249
                            ],
                            [
                                129.42348,
                                34.69168
                            ],
                            [
                                129.39252,
                                34.64799
                            ],
                            [
                                129.32625,
                                34.64051
                            ],
                            [
                                129.32913,
                                34.54526
                            ],
                            [
                                129.27852,
                                34.46566
                            ],
                            [
                                129.27592,
                                34.37403
                            ],
                            [
                                129.37113,
                                34.33115
                            ],
                            [
                                129.37728,
                                34.4173
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                130.88832,
                                30.4779
                            ],
                            [
                                130.85362,
                                30.44871
                            ],
                            [
                                130.88219,
                                30.33807
                            ],
                            [
                                130.98387,
                                30.39266
                            ],
                            [
                                130.96944,
                                30.47471
                            ],
                            [
                                131.03123,
                                30.55806
                            ],
                            [
                                131.07684,
                                30.68916
                            ],
                            [
                                131.08586,
                                30.78323
                            ],
                            [
                                131.00874,
                                30.77538
                            ],
                            [
                                130.9451,
                                30.66451
                            ],
                            [
                                130.95477,
                                30.57616
                            ],
                            [
                                130.88832,
                                30.4779
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                128.60241,
                                32.61044
                            ],
                            [
                                128.64131,
                                32.58956
                            ],
                            [
                                128.73143,
                                32.60204
                            ],
                            [
                                128.85311,
                                32.68494
                            ],
                            [
                                128.8109,
                                32.76569
                            ],
                            [
                                128.69596,
                                32.73704
                            ],
                            [
                                128.67016,
                                32.66153
                            ],
                            [
                                128.60241,
                                32.61044
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                133.17903,
                                36.25164
                            ],
                            [
                                133.24039,
                                36.16571
                            ],
                            [
                                133.34283,
                                36.16649
                            ],
                            [
                                133.3827,
                                36.22678
                            ],
                            [
                                133.32481,
                                36.32088
                            ],
                            [
                                133.24646,
                                36.32719
                            ],
                            [
                                133.17903,
                                36.25164
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                123.66287,
                                24.30079
                            ],
                            [
                                123.86068,
                                24.25206
                            ],
                            [
                                123.93903,
                                24.35722
                            ],
                            [
                                123.80923,
                                24.40603
                            ],
                            [
                                123.75677,
                                24.40048
                            ],
                            [
                                123.74713,
                                24.32127
                            ],
                            [
                                123.66287,
                                24.30079
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                129.17035,
                                34.1368
                            ],
                            [
                                129.23171,
                                34.09122
                            ],
                            [
                                129.28142,
                                34.12781
                            ],
                            [
                                129.30085,
                                34.21486
                            ],
                            [
                                129.34359,
                                34.29333
                            ],
                            [
                                129.29485,
                                34.31424
                            ],
                            [
                                129.22324,
                                34.29291
                            ],
                            [
                                129.17035,
                                34.1368
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                128.88423,
                                27.71348
                            ],
                            [
                                128.94188,
                                27.65481
                            ],
                            [
                                128.98492,
                                27.66543
                            ],
                            [
                                129.03798,
                                27.75826
                            ],
                            [
                                128.97006,
                                27.8207
                            ],
                            [
                                128.96927,
                                27.88604
                            ],
                            [
                                128.89725,
                                27.88361
                            ],
                            [
                                128.90604,
                                27.75767
                            ],
                            [
                                128.88423,
                                27.71348
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                130.21413,
                                32.44128
                            ],
                            [
                                130.22974,
                                32.41165
                            ],
                            [
                                130.36021,
                                32.37458
                            ],
                            [
                                130.40587,
                                32.38756
                            ],
                            [
                                130.46554,
                                32.5204
                            ],
                            [
                                130.36423,
                                32.52188
                            ],
                            [
                                130.21413,
                                32.44128
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                141.12955,
                                45.18354
                            ],
                            [
                                141.23731,
                                45.09701
                            ],
                            [
                                141.33504,
                                45.15333
                            ],
                            [
                                141.27921,
                                45.23204
                            ],
                            [
                                141.20114,
                                45.2571
                            ],
                            [
                                141.12955,
                                45.18354
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                124.07157,
                                24.42494
                            ],
                            [
                                124.16593,
                                24.32945
                            ],
                            [
                                124.2556,
                                24.36875
                            ],
                            [
                                124.26263,
                                24.46893
                            ],
                            [
                                124.07157,
                                24.42494
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                128.9986,
                                32.93803
                            ],
                            [
                                129.06729,
                                32.89851
                            ],
                            [
                                129.18527,
                                32.96999
                            ],
                            [
                                129.17261,
                                32.99925
                            ],
                            [
                                129.04676,
                                32.98502
                            ],
                            [
                                128.9986,
                                32.93803
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                129.51947,
                                33.32267
                            ],
                            [
                                129.44627,
                                33.28966
                            ],
                            [
                                129.38534,
                                33.20471
                            ],
                            [
                                129.46853,
                                33.2094
                            ],
                            [
                                129.51947,
                                33.32267
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                139.40819,
                                42.15991
                            ],
                            [
                                139.42515,
                                42.06873
                            ],
                            [
                                139.50853,
                                42.09427
                            ],
                            [
                                139.53722,
                                42.22945
                            ],
                            [
                                139.44263,
                                42.21198
                            ],
                            [
                                139.40819,
                                42.15991
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                134.24991,
                                34.4173
                            ],
                            [
                                134.36413,
                                34.52641
                            ],
                            [
                                134.35342,
                                34.56296
                            ],
                            [
                                134.24266,
                                34.52806
                            ],
                            [
                                134.24991,
                                34.4173
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                125.25735,
                                24.90349
                            ],
                            [
                                125.29539,
                                24.84247
                            ],
                            [
                                125.26631,
                                24.78232
                            ],
                            [
                                125.31023,
                                24.7105
                            ],
                            [
                                125.4421,
                                24.75135
                            ],
                            [
                                125.33575,
                                24.80478
                            ],
                            [
                                125.25735,
                                24.90349
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                132.24702,
                                33.87162
                            ],
                            [
                                132.32046,
                                33.88612
                            ],
                            [
                                132.2891,
                                33.95147
                            ],
                            [
                                132.18732,
                                33.94449
                            ],
                            [
                                132.18243,
                                33.89238
                            ],
                            [
                                132.24702,
                                33.87162
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                129.64749,
                                33.74612
                            ],
                            [
                                129.69795,
                                33.70533
                            ],
                            [
                                129.79909,
                                33.75506
                            ],
                            [
                                129.70455,
                                33.8531
                            ],
                            [
                                129.64749,
                                33.74612
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                140.9678,
                                45.46148
                            ],
                            [
                                140.98551,
                                45.37559
                            ],
                            [
                                141.05193,
                                45.27554
                            ],
                            [
                                141.06964,
                                45.42052
                            ],
                            [
                                140.9678,
                                45.46148
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                132.37764,
                                34.25594
                            ],
                            [
                                132.38972,
                                34.22016
                            ],
                            [
                                132.49364,
                                34.14004
                            ],
                            [
                                132.49177,
                                34.28287
                            ],
                            [
                                132.37764,
                                34.25594
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                139.35641,
                                34.75776
                            ],
                            [
                                139.36702,
                                34.70262
                            ],
                            [
                                139.45195,
                                34.68151
                            ],
                            [
                                139.45638,
                                34.74614
                            ],
                            [
                                139.42221,
                                34.79076
                            ],
                            [
                                139.35641,
                                34.75776
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                130.21037,
                                32.14405
                            ],
                            [
                                130.18757,
                                32.22531
                            ],
                            [
                                130.10151,
                                32.17902
                            ],
                            [
                                130.16295,
                                32.08552
                            ],
                            [
                                130.21037,
                                32.14405
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                128.52271,
                                27.37333
                            ],
                            [
                                128.59026,
                                27.32283
                            ],
                            [
                                128.62738,
                                27.39964
                            ],
                            [
                                128.52271,
                                27.37333
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                129.8044,
                                31.77777
                            ],
                            [
                                129.71353,
                                31.71662
                            ],
                            [
                                129.67153,
                                31.62784
                            ],
                            [
                                129.71595,
                                31.61554
                            ],
                            [
                                129.74546,
                                31.69419
                            ],
                            [
                                129.8044,
                                31.77777
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                139.74547,
                                33.13681
                            ],
                            [
                                139.78853,
                                33.06746
                            ],
                            [
                                139.8569,
                                33.10802
                            ],
                            [
                                139.78059,
                                33.15531
                            ],
                            [
                                139.74547,
                                33.13681
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                126.712,
                                26.35644
                            ],
                            [
                                126.79647,
                                26.29419
                            ],
                            [
                                126.82264,
                                26.3485
                            ],
                            [
                                126.77414,
                                26.38842
                            ],
                            [
                                126.712,
                                26.35644
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "JOR",
                "Country": "Jordan",
                "Total_3GHG": 0.04,
                "Total_3GHG_timeseries": [
                    2.6304e-08,
                    5.2824e-08,
                    7.9557e-08,
                    1.0649e-07,
                    1.336e-07,
                    1.6089e-07,
                    1.8832e-07,
                    2.1588e-07,
                    2.4354e-07,
                    2.7088e-07,
                    2.9811e-07,
                    3.253e-07,
                    3.5249e-07,
                    3.797e-07,
                    4.0695e-07,
                    4.3423e-07,
                    4.6158e-07,
                    4.8898e-07,
                    5.1645e-07,
                    5.5349e-07,
                    5.9875e-07,
                    6.5067e-07,
                    7.0854e-07,
                    7.72e-07,
                    8.4081e-07,
                    9.1481e-07,
                    9.9377e-07,
                    1.0775e-06,
                    1.1656e-06,
                    1.2589e-06,
                    1.3535e-06,
                    1.4493e-06,
                    1.5459e-06,
                    1.6434e-06,
                    1.7416e-06,
                    1.8405e-06,
                    1.94e-06,
                    2.04e-06,
                    2.1406e-06,
                    2.2417e-06,
                    2.3401e-06,
                    2.4359e-06,
                    2.5291e-06,
                    2.6198e-06,
                    2.7079e-06,
                    2.7934e-06,
                    2.8764e-06,
                    2.9569e-06,
                    3.0347e-06,
                    3.1126e-06,
                    3.1892e-06,
                    3.2641e-06,
                    3.3376e-06,
                    3.4087e-06,
                    3.4778e-06,
                    3.5448e-06,
                    3.6098e-06,
                    3.6727e-06,
                    3.7333e-06,
                    3.7909e-06,
                    3.8466e-06,
                    3.9007e-06,
                    3.9534e-06,
                    4.0045e-06,
                    4.054e-06,
                    4.102e-06,
                    4.1488e-06,
                    4.1942e-06,
                    4.2383e-06,
                    4.283e-06,
                    4.3332e-06,
                    4.3884e-06,
                    4.4489e-06,
                    4.5148e-06,
                    4.5861e-06,
                    4.6626e-06,
                    4.7442e-06,
                    4.8309e-06,
                    4.9225e-06,
                    5.028e-06,
                    5.1428e-06,
                    5.265e-06,
                    5.3937e-06,
                    5.5277e-06,
                    5.6669e-06,
                    5.8177e-06,
                    5.98e-06,
                    6.154e-06,
                    6.3395e-06,
                    6.5342e-06,
                    6.7409e-06,
                    6.9623e-06,
                    7.2003e-06,
                    7.456e-06,
                    7.7364e-06,
                    8.0418e-06,
                    8.3726e-06,
                    8.7295e-06,
                    9.1121e-06,
                    9.7394e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006
                ],
                "Fossil_3GHG": 0.05,
                "Fossil_3GHG_timeseries": [
                    1.1706e-08,
                    2.3472e-08,
                    3.5296e-08,
                    4.7173e-08,
                    5.9096e-08,
                    7.106e-08,
                    8.3054e-08,
                    9.507e-08,
                    1.071e-07,
                    1.1912e-07,
                    1.3113e-07,
                    1.4313e-07,
                    1.5511e-07,
                    1.6707e-07,
                    1.7901e-07,
                    1.9094e-07,
                    2.0285e-07,
                    2.1474e-07,
                    2.2662e-07,
                    2.3848e-07,
                    2.5245e-07,
                    2.6862e-07,
                    2.8708e-07,
                    3.0789e-07,
                    3.3107e-07,
                    3.5663e-07,
                    3.8454e-07,
                    4.1476e-07,
                    4.472e-07,
                    4.8178e-07,
                    5.1638e-07,
                    5.51e-07,
                    5.8563e-07,
                    6.2026e-07,
                    6.5488e-07,
                    6.8949e-07,
                    7.2409e-07,
                    7.5869e-07,
                    7.9328e-07,
                    8.2789e-07,
                    8.6058e-07,
                    8.9137e-07,
                    9.2025e-07,
                    9.4724e-07,
                    9.7234e-07,
                    9.9557e-07,
                    1.0169e-06,
                    1.0364e-06,
                    1.0541e-06,
                    1.0699e-06,
                    1.0832e-06,
                    1.0941e-06,
                    1.1025e-06,
                    1.1085e-06,
                    1.1122e-06,
                    1.1135e-06,
                    1.1126e-06,
                    1.1093e-06,
                    1.1038e-06,
                    1.096e-06,
                    1.0865e-06,
                    1.0754e-06,
                    1.0625e-06,
                    1.0479e-06,
                    1.0316e-06,
                    1.0136e-06,
                    9.9397e-07,
                    9.7261e-07,
                    9.4957e-07,
                    9.2484e-07,
                    9.0238e-07,
                    8.8211e-07,
                    8.6395e-07,
                    8.4779e-07,
                    8.3354e-07,
                    8.2113e-07,
                    8.1045e-07,
                    8.0142e-07,
                    7.9393e-07,
                    7.8791e-07,
                    7.8312e-07,
                    7.7959e-07,
                    7.7734e-07,
                    7.7637e-07,
                    7.7666e-07,
                    7.7819e-07,
                    7.8091e-07,
                    7.8477e-07,
                    7.8969e-07,
                    7.9844e-07,
                    8.1123e-07,
                    8.2865e-07,
                    8.5121e-07,
                    8.7928e-07,
                    9.1846e-07,
                    9.6923e-07,
                    1.032e-06,
                    1.1069e-06,
                    1.1942e-06,
                    1.3747e-06,
                    1.578e-06,
                    1.8214e-06,
                    2.0971e-06,
                    2.4163e-06,
                    2.8237e-06,
                    3.2967e-06,
                    3.8276e-06,
                    4.4133e-06,
                    5.1035e-06,
                    5.8744e-06,
                    6.7919e-06,
                    7.7807e-06,
                    8.8923e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Land_3GHG": 0.01,
                "Land_3GHG_timeseries": [
                    1.4598e-08,
                    2.9352e-08,
                    4.426e-08,
                    5.9317e-08,
                    7.4507e-08,
                    8.9829e-08,
                    1.0527e-07,
                    1.2081e-07,
                    1.3644e-07,
                    1.5176e-07,
                    1.6698e-07,
                    1.8217e-07,
                    1.9738e-07,
                    2.1263e-07,
                    2.2793e-07,
                    2.433e-07,
                    2.5873e-07,
                    2.7424e-07,
                    2.8984e-07,
                    3.1501e-07,
                    3.463e-07,
                    3.8205e-07,
                    4.2146e-07,
                    4.6411e-07,
                    5.0974e-07,
                    5.5818e-07,
                    6.0923e-07,
                    6.6271e-07,
                    7.1844e-07,
                    7.7711e-07,
                    8.3714e-07,
                    8.9826e-07,
                    9.603e-07,
                    1.0232e-06,
                    1.0867e-06,
                    1.151e-06,
                    1.2159e-06,
                    1.2813e-06,
                    1.3473e-06,
                    1.4138e-06,
                    1.4795e-06,
                    1.5445e-06,
                    1.6089e-06,
                    1.6725e-06,
                    1.7355e-06,
                    1.7979e-06,
                    1.8595e-06,
                    1.9204e-06,
                    1.9807e-06,
                    2.0426e-06,
                    2.1059e-06,
                    2.17e-06,
                    2.2351e-06,
                    2.3002e-06,
                    2.3656e-06,
                    2.4312e-06,
                    2.4973e-06,
                    2.5634e-06,
                    2.6295e-06,
                    2.6949e-06,
                    2.7601e-06,
                    2.8254e-06,
                    2.8909e-06,
                    2.9566e-06,
                    3.0224e-06,
                    3.0884e-06,
                    3.1548e-06,
                    3.2216e-06,
                    3.2887e-06,
                    3.3582e-06,
                    3.4308e-06,
                    3.5063e-06,
                    3.585e-06,
                    3.667e-06,
                    3.7525e-06,
                    3.8415e-06,
                    3.9338e-06,
                    4.0295e-06,
                    4.1285e-06,
                    4.2401e-06,
                    4.3597e-06,
                    4.4854e-06,
                    4.6163e-06,
                    4.7513e-06,
                    4.8902e-06,
                    5.0395e-06,
                    5.1991e-06,
                    5.3692e-06,
                    5.5498e-06,
                    5.7358e-06,
                    5.9297e-06,
                    6.1336e-06,
                    6.3491e-06,
                    6.5767e-06,
                    6.8179e-06,
                    7.0725e-06,
                    7.3406e-06,
                    7.6226e-06,
                    7.9179e-06,
                    8.3648e-06,
                    8.868e-06,
                    9.4036e-06,
                    9.9685e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001
                ],
                "Total_CO2": 0.03,
                "Total_CO2_timeseries": [
                    4.158e-09,
                    8.3435e-09,
                    1.2562e-08,
                    1.6814e-08,
                    2.1092e-08,
                    2.541e-08,
                    2.9766e-08,
                    3.416e-08,
                    3.8599e-08,
                    4.2702e-08,
                    4.669e-08,
                    5.0639e-08,
                    5.4598e-08,
                    5.8591e-08,
                    6.2634e-08,
                    6.6731e-08,
                    7.0895e-08,
                    7.5125e-08,
                    7.9431e-08,
                    9.3302e-08,
                    1.122e-07,
                    1.3428e-07,
                    1.586e-07,
                    1.8466e-07,
                    2.1212e-07,
                    2.4081e-07,
                    2.7055e-07,
                    3.0125e-07,
                    3.3282e-07,
                    3.6612e-07,
                    4.0064e-07,
                    4.3613e-07,
                    4.7245e-07,
                    5.0949e-07,
                    5.4719e-07,
                    5.8548e-07,
                    6.2431e-07,
                    6.6362e-07,
                    7.0339e-07,
                    7.4311e-07,
                    7.8292e-07,
                    8.2291e-07,
                    8.6309e-07,
                    9.0346e-07,
                    9.4403e-07,
                    9.8475e-07,
                    1.0256e-06,
                    1.0667e-06,
                    1.1078e-06,
                    1.1516e-06,
                    1.1967e-06,
                    1.2426e-06,
                    1.2896e-06,
                    1.3366e-06,
                    1.3839e-06,
                    1.4315e-06,
                    1.4794e-06,
                    1.5275e-06,
                    1.5754e-06,
                    1.6228e-06,
                    1.6696e-06,
                    1.7162e-06,
                    1.7627e-06,
                    1.8091e-06,
                    1.8553e-06,
                    1.9013e-06,
                    1.9476e-06,
                    1.9937e-06,
                    2.0398e-06,
                    2.0879e-06,
                    2.1372e-06,
                    2.1872e-06,
                    2.2379e-06,
                    2.2893e-06,
                    2.3414e-06,
                    2.3942e-06,
                    2.4474e-06,
                    2.5012e-06,
                    2.5556e-06,
                    2.6201e-06,
                    2.6901e-06,
                    2.764e-06,
                    2.8408e-06,
                    2.9194e-06,
                    2.9996e-06,
                    3.0815e-06,
                    3.1646e-06,
                    3.249e-06,
                    3.3344e-06,
                    3.4154e-06,
                    3.4943e-06,
                    3.5723e-06,
                    3.6499e-06,
                    3.727e-06,
                    3.8044e-06,
                    3.8818e-06,
                    3.9591e-06,
                    4.0366e-06,
                    4.114e-06,
                    4.4075e-06,
                    4.7129e-06,
                    5.0325e-06,
                    5.3589e-06,
                    5.7106e-06,
                    6.1383e-06,
                    6.6221e-06,
                    7.1322e-06,
                    7.6564e-06,
                    8.2129e-06,
                    8.8333e-06,
                    9.4727e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_CO2": 0.04,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    7.755e-08,
                    1.5015e-07,
                    2.376e-07,
                    3.333e-07,
                    4.4703e-07,
                    6.1847e-07,
                    8.2127e-07,
                    1.0438e-06,
                    1.2796e-06,
                    1.5747e-06,
                    1.9094e-06,
                    2.3495e-06,
                    2.821e-06,
                    3.3699e-06,
                    3.9287e-06,
                    4.5684e-06,
                    5.2805e-06,
                    5.9168e-06,
                    6.5941e-06,
                    7.3852e-06,
                    8.0858e-06,
                    8.8308e-06,
                    9.6926e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [
                    4.158e-09,
                    8.3435e-09,
                    1.2562e-08,
                    1.6814e-08,
                    2.1092e-08,
                    2.541e-08,
                    2.9766e-08,
                    3.416e-08,
                    3.8599e-08,
                    4.2702e-08,
                    4.669e-08,
                    5.0639e-08,
                    5.4598e-08,
                    5.8591e-08,
                    6.2634e-08,
                    6.6731e-08,
                    7.0895e-08,
                    7.5125e-08,
                    7.9431e-08,
                    9.3302e-08,
                    1.122e-07,
                    1.3428e-07,
                    1.586e-07,
                    1.8466e-07,
                    2.1212e-07,
                    2.4081e-07,
                    2.7055e-07,
                    3.0125e-07,
                    3.3282e-07,
                    3.6612e-07,
                    4.0064e-07,
                    4.3613e-07,
                    4.7245e-07,
                    5.0949e-07,
                    5.4719e-07,
                    5.8548e-07,
                    6.2431e-07,
                    6.6362e-07,
                    7.0339e-07,
                    7.4311e-07,
                    7.8292e-07,
                    8.2291e-07,
                    8.6309e-07,
                    9.0346e-07,
                    9.4403e-07,
                    9.8475e-07,
                    1.0256e-06,
                    1.0667e-06,
                    1.1078e-06,
                    1.1516e-06,
                    1.1967e-06,
                    1.2426e-06,
                    1.2896e-06,
                    1.3366e-06,
                    1.3839e-06,
                    1.4315e-06,
                    1.4794e-06,
                    1.5275e-06,
                    1.5754e-06,
                    1.6228e-06,
                    1.6696e-06,
                    1.7162e-06,
                    1.7627e-06,
                    1.8091e-06,
                    1.8553e-06,
                    1.9013e-06,
                    1.9476e-06,
                    1.9937e-06,
                    2.0398e-06,
                    2.0879e-06,
                    2.1372e-06,
                    2.1872e-06,
                    2.2379e-06,
                    2.2893e-06,
                    2.3414e-06,
                    2.3942e-06,
                    2.4474e-06,
                    2.5012e-06,
                    2.5556e-06,
                    2.6201e-06,
                    2.6901e-06,
                    2.764e-06,
                    2.8408e-06,
                    2.9194e-06,
                    2.9996e-06,
                    3.0815e-06,
                    3.1646e-06,
                    3.249e-06,
                    3.3344e-06,
                    3.4154e-06,
                    3.4943e-06,
                    3.5723e-06,
                    3.6499e-06,
                    3.727e-06,
                    3.8044e-06,
                    3.8818e-06,
                    3.9591e-06,
                    4.0366e-06,
                    4.114e-06,
                    4.33e-06,
                    4.5628e-06,
                    4.7949e-06,
                    5.0256e-06,
                    5.2635e-06,
                    5.5199e-06,
                    5.8008e-06,
                    6.0884e-06,
                    6.3768e-06,
                    6.6381e-06,
                    6.924e-06,
                    7.1231e-06,
                    7.2867e-06,
                    7.4452e-06,
                    7.5598e-06,
                    7.6571e-06,
                    7.7575e-06,
                    7.8406e-06,
                    7.9253e-06,
                    8.0273e-06,
                    8.1144e-06,
                    8.2214e-06,
                    8.316e-06,
                    8.4346e-06,
                    8.5176e-06,
                    8.6013e-06,
                    8.6632e-06,
                    8.7405e-06,
                    8.8187e-06,
                    8.881e-06,
                    8.9077e-06,
                    8.9996e-06,
                    9.1221e-06,
                    8.9813e-06,
                    9.3199e-06,
                    9.543e-06,
                    9.8622e-06,
                    0,
                    0,
                    0,
                    9.9662e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_CH4": 0.05,
                "Total_CH4_timeseries": [
                    1.0601e-08,
                    2.1172e-08,
                    3.1714e-08,
                    4.2227e-08,
                    5.2711e-08,
                    6.3166e-08,
                    7.3591e-08,
                    8.3987e-08,
                    9.4354e-08,
                    1.0469e-07,
                    1.15e-07,
                    1.2527e-07,
                    1.3551e-07,
                    1.4572e-07,
                    1.5589e-07,
                    1.6604e-07,
                    1.7615e-07,
                    1.8623e-07,
                    1.9627e-07,
                    2.0629e-07,
                    2.1928e-07,
                    2.3525e-07,
                    2.542e-07,
                    2.7611e-07,
                    3.0097e-07,
                    3.288e-07,
                    3.5957e-07,
                    3.9329e-07,
                    4.2994e-07,
                    4.6953e-07,
                    5.0906e-07,
                    5.4852e-07,
                    5.8792e-07,
                    6.2726e-07,
                    6.6654e-07,
                    7.0575e-07,
                    7.449e-07,
                    7.8399e-07,
                    8.2301e-07,
                    8.6197e-07,
                    8.9804e-07,
                    9.3121e-07,
                    9.6149e-07,
                    9.8889e-07,
                    1.0134e-06,
                    1.0351e-06,
                    1.0538e-06,
                    1.0697e-06,
                    1.0828e-06,
                    1.093e-06,
                    1.1004e-06,
                    1.1051e-06,
                    1.107e-06,
                    1.1062e-06,
                    1.1028e-06,
                    1.0966e-06,
                    1.0879e-06,
                    1.0765e-06,
                    1.0625e-06,
                    1.0459e-06,
                    1.0276e-06,
                    1.0077e-06,
                    9.8602e-07,
                    9.6269e-07,
                    9.3767e-07,
                    9.1097e-07,
                    8.8258e-07,
                    8.5252e-07,
                    8.2078e-07,
                    7.8736e-07,
                    7.5751e-07,
                    7.3115e-07,
                    7.0817e-07,
                    6.8849e-07,
                    6.7202e-07,
                    6.5866e-07,
                    6.4834e-07,
                    6.4096e-07,
                    6.3644e-07,
                    6.3469e-07,
                    6.3543e-07,
                    6.3859e-07,
                    6.4408e-07,
                    6.5183e-07,
                    6.6176e-07,
                    6.8031e-07,
                    7.0764e-07,
                    7.439e-07,
                    7.8924e-07,
                    8.4668e-07,
                    9.1577e-07,
                    9.969e-07,
                    1.0904e-06,
                    1.1968e-06,
                    1.3216e-06,
                    1.4657e-06,
                    1.6298e-06,
                    1.8145e-06,
                    2.0206e-06,
                    2.2521e-06,
                    2.5484e-06,
                    2.8999e-06,
                    3.3034e-06,
                    3.7616e-06,
                    4.2838e-06,
                    4.8733e-06,
                    5.539e-06,
                    6.2881e-06,
                    7.1247e-06,
                    8.0425e-06,
                    8.8273e-06,
                    9.7439e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_CH4": 0.07,
                "Fossil_CH4_timeseries": [
                    6.5168e-09,
                    1.3004e-08,
                    1.946e-08,
                    2.5887e-08,
                    3.2284e-08,
                    3.8651e-08,
                    4.4987e-08,
                    5.1294e-08,
                    5.757e-08,
                    6.3817e-08,
                    7.003e-08,
                    7.621e-08,
                    8.2357e-08,
                    8.8471e-08,
                    9.4551e-08,
                    1.006e-07,
                    1.0661e-07,
                    1.1259e-07,
                    1.1854e-07,
                    1.2446e-07,
                    1.3238e-07,
                    1.4232e-07,
                    1.5426e-07,
                    1.6819e-07,
                    1.8411e-07,
                    2.0202e-07,
                    2.2192e-07,
                    2.4378e-07,
                    2.6762e-07,
                    2.9342e-07,
                    3.1916e-07,
                    3.4483e-07,
                    3.7043e-07,
                    3.9597e-07,
                    4.2145e-07,
                    4.4686e-07,
                    4.722e-07,
                    4.9748e-07,
                    5.2269e-07,
                    5.4784e-07,
                    5.7099e-07,
                    5.9215e-07,
                    6.1133e-07,
                    6.2854e-07,
                    6.4376e-07,
                    6.5702e-07,
                    6.6832e-07,
                    6.7766e-07,
                    6.8504e-07,
                    6.9048e-07,
                    6.9326e-07,
                    6.9342e-07,
                    6.9097e-07,
                    6.8594e-07,
                    6.7836e-07,
                    6.6823e-07,
                    6.5559e-07,
                    6.4046e-07,
                    6.2286e-07,
                    6.0281e-07,
                    5.8088e-07,
                    5.5705e-07,
                    5.3134e-07,
                    5.0375e-07,
                    4.7428e-07,
                    4.4292e-07,
                    4.0969e-07,
                    3.7458e-07,
                    3.3759e-07,
                    2.9873e-07,
                    2.6195e-07,
                    2.2717e-07,
                    1.9429e-07,
                    1.6321e-07,
                    1.3385e-07,
                    1.0613e-07,
                    7.9939e-08,
                    5.5208e-08,
                    3.1845e-08,
                    9.7671e-09,
                    -0.000000011303,
                    -0.000000031445,
                    -0.000000050737,
                    -0.000000069257,
                    -0.000000087079,
                    -0.00000010428,
                    -0.00000012093,
                    -0.00000013711,
                    -0.00000015288,
                    -0.00000016546,
                    -0.00000017493,
                    -0.00000018119,
                    -0.00000018414,
                    -0.00000018365,
                    -0.0000001743,
                    -0.00000015563,
                    -0.00000012722,
                    -0.000000088607,
                    -0.000000039342,
                    2.4349e-08,
                    1.1489e-07,
                    2.298e-07,
                    3.6807e-07,
                    5.3114e-07,
                    7.2414e-07,
                    9.5069e-07,
                    1.2146e-06,
                    1.5194e-06,
                    1.8683e-06,
                    2.2574e-06,
                    2.6858e-06,
                    3.1512e-06,
                    3.6578e-06,
                    4.2136e-06,
                    4.8296e-06,
                    5.5223e-06,
                    6.3055e-06,
                    7.1923e-06,
                    8.1875e-06,
                    9.1217e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_CH4": 0.02,
                "Land_CH4_timeseries": [
                    4.0838e-09,
                    8.1683e-09,
                    1.2254e-08,
                    1.634e-08,
                    2.0427e-08,
                    2.4515e-08,
                    2.8604e-08,
                    3.2693e-08,
                    3.6783e-08,
                    4.0874e-08,
                    4.4966e-08,
                    4.9059e-08,
                    5.3153e-08,
                    5.7247e-08,
                    6.1342e-08,
                    6.5438e-08,
                    6.9535e-08,
                    7.3633e-08,
                    7.7731e-08,
                    8.1831e-08,
                    8.6899e-08,
                    9.2936e-08,
                    9.9942e-08,
                    1.0792e-07,
                    1.1686e-07,
                    1.2677e-07,
                    1.3765e-07,
                    1.495e-07,
                    1.6232e-07,
                    1.7611e-07,
                    1.899e-07,
                    2.0369e-07,
                    2.1749e-07,
                    2.3129e-07,
                    2.4509e-07,
                    2.5889e-07,
                    2.727e-07,
                    2.8651e-07,
                    3.0032e-07,
                    3.1414e-07,
                    3.2705e-07,
                    3.3905e-07,
                    3.5015e-07,
                    3.6035e-07,
                    3.6964e-07,
                    3.7803e-07,
                    3.8551e-07,
                    3.9209e-07,
                    3.9776e-07,
                    4.0253e-07,
                    4.0717e-07,
                    4.1167e-07,
                    4.1605e-07,
                    4.203e-07,
                    4.2442e-07,
                    4.2841e-07,
                    4.3227e-07,
                    4.3601e-07,
                    4.3961e-07,
                    4.4308e-07,
                    4.4675e-07,
                    4.5061e-07,
                    4.5468e-07,
                    4.5894e-07,
                    4.6339e-07,
                    4.6805e-07,
                    4.729e-07,
                    4.7794e-07,
                    4.8319e-07,
                    4.8863e-07,
                    4.9556e-07,
                    5.0398e-07,
                    5.1388e-07,
                    5.2528e-07,
                    5.3816e-07,
                    5.5254e-07,
                    5.684e-07,
                    5.8575e-07,
                    6.0459e-07,
                    6.2492e-07,
                    6.4673e-07,
                    6.7003e-07,
                    6.9481e-07,
                    7.2108e-07,
                    7.4884e-07,
                    7.8459e-07,
                    8.2857e-07,
                    8.8101e-07,
                    9.4212e-07,
                    1.0121e-06,
                    1.0907e-06,
                    1.1781e-06,
                    1.2746e-06,
                    1.3804e-06,
                    1.4959e-06,
                    1.6214e-06,
                    1.757e-06,
                    1.9031e-06,
                    2.0599e-06,
                    2.2278e-06,
                    2.4335e-06,
                    2.6702e-06,
                    2.9353e-06,
                    3.2304e-06,
                    3.5597e-06,
                    3.9226e-06,
                    4.3244e-06,
                    4.7687e-06,
                    5.2563e-06,
                    5.785e-06,
                    6.1415e-06,
                    6.5927e-06,
                    7.0461e-06,
                    7.5404e-06,
                    8.135e-06,
                    8.7761e-06,
                    9.0774e-06,
                    9.3771e-06,
                    9.7588e-06,
                    9.9966e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_N2O": 0.03,
                "Total_N2O_timeseries": [
                    1.1545e-08,
                    2.3308e-08,
                    3.528e-08,
                    4.7449e-08,
                    5.98e-08,
                    7.2313e-08,
                    8.4966e-08,
                    9.7733e-08,
                    1.1059e-07,
                    1.2349e-07,
                    1.3643e-07,
                    1.4939e-07,
                    1.6238e-07,
                    1.7539e-07,
                    1.8842e-07,
                    2.0147e-07,
                    2.1453e-07,
                    2.2763e-07,
                    2.4075e-07,
                    2.539e-07,
                    2.6727e-07,
                    2.8114e-07,
                    2.9574e-07,
                    3.1124e-07,
                    3.2772e-07,
                    3.452e-07,
                    3.6365e-07,
                    3.8294e-07,
                    4.0288e-07,
                    4.2324e-07,
                    4.4382e-07,
                    4.6461e-07,
                    4.8556e-07,
                    5.0667e-07,
                    5.279e-07,
                    5.4927e-07,
                    5.7076e-07,
                    5.9238e-07,
                    6.1415e-07,
                    6.3659e-07,
                    6.5912e-07,
                    6.8177e-07,
                    7.0453e-07,
                    7.2742e-07,
                    7.5045e-07,
                    7.7362e-07,
                    7.9695e-07,
                    8.2045e-07,
                    8.4412e-07,
                    8.6798e-07,
                    8.9205e-07,
                    9.1637e-07,
                    9.4097e-07,
                    9.6587e-07,
                    9.9109e-07,
                    1.0166e-06,
                    1.0425e-06,
                    1.0688e-06,
                    1.0953e-06,
                    1.1222e-06,
                    1.1494e-06,
                    1.1769e-06,
                    1.2047e-06,
                    1.2327e-06,
                    1.261e-06,
                    1.2897e-06,
                    1.3186e-06,
                    1.348e-06,
                    1.3776e-06,
                    1.4077e-06,
                    1.4384e-06,
                    1.4701e-06,
                    1.5028e-06,
                    1.537e-06,
                    1.5726e-06,
                    1.6098e-06,
                    1.6485e-06,
                    1.6888e-06,
                    1.7304e-06,
                    1.7732e-06,
                    1.8172e-06,
                    1.8624e-06,
                    1.9088e-06,
                    1.9565e-06,
                    2.0055e-06,
                    2.0559e-06,
                    2.1078e-06,
                    2.1611e-06,
                    2.2159e-06,
                    2.2722e-06,
                    2.3308e-06,
                    2.3931e-06,
                    2.46e-06,
                    2.5322e-06,
                    2.6103e-06,
                    2.6942e-06,
                    2.7838e-06,
                    2.8785e-06,
                    2.9776e-06,
                    3.0798e-06,
                    3.1847e-06,
                    3.2925e-06,
                    3.4033e-06,
                    3.5172e-06,
                    3.6343e-06,
                    3.7543e-06,
                    3.8772e-06,
                    4.0027e-06,
                    4.1306e-06,
                    4.2604e-06,
                    4.3778e-06,
                    4.5105e-06,
                    4.6493e-06,
                    4.8099e-06,
                    4.9899e-06,
                    5.174e-06,
                    5.3309e-06,
                    5.495e-06,
                    5.692e-06,
                    5.8663e-06,
                    6.054e-06,
                    6.2491e-06,
                    6.4526e-06,
                    6.6608e-06,
                    6.8677e-06,
                    7.0743e-06,
                    7.2811e-06,
                    7.5034e-06,
                    7.7444e-06,
                    7.9904e-06,
                    8.2463e-06,
                    8.5204e-06,
                    8.8034e-06,
                    9.0837e-06,
                    9.3894e-06,
                    9.6705e-06,
                    9.9763e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_N2O": 0.07,
                "Fossil_N2O_timeseries": [
                    5.1888e-09,
                    1.0468e-08,
                    1.5836e-08,
                    2.1286e-08,
                    2.6812e-08,
                    3.2409e-08,
                    3.8067e-08,
                    4.3776e-08,
                    4.9525e-08,
                    5.5303e-08,
                    6.11e-08,
                    6.6916e-08,
                    7.2748e-08,
                    7.8596e-08,
                    8.446e-08,
                    9.0338e-08,
                    9.6233e-08,
                    1.0214e-07,
                    1.0807e-07,
                    1.1403e-07,
                    1.2006e-07,
                    1.263e-07,
                    1.3283e-07,
                    1.397e-07,
                    1.4696e-07,
                    1.5461e-07,
                    1.6263e-07,
                    1.7098e-07,
                    1.7959e-07,
                    1.8836e-07,
                    1.9722e-07,
                    2.0617e-07,
                    2.152e-07,
                    2.2429e-07,
                    2.3343e-07,
                    2.4263e-07,
                    2.5189e-07,
                    2.6121e-07,
                    2.7059e-07,
                    2.8005e-07,
                    2.8959e-07,
                    2.9921e-07,
                    3.0892e-07,
                    3.187e-07,
                    3.2858e-07,
                    3.3854e-07,
                    3.4861e-07,
                    3.5877e-07,
                    3.6905e-07,
                    3.7945e-07,
                    3.8998e-07,
                    4.0067e-07,
                    4.1154e-07,
                    4.2259e-07,
                    4.3385e-07,
                    4.4531e-07,
                    4.5698e-07,
                    4.6885e-07,
                    4.8093e-07,
                    4.932e-07,
                    5.0566e-07,
                    5.183e-07,
                    5.3113e-07,
                    5.4414e-07,
                    5.5733e-07,
                    5.7072e-07,
                    5.8428e-07,
                    5.9804e-07,
                    6.1198e-07,
                    6.2611e-07,
                    6.4043e-07,
                    6.5494e-07,
                    6.6966e-07,
                    6.8458e-07,
                    6.9969e-07,
                    7.15e-07,
                    7.3051e-07,
                    7.4621e-07,
                    7.6209e-07,
                    7.7814e-07,
                    7.9442e-07,
                    8.1103e-07,
                    8.2808e-07,
                    8.4563e-07,
                    8.6374e-07,
                    8.8247e-07,
                    9.0185e-07,
                    9.2188e-07,
                    9.4257e-07,
                    9.639e-07,
                    9.8616e-07,
                    1.0098e-06,
                    1.0353e-06,
                    1.0629e-06,
                    1.0928e-06,
                    1.1249e-06,
                    1.1592e-06,
                    1.1955e-06,
                    1.2335e-06,
                    1.2728e-06,
                    1.313e-06,
                    1.354e-06,
                    1.3957e-06,
                    1.4381e-06,
                    1.4811e-06,
                    1.5248e-06,
                    1.5692e-06,
                    1.6143e-06,
                    1.6604e-06,
                    1.7076e-06,
                    1.7566e-06,
                    1.8085e-06,
                    1.8645e-06,
                    1.9256e-06,
                    1.9927e-06,
                    2.0667e-06,
                    2.1484e-06,
                    2.2384e-06,
                    2.3374e-06,
                    2.4335e-06,
                    2.5333e-06,
                    2.6363e-06,
                    2.7442e-06,
                    2.8551e-06,
                    2.9701e-06,
                    3.0905e-06,
                    3.2139e-06,
                    3.3442e-06,
                    3.4773e-06,
                    3.6191e-06,
                    3.7712e-06,
                    3.9308e-06,
                    4.0975e-06,
                    4.2684e-06,
                    4.446e-06,
                    4.6231e-06,
                    4.8073e-06,
                    4.993e-06,
                    5.1796e-06,
                    5.3725e-06,
                    5.5915e-06,
                    5.8022e-06,
                    6.013e-06,
                    6.2317e-06,
                    6.4618e-06,
                    6.6994e-06,
                    6.9461e-06,
                    7.1985e-06,
                    7.4545e-06,
                    7.6523e-06,
                    7.882e-06,
                    8.147e-06,
                    8.4391e-06,
                    8.7573e-06,
                    9.0989e-06,
                    9.4448e-06,
                    9.7958e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.02,
                "Land_N2O_timeseries": [
                    6.3563e-09,
                    1.284e-08,
                    1.9445e-08,
                    2.6164e-08,
                    3.2987e-08,
                    3.9904e-08,
                    4.6899e-08,
                    5.3957e-08,
                    6.106e-08,
                    6.8188e-08,
                    7.5328e-08,
                    8.2477e-08,
                    8.9632e-08,
                    9.6793e-08,
                    1.0396e-07,
                    1.1113e-07,
                    1.183e-07,
                    1.2548e-07,
                    1.3267e-07,
                    1.3988e-07,
                    1.472e-07,
                    1.5483e-07,
                    1.6291e-07,
                    1.7153e-07,
                    1.8076e-07,
                    1.906e-07,
                    2.0102e-07,
                    2.1196e-07,
                    2.233e-07,
                    2.3488e-07,
                    2.466e-07,
                    2.5844e-07,
                    2.7037e-07,
                    2.8238e-07,
                    2.9447e-07,
                    3.0663e-07,
                    3.1886e-07,
                    3.3117e-07,
                    3.4356e-07,
                    3.5654e-07,
                    3.6953e-07,
                    3.8256e-07,
                    3.9562e-07,
                    4.0872e-07,
                    4.2187e-07,
                    4.3508e-07,
                    4.4834e-07,
                    4.6167e-07,
                    4.7507e-07,
                    4.8853e-07,
                    5.0207e-07,
                    5.157e-07,
                    5.2943e-07,
                    5.4328e-07,
                    5.5725e-07,
                    5.7134e-07,
                    5.8557e-07,
                    5.9992e-07,
                    6.1441e-07,
                    6.2902e-07,
                    6.4375e-07,
                    6.5859e-07,
                    6.7353e-07,
                    6.8856e-07,
                    7.0371e-07,
                    7.1897e-07,
                    7.3437e-07,
                    7.4992e-07,
                    7.6567e-07,
                    7.8163e-07,
                    7.9801e-07,
                    8.1511e-07,
                    8.3318e-07,
                    8.524e-07,
                    8.7291e-07,
                    8.9478e-07,
                    9.1801e-07,
                    9.4256e-07,
                    9.6832e-07,
                    9.9511e-07,
                    1.0228e-06,
                    1.0513e-06,
                    1.0807e-06,
                    1.1109e-06,
                    1.1418e-06,
                    1.1735e-06,
                    1.2059e-06,
                    1.2392e-06,
                    1.2733e-06,
                    1.3083e-06,
                    1.3447e-06,
                    1.3832e-06,
                    1.4246e-06,
                    1.4693e-06,
                    1.5175e-06,
                    1.5693e-06,
                    1.6246e-06,
                    1.683e-06,
                    1.7441e-06,
                    1.807e-06,
                    1.8717e-06,
                    1.9385e-06,
                    2.0076e-06,
                    2.0791e-06,
                    2.1531e-06,
                    2.2295e-06,
                    2.308e-06,
                    2.3884e-06,
                    2.4701e-06,
                    2.5528e-06,
                    2.6212e-06,
                    2.702e-06,
                    2.7848e-06,
                    2.8843e-06,
                    2.9972e-06,
                    3.1073e-06,
                    3.1825e-06,
                    3.2566e-06,
                    3.3546e-06,
                    3.4328e-06,
                    3.5207e-06,
                    3.6128e-06,
                    3.7083e-06,
                    3.8057e-06,
                    3.8975e-06,
                    3.9837e-06,
                    4.0673e-06,
                    4.1592e-06,
                    4.2671e-06,
                    4.3713e-06,
                    4.4751e-06,
                    4.5895e-06,
                    4.7059e-06,
                    4.8152e-06,
                    4.9434e-06,
                    5.0474e-06,
                    5.1689e-06,
                    5.313e-06,
                    5.4548e-06,
                    5.5941e-06,
                    5.7766e-06,
                    5.9813e-06,
                    6.1825e-06,
                    6.3572e-06,
                    6.5421e-06,
                    6.7164e-06,
                    6.8965e-06,
                    7.0715e-06,
                    7.2455e-06,
                    7.3981e-06,
                    7.5508e-06,
                    7.7134e-06,
                    7.8795e-06,
                    8.0343e-06,
                    8.2189e-06,
                    8.379e-06,
                    8.5604e-06,
                    8.7743e-06,
                    8.9683e-06,
                    9.1682e-06,
                    9.3733e-06,
                    9.5739e-06,
                    9.8171e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            34.95704,
                            29.35671
                        ],
                        [
                            35.43036,
                            29.28396
                        ],
                        [
                            36.06849,
                            29.18524
                        ],
                        [
                            36.49907,
                            29.49969
                        ],
                        [
                            36.75119,
                            29.86655
                        ],
                        [
                            37.49837,
                            30.00087
                        ],
                        [
                            37.66721,
                            30.3332
                        ],
                        [
                            37.99773,
                            30.5007
                        ],
                        [
                            37.72802,
                            30.77275
                        ],
                        [
                            37.22905,
                            31.27403
                        ],
                        [
                            37.00269,
                            31.50055
                        ],
                        [
                            37.95146,
                            31.74293
                        ],
                        [
                            38.99789,
                            32.00001
                        ],
                        [
                            39.10447,
                            32.08216
                        ],
                        [
                            39.13036,
                            32.13472
                        ],
                        [
                            39.20094,
                            32.15433
                        ],
                        [
                            39.30028,
                            32.23018
                        ],
                        [
                            39.25567,
                            32.35432
                        ],
                        [
                            39.04304,
                            32.30622
                        ],
                        [
                            38.98681,
                            32.47681
                        ],
                        [
                            39.08523,
                            32.50347
                        ],
                        [
                            38.7925,
                            33.37472
                        ],
                        [
                            38.32315,
                            33.12314
                        ],
                        [
                            37.72802,
                            32.80497
                        ],
                        [
                            36.86975,
                            32.3441
                        ],
                        [
                            36.83407,
                            32.3169
                        ],
                        [
                            36.50432,
                            32.36012
                        ],
                        [
                            36.4088,
                            32.38285
                        ],
                        [
                            36.20683,
                            32.52758
                        ],
                        [
                            36.09146,
                            32.51878
                        ],
                        [
                            36.03576,
                            32.60558
                        ],
                        [
                            36.03536,
                            32.65512
                        ],
                        [
                            35.97547,
                            32.66985
                        ],
                        [
                            35.93191,
                            32.72437
                        ],
                        [
                            35.84133,
                            32.72964
                        ],
                        [
                            35.79977,
                            32.75883
                        ],
                        [
                            35.67163,
                            32.69106
                        ],
                        [
                            35.56726,
                            32.64089
                        ],
                        [
                            35.57878,
                            32.4895
                        ],
                        [
                            35.55512,
                            32.389
                        ],
                        [
                            35.57306,
                            32.21208
                        ],
                        [
                            35.54468,
                            32.0834
                        ],
                        [
                            35.51994,
                            32.04726
                        ],
                        [
                            35.54789,
                            31.971
                        ],
                        [
                            35.52487,
                            31.9063
                        ],
                        [
                            35.55833,
                            31.76142
                        ],
                        [
                            35.48965,
                            31.6188
                        ],
                        [
                            35.47596,
                            31.49051
                        ],
                        [
                            35.47361,
                            31.4134
                        ],
                        [
                            35.41331,
                            31.29145
                        ],
                        [
                            35.40494,
                            31.22779
                        ],
                        [
                            35.45124,
                            31.16263
                        ],
                        [
                            35.41433,
                            30.94984
                        ],
                        [
                            35.35272,
                            30.90637
                        ],
                        [
                            35.336,
                            30.80111
                        ],
                        [
                            35.20408,
                            30.58213
                        ],
                        [
                            35.16198,
                            30.43899
                        ],
                        [
                            35.19093,
                            30.34817
                        ],
                        [
                            35.14625,
                            30.28246
                        ],
                        [
                            35.14477,
                            30.06349
                        ],
                        [
                            35.10128,
                            30.01354
                        ],
                        [
                            35.08424,
                            29.88577
                        ],
                        [
                            35.03113,
                            29.77582
                        ],
                        [
                            35.01398,
                            29.63889
                        ],
                        [
                            34.97819,
                            29.54182
                        ],
                        [
                            34.95704,
                            29.35671
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "KAZ",
                "Country": "Kazakhstan",
                "Total_3GHG": 0.88,
                "Total_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0033,
                    0.0034,
                    0.0036,
                    0.0037,
                    0.0039,
                    0.0042,
                    0.0044,
                    0.0047,
                    0.005,
                    0.0052,
                    0.0055,
                    0.0058,
                    0.0061,
                    0.0064,
                    0.0067,
                    0.007,
                    0.0073,
                    0.0076,
                    0.0079,
                    0.0082,
                    0.0085,
                    0.0088,
                    0.0091,
                    0.0093,
                    0.0096,
                    0.0098,
                    0.01,
                    0.0103,
                    0.0104,
                    0.0106,
                    0.0108,
                    0.011,
                    0.0111,
                    0.0113,
                    0.0114,
                    0.0115,
                    0.0116,
                    0.0118,
                    0.0119,
                    0.0119,
                    0.012,
                    0.0121,
                    0.0121,
                    0.0121,
                    0.012,
                    0.012,
                    0.0119,
                    0.0119,
                    0.0118,
                    0.0118,
                    0.0118,
                    0.0118,
                    0.0118,
                    0.0119,
                    0.0119,
                    0.012,
                    0.0121,
                    0.0122,
                    0.0123,
                    0.0125,
                    0.0126,
                    0.0127,
                    0.0129,
                    0.0131,
                    0.0132,
                    0.0134,
                    0.0137,
                    0.0139,
                    0.0141,
                    0.0142,
                    0.0144
                ],
                "Fossil_3GHG": 0.81,
                "Fossil_3GHG_timeseries": [
                    1.4191e-07,
                    2.8536e-07,
                    4.2996e-07,
                    5.7643e-07,
                    7.4482e-07,
                    8.9376e-07,
                    1.0441e-06,
                    1.2253e-06,
                    1.4106e-06,
                    1.6076e-06,
                    1.8193e-06,
                    2.03e-06,
                    2.2467e-06,
                    2.4731e-06,
                    2.701e-06,
                    3.043e-06,
                    3.4125e-06,
                    3.7544e-06,
                    4.1552e-06,
                    4.5745e-06,
                    5.0885e-06,
                    5.623e-06,
                    6.1491e-06,
                    6.7507e-06,
                    7.4087e-06,
                    8.1883e-06,
                    8.9876e-06,
                    9.9506e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0019,
                    0.002,
                    0.0022,
                    0.0023,
                    0.0025,
                    0.0027,
                    0.0029,
                    0.0031,
                    0.0033,
                    0.0035,
                    0.0037,
                    0.0039,
                    0.0041,
                    0.0043,
                    0.0045,
                    0.0047,
                    0.0048,
                    0.005,
                    0.0051,
                    0.0053,
                    0.0054,
                    0.0055,
                    0.0056,
                    0.0057,
                    0.0058,
                    0.0059,
                    0.0059,
                    0.006,
                    0.0061,
                    0.0061,
                    0.0062,
                    0.0062,
                    0.0062,
                    0.0062,
                    0.0062,
                    0.0062,
                    0.0061,
                    0.0061,
                    0.0061,
                    0.0061,
                    0.0061,
                    0.0061,
                    0.0061,
                    0.0061,
                    0.0062,
                    0.0063,
                    0.0064,
                    0.0065,
                    0.0066,
                    0.0067,
                    0.0068,
                    0.0069,
                    0.007,
                    0.0072,
                    0.0074,
                    0.0075,
                    0.0077,
                    0.0079,
                    0.0081,
                    0.0082,
                    0.0084,
                    0.0085
                ],
                "Land_3GHG": 1.02,
                "Land_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0031,
                    0.0032,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0048,
                    0.0049,
                    0.005,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0054,
                    0.0055,
                    0.0055,
                    0.0056,
                    0.0056,
                    0.0057,
                    0.0057,
                    0.0058,
                    0.0058,
                    0.0058,
                    0.0058,
                    0.0059,
                    0.0059,
                    0.0058,
                    0.0058,
                    0.0058,
                    0.0058,
                    0.0058,
                    0.0057,
                    0.0057,
                    0.0057,
                    0.0057,
                    0.0057,
                    0.0056,
                    0.0056,
                    0.0056,
                    0.0057,
                    0.0057,
                    0.0057,
                    0.0057,
                    0.0057,
                    0.0057,
                    0.0057,
                    0.0057,
                    0.0058,
                    0.0058,
                    0.0058,
                    0.0058,
                    0.0059
                ],
                "Total_CO2": 0.97,
                "Total_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0027,
                    0.0028,
                    0.003,
                    0.0032,
                    0.0034,
                    0.0035,
                    0.0037,
                    0.0039,
                    0.004,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0046,
                    0.0047,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0053,
                    0.0054,
                    0.0056,
                    0.0057,
                    0.0058,
                    0.006,
                    0.0061,
                    0.0063,
                    0.0064,
                    0.0066,
                    0.0067,
                    0.0069,
                    0.007,
                    0.0072,
                    0.0073,
                    0.0075,
                    0.0076,
                    0.0077,
                    0.0079,
                    0.008,
                    0.0081,
                    0.0082,
                    0.0083,
                    0.0083,
                    0.0084,
                    0.0085,
                    0.0085,
                    0.0086,
                    0.0086,
                    0.0087,
                    0.0088,
                    0.0089,
                    0.009,
                    0.0091,
                    0.0092,
                    0.0093,
                    0.0095,
                    0.0096,
                    0.0097,
                    0.0099,
                    0.01,
                    0.0101,
                    0.0103,
                    0.0104,
                    0.0106,
                    0.0107,
                    0.0108,
                    0.0109,
                    0.0111
                ],
                "Fossil_CO2": 0.83,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    1.03e-08,
                    1.03e-08,
                    1.03e-08,
                    2.4764e-08,
                    4.0105e-08,
                    6.0377e-08,
                    8.6127e-08,
                    1.0936e-07,
                    1.3368e-07,
                    1.6097e-07,
                    1.8705e-07,
                    2.6945e-07,
                    3.6401e-07,
                    4.4269e-07,
                    5.4941e-07,
                    6.6524e-07,
                    8.216e-07,
                    9.8213e-07,
                    1.1328e-06,
                    1.3157e-06,
                    1.5262e-06,
                    1.7875e-06,
                    2.0542e-06,
                    2.4028e-06,
                    2.7604e-06,
                    3.18e-06,
                    3.6219e-06,
                    4.0874e-06,
                    4.6172e-06,
                    5.1551e-06,
                    5.741e-06,
                    6.3419e-06,
                    6.9778e-06,
                    7.6411e-06,
                    8.3574e-06,
                    9.1686e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.004,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0055,
                    0.0057,
                    0.0058,
                    0.0059,
                    0.0061,
                    0.0062,
                    0.0063,
                    0.0064
                ],
                "Land_CO2": 1.3,
                "Land_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.004,
                    0.004,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0043,
                    0.0043,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0044,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0045,
                    0.0045,
                    0.0045,
                    0.0045,
                    0.0045,
                    0.0045,
                    0.0045,
                    0.0045,
                    0.0045,
                    0.0045,
                    0.0045,
                    0.0045,
                    0.0045,
                    0.0045,
                    0.0046,
                    0.0046,
                    0.0046,
                    0.0046,
                    0.0046,
                    0.0046,
                    0.0046,
                    0.0046,
                    0.0046,
                    0.0047,
                    0.0047,
                    0.0047
                ],
                "Total_CH4": 0.69,
                "Total_CH4_timeseries": [
                    3.8555e-07,
                    7.7182e-07,
                    1.1584e-06,
                    1.5461e-06,
                    1.9447e-06,
                    2.3333e-06,
                    2.7226e-06,
                    3.1276e-06,
                    3.5351e-06,
                    3.9487e-06,
                    4.3984e-06,
                    4.8764e-06,
                    5.3861e-06,
                    5.9294e-06,
                    6.5023e-06,
                    7.1597e-06,
                    7.8593e-06,
                    8.5741e-06,
                    9.3466e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0024,
                    0.0025,
                    0.0027,
                    0.0028,
                    0.003,
                    0.0031,
                    0.0033,
                    0.0034,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0041,
                    0.0041,
                    0.0041,
                    0.0041,
                    0.0041,
                    0.0041,
                    0.004,
                    0.004,
                    0.0039,
                    0.0039,
                    0.0038,
                    0.0037,
                    0.0036,
                    0.0035,
                    0.0034,
                    0.0033,
                    0.0032,
                    0.0031,
                    0.003,
                    0.0029,
                    0.0028,
                    0.0027,
                    0.0027,
                    0.0026,
                    0.0026,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029
                ],
                "Fossil_CH4": 0.79,
                "Fossil_CH4_timeseries": [
                    2.2995e-08,
                    4.6256e-08,
                    6.941e-08,
                    9.3187e-08,
                    1.2734e-07,
                    1.5113e-07,
                    1.7507e-07,
                    2.1436e-07,
                    2.5559e-07,
                    3.0251e-07,
                    3.5762e-07,
                    4.1306e-07,
                    4.7231e-07,
                    5.3719e-07,
                    6.0378e-07,
                    7.2696e-07,
                    8.6432e-07,
                    9.8902e-07,
                    1.1434e-06,
                    1.306e-06,
                    1.5216e-06,
                    1.752e-06,
                    1.9821e-06,
                    2.2537e-06,
                    2.5521e-06,
                    2.9194e-06,
                    3.299e-06,
                    3.7588e-06,
                    4.2341e-06,
                    4.7797e-06,
                    5.3403e-06,
                    5.932e-06,
                    6.5948e-06,
                    7.2492e-06,
                    7.9454e-06,
                    8.6112e-06,
                    9.2876e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.003,
                    0.003,
                    0.0029,
                    0.0029,
                    0.0028,
                    0.0028,
                    0.0027,
                    0.0026,
                    0.0025,
                    0.0024,
                    0.0023,
                    0.0022,
                    0.0021,
                    0.002,
                    0.0019,
                    0.0019,
                    0.0018,
                    0.0018,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021
                ],
                "Land_CH4": 0.52,
                "Land_CH4_timeseries": [
                    3.6255e-07,
                    7.2556e-07,
                    1.089e-06,
                    1.453e-06,
                    1.8173e-06,
                    2.1822e-06,
                    2.5475e-06,
                    2.9133e-06,
                    3.2795e-06,
                    3.6462e-06,
                    4.0408e-06,
                    4.4633e-06,
                    4.9138e-06,
                    5.3922e-06,
                    5.8985e-06,
                    6.4328e-06,
                    6.995e-06,
                    7.5851e-06,
                    8.2032e-06,
                    8.8492e-06,
                    9.6222e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008
                ],
                "Total_N2O": 0.57,
                "Total_N2O_timeseries": [
                    5.3336e-07,
                    1.0763e-06,
                    1.6284e-06,
                    2.1892e-06,
                    2.758e-06,
                    3.3341e-06,
                    3.9166e-06,
                    4.5043e-06,
                    5.0961e-06,
                    5.6906e-06,
                    6.2871e-06,
                    6.8852e-06,
                    7.4849e-06,
                    8.086e-06,
                    8.6884e-06,
                    9.2923e-06,
                    9.8976e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Fossil_N2O": 0.37,
                "Fossil_N2O_timeseries": [
                    1.1892e-07,
                    2.3911e-07,
                    3.6055e-07,
                    4.8325e-07,
                    6.0718e-07,
                    7.3233e-07,
                    8.5868e-07,
                    9.862e-07,
                    1.1149e-06,
                    1.2447e-06,
                    1.3756e-06,
                    1.5076e-06,
                    1.6407e-06,
                    1.7749e-06,
                    1.9102e-06,
                    2.0466e-06,
                    2.1841e-06,
                    2.3227e-06,
                    2.4624e-06,
                    2.6032e-06,
                    2.7453e-06,
                    2.8889e-06,
                    3.0342e-06,
                    3.1813e-06,
                    3.3304e-06,
                    3.4814e-06,
                    3.6343e-06,
                    3.7891e-06,
                    3.9454e-06,
                    4.1033e-06,
                    4.2624e-06,
                    4.4227e-06,
                    4.5843e-06,
                    4.7471e-06,
                    4.911e-06,
                    5.0762e-06,
                    5.2425e-06,
                    5.4101e-06,
                    5.5788e-06,
                    5.7494e-06,
                    5.9213e-06,
                    6.0946e-06,
                    6.2694e-06,
                    6.4455e-06,
                    6.6232e-06,
                    6.8022e-06,
                    6.9828e-06,
                    7.1649e-06,
                    7.3485e-06,
                    7.5336e-06,
                    7.7204e-06,
                    7.9088e-06,
                    8.099e-06,
                    8.291e-06,
                    8.4848e-06,
                    8.6804e-06,
                    8.8778e-06,
                    9.0771e-06,
                    9.2781e-06,
                    9.4808e-06,
                    9.6851e-06,
                    9.8911e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_N2O": 0.65,
                "Land_N2O_timeseries": [
                    4.1444e-07,
                    8.3717e-07,
                    1.2678e-06,
                    1.7059e-06,
                    2.1508e-06,
                    2.6018e-06,
                    3.0579e-06,
                    3.5181e-06,
                    3.9812e-06,
                    4.446e-06,
                    4.9115e-06,
                    5.3776e-06,
                    5.8442e-06,
                    6.3111e-06,
                    6.7782e-06,
                    7.2457e-06,
                    7.7134e-06,
                    8.1817e-06,
                    8.6506e-06,
                    9.1203e-06,
                    9.5979e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                56.0006,
                                41.31805
                            ],
                            [
                                56.00039,
                                42.1923
                            ],
                            [
                                56.00024,
                                42.8196
                            ],
                            [
                                56.00004,
                                43.64984
                            ],
                            [
                                56.00072,
                                45.00006
                            ],
                            [
                                57.00798,
                                45.22994
                            ],
                            [
                                57.91759,
                                45.43673
                            ],
                            [
                                58.59581,
                                45.59043
                            ],
                            [
                                59.48846,
                                45.12475
                            ],
                            [
                                60.59141,
                                44.54405
                            ],
                            [
                                61.12991,
                                44.26063
                            ],
                            [
                                61.41135,
                                44.01838
                            ],
                            [
                                61.9755,
                                43.51241
                            ],
                            [
                                62.02898,
                                43.48656
                            ],
                            [
                                63.20776,
                                43.65245
                            ],
                            [
                                63.38911,
                                43.67283
                            ],
                            [
                                63.91202,
                                43.62808
                            ],
                            [
                                64.25279,
                                43.60986
                            ],
                            [
                                64.53623,
                                43.60346
                            ],
                            [
                                65.00857,
                                43.76612
                            ],
                            [
                                65.11221,
                                43.7755
                            ],
                            [
                                65.16998,
                                43.74273
                            ],
                            [
                                65.29619,
                                43.54401
                            ],
                            [
                                65.6504,
                                43.30308
                            ],
                            [
                                65.68431,
                                43.20593
                            ],
                            [
                                65.82713,
                                42.87014
                            ],
                            [
                                66.09863,
                                42.95982
                            ],
                            [
                                66.10596,
                                42.35262
                            ],
                            [
                                66.01679,
                                42.37472
                            ],
                            [
                                66.0103,
                                41.94583
                            ],
                            [
                                66.53033,
                                41.89447
                            ],
                            [
                                66.60803,
                                41.25202
                            ],
                            [
                                67.30723,
                                41.21169
                            ],
                            [
                                67.77564,
                                41.2021
                            ],
                            [
                                67.84908,
                                41.16104
                            ],
                            [
                                67.93276,
                                41.19543
                            ],
                            [
                                68.03571,
                                41.04229
                            ],
                            [
                                68.10569,
                                41.0651
                            ],
                            [
                                68.14885,
                                41.0305
                            ],
                            [
                                68.13427,
                                40.9367
                            ],
                            [
                                68.0742,
                                40.80121
                            ],
                            [
                                68.23302,
                                40.6918
                            ],
                            [
                                68.48474,
                                40.59288
                            ],
                            [
                                68.53902,
                                40.62445
                            ],
                            [
                                68.60928,
                                40.60081
                            ],
                            [
                                68.65053,
                                40.67185
                            ],
                            [
                                68.58866,
                                40.73537
                            ],
                            [
                                68.56892,
                                40.85818
                            ],
                            [
                                68.59392,
                                40.91763
                            ],
                            [
                                68.74397,
                                40.98738
                            ],
                            [
                                68.76644,
                                41.04332
                            ],
                            [
                                68.86365,
                                41.15012
                            ],
                            [
                                68.94527,
                                41.19475
                            ],
                            [
                                69.03317,
                                41.34133
                            ],
                            [
                                69.23247,
                                41.46151
                            ],
                            [
                                69.41955,
                                41.45554
                            ],
                            [
                                69.40624,
                                41.50029
                            ],
                            [
                                69.51536,
                                41.55938
                            ],
                            [
                                69.62041,
                                41.65719
                            ],
                            [
                                69.83319,
                                41.71886
                            ],
                            [
                                69.95206,
                                41.71917
                            ],
                            [
                                69.98364,
                                41.77901
                            ],
                            [
                                70.15974,
                                41.84434
                            ],
                            [
                                70.24031,
                                41.94113
                            ],
                            [
                                70.33083,
                                41.97559
                            ],
                            [
                                70.32271,
                                42.03444
                            ],
                            [
                                70.43324,
                                42.13009
                            ],
                            [
                                70.54644,
                                42.0695
                            ],
                            [
                                70.55911,
                                42.01883
                            ],
                            [
                                70.62698,
                                42.00088
                            ],
                            [
                                70.69353,
                                42.12676
                            ],
                            [
                                70.80099,
                                42.20983
                            ],
                            [
                                70.83914,
                                42.19401
                            ],
                            [
                                70.94022,
                                42.2592
                            ],
                            [
                                70.87185,
                                42.31812
                            ],
                            [
                                70.99593,
                                42.4943
                            ],
                            [
                                71.09537,
                                42.49966
                            ],
                            [
                                71.00761,
                                42.56865
                            ],
                            [
                                71.05575,
                                42.60086
                            ],
                            [
                                71.16245,
                                42.60821
                            ],
                            [
                                71.17558,
                                42.67149
                            ],
                            [
                                71.22961,
                                42.69568
                            ],
                            [
                                71.27684,
                                42.77888
                            ],
                            [
                                71.51352,
                                42.80899
                            ],
                            [
                                71.62773,
                                42.76535
                            ],
                            [
                                71.81688,
                                42.83027
                            ],
                            [
                                71.93656,
                                42.8144
                            ],
                            [
                                72.08816,
                                42.74519
                            ],
                            [
                                72.27858,
                                42.75932
                            ],
                            [
                                72.49762,
                                42.68567
                            ],
                            [
                                72.60953,
                                42.68049
                            ],
                            [
                                72.74171,
                                42.63987
                            ],
                            [
                                72.82408,
                                42.56321
                            ],
                            [
                                72.97231,
                                42.52789
                            ],
                            [
                                73.08932,
                                42.53597
                            ],
                            [
                                73.29832,
                                42.50548
                            ],
                            [
                                73.34259,
                                42.42926
                            ],
                            [
                                73.44788,
                                42.4197
                            ],
                            [
                                73.51349,
                                42.43764
                            ],
                            [
                                73.44415,
                                42.50166
                            ],
                            [
                                73.42336,
                                42.61003
                            ],
                            [
                                73.46091,
                                42.72197
                            ],
                            [
                                73.50343,
                                42.7839
                            ],
                            [
                                73.50044,
                                42.90591
                            ],
                            [
                                73.57348,
                                43.03466
                            ],
                            [
                                73.77842,
                                43.10858
                            ],
                            [
                                73.87214,
                                43.09792
                            ],
                            [
                                73.95464,
                                43.19131
                            ],
                            [
                                74.05123,
                                43.15841
                            ],
                            [
                                74.17339,
                                43.19129
                            ],
                            [
                                74.15714,
                                43.22746
                            ],
                            [
                                74.29272,
                                43.23795
                            ],
                            [
                                74.34262,
                                43.20577
                            ],
                            [
                                74.48511,
                                43.18393
                            ],
                            [
                                74.61294,
                                43.12149
                            ],
                            [
                                74.73889,
                                42.9957
                            ],
                            [
                                74.83617,
                                43.00552
                            ],
                            [
                                74.90966,
                                42.98287
                            ],
                            [
                                75.1585,
                                42.85053
                            ],
                            [
                                75.32269,
                                42.85586
                            ],
                            [
                                75.42882,
                                42.82206
                            ],
                            [
                                75.61487,
                                42.82044
                            ],
                            [
                                75.71256,
                                42.79736
                            ],
                            [
                                75.76859,
                                42.83375
                            ],
                            [
                                75.81368,
                                42.93155
                            ],
                            [
                                75.92974,
                                42.95303
                            ],
                            [
                                76.03735,
                                42.9102
                            ],
                            [
                                76.27007,
                                42.91851
                            ],
                            [
                                76.32532,
                                42.86628
                            ],
                            [
                                76.48424,
                                42.88927
                            ],
                            [
                                76.50884,
                                42.91582
                            ],
                            [
                                76.70226,
                                42.90441
                            ],
                            [
                                76.84414,
                                42.98097
                            ],
                            [
                                77.1752,
                                42.95954
                            ],
                            [
                                77.22434,
                                42.92206
                            ],
                            [
                                77.34895,
                                42.91606
                            ],
                            [
                                77.44733,
                                42.93541
                            ],
                            [
                                77.72849,
                                42.90525
                            ],
                            [
                                78.05932,
                                42.83997
                            ],
                            [
                                78.18135,
                                42.88073
                            ],
                            [
                                78.31608,
                                42.85694
                            ],
                            [
                                78.49241,
                                42.90264
                            ],
                            [
                                78.69349,
                                42.82156
                            ],
                            [
                                78.93841,
                                42.77552
                            ],
                            [
                                79.10069,
                                42.77051
                            ],
                            [
                                79.16666,
                                42.75051
                            ],
                            [
                                79.1874,
                                42.688
                            ],
                            [
                                79.25318,
                                42.63175
                            ],
                            [
                                79.37006,
                                42.57954
                            ],
                            [
                                79.50881,
                                42.45778
                            ],
                            [
                                79.66746,
                                42.47649
                            ],
                            [
                                79.75855,
                                42.45214
                            ],
                            [
                                79.95181,
                                42.42899
                            ],
                            [
                                79.98442,
                                42.374
                            ],
                            [
                                80.08481,
                                42.32773
                            ],
                            [
                                80.12878,
                                42.20263
                            ],
                            [
                                80.24563,
                                42.22089
                            ],
                            [
                                80.28854,
                                42.25929
                            ],
                            [
                                80.27412,
                                42.32771
                            ],
                            [
                                80.22862,
                                42.35164
                            ],
                            [
                                80.20897,
                                42.42841
                            ],
                            [
                                80.22171,
                                42.53624
                            ],
                            [
                                80.16753,
                                42.6365
                            ],
                            [
                                80.21322,
                                42.69689
                            ],
                            [
                                80.25783,
                                42.82671
                            ],
                            [
                                80.399,
                                42.82818
                            ],
                            [
                                80.58951,
                                42.89731
                            ],
                            [
                                80.40388,
                                42.98627
                            ],
                            [
                                80.39022,
                                43.04128
                            ],
                            [
                                80.50291,
                                43.07724
                            ],
                            [
                                80.59379,
                                43.13181
                            ],
                            [
                                80.7223,
                                43.13276
                            ],
                            [
                                80.79944,
                                43.17674
                            ],
                            [
                                80.74334,
                                43.29781
                            ],
                            [
                                80.66172,
                                43.31408
                            ],
                            [
                                80.73415,
                                43.40701
                            ],
                            [
                                80.74535,
                                43.45971
                            ],
                            [
                                80.59023,
                                43.74103
                            ],
                            [
                                80.52004,
                                43.83411
                            ],
                            [
                                80.50604,
                                43.9203
                            ],
                            [
                                80.45462,
                                44.00327
                            ],
                            [
                                80.41728,
                                44.13036
                            ],
                            [
                                80.40083,
                                44.28608
                            ],
                            [
                                80.34356,
                                44.48096
                            ],
                            [
                                80.40332,
                                44.6086
                            ],
                            [
                                80.36128,
                                44.65581
                            ],
                            [
                                80.47879,
                                44.70215
                            ],
                            [
                                80.48226,
                                44.73239
                            ],
                            [
                                80.24595,
                                44.83876
                            ],
                            [
                                80.05499,
                                44.8017
                            ],
                            [
                                79.98983,
                                44.8172
                            ],
                            [
                                79.96036,
                                44.8784
                            ],
                            [
                                79.87533,
                                44.90923
                            ],
                            [
                                79.99434,
                                44.96877
                            ],
                            [
                                80.08152,
                                45.049
                            ],
                            [
                                80.17723,
                                45.02909
                            ],
                            [
                                80.29812,
                                45.06538
                            ],
                            [
                                80.37926,
                                45.04443
                            ],
                            [
                                80.44496,
                                45.10199
                            ],
                            [
                                80.60455,
                                45.11019
                            ],
                            [
                                80.75293,
                                45.1574
                            ],
                            [
                                80.85408,
                                45.12833
                            ],
                            [
                                80.95161,
                                45.16672
                            ],
                            [
                                81.07764,
                                45.17553
                            ],
                            [
                                81.10711,
                                45.21916
                            ],
                            [
                                81.45375,
                                45.26898
                            ],
                            [
                                81.69007,
                                45.36596
                            ],
                            [
                                81.78755,
                                45.30713
                            ],
                            [
                                81.81922,
                                45.20467
                            ],
                            [
                                81.92576,
                                45.1687
                            ],
                            [
                                82.03178,
                                45.16588
                            ],
                            [
                                82.11515,
                                45.20808
                            ],
                            [
                                82.23893,
                                45.23503
                            ],
                            [
                                82.32697,
                                45.21558
                            ],
                            [
                                82.48675,
                                45.12159
                            ],
                            [
                                82.59211,
                                45.23148
                            ],
                            [
                                82.63063,
                                45.36019
                            ],
                            [
                                82.58856,
                                45.44575
                            ],
                            [
                                82.43196,
                                45.4683
                            ],
                            [
                                82.27542,
                                45.54657
                            ],
                            [
                                82.28904,
                                45.63177
                            ],
                            [
                                82.41841,
                                45.86561
                            ],
                            [
                                82.50416,
                                45.98322
                            ],
                            [
                                82.52936,
                                46.18451
                            ],
                            [
                                82.57881,
                                46.28214
                            ],
                            [
                                82.73855,
                                46.51682
                            ],
                            [
                                82.80659,
                                46.74779
                            ],
                            [
                                82.88981,
                                46.87618
                            ],
                            [
                                82.93593,
                                47.01081
                            ],
                            [
                                82.99334,
                                47.05531
                            ],
                            [
                                83.02279,
                                47.1919
                            ],
                            [
                                83.05176,
                                47.22182
                            ],
                            [
                                83.177,
                                47.22293
                            ],
                            [
                                83.23521,
                                47.18124
                            ],
                            [
                                83.34072,
                                47.17611
                            ],
                            [
                                83.45942,
                                47.13111
                            ],
                            [
                                83.5574,
                                47.06753
                            ],
                            [
                                84.03973,
                                46.96537
                            ],
                            [
                                84.19882,
                                46.99825
                            ],
                            [
                                84.42191,
                                47.01074
                            ],
                            [
                                84.50699,
                                46.97819
                            ],
                            [
                                84.7045,
                                46.99602
                            ],
                            [
                                84.78485,
                                46.90803
                            ],
                            [
                                84.705,
                                46.83433
                            ],
                            [
                                84.80551,
                                46.82695
                            ],
                            [
                                84.96148,
                                46.87135
                            ],
                            [
                                85.18876,
                                47.0059
                            ],
                            [
                                85.21824,
                                47.04958
                            ],
                            [
                                85.52909,
                                47.06001
                            ],
                            [
                                85.57777,
                                47.19177
                            ],
                            [
                                85.69119,
                                47.21903
                            ],
                            [
                                85.7066,
                                47.37789
                            ],
                            [
                                85.60383,
                                47.51948
                            ],
                            [
                                85.62089,
                                47.60944
                            ],
                            [
                                85.54172,
                                47.94135
                            ],
                            [
                                85.61147,
                                48.08223
                            ],
                            [
                                85.61102,
                                48.15772
                            ],
                            [
                                85.73714,
                                48.37185
                            ],
                            [
                                85.84355,
                                48.42634
                            ],
                            [
                                86.01548,
                                48.44912
                            ],
                            [
                                86.21454,
                                48.43575
                            ],
                            [
                                86.31711,
                                48.50051
                            ],
                            [
                                86.43438,
                                48.49502
                            ],
                            [
                                86.58728,
                                48.54264
                            ],
                            [
                                86.63428,
                                48.62418
                            ],
                            [
                                86.76353,
                                48.71619
                            ],
                            [
                                86.74772,
                                48.77183
                            ],
                            [
                                86.80974,
                                48.85084
                            ],
                            [
                                86.73786,
                                48.90791
                            ],
                            [
                                86.75318,
                                49.01834
                            ],
                            [
                                86.82941,
                                49.05094
                            ],
                            [
                                86.85552,
                                49.10749
                            ],
                            [
                                86.9879,
                                49.10373
                            ],
                            [
                                87.13495,
                                49.15043
                            ],
                            [
                                87.31258,
                                49.09969
                            ],
                            [
                                87.26857,
                                49.2161
                            ],
                            [
                                87.17381,
                                49.25128
                            ],
                            [
                                87.04962,
                                49.25489
                            ],
                            [
                                86.94497,
                                49.30231
                            ],
                            [
                                86.90275,
                                49.35183
                            ],
                            [
                                86.90924,
                                49.41243
                            ],
                            [
                                86.82455,
                                49.44351
                            ],
                            [
                                86.79258,
                                49.54835
                            ],
                            [
                                86.65612,
                                49.56755
                            ],
                            [
                                86.61839,
                                49.63112
                            ],
                            [
                                86.66833,
                                49.67957
                            ],
                            [
                                86.78058,
                                49.70984
                            ],
                            [
                                86.80048,
                                49.80273
                            ],
                            [
                                86.64161,
                                49.8058
                            ],
                            [
                                86.5889,
                                49.74309
                            ],
                            [
                                86.42638,
                                49.6392
                            ],
                            [
                                86.25277,
                                49.58792
                            ],
                            [
                                86.15685,
                                49.46601
                            ],
                            [
                                86.10221,
                                49.51654
                            ],
                            [
                                85.97756,
                                49.48709
                            ],
                            [
                                85.9233,
                                49.55337
                            ],
                            [
                                85.69504,
                                49.55775
                            ],
                            [
                                85.52699,
                                49.60451
                            ],
                            [
                                85.42326,
                                49.56526
                            ],
                            [
                                85.28918,
                                49.58886
                            ],
                            [
                                85.21474,
                                49.6261
                            ],
                            [
                                85.19552,
                                49.73836
                            ],
                            [
                                85.09117,
                                49.87928
                            ],
                            [
                                84.99575,
                                49.90193
                            ],
                            [
                                84.97757,
                                49.95863
                            ],
                            [
                                85.03098,
                                50.01667
                            ],
                            [
                                84.93037,
                                50.09076
                            ],
                            [
                                84.8508,
                                50.09394
                            ],
                            [
                                84.66789,
                                50.18177
                            ],
                            [
                                84.56069,
                                50.20214
                            ],
                            [
                                84.47758,
                                50.2496
                            ],
                            [
                                84.32245,
                                50.2259
                            ],
                            [
                                84.26236,
                                50.27011
                            ],
                            [
                                84.21263,
                                50.47283
                            ],
                            [
                                84.21802,
                                50.53253
                            ],
                            [
                                83.97996,
                                50.71994
                            ],
                            [
                                83.9623,
                                50.78124
                            ],
                            [
                                83.83457,
                                50.87298
                            ],
                            [
                                83.69308,
                                50.90124
                            ],
                            [
                                83.5825,
                                50.9502
                            ],
                            [
                                83.49029,
                                50.95616
                            ],
                            [
                                83.29401,
                                51.01406
                            ],
                            [
                                83.11353,
                                50.99064
                            ],
                            [
                                82.98891,
                                50.90076
                            ],
                            [
                                82.76696,
                                50.93705
                            ],
                            [
                                82.72214,
                                50.84344
                            ],
                            [
                                82.57034,
                                50.75988
                            ],
                            [
                                82.28291,
                                50.77543
                            ],
                            [
                                82.14097,
                                50.74098
                            ],
                            [
                                82.00529,
                                50.79975
                            ],
                            [
                                81.88327,
                                50.81056
                            ],
                            [
                                81.75941,
                                50.77174
                            ],
                            [
                                81.59898,
                                50.75339
                            ],
                            [
                                81.4541,
                                50.76144
                            ],
                            [
                                81.4772,
                                50.81781
                            ],
                            [
                                81.40346,
                                50.98186
                            ],
                            [
                                81.172,
                                50.9438
                            ],
                            [
                                81.07421,
                                50.94662
                            ],
                            [
                                81.09007,
                                51.03944
                            ],
                            [
                                81.13627,
                                51.0861
                            ],
                            [
                                81.15763,
                                51.18671
                            ],
                            [
                                81.07468,
                                51.17322
                            ],
                            [
                                80.93005,
                                51.21682
                            ],
                            [
                                80.9212,
                                51.254
                            ],
                            [
                                80.67079,
                                51.30757
                            ],
                            [
                                80.62261,
                                51.20754
                            ],
                            [
                                80.44152,
                                51.20607
                            ],
                            [
                                80.47379,
                                51.10128
                            ],
                            [
                                80.46801,
                                50.97497
                            ],
                            [
                                80.37596,
                                50.93643
                            ],
                            [
                                80.19884,
                                50.90515
                            ],
                            [
                                80.19113,
                                50.83207
                            ],
                            [
                                80.09443,
                                50.83165
                            ],
                            [
                                79.9691,
                                50.89039
                            ],
                            [
                                79.70403,
                                51.24697
                            ],
                            [
                                79.21626,
                                51.88191
                            ],
                            [
                                78.89338,
                                52.25645
                            ],
                            [
                                78.62473,
                                52.54558
                            ],
                            [
                                78.25047,
                                52.95348
                            ],
                            [
                                77.90886,
                                53.2804
                            ],
                            [
                                77.56995,
                                53.48111
                            ],
                            [
                                76.76111,
                                53.86965
                            ],
                            [
                                76.58235,
                                53.96877
                            ],
                            [
                                76.43088,
                                54.13245
                            ],
                            [
                                76.44049,
                                54.1723
                            ],
                            [
                                76.65223,
                                54.12648
                            ],
                            [
                                76.74757,
                                54.16015
                            ],
                            [
                                76.84192,
                                54.23433
                            ],
                            [
                                76.86207,
                                54.35226
                            ],
                            [
                                76.93243,
                                54.42569
                            ],
                            [
                                76.91131,
                                54.45742
                            ],
                            [
                                76.7467,
                                54.41968
                            ],
                            [
                                76.65145,
                                54.34655
                            ],
                            [
                                76.50377,
                                54.32694
                            ],
                            [
                                76.3289,
                                54.33323
                            ],
                            [
                                76.23315,
                                54.35412
                            ],
                            [
                                76.22511,
                                54.27377
                            ],
                            [
                                75.6135,
                                54.10667
                            ],
                            [
                                75.5288,
                                54.12166
                            ],
                            [
                                75.40047,
                                54.08297
                            ],
                            [
                                75.48217,
                                54.01001
                            ],
                            [
                                75.4533,
                                53.96937
                            ],
                            [
                                75.21833,
                                53.8797
                            ],
                            [
                                75.03888,
                                53.79114
                            ],
                            [
                                74.93819,
                                53.81534
                            ],
                            [
                                74.80241,
                                53.81361
                            ],
                            [
                                74.77889,
                                53.76593
                            ],
                            [
                                74.68621,
                                53.75523
                            ],
                            [
                                74.64204,
                                53.66821
                            ],
                            [
                                74.47273,
                                53.68251
                            ],
                            [
                                74.44268,
                                53.59638
                            ],
                            [
                                74.48412,
                                53.57996
                            ],
                            [
                                74.40359,
                                53.46226
                            ],
                            [
                                74.28324,
                                53.48908
                            ],
                            [
                                74.26794,
                                53.56255
                            ],
                            [
                                74.06836,
                                53.55592
                            ],
                            [
                                74.07225,
                                53.62527
                            ],
                            [
                                73.89193,
                                53.63969
                            ],
                            [
                                73.8337,
                                53.5874
                            ],
                            [
                                73.6762,
                                53.62342
                            ],
                            [
                                73.6494,
                                53.56097
                            ],
                            [
                                73.44715,
                                53.44602
                            ],
                            [
                                73.38109,
                                53.47659
                            ],
                            [
                                73.40017,
                                53.53086
                            ],
                            [
                                73.24782,
                                53.57386
                            ],
                            [
                                73.32889,
                                53.6886
                            ],
                            [
                                73.34925,
                                53.79383
                            ],
                            [
                                73.45362,
                                53.81338
                            ],
                            [
                                73.46429,
                                53.88132
                            ],
                            [
                                73.69084,
                                53.86345
                            ],
                            [
                                73.74799,
                                54.05387
                            ],
                            [
                                73.68868,
                                54.07101
                            ],
                            [
                                73.51205,
                                54.00453
                            ],
                            [
                                73.50859,
                                53.95275
                            ],
                            [
                                73.29425,
                                53.95324
                            ],
                            [
                                73.08739,
                                53.9903
                            ],
                            [
                                72.97747,
                                54.09855
                            ],
                            [
                                72.60372,
                                54.1336
                            ],
                            [
                                72.52117,
                                54.0486
                            ],
                            [
                                72.66259,
                                54.04726
                            ],
                            [
                                72.72136,
                                53.95141
                            ],
                            [
                                72.5546,
                                53.98847
                            ],
                            [
                                72.4943,
                                53.91557
                            ],
                            [
                                72.37931,
                                53.95264
                            ],
                            [
                                72.4192,
                                54.03949
                            ],
                            [
                                72.37079,
                                54.10428
                            ],
                            [
                                72.40043,
                                54.1542
                            ],
                            [
                                72.29988,
                                54.19781
                            ],
                            [
                                72.26346,
                                54.31886
                            ],
                            [
                                72.17754,
                                54.35833
                            ],
                            [
                                72.06347,
                                54.36395
                            ],
                            [
                                72.12569,
                                54.28995
                            ],
                            [
                                72.08333,
                                54.23718
                            ],
                            [
                                72.19332,
                                54.18574
                            ],
                            [
                                72.09681,
                                54.15451
                            ],
                            [
                                72.00461,
                                54.2267
                            ],
                            [
                                71.77112,
                                54.2481
                            ],
                            [
                                71.72623,
                                54.19506
                            ],
                            [
                                71.73793,
                                54.12946
                            ],
                            [
                                71.65615,
                                54.10344
                            ],
                            [
                                71.51466,
                                54.10957
                            ],
                            [
                                71.49008,
                                54.15936
                            ],
                            [
                                71.35265,
                                54.18323
                            ],
                            [
                                71.20975,
                                54.1111
                            ],
                            [
                                71.07442,
                                54.21667
                            ],
                            [
                                71.10978,
                                54.25242
                            ],
                            [
                                71.01563,
                                54.30522
                            ],
                            [
                                71.02931,
                                54.34793
                            ],
                            [
                                71.19006,
                                54.31945
                            ],
                            [
                                71.23188,
                                54.3918
                            ],
                            [
                                71.18855,
                                54.54021
                            ],
                            [
                                71.20739,
                                54.59488
                            ],
                            [
                                71.29334,
                                54.61444
                            ],
                            [
                                71.29507,
                                54.66605
                            ],
                            [
                                71.13627,
                                54.70887
                            ],
                            [
                                71.05091,
                                54.7913
                            ],
                            [
                                71.00177,
                                54.8769
                            ],
                            [
                                71.01481,
                                55.07257
                            ],
                            [
                                70.83094,
                                55.25741
                            ],
                            [
                                70.81911,
                                55.2976
                            ],
                            [
                                70.57756,
                                55.25863
                            ],
                            [
                                70.45941,
                                55.2755
                            ],
                            [
                                70.41172,
                                55.21026
                            ],
                            [
                                70.23614,
                                55.13927
                            ],
                            [
                                70.13025,
                                55.14056
                            ],
                            [
                                70.05088,
                                55.18747
                            ],
                            [
                                69.91844,
                                55.21755
                            ],
                            [
                                69.83047,
                                55.30241
                            ],
                            [
                                69.66581,
                                55.34299
                            ],
                            [
                                69.48657,
                                55.34175
                            ],
                            [
                                69.33015,
                                55.36232
                            ],
                            [
                                69.19514,
                                55.33608
                            ],
                            [
                                69.05386,
                                55.41958
                            ],
                            [
                                68.93876,
                                55.42893
                            ],
                            [
                                68.97304,
                                55.29257
                            ],
                            [
                                68.85149,
                                55.34097
                            ],
                            [
                                68.74671,
                                55.35424
                            ],
                            [
                                68.61722,
                                55.18985
                            ],
                            [
                                68.29377,
                                55.19687
                            ],
                            [
                                68.17889,
                                55.18094
                            ],
                            [
                                68.28253,
                                55.06331
                            ],
                            [
                                68.19642,
                                54.95779
                            ],
                            [
                                68.00651,
                                54.94568
                            ],
                            [
                                67.88617,
                                54.97825
                            ],
                            [
                                67.7929,
                                54.94042
                            ],
                            [
                                67.76838,
                                54.887
                            ],
                            [
                                67.55107,
                                54.8388
                            ],
                            [
                                67.302,
                                54.85889
                            ],
                            [
                                67.27864,
                                54.82068
                            ],
                            [
                                66.77979,
                                54.75895
                            ],
                            [
                                66.34788,
                                54.6894
                            ],
                            [
                                66.01834,
                                54.61814
                            ],
                            [
                                65.95338,
                                54.63069
                            ],
                            [
                                65.96319,
                                54.70876
                            ],
                            [
                                65.83903,
                                54.69249
                            ],
                            [
                                65.8027,
                                54.62922
                            ],
                            [
                                65.72958,
                                54.60557
                            ],
                            [
                                65.50366,
                                54.65056
                            ],
                            [
                                65.4563,
                                54.56959
                            ],
                            [
                                65.35309,
                                54.57996
                            ],
                            [
                                65.20273,
                                54.52557
                            ],
                            [
                                65.19059,
                                54.45789
                            ],
                            [
                                65.23991,
                                54.36686
                            ],
                            [
                                65.12437,
                                54.3381
                            ],
                            [
                                64.98038,
                                54.41843
                            ],
                            [
                                64.81213,
                                54.36763
                            ],
                            [
                                64.74246,
                                54.40408
                            ],
                            [
                                64.62146,
                                54.39513
                            ],
                            [
                                64.45815,
                                54.3365
                            ],
                            [
                                64.18701,
                                54.30799
                            ],
                            [
                                64.07977,
                                54.31736
                            ],
                            [
                                64.02991,
                                54.28177
                            ],
                            [
                                63.88097,
                                54.2855
                            ],
                            [
                                63.51706,
                                54.20621
                            ],
                            [
                                63.16952,
                                54.19245
                            ],
                            [
                                63.16154,
                                54.12724
                            ],
                            [
                                63.06049,
                                54.1006
                            ],
                            [
                                62.82315,
                                54.11618
                            ],
                            [
                                62.80128,
                                54.08213
                            ],
                            [
                                62.59232,
                                53.98321
                            ],
                            [
                                62.5317,
                                53.90051
                            ],
                            [
                                62.45558,
                                53.92567
                            ],
                            [
                                62.34014,
                                54.0353
                            ],
                            [
                                62.19813,
                                54.03308
                            ],
                            [
                                62.08841,
                                54.05744
                            ],
                            [
                                62.00406,
                                54.0294
                            ],
                            [
                                62.04111,
                                53.97225
                            ],
                            [
                                61.95287,
                                53.94582
                            ],
                            [
                                61.79455,
                                53.98461
                            ],
                            [
                                61.73711,
                                54.0287
                            ],
                            [
                                61.5801,
                                53.9959
                            ],
                            [
                                61.49565,
                                54.01966
                            ],
                            [
                                61.46096,
                                54.08353
                            ],
                            [
                                61.33194,
                                54.07954
                            ],
                            [
                                61.2565,
                                54.03403
                            ],
                            [
                                61.27503,
                                53.98493
                            ],
                            [
                                61.03561,
                                53.95382
                            ],
                            [
                                60.98944,
                                53.89795
                            ],
                            [
                                61.13466,
                                53.88134
                            ],
                            [
                                61.21825,
                                53.81546
                            ],
                            [
                                61.1104,
                                53.71626
                            ],
                            [
                                60.91651,
                                53.61695
                            ],
                            [
                                61.11081,
                                53.59751
                            ],
                            [
                                61.17276,
                                53.56802
                            ],
                            [
                                61.35492,
                                53.55941
                            ],
                            [
                                61.4328,
                                53.5918
                            ],
                            [
                                61.55551,
                                53.57486
                            ],
                            [
                                61.58527,
                                53.50545
                            ],
                            [
                                61.48258,
                                53.46179
                            ],
                            [
                                61.2555,
                                53.50193
                            ],
                            [
                                61.23453,
                                53.43733
                            ],
                            [
                                61.16188,
                                53.39254
                            ],
                            [
                                61.17279,
                                53.30512
                            ],
                            [
                                61.24406,
                                53.27298
                            ],
                            [
                                61.39437,
                                53.26725
                            ],
                            [
                                61.4633,
                                53.22403
                            ],
                            [
                                61.60898,
                                53.21531
                            ],
                            [
                                61.66847,
                                53.25138
                            ],
                            [
                                61.8005,
                                53.16054
                            ],
                            [
                                61.94635,
                                53.12924
                            ],
                            [
                                62.11008,
                                53.11662
                            ],
                            [
                                62.13703,
                                53.00658
                            ],
                            [
                                62.0067,
                                52.95176
                            ],
                            [
                                61.89421,
                                53.00938
                            ],
                            [
                                61.71465,
                                52.99656
                            ],
                            [
                                61.64488,
                                52.9625
                            ],
                            [
                                61.5365,
                                53.01827
                            ],
                            [
                                61.45381,
                                53.03241
                            ],
                            [
                                61.37368,
                                52.98707
                            ],
                            [
                                61.23724,
                                53.03149
                            ],
                            [
                                61.11524,
                                52.97061
                            ],
                            [
                                61.07237,
                                52.91081
                            ],
                            [
                                60.89714,
                                52.81847
                            ],
                            [
                                60.8247,
                                52.76241
                            ],
                            [
                                60.71701,
                                52.74026
                            ],
                            [
                                60.7147,
                                52.65541
                            ],
                            [
                                60.84112,
                                52.61753
                            ],
                            [
                                60.8435,
                                52.52667
                            ],
                            [
                                60.96563,
                                52.50591
                            ],
                            [
                                61.07106,
                                52.3373
                            ],
                            [
                                60.96251,
                                52.27307
                            ],
                            [
                                60.79515,
                                52.23072
                            ],
                            [
                                60.72205,
                                52.16876
                            ],
                            [
                                60.55649,
                                52.16847
                            ],
                            [
                                60.49282,
                                52.14994
                            ],
                            [
                                60.32438,
                                52.0393
                            ],
                            [
                                60.2268,
                                52.00032
                            ],
                            [
                                60.08439,
                                51.99476
                            ],
                            [
                                60.06043,
                                51.91899
                            ],
                            [
                                60.18158,
                                51.9031
                            ],
                            [
                                60.40309,
                                51.81384
                            ],
                            [
                                60.52252,
                                51.78318
                            ],
                            [
                                60.39436,
                                51.70285
                            ],
                            [
                                60.49085,
                                51.6389
                            ],
                            [
                                60.60301,
                                51.61491
                            ],
                            [
                                60.90352,
                                51.61412
                            ],
                            [
                                60.96255,
                                51.49735
                            ],
                            [
                                61.00366,
                                51.4655
                            ],
                            [
                                61.18005,
                                51.45642
                            ],
                            [
                                61.28912,
                                51.41019
                            ],
                            [
                                61.50968,
                                51.41456
                            ],
                            [
                                61.55262,
                                51.34082
                            ],
                            [
                                61.67621,
                                51.26487
                            ],
                            [
                                61.57971,
                                51.23134
                            ],
                            [
                                61.45035,
                                50.80728
                            ],
                            [
                                61.3566,
                                50.77334
                            ],
                            [
                                61.00955,
                                50.68657
                            ],
                            [
                                60.82785,
                                50.66117
                            ],
                            [
                                60.5841,
                                50.6645
                            ],
                            [
                                60.34761,
                                50.68094
                            ],
                            [
                                60.19487,
                                50.78932
                            ],
                            [
                                60.19124,
                                50.83514
                            ],
                            [
                                60.06936,
                                50.86543
                            ],
                            [
                                60.00373,
                                50.82881
                            ],
                            [
                                59.93468,
                                50.70703
                            ],
                            [
                                59.83142,
                                50.5837
                            ],
                            [
                                59.51833,
                                50.52424
                            ],
                            [
                                59.53633,
                                50.6113
                            ],
                            [
                                59.48559,
                                50.65486
                            ],
                            [
                                59.39024,
                                50.64838
                            ],
                            [
                                59.10308,
                                50.68479
                            ],
                            [
                                58.94105,
                                50.69439
                            ],
                            [
                                58.79712,
                                50.76659
                            ],
                            [
                                58.78732,
                                50.82998
                            ],
                            [
                                58.65393,
                                50.81621
                            ],
                            [
                                58.59111,
                                50.8369
                            ],
                            [
                                58.56687,
                                50.93943
                            ],
                            [
                                58.59794,
                                51.02409
                            ],
                            [
                                58.54266,
                                51.07517
                            ],
                            [
                                58.35725,
                                51.0915
                            ],
                            [
                                58.32517,
                                51.15244
                            ],
                            [
                                58.21554,
                                51.13198
                            ],
                            [
                                58.17664,
                                51.06837
                            ],
                            [
                                58.08892,
                                51.12531
                            ],
                            [
                                58.00058,
                                51.08463
                            ],
                            [
                                57.81761,
                                51.1391
                            ],
                            [
                                57.75433,
                                51.12738
                            ],
                            [
                                57.73186,
                                50.93268
                            ],
                            [
                                57.65242,
                                50.94297
                            ],
                            [
                                57.4407,
                                50.89074
                            ],
                            [
                                57.32058,
                                50.95433
                            ],
                            [
                                57.29429,
                                51.01382
                            ],
                            [
                                57.18488,
                                51.09424
                            ],
                            [
                                57.05386,
                                51.05716
                            ],
                            [
                                56.90019,
                                51.05394
                            ],
                            [
                                56.80761,
                                51.08372
                            ],
                            [
                                56.72308,
                                51.07265
                            ],
                            [
                                56.73062,
                                50.97243
                            ],
                            [
                                56.63513,
                                50.99103
                            ],
                            [
                                56.53901,
                                51.04731
                            ],
                            [
                                56.47739,
                                50.98096
                            ],
                            [
                                56.38251,
                                50.92566
                            ],
                            [
                                56.17334,
                                50.91684
                            ],
                            [
                                56.1378,
                                50.77183
                            ],
                            [
                                55.96931,
                                50.68377
                            ],
                            [
                                55.81404,
                                50.63824
                            ],
                            [
                                55.66248,
                                50.5732
                            ],
                            [
                                55.49956,
                                50.64711
                            ],
                            [
                                55.35566,
                                50.66045
                            ],
                            [
                                55.0678,
                                50.82175
                            ],
                            [
                                55.08291,
                                50.91999
                            ],
                            [
                                54.90149,
                                50.86419
                            ],
                            [
                                54.70762,
                                50.89221
                            ],
                            [
                                54.65615,
                                50.8072
                            ],
                            [
                                54.72646,
                                50.63078
                            ],
                            [
                                54.62665,
                                50.55276
                            ],
                            [
                                54.51351,
                                50.53986
                            ],
                            [
                                54.42544,
                                50.62088
                            ],
                            [
                                54.4532,
                                50.73703
                            ],
                            [
                                54.51485,
                                50.82996
                            ],
                            [
                                54.44646,
                                50.871
                            ],
                            [
                                54.32262,
                                50.87812
                            ],
                            [
                                54.16811,
                                51.0208
                            ],
                            [
                                54.12725,
                                51.11933
                            ],
                            [
                                53.89974,
                                51.20042
                            ],
                            [
                                53.75173,
                                51.20538
                            ],
                            [
                                53.67496,
                                51.22943
                            ],
                            [
                                53.6117,
                                51.31948
                            ],
                            [
                                53.63829,
                                51.37875
                            ],
                            [
                                53.57385,
                                51.42957
                            ],
                            [
                                53.45022,
                                51.46416
                            ],
                            [
                                53.37397,
                                51.51475
                            ],
                            [
                                53.29381,
                                51.48815
                            ],
                            [
                                53.14688,
                                51.51332
                            ],
                            [
                                52.9548,
                                51.46345
                            ],
                            [
                                52.91534,
                                51.49647
                            ],
                            [
                                52.7716,
                                51.51524
                            ],
                            [
                                52.63041,
                                51.45712
                            ],
                            [
                                52.55056,
                                51.46548
                            ],
                            [
                                52.5016,
                                51.54913
                            ],
                            [
                                52.3851,
                                51.65492
                            ],
                            [
                                52.36714,
                                51.7397
                            ],
                            [
                                52.17583,
                                51.71942
                            ],
                            [
                                52.1398,
                                51.66804
                            ],
                            [
                                52.02839,
                                51.65282
                            ],
                            [
                                51.85569,
                                51.68129
                            ],
                            [
                                51.7586,
                                51.59528
                            ],
                            [
                                51.78389,
                                51.51695
                            ],
                            [
                                51.64797,
                                51.46943
                            ],
                            [
                                51.6424,
                                51.51764
                            ],
                            [
                                51.55998,
                                51.56069
                            ],
                            [
                                51.43564,
                                51.48477
                            ],
                            [
                                51.27819,
                                51.49995
                            ],
                            [
                                51.2542,
                                51.56166
                            ],
                            [
                                51.36414,
                                51.57975
                            ],
                            [
                                51.35573,
                                51.6529
                            ],
                            [
                                51.26248,
                                51.68918
                            ],
                            [
                                51.06414,
                                51.66866
                            ],
                            [
                                50.89105,
                                51.68113
                            ],
                            [
                                50.86089,
                                51.73904
                            ],
                            [
                                50.74272,
                                51.76268
                            ],
                            [
                                50.7145,
                                51.62733
                            ],
                            [
                                50.56695,
                                51.64056
                            ],
                            [
                                50.51634,
                                51.60121
                            ],
                            [
                                50.51053,
                                51.47702
                            ],
                            [
                                50.45645,
                                51.43923
                            ],
                            [
                                50.36703,
                                51.4365
                            ],
                            [
                                50.36632,
                                51.34077
                            ],
                            [
                                50.22407,
                                51.29548
                            ],
                            [
                                49.95785,
                                51.24179
                            ],
                            [
                                49.73639,
                                51.11556
                            ],
                            [
                                49.59647,
                                51.12421
                            ],
                            [
                                49.50907,
                                51.10868
                            ],
                            [
                                49.42068,
                                51.12759
                            ],
                            [
                                49.32832,
                                50.98748
                            ],
                            [
                                49.42046,
                                50.87723
                            ],
                            [
                                49.0984,
                                50.78567
                            ],
                            [
                                48.94145,
                                50.66125
                            ],
                            [
                                48.82578,
                                50.60217
                            ],
                            [
                                48.70015,
                                50.62393
                            ],
                            [
                                48.63726,
                                50.53954
                            ],
                            [
                                48.71766,
                                50.25595
                            ],
                            [
                                48.77802,
                                50.18059
                            ],
                            [
                                48.75755,
                                50.10909
                            ],
                            [
                                48.84943,
                                50.08475
                            ],
                            [
                                48.86284,
                                50.00779
                            ],
                            [
                                48.73609,
                                49.92811
                            ],
                            [
                                48.4407,
                                49.83981
                            ],
                            [
                                48.34795,
                                49.83179
                            ],
                            [
                                48.21639,
                                49.90959
                            ],
                            [
                                48.13051,
                                49.99506
                            ],
                            [
                                48.09645,
                                50.08998
                            ],
                            [
                                47.98417,
                                50.17669
                            ],
                            [
                                47.81544,
                                50.33051
                            ],
                            [
                                47.74064,
                                50.38024
                            ],
                            [
                                47.5519,
                                50.46202
                            ],
                            [
                                47.44435,
                                50.41561
                            ],
                            [
                                47.40534,
                                50.33923
                            ],
                            [
                                47.32017,
                                50.33075
                            ],
                            [
                                47.26234,
                                50.19905
                            ],
                            [
                                47.33706,
                                50.10185
                            ],
                            [
                                47.26516,
                                50.00674
                            ],
                            [
                                47.16204,
                                49.92633
                            ],
                            [
                                46.89359,
                                49.83964
                            ],
                            [
                                46.85942,
                                49.6093
                            ],
                            [
                                46.8193,
                                49.55403
                            ],
                            [
                                46.78406,
                                49.33305
                            ],
                            [
                                47.02154,
                                49.20832
                            ],
                            [
                                47.05208,
                                49.16498
                            ],
                            [
                                47.00334,
                                49.06047
                            ],
                            [
                                46.93721,
                                49.00399
                            ],
                            [
                                46.77661,
                                48.93558
                            ],
                            [
                                46.6005,
                                48.64528
                            ],
                            [
                                46.49334,
                                48.444
                            ],
                            [
                                46.80059,
                                48.34895
                            ],
                            [
                                46.92931,
                                48.32098
                            ],
                            [
                                47.0369,
                                48.23016
                            ],
                            [
                                47.09613,
                                48.21131
                            ],
                            [
                                47.09632,
                                48.10713
                            ],
                            [
                                47.13607,
                                48.03911
                            ],
                            [
                                47.01932,
                                47.99795
                            ],
                            [
                                47.15898,
                                47.83939
                            ],
                            [
                                47.11889,
                                47.81343
                            ],
                            [
                                47.19697,
                                47.74892
                            ],
                            [
                                47.37532,
                                47.67772
                            ],
                            [
                                47.40734,
                                47.80957
                            ],
                            [
                                47.66299,
                                47.74834
                            ],
                            [
                                48.05556,
                                47.76089
                            ],
                            [
                                48.1841,
                                47.67579
                            ],
                            [
                                48.27824,
                                47.54552
                            ],
                            [
                                48.38094,
                                47.4345
                            ],
                            [
                                48.60749,
                                47.41357
                            ],
                            [
                                48.66181,
                                47.2084
                            ],
                            [
                                48.78232,
                                47.01004
                            ],
                            [
                                48.97074,
                                46.83517
                            ],
                            [
                                49.00487,
                                46.76645
                            ],
                            [
                                48.91443,
                                46.69364
                            ],
                            [
                                48.75044,
                                46.68869
                            ],
                            [
                                48.65804,
                                46.77059
                            ],
                            [
                                48.58226,
                                46.77387
                            ],
                            [
                                48.51008,
                                46.73144
                            ],
                            [
                                48.48107,
                                46.65835
                            ],
                            [
                                48.56039,
                                46.60849
                            ],
                            [
                                48.64114,
                                46.60686
                            ],
                            [
                                48.67087,
                                46.56377
                            ],
                            [
                                48.7751,
                                46.53522
                            ],
                            [
                                48.82236,
                                46.47751
                            ],
                            [
                                49.14863,
                                46.3701
                            ],
                            [
                                49.21362,
                                46.33324
                            ],
                            [
                                49.24711,
                                46.38764
                            ],
                            [
                                49.3594,
                                46.42888
                            ],
                            [
                                49.40759,
                                46.53415
                            ],
                            [
                                49.4725,
                                46.55836
                            ],
                            [
                                49.62461,
                                46.51989
                            ],
                            [
                                49.677,
                                46.54356
                            ],
                            [
                                49.87991,
                                46.57365
                            ],
                            [
                                50.01881,
                                46.6267
                            ],
                            [
                                50.14337,
                                46.7306
                            ],
                            [
                                50.27266,
                                46.75509
                            ],
                            [
                                50.30203,
                                46.79901
                            ],
                            [
                                50.38349,
                                46.81413
                            ],
                            [
                                50.4378,
                                46.8972
                            ],
                            [
                                50.50477,
                                46.86006
                            ],
                            [
                                50.60738,
                                46.9175
                            ],
                            [
                                50.73568,
                                46.96307
                            ],
                            [
                                50.79619,
                                46.96236
                            ],
                            [
                                50.85935,
                                47.03174
                            ],
                            [
                                51.10018,
                                47.07053
                            ],
                            [
                                51.19124,
                                47.11228
                            ],
                            [
                                51.52675,
                                47.05254
                            ],
                            [
                                51.61098,
                                46.98391
                            ],
                            [
                                51.79432,
                                46.90166
                            ],
                            [
                                51.99589,
                                46.88521
                            ],
                            [
                                52.0967,
                                46.81153
                            ],
                            [
                                52.23708,
                                46.80071
                            ],
                            [
                                52.25641,
                                46.86183
                            ],
                            [
                                52.37662,
                                46.89678
                            ],
                            [
                                52.44834,
                                46.99275
                            ],
                            [
                                52.57254,
                                46.95306
                            ],
                            [
                                52.80345,
                                46.93454
                            ],
                            [
                                52.88793,
                                46.96016
                            ],
                            [
                                52.99506,
                                46.89064
                            ],
                            [
                                53.06491,
                                46.88083
                            ],
                            [
                                53.09976,
                                46.74221
                            ],
                            [
                                53.19415,
                                46.71286
                            ],
                            [
                                53.20527,
                                46.63785
                            ],
                            [
                                53.10027,
                                46.60647
                            ],
                            [
                                53.07833,
                                46.43258
                            ],
                            [
                                53.16415,
                                46.31508
                            ],
                            [
                                53.07972,
                                45.99424
                            ],
                            [
                                52.93638,
                                45.80091
                            ],
                            [
                                52.87193,
                                45.77174
                            ],
                            [
                                52.80027,
                                45.67147
                            ],
                            [
                                52.74718,
                                45.6433
                            ],
                            [
                                52.73331,
                                45.5485
                            ],
                            [
                                52.75845,
                                45.50971
                            ],
                            [
                                53.06889,
                                45.40174
                            ],
                            [
                                53.11194,
                                45.40312
                            ],
                            [
                                53.22027,
                                45.33535
                            ],
                            [
                                53.10889,
                                45.29647
                            ],
                            [
                                52.89861,
                                45.30952
                            ],
                            [
                                52.74724,
                                45.33925
                            ],
                            [
                                52.53797,
                                45.40148
                            ],
                            [
                                52.34679,
                                45.40236
                            ],
                            [
                                52.20414,
                                45.38258
                            ],
                            [
                                51.98336,
                                45.38347
                            ],
                            [
                                51.72235,
                                45.39983
                            ],
                            [
                                51.58891,
                                45.3332
                            ],
                            [
                                51.40887,
                                45.34187
                            ],
                            [
                                51.30837,
                                45.24887
                            ],
                            [
                                51.2481,
                                45.16575
                            ],
                            [
                                51.24902,
                                45.0228
                            ],
                            [
                                51.17732,
                                45.05697
                            ],
                            [
                                51.00987,
                                44.99054
                            ],
                            [
                                50.9591,
                                44.85102
                            ],
                            [
                                51.22095,
                                44.72509
                            ],
                            [
                                51.29845,
                                44.59668
                            ],
                            [
                                51.4102,
                                44.60784
                            ],
                            [
                                51.57055,
                                44.53202
                            ],
                            [
                                51.27955,
                                44.54287
                            ],
                            [
                                51.21932,
                                44.48778
                            ],
                            [
                                51.14014,
                                44.47737
                            ],
                            [
                                50.9945,
                                44.52902
                            ],
                            [
                                50.91365,
                                44.60349
                            ],
                            [
                                50.78765,
                                44.63082
                            ],
                            [
                                50.63681,
                                44.61415
                            ],
                            [
                                50.4302,
                                44.62533
                            ],
                            [
                                50.31505,
                                44.65617
                            ],
                            [
                                50.27455,
                                44.56657
                            ],
                            [
                                50.22488,
                                44.57122
                            ],
                            [
                                50.23523,
                                44.36166
                            ],
                            [
                                50.27947,
                                44.32759
                            ],
                            [
                                50.42323,
                                44.28708
                            ],
                            [
                                50.67906,
                                44.26205
                            ],
                            [
                                50.8188,
                                44.20826
                            ],
                            [
                                50.85038,
                                44.16648
                            ],
                            [
                                50.85077,
                                44.04338
                            ],
                            [
                                50.98343,
                                43.91073
                            ],
                            [
                                51.01834,
                                43.80467
                            ],
                            [
                                51.14765,
                                43.61845
                            ],
                            [
                                51.19335,
                                43.61967
                            ],
                            [
                                51.27174,
                                43.54648
                            ],
                            [
                                51.32239,
                                43.40856
                            ],
                            [
                                51.31432,
                                43.29424
                            ],
                            [
                                51.26248,
                                43.16764
                            ],
                            [
                                51.51019,
                                43.14963
                            ],
                            [
                                51.65293,
                                43.18101
                            ],
                            [
                                51.70813,
                                43.08592
                            ],
                            [
                                51.7693,
                                43.02949
                            ],
                            [
                                51.8295,
                                42.90897
                            ],
                            [
                                51.94616,
                                42.8345
                            ],
                            [
                                52.08481,
                                42.8785
                            ],
                            [
                                52.17185,
                                42.88172
                            ],
                            [
                                52.29607,
                                42.78769
                            ],
                            [
                                52.3318,
                                42.82094
                            ],
                            [
                                52.42749,
                                42.82972
                            ],
                            [
                                52.57499,
                                42.79666
                            ],
                            [
                                52.73685,
                                42.70762
                            ],
                            [
                                52.74545,
                                42.6482
                            ],
                            [
                                52.67997,
                                42.56397
                            ],
                            [
                                52.66899,
                                42.49056
                            ],
                            [
                                52.60398,
                                42.38862
                            ],
                            [
                                52.59202,
                                42.3299
                            ],
                            [
                                52.40719,
                                42.0948
                            ],
                            [
                                52.42995,
                                41.99902
                            ],
                            [
                                52.49469,
                                41.89929
                            ],
                            [
                                52.43217,
                                41.75973
                            ],
                            [
                                52.62846,
                                41.88163
                            ],
                            [
                                52.9583,
                                42.1025
                            ],
                            [
                                53.4215,
                                42.25904
                            ],
                            [
                                53.58719,
                                42.29277
                            ],
                            [
                                53.95281,
                                42.33612
                            ],
                            [
                                54.16777,
                                42.34333
                            ],
                            [
                                54.28725,
                                42.30537
                            ],
                            [
                                54.83604,
                                42.02234
                            ],
                            [
                                54.9576,
                                41.90978
                            ],
                            [
                                54.96858,
                                41.8014
                            ],
                            [
                                55.07109,
                                41.70891
                            ],
                            [
                                55.14612,
                                41.57655
                            ],
                            [
                                55.2832,
                                41.41594
                            ],
                            [
                                55.46618,
                                41.2757
                            ],
                            [
                                55.77979,
                                41.29468
                            ],
                            [
                                55.86738,
                                41.32203
                            ],
                            [
                                56.0006,
                                41.31805
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                52.96027,
                                46.26425
                            ],
                            [
                                53.06416,
                                46.25036
                            ],
                            [
                                53.09749,
                                46.29452
                            ],
                            [
                                53.05833,
                                46.35814
                            ],
                            [
                                52.96027,
                                46.26425
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "KEN",
                "Country": "Kenya",
                "Total_3GHG": 0.23,
                "Total_3GHG_timeseries": [
                    1.0061e-06,
                    1.9903e-06,
                    2.9853e-06,
                    3.9697e-06,
                    4.9534e-06,
                    5.9374e-06,
                    6.9486e-06,
                    7.9529e-06,
                    8.959e-06,
                    9.9668e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037
                ],
                "Fossil_3GHG": 0.11,
                "Fossil_3GHG_timeseries": [
                    9.8154e-08,
                    1.9806e-07,
                    2.9974e-07,
                    4.0326e-07,
                    5.0863e-07,
                    6.159e-07,
                    7.2509e-07,
                    8.3626e-07,
                    9.4942e-07,
                    1.0646e-06,
                    1.1828e-06,
                    1.3041e-06,
                    1.4285e-06,
                    1.5562e-06,
                    1.6871e-06,
                    1.8213e-06,
                    1.959e-06,
                    2.1002e-06,
                    2.2449e-06,
                    2.3934e-06,
                    2.5446e-06,
                    2.699e-06,
                    2.8566e-06,
                    3.0178e-06,
                    3.1826e-06,
                    3.3512e-06,
                    3.5234e-06,
                    3.6994e-06,
                    3.8789e-06,
                    4.066e-06,
                    4.2597e-06,
                    4.4601e-06,
                    4.6674e-06,
                    4.8818e-06,
                    5.1034e-06,
                    5.3324e-06,
                    5.5691e-06,
                    5.8135e-06,
                    6.0659e-06,
                    6.3007e-06,
                    6.5446e-06,
                    6.7978e-06,
                    7.0605e-06,
                    7.3332e-06,
                    7.6161e-06,
                    7.9097e-06,
                    8.2143e-06,
                    8.5302e-06,
                    8.8577e-06,
                    9.1936e-06,
                    9.6061e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012
                ],
                "Land_3GHG": 0.44,
                "Land_3GHG_timeseries": [
                    9.079e-07,
                    1.7923e-06,
                    2.6855e-06,
                    3.5664e-06,
                    4.4447e-06,
                    5.3215e-06,
                    6.2235e-06,
                    7.1166e-06,
                    8.0096e-06,
                    8.9022e-06,
                    9.8061e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0025
                ],
                "Total_CO2": 0.11,
                "Total_CO2_timeseries": [
                    4.2684e-07,
                    8.2764e-07,
                    1.2349e-06,
                    1.6276e-06,
                    2.0156e-06,
                    2.4001e-06,
                    2.8081e-06,
                    3.206e-06,
                    3.6025e-06,
                    3.9979e-06,
                    4.3985e-06,
                    4.805e-06,
                    5.213e-06,
                    5.6219e-06,
                    6.0317e-06,
                    6.4461e-06,
                    6.868e-06,
                    7.3025e-06,
                    7.7291e-06,
                    8.1735e-06,
                    8.629e-06,
                    9.0987e-06,
                    9.572e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013
                ],
                "Fossil_CO2": 0.03,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    4.092e-07,
                    1.0362e-06,
                    1.7522e-06,
                    2.4336e-06,
                    3.1991e-06,
                    4.0931e-06,
                    5.0927e-06,
                    6.1203e-06,
                    7.0604e-06,
                    8.0547e-06,
                    9.1464e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_CO2": 0.28,
                "Land_CO2_timeseries": [
                    4.2684e-07,
                    8.2764e-07,
                    1.2349e-06,
                    1.6276e-06,
                    2.0156e-06,
                    2.4001e-06,
                    2.8081e-06,
                    3.206e-06,
                    3.6025e-06,
                    3.9979e-06,
                    4.3985e-06,
                    4.805e-06,
                    5.213e-06,
                    5.6219e-06,
                    6.0317e-06,
                    6.4461e-06,
                    6.868e-06,
                    7.3025e-06,
                    7.7291e-06,
                    8.1735e-06,
                    8.629e-06,
                    9.0987e-06,
                    9.572e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001
                ],
                "Total_CH4": 0.5,
                "Total_CH4_timeseries": [
                    4.3658e-07,
                    8.7481e-07,
                    1.3147e-06,
                    1.7564e-06,
                    2.1998e-06,
                    2.6451e-06,
                    3.0922e-06,
                    3.5413e-06,
                    3.9925e-06,
                    4.4456e-06,
                    4.9076e-06,
                    5.3786e-06,
                    5.8584e-06,
                    6.3473e-06,
                    6.8453e-06,
                    7.3525e-06,
                    7.8689e-06,
                    8.3947e-06,
                    8.9298e-06,
                    9.4745e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021
                ],
                "Fossil_CH4": 0.35,
                "Fossil_CH4_timeseries": [
                    6.485e-08,
                    1.3103e-07,
                    1.9859e-07,
                    2.6756e-07,
                    3.3802e-07,
                    4.1e-07,
                    4.8355e-07,
                    5.5875e-07,
                    6.3563e-07,
                    7.1427e-07,
                    7.9567e-07,
                    8.7988e-07,
                    9.6698e-07,
                    1.057e-06,
                    1.1501e-06,
                    1.2463e-06,
                    1.3457e-06,
                    1.4483e-06,
                    1.5542e-06,
                    1.6636e-06,
                    1.7753e-06,
                    1.8895e-06,
                    2.0061e-06,
                    2.1253e-06,
                    2.247e-06,
                    2.3714e-06,
                    2.4984e-06,
                    2.6282e-06,
                    2.7608e-06,
                    2.9003e-06,
                    3.046e-06,
                    3.1981e-06,
                    3.3567e-06,
                    3.5219e-06,
                    3.6941e-06,
                    3.8733e-06,
                    4.0598e-06,
                    4.2537e-06,
                    4.4553e-06,
                    4.6381e-06,
                    4.8293e-06,
                    5.0293e-06,
                    5.2382e-06,
                    5.4564e-06,
                    5.6841e-06,
                    5.9218e-06,
                    6.1697e-06,
                    6.4283e-06,
                    6.6977e-06,
                    6.9747e-06,
                    7.3275e-06,
                    7.7691e-06,
                    8.3145e-06,
                    8.8108e-06,
                    9.2588e-06,
                    9.7468e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009
                ],
                "Land_CH4": 0.76,
                "Land_CH4_timeseries": [
                    3.7173e-07,
                    7.4378e-07,
                    1.1161e-06,
                    1.4888e-06,
                    1.8618e-06,
                    2.2351e-06,
                    2.6087e-06,
                    2.9826e-06,
                    3.3568e-06,
                    3.7314e-06,
                    4.112e-06,
                    4.4987e-06,
                    4.8914e-06,
                    5.2903e-06,
                    5.6952e-06,
                    6.1062e-06,
                    6.5232e-06,
                    6.9464e-06,
                    7.3756e-06,
                    7.8109e-06,
                    8.2524e-06,
                    8.7002e-06,
                    9.1542e-06,
                    9.6145e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012
                ],
                "Total_N2O": 0.43,
                "Total_N2O_timeseries": [
                    1.4263e-07,
                    2.8787e-07,
                    4.3561e-07,
                    5.8572e-07,
                    7.38e-07,
                    8.9226e-07,
                    1.0482e-06,
                    1.2056e-06,
                    1.364e-06,
                    1.5232e-06,
                    1.6828e-06,
                    1.8428e-06,
                    2.0032e-06,
                    2.164e-06,
                    2.325e-06,
                    2.4864e-06,
                    2.6481e-06,
                    2.8102e-06,
                    2.9728e-06,
                    3.1358e-06,
                    3.3013e-06,
                    3.4727e-06,
                    3.6526e-06,
                    3.843e-06,
                    4.0447e-06,
                    4.2581e-06,
                    4.4826e-06,
                    4.7169e-06,
                    4.9589e-06,
                    5.2057e-06,
                    5.4552e-06,
                    5.7072e-06,
                    5.9611e-06,
                    6.2169e-06,
                    6.4743e-06,
                    6.7333e-06,
                    6.9938e-06,
                    7.256e-06,
                    7.5199e-06,
                    7.7963e-06,
                    8.0753e-06,
                    8.3573e-06,
                    8.6421e-06,
                    8.9301e-06,
                    9.2212e-06,
                    9.5157e-06,
                    9.8136e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004
                ],
                "Fossil_N2O": 0.16,
                "Fossil_N2O_timeseries": [
                    3.3304e-08,
                    6.7026e-08,
                    1.0116e-07,
                    1.3569e-07,
                    1.7061e-07,
                    2.059e-07,
                    2.4154e-07,
                    2.7751e-07,
                    3.1379e-07,
                    3.5034e-07,
                    3.8715e-07,
                    4.2422e-07,
                    4.6155e-07,
                    4.9912e-07,
                    5.3694e-07,
                    5.7501e-07,
                    6.1333e-07,
                    6.519e-07,
                    6.9073e-07,
                    7.2982e-07,
                    7.6932e-07,
                    8.0949e-07,
                    8.5051e-07,
                    8.9252e-07,
                    9.356e-07,
                    9.7977e-07,
                    1.025e-06,
                    1.0712e-06,
                    1.1181e-06,
                    1.1657e-06,
                    1.2136e-06,
                    1.262e-06,
                    1.3108e-06,
                    1.3599e-06,
                    1.4093e-06,
                    1.4591e-06,
                    1.5092e-06,
                    1.5597e-06,
                    1.6106e-06,
                    1.6626e-06,
                    1.7152e-06,
                    1.7685e-06,
                    1.8224e-06,
                    1.8769e-06,
                    1.9321e-06,
                    1.988e-06,
                    2.0446e-06,
                    2.1019e-06,
                    2.16e-06,
                    2.2189e-06,
                    2.2787e-06,
                    2.3394e-06,
                    2.4011e-06,
                    2.4639e-06,
                    2.5278e-06,
                    2.5927e-06,
                    2.6588e-06,
                    2.7259e-06,
                    2.7939e-06,
                    2.8628e-06,
                    2.9325e-06,
                    3.0029e-06,
                    3.074e-06,
                    3.1458e-06,
                    3.2183e-06,
                    3.2915e-06,
                    3.3654e-06,
                    3.4399e-06,
                    3.5152e-06,
                    3.5912e-06,
                    3.6679e-06,
                    3.7453e-06,
                    3.8235e-06,
                    3.9024e-06,
                    3.982e-06,
                    4.0624e-06,
                    4.1436e-06,
                    4.2255e-06,
                    4.3083e-06,
                    4.3919e-06,
                    4.4765e-06,
                    4.5622e-06,
                    4.6491e-06,
                    4.7373e-06,
                    4.8269e-06,
                    4.9181e-06,
                    5.0108e-06,
                    5.1052e-06,
                    5.2013e-06,
                    5.2991e-06,
                    5.399e-06,
                    5.5018e-06,
                    5.608e-06,
                    5.7181e-06,
                    5.8324e-06,
                    5.951e-06,
                    6.0739e-06,
                    6.201e-06,
                    6.3321e-06,
                    6.4668e-06,
                    6.6048e-06,
                    6.7466e-06,
                    6.8922e-06,
                    7.0417e-06,
                    7.1951e-06,
                    7.3525e-06,
                    7.5138e-06,
                    7.6787e-06,
                    7.8472e-06,
                    8.0188e-06,
                    8.1936e-06,
                    8.3716e-06,
                    8.5531e-06,
                    8.7382e-06,
                    8.9272e-06,
                    9.1201e-06,
                    9.3171e-06,
                    9.5186e-06,
                    9.7246e-06,
                    9.9431e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.53,
                "Land_N2O_timeseries": [
                    1.0933e-07,
                    2.2085e-07,
                    3.3446e-07,
                    4.5003e-07,
                    5.6739e-07,
                    6.8636e-07,
                    8.0667e-07,
                    9.2808e-07,
                    1.0502e-06,
                    1.1729e-06,
                    1.2957e-06,
                    1.4186e-06,
                    1.5417e-06,
                    1.6649e-06,
                    1.7881e-06,
                    1.9114e-06,
                    2.0348e-06,
                    2.1583e-06,
                    2.282e-06,
                    2.4059e-06,
                    2.5319e-06,
                    2.6632e-06,
                    2.8021e-06,
                    2.9504e-06,
                    3.1091e-06,
                    3.2783e-06,
                    3.4576e-06,
                    3.6458e-06,
                    3.8408e-06,
                    4.04e-06,
                    4.2416e-06,
                    4.4452e-06,
                    4.6504e-06,
                    4.8571e-06,
                    5.065e-06,
                    5.2742e-06,
                    5.4846e-06,
                    5.6962e-06,
                    5.9094e-06,
                    6.1337e-06,
                    6.3601e-06,
                    6.5888e-06,
                    6.8198e-06,
                    7.0532e-06,
                    7.2892e-06,
                    7.5277e-06,
                    7.769e-06,
                    8.0131e-06,
                    8.26e-06,
                    8.5098e-06,
                    8.7625e-06,
                    9.018e-06,
                    9.2762e-06,
                    9.5372e-06,
                    9.8012e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            41.56449,
                            -1.65575
                        ],
                        [
                            41.56449,
                            -1.60122
                        ],
                        [
                            41.2222,
                            -1.1391
                        ],
                        [
                            40.99565,
                            -0.83324
                        ],
                        [
                            40.99565,
                            0.08363
                        ],
                        [
                            40.99565,
                            0.69407
                        ],
                        [
                            40.99565,
                            1.23274
                        ],
                        [
                            40.99565,
                            1.69952
                        ],
                        [
                            40.99492,
                            2.34004
                        ],
                        [
                            40.99565,
                            2.82169
                        ],
                        [
                            41.33322,
                            3.15642
                        ],
                        [
                            41.64906,
                            3.60858
                        ],
                        [
                            41.91012,
                            3.98232
                        ],
                        [
                            41.82491,
                            3.94944
                        ],
                        [
                            41.78162,
                            3.97877
                        ],
                        [
                            41.55244,
                            3.98069
                        ],
                        [
                            41.42415,
                            3.94824
                        ],
                        [
                            41.33113,
                            3.93962
                        ],
                        [
                            41.26817,
                            3.9553
                        ],
                        [
                            41.20769,
                            3.9356
                        ],
                        [
                            41.13827,
                            3.9656
                        ],
                        [
                            41.04122,
                            4.07501
                        ],
                        [
                            40.95724,
                            4.14369
                        ],
                        [
                            40.90834,
                            4.15746
                        ],
                        [
                            40.88602,
                            4.21273
                        ],
                        [
                            40.75792,
                            4.28145
                        ],
                        [
                            40.74444,
                            4.26333
                        ],
                        [
                            40.1829,
                            4.03301
                        ],
                        [
                            39.86842,
                            3.86812
                        ],
                        [
                            39.77323,
                            3.66753
                        ],
                        [
                            39.58948,
                            3.48863
                        ],
                        [
                            39.55303,
                            3.40187
                        ],
                        [
                            39.46107,
                            3.45702
                        ],
                        [
                            39.19358,
                            3.48055
                        ],
                        [
                            39.1054,
                            3.52441
                        ],
                        [
                            38.90333,
                            3.51422
                        ],
                        [
                            38.66368,
                            3.59584
                        ],
                        [
                            38.55761,
                            3.61673
                        ],
                        [
                            38.54856,
                            3.64349
                        ],
                        [
                            38.44667,
                            3.60437
                        ],
                        [
                            38.1844,
                            3.62163
                        ],
                        [
                            38.12736,
                            3.60861
                        ],
                        [
                            38.04505,
                            3.67525
                        ],
                        [
                            38.00601,
                            3.7285
                        ],
                        [
                            37.91946,
                            3.77231
                        ],
                        [
                            37.73652,
                            3.89267
                        ],
                        [
                            37.41658,
                            4.11287
                        ],
                        [
                            37.1402,
                            4.29266
                        ],
                        [
                            37.03119,
                            4.38383
                        ],
                        [
                            36.84308,
                            4.44883
                        ],
                        [
                            36.68098,
                            4.44147
                        ],
                        [
                            36.05223,
                            4.4541
                        ],
                        [
                            35.94221,
                            4.54727
                        ],
                        [
                            35.9477,
                            4.62
                        ],
                        [
                            35.50877,
                            4.62
                        ],
                        [
                            35.421314298485058,
                            4.770425976097818
                        ],
                        [
                            35.472193609598193,
                            4.90016821943631
                        ],
                        [
                            35.474737575153846,
                            4.917975978325908
                        ],
                        [
                            35.454385850708597,
                            4.925607874992878
                        ],
                        [
                            35.311923779591822,
                            4.905256150547624
                        ],
                        [
                            35.311923779591822,
                            4.925607874992878
                        ],
                        [
                            35.329731538481418,
                            4.971399254994698
                        ],
                        [
                            35.347539297371014,
                            5.009558738329549
                        ],
                        [
                            35.33481946959273,
                            5.022278566107833
                        ],
                        [
                            35.309379814036163,
                            5.022278566107833
                        ],
                        [
                            35.197445329587268,
                            4.956135461660758
                        ],
                        [
                            35.151653949585445,
                            4.984119082772982
                        ],
                        [
                            35.00919187846867,
                            4.905256150547624
                        ],
                        [
                            34.726811701790773,
                            4.800953562765699
                        ],
                        [
                            34.485134974003387,
                            4.727178561651654
                        ],
                        [
                            34.37846,
                            4.62
                        ],
                        [
                            34.26496,
                            4.48864
                        ],
                        [
                            33.99449,
                            4.21443
                        ],
                        [
                            34.06101,
                            4.15082
                        ],
                        [
                            34.05291,
                            4.10872
                        ],
                        [
                            34.09126,
                            4.04936
                        ],
                        [
                            34.05904,
                            4.00901
                        ],
                        [
                            34.12905,
                            3.95228
                        ],
                        [
                            34.11923,
                            3.90126
                        ],
                        [
                            34.15775,
                            3.87003
                        ],
                        [
                            34.17628,
                            3.76617
                        ],
                        [
                            34.25006,
                            3.78158
                        ],
                        [
                            34.29883,
                            3.71651
                        ],
                        [
                            34.35337,
                            3.73696
                        ],
                        [
                            34.45921,
                            3.66899
                        ],
                        [
                            34.44071,
                            3.50517
                        ],
                        [
                            34.40139,
                            3.38219
                        ],
                        [
                            34.45019,
                            3.24311
                        ],
                        [
                            34.453,
                            3.19128
                        ],
                        [
                            34.49341,
                            3.14362
                        ],
                        [
                            34.5487,
                            3.1315
                        ],
                        [
                            34.59747,
                            2.91899
                        ],
                        [
                            34.65703,
                            2.86452
                        ],
                        [
                            34.70615,
                            2.87316
                        ],
                        [
                            34.77101,
                            2.81204
                        ],
                        [
                            34.77962,
                            2.68997
                        ],
                        [
                            34.86244,
                            2.57061
                        ],
                        [
                            34.92861,
                            2.51649
                        ],
                        [
                            34.9537,
                            2.45562
                        ],
                        [
                            34.91575,
                            2.39879
                        ],
                        [
                            34.98679,
                            1.99129
                        ],
                        [
                            35.03567,
                            1.9181
                        ],
                        [
                            34.99884,
                            1.68216
                        ],
                        [
                            34.9473,
                            1.58218
                        ],
                        [
                            34.88826,
                            1.55557
                        ],
                        [
                            34.84322,
                            1.46054
                        ],
                        [
                            34.77215,
                            1.41643
                        ],
                        [
                            34.82911,
                            1.30342
                        ],
                        [
                            34.79534,
                            1.21986
                        ],
                        [
                            34.67145,
                            1.20611
                        ],
                        [
                            34.57218,
                            1.09795
                        ],
                        [
                            34.52417,
                            1.10441
                        ],
                        [
                            34.4892,
                            1.01364
                        ],
                        [
                            34.47989,
                            0.93567
                        ],
                        [
                            34.41163,
                            0.8241
                        ],
                        [
                            34.3099,
                            0.75911
                        ],
                        [
                            34.27722,
                            0.64174
                        ],
                        [
                            34.15777,
                            0.59103
                        ],
                        [
                            34.09718,
                            0.34823
                        ],
                        [
                            34.04141,
                            0.28852
                        ],
                        [
                            33.91104,
                            0.09936
                        ],
                        [
                            33.98438,
                            -0.13767
                        ],
                        [
                            33.92939,
                            -0.45994
                        ],
                        [
                            33.92553,
                            -0.56166
                        ],
                        [
                            33.93398,
                            -0.99989
                        ],
                        [
                            34.02449,
                            -1.00041
                        ],
                        [
                            34.09884,
                            -1.03383
                        ],
                        [
                            35.16307,
                            -1.63338
                        ],
                        [
                            37.50997,
                            -2.95481
                        ],
                        [
                            37.67141,
                            -3.06522
                        ],
                        [
                            37.70959,
                            -3.30841
                        ],
                        [
                            37.58662,
                            -3.4383
                        ],
                        [
                            37.61847,
                            -3.47973
                        ],
                        [
                            37.74609,
                            -3.54487
                        ],
                        [
                            37.78617,
                            -3.67838
                        ],
                        [
                            38.51215,
                            -4.18596
                        ],
                        [
                            39.20421,
                            -4.67031
                        ],
                        [
                            39.26279,
                            -4.58125
                        ],
                        [
                            39.30978,
                            -4.63743
                        ],
                        [
                            39.38875,
                            -4.64782
                        ],
                        [
                            39.39695,
                            -4.58871
                        ],
                        [
                            39.45106,
                            -4.57771
                        ],
                        [
                            39.50878,
                            -4.43296
                        ],
                        [
                            39.552,
                            -4.38473
                        ],
                        [
                            39.61362,
                            -4.20799
                        ],
                        [
                            39.82597,
                            -3.83104
                        ],
                        [
                            39.86717,
                            -3.70311
                        ],
                        [
                            39.87498,
                            -3.62292
                        ],
                        [
                            39.97747,
                            -3.38403
                        ],
                        [
                            40.09795,
                            -3.30734
                        ],
                        [
                            40.12951,
                            -3.25476
                        ],
                        [
                            40.12516,
                            -3.19769
                        ],
                        [
                            40.15886,
                            -3.13735
                        ],
                        [
                            40.1519,
                            -2.95512
                        ],
                        [
                            40.17825,
                            -2.83322
                        ],
                        [
                            40.17,
                            -2.74594
                        ],
                        [
                            40.2737,
                            -2.64286
                        ],
                        [
                            40.44168,
                            -2.54799
                        ],
                        [
                            40.52932,
                            -2.53492
                        ],
                        [
                            40.61349,
                            -2.55526
                        ],
                        [
                            40.71089,
                            -2.47422
                        ],
                        [
                            40.76911,
                            -2.44847
                        ],
                        [
                            40.81949,
                            -2.39466
                        ],
                        [
                            40.75721,
                            -2.32563
                        ],
                        [
                            40.70823,
                            -2.30509
                        ],
                        [
                            40.73043,
                            -2.24237
                        ],
                        [
                            40.78402,
                            -2.25708
                        ],
                        [
                            40.90402,
                            -2.2239
                        ],
                        [
                            40.92786,
                            -2.2989
                        ],
                        [
                            40.98247,
                            -2.26694
                        ],
                        [
                            40.91578,
                            -2.21125
                        ],
                        [
                            40.91361,
                            -2.09718
                        ],
                        [
                            41.02546,
                            -2.04569
                        ],
                        [
                            41.07831,
                            -1.98649
                        ],
                        [
                            41.16078,
                            -1.95461
                        ],
                        [
                            41.21711,
                            -1.90153
                        ],
                        [
                            41.29036,
                            -1.97362
                        ],
                        [
                            41.35445,
                            -1.91688
                        ],
                        [
                            41.38276,
                            -1.86393
                        ],
                        [
                            41.56449,
                            -1.65575
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "KIR",
                "Country": "Kiribati",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    9.0719e-10,
                    1.8236e-09,
                    2.7492e-09,
                    3.6841e-09,
                    4.6281e-09,
                    5.5813e-09,
                    6.5435e-09,
                    7.5146e-09,
                    8.4946e-09,
                    9.4831e-09,
                    1.0469e-08,
                    1.1453e-08,
                    1.2434e-08,
                    1.3413e-08,
                    1.4389e-08,
                    1.5364e-08,
                    1.6336e-08,
                    1.7307e-08,
                    1.8276e-08,
                    1.9243e-08,
                    2.0207e-08,
                    2.1172e-08,
                    2.2138e-08,
                    2.3107e-08,
                    2.4081e-08,
                    2.506e-08,
                    2.6043e-08,
                    2.7029e-08,
                    2.8016e-08,
                    2.9003e-08,
                    2.9988e-08,
                    3.0982e-08,
                    3.1986e-08,
                    3.2998e-08,
                    3.402e-08,
                    3.5051e-08,
                    3.6092e-08,
                    3.7143e-08,
                    3.8205e-08,
                    3.9295e-08,
                    4.0376e-08,
                    4.145e-08,
                    4.2518e-08,
                    4.3581e-08,
                    4.4639e-08,
                    4.5694e-08,
                    4.6747e-08,
                    4.7798e-08,
                    4.8848e-08,
                    4.9899e-08,
                    5.1003e-08,
                    5.2159e-08,
                    5.3369e-08,
                    5.4635e-08,
                    5.5958e-08,
                    5.7338e-08,
                    5.8775e-08,
                    6.0269e-08,
                    6.1819e-08,
                    6.3422e-08,
                    6.5073e-08,
                    6.6772e-08,
                    6.8519e-08,
                    7.0313e-08,
                    7.2155e-08,
                    7.4043e-08,
                    7.5977e-08,
                    7.7958e-08,
                    7.9986e-08,
                    8.206e-08,
                    8.414e-08,
                    8.6213e-08,
                    8.8281e-08,
                    9.0345e-08,
                    9.2404e-08,
                    9.4448e-08,
                    9.6486e-08,
                    9.8517e-08,
                    1.0053e-07,
                    1.0253e-07,
                    1.0455e-07,
                    1.0656e-07,
                    1.0857e-07,
                    1.1058e-07,
                    1.1259e-07,
                    1.1465e-07,
                    1.1677e-07,
                    1.1893e-07,
                    1.2116e-07,
                    1.2344e-07,
                    1.2588e-07,
                    1.285e-07,
                    1.3131e-07,
                    1.343e-07,
                    1.3745e-07,
                    1.4077e-07,
                    1.4421e-07,
                    1.4779e-07,
                    1.5149e-07,
                    1.5532e-07,
                    1.5943e-07,
                    1.6385e-07,
                    1.686e-07,
                    1.737e-07,
                    1.7918e-07,
                    1.8499e-07,
                    1.9116e-07,
                    1.977e-07,
                    2.0463e-07,
                    2.1196e-07,
                    2.2181e-07,
                    2.334e-07,
                    2.4841e-07,
                    2.6573e-07,
                    2.7978e-07,
                    2.9253e-07,
                    3.104e-07,
                    3.334e-07,
                    3.4645e-07,
                    3.6501e-07,
                    3.8771e-07,
                    4.0924e-07,
                    4.3621e-07,
                    4.6199e-07,
                    4.881e-07,
                    5.1457e-07,
                    5.3646e-07,
                    5.5866e-07,
                    5.8284e-07,
                    6.0905e-07,
                    6.3661e-07,
                    6.6313e-07,
                    6.8861e-07,
                    7.1247e-07,
                    7.3728e-07,
                    7.6261e-07,
                    7.904e-07,
                    8.1903e-07,
                    8.4874e-07,
                    8.79e-07,
                    9.0837e-07,
                    9.3895e-07,
                    9.7072e-07,
                    1.002e-06,
                    1.0332e-06,
                    1.0649e-06,
                    1.0965e-06,
                    1.1283e-06,
                    1.1601e-06,
                    1.1967e-06,
                    1.233e-06,
                    1.2706e-06,
                    1.3095e-06,
                    1.3482e-06,
                    1.3903e-06,
                    1.4323e-06,
                    1.4746e-06,
                    1.5168e-06,
                    1.5587e-06,
                    1.6057e-06,
                    1.6518e-06,
                    1.6976e-06,
                    1.7445e-06,
                    1.7957e-06,
                    1.8465e-06,
                    1.8979e-06,
                    1.9549e-06,
                    2.012e-06,
                    2.0693e-06,
                    2.1258e-06,
                    2.1845e-06,
                    2.2424e-06
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    3.3689e-10,
                    6.787e-10,
                    1.0255e-09,
                    1.3774e-09,
                    1.7345e-09,
                    2.0969e-09,
                    2.4646e-09,
                    2.8378e-09,
                    3.2165e-09,
                    3.6008e-09,
                    3.9864e-09,
                    4.3734e-09,
                    4.7619e-09,
                    5.152e-09,
                    5.5438e-09,
                    5.9374e-09,
                    6.3329e-09,
                    6.7305e-09,
                    7.1303e-09,
                    7.5325e-09,
                    7.9346e-09,
                    8.3372e-09,
                    8.7407e-09,
                    9.1454e-09,
                    9.5515e-09,
                    9.9591e-09,
                    1.0368e-08,
                    1.0778e-08,
                    1.119e-08,
                    1.1602e-08,
                    1.2009e-08,
                    1.2422e-08,
                    1.2842e-08,
                    1.3269e-08,
                    1.3702e-08,
                    1.4143e-08,
                    1.4591e-08,
                    1.5046e-08,
                    1.551e-08,
                    1.5982e-08,
                    1.6453e-08,
                    1.6921e-08,
                    1.7388e-08,
                    1.7852e-08,
                    1.8314e-08,
                    1.8774e-08,
                    1.9234e-08,
                    1.9692e-08,
                    2.0148e-08,
                    2.0603e-08,
                    2.1087e-08,
                    2.1594e-08,
                    2.2127e-08,
                    2.2685e-08,
                    2.3268e-08,
                    2.3876e-08,
                    2.4511e-08,
                    2.5171e-08,
                    2.5858e-08,
                    2.6571e-08,
                    2.7308e-08,
                    2.807e-08,
                    2.8857e-08,
                    2.9669e-08,
                    3.0506e-08,
                    3.1367e-08,
                    3.2252e-08,
                    3.3161e-08,
                    3.4095e-08,
                    3.5052e-08,
                    3.6014e-08,
                    3.6965e-08,
                    3.7909e-08,
                    3.8846e-08,
                    3.9775e-08,
                    4.0688e-08,
                    4.1591e-08,
                    4.2486e-08,
                    4.3363e-08,
                    4.4229e-08,
                    4.5104e-08,
                    4.5974e-08,
                    4.6841e-08,
                    4.7706e-08,
                    4.857e-08,
                    4.9433e-08,
                    5.0295e-08,
                    5.1157e-08,
                    5.2017e-08,
                    5.2877e-08,
                    5.3838e-08,
                    5.4911e-08,
                    5.6095e-08,
                    5.7392e-08,
                    5.8761e-08,
                    6.0218e-08,
                    6.1722e-08,
                    6.3273e-08,
                    6.488e-08,
                    6.654e-08,
                    6.8332e-08,
                    7.0276e-08,
                    7.2377e-08,
                    7.4642e-08,
                    7.7076e-08,
                    7.9687e-08,
                    8.2481e-08,
                    8.5465e-08,
                    8.8643e-08,
                    9.2024e-08,
                    9.8892e-08,
                    1.0757e-07,
                    1.1975e-07,
                    1.3205e-07,
                    1.4117e-07,
                    1.5044e-07,
                    1.6493e-07,
                    1.8461e-07,
                    1.9442e-07,
                    2.0955e-07,
                    2.2893e-07,
                    2.4731e-07,
                    2.7129e-07,
                    2.9425e-07,
                    3.1775e-07,
                    3.4183e-07,
                    3.6153e-07,
                    3.8178e-07,
                    4.0425e-07,
                    4.2903e-07,
                    4.5436e-07,
                    4.7862e-07,
                    5.0183e-07,
                    5.2545e-07,
                    5.5001e-07,
                    5.7384e-07,
                    6.0038e-07,
                    6.2796e-07,
                    6.5679e-07,
                    6.8646e-07,
                    7.1544e-07,
                    7.4563e-07,
                    7.7702e-07,
                    8.0794e-07,
                    8.3881e-07,
                    8.6967e-07,
                    9.0057e-07,
                    9.3162e-07,
                    9.6262e-07,
                    9.974e-07,
                    1.0316e-06,
                    1.0659e-06,
                    1.1015e-06,
                    1.1366e-06,
                    1.175e-06,
                    1.2133e-06,
                    1.2514e-06,
                    1.289e-06,
                    1.3262e-06,
                    1.368e-06,
                    1.4087e-06,
                    1.4487e-06,
                    1.4898e-06,
                    1.5347e-06,
                    1.5791e-06,
                    1.6242e-06,
                    1.6748e-06,
                    1.7256e-06,
                    1.7765e-06,
                    1.8272e-06,
                    1.8801e-06,
                    1.9332e-06
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [
                    5.703e-10,
                    1.1449e-09,
                    1.7237e-09,
                    2.3066e-09,
                    2.8936e-09,
                    3.4844e-09,
                    4.0788e-09,
                    4.6768e-09,
                    5.2781e-09,
                    5.8823e-09,
                    6.4828e-09,
                    7.0793e-09,
                    7.6719e-09,
                    8.2606e-09,
                    8.8454e-09,
                    9.4262e-09,
                    1.0003e-08,
                    1.0576e-08,
                    1.1145e-08,
                    1.171e-08,
                    1.2273e-08,
                    1.2834e-08,
                    1.3397e-08,
                    1.3962e-08,
                    1.453e-08,
                    1.5101e-08,
                    1.5675e-08,
                    1.625e-08,
                    1.6827e-08,
                    1.7401e-08,
                    1.7979e-08,
                    1.856e-08,
                    1.9143e-08,
                    1.9729e-08,
                    2.0318e-08,
                    2.0908e-08,
                    2.1502e-08,
                    2.2097e-08,
                    2.2695e-08,
                    2.3312e-08,
                    2.3923e-08,
                    2.4529e-08,
                    2.5131e-08,
                    2.5729e-08,
                    2.6325e-08,
                    2.6919e-08,
                    2.7513e-08,
                    2.8106e-08,
                    2.87e-08,
                    2.9295e-08,
                    2.9916e-08,
                    3.0564e-08,
                    3.1242e-08,
                    3.1951e-08,
                    3.269e-08,
                    3.3462e-08,
                    3.4264e-08,
                    3.5098e-08,
                    3.5961e-08,
                    3.6851e-08,
                    3.7765e-08,
                    3.8702e-08,
                    3.9662e-08,
                    4.0644e-08,
                    4.1649e-08,
                    4.2675e-08,
                    4.3725e-08,
                    4.4796e-08,
                    4.5891e-08,
                    4.7008e-08,
                    4.8127e-08,
                    4.9248e-08,
                    5.0372e-08,
                    5.1499e-08,
                    5.2628e-08,
                    5.376e-08,
                    5.4895e-08,
                    5.6031e-08,
                    5.7167e-08,
                    5.8304e-08,
                    5.9443e-08,
                    6.0585e-08,
                    6.1728e-08,
                    6.2872e-08,
                    6.4019e-08,
                    6.5218e-08,
                    6.6471e-08,
                    6.7778e-08,
                    6.9141e-08,
                    7.0561e-08,
                    7.2042e-08,
                    7.359e-08,
                    7.5212e-08,
                    7.691e-08,
                    7.8689e-08,
                    8.0549e-08,
                    8.2491e-08,
                    8.4512e-08,
                    8.6611e-08,
                    8.8783e-08,
                    9.1098e-08,
                    9.3572e-08,
                    9.6222e-08,
                    9.9061e-08,
                    1.021e-07,
                    1.053e-07,
                    1.0868e-07,
                    1.1224e-07,
                    1.1599e-07,
                    1.1994e-07,
                    1.2292e-07,
                    1.2583e-07,
                    1.2866e-07,
                    1.3368e-07,
                    1.3861e-07,
                    1.4208e-07,
                    1.4546e-07,
                    1.4879e-07,
                    1.5203e-07,
                    1.5546e-07,
                    1.5878e-07,
                    1.6193e-07,
                    1.6492e-07,
                    1.6773e-07,
                    1.7035e-07,
                    1.7274e-07,
                    1.7493e-07,
                    1.7689e-07,
                    1.7859e-07,
                    1.8002e-07,
                    1.8225e-07,
                    1.8451e-07,
                    1.8678e-07,
                    1.8702e-07,
                    1.8727e-07,
                    1.8877e-07,
                    1.9002e-07,
                    1.9107e-07,
                    1.9195e-07,
                    1.9254e-07,
                    1.9293e-07,
                    1.9332e-07,
                    1.937e-07,
                    1.9406e-07,
                    1.944e-07,
                    1.9518e-07,
                    1.9596e-07,
                    1.9672e-07,
                    1.9746e-07,
                    1.9926e-07,
                    2.0142e-07,
                    2.0472e-07,
                    2.0802e-07,
                    2.1152e-07,
                    2.1522e-07,
                    2.1901e-07,
                    2.2327e-07,
                    2.2779e-07,
                    2.3253e-07,
                    2.3771e-07,
                    2.4309e-07,
                    2.4891e-07,
                    2.5473e-07,
                    2.6099e-07,
                    2.6745e-07,
                    2.7368e-07,
                    2.801e-07,
                    2.8638e-07,
                    2.9285e-07,
                    2.9865e-07,
                    3.0437e-07,
                    3.0924e-07
                ],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    3.3e-09,
                    8.25e-09,
                    1.65e-08,
                    2.475e-08,
                    2.97e-08,
                    3.465e-08,
                    4.455e-08,
                    5.94e-08,
                    6.435e-08,
                    7.425e-08,
                    8.745e-08,
                    9.9e-08,
                    1.155e-07,
                    1.3035e-07,
                    1.452e-07,
                    1.6005e-07,
                    1.6995e-07,
                    1.7985e-07,
                    1.914e-07,
                    2.046e-07,
                    2.178e-07,
                    2.2935e-07,
                    2.3925e-07,
                    2.4915e-07,
                    2.5905e-07,
                    2.673e-07,
                    2.772e-07,
                    2.871e-07,
                    2.97e-07,
                    3.069e-07,
                    3.168e-07,
                    3.2835e-07,
                    3.4155e-07,
                    3.5475e-07,
                    3.6795e-07,
                    3.8115e-07,
                    3.9435e-07,
                    4.0755e-07,
                    4.2075e-07,
                    4.3725e-07,
                    4.5375e-07,
                    4.7025e-07,
                    4.884e-07,
                    5.0655e-07,
                    5.28e-07,
                    5.4945e-07,
                    5.709e-07,
                    5.9235e-07,
                    6.138e-07,
                    6.402e-07,
                    6.6495e-07,
                    6.8805e-07,
                    7.1115e-07,
                    7.3755e-07,
                    7.623e-07,
                    7.8705e-07,
                    8.1675e-07,
                    8.4645e-07,
                    8.7615e-07,
                    9.0585e-07,
                    9.3684e-07,
                    9.6748e-07
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    3.3e-09,
                    8.25e-09,
                    1.65e-08,
                    2.475e-08,
                    2.97e-08,
                    3.465e-08,
                    4.455e-08,
                    5.94e-08,
                    6.435e-08,
                    7.425e-08,
                    8.745e-08,
                    9.9e-08,
                    1.155e-07,
                    1.3035e-07,
                    1.452e-07,
                    1.6005e-07,
                    1.6995e-07,
                    1.7985e-07,
                    1.914e-07,
                    2.046e-07,
                    2.178e-07,
                    2.2935e-07,
                    2.3925e-07,
                    2.4915e-07,
                    2.5905e-07,
                    2.673e-07,
                    2.772e-07,
                    2.871e-07,
                    2.97e-07,
                    3.069e-07,
                    3.168e-07,
                    3.2835e-07,
                    3.4155e-07,
                    3.5475e-07,
                    3.6795e-07,
                    3.8115e-07,
                    3.9435e-07,
                    4.0755e-07,
                    4.2075e-07,
                    4.3725e-07,
                    4.5375e-07,
                    4.7025e-07,
                    4.884e-07,
                    5.0655e-07,
                    5.28e-07,
                    5.4945e-07,
                    5.709e-07,
                    5.9235e-07,
                    6.138e-07,
                    6.402e-07,
                    6.6495e-07,
                    6.8805e-07,
                    7.1115e-07,
                    7.3755e-07,
                    7.623e-07,
                    7.8705e-07,
                    8.1675e-07,
                    8.4645e-07,
                    8.7615e-07,
                    9.0585e-07,
                    9.3684e-07,
                    9.6748e-07
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [
                    7.5923e-10,
                    1.5252e-09,
                    2.2981e-09,
                    3.078e-09,
                    3.8649e-09,
                    4.6591e-09,
                    5.4606e-09,
                    6.2696e-09,
                    7.0862e-09,
                    7.9105e-09,
                    8.7316e-09,
                    9.5496e-09,
                    1.0364e-08,
                    1.1176e-08,
                    1.1986e-08,
                    1.2792e-08,
                    1.3596e-08,
                    1.4397e-08,
                    1.5196e-08,
                    1.5993e-08,
                    1.6785e-08,
                    1.7571e-08,
                    1.8352e-08,
                    1.9128e-08,
                    1.9898e-08,
                    2.0663e-08,
                    2.1423e-08,
                    2.2178e-08,
                    2.2928e-08,
                    2.3673e-08,
                    2.4414e-08,
                    2.5162e-08,
                    2.5917e-08,
                    2.6679e-08,
                    2.7449e-08,
                    2.8227e-08,
                    2.9013e-08,
                    2.9807e-08,
                    3.061e-08,
                    3.1422e-08,
                    3.2233e-08,
                    3.3042e-08,
                    3.3849e-08,
                    3.4655e-08,
                    3.5459e-08,
                    3.6263e-08,
                    3.7065e-08,
                    3.7867e-08,
                    3.8667e-08,
                    3.9466e-08,
                    4.0317e-08,
                    4.1214e-08,
                    4.216e-08,
                    4.3153e-08,
                    4.4194e-08,
                    4.5283e-08,
                    4.6421e-08,
                    4.7607e-08,
                    4.8843e-08,
                    5.0127e-08,
                    5.1455e-08,
                    5.2828e-08,
                    5.4245e-08,
                    5.5707e-08,
                    5.7213e-08,
                    5.8763e-08,
                    6.0357e-08,
                    6.1994e-08,
                    6.3676e-08,
                    6.5401e-08,
                    6.7128e-08,
                    6.8844e-08,
                    7.0551e-08,
                    7.2249e-08,
                    7.3939e-08,
                    7.5609e-08,
                    7.727e-08,
                    7.892e-08,
                    8.055e-08,
                    8.2169e-08,
                    8.3797e-08,
                    8.542e-08,
                    8.704e-08,
                    8.8658e-08,
                    9.0274e-08,
                    9.1939e-08,
                    9.3653e-08,
                    9.5418e-08,
                    9.7234e-08,
                    9.9102e-08,
                    1.0112e-07,
                    1.0331e-07,
                    1.0566e-07,
                    1.0816e-07,
                    1.1079e-07,
                    1.1356e-07,
                    1.1643e-07,
                    1.194e-07,
                    1.2247e-07,
                    1.2566e-07,
                    1.2911e-07,
                    1.3286e-07,
                    1.3693e-07,
                    1.4134e-07,
                    1.4611e-07,
                    1.512e-07,
                    1.5664e-07,
                    1.6243e-07,
                    1.686e-07,
                    1.7516e-07,
                    1.8094e-07,
                    1.8679e-07,
                    1.9273e-07,
                    2.0088e-07,
                    2.0902e-07,
                    2.1588e-07,
                    2.229e-07,
                    2.3006e-07,
                    2.3714e-07,
                    2.4485e-07,
                    2.5337e-07,
                    2.6233e-07,
                    2.7175e-07,
                    2.8158e-07,
                    2.9175e-07,
                    3.0225e-07,
                    3.1305e-07,
                    3.2416e-07,
                    3.3558e-07,
                    3.4733e-07,
                    3.6043e-07,
                    3.7411e-07,
                    3.8838e-07,
                    4.0113e-07,
                    4.148e-07,
                    4.3061e-07,
                    4.4717e-07,
                    4.6454e-07,
                    4.8299e-07,
                    5.0196e-07,
                    5.2002e-07,
                    5.3759e-07,
                    5.5468e-07,
                    5.7127e-07,
                    5.8776e-07,
                    6.0462e-07,
                    6.215e-07,
                    6.3848e-07,
                    6.5538e-07,
                    6.7356e-07,
                    6.9148e-07,
                    7.1034e-07,
                    7.2885e-07,
                    7.4711e-07,
                    7.6528e-07,
                    7.8341e-07,
                    8.0162e-07,
                    8.1966e-07,
                    8.3751e-07,
                    8.5536e-07,
                    8.7402e-07,
                    8.9402e-07,
                    9.1506e-07,
                    9.3712e-07,
                    9.6033e-07,
                    9.8402e-07,
                    1.0083e-06,
                    1.0328e-06,
                    1.0574e-06,
                    1.0812e-06,
                    1.1058e-06,
                    1.13e-06
                ],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [
                    2.6721e-10,
                    5.3848e-10,
                    8.139e-10,
                    1.0936e-09,
                    1.3777e-09,
                    1.6662e-09,
                    1.9594e-09,
                    2.2574e-09,
                    2.5602e-09,
                    2.8681e-09,
                    3.1767e-09,
                    3.4861e-09,
                    3.7966e-09,
                    4.1081e-09,
                    4.4207e-09,
                    4.7347e-09,
                    5.05e-09,
                    5.3669e-09,
                    5.6854e-09,
                    6.0057e-09,
                    6.3251e-09,
                    6.6437e-09,
                    6.9614e-09,
                    7.2784e-09,
                    7.5945e-09,
                    7.91e-09,
                    8.2247e-09,
                    8.5387e-09,
                    8.8522e-09,
                    9.165e-09,
                    9.4724e-09,
                    9.7852e-09,
                    1.0104e-08,
                    1.0428e-08,
                    1.0758e-08,
                    1.1095e-08,
                    1.1439e-08,
                    1.1789e-08,
                    1.2147e-08,
                    1.2512e-08,
                    1.2874e-08,
                    1.3233e-08,
                    1.3589e-08,
                    1.3942e-08,
                    1.4292e-08,
                    1.4639e-08,
                    1.4984e-08,
                    1.5326e-08,
                    1.5665e-08,
                    1.6002e-08,
                    1.6366e-08,
                    1.6752e-08,
                    1.7162e-08,
                    1.7596e-08,
                    1.8053e-08,
                    1.8534e-08,
                    1.9039e-08,
                    1.9569e-08,
                    2.0123e-08,
                    2.0701e-08,
                    2.1303e-08,
                    2.1928e-08,
                    2.2577e-08,
                    2.3249e-08,
                    2.3945e-08,
                    2.4663e-08,
                    2.5404e-08,
                    2.6168e-08,
                    2.6955e-08,
                    2.7765e-08,
                    2.8577e-08,
                    2.9378e-08,
                    3.0172e-08,
                    3.0957e-08,
                    3.1733e-08,
                    3.2491e-08,
                    3.3239e-08,
                    3.3978e-08,
                    3.4697e-08,
                    3.5405e-08,
                    3.6121e-08,
                    3.6828e-08,
                    3.753e-08,
                    3.8228e-08,
                    3.892e-08,
                    3.9607e-08,
                    4.029e-08,
                    4.0967e-08,
                    4.164e-08,
                    4.2308e-08,
                    4.3073e-08,
                    4.3941e-08,
                    4.4912e-08,
                    4.5987e-08,
                    4.7122e-08,
                    4.8336e-08,
                    4.9585e-08,
                    5.0873e-08,
                    5.2207e-08,
                    5.3589e-08,
                    5.5097e-08,
                    5.6752e-08,
                    5.8561e-08,
                    6.0528e-08,
                    6.2662e-08,
                    6.4968e-08,
                    6.7453e-08,
                    7.0123e-08,
                    7.2982e-08,
                    7.6039e-08,
                    7.9273e-08,
                    8.2653e-08,
                    8.621e-08,
                    8.9874e-08,
                    9.3623e-08,
                    9.7508e-08,
                    1.0163e-07,
                    1.0598e-07,
                    1.1034e-07,
                    1.1514e-07,
                    1.2087e-07,
                    1.2721e-07,
                    1.3417e-07,
                    1.4174e-07,
                    1.4983e-07,
                    1.5848e-07,
                    1.6765e-07,
                    1.7738e-07,
                    1.8766e-07,
                    1.9854e-07,
                    2.0999e-07,
                    2.2199e-07,
                    2.3459e-07,
                    2.4773e-07,
                    2.6177e-07,
                    2.7672e-07,
                    2.9267e-07,
                    3.0964e-07,
                    3.2787e-07,
                    3.4692e-07,
                    3.6527e-07,
                    3.8314e-07,
                    4.0055e-07,
                    4.1748e-07,
                    4.3434e-07,
                    4.5116e-07,
                    4.6799e-07,
                    4.8495e-07,
                    5.0185e-07,
                    5.191e-07,
                    5.3582e-07,
                    5.5242e-07,
                    5.6868e-07,
                    5.845e-07,
                    6.0007e-07,
                    6.1549e-07,
                    6.3063e-07,
                    6.4536e-07,
                    6.5972e-07,
                    6.7369e-07,
                    6.8829e-07,
                    7.0379e-07,
                    7.2033e-07,
                    7.3745e-07,
                    7.5556e-07,
                    7.7438e-07,
                    7.9362e-07,
                    8.1318e-07,
                    8.327e-07,
                    8.5211e-07,
                    8.7244e-07,
                    8.9325e-07
                ],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [
                    4.9201e-10,
                    9.8674e-10,
                    1.4842e-09,
                    1.9844e-09,
                    2.4872e-09,
                    2.9928e-09,
                    3.5012e-09,
                    4.0122e-09,
                    4.526e-09,
                    5.0424e-09,
                    5.5549e-09,
                    6.0634e-09,
                    6.5679e-09,
                    7.0684e-09,
                    7.5649e-09,
                    8.0574e-09,
                    8.546e-09,
                    9.0305e-09,
                    9.511e-09,
                    9.9876e-09,
                    1.046e-08,
                    1.0927e-08,
                    1.139e-08,
                    1.1849e-08,
                    1.2303e-08,
                    1.2753e-08,
                    1.3199e-08,
                    1.364e-08,
                    1.4076e-08,
                    1.4508e-08,
                    1.4942e-08,
                    1.5377e-08,
                    1.5813e-08,
                    1.6251e-08,
                    1.6691e-08,
                    1.7132e-08,
                    1.7574e-08,
                    1.8018e-08,
                    1.8463e-08,
                    1.891e-08,
                    1.9359e-08,
                    1.9809e-08,
                    2.026e-08,
                    2.0713e-08,
                    2.1168e-08,
                    2.1624e-08,
                    2.2082e-08,
                    2.2541e-08,
                    2.3002e-08,
                    2.3464e-08,
                    2.3951e-08,
                    2.4462e-08,
                    2.4997e-08,
                    2.5557e-08,
                    2.6141e-08,
                    2.6749e-08,
                    2.7382e-08,
                    2.8039e-08,
                    2.872e-08,
                    2.9426e-08,
                    3.0152e-08,
                    3.09e-08,
                    3.1669e-08,
                    3.2458e-08,
                    3.3269e-08,
                    3.41e-08,
                    3.4953e-08,
                    3.5826e-08,
                    3.6721e-08,
                    3.7636e-08,
                    3.8551e-08,
                    3.9465e-08,
                    4.0379e-08,
                    4.1293e-08,
                    4.2206e-08,
                    4.3118e-08,
                    4.403e-08,
                    4.4942e-08,
                    4.5853e-08,
                    4.6763e-08,
                    4.7676e-08,
                    4.8592e-08,
                    4.951e-08,
                    5.0431e-08,
                    5.1354e-08,
                    5.2331e-08,
                    5.3363e-08,
                    5.4451e-08,
                    5.5594e-08,
                    5.6794e-08,
                    5.8052e-08,
                    5.9368e-08,
                    6.0743e-08,
                    6.2177e-08,
                    6.3672e-08,
                    6.5228e-08,
                    6.6845e-08,
                    6.8525e-08,
                    7.0268e-08,
                    7.2074e-08,
                    7.4016e-08,
                    7.6111e-08,
                    7.8373e-08,
                    8.0815e-08,
                    8.3449e-08,
                    8.6236e-08,
                    8.9188e-08,
                    9.2312e-08,
                    9.5619e-08,
                    9.9117e-08,
                    1.0167e-07,
                    1.0414e-07,
                    1.0652e-07,
                    1.11e-07,
                    1.154e-07,
                    1.1837e-07,
                    1.2126e-07,
                    1.2407e-07,
                    1.268e-07,
                    1.2971e-07,
                    1.325e-07,
                    1.3512e-07,
                    1.3757e-07,
                    1.3984e-07,
                    1.4192e-07,
                    1.4377e-07,
                    1.454e-07,
                    1.4678e-07,
                    1.4793e-07,
                    1.4878e-07,
                    1.5044e-07,
                    1.5211e-07,
                    1.5378e-07,
                    1.5341e-07,
                    1.5303e-07,
                    1.5389e-07,
                    1.545e-07,
                    1.549e-07,
                    1.5512e-07,
                    1.5504e-07,
                    1.5475e-07,
                    1.5445e-07,
                    1.5413e-07,
                    1.5379e-07,
                    1.5342e-07,
                    1.5346e-07,
                    1.535e-07,
                    1.5352e-07,
                    1.5353e-07,
                    1.5445e-07,
                    1.5567e-07,
                    1.5792e-07,
                    1.6017e-07,
                    1.626e-07,
                    1.6521e-07,
                    1.6791e-07,
                    1.71e-07,
                    1.743e-07,
                    1.7778e-07,
                    1.8167e-07,
                    1.8573e-07,
                    1.9023e-07,
                    1.9473e-07,
                    1.9966e-07,
                    2.0477e-07,
                    2.0964e-07,
                    2.1468e-07,
                    2.1959e-07,
                    2.2467e-07,
                    2.2907e-07,
                    2.3337e-07,
                    2.3679e-07
                ],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [
                    1.4797e-10,
                    2.9837e-10,
                    4.5112e-10,
                    6.061e-10,
                    7.6318e-10,
                    9.2217e-10,
                    1.0829e-09,
                    1.245e-09,
                    1.4084e-09,
                    1.5726e-09,
                    1.7376e-09,
                    1.9032e-09,
                    2.0694e-09,
                    2.2362e-09,
                    2.4036e-09,
                    2.5715e-09,
                    2.7401e-09,
                    2.9093e-09,
                    3.0791e-09,
                    3.2497e-09,
                    3.4226e-09,
                    3.6006e-09,
                    3.7859e-09,
                    3.9799e-09,
                    4.1835e-09,
                    4.3968e-09,
                    4.6195e-09,
                    4.8505e-09,
                    5.088e-09,
                    5.3296e-09,
                    5.5739e-09,
                    5.8204e-09,
                    6.0689e-09,
                    6.3192e-09,
                    6.5711e-09,
                    6.8246e-09,
                    7.0797e-09,
                    7.3364e-09,
                    7.5949e-09,
                    7.8725e-09,
                    8.1434e-09,
                    8.4085e-09,
                    8.6689e-09,
                    8.9255e-09,
                    9.1792e-09,
                    9.4308e-09,
                    9.6812e-09,
                    9.9311e-09,
                    1.0181e-08,
                    1.0432e-08,
                    1.0686e-08,
                    1.0944e-08,
                    1.121e-08,
                    1.1483e-08,
                    1.1764e-08,
                    1.2055e-08,
                    1.2354e-08,
                    1.2662e-08,
                    1.2976e-08,
                    1.3295e-08,
                    1.3618e-08,
                    1.3944e-08,
                    1.4274e-08,
                    1.4606e-08,
                    1.4941e-08,
                    1.5279e-08,
                    1.562e-08,
                    1.5964e-08,
                    1.631e-08,
                    1.6659e-08,
                    1.7012e-08,
                    1.7369e-08,
                    1.773e-08,
                    1.8096e-08,
                    1.8465e-08,
                    1.8839e-08,
                    1.9216e-08,
                    1.9597e-08,
                    1.998e-08,
                    2.0365e-08,
                    2.0751e-08,
                    2.1139e-08,
                    2.1528e-08,
                    2.192e-08,
                    2.2315e-08,
                    2.2712e-08,
                    2.3113e-08,
                    2.3517e-08,
                    2.3924e-08,
                    2.4335e-08,
                    2.4755e-08,
                    2.5192e-08,
                    2.5652e-08,
                    2.6139e-08,
                    2.6656e-08,
                    2.7204e-08,
                    2.7783e-08,
                    2.8388e-08,
                    2.9016e-08,
                    2.966e-08,
                    3.0317e-08,
                    3.0985e-08,
                    3.1666e-08,
                    3.236e-08,
                    3.3066e-08,
                    3.3785e-08,
                    3.4518e-08,
                    3.5265e-08,
                    3.6027e-08,
                    3.6805e-08,
                    3.7569e-08,
                    3.8361e-08,
                    3.9173e-08,
                    4.0106e-08,
                    4.1063e-08,
                    4.1994e-08,
                    4.2949e-08,
                    4.3948e-08,
                    4.4962e-08,
                    4.5915e-08,
                    4.6892e-08,
                    4.7903e-08,
                    4.8965e-08,
                    5.0053e-08,
                    5.1154e-08,
                    5.2268e-08,
                    5.3465e-08,
                    5.4647e-08,
                    5.5859e-08,
                    5.712e-08,
                    5.8385e-08,
                    5.9673e-08,
                    6.0984e-08,
                    6.2187e-08,
                    6.3431e-08,
                    6.4701e-08,
                    6.6037e-08,
                    6.7393e-08,
                    6.8747e-08,
                    7.0138e-08,
                    7.1548e-08,
                    7.3007e-08,
                    7.4494e-08,
                    7.5977e-08,
                    7.7497e-08,
                    7.908e-08,
                    8.0682e-08,
                    8.2312e-08,
                    8.3958e-08,
                    8.5855e-08,
                    8.7792e-08,
                    9.0002e-08,
                    9.2235e-08,
                    9.451e-08,
                    9.6973e-08,
                    9.9489e-08,
                    1.021e-07,
                    1.0481e-07,
                    1.0742e-07,
                    1.1011e-07,
                    1.1281e-07,
                    1.1554e-07,
                    1.1829e-07,
                    1.2106e-07,
                    1.2388e-07,
                    1.2679e-07,
                    1.2981e-07,
                    1.328e-07,
                    1.3581e-07,
                    1.3878e-07,
                    1.4182e-07,
                    1.4489e-07
                ],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [
                    6.9675e-11,
                    1.4022e-10,
                    2.1161e-10,
                    2.8383e-10,
                    3.5686e-10,
                    4.3066e-10,
                    5.0519e-10,
                    5.8041e-10,
                    6.5627e-10,
                    7.3272e-10,
                    8.0972e-10,
                    8.8726e-10,
                    9.6533e-10,
                    1.0439e-09,
                    1.1231e-09,
                    1.2027e-09,
                    1.2829e-09,
                    1.3637e-09,
                    1.4449e-09,
                    1.5268e-09,
                    1.6094e-09,
                    1.6935e-09,
                    1.7792e-09,
                    1.867e-09,
                    1.957e-09,
                    2.0492e-09,
                    2.1434e-09,
                    2.2397e-09,
                    2.3375e-09,
                    2.4365e-09,
                    2.5364e-09,
                    2.6372e-09,
                    2.7387e-09,
                    2.841e-09,
                    2.944e-09,
                    3.0477e-09,
                    3.1521e-09,
                    3.2572e-09,
                    3.3631e-09,
                    3.4705e-09,
                    3.5788e-09,
                    3.6881e-09,
                    3.7984e-09,
                    3.9098e-09,
                    4.0222e-09,
                    4.1357e-09,
                    4.2503e-09,
                    4.3661e-09,
                    4.4831e-09,
                    4.6013e-09,
                    4.7209e-09,
                    4.8419e-09,
                    4.9645e-09,
                    5.0887e-09,
                    5.2147e-09,
                    5.3423e-09,
                    5.4717e-09,
                    5.6028e-09,
                    5.7354e-09,
                    5.8695e-09,
                    6.0051e-09,
                    6.1421e-09,
                    6.2805e-09,
                    6.4203e-09,
                    6.5615e-09,
                    6.7041e-09,
                    6.848e-09,
                    6.9932e-09,
                    7.1397e-09,
                    7.2874e-09,
                    7.4363e-09,
                    7.5863e-09,
                    7.7373e-09,
                    7.8894e-09,
                    8.0425e-09,
                    8.1967e-09,
                    8.3519e-09,
                    8.5081e-09,
                    8.6654e-09,
                    8.8238e-09,
                    8.9836e-09,
                    9.1457e-09,
                    9.3105e-09,
                    9.4785e-09,
                    9.6501e-09,
                    9.8257e-09,
                    1.0005e-08,
                    1.0189e-08,
                    1.0377e-08,
                    1.0569e-08,
                    1.0766e-08,
                    1.097e-08,
                    1.1183e-08,
                    1.1406e-08,
                    1.1639e-08,
                    1.1883e-08,
                    1.2137e-08,
                    1.2401e-08,
                    1.2673e-08,
                    1.2951e-08,
                    1.3235e-08,
                    1.3524e-08,
                    1.3817e-08,
                    1.4113e-08,
                    1.4414e-08,
                    1.4719e-08,
                    1.5028e-08,
                    1.5342e-08,
                    1.5661e-08,
                    1.5985e-08,
                    1.6319e-08,
                    1.6669e-08,
                    1.7038e-08,
                    1.743e-08,
                    1.7846e-08,
                    1.8286e-08,
                    1.8749e-08,
                    1.9231e-08,
                    1.9729e-08,
                    2.0166e-08,
                    2.0614e-08,
                    2.1097e-08,
                    2.1618e-08,
                    2.2164e-08,
                    2.2724e-08,
                    2.3298e-08,
                    2.3929e-08,
                    2.4545e-08,
                    2.5192e-08,
                    2.5888e-08,
                    2.6575e-08,
                    2.7273e-08,
                    2.7982e-08,
                    2.8569e-08,
                    2.9187e-08,
                    2.9817e-08,
                    3.0514e-08,
                    3.1219e-08,
                    3.1921e-08,
                    3.2636e-08,
                    3.3369e-08,
                    3.4141e-08,
                    3.4926e-08,
                    3.5709e-08,
                    3.6516e-08,
                    3.7361e-08,
                    3.8225e-08,
                    3.9117e-08,
                    4.0026e-08,
                    4.105e-08,
                    4.2041e-08,
                    4.3193e-08,
                    4.4382e-08,
                    4.5586e-08,
                    4.6968e-08,
                    4.839e-08,
                    4.9823e-08,
                    5.1317e-08,
                    5.2667e-08,
                    5.4066e-08,
                    5.5451e-08,
                    5.6858e-08,
                    5.8291e-08,
                    5.9729e-08,
                    6.1195e-08,
                    6.275e-08,
                    6.4387e-08,
                    6.6013e-08,
                    6.7638e-08,
                    6.9207e-08,
                    7.0814e-08,
                    7.2448e-08
                ],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": [
                    7.8293e-11,
                    1.5815e-10,
                    2.3951e-10,
                    3.2227e-10,
                    4.0632e-10,
                    4.9151e-10,
                    5.7767e-10,
                    6.6461e-10,
                    7.521e-10,
                    8.3989e-10,
                    9.2784e-10,
                    1.0159e-09,
                    1.104e-09,
                    1.1922e-09,
                    1.2805e-09,
                    1.3688e-09,
                    1.4572e-09,
                    1.5456e-09,
                    1.6342e-09,
                    1.7229e-09,
                    1.8132e-09,
                    1.9072e-09,
                    2.0066e-09,
                    2.1128e-09,
                    2.2265e-09,
                    2.3477e-09,
                    2.4761e-09,
                    2.6108e-09,
                    2.7505e-09,
                    2.8931e-09,
                    3.0375e-09,
                    3.1832e-09,
                    3.3302e-09,
                    3.4782e-09,
                    3.6271e-09,
                    3.7769e-09,
                    3.9276e-09,
                    4.0792e-09,
                    4.2318e-09,
                    4.402e-09,
                    4.5646e-09,
                    4.7204e-09,
                    4.8705e-09,
                    5.0157e-09,
                    5.157e-09,
                    5.2951e-09,
                    5.4309e-09,
                    5.565e-09,
                    5.6982e-09,
                    5.831e-09,
                    5.9651e-09,
                    6.1025e-09,
                    6.2451e-09,
                    6.3938e-09,
                    6.5496e-09,
                    6.7126e-09,
                    6.8826e-09,
                    7.059e-09,
                    7.2404e-09,
                    7.4255e-09,
                    7.6128e-09,
                    7.8022e-09,
                    7.9932e-09,
                    8.1859e-09,
                    8.3799e-09,
                    8.5753e-09,
                    8.7721e-09,
                    8.9704e-09,
                    9.1703e-09,
                    9.372e-09,
                    9.576e-09,
                    9.7829e-09,
                    9.9928e-09,
                    1.0206e-08,
                    1.0423e-08,
                    1.0642e-08,
                    1.0864e-08,
                    1.1089e-08,
                    1.1315e-08,
                    1.1541e-08,
                    1.1767e-08,
                    1.1993e-08,
                    1.2218e-08,
                    1.2442e-08,
                    1.2664e-08,
                    1.2886e-08,
                    1.3107e-08,
                    1.3327e-08,
                    1.3547e-08,
                    1.3767e-08,
                    1.3989e-08,
                    1.4222e-08,
                    1.4469e-08,
                    1.4733e-08,
                    1.5017e-08,
                    1.5322e-08,
                    1.5646e-08,
                    1.5988e-08,
                    1.6343e-08,
                    1.6709e-08,
                    1.7081e-08,
                    1.7461e-08,
                    1.785e-08,
                    1.8246e-08,
                    1.8651e-08,
                    1.9066e-08,
                    1.949e-08,
                    1.9923e-08,
                    2.0366e-08,
                    2.0819e-08,
                    2.125e-08,
                    2.1692e-08,
                    2.2135e-08,
                    2.2676e-08,
                    2.3217e-08,
                    2.3708e-08,
                    2.42e-08,
                    2.4717e-08,
                    2.5233e-08,
                    2.5749e-08,
                    2.6278e-08,
                    2.6806e-08,
                    2.7347e-08,
                    2.7888e-08,
                    2.8429e-08,
                    2.897e-08,
                    2.9536e-08,
                    3.0101e-08,
                    3.0667e-08,
                    3.1232e-08,
                    3.181e-08,
                    3.24e-08,
                    3.3003e-08,
                    3.3617e-08,
                    3.4244e-08,
                    3.4884e-08,
                    3.5523e-08,
                    3.6174e-08,
                    3.6826e-08,
                    3.7502e-08,
                    3.8178e-08,
                    3.8867e-08,
                    3.9568e-08,
                    4.0268e-08,
                    4.0981e-08,
                    4.1719e-08,
                    4.2457e-08,
                    4.3194e-08,
                    4.3932e-08,
                    4.4805e-08,
                    4.5751e-08,
                    4.6809e-08,
                    4.7854e-08,
                    4.8923e-08,
                    5.0005e-08,
                    5.1099e-08,
                    5.228e-08,
                    5.3497e-08,
                    5.4751e-08,
                    5.6041e-08,
                    5.7357e-08,
                    5.8685e-08,
                    6e-08,
                    6.1328e-08,
                    6.268e-08,
                    6.4045e-08,
                    6.5422e-08,
                    6.6786e-08,
                    6.8176e-08,
                    6.9577e-08,
                    7.1003e-08,
                    7.2442e-08
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -157.36273,
                            1.9932
                        ],
                        [
                            -157.43074,
                            1.99793
                        ],
                        [
                            -157.42133,
                            1.94365
                        ],
                        [
                            -157.47934,
                            1.84163
                        ],
                        [
                            -157.43458,
                            1.78697
                        ],
                        [
                            -157.34864,
                            1.77281
                        ],
                        [
                            -157.21129,
                            1.6933
                        ],
                        [
                            -157.17868,
                            1.76408
                        ],
                        [
                            -157.29224,
                            1.80748
                        ],
                        [
                            -157.34013,
                            1.84472
                        ],
                        [
                            -157.3458,
                            1.90419
                        ],
                        [
                            -157.30171,
                            1.96516
                        ],
                        [
                            -157.36273,
                            1.9932
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "KWT",
                "Country": "Kuwait",
                "Total_3GHG": 0.19,
                "Total_3GHG_timeseries": [
                    1.2861e-08,
                    2.5893e-08,
                    3.9073e-08,
                    5.2393e-08,
                    6.5839e-08,
                    7.9404e-08,
                    9.3077e-08,
                    1.0684e-07,
                    1.2068e-07,
                    1.3458e-07,
                    1.4821e-07,
                    1.6157e-07,
                    1.7466e-07,
                    1.8747e-07,
                    2e-07,
                    2.1226e-07,
                    2.2424e-07,
                    2.3595e-07,
                    2.4738e-07,
                    2.5853e-07,
                    2.6947e-07,
                    2.8032e-07,
                    2.9116e-07,
                    3.0207e-07,
                    3.1309e-07,
                    3.2422e-07,
                    3.3545e-07,
                    3.4673e-07,
                    3.5798e-07,
                    3.6909e-07,
                    3.8028e-07,
                    3.9152e-07,
                    4.0281e-07,
                    4.1414e-07,
                    4.255e-07,
                    4.3689e-07,
                    4.4831e-07,
                    4.5977e-07,
                    4.7126e-07,
                    4.8287e-07,
                    4.9453e-07,
                    5.0622e-07,
                    5.1797e-07,
                    5.2977e-07,
                    5.4163e-07,
                    5.5355e-07,
                    5.6553e-07,
                    5.7759e-07,
                    5.8973e-07,
                    6.0195e-07,
                    6.1342e-07,
                    6.2427e-07,
                    6.3457e-07,
                    6.4424e-07,
                    6.5333e-07,
                    6.6186e-07,
                    6.6985e-07,
                    6.7725e-07,
                    6.8409e-07,
                    6.9043e-07,
                    6.9672e-07,
                    7.0285e-07,
                    7.0888e-07,
                    7.1478e-07,
                    7.2057e-07,
                    7.2628e-07,
                    7.3187e-07,
                    7.3739e-07,
                    7.4277e-07,
                    7.4811e-07,
                    7.5453e-07,
                    7.6205e-07,
                    7.7072e-07,
                    7.8052e-07,
                    7.915e-07,
                    8.0363e-07,
                    8.1689e-07,
                    8.3127e-07,
                    8.4674e-07,
                    8.6323e-07,
                    8.8039e-07,
                    8.9831e-07,
                    9.1705e-07,
                    9.3666e-07,
                    9.5715e-07,
                    9.7975e-07,
                    1.0045e-06,
                    1.0313e-06,
                    1.0604e-06,
                    1.0922e-06,
                    1.1284e-06,
                    1.1696e-06,
                    1.2162e-06,
                    1.2686e-06,
                    1.3342e-06,
                    3.7125e-06,
                    9.2478e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031
                ],
                "Fossil_3GHG": 0.29,
                "Fossil_3GHG_timeseries": [
                    1.3973e-08,
                    2.8051e-08,
                    4.2231e-08,
                    5.6509e-08,
                    7.0878e-08,
                    8.5332e-08,
                    9.9862e-08,
                    1.1446e-07,
                    1.2911e-07,
                    1.4381e-07,
                    1.5827e-07,
                    1.7249e-07,
                    1.8647e-07,
                    2.002e-07,
                    2.137e-07,
                    2.2696e-07,
                    2.3998e-07,
                    2.5276e-07,
                    2.6531e-07,
                    2.7763e-07,
                    2.8975e-07,
                    3.018e-07,
                    3.1385e-07,
                    3.2596e-07,
                    3.3816e-07,
                    3.5045e-07,
                    3.6284e-07,
                    3.7526e-07,
                    3.8767e-07,
                    3.9996e-07,
                    4.1232e-07,
                    4.2474e-07,
                    4.3721e-07,
                    4.4971e-07,
                    4.6224e-07,
                    4.7481e-07,
                    4.874e-07,
                    5.0003e-07,
                    5.1269e-07,
                    5.2542e-07,
                    5.3821e-07,
                    5.5104e-07,
                    5.6393e-07,
                    5.7688e-07,
                    5.8989e-07,
                    6.0297e-07,
                    6.1612e-07,
                    6.2934e-07,
                    6.4265e-07,
                    6.5604e-07,
                    6.6877e-07,
                    6.8084e-07,
                    6.923e-07,
                    7.0315e-07,
                    7.1343e-07,
                    7.2314e-07,
                    7.3229e-07,
                    7.4089e-07,
                    7.4895e-07,
                    7.5646e-07,
                    7.638e-07,
                    7.7097e-07,
                    7.7795e-07,
                    7.8476e-07,
                    7.9138e-07,
                    7.9783e-07,
                    8.0408e-07,
                    8.1015e-07,
                    8.1604e-07,
                    8.2174e-07,
                    8.2838e-07,
                    8.3594e-07,
                    8.4443e-07,
                    8.5383e-07,
                    8.6415e-07,
                    8.7535e-07,
                    8.8745e-07,
                    9.0042e-07,
                    9.1425e-07,
                    9.2894e-07,
                    9.4419e-07,
                    9.6008e-07,
                    9.7669e-07,
                    9.9407e-07,
                    1.0123e-06,
                    1.0313e-06,
                    1.0512e-06,
                    1.0721e-06,
                    1.0938e-06,
                    1.117e-06,
                    1.1434e-06,
                    1.1733e-06,
                    1.2071e-06,
                    1.245e-06,
                    1.2945e-06,
                    3.6552e-06,
                    9.1711e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [
                    -0.0000000011116,
                    -0.0000000021586,
                    -0.0000000031579,
                    -0.0000000041159,
                    -0.0000000050388,
                    -0.0000000059279,
                    -0.0000000067845,
                    -0.0000000076212,
                    -0.000000008434,
                    -0.000000009225,
                    -0.000000010053,
                    -0.000000010913,
                    -0.000000011804,
                    -0.000000012734,
                    -0.000000013701,
                    -0.0000000147,
                    -0.000000015742,
                    -0.000000016816,
                    -0.000000017933,
                    -0.000000019092,
                    -0.000000020281,
                    -0.000000021485,
                    -0.000000022693,
                    -0.00000002389,
                    -0.000000025069,
                    -0.000000026234,
                    -0.000000027385,
                    -0.000000028532,
                    -0.000000029686,
                    -0.000000030869,
                    -0.000000032048,
                    -0.000000033227,
                    -0.0000000344,
                    -0.000000035571,
                    -0.000000036744,
                    -0.000000037915,
                    -0.000000039089,
                    -0.00000004026,
                    -0.000000041428,
                    -0.00000004255,
                    -0.00000004368,
                    -0.000000044817,
                    -0.000000045961,
                    -0.000000047111,
                    -0.000000048266,
                    -0.00000004942,
                    -0.000000050584,
                    -0.000000051747,
                    -0.000000052913,
                    -0.000000054094,
                    -0.00000005535,
                    -0.000000056567,
                    -0.000000057725,
                    -0.000000058915,
                    -0.000000060097,
                    -0.000000061277,
                    -0.000000062444,
                    -0.000000063642,
                    -0.000000064864,
                    -0.000000066029,
                    -0.000000067084,
                    -0.000000068118,
                    -0.00000006907,
                    -0.000000069974,
                    -0.000000070813,
                    -0.000000071547,
                    -0.000000072213,
                    -0.00000007277,
                    -0.000000073276,
                    -0.000000073634,
                    -0.000000073851,
                    -0.000000073893,
                    -0.000000073708,
                    -0.000000073317,
                    -0.000000072641,
                    -0.000000071723,
                    -0.000000070562,
                    -0.000000069152,
                    -0.000000067509,
                    -0.000000065704,
                    -0.000000063791,
                    -0.00000006177,
                    -0.000000059633,
                    -0.000000057405,
                    -0.000000055109,
                    -0.000000051561,
                    -0.000000046765,
                    -0.000000040713,
                    -0.000000033374,
                    -0.000000024836,
                    -0.000000014969,
                    -0.0000000036639,
                    9.1797e-09,
                    2.36e-08,
                    3.9662e-08,
                    5.7385e-08,
                    7.6767e-08,
                    9.7819e-08,
                    1.2052e-07,
                    1.4493e-07,
                    1.7314e-07,
                    2.0508e-07,
                    2.4047e-07,
                    2.79e-07,
                    3.2056e-07,
                    3.6408e-07,
                    4.0984e-07,
                    4.5847e-07,
                    5.0757e-07,
                    5.6713e-07,
                    6.242e-07,
                    6.8062e-07,
                    7.3815e-07,
                    7.9776e-07,
                    8.5802e-07,
                    9.2068e-07,
                    9.8453e-07,
                    1.05e-06,
                    1.1203e-06,
                    1.1898e-06,
                    1.255e-06,
                    1.3206e-06,
                    1.3804e-06,
                    1.4452e-06,
                    1.5128e-06,
                    1.5822e-06,
                    1.6583e-06,
                    1.7738e-06,
                    1.9596e-06,
                    2.1389e-06,
                    2.277e-06,
                    2.3975e-06,
                    2.5246e-06,
                    2.6791e-06,
                    2.877e-06,
                    3.0335e-06,
                    3.2366e-06,
                    3.4252e-06,
                    3.6126e-06,
                    3.7584e-06,
                    3.7451e-06,
                    3.7435e-06,
                    3.8142e-06,
                    3.9181e-06,
                    4.0681e-06,
                    4.265e-06,
                    4.468e-06,
                    4.6526e-06,
                    4.8224e-06,
                    5.027e-06,
                    5.1693e-06,
                    5.4038e-06,
                    5.6595e-06,
                    5.8402e-06,
                    5.9919e-06,
                    6.1853e-06,
                    6.3675e-06,
                    6.5916e-06,
                    6.8495e-06,
                    7.108e-06,
                    7.4854e-06,
                    7.8581e-06,
                    8.2011e-06,
                    8.5534e-06,
                    8.8688e-06,
                    9.1829e-06,
                    9.4999e-06,
                    9.8234e-06,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_CO2": 0.13,
                "Total_CO2_timeseries": [
                    -0.000000003377,
                    -0.00000000671,
                    -0.000000010015,
                    -0.000000013299,
                    -0.000000016566,
                    -0.000000019817,
                    -0.00000002305,
                    -0.000000026279,
                    -0.000000029496,
                    -0.000000032703,
                    -0.00000003591,
                    -0.00000003911,
                    -0.000000042306,
                    -0.000000045501,
                    -0.000000048697,
                    -0.000000051887,
                    -0.000000055082,
                    -0.000000058272,
                    -0.000000061468,
                    -0.000000064669,
                    -0.00000006787,
                    -0.000000071076,
                    -0.000000074288,
                    -0.0000000775,
                    -0.000000080712,
                    -0.00000008393,
                    -0.000000087147,
                    -0.00000009037,
                    -0.000000093599,
                    -0.000000096838,
                    -0.00000010009,
                    -0.00000010335,
                    -0.00000010662,
                    -0.00000010989,
                    -0.00000011317,
                    -0.00000011646,
                    -0.00000011976,
                    -0.00000012307,
                    -0.00000012638,
                    -0.0000001297,
                    -0.00000013303,
                    -0.00000013638,
                    -0.00000013973,
                    -0.0000001431,
                    -0.00000014648,
                    -0.00000014986,
                    -0.00000015326,
                    -0.00000015666,
                    -0.00000016008,
                    -0.00000016351,
                    -0.00000016704,
                    -0.00000017053,
                    -0.00000017397,
                    -0.00000017746,
                    -0.00000018095,
                    -0.00000018445,
                    -0.00000018796,
                    -0.0000001915,
                    -0.00000019509,
                    -0.00000019863,
                    -0.00000020216,
                    -0.00000020576,
                    -0.00000020936,
                    -0.00000021302,
                    -0.00000021669,
                    -0.00000022036,
                    -0.00000022406,
                    -0.00000022774,
                    -0.00000023148,
                    -0.00000023517,
                    -0.00000023885,
                    -0.00000024251,
                    -0.00000024613,
                    -0.00000024974,
                    -0.00000025329,
                    -0.00000025681,
                    -0.0000002603,
                    -0.00000026377,
                    -0.00000026721,
                    -0.00000027067,
                    -0.00000027414,
                    -0.0000002776,
                    -0.00000028104,
                    -0.00000028449,
                    -0.00000028796,
                    -0.00000029141,
                    -0.00000029486,
                    -0.0000002983,
                    -0.00000030175,
                    -0.00000030529,
                    -0.00000030889,
                    -0.00000031251,
                    -0.00000031615,
                    -0.00000031981,
                    -0.00000032349,
                    7.7831e-07,
                    3.8139e-06,
                    3.962e-06,
                    4.4368e-06,
                    4.6064e-06,
                    4.6554e-06,
                    4.6514e-06,
                    4.6472e-06,
                    5.2746e-06,
                    6.1014e-06,
                    6.5648e-06,
                    7.5488e-06,
                    9.2032e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014
                ],
                "Fossil_CO2": 0.18,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.1055e-06,
                    4.1448e-06,
                    4.2966e-06,
                    4.7751e-06,
                    4.9483e-06,
                    5.0012e-06,
                    5.0012e-06,
                    5.0012e-06,
                    5.6331e-06,
                    6.4647e-06,
                    6.9333e-06,
                    7.9233e-06,
                    9.5849e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014
                ],
                "Land_CO2": -0,
                "Land_CO2_timeseries": [
                    -0.000000003377,
                    -0.00000000671,
                    -0.000000010015,
                    -0.000000013299,
                    -0.000000016566,
                    -0.000000019817,
                    -0.00000002305,
                    -0.000000026279,
                    -0.000000029496,
                    -0.000000032703,
                    -0.00000003591,
                    -0.00000003911,
                    -0.000000042306,
                    -0.000000045501,
                    -0.000000048697,
                    -0.000000051887,
                    -0.000000055082,
                    -0.000000058272,
                    -0.000000061468,
                    -0.000000064669,
                    -0.00000006787,
                    -0.000000071076,
                    -0.000000074288,
                    -0.0000000775,
                    -0.000000080712,
                    -0.00000008393,
                    -0.000000087147,
                    -0.00000009037,
                    -0.000000093599,
                    -0.000000096838,
                    -0.00000010009,
                    -0.00000010335,
                    -0.00000010662,
                    -0.00000010989,
                    -0.00000011317,
                    -0.00000011646,
                    -0.00000011976,
                    -0.00000012307,
                    -0.00000012638,
                    -0.0000001297,
                    -0.00000013303,
                    -0.00000013638,
                    -0.00000013973,
                    -0.0000001431,
                    -0.00000014648,
                    -0.00000014986,
                    -0.00000015326,
                    -0.00000015666,
                    -0.00000016008,
                    -0.00000016351,
                    -0.00000016704,
                    -0.00000017053,
                    -0.00000017397,
                    -0.00000017746,
                    -0.00000018095,
                    -0.00000018445,
                    -0.00000018796,
                    -0.0000001915,
                    -0.00000019509,
                    -0.00000019863,
                    -0.00000020216,
                    -0.00000020576,
                    -0.00000020936,
                    -0.00000021302,
                    -0.00000021669,
                    -0.00000022036,
                    -0.00000022406,
                    -0.00000022774,
                    -0.00000023148,
                    -0.00000023517,
                    -0.00000023885,
                    -0.00000024251,
                    -0.00000024613,
                    -0.00000024974,
                    -0.00000025329,
                    -0.00000025681,
                    -0.0000002603,
                    -0.00000026377,
                    -0.00000026721,
                    -0.00000027067,
                    -0.00000027414,
                    -0.0000002776,
                    -0.00000028104,
                    -0.00000028449,
                    -0.00000028796,
                    -0.00000029141,
                    -0.00000029486,
                    -0.0000002983,
                    -0.00000030175,
                    -0.00000030529,
                    -0.00000030889,
                    -0.00000031251,
                    -0.00000031615,
                    -0.00000031981,
                    -0.00000032349,
                    -0.00000032719,
                    -0.00000033091,
                    -0.00000033463,
                    -0.00000033834,
                    -0.00000034192,
                    -0.00000034575,
                    -0.00000034974,
                    -0.00000035396,
                    -0.00000035848,
                    -0.00000036327,
                    -0.00000036852,
                    -0.00000037448,
                    -0.00000038169,
                    -0.00000039437,
                    -0.00000040504,
                    -0.00000041435,
                    -0.00000042234,
                    -0.0000004291,
                    -0.00000043502,
                    -0.0000004401,
                    -0.000000444,
                    -0.00000044722,
                    -0.00000044936,
                    -0.00000045077,
                    -0.00000045135,
                    -0.00000045126,
                    -0.00000045098,
                    -0.00000045057,
                    -0.0000004497,
                    -0.00000044854,
                    -0.00000044712,
                    -0.00000044622,
                    -0.00000044542,
                    -0.0000004424,
                    -0.00000043841,
                    -0.0000004346,
                    -0.00000042895,
                    -0.00000042234,
                    -0.00000041583,
                    -0.0000004083,
                    -0.00000039912,
                    -0.00000038986,
                    -0.00000038072,
                    -0.00000037267,
                    -0.00000036475,
                    -0.00000035658,
                    -0.00000034857,
                    -0.00000034228,
                    -0.00000033701,
                    -0.00000033234,
                    -0.00000032979,
                    -0.00000032564,
                    -0.00000031426,
                    -0.00000029384,
                    -0.0000002694,
                    -0.00000024396,
                    -0.00000022013,
                    -0.00000020222,
                    -0.00000018853,
                    -0.00000017724,
                    -0.0000001673,
                    -0.00000015747,
                    -0.00000014747,
                    -0.00000013633,
                    -0.00000012714,
                    -0.00000011579,
                    -0.00000010658,
                    -0.00000009905,
                    -0.000000093791,
                    -0.000000089666,
                    -0.000000085772,
                    -0.000000083979,
                    -0.000000081867,
                    -0.000000080586,
                    -0.000000079238,
                    -0.000000077831,
                    -0.000000076285
                ],
                "Total_CH4": 0.39,
                "Total_CH4_timeseries": [
                    9.9504e-09,
                    1.9922e-08,
                    2.9913e-08,
                    3.9926e-08,
                    4.9957e-08,
                    6.0009e-08,
                    7.008e-08,
                    8.017e-08,
                    9.0279e-08,
                    1.0041e-07,
                    1.1023e-07,
                    1.1975e-07,
                    1.2897e-07,
                    1.3789e-07,
                    1.465e-07,
                    1.5482e-07,
                    1.6283e-07,
                    1.7055e-07,
                    1.7796e-07,
                    1.8508e-07,
                    1.9189e-07,
                    1.9837e-07,
                    2.0454e-07,
                    2.104e-07,
                    2.1594e-07,
                    2.2116e-07,
                    2.2608e-07,
                    2.3068e-07,
                    2.3497e-07,
                    2.3895e-07,
                    2.429e-07,
                    2.4682e-07,
                    2.5071e-07,
                    2.5457e-07,
                    2.584e-07,
                    2.622e-07,
                    2.6598e-07,
                    2.6972e-07,
                    2.7343e-07,
                    2.7711e-07,
                    2.8076e-07,
                    2.8438e-07,
                    2.8796e-07,
                    2.9151e-07,
                    2.9503e-07,
                    2.9851e-07,
                    3.0196e-07,
                    3.0537e-07,
                    3.0876e-07,
                    3.121e-07,
                    3.1463e-07,
                    3.1636e-07,
                    3.1728e-07,
                    3.1741e-07,
                    3.1675e-07,
                    3.1533e-07,
                    3.1313e-07,
                    3.1018e-07,
                    3.0647e-07,
                    3.0203e-07,
                    2.973e-07,
                    2.9229e-07,
                    2.8699e-07,
                    2.8141e-07,
                    2.7554e-07,
                    2.6938e-07,
                    2.6293e-07,
                    2.5618e-07,
                    2.4915e-07,
                    2.4182e-07,
                    2.3532e-07,
                    2.2965e-07,
                    2.2479e-07,
                    2.2075e-07,
                    2.175e-07,
                    2.1505e-07,
                    2.1338e-07,
                    2.1248e-07,
                    2.1236e-07,
                    2.1299e-07,
                    2.14e-07,
                    2.1537e-07,
                    2.1712e-07,
                    2.1924e-07,
                    2.2175e-07,
                    2.2576e-07,
                    2.3131e-07,
                    2.3841e-07,
                    2.4707e-07,
                    2.5801e-07,
                    2.7251e-07,
                    2.9062e-07,
                    3.1237e-07,
                    3.378e-07,
                    3.7426e-07,
                    1.6156e-06,
                    4.078e-06,
                    7.7772e-06,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.001,
                    0.001,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016
                ],
                "Fossil_CH4": 0.63,
                "Fossil_CH4_timeseries": [
                    8.2954e-09,
                    1.6603e-08,
                    2.4923e-08,
                    3.3255e-08,
                    4.1598e-08,
                    4.9952e-08,
                    5.8318e-08,
                    6.6694e-08,
                    7.508e-08,
                    8.3476e-08,
                    9.1607e-08,
                    9.9473e-08,
                    1.0707e-07,
                    1.1441e-07,
                    1.2149e-07,
                    1.283e-07,
                    1.3485e-07,
                    1.4114e-07,
                    1.4717e-07,
                    1.5294e-07,
                    1.5843e-07,
                    1.6365e-07,
                    1.6859e-07,
                    1.7326e-07,
                    1.7765e-07,
                    1.8177e-07,
                    1.8562e-07,
                    1.8919e-07,
                    1.925e-07,
                    1.9553e-07,
                    1.9854e-07,
                    2.0151e-07,
                    2.0445e-07,
                    2.0737e-07,
                    2.1025e-07,
                    2.131e-07,
                    2.1592e-07,
                    2.1871e-07,
                    2.2147e-07,
                    2.242e-07,
                    2.2689e-07,
                    2.2955e-07,
                    2.3218e-07,
                    2.3477e-07,
                    2.3733e-07,
                    2.3985e-07,
                    2.4234e-07,
                    2.4479e-07,
                    2.4721e-07,
                    2.4959e-07,
                    2.5116e-07,
                    2.5192e-07,
                    2.5187e-07,
                    2.5103e-07,
                    2.4941e-07,
                    2.4701e-07,
                    2.4385e-07,
                    2.3992e-07,
                    2.3524e-07,
                    2.2982e-07,
                    2.2404e-07,
                    2.1789e-07,
                    2.1138e-07,
                    2.0449e-07,
                    1.9723e-07,
                    1.896e-07,
                    1.816e-07,
                    1.7322e-07,
                    1.6447e-07,
                    1.5534e-07,
                    1.4695e-07,
                    1.393e-07,
                    1.3238e-07,
                    1.2617e-07,
                    1.2068e-07,
                    1.1588e-07,
                    1.1179e-07,
                    1.0838e-07,
                    1.0564e-07,
                    1.0358e-07,
                    1.0187e-07,
                    1.005e-07,
                    9.949e-08,
                    9.8834e-08,
                    9.8535e-08,
                    9.8597e-08,
                    9.9022e-08,
                    9.9813e-08,
                    1.0097e-07,
                    1.0318e-07,
                    1.0772e-07,
                    1.146e-07,
                    1.2384e-07,
                    1.3548e-07,
                    1.5683e-07,
                    1.3818e-06,
                    3.8263e-06,
                    7.5064e-06,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.001,
                    0.001,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016
                ],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [
                    1.655e-09,
                    3.3185e-09,
                    4.9904e-09,
                    6.6707e-09,
                    8.3595e-09,
                    1.0057e-08,
                    1.1762e-08,
                    1.3477e-08,
                    1.5199e-08,
                    1.693e-08,
                    1.8623e-08,
                    2.0278e-08,
                    2.1895e-08,
                    2.3473e-08,
                    2.5014e-08,
                    2.6516e-08,
                    2.798e-08,
                    2.9407e-08,
                    3.0795e-08,
                    3.2145e-08,
                    3.3454e-08,
                    3.4723e-08,
                    3.5951e-08,
                    3.7139e-08,
                    3.8286e-08,
                    3.9393e-08,
                    4.0459e-08,
                    4.1485e-08,
                    4.247e-08,
                    4.3415e-08,
                    4.4361e-08,
                    4.5307e-08,
                    4.6255e-08,
                    4.7203e-08,
                    4.8153e-08,
                    4.9103e-08,
                    5.0054e-08,
                    5.1007e-08,
                    5.196e-08,
                    5.2914e-08,
                    5.3869e-08,
                    5.4825e-08,
                    5.5782e-08,
                    5.674e-08,
                    5.77e-08,
                    5.8659e-08,
                    5.962e-08,
                    6.0582e-08,
                    6.1545e-08,
                    6.2509e-08,
                    6.3474e-08,
                    6.444e-08,
                    6.5406e-08,
                    6.6374e-08,
                    6.7343e-08,
                    6.8312e-08,
                    6.9283e-08,
                    7.0255e-08,
                    7.1227e-08,
                    7.2201e-08,
                    7.3257e-08,
                    7.4396e-08,
                    7.5617e-08,
                    7.6921e-08,
                    7.8307e-08,
                    7.9776e-08,
                    8.1328e-08,
                    8.2962e-08,
                    8.4679e-08,
                    8.6478e-08,
                    8.8368e-08,
                    9.0347e-08,
                    9.2415e-08,
                    9.4574e-08,
                    9.6822e-08,
                    9.9161e-08,
                    1.0159e-07,
                    1.0411e-07,
                    1.0671e-07,
                    1.0941e-07,
                    1.1213e-07,
                    1.1487e-07,
                    1.1763e-07,
                    1.2041e-07,
                    1.2321e-07,
                    1.2717e-07,
                    1.3229e-07,
                    1.386e-07,
                    1.461e-07,
                    1.5483e-07,
                    1.648e-07,
                    1.7602e-07,
                    1.8852e-07,
                    2.0232e-07,
                    2.1743e-07,
                    2.3388e-07,
                    2.5167e-07,
                    2.7083e-07,
                    2.9138e-07,
                    3.1333e-07,
                    3.3915e-07,
                    3.6867e-07,
                    4.0165e-07,
                    4.3783e-07,
                    4.7708e-07,
                    5.1851e-07,
                    5.627e-07,
                    6.1081e-07,
                    6.6474e-07,
                    7.2704e-07,
                    7.838e-07,
                    8.3857e-07,
                    8.9268e-07,
                    9.4738e-07,
                    1.0014e-06,
                    1.0559e-06,
                    1.11e-06,
                    1.1636e-06,
                    1.2203e-06,
                    1.2752e-06,
                    1.3246e-06,
                    1.3726e-06,
                    1.4146e-06,
                    1.4602e-06,
                    1.5073e-06,
                    1.556e-06,
                    1.6108e-06,
                    1.6993e-06,
                    1.8446e-06,
                    1.9799e-06,
                    2.0756e-06,
                    2.1562e-06,
                    2.2383e-06,
                    2.3426e-06,
                    2.4801e-06,
                    2.5756e-06,
                    2.7036e-06,
                    2.8206e-06,
                    2.9359e-06,
                    3.0216e-06,
                    2.9796e-06,
                    2.9483e-06,
                    2.9731e-06,
                    3.0231e-06,
                    3.114e-06,
                    3.2379e-06,
                    3.3675e-06,
                    3.467e-06,
                    3.5348e-06,
                    3.6374e-06,
                    3.6858e-06,
                    3.8163e-06,
                    3.9691e-06,
                    4.0571e-06,
                    4.1122e-06,
                    4.212e-06,
                    4.2997e-06,
                    4.4179e-06,
                    4.5615e-06,
                    4.7215e-06,
                    4.9848e-06,
                    5.236e-06,
                    5.4552e-06,
                    5.6844e-06,
                    5.8668e-06,
                    6.0472e-06,
                    6.2249e-06,
                    6.4093e-06,
                    6.6095e-06,
                    6.7695e-06,
                    7.0228e-06,
                    7.2291e-06
                ],
                "Total_N2O": 0.02,
                "Total_N2O_timeseries": [
                    6.2878e-09,
                    1.2681e-08,
                    1.9176e-08,
                    2.5767e-08,
                    3.2448e-08,
                    3.9211e-08,
                    4.6048e-08,
                    5.2946e-08,
                    5.9895e-08,
                    6.6881e-08,
                    7.3895e-08,
                    8.0935e-08,
                    8.7999e-08,
                    9.5087e-08,
                    1.022e-07,
                    1.0933e-07,
                    1.1649e-07,
                    1.2367e-07,
                    1.3088e-07,
                    1.3812e-07,
                    1.4546e-07,
                    1.5302e-07,
                    1.609e-07,
                    1.6917e-07,
                    1.7786e-07,
                    1.8699e-07,
                    1.9652e-07,
                    2.0642e-07,
                    2.1661e-07,
                    2.2698e-07,
                    2.3747e-07,
                    2.4805e-07,
                    2.5871e-07,
                    2.6946e-07,
                    2.8027e-07,
                    2.9115e-07,
                    3.021e-07,
                    3.1311e-07,
                    3.2421e-07,
                    3.3546e-07,
                    3.468e-07,
                    3.5822e-07,
                    3.6974e-07,
                    3.8136e-07,
                    3.9307e-07,
                    4.049e-07,
                    4.1683e-07,
                    4.2888e-07,
                    4.4105e-07,
                    4.5336e-07,
                    4.6582e-07,
                    4.7845e-07,
                    4.9127e-07,
                    5.0429e-07,
                    5.1753e-07,
                    5.3099e-07,
                    5.4467e-07,
                    5.5858e-07,
                    5.7271e-07,
                    5.8704e-07,
                    6.0158e-07,
                    6.1631e-07,
                    6.3125e-07,
                    6.4639e-07,
                    6.6172e-07,
                    6.7726e-07,
                    6.93e-07,
                    7.0894e-07,
                    7.251e-07,
                    7.4146e-07,
                    7.5805e-07,
                    7.7491e-07,
                    7.9206e-07,
                    8.0952e-07,
                    8.2729e-07,
                    8.4539e-07,
                    8.6382e-07,
                    8.8255e-07,
                    9.0159e-07,
                    9.2091e-07,
                    9.4053e-07,
                    9.6053e-07,
                    9.8097e-07,
                    1.0019e-06,
                    1.0234e-06,
                    1.0454e-06,
                    1.068e-06,
                    1.0912e-06,
                    1.1151e-06,
                    1.1395e-06,
                    1.1648e-06,
                    1.1915e-06,
                    1.22e-06,
                    1.2506e-06,
                    1.2834e-06,
                    1.3186e-06,
                    1.356e-06,
                    1.3955e-06,
                    1.4368e-06,
                    1.4795e-06,
                    1.5233e-06,
                    1.5682e-06,
                    1.6142e-06,
                    1.6613e-06,
                    1.7095e-06,
                    1.7588e-06,
                    1.8092e-06,
                    1.8609e-06,
                    1.9139e-06,
                    1.9683e-06,
                    2.0261e-06,
                    2.0862e-06,
                    2.1499e-06,
                    2.2176e-06,
                    2.2899e-06,
                    2.3672e-06,
                    2.4505e-06,
                    2.5401e-06,
                    2.6366e-06,
                    2.7353e-06,
                    2.8398e-06,
                    2.9484e-06,
                    3.0495e-06,
                    3.1405e-06,
                    3.2279e-06,
                    3.3151e-06,
                    3.4047e-06,
                    3.5109e-06,
                    3.6329e-06,
                    3.7703e-06,
                    3.9176e-06,
                    4.0786e-06,
                    4.249e-06,
                    4.4143e-06,
                    4.6077e-06,
                    4.8021e-06,
                    5.0131e-06,
                    5.2386e-06,
                    5.4888e-06,
                    5.6771e-06,
                    5.8133e-06,
                    5.9717e-06,
                    6.1539e-06,
                    6.3637e-06,
                    6.5846e-06,
                    6.8305e-06,
                    7.0957e-06,
                    7.3837e-06,
                    7.6988e-06,
                    7.9854e-06,
                    8.2715e-06,
                    8.5786e-06,
                    8.8934e-06,
                    9.2092e-06,
                    9.5542e-06,
                    9.9048e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_N2O": 0.06,
                "Fossil_N2O_timeseries": [
                    5.6774e-09,
                    1.1448e-08,
                    1.7308e-08,
                    2.3254e-08,
                    2.928e-08,
                    3.538e-08,
                    4.1544e-08,
                    4.7765e-08,
                    5.4032e-08,
                    6.0333e-08,
                    6.6661e-08,
                    7.3015e-08,
                    7.9392e-08,
                    8.5792e-08,
                    9.2215e-08,
                    9.866e-08,
                    1.0513e-07,
                    1.1162e-07,
                    1.1814e-07,
                    1.2469e-07,
                    1.3132e-07,
                    1.3815e-07,
                    1.4526e-07,
                    1.527e-07,
                    1.605e-07,
                    1.6868e-07,
                    1.7722e-07,
                    1.8607e-07,
                    1.9517e-07,
                    2.0443e-07,
                    2.1379e-07,
                    2.2323e-07,
                    2.3275e-07,
                    2.4234e-07,
                    2.5199e-07,
                    2.617e-07,
                    2.7148e-07,
                    2.8131e-07,
                    2.9122e-07,
                    3.0122e-07,
                    3.1131e-07,
                    3.2149e-07,
                    3.3175e-07,
                    3.4211e-07,
                    3.5256e-07,
                    3.6312e-07,
                    3.7378e-07,
                    3.8455e-07,
                    3.9544e-07,
                    4.0645e-07,
                    4.1761e-07,
                    4.2893e-07,
                    4.4043e-07,
                    4.5212e-07,
                    4.6402e-07,
                    4.7612e-07,
                    4.8844e-07,
                    5.0097e-07,
                    5.1371e-07,
                    5.2664e-07,
                    5.3976e-07,
                    5.5307e-07,
                    5.6657e-07,
                    5.8027e-07,
                    5.9415e-07,
                    6.0822e-07,
                    6.2248e-07,
                    6.3693e-07,
                    6.5157e-07,
                    6.664e-07,
                    6.8143e-07,
                    6.9664e-07,
                    7.1205e-07,
                    7.2766e-07,
                    7.4347e-07,
                    7.5947e-07,
                    7.7566e-07,
                    7.9204e-07,
                    8.0861e-07,
                    8.2536e-07,
                    8.4232e-07,
                    8.5958e-07,
                    8.772e-07,
                    8.9523e-07,
                    9.1373e-07,
                    9.3272e-07,
                    9.5222e-07,
                    9.7225e-07,
                    9.928e-07,
                    1.0139e-06,
                    1.0357e-06,
                    1.0587e-06,
                    1.0832e-06,
                    1.1095e-06,
                    1.1377e-06,
                    1.1679e-06,
                    1.2e-06,
                    1.2339e-06,
                    1.2693e-06,
                    1.306e-06,
                    1.3436e-06,
                    1.3821e-06,
                    1.4215e-06,
                    1.4617e-06,
                    1.5027e-06,
                    1.5447e-06,
                    1.5876e-06,
                    1.6315e-06,
                    1.6767e-06,
                    1.7231e-06,
                    1.7713e-06,
                    1.8219e-06,
                    1.8753e-06,
                    1.9322e-06,
                    1.9931e-06,
                    2.0584e-06,
                    2.1287e-06,
                    2.2044e-06,
                    2.2859e-06,
                    2.3693e-06,
                    2.4582e-06,
                    2.5494e-06,
                    2.6331e-06,
                    2.7059e-06,
                    2.7739e-06,
                    2.8417e-06,
                    2.9109e-06,
                    2.9909e-06,
                    3.0755e-06,
                    3.1729e-06,
                    3.2816e-06,
                    3.4083e-06,
                    3.5403e-06,
                    3.662e-06,
                    3.8025e-06,
                    3.945e-06,
                    4.0902e-06,
                    4.2533e-06,
                    4.4394e-06,
                    4.5755e-06,
                    4.6911e-06,
                    4.828e-06,
                    4.9705e-06,
                    5.1318e-06,
                    5.2981e-06,
                    5.4737e-06,
                    5.6696e-06,
                    5.8838e-06,
                    6.1174e-06,
                    6.3264e-06,
                    6.544e-06,
                    6.7709e-06,
                    7.0008e-06,
                    7.2376e-06,
                    7.4973e-06,
                    7.7642e-06,
                    8.0324e-06,
                    8.3073e-06,
                    8.6063e-06,
                    8.9015e-06,
                    9.1946e-06,
                    9.4824e-06,
                    9.7986e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.01,
                "Land_N2O_timeseries": [
                    6.1037e-10,
                    1.2329e-09,
                    1.8672e-09,
                    2.5124e-09,
                    3.1677e-09,
                    3.8318e-09,
                    4.5035e-09,
                    5.1813e-09,
                    5.8634e-09,
                    6.5478e-09,
                    7.2334e-09,
                    7.9199e-09,
                    8.6071e-09,
                    9.2947e-09,
                    9.9827e-09,
                    1.0671e-08,
                    1.136e-08,
                    1.205e-08,
                    1.274e-08,
                    1.3432e-08,
                    1.4135e-08,
                    1.4868e-08,
                    1.5644e-08,
                    1.6472e-08,
                    1.7357e-08,
                    1.8302e-08,
                    1.9303e-08,
                    2.0354e-08,
                    2.1443e-08,
                    2.2555e-08,
                    2.368e-08,
                    2.4817e-08,
                    2.5962e-08,
                    2.7116e-08,
                    2.8277e-08,
                    2.9445e-08,
                    3.0619e-08,
                    3.1801e-08,
                    3.2991e-08,
                    3.4237e-08,
                    3.5485e-08,
                    3.6735e-08,
                    3.7989e-08,
                    3.9248e-08,
                    4.0511e-08,
                    4.1779e-08,
                    4.3053e-08,
                    4.4333e-08,
                    4.5619e-08,
                    4.6912e-08,
                    4.8212e-08,
                    4.952e-08,
                    5.0839e-08,
                    5.2169e-08,
                    5.351e-08,
                    5.4864e-08,
                    5.623e-08,
                    5.7608e-08,
                    5.8999e-08,
                    6.0403e-08,
                    6.1817e-08,
                    6.3242e-08,
                    6.4676e-08,
                    6.612e-08,
                    6.7574e-08,
                    6.904e-08,
                    7.0518e-08,
                    7.2012e-08,
                    7.3524e-08,
                    7.5057e-08,
                    7.663e-08,
                    7.8272e-08,
                    8.0007e-08,
                    8.1853e-08,
                    8.3822e-08,
                    8.5922e-08,
                    8.8153e-08,
                    9.0511e-08,
                    9.2984e-08,
                    9.5556e-08,
                    9.8216e-08,
                    1.0096e-07,
                    1.0378e-07,
                    1.0667e-07,
                    1.0964e-07,
                    1.1268e-07,
                    1.158e-07,
                    1.19e-07,
                    1.2227e-07,
                    1.2563e-07,
                    1.2912e-07,
                    1.3283e-07,
                    1.368e-07,
                    1.4109e-07,
                    1.4572e-07,
                    1.507e-07,
                    1.56e-07,
                    1.6161e-07,
                    1.6747e-07,
                    1.7352e-07,
                    1.7973e-07,
                    1.8615e-07,
                    1.9278e-07,
                    1.9965e-07,
                    2.0676e-07,
                    2.1409e-07,
                    2.2163e-07,
                    2.2935e-07,
                    2.372e-07,
                    2.4513e-07,
                    2.5475e-07,
                    2.6439e-07,
                    2.7458e-07,
                    2.854e-07,
                    2.9677e-07,
                    3.0875e-07,
                    3.2172e-07,
                    3.3567e-07,
                    3.5068e-07,
                    3.6601e-07,
                    3.8161e-07,
                    3.99e-07,
                    4.164e-07,
                    4.3467e-07,
                    4.5398e-07,
                    4.7333e-07,
                    4.9375e-07,
                    5.1998e-07,
                    5.5741e-07,
                    5.9742e-07,
                    6.3604e-07,
                    6.7025e-07,
                    7.0864e-07,
                    7.5237e-07,
                    8.052e-07,
                    8.5705e-07,
                    9.229e-07,
                    9.8527e-07,
                    1.0494e-06,
                    1.1015e-06,
                    1.1221e-06,
                    1.1437e-06,
                    1.1834e-06,
                    1.2319e-06,
                    1.2865e-06,
                    1.3568e-06,
                    1.4262e-06,
                    1.4998e-06,
                    1.5814e-06,
                    1.659e-06,
                    1.7275e-06,
                    1.8077e-06,
                    1.8926e-06,
                    1.9716e-06,
                    2.057e-06,
                    2.1406e-06,
                    2.2253e-06,
                    2.3212e-06,
                    2.4244e-06,
                    2.5136e-06,
                    2.6164e-06,
                    2.7286e-06,
                    2.845e-06,
                    2.9629e-06,
                    3.0916e-06,
                    3.2215e-06,
                    3.3589e-06,
                    3.496e-06,
                    3.6385e-06,
                    3.7851e-06,
                    3.9354e-06,
                    4.0896e-06
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                46.55304,
                                29.10117
                            ],
                            [
                                46.57574,
                                29.09639
                            ],
                            [
                                47.46915,
                                28.99625
                            ],
                            [
                                47.58946,
                                28.83349
                            ],
                            [
                                47.60783,
                                28.65441
                            ],
                            [
                                47.70776,
                                28.52214
                            ],
                            [
                                48.43327,
                                28.5314
                            ],
                            [
                                48.38976,
                                28.61348
                            ],
                            [
                                48.39681,
                                28.73737
                            ],
                            [
                                48.30528,
                                28.76892
                            ],
                            [
                                48.29129,
                                28.87533
                            ],
                            [
                                48.24546,
                                28.89002
                            ],
                            [
                                48.1623,
                                29.01435
                            ],
                            [
                                48.12544,
                                29.17482
                            ],
                            [
                                48.05372,
                                29.33989
                            ],
                            [
                                47.98761,
                                29.3882
                            ],
                            [
                                47.89231,
                                29.32556
                            ],
                            [
                                47.75869,
                                29.41024
                            ],
                            [
                                47.83884,
                                29.49461
                            ],
                            [
                                47.97214,
                                29.56827
                            ],
                            [
                                48.04257,
                                29.57171
                            ],
                            [
                                48.14853,
                                29.53312
                            ],
                            [
                                48.18947,
                                29.54348
                            ],
                            [
                                48.0179,
                                29.84502
                            ],
                            [
                                48.01318,
                                29.98154
                            ],
                            [
                                47.95914,
                                30.00375
                            ],
                            [
                                47.70768,
                                30.1037
                            ],
                            [
                                47.37131,
                                30.1037
                            ],
                            [
                                47.1726,
                                30.01747
                            ],
                            [
                                47.13946,
                                29.98653
                            ],
                            [
                                47.08137,
                                29.8512
                            ],
                            [
                                47.0075,
                                29.72292
                            ],
                            [
                                46.99785,
                                29.66346
                            ],
                            [
                                46.90523,
                                29.52544
                            ],
                            [
                                46.86671,
                                29.43785
                            ],
                            [
                                46.78494,
                                29.35592
                            ],
                            [
                                46.67135,
                                29.20765
                            ],
                            [
                                46.55304,
                                29.10117
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                48.04002,
                                29.82587
                            ],
                            [
                                48.121,
                                29.73727
                            ],
                            [
                                48.18716,
                                29.58894
                            ],
                            [
                                48.26659,
                                29.59861
                            ],
                            [
                                48.33366,
                                29.66089
                            ],
                            [
                                48.38125,
                                29.74847
                            ],
                            [
                                48.29419,
                                29.88401
                            ],
                            [
                                48.20399,
                                29.96214
                            ],
                            [
                                48.11265,
                                29.97116
                            ],
                            [
                                48.16778,
                                29.88243
                            ],
                            [
                                48.04002,
                                29.82587
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "KGZ",
                "Country": "Kyrgyzstan",
                "Total_3GHG": 0.06,
                "Total_3GHG_timeseries": [
                    1.3093e-06,
                    2.6213e-06,
                    3.9377e-06,
                    5.2585e-06,
                    6.5851e-06,
                    7.9146e-06,
                    9.2481e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001
                ],
                "Fossil_3GHG": 0.05,
                "Fossil_3GHG_timeseries": [
                    5.1985e-08,
                    1.0436e-07,
                    1.5711e-07,
                    2.1026e-07,
                    2.6503e-07,
                    3.1893e-07,
                    3.7321e-07,
                    4.2958e-07,
                    4.8641e-07,
                    5.4417e-07,
                    6.0332e-07,
                    6.6289e-07,
                    7.2331e-07,
                    7.8481e-07,
                    8.4687e-07,
                    9.1638e-07,
                    9.8805e-07,
                    1.0585e-06,
                    1.133e-06,
                    1.2093e-06,
                    1.2912e-06,
                    1.3746e-06,
                    1.4575e-06,
                    1.5451e-06,
                    1.6364e-06,
                    1.7347e-06,
                    1.8342e-06,
                    1.9437e-06,
                    2.0548e-06,
                    2.1736e-06,
                    2.2949e-06,
                    2.4192e-06,
                    2.5514e-06,
                    2.6839e-06,
                    2.8216e-06,
                    2.9597e-06,
                    3.1009e-06,
                    3.246e-06,
                    3.3968e-06,
                    3.5577e-06,
                    3.7258e-06,
                    3.9e-06,
                    4.0924e-06,
                    4.2877e-06,
                    4.4987e-06,
                    4.7118e-06,
                    4.9474e-06,
                    5.2007e-06,
                    5.4848e-06,
                    5.7949e-06,
                    6.1094e-06,
                    6.4162e-06,
                    6.7184e-06,
                    7.0487e-06,
                    7.3549e-06,
                    7.6934e-06,
                    8.0646e-06,
                    8.4377e-06,
                    8.8257e-06,
                    9.2057e-06,
                    9.6007e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Land_3GHG": 0.08,
                "Land_3GHG_timeseries": [
                    1.2573e-06,
                    2.517e-06,
                    3.7805e-06,
                    5.0483e-06,
                    6.32e-06,
                    7.5957e-06,
                    8.8749e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Total_CO2": 0.06,
                "Total_CO2_timeseries": [
                    9.7115e-07,
                    1.9422e-06,
                    2.9146e-06,
                    3.8887e-06,
                    4.8654e-06,
                    5.8428e-06,
                    6.8218e-06,
                    7.8034e-06,
                    8.7864e-06,
                    9.7724e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006
                ],
                "Fossil_CO2": 0.05,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    8.8985e-10,
                    8.8985e-10,
                    8.8985e-10,
                    2.1391e-09,
                    3.4639e-09,
                    5.2148e-09,
                    7.439e-09,
                    9.4456e-09,
                    1.1547e-08,
                    1.3903e-08,
                    1.6156e-08,
                    2.3273e-08,
                    3.1441e-08,
                    3.8236e-08,
                    4.7454e-08,
                    5.7458e-08,
                    7.0964e-08,
                    8.4829e-08,
                    9.7842e-08,
                    1.1364e-07,
                    1.3182e-07,
                    1.5439e-07,
                    1.7743e-07,
                    2.0753e-07,
                    2.3843e-07,
                    2.7466e-07,
                    3.1283e-07,
                    3.5304e-07,
                    3.988e-07,
                    4.4526e-07,
                    4.9586e-07,
                    5.4777e-07,
                    6.0269e-07,
                    6.5998e-07,
                    7.2184e-07,
                    7.9191e-07,
                    8.6905e-07,
                    9.5071e-07,
                    1.0464e-06,
                    1.1439e-06,
                    1.2559e-06,
                    1.3699e-06,
                    1.5018e-06,
                    1.6496e-06,
                    1.8212e-06,
                    2.0155e-06,
                    2.215e-06,
                    2.4076e-06,
                    2.5961e-06,
                    2.8058e-06,
                    2.993e-06,
                    3.2065e-06,
                    3.4456e-06,
                    3.6862e-06,
                    3.9402e-06,
                    4.1893e-06,
                    4.4475e-06,
                    4.7401e-06,
                    5.0578e-06,
                    5.3447e-06,
                    5.6079e-06,
                    5.8885e-06,
                    6.1467e-06,
                    6.2497e-06,
                    6.3376e-06,
                    6.4179e-06,
                    6.5048e-06,
                    6.6109e-06,
                    6.7281e-06,
                    6.8677e-06,
                    7.0055e-06,
                    7.2052e-06,
                    7.4534e-06,
                    7.7298e-06,
                    8.0275e-06,
                    8.4321e-06,
                    8.9181e-06,
                    9.4656e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Land_CO2": 0.07,
                "Land_CO2_timeseries": [
                    9.7115e-07,
                    1.9422e-06,
                    2.9146e-06,
                    3.8887e-06,
                    4.8645e-06,
                    5.8419e-06,
                    6.8209e-06,
                    7.8013e-06,
                    8.7829e-06,
                    9.7672e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Total_CH4": 0.06,
                "Total_CH4_timeseries": [
                    2.707e-07,
                    5.431e-07,
                    8.1717e-07,
                    1.0929e-06,
                    1.3707e-06,
                    1.6499e-06,
                    1.9307e-06,
                    2.2136e-06,
                    2.4983e-06,
                    2.7848e-06,
                    3.0757e-06,
                    3.3708e-06,
                    3.6701e-06,
                    3.9737e-06,
                    4.2814e-06,
                    4.5953e-06,
                    4.9137e-06,
                    5.2358e-06,
                    5.563e-06,
                    5.8946e-06,
                    6.2324e-06,
                    6.5748e-06,
                    6.9215e-06,
                    7.2738e-06,
                    7.6312e-06,
                    7.9948e-06,
                    8.363e-06,
                    8.7378e-06,
                    9.1171e-06,
                    9.5027e-06,
                    9.891e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_CH4": 0.05,
                "Fossil_CH4_timeseries": [
                    4.0164e-08,
                    8.0583e-08,
                    1.2125e-07,
                    1.6218e-07,
                    2.0371e-07,
                    2.4514e-07,
                    2.8681e-07,
                    3.2922e-07,
                    3.719e-07,
                    4.1499e-07,
                    4.5888e-07,
                    5.0331e-07,
                    5.4839e-07,
                    5.9418e-07,
                    6.4056e-07,
                    6.8941e-07,
                    7.3927e-07,
                    7.8919e-07,
                    8.4066e-07,
                    8.9293e-07,
                    9.4732e-07,
                    1.0025e-06,
                    1.0579e-06,
                    1.115e-06,
                    1.1731e-06,
                    1.2335e-06,
                    1.2945e-06,
                    1.3581e-06,
                    1.4223e-06,
                    1.4888e-06,
                    1.5555e-06,
                    1.6233e-06,
                    1.6931e-06,
                    1.7625e-06,
                    1.8328e-06,
                    1.9021e-06,
                    1.9714e-06,
                    2.042e-06,
                    2.1137e-06,
                    2.187e-06,
                    2.2603e-06,
                    2.3352e-06,
                    2.4138e-06,
                    2.4937e-06,
                    2.5744e-06,
                    2.6551e-06,
                    2.7403e-06,
                    2.827e-06,
                    2.9206e-06,
                    3.0174e-06,
                    3.1132e-06,
                    3.2078e-06,
                    3.3019e-06,
                    3.4026e-06,
                    3.5015e-06,
                    3.6061e-06,
                    3.7177e-06,
                    3.8294e-06,
                    3.9425e-06,
                    4.0522e-06,
                    4.1676e-06,
                    4.2944e-06,
                    4.4293e-06,
                    4.5556e-06,
                    4.6749e-06,
                    4.8e-06,
                    4.9198e-06,
                    5.0024e-06,
                    5.0747e-06,
                    5.144e-06,
                    5.2194e-06,
                    5.3025e-06,
                    5.3898e-06,
                    5.4813e-06,
                    5.5753e-06,
                    5.6843e-06,
                    5.8025e-06,
                    5.9321e-06,
                    6.0644e-06,
                    6.2158e-06,
                    6.3806e-06,
                    6.5593e-06,
                    6.7506e-06,
                    6.9849e-06,
                    7.2546e-06,
                    7.5528e-06,
                    7.8581e-06,
                    8.2103e-06,
                    8.5718e-06,
                    8.9958e-06,
                    9.3793e-06,
                    9.6622e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CH4": 0.09,
                "Land_CH4_timeseries": [
                    2.3054e-07,
                    4.6251e-07,
                    6.9592e-07,
                    9.3076e-07,
                    1.167e-06,
                    1.4047e-06,
                    1.6439e-06,
                    1.8844e-06,
                    2.1264e-06,
                    2.3698e-06,
                    2.6169e-06,
                    2.8675e-06,
                    3.1217e-06,
                    3.3795e-06,
                    3.6409e-06,
                    3.9059e-06,
                    4.1744e-06,
                    4.4466e-06,
                    4.7224e-06,
                    5.0017e-06,
                    5.285e-06,
                    5.5723e-06,
                    5.8636e-06,
                    6.1589e-06,
                    6.4581e-06,
                    6.7613e-06,
                    7.0685e-06,
                    7.3796e-06,
                    7.6948e-06,
                    8.0139e-06,
                    8.3355e-06,
                    8.6595e-06,
                    8.9859e-06,
                    9.3149e-06,
                    9.6463e-06,
                    9.9801e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_N2O": 0.08,
                "Total_N2O_timeseries": [
                    6.7413e-08,
                    1.3607e-07,
                    2.0593e-07,
                    2.7692e-07,
                    3.4894e-07,
                    4.2191e-07,
                    4.9568e-07,
                    5.7013e-07,
                    6.4507e-07,
                    7.2034e-07,
                    7.9583e-07,
                    8.7149e-07,
                    9.4731e-07,
                    1.0233e-06,
                    1.0994e-06,
                    1.1756e-06,
                    1.252e-06,
                    1.3286e-06,
                    1.4053e-06,
                    1.4823e-06,
                    1.5604e-06,
                    1.6414e-06,
                    1.7265e-06,
                    1.8167e-06,
                    1.9124e-06,
                    2.0137e-06,
                    2.1204e-06,
                    2.2319e-06,
                    2.347e-06,
                    2.4645e-06,
                    2.5833e-06,
                    2.7032e-06,
                    2.8241e-06,
                    2.9459e-06,
                    3.0684e-06,
                    3.1917e-06,
                    3.3157e-06,
                    3.4404e-06,
                    3.5661e-06,
                    3.6943e-06,
                    3.8245e-06,
                    3.9566e-06,
                    4.0905e-06,
                    4.2261e-06,
                    4.3633e-06,
                    4.502e-06,
                    4.6419e-06,
                    4.7828e-06,
                    4.9246e-06,
                    5.0669e-06,
                    5.2097e-06,
                    5.3528e-06,
                    5.4962e-06,
                    5.6399e-06,
                    5.7839e-06,
                    5.9282e-06,
                    6.0729e-06,
                    6.2179e-06,
                    6.3632e-06,
                    6.509e-06,
                    6.6567e-06,
                    6.8086e-06,
                    6.9666e-06,
                    7.132e-06,
                    7.3056e-06,
                    7.4875e-06,
                    7.6773e-06,
                    7.8743e-06,
                    8.0769e-06,
                    8.283e-06,
                    8.4916e-06,
                    8.7026e-06,
                    8.9158e-06,
                    9.1313e-06,
                    9.3489e-06,
                    9.5683e-06,
                    9.7894e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_N2O": 0.04,
                "Fossil_N2O_timeseries": [
                    1.1821e-08,
                    2.3777e-08,
                    3.5866e-08,
                    4.8086e-08,
                    6.0435e-08,
                    7.2909e-08,
                    8.5504e-08,
                    9.8217e-08,
                    1.1104e-07,
                    1.2397e-07,
                    1.3701e-07,
                    1.5014e-07,
                    1.6338e-07,
                    1.7672e-07,
                    1.9016e-07,
                    2.037e-07,
                    2.1734e-07,
                    2.3108e-07,
                    2.4493e-07,
                    2.5888e-07,
                    2.7296e-07,
                    2.8723e-07,
                    3.0171e-07,
                    3.1645e-07,
                    3.3146e-07,
                    3.4673e-07,
                    3.6227e-07,
                    3.7805e-07,
                    3.9404e-07,
                    4.1019e-07,
                    4.2648e-07,
                    4.4291e-07,
                    4.5946e-07,
                    4.7613e-07,
                    4.9293e-07,
                    5.0984e-07,
                    5.2687e-07,
                    5.4402e-07,
                    5.613e-07,
                    5.7877e-07,
                    5.964e-07,
                    6.1417e-07,
                    6.3209e-07,
                    6.5017e-07,
                    6.684e-07,
                    6.868e-07,
                    7.0536e-07,
                    7.2408e-07,
                    7.4298e-07,
                    7.6205e-07,
                    7.813e-07,
                    8.0076e-07,
                    8.2042e-07,
                    8.403e-07,
                    8.604e-07,
                    8.8073e-07,
                    9.0128e-07,
                    9.2205e-07,
                    9.4303e-07,
                    9.6422e-07,
                    9.8561e-07,
                    1.0072e-06,
                    1.029e-06,
                    1.0509e-06,
                    1.073e-06,
                    1.0954e-06,
                    1.1179e-06,
                    1.1406e-06,
                    1.1635e-06,
                    1.1866e-06,
                    1.21e-06,
                    1.2337e-06,
                    1.2578e-06,
                    1.2823e-06,
                    1.3073e-06,
                    1.3329e-06,
                    1.3589e-06,
                    1.3856e-06,
                    1.4129e-06,
                    1.4408e-06,
                    1.4694e-06,
                    1.499e-06,
                    1.5296e-06,
                    1.5613e-06,
                    1.5944e-06,
                    1.6287e-06,
                    1.6643e-06,
                    1.7013e-06,
                    1.7395e-06,
                    1.7789e-06,
                    1.8195e-06,
                    1.8615e-06,
                    1.9048e-06,
                    1.9497e-06,
                    1.9961e-06,
                    2.0442e-06,
                    2.0939e-06,
                    2.1454e-06,
                    2.1985e-06,
                    2.2534e-06,
                    2.3103e-06,
                    2.3699e-06,
                    2.4324e-06,
                    2.4982e-06,
                    2.5672e-06,
                    2.6394e-06,
                    2.7144e-06,
                    2.7919e-06,
                    2.871e-06,
                    2.9511e-06,
                    3.0315e-06,
                    3.1118e-06,
                    3.1919e-06,
                    3.2715e-06,
                    3.3506e-06,
                    3.4292e-06,
                    3.5075e-06,
                    3.5855e-06,
                    3.6636e-06,
                    3.7431e-06,
                    3.8247e-06,
                    3.9111e-06,
                    4.002e-06,
                    4.0973e-06,
                    4.2077e-06,
                    4.3236e-06,
                    4.4417e-06,
                    4.5635e-06,
                    4.6889e-06,
                    4.8198e-06,
                    4.9507e-06,
                    5.0821e-06,
                    5.2125e-06,
                    5.3448e-06,
                    5.4772e-06,
                    5.6126e-06,
                    5.752e-06,
                    5.8933e-06,
                    6.0352e-06,
                    6.1973e-06,
                    6.3485e-06,
                    6.4746e-06,
                    6.5761e-06,
                    6.6539e-06,
                    6.7256e-06,
                    6.7961e-06,
                    6.8625e-06,
                    6.924e-06,
                    6.9831e-06,
                    7.0379e-06,
                    7.0913e-06,
                    7.146e-06,
                    7.2045e-06,
                    7.2657e-06,
                    7.3294e-06,
                    7.3932e-06,
                    7.474e-06,
                    7.5568e-06,
                    7.6356e-06,
                    7.7131e-06,
                    7.8023e-06,
                    7.9057e-06,
                    8.0108e-06,
                    8.1104e-06,
                    8.2079e-06,
                    8.2996e-06,
                    8.3781e-06,
                    8.4597e-06,
                    8.5405e-06,
                    8.6228e-06,
                    8.7104e-06,
                    8.8e-06
                ],
                "Land_N2O": 0.09,
                "Land_N2O_timeseries": [
                    5.5592e-08,
                    1.123e-07,
                    1.7006e-07,
                    2.2883e-07,
                    2.8851e-07,
                    3.49e-07,
                    4.1018e-07,
                    4.7191e-07,
                    5.3403e-07,
                    5.9637e-07,
                    6.5882e-07,
                    7.2134e-07,
                    7.8393e-07,
                    8.4655e-07,
                    9.0922e-07,
                    9.7192e-07,
                    1.0347e-06,
                    1.0975e-06,
                    1.1604e-06,
                    1.2234e-06,
                    1.2874e-06,
                    1.3542e-06,
                    1.4248e-06,
                    1.5002e-06,
                    1.5809e-06,
                    1.667e-06,
                    1.7581e-06,
                    1.8538e-06,
                    1.953e-06,
                    2.0543e-06,
                    2.1568e-06,
                    2.2603e-06,
                    2.3646e-06,
                    2.4697e-06,
                    2.5755e-06,
                    2.6818e-06,
                    2.7888e-06,
                    2.8964e-06,
                    3.0048e-06,
                    3.1156e-06,
                    3.2281e-06,
                    3.3424e-06,
                    3.4584e-06,
                    3.5759e-06,
                    3.6949e-06,
                    3.8152e-06,
                    3.9365e-06,
                    4.0587e-06,
                    4.1816e-06,
                    4.3049e-06,
                    4.4284e-06,
                    4.552e-06,
                    4.6758e-06,
                    4.7996e-06,
                    4.9235e-06,
                    5.0475e-06,
                    5.1716e-06,
                    5.2958e-06,
                    5.4202e-06,
                    5.5448e-06,
                    5.6711e-06,
                    5.8014e-06,
                    5.9377e-06,
                    6.0811e-06,
                    6.2325e-06,
                    6.3921e-06,
                    6.5595e-06,
                    6.7337e-06,
                    6.9134e-06,
                    7.0964e-06,
                    7.2816e-06,
                    7.4689e-06,
                    7.658e-06,
                    7.849e-06,
                    8.0415e-06,
                    8.2354e-06,
                    8.4305e-06,
                    8.6263e-06,
                    8.8227e-06,
                    9.0192e-06,
                    9.2149e-06,
                    9.4082e-06,
                    9.5981e-06,
                    9.7837e-06,
                    9.9647e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            70.96761,
                            40.22851
                        ],
                        [
                            70.96282,
                            40.1582
                        ],
                        [
                            70.82426,
                            40.15963
                        ],
                        [
                            70.75871,
                            40.08982
                        ],
                        [
                            70.65443,
                            40.06601
                        ],
                        [
                            70.64054,
                            39.97927
                        ],
                        [
                            70.57553,
                            39.94346
                        ],
                        [
                            70.45652,
                            39.94771
                        ],
                        [
                            70.56504,
                            40.0207
                        ],
                        [
                            70.43004,
                            40.06288
                        ],
                        [
                            70.26884,
                            40.13168
                        ],
                        [
                            70.2151,
                            40.12839
                        ],
                        [
                            70.04791,
                            40.23528
                        ],
                        [
                            69.79951,
                            40.15772
                        ],
                        [
                            69.70069,
                            40.11666
                        ],
                        [
                            69.56283,
                            40.10346
                        ],
                        [
                            69.50789,
                            40.03331
                        ],
                        [
                            69.53255,
                            39.93449
                        ],
                        [
                            69.42854,
                            39.90582
                        ],
                        [
                            69.35484,
                            39.97543
                        ],
                        [
                            69.27696,
                            39.79105
                        ],
                        [
                            69.32579,
                            39.69345
                        ],
                        [
                            69.34098,
                            39.53914
                        ],
                        [
                            69.48399,
                            39.52563
                        ],
                        [
                            69.62365,
                            39.58421
                        ],
                        [
                            69.71133,
                            39.59301
                        ],
                        [
                            69.81015,
                            39.56575
                        ],
                        [
                            69.90404,
                            39.56895
                        ],
                        [
                            70.03087,
                            39.54588
                        ],
                        [
                            70.10614,
                            39.58247
                        ],
                        [
                            70.27134,
                            39.52851
                        ],
                        [
                            70.37567,
                            39.59096
                        ],
                        [
                            70.45343,
                            39.57737
                        ],
                        [
                            70.48753,
                            39.61379
                        ],
                        [
                            70.66078,
                            39.56539
                        ],
                        [
                            70.76169,
                            39.46049
                        ],
                        [
                            70.78882,
                            39.38962
                        ],
                        [
                            70.91181,
                            39.38352
                        ],
                        [
                            71.06631,
                            39.41466
                        ],
                        [
                            71.08977,
                            39.49878
                        ],
                        [
                            71.29603,
                            39.51856
                        ],
                        [
                            71.35998,
                            39.57611
                        ],
                        [
                            71.41737,
                            39.57203
                        ],
                        [
                            71.49894,
                            39.61325
                        ],
                        [
                            71.5486,
                            39.58881
                        ],
                        [
                            71.54376,
                            39.50751
                        ],
                        [
                            71.57755,
                            39.44906
                        ],
                        [
                            71.70509,
                            39.45581
                        ],
                        [
                            71.78755,
                            39.4419
                        ],
                        [
                            71.80029,
                            39.38172
                        ],
                        [
                            71.75835,
                            39.3517
                        ],
                        [
                            71.7784,
                            39.28842
                        ],
                        [
                            71.91926,
                            39.2814
                        ],
                        [
                            71.95731,
                            39.33039
                        ],
                        [
                            72.0347,
                            39.36551
                        ],
                        [
                            72.10821,
                            39.26475
                        ],
                        [
                            72.16797,
                            39.26132
                        ],
                        [
                            72.26386,
                            39.21226
                        ],
                        [
                            72.34838,
                            39.32944
                        ],
                        [
                            72.46922,
                            39.34911
                        ],
                        [
                            72.49653,
                            39.37591
                        ],
                        [
                            72.59529,
                            39.35783
                        ],
                        [
                            72.68943,
                            39.38445
                        ],
                        [
                            72.76902,
                            39.35257
                        ],
                        [
                            73.03785,
                            39.35479
                        ],
                        [
                            73.09649,
                            39.37276
                        ],
                        [
                            73.21142,
                            39.35676
                        ],
                        [
                            73.24039,
                            39.40526
                        ],
                        [
                            73.31253,
                            39.38634
                        ],
                        [
                            73.38966,
                            39.44991
                        ],
                        [
                            73.50926,
                            39.46738
                        ],
                        [
                            73.65824,
                            39.46508
                        ],
                        [
                            73.81392,
                            39.45899
                        ],
                        [
                            73.86311,
                            39.48017
                        ],
                        [
                            73.94031,
                            39.60661
                        ],
                        [
                            73.90969,
                            39.72539
                        ],
                        [
                            73.83239,
                            39.77254
                        ],
                        [
                            73.91334,
                            39.91651
                        ],
                        [
                            73.97748,
                            39.99596
                        ],
                        [
                            73.95562,
                            40.02877
                        ],
                        [
                            74.02619,
                            40.07952
                        ],
                        [
                            74.1065,
                            40.07922
                        ],
                        [
                            74.22407,
                            40.12286
                        ],
                        [
                            74.34285,
                            40.08643
                        ],
                        [
                            74.52644,
                            40.20738
                        ],
                        [
                            74.58277,
                            40.27197
                        ],
                        [
                            74.67712,
                            40.26536
                        ],
                        [
                            74.70276,
                            40.34482
                        ],
                        [
                            74.90309,
                            40.34964
                        ],
                        [
                            74.79129,
                            40.44587
                        ],
                        [
                            74.83907,
                            40.52163
                        ],
                        [
                            74.98842,
                            40.45135
                        ],
                        [
                            75.21647,
                            40.44153
                        ],
                        [
                            75.46298,
                            40.60944
                        ],
                        [
                            75.59291,
                            40.65703
                        ],
                        [
                            75.64195,
                            40.50796
                        ],
                        [
                            75.71329,
                            40.48656
                        ],
                        [
                            75.7127,
                            40.43619
                        ],
                        [
                            75.65024,
                            40.38962
                        ],
                        [
                            75.70315,
                            40.27951
                        ],
                        [
                            75.81626,
                            40.33377
                        ],
                        [
                            75.88269,
                            40.30765
                        ],
                        [
                            75.9604,
                            40.37074
                        ],
                        [
                            76.06727,
                            40.40281
                        ],
                        [
                            76.22138,
                            40.39788
                        ],
                        [
                            76.31024,
                            40.45253
                        ],
                        [
                            76.32487,
                            40.37247
                        ],
                        [
                            76.43629,
                            40.40144
                        ],
                        [
                            76.52253,
                            40.46507
                        ],
                        [
                            76.54012,
                            40.53648
                        ],
                        [
                            76.63848,
                            40.62218
                        ],
                        [
                            76.63472,
                            40.75707
                        ],
                        [
                            76.77847,
                            40.84415
                        ],
                        [
                            76.7856,
                            40.95818
                        ],
                        [
                            76.86567,
                            41.02095
                        ],
                        [
                            77.04755,
                            41.05923
                        ],
                        [
                            77.16704,
                            41.01606
                        ],
                        [
                            77.27109,
                            41.00747
                        ],
                        [
                            77.35955,
                            41.0324
                        ],
                        [
                            77.47135,
                            41.00158
                        ],
                        [
                            77.66604,
                            40.99991
                        ],
                        [
                            77.87615,
                            41.07237
                        ],
                        [
                            77.98484,
                            41.07676
                        ],
                        [
                            78.06025,
                            41.03418
                        ],
                        [
                            78.18825,
                            41.07804
                        ],
                        [
                            78.27322,
                            41.21387
                        ],
                        [
                            78.3842,
                            41.26989
                        ],
                        [
                            78.40337,
                            41.41297
                        ],
                        [
                            78.53378,
                            41.4565
                        ],
                        [
                            78.64348,
                            41.47212
                        ],
                        [
                            78.70656,
                            41.54966
                        ],
                        [
                            78.83505,
                            41.57509
                        ],
                        [
                            78.93626,
                            41.64498
                        ],
                        [
                            79.01039,
                            41.65814
                        ],
                        [
                            79.13621,
                            41.72362
                        ],
                        [
                            79.22681,
                            41.73901
                        ],
                        [
                            79.26539,
                            41.78464
                        ],
                        [
                            79.36055,
                            41.80179
                        ],
                        [
                            79.45207,
                            41.84898
                        ],
                        [
                            79.51324,
                            41.78634
                        ],
                        [
                            79.67044,
                            41.79037
                        ],
                        [
                            79.76778,
                            41.89192
                        ],
                        [
                            79.87946,
                            42.03723
                        ],
                        [
                            80.032,
                            42.05135
                        ],
                        [
                            80.12928,
                            42.03497
                        ],
                        [
                            80.2804,
                            42.05873
                        ],
                        [
                            80.24563,
                            42.22089
                        ],
                        [
                            80.12878,
                            42.20263
                        ],
                        [
                            80.08481,
                            42.32773
                        ],
                        [
                            79.98442,
                            42.374
                        ],
                        [
                            79.95181,
                            42.42899
                        ],
                        [
                            79.75855,
                            42.45214
                        ],
                        [
                            79.66746,
                            42.47649
                        ],
                        [
                            79.50881,
                            42.45778
                        ],
                        [
                            79.37006,
                            42.57954
                        ],
                        [
                            79.25318,
                            42.63175
                        ],
                        [
                            79.1874,
                            42.688
                        ],
                        [
                            79.16666,
                            42.75051
                        ],
                        [
                            79.10069,
                            42.77051
                        ],
                        [
                            78.93841,
                            42.77552
                        ],
                        [
                            78.69349,
                            42.82156
                        ],
                        [
                            78.49241,
                            42.90264
                        ],
                        [
                            78.31608,
                            42.85694
                        ],
                        [
                            78.18135,
                            42.88073
                        ],
                        [
                            78.05932,
                            42.83997
                        ],
                        [
                            77.72849,
                            42.90525
                        ],
                        [
                            77.44733,
                            42.93541
                        ],
                        [
                            77.34895,
                            42.91606
                        ],
                        [
                            77.22434,
                            42.92206
                        ],
                        [
                            77.1752,
                            42.95954
                        ],
                        [
                            76.84414,
                            42.98097
                        ],
                        [
                            76.70226,
                            42.90441
                        ],
                        [
                            76.50884,
                            42.91582
                        ],
                        [
                            76.48424,
                            42.88927
                        ],
                        [
                            76.32532,
                            42.86628
                        ],
                        [
                            76.27007,
                            42.91851
                        ],
                        [
                            76.03735,
                            42.9102
                        ],
                        [
                            75.92974,
                            42.95303
                        ],
                        [
                            75.81368,
                            42.93155
                        ],
                        [
                            75.76859,
                            42.83375
                        ],
                        [
                            75.71256,
                            42.79736
                        ],
                        [
                            75.61487,
                            42.82044
                        ],
                        [
                            75.42882,
                            42.82206
                        ],
                        [
                            75.32269,
                            42.85586
                        ],
                        [
                            75.1585,
                            42.85053
                        ],
                        [
                            74.90966,
                            42.98287
                        ],
                        [
                            74.83617,
                            43.00552
                        ],
                        [
                            74.73889,
                            42.9957
                        ],
                        [
                            74.61294,
                            43.12149
                        ],
                        [
                            74.48511,
                            43.18393
                        ],
                        [
                            74.34262,
                            43.20577
                        ],
                        [
                            74.29272,
                            43.23795
                        ],
                        [
                            74.15714,
                            43.22746
                        ],
                        [
                            74.17339,
                            43.19129
                        ],
                        [
                            74.05123,
                            43.15841
                        ],
                        [
                            73.95464,
                            43.19131
                        ],
                        [
                            73.87214,
                            43.09792
                        ],
                        [
                            73.77842,
                            43.10858
                        ],
                        [
                            73.57348,
                            43.03466
                        ],
                        [
                            73.50044,
                            42.90591
                        ],
                        [
                            73.50343,
                            42.7839
                        ],
                        [
                            73.46091,
                            42.72197
                        ],
                        [
                            73.42336,
                            42.61003
                        ],
                        [
                            73.44415,
                            42.50166
                        ],
                        [
                            73.51349,
                            42.43764
                        ],
                        [
                            73.44788,
                            42.4197
                        ],
                        [
                            73.34259,
                            42.42926
                        ],
                        [
                            73.29832,
                            42.50548
                        ],
                        [
                            73.08932,
                            42.53597
                        ],
                        [
                            72.97231,
                            42.52789
                        ],
                        [
                            72.82408,
                            42.56321
                        ],
                        [
                            72.74171,
                            42.63987
                        ],
                        [
                            72.60953,
                            42.68049
                        ],
                        [
                            72.49762,
                            42.68567
                        ],
                        [
                            72.27858,
                            42.75932
                        ],
                        [
                            72.08816,
                            42.74519
                        ],
                        [
                            71.93656,
                            42.8144
                        ],
                        [
                            71.81688,
                            42.83027
                        ],
                        [
                            71.62773,
                            42.76535
                        ],
                        [
                            71.51352,
                            42.80899
                        ],
                        [
                            71.27684,
                            42.77888
                        ],
                        [
                            71.22961,
                            42.69568
                        ],
                        [
                            71.17558,
                            42.67149
                        ],
                        [
                            71.16245,
                            42.60821
                        ],
                        [
                            71.05575,
                            42.60086
                        ],
                        [
                            71.00761,
                            42.56865
                        ],
                        [
                            71.09537,
                            42.49966
                        ],
                        [
                            70.99593,
                            42.4943
                        ],
                        [
                            70.87185,
                            42.31812
                        ],
                        [
                            70.94022,
                            42.2592
                        ],
                        [
                            71.05939,
                            42.28758
                        ],
                        [
                            71.13671,
                            42.27187
                        ],
                        [
                            71.25691,
                            42.20152
                        ],
                        [
                            71.21366,
                            42.13645
                        ],
                        [
                            71.14631,
                            42.13259
                        ],
                        [
                            70.96992,
                            42.02808
                        ],
                        [
                            70.86365,
                            42.04184
                        ],
                        [
                            70.82858,
                            41.92583
                        ],
                        [
                            70.6779,
                            41.90732
                        ],
                        [
                            70.59848,
                            41.82678
                        ],
                        [
                            70.52941,
                            41.79431
                        ],
                        [
                            70.48849,
                            41.71703
                        ],
                        [
                            70.34497,
                            41.63691
                        ],
                        [
                            70.19405,
                            41.59602
                        ],
                        [
                            70.18408,
                            41.52365
                        ],
                        [
                            70.35656,
                            41.50003
                        ],
                        [
                            70.48814,
                            41.39972
                        ],
                        [
                            70.58355,
                            41.4417
                        ],
                        [
                            70.71203,
                            41.46207
                        ],
                        [
                            70.77764,
                            41.37826
                        ],
                        [
                            70.78425,
                            41.18843
                        ],
                        [
                            70.87806,
                            41.22883
                        ],
                        [
                            70.95855,
                            41.16475
                        ],
                        [
                            71.02948,
                            41.19241
                        ],
                        [
                            71.12907,
                            41.14801
                        ],
                        [
                            71.26018,
                            41.18362
                        ],
                        [
                            71.39344,
                            41.11307
                        ],
                        [
                            71.43613,
                            41.1271
                        ],
                        [
                            71.47485,
                            41.21904
                        ],
                        [
                            71.4521,
                            41.28821
                        ],
                        [
                            71.48479,
                            41.31421
                        ],
                        [
                            71.59199,
                            41.30647
                        ],
                        [
                            71.67302,
                            41.39537
                        ],
                        [
                            71.67525,
                            41.46171
                        ],
                        [
                            71.62485,
                            41.48954
                        ],
                        [
                            71.73157,
                            41.54485
                        ],
                        [
                            71.74169,
                            41.45335
                        ],
                        [
                            71.8876,
                            41.36975
                        ],
                        [
                            71.93275,
                            41.30984
                        ],
                        [
                            71.86484,
                            41.20731
                        ],
                        [
                            71.9435,
                            41.15883
                        ],
                        [
                            72.07629,
                            41.14095
                        ],
                        [
                            72.19128,
                            41.15437
                        ],
                        [
                            72.2264,
                            41.05128
                        ],
                        [
                            72.2947,
                            41.02942
                        ],
                        [
                            72.35944,
                            41.06315
                        ],
                        [
                            72.49567,
                            41.02988
                        ],
                        [
                            72.50695,
                            40.98087
                        ],
                        [
                            72.57878,
                            40.88921
                        ],
                        [
                            72.67811,
                            40.85694
                        ],
                        [
                            72.832,
                            40.86874
                        ],
                        [
                            72.91102,
                            40.81778
                        ],
                        [
                            73.06088,
                            40.85196
                        ],
                        [
                            73.10651,
                            40.79327
                        ],
                        [
                            73.0069,
                            40.7662
                        ],
                        [
                            72.84474,
                            40.6881
                        ],
                        [
                            72.77241,
                            40.67903
                        ],
                        [
                            72.76029,
                            40.57077
                        ],
                        [
                            72.68322,
                            40.59123
                        ],
                        [
                            72.63418,
                            40.52075
                        ],
                        [
                            72.48614,
                            40.55745
                        ],
                        [
                            72.40851,
                            40.40194
                        ],
                        [
                            72.18603,
                            40.49814
                        ],
                        [
                            72.07931,
                            40.38887
                        ],
                        [
                            71.95196,
                            40.3097
                        ],
                        [
                            71.9928,
                            40.27003
                        ],
                        [
                            71.92729,
                            40.22528
                        ],
                        [
                            71.72676,
                            40.15002
                        ],
                        [
                            71.68068,
                            40.22965
                        ],
                        [
                            71.61002,
                            40.19024
                        ],
                        [
                            71.49506,
                            40.222
                        ],
                        [
                            71.48671,
                            40.26123
                        ],
                        [
                            71.2728,
                            40.32647
                        ],
                        [
                            71.12112,
                            40.31994
                        ],
                        [
                            70.9698,
                            40.26574
                        ],
                        [
                            70.96761,
                            40.22851
                        ]
                    ],
                    [
                        [
                            70.99603,
                            40.16894
                        ],
                        [
                            71.08144,
                            40.15071
                        ],
                        [
                            71.11976,
                            40.01747
                        ],
                        [
                            71.22936,
                            39.91974
                        ],
                        [
                            71.18046,
                            39.87578
                        ],
                        [
                            71.11277,
                            39.91526
                        ],
                        [
                            71.08546,
                            40.00978
                        ],
                        [
                            71.00768,
                            40.03953
                        ],
                        [
                            70.99603,
                            40.16894
                        ]
                    ],
                    [
                        [
                            70.50396,
                            39.88347
                        ],
                        [
                            70.71713,
                            39.90257
                        ],
                        [
                            70.72545,
                            39.84998
                        ],
                        [
                            70.62796,
                            39.79871
                        ],
                        [
                            70.50396,
                            39.88347
                        ]
                    ],
                    [
                        [
                            71.68945,
                            39.94
                        ],
                        [
                            71.79083,
                            39.99444
                        ],
                        [
                            71.78944,
                            39.9125
                        ],
                        [
                            71.68945,
                            39.94
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "LAO",
                "Country": "Laos",
                "Total_3GHG": 0.09,
                "Total_3GHG_timeseries": [
                    1.6611e-06,
                    3.3816e-06,
                    4.9366e-06,
                    6.5541e-06,
                    8.0239e-06,
                    9.48e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015
                ],
                "Fossil_3GHG": 0.02,
                "Fossil_3GHG_timeseries": [
                    1.205e-07,
                    2.4257e-07,
                    3.6626e-07,
                    4.916e-07,
                    6.1865e-07,
                    7.4745e-07,
                    8.7804e-07,
                    1.0105e-06,
                    1.1448e-06,
                    1.2811e-06,
                    1.419e-06,
                    1.5588e-06,
                    2.063e-06,
                    2.5729e-06,
                    3.0884e-06,
                    3.6097e-06,
                    4.1368e-06,
                    4.6698e-06,
                    5.2087e-06,
                    5.7314e-06,
                    6.274e-06,
                    6.8366e-06,
                    7.4193e-06,
                    8.022e-06,
                    8.6449e-06,
                    9.2879e-06,
                    9.9511e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_3GHG": 0.23,
                "Land_3GHG_timeseries": [
                    1.5406e-06,
                    3.139e-06,
                    4.5704e-06,
                    6.0625e-06,
                    7.4052e-06,
                    8.7326e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013
                ],
                "Total_CO2": 0.09,
                "Total_CO2_timeseries": [
                    1.1343e-06,
                    2.3218e-06,
                    3.3377e-06,
                    4.4099e-06,
                    5.3281e-06,
                    6.2264e-06,
                    7.1015e-06,
                    7.9266e-06,
                    8.7571e-06,
                    9.5047e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001
                ],
                "Fossil_CO2": 0.01,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.155e-08,
                    3.795e-08,
                    6.435e-08,
                    9.735e-08,
                    1.32e-07,
                    1.683e-07,
                    2.1945e-07,
                    2.7885e-07,
                    3.4485e-07,
                    4.224e-07,
                    5.0325e-07,
                    6.0885e-07,
                    7.524e-07,
                    8.283e-07,
                    9.7185e-07,
                    1.2292e-06,
                    1.419e-06,
                    1.6384e-06,
                    1.8711e-06,
                    2.0031e-06,
                    2.117e-06,
                    2.2176e-06,
                    2.3215e-06,
                    2.4255e-06,
                    2.5261e-06,
                    2.6103e-06,
                    2.6779e-06,
                    2.7489e-06,
                    2.8297e-06,
                    2.9122e-06,
                    3.0047e-06,
                    3.0987e-06,
                    3.1944e-06,
                    3.2901e-06,
                    3.3941e-06,
                    3.6251e-06,
                    3.8709e-06,
                    4.1378e-06,
                    4.4114e-06,
                    4.697e-06,
                    4.9991e-06,
                    5.3368e-06,
                    5.6937e-06,
                    6.063e-06,
                    6.4439e-06,
                    6.8764e-06,
                    7.3549e-06,
                    7.8799e-06,
                    8.4297e-06,
                    9.0073e-06,
                    9.6094e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CO2": 0.26,
                "Land_CO2_timeseries": [
                    1.1343e-06,
                    2.3218e-06,
                    3.3377e-06,
                    4.4099e-06,
                    5.3281e-06,
                    6.2264e-06,
                    7.1015e-06,
                    7.9266e-06,
                    8.7571e-06,
                    9.5047e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009
                ],
                "Total_CH4": 0.1,
                "Total_CH4_timeseries": [
                    5.1346e-07,
                    1.0328e-06,
                    1.5581e-06,
                    2.0893e-06,
                    2.6265e-06,
                    3.1698e-06,
                    3.7193e-06,
                    4.2749e-06,
                    4.8367e-06,
                    5.4047e-06,
                    5.9793e-06,
                    6.5605e-06,
                    7.5109e-06,
                    8.4718e-06,
                    9.4432e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Fossil_CH4": 0.04,
                "Fossil_CH4_timeseries": [
                    1.1895e-07,
                    2.3945e-07,
                    3.6154e-07,
                    4.8526e-07,
                    6.1066e-07,
                    7.378e-07,
                    8.6671e-07,
                    9.9745e-07,
                    1.1301e-06,
                    1.2646e-06,
                    1.4009e-06,
                    1.5389e-06,
                    2.0414e-06,
                    2.5495e-06,
                    3.0633e-06,
                    3.5828e-06,
                    4.1082e-06,
                    4.6393e-06,
                    5.1764e-06,
                    5.6974e-06,
                    6.2382e-06,
                    6.7989e-06,
                    7.3797e-06,
                    7.9804e-06,
                    8.6011e-06,
                    9.2419e-06,
                    9.9028e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CH4": 0.2,
                "Land_CH4_timeseries": [
                    3.945e-07,
                    7.9334e-07,
                    1.1965e-06,
                    1.604e-06,
                    2.0159e-06,
                    2.432e-06,
                    2.8526e-06,
                    3.2774e-06,
                    3.7066e-06,
                    4.1401e-06,
                    4.5784e-06,
                    5.0216e-06,
                    5.4696e-06,
                    5.9224e-06,
                    6.38e-06,
                    6.8424e-06,
                    7.3096e-06,
                    7.7817e-06,
                    8.2585e-06,
                    8.7402e-06,
                    9.2716e-06,
                    9.8526e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Total_N2O": 0.06,
                "Total_N2O_timeseries": [
                    1.3355e-08,
                    2.6971e-08,
                    4.0837e-08,
                    5.4938e-08,
                    6.9255e-08,
                    8.3764e-08,
                    9.8437e-08,
                    1.1324e-07,
                    1.2814e-07,
                    1.431e-07,
                    1.5809e-07,
                    1.731e-07,
                    1.8813e-07,
                    2.0317e-07,
                    2.1824e-07,
                    2.3331e-07,
                    2.484e-07,
                    2.6351e-07,
                    2.7865e-07,
                    2.9382e-07,
                    3.0924e-07,
                    3.2527e-07,
                    3.4221e-07,
                    3.6025e-07,
                    3.7951e-07,
                    4e-07,
                    4.2168e-07,
                    4.4439e-07,
                    4.6792e-07,
                    4.9193e-07,
                    5.1623e-07,
                    5.4077e-07,
                    5.655e-07,
                    5.9041e-07,
                    6.1548e-07,
                    6.407e-07,
                    6.6606e-07,
                    6.9158e-07,
                    7.1727e-07,
                    7.4479e-07,
                    7.7294e-07,
                    8.0173e-07,
                    8.3118e-07,
                    8.6133e-07,
                    8.9218e-07,
                    9.2376e-07,
                    9.5608e-07,
                    9.8917e-07,
                    1.023e-06,
                    1.0577e-06,
                    1.0932e-06,
                    1.1295e-06,
                    1.1667e-06,
                    1.2047e-06,
                    1.2437e-06,
                    1.2835e-06,
                    1.3244e-06,
                    1.3662e-06,
                    1.4092e-06,
                    1.4532e-06,
                    1.4984e-06,
                    1.545e-06,
                    1.593e-06,
                    1.6425e-06,
                    1.6935e-06,
                    1.7461e-06,
                    1.8003e-06,
                    1.8562e-06,
                    1.9137e-06,
                    1.9728e-06,
                    2.0335e-06,
                    2.0958e-06,
                    2.1596e-06,
                    2.225e-06,
                    2.292e-06,
                    2.3606e-06,
                    2.431e-06,
                    2.5032e-06,
                    2.5772e-06,
                    2.6533e-06,
                    2.7315e-06,
                    2.812e-06,
                    2.8949e-06,
                    2.9803e-06,
                    3.0683e-06,
                    3.1591e-06,
                    3.2528e-06,
                    3.3495e-06,
                    3.4494e-06,
                    3.5525e-06,
                    3.6604e-06,
                    3.7756e-06,
                    3.9e-06,
                    4.0351e-06,
                    4.182e-06,
                    4.341e-06,
                    4.5123e-06,
                    4.6952e-06,
                    4.8889e-06,
                    5.0916e-06,
                    5.3027e-06,
                    5.5226e-06,
                    5.7515e-06,
                    5.9897e-06,
                    6.2374e-06,
                    6.4948e-06,
                    6.762e-06,
                    7.0392e-06,
                    7.3262e-06,
                    7.6232e-06,
                    7.8722e-06,
                    8.1302e-06,
                    8.4032e-06,
                    8.7259e-06,
                    9.0719e-06,
                    9.4506e-06,
                    9.8667e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001
                ],
                "Fossil_N2O": 0.02,
                "Fossil_N2O_timeseries": [
                    1.5493e-09,
                    3.1236e-09,
                    4.722e-09,
                    6.3435e-09,
                    7.9866e-09,
                    9.6495e-09,
                    1.133e-08,
                    1.3026e-08,
                    1.4735e-08,
                    1.6453e-08,
                    1.8179e-08,
                    1.9912e-08,
                    2.1652e-08,
                    2.3398e-08,
                    2.5152e-08,
                    2.6911e-08,
                    2.8678e-08,
                    3.0451e-08,
                    3.2232e-08,
                    3.402e-08,
                    3.5832e-08,
                    3.7697e-08,
                    3.9634e-08,
                    4.1659e-08,
                    4.3781e-08,
                    4.6001e-08,
                    4.8315e-08,
                    5.0712e-08,
                    5.3175e-08,
                    5.568e-08,
                    5.8212e-08,
                    6.0768e-08,
                    6.3343e-08,
                    6.5938e-08,
                    6.8549e-08,
                    7.1177e-08,
                    7.3821e-08,
                    7.6483e-08,
                    7.9163e-08,
                    8.1894e-08,
                    8.4656e-08,
                    8.7447e-08,
                    9.027e-08,
                    9.3126e-08,
                    9.6015e-08,
                    9.894e-08,
                    1.019e-07,
                    1.049e-07,
                    1.0795e-07,
                    1.1103e-07,
                    1.1416e-07,
                    1.1735e-07,
                    1.206e-07,
                    1.2392e-07,
                    1.273e-07,
                    1.3075e-07,
                    1.3427e-07,
                    1.3786e-07,
                    1.4151e-07,
                    1.4521e-07,
                    1.4898e-07,
                    1.5279e-07,
                    1.5666e-07,
                    1.6058e-07,
                    1.6455e-07,
                    1.6858e-07,
                    1.7265e-07,
                    1.7678e-07,
                    1.8095e-07,
                    1.8517e-07,
                    1.8943e-07,
                    1.9375e-07,
                    1.9811e-07,
                    2.0252e-07,
                    2.0698e-07,
                    2.1148e-07,
                    2.1604e-07,
                    2.2063e-07,
                    2.2527e-07,
                    2.2996e-07,
                    2.3469e-07,
                    2.3946e-07,
                    2.4427e-07,
                    2.4912e-07,
                    2.5402e-07,
                    2.5898e-07,
                    2.6399e-07,
                    2.6907e-07,
                    2.7422e-07,
                    2.7944e-07,
                    2.8482e-07,
                    2.9044e-07,
                    2.9639e-07,
                    3.0273e-07,
                    3.095e-07,
                    3.1672e-07,
                    3.2439e-07,
                    3.3249e-07,
                    3.4097e-07,
                    3.4976e-07,
                    3.5894e-07,
                    3.6868e-07,
                    3.7913e-07,
                    3.9038e-07,
                    4.025e-07,
                    4.1552e-07,
                    4.2943e-07,
                    4.4418e-07,
                    4.5968e-07,
                    4.7581e-07,
                    4.9247e-07,
                    5.0967e-07,
                    5.2739e-07,
                    5.4565e-07,
                    5.6448e-07,
                    5.8392e-07,
                    6.0402e-07,
                    6.2485e-07,
                    6.4648e-07,
                    6.6847e-07,
                    6.9065e-07,
                    7.1307e-07,
                    7.3591e-07,
                    7.5904e-07,
                    7.824e-07,
                    8.0626e-07,
                    8.3108e-07,
                    8.56e-07,
                    8.8115e-07,
                    9.0717e-07,
                    9.3231e-07,
                    9.7752e-07,
                    1.0102e-06,
                    1.0553e-06,
                    1.0871e-06,
                    1.122e-06,
                    1.1573e-06,
                    1.1967e-06,
                    1.2332e-06,
                    1.27e-06,
                    1.3079e-06,
                    1.3469e-06,
                    1.3867e-06,
                    1.4276e-06,
                    1.4823e-06,
                    1.5441e-06,
                    1.607e-06,
                    1.6717e-06,
                    1.7375e-06,
                    1.8081e-06,
                    1.8814e-06,
                    1.9565e-06,
                    2.0344e-06,
                    2.1152e-06,
                    2.1985e-06,
                    2.2852e-06,
                    2.3749e-06,
                    2.4699e-06,
                    2.5679e-06,
                    2.6694e-06,
                    2.7739e-06,
                    2.8811e-06,
                    2.9949e-06,
                    3.1158e-06,
                    3.2509e-06,
                    3.4077e-06,
                    3.5702e-06,
                    3.7349e-06,
                    3.8961e-06,
                    4.0596e-06,
                    4.2261e-06,
                    4.3888e-06
                ],
                "Land_N2O": 0.08,
                "Land_N2O_timeseries": [
                    1.1806e-08,
                    2.3848e-08,
                    3.6115e-08,
                    4.8595e-08,
                    6.1269e-08,
                    7.4114e-08,
                    8.7107e-08,
                    1.0022e-07,
                    1.1341e-07,
                    1.2665e-07,
                    1.3991e-07,
                    1.5319e-07,
                    1.6648e-07,
                    1.7978e-07,
                    1.9308e-07,
                    2.064e-07,
                    2.1972e-07,
                    2.3306e-07,
                    2.4642e-07,
                    2.598e-07,
                    2.7341e-07,
                    2.8758e-07,
                    3.0258e-07,
                    3.1859e-07,
                    3.3573e-07,
                    3.54e-07,
                    3.7336e-07,
                    3.9368e-07,
                    4.1474e-07,
                    4.3625e-07,
                    4.5802e-07,
                    4.8e-07,
                    5.0216e-07,
                    5.2448e-07,
                    5.4693e-07,
                    5.6952e-07,
                    5.9224e-07,
                    6.1509e-07,
                    6.3811e-07,
                    6.629e-07,
                    6.8828e-07,
                    7.1428e-07,
                    7.4091e-07,
                    7.682e-07,
                    7.9616e-07,
                    8.2482e-07,
                    8.5418e-07,
                    8.8427e-07,
                    9.151e-07,
                    9.4669e-07,
                    9.7905e-07,
                    1.0122e-06,
                    1.0461e-06,
                    1.0808e-06,
                    1.1164e-06,
                    1.1528e-06,
                    1.1901e-06,
                    1.2284e-06,
                    1.2676e-06,
                    1.308e-06,
                    1.3495e-06,
                    1.3922e-06,
                    1.4363e-06,
                    1.4819e-06,
                    1.5289e-06,
                    1.5775e-06,
                    1.6277e-06,
                    1.6794e-06,
                    1.7328e-06,
                    1.7877e-06,
                    1.8441e-06,
                    1.902e-06,
                    1.9615e-06,
                    2.0225e-06,
                    2.085e-06,
                    2.1491e-06,
                    2.215e-06,
                    2.2825e-06,
                    2.352e-06,
                    2.4234e-06,
                    2.4968e-06,
                    2.5726e-06,
                    2.6506e-06,
                    2.7312e-06,
                    2.8143e-06,
                    2.9001e-06,
                    2.9888e-06,
                    3.0805e-06,
                    3.1752e-06,
                    3.2731e-06,
                    3.3756e-06,
                    3.4851e-06,
                    3.6036e-06,
                    3.7324e-06,
                    3.8725e-06,
                    4.0243e-06,
                    4.1879e-06,
                    4.3628e-06,
                    4.5479e-06,
                    4.7418e-06,
                    4.9438e-06,
                    5.1539e-06,
                    5.3723e-06,
                    5.5993e-06,
                    5.8349e-06,
                    6.0793e-06,
                    6.3326e-06,
                    6.595e-06,
                    6.8665e-06,
                    7.1474e-06,
                    7.3797e-06,
                    7.6206e-06,
                    7.8758e-06,
                    8.1802e-06,
                    8.5074e-06,
                    8.8667e-06,
                    9.2626e-06,
                    9.6388e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            100.08532,
                            20.35273
                        ],
                        [
                            100.09463,
                            20.26527
                        ],
                        [
                            100.16873,
                            20.24576
                        ],
                        [
                            100.27417,
                            20.40054
                        ],
                        [
                            100.33112,
                            20.39826
                        ],
                        [
                            100.3747,
                            20.35
                        ],
                        [
                            100.41456,
                            20.25471
                        ],
                        [
                            100.50843,
                            20.15121
                        ],
                        [
                            100.57643,
                            20.16914
                        ],
                        [
                            100.56954,
                            20.10153
                        ],
                        [
                            100.49815,
                            19.86793
                        ],
                        [
                            100.4423,
                            19.83732
                        ],
                        [
                            100.40876,
                            19.73523
                        ],
                        [
                            100.48956,
                            19.65269
                        ],
                        [
                            100.4743,
                            19.55837
                        ],
                        [
                            100.52096,
                            19.52089
                        ],
                        [
                            100.59764,
                            19.50684
                        ],
                        [
                            100.64889,
                            19.55662
                        ],
                        [
                            100.75589,
                            19.51122
                        ],
                        [
                            100.81568,
                            19.52697
                        ],
                        [
                            100.8962,
                            19.63364
                        ],
                        [
                            101.02978,
                            19.62928
                        ],
                        [
                            101.12264,
                            19.57366
                        ],
                        [
                            101.2414,
                            19.60283
                        ],
                        [
                            101.28614,
                            19.57016
                        ],
                        [
                            101.26387,
                            19.4648
                        ],
                        [
                            101.21279,
                            19.46544
                        ],
                        [
                            101.20538,
                            19.35136
                        ],
                        [
                            101.25787,
                            19.22954
                        ],
                        [
                            101.25607,
                            19.13057
                        ],
                        [
                            101.35389,
                            19.04827
                        ],
                        [
                            101.30884,
                            19.00042
                        ],
                        [
                            101.29305,
                            18.93865
                        ],
                        [
                            101.24569,
                            18.88997
                        ],
                        [
                            101.24965,
                            18.78068
                        ],
                        [
                            101.22415,
                            18.72771
                        ],
                        [
                            101.2569,
                            18.67745
                        ],
                        [
                            101.18331,
                            18.57791
                        ],
                        [
                            101.10243,
                            18.5205
                        ],
                        [
                            101.05364,
                            18.44351
                        ],
                        [
                            101.09153,
                            18.37897
                        ],
                        [
                            101.17783,
                            18.33349
                        ],
                        [
                            101.14853,
                            18.26238
                        ],
                        [
                            101.18906,
                            18.19617
                        ],
                        [
                            101.16072,
                            18.12874
                        ],
                        [
                            101.18475,
                            18.06578
                        ],
                        [
                            101.11979,
                            17.99565
                        ],
                        [
                            101.12078,
                            17.89862
                        ],
                        [
                            101.08658,
                            17.8459
                        ],
                        [
                            100.99539,
                            17.80849
                        ],
                        [
                            100.9786,
                            17.75432
                        ],
                        [
                            101.02983,
                            17.67655
                        ],
                        [
                            100.96914,
                            17.59037
                        ],
                        [
                            101.06565,
                            17.51196
                        ],
                        [
                            101.16033,
                            17.46907
                        ],
                        [
                            101.17838,
                            17.52492
                        ],
                        [
                            101.22789,
                            17.53709
                        ],
                        [
                            101.30952,
                            17.64996
                        ],
                        [
                            101.40913,
                            17.70203
                        ],
                        [
                            101.46682,
                            17.75426
                        ],
                        [
                            101.55157,
                            17.78728
                        ],
                        [
                            101.5537,
                            17.82356
                        ],
                        [
                            101.61786,
                            17.89237
                        ],
                        [
                            101.73163,
                            17.92433
                        ],
                        [
                            101.78009,
                            18.0647
                        ],
                        [
                            101.90601,
                            18.03197
                        ],
                        [
                            101.94653,
                            18.08823
                        ],
                        [
                            102.09554,
                            18.21433
                        ],
                        [
                            102.16125,
                            18.20209
                        ],
                        [
                            102.1889,
                            18.14644
                        ],
                        [
                            102.2953,
                            18.05206
                        ],
                        [
                            102.345,
                            18.04517
                        ],
                        [
                            102.46756,
                            17.96874
                        ],
                        [
                            102.59974,
                            17.95722
                        ],
                        [
                            102.59848,
                            17.83541
                        ],
                        [
                            102.67701,
                            17.80443
                        ],
                        [
                            102.70161,
                            17.87679
                        ],
                        [
                            102.76826,
                            17.90365
                        ],
                        [
                            102.85591,
                            17.97087
                        ],
                        [
                            102.95328,
                            18.00443
                        ],
                        [
                            103.01767,
                            17.97337
                        ],
                        [
                            103.07898,
                            18.04005
                        ],
                        [
                            103.0823,
                            18.12937
                        ],
                        [
                            103.13277,
                            18.16069
                        ],
                        [
                            103.18417,
                            18.26627
                        ],
                        [
                            103.27875,
                            18.29426
                        ],
                        [
                            103.24353,
                            18.36048
                        ],
                        [
                            103.30843,
                            18.43243
                        ],
                        [
                            103.40985,
                            18.44801
                        ],
                        [
                            103.62685,
                            18.39366
                        ],
                        [
                            103.69806,
                            18.34383
                        ],
                        [
                            103.83593,
                            18.32385
                        ],
                        [
                            103.85823,
                            18.28478
                        ],
                        [
                            103.92443,
                            18.32843
                        ],
                        [
                            103.98491,
                            18.32601
                        ],
                        [
                            104.06032,
                            18.2212
                        ],
                        [
                            104.11047,
                            18.10891
                        ],
                        [
                            104.22606,
                            17.97917
                        ],
                        [
                            104.2768,
                            17.86099
                        ],
                        [
                            104.34044,
                            17.83557
                        ],
                        [
                            104.47803,
                            17.64655
                        ],
                        [
                            104.69929,
                            17.52945
                        ],
                        [
                            104.79679,
                            17.3973
                        ],
                        [
                            104.80362,
                            17.2026
                        ],
                        [
                            104.72937,
                            17.00752
                        ],
                        [
                            104.73488,
                            16.90708
                        ],
                        [
                            104.76136,
                            16.84266
                        ],
                        [
                            104.73914,
                            16.80507
                        ],
                        [
                            104.75938,
                            16.69565
                        ],
                        [
                            104.74015,
                            16.53038
                        ],
                        [
                            104.83919,
                            16.45871
                        ],
                        [
                            104.88947,
                            16.35734
                        ],
                        [
                            105.01736,
                            16.23359
                        ],
                        [
                            105.01304,
                            16.18908
                        ],
                        [
                            105.04804,
                            16.10274
                        ],
                        [
                            105.20542,
                            16.05179
                        ],
                        [
                            105.41718,
                            16.01157
                        ],
                        [
                            105.3403,
                            15.92078
                        ],
                        [
                            105.3905,
                            15.80514
                        ],
                        [
                            105.44342,
                            15.75044
                        ],
                        [
                            105.50319,
                            15.76612
                        ],
                        [
                            105.59765,
                            15.72236
                        ],
                        [
                            105.63584,
                            15.63654
                        ],
                        [
                            105.59283,
                            15.51064
                        ],
                        [
                            105.59226,
                            15.42916
                        ],
                        [
                            105.50126,
                            15.39167
                        ],
                        [
                            105.50589,
                            15.31893
                        ],
                        [
                            105.57299,
                            15.32538
                        ],
                        [
                            105.59485,
                            15.27379
                        ],
                        [
                            105.53362,
                            15.24326
                        ],
                        [
                            105.4718,
                            15.16386
                        ],
                        [
                            105.4866,
                            15.09909
                        ],
                        [
                            105.52565,
                            15.07018
                        ],
                        [
                            105.589,
                            14.94114
                        ],
                        [
                            105.52496,
                            14.79826
                        ],
                        [
                            105.53782,
                            14.55535
                        ],
                        [
                            105.43267,
                            14.41673
                        ],
                        [
                            105.35724,
                            14.37546
                        ],
                        [
                            105.20007,
                            14.34271
                        ],
                        [
                            105.27208,
                            14.18358
                        ],
                        [
                            105.36092,
                            14.10973
                        ],
                        [
                            105.45391,
                            14.10273
                        ],
                        [
                            105.54851,
                            14.15712
                        ],
                        [
                            105.60346,
                            14.14614
                        ],
                        [
                            105.70323,
                            14.08859
                        ],
                        [
                            105.78148,
                            14.08508
                        ],
                        [
                            105.79078,
                            14.0226
                        ],
                        [
                            105.91068,
                            13.93026
                        ],
                        [
                            106.00361,
                            13.9346
                        ],
                        [
                            106.10733,
                            13.91612
                        ],
                        [
                            106.11762,
                            13.99144
                        ],
                        [
                            106.18453,
                            14.06047
                        ],
                        [
                            106.13354,
                            14.10355
                        ],
                        [
                            106.02737,
                            14.25813
                        ],
                        [
                            106.02494,
                            14.35
                        ],
                        [
                            106.09185,
                            14.37385
                        ],
                        [
                            106.1757,
                            14.35705
                        ],
                        [
                            106.21939,
                            14.37879
                        ],
                        [
                            106.25331,
                            14.4813
                        ],
                        [
                            106.3178,
                            14.43746
                        ],
                        [
                            106.40908,
                            14.45232
                        ],
                        [
                            106.46138,
                            14.55039
                        ],
                        [
                            106.54379,
                            14.5879
                        ],
                        [
                            106.63088,
                            14.45099
                        ],
                        [
                            106.73995,
                            14.42412
                        ],
                        [
                            106.81654,
                            14.31024
                        ],
                        [
                            106.97608,
                            14.33416
                        ],
                        [
                            107.0224,
                            14.40182
                        ],
                        [
                            107.07507,
                            14.42179
                        ],
                        [
                            107.2019,
                            14.43075
                        ],
                        [
                            107.24883,
                            14.46706
                        ],
                        [
                            107.25652,
                            14.52578
                        ],
                        [
                            107.29885,
                            14.58559
                        ],
                        [
                            107.43695,
                            14.52817
                        ],
                        [
                            107.45845,
                            14.61459
                        ],
                        [
                            107.55613,
                            14.6866
                        ],
                        [
                            107.50706,
                            14.79795
                        ],
                        [
                            107.58864,
                            14.87089
                        ],
                        [
                            107.50424,
                            14.93118
                        ],
                        [
                            107.48011,
                            15.0239
                        ],
                        [
                            107.59424,
                            15.05379
                        ],
                        [
                            107.54837,
                            15.15932
                        ],
                        [
                            107.58866,
                            15.26851
                        ],
                        [
                            107.68317,
                            15.28446
                        ],
                        [
                            107.67225,
                            15.34844
                        ],
                        [
                            107.61103,
                            15.39189
                        ],
                        [
                            107.52717,
                            15.41403
                        ],
                        [
                            107.51039,
                            15.47457
                        ],
                        [
                            107.38448,
                            15.50394
                        ],
                        [
                            107.34869,
                            15.60809
                        ],
                        [
                            107.26714,
                            15.657
                        ],
                        [
                            107.28284,
                            15.70961
                        ],
                        [
                            107.21646,
                            15.7603
                        ],
                        [
                            107.22548,
                            15.84254
                        ],
                        [
                            107.42238,
                            15.91883
                        ],
                        [
                            107.47422,
                            16.0665
                        ],
                        [
                            107.43344,
                            16.14546
                        ],
                        [
                            107.35599,
                            16.11237
                        ],
                        [
                            107.18583,
                            16.15064
                        ],
                        [
                            107.15353,
                            16.1782
                        ],
                        [
                            107.15567,
                            16.25784
                        ],
                        [
                            107.09089,
                            16.30928
                        ],
                        [
                            106.96586,
                            16.31276
                        ],
                        [
                            106.96336,
                            16.35333
                        ],
                        [
                            106.87533,
                            16.4389
                        ],
                        [
                            106.88956,
                            16.51245
                        ],
                        [
                            106.83223,
                            16.54484
                        ],
                        [
                            106.80255,
                            16.465
                        ],
                        [
                            106.76377,
                            16.42646
                        ],
                        [
                            106.68885,
                            16.44051
                        ],
                        [
                            106.6611,
                            16.47555
                        ],
                        [
                            106.64487,
                            16.59332
                        ],
                        [
                            106.5847,
                            16.60372
                        ],
                        [
                            106.55534,
                            16.69176
                        ],
                        [
                            106.5496,
                            17.00463
                        ],
                        [
                            106.51238,
                            16.97151
                        ],
                        [
                            106.42639,
                            17.00715
                        ],
                        [
                            106.40564,
                            17.08764
                        ],
                        [
                            106.37499,
                            17.11046
                        ],
                        [
                            106.31253,
                            17.21993
                        ],
                        [
                            106.25024,
                            17.24627
                        ],
                        [
                            106.0871,
                            17.35785
                        ],
                        [
                            105.8648,
                            17.61828
                        ],
                        [
                            105.7516,
                            17.67583
                        ],
                        [
                            105.72775,
                            17.74635
                        ],
                        [
                            105.67805,
                            17.79474
                        ],
                        [
                            105.68239,
                            17.83542
                        ],
                        [
                            105.61256,
                            17.88592
                        ],
                        [
                            105.64084,
                            17.98733
                        ],
                        [
                            105.59248,
                            18.00943
                        ],
                        [
                            105.57051,
                            18.07727
                        ],
                        [
                            105.50644,
                            18.12261
                        ],
                        [
                            105.48573,
                            18.19456
                        ],
                        [
                            105.40632,
                            18.14974
                        ],
                        [
                            105.3278,
                            18.1888
                        ],
                        [
                            105.32306,
                            18.22986
                        ],
                        [
                            105.258,
                            18.2558
                        ],
                        [
                            105.18746,
                            18.32145
                        ],
                        [
                            105.17813,
                            18.38144
                        ],
                        [
                            105.10321,
                            18.44305
                        ],
                        [
                            105.13786,
                            18.58607
                        ],
                        [
                            105.19019,
                            18.63916
                        ],
                        [
                            105.12609,
                            18.69412
                        ],
                        [
                            105.00953,
                            18.73979
                        ],
                        [
                            104.94473,
                            18.74277
                        ],
                        [
                            104.91482,
                            18.78399
                        ],
                        [
                            104.85539,
                            18.77849
                        ],
                        [
                            104.74622,
                            18.80036
                        ],
                        [
                            104.58203,
                            18.90372
                        ],
                        [
                            104.54144,
                            18.97239
                        ],
                        [
                            104.44865,
                            18.98878
                        ],
                        [
                            104.3979,
                            19.05657
                        ],
                        [
                            104.3162,
                            19.08724
                        ],
                        [
                            104.1863,
                            19.19841
                        ],
                        [
                            104.06702,
                            19.24483
                        ],
                        [
                            104.00055,
                            19.2329
                        ],
                        [
                            103.90016,
                            19.3065
                        ],
                        [
                            103.97793,
                            19.39765
                        ],
                        [
                            104.07828,
                            19.42557
                        ],
                        [
                            104.12045,
                            19.4994
                        ],
                        [
                            104.09964,
                            19.56544
                        ],
                        [
                            104.03561,
                            19.61893
                        ],
                        [
                            104.09273,
                            19.66704
                        ],
                        [
                            104.24153,
                            19.70638
                        ],
                        [
                            104.32304,
                            19.67126
                        ],
                        [
                            104.40361,
                            19.70536
                        ],
                        [
                            104.42492,
                            19.67081
                        ],
                        [
                            104.5214,
                            19.61407
                        ],
                        [
                            104.64158,
                            19.62374
                        ],
                        [
                            104.66507,
                            19.70175
                        ],
                        [
                            104.72321,
                            19.75281
                        ],
                        [
                            104.83383,
                            19.79623
                        ],
                        [
                            104.84155,
                            19.84694
                        ],
                        [
                            104.76955,
                            19.87499
                        ],
                        [
                            104.79883,
                            19.92248
                        ],
                        [
                            104.97592,
                            20.01172
                        ],
                        [
                            104.99035,
                            20.09635
                        ],
                        [
                            104.68008,
                            20.24544
                        ],
                        [
                            104.7794,
                            20.27984
                        ],
                        [
                            104.75492,
                            20.38899
                        ],
                        [
                            104.62256,
                            20.428
                        ],
                        [
                            104.4615,
                            20.40309
                        ],
                        [
                            104.44239,
                            20.45813
                        ],
                        [
                            104.49254,
                            20.51719
                        ],
                        [
                            104.59829,
                            20.53589
                        ],
                        [
                            104.53472,
                            20.69025
                        ],
                        [
                            104.47818,
                            20.76598
                        ],
                        [
                            104.33083,
                            20.86058
                        ],
                        [
                            104.32839,
                            20.88819
                        ],
                        [
                            104.18349,
                            20.95676
                        ],
                        [
                            104.10549,
                            20.9766
                        ],
                        [
                            104.05221,
                            20.94891
                        ],
                        [
                            104.025,
                            20.89547
                        ],
                        [
                            103.9686,
                            20.87806
                        ],
                        [
                            103.82134,
                            20.7858
                        ],
                        [
                            103.75264,
                            20.77581
                        ],
                        [
                            103.59718,
                            20.80809
                        ],
                        [
                            103.4963,
                            20.77603
                        ],
                        [
                            103.44071,
                            20.84335
                        ],
                        [
                            103.32817,
                            20.81561
                        ],
                        [
                            103.25742,
                            20.8245
                        ],
                        [
                            103.12,
                            20.88666
                        ],
                        [
                            103.0406,
                            21.04644
                        ],
                        [
                            102.96135,
                            21.07923
                        ],
                        [
                            102.96029,
                            21.11319
                        ],
                        [
                            102.88418,
                            21.24299
                        ],
                        [
                            102.80843,
                            21.2633
                        ],
                        [
                            102.89181,
                            21.32778
                        ],
                        [
                            102.89682,
                            21.38401
                        ],
                        [
                            102.99623,
                            21.57536
                        ],
                        [
                            102.97987,
                            21.68871
                        ],
                        [
                            102.94165,
                            21.7758
                        ],
                        [
                            102.80626,
                            21.8182
                        ],
                        [
                            102.72822,
                            21.82457
                        ],
                        [
                            102.62106,
                            21.86485
                        ],
                        [
                            102.61054,
                            21.92179
                        ],
                        [
                            102.50555,
                            21.9732
                        ],
                        [
                            102.48387,
                            22.04305
                        ],
                        [
                            102.3819,
                            22.14881
                        ],
                        [
                            102.28372,
                            22.207
                        ],
                        [
                            102.23758,
                            22.27072
                        ],
                        [
                            102.17897,
                            22.30535
                        ],
                        [
                            102.14389,
                            22.40069
                        ],
                        [
                            102.12778,
                            22.43403
                        ],
                        [
                            102.04594,
                            22.45833
                        ],
                        [
                            101.9968,
                            22.43536
                        ],
                        [
                            101.91382,
                            22.44084
                        ],
                        [
                            101.8495,
                            22.38851
                        ],
                        [
                            101.82789,
                            22.45959
                        ],
                        [
                            101.73825,
                            22.49901
                        ],
                        [
                            101.64583,
                            22.41582
                        ],
                        [
                            101.66872,
                            22.37015
                        ],
                        [
                            101.62686,
                            22.28917
                        ],
                        [
                            101.56053,
                            22.27823
                        ],
                        [
                            101.59873,
                            22.13403
                        ],
                        [
                            101.57999,
                            22.06345
                        ],
                        [
                            101.62192,
                            22.0212
                        ],
                        [
                            101.59844,
                            21.97262
                        ],
                        [
                            101.67078,
                            21.93366
                        ],
                        [
                            101.77157,
                            21.83695
                        ],
                        [
                            101.74703,
                            21.73161
                        ],
                        [
                            101.76938,
                            21.66068
                        ],
                        [
                            101.83192,
                            21.61565
                        ],
                        [
                            101.76258,
                            21.5637
                        ],
                        [
                            101.77619,
                            21.51758
                        ],
                        [
                            101.72708,
                            21.35409
                        ],
                        [
                            101.75639,
                            21.29334
                        ],
                        [
                            101.84427,
                            21.2519
                        ],
                        [
                            101.86834,
                            21.1901
                        ],
                        [
                            101.81613,
                            21.14256
                        ],
                        [
                            101.70934,
                            21.14592
                        ],
                        [
                            101.68384,
                            21.20361
                        ],
                        [
                            101.5337,
                            21.25616
                        ],
                        [
                            101.40001,
                            21.23266
                        ],
                        [
                            101.28533,
                            21.17659
                        ],
                        [
                            101.24363,
                            21.27316
                        ],
                        [
                            101.24608,
                            21.37684
                        ],
                        [
                            101.18777,
                            21.41868
                        ],
                        [
                            101.21469,
                            21.49166
                        ],
                        [
                            101.20713,
                            21.56072
                        ],
                        [
                            101.14319,
                            21.56406
                        ],
                        [
                            101.16202,
                            21.52428
                        ],
                        [
                            101.05938,
                            21.45461
                        ],
                        [
                            100.99974,
                            21.38696
                        ],
                        [
                            100.88568,
                            21.34894
                        ],
                        [
                            100.80656,
                            21.29365
                        ],
                        [
                            100.7354,
                            21.31472
                        ],
                        [
                            100.69807,
                            21.17873
                        ],
                        [
                            100.63761,
                            21.06213
                        ],
                        [
                            100.54644,
                            21.02367
                        ],
                        [
                            100.50994,
                            20.89372
                        ],
                        [
                            100.56973,
                            20.82353
                        ],
                        [
                            100.3597,
                            20.82161
                        ],
                        [
                            100.25437,
                            20.74966
                        ],
                        [
                            100.17726,
                            20.64008
                        ],
                        [
                            100.12,
                            20.43891
                        ],
                        [
                            100.08532,
                            20.35273
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "LVA",
                "Country": "Latvia",
                "Total_3GHG": 0.06,
                "Total_3GHG_timeseries": [
                    3.9995e-06,
                    8.0028e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009
                ],
                "Fossil_3GHG": 0.05,
                "Fossil_3GHG_timeseries": [
                    1.9375e-07,
                    3.9546e-07,
                    6.0529e-07,
                    8.2337e-07,
                    1.0509e-06,
                    1.2859e-06,
                    1.5296e-06,
                    1.7836e-06,
                    1.956e-06,
                    2.0535e-06,
                    2.2097e-06,
                    2.4281e-06,
                    2.7139e-06,
                    3.0145e-06,
                    3.3298e-06,
                    3.666e-06,
                    4.019e-06,
                    4.3755e-06,
                    4.7402e-06,
                    5.1111e-06,
                    5.4846e-06,
                    5.8625e-06,
                    6.2436e-06,
                    6.6321e-06,
                    7.0277e-06,
                    7.4329e-06,
                    7.843e-06,
                    8.2658e-06,
                    8.779e-06,
                    9.3821e-06,
                    9.9461e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Land_3GHG": 0.08,
                "Land_3GHG_timeseries": [
                    3.8057e-06,
                    7.6074e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Total_CO2": 0.07,
                "Total_CO2_timeseries": [
                    3.1492e-06,
                    6.2884e-06,
                    9.4139e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Fossil_CO2": 0.06,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    1.0276e-09,
                    1.0276e-09,
                    1.0276e-09,
                    2.4705e-09,
                    4.0007e-09,
                    6.0227e-09,
                    8.5913e-09,
                    1.0909e-08,
                    1.3335e-08,
                    1.6057e-08,
                    1.8658e-08,
                    2.6878e-08,
                    3.6311e-08,
                    4.4159e-08,
                    5.4805e-08,
                    6.6358e-08,
                    8.1956e-08,
                    9.7969e-08,
                    1.13e-07,
                    1.3124e-07,
                    1.5224e-07,
                    1.7831e-07,
                    2.0491e-07,
                    2.3968e-07,
                    2.7536e-07,
                    3.1721e-07,
                    3.6129e-07,
                    4.0772e-07,
                    4.6057e-07,
                    5.1423e-07,
                    5.7267e-07,
                    6.3262e-07,
                    6.9604e-07,
                    7.622e-07,
                    8.3366e-07,
                    9.1457e-07,
                    1.0037e-06,
                    1.098e-06,
                    1.2085e-06,
                    1.3211e-06,
                    1.4505e-06,
                    1.5821e-06,
                    1.7344e-06,
                    1.9052e-06,
                    2.1033e-06,
                    2.3277e-06,
                    2.5581e-06,
                    2.7806e-06,
                    2.9983e-06,
                    3.2404e-06,
                    3.4566e-06,
                    3.7032e-06,
                    3.9793e-06,
                    4.2572e-06,
                    4.5505e-06,
                    4.8382e-06,
                    5.1365e-06,
                    5.4743e-06,
                    5.8413e-06,
                    6.1725e-06,
                    6.4766e-06,
                    6.8006e-06,
                    7.0988e-06,
                    7.2178e-06,
                    7.3194e-06,
                    7.412e-06,
                    7.5124e-06,
                    7.635e-06,
                    7.7703e-06,
                    7.9316e-06,
                    8.0907e-06,
                    8.3213e-06,
                    8.608e-06,
                    8.9243e-06,
                    9.2648e-06,
                    9.7304e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Land_CO2": 0.09,
                "Land_CO2_timeseries": [
                    3.1492e-06,
                    6.2884e-06,
                    9.4139e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Total_CH4": 0.02,
                "Total_CH4_timeseries": [
                    6.9381e-07,
                    1.3985e-06,
                    2.1141e-06,
                    2.8409e-06,
                    3.579e-06,
                    4.3285e-06,
                    5.0896e-06,
                    5.8624e-06,
                    6.5565e-06,
                    7.1782e-06,
                    7.8541e-06,
                    8.5888e-06,
                    9.387e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_CH4": 0.02,
                "Fossil_CH4_timeseries": [
                    1.6613e-07,
                    3.3994e-07,
                    5.2156e-07,
                    7.1114e-07,
                    9.0885e-07,
                    1.1148e-06,
                    1.3291e-06,
                    1.552e-06,
                    1.693e-06,
                    1.7584e-06,
                    1.8816e-06,
                    2.067e-06,
                    2.3194e-06,
                    2.5862e-06,
                    2.8675e-06,
                    3.1638e-06,
                    3.4754e-06,
                    3.7919e-06,
                    4.1135e-06,
                    4.4402e-06,
                    4.7651e-06,
                    5.0937e-06,
                    5.426e-06,
                    5.7621e-06,
                    6.102e-06,
                    6.4459e-06,
                    6.7938e-06,
                    7.1458e-06,
                    7.5869e-06,
                    8.1113e-06,
                    8.5941e-06,
                    9.0333e-06,
                    9.4246e-06,
                    9.8178e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CH4": 0.02,
                "Land_CH4_timeseries": [
                    5.2768e-07,
                    1.0585e-06,
                    1.5926e-06,
                    2.1298e-06,
                    2.6702e-06,
                    3.2137e-06,
                    3.7605e-06,
                    4.3104e-06,
                    4.8635e-06,
                    5.4198e-06,
                    5.9726e-06,
                    6.5218e-06,
                    7.0676e-06,
                    7.6098e-06,
                    8.1486e-06,
                    8.6838e-06,
                    9.2155e-06,
                    9.7437e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_N2O": 0.14,
                "Total_N2O_timeseries": [
                    1.5652e-07,
                    3.1591e-07,
                    4.7807e-07,
                    6.4283e-07,
                    8.1e-07,
                    9.7934e-07,
                    1.1506e-06,
                    1.3233e-06,
                    1.4973e-06,
                    1.672e-06,
                    1.8472e-06,
                    2.0228e-06,
                    2.1988e-06,
                    2.3752e-06,
                    2.5519e-06,
                    2.729e-06,
                    2.9064e-06,
                    3.0842e-06,
                    3.2625e-06,
                    3.4413e-06,
                    3.6228e-06,
                    3.8109e-06,
                    4.0084e-06,
                    4.2175e-06,
                    4.4392e-06,
                    4.6739e-06,
                    4.921e-06,
                    5.1789e-06,
                    5.4453e-06,
                    5.717e-06,
                    5.9917e-06,
                    6.2691e-06,
                    6.5488e-06,
                    6.8304e-06,
                    7.1138e-06,
                    7.399e-06,
                    7.6858e-06,
                    7.9745e-06,
                    8.2651e-06,
                    8.5617e-06,
                    8.8627e-06,
                    9.1681e-06,
                    9.4777e-06,
                    9.7913e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_N2O": 0.06,
                "Fossil_N2O_timeseries": [
                    2.7614e-08,
                    5.5526e-08,
                    8.3732e-08,
                    1.1223e-07,
                    1.4102e-07,
                    1.7009e-07,
                    1.9944e-07,
                    2.2907e-07,
                    2.5896e-07,
                    2.8911e-07,
                    3.1951e-07,
                    3.5017e-07,
                    3.8108e-07,
                    4.1225e-07,
                    4.4366e-07,
                    4.7533e-07,
                    5.0725e-07,
                    5.3942e-07,
                    5.7185e-07,
                    6.0453e-07,
                    6.375e-07,
                    6.7084e-07,
                    7.0459e-07,
                    7.388e-07,
                    7.7348e-07,
                    8.0863e-07,
                    8.4425e-07,
                    8.8031e-07,
                    9.1677e-07,
                    9.5357e-07,
                    9.9067e-07,
                    1.0281e-06,
                    1.0657e-06,
                    1.1037e-06,
                    1.1419e-06,
                    1.1805e-06,
                    1.2192e-06,
                    1.2583e-06,
                    1.2977e-06,
                    1.3374e-06,
                    1.3774e-06,
                    1.4178e-06,
                    1.4585e-06,
                    1.4995e-06,
                    1.5408e-06,
                    1.5825e-06,
                    1.6245e-06,
                    1.6668e-06,
                    1.7095e-06,
                    1.7526e-06,
                    1.796e-06,
                    1.8398e-06,
                    1.8839e-06,
                    1.9285e-06,
                    1.9735e-06,
                    2.019e-06,
                    2.0648e-06,
                    2.111e-06,
                    2.1577e-06,
                    2.2047e-06,
                    2.2522e-06,
                    2.3e-06,
                    2.3481e-06,
                    2.3967e-06,
                    2.4456e-06,
                    2.4948e-06,
                    2.5444e-06,
                    2.5945e-06,
                    2.6449e-06,
                    2.6957e-06,
                    2.7469e-06,
                    2.7987e-06,
                    2.8512e-06,
                    2.9043e-06,
                    2.9582e-06,
                    3.013e-06,
                    3.0685e-06,
                    3.125e-06,
                    3.1825e-06,
                    3.2409e-06,
                    3.3003e-06,
                    3.3612e-06,
                    3.4235e-06,
                    3.4876e-06,
                    3.5534e-06,
                    3.6211e-06,
                    3.6907e-06,
                    3.7622e-06,
                    3.8355e-06,
                    3.9105e-06,
                    3.9872e-06,
                    4.0659e-06,
                    4.1465e-06,
                    4.2293e-06,
                    4.3143e-06,
                    4.4016e-06,
                    4.4913e-06,
                    4.5834e-06,
                    4.6779e-06,
                    4.7748e-06,
                    4.8746e-06,
                    4.978e-06,
                    5.0856e-06,
                    5.1976e-06,
                    5.3141e-06,
                    5.435e-06,
                    5.5598e-06,
                    5.6879e-06,
                    5.8185e-06,
                    5.9504e-06,
                    6.0828e-06,
                    6.2152e-06,
                    6.3474e-06,
                    6.4791e-06,
                    6.6102e-06,
                    6.7408e-06,
                    6.8709e-06,
                    7.0008e-06,
                    7.1309e-06,
                    7.2579e-06,
                    7.3857e-06,
                    7.5195e-06,
                    7.661e-06,
                    7.8096e-06,
                    7.9783e-06,
                    8.1514e-06,
                    8.3268e-06,
                    8.5078e-06,
                    8.6915e-06,
                    8.8792e-06,
                    9.0692e-06,
                    9.2598e-06,
                    9.4504e-06,
                    9.6406e-06,
                    9.8299e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.16,
                "Land_N2O_timeseries": [
                    1.2891e-07,
                    2.6039e-07,
                    3.9434e-07,
                    5.306e-07,
                    6.6899e-07,
                    8.0925e-07,
                    9.5111e-07,
                    1.0942e-06,
                    1.2383e-06,
                    1.3828e-06,
                    1.5276e-06,
                    1.6726e-06,
                    1.8177e-06,
                    1.963e-06,
                    2.1083e-06,
                    2.2537e-06,
                    2.3992e-06,
                    2.5448e-06,
                    2.6906e-06,
                    2.8367e-06,
                    2.9853e-06,
                    3.14e-06,
                    3.3038e-06,
                    3.4787e-06,
                    3.6658e-06,
                    3.8653e-06,
                    4.0767e-06,
                    4.2986e-06,
                    4.5285e-06,
                    4.7634e-06,
                    5.0011e-06,
                    5.2411e-06,
                    5.483e-06,
                    5.7267e-06,
                    5.9719e-06,
                    6.2185e-06,
                    6.4666e-06,
                    6.7161e-06,
                    6.9674e-06,
                    7.2243e-06,
                    7.4853e-06,
                    7.7503e-06,
                    8.0192e-06,
                    8.2918e-06,
                    8.5676e-06,
                    8.8465e-06,
                    9.1279e-06,
                    9.4113e-06,
                    9.6962e-06,
                    9.982e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            27.35158,
                            57.51824
                        ],
                        [
                            27.10268,
                            57.56594
                        ],
                        [
                            26.90553,
                            57.63258
                        ],
                        [
                            26.86204,
                            57.59273
                        ],
                        [
                            26.67604,
                            57.56632
                        ],
                        [
                            26.61523,
                            57.52943
                        ],
                        [
                            26.49989,
                            57.52507
                        ],
                        [
                            26.46809,
                            57.57548
                        ],
                        [
                            26.28707,
                            57.59197
                        ],
                        [
                            26.20489,
                            57.71494
                        ],
                        [
                            26.02559,
                            57.78374
                        ],
                        [
                            26.05821,
                            57.83688
                        ],
                        [
                            25.82156,
                            57.86496
                        ],
                        [
                            25.48585,
                            57.97481
                        ],
                        [
                            25.45121,
                            58.01525
                        ],
                        [
                            25.30291,
                            58.03537
                        ],
                        [
                            25.21525,
                            58.07432
                        ],
                        [
                            25.10933,
                            58.07792
                        ],
                        [
                            25.01856,
                            58.01736
                        ],
                        [
                            24.83066,
                            57.97326
                        ],
                        [
                            24.58642,
                            57.96136
                        ],
                        [
                            24.35282,
                            57.87656
                        ],
                        [
                            24.34332,
                            57.70116
                        ],
                        [
                            24.38624,
                            57.61503
                        ],
                        [
                            24.36359,
                            57.57819
                        ],
                        [
                            24.41066,
                            57.26745
                        ],
                        [
                            24.33949,
                            57.19579
                        ],
                        [
                            24.16081,
                            57.10163
                        ],
                        [
                            23.97581,
                            57.02548
                        ],
                        [
                            23.75286,
                            56.96967
                        ],
                        [
                            23.62539,
                            56.96445
                        ],
                        [
                            23.49373,
                            57.031
                        ],
                        [
                            23.30491,
                            57.0642
                        ],
                        [
                            23.23752,
                            57.10921
                        ],
                        [
                            23.13223,
                            57.35933
                        ],
                        [
                            22.94604,
                            57.41421
                        ],
                        [
                            22.8459,
                            57.49195
                        ],
                        [
                            22.66009,
                            57.5695
                        ],
                        [
                            22.60596,
                            57.61281
                        ],
                        [
                            22.51879,
                            57.74616
                        ],
                        [
                            22.04943,
                            57.61577
                        ],
                        [
                            21.72236,
                            57.57639
                        ],
                        [
                            21.59386,
                            57.43101
                        ],
                        [
                            21.41178,
                            57.2683
                        ],
                        [
                            21.40927,
                            57.05
                        ],
                        [
                            21.35343,
                            56.98504
                        ],
                        [
                            21.05237,
                            56.82376
                        ],
                        [
                            21.05805,
                            56.70331
                        ],
                        [
                            20.98527,
                            56.51768
                        ],
                        [
                            20.97291,
                            56.37312
                        ],
                        [
                            20.98517,
                            56.2121
                        ],
                        [
                            21.06424,
                            56.06914
                        ],
                        [
                            21.20118,
                            56.07755
                        ],
                        [
                            21.32773,
                            56.21755
                        ],
                        [
                            21.45228,
                            56.24903
                        ],
                        [
                            21.50112,
                            56.29471
                        ],
                        [
                            21.61805,
                            56.32449
                        ],
                        [
                            21.72296,
                            56.31375
                        ],
                        [
                            21.83665,
                            56.37133
                        ],
                        [
                            21.97092,
                            56.3772
                        ],
                        [
                            21.9954,
                            56.41343
                        ],
                        [
                            22.12732,
                            56.43187
                        ],
                        [
                            22.2428,
                            56.40007
                        ],
                        [
                            22.42523,
                            56.40977
                        ],
                        [
                            22.83979,
                            56.3654
                        ],
                        [
                            23.00309,
                            56.40458
                        ],
                        [
                            23.02808,
                            56.33165
                        ],
                        [
                            23.09325,
                            56.30464
                        ],
                        [
                            23.17808,
                            56.36851
                        ],
                        [
                            23.38572,
                            56.37901
                        ],
                        [
                            23.55488,
                            56.33353
                        ],
                        [
                            23.76527,
                            56.37286
                        ],
                        [
                            23.76241,
                            56.33618
                        ],
                        [
                            24.01894,
                            56.32975
                        ],
                        [
                            24.11904,
                            56.24964
                        ],
                        [
                            24.3168,
                            56.30087
                        ],
                        [
                            24.45484,
                            56.25854
                        ],
                        [
                            24.57922,
                            56.28891
                        ],
                        [
                            24.62857,
                            56.37469
                        ],
                        [
                            24.71247,
                            56.40095
                        ],
                        [
                            24.90328,
                            56.42063
                        ],
                        [
                            24.97392,
                            56.31101
                        ],
                        [
                            25.05665,
                            56.26473
                        ],
                        [
                            25.07631,
                            56.1958
                        ],
                        [
                            25.28046,
                            56.15853
                        ],
                        [
                            25.65256,
                            56.13588
                        ],
                        [
                            25.68968,
                            56.08604
                        ],
                        [
                            25.81918,
                            56.05471
                        ],
                        [
                            25.86169,
                            56.00023
                        ],
                        [
                            25.97424,
                            55.98114
                        ],
                        [
                            26.12031,
                            55.88026
                        ],
                        [
                            26.20286,
                            55.85913
                        ],
                        [
                            26.26911,
                            55.76766
                        ],
                        [
                            26.53191,
                            55.67702
                        ],
                        [
                            26.63037,
                            55.68067
                        ],
                        [
                            26.65324,
                            55.70727
                        ],
                        [
                            26.8691,
                            55.71244
                        ],
                        [
                            26.92003,
                            55.78688
                        ],
                        [
                            27.01483,
                            55.82828
                        ],
                        [
                            27.15405,
                            55.85163
                        ],
                        [
                            27.28512,
                            55.78581
                        ],
                        [
                            27.3567,
                            55.81172
                        ],
                        [
                            27.6136,
                            55.78676
                        ],
                        [
                            27.65309,
                            55.92959
                        ],
                        [
                            27.78534,
                            55.97625
                        ],
                        [
                            27.99238,
                            56.12553
                        ],
                        [
                            28.15456,
                            56.16984
                        ],
                        [
                            28.24058,
                            56.27606
                        ],
                        [
                            28.16383,
                            56.37865
                        ],
                        [
                            28.19356,
                            56.44074
                        ],
                        [
                            28.10014,
                            56.50971
                        ],
                        [
                            28.12591,
                            56.58215
                        ],
                        [
                            28.0429,
                            56.59097
                        ],
                        [
                            28.01224,
                            56.67242
                        ],
                        [
                            27.89947,
                            56.75271
                        ],
                        [
                            27.8719,
                            56.86661
                        ],
                        [
                            27.65944,
                            56.83437
                        ],
                        [
                            27.73776,
                            56.92159
                        ],
                        [
                            27.76808,
                            57.00292
                        ],
                        [
                            27.75794,
                            57.13075
                        ],
                        [
                            27.81777,
                            57.1434
                        ],
                        [
                            27.86722,
                            57.29686
                        ],
                        [
                            27.78326,
                            57.32124
                        ],
                        [
                            27.6709,
                            57.3948
                        ],
                        [
                            27.51821,
                            57.42741
                        ],
                        [
                            27.56647,
                            57.51375
                        ],
                        [
                            27.5041,
                            57.54
                        ],
                        [
                            27.35158,
                            57.51824
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "LBN",
                "Country": "Lebanon",
                "Total_3GHG": 0.03,
                "Total_3GHG_timeseries": [
                    7.3071e-08,
                    1.4694e-07,
                    2.2157e-07,
                    2.9696e-07,
                    3.7306e-07,
                    4.4985e-07,
                    5.273e-07,
                    6.0538e-07,
                    6.8404e-07,
                    7.6297e-07,
                    8.422e-07,
                    9.2182e-07,
                    1.0019e-06,
                    1.0823e-06,
                    1.1633e-06,
                    1.2446e-06,
                    1.3264e-06,
                    1.4087e-06,
                    1.4915e-06,
                    1.5847e-06,
                    1.6896e-06,
                    1.8041e-06,
                    1.927e-06,
                    2.0573e-06,
                    2.1947e-06,
                    2.3386e-06,
                    2.4889e-06,
                    2.6452e-06,
                    2.8072e-06,
                    2.9615e-06,
                    3.1057e-06,
                    3.2425e-06,
                    3.3737e-06,
                    3.5003e-06,
                    3.6229e-06,
                    3.742e-06,
                    3.8578e-06,
                    3.9707e-06,
                    4.0808e-06,
                    4.192e-06,
                    4.3039e-06,
                    4.416e-06,
                    4.5277e-06,
                    4.6389e-06,
                    4.7494e-06,
                    4.8591e-06,
                    4.968e-06,
                    5.0759e-06,
                    5.1829e-06,
                    5.2849e-06,
                    5.3815e-06,
                    5.4725e-06,
                    5.5599e-06,
                    5.6424e-06,
                    5.7213e-06,
                    5.7965e-06,
                    5.8684e-06,
                    5.937e-06,
                    6.002e-06,
                    6.0641e-06,
                    6.1257e-06,
                    6.1863e-06,
                    6.2465e-06,
                    6.3061e-06,
                    6.3653e-06,
                    6.4236e-06,
                    6.482e-06,
                    6.5398e-06,
                    6.5974e-06,
                    6.6725e-06,
                    6.7719e-06,
                    6.8919e-06,
                    7.0305e-06,
                    7.186e-06,
                    7.359e-06,
                    7.5471e-06,
                    7.751e-06,
                    7.9702e-06,
                    8.204e-06,
                    8.4566e-06,
                    8.7249e-06,
                    9.0122e-06,
                    9.3157e-06,
                    9.6233e-06,
                    9.9655e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Fossil_3GHG": 0.05,
                "Fossil_3GHG_timeseries": [
                    3.7209e-08,
                    7.4707e-08,
                    1.1249e-07,
                    1.5057e-07,
                    1.8893e-07,
                    2.2757e-07,
                    2.6649e-07,
                    3.0569e-07,
                    3.4516e-07,
                    3.849e-07,
                    4.2491e-07,
                    4.6521e-07,
                    5.0578e-07,
                    5.4663e-07,
                    5.8775e-07,
                    6.2915e-07,
                    6.7082e-07,
                    7.1277e-07,
                    7.55e-07,
                    7.975e-07,
                    8.4248e-07,
                    8.8998e-07,
                    9.4002e-07,
                    9.9262e-07,
                    1.0478e-06,
                    1.1055e-06,
                    1.1658e-06,
                    1.2287e-06,
                    1.2941e-06,
                    1.3619e-06,
                    1.429e-06,
                    1.4952e-06,
                    1.5606e-06,
                    1.6252e-06,
                    1.689e-06,
                    1.7519e-06,
                    1.814e-06,
                    1.8752e-06,
                    1.9356e-06,
                    1.9953e-06,
                    2.0542e-06,
                    2.1123e-06,
                    2.1696e-06,
                    2.2263e-06,
                    2.2821e-06,
                    2.3372e-06,
                    2.3916e-06,
                    2.4453e-06,
                    2.4981e-06,
                    2.5503e-06,
                    2.6009e-06,
                    2.65e-06,
                    2.6975e-06,
                    2.7436e-06,
                    2.7881e-06,
                    2.8312e-06,
                    2.8728e-06,
                    2.9129e-06,
                    2.9516e-06,
                    2.9888e-06,
                    3.0256e-06,
                    3.062e-06,
                    3.0979e-06,
                    3.1334e-06,
                    3.1684e-06,
                    3.2029e-06,
                    3.2368e-06,
                    3.2703e-06,
                    3.3032e-06,
                    3.3356e-06,
                    3.3754e-06,
                    3.4224e-06,
                    3.4768e-06,
                    3.5385e-06,
                    3.6075e-06,
                    3.6839e-06,
                    3.7676e-06,
                    3.8587e-06,
                    3.9571e-06,
                    4.0628e-06,
                    4.1762e-06,
                    4.2994e-06,
                    4.4307e-06,
                    4.5622e-06,
                    4.7235e-06,
                    4.895e-06,
                    5.0751e-06,
                    5.2622e-06,
                    5.4546e-06,
                    5.6389e-06,
                    5.8336e-06,
                    6.1865e-06,
                    6.4097e-06,
                    6.6576e-06,
                    6.933e-06,
                    7.2335e-06,
                    7.5653e-06,
                    7.9326e-06,
                    8.3347e-06,
                    9.4258e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Land_3GHG": 0.01,
                "Land_3GHG_timeseries": [
                    3.5862e-08,
                    7.2228e-08,
                    1.0908e-07,
                    1.4639e-07,
                    1.8413e-07,
                    2.2228e-07,
                    2.6081e-07,
                    2.9969e-07,
                    3.3888e-07,
                    3.7807e-07,
                    4.1729e-07,
                    4.5661e-07,
                    4.9608e-07,
                    5.357e-07,
                    5.755e-07,
                    6.1547e-07,
                    6.5563e-07,
                    6.9596e-07,
                    7.3648e-07,
                    7.8724e-07,
                    8.4715e-07,
                    9.1416e-07,
                    9.8695e-07,
                    1.0647e-06,
                    1.1469e-06,
                    1.2331e-06,
                    1.3231e-06,
                    1.4165e-06,
                    1.5131e-06,
                    1.5995e-06,
                    1.6767e-06,
                    1.7473e-06,
                    1.8131e-06,
                    1.8751e-06,
                    1.934e-06,
                    1.9901e-06,
                    2.0439e-06,
                    2.0955e-06,
                    2.1452e-06,
                    2.1967e-06,
                    2.2497e-06,
                    2.3037e-06,
                    2.3581e-06,
                    2.4127e-06,
                    2.4673e-06,
                    2.5219e-06,
                    2.5764e-06,
                    2.6307e-06,
                    2.6848e-06,
                    2.7346e-06,
                    2.7806e-06,
                    2.8225e-06,
                    2.8624e-06,
                    2.8989e-06,
                    2.9332e-06,
                    2.9653e-06,
                    2.9957e-06,
                    3.0241e-06,
                    3.0504e-06,
                    3.0754e-06,
                    3.1001e-06,
                    3.1244e-06,
                    3.1486e-06,
                    3.1727e-06,
                    3.1969e-06,
                    3.2208e-06,
                    3.2452e-06,
                    3.2694e-06,
                    3.2942e-06,
                    3.3369e-06,
                    3.3965e-06,
                    3.4695e-06,
                    3.5537e-06,
                    3.6475e-06,
                    3.7515e-06,
                    3.8631e-06,
                    3.9834e-06,
                    4.1116e-06,
                    4.2469e-06,
                    4.3939e-06,
                    4.5487e-06,
                    4.7129e-06,
                    4.885e-06,
                    5.0611e-06,
                    5.2421e-06,
                    5.4342e-06,
                    5.6373e-06,
                    5.8466e-06,
                    6.0674e-06,
                    6.2906e-06,
                    6.522e-06,
                    6.7598e-06,
                    7.0079e-06,
                    7.263e-06,
                    7.5335e-06,
                    7.8174e-06,
                    8.1128e-06,
                    8.4168e-06,
                    8.7328e-06,
                    9.0654e-06,
                    9.4172e-06,
                    9.7826e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_CO2": 0.03,
                "Total_CO2_timeseries": [
                    1.6923e-08,
                    3.4138e-08,
                    5.1628e-08,
                    6.9383e-08,
                    8.7373e-08,
                    1.0559e-07,
                    1.2403e-07,
                    1.4266e-07,
                    1.6147e-07,
                    1.8016e-07,
                    1.9878e-07,
                    2.1739e-07,
                    2.3604e-07,
                    2.5475e-07,
                    2.7353e-07,
                    2.9237e-07,
                    3.113e-07,
                    3.303e-07,
                    3.4939e-07,
                    3.786e-07,
                    4.1576e-07,
                    4.5865e-07,
                    5.058e-07,
                    5.563e-07,
                    6.0958e-07,
                    6.6525e-07,
                    7.2302e-07,
                    7.8266e-07,
                    8.4398e-07,
                    8.9383e-07,
                    9.3471e-07,
                    9.6933e-07,
                    9.9942e-07,
                    1.026e-06,
                    1.0499e-06,
                    1.0713e-06,
                    1.0908e-06,
                    1.1083e-06,
                    1.1243e-06,
                    1.142e-06,
                    1.1615e-06,
                    1.1823e-06,
                    1.2039e-06,
                    1.226e-06,
                    1.2484e-06,
                    1.2711e-06,
                    1.2941e-06,
                    1.3171e-06,
                    1.3403e-06,
                    1.3595e-06,
                    1.3751e-06,
                    1.387e-06,
                    1.3969e-06,
                    1.4038e-06,
                    1.4088e-06,
                    1.4118e-06,
                    1.4132e-06,
                    1.4129e-06,
                    1.4107e-06,
                    1.4074e-06,
                    1.4035e-06,
                    1.3989e-06,
                    1.394e-06,
                    1.3887e-06,
                    1.3832e-06,
                    1.377e-06,
                    1.371e-06,
                    1.3645e-06,
                    1.3582e-06,
                    1.3694e-06,
                    1.3942e-06,
                    1.4286e-06,
                    1.4703e-06,
                    1.5176e-06,
                    1.5709e-06,
                    1.6275e-06,
                    1.6885e-06,
                    1.7531e-06,
                    1.8208e-06,
                    1.8961e-06,
                    1.9777e-06,
                    2.0687e-06,
                    2.1661e-06,
                    2.2578e-06,
                    2.3742e-06,
                    2.4985e-06,
                    2.6286e-06,
                    2.758e-06,
                    2.8902e-06,
                    3.0011e-06,
                    3.1127e-06,
                    3.3695e-06,
                    3.4864e-06,
                    3.6136e-06,
                    3.749e-06,
                    3.8873e-06,
                    4.0312e-06,
                    4.1815e-06,
                    4.34e-06,
                    5.134e-06,
                    5.9139e-06,
                    6.5691e-06,
                    7.2423e-06,
                    7.9538e-06,
                    8.8149e-06,
                    9.784e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004
                ],
                "Fossil_CO2": 0.04,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.6365e-09,
                    6.5464e-09,
                    1.3093e-08,
                    1.3093e-08,
                    3.6005e-08,
                    6.2192e-08,
                    9.0014e-08,
                    1.1784e-07,
                    1.4402e-07,
                    1.5384e-07,
                    1.6366e-07,
                    3.2078e-07,
                    3.3714e-07,
                    3.666e-07,
                    3.9934e-07,
                    4.3207e-07,
                    4.6971e-07,
                    5.1554e-07,
                    5.6791e-07,
                    1.2489e-06,
                    1.905e-06,
                    2.4342e-06,
                    2.9963e-06,
                    3.5847e-06,
                    4.3148e-06,
                    5.1637e-06,
                    6.0933e-06,
                    6.985e-06,
                    8.0875e-06,
                    9.2475e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [
                    1.6923e-08,
                    3.4138e-08,
                    5.1628e-08,
                    6.9383e-08,
                    8.7373e-08,
                    1.0559e-07,
                    1.2403e-07,
                    1.4266e-07,
                    1.6147e-07,
                    1.8016e-07,
                    1.9878e-07,
                    2.1739e-07,
                    2.3604e-07,
                    2.5475e-07,
                    2.7353e-07,
                    2.9237e-07,
                    3.113e-07,
                    3.303e-07,
                    3.4939e-07,
                    3.786e-07,
                    4.1576e-07,
                    4.5865e-07,
                    5.058e-07,
                    5.563e-07,
                    6.0958e-07,
                    6.6525e-07,
                    7.2302e-07,
                    7.8266e-07,
                    8.4398e-07,
                    8.9383e-07,
                    9.3471e-07,
                    9.6933e-07,
                    9.9942e-07,
                    1.026e-06,
                    1.0499e-06,
                    1.0713e-06,
                    1.0908e-06,
                    1.1083e-06,
                    1.1243e-06,
                    1.142e-06,
                    1.1615e-06,
                    1.1823e-06,
                    1.2039e-06,
                    1.226e-06,
                    1.2484e-06,
                    1.2711e-06,
                    1.2941e-06,
                    1.3171e-06,
                    1.3403e-06,
                    1.3595e-06,
                    1.3751e-06,
                    1.387e-06,
                    1.3969e-06,
                    1.4038e-06,
                    1.4088e-06,
                    1.4118e-06,
                    1.4132e-06,
                    1.4129e-06,
                    1.4107e-06,
                    1.4074e-06,
                    1.4035e-06,
                    1.3989e-06,
                    1.394e-06,
                    1.3887e-06,
                    1.3832e-06,
                    1.377e-06,
                    1.371e-06,
                    1.3645e-06,
                    1.3582e-06,
                    1.3694e-06,
                    1.3942e-06,
                    1.4286e-06,
                    1.4703e-06,
                    1.5176e-06,
                    1.5709e-06,
                    1.6275e-06,
                    1.6885e-06,
                    1.7531e-06,
                    1.8208e-06,
                    1.8961e-06,
                    1.976e-06,
                    2.0621e-06,
                    2.153e-06,
                    2.2447e-06,
                    2.3382e-06,
                    2.4363e-06,
                    2.5386e-06,
                    2.6402e-06,
                    2.7462e-06,
                    2.8472e-06,
                    2.949e-06,
                    3.0487e-06,
                    3.1493e-06,
                    3.247e-06,
                    3.3497e-06,
                    3.4552e-06,
                    3.5615e-06,
                    3.666e-06,
                    3.7721e-06,
                    3.8851e-06,
                    4.0089e-06,
                    4.135e-06,
                    4.2461e-06,
                    4.3691e-06,
                    4.5001e-06,
                    4.6203e-06,
                    4.7191e-06,
                    4.8316e-06,
                    4.8967e-06,
                    5.0059e-06,
                    5.1387e-06,
                    5.2518e-06,
                    5.418e-06,
                    5.6503e-06,
                    5.8087e-06,
                    6.0354e-06,
                    6.2549e-06,
                    6.453e-06,
                    6.6487e-06,
                    6.8552e-06,
                    7.058e-06,
                    7.3003e-06,
                    7.4746e-06,
                    7.5671e-06,
                    7.6418e-06,
                    7.6825e-06,
                    7.6939e-06,
                    7.6835e-06,
                    7.6444e-06,
                    7.597e-06,
                    7.5517e-06,
                    7.5174e-06,
                    7.4879e-06,
                    7.4675e-06,
                    7.4747e-06,
                    7.49e-06,
                    7.4809e-06,
                    7.4546e-06,
                    7.5014e-06,
                    7.5508e-06,
                    7.5106e-06,
                    7.4773e-06,
                    7.5268e-06,
                    7.5039e-06,
                    7.6404e-06,
                    7.7486e-06,
                    7.8152e-06,
                    7.6409e-06,
                    7.656e-06,
                    7.5329e-06,
                    7.4939e-06,
                    7.4783e-06,
                    7.3455e-06,
                    7.3693e-06,
                    7.3518e-06,
                    7.3938e-06,
                    7.4402e-06,
                    7.6322e-06,
                    7.5762e-06,
                    7.8958e-06,
                    7.8803e-06,
                    7.7033e-06,
                    7.7894e-06,
                    8.0544e-06,
                    8.1364e-06,
                    8.293e-06,
                    9.1364e-06,
                    9.0203e-06,
                    8.7394e-06,
                    8.5003e-06,
                    8.8125e-06,
                    9.0237e-06
                ],
                "Total_CH4": 0.04,
                "Total_CH4_timeseries": [
                    4.0971e-08,
                    8.222e-08,
                    1.2375e-07,
                    1.6555e-07,
                    2.0764e-07,
                    2.5e-07,
                    2.9263e-07,
                    3.3555e-07,
                    3.7874e-07,
                    4.2221e-07,
                    4.6597e-07,
                    5.1003e-07,
                    5.5439e-07,
                    5.9904e-07,
                    6.4399e-07,
                    6.8923e-07,
                    7.3477e-07,
                    7.806e-07,
                    8.2673e-07,
                    8.7315e-07,
                    9.2303e-07,
                    9.7638e-07,
                    1.0332e-06,
                    1.0934e-06,
                    1.1572e-06,
                    1.2243e-06,
                    1.295e-06,
                    1.3691e-06,
                    1.4466e-06,
                    1.5276e-06,
                    1.6072e-06,
                    1.6856e-06,
                    1.7626e-06,
                    1.8382e-06,
                    1.9126e-06,
                    1.9856e-06,
                    2.0573e-06,
                    2.1277e-06,
                    2.1967e-06,
                    2.2645e-06,
                    2.331e-06,
                    2.3962e-06,
                    2.4603e-06,
                    2.5231e-06,
                    2.5847e-06,
                    2.645e-06,
                    2.7042e-06,
                    2.7621e-06,
                    2.8188e-06,
                    2.8742e-06,
                    2.9277e-06,
                    2.9791e-06,
                    3.0285e-06,
                    3.0759e-06,
                    3.1214e-06,
                    3.1648e-06,
                    3.2063e-06,
                    3.2458e-06,
                    3.2834e-06,
                    3.319e-06,
                    3.3543e-06,
                    3.3892e-06,
                    3.4237e-06,
                    3.4577e-06,
                    3.4914e-06,
                    3.5246e-06,
                    3.5573e-06,
                    3.5896e-06,
                    3.6214e-06,
                    3.6527e-06,
                    3.6942e-06,
                    3.7459e-06,
                    3.8077e-06,
                    3.8797e-06,
                    3.9619e-06,
                    4.0543e-06,
                    4.1568e-06,
                    4.2695e-06,
                    4.3924e-06,
                    4.5254e-06,
                    4.6668e-06,
                    4.8164e-06,
                    4.9743e-06,
                    5.1406e-06,
                    5.3153e-06,
                    5.5018e-06,
                    5.7004e-06,
                    5.9112e-06,
                    6.1343e-06,
                    6.3714e-06,
                    6.6242e-06,
                    6.8932e-06,
                    7.1788e-06,
                    7.4815e-06,
                    7.814e-06,
                    8.1776e-06,
                    8.5737e-06,
                    9.0036e-06,
                    9.4685e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002
                ],
                "Fossil_CH4": 0.06,
                "Fossil_CH4_timeseries": [
                    2.8087e-08,
                    5.636e-08,
                    8.482e-08,
                    1.1347e-07,
                    1.423e-07,
                    1.7132e-07,
                    2.0052e-07,
                    2.2992e-07,
                    2.5949e-07,
                    2.8925e-07,
                    3.1922e-07,
                    3.4937e-07,
                    3.7973e-07,
                    4.1028e-07,
                    4.4103e-07,
                    4.7198e-07,
                    5.0313e-07,
                    5.3447e-07,
                    5.6601e-07,
                    5.9774e-07,
                    6.3186e-07,
                    6.6835e-07,
                    7.0721e-07,
                    7.4845e-07,
                    7.9206e-07,
                    8.3804e-07,
                    8.8638e-07,
                    9.371e-07,
                    9.9018e-07,
                    1.0456e-06,
                    1.1001e-06,
                    1.1537e-06,
                    1.2064e-06,
                    1.2582e-06,
                    1.309e-06,
                    1.3589e-06,
                    1.4079e-06,
                    1.456e-06,
                    1.5031e-06,
                    1.5493e-06,
                    1.5947e-06,
                    1.6392e-06,
                    1.6829e-06,
                    1.7257e-06,
                    1.7676e-06,
                    1.8087e-06,
                    1.8489e-06,
                    1.8883e-06,
                    1.9268e-06,
                    1.9644e-06,
                    2.0004e-06,
                    2.0347e-06,
                    2.0674e-06,
                    2.0984e-06,
                    2.1277e-06,
                    2.1554e-06,
                    2.1815e-06,
                    2.206e-06,
                    2.2289e-06,
                    2.2502e-06,
                    2.2709e-06,
                    2.2911e-06,
                    2.3106e-06,
                    2.3296e-06,
                    2.3479e-06,
                    2.3656e-06,
                    2.3827e-06,
                    2.399e-06,
                    2.4147e-06,
                    2.4298e-06,
                    2.452e-06,
                    2.4814e-06,
                    2.518e-06,
                    2.5618e-06,
                    2.6127e-06,
                    2.6709e-06,
                    2.7363e-06,
                    2.8088e-06,
                    2.8885e-06,
                    2.9755e-06,
                    3.0683e-06,
                    3.167e-06,
                    3.2717e-06,
                    3.3824e-06,
                    3.499e-06,
                    3.6217e-06,
                    3.7503e-06,
                    3.8851e-06,
                    4.0259e-06,
                    4.1742e-06,
                    4.332e-06,
                    4.4996e-06,
                    4.6771e-06,
                    4.865e-06,
                    5.0756e-06,
                    5.3102e-06,
                    5.5699e-06,
                    5.8558e-06,
                    6.169e-06,
                    6.5419e-06,
                    6.9395e-06,
                    7.3638e-06,
                    7.8272e-06,
                    8.3339e-06,
                    8.8919e-06,
                    9.5035e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CH4": 0.01,
                "Land_CH4_timeseries": [
                    1.2884e-08,
                    2.586e-08,
                    3.8927e-08,
                    5.2085e-08,
                    6.5335e-08,
                    7.8676e-08,
                    9.2109e-08,
                    1.0563e-07,
                    1.1925e-07,
                    1.3295e-07,
                    1.4676e-07,
                    1.6066e-07,
                    1.7466e-07,
                    1.8876e-07,
                    2.0296e-07,
                    2.1725e-07,
                    2.3164e-07,
                    2.4613e-07,
                    2.6072e-07,
                    2.7541e-07,
                    2.9118e-07,
                    3.0803e-07,
                    3.2597e-07,
                    3.45e-07,
                    3.6511e-07,
                    3.8631e-07,
                    4.0859e-07,
                    4.3196e-07,
                    4.5642e-07,
                    4.8196e-07,
                    5.0709e-07,
                    5.3182e-07,
                    5.5615e-07,
                    5.8007e-07,
                    6.0359e-07,
                    6.267e-07,
                    6.4941e-07,
                    6.7172e-07,
                    6.9362e-07,
                    7.1512e-07,
                    7.3625e-07,
                    7.5701e-07,
                    7.774e-07,
                    7.9742e-07,
                    8.1707e-07,
                    8.3636e-07,
                    8.5527e-07,
                    8.7382e-07,
                    8.9199e-07,
                    9.098e-07,
                    9.2726e-07,
                    9.4437e-07,
                    9.6114e-07,
                    9.7756e-07,
                    9.9364e-07,
                    1.0094e-06,
                    1.0248e-06,
                    1.0398e-06,
                    1.0545e-06,
                    1.0688e-06,
                    1.0834e-06,
                    1.0981e-06,
                    1.113e-06,
                    1.1282e-06,
                    1.1435e-06,
                    1.159e-06,
                    1.1747e-06,
                    1.1906e-06,
                    1.2067e-06,
                    1.223e-06,
                    1.2423e-06,
                    1.2645e-06,
                    1.2897e-06,
                    1.318e-06,
                    1.3492e-06,
                    1.3834e-06,
                    1.4205e-06,
                    1.4607e-06,
                    1.5038e-06,
                    1.5499e-06,
                    1.5984e-06,
                    1.6493e-06,
                    1.7026e-06,
                    1.7583e-06,
                    1.8163e-06,
                    1.8802e-06,
                    1.9501e-06,
                    2.0261e-06,
                    2.1084e-06,
                    2.1972e-06,
                    2.2922e-06,
                    2.3936e-06,
                    2.5017e-06,
                    2.6165e-06,
                    2.7384e-06,
                    2.8674e-06,
                    3.0038e-06,
                    3.1478e-06,
                    3.2995e-06,
                    3.4591e-06,
                    3.6255e-06,
                    3.8012e-06,
                    3.9882e-06,
                    4.1881e-06,
                    4.4019e-06,
                    4.6271e-06,
                    4.8642e-06,
                    5.1138e-06,
                    5.3765e-06,
                    5.6531e-06,
                    5.8592e-06,
                    6.0765e-06,
                    6.3204e-06,
                    6.5311e-06,
                    6.7446e-06,
                    6.947e-06,
                    7.1164e-06,
                    7.2372e-06,
                    7.3472e-06,
                    7.468e-06,
                    7.5815e-06,
                    7.6806e-06,
                    7.7395e-06,
                    7.7566e-06,
                    7.6967e-06,
                    7.5639e-06,
                    7.3747e-06,
                    7.3107e-06,
                    7.2074e-06,
                    7.1053e-06,
                    7.0603e-06,
                    6.9908e-06,
                    6.8731e-06,
                    6.7768e-06,
                    6.676e-06,
                    6.5922e-06,
                    6.5442e-06,
                    6.5302e-06,
                    6.5266e-06,
                    6.5344e-06,
                    6.5785e-06,
                    6.6286e-06,
                    6.7036e-06,
                    6.8046e-06,
                    6.9362e-06,
                    7.1643e-06,
                    7.4212e-06,
                    7.552e-06,
                    7.7084e-06,
                    7.8329e-06,
                    7.9491e-06,
                    8.0872e-06,
                    8.2456e-06,
                    8.3962e-06,
                    8.5596e-06,
                    8.7163e-06,
                    8.8375e-06,
                    8.9762e-06,
                    9.0977e-06,
                    9.1437e-06,
                    9.2722e-06,
                    9.4169e-06,
                    9.5697e-06,
                    9.7352e-06,
                    9.8987e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_N2O": 0.03,
                "Total_N2O_timeseries": [
                    1.5176e-08,
                    3.0577e-08,
                    4.6195e-08,
                    6.2023e-08,
                    7.8049e-08,
                    9.426e-08,
                    1.1064e-07,
                    1.2717e-07,
                    1.4383e-07,
                    1.6059e-07,
                    1.7745e-07,
                    1.9439e-07,
                    2.1142e-07,
                    2.2854e-07,
                    2.4573e-07,
                    2.6301e-07,
                    2.8038e-07,
                    2.9782e-07,
                    3.1536e-07,
                    3.3299e-07,
                    3.5084e-07,
                    3.6912e-07,
                    3.8799e-07,
                    4.0756e-07,
                    4.2791e-07,
                    4.4905e-07,
                    4.7094e-07,
                    4.935e-07,
                    5.1659e-07,
                    5.4005e-07,
                    5.6374e-07,
                    5.8765e-07,
                    6.1174e-07,
                    6.3601e-07,
                    6.6044e-07,
                    6.8503e-07,
                    7.0978e-07,
                    7.3469e-07,
                    7.5978e-07,
                    7.8554e-07,
                    8.1143e-07,
                    8.3744e-07,
                    8.636e-07,
                    8.899e-07,
                    9.1636e-07,
                    9.4298e-07,
                    9.6977e-07,
                    9.9673e-07,
                    1.0239e-06,
                    1.0512e-06,
                    1.0787e-06,
                    1.1065e-06,
                    1.1344e-06,
                    1.1627e-06,
                    1.1912e-06,
                    1.2199e-06,
                    1.249e-06,
                    1.2783e-06,
                    1.3079e-06,
                    1.3378e-06,
                    1.3679e-06,
                    1.3982e-06,
                    1.4288e-06,
                    1.4597e-06,
                    1.4907e-06,
                    1.5221e-06,
                    1.5537e-06,
                    1.5856e-06,
                    1.6178e-06,
                    1.6504e-06,
                    1.6835e-06,
                    1.7174e-06,
                    1.7524e-06,
                    1.7887e-06,
                    1.8263e-06,
                    1.8653e-06,
                    1.9058e-06,
                    1.9477e-06,
                    1.9908e-06,
                    2.0351e-06,
                    2.0805e-06,
                    2.1272e-06,
                    2.1753e-06,
                    2.2249e-06,
                    2.276e-06,
                    2.3289e-06,
                    2.3834e-06,
                    2.4396e-06,
                    2.4975e-06,
                    2.557e-06,
                    2.6188e-06,
                    2.6836e-06,
                    2.7524e-06,
                    2.8256e-06,
                    2.9034e-06,
                    2.986e-06,
                    3.0731e-06,
                    3.1643e-06,
                    3.259e-06,
                    3.3562e-06,
                    3.4557e-06,
                    3.5577e-06,
                    3.6625e-06,
                    3.7701e-06,
                    3.8807e-06,
                    3.9941e-06,
                    4.1103e-06,
                    4.2289e-06,
                    4.3497e-06,
                    4.4722e-06,
                    4.5966e-06,
                    4.7229e-06,
                    4.8673e-06,
                    5.0173e-06,
                    5.1738e-06,
                    5.3439e-06,
                    5.5226e-06,
                    5.7094e-06,
                    5.9135e-06,
                    6.1073e-06,
                    6.3294e-06,
                    6.5662e-06,
                    6.8236e-06,
                    7.0328e-06,
                    7.194e-06,
                    7.3716e-06,
                    7.5352e-06,
                    7.7266e-06,
                    7.9328e-06,
                    8.159e-06,
                    8.3868e-06,
                    8.6242e-06,
                    8.8469e-06,
                    9.0743e-06,
                    9.2974e-06,
                    9.5198e-06,
                    9.738e-06,
                    9.9507e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_N2O": 0.05,
                "Fossil_N2O_timeseries": [
                    9.1219e-09,
                    1.8347e-08,
                    2.7674e-08,
                    3.7102e-08,
                    4.6628e-08,
                    5.6251e-08,
                    6.5967e-08,
                    7.5774e-08,
                    8.5667e-08,
                    9.5643e-08,
                    1.057e-07,
                    1.1583e-07,
                    1.2605e-07,
                    1.3634e-07,
                    1.4671e-07,
                    1.5716e-07,
                    1.6769e-07,
                    1.783e-07,
                    1.8899e-07,
                    1.9976e-07,
                    2.1063e-07,
                    2.2164e-07,
                    2.3281e-07,
                    2.4418e-07,
                    2.5574e-07,
                    2.675e-07,
                    2.7946e-07,
                    2.916e-07,
                    3.039e-07,
                    3.1632e-07,
                    3.2885e-07,
                    3.4149e-07,
                    3.5421e-07,
                    3.6704e-07,
                    3.7995e-07,
                    3.9296e-07,
                    4.0606e-07,
                    4.1925e-07,
                    4.3254e-07,
                    4.4594e-07,
                    4.5945e-07,
                    4.7306e-07,
                    4.8677e-07,
                    5.0059e-07,
                    5.1452e-07,
                    5.2856e-07,
                    5.4272e-07,
                    5.5698e-07,
                    5.7136e-07,
                    5.8586e-07,
                    6.0049e-07,
                    6.1525e-07,
                    6.3015e-07,
                    6.4519e-07,
                    6.6039e-07,
                    6.7573e-07,
                    6.9122e-07,
                    7.0687e-07,
                    7.2266e-07,
                    7.386e-07,
                    7.5469e-07,
                    7.7091e-07,
                    7.8728e-07,
                    8.0379e-07,
                    8.2045e-07,
                    8.3725e-07,
                    8.5419e-07,
                    8.7128e-07,
                    8.885e-07,
                    9.0587e-07,
                    9.2338e-07,
                    9.4103e-07,
                    9.5881e-07,
                    9.7675e-07,
                    9.9482e-07,
                    1.013e-06,
                    1.0314e-06,
                    1.0499e-06,
                    1.0685e-06,
                    1.0873e-06,
                    1.1063e-06,
                    1.1258e-06,
                    1.1459e-06,
                    1.1668e-06,
                    1.1885e-06,
                    1.2111e-06,
                    1.2347e-06,
                    1.2592e-06,
                    1.2847e-06,
                    1.3109e-06,
                    1.338e-06,
                    1.3661e-06,
                    1.3954e-06,
                    1.4261e-06,
                    1.458e-06,
                    1.4912e-06,
                    1.5257e-06,
                    1.5612e-06,
                    1.5978e-06,
                    1.635e-06,
                    1.6729e-06,
                    1.7113e-06,
                    1.7502e-06,
                    1.7897e-06,
                    1.8298e-06,
                    1.8705e-06,
                    1.9119e-06,
                    1.954e-06,
                    1.9969e-06,
                    2.0406e-06,
                    2.0859e-06,
                    2.134e-06,
                    2.1862e-06,
                    2.2437e-06,
                    2.3077e-06,
                    2.3796e-06,
                    2.4607e-06,
                    2.5521e-06,
                    2.6552e-06,
                    2.7371e-06,
                    2.8211e-06,
                    2.9089e-06,
                    3.0057e-06,
                    3.1059e-06,
                    3.2013e-06,
                    3.298e-06,
                    3.3919e-06,
                    3.4907e-06,
                    3.5924e-06,
                    3.6999e-06,
                    3.8068e-06,
                    3.9071e-06,
                    4.0107e-06,
                    4.1138e-06,
                    4.2225e-06,
                    4.3301e-06,
                    4.4381e-06,
                    4.5367e-06,
                    4.6388e-06,
                    4.7404e-06,
                    4.8513e-06,
                    4.9718e-06,
                    5.1069e-06,
                    5.2494e-06,
                    5.4111e-06,
                    5.5873e-06,
                    5.7797e-06,
                    5.9918e-06,
                    6.2034e-06,
                    6.38e-06,
                    6.5573e-06,
                    6.7397e-06,
                    6.9278e-06,
                    7.1179e-06,
                    7.3066e-06,
                    7.4925e-06,
                    7.6709e-06,
                    7.863e-06,
                    8.0566e-06,
                    8.2613e-06,
                    8.4767e-06,
                    8.7324e-06,
                    8.9957e-06,
                    9.2745e-06,
                    9.5747e-06,
                    9.8813e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.02,
                "Land_N2O_timeseries": [
                    6.0544e-09,
                    1.223e-08,
                    1.8521e-08,
                    2.4921e-08,
                    3.1421e-08,
                    3.8009e-08,
                    4.4671e-08,
                    5.1394e-08,
                    5.816e-08,
                    6.4949e-08,
                    7.175e-08,
                    7.856e-08,
                    8.5375e-08,
                    9.2196e-08,
                    9.902e-08,
                    1.0585e-07,
                    1.1268e-07,
                    1.1952e-07,
                    1.2637e-07,
                    1.3323e-07,
                    1.4021e-07,
                    1.4748e-07,
                    1.5517e-07,
                    1.6339e-07,
                    1.7217e-07,
                    1.8154e-07,
                    1.9147e-07,
                    2.0189e-07,
                    2.1269e-07,
                    2.2373e-07,
                    2.3489e-07,
                    2.4616e-07,
                    2.5753e-07,
                    2.6897e-07,
                    2.8049e-07,
                    2.9207e-07,
                    3.0372e-07,
                    3.1544e-07,
                    3.2724e-07,
                    3.396e-07,
                    3.5198e-07,
                    3.6439e-07,
                    3.7683e-07,
                    3.8931e-07,
                    4.0183e-07,
                    4.1441e-07,
                    4.2705e-07,
                    4.3975e-07,
                    4.525e-07,
                    4.6533e-07,
                    4.7822e-07,
                    4.912e-07,
                    5.0429e-07,
                    5.1747e-07,
                    5.3078e-07,
                    5.442e-07,
                    5.5775e-07,
                    5.7143e-07,
                    5.8523e-07,
                    5.9915e-07,
                    6.1318e-07,
                    6.2731e-07,
                    6.4154e-07,
                    6.5586e-07,
                    6.7028e-07,
                    6.8482e-07,
                    6.9949e-07,
                    7.1431e-07,
                    7.293e-07,
                    7.4451e-07,
                    7.6011e-07,
                    7.7639e-07,
                    7.936e-07,
                    8.1192e-07,
                    8.3145e-07,
                    8.5228e-07,
                    8.7441e-07,
                    8.978e-07,
                    9.2233e-07,
                    9.4785e-07,
                    9.7423e-07,
                    1.0014e-06,
                    1.0294e-06,
                    1.0581e-06,
                    1.0875e-06,
                    1.1177e-06,
                    1.1487e-06,
                    1.1803e-06,
                    1.2128e-06,
                    1.2461e-06,
                    1.2808e-06,
                    1.3175e-06,
                    1.357e-06,
                    1.3995e-06,
                    1.4455e-06,
                    1.4948e-06,
                    1.5474e-06,
                    1.6031e-06,
                    1.6612e-06,
                    1.7212e-06,
                    1.7828e-06,
                    1.8464e-06,
                    1.9123e-06,
                    1.9804e-06,
                    2.0509e-06,
                    2.1236e-06,
                    2.1984e-06,
                    2.2749e-06,
                    2.3528e-06,
                    2.4315e-06,
                    2.5107e-06,
                    2.5889e-06,
                    2.6811e-06,
                    2.7736e-06,
                    2.866e-06,
                    2.9642e-06,
                    3.062e-06,
                    3.1573e-06,
                    3.2583e-06,
                    3.3702e-06,
                    3.5083e-06,
                    3.6573e-06,
                    3.8179e-06,
                    3.927e-06,
                    3.9927e-06,
                    4.0735e-06,
                    4.1433e-06,
                    4.2358e-06,
                    4.3404e-06,
                    4.4591e-06,
                    4.58e-06,
                    4.7171e-06,
                    4.8362e-06,
                    4.9605e-06,
                    5.0749e-06,
                    5.1897e-06,
                    5.2999e-06,
                    5.414e-06,
                    5.5403e-06,
                    5.6594e-06,
                    5.7827e-06,
                    5.9129e-06,
                    6.0557e-06,
                    6.1813e-06,
                    6.3419e-06,
                    6.5e-06,
                    6.6619e-06,
                    6.8311e-06,
                    6.9982e-06,
                    7.1701e-06,
                    7.3568e-06,
                    7.5219e-06,
                    7.6989e-06,
                    7.8843e-06,
                    8.0433e-06,
                    8.1907e-06,
                    8.3515e-06,
                    8.5073e-06,
                    8.6802e-06,
                    8.8569e-06,
                    9.0724e-06,
                    9.3001e-06,
                    9.5182e-06,
                    9.738e-06,
                    9.9608e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            35.10342,
                            33.0936
                        ],
                        [
                            35.19336,
                            33.08525
                        ],
                        [
                            35.31725,
                            33.10487
                        ],
                        [
                            35.35436,
                            33.05735
                        ],
                        [
                            35.50356,
                            33.08957
                        ],
                        [
                            35.56351,
                            33.2729
                        ],
                        [
                            35.62444,
                            33.24235
                        ],
                        [
                            35.72744,
                            33.32799
                        ],
                        [
                            35.81543,
                            33.36047
                        ],
                        [
                            35.8276,
                            33.39722
                        ],
                        [
                            35.94421,
                            33.46877
                        ],
                        [
                            35.94561,
                            33.52132
                        ],
                        [
                            36.02854,
                            33.54208
                        ],
                        [
                            36.05463,
                            33.5901
                        ],
                        [
                            35.97782,
                            33.63551
                        ],
                        [
                            35.96892,
                            33.68048
                        ],
                        [
                            36.01323,
                            33.76554
                        ],
                        [
                            36.07033,
                            33.81952
                        ],
                        [
                            36.15689,
                            33.85194
                        ],
                        [
                            36.24927,
                            33.85215
                        ],
                        [
                            36.36424,
                            33.81936
                        ],
                        [
                            36.36246,
                            33.87218
                        ],
                        [
                            36.28717,
                            33.90291
                        ],
                        [
                            36.30681,
                            33.94474
                        ],
                        [
                            36.42921,
                            34.05196
                        ],
                        [
                            36.4955,
                            34.03743
                        ],
                        [
                            36.51602,
                            34.09585
                        ],
                        [
                            36.62134,
                            34.2022
                        ],
                        [
                            36.58866,
                            34.22939
                        ],
                        [
                            36.53363,
                            34.36943
                        ],
                        [
                            36.55061,
                            34.42109
                        ],
                        [
                            36.46526,
                            34.46489
                        ],
                        [
                            36.38683,
                            34.63135
                        ],
                        [
                            36.3229,
                            34.68381
                        ],
                        [
                            36.29023,
                            34.63272
                        ],
                        [
                            36.12573,
                            34.64
                        ],
                        [
                            35.97558,
                            34.63341
                        ],
                        [
                            35.98509,
                            34.52737
                        ],
                        [
                            35.90688,
                            34.47419
                        ],
                        [
                            35.80928,
                            34.45623
                        ],
                        [
                            35.81862,
                            34.41033
                        ],
                        [
                            35.73685,
                            34.37776
                        ],
                        [
                            35.71476,
                            34.31213
                        ],
                        [
                            35.65445,
                            34.28302
                        ],
                        [
                            35.62831,
                            34.14225
                        ],
                        [
                            35.65112,
                            34.10418
                        ],
                        [
                            35.57264,
                            33.90523
                        ],
                        [
                            35.48396,
                            33.90417
                        ],
                        [
                            35.48301,
                            33.81404
                        ],
                        [
                            35.41712,
                            33.69077
                        ],
                        [
                            35.35588,
                            33.52033
                        ],
                        [
                            35.28007,
                            33.45039
                        ],
                        [
                            35.20721,
                            33.26201
                        ],
                        [
                            35.20411,
                            33.20167
                        ],
                        [
                            35.10342,
                            33.0936
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "LSO",
                "Country": "Lesotho",
                "Total_3GHG": 0.01,
                "Total_3GHG_timeseries": [
                    8.9589e-08,
                    1.8051e-07,
                    2.7272e-07,
                    3.6617e-07,
                    4.6078e-07,
                    5.565e-07,
                    6.5327e-07,
                    7.5104e-07,
                    8.4978e-07,
                    9.4998e-07,
                    1.053e-06,
                    1.1586e-06,
                    1.2668e-06,
                    1.3776e-06,
                    1.4907e-06,
                    1.6062e-06,
                    1.7241e-06,
                    1.8443e-06,
                    1.9668e-06,
                    2.0928e-06,
                    2.2242e-06,
                    2.3611e-06,
                    2.5034e-06,
                    2.6509e-06,
                    2.8037e-06,
                    2.9615e-06,
                    3.1243e-06,
                    3.2918e-06,
                    3.4637e-06,
                    3.6385e-06,
                    3.8176e-06,
                    4.0008e-06,
                    4.188e-06,
                    4.3791e-06,
                    4.5739e-06,
                    4.7724e-06,
                    4.9745e-06,
                    5.1802e-06,
                    5.3894e-06,
                    5.6051e-06,
                    5.8282e-06,
                    6.0585e-06,
                    6.296e-06,
                    6.5409e-06,
                    6.7935e-06,
                    7.054e-06,
                    7.3232e-06,
                    7.6017e-06,
                    7.8904e-06,
                    8.1911e-06,
                    8.5129e-06,
                    8.8499e-06,
                    9.1942e-06,
                    9.5624e-06,
                    9.9602e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_3GHG": 0.01,
                "Fossil_3GHG_timeseries": [
                    2.0973e-08,
                    4.2075e-08,
                    6.3311e-08,
                    8.4688e-08,
                    1.0621e-07,
                    1.2788e-07,
                    1.4972e-07,
                    1.7171e-07,
                    1.9387e-07,
                    2.162e-07,
                    2.3877e-07,
                    2.6158e-07,
                    2.8465e-07,
                    3.0798e-07,
                    3.3159e-07,
                    3.5547e-07,
                    3.7965e-07,
                    4.0412e-07,
                    4.2891e-07,
                    4.5401e-07,
                    4.797e-07,
                    5.0601e-07,
                    5.3297e-07,
                    5.6061e-07,
                    5.8894e-07,
                    6.1797e-07,
                    6.4769e-07,
                    6.781e-07,
                    7.0916e-07,
                    7.4086e-07,
                    7.7316e-07,
                    8.0607e-07,
                    8.3959e-07,
                    8.737e-07,
                    9.0842e-07,
                    9.4375e-07,
                    9.797e-07,
                    1.0163e-06,
                    1.0534e-06,
                    1.0918e-06,
                    1.131e-06,
                    1.1711e-06,
                    1.212e-06,
                    1.2539e-06,
                    1.2966e-06,
                    1.3398e-06,
                    1.3834e-06,
                    1.4274e-06,
                    1.4719e-06,
                    1.5169e-06,
                    1.564e-06,
                    1.6135e-06,
                    1.6652e-06,
                    1.7193e-06,
                    1.7768e-06,
                    1.8377e-06,
                    1.9022e-06,
                    1.9703e-06,
                    2.0422e-06,
                    2.1176e-06,
                    2.1978e-06,
                    2.2829e-06,
                    2.3732e-06,
                    2.4685e-06,
                    2.5692e-06,
                    2.6757e-06,
                    2.7881e-06,
                    2.9067e-06,
                    3.0314e-06,
                    3.1625e-06,
                    3.2996e-06,
                    3.4406e-06,
                    3.5856e-06,
                    3.7345e-06,
                    3.8864e-06,
                    4.0413e-06,
                    4.1991e-06,
                    4.3597e-06,
                    4.5232e-06,
                    4.6895e-06,
                    4.8593e-06,
                    5.0325e-06,
                    5.2093e-06,
                    5.3895e-06,
                    5.5732e-06,
                    5.7604e-06,
                    5.9531e-06,
                    6.1516e-06,
                    6.3558e-06,
                    6.5658e-06,
                    6.7767e-06,
                    6.9908e-06,
                    7.2081e-06,
                    7.4289e-06,
                    7.658e-06,
                    7.8954e-06,
                    8.1411e-06,
                    8.3953e-06,
                    8.6578e-06,
                    8.9288e-06,
                    9.201e-06,
                    9.4745e-06,
                    9.7491e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_3GHG": 0.02,
                "Land_3GHG_timeseries": [
                    6.8616e-08,
                    1.3844e-07,
                    2.0941e-07,
                    2.8148e-07,
                    3.5457e-07,
                    4.2862e-07,
                    5.0356e-07,
                    5.7933e-07,
                    6.5591e-07,
                    7.3378e-07,
                    8.142e-07,
                    8.9704e-07,
                    9.822e-07,
                    1.0696e-06,
                    1.1591e-06,
                    1.2508e-06,
                    1.3445e-06,
                    1.4402e-06,
                    1.5379e-06,
                    1.6388e-06,
                    1.7445e-06,
                    1.8551e-06,
                    1.9704e-06,
                    2.0903e-06,
                    2.2147e-06,
                    2.3435e-06,
                    2.4766e-06,
                    2.6137e-06,
                    2.7545e-06,
                    2.8976e-06,
                    3.0444e-06,
                    3.1947e-06,
                    3.3484e-06,
                    3.5054e-06,
                    3.6655e-06,
                    3.8287e-06,
                    3.9948e-06,
                    4.164e-06,
                    4.336e-06,
                    4.5133e-06,
                    4.6972e-06,
                    4.8874e-06,
                    5.084e-06,
                    5.287e-06,
                    5.4969e-06,
                    5.7142e-06,
                    5.9398e-06,
                    6.1743e-06,
                    6.4185e-06,
                    6.6742e-06,
                    6.9489e-06,
                    7.2364e-06,
                    7.529e-06,
                    7.8431e-06,
                    8.1834e-06,
                    8.5415e-06,
                    8.9289e-06,
                    9.3174e-06,
                    9.7434e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_CO2": 0.01,
                "Total_CO2_timeseries": [
                    3.5194e-08,
                    7.0934e-08,
                    1.0718e-07,
                    1.4388e-07,
                    1.8098e-07,
                    2.1843e-07,
                    2.562e-07,
                    2.9424e-07,
                    3.3257e-07,
                    3.717e-07,
                    4.1177e-07,
                    4.5269e-07,
                    4.9434e-07,
                    5.3663e-07,
                    5.795e-07,
                    6.229e-07,
                    6.6675e-07,
                    7.1102e-07,
                    7.5574e-07,
                    8.0205e-07,
                    8.5073e-07,
                    9.0153e-07,
                    9.541e-07,
                    1.0081e-06,
                    1.0635e-06,
                    1.12e-06,
                    1.1775e-06,
                    1.236e-06,
                    1.2953e-06,
                    1.3543e-06,
                    1.4146e-06,
                    1.476e-06,
                    1.5385e-06,
                    1.6019e-06,
                    1.6662e-06,
                    1.7313e-06,
                    1.7971e-06,
                    1.8635e-06,
                    1.9306e-06,
                    1.9997e-06,
                    2.0723e-06,
                    2.1481e-06,
                    2.2271e-06,
                    2.3094e-06,
                    2.3955e-06,
                    2.4859e-06,
                    2.5814e-06,
                    2.6827e-06,
                    2.7904e-06,
                    2.9066e-06,
                    3.0375e-06,
                    3.1772e-06,
                    3.3178e-06,
                    3.4758e-06,
                    3.6559e-06,
                    3.8496e-06,
                    4.0683e-06,
                    4.2841e-06,
                    4.5328e-06,
                    4.7763e-06,
                    5.0383e-06,
                    5.3076e-06,
                    5.5918e-06,
                    5.9009e-06,
                    6.2282e-06,
                    6.5574e-06,
                    6.9167e-06,
                    7.2814e-06,
                    7.6431e-06,
                    8.0317e-06,
                    8.4518e-06,
                    8.8865e-06,
                    9.3447e-06,
                    9.8347e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    6.633e-07,
                    1.3513e-06,
                    2.0658e-06,
                    2.8017e-06,
                    3.5557e-06,
                    4.3247e-06,
                    5.1067e-06,
                    5.9037e-06,
                    6.7155e-06,
                    7.5372e-06,
                    8.3705e-06,
                    9.2152e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CO2": 0.02,
                "Land_CO2_timeseries": [
                    3.5194e-08,
                    7.0934e-08,
                    1.0718e-07,
                    1.4388e-07,
                    1.8098e-07,
                    2.1843e-07,
                    2.562e-07,
                    2.9424e-07,
                    3.3257e-07,
                    3.717e-07,
                    4.1177e-07,
                    4.5269e-07,
                    4.9434e-07,
                    5.3663e-07,
                    5.795e-07,
                    6.229e-07,
                    6.6675e-07,
                    7.1102e-07,
                    7.5574e-07,
                    8.0205e-07,
                    8.5073e-07,
                    9.0153e-07,
                    9.541e-07,
                    1.0081e-06,
                    1.0635e-06,
                    1.12e-06,
                    1.1775e-06,
                    1.236e-06,
                    1.2953e-06,
                    1.3543e-06,
                    1.4146e-06,
                    1.476e-06,
                    1.5385e-06,
                    1.6019e-06,
                    1.6662e-06,
                    1.7313e-06,
                    1.7971e-06,
                    1.8635e-06,
                    1.9306e-06,
                    1.9997e-06,
                    2.0723e-06,
                    2.1481e-06,
                    2.2271e-06,
                    2.3094e-06,
                    2.3955e-06,
                    2.4859e-06,
                    2.5814e-06,
                    2.6827e-06,
                    2.7904e-06,
                    2.9066e-06,
                    3.0375e-06,
                    3.1772e-06,
                    3.3178e-06,
                    3.4758e-06,
                    3.6559e-06,
                    3.8496e-06,
                    4.0683e-06,
                    4.2841e-06,
                    4.5328e-06,
                    4.7763e-06,
                    5.0383e-06,
                    5.3076e-06,
                    5.5918e-06,
                    5.9009e-06,
                    6.2282e-06,
                    6.5574e-06,
                    6.9167e-06,
                    7.2814e-06,
                    7.6431e-06,
                    8.0317e-06,
                    8.4518e-06,
                    8.8865e-06,
                    9.3447e-06,
                    9.8347e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_CH4": 0.02,
                "Total_CH4_timeseries": [
                    4.1097e-08,
                    8.2732e-08,
                    1.2491e-07,
                    1.6764e-07,
                    2.1094e-07,
                    2.548e-07,
                    2.9923e-07,
                    3.4426e-07,
                    3.8987e-07,
                    4.3608e-07,
                    4.8409e-07,
                    5.339e-07,
                    5.8552e-07,
                    6.3896e-07,
                    6.9423e-07,
                    7.5134e-07,
                    8.103e-07,
                    8.7111e-07,
                    9.3379e-07,
                    9.9834e-07,
                    1.0657e-06,
                    1.1358e-06,
                    1.2087e-06,
                    1.2843e-06,
                    1.3628e-06,
                    1.444e-06,
                    1.5281e-06,
                    1.6149e-06,
                    1.7046e-06,
                    1.797e-06,
                    1.8922e-06,
                    1.9901e-06,
                    2.0907e-06,
                    2.1941e-06,
                    2.3002e-06,
                    2.4091e-06,
                    2.5208e-06,
                    2.6351e-06,
                    2.7523e-06,
                    2.8725e-06,
                    2.9963e-06,
                    3.1239e-06,
                    3.255e-06,
                    3.3898e-06,
                    3.5283e-06,
                    3.67e-06,
                    3.8149e-06,
                    3.9631e-06,
                    4.1144e-06,
                    4.2689e-06,
                    4.4293e-06,
                    4.5956e-06,
                    4.768e-06,
                    4.9463e-06,
                    5.1316e-06,
                    5.3241e-06,
                    5.5238e-06,
                    5.7308e-06,
                    5.9452e-06,
                    6.1668e-06,
                    6.4037e-06,
                    6.6561e-06,
                    6.924e-06,
                    7.2076e-06,
                    7.507e-06,
                    7.8226e-06,
                    8.1547e-06,
                    8.5034e-06,
                    8.8688e-06,
                    9.251e-06,
                    9.656e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_CH4": 0.01,
                "Fossil_CH4_timeseries": [
                    1.8118e-08,
                    3.6323e-08,
                    5.4622e-08,
                    7.3023e-08,
                    9.1534e-08,
                    1.1016e-07,
                    1.2892e-07,
                    1.478e-07,
                    1.6683e-07,
                    1.8601e-07,
                    2.0541e-07,
                    2.2504e-07,
                    2.449e-07,
                    2.6502e-07,
                    2.8538e-07,
                    3.0602e-07,
                    3.2692e-07,
                    3.4811e-07,
                    3.6959e-07,
                    3.9137e-07,
                    4.1369e-07,
                    4.3656e-07,
                    4.5998e-07,
                    4.8395e-07,
                    5.0848e-07,
                    5.3356e-07,
                    5.592e-07,
                    5.8541e-07,
                    6.1218e-07,
                    6.3952e-07,
                    6.6742e-07,
                    6.9589e-07,
                    7.2493e-07,
                    7.5454e-07,
                    7.8472e-07,
                    8.1548e-07,
                    8.4683e-07,
                    8.7875e-07,
                    9.1127e-07,
                    9.4468e-07,
                    9.7884e-07,
                    1.0138e-06,
                    1.0495e-06,
                    1.0859e-06,
                    1.1231e-06,
                    1.1607e-06,
                    1.1985e-06,
                    1.2367e-06,
                    1.2752e-06,
                    1.3139e-06,
                    1.3548e-06,
                    1.3977e-06,
                    1.4427e-06,
                    1.4898e-06,
                    1.5402e-06,
                    1.5938e-06,
                    1.6507e-06,
                    1.7111e-06,
                    1.7751e-06,
                    1.8424e-06,
                    1.9144e-06,
                    1.9913e-06,
                    2.0732e-06,
                    2.1601e-06,
                    2.2523e-06,
                    2.3501e-06,
                    2.4538e-06,
                    2.5635e-06,
                    2.6793e-06,
                    2.8014e-06,
                    2.9294e-06,
                    3.0612e-06,
                    3.1969e-06,
                    3.3364e-06,
                    3.4788e-06,
                    3.624e-06,
                    3.7721e-06,
                    3.9229e-06,
                    4.0764e-06,
                    4.2325e-06,
                    4.392e-06,
                    4.5546e-06,
                    4.7205e-06,
                    4.8894e-06,
                    5.0614e-06,
                    5.2364e-06,
                    5.4166e-06,
                    5.602e-06,
                    5.7927e-06,
                    5.9887e-06,
                    6.1852e-06,
                    6.3842e-06,
                    6.586e-06,
                    6.7906e-06,
                    7.0028e-06,
                    7.2227e-06,
                    7.4503e-06,
                    7.6856e-06,
                    7.9287e-06,
                    8.1795e-06,
                    8.4308e-06,
                    8.6825e-06,
                    8.9345e-06,
                    9.1866e-06,
                    9.4388e-06,
                    9.6909e-06,
                    9.9405e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CH4": 0.03,
                "Land_CH4_timeseries": [
                    2.2979e-08,
                    4.641e-08,
                    7.029e-08,
                    9.4621e-08,
                    1.194e-07,
                    1.4464e-07,
                    1.7032e-07,
                    1.9645e-07,
                    2.2304e-07,
                    2.5007e-07,
                    2.7868e-07,
                    3.0886e-07,
                    3.4062e-07,
                    3.7395e-07,
                    4.0885e-07,
                    4.4533e-07,
                    4.8338e-07,
                    5.23e-07,
                    5.642e-07,
                    6.0697e-07,
                    6.5197e-07,
                    6.9921e-07,
                    7.4868e-07,
                    8.0038e-07,
                    8.5432e-07,
                    9.1048e-07,
                    9.6888e-07,
                    1.0295e-06,
                    1.0924e-06,
                    1.1575e-06,
                    1.2247e-06,
                    1.2942e-06,
                    1.3658e-06,
                    1.4396e-06,
                    1.5155e-06,
                    1.5936e-06,
                    1.6739e-06,
                    1.7564e-06,
                    1.841e-06,
                    1.9278e-06,
                    2.0175e-06,
                    2.1101e-06,
                    2.2056e-06,
                    2.3039e-06,
                    2.4052e-06,
                    2.5094e-06,
                    2.6164e-06,
                    2.7264e-06,
                    2.8392e-06,
                    2.9549e-06,
                    3.0745e-06,
                    3.198e-06,
                    3.3253e-06,
                    3.4564e-06,
                    3.5914e-06,
                    3.7303e-06,
                    3.8731e-06,
                    4.0196e-06,
                    4.1701e-06,
                    4.3244e-06,
                    4.4893e-06,
                    4.6648e-06,
                    4.8508e-06,
                    5.0475e-06,
                    5.2547e-06,
                    5.4725e-06,
                    5.7009e-06,
                    5.9399e-06,
                    6.1895e-06,
                    6.4496e-06,
                    6.7266e-06,
                    7.0204e-06,
                    7.3311e-06,
                    7.6586e-06,
                    8.0029e-06,
                    8.3641e-06,
                    8.7421e-06,
                    9.1369e-06,
                    9.5485e-06,
                    9.977e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_N2O": 0.03,
                "Total_N2O_timeseries": [
                    1.3297e-08,
                    2.6844e-08,
                    4.0632e-08,
                    5.4645e-08,
                    6.8866e-08,
                    8.3274e-08,
                    9.7842e-08,
                    1.1254e-07,
                    1.2734e-07,
                    1.422e-07,
                    1.571e-07,
                    1.7203e-07,
                    1.8699e-07,
                    2.0197e-07,
                    2.1698e-07,
                    2.3201e-07,
                    2.4707e-07,
                    2.6215e-07,
                    2.7727e-07,
                    2.9243e-07,
                    3.0782e-07,
                    3.238e-07,
                    3.4061e-07,
                    3.5844e-07,
                    3.774e-07,
                    3.9751e-07,
                    4.1872e-07,
                    4.4088e-07,
                    4.638e-07,
                    4.8719e-07,
                    5.1084e-07,
                    5.3472e-07,
                    5.588e-07,
                    5.8304e-07,
                    6.0744e-07,
                    6.3199e-07,
                    6.5668e-07,
                    6.8152e-07,
                    7.0654e-07,
                    7.3291e-07,
                    7.5959e-07,
                    7.8658e-07,
                    8.139e-07,
                    8.4158e-07,
                    8.6961e-07,
                    8.9802e-07,
                    9.2682e-07,
                    9.5603e-07,
                    9.8564e-07,
                    1.0157e-06,
                    1.0462e-06,
                    1.0771e-06,
                    1.1084e-06,
                    1.1403e-06,
                    1.1727e-06,
                    1.2055e-06,
                    1.2389e-06,
                    1.2729e-06,
                    1.3076e-06,
                    1.3428e-06,
                    1.379e-06,
                    1.4164e-06,
                    1.4553e-06,
                    1.496e-06,
                    1.5387e-06,
                    1.5835e-06,
                    1.6304e-06,
                    1.6794e-06,
                    1.7304e-06,
                    1.7833e-06,
                    1.8381e-06,
                    1.895e-06,
                    1.9542e-06,
                    2.0156e-06,
                    2.0792e-06,
                    2.145e-06,
                    2.2125e-06,
                    2.2815e-06,
                    2.3515e-06,
                    2.4221e-06,
                    2.4926e-06,
                    2.5628e-06,
                    2.6324e-06,
                    2.7012e-06,
                    2.7692e-06,
                    2.8363e-06,
                    2.9028e-06,
                    2.9687e-06,
                    3.0346e-06,
                    3.1007e-06,
                    3.1727e-06,
                    3.2596e-06,
                    3.3686e-06,
                    3.5041e-06,
                    3.6685e-06,
                    3.8619e-06,
                    4.0822e-06,
                    4.3249e-06,
                    4.5833e-06,
                    4.8484e-06,
                    5.1124e-06,
                    5.3707e-06,
                    5.6201e-06,
                    5.8582e-06,
                    6.0841e-06,
                    6.2977e-06,
                    6.5e-06,
                    6.6934e-06,
                    6.8812e-06,
                    7.0677e-06,
                    7.2778e-06,
                    7.5033e-06,
                    7.7196e-06,
                    7.9264e-06,
                    8.162e-06,
                    8.3696e-06,
                    8.6062e-06,
                    8.8379e-06,
                    9.0889e-06,
                    9.3703e-06,
                    9.641e-06,
                    9.9042e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_N2O": 0.02,
                "Fossil_N2O_timeseries": [
                    2.8556e-09,
                    5.7523e-09,
                    8.6891e-09,
                    1.1664e-08,
                    1.4676e-08,
                    1.7722e-08,
                    2.08e-08,
                    2.3906e-08,
                    2.7037e-08,
                    3.0188e-08,
                    3.3357e-08,
                    3.6544e-08,
                    3.9748e-08,
                    4.2968e-08,
                    4.6205e-08,
                    4.9458e-08,
                    5.2728e-08,
                    5.6015e-08,
                    5.932e-08,
                    6.2643e-08,
                    6.6006e-08,
                    6.9445e-08,
                    7.2991e-08,
                    7.6661e-08,
                    8.0467e-08,
                    8.4413e-08,
                    8.8492e-08,
                    9.269e-08,
                    9.6983e-08,
                    1.0134e-07,
                    1.0574e-07,
                    1.1018e-07,
                    1.1466e-07,
                    1.1917e-07,
                    1.237e-07,
                    1.2827e-07,
                    1.3287e-07,
                    1.375e-07,
                    1.4216e-07,
                    1.4711e-07,
                    1.5216e-07,
                    1.5731e-07,
                    1.6258e-07,
                    1.6795e-07,
                    1.7345e-07,
                    1.7908e-07,
                    1.8484e-07,
                    1.9073e-07,
                    1.9676e-07,
                    2.0294e-07,
                    2.0928e-07,
                    2.158e-07,
                    2.2252e-07,
                    2.2945e-07,
                    2.3658e-07,
                    2.4393e-07,
                    2.5148e-07,
                    2.5921e-07,
                    2.6711e-07,
                    2.7515e-07,
                    2.8331e-07,
                    2.9158e-07,
                    2.9995e-07,
                    3.0841e-07,
                    3.1696e-07,
                    3.2561e-07,
                    3.3434e-07,
                    3.4316e-07,
                    3.5207e-07,
                    3.6109e-07,
                    3.7021e-07,
                    3.7943e-07,
                    3.8874e-07,
                    3.9815e-07,
                    4.0766e-07,
                    4.1728e-07,
                    4.2701e-07,
                    4.3686e-07,
                    4.4685e-07,
                    4.5698e-07,
                    4.6731e-07,
                    4.779e-07,
                    4.8882e-07,
                    5.001e-07,
                    5.118e-07,
                    5.2394e-07,
                    5.3654e-07,
                    5.4961e-07,
                    5.6314e-07,
                    5.7712e-07,
                    5.9159e-07,
                    6.0658e-07,
                    6.2214e-07,
                    6.3832e-07,
                    6.5515e-07,
                    6.7263e-07,
                    6.908e-07,
                    7.0965e-07,
                    7.2917e-07,
                    7.4936e-07,
                    7.7027e-07,
                    7.9202e-07,
                    8.1467e-07,
                    8.3829e-07,
                    8.629e-07,
                    8.8847e-07,
                    9.1498e-07,
                    9.4235e-07,
                    9.7048e-07,
                    9.9925e-07,
                    1.0285e-06,
                    1.0583e-06,
                    1.0885e-06,
                    1.1192e-06,
                    1.1503e-06,
                    1.1821e-06,
                    1.2146e-06,
                    1.248e-06,
                    1.2823e-06,
                    1.3189e-06,
                    1.356e-06,
                    1.3936e-06,
                    1.4311e-06,
                    1.4696e-06,
                    1.5096e-06,
                    1.5507e-06,
                    1.5934e-06,
                    1.6368e-06,
                    1.6812e-06,
                    1.7265e-06,
                    1.7731e-06,
                    1.821e-06,
                    1.8719e-06,
                    1.9225e-06,
                    1.9746e-06,
                    2.0274e-06,
                    2.0814e-06,
                    2.135e-06,
                    2.1901e-06,
                    2.2458e-06,
                    2.3022e-06,
                    2.3583e-06,
                    2.4145e-06,
                    2.4715e-06,
                    2.5295e-06,
                    2.5879e-06,
                    2.6465e-06,
                    2.7055e-06,
                    2.7675e-06,
                    2.832e-06,
                    2.8968e-06,
                    2.9621e-06,
                    3.028e-06,
                    3.0953e-06,
                    3.1639e-06,
                    3.2336e-06,
                    3.3056e-06,
                    3.3775e-06,
                    3.451e-06,
                    3.5233e-06,
                    3.5947e-06,
                    3.6654e-06,
                    3.7344e-06,
                    3.8019e-06,
                    3.8671e-06,
                    3.9305e-06,
                    3.993e-06,
                    4.0541e-06,
                    4.1162e-06,
                    4.1787e-06,
                    4.2413e-06,
                    4.3037e-06
                ],
                "Land_N2O": 0.03,
                "Land_N2O_timeseries": [
                    1.0442e-08,
                    2.1092e-08,
                    3.1942e-08,
                    4.298e-08,
                    5.419e-08,
                    6.5551e-08,
                    7.7042e-08,
                    8.8637e-08,
                    1.0031e-07,
                    1.1201e-07,
                    1.2374e-07,
                    1.3549e-07,
                    1.4724e-07,
                    1.59e-07,
                    1.7077e-07,
                    1.8255e-07,
                    1.9434e-07,
                    2.0613e-07,
                    2.1795e-07,
                    2.2978e-07,
                    2.4182e-07,
                    2.5435e-07,
                    2.6762e-07,
                    2.8178e-07,
                    2.9694e-07,
                    3.131e-07,
                    3.3022e-07,
                    3.4819e-07,
                    3.6682e-07,
                    3.8585e-07,
                    4.051e-07,
                    4.2454e-07,
                    4.4414e-07,
                    4.6388e-07,
                    4.8374e-07,
                    5.0372e-07,
                    5.2381e-07,
                    5.4402e-07,
                    5.6438e-07,
                    5.858e-07,
                    6.0743e-07,
                    6.2927e-07,
                    6.5133e-07,
                    6.7362e-07,
                    6.9616e-07,
                    7.1894e-07,
                    7.4199e-07,
                    7.653e-07,
                    7.8888e-07,
                    8.1274e-07,
                    8.3687e-07,
                    8.6127e-07,
                    8.8593e-07,
                    9.1086e-07,
                    9.3607e-07,
                    9.6159e-07,
                    9.8746e-07,
                    1.0137e-06,
                    1.0404e-06,
                    1.0677e-06,
                    1.0956e-06,
                    1.1248e-06,
                    1.1553e-06,
                    1.1876e-06,
                    1.2218e-06,
                    1.2579e-06,
                    1.2961e-06,
                    1.3363e-06,
                    1.3784e-06,
                    1.4222e-06,
                    1.4679e-06,
                    1.5156e-06,
                    1.5654e-06,
                    1.6174e-06,
                    1.6716e-06,
                    1.7277e-06,
                    1.7855e-06,
                    1.8446e-06,
                    1.9047e-06,
                    1.9651e-06,
                    2.0253e-06,
                    2.0849e-06,
                    2.1436e-06,
                    2.2011e-06,
                    2.2574e-06,
                    2.3124e-06,
                    2.3662e-06,
                    2.4191e-06,
                    2.4715e-06,
                    2.5236e-06,
                    2.5811e-06,
                    2.6531e-06,
                    2.7464e-06,
                    2.8657e-06,
                    3.0133e-06,
                    3.1893e-06,
                    3.3914e-06,
                    3.6153e-06,
                    3.8542e-06,
                    4.0991e-06,
                    4.3421e-06,
                    4.5787e-06,
                    4.8054e-06,
                    5.0199e-06,
                    5.2212e-06,
                    5.4092e-06,
                    5.5851e-06,
                    5.7511e-06,
                    5.9107e-06,
                    6.0685e-06,
                    6.2493e-06,
                    6.445e-06,
                    6.6312e-06,
                    6.8072e-06,
                    7.0116e-06,
                    7.1875e-06,
                    7.3916e-06,
                    7.5899e-06,
                    7.8065e-06,
                    8.0515e-06,
                    8.285e-06,
                    8.5107e-06,
                    8.7352e-06,
                    8.9698e-06,
                    9.2045e-06,
                    9.4327e-06,
                    9.6379e-06,
                    9.8436e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            27.02982,
                            -29.61713
                        ],
                        [
                            27.03006,
                            -29.64694
                        ],
                        [
                            27.12345,
                            -29.7558
                        ],
                        [
                            27.23696,
                            -30.00296
                        ],
                        [
                            27.31194,
                            -30.06864
                        ],
                        [
                            27.33572,
                            -30.1503
                        ],
                        [
                            27.40229,
                            -30.14197
                        ],
                        [
                            27.37481,
                            -30.26947
                        ],
                        [
                            27.40892,
                            -30.33133
                        ],
                        [
                            27.46328,
                            -30.3118
                        ],
                        [
                            27.51437,
                            -30.37677
                        ],
                        [
                            27.57104,
                            -30.40091
                        ],
                        [
                            27.62065,
                            -30.48271
                        ],
                        [
                            27.68767,
                            -30.52117
                        ],
                        [
                            27.75024,
                            -30.59423
                        ],
                        [
                            27.86482,
                            -30.61102
                        ],
                        [
                            27.92922,
                            -30.64164
                        ],
                        [
                            28.08932,
                            -30.64974
                        ],
                        [
                            28.16077,
                            -30.56134
                        ],
                        [
                            28.18549,
                            -30.49316
                        ],
                        [
                            28.16104,
                            -30.45257
                        ],
                        [
                            28.24111,
                            -30.41051
                        ],
                        [
                            28.27922,
                            -30.3623
                        ],
                        [
                            28.22438,
                            -30.29824
                        ],
                        [
                            28.31645,
                            -30.25237
                        ],
                        [
                            28.3744,
                            -30.16575
                        ],
                        [
                            28.47498,
                            -30.15637
                        ],
                        [
                            28.55732,
                            -30.11845
                        ],
                        [
                            28.68225,
                            -30.13805
                        ],
                        [
                            28.84893,
                            -30.09421
                        ],
                        [
                            29.04978,
                            -29.98928
                        ],
                        [
                            29.17426,
                            -29.91286
                        ],
                        [
                            29.1353,
                            -29.8539
                        ],
                        [
                            29.15002,
                            -29.72029
                        ],
                        [
                            29.18473,
                            -29.66518
                        ],
                        [
                            29.29986,
                            -29.62349
                        ],
                        [
                            29.30485,
                            -29.49594
                        ],
                        [
                            29.42706,
                            -29.43169
                        ],
                        [
                            29.46537,
                            -29.3514
                        ],
                        [
                            29.39156,
                            -29.19501
                        ],
                        [
                            29.32277,
                            -29.08425
                        ],
                        [
                            29.26114,
                            -29.08835
                        ],
                        [
                            29.2243,
                            -29.03604
                        ],
                        [
                            28.9991,
                            -28.91249
                        ],
                        [
                            28.91535,
                            -28.79514
                        ],
                        [
                            28.82994,
                            -28.75763
                        ],
                        [
                            28.80834,
                            -28.70353
                        ],
                        [
                            28.7376,
                            -28.68746
                        ],
                        [
                            28.70473,
                            -28.6102
                        ],
                        [
                            28.6534,
                            -28.57244
                        ],
                        [
                            28.58563,
                            -28.60281
                        ],
                        [
                            28.41393,
                            -28.6194
                        ],
                        [
                            28.3632,
                            -28.69777
                        ],
                        [
                            28.29205,
                            -28.70729
                        ],
                        [
                            28.19364,
                            -28.69072
                        ],
                        [
                            28.12259,
                            -28.74244
                        ],
                        [
                            28.03916,
                            -28.8724
                        ],
                        [
                            27.94388,
                            -28.85187
                        ],
                        [
                            27.87468,
                            -28.9143
                        ],
                        [
                            27.77339,
                            -28.92095
                        ],
                        [
                            27.68379,
                            -29.02619
                        ],
                        [
                            27.68122,
                            -29.07565
                        ],
                        [
                            27.62298,
                            -29.15088
                        ],
                        [
                            27.53039,
                            -29.21617
                        ],
                        [
                            27.54475,
                            -29.25488
                        ],
                        [
                            27.45027,
                            -29.3299
                        ],
                        [
                            27.43075,
                            -29.40464
                        ],
                        [
                            27.3679,
                            -29.4771
                        ],
                        [
                            27.25333,
                            -29.54793
                        ],
                        [
                            27.16344,
                            -29.55619
                        ],
                        [
                            27.0719,
                            -29.62444
                        ],
                        [
                            27.02982,
                            -29.61713
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "LBR",
                "Country": "Liberia",
                "Total_3GHG": 0.04,
                "Total_3GHG_timeseries": [
                    4.1399e-06,
                    8.9721e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007
                ],
                "Fossil_3GHG": 0.01,
                "Fossil_3GHG_timeseries": [
                    2.1605e-08,
                    4.8264e-08,
                    8.0169e-08,
                    1.1752e-07,
                    1.6051e-07,
                    2.0937e-07,
                    2.6431e-07,
                    3.2556e-07,
                    3.9335e-07,
                    4.6794e-07,
                    5.4968e-07,
                    6.3884e-07,
                    9.689e-07,
                    1.307e-06,
                    1.6534e-06,
                    2.0085e-06,
                    2.3726e-06,
                    2.7761e-06,
                    3.1805e-06,
                    3.5846e-06,
                    3.9882e-06,
                    4.3912e-06,
                    4.7936e-06,
                    5.1951e-06,
                    5.5957e-06,
                    6.0101e-06,
                    6.4392e-06,
                    6.8841e-06,
                    7.346e-06,
                    7.826e-06,
                    8.3015e-06,
                    8.7721e-06,
                    9.0191e-06,
                    9.2606e-06,
                    9.5156e-06,
                    9.7849e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_3GHG": 0.09,
                "Land_3GHG_timeseries": [
                    4.1183e-06,
                    8.9238e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Total_CO2": 0.05,
                "Total_CO2_timeseries": [
                    4.1098e-06,
                    8.9069e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2.145e-08,
                    4.125e-08,
                    6.6e-08,
                    9.24e-08,
                    1.386e-07,
                    1.65e-07,
                    1.8645e-07,
                    2.244e-07,
                    2.97e-07,
                    3.6135e-07,
                    4.356e-07,
                    5.082e-07,
                    6.2205e-07,
                    7.821e-07,
                    9.999e-07,
                    1.2507e-06,
                    1.5262e-06,
                    1.8018e-06,
                    2.1994e-06,
                    2.7718e-06,
                    3.425e-06,
                    4.1113e-06,
                    4.7892e-06,
                    5.4557e-06,
                    6.231e-06,
                    6.8991e-06,
                    7.5636e-06,
                    8.2262e-06,
                    8.9031e-06,
                    9.7776e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CO2": 0.15,
                "Land_CO2_timeseries": [
                    4.1098e-06,
                    8.9069e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Total_CH4": 0.03,
                "Total_CH4_timeseries": [
                    2.5439e-08,
                    5.5919e-08,
                    9.163e-08,
                    1.3277e-07,
                    1.7955e-07,
                    2.3218e-07,
                    2.9087e-07,
                    3.5588e-07,
                    4.2742e-07,
                    5.0575e-07,
                    5.9132e-07,
                    6.8438e-07,
                    1.0184e-06,
                    1.3606e-06,
                    1.7111e-06,
                    2.0704e-06,
                    2.4388e-06,
                    2.8467e-06,
                    3.2555e-06,
                    3.6641e-06,
                    4.0723e-06,
                    4.4799e-06,
                    4.8869e-06,
                    5.2931e-06,
                    5.6984e-06,
                    6.1174e-06,
                    6.5512e-06,
                    7.0009e-06,
                    7.4675e-06,
                    7.9523e-06,
                    8.4326e-06,
                    8.908e-06,
                    9.1597e-06,
                    9.406e-06,
                    9.6659e-06,
                    9.94e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_CH4": 0.04,
                "Fossil_CH4_timeseries": [
                    2.0458e-08,
                    4.5953e-08,
                    7.6674e-08,
                    1.1282e-07,
                    1.546e-07,
                    2.0223e-07,
                    2.5592e-07,
                    3.1591e-07,
                    3.8244e-07,
                    4.5575e-07,
                    5.3622e-07,
                    6.241e-07,
                    9.5287e-07,
                    1.2897e-06,
                    1.6348e-06,
                    1.9886e-06,
                    2.3513e-06,
                    2.7536e-06,
                    3.1567e-06,
                    3.5594e-06,
                    3.9617e-06,
                    4.3633e-06,
                    4.7642e-06,
                    5.1643e-06,
                    5.5633e-06,
                    5.976e-06,
                    6.4034e-06,
                    6.8465e-06,
                    7.3066e-06,
                    7.7847e-06,
                    8.2583e-06,
                    8.727e-06,
                    8.9721e-06,
                    9.2116e-06,
                    9.4647e-06,
                    9.7321e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CH4": 0.01,
                "Land_CH4_timeseries": [
                    4.9811e-09,
                    9.9664e-09,
                    1.4956e-08,
                    1.995e-08,
                    2.4947e-08,
                    2.9949e-08,
                    3.4956e-08,
                    3.9966e-08,
                    4.4981e-08,
                    4.9999e-08,
                    5.5099e-08,
                    6.0281e-08,
                    6.5544e-08,
                    7.0888e-08,
                    7.6314e-08,
                    8.1821e-08,
                    8.741e-08,
                    9.308e-08,
                    9.8831e-08,
                    1.0466e-07,
                    1.1058e-07,
                    1.1658e-07,
                    1.2266e-07,
                    1.2883e-07,
                    1.3508e-07,
                    1.4142e-07,
                    1.4784e-07,
                    1.5434e-07,
                    1.6092e-07,
                    1.6759e-07,
                    1.7428e-07,
                    1.8097e-07,
                    1.8768e-07,
                    1.9441e-07,
                    2.0114e-07,
                    2.0789e-07,
                    2.1466e-07,
                    2.2144e-07,
                    2.2823e-07,
                    2.3503e-07,
                    2.4185e-07,
                    2.4869e-07,
                    2.5553e-07,
                    2.624e-07,
                    2.6927e-07,
                    2.7616e-07,
                    2.8306e-07,
                    2.8998e-07,
                    2.9691e-07,
                    3.0385e-07,
                    3.1119e-07,
                    3.1892e-07,
                    3.2705e-07,
                    3.3557e-07,
                    3.4449e-07,
                    3.538e-07,
                    3.635e-07,
                    3.736e-07,
                    3.8409e-07,
                    3.9497e-07,
                    4.0753e-07,
                    4.2176e-07,
                    4.3766e-07,
                    4.5524e-07,
                    4.7448e-07,
                    4.954e-07,
                    5.1799e-07,
                    5.4225e-07,
                    5.6818e-07,
                    5.9578e-07,
                    6.2498e-07,
                    6.5578e-07,
                    6.8818e-07,
                    7.2217e-07,
                    7.5776e-07,
                    7.9495e-07,
                    8.3374e-07,
                    8.7412e-07,
                    9.161e-07,
                    9.5968e-07,
                    1.004e-06,
                    1.0491e-06,
                    1.0948e-06,
                    1.1414e-06,
                    1.1887e-06,
                    1.2413e-06,
                    1.2995e-06,
                    1.3634e-06,
                    1.4332e-06,
                    1.5091e-06,
                    1.5914e-06,
                    1.6805e-06,
                    1.7764e-06,
                    1.8794e-06,
                    1.9897e-06,
                    2.1075e-06,
                    2.233e-06,
                    2.3665e-06,
                    2.508e-06,
                    2.6579e-06,
                    2.8152e-06,
                    2.9806e-06,
                    3.1546e-06,
                    3.3379e-06,
                    3.5311e-06,
                    3.7305e-06,
                    3.9365e-06,
                    4.1496e-06,
                    4.3703e-06,
                    4.5989e-06,
                    4.8054e-06,
                    5.0163e-06,
                    5.2456e-06,
                    5.4835e-06,
                    5.7195e-06,
                    5.8611e-06,
                    6e-06,
                    6.1396e-06,
                    6.2793e-06,
                    6.4286e-06,
                    6.5749e-06,
                    6.719e-06,
                    6.8836e-06,
                    7.0053e-06,
                    7.1266e-06,
                    7.2541e-06,
                    7.412e-06,
                    7.5161e-06,
                    7.6336e-06,
                    7.7927e-06,
                    7.9362e-06,
                    8.1097e-06,
                    8.2668e-06,
                    8.4034e-06,
                    8.5119e-06,
                    8.7072e-06,
                    8.9107e-06,
                    9.0874e-06,
                    9.2811e-06,
                    9.2948e-06,
                    9.2488e-06,
                    9.2011e-06,
                    9.0795e-06,
                    8.9769e-06,
                    8.8677e-06,
                    8.7302e-06,
                    8.5962e-06,
                    8.5201e-06,
                    8.4125e-06,
                    8.247e-06,
                    8.0993e-06,
                    7.9046e-06,
                    7.7262e-06,
                    7.5451e-06,
                    7.3722e-06,
                    7.2333e-06,
                    7.1134e-06,
                    7.0364e-06,
                    7.2122e-06,
                    7.3433e-06,
                    7.5288e-06,
                    7.7187e-06,
                    7.9256e-06,
                    8.2171e-06,
                    8.6346e-06,
                    8.9277e-06,
                    9.1317e-06,
                    9.3134e-06,
                    9.5731e-06,
                    9.7746e-06,
                    9.9831e-06,
                    0
                ],
                "Total_N2O": 0.01,
                "Total_N2O_timeseries": [
                    4.5744e-09,
                    9.2362e-09,
                    1.3982e-08,
                    1.8806e-08,
                    2.3703e-08,
                    2.8665e-08,
                    3.3682e-08,
                    3.8745e-08,
                    4.3841e-08,
                    4.8958e-08,
                    5.4086e-08,
                    5.9225e-08,
                    6.4372e-08,
                    6.9526e-08,
                    7.4687e-08,
                    7.9855e-08,
                    8.503e-08,
                    9.0214e-08,
                    9.5409e-08,
                    1.0062e-07,
                    1.0591e-07,
                    1.114e-07,
                    1.1719e-07,
                    1.2334e-07,
                    1.299e-07,
                    1.3685e-07,
                    1.442e-07,
                    1.5189e-07,
                    1.5984e-07,
                    1.6796e-07,
                    1.7617e-07,
                    1.8446e-07,
                    1.9282e-07,
                    2.0124e-07,
                    2.0971e-07,
                    2.1823e-07,
                    2.268e-07,
                    2.3542e-07,
                    2.441e-07,
                    2.5326e-07,
                    2.6253e-07,
                    2.7191e-07,
                    2.8142e-07,
                    2.9105e-07,
                    3.0081e-07,
                    3.1071e-07,
                    3.2075e-07,
                    3.3094e-07,
                    3.4127e-07,
                    3.5177e-07,
                    3.6243e-07,
                    3.7325e-07,
                    3.8426e-07,
                    3.9544e-07,
                    4.0681e-07,
                    4.1839e-07,
                    4.3017e-07,
                    4.4216e-07,
                    4.5438e-07,
                    4.6684e-07,
                    4.7959e-07,
                    4.9278e-07,
                    5.0649e-07,
                    5.2081e-07,
                    5.3578e-07,
                    5.5145e-07,
                    5.6784e-07,
                    5.8493e-07,
                    6.0269e-07,
                    6.2108e-07,
                    6.4011e-07,
                    6.5986e-07,
                    6.8036e-07,
                    7.0162e-07,
                    7.2363e-07,
                    7.4633e-07,
                    7.6965e-07,
                    7.9347e-07,
                    8.1765e-07,
                    8.4201e-07,
                    8.6639e-07,
                    8.9067e-07,
                    9.1477e-07,
                    9.3862e-07,
                    9.6221e-07,
                    9.8555e-07,
                    1.0087e-06,
                    1.0317e-06,
                    1.0546e-06,
                    1.0777e-06,
                    1.1028e-06,
                    1.1328e-06,
                    1.1702e-06,
                    1.2163e-06,
                    1.2721e-06,
                    1.3376e-06,
                    1.412e-06,
                    1.4938e-06,
                    1.581e-06,
                    1.6704e-06,
                    1.7596e-06,
                    1.8471e-06,
                    1.9317e-06,
                    2.0127e-06,
                    2.0899e-06,
                    2.1631e-06,
                    2.2327e-06,
                    2.2995e-06,
                    2.3646e-06,
                    2.4293e-06,
                    2.4999e-06,
                    2.5722e-06,
                    2.6474e-06,
                    2.725e-06,
                    2.8041e-06,
                    2.8813e-06,
                    2.9605e-06,
                    3.0406e-06,
                    3.1232e-06,
                    3.214e-06,
                    3.3048e-06,
                    3.3994e-06,
                    3.4994e-06,
                    3.5873e-06,
                    3.6828e-06,
                    3.7846e-06,
                    3.9015e-06,
                    4.0068e-06,
                    4.1256e-06,
                    4.2519e-06,
                    4.3681e-06,
                    4.4956e-06,
                    4.6197e-06,
                    4.7455e-06,
                    4.8676e-06,
                    4.9966e-06,
                    5.1312e-06,
                    5.2673e-06,
                    5.4038e-06,
                    5.5132e-06,
                    5.6137e-06,
                    5.7107e-06,
                    5.8006e-06,
                    5.8888e-06,
                    5.9788e-06,
                    6.067e-06,
                    6.163e-06,
                    6.2662e-06,
                    6.3761e-06,
                    6.4942e-06,
                    6.6141e-06,
                    6.7403e-06,
                    6.8748e-06,
                    7.0073e-06,
                    7.1437e-06,
                    7.2989e-06,
                    7.4564e-06,
                    7.6263e-06,
                    7.8524e-06,
                    8.0505e-06,
                    8.247e-06,
                    8.4608e-06,
                    8.6748e-06,
                    8.9084e-06,
                    9.1677e-06,
                    9.4057e-06,
                    9.6471e-06,
                    9.8917e-06,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_N2O": 0.02,
                "Fossil_N2O_timeseries": [
                    1.1464e-09,
                    2.3115e-09,
                    3.4949e-09,
                    4.6955e-09,
                    5.9124e-09,
                    7.144e-09,
                    8.3888e-09,
                    9.645e-09,
                    1.091e-08,
                    1.2183e-08,
                    1.3461e-08,
                    1.4743e-08,
                    1.6031e-08,
                    1.7323e-08,
                    1.862e-08,
                    1.9922e-08,
                    2.1228e-08,
                    2.2539e-08,
                    2.3855e-08,
                    2.5176e-08,
                    2.6516e-08,
                    2.7895e-08,
                    2.933e-08,
                    3.0833e-08,
                    3.2409e-08,
                    3.4061e-08,
                    3.5785e-08,
                    3.7573e-08,
                    3.9412e-08,
                    4.1282e-08,
                    4.3173e-08,
                    4.5081e-08,
                    4.7004e-08,
                    4.8941e-08,
                    5.0891e-08,
                    5.2853e-08,
                    5.4827e-08,
                    5.6814e-08,
                    5.8815e-08,
                    6.0941e-08,
                    6.3108e-08,
                    6.532e-08,
                    6.758e-08,
                    6.9891e-08,
                    7.2254e-08,
                    7.4672e-08,
                    7.7147e-08,
                    7.9683e-08,
                    8.2281e-08,
                    8.4943e-08,
                    8.7677e-08,
                    9.0493e-08,
                    9.3399e-08,
                    9.6399e-08,
                    9.9496e-08,
                    1.0269e-07,
                    1.0598e-07,
                    1.0935e-07,
                    1.128e-07,
                    1.1631e-07,
                    1.1989e-07,
                    1.2351e-07,
                    1.2718e-07,
                    1.309e-07,
                    1.3467e-07,
                    1.3847e-07,
                    1.4232e-07,
                    1.4622e-07,
                    1.5016e-07,
                    1.5415e-07,
                    1.5819e-07,
                    1.6228e-07,
                    1.6642e-07,
                    1.706e-07,
                    1.7484e-07,
                    1.7912e-07,
                    1.8346e-07,
                    1.8786e-07,
                    1.9232e-07,
                    1.9685e-07,
                    2.0146e-07,
                    2.0618e-07,
                    2.1102e-07,
                    2.1599e-07,
                    2.2111e-07,
                    2.2639e-07,
                    2.3183e-07,
                    2.3745e-07,
                    2.4325e-07,
                    2.4922e-07,
                    2.5538e-07,
                    2.618e-07,
                    2.6849e-07,
                    2.7549e-07,
                    2.8283e-07,
                    2.9051e-07,
                    2.9854e-07,
                    3.0692e-07,
                    3.1564e-07,
                    3.2469e-07,
                    3.3408e-07,
                    3.4385e-07,
                    3.5403e-07,
                    3.6464e-07,
                    3.7569e-07,
                    3.8718e-07,
                    3.9909e-07,
                    4.1139e-07,
                    4.2404e-07,
                    4.3699e-07,
                    4.5021e-07,
                    4.6366e-07,
                    4.7736e-07,
                    4.9128e-07,
                    5.0546e-07,
                    5.199e-07,
                    5.3464e-07,
                    5.4971e-07,
                    5.6517e-07,
                    5.8443e-07,
                    6.0433e-07,
                    6.2472e-07,
                    6.4609e-07,
                    6.6584e-07,
                    6.8582e-07,
                    7.0591e-07,
                    7.336e-07,
                    7.6208e-07,
                    7.936e-07,
                    8.267e-07,
                    8.566e-07,
                    8.9226e-07,
                    9.2484e-07,
                    9.6013e-07,
                    9.9397e-07,
                    1.0337e-06,
                    1.0734e-06,
                    1.1178e-06,
                    1.1631e-06,
                    1.2087e-06,
                    1.2517e-06,
                    1.2909e-06,
                    1.3269e-06,
                    1.3623e-06,
                    1.399e-06,
                    1.438e-06,
                    1.4806e-06,
                    1.528e-06,
                    1.5827e-06,
                    1.6444e-06,
                    1.7084e-06,
                    1.7749e-06,
                    1.8442e-06,
                    1.9174e-06,
                    1.9957e-06,
                    2.0781e-06,
                    2.1628e-06,
                    2.2502e-06,
                    2.3413e-06,
                    2.4384e-06,
                    2.5396e-06,
                    2.6463e-06,
                    2.7556e-06,
                    2.8709e-06,
                    2.9902e-06,
                    3.1163e-06,
                    3.2461e-06,
                    3.38e-06,
                    3.5191e-06,
                    3.6634e-06,
                    3.8117e-06,
                    3.9614e-06
                ],
                "Land_N2O": 0.01,
                "Land_N2O_timeseries": [
                    3.4281e-09,
                    6.9247e-09,
                    1.0487e-08,
                    1.4111e-08,
                    1.7791e-08,
                    2.1521e-08,
                    2.5293e-08,
                    2.91e-08,
                    3.2931e-08,
                    3.6775e-08,
                    4.0626e-08,
                    4.4481e-08,
                    4.8341e-08,
                    5.2202e-08,
                    5.6066e-08,
                    5.9933e-08,
                    6.3802e-08,
                    6.7675e-08,
                    7.1554e-08,
                    7.5439e-08,
                    7.939e-08,
                    8.3505e-08,
                    8.7861e-08,
                    9.2512e-08,
                    9.7486e-08,
                    1.0279e-07,
                    1.0841e-07,
                    1.1431e-07,
                    1.2043e-07,
                    1.2668e-07,
                    1.33e-07,
                    1.3938e-07,
                    1.4581e-07,
                    1.5229e-07,
                    1.5881e-07,
                    1.6537e-07,
                    1.7197e-07,
                    1.7861e-07,
                    1.8529e-07,
                    1.9232e-07,
                    1.9942e-07,
                    2.0659e-07,
                    2.1384e-07,
                    2.2116e-07,
                    2.2855e-07,
                    2.3603e-07,
                    2.436e-07,
                    2.5125e-07,
                    2.5899e-07,
                    2.6683e-07,
                    2.7475e-07,
                    2.8276e-07,
                    2.9086e-07,
                    2.9904e-07,
                    3.0732e-07,
                    3.157e-07,
                    3.2419e-07,
                    3.3281e-07,
                    3.4158e-07,
                    3.5052e-07,
                    3.5971e-07,
                    3.6927e-07,
                    3.7931e-07,
                    3.899e-07,
                    4.0112e-07,
                    4.1298e-07,
                    4.2551e-07,
                    4.3871e-07,
                    4.5253e-07,
                    4.6693e-07,
                    4.8192e-07,
                    4.9757e-07,
                    5.1394e-07,
                    5.3102e-07,
                    5.4879e-07,
                    5.6721e-07,
                    5.8619e-07,
                    6.0561e-07,
                    6.2532e-07,
                    6.4516e-07,
                    6.6493e-07,
                    6.8449e-07,
                    7.0375e-07,
                    7.2264e-07,
                    7.4111e-07,
                    7.5916e-07,
                    7.7685e-07,
                    7.9422e-07,
                    8.1139e-07,
                    8.2851e-07,
                    8.4738e-07,
                    8.7102e-07,
                    9.0167e-07,
                    9.4084e-07,
                    9.893e-07,
                    1.0471e-06,
                    1.1134e-06,
                    1.1869e-06,
                    1.2653e-06,
                    1.3458e-06,
                    1.4255e-06,
                    1.5032e-06,
                    1.5776e-06,
                    1.6481e-06,
                    1.7142e-06,
                    1.7759e-06,
                    1.8336e-06,
                    1.8881e-06,
                    1.9405e-06,
                    1.9923e-06,
                    2.0497e-06,
                    2.1086e-06,
                    2.1701e-06,
                    2.2337e-06,
                    2.2986e-06,
                    2.3614e-06,
                    2.4259e-06,
                    2.4909e-06,
                    2.5581e-06,
                    2.6296e-06,
                    2.7004e-06,
                    2.7747e-06,
                    2.8533e-06,
                    2.9214e-06,
                    2.9969e-06,
                    3.0787e-06,
                    3.1679e-06,
                    3.2447e-06,
                    3.332e-06,
                    3.4252e-06,
                    3.5115e-06,
                    3.6034e-06,
                    3.6948e-06,
                    3.7853e-06,
                    3.8736e-06,
                    3.9628e-06,
                    4.0579e-06,
                    4.1495e-06,
                    4.2407e-06,
                    4.3044e-06,
                    4.3619e-06,
                    4.4198e-06,
                    4.4737e-06,
                    4.5265e-06,
                    4.5798e-06,
                    4.629e-06,
                    4.6824e-06,
                    4.7382e-06,
                    4.7934e-06,
                    4.8499e-06,
                    4.9057e-06,
                    4.9654e-06,
                    5.0306e-06,
                    5.0899e-06,
                    5.148e-06,
                    5.2208e-06,
                    5.2936e-06,
                    5.3761e-06,
                    5.5112e-06,
                    5.6121e-06,
                    5.7073e-06,
                    5.8145e-06,
                    5.9193e-06,
                    6.0375e-06,
                    6.1775e-06,
                    6.2895e-06,
                    6.401e-06,
                    6.5117e-06,
                    6.6378e-06,
                    6.7541e-06,
                    6.8561e-06,
                    6.9606e-06
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -8.47218,
                            7.55459
                        ],
                        [
                            -8.56397,
                            7.62499
                        ],
                        [
                            -8.56043,
                            7.69196
                        ],
                        [
                            -8.65686,
                            7.69596
                        ],
                        [
                            -8.7067,
                            7.63876
                        ],
                        [
                            -8.7223,
                            7.55186
                        ],
                        [
                            -8.70849,
                            7.50996
                        ],
                        [
                            -8.84577,
                            7.34356
                        ],
                        [
                            -8.83348,
                            7.28377
                        ],
                        [
                            -9.01688,
                            7.24359
                        ],
                        [
                            -9.06589,
                            7.20106
                        ],
                        [
                            -9.12077,
                            7.27647
                        ],
                        [
                            -9.20084,
                            7.32097
                        ],
                        [
                            -9.20343,
                            7.38084
                        ],
                        [
                            -9.27555,
                            7.38037
                        ],
                        [
                            -9.35068,
                            7.42836
                        ],
                        [
                            -9.39487,
                            7.38909
                        ],
                        [
                            -9.4185,
                            7.47281
                        ],
                        [
                            -9.35542,
                            7.626
                        ],
                        [
                            -9.36762,
                            7.69686
                        ],
                        [
                            -9.34481,
                            7.74807
                        ],
                        [
                            -9.42323,
                            7.86285
                        ],
                        [
                            -9.43052,
                            8.02445
                        ],
                        [
                            -9.46365,
                            8.16478
                        ],
                        [
                            -9.51546,
                            8.17681
                        ],
                        [
                            -9.5159,
                            8.24244
                        ],
                        [
                            -9.48873,
                            8.38097
                        ],
                        [
                            -9.53496,
                            8.38463
                        ],
                        [
                            -9.66725,
                            8.49176
                        ],
                        [
                            -9.7048,
                            8.47979
                        ],
                        [
                            -9.77801,
                            8.54839
                        ],
                        [
                            -9.80371,
                            8.50327
                        ],
                        [
                            -9.93368,
                            8.49176
                        ],
                        [
                            -9.99577,
                            8.44102
                        ],
                        [
                            -10.06717,
                            8.42979
                        ],
                        [
                            -10.05251,
                            8.49181
                        ],
                        [
                            -10.0867,
                            8.51755
                        ],
                        [
                            -10.1647,
                            8.51484
                        ],
                        [
                            -10.21323,
                            8.48102
                        ],
                        [
                            -10.28204,
                            8.48795
                        ],
                        [
                            -10.27215,
                            8.44242
                        ],
                        [
                            -10.3024,
                            8.29651
                        ],
                        [
                            -10.29581,
                            8.22307
                        ],
                        [
                            -10.35281,
                            8.15065
                        ],
                        [
                            -10.46321,
                            8.15617
                        ],
                        [
                            -10.52602,
                            8.12618
                        ],
                        [
                            -10.60486,
                            8.03662
                        ],
                        [
                            -10.60581,
                            7.77498
                        ],
                        [
                            -10.69873,
                            7.73628
                        ],
                        [
                            -10.79127,
                            7.59895
                        ],
                        [
                            -10.92005,
                            7.49876
                        ],
                        [
                            -10.93689,
                            7.50962
                        ],
                        [
                            -11.05973,
                            7.40298
                        ],
                        [
                            -11.10149,
                            7.38808
                        ],
                        [
                            -11.18495,
                            7.26261
                        ],
                        [
                            -11.30835,
                            7.20971
                        ],
                        [
                            -11.35035,
                            7.13952
                        ],
                        [
                            -11.3713,
                            7.01814
                        ],
                        [
                            -11.46102,
                            6.92358
                        ],
                        [
                            -11.49748,
                            6.92344
                        ],
                        [
                            -11.39644,
                            6.84672
                        ],
                        [
                            -11.36523,
                            6.78604
                        ],
                        [
                            -11.36112,
                            6.70732
                        ],
                        [
                            -11.00637,
                            6.55141
                        ],
                        [
                            -10.86082,
                            6.45793
                        ],
                        [
                            -10.79354,
                            6.36095
                        ],
                        [
                            -10.81592,
                            6.31106
                        ],
                        [
                            -10.69368,
                            6.23314
                        ],
                        [
                            -10.49533,
                            6.17905
                        ],
                        [
                            -10.38841,
                            6.13922
                        ],
                        [
                            -10.35735,
                            6.10261
                        ],
                        [
                            -10.21788,
                            6.03274
                        ],
                        [
                            -10.19268,
                            5.98607
                        ],
                        [
                            -10.07976,
                            5.92196
                        ],
                        [
                            -10.00521,
                            5.8097
                        ],
                        [
                            -9.86709,
                            5.70262
                        ],
                        [
                            -9.77723,
                            5.60256
                        ],
                        [
                            -9.59431,
                            5.47522
                        ],
                        [
                            -9.59191,
                            5.43237
                        ],
                        [
                            -9.49637,
                            5.3797
                        ],
                        [
                            -9.48816,
                            5.34195
                        ],
                        [
                            -9.37283,
                            5.22517
                        ],
                        [
                            -9.29227,
                            5.17847
                        ],
                        [
                            -9.29346,
                            5.14906
                        ],
                        [
                            -9.20832,
                            5.11106
                        ],
                        [
                            -9.04379,
                            5.00889
                        ],
                        [
                            -9.04006,
                            4.98436
                        ],
                        [
                            -8.87969,
                            4.93287
                        ],
                        [
                            -8.78891,
                            4.85136
                        ],
                        [
                            -8.71488,
                            4.80795
                        ],
                        [
                            -8.61648,
                            4.77932
                        ],
                        [
                            -8.51403,
                            4.73028
                        ],
                        [
                            -8.4478,
                            4.67322
                        ],
                        [
                            -8.32302,
                            4.62882
                        ],
                        [
                            -8.24694,
                            4.57171
                        ],
                        [
                            -7.95335,
                            4.50973
                        ],
                        [
                            -7.83802,
                            4.45871
                        ],
                        [
                            -7.82429,
                            4.41924
                        ],
                        [
                            -7.72124,
                            4.37167
                        ],
                        [
                            -7.61237,
                            4.35576
                        ],
                        [
                            -7.52313,
                            4.36173
                        ],
                        [
                            -7.56045,
                            4.46825
                        ],
                        [
                            -7.54701,
                            4.60882
                        ],
                        [
                            -7.56238,
                            4.76806
                        ],
                        [
                            -7.59172,
                            4.82006
                        ],
                        [
                            -7.58399,
                            4.90987
                        ],
                        [
                            -7.52545,
                            4.92846
                        ],
                        [
                            -7.55531,
                            5.06923
                        ],
                        [
                            -7.5011,
                            5.09642
                        ],
                        [
                            -7.47122,
                            5.1506
                        ],
                        [
                            -7.47101,
                            5.26649
                        ],
                        [
                            -7.36577,
                            5.32733
                        ],
                        [
                            -7.42063,
                            5.37753
                        ],
                        [
                            -7.42127,
                            5.47726
                        ],
                        [
                            -7.38082,
                            5.52938
                        ],
                        [
                            -7.37956,
                            5.62384
                        ],
                        [
                            -7.44042,
                            5.75266
                        ],
                        [
                            -7.42333,
                            5.84276
                        ],
                        [
                            -7.51975,
                            5.85791
                        ],
                        [
                            -7.57596,
                            5.89737
                        ],
                        [
                            -7.68283,
                            5.90099
                        ],
                        [
                            -7.78584,
                            5.98239
                        ],
                        [
                            -7.78734,
                            6.07239
                        ],
                        [
                            -7.84811,
                            6.0956
                        ],
                        [
                            -7.83235,
                            6.15997
                        ],
                        [
                            -7.85307,
                            6.22819
                        ],
                        [
                            -7.90148,
                            6.27887
                        ],
                        [
                            -8.00618,
                            6.31466
                        ],
                        [
                            -8.16911,
                            6.27541
                        ],
                        [
                            -8.38464,
                            6.37865
                        ],
                        [
                            -8.40418,
                            6.43089
                        ],
                        [
                            -8.47091,
                            6.43466
                        ],
                        [
                            -8.54125,
                            6.49169
                        ],
                        [
                            -8.58559,
                            6.49672
                        ],
                        [
                            -8.50175,
                            6.61266
                        ],
                        [
                            -8.44985,
                            6.63715
                        ],
                        [
                            -8.40504,
                            6.70563
                        ],
                        [
                            -8.34004,
                            6.75934
                        ],
                        [
                            -8.30764,
                            6.84969
                        ],
                        [
                            -8.32302,
                            6.96155
                        ],
                        [
                            -8.28671,
                            6.98643
                        ],
                        [
                            -8.29936,
                            7.08529
                        ],
                        [
                            -8.28992,
                            7.18214
                        ],
                        [
                            -8.36009,
                            7.24263
                        ],
                        [
                            -8.38596,
                            7.3195
                        ],
                        [
                            -8.41414,
                            7.49378
                        ],
                        [
                            -8.47218,
                            7.55459
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "LBY",
                "Country": "Libya",
                "Total_3GHG": 0.17,
                "Total_3GHG_timeseries": [
                    5.5222e-08,
                    1.1075e-07,
                    1.6654e-07,
                    2.2257e-07,
                    2.7881e-07,
                    3.3526e-07,
                    3.9151e-07,
                    4.4671e-07,
                    5.0061e-07,
                    5.5288e-07,
                    6.0457e-07,
                    6.5579e-07,
                    7.0654e-07,
                    7.5682e-07,
                    8.0661e-07,
                    8.559e-07,
                    9.0466e-07,
                    9.5284e-07,
                    1.0004e-06,
                    1.048e-06,
                    1.0954e-06,
                    1.143e-06,
                    1.191e-06,
                    1.2394e-06,
                    1.2883e-06,
                    1.3378e-06,
                    1.3876e-06,
                    1.4377e-06,
                    1.4876e-06,
                    1.5508e-06,
                    1.617e-06,
                    1.6833e-06,
                    1.7483e-06,
                    1.8112e-06,
                    1.8716e-06,
                    1.9294e-06,
                    1.9845e-06,
                    2.0366e-06,
                    2.0859e-06,
                    2.1613e-06,
                    2.2509e-06,
                    2.3489e-06,
                    2.4524e-06,
                    2.5603e-06,
                    2.6723e-06,
                    2.789e-06,
                    2.9125e-06,
                    3.046e-06,
                    3.1945e-06,
                    3.3337e-06,
                    3.4828e-06,
                    3.6556e-06,
                    3.8603e-06,
                    4.1037e-06,
                    4.3891e-06,
                    4.7186e-06,
                    5.0944e-06,
                    5.516e-06,
                    5.9834e-06,
                    6.4814e-06,
                    7.0099e-06,
                    7.571e-06,
                    8.1674e-06,
                    8.7992e-06,
                    9.464e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0009,
                    0.001,
                    0.0013,
                    0.0015,
                    0.0016,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0028,
                    0.0027,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0026,
                    0.0027,
                    0.0027
                ],
                "Fossil_3GHG": 0.25,
                "Fossil_3GHG_timeseries": [
                    2.3729e-08,
                    4.7587e-08,
                    7.1572e-08,
                    9.5679e-08,
                    1.199e-07,
                    1.4423e-07,
                    1.6867e-07,
                    1.932e-07,
                    2.1781e-07,
                    2.4249e-07,
                    2.6747e-07,
                    2.9275e-07,
                    3.1833e-07,
                    3.442e-07,
                    3.7037e-07,
                    3.9684e-07,
                    4.2361e-07,
                    4.5067e-07,
                    4.7804e-07,
                    5.057e-07,
                    5.3373e-07,
                    5.6224e-07,
                    5.9131e-07,
                    6.2099e-07,
                    6.5131e-07,
                    6.8229e-07,
                    7.139e-07,
                    7.4611e-07,
                    7.7885e-07,
                    8.1202e-07,
                    8.4536e-07,
                    8.7885e-07,
                    9.1247e-07,
                    9.4622e-07,
                    9.8009e-07,
                    1.0141e-06,
                    1.0482e-06,
                    1.0824e-06,
                    1.1168e-06,
                    1.1514e-06,
                    1.1886e-06,
                    1.2286e-06,
                    1.2712e-06,
                    1.3165e-06,
                    1.3646e-06,
                    1.4153e-06,
                    1.4687e-06,
                    1.5248e-06,
                    1.5837e-06,
                    1.6453e-06,
                    1.7069e-06,
                    1.7686e-06,
                    1.8304e-06,
                    1.8924e-06,
                    1.9543e-06,
                    2.0164e-06,
                    2.0786e-06,
                    2.1408e-06,
                    2.203e-06,
                    2.2653e-06,
                    2.3241e-06,
                    2.3797e-06,
                    2.4336e-06,
                    2.4867e-06,
                    2.539e-06,
                    2.5907e-06,
                    2.6416e-06,
                    2.692e-06,
                    2.7418e-06,
                    2.7911e-06,
                    2.8424e-06,
                    2.8957e-06,
                    2.9511e-06,
                    3.0088e-06,
                    3.0687e-06,
                    3.1309e-06,
                    3.1956e-06,
                    3.2627e-06,
                    3.3324e-06,
                    3.4047e-06,
                    3.4861e-06,
                    3.5766e-06,
                    3.6748e-06,
                    3.78e-06,
                    3.8921e-06,
                    4.0113e-06,
                    4.1376e-06,
                    4.2711e-06,
                    4.4118e-06,
                    4.5598e-06,
                    4.7173e-06,
                    4.8847e-06,
                    5.0625e-06,
                    5.2512e-06,
                    5.4575e-06,
                    5.682e-06,
                    5.9251e-06,
                    6.1871e-06,
                    6.4686e-06,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0007,
                    0.0008,
                    0.0009,
                    0.0012,
                    0.0014,
                    0.0016,
                    0.0017,
                    0.0019,
                    0.002,
                    0.002,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0027,
                    0.0026,
                    0.0026,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0025,
                    0.0026,
                    0.0026
                ],
                "Land_3GHG": 0.02,
                "Land_3GHG_timeseries": [
                    3.1493e-08,
                    6.3161e-08,
                    9.4968e-08,
                    1.2689e-07,
                    1.5891e-07,
                    1.9103e-07,
                    2.2285e-07,
                    2.5351e-07,
                    2.8281e-07,
                    3.1039e-07,
                    3.3711e-07,
                    3.6304e-07,
                    3.8822e-07,
                    4.1262e-07,
                    4.3624e-07,
                    4.5906e-07,
                    4.8105e-07,
                    5.0217e-07,
                    5.2241e-07,
                    5.4227e-07,
                    5.6169e-07,
                    5.8078e-07,
                    5.9967e-07,
                    6.1841e-07,
                    6.3703e-07,
                    6.5549e-07,
                    6.7371e-07,
                    6.9154e-07,
                    7.0877e-07,
                    7.3881e-07,
                    7.7167e-07,
                    8.0445e-07,
                    8.3578e-07,
                    8.6495e-07,
                    8.9155e-07,
                    9.1535e-07,
                    9.3625e-07,
                    9.5416e-07,
                    9.6906e-07,
                    1.0099e-06,
                    1.0623e-06,
                    1.1203e-06,
                    1.1812e-06,
                    1.2438e-06,
                    1.3077e-06,
                    1.3737e-06,
                    1.4437e-06,
                    1.5211e-06,
                    1.6108e-06,
                    1.6884e-06,
                    1.7759e-06,
                    1.8869e-06,
                    2.0299e-06,
                    2.2114e-06,
                    2.4347e-06,
                    2.7022e-06,
                    3.0158e-06,
                    3.3752e-06,
                    3.7804e-06,
                    4.2162e-06,
                    4.6858e-06,
                    5.1913e-06,
                    5.7338e-06,
                    6.3125e-06,
                    6.9249e-06,
                    7.5697e-06,
                    8.2468e-06,
                    8.9538e-06,
                    9.6872e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_CO2": 0.09,
                "Total_CO2_timeseries": [
                    -0.0000000082885,
                    -0.000000016605,
                    -0.000000024976,
                    -0.000000033418,
                    -0.000000041926,
                    -0.000000050501,
                    -0.000000059505,
                    -0.000000069773,
                    -0.000000081505,
                    -0.000000095002,
                    -0.0000001099,
                    -0.00000012609,
                    -0.00000014356,
                    -0.0000001623,
                    -0.00000018235,
                    -0.00000020371,
                    -0.00000022642,
                    -0.0000002505,
                    -0.00000027599,
                    -0.00000030238,
                    -0.00000032991,
                    -0.00000035869,
                    -0.00000038883,
                    -0.00000042039,
                    -0.00000045342,
                    -0.00000048798,
                    -0.00000052412,
                    -0.00000056188,
                    -0.00000060131,
                    -0.00000062879,
                    -0.00000065373,
                    -0.00000067899,
                    -0.00000070591,
                    -0.00000073521,
                    -0.00000076726,
                    -0.00000080229,
                    -0.0000008404,
                    -0.00000088169,
                    -0.00000092619,
                    -0.00000094576,
                    -0.00000095916,
                    -0.00000097229,
                    -0.00000098789,
                    -0.0000010073,
                    -0.0000010307,
                    -0.0000010574,
                    -0.0000010856,
                    -0.0000011118,
                    -0.0000011312,
                    -0.0000011681,
                    -0.0000011977,
                    -0.0000012063,
                    -0.0000011855,
                    -0.0000011287,
                    -0.0000010327,
                    -0.00000089514,
                    -0.00000071402,
                    -0.00000048987,
                    -0.0000002226,
                    7.2506e-08,
                    4.0533e-07,
                    7.7762e-07,
                    1.1902e-06,
                    1.642e-06,
                    2.1306e-06,
                    2.6542e-06,
                    3.2131e-06,
                    3.8047e-06,
                    4.4255e-06,
                    5.0736e-06,
                    5.7487e-06,
                    6.4444e-06,
                    7.1615e-06,
                    7.897e-06,
                    8.6499e-06,
                    9.415e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011
                ],
                "Fossil_CO2": 0.14,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    6.435e-08,
                    1.4025e-07,
                    2.145e-07,
                    3.267e-07,
                    4.62e-07,
                    6.5505e-07,
                    8.0355e-07,
                    9.438e-07,
                    1.1022e-06,
                    1.2969e-06,
                    1.6088e-06,
                    2.1467e-06,
                    2.6186e-06,
                    3.2769e-06,
                    3.5756e-06,
                    4.0326e-06,
                    5.2156e-06,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011
                ],
                "Land_CO2": -0,
                "Land_CO2_timeseries": [
                    -0.0000000082885,
                    -0.000000016605,
                    -0.000000024976,
                    -0.000000033418,
                    -0.000000041926,
                    -0.000000050501,
                    -0.000000059505,
                    -0.000000069773,
                    -0.000000081505,
                    -0.000000095002,
                    -0.0000001099,
                    -0.00000012609,
                    -0.00000014356,
                    -0.0000001623,
                    -0.00000018235,
                    -0.00000020371,
                    -0.00000022642,
                    -0.0000002505,
                    -0.00000027599,
                    -0.00000030238,
                    -0.00000032991,
                    -0.00000035869,
                    -0.00000038883,
                    -0.00000042039,
                    -0.00000045342,
                    -0.00000048798,
                    -0.00000052412,
                    -0.00000056188,
                    -0.00000060131,
                    -0.00000062879,
                    -0.00000065373,
                    -0.00000067899,
                    -0.00000070591,
                    -0.00000073521,
                    -0.00000076726,
                    -0.00000080229,
                    -0.0000008404,
                    -0.00000088169,
                    -0.00000092619,
                    -0.00000094576,
                    -0.00000095916,
                    -0.00000097229,
                    -0.00000098789,
                    -0.0000010073,
                    -0.0000010307,
                    -0.0000010574,
                    -0.0000010856,
                    -0.0000011118,
                    -0.0000011312,
                    -0.0000011681,
                    -0.0000011977,
                    -0.0000012063,
                    -0.0000011855,
                    -0.0000011287,
                    -0.0000010327,
                    -0.00000089514,
                    -0.00000071402,
                    -0.00000048987,
                    -0.0000002226,
                    7.2506e-08,
                    4.0533e-07,
                    7.7762e-07,
                    1.1902e-06,
                    1.642e-06,
                    2.1306e-06,
                    2.6542e-06,
                    3.2131e-06,
                    3.8047e-06,
                    4.4255e-06,
                    5.0736e-06,
                    5.7487e-06,
                    6.4444e-06,
                    7.1615e-06,
                    7.897e-06,
                    8.6499e-06,
                    9.415e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    9.6298e-06,
                    9.1093e-06,
                    8.6742e-06,
                    8.6157e-06,
                    9.2057e-06,
                    9.5147e-06,
                    9.2277e-06,
                    8.8983e-06,
                    8.5273e-06,
                    8.1122e-06,
                    7.6523e-06,
                    7.2869e-06,
                    6.8038e-06,
                    6.3535e-06,
                    5.9076e-06,
                    5.4764e-06,
                    5.0526e-06,
                    4.6951e-06,
                    4.2745e-06,
                    3.8462e-06,
                    3.4438e-06,
                    3.0645e-06,
                    2.674e-06,
                    2.297e-06,
                    1.937e-06,
                    1.5834e-06,
                    1.2354e-06,
                    8.9415e-07,
                    5.6393e-07,
                    2.4187e-07,
                    -0.000000071539,
                    -0.0000003715
                ],
                "Total_CH4": 0.38,
                "Total_CH4_timeseries": [
                    4.5877e-08,
                    9.1786e-08,
                    1.3773e-07,
                    1.837e-07,
                    2.297e-07,
                    2.7573e-07,
                    3.218e-07,
                    3.6789e-07,
                    4.1402e-07,
                    4.6018e-07,
                    5.0708e-07,
                    5.5474e-07,
                    6.0315e-07,
                    6.523e-07,
                    7.022e-07,
                    7.5286e-07,
                    8.0426e-07,
                    8.5641e-07,
                    9.0931e-07,
                    9.6296e-07,
                    1.0174e-06,
                    1.0726e-06,
                    1.1285e-06,
                    1.1852e-06,
                    1.2427e-06,
                    1.301e-06,
                    1.36e-06,
                    1.4198e-06,
                    1.4804e-06,
                    1.5417e-06,
                    1.6032e-06,
                    1.6647e-06,
                    1.7264e-06,
                    1.7882e-06,
                    1.8501e-06,
                    1.9121e-06,
                    1.9742e-06,
                    2.0365e-06,
                    2.0988e-06,
                    2.1613e-06,
                    2.2315e-06,
                    2.3096e-06,
                    2.3953e-06,
                    2.4888e-06,
                    2.5901e-06,
                    2.6992e-06,
                    2.816e-06,
                    2.9405e-06,
                    3.0729e-06,
                    3.2129e-06,
                    3.3552e-06,
                    3.4997e-06,
                    3.6464e-06,
                    3.7953e-06,
                    3.9463e-06,
                    4.0995e-06,
                    4.2548e-06,
                    4.4123e-06,
                    4.5719e-06,
                    4.7336e-06,
                    4.8872e-06,
                    5.0327e-06,
                    5.1718e-06,
                    5.3054e-06,
                    5.4335e-06,
                    5.5561e-06,
                    5.6733e-06,
                    5.7852e-06,
                    5.8918e-06,
                    5.9932e-06,
                    6.0943e-06,
                    6.1951e-06,
                    6.2959e-06,
                    6.3966e-06,
                    6.4973e-06,
                    6.598e-06,
                    6.6989e-06,
                    6.8001e-06,
                    6.9016e-06,
                    7.0035e-06,
                    7.1281e-06,
                    7.2755e-06,
                    7.4443e-06,
                    7.6337e-06,
                    7.8438e-06,
                    8.0935e-06,
                    8.3837e-06,
                    8.7154e-06,
                    9.0896e-06,
                    9.5071e-06,
                    9.9654e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0009,
                    0.0012,
                    0.0014,
                    0.0015,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0026,
                    0.0026,
                    0.0025,
                    0.0024,
                    0.0023,
                    0.0023,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0021,
                    0.0021,
                    0.002,
                    0.002,
                    0.002,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0018,
                    0.0018,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016
                ],
                "Fossil_CH4": 0.59,
                "Fossil_CH4_timeseries": [
                    1.4903e-08,
                    2.9812e-08,
                    4.4725e-08,
                    5.9644e-08,
                    7.4567e-08,
                    8.9496e-08,
                    1.0443e-07,
                    1.1937e-07,
                    1.3431e-07,
                    1.4926e-07,
                    1.6446e-07,
                    1.7989e-07,
                    1.9557e-07,
                    2.1149e-07,
                    2.2766e-07,
                    2.4407e-07,
                    2.6072e-07,
                    2.7761e-07,
                    2.9475e-07,
                    3.1212e-07,
                    3.2975e-07,
                    3.4763e-07,
                    3.6575e-07,
                    3.8412e-07,
                    4.0274e-07,
                    4.2161e-07,
                    4.4073e-07,
                    4.6009e-07,
                    4.797e-07,
                    4.9956e-07,
                    5.1945e-07,
                    5.3936e-07,
                    5.5931e-07,
                    5.7929e-07,
                    5.993e-07,
                    6.1934e-07,
                    6.394e-07,
                    6.595e-07,
                    6.7963e-07,
                    6.9978e-07,
                    7.225e-07,
                    7.4777e-07,
                    7.756e-07,
                    8.0599e-07,
                    8.3894e-07,
                    8.7443e-07,
                    9.1248e-07,
                    9.5309e-07,
                    9.9624e-07,
                    1.0419e-06,
                    1.0875e-06,
                    1.133e-06,
                    1.1783e-06,
                    1.2235e-06,
                    1.2684e-06,
                    1.3133e-06,
                    1.3579e-06,
                    1.4023e-06,
                    1.4465e-06,
                    1.4905e-06,
                    1.5309e-06,
                    1.5677e-06,
                    1.6027e-06,
                    1.6366e-06,
                    1.6696e-06,
                    1.7017e-06,
                    1.7329e-06,
                    1.7632e-06,
                    1.7928e-06,
                    1.8217e-06,
                    1.8523e-06,
                    1.8848e-06,
                    1.9191e-06,
                    1.9554e-06,
                    1.9937e-06,
                    2.0341e-06,
                    2.0767e-06,
                    2.1216e-06,
                    2.1688e-06,
                    2.2184e-06,
                    2.2769e-06,
                    2.3443e-06,
                    2.4191e-06,
                    2.5007e-06,
                    2.589e-06,
                    2.6841e-06,
                    2.786e-06,
                    2.8949e-06,
                    3.0106e-06,
                    3.1333e-06,
                    3.2648e-06,
                    3.4053e-06,
                    3.5548e-06,
                    3.7136e-06,
                    3.8882e-06,
                    4.0792e-06,
                    4.287e-06,
                    4.5122e-06,
                    4.7552e-06,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0007,
                    0.0008,
                    0.0009,
                    0.0012,
                    0.0013,
                    0.0015,
                    0.0016,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0024,
                    0.0023,
                    0.0023,
                    0.0022,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.002,
                    0.002,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0017,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0015,
                    0.0015,
                    0.0015
                ],
                "Land_CH4": 0.04,
                "Land_CH4_timeseries": [
                    3.0974e-08,
                    6.1974e-08,
                    9.3001e-08,
                    1.2405e-07,
                    1.5513e-07,
                    1.8624e-07,
                    2.1737e-07,
                    2.4852e-07,
                    2.797e-07,
                    3.1091e-07,
                    3.4263e-07,
                    3.7485e-07,
                    4.0757e-07,
                    4.4081e-07,
                    4.7455e-07,
                    5.0879e-07,
                    5.4354e-07,
                    5.788e-07,
                    6.1456e-07,
                    6.5083e-07,
                    6.8763e-07,
                    7.2494e-07,
                    7.6277e-07,
                    8.0112e-07,
                    8.3999e-07,
                    8.7938e-07,
                    9.1929e-07,
                    9.5972e-07,
                    1.0007e-06,
                    1.0421e-06,
                    1.0837e-06,
                    1.1253e-06,
                    1.1671e-06,
                    1.2089e-06,
                    1.2508e-06,
                    1.2928e-06,
                    1.3348e-06,
                    1.377e-06,
                    1.4192e-06,
                    1.4615e-06,
                    1.509e-06,
                    1.5618e-06,
                    1.6197e-06,
                    1.6828e-06,
                    1.7512e-06,
                    1.8247e-06,
                    1.9035e-06,
                    1.9875e-06,
                    2.0766e-06,
                    2.171e-06,
                    2.2677e-06,
                    2.3667e-06,
                    2.4681e-06,
                    2.5718e-06,
                    2.6779e-06,
                    2.7862e-06,
                    2.8969e-06,
                    3.01e-06,
                    3.1254e-06,
                    3.2431e-06,
                    3.3563e-06,
                    3.465e-06,
                    3.5691e-06,
                    3.6687e-06,
                    3.7638e-06,
                    3.8544e-06,
                    3.9405e-06,
                    4.022e-06,
                    4.099e-06,
                    4.1715e-06,
                    4.242e-06,
                    4.3104e-06,
                    4.3768e-06,
                    4.4412e-06,
                    4.5036e-06,
                    4.5639e-06,
                    4.6222e-06,
                    4.6785e-06,
                    4.7328e-06,
                    4.785e-06,
                    4.8512e-06,
                    4.9312e-06,
                    5.0252e-06,
                    5.1331e-06,
                    5.2548e-06,
                    5.4094e-06,
                    5.5977e-06,
                    5.8206e-06,
                    6.079e-06,
                    6.3738e-06,
                    6.7006e-06,
                    7.0601e-06,
                    7.4528e-06,
                    7.8795e-06,
                    8.3406e-06,
                    8.8369e-06,
                    9.369e-06,
                    9.9374e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_N2O": 0.05,
                "Total_N2O_timeseries": [
                    1.7633e-08,
                    3.5567e-08,
                    5.379e-08,
                    7.2288e-08,
                    9.1043e-08,
                    1.1003e-07,
                    1.2922e-07,
                    1.4859e-07,
                    1.681e-07,
                    1.877e-07,
                    2.0739e-07,
                    2.2714e-07,
                    2.4695e-07,
                    2.6683e-07,
                    2.8676e-07,
                    3.0676e-07,
                    3.2681e-07,
                    3.4693e-07,
                    3.6713e-07,
                    3.8739e-07,
                    4.0795e-07,
                    4.2916e-07,
                    4.5129e-07,
                    4.7455e-07,
                    4.9903e-07,
                    5.2477e-07,
                    5.5172e-07,
                    5.7972e-07,
                    6.0856e-07,
                    6.3792e-07,
                    6.6761e-07,
                    6.9757e-07,
                    7.2778e-07,
                    7.582e-07,
                    7.8882e-07,
                    8.1963e-07,
                    8.5063e-07,
                    8.8182e-07,
                    9.1323e-07,
                    9.4572e-07,
                    9.785e-07,
                    1.0116e-06,
                    1.045e-06,
                    1.0787e-06,
                    1.1128e-06,
                    1.1473e-06,
                    1.1821e-06,
                    1.2173e-06,
                    1.2529e-06,
                    1.2889e-06,
                    1.3253e-06,
                    1.3621e-06,
                    1.3994e-06,
                    1.4372e-06,
                    1.4755e-06,
                    1.5143e-06,
                    1.5536e-06,
                    1.5936e-06,
                    1.6341e-06,
                    1.6753e-06,
                    1.7174e-06,
                    1.7607e-06,
                    1.8054e-06,
                    1.8518e-06,
                    1.8999e-06,
                    1.95e-06,
                    2.002e-06,
                    2.0559e-06,
                    2.1116e-06,
                    2.169e-06,
                    2.2282e-06,
                    2.2893e-06,
                    2.3525e-06,
                    2.4177e-06,
                    2.4849e-06,
                    2.5541e-06,
                    2.6249e-06,
                    2.697e-06,
                    2.7702e-06,
                    2.8438e-06,
                    2.9176e-06,
                    2.991e-06,
                    3.0638e-06,
                    3.1359e-06,
                    3.2072e-06,
                    3.2777e-06,
                    3.3474e-06,
                    3.4167e-06,
                    3.4858e-06,
                    3.5551e-06,
                    3.6295e-06,
                    3.7172e-06,
                    3.8243e-06,
                    3.9549e-06,
                    4.111e-06,
                    4.2929e-06,
                    4.4987e-06,
                    4.7244e-06,
                    4.9643e-06,
                    5.2104e-06,
                    5.4558e-06,
                    5.6966e-06,
                    5.9299e-06,
                    6.1537e-06,
                    6.3669e-06,
                    6.5697e-06,
                    6.763e-06,
                    6.9489e-06,
                    7.1301e-06,
                    7.3108e-06,
                    7.5265e-06,
                    7.7481e-06,
                    7.974e-06,
                    8.206e-06,
                    8.4459e-06,
                    8.6919e-06,
                    8.9495e-06,
                    9.2068e-06,
                    9.4659e-06,
                    9.7539e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_N2O": 0.06,
                "Fossil_N2O_timeseries": [
                    8.8257e-09,
                    1.7776e-08,
                    2.6847e-08,
                    3.6035e-08,
                    4.5335e-08,
                    5.4738e-08,
                    6.4239e-08,
                    7.3827e-08,
                    8.3492e-08,
                    9.3222e-08,
                    1.0301e-07,
                    1.1286e-07,
                    1.2275e-07,
                    1.3271e-07,
                    1.4272e-07,
                    1.5278e-07,
                    1.6289e-07,
                    1.7306e-07,
                    1.8329e-07,
                    1.9358e-07,
                    2.0398e-07,
                    2.1462e-07,
                    2.2556e-07,
                    2.3686e-07,
                    2.4857e-07,
                    2.6068e-07,
                    2.7318e-07,
                    2.8602e-07,
                    2.9915e-07,
                    3.1247e-07,
                    3.2591e-07,
                    3.3948e-07,
                    3.5315e-07,
                    3.6693e-07,
                    3.8079e-07,
                    3.9475e-07,
                    4.088e-07,
                    4.2294e-07,
                    4.3719e-07,
                    4.516e-07,
                    4.6614e-07,
                    4.8081e-07,
                    4.9562e-07,
                    5.1056e-07,
                    5.2563e-07,
                    5.4086e-07,
                    5.5623e-07,
                    5.7176e-07,
                    5.8746e-07,
                    6.0332e-07,
                    6.1938e-07,
                    6.3565e-07,
                    6.5215e-07,
                    6.689e-07,
                    6.859e-07,
                    7.0317e-07,
                    7.207e-07,
                    7.3848e-07,
                    7.5651e-07,
                    7.7478e-07,
                    7.9326e-07,
                    8.1197e-07,
                    8.3089e-07,
                    8.5003e-07,
                    8.6939e-07,
                    8.8895e-07,
                    9.0873e-07,
                    9.2873e-07,
                    9.4895e-07,
                    9.6938e-07,
                    9.9004e-07,
                    1.0109e-06,
                    1.032e-06,
                    1.0534e-06,
                    1.075e-06,
                    1.0968e-06,
                    1.1188e-06,
                    1.1411e-06,
                    1.1636e-06,
                    1.1863e-06,
                    1.2092e-06,
                    1.2324e-06,
                    1.2557e-06,
                    1.2793e-06,
                    1.3031e-06,
                    1.3272e-06,
                    1.3516e-06,
                    1.3762e-06,
                    1.4012e-06,
                    1.4265e-06,
                    1.4524e-06,
                    1.4794e-06,
                    1.5077e-06,
                    1.5377e-06,
                    1.5693e-06,
                    1.6028e-06,
                    1.6381e-06,
                    1.675e-06,
                    1.7133e-06,
                    1.7529e-06,
                    1.7933e-06,
                    1.8346e-06,
                    1.8766e-06,
                    1.9194e-06,
                    1.9629e-06,
                    2.0071e-06,
                    2.0521e-06,
                    2.0979e-06,
                    2.1445e-06,
                    2.1921e-06,
                    2.2409e-06,
                    2.2911e-06,
                    2.3431e-06,
                    2.397e-06,
                    2.4529e-06,
                    2.5109e-06,
                    2.571e-06,
                    2.6331e-06,
                    2.6971e-06,
                    2.7922e-06,
                    2.864e-06,
                    2.9293e-06,
                    2.999e-06,
                    3.0631e-06,
                    3.1397e-06,
                    3.229e-06,
                    3.3247e-06,
                    3.437e-06,
                    3.5583e-06,
                    3.6799e-06,
                    3.8106e-06,
                    3.9537e-06,
                    4.0948e-06,
                    4.2375e-06,
                    4.3711e-06,
                    4.5135e-06,
                    4.6586e-06,
                    4.8106e-06,
                    4.9591e-06,
                    5.1147e-06,
                    5.271e-06,
                    5.431e-06,
                    5.6072e-06,
                    5.8113e-06,
                    6.033e-06,
                    6.266e-06,
                    6.4911e-06,
                    6.7103e-06,
                    6.9413e-06,
                    7.1853e-06,
                    7.4317e-06,
                    7.6849e-06,
                    7.9472e-06,
                    8.2084e-06,
                    8.4838e-06,
                    8.76e-06,
                    9.0178e-06,
                    9.2962e-06,
                    9.6033e-06,
                    9.9384e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.05,
                "Land_N2O_timeseries": [
                    8.8074e-09,
                    1.7791e-08,
                    2.6943e-08,
                    3.6253e-08,
                    4.5708e-08,
                    5.5292e-08,
                    6.4984e-08,
                    7.4764e-08,
                    8.4606e-08,
                    9.4483e-08,
                    1.0438e-07,
                    1.1428e-07,
                    1.242e-07,
                    1.3412e-07,
                    1.4405e-07,
                    1.5398e-07,
                    1.6392e-07,
                    1.7387e-07,
                    1.8384e-07,
                    1.9382e-07,
                    2.0397e-07,
                    2.1454e-07,
                    2.2573e-07,
                    2.3768e-07,
                    2.5046e-07,
                    2.641e-07,
                    2.7854e-07,
                    2.937e-07,
                    3.0941e-07,
                    3.2546e-07,
                    3.417e-07,
                    3.5809e-07,
                    3.7463e-07,
                    3.9128e-07,
                    4.0803e-07,
                    4.2488e-07,
                    4.4183e-07,
                    4.5888e-07,
                    4.7605e-07,
                    4.9412e-07,
                    5.1236e-07,
                    5.3078e-07,
                    5.4939e-07,
                    5.6819e-07,
                    5.872e-07,
                    6.0642e-07,
                    6.2586e-07,
                    6.4552e-07,
                    6.6541e-07,
                    6.8554e-07,
                    7.0589e-07,
                    7.2647e-07,
                    7.4727e-07,
                    7.683e-07,
                    7.8956e-07,
                    8.1109e-07,
                    8.3292e-07,
                    8.5507e-07,
                    8.776e-07,
                    9.0056e-07,
                    9.2417e-07,
                    9.4873e-07,
                    9.7452e-07,
                    1.0017e-06,
                    1.0306e-06,
                    1.061e-06,
                    1.0932e-06,
                    1.1271e-06,
                    1.1626e-06,
                    1.1996e-06,
                    1.2381e-06,
                    1.2784e-06,
                    1.3204e-06,
                    1.3643e-06,
                    1.41e-06,
                    1.4573e-06,
                    1.506e-06,
                    1.5559e-06,
                    1.6066e-06,
                    1.6575e-06,
                    1.7083e-06,
                    1.7586e-06,
                    1.8081e-06,
                    1.8566e-06,
                    1.9041e-06,
                    1.9505e-06,
                    1.9959e-06,
                    2.0405e-06,
                    2.0846e-06,
                    2.1286e-06,
                    2.1771e-06,
                    2.2378e-06,
                    2.3166e-06,
                    2.4172e-06,
                    2.5417e-06,
                    2.6901e-06,
                    2.8606e-06,
                    3.0495e-06,
                    3.2509e-06,
                    3.4575e-06,
                    3.6625e-06,
                    3.8621e-06,
                    4.0533e-06,
                    4.2343e-06,
                    4.404e-06,
                    4.5626e-06,
                    4.7109e-06,
                    4.851e-06,
                    4.9856e-06,
                    5.1187e-06,
                    5.2856e-06,
                    5.457e-06,
                    5.6309e-06,
                    5.809e-06,
                    5.993e-06,
                    6.181e-06,
                    6.3785e-06,
                    6.5737e-06,
                    6.7688e-06,
                    6.9617e-06,
                    7.1528e-06,
                    7.3466e-06,
                    7.5754e-06,
                    7.8267e-06,
                    8.1512e-06,
                    8.4918e-06,
                    8.7923e-06,
                    9.105e-06,
                    9.4879e-06,
                    9.86e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            25.0,
                            22.0
                        ],
                        [
                            25.0,
                            24.98755
                        ],
                        [
                            25.0,
                            25.52677
                        ],
                        [
                            25.0,
                            27.60221
                        ],
                        [
                            24.99995,
                            27.73058
                        ],
                        [
                            24.99945,
                            29.02699
                        ],
                        [
                            24.99937,
                            29.24849
                        ],
                        [
                            24.88273,
                            29.48202
                        ],
                        [
                            24.85877,
                            29.55062
                        ],
                        [
                            24.89723,
                            29.62494
                        ],
                        [
                            24.81972,
                            29.78884
                        ],
                        [
                            24.81381,
                            29.91587
                        ],
                        [
                            24.75306,
                            30.09587
                        ],
                        [
                            24.69816,
                            30.14895
                        ],
                        [
                            24.78312,
                            30.33132
                        ],
                        [
                            24.83455,
                            30.36909
                        ],
                        [
                            24.92701,
                            30.48283
                        ],
                        [
                            24.95458,
                            30.5967
                        ],
                        [
                            25.01794,
                            30.7774
                        ],
                        [
                            24.87786,
                            31.16919
                        ],
                        [
                            24.88689,
                            31.30286
                        ],
                        [
                            24.86331,
                            31.40735
                        ],
                        [
                            25.06192,
                            31.54172
                        ],
                        [
                            25.09036,
                            31.61968
                        ],
                        [
                            25.14715,
                            31.64969
                        ],
                        [
                            25.11317,
                            31.74626
                        ],
                        [
                            25.02869,
                            31.85246
                        ],
                        [
                            25.04027,
                            31.91965
                        ],
                        [
                            24.97816,
                            31.9694
                        ],
                        [
                            24.8819,
                            31.9787
                        ],
                        [
                            24.76158,
                            32.01648
                        ],
                        [
                            24.6634,
                            32.02038
                        ],
                        [
                            24.54649,
                            31.98142
                        ],
                        [
                            24.49517,
                            31.99297
                        ],
                        [
                            24.09056,
                            32.01202
                        ],
                        [
                            23.97735,
                            32.10306
                        ],
                        [
                            23.88193,
                            32.11712
                        ],
                        [
                            23.77123,
                            32.16516
                        ],
                        [
                            23.66829,
                            32.18114
                        ],
                        [
                            23.42435,
                            32.17393
                        ],
                        [
                            23.36813,
                            32.20302
                        ],
                        [
                            23.25305,
                            32.2058
                        ],
                        [
                            23.21557,
                            32.27243
                        ],
                        [
                            23.09699,
                            32.31789
                        ],
                        [
                            23.08321,
                            32.36402
                        ],
                        [
                            23.15633,
                            32.45304
                        ],
                        [
                            23.10937,
                            32.50763
                        ],
                        [
                            23.12505,
                            32.61555
                        ],
                        [
                            23.02872,
                            32.65418
                        ],
                        [
                            22.91316,
                            32.67179
                        ],
                        [
                            22.81205,
                            32.71598
                        ],
                        [
                            22.49301,
                            32.81224
                        ],
                        [
                            22.37326,
                            32.87177
                        ],
                        [
                            22.19558,
                            32.88073
                        ],
                        [
                            22.14717,
                            32.9371
                        ],
                        [
                            22.05474,
                            32.90727
                        ],
                        [
                            21.92239,
                            32.89474
                        ],
                        [
                            21.71635,
                            32.94034
                        ],
                        [
                            21.62849,
                            32.92505
                        ],
                        [
                            21.50877,
                            32.8362
                        ],
                        [
                            21.35084,
                            32.77435
                        ],
                        [
                            21.11334,
                            32.77059
                        ],
                        [
                            20.94519,
                            32.71461
                        ],
                        [
                            20.88207,
                            32.67479
                        ],
                        [
                            20.67392,
                            32.59291
                        ],
                        [
                            20.56186,
                            32.53745
                        ],
                        [
                            20.36392,
                            32.40739
                        ],
                        [
                            20.21043,
                            32.2835
                        ],
                        [
                            20.05022,
                            32.11919
                        ],
                        [
                            20.03576,
                            32.06375
                        ],
                        [
                            19.94765,
                            31.97289
                        ],
                        [
                            19.95312,
                            31.93148
                        ],
                        [
                            19.92161,
                            31.75992
                        ],
                        [
                            20.01675,
                            31.42295
                        ],
                        [
                            20.08725,
                            31.34053
                        ],
                        [
                            20.14927,
                            31.23771
                        ],
                        [
                            20.17493,
                            31.14859
                        ],
                        [
                            20.15698,
                            31.04436
                        ],
                        [
                            20.04108,
                            30.82814
                        ],
                        [
                            19.91085,
                            30.66693
                        ],
                        [
                            19.78191,
                            30.53543
                        ],
                        [
                            19.68631,
                            30.46284
                        ],
                        [
                            19.379,
                            30.31685
                        ],
                        [
                            19.1851,
                            30.26692
                        ],
                        [
                            19.05592,
                            30.26758
                        ],
                        [
                            18.94373,
                            30.28748
                        ],
                        [
                            18.78946,
                            30.38276
                        ],
                        [
                            18.68447,
                            30.40532
                        ],
                        [
                            18.5713,
                            30.50044
                        ],
                        [
                            18.32103,
                            30.66146
                        ],
                        [
                            18.21968,
                            30.76582
                        ],
                        [
                            17.9139,
                            30.85512
                        ],
                        [
                            17.85535,
                            30.92377
                        ],
                        [
                            17.68948,
                            30.95141
                        ],
                        [
                            17.45967,
                            31.02941
                        ],
                        [
                            17.39123,
                            31.07529
                        ],
                        [
                            17.14394,
                            31.12374
                        ],
                        [
                            17.00074,
                            31.16331
                        ],
                        [
                            16.76341,
                            31.211
                        ],
                        [
                            16.37223,
                            31.21908
                        ],
                        [
                            16.21305,
                            31.23654
                        ],
                        [
                            16.01949,
                            31.2778
                        ],
                        [
                            15.80728,
                            31.36304
                        ],
                        [
                            15.65383,
                            31.4545
                        ],
                        [
                            15.53172,
                            31.59906
                        ],
                        [
                            15.39506,
                            31.85913
                        ],
                        [
                            15.35342,
                            31.9963
                        ],
                        [
                            15.35683,
                            32.16214
                        ],
                        [
                            15.27202,
                            32.31587
                        ],
                        [
                            15.21341,
                            32.37348
                        ],
                        [
                            15.09986,
                            32.4101
                        ],
                        [
                            14.89468,
                            32.43984
                        ],
                        [
                            14.75468,
                            32.43932
                        ],
                        [
                            14.60766,
                            32.49578
                        ],
                        [
                            14.5029,
                            32.50631
                        ],
                        [
                            14.17555,
                            32.71125
                        ],
                        [
                            14.01468,
                            32.72948
                        ],
                        [
                            13.94322,
                            32.77267
                        ],
                        [
                            13.80253,
                            32.80165
                        ],
                        [
                            13.64675,
                            32.78934
                        ],
                        [
                            13.5811,
                            32.79779
                        ],
                        [
                            13.41569,
                            32.8695
                        ],
                        [
                            13.38832,
                            32.89625
                        ],
                        [
                            13.23432,
                            32.91199
                        ],
                        [
                            12.97032,
                            32.82666
                        ],
                        [
                            12.74357,
                            32.79306
                        ],
                        [
                            12.56009,
                            32.79618
                        ],
                        [
                            12.33148,
                            32.82787
                        ],
                        [
                            12.12647,
                            32.91386
                        ],
                        [
                            11.87821,
                            33.05992
                        ],
                        [
                            11.65641,
                            33.09279
                        ],
                        [
                            11.56432,
                            33.16511
                        ],
                        [
                            11.52885,
                            33.07364
                        ],
                        [
                            11.48979,
                            32.89358
                        ],
                        [
                            11.50721,
                            32.84318
                        ],
                        [
                            11.48905,
                            32.66569
                        ],
                        [
                            11.50869,
                            32.61364
                        ],
                        [
                            11.59758,
                            32.52333
                        ],
                        [
                            11.52801,
                            32.40432
                        ],
                        [
                            11.36426,
                            32.32172
                        ],
                        [
                            11.20182,
                            32.27576
                        ],
                        [
                            10.97898,
                            32.18476
                        ],
                        [
                            10.8597,
                            32.11084
                        ],
                        [
                            10.79235,
                            31.99992
                        ],
                        [
                            10.6437,
                            31.97284
                        ],
                        [
                            10.63224,
                            31.86271
                        ],
                        [
                            10.53013,
                            31.7481
                        ],
                        [
                            10.45664,
                            31.72841
                        ],
                        [
                            10.37654,
                            31.73838
                        ],
                        [
                            10.29157,
                            31.68956
                        ],
                        [
                            10.14115,
                            31.49289
                        ],
                        [
                            10.15314,
                            31.39144
                        ],
                        [
                            10.28685,
                            31.0813
                        ],
                        [
                            10.27549,
                            31.02718
                        ],
                        [
                            10.30681,
                            30.90819
                        ],
                        [
                            10.27697,
                            30.82343
                        ],
                        [
                            10.21493,
                            30.71607
                        ],
                        [
                            10.0217,
                            30.50721
                        ],
                        [
                            9.94569,
                            30.39311
                        ],
                        [
                            9.88718,
                            30.34929
                        ],
                        [
                            9.7457,
                            30.31605
                        ],
                        [
                            9.6176,
                            30.25122
                        ],
                        [
                            9.55156,
                            30.24639
                        ],
                        [
                            9.39103,
                            30.16566
                        ],
                        [
                            9.4214,
                            30.03975
                        ],
                        [
                            9.53771,
                            29.90395
                        ],
                        [
                            9.78262,
                            29.42682
                        ],
                        [
                            9.87506,
                            29.02699
                        ],
                        [
                            9.9054,
                            28.76569
                        ],
                        [
                            9.83768,
                            28.28692
                        ],
                        [
                            9.96109,
                            27.88622
                        ],
                        [
                            9.94116,
                            27.73783
                        ],
                        [
                            9.85763,
                            27.50068
                        ],
                        [
                            9.81552,
                            27.4592
                        ],
                        [
                            9.78203,
                            27.27807
                        ],
                        [
                            9.82916,
                            27.15237
                        ],
                        [
                            9.84562,
                            27.02323
                        ],
                        [
                            9.87892,
                            26.91179
                        ],
                        [
                            9.92757,
                            26.86027
                        ],
                        [
                            9.90308,
                            26.74501
                        ],
                        [
                            9.91709,
                            26.64751
                        ],
                        [
                            9.86492,
                            26.52287
                        ],
                        [
                            9.52609,
                            26.38362
                        ],
                        [
                            9.44742,
                            26.24921
                        ],
                        [
                            9.39859,
                            26.20038
                        ],
                        [
                            10.02459,
                            25.33656
                        ],
                        [
                            10.03691,
                            24.96182
                        ],
                        [
                            10.05505,
                            24.83969
                        ],
                        [
                            10.21685,
                            24.75109
                        ],
                        [
                            10.25429,
                            24.60476
                        ],
                        [
                            10.423,
                            24.47883
                        ],
                        [
                            10.48269,
                            24.47923
                        ],
                        [
                            10.71444,
                            24.56611
                        ],
                        [
                            10.96304,
                            24.47478
                        ],
                        [
                            11.13561,
                            24.39056
                        ],
                        [
                            11.4244,
                            24.19974
                        ],
                        [
                            11.60896,
                            24.25957
                        ],
                        [
                            11.9985,
                            23.5127
                        ],
                        [
                            12.43499,
                            23.42203
                        ],
                        [
                            13.18777,
                            23.26074
                        ],
                        [
                            13.39798,
                            23.2175
                        ],
                        [
                            13.54501,
                            23.15684
                        ],
                        [
                            13.68032,
                            23.07229
                        ],
                        [
                            14.18933,
                            22.64455
                        ],
                        [
                            14.70357,
                            22.8742
                        ],
                        [
                            14.99842,
                            22.99718
                        ],
                        [
                            15.99942,
                            23.43883
                        ],
                        [
                            16.80296,
                            23.04559
                        ],
                        [
                            17.58537,
                            22.66071
                        ],
                        [
                            18.38743,
                            22.26503
                        ],
                        [
                            18.97313,
                            21.97539
                        ],
                        [
                            19.64221,
                            21.64617
                        ],
                        [
                            20.34196,
                            21.30133
                        ],
                        [
                            21.20811,
                            20.87531
                        ],
                        [
                            21.98411,
                            20.49427
                        ],
                        [
                            22.47313,
                            20.25366
                        ],
                        [
                            22.85778,
                            20.06389
                        ],
                        [
                            23.46692,
                            19.76342
                        ],
                        [
                            24.0,
                            19.5
                        ],
                        [
                            24.0001,
                            19.99789
                        ],
                        [
                            24.99997,
                            19.99805
                        ],
                        [
                            24.99999,
                            21.30133
                        ],
                        [
                            25.0,
                            22.0
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "LIE",
                "Country": "Liechtenstein",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    4.8048e-09,
                    9.4824e-09,
                    1.4296e-08,
                    1.8718e-08,
                    2.3281e-08,
                    2.7721e-08,
                    3.1939e-08,
                    3.6148e-08,
                    3.9831e-08,
                    4.4017e-08,
                    4.7693e-08,
                    5.146e-08,
                    5.5152e-08,
                    5.8906e-08,
                    6.2431e-08,
                    6.6096e-08,
                    6.9921e-08,
                    7.3659e-08,
                    7.7344e-08,
                    8.1108e-08,
                    8.4763e-08,
                    8.8348e-08,
                    9.213e-08,
                    9.5635e-08,
                    9.9374e-08,
                    1.0313e-07,
                    1.0682e-07,
                    1.1062e-07,
                    1.1405e-07,
                    1.1809e-07,
                    1.2177e-07,
                    1.2555e-07,
                    1.2929e-07,
                    1.3309e-07,
                    1.3673e-07,
                    1.4053e-07,
                    1.4454e-07,
                    1.4855e-07,
                    1.5258e-07,
                    1.5669e-07,
                    1.6092e-07,
                    1.6527e-07,
                    1.6991e-07,
                    1.7442e-07,
                    1.7925e-07,
                    1.8417e-07,
                    1.8908e-07,
                    1.9417e-07,
                    1.9893e-07,
                    2.0429e-07,
                    2.0945e-07,
                    2.1481e-07,
                    2.2031e-07,
                    2.2615e-07,
                    2.3194e-07,
                    2.3788e-07,
                    2.4377e-07,
                    2.4957e-07,
                    2.5551e-07,
                    2.6065e-07,
                    2.6533e-07,
                    2.6953e-07,
                    2.7361e-07,
                    2.7746e-07,
                    2.8119e-07,
                    2.8433e-07,
                    2.8736e-07,
                    2.9019e-07,
                    2.9281e-07,
                    2.951e-07,
                    2.9749e-07,
                    2.9966e-07,
                    3.0157e-07,
                    3.0339e-07,
                    3.0505e-07,
                    3.0651e-07,
                    3.0785e-07,
                    3.0898e-07,
                    3.1008e-07,
                    3.108e-07,
                    3.1196e-07,
                    3.1307e-07,
                    3.1413e-07,
                    3.1493e-07,
                    3.1573e-07,
                    3.1655e-07,
                    3.1729e-07,
                    3.1801e-07,
                    3.1871e-07,
                    3.1953e-07,
                    3.2003e-07,
                    3.2063e-07,
                    3.2129e-07,
                    3.2224e-07,
                    3.2359e-07,
                    3.2554e-07,
                    3.2814e-07,
                    3.313e-07,
                    3.3509e-07,
                    3.396e-07,
                    3.4481e-07,
                    3.5083e-07,
                    3.5747e-07,
                    3.6496e-07,
                    3.7338e-07,
                    3.828e-07,
                    3.9305e-07,
                    4.0458e-07,
                    4.2253e-07,
                    4.3787e-07,
                    4.5434e-07,
                    4.7174e-07,
                    4.9045e-07,
                    5.2724e-07,
                    5.6689e-07,
                    6.0646e-07,
                    6.4653e-07,
                    6.9334e-07,
                    7.4705e-07,
                    8.2493e-07,
                    9.0512e-07,
                    9.8169e-07,
                    1.0724e-06,
                    1.1521e-06,
                    1.2441e-06,
                    1.3359e-06,
                    1.437e-06,
                    1.5382e-06,
                    1.6303e-06,
                    1.7397e-06,
                    1.8434e-06,
                    1.9266e-06,
                    2.0232e-06,
                    2.1226e-06,
                    2.236e-06,
                    2.3599e-06,
                    2.4553e-06,
                    2.5699e-06,
                    2.6872e-06,
                    2.7952e-06,
                    2.905e-06,
                    3.0125e-06,
                    3.1198e-06,
                    3.2191e-06,
                    3.3197e-06,
                    3.4203e-06,
                    3.5238e-06,
                    3.6312e-06,
                    3.7348e-06,
                    3.8335e-06,
                    3.9313e-06,
                    4.0303e-06,
                    4.1307e-06,
                    4.2302e-06,
                    4.3293e-06,
                    4.429e-06,
                    4.5162e-06,
                    4.611e-06,
                    4.6948e-06,
                    4.7721e-06,
                    4.8423e-06,
                    4.9176e-06,
                    4.9988e-06,
                    5.0666e-06,
                    5.1339e-06,
                    5.1957e-06,
                    5.2619e-06,
                    5.3227e-06,
                    5.3876e-06,
                    5.4498e-06,
                    5.5142e-06,
                    5.5812e-06
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    2.3449e-10,
                    4.6711e-10,
                    6.9755e-10,
                    9.2552e-10,
                    1.1507e-09,
                    1.3567e-09,
                    1.5435e-09,
                    1.7111e-09,
                    1.8596e-09,
                    1.9889e-09,
                    2.099e-09,
                    2.2128e-09,
                    2.3299e-09,
                    2.4503e-09,
                    2.5736e-09,
                    2.6997e-09,
                    2.8284e-09,
                    2.9595e-09,
                    3.0932e-09,
                    3.2293e-09,
                    3.3713e-09,
                    3.5205e-09,
                    3.6778e-09,
                    3.8439e-09,
                    4.0304e-09,
                    4.2527e-09,
                    4.5104e-09,
                    4.8029e-09,
                    5.1292e-09,
                    5.4882e-09,
                    5.8394e-09,
                    6.1619e-09,
                    6.4563e-09,
                    6.7234e-09,
                    6.9638e-09,
                    7.2139e-09,
                    7.4737e-09,
                    7.7436e-09,
                    8.0234e-09,
                    8.3201e-09,
                    8.6288e-09,
                    8.9292e-09,
                    9.2217e-09,
                    9.5068e-09,
                    9.7743e-09,
                    1.0025e-08,
                    1.0258e-08,
                    1.0475e-08,
                    1.0676e-08,
                    1.0861e-08,
                    1.1068e-08,
                    1.1389e-08,
                    1.1828e-08,
                    1.2391e-08,
                    1.3083e-08,
                    1.3723e-08,
                    1.4364e-08,
                    1.5007e-08,
                    1.565e-08,
                    1.6444e-08,
                    1.6895e-08,
                    1.746e-08,
                    1.8148e-08,
                    1.8966e-08,
                    1.9922e-08,
                    2.076e-08,
                    2.1635e-08,
                    2.255e-08,
                    2.3505e-08,
                    2.45e-08,
                    2.553e-08,
                    2.6512e-08,
                    2.744e-08,
                    2.8311e-08,
                    2.9118e-08,
                    2.9882e-08,
                    3.0556e-08,
                    3.1146e-08,
                    3.1655e-08,
                    3.1948e-08,
                    3.2632e-08,
                    3.3301e-08,
                    3.3953e-08,
                    3.4585e-08,
                    3.5195e-08,
                    3.5935e-08,
                    3.6658e-08,
                    3.7364e-08,
                    3.8051e-08,
                    3.8718e-08,
                    3.9131e-08,
                    3.9561e-08,
                    4.001e-08,
                    4.0478e-08,
                    4.1181e-08,
                    4.2246e-08,
                    4.3678e-08,
                    4.5485e-08,
                    4.7606e-08,
                    5.0222e-08,
                    5.3058e-08,
                    5.6044e-08,
                    5.9151e-08,
                    6.2346e-08,
                    6.5853e-08,
                    6.9517e-08,
                    7.3319e-08,
                    7.7506e-08,
                    8.727e-08,
                    9.3676e-08,
                    1.0099e-07,
                    1.0855e-07,
                    1.1677e-07,
                    1.4247e-07,
                    1.7022e-07,
                    1.9717e-07,
                    2.2371e-07,
                    2.5598e-07,
                    2.9426e-07,
                    3.5658e-07,
                    4.2207e-07,
                    4.8375e-07,
                    5.5819e-07,
                    6.2096e-07,
                    6.9604e-07,
                    7.6977e-07,
                    8.5233e-07,
                    9.3432e-07,
                    1.007e-06,
                    1.0972e-06,
                    1.1833e-06,
                    1.2496e-06,
                    1.3291e-06,
                    1.4116e-06,
                    1.5096e-06,
                    1.6192e-06,
                    1.7019e-06,
                    1.8047e-06,
                    1.9114e-06,
                    2.0095e-06,
                    2.1102e-06,
                    2.2099e-06,
                    2.3108e-06,
                    2.4043e-06,
                    2.4994e-06,
                    2.595e-06,
                    2.6957e-06,
                    2.8011e-06,
                    2.9046e-06,
                    3.0028e-06,
                    3.0998e-06,
                    3.1989e-06,
                    3.3007e-06,
                    3.4026e-06,
                    3.5042e-06,
                    3.6065e-06,
                    3.6951e-06,
                    3.7917e-06,
                    3.8789e-06,
                    3.9606e-06,
                    4.0357e-06,
                    4.1161e-06,
                    4.2021e-06,
                    4.2754e-06,
                    4.3485e-06,
                    4.4178e-06,
                    4.4904e-06,
                    4.5578e-06,
                    4.6289e-06,
                    4.6978e-06,
                    4.7695e-06,
                    4.844e-06
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [
                    4.5703e-09,
                    9.0153e-09,
                    1.3599e-08,
                    1.7793e-08,
                    2.2131e-08,
                    2.6364e-08,
                    3.0395e-08,
                    3.4436e-08,
                    3.7971e-08,
                    4.2028e-08,
                    4.5594e-08,
                    4.9247e-08,
                    5.2822e-08,
                    5.6456e-08,
                    5.9858e-08,
                    6.3396e-08,
                    6.7093e-08,
                    7.07e-08,
                    7.4251e-08,
                    7.7879e-08,
                    8.1392e-08,
                    8.4827e-08,
                    8.8453e-08,
                    9.1791e-08,
                    9.5343e-08,
                    9.888e-08,
                    1.0231e-07,
                    1.0581e-07,
                    1.0892e-07,
                    1.126e-07,
                    1.1593e-07,
                    1.1939e-07,
                    1.2283e-07,
                    1.2637e-07,
                    1.2976e-07,
                    1.3331e-07,
                    1.3707e-07,
                    1.4081e-07,
                    1.4456e-07,
                    1.4837e-07,
                    1.5229e-07,
                    1.5634e-07,
                    1.6069e-07,
                    1.6492e-07,
                    1.6947e-07,
                    1.7415e-07,
                    1.7882e-07,
                    1.837e-07,
                    1.8825e-07,
                    1.9343e-07,
                    1.9838e-07,
                    2.0342e-07,
                    2.0848e-07,
                    2.1375e-07,
                    2.1886e-07,
                    2.2416e-07,
                    2.2941e-07,
                    2.3456e-07,
                    2.3986e-07,
                    2.4421e-07,
                    2.4844e-07,
                    2.5207e-07,
                    2.5546e-07,
                    2.5849e-07,
                    2.6127e-07,
                    2.6357e-07,
                    2.6572e-07,
                    2.6764e-07,
                    2.6931e-07,
                    2.706e-07,
                    2.7196e-07,
                    2.7314e-07,
                    2.7413e-07,
                    2.7508e-07,
                    2.7593e-07,
                    2.7663e-07,
                    2.773e-07,
                    2.7783e-07,
                    2.7843e-07,
                    2.7885e-07,
                    2.7933e-07,
                    2.7977e-07,
                    2.8018e-07,
                    2.8035e-07,
                    2.8054e-07,
                    2.8062e-07,
                    2.8063e-07,
                    2.8065e-07,
                    2.8066e-07,
                    2.8081e-07,
                    2.809e-07,
                    2.8107e-07,
                    2.8128e-07,
                    2.8176e-07,
                    2.8241e-07,
                    2.833e-07,
                    2.8446e-07,
                    2.8581e-07,
                    2.8749e-07,
                    2.8938e-07,
                    2.9175e-07,
                    2.9479e-07,
                    2.9832e-07,
                    3.0261e-07,
                    3.0753e-07,
                    3.1328e-07,
                    3.1973e-07,
                    3.2707e-07,
                    3.3526e-07,
                    3.4419e-07,
                    3.5335e-07,
                    3.6319e-07,
                    3.7368e-07,
                    3.8477e-07,
                    3.9667e-07,
                    4.0929e-07,
                    4.2282e-07,
                    4.3736e-07,
                    4.5279e-07,
                    4.6835e-07,
                    4.8305e-07,
                    4.9794e-07,
                    5.1422e-07,
                    5.3117e-07,
                    5.4808e-07,
                    5.6617e-07,
                    5.8469e-07,
                    6.0386e-07,
                    6.2331e-07,
                    6.4251e-07,
                    6.6012e-07,
                    6.7708e-07,
                    6.9411e-07,
                    7.1099e-07,
                    7.2639e-07,
                    7.4073e-07,
                    7.5338e-07,
                    7.6516e-07,
                    7.7579e-07,
                    7.8568e-07,
                    7.9482e-07,
                    8.0268e-07,
                    8.0906e-07,
                    8.1476e-07,
                    8.2024e-07,
                    8.2525e-07,
                    8.2814e-07,
                    8.3015e-07,
                    8.3025e-07,
                    8.3071e-07,
                    8.3141e-07,
                    8.3134e-07,
                    8.2996e-07,
                    8.2754e-07,
                    8.2507e-07,
                    8.2249e-07,
                    8.2106e-07,
                    8.1934e-07,
                    8.1584e-07,
                    8.1155e-07,
                    8.066e-07,
                    8.0151e-07,
                    7.9667e-07,
                    7.9123e-07,
                    7.8541e-07,
                    7.7786e-07,
                    7.7153e-07,
                    7.6495e-07,
                    7.5863e-07,
                    7.52e-07,
                    7.4468e-07,
                    7.3717e-07
                ],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    2.8325e-09,
                    5.533e-09,
                    8.3655e-09,
                    1.0802e-08,
                    1.3376e-08,
                    1.584e-08,
                    1.8095e-08,
                    2.0355e-08,
                    2.2105e-08,
                    2.437e-08,
                    2.6141e-08,
                    2.7995e-08,
                    2.9766e-08,
                    3.1592e-08,
                    3.3181e-08,
                    3.4903e-08,
                    3.6779e-08,
                    3.8561e-08,
                    4.0282e-08,
                    4.2075e-08,
                    4.3747e-08,
                    4.5331e-08,
                    4.7091e-08,
                    4.8548e-08,
                    5.0204e-08,
                    5.1826e-08,
                    5.3322e-08,
                    5.4884e-08,
                    5.6028e-08,
                    5.775e-08,
                    5.9097e-08,
                    6.0582e-08,
                    6.2034e-08,
                    6.358e-08,
                    6.4971e-08,
                    6.6517e-08,
                    6.8261e-08,
                    6.9982e-08,
                    7.1709e-08,
                    7.3524e-08,
                    7.541e-08,
                    7.7396e-08,
                    7.9645e-08,
                    8.1741e-08,
                    8.4144e-08,
                    8.6642e-08,
                    8.9122e-08,
                    9.1784e-08,
                    9.4116e-08,
                    9.7064e-08,
                    9.9781e-08,
                    1.0259e-07,
                    1.0542e-07,
                    1.0848e-07,
                    1.1138e-07,
                    1.1447e-07,
                    1.1752e-07,
                    1.2049e-07,
                    1.236e-07,
                    1.2575e-07,
                    1.2778e-07,
                    1.2921e-07,
                    1.3039e-07,
                    1.3121e-07,
                    1.3176e-07,
                    1.3183e-07,
                    1.3175e-07,
                    1.3142e-07,
                    1.3084e-07,
                    1.2987e-07,
                    1.2896e-07,
                    1.2787e-07,
                    1.2657e-07,
                    1.2523e-07,
                    1.2377e-07,
                    1.2215e-07,
                    1.2048e-07,
                    1.1867e-07,
                    1.1691e-07,
                    1.1497e-07,
                    1.1307e-07,
                    1.1112e-07,
                    1.0911e-07,
                    1.0686e-07,
                    1.0462e-07,
                    1.0225e-07,
                    9.9809e-08,
                    9.7355e-08,
                    9.4891e-08,
                    9.2554e-08,
                    9.0128e-08,
                    8.7703e-08,
                    8.52e-08,
                    8.2841e-08,
                    8.0388e-08,
                    7.7924e-08,
                    7.5487e-08,
                    7.3023e-08,
                    7.0691e-08,
                    6.8436e-08,
                    6.6319e-08,
                    6.4526e-08,
                    6.2848e-08,
                    6.1523e-08,
                    6.0368e-08,
                    5.9554e-08,
                    5.8888e-08,
                    5.852e-08,
                    6.3649e-08,
                    7.0546e-08,
                    7.7612e-08,
                    8.4813e-08,
                    9.249e-08,
                    1.1733e-07,
                    1.4436e-07,
                    1.706e-07,
                    1.9658e-07,
                    2.2855e-07,
                    2.6665e-07,
                    3.1534e-07,
                    3.6629e-07,
                    4.1317e-07,
                    4.7227e-07,
                    5.1996e-07,
                    5.8037e-07,
                    6.3913e-07,
                    7.0629e-07,
                    7.7334e-07,
                    8.3079e-07,
                    9.0024e-07,
                    9.6539e-07,
                    1.0104e-06,
                    1.0677e-06,
                    1.1275e-06,
                    1.202e-06,
                    1.2874e-06,
                    1.3458e-06,
                    1.4238e-06,
                    1.5047e-06,
                    1.5905e-06,
                    1.6788e-06,
                    1.7677e-06,
                    1.8605e-06,
                    1.9473e-06,
                    2.0362e-06,
                    2.1267e-06,
                    2.2224e-06,
                    2.3228e-06,
                    2.4219e-06,
                    2.5174e-06,
                    2.6107e-06,
                    2.7061e-06,
                    2.8053e-06,
                    2.9046e-06,
                    3.0033e-06,
                    3.1026e-06,
                    3.1888e-06,
                    3.2827e-06,
                    3.3699e-06,
                    3.4497e-06,
                    3.5225e-06,
                    3.5988e-06,
                    3.6773e-06,
                    3.741e-06,
                    3.8039e-06,
                    3.8609e-06,
                    3.9213e-06,
                    3.9758e-06,
                    4.0333e-06,
                    4.0876e-06,
                    4.1439e-06,
                    4.2017e-06
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    5.2724e-09,
                    1.2229e-08,
                    1.9823e-08,
                    2.764e-08,
                    3.6093e-08,
                    6.1991e-08,
                    9.0124e-08,
                    1.1764e-07,
                    1.4495e-07,
                    1.782e-07,
                    2.1764e-07,
                    2.6763e-07,
                    3.1995e-07,
                    3.6838e-07,
                    4.2897e-07,
                    4.7814e-07,
                    5.4004e-07,
                    6.0024e-07,
                    6.6881e-07,
                    7.3721e-07,
                    7.9606e-07,
                    8.6713e-07,
                    9.3388e-07,
                    9.8062e-07,
                    1.0395e-06,
                    1.1009e-06,
                    1.1776e-06,
                    1.2655e-06,
                    1.3263e-06,
                    1.4069e-06,
                    1.4912e-06,
                    1.5808e-06,
                    1.6737e-06,
                    1.7669e-06,
                    1.8637e-06,
                    1.9543e-06,
                    2.0463e-06,
                    2.139e-06,
                    2.2374e-06,
                    2.3406e-06,
                    2.4426e-06,
                    2.5403e-06,
                    2.6369e-06,
                    2.736e-06,
                    2.8393e-06,
                    2.9426e-06,
                    3.0457e-06,
                    3.1498e-06,
                    3.2402e-06,
                    3.3391e-06,
                    3.4316e-06,
                    3.5175e-06,
                    3.5971e-06,
                    3.6806e-06,
                    3.7673e-06,
                    3.8399e-06,
                    3.9119e-06,
                    3.9793e-06,
                    4.0495e-06,
                    4.1139e-06,
                    4.181e-06,
                    4.2449e-06,
                    4.3106e-06,
                    4.3781e-06
                ],
                "Land_CO2": -0,
                "Land_CO2_timeseries": [
                    2.8325e-09,
                    5.533e-09,
                    8.3655e-09,
                    1.0802e-08,
                    1.3376e-08,
                    1.584e-08,
                    1.8095e-08,
                    2.0355e-08,
                    2.2105e-08,
                    2.437e-08,
                    2.6141e-08,
                    2.7995e-08,
                    2.9766e-08,
                    3.1592e-08,
                    3.3181e-08,
                    3.4903e-08,
                    3.6779e-08,
                    3.8561e-08,
                    4.0282e-08,
                    4.2075e-08,
                    4.3747e-08,
                    4.5331e-08,
                    4.7091e-08,
                    4.8548e-08,
                    5.0204e-08,
                    5.1826e-08,
                    5.3322e-08,
                    5.4884e-08,
                    5.6028e-08,
                    5.775e-08,
                    5.9097e-08,
                    6.0582e-08,
                    6.2034e-08,
                    6.358e-08,
                    6.4971e-08,
                    6.6517e-08,
                    6.8261e-08,
                    6.9982e-08,
                    7.1709e-08,
                    7.3524e-08,
                    7.541e-08,
                    7.7396e-08,
                    7.9645e-08,
                    8.1741e-08,
                    8.4144e-08,
                    8.6642e-08,
                    8.9122e-08,
                    9.1784e-08,
                    9.4116e-08,
                    9.7064e-08,
                    9.9781e-08,
                    1.0259e-07,
                    1.0542e-07,
                    1.0848e-07,
                    1.1138e-07,
                    1.1447e-07,
                    1.1752e-07,
                    1.2049e-07,
                    1.236e-07,
                    1.2575e-07,
                    1.2778e-07,
                    1.2921e-07,
                    1.3039e-07,
                    1.3121e-07,
                    1.3176e-07,
                    1.3183e-07,
                    1.3175e-07,
                    1.3142e-07,
                    1.3084e-07,
                    1.2987e-07,
                    1.2896e-07,
                    1.2787e-07,
                    1.2657e-07,
                    1.2523e-07,
                    1.2377e-07,
                    1.2215e-07,
                    1.2048e-07,
                    1.1867e-07,
                    1.1691e-07,
                    1.1497e-07,
                    1.1307e-07,
                    1.1112e-07,
                    1.0911e-07,
                    1.0686e-07,
                    1.0462e-07,
                    1.0225e-07,
                    9.9809e-08,
                    9.7355e-08,
                    9.4891e-08,
                    9.2554e-08,
                    9.0128e-08,
                    8.7703e-08,
                    8.52e-08,
                    8.2841e-08,
                    8.0388e-08,
                    7.7924e-08,
                    7.5487e-08,
                    7.3023e-08,
                    7.0691e-08,
                    6.8436e-08,
                    6.6319e-08,
                    6.4526e-08,
                    6.2848e-08,
                    6.1523e-08,
                    6.0368e-08,
                    5.9554e-08,
                    5.8888e-08,
                    5.852e-08,
                    5.8377e-08,
                    5.8316e-08,
                    5.7788e-08,
                    5.7172e-08,
                    5.6397e-08,
                    5.5335e-08,
                    5.4236e-08,
                    5.2959e-08,
                    5.1628e-08,
                    5.0342e-08,
                    4.9016e-08,
                    4.7718e-08,
                    4.6332e-08,
                    4.4792e-08,
                    4.3301e-08,
                    4.1822e-08,
                    4.0331e-08,
                    3.8891e-08,
                    3.7482e-08,
                    3.6124e-08,
                    3.4732e-08,
                    3.311e-08,
                    3.151e-08,
                    2.981e-08,
                    2.8188e-08,
                    2.662e-08,
                    2.437e-08,
                    2.1973e-08,
                    1.9503e-08,
                    1.6902e-08,
                    1.3464e-08,
                    9.669e-09,
                    5.1205e-09,
                    7.865e-10,
                    -0.0000000032725,
                    -0.000000006963,
                    -0.000000010059,
                    -0.000000012276,
                    -0.000000014965,
                    -0.000000017743,
                    -0.000000020751,
                    -0.000000022852,
                    -0.000000026213,
                    -0.000000029942,
                    -0.000000033962,
                    -0.000000038005,
                    -0.000000042422,
                    -0.000000047251,
                    -0.000000051425,
                    -0.000000056348,
                    -0.000000061666,
                    -0.000000067815,
                    -0.000000074613,
                    -0.000000081829,
                    -0.000000089953,
                    -0.000000098868,
                    -0.00000010801,
                    -0.0000001184,
                    -0.00000012817,
                    -0.00000013806,
                    -0.00000014766,
                    -0.00000015728,
                    -0.00000016673,
                    -0.00000017642
                ],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [
                    1.6604e-09,
                    3.3209e-09,
                    4.9811e-09,
                    6.6408e-09,
                    8.2999e-09,
                    9.9418e-09,
                    1.1567e-08,
                    1.3175e-08,
                    1.4766e-08,
                    1.6341e-08,
                    1.7899e-08,
                    1.9464e-08,
                    2.1035e-08,
                    2.2612e-08,
                    2.4194e-08,
                    2.5783e-08,
                    2.7376e-08,
                    2.8975e-08,
                    3.0579e-08,
                    3.2188e-08,
                    3.3805e-08,
                    3.5431e-08,
                    3.7064e-08,
                    3.8706e-08,
                    4.0368e-08,
                    4.2064e-08,
                    4.3796e-08,
                    4.5561e-08,
                    4.7361e-08,
                    4.9195e-08,
                    5.1023e-08,
                    5.2825e-08,
                    5.4602e-08,
                    5.6353e-08,
                    5.808e-08,
                    5.982e-08,
                    6.1572e-08,
                    6.3337e-08,
                    6.5114e-08,
                    6.6903e-08,
                    6.8705e-08,
                    7.05e-08,
                    7.2287e-08,
                    7.4067e-08,
                    7.5829e-08,
                    7.7575e-08,
                    7.9303e-08,
                    8.1015e-08,
                    8.271e-08,
                    8.4389e-08,
                    8.6089e-08,
                    8.7901e-08,
                    8.9829e-08,
                    9.1879e-08,
                    9.4057e-08,
                    9.6179e-08,
                    9.83e-08,
                    1.0042e-07,
                    1.0254e-07,
                    1.0481e-07,
                    1.0674e-07,
                    1.0878e-07,
                    1.1095e-07,
                    1.1325e-07,
                    1.1568e-07,
                    1.18e-07,
                    1.2036e-07,
                    1.2276e-07,
                    1.252e-07,
                    1.2767e-07,
                    1.3019e-07,
                    1.3265e-07,
                    1.3506e-07,
                    1.3741e-07,
                    1.397e-07,
                    1.4194e-07,
                    1.4409e-07,
                    1.4615e-07,
                    1.4814e-07,
                    1.4991e-07,
                    1.5207e-07,
                    1.5422e-07,
                    1.5634e-07,
                    1.5845e-07,
                    1.6053e-07,
                    1.6274e-07,
                    1.6492e-07,
                    1.6709e-07,
                    1.6923e-07,
                    1.7135e-07,
                    1.7322e-07,
                    1.7509e-07,
                    1.7699e-07,
                    1.789e-07,
                    1.8114e-07,
                    1.8384e-07,
                    1.87e-07,
                    1.9064e-07,
                    1.9469e-07,
                    1.9933e-07,
                    2.045e-07,
                    2.1013e-07,
                    2.1622e-07,
                    2.2276e-07,
                    2.3002e-07,
                    2.3789e-07,
                    2.4638e-07,
                    2.558e-07,
                    2.6609e-07,
                    2.7194e-07,
                    2.7869e-07,
                    2.8611e-07,
                    2.9424e-07,
                    3.0311e-07,
                    3.1248e-07,
                    3.2239e-07,
                    3.3289e-07,
                    3.4398e-07,
                    3.557e-07,
                    3.811e-07,
                    4.0649e-07,
                    4.3222e-07,
                    4.5965e-07,
                    4.8747e-07,
                    5.148e-07,
                    5.4339e-07,
                    5.7267e-07,
                    6.0195e-07,
                    6.3169e-07,
                    6.6666e-07,
                    7.0031e-07,
                    7.3362e-07,
                    7.6796e-07,
                    8.0232e-07,
                    8.3627e-07,
                    8.6953e-07,
                    9.0143e-07,
                    9.3292e-07,
                    9.6428e-07,
                    9.8159e-07,
                    9.9804e-07,
                    1.0118e-06,
                    1.0215e-06,
                    1.0291e-06,
                    1.0359e-06,
                    1.0411e-06,
                    1.0442e-06,
                    1.0462e-06,
                    1.046e-06,
                    1.0443e-06,
                    1.0439e-06,
                    1.0429e-06,
                    1.0393e-06,
                    1.0349e-06,
                    1.0306e-06,
                    1.0265e-06,
                    1.0229e-06,
                    1.0193e-06,
                    1.0115e-06,
                    1.0047e-06,
                    9.9766e-07,
                    9.9254e-07,
                    9.9091e-07,
                    9.9091e-07,
                    9.9139e-07,
                    9.9206e-07,
                    9.9385e-07,
                    9.9611e-07,
                    9.9936e-07,
                    1.0033e-06,
                    1.0074e-06,
                    1.0125e-06
                ],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [
                    5.2731e-11,
                    1.0138e-10,
                    1.4569e-10,
                    1.8541e-10,
                    2.2031e-10,
                    2.3402e-10,
                    2.2663e-10,
                    1.9826e-10,
                    1.4904e-10,
                    7.9097e-11,
                    -0.000000000011517,
                    -0.000000000099948,
                    -0.00000000018641,
                    -0.00000000027112,
                    -0.00000000035429,
                    -0.00000000043612,
                    -0.00000000051682,
                    -0.00000000059659,
                    -0.00000000067521,
                    -0.00000000075289,
                    -0.0000000008268,
                    -0.00000000089687,
                    -0.00000000096303,
                    -0.0000000010252,
                    -0.0000000010721,
                    -0.0000000010885,
                    -0.0000000010745,
                    -0.0000000010303,
                    -0.00000000095621,
                    -0.00000000085238,
                    -0.00000000075856,
                    -0.0000000006956,
                    -0.00000000066271,
                    -0.00000000065912,
                    -0.00000000068406,
                    -0.00000000070117,
                    -0.00000000071032,
                    -0.00000000071135,
                    -0.00000000070448,
                    -0.00000000068956,
                    -0.00000000066644,
                    -0.00000000065552,
                    -0.00000000065653,
                    -0.00000000066922,
                    -0.00000000070386,
                    -0.00000000076025,
                    -0.00000000083817,
                    -0.00000000093738,
                    -0.0000000010577,
                    -0.0000000011988,
                    -0.0000000013235,
                    -0.0000000013411,
                    -0.0000000012467,
                    -0.0000000010352,
                    -0.00000000070099,
                    -0.00000000042676,
                    -0.00000000015773,
                    1.0619e-10,
                    3.6511e-10,
                    7.6914e-10,
                    8.2542e-10,
                    9.9217e-10,
                    1.277e-09,
                    1.688e-09,
                    2.2342e-09,
                    2.6573e-09,
                    3.1152e-09,
                    3.6082e-09,
                    4.1366e-09,
                    4.7009e-09,
                    5.2955e-09,
                    5.8354e-09,
                    6.3158e-09,
                    6.732e-09,
                    7.0784e-09,
                    7.3747e-09,
                    7.5756e-09,
                    7.6864e-09,
                    7.7125e-09,
                    7.5179e-09,
                    7.711e-09,
                    7.884e-09,
                    8.0335e-09,
                    8.1561e-09,
                    8.2476e-09,
                    8.4607e-09,
                    8.6478e-09,
                    8.8085e-09,
                    8.9427e-09,
                    9.0502e-09,
                    8.8946e-09,
                    8.7487e-09,
                    8.6128e-09,
                    8.4873e-09,
                    8.5867e-09,
                    9.0374e-09,
                    9.8447e-09,
                    1.1015e-08,
                    1.2488e-08,
                    1.4443e-08,
                    1.6601e-08,
                    1.8886e-08,
                    2.1263e-08,
                    2.3696e-08,
                    2.6403e-08,
                    2.9229e-08,
                    3.2151e-08,
                    3.5418e-08,
                    3.8946e-08,
                    3.7393e-08,
                    3.6071e-08,
                    3.4722e-08,
                    3.3348e-08,
                    3.1947e-08,
                    3.0317e-08,
                    2.8446e-08,
                    2.6323e-08,
                    2.3938e-08,
                    2.1342e-08,
                    3.2289e-08,
                    4.3992e-08,
                    5.5743e-08,
                    6.7964e-08,
                    7.996e-08,
                    9.1552e-08,
                    1.0346e-07,
                    1.1574e-07,
                    1.2759e-07,
                    1.3964e-07,
                    1.57e-07,
                    1.7458e-07,
                    1.9235e-07,
                    2.1127e-07,
                    2.3048e-07,
                    2.5008e-07,
                    2.6991e-07,
                    2.8997e-07,
                    3.1039e-07,
                    3.3102e-07,
                    3.3793e-07,
                    3.4393e-07,
                    3.4871e-07,
                    3.5113e-07,
                    3.5247e-07,
                    3.5393e-07,
                    3.5507e-07,
                    3.5568e-07,
                    3.5611e-07,
                    3.558e-07,
                    3.5462e-07,
                    3.5328e-07,
                    3.516e-07,
                    3.4843e-07,
                    3.4538e-07,
                    3.4225e-07,
                    3.3892e-07,
                    3.3557e-07,
                    3.3173e-07,
                    3.2496e-07,
                    3.1911e-07,
                    3.1318e-07,
                    3.0868e-07,
                    3.0649e-07,
                    3.057e-07,
                    3.0546e-07,
                    3.0587e-07,
                    3.0689e-07,
                    3.0852e-07,
                    3.1117e-07,
                    3.148e-07,
                    3.1943e-07,
                    3.2503e-07
                ],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [
                    1.6077e-09,
                    3.2195e-09,
                    4.8354e-09,
                    6.4554e-09,
                    8.0796e-09,
                    9.7078e-09,
                    1.134e-08,
                    1.2977e-08,
                    1.4617e-08,
                    1.6262e-08,
                    1.7911e-08,
                    1.9564e-08,
                    2.1221e-08,
                    2.2883e-08,
                    2.4549e-08,
                    2.6219e-08,
                    2.7893e-08,
                    2.9571e-08,
                    3.1254e-08,
                    3.2941e-08,
                    3.4632e-08,
                    3.6328e-08,
                    3.8027e-08,
                    3.9732e-08,
                    4.144e-08,
                    4.3153e-08,
                    4.487e-08,
                    4.6591e-08,
                    4.8317e-08,
                    5.0047e-08,
                    5.1782e-08,
                    5.3521e-08,
                    5.5264e-08,
                    5.7012e-08,
                    5.8764e-08,
                    6.0521e-08,
                    6.2282e-08,
                    6.4048e-08,
                    6.5818e-08,
                    6.7593e-08,
                    6.9372e-08,
                    7.1155e-08,
                    7.2943e-08,
                    7.4736e-08,
                    7.6533e-08,
                    7.8335e-08,
                    8.0141e-08,
                    8.1952e-08,
                    8.3768e-08,
                    8.5588e-08,
                    8.7412e-08,
                    8.9242e-08,
                    9.1076e-08,
                    9.2914e-08,
                    9.4757e-08,
                    9.6605e-08,
                    9.8458e-08,
                    1.0032e-07,
                    1.0218e-07,
                    1.0404e-07,
                    1.0592e-07,
                    1.0779e-07,
                    1.0967e-07,
                    1.1156e-07,
                    1.1345e-07,
                    1.1534e-07,
                    1.1724e-07,
                    1.1915e-07,
                    1.2106e-07,
                    1.2297e-07,
                    1.2489e-07,
                    1.2682e-07,
                    1.2875e-07,
                    1.3068e-07,
                    1.3262e-07,
                    1.3456e-07,
                    1.3651e-07,
                    1.3847e-07,
                    1.4043e-07,
                    1.4239e-07,
                    1.4436e-07,
                    1.4633e-07,
                    1.4831e-07,
                    1.5029e-07,
                    1.5228e-07,
                    1.5428e-07,
                    1.5628e-07,
                    1.5828e-07,
                    1.6029e-07,
                    1.623e-07,
                    1.6432e-07,
                    1.6635e-07,
                    1.6837e-07,
                    1.7041e-07,
                    1.7255e-07,
                    1.748e-07,
                    1.7716e-07,
                    1.7962e-07,
                    1.822e-07,
                    1.8488e-07,
                    1.8789e-07,
                    1.9124e-07,
                    1.9496e-07,
                    1.9907e-07,
                    2.0362e-07,
                    2.0866e-07,
                    2.1423e-07,
                    2.2038e-07,
                    2.2715e-07,
                    2.3455e-07,
                    2.4262e-07,
                    2.5139e-07,
                    2.6089e-07,
                    2.7116e-07,
                    2.8216e-07,
                    2.9395e-07,
                    3.0657e-07,
                    3.2005e-07,
                    3.3436e-07,
                    3.4881e-07,
                    3.625e-07,
                    3.7648e-07,
                    3.9169e-07,
                    4.0751e-07,
                    4.2325e-07,
                    4.3994e-07,
                    4.5693e-07,
                    4.7436e-07,
                    4.9205e-07,
                    5.0966e-07,
                    5.2573e-07,
                    5.4127e-07,
                    5.5669e-07,
                    5.7184e-07,
                    5.8618e-07,
                    5.9962e-07,
                    6.1147e-07,
                    6.2253e-07,
                    6.3325e-07,
                    6.4366e-07,
                    6.5411e-07,
                    6.6312e-07,
                    6.7039e-07,
                    6.7658e-07,
                    6.8197e-07,
                    6.8601e-07,
                    6.8847e-07,
                    6.9013e-07,
                    6.9022e-07,
                    6.897e-07,
                    6.9065e-07,
                    6.9128e-07,
                    6.9088e-07,
                    6.8947e-07,
                    6.8834e-07,
                    6.8754e-07,
                    6.8733e-07,
                    6.8761e-07,
                    6.8655e-07,
                    6.8557e-07,
                    6.8448e-07,
                    6.8386e-07,
                    6.8443e-07,
                    6.8522e-07,
                    6.8593e-07,
                    6.862e-07,
                    6.8696e-07,
                    6.8759e-07,
                    6.8819e-07,
                    6.8854e-07,
                    6.8801e-07,
                    6.8748e-07
                ],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [
                    3.1185e-10,
                    6.2851e-10,
                    9.4982e-10,
                    1.2756e-09,
                    1.6055e-09,
                    1.9394e-09,
                    2.2767e-09,
                    2.6172e-09,
                    2.9602e-09,
                    3.3054e-09,
                    3.6522e-09,
                    4.0007e-09,
                    4.3508e-09,
                    4.7024e-09,
                    5.0556e-09,
                    5.4102e-09,
                    5.7665e-09,
                    6.1243e-09,
                    6.4837e-09,
                    6.845e-09,
                    7.2109e-09,
                    7.5863e-09,
                    7.9751e-09,
                    8.3798e-09,
                    8.802e-09,
                    9.242e-09,
                    9.6991e-09,
                    1.0171e-08,
                    1.0656e-08,
                    1.1148e-08,
                    1.1645e-08,
                    1.2147e-08,
                    1.2652e-08,
                    1.3162e-08,
                    1.3675e-08,
                    1.4191e-08,
                    1.471e-08,
                    1.5233e-08,
                    1.5759e-08,
                    1.6265e-08,
                    1.6805e-08,
                    1.7378e-08,
                    1.7982e-08,
                    1.8615e-08,
                    1.9274e-08,
                    1.9956e-08,
                    2.0657e-08,
                    2.1374e-08,
                    2.2102e-08,
                    2.2838e-08,
                    2.3578e-08,
                    2.4317e-08,
                    2.5053e-08,
                    2.5784e-08,
                    2.6511e-08,
                    2.7232e-08,
                    2.7948e-08,
                    2.8662e-08,
                    2.9375e-08,
                    3.0091e-08,
                    3.0811e-08,
                    3.1537e-08,
                    3.2268e-08,
                    3.3005e-08,
                    3.3747e-08,
                    3.4494e-08,
                    3.5248e-08,
                    3.6009e-08,
                    3.6776e-08,
                    3.7551e-08,
                    3.8334e-08,
                    3.9127e-08,
                    3.9932e-08,
                    4.075e-08,
                    4.158e-08,
                    4.2424e-08,
                    4.3282e-08,
                    4.4152e-08,
                    4.5033e-08,
                    4.5924e-08,
                    4.6827e-08,
                    4.7742e-08,
                    4.8673e-08,
                    4.962e-08,
                    5.0583e-08,
                    5.1564e-08,
                    5.256e-08,
                    5.357e-08,
                    5.4591e-08,
                    5.5622e-08,
                    5.6687e-08,
                    5.7835e-08,
                    5.9099e-08,
                    6.0505e-08,
                    6.2066e-08,
                    6.3783e-08,
                    6.5646e-08,
                    6.7633e-08,
                    6.9713e-08,
                    7.184e-08,
                    7.3994e-08,
                    7.618e-08,
                    7.8404e-08,
                    8.0673e-08,
                    8.2989e-08,
                    8.5357e-08,
                    8.7778e-08,
                    9.0255e-08,
                    9.2788e-08,
                    9.5376e-08,
                    9.8039e-08,
                    1.0081e-07,
                    1.0373e-07,
                    1.068e-07,
                    1.1005e-07,
                    1.1347e-07,
                    1.1706e-07,
                    1.2081e-07,
                    1.2469e-07,
                    1.2849e-07,
                    1.3235e-07,
                    1.363e-07,
                    1.4048e-07,
                    1.447e-07,
                    1.4895e-07,
                    1.5342e-07,
                    1.5805e-07,
                    1.6289e-07,
                    1.6781e-07,
                    1.7281e-07,
                    1.7773e-07,
                    1.8259e-07,
                    1.876e-07,
                    1.9269e-07,
                    1.9781e-07,
                    2.0297e-07,
                    2.0805e-07,
                    2.1313e-07,
                    2.1822e-07,
                    2.2315e-07,
                    2.281e-07,
                    2.3302e-07,
                    2.3783e-07,
                    2.427e-07,
                    2.4758e-07,
                    2.5247e-07,
                    2.5727e-07,
                    2.6212e-07,
                    2.6693e-07,
                    2.7175e-07,
                    2.7659e-07,
                    2.8132e-07,
                    2.8603e-07,
                    2.907e-07,
                    2.9536e-07,
                    2.9997e-07,
                    3.0447e-07,
                    3.0896e-07,
                    3.1335e-07,
                    3.1773e-07,
                    3.2212e-07,
                    3.2635e-07,
                    3.3054e-07,
                    3.3466e-07,
                    3.3866e-07,
                    3.4266e-07,
                    3.4675e-07,
                    3.5083e-07,
                    3.549e-07,
                    3.5889e-07,
                    3.6293e-07,
                    3.6702e-07
                ],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [
                    1.8176e-10,
                    3.6573e-10,
                    5.5186e-10,
                    7.401e-10,
                    9.3041e-10,
                    1.1227e-09,
                    1.3169e-09,
                    1.5129e-09,
                    1.7106e-09,
                    1.9098e-09,
                    2.1105e-09,
                    2.3127e-09,
                    2.5163e-09,
                    2.7214e-09,
                    2.9279e-09,
                    3.1359e-09,
                    3.3452e-09,
                    3.5561e-09,
                    3.7684e-09,
                    3.9822e-09,
                    4.1981e-09,
                    4.4174e-09,
                    4.6408e-09,
                    4.8691e-09,
                    5.1025e-09,
                    5.3411e-09,
                    5.5849e-09,
                    5.8332e-09,
                    6.0854e-09,
                    6.3405e-09,
                    6.5979e-09,
                    6.8575e-09,
                    7.119e-09,
                    7.3825e-09,
                    7.6478e-09,
                    7.915e-09,
                    8.1841e-09,
                    8.455e-09,
                    8.7278e-09,
                    9.0097e-09,
                    9.2953e-09,
                    9.5847e-09,
                    9.8783e-09,
                    1.0176e-08,
                    1.0478e-08,
                    1.0785e-08,
                    1.1096e-08,
                    1.1413e-08,
                    1.1734e-08,
                    1.206e-08,
                    1.2392e-08,
                    1.273e-08,
                    1.3074e-08,
                    1.3426e-08,
                    1.3784e-08,
                    1.415e-08,
                    1.4522e-08,
                    1.4901e-08,
                    1.5285e-08,
                    1.5675e-08,
                    1.6069e-08,
                    1.6468e-08,
                    1.6871e-08,
                    1.7278e-08,
                    1.7688e-08,
                    1.8102e-08,
                    1.852e-08,
                    1.8942e-08,
                    1.9368e-08,
                    1.9799e-08,
                    2.0235e-08,
                    2.0676e-08,
                    2.1124e-08,
                    2.1579e-08,
                    2.204e-08,
                    2.2507e-08,
                    2.2981e-08,
                    2.3459e-08,
                    2.3943e-08,
                    2.443e-08,
                    2.4921e-08,
                    2.5417e-08,
                    2.5919e-08,
                    2.6429e-08,
                    2.6948e-08,
                    2.7475e-08,
                    2.8011e-08,
                    2.8555e-08,
                    2.9108e-08,
                    2.9668e-08,
                    3.0236e-08,
                    3.0812e-08,
                    3.1397e-08,
                    3.1991e-08,
                    3.2594e-08,
                    3.3208e-08,
                    3.3833e-08,
                    3.447e-08,
                    3.5118e-08,
                    3.578e-08,
                    3.6458e-08,
                    3.7158e-08,
                    3.7888e-08,
                    3.865e-08,
                    3.945e-08,
                    4.0288e-08,
                    4.1167e-08,
                    4.2088e-08,
                    4.3051e-08,
                    4.4053e-08,
                    4.5098e-08,
                    4.619e-08,
                    4.7333e-08,
                    4.8529e-08,
                    4.978e-08,
                    5.1083e-08,
                    5.2437e-08,
                    5.3838e-08,
                    5.528e-08,
                    5.6661e-08,
                    5.812e-08,
                    5.9633e-08,
                    6.1253e-08,
                    6.2865e-08,
                    6.4445e-08,
                    6.6077e-08,
                    6.7774e-08,
                    6.9524e-08,
                    7.1284e-08,
                    7.3069e-08,
                    7.4859e-08,
                    7.6588e-08,
                    7.8367e-08,
                    8.0165e-08,
                    8.1972e-08,
                    8.3836e-08,
                    8.5643e-08,
                    8.7406e-08,
                    8.9149e-08,
                    9.0805e-08,
                    9.2521e-08,
                    9.4246e-08,
                    9.5886e-08,
                    9.7553e-08,
                    9.9247e-08,
                    1.0095e-07,
                    1.0264e-07,
                    1.0435e-07,
                    1.0614e-07,
                    1.0789e-07,
                    1.0962e-07,
                    1.1132e-07,
                    1.1299e-07,
                    1.1462e-07,
                    1.1621e-07,
                    1.1778e-07,
                    1.1932e-07,
                    1.2088e-07,
                    1.224e-07,
                    1.2393e-07,
                    1.2539e-07,
                    1.2687e-07,
                    1.2835e-07,
                    1.2978e-07,
                    1.3117e-07,
                    1.326e-07,
                    1.3401e-07,
                    1.3541e-07,
                    1.368e-07,
                    1.3815e-07,
                    1.3953e-07,
                    1.4091e-07
                ],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": [
                    1.3009e-10,
                    2.6278e-10,
                    3.9797e-10,
                    5.3548e-10,
                    6.7514e-10,
                    8.1669e-10,
                    9.5986e-10,
                    1.1043e-09,
                    1.2497e-09,
                    1.3956e-09,
                    1.5417e-09,
                    1.688e-09,
                    1.8345e-09,
                    1.981e-09,
                    2.1277e-09,
                    2.2744e-09,
                    2.4212e-09,
                    2.5682e-09,
                    2.7154e-09,
                    2.8628e-09,
                    3.0128e-09,
                    3.1689e-09,
                    3.3342e-09,
                    3.5107e-09,
                    3.6995e-09,
                    3.9009e-09,
                    4.1142e-09,
                    4.3381e-09,
                    4.5702e-09,
                    4.8072e-09,
                    5.0471e-09,
                    5.2893e-09,
                    5.5335e-09,
                    5.7794e-09,
                    6.0268e-09,
                    6.2757e-09,
                    6.526e-09,
                    6.7779e-09,
                    7.0315e-09,
                    7.2548e-09,
                    7.5094e-09,
                    7.7933e-09,
                    8.1041e-09,
                    8.4393e-09,
                    8.796e-09,
                    9.1709e-09,
                    9.5606e-09,
                    9.9612e-09,
                    1.0369e-08,
                    1.0778e-08,
                    1.1186e-08,
                    1.1587e-08,
                    1.1978e-08,
                    1.2359e-08,
                    1.2726e-08,
                    1.3082e-08,
                    1.3426e-08,
                    1.3761e-08,
                    1.4089e-08,
                    1.4416e-08,
                    1.4742e-08,
                    1.5069e-08,
                    1.5397e-08,
                    1.5727e-08,
                    1.6059e-08,
                    1.6392e-08,
                    1.6728e-08,
                    1.7067e-08,
                    1.7408e-08,
                    1.7752e-08,
                    1.8099e-08,
                    1.8451e-08,
                    1.8808e-08,
                    1.9171e-08,
                    1.9541e-08,
                    1.9917e-08,
                    2.0301e-08,
                    2.0692e-08,
                    2.109e-08,
                    2.1495e-08,
                    2.1906e-08,
                    2.2326e-08,
                    2.2754e-08,
                    2.319e-08,
                    2.3636e-08,
                    2.4089e-08,
                    2.4549e-08,
                    2.5014e-08,
                    2.5484e-08,
                    2.5954e-08,
                    2.6451e-08,
                    2.7022e-08,
                    2.7702e-08,
                    2.8514e-08,
                    2.9472e-08,
                    3.0574e-08,
                    3.1812e-08,
                    3.3163e-08,
                    3.4595e-08,
                    3.6061e-08,
                    3.7536e-08,
                    3.9021e-08,
                    4.0516e-08,
                    4.2022e-08,
                    4.354e-08,
                    4.5069e-08,
                    4.6611e-08,
                    4.8167e-08,
                    4.9737e-08,
                    5.1322e-08,
                    5.2941e-08,
                    5.4624e-08,
                    5.6396e-08,
                    5.8274e-08,
                    6.0269e-08,
                    6.2386e-08,
                    6.4623e-08,
                    6.697e-08,
                    6.9414e-08,
                    7.1824e-08,
                    7.4226e-08,
                    7.667e-08,
                    7.9232e-08,
                    8.1837e-08,
                    8.4501e-08,
                    8.734e-08,
                    9.0275e-08,
                    9.337e-08,
                    9.653e-08,
                    9.974e-08,
                    1.0287e-07,
                    1.06e-07,
                    1.0923e-07,
                    1.1253e-07,
                    1.1584e-07,
                    1.1913e-07,
                    1.2241e-07,
                    1.2573e-07,
                    1.2907e-07,
                    1.3235e-07,
                    1.3558e-07,
                    1.3878e-07,
                    1.4195e-07,
                    1.4515e-07,
                    1.4833e-07,
                    1.5152e-07,
                    1.5464e-07,
                    1.5776e-07,
                    1.6079e-07,
                    1.6386e-07,
                    1.6697e-07,
                    1.7001e-07,
                    1.7304e-07,
                    1.7607e-07,
                    1.7915e-07,
                    1.822e-07,
                    1.8515e-07,
                    1.8808e-07,
                    1.9096e-07,
                    1.938e-07,
                    1.9673e-07,
                    1.9948e-07,
                    2.0219e-07,
                    2.0488e-07,
                    2.0749e-07,
                    2.1006e-07,
                    2.1274e-07,
                    2.1542e-07,
                    2.181e-07,
                    2.2074e-07,
                    2.234e-07,
                    2.2611e-07
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            9.60708,
                            47.06077
                        ],
                        [
                            9.62498,
                            47.14572
                        ],
                        [
                            9.53075,
                            47.27058
                        ],
                        [
                            9.4862,
                            47.17833
                        ],
                        [
                            9.52005,
                            47.10343
                        ],
                        [
                            9.60708,
                            47.06077
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "LTU",
                "Country": "Lithuania",
                "Total_3GHG": 0.11,
                "Total_3GHG_timeseries": [
                    6.0483e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018
                ],
                "Fossil_3GHG": 0.08,
                "Fossil_3GHG_timeseries": [
                    1.8929e-07,
                    3.9088e-07,
                    6.0505e-07,
                    8.3208e-07,
                    1.0739e-06,
                    1.3275e-06,
                    1.5949e-06,
                    1.8786e-06,
                    2.1665e-06,
                    2.4593e-06,
                    2.7567e-06,
                    3.0573e-06,
                    3.3619e-06,
                    3.6864e-06,
                    4.0306e-06,
                    4.4042e-06,
                    4.8008e-06,
                    5.2016e-06,
                    5.6136e-06,
                    6.0339e-06,
                    6.457e-06,
                    6.8892e-06,
                    7.3286e-06,
                    7.782e-06,
                    8.249e-06,
                    8.7335e-06,
                    9.2285e-06,
                    9.7463e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009
                ],
                "Land_3GHG": 0.16,
                "Land_3GHG_timeseries": [
                    5.8591e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009
                ],
                "Total_CO2": 0.12,
                "Total_CO2_timeseries": [
                    4.7702e-06,
                    9.5758e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014
                ],
                "Fossil_CO2": 0.09,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    1.6077e-09,
                    1.6077e-09,
                    1.6077e-09,
                    3.8656e-09,
                    6.26e-09,
                    9.4245e-09,
                    1.3444e-08,
                    1.707e-08,
                    2.0867e-08,
                    2.5126e-08,
                    2.9197e-08,
                    4.2059e-08,
                    5.682e-08,
                    6.9101e-08,
                    8.576e-08,
                    1.0384e-07,
                    1.2825e-07,
                    1.533e-07,
                    1.7682e-07,
                    2.0537e-07,
                    2.3823e-07,
                    2.7902e-07,
                    3.2065e-07,
                    3.7506e-07,
                    4.3089e-07,
                    4.9638e-07,
                    5.6536e-07,
                    6.3802e-07,
                    7.2072e-07,
                    8.0469e-07,
                    8.9614e-07,
                    9.8994e-07,
                    1.0892e-06,
                    1.1927e-06,
                    1.3045e-06,
                    1.4312e-06,
                    1.5706e-06,
                    1.7182e-06,
                    1.8911e-06,
                    2.0673e-06,
                    2.2697e-06,
                    2.4758e-06,
                    2.7141e-06,
                    2.9813e-06,
                    3.2913e-06,
                    3.6425e-06,
                    4.003e-06,
                    4.3512e-06,
                    4.6918e-06,
                    5.0708e-06,
                    5.409e-06,
                    5.7949e-06,
                    6.2271e-06,
                    6.6619e-06,
                    7.1209e-06,
                    7.571e-06,
                    8.0377e-06,
                    8.5664e-06,
                    9.1407e-06,
                    9.6591e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Land_CO2": 0.18,
                "Land_CO2_timeseries": [
                    4.7702e-06,
                    9.5758e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Total_CH4": 0.04,
                "Total_CH4_timeseries": [
                    9.8348e-07,
                    1.984e-06,
                    3.0017e-06,
                    4.037e-06,
                    5.0902e-06,
                    6.1615e-06,
                    7.2512e-06,
                    8.3597e-06,
                    9.477e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_CH4": 0.03,
                "Fossil_CH4_timeseries": [
                    1.7005e-07,
                    3.5219e-07,
                    5.467e-07,
                    7.5387e-07,
                    9.7403e-07,
                    1.2074e-06,
                    1.4543e-06,
                    1.7151e-06,
                    1.9797e-06,
                    2.2483e-06,
                    2.5205e-06,
                    2.7961e-06,
                    3.0754e-06,
                    3.3739e-06,
                    3.6921e-06,
                    4.0309e-06,
                    4.3905e-06,
                    4.7566e-06,
                    5.1293e-06,
                    5.5088e-06,
                    5.8846e-06,
                    6.2685e-06,
                    6.6608e-06,
                    7.0618e-06,
                    7.4717e-06,
                    7.8908e-06,
                    8.3191e-06,
                    8.7571e-06,
                    9.2144e-06,
                    9.6916e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CH4": 0.05,
                "Land_CH4_timeseries": [
                    8.1343e-07,
                    1.6318e-06,
                    2.455e-06,
                    3.2831e-06,
                    4.1162e-06,
                    4.9541e-06,
                    5.7969e-06,
                    6.6447e-06,
                    7.4973e-06,
                    8.3548e-06,
                    9.207e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_N2O": 0.32,
                "Total_N2O_timeseries": [
                    2.9471e-07,
                    5.9513e-07,
                    9.0104e-07,
                    1.2121e-06,
                    1.5279e-06,
                    1.8479e-06,
                    2.1715e-06,
                    2.4981e-06,
                    2.8268e-06,
                    3.1567e-06,
                    3.4873e-06,
                    3.8185e-06,
                    4.1501e-06,
                    4.4822e-06,
                    4.8146e-06,
                    5.1473e-06,
                    5.4805e-06,
                    5.8141e-06,
                    6.1483e-06,
                    6.4833e-06,
                    6.8237e-06,
                    7.1776e-06,
                    7.5512e-06,
                    7.9488e-06,
                    8.3728e-06,
                    8.8238e-06,
                    9.3006e-06,
                    9.8001e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_N2O": 0.25,
                "Fossil_N2O_timeseries": [
                    1.9237e-08,
                    3.8686e-08,
                    5.8346e-08,
                    7.8213e-08,
                    9.8285e-08,
                    1.1856e-07,
                    1.3903e-07,
                    1.5969e-07,
                    1.8053e-07,
                    2.0155e-07,
                    2.2274e-07,
                    2.4411e-07,
                    2.6565e-07,
                    2.8736e-07,
                    3.0923e-07,
                    3.3128e-07,
                    3.535e-07,
                    3.7589e-07,
                    3.9846e-07,
                    4.212e-07,
                    4.4414e-07,
                    4.6736e-07,
                    4.909e-07,
                    5.148e-07,
                    5.3907e-07,
                    5.6372e-07,
                    5.8874e-07,
                    6.141e-07,
                    6.3976e-07,
                    6.6568e-07,
                    6.9181e-07,
                    7.1816e-07,
                    7.447e-07,
                    7.7144e-07,
                    7.9838e-07,
                    8.2551e-07,
                    8.5283e-07,
                    8.8035e-07,
                    9.0806e-07,
                    9.3609e-07,
                    9.6436e-07,
                    9.9286e-07,
                    1.0216e-06,
                    1.0506e-06,
                    1.0798e-06,
                    1.1093e-06,
                    1.139e-06,
                    1.169e-06,
                    1.1993e-06,
                    1.2298e-06,
                    1.2607e-06,
                    1.2918e-06,
                    1.3232e-06,
                    1.355e-06,
                    1.3871e-06,
                    1.4195e-06,
                    1.4523e-06,
                    1.4854e-06,
                    1.5188e-06,
                    1.5525e-06,
                    1.5865e-06,
                    1.6208e-06,
                    1.6554e-06,
                    1.6903e-06,
                    1.7254e-06,
                    1.7608e-06,
                    1.7966e-06,
                    1.8326e-06,
                    1.8689e-06,
                    1.9055e-06,
                    1.9425e-06,
                    1.98e-06,
                    2.0181e-06,
                    2.0568e-06,
                    2.0963e-06,
                    2.1366e-06,
                    2.1777e-06,
                    2.2198e-06,
                    2.2627e-06,
                    2.3066e-06,
                    2.3522e-06,
                    2.4003e-06,
                    2.452e-06,
                    2.508e-06,
                    2.5687e-06,
                    2.6345e-06,
                    2.7055e-06,
                    2.7816e-06,
                    2.8625e-06,
                    2.9479e-06,
                    3.0373e-06,
                    3.1305e-06,
                    3.2276e-06,
                    3.3284e-06,
                    3.4333e-06,
                    3.5425e-06,
                    3.6563e-06,
                    3.7753e-06,
                    3.9001e-06,
                    4.0313e-06,
                    4.1729e-06,
                    4.3311e-06,
                    4.5113e-06,
                    4.718e-06,
                    4.9548e-06,
                    5.2244e-06,
                    5.5285e-06,
                    5.8681e-06,
                    6.243e-06,
                    6.6525e-06,
                    7.1039e-06,
                    7.6111e-06,
                    8.1835e-06,
                    8.8263e-06,
                    9.5407e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_N2O": 0.34,
                "Land_N2O_timeseries": [
                    2.7547e-07,
                    5.5645e-07,
                    8.427e-07,
                    1.1339e-06,
                    1.4296e-06,
                    1.7294e-06,
                    2.0325e-06,
                    2.3384e-06,
                    2.6462e-06,
                    2.9551e-06,
                    3.2646e-06,
                    3.5744e-06,
                    3.8845e-06,
                    4.1948e-06,
                    4.5053e-06,
                    4.816e-06,
                    5.127e-06,
                    5.4382e-06,
                    5.7498e-06,
                    6.0621e-06,
                    6.3795e-06,
                    6.7102e-06,
                    7.0603e-06,
                    7.434e-06,
                    7.8337e-06,
                    8.2601e-06,
                    8.7119e-06,
                    9.186e-06,
                    9.6774e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            26.63037,
                            55.68067
                        ],
                        [
                            26.53191,
                            55.67702
                        ],
                        [
                            26.26911,
                            55.76766
                        ],
                        [
                            26.20286,
                            55.85913
                        ],
                        [
                            26.12031,
                            55.88026
                        ],
                        [
                            25.97424,
                            55.98114
                        ],
                        [
                            25.86169,
                            56.00023
                        ],
                        [
                            25.81918,
                            56.05471
                        ],
                        [
                            25.68968,
                            56.08604
                        ],
                        [
                            25.65256,
                            56.13588
                        ],
                        [
                            25.28046,
                            56.15853
                        ],
                        [
                            25.07631,
                            56.1958
                        ],
                        [
                            25.05665,
                            56.26473
                        ],
                        [
                            24.97392,
                            56.31101
                        ],
                        [
                            24.90328,
                            56.42063
                        ],
                        [
                            24.71247,
                            56.40095
                        ],
                        [
                            24.62857,
                            56.37469
                        ],
                        [
                            24.57922,
                            56.28891
                        ],
                        [
                            24.45484,
                            56.25854
                        ],
                        [
                            24.3168,
                            56.30087
                        ],
                        [
                            24.11904,
                            56.24964
                        ],
                        [
                            24.01894,
                            56.32975
                        ],
                        [
                            23.76241,
                            56.33618
                        ],
                        [
                            23.76527,
                            56.37286
                        ],
                        [
                            23.55488,
                            56.33353
                        ],
                        [
                            23.38572,
                            56.37901
                        ],
                        [
                            23.17808,
                            56.36851
                        ],
                        [
                            23.09325,
                            56.30464
                        ],
                        [
                            23.02808,
                            56.33165
                        ],
                        [
                            23.00309,
                            56.40458
                        ],
                        [
                            22.83979,
                            56.3654
                        ],
                        [
                            22.42523,
                            56.40977
                        ],
                        [
                            22.2428,
                            56.40007
                        ],
                        [
                            22.12732,
                            56.43187
                        ],
                        [
                            21.9954,
                            56.41343
                        ],
                        [
                            21.97092,
                            56.3772
                        ],
                        [
                            21.83665,
                            56.37133
                        ],
                        [
                            21.72296,
                            56.31375
                        ],
                        [
                            21.61805,
                            56.32449
                        ],
                        [
                            21.50112,
                            56.29471
                        ],
                        [
                            21.45228,
                            56.24903
                        ],
                        [
                            21.32773,
                            56.21755
                        ],
                        [
                            21.20118,
                            56.07755
                        ],
                        [
                            21.06424,
                            56.06914
                        ],
                        [
                            21.04903,
                            55.91872
                        ],
                        [
                            21.08337,
                            55.72991
                        ],
                        [
                            21.25119,
                            55.46631
                        ],
                        [
                            21.23252,
                            55.35018
                        ],
                        [
                            21.29662,
                            55.29765
                        ],
                        [
                            21.27351,
                            55.24565
                        ],
                        [
                            21.38282,
                            55.29441
                        ],
                        [
                            21.50239,
                            55.18677
                        ],
                        [
                            21.65107,
                            55.17998
                        ],
                        [
                            21.72084,
                            55.13396
                        ],
                        [
                            22.03126,
                            55.05391
                        ],
                        [
                            22.29129,
                            55.06474
                        ],
                        [
                            22.46304,
                            55.04444
                        ],
                        [
                            22.58897,
                            55.07025
                        ],
                        [
                            22.64298,
                            54.98319
                        ],
                        [
                            22.85403,
                            54.88754
                        ],
                        [
                            22.87254,
                            54.79743
                        ],
                        [
                            22.77536,
                            54.75105
                        ],
                        [
                            22.72449,
                            54.68594
                        ],
                        [
                            22.75638,
                            54.65324
                        ],
                        [
                            22.68519,
                            54.58916
                        ],
                        [
                            22.70276,
                            54.45354
                        ],
                        [
                            22.7921,
                            54.36336
                        ],
                        [
                            22.83594,
                            54.40558
                        ],
                        [
                            22.98221,
                            54.38957
                        ],
                        [
                            23.09311,
                            54.2987
                        ],
                        [
                            23.34047,
                            54.25013
                        ],
                        [
                            23.48604,
                            54.15234
                        ],
                        [
                            23.52816,
                            54.06624
                        ],
                        [
                            23.48151,
                            53.99788
                        ],
                        [
                            23.51465,
                            53.95656
                        ],
                        [
                            23.60653,
                            53.92252
                        ],
                        [
                            23.88555,
                            53.94364
                        ],
                        [
                            23.98501,
                            53.92428
                        ],
                        [
                            24.20162,
                            53.96995
                        ],
                        [
                            24.35333,
                            53.89702
                        ],
                        [
                            24.43173,
                            53.90437
                        ],
                        [
                            24.61674,
                            54.007
                        ],
                        [
                            24.84211,
                            54.03393
                        ],
                        [
                            24.7786,
                            54.10078
                        ],
                        [
                            24.95661,
                            54.17152
                        ],
                        [
                            25.06863,
                            54.13416
                        ],
                        [
                            25.2039,
                            54.2242
                        ],
                        [
                            25.21591,
                            54.25615
                        ],
                        [
                            25.35364,
                            54.26421
                        ],
                        [
                            25.51053,
                            54.30836
                        ],
                        [
                            25.57024,
                            54.24665
                        ],
                        [
                            25.54822,
                            54.15274
                        ],
                        [
                            25.6849,
                            54.14147
                        ],
                        [
                            25.78115,
                            54.15994
                        ],
                        [
                            25.78423,
                            54.23326
                        ],
                        [
                            25.67753,
                            54.32343
                        ],
                        [
                            25.55516,
                            54.31552
                        ],
                        [
                            25.63143,
                            54.42085
                        ],
                        [
                            25.61807,
                            54.45872
                        ],
                        [
                            25.67955,
                            54.53378
                        ],
                        [
                            25.7616,
                            54.5771
                        ],
                        [
                            25.73117,
                            54.6825
                        ],
                        [
                            25.73429,
                            54.80214
                        ],
                        [
                            25.85966,
                            54.92769
                        ],
                        [
                            26.07929,
                            54.95484
                        ],
                        [
                            26.20797,
                            54.99768
                        ],
                        [
                            26.35955,
                            55.15016
                        ],
                        [
                            26.46216,
                            55.1292
                        ],
                        [
                            26.61831,
                            55.14709
                        ],
                        [
                            26.68648,
                            55.17865
                        ],
                        [
                            26.79072,
                            55.32044
                        ],
                        [
                            26.4526,
                            55.34062
                        ],
                        [
                            26.55139,
                            55.38961
                        ],
                        [
                            26.52676,
                            55.51294
                        ],
                        [
                            26.62074,
                            55.56534
                        ],
                        [
                            26.63037,
                            55.68067
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "LUX",
                "Country": "Luxembourg",
                "Total_3GHG": 0.02,
                "Total_3GHG_timeseries": [
                    2.6244e-07,
                    5.2436e-07,
                    7.8971e-07,
                    1.0562e-06,
                    1.3192e-06,
                    1.5833e-06,
                    1.8464e-06,
                    2.1067e-06,
                    2.3611e-06,
                    2.6153e-06,
                    2.8574e-06,
                    3.0878e-06,
                    3.3031e-06,
                    3.5128e-06,
                    3.7082e-06,
                    3.8912e-06,
                    4.0717e-06,
                    4.2409e-06,
                    4.4003e-06,
                    4.5632e-06,
                    4.7228e-06,
                    4.8811e-06,
                    5.0416e-06,
                    5.2031e-06,
                    5.3627e-06,
                    5.5208e-06,
                    5.6765e-06,
                    5.8268e-06,
                    5.9708e-06,
                    6.1197e-06,
                    6.2677e-06,
                    6.4152e-06,
                    6.5617e-06,
                    6.7137e-06,
                    6.8635e-06,
                    7.014e-06,
                    7.1745e-06,
                    7.3348e-06,
                    7.497e-06,
                    7.6586e-06,
                    7.8194e-06,
                    7.9808e-06,
                    8.1467e-06,
                    8.3145e-06,
                    8.4792e-06,
                    8.6468e-06,
                    8.8163e-06,
                    8.9853e-06,
                    9.1523e-06,
                    9.3329e-06,
                    9.5113e-06,
                    9.6879e-06,
                    9.8637e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Fossil_3GHG": 0.03,
                "Fossil_3GHG_timeseries": [
                    2.8481e-08,
                    5.6208e-08,
                    8.3155e-08,
                    1.093e-07,
                    1.3461e-07,
                    1.5974e-07,
                    1.8466e-07,
                    2.0932e-07,
                    2.3369e-07,
                    2.5775e-07,
                    2.8123e-07,
                    3.0419e-07,
                    3.266e-07,
                    3.4842e-07,
                    3.6942e-07,
                    3.8941e-07,
                    4.0838e-07,
                    4.263e-07,
                    4.4318e-07,
                    4.6459e-07,
                    4.8637e-07,
                    5.086e-07,
                    5.3131e-07,
                    5.5451e-07,
                    5.7824e-07,
                    6.0056e-07,
                    6.2151e-07,
                    6.4112e-07,
                    6.5941e-07,
                    6.764e-07,
                    6.9296e-07,
                    7.0941e-07,
                    7.2577e-07,
                    7.4205e-07,
                    7.5849e-07,
                    7.7459e-07,
                    7.9052e-07,
                    8.0632e-07,
                    8.2201e-07,
                    8.3271e-07,
                    8.4333e-07,
                    8.5388e-07,
                    8.6441e-07,
                    8.7494e-07,
                    8.8551e-07,
                    8.9703e-07,
                    9.0997e-07,
                    9.2432e-07,
                    9.4008e-07,
                    9.5726e-07,
                    9.7398e-07,
                    9.9123e-07,
                    1.0089e-06,
                    1.027e-06,
                    1.0456e-06,
                    1.0652e-06,
                    1.086e-06,
                    1.1078e-06,
                    1.1306e-06,
                    1.1542e-06,
                    1.1782e-06,
                    1.2026e-06,
                    1.2274e-06,
                    1.2528e-06,
                    1.2784e-06,
                    1.3047e-06,
                    1.3312e-06,
                    1.358e-06,
                    1.3851e-06,
                    1.4125e-06,
                    1.4413e-06,
                    1.4704e-06,
                    1.5001e-06,
                    1.5304e-06,
                    1.5612e-06,
                    1.5927e-06,
                    1.6251e-06,
                    1.6579e-06,
                    1.6914e-06,
                    1.7255e-06,
                    1.7601e-06,
                    1.7951e-06,
                    1.8304e-06,
                    1.8659e-06,
                    1.9019e-06,
                    1.9383e-06,
                    1.9753e-06,
                    2.0127e-06,
                    2.0502e-06,
                    2.0878e-06,
                    2.1299e-06,
                    2.1763e-06,
                    2.2267e-06,
                    2.2812e-06,
                    2.353e-06,
                    2.4355e-06,
                    2.5268e-06,
                    2.6278e-06,
                    2.7381e-06,
                    6.2081e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [
                    2.3396e-07,
                    4.6815e-07,
                    7.0655e-07,
                    9.4693e-07,
                    1.1846e-06,
                    1.4236e-06,
                    1.6617e-06,
                    1.8973e-06,
                    2.1274e-06,
                    2.3575e-06,
                    2.5762e-06,
                    2.7836e-06,
                    2.9765e-06,
                    3.1644e-06,
                    3.3388e-06,
                    3.5018e-06,
                    3.6633e-06,
                    3.8146e-06,
                    3.9572e-06,
                    4.0986e-06,
                    4.2364e-06,
                    4.3725e-06,
                    4.5103e-06,
                    4.6486e-06,
                    4.7845e-06,
                    4.9202e-06,
                    5.055e-06,
                    5.1857e-06,
                    5.3114e-06,
                    5.4433e-06,
                    5.5747e-06,
                    5.7058e-06,
                    5.836e-06,
                    5.9717e-06,
                    6.105e-06,
                    6.2394e-06,
                    6.384e-06,
                    6.5285e-06,
                    6.675e-06,
                    6.8259e-06,
                    6.976e-06,
                    7.1269e-06,
                    7.2823e-06,
                    7.4395e-06,
                    7.5937e-06,
                    7.7498e-06,
                    7.9063e-06,
                    8.061e-06,
                    8.2123e-06,
                    8.3756e-06,
                    8.5373e-06,
                    8.6966e-06,
                    8.8548e-06,
                    9.0114e-06,
                    9.17e-06,
                    9.3236e-06,
                    9.4756e-06,
                    9.6254e-06,
                    9.7736e-06,
                    9.9101e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_CO2": 0.03,
                "Total_CO2_timeseries": [
                    1.2611e-07,
                    2.5118e-07,
                    3.792e-07,
                    5.0792e-07,
                    6.327e-07,
                    7.5752e-07,
                    8.8031e-07,
                    9.9931e-07,
                    1.1115e-06,
                    1.2227e-06,
                    1.3259e-06,
                    1.4213e-06,
                    1.5058e-06,
                    1.5887e-06,
                    1.6616e-06,
                    1.7267e-06,
                    1.7938e-06,
                    1.8542e-06,
                    1.9093e-06,
                    1.9668e-06,
                    2.0221e-06,
                    2.0767e-06,
                    2.1342e-06,
                    2.193e-06,
                    2.2504e-06,
                    2.3085e-06,
                    2.3666e-06,
                    2.4216e-06,
                    2.4727e-06,
                    2.5312e-06,
                    2.5865e-06,
                    2.6388e-06,
                    2.6875e-06,
                    2.7392e-06,
                    2.7858e-06,
                    2.8309e-06,
                    2.8835e-06,
                    2.9335e-06,
                    2.9828e-06,
                    3.0352e-06,
                    3.0853e-06,
                    3.1347e-06,
                    3.1873e-06,
                    3.2405e-06,
                    3.2896e-06,
                    3.3395e-06,
                    3.3892e-06,
                    3.4363e-06,
                    3.4796e-06,
                    3.5347e-06,
                    3.588e-06,
                    3.639e-06,
                    3.6891e-06,
                    3.7378e-06,
                    3.7889e-06,
                    3.8354e-06,
                    3.8806e-06,
                    3.9238e-06,
                    3.9655e-06,
                    3.9953e-06,
                    4.0216e-06,
                    4.0473e-06,
                    4.0652e-06,
                    4.0786e-06,
                    4.0919e-06,
                    4.1e-06,
                    4.1022e-06,
                    4.1046e-06,
                    4.1046e-06,
                    4.0968e-06,
                    4.0881e-06,
                    4.0908e-06,
                    4.0822e-06,
                    4.0693e-06,
                    4.0572e-06,
                    4.0419e-06,
                    4.0259e-06,
                    4.009e-06,
                    3.9931e-06,
                    3.9722e-06,
                    3.9495e-06,
                    3.9247e-06,
                    3.898e-06,
                    3.8681e-06,
                    3.8375e-06,
                    3.8039e-06,
                    3.7672e-06,
                    3.7318e-06,
                    3.6932e-06,
                    3.6505e-06,
                    3.6006e-06,
                    3.5448e-06,
                    3.4823e-06,
                    3.4189e-06,
                    3.3557e-06,
                    3.2955e-06,
                    3.2314e-06,
                    3.1667e-06,
                    3.1002e-06,
                    6.3543e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_CO2": 0.04,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.1456e-08,
                    2.7823e-08,
                    4.7462e-08,
                    7.0374e-08,
                    9.6561e-08,
                    3.4376e-06,
                    7.4947e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Land_CO2": -0,
                "Land_CO2_timeseries": [
                    1.2611e-07,
                    2.5118e-07,
                    3.792e-07,
                    5.0792e-07,
                    6.327e-07,
                    7.5752e-07,
                    8.8031e-07,
                    9.9931e-07,
                    1.1115e-06,
                    1.2227e-06,
                    1.3259e-06,
                    1.4213e-06,
                    1.5058e-06,
                    1.5887e-06,
                    1.6616e-06,
                    1.7267e-06,
                    1.7938e-06,
                    1.8542e-06,
                    1.9093e-06,
                    1.9668e-06,
                    2.0221e-06,
                    2.0767e-06,
                    2.1342e-06,
                    2.193e-06,
                    2.2504e-06,
                    2.3085e-06,
                    2.3666e-06,
                    2.4216e-06,
                    2.4727e-06,
                    2.5312e-06,
                    2.5865e-06,
                    2.6388e-06,
                    2.6875e-06,
                    2.7392e-06,
                    2.7858e-06,
                    2.8309e-06,
                    2.8835e-06,
                    2.9335e-06,
                    2.9828e-06,
                    3.0352e-06,
                    3.0853e-06,
                    3.1347e-06,
                    3.1873e-06,
                    3.2405e-06,
                    3.2896e-06,
                    3.3395e-06,
                    3.3892e-06,
                    3.4363e-06,
                    3.4796e-06,
                    3.5347e-06,
                    3.588e-06,
                    3.639e-06,
                    3.6891e-06,
                    3.7378e-06,
                    3.7889e-06,
                    3.8354e-06,
                    3.8806e-06,
                    3.9238e-06,
                    3.9655e-06,
                    3.9953e-06,
                    4.0216e-06,
                    4.0473e-06,
                    4.0652e-06,
                    4.0786e-06,
                    4.0919e-06,
                    4.1e-06,
                    4.1022e-06,
                    4.1046e-06,
                    4.1046e-06,
                    4.0968e-06,
                    4.0881e-06,
                    4.0908e-06,
                    4.0822e-06,
                    4.0693e-06,
                    4.0572e-06,
                    4.0419e-06,
                    4.0259e-06,
                    4.009e-06,
                    3.9931e-06,
                    3.9722e-06,
                    3.9495e-06,
                    3.9247e-06,
                    3.898e-06,
                    3.8681e-06,
                    3.8375e-06,
                    3.8039e-06,
                    3.7672e-06,
                    3.7318e-06,
                    3.6932e-06,
                    3.6505e-06,
                    3.6006e-06,
                    3.5448e-06,
                    3.4823e-06,
                    3.4189e-06,
                    3.3443e-06,
                    3.2677e-06,
                    3.1839e-06,
                    3.0963e-06,
                    3.0036e-06,
                    2.9167e-06,
                    2.827e-06,
                    2.7434e-06,
                    2.6557e-06,
                    2.5739e-06,
                    2.4924e-06,
                    2.4115e-06,
                    2.3288e-06,
                    2.2464e-06,
                    2.1422e-06,
                    2.0436e-06,
                    1.9427e-06,
                    1.8481e-06,
                    1.753e-06,
                    1.6576e-06,
                    1.5668e-06,
                    1.4729e-06,
                    1.3789e-06,
                    1.2864e-06,
                    1.1944e-06,
                    1.1051e-06,
                    1.0168e-06,
                    9.3263e-07,
                    8.4841e-07,
                    7.6619e-07,
                    6.8075e-07,
                    5.9691e-07,
                    5.1413e-07,
                    4.3077e-07,
                    3.1079e-07,
                    1.871e-07,
                    7.0251e-08,
                    -0.000000053196,
                    -0.00000016108,
                    -0.0000002662,
                    -0.00000037144,
                    -0.00000048426,
                    -0.00000049423,
                    -0.00000055866,
                    -0.00000063702,
                    -0.00000071078,
                    -0.00000069588,
                    -0.00000069121,
                    -0.00000060584,
                    -0.00000059269,
                    -0.00000060355,
                    -0.00000060597,
                    -0.00000061823,
                    -0.0000006261,
                    -0.00000059067,
                    -0.00000058401,
                    -0.00000058538,
                    -0.00000059198,
                    -0.00000059744,
                    -0.00000060516,
                    -0.00000061758,
                    -0.0000006054,
                    -0.00000059256,
                    -0.00000058997,
                    -0.00000058337,
                    -0.00000056926,
                    -0.00000055628,
                    -0.00000053963,
                    -0.00000051701,
                    -0.0000005025,
                    -0.0000004916,
                    -0.00000047518,
                    -0.00000046145,
                    -0.00000044884,
                    -0.00000042986,
                    -0.00000041209,
                    -0.00000038726,
                    -0.00000036782
                ],
                "Total_CH4": 0.01,
                "Total_CH4_timeseries": [
                    1.1484e-07,
                    2.2992e-07,
                    3.4521e-07,
                    4.607e-07,
                    5.7635e-07,
                    6.9281e-07,
                    8.1006e-07,
                    9.2806e-07,
                    1.0468e-06,
                    1.1662e-06,
                    1.2814e-06,
                    1.3924e-06,
                    1.4992e-06,
                    1.6017e-06,
                    1.6998e-06,
                    1.7932e-06,
                    1.8819e-06,
                    1.9659e-06,
                    2.0452e-06,
                    2.1254e-06,
                    2.2043e-06,
                    2.282e-06,
                    2.3586e-06,
                    2.434e-06,
                    2.5082e-06,
                    2.5793e-06,
                    2.6473e-06,
                    2.7123e-06,
                    2.7743e-06,
                    2.8334e-06,
                    2.8945e-06,
                    2.9578e-06,
                    3.0235e-06,
                    3.0915e-06,
                    3.162e-06,
                    3.2347e-06,
                    3.3095e-06,
                    3.3867e-06,
                    3.4661e-06,
                    3.5427e-06,
                    3.6191e-06,
                    3.6954e-06,
                    3.7716e-06,
                    3.8477e-06,
                    3.9238e-06,
                    4.0007e-06,
                    4.079e-06,
                    4.1586e-06,
                    4.2395e-06,
                    4.3217e-06,
                    4.4034e-06,
                    4.4854e-06,
                    4.5676e-06,
                    4.6502e-06,
                    4.733e-06,
                    4.8166e-06,
                    4.9013e-06,
                    4.9868e-06,
                    5.0732e-06,
                    5.1603e-06,
                    5.2478e-06,
                    5.3355e-06,
                    5.4237e-06,
                    5.5123e-06,
                    5.6011e-06,
                    5.6905e-06,
                    5.7802e-06,
                    5.8701e-06,
                    5.9602e-06,
                    6.0505e-06,
                    6.1422e-06,
                    6.234e-06,
                    6.3262e-06,
                    6.4189e-06,
                    6.512e-06,
                    6.6056e-06,
                    6.6999e-06,
                    6.7946e-06,
                    6.8898e-06,
                    6.9857e-06,
                    7.082e-06,
                    7.1786e-06,
                    7.2757e-06,
                    7.3728e-06,
                    7.4704e-06,
                    7.5743e-06,
                    7.6843e-06,
                    7.8008e-06,
                    7.9232e-06,
                    8.0516e-06,
                    8.1865e-06,
                    8.3275e-06,
                    8.4744e-06,
                    8.6273e-06,
                    8.7878e-06,
                    8.9559e-06,
                    9.1315e-06,
                    9.3151e-06,
                    9.5066e-06,
                    9.7446e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [
                    1.2526e-08,
                    2.4126e-08,
                    3.4778e-08,
                    4.4457e-08,
                    5.3142e-08,
                    6.1478e-08,
                    6.9434e-08,
                    7.698e-08,
                    8.4086e-08,
                    9.0724e-08,
                    9.6645e-08,
                    1.0189e-07,
                    1.0644e-07,
                    1.1026e-07,
                    1.1311e-07,
                    1.148e-07,
                    1.1532e-07,
                    1.1465e-07,
                    1.1279e-07,
                    1.1531e-07,
                    1.1804e-07,
                    1.21e-07,
                    1.2421e-07,
                    1.2766e-07,
                    1.3137e-07,
                    1.334e-07,
                    1.338e-07,
                    1.3261e-07,
                    1.2988e-07,
                    1.2564e-07,
                    1.2081e-07,
                    1.157e-07,
                    1.1033e-07,
                    1.0472e-07,
                    9.9104e-08,
                    9.2998e-08,
                    8.6561e-08,
                    7.9828e-08,
                    7.2834e-08,
                    6.0366e-08,
                    4.7583e-08,
                    3.4492e-08,
                    2.1118e-08,
                    7.4871e-09,
                    -0.000000006377,
                    -0.000000019559,
                    -0.000000031606,
                    -0.000000042524,
                    -0.000000052318,
                    -0.000000060995,
                    -0.000000070436,
                    -0.000000079687,
                    -0.00000008887,
                    -0.000000097968,
                    -0.00000010698,
                    -0.00000011537,
                    -0.00000012288,
                    -0.00000012972,
                    -0.0000001359,
                    -0.00000014157,
                    -0.00000014711,
                    -0.00000015249,
                    -0.00000015766,
                    -0.00000016254,
                    -0.00000016742,
                    -0.00000017189,
                    -0.00000017632,
                    -0.00000018069,
                    -0.00000018501,
                    -0.00000018932,
                    -0.00000019251,
                    -0.00000019574,
                    -0.00000019869,
                    -0.0000002014,
                    -0.00000020389,
                    -0.00000020603,
                    -0.00000020767,
                    -0.00000020919,
                    -0.00000021024,
                    -0.00000021089,
                    -0.00000021133,
                    -0.00000021154,
                    -0.00000021161,
                    -0.00000021172,
                    -0.00000021156,
                    -0.00000021111,
                    -0.00000021041,
                    -0.00000020942,
                    -0.00000020847,
                    -0.00000020771,
                    -0.00000020256,
                    -0.00000019332,
                    -0.00000018017,
                    -0.00000016309,
                    -0.00000014042,
                    -0.00000011203,
                    -0.000000078247,
                    -0.000000038322,
                    7.5724e-09,
                    9.8026e-08,
                    2.0452e-07,
                    3.2081e-07,
                    4.3937e-07,
                    5.6742e-07,
                    7.09e-07,
                    8.6284e-07,
                    1.0264e-06,
                    1.1955e-06,
                    1.3754e-06,
                    1.5724e-06,
                    1.7771e-06,
                    1.9914e-06,
                    2.2165e-06,
                    2.4533e-06,
                    2.6963e-06,
                    2.945e-06,
                    3.2008e-06,
                    3.469e-06,
                    3.7519e-06,
                    3.9968e-06,
                    4.2267e-06,
                    4.4523e-06,
                    4.678e-06,
                    4.9136e-06,
                    5.1231e-06,
                    5.3279e-06,
                    5.5278e-06,
                    5.7377e-06,
                    5.9433e-06,
                    6.136e-06,
                    6.319e-06,
                    6.4936e-06,
                    6.6403e-06,
                    6.7669e-06,
                    6.8922e-06,
                    7.0016e-06,
                    7.0968e-06,
                    7.1756e-06,
                    7.2418e-06,
                    7.3077e-06,
                    7.3782e-06,
                    7.4633e-06,
                    7.5374e-06,
                    7.6034e-06,
                    7.6707e-06,
                    7.7141e-06,
                    7.7495e-06,
                    7.7632e-06,
                    7.7616e-06,
                    7.771e-06,
                    7.7509e-06,
                    7.7201e-06,
                    7.6913e-06,
                    7.6514e-06,
                    7.5889e-06,
                    7.5431e-06,
                    7.4924e-06,
                    7.4206e-06,
                    7.34e-06,
                    7.3018e-06,
                    7.2178e-06,
                    7.0903e-06,
                    6.9623e-06,
                    6.8132e-06,
                    6.6209e-06,
                    6.4409e-06,
                    6.2567e-06,
                    6.0771e-06,
                    5.8964e-06,
                    5.7038e-06,
                    5.5241e-06,
                    5.3475e-06
                ],
                "Land_CH4": 0.01,
                "Land_CH4_timeseries": [
                    1.0232e-07,
                    2.0579e-07,
                    3.1044e-07,
                    4.1624e-07,
                    5.2321e-07,
                    6.3134e-07,
                    7.4063e-07,
                    8.5108e-07,
                    9.627e-07,
                    1.0755e-06,
                    1.1847e-06,
                    1.2905e-06,
                    1.3927e-06,
                    1.4915e-06,
                    1.5867e-06,
                    1.6784e-06,
                    1.7666e-06,
                    1.8512e-06,
                    1.9324e-06,
                    2.01e-06,
                    2.0863e-06,
                    2.161e-06,
                    2.2344e-06,
                    2.3063e-06,
                    2.3768e-06,
                    2.4459e-06,
                    2.5135e-06,
                    2.5797e-06,
                    2.6444e-06,
                    2.7078e-06,
                    2.7737e-06,
                    2.8421e-06,
                    2.9132e-06,
                    2.9868e-06,
                    3.0629e-06,
                    3.1417e-06,
                    3.223e-06,
                    3.3069e-06,
                    3.3933e-06,
                    3.4823e-06,
                    3.5715e-06,
                    3.6609e-06,
                    3.7505e-06,
                    3.8402e-06,
                    3.9302e-06,
                    4.0203e-06,
                    4.1106e-06,
                    4.2011e-06,
                    4.2918e-06,
                    4.3827e-06,
                    4.4738e-06,
                    4.5651e-06,
                    4.6565e-06,
                    4.7481e-06,
                    4.84e-06,
                    4.932e-06,
                    5.0242e-06,
                    5.1166e-06,
                    5.2091e-06,
                    5.3019e-06,
                    5.3949e-06,
                    5.488e-06,
                    5.5813e-06,
                    5.6748e-06,
                    5.7685e-06,
                    5.8624e-06,
                    5.9565e-06,
                    6.0508e-06,
                    6.1452e-06,
                    6.2399e-06,
                    6.3347e-06,
                    6.4297e-06,
                    6.5249e-06,
                    6.6203e-06,
                    6.7159e-06,
                    6.8116e-06,
                    6.9076e-06,
                    7.0037e-06,
                    7.1001e-06,
                    7.1966e-06,
                    7.2933e-06,
                    7.3902e-06,
                    7.4873e-06,
                    7.5845e-06,
                    7.682e-06,
                    7.7854e-06,
                    7.8948e-06,
                    8.0102e-06,
                    8.1317e-06,
                    8.2593e-06,
                    8.389e-06,
                    8.5208e-06,
                    8.6546e-06,
                    8.7904e-06,
                    8.9282e-06,
                    9.068e-06,
                    9.2097e-06,
                    9.3534e-06,
                    9.4991e-06,
                    9.6466e-06,
                    9.8012e-06,
                    9.9636e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_N2O": 0.02,
                "Total_N2O_timeseries": [
                    2.1486e-08,
                    4.3254e-08,
                    6.5297e-08,
                    8.7608e-08,
                    1.1018e-07,
                    1.3299e-07,
                    1.5603e-07,
                    1.7929e-07,
                    2.0273e-07,
                    2.2636e-07,
                    2.5013e-07,
                    2.7407e-07,
                    2.9815e-07,
                    3.2239e-07,
                    3.4678e-07,
                    3.7131e-07,
                    3.96e-07,
                    4.2084e-07,
                    4.4584e-07,
                    4.7099e-07,
                    4.9642e-07,
                    5.2233e-07,
                    5.4885e-07,
                    5.7611e-07,
                    6.0416e-07,
                    6.3301e-07,
                    6.6263e-07,
                    6.9295e-07,
                    7.2384e-07,
                    7.5514e-07,
                    7.8673e-07,
                    8.1859e-07,
                    8.507e-07,
                    8.8305e-07,
                    9.1562e-07,
                    9.4841e-07,
                    9.8142e-07,
                    1.0147e-06,
                    1.0481e-06,
                    1.0808e-06,
                    1.115e-06,
                    1.1507e-06,
                    1.1878e-06,
                    1.2263e-06,
                    1.2659e-06,
                    1.3065e-06,
                    1.348e-06,
                    1.3903e-06,
                    1.4332e-06,
                    1.4765e-06,
                    1.52e-06,
                    1.5635e-06,
                    1.607e-06,
                    1.6504e-06,
                    1.6937e-06,
                    1.7367e-06,
                    1.7797e-06,
                    1.8226e-06,
                    1.8655e-06,
                    1.9086e-06,
                    1.952e-06,
                    1.9957e-06,
                    2.0397e-06,
                    2.084e-06,
                    2.1286e-06,
                    2.1735e-06,
                    2.2187e-06,
                    2.2643e-06,
                    2.3103e-06,
                    2.3566e-06,
                    2.4033e-06,
                    2.4506e-06,
                    2.4984e-06,
                    2.5468e-06,
                    2.5959e-06,
                    2.6456e-06,
                    2.6959e-06,
                    2.7468e-06,
                    2.7983e-06,
                    2.8503e-06,
                    2.9028e-06,
                    2.9558e-06,
                    3.0094e-06,
                    3.0636e-06,
                    3.1183e-06,
                    3.1736e-06,
                    3.2294e-06,
                    3.2856e-06,
                    3.3421e-06,
                    3.3989e-06,
                    3.4571e-06,
                    3.5185e-06,
                    3.5847e-06,
                    3.6567e-06,
                    3.7349e-06,
                    3.8196e-06,
                    3.9101e-06,
                    4.0057e-06,
                    4.1048e-06,
                    4.2057e-06,
                    4.3072e-06,
                    4.4095e-06,
                    4.5126e-06,
                    4.6167e-06,
                    4.7218e-06,
                    4.8279e-06,
                    4.9352e-06,
                    5.0436e-06,
                    5.1532e-06,
                    5.2641e-06,
                    5.3759e-06,
                    5.4965e-06,
                    5.6194e-06,
                    5.7353e-06,
                    5.8564e-06,
                    5.9798e-06,
                    6.1078e-06,
                    6.2365e-06,
                    6.369e-06,
                    6.4982e-06,
                    6.6306e-06,
                    6.7641e-06,
                    6.9036e-06,
                    7.043e-06,
                    7.1771e-06,
                    7.3149e-06,
                    7.4522e-06,
                    7.5973e-06,
                    7.7414e-06,
                    7.8822e-06,
                    8.0187e-06,
                    8.1528e-06,
                    8.2852e-06,
                    8.4207e-06,
                    8.5579e-06,
                    8.695e-06,
                    8.8332e-06,
                    8.9721e-06,
                    9.1153e-06,
                    9.2632e-06,
                    9.4107e-06,
                    9.5576e-06,
                    9.7035e-06,
                    9.8495e-06,
                    9.9927e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_N2O": 0.03,
                "Fossil_N2O_timeseries": [
                    1.5955e-08,
                    3.2081e-08,
                    4.8377e-08,
                    6.4841e-08,
                    8.1472e-08,
                    9.8266e-08,
                    1.1522e-07,
                    1.3234e-07,
                    1.496e-07,
                    1.6702e-07,
                    1.8459e-07,
                    2.023e-07,
                    2.2016e-07,
                    2.3817e-07,
                    2.5632e-07,
                    2.7462e-07,
                    2.9306e-07,
                    3.1165e-07,
                    3.3039e-07,
                    3.4928e-07,
                    3.6834e-07,
                    3.876e-07,
                    4.071e-07,
                    4.2685e-07,
                    4.4687e-07,
                    4.6716e-07,
                    4.8771e-07,
                    5.0851e-07,
                    5.2954e-07,
                    5.5076e-07,
                    5.7215e-07,
                    5.9372e-07,
                    6.1544e-07,
                    6.3733e-07,
                    6.5938e-07,
                    6.8159e-07,
                    7.0396e-07,
                    7.2649e-07,
                    7.4918e-07,
                    7.7234e-07,
                    7.9574e-07,
                    8.1939e-07,
                    8.4329e-07,
                    8.6746e-07,
                    8.9189e-07,
                    9.1659e-07,
                    9.4157e-07,
                    9.6684e-07,
                    9.924e-07,
                    1.0183e-06,
                    1.0444e-06,
                    1.0709e-06,
                    1.0978e-06,
                    1.125e-06,
                    1.1526e-06,
                    1.1805e-06,
                    1.2088e-06,
                    1.2375e-06,
                    1.2665e-06,
                    1.2957e-06,
                    1.3253e-06,
                    1.3551e-06,
                    1.3851e-06,
                    1.4154e-06,
                    1.4458e-06,
                    1.4766e-06,
                    1.5075e-06,
                    1.5387e-06,
                    1.5701e-06,
                    1.6018e-06,
                    1.6338e-06,
                    1.6661e-06,
                    1.6988e-06,
                    1.7318e-06,
                    1.7651e-06,
                    1.7988e-06,
                    1.8328e-06,
                    1.8671e-06,
                    1.9016e-06,
                    1.9364e-06,
                    1.9714e-06,
                    2.0066e-06,
                    2.042e-06,
                    2.0776e-06,
                    2.1134e-06,
                    2.1494e-06,
                    2.1857e-06,
                    2.2221e-06,
                    2.2587e-06,
                    2.2955e-06,
                    2.3325e-06,
                    2.3696e-06,
                    2.4069e-06,
                    2.4443e-06,
                    2.4819e-06,
                    2.5197e-06,
                    2.5576e-06,
                    2.5957e-06,
                    2.634e-06,
                    2.6725e-06,
                    2.7113e-06,
                    2.7505e-06,
                    2.79e-06,
                    2.8301e-06,
                    2.8707e-06,
                    2.9118e-06,
                    2.9535e-06,
                    2.9958e-06,
                    3.0386e-06,
                    3.082e-06,
                    3.126e-06,
                    3.1707e-06,
                    3.216e-06,
                    3.2621e-06,
                    3.3089e-06,
                    3.3565e-06,
                    3.4047e-06,
                    3.4535e-06,
                    3.5028e-06,
                    3.5492e-06,
                    3.5969e-06,
                    3.6469e-06,
                    3.7005e-06,
                    3.7507e-06,
                    3.7974e-06,
                    3.8475e-06,
                    3.8964e-06,
                    3.9519e-06,
                    4.0055e-06,
                    4.0566e-06,
                    4.1035e-06,
                    4.1474e-06,
                    4.1883e-06,
                    4.2314e-06,
                    4.2764e-06,
                    4.3215e-06,
                    4.3676e-06,
                    4.4148e-06,
                    4.4666e-06,
                    4.5221e-06,
                    4.5809e-06,
                    4.641e-06,
                    4.7004e-06,
                    4.7599e-06,
                    4.8157e-06,
                    4.8725e-06,
                    4.9305e-06,
                    4.9892e-06,
                    5.0496e-06,
                    5.1101e-06,
                    5.1724e-06,
                    5.2363e-06,
                    5.3028e-06,
                    5.3753e-06,
                    5.4486e-06,
                    5.5187e-06,
                    5.5859e-06,
                    5.6527e-06,
                    5.7148e-06,
                    5.7789e-06,
                    5.8436e-06,
                    5.9067e-06,
                    5.9683e-06,
                    6.028e-06,
                    6.0839e-06,
                    6.1381e-06,
                    6.192e-06,
                    6.2471e-06,
                    6.301e-06,
                    6.3482e-06,
                    6.397e-06,
                    6.4418e-06
                ],
                "Land_N2O": 0.01,
                "Land_N2O_timeseries": [
                    5.5309e-09,
                    1.1172e-08,
                    1.692e-08,
                    2.2767e-08,
                    2.8704e-08,
                    3.4722e-08,
                    4.0809e-08,
                    4.6951e-08,
                    5.3132e-08,
                    5.9334e-08,
                    6.5547e-08,
                    7.1768e-08,
                    7.7994e-08,
                    8.4225e-08,
                    9.0459e-08,
                    9.6698e-08,
                    1.0294e-07,
                    1.0919e-07,
                    1.1545e-07,
                    1.2172e-07,
                    1.2809e-07,
                    1.3473e-07,
                    1.4176e-07,
                    1.4926e-07,
                    1.5729e-07,
                    1.6585e-07,
                    1.7492e-07,
                    1.8444e-07,
                    1.943e-07,
                    2.0438e-07,
                    2.1458e-07,
                    2.2488e-07,
                    2.3526e-07,
                    2.4572e-07,
                    2.5624e-07,
                    2.6682e-07,
                    2.7746e-07,
                    2.8817e-07,
                    2.9895e-07,
                    3.0845e-07,
                    3.1927e-07,
                    3.3134e-07,
                    3.4455e-07,
                    3.588e-07,
                    3.7397e-07,
                    3.8991e-07,
                    4.0648e-07,
                    4.2351e-07,
                    4.4083e-07,
                    4.5825e-07,
                    4.7557e-07,
                    4.9261e-07,
                    5.0927e-07,
                    5.2543e-07,
                    5.4108e-07,
                    5.5619e-07,
                    5.7082e-07,
                    5.8506e-07,
                    5.9902e-07,
                    6.1289e-07,
                    6.2677e-07,
                    6.4067e-07,
                    6.5463e-07,
                    6.6865e-07,
                    6.8274e-07,
                    6.9693e-07,
                    7.1122e-07,
                    7.2561e-07,
                    7.4011e-07,
                    7.5473e-07,
                    7.695e-07,
                    7.8445e-07,
                    7.9963e-07,
                    8.1507e-07,
                    8.3079e-07,
                    8.468e-07,
                    8.6312e-07,
                    8.7975e-07,
                    8.9667e-07,
                    9.1386e-07,
                    9.3136e-07,
                    9.4919e-07,
                    9.6739e-07,
                    9.8596e-07,
                    1.0049e-06,
                    1.0242e-06,
                    1.0437e-06,
                    1.0635e-06,
                    1.0835e-06,
                    1.1035e-06,
                    1.1246e-06,
                    1.1489e-06,
                    1.1778e-06,
                    1.2123e-06,
                    1.253e-06,
                    1.2999e-06,
                    1.3525e-06,
                    1.41e-06,
                    1.4708e-06,
                    1.5332e-06,
                    1.5959e-06,
                    1.659e-06,
                    1.7226e-06,
                    1.7866e-06,
                    1.8511e-06,
                    1.9161e-06,
                    1.9817e-06,
                    2.0479e-06,
                    2.1146e-06,
                    2.182e-06,
                    2.2498e-06,
                    2.3258e-06,
                    2.4034e-06,
                    2.4732e-06,
                    2.5474e-06,
                    2.6233e-06,
                    2.7031e-06,
                    2.783e-06,
                    2.8661e-06,
                    2.949e-06,
                    3.0336e-06,
                    3.1172e-06,
                    3.2031e-06,
                    3.2922e-06,
                    3.3797e-06,
                    3.4674e-06,
                    3.5558e-06,
                    3.6454e-06,
                    3.7358e-06,
                    3.8255e-06,
                    3.9152e-06,
                    4.0054e-06,
                    4.0969e-06,
                    4.1893e-06,
                    4.2815e-06,
                    4.3735e-06,
                    4.4656e-06,
                    4.5573e-06,
                    4.6487e-06,
                    4.741e-06,
                    4.8298e-06,
                    4.9166e-06,
                    5.0031e-06,
                    5.0895e-06,
                    5.177e-06,
                    5.2653e-06,
                    5.3522e-06,
                    5.4389e-06,
                    5.5278e-06,
                    5.5846e-06,
                    5.641e-06,
                    5.7294e-06,
                    5.8161e-06,
                    5.9112e-06,
                    6.0005e-06,
                    6.0885e-06,
                    6.1762e-06,
                    6.2657e-06,
                    6.3555e-06,
                    6.4466e-06,
                    6.5378e-06,
                    6.6262e-06,
                    6.7156e-06,
                    6.8042e-06,
                    6.8947e-06,
                    6.9868e-06,
                    7.0795e-06,
                    7.1664e-06,
                    7.2548e-06,
                    7.3408e-06,
                    7.4279e-06,
                    7.5151e-06
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            6.13766,
                            50.12995
                        ],
                        [
                            6.0249,
                            50.18278
                        ],
                        [
                            5.89527,
                            50.11222
                        ],
                        [
                            5.83197,
                            49.97698
                        ],
                        [
                            5.77704,
                            49.96095
                        ],
                        [
                            5.77704,
                            49.88406
                        ],
                        [
                            5.74,
                            49.83566
                        ],
                        [
                            5.90967,
                            49.66343
                        ],
                        [
                            5.87156,
                            49.57452
                        ],
                        [
                            5.81812,
                            49.54631
                        ],
                        [
                            5.86641,
                            49.50029
                        ],
                        [
                            5.98582,
                            49.45617
                        ],
                        [
                            6.25518,
                            49.50922
                        ],
                        [
                            6.36711,
                            49.46951
                        ],
                        [
                            6.35812,
                            49.57232
                        ],
                        [
                            6.50702,
                            49.71264
                        ],
                        [
                            6.51482,
                            49.80407
                        ],
                        [
                            6.40138,
                            49.82023
                        ],
                        [
                            6.25911,
                            49.88359
                        ],
                        [
                            6.11293,
                            50.05973
                        ],
                        [
                            6.13766,
                            50.12995
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "MAC",
                "Country": "Macau",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    6.3327e-09,
                    1.2685e-08,
                    1.9057e-08,
                    2.5449e-08,
                    3.186e-08,
                    3.8291e-08,
                    4.4742e-08,
                    5.1212e-08,
                    5.7702e-08,
                    6.4212e-08,
                    7.0742e-08,
                    7.729e-08,
                    8.3858e-08,
                    9.0446e-08,
                    9.7053e-08,
                    1.0368e-07,
                    1.1033e-07,
                    1.1699e-07,
                    1.2368e-07,
                    1.3038e-07,
                    1.3711e-07,
                    1.4385e-07,
                    1.5062e-07,
                    1.574e-07,
                    1.6421e-07,
                    1.7105e-07,
                    1.779e-07,
                    1.8477e-07,
                    1.9166e-07,
                    1.9858e-07,
                    2.0551e-07,
                    2.1247e-07,
                    2.1944e-07,
                    2.2643e-07,
                    2.3344e-07,
                    2.4048e-07,
                    2.4753e-07,
                    2.546e-07,
                    2.6169e-07,
                    2.688e-07,
                    2.7594e-07,
                    2.8309e-07,
                    2.9027e-07,
                    2.9746e-07,
                    3.0468e-07,
                    3.1191e-07,
                    3.1917e-07,
                    3.2645e-07,
                    3.3375e-07,
                    3.4107e-07,
                    3.4845e-07,
                    3.5588e-07,
                    3.6336e-07,
                    3.7091e-07,
                    3.785e-07,
                    3.8616e-07,
                    3.9386e-07,
                    4.0163e-07,
                    4.0945e-07,
                    4.1732e-07,
                    4.2525e-07,
                    4.3323e-07,
                    4.4127e-07,
                    4.4937e-07,
                    4.5752e-07,
                    4.6573e-07,
                    4.7399e-07,
                    4.8231e-07,
                    4.9069e-07,
                    4.9912e-07,
                    5.0756e-07,
                    5.1602e-07,
                    5.2449e-07,
                    5.3297e-07,
                    5.4146e-07,
                    5.4997e-07,
                    5.5848e-07,
                    5.6701e-07,
                    5.7554e-07,
                    5.8409e-07,
                    5.9314e-07,
                    6.027e-07,
                    6.1277e-07,
                    6.2334e-07,
                    6.3441e-07,
                    6.4598e-07,
                    6.5806e-07,
                    6.7064e-07,
                    6.8371e-07,
                    6.9729e-07,
                    7.1298e-07,
                    7.3084e-07,
                    7.5092e-07,
                    7.7327e-07,
                    7.9733e-07,
                    8.231e-07,
                    8.5057e-07,
                    8.7972e-07,
                    9.1053e-07,
                    9.4299e-07,
                    9.7556e-07,
                    1.0076e-06,
                    1.0386e-06,
                    1.0789e-06,
                    1.1174e-06,
                    1.1563e-06,
                    1.1957e-06,
                    1.2343e-06,
                    1.276e-06,
                    1.3247e-06,
                    1.3819e-06,
                    1.4513e-06,
                    1.5273e-06,
                    1.6148e-06,
                    1.7061e-06,
                    1.8082e-06,
                    1.9196e-06,
                    2.0351e-06,
                    2.1522e-06,
                    2.2913e-06,
                    2.4412e-06,
                    2.588e-06,
                    2.7319e-06,
                    2.8947e-06,
                    3.0694e-06,
                    3.2229e-06,
                    3.3995e-06,
                    3.6237e-06,
                    3.8495e-06,
                    4.1284e-06,
                    4.4095e-06,
                    4.6679e-06,
                    5.0169e-06,
                    5.331e-06,
                    5.7024e-06,
                    6.1386e-06,
                    6.6199e-06,
                    7.098e-06,
                    7.607e-06,
                    8.1158e-06,
                    8.6543e-06,
                    9.1968e-06,
                    9.7862e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    6.316e-09,
                    1.2651e-08,
                    1.9006e-08,
                    2.538e-08,
                    3.1773e-08,
                    3.8186e-08,
                    4.4619e-08,
                    5.1071e-08,
                    5.7542e-08,
                    6.4033e-08,
                    7.0544e-08,
                    7.7074e-08,
                    8.3623e-08,
                    9.0192e-08,
                    9.678e-08,
                    1.0339e-07,
                    1.1002e-07,
                    1.1666e-07,
                    1.2333e-07,
                    1.3001e-07,
                    1.3672e-07,
                    1.4344e-07,
                    1.5019e-07,
                    1.5695e-07,
                    1.6374e-07,
                    1.7054e-07,
                    1.7737e-07,
                    1.8421e-07,
                    1.9108e-07,
                    1.9796e-07,
                    2.0487e-07,
                    2.1179e-07,
                    2.1873e-07,
                    2.2569e-07,
                    2.3267e-07,
                    2.3967e-07,
                    2.4669e-07,
                    2.5373e-07,
                    2.6079e-07,
                    2.6787e-07,
                    2.7496e-07,
                    2.8208e-07,
                    2.8922e-07,
                    2.9638e-07,
                    3.0355e-07,
                    3.1075e-07,
                    3.1797e-07,
                    3.252e-07,
                    3.3246e-07,
                    3.3973e-07,
                    3.4707e-07,
                    3.5445e-07,
                    3.6189e-07,
                    3.6938e-07,
                    3.7693e-07,
                    3.8453e-07,
                    3.9218e-07,
                    3.9989e-07,
                    4.0766e-07,
                    4.1547e-07,
                    4.2334e-07,
                    4.3127e-07,
                    4.3925e-07,
                    4.4728e-07,
                    4.5536e-07,
                    4.635e-07,
                    4.7169e-07,
                    4.7994e-07,
                    4.8824e-07,
                    4.9659e-07,
                    5.0496e-07,
                    5.1333e-07,
                    5.2172e-07,
                    5.3011e-07,
                    5.3852e-07,
                    5.4693e-07,
                    5.5535e-07,
                    5.6378e-07,
                    5.7222e-07,
                    5.8067e-07,
                    5.8962e-07,
                    5.9907e-07,
                    6.0903e-07,
                    6.1948e-07,
                    6.3044e-07,
                    6.4189e-07,
                    6.5384e-07,
                    6.6628e-07,
                    6.7923e-07,
                    6.9267e-07,
                    7.0821e-07,
                    7.2592e-07,
                    7.4583e-07,
                    7.6799e-07,
                    7.9186e-07,
                    8.1741e-07,
                    8.4465e-07,
                    8.7355e-07,
                    9.0411e-07,
                    9.3629e-07,
                    9.6857e-07,
                    1.0003e-06,
                    1.031e-06,
                    1.071e-06,
                    1.1092e-06,
                    1.1477e-06,
                    1.1868e-06,
                    1.225e-06,
                    1.2663e-06,
                    1.3146e-06,
                    1.3712e-06,
                    1.44e-06,
                    1.5152e-06,
                    1.6019e-06,
                    1.6923e-06,
                    1.7936e-06,
                    1.9043e-06,
                    2.019e-06,
                    2.1353e-06,
                    2.2735e-06,
                    2.4225e-06,
                    2.5683e-06,
                    2.7113e-06,
                    2.873e-06,
                    3.0467e-06,
                    3.1993e-06,
                    3.3748e-06,
                    3.598e-06,
                    3.8225e-06,
                    4.1001e-06,
                    4.3802e-06,
                    4.6375e-06,
                    4.9857e-06,
                    5.2989e-06,
                    5.6694e-06,
                    6.1047e-06,
                    6.585e-06,
                    7.062e-06,
                    7.5701e-06,
                    8.0779e-06,
                    8.6154e-06,
                    9.1569e-06,
                    9.7454e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [
                    1.6676e-11,
                    3.3686e-11,
                    5.1016e-11,
                    6.8644e-11,
                    8.6547e-11,
                    1.0469e-10,
                    1.2304e-10,
                    1.4156e-10,
                    1.602e-10,
                    1.789e-10,
                    1.9763e-10,
                    2.1639e-10,
                    2.3516e-10,
                    2.5395e-10,
                    2.7275e-10,
                    2.9155e-10,
                    3.1038e-10,
                    3.2922e-10,
                    3.4809e-10,
                    3.6699e-10,
                    3.8621e-10,
                    4.0623e-10,
                    4.2742e-10,
                    4.5004e-10,
                    4.7424e-10,
                    5.0005e-10,
                    5.274e-10,
                    5.561e-10,
                    5.8585e-10,
                    6.1624e-10,
                    6.4699e-10,
                    6.7804e-10,
                    7.0934e-10,
                    7.4086e-10,
                    7.7258e-10,
                    8.0449e-10,
                    8.3658e-10,
                    8.6887e-10,
                    9.0137e-10,
                    9.3639e-10,
                    9.7225e-10,
                    1.009e-09,
                    1.0466e-09,
                    1.0851e-09,
                    1.1246e-09,
                    1.1651e-09,
                    1.2066e-09,
                    1.2491e-09,
                    1.2927e-09,
                    1.3373e-09,
                    1.383e-09,
                    1.4298e-09,
                    1.4777e-09,
                    1.5267e-09,
                    1.5769e-09,
                    1.6284e-09,
                    1.6811e-09,
                    1.7352e-09,
                    1.7906e-09,
                    1.8476e-09,
                    1.9062e-09,
                    1.9666e-09,
                    2.0289e-09,
                    2.0933e-09,
                    2.1597e-09,
                    2.2284e-09,
                    2.2992e-09,
                    2.3723e-09,
                    2.4477e-09,
                    2.5252e-09,
                    2.6049e-09,
                    2.6868e-09,
                    2.7707e-09,
                    2.8569e-09,
                    2.9452e-09,
                    3.0358e-09,
                    3.1288e-09,
                    3.2243e-09,
                    3.3223e-09,
                    3.4232e-09,
                    3.527e-09,
                    3.6339e-09,
                    3.7442e-09,
                    3.858e-09,
                    3.9754e-09,
                    4.0967e-09,
                    4.2219e-09,
                    4.3514e-09,
                    4.4852e-09,
                    4.6235e-09,
                    4.7683e-09,
                    4.923e-09,
                    5.0903e-09,
                    5.2723e-09,
                    5.4701e-09,
                    5.6846e-09,
                    5.9157e-09,
                    6.1627e-09,
                    6.4242e-09,
                    6.6982e-09,
                    6.9834e-09,
                    7.2802e-09,
                    7.5888e-09,
                    7.9094e-09,
                    8.2422e-09,
                    8.5875e-09,
                    8.9453e-09,
                    9.3159e-09,
                    9.6995e-09,
                    1.0096e-08,
                    1.0674e-08,
                    1.1335e-08,
                    1.2149e-08,
                    1.2963e-08,
                    1.3777e-08,
                    1.4591e-08,
                    1.5369e-08,
                    1.6124e-08,
                    1.688e-08,
                    1.7794e-08,
                    1.8726e-08,
                    1.9669e-08,
                    2.0648e-08,
                    2.1627e-08,
                    2.2642e-08,
                    2.3656e-08,
                    2.4694e-08,
                    2.5755e-08,
                    2.7028e-08,
                    2.8301e-08,
                    2.9366e-08,
                    3.04e-08,
                    3.1253e-08,
                    3.2106e-08,
                    3.2959e-08,
                    3.3941e-08,
                    3.4946e-08,
                    3.5961e-08,
                    3.6976e-08,
                    3.7935e-08,
                    3.8887e-08,
                    3.983e-08,
                    4.0786e-08,
                    4.1659e-08,
                    4.2521e-08,
                    4.3361e-08,
                    4.419e-08,
                    4.5232e-08,
                    4.6474e-08,
                    4.7483e-08,
                    4.8762e-08,
                    5.0115e-08,
                    5.1729e-08,
                    5.3072e-08,
                    5.471e-08,
                    5.6272e-08,
                    5.8058e-08,
                    5.9546e-08,
                    6.0973e-08,
                    6.24e-08,
                    6.3827e-08,
                    6.537e-08,
                    6.6857e-08,
                    6.84e-08,
                    7.0008e-08,
                    7.1625e-08,
                    7.3253e-08,
                    7.4787e-08,
                    7.6246e-08,
                    7.7838e-08,
                    7.935e-08,
                    8.0872e-08
                ],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    9.9e-09,
                    1.98e-08,
                    3.135e-08,
                    4.455e-08,
                    5.775e-08,
                    7.425e-08,
                    9.735e-08,
                    1.287e-07,
                    1.716e-07,
                    2.1945e-07,
                    2.772e-07,
                    3.366e-07,
                    4.0425e-07,
                    4.785e-07,
                    5.544e-07,
                    6.303e-07,
                    7.227e-07,
                    8.25e-07,
                    9.2895e-07,
                    1.0296e-06,
                    1.15e-06,
                    1.2837e-06,
                    1.3976e-06,
                    1.5361e-06,
                    1.7226e-06,
                    1.909e-06,
                    2.1467e-06,
                    2.3876e-06,
                    2.6053e-06,
                    2.9122e-06,
                    3.1845e-06,
                    3.5145e-06,
                    3.9088e-06,
                    4.3461e-06,
                    4.7801e-06,
                    5.2437e-06,
                    5.709e-06,
                    6.2007e-06,
                    6.6874e-06,
                    7.2188e-06,
                    7.7913e-06,
                    8.3457e-06,
                    8.9793e-06,
                    9.6492e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    9.9e-09,
                    1.98e-08,
                    3.135e-08,
                    4.455e-08,
                    5.775e-08,
                    7.425e-08,
                    9.735e-08,
                    1.287e-07,
                    1.716e-07,
                    2.1945e-07,
                    2.772e-07,
                    3.366e-07,
                    4.0425e-07,
                    4.785e-07,
                    5.544e-07,
                    6.303e-07,
                    7.227e-07,
                    8.25e-07,
                    9.2895e-07,
                    1.0296e-06,
                    1.15e-06,
                    1.2837e-06,
                    1.3976e-06,
                    1.5361e-06,
                    1.7226e-06,
                    1.909e-06,
                    2.1467e-06,
                    2.3876e-06,
                    2.6053e-06,
                    2.9122e-06,
                    3.1845e-06,
                    3.5145e-06,
                    3.9088e-06,
                    4.3461e-06,
                    4.7801e-06,
                    5.2437e-06,
                    5.709e-06,
                    6.2007e-06,
                    6.6874e-06,
                    7.2188e-06,
                    7.7913e-06,
                    8.3457e-06,
                    8.9793e-06,
                    9.6492e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [
                    6.0587e-09,
                    1.2134e-08,
                    1.8226e-08,
                    2.4335e-08,
                    3.0461e-08,
                    3.6603e-08,
                    4.2763e-08,
                    4.8939e-08,
                    5.5133e-08,
                    6.1343e-08,
                    6.7571e-08,
                    7.3816e-08,
                    8.0077e-08,
                    8.6355e-08,
                    9.265e-08,
                    9.8963e-08,
                    1.0529e-07,
                    1.1164e-07,
                    1.18e-07,
                    1.2438e-07,
                    1.3078e-07,
                    1.3719e-07,
                    1.4363e-07,
                    1.5007e-07,
                    1.5654e-07,
                    1.6302e-07,
                    1.6952e-07,
                    1.7603e-07,
                    1.8257e-07,
                    1.8912e-07,
                    1.9568e-07,
                    2.0226e-07,
                    2.0886e-07,
                    2.1548e-07,
                    2.2211e-07,
                    2.2876e-07,
                    2.3543e-07,
                    2.4211e-07,
                    2.4881e-07,
                    2.5552e-07,
                    2.6226e-07,
                    2.6901e-07,
                    2.7577e-07,
                    2.8256e-07,
                    2.8936e-07,
                    2.9617e-07,
                    3.0301e-07,
                    3.0986e-07,
                    3.1673e-07,
                    3.2361e-07,
                    3.3054e-07,
                    3.3753e-07,
                    3.4457e-07,
                    3.5165e-07,
                    3.5879e-07,
                    3.6598e-07,
                    3.7322e-07,
                    3.8051e-07,
                    3.8785e-07,
                    3.9524e-07,
                    4.0268e-07,
                    4.1018e-07,
                    4.1772e-07,
                    4.2531e-07,
                    4.3296e-07,
                    4.4065e-07,
                    4.484e-07,
                    4.5619e-07,
                    4.6404e-07,
                    4.7194e-07,
                    4.7985e-07,
                    4.8776e-07,
                    4.9569e-07,
                    5.0362e-07,
                    5.1155e-07,
                    5.1949e-07,
                    5.2744e-07,
                    5.3539e-07,
                    5.4335e-07,
                    5.5132e-07,
                    5.5978e-07,
                    5.6875e-07,
                    5.7821e-07,
                    5.8817e-07,
                    5.9863e-07,
                    6.0958e-07,
                    6.2103e-07,
                    6.3297e-07,
                    6.454e-07,
                    6.5832e-07,
                    6.7335e-07,
                    6.9053e-07,
                    7.0991e-07,
                    7.3154e-07,
                    7.5487e-07,
                    7.7988e-07,
                    8.0657e-07,
                    8.3492e-07,
                    8.6491e-07,
                    8.9653e-07,
                    9.2823e-07,
                    9.5937e-07,
                    9.8946e-07,
                    1.0189e-06,
                    1.0465e-06,
                    1.0727e-06,
                    1.0978e-06,
                    1.1221e-06,
                    1.1461e-06,
                    1.1704e-06,
                    1.1951e-06,
                    1.2204e-06,
                    1.2472e-06,
                    1.2755e-06,
                    1.306e-06,
                    1.3391e-06,
                    1.3749e-06,
                    1.4131e-06,
                    1.4528e-06,
                    1.4973e-06,
                    1.5429e-06,
                    1.5834e-06,
                    1.6243e-06,
                    1.6641e-06,
                    1.7024e-06,
                    1.7396e-06,
                    1.7748e-06,
                    1.8098e-06,
                    1.8462e-06,
                    1.8841e-06,
                    1.921e-06,
                    1.958e-06,
                    1.9957e-06,
                    2.0329e-06,
                    2.0698e-06,
                    2.1056e-06,
                    2.1427e-06,
                    2.18e-06,
                    2.2187e-06,
                    2.2555e-06,
                    2.295e-06,
                    2.3429e-06,
                    2.3925e-06,
                    2.4474e-06,
                    2.5084e-06,
                    2.57e-06,
                    2.639e-06,
                    2.7097e-06,
                    2.7808e-06,
                    2.8507e-06,
                    2.9228e-06,
                    2.9961e-06,
                    3.0716e-06,
                    3.1498e-06,
                    3.2277e-06,
                    3.3064e-06,
                    3.3839e-06,
                    3.4596e-06,
                    3.5362e-06,
                    3.6125e-06,
                    3.6895e-06,
                    3.7686e-06,
                    3.8508e-06,
                    3.9339e-06,
                    4.0205e-06,
                    4.1112e-06,
                    4.2025e-06,
                    4.2935e-06,
                    4.39e-06,
                    4.4868e-06,
                    4.5852e-06,
                    4.6832e-06
                ],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [
                    6.0587e-09,
                    1.2134e-08,
                    1.8226e-08,
                    2.4335e-08,
                    3.0461e-08,
                    3.6603e-08,
                    4.2763e-08,
                    4.8939e-08,
                    5.5133e-08,
                    6.1343e-08,
                    6.7571e-08,
                    7.3816e-08,
                    8.0077e-08,
                    8.6355e-08,
                    9.265e-08,
                    9.8963e-08,
                    1.0529e-07,
                    1.1164e-07,
                    1.18e-07,
                    1.2438e-07,
                    1.3078e-07,
                    1.3719e-07,
                    1.4363e-07,
                    1.5007e-07,
                    1.5654e-07,
                    1.6302e-07,
                    1.6952e-07,
                    1.7603e-07,
                    1.8257e-07,
                    1.8912e-07,
                    1.9568e-07,
                    2.0226e-07,
                    2.0886e-07,
                    2.1548e-07,
                    2.2211e-07,
                    2.2876e-07,
                    2.3543e-07,
                    2.4211e-07,
                    2.4881e-07,
                    2.5552e-07,
                    2.6226e-07,
                    2.6901e-07,
                    2.7577e-07,
                    2.8256e-07,
                    2.8936e-07,
                    2.9617e-07,
                    3.0301e-07,
                    3.0986e-07,
                    3.1673e-07,
                    3.2361e-07,
                    3.3054e-07,
                    3.3753e-07,
                    3.4457e-07,
                    3.5165e-07,
                    3.5879e-07,
                    3.6598e-07,
                    3.7322e-07,
                    3.8051e-07,
                    3.8785e-07,
                    3.9524e-07,
                    4.0268e-07,
                    4.1018e-07,
                    4.1772e-07,
                    4.2531e-07,
                    4.3296e-07,
                    4.4065e-07,
                    4.484e-07,
                    4.5619e-07,
                    4.6404e-07,
                    4.7194e-07,
                    4.7985e-07,
                    4.8776e-07,
                    4.9569e-07,
                    5.0362e-07,
                    5.1155e-07,
                    5.1949e-07,
                    5.2744e-07,
                    5.3539e-07,
                    5.4335e-07,
                    5.5132e-07,
                    5.5978e-07,
                    5.6875e-07,
                    5.7821e-07,
                    5.8817e-07,
                    5.9863e-07,
                    6.0958e-07,
                    6.2103e-07,
                    6.3297e-07,
                    6.454e-07,
                    6.5832e-07,
                    6.7335e-07,
                    6.9053e-07,
                    7.0991e-07,
                    7.3154e-07,
                    7.5487e-07,
                    7.7988e-07,
                    8.0657e-07,
                    8.3492e-07,
                    8.6491e-07,
                    8.9653e-07,
                    9.2823e-07,
                    9.5937e-07,
                    9.8946e-07,
                    1.0189e-06,
                    1.0465e-06,
                    1.0727e-06,
                    1.0978e-06,
                    1.1221e-06,
                    1.1461e-06,
                    1.1704e-06,
                    1.1949e-06,
                    1.2199e-06,
                    1.2464e-06,
                    1.2744e-06,
                    1.3046e-06,
                    1.3374e-06,
                    1.3729e-06,
                    1.4108e-06,
                    1.4502e-06,
                    1.4944e-06,
                    1.5396e-06,
                    1.5798e-06,
                    1.6203e-06,
                    1.6597e-06,
                    1.6976e-06,
                    1.7344e-06,
                    1.7692e-06,
                    1.8038e-06,
                    1.8397e-06,
                    1.8772e-06,
                    1.9137e-06,
                    1.9504e-06,
                    1.988e-06,
                    2.0251e-06,
                    2.0618e-06,
                    2.0974e-06,
                    2.1342e-06,
                    2.1713e-06,
                    2.2099e-06,
                    2.2465e-06,
                    2.2858e-06,
                    2.3335e-06,
                    2.383e-06,
                    2.4378e-06,
                    2.4987e-06,
                    2.5601e-06,
                    2.629e-06,
                    2.6996e-06,
                    2.7705e-06,
                    2.8403e-06,
                    2.9121e-06,
                    2.9853e-06,
                    3.0605e-06,
                    3.1384e-06,
                    3.2159e-06,
                    3.2943e-06,
                    3.3714e-06,
                    3.4468e-06,
                    3.5231e-06,
                    3.599e-06,
                    3.6757e-06,
                    3.7545e-06,
                    3.8364e-06,
                    3.9191e-06,
                    4.0054e-06,
                    4.0957e-06,
                    4.1866e-06,
                    4.2772e-06,
                    4.3735e-06,
                    4.47e-06,
                    4.5681e-06,
                    4.6659e-06
                ],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2.2146e-10,
                    4.7614e-10,
                    7.8618e-10,
                    1.0962e-09,
                    1.4063e-09,
                    1.7163e-09,
                    2.0153e-09,
                    2.3032e-09,
                    2.5911e-09,
                    2.9399e-09,
                    3.2942e-09,
                    3.6596e-09,
                    4.0361e-09,
                    4.4126e-09,
                    4.8002e-09,
                    5.1877e-09,
                    5.5863e-09,
                    5.996e-09,
                    6.4943e-09,
                    6.9926e-09,
                    7.2833e-09,
                    7.5428e-09,
                    7.6951e-09,
                    7.8473e-09,
                    7.9996e-09,
                    8.2072e-09,
                    8.4252e-09,
                    8.6536e-09,
                    8.8819e-09,
                    9.0532e-09,
                    9.2193e-09,
                    9.375e-09,
                    9.5314e-09,
                    9.6546e-09,
                    9.7674e-09,
                    9.8692e-09,
                    9.9605e-09,
                    1.013e-08,
                    1.0327e-08,
                    1.0414e-08,
                    1.0611e-08,
                    1.0808e-08,
                    1.1168e-08,
                    1.1417e-08,
                    1.1777e-08,
                    1.2085e-08,
                    1.2482e-08,
                    1.279e-08,
                    1.3098e-08,
                    1.3406e-08,
                    1.3714e-08,
                    1.4077e-08,
                    1.4408e-08,
                    1.4759e-08,
                    1.5137e-08,
                    1.5537e-08,
                    1.5948e-08,
                    1.6265e-08,
                    1.6495e-08,
                    1.6845e-08,
                    1.7103e-08,
                    1.7367e-08
                ],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [
                    2.7401e-10,
                    5.5097e-10,
                    8.3086e-10,
                    1.1137e-09,
                    1.3993e-09,
                    1.6878e-09,
                    1.9791e-09,
                    2.2731e-09,
                    2.5697e-09,
                    2.8689e-09,
                    3.1706e-09,
                    3.4748e-09,
                    3.7815e-09,
                    4.0908e-09,
                    4.4025e-09,
                    4.7167e-09,
                    5.0334e-09,
                    5.3526e-09,
                    5.6743e-09,
                    5.9986e-09,
                    6.3257e-09,
                    6.6565e-09,
                    6.9915e-09,
                    7.331e-09,
                    7.6752e-09,
                    8.0242e-09,
                    8.3778e-09,
                    8.7359e-09,
                    9.098e-09,
                    9.4634e-09,
                    9.8319e-09,
                    1.0203e-08,
                    1.0577e-08,
                    1.0954e-08,
                    1.1334e-08,
                    1.1717e-08,
                    1.2102e-08,
                    1.249e-08,
                    1.2881e-08,
                    1.3278e-08,
                    1.3678e-08,
                    1.4083e-08,
                    1.4491e-08,
                    1.4904e-08,
                    1.532e-08,
                    1.574e-08,
                    1.6165e-08,
                    1.6593e-08,
                    1.7026e-08,
                    1.7463e-08,
                    1.7904e-08,
                    1.8349e-08,
                    1.8799e-08,
                    1.9254e-08,
                    1.9713e-08,
                    2.0177e-08,
                    2.0645e-08,
                    2.1119e-08,
                    2.1597e-08,
                    2.2079e-08,
                    2.2567e-08,
                    2.3059e-08,
                    2.3556e-08,
                    2.4058e-08,
                    2.4565e-08,
                    2.5077e-08,
                    2.5595e-08,
                    2.6117e-08,
                    2.6645e-08,
                    2.7177e-08,
                    2.7715e-08,
                    2.8257e-08,
                    2.8804e-08,
                    2.9356e-08,
                    2.9913e-08,
                    3.0474e-08,
                    3.1041e-08,
                    3.1613e-08,
                    3.219e-08,
                    3.2773e-08,
                    3.3362e-08,
                    3.3956e-08,
                    3.4557e-08,
                    3.5165e-08,
                    3.578e-08,
                    3.6402e-08,
                    3.7032e-08,
                    3.7669e-08,
                    3.8315e-08,
                    3.8969e-08,
                    3.9633e-08,
                    4.0311e-08,
                    4.1007e-08,
                    4.1722e-08,
                    4.2458e-08,
                    4.3216e-08,
                    4.3997e-08,
                    4.48e-08,
                    4.5623e-08,
                    4.6465e-08,
                    4.7329e-08,
                    4.8224e-08,
                    4.9155e-08,
                    5.0129e-08,
                    5.1146e-08,
                    5.221e-08,
                    5.3319e-08,
                    5.4471e-08,
                    5.5662e-08,
                    5.6886e-08,
                    5.8085e-08,
                    5.9344e-08,
                    6.0711e-08,
                    6.2087e-08,
                    6.3471e-08,
                    6.4865e-08,
                    6.6247e-08,
                    6.7631e-08,
                    6.9035e-08,
                    7.1207e-08,
                    7.3342e-08,
                    7.5574e-08,
                    7.7959e-08,
                    8.052e-08,
                    8.3251e-08,
                    8.5774e-08,
                    8.8522e-08,
                    9.1274e-08,
                    9.4325e-08,
                    9.7611e-08,
                    1.0097e-07,
                    1.0453e-07,
                    1.0896e-07,
                    1.1356e-07,
                    1.1806e-07,
                    1.2418e-07,
                    1.3114e-07,
                    1.3795e-07,
                    1.4459e-07,
                    1.5124e-07,
                    1.5854e-07,
                    1.6645e-07,
                    1.7492e-07,
                    1.8411e-07,
                    1.9323e-07,
                    2.032e-07,
                    2.1352e-07,
                    2.2451e-07,
                    2.3578e-07,
                    2.4578e-07,
                    2.5569e-07,
                    2.6585e-07,
                    2.7622e-07,
                    2.875e-07,
                    2.9879e-07,
                    3.1062e-07,
                    3.23e-07,
                    3.3439e-07,
                    3.466e-07,
                    3.5722e-07,
                    3.6991e-07,
                    3.833e-07,
                    3.9479e-07,
                    4.0658e-07,
                    4.2217e-07,
                    4.3794e-07,
                    4.5443e-07,
                    4.6995e-07,
                    4.8572e-07,
                    4.9968e-07,
                    5.141e-07,
                    5.2879e-07
                ],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [
                    2.5733e-10,
                    5.1728e-10,
                    7.7984e-10,
                    1.045e-09,
                    1.3128e-09,
                    1.5831e-09,
                    1.856e-09,
                    2.1315e-09,
                    2.4095e-09,
                    2.69e-09,
                    2.973e-09,
                    3.2584e-09,
                    3.5464e-09,
                    3.8368e-09,
                    4.1297e-09,
                    4.4251e-09,
                    4.723e-09,
                    5.0234e-09,
                    5.3262e-09,
                    5.6316e-09,
                    5.9395e-09,
                    6.2503e-09,
                    6.5641e-09,
                    6.8809e-09,
                    7.2009e-09,
                    7.5241e-09,
                    7.8504e-09,
                    8.1798e-09,
                    8.5121e-09,
                    8.8472e-09,
                    9.1849e-09,
                    9.5252e-09,
                    9.868e-09,
                    1.0213e-08,
                    1.0562e-08,
                    1.0912e-08,
                    1.1265e-08,
                    1.1621e-08,
                    1.1979e-08,
                    1.2341e-08,
                    1.2706e-08,
                    1.3074e-08,
                    1.3445e-08,
                    1.3819e-08,
                    1.4195e-08,
                    1.4575e-08,
                    1.4958e-08,
                    1.5344e-08,
                    1.5733e-08,
                    1.6125e-08,
                    1.6521e-08,
                    1.6919e-08,
                    1.7321e-08,
                    1.7727e-08,
                    1.8136e-08,
                    1.8548e-08,
                    1.8964e-08,
                    1.9383e-08,
                    1.9806e-08,
                    2.0232e-08,
                    2.066e-08,
                    2.1092e-08,
                    2.1527e-08,
                    2.1965e-08,
                    2.2405e-08,
                    2.2849e-08,
                    2.3295e-08,
                    2.3745e-08,
                    2.4197e-08,
                    2.4652e-08,
                    2.511e-08,
                    2.557e-08,
                    2.6033e-08,
                    2.6499e-08,
                    2.6967e-08,
                    2.7439e-08,
                    2.7912e-08,
                    2.8389e-08,
                    2.8868e-08,
                    2.935e-08,
                    2.9835e-08,
                    3.0322e-08,
                    3.0813e-08,
                    3.1307e-08,
                    3.1805e-08,
                    3.2305e-08,
                    3.281e-08,
                    3.3318e-08,
                    3.383e-08,
                    3.4345e-08,
                    3.4864e-08,
                    3.5388e-08,
                    3.5916e-08,
                    3.6449e-08,
                    3.6988e-08,
                    3.7532e-08,
                    3.8082e-08,
                    3.8637e-08,
                    3.9199e-08,
                    3.9767e-08,
                    4.0346e-08,
                    4.0944e-08,
                    4.1567e-08,
                    4.2219e-08,
                    4.2904e-08,
                    4.3622e-08,
                    4.4374e-08,
                    4.5155e-08,
                    4.5962e-08,
                    4.679e-08,
                    4.7632e-08,
                    4.8486e-08,
                    4.9349e-08,
                    5.022e-08,
                    5.1101e-08,
                    5.199e-08,
                    5.2892e-08,
                    5.381e-08,
                    5.4747e-08,
                    5.6354e-08,
                    5.791e-08,
                    5.9564e-08,
                    6.1347e-08,
                    6.3305e-08,
                    6.541e-08,
                    6.7305e-08,
                    6.9414e-08,
                    7.1515e-08,
                    7.3792e-08,
                    7.6303e-08,
                    7.889e-08,
                    8.1675e-08,
                    8.5403e-08,
                    8.9305e-08,
                    9.3102e-08,
                    9.8441e-08,
                    1.0461e-07,
                    1.1064e-07,
                    1.165e-07,
                    1.2236e-07,
                    1.2888e-07,
                    1.3599e-07,
                    1.4366e-07,
                    1.5211e-07,
                    1.6048e-07,
                    1.697e-07,
                    1.7929e-07,
                    1.894e-07,
                    1.9964e-07,
                    2.0871e-07,
                    2.1754e-07,
                    2.2654e-07,
                    2.3566e-07,
                    2.4585e-07,
                    2.5586e-07,
                    2.6644e-07,
                    2.7743e-07,
                    2.8763e-07,
                    2.9872e-07,
                    3.0822e-07,
                    3.1979e-07,
                    3.32e-07,
                    3.4234e-07,
                    3.5294e-07,
                    3.673e-07,
                    3.8185e-07,
                    3.9713e-07,
                    4.1143e-07,
                    4.2596e-07,
                    4.3869e-07,
                    4.5186e-07,
                    4.6529e-07
                ],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": [
                    1.6676e-11,
                    3.3686e-11,
                    5.1016e-11,
                    6.8644e-11,
                    8.6547e-11,
                    1.0469e-10,
                    1.2304e-10,
                    1.4156e-10,
                    1.602e-10,
                    1.789e-10,
                    1.9763e-10,
                    2.1639e-10,
                    2.3516e-10,
                    2.5395e-10,
                    2.7275e-10,
                    2.9155e-10,
                    3.1038e-10,
                    3.2922e-10,
                    3.4809e-10,
                    3.6699e-10,
                    3.8621e-10,
                    4.0623e-10,
                    4.2742e-10,
                    4.5004e-10,
                    4.7424e-10,
                    5.0005e-10,
                    5.274e-10,
                    5.561e-10,
                    5.8585e-10,
                    6.1624e-10,
                    6.4699e-10,
                    6.7804e-10,
                    7.0934e-10,
                    7.4086e-10,
                    7.7258e-10,
                    8.0449e-10,
                    8.3658e-10,
                    8.6887e-10,
                    9.0137e-10,
                    9.3639e-10,
                    9.7225e-10,
                    1.009e-09,
                    1.0466e-09,
                    1.0851e-09,
                    1.1246e-09,
                    1.1651e-09,
                    1.2066e-09,
                    1.2491e-09,
                    1.2927e-09,
                    1.3373e-09,
                    1.383e-09,
                    1.4298e-09,
                    1.4777e-09,
                    1.5267e-09,
                    1.5769e-09,
                    1.6284e-09,
                    1.6811e-09,
                    1.7352e-09,
                    1.7906e-09,
                    1.8476e-09,
                    1.9062e-09,
                    1.9666e-09,
                    2.0289e-09,
                    2.0933e-09,
                    2.1597e-09,
                    2.2284e-09,
                    2.2992e-09,
                    2.3723e-09,
                    2.4477e-09,
                    2.5252e-09,
                    2.6049e-09,
                    2.6868e-09,
                    2.7707e-09,
                    2.8569e-09,
                    2.9452e-09,
                    3.0358e-09,
                    3.1288e-09,
                    3.2243e-09,
                    3.3223e-09,
                    3.4232e-09,
                    3.527e-09,
                    3.6339e-09,
                    3.7442e-09,
                    3.858e-09,
                    3.9754e-09,
                    4.0967e-09,
                    4.2219e-09,
                    4.3514e-09,
                    4.4852e-09,
                    4.6235e-09,
                    4.7683e-09,
                    4.923e-09,
                    5.0903e-09,
                    5.2723e-09,
                    5.4701e-09,
                    5.6846e-09,
                    5.9157e-09,
                    6.1627e-09,
                    6.4242e-09,
                    6.6982e-09,
                    6.9834e-09,
                    7.2802e-09,
                    7.5888e-09,
                    7.9094e-09,
                    8.2422e-09,
                    8.5875e-09,
                    8.9453e-09,
                    9.3159e-09,
                    9.6995e-09,
                    1.0096e-08,
                    1.0453e-08,
                    1.0858e-08,
                    1.1362e-08,
                    1.1867e-08,
                    1.2371e-08,
                    1.2875e-08,
                    1.3354e-08,
                    1.3821e-08,
                    1.4288e-08,
                    1.4854e-08,
                    1.5432e-08,
                    1.601e-08,
                    1.6612e-08,
                    1.7214e-08,
                    1.7841e-08,
                    1.8468e-08,
                    1.9108e-08,
                    1.9759e-08,
                    2.0534e-08,
                    2.1308e-08,
                    2.2083e-08,
                    2.2857e-08,
                    2.3558e-08,
                    2.4259e-08,
                    2.496e-08,
                    2.5734e-08,
                    2.6521e-08,
                    2.7308e-08,
                    2.8095e-08,
                    2.8881e-08,
                    2.9668e-08,
                    3.0455e-08,
                    3.1254e-08,
                    3.2004e-08,
                    3.2754e-08,
                    3.3492e-08,
                    3.4229e-08,
                    3.5102e-08,
                    3.6147e-08,
                    3.7069e-08,
                    3.8151e-08,
                    3.9307e-08,
                    4.0561e-08,
                    4.1655e-08,
                    4.2933e-08,
                    4.4187e-08,
                    4.5577e-08,
                    4.6757e-08,
                    4.7875e-08,
                    4.8994e-08,
                    5.0113e-08,
                    5.1293e-08,
                    5.2449e-08,
                    5.3641e-08,
                    5.4871e-08,
                    5.6088e-08,
                    5.7305e-08,
                    5.8522e-08,
                    5.9751e-08,
                    6.0993e-08,
                    6.2247e-08,
                    6.3505e-08
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            113.55041,
                            22.11336
                        ],
                        [
                            113.57201,
                            22.11333
                        ],
                        [
                            113.57223,
                            22.13751
                        ],
                        [
                            113.55041,
                            22.11336
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "MDG",
                "Country": "Madagascar",
                "Total_3GHG": 0.26,
                "Total_3GHG_timeseries": [
                    5.3268e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.004,
                    0.004,
                    0.004,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0043
                ],
                "Fossil_3GHG": 0.04,
                "Fossil_3GHG_timeseries": [
                    8.013e-08,
                    1.6079e-07,
                    2.4255e-07,
                    3.2543e-07,
                    4.0943e-07,
                    4.9457e-07,
                    5.8085e-07,
                    6.6827e-07,
                    7.5684e-07,
                    8.4657e-07,
                    9.38e-07,
                    1.0312e-06,
                    1.1284e-06,
                    1.2275e-06,
                    1.3283e-06,
                    1.4309e-06,
                    1.5353e-06,
                    1.6415e-06,
                    1.7496e-06,
                    1.8595e-06,
                    1.9715e-06,
                    2.0853e-06,
                    2.2007e-06,
                    2.3177e-06,
                    2.4363e-06,
                    2.5565e-06,
                    2.6783e-06,
                    2.8017e-06,
                    2.9266e-06,
                    3.0529e-06,
                    3.1802e-06,
                    3.3084e-06,
                    3.4353e-06,
                    3.5632e-06,
                    3.6919e-06,
                    3.8216e-06,
                    3.9522e-06,
                    4.0838e-06,
                    4.2163e-06,
                    4.3434e-06,
                    4.4714e-06,
                    4.6002e-06,
                    4.7299e-06,
                    4.8605e-06,
                    4.992e-06,
                    5.1244e-06,
                    5.2577e-06,
                    5.392e-06,
                    5.5272e-06,
                    5.6633e-06,
                    5.8141e-06,
                    5.9664e-06,
                    6.1203e-06,
                    6.2759e-06,
                    6.4147e-06,
                    6.5591e-06,
                    6.7147e-06,
                    6.8767e-06,
                    7.0456e-06,
                    7.1934e-06,
                    7.3833e-06,
                    7.5827e-06,
                    7.7867e-06,
                    7.9969e-06,
                    8.1798e-06,
                    8.3848e-06,
                    8.614e-06,
                    8.8689e-06,
                    9.1068e-06,
                    9.3294e-06,
                    9.5848e-06,
                    9.8465e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Land_3GHG": 0.68,
                "Land_3GHG_timeseries": [
                    5.2467e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.0039
                ],
                "Total_CO2": 0.26,
                "Total_CO2_timeseries": [
                    4.1431e-06,
                    8.3224e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029
                ],
                "Fossil_CO2": 0.01,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.6365e-09,
                    4.9099e-09,
                    6.5464e-09,
                    6.5464e-09,
                    6.5464e-09,
                    6.5464e-09,
                    6.5464e-09,
                    6.5464e-09,
                    6.5464e-09,
                    6.5464e-09,
                    6.5464e-09,
                    6.5464e-09,
                    9.8464e-09,
                    9.8464e-09,
                    1.1483e-08,
                    1.3119e-08,
                    1.4756e-08,
                    1.5169e-07,
                    2.6223e-07,
                    4.0083e-07,
                    5.1468e-07,
                    6.4503e-07,
                    7.8198e-07,
                    9.2553e-07,
                    1.0674e-06,
                    1.2357e-06,
                    1.404e-06,
                    1.5839e-06,
                    1.7439e-06,
                    1.9221e-06,
                    2.1299e-06,
                    2.3476e-06,
                    2.5984e-06,
                    2.859e-06,
                    3.2384e-06,
                    3.6491e-06,
                    4.0318e-06,
                    4.4689e-06,
                    4.9308e-06,
                    5.5098e-06,
                    5.9931e-06,
                    6.5276e-06,
                    7.2898e-06,
                    7.7366e-06,
                    8.1174e-06,
                    8.5755e-06,
                    9.0845e-06,
                    9.8113e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CO2": 0.81,
                "Land_CO2_timeseries": [
                    4.1431e-06,
                    8.3224e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029
                ],
                "Total_CH4": 0.25,
                "Total_CH4_timeseries": [
                    1.0326e-06,
                    2.0697e-06,
                    3.1117e-06,
                    4.1588e-06,
                    5.2109e-06,
                    6.268e-06,
                    7.3302e-06,
                    8.3974e-06,
                    9.4698e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011
                ],
                "Fossil_CH4": 0.13,
                "Fossil_CH4_timeseries": [
                    7.4862e-08,
                    1.5016e-07,
                    2.2649e-07,
                    3.0386e-07,
                    3.8227e-07,
                    4.6175e-07,
                    5.4231e-07,
                    6.2396e-07,
                    7.0672e-07,
                    7.906e-07,
                    8.7616e-07,
                    9.6342e-07,
                    1.0548e-06,
                    1.1479e-06,
                    1.2427e-06,
                    1.3394e-06,
                    1.4378e-06,
                    1.538e-06,
                    1.64e-06,
                    1.7439e-06,
                    1.8496e-06,
                    1.9572e-06,
                    2.066e-06,
                    2.176e-06,
                    2.2874e-06,
                    2.4e-06,
                    2.5139e-06,
                    2.6291e-06,
                    2.7455e-06,
                    2.8633e-06,
                    2.9819e-06,
                    3.1014e-06,
                    3.2195e-06,
                    3.3385e-06,
                    3.4583e-06,
                    3.579e-06,
                    3.7006e-06,
                    3.823e-06,
                    3.9464e-06,
                    4.064e-06,
                    4.1823e-06,
                    4.3014e-06,
                    4.4212e-06,
                    4.5418e-06,
                    4.663e-06,
                    4.7851e-06,
                    4.9078e-06,
                    5.0313e-06,
                    5.1556e-06,
                    5.2806e-06,
                    5.42e-06,
                    5.5607e-06,
                    5.7027e-06,
                    5.8461e-06,
                    5.9724e-06,
                    6.104e-06,
                    6.2465e-06,
                    6.3951e-06,
                    6.5503e-06,
                    6.6842e-06,
                    6.86e-06,
                    7.0451e-06,
                    7.2346e-06,
                    7.4301e-06,
                    7.5981e-06,
                    7.7882e-06,
                    8.002e-06,
                    8.2416e-06,
                    8.4639e-06,
                    8.6707e-06,
                    8.9101e-06,
                    9.1555e-06,
                    9.4074e-06,
                    9.6658e-06,
                    9.9481e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Land_CH4": 0.47,
                "Land_CH4_timeseries": [
                    9.5778e-07,
                    1.9195e-06,
                    2.8852e-06,
                    3.8549e-06,
                    4.8286e-06,
                    5.8063e-06,
                    6.7879e-06,
                    7.7735e-06,
                    8.7631e-06,
                    9.7566e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Total_N2O": 0.33,
                "Total_N2O_timeseries": [
                    1.5109e-07,
                    3.0518e-07,
                    4.6215e-07,
                    6.2181e-07,
                    7.8395e-07,
                    9.4828e-07,
                    1.1145e-06,
                    1.2822e-06,
                    1.4509e-06,
                    1.6203e-06,
                    1.79e-06,
                    1.9599e-06,
                    2.13e-06,
                    2.3002e-06,
                    2.4705e-06,
                    2.641e-06,
                    2.8116e-06,
                    2.9823e-06,
                    3.1534e-06,
                    3.3247e-06,
                    3.4989e-06,
                    3.6803e-06,
                    3.8722e-06,
                    4.0769e-06,
                    4.2958e-06,
                    4.5291e-06,
                    4.7761e-06,
                    5.0353e-06,
                    5.3038e-06,
                    5.5781e-06,
                    5.8557e-06,
                    6.1359e-06,
                    6.4184e-06,
                    6.703e-06,
                    6.9893e-06,
                    7.2772e-06,
                    7.5669e-06,
                    7.8583e-06,
                    8.1518e-06,
                    8.4604e-06,
                    8.7721e-06,
                    9.0868e-06,
                    9.4048e-06,
                    9.7263e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_N2O": 0.05,
                "Fossil_N2O_timeseries": [
                    5.2676e-09,
                    1.0621e-08,
                    1.6058e-08,
                    2.1574e-08,
                    2.7164e-08,
                    3.2821e-08,
                    3.854e-08,
                    4.431e-08,
                    5.0123e-08,
                    5.5968e-08,
                    6.1839e-08,
                    6.7733e-08,
                    7.365e-08,
                    7.9588e-08,
                    8.5548e-08,
                    9.1528e-08,
                    9.7531e-08,
                    1.0356e-07,
                    1.0961e-07,
                    1.1568e-07,
                    1.2184e-07,
                    1.2818e-07,
                    1.3477e-07,
                    1.4167e-07,
                    1.489e-07,
                    1.5648e-07,
                    1.6439e-07,
                    1.7258e-07,
                    1.8101e-07,
                    1.8958e-07,
                    1.9824e-07,
                    2.0699e-07,
                    2.158e-07,
                    2.2468e-07,
                    2.3361e-07,
                    2.426e-07,
                    2.5165e-07,
                    2.6076e-07,
                    2.6992e-07,
                    2.7941e-07,
                    2.8903e-07,
                    2.9879e-07,
                    3.0869e-07,
                    3.1875e-07,
                    3.2897e-07,
                    3.3935e-07,
                    3.4991e-07,
                    3.6066e-07,
                    3.7159e-07,
                    3.8273e-07,
                    3.9409e-07,
                    4.057e-07,
                    4.176e-07,
                    4.2979e-07,
                    4.4229e-07,
                    4.551e-07,
                    4.6821e-07,
                    4.8161e-07,
                    4.9527e-07,
                    5.0917e-07,
                    5.2327e-07,
                    5.3758e-07,
                    5.5208e-07,
                    5.6677e-07,
                    5.8164e-07,
                    5.9669e-07,
                    6.1193e-07,
                    6.2734e-07,
                    6.4295e-07,
                    6.5875e-07,
                    6.7475e-07,
                    6.9094e-07,
                    7.0734e-07,
                    7.2393e-07,
                    7.4072e-07,
                    7.5772e-07,
                    7.7493e-07,
                    7.9236e-07,
                    8.1001e-07,
                    8.2789e-07,
                    8.4603e-07,
                    8.6446e-07,
                    8.8322e-07,
                    9.0234e-07,
                    9.2184e-07,
                    9.4176e-07,
                    9.6211e-07,
                    9.8293e-07,
                    1.0042e-06,
                    1.026e-06,
                    1.0485e-06,
                    1.072e-06,
                    1.0967e-06,
                    1.1228e-06,
                    1.1505e-06,
                    1.1797e-06,
                    1.2105e-06,
                    1.2429e-06,
                    1.2766e-06,
                    1.3116e-06,
                    1.3476e-06,
                    1.3849e-06,
                    1.4233e-06,
                    1.463e-06,
                    1.5038e-06,
                    1.5459e-06,
                    1.5892e-06,
                    1.6336e-06,
                    1.6792e-06,
                    1.7258e-06,
                    1.7735e-06,
                    1.8225e-06,
                    1.8727e-06,
                    1.9244e-06,
                    1.9776e-06,
                    2.0323e-06,
                    2.0887e-06,
                    2.1466e-06,
                    2.2063e-06,
                    2.2668e-06,
                    2.3285e-06,
                    2.3914e-06,
                    2.4552e-06,
                    2.5215e-06,
                    2.5894e-06,
                    2.6584e-06,
                    2.727e-06,
                    2.7998e-06,
                    2.8723e-06,
                    2.9473e-06,
                    3.0241e-06,
                    3.1242e-06,
                    3.2389e-06,
                    3.36e-06,
                    3.4709e-06,
                    3.5839e-06,
                    3.7088e-06,
                    3.8466e-06,
                    3.9543e-06,
                    4.0744e-06,
                    4.1983e-06,
                    4.3244e-06,
                    4.4528e-06,
                    4.5809e-06,
                    4.7237e-06,
                    4.8713e-06,
                    5.0176e-06,
                    5.1701e-06,
                    5.3252e-06,
                    5.4895e-06,
                    5.6572e-06,
                    5.8254e-06,
                    6.0022e-06,
                    6.1859e-06,
                    6.3771e-06,
                    6.5802e-06,
                    6.7899e-06,
                    7.006e-06,
                    7.224e-06,
                    7.4493e-06,
                    7.6821e-06,
                    7.923e-06,
                    8.174e-06,
                    8.4288e-06,
                    8.6887e-06,
                    8.9715e-06,
                    9.2616e-06,
                    9.5586e-06,
                    9.8663e-06,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.44,
                "Land_N2O_timeseries": [
                    1.4582e-07,
                    2.9456e-07,
                    4.4609e-07,
                    6.0024e-07,
                    7.5678e-07,
                    9.1545e-07,
                    1.0759e-06,
                    1.2379e-06,
                    1.4008e-06,
                    1.5643e-06,
                    1.7281e-06,
                    1.8921e-06,
                    2.0563e-06,
                    2.2206e-06,
                    2.385e-06,
                    2.5494e-06,
                    2.714e-06,
                    2.8788e-06,
                    3.0438e-06,
                    3.209e-06,
                    3.3771e-06,
                    3.5521e-06,
                    3.7374e-06,
                    3.9353e-06,
                    4.1469e-06,
                    4.3726e-06,
                    4.6118e-06,
                    4.8627e-06,
                    5.1228e-06,
                    5.3885e-06,
                    5.6574e-06,
                    5.9289e-06,
                    6.2026e-06,
                    6.4783e-06,
                    6.7557e-06,
                    7.0346e-06,
                    7.3152e-06,
                    7.5976e-06,
                    7.8818e-06,
                    8.181e-06,
                    8.483e-06,
                    8.788e-06,
                    9.0961e-06,
                    9.4075e-06,
                    9.7222e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                47.33084,
                                -24.35396
                            ],
                            [
                                47.40604,
                                -24.15811
                            ],
                            [
                                47.48021,
                                -24.03784
                            ],
                            [
                                47.59104,
                                -23.78922
                            ],
                            [
                                47.64658,
                                -23.48293
                            ],
                            [
                                47.71375,
                                -23.31996
                            ],
                            [
                                47.76926,
                                -23.0764
                            ],
                            [
                                47.80604,
                                -22.97965
                            ],
                            [
                                47.85615,
                                -22.74722
                            ],
                            [
                                47.89314,
                                -22.4867
                            ],
                            [
                                47.95864,
                                -22.29483
                            ],
                            [
                                48.09835,
                                -21.97624
                            ],
                            [
                                48.19515,
                                -21.73279
                            ],
                            [
                                48.29285,
                                -21.46149
                            ],
                            [
                                48.35157,
                                -21.22898
                            ],
                            [
                                48.44191,
                                -20.99394
                            ],
                            [
                                48.50856,
                                -20.68656
                            ],
                            [
                                48.60586,
                                -20.39424
                            ],
                            [
                                48.68655,
                                -20.20558
                            ],
                            [
                                48.78582,
                                -20.00521
                            ],
                            [
                                48.82047,
                                -19.91607
                            ],
                            [
                                48.81442,
                                -19.84713
                            ],
                            [
                                48.88487,
                                -19.55948
                            ],
                            [
                                48.98319,
                                -19.33525
                            ],
                            [
                                49.00072,
                                -19.2249
                            ],
                            [
                                49.1147,
                                -18.94393
                            ],
                            [
                                49.22915,
                                -18.63955
                            ],
                            [
                                49.33519,
                                -18.41149
                            ],
                            [
                                49.38557,
                                -18.19312
                            ],
                            [
                                49.42305,
                                -18.16394
                            ],
                            [
                                49.40493,
                                -18.07985
                            ],
                            [
                                49.43381,
                                -17.96122
                            ],
                            [
                                49.51828,
                                -17.69024
                            ],
                            [
                                49.47772,
                                -17.5913
                            ],
                            [
                                49.47179,
                                -17.4829
                            ],
                            [
                                49.41348,
                                -17.3724
                            ],
                            [
                                49.42278,
                                -17.29768
                            ],
                            [
                                49.48959,
                                -17.15874
                            ],
                            [
                                49.53411,
                                -17.03069
                            ],
                            [
                                49.59585,
                                -16.91028
                            ],
                            [
                                49.70541,
                                -16.86587
                            ],
                            [
                                49.7993,
                                -16.85074
                            ],
                            [
                                49.72747,
                                -16.75796
                            ],
                            [
                                49.83887,
                                -16.55989
                            ],
                            [
                                49.86236,
                                -16.45326
                            ],
                            [
                                49.81508,
                                -16.34651
                            ],
                            [
                                49.85621,
                                -16.22471
                            ],
                            [
                                49.8239,
                                -16.1803
                            ],
                            [
                                49.70568,
                                -16.11962
                            ],
                            [
                                49.67893,
                                -16.04918
                            ],
                            [
                                49.7279,
                                -15.90631
                            ],
                            [
                                49.64328,
                                -15.69584
                            ],
                            [
                                49.63597,
                                -15.51935
                            ],
                            [
                                49.71196,
                                -15.45011
                            ],
                            [
                                49.90116,
                                -15.44594
                            ],
                            [
                                49.89298,
                                -15.56147
                            ],
                            [
                                49.96438,
                                -15.63133
                            ],
                            [
                                49.95796,
                                -15.73534
                            ],
                            [
                                50.01726,
                                -15.78854
                            ],
                            [
                                50.02128,
                                -15.87749
                            ],
                            [
                                50.2112,
                                -15.98908
                            ],
                            [
                                50.24753,
                                -15.90859
                            ],
                            [
                                50.2834,
                                -15.88403
                            ],
                            [
                                50.3222,
                                -15.77889
                            ],
                            [
                                50.42275,
                                -15.55968
                            ],
                            [
                                50.44292,
                                -15.43966
                            ],
                            [
                                50.46567,
                                -15.40177
                            ],
                            [
                                50.4814,
                                -15.2652
                            ],
                            [
                                50.42677,
                                -15.14284
                            ],
                            [
                                50.33675,
                                -15.03053
                            ],
                            [
                                50.31551,
                                -14.95569
                            ],
                            [
                                50.22627,
                                -14.76446
                            ],
                            [
                                50.22545,
                                -14.71652
                            ],
                            [
                                50.18459,
                                -14.58206
                            ],
                            [
                                50.17655,
                                -14.45864
                            ],
                            [
                                50.20046,
                                -14.3064
                            ],
                            [
                                50.1517,
                                -14.24956
                            ],
                            [
                                50.1649,
                                -14.06103
                            ],
                            [
                                50.13869,
                                -14.00163
                            ],
                            [
                                50.13889,
                                -13.80038
                            ],
                            [
                                50.08876,
                                -13.69191
                            ],
                            [
                                50.08116,
                                -13.62322
                            ],
                            [
                                50.02993,
                                -13.52687
                            ],
                            [
                                49.96599,
                                -13.2878
                            ],
                            [
                                49.92053,
                                -13.19476
                            ],
                            [
                                49.92692,
                                -13.04526
                            ],
                            [
                                49.85442,
                                -12.91215
                            ],
                            [
                                49.80366,
                                -12.89253
                            ],
                            [
                                49.78165,
                                -12.8094
                            ],
                            [
                                49.63228,
                                -12.69681
                            ],
                            [
                                49.55541,
                                -12.61189
                            ],
                            [
                                49.54362,
                                -12.50757
                            ],
                            [
                                49.51734,
                                -12.46941
                            ],
                            [
                                49.53362,
                                -12.38952
                            ],
                            [
                                49.44952,
                                -12.37961
                            ],
                            [
                                49.41343,
                                -12.33539
                            ],
                            [
                                49.39193,
                                -12.25519
                            ],
                            [
                                49.30766,
                                -12.30951
                            ],
                            [
                                49.25006,
                                -12.28841
                            ],
                            [
                                49.22564,
                                -12.18102
                            ],
                            [
                                49.3308,
                                -12.17382
                            ],
                            [
                                49.35425,
                                -12.10326
                            ],
                            [
                                49.30824,
                                -12.03774
                            ],
                            [
                                49.29656,
                                -11.97835
                            ],
                            [
                                49.2413,
                                -11.95933
                            ],
                            [
                                49.18916,
                                -12.03097
                            ],
                            [
                                49.2153,
                                -12.09157
                            ],
                            [
                                49.14733,
                                -12.21272
                            ],
                            [
                                49.13884,
                                -12.27928
                            ],
                            [
                                49.08438,
                                -12.31601
                            ],
                            [
                                48.97542,
                                -12.34578
                            ],
                            [
                                48.93516,
                                -12.48891
                            ],
                            [
                                48.90251,
                                -12.51005
                            ],
                            [
                                48.85465,
                                -12.42405
                            ],
                            [
                                48.74569,
                                -12.407
                            ],
                            [
                                48.72541,
                                -12.444
                            ],
                            [
                                48.80711,
                                -12.50989
                            ],
                            [
                                48.86369,
                                -12.58471
                            ],
                            [
                                48.86019,
                                -12.66015
                            ],
                            [
                                48.89526,
                                -12.6853
                            ],
                            [
                                48.90367,
                                -12.76821
                            ],
                            [
                                48.96504,
                                -12.82768
                            ],
                            [
                                48.99653,
                                -12.90224
                            ],
                            [
                                48.94468,
                                -12.99963
                            ],
                            [
                                48.88351,
                                -13.02633
                            ],
                            [
                                48.84761,
                                -13.08665
                            ],
                            [
                                48.82654,
                                -13.19859
                            ],
                            [
                                48.84989,
                                -13.24537
                            ],
                            [
                                48.81721,
                                -13.30061
                            ],
                            [
                                48.82758,
                                -13.3844
                            ],
                            [
                                48.73553,
                                -13.46205
                            ],
                            [
                                48.69379,
                                -13.45015
                            ],
                            [
                                48.60395,
                                -13.48973
                            ],
                            [
                                48.50166,
                                -13.40535
                            ],
                            [
                                48.4789,
                                -13.42891
                            ],
                            [
                                48.52155,
                                -13.51567
                            ],
                            [
                                48.51412,
                                -13.57671
                            ],
                            [
                                48.40807,
                                -13.57383
                            ],
                            [
                                48.33618,
                                -13.64588
                            ],
                            [
                                48.35609,
                                -13.74547
                            ],
                            [
                                48.32945,
                                -13.79769
                            ],
                            [
                                48.26729,
                                -13.82345
                            ],
                            [
                                48.16353,
                                -13.75731
                            ],
                            [
                                48.14044,
                                -13.60331
                            ],
                            [
                                47.97243,
                                -13.55378
                            ],
                            [
                                47.88806,
                                -13.62312
                            ],
                            [
                                47.86189,
                                -13.76381
                            ],
                            [
                                47.89781,
                                -13.89985
                            ],
                            [
                                47.99845,
                                -13.91364
                            ],
                            [
                                48.03192,
                                -13.9676
                            ],
                            [
                                47.9816,
                                -14.00637
                            ],
                            [
                                47.98218,
                                -14.05199
                            ],
                            [
                                48.0467,
                                -14.10675
                            ],
                            [
                                48.0427,
                                -14.27173
                            ],
                            [
                                48.00746,
                                -14.31711
                            ],
                            [
                                47.96296,
                                -14.26777
                            ],
                            [
                                47.99916,
                                -14.16277
                            ],
                            [
                                47.95442,
                                -14.16902
                            ],
                            [
                                47.92954,
                                -14.25974
                            ],
                            [
                                47.76764,
                                -14.25014
                            ],
                            [
                                47.71255,
                                -14.35565
                            ],
                            [
                                47.69361,
                                -14.44316
                            ],
                            [
                                47.73442,
                                -14.52066
                            ],
                            [
                                47.73093,
                                -14.60007
                            ],
                            [
                                47.8698,
                                -14.596
                            ],
                            [
                                47.94804,
                                -14.55425
                            ],
                            [
                                48.00564,
                                -14.58871
                            ],
                            [
                                48.01933,
                                -14.71568
                            ],
                            [
                                47.98279,
                                -14.88243
                            ],
                            [
                                47.87425,
                                -14.88074
                            ],
                            [
                                47.89934,
                                -14.81428
                            ],
                            [
                                47.97514,
                                -14.77297
                            ],
                            [
                                47.87212,
                                -14.68638
                            ],
                            [
                                47.80852,
                                -14.60004
                            ],
                            [
                                47.75491,
                                -14.6203
                            ],
                            [
                                47.71594,
                                -14.69456
                            ],
                            [
                                47.63742,
                                -14.78928
                            ],
                            [
                                47.58959,
                                -14.89281
                            ],
                            [
                                47.55081,
                                -15.02471
                            ],
                            [
                                47.4224,
                                -15.14589
                            ],
                            [
                                47.39746,
                                -15.10153
                            ],
                            [
                                47.40249,
                                -14.98366
                            ],
                            [
                                47.47909,
                                -14.88245
                            ],
                            [
                                47.49454,
                                -14.72058
                            ],
                            [
                                47.46056,
                                -14.67845
                            ],
                            [
                                47.31768,
                                -14.8084
                            ],
                            [
                                47.29652,
                                -14.88371
                            ],
                            [
                                47.38878,
                                -14.85944
                            ],
                            [
                                47.37461,
                                -14.924
                            ],
                            [
                                47.28184,
                                -14.94029
                            ],
                            [
                                47.15374,
                                -15.10094
                            ],
                            [
                                47.10287,
                                -15.11157
                            ],
                            [
                                47.05746,
                                -15.16792
                            ],
                            [
                                47.04602,
                                -15.22631
                            ],
                            [
                                47.09522,
                                -15.31118
                            ],
                            [
                                47.18462,
                                -15.41809
                            ],
                            [
                                47.24523,
                                -15.41493
                            ],
                            [
                                47.25284,
                                -15.47249
                            ],
                            [
                                47.2008,
                                -15.48918
                            ],
                            [
                                47.11071,
                                -15.45132
                            ],
                            [
                                47.00206,
                                -15.48891
                            ],
                            [
                                46.95739,
                                -15.42669
                            ],
                            [
                                47.05752,
                                -15.35796
                            ],
                            [
                                47.04157,
                                -15.31802
                            ],
                            [
                                46.96031,
                                -15.28382
                            ],
                            [
                                46.9371,
                                -15.20304
                            ],
                            [
                                46.87582,
                                -15.22925
                            ],
                            [
                                46.70264,
                                -15.36244
                            ],
                            [
                                46.69481,
                                -15.45277
                            ],
                            [
                                46.62579,
                                -15.42538
                            ],
                            [
                                46.48773,
                                -15.52505
                            ],
                            [
                                46.46392,
                                -15.51991
                            ],
                            [
                                46.3277,
                                -15.66291
                            ],
                            [
                                46.31549,
                                -15.72562
                            ],
                            [
                                46.3777,
                                -15.76325
                            ],
                            [
                                46.22118,
                                -15.84384
                            ],
                            [
                                46.24377,
                                -15.75582
                            ],
                            [
                                46.19546,
                                -15.70835
                            ],
                            [
                                46.08811,
                                -15.72625
                            ],
                            [
                                46.05566,
                                -15.8433
                            ],
                            [
                                45.96414,
                                -15.86629
                            ],
                            [
                                45.80018,
                                -15.84395
                            ],
                            [
                                45.76207,
                                -15.88544
                            ],
                            [
                                45.70264,
                                -15.79585
                            ],
                            [
                                45.66016,
                                -15.80318
                            ],
                            [
                                45.65321,
                                -15.91171
                            ],
                            [
                                45.60454,
                                -16.01134
                            ],
                            [
                                45.64608,
                                -16.06677
                            ],
                            [
                                45.5457,
                                -16.07938
                            ],
                            [
                                45.53261,
                                -15.96735
                            ],
                            [
                                45.4197,
                                -15.98482
                            ],
                            [
                                45.42478,
                                -16.02596
                            ],
                            [
                                45.34343,
                                -16.08376
                            ],
                            [
                                45.3129,
                                -16.16247
                            ],
                            [
                                45.25783,
                                -16.14683
                            ],
                            [
                                45.27561,
                                -16.06763
                            ],
                            [
                                45.2644,
                                -15.94702
                            ],
                            [
                                45.21344,
                                -15.9534
                            ],
                            [
                                45.12208,
                                -16.01691
                            ],
                            [
                                44.98128,
                                -16.16305
                            ],
                            [
                                44.89876,
                                -16.20698
                            ],
                            [
                                44.89083,
                                -16.26539
                            ],
                            [
                                44.78429,
                                -16.31519
                            ],
                            [
                                44.78422,
                                -16.25763
                            ],
                            [
                                44.72512,
                                -16.25631
                            ],
                            [
                                44.68799,
                                -16.21851
                            ],
                            [
                                44.55996,
                                -16.19199
                            ],
                            [
                                44.47762,
                                -16.24691
                            ],
                            [
                                44.43967,
                                -16.37705
                            ],
                            [
                                44.46955,
                                -16.52339
                            ],
                            [
                                44.42619,
                                -16.58504
                            ],
                            [
                                44.42622,
                                -16.70674
                            ],
                            [
                                44.35091,
                                -16.79085
                            ],
                            [
                                44.2153,
                                -17.02177
                            ],
                            [
                                44.14136,
                                -17.0955
                            ],
                            [
                                44.08566,
                                -17.23323
                            ],
                            [
                                43.97727,
                                -17.38873
                            ],
                            [
                                43.93813,
                                -17.4626
                            ],
                            [
                                43.93003,
                                -17.54582
                            ],
                            [
                                43.95823,
                                -17.7268
                            ],
                            [
                                44.03242,
                                -17.80073
                            ],
                            [
                                44.01851,
                                -17.87418
                            ],
                            [
                                44.0163,
                                -18.04897
                            ],
                            [
                                44.06623,
                                -18.11276
                            ],
                            [
                                44.07359,
                                -18.26651
                            ],
                            [
                                44.04906,
                                -18.29222
                            ],
                            [
                                44.09532,
                                -18.43983
                            ],
                            [
                                44.16527,
                                -18.61241
                            ],
                            [
                                44.22563,
                                -18.72687
                            ],
                            [
                                44.25626,
                                -18.83423
                            ],
                            [
                                44.25218,
                                -18.94412
                            ],
                            [
                                44.28482,
                                -18.98259
                            ],
                            [
                                44.27009,
                                -19.04456
                            ],
                            [
                                44.32542,
                                -19.17553
                            ],
                            [
                                44.3514,
                                -19.28043
                            ],
                            [
                                44.40598,
                                -19.33591
                            ],
                            [
                                44.4533,
                                -19.33471
                            ],
                            [
                                44.46218,
                                -19.49582
                            ],
                            [
                                44.48448,
                                -19.57604
                            ],
                            [
                                44.39129,
                                -19.78779
                            ],
                            [
                                44.45806,
                                -19.87198
                            ],
                            [
                                44.50904,
                                -19.9727
                            ],
                            [
                                44.39741,
                                -20.1573
                            ],
                            [
                                44.3023,
                                -20.23961
                            ],
                            [
                                44.25159,
                                -20.3232
                            ],
                            [
                                44.24437,
                                -20.40153
                            ],
                            [
                                44.14022,
                                -20.46937
                            ],
                            [
                                44.08932,
                                -20.56967
                            ],
                            [
                                44.05491,
                                -20.68538
                            ],
                            [
                                43.91354,
                                -20.8396
                            ],
                            [
                                43.87395,
                                -20.94906
                            ],
                            [
                                43.86579,
                                -21.03058
                            ],
                            [
                                43.80077,
                                -21.22316
                            ],
                            [
                                43.67921,
                                -21.32291
                            ],
                            [
                                43.56822,
                                -21.33081
                            ],
                            [
                                43.49855,
                                -21.41009
                            ],
                            [
                                43.50082,
                                -21.52027
                            ],
                            [
                                43.43776,
                                -21.65524
                            ],
                            [
                                43.35299,
                                -21.75042
                            ],
                            [
                                43.35136,
                                -21.89807
                            ],
                            [
                                43.33339,
                                -21.95231
                            ],
                            [
                                43.26081,
                                -21.99677
                            ],
                            [
                                43.23761,
                                -22.06768
                            ],
                            [
                                43.23061,
                                -22.32373
                            ],
                            [
                                43.26139,
                                -22.3787
                            ],
                            [
                                43.28869,
                                -22.57823
                            ],
                            [
                                43.3355,
                                -22.70106
                            ],
                            [
                                43.37689,
                                -22.85136
                            ],
                            [
                                43.49323,
                                -23.00022
                            ],
                            [
                                43.57615,
                                -23.05371
                            ],
                            [
                                43.60812,
                                -23.10602
                            ],
                            [
                                43.6188,
                                -23.31187
                            ],
                            [
                                43.76379,
                                -23.46085
                            ],
                            [
                                43.72653,
                                -23.59143
                            ],
                            [
                                43.6657,
                                -23.60971
                            ],
                            [
                                43.64231,
                                -23.66613
                            ],
                            [
                                43.64304,
                                -23.76664
                            ],
                            [
                                43.67317,
                                -23.89537
                            ],
                            [
                                43.67565,
                                -24.0441
                            ],
                            [
                                43.66346,
                                -24.23614
                            ],
                            [
                                43.67093,
                                -24.32759
                            ],
                            [
                                43.70125,
                                -24.40222
                            ],
                            [
                                43.81818,
                                -24.50155
                            ],
                            [
                                43.9312,
                                -24.63096
                            ],
                            [
                                43.92212,
                                -24.73638
                            ],
                            [
                                43.96053,
                                -24.81707
                            ],
                            [
                                44.01901,
                                -24.87459
                            ],
                            [
                                44.0273,
                                -24.98756
                            ],
                            [
                                44.10995,
                                -25.07511
                            ],
                            [
                                44.19175,
                                -25.07979
                            ],
                            [
                                44.31106,
                                -25.16748
                            ],
                            [
                                44.35642,
                                -25.26506
                            ],
                            [
                                44.71314,
                                -25.31446
                            ],
                            [
                                44.80434,
                                -25.34089
                            ],
                            [
                                44.93014,
                                -25.41447
                            ],
                            [
                                44.97389,
                                -25.4766
                            ],
                            [
                                45.0845,
                                -25.51897
                            ],
                            [
                                45.17248,
                                -25.60479
                            ],
                            [
                                45.28276,
                                -25.58383
                            ],
                            [
                                45.47047,
                                -25.57903
                            ],
                            [
                                45.60051,
                                -25.54397
                            ],
                            [
                                45.87433,
                                -25.36443
                            ],
                            [
                                46.08798,
                                -25.26814
                            ],
                            [
                                46.34461,
                                -25.18422
                            ],
                            [
                                46.49623,
                                -25.16537
                            ],
                            [
                                46.63258,
                                -25.19655
                            ],
                            [
                                46.77037,
                                -25.15572
                            ],
                            [
                                46.86179,
                                -25.08808
                            ],
                            [
                                46.96102,
                                -25.07329
                            ],
                            [
                                46.99393,
                                -25.01117
                            ],
                            [
                                47.08986,
                                -24.97639
                            ],
                            [
                                47.13339,
                                -24.92742
                            ],
                            [
                                47.13136,
                                -24.85227
                            ],
                            [
                                47.19913,
                                -24.77126
                            ],
                            [
                                47.19361,
                                -24.71987
                            ],
                            [
                                47.28162,
                                -24.53958
                            ],
                            [
                                47.33084,
                                -24.35396
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                48.17523,
                                -13.25541
                            ],
                            [
                                48.19419,
                                -13.389
                            ],
                            [
                                48.3106,
                                -13.42068
                            ],
                            [
                                48.34063,
                                -13.31611
                            ],
                            [
                                48.2929,
                                -13.27299
                            ],
                            [
                                48.216,
                                -13.27968
                            ],
                            [
                                48.17523,
                                -13.25541
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                49.81188,
                                -17.09386
                            ],
                            [
                                49.87968,
                                -17.01107
                            ],
                            [
                                49.95245,
                                -16.86249
                            ],
                            [
                                49.92863,
                                -16.81486
                            ],
                            [
                                49.85599,
                                -16.93389
                            ],
                            [
                                49.86002,
                                -16.97433
                            ],
                            [
                                49.81188,
                                -17.09386
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "MWI",
                "Country": "Malawi",
                "Total_3GHG": 0.06,
                "Total_3GHG_timeseries": [
                    4.012e-07,
                    7.9185e-07,
                    1.1768e-06,
                    1.5622e-06,
                    1.9567e-06,
                    2.3422e-06,
                    2.7273e-06,
                    3.1016e-06,
                    3.5082e-06,
                    3.8996e-06,
                    4.3099e-06,
                    4.7052e-06,
                    5.0994e-06,
                    5.4981e-06,
                    5.9128e-06,
                    6.3322e-06,
                    6.7438e-06,
                    7.1553e-06,
                    7.5814e-06,
                    8.0217e-06,
                    8.4771e-06,
                    8.9481e-06,
                    9.4075e-06,
                    9.8679e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001
                ],
                "Fossil_3GHG": 0.02,
                "Fossil_3GHG_timeseries": [
                    3.1144e-08,
                    6.2428e-08,
                    9.3853e-08,
                    1.2542e-07,
                    1.5711e-07,
                    1.8894e-07,
                    2.209e-07,
                    2.5298e-07,
                    2.8523e-07,
                    3.1861e-07,
                    3.5352e-07,
                    3.8998e-07,
                    4.3352e-07,
                    4.7868e-07,
                    5.2549e-07,
                    5.7398e-07,
                    6.2419e-07,
                    6.7615e-07,
                    7.299e-07,
                    7.8547e-07,
                    8.429e-07,
                    9.0232e-07,
                    9.6381e-07,
                    1.0275e-06,
                    1.0933e-06,
                    1.1615e-06,
                    1.2319e-06,
                    1.3047e-06,
                    1.3797e-06,
                    1.456e-06,
                    1.5332e-06,
                    1.6114e-06,
                    1.6855e-06,
                    1.7605e-06,
                    1.8365e-06,
                    1.9135e-06,
                    1.9916e-06,
                    2.0708e-06,
                    2.151e-06,
                    2.229e-06,
                    2.3083e-06,
                    2.3891e-06,
                    2.4715e-06,
                    2.5553e-06,
                    2.6407e-06,
                    2.7278e-06,
                    2.8166e-06,
                    2.9071e-06,
                    2.9994e-06,
                    3.0936e-06,
                    3.1935e-06,
                    3.3094e-06,
                    3.4433e-06,
                    3.5976e-06,
                    3.7234e-06,
                    3.8721e-06,
                    4.0236e-06,
                    4.1824e-06,
                    4.3544e-06,
                    4.5169e-06,
                    4.6986e-06,
                    4.8964e-06,
                    5.1079e-06,
                    5.3388e-06,
                    5.5845e-06,
                    5.8513e-06,
                    6.1272e-06,
                    6.4353e-06,
                    6.75e-06,
                    7.0703e-06,
                    7.3978e-06,
                    7.7203e-06,
                    8.0329e-06,
                    8.3498e-06,
                    8.7062e-06,
                    9.0766e-06,
                    9.4545e-06,
                    9.8531e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_3GHG": 0.14,
                "Land_3GHG_timeseries": [
                    3.7006e-07,
                    7.2943e-07,
                    1.0829e-06,
                    1.4368e-06,
                    1.7996e-06,
                    2.1533e-06,
                    2.5064e-06,
                    2.8486e-06,
                    3.2229e-06,
                    3.5809e-06,
                    3.9564e-06,
                    4.3153e-06,
                    4.6659e-06,
                    5.0194e-06,
                    5.3873e-06,
                    5.7582e-06,
                    6.1196e-06,
                    6.4792e-06,
                    6.8515e-06,
                    7.2362e-06,
                    7.6342e-06,
                    8.0458e-06,
                    8.4437e-06,
                    8.8404e-06,
                    9.2321e-06,
                    9.6292e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008
                ],
                "Total_CO2": 0.06,
                "Total_CO2_timeseries": [
                    3.3281e-07,
                    6.5469e-07,
                    9.7046e-07,
                    1.2864e-06,
                    1.611e-06,
                    1.9264e-06,
                    2.241e-06,
                    2.5446e-06,
                    2.8802e-06,
                    3.1994e-06,
                    3.5356e-06,
                    3.8548e-06,
                    4.1653e-06,
                    4.4783e-06,
                    4.8051e-06,
                    5.1346e-06,
                    5.4542e-06,
                    5.7714e-06,
                    6.101e-06,
                    6.4425e-06,
                    6.7967e-06,
                    7.1634e-06,
                    7.5152e-06,
                    7.8646e-06,
                    8.2073e-06,
                    8.5539e-06,
                    8.9071e-06,
                    9.2602e-06,
                    9.6218e-06,
                    9.9818e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.0562e-07,
                    2.2209e-07,
                    3.5311e-07,
                    4.959e-07,
                    6.529e-07,
                    8.3804e-07,
                    1.0399e-06,
                    1.2477e-06,
                    1.4332e-06,
                    1.6403e-06,
                    1.8377e-06,
                    2.0058e-06,
                    2.1682e-06,
                    2.3243e-06,
                    2.4728e-06,
                    2.6295e-06,
                    2.8224e-06,
                    2.9873e-06,
                    3.1621e-06,
                    3.3336e-06,
                    3.5381e-06,
                    3.764e-06,
                    4.0097e-06,
                    4.2669e-06,
                    4.5141e-06,
                    4.7746e-06,
                    5.0366e-06,
                    5.3234e-06,
                    5.625e-06,
                    5.9118e-06,
                    6.2315e-06,
                    6.5035e-06,
                    6.7706e-06,
                    7.0293e-06,
                    7.2797e-06,
                    7.5303e-06,
                    7.7791e-06,
                    8.0245e-06,
                    8.2684e-06,
                    8.5221e-06,
                    8.8555e-06,
                    9.2101e-06,
                    9.5646e-06,
                    9.9618e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CO2": 0.18,
                "Land_CO2_timeseries": [
                    3.3281e-07,
                    6.5469e-07,
                    9.7046e-07,
                    1.2864e-06,
                    1.611e-06,
                    1.9264e-06,
                    2.241e-06,
                    2.5446e-06,
                    2.8802e-06,
                    3.1994e-06,
                    3.5356e-06,
                    3.8548e-06,
                    4.1653e-06,
                    4.4783e-06,
                    4.8051e-06,
                    5.1346e-06,
                    5.4542e-06,
                    5.7714e-06,
                    6.101e-06,
                    6.4425e-06,
                    6.7967e-06,
                    7.1634e-06,
                    7.5152e-06,
                    7.8646e-06,
                    8.2073e-06,
                    8.5539e-06,
                    8.9071e-06,
                    9.2602e-06,
                    9.6218e-06,
                    9.9818e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Total_CH4": 0.07,
                "Total_CH4_timeseries": [
                    5.3832e-08,
                    1.0777e-07,
                    1.618e-07,
                    2.1594e-07,
                    2.7018e-07,
                    3.2454e-07,
                    3.79e-07,
                    4.3357e-07,
                    4.883e-07,
                    5.4417e-07,
                    6.0199e-07,
                    6.6177e-07,
                    7.2905e-07,
                    7.9836e-07,
                    8.6975e-07,
                    9.4323e-07,
                    1.0189e-06,
                    1.0966e-06,
                    1.1766e-06,
                    1.2589e-06,
                    1.3433e-06,
                    1.4301e-06,
                    1.5192e-06,
                    1.6106e-06,
                    1.7044e-06,
                    1.8007e-06,
                    1.8994e-06,
                    2.0006e-06,
                    2.1044e-06,
                    2.2097e-06,
                    2.3161e-06,
                    2.4234e-06,
                    2.5265e-06,
                    2.6307e-06,
                    2.7359e-06,
                    2.8422e-06,
                    2.9495e-06,
                    3.0579e-06,
                    3.1675e-06,
                    3.2745e-06,
                    3.383e-06,
                    3.4928e-06,
                    3.6041e-06,
                    3.7168e-06,
                    3.8311e-06,
                    3.947e-06,
                    4.0645e-06,
                    4.1837e-06,
                    4.3046e-06,
                    4.4272e-06,
                    4.5558e-06,
                    4.7007e-06,
                    4.8638e-06,
                    5.0476e-06,
                    5.2029e-06,
                    5.3816e-06,
                    5.5631e-06,
                    5.7522e-06,
                    5.9547e-06,
                    6.148e-06,
                    6.3675e-06,
                    6.6102e-06,
                    6.8735e-06,
                    7.1632e-06,
                    7.4748e-06,
                    7.8145e-06,
                    8.1704e-06,
                    8.5655e-06,
                    8.9741e-06,
                    9.3954e-06,
                    9.832e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_CH4": 0.07,
                "Fossil_CH4_timeseries": [
                    2.7705e-08,
                    5.5489e-08,
                    8.3353e-08,
                    1.113e-07,
                    1.3933e-07,
                    1.6744e-07,
                    1.9564e-07,
                    2.2393e-07,
                    2.5237e-07,
                    2.8191e-07,
                    3.1298e-07,
                    3.4558e-07,
                    3.8525e-07,
                    4.2653e-07,
                    4.6946e-07,
                    5.1406e-07,
                    5.6037e-07,
                    6.0842e-07,
                    6.5824e-07,
                    7.0988e-07,
                    7.6332e-07,
                    8.1861e-07,
                    8.7577e-07,
                    9.3484e-07,
                    9.9587e-07,
                    1.0589e-06,
                    1.124e-06,
                    1.1911e-06,
                    1.2603e-06,
                    1.3307e-06,
                    1.402e-06,
                    1.4741e-06,
                    1.5421e-06,
                    1.611e-06,
                    1.6809e-06,
                    1.7517e-06,
                    1.8236e-06,
                    1.8964e-06,
                    1.9704e-06,
                    2.0417e-06,
                    2.1144e-06,
                    2.1884e-06,
                    2.2637e-06,
                    2.3405e-06,
                    2.4188e-06,
                    2.4985e-06,
                    2.5798e-06,
                    2.6627e-06,
                    2.7472e-06,
                    2.8334e-06,
                    2.9252e-06,
                    3.0326e-06,
                    3.158e-06,
                    3.3034e-06,
                    3.42e-06,
                    3.5594e-06,
                    3.7013e-06,
                    3.8502e-06,
                    4.012e-06,
                    4.1643e-06,
                    4.3355e-06,
                    4.5228e-06,
                    4.7235e-06,
                    4.9434e-06,
                    5.178e-06,
                    5.4336e-06,
                    5.6982e-06,
                    5.9948e-06,
                    6.2979e-06,
                    6.6064e-06,
                    6.9219e-06,
                    7.2323e-06,
                    7.5326e-06,
                    7.8371e-06,
                    8.1809e-06,
                    8.5386e-06,
                    8.9035e-06,
                    9.289e-06,
                    9.6839e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_CH4": 0.07,
                "Land_CH4_timeseries": [
                    2.6127e-08,
                    5.2276e-08,
                    7.8447e-08,
                    1.0464e-07,
                    1.3086e-07,
                    1.5709e-07,
                    1.8335e-07,
                    2.0963e-07,
                    2.3593e-07,
                    2.6226e-07,
                    2.8901e-07,
                    3.1619e-07,
                    3.438e-07,
                    3.7183e-07,
                    4.0029e-07,
                    4.2917e-07,
                    4.5849e-07,
                    4.8823e-07,
                    5.1839e-07,
                    5.4899e-07,
                    5.8002e-07,
                    6.1149e-07,
                    6.4341e-07,
                    6.7575e-07,
                    7.0854e-07,
                    7.4177e-07,
                    7.7544e-07,
                    8.0954e-07,
                    8.4408e-07,
                    8.7907e-07,
                    9.1412e-07,
                    9.4925e-07,
                    9.8444e-07,
                    1.0197e-06,
                    1.0551e-06,
                    1.0905e-06,
                    1.1259e-06,
                    1.1615e-06,
                    1.1971e-06,
                    1.2328e-06,
                    1.2686e-06,
                    1.3044e-06,
                    1.3403e-06,
                    1.3763e-06,
                    1.4124e-06,
                    1.4485e-06,
                    1.4847e-06,
                    1.521e-06,
                    1.5574e-06,
                    1.5938e-06,
                    1.6307e-06,
                    1.668e-06,
                    1.7059e-06,
                    1.7442e-06,
                    1.7829e-06,
                    1.8222e-06,
                    1.8619e-06,
                    1.902e-06,
                    1.9426e-06,
                    1.9837e-06,
                    2.032e-06,
                    2.0874e-06,
                    2.1501e-06,
                    2.2198e-06,
                    2.2968e-06,
                    2.3809e-06,
                    2.4722e-06,
                    2.5706e-06,
                    2.6762e-06,
                    2.789e-06,
                    2.9101e-06,
                    3.0394e-06,
                    3.1771e-06,
                    3.323e-06,
                    3.4772e-06,
                    3.6396e-06,
                    3.8104e-06,
                    3.9894e-06,
                    4.1767e-06,
                    4.3723e-06,
                    4.5716e-06,
                    4.7747e-06,
                    4.9817e-06,
                    5.1923e-06,
                    5.4068e-06,
                    5.6281e-06,
                    5.8563e-06,
                    6.0916e-06,
                    6.334e-06,
                    6.5838e-06,
                    6.8417e-06,
                    7.1079e-06,
                    7.3827e-06,
                    7.666e-06,
                    7.9581e-06,
                    8.259e-06,
                    8.5689e-06,
                    8.8879e-06,
                    9.2162e-06,
                    9.5539e-06,
                    9.9008e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_N2O": 0.07,
                "Total_N2O_timeseries": [
                    1.4559e-08,
                    2.9403e-08,
                    4.4518e-08,
                    5.989e-08,
                    7.5497e-08,
                    9.1313e-08,
                    1.0731e-07,
                    1.2345e-07,
                    1.3969e-07,
                    1.5599e-07,
                    1.7233e-07,
                    1.887e-07,
                    2.0508e-07,
                    2.2148e-07,
                    2.379e-07,
                    2.5434e-07,
                    2.7079e-07,
                    2.8727e-07,
                    3.0377e-07,
                    3.2031e-07,
                    3.3712e-07,
                    3.546e-07,
                    3.7306e-07,
                    3.9273e-07,
                    4.1371e-07,
                    4.3605e-07,
                    4.5967e-07,
                    4.8442e-07,
                    5.1005e-07,
                    5.3621e-07,
                    5.6269e-07,
                    5.8942e-07,
                    6.1637e-07,
                    6.4352e-07,
                    6.7083e-07,
                    6.983e-07,
                    7.2593e-07,
                    7.5374e-07,
                    7.8173e-07,
                    8.1115e-07,
                    8.4088e-07,
                    8.7096e-07,
                    9.014e-07,
                    9.3221e-07,
                    9.6341e-07,
                    9.9502e-07,
                    1.027e-06,
                    1.0595e-06,
                    1.0924e-06,
                    1.1258e-06,
                    1.1597e-06,
                    1.194e-06,
                    1.2289e-06,
                    1.2643e-06,
                    1.3003e-06,
                    1.3368e-06,
                    1.374e-06,
                    1.4119e-06,
                    1.4504e-06,
                    1.4897e-06,
                    1.5299e-06,
                    1.5716e-06,
                    1.6149e-06,
                    1.6602e-06,
                    1.7076e-06,
                    1.7573e-06,
                    1.8093e-06,
                    1.8636e-06,
                    1.9201e-06,
                    1.9786e-06,
                    2.0392e-06,
                    2.1021e-06,
                    2.1675e-06,
                    2.2353e-06,
                    2.3056e-06,
                    2.3781e-06,
                    2.4525e-06,
                    2.5286e-06,
                    2.6059e-06,
                    2.6837e-06,
                    2.7616e-06,
                    2.8392e-06,
                    2.9163e-06,
                    2.9927e-06,
                    3.0685e-06,
                    3.1436e-06,
                    3.2182e-06,
                    3.2926e-06,
                    3.3671e-06,
                    3.4421e-06,
                    3.5237e-06,
                    3.6218e-06,
                    3.744e-06,
                    3.8953e-06,
                    4.0783e-06,
                    4.2931e-06,
                    4.5374e-06,
                    4.8062e-06,
                    5.0924e-06,
                    5.3861e-06,
                    5.6789e-06,
                    5.9659e-06,
                    6.2435e-06,
                    6.5092e-06,
                    6.7619e-06,
                    7.0016e-06,
                    7.2295e-06,
                    7.4479e-06,
                    7.6605e-06,
                    7.8722e-06,
                    8.122e-06,
                    8.373e-06,
                    8.6271e-06,
                    8.8936e-06,
                    9.1687e-06,
                    9.4488e-06,
                    9.7497e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_N2O": 0.04,
                "Fossil_N2O_timeseries": [
                    3.4386e-09,
                    6.9392e-09,
                    1.0499e-08,
                    1.4116e-08,
                    1.7784e-08,
                    2.15e-08,
                    2.5256e-08,
                    2.9047e-08,
                    3.2864e-08,
                    3.6698e-08,
                    4.0544e-08,
                    4.4401e-08,
                    4.8267e-08,
                    5.2142e-08,
                    5.6026e-08,
                    5.9918e-08,
                    6.382e-08,
                    6.7731e-08,
                    7.1652e-08,
                    7.5587e-08,
                    7.958e-08,
                    8.3713e-08,
                    8.8047e-08,
                    9.2625e-08,
                    9.7471e-08,
                    1.0259e-07,
                    1.0797e-07,
                    1.1358e-07,
                    1.1938e-07,
                    1.2528e-07,
                    1.3125e-07,
                    1.3728e-07,
                    1.4336e-07,
                    1.4948e-07,
                    1.5564e-07,
                    1.6184e-07,
                    1.6807e-07,
                    1.7434e-07,
                    1.8066e-07,
                    1.8726e-07,
                    1.9397e-07,
                    2.0079e-07,
                    2.0773e-07,
                    2.148e-07,
                    2.2199e-07,
                    2.2933e-07,
                    2.3682e-07,
                    2.4446e-07,
                    2.5226e-07,
                    2.6022e-07,
                    2.6837e-07,
                    2.7674e-07,
                    2.8535e-07,
                    2.9421e-07,
                    3.0333e-07,
                    3.1271e-07,
                    3.2235e-07,
                    3.3222e-07,
                    3.4232e-07,
                    3.526e-07,
                    3.6306e-07,
                    3.7368e-07,
                    3.8445e-07,
                    3.9537e-07,
                    4.0644e-07,
                    4.1765e-07,
                    4.29e-07,
                    4.4049e-07,
                    4.5214e-07,
                    4.6394e-07,
                    4.759e-07,
                    4.8801e-07,
                    5.0028e-07,
                    5.1271e-07,
                    5.253e-07,
                    5.3805e-07,
                    5.5097e-07,
                    5.6407e-07,
                    5.7735e-07,
                    5.9083e-07,
                    6.0456e-07,
                    6.1869e-07,
                    6.3331e-07,
                    6.4851e-07,
                    6.6436e-07,
                    6.809e-07,
                    6.9818e-07,
                    7.1621e-07,
                    7.3497e-07,
                    7.5446e-07,
                    7.748e-07,
                    7.9625e-07,
                    8.1903e-07,
                    8.4327e-07,
                    8.6908e-07,
                    8.9648e-07,
                    9.2544e-07,
                    9.5588e-07,
                    9.8766e-07,
                    1.0206e-06,
                    1.0545e-06,
                    1.0896e-06,
                    1.1257e-06,
                    1.1629e-06,
                    1.2013e-06,
                    1.2407e-06,
                    1.2813e-06,
                    1.3229e-06,
                    1.3656e-06,
                    1.4093e-06,
                    1.454e-06,
                    1.5e-06,
                    1.5476e-06,
                    1.597e-06,
                    1.6483e-06,
                    1.7018e-06,
                    1.7578e-06,
                    1.8164e-06,
                    1.8778e-06,
                    1.942e-06,
                    2.0079e-06,
                    2.0747e-06,
                    2.1429e-06,
                    2.212e-06,
                    2.2832e-06,
                    2.3569e-06,
                    2.4317e-06,
                    2.5084e-06,
                    2.5859e-06,
                    2.6654e-06,
                    2.7475e-06,
                    2.8399e-06,
                    2.9342e-06,
                    3.0245e-06,
                    3.1205e-06,
                    3.2217e-06,
                    3.3285e-06,
                    3.4372e-06,
                    3.5529e-06,
                    3.6788e-06,
                    3.806e-06,
                    3.9333e-06,
                    4.0567e-06,
                    4.185e-06,
                    4.314e-06,
                    4.4438e-06,
                    4.5752e-06,
                    4.7106e-06,
                    4.8524e-06,
                    5.0013e-06,
                    5.1521e-06,
                    5.3065e-06,
                    5.4647e-06,
                    5.6268e-06,
                    5.7941e-06,
                    5.966e-06,
                    6.1448e-06,
                    6.3308e-06,
                    6.5206e-06,
                    6.7172e-06,
                    6.9209e-06,
                    7.131e-06,
                    7.3456e-06,
                    7.5662e-06,
                    7.7933e-06,
                    8.0278e-06,
                    8.2695e-06,
                    8.5156e-06,
                    8.7687e-06,
                    9.0277e-06,
                    9.2925e-06,
                    9.5678e-06
                ],
                "Land_N2O": 0.08,
                "Land_N2O_timeseries": [
                    1.112e-08,
                    2.2463e-08,
                    3.4019e-08,
                    4.5774e-08,
                    5.7712e-08,
                    6.9813e-08,
                    8.2051e-08,
                    9.4399e-08,
                    1.0683e-07,
                    1.193e-07,
                    1.3179e-07,
                    1.443e-07,
                    1.5681e-07,
                    1.6934e-07,
                    1.8188e-07,
                    1.9442e-07,
                    2.0697e-07,
                    2.1954e-07,
                    2.3212e-07,
                    2.4472e-07,
                    2.5754e-07,
                    2.7089e-07,
                    2.8502e-07,
                    3.001e-07,
                    3.1624e-07,
                    3.3345e-07,
                    3.5169e-07,
                    3.7083e-07,
                    3.9067e-07,
                    4.1093e-07,
                    4.3143e-07,
                    4.5214e-07,
                    4.7301e-07,
                    4.9403e-07,
                    5.1519e-07,
                    5.3646e-07,
                    5.5786e-07,
                    5.7939e-07,
                    6.0107e-07,
                    6.2389e-07,
                    6.4692e-07,
                    6.7018e-07,
                    6.9367e-07,
                    7.1742e-07,
                    7.4142e-07,
                    7.6568e-07,
                    7.9023e-07,
                    8.1505e-07,
                    8.4016e-07,
                    8.6558e-07,
                    8.9128e-07,
                    9.1726e-07,
                    9.4352e-07,
                    9.7007e-07,
                    9.9692e-07,
                    1.0241e-06,
                    1.0517e-06,
                    1.0796e-06,
                    1.1081e-06,
                    1.1371e-06,
                    1.1669e-06,
                    1.1979e-06,
                    1.2305e-06,
                    1.2648e-06,
                    1.3012e-06,
                    1.3397e-06,
                    1.3803e-06,
                    1.4231e-06,
                    1.468e-06,
                    1.5147e-06,
                    1.5633e-06,
                    1.6141e-06,
                    1.6672e-06,
                    1.7226e-06,
                    1.7803e-06,
                    1.84e-06,
                    1.9016e-06,
                    1.9646e-06,
                    2.0285e-06,
                    2.0929e-06,
                    2.157e-06,
                    2.2205e-06,
                    2.2829e-06,
                    2.3442e-06,
                    2.4041e-06,
                    2.4627e-06,
                    2.5201e-06,
                    2.5764e-06,
                    2.6321e-06,
                    2.6876e-06,
                    2.7489e-06,
                    2.8256e-06,
                    2.925e-06,
                    3.052e-06,
                    3.2092e-06,
                    3.3966e-06,
                    3.6119e-06,
                    3.8503e-06,
                    4.1047e-06,
                    4.3655e-06,
                    4.6244e-06,
                    4.8763e-06,
                    5.1178e-06,
                    5.3463e-06,
                    5.5607e-06,
                    5.7609e-06,
                    5.9481e-06,
                    6.1249e-06,
                    6.2949e-06,
                    6.463e-06,
                    6.668e-06,
                    6.8729e-06,
                    7.0795e-06,
                    7.2966e-06,
                    7.5204e-06,
                    7.747e-06,
                    7.9919e-06,
                    8.245e-06,
                    8.5079e-06,
                    8.8079e-06,
                    9.0786e-06,
                    9.3662e-06,
                    9.6725e-06,
                    9.9716e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                33.24222,
                                -13.99852
                            ],
                            [
                                33.29452,
                                -14.03445
                            ],
                            [
                                33.31657,
                                -14.08837
                            ],
                            [
                                33.29987,
                                -14.14256
                            ],
                            [
                                33.34208,
                                -14.21377
                            ],
                            [
                                33.37604,
                                -14.21374
                            ],
                            [
                                33.47303,
                                -14.39993
                            ],
                            [
                                33.54041,
                                -14.43018
                            ],
                            [
                                33.60474,
                                -14.49223
                            ],
                            [
                                33.63518,
                                -14.58393
                            ],
                            [
                                33.71435,
                                -14.57715
                            ],
                            [
                                33.71058,
                                -14.5067
                            ],
                            [
                                33.81263,
                                -14.54819
                            ],
                            [
                                33.92065,
                                -14.47749
                            ],
                            [
                                34.08163,
                                -14.48755
                            ],
                            [
                                34.09028,
                                -14.45642
                            ],
                            [
                                34.26486,
                                -14.42964
                            ],
                            [
                                34.29802,
                                -14.39984
                            ],
                            [
                                34.39269,
                                -14.39658
                            ],
                            [
                                34.47569,
                                -14.53181
                            ],
                            [
                                34.51387,
                                -14.55425
                            ],
                            [
                                34.54974,
                                -14.64554
                            ],
                            [
                                34.52114,
                                -14.68697
                            ],
                            [
                                34.58277,
                                -14.80868
                            ],
                            [
                                34.56693,
                                -14.89685
                            ],
                            [
                                34.62186,
                                -15.00146
                            ],
                            [
                                34.57684,
                                -15.06162
                            ],
                            [
                                34.57923,
                                -15.2019
                            ],
                            [
                                34.60038,
                                -15.28072
                            ],
                            [
                                34.52184,
                                -15.35059
                            ],
                            [
                                34.51275,
                                -15.40949
                            ],
                            [
                                34.42594,
                                -15.47507
                            ],
                            [
                                34.44107,
                                -15.53742
                            ],
                            [
                                34.43249,
                                -15.6596
                            ],
                            [
                                34.36921,
                                -15.73335
                            ],
                            [
                                34.30603,
                                -15.75594
                            ],
                            [
                                34.25175,
                                -15.84217
                            ],
                            [
                                34.25852,
                                -15.91336
                            ],
                            [
                                34.3087,
                                -15.93182
                            ],
                            [
                                34.4237,
                                -16.04036
                            ],
                            [
                                34.39215,
                                -16.13614
                            ],
                            [
                                34.42042,
                                -16.24627
                            ],
                            [
                                34.4912,
                                -16.29393
                            ],
                            [
                                34.56874,
                                -16.31553
                            ],
                            [
                                34.59435,
                                -16.41522
                            ],
                            [
                                34.68694,
                                -16.49897
                            ],
                            [
                                34.73629,
                                -16.50626
                            ],
                            [
                                34.77448,
                                -16.58089
                            ],
                            [
                                34.84615,
                                -16.6171
                            ],
                            [
                                34.85814,
                                -16.67193
                            ],
                            [
                                34.92333,
                                -16.74494
                            ],
                            [
                                35.0565,
                                -16.83085
                            ],
                            [
                                35.12814,
                                -16.81728
                            ],
                            [
                                35.16768,
                                -16.93569
                            ],
                            [
                                35.07188,
                                -16.98925
                            ],
                            [
                                35.05836,
                                -17.04763
                            ],
                            [
                                35.10746,
                                -17.1287
                            ],
                            [
                                35.28471,
                                -17.12717
                            ],
                            [
                                35.31111,
                                -17.06249
                            ],
                            [
                                35.30298,
                                -16.98208
                            ],
                            [
                                35.26479,
                                -16.94203
                            ],
                            [
                                35.3124,
                                -16.83087
                            ],
                            [
                                35.28668,
                                -16.71312
                            ],
                            [
                                35.22853,
                                -16.64976
                            ],
                            [
                                35.17143,
                                -16.62105
                            ],
                            [
                                35.14563,
                                -16.56076
                            ],
                            [
                                35.26037,
                                -16.47526
                            ],
                            [
                                35.26432,
                                -16.3985
                            ],
                            [
                                35.3157,
                                -16.20663
                            ],
                            [
                                35.4071,
                                -16.1261
                            ],
                            [
                                35.48394,
                                -16.12228
                            ],
                            [
                                35.52411,
                                -16.16601
                            ],
                            [
                                35.67009,
                                -16.09701
                            ],
                            [
                                35.70555,
                                -16.1011
                            ],
                            [
                                35.81326,
                                -16.03128
                            ],
                            [
                                35.82724,
                                -15.92581
                            ],
                            [
                                35.86608,
                                -15.4179
                            ],
                            [
                                35.80399,
                                -15.16815
                            ],
                            [
                                35.93104,
                                -14.8948
                            ],
                            [
                                35.88574,
                                -14.89151
                            ],
                            [
                                35.88437,
                                -14.6726
                            ],
                            [
                                35.53562,
                                -14.2589
                            ],
                            [
                                35.50004,
                                -14.16908
                            ],
                            [
                                35.24085,
                                -13.87877
                            ],
                            [
                                35.10304,
                                -13.69715
                            ],
                            [
                                34.88047,
                                -13.48148
                            ],
                            [
                                34.60441,
                                -13.4813
                            ],
                            [
                                34.55834,
                                -13.38278
                            ],
                            [
                                34.57481,
                                -13.04906
                            ],
                            [
                                34.525,
                                -12.84866
                            ],
                            [
                                34.51428,
                                -12.7326
                            ],
                            [
                                34.47718,
                                -12.57556
                            ],
                            [
                                34.42577,
                                -12.49122
                            ],
                            [
                                34.4185,
                                -12.41498
                            ],
                            [
                                34.35967,
                                -12.29237
                            ],
                            [
                                34.36008,
                                -12.20645
                            ],
                            [
                                34.54656,
                                -11.92174
                            ],
                            [
                                34.55319,
                                -11.85451
                            ],
                            [
                                34.63674,
                                -11.73185
                            ],
                            [
                                34.64624,
                                -11.68588
                            ],
                            [
                                34.61284,
                                -11.57337
                            ],
                            [
                                34.95957,
                                -11.57333
                            ],
                            [
                                34.92526,
                                -11.4136
                            ],
                            [
                                34.88116,
                                -11.35459
                            ],
                            [
                                34.80464,
                                -11.32148
                            ],
                            [
                                34.72987,
                                -11.18973
                            ],
                            [
                                34.62879,
                                -11.10321
                            ],
                            [
                                34.6046,
                                -10.98912
                            ],
                            [
                                34.63853,
                                -10.94328
                            ],
                            [
                                34.65121,
                                -10.75888
                            ],
                            [
                                34.62419,
                                -10.67839
                            ],
                            [
                                34.55911,
                                -10.55587
                            ],
                            [
                                34.57472,
                                -10.46814
                            ],
                            [
                                34.54199,
                                -10.41337
                            ],
                            [
                                34.56677,
                                -10.26944
                            ],
                            [
                                34.55346,
                                -10.18431
                            ],
                            [
                                34.51864,
                                -10.1
                            ],
                            [
                                34.53642,
                                -10.04847
                            ],
                            [
                                34.50334,
                                -9.97931
                            ],
                            [
                                34.33863,
                                -9.79904
                            ],
                            [
                                34.30642,
                                -9.74114
                            ],
                            [
                                34.17516,
                                -9.6129
                            ],
                            [
                                34.01475,
                                -9.49499
                            ],
                            [
                                33.96506,
                                -9.52848
                            ],
                            [
                                33.96676,
                                -9.62634
                            ],
                            [
                                33.91932,
                                -9.70753
                            ],
                            [
                                33.76412,
                                -9.58301
                            ],
                            [
                                33.70158,
                                -9.61729
                            ],
                            [
                                33.58914,
                                -9.58122
                            ],
                            [
                                33.51878,
                                -9.62664
                            ],
                            [
                                33.4439,
                                -9.61393
                            ],
                            [
                                33.39148,
                                -9.53802
                            ],
                            [
                                33.32874,
                                -9.49141
                            ],
                            [
                                33.20915,
                                -9.50851
                            ],
                            [
                                33.07969,
                                -9.44916
                            ],
                            [
                                32.98994,
                                -9.36968
                            ],
                            [
                                32.95351,
                                -9.40145
                            ],
                            [
                                32.94786,
                                -9.48507
                            ],
                            [
                                33.0279,
                                -9.52581
                            ],
                            [
                                33.0031,
                                -9.61516
                            ],
                            [
                                33.06037,
                                -9.63384
                            ],
                            [
                                33.19425,
                                -9.60567
                            ],
                            [
                                33.22688,
                                -9.65503
                            ],
                            [
                                33.22716,
                                -9.71818
                            ],
                            [
                                33.28969,
                                -9.80957
                            ],
                            [
                                33.33805,
                                -9.82326
                            ],
                            [
                                33.3809,
                                -9.90571
                            ],
                            [
                                33.34817,
                                -9.94656
                            ],
                            [
                                33.31898,
                                -10.045
                            ],
                            [
                                33.33914,
                                -10.08803
                            ],
                            [
                                33.41944,
                                -10.12585
                            ],
                            [
                                33.45882,
                                -10.17053
                            ],
                            [
                                33.55909,
                                -10.22679
                            ],
                            [
                                33.53552,
                                -10.32891
                            ],
                            [
                                33.57751,
                                -10.42887
                            ],
                            [
                                33.61952,
                                -10.45056
                            ],
                            [
                                33.66905,
                                -10.53168
                            ],
                            [
                                33.68348,
                                -10.60704
                            ],
                            [
                                33.59811,
                                -10.6603
                            ],
                            [
                                33.53198,
                                -10.76307
                            ],
                            [
                                33.46031,
                                -10.81603
                            ],
                            [
                                33.33528,
                                -10.82906
                            ],
                            [
                                33.31072,
                                -10.86921
                            ],
                            [
                                33.30815,
                                -10.99268
                            ],
                            [
                                33.33267,
                                -11.06806
                            ],
                            [
                                33.4058,
                                -11.15866
                            ],
                            [
                                33.38105,
                                -11.23177
                            ],
                            [
                                33.29047,
                                -11.36855
                            ],
                            [
                                33.2411,
                                -11.4018
                            ],
                            [
                                33.24819,
                                -11.52857
                            ],
                            [
                                33.31107,
                                -11.59618
                            ],
                            [
                                33.31523,
                                -11.72233
                            ],
                            [
                                33.33356,
                                -11.80138
                            ],
                            [
                                33.30532,
                                -11.86205
                            ],
                            [
                                33.32303,
                                -11.89957
                            ],
                            [
                                33.3085,
                                -12.00052
                            ],
                            [
                                33.26109,
                                -12.11773
                            ],
                            [
                                33.30849,
                                -12.16568
                            ],
                            [
                                33.31009,
                                -12.24595
                            ],
                            [
                                33.36696,
                                -12.34768
                            ],
                            [
                                33.45712,
                                -12.32265
                            ],
                            [
                                33.54387,
                                -12.37139
                            ],
                            [
                                33.47247,
                                -12.42157
                            ],
                            [
                                33.40978,
                                -12.52089
                            ],
                            [
                                33.36096,
                                -12.55274
                            ],
                            [
                                33.26833,
                                -12.53848
                            ],
                            [
                                33.23272,
                                -12.59172
                            ],
                            [
                                33.17736,
                                -12.61073
                            ],
                            [
                                33.08663,
                                -12.59471
                            ],
                            [
                                33.01532,
                                -12.65784
                            ],
                            [
                                32.96041,
                                -12.75613
                            ],
                            [
                                32.95734,
                                -12.84254
                            ],
                            [
                                33.02593,
                                -12.91077
                            ],
                            [
                                32.98758,
                                -13.02777
                            ],
                            [
                                32.98082,
                                -13.15616
                            ],
                            [
                                33.01531,
                                -13.21083
                            ],
                            [
                                32.94584,
                                -13.27352
                            ],
                            [
                                32.91375,
                                -13.40996
                            ],
                            [
                                32.84638,
                                -13.50657
                            ],
                            [
                                32.70539,
                                -13.56549
                            ],
                            [
                                32.67547,
                                -13.60985
                            ],
                            [
                                32.77406,
                                -13.63626
                            ],
                            [
                                32.84265,
                                -13.71319
                            ],
                            [
                                32.77279,
                                -13.77349
                            ],
                            [
                                32.8597,
                                -13.79235
                            ],
                            [
                                32.9376,
                                -13.87602
                            ],
                            [
                                32.9441,
                                -13.92535
                            ],
                            [
                                32.99999,
                                -13.94966
                            ],
                            [
                                32.99197,
                                -14.01249
                            ],
                            [
                                33.02871,
                                -14.045
                            ],
                            [
                                33.06979,
                                -13.99115
                            ],
                            [
                                33.15557,
                                -13.93726
                            ],
                            [
                                33.19765,
                                -13.99114
                            ],
                            [
                                33.24222,
                                -13.99852
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                34.67685,
                                -12.08851
                            ],
                            [
                                34.72768,
                                -12.13325
                            ],
                            [
                                34.78027,
                                -12.0851
                            ],
                            [
                                34.79191,
                                -12.03655
                            ],
                            [
                                34.71484,
                                -12.00212
                            ],
                            [
                                34.67685,
                                -12.08851
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                34.57404,
                                -12.01719
                            ],
                            [
                                34.5913,
                                -12.07489
                            ],
                            [
                                34.63766,
                                -12.07757
                            ],
                            [
                                34.65809,
                                -12.00102
                            ],
                            [
                                34.61194,
                                -11.97461
                            ],
                            [
                                34.57404,
                                -12.01719
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "MYS",
                "Country": "Malaysia",
                "Total_3GHG": 0.67,
                "Total_3GHG_timeseries": [
                    6.5924e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0038,
                    0.0039,
                    0.0041,
                    0.0043,
                    0.0045,
                    0.0046,
                    0.0048,
                    0.0049,
                    0.005,
                    0.0052,
                    0.0054,
                    0.0055,
                    0.0057,
                    0.0058,
                    0.006,
                    0.0061,
                    0.0063,
                    0.0064,
                    0.0066,
                    0.0068,
                    0.007,
                    0.0071,
                    0.0073,
                    0.0075,
                    0.0077,
                    0.0079,
                    0.0081,
                    0.0084,
                    0.0086,
                    0.0088,
                    0.0091,
                    0.0094,
                    0.0096,
                    0.0098,
                    0.01,
                    0.0102,
                    0.0105,
                    0.0107,
                    0.0109
                ],
                "Fossil_3GHG": 0.49,
                "Fossil_3GHG_timeseries": [
                    1.2324e-07,
                    2.4902e-07,
                    3.7738e-07,
                    5.0836e-07,
                    6.4198e-07,
                    7.7827e-07,
                    9.1727e-07,
                    1.059e-06,
                    1.2035e-06,
                    1.3508e-06,
                    1.5e-06,
                    1.6511e-06,
                    1.8042e-06,
                    1.9594e-06,
                    2.1166e-06,
                    2.276e-06,
                    2.4375e-06,
                    2.6013e-06,
                    2.7673e-06,
                    2.936e-06,
                    3.1243e-06,
                    3.3324e-06,
                    3.5607e-06,
                    3.8092e-06,
                    4.0791e-06,
                    4.372e-06,
                    4.6879e-06,
                    5.0269e-06,
                    5.3888e-06,
                    5.7735e-06,
                    6.1603e-06,
                    6.549e-06,
                    6.9395e-06,
                    7.3319e-06,
                    7.729e-06,
                    8.1313e-06,
                    8.5394e-06,
                    8.9532e-06,
                    9.3728e-06,
                    9.8019e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0027,
                    0.0028,
                    0.003,
                    0.0031,
                    0.0033,
                    0.0034,
                    0.0036,
                    0.0037,
                    0.0039,
                    0.0041,
                    0.0042,
                    0.0044,
                    0.0045,
                    0.0047,
                    0.0048,
                    0.005,
                    0.0052
                ],
                "Land_3GHG": 0.99,
                "Land_3GHG_timeseries": [
                    6.4692e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0045,
                    0.0046,
                    0.0046,
                    0.0046,
                    0.0047,
                    0.0047,
                    0.0048,
                    0.0048,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0053,
                    0.0054,
                    0.0055,
                    0.0055,
                    0.0056,
                    0.0057,
                    0.0057
                ],
                "Total_CO2": 0.73,
                "Total_CO2_timeseries": [
                    6.254e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0036,
                    0.0037,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0055,
                    0.0057,
                    0.0058,
                    0.0059,
                    0.0061,
                    0.0063,
                    0.0064,
                    0.0066,
                    0.0068,
                    0.007,
                    0.0072,
                    0.0074,
                    0.0075,
                    0.0077,
                    0.0079,
                    0.0081,
                    0.0083
                ],
                "Fossil_CO2": 0.38,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    3.3e-09,
                    1.155e-08,
                    3.3e-08,
                    3.795e-08,
                    5.94e-08,
                    1.089e-07,
                    1.65e-07,
                    2.0625e-07,
                    2.64e-07,
                    3.1845e-07,
                    3.4485e-07,
                    3.663e-07,
                    3.894e-07,
                    4.125e-07,
                    4.2735e-07,
                    4.455e-07,
                    4.62e-07,
                    5.016e-07,
                    5.4285e-07,
                    6.1875e-07,
                    7.2435e-07,
                    7.2435e-07,
                    7.326e-07,
                    7.6065e-07,
                    8.2665e-07,
                    9.1905e-07,
                    1.1666e-06,
                    1.4602e-06,
                    1.7622e-06,
                    2.1087e-06,
                    2.6087e-06,
                    3.2456e-06,
                    4.1481e-06,
                    5.3114e-06,
                    6.44e-06,
                    7.7748e-06,
                    9.306e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0027,
                    0.0028,
                    0.0029
                ],
                "Land_CO2": 1.49,
                "Land_CO2_timeseries": [
                    6.254e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.004,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0043,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0047,
                    0.0049,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0051,
                    0.0052,
                    0.0052,
                    0.0053,
                    0.0054
                ],
                "Total_CH4": 0.59,
                "Total_CH4_timeseries": [
                    2.9052e-07,
                    5.8817e-07,
                    8.9298e-07,
                    1.205e-06,
                    1.5242e-06,
                    1.8508e-06,
                    2.1846e-06,
                    2.5258e-06,
                    2.8744e-06,
                    3.2305e-06,
                    3.5913e-06,
                    3.9571e-06,
                    4.3278e-06,
                    4.7034e-06,
                    5.084e-06,
                    5.4697e-06,
                    5.8605e-06,
                    6.2565e-06,
                    6.6577e-06,
                    7.0644e-06,
                    7.5369e-06,
                    8.0754e-06,
                    8.68e-06,
                    9.3508e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025
                ],
                "Fossil_CH4": 0.85,
                "Fossil_CH4_timeseries": [
                    1.0031e-07,
                    2.0289e-07,
                    3.0777e-07,
                    4.1501e-07,
                    5.2464e-07,
                    6.3668e-07,
                    7.512e-07,
                    8.6822e-07,
                    9.8779e-07,
                    1.11e-06,
                    1.2338e-06,
                    1.3595e-06,
                    1.4869e-06,
                    1.6162e-06,
                    1.7473e-06,
                    1.8805e-06,
                    2.0156e-06,
                    2.1527e-06,
                    2.292e-06,
                    2.4337e-06,
                    2.5947e-06,
                    2.7752e-06,
                    2.9753e-06,
                    3.195e-06,
                    3.4356e-06,
                    3.6985e-06,
                    3.9838e-06,
                    4.2916e-06,
                    4.6218e-06,
                    4.9746e-06,
                    5.3291e-06,
                    5.6853e-06,
                    6.043e-06,
                    6.4024e-06,
                    6.7662e-06,
                    7.135e-06,
                    7.5094e-06,
                    7.8891e-06,
                    8.2745e-06,
                    8.6656e-06,
                    9.0691e-06,
                    9.4851e-06,
                    9.914e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022
                ],
                "Land_CH4": 0.16,
                "Land_CH4_timeseries": [
                    1.9021e-07,
                    3.8528e-07,
                    5.852e-07,
                    7.8997e-07,
                    9.996e-07,
                    1.2141e-06,
                    1.4334e-06,
                    1.6576e-06,
                    1.8866e-06,
                    2.1205e-06,
                    2.3575e-06,
                    2.5976e-06,
                    2.8409e-06,
                    3.0872e-06,
                    3.3367e-06,
                    3.5893e-06,
                    3.8449e-06,
                    4.1038e-06,
                    4.3657e-06,
                    4.6307e-06,
                    4.9422e-06,
                    5.3002e-06,
                    5.7047e-06,
                    6.1557e-06,
                    6.6532e-06,
                    7.1972e-06,
                    7.7876e-06,
                    8.4245e-06,
                    9.1079e-06,
                    9.8378e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Total_N2O": 0.21,
                "Total_N2O_timeseries": [
                    4.7967e-08,
                    9.6709e-08,
                    1.462e-07,
                    1.964e-07,
                    2.4728e-07,
                    2.9876e-07,
                    3.508e-07,
                    4.0331e-07,
                    4.5621e-07,
                    5.0941e-07,
                    5.6285e-07,
                    6.1651e-07,
                    6.7038e-07,
                    7.2446e-07,
                    7.7874e-07,
                    8.3322e-07,
                    8.879e-07,
                    9.428e-07,
                    9.9793e-07,
                    1.0533e-06,
                    1.1094e-06,
                    1.1671e-06,
                    1.2271e-06,
                    1.2898e-06,
                    1.3555e-06,
                    1.4243e-06,
                    1.4959e-06,
                    1.5702e-06,
                    1.6465e-06,
                    1.7241e-06,
                    1.8025e-06,
                    1.8817e-06,
                    1.9615e-06,
                    2.0418e-06,
                    2.1227e-06,
                    2.2041e-06,
                    2.286e-06,
                    2.3685e-06,
                    2.4515e-06,
                    2.5401e-06,
                    2.6295e-06,
                    2.7199e-06,
                    2.8115e-06,
                    2.9045e-06,
                    2.999e-06,
                    3.0951e-06,
                    3.1931e-06,
                    3.2929e-06,
                    3.3947e-06,
                    3.4985e-06,
                    3.6044e-06,
                    3.7127e-06,
                    3.8237e-06,
                    3.9375e-06,
                    4.0545e-06,
                    4.1747e-06,
                    4.2986e-06,
                    4.4263e-06,
                    4.5581e-06,
                    4.6941e-06,
                    4.8353e-06,
                    4.983e-06,
                    5.138e-06,
                    5.3013e-06,
                    5.4732e-06,
                    5.6539e-06,
                    5.8436e-06,
                    6.0418e-06,
                    6.2479e-06,
                    6.4612e-06,
                    6.6812e-06,
                    6.9079e-06,
                    7.1413e-06,
                    7.3812e-06,
                    7.6276e-06,
                    7.8801e-06,
                    8.1384e-06,
                    8.4021e-06,
                    8.6707e-06,
                    8.9438e-06,
                    9.2211e-06,
                    9.5027e-06,
                    9.7888e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_N2O": 0.2,
                "Fossil_N2O_timeseries": [
                    2.293e-08,
                    4.6135e-08,
                    6.9609e-08,
                    9.3347e-08,
                    1.1734e-07,
                    1.4159e-07,
                    1.6607e-07,
                    1.9078e-07,
                    2.157e-07,
                    2.4083e-07,
                    2.6614e-07,
                    2.9164e-07,
                    3.1733e-07,
                    3.432e-07,
                    3.6926e-07,
                    3.955e-07,
                    4.2192e-07,
                    4.4853e-07,
                    4.7533e-07,
                    5.0232e-07,
                    5.2958e-07,
                    5.5725e-07,
                    5.8542e-07,
                    6.1417e-07,
                    6.4354e-07,
                    6.7353e-07,
                    7.0414e-07,
                    7.353e-07,
                    7.6693e-07,
                    7.9892e-07,
                    8.312e-07,
                    8.6374e-07,
                    8.9653e-07,
                    9.2956e-07,
                    9.6283e-07,
                    9.9633e-07,
                    1.0301e-06,
                    1.064e-06,
                    1.0982e-06,
                    1.133e-06,
                    1.1681e-06,
                    1.2035e-06,
                    1.2392e-06,
                    1.2753e-06,
                    1.3118e-06,
                    1.3486e-06,
                    1.3858e-06,
                    1.4234e-06,
                    1.4615e-06,
                    1.4999e-06,
                    1.5388e-06,
                    1.5781e-06,
                    1.618e-06,
                    1.6584e-06,
                    1.6994e-06,
                    1.7409e-06,
                    1.783e-06,
                    1.8256e-06,
                    1.8688e-06,
                    1.9124e-06,
                    1.9566e-06,
                    2.0011e-06,
                    2.0462e-06,
                    2.0917e-06,
                    2.1376e-06,
                    2.1839e-06,
                    2.2307e-06,
                    2.2779e-06,
                    2.3257e-06,
                    2.3739e-06,
                    2.4227e-06,
                    2.4721e-06,
                    2.5222e-06,
                    2.5729e-06,
                    2.6244e-06,
                    2.6766e-06,
                    2.7295e-06,
                    2.7832e-06,
                    2.8376e-06,
                    2.8926e-06,
                    2.9483e-06,
                    3.0048e-06,
                    3.0622e-06,
                    3.1203e-06,
                    3.1794e-06,
                    3.2393e-06,
                    3.3001e-06,
                    3.3616e-06,
                    3.4239e-06,
                    3.4868e-06,
                    3.5505e-06,
                    3.615e-06,
                    3.6806e-06,
                    3.7475e-06,
                    3.8157e-06,
                    3.8854e-06,
                    3.9565e-06,
                    4.029e-06,
                    4.1029e-06,
                    4.1782e-06,
                    4.2551e-06,
                    4.3339e-06,
                    4.4153e-06,
                    4.4996e-06,
                    4.587e-06,
                    4.6778e-06,
                    4.7723e-06,
                    4.8705e-06,
                    4.9724e-06,
                    5.0781e-06,
                    5.1875e-06,
                    5.3007e-06,
                    5.4176e-06,
                    5.5386e-06,
                    5.6641e-06,
                    5.7944e-06,
                    5.9302e-06,
                    6.0723e-06,
                    6.2214e-06,
                    6.3935e-06,
                    6.5681e-06,
                    6.7449e-06,
                    6.9288e-06,
                    7.1204e-06,
                    7.3242e-06,
                    7.5359e-06,
                    7.7499e-06,
                    7.9764e-06,
                    8.2184e-06,
                    8.4768e-06,
                    8.7519e-06,
                    9.0504e-06,
                    9.3868e-06,
                    9.7146e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.21,
                "Land_N2O_timeseries": [
                    2.5037e-08,
                    5.0575e-08,
                    7.6591e-08,
                    1.0306e-07,
                    1.2994e-07,
                    1.5718e-07,
                    1.8473e-07,
                    2.1253e-07,
                    2.4051e-07,
                    2.6859e-07,
                    2.9671e-07,
                    3.2487e-07,
                    3.5306e-07,
                    3.8126e-07,
                    4.0948e-07,
                    4.3772e-07,
                    4.6598e-07,
                    4.9427e-07,
                    5.2259e-07,
                    5.5097e-07,
                    5.7982e-07,
                    6.0988e-07,
                    6.417e-07,
                    6.7566e-07,
                    7.1199e-07,
                    7.5075e-07,
                    7.9181e-07,
                    8.349e-07,
                    8.7956e-07,
                    9.2518e-07,
                    9.7134e-07,
                    1.018e-06,
                    1.065e-06,
                    1.1123e-06,
                    1.1599e-06,
                    1.2078e-06,
                    1.256e-06,
                    1.3045e-06,
                    1.3533e-06,
                    1.4071e-06,
                    1.4614e-06,
                    1.5164e-06,
                    1.5722e-06,
                    1.6291e-06,
                    1.6872e-06,
                    1.7465e-06,
                    1.8072e-06,
                    1.8695e-06,
                    1.9332e-06,
                    1.9986e-06,
                    2.0656e-06,
                    2.1346e-06,
                    2.2057e-06,
                    2.2791e-06,
                    2.3551e-06,
                    2.4339e-06,
                    2.5156e-06,
                    2.6007e-06,
                    2.6893e-06,
                    2.7817e-06,
                    2.8788e-06,
                    2.9818e-06,
                    3.0918e-06,
                    3.2096e-06,
                    3.3356e-06,
                    3.47e-06,
                    3.6129e-06,
                    3.7638e-06,
                    3.9222e-06,
                    4.0873e-06,
                    4.2585e-06,
                    4.4358e-06,
                    4.6191e-06,
                    4.8083e-06,
                    5.0032e-06,
                    5.2035e-06,
                    5.4088e-06,
                    5.6189e-06,
                    5.8332e-06,
                    6.0512e-06,
                    6.2728e-06,
                    6.4979e-06,
                    6.7266e-06,
                    6.9587e-06,
                    7.194e-06,
                    7.4321e-06,
                    7.6725e-06,
                    7.9148e-06,
                    8.1583e-06,
                    8.4022e-06,
                    8.657e-06,
                    8.941e-06,
                    9.2682e-06,
                    9.6479e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                109.64297,
                                2.07595
                            ],
                            [
                                109.62039,
                                1.9859
                            ],
                            [
                                109.53767,
                                1.92286
                            ],
                            [
                                109.55177,
                                1.85784
                            ],
                            [
                                109.59971,
                                1.79806
                            ],
                            [
                                109.68144,
                                1.78378
                            ],
                            [
                                109.65842,
                                1.62205
                            ],
                            [
                                109.8469,
                                1.42678
                            ],
                            [
                                109.95477,
                                1.39996
                            ],
                            [
                                109.97772,
                                1.30046
                            ],
                            [
                                110.05297,
                                1.26387
                            ],
                            [
                                110.09462,
                                1.19723
                            ],
                            [
                                110.19133,
                                1.18327
                            ],
                            [
                                110.20962,
                                1.1205
                            ],
                            [
                                110.26092,
                                1.07363
                            ],
                            [
                                110.2723,
                                0.99949
                            ],
                            [
                                110.35824,
                                0.98367
                            ],
                            [
                                110.46375,
                                0.89281
                            ],
                            [
                                110.57421,
                                0.85564
                            ],
                            [
                                110.75272,
                                0.90406
                            ],
                            [
                                110.85947,
                                0.95523
                            ],
                            [
                                110.89948,
                                1.02785
                            ],
                            [
                                110.97762,
                                1.02758
                            ],
                            [
                                111.07756,
                                1.051
                            ],
                            [
                                111.25093,
                                1.06492
                            ],
                            [
                                111.44158,
                                1.01268
                            ],
                            [
                                111.48779,
                                1.0337
                            ],
                            [
                                111.51744,
                                0.97008
                            ],
                            [
                                111.66304,
                                1.03936
                            ],
                            [
                                111.72158,
                                1.00599
                            ],
                            [
                                111.82745,
                                0.98816
                            ],
                            [
                                111.87794,
                                1.06102
                            ],
                            [
                                111.95335,
                                1.12142
                            ],
                            [
                                112.1276,
                                1.13604
                            ],
                            [
                                112.15776,
                                1.19768
                            ],
                            [
                                112.18035,
                                1.30385
                            ],
                            [
                                112.23096,
                                1.39547
                            ],
                            [
                                112.21057,
                                1.44489
                            ],
                            [
                                112.32229,
                                1.50523
                            ],
                            [
                                112.43387,
                                1.52829
                            ],
                            [
                                112.4876,
                                1.57922
                            ],
                            [
                                112.72999,
                                1.56626
                            ],
                            [
                                112.84612,
                                1.54231
                            ],
                            [
                                112.89574,
                                1.58585
                            ],
                            [
                                113.05404,
                                1.55739
                            ],
                            [
                                113.01869,
                                1.40705
                            ],
                            [
                                113.1049,
                                1.44328
                            ],
                            [
                                113.14474,
                                1.38947
                            ],
                            [
                                113.23355,
                                1.39336
                            ],
                            [
                                113.35711,
                                1.35531
                            ],
                            [
                                113.42534,
                                1.28563
                            ],
                            [
                                113.50004,
                                1.31609
                            ],
                            [
                                113.5786,
                                1.30627
                            ],
                            [
                                113.63353,
                                1.22042
                            ],
                            [
                                113.80064,
                                1.30122
                            ],
                            [
                                113.82064,
                                1.37208
                            ],
                            [
                                113.93313,
                                1.41588
                            ],
                            [
                                113.97369,
                                1.44763
                            ],
                            [
                                114.14016,
                                1.46507
                            ],
                            [
                                114.21927,
                                1.41637
                            ],
                            [
                                114.3766,
                                1.49351
                            ],
                            [
                                114.40144,
                                1.52022
                            ],
                            [
                                114.53774,
                                1.43724
                            ],
                            [
                                114.58155,
                                1.44295
                            ],
                            [
                                114.61343,
                                1.5123
                            ],
                            [
                                114.60994,
                                1.57186
                            ],
                            [
                                114.68094,
                                1.60972
                            ],
                            [
                                114.71073,
                                1.65374
                            ],
                            [
                                114.70328,
                                1.8103
                            ],
                            [
                                114.7465,
                                1.86657
                            ],
                            [
                                114.79402,
                                1.85059
                            ],
                            [
                                114.88016,
                                1.91589
                            ],
                            [
                                114.85144,
                                1.96404
                            ],
                            [
                                114.87817,
                                2.03235
                            ],
                            [
                                114.8012,
                                2.02864
                            ],
                            [
                                114.80312,
                                2.10376
                            ],
                            [
                                114.75983,
                                2.16864
                            ],
                            [
                                114.80166,
                                2.24884
                            ],
                            [
                                114.91223,
                                2.2557
                            ],
                            [
                                114.96428,
                                2.2941
                            ],
                            [
                                114.95412,
                                2.34856
                            ],
                            [
                                115.09792,
                                2.40584
                            ],
                            [
                                115.14274,
                                2.47327
                            ],
                            [
                                115.2452,
                                2.50594
                            ],
                            [
                                115.17723,
                                2.60663
                            ],
                            [
                                115.13356,
                                2.58822
                            ],
                            [
                                115.10494,
                                2.7211
                            ],
                            [
                                115.15114,
                                2.79063
                            ],
                            [
                                115.10225,
                                2.81535
                            ],
                            [
                                115.16084,
                                2.9233
                            ],
                            [
                                115.24665,
                                2.96668
                            ],
                            [
                                115.2845,
                                3.04343
                            ],
                            [
                                115.33442,
                                2.97795
                            ],
                            [
                                115.48253,
                                3.01978
                            ],
                            [
                                115.51581,
                                3.10898
                            ],
                            [
                                115.55303,
                                3.15169
                            ],
                            [
                                115.51879,
                                3.20519
                            ],
                            [
                                115.54625,
                                3.36653
                            ],
                            [
                                115.60559,
                                3.45421
                            ],
                            [
                                115.61037,
                                3.55538
                            ],
                            [
                                115.57601,
                                3.61224
                            ],
                            [
                                115.57839,
                                3.74539
                            ],
                            [
                                115.61626,
                                3.8406
                            ],
                            [
                                115.56382,
                                3.91728
                            ],
                            [
                                115.63993,
                                3.96503
                            ],
                            [
                                115.68243,
                                4.15555
                            ],
                            [
                                115.76804,
                                4.24841
                            ],
                            [
                                115.80235,
                                4.22239
                            ],
                            [
                                115.86931,
                                4.28936
                            ],
                            [
                                115.87004,
                                4.37577
                            ],
                            [
                                115.97276,
                                4.3573
                            ],
                            [
                                116.08379,
                                4.28358
                            ],
                            [
                                116.16826,
                                4.38734
                            ],
                            [
                                116.27144,
                                4.36365
                            ],
                            [
                                116.35246,
                                4.38951
                            ],
                            [
                                116.42773,
                                4.3267
                            ],
                            [
                                116.53457,
                                4.32835
                            ],
                            [
                                116.56699,
                                4.40529
                            ],
                            [
                                116.61976,
                                4.34186
                            ],
                            [
                                116.70284,
                                4.34047
                            ],
                            [
                                116.749,
                                4.38867
                            ],
                            [
                                116.79008,
                                4.34332
                            ],
                            [
                                116.87102,
                                4.3413
                            ],
                            [
                                116.90875,
                                4.3687
                            ],
                            [
                                116.96628,
                                4.34099
                            ],
                            [
                                117.17703,
                                4.3287
                            ],
                            [
                                117.24498,
                                4.37215
                            ],
                            [
                                117.29019,
                                4.3171
                            ],
                            [
                                117.36431,
                                4.28578
                            ],
                            [
                                117.46501,
                                4.17872
                            ],
                            [
                                117.586,
                                4.17764
                            ],
                            [
                                117.64914,
                                4.27801
                            ],
                            [
                                117.61817,
                                4.34733
                            ],
                            [
                                117.64917,
                                4.41006
                            ],
                            [
                                117.75822,
                                4.33282
                            ],
                            [
                                117.79624,
                                4.32807
                            ],
                            [
                                117.87831,
                                4.24616
                            ],
                            [
                                117.98047,
                                4.22451
                            ],
                            [
                                118.16403,
                                4.29783
                            ],
                            [
                                118.40807,
                                4.32661
                            ],
                            [
                                118.54025,
                                4.35294
                            ],
                            [
                                118.6313,
                                4.43308
                            ],
                            [
                                118.5824,
                                4.50858
                            ],
                            [
                                118.53374,
                                4.51946
                            ],
                            [
                                118.42716,
                                4.59434
                            ],
                            [
                                118.31084,
                                4.62891
                            ],
                            [
                                118.20795,
                                4.73003
                            ],
                            [
                                118.18542,
                                4.80314
                            ],
                            [
                                118.12561,
                                4.87358
                            ],
                            [
                                118.20927,
                                4.95942
                            ],
                            [
                                118.29997,
                                4.96543
                            ],
                            [
                                118.32967,
                                5.02133
                            ],
                            [
                                118.42637,
                                5.00596
                            ],
                            [
                                118.47987,
                                4.92213
                            ],
                            [
                                118.54674,
                                4.9583
                            ],
                            [
                                118.66907,
                                4.93748
                            ],
                            [
                                118.73124,
                                4.94947
                            ],
                            [
                                118.95897,
                                5.04805
                            ],
                            [
                                119.04134,
                                5.06357
                            ],
                            [
                                119.16233,
                                5.10895
                            ],
                            [
                                119.26253,
                                5.20881
                            ],
                            [
                                119.26302,
                                5.31625
                            ],
                            [
                                119.23766,
                                5.39078
                            ],
                            [
                                119.14827,
                                5.44803
                            ],
                            [
                                119.09111,
                                5.41
                            ],
                            [
                                119.00248,
                                5.41037
                            ],
                            [
                                118.8609,
                                5.46812
                            ],
                            [
                                118.74367,
                                5.53658
                            ],
                            [
                                118.65987,
                                5.61449
                            ],
                            [
                                118.46159,
                                5.75496
                            ],
                            [
                                118.35667,
                                5.8162
                            ],
                            [
                                118.27133,
                                5.81643
                            ],
                            [
                                118.2016,
                                5.84997
                            ],
                            [
                                118.16211,
                                5.84073
                            ],
                            [
                                118.12832,
                                5.73939
                            ],
                            [
                                117.9563,
                                5.6779
                            ],
                            [
                                117.91429,
                                5.74459
                            ],
                            [
                                117.99307,
                                5.74489
                            ],
                            [
                                118.02994,
                                5.79426
                            ],
                            [
                                118.1134,
                                5.83883
                            ],
                            [
                                118.03799,
                                6.02713
                            ],
                            [
                                118.00354,
                                6.0533
                            ],
                            [
                                117.90438,
                                5.99203
                            ],
                            [
                                117.87924,
                                5.95106
                            ],
                            [
                                117.76074,
                                5.93602
                            ],
                            [
                                117.71615,
                                5.89959
                            ],
                            [
                                117.62494,
                                5.92794
                            ],
                            [
                                117.67348,
                                5.98273
                            ],
                            [
                                117.61321,
                                6.03911
                            ],
                            [
                                117.64959,
                                6.06921
                            ],
                            [
                                117.59518,
                                6.16957
                            ],
                            [
                                117.64188,
                                6.24282
                            ],
                            [
                                117.70805,
                                6.24242
                            ],
                            [
                                117.7251,
                                6.31321
                            ],
                            [
                                117.71037,
                                6.45225
                            ],
                            [
                                117.56061,
                                6.53369
                            ],
                            [
                                117.51677,
                                6.61383
                            ],
                            [
                                117.45419,
                                6.5532
                            ],
                            [
                                117.37873,
                                6.60268
                            ],
                            [
                                117.29334,
                                6.61593
                            ],
                            [
                                117.27727,
                                6.7119
                            ],
                            [
                                117.22065,
                                6.81342
                            ],
                            [
                                117.2478,
                                6.86337
                            ],
                            [
                                117.24833,
                                6.93411
                            ],
                            [
                                117.13837,
                                7.00688
                            ],
                            [
                                117.03243,
                                6.93853
                            ],
                            [
                                117.05002,
                                6.84557
                            ],
                            [
                                116.97701,
                                6.74176
                            ],
                            [
                                116.97511,
                                6.70214
                            ],
                            [
                                116.86048,
                                6.61548
                            ],
                            [
                                116.84724,
                                6.58067
                            ],
                            [
                                116.76282,
                                6.57642
                            ],
                            [
                                116.75812,
                                6.62971
                            ],
                            [
                                116.85325,
                                6.77107
                            ],
                            [
                                116.84909,
                                6.89737
                            ],
                            [
                                116.83304,
                                6.95227
                            ],
                            [
                                116.75895,
                                7.02517
                            ],
                            [
                                116.72897,
                                7.00916
                            ],
                            [
                                116.68412,
                                6.89485
                            ],
                            [
                                116.64146,
                                6.85708
                            ],
                            [
                                116.643,
                                6.72275
                            ],
                            [
                                116.50101,
                                6.5371
                            ],
                            [
                                116.48855,
                                6.48875
                            ],
                            [
                                116.33994,
                                6.38714
                            ],
                            [
                                116.32257,
                                6.31378
                            ],
                            [
                                116.23545,
                                6.28017
                            ],
                            [
                                116.1371,
                                6.14428
                            ],
                            [
                                116.11086,
                                6.01344
                            ],
                            [
                                116.04408,
                                5.951
                            ],
                            [
                                116.03532,
                                5.83701
                            ],
                            [
                                115.89573,
                                5.72757
                            ],
                            [
                                115.88655,
                                5.62474
                            ],
                            [
                                115.85574,
                                5.56524
                            ],
                            [
                                115.79547,
                                5.53438
                            ],
                            [
                                115.66654,
                                5.53756
                            ],
                            [
                                115.60672,
                                5.56935
                            ],
                            [
                                115.55631,
                                5.55523
                            ],
                            [
                                115.41893,
                                5.42307
                            ],
                            [
                                115.36849,
                                5.38893
                            ],
                            [
                                115.3468,
                                5.30434
                            ],
                            [
                                115.39499,
                                5.28618
                            ],
                            [
                                115.49319,
                                5.21002
                            ],
                            [
                                115.55449,
                                5.2074
                            ],
                            [
                                115.5446,
                                5.07651
                            ],
                            [
                                115.46766,
                                5.01622
                            ],
                            [
                                115.35666,
                                4.89708
                            ],
                            [
                                115.24902,
                                4.91859
                            ],
                            [
                                115.21486,
                                4.96514
                            ],
                            [
                                115.15459,
                                4.91276
                            ],
                            [
                                115.15041,
                                4.87293
                            ],
                            [
                                115.23704,
                                4.80414
                            ],
                            [
                                115.26036,
                                4.65089
                            ],
                            [
                                115.29005,
                                4.6092
                            ],
                            [
                                115.26726,
                                4.5288
                            ],
                            [
                                115.27302,
                                4.44717
                            ],
                            [
                                115.36357,
                                4.34072
                            ],
                            [
                                115.29582,
                                4.33591
                            ],
                            [
                                115.14904,
                                4.38346
                            ],
                            [
                                115.11134,
                                4.37124
                            ],
                            [
                                115.09482,
                                4.49152
                            ],
                            [
                                115.0423,
                                4.61904
                            ],
                            [
                                115.02255,
                                4.74704
                            ],
                            [
                                115.03586,
                                4.80439
                            ],
                            [
                                115.01164,
                                4.89172
                            ],
                            [
                                114.97277,
                                4.81253
                            ],
                            [
                                114.88592,
                                4.81403
                            ],
                            [
                                114.82497,
                                4.74759
                            ],
                            [
                                114.77756,
                                4.72882
                            ],
                            [
                                114.81776,
                                4.58738
                            ],
                            [
                                114.83118,
                                4.42843
                            ],
                            [
                                114.88196,
                                4.42346
                            ],
                            [
                                114.8566,
                                4.26802
                            ],
                            [
                                114.80745,
                                4.19219
                            ],
                            [
                                114.79232,
                                4.1247
                            ],
                            [
                                114.68986,
                                4.02231
                            ],
                            [
                                114.57086,
                                4.04558
                            ],
                            [
                                114.54421,
                                4.12404
                            ],
                            [
                                114.49681,
                                4.14819
                            ],
                            [
                                114.45966,
                                4.22031
                            ],
                            [
                                114.31704,
                                4.27871
                            ],
                            [
                                114.32804,
                                4.34376
                            ],
                            [
                                114.25516,
                                4.50396
                            ],
                            [
                                114.1591,
                                4.57043
                            ],
                            [
                                114.07146,
                                4.58887
                            ],
                            [
                                113.96403,
                                4.57611
                            ],
                            [
                                113.98927,
                                4.45443
                            ],
                            [
                                113.95959,
                                4.33537
                            ],
                            [
                                113.86022,
                                4.17505
                            ],
                            [
                                113.80616,
                                4.11757
                            ],
                            [
                                113.75874,
                                4.03425
                            ],
                            [
                                113.55092,
                                3.84113
                            ],
                            [
                                113.42011,
                                3.7432
                            ],
                            [
                                113.36223,
                                3.61958
                            ],
                            [
                                113.29433,
                                3.54918
                            ],
                            [
                                113.25317,
                                3.4687
                            ],
                            [
                                113.18051,
                                3.40709
                            ],
                            [
                                113.14319,
                                3.34223
                            ],
                            [
                                113.0601,
                                3.27802
                            ],
                            [
                                113.06996,
                                3.24961
                            ],
                            [
                                113.017,
                                3.17607
                            ],
                            [
                                112.91107,
                                3.11751
                            ],
                            [
                                112.77619,
                                3.08769
                            ],
                            [
                                112.56518,
                                3.0281
                            ],
                            [
                                112.29741,
                                2.97249
                            ],
                            [
                                112.16548,
                                2.93321
                            ],
                            [
                                111.96204,
                                2.88697
                            ],
                            [
                                111.70269,
                                2.85525
                            ],
                            [
                                111.60202,
                                2.80559
                            ],
                            [
                                111.42808,
                                2.69798
                            ],
                            [
                                111.39276,
                                2.5654
                            ],
                            [
                                111.39016,
                                2.4827
                            ],
                            [
                                111.43261,
                                2.37258
                            ],
                            [
                                111.35333,
                                2.3401
                            ],
                            [
                                111.31486,
                                2.39072
                            ],
                            [
                                111.21643,
                                2.42588
                            ],
                            [
                                111.18891,
                                2.3777
                            ],
                            [
                                111.16736,
                                2.18028
                            ],
                            [
                                111.19939,
                                2.09088
                            ],
                            [
                                111.16521,
                                1.96062
                            ],
                            [
                                111.09903,
                                1.82451
                            ],
                            [
                                111.08215,
                                1.76298
                            ],
                            [
                                111.13278,
                                1.67939
                            ],
                            [
                                111.03268,
                                1.67522
                            ],
                            [
                                110.98867,
                                1.57241
                            ],
                            [
                                110.99931,
                                1.47581
                            ],
                            [
                                110.93117,
                                1.52193
                            ],
                            [
                                110.78946,
                                1.57877
                            ],
                            [
                                110.70789,
                                1.55463
                            ],
                            [
                                110.59821,
                                1.59975
                            ],
                            [
                                110.52792,
                                1.56966
                            ],
                            [
                                110.44339,
                                1.73088
                            ],
                            [
                                110.3727,
                                1.69587
                            ],
                            [
                                110.32132,
                                1.79707
                            ],
                            [
                                110.29413,
                                1.68935
                            ],
                            [
                                110.20465,
                                1.70103
                            ],
                            [
                                110.00627,
                                1.70142
                            ],
                            [
                                109.92891,
                                1.69277
                            ],
                            [
                                109.87123,
                                1.73479
                            ],
                            [
                                109.84144,
                                1.79046
                            ],
                            [
                                109.70391,
                                1.84709
                            ],
                            [
                                109.64469,
                                1.92247
                            ],
                            [
                                109.64297,
                                2.07595
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                100.12125,
                                6.42171
                            ],
                            [
                                100.17185,
                                6.29058
                            ],
                            [
                                100.24492,
                                6.21
                            ],
                            [
                                100.28436,
                                6.10447
                            ],
                            [
                                100.3253,
                                6.05343
                            ],
                            [
                                100.35147,
                                5.97097
                            ],
                            [
                                100.37044,
                                5.81125
                            ],
                            [
                                100.33908,
                                5.65869
                            ],
                            [
                                100.34723,
                                5.56887
                            ],
                            [
                                100.37213,
                                5.54242
                            ],
                            [
                                100.38389,
                                5.44944
                            ],
                            [
                                100.37054,
                                5.39274
                            ],
                            [
                                100.42404,
                                5.28387
                            ],
                            [
                                100.42133,
                                5.16497
                            ],
                            [
                                100.3649,
                                5.08523
                            ],
                            [
                                100.4227,
                                4.99155
                            ],
                            [
                                100.44491,
                                4.92113
                            ],
                            [
                                100.49034,
                                4.87607
                            ],
                            [
                                100.55287,
                                4.88493
                            ],
                            [
                                100.60636,
                                4.63805
                            ],
                            [
                                100.5925,
                                4.56757
                            ],
                            [
                                100.62752,
                                4.52114
                            ],
                            [
                                100.61998,
                                4.43624
                            ],
                            [
                                100.56505,
                                4.31024
                            ],
                            [
                                100.58771,
                                4.2875
                            ],
                            [
                                100.63062,
                                4.16113
                            ],
                            [
                                100.69568,
                                4.15794
                            ],
                            [
                                100.76412,
                                4.08207
                            ],
                            [
                                100.76453,
                                3.99112
                            ],
                            [
                                100.70408,
                                3.97295
                            ],
                            [
                                100.72841,
                                3.86378
                            ],
                            [
                                100.81285,
                                3.83872
                            ],
                            [
                                100.8147,
                                3.7854
                            ],
                            [
                                100.87742,
                                3.76106
                            ],
                            [
                                100.9278,
                                3.69217
                            ],
                            [
                                101.02912,
                                3.62748
                            ],
                            [
                                101.09923,
                                3.48471
                            ],
                            [
                                101.18881,
                                3.35511
                            ],
                            [
                                101.26951,
                                3.29641
                            ],
                            [
                                101.30006,
                                3.2514
                            ],
                            [
                                101.3195,
                                3.11895
                            ],
                            [
                                101.35922,
                                3.07077
                            ],
                            [
                                101.36405,
                                3.01093
                            ],
                            [
                                101.28221,
                                2.90368
                            ],
                            [
                                101.30094,
                                2.84282
                            ],
                            [
                                101.41539,
                                2.80977
                            ],
                            [
                                101.48626,
                                2.69261
                            ],
                            [
                                101.70763,
                                2.59828
                            ],
                            [
                                101.80107,
                                2.57857
                            ],
                            [
                                101.87723,
                                2.41603
                            ],
                            [
                                101.94014,
                                2.42124
                            ],
                            [
                                101.98675,
                                2.37027
                            ],
                            [
                                102.06527,
                                2.33898
                            ],
                            [
                                102.16185,
                                2.21939
                            ],
                            [
                                102.2064,
                                2.21524
                            ],
                            [
                                102.37177,
                                2.13699
                            ],
                            [
                                102.46739,
                                2.11031
                            ],
                            [
                                102.55899,
                                2.05023
                            ],
                            [
                                102.55723,
                                2.02344
                            ],
                            [
                                102.63043,
                                1.95858
                            ],
                            [
                                102.69583,
                                1.86649
                            ],
                            [
                                102.80815,
                                1.86474
                            ],
                            [
                                102.89454,
                                1.81809
                            ],
                            [
                                102.93765,
                                1.74609
                            ],
                            [
                                102.99395,
                                1.7444
                            ],
                            [
                                103.08027,
                                1.70311
                            ],
                            [
                                103.1667,
                                1.64078
                            ],
                            [
                                103.28937,
                                1.58725
                            ],
                            [
                                103.37223,
                                1.52673
                            ],
                            [
                                103.44398,
                                1.32901
                            ],
                            [
                                103.50852,
                                1.26704
                            ],
                            [
                                103.55794,
                                1.35243
                            ],
                            [
                                103.61164,
                                1.34675
                            ],
                            [
                                103.71406,
                                1.46813
                            ],
                            [
                                103.80024,
                                1.48306
                            ],
                            [
                                103.88856,
                                1.44199
                            ],
                            [
                                103.96785,
                                1.42659
                            ],
                            [
                                104.05666,
                                1.45375
                            ],
                            [
                                104.11814,
                                1.39959
                            ],
                            [
                                104.14391,
                                1.34119
                            ],
                            [
                                104.20871,
                                1.33744
                            ],
                            [
                                104.28873,
                                1.37793
                            ],
                            [
                                104.30241,
                                1.43621
                            ],
                            [
                                104.26171,
                                1.56086
                            ],
                            [
                                104.2682,
                                1.61224
                            ],
                            [
                                104.19537,
                                1.78225
                            ],
                            [
                                104.11399,
                                1.87724
                            ],
                            [
                                104.12462,
                                1.95575
                            ],
                            [
                                103.96331,
                                2.21364
                            ],
                            [
                                103.96467,
                                2.31289
                            ],
                            [
                                103.84152,
                                2.44386
                            ],
                            [
                                103.84643,
                                2.50886
                            ],
                            [
                                103.82379,
                                2.5826
                            ],
                            [
                                103.76825,
                                2.62317
                            ],
                            [
                                103.63868,
                                2.66712
                            ],
                            [
                                103.48743,
                                2.82037
                            ],
                            [
                                103.44377,
                                2.91311
                            ],
                            [
                                103.43676,
                                3.00751
                            ],
                            [
                                103.45229,
                                3.13875
                            ],
                            [
                                103.43441,
                                3.32175
                            ],
                            [
                                103.43818,
                                3.41266
                            ],
                            [
                                103.47916,
                                3.49895
                            ],
                            [
                                103.37533,
                                3.64647
                            ],
                            [
                                103.33295,
                                3.74823
                            ],
                            [
                                103.382,
                                3.81677
                            ],
                            [
                                103.38415,
                                3.93714
                            ],
                            [
                                103.44018,
                                3.96605
                            ],
                            [
                                103.39277,
                                4.11389
                            ],
                            [
                                103.49688,
                                4.31303
                            ],
                            [
                                103.4524,
                                4.47103
                            ],
                            [
                                103.47681,
                                4.54238
                            ],
                            [
                                103.44301,
                                4.64237
                            ],
                            [
                                103.43746,
                                4.79066
                            ],
                            [
                                103.32544,
                                4.99467
                            ],
                            [
                                103.16039,
                                5.32303
                            ],
                            [
                                103.10368,
                                5.40218
                            ],
                            [
                                102.97145,
                                5.52485
                            ],
                            [
                                102.83641,
                                5.58561
                            ],
                            [
                                102.70306,
                                5.69663
                            ],
                            [
                                102.63399,
                                5.77938
                            ],
                            [
                                102.53406,
                                5.84978
                            ],
                            [
                                102.46699,
                                5.92857
                            ],
                            [
                                102.35654,
                                6.1567
                            ],
                            [
                                102.24762,
                                6.21187
                            ],
                            [
                                102.14875,
                                6.20911
                            ],
                            [
                                102.09102,
                                6.24087
                            ],
                            [
                                102.09104,
                                6.14494
                            ],
                            [
                                102.0544,
                                6.08168
                            ],
                            [
                                101.94477,
                                5.98457
                            ],
                            [
                                101.92259,
                                5.91508
                            ],
                            [
                                101.94256,
                                5.87469
                            ],
                            [
                                101.83641,
                                5.78769
                            ],
                            [
                                101.81776,
                                5.73255
                            ],
                            [
                                101.75711,
                                5.79447
                            ],
                            [
                                101.67007,
                                5.79047
                            ],
                            [
                                101.65911,
                                5.87163
                            ],
                            [
                                101.58037,
                                5.93153
                            ],
                            [
                                101.48622,
                                5.87045
                            ],
                            [
                                101.39657,
                                5.871
                            ],
                            [
                                101.34362,
                                5.80852
                            ],
                            [
                                101.26877,
                                5.80171
                            ],
                            [
                                101.26024,
                                5.71289
                            ],
                            [
                                101.14496,
                                5.61571
                            ],
                            [
                                101.12105,
                                5.66937
                            ],
                            [
                                100.98834,
                                5.80205
                            ],
                            [
                                101.03095,
                                5.91247
                            ],
                            [
                                101.08872,
                                5.91418
                            ],
                            [
                                101.12133,
                                5.97487
                            ],
                            [
                                101.10338,
                                6.04995
                            ],
                            [
                                101.12735,
                                6.09663
                            ],
                            [
                                101.08041,
                                6.17253
                            ],
                            [
                                101.12139,
                                6.19324
                            ],
                            [
                                101.10758,
                                6.25109
                            ],
                            [
                                101.0198,
                                6.24796
                            ],
                            [
                                100.97711,
                                6.27856
                            ],
                            [
                                100.90084,
                                6.23607
                            ],
                            [
                                100.83731,
                                6.28983
                            ],
                            [
                                100.81609,
                                6.43634
                            ],
                            [
                                100.7089,
                                6.47257
                            ],
                            [
                                100.6542,
                                6.44548
                            ],
                            [
                                100.48868,
                                6.52447
                            ],
                            [
                                100.36569,
                                6.54264
                            ],
                            [
                                100.30971,
                                6.60752
                            ],
                            [
                                100.323,
                                6.65728
                            ],
                            [
                                100.29058,
                                6.7059
                            ],
                            [
                                100.17679,
                                6.6957
                            ],
                            [
                                100.18313,
                                6.57676
                            ],
                            [
                                100.16057,
                                6.48959
                            ],
                            [
                                100.12125,
                                6.42171
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                117.05338,
                                7.18709
                            ],
                            [
                                117.05815,
                                7.12616
                            ],
                            [
                                117.17999,
                                7.18721
                            ],
                            [
                                117.25537,
                                7.18657
                            ],
                            [
                                117.26264,
                                7.27433
                            ],
                            [
                                117.29595,
                                7.3269
                            ],
                            [
                                117.23328,
                                7.36332
                            ],
                            [
                                117.14952,
                                7.35121
                            ],
                            [
                                117.06152,
                                7.29324
                            ],
                            [
                                117.05338,
                                7.18709
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                111.27793,
                                2.71895
                            ],
                            [
                                111.30153,
                                2.51644
                            ],
                            [
                                111.29146,
                                2.46278
                            ],
                            [
                                111.35452,
                                2.34981
                            ],
                            [
                                111.40081,
                                2.39961
                            ],
                            [
                                111.37117,
                                2.49329
                            ],
                            [
                                111.37566,
                                2.72041
                            ],
                            [
                                111.35652,
                                2.76525
                            ],
                            [
                                111.29563,
                                2.77691
                            ],
                            [
                                111.27793,
                                2.71895
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                99.71924,
                                6.43197
                            ],
                            [
                                99.64366,
                                6.41786
                            ],
                            [
                                99.6602,
                                6.36168
                            ],
                            [
                                99.71027,
                                6.35912
                            ],
                            [
                                99.73198,
                                6.26495
                            ],
                            [
                                99.81142,
                                6.31612
                            ],
                            [
                                99.85665,
                                6.2997
                            ],
                            [
                                99.91151,
                                6.32971
                            ],
                            [
                                99.91129,
                                6.37744
                            ],
                            [
                                99.85743,
                                6.45661
                            ],
                            [
                                99.79294,
                                6.42379
                            ],
                            [
                                99.71924,
                                6.43197
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                100.17754,
                                5.46874
                            ],
                            [
                                100.19746,
                                5.41951
                            ],
                            [
                                100.20195,
                                5.31349
                            ],
                            [
                                100.29436,
                                5.2791
                            ],
                            [
                                100.3253,
                                5.39592
                            ],
                            [
                                100.30855,
                                5.46305
                            ],
                            [
                                100.17754,
                                5.46874
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                117.67835,
                                4.16687
                            ],
                            [
                                117.89587,
                                4.16674
                            ],
                            [
                                117.81148,
                                4.20162
                            ],
                            [
                                117.72683,
                                4.26324
                            ],
                            [
                                117.66957,
                                4.26171
                            ],
                            [
                                117.62606,
                                4.20569
                            ],
                            [
                                117.67835,
                                4.16687
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                117.32615,
                                6.65745
                            ],
                            [
                                117.39928,
                                6.61707
                            ],
                            [
                                117.48471,
                                6.64368
                            ],
                            [
                                117.50428,
                                6.69208
                            ],
                            [
                                117.47585,
                                6.73662
                            ],
                            [
                                117.40961,
                                6.74936
                            ],
                            [
                                117.37462,
                                6.6781
                            ],
                            [
                                117.32615,
                                6.65745
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                104.1241,
                                2.78325
                            ],
                            [
                                104.17152,
                                2.71787
                            ],
                            [
                                104.21934,
                                2.72148
                            ],
                            [
                                104.22813,
                                2.77961
                            ],
                            [
                                104.16434,
                                2.82187
                            ],
                            [
                                104.1241,
                                2.78325
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                118.37645,
                                4.641
                            ],
                            [
                                118.5209,
                                4.59402
                            ],
                            [
                                118.58111,
                                4.63432
                            ],
                            [
                                118.42736,
                                4.66032
                            ],
                            [
                                118.37645,
                                4.641
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                116.94833,
                                7.24579
                            ],
                            [
                                117.02043,
                                7.27978
                            ],
                            [
                                117.01753,
                                7.33484
                            ],
                            [
                                116.93225,
                                7.29175
                            ],
                            [
                                116.94833,
                                7.24579
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                115.15467,
                                5.25149
                            ],
                            [
                                115.26704,
                                5.29254
                            ],
                            [
                                115.23209,
                                5.38793
                            ],
                            [
                                115.15467,
                                5.25149
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                101.26779,
                                2.97532
                            ],
                            [
                                101.33964,
                                3.00935
                            ],
                            [
                                101.30292,
                                3.05208
                            ],
                            [
                                101.26779,
                                2.97532
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "MDV",
                "Country": "Maldives",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    7.4407e-10,
                    1.4936e-09,
                    2.2815e-09,
                    3.0583e-09,
                    3.7911e-09,
                    4.5292e-09,
                    5.3056e-09,
                    6.0874e-09,
                    6.8743e-09,
                    7.6499e-09,
                    8.4392e-09,
                    9.2588e-09,
                    1.0076e-08,
                    1.094e-08,
                    1.1817e-08,
                    1.2726e-08,
                    1.3714e-08,
                    1.4783e-08,
                    1.5833e-08,
                    1.693e-08,
                    1.8062e-08,
                    1.923e-08,
                    2.0436e-08,
                    2.1679e-08,
                    2.2977e-08,
                    2.4265e-08,
                    2.559e-08,
                    2.6937e-08,
                    2.8337e-08,
                    2.979e-08,
                    3.1223e-08,
                    3.269e-08,
                    3.4192e-08,
                    3.5712e-08,
                    3.725e-08,
                    3.8789e-08,
                    4.0364e-08,
                    4.1957e-08,
                    4.3569e-08,
                    4.5217e-08,
                    4.688e-08,
                    4.8542e-08,
                    5.0171e-08,
                    5.1815e-08,
                    5.354e-08,
                    5.5281e-08,
                    5.7038e-08,
                    5.8811e-08,
                    6.06e-08,
                    6.2339e-08,
                    6.4075e-08,
                    6.5855e-08,
                    6.7632e-08,
                    6.9406e-08,
                    7.1127e-08,
                    7.2847e-08,
                    7.4565e-08,
                    7.6282e-08,
                    7.7998e-08,
                    7.973e-08,
                    8.1611e-08,
                    8.3692e-08,
                    8.5908e-08,
                    8.8258e-08,
                    9.0678e-08,
                    9.3234e-08,
                    9.5926e-08,
                    9.8689e-08,
                    1.0166e-07,
                    1.0474e-07,
                    1.0805e-07,
                    1.1158e-07,
                    1.1525e-07,
                    1.1919e-07,
                    1.2329e-07,
                    1.2758e-07,
                    1.3208e-07,
                    1.368e-07,
                    1.4171e-07,
                    1.4683e-07,
                    1.5218e-07,
                    1.5769e-07,
                    1.6337e-07,
                    1.692e-07,
                    1.7519e-07,
                    1.8133e-07,
                    1.8762e-07,
                    1.9408e-07,
                    2.0069e-07,
                    2.075e-07,
                    2.1465e-07,
                    2.2214e-07,
                    2.2996e-07,
                    2.3814e-07,
                    2.4663e-07,
                    2.5546e-07,
                    2.6455e-07,
                    2.739e-07,
                    2.8353e-07,
                    2.934e-07,
                    3.0324e-07,
                    3.1319e-07,
                    3.2334e-07,
                    3.3376e-07,
                    3.4448e-07,
                    3.5554e-07,
                    3.6698e-07,
                    3.7881e-07,
                    3.9109e-07,
                    4.0386e-07,
                    4.17e-07,
                    4.3145e-07,
                    4.454e-07,
                    4.5983e-07,
                    4.7468e-07,
                    4.899e-07,
                    5.0555e-07,
                    5.2163e-07,
                    5.3825e-07,
                    5.5895e-07,
                    5.8411e-07,
                    6.1148e-07,
                    6.4139e-07,
                    6.7388e-07,
                    7.1057e-07,
                    7.5143e-07,
                    7.9644e-07,
                    8.4732e-07,
                    9.0408e-07,
                    9.7029e-07,
                    1.0411e-06,
                    1.115e-06,
                    1.194e-06,
                    1.2806e-06,
                    1.3744e-06,
                    1.4774e-06,
                    1.583e-06,
                    1.6982e-06,
                    1.8287e-06,
                    1.98e-06,
                    2.1234e-06,
                    2.3023e-06,
                    2.4673e-06,
                    2.6349e-06,
                    2.8289e-06,
                    3.0432e-06,
                    3.2772e-06,
                    3.5004e-06,
                    3.7794e-06,
                    4.0811e-06,
                    4.388e-06,
                    4.763e-06,
                    5.1033e-06,
                    5.5258e-06,
                    5.9207e-06,
                    6.3923e-06,
                    6.8888e-06,
                    7.422e-06,
                    7.9792e-06,
                    8.5708e-06,
                    9.1975e-06,
                    9.8954e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    6.9457e-10,
                    1.3946e-09,
                    2.1e-09,
                    2.8108e-09,
                    3.5271e-09,
                    4.2487e-09,
                    4.9756e-09,
                    5.7079e-09,
                    6.4453e-09,
                    7.1879e-09,
                    7.9607e-09,
                    8.7638e-09,
                    9.5973e-09,
                    1.0461e-08,
                    1.1355e-08,
                    1.228e-08,
                    1.3236e-08,
                    1.4222e-08,
                    1.5239e-08,
                    1.6286e-08,
                    1.7369e-08,
                    1.8488e-08,
                    1.9644e-08,
                    2.0838e-08,
                    2.207e-08,
                    2.3341e-08,
                    2.4649e-08,
                    2.5996e-08,
                    2.738e-08,
                    2.88e-08,
                    3.0233e-08,
                    3.1684e-08,
                    3.3153e-08,
                    3.4639e-08,
                    3.6144e-08,
                    3.7667e-08,
                    3.9209e-08,
                    4.0769e-08,
                    4.2348e-08,
                    4.3946e-08,
                    4.556e-08,
                    4.7189e-08,
                    4.8834e-08,
                    5.0495e-08,
                    5.2171e-08,
                    5.3862e-08,
                    5.557e-08,
                    5.7293e-08,
                    5.9033e-08,
                    6.0788e-08,
                    6.254e-08,
                    6.4288e-08,
                    6.6031e-08,
                    6.7772e-08,
                    6.951e-08,
                    7.1246e-08,
                    7.2981e-08,
                    7.4714e-08,
                    7.6447e-08,
                    7.8179e-08,
                    8.0044e-08,
                    8.2042e-08,
                    8.4175e-08,
                    8.6443e-08,
                    8.8847e-08,
                    9.1386e-08,
                    9.4061e-08,
                    9.6874e-08,
                    9.9824e-08,
                    1.0291e-07,
                    1.0622e-07,
                    1.0973e-07,
                    1.1346e-07,
                    1.1739e-07,
                    1.2154e-07,
                    1.2588e-07,
                    1.3043e-07,
                    1.352e-07,
                    1.4016e-07,
                    1.4533e-07,
                    1.5067e-07,
                    1.5618e-07,
                    1.6183e-07,
                    1.6765e-07,
                    1.7363e-07,
                    1.7976e-07,
                    1.8605e-07,
                    1.925e-07,
                    1.991e-07,
                    2.0587e-07,
                    2.1295e-07,
                    2.2037e-07,
                    2.2813e-07,
                    2.3625e-07,
                    2.4467e-07,
                    2.5343e-07,
                    2.6246e-07,
                    2.7174e-07,
                    2.813e-07,
                    2.9114e-07,
                    3.0095e-07,
                    3.1086e-07,
                    3.2097e-07,
                    3.3133e-07,
                    3.42e-07,
                    3.5302e-07,
                    3.6441e-07,
                    3.762e-07,
                    3.8845e-07,
                    4.0121e-07,
                    4.1431e-07,
                    4.278e-07,
                    4.4171e-07,
                    4.5602e-07,
                    4.7078e-07,
                    4.8592e-07,
                    5.0151e-07,
                    5.1755e-07,
                    5.3413e-07,
                    5.5477e-07,
                    5.7985e-07,
                    6.0718e-07,
                    6.3704e-07,
                    6.6944e-07,
                    7.0602e-07,
                    7.4681e-07,
                    7.9177e-07,
                    8.426e-07,
                    8.9933e-07,
                    9.6549e-07,
                    1.0363e-06,
                    1.1101e-06,
                    1.1891e-06,
                    1.2756e-06,
                    1.3693e-06,
                    1.4723e-06,
                    1.5779e-06,
                    1.693e-06,
                    1.8234e-06,
                    1.9746e-06,
                    2.118e-06,
                    2.2969e-06,
                    2.4618e-06,
                    2.6295e-06,
                    2.8235e-06,
                    3.0378e-06,
                    3.2718e-06,
                    3.4949e-06,
                    3.7739e-06,
                    4.0757e-06,
                    4.3825e-06,
                    4.7574e-06,
                    5.0977e-06,
                    5.5195e-06,
                    5.9143e-06,
                    6.3856e-06,
                    6.8808e-06,
                    7.4138e-06,
                    7.9706e-06,
                    8.5617e-06,
                    9.1882e-06,
                    9.8851e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [
                    4.95e-11,
                    9.9e-11,
                    1.815e-10,
                    2.475e-10,
                    2.64e-10,
                    2.805e-10,
                    3.3e-10,
                    3.795e-10,
                    4.29e-10,
                    4.62e-10,
                    4.785e-10,
                    4.95e-10,
                    4.785e-10,
                    4.785e-10,
                    4.62e-10,
                    4.455e-10,
                    4.785e-10,
                    5.61e-10,
                    5.94e-10,
                    6.435e-10,
                    6.93e-10,
                    7.425e-10,
                    7.92e-10,
                    8.415e-10,
                    9.075e-10,
                    9.24e-10,
                    9.405e-10,
                    9.405e-10,
                    9.57e-10,
                    9.9e-10,
                    9.9e-10,
                    1.0065e-09,
                    1.0395e-09,
                    1.0725e-09,
                    1.1055e-09,
                    1.122e-09,
                    1.155e-09,
                    1.188e-09,
                    1.221e-09,
                    1.2705e-09,
                    1.32e-09,
                    1.353e-09,
                    1.3365e-09,
                    1.32e-09,
                    1.3695e-09,
                    1.419e-09,
                    1.4685e-09,
                    1.518e-09,
                    1.5675e-09,
                    1.551e-09,
                    1.5345e-09,
                    1.5675e-09,
                    1.6005e-09,
                    1.6335e-09,
                    1.617e-09,
                    1.6005e-09,
                    1.584e-09,
                    1.5675e-09,
                    1.551e-09,
                    1.551e-09,
                    1.5675e-09,
                    1.65e-09,
                    1.7325e-09,
                    1.815e-09,
                    1.8315e-09,
                    1.848e-09,
                    1.8645e-09,
                    1.815e-09,
                    1.8315e-09,
                    1.8315e-09,
                    1.8315e-09,
                    1.848e-09,
                    1.7985e-09,
                    1.7985e-09,
                    1.749e-09,
                    1.6995e-09,
                    1.65e-09,
                    1.6005e-09,
                    1.551e-09,
                    1.5015e-09,
                    1.5015e-09,
                    1.518e-09,
                    1.5345e-09,
                    1.551e-09,
                    1.5675e-09,
                    1.5675e-09,
                    1.5675e-09,
                    1.584e-09,
                    1.584e-09,
                    1.6335e-09,
                    1.6995e-09,
                    1.7655e-09,
                    1.8315e-09,
                    1.8975e-09,
                    1.9635e-09,
                    2.0295e-09,
                    2.0955e-09,
                    2.1615e-09,
                    2.2275e-09,
                    2.2605e-09,
                    2.2935e-09,
                    2.3265e-09,
                    2.376e-09,
                    2.4255e-09,
                    2.475e-09,
                    2.5245e-09,
                    2.574e-09,
                    2.607e-09,
                    2.64e-09,
                    2.6565e-09,
                    2.6895e-09,
                    3.6465e-09,
                    3.6918e-09,
                    3.8031e-09,
                    3.8979e-09,
                    3.9762e-09,
                    4.0435e-09,
                    4.082e-09,
                    4.1206e-09,
                    4.1824e-09,
                    4.2649e-09,
                    4.2979e-09,
                    4.3555e-09,
                    4.4351e-09,
                    4.5516e-09,
                    4.6176e-09,
                    4.6671e-09,
                    4.7166e-09,
                    4.7496e-09,
                    4.7991e-09,
                    4.8486e-09,
                    4.8816e-09,
                    4.9476e-09,
                    4.9971e-09,
                    5.0631e-09,
                    5.1126e-09,
                    5.1734e-09,
                    5.2177e-09,
                    5.2785e-09,
                    5.3445e-09,
                    5.427e-09,
                    5.427e-09,
                    5.4435e-09,
                    5.4383e-09,
                    5.4331e-09,
                    5.4331e-09,
                    5.4552e-09,
                    5.4607e-09,
                    5.4497e-09,
                    5.4388e-09,
                    5.4443e-09,
                    5.6229e-09,
                    5.6531e-09,
                    6.3018e-09,
                    6.4099e-09,
                    6.7228e-09,
                    7.9739e-09,
                    8.1392e-09,
                    8.6003e-09,
                    9.1565e-09,
                    9.3299e-09,
                    1.0291e-08,
                    1.0932e-08,
                    1.1454e-08,
                    1.2169e-08,
                    1.3147e-08,
                    1.4127e-08,
                    1.5271e-08,
                    1.5895e-08,
                    1.6572e-08,
                    1.7273e-08,
                    1.7979e-08
                ],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    4.95e-11,
                    9.9e-11,
                    1.815e-10,
                    2.475e-10,
                    2.64e-10,
                    2.805e-10,
                    3.3e-10,
                    3.795e-10,
                    4.29e-10,
                    4.62e-10,
                    4.785e-10,
                    4.95e-10,
                    4.785e-10,
                    4.785e-10,
                    4.62e-10,
                    4.455e-10,
                    4.785e-10,
                    5.61e-10,
                    5.94e-10,
                    6.435e-10,
                    6.93e-10,
                    7.425e-10,
                    7.92e-10,
                    8.415e-10,
                    9.075e-10,
                    9.24e-10,
                    9.405e-10,
                    9.405e-10,
                    9.57e-10,
                    9.9e-10,
                    9.9e-10,
                    1.0065e-09,
                    1.0395e-09,
                    1.0725e-09,
                    1.1055e-09,
                    1.122e-09,
                    1.155e-09,
                    1.188e-09,
                    1.221e-09,
                    1.2705e-09,
                    1.32e-09,
                    1.353e-09,
                    1.3365e-09,
                    1.32e-09,
                    1.3695e-09,
                    1.419e-09,
                    1.4685e-09,
                    1.518e-09,
                    1.5675e-09,
                    1.551e-09,
                    1.5345e-09,
                    1.5675e-09,
                    1.6005e-09,
                    1.6335e-09,
                    1.617e-09,
                    1.6005e-09,
                    1.584e-09,
                    1.5675e-09,
                    1.551e-09,
                    1.551e-09,
                    1.5675e-09,
                    1.65e-09,
                    1.7325e-09,
                    1.815e-09,
                    1.8315e-09,
                    1.848e-09,
                    1.8645e-09,
                    1.815e-09,
                    1.8315e-09,
                    1.8315e-09,
                    1.8315e-09,
                    1.848e-09,
                    1.7985e-09,
                    1.7985e-09,
                    1.749e-09,
                    1.6995e-09,
                    1.65e-09,
                    1.6005e-09,
                    1.551e-09,
                    1.5015e-09,
                    1.5015e-09,
                    1.518e-09,
                    1.5345e-09,
                    1.551e-09,
                    1.5675e-09,
                    1.5675e-09,
                    1.5675e-09,
                    1.584e-09,
                    1.584e-09,
                    1.6335e-09,
                    1.6995e-09,
                    1.7655e-09,
                    1.8315e-09,
                    1.8975e-09,
                    1.9635e-09,
                    2.0295e-09,
                    2.0955e-09,
                    2.1615e-09,
                    2.2275e-09,
                    2.2605e-09,
                    2.2935e-09,
                    2.3265e-09,
                    2.376e-09,
                    2.4255e-09,
                    2.475e-09,
                    2.5245e-09,
                    2.574e-09,
                    2.607e-09,
                    2.64e-09,
                    2.6565e-09,
                    2.6895e-09,
                    3.6465e-09,
                    3.6795e-09,
                    3.7785e-09,
                    3.861e-09,
                    3.927e-09,
                    3.9765e-09,
                    4.0095e-09,
                    4.0425e-09,
                    4.092e-09,
                    5.8245e-09,
                    7.5075e-09,
                    9.1905e-09,
                    1.089e-08,
                    1.4239e-08,
                    1.9255e-08,
                    2.5905e-08,
                    3.5854e-08,
                    4.9088e-08,
                    6.8937e-08,
                    9.0437e-08,
                    1.1192e-07,
                    1.3509e-07,
                    1.6153e-07,
                    1.913e-07,
                    2.2765e-07,
                    2.6402e-07,
                    3.0697e-07,
                    3.6313e-07,
                    4.4075e-07,
                    5.1013e-07,
                    6.1408e-07,
                    7.032e-07,
                    7.923e-07,
                    9.045e-07,
                    1.0348e-06,
                    1.1834e-06,
                    1.3187e-06,
                    1.5084e-06,
                    1.7113e-06,
                    1.9192e-06,
                    2.1867e-06,
                    2.4144e-06,
                    2.7153e-06,
                    2.9859e-06,
                    3.3208e-06,
                    3.6729e-06,
                    4.0524e-06,
                    4.4501e-06,
                    4.8711e-06,
                    5.3149e-06,
                    5.8151e-06,
                    6.3068e-06,
                    6.8991e-06,
                    7.4751e-06,
                    8.122e-06,
                    8.8035e-06,
                    9.5874e-06,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.65e-09,
                    3.3e-09,
                    4.95e-09,
                    6.6e-09,
                    9.9e-09,
                    1.485e-08,
                    2.145e-08,
                    3.135e-08,
                    4.455e-08,
                    6.435e-08,
                    8.58e-08,
                    1.0725e-07,
                    1.3035e-07,
                    1.5675e-07,
                    1.8645e-07,
                    2.2275e-07,
                    2.5905e-07,
                    3.0195e-07,
                    3.5805e-07,
                    4.356e-07,
                    5.049e-07,
                    6.0885e-07,
                    6.9795e-07,
                    7.8705e-07,
                    8.9925e-07,
                    1.0296e-06,
                    1.1781e-06,
                    1.3134e-06,
                    1.5031e-06,
                    1.7061e-06,
                    1.914e-06,
                    2.1813e-06,
                    2.409e-06,
                    2.7093e-06,
                    2.9799e-06,
                    3.3149e-06,
                    3.6663e-06,
                    4.0458e-06,
                    4.4434e-06,
                    4.8642e-06,
                    5.308e-06,
                    5.808e-06,
                    6.2997e-06,
                    6.8921e-06,
                    7.4679e-06,
                    8.1147e-06,
                    8.7962e-06,
                    9.5799e-06,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [
                    4.95e-11,
                    9.9e-11,
                    1.815e-10,
                    2.475e-10,
                    2.64e-10,
                    2.805e-10,
                    3.3e-10,
                    3.795e-10,
                    4.29e-10,
                    4.62e-10,
                    4.785e-10,
                    4.95e-10,
                    4.785e-10,
                    4.785e-10,
                    4.62e-10,
                    4.455e-10,
                    4.785e-10,
                    5.61e-10,
                    5.94e-10,
                    6.435e-10,
                    6.93e-10,
                    7.425e-10,
                    7.92e-10,
                    8.415e-10,
                    9.075e-10,
                    9.24e-10,
                    9.405e-10,
                    9.405e-10,
                    9.57e-10,
                    9.9e-10,
                    9.9e-10,
                    1.0065e-09,
                    1.0395e-09,
                    1.0725e-09,
                    1.1055e-09,
                    1.122e-09,
                    1.155e-09,
                    1.188e-09,
                    1.221e-09,
                    1.2705e-09,
                    1.32e-09,
                    1.353e-09,
                    1.3365e-09,
                    1.32e-09,
                    1.3695e-09,
                    1.419e-09,
                    1.4685e-09,
                    1.518e-09,
                    1.5675e-09,
                    1.551e-09,
                    1.5345e-09,
                    1.5675e-09,
                    1.6005e-09,
                    1.6335e-09,
                    1.617e-09,
                    1.6005e-09,
                    1.584e-09,
                    1.5675e-09,
                    1.551e-09,
                    1.551e-09,
                    1.5675e-09,
                    1.65e-09,
                    1.7325e-09,
                    1.815e-09,
                    1.8315e-09,
                    1.848e-09,
                    1.8645e-09,
                    1.815e-09,
                    1.8315e-09,
                    1.8315e-09,
                    1.8315e-09,
                    1.848e-09,
                    1.7985e-09,
                    1.7985e-09,
                    1.749e-09,
                    1.6995e-09,
                    1.65e-09,
                    1.6005e-09,
                    1.551e-09,
                    1.5015e-09,
                    1.5015e-09,
                    1.518e-09,
                    1.5345e-09,
                    1.551e-09,
                    1.5675e-09,
                    1.5675e-09,
                    1.5675e-09,
                    1.584e-09,
                    1.584e-09,
                    1.6335e-09,
                    1.6995e-09,
                    1.7655e-09,
                    1.8315e-09,
                    1.8975e-09,
                    1.9635e-09,
                    2.0295e-09,
                    2.0955e-09,
                    2.1615e-09,
                    2.2275e-09,
                    2.2605e-09,
                    2.2935e-09,
                    2.3265e-09,
                    2.376e-09,
                    2.4255e-09,
                    2.475e-09,
                    2.5245e-09,
                    2.574e-09,
                    2.607e-09,
                    2.64e-09,
                    2.6565e-09,
                    2.6895e-09,
                    3.6465e-09,
                    3.6795e-09,
                    3.7785e-09,
                    3.861e-09,
                    3.927e-09,
                    3.9765e-09,
                    4.0095e-09,
                    4.0425e-09,
                    4.092e-09,
                    4.1745e-09,
                    4.2075e-09,
                    4.2405e-09,
                    4.29e-09,
                    4.3395e-09,
                    4.4055e-09,
                    4.455e-09,
                    4.5045e-09,
                    4.5375e-09,
                    4.587e-09,
                    4.6365e-09,
                    4.6695e-09,
                    4.7355e-09,
                    4.785e-09,
                    4.851e-09,
                    4.9005e-09,
                    4.9665e-09,
                    5.016e-09,
                    5.082e-09,
                    5.148e-09,
                    5.2305e-09,
                    5.2305e-09,
                    5.247e-09,
                    5.247e-09,
                    5.247e-09,
                    5.247e-09,
                    5.2635e-09,
                    5.2635e-09,
                    5.247e-09,
                    5.2305e-09,
                    5.2305e-09,
                    5.379e-09,
                    5.379e-09,
                    5.973e-09,
                    5.9895e-09,
                    5.9895e-09,
                    6.5835e-09,
                    6.5835e-09,
                    6.6825e-09,
                    6.9135e-09,
                    6.897e-09,
                    7.0785e-09,
                    7.062e-09,
                    7.062e-09,
                    7.194e-09,
                    7.293e-09,
                    7.3755e-09,
                    7.4745e-09,
                    7.5075e-09,
                    7.557e-09,
                    7.6065e-09,
                    7.656e-09
                ],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [
                    6.3367e-10,
                    1.2717e-09,
                    1.9142e-09,
                    2.5612e-09,
                    3.2127e-09,
                    3.8688e-09,
                    4.5295e-09,
                    5.1948e-09,
                    5.8649e-09,
                    6.5398e-09,
                    7.2447e-09,
                    7.9796e-09,
                    8.7447e-09,
                    9.5398e-09,
                    1.0365e-08,
                    1.1221e-08,
                    1.2107e-08,
                    1.3024e-08,
                    1.3971e-08,
                    1.4948e-08,
                    1.596e-08,
                    1.7006e-08,
                    1.8085e-08,
                    1.9199e-08,
                    2.0347e-08,
                    2.1529e-08,
                    2.2745e-08,
                    2.3996e-08,
                    2.528e-08,
                    2.66e-08,
                    2.7931e-08,
                    2.9278e-08,
                    3.0643e-08,
                    3.2026e-08,
                    3.3425e-08,
                    3.4842e-08,
                    3.6277e-08,
                    3.773e-08,
                    3.9201e-08,
                    4.0691e-08,
                    4.2195e-08,
                    4.3714e-08,
                    4.5247e-08,
                    4.6794e-08,
                    4.8356e-08,
                    4.9933e-08,
                    5.1525e-08,
                    5.3131e-08,
                    5.4752e-08,
                    5.6387e-08,
                    5.8018e-08,
                    5.9642e-08,
                    6.126e-08,
                    6.2873e-08,
                    6.4482e-08,
                    6.6086e-08,
                    6.7686e-08,
                    6.9282e-08,
                    7.0876e-08,
                    7.2467e-08,
                    7.4188e-08,
                    7.6042e-08,
                    7.8027e-08,
                    8.0146e-08,
                    8.2398e-08,
                    8.4784e-08,
                    8.7304e-08,
                    8.9959e-08,
                    9.2749e-08,
                    9.5676e-08,
                    9.8819e-08,
                    1.0217e-07,
                    1.0572e-07,
                    1.0949e-07,
                    1.1346e-07,
                    1.1763e-07,
                    1.2201e-07,
                    1.2659e-07,
                    1.3137e-07,
                    1.3636e-07,
                    1.4152e-07,
                    1.4683e-07,
                    1.5231e-07,
                    1.5793e-07,
                    1.6372e-07,
                    1.6966e-07,
                    1.7576e-07,
                    1.8201e-07,
                    1.8842e-07,
                    1.9498e-07,
                    2.0186e-07,
                    2.0906e-07,
                    2.1659e-07,
                    2.2445e-07,
                    2.3261e-07,
                    2.4108e-07,
                    2.498e-07,
                    2.5876e-07,
                    2.6797e-07,
                    2.7746e-07,
                    2.869e-07,
                    2.9645e-07,
                    3.0618e-07,
                    3.1616e-07,
                    3.2644e-07,
                    3.3705e-07,
                    3.4804e-07,
                    3.5942e-07,
                    3.7125e-07,
                    3.8358e-07,
                    3.9624e-07,
                    4.0927e-07,
                    4.227e-07,
                    4.3651e-07,
                    4.5074e-07,
                    4.6534e-07,
                    4.8035e-07,
                    4.958e-07,
                    5.1178e-07,
                    5.3163e-07,
                    5.5434e-07,
                    5.7929e-07,
                    6.0659e-07,
                    6.3641e-07,
                    6.6874e-07,
                    7.0358e-07,
                    7.4093e-07,
                    7.8077e-07,
                    8.2319e-07,
                    8.6838e-07,
                    9.1641e-07,
                    9.6747e-07,
                    1.0219e-06,
                    1.08e-06,
                    1.142e-06,
                    1.2064e-06,
                    1.2735e-06,
                    1.3432e-06,
                    1.4153e-06,
                    1.4868e-06,
                    1.5584e-06,
                    1.6308e-06,
                    1.7038e-06,
                    1.7786e-06,
                    1.8559e-06,
                    1.9351e-06,
                    2.016e-06,
                    2.0988e-06,
                    2.183e-06,
                    2.2737e-06,
                    2.3653e-06,
                    2.4644e-06,
                    2.5693e-06,
                    2.6818e-06,
                    2.7973e-06,
                    2.9236e-06,
                    3.0566e-06,
                    3.198e-06,
                    3.344e-06,
                    3.4996e-06,
                    3.6656e-06,
                    3.8422e-06,
                    4.0299e-06,
                    4.2302e-06,
                    4.4339e-06,
                    4.6453e-06,
                    4.8642e-06,
                    5.0908e-06,
                    5.3284e-06,
                    5.5643e-06,
                    5.8073e-06,
                    6.051e-06
                ],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [
                    6.3367e-10,
                    1.2717e-09,
                    1.9142e-09,
                    2.5612e-09,
                    3.2127e-09,
                    3.8688e-09,
                    4.5295e-09,
                    5.1948e-09,
                    5.8649e-09,
                    6.5398e-09,
                    7.2447e-09,
                    7.9796e-09,
                    8.7447e-09,
                    9.5398e-09,
                    1.0365e-08,
                    1.1221e-08,
                    1.2107e-08,
                    1.3024e-08,
                    1.3971e-08,
                    1.4948e-08,
                    1.596e-08,
                    1.7006e-08,
                    1.8085e-08,
                    1.9199e-08,
                    2.0347e-08,
                    2.1529e-08,
                    2.2745e-08,
                    2.3996e-08,
                    2.528e-08,
                    2.66e-08,
                    2.7931e-08,
                    2.9278e-08,
                    3.0643e-08,
                    3.2026e-08,
                    3.3425e-08,
                    3.4842e-08,
                    3.6277e-08,
                    3.773e-08,
                    3.9201e-08,
                    4.0691e-08,
                    4.2195e-08,
                    4.3714e-08,
                    4.5247e-08,
                    4.6794e-08,
                    4.8356e-08,
                    4.9933e-08,
                    5.1525e-08,
                    5.3131e-08,
                    5.4752e-08,
                    5.6387e-08,
                    5.8018e-08,
                    5.9642e-08,
                    6.126e-08,
                    6.2873e-08,
                    6.4482e-08,
                    6.6086e-08,
                    6.7686e-08,
                    6.9282e-08,
                    7.0876e-08,
                    7.2467e-08,
                    7.4188e-08,
                    7.6042e-08,
                    7.8027e-08,
                    8.0146e-08,
                    8.2398e-08,
                    8.4784e-08,
                    8.7304e-08,
                    8.9959e-08,
                    9.2749e-08,
                    9.5676e-08,
                    9.8819e-08,
                    1.0217e-07,
                    1.0572e-07,
                    1.0949e-07,
                    1.1346e-07,
                    1.1763e-07,
                    1.2201e-07,
                    1.2659e-07,
                    1.3137e-07,
                    1.3636e-07,
                    1.4152e-07,
                    1.4683e-07,
                    1.5231e-07,
                    1.5793e-07,
                    1.6372e-07,
                    1.6966e-07,
                    1.7576e-07,
                    1.8201e-07,
                    1.8842e-07,
                    1.9498e-07,
                    2.0186e-07,
                    2.0906e-07,
                    2.1659e-07,
                    2.2445e-07,
                    2.3261e-07,
                    2.4108e-07,
                    2.498e-07,
                    2.5876e-07,
                    2.6797e-07,
                    2.7746e-07,
                    2.869e-07,
                    2.9645e-07,
                    3.0618e-07,
                    3.1616e-07,
                    3.2644e-07,
                    3.3705e-07,
                    3.4804e-07,
                    3.5942e-07,
                    3.7125e-07,
                    3.8358e-07,
                    3.9624e-07,
                    4.0927e-07,
                    4.227e-07,
                    4.3651e-07,
                    4.5074e-07,
                    4.6534e-07,
                    4.8035e-07,
                    4.9579e-07,
                    5.1176e-07,
                    5.3162e-07,
                    5.5433e-07,
                    5.7928e-07,
                    6.0657e-07,
                    6.3639e-07,
                    6.6871e-07,
                    7.0356e-07,
                    7.4091e-07,
                    7.8074e-07,
                    8.2316e-07,
                    8.6835e-07,
                    9.1638e-07,
                    9.6744e-07,
                    1.0218e-06,
                    1.08e-06,
                    1.1419e-06,
                    1.2064e-06,
                    1.2735e-06,
                    1.3432e-06,
                    1.4153e-06,
                    1.4868e-06,
                    1.5584e-06,
                    1.6308e-06,
                    1.7038e-06,
                    1.7786e-06,
                    1.8559e-06,
                    1.9351e-06,
                    2.016e-06,
                    2.0988e-06,
                    2.183e-06,
                    2.2737e-06,
                    2.3653e-06,
                    2.4643e-06,
                    2.5693e-06,
                    2.6817e-06,
                    2.7973e-06,
                    2.9236e-06,
                    3.0566e-06,
                    3.1979e-06,
                    3.3439e-06,
                    3.4995e-06,
                    3.6655e-06,
                    3.8421e-06,
                    4.0298e-06,
                    4.2301e-06,
                    4.4338e-06,
                    4.6452e-06,
                    4.8641e-06,
                    5.0907e-06,
                    5.3282e-06,
                    5.5642e-06,
                    5.8072e-06,
                    6.0509e-06
                ],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    5.5365e-12,
                    1.1073e-11,
                    1.661e-11,
                    1.661e-11,
                    1.661e-11,
                    1.661e-11,
                    1.661e-11,
                    2.2146e-11,
                    2.7683e-11,
                    2.7683e-11,
                    2.7683e-11,
                    2.7683e-11,
                    2.7683e-11,
                    2.7683e-11,
                    2.7683e-11,
                    2.7683e-11,
                    2.7683e-11,
                    2.7683e-11,
                    2.7683e-11,
                    2.7683e-11,
                    2.2492e-11,
                    1.7302e-11,
                    1.2111e-11,
                    1.2111e-11,
                    1.2111e-11,
                    1.2111e-11,
                    1.2111e-11,
                    6.9206e-12,
                    1.7302e-12,
                    1.7302e-12,
                    7.2667e-12,
                    1.2803e-11,
                    1.834e-11,
                    2.3876e-11,
                    2.9413e-11,
                    3.4949e-11,
                    4.0486e-11,
                    4.6022e-11,
                    5.1559e-11,
                    5.7095e-11,
                    6.2632e-11,
                    6.8168e-11,
                    7.3705e-11,
                    7.9241e-11,
                    8.4778e-11,
                    9.0314e-11,
                    9.5851e-11,
                    1.0139e-10,
                    1.0692e-10,
                    1.1246e-10,
                    1.1281e-10,
                    1.1315e-10,
                    1.135e-10,
                    1.1384e-10,
                    1.1419e-10,
                    1.1457e-10
                ],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [
                    6.0907e-11,
                    1.2284e-10,
                    1.8577e-10,
                    2.4963e-10,
                    3.1438e-10,
                    3.7992e-10,
                    4.4617e-10,
                    5.1302e-10,
                    5.8036e-10,
                    6.4805e-10,
                    7.1601e-10,
                    7.8421e-10,
                    8.5265e-10,
                    9.213e-10,
                    9.9017e-10,
                    1.0593e-09,
                    1.1286e-09,
                    1.1981e-09,
                    1.2679e-09,
                    1.338e-09,
                    1.409e-09,
                    1.4823e-09,
                    1.5587e-09,
                    1.6389e-09,
                    1.7232e-09,
                    1.8118e-09,
                    1.9045e-09,
                    2.0007e-09,
                    2.0998e-09,
                    2.2007e-09,
                    2.3026e-09,
                    2.4055e-09,
                    2.5093e-09,
                    2.6138e-09,
                    2.7189e-09,
                    2.8248e-09,
                    2.9312e-09,
                    3.0384e-09,
                    3.1463e-09,
                    3.2552e-09,
                    3.3651e-09,
                    3.4759e-09,
                    3.5877e-09,
                    3.7005e-09,
                    3.8143e-09,
                    3.9292e-09,
                    4.0453e-09,
                    4.1626e-09,
                    4.2812e-09,
                    4.4011e-09,
                    4.5226e-09,
                    4.6459e-09,
                    4.7713e-09,
                    4.8988e-09,
                    5.0285e-09,
                    5.1606e-09,
                    5.295e-09,
                    5.4318e-09,
                    5.5708e-09,
                    5.712e-09,
                    5.8552e-09,
                    6.0005e-09,
                    6.1479e-09,
                    6.2972e-09,
                    6.4486e-09,
                    6.6021e-09,
                    6.7575e-09,
                    6.915e-09,
                    7.0746e-09,
                    7.2362e-09,
                    7.4e-09,
                    7.5659e-09,
                    7.7339e-09,
                    7.9042e-09,
                    8.0767e-09,
                    8.2513e-09,
                    8.4281e-09,
                    8.6069e-09,
                    8.7878e-09,
                    8.9706e-09,
                    9.1551e-09,
                    9.3412e-09,
                    9.5287e-09,
                    9.7176e-09,
                    9.908e-09,
                    1.01e-08,
                    1.0294e-08,
                    1.0489e-08,
                    1.0687e-08,
                    1.0888e-08,
                    1.1094e-08,
                    1.1311e-08,
                    1.1543e-08,
                    1.1793e-08,
                    1.2062e-08,
                    1.2351e-08,
                    1.2659e-08,
                    1.2986e-08,
                    1.3328e-08,
                    1.3682e-08,
                    1.4045e-08,
                    1.4416e-08,
                    1.4794e-08,
                    1.5178e-08,
                    1.5569e-08,
                    1.5966e-08,
                    1.6369e-08,
                    1.678e-08,
                    1.72e-08,
                    1.7629e-08,
                    1.8072e-08,
                    1.8531e-08,
                    1.9022e-08,
                    1.9536e-08,
                    2.0074e-08,
                    2.0636e-08,
                    2.1221e-08,
                    2.1816e-08,
                    2.2431e-08,
                    2.3224e-08,
                    2.3948e-08,
                    2.4679e-08,
                    2.5609e-08,
                    2.6575e-08,
                    2.7588e-08,
                    2.8588e-08,
                    2.9596e-08,
                    3.0693e-08,
                    3.1803e-08,
                    3.2981e-08,
                    3.4286e-08,
                    3.5614e-08,
                    3.7103e-08,
                    3.9034e-08,
                    4.1148e-08,
                    4.3296e-08,
                    4.5506e-08,
                    4.8015e-08,
                    5.0284e-08,
                    5.248e-08,
                    5.4855e-08,
                    5.7466e-08,
                    6.026e-08,
                    6.4044e-08,
                    6.8552e-08,
                    7.3293e-08,
                    7.7905e-08,
                    8.2946e-08,
                    8.7958e-08,
                    9.6079e-08,
                    1.0346e-07,
                    1.1196e-07,
                    1.1962e-07,
                    1.2876e-07,
                    1.3751e-07,
                    1.4785e-07,
                    1.5926e-07,
                    1.7159e-07,
                    1.8514e-07,
                    2.0012e-07,
                    2.1703e-07,
                    2.3815e-07,
                    2.5925e-07,
                    2.8568e-07,
                    3.0642e-07,
                    3.2777e-07,
                    3.4986e-07,
                    3.7307e-07,
                    3.996e-07,
                    4.2475e-07,
                    4.5064e-07,
                    4.7709e-07
                ],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [
                    6.0907e-11,
                    1.2284e-10,
                    1.8577e-10,
                    2.4963e-10,
                    3.1438e-10,
                    3.7992e-10,
                    4.4617e-10,
                    5.1302e-10,
                    5.8036e-10,
                    6.4805e-10,
                    7.1601e-10,
                    7.8421e-10,
                    8.5265e-10,
                    9.213e-10,
                    9.9017e-10,
                    1.0593e-09,
                    1.1286e-09,
                    1.1981e-09,
                    1.2679e-09,
                    1.338e-09,
                    1.409e-09,
                    1.4823e-09,
                    1.5587e-09,
                    1.6389e-09,
                    1.7232e-09,
                    1.8118e-09,
                    1.9045e-09,
                    2.0007e-09,
                    2.0998e-09,
                    2.2007e-09,
                    2.3026e-09,
                    2.4055e-09,
                    2.5093e-09,
                    2.6138e-09,
                    2.7189e-09,
                    2.8248e-09,
                    2.9312e-09,
                    3.0384e-09,
                    3.1463e-09,
                    3.2552e-09,
                    3.3651e-09,
                    3.4759e-09,
                    3.5877e-09,
                    3.7005e-09,
                    3.8143e-09,
                    3.9292e-09,
                    4.0453e-09,
                    4.1626e-09,
                    4.2812e-09,
                    4.4011e-09,
                    4.5226e-09,
                    4.6459e-09,
                    4.7713e-09,
                    4.8988e-09,
                    5.0285e-09,
                    5.1606e-09,
                    5.295e-09,
                    5.4318e-09,
                    5.5708e-09,
                    5.712e-09,
                    5.8552e-09,
                    6.0005e-09,
                    6.1479e-09,
                    6.2972e-09,
                    6.4486e-09,
                    6.6021e-09,
                    6.7575e-09,
                    6.915e-09,
                    7.0746e-09,
                    7.2362e-09,
                    7.4e-09,
                    7.5659e-09,
                    7.7339e-09,
                    7.9042e-09,
                    8.0767e-09,
                    8.2513e-09,
                    8.4281e-09,
                    8.6069e-09,
                    8.7878e-09,
                    8.9706e-09,
                    9.1551e-09,
                    9.3412e-09,
                    9.5287e-09,
                    9.7176e-09,
                    9.908e-09,
                    1.01e-08,
                    1.0294e-08,
                    1.0489e-08,
                    1.0687e-08,
                    1.0888e-08,
                    1.1094e-08,
                    1.1311e-08,
                    1.1543e-08,
                    1.1793e-08,
                    1.2062e-08,
                    1.2351e-08,
                    1.2659e-08,
                    1.2986e-08,
                    1.3328e-08,
                    1.3682e-08,
                    1.4045e-08,
                    1.4416e-08,
                    1.4794e-08,
                    1.5178e-08,
                    1.5569e-08,
                    1.5966e-08,
                    1.6369e-08,
                    1.678e-08,
                    1.72e-08,
                    1.7629e-08,
                    1.8072e-08,
                    1.8531e-08,
                    1.901e-08,
                    1.9512e-08,
                    2.0037e-08,
                    2.0587e-08,
                    2.116e-08,
                    2.1755e-08,
                    2.237e-08,
                    2.3151e-08,
                    2.3874e-08,
                    2.4605e-08,
                    2.5511e-08,
                    2.6452e-08,
                    2.7403e-08,
                    2.8404e-08,
                    2.9411e-08,
                    3.0509e-08,
                    3.1619e-08,
                    3.2796e-08,
                    3.4101e-08,
                    3.543e-08,
                    3.6919e-08,
                    3.885e-08,
                    4.0963e-08,
                    4.3111e-08,
                    4.5321e-08,
                    4.7831e-08,
                    5.01e-08,
                    5.2296e-08,
                    5.4671e-08,
                    5.7282e-08,
                    6.0076e-08,
                    6.386e-08,
                    6.8368e-08,
                    7.3108e-08,
                    7.7721e-08,
                    8.2762e-08,
                    8.7774e-08,
                    9.5895e-08,
                    1.0328e-07,
                    1.1175e-07,
                    1.1939e-07,
                    1.2848e-07,
                    1.3714e-07,
                    1.4718e-07,
                    1.5793e-07,
                    1.701e-07,
                    1.833e-07,
                    1.9796e-07,
                    2.1469e-07,
                    2.3502e-07,
                    2.5548e-07,
                    2.8139e-07,
                    3.0156e-07,
                    3.2203e-07,
                    3.4323e-07,
                    3.6538e-07,
                    3.9132e-07,
                    4.1585e-07,
                    4.4109e-07,
                    4.6689e-07
                ],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.2294e-11,
                    2.4588e-11,
                    3.6882e-11,
                    4.9176e-11,
                    6.147e-11,
                    6.147e-11,
                    6.147e-11,
                    7.3764e-11,
                    7.3764e-11,
                    7.3764e-11,
                    9.8352e-11,
                    1.2294e-10,
                    1.8441e-10,
                    1.8441e-10,
                    1.8441e-10,
                    1.8441e-10,
                    1.8441e-10,
                    1.8441e-10,
                    1.8441e-10,
                    1.8441e-10,
                    1.8441e-10,
                    1.8441e-10,
                    1.8441e-10,
                    1.8441e-10,
                    1.8441e-10,
                    1.8441e-10,
                    1.8441e-10,
                    1.8441e-10,
                    1.8441e-10,
                    1.8441e-10,
                    1.8441e-10,
                    1.8441e-10,
                    1.8441e-10,
                    1.8441e-10,
                    1.8441e-10,
                    1.8441e-10,
                    1.8441e-10,
                    1.8441e-10,
                    1.8441e-10,
                    2.09e-10,
                    2.3358e-10,
                    2.8276e-10,
                    3.6882e-10,
                    6.7617e-10,
                    1.3277e-09,
                    1.4876e-09,
                    1.8441e-09,
                    2.1637e-09,
                    2.3481e-09,
                    3.1227e-09,
                    3.7742e-09,
                    4.2906e-09,
                    4.8684e-09,
                    5.7413e-09,
                    6.6387e-09,
                    7.6837e-09,
                    8.2738e-09,
                    8.9008e-09,
                    9.5524e-09,
                    1.0208e-08
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            73.51586,
                            1.85232
                        ],
                        [
                            73.52589,
                            1.86762
                        ],
                        [
                            73.55324,
                            1.92827
                        ],
                        [
                            73.5385,
                            1.9181
                        ],
                        [
                            73.53295,
                            1.89127
                        ],
                        [
                            73.51586,
                            1.85232
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "MLI",
                "Country": "Mali",
                "Total_3GHG": 0.09,
                "Total_3GHG_timeseries": [
                    7.0939e-07,
                    1.445e-06,
                    2.196e-06,
                    2.9566e-06,
                    3.7238e-06,
                    4.4956e-06,
                    5.2707e-06,
                    6.0482e-06,
                    6.8273e-06,
                    7.4781e-06,
                    8.1045e-06,
                    8.7299e-06,
                    9.3649e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015
                ],
                "Fossil_3GHG": 0.02,
                "Fossil_3GHG_timeseries": [
                    5.2566e-08,
                    1.0642e-07,
                    1.6154e-07,
                    2.1794e-07,
                    2.7559e-07,
                    3.3448e-07,
                    3.9461e-07,
                    4.5596e-07,
                    5.1851e-07,
                    5.8224e-07,
                    6.4935e-07,
                    7.1982e-07,
                    7.9428e-07,
                    8.7209e-07,
                    9.5324e-07,
                    1.0377e-06,
                    1.1255e-06,
                    1.2166e-06,
                    1.311e-06,
                    1.4087e-06,
                    1.5088e-06,
                    1.6112e-06,
                    1.7162e-06,
                    1.8236e-06,
                    1.9335e-06,
                    2.046e-06,
                    2.1609e-06,
                    2.2784e-06,
                    2.3983e-06,
                    2.5206e-06,
                    2.6433e-06,
                    2.7665e-06,
                    2.8895e-06,
                    3.0129e-06,
                    3.1367e-06,
                    3.261e-06,
                    3.3857e-06,
                    3.5108e-06,
                    3.6364e-06,
                    3.7627e-06,
                    3.8895e-06,
                    4.0168e-06,
                    4.1447e-06,
                    4.2733e-06,
                    4.4024e-06,
                    4.5321e-06,
                    4.6625e-06,
                    4.7935e-06,
                    4.9252e-06,
                    5.0576e-06,
                    5.1975e-06,
                    5.345e-06,
                    5.5001e-06,
                    5.6629e-06,
                    5.8334e-06,
                    6.0116e-06,
                    6.1975e-06,
                    6.3912e-06,
                    6.5927e-06,
                    6.8019e-06,
                    7.0189e-06,
                    7.2438e-06,
                    7.4765e-06,
                    7.7373e-06,
                    8.0052e-06,
                    8.2761e-06,
                    8.5498e-06,
                    8.8266e-06,
                    9.1063e-06,
                    9.39e-06,
                    9.675e-06,
                    9.9615e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_3GHG": 0.22,
                "Land_3GHG_timeseries": [
                    6.5683e-07,
                    1.3386e-06,
                    2.0344e-06,
                    2.7386e-06,
                    3.4482e-06,
                    4.1611e-06,
                    4.8761e-06,
                    5.5922e-06,
                    6.3088e-06,
                    6.8959e-06,
                    7.4552e-06,
                    8.0101e-06,
                    8.5706e-06,
                    9.1421e-06,
                    9.7281e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013
                ],
                "Total_CO2": 0.03,
                "Total_CO2_timeseries": [
                    1.1613e-07,
                    2.5446e-07,
                    4.0422e-07,
                    5.5989e-07,
                    7.1861e-07,
                    8.7857e-07,
                    1.0387e-06,
                    1.1986e-06,
                    1.3576e-06,
                    1.3864e-06,
                    1.3627e-06,
                    1.31e-06,
                    1.2384e-06,
                    1.1533e-06,
                    1.058e-06,
                    9.5476e-07,
                    8.4509e-07,
                    7.3009e-07,
                    6.1053e-07,
                    4.9586e-07,
                    3.8133e-07,
                    2.6448e-07,
                    1.4467e-07,
                    2.1841e-08,
                    -0.00000010391,
                    -0.00000023236,
                    -0.00000036336,
                    -0.00000049669,
                    -0.00000063217,
                    -0.00000076928,
                    -0.00000090538,
                    -0.0000010428,
                    -0.0000011824,
                    -0.0000013245,
                    -0.0000014691,
                    -0.0000016162,
                    -0.0000017658,
                    -0.0000019178,
                    -0.000002072,
                    -0.0000022181,
                    -0.000002362,
                    -0.0000025082,
                    -0.0000026582,
                    -0.0000028123,
                    -0.0000029704,
                    -0.0000031316,
                    -0.0000032947,
                    -0.0000034583,
                    -0.000003621,
                    -0.000003767,
                    -0.0000039013,
                    -0.0000040316,
                    -0.0000041624,
                    -0.0000042857,
                    -0.0000044019,
                    -0.0000045091,
                    -0.0000045916,
                    -0.0000046721,
                    -0.000004747,
                    -0.0000047666,
                    -0.0000047571,
                    -0.0000047377,
                    -0.0000047103,
                    -0.0000046766,
                    -0.0000046283,
                    -0.0000045602,
                    -0.0000044858,
                    -0.0000044053,
                    -0.0000043285,
                    -0.0000042123,
                    -0.000004061,
                    -0.0000039015,
                    -0.000003727,
                    -0.0000035651,
                    -0.0000033821,
                    -0.0000031881,
                    -0.0000029989,
                    -0.0000028023,
                    -0.0000025939,
                    -0.000002293,
                    -0.0000019619,
                    -0.0000016327,
                    -0.000001325,
                    -0.0000010284,
                    -0.00000079474,
                    -0.00000058554,
                    -0.00000037277,
                    -0.00000019954,
                    -0.000000045001,
                    4.6777e-07,
                    1.1187e-06,
                    1.7271e-06,
                    2.2198e-06,
                    2.6598e-06,
                    2.9415e-06,
                    3.1364e-06,
                    3.2686e-06,
                    3.3061e-06,
                    3.244e-06,
                    3.2947e-06,
                    4.7348e-06,
                    5.7304e-06,
                    6.5463e-06,
                    7.2526e-06,
                    7.8621e-06,
                    8.4701e-06,
                    8.9749e-06,
                    9.4407e-06,
                    9.9545e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2.145e-08,
                    7.59e-08,
                    1.287e-07,
                    1.914e-07,
                    2.706e-07,
                    3.498e-07,
                    4.389e-07,
                    5.247e-07,
                    6.2535e-07,
                    7.1445e-07,
                    7.8705e-07,
                    8.778e-07,
                    9.801e-07,
                    1.0907e-06,
                    1.211e-06,
                    1.3479e-06,
                    1.5012e-06,
                    1.6545e-06,
                    1.8407e-06,
                    2.0185e-06,
                    2.2112e-06,
                    2.3875e-06,
                    2.5653e-06,
                    2.7297e-06,
                    2.9173e-06,
                    3.1131e-06,
                    3.2957e-06,
                    3.4666e-06,
                    3.6276e-06,
                    3.8001e-06,
                    3.9874e-06,
                    4.1776e-06,
                    4.3694e-06,
                    4.5776e-06,
                    4.8041e-06,
                    5.051e-06,
                    5.3191e-06,
                    5.61e-06,
                    5.9372e-06,
                    6.358e-06,
                    6.7952e-06,
                    7.2754e-06,
                    7.7984e-06,
                    8.3429e-06,
                    8.9039e-06,
                    9.5375e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CO2": 0.07,
                "Land_CO2_timeseries": [
                    1.1613e-07,
                    2.5446e-07,
                    4.0422e-07,
                    5.5989e-07,
                    7.1861e-07,
                    8.7857e-07,
                    1.0387e-06,
                    1.1986e-06,
                    1.3576e-06,
                    1.3864e-06,
                    1.3627e-06,
                    1.31e-06,
                    1.2384e-06,
                    1.1533e-06,
                    1.058e-06,
                    9.5476e-07,
                    8.4509e-07,
                    7.3009e-07,
                    6.1053e-07,
                    4.9586e-07,
                    3.8133e-07,
                    2.6448e-07,
                    1.4467e-07,
                    2.1841e-08,
                    -0.00000010391,
                    -0.00000023236,
                    -0.00000036336,
                    -0.00000049669,
                    -0.00000063217,
                    -0.00000076928,
                    -0.00000090538,
                    -0.0000010428,
                    -0.0000011824,
                    -0.0000013245,
                    -0.0000014691,
                    -0.0000016162,
                    -0.0000017658,
                    -0.0000019178,
                    -0.000002072,
                    -0.0000022181,
                    -0.000002362,
                    -0.0000025082,
                    -0.0000026582,
                    -0.0000028123,
                    -0.0000029704,
                    -0.0000031316,
                    -0.0000032947,
                    -0.0000034583,
                    -0.000003621,
                    -0.000003767,
                    -0.0000039013,
                    -0.0000040316,
                    -0.0000041624,
                    -0.0000042857,
                    -0.0000044019,
                    -0.0000045091,
                    -0.0000045916,
                    -0.0000046721,
                    -0.000004747,
                    -0.0000047666,
                    -0.0000047571,
                    -0.0000047377,
                    -0.0000047103,
                    -0.0000046766,
                    -0.0000046283,
                    -0.0000045602,
                    -0.0000044858,
                    -0.0000044053,
                    -0.0000043285,
                    -0.0000042123,
                    -0.000004061,
                    -0.0000039015,
                    -0.000003727,
                    -0.0000035651,
                    -0.0000033821,
                    -0.0000031881,
                    -0.0000029989,
                    -0.0000028023,
                    -0.0000025939,
                    -0.000002293,
                    -0.0000019619,
                    -0.0000016327,
                    -0.000001325,
                    -0.0000010284,
                    -0.00000079474,
                    -0.00000058554,
                    -0.00000037277,
                    -0.00000019954,
                    -0.000000045001,
                    4.6777e-07,
                    1.1187e-06,
                    1.7271e-06,
                    2.2198e-06,
                    2.6598e-06,
                    2.9415e-06,
                    3.1364e-06,
                    3.2686e-06,
                    3.3061e-06,
                    3.244e-06,
                    3.2947e-06,
                    4.7348e-06,
                    5.7304e-06,
                    6.5463e-06,
                    7.2526e-06,
                    7.8621e-06,
                    8.4701e-06,
                    8.9749e-06,
                    9.4407e-06,
                    9.933e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Total_CH4": 0.23,
                "Total_CH4_timeseries": [
                    4.7138e-07,
                    9.4435e-07,
                    1.4189e-06,
                    1.895e-06,
                    2.3727e-06,
                    2.8519e-06,
                    3.3327e-06,
                    3.8151e-06,
                    4.2989e-06,
                    4.7843e-06,
                    5.2975e-06,
                    5.8385e-06,
                    6.4079e-06,
                    7.0051e-06,
                    7.63e-06,
                    8.2827e-06,
                    8.9632e-06,
                    9.6714e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009
                ],
                "Fossil_CH4": 0.06,
                "Fossil_CH4_timeseries": [
                    4.9596e-08,
                    1.0042e-07,
                    1.5247e-07,
                    2.0574e-07,
                    2.6022e-07,
                    3.159e-07,
                    3.7278e-07,
                    4.3085e-07,
                    4.901e-07,
                    5.5052e-07,
                    6.143e-07,
                    6.8143e-07,
                    7.5256e-07,
                    8.2702e-07,
                    9.0482e-07,
                    9.8593e-07,
                    1.0704e-06,
                    1.1581e-06,
                    1.2491e-06,
                    1.3434e-06,
                    1.44e-06,
                    1.5389e-06,
                    1.6401e-06,
                    1.7435e-06,
                    1.8493e-06,
                    1.9573e-06,
                    2.0676e-06,
                    2.1802e-06,
                    2.295e-06,
                    2.4122e-06,
                    2.5297e-06,
                    2.6476e-06,
                    2.7653e-06,
                    2.8834e-06,
                    3.0018e-06,
                    3.1207e-06,
                    3.24e-06,
                    3.3596e-06,
                    3.4797e-06,
                    3.6002e-06,
                    3.7212e-06,
                    3.8426e-06,
                    3.9645e-06,
                    4.0869e-06,
                    4.2098e-06,
                    4.3332e-06,
                    4.4571e-06,
                    4.5815e-06,
                    4.7065e-06,
                    4.832e-06,
                    4.9648e-06,
                    5.1051e-06,
                    5.2528e-06,
                    5.4079e-06,
                    5.5705e-06,
                    5.7406e-06,
                    5.9183e-06,
                    6.1035e-06,
                    6.2962e-06,
                    6.4966e-06,
                    6.7046e-06,
                    6.9203e-06,
                    7.1437e-06,
                    7.3951e-06,
                    7.6535e-06,
                    7.9147e-06,
                    8.1787e-06,
                    8.4455e-06,
                    8.7151e-06,
                    8.9886e-06,
                    9.2634e-06,
                    9.5394e-06,
                    9.8168e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_CH4": 0.5,
                "Land_CH4_timeseries": [
                    4.2179e-07,
                    8.4393e-07,
                    1.2664e-06,
                    1.6893e-06,
                    2.1125e-06,
                    2.536e-06,
                    2.9599e-06,
                    3.3842e-06,
                    3.8088e-06,
                    4.2338e-06,
                    4.6832e-06,
                    5.1571e-06,
                    5.6553e-06,
                    6.1781e-06,
                    6.7252e-06,
                    7.2968e-06,
                    7.8928e-06,
                    8.5133e-06,
                    9.1582e-06,
                    9.8275e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008
                ],
                "Total_N2O": 0.33,
                "Total_N2O_timeseries": [
                    1.2188e-07,
                    2.462e-07,
                    3.7285e-07,
                    5.0167e-07,
                    6.325e-07,
                    7.651e-07,
                    8.9922e-07,
                    1.0345e-06,
                    1.1707e-06,
                    1.3074e-06,
                    1.4443e-06,
                    1.5814e-06,
                    1.7186e-06,
                    1.8559e-06,
                    1.9933e-06,
                    2.1308e-06,
                    2.2683e-06,
                    2.4061e-06,
                    2.544e-06,
                    2.6822e-06,
                    2.8226e-06,
                    2.969e-06,
                    3.1238e-06,
                    3.2891e-06,
                    3.4659e-06,
                    3.6544e-06,
                    3.8541e-06,
                    4.0636e-06,
                    4.2808e-06,
                    4.5026e-06,
                    4.7271e-06,
                    4.9537e-06,
                    5.1822e-06,
                    5.4124e-06,
                    5.6439e-06,
                    5.8768e-06,
                    6.1111e-06,
                    6.3468e-06,
                    6.5841e-06,
                    6.8338e-06,
                    7.0859e-06,
                    7.3405e-06,
                    7.5978e-06,
                    7.8578e-06,
                    8.1207e-06,
                    8.3866e-06,
                    8.6555e-06,
                    8.9275e-06,
                    9.2028e-06,
                    9.4814e-06,
                    9.7633e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_N2O": 0.03,
                "Fossil_N2O_timeseries": [
                    2.9703e-09,
                    5.995e-09,
                    9.072e-09,
                    1.2198e-08,
                    1.537e-08,
                    1.8583e-08,
                    2.1831e-08,
                    2.5109e-08,
                    2.8409e-08,
                    3.1724e-08,
                    3.5048e-08,
                    3.8381e-08,
                    4.1721e-08,
                    4.5069e-08,
                    4.8423e-08,
                    5.1783e-08,
                    5.5151e-08,
                    5.8526e-08,
                    6.191e-08,
                    6.5304e-08,
                    6.875e-08,
                    7.2319e-08,
                    7.6067e-08,
                    8.0032e-08,
                    8.4236e-08,
                    8.8684e-08,
                    9.3364e-08,
                    9.8249e-08,
                    1.0329e-07,
                    1.0844e-07,
                    1.1364e-07,
                    1.189e-07,
                    1.2419e-07,
                    1.2952e-07,
                    1.3489e-07,
                    1.4029e-07,
                    1.4572e-07,
                    1.5119e-07,
                    1.5669e-07,
                    1.6243e-07,
                    1.6825e-07,
                    1.7418e-07,
                    1.802e-07,
                    1.8633e-07,
                    1.9257e-07,
                    1.9893e-07,
                    2.0541e-07,
                    2.1202e-07,
                    2.1876e-07,
                    2.2565e-07,
                    2.3269e-07,
                    2.3992e-07,
                    2.4735e-07,
                    2.5499e-07,
                    2.6286e-07,
                    2.7094e-07,
                    2.7925e-07,
                    2.8776e-07,
                    2.9646e-07,
                    3.0532e-07,
                    3.1433e-07,
                    3.2349e-07,
                    3.3277e-07,
                    3.4219e-07,
                    3.5173e-07,
                    3.614e-07,
                    3.7119e-07,
                    3.8111e-07,
                    3.9116e-07,
                    4.0135e-07,
                    4.1167e-07,
                    4.2213e-07,
                    4.3273e-07,
                    4.4347e-07,
                    4.5435e-07,
                    4.6537e-07,
                    4.7653e-07,
                    4.8785e-07,
                    4.9933e-07,
                    5.1097e-07,
                    5.228e-07,
                    5.3484e-07,
                    5.4711e-07,
                    5.5965e-07,
                    5.7247e-07,
                    5.856e-07,
                    5.9906e-07,
                    6.1286e-07,
                    6.2701e-07,
                    6.4153e-07,
                    6.5656e-07,
                    6.723e-07,
                    6.8895e-07,
                    7.0662e-07,
                    7.2542e-07,
                    7.4538e-07,
                    7.665e-07,
                    7.8874e-07,
                    8.12e-07,
                    8.3615e-07,
                    8.6114e-07,
                    8.87e-07,
                    9.1374e-07,
                    9.414e-07,
                    9.6997e-07,
                    9.9944e-07,
                    1.0298e-06,
                    1.061e-06,
                    1.0931e-06,
                    1.126e-06,
                    1.1596e-06,
                    1.1942e-06,
                    1.2297e-06,
                    1.2662e-06,
                    1.3038e-06,
                    1.3425e-06,
                    1.3825e-06,
                    1.4235e-06,
                    1.4658e-06,
                    1.5124e-06,
                    1.5563e-06,
                    1.6005e-06,
                    1.6445e-06,
                    1.6912e-06,
                    1.74e-06,
                    1.7897e-06,
                    1.839e-06,
                    1.8893e-06,
                    1.9419e-06,
                    1.9936e-06,
                    2.0463e-06,
                    2.1113e-06,
                    2.1762e-06,
                    2.2421e-06,
                    2.3164e-06,
                    2.3906e-06,
                    2.468e-06,
                    2.5493e-06,
                    2.6344e-06,
                    2.7215e-06,
                    2.8112e-06,
                    2.9003e-06,
                    2.9908e-06,
                    3.0847e-06,
                    3.1826e-06,
                    3.2827e-06,
                    3.3843e-06,
                    3.4886e-06,
                    3.5981e-06,
                    3.7127e-06,
                    3.8295e-06,
                    3.9492e-06,
                    4.0729e-06,
                    4.2014e-06,
                    4.3358e-06,
                    4.4756e-06,
                    4.6218e-06,
                    4.7752e-06,
                    4.9386e-06,
                    5.1077e-06,
                    5.284e-06,
                    5.4654e-06,
                    5.6542e-06,
                    5.8487e-06,
                    6.0527e-06,
                    6.2658e-06,
                    6.4897e-06,
                    6.7197e-06,
                    6.9555e-06,
                    7.199e-06,
                    7.4498e-06,
                    7.7046e-06
                ],
                "Land_N2O": 0.44,
                "Land_N2O_timeseries": [
                    1.1891e-07,
                    2.4021e-07,
                    3.6377e-07,
                    4.8948e-07,
                    6.1713e-07,
                    7.4652e-07,
                    8.7739e-07,
                    1.0094e-06,
                    1.1423e-06,
                    1.2757e-06,
                    1.4092e-06,
                    1.543e-06,
                    1.6768e-06,
                    1.8108e-06,
                    1.9449e-06,
                    2.079e-06,
                    2.2132e-06,
                    2.3475e-06,
                    2.4821e-06,
                    2.6169e-06,
                    2.7539e-06,
                    2.8967e-06,
                    3.0478e-06,
                    3.2091e-06,
                    3.3816e-06,
                    3.5657e-06,
                    3.7607e-06,
                    3.9654e-06,
                    4.1775e-06,
                    4.3942e-06,
                    4.6134e-06,
                    4.8348e-06,
                    5.058e-06,
                    5.2828e-06,
                    5.509e-06,
                    5.7365e-06,
                    5.9653e-06,
                    6.1956e-06,
                    6.4274e-06,
                    6.6713e-06,
                    6.9176e-06,
                    7.1663e-06,
                    7.4176e-06,
                    7.6715e-06,
                    7.9281e-06,
                    8.1876e-06,
                    8.4501e-06,
                    8.7155e-06,
                    8.9841e-06,
                    9.2558e-06,
                    9.5307e-06,
                    9.8085e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -5.51892,
                            10.43327
                        ],
                        [
                            -5.46613,
                            10.5927
                        ],
                        [
                            -5.48,
                            10.63071
                        ],
                        [
                            -5.47334,
                            10.75733
                        ],
                        [
                            -5.42262,
                            10.85044
                        ],
                        [
                            -5.48903,
                            10.97359
                        ],
                        [
                            -5.496,
                            11.06316
                        ],
                        [
                            -5.39453,
                            11.098
                        ],
                        [
                            -5.34229,
                            11.136
                        ],
                        [
                            -5.32788,
                            11.19699
                        ],
                        [
                            -5.27105,
                            11.2378
                        ],
                        [
                            -5.25656,
                            11.37041
                        ],
                        [
                            -5.20001,
                            11.43074
                        ],
                        [
                            -5.2046,
                            11.53211
                        ],
                        [
                            -5.24209,
                            11.60465
                        ],
                        [
                            -5.29842,
                            11.62863
                        ],
                        [
                            -5.26552,
                            11.74381
                        ],
                        [
                            -5.32834,
                            11.84418
                        ],
                        [
                            -5.24829,
                            11.86508
                        ],
                        [
                            -5.15465,
                            11.94767
                        ],
                        [
                            -5.09345,
                            11.97063
                        ],
                        [
                            -4.84023,
                            12.0162
                        ],
                        [
                            -4.73368,
                            11.99827
                        ],
                        [
                            -4.70721,
                            12.04978
                        ],
                        [
                            -4.65792,
                            12.05469
                        ],
                        [
                            -4.60937,
                            12.1237
                        ],
                        [
                            -4.58426,
                            12.19834
                        ],
                        [
                            -4.51464,
                            12.2544
                        ],
                        [
                            -4.46835,
                            12.3261
                        ],
                        [
                            -4.42905,
                            12.48386
                        ],
                        [
                            -4.39418,
                            12.53347
                        ],
                        [
                            -4.4199,
                            12.59012
                        ],
                        [
                            -4.47693,
                            12.63369
                        ],
                        [
                            -4.48835,
                            12.71198
                        ],
                        [
                            -4.37121,
                            12.73129
                        ],
                        [
                            -4.29521,
                            12.69934
                        ],
                        [
                            -4.22898,
                            12.77508
                        ],
                        [
                            -4.23045,
                            12.93604
                        ],
                        [
                            -4.34577,
                            13.14592
                        ],
                        [
                            -4.24296,
                            13.19449
                        ],
                        [
                            -4.25822,
                            13.22932
                        ],
                        [
                            -4.15442,
                            13.29189
                        ],
                        [
                            -4.10405,
                            13.38281
                        ],
                        [
                            -4.00684,
                            13.4335
                        ],
                        [
                            -3.95694,
                            13.49458
                        ],
                        [
                            -3.92063,
                            13.43164
                        ],
                        [
                            -3.96753,
                            13.38729
                        ],
                        [
                            -3.77784,
                            13.34597
                        ],
                        [
                            -3.7236,
                            13.28426
                        ],
                        [
                            -3.60167,
                            13.20343
                        ],
                        [
                            -3.53138,
                            13.17194
                        ],
                        [
                            -3.43372,
                            13.16309
                        ],
                        [
                            -3.43442,
                            13.25198
                        ],
                        [
                            -3.403,
                            13.27156
                        ],
                        [
                            -3.25427,
                            13.28487
                        ],
                        [
                            -3.28163,
                            13.53393
                        ],
                        [
                            -3.26052,
                            13.57715
                        ],
                        [
                            -3.26272,
                            13.71835
                        ],
                        [
                            -3.18491,
                            13.68558
                        ],
                        [
                            -3.10515,
                            13.69446
                        ],
                        [
                            -3.03892,
                            13.62919
                        ],
                        [
                            -2.99483,
                            13.66315
                        ],
                        [
                            -2.95302,
                            13.62727
                        ],
                        [
                            -2.87365,
                            13.6551
                        ],
                        [
                            -2.90271,
                            13.72472
                        ],
                        [
                            -2.89609,
                            13.82274
                        ],
                        [
                            -2.83345,
                            13.99529
                        ],
                        [
                            -2.83699,
                            14.05949
                        ],
                        [
                            -2.67214,
                            14.13463
                        ],
                        [
                            -2.47783,
                            14.29654
                        ],
                        [
                            -2.29202,
                            14.25202
                        ],
                        [
                            -2.10627,
                            14.15101
                        ],
                        [
                            -1.99344,
                            14.19946
                        ],
                        [
                            -1.97421,
                            14.48054
                        ],
                        [
                            -1.75793,
                            14.48254
                        ],
                        [
                            -1.6755,
                            14.50687
                        ],
                        [
                            -1.31542,
                            14.7331
                        ],
                        [
                            -1.08734,
                            14.79078
                        ],
                        [
                            -0.88508,
                            14.95207
                        ],
                        [
                            -0.82349,
                            15.0133
                        ],
                        [
                            -0.7035,
                            15.08137
                        ],
                        [
                            -0.45695,
                            15.08101
                        ],
                        [
                            -0.37565,
                            15.01198
                        ],
                        [
                            -0.25257,
                            15.07657
                        ],
                        [
                            -0.00836,
                            14.98526
                        ],
                        [
                            0.06126,
                            14.97795
                        ],
                        [
                            0.22935,
                            14.98967
                        ],
                        [
                            0.4018,
                            14.96986
                        ],
                        [
                            0.51096,
                            15.00093
                        ],
                        [
                            0.70217,
                            14.94619
                        ],
                        [
                            0.72318,
                            14.95941
                        ],
                        [
                            0.97535,
                            14.98081
                        ],
                        [
                            1.28796,
                            15.24117
                        ],
                        [
                            1.32601,
                            15.26521
                        ],
                        [
                            1.90956,
                            15.306
                        ],
                        [
                            2.62737,
                            15.36699
                        ],
                        [
                            3.09896,
                            15.34166
                        ],
                        [
                            3.52558,
                            15.34169
                        ],
                        [
                            3.53645,
                            15.48643
                        ],
                        [
                            3.60616,
                            15.52498
                        ],
                        [
                            3.70832,
                            15.64059
                        ],
                        [
                            3.82382,
                            15.6641
                        ],
                        [
                            3.8736,
                            15.69364
                        ],
                        [
                            3.90512,
                            15.77222
                        ],
                        [
                            3.91519,
                            15.86429
                        ],
                        [
                            3.9477,
                            15.94183
                        ],
                        [
                            4.00394,
                            15.98611
                        ],
                        [
                            3.98833,
                            16.06212
                        ],
                        [
                            4.0761,
                            16.31883
                        ],
                        [
                            4.07967,
                            16.61159
                        ],
                        [
                            4.07695,
                            16.91076
                        ],
                        [
                            4.24117,
                            16.98993
                        ],
                        [
                            4.23929,
                            17.52425
                        ],
                        [
                            4.24091,
                            18.13597
                        ],
                        [
                            4.24487,
                            18.81029
                        ],
                        [
                            4.24295,
                            19.1389
                        ],
                        [
                            3.3604,
                            18.9639
                        ],
                        [
                            3.16562,
                            19.10741
                        ],
                        [
                            3.12409,
                            19.18096
                        ],
                        [
                            3.1969,
                            19.27103
                        ],
                        [
                            3.17716,
                            19.35578
                        ],
                        [
                            3.20951,
                            19.43004
                        ],
                        [
                            3.26465,
                            19.44962
                        ],
                        [
                            3.23155,
                            19.58385
                        ],
                        [
                            3.25048,
                            19.63305
                        ],
                        [
                            3.22945,
                            19.70944
                        ],
                        [
                            3.25342,
                            19.83229
                        ],
                        [
                            3.19936,
                            19.8393
                        ],
                        [
                            3.03647,
                            19.90722
                        ],
                        [
                            2.97662,
                            19.94845
                        ],
                        [
                            2.83053,
                            19.95969
                        ],
                        [
                            2.73587,
                            19.99069
                        ],
                        [
                            2.69686,
                            20.07089
                        ],
                        [
                            2.56204,
                            20.03556
                        ],
                        [
                            2.48171,
                            20.10134
                        ],
                        [
                            2.38058,
                            20.02172
                        ],
                        [
                            2.40254,
                            20.11668
                        ],
                        [
                            2.33269,
                            20.17975
                        ],
                        [
                            2.30431,
                            20.27459
                        ],
                        [
                            2.21079,
                            20.3109
                        ],
                        [
                            2.13208,
                            20.23633
                        ],
                        [
                            2.04297,
                            20.26344
                        ],
                        [
                            2.00021,
                            20.23673
                        ],
                        [
                            1.88264,
                            20.28863
                        ],
                        [
                            1.79744,
                            20.29166
                        ],
                        [
                            1.77566,
                            20.33209
                        ],
                        [
                            1.67043,
                            20.39966
                        ],
                        [
                            1.66719,
                            20.52498
                        ],
                        [
                            1.60224,
                            20.59255
                        ],
                        [
                            1.38638,
                            20.65217
                        ],
                        [
                            1.3165,
                            20.73045
                        ],
                        [
                            1.1789,
                            20.72425
                        ],
                        [
                            1.16464,
                            20.78943
                        ],
                        [
                            1.19303,
                            20.97151
                        ],
                        [
                            1.15442,
                            21.1249
                        ],
                        [
                            -0.4043,
                            22.15752
                        ],
                        [
                            -1,
                            22.54746
                        ],
                        [
                            -1.66667,
                            22.98038
                        ],
                        [
                            -2.25,
                            23.35635
                        ],
                        [
                            -2.98222,
                            23.82438
                        ],
                        [
                            -3.83333,
                            24.36397
                        ],
                        [
                            -4.34244,
                            24.68283
                        ],
                        [
                            -4.83333,
                            24.99759
                        ],
                        [
                            -5.01,
                            25.0
                        ],
                        [
                            -6.55451,
                            24.99985
                        ],
                        [
                            -6.5637,
                            24.99603
                        ],
                        [
                            -6.4551,
                            24.034
                        ],
                        [
                            -6.45151,
                            23.9427
                        ],
                        [
                            -6.38408,
                            23.40832
                        ],
                        [
                            -6.3388,
                            23.02903
                        ],
                        [
                            -6.29274,
                            22.59888
                        ],
                        [
                            -6.22378,
                            22.01127
                        ],
                        [
                            -6.09197,
                            20.86866
                        ],
                        [
                            -6.02619,
                            20.31144
                        ],
                        [
                            -5.97349,
                            19.82778
                        ],
                        [
                            -5.91669,
                            19.34797
                        ],
                        [
                            -5.84953,
                            18.73077
                        ],
                        [
                            -5.76652,
                            18.0087
                        ],
                        [
                            -5.71048,
                            17.49486
                        ],
                        [
                            -5.65928,
                            16.9968
                        ],
                        [
                            -5.60359,
                            16.50771
                        ],
                        [
                            -5.59478,
                            16.49471
                        ],
                        [
                            -5.33006,
                            16.33105
                        ],
                        [
                            -5.39809,
                            15.99752
                        ],
                        [
                            -5.50775,
                            15.5091
                        ],
                        [
                            -5.52264,
                            15.50183
                        ],
                        [
                            -6.1502,
                            15.4943
                        ],
                        [
                            -6.71731,
                            15.49918
                        ],
                        [
                            -7.13233,
                            15.49779
                        ],
                        [
                            -7.66416,
                            15.49953
                        ],
                        [
                            -7.98394,
                            15.49636
                        ],
                        [
                            -8.75178,
                            15.49823
                        ],
                        [
                            -9.32534,
                            15.4963
                        ],
                        [
                            -9.33251,
                            15.56696
                        ],
                        [
                            -9.31148,
                            15.66688
                        ],
                        [
                            -9.33208,
                            15.69126
                        ],
                        [
                            -9.44215,
                            15.59687
                        ],
                        [
                            -9.41079,
                            15.4344
                        ],
                        [
                            -9.6964,
                            15.4274
                        ],
                        [
                            -9.79293,
                            15.37328
                        ],
                        [
                            -9.92146,
                            15.37332
                        ],
                        [
                            -9.99956,
                            15.35669
                        ],
                        [
                            -10.12971,
                            15.3667
                        ],
                        [
                            -10.31898,
                            15.43058
                        ],
                        [
                            -10.50878,
                            15.43974
                        ],
                        [
                            -10.66241,
                            15.40508
                        ],
                        [
                            -10.82806,
                            15.26967
                        ],
                        [
                            -10.91198,
                            15.11571
                        ],
                        [
                            -10.99947,
                            15.23871
                        ],
                        [
                            -11.0753,
                            15.30429
                        ],
                        [
                            -11.24005,
                            15.41082
                        ],
                        [
                            -11.32133,
                            15.49995
                        ],
                        [
                            -11.43107,
                            15.64523
                        ],
                        [
                            -11.56783,
                            15.57494
                        ],
                        [
                            -11.60072,
                            15.52941
                        ],
                        [
                            -11.71462,
                            15.52531
                        ],
                        [
                            -11.74652,
                            15.45788
                        ],
                        [
                            -11.77055,
                            15.33938
                        ],
                        [
                            -11.83759,
                            15.17447
                        ],
                        [
                            -11.83552,
                            15.03733
                        ],
                        [
                            -11.7927,
                            15.02494
                        ],
                        [
                            -11.80716,
                            14.89897
                        ],
                        [
                            -11.93651,
                            14.81344
                        ],
                        [
                            -11.97983,
                            14.76166
                        ],
                        [
                            -12.12814,
                            14.76888
                        ],
                        [
                            -12.23916,
                            14.75937
                        ],
                        [
                            -12.21263,
                            14.70322
                        ],
                        [
                            -12.14481,
                            14.64597
                        ],
                        [
                            -12.18635,
                            14.55682
                        ],
                        [
                            -12.21599,
                            14.54857
                        ],
                        [
                            -12.19173,
                            14.40282
                        ],
                        [
                            -12.12721,
                            14.3857
                        ],
                        [
                            -12.09282,
                            14.30656
                        ],
                        [
                            -12.02626,
                            14.28565
                        ],
                        [
                            -11.98743,
                            14.16674
                        ],
                        [
                            -12.01405,
                            14.00101
                        ],
                        [
                            -11.93376,
                            13.92121
                        ],
                        [
                            -11.94833,
                            13.80781
                        ],
                        [
                            -12.07213,
                            13.71962
                        ],
                        [
                            -12.03604,
                            13.62248
                        ],
                        [
                            -11.9694,
                            13.53497
                        ],
                        [
                            -11.86745,
                            13.46043
                        ],
                        [
                            -11.88738,
                            13.38704
                        ],
                        [
                            -11.79908,
                            13.311
                        ],
                        [
                            -11.74384,
                            13.40793
                        ],
                        [
                            -11.64304,
                            13.39494
                        ],
                        [
                            -11.59768,
                            13.36448
                        ],
                        [
                            -11.58758,
                            13.31043
                        ],
                        [
                            -11.52365,
                            13.25695
                        ],
                        [
                            -11.51751,
                            13.15853
                        ],
                        [
                            -11.38028,
                            12.99172
                        ],
                        [
                            -11.40844,
                            12.8472
                        ],
                        [
                            -11.38416,
                            12.82721
                        ],
                        [
                            -11.38079,
                            12.72833
                        ],
                        [
                            -11.42256,
                            12.72716
                        ],
                        [
                            -11.44245,
                            12.66286
                        ],
                        [
                            -11.40458,
                            12.58814
                        ],
                        [
                            -11.44,
                            12.56557
                        ],
                        [
                            -11.35586,
                            12.4978
                        ],
                        [
                            -11.37946,
                            12.41356
                        ],
                        [
                            -11.43865,
                            12.37839
                        ],
                        [
                            -11.43434,
                            12.29641
                        ],
                        [
                            -11.49557,
                            12.2116
                        ],
                        [
                            -11.46358,
                            12.13409
                        ],
                        [
                            -11.376,
                            12.1031
                        ],
                        [
                            -11.3587,
                            12.05795
                        ],
                        [
                            -11.26356,
                            11.99584
                        ],
                        [
                            -11.18382,
                            12.01807
                        ],
                        [
                            -11.13319,
                            12.09473
                        ],
                        [
                            -11.07291,
                            12.1368
                        ],
                        [
                            -11.04552,
                            12.21857
                        ],
                        [
                            -10.93154,
                            12.2221
                        ],
                        [
                            -10.87575,
                            12.16074
                        ],
                        [
                            -10.78969,
                            12.10729
                        ],
                        [
                            -10.79243,
                            12.03363
                        ],
                        [
                            -10.73503,
                            11.92156
                        ],
                        [
                            -10.64375,
                            11.9112
                        ],
                        [
                            -10.61728,
                            11.97165
                        ],
                        [
                            -10.52315,
                            12.04251
                        ],
                        [
                            -10.51797,
                            12.10642
                        ],
                        [
                            -10.45427,
                            12.11763
                        ],
                        [
                            -10.37196,
                            12.16824
                        ],
                        [
                            -10.34056,
                            12.21802
                        ],
                        [
                            -10.09,
                            12.17907
                        ],
                        [
                            -10.06668,
                            12.13963
                        ],
                        [
                            -9.91732,
                            12.09951
                        ],
                        [
                            -9.8817,
                            12.05693
                        ],
                        [
                            -9.81287,
                            12.0571
                        ],
                        [
                            -9.7013,
                            12.02426
                        ],
                        [
                            -9.67754,
                            12.12285
                        ],
                        [
                            -9.62932,
                            12.17287
                        ],
                        [
                            -9.54168,
                            12.19353
                        ],
                        [
                            -9.47939,
                            12.24524
                        ],
                        [
                            -9.36847,
                            12.24603
                        ],
                        [
                            -9.32106,
                            12.27279
                        ],
                        [
                            -9.29831,
                            12.35734
                        ],
                        [
                            -9.40143,
                            12.46311
                        ],
                        [
                            -9.3602,
                            12.49439
                        ],
                        [
                            -9.25329,
                            12.50179
                        ],
                        [
                            -9.15715,
                            12.48441
                        ],
                        [
                            -9.03532,
                            12.4229
                        ],
                        [
                            -8.96884,
                            12.34753
                        ],
                        [
                            -8.99267,
                            12.22474
                        ],
                        [
                            -8.92661,
                            12.19747
                        ],
                        [
                            -8.8963,
                            12.14655
                        ],
                        [
                            -8.91254,
                            12.04251
                        ],
                        [
                            -8.85628,
                            12.04123
                        ],
                        [
                            -8.80615,
                            12.00546
                        ],
                        [
                            -8.79532,
                            11.9219
                        ],
                        [
                            -8.85345,
                            11.6292
                        ],
                        [
                            -8.69025,
                            11.5882
                        ],
                        [
                            -8.65323,
                            11.49826
                        ],
                        [
                            -8.58242,
                            11.44436
                        ],
                        [
                            -8.53341,
                            11.4768
                        ],
                        [
                            -8.50001,
                            11.39817
                        ],
                        [
                            -8.39658,
                            11.38183
                        ],
                        [
                            -8.41985,
                            11.27037
                        ],
                        [
                            -8.48039,
                            11.28808
                        ],
                        [
                            -8.49715,
                            11.21655
                        ],
                        [
                            -8.55507,
                            11.21142
                        ],
                        [
                            -8.5649,
                            11.15482
                        ],
                        [
                            -8.61049,
                            11.12764
                        ],
                        [
                            -8.68037,
                            10.96488
                        ],
                        [
                            -8.58966,
                            10.9509
                        ],
                        [
                            -8.51479,
                            10.97301
                        ],
                        [
                            -8.48261,
                            11.06398
                        ],
                        [
                            -8.34779,
                            11.06767
                        ],
                        [
                            -8.28743,
                            10.99511
                        ],
                        [
                            -8.2759,
                            10.85357
                        ],
                        [
                            -8.32648,
                            10.77668
                        ],
                        [
                            -8.29629,
                            10.75166
                        ],
                        [
                            -8.30125,
                            10.63703
                        ],
                        [
                            -8.27698,
                            10.52374
                        ],
                        [
                            -8.22434,
                            10.40978
                        ],
                        [
                            -8.11834,
                            10.4179
                        ],
                        [
                            -8.09115,
                            10.3582
                        ],
                        [
                            -7.97161,
                            10.31675
                        ],
                        [
                            -7.94757,
                            10.24164
                        ],
                        [
                            -7.97855,
                            10.17511
                        ],
                        [
                            -7.92757,
                            10.17102
                        ],
                        [
                            -7.85622,
                            10.20572
                        ],
                        [
                            -7.76683,
                            10.29213
                        ],
                        [
                            -7.73497,
                            10.34647
                        ],
                        [
                            -7.72502,
                            10.42657
                        ],
                        [
                            -7.64815,
                            10.48358
                        ],
                        [
                            -7.55168,
                            10.44511
                        ],
                        [
                            -7.50997,
                            10.47839
                        ],
                        [
                            -7.44874,
                            10.46094
                        ],
                        [
                            -7.42769,
                            10.39289
                        ],
                        [
                            -7.36579,
                            10.36086
                        ],
                        [
                            -7.37903,
                            10.27624
                        ],
                        [
                            -7.29759,
                            10.28712
                        ],
                        [
                            -7.08918,
                            10.22361
                        ],
                        [
                            -7.0509,
                            10.16605
                        ],
                        [
                            -6.96569,
                            10.22081
                        ],
                        [
                            -6.99638,
                            10.30428
                        ],
                        [
                            -6.95047,
                            10.36698
                        ],
                        [
                            -6.85696,
                            10.36295
                        ],
                        [
                            -6.764,
                            10.39035
                        ],
                        [
                            -6.67201,
                            10.36654
                        ],
                        [
                            -6.63751,
                            10.4154
                        ],
                        [
                            -6.68339,
                            10.49088
                        ],
                        [
                            -6.66743,
                            10.62941
                        ],
                        [
                            -6.64253,
                            10.67009
                        ],
                        [
                            -6.53965,
                            10.58727
                        ],
                        [
                            -6.4631,
                            10.56582
                        ],
                        [
                            -6.40212,
                            10.59849
                        ],
                        [
                            -6.41534,
                            10.70034
                        ],
                        [
                            -6.34784,
                            10.69642
                        ],
                        [
                            -6.25677,
                            10.73582
                        ],
                        [
                            -6.2117,
                            10.57383
                        ],
                        [
                            -6.19003,
                            10.3893
                        ],
                        [
                            -6.17007,
                            10.36348
                        ],
                        [
                            -6.23631,
                            10.29656
                        ],
                        [
                            -6.1908,
                            10.23576
                        ],
                        [
                            -6.11987,
                            10.20506
                        ],
                        [
                            -6.01163,
                            10.20458
                        ],
                        [
                            -5.97297,
                            10.27695
                        ],
                        [
                            -5.90936,
                            10.28181
                        ],
                        [
                            -5.88449,
                            10.37205
                        ],
                        [
                            -5.77974,
                            10.43899
                        ],
                        [
                            -5.67622,
                            10.46184
                        ],
                        [
                            -5.56816,
                            10.46413
                        ],
                        [
                            -5.51892,
                            10.43327
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "MLT",
                "Country": "Malta",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    1.7731e-08,
                    3.4221e-08,
                    4.9964e-08,
                    6.5068e-08,
                    7.9613e-08,
                    9.368e-08,
                    1.0732e-07,
                    1.2059e-07,
                    1.3352e-07,
                    1.4611e-07,
                    1.5845e-07,
                    1.7057e-07,
                    1.8248e-07,
                    1.942e-07,
                    2.0576e-07,
                    2.1717e-07,
                    2.2843e-07,
                    2.3955e-07,
                    2.5054e-07,
                    2.6142e-07,
                    2.7219e-07,
                    2.8287e-07,
                    2.9348e-07,
                    3.0405e-07,
                    3.1459e-07,
                    3.251e-07,
                    3.3562e-07,
                    3.4613e-07,
                    3.5664e-07,
                    3.6712e-07,
                    3.7754e-07,
                    3.8795e-07,
                    3.9837e-07,
                    4.088e-07,
                    4.1925e-07,
                    4.2976e-07,
                    4.4032e-07,
                    4.5094e-07,
                    4.616e-07,
                    4.721e-07,
                    4.8269e-07,
                    4.9341e-07,
                    5.0429e-07,
                    5.1539e-07,
                    5.2676e-07,
                    5.3852e-07,
                    5.5071e-07,
                    5.6338e-07,
                    5.7654e-07,
                    5.9027e-07,
                    6.0448e-07,
                    6.1909e-07,
                    6.3401e-07,
                    6.4918e-07,
                    6.6456e-07,
                    6.8012e-07,
                    6.9581e-07,
                    7.115e-07,
                    7.2697e-07,
                    7.4166e-07,
                    7.556e-07,
                    7.691e-07,
                    7.8221e-07,
                    7.951e-07,
                    8.0773e-07,
                    8.2008e-07,
                    8.3219e-07,
                    8.4402e-07,
                    8.5557e-07,
                    8.6684e-07,
                    8.7789e-07,
                    8.887e-07,
                    8.9929e-07,
                    9.0968e-07,
                    9.1988e-07,
                    9.299e-07,
                    9.3976e-07,
                    9.4951e-07,
                    9.5919e-07,
                    9.6856e-07,
                    9.7758e-07,
                    9.8645e-07,
                    9.9522e-07,
                    1.0038e-06,
                    1.0122e-06,
                    1.0209e-06,
                    1.03e-06,
                    1.0395e-06,
                    1.0493e-06,
                    1.0592e-06,
                    1.0709e-06,
                    1.0845e-06,
                    1.1003e-06,
                    1.1186e-06,
                    1.1401e-06,
                    1.1648e-06,
                    1.1929e-06,
                    1.2244e-06,
                    1.259e-06,
                    1.4087e-06,
                    1.5646e-06,
                    1.7148e-06,
                    1.8609e-06,
                    2.0431e-06,
                    2.2416e-06,
                    2.4219e-06,
                    2.6084e-06,
                    2.804e-06,
                    3.027e-06,
                    3.2293e-06,
                    3.4142e-06,
                    3.6081e-06,
                    3.8262e-06,
                    4.0836e-06,
                    4.3246e-06,
                    4.5516e-06,
                    4.83e-06,
                    5.1659e-06,
                    5.5124e-06,
                    5.8535e-06,
                    6.1979e-06,
                    6.6182e-06,
                    7.0268e-06,
                    7.4027e-06,
                    7.7449e-06,
                    8.1604e-06,
                    8.5952e-06,
                    9.0816e-06,
                    9.5389e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_3GHG": 0.01,
                "Fossil_3GHG_timeseries": [
                    3.6536e-09,
                    7.3539e-09,
                    1.11e-08,
                    1.4891e-08,
                    1.8726e-08,
                    2.2603e-08,
                    2.6522e-08,
                    3.0482e-08,
                    3.448e-08,
                    3.8515e-08,
                    4.2601e-08,
                    4.6732e-08,
                    5.0906e-08,
                    5.5122e-08,
                    5.9381e-08,
                    6.3681e-08,
                    6.8001e-08,
                    7.2343e-08,
                    7.6704e-08,
                    8.1086e-08,
                    8.5465e-08,
                    8.9831e-08,
                    9.4188e-08,
                    9.8542e-08,
                    1.0289e-07,
                    1.0725e-07,
                    1.1162e-07,
                    1.1602e-07,
                    1.2042e-07,
                    1.2484e-07,
                    1.2924e-07,
                    1.3368e-07,
                    1.3816e-07,
                    1.4267e-07,
                    1.4721e-07,
                    1.5179e-07,
                    1.564e-07,
                    1.6106e-07,
                    1.6575e-07,
                    1.705e-07,
                    1.7529e-07,
                    1.8015e-07,
                    1.8508e-07,
                    1.9007e-07,
                    1.9513e-07,
                    2.0026e-07,
                    2.0545e-07,
                    2.1069e-07,
                    2.16e-07,
                    2.2136e-07,
                    2.2677e-07,
                    2.3223e-07,
                    2.3773e-07,
                    2.4329e-07,
                    2.489e-07,
                    2.5456e-07,
                    2.6029e-07,
                    2.6609e-07,
                    2.7196e-07,
                    2.7789e-07,
                    2.8391e-07,
                    2.8984e-07,
                    2.9567e-07,
                    3.0156e-07,
                    3.0748e-07,
                    3.1343e-07,
                    3.1943e-07,
                    3.2545e-07,
                    3.3148e-07,
                    3.3752e-07,
                    3.436e-07,
                    3.497e-07,
                    3.5581e-07,
                    3.6193e-07,
                    3.6808e-07,
                    3.7423e-07,
                    3.8041e-07,
                    3.8661e-07,
                    3.9288e-07,
                    3.9921e-07,
                    4.0559e-07,
                    4.1217e-07,
                    4.1895e-07,
                    4.2578e-07,
                    4.3271e-07,
                    4.3972e-07,
                    4.468e-07,
                    4.5396e-07,
                    4.6123e-07,
                    4.6859e-07,
                    4.7696e-07,
                    4.8638e-07,
                    4.9688e-07,
                    5.0849e-07,
                    5.2193e-07,
                    5.3722e-07,
                    5.5442e-07,
                    5.736e-07,
                    5.9469e-07,
                    7.304e-07,
                    8.7263e-07,
                    1.0096e-06,
                    1.1429e-06,
                    1.3127e-06,
                    1.4992e-06,
                    1.6671e-06,
                    1.8432e-06,
                    2.0292e-06,
                    2.2436e-06,
                    2.4374e-06,
                    2.6097e-06,
                    2.7994e-06,
                    3.0263e-06,
                    3.294e-06,
                    3.5496e-06,
                    3.7782e-06,
                    4.0554e-06,
                    4.386e-06,
                    4.7232e-06,
                    5.0615e-06,
                    5.398e-06,
                    5.8145e-06,
                    6.2155e-06,
                    6.5857e-06,
                    6.9185e-06,
                    7.2942e-06,
                    7.6871e-06,
                    8.1379e-06,
                    8.5734e-06,
                    9.0616e-06,
                    9.6042e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [
                    1.4077e-08,
                    2.6867e-08,
                    3.8864e-08,
                    5.0177e-08,
                    6.0887e-08,
                    7.1077e-08,
                    8.08e-08,
                    9.0109e-08,
                    9.9036e-08,
                    1.076e-07,
                    1.1585e-07,
                    1.2384e-07,
                    1.3157e-07,
                    1.3908e-07,
                    1.4638e-07,
                    1.5349e-07,
                    1.6043e-07,
                    1.6721e-07,
                    1.7384e-07,
                    1.8033e-07,
                    1.8673e-07,
                    1.9304e-07,
                    1.993e-07,
                    2.0551e-07,
                    2.1169e-07,
                    2.1785e-07,
                    2.2399e-07,
                    2.3012e-07,
                    2.3621e-07,
                    2.4228e-07,
                    2.483e-07,
                    2.5427e-07,
                    2.6022e-07,
                    2.6614e-07,
                    2.7204e-07,
                    2.7797e-07,
                    2.8392e-07,
                    2.8988e-07,
                    2.9586e-07,
                    3.016e-07,
                    3.074e-07,
                    3.1326e-07,
                    3.1921e-07,
                    3.2532e-07,
                    3.3163e-07,
                    3.3826e-07,
                    3.4526e-07,
                    3.5269e-07,
                    3.6054e-07,
                    3.6891e-07,
                    3.7771e-07,
                    3.8687e-07,
                    3.9628e-07,
                    4.059e-07,
                    4.1567e-07,
                    4.2556e-07,
                    4.3552e-07,
                    4.4541e-07,
                    4.5501e-07,
                    4.6377e-07,
                    4.7168e-07,
                    4.7926e-07,
                    4.8654e-07,
                    4.9354e-07,
                    5.0025e-07,
                    5.0665e-07,
                    5.1276e-07,
                    5.1857e-07,
                    5.2409e-07,
                    5.2932e-07,
                    5.3429e-07,
                    5.39e-07,
                    5.4348e-07,
                    5.4774e-07,
                    5.518e-07,
                    5.5567e-07,
                    5.5935e-07,
                    5.629e-07,
                    5.6631e-07,
                    5.6934e-07,
                    5.7199e-07,
                    5.7428e-07,
                    5.7627e-07,
                    5.78e-07,
                    5.7948e-07,
                    5.8121e-07,
                    5.832e-07,
                    5.855e-07,
                    5.8807e-07,
                    5.9063e-07,
                    5.9389e-07,
                    5.981e-07,
                    6.0344e-07,
                    6.1011e-07,
                    6.1815e-07,
                    6.2762e-07,
                    6.3848e-07,
                    6.5078e-07,
                    6.6431e-07,
                    6.7834e-07,
                    6.9198e-07,
                    7.0517e-07,
                    7.18e-07,
                    7.3036e-07,
                    7.4235e-07,
                    7.5472e-07,
                    7.652e-07,
                    7.7477e-07,
                    7.8342e-07,
                    7.9193e-07,
                    8.0443e-07,
                    8.087e-07,
                    7.9981e-07,
                    7.8961e-07,
                    7.7495e-07,
                    7.7332e-07,
                    7.7456e-07,
                    7.7991e-07,
                    7.8921e-07,
                    7.9201e-07,
                    7.9994e-07,
                    8.037e-07,
                    8.1129e-07,
                    8.1698e-07,
                    8.264e-07,
                    8.6622e-07,
                    9.0804e-07,
                    9.4367e-07,
                    9.6549e-07,
                    9.7723e-07,
                    9.7401e-07,
                    9.8454e-07,
                    1.0257e-06,
                    1.0878e-06,
                    1.1628e-06,
                    1.2326e-06,
                    1.3066e-06,
                    1.3822e-06,
                    1.4608e-06,
                    1.5517e-06,
                    1.6427e-06,
                    1.7558e-06,
                    1.8641e-06,
                    1.9542e-06,
                    2.0206e-06,
                    2.062e-06,
                    2.0993e-06,
                    2.1196e-06,
                    2.1644e-06,
                    2.226e-06,
                    2.3105e-06,
                    2.3868e-06,
                    2.4279e-06,
                    2.4291e-06,
                    2.4294e-06,
                    2.4227e-06,
                    2.4051e-06,
                    2.4046e-06,
                    2.3955e-06,
                    2.3711e-06,
                    2.3246e-06,
                    2.2657e-06,
                    2.1929e-06,
                    2.1223e-06,
                    2.0672e-06,
                    2.0086e-06,
                    1.9366e-06,
                    1.8855e-06,
                    1.8139e-06,
                    1.7514e-06,
                    1.6901e-06,
                    1.6289e-06
                ],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    9.097e-09,
                    1.6879e-08,
                    2.3842e-08,
                    3.0096e-08,
                    3.5722e-08,
                    4.0804e-08,
                    4.5397e-08,
                    4.9555e-08,
                    5.3312e-08,
                    5.6683e-08,
                    5.9708e-08,
                    6.2419e-08,
                    6.484e-08,
                    6.699e-08,
                    6.8888e-08,
                    7.056e-08,
                    7.2012e-08,
                    7.326e-08,
                    7.4322e-08,
                    7.5202e-08,
                    7.5928e-08,
                    7.65e-08,
                    7.6929e-08,
                    7.722e-08,
                    7.738e-08,
                    7.7418e-08,
                    7.7335e-08,
                    7.7143e-08,
                    7.6846e-08,
                    7.645e-08,
                    7.5966e-08,
                    7.5411e-08,
                    7.4795e-08,
                    7.4124e-08,
                    7.3403e-08,
                    7.2677e-08,
                    7.1946e-08,
                    7.1203e-08,
                    7.0438e-08,
                    6.9559e-08,
                    6.8563e-08,
                    6.748e-08,
                    6.6341e-08,
                    6.5219e-08,
                    6.4191e-08,
                    6.336e-08,
                    6.2821e-08,
                    6.2634e-08,
                    6.2821e-08,
                    6.3487e-08,
                    6.457e-08,
                    6.6011e-08,
                    6.7733e-08,
                    6.9679e-08,
                    7.1814e-08,
                    7.4101e-08,
                    7.6483e-08,
                    7.8815e-08,
                    8.0861e-08,
                    8.2055e-08,
                    8.2324e-08,
                    8.2181e-08,
                    8.1659e-08,
                    8.0773e-08,
                    7.9514e-08,
                    7.7869e-08,
                    7.5845e-08,
                    7.3436e-08,
                    7.0648e-08,
                    6.748e-08,
                    6.396e-08,
                    6.0082e-08,
                    5.5875e-08,
                    5.1331e-08,
                    4.648e-08,
                    4.1322e-08,
                    3.5871e-08,
                    3.0173e-08,
                    2.4222e-08,
                    1.7781e-08,
                    1.0885e-08,
                    3.5585e-09,
                    -0.000000004147,
                    -0.000000012193,
                    -0.000000020576,
                    -0.000000029254,
                    -0.000000038236,
                    -0.000000047465,
                    -0.000000056974,
                    -0.000000067045,
                    -0.000000077687,
                    -0.000000088874,
                    -0.00000010059,
                    -0.00000011279,
                    -0.00000012548,
                    -0.00000013861,
                    -0.00000015221,
                    -0.00000016615,
                    -0.00000018049,
                    -0.000000085222,
                    1.4069e-08,
                    1.0584e-07,
                    1.9185e-07,
                    3.116e-07,
                    4.4542e-07,
                    5.5986e-07,
                    6.7907e-07,
                    8.0572e-07,
                    9.5802e-07,
                    1.089e-06,
                    1.1948e-06,
                    1.3124e-06,
                    1.4612e-06,
                    1.6442e-06,
                    1.814e-06,
                    1.9565e-06,
                    2.1468e-06,
                    2.3906e-06,
                    2.6424e-06,
                    2.9003e-06,
                    3.1578e-06,
                    3.4972e-06,
                    3.8228e-06,
                    4.1172e-06,
                    4.3771e-06,
                    4.6918e-06,
                    5.0204e-06,
                    5.4079e-06,
                    5.7791e-06,
                    6.2035e-06,
                    6.6821e-06,
                    7.2366e-06,
                    7.6492e-06,
                    8.2275e-06,
                    8.7322e-06,
                    9.3662e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_CO2": 0.01,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.1055e-07,
                    2.2605e-07,
                    3.3495e-07,
                    4.389e-07,
                    5.775e-07,
                    7.3095e-07,
                    8.646e-07,
                    1.0049e-06,
                    1.1533e-06,
                    1.3282e-06,
                    1.4817e-06,
                    1.6137e-06,
                    1.7622e-06,
                    1.947e-06,
                    2.1714e-06,
                    2.3843e-06,
                    2.5707e-06,
                    2.805e-06,
                    3.0921e-06,
                    3.3858e-06,
                    3.6844e-06,
                    3.9814e-06,
                    4.3593e-06,
                    4.7223e-06,
                    5.0572e-06,
                    5.3576e-06,
                    5.7007e-06,
                    6.0621e-06,
                    6.4829e-06,
                    6.8904e-06,
                    7.3507e-06,
                    7.8655e-06,
                    8.4563e-06,
                    8.9051e-06,
                    9.5188e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CO2": -0,
                "Land_CO2_timeseries": [
                    9.097e-09,
                    1.6879e-08,
                    2.3842e-08,
                    3.0096e-08,
                    3.5722e-08,
                    4.0804e-08,
                    4.5397e-08,
                    4.9555e-08,
                    5.3312e-08,
                    5.6683e-08,
                    5.9708e-08,
                    6.2419e-08,
                    6.484e-08,
                    6.699e-08,
                    6.8888e-08,
                    7.056e-08,
                    7.2012e-08,
                    7.326e-08,
                    7.4322e-08,
                    7.5202e-08,
                    7.5928e-08,
                    7.65e-08,
                    7.6929e-08,
                    7.722e-08,
                    7.738e-08,
                    7.7418e-08,
                    7.7335e-08,
                    7.7143e-08,
                    7.6846e-08,
                    7.645e-08,
                    7.5966e-08,
                    7.5411e-08,
                    7.4795e-08,
                    7.4124e-08,
                    7.3403e-08,
                    7.2677e-08,
                    7.1946e-08,
                    7.1203e-08,
                    7.0438e-08,
                    6.9559e-08,
                    6.8563e-08,
                    6.748e-08,
                    6.6341e-08,
                    6.5219e-08,
                    6.4191e-08,
                    6.336e-08,
                    6.2821e-08,
                    6.2634e-08,
                    6.2821e-08,
                    6.3487e-08,
                    6.457e-08,
                    6.6011e-08,
                    6.7733e-08,
                    6.9679e-08,
                    7.1814e-08,
                    7.4101e-08,
                    7.6483e-08,
                    7.8815e-08,
                    8.0861e-08,
                    8.2055e-08,
                    8.2324e-08,
                    8.2181e-08,
                    8.1659e-08,
                    8.0773e-08,
                    7.9514e-08,
                    7.7869e-08,
                    7.5845e-08,
                    7.3436e-08,
                    7.0648e-08,
                    6.748e-08,
                    6.396e-08,
                    6.0082e-08,
                    5.5875e-08,
                    5.1331e-08,
                    4.648e-08,
                    4.1322e-08,
                    3.5871e-08,
                    3.0173e-08,
                    2.4222e-08,
                    1.7781e-08,
                    1.0885e-08,
                    3.5585e-09,
                    -0.000000004147,
                    -0.000000012193,
                    -0.000000020576,
                    -0.000000029254,
                    -0.000000038236,
                    -0.000000047465,
                    -0.000000056974,
                    -0.000000067045,
                    -0.000000077687,
                    -0.000000088874,
                    -0.00000010059,
                    -0.00000011279,
                    -0.00000012548,
                    -0.00000013861,
                    -0.00000015221,
                    -0.00000016615,
                    -0.00000018049,
                    -0.00000019577,
                    -0.00000021198,
                    -0.00000022911,
                    -0.00000024705,
                    -0.0000002659,
                    -0.00000028553,
                    -0.00000030474,
                    -0.00000032578,
                    -0.00000034763,
                    -0.00000037023,
                    -0.00000039272,
                    -0.00000041893,
                    -0.00000044975,
                    -0.00000048578,
                    -0.00000052715,
                    -0.00000057025,
                    -0.00000061416,
                    -0.00000065816,
                    -0.00000070152,
                    -0.0000007434,
                    -0.00000078418,
                    -0.00000082366,
                    -0.00000086205,
                    -0.00000089949,
                    -0.00000094009,
                    -0.00000098044,
                    -0.0000010089,
                    -0.0000010417,
                    -0.000001075,
                    -0.0000011113,
                    -0.0000011473,
                    -0.0000011835,
                    -0.0000012196,
                    -0.0000012558,
                    -0.0000012913,
                    -0.0000013262,
                    -0.0000013605,
                    -0.0000013942,
                    -0.0000014273,
                    -0.0000014598,
                    -0.0000014918,
                    -0.0000015232,
                    -0.000001554,
                    -0.0000015844,
                    -0.0000016226,
                    -0.000001662,
                    -0.0000017064,
                    -0.0000017566,
                    -0.0000018089,
                    -0.0000018617,
                    -0.0000019026,
                    -0.0000019221,
                    -0.0000019378,
                    -0.0000019666,
                    -0.0000020037,
                    -0.0000020423,
                    -0.0000020797,
                    -0.0000021171,
                    -0.0000021345,
                    -0.0000021301,
                    -0.0000021298,
                    -0.0000021293,
                    -0.0000021277,
                    -0.0000021423,
                    -0.0000021596,
                    -0.0000021768,
                    -0.0000021954,
                    -0.0000022142,
                    -0.000002233,
                    -0.0000022548,
                    -0.0000022773,
                    -0.0000022995,
                    -0.0000023215
                ],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [
                    7.156e-09,
                    1.4362e-08,
                    2.1618e-08,
                    2.8923e-08,
                    3.6276e-08,
                    4.3677e-08,
                    5.1125e-08,
                    5.8619e-08,
                    6.616e-08,
                    7.3745e-08,
                    8.1417e-08,
                    8.9168e-08,
                    9.6999e-08,
                    1.0491e-07,
                    1.1289e-07,
                    1.2096e-07,
                    1.2907e-07,
                    1.3725e-07,
                    1.4548e-07,
                    1.5377e-07,
                    1.6208e-07,
                    1.7041e-07,
                    1.7875e-07,
                    1.871e-07,
                    1.9546e-07,
                    2.0384e-07,
                    2.1225e-07,
                    2.2069e-07,
                    2.2917e-07,
                    2.3768e-07,
                    2.462e-07,
                    2.5476e-07,
                    2.6337e-07,
                    2.7203e-07,
                    2.8073e-07,
                    2.8949e-07,
                    2.9829e-07,
                    3.0714e-07,
                    3.1604e-07,
                    3.25e-07,
                    3.34e-07,
                    3.4308e-07,
                    3.5223e-07,
                    3.6146e-07,
                    3.7075e-07,
                    3.8012e-07,
                    3.8956e-07,
                    3.9905e-07,
                    4.0861e-07,
                    4.1822e-07,
                    4.2789e-07,
                    4.376e-07,
                    4.4735e-07,
                    4.5715e-07,
                    4.67e-07,
                    4.7689e-07,
                    4.8685e-07,
                    4.9687e-07,
                    5.0696e-07,
                    5.1711e-07,
                    5.2741e-07,
                    5.3766e-07,
                    5.4787e-07,
                    5.5819e-07,
                    5.686e-07,
                    5.7909e-07,
                    5.8969e-07,
                    6.0035e-07,
                    6.1108e-07,
                    6.2188e-07,
                    6.3278e-07,
                    6.4374e-07,
                    6.5477e-07,
                    6.6586e-07,
                    6.7703e-07,
                    6.8826e-07,
                    6.9956e-07,
                    7.1094e-07,
                    7.2244e-07,
                    7.3408e-07,
                    7.4578e-07,
                    7.577e-07,
                    7.6985e-07,
                    7.8207e-07,
                    7.944e-07,
                    8.0732e-07,
                    8.2081e-07,
                    8.3489e-07,
                    8.496e-07,
                    8.6491e-07,
                    8.8235e-07,
                    9.0193e-07,
                    9.2371e-07,
                    9.477e-07,
                    9.7463e-07,
                    1.0046e-06,
                    1.0375e-06,
                    1.0736e-06,
                    1.1128e-06,
                    1.1574e-06,
                    1.2039e-06,
                    1.2521e-06,
                    1.3019e-06,
                    1.3539e-06,
                    1.4079e-06,
                    1.4631e-06,
                    1.5196e-06,
                    1.5775e-06,
                    1.637e-06,
                    1.697e-06,
                    1.7642e-06,
                    1.8285e-06,
                    1.8857e-06,
                    1.9478e-06,
                    2.007e-06,
                    2.0789e-06,
                    2.1538e-06,
                    2.2323e-06,
                    2.3126e-06,
                    2.3806e-06,
                    2.4521e-06,
                    2.517e-06,
                    2.585e-06,
                    2.6522e-06,
                    2.7201e-06,
                    2.805e-06,
                    2.8942e-06,
                    2.9759e-06,
                    3.0449e-06,
                    3.1026e-06,
                    3.147e-06,
                    3.2038e-06,
                    3.2886e-06,
                    3.3916e-06,
                    3.5036e-06,
                    3.6132e-06,
                    3.7247e-06,
                    3.8359e-06,
                    3.9484e-06,
                    4.0728e-06,
                    4.201e-06,
                    4.3558e-06,
                    4.5119e-06,
                    4.6674e-06,
                    4.8098e-06,
                    4.9333e-06,
                    5.064e-06,
                    5.1897e-06,
                    5.3472e-06,
                    5.516e-06,
                    5.6939e-06,
                    5.8653e-06,
                    6.0229e-06,
                    6.1526e-06,
                    6.3084e-06,
                    6.4827e-06,
                    6.6683e-06,
                    6.8662e-06,
                    7.0725e-06,
                    7.289e-06,
                    7.4981e-06,
                    7.5192e-06,
                    7.5317e-06,
                    7.5493e-06,
                    7.5943e-06,
                    7.6374e-06,
                    7.6649e-06,
                    7.7152e-06,
                    7.754e-06,
                    7.7971e-06,
                    7.8375e-06,
                    7.8757e-06
                ],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [
                    2.7646e-09,
                    5.5643e-09,
                    8.3986e-09,
                    1.1267e-08,
                    1.4168e-08,
                    1.7102e-08,
                    2.0068e-08,
                    2.3066e-08,
                    2.6094e-08,
                    2.9152e-08,
                    3.2255e-08,
                    3.5396e-08,
                    3.8573e-08,
                    4.1787e-08,
                    4.5036e-08,
                    4.832e-08,
                    5.1619e-08,
                    5.4933e-08,
                    5.8259e-08,
                    6.1599e-08,
                    6.4926e-08,
                    6.822e-08,
                    7.148e-08,
                    7.4707e-08,
                    7.7902e-08,
                    8.1065e-08,
                    8.4218e-08,
                    8.7362e-08,
                    9.0495e-08,
                    9.362e-08,
                    9.6724e-08,
                    9.9851e-08,
                    1.03e-07,
                    1.0618e-07,
                    1.0938e-07,
                    1.1261e-07,
                    1.1587e-07,
                    1.1915e-07,
                    1.2246e-07,
                    1.258e-07,
                    1.2917e-07,
                    1.3259e-07,
                    1.3605e-07,
                    1.3957e-07,
                    1.4314e-07,
                    1.4675e-07,
                    1.5041e-07,
                    1.541e-07,
                    1.5783e-07,
                    1.616e-07,
                    1.6539e-07,
                    1.6921e-07,
                    1.7304e-07,
                    1.7689e-07,
                    1.8077e-07,
                    1.8467e-07,
                    1.8861e-07,
                    1.9259e-07,
                    1.9661e-07,
                    2.0067e-07,
                    2.048e-07,
                    2.0881e-07,
                    2.127e-07,
                    2.1664e-07,
                    2.2058e-07,
                    2.2453e-07,
                    2.2852e-07,
                    2.325e-07,
                    2.3646e-07,
                    2.4043e-07,
                    2.4441e-07,
                    2.4837e-07,
                    2.5232e-07,
                    2.5626e-07,
                    2.6018e-07,
                    2.641e-07,
                    2.68e-07,
                    2.719e-07,
                    2.7585e-07,
                    2.7984e-07,
                    2.8386e-07,
                    2.8807e-07,
                    2.9246e-07,
                    2.9688e-07,
                    3.0137e-07,
                    3.0593e-07,
                    3.1053e-07,
                    3.1519e-07,
                    3.1994e-07,
                    3.2475e-07,
                    3.3054e-07,
                    3.3732e-07,
                    3.4511e-07,
                    3.5392e-07,
                    3.6445e-07,
                    3.7676e-07,
                    3.9086e-07,
                    4.0687e-07,
                    4.2469e-07,
                    4.4652e-07,
                    4.6985e-07,
                    4.9449e-07,
                    5.2029e-07,
                    5.4788e-07,
                    5.7722e-07,
                    6.0772e-07,
                    6.3967e-07,
                    6.7315e-07,
                    7.0856e-07,
                    7.4472e-07,
                    7.8081e-07,
                    8.1749e-07,
                    8.5506e-07,
                    8.9349e-07,
                    9.3134e-07,
                    9.6836e-07,
                    1.0059e-06,
                    1.0439e-06,
                    1.0818e-06,
                    1.115e-06,
                    1.1479e-06,
                    1.1795e-06,
                    1.2104e-06,
                    1.2389e-06,
                    1.2649e-06,
                    1.2905e-06,
                    1.3151e-06,
                    1.3379e-06,
                    1.3585e-06,
                    1.3784e-06,
                    1.398e-06,
                    1.4166e-06,
                    1.434e-06,
                    1.4505e-06,
                    1.4643e-06,
                    1.4817e-06,
                    1.4978e-06,
                    1.5127e-06,
                    1.5266e-06,
                    1.5413e-06,
                    1.5604e-06,
                    1.5852e-06,
                    1.6165e-06,
                    1.6572e-06,
                    1.7076e-06,
                    1.7581e-06,
                    1.8144e-06,
                    1.8811e-06,
                    1.9535e-06,
                    2.0329e-06,
                    2.1201e-06,
                    2.2122e-06,
                    2.3128e-06,
                    2.4163e-06,
                    2.546e-06,
                    2.7027e-06,
                    2.8811e-06,
                    3.0749e-06,
                    3.3058e-06,
                    3.5581e-06,
                    3.8241e-06,
                    3.9158e-06,
                    3.9967e-06,
                    4.0778e-06,
                    4.1709e-06,
                    4.2639e-06,
                    4.3542e-06,
                    4.4463e-06,
                    4.5441e-06,
                    4.6368e-06,
                    4.7256e-06,
                    4.8125e-06
                ],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [
                    4.3914e-09,
                    8.7979e-09,
                    1.3219e-08,
                    1.7656e-08,
                    2.2108e-08,
                    2.6575e-08,
                    3.1057e-08,
                    3.5554e-08,
                    4.0066e-08,
                    4.4593e-08,
                    4.9162e-08,
                    5.3773e-08,
                    5.8426e-08,
                    6.312e-08,
                    6.7857e-08,
                    7.2635e-08,
                    7.7455e-08,
                    8.2317e-08,
                    8.7221e-08,
                    9.2166e-08,
                    9.7157e-08,
                    1.0219e-07,
                    1.0727e-07,
                    1.1239e-07,
                    1.1756e-07,
                    1.2277e-07,
                    1.2803e-07,
                    1.3333e-07,
                    1.3867e-07,
                    1.4406e-07,
                    1.4948e-07,
                    1.5491e-07,
                    1.6037e-07,
                    1.6585e-07,
                    1.7135e-07,
                    1.7687e-07,
                    1.8242e-07,
                    1.8799e-07,
                    1.9358e-07,
                    1.9919e-07,
                    2.0483e-07,
                    2.1049e-07,
                    2.1618e-07,
                    2.2188e-07,
                    2.2762e-07,
                    2.3337e-07,
                    2.3915e-07,
                    2.4495e-07,
                    2.5077e-07,
                    2.5662e-07,
                    2.6249e-07,
                    2.6839e-07,
                    2.7431e-07,
                    2.8026e-07,
                    2.8623e-07,
                    2.9222e-07,
                    2.9824e-07,
                    3.0428e-07,
                    3.1035e-07,
                    3.1644e-07,
                    3.2261e-07,
                    3.2885e-07,
                    3.3516e-07,
                    3.4155e-07,
                    3.4802e-07,
                    3.5456e-07,
                    3.6117e-07,
                    3.6786e-07,
                    3.7462e-07,
                    3.8146e-07,
                    3.8837e-07,
                    3.9537e-07,
                    4.0245e-07,
                    4.096e-07,
                    4.1684e-07,
                    4.2416e-07,
                    4.3156e-07,
                    4.3904e-07,
                    4.4659e-07,
                    4.5423e-07,
                    4.6191e-07,
                    4.6963e-07,
                    4.7739e-07,
                    4.8519e-07,
                    4.9303e-07,
                    5.0139e-07,
                    5.1028e-07,
                    5.197e-07,
                    5.2966e-07,
                    5.4016e-07,
                    5.5181e-07,
                    5.6461e-07,
                    5.786e-07,
                    5.9378e-07,
                    6.1017e-07,
                    6.2779e-07,
                    6.4665e-07,
                    6.6677e-07,
                    6.8815e-07,
                    7.1083e-07,
                    7.34e-07,
                    7.576e-07,
                    7.816e-07,
                    8.0598e-07,
                    8.3073e-07,
                    8.5539e-07,
                    8.7992e-07,
                    9.043e-07,
                    9.2844e-07,
                    9.5226e-07,
                    9.8343e-07,
                    1.011e-06,
                    1.0307e-06,
                    1.0543e-06,
                    1.0756e-06,
                    1.1106e-06,
                    1.1479e-06,
                    1.1884e-06,
                    1.2308e-06,
                    1.2657e-06,
                    1.3042e-06,
                    1.3375e-06,
                    1.3746e-06,
                    1.4133e-06,
                    1.4552e-06,
                    1.5145e-06,
                    1.579e-06,
                    1.638e-06,
                    1.6864e-06,
                    1.7242e-06,
                    1.749e-06,
                    1.7873e-06,
                    1.8546e-06,
                    1.9411e-06,
                    2.0393e-06,
                    2.1315e-06,
                    2.2269e-06,
                    2.3232e-06,
                    2.4218e-06,
                    2.5315e-06,
                    2.6406e-06,
                    2.7706e-06,
                    2.8954e-06,
                    3.0102e-06,
                    3.1022e-06,
                    3.1752e-06,
                    3.2496e-06,
                    3.3086e-06,
                    3.3937e-06,
                    3.4832e-06,
                    3.5738e-06,
                    3.6531e-06,
                    3.7101e-06,
                    3.7363e-06,
                    3.7624e-06,
                    3.78e-06,
                    3.7871e-06,
                    3.7913e-06,
                    3.7667e-06,
                    3.7309e-06,
                    3.674e-06,
                    3.6034e-06,
                    3.535e-06,
                    3.4714e-06,
                    3.4234e-06,
                    3.3735e-06,
                    3.3107e-06,
                    3.269e-06,
                    3.2098e-06,
                    3.1603e-06,
                    3.1118e-06,
                    3.0632e-06
                ],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [
                    1.4781e-09,
                    2.9795e-09,
                    4.5034e-09,
                    6.0489e-09,
                    7.6147e-09,
                    9.1991e-09,
                    1.08e-08,
                    1.2416e-08,
                    1.4044e-08,
                    1.5682e-08,
                    1.7327e-08,
                    1.898e-08,
                    2.0639e-08,
                    2.2306e-08,
                    2.3979e-08,
                    2.5659e-08,
                    2.7345e-08,
                    2.9039e-08,
                    3.074e-08,
                    3.2449e-08,
                    3.4181e-08,
                    3.596e-08,
                    3.7806e-08,
                    3.9731e-08,
                    4.1744e-08,
                    4.3846e-08,
                    4.6034e-08,
                    4.8297e-08,
                    5.0621e-08,
                    5.2983e-08,
                    5.5371e-08,
                    5.778e-08,
                    6.0208e-08,
                    6.2653e-08,
                    6.5115e-08,
                    6.7593e-08,
                    7.0086e-08,
                    7.2596e-08,
                    7.5123e-08,
                    7.7545e-08,
                    8.0123e-08,
                    8.2851e-08,
                    8.5717e-08,
                    8.8712e-08,
                    9.1821e-08,
                    9.5032e-08,
                    9.8329e-08,
                    1.017e-07,
                    1.0511e-07,
                    1.0856e-07,
                    1.1203e-07,
                    1.1549e-07,
                    1.1893e-07,
                    1.2235e-07,
                    1.2575e-07,
                    1.2912e-07,
                    1.3247e-07,
                    1.3581e-07,
                    1.3915e-07,
                    1.4249e-07,
                    1.4587e-07,
                    1.4926e-07,
                    1.5269e-07,
                    1.5614e-07,
                    1.5961e-07,
                    1.6312e-07,
                    1.6666e-07,
                    1.7023e-07,
                    1.7383e-07,
                    1.7747e-07,
                    1.8115e-07,
                    1.8487e-07,
                    1.8865e-07,
                    1.9248e-07,
                    1.9637e-07,
                    2.0032e-07,
                    2.0434e-07,
                    2.084e-07,
                    2.1253e-07,
                    2.167e-07,
                    2.2092e-07,
                    2.2519e-07,
                    2.2952e-07,
                    2.3391e-07,
                    2.3836e-07,
                    2.4287e-07,
                    2.4743e-07,
                    2.5203e-07,
                    2.5668e-07,
                    2.6136e-07,
                    2.6619e-07,
                    2.7142e-07,
                    2.7721e-07,
                    2.8369e-07,
                    2.9092e-07,
                    2.989e-07,
                    3.076e-07,
                    3.169e-07,
                    3.2664e-07,
                    3.3661e-07,
                    3.4669e-07,
                    3.5688e-07,
                    3.6719e-07,
                    3.7762e-07,
                    3.8819e-07,
                    3.989e-07,
                    4.0976e-07,
                    4.2078e-07,
                    4.3197e-07,
                    4.4332e-07,
                    4.5517e-07,
                    4.6708e-07,
                    4.792e-07,
                    4.9152e-07,
                    5.036e-07,
                    5.1612e-07,
                    5.2934e-07,
                    5.4307e-07,
                    5.5746e-07,
                    5.7261e-07,
                    5.8806e-07,
                    6.0398e-07,
                    6.1904e-07,
                    6.3335e-07,
                    6.4767e-07,
                    6.6349e-07,
                    6.8063e-07,
                    6.9781e-07,
                    7.1485e-07,
                    7.3275e-07,
                    7.4915e-07,
                    7.663e-07,
                    7.8431e-07,
                    8.043e-07,
                    8.2378e-07,
                    8.468e-07,
                    8.7082e-07,
                    8.9546e-07,
                    9.2132e-07,
                    9.4782e-07,
                    9.7423e-07,
                    1.0014e-06,
                    1.0309e-06,
                    1.0598e-06,
                    1.0899e-06,
                    1.1174e-06,
                    1.1468e-06,
                    1.1768e-06,
                    1.2051e-06,
                    1.2325e-06,
                    1.2614e-06,
                    1.2881e-06,
                    1.3163e-06,
                    1.3441e-06,
                    1.3734e-06,
                    1.403e-06,
                    1.4316e-06,
                    1.4599e-06,
                    1.4856e-06,
                    1.5117e-06,
                    1.5364e-06,
                    1.5615e-06,
                    1.5856e-06,
                    1.6095e-06,
                    1.6316e-06,
                    1.6524e-06,
                    1.6724e-06,
                    1.6918e-06,
                    1.7131e-06,
                    1.7334e-06,
                    1.7537e-06,
                    1.7741e-06
                ],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [
                    8.8901e-10,
                    1.7896e-09,
                    2.7014e-09,
                    3.6242e-09,
                    4.5577e-09,
                    5.5011e-09,
                    6.4541e-09,
                    7.4159e-09,
                    8.3856e-09,
                    9.3626e-09,
                    1.0346e-08,
                    1.1336e-08,
                    1.2333e-08,
                    1.3336e-08,
                    1.4345e-08,
                    1.536e-08,
                    1.6382e-08,
                    1.741e-08,
                    1.8445e-08,
                    1.9486e-08,
                    2.0539e-08,
                    2.1611e-08,
                    2.2708e-08,
                    2.3834e-08,
                    2.4992e-08,
                    2.6183e-08,
                    2.7404e-08,
                    2.8654e-08,
                    2.9927e-08,
                    3.1216e-08,
                    3.2517e-08,
                    3.383e-08,
                    3.5152e-08,
                    3.6484e-08,
                    3.7826e-08,
                    3.9176e-08,
                    4.0536e-08,
                    4.1905e-08,
                    4.3284e-08,
                    4.4694e-08,
                    4.612e-08,
                    4.7563e-08,
                    4.9022e-08,
                    5.0498e-08,
                    5.1993e-08,
                    5.3506e-08,
                    5.5039e-08,
                    5.6591e-08,
                    5.8164e-08,
                    5.9759e-08,
                    6.1377e-08,
                    6.3021e-08,
                    6.4692e-08,
                    6.6394e-08,
                    6.8125e-08,
                    6.9888e-08,
                    7.1679e-08,
                    7.35e-08,
                    7.5348e-08,
                    7.722e-08,
                    7.9114e-08,
                    8.1031e-08,
                    8.2967e-08,
                    8.4924e-08,
                    8.6901e-08,
                    8.8898e-08,
                    9.0915e-08,
                    9.2952e-08,
                    9.501e-08,
                    9.7091e-08,
                    9.9196e-08,
                    1.0133e-07,
                    1.0349e-07,
                    1.0567e-07,
                    1.0789e-07,
                    1.1014e-07,
                    1.1241e-07,
                    1.1471e-07,
                    1.1703e-07,
                    1.1937e-07,
                    1.2172e-07,
                    1.241e-07,
                    1.2649e-07,
                    1.289e-07,
                    1.3134e-07,
                    1.3379e-07,
                    1.3627e-07,
                    1.3877e-07,
                    1.4129e-07,
                    1.4384e-07,
                    1.4642e-07,
                    1.4906e-07,
                    1.5178e-07,
                    1.5458e-07,
                    1.5747e-07,
                    1.6046e-07,
                    1.6355e-07,
                    1.6673e-07,
                    1.7e-07,
                    1.7333e-07,
                    1.7672e-07,
                    1.8019e-07,
                    1.8373e-07,
                    1.8734e-07,
                    1.9104e-07,
                    1.9483e-07,
                    1.9871e-07,
                    2.0268e-07,
                    2.0676e-07,
                    2.1093e-07,
                    2.1523e-07,
                    2.1968e-07,
                    2.2428e-07,
                    2.2907e-07,
                    2.3404e-07,
                    2.3919e-07,
                    2.4452e-07,
                    2.5001e-07,
                    2.5564e-07,
                    2.621e-07,
                    2.6862e-07,
                    2.7574e-07,
                    2.8283e-07,
                    2.8956e-07,
                    2.9603e-07,
                    3.029e-07,
                    3.0989e-07,
                    3.1718e-07,
                    3.2452e-07,
                    3.3247e-07,
                    3.4068e-07,
                    3.4941e-07,
                    3.5737e-07,
                    3.6623e-07,
                    3.7411e-07,
                    3.8526e-07,
                    3.969e-07,
                    4.0918e-07,
                    4.225e-07,
                    4.3584e-07,
                    4.4906e-07,
                    4.6228e-07,
                    4.7787e-07,
                    4.9314e-07,
                    5.0947e-07,
                    5.2422e-07,
                    5.4045e-07,
                    5.5681e-07,
                    5.726e-07,
                    5.8705e-07,
                    6.0254e-07,
                    6.1665e-07,
                    6.3196e-07,
                    6.4753e-07,
                    6.6406e-07,
                    6.8054e-07,
                    6.9645e-07,
                    7.1226e-07,
                    7.267e-07,
                    7.4177e-07,
                    7.566e-07,
                    7.715e-07,
                    7.8537e-07,
                    7.9902e-07,
                    8.1091e-07,
                    8.219e-07,
                    8.3226e-07,
                    8.4222e-07,
                    8.5423e-07,
                    8.6502e-07,
                    8.7587e-07,
                    8.869e-07
                ],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": [
                    5.8906e-10,
                    1.1899e-09,
                    1.802e-09,
                    2.4247e-09,
                    3.0571e-09,
                    3.698e-09,
                    4.3463e-09,
                    5.0004e-09,
                    5.6586e-09,
                    6.3192e-09,
                    6.9809e-09,
                    7.6434e-09,
                    8.3065e-09,
                    8.9701e-09,
                    9.6341e-09,
                    1.0298e-08,
                    1.0963e-08,
                    1.1629e-08,
                    1.2295e-08,
                    1.2963e-08,
                    1.3642e-08,
                    1.4349e-08,
                    1.5098e-08,
                    1.5897e-08,
                    1.6751e-08,
                    1.7663e-08,
                    1.8629e-08,
                    1.9643e-08,
                    2.0694e-08,
                    2.1767e-08,
                    2.2853e-08,
                    2.395e-08,
                    2.5056e-08,
                    2.6169e-08,
                    2.729e-08,
                    2.8417e-08,
                    2.955e-08,
                    3.0691e-08,
                    3.1839e-08,
                    3.285e-08,
                    3.4003e-08,
                    3.5288e-08,
                    3.6696e-08,
                    3.8213e-08,
                    3.9828e-08,
                    4.1526e-08,
                    4.3291e-08,
                    4.5105e-08,
                    4.6949e-08,
                    4.8804e-08,
                    5.0649e-08,
                    5.2465e-08,
                    5.4238e-08,
                    5.596e-08,
                    5.7626e-08,
                    5.9236e-08,
                    6.0794e-08,
                    6.231e-08,
                    6.3797e-08,
                    6.5274e-08,
                    6.6752e-08,
                    6.8233e-08,
                    6.9719e-08,
                    7.1212e-08,
                    7.2714e-08,
                    7.4225e-08,
                    7.5746e-08,
                    7.7279e-08,
                    7.8824e-08,
                    8.0381e-08,
                    8.1953e-08,
                    8.3545e-08,
                    8.5162e-08,
                    8.6806e-08,
                    8.848e-08,
                    9.0186e-08,
                    9.1924e-08,
                    9.3695e-08,
                    9.5497e-08,
                    9.7328e-08,
                    9.9192e-08,
                    1.0109e-07,
                    1.0303e-07,
                    1.0501e-07,
                    1.0702e-07,
                    1.0908e-07,
                    1.1116e-07,
                    1.1327e-07,
                    1.1539e-07,
                    1.1752e-07,
                    1.1977e-07,
                    1.2236e-07,
                    1.2544e-07,
                    1.2911e-07,
                    1.3345e-07,
                    1.3844e-07,
                    1.4405e-07,
                    1.5017e-07,
                    1.5665e-07,
                    1.6328e-07,
                    1.6996e-07,
                    1.7669e-07,
                    1.8346e-07,
                    1.9028e-07,
                    1.9715e-07,
                    2.0407e-07,
                    2.1106e-07,
                    2.181e-07,
                    2.2521e-07,
                    2.3239e-07,
                    2.3994e-07,
                    2.474e-07,
                    2.5491e-07,
                    2.6245e-07,
                    2.6957e-07,
                    2.7693e-07,
                    2.8482e-07,
                    2.9306e-07,
                    3.0183e-07,
                    3.1051e-07,
                    3.1944e-07,
                    3.2823e-07,
                    3.3621e-07,
                    3.4378e-07,
                    3.5164e-07,
                    3.6059e-07,
                    3.7075e-07,
                    3.8063e-07,
                    3.9033e-07,
                    4.0029e-07,
                    4.0848e-07,
                    4.169e-07,
                    4.2694e-07,
                    4.3807e-07,
                    4.4967e-07,
                    4.6154e-07,
                    4.7392e-07,
                    4.8628e-07,
                    4.9882e-07,
                    5.1198e-07,
                    5.2517e-07,
                    5.3914e-07,
                    5.5304e-07,
                    5.6665e-07,
                    5.8043e-07,
                    5.9318e-07,
                    6.0633e-07,
                    6.1997e-07,
                    6.325e-07,
                    6.4548e-07,
                    6.5883e-07,
                    6.7149e-07,
                    6.8439e-07,
                    6.9652e-07,
                    7.0936e-07,
                    7.2241e-07,
                    7.3513e-07,
                    7.4768e-07,
                    7.5891e-07,
                    7.6994e-07,
                    7.7983e-07,
                    7.9003e-07,
                    8.0022e-07,
                    8.1045e-07,
                    8.2065e-07,
                    8.3053e-07,
                    8.4016e-07,
                    8.4956e-07,
                    8.5885e-07,
                    8.6837e-07,
                    8.7778e-07,
                    8.8719e-07
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            14.36876,
                            35.99715
                        ],
                        [
                            14.33262,
                            35.98641
                        ],
                        [
                            14.33805,
                            35.87853
                        ],
                        [
                            14.41721,
                            35.82861
                        ],
                        [
                            14.51642,
                            35.80686
                        ],
                        [
                            14.57432,
                            35.86772
                        ],
                        [
                            14.36876,
                            35.99715
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "MHL",
                "Country": "Marshall Islands",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    3.465e-08,
                    7.26e-08,
                    1.1055e-07,
                    1.5015e-07,
                    1.8975e-07,
                    2.2935e-07,
                    2.706e-07,
                    3.102e-07,
                    3.5475e-07,
                    4.0095e-07,
                    4.5045e-07,
                    4.983e-07,
                    5.511e-07,
                    6.0225e-07,
                    6.567e-07,
                    7.128e-07,
                    7.7055e-07,
                    8.2995e-07,
                    8.91e-07,
                    9.537e-07,
                    1.0147e-06,
                    1.0774e-06,
                    1.1418e-06,
                    1.2062e-06,
                    1.2705e-06,
                    1.3365e-06,
                    1.4025e-06,
                    1.4685e-06,
                    1.5345e-06,
                    1.6034e-06,
                    1.6715e-06
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    3.465e-08,
                    7.26e-08,
                    1.1055e-07,
                    1.5015e-07,
                    1.8975e-07,
                    2.2935e-07,
                    2.706e-07,
                    3.102e-07,
                    3.5475e-07,
                    4.0095e-07,
                    4.5045e-07,
                    4.983e-07,
                    5.511e-07,
                    6.0225e-07,
                    6.567e-07,
                    7.128e-07,
                    7.7055e-07,
                    8.2995e-07,
                    8.91e-07,
                    9.537e-07,
                    1.0147e-06,
                    1.0774e-06,
                    1.1418e-06,
                    1.2062e-06,
                    1.2705e-06,
                    1.3365e-06,
                    1.4025e-06,
                    1.4685e-06,
                    1.5345e-06,
                    1.6034e-06,
                    1.6715e-06
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    3.465e-08,
                    7.26e-08,
                    1.1055e-07,
                    1.5015e-07,
                    1.8975e-07,
                    2.2935e-07,
                    2.706e-07,
                    3.102e-07,
                    3.5475e-07,
                    4.0095e-07,
                    4.5045e-07,
                    4.983e-07,
                    5.511e-07,
                    6.0225e-07,
                    6.567e-07,
                    7.128e-07,
                    7.7055e-07,
                    8.2995e-07,
                    8.91e-07,
                    9.537e-07,
                    1.0147e-06,
                    1.0774e-06,
                    1.1418e-06,
                    1.2062e-06,
                    1.2705e-06,
                    1.3365e-06,
                    1.4025e-06,
                    1.4685e-06,
                    1.5345e-06,
                    1.6034e-06,
                    1.6715e-06
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    3.465e-08,
                    7.26e-08,
                    1.1055e-07,
                    1.5015e-07,
                    1.8975e-07,
                    2.2935e-07,
                    2.706e-07,
                    3.102e-07,
                    3.5475e-07,
                    4.0095e-07,
                    4.5045e-07,
                    4.983e-07,
                    5.511e-07,
                    6.0225e-07,
                    6.567e-07,
                    7.128e-07,
                    7.7055e-07,
                    8.2995e-07,
                    8.91e-07,
                    9.537e-07,
                    1.0147e-06,
                    1.0774e-06,
                    1.1418e-06,
                    1.2062e-06,
                    1.2705e-06,
                    1.3365e-06,
                    1.4025e-06,
                    1.4685e-06,
                    1.5345e-06,
                    1.6034e-06,
                    1.6715e-06
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": []
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            168.11603,
                            5.63596
                        ],
                        [
                            168.08646,
                            5.64481
                        ],
                        [
                            168.09769,
                            5.59361
                        ],
                        [
                            168.12204,
                            5.58862
                        ],
                        [
                            168.11603,
                            5.63596
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "MRT",
                "Country": "Mauritania",
                "Total_3GHG": 0.02,
                "Total_3GHG_timeseries": [
                    1.6954e-07,
                    3.3762e-07,
                    5.0429e-07,
                    6.6974e-07,
                    8.3411e-07,
                    9.9755e-07,
                    1.1602e-06,
                    1.322e-06,
                    1.483e-06,
                    1.6438e-06,
                    1.8065e-06,
                    1.9704e-06,
                    2.1707e-06,
                    2.3728e-06,
                    2.5768e-06,
                    2.7831e-06,
                    2.9919e-06,
                    3.2034e-06,
                    3.4177e-06,
                    3.6356e-06,
                    3.8559e-06,
                    4.0794e-06,
                    4.3073e-06,
                    4.5408e-06,
                    4.7806e-06,
                    5.0272e-06,
                    5.2806e-06,
                    5.5405e-06,
                    5.8062e-06,
                    6.0771e-06,
                    6.3462e-06,
                    6.612e-06,
                    6.842e-06,
                    7.0692e-06,
                    7.2938e-06,
                    7.5164e-06,
                    7.7371e-06,
                    7.9564e-06,
                    8.1748e-06,
                    8.3979e-06,
                    8.6177e-06,
                    8.8324e-06,
                    9.0426e-06,
                    9.2501e-06,
                    9.455e-06,
                    9.6565e-06,
                    9.8562e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Fossil_3GHG": 0.01,
                "Fossil_3GHG_timeseries": [
                    1.3283e-08,
                    2.6592e-08,
                    3.9927e-08,
                    5.3288e-08,
                    6.6673e-08,
                    8.0081e-08,
                    9.351e-08,
                    1.0696e-07,
                    1.2043e-07,
                    1.3391e-07,
                    1.476e-07,
                    1.615e-07,
                    2.1057e-07,
                    2.5991e-07,
                    3.0952e-07,
                    3.5941e-07,
                    4.0957e-07,
                    4.6e-07,
                    5.107e-07,
                    5.6168e-07,
                    6.1294e-07,
                    6.6452e-07,
                    7.1642e-07,
                    7.6865e-07,
                    8.2122e-07,
                    8.7413e-07,
                    9.2738e-07,
                    9.8096e-07,
                    1.0349e-06,
                    1.0891e-06,
                    1.1434e-06,
                    1.1978e-06,
                    1.2196e-06,
                    1.2414e-06,
                    1.2633e-06,
                    1.2852e-06,
                    1.3072e-06,
                    1.3292e-06,
                    1.3513e-06,
                    1.3734e-06,
                    1.3957e-06,
                    1.418e-06,
                    1.4404e-06,
                    1.4628e-06,
                    1.4854e-06,
                    1.508e-06,
                    1.5306e-06,
                    1.5534e-06,
                    1.5762e-06,
                    1.5992e-06,
                    1.6216e-06,
                    1.6437e-06,
                    1.6652e-06,
                    1.6862e-06,
                    1.7067e-06,
                    1.7267e-06,
                    1.7461e-06,
                    1.7648e-06,
                    1.783e-06,
                    1.8004e-06,
                    1.819e-06,
                    1.8401e-06,
                    1.8631e-06,
                    1.8879e-06,
                    1.9146e-06,
                    1.9433e-06,
                    1.974e-06,
                    2.0066e-06,
                    2.0411e-06,
                    2.0777e-06,
                    2.1173e-06,
                    2.16e-06,
                    2.2059e-06,
                    2.2551e-06,
                    2.3077e-06,
                    2.3638e-06,
                    2.4233e-06,
                    2.4864e-06,
                    2.5531e-06,
                    2.6235e-06,
                    2.6961e-06,
                    2.7716e-06,
                    2.8487e-06,
                    2.9273e-06,
                    3.008e-06,
                    3.092e-06,
                    3.1748e-06,
                    3.2578e-06,
                    3.3411e-06,
                    3.4246e-06,
                    3.5116e-06,
                    3.6004e-06,
                    3.691e-06,
                    3.789e-06,
                    3.8938e-06,
                    4.0033e-06,
                    4.1178e-06,
                    4.2376e-06,
                    4.363e-06,
                    4.4943e-06,
                    4.6286e-06,
                    4.7669e-06,
                    4.9103e-06,
                    5.0589e-06,
                    5.2127e-06,
                    5.3707e-06,
                    5.5375e-06,
                    5.7114e-06,
                    5.908e-06,
                    6.1141e-06,
                    6.3293e-06,
                    6.5571e-06,
                    6.8023e-06,
                    7.0614e-06,
                    7.3417e-06,
                    7.6332e-06,
                    7.9357e-06,
                    8.2566e-06,
                    8.5977e-06,
                    9.0396e-06,
                    9.4829e-06,
                    9.9591e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_3GHG": 0.05,
                "Land_3GHG_timeseries": [
                    1.5626e-07,
                    3.1103e-07,
                    4.6436e-07,
                    6.1645e-07,
                    7.6744e-07,
                    9.1747e-07,
                    1.0666e-06,
                    1.215e-06,
                    1.3626e-06,
                    1.5098e-06,
                    1.6588e-06,
                    1.8089e-06,
                    1.9602e-06,
                    2.1129e-06,
                    2.2673e-06,
                    2.4237e-06,
                    2.5823e-06,
                    2.7434e-06,
                    2.907e-06,
                    3.0739e-06,
                    3.243e-06,
                    3.4149e-06,
                    3.5909e-06,
                    3.7722e-06,
                    3.9594e-06,
                    4.1531e-06,
                    4.3533e-06,
                    4.5596e-06,
                    4.7713e-06,
                    4.988e-06,
                    5.2028e-06,
                    5.4142e-06,
                    5.6225e-06,
                    5.8278e-06,
                    6.0306e-06,
                    6.2312e-06,
                    6.4299e-06,
                    6.6272e-06,
                    6.8235e-06,
                    7.0245e-06,
                    7.222e-06,
                    7.4144e-06,
                    7.6022e-06,
                    7.7873e-06,
                    7.9697e-06,
                    8.1486e-06,
                    8.3256e-06,
                    8.5036e-06,
                    8.6861e-06,
                    8.876e-06,
                    9.0452e-06,
                    9.1908e-06,
                    9.3178e-06,
                    9.4288e-06,
                    9.5227e-06,
                    9.6034e-06,
                    9.6781e-06,
                    9.7349e-06,
                    9.7792e-06,
                    9.8144e-06,
                    9.8687e-06,
                    9.9306e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Total_CO2": -0,
                "Total_CO2_timeseries": [
                    -0.00000013984,
                    -0.00000028239,
                    -0.00000042754,
                    -0.00000057505,
                    -0.0000007247,
                    -0.00000087624,
                    -0.0000010295,
                    -0.0000011842,
                    -0.0000013403,
                    -0.0000014972,
                    -0.0000016564,
                    -0.0000018186,
                    -0.0000019837,
                    -0.0000021513,
                    -0.0000023214,
                    -0.0000024935,
                    -0.0000026674,
                    -0.000002843,
                    -0.00000302,
                    -0.000003198,
                    -0.0000033788,
                    -0.0000035634,
                    -0.0000037515,
                    -0.0000039428,
                    -0.0000041371,
                    -0.0000043339,
                    -0.000004533,
                    -0.0000047342,
                    -0.0000049373,
                    -0.0000051414,
                    -0.0000053493,
                    -0.000005562,
                    -0.0000057795,
                    -0.0000060011,
                    -0.0000062266,
                    -0.0000064555,
                    -0.0000066874,
                    -0.0000069221,
                    -0.0000071591,
                    -0.0000073973,
                    -0.0000076406,
                    -0.0000078907,
                    -0.0000081473,
                    -0.0000084083,
                    -0.0000086739,
                    -0.0000089449,
                    -0.0000092196,
                    -0.0000094954,
                    -0.0000097686,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_CO2": 0.01,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.485e-08,
                    3.135e-08,
                    5.28e-08,
                    8.085e-08,
                    1.2045e-07,
                    1.7325e-07,
                    2.4585e-07,
                    3.267e-07,
                    4.158e-07,
                    5.214e-07,
                    6.4515e-07,
                    8.382e-07,
                    1.018e-06,
                    1.2194e-06,
                    1.4306e-06,
                    1.6484e-06,
                    1.8777e-06,
                    2.1104e-06,
                    2.3611e-06,
                    2.6235e-06,
                    2.8958e-06,
                    3.1795e-06,
                    3.4649e-06,
                    3.8626e-06,
                    4.285e-06,
                    4.6777e-06,
                    4.973e-06,
                    5.1413e-06,
                    6.6016e-06,
                    8.0354e-06,
                    9.2977e-06,
                    9.6821e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CO2": -0.02,
                "Land_CO2_timeseries": [
                    -0.00000013984,
                    -0.00000028239,
                    -0.00000042754,
                    -0.00000057505,
                    -0.0000007247,
                    -0.00000087624,
                    -0.0000010295,
                    -0.0000011842,
                    -0.0000013403,
                    -0.0000014972,
                    -0.0000016564,
                    -0.0000018186,
                    -0.0000019837,
                    -0.0000021513,
                    -0.0000023214,
                    -0.0000024935,
                    -0.0000026674,
                    -0.000002843,
                    -0.00000302,
                    -0.000003198,
                    -0.0000033788,
                    -0.0000035634,
                    -0.0000037515,
                    -0.0000039428,
                    -0.0000041371,
                    -0.0000043339,
                    -0.000004533,
                    -0.0000047342,
                    -0.0000049373,
                    -0.0000051414,
                    -0.0000053493,
                    -0.000005562,
                    -0.0000057795,
                    -0.0000060011,
                    -0.0000062266,
                    -0.0000064555,
                    -0.0000066874,
                    -0.0000069221,
                    -0.0000071591,
                    -0.0000073973,
                    -0.0000076406,
                    -0.0000078907,
                    -0.0000081473,
                    -0.0000084083,
                    -0.0000086739,
                    -0.0000089449,
                    -0.0000092196,
                    -0.0000094954,
                    -0.0000097686,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001
                ],
                "Total_CH4": 0.07,
                "Total_CH4_timeseries": [
                    2.5786e-07,
                    5.1593e-07,
                    7.7422e-07,
                    1.0327e-06,
                    1.2914e-06,
                    1.5504e-06,
                    1.8095e-06,
                    2.0689e-06,
                    2.3285e-06,
                    2.5883e-06,
                    2.8523e-06,
                    3.1205e-06,
                    3.4279e-06,
                    3.7396e-06,
                    4.0556e-06,
                    4.3759e-06,
                    4.7004e-06,
                    5.0292e-06,
                    5.3623e-06,
                    5.6997e-06,
                    6.0415e-06,
                    6.3877e-06,
                    6.7383e-06,
                    7.0932e-06,
                    7.4526e-06,
                    7.8164e-06,
                    8.1846e-06,
                    8.5571e-06,
                    8.9341e-06,
                    9.3155e-06,
                    9.6976e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_CH4": 0.02,
                "Fossil_CH4_timeseries": [
                    1.2258e-08,
                    2.4525e-08,
                    3.6803e-08,
                    4.9091e-08,
                    6.1388e-08,
                    7.3695e-08,
                    8.6013e-08,
                    9.834e-08,
                    1.1068e-07,
                    1.2302e-07,
                    1.3557e-07,
                    1.4832e-07,
                    1.9624e-07,
                    2.4443e-07,
                    2.9288e-07,
                    3.416e-07,
                    3.9059e-07,
                    4.3985e-07,
                    4.8938e-07,
                    5.3917e-07,
                    5.8924e-07,
                    6.3958e-07,
                    6.9019e-07,
                    7.4108e-07,
                    7.9225e-07,
                    8.4369e-07,
                    8.954e-07,
                    9.4739e-07,
                    9.9965e-07,
                    1.0522e-06,
                    1.1048e-06,
                    1.1576e-06,
                    1.1776e-06,
                    1.1977e-06,
                    1.2179e-06,
                    1.238e-06,
                    1.2582e-06,
                    1.2785e-06,
                    1.2988e-06,
                    1.3191e-06,
                    1.3395e-06,
                    1.3599e-06,
                    1.3803e-06,
                    1.4008e-06,
                    1.4214e-06,
                    1.4419e-06,
                    1.4626e-06,
                    1.4832e-06,
                    1.5039e-06,
                    1.5246e-06,
                    1.5449e-06,
                    1.5646e-06,
                    1.5838e-06,
                    1.6024e-06,
                    1.6205e-06,
                    1.6379e-06,
                    1.6547e-06,
                    1.6708e-06,
                    1.6862e-06,
                    1.7009e-06,
                    1.7168e-06,
                    1.735e-06,
                    1.7551e-06,
                    1.777e-06,
                    1.8008e-06,
                    1.8265e-06,
                    1.8542e-06,
                    1.8837e-06,
                    1.9152e-06,
                    1.9487e-06,
                    1.9851e-06,
                    2.0245e-06,
                    2.0672e-06,
                    2.1132e-06,
                    2.1625e-06,
                    2.2152e-06,
                    2.2713e-06,
                    2.331e-06,
                    2.3942e-06,
                    2.461e-06,
                    2.5301e-06,
                    2.6019e-06,
                    2.6753e-06,
                    2.7501e-06,
                    2.8269e-06,
                    2.907e-06,
                    2.9857e-06,
                    3.0646e-06,
                    3.1436e-06,
                    3.2228e-06,
                    3.3052e-06,
                    3.3893e-06,
                    3.475e-06,
                    3.5678e-06,
                    3.6671e-06,
                    3.7708e-06,
                    3.8793e-06,
                    3.9927e-06,
                    4.1114e-06,
                    4.2358e-06,
                    4.363e-06,
                    4.4939e-06,
                    4.6296e-06,
                    4.7703e-06,
                    4.916e-06,
                    5.0656e-06,
                    5.2238e-06,
                    5.3888e-06,
                    5.5615e-06,
                    5.7417e-06,
                    5.926e-06,
                    6.1159e-06,
                    6.3115e-06,
                    6.5076e-06,
                    6.7047e-06,
                    6.9045e-06,
                    7.1068e-06,
                    7.3106e-06,
                    7.5161e-06,
                    7.751e-06,
                    8.0003e-06,
                    8.261e-06,
                    8.536e-06,
                    8.8178e-06,
                    9.1253e-06,
                    9.4475e-06,
                    9.7881e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CH4": 0.16,
                "Land_CH4_timeseries": [
                    2.456e-07,
                    4.914e-07,
                    7.3741e-07,
                    9.8363e-07,
                    1.2301e-06,
                    1.4767e-06,
                    1.7235e-06,
                    1.9706e-06,
                    2.2178e-06,
                    2.4653e-06,
                    2.7167e-06,
                    2.9722e-06,
                    3.2317e-06,
                    3.4952e-06,
                    3.7627e-06,
                    4.0343e-06,
                    4.3098e-06,
                    4.5894e-06,
                    4.873e-06,
                    5.1605e-06,
                    5.4523e-06,
                    5.7481e-06,
                    6.0481e-06,
                    6.3522e-06,
                    6.6604e-06,
                    6.9727e-06,
                    7.2892e-06,
                    7.6098e-06,
                    7.9345e-06,
                    8.2633e-06,
                    8.5928e-06,
                    8.923e-06,
                    9.2539e-06,
                    9.5854e-06,
                    9.9176e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Total_N2O": 0.1,
                "Total_N2O_timeseries": [
                    5.1525e-08,
                    1.0408e-07,
                    1.5761e-07,
                    2.1207e-07,
                    2.6737e-07,
                    3.2342e-07,
                    3.8011e-07,
                    4.3731e-07,
                    4.9487e-07,
                    5.5264e-07,
                    6.1051e-07,
                    6.6845e-07,
                    7.2646e-07,
                    7.845e-07,
                    8.4259e-07,
                    9.0071e-07,
                    9.5888e-07,
                    1.0171e-06,
                    1.0754e-06,
                    1.1338e-06,
                    1.1932e-06,
                    1.2551e-06,
                    1.3205e-06,
                    1.3904e-06,
                    1.4651e-06,
                    1.5447e-06,
                    1.6291e-06,
                    1.7176e-06,
                    1.8093e-06,
                    1.903e-06,
                    1.9978e-06,
                    2.0935e-06,
                    2.19e-06,
                    2.2872e-06,
                    2.385e-06,
                    2.4834e-06,
                    2.5823e-06,
                    2.6818e-06,
                    2.7821e-06,
                    2.8875e-06,
                    2.994e-06,
                    3.1015e-06,
                    3.2101e-06,
                    3.3199e-06,
                    3.4309e-06,
                    3.5432e-06,
                    3.6567e-06,
                    3.7715e-06,
                    3.8877e-06,
                    4.0053e-06,
                    4.1243e-06,
                    4.2445e-06,
                    4.3661e-06,
                    4.4891e-06,
                    4.6135e-06,
                    4.7395e-06,
                    4.8672e-06,
                    4.9969e-06,
                    5.1288e-06,
                    5.2632e-06,
                    5.4013e-06,
                    5.545e-06,
                    5.6957e-06,
                    5.8547e-06,
                    6.0229e-06,
                    6.2006e-06,
                    6.3882e-06,
                    6.5856e-06,
                    6.7923e-06,
                    7.0076e-06,
                    7.2316e-06,
                    7.4654e-06,
                    7.7097e-06,
                    7.9646e-06,
                    8.2298e-06,
                    8.5045e-06,
                    8.7874e-06,
                    9.077e-06,
                    9.3709e-06,
                    9.6666e-06,
                    9.9614e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_N2O": 0.01,
                "Fossil_N2O_timeseries": [
                    1.0249e-09,
                    2.0665e-09,
                    3.1242e-09,
                    4.1972e-09,
                    5.2846e-09,
                    6.3852e-09,
                    7.4975e-09,
                    8.62e-09,
                    9.7508e-09,
                    1.0888e-08,
                    1.203e-08,
                    1.3177e-08,
                    1.4328e-08,
                    1.5483e-08,
                    1.6643e-08,
                    1.7807e-08,
                    1.8975e-08,
                    2.0147e-08,
                    2.1325e-08,
                    2.2507e-08,
                    2.3706e-08,
                    2.4939e-08,
                    2.6221e-08,
                    2.7563e-08,
                    2.8969e-08,
                    3.0441e-08,
                    3.1977e-08,
                    3.3569e-08,
                    3.5205e-08,
                    3.6869e-08,
                    3.8551e-08,
                    4.0249e-08,
                    4.196e-08,
                    4.3683e-08,
                    4.5418e-08,
                    4.7164e-08,
                    4.8921e-08,
                    5.0689e-08,
                    5.2469e-08,
                    5.4317e-08,
                    5.6192e-08,
                    5.8095e-08,
                    6.0029e-08,
                    6.1994e-08,
                    6.3992e-08,
                    6.6025e-08,
                    6.8094e-08,
                    7.0201e-08,
                    7.2346e-08,
                    7.4533e-08,
                    7.6766e-08,
                    7.9051e-08,
                    8.1393e-08,
                    8.3796e-08,
                    8.6262e-08,
                    8.8791e-08,
                    9.1381e-08,
                    9.4029e-08,
                    9.673e-08,
                    9.9478e-08,
                    1.0227e-07,
                    1.051e-07,
                    1.0797e-07,
                    1.1087e-07,
                    1.1381e-07,
                    1.1679e-07,
                    1.198e-07,
                    1.2284e-07,
                    1.2593e-07,
                    1.2905e-07,
                    1.3221e-07,
                    1.3541e-07,
                    1.3865e-07,
                    1.4193e-07,
                    1.4525e-07,
                    1.486e-07,
                    1.52e-07,
                    1.5545e-07,
                    1.5893e-07,
                    1.6247e-07,
                    1.6605e-07,
                    1.697e-07,
                    1.7342e-07,
                    1.7721e-07,
                    1.8108e-07,
                    1.8505e-07,
                    1.891e-07,
                    1.9325e-07,
                    1.9751e-07,
                    2.0186e-07,
                    2.0636e-07,
                    2.1105e-07,
                    2.1597e-07,
                    2.2117e-07,
                    2.2666e-07,
                    2.3246e-07,
                    2.3856e-07,
                    2.4496e-07,
                    2.5163e-07,
                    2.5855e-07,
                    2.6569e-07,
                    2.7306e-07,
                    2.8069e-07,
                    2.8857e-07,
                    2.967e-07,
                    3.0509e-07,
                    3.1372e-07,
                    3.226e-07,
                    3.317e-07,
                    3.4102e-07,
                    3.5055e-07,
                    3.6031e-07,
                    3.7032e-07,
                    3.8059e-07,
                    3.9115e-07,
                    4.0199e-07,
                    4.1314e-07,
                    4.246e-07,
                    4.3637e-07,
                    4.5043e-07,
                    4.6453e-07,
                    4.7872e-07,
                    4.9321e-07,
                    5.0799e-07,
                    5.2378e-07,
                    5.3996e-07,
                    5.5697e-07,
                    5.7474e-07,
                    5.9299e-07,
                    6.1192e-07,
                    6.312e-07,
                    6.5178e-07,
                    6.734e-07,
                    6.9647e-07,
                    7.2032e-07,
                    7.429e-07,
                    7.6775e-07,
                    7.932e-07,
                    8.2202e-07,
                    8.529e-07,
                    8.8602e-07,
                    9.3351e-07,
                    9.8101e-07,
                    1.0291e-06,
                    1.079e-06,
                    1.1301e-06,
                    1.1812e-06,
                    1.2328e-06,
                    1.287e-06,
                    1.3292e-06,
                    1.3728e-06,
                    1.4184e-06,
                    1.4662e-06,
                    1.5162e-06,
                    1.5681e-06,
                    1.6209e-06,
                    1.6766e-06,
                    1.7369e-06,
                    1.7988e-06,
                    1.8616e-06,
                    1.927e-06,
                    1.9961e-06,
                    2.0647e-06,
                    2.1391e-06,
                    2.2148e-06,
                    2.2911e-06,
                    2.3749e-06,
                    2.4607e-06,
                    2.5498e-06,
                    2.6411e-06,
                    2.736e-06,
                    2.8318e-06
                ],
                "Land_N2O": 0.14,
                "Land_N2O_timeseries": [
                    5.0501e-08,
                    1.0201e-07,
                    1.5449e-07,
                    2.0787e-07,
                    2.6208e-07,
                    3.1703e-07,
                    3.7261e-07,
                    4.2869e-07,
                    4.8512e-07,
                    5.4175e-07,
                    5.9848e-07,
                    6.5528e-07,
                    7.1213e-07,
                    7.6902e-07,
                    8.2594e-07,
                    8.829e-07,
                    9.399e-07,
                    9.9696e-07,
                    1.0541e-06,
                    1.1113e-06,
                    1.1695e-06,
                    1.2302e-06,
                    1.2943e-06,
                    1.3628e-06,
                    1.4361e-06,
                    1.5143e-06,
                    1.5971e-06,
                    1.684e-06,
                    1.7741e-06,
                    1.8661e-06,
                    1.9592e-06,
                    2.0533e-06,
                    2.1481e-06,
                    2.2435e-06,
                    2.3396e-06,
                    2.4362e-06,
                    2.5334e-06,
                    2.6311e-06,
                    2.7296e-06,
                    2.8332e-06,
                    2.9378e-06,
                    3.0434e-06,
                    3.1501e-06,
                    3.2579e-06,
                    3.3669e-06,
                    3.4771e-06,
                    3.5886e-06,
                    3.7013e-06,
                    3.8154e-06,
                    3.9308e-06,
                    4.0475e-06,
                    4.1655e-06,
                    4.2847e-06,
                    4.4053e-06,
                    4.5272e-06,
                    4.6507e-06,
                    4.7758e-06,
                    4.9029e-06,
                    5.032e-06,
                    5.1637e-06,
                    5.2991e-06,
                    5.4399e-06,
                    5.5878e-06,
                    5.7439e-06,
                    5.909e-06,
                    6.0838e-06,
                    6.2684e-06,
                    6.4628e-06,
                    6.6664e-06,
                    6.8785e-06,
                    7.0994e-06,
                    7.33e-06,
                    7.5711e-06,
                    7.8227e-06,
                    8.0845e-06,
                    8.3559e-06,
                    8.6354e-06,
                    8.9215e-06,
                    9.212e-06,
                    9.5041e-06,
                    9.7954e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -12.23916,
                                14.75937
                            ],
                            [
                                -12.12814,
                                14.76888
                            ],
                            [
                                -11.97983,
                                14.76166
                            ],
                            [
                                -11.93651,
                                14.81344
                            ],
                            [
                                -11.80716,
                                14.89897
                            ],
                            [
                                -11.7927,
                                15.02494
                            ],
                            [
                                -11.83552,
                                15.03733
                            ],
                            [
                                -11.83759,
                                15.17447
                            ],
                            [
                                -11.77055,
                                15.33938
                            ],
                            [
                                -11.74652,
                                15.45788
                            ],
                            [
                                -11.71462,
                                15.52531
                            ],
                            [
                                -11.60072,
                                15.52941
                            ],
                            [
                                -11.56783,
                                15.57494
                            ],
                            [
                                -11.43107,
                                15.64523
                            ],
                            [
                                -11.32133,
                                15.49995
                            ],
                            [
                                -11.24005,
                                15.41082
                            ],
                            [
                                -11.0753,
                                15.30429
                            ],
                            [
                                -10.99947,
                                15.23871
                            ],
                            [
                                -10.91198,
                                15.11571
                            ],
                            [
                                -10.82806,
                                15.26967
                            ],
                            [
                                -10.66241,
                                15.40508
                            ],
                            [
                                -10.50878,
                                15.43974
                            ],
                            [
                                -10.31898,
                                15.43058
                            ],
                            [
                                -10.12971,
                                15.3667
                            ],
                            [
                                -9.99956,
                                15.35669
                            ],
                            [
                                -9.92146,
                                15.37332
                            ],
                            [
                                -9.79293,
                                15.37328
                            ],
                            [
                                -9.6964,
                                15.4274
                            ],
                            [
                                -9.41079,
                                15.4344
                            ],
                            [
                                -9.44215,
                                15.59687
                            ],
                            [
                                -9.33208,
                                15.69126
                            ],
                            [
                                -9.31148,
                                15.66688
                            ],
                            [
                                -9.33251,
                                15.56696
                            ],
                            [
                                -9.32534,
                                15.4963
                            ],
                            [
                                -8.75178,
                                15.49823
                            ],
                            [
                                -7.98394,
                                15.49636
                            ],
                            [
                                -7.66416,
                                15.49953
                            ],
                            [
                                -7.13233,
                                15.49779
                            ],
                            [
                                -6.71731,
                                15.49918
                            ],
                            [
                                -6.1502,
                                15.4943
                            ],
                            [
                                -5.52264,
                                15.50183
                            ],
                            [
                                -5.50775,
                                15.5091
                            ],
                            [
                                -5.39809,
                                15.99752
                            ],
                            [
                                -5.33006,
                                16.33105
                            ],
                            [
                                -5.59478,
                                16.49471
                            ],
                            [
                                -5.60359,
                                16.50771
                            ],
                            [
                                -5.65928,
                                16.9968
                            ],
                            [
                                -5.71048,
                                17.49486
                            ],
                            [
                                -5.76652,
                                18.0087
                            ],
                            [
                                -5.84953,
                                18.73077
                            ],
                            [
                                -5.91669,
                                19.34797
                            ],
                            [
                                -5.97349,
                                19.82778
                            ],
                            [
                                -6.02619,
                                20.31144
                            ],
                            [
                                -6.09197,
                                20.86866
                            ],
                            [
                                -6.22378,
                                22.01127
                            ],
                            [
                                -6.29274,
                                22.59888
                            ],
                            [
                                -6.3388,
                                23.02903
                            ],
                            [
                                -6.38408,
                                23.40832
                            ],
                            [
                                -6.45151,
                                23.9427
                            ],
                            [
                                -6.4551,
                                24.034
                            ],
                            [
                                -6.5637,
                                24.99603
                            ],
                            [
                                -6.55451,
                                24.99985
                            ],
                            [
                                -5.01,
                                25.0
                            ],
                            [
                                -4.83333,
                                24.99759
                            ],
                            [
                                -5.68229,
                                25.52041
                            ],
                            [
                                -6.31388,
                                25.90535
                            ],
                            [
                                -6.75,
                                26.17015
                            ],
                            [
                                -7.21442,
                                26.44891
                            ],
                            [
                                -7.85542,
                                26.83217
                            ],
                            [
                                -8.66667,
                                27.31274
                            ],
                            [
                                -8.67248,
                                27.28832
                            ],
                            [
                                -8.67232,
                                26.54068
                            ],
                            [
                                -8.67416,
                                25.99762
                            ],
                            [
                                -8.97905,
                                25.99689
                            ],
                            [
                                -9.56291,
                                26.00001
                            ],
                            [
                                -9.88807,
                                25.99775
                            ],
                            [
                                -10.37411,
                                25.9987
                            ],
                            [
                                -11.00663,
                                25.99864
                            ],
                            [
                                -11.56514,
                                25.99853
                            ],
                            [
                                -12.00381,
                                25.99859
                            ],
                            [
                                -12.00522,
                                25.12668
                            ],
                            [
                                -12.00298,
                                24.51334
                            ],
                            [
                                -12,
                                23.99971
                            ],
                            [
                                -12.00002,
                                23.46762
                            ],
                            [
                                -12.12636,
                                23.41269
                            ],
                            [
                                -12.15603,
                                23.41629
                            ],
                            [
                                -12.36583,
                                23.31863
                            ],
                            [
                                -12.57159,
                                23.29127
                            ],
                            [
                                -12.99827,
                                23.02474
                            ],
                            [
                                -13.11354,
                                22.88332
                            ],
                            [
                                -13.14521,
                                22.74169
                            ],
                            [
                                -13.0801,
                                22.52766
                            ],
                            [
                                -13.00184,
                                21.33087
                            ],
                            [
                                -13.88312,
                                21.34036
                            ],
                            [
                                -14.59675,
                                21.3436
                            ],
                            [
                                -15.20169,
                                21.34334
                            ],
                            [
                                -15.87707,
                                21.34121
                            ],
                            [
                                -16.30914,
                                21.33701
                            ],
                            [
                                -16.91968,
                                21.33016
                            ],
                            [
                                -16.93952,
                                21.32565
                            ],
                            [
                                -17.00309,
                                21.10466
                            ],
                            [
                                -17.03984,
                                21.04016
                            ],
                            [
                                -17.06637,
                                20.92283
                            ],
                            [
                                -17.0513,
                                20.77162
                            ],
                            [
                                -17.0061,
                                21.01085
                            ],
                            [
                                -16.9472,
                                21.113
                            ],
                            [
                                -16.88637,
                                21.11743
                            ],
                            [
                                -16.85965,
                                21.03077
                            ],
                            [
                                -16.77798,
                                20.91875
                            ],
                            [
                                -16.75293,
                                20.83206
                            ],
                            [
                                -16.67212,
                                20.73178
                            ],
                            [
                                -16.67215,
                                20.68146
                            ],
                            [
                                -16.581,
                                20.59312
                            ],
                            [
                                -16.5272,
                                20.58532
                            ],
                            [
                                -16.53216,
                                20.68405
                            ],
                            [
                                -16.43387,
                                20.63203
                            ],
                            [
                                -16.38547,
                                20.53315
                            ],
                            [
                                -16.35251,
                                20.41711
                            ],
                            [
                                -16.26939,
                                20.29027
                            ],
                            [
                                -16.23109,
                                20.27024
                            ],
                            [
                                -16.20888,
                                20.18309
                            ],
                            [
                                -16.25786,
                                20.12223
                            ],
                            [
                                -16.22694,
                                20.0512
                            ],
                            [
                                -16.22805,
                                19.98525
                            ],
                            [
                                -16.29793,
                                19.91504
                            ],
                            [
                                -16.25222,
                                19.83973
                            ],
                            [
                                -16.27974,
                                19.72746
                            ],
                            [
                                -16.32168,
                                19.72751
                            ],
                            [
                                -16.46154,
                                19.4445
                            ],
                            [
                                -16.41632,
                                19.43351
                            ],
                            [
                                -16.38028,
                                19.51757
                            ],
                            [
                                -16.293,
                                19.5237
                            ],
                            [
                                -16.30864,
                                19.47431
                            ],
                            [
                                -16.45264,
                                19.37549
                            ],
                            [
                                -16.52008,
                                19.36152
                            ],
                            [
                                -16.46424,
                                19.25433
                            ],
                            [
                                -16.35541,
                                19.19011
                            ],
                            [
                                -16.25151,
                                19.06779
                            ],
                            [
                                -16.1886,
                                18.93313
                            ],
                            [
                                -16.13241,
                                18.65461
                            ],
                            [
                                -16.05846,
                                18.46344
                            ],
                            [
                                -16.029,
                                18.16905
                            ],
                            [
                                -16.02226,
                                17.97366
                            ],
                            [
                                -16.04621,
                                17.7231
                            ],
                            [
                                -16.08517,
                                17.5119
                            ],
                            [
                                -16.1475,
                                17.32522
                            ],
                            [
                                -16.33372,
                                16.89219
                            ],
                            [
                                -16.43359,
                                16.63963
                            ],
                            [
                                -16.45658,
                                16.47952
                            ],
                            [
                                -16.50813,
                                16.32179
                            ],
                            [
                                -16.51858,
                                16.25915
                            ],
                            [
                                -16.51027,
                                16.20455
                            ],
                            [
                                -16.50871,
                                16.05727
                            ],
                            [
                                -16.50522,
                                16.05727
                            ],
                            [
                                -16.50409,
                                16.05727
                            ],
                            [
                                -16.50064,
                                16.06014
                            ],
                            [
                                -16.50875,
                                16.1857
                            ],
                            [
                                -16.48343,
                                16.27352
                            ],
                            [
                                -16.45291,
                                16.32251
                            ],
                            [
                                -16.46078,
                                16.38546
                            ],
                            [
                                -16.42958,
                                16.49258
                            ],
                            [
                                -16.38644,
                                16.51454
                            ],
                            [
                                -16.31785,
                                16.4461
                            ],
                            [
                                -16.41155,
                                16.44245
                            ],
                            [
                                -16.40397,
                                16.35483
                            ],
                            [
                                -16.4418,
                                16.23212
                            ],
                            [
                                -16.41478,
                                16.21945
                            ],
                            [
                                -16.35593,
                                16.28085
                            ],
                            [
                                -16.28531,
                                16.50509
                            ],
                            [
                                -16.11611,
                                16.5554
                            ],
                            [
                                -16.05954,
                                16.48353
                            ],
                            [
                                -15.9507,
                                16.49066
                            ],
                            [
                                -15.91759,
                                16.51194
                            ],
                            [
                                -15.81168,
                                16.50803
                            ],
                            [
                                -15.70928,
                                16.47437
                            ],
                            [
                                -15.63137,
                                16.49161
                            ],
                            [
                                -15.60842,
                                16.53784
                            ],
                            [
                                -15.54939,
                                16.51258
                            ],
                            [
                                -15.46772,
                                16.59138
                            ],
                            [
                                -15.40394,
                                16.53711
                            ],
                            [
                                -15.30861,
                                16.57461
                            ],
                            [
                                -15.2277,
                                16.55689
                            ],
                            [
                                -15.1143,
                                16.63412
                            ],
                            [
                                -15.00383,
                                16.64508
                            ],
                            [
                                -14.49731,
                                16.61618
                            ],
                            [
                                -14.33379,
                                16.63927
                            ],
                            [
                                -14.3325,
                                16.5791
                            ],
                            [
                                -14.22215,
                                16.54372
                            ],
                            [
                                -14.02938,
                                16.3525
                            ],
                            [
                                -13.96606,
                                16.32882
                            ],
                            [
                                -13.9541,
                                16.26985
                            ],
                            [
                                -13.84172,
                                16.11145
                            ],
                            [
                                -13.72477,
                                16.17663
                            ],
                            [
                                -13.68031,
                                16.0986
                            ],
                            [
                                -13.57189,
                                16.13468
                            ],
                            [
                                -13.37913,
                                16.05828
                            ],
                            [
                                -13.35953,
                                15.96573
                            ],
                            [
                                -13.31378,
                                15.92378
                            ],
                            [
                                -13.27511,
                                15.75385
                            ],
                            [
                                -13.20985,
                                15.69513
                            ],
                            [
                                -13.1814,
                                15.62427
                            ],
                            [
                                -13.09155,
                                15.58266
                            ],
                            [
                                -13.10146,
                                15.5075
                            ],
                            [
                                -13.0601,
                                15.48209
                            ],
                            [
                                -12.96089,
                                15.49854
                            ],
                            [
                                -12.94403,
                                15.36265
                            ],
                            [
                                -12.83607,
                                15.2897
                            ],
                            [
                                -12.84778,
                                15.20455
                            ],
                            [
                                -12.68991,
                                15.09104
                            ],
                            [
                                -12.60721,
                                15.08314
                            ],
                            [
                                -12.4612,
                                14.97906
                            ],
                            [
                                -12.44684,
                                14.88958
                            ],
                            [
                                -12.37749,
                                14.83682
                            ],
                            [
                                -12.3262,
                                14.82579
                            ],
                            [
                                -12.23916,
                                14.75937
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -16.44929,
                                19.62138
                            ],
                            [
                                -16.41828,
                                19.61685
                            ],
                            [
                                -16.37383,
                                19.69177
                            ],
                            [
                                -16.3531,
                                19.7936
                            ],
                            [
                                -16.42195,
                                19.8077
                            ],
                            [
                                -16.44929,
                                19.62138
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "MUS",
                "Country": "Mauritius",
                "Total_3GHG": 0.01,
                "Total_3GHG_timeseries": [
                    4.811e-08,
                    1.0251e-07,
                    1.6356e-07,
                    2.31e-07,
                    3.056e-07,
                    3.8474e-07,
                    4.7375e-07,
                    5.7183e-07,
                    6.9181e-07,
                    8.1134e-07,
                    9.3067e-07,
                    1.0559e-06,
                    1.1832e-06,
                    1.3116e-06,
                    1.4389e-06,
                    1.5671e-06,
                    1.6872e-06,
                    1.8043e-06,
                    1.9208e-06,
                    2.035e-06,
                    2.1367e-06,
                    2.2317e-06,
                    2.3225e-06,
                    2.4089e-06,
                    2.4909e-06,
                    2.57e-06,
                    2.6434e-06,
                    2.7055e-06,
                    2.7549e-06,
                    2.8009e-06,
                    2.8495e-06,
                    2.8881e-06,
                    2.922e-06,
                    2.9598e-06,
                    2.9903e-06,
                    3.0161e-06,
                    3.0494e-06,
                    3.0898e-06,
                    3.1253e-06,
                    3.1597e-06,
                    3.2084e-06,
                    3.2556e-06,
                    3.299e-06,
                    3.3346e-06,
                    3.3725e-06,
                    3.4028e-06,
                    3.4211e-06,
                    3.4364e-06,
                    3.4489e-06,
                    3.4586e-06,
                    3.4749e-06,
                    3.4913e-06,
                    3.508e-06,
                    3.5238e-06,
                    3.539e-06,
                    3.5544e-06,
                    3.5698e-06,
                    3.5855e-06,
                    3.6007e-06,
                    3.6152e-06,
                    3.6308e-06,
                    3.6475e-06,
                    3.6657e-06,
                    3.6853e-06,
                    3.7058e-06,
                    3.7288e-06,
                    3.7526e-06,
                    3.7783e-06,
                    3.8033e-06,
                    3.8325e-06,
                    3.8638e-06,
                    3.8969e-06,
                    3.9317e-06,
                    3.9683e-06,
                    4.0066e-06,
                    4.0476e-06,
                    4.0908e-06,
                    4.1356e-06,
                    4.1824e-06,
                    4.2266e-06,
                    4.2679e-06,
                    4.3073e-06,
                    4.3443e-06,
                    4.3801e-06,
                    4.4147e-06,
                    4.4491e-06,
                    4.4834e-06,
                    4.5182e-06,
                    4.5554e-06,
                    4.598e-06,
                    4.6462e-06,
                    4.7031e-06,
                    4.7697e-06,
                    4.8472e-06,
                    4.9452e-06,
                    5.0645e-06,
                    5.2054e-06,
                    5.3673e-06,
                    5.5519e-06,
                    5.8719e-06,
                    6.1723e-06,
                    6.5049e-06,
                    6.8653e-06,
                    7.2498e-06,
                    7.633e-06,
                    8.0828e-06,
                    8.5596e-06,
                    9.0586e-06,
                    9.5922e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_3GHG": 0.01,
                "Fossil_3GHG_timeseries": [
                    2.1148e-08,
                    5.0023e-08,
                    8.4979e-08,
                    1.2518e-07,
                    1.7112e-07,
                    2.2117e-07,
                    2.7714e-07,
                    3.4242e-07,
                    4.2139e-07,
                    5.0634e-07,
                    5.9502e-07,
                    6.8528e-07,
                    7.7721e-07,
                    8.7036e-07,
                    9.6798e-07,
                    1.0664e-06,
                    1.1565e-06,
                    1.2439e-06,
                    1.3306e-06,
                    1.4184e-06,
                    1.4948e-06,
                    1.5659e-06,
                    1.6336e-06,
                    1.698e-06,
                    1.7588e-06,
                    1.8172e-06,
                    1.871e-06,
                    1.9173e-06,
                    1.952e-06,
                    1.9822e-06,
                    2.0087e-06,
                    2.033e-06,
                    2.0552e-06,
                    2.0767e-06,
                    2.0941e-06,
                    2.1098e-06,
                    2.1326e-06,
                    2.1573e-06,
                    2.1823e-06,
                    2.2064e-06,
                    2.233e-06,
                    2.2573e-06,
                    2.2784e-06,
                    2.297e-06,
                    2.3136e-06,
                    2.3281e-06,
                    2.3407e-06,
                    2.3516e-06,
                    2.3608e-06,
                    2.3684e-06,
                    2.3761e-06,
                    2.3846e-06,
                    2.3932e-06,
                    2.4012e-06,
                    2.4092e-06,
                    2.4174e-06,
                    2.4259e-06,
                    2.4346e-06,
                    2.4429e-06,
                    2.451e-06,
                    2.4599e-06,
                    2.4693e-06,
                    2.4802e-06,
                    2.4926e-06,
                    2.5052e-06,
                    2.5193e-06,
                    2.5346e-06,
                    2.5507e-06,
                    2.566e-06,
                    2.5834e-06,
                    2.6023e-06,
                    2.6217e-06,
                    2.6423e-06,
                    2.6642e-06,
                    2.6872e-06,
                    2.7121e-06,
                    2.7383e-06,
                    2.7658e-06,
                    2.7945e-06,
                    2.825e-06,
                    2.8555e-06,
                    2.8865e-06,
                    2.9184e-06,
                    2.9511e-06,
                    2.9853e-06,
                    3.0206e-06,
                    3.0574e-06,
                    3.0957e-06,
                    3.1369e-06,
                    3.1787e-06,
                    3.2219e-06,
                    3.2676e-06,
                    3.3157e-06,
                    3.3661e-06,
                    3.4285e-06,
                    3.5035e-06,
                    3.5919e-06,
                    3.6945e-06,
                    3.814e-06,
                    4.0391e-06,
                    4.2559e-06,
                    4.5065e-06,
                    4.7852e-06,
                    5.0878e-06,
                    5.3889e-06,
                    5.7577e-06,
                    6.1534e-06,
                    6.5716e-06,
                    7.0258e-06,
                    7.4899e-06,
                    7.9881e-06,
                    8.5487e-06,
                    9.1227e-06,
                    9.7768e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [
                    2.6962e-08,
                    5.2487e-08,
                    7.8581e-08,
                    1.0582e-07,
                    1.3448e-07,
                    1.6357e-07,
                    1.9661e-07,
                    2.294e-07,
                    2.7042e-07,
                    3.0501e-07,
                    3.3565e-07,
                    3.7065e-07,
                    4.0603e-07,
                    4.4119e-07,
                    4.7091e-07,
                    5.0069e-07,
                    5.3068e-07,
                    5.6038e-07,
                    5.9018e-07,
                    6.1658e-07,
                    6.4192e-07,
                    6.6573e-07,
                    6.8897e-07,
                    7.1097e-07,
                    7.321e-07,
                    7.5275e-07,
                    7.724e-07,
                    7.8821e-07,
                    8.0289e-07,
                    8.1869e-07,
                    8.4077e-07,
                    8.5513e-07,
                    8.6682e-07,
                    8.8305e-07,
                    8.9614e-07,
                    9.0636e-07,
                    9.1679e-07,
                    9.3254e-07,
                    9.4298e-07,
                    9.5328e-07,
                    9.7537e-07,
                    9.9827e-07,
                    1.0206e-06,
                    1.0377e-06,
                    1.0589e-06,
                    1.0747e-06,
                    1.0804e-06,
                    1.0848e-06,
                    1.0881e-06,
                    1.0901e-06,
                    1.0988e-06,
                    1.1068e-06,
                    1.1148e-06,
                    1.1226e-06,
                    1.1298e-06,
                    1.137e-06,
                    1.1439e-06,
                    1.1509e-06,
                    1.1578e-06,
                    1.1642e-06,
                    1.171e-06,
                    1.1782e-06,
                    1.1854e-06,
                    1.1927e-06,
                    1.2006e-06,
                    1.2095e-06,
                    1.218e-06,
                    1.2276e-06,
                    1.2372e-06,
                    1.2491e-06,
                    1.2616e-06,
                    1.2751e-06,
                    1.2894e-06,
                    1.3042e-06,
                    1.3194e-06,
                    1.3355e-06,
                    1.3525e-06,
                    1.3698e-06,
                    1.3878e-06,
                    1.4016e-06,
                    1.4124e-06,
                    1.4207e-06,
                    1.4259e-06,
                    1.429e-06,
                    1.4294e-06,
                    1.4284e-06,
                    1.426e-06,
                    1.4225e-06,
                    1.4185e-06,
                    1.4194e-06,
                    1.4243e-06,
                    1.4354e-06,
                    1.454e-06,
                    1.481e-06,
                    1.5167e-06,
                    1.561e-06,
                    1.6135e-06,
                    1.6728e-06,
                    1.7379e-06,
                    1.8328e-06,
                    1.9164e-06,
                    1.9983e-06,
                    2.0801e-06,
                    2.162e-06,
                    2.244e-06,
                    2.3251e-06,
                    2.4062e-06,
                    2.487e-06,
                    2.5665e-06,
                    2.6498e-06,
                    2.7303e-06,
                    2.8145e-06,
                    2.8983e-06,
                    2.9865e-06,
                    3.0708e-06,
                    3.1577e-06,
                    3.2362e-06,
                    3.3086e-06,
                    3.3834e-06,
                    3.4593e-06,
                    3.5311e-06,
                    3.6089e-06,
                    3.6684e-06,
                    3.7081e-06,
                    3.7397e-06,
                    3.7702e-06,
                    3.7965e-06,
                    3.7974e-06,
                    3.867e-06,
                    3.9139e-06,
                    3.9282e-06,
                    3.9441e-06,
                    3.9646e-06,
                    3.9815e-06,
                    4.0076e-06,
                    4.0411e-06,
                    4.0792e-06,
                    4.1124e-06,
                    4.1732e-06,
                    4.2044e-06,
                    4.2247e-06,
                    4.2587e-06,
                    4.2872e-06,
                    4.3325e-06,
                    4.4517e-06,
                    4.5231e-06,
                    4.5731e-06,
                    4.6405e-06,
                    4.723e-06,
                    4.876e-06,
                    4.9355e-06,
                    4.973e-06,
                    5.0115e-06,
                    5.188e-06,
                    5.2265e-06,
                    5.2401e-06,
                    5.2415e-06,
                    5.2317e-06,
                    5.2457e-06,
                    5.2429e-06,
                    5.2494e-06,
                    5.2659e-06,
                    5.5651e-06,
                    5.6947e-06,
                    5.7301e-06,
                    5.789e-06,
                    5.8345e-06,
                    5.8682e-06,
                    5.8734e-06,
                    5.8875e-06,
                    5.9326e-06,
                    5.9832e-06
                ],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    2.0944e-08,
                    3.8643e-08,
                    5.5105e-08,
                    7.0912e-08,
                    8.6328e-08,
                    1.0039e-07,
                    1.1661e-07,
                    1.308e-07,
                    1.5143e-07,
                    1.6386e-07,
                    1.7224e-07,
                    1.8488e-07,
                    1.9781e-07,
                    2.1041e-07,
                    2.1748e-07,
                    2.245e-07,
                    2.3164e-07,
                    2.3839e-07,
                    2.4514e-07,
                    2.4838e-07,
                    2.5164e-07,
                    2.5434e-07,
                    2.5743e-07,
                    2.6018e-07,
                    2.6295e-07,
                    2.6612e-07,
                    2.6918e-07,
                    2.6932e-07,
                    2.6929e-07,
                    2.714e-07,
                    2.7969e-07,
                    2.8018e-07,
                    2.7791e-07,
                    2.8012e-07,
                    2.7911e-07,
                    2.7516e-07,
                    2.7136e-07,
                    2.728e-07,
                    2.6886e-07,
                    2.6448e-07,
                    2.7239e-07,
                    2.8159e-07,
                    2.9069e-07,
                    2.95e-07,
                    3.0389e-07,
                    3.0792e-07,
                    3.0226e-07,
                    2.9573e-07,
                    2.8864e-07,
                    2.8068e-07,
                    2.7949e-07,
                    2.7772e-07,
                    2.7617e-07,
                    2.7446e-07,
                    2.7224e-07,
                    2.7013e-07,
                    2.6781e-07,
                    2.6578e-07,
                    2.6357e-07,
                    2.6108e-07,
                    2.5859e-07,
                    2.5618e-07,
                    2.5345e-07,
                    2.5023e-07,
                    2.4711e-07,
                    2.4442e-07,
                    2.4087e-07,
                    2.3787e-07,
                    2.3431e-07,
                    2.3253e-07,
                    2.3055e-07,
                    2.2881e-07,
                    2.2692e-07,
                    2.2467e-07,
                    2.2197e-07,
                    2.1943e-07,
                    2.1686e-07,
                    2.1401e-07,
                    2.1127e-07,
                    2.0376e-07,
                    1.9291e-07,
                    1.7908e-07,
                    1.6182e-07,
                    1.4221e-07,
                    1.1968e-07,
                    9.4661e-08,
                    6.7111e-08,
                    3.723e-08,
                    5.5055e-09,
                    -0.000000022633,
                    -0.000000049153,
                    -0.000000073936,
                    -0.000000097251,
                    -0.0000001191,
                    -0.00000013988,
                    -0.0000001596,
                    -0.00000017827,
                    -0.00000019626,
                    -0.00000021312,
                    -0.00000011208,
                    -0.000000052723,
                    2.0059e-08,
                    9.6586e-08,
                    1.7256e-07,
                    2.2163e-07,
                    3.1117e-07,
                    4.0042e-07,
                    4.8355e-07,
                    5.7026e-07,
                    6.3809e-07,
                    7.1501e-07,
                    8.2343e-07,
                    9.1299e-07,
                    1.049e-06,
                    1.1841e-06,
                    1.3133e-06,
                    1.5323e-06,
                    1.8101e-06,
                    2.0585e-06,
                    2.2734e-06,
                    2.4424e-06,
                    2.7435e-06,
                    3.0392e-06,
                    3.3461e-06,
                    3.6078e-06,
                    3.8903e-06,
                    4.1751e-06,
                    4.4535e-06,
                    4.8131e-06,
                    5.1096e-06,
                    5.3517e-06,
                    5.5761e-06,
                    5.8481e-06,
                    6.1305e-06,
                    6.4477e-06,
                    6.8069e-06,
                    7.2221e-06,
                    7.5992e-06,
                    8.0911e-06,
                    8.7487e-06,
                    9.4285e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_CO2": 0.01,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    9.075e-08,
                    1.5345e-07,
                    2.3265e-07,
                    3.168e-07,
                    4.0095e-07,
                    4.587e-07,
                    5.577e-07,
                    6.567e-07,
                    7.5075e-07,
                    8.514e-07,
                    9.3225e-07,
                    1.0164e-06,
                    1.1303e-06,
                    1.2243e-06,
                    1.3629e-06,
                    1.4998e-06,
                    1.6236e-06,
                    1.848e-06,
                    2.1351e-06,
                    2.3925e-06,
                    2.6169e-06,
                    2.7951e-06,
                    3.1053e-06,
                    3.4105e-06,
                    3.7224e-06,
                    3.988e-06,
                    4.2669e-06,
                    4.5557e-06,
                    4.8394e-06,
                    5.1364e-06,
                    5.4021e-06,
                    5.6463e-06,
                    5.8723e-06,
                    6.1413e-06,
                    6.4235e-06,
                    6.7419e-06,
                    7.1016e-06,
                    7.5207e-06,
                    7.9052e-06,
                    8.3787e-06,
                    9.0371e-06,
                    9.7218e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [
                    2.0944e-08,
                    3.8643e-08,
                    5.5105e-08,
                    7.0912e-08,
                    8.6328e-08,
                    1.0039e-07,
                    1.1661e-07,
                    1.308e-07,
                    1.5143e-07,
                    1.6386e-07,
                    1.7224e-07,
                    1.8488e-07,
                    1.9781e-07,
                    2.1041e-07,
                    2.1748e-07,
                    2.245e-07,
                    2.3164e-07,
                    2.3839e-07,
                    2.4514e-07,
                    2.4838e-07,
                    2.5164e-07,
                    2.5434e-07,
                    2.5743e-07,
                    2.6018e-07,
                    2.6295e-07,
                    2.6612e-07,
                    2.6918e-07,
                    2.6932e-07,
                    2.6929e-07,
                    2.714e-07,
                    2.7969e-07,
                    2.8018e-07,
                    2.7791e-07,
                    2.8012e-07,
                    2.7911e-07,
                    2.7516e-07,
                    2.7136e-07,
                    2.728e-07,
                    2.6886e-07,
                    2.6448e-07,
                    2.7239e-07,
                    2.8159e-07,
                    2.9069e-07,
                    2.95e-07,
                    3.0389e-07,
                    3.0792e-07,
                    3.0226e-07,
                    2.9573e-07,
                    2.8864e-07,
                    2.8068e-07,
                    2.7949e-07,
                    2.7772e-07,
                    2.7617e-07,
                    2.7446e-07,
                    2.7224e-07,
                    2.7013e-07,
                    2.6781e-07,
                    2.6578e-07,
                    2.6357e-07,
                    2.6108e-07,
                    2.5859e-07,
                    2.5618e-07,
                    2.5345e-07,
                    2.5023e-07,
                    2.4711e-07,
                    2.4442e-07,
                    2.4087e-07,
                    2.3787e-07,
                    2.3431e-07,
                    2.3253e-07,
                    2.3055e-07,
                    2.2881e-07,
                    2.2692e-07,
                    2.2467e-07,
                    2.2197e-07,
                    2.1943e-07,
                    2.1686e-07,
                    2.1401e-07,
                    2.1127e-07,
                    2.0376e-07,
                    1.9291e-07,
                    1.7908e-07,
                    1.6182e-07,
                    1.4221e-07,
                    1.1968e-07,
                    9.4661e-08,
                    6.7111e-08,
                    3.723e-08,
                    5.5055e-09,
                    -0.000000022633,
                    -0.000000049153,
                    -0.000000073936,
                    -0.000000097251,
                    -0.0000001191,
                    -0.00000013988,
                    -0.0000001596,
                    -0.00000017827,
                    -0.00000019626,
                    -0.00000021312,
                    -0.00000020283,
                    -0.00000020617,
                    -0.00000021259,
                    -0.00000022021,
                    -0.00000022839,
                    -0.00000023707,
                    -0.00000024653,
                    -0.00000025628,
                    -0.0000002672,
                    -0.00000028114,
                    -0.00000029416,
                    -0.00000030139,
                    -0.00000030682,
                    -0.00000031131,
                    -0.00000031391,
                    -0.00000031572,
                    -0.00000031034,
                    -0.00000031566,
                    -0.00000032497,
                    -0.00000033399,
                    -0.00000034351,
                    -0.00000035274,
                    -0.00000036178,
                    -0.00000037137,
                    -0.00000037633,
                    -0.00000038027,
                    -0.00000037663,
                    -0.00000038053,
                    -0.00000038597,
                    -0.00000032334,
                    -0.00000029252,
                    -0.00000029457,
                    -0.00000029621,
                    -0.00000029316,
                    -0.00000029298,
                    -0.00000029418,
                    -0.00000029471,
                    -0.00000029862,
                    -0.00000030591,
                    -0.00000028759,
                    -0.00000028839,
                    -0.00000029329,
                    -0.0000002896,
                    -0.00000029422,
                    -0.00000029889,
                    -0.0000002956,
                    -0.00000028555,
                    -0.00000028453,
                    -0.00000028604,
                    -0.00000027881,
                    -0.00000019017,
                    -0.00000016033,
                    -0.0000001523,
                    -0.00000014329,
                    1.3959e-08,
                    4.8081e-08,
                    6.7369e-08,
                    7.0669e-08,
                    6.7502e-08,
                    9.1129e-08,
                    9.1894e-08,
                    8.6521e-08,
                    8.283e-08,
                    3.6961e-07,
                    4.7858e-07,
                    5.5612e-07,
                    5.9965e-07,
                    6.3014e-07,
                    6.5243e-07,
                    6.5181e-07,
                    6.6087e-07,
                    6.742e-07,
                    6.8698e-07
                ],
                "Total_CH4": 0.01,
                "Total_CH4_timeseries": [
                    1.9729e-08,
                    4.889e-08,
                    8.5839e-08,
                    1.2974e-07,
                    1.8109e-07,
                    2.3825e-07,
                    3.0306e-07,
                    3.7887e-07,
                    4.7009e-07,
                    5.69e-07,
                    6.717e-07,
                    7.7603e-07,
                    8.8207e-07,
                    9.8939e-07,
                    1.1012e-06,
                    1.214e-06,
                    1.3183e-06,
                    1.4201e-06,
                    1.5213e-06,
                    1.6235e-06,
                    1.7132e-06,
                    1.7965e-06,
                    1.8751e-06,
                    1.9492e-06,
                    2.0186e-06,
                    2.0844e-06,
                    2.1443e-06,
                    2.1956e-06,
                    2.2341e-06,
                    2.2668e-06,
                    2.296e-06,
                    2.3229e-06,
                    2.3476e-06,
                    2.3717e-06,
                    2.3917e-06,
                    2.4099e-06,
                    2.4352e-06,
                    2.4625e-06,
                    2.49e-06,
                    2.5166e-06,
                    2.545e-06,
                    2.5706e-06,
                    2.5923e-06,
                    2.611e-06,
                    2.6271e-06,
                    2.6404e-06,
                    2.6512e-06,
                    2.6598e-06,
                    2.666e-06,
                    2.6701e-06,
                    2.674e-06,
                    2.6783e-06,
                    2.6825e-06,
                    2.6859e-06,
                    2.689e-06,
                    2.6919e-06,
                    2.695e-06,
                    2.6978e-06,
                    2.7001e-06,
                    2.7018e-06,
                    2.7044e-06,
                    2.7076e-06,
                    2.7123e-06,
                    2.7185e-06,
                    2.7249e-06,
                    2.7328e-06,
                    2.7419e-06,
                    2.7519e-06,
                    2.7612e-06,
                    2.7725e-06,
                    2.7856e-06,
                    2.7996e-06,
                    2.8151e-06,
                    2.8322e-06,
                    2.8507e-06,
                    2.8714e-06,
                    2.8938e-06,
                    2.9177e-06,
                    2.9432e-06,
                    2.9708e-06,
                    2.9988e-06,
                    3.0277e-06,
                    3.0579e-06,
                    3.0893e-06,
                    3.1226e-06,
                    3.1582e-06,
                    3.1965e-06,
                    3.2376e-06,
                    3.2829e-06,
                    3.33e-06,
                    3.3796e-06,
                    3.4327e-06,
                    3.4892e-06,
                    3.5491e-06,
                    3.6219e-06,
                    3.7084e-06,
                    3.8092e-06,
                    3.9255e-06,
                    4.0596e-06,
                    4.2097e-06,
                    4.3819e-06,
                    4.574e-06,
                    4.7922e-06,
                    5.0373e-06,
                    5.3105e-06,
                    5.6127e-06,
                    5.9443e-06,
                    6.3063e-06,
                    6.7004e-06,
                    7.1273e-06,
                    7.5734e-06,
                    8.0506e-06,
                    8.5595e-06,
                    9.1085e-06,
                    9.6798e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_CH4": 0.01,
                "Fossil_CH4_timeseries": [
                    1.6022e-08,
                    3.9713e-08,
                    6.9431e-08,
                    1.0434e-07,
                    1.4493e-07,
                    1.8958e-07,
                    2.401e-07,
                    2.9988e-07,
                    3.7329e-07,
                    4.5264e-07,
                    5.3567e-07,
                    6.2024e-07,
                    7.0643e-07,
                    7.938e-07,
                    8.8558e-07,
                    9.7816e-07,
                    1.0623e-06,
                    1.1437e-06,
                    1.2245e-06,
                    1.3062e-06,
                    1.3764e-06,
                    1.4414e-06,
                    1.5027e-06,
                    1.5608e-06,
                    1.6152e-06,
                    1.667e-06,
                    1.7141e-06,
                    1.7537e-06,
                    1.7816e-06,
                    1.8049e-06,
                    1.8245e-06,
                    1.8418e-06,
                    1.857e-06,
                    1.8714e-06,
                    1.8817e-06,
                    1.8901e-06,
                    1.9057e-06,
                    1.9231e-06,
                    1.9407e-06,
                    1.9574e-06,
                    1.9765e-06,
                    1.9932e-06,
                    2.0065e-06,
                    2.0173e-06,
                    2.0262e-06,
                    2.0327e-06,
                    2.0373e-06,
                    2.0401e-06,
                    2.0411e-06,
                    2.0405e-06,
                    2.0399e-06,
                    2.0398e-06,
                    2.0399e-06,
                    2.0393e-06,
                    2.0385e-06,
                    2.0379e-06,
                    2.0374e-06,
                    2.037e-06,
                    2.0361e-06,
                    2.0349e-06,
                    2.0345e-06,
                    2.0345e-06,
                    2.0359e-06,
                    2.0388e-06,
                    2.0417e-06,
                    2.0461e-06,
                    2.0516e-06,
                    2.0578e-06,
                    2.0632e-06,
                    2.0706e-06,
                    2.0794e-06,
                    2.0887e-06,
                    2.099e-06,
                    2.1105e-06,
                    2.1232e-06,
                    2.1376e-06,
                    2.1533e-06,
                    2.1701e-06,
                    2.1881e-06,
                    2.2078e-06,
                    2.2274e-06,
                    2.2474e-06,
                    2.2682e-06,
                    2.2896e-06,
                    2.3123e-06,
                    2.3361e-06,
                    2.3611e-06,
                    2.3876e-06,
                    2.4168e-06,
                    2.4464e-06,
                    2.4773e-06,
                    2.5104e-06,
                    2.5457e-06,
                    2.5831e-06,
                    2.6321e-06,
                    2.6935e-06,
                    2.7679e-06,
                    2.8564e-06,
                    2.9614e-06,
                    3.081e-06,
                    3.2201e-06,
                    3.3762e-06,
                    3.5551e-06,
                    3.7576e-06,
                    3.9847e-06,
                    4.2379e-06,
                    4.5176e-06,
                    4.8246e-06,
                    5.1606e-06,
                    5.5262e-06,
                    5.9222e-06,
                    6.3508e-06,
                    6.8123e-06,
                    7.3092e-06,
                    7.8314e-06,
                    8.3737e-06,
                    8.9377e-06,
                    9.5198e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [
                    3.7076e-09,
                    9.1771e-09,
                    1.6409e-08,
                    2.5402e-08,
                    3.6158e-08,
                    4.8675e-08,
                    6.2954e-08,
                    7.8996e-08,
                    9.6799e-08,
                    1.1636e-07,
                    1.3603e-07,
                    1.5579e-07,
                    1.7564e-07,
                    1.956e-07,
                    2.1565e-07,
                    2.3579e-07,
                    2.5604e-07,
                    2.7638e-07,
                    2.9682e-07,
                    3.1735e-07,
                    3.3678e-07,
                    3.5511e-07,
                    3.7232e-07,
                    3.8844e-07,
                    4.0345e-07,
                    4.1735e-07,
                    4.3015e-07,
                    4.4185e-07,
                    4.5243e-07,
                    4.6192e-07,
                    4.7144e-07,
                    4.8102e-07,
                    4.9063e-07,
                    5.0029e-07,
                    5.0999e-07,
                    5.1974e-07,
                    5.2953e-07,
                    5.3937e-07,
                    5.4925e-07,
                    5.5917e-07,
                    5.6857e-07,
                    5.7745e-07,
                    5.858e-07,
                    5.9363e-07,
                    6.0093e-07,
                    6.0772e-07,
                    6.1398e-07,
                    6.1971e-07,
                    6.2492e-07,
                    6.2961e-07,
                    6.3413e-07,
                    6.3847e-07,
                    6.4263e-07,
                    6.4662e-07,
                    6.5044e-07,
                    6.5408e-07,
                    6.5755e-07,
                    6.6085e-07,
                    6.6397e-07,
                    6.6691e-07,
                    6.6996e-07,
                    6.731e-07,
                    6.7635e-07,
                    6.797e-07,
                    6.8314e-07,
                    6.8669e-07,
                    6.9034e-07,
                    6.9409e-07,
                    6.9794e-07,
                    7.0189e-07,
                    7.0623e-07,
                    7.1096e-07,
                    7.1609e-07,
                    7.2161e-07,
                    7.2753e-07,
                    7.3383e-07,
                    7.4053e-07,
                    7.4762e-07,
                    7.5511e-07,
                    7.6299e-07,
                    7.7139e-07,
                    7.8031e-07,
                    7.8976e-07,
                    7.9973e-07,
                    8.1023e-07,
                    8.2209e-07,
                    8.3535e-07,
                    8.5e-07,
                    8.6608e-07,
                    8.836e-07,
                    9.0234e-07,
                    9.2231e-07,
                    9.4353e-07,
                    9.6603e-07,
                    9.8981e-07,
                    1.0149e-06,
                    1.0413e-06,
                    1.0691e-06,
                    1.0982e-06,
                    1.1287e-06,
                    1.1618e-06,
                    1.1978e-06,
                    1.237e-06,
                    1.2796e-06,
                    1.3258e-06,
                    1.3748e-06,
                    1.4267e-06,
                    1.4816e-06,
                    1.5398e-06,
                    1.6012e-06,
                    1.6512e-06,
                    1.6998e-06,
                    1.7472e-06,
                    1.7993e-06,
                    1.8483e-06,
                    1.8939e-06,
                    1.9395e-06,
                    1.9838e-06,
                    2.0301e-06,
                    2.0781e-06,
                    2.1213e-06,
                    2.1586e-06,
                    2.1853e-06,
                    2.195e-06,
                    2.1929e-06,
                    2.1849e-06,
                    2.1763e-06,
                    2.1455e-06,
                    2.1157e-06,
                    2.0917e-06,
                    2.0703e-06,
                    2.0488e-06,
                    2.0251e-06,
                    2.0001e-06,
                    1.9842e-06,
                    1.9765e-06,
                    1.9691e-06,
                    1.9637e-06,
                    1.9574e-06,
                    1.9413e-06,
                    1.9184e-06,
                    1.8994e-06,
                    1.8859e-06,
                    1.8835e-06,
                    1.945e-06,
                    1.9501e-06,
                    1.9465e-06,
                    1.9626e-06,
                    1.9802e-06,
                    1.9864e-06,
                    1.9716e-06,
                    1.9493e-06,
                    1.9279e-06,
                    1.8973e-06,
                    1.8535e-06,
                    1.8022e-06,
                    1.7511e-06,
                    1.6983e-06,
                    1.6432e-06,
                    1.5969e-06,
                    1.5592e-06,
                    1.5229e-06,
                    1.4864e-06,
                    1.4504e-06,
                    1.3613e-06,
                    1.323e-06,
                    1.2861e-06,
                    1.247e-06,
                    1.2012e-06,
                    1.1594e-06,
                    1.1427e-06,
                    1.132e-06
                ],
                "Total_N2O": 0.01,
                "Total_N2O_timeseries": [
                    7.4374e-09,
                    1.4977e-08,
                    2.2616e-08,
                    3.0352e-08,
                    3.818e-08,
                    4.6094e-08,
                    5.4089e-08,
                    6.2158e-08,
                    7.0293e-08,
                    7.8484e-08,
                    8.6727e-08,
                    9.5019e-08,
                    1.0336e-07,
                    1.1175e-07,
                    1.2018e-07,
                    1.2867e-07,
                    1.372e-07,
                    1.4578e-07,
                    1.5441e-07,
                    1.6309e-07,
                    1.7187e-07,
                    1.8084e-07,
                    1.9004e-07,
                    1.9954e-07,
                    2.0935e-07,
                    2.1947e-07,
                    2.2991e-07,
                    2.4061e-07,
                    2.5154e-07,
                    2.6263e-07,
                    2.7382e-07,
                    2.851e-07,
                    2.9648e-07,
                    3.0794e-07,
                    3.1948e-07,
                    3.3109e-07,
                    3.4278e-07,
                    3.5456e-07,
                    3.6641e-07,
                    3.7862e-07,
                    3.9095e-07,
                    4.0341e-07,
                    4.1598e-07,
                    4.2868e-07,
                    4.4151e-07,
                    4.5448e-07,
                    4.6759e-07,
                    4.8084e-07,
                    4.9423e-07,
                    5.0777e-07,
                    5.2146e-07,
                    5.353e-07,
                    5.4931e-07,
                    5.6348e-07,
                    5.7782e-07,
                    5.9234e-07,
                    6.0704e-07,
                    6.2193e-07,
                    6.3701e-07,
                    6.5229e-07,
                    6.6783e-07,
                    6.8369e-07,
                    6.9995e-07,
                    7.1666e-07,
                    7.3385e-07,
                    7.5157e-07,
                    7.698e-07,
                    7.8855e-07,
                    8.078e-07,
                    8.2752e-07,
                    8.4771e-07,
                    8.6843e-07,
                    8.897e-07,
                    9.1153e-07,
                    9.339e-07,
                    9.5678e-07,
                    9.8012e-07,
                    1.0038e-06,
                    1.0279e-06,
                    1.052e-06,
                    1.0763e-06,
                    1.1005e-06,
                    1.1246e-06,
                    1.1486e-06,
                    1.1724e-06,
                    1.1962e-06,
                    1.2198e-06,
                    1.2434e-06,
                    1.267e-06,
                    1.2907e-06,
                    1.3158e-06,
                    1.3443e-06,
                    1.3777e-06,
                    1.4172e-06,
                    1.4632e-06,
                    1.5157e-06,
                    1.5744e-06,
                    1.6381e-06,
                    1.7054e-06,
                    1.7744e-06,
                    1.8431e-06,
                    1.9108e-06,
                    1.9766e-06,
                    2.04e-06,
                    2.1008e-06,
                    2.159e-06,
                    2.2148e-06,
                    2.2688e-06,
                    2.3216e-06,
                    2.3743e-06,
                    2.43e-06,
                    2.4892e-06,
                    2.5485e-06,
                    2.6058e-06,
                    2.6617e-06,
                    2.7167e-06,
                    2.7742e-06,
                    2.8313e-06,
                    2.8888e-06,
                    2.9461e-06,
                    3.0039e-06,
                    3.0739e-06,
                    3.1368e-06,
                    3.1937e-06,
                    3.2537e-06,
                    3.3117e-06,
                    3.3747e-06,
                    3.4364e-06,
                    3.4976e-06,
                    3.5614e-06,
                    3.6229e-06,
                    3.6844e-06,
                    3.7493e-06,
                    3.8146e-06,
                    3.8805e-06,
                    3.9479e-06,
                    4.0244e-06,
                    4.0987e-06,
                    4.1768e-06,
                    4.2589e-06,
                    4.3411e-06,
                    4.426e-06,
                    4.5091e-06,
                    4.5971e-06,
                    4.6897e-06,
                    4.7829e-06,
                    4.8734e-06,
                    4.9647e-06,
                    5.0595e-06,
                    5.1539e-06,
                    5.2358e-06,
                    5.3239e-06,
                    5.4134e-06,
                    5.503e-06,
                    5.5914e-06,
                    5.6782e-06,
                    5.767e-06,
                    5.8518e-06,
                    5.9362e-06,
                    6.0196e-06,
                    6.1105e-06,
                    6.2081e-06,
                    6.2979e-06,
                    6.3957e-06,
                    6.4852e-06,
                    6.5816e-06,
                    6.6771e-06,
                    6.7706e-06,
                    6.865e-06,
                    6.9527e-06,
                    7.044e-06,
                    7.1365e-06
                ],
                "Fossil_N2O": 0.01,
                "Fossil_N2O_timeseries": [
                    5.1269e-09,
                    1.031e-08,
                    1.5548e-08,
                    2.0842e-08,
                    2.6189e-08,
                    3.159e-08,
                    3.7042e-08,
                    4.2546e-08,
                    4.8098e-08,
                    5.3699e-08,
                    5.9346e-08,
                    6.5039e-08,
                    7.0779e-08,
                    7.6564e-08,
                    8.2396e-08,
                    8.8274e-08,
                    9.4198e-08,
                    1.0017e-07,
                    1.0618e-07,
                    1.1225e-07,
                    1.1837e-07,
                    1.2456e-07,
                    1.3083e-07,
                    1.3719e-07,
                    1.4364e-07,
                    1.5019e-07,
                    1.5684e-07,
                    1.6357e-07,
                    1.7037e-07,
                    1.7725e-07,
                    1.8418e-07,
                    1.9117e-07,
                    1.982e-07,
                    2.053e-07,
                    2.1244e-07,
                    2.1963e-07,
                    2.2688e-07,
                    2.3418e-07,
                    2.4153e-07,
                    2.49e-07,
                    2.5655e-07,
                    2.6417e-07,
                    2.7186e-07,
                    2.7963e-07,
                    2.8747e-07,
                    2.954e-07,
                    3.0341e-07,
                    3.115e-07,
                    3.1967e-07,
                    3.2793e-07,
                    3.3628e-07,
                    3.4473e-07,
                    3.5328e-07,
                    3.6194e-07,
                    3.707e-07,
                    3.7957e-07,
                    3.8854e-07,
                    3.9762e-07,
                    4.0679e-07,
                    4.1605e-07,
                    4.2539e-07,
                    4.3481e-07,
                    4.443e-07,
                    4.5387e-07,
                    4.6351e-07,
                    4.7323e-07,
                    4.8301e-07,
                    4.9287e-07,
                    5.0281e-07,
                    5.1282e-07,
                    5.2291e-07,
                    5.3307e-07,
                    5.4331e-07,
                    5.5363e-07,
                    5.6402e-07,
                    5.745e-07,
                    5.8505e-07,
                    5.9568e-07,
                    6.064e-07,
                    6.1721e-07,
                    6.2811e-07,
                    6.3913e-07,
                    6.5027e-07,
                    6.6154e-07,
                    6.7295e-07,
                    6.845e-07,
                    6.9621e-07,
                    7.0808e-07,
                    7.201e-07,
                    7.3228e-07,
                    7.4464e-07,
                    7.5721e-07,
                    7.7002e-07,
                    7.8308e-07,
                    7.9642e-07,
                    8.1004e-07,
                    8.2395e-07,
                    8.3814e-07,
                    8.5262e-07,
                    8.6735e-07,
                    8.8235e-07,
                    8.9765e-07,
                    9.1327e-07,
                    9.2921e-07,
                    9.4549e-07,
                    9.6209e-07,
                    9.7902e-07,
                    9.9625e-07,
                    1.0137e-06,
                    1.0315e-06,
                    1.0495e-06,
                    1.0677e-06,
                    1.0861e-06,
                    1.1047e-06,
                    1.1235e-06,
                    1.1426e-06,
                    1.1619e-06,
                    1.1815e-06,
                    1.2014e-06,
                    1.2214e-06,
                    1.2414e-06,
                    1.2618e-06,
                    1.2824e-06,
                    1.3043e-06,
                    1.3266e-06,
                    1.3498e-06,
                    1.3741e-06,
                    1.3986e-06,
                    1.4229e-06,
                    1.4466e-06,
                    1.4704e-06,
                    1.4929e-06,
                    1.5166e-06,
                    1.5402e-06,
                    1.5629e-06,
                    1.5886e-06,
                    1.6157e-06,
                    1.6441e-06,
                    1.6735e-06,
                    1.7073e-06,
                    1.7414e-06,
                    1.7771e-06,
                    1.8135e-06,
                    1.8492e-06,
                    1.8874e-06,
                    1.9244e-06,
                    1.9623e-06,
                    2.0008e-06,
                    2.0379e-06,
                    2.0742e-06,
                    2.1115e-06,
                    2.1479e-06,
                    2.1865e-06,
                    2.2262e-06,
                    2.2664e-06,
                    2.3077e-06,
                    2.3473e-06,
                    2.3859e-06,
                    2.4248e-06,
                    2.4655e-06,
                    2.5068e-06,
                    2.5479e-06,
                    2.5889e-06,
                    2.6299e-06,
                    2.6725e-06,
                    2.7152e-06,
                    2.7588e-06,
                    2.8019e-06,
                    2.8446e-06,
                    2.8855e-06,
                    2.9283e-06,
                    2.9723e-06
                ],
                "Land_N2O": 0.01,
                "Land_N2O_timeseries": [
                    2.3104e-09,
                    4.6671e-09,
                    7.068e-09,
                    9.5103e-09,
                    1.1991e-08,
                    1.4505e-08,
                    1.7047e-08,
                    1.9613e-08,
                    2.2195e-08,
                    2.4786e-08,
                    2.7381e-08,
                    2.9979e-08,
                    3.258e-08,
                    3.5183e-08,
                    3.7788e-08,
                    4.0394e-08,
                    4.3001e-08,
                    4.5612e-08,
                    4.8226e-08,
                    5.0844e-08,
                    5.3507e-08,
                    5.6281e-08,
                    5.9217e-08,
                    6.2351e-08,
                    6.5704e-08,
                    6.928e-08,
                    7.3069e-08,
                    7.7046e-08,
                    8.1167e-08,
                    8.5377e-08,
                    8.9637e-08,
                    9.3939e-08,
                    9.8276e-08,
                    1.0264e-07,
                    1.0704e-07,
                    1.1146e-07,
                    1.159e-07,
                    1.2038e-07,
                    1.2488e-07,
                    1.2962e-07,
                    1.3441e-07,
                    1.3924e-07,
                    1.4412e-07,
                    1.4905e-07,
                    1.5404e-07,
                    1.5908e-07,
                    1.6418e-07,
                    1.6934e-07,
                    1.7456e-07,
                    1.7984e-07,
                    1.8518e-07,
                    1.9057e-07,
                    1.9603e-07,
                    2.0155e-07,
                    2.0713e-07,
                    2.1277e-07,
                    2.185e-07,
                    2.2431e-07,
                    2.3022e-07,
                    2.3624e-07,
                    2.4244e-07,
                    2.4888e-07,
                    2.5565e-07,
                    2.6279e-07,
                    2.7034e-07,
                    2.7834e-07,
                    2.8679e-07,
                    2.9568e-07,
                    3.0499e-07,
                    3.147e-07,
                    3.248e-07,
                    3.3535e-07,
                    3.4638e-07,
                    3.5789e-07,
                    3.6987e-07,
                    3.8229e-07,
                    3.9508e-07,
                    4.0817e-07,
                    4.2146e-07,
                    4.3482e-07,
                    4.4815e-07,
                    4.6133e-07,
                    4.7432e-07,
                    4.8704e-07,
                    4.9949e-07,
                    5.1166e-07,
                    5.2358e-07,
                    5.3529e-07,
                    5.4686e-07,
                    5.584e-07,
                    5.7112e-07,
                    5.8705e-07,
                    6.0771e-07,
                    6.3411e-07,
                    6.6677e-07,
                    7.057e-07,
                    7.5043e-07,
                    7.9996e-07,
                    8.5282e-07,
                    9.0701e-07,
                    9.6078e-07,
                    1.0131e-06,
                    1.0633e-06,
                    1.1108e-06,
                    1.1553e-06,
                    1.1969e-06,
                    1.2358e-06,
                    1.2725e-06,
                    1.3079e-06,
                    1.3428e-06,
                    1.3805e-06,
                    1.4216e-06,
                    1.4624e-06,
                    1.5011e-06,
                    1.5382e-06,
                    1.5741e-06,
                    1.6123e-06,
                    1.6498e-06,
                    1.6874e-06,
                    1.7247e-06,
                    1.7625e-06,
                    1.8121e-06,
                    1.8544e-06,
                    1.8894e-06,
                    1.927e-06,
                    1.9619e-06,
                    2.0007e-06,
                    2.0378e-06,
                    2.0747e-06,
                    2.1148e-06,
                    2.1525e-06,
                    2.1915e-06,
                    2.2327e-06,
                    2.2744e-06,
                    2.3176e-06,
                    2.3593e-06,
                    2.4087e-06,
                    2.4547e-06,
                    2.5034e-06,
                    2.5516e-06,
                    2.5996e-06,
                    2.6489e-06,
                    2.6956e-06,
                    2.7479e-06,
                    2.8023e-06,
                    2.8585e-06,
                    2.911e-06,
                    2.964e-06,
                    3.0216e-06,
                    3.0797e-06,
                    3.1242e-06,
                    3.1759e-06,
                    3.2268e-06,
                    3.2767e-06,
                    3.325e-06,
                    3.3705e-06,
                    3.4197e-06,
                    3.4659e-06,
                    3.5114e-06,
                    3.5541e-06,
                    3.6037e-06,
                    3.6601e-06,
                    3.709e-06,
                    3.7657e-06,
                    3.8127e-06,
                    3.8663e-06,
                    3.9183e-06,
                    3.9687e-06,
                    4.0204e-06,
                    4.0673e-06,
                    4.1157e-06,
                    4.1642e-06
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                57.60046,
                                -19.98544
                            ],
                            [
                                57.52393,
                                -20.04978
                            ],
                            [
                                57.497,
                                -20.13671
                            ],
                            [
                                57.43063,
                                -20.17608
                            ],
                            [
                                57.36388,
                                -20.28807
                            ],
                            [
                                57.37557,
                                -20.38994
                            ],
                            [
                                57.35558,
                                -20.48547
                            ],
                            [
                                57.52978,
                                -20.52385
                            ],
                            [
                                57.67381,
                                -20.47853
                            ],
                            [
                                57.72464,
                                -20.43789
                            ],
                            [
                                57.69824,
                                -20.39671
                            ],
                            [
                                57.7746,
                                -20.33716
                            ],
                            [
                                57.80533,
                                -20.23012
                            ],
                            [
                                57.68228,
                                -20.05107
                            ],
                            [
                                57.68229,
                                -20.01107
                            ],
                            [
                                57.60046,
                                -19.98544
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                63.33033,
                                -19.73891
                            ],
                            [
                                63.36002,
                                -19.76384
                            ],
                            [
                                63.46929,
                                -19.7411
                            ],
                            [
                                63.5014,
                                -19.68638
                            ],
                            [
                                63.44151,
                                -19.66896
                            ],
                            [
                                63.33033,
                                -19.73891
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "MEX",
                "Country": "Mexico",
                "Total_3GHG": 1.42,
                "Total_3GHG_timeseries": [
                    9.991e-06,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0054,
                    0.0055,
                    0.0056,
                    0.0058,
                    0.0059,
                    0.0061,
                    0.0062,
                    0.0064,
                    0.0065,
                    0.0067,
                    0.0069,
                    0.0071,
                    0.0073,
                    0.0075,
                    0.0077,
                    0.0079,
                    0.0082,
                    0.0085,
                    0.0088,
                    0.0091,
                    0.0094,
                    0.0097,
                    0.01,
                    0.0103,
                    0.0107,
                    0.011,
                    0.0114,
                    0.0117,
                    0.0121,
                    0.0124,
                    0.0127,
                    0.0131,
                    0.0134,
                    0.0137,
                    0.0141,
                    0.0145,
                    0.0148,
                    0.0152,
                    0.0155,
                    0.0158,
                    0.0162,
                    0.0165,
                    0.0169,
                    0.0173,
                    0.0176,
                    0.018,
                    0.0184,
                    0.0187,
                    0.0191,
                    0.0194,
                    0.0198,
                    0.0202,
                    0.0206,
                    0.021,
                    0.0213,
                    0.0217,
                    0.0221,
                    0.0224,
                    0.0228,
                    0.0233
                ],
                "Fossil_3GHG": 1.43,
                "Fossil_3GHG_timeseries": [
                    6.6099e-07,
                    1.3433e-06,
                    2.047e-06,
                    2.7721e-06,
                    3.5118e-06,
                    4.2839e-06,
                    5.0886e-06,
                    5.9124e-06,
                    6.7553e-06,
                    7.6172e-06,
                    8.4948e-06,
                    9.3881e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0028,
                    0.0029,
                    0.0031,
                    0.0033,
                    0.0035,
                    0.0037,
                    0.0039,
                    0.0041,
                    0.0044,
                    0.0046,
                    0.0048,
                    0.005,
                    0.0053,
                    0.0055,
                    0.0057,
                    0.006,
                    0.0062,
                    0.0065,
                    0.0067,
                    0.007,
                    0.0072,
                    0.0075,
                    0.0078,
                    0.0081,
                    0.0084,
                    0.0087,
                    0.009,
                    0.0093,
                    0.0095,
                    0.0099,
                    0.0102,
                    0.0105,
                    0.0109,
                    0.0112,
                    0.0115,
                    0.0118,
                    0.0122,
                    0.0125,
                    0.0128,
                    0.0131,
                    0.0134,
                    0.0137,
                    0.014,
                    0.0143,
                    0.0145,
                    0.0148,
                    0.0151
                ],
                "Land_3GHG": 1.41,
                "Land_3GHG_timeseries": [
                    9.33e-06,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0048,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0055,
                    0.0056,
                    0.0057,
                    0.0059,
                    0.006,
                    0.0061,
                    0.0062,
                    0.0063,
                    0.0064,
                    0.0064,
                    0.0065,
                    0.0066,
                    0.0066,
                    0.0067,
                    0.0068,
                    0.0068,
                    0.0069,
                    0.0069,
                    0.007,
                    0.007,
                    0.0071,
                    0.0071,
                    0.0071,
                    0.0072,
                    0.0072,
                    0.0072,
                    0.0073,
                    0.0073,
                    0.0074,
                    0.0074,
                    0.0075,
                    0.0076,
                    0.0077,
                    0.0078,
                    0.0079,
                    0.008,
                    0.0081
                ],
                "Total_CO2": 1.23,
                "Total_CO2_timeseries": [
                    7.2338e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.004,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.0051,
                    0.0052,
                    0.0054,
                    0.0056,
                    0.0057,
                    0.0059,
                    0.0061,
                    0.0063,
                    0.0065,
                    0.0067,
                    0.0069,
                    0.0071,
                    0.0073,
                    0.0075,
                    0.0076,
                    0.0078,
                    0.008,
                    0.0082,
                    0.0085,
                    0.0087,
                    0.0089,
                    0.0091,
                    0.0093,
                    0.0095,
                    0.0098,
                    0.01,
                    0.0102,
                    0.0105,
                    0.0107,
                    0.0109,
                    0.0111,
                    0.0113,
                    0.0116,
                    0.0118,
                    0.0121,
                    0.0124,
                    0.0126,
                    0.0129,
                    0.0132,
                    0.0134,
                    0.0137,
                    0.014
                ],
                "Fossil_CO2": 1.23,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2.343e-07,
                    4.95e-07,
                    7.3425e-07,
                    9.768e-07,
                    1.1996e-06,
                    1.4602e-06,
                    1.7704e-06,
                    2.1021e-06,
                    2.442e-06,
                    2.8925e-06,
                    3.4831e-06,
                    4.125e-06,
                    4.8262e-06,
                    5.6001e-06,
                    6.369e-06,
                    7.2336e-06,
                    8.2533e-06,
                    9.9512e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0029,
                    0.003,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0036,
                    0.0037,
                    0.0039,
                    0.0041,
                    0.0042,
                    0.0044,
                    0.0045,
                    0.0047,
                    0.0049,
                    0.0051,
                    0.0053,
                    0.0055,
                    0.0057,
                    0.0059,
                    0.0061,
                    0.0063,
                    0.0065,
                    0.0067,
                    0.0069,
                    0.0071,
                    0.0074,
                    0.0076,
                    0.0078,
                    0.008,
                    0.0082,
                    0.0084,
                    0.0087,
                    0.0089,
                    0.0091,
                    0.0093,
                    0.0095
                ],
                "Land_CO2": 1.25,
                "Land_CO2_timeseries": [
                    7.2338e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.004,
                    0.004,
                    0.004,
                    0.004,
                    0.004,
                    0.004,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0045
                ],
                "Total_CH4": 1.81,
                "Total_CH4_timeseries": [
                    2.5267e-06,
                    5.153e-06,
                    7.8791e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0039,
                    0.004,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.005,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0055,
                    0.0056,
                    0.0057,
                    0.0058,
                    0.0059,
                    0.006,
                    0.0061,
                    0.0062,
                    0.0063,
                    0.0064,
                    0.0065,
                    0.0066,
                    0.0066,
                    0.0067,
                    0.0068,
                    0.0069,
                    0.007,
                    0.0071,
                    0.0072,
                    0.0072,
                    0.0073,
                    0.0073,
                    0.0074,
                    0.0074,
                    0.0075
                ],
                "Fossil_CH4": 1.83,
                "Fossil_CH4_timeseries": [
                    5.0834e-07,
                    1.0362e-06,
                    1.5837e-06,
                    2.1509e-06,
                    2.7311e-06,
                    3.3419e-06,
                    3.9838e-06,
                    4.6433e-06,
                    5.3204e-06,
                    6.0152e-06,
                    6.7244e-06,
                    7.4481e-06,
                    8.2453e-06,
                    9.0515e-06,
                    9.8666e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0045,
                    0.0046,
                    0.0046,
                    0.0046,
                    0.0047,
                    0.0047,
                    0.0047
                ],
                "Land_CH4": 1.77,
                "Land_CH4_timeseries": [
                    2.0183e-06,
                    4.1168e-06,
                    6.2953e-06,
                    8.5539e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028
                ],
                "Total_N2O": 2.11,
                "Total_N2O_timeseries": [
                    2.3056e-07,
                    4.6445e-07,
                    7.016e-07,
                    9.4187e-07,
                    1.1851e-06,
                    1.4311e-06,
                    1.6797e-06,
                    1.9305e-06,
                    2.1833e-06,
                    2.4378e-06,
                    2.6937e-06,
                    2.951e-06,
                    3.2097e-06,
                    3.4697e-06,
                    3.731e-06,
                    3.9937e-06,
                    4.2577e-06,
                    4.523e-06,
                    4.7897e-06,
                    5.058e-06,
                    5.3294e-06,
                    5.6071e-06,
                    5.8934e-06,
                    6.19e-06,
                    6.4976e-06,
                    6.8166e-06,
                    7.1465e-06,
                    7.4861e-06,
                    7.8335e-06,
                    8.1861e-06,
                    8.5423e-06,
                    8.9016e-06,
                    9.2637e-06,
                    9.6285e-06,
                    9.9957e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017
                ],
                "Fossil_N2O": 3.84,
                "Fossil_N2O_timeseries": [
                    1.5265e-07,
                    3.0708e-07,
                    4.6326e-07,
                    6.2117e-07,
                    7.8077e-07,
                    9.42e-07,
                    1.1048e-06,
                    1.2691e-06,
                    1.4349e-06,
                    1.602e-06,
                    1.7704e-06,
                    1.9401e-06,
                    2.1111e-06,
                    2.2833e-06,
                    2.4568e-06,
                    2.6316e-06,
                    2.8076e-06,
                    2.9849e-06,
                    3.1635e-06,
                    3.3435e-06,
                    3.5251e-06,
                    3.7093e-06,
                    3.8966e-06,
                    4.0874e-06,
                    4.282e-06,
                    4.4804e-06,
                    4.6825e-06,
                    4.8881e-06,
                    5.0965e-06,
                    5.3072e-06,
                    5.5197e-06,
                    5.7339e-06,
                    5.9498e-06,
                    6.1673e-06,
                    6.3863e-06,
                    6.6069e-06,
                    6.8291e-06,
                    7.0528e-06,
                    7.2781e-06,
                    7.5071e-06,
                    7.7383e-06,
                    7.9717e-06,
                    8.2074e-06,
                    8.4455e-06,
                    8.6861e-06,
                    8.9291e-06,
                    9.1747e-06,
                    9.423e-06,
                    9.6739e-06,
                    9.9277e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009
                ],
                "Land_N2O": 1.45,
                "Land_N2O_timeseries": [
                    7.791e-08,
                    1.5738e-07,
                    2.3834e-07,
                    3.2069e-07,
                    4.0433e-07,
                    4.8911e-07,
                    5.7485e-07,
                    6.6136e-07,
                    7.4842e-07,
                    8.3579e-07,
                    9.2331e-07,
                    1.0109e-06,
                    1.0986e-06,
                    1.1864e-06,
                    1.2742e-06,
                    1.3621e-06,
                    1.45e-06,
                    1.5381e-06,
                    1.6262e-06,
                    1.7145e-06,
                    1.8043e-06,
                    1.8978e-06,
                    1.9968e-06,
                    2.1025e-06,
                    2.2156e-06,
                    2.3362e-06,
                    2.464e-06,
                    2.598e-06,
                    2.737e-06,
                    2.879e-06,
                    3.0226e-06,
                    3.1677e-06,
                    3.3139e-06,
                    3.4612e-06,
                    3.6094e-06,
                    3.7584e-06,
                    3.9084e-06,
                    4.0592e-06,
                    4.2111e-06,
                    4.4402e-06,
                    4.6726e-06,
                    4.9119e-06,
                    5.1614e-06,
                    5.4239e-06,
                    5.7022e-06,
                    5.9984e-06,
                    6.3142e-06,
                    6.6513e-06,
                    7.0106e-06,
                    7.3928e-06,
                    7.8072e-06,
                    8.2686e-06,
                    8.788e-06,
                    9.3725e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -97.14614,
                                25.95613
                            ],
                            [
                                -97.28521,
                                25.93789
                            ],
                            [
                                -97.37571,
                                25.90117
                            ],
                            [
                                -97.42297,
                                25.83814
                            ],
                            [
                                -97.60687,
                                25.95616
                            ],
                            [
                                -97.66714,
                                26.02864
                            ],
                            [
                                -97.73624,
                                26.0215
                            ],
                            [
                                -97.7998,
                                26.0512
                            ],
                            [
                                -97.98362,
                                26.0547
                            ],
                            [
                                -98.04558,
                                26.03558
                            ],
                            [
                                -98.14074,
                                26.06022
                            ],
                            [
                                -98.20593,
                                26.05469
                            ],
                            [
                                -98.3765,
                                26.15133
                            ],
                            [
                                -98.45215,
                                26.21764
                            ],
                            [
                                -98.56197,
                                26.2275
                            ],
                            [
                                -98.59546,
                                26.25463
                            ],
                            [
                                -98.66365,
                                26.23186
                            ],
                            [
                                -98.6957,
                                26.28392
                            ],
                            [
                                -98.75161,
                                26.29153
                            ],
                            [
                                -98.80548,
                                26.36298
                            ],
                            [
                                -98.89501,
                                26.35371
                            ],
                            [
                                -98.92367,
                                26.37574
                            ],
                            [
                                -99.06117,
                                26.39364
                            ],
                            [
                                -99.11108,
                                26.419
                            ],
                            [
                                -99.09377,
                                26.47773
                            ],
                            [
                                -99.19551,
                                26.62759
                            ],
                            [
                                -99.23562,
                                26.79048
                            ],
                            [
                                -99.30762,
                                26.86411
                            ],
                            [
                                -99.38297,
                                26.97678
                            ],
                            [
                                -99.44981,
                                27.01847
                            ],
                            [
                                -99.42955,
                                27.16399
                            ],
                            [
                                -99.44544,
                                27.24528
                            ],
                            [
                                -99.49734,
                                27.26627
                            ],
                            [
                                -99.50964,
                                27.33187
                            ],
                            [
                                -99.4842,
                                27.4815
                            ],
                            [
                                -99.52631,
                                27.49732
                            ],
                            [
                                -99.51588,
                                27.56352
                            ],
                            [
                                -99.59814,
                                27.63414
                            ],
                            [
                                -99.63955,
                                27.62479
                            ],
                            [
                                -99.72282,
                                27.66348
                            ],
                            [
                                -99.76831,
                                27.72507
                            ],
                            [
                                -99.87317,
                                27.79609
                            ],
                            [
                                -99.89273,
                                27.8939
                            ],
                            [
                                -99.93108,
                                27.97441
                            ],
                            [
                                -99.99297,
                                27.99669
                            ],
                            [
                                -100.01753,
                                28.06385
                            ],
                            [
                                -100.08154,
                                28.14271
                            ],
                            [
                                -100.2002,
                                28.18974
                            ],
                            [
                                -100.28421,
                                28.27454
                            ],
                            [
                                -100.28504,
                                28.31267
                            ],
                            [
                                -100.34177,
                                28.39275
                            ],
                            [
                                -100.33417,
                                28.43439
                            ],
                            [
                                -100.40417,
                                28.54742
                            ],
                            [
                                -100.39661,
                                28.5837
                            ],
                            [
                                -100.49699,
                                28.66612
                            ],
                            [
                                -100.50437,
                                28.74033
                            ],
                            [
                                -100.54394,
                                28.82304
                            ],
                            [
                                -100.63587,
                                28.94109
                            ],
                            [
                                -100.66865,
                                29.09216
                            ],
                            [
                                -100.77061,
                                29.17212
                            ],
                            [
                                -100.79447,
                                29.24094
                            ],
                            [
                                -101.00524,
                                29.36212
                            ],
                            [
                                -101.05666,
                                29.44142
                            ],
                            [
                                -101.25249,
                                29.52529
                            ],
                            [
                                -101.24773,
                                29.61688
                            ],
                            [
                                -101.31225,
                                29.60088
                            ],
                            [
                                -101.37106,
                                29.69337
                            ],
                            [
                                -101.45294,
                                29.78209
                            ],
                            [
                                -101.70635,
                                29.76109
                            ],
                            [
                                -101.85144,
                                29.80243
                            ],
                            [
                                -102.06543,
                                29.78589
                            ],
                            [
                                -102.1758,
                                29.83966
                            ],
                            [
                                -102.31209,
                                29.87722
                            ],
                            [
                                -102.3573,
                                29.84469
                            ],
                            [
                                -102.38579,
                                29.76621
                            ],
                            [
                                -102.50862,
                                29.77978
                            ],
                            [
                                -102.54144,
                                29.74612
                            ],
                            [
                                -102.66993,
                                29.73963
                            ],
                            [
                                -102.79988,
                                29.51892
                            ],
                            [
                                -102.81454,
                                29.3977
                            ],
                            [
                                -102.87834,
                                29.34113
                            ],
                            [
                                -102.90018,
                                29.25759
                            ],
                            [
                                -102.8675,
                                29.22001
                            ],
                            [
                                -102.98673,
                                29.17448
                            ],
                            [
                                -103.07071,
                                29.08819
                            ],
                            [
                                -103.11508,
                                28.99105
                            ],
                            [
                                -103.2443,
                                28.98589
                            ],
                            [
                                -103.42678,
                                29.04263
                            ],
                            [
                                -103.55457,
                                29.15112
                            ],
                            [
                                -103.71776,
                                29.18267
                            ],
                            [
                                -103.78492,
                                29.25872
                            ],
                            [
                                -103.97824,
                                29.29592
                            ],
                            [
                                -104.15912,
                                29.39358
                            ],
                            [
                                -104.20925,
                                29.47794
                            ],
                            [
                                -104.3317,
                                29.52118
                            ],
                            [
                                -104.50772,
                                29.63955
                            ],
                            [
                                -104.56448,
                                29.77282
                            ],
                            [
                                -104.67653,
                                29.92526
                            ],
                            [
                                -104.69915,
                                30.02865
                            ],
                            [
                                -104.68615,
                                30.1709
                            ],
                            [
                                -104.70622,
                                30.23454
                            ],
                            [
                                -104.85281,
                                30.38492
                            ],
                            [
                                -104.86512,
                                30.48749
                            ],
                            [
                                -104.92147,
                                30.59686
                            ],
                            [
                                -104.97349,
                                30.6136
                            ],
                            [
                                -105.00211,
                                30.67788
                            ],
                            [
                                -105.05514,
                                30.684
                            ],
                            [
                                -105.20554,
                                30.79935
                            ],
                            [
                                -105.24684,
                                30.7981
                            ],
                            [
                                -105.38955,
                                30.85294
                            ],
                            [
                                -105.40323,
                                30.89154
                            ],
                            [
                                -105.55414,
                                30.99317
                            ],
                            [
                                -105.60691,
                                31.08779
                            ],
                            [
                                -105.76182,
                                31.16847
                            ],
                            [
                                -105.85232,
                                31.27069
                            ],
                            [
                                -105.93796,
                                31.3187
                            ],
                            [
                                -105.95179,
                                31.35983
                            ],
                            [
                                -106.07293,
                                31.39891
                            ],
                            [
                                -106.2046,
                                31.47036
                            ],
                            [
                                -106.27687,
                                31.56535
                            ],
                            [
                                -106.37955,
                                31.73142
                            ],
                            [
                                -106.48629,
                                31.74961
                            ],
                            [
                                -106.52977,
                                31.77816
                            ],
                            [
                                -107.75588,
                                31.7825
                            ],
                            [
                                -108.20221,
                                31.78308
                            ],
                            [
                                -108.20188,
                                31.36112
                            ],
                            [
                                -108.20823,
                                31.33148
                            ],
                            [
                                -108.709,
                                31.33062
                            ],
                            [
                                -109.30069,
                                31.33401
                            ],
                            [
                                -109.9452,
                                31.33218
                            ],
                            [
                                -110.44012,
                                31.33157
                            ],
                            [
                                -111.06468,
                                31.32883
                            ],
                            [
                                -111.66109,
                                31.51658
                            ],
                            [
                                -112.28707,
                                31.71509
                            ],
                            [
                                -113.16644,
                                31.98799
                            ],
                            [
                                -113.99122,
                                32.23883
                            ],
                            [
                                -114.80514,
                                32.49167
                            ],
                            [
                                -114.80572,
                                32.61035
                            ],
                            [
                                -114.73919,
                                32.66575
                            ],
                            [
                                -114.71719,
                                32.71673
                            ],
                            [
                                -115.35693,
                                32.66833
                            ],
                            [
                                -116.25803,
                                32.60013
                            ],
                            [
                                -117.12358,
                                32.53462
                            ],
                            [
                                -117.11861,
                                32.46789
                            ],
                            [
                                -117.03708,
                                32.28514
                            ],
                            [
                                -116.92168,
                                32.22169
                            ],
                            [
                                -116.88845,
                                32.12607
                            ],
                            [
                                -116.88481,
                                32.03556
                            ],
                            [
                                -116.8383,
                                31.98269
                            ],
                            [
                                -116.77321,
                                31.97203
                            ],
                            [
                                -116.74762,
                                31.90686
                            ],
                            [
                                -116.63036,
                                31.85721
                            ],
                            [
                                -116.61099,
                                31.81975
                            ],
                            [
                                -116.68287,
                                31.57107
                            ],
                            [
                                -116.59977,
                                31.46739
                            ],
                            [
                                -116.52418,
                                31.43371
                            ],
                            [
                                -116.45326,
                                31.33122
                            ],
                            [
                                -116.36175,
                                31.24071
                            ],
                            [
                                -116.31105,
                                31.14532
                            ],
                            [
                                -116.33693,
                                30.98571
                            ],
                            [
                                -116.27106,
                                30.96425
                            ],
                            [
                                -116.17496,
                                30.86459
                            ],
                            [
                                -116.07512,
                                30.81477
                            ],
                            [
                                -116.02861,
                                30.65527
                            ],
                            [
                                -116.04589,
                                30.47492
                            ],
                            [
                                -115.84867,
                                30.3543
                            ],
                            [
                                -115.80327,
                                30.27724
                            ],
                            [
                                -115.80105,
                                30.14192
                            ],
                            [
                                -115.78323,
                                30.0874
                            ],
                            [
                                -115.80719,
                                29.96081
                            ],
                            [
                                -115.70524,
                                29.90248
                            ],
                            [
                                -115.69154,
                                29.75146
                            ],
                            [
                                -115.5844,
                                29.68939
                            ],
                            [
                                -115.50891,
                                29.62172
                            ],
                            [
                                -115.43816,
                                29.61154
                            ],
                            [
                                -115.38068,
                                29.56255
                            ],
                            [
                                -115.25384,
                                29.51481
                            ],
                            [
                                -115.18541,
                                29.43078
                            ],
                            [
                                -115.07396,
                                29.41492
                            ],
                            [
                                -114.94689,
                                29.35592
                            ],
                            [
                                -114.80973,
                                29.21516
                            ],
                            [
                                -114.74573,
                                29.17856
                            ],
                            [
                                -114.70923,
                                29.11037
                            ],
                            [
                                -114.63083,
                                29.09054
                            ],
                            [
                                -114.59063,
                                28.97386
                            ],
                            [
                                -114.48846,
                                28.92893
                            ],
                            [
                                -114.41597,
                                28.8744
                            ],
                            [
                                -114.34076,
                                28.73603
                            ],
                            [
                                -114.26278,
                                28.66262
                            ],
                            [
                                -114.17122,
                                28.64478
                            ],
                            [
                                -114.15398,
                                28.56738
                            ],
                            [
                                -114.10024,
                                28.54672
                            ],
                            [
                                -114.04792,
                                28.46455
                            ],
                            [
                                -114.11923,
                                28.2579
                            ],
                            [
                                -114.06894,
                                28.25613
                            ],
                            [
                                -114.04223,
                                28.16514
                            ],
                            [
                                -114.09714,
                                28.05971
                            ],
                            [
                                -114.04391,
                                28.03927
                            ],
                            [
                                -114.17651,
                                27.81758
                            ],
                            [
                                -114.17928,
                                27.75401
                            ],
                            [
                                -114.10244,
                                27.70932
                            ],
                            [
                                -113.98992,
                                27.75717
                            ],
                            [
                                -113.92188,
                                27.70961
                            ],
                            [
                                -113.96475,
                                27.65887
                            ],
                            [
                                -114.04613,
                                27.65943
                            ],
                            [
                                -114.10007,
                                27.61126
                            ],
                            [
                                -114.1641,
                                27.67167
                            ],
                            [
                                -114.23428,
                                27.69904
                            ],
                            [
                                -114.30913,
                                27.76604
                            ],
                            [
                                -114.29745,
                                27.85911
                            ],
                            [
                                -114.34159,
                                27.8641
                            ],
                            [
                                -114.4983,
                                27.77439
                            ],
                            [
                                -114.60407,
                                27.77475
                            ],
                            [
                                -114.72995,
                                27.80522
                            ],
                            [
                                -114.91571,
                                27.83314
                            ],
                            [
                                -115.05325,
                                27.81798
                            ],
                            [
                                -115.0248,
                                27.74483
                            ],
                            [
                                -114.84744,
                                27.66976
                            ],
                            [
                                -114.73783,
                                27.528
                            ],
                            [
                                -114.60333,
                                27.4781
                            ],
                            [
                                -114.51525,
                                27.41717
                            ],
                            [
                                -114.48921,
                                27.34826
                            ],
                            [
                                -114.48575,
                                27.22972
                            ],
                            [
                                -114.30031,
                                27.13157
                            ],
                            [
                                -114.26104,
                                27.14969
                            ],
                            [
                                -114.16892,
                                27.13261
                            ],
                            [
                                -114.09238,
                                27.0866
                            ],
                            [
                                -114.00636,
                                26.97615
                            ],
                            [
                                -113.94697,
                                26.99818
                            ],
                            [
                                -113.84641,
                                26.9658
                            ],
                            [
                                -113.78298,
                                26.91218
                            ],
                            [
                                -113.73138,
                                26.80258
                            ],
                            [
                                -113.60853,
                                26.7314
                            ],
                            [
                                -113.55338,
                                26.72207
                            ],
                            [
                                -113.45042,
                                26.82974
                            ],
                            [
                                -113.29261,
                                26.75898
                            ],
                            [
                                -113.25235,
                                26.83914
                            ],
                            [
                                -113.20551,
                                26.85648
                            ],
                            [
                                -113.18671,
                                26.96498
                            ],
                            [
                                -113.13177,
                                26.89409
                            ],
                            [
                                -113.19368,
                                26.80782
                            ],
                            [
                                -113.05816,
                                26.64554
                            ],
                            [
                                -113.05284,
                                26.59246
                            ],
                            [
                                -112.72192,
                                26.36415
                            ],
                            [
                                -112.50346,
                                26.23683
                            ],
                            [
                                -112.41179,
                                26.24401
                            ],
                            [
                                -112.34987,
                                26.18253
                            ],
                            [
                                -112.30084,
                                26.06695
                            ],
                            [
                                -112.19258,
                                25.98422
                            ],
                            [
                                -112.06451,
                                25.6476
                            ],
                            [
                                -112.07875,
                                25.24321
                            ],
                            [
                                -112.12671,
                                25.17598
                            ],
                            [
                                -112.13505,
                                25.09339
                            ],
                            [
                                -112.09686,
                                24.9989
                            ],
                            [
                                -112.08451,
                                24.90396
                            ],
                            [
                                -112.10893,
                                24.8894
                            ],
                            [
                                -112.08153,
                                24.7769
                            ],
                            [
                                -111.91897,
                                24.73904
                            ],
                            [
                                -111.78954,
                                24.54824
                            ],
                            [
                                -111.6415,
                                24.53738
                            ],
                            [
                                -111.57571,
                                24.42715
                            ],
                            [
                                -111.49497,
                                24.3871
                            ],
                            [
                                -111.47103,
                                24.34856
                            ],
                            [
                                -111.11213,
                                24.15137
                            ],
                            [
                                -111.0248,
                                24.09464
                            ],
                            [
                                -110.82185,
                                23.9149
                            ],
                            [
                                -110.66345,
                                23.75053
                            ],
                            [
                                -110.5359,
                                23.66331
                            ],
                            [
                                -110.37556,
                                23.59311
                            ],
                            [
                                -110.262,
                                23.47222
                            ],
                            [
                                -110.19527,
                                23.35602
                            ],
                            [
                                -110.11464,
                                23.09718
                            ],
                            [
                                -110.05704,
                                22.94519
                            ],
                            [
                                -109.96846,
                                22.87495
                            ],
                            [
                                -109.84565,
                                22.90362
                            ],
                            [
                                -109.79468,
                                22.96261
                            ],
                            [
                                -109.71948,
                                23.00171
                            ],
                            [
                                -109.66325,
                                23.06137
                            ],
                            [
                                -109.53392,
                                23.11156
                            ],
                            [
                                -109.46006,
                                23.19587
                            ],
                            [
                                -109.4257,
                                23.30926
                            ],
                            [
                                -109.42789,
                                23.45175
                            ],
                            [
                                -109.52536,
                                23.5859
                            ],
                            [
                                -109.67114,
                                23.64354
                            ],
                            [
                                -109.71229,
                                23.73918
                            ],
                            [
                                -109.70313,
                                23.80093
                            ],
                            [
                                -109.8247,
                                23.91277
                            ],
                            [
                                -109.8358,
                                24.05864
                            ],
                            [
                                -109.9266,
                                24.03058
                            ],
                            [
                                -109.98857,
                                24.05605
                            ],
                            [
                                -110.01299,
                                24.16386
                            ],
                            [
                                -110.17346,
                                24.255
                            ],
                            [
                                -110.24728,
                                24.34746
                            ],
                            [
                                -110.32527,
                                24.33364
                            ],
                            [
                                -110.33259,
                                24.28825
                            ],
                            [
                                -110.30411,
                                24.17972
                            ],
                            [
                                -110.39119,
                                24.10221
                            ],
                            [
                                -110.42958,
                                24.17182
                            ],
                            [
                                -110.55674,
                                24.21084
                            ],
                            [
                                -110.61134,
                                24.25828
                            ],
                            [
                                -110.67729,
                                24.35309
                            ],
                            [
                                -110.68777,
                                24.4605
                            ],
                            [
                                -110.72828,
                                24.51617
                            ],
                            [
                                -110.73957,
                                24.61271
                            ],
                            [
                                -110.65904,
                                24.80502
                            ],
                            [
                                -110.68801,
                                24.88495
                            ],
                            [
                                -110.76169,
                                25.01354
                            ],
                            [
                                -110.81615,
                                25.03581
                            ],
                            [
                                -110.90676,
                                25.14574
                            ],
                            [
                                -110.93676,
                                25.29024
                            ],
                            [
                                -110.97852,
                                25.34172
                            ],
                            [
                                -111.02538,
                                25.45699
                            ],
                            [
                                -111.01826,
                                25.51381
                            ],
                            [
                                -111.11345,
                                25.52515
                            ],
                            [
                                -111.19166,
                                25.61168
                            ],
                            [
                                -111.2274,
                                25.72494
                            ],
                            [
                                -111.30581,
                                25.77603
                            ],
                            [
                                -111.35655,
                                25.96317
                            ],
                            [
                                -111.31938,
                                26.07468
                            ],
                            [
                                -111.39575,
                                26.2548
                            ],
                            [
                                -111.39769,
                                26.34053
                            ],
                            [
                                -111.46776,
                                26.41412
                            ],
                            [
                                -111.44574,
                                26.51796
                            ],
                            [
                                -111.56272,
                                26.5581
                            ],
                            [
                                -111.56465,
                                26.69662
                            ],
                            [
                                -111.64623,
                                26.74686
                            ],
                            [
                                -111.81519,
                                26.89411
                            ],
                            [
                                -111.84898,
                                26.87701
                            ],
                            [
                                -111.79406,
                                26.68976
                            ],
                            [
                                -111.68064,
                                26.59422
                            ],
                            [
                                -111.7373,
                                26.54009
                            ],
                            [
                                -111.78077,
                                26.56916
                            ],
                            [
                                -111.86419,
                                26.69315
                            ],
                            [
                                -111.90504,
                                26.71744
                            ],
                            [
                                -111.86369,
                                26.78484
                            ],
                            [
                                -111.87484,
                                26.83045
                            ],
                            [
                                -112.00471,
                                26.95687
                            ],
                            [
                                -111.98522,
                                27.05711
                            ],
                            [
                                -112.01545,
                                27.11795
                            ],
                            [
                                -112.09157,
                                27.13227
                            ],
                            [
                                -112.21176,
                                27.20549
                            ],
                            [
                                -112.20046,
                                27.25174
                            ],
                            [
                                -112.30202,
                                27.38534
                            ],
                            [
                                -112.33079,
                                27.51563
                            ],
                            [
                                -112.37277,
                                27.56312
                            ],
                            [
                                -112.48439,
                                27.61945
                            ],
                            [
                                -112.59318,
                                27.65002
                            ],
                            [
                                -112.70344,
                                27.75605
                            ],
                            [
                                -112.7205,
                                27.82394
                            ],
                            [
                                -112.77019,
                                27.86169
                            ],
                            [
                                -112.76436,
                                27.99907
                            ],
                            [
                                -112.81053,
                                28.14341
                            ],
                            [
                                -112.80142,
                                28.20447
                            ],
                            [
                                -112.87238,
                                28.28393
                            ],
                            [
                                -112.84533,
                                28.42338
                            ],
                            [
                                -112.90174,
                                28.47373
                            ],
                            [
                                -113.00164,
                                28.45518
                            ],
                            [
                                -113.10021,
                                28.50333
                            ],
                            [
                                -113.19333,
                                28.74426
                            ],
                            [
                                -113.19757,
                                28.79227
                            ],
                            [
                                -113.25562,
                                28.83926
                            ],
                            [
                                -113.34597,
                                28.79794
                            ],
                            [
                                -113.37154,
                                28.9045
                            ],
                            [
                                -113.43551,
                                28.95609
                            ],
                            [
                                -113.52567,
                                28.89556
                            ],
                            [
                                -113.55622,
                                28.9476
                            ],
                            [
                                -113.53994,
                                29.05712
                            ],
                            [
                                -113.60881,
                                29.16038
                            ],
                            [
                                -113.64425,
                                29.17893
                            ],
                            [
                                -113.63838,
                                29.28231
                            ],
                            [
                                -113.77371,
                                29.40822
                            ],
                            [
                                -113.89658,
                                29.48575
                            ],
                            [
                                -113.99103,
                                29.57294
                            ],
                            [
                                -114.0452,
                                29.59773
                            ],
                            [
                                -114.2099,
                                29.74255
                            ],
                            [
                                -114.27459,
                                29.7698
                            ],
                            [
                                -114.32896,
                                29.74355
                            ],
                            [
                                -114.38696,
                                29.77951
                            ],
                            [
                                -114.41512,
                                29.89007
                            ],
                            [
                                -114.5345,
                                29.97235
                            ],
                            [
                                -114.6002,
                                30.1003
                            ],
                            [
                                -114.6648,
                                30.19269
                            ],
                            [
                                -114.64259,
                                30.25789
                            ],
                            [
                                -114.63281,
                                30.48933
                            ],
                            [
                                -114.6966,
                                30.63303
                            ],
                            [
                                -114.70555,
                                30.86846
                            ],
                            [
                                -114.72463,
                                30.93686
                            ],
                            [
                                -114.82994,
                                30.99848
                            ],
                            [
                                -114.81823,
                                31.04856
                            ],
                            [
                                -114.86669,
                                31.09168
                            ],
                            [
                                -114.88921,
                                31.15976
                            ],
                            [
                                -114.88681,
                                31.27544
                            ],
                            [
                                -114.8557,
                                31.38587
                            ],
                            [
                                -114.84896,
                                31.5256
                            ],
                            [
                                -114.78551,
                                31.63341
                            ],
                            [
                                -114.81705,
                                31.73855
                            ],
                            [
                                -114.71357,
                                31.68113
                            ],
                            [
                                -114.61741,
                                31.76011
                            ],
                            [
                                -114.55699,
                                31.73546
                            ],
                            [
                                -114.44041,
                                31.64571
                            ],
                            [
                                -114.34224,
                                31.59898
                            ],
                            [
                                -114.28169,
                                31.5486
                            ],
                            [
                                -114.1682,
                                31.49944
                            ],
                            [
                                -114.03148,
                                31.49609
                            ],
                            [
                                -113.98272,
                                31.53807
                            ],
                            [
                                -113.97782,
                                31.62429
                            ],
                            [
                                -113.87004,
                                31.59327
                            ],
                            [
                                -113.6842,
                                31.51516
                            ],
                            [
                                -113.6345,
                                31.46386
                            ],
                            [
                                -113.61092,
                                31.36737
                            ],
                            [
                                -113.62445,
                                31.33123
                            ],
                            [
                                -113.53645,
                                31.29573
                            ],
                            [
                                -113.2168,
                                31.23911
                            ],
                            [
                                -113.1039,
                                31.19921
                            ],
                            [
                                -113.04965,
                                31.09813
                            ],
                            [
                                -113.05423,
                                31.02749
                            ],
                            [
                                -113.09684,
                                30.96346
                            ],
                            [
                                -113.12438,
                                30.81118
                            ],
                            [
                                -113.08058,
                                30.67445
                            ],
                            [
                                -112.99439,
                                30.54543
                            ],
                            [
                                -112.86795,
                                30.41712
                            ],
                            [
                                -112.84717,
                                30.34268
                            ],
                            [
                                -112.85593,
                                30.2715
                            ],
                            [
                                -112.77935,
                                30.2276
                            ],
                            [
                                -112.75457,
                                30.17161
                            ],
                            [
                                -112.75933,
                                30.06467
                            ],
                            [
                                -112.73493,
                                29.99777
                            ],
                            [
                                -112.74237,
                                29.91384
                            ],
                            [
                                -112.66672,
                                29.88968
                            ],
                            [
                                -112.57854,
                                29.71354
                            ],
                            [
                                -112.39098,
                                29.49795
                            ],
                            [
                                -112.38289,
                                29.45043
                            ],
                            [
                                -112.41732,
                                29.37827
                            ],
                            [
                                -112.34479,
                                29.32687
                            ],
                            [
                                -112.28392,
                                29.34173
                            ],
                            [
                                -112.21158,
                                29.25096
                            ],
                            [
                                -112.22484,
                                29.18242
                            ],
                            [
                                -112.16918,
                                29.12107
                            ],
                            [
                                -112.15392,
                                28.97315
                            ],
                            [
                                -112.10364,
                                28.9543
                            ],
                            [
                                -112.02722,
                                28.86197
                            ],
                            [
                                -111.84623,
                                28.79084
                            ],
                            [
                                -111.92114,
                                28.71863
                            ],
                            [
                                -111.77301,
                                28.60333
                            ],
                            [
                                -111.70504,
                                28.45941
                            ],
                            [
                                -111.46254,
                                28.36715
                            ],
                            [
                                -111.4514,
                                28.31292
                            ],
                            [
                                -111.3919,
                                28.26851
                            ],
                            [
                                -111.25293,
                                28.05893
                            ],
                            [
                                -111.09744,
                                27.93998
                            ],
                            [
                                -110.98519,
                                27.96046
                            ],
                            [
                                -110.9474,
                                27.87337
                            ],
                            [
                                -110.88613,
                                27.84573
                            ],
                            [
                                -110.86776,
                                27.9214
                            ],
                            [
                                -110.80402,
                                27.91919
                            ],
                            [
                                -110.56888,
                                27.87973
                            ],
                            [
                                -110.60665,
                                27.77068
                            ],
                            [
                                -110.56274,
                                27.72278
                            ],
                            [
                                -110.61525,
                                27.60906
                            ],
                            [
                                -110.57231,
                                27.53551
                            ],
                            [
                                -110.57042,
                                27.48324
                            ],
                            [
                                -110.5204,
                                27.46436
                            ],
                            [
                                -110.43204,
                                27.26601
                            ],
                            [
                                -110.33133,
                                27.17448
                            ],
                            [
                                -110.06527,
                                27.08867
                            ],
                            [
                                -109.97774,
                                27.1076
                            ],
                            [
                                -109.91468,
                                27.05031
                            ],
                            [
                                -109.89295,
                                26.9264
                            ],
                            [
                                -109.84836,
                                26.79104
                            ],
                            [
                                -109.77636,
                                26.71546
                            ],
                            [
                                -109.69887,
                                26.6817
                            ],
                            [
                                -109.5434,
                                26.6934
                            ],
                            [
                                -109.52452,
                                26.75083
                            ],
                            [
                                -109.44266,
                                26.71044
                            ],
                            [
                                -109.42517,
                                26.66886
                            ],
                            [
                                -109.28944,
                                26.53816
                            ],
                            [
                                -109.23074,
                                26.39839
                            ],
                            [
                                -109.16863,
                                26.3779
                            ],
                            [
                                -109.12786,
                                26.29311
                            ],
                            [
                                -109.12715,
                                26.21409
                            ],
                            [
                                -109.22372,
                                26.26342
                            ],
                            [
                                -109.27831,
                                26.1461
                            ],
                            [
                                -109.31256,
                                26.20002
                            ],
                            [
                                -109.3919,
                                26.07902
                            ],
                            [
                                -109.4395,
                                25.96886
                            ],
                            [
                                -109.4181,
                                25.92944
                            ],
                            [
                                -109.42246,
                                25.83634
                            ],
                            [
                                -109.32544,
                                25.78263
                            ],
                            [
                                -109.2605,
                                25.69849
                            ],
                            [
                                -109.1497,
                                25.67486
                            ],
                            [
                                -109.13623,
                                25.62638
                            ],
                            [
                                -109.04578,
                                25.60042
                            ],
                            [
                                -109.01951,
                                25.65044
                            ],
                            [
                                -108.93489,
                                25.67631
                            ],
                            [
                                -108.92081,
                                25.63197
                            ],
                            [
                                -108.97643,
                                25.58376
                            ],
                            [
                                -109.0779,
                                25.53141
                            ],
                            [
                                -109.04663,
                                25.47928
                            ],
                            [
                                -108.97696,
                                25.50603
                            ],
                            [
                                -108.92645,
                                25.45932
                            ],
                            [
                                -108.86237,
                                25.57219
                            ],
                            [
                                -108.77735,
                                25.54507
                            ],
                            [
                                -108.70576,
                                25.43932
                            ],
                            [
                                -108.62271,
                                25.36728
                            ],
                            [
                                -108.5503,
                                25.34696
                            ],
                            [
                                -108.52846,
                                25.2996
                            ],
                            [
                                -108.37706,
                                25.21869
                            ],
                            [
                                -108.41346,
                                25.29595
                            ],
                            [
                                -108.33212,
                                25.29311
                            ],
                            [
                                -108.32116,
                                25.253
                            ],
                            [
                                -108.15967,
                                25.10774
                            ],
                            [
                                -108.12117,
                                25.11722
                            ],
                            [
                                -108.02573,
                                25.06141
                            ],
                            [
                                -108.03083,
                                25.00082
                            ],
                            [
                                -107.95597,
                                24.98545
                            ],
                            [
                                -107.91818,
                                24.79921
                            ],
                            [
                                -107.93195,
                                24.72415
                            ],
                            [
                                -108.01464,
                                24.68073
                            ],
                            [
                                -107.97556,
                                24.63417
                            ],
                            [
                                -107.85679,
                                24.62687
                            ],
                            [
                                -107.76488,
                                24.58223
                            ],
                            [
                                -107.69378,
                                24.52645
                            ],
                            [
                                -107.53524,
                                24.52401
                            ],
                            [
                                -107.48142,
                                24.39319
                            ],
                            [
                                -107.54915,
                                24.34991
                            ],
                            [
                                -107.42262,
                                24.25298
                            ],
                            [
                                -107.34017,
                                24.2574
                            ],
                            [
                                -107.29045,
                                24.23335
                            ],
                            [
                                -107.27377,
                                24.17464
                            ],
                            [
                                -107.14983,
                                24.11379
                            ],
                            [
                                -107.03835,
                                23.99997
                            ],
                            [
                                -107.04619,
                                23.98312
                            ],
                            [
                                -106.89566,
                                23.84213
                            ],
                            [
                                -106.80042,
                                23.68502
                            ],
                            [
                                -106.80328,
                                23.64957
                            ],
                            [
                                -106.69991,
                                23.57196
                            ],
                            [
                                -106.61951,
                                23.47413
                            ],
                            [
                                -106.52832,
                                23.38932
                            ],
                            [
                                -106.42711,
                                23.19963
                            ],
                            [
                                -106.26829,
                                23.07879
                            ],
                            [
                                -106.16345,
                                22.97904
                            ],
                            [
                                -106.03946,
                                22.83801
                            ],
                            [
                                -105.95072,
                                22.77891
                            ],
                            [
                                -105.82865,
                                22.66135
                            ],
                            [
                                -105.72191,
                                22.49692
                            ],
                            [
                                -105.69158,
                                22.59658
                            ],
                            [
                                -105.77728,
                                22.71799
                            ],
                            [
                                -105.76668,
                                22.77099
                            ],
                            [
                                -105.64707,
                                22.73087
                            ],
                            [
                                -105.61987,
                                22.67777
                            ],
                            [
                                -105.65413,
                                22.60959
                            ],
                            [
                                -105.60217,
                                22.3003
                            ],
                            [
                                -105.55588,
                                22.28421
                            ],
                            [
                                -105.52191,
                                22.22053
                            ],
                            [
                                -105.4697,
                                22.19797
                            ],
                            [
                                -105.39259,
                                22.21062
                            ],
                            [
                                -105.33403,
                                22.17581
                            ],
                            [
                                -105.37517,
                                22.08755
                            ],
                            [
                                -105.42252,
                                22.05418
                            ],
                            [
                                -105.46639,
                                21.97146
                            ],
                            [
                                -105.44382,
                                21.88703
                            ],
                            [
                                -105.48357,
                                21.8068
                            ],
                            [
                                -105.48633,
                                21.72273
                            ],
                            [
                                -105.43016,
                                21.61352
                            ],
                            [
                                -105.26687,
                                21.51515
                            ],
                            [
                                -105.2288,
                                21.52304
                            ],
                            [
                                -105.1891,
                                21.44578
                            ],
                            [
                                -105.24431,
                                21.34865
                            ],
                            [
                                -105.2169,
                                21.20707
                            ],
                            [
                                -105.23083,
                                21.08262
                            ],
                            [
                                -105.39967,
                                20.9311
                            ],
                            [
                                -105.51132,
                                20.77092
                            ],
                            [
                                -105.3098,
                                20.72328
                            ],
                            [
                                -105.23339,
                                20.61955
                            ],
                            [
                                -105.25672,
                                20.56101
                            ],
                            [
                                -105.3197,
                                20.51283
                            ],
                            [
                                -105.55805,
                                20.48641
                            ],
                            [
                                -105.61629,
                                20.46833
                            ],
                            [
                                -105.67309,
                                20.40862
                            ],
                            [
                                -105.65576,
                                20.3183
                            ],
                            [
                                -105.56087,
                                20.23235
                            ],
                            [
                                -105.54688,
                                20.09233
                            ],
                            [
                                -105.48918,
                                19.98689
                            ],
                            [
                                -105.34639,
                                19.80688
                            ],
                            [
                                -105.25754,
                                19.67716
                            ],
                            [
                                -105.09138,
                                19.56211
                            ],
                            [
                                -105.02779,
                                19.386
                            ],
                            [
                                -104.87855,
                                19.2834
                            ],
                            [
                                -104.8172,
                                19.30551
                            ],
                            [
                                -104.77657,
                                19.23831
                            ],
                            [
                                -104.70321,
                                19.22012
                            ],
                            [
                                -104.69655,
                                19.18303
                            ],
                            [
                                -104.49247,
                                19.12517
                            ],
                            [
                                -104.44124,
                                19.091
                            ],
                            [
                                -104.3586,
                                19.11471
                            ],
                            [
                                -104.31447,
                                19.08792
                            ],
                            [
                                -104.33057,
                                19.02061
                            ],
                            [
                                -104.11443,
                                18.94155
                            ],
                            [
                                -103.9721,
                                18.86441
                            ],
                            [
                                -103.80367,
                                18.74895
                            ],
                            [
                                -103.71705,
                                18.66971
                            ],
                            [
                                -103.7056,
                                18.59853
                            ],
                            [
                                -103.58222,
                                18.50372
                            ],
                            [
                                -103.51107,
                                18.34868
                            ],
                            [
                                -103.36151,
                                18.26702
                            ],
                            [
                                -103.3326,
                                18.26802
                            ],
                            [
                                -103.10659,
                                18.19268
                            ],
                            [
                                -102.97899,
                                18.16793
                            ],
                            [
                                -102.79384,
                                18.08604
                            ],
                            [
                                -102.60698,
                                18.0472
                            ],
                            [
                                -102.31047,
                                17.96956
                            ],
                            [
                                -102.19068,
                                17.9176
                            ],
                            [
                                -102.10041,
                                17.97919
                            ],
                            [
                                -102.02106,
                                17.98437
                            ],
                            [
                                -101.94126,
                                17.95648
                            ],
                            [
                                -101.79855,
                                17.87726
                            ],
                            [
                                -101.74091,
                                17.79181
                            ],
                            [
                                -101.6656,
                                17.72989
                            ],
                            [
                                -101.64153,
                                17.66724
                            ],
                            [
                                -101.51149,
                                17.62004
                            ],
                            [
                                -101.44465,
                                17.56092
                            ],
                            [
                                -101.44958,
                                17.52672
                            ],
                            [
                                -101.20466,
                                17.42565
                            ],
                            [
                                -101.06662,
                                17.31439
                            ],
                            [
                                -101.05509,
                                17.26977
                            ],
                            [
                                -100.67903,
                                17.13935
                            ],
                            [
                                -100.42732,
                                17.06132
                            ],
                            [
                                -100.14022,
                                16.95676
                            ],
                            [
                                -100.05194,
                                16.94312
                            ],
                            [
                                -100.00532,
                                16.95874
                            ],
                            [
                                -99.91335,
                                16.83315
                            ],
                            [
                                -99.7037,
                                16.71502
                            ],
                            [
                                -99.60593,
                                16.68538
                            ],
                            [
                                -99.46314,
                                16.68167
                            ],
                            [
                                -99.32783,
                                16.65699
                            ],
                            [
                                -99.06371,
                                16.58839
                            ],
                            [
                                -98.90283,
                                16.53561
                            ],
                            [
                                -98.77945,
                                16.55276
                            ],
                            [
                                -98.55508,
                                16.31876
                            ],
                            [
                                -98.42087,
                                16.27118
                            ],
                            [
                                -98.21016,
                                16.22975
                            ],
                            [
                                -97.97229,
                                16.10635
                            ],
                            [
                                -97.77626,
                                15.98044
                            ],
                            [
                                -97.52366,
                                15.96651
                            ],
                            [
                                -97.42597,
                                15.94354
                            ],
                            [
                                -97.32665,
                                15.94397
                            ],
                            [
                                -97.21913,
                                15.92453
                            ],
                            [
                                -97.06452,
                                15.8559
                            ],
                            [
                                -97.0239,
                                15.81193
                            ],
                            [
                                -96.85408,
                                15.73864
                            ],
                            [
                                -96.71235,
                                15.71784
                            ],
                            [
                                -96.56203,
                                15.66296
                            ],
                            [
                                -96.49686,
                                15.66189
                            ],
                            [
                                -96.42495,
                                15.69302
                            ],
                            [
                                -96.24089,
                                15.68661
                            ],
                            [
                                -96.11991,
                                15.75738
                            ],
                            [
                                -95.95249,
                                15.82826
                            ],
                            [
                                -95.79171,
                                15.87093
                            ],
                            [
                                -95.76064,
                                15.89619
                            ],
                            [
                                -95.66035,
                                15.91544
                            ],
                            [
                                -95.56549,
                                15.95616
                            ],
                            [
                                -95.43872,
                                15.98051
                            ],
                            [
                                -95.37674,
                                16.02174
                            ],
                            [
                                -95.35091,
                                16.07936
                            ],
                            [
                                -95.23446,
                                16.15431
                            ],
                            [
                                -95.13741,
                                16.18691
                            ],
                            [
                                -95.04358,
                                16.18772
                            ],
                            [
                                -94.96615,
                                16.21085
                            ],
                            [
                                -94.69298,
                                16.20873
                            ],
                            [
                                -94.46301,
                                16.17771
                            ],
                            [
                                -94.4106,
                                16.28003
                            ],
                            [
                                -94.20344,
                                16.19038
                            ],
                            [
                                -94.11983,
                                16.20952
                            ],
                            [
                                -94.09511,
                                16.14096
                            ],
                            [
                                -93.99457,
                                16.09928
                            ],
                            [
                                -93.90013,
                                16.08043
                            ],
                            [
                                -93.81884,
                                15.98299
                            ],
                            [
                                -93.8427,
                                15.94931
                            ],
                            [
                                -93.68139,
                                15.85439
                            ],
                            [
                                -93.32666,
                                15.58745
                            ],
                            [
                                -93.15827,
                                15.43994
                            ],
                            [
                                -92.86512,
                                15.16795
                            ],
                            [
                                -92.51636,
                                14.8052
                            ],
                            [
                                -92.23132,
                                14.53332
                            ],
                            [
                                -92.19032,
                                14.56396
                            ],
                            [
                                -92.15158,
                                14.65791
                            ],
                            [
                                -92.14961,
                                14.71545
                            ],
                            [
                                -92.18181,
                                14.83286
                            ],
                            [
                                -92.14159,
                                14.88412
                            ],
                            [
                                -92.14554,
                                14.98333
                            ],
                            [
                                -92.0937,
                                15.01297
                            ],
                            [
                                -92.06157,
                                15.07046
                            ],
                            [
                                -92.21231,
                                15.26436
                            ],
                            [
                                -92.1009,
                                15.44424
                            ],
                            [
                                -91.72529,
                                16.07907
                            ],
                            [
                                -91.07188,
                                16.07393
                            ],
                            [
                                -90.45564,
                                16.06908
                            ],
                            [
                                -90.45016,
                                16.24433
                            ],
                            [
                                -90.39177,
                                16.3722
                            ],
                            [
                                -90.41626,
                                16.41742
                            ],
                            [
                                -90.4808,
                                16.41884
                            ],
                            [
                                -90.54476,
                                16.47478
                            ],
                            [
                                -90.58034,
                                16.46467
                            ],
                            [
                                -90.64236,
                                16.51422
                            ],
                            [
                                -90.65739,
                                16.63515
                            ],
                            [
                                -90.71113,
                                16.7193
                            ],
                            [
                                -90.80135,
                                16.79065
                            ],
                            [
                                -90.91733,
                                16.81494
                            ],
                            [
                                -90.9692,
                                16.8925
                            ],
                            [
                                -91.05879,
                                16.89484
                            ],
                            [
                                -91.17241,
                                17.02051
                            ],
                            [
                                -91.23226,
                                17.10357
                            ],
                            [
                                -91.31688,
                                17.18323
                            ],
                            [
                                -91.34268,
                                17.16883
                            ],
                            [
                                -91.42319,
                                17.25155
                            ],
                            [
                                -90.99194,
                                17.25975
                            ],
                            [
                                -90.98027,
                                17.81483
                            ],
                            [
                                -90.45564,
                                17.81343
                            ],
                            [
                                -89.60937,
                                17.81094
                            ],
                            [
                                -89.14696,
                                17.8095
                            ],
                            [
                                -89.14518,
                                17.94339
                            ],
                            [
                                -89.02756,
                                18.00304
                            ],
                            [
                                -88.91663,
                                17.92154
                            ],
                            [
                                -88.84697,
                                17.92736
                            ],
                            [
                                -88.78058,
                                17.97916
                            ],
                            [
                                -88.75352,
                                18.03559
                            ],
                            [
                                -88.69969,
                                18.06359
                            ],
                            [
                                -88.6523,
                                18.1748
                            ],
                            [
                                -88.5997,
                                18.2493
                            ],
                            [
                                -88.59219,
                                18.30167
                            ],
                            [
                                -88.54588,
                                18.351
                            ],
                            [
                                -88.51196,
                                18.46289
                            ],
                            [
                                -88.47387,
                                18.49406
                            ],
                            [
                                -88.31683,
                                18.4888
                            ],
                            [
                                -88.28108,
                                18.50247
                            ],
                            [
                                -88.23194,
                                18.58736
                            ],
                            [
                                -88.18447,
                                18.70745
                            ],
                            [
                                -88.06911,
                                18.85634
                            ],
                            [
                                -88.01748,
                                18.79559
                            ],
                            [
                                -88.00392,
                                18.66068
                            ],
                            [
                                -88.04078,
                                18.5817
                            ],
                            [
                                -88.06237,
                                18.48034
                            ],
                            [
                                -87.93626,
                                18.43201
                            ],
                            [
                                -87.88284,
                                18.34689
                            ],
                            [
                                -87.89054,
                                18.24312
                            ],
                            [
                                -87.84569,
                                18.22618
                            ],
                            [
                                -87.82373,
                                18.31904
                            ],
                            [
                                -87.76618,
                                18.41555
                            ],
                            [
                                -87.72535,
                                18.66114
                            ],
                            [
                                -87.67345,
                                18.75613
                            ],
                            [
                                -87.62558,
                                18.93875
                            ],
                            [
                                -87.55255,
                                19.08115
                            ],
                            [
                                -87.5391,
                                19.19471
                            ],
                            [
                                -87.4932,
                                19.25854
                            ],
                            [
                                -87.56092,
                                19.28742
                            ],
                            [
                                -87.62583,
                                19.18718
                            ],
                            [
                                -87.68881,
                                19.23491
                            ],
                            [
                                -87.66156,
                                19.34551
                            ],
                            [
                                -87.62031,
                                19.39593
                            ],
                            [
                                -87.4664,
                                19.4715
                            ],
                            [
                                -87.4932,
                                19.53856
                            ],
                            [
                                -87.61118,
                                19.55177
                            ],
                            [
                                -87.64974,
                                19.50776
                            ],
                            [
                                -87.74489,
                                19.59675
                            ],
                            [
                                -87.73828,
                                19.66828
                            ],
                            [
                                -87.6485,
                                19.67959
                            ],
                            [
                                -87.57172,
                                19.79438
                            ],
                            [
                                -87.47408,
                                19.85444
                            ],
                            [
                                -87.46056,
                                19.95206
                            ],
                            [
                                -87.47603,
                                20.0797
                            ],
                            [
                                -87.42434,
                                20.2217
                            ],
                            [
                                -87.36171,
                                20.30208
                            ],
                            [
                                -87.32138,
                                20.3845
                            ],
                            [
                                -87.23339,
                                20.49294
                            ],
                            [
                                -87.09505,
                                20.59914
                            ],
                            [
                                -86.96896,
                                20.72863
                            ],
                            [
                                -86.8789,
                                20.84524
                            ],
                            [
                                -86.81542,
                                21.01616
                            ],
                            [
                                -86.78174,
                                21.0359
                            ],
                            [
                                -86.74678,
                                21.13273
                            ],
                            [
                                -86.80361,
                                21.17172
                            ],
                            [
                                -86.85695,
                                21.25546
                            ],
                            [
                                -86.8918,
                                21.39932
                            ],
                            [
                                -86.9669,
                                21.50149
                            ],
                            [
                                -87.08737,
                                21.57855
                            ],
                            [
                                -87.10782,
                                21.46322
                            ],
                            [
                                -87.19678,
                                21.39869
                            ],
                            [
                                -87.50618,
                                21.48451
                            ],
                            [
                                -87.72809,
                                21.52789
                            ],
                            [
                                -87.83282,
                                21.5597
                            ],
                            [
                                -87.94987,
                                21.5593
                            ],
                            [
                                -88.11936,
                                21.60807
                            ],
                            [
                                -88.19103,
                                21.56794
                            ],
                            [
                                -88.60634,
                                21.47238
                            ],
                            [
                                -88.72179,
                                21.3996
                            ],
                            [
                                -88.88065,
                                21.39531
                            ],
                            [
                                -89.11084,
                                21.35891
                            ],
                            [
                                -89.3189,
                                21.34038
                            ],
                            [
                                -89.53686,
                                21.30999
                            ],
                            [
                                -89.68175,
                                21.27458
                            ],
                            [
                                -89.69647,
                                21.23442
                            ],
                            [
                                -89.83141,
                                21.22242
                            ],
                            [
                                -90.00018,
                                21.15058
                            ],
                            [
                                -90.05812,
                                21.1427
                            ],
                            [
                                -90.19018,
                                21.08188
                            ],
                            [
                                -90.31299,
                                20.97468
                            ],
                            [
                                -90.43366,
                                20.72021
                            ],
                            [
                                -90.44411,
                                20.6114
                            ],
                            [
                                -90.48786,
                                20.49253
                            ],
                            [
                                -90.47037,
                                20.42134
                            ],
                            [
                                -90.48166,
                                20.32633
                            ],
                            [
                                -90.47402,
                                20.19859
                            ],
                            [
                                -90.48284,
                                20.06616
                            ],
                            [
                                -90.45186,
                                19.94804
                            ],
                            [
                                -90.49401,
                                19.87636
                            ],
                            [
                                -90.65647,
                                19.76081
                            ],
                            [
                                -90.70228,
                                19.67675
                            ],
                            [
                                -90.70521,
                                19.47535
                            ],
                            [
                                -90.72686,
                                19.3563
                            ],
                            [
                                -90.76187,
                                19.30534
                            ],
                            [
                                -90.90414,
                                19.18088
                            ],
                            [
                                -91.07304,
                                19.07157
                            ],
                            [
                                -91.3379,
                                18.88362
                            ],
                            [
                                -91.33951,
                                18.80402
                            ],
                            [
                                -91.284,
                                18.79557
                            ],
                            [
                                -91.22258,
                                18.75137
                            ],
                            [
                                -91.26494,
                                18.66761
                            ],
                            [
                                -91.24446,
                                18.61508
                            ],
                            [
                                -91.33641,
                                18.53714
                            ],
                            [
                                -91.45524,
                                18.50627
                            ],
                            [
                                -91.47078,
                                18.44982
                            ],
                            [
                                -91.59181,
                                18.44316
                            ],
                            [
                                -91.72182,
                                18.46949
                            ],
                            [
                                -91.78724,
                                18.37942
                            ],
                            [
                                -91.82794,
                                18.42955
                            ],
                            [
                                -91.80407,
                                18.49358
                            ],
                            [
                                -91.9598,
                                18.57289
                            ],
                            [
                                -91.97758,
                                18.51581
                            ],
                            [
                                -92.02838,
                                18.53084
                            ],
                            [
                                -91.99537,
                                18.594
                            ],
                            [
                                -91.86533,
                                18.61081
                            ],
                            [
                                -91.96011,
                                18.69318
                            ],
                            [
                                -91.99824,
                                18.69739
                            ],
                            [
                                -92.39135,
                                18.66506
                            ],
                            [
                                -92.62309,
                                18.61557
                            ],
                            [
                                -92.68296,
                                18.61307
                            ],
                            [
                                -92.74186,
                                18.53659
                            ],
                            [
                                -92.8347,
                                18.4668
                            ],
                            [
                                -92.90138,
                                18.44332
                            ],
                            [
                                -93.01455,
                                18.43232
                            ],
                            [
                                -93.11135,
                                18.44264
                            ],
                            [
                                -93.39403,
                                18.43283
                            ],
                            [
                                -93.61781,
                                18.38127
                            ],
                            [
                                -93.85895,
                                18.29657
                            ],
                            [
                                -94.12576,
                                18.21506
                            ],
                            [
                                -94.29795,
                                18.17507
                            ],
                            [
                                -94.46986,
                                18.15179
                            ],
                            [
                                -94.54995,
                                18.16621
                            ],
                            [
                                -94.61353,
                                18.22248
                            ],
                            [
                                -94.62964,
                                18.28809
                            ],
                            [
                                -94.73291,
                                18.39336
                            ],
                            [
                                -94.79288,
                                18.51228
                            ],
                            [
                                -94.84892,
                                18.54448
                            ],
                            [
                                -95.03435,
                                18.57501
                            ],
                            [
                                -95.08368,
                                18.63905
                            ],
                            [
                                -95.18895,
                                18.70478
                            ],
                            [
                                -95.29491,
                                18.71427
                            ],
                            [
                                -95.46908,
                                18.71177
                            ],
                            [
                                -95.65754,
                                18.74049
                            ],
                            [
                                -95.86773,
                                18.83699
                            ],
                            [
                                -95.93847,
                                18.90484
                            ],
                            [
                                -95.9694,
                                19.03955
                            ],
                            [
                                -96.08403,
                                19.08052
                            ],
                            [
                                -96.12979,
                                19.21451
                            ],
                            [
                                -96.2771,
                                19.30186
                            ],
                            [
                                -96.31954,
                                19.41352
                            ],
                            [
                                -96.3127,
                                19.47099
                            ],
                            [
                                -96.37274,
                                19.56239
                            ],
                            [
                                -96.40631,
                                19.73721
                            ],
                            [
                                -96.45267,
                                19.84866
                            ],
                            [
                                -96.54688,
                                19.94908
                            ],
                            [
                                -96.58328,
                                20.0128
                            ],
                            [
                                -96.71807,
                                20.17293
                            ],
                            [
                                -96.92582,
                                20.38434
                            ],
                            [
                                -96.99244,
                                20.4679
                            ],
                            [
                                -97.13571,
                                20.60609
                            ],
                            [
                                -97.17596,
                                20.66243
                            ],
                            [
                                -97.23041,
                                20.83071
                            ],
                            [
                                -97.29871,
                                20.95066
                            ],
                            [
                                -97.40447,
                                21.18408
                            ],
                            [
                                -97.41218,
                                21.32684
                            ],
                            [
                                -97.33333,
                                21.50896
                            ],
                            [
                                -97.33438,
                                21.56947
                            ],
                            [
                                -97.5474,
                                21.75403
                            ],
                            [
                                -97.47172,
                                21.61342
                            ],
                            [
                                -97.40456,
                                21.56008
                            ],
                            [
                                -97.38237,
                                21.47569
                            ],
                            [
                                -97.4421,
                                21.36406
                            ],
                            [
                                -97.48958,
                                21.35083
                            ],
                            [
                                -97.51493,
                                21.4675
                            ],
                            [
                                -97.57949,
                                21.47804
                            ],
                            [
                                -97.67962,
                                21.66605
                            ],
                            [
                                -97.71851,
                                21.826
                            ],
                            [
                                -97.70676,
                                21.88652
                            ],
                            [
                                -97.79069,
                                22.20145
                            ],
                            [
                                -97.78997,
                                22.26841
                            ],
                            [
                                -97.82867,
                                22.35105
                            ],
                            [
                                -97.89023,
                                22.64412
                            ],
                            [
                                -97.80005,
                                22.79332
                            ],
                            [
                                -97.77174,
                                22.88415
                            ],
                            [
                                -97.76135,
                                23.01135
                            ],
                            [
                                -97.7693,
                                23.34654
                            ],
                            [
                                -97.73564,
                                23.77959
                            ],
                            [
                                -97.76871,
                                23.80078
                            ],
                            [
                                -97.77465,
                                24.04969
                            ],
                            [
                                -97.74904,
                                24.27601
                            ],
                            [
                                -97.75431,
                                24.42405
                            ],
                            [
                                -97.70967,
                                24.65533
                            ],
                            [
                                -97.74184,
                                24.83538
                            ],
                            [
                                -97.64676,
                                24.90821
                            ],
                            [
                                -97.7414,
                                24.99456
                            ],
                            [
                                -97.67557,
                                25.16829
                            ],
                            [
                                -97.68211,
                                25.22723
                            ],
                            [
                                -97.53284,
                                25.3025
                            ],
                            [
                                -97.54935,
                                25.3398
                            ],
                            [
                                -97.47436,
                                25.42047
                            ],
                            [
                                -97.36929,
                                25.34416
                            ],
                            [
                                -97.20249,
                                25.6302
                            ],
                            [
                                -97.16899,
                                25.72424
                            ],
                            [
                                -97.14614,
                                25.95613
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -112.36037,
                                29.21969
                            ],
                            [
                                -112.47709,
                                29.16655
                            ],
                            [
                                -112.50538,
                                29.01353
                            ],
                            [
                                -112.49239,
                                28.94597
                            ],
                            [
                                -112.58246,
                                28.87663
                            ],
                            [
                                -112.30822,
                                28.74815
                            ],
                            [
                                -112.23949,
                                28.87214
                            ],
                            [
                                -112.20195,
                                29.02412
                            ],
                            [
                                -112.27326,
                                29.13654
                            ],
                            [
                                -112.27017,
                                29.19696
                            ],
                            [
                                -112.36037,
                                29.21969
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -113.52801,
                                29.54186
                            ],
                            [
                                -113.59159,
                                29.45075
                            ],
                            [
                                -113.50735,
                                29.32308
                            ],
                            [
                                -113.44928,
                                29.2794
                            ],
                            [
                                -113.40089,
                                29.20768
                            ],
                            [
                                -113.30092,
                                29.14465
                            ],
                            [
                                -113.24374,
                                29.06755
                            ],
                            [
                                -113.12282,
                                28.98857
                            ],
                            [
                                -113.10383,
                                29.05283
                            ],
                            [
                                -113.14968,
                                29.06838
                            ],
                            [
                                -113.17412,
                                29.12811
                            ],
                            [
                                -113.18376,
                                29.28838
                            ],
                            [
                                -113.34545,
                                29.29621
                            ],
                            [
                                -113.35364,
                                29.38444
                            ],
                            [
                                -113.39445,
                                29.4579
                            ],
                            [
                                -113.47761,
                                29.5301
                            ],
                            [
                                -113.52801,
                                29.54186
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -86.73315,
                                20.56389
                            ],
                            [
                                -86.80684,
                                20.53923
                            ],
                            [
                                -86.92541,
                                20.55135
                            ],
                            [
                                -87.01588,
                                20.41383
                            ],
                            [
                                -87.0208,
                                20.3403
                            ],
                            [
                                -86.9742,
                                20.28087
                            ],
                            [
                                -86.89752,
                                20.34665
                            ],
                            [
                                -86.76275,
                                20.50904
                            ],
                            [
                                -86.73315,
                                20.56389
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -115.18614,
                                28.10255
                            ],
                            [
                                -115.15915,
                                28.13906
                            ],
                            [
                                -115.16491,
                                28.25942
                            ],
                            [
                                -115.19428,
                                28.35478
                            ],
                            [
                                -115.28063,
                                28.35314
                            ],
                            [
                                -115.23885,
                                28.23028
                            ],
                            [
                                -115.32195,
                                28.13294
                            ],
                            [
                                -115.25206,
                                28.03584
                            ],
                            [
                                -115.1822,
                                28.04112
                            ],
                            [
                                -115.18614,
                                28.10255
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -118.27078,
                                29.17124
                            ],
                            [
                                -118.36484,
                                29.14631
                            ],
                            [
                                -118.36352,
                                29.07411
                            ],
                            [
                                -118.31748,
                                29.03849
                            ],
                            [
                                -118.2608,
                                28.88406
                            ],
                            [
                                -118.22051,
                                28.96365
                            ],
                            [
                                -118.22979,
                                29.06523
                            ],
                            [
                                -118.27967,
                                29.10473
                            ],
                            [
                                -118.27078,
                                29.17124
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -112.00507,
                                24.51433
                            ],
                            [
                                -111.94065,
                                24.48403
                            ],
                            [
                                -111.74913,
                                24.35069
                            ],
                            [
                                -111.75003,
                                24.44097
                            ],
                            [
                                -111.81736,
                                24.46709
                            ],
                            [
                                -111.86521,
                                24.5197
                            ],
                            [
                                -112.00507,
                                24.51433
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -105.64319,
                                22.17639
                            ],
                            [
                                -105.65316,
                                22.03404
                            ],
                            [
                                -105.62852,
                                21.9591
                            ],
                            [
                                -105.55778,
                                21.85184
                            ],
                            [
                                -105.50512,
                                21.89651
                            ],
                            [
                                -105.55413,
                                21.9929
                            ],
                            [
                                -105.60851,
                                22.00842
                            ],
                            [
                                -105.64319,
                                22.17639
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -110.53423,
                                24.87603
                            ],
                            [
                                -110.57619,
                                25.01526
                            ],
                            [
                                -110.66603,
                                25.0518
                            ],
                            [
                                -110.65418,
                                24.94846
                            ],
                            [
                                -110.53423,
                                24.87603
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -111.07299,
                                26.06653
                            ],
                            [
                                -111.17532,
                                26.04198
                            ],
                            [
                                -111.16755,
                                25.98894
                            ],
                            [
                                -111.0838,
                                26.02017
                            ],
                            [
                                -111.07299,
                                26.06653
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -106.66039,
                                21.69308
                            ],
                            [
                                -106.62902,
                                21.59912
                            ],
                            [
                                -106.52106,
                                21.56111
                            ],
                            [
                                -106.53488,
                                21.65694
                            ],
                            [
                                -106.66039,
                                21.69308
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -109.83592,
                                24.2213
                            ],
                            [
                                -109.88723,
                                24.31007
                            ],
                            [
                                -109.93718,
                                24.32468
                            ],
                            [
                                -109.89904,
                                24.19986
                            ],
                            [
                                -109.86321,
                                24.14791
                            ],
                            [
                                -109.79909,
                                24.15589
                            ],
                            [
                                -109.83592,
                                24.2213
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -110.99336,
                                18.85969
                            ],
                            [
                                -111.04313,
                                18.81383
                            ],
                            [
                                -111.01716,
                                18.75614
                            ],
                            [
                                -110.91969,
                                18.73268
                            ],
                            [
                                -110.91615,
                                18.79759
                            ],
                            [
                                -110.99336,
                                18.85969
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -105.66809,
                                22.47085
                            ],
                            [
                                -105.72208,
                                22.46294
                            ],
                            [
                                -105.66097,
                                22.28435
                            ],
                            [
                                -105.65408,
                                22.44742
                            ],
                            [
                                -105.66809,
                                22.47085
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -108.11584,
                                25.0171
                            ],
                            [
                                -108.12346,
                                24.96651
                            ],
                            [
                                -108.06866,
                                24.82988
                            ],
                            [
                                -108.04242,
                                24.85039
                            ],
                            [
                                -108.06158,
                                24.97858
                            ],
                            [
                                -108.11584,
                                25.0171
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -110.30354,
                                24.4854
                            ],
                            [
                                -110.35974,
                                24.53258
                            ],
                            [
                                -110.38581,
                                24.47633
                            ],
                            [
                                -110.32618,
                                24.40477
                            ],
                            [
                                -110.30354,
                                24.4854
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -108.33776,
                                25.1188
                            ],
                            [
                                -108.21921,
                                25.00852
                            ],
                            [
                                -108.14125,
                                24.88061
                            ],
                            [
                                -108.11361,
                                24.89452
                            ],
                            [
                                -108.2756,
                                25.09066
                            ],
                            [
                                -108.33776,
                                25.1188
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -106.48372,
                                21.47889
                            ],
                            [
                                -106.38882,
                                21.41945
                            ],
                            [
                                -106.37312,
                                21.4821
                            ],
                            [
                                -106.48372,
                                21.47889
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "FSM",
                "Country": "Micronesia",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    3.3935e-08,
                    6.8186e-08,
                    1.0275e-07,
                    1.3762e-07,
                    1.7279e-07,
                    2.0824e-07,
                    2.4399e-07,
                    2.8003e-07,
                    3.1634e-07,
                    3.5294e-07,
                    3.8979e-07,
                    4.269e-07,
                    4.6426e-07,
                    5.0185e-07,
                    5.3968e-07,
                    5.7773e-07,
                    6.1598e-07,
                    6.5443e-07,
                    6.9307e-07,
                    7.3189e-07,
                    7.7087e-07,
                    8.1001e-07,
                    8.493e-07,
                    8.8873e-07,
                    9.2829e-07,
                    9.6798e-07,
                    1.0078e-06,
                    1.0477e-06,
                    1.0876e-06,
                    1.1277e-06,
                    1.1677e-06,
                    1.2079e-06,
                    1.248e-06,
                    1.2882e-06,
                    1.3285e-06,
                    1.3687e-06,
                    1.4089e-06,
                    1.4492e-06,
                    1.4894e-06,
                    1.5296e-06,
                    1.5698e-06,
                    1.6099e-06,
                    1.65e-06,
                    1.69e-06,
                    1.73e-06,
                    1.7699e-06,
                    1.8097e-06,
                    1.8495e-06,
                    1.8891e-06,
                    1.9286e-06,
                    1.9681e-06,
                    2.0074e-06,
                    2.0467e-06,
                    2.0857e-06,
                    2.1247e-06,
                    2.1635e-06,
                    2.2022e-06,
                    2.2407e-06,
                    2.279e-06,
                    2.3171e-06,
                    2.3551e-06,
                    2.3929e-06,
                    2.4305e-06,
                    2.4678e-06,
                    2.505e-06,
                    2.5419e-06,
                    2.5787e-06,
                    2.6151e-06,
                    2.6514e-06,
                    2.6874e-06,
                    2.7231e-06,
                    2.7586e-06,
                    2.7938e-06,
                    2.8287e-06,
                    2.8633e-06,
                    2.8976e-06,
                    2.9317e-06,
                    2.9654e-06,
                    2.9988e-06,
                    3.0319e-06,
                    3.0646e-06,
                    3.097e-06,
                    3.129e-06,
                    3.1607e-06,
                    3.1931e-06,
                    3.2254e-06,
                    3.2568e-06,
                    3.2877e-06,
                    3.3176e-06,
                    3.3465e-06,
                    3.3742e-06,
                    3.4006e-06,
                    3.4256e-06,
                    3.4489e-06,
                    3.4703e-06,
                    3.4896e-06,
                    3.5066e-06,
                    3.5213e-06,
                    3.5334e-06,
                    3.5426e-06,
                    3.5495e-06,
                    3.5534e-06,
                    3.5545e-06,
                    3.5526e-06,
                    3.548e-06,
                    3.5406e-06,
                    3.5302e-06,
                    3.5173e-06,
                    3.5017e-06,
                    3.4837e-06,
                    3.463e-06,
                    3.4399e-06,
                    3.4142e-06,
                    3.3859e-06,
                    3.3556e-06,
                    3.3229e-06,
                    3.2884e-06,
                    3.252e-06,
                    3.2136e-06,
                    3.1735e-06,
                    3.132e-06,
                    3.0886e-06,
                    3.0432e-06,
                    2.9967e-06,
                    2.9489e-06,
                    2.9001e-06,
                    2.8499e-06,
                    2.7989e-06,
                    2.7473e-06,
                    2.6953e-06,
                    2.6431e-06,
                    2.5913e-06,
                    2.5397e-06,
                    2.4887e-06,
                    2.4387e-06,
                    2.39e-06,
                    2.3433e-06,
                    2.2993e-06,
                    2.2582e-06,
                    2.2197e-06,
                    2.184e-06,
                    2.2119e-06,
                    2.2454e-06,
                    2.2855e-06,
                    2.429e-06,
                    2.5756e-06,
                    2.7284e-06,
                    2.8852e-06,
                    3.038e-06,
                    3.1864e-06,
                    3.3287e-06,
                    3.465e-06,
                    3.6069e-06,
                    3.7407e-06,
                    3.863e-06,
                    3.9836e-06,
                    4.1134e-06,
                    4.2325e-06,
                    4.3717e-06,
                    4.4905e-06,
                    4.6185e-06,
                    4.7461e-06,
                    4.8807e-06,
                    5.0167e-06,
                    5.078e-06,
                    5.1412e-06,
                    5.2029e-06,
                    5.2658e-06,
                    5.3326e-06,
                    5.4016e-06,
                    5.4766e-06,
                    5.5526e-06
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    2.8485e-10,
                    5.7128e-10,
                    8.5928e-10,
                    1.1489e-09,
                    1.44e-09,
                    1.7327e-09,
                    2.027e-09,
                    2.3229e-09,
                    2.6203e-09,
                    2.9194e-09,
                    3.2161e-09,
                    3.5105e-09,
                    3.8025e-09,
                    4.0923e-09,
                    4.3798e-09,
                    4.6649e-09,
                    4.9477e-09,
                    5.2283e-09,
                    5.5065e-09,
                    5.7824e-09,
                    6.0557e-09,
                    6.3264e-09,
                    6.5946e-09,
                    6.8602e-09,
                    7.1232e-09,
                    7.3836e-09,
                    7.6415e-09,
                    7.8968e-09,
                    8.1495e-09,
                    8.3996e-09,
                    8.6506e-09,
                    8.9024e-09,
                    9.1551e-09,
                    9.4087e-09,
                    9.6631e-09,
                    9.9184e-09,
                    1.0175e-08,
                    1.0432e-08,
                    1.0689e-08,
                    1.0948e-08,
                    1.1208e-08,
                    1.1468e-08,
                    1.173e-08,
                    1.1992e-08,
                    1.2255e-08,
                    1.2519e-08,
                    1.2784e-08,
                    1.305e-08,
                    1.3317e-08,
                    1.3585e-08,
                    1.3853e-08,
                    1.4123e-08,
                    1.4393e-08,
                    1.4665e-08,
                    1.4937e-08,
                    1.521e-08,
                    1.5484e-08,
                    1.5759e-08,
                    1.6035e-08,
                    1.6312e-08,
                    1.6588e-08,
                    1.6863e-08,
                    1.7137e-08,
                    1.741e-08,
                    1.7681e-08,
                    1.7952e-08,
                    1.8222e-08,
                    1.8491e-08,
                    1.8758e-08,
                    1.9025e-08,
                    1.9291e-08,
                    1.9555e-08,
                    1.9819e-08,
                    2.0081e-08,
                    2.0342e-08,
                    2.0602e-08,
                    2.0861e-08,
                    2.1119e-08,
                    2.1376e-08,
                    2.1631e-08,
                    2.1888e-08,
                    2.2144e-08,
                    2.2402e-08,
                    2.266e-08,
                    2.2919e-08,
                    2.3179e-08,
                    2.3439e-08,
                    2.37e-08,
                    2.3961e-08,
                    2.4224e-08,
                    2.4591e-08,
                    2.5059e-08,
                    2.5623e-08,
                    2.6279e-08,
                    2.6961e-08,
                    2.766e-08,
                    2.8368e-08,
                    2.9079e-08,
                    2.9784e-08,
                    3.0477e-08,
                    3.1328e-08,
                    3.2316e-08,
                    3.3429e-08,
                    3.4659e-08,
                    3.6005e-08,
                    3.747e-08,
                    3.9055e-08,
                    4.076e-08,
                    4.2582e-08,
                    4.4514e-08,
                    4.645e-08,
                    4.8385e-08,
                    5.0319e-08,
                    5.2255e-08,
                    5.4256e-08,
                    5.6336e-08,
                    5.8499e-08,
                    6.0734e-08,
                    6.3002e-08,
                    6.5562e-08,
                    6.8029e-08,
                    7.038e-08,
                    7.2612e-08,
                    7.4744e-08,
                    7.6821e-08,
                    7.8889e-08,
                    8.0988e-08,
                    8.3153e-08,
                    8.5405e-08,
                    8.7756e-08,
                    9.0222e-08,
                    9.2818e-08,
                    9.555e-08,
                    9.8414e-08,
                    1.014e-07,
                    1.0449e-07,
                    1.0766e-07,
                    1.1093e-07,
                    1.1434e-07,
                    1.1751e-07,
                    1.21e-07,
                    1.857e-07,
                    2.5389e-07,
                    3.2719e-07,
                    4.1211e-07,
                    4.9857e-07,
                    5.8979e-07,
                    6.8401e-07,
                    7.7304e-07,
                    8.5679e-07,
                    9.3375e-07,
                    1.0039e-06,
                    1.0788e-06,
                    1.1452e-06,
                    1.1998e-06,
                    1.2526e-06,
                    1.3134e-06,
                    1.3641e-06,
                    1.4312e-06,
                    1.4783e-06,
                    1.5317e-06,
                    1.5882e-06,
                    1.6496e-06,
                    1.7108e-06,
                    1.7753e-06,
                    1.8399e-06,
                    1.9046e-06,
                    1.9696e-06,
                    2.036e-06,
                    2.1026e-06,
                    2.1722e-06,
                    2.241e-06
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [
                    3.365e-08,
                    6.7615e-08,
                    1.0189e-07,
                    1.3647e-07,
                    1.7135e-07,
                    2.0651e-07,
                    2.4197e-07,
                    2.7771e-07,
                    3.1372e-07,
                    3.5002e-07,
                    3.8657e-07,
                    4.2339e-07,
                    4.6045e-07,
                    4.9776e-07,
                    5.353e-07,
                    5.7306e-07,
                    6.1103e-07,
                    6.492e-07,
                    6.8756e-07,
                    7.2611e-07,
                    7.6481e-07,
                    8.0368e-07,
                    8.427e-07,
                    8.8187e-07,
                    9.2117e-07,
                    9.6059e-07,
                    1.0001e-06,
                    1.0398e-06,
                    1.0795e-06,
                    1.1193e-06,
                    1.1591e-06,
                    1.199e-06,
                    1.2389e-06,
                    1.2788e-06,
                    1.3188e-06,
                    1.3588e-06,
                    1.3987e-06,
                    1.4387e-06,
                    1.4787e-06,
                    1.5186e-06,
                    1.5586e-06,
                    1.5984e-06,
                    1.6383e-06,
                    1.678e-06,
                    1.7177e-06,
                    1.7574e-06,
                    1.7969e-06,
                    1.8364e-06,
                    1.8758e-06,
                    1.9151e-06,
                    1.9543e-06,
                    1.9933e-06,
                    2.0323e-06,
                    2.0711e-06,
                    2.1097e-06,
                    2.1483e-06,
                    2.1867e-06,
                    2.2249e-06,
                    2.263e-06,
                    2.3008e-06,
                    2.3385e-06,
                    2.376e-06,
                    2.4133e-06,
                    2.4504e-06,
                    2.4873e-06,
                    2.524e-06,
                    2.5604e-06,
                    2.5966e-06,
                    2.6326e-06,
                    2.6683e-06,
                    2.7038e-06,
                    2.739e-06,
                    2.7739e-06,
                    2.8086e-06,
                    2.843e-06,
                    2.877e-06,
                    2.9108e-06,
                    2.9443e-06,
                    2.9775e-06,
                    3.0103e-06,
                    3.0427e-06,
                    3.0748e-06,
                    3.1066e-06,
                    3.138e-06,
                    3.1702e-06,
                    3.2022e-06,
                    3.2334e-06,
                    3.264e-06,
                    3.2936e-06,
                    3.3222e-06,
                    3.3496e-06,
                    3.3755e-06,
                    3.4e-06,
                    3.4226e-06,
                    3.4433e-06,
                    3.4619e-06,
                    3.4783e-06,
                    3.4922e-06,
                    3.5036e-06,
                    3.5122e-06,
                    3.5181e-06,
                    3.5211e-06,
                    3.5211e-06,
                    3.518e-06,
                    3.512e-06,
                    3.5032e-06,
                    3.4912e-06,
                    3.4765e-06,
                    3.4592e-06,
                    3.4392e-06,
                    3.4166e-06,
                    3.3915e-06,
                    3.3638e-06,
                    3.3337e-06,
                    3.3013e-06,
                    3.2666e-06,
                    3.2299e-06,
                    3.1912e-06,
                    3.1506e-06,
                    3.108e-06,
                    3.0639e-06,
                    3.0182e-06,
                    2.9706e-06,
                    2.9219e-06,
                    2.8721e-06,
                    2.8212e-06,
                    2.7689e-06,
                    2.7157e-06,
                    2.6619e-06,
                    2.6075e-06,
                    2.5529e-06,
                    2.4985e-06,
                    2.4441e-06,
                    2.3903e-06,
                    2.3373e-06,
                    2.2855e-06,
                    2.2357e-06,
                    2.1883e-06,
                    2.1438e-06,
                    2.1022e-06,
                    2.063e-06,
                    2.0262e-06,
                    1.9915e-06,
                    1.9583e-06,
                    2.0169e-06,
                    2.077e-06,
                    2.1386e-06,
                    2.2012e-06,
                    2.265e-06,
                    2.3296e-06,
                    2.395e-06,
                    2.4611e-06,
                    2.5281e-06,
                    2.5955e-06,
                    2.6632e-06,
                    2.731e-06,
                    2.8e-06,
                    2.8684e-06,
                    2.9405e-06,
                    3.0122e-06,
                    3.0868e-06,
                    3.1578e-06,
                    3.2311e-06,
                    3.306e-06,
                    3.3027e-06,
                    3.3014e-06,
                    3.2983e-06,
                    3.2962e-06,
                    3.2966e-06,
                    3.299e-06,
                    3.3045e-06,
                    3.3116e-06
                ],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    3.3594e-08,
                    6.7502e-08,
                    1.0172e-07,
                    1.3624e-07,
                    1.7106e-07,
                    2.0616e-07,
                    2.4155e-07,
                    2.7723e-07,
                    3.1319e-07,
                    3.4941e-07,
                    3.8591e-07,
                    4.2266e-07,
                    4.5966e-07,
                    4.9691e-07,
                    5.3439e-07,
                    5.7208e-07,
                    6.0999e-07,
                    6.481e-07,
                    6.8639e-07,
                    7.2487e-07,
                    7.6352e-07,
                    8.0232e-07,
                    8.4127e-07,
                    8.8036e-07,
                    9.1958e-07,
                    9.5891e-07,
                    9.9835e-07,
                    1.0379e-06,
                    1.0775e-06,
                    1.1172e-06,
                    1.1569e-06,
                    1.1967e-06,
                    1.2365e-06,
                    1.2763e-06,
                    1.3162e-06,
                    1.3561e-06,
                    1.3959e-06,
                    1.4358e-06,
                    1.4757e-06,
                    1.5155e-06,
                    1.5553e-06,
                    1.5951e-06,
                    1.6348e-06,
                    1.6744e-06,
                    1.714e-06,
                    1.7536e-06,
                    1.793e-06,
                    1.8324e-06,
                    1.8717e-06,
                    1.9109e-06,
                    1.95e-06,
                    1.989e-06,
                    2.0278e-06,
                    2.0665e-06,
                    2.1051e-06,
                    2.1435e-06,
                    2.1818e-06,
                    2.2198e-06,
                    2.2578e-06,
                    2.2955e-06,
                    2.3331e-06,
                    2.3704e-06,
                    2.4076e-06,
                    2.4445e-06,
                    2.4813e-06,
                    2.5179e-06,
                    2.5542e-06,
                    2.5902e-06,
                    2.6261e-06,
                    2.6616e-06,
                    2.697e-06,
                    2.732e-06,
                    2.7668e-06,
                    2.8013e-06,
                    2.8355e-06,
                    2.8694e-06,
                    2.9031e-06,
                    2.9364e-06,
                    2.9694e-06,
                    3.002e-06,
                    3.0343e-06,
                    3.0662e-06,
                    3.0978e-06,
                    3.1291e-06,
                    3.1611e-06,
                    3.193e-06,
                    3.224e-06,
                    3.2545e-06,
                    3.2839e-06,
                    3.3124e-06,
                    3.3396e-06,
                    3.3654e-06,
                    3.3896e-06,
                    3.4121e-06,
                    3.4326e-06,
                    3.451e-06,
                    3.4671e-06,
                    3.4808e-06,
                    3.4919e-06,
                    3.5002e-06,
                    3.5059e-06,
                    3.5086e-06,
                    3.5083e-06,
                    3.5049e-06,
                    3.4986e-06,
                    3.4895e-06,
                    3.4772e-06,
                    3.4623e-06,
                    3.4446e-06,
                    3.4243e-06,
                    3.4013e-06,
                    3.3759e-06,
                    3.3479e-06,
                    3.3173e-06,
                    3.2845e-06,
                    3.2492e-06,
                    3.2121e-06,
                    3.1728e-06,
                    3.1317e-06,
                    3.0884e-06,
                    3.0438e-06,
                    2.9975e-06,
                    2.9494e-06,
                    2.9001e-06,
                    2.8496e-06,
                    2.7982e-06,
                    2.7453e-06,
                    2.6916e-06,
                    2.6372e-06,
                    2.5823e-06,
                    2.5271e-06,
                    2.4722e-06,
                    2.4172e-06,
                    2.3629e-06,
                    2.3093e-06,
                    2.2569e-06,
                    2.2065e-06,
                    2.1586e-06,
                    2.1135e-06,
                    2.0712e-06,
                    2.032e-06,
                    2.0563e-06,
                    2.086e-06,
                    2.1221e-06,
                    2.1713e-06,
                    2.2236e-06,
                    2.2821e-06,
                    2.345e-06,
                    2.4042e-06,
                    2.4592e-06,
                    2.5083e-06,
                    2.5515e-06,
                    2.6002e-06,
                    2.6411e-06,
                    2.6706e-06,
                    2.6986e-06,
                    2.7348e-06,
                    2.7602e-06,
                    2.8015e-06,
                    2.8224e-06,
                    2.8468e-06,
                    2.8708e-06,
                    2.8989e-06,
                    2.9267e-06,
                    2.9575e-06,
                    2.9882e-06,
                    3.0189e-06,
                    3.0496e-06,
                    3.0819e-06,
                    3.1144e-06,
                    3.1499e-06,
                    3.1846e-06
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    6.105e-08,
                    1.254e-07,
                    1.947e-07,
                    2.7555e-07,
                    3.5805e-07,
                    4.455e-07,
                    5.3625e-07,
                    6.2205e-07,
                    7.029e-07,
                    7.7715e-07,
                    8.448e-07,
                    9.174e-07,
                    9.8175e-07,
                    1.0345e-06,
                    1.0857e-06,
                    1.1451e-06,
                    1.1946e-06,
                    1.2606e-06,
                    1.3068e-06,
                    1.3596e-06,
                    1.4157e-06,
                    1.4768e-06,
                    1.5378e-06,
                    1.6021e-06,
                    1.6665e-06,
                    1.7308e-06,
                    1.7952e-06,
                    1.8612e-06,
                    1.9272e-06,
                    1.9961e-06,
                    2.0642e-06
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [
                    3.3594e-08,
                    6.7502e-08,
                    1.0172e-07,
                    1.3624e-07,
                    1.7106e-07,
                    2.0616e-07,
                    2.4155e-07,
                    2.7723e-07,
                    3.1319e-07,
                    3.4941e-07,
                    3.8591e-07,
                    4.2266e-07,
                    4.5966e-07,
                    4.9691e-07,
                    5.3439e-07,
                    5.7208e-07,
                    6.0999e-07,
                    6.481e-07,
                    6.8639e-07,
                    7.2487e-07,
                    7.6352e-07,
                    8.0232e-07,
                    8.4127e-07,
                    8.8036e-07,
                    9.1958e-07,
                    9.5891e-07,
                    9.9835e-07,
                    1.0379e-06,
                    1.0775e-06,
                    1.1172e-06,
                    1.1569e-06,
                    1.1967e-06,
                    1.2365e-06,
                    1.2763e-06,
                    1.3162e-06,
                    1.3561e-06,
                    1.3959e-06,
                    1.4358e-06,
                    1.4757e-06,
                    1.5155e-06,
                    1.5553e-06,
                    1.5951e-06,
                    1.6348e-06,
                    1.6744e-06,
                    1.714e-06,
                    1.7536e-06,
                    1.793e-06,
                    1.8324e-06,
                    1.8717e-06,
                    1.9109e-06,
                    1.95e-06,
                    1.989e-06,
                    2.0278e-06,
                    2.0665e-06,
                    2.1051e-06,
                    2.1435e-06,
                    2.1818e-06,
                    2.2198e-06,
                    2.2578e-06,
                    2.2955e-06,
                    2.3331e-06,
                    2.3704e-06,
                    2.4076e-06,
                    2.4445e-06,
                    2.4813e-06,
                    2.5179e-06,
                    2.5542e-06,
                    2.5902e-06,
                    2.6261e-06,
                    2.6616e-06,
                    2.697e-06,
                    2.732e-06,
                    2.7668e-06,
                    2.8013e-06,
                    2.8355e-06,
                    2.8694e-06,
                    2.9031e-06,
                    2.9364e-06,
                    2.9694e-06,
                    3.002e-06,
                    3.0343e-06,
                    3.0662e-06,
                    3.0978e-06,
                    3.1291e-06,
                    3.1611e-06,
                    3.193e-06,
                    3.224e-06,
                    3.2545e-06,
                    3.2839e-06,
                    3.3124e-06,
                    3.3396e-06,
                    3.3654e-06,
                    3.3896e-06,
                    3.4121e-06,
                    3.4326e-06,
                    3.451e-06,
                    3.4671e-06,
                    3.4808e-06,
                    3.4919e-06,
                    3.5002e-06,
                    3.5059e-06,
                    3.5086e-06,
                    3.5083e-06,
                    3.5049e-06,
                    3.4986e-06,
                    3.4895e-06,
                    3.4772e-06,
                    3.4623e-06,
                    3.4446e-06,
                    3.4243e-06,
                    3.4013e-06,
                    3.3759e-06,
                    3.3479e-06,
                    3.3173e-06,
                    3.2845e-06,
                    3.2492e-06,
                    3.2121e-06,
                    3.1728e-06,
                    3.1317e-06,
                    3.0884e-06,
                    3.0438e-06,
                    2.9975e-06,
                    2.9494e-06,
                    2.9001e-06,
                    2.8496e-06,
                    2.7982e-06,
                    2.7453e-06,
                    2.6916e-06,
                    2.6372e-06,
                    2.5823e-06,
                    2.5271e-06,
                    2.4722e-06,
                    2.4172e-06,
                    2.3629e-06,
                    2.3093e-06,
                    2.2569e-06,
                    2.2065e-06,
                    2.1586e-06,
                    2.1135e-06,
                    2.0712e-06,
                    2.032e-06,
                    1.9953e-06,
                    1.9606e-06,
                    1.9274e-06,
                    1.8957e-06,
                    1.8655e-06,
                    1.8366e-06,
                    1.8088e-06,
                    1.7821e-06,
                    1.7563e-06,
                    1.7311e-06,
                    1.7067e-06,
                    1.6828e-06,
                    1.6593e-06,
                    1.6361e-06,
                    1.6129e-06,
                    1.5897e-06,
                    1.5656e-06,
                    1.5409e-06,
                    1.5156e-06,
                    1.4872e-06,
                    1.4551e-06,
                    1.4221e-06,
                    1.3889e-06,
                    1.3554e-06,
                    1.3217e-06,
                    1.288e-06,
                    1.2544e-06,
                    1.2207e-06,
                    1.1872e-06,
                    1.1538e-06,
                    1.1205e-06
                ],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [
                    2.8485e-10,
                    5.7128e-10,
                    8.5928e-10,
                    1.1489e-09,
                    1.44e-09,
                    1.7327e-09,
                    2.027e-09,
                    2.3229e-09,
                    2.6203e-09,
                    2.9194e-09,
                    3.2161e-09,
                    3.5105e-09,
                    3.8025e-09,
                    4.0923e-09,
                    4.3798e-09,
                    4.6649e-09,
                    4.9477e-09,
                    5.2283e-09,
                    5.5065e-09,
                    5.7824e-09,
                    6.0557e-09,
                    6.3264e-09,
                    6.5946e-09,
                    6.8602e-09,
                    7.1232e-09,
                    7.3836e-09,
                    7.6415e-09,
                    7.8967e-09,
                    8.1494e-09,
                    8.3996e-09,
                    8.6505e-09,
                    8.9024e-09,
                    9.1551e-09,
                    9.4087e-09,
                    9.6631e-09,
                    9.9184e-09,
                    1.0175e-08,
                    1.0432e-08,
                    1.0689e-08,
                    1.0948e-08,
                    1.1208e-08,
                    1.1468e-08,
                    1.173e-08,
                    1.1992e-08,
                    1.2255e-08,
                    1.2519e-08,
                    1.2784e-08,
                    1.305e-08,
                    1.3317e-08,
                    1.3585e-08,
                    1.3853e-08,
                    1.4123e-08,
                    1.4393e-08,
                    1.4665e-08,
                    1.4937e-08,
                    1.521e-08,
                    1.5484e-08,
                    1.5759e-08,
                    1.6035e-08,
                    1.6312e-08,
                    1.6588e-08,
                    1.6863e-08,
                    1.7137e-08,
                    1.741e-08,
                    1.7681e-08,
                    1.7952e-08,
                    1.8222e-08,
                    1.8491e-08,
                    1.8758e-08,
                    1.9025e-08,
                    1.9291e-08,
                    1.9555e-08,
                    1.9819e-08,
                    2.0081e-08,
                    2.0342e-08,
                    2.0602e-08,
                    2.0861e-08,
                    2.1119e-08,
                    2.1376e-08,
                    2.1631e-08,
                    2.1887e-08,
                    2.2144e-08,
                    2.2402e-08,
                    2.266e-08,
                    2.2919e-08,
                    2.3179e-08,
                    2.3439e-08,
                    2.37e-08,
                    2.3961e-08,
                    2.4224e-08,
                    2.4591e-08,
                    2.5058e-08,
                    2.5623e-08,
                    2.6279e-08,
                    2.6961e-08,
                    2.766e-08,
                    2.8368e-08,
                    2.9079e-08,
                    2.9784e-08,
                    3.0477e-08,
                    3.1328e-08,
                    3.2316e-08,
                    3.3428e-08,
                    3.4658e-08,
                    3.6005e-08,
                    3.747e-08,
                    3.9055e-08,
                    4.076e-08,
                    4.2582e-08,
                    4.4514e-08,
                    4.645e-08,
                    4.8385e-08,
                    5.0319e-08,
                    5.2255e-08,
                    5.4256e-08,
                    5.6336e-08,
                    5.8499e-08,
                    6.0734e-08,
                    6.3002e-08,
                    6.5562e-08,
                    6.8029e-08,
                    7.038e-08,
                    7.2611e-08,
                    7.4744e-08,
                    7.6821e-08,
                    7.8889e-08,
                    8.0988e-08,
                    8.3153e-08,
                    8.5404e-08,
                    8.7756e-08,
                    9.0222e-08,
                    9.2818e-08,
                    9.555e-08,
                    9.8414e-08,
                    1.014e-07,
                    1.0449e-07,
                    1.0766e-07,
                    1.1093e-07,
                    1.1434e-07,
                    1.1751e-07,
                    1.21e-07,
                    1.2466e-07,
                    1.285e-07,
                    1.3251e-07,
                    2.2118e-07,
                    3.0986e-07,
                    3.9844e-07,
                    4.8676e-07,
                    5.7482e-07,
                    6.6253e-07,
                    7.5017e-07,
                    8.3764e-07,
                    9.2513e-07,
                    1.0125e-06,
                    1.0997e-06,
                    1.1867e-06,
                    1.2746e-06,
                    1.3625e-06,
                    1.4545e-06,
                    1.5463e-06,
                    1.6436e-06,
                    1.7407e-06,
                    1.8407e-06,
                    1.9425e-06,
                    1.9661e-06,
                    1.9919e-06,
                    2.0162e-06,
                    2.0416e-06,
                    2.0691e-06,
                    2.0986e-06,
                    2.1309e-06,
                    2.1648e-06
                ],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [
                    2.8485e-10,
                    5.7128e-10,
                    8.5928e-10,
                    1.1489e-09,
                    1.44e-09,
                    1.7327e-09,
                    2.027e-09,
                    2.3229e-09,
                    2.6203e-09,
                    2.9194e-09,
                    3.2161e-09,
                    3.5105e-09,
                    3.8025e-09,
                    4.0923e-09,
                    4.3798e-09,
                    4.6649e-09,
                    4.9477e-09,
                    5.2283e-09,
                    5.5065e-09,
                    5.7824e-09,
                    6.0557e-09,
                    6.3264e-09,
                    6.5946e-09,
                    6.8602e-09,
                    7.1232e-09,
                    7.3836e-09,
                    7.6415e-09,
                    7.8967e-09,
                    8.1494e-09,
                    8.3996e-09,
                    8.6505e-09,
                    8.9024e-09,
                    9.1551e-09,
                    9.4087e-09,
                    9.6631e-09,
                    9.9184e-09,
                    1.0175e-08,
                    1.0432e-08,
                    1.0689e-08,
                    1.0948e-08,
                    1.1208e-08,
                    1.1468e-08,
                    1.173e-08,
                    1.1992e-08,
                    1.2255e-08,
                    1.2519e-08,
                    1.2784e-08,
                    1.305e-08,
                    1.3317e-08,
                    1.3585e-08,
                    1.3853e-08,
                    1.4123e-08,
                    1.4393e-08,
                    1.4665e-08,
                    1.4937e-08,
                    1.521e-08,
                    1.5484e-08,
                    1.5759e-08,
                    1.6035e-08,
                    1.6312e-08,
                    1.6588e-08,
                    1.6863e-08,
                    1.7137e-08,
                    1.741e-08,
                    1.7681e-08,
                    1.7952e-08,
                    1.8222e-08,
                    1.8491e-08,
                    1.8758e-08,
                    1.9025e-08,
                    1.9291e-08,
                    1.9555e-08,
                    1.9819e-08,
                    2.0081e-08,
                    2.0342e-08,
                    2.0602e-08,
                    2.0861e-08,
                    2.1119e-08,
                    2.1376e-08,
                    2.1631e-08,
                    2.1887e-08,
                    2.2144e-08,
                    2.2402e-08,
                    2.266e-08,
                    2.2919e-08,
                    2.3179e-08,
                    2.3439e-08,
                    2.37e-08,
                    2.3961e-08,
                    2.4224e-08,
                    2.4591e-08,
                    2.5058e-08,
                    2.5623e-08,
                    2.6279e-08,
                    2.6961e-08,
                    2.766e-08,
                    2.8368e-08,
                    2.9079e-08,
                    2.9784e-08,
                    3.0477e-08,
                    3.1328e-08,
                    3.2316e-08,
                    3.3428e-08,
                    3.4658e-08,
                    3.6005e-08,
                    3.747e-08,
                    3.9055e-08,
                    4.076e-08,
                    4.2582e-08,
                    4.4514e-08,
                    4.645e-08,
                    4.8385e-08,
                    5.0319e-08,
                    5.2255e-08,
                    5.4256e-08,
                    5.6336e-08,
                    5.8499e-08,
                    6.0734e-08,
                    6.3002e-08,
                    6.5562e-08,
                    6.8029e-08,
                    7.038e-08,
                    7.2611e-08,
                    7.4744e-08,
                    7.6821e-08,
                    7.8889e-08,
                    8.0988e-08,
                    8.3153e-08,
                    8.5404e-08,
                    8.7756e-08,
                    9.0222e-08,
                    9.2818e-08,
                    9.555e-08,
                    9.8414e-08,
                    1.014e-07,
                    1.0449e-07,
                    1.0766e-07,
                    1.1093e-07,
                    1.1434e-07,
                    1.1751e-07,
                    1.21e-07,
                    1.2465e-07,
                    1.2849e-07,
                    1.3249e-07,
                    1.3656e-07,
                    1.4052e-07,
                    1.4429e-07,
                    1.4776e-07,
                    1.5099e-07,
                    1.5389e-07,
                    1.566e-07,
                    1.591e-07,
                    1.6138e-07,
                    1.6346e-07,
                    1.6528e-07,
                    1.6693e-07,
                    1.6834e-07,
                    1.6953e-07,
                    1.7056e-07,
                    1.7151e-07,
                    1.721e-07,
                    1.7252e-07,
                    1.7283e-07,
                    1.7297e-07,
                    1.7312e-07,
                    1.7339e-07,
                    1.7377e-07,
                    1.744e-07,
                    1.7483e-07,
                    1.7544e-07,
                    1.7609e-07,
                    1.7681e-07
                ],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    5.5365e-12,
                    1.1073e-11,
                    1.661e-11,
                    2.2146e-11,
                    8.4626e-08,
                    1.6934e-07,
                    2.5415e-07,
                    3.39e-07,
                    4.2383e-07,
                    5.0864e-07,
                    5.9357e-07,
                    6.7855e-07,
                    7.6374e-07,
                    8.4901e-07,
                    9.344e-07,
                    1.0197e-06,
                    1.1063e-06,
                    1.193e-06,
                    1.2839e-06,
                    1.3748e-06,
                    1.4715e-06,
                    1.5682e-06,
                    1.6679e-06,
                    1.7695e-06,
                    1.793e-06,
                    1.8185e-06,
                    1.8424e-06,
                    1.8672e-06,
                    1.8943e-06,
                    1.9231e-06,
                    1.9548e-06,
                    1.9879e-06
                ],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [
                    5.6021e-11,
                    1.1316e-10,
                    1.7137e-10,
                    2.3059e-10,
                    2.9073e-10,
                    3.5169e-10,
                    4.1334e-10,
                    4.7555e-10,
                    5.3815e-10,
                    6.0097e-10,
                    6.639e-10,
                    7.269e-10,
                    7.8997e-10,
                    8.5308e-10,
                    9.1623e-10,
                    9.7941e-10,
                    1.0426e-09,
                    1.1059e-09,
                    1.1693e-09,
                    1.2328e-09,
                    1.2974e-09,
                    1.3646e-09,
                    1.4358e-09,
                    1.5118e-09,
                    1.5931e-09,
                    1.6798e-09,
                    1.7717e-09,
                    1.8681e-09,
                    1.968e-09,
                    2.0701e-09,
                    2.1734e-09,
                    2.2777e-09,
                    2.3829e-09,
                    2.4888e-09,
                    2.5953e-09,
                    2.7025e-09,
                    2.8103e-09,
                    2.9187e-09,
                    3.028e-09,
                    3.1498e-09,
                    3.2661e-09,
                    3.3776e-09,
                    3.485e-09,
                    3.5889e-09,
                    3.69e-09,
                    3.7888e-09,
                    3.886e-09,
                    3.9819e-09,
                    4.0772e-09,
                    4.1722e-09,
                    4.2682e-09,
                    4.3665e-09,
                    4.4685e-09,
                    4.575e-09,
                    4.6864e-09,
                    4.8031e-09,
                    4.9247e-09,
                    5.0509e-09,
                    5.1807e-09,
                    5.3131e-09,
                    5.4472e-09,
                    5.5827e-09,
                    5.7194e-09,
                    5.8572e-09,
                    5.9961e-09,
                    6.1359e-09,
                    6.2767e-09,
                    6.4186e-09,
                    6.5616e-09,
                    6.7059e-09,
                    6.8519e-09,
                    6.9999e-09,
                    7.1502e-09,
                    7.3028e-09,
                    7.4577e-09,
                    7.6148e-09,
                    7.7739e-09,
                    7.9344e-09,
                    8.096e-09,
                    8.258e-09,
                    8.4198e-09,
                    8.5812e-09,
                    8.7421e-09,
                    8.9023e-09,
                    9.0618e-09,
                    9.2206e-09,
                    9.3786e-09,
                    9.5362e-09,
                    9.6933e-09,
                    9.8504e-09,
                    1.001e-08,
                    1.0176e-08,
                    1.0353e-08,
                    1.0542e-08,
                    1.0745e-08,
                    1.0963e-08,
                    1.1195e-08,
                    1.144e-08,
                    1.1694e-08,
                    1.1956e-08,
                    1.2222e-08,
                    1.2494e-08,
                    1.2772e-08,
                    1.3056e-08,
                    1.3346e-08,
                    1.3642e-08,
                    1.3946e-08,
                    1.4256e-08,
                    1.4573e-08,
                    1.4897e-08,
                    1.5233e-08,
                    1.5592e-08,
                    1.5979e-08,
                    1.64e-08,
                    1.6855e-08,
                    1.7345e-08,
                    1.7867e-08,
                    1.8414e-08,
                    1.8979e-08,
                    1.9558e-08,
                    2.0137e-08,
                    2.0717e-08,
                    2.1266e-08,
                    2.183e-08,
                    2.2416e-08,
                    2.3004e-08,
                    2.3566e-08,
                    2.4117e-08,
                    2.4665e-08,
                    2.522e-08,
                    2.5772e-08,
                    2.6328e-08,
                    2.6871e-08,
                    2.7429e-08,
                    2.8003e-08,
                    2.8582e-08,
                    2.9152e-08,
                    2.9734e-08,
                    3.0332e-08,
                    3.0942e-08,
                    3.0942e-08,
                    3.0942e-08,
                    3.0942e-08,
                    3.0942e-08,
                    3.6548e-08,
                    4.2166e-08,
                    4.7785e-08,
                    5.3403e-08,
                    5.9021e-08,
                    6.464e-08,
                    7.0258e-08,
                    7.5876e-08,
                    8.1495e-08,
                    8.7113e-08,
                    9.2731e-08,
                    9.835e-08,
                    1.0405e-07,
                    1.0976e-07,
                    1.1576e-07,
                    1.2175e-07,
                    1.281e-07,
                    1.3448e-07,
                    1.4105e-07,
                    1.4761e-07,
                    1.543e-07,
                    1.611e-07,
                    1.6782e-07,
                    1.7463e-07,
                    1.8158e-07,
                    1.8866e-07,
                    1.9588e-07,
                    2.0319e-07
                ],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [
                    4.2291e-16,
                    8.4951e-16,
                    1.281e-15,
                    1.7162e-15,
                    2.1551e-15,
                    2.5989e-15,
                    3.0464e-15,
                    3.4976e-15,
                    3.9537e-15,
                    4.4135e-15,
                    4.8782e-15,
                    5.3466e-15,
                    5.8187e-15,
                    6.2957e-15,
                    6.7764e-15,
                    7.262e-15,
                    7.7513e-15,
                    8.2443e-15,
                    8.7422e-15,
                    9.2438e-15,
                    9.7503e-15,
                    1.0261e-14,
                    1.0774e-14,
                    1.1293e-14,
                    1.1816e-14,
                    1.2343e-14,
                    1.2874e-14,
                    1.3409e-14,
                    1.3947e-14,
                    1.4492e-14,
                    1.504e-14,
                    1.5592e-14,
                    1.6149e-14,
                    1.671e-14,
                    1.7274e-14,
                    1.7843e-14,
                    1.8416e-14,
                    1.8994e-14,
                    1.9576e-14,
                    2.0161e-14,
                    2.0751e-14,
                    2.1345e-14,
                    2.1943e-14,
                    2.2546e-14,
                    2.3152e-14,
                    2.3763e-14,
                    2.4379e-14,
                    2.4998e-14,
                    2.5622e-14,
                    2.625e-14,
                    2.6882e-14,
                    2.7518e-14,
                    2.8158e-14,
                    2.8802e-14,
                    2.945e-14,
                    3.0103e-14,
                    3.0759e-14,
                    3.1423e-14,
                    3.2087e-14,
                    3.2763e-14,
                    3.344e-14,
                    3.4116e-14,
                    3.4804e-14,
                    3.5493e-14,
                    3.6181e-14,
                    3.6882e-14,
                    3.757e-14,
                    3.8271e-14,
                    3.8972e-14,
                    3.9685e-14,
                    4.041e-14,
                    4.1136e-14,
                    4.1861e-14,
                    4.2586e-14,
                    4.3312e-14,
                    4.4049e-14,
                    4.4787e-14,
                    4.5537e-14,
                    4.6287e-14,
                    4.7037e-14,
                    4.7799e-14,
                    4.8549e-14,
                    4.9323e-14,
                    5.0098e-14,
                    5.0872e-14,
                    5.1647e-14,
                    5.2421e-14,
                    5.3208e-14,
                    5.3995e-14,
                    5.4794e-14,
                    5.5593e-14,
                    5.6405e-14,
                    5.7216e-14,
                    5.8027e-14,
                    5.8851e-14,
                    5.9675e-14,
                    6.0498e-14,
                    6.1322e-14,
                    6.2158e-14,
                    6.2994e-14,
                    6.3842e-14,
                    6.4691e-14,
                    6.5539e-14,
                    6.64e-14,
                    6.726e-14,
                    6.8121e-14,
                    6.8981e-14,
                    6.9854e-14,
                    7.0727e-14,
                    7.1612e-14,
                    7.2497e-14,
                    7.3383e-14,
                    7.4268e-14,
                    7.5165e-14,
                    7.6063e-14,
                    7.6972e-14,
                    7.7882e-14,
                    7.8792e-14,
                    7.9702e-14,
                    8.0611e-14,
                    8.1546e-14,
                    8.248e-14,
                    8.3414e-14,
                    8.4349e-14,
                    8.5283e-14,
                    8.623e-14,
                    8.7189e-14,
                    8.8135e-14,
                    8.9094e-14,
                    9.0065e-14,
                    9.1024e-14,
                    9.1996e-14,
                    9.2967e-14,
                    9.3938e-14,
                    9.4922e-14,
                    9.5917e-14,
                    9.6913e-14,
                    9.7909e-14,
                    9.8905e-14,
                    9.9913e-14,
                    1.0091e-13,
                    1.0191e-13,
                    1.0291e-13,
                    1.0391e-13,
                    1.0489e-13,
                    1.0588e-13,
                    1.0686e-13,
                    1.0784e-13,
                    1.0883e-13,
                    1.0981e-13,
                    1.108e-13,
                    1.1178e-13,
                    1.1276e-13,
                    1.1375e-13,
                    1.1473e-13,
                    1.1571e-13,
                    1.1682e-13,
                    1.178e-13,
                    1.1879e-13,
                    1.1977e-13,
                    1.2075e-13,
                    1.2174e-13,
                    1.2272e-13,
                    1.237e-13,
                    1.2469e-13,
                    1.2567e-13,
                    1.2665e-13,
                    1.2764e-13,
                    1.2874e-13,
                    1.2985e-13,
                    1.3096e-13,
                    1.3206e-13
                ],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": [
                    5.602e-11,
                    1.1316e-10,
                    1.7137e-10,
                    2.3059e-10,
                    2.9073e-10,
                    3.5169e-10,
                    4.1334e-10,
                    4.7554e-10,
                    5.3814e-10,
                    6.0096e-10,
                    6.6389e-10,
                    7.269e-10,
                    7.8996e-10,
                    8.5307e-10,
                    9.1622e-10,
                    9.794e-10,
                    1.0426e-09,
                    1.1059e-09,
                    1.1693e-09,
                    1.2328e-09,
                    1.2974e-09,
                    1.3646e-09,
                    1.4358e-09,
                    1.5118e-09,
                    1.5931e-09,
                    1.6798e-09,
                    1.7717e-09,
                    1.8681e-09,
                    1.968e-09,
                    2.0701e-09,
                    2.1734e-09,
                    2.2777e-09,
                    2.3828e-09,
                    2.4887e-09,
                    2.5953e-09,
                    2.7025e-09,
                    2.8103e-09,
                    2.9187e-09,
                    3.0279e-09,
                    3.1497e-09,
                    3.2661e-09,
                    3.3776e-09,
                    3.4849e-09,
                    3.5889e-09,
                    3.69e-09,
                    3.7888e-09,
                    3.8859e-09,
                    3.9819e-09,
                    4.0772e-09,
                    4.1722e-09,
                    4.2682e-09,
                    4.3665e-09,
                    4.4685e-09,
                    4.5749e-09,
                    4.6864e-09,
                    4.803e-09,
                    4.9247e-09,
                    5.0509e-09,
                    5.1807e-09,
                    5.3131e-09,
                    5.4471e-09,
                    5.5826e-09,
                    5.7194e-09,
                    5.8572e-09,
                    5.996e-09,
                    6.1359e-09,
                    6.2767e-09,
                    6.4185e-09,
                    6.5615e-09,
                    6.7059e-09,
                    6.8519e-09,
                    6.9999e-09,
                    7.1501e-09,
                    7.3027e-09,
                    7.4576e-09,
                    7.6148e-09,
                    7.7738e-09,
                    7.9344e-09,
                    8.096e-09,
                    8.2579e-09,
                    8.4197e-09,
                    8.5812e-09,
                    8.742e-09,
                    8.9023e-09,
                    9.0617e-09,
                    9.2205e-09,
                    9.3786e-09,
                    9.5361e-09,
                    9.6933e-09,
                    9.8503e-09,
                    1.001e-08,
                    1.0176e-08,
                    1.0353e-08,
                    1.0542e-08,
                    1.0745e-08,
                    1.0963e-08,
                    1.1195e-08,
                    1.1439e-08,
                    1.1694e-08,
                    1.1956e-08,
                    1.2222e-08,
                    1.2494e-08,
                    1.2772e-08,
                    1.3055e-08,
                    1.3346e-08,
                    1.3642e-08,
                    1.3945e-08,
                    1.4256e-08,
                    1.4573e-08,
                    1.4897e-08,
                    1.5233e-08,
                    1.5592e-08,
                    1.5979e-08,
                    1.64e-08,
                    1.6855e-08,
                    1.7345e-08,
                    1.7867e-08,
                    1.8414e-08,
                    1.8979e-08,
                    1.9557e-08,
                    2.0137e-08,
                    2.0717e-08,
                    2.1266e-08,
                    2.183e-08,
                    2.2416e-08,
                    2.3003e-08,
                    2.3565e-08,
                    2.4117e-08,
                    2.4665e-08,
                    2.522e-08,
                    2.5772e-08,
                    2.6328e-08,
                    2.6871e-08,
                    2.7429e-08,
                    2.8003e-08,
                    2.8581e-08,
                    2.9152e-08,
                    2.9734e-08,
                    3.0332e-08,
                    3.0942e-08,
                    3.0942e-08,
                    3.0942e-08,
                    3.0942e-08,
                    3.0942e-08,
                    3.6548e-08,
                    4.2166e-08,
                    4.7785e-08,
                    5.3403e-08,
                    5.9021e-08,
                    6.464e-08,
                    7.0258e-08,
                    7.5876e-08,
                    8.1495e-08,
                    8.7113e-08,
                    9.2731e-08,
                    9.835e-08,
                    1.0405e-07,
                    1.0976e-07,
                    1.1576e-07,
                    1.2175e-07,
                    1.281e-07,
                    1.3448e-07,
                    1.4105e-07,
                    1.4761e-07,
                    1.543e-07,
                    1.611e-07,
                    1.6782e-07,
                    1.7463e-07,
                    1.8158e-07,
                    1.8866e-07,
                    1.9588e-07,
                    2.0319e-07
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                158.11212,
                                6.92501
                            ],
                            [
                                158.14995,
                                6.88952
                            ],
                            [
                                158.1642,
                                6.80808
                            ],
                            [
                                158.20967,
                                6.78732
                            ],
                            [
                                158.31337,
                                6.8165
                            ],
                            [
                                158.29339,
                                6.86521
                            ],
                            [
                                158.32561,
                                6.91662
                            ],
                            [
                                158.27791,
                                6.95793
                            ],
                            [
                                158.20848,
                                6.97108
                            ],
                            [
                                158.11212,
                                6.92501
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                162.89992,
                                5.2973
                            ],
                            [
                                162.9148,
                                5.27455
                            ],
                            [
                                163.02174,
                                5.27637
                            ],
                            [
                                163.01529,
                                5.36911
                            ],
                            [
                                162.96158,
                                5.35572
                            ],
                            [
                                162.89992,
                                5.2973
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                138.05666,
                                9.44276
                            ],
                            [
                                138.07519,
                                9.47644
                            ],
                            [
                                138.18897,
                                9.53561
                            ],
                            [
                                138.12339,
                                9.58723
                            ],
                            [
                                138.06251,
                                9.49495
                            ],
                            [
                                138.05666,
                                9.44276
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "MDA",
                "Country": "Moldova",
                "Total_3GHG": 0.06,
                "Total_3GHG_timeseries": [
                    1.5429e-06,
                    3.0962e-06,
                    4.6525e-06,
                    6.208e-06,
                    7.7678e-06,
                    9.3297e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001
                ],
                "Fossil_3GHG": 0.06,
                "Fossil_3GHG_timeseries": [
                    5.1038e-08,
                    1.0347e-07,
                    1.5731e-07,
                    2.1256e-07,
                    2.7087e-07,
                    3.2896e-07,
                    3.8847e-07,
                    4.5172e-07,
                    5.1956e-07,
                    5.9271e-07,
                    6.727e-07,
                    7.5833e-07,
                    8.5027e-07,
                    9.4888e-07,
                    1.0506e-06,
                    1.1645e-06,
                    1.2836e-06,
                    1.403e-06,
                    1.5295e-06,
                    1.6602e-06,
                    1.7991e-06,
                    1.9465e-06,
                    2.1005e-06,
                    2.2679e-06,
                    2.4482e-06,
                    2.6454e-06,
                    2.8522e-06,
                    3.0812e-06,
                    3.318e-06,
                    3.5711e-06,
                    3.8333e-06,
                    4.1033e-06,
                    4.3878e-06,
                    4.6777e-06,
                    4.9825e-06,
                    5.2898e-06,
                    5.6029e-06,
                    5.9212e-06,
                    6.2489e-06,
                    6.5925e-06,
                    6.9498e-06,
                    7.3232e-06,
                    7.7304e-06,
                    8.1491e-06,
                    8.6029e-06,
                    9.0693e-06,
                    9.5776e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Land_3GHG": 0.05,
                "Land_3GHG_timeseries": [
                    1.4919e-06,
                    2.9927e-06,
                    4.4952e-06,
                    5.9955e-06,
                    7.497e-06,
                    9.0007e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Total_CO2": 0.07,
                "Total_CO2_timeseries": [
                    1.3003e-06,
                    2.6082e-06,
                    3.9166e-06,
                    5.2216e-06,
                    6.5284e-06,
                    7.8349e-06,
                    9.1376e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008
                ],
                "Fossil_CO2": 0.08,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    1.5996e-09,
                    1.5996e-09,
                    1.5996e-09,
                    3.8453e-09,
                    6.2276e-09,
                    9.3754e-09,
                    1.3374e-08,
                    1.6981e-08,
                    2.0758e-08,
                    2.4995e-08,
                    2.9044e-08,
                    4.1839e-08,
                    5.6522e-08,
                    6.8739e-08,
                    8.5311e-08,
                    1.033e-07,
                    1.2757e-07,
                    1.525e-07,
                    1.759e-07,
                    2.0429e-07,
                    2.3698e-07,
                    2.7756e-07,
                    3.1897e-07,
                    3.7309e-07,
                    4.2863e-07,
                    4.9378e-07,
                    5.6239e-07,
                    6.3467e-07,
                    7.1694e-07,
                    8.0046e-07,
                    8.9144e-07,
                    9.8474e-07,
                    1.0835e-06,
                    1.1865e-06,
                    1.2977e-06,
                    1.4236e-06,
                    1.5623e-06,
                    1.7091e-06,
                    1.8812e-06,
                    2.0564e-06,
                    2.2578e-06,
                    2.4628e-06,
                    2.6998e-06,
                    2.9656e-06,
                    3.274e-06,
                    3.6233e-06,
                    3.9819e-06,
                    4.3283e-06,
                    4.6672e-06,
                    5.0441e-06,
                    5.3806e-06,
                    5.7644e-06,
                    6.1943e-06,
                    6.6269e-06,
                    7.0835e-06,
                    7.5313e-06,
                    7.9955e-06,
                    8.5214e-06,
                    9.0927e-06,
                    9.6083e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006
                ],
                "Land_CO2": 0.06,
                "Land_CO2_timeseries": [
                    1.3003e-06,
                    2.6082e-06,
                    3.9166e-06,
                    5.2216e-06,
                    6.5268e-06,
                    7.8333e-06,
                    9.136e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Total_CH4": 0.02,
                "Total_CH4_timeseries": [
                    1.7712e-07,
                    3.5568e-07,
                    5.3569e-07,
                    7.1715e-07,
                    9.0011e-07,
                    1.0845e-06,
                    1.2704e-06,
                    1.4578e-06,
                    1.6497e-06,
                    1.8463e-06,
                    2.0594e-06,
                    2.289e-06,
                    2.5352e-06,
                    2.7982e-06,
                    3.0749e-06,
                    3.3657e-06,
                    3.6703e-06,
                    3.988e-06,
                    4.3192e-06,
                    4.6635e-06,
                    5.0212e-06,
                    5.3982e-06,
                    5.7946e-06,
                    6.2107e-06,
                    6.6466e-06,
                    7.1028e-06,
                    7.5791e-06,
                    8.0761e-06,
                    8.5909e-06,
                    9.1238e-06,
                    9.6648e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_CH4": 0.02,
                "Fossil_CH4_timeseries": [
                    3.939e-08,
                    8.0043e-08,
                    1.2197e-07,
                    1.6517e-07,
                    2.0971e-07,
                    2.555e-07,
                    3.0259e-07,
                    3.5106e-07,
                    4.0388e-07,
                    4.6113e-07,
                    5.2428e-07,
                    5.9336e-07,
                    6.6847e-07,
                    7.497e-07,
                    8.3409e-07,
                    9.2188e-07,
                    1.0129e-06,
                    1.1065e-06,
                    1.2028e-06,
                    1.3018e-06,
                    1.4025e-06,
                    1.511e-06,
                    1.6273e-06,
                    1.7518e-06,
                    1.8846e-06,
                    2.026e-06,
                    2.1761e-06,
                    2.3353e-06,
                    2.5007e-06,
                    2.6727e-06,
                    2.8501e-06,
                    3.0316e-06,
                    3.2174e-06,
                    3.4073e-06,
                    3.6044e-06,
                    3.8017e-06,
                    3.9992e-06,
                    4.1976e-06,
                    4.3969e-06,
                    4.5972e-06,
                    4.7983e-06,
                    5.0072e-06,
                    5.2244e-06,
                    5.4499e-06,
                    5.6841e-06,
                    5.9272e-06,
                    6.1799e-06,
                    6.4335e-06,
                    6.6883e-06,
                    6.944e-06,
                    7.1979e-06,
                    7.451e-06,
                    7.7033e-06,
                    7.9555e-06,
                    8.2065e-06,
                    8.4639e-06,
                    8.7277e-06,
                    9.0029e-06,
                    9.2898e-06,
                    9.5881e-06,
                    9.8434e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001
                ],
                "Land_CH4": 0.02,
                "Land_CH4_timeseries": [
                    1.3773e-07,
                    2.7564e-07,
                    4.1372e-07,
                    5.5198e-07,
                    6.9041e-07,
                    8.2901e-07,
                    9.6779e-07,
                    1.1067e-06,
                    1.2459e-06,
                    1.3852e-06,
                    1.5351e-06,
                    1.6956e-06,
                    1.8667e-06,
                    2.0485e-06,
                    2.2408e-06,
                    2.4438e-06,
                    2.6574e-06,
                    2.8816e-06,
                    3.1164e-06,
                    3.3618e-06,
                    3.6187e-06,
                    3.8872e-06,
                    4.1673e-06,
                    4.4589e-06,
                    4.762e-06,
                    5.0767e-06,
                    5.403e-06,
                    5.7408e-06,
                    6.0901e-06,
                    6.451e-06,
                    6.8147e-06,
                    7.1811e-06,
                    7.5504e-06,
                    7.9224e-06,
                    8.2971e-06,
                    8.6747e-06,
                    9.055e-06,
                    9.4381e-06,
                    9.824e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_N2O": 0.07,
                "Total_N2O_timeseries": [
                    6.5552e-08,
                    1.3232e-07,
                    2.0025e-07,
                    2.6927e-07,
                    3.3931e-07,
                    4.1026e-07,
                    4.82e-07,
                    5.5439e-07,
                    6.2727e-07,
                    7.0046e-07,
                    7.7386e-07,
                    8.4743e-07,
                    9.2116e-07,
                    9.9503e-07,
                    1.069e-06,
                    1.1432e-06,
                    1.2174e-06,
                    1.2919e-06,
                    1.3665e-06,
                    1.4413e-06,
                    1.5173e-06,
                    1.5961e-06,
                    1.6789e-06,
                    1.7665e-06,
                    1.8596e-06,
                    1.9581e-06,
                    2.0619e-06,
                    2.1703e-06,
                    2.2823e-06,
                    2.3965e-06,
                    2.512e-06,
                    2.6287e-06,
                    2.7462e-06,
                    2.8647e-06,
                    2.9838e-06,
                    3.1037e-06,
                    3.2243e-06,
                    3.3457e-06,
                    3.4679e-06,
                    3.5926e-06,
                    3.7193e-06,
                    3.8478e-06,
                    3.9781e-06,
                    4.1101e-06,
                    4.2437e-06,
                    4.3786e-06,
                    4.5149e-06,
                    4.6521e-06,
                    4.7902e-06,
                    4.9289e-06,
                    5.0679e-06,
                    5.2074e-06,
                    5.3472e-06,
                    5.4873e-06,
                    5.6277e-06,
                    5.7685e-06,
                    5.9097e-06,
                    6.0512e-06,
                    6.1931e-06,
                    6.3354e-06,
                    6.4796e-06,
                    6.6279e-06,
                    6.7822e-06,
                    6.9436e-06,
                    7.113e-06,
                    7.2904e-06,
                    7.4757e-06,
                    7.6678e-06,
                    7.8653e-06,
                    8.0664e-06,
                    8.2699e-06,
                    8.4759e-06,
                    8.6842e-06,
                    8.8948e-06,
                    9.1077e-06,
                    9.3227e-06,
                    9.5396e-06,
                    9.7582e-06,
                    9.9782e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_N2O": 0.04,
                "Fossil_N2O_timeseries": [
                    1.1648e-08,
                    2.343e-08,
                    3.5345e-08,
                    4.7391e-08,
                    5.9564e-08,
                    7.1862e-08,
                    8.4279e-08,
                    9.6812e-08,
                    1.0945e-07,
                    1.222e-07,
                    1.3505e-07,
                    1.48e-07,
                    1.6104e-07,
                    1.7418e-07,
                    1.8742e-07,
                    2.0076e-07,
                    2.142e-07,
                    2.2774e-07,
                    2.4137e-07,
                    2.5511e-07,
                    2.6897e-07,
                    2.8303e-07,
                    2.9732e-07,
                    3.1186e-07,
                    3.2668e-07,
                    3.4178e-07,
                    3.5715e-07,
                    3.7277e-07,
                    3.886e-07,
                    4.046e-07,
                    4.2075e-07,
                    4.3702e-07,
                    4.5341e-07,
                    4.6993e-07,
                    4.8657e-07,
                    5.0333e-07,
                    5.202e-07,
                    5.3719e-07,
                    5.543e-07,
                    5.7167e-07,
                    5.8919e-07,
                    6.0688e-07,
                    6.2473e-07,
                    6.4276e-07,
                    6.6095e-07,
                    6.7933e-07,
                    6.9788e-07,
                    7.1662e-07,
                    7.3556e-07,
                    7.5469e-07,
                    7.7403e-07,
                    7.9359e-07,
                    8.1339e-07,
                    8.3344e-07,
                    8.5374e-07,
                    8.743e-07,
                    8.9511e-07,
                    9.1617e-07,
                    9.3747e-07,
                    9.59e-07,
                    9.8074e-07,
                    1.0027e-06,
                    1.0248e-06,
                    1.0472e-06,
                    1.0697e-06,
                    1.0924e-06,
                    1.1154e-06,
                    1.1385e-06,
                    1.1619e-06,
                    1.1855e-06,
                    1.2095e-06,
                    1.2338e-06,
                    1.2587e-06,
                    1.2842e-06,
                    1.3104e-06,
                    1.3374e-06,
                    1.3651e-06,
                    1.3938e-06,
                    1.4234e-06,
                    1.4539e-06,
                    1.4856e-06,
                    1.5187e-06,
                    1.5536e-06,
                    1.5903e-06,
                    1.6291e-06,
                    1.6699e-06,
                    1.713e-06,
                    1.7581e-06,
                    1.8053e-06,
                    1.8544e-06,
                    1.9054e-06,
                    1.9582e-06,
                    2.013e-06,
                    2.0698e-06,
                    2.1288e-06,
                    2.1899e-06,
                    2.2533e-06,
                    2.319e-06,
                    2.3873e-06,
                    2.458e-06,
                    2.532e-06,
                    2.6102e-06,
                    2.6932e-06,
                    2.7816e-06,
                    2.8753e-06,
                    2.9742e-06,
                    3.0777e-06,
                    3.185e-06,
                    3.2951e-06,
                    3.4064e-06,
                    3.5177e-06,
                    3.6285e-06,
                    3.7382e-06,
                    3.8465e-06,
                    3.9533e-06,
                    4.0585e-06,
                    4.1624e-06,
                    4.2653e-06,
                    4.3676e-06,
                    4.4785e-06,
                    4.59e-06,
                    4.707e-06,
                    4.8296e-06,
                    4.9576e-06,
                    5.1165e-06,
                    5.2836e-06,
                    5.4542e-06,
                    5.6305e-06,
                    5.8113e-06,
                    5.9983e-06,
                    6.1849e-06,
                    6.3727e-06,
                    6.5612e-06,
                    6.7509e-06,
                    6.9425e-06,
                    7.1358e-06,
                    7.3325e-06,
                    7.5295e-06,
                    7.7262e-06,
                    7.8265e-06,
                    7.9251e-06,
                    8.0263e-06,
                    8.1425e-06,
                    8.2409e-06,
                    8.3308e-06,
                    8.4105e-06,
                    8.4842e-06,
                    8.5483e-06,
                    8.6018e-06,
                    8.6515e-06,
                    8.7028e-06,
                    8.7612e-06,
                    8.8213e-06,
                    8.8813e-06,
                    8.942e-06,
                    9.0052e-06,
                    9.0685e-06,
                    9.1375e-06,
                    9.2002e-06,
                    9.2799e-06,
                    9.3607e-06,
                    9.4389e-06,
                    9.5177e-06,
                    9.5966e-06,
                    9.6779e-06,
                    9.7646e-06,
                    9.8557e-06,
                    9.9478e-06,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.08,
                "Land_N2O_timeseries": [
                    5.3904e-08,
                    1.0889e-07,
                    1.649e-07,
                    2.2188e-07,
                    2.7975e-07,
                    3.384e-07,
                    3.9772e-07,
                    4.5758e-07,
                    5.1782e-07,
                    5.7826e-07,
                    6.3881e-07,
                    6.9944e-07,
                    7.6012e-07,
                    8.2085e-07,
                    8.8161e-07,
                    9.4241e-07,
                    1.0032e-06,
                    1.0642e-06,
                    1.1251e-06,
                    1.1862e-06,
                    1.2484e-06,
                    1.3131e-06,
                    1.3816e-06,
                    1.4547e-06,
                    1.5329e-06,
                    1.6163e-06,
                    1.7047e-06,
                    1.7975e-06,
                    1.8937e-06,
                    1.9919e-06,
                    2.0913e-06,
                    2.1916e-06,
                    2.2928e-06,
                    2.3947e-06,
                    2.4973e-06,
                    2.6004e-06,
                    2.7041e-06,
                    2.8085e-06,
                    2.9135e-06,
                    3.021e-06,
                    3.1301e-06,
                    3.2409e-06,
                    3.3534e-06,
                    3.4674e-06,
                    3.5827e-06,
                    3.6993e-06,
                    3.817e-06,
                    3.9355e-06,
                    4.0546e-06,
                    4.1742e-06,
                    4.2939e-06,
                    4.4138e-06,
                    4.5338e-06,
                    4.6538e-06,
                    4.774e-06,
                    4.8942e-06,
                    5.0146e-06,
                    5.135e-06,
                    5.2556e-06,
                    5.3764e-06,
                    5.4989e-06,
                    5.6252e-06,
                    5.7574e-06,
                    5.8965e-06,
                    6.0433e-06,
                    6.198e-06,
                    6.3603e-06,
                    6.5292e-06,
                    6.7034e-06,
                    6.8809e-06,
                    7.0605e-06,
                    7.2421e-06,
                    7.4255e-06,
                    7.6107e-06,
                    7.7973e-06,
                    7.9854e-06,
                    8.1745e-06,
                    8.3644e-06,
                    8.5548e-06,
                    8.7453e-06,
                    8.9351e-06,
                    9.1225e-06,
                    9.3066e-06,
                    9.4866e-06,
                    9.6621e-06,
                    9.8332e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            28.21136,
                            45.46728
                        ],
                        [
                            28.30511,
                            45.54698
                        ],
                        [
                            28.51329,
                            45.49957
                        ],
                        [
                            28.54429,
                            45.57952
                        ],
                        [
                            28.51557,
                            45.66384
                        ],
                        [
                            28.52107,
                            45.73734
                        ],
                        [
                            28.59431,
                            45.73503
                        ],
                        [
                            28.78539,
                            45.83215
                        ],
                        [
                            28.7552,
                            45.92643
                        ],
                        [
                            28.7765,
                            45.97086
                        ],
                        [
                            28.97879,
                            46.00359
                        ],
                        [
                            29.00477,
                            46.0493
                        ],
                        [
                            28.95038,
                            46.09372
                        ],
                        [
                            29.065,
                            46.19459
                        ],
                        [
                            28.95187,
                            46.25954
                        ],
                        [
                            28.99685,
                            46.32287
                        ],
                        [
                            28.93081,
                            46.45771
                        ],
                        [
                            29.02473,
                            46.46274
                        ],
                        [
                            29.06293,
                            46.51241
                        ],
                        [
                            29.16361,
                            46.51552
                        ],
                        [
                            29.24516,
                            46.41695
                        ],
                        [
                            29.32319,
                            46.41504
                        ],
                        [
                            29.44916,
                            46.4976
                        ],
                        [
                            29.56555,
                            46.41592
                        ],
                        [
                            29.58034,
                            46.36198
                        ],
                        [
                            29.67865,
                            46.36144
                        ],
                        [
                            29.68719,
                            46.42653
                        ],
                        [
                            29.77632,
                            46.454
                        ],
                        [
                            29.80679,
                            46.38521
                        ],
                        [
                            29.88811,
                            46.37207
                        ],
                        [
                            29.93881,
                            46.40096
                        ],
                        [
                            30.02208,
                            46.38343
                        ],
                        [
                            30.16314,
                            46.41337
                        ],
                        [
                            30.00502,
                            46.45435
                        ],
                        [
                            29.92545,
                            46.50259
                        ],
                        [
                            29.96738,
                            46.59716
                        ],
                        [
                            29.94604,
                            46.64834
                        ],
                        [
                            29.97403,
                            46.75221
                        ],
                        [
                            29.88429,
                            46.84971
                        ],
                        [
                            29.74996,
                            46.86109
                        ],
                        [
                            29.73151,
                            46.91783
                        ],
                        [
                            29.64804,
                            46.91979
                        ],
                        [
                            29.59587,
                            46.96364
                        ],
                        [
                            29.61205,
                            47.10033
                        ],
                        [
                            29.57923,
                            47.13587
                        ],
                        [
                            29.5519,
                            47.2515
                        ],
                        [
                            29.59892,
                            47.25745
                        ],
                        [
                            29.57406,
                            47.37054
                        ],
                        [
                            29.48802,
                            47.35548
                        ],
                        [
                            29.4858,
                            47.30574
                        ],
                        [
                            29.39838,
                            47.30037
                        ],
                        [
                            29.33727,
                            47.37027
                        ],
                        [
                            29.31734,
                            47.44841
                        ],
                        [
                            29.23872,
                            47.45709
                        ],
                        [
                            29.11718,
                            47.5544
                        ],
                        [
                            29.21679,
                            47.61245
                        ],
                        [
                            29.2489,
                            47.75227
                        ],
                        [
                            29.20235,
                            47.82859
                        ],
                        [
                            29.17485,
                            47.99286
                        ],
                        [
                            29.03242,
                            47.94324
                        ],
                        [
                            28.926,
                            47.96069
                        ],
                        [
                            28.83948,
                            48.03468
                        ],
                        [
                            28.84148,
                            48.12451
                        ],
                        [
                            28.5456,
                            48.16932
                        ],
                        [
                            28.44907,
                            48.08428
                        ],
                        [
                            28.35709,
                            48.2445
                        ],
                        [
                            28.23281,
                            48.21124
                        ],
                        [
                            28.04599,
                            48.32494
                        ],
                        [
                            27.9646,
                            48.32496
                        ],
                        [
                            27.86762,
                            48.4067
                        ],
                        [
                            27.74259,
                            48.45696
                        ],
                        [
                            27.64204,
                            48.44141
                        ],
                        [
                            27.58024,
                            48.48982
                        ],
                        [
                            27.4653,
                            48.44754
                        ],
                        [
                            27.44634,
                            48.40916
                        ],
                        [
                            27.31955,
                            48.44181
                        ],
                        [
                            27.28607,
                            48.37128
                        ],
                        [
                            27.08821,
                            48.41249
                        ],
                        [
                            26.99216,
                            48.36063
                        ],
                        [
                            26.77947,
                            48.41853
                        ],
                        [
                            26.76493,
                            48.35435
                        ],
                        [
                            26.69588,
                            48.32717
                        ],
                        [
                            26.63056,
                            48.25975
                        ],
                        [
                            26.80742,
                            48.25446
                        ],
                        [
                            26.93922,
                            48.1977
                        ],
                        [
                            27.03977,
                            48.10736
                        ],
                        [
                            27.17814,
                            47.94693
                        ],
                        [
                            27.21433,
                            47.82285
                        ],
                        [
                            27.2782,
                            47.76367
                        ],
                        [
                            27.26669,
                            47.71179
                        ],
                        [
                            27.31659,
                            47.64151
                        ],
                        [
                            27.40291,
                            47.58332
                        ],
                        [
                            27.47337,
                            47.48684
                        ],
                        [
                            27.55818,
                            47.44647
                        ],
                        [
                            27.60067,
                            47.32931
                        ],
                        [
                            27.72849,
                            47.29445
                        ],
                        [
                            27.8014,
                            47.18889
                        ],
                        [
                            27.79569,
                            47.14872
                        ],
                        [
                            27.89756,
                            47.07378
                        ],
                        [
                            28.0807,
                            46.98997
                        ],
                        [
                            28.11143,
                            46.92011
                        ],
                        [
                            28.11546,
                            46.82134
                        ],
                        [
                            28.17524,
                            46.77778
                        ],
                        [
                            28.25115,
                            46.61188
                        ],
                        [
                            28.22275,
                            46.51216
                        ],
                        [
                            28.26003,
                            46.4375
                        ],
                        [
                            28.1932,
                            46.35612
                        ],
                        [
                            28.20674,
                            46.31799
                        ],
                        [
                            28.11142,
                            46.23182
                        ],
                        [
                            28.1415,
                            46.19035
                        ],
                        [
                            28.08707,
                            46.00791
                        ],
                        [
                            28.13144,
                            45.87552
                        ],
                        [
                            28.11195,
                            45.82133
                        ],
                        [
                            28.16629,
                            45.73585
                        ],
                        [
                            28.17305,
                            45.64703
                        ],
                        [
                            28.09343,
                            45.59767
                        ],
                        [
                            28.16514,
                            45.54254
                        ],
                        [
                            28.21136,
                            45.46728
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "MNG",
                "Country": "Mongolia",
                "Total_3GHG": 0.2,
                "Total_3GHG_timeseries": [
                    6.968e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032
                ],
                "Fossil_3GHG": 0.08,
                "Fossil_3GHG_timeseries": [
                    3.8752e-08,
                    7.7806e-08,
                    1.1716e-07,
                    1.5682e-07,
                    1.9678e-07,
                    2.3705e-07,
                    2.7763e-07,
                    3.1851e-07,
                    3.597e-07,
                    4.0119e-07,
                    4.43e-07,
                    4.8512e-07,
                    5.2756e-07,
                    5.7033e-07,
                    6.1342e-07,
                    6.5683e-07,
                    7.0057e-07,
                    7.4464e-07,
                    7.8905e-07,
                    8.3379e-07,
                    8.7883e-07,
                    9.2418e-07,
                    9.6987e-07,
                    1.0159e-06,
                    1.0623e-06,
                    1.109e-06,
                    1.1561e-06,
                    1.2035e-06,
                    1.2513e-06,
                    1.2994e-06,
                    1.3491e-06,
                    1.4005e-06,
                    1.4535e-06,
                    1.5081e-06,
                    1.5644e-06,
                    1.6223e-06,
                    1.6818e-06,
                    1.743e-06,
                    1.8059e-06,
                    1.8704e-06,
                    1.9366e-06,
                    2.0045e-06,
                    2.0741e-06,
                    2.1454e-06,
                    2.2183e-06,
                    2.293e-06,
                    2.3693e-06,
                    2.4474e-06,
                    2.5272e-06,
                    2.6087e-06,
                    2.691e-06,
                    2.774e-06,
                    2.8579e-06,
                    2.9426e-06,
                    3.0281e-06,
                    3.1144e-06,
                    3.2015e-06,
                    3.2895e-06,
                    3.3784e-06,
                    3.468e-06,
                    3.5552e-06,
                    3.6399e-06,
                    3.7221e-06,
                    3.8018e-06,
                    3.8791e-06,
                    3.9539e-06,
                    4.0263e-06,
                    4.0963e-06,
                    4.1639e-06,
                    4.2291e-06,
                    4.2916e-06,
                    4.3515e-06,
                    4.4087e-06,
                    4.4634e-06,
                    4.5154e-06,
                    4.5649e-06,
                    4.6118e-06,
                    4.6562e-06,
                    4.6981e-06,
                    4.7376e-06,
                    4.7776e-06,
                    4.8181e-06,
                    4.8592e-06,
                    4.901e-06,
                    4.9434e-06,
                    4.9865e-06,
                    5.0304e-06,
                    5.0751e-06,
                    5.1206e-06,
                    5.167e-06,
                    5.2154e-06,
                    5.2659e-06,
                    5.3187e-06,
                    5.3737e-06,
                    5.4249e-06,
                    5.472e-06,
                    5.5151e-06,
                    5.554e-06,
                    5.5887e-06,
                    5.8543e-06,
                    6.1404e-06,
                    6.4479e-06,
                    6.7743e-06,
                    7.2046e-06,
                    7.7015e-06,
                    8.298e-06,
                    8.9762e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008
                ],
                "Land_3GHG": 0.42,
                "Land_3GHG_timeseries": [
                    6.9293e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024
                ],
                "Total_CO2": 0.17,
                "Total_CO2_timeseries": [
                    6.0719e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019
                ],
                "Fossil_CO2": 0.04,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.287e-07,
                    2.607e-07,
                    3.96e-07,
                    5.3295e-07,
                    7.524e-07,
                    1.018e-06,
                    1.3282e-06,
                    1.6714e-06,
                    2.1829e-06,
                    2.7885e-06,
                    3.3709e-06,
                    3.998e-06,
                    4.8857e-06,
                    5.6067e-06,
                    6.5274e-06,
                    7.4085e-06,
                    8.288e-06,
                    9.2564e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Land_CO2": 0.44,
                "Land_CO2_timeseries": [
                    6.0719e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016
                ],
                "Total_CH4": 0.23,
                "Total_CH4_timeseries": [
                    7.5274e-07,
                    1.507e-06,
                    2.2627e-06,
                    3.0199e-06,
                    3.7786e-06,
                    4.5387e-06,
                    5.3004e-06,
                    6.0636e-06,
                    6.8282e-06,
                    7.5944e-06,
                    8.3621e-06,
                    9.1313e-06,
                    9.902e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009
                ],
                "Fossil_CH4": 0.17,
                "Fossil_CH4_timeseries": [
                    3.6325e-08,
                    7.292e-08,
                    1.0979e-07,
                    1.4693e-07,
                    1.8435e-07,
                    2.2204e-07,
                    2.6002e-07,
                    2.9828e-07,
                    3.3682e-07,
                    3.7564e-07,
                    4.1477e-07,
                    4.5419e-07,
                    4.9391e-07,
                    5.3394e-07,
                    5.7427e-07,
                    6.1491e-07,
                    6.5586e-07,
                    6.9712e-07,
                    7.387e-07,
                    7.8059e-07,
                    8.2276e-07,
                    8.6518e-07,
                    9.0788e-07,
                    9.5084e-07,
                    9.9408e-07,
                    1.0376e-06,
                    1.0814e-06,
                    1.1254e-06,
                    1.1697e-06,
                    1.2143e-06,
                    1.2605e-06,
                    1.3084e-06,
                    1.3578e-06,
                    1.4088e-06,
                    1.4615e-06,
                    1.5157e-06,
                    1.5716e-06,
                    1.6291e-06,
                    1.6882e-06,
                    1.749e-06,
                    1.8114e-06,
                    1.8754e-06,
                    1.9411e-06,
                    2.0084e-06,
                    2.0774e-06,
                    2.148e-06,
                    2.2203e-06,
                    2.2943e-06,
                    2.3699e-06,
                    2.4472e-06,
                    2.5252e-06,
                    2.604e-06,
                    2.6835e-06,
                    2.7637e-06,
                    2.8447e-06,
                    2.9265e-06,
                    3.009e-06,
                    3.0923e-06,
                    3.1763e-06,
                    3.2612e-06,
                    3.3435e-06,
                    3.4233e-06,
                    3.5005e-06,
                    3.5752e-06,
                    3.6474e-06,
                    3.7171e-06,
                    3.7843e-06,
                    3.8491e-06,
                    3.9114e-06,
                    3.9712e-06,
                    4.0284e-06,
                    4.0828e-06,
                    4.1346e-06,
                    4.1837e-06,
                    4.2302e-06,
                    4.2741e-06,
                    4.3154e-06,
                    4.3541e-06,
                    4.3903e-06,
                    4.424e-06,
                    4.4581e-06,
                    4.4928e-06,
                    4.528e-06,
                    4.5638e-06,
                    4.6003e-06,
                    4.6373e-06,
                    4.6751e-06,
                    4.7135e-06,
                    4.7528e-06,
                    4.7928e-06,
                    4.8348e-06,
                    4.8787e-06,
                    4.9245e-06,
                    4.9724e-06,
                    5.0161e-06,
                    5.0554e-06,
                    5.0903e-06,
                    5.1208e-06,
                    5.1467e-06,
                    5.2747e-06,
                    5.4194e-06,
                    5.5817e-06,
                    5.7606e-06,
                    5.9601e-06,
                    6.1791e-06,
                    6.4523e-06,
                    6.7732e-06,
                    7.2913e-06,
                    7.9303e-06,
                    8.5749e-06,
                    9.3187e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Land_CH4": 0.32,
                "Land_CH4_timeseries": [
                    7.1642e-07,
                    1.4341e-06,
                    2.1529e-06,
                    2.873e-06,
                    3.5942e-06,
                    4.3167e-06,
                    5.0404e-06,
                    5.7653e-06,
                    6.4914e-06,
                    7.2187e-06,
                    7.9473e-06,
                    8.6771e-06,
                    9.4081e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Total_N2O": 0.41,
                "Total_N2O_timeseries": [
                    1.434e-07,
                    2.8966e-07,
                    4.3864e-07,
                    5.9018e-07,
                    7.4407e-07,
                    9.0004e-07,
                    1.0578e-06,
                    1.2169e-06,
                    1.3771e-06,
                    1.5379e-06,
                    1.6989e-06,
                    1.8602e-06,
                    2.0216e-06,
                    2.1832e-06,
                    2.3448e-06,
                    2.5066e-06,
                    2.6685e-06,
                    2.8306e-06,
                    2.9929e-06,
                    3.1556e-06,
                    3.3209e-06,
                    3.4931e-06,
                    3.6752e-06,
                    3.8695e-06,
                    4.0772e-06,
                    4.2987e-06,
                    4.5332e-06,
                    4.7792e-06,
                    5.0341e-06,
                    5.2945e-06,
                    5.5579e-06,
                    5.8239e-06,
                    6.0922e-06,
                    6.3622e-06,
                    6.634e-06,
                    6.9074e-06,
                    7.1823e-06,
                    7.459e-06,
                    7.7375e-06,
                    8.0373e-06,
                    8.3443e-06,
                    8.6586e-06,
                    8.9805e-06,
                    9.3103e-06,
                    9.6482e-06,
                    9.9944e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_N2O": 0.02,
                "Fossil_N2O_timeseries": [
                    2.4273e-09,
                    4.8854e-09,
                    7.3737e-09,
                    9.8916e-09,
                    1.2438e-08,
                    1.5011e-08,
                    1.761e-08,
                    2.0234e-08,
                    2.2879e-08,
                    2.5544e-08,
                    2.8228e-08,
                    3.093e-08,
                    3.3651e-08,
                    3.6389e-08,
                    3.9145e-08,
                    4.1919e-08,
                    4.4711e-08,
                    4.7521e-08,
                    5.0349e-08,
                    5.3196e-08,
                    5.6073e-08,
                    5.9e-08,
                    6.1992e-08,
                    6.5059e-08,
                    6.8206e-08,
                    7.1437e-08,
                    7.4746e-08,
                    7.8128e-08,
                    8.1569e-08,
                    8.5053e-08,
                    8.857e-08,
                    9.2115e-08,
                    9.5689e-08,
                    9.9289e-08,
                    1.0291e-07,
                    1.0656e-07,
                    1.1024e-07,
                    1.1394e-07,
                    1.1766e-07,
                    1.2145e-07,
                    1.2527e-07,
                    1.2913e-07,
                    1.3303e-07,
                    1.3697e-07,
                    1.4095e-07,
                    1.4497e-07,
                    1.4903e-07,
                    1.5314e-07,
                    1.5729e-07,
                    1.6149e-07,
                    1.6574e-07,
                    1.7005e-07,
                    1.7442e-07,
                    1.7886e-07,
                    1.8336e-07,
                    1.8793e-07,
                    1.9256e-07,
                    1.9726e-07,
                    2.0202e-07,
                    2.0684e-07,
                    2.1171e-07,
                    2.1663e-07,
                    2.2161e-07,
                    2.2664e-07,
                    2.3172e-07,
                    2.3685e-07,
                    2.4203e-07,
                    2.4726e-07,
                    2.5254e-07,
                    2.5786e-07,
                    2.6323e-07,
                    2.6864e-07,
                    2.741e-07,
                    2.7961e-07,
                    2.8516e-07,
                    2.9076e-07,
                    2.964e-07,
                    3.0209e-07,
                    3.0782e-07,
                    3.1359e-07,
                    3.1941e-07,
                    3.2527e-07,
                    3.3118e-07,
                    3.3714e-07,
                    3.4315e-07,
                    3.4921e-07,
                    3.5534e-07,
                    3.6153e-07,
                    3.678e-07,
                    3.7414e-07,
                    3.806e-07,
                    3.8725e-07,
                    3.9414e-07,
                    4.0131e-07,
                    4.088e-07,
                    4.1661e-07,
                    4.2475e-07,
                    4.3321e-07,
                    4.4196e-07,
                    4.5096e-07,
                    4.603e-07,
                    4.7017e-07,
                    4.8074e-07,
                    4.9211e-07,
                    5.0435e-07,
                    5.1749e-07,
                    5.3152e-07,
                    5.4637e-07,
                    5.6195e-07,
                    5.7812e-07,
                    5.9476e-07,
                    6.1184e-07,
                    6.2933e-07,
                    6.4723e-07,
                    6.6557e-07,
                    6.8437e-07,
                    7.0369e-07,
                    7.2362e-07,
                    7.4424e-07,
                    7.7334e-07,
                    8.0244e-07,
                    8.3035e-07,
                    8.5919e-07,
                    8.8992e-07,
                    9.2316e-07,
                    9.5727e-07,
                    9.9555e-07,
                    1.0361e-06,
                    1.079e-06,
                    1.1249e-06,
                    1.1699e-06,
                    1.2309e-06,
                    1.2916e-06,
                    1.3496e-06,
                    1.429e-06,
                    1.5002e-06,
                    1.5767e-06,
                    1.6668e-06,
                    1.7515e-06,
                    1.8344e-06,
                    1.9179e-06,
                    1.9898e-06,
                    2.0662e-06,
                    2.1263e-06,
                    2.1883e-06,
                    2.2444e-06,
                    2.3012e-06,
                    2.356e-06,
                    2.4131e-06,
                    2.4737e-06,
                    2.5353e-06,
                    2.6018e-06,
                    2.6677e-06,
                    2.7389e-06,
                    2.8147e-06,
                    2.901e-06,
                    2.9951e-06,
                    3.092e-06,
                    3.1874e-06,
                    3.2878e-06,
                    3.4033e-06,
                    3.5285e-06,
                    3.6593e-06,
                    3.7876e-06,
                    3.9119e-06,
                    4.0318e-06,
                    4.1712e-06,
                    4.3204e-06,
                    4.4831e-06,
                    4.6424e-06,
                    4.8067e-06,
                    4.9782e-06
                ],
                "Land_N2O": 0.56,
                "Land_N2O_timeseries": [
                    1.4098e-07,
                    2.8477e-07,
                    4.3126e-07,
                    5.8029e-07,
                    7.3163e-07,
                    8.8503e-07,
                    1.0402e-06,
                    1.1967e-06,
                    1.3542e-06,
                    1.5123e-06,
                    1.6707e-06,
                    1.8293e-06,
                    1.988e-06,
                    2.1468e-06,
                    2.3057e-06,
                    2.4647e-06,
                    2.6238e-06,
                    2.7831e-06,
                    2.9426e-06,
                    3.1024e-06,
                    3.2648e-06,
                    3.4341e-06,
                    3.6132e-06,
                    3.8045e-06,
                    4.009e-06,
                    4.2272e-06,
                    4.4585e-06,
                    4.7011e-06,
                    4.9526e-06,
                    5.2094e-06,
                    5.4694e-06,
                    5.7318e-06,
                    5.9965e-06,
                    6.263e-06,
                    6.5311e-06,
                    6.8008e-06,
                    7.0721e-06,
                    7.345e-06,
                    7.6199e-06,
                    7.9159e-06,
                    8.219e-06,
                    8.5294e-06,
                    8.8475e-06,
                    9.1733e-06,
                    9.5072e-06,
                    9.8494e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            87.82497,
                            49.18332
                        ],
                        [
                            87.88199,
                            49.10613
                        ],
                        [
                            87.90867,
                            48.99666
                        ],
                        [
                            87.79046,
                            48.94046
                        ],
                        [
                            87.76477,
                            48.87763
                        ],
                        [
                            87.91799,
                            48.7751
                        ],
                        [
                            88.02514,
                            48.75454
                        ],
                        [
                            88.07142,
                            48.68958
                        ],
                        [
                            87.96535,
                            48.60405
                        ],
                        [
                            87.98216,
                            48.57424
                        ],
                        [
                            88.17489,
                            48.50152
                        ],
                        [
                            88.34443,
                            48.46523
                        ],
                        [
                            88.4467,
                            48.38509
                        ],
                        [
                            88.49441,
                            48.40691
                        ],
                        [
                            88.59501,
                            48.33624
                        ],
                        [
                            88.56649,
                            48.2819
                        ],
                        [
                            88.62602,
                            48.1717
                        ],
                        [
                            88.78943,
                            48.10988
                        ],
                        [
                            88.91092,
                            48.10866
                        ],
                        [
                            89.06976,
                            47.9744
                        ],
                        [
                            89.21359,
                            47.9724
                        ],
                        [
                            89.38107,
                            48.04018
                        ],
                        [
                            89.48047,
                            48.01303
                        ],
                        [
                            89.59643,
                            48.00867
                        ],
                        [
                            89.57552,
                            47.96082
                        ],
                        [
                            89.64401,
                            47.89646
                        ],
                        [
                            89.70782,
                            47.89477
                        ],
                        [
                            89.74758,
                            47.82376
                        ],
                        [
                            89.85092,
                            47.81819
                        ],
                        [
                            89.98213,
                            47.89148
                        ],
                        [
                            90.07821,
                            47.83697
                        ],
                        [
                            90.0648,
                            47.78169
                        ],
                        [
                            90.12904,
                            47.70806
                        ],
                        [
                            90.24884,
                            47.69729
                        ],
                        [
                            90.34382,
                            47.64857
                        ],
                        [
                            90.33754,
                            47.6059
                        ],
                        [
                            90.46395,
                            47.48116
                        ],
                        [
                            90.44817,
                            47.40415
                        ],
                        [
                            90.50679,
                            47.36536
                        ],
                        [
                            90.47302,
                            47.30803
                        ],
                        [
                            90.53176,
                            47.20576
                        ],
                        [
                            90.76499,
                            46.98546
                        ],
                        [
                            90.91626,
                            46.93213
                        ],
                        [
                            90.94094,
                            46.81914
                        ],
                        [
                            91.04607,
                            46.70843
                        ],
                        [
                            91.00841,
                            46.57546
                        ],
                        [
                            91.06695,
                            46.56647
                        ],
                        [
                            90.96354,
                            46.34206
                        ],
                        [
                            90.89883,
                            46.29008
                        ],
                        [
                            90.97226,
                            46.1644
                        ],
                        [
                            91.01978,
                            46.12725
                        ],
                        [
                            91.03193,
                            46.01254
                        ],
                        [
                            90.87753,
                            45.90892
                        ],
                        [
                            90.73133,
                            45.73356
                        ],
                        [
                            90.68687,
                            45.61673
                        ],
                        [
                            90.67133,
                            45.50785
                        ],
                        [
                            90.77253,
                            45.40535
                        ],
                        [
                            90.82604,
                            45.32455
                        ],
                        [
                            90.91417,
                            45.25336
                        ],
                        [
                            90.89472,
                            45.20146
                        ],
                        [
                            91.16816,
                            45.20805
                        ],
                        [
                            91.28644,
                            45.13954
                        ],
                        [
                            91.41893,
                            45.1264
                        ],
                        [
                            91.47467,
                            45.16169
                        ],
                        [
                            91.55424,
                            45.10872
                        ],
                        [
                            91.70654,
                            45.07824
                        ],
                        [
                            91.85933,
                            45.10026
                        ],
                        [
                            92.1089,
                            45.09765
                        ],
                        [
                            92.2379,
                            45.03701
                        ],
                        [
                            92.48726,
                            45.01311
                        ],
                        [
                            92.78912,
                            45.05438
                        ],
                        [
                            93.35513,
                            45.00637
                        ],
                        [
                            93.44315,
                            44.96917
                        ],
                        [
                            93.55542,
                            44.96773
                        ],
                        [
                            93.75151,
                            44.87561
                        ],
                        [
                            94.08359,
                            44.74946
                        ],
                        [
                            94.2134,
                            44.68686
                        ],
                        [
                            94.41155,
                            44.53781
                        ],
                        [
                            94.61612,
                            44.45678
                        ],
                        [
                            94.73921,
                            44.34888
                        ],
                        [
                            94.94523,
                            44.30683
                        ],
                        [
                            95.009,
                            44.26483
                        ],
                        [
                            95.41272,
                            44.30431
                        ],
                        [
                            95.36739,
                            44.22772
                        ],
                        [
                            95.33934,
                            44.03855
                        ],
                        [
                            95.53687,
                            44.00178
                        ],
                        [
                            95.62924,
                            43.8596
                        ],
                        [
                            95.64345,
                            43.77996
                        ],
                        [
                            95.75587,
                            43.57412
                        ],
                        [
                            95.86784,
                            43.39627
                        ],
                        [
                            95.91896,
                            43.2515
                        ],
                        [
                            96.38049,
                            42.90596
                        ],
                        [
                            96.40052,
                            42.73553
                        ],
                        [
                            96.71868,
                            42.76425
                        ],
                        [
                            97.02158,
                            42.76632
                        ],
                        [
                            97.19016,
                            42.79646
                        ],
                        [
                            98.1968,
                            42.65361
                        ],
                        [
                            98.98998,
                            42.60047
                        ],
                        [
                            99.50352,
                            42.56604
                        ],
                        [
                            99.97809,
                            42.65149
                        ],
                        [
                            100.26974,
                            42.64024
                        ],
                        [
                            100.3174,
                            42.69041
                        ],
                        [
                            100.84091,
                            42.67417
                        ],
                        [
                            101.58462,
                            42.52352
                        ],
                        [
                            101.79759,
                            42.50648
                        ],
                        [
                            102.07115,
                            42.23327
                        ],
                        [
                            102.46806,
                            42.1453
                        ],
                        [
                            102.53171,
                            42.16796
                        ],
                        [
                            102.62273,
                            42.14786
                        ],
                        [
                            102.71888,
                            42.15538
                        ],
                        [
                            103.01922,
                            42.02335
                        ],
                        [
                            103.41681,
                            41.88088
                        ],
                        [
                            103.85586,
                            41.79885
                        ],
                        [
                            104.07021,
                            41.80125
                        ],
                        [
                            104.51566,
                            41.87928
                        ],
                        [
                            104.5189,
                            41.66783
                        ],
                        [
                            104.66565,
                            41.64292
                        ],
                        [
                            104.91387,
                            41.662
                        ],
                        [
                            104.98484,
                            41.5873
                        ],
                        [
                            105.20796,
                            41.7498
                        ],
                        [
                            105.27544,
                            41.75258
                        ],
                        [
                            105.69879,
                            41.94293
                        ],
                        [
                            106.05127,
                            42.05815
                        ],
                        [
                            106.34232,
                            42.16476
                        ],
                        [
                            106.76758,
                            42.29179
                        ],
                        [
                            107.04064,
                            42.31861
                        ],
                        [
                            107.24432,
                            42.36202
                        ],
                        [
                            107.28726,
                            42.41125
                        ],
                        [
                            107.44421,
                            42.45458
                        ],
                        [
                            107.59727,
                            42.41237
                        ],
                        [
                            107.93262,
                            42.4021
                        ],
                        [
                            108.01616,
                            42.43526
                        ],
                        [
                            108.24042,
                            42.45713
                        ],
                        [
                            108.29184,
                            42.4389
                        ],
                        [
                            108.53903,
                            42.44
                        ],
                        [
                            108.85995,
                            42.39678
                        ],
                        [
                            109.0214,
                            42.45488
                        ],
                        [
                            109.30876,
                            42.43559
                        ],
                        [
                            109.53026,
                            42.46372
                        ],
                        [
                            109.67849,
                            42.55491
                        ],
                        [
                            109.91322,
                            42.63424
                        ],
                        [
                            110.11045,
                            42.6394
                        ],
                        [
                            110.14304,
                            42.67769
                        ],
                        [
                            110.33946,
                            42.73382
                        ],
                        [
                            110.43057,
                            42.77689
                        ],
                        [
                            110.46419,
                            42.83178
                        ],
                        [
                            110.62892,
                            42.93829
                        ],
                        [
                            110.67087,
                            43.0271
                        ],
                        [
                            110.76229,
                            43.09448
                        ],
                        [
                            110.9684,
                            43.29168
                        ],
                        [
                            111.10558,
                            43.36697
                        ],
                        [
                            111.36025,
                            43.44028
                        ],
                        [
                            111.41965,
                            43.47855
                        ],
                        [
                            111.59282,
                            43.50348
                        ],
                        [
                            111.78886,
                            43.66494
                        ],
                        [
                            111.919,
                            43.67811
                        ],
                        [
                            111.97077,
                            43.74
                        ],
                        [
                            111.95245,
                            43.82191
                        ],
                        [
                            111.90577,
                            43.89051
                        ],
                        [
                            111.8044,
                            43.98083
                        ],
                        [
                            111.70944,
                            44.02818
                        ],
                        [
                            111.60061,
                            44.1117
                        ],
                        [
                            111.53872,
                            44.19225
                        ],
                        [
                            111.51522,
                            44.27372
                        ],
                        [
                            111.41153,
                            44.34785
                        ],
                        [
                            111.42287,
                            44.39848
                        ],
                        [
                            111.53408,
                            44.55881
                        ],
                        [
                            111.56663,
                            44.57466
                        ],
                        [
                            111.56268,
                            44.6704
                        ],
                        [
                            111.74363,
                            44.94714
                        ],
                        [
                            111.78498,
                            44.98815
                        ],
                        [
                            111.95827,
                            45.08272
                        ],
                        [
                            112.05307,
                            45.10048
                        ],
                        [
                            112.11437,
                            45.07521
                        ],
                        [
                            112.31919,
                            45.06052
                        ],
                        [
                            112.42505,
                            45.08844
                        ],
                        [
                            112.59924,
                            44.93102
                        ],
                        [
                            112.70995,
                            44.88204
                        ],
                        [
                            112.86306,
                            44.83747
                        ],
                        [
                            112.94819,
                            44.83975
                        ],
                        [
                            113.11845,
                            44.7931
                        ],
                        [
                            113.49686,
                            44.77793
                        ],
                        [
                            113.6178,
                            44.74392
                        ],
                        [
                            113.75377,
                            44.8414
                        ],
                        [
                            113.84509,
                            44.86753
                        ],
                        [
                            113.8864,
                            44.91783
                        ],
                        [
                            114.04508,
                            44.93553
                        ],
                        [
                            114.13667,
                            44.98892
                        ],
                        [
                            114.16664,
                            45.03765
                        ],
                        [
                            114.31691,
                            45.11883
                        ],
                        [
                            114.45204,
                            45.21744
                        ],
                        [
                            114.51533,
                            45.29728
                        ],
                        [
                            114.53187,
                            45.37744
                        ],
                        [
                            114.73075,
                            45.43619
                        ],
                        [
                            114.91987,
                            45.37987
                        ],
                        [
                            115.22789,
                            45.397
                        ],
                        [
                            115.34171,
                            45.39072
                        ],
                        [
                            115.67801,
                            45.46094
                        ],
                        [
                            115.94443,
                            45.637
                        ],
                        [
                            116.06044,
                            45.68735
                        ],
                        [
                            116.18089,
                            45.69874
                        ],
                        [
                            116.2718,
                            45.77379
                        ],
                        [
                            116.24164,
                            45.87355
                        ],
                        [
                            116.27824,
                            45.98116
                        ],
                        [
                            116.40043,
                            46.12317
                        ],
                        [
                            116.59867,
                            46.307
                        ],
                        [
                            116.75748,
                            46.32477
                        ],
                        [
                            116.82345,
                            46.38214
                        ],
                        [
                            116.99891,
                            46.36369
                        ],
                        [
                            117.32553,
                            46.36101
                        ],
                        [
                            117.4289,
                            46.53669
                        ],
                        [
                            117.43706,
                            46.58756
                        ],
                        [
                            117.5802,
                            46.59968
                        ],
                        [
                            117.68789,
                            46.5217
                        ],
                        [
                            117.81892,
                            46.55105
                        ],
                        [
                            117.90073,
                            46.61358
                        ],
                        [
                            118.04589,
                            46.64167
                        ],
                        [
                            118.30402,
                            46.74747
                        ],
                        [
                            118.41763,
                            46.70615
                        ],
                        [
                            118.54569,
                            46.69716
                        ],
                        [
                            118.6255,
                            46.72419
                        ],
                        [
                            118.73784,
                            46.6957
                        ],
                        [
                            118.83478,
                            46.77345
                        ],
                        [
                            118.92808,
                            46.73295
                        ],
                        [
                            119.01015,
                            46.74859
                        ],
                        [
                            119.08844,
                            46.66047
                        ],
                        [
                            119.22877,
                            46.65721
                        ],
                        [
                            119.30537,
                            46.6248
                        ],
                        [
                            119.55443,
                            46.64447
                        ],
                        [
                            119.66183,
                            46.64073
                        ],
                        [
                            119.70813,
                            46.61026
                        ],
                        [
                            119.80767,
                            46.6857
                        ],
                        [
                            119.90681,
                            46.68953
                        ],
                        [
                            119.93029,
                            46.80085
                        ],
                        [
                            119.90489,
                            46.87997
                        ],
                        [
                            119.77873,
                            47.00398
                        ],
                        [
                            119.76766,
                            47.1105
                        ],
                        [
                            119.70876,
                            47.18439
                        ],
                        [
                            119.54322,
                            47.30108
                        ],
                        [
                            119.3787,
                            47.3906
                        ],
                        [
                            119.35927,
                            47.47938
                        ],
                        [
                            119.14512,
                            47.52145
                        ],
                        [
                            119.12061,
                            47.65679
                        ],
                        [
                            118.76897,
                            47.77242
                        ],
                        [
                            118.5613,
                            47.99477
                        ],
                        [
                            118.46563,
                            47.99168
                        ],
                        [
                            118.41316,
                            48.02254
                        ],
                        [
                            118.27737,
                            48.01946
                        ],
                        [
                            118.17064,
                            48.06395
                        ],
                        [
                            118.03896,
                            48.0228
                        ],
                        [
                            117.8723,
                            48.03514
                        ],
                        [
                            117.79,
                            48.0228
                        ],
                        [
                            117.47726,
                            47.76561
                        ],
                        [
                            117.36616,
                            47.65451
                        ],
                        [
                            117.06576,
                            47.83557
                        ],
                        [
                            116.84355,
                            47.90346
                        ],
                        [
                            116.67895,
                            47.90141
                        ],
                        [
                            116.42794,
                            47.84997
                        ],
                        [
                            116.24688,
                            47.88495
                        ],
                        [
                            116.11726,
                            47.83557
                        ],
                        [
                            115.94237,
                            47.68537
                        ],
                        [
                            115.55958,
                            47.92707
                        ],
                        [
                            115.5291,
                            48.05285
                        ],
                        [
                            115.5299,
                            48.13809
                        ],
                        [
                            115.81217,
                            48.25769
                        ],
                        [
                            115.78434,
                            48.51517
                        ],
                        [
                            116.07276,
                            48.81483
                        ],
                        [
                            116.0411,
                            48.86377
                        ],
                        [
                            116.72094,
                            49.84979
                        ],
                        [
                            116.60721,
                            49.93963
                        ],
                        [
                            116.44647,
                            49.96358
                        ],
                        [
                            116.20434,
                            50.0314
                        ],
                        [
                            116.02437,
                            49.99756
                        ],
                        [
                            115.77549,
                            49.89318
                        ],
                        [
                            115.37255,
                            49.90921
                        ],
                        [
                            115.23473,
                            49.98164
                        ],
                        [
                            114.9666,
                            50.19228
                        ],
                        [
                            114.67278,
                            50.25602
                        ],
                        [
                            114.50604,
                            50.23741
                        ],
                        [
                            114.34412,
                            50.28233
                        ],
                        [
                            114.19739,
                            50.24754
                        ],
                        [
                            114.02016,
                            50.17981
                        ],
                        [
                            113.8689,
                            50.08566
                        ],
                        [
                            113.77981,
                            50.09009
                        ],
                        [
                            113.59871,
                            50.02167
                        ],
                        [
                            113.53147,
                            49.97738
                        ],
                        [
                            113.23205,
                            49.83563
                        ],
                        [
                            113.18522,
                            49.79921
                        ],
                        [
                            113.08395,
                            49.60768
                        ],
                        [
                            112.96871,
                            49.58701
                        ],
                        [
                            112.7438,
                            49.49065
                        ],
                        [
                            112.65106,
                            49.52694
                        ],
                        [
                            112.50967,
                            49.54577
                        ],
                        [
                            112.28772,
                            49.49004
                        ],
                        [
                            112.12829,
                            49.43535
                        ],
                        [
                            111.89574,
                            49.39178
                        ],
                        [
                            111.72751,
                            49.40591
                        ],
                        [
                            111.50485,
                            49.34427
                        ],
                        [
                            111.39578,
                            49.37214
                        ],
                        [
                            111.32273,
                            49.3348
                        ],
                        [
                            111.17003,
                            49.30023
                        ],
                        [
                            110.9925,
                            49.20033
                        ],
                        [
                            110.76441,
                            49.14523
                        ],
                        [
                            110.59645,
                            49.16235
                        ],
                        [
                            110.41605,
                            49.25025
                        ],
                        [
                            110.29988,
                            49.18104
                        ],
                        [
                            110.18292,
                            49.16791
                        ],
                        [
                            110.05159,
                            49.195
                        ],
                        [
                            109.69893,
                            49.23136
                        ],
                        [
                            109.5878,
                            49.22287
                        ],
                        [
                            109.48379,
                            49.28747
                        ],
                        [
                            109.32656,
                            49.34164
                        ],
                        [
                            109.18499,
                            49.35994
                        ],
                        [
                            109.04617,
                            49.33664
                        ],
                        [
                            108.96102,
                            49.35906
                        ],
                        [
                            108.8765,
                            49.34274
                        ],
                        [
                            108.54556,
                            49.33679
                        ],
                        [
                            108.36984,
                            49.44243
                        ],
                        [
                            108.28466,
                            49.52753
                        ],
                        [
                            108.15644,
                            49.55429
                        ],
                        [
                            108.05258,
                            49.60037
                        ],
                        [
                            107.93991,
                            49.70048
                        ],
                        [
                            107.981,
                            49.74248
                        ],
                        [
                            107.95221,
                            49.82449
                        ],
                        [
                            107.97644,
                            49.90329
                        ],
                        [
                            107.85524,
                            49.9219
                        ],
                        [
                            107.75744,
                            49.9775
                        ],
                        [
                            107.58446,
                            49.95876
                        ],
                        [
                            107.14636,
                            50.02045
                        ],
                        [
                            107.03714,
                            50.1111
                        ],
                        [
                            106.99682,
                            50.19219
                        ],
                        [
                            106.92207,
                            50.24856
                        ],
                        [
                            106.75933,
                            50.32081
                        ],
                        [
                            106.59705,
                            50.34441
                        ],
                        [
                            106.47605,
                            50.33682
                        ],
                        [
                            106.27626,
                            50.29688
                        ],
                        [
                            106.09525,
                            50.35089
                        ],
                        [
                            106.0297,
                            50.41241
                        ],
                        [
                            105.84385,
                            50.43004
                        ],
                        [
                            105.61242,
                            50.43261
                        ],
                        [
                            105.38734,
                            50.47869
                        ],
                        [
                            105.28321,
                            50.46615
                        ],
                        [
                            105.09412,
                            50.39117
                        ],
                        [
                            104.91136,
                            50.38795
                        ],
                        [
                            104.82175,
                            50.35598
                        ],
                        [
                            104.72185,
                            50.3548
                        ],
                        [
                            104.59354,
                            50.31467
                        ],
                        [
                            104.39991,
                            50.30348
                        ],
                        [
                            104.28337,
                            50.25093
                        ],
                        [
                            104.24778,
                            50.1987
                        ],
                        [
                            104.06304,
                            50.15505
                        ],
                        [
                            103.84557,
                            50.20463
                        ],
                        [
                            103.75974,
                            50.19511
                        ],
                        [
                            103.69128,
                            50.13801
                        ],
                        [
                            103.44103,
                            50.21473
                        ],
                        [
                            103.28753,
                            50.21943
                        ],
                        [
                            103.20601,
                            50.31184
                        ],
                        [
                            102.97936,
                            50.30454
                        ],
                        [
                            102.8894,
                            50.32605
                        ],
                        [
                            102.82609,
                            50.37747
                        ],
                        [
                            102.6435,
                            50.42917
                        ],
                        [
                            102.50356,
                            50.54055
                        ],
                        [
                            102.3356,
                            50.57673
                        ],
                        [
                            102.28978,
                            50.62893
                        ],
                        [
                            102.35223,
                            50.72493
                        ],
                        [
                            102.33699,
                            50.76498
                        ],
                        [
                            102.23272,
                            50.82751
                        ],
                        [
                            102.26562,
                            50.9695
                        ],
                        [
                            102.19434,
                            51.07261
                        ],
                        [
                            102.15218,
                            51.2659
                        ],
                        [
                            102.21351,
                            51.31388
                        ],
                        [
                            102.06463,
                            51.39681
                        ],
                        [
                            101.85465,
                            51.42215
                        ],
                        [
                            101.74914,
                            51.46015
                        ],
                        [
                            101.64149,
                            51.45817
                        ],
                        [
                            101.5346,
                            51.50294
                        ],
                        [
                            101.34541,
                            51.47239
                        ],
                        [
                            101.26354,
                            51.53567
                        ],
                        [
                            101.14183,
                            51.54395
                        ],
                        [
                            100.94622,
                            51.625
                        ],
                        [
                            100.74866,
                            51.67668
                        ],
                        [
                            100.70032,
                            51.70465
                        ],
                        [
                            100.51896,
                            51.74923
                        ],
                        [
                            100.28254,
                            51.745
                        ],
                        [
                            100.12587,
                            51.7602
                        ],
                        [
                            99.99134,
                            51.75446
                        ],
                        [
                            99.89412,
                            51.78902
                        ],
                        [
                            99.72811,
                            51.90101
                        ],
                        [
                            99.57184,
                            51.9182
                        ],
                        [
                            99.29479,
                            51.97642
                        ],
                        [
                            99.28544,
                            52.00743
                        ],
                        [
                            99.05163,
                            52.07122
                        ],
                        [
                            98.95903,
                            52.14429
                        ],
                        [
                            98.88018,
                            52.13929
                        ],
                        [
                            98.73014,
                            51.85099
                        ],
                        [
                            98.69443,
                            51.81986
                        ],
                        [
                            98.34539,
                            51.73555
                        ],
                        [
                            98.24161,
                            51.56777
                        ],
                        [
                            98.23397,
                            51.4629
                        ],
                        [
                            98.05205,
                            51.43958
                        ],
                        [
                            97.94655,
                            51.32435
                        ],
                        [
                            97.95251,
                            51.23144
                        ],
                        [
                            97.90902,
                            51.17246
                        ],
                        [
                            97.86689,
                            51.04557
                        ],
                        [
                            97.83003,
                            51.00397
                        ],
                        [
                            97.86868,
                            50.95007
                        ],
                        [
                            98.01068,
                            50.87512
                        ],
                        [
                            97.95557,
                            50.78125
                        ],
                        [
                            98.04855,
                            50.65359
                        ],
                        [
                            98.12943,
                            50.59862
                        ],
                        [
                            98.26456,
                            50.57444
                        ],
                        [
                            98.32338,
                            50.53725
                        ],
                        [
                            98.25729,
                            50.4117
                        ],
                        [
                            98.27781,
                            50.3148
                        ],
                        [
                            98.25493,
                            50.25699
                        ],
                        [
                            98.15092,
                            50.17746
                        ],
                        [
                            98.05964,
                            50.05507
                        ],
                        [
                            97.91669,
                            49.99639
                        ],
                        [
                            97.87538,
                            49.95263
                        ],
                        [
                            97.7619,
                            49.9829
                        ],
                        [
                            97.42825,
                            49.78795
                        ],
                        [
                            97.31547,
                            49.75772
                        ],
                        [
                            97.21906,
                            49.76891
                        ],
                        [
                            97.09218,
                            49.83889
                        ],
                        [
                            96.9986,
                            49.91526
                        ],
                        [
                            96.84107,
                            49.94315
                        ],
                        [
                            96.71609,
                            49.90792
                        ],
                        [
                            96.66015,
                            49.97471
                        ],
                        [
                            96.53567,
                            49.95666
                        ],
                        [
                            96.40421,
                            49.90512
                        ],
                        [
                            96.29369,
                            49.99035
                        ],
                        [
                            96.07674,
                            50.01953
                        ],
                        [
                            95.96958,
                            49.98052
                        ],
                        [
                            95.8629,
                            50.04086
                        ],
                        [
                            95.76129,
                            50.01328
                        ],
                        [
                            95.72168,
                            49.96191
                        ],
                        [
                            95.47546,
                            49.92298
                        ],
                        [
                            95.33382,
                            49.95126
                        ],
                        [
                            95.13285,
                            49.94898
                        ],
                        [
                            95.03991,
                            49.98372
                        ],
                        [
                            94.98198,
                            50.05724
                        ],
                        [
                            94.83913,
                            50.06204
                        ],
                        [
                            94.6436,
                            50.02928
                        ],
                        [
                            94.52949,
                            50.12401
                        ],
                        [
                            94.51115,
                            50.16839
                        ],
                        [
                            94.39844,
                            50.23594
                        ],
                        [
                            94.34858,
                            50.46366
                        ],
                        [
                            94.30303,
                            50.55201
                        ],
                        [
                            94.22204,
                            50.58261
                        ],
                        [
                            93.9534,
                            50.59117
                        ],
                        [
                            93.6737,
                            50.57816
                        ],
                        [
                            93.40273,
                            50.5857
                        ],
                        [
                            93.10905,
                            50.56615
                        ],
                        [
                            93.00227,
                            50.60329
                        ],
                        [
                            92.98313,
                            50.65901
                        ],
                        [
                            93.03189,
                            50.7616
                        ],
                        [
                            92.99213,
                            50.78834
                        ],
                        [
                            92.84642,
                            50.79397
                        ],
                        [
                            92.7498,
                            50.7541
                        ],
                        [
                            92.74774,
                            50.7101
                        ],
                        [
                            92.60764,
                            50.71622
                        ],
                        [
                            92.58958,
                            50.7703
                        ],
                        [
                            92.46627,
                            50.77955
                        ],
                        [
                            92.4131,
                            50.8153
                        ],
                        [
                            92.40096,
                            50.8811
                        ],
                        [
                            92.32258,
                            50.88078
                        ],
                        [
                            92.28765,
                            50.80842
                        ],
                        [
                            92.28931,
                            50.72564
                        ],
                        [
                            92.19507,
                            50.68516
                        ],
                        [
                            92.02177,
                            50.68408
                        ],
                        [
                            91.88359,
                            50.73014
                        ],
                        [
                            91.75748,
                            50.7199
                        ],
                        [
                            91.6567,
                            50.66022
                        ],
                        [
                            91.6477,
                            50.57777
                        ],
                        [
                            91.44087,
                            50.54611
                        ],
                        [
                            91.42399,
                            50.45865
                        ],
                        [
                            91.28836,
                            50.47987
                        ],
                        [
                            91.13955,
                            50.43299
                        ],
                        [
                            90.94925,
                            50.43783
                        ],
                        [
                            90.8976,
                            50.35929
                        ],
                        [
                            90.82031,
                            50.36085
                        ],
                        [
                            90.70241,
                            50.30939
                        ],
                        [
                            90.67497,
                            50.22796
                        ],
                        [
                            90.55345,
                            50.25083
                        ],
                        [
                            90.39945,
                            50.20967
                        ],
                        [
                            90.28163,
                            50.13364
                        ],
                        [
                            90.13719,
                            50.11596
                        ],
                        [
                            90.01729,
                            50.07419
                        ],
                        [
                            90.00878,
                            50.00113
                        ],
                        [
                            89.94313,
                            49.97482
                        ],
                        [
                            89.70832,
                            49.95826
                        ],
                        [
                            89.63781,
                            49.90593
                        ],
                        [
                            89.65299,
                            49.81586
                        ],
                        [
                            89.73776,
                            49.79548
                        ],
                        [
                            89.6806,
                            49.71015
                        ],
                        [
                            89.44673,
                            49.65909
                        ],
                        [
                            89.36816,
                            49.59749
                        ],
                        [
                            89.22296,
                            49.6454
                        ],
                        [
                            89.2236,
                            49.56537
                        ],
                        [
                            89.12678,
                            49.50692
                        ],
                        [
                            88.96861,
                            49.48075
                        ],
                        [
                            88.89106,
                            49.55554
                        ],
                        [
                            88.8462,
                            49.50694
                        ],
                        [
                            88.86766,
                            49.45689
                        ],
                        [
                            88.68301,
                            49.47368
                        ],
                        [
                            88.64915,
                            49.52047
                        ],
                        [
                            88.55556,
                            49.48524
                        ],
                        [
                            88.45178,
                            49.47925
                        ],
                        [
                            88.33949,
                            49.50775
                        ],
                        [
                            88.22228,
                            49.48942
                        ],
                        [
                            88.18798,
                            49.43048
                        ],
                        [
                            88.09695,
                            49.37296
                        ],
                        [
                            88.19294,
                            49.28402
                        ],
                        [
                            88.1268,
                            49.24482
                        ],
                        [
                            88.05494,
                            49.26588
                        ],
                        [
                            87.99419,
                            49.18699
                        ],
                        [
                            87.89911,
                            49.16721
                        ],
                        [
                            87.82497,
                            49.18332
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "MNE",
                "Country": "Montenegro",
                "Total_3GHG": 0.01,
                "Total_3GHG_timeseries": [
                    4.1667e-07,
                    8.5394e-07,
                    1.3093e-06,
                    1.7711e-06,
                    2.2344e-06,
                    2.7064e-06,
                    3.1888e-06,
                    3.685e-06,
                    4.1693e-06,
                    4.6537e-06,
                    5.1435e-06,
                    5.6271e-06,
                    6.1271e-06,
                    6.6093e-06,
                    7.1226e-06,
                    7.6501e-06,
                    8.1986e-06,
                    8.7311e-06,
                    9.2837e-06,
                    9.8561e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_3GHG": 0.01,
                "Fossil_3GHG_timeseries": [
                    3.7941e-09,
                    7.6239e-09,
                    1.1489e-08,
                    1.5389e-08,
                    1.9323e-08,
                    2.329e-08,
                    2.729e-08,
                    3.1321e-08,
                    3.5383e-08,
                    3.9473e-08,
                    4.3631e-08,
                    4.7856e-08,
                    5.2148e-08,
                    5.6508e-08,
                    6.0934e-08,
                    6.5428e-08,
                    6.9988e-08,
                    7.4615e-08,
                    7.931e-08,
                    8.4071e-08,
                    8.8914e-08,
                    9.385e-08,
                    9.8889e-08,
                    1.0404e-07,
                    1.093e-07,
                    1.1467e-07,
                    1.2016e-07,
                    1.2575e-07,
                    1.3145e-07,
                    1.3723e-07,
                    1.4306e-07,
                    1.4895e-07,
                    1.5488e-07,
                    1.6086e-07,
                    1.6709e-07,
                    1.7317e-07,
                    1.793e-07,
                    1.8547e-07,
                    1.9169e-07,
                    1.9858e-07,
                    2.0562e-07,
                    2.128e-07,
                    2.2063e-07,
                    2.2977e-07,
                    2.3897e-07,
                    2.4853e-07,
                    2.575e-07,
                    2.677e-07,
                    2.7854e-07,
                    2.9087e-07,
                    3.0346e-07,
                    3.1543e-07,
                    3.2763e-07,
                    3.3997e-07,
                    3.5261e-07,
                    3.6636e-07,
                    3.8e-07,
                    3.94e-07,
                    4.0798e-07,
                    4.2156e-07,
                    4.3565e-07,
                    4.4971e-07,
                    4.8163e-07,
                    4.8472e-07,
                    4.8751e-07,
                    4.8998e-07,
                    4.9212e-07,
                    4.9394e-07,
                    5.1586e-07,
                    5.4413e-07,
                    5.779e-07,
                    6.2861e-07,
                    6.8706e-07,
                    7.5069e-07,
                    8.2972e-07,
                    9.121e-07,
                    1.0058e-06,
                    1.1121e-06,
                    1.2293e-06,
                    1.3475e-06,
                    1.466e-06,
                    1.5845e-06,
                    1.7045e-06,
                    1.8324e-06,
                    1.9688e-06,
                    2.1104e-06,
                    2.2645e-06,
                    2.4216e-06,
                    2.5881e-06,
                    2.7702e-06,
                    2.8851e-06,
                    3.0032e-06,
                    3.1274e-06,
                    3.253e-06,
                    3.4062e-06,
                    3.5922e-06,
                    3.8032e-06,
                    4.0238e-06,
                    4.2568e-06,
                    4.481e-06,
                    4.6942e-06,
                    4.9042e-06,
                    5.11e-06,
                    5.3338e-06,
                    5.5728e-06,
                    5.8284e-06,
                    6.0928e-06,
                    6.3471e-06,
                    6.6215e-06,
                    6.9078e-06,
                    7.1942e-06,
                    7.4755e-06,
                    7.7739e-06,
                    8.0977e-06,
                    8.4218e-06,
                    8.7335e-06,
                    9.0392e-06,
                    9.3594e-06,
                    9.6848e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_3GHG": 0.01,
                "Land_3GHG_timeseries": [
                    4.1288e-07,
                    8.4632e-07,
                    1.2978e-06,
                    1.7557e-06,
                    2.2151e-06,
                    2.6831e-06,
                    3.1615e-06,
                    3.6536e-06,
                    4.134e-06,
                    4.6142e-06,
                    5.0999e-06,
                    5.5792e-06,
                    6.0749e-06,
                    6.5528e-06,
                    7.0617e-06,
                    7.5847e-06,
                    8.1286e-06,
                    8.6565e-06,
                    9.2044e-06,
                    9.772e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_CO2": 0.01,
                "Total_CO2_timeseries": [
                    3.4774e-07,
                    7.1562e-07,
                    1.1011e-06,
                    1.4926e-06,
                    1.8852e-06,
                    2.286e-06,
                    2.6967e-06,
                    3.1208e-06,
                    3.5326e-06,
                    3.9441e-06,
                    4.3587e-06,
                    4.7646e-06,
                    5.1846e-06,
                    5.5844e-06,
                    6.0131e-06,
                    6.4535e-06,
                    6.9126e-06,
                    7.3534e-06,
                    7.8119e-06,
                    8.2878e-06,
                    8.7407e-06,
                    9.2129e-06,
                    9.7037e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_CO2": 0.01,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2.0085e-10,
                    2.0085e-10,
                    2.0085e-10,
                    2.0085e-10,
                    2.0085e-10,
                    8.0293e-10,
                    1.5054e-09,
                    2.2832e-09,
                    3.663e-09,
                    6.2969e-09,
                    8.9309e-09,
                    1.1866e-08,
                    1.4149e-08,
                    1.7611e-08,
                    2.165e-08,
                    2.7119e-08,
                    3.3089e-08,
                    3.8684e-08,
                    4.4754e-08,
                    5.1227e-08,
                    5.8251e-08,
                    6.6655e-08,
                    7.521e-08,
                    8.4417e-08,
                    9.3874e-08,
                    1.0323e-07,
                    1.1337e-07,
                    1.2375e-07,
                    1.5228e-07,
                    1.5228e-07,
                    1.5228e-07,
                    1.5228e-07,
                    1.5228e-07,
                    1.5228e-07,
                    1.7272e-07,
                    1.9987e-07,
                    2.2877e-07,
                    2.7076e-07,
                    3.1657e-07,
                    3.6353e-07,
                    4.1508e-07,
                    4.6528e-07,
                    5.22e-07,
                    5.8643e-07,
                    6.5669e-07,
                    7.2282e-07,
                    7.8393e-07,
                    8.3965e-07,
                    8.9121e-07,
                    9.4487e-07,
                    1.001e-06,
                    1.0564e-06,
                    1.1181e-06,
                    1.1766e-06,
                    1.2379e-06,
                    1.3085e-06,
                    1.3085e-06,
                    1.3085e-06,
                    1.3111e-06,
                    1.3117e-06,
                    1.3473e-06,
                    1.4178e-06,
                    1.5158e-06,
                    1.6263e-06,
                    1.7525e-06,
                    1.8737e-06,
                    1.9885e-06,
                    2.1037e-06,
                    2.2182e-06,
                    2.3547e-06,
                    2.5111e-06,
                    2.6898e-06,
                    2.8839e-06,
                    3.0752e-06,
                    3.2945e-06,
                    3.534e-06,
                    3.7851e-06,
                    4.0427e-06,
                    4.3293e-06,
                    4.654e-06,
                    4.9881e-06,
                    5.3192e-06,
                    5.6536e-06,
                    6.0113e-06,
                    6.3821e-06,
                    6.8667e-06,
                    7.389e-06,
                    7.8785e-06,
                    8.4633e-06,
                    9.0506e-06,
                    9.6635e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CO2": 0.01,
                "Land_CO2_timeseries": [
                    3.4774e-07,
                    7.1562e-07,
                    1.1011e-06,
                    1.4926e-06,
                    1.8852e-06,
                    2.286e-06,
                    2.6967e-06,
                    3.1208e-06,
                    3.5326e-06,
                    3.9441e-06,
                    4.3587e-06,
                    4.7646e-06,
                    5.1846e-06,
                    5.5844e-06,
                    6.0131e-06,
                    6.4535e-06,
                    6.9126e-06,
                    7.3534e-06,
                    7.8119e-06,
                    8.2878e-06,
                    8.7407e-06,
                    9.2129e-06,
                    9.7037e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_CH4": 0.01,
                "Total_CH4_timeseries": [
                    6.3918e-08,
                    1.2822e-07,
                    1.929e-07,
                    2.5797e-07,
                    3.2343e-07,
                    3.8926e-07,
                    4.5548e-07,
                    5.2209e-07,
                    5.8907e-07,
                    6.5645e-07,
                    7.2615e-07,
                    7.9818e-07,
                    8.7254e-07,
                    9.4923e-07,
                    1.0282e-06,
                    1.1096e-06,
                    1.1933e-06,
                    1.2793e-06,
                    1.3676e-06,
                    1.4583e-06,
                    1.5516e-06,
                    1.6477e-06,
                    1.7464e-06,
                    1.8477e-06,
                    1.9518e-06,
                    2.0585e-06,
                    2.168e-06,
                    2.28e-06,
                    2.3948e-06,
                    2.5123e-06,
                    2.631e-06,
                    2.751e-06,
                    2.8722e-06,
                    2.9947e-06,
                    3.1185e-06,
                    3.2436e-06,
                    3.3699e-06,
                    3.4975e-06,
                    3.6263e-06,
                    3.7564e-06,
                    3.8879e-06,
                    4.0209e-06,
                    4.1552e-06,
                    4.2909e-06,
                    4.4281e-06,
                    4.5666e-06,
                    4.7065e-06,
                    4.8479e-06,
                    4.9906e-06,
                    5.1348e-06,
                    5.2802e-06,
                    5.4268e-06,
                    5.5747e-06,
                    5.7238e-06,
                    5.8741e-06,
                    6.0256e-06,
                    6.1784e-06,
                    6.3323e-06,
                    6.4875e-06,
                    6.6438e-06,
                    6.8038e-06,
                    6.9675e-06,
                    7.1349e-06,
                    7.3059e-06,
                    7.4806e-06,
                    7.6589e-06,
                    7.8409e-06,
                    8.0264e-06,
                    8.2156e-06,
                    8.4084e-06,
                    8.6097e-06,
                    8.8195e-06,
                    9.0379e-06,
                    9.2651e-06,
                    9.5078e-06,
                    9.7599e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_CH4": 0.01,
                "Fossil_CH4_timeseries": [
                    1.2602e-09,
                    2.5268e-09,
                    3.7997e-09,
                    5.079e-09,
                    6.3645e-09,
                    7.6563e-09,
                    8.9543e-09,
                    1.0259e-08,
                    1.1569e-08,
                    1.2886e-08,
                    1.4249e-08,
                    1.5657e-08,
                    1.7112e-08,
                    1.8613e-08,
                    2.0159e-08,
                    2.1751e-08,
                    2.3388e-08,
                    2.5071e-08,
                    2.68e-08,
                    2.8574e-08,
                    3.0401e-08,
                    3.2279e-08,
                    3.421e-08,
                    3.6193e-08,
                    3.8228e-08,
                    4.0315e-08,
                    4.2454e-08,
                    4.4644e-08,
                    4.6886e-08,
                    4.918e-08,
                    5.1496e-08,
                    5.3835e-08,
                    5.6195e-08,
                    5.8578e-08,
                    6.0982e-08,
                    6.3409e-08,
                    6.5857e-08,
                    6.8328e-08,
                    7.082e-08,
                    7.3334e-08,
                    7.5872e-08,
                    7.8434e-08,
                    8.102e-08,
                    8.363e-08,
                    8.6264e-08,
                    8.8921e-08,
                    9.1602e-08,
                    9.4307e-08,
                    9.7035e-08,
                    9.9787e-08,
                    1.0226e-07,
                    1.0444e-07,
                    1.0632e-07,
                    1.0791e-07,
                    1.0919e-07,
                    1.1015e-07,
                    1.108e-07,
                    1.1112e-07,
                    1.1111e-07,
                    1.1077e-07,
                    1.1011e-07,
                    1.0913e-07,
                    1.0783e-07,
                    1.0619e-07,
                    1.042e-07,
                    1.0186e-07,
                    9.9154e-08,
                    9.6074e-08,
                    9.2614e-08,
                    8.8762e-08,
                    8.8609e-08,
                    9.225e-08,
                    9.9778e-08,
                    1.1129e-07,
                    1.3355e-07,
                    1.6048e-07,
                    1.9217e-07,
                    2.2873e-07,
                    2.7026e-07,
                    3.1687e-07,
                    3.6871e-07,
                    4.259e-07,
                    4.8856e-07,
                    5.5682e-07,
                    6.3078e-07,
                    7.1056e-07,
                    7.9628e-07,
                    8.8806e-07,
                    9.8601e-07,
                    1.0902e-06,
                    1.1975e-06,
                    1.3078e-06,
                    1.4211e-06,
                    1.5376e-06,
                    1.6463e-06,
                    1.7526e-06,
                    1.856e-06,
                    1.956e-06,
                    2.0523e-06,
                    2.1443e-06,
                    2.2313e-06,
                    2.3138e-06,
                    2.3919e-06,
                    2.4649e-06,
                    2.5319e-06,
                    2.5918e-06,
                    2.6437e-06,
                    2.6867e-06,
                    2.7203e-06,
                    2.7441e-06,
                    2.7547e-06,
                    2.7519e-06,
                    2.7352e-06,
                    2.7036e-06,
                    2.6608e-06,
                    2.6064e-06,
                    2.5403e-06,
                    2.463e-06,
                    2.3755e-06,
                    2.8486e-06,
                    3.3463e-06,
                    3.8418e-06,
                    4.3486e-06,
                    4.8832e-06,
                    5.4442e-06,
                    6.0091e-06,
                    6.5996e-06,
                    7.1863e-06,
                    7.7964e-06,
                    8.429e-06,
                    9.1048e-06,
                    9.8313e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CH4": 0.01,
                "Land_CH4_timeseries": [
                    6.2657e-08,
                    1.2569e-07,
                    1.891e-07,
                    2.5289e-07,
                    3.1706e-07,
                    3.8161e-07,
                    4.4653e-07,
                    5.1183e-07,
                    5.7751e-07,
                    6.4356e-07,
                    7.119e-07,
                    7.8252e-07,
                    8.5543e-07,
                    9.3062e-07,
                    1.0081e-06,
                    1.0878e-06,
                    1.1699e-06,
                    1.2542e-06,
                    1.3408e-06,
                    1.4297e-06,
                    1.5212e-06,
                    1.6154e-06,
                    1.7122e-06,
                    1.8116e-06,
                    1.9136e-06,
                    2.0182e-06,
                    2.1255e-06,
                    2.2354e-06,
                    2.3479e-06,
                    2.4631e-06,
                    2.5795e-06,
                    2.6971e-06,
                    2.816e-06,
                    2.9361e-06,
                    3.0575e-06,
                    3.1802e-06,
                    3.304e-06,
                    3.4291e-06,
                    3.5555e-06,
                    3.6831e-06,
                    3.8121e-06,
                    3.9424e-06,
                    4.0742e-06,
                    4.2073e-06,
                    4.3418e-06,
                    4.4777e-06,
                    4.6149e-06,
                    4.7536e-06,
                    4.8936e-06,
                    5.035e-06,
                    5.1779e-06,
                    5.3224e-06,
                    5.4684e-06,
                    5.6159e-06,
                    5.7649e-06,
                    5.9155e-06,
                    6.0676e-06,
                    6.2212e-06,
                    6.3764e-06,
                    6.533e-06,
                    6.6937e-06,
                    6.8584e-06,
                    7.0271e-06,
                    7.1997e-06,
                    7.3764e-06,
                    7.5571e-06,
                    7.7417e-06,
                    7.9304e-06,
                    8.123e-06,
                    8.3197e-06,
                    8.5211e-06,
                    8.7272e-06,
                    8.9381e-06,
                    9.1538e-06,
                    9.3742e-06,
                    9.5994e-06,
                    9.8294e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_N2O": 0.01,
                "Total_N2O_timeseries": [
                    5.0117e-09,
                    1.0102e-08,
                    1.5269e-08,
                    2.0509e-08,
                    2.5818e-08,
                    3.119e-08,
                    3.6618e-08,
                    4.2097e-08,
                    4.7616e-08,
                    5.3168e-08,
                    5.8747e-08,
                    6.435e-08,
                    6.9977e-08,
                    7.5628e-08,
                    8.1301e-08,
                    8.6997e-08,
                    9.2717e-08,
                    9.8461e-08,
                    1.0423e-07,
                    1.1003e-07,
                    1.159e-07,
                    1.2193e-07,
                    1.2819e-07,
                    1.3471e-07,
                    1.4153e-07,
                    1.4866e-07,
                    1.5607e-07,
                    1.6374e-07,
                    1.7161e-07,
                    1.7961e-07,
                    1.877e-07,
                    1.9586e-07,
                    2.0408e-07,
                    2.1236e-07,
                    2.207e-07,
                    2.291e-07,
                    2.3754e-07,
                    2.4604e-07,
                    2.546e-07,
                    2.6374e-07,
                    2.7256e-07,
                    2.8108e-07,
                    2.8933e-07,
                    2.9732e-07,
                    3.0508e-07,
                    3.1266e-07,
                    3.201e-07,
                    3.2743e-07,
                    3.3472e-07,
                    3.4201e-07,
                    3.4935e-07,
                    3.5674e-07,
                    3.6421e-07,
                    3.7175e-07,
                    3.7939e-07,
                    3.8712e-07,
                    3.9496e-07,
                    4.0292e-07,
                    4.1099e-07,
                    4.1919e-07,
                    4.2762e-07,
                    4.3645e-07,
                    4.4585e-07,
                    4.5594e-07,
                    4.6683e-07,
                    4.786e-07,
                    4.913e-07,
                    5.0497e-07,
                    5.1961e-07,
                    5.3519e-07,
                    5.5187e-07,
                    5.6994e-07,
                    5.8959e-07,
                    6.109e-07,
                    6.3389e-07,
                    6.5846e-07,
                    6.8445e-07,
                    7.1156e-07,
                    7.3943e-07,
                    7.6761e-07,
                    7.9556e-07,
                    8.2279e-07,
                    8.4897e-07,
                    8.7385e-07,
                    8.9733e-07,
                    9.1944e-07,
                    9.403e-07,
                    9.6018e-07,
                    9.7947e-07,
                    9.9868e-07,
                    1.019e-06,
                    1.042e-06,
                    1.0688e-06,
                    1.1004e-06,
                    1.1371e-06,
                    1.1791e-06,
                    1.2262e-06,
                    1.2777e-06,
                    1.3327e-06,
                    1.3897e-06,
                    1.4482e-06,
                    1.5082e-06,
                    1.5698e-06,
                    1.6331e-06,
                    1.6983e-06,
                    1.7653e-06,
                    1.8342e-06,
                    1.9051e-06,
                    1.9781e-06,
                    2.0531e-06,
                    2.1349e-06,
                    2.2201e-06,
                    2.3048e-06,
                    2.3916e-06,
                    2.4812e-06,
                    2.5761e-06,
                    2.6751e-06,
                    2.7785e-06,
                    2.8823e-06,
                    2.9808e-06,
                    3.0842e-06,
                    3.1881e-06,
                    3.2963e-06,
                    3.4107e-06,
                    3.5256e-06,
                    3.6422e-06,
                    3.7599e-06,
                    3.8783e-06,
                    3.9972e-06,
                    4.1132e-06,
                    4.2326e-06,
                    4.3513e-06,
                    4.4685e-06,
                    4.5909e-06,
                    4.7083e-06,
                    4.8233e-06,
                    4.9354e-06,
                    5.0455e-06,
                    5.1512e-06,
                    5.2508e-06,
                    5.3337e-06,
                    5.4068e-06,
                    5.473e-06,
                    5.5404e-06,
                    5.6183e-06,
                    5.71e-06,
                    5.8048e-06,
                    5.8915e-06,
                    5.9696e-06,
                    6.0488e-06,
                    6.1354e-06,
                    6.2198e-06,
                    6.3034e-06,
                    6.4005e-06,
                    6.4932e-06,
                    6.5906e-06,
                    6.6949e-06,
                    6.7889e-06,
                    6.8795e-06,
                    6.9705e-06,
                    7.0586e-06,
                    7.1487e-06,
                    7.2371e-06,
                    7.3246e-06,
                    7.4177e-06,
                    7.5121e-06,
                    7.609e-06,
                    7.7032e-06,
                    7.7951e-06,
                    7.8843e-06,
                    7.9715e-06,
                    8.0603e-06
                ],
                "Fossil_N2O": 0.01,
                "Fossil_N2O_timeseries": [
                    2.5339e-09,
                    5.0971e-09,
                    7.6893e-09,
                    1.031e-08,
                    1.2959e-08,
                    1.5634e-08,
                    1.8336e-08,
                    2.1063e-08,
                    2.3814e-08,
                    2.6587e-08,
                    2.9382e-08,
                    3.2198e-08,
                    3.5036e-08,
                    3.7895e-08,
                    4.0776e-08,
                    4.3677e-08,
                    4.66e-08,
                    4.9544e-08,
                    5.251e-08,
                    5.5497e-08,
                    5.8513e-08,
                    6.1571e-08,
                    6.4679e-08,
                    6.7844e-08,
                    7.1071e-08,
                    7.4359e-08,
                    7.7706e-08,
                    8.1109e-08,
                    8.456e-08,
                    8.8047e-08,
                    9.1565e-08,
                    9.5111e-08,
                    9.8684e-08,
                    1.0228e-07,
                    1.0591e-07,
                    1.0956e-07,
                    1.1324e-07,
                    1.1694e-07,
                    1.2067e-07,
                    1.2444e-07,
                    1.2824e-07,
                    1.3208e-07,
                    1.3594e-07,
                    1.3984e-07,
                    1.4378e-07,
                    1.4774e-07,
                    1.5174e-07,
                    1.5578e-07,
                    1.5985e-07,
                    1.6397e-07,
                    1.6812e-07,
                    1.7231e-07,
                    1.7655e-07,
                    1.8084e-07,
                    1.8517e-07,
                    1.8955e-07,
                    1.9399e-07,
                    1.9847e-07,
                    2.0299e-07,
                    2.0756e-07,
                    2.1217e-07,
                    2.1683e-07,
                    2.2152e-07,
                    2.2625e-07,
                    2.3103e-07,
                    2.3584e-07,
                    2.4069e-07,
                    2.4559e-07,
                    2.5053e-07,
                    2.555e-07,
                    2.6053e-07,
                    2.6559e-07,
                    2.7071e-07,
                    2.7587e-07,
                    2.8108e-07,
                    2.8634e-07,
                    2.9164e-07,
                    2.9699e-07,
                    3.0239e-07,
                    3.0783e-07,
                    3.1334e-07,
                    3.1897e-07,
                    3.2475e-07,
                    3.3074e-07,
                    3.3694e-07,
                    3.4337e-07,
                    3.5005e-07,
                    3.5697e-07,
                    3.6413e-07,
                    3.715e-07,
                    3.7911e-07,
                    3.8698e-07,
                    3.9516e-07,
                    4.0367e-07,
                    4.1255e-07,
                    4.218e-07,
                    4.3146e-07,
                    4.4153e-07,
                    4.5203e-07,
                    4.6295e-07,
                    4.7442e-07,
                    4.8667e-07,
                    4.9987e-07,
                    5.1421e-07,
                    5.2982e-07,
                    5.468e-07,
                    5.6525e-07,
                    5.8521e-07,
                    6.0671e-07,
                    6.2976e-07,
                    6.5444e-07,
                    6.8094e-07,
                    7.0943e-07,
                    7.4002e-07,
                    7.7283e-07,
                    8.0793e-07,
                    8.4535e-07,
                    8.8511e-07,
                    9.2721e-07,
                    9.6537e-07,
                    1.0046e-06,
                    1.0442e-06,
                    1.0868e-06,
                    1.1321e-06,
                    1.1763e-06,
                    1.2212e-06,
                    1.2672e-06,
                    1.3134e-06,
                    1.3602e-06,
                    1.4056e-06,
                    1.4521e-06,
                    1.4963e-06,
                    1.5397e-06,
                    1.5835e-06,
                    1.6265e-06,
                    1.6686e-06,
                    1.7083e-06,
                    1.7468e-06,
                    1.7844e-06,
                    1.8192e-06,
                    1.849e-06,
                    1.8772e-06,
                    1.9003e-06,
                    1.925e-06,
                    1.9533e-06,
                    1.9929e-06,
                    2.0343e-06,
                    2.0706e-06,
                    2.1018e-06,
                    2.1382e-06,
                    2.1792e-06,
                    2.2195e-06,
                    2.2612e-06,
                    2.3062e-06,
                    2.3515e-06,
                    2.3897e-06,
                    2.4364e-06,
                    2.4777e-06,
                    2.5181e-06,
                    2.5599e-06,
                    2.6018e-06,
                    2.642e-06,
                    2.6827e-06,
                    2.722e-06,
                    2.765e-06,
                    2.8104e-06,
                    2.8578e-06,
                    2.9058e-06,
                    2.9536e-06,
                    2.9998e-06,
                    3.0435e-06,
                    3.0876e-06
                ],
                "Land_N2O": 0.01,
                "Land_N2O_timeseries": [
                    2.4779e-09,
                    5.0053e-09,
                    7.5801e-09,
                    1.0199e-08,
                    1.2859e-08,
                    1.5556e-08,
                    1.8282e-08,
                    2.1034e-08,
                    2.3803e-08,
                    2.6581e-08,
                    2.9365e-08,
                    3.2152e-08,
                    3.4941e-08,
                    3.7733e-08,
                    4.0526e-08,
                    4.332e-08,
                    4.6117e-08,
                    4.8917e-08,
                    5.172e-08,
                    5.4528e-08,
                    5.7384e-08,
                    6.0359e-08,
                    6.3507e-08,
                    6.6869e-08,
                    7.0464e-08,
                    7.43e-08,
                    7.8364e-08,
                    8.2628e-08,
                    8.7048e-08,
                    9.1563e-08,
                    9.6132e-08,
                    1.0075e-07,
                    1.054e-07,
                    1.1008e-07,
                    1.1479e-07,
                    1.1953e-07,
                    1.243e-07,
                    1.291e-07,
                    1.3393e-07,
                    1.3929e-07,
                    1.4431e-07,
                    1.49e-07,
                    1.5338e-07,
                    1.5747e-07,
                    1.6131e-07,
                    1.6492e-07,
                    1.6835e-07,
                    1.7165e-07,
                    1.7486e-07,
                    1.7804e-07,
                    1.8123e-07,
                    1.8443e-07,
                    1.8766e-07,
                    1.9092e-07,
                    1.9422e-07,
                    1.9757e-07,
                    2.0098e-07,
                    2.0445e-07,
                    2.08e-07,
                    2.1163e-07,
                    2.1545e-07,
                    2.1963e-07,
                    2.2433e-07,
                    2.2969e-07,
                    2.358e-07,
                    2.4276e-07,
                    2.5061e-07,
                    2.5938e-07,
                    2.6908e-07,
                    2.7968e-07,
                    2.9135e-07,
                    3.0435e-07,
                    3.1888e-07,
                    3.3503e-07,
                    3.5281e-07,
                    3.7213e-07,
                    3.9281e-07,
                    4.1457e-07,
                    4.3705e-07,
                    4.5979e-07,
                    4.8222e-07,
                    5.0383e-07,
                    5.2421e-07,
                    5.4311e-07,
                    5.6039e-07,
                    5.7606e-07,
                    5.9025e-07,
                    6.0321e-07,
                    6.1535e-07,
                    6.2718e-07,
                    6.3989e-07,
                    6.55e-07,
                    6.7367e-07,
                    6.9671e-07,
                    7.2457e-07,
                    7.5734e-07,
                    7.9475e-07,
                    8.3617e-07,
                    8.8063e-07,
                    9.2678e-07,
                    9.7378e-07,
                    1.0215e-06,
                    1.0699e-06,
                    1.1189e-06,
                    1.1684e-06,
                    1.2185e-06,
                    1.269e-06,
                    1.3199e-06,
                    1.3714e-06,
                    1.4234e-06,
                    1.4805e-06,
                    1.5391e-06,
                    1.5953e-06,
                    1.6516e-06,
                    1.7084e-06,
                    1.7681e-06,
                    1.8298e-06,
                    1.8934e-06,
                    1.9551e-06,
                    2.0155e-06,
                    2.0796e-06,
                    2.144e-06,
                    2.2096e-06,
                    2.2786e-06,
                    2.3493e-06,
                    2.4209e-06,
                    2.4927e-06,
                    2.565e-06,
                    2.637e-06,
                    2.7076e-06,
                    2.7805e-06,
                    2.8551e-06,
                    2.9288e-06,
                    3.0074e-06,
                    3.0818e-06,
                    3.1548e-06,
                    3.2272e-06,
                    3.2987e-06,
                    3.3668e-06,
                    3.4316e-06,
                    3.4846e-06,
                    3.5295e-06,
                    3.5727e-06,
                    3.6154e-06,
                    3.665e-06,
                    3.7171e-06,
                    3.7705e-06,
                    3.8208e-06,
                    3.8678e-06,
                    3.9106e-06,
                    3.9562e-06,
                    4.0003e-06,
                    4.0422e-06,
                    4.0943e-06,
                    4.1417e-06,
                    4.2009e-06,
                    4.2585e-06,
                    4.3112e-06,
                    4.3614e-06,
                    4.4106e-06,
                    4.4567e-06,
                    4.5067e-06,
                    4.5545e-06,
                    4.6026e-06,
                    4.6528e-06,
                    4.7017e-06,
                    4.7512e-06,
                    4.7974e-06,
                    4.8415e-06,
                    4.8845e-06,
                    4.928e-06,
                    4.9727e-06
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            18.4381,
                            42.5557
                        ],
                        [
                            18.43499,
                            42.48403
                        ],
                        [
                            18.52521,
                            42.42046
                        ],
                        [
                            18.58294,
                            42.42995
                        ],
                        [
                            18.61027,
                            42.36582
                        ],
                        [
                            18.68866,
                            42.35596
                        ],
                        [
                            18.78782,
                            42.2797
                        ],
                        [
                            18.88134,
                            42.27846
                        ],
                        [
                            18.90783,
                            42.22027
                        ],
                        [
                            19.14039,
                            42.04345
                        ],
                        [
                            19.15696,
                            41.94531
                        ],
                        [
                            19.31016,
                            41.88592
                        ],
                        [
                            19.37253,
                            41.84415
                        ],
                        [
                            19.34308,
                            41.90567
                        ],
                        [
                            19.38159,
                            41.96155
                        ],
                        [
                            19.36967,
                            42.02656
                        ],
                        [
                            19.40117,
                            42.10409
                        ],
                        [
                            19.28184,
                            42.18051
                        ],
                        [
                            19.34886,
                            42.24014
                        ],
                        [
                            19.56253,
                            42.50158
                        ],
                        [
                            19.61209,
                            42.57759
                        ],
                        [
                            19.72286,
                            42.66054
                        ],
                        [
                            19.75536,
                            42.63725
                        ],
                        [
                            19.74392,
                            42.54504
                        ],
                        [
                            19.79282,
                            42.48167
                        ],
                        [
                            19.89781,
                            42.48546
                        ],
                        [
                            19.94045,
                            42.5179
                        ],
                        [
                            20.0763,
                            42.55582
                        ],
                        [
                            20.11194,
                            42.6554
                        ],
                        [
                            20.03466,
                            42.69801
                        ],
                        [
                            20.05722,
                            42.77806
                        ],
                        [
                            20.19031,
                            42.747
                        ],
                        [
                            20.25542,
                            42.81343
                        ],
                        [
                            20.35293,
                            42.83338
                        ],
                        [
                            20.34453,
                            42.9092
                        ],
                        [
                            20.15395,
                            42.97608
                        ],
                        [
                            20.11878,
                            42.96542
                        ],
                        [
                            19.96844,
                            43.08569
                        ],
                        [
                            19.78859,
                            43.12573
                        ],
                        [
                            19.77038,
                            43.16551
                        ],
                        [
                            19.6859,
                            43.16861
                        ],
                        [
                            19.61698,
                            43.23051
                        ],
                        [
                            19.54523,
                            43.24785
                        ],
                        [
                            19.52247,
                            43.32015
                        ],
                        [
                            19.44842,
                            43.38749
                        ],
                        [
                            19.34894,
                            43.41698
                        ],
                        [
                            19.22251,
                            43.48269
                        ],
                        [
                            19.22407,
                            43.52754
                        ],
                        [
                            19.15582,
                            43.53548
                        ],
                        [
                            18.9564,
                            43.49018
                        ],
                        [
                            19.01814,
                            43.42969
                        ],
                        [
                            19.08499,
                            43.32153
                        ],
                        [
                            19.01355,
                            43.25242
                        ],
                        [
                            18.95514,
                            43.28999
                        ],
                        [
                            18.91586,
                            43.35839
                        ],
                        [
                            18.73627,
                            43.28226
                        ],
                        [
                            18.64885,
                            43.14649
                        ],
                        [
                            18.66078,
                            43.03707
                        ],
                        [
                            18.54203,
                            43.02923
                        ],
                        [
                            18.48979,
                            42.98646
                        ],
                        [
                            18.50805,
                            42.88678
                        ],
                        [
                            18.451,
                            42.81533
                        ],
                        [
                            18.47289,
                            42.75783
                        ],
                        [
                            18.53105,
                            42.72438
                        ],
                        [
                            18.57397,
                            42.64547
                        ],
                        [
                            18.4381,
                            42.5557
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "MSR",
                "Country": "Montserrat",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.65e-09,
                    3.3e-09,
                    6.6e-09,
                    8.25e-09,
                    1.155e-08,
                    1.485e-08,
                    1.815e-08,
                    2.145e-08,
                    2.805e-08,
                    3.465e-08,
                    4.125e-08,
                    4.785e-08,
                    5.445e-08,
                    5.94e-08,
                    6.435e-08,
                    7.59e-08,
                    8.745e-08,
                    9.9e-08,
                    1.056e-07,
                    1.1385e-07,
                    1.221e-07,
                    1.32e-07,
                    1.419e-07,
                    1.5345e-07,
                    1.6665e-07,
                    1.7985e-07,
                    1.9305e-07,
                    2.0625e-07,
                    2.1945e-07,
                    2.3265e-07,
                    2.4585e-07,
                    2.5905e-07,
                    2.739e-07,
                    2.8875e-07,
                    3.0525e-07,
                    3.201e-07,
                    3.333e-07,
                    3.498e-07,
                    3.6135e-07,
                    3.729e-07,
                    3.9435e-07,
                    4.1085e-07,
                    4.323e-07,
                    4.5045e-07,
                    4.686e-07,
                    4.8675e-07,
                    5.082e-07,
                    5.28e-07,
                    5.544e-07,
                    5.709e-07,
                    5.8905e-07,
                    6.105e-07,
                    6.3195e-07,
                    6.567e-07,
                    6.699e-07,
                    6.831e-07,
                    6.963e-07,
                    7.062e-07,
                    7.161e-07,
                    7.2564e-07,
                    7.3527e-07
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.65e-09,
                    3.3e-09,
                    6.6e-09,
                    8.25e-09,
                    1.155e-08,
                    1.485e-08,
                    1.815e-08,
                    2.145e-08,
                    2.805e-08,
                    3.465e-08,
                    4.125e-08,
                    4.785e-08,
                    5.445e-08,
                    5.94e-08,
                    6.435e-08,
                    7.59e-08,
                    8.745e-08,
                    9.9e-08,
                    1.056e-07,
                    1.1385e-07,
                    1.221e-07,
                    1.32e-07,
                    1.419e-07,
                    1.5345e-07,
                    1.6665e-07,
                    1.7985e-07,
                    1.9305e-07,
                    2.0625e-07,
                    2.1945e-07,
                    2.3265e-07,
                    2.4585e-07,
                    2.5905e-07,
                    2.739e-07,
                    2.8875e-07,
                    3.0525e-07,
                    3.201e-07,
                    3.333e-07,
                    3.498e-07,
                    3.6135e-07,
                    3.729e-07,
                    3.9435e-07,
                    4.1085e-07,
                    4.323e-07,
                    4.5045e-07,
                    4.686e-07,
                    4.8675e-07,
                    5.082e-07,
                    5.28e-07,
                    5.544e-07,
                    5.709e-07,
                    5.8905e-07,
                    6.105e-07,
                    6.3195e-07,
                    6.567e-07,
                    6.699e-07,
                    6.831e-07,
                    6.963e-07,
                    7.062e-07,
                    7.161e-07,
                    7.2564e-07,
                    7.3527e-07
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.65e-09,
                    3.3e-09,
                    6.6e-09,
                    8.25e-09,
                    1.155e-08,
                    1.485e-08,
                    1.815e-08,
                    2.145e-08,
                    2.805e-08,
                    3.465e-08,
                    4.125e-08,
                    4.785e-08,
                    5.445e-08,
                    5.94e-08,
                    6.435e-08,
                    7.59e-08,
                    8.745e-08,
                    9.9e-08,
                    1.056e-07,
                    1.1385e-07,
                    1.221e-07,
                    1.32e-07,
                    1.419e-07,
                    1.5345e-07,
                    1.6665e-07,
                    1.7985e-07,
                    1.9305e-07,
                    2.0625e-07,
                    2.1945e-07,
                    2.3265e-07,
                    2.4585e-07,
                    2.5905e-07,
                    2.739e-07,
                    2.8875e-07,
                    3.0525e-07,
                    3.201e-07,
                    3.333e-07,
                    3.498e-07,
                    3.6135e-07,
                    3.729e-07,
                    3.9435e-07,
                    4.1085e-07,
                    4.323e-07,
                    4.5045e-07,
                    4.686e-07,
                    4.8675e-07,
                    5.082e-07,
                    5.28e-07,
                    5.544e-07,
                    5.709e-07,
                    5.8905e-07,
                    6.105e-07,
                    6.3195e-07,
                    6.567e-07,
                    6.699e-07,
                    6.831e-07,
                    6.963e-07,
                    7.062e-07,
                    7.161e-07,
                    7.2564e-07,
                    7.3527e-07
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.65e-09,
                    3.3e-09,
                    6.6e-09,
                    8.25e-09,
                    1.155e-08,
                    1.485e-08,
                    1.815e-08,
                    2.145e-08,
                    2.805e-08,
                    3.465e-08,
                    4.125e-08,
                    4.785e-08,
                    5.445e-08,
                    5.94e-08,
                    6.435e-08,
                    7.59e-08,
                    8.745e-08,
                    9.9e-08,
                    1.056e-07,
                    1.1385e-07,
                    1.221e-07,
                    1.32e-07,
                    1.419e-07,
                    1.5345e-07,
                    1.6665e-07,
                    1.7985e-07,
                    1.9305e-07,
                    2.0625e-07,
                    2.1945e-07,
                    2.3265e-07,
                    2.4585e-07,
                    2.5905e-07,
                    2.739e-07,
                    2.8875e-07,
                    3.0525e-07,
                    3.201e-07,
                    3.333e-07,
                    3.498e-07,
                    3.6135e-07,
                    3.729e-07,
                    3.9435e-07,
                    4.1085e-07,
                    4.323e-07,
                    4.5045e-07,
                    4.686e-07,
                    4.8675e-07,
                    5.082e-07,
                    5.28e-07,
                    5.544e-07,
                    5.709e-07,
                    5.8905e-07,
                    6.105e-07,
                    6.3195e-07,
                    6.567e-07,
                    6.699e-07,
                    6.831e-07,
                    6.963e-07,
                    7.062e-07,
                    7.161e-07,
                    7.2564e-07,
                    7.3527e-07
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": []
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -62.2395,
                            16.72323
                        ],
                        [
                            -62.18862,
                            16.67555
                        ],
                        [
                            -62.14474,
                            16.6978
                        ],
                        [
                            -62.18092,
                            16.80091
                        ],
                        [
                            -62.2395,
                            16.72323
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "MAR",
                "Country": "Morocco",
                "Total_3GHG": 0.17,
                "Total_3GHG_timeseries": [
                    2.5273e-06,
                    5.0615e-06,
                    7.6026e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028
                ],
                "Fossil_3GHG": 0.16,
                "Fossil_3GHG_timeseries": [
                    3.6961e-07,
                    7.4062e-07,
                    1.1131e-06,
                    1.487e-06,
                    1.8624e-06,
                    2.2394e-06,
                    2.618e-06,
                    2.9982e-06,
                    3.38e-06,
                    3.7636e-06,
                    4.1488e-06,
                    4.5358e-06,
                    4.9246e-06,
                    5.3153e-06,
                    5.7079e-06,
                    6.1025e-06,
                    6.4991e-06,
                    6.8978e-06,
                    7.2987e-06,
                    7.7017e-06,
                    8.16e-06,
                    8.6189e-06,
                    9.0787e-06,
                    9.5394e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017
                ],
                "Land_3GHG": 0.19,
                "Land_3GHG_timeseries": [
                    2.1577e-06,
                    4.3208e-06,
                    6.4895e-06,
                    8.6633e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011
                ],
                "Total_CO2": 0.13,
                "Total_CO2_timeseries": [
                    8.9284e-07,
                    1.7864e-06,
                    2.6807e-06,
                    3.5756e-06,
                    4.4709e-06,
                    5.3665e-06,
                    6.2623e-06,
                    7.1581e-06,
                    8.0538e-06,
                    8.9446e-06,
                    9.8339e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014
                ],
                "Fossil_CO2": 0.11,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.3093e-08,
                    2.7823e-08,
                    4.5839e-08,
                    8.681e-08,
                    1.5406e-07,
                    2.329e-07,
                    3.1836e-07,
                    4.2361e-07,
                    5.1902e-07,
                    6.8539e-07,
                    8.9464e-07,
                    1.0382e-06,
                    1.2164e-06,
                    1.3913e-06,
                    1.5398e-06,
                    1.6996e-06,
                    1.8891e-06,
                    2.125e-06,
                    2.4332e-06,
                    2.8073e-06,
                    3.2309e-06,
                    3.7205e-06,
                    4.8732e-06,
                    6.1909e-06,
                    7.7956e-06,
                    9.6738e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008
                ],
                "Land_CO2": 0.16,
                "Land_CO2_timeseries": [
                    8.9284e-07,
                    1.7864e-06,
                    2.6807e-06,
                    3.5756e-06,
                    4.4709e-06,
                    5.3665e-06,
                    6.2623e-06,
                    7.1581e-06,
                    8.0538e-06,
                    8.9446e-06,
                    9.8339e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006
                ],
                "Total_CH4": 0.29,
                "Total_CH4_timeseries": [
                    1.5297e-06,
                    3.0636e-06,
                    4.6017e-06,
                    6.1442e-06,
                    7.6909e-06,
                    9.2421e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012
                ],
                "Fossil_CH4": 0.34,
                "Fossil_CH4_timeseries": [
                    3.5315e-07,
                    7.0747e-07,
                    1.063e-06,
                    1.4198e-06,
                    1.7779e-06,
                    2.1373e-06,
                    2.4982e-06,
                    2.8605e-06,
                    3.2243e-06,
                    3.5897e-06,
                    3.9566e-06,
                    4.3253e-06,
                    4.6957e-06,
                    5.0678e-06,
                    5.4417e-06,
                    5.8176e-06,
                    6.1953e-06,
                    6.5751e-06,
                    6.9569e-06,
                    7.3407e-06,
                    7.7796e-06,
                    8.2187e-06,
                    8.6581e-06,
                    9.0976e-06,
                    9.5374e-06,
                    9.9773e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009
                ],
                "Land_CH4": 0.21,
                "Land_CH4_timeseries": [
                    1.1765e-06,
                    2.3561e-06,
                    3.5387e-06,
                    4.7244e-06,
                    5.9131e-06,
                    7.1048e-06,
                    8.2996e-06,
                    9.4974e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Total_N2O": 0.27,
                "Total_N2O_timeseries": [
                    1.0475e-07,
                    2.115e-07,
                    3.2017e-07,
                    4.3064e-07,
                    5.4277e-07,
                    6.5638e-07,
                    7.7127e-07,
                    8.8719e-07,
                    1.0039e-06,
                    1.121e-06,
                    1.2385e-06,
                    1.3561e-06,
                    1.474e-06,
                    1.592e-06,
                    1.7102e-06,
                    1.8286e-06,
                    1.9471e-06,
                    2.0658e-06,
                    2.1848e-06,
                    2.304e-06,
                    2.4252e-06,
                    2.551e-06,
                    2.6836e-06,
                    2.8245e-06,
                    2.9744e-06,
                    3.1337e-06,
                    3.3019e-06,
                    3.4778e-06,
                    3.6599e-06,
                    3.8456e-06,
                    4.0336e-06,
                    4.2233e-06,
                    4.4146e-06,
                    4.6073e-06,
                    4.8011e-06,
                    4.9961e-06,
                    5.1923e-06,
                    5.3897e-06,
                    5.5884e-06,
                    5.7968e-06,
                    6.0073e-06,
                    6.2198e-06,
                    6.4346e-06,
                    6.6517e-06,
                    6.8712e-06,
                    7.0932e-06,
                    7.3178e-06,
                    7.545e-06,
                    7.7749e-06,
                    8.0077e-06,
                    8.2432e-06,
                    8.4815e-06,
                    8.7226e-06,
                    8.9666e-06,
                    9.2137e-06,
                    9.4641e-06,
                    9.7181e-06,
                    9.9759e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_N2O": 0.12,
                "Fossil_N2O_timeseries": [
                    1.6459e-08,
                    3.3151e-08,
                    5.0069e-08,
                    6.7207e-08,
                    8.4553e-08,
                    1.0209e-07,
                    1.1982e-07,
                    1.377e-07,
                    1.5573e-07,
                    1.7388e-07,
                    1.9214e-07,
                    2.105e-07,
                    2.2896e-07,
                    2.4752e-07,
                    2.6618e-07,
                    2.8494e-07,
                    3.038e-07,
                    3.2276e-07,
                    3.4183e-07,
                    3.6101e-07,
                    3.8041e-07,
                    4.0024e-07,
                    4.2065e-07,
                    4.4175e-07,
                    4.636e-07,
                    4.8622e-07,
                    5.0957e-07,
                    5.3357e-07,
                    5.5811e-07,
                    5.8301e-07,
                    6.0815e-07,
                    6.3351e-07,
                    6.5907e-07,
                    6.8482e-07,
                    7.1074e-07,
                    7.3683e-07,
                    7.631e-07,
                    7.8954e-07,
                    8.1617e-07,
                    8.4343e-07,
                    8.71e-07,
                    8.989e-07,
                    9.2713e-07,
                    9.5571e-07,
                    9.8465e-07,
                    1.014e-06,
                    1.0437e-06,
                    1.0738e-06,
                    1.1043e-06,
                    1.1353e-06,
                    1.1668e-06,
                    1.1988e-06,
                    1.2314e-06,
                    1.2646e-06,
                    1.2985e-06,
                    1.3331e-06,
                    1.3683e-06,
                    1.4041e-06,
                    1.4404e-06,
                    1.4773e-06,
                    1.5147e-06,
                    1.5526e-06,
                    1.5908e-06,
                    1.6295e-06,
                    1.6687e-06,
                    1.7083e-06,
                    1.7483e-06,
                    1.7887e-06,
                    1.8295e-06,
                    1.8708e-06,
                    1.9126e-06,
                    1.9548e-06,
                    1.9975e-06,
                    2.0407e-06,
                    2.0843e-06,
                    2.1284e-06,
                    2.1729e-06,
                    2.218e-06,
                    2.2635e-06,
                    2.3096e-06,
                    2.3562e-06,
                    2.4035e-06,
                    2.4516e-06,
                    2.5006e-06,
                    2.5505e-06,
                    2.6014e-06,
                    2.6534e-06,
                    2.7065e-06,
                    2.7607e-06,
                    2.8161e-06,
                    2.873e-06,
                    2.9322e-06,
                    2.9941e-06,
                    3.0592e-06,
                    3.1277e-06,
                    3.1997e-06,
                    3.2753e-06,
                    3.3541e-06,
                    3.436e-06,
                    3.5203e-06,
                    3.607e-06,
                    3.696e-06,
                    3.7874e-06,
                    3.8811e-06,
                    3.9771e-06,
                    4.0755e-06,
                    4.1763e-06,
                    4.2793e-06,
                    4.3846e-06,
                    4.492e-06,
                    4.6019e-06,
                    4.7146e-06,
                    4.8305e-06,
                    4.9498e-06,
                    5.0729e-06,
                    5.1999e-06,
                    5.331e-06,
                    5.4663e-06,
                    5.606e-06,
                    5.7535e-06,
                    5.9052e-06,
                    6.0671e-06,
                    6.2403e-06,
                    6.4206e-06,
                    6.6141e-06,
                    6.8153e-06,
                    7.0335e-06,
                    7.2593e-06,
                    7.4994e-06,
                    7.74e-06,
                    7.9874e-06,
                    8.2496e-06,
                    8.5164e-06,
                    8.7905e-06,
                    9.0741e-06,
                    9.3752e-06,
                    9.6854e-06,
                    9.9826e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.33,
                "Land_N2O_timeseries": [
                    8.8292e-08,
                    1.7835e-07,
                    2.701e-07,
                    3.6343e-07,
                    4.5821e-07,
                    5.5429e-07,
                    6.5145e-07,
                    7.4949e-07,
                    8.4816e-07,
                    9.4717e-07,
                    1.0463e-06,
                    1.1457e-06,
                    1.245e-06,
                    1.3445e-06,
                    1.444e-06,
                    1.5436e-06,
                    1.6433e-06,
                    1.743e-06,
                    1.8429e-06,
                    1.943e-06,
                    2.0447e-06,
                    2.1507e-06,
                    2.2629e-06,
                    2.3827e-06,
                    2.5108e-06,
                    2.6475e-06,
                    2.7923e-06,
                    2.9443e-06,
                    3.1018e-06,
                    3.2626e-06,
                    3.4254e-06,
                    3.5898e-06,
                    3.7555e-06,
                    3.9224e-06,
                    4.0904e-06,
                    4.2593e-06,
                    4.4292e-06,
                    4.6001e-06,
                    4.7723e-06,
                    4.9534e-06,
                    5.1363e-06,
                    5.3209e-06,
                    5.5075e-06,
                    5.696e-06,
                    5.8866e-06,
                    6.0792e-06,
                    6.2741e-06,
                    6.4712e-06,
                    6.6706e-06,
                    6.8723e-06,
                    7.0764e-06,
                    7.2827e-06,
                    7.4912e-06,
                    7.702e-06,
                    7.9152e-06,
                    8.131e-06,
                    8.3498e-06,
                    8.5719e-06,
                    8.7978e-06,
                    9.028e-06,
                    9.2646e-06,
                    9.5108e-06,
                    9.7694e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -17.0513,
                            20.77162
                        ],
                        [
                            -17.06637,
                            20.92283
                        ],
                        [
                            -17.03984,
                            21.04016
                        ],
                        [
                            -17.00309,
                            21.10466
                        ],
                        [
                            -16.93952,
                            21.32565
                        ],
                        [
                            -16.91968,
                            21.33016
                        ],
                        [
                            -16.30914,
                            21.33701
                        ],
                        [
                            -15.87707,
                            21.34121
                        ],
                        [
                            -15.20169,
                            21.34334
                        ],
                        [
                            -14.59675,
                            21.3436
                        ],
                        [
                            -13.88312,
                            21.34036
                        ],
                        [
                            -13.00184,
                            21.33087
                        ],
                        [
                            -13.0801,
                            22.52766
                        ],
                        [
                            -13.14521,
                            22.74169
                        ],
                        [
                            -13.11354,
                            22.88332
                        ],
                        [
                            -12.99827,
                            23.02474
                        ],
                        [
                            -12.57159,
                            23.29127
                        ],
                        [
                            -12.36583,
                            23.31863
                        ],
                        [
                            -12.15603,
                            23.41629
                        ],
                        [
                            -12.12636,
                            23.41269
                        ],
                        [
                            -12.00002,
                            23.46762
                        ],
                        [
                            -12,
                            23.99971
                        ],
                        [
                            -12.00298,
                            24.51334
                        ],
                        [
                            -12.00522,
                            25.12668
                        ],
                        [
                            -12.00381,
                            25.99859
                        ],
                        [
                            -11.56514,
                            25.99853
                        ],
                        [
                            -11.00663,
                            25.99864
                        ],
                        [
                            -10.37411,
                            25.9987
                        ],
                        [
                            -9.88807,
                            25.99775
                        ],
                        [
                            -9.56291,
                            26.00001
                        ],
                        [
                            -8.97905,
                            25.99689
                        ],
                        [
                            -8.67416,
                            25.99762
                        ],
                        [
                            -8.67232,
                            26.54068
                        ],
                        [
                            -8.67248,
                            27.28832
                        ],
                        [
                            -8.66667,
                            27.31274
                        ],
                        [
                            -8.66665,
                            27.66204
                        ],
                        [
                            -8.66421,
                            28.71337
                        ],
                        [
                            -8.45111,
                            28.80244
                        ],
                        [
                            -8.22371,
                            28.98884
                        ],
                        [
                            -7.96402,
                            29.12719
                        ],
                        [
                            -7.89384,
                            29.18672
                        ],
                        [
                            -7.77368,
                            29.25817
                        ],
                        [
                            -7.6487,
                            29.30529
                        ],
                        [
                            -7.58324,
                            29.37465
                        ],
                        [
                            -7.4868,
                            29.3631
                        ],
                        [
                            -7.33806,
                            29.39754
                        ],
                        [
                            -7.24973,
                            29.47431
                        ],
                        [
                            -7.15253,
                            29.5192
                        ],
                        [
                            -7.02234,
                            29.49444
                        ],
                        [
                            -6.90763,
                            29.49922
                        ],
                        [
                            -6.77994,
                            29.46201
                        ],
                        [
                            -6.69752,
                            29.51202
                        ],
                        [
                            -6.52448,
                            29.52066
                        ],
                        [
                            -6.45983,
                            29.56313
                        ],
                        [
                            -6.24133,
                            29.5684
                        ],
                        [
                            -6.1933,
                            29.58385
                        ],
                        [
                            -6.06352,
                            29.56337
                        ],
                        [
                            -5.78954,
                            29.61264
                        ],
                        [
                            -5.72135,
                            29.58597
                        ],
                        [
                            -5.64016,
                            29.49906
                        ],
                        [
                            -5.55115,
                            29.5012
                        ],
                        [
                            -5.32358,
                            29.77823
                        ],
                        [
                            -5.32807,
                            29.83746
                        ],
                        [
                            -5.27837,
                            29.90054
                        ],
                        [
                            -4.93553,
                            30.13983
                        ],
                        [
                            -4.59741,
                            30.2912
                        ],
                        [
                            -4.32252,
                            30.52736
                        ],
                        [
                            -4.14959,
                            30.58384
                        ],
                        [
                            -3.98376,
                            30.59615
                        ],
                        [
                            -3.84456,
                            30.62689
                        ],
                        [
                            -3.6389,
                            30.70005
                        ],
                        [
                            -3.64945,
                            30.84367
                        ],
                        [
                            -3.53901,
                            30.95792
                        ],
                        [
                            -3.5514,
                            31.06445
                        ],
                        [
                            -3.67009,
                            31.15325
                        ],
                        [
                            -3.75645,
                            31.17916
                        ],
                        [
                            -3.76059,
                            31.33104
                        ],
                        [
                            -3.66971,
                            31.37788
                        ],
                        [
                            -3.66499,
                            31.63171
                        ],
                        [
                            -2.82442,
                            31.8013
                        ],
                        [
                            -2.84388,
                            31.88364
                        ],
                        [
                            -2.92752,
                            32.04186
                        ],
                        [
                            -2.90057,
                            32.11844
                        ],
                        [
                            -2.59516,
                            32.11227
                        ],
                        [
                            -2.53443,
                            32.14741
                        ],
                        [
                            -2.26968,
                            32.16137
                        ],
                        [
                            -2.1367,
                            32.13933
                        ],
                        [
                            -2.01639,
                            32.17514
                        ],
                        [
                            -1.89454,
                            32.16073
                        ],
                        [
                            -1.75183,
                            32.12268
                        ],
                        [
                            -1.5814,
                            32.09272
                        ],
                        [
                            -1.47606,
                            32.09507
                        ],
                        [
                            -1.24505,
                            32.07572
                        ],
                        [
                            -1.15505,
                            32.11173
                        ],
                        [
                            -1.24181,
                            32.20638
                        ],
                        [
                            -1.20381,
                            32.39303
                        ],
                        [
                            -1.0631,
                            32.45179
                        ],
                        [
                            -0.9994,
                            32.51715
                        ],
                        [
                            -1.26695,
                            32.6935
                        ],
                        [
                            -1.38196,
                            32.74377
                        ],
                        [
                            -1.54098,
                            32.95655
                        ],
                        [
                            -1.49342,
                            32.96742
                        ],
                        [
                            -1.47471,
                            33.07517
                        ],
                        [
                            -1.57087,
                            33.14499
                        ],
                        [
                            -1.6675,
                            33.27915
                        ],
                        [
                            -1.66105,
                            33.37782
                        ],
                        [
                            -1.58792,
                            33.52927
                        ],
                        [
                            -1.59401,
                            33.60445
                        ],
                        [
                            -1.64568,
                            33.6758
                        ],
                        [
                            -1.70006,
                            33.67631
                        ],
                        [
                            -1.72646,
                            33.73458
                        ],
                        [
                            -1.66954,
                            33.77407
                        ],
                        [
                            -1.69659,
                            33.87223
                        ],
                        [
                            -1.64602,
                            34.10476
                        ],
                        [
                            -1.70916,
                            34.22989
                        ],
                        [
                            -1.70585,
                            34.31002
                        ],
                        [
                            -1.78102,
                            34.39324
                        ],
                        [
                            -1.69298,
                            34.49983
                        ],
                        [
                            -1.74801,
                            34.5233
                        ],
                        [
                            -1.84606,
                            34.62384
                        ],
                        [
                            -1.74696,
                            34.75314
                        ],
                        [
                            -1.88285,
                            34.81332
                        ],
                        [
                            -1.95954,
                            34.87342
                        ],
                        [
                            -1.98322,
                            34.93454
                        ],
                        [
                            -2.07844,
                            34.95499
                        ],
                        [
                            -2.20601,
                            35.05081
                        ],
                        [
                            -2.20974,
                            35.0846
                        ],
                        [
                            -2.42375,
                            35.14531
                        ],
                        [
                            -2.56403,
                            35.08222
                        ],
                        [
                            -2.74551,
                            35.12446
                        ],
                        [
                            -2.81391,
                            35.10389
                        ],
                        [
                            -2.87995,
                            35.13157
                        ],
                        [
                            -2.92546,
                            35.19325
                        ],
                        [
                            -2.92812,
                            35.27308
                        ],
                        [
                            -2.97009,
                            35.28943
                        ],
                        [
                            -2.99432,
                            35.43049
                        ],
                        [
                            -3.06818,
                            35.29438
                        ],
                        [
                            -3.13377,
                            35.28384
                        ],
                        [
                            -3.18755,
                            35.23026
                        ],
                        [
                            -3.33486,
                            35.18587
                        ],
                        [
                            -3.48881,
                            35.19961
                        ],
                        [
                            -3.58503,
                            35.22528
                        ],
                        [
                            -3.68635,
                            35.2842
                        ],
                        [
                            -3.7576,
                            35.26476
                        ],
                        [
                            -3.7911,
                            35.20859
                        ],
                        [
                            -3.90659,
                            35.21416
                        ],
                        [
                            -3.94171,
                            35.25799
                        ],
                        [
                            -4.11245,
                            35.20625
                        ],
                        [
                            -4.25092,
                            35.1881
                        ],
                        [
                            -4.35567,
                            35.14786
                        ],
                        [
                            -4.61345,
                            35.18936
                        ],
                        [
                            -4.75288,
                            35.22553
                        ],
                        [
                            -4.86783,
                            35.30087
                        ],
                        [
                            -4.92613,
                            35.31722
                        ],
                        [
                            -5.0167,
                            35.40262
                        ],
                        [
                            -5.06199,
                            35.4079
                        ],
                        [
                            -5.10553,
                            35.47554
                        ],
                        [
                            -5.17427,
                            35.5316
                        ],
                        [
                            -5.2405,
                            35.55017
                        ],
                        [
                            -5.2833,
                            35.66366
                        ],
                        [
                            -5.33486,
                            35.71598
                        ],
                        [
                            -5.34337,
                            35.87088
                        ],
                        [
                            -5.38194,
                            35.91302
                        ],
                        [
                            -5.4652,
                            35.91286
                        ],
                        [
                            -5.59072,
                            35.83273
                        ],
                        [
                            -5.68825,
                            35.83721
                        ],
                        [
                            -5.78157,
                            35.77785
                        ],
                        [
                            -5.84812,
                            35.79956
                        ],
                        [
                            -5.92913,
                            35.78688
                        ],
                        [
                            -6.02638,
                            35.48023
                        ],
                        [
                            -6.08117,
                            35.3952
                        ],
                        [
                            -6.14927,
                            35.21079
                        ],
                        [
                            -6.17054,
                            35.18952
                        ],
                        [
                            -6.30416,
                            34.86463
                        ],
                        [
                            -6.39064,
                            34.69732
                        ],
                        [
                            -6.53813,
                            34.45078
                        ],
                        [
                            -6.66579,
                            34.2802
                        ],
                        [
                            -6.72738,
                            34.16391
                        ],
                        [
                            -6.78692,
                            34.08881
                        ],
                        [
                            -6.94857,
                            33.93479
                        ],
                        [
                            -7.12832,
                            33.82921
                        ],
                        [
                            -7.22822,
                            33.79958
                        ],
                        [
                            -7.35493,
                            33.71491
                        ],
                        [
                            -7.39835,
                            33.71943
                        ],
                        [
                            -7.53379,
                            33.62298
                        ],
                        [
                            -7.65394,
                            33.61003
                        ],
                        [
                            -7.75937,
                            33.54835
                        ],
                        [
                            -8.2215,
                            33.38292
                        ],
                        [
                            -8.30167,
                            33.3651
                        ],
                        [
                            -8.4406,
                            33.25478
                        ],
                        [
                            -8.53877,
                            33.24854
                        ],
                        [
                            -8.6221,
                            33.17125
                        ],
                        [
                            -8.6514,
                            33.09029
                        ],
                        [
                            -8.78978,
                            32.94426
                        ],
                        [
                            -8.89977,
                            32.84287
                        ],
                        [
                            -9.03513,
                            32.74588
                        ],
                        [
                            -9.11056,
                            32.67128
                        ],
                        [
                            -9.28166,
                            32.54297
                        ],
                        [
                            -9.23227,
                            32.47397
                        ],
                        [
                            -9.28445,
                            32.37668
                        ],
                        [
                            -9.24486,
                            32.3
                        ],
                        [
                            -9.26112,
                            32.17594
                        ],
                        [
                            -9.31972,
                            32.11487
                        ],
                        [
                            -9.34741,
                            32.03062
                        ],
                        [
                            -9.67378,
                            31.69923
                        ],
                        [
                            -9.67663,
                            31.6346
                        ],
                        [
                            -9.84085,
                            31.39301
                        ],
                        [
                            -9.80442,
                            31.36759
                        ],
                        [
                            -9.79879,
                            31.28978
                        ],
                        [
                            -9.84029,
                            31.10739
                        ],
                        [
                            -9.80936,
                            31.01106
                        ],
                        [
                            -9.82502,
                            30.96568
                        ],
                        [
                            -9.80554,
                            30.81957
                        ],
                        [
                            -9.88646,
                            30.65994
                        ],
                        [
                            -9.8771,
                            30.62481
                        ],
                        [
                            -9.78352,
                            30.60827
                        ],
                        [
                            -9.70193,
                            30.53855
                        ],
                        [
                            -9.66161,
                            30.44837
                        ],
                        [
                            -9.60141,
                            30.3938
                        ],
                        [
                            -9.64251,
                            30.17302
                        ],
                        [
                            -9.66794,
                            30.08811
                        ],
                        [
                            -9.76215,
                            29.91376
                        ],
                        [
                            -9.83199,
                            29.80851
                        ],
                        [
                            -9.95944,
                            29.70005
                        ],
                        [
                            -10.0473,
                            29.585
                        ],
                        [
                            -10.07711,
                            29.50231
                        ],
                        [
                            -10.18971,
                            29.36551
                        ],
                        [
                            -10.2172,
                            29.31073
                        ],
                        [
                            -10.32714,
                            29.23597
                        ],
                        [
                            -10.5079,
                            29.03087
                        ],
                        [
                            -10.62236,
                            28.9603
                        ],
                        [
                            -10.84438,
                            28.84845
                        ],
                        [
                            -11.04196,
                            28.76187
                        ],
                        [
                            -11.09884,
                            28.70108
                        ],
                        [
                            -11.32087,
                            28.51629
                        ],
                        [
                            -11.46548,
                            28.3359
                        ],
                        [
                            -11.58809,
                            28.27575
                        ],
                        [
                            -11.89859,
                            28.17039
                        ],
                        [
                            -12.08499,
                            28.08654
                        ],
                        [
                            -12.21569,
                            28.05897
                        ],
                        [
                            -12.66482,
                            27.98212
                        ],
                        [
                            -12.91634,
                            27.95369
                        ],
                        [
                            -12.98022,
                            27.8933
                        ],
                        [
                            -13.00882,
                            27.80926
                        ],
                        [
                            -13.07206,
                            27.73587
                        ],
                        [
                            -13.16033,
                            27.69697
                        ],
                        [
                            -13.30616,
                            27.32133
                        ],
                        [
                            -13.40711,
                            27.16409
                        ],
                        [
                            -13.42101,
                            27.07628
                        ],
                        [
                            -13.50138,
                            26.86934
                        ],
                        [
                            -13.56612,
                            26.74176
                        ],
                        [
                            -13.61336,
                            26.6927
                        ],
                        [
                            -13.74387,
                            26.60679
                        ],
                        [
                            -14.0438,
                            26.4442
                        ],
                        [
                            -14.18122,
                            26.42376
                        ],
                        [
                            -14.25054,
                            26.33266
                        ],
                        [
                            -14.31935,
                            26.2813
                        ],
                        [
                            -14.40375,
                            26.26078
                        ],
                        [
                            -14.47329,
                            26.18103
                        ],
                        [
                            -14.49982,
                            25.9865
                        ],
                        [
                            -14.56803,
                            25.84828
                        ],
                        [
                            -14.63598,
                            25.76747
                        ],
                        [
                            -14.69631,
                            25.54721
                        ],
                        [
                            -14.78601,
                            25.41772
                        ],
                        [
                            -14.8437,
                            25.2035
                        ],
                        [
                            -14.84006,
                            25.08772
                        ],
                        [
                            -14.81908,
                            25.04809
                        ],
                        [
                            -14.83005,
                            24.90918
                        ],
                        [
                            -14.87067,
                            24.80842
                        ],
                        [
                            -14.88511,
                            24.70059
                        ],
                        [
                            -14.98381,
                            24.63062
                        ],
                        [
                            -15.0027,
                            24.5697
                        ],
                        [
                            -15.14501,
                            24.49989
                        ],
                        [
                            -15.22087,
                            24.43905
                        ],
                        [
                            -15.32827,
                            24.30552
                        ],
                        [
                            -15.44975,
                            24.21075
                        ],
                        [
                            -15.57516,
                            24.08989
                        ],
                        [
                            -15.59345,
                            24.04409
                        ],
                        [
                            -15.8005,
                            23.92332
                        ],
                        [
                            -15.73952,
                            23.86537
                        ],
                        [
                            -15.73903,
                            23.78768
                        ],
                        [
                            -15.79123,
                            23.73659
                        ],
                        [
                            -15.90594,
                            23.5667
                        ],
                        [
                            -15.97276,
                            23.50893
                        ],
                        [
                            -15.95796,
                            23.45858
                        ],
                        [
                            -15.99884,
                            23.3877
                        ],
                        [
                            -16.06218,
                            23.32966
                        ],
                        [
                            -16.12274,
                            23.19341
                        ],
                        [
                            -16.18834,
                            23.12119
                        ],
                        [
                            -16.14182,
                            23.01819
                        ],
                        [
                            -16.19217,
                            22.93324
                        ],
                        [
                            -16.27084,
                            22.89607
                        ],
                        [
                            -16.32766,
                            22.7743
                        ],
                        [
                            -16.35969,
                            22.57733
                        ],
                        [
                            -16.42526,
                            22.52235
                        ],
                        [
                            -16.45991,
                            22.39172
                        ],
                        [
                            -16.49493,
                            22.3238
                        ],
                        [
                            -16.61576,
                            22.2686
                        ],
                        [
                            -16.68107,
                            22.29334
                        ],
                        [
                            -16.803,
                            22.16251
                        ],
                        [
                            -16.9195,
                            21.86715
                        ],
                        [
                            -16.96512,
                            21.79268
                        ],
                        [
                            -16.98066,
                            21.71433
                        ],
                        [
                            -16.98114,
                            21.56192
                        ],
                        [
                            -17.03005,
                            21.33012
                        ],
                        [
                            -17.02772,
                            21.29069
                        ],
                        [
                            -17.06424,
                            21.07873
                        ],
                        [
                            -17.06393,
                            21.00053
                        ],
                        [
                            -17.10328,
                            20.84346
                        ],
                        [
                            -17.0513,
                            20.77162
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "MOZ",
                "Country": "Mozambique",
                "Total_3GHG": 0.19,
                "Total_3GHG_timeseries": [
                    5.0847e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032
                ],
                "Fossil_3GHG": 0.06,
                "Fossil_3GHG_timeseries": [
                    3.1412e-07,
                    6.239e-07,
                    9.2933e-07,
                    1.2304e-06,
                    1.5271e-06,
                    1.8194e-06,
                    2.1074e-06,
                    2.3909e-06,
                    2.6701e-06,
                    2.9448e-06,
                    3.2111e-06,
                    3.4691e-06,
                    3.7201e-06,
                    3.9628e-06,
                    4.198e-06,
                    4.4258e-06,
                    4.6462e-06,
                    4.8592e-06,
                    5.0648e-06,
                    5.263e-06,
                    5.4603e-06,
                    5.6568e-06,
                    5.8527e-06,
                    6.0481e-06,
                    6.243e-06,
                    6.4375e-06,
                    6.6315e-06,
                    6.825e-06,
                    7.0178e-06,
                    7.2098e-06,
                    7.4038e-06,
                    7.5996e-06,
                    7.796e-06,
                    7.9943e-06,
                    8.1935e-06,
                    8.3938e-06,
                    8.595e-06,
                    8.7971e-06,
                    9.0003e-06,
                    9.2056e-06,
                    9.4022e-06,
                    9.5904e-06,
                    9.7703e-06,
                    9.9421e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007
                ],
                "Land_3GHG": 0.44,
                "Land_3GHG_timeseries": [
                    4.7706e-06,
                    9.623e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025
                ],
                "Total_CO2": 0.17,
                "Total_CO2_timeseries": [
                    4.4192e-06,
                    8.9151e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019
                ],
                "Fossil_CO2": 0.01,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.98e-08,
                    2.9673e-08,
                    3.4583e-08,
                    3.9493e-08,
                    4.4403e-08,
                    7.2413e-08,
                    9.5476e-08,
                    1.2515e-07,
                    1.4657e-07,
                    1.6965e-07,
                    1.9602e-07,
                    2.1413e-07,
                    2.4377e-07,
                    2.7342e-07,
                    2.9976e-07,
                    3.1292e-07,
                    3.3597e-07,
                    3.6067e-07,
                    3.8205e-07,
                    4.0675e-07,
                    4.3309e-07,
                    4.5282e-07,
                    4.7914e-07,
                    8.8495e-07,
                    1.3039e-06,
                    1.7872e-06,
                    2.2738e-06,
                    2.7884e-06,
                    3.4069e-06,
                    4.1062e-06,
                    4.9029e-06,
                    5.7209e-06,
                    6.529e-06,
                    7.3767e-06,
                    8.5611e-06,
                    9.455e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CO2": 0.51,
                "Land_CO2_timeseries": [
                    4.4192e-06,
                    8.9151e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018
                ],
                "Total_CH4": 0.24,
                "Total_CH4_timeseries": [
                    5.2515e-07,
                    1.0482e-06,
                    1.5692e-06,
                    2.0881e-06,
                    2.605e-06,
                    3.1197e-06,
                    3.6324e-06,
                    4.143e-06,
                    4.6516e-06,
                    5.1581e-06,
                    5.654e-06,
                    6.1393e-06,
                    6.6154e-06,
                    7.0809e-06,
                    7.5368e-06,
                    7.9831e-06,
                    8.4197e-06,
                    8.8467e-06,
                    9.264e-06,
                    9.6718e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001
                ],
                "Fossil_CH4": 0.21,
                "Fossil_CH4_timeseries": [
                    3.0556e-07,
                    6.0662e-07,
                    9.0319e-07,
                    1.1953e-06,
                    1.4829e-06,
                    1.766e-06,
                    2.0446e-06,
                    2.3187e-06,
                    2.5884e-06,
                    2.8535e-06,
                    3.1103e-06,
                    3.3587e-06,
                    3.6001e-06,
                    3.8331e-06,
                    4.0586e-06,
                    4.2767e-06,
                    4.4874e-06,
                    4.6906e-06,
                    4.8864e-06,
                    5.0748e-06,
                    5.2621e-06,
                    5.4483e-06,
                    5.6334e-06,
                    5.8175e-06,
                    6.0005e-06,
                    6.1824e-06,
                    6.3633e-06,
                    6.543e-06,
                    6.7217e-06,
                    6.8994e-06,
                    7.0788e-06,
                    7.2599e-06,
                    7.4415e-06,
                    7.6249e-06,
                    7.8092e-06,
                    7.9943e-06,
                    8.1804e-06,
                    8.3673e-06,
                    8.555e-06,
                    8.7437e-06,
                    8.9233e-06,
                    9.0941e-06,
                    9.2562e-06,
                    9.4096e-06,
                    9.5547e-06,
                    9.6915e-06,
                    9.8202e-06,
                    9.9409e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006
                ],
                "Land_CH4": 0.28,
                "Land_CH4_timeseries": [
                    2.1959e-07,
                    4.416e-07,
                    6.6602e-07,
                    8.9285e-07,
                    1.1221e-06,
                    1.3538e-06,
                    1.5878e-06,
                    1.8243e-06,
                    2.0632e-06,
                    2.3045e-06,
                    2.5436e-06,
                    2.7806e-06,
                    3.0153e-06,
                    3.2478e-06,
                    3.4782e-06,
                    3.7063e-06,
                    3.9323e-06,
                    4.156e-06,
                    4.3776e-06,
                    4.597e-06,
                    4.8136e-06,
                    5.0275e-06,
                    5.2387e-06,
                    5.4471e-06,
                    5.6527e-06,
                    5.8556e-06,
                    6.0558e-06,
                    6.2533e-06,
                    6.448e-06,
                    6.6399e-06,
                    6.8331e-06,
                    7.0274e-06,
                    7.223e-06,
                    7.4197e-06,
                    7.6177e-06,
                    7.8168e-06,
                    8.0172e-06,
                    8.2187e-06,
                    8.4215e-06,
                    8.6254e-06,
                    8.8306e-06,
                    9.0371e-06,
                    9.2449e-06,
                    9.454e-06,
                    9.6643e-06,
                    9.8759e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Total_N2O": 0.33,
                "Total_N2O_timeseries": [
                    1.404e-07,
                    2.8359e-07,
                    4.2944e-07,
                    5.7779e-07,
                    7.2843e-07,
                    8.8112e-07,
                    1.0355e-06,
                    1.1913e-06,
                    1.3481e-06,
                    1.5055e-06,
                    1.6632e-06,
                    1.821e-06,
                    1.9791e-06,
                    2.1373e-06,
                    2.2955e-06,
                    2.4539e-06,
                    2.6125e-06,
                    2.7712e-06,
                    2.9302e-06,
                    3.0894e-06,
                    3.2513e-06,
                    3.4199e-06,
                    3.5982e-06,
                    3.7883e-06,
                    3.9916e-06,
                    4.2082e-06,
                    4.4376e-06,
                    4.6782e-06,
                    4.9275e-06,
                    5.1821e-06,
                    5.4397e-06,
                    5.6998e-06,
                    5.9621e-06,
                    6.2262e-06,
                    6.4919e-06,
                    6.7592e-06,
                    7.0281e-06,
                    7.2986e-06,
                    7.571e-06,
                    7.8581e-06,
                    8.1481e-06,
                    8.4413e-06,
                    8.7377e-06,
                    9.0375e-06,
                    9.3408e-06,
                    9.6478e-06,
                    9.9586e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_N2O": 0.09,
                "Fossil_N2O_timeseries": [
                    8.5668e-09,
                    1.7282e-08,
                    2.6139e-08,
                    3.5132e-08,
                    4.425e-08,
                    5.3483e-08,
                    6.2816e-08,
                    7.2234e-08,
                    8.1719e-08,
                    9.1251e-08,
                    1.0082e-07,
                    1.1042e-07,
                    1.2005e-07,
                    1.297e-07,
                    1.3938e-07,
                    1.4909e-07,
                    1.5883e-07,
                    1.686e-07,
                    1.784e-07,
                    1.8824e-07,
                    1.9821e-07,
                    2.0851e-07,
                    2.1928e-07,
                    2.306e-07,
                    2.4254e-07,
                    2.5511e-07,
                    2.6828e-07,
                    2.8198e-07,
                    2.9609e-07,
                    3.1047e-07,
                    3.2501e-07,
                    3.3968e-07,
                    3.5447e-07,
                    3.6936e-07,
                    3.8436e-07,
                    3.9944e-07,
                    4.1462e-07,
                    4.2989e-07,
                    4.4527e-07,
                    4.6187e-07,
                    4.7887e-07,
                    4.9628e-07,
                    5.1413e-07,
                    5.3245e-07,
                    5.5127e-07,
                    5.706e-07,
                    5.9047e-07,
                    6.109e-07,
                    6.3192e-07,
                    6.5354e-07,
                    6.7583e-07,
                    6.9889e-07,
                    7.2279e-07,
                    7.4758e-07,
                    7.7327e-07,
                    7.9986e-07,
                    8.2731e-07,
                    8.5556e-07,
                    8.8452e-07,
                    9.1408e-07,
                    9.4413e-07,
                    9.7464e-07,
                    1.0056e-06,
                    1.0369e-06,
                    1.0686e-06,
                    1.1007e-06,
                    1.1332e-06,
                    1.166e-06,
                    1.1992e-06,
                    1.2329e-06,
                    1.267e-06,
                    1.3015e-06,
                    1.3364e-06,
                    1.3717e-06,
                    1.4074e-06,
                    1.4436e-06,
                    1.4803e-06,
                    1.5175e-06,
                    1.5552e-06,
                    1.5936e-06,
                    1.6329e-06,
                    1.6734e-06,
                    1.7155e-06,
                    1.7595e-06,
                    1.8055e-06,
                    1.8537e-06,
                    1.9043e-06,
                    1.9572e-06,
                    2.0125e-06,
                    2.07e-06,
                    2.1299e-06,
                    2.1926e-06,
                    2.2582e-06,
                    2.3272e-06,
                    2.3995e-06,
                    2.4753e-06,
                    2.5546e-06,
                    2.6374e-06,
                    2.7235e-06,
                    2.8127e-06,
                    2.9053e-06,
                    3.0016e-06,
                    3.102e-06,
                    3.2067e-06,
                    3.3156e-06,
                    3.4289e-06,
                    3.5463e-06,
                    3.6676e-06,
                    3.7923e-06,
                    3.9199e-06,
                    4.0502e-06,
                    4.183e-06,
                    4.3187e-06,
                    4.4573e-06,
                    4.5994e-06,
                    4.7455e-06,
                    4.8961e-06,
                    5.0522e-06,
                    5.2144e-06,
                    5.3738e-06,
                    5.5341e-06,
                    5.6936e-06,
                    5.8553e-06,
                    6.0155e-06,
                    6.1753e-06,
                    6.3365e-06,
                    6.4971e-06,
                    6.6583e-06,
                    6.8216e-06,
                    6.988e-06,
                    7.1543e-06,
                    7.3714e-06,
                    7.594e-06,
                    7.7986e-06,
                    8.0185e-06,
                    8.2386e-06,
                    8.4496e-06,
                    8.6529e-06,
                    8.8652e-06,
                    9.0863e-06,
                    9.3073e-06,
                    9.534e-06,
                    9.77e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.43,
                "Land_N2O_timeseries": [
                    1.3183e-07,
                    2.663e-07,
                    4.033e-07,
                    5.4266e-07,
                    6.8418e-07,
                    8.2763e-07,
                    9.7272e-07,
                    1.1191e-06,
                    1.2664e-06,
                    1.4143e-06,
                    1.5624e-06,
                    1.7106e-06,
                    1.859e-06,
                    2.0076e-06,
                    2.1562e-06,
                    2.3049e-06,
                    2.4537e-06,
                    2.6026e-06,
                    2.7518e-06,
                    2.9012e-06,
                    3.0531e-06,
                    3.2114e-06,
                    3.3789e-06,
                    3.5577e-06,
                    3.749e-06,
                    3.9531e-06,
                    4.1693e-06,
                    4.3962e-06,
                    4.6314e-06,
                    4.8716e-06,
                    5.1147e-06,
                    5.3601e-06,
                    5.6076e-06,
                    5.8568e-06,
                    6.1076e-06,
                    6.3598e-06,
                    6.6135e-06,
                    6.8687e-06,
                    7.1257e-06,
                    7.3962e-06,
                    7.6692e-06,
                    7.945e-06,
                    8.2235e-06,
                    8.505e-06,
                    8.7895e-06,
                    9.0772e-06,
                    9.3682e-06,
                    9.6624e-06,
                    9.9602e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                32.89152,
                                -26.85833
                            ],
                            [
                                32.90385,
                                -26.71324
                            ],
                            [
                                32.89417,
                                -26.65621
                            ],
                            [
                                32.95867,
                                -26.08726
                            ],
                            [
                                32.90795,
                                -26.11331
                            ],
                            [
                                32.8346,
                                -26.28627
                            ],
                            [
                                32.72394,
                                -26.18692
                            ],
                            [
                                32.6817,
                                -26.18954
                            ],
                            [
                                32.66145,
                                -26.11607
                            ],
                            [
                                32.57432,
                                -25.9781
                            ],
                            [
                                32.67438,
                                -25.88851
                            ],
                            [
                                32.7461,
                                -25.86914
                            ],
                            [
                                32.73438,
                                -25.80289
                            ],
                            [
                                32.77985,
                                -25.66274
                            ],
                            [
                                32.83916,
                                -25.57805
                            ],
                            [
                                32.93906,
                                -25.49747
                            ],
                            [
                                33.06424,
                                -25.42041
                            ],
                            [
                                33.3162,
                                -25.28911
                            ],
                            [
                                33.51802,
                                -25.20317
                            ],
                            [
                                33.86194,
                                -25.07188
                            ],
                            [
                                33.99298,
                                -25.03345
                            ],
                            [
                                34.23094,
                                -24.94463
                            ],
                            [
                                34.7836,
                                -24.75868
                            ],
                            [
                                34.9972,
                                -24.66891
                            ],
                            [
                                35.14286,
                                -24.58436
                            ],
                            [
                                35.22183,
                                -24.46845
                            ],
                            [
                                35.40657,
                                -24.25445
                            ],
                            [
                                35.49732,
                                -24.10614
                            ],
                            [
                                35.50204,
                                -23.99143
                            ],
                            [
                                35.55093,
                                -23.86822
                            ],
                            [
                                35.53342,
                                -23.79939
                            ],
                            [
                                35.45457,
                                -23.87354
                            ],
                            [
                                35.40405,
                                -23.84018
                            ],
                            [
                                35.3415,
                                -23.91479
                            ],
                            [
                                35.37335,
                                -23.7072
                            ],
                            [
                                35.43106,
                                -23.64915
                            ],
                            [
                                35.42836,
                                -23.49438
                            ],
                            [
                                35.48489,
                                -23.33524
                            ],
                            [
                                35.49085,
                                -23.16308
                            ],
                            [
                                35.51322,
                                -23.09626
                            ],
                            [
                                35.58775,
                                -22.97551
                            ],
                            [
                                35.52123,
                                -22.83862
                            ],
                            [
                                35.50359,
                                -22.59222
                            ],
                            [
                                35.53771,
                                -22.43523
                            ],
                            [
                                35.5429,
                                -22.32958
                            ],
                            [
                                35.52314,
                                -22.21264
                            ],
                            [
                                35.48005,
                                -22.10298
                            ],
                            [
                                35.40145,
                                -22.20587
                            ],
                            [
                                35.33488,
                                -22.14097
                            ],
                            [
                                35.31853,
                                -21.91474
                            ],
                            [
                                35.284,
                                -21.80575
                            ],
                            [
                                35.26958,
                                -21.63831
                            ],
                            [
                                35.13409,
                                -21.40806
                            ],
                            [
                                35.10007,
                                -21.21318
                            ],
                            [
                                35.05967,
                                -21.13283
                            ],
                            [
                                35.12213,
                                -20.96892
                            ],
                            [
                                35.03376,
                                -20.83825
                            ],
                            [
                                35.00099,
                                -20.72134
                            ],
                            [
                                34.92314,
                                -20.62951
                            ],
                            [
                                34.85086,
                                -20.63325
                            ],
                            [
                                34.75586,
                                -20.54436
                            ],
                            [
                                34.70351,
                                -20.52027
                            ],
                            [
                                34.6935,
                                -20.32812
                            ],
                            [
                                34.73787,
                                -20.23106
                            ],
                            [
                                34.709,
                                -20.16738
                            ],
                            [
                                34.77773,
                                -20.14459
                            ],
                            [
                                34.75131,
                                -20.02011
                            ],
                            [
                                34.77289,
                                -19.85897
                            ],
                            [
                                34.89287,
                                -19.84619
                            ],
                            [
                                34.97774,
                                -19.80029
                            ],
                            [
                                35.13459,
                                -19.68917
                            ],
                            [
                                35.39146,
                                -19.46752
                            ],
                            [
                                35.52478,
                                -19.30924
                            ],
                            [
                                35.75066,
                                -19.06813
                            ],
                            [
                                35.96676,
                                -18.93934
                            ],
                            [
                                36.13676,
                                -18.90075
                            ],
                            [
                                36.27202,
                                -18.88461
                            ],
                            [
                                36.38375,
                                -18.78471
                            ],
                            [
                                36.37902,
                                -18.69656
                            ],
                            [
                                36.47096,
                                -18.60986
                            ],
                            [
                                36.50887,
                                -18.53638
                            ],
                            [
                                36.62381,
                                -18.41673
                            ],
                            [
                                36.81581,
                                -18.23342
                            ],
                            [
                                36.9653,
                                -18.06421
                            ],
                            [
                                36.9668,
                                -18.03637
                            ],
                            [
                                37.11031,
                                -17.85462
                            ],
                            [
                                37.19781,
                                -17.7669
                            ],
                            [
                                37.33132,
                                -17.67396
                            ],
                            [
                                37.61157,
                                -17.53541
                            ],
                            [
                                37.84427,
                                -17.40735
                            ],
                            [
                                38.00423,
                                -17.33993
                            ],
                            [
                                38.15426,
                                -17.29593
                            ],
                            [
                                38.24884,
                                -17.23303
                            ],
                            [
                                38.43985,
                                -17.15952
                            ],
                            [
                                38.6899,
                                -17.08159
                            ],
                            [
                                38.88351,
                                -17.04756
                            ],
                            [
                                38.95163,
                                -17.02082
                            ],
                            [
                                39.07132,
                                -17.01147
                            ],
                            [
                                39.14907,
                                -16.8849
                            ],
                            [
                                39.20236,
                                -16.83276
                            ],
                            [
                                39.34117,
                                -16.74389
                            ],
                            [
                                39.48104,
                                -16.6784
                            ],
                            [
                                39.8077,
                                -16.46351
                            ],
                            [
                                39.9046,
                                -16.41218
                            ],
                            [
                                39.94357,
                                -16.31951
                            ],
                            [
                                39.86642,
                                -16.24388
                            ],
                            [
                                39.96437,
                                -16.23954
                            ],
                            [
                                40.02543,
                                -16.18957
                            ],
                            [
                                40.09997,
                                -16.07998
                            ],
                            [
                                40.13867,
                                -15.9681
                            ],
                            [
                                40.18965,
                                -15.89788
                            ],
                            [
                                40.35137,
                                -15.74351
                            ],
                            [
                                40.42989,
                                -15.61659
                            ],
                            [
                                40.56237,
                                -15.49855
                            ],
                            [
                                40.58895,
                                -15.4015
                            ],
                            [
                                40.67752,
                                -15.25397
                            ],
                            [
                                40.62025,
                                -15.14988
                            ],
                            [
                                40.6307,
                                -15.08915
                            ],
                            [
                                40.70653,
                                -15.07461
                            ],
                            [
                                40.65743,
                                -14.99535
                            ],
                            [
                                40.74687,
                                -14.98467
                            ],
                            [
                                40.75489,
                                -14.87172
                            ],
                            [
                                40.83119,
                                -14.82398
                            ],
                            [
                                40.83553,
                                -14.68133
                            ],
                            [
                                40.80056,
                                -14.62769
                            ],
                            [
                                40.8289,
                                -14.49514
                            ],
                            [
                                40.80559,
                                -14.41303
                            ],
                            [
                                40.62563,
                                -14.47711
                            ],
                            [
                                40.64623,
                                -14.38899
                            ],
                            [
                                40.72976,
                                -14.33371
                            ],
                            [
                                40.7161,
                                -14.20702
                            ],
                            [
                                40.65297,
                                -14.19928
                            ],
                            [
                                40.61464,
                                -14.23999
                            ],
                            [
                                40.56105,
                                -14.22689
                            ],
                            [
                                40.53897,
                                -14.15782
                            ],
                            [
                                40.60638,
                                -14.14246
                            ],
                            [
                                40.6364,
                                -14.02439
                            ],
                            [
                                40.58847,
                                -13.88663
                            ],
                            [
                                40.57245,
                                -13.71686
                            ],
                            [
                                40.54383,
                                -13.68878
                            ],
                            [
                                40.56048,
                                -13.56342
                            ],
                            [
                                40.52524,
                                -13.50922
                            ],
                            [
                                40.58296,
                                -13.36513
                            ],
                            [
                                40.55669,
                                -13.21829
                            ],
                            [
                                40.5564,
                                -13.057
                            ],
                            [
                                40.58423,
                                -12.99312
                            ],
                            [
                                40.50916,
                                -12.95302
                            ],
                            [
                                40.50628,
                                -13.02938
                            ],
                            [
                                40.44357,
                                -13.02792
                            ],
                            [
                                40.40434,
                                -12.94946
                            ],
                            [
                                40.45521,
                                -12.88635
                            ],
                            [
                                40.5274,
                                -12.89646
                            ],
                            [
                                40.54276,
                                -12.83623
                            ],
                            [
                                40.6089,
                                -12.80183
                            ],
                            [
                                40.62855,
                                -12.75481
                            ],
                            [
                                40.57853,
                                -12.71204
                            ],
                            [
                                40.55122,
                                -12.58557
                            ],
                            [
                                40.56601,
                                -12.53303
                            ],
                            [
                                40.47644,
                                -12.50396
                            ],
                            [
                                40.53071,
                                -12.40811
                            ],
                            [
                                40.49875,
                                -12.36869
                            ],
                            [
                                40.4907,
                                -12.2713
                            ],
                            [
                                40.51337,
                                -12.20291
                            ],
                            [
                                40.4891,
                                -12.14502
                            ],
                            [
                                40.5008,
                                -12.05824
                            ],
                            [
                                40.53728,
                                -11.99922
                            ],
                            [
                                40.48559,
                                -11.92914
                            ],
                            [
                                40.46393,
                                -11.74903
                            ],
                            [
                                40.43622,
                                -11.72558
                            ],
                            [
                                40.45411,
                                -11.60127
                            ],
                            [
                                40.44891,
                                -11.52826
                            ],
                            [
                                40.47329,
                                -11.40888
                            ],
                            [
                                40.42034,
                                -11.39065
                            ],
                            [
                                40.38255,
                                -11.32673
                            ],
                            [
                                40.43365,
                                -11.23497
                            ],
                            [
                                40.50534,
                                -11.19686
                            ],
                            [
                                40.49116,
                                -11.15014
                            ],
                            [
                                40.56151,
                                -11.03414
                            ],
                            [
                                40.48336,
                                -11
                            ],
                            [
                                40.51314,
                                -10.91482
                            ],
                            [
                                40.59046,
                                -10.86465
                            ],
                            [
                                40.57242,
                                -10.8191
                            ],
                            [
                                40.48519,
                                -10.7534
                            ],
                            [
                                40.57249,
                                -10.69132
                            ],
                            [
                                40.58195,
                                -10.60136
                            ],
                            [
                                40.53416,
                                -10.57501
                            ],
                            [
                                40.53241,
                                -10.49371
                            ],
                            [
                                40.44777,
                                -10.47529
                            ],
                            [
                                40.39442,
                                -10.51072
                            ],
                            [
                                40.35826,
                                -10.57244
                            ],
                            [
                                40.29645,
                                -10.56759
                            ],
                            [
                                40.21484,
                                -10.61257
                            ],
                            [
                                40.20141,
                                -10.64481
                            ],
                            [
                                40.04252,
                                -10.76509
                            ],
                            [
                                40.00074,
                                -10.8091
                            ],
                            [
                                39.86709,
                                -10.84925
                            ],
                            [
                                39.80877,
                                -10.89971
                            ],
                            [
                                39.62063,
                                -10.94497
                            ],
                            [
                                39.33025,
                                -11.10242
                            ],
                            [
                                39.2404,
                                -11.17331
                            ],
                            [
                                39.12331,
                                -11.1441
                            ],
                            [
                                39.03335,
                                -11.16905
                            ],
                            [
                                38.88411,
                                -11.17176
                            ],
                            [
                                38.75183,
                                -11.27128
                            ],
                            [
                                38.63454,
                                -11.2881
                            ],
                            [
                                38.49042,
                                -11.4166
                            ],
                            [
                                38.36892,
                                -11.37646
                            ],
                            [
                                38.26845,
                                -11.29116
                            ],
                            [
                                38.11249,
                                -11.25699
                            ],
                            [
                                38.0628,
                                -11.27596
                            ],
                            [
                                37.94636,
                                -11.25961
                            ],
                            [
                                37.83167,
                                -11.31122
                            ],
                            [
                                37.82703,
                                -11.36992
                            ],
                            [
                                37.77867,
                                -11.45397
                            ],
                            [
                                37.78428,
                                -11.50797
                            ],
                            [
                                37.73362,
                                -11.55447
                            ],
                            [
                                37.65759,
                                -11.5776
                            ],
                            [
                                37.58309,
                                -11.62572
                            ],
                            [
                                37.49978,
                                -11.61553
                            ],
                            [
                                37.41747,
                                -11.68273
                            ],
                            [
                                37.33237,
                                -11.67502
                            ],
                            [
                                37.30109,
                                -11.64241
                            ],
                            [
                                37.22142,
                                -11.65426
                            ],
                            [
                                37.08509,
                                -11.62592
                            ],
                            [
                                36.98595,
                                -11.58063
                            ],
                            [
                                36.91644,
                                -11.60411
                            ],
                            [
                                36.80123,
                                -11.57653
                            ],
                            [
                                36.76904,
                                -11.6443
                            ],
                            [
                                36.62314,
                                -11.73459
                            ],
                            [
                                36.5752,
                                -11.70049
                            ],
                            [
                                36.47261,
                                -11.68032
                            ],
                            [
                                36.29572,
                                -11.72084
                            ],
                            [
                                36.21591,
                                -11.7063
                            ],
                            [
                                36.18375,
                                -11.66189
                            ],
                            [
                                36.18745,
                                -11.60282
                            ],
                            [
                                36.03904,
                                -11.49357
                            ],
                            [
                                35.93099,
                                -11.43782
                            ],
                            [
                                35.84445,
                                -11.41259
                            ],
                            [
                                35.77625,
                                -11.46742
                            ],
                            [
                                35.7142,
                                -11.47777
                            ],
                            [
                                35.65574,
                                -11.54713
                            ],
                            [
                                35.50577,
                                -11.57861
                            ],
                            [
                                35.40843,
                                -11.57048
                            ],
                            [
                                34.95957,
                                -11.57333
                            ],
                            [
                                34.61284,
                                -11.57337
                            ],
                            [
                                34.64624,
                                -11.68588
                            ],
                            [
                                34.63674,
                                -11.73185
                            ],
                            [
                                34.55319,
                                -11.85451
                            ],
                            [
                                34.54656,
                                -11.92174
                            ],
                            [
                                34.36008,
                                -12.20645
                            ],
                            [
                                34.35967,
                                -12.29237
                            ],
                            [
                                34.4185,
                                -12.41498
                            ],
                            [
                                34.42577,
                                -12.49122
                            ],
                            [
                                34.47718,
                                -12.57556
                            ],
                            [
                                34.51428,
                                -12.7326
                            ],
                            [
                                34.525,
                                -12.84866
                            ],
                            [
                                34.57481,
                                -13.04906
                            ],
                            [
                                34.55834,
                                -13.38278
                            ],
                            [
                                34.60441,
                                -13.4813
                            ],
                            [
                                34.88047,
                                -13.48148
                            ],
                            [
                                35.10304,
                                -13.69715
                            ],
                            [
                                35.24085,
                                -13.87877
                            ],
                            [
                                35.50004,
                                -14.16908
                            ],
                            [
                                35.53562,
                                -14.2589
                            ],
                            [
                                35.88437,
                                -14.6726
                            ],
                            [
                                35.88574,
                                -14.89151
                            ],
                            [
                                35.93104,
                                -14.8948
                            ],
                            [
                                35.80399,
                                -15.16815
                            ],
                            [
                                35.86608,
                                -15.4179
                            ],
                            [
                                35.82724,
                                -15.92581
                            ],
                            [
                                35.81326,
                                -16.03128
                            ],
                            [
                                35.70555,
                                -16.1011
                            ],
                            [
                                35.67009,
                                -16.09701
                            ],
                            [
                                35.52411,
                                -16.16601
                            ],
                            [
                                35.48394,
                                -16.12228
                            ],
                            [
                                35.4071,
                                -16.1261
                            ],
                            [
                                35.3157,
                                -16.20663
                            ],
                            [
                                35.26432,
                                -16.3985
                            ],
                            [
                                35.26037,
                                -16.47526
                            ],
                            [
                                35.14563,
                                -16.56076
                            ],
                            [
                                35.17143,
                                -16.62105
                            ],
                            [
                                35.22853,
                                -16.64976
                            ],
                            [
                                35.28668,
                                -16.71312
                            ],
                            [
                                35.3124,
                                -16.83087
                            ],
                            [
                                35.26479,
                                -16.94203
                            ],
                            [
                                35.30298,
                                -16.98208
                            ],
                            [
                                35.31111,
                                -17.06249
                            ],
                            [
                                35.28471,
                                -17.12717
                            ],
                            [
                                35.10746,
                                -17.1287
                            ],
                            [
                                35.05836,
                                -17.04763
                            ],
                            [
                                35.07188,
                                -16.98925
                            ],
                            [
                                35.16768,
                                -16.93569
                            ],
                            [
                                35.12814,
                                -16.81728
                            ],
                            [
                                35.0565,
                                -16.83085
                            ],
                            [
                                34.92333,
                                -16.74494
                            ],
                            [
                                34.85814,
                                -16.67193
                            ],
                            [
                                34.84615,
                                -16.6171
                            ],
                            [
                                34.77448,
                                -16.58089
                            ],
                            [
                                34.73629,
                                -16.50626
                            ],
                            [
                                34.68694,
                                -16.49897
                            ],
                            [
                                34.59435,
                                -16.41522
                            ],
                            [
                                34.56874,
                                -16.31553
                            ],
                            [
                                34.4912,
                                -16.29393
                            ],
                            [
                                34.42042,
                                -16.24627
                            ],
                            [
                                34.39215,
                                -16.13614
                            ],
                            [
                                34.4237,
                                -16.04036
                            ],
                            [
                                34.3087,
                                -15.93182
                            ],
                            [
                                34.25852,
                                -15.91336
                            ],
                            [
                                34.25175,
                                -15.84217
                            ],
                            [
                                34.30603,
                                -15.75594
                            ],
                            [
                                34.36921,
                                -15.73335
                            ],
                            [
                                34.43249,
                                -15.6596
                            ],
                            [
                                34.44107,
                                -15.53742
                            ],
                            [
                                34.42594,
                                -15.47507
                            ],
                            [
                                34.51275,
                                -15.40949
                            ],
                            [
                                34.52184,
                                -15.35059
                            ],
                            [
                                34.60038,
                                -15.28072
                            ],
                            [
                                34.57923,
                                -15.2019
                            ],
                            [
                                34.57684,
                                -15.06162
                            ],
                            [
                                34.62186,
                                -15.00146
                            ],
                            [
                                34.56693,
                                -14.89685
                            ],
                            [
                                34.58277,
                                -14.80868
                            ],
                            [
                                34.52114,
                                -14.68697
                            ],
                            [
                                34.54974,
                                -14.64554
                            ],
                            [
                                34.51387,
                                -14.55425
                            ],
                            [
                                34.47569,
                                -14.53181
                            ],
                            [
                                34.39269,
                                -14.39658
                            ],
                            [
                                34.29802,
                                -14.39984
                            ],
                            [
                                34.26486,
                                -14.42964
                            ],
                            [
                                34.09028,
                                -14.45642
                            ],
                            [
                                34.08163,
                                -14.48755
                            ],
                            [
                                33.92065,
                                -14.47749
                            ],
                            [
                                33.81263,
                                -14.54819
                            ],
                            [
                                33.71058,
                                -14.5067
                            ],
                            [
                                33.71435,
                                -14.57715
                            ],
                            [
                                33.63518,
                                -14.58393
                            ],
                            [
                                33.60474,
                                -14.49223
                            ],
                            [
                                33.54041,
                                -14.43018
                            ],
                            [
                                33.47303,
                                -14.39993
                            ],
                            [
                                33.37604,
                                -14.21374
                            ],
                            [
                                33.34208,
                                -14.21377
                            ],
                            [
                                33.29987,
                                -14.14256
                            ],
                            [
                                33.31657,
                                -14.08837
                            ],
                            [
                                33.29452,
                                -14.03445
                            ],
                            [
                                33.24222,
                                -13.99852
                            ],
                            [
                                33.20672,
                                -14.00444
                            ],
                            [
                                32.61303,
                                -14.2137
                            ],
                            [
                                32.45068,
                                -14.28265
                            ],
                            [
                                32.24352,
                                -14.32286
                            ],
                            [
                                32.05615,
                                -14.38843
                            ],
                            [
                                31.94781,
                                -14.41297
                            ],
                            [
                                31.81475,
                                -14.47679
                            ],
                            [
                                31.68165,
                                -14.50752
                            ],
                            [
                                31.47334,
                                -14.61945
                            ],
                            [
                                31.26428,
                                -14.65951
                            ],
                            [
                                31.08057,
                                -14.7167
                            ],
                            [
                                30.79877,
                                -14.78385
                            ],
                            [
                                30.51718,
                                -14.88835
                            ],
                            [
                                30.36618,
                                -14.95912
                            ],
                            [
                                30.21821,
                                -14.99832
                            ],
                            [
                                30.23038,
                                -15.13849
                            ],
                            [
                                30.27967,
                                -15.25114
                            ],
                            [
                                30.37569,
                                -15.34252
                            ],
                            [
                                30.40132,
                                -15.47285
                            ],
                            [
                                30.36583,
                                -15.5532
                            ],
                            [
                                30.41826,
                                -15.61757
                            ],
                            [
                                30.42519,
                                -15.63229
                            ],
                            [
                                30.42584,
                                -15.99957
                            ],
                            [
                                30.92071,
                                -16.0001
                            ],
                            [
                                30.98351,
                                -16.05862
                            ],
                            [
                                31.03131,
                                -16.01927
                            ],
                            [
                                31.13821,
                                -15.98318
                            ],
                            [
                                31.30676,
                                -16.02725
                            ],
                            [
                                31.43106,
                                -16.1556
                            ],
                            [
                                31.54729,
                                -16.18457
                            ],
                            [
                                31.69154,
                                -16.20191
                            ],
                            [
                                31.77082,
                                -16.23751
                            ],
                            [
                                31.83336,
                                -16.31035
                            ],
                            [
                                31.89442,
                                -16.33817
                            ],
                            [
                                31.91841,
                                -16.41389
                            ],
                            [
                                32.03821,
                                -16.44193
                            ],
                            [
                                32.27757,
                                -16.43467
                            ],
                            [
                                32.41156,
                                -16.46957
                            ],
                            [
                                32.70849,
                                -16.60026
                            ],
                            [
                                32.7038,
                                -16.67706
                            ],
                            [
                                32.76654,
                                -16.70788
                            ],
                            [
                                32.89076,
                                -16.7193
                            ],
                            [
                                32.97645,
                                -16.70767
                            ],
                            [
                                32.96673,
                                -16.77175
                            ],
                            [
                                32.91223,
                                -16.89277
                            ],
                            [
                                32.84866,
                                -16.94669
                            ],
                            [
                                32.93931,
                                -17.0717
                            ],
                            [
                                32.9865,
                                -17.1806
                            ],
                            [
                                32.99837,
                                -17.30914
                            ],
                            [
                                33.04325,
                                -17.34674
                            ],
                            [
                                32.95981,
                                -17.49275
                            ],
                            [
                                32.98095,
                                -17.5607
                            ],
                            [
                                33.04251,
                                -17.60695
                            ],
                            [
                                33.00396,
                                -17.74048
                            ],
                            [
                                33.00862,
                                -17.80066
                            ],
                            [
                                32.96095,
                                -17.81769
                            ],
                            [
                                32.94246,
                                -17.98577
                            ],
                            [
                                33.00839,
                                -18.2339
                            ],
                            [
                                33.00189,
                                -18.30203
                            ],
                            [
                                33.05403,
                                -18.36214
                            ],
                            [
                                33.02336,
                                -18.39417
                            ],
                            [
                                33.01475,
                                -18.47267
                            ],
                            [
                                32.89113,
                                -18.50857
                            ],
                            [
                                32.88791,
                                -18.58037
                            ],
                            [
                                32.95407,
                                -18.69327
                            ],
                            [
                                32.92678,
                                -18.76697
                            ],
                            [
                                32.87511,
                                -18.79577
                            ],
                            [
                                32.81776,
                                -18.7803
                            ],
                            [
                                32.71519,
                                -18.83149
                            ],
                            [
                                32.72991,
                                -18.92509
                            ],
                            [
                                32.70113,
                                -18.94278
                            ],
                            [
                                32.71884,
                                -19.02099
                            ],
                            [
                                32.84592,
                                -19.02843
                            ],
                            [
                                32.8769,
                                -19.11315
                            ],
                            [
                                32.84992,
                                -19.29134
                            ],
                            [
                                32.7797,
                                -19.35871
                            ],
                            [
                                32.77983,
                                -19.46194
                            ],
                            [
                                32.84447,
                                -19.48007
                            ],
                            [
                                32.85038,
                                -19.68414
                            ],
                            [
                                32.96859,
                                -19.65607
                            ],
                            [
                                32.95881,
                                -19.72177
                            ],
                            [
                                33.05199,
                                -19.781
                            ],
                            [
                                33.01082,
                                -20.01728
                            ],
                            [
                                32.92902,
                                -20.04378
                            ],
                            [
                                32.91653,
                                -20.11611
                            ],
                            [
                                32.86752,
                                -20.11496
                            ],
                            [
                                32.86159,
                                -20.28893
                            ],
                            [
                                32.73431,
                                -20.44843
                            ],
                            [
                                32.65589,
                                -20.56113
                            ],
                            [
                                32.56746,
                                -20.56168
                            ],
                            [
                                32.49137,
                                -20.62048
                            ],
                            [
                                32.49787,
                                -20.80704
                            ],
                            [
                                32.51802,
                                -20.88629
                            ],
                            [
                                32.49293,
                                -20.96849
                            ],
                            [
                                32.36752,
                                -21.13652
                            ],
                            [
                                32.39909,
                                -21.20525
                            ],
                            [
                                32.47519,
                                -21.31009
                            ],
                            [
                                32.39848,
                                -21.32898
                            ],
                            [
                                31.90382,
                                -21.83988
                            ],
                            [
                                31.38151,
                                -22.37176
                            ],
                            [
                                31.31127,
                                -22.41774
                            ],
                            [
                                31.3101,
                                -22.43587
                            ],
                            [
                                31.5582,
                                -23.1774
                            ],
                            [
                                31.54583,
                                -23.40272
                            ],
                            [
                                31.56612,
                                -23.48547
                            ],
                            [
                                31.6888,
                                -23.61923
                            ],
                            [
                                31.69573,
                                -23.72082
                            ],
                            [
                                31.7617,
                                -23.87948
                            ],
                            [
                                31.87462,
                                -23.95158
                            ],
                            [
                                31.89172,
                                -24.00184
                            ],
                            [
                                31.91349,
                                -24.18986
                            ],
                            [
                                31.98672,
                                -24.30244
                            ],
                            [
                                32.01144,
                                -24.47614
                            ],
                            [
                                32.0011,
                                -24.68219
                            ],
                            [
                                32.04428,
                                -25.12604
                            ],
                            [
                                32.02489,
                                -25.37267
                            ],
                            [
                                31.98929,
                                -25.44544
                            ],
                            [
                                32.01255,
                                -25.63768
                            ],
                            [
                                31.93807,
                                -25.83085
                            ],
                            [
                                31.98213,
                                -25.95205
                            ],
                            [
                                32.00495,
                                -25.99025
                            ],
                            [
                                32.08816,
                                -26.01386
                            ],
                            [
                                32.10778,
                                -26.16602
                            ],
                            [
                                32.07523,
                                -26.31163
                            ],
                            [
                                32.08104,
                                -26.41111
                            ],
                            [
                                32.13648,
                                -26.53607
                            ],
                            [
                                32.13366,
                                -26.83498
                            ],
                            [
                                32.22658,
                                -26.83282
                            ],
                            [
                                32.35484,
                                -26.861
                            ],
                            [
                                32.84763,
                                -26.86805
                            ],
                            [
                                32.89152,
                                -26.85833
                            ]
                        ],
                        [
                            [
                                34.67685,
                                -12.08851
                            ],
                            [
                                34.71484,
                                -12.00212
                            ],
                            [
                                34.79191,
                                -12.03655
                            ],
                            [
                                34.78027,
                                -12.0851
                            ],
                            [
                                34.72768,
                                -12.13325
                            ],
                            [
                                34.67685,
                                -12.08851
                            ]
                        ],
                        [
                            [
                                34.57404,
                                -12.01719
                            ],
                            [
                                34.61194,
                                -11.97461
                            ],
                            [
                                34.65809,
                                -12.00102
                            ],
                            [
                                34.63766,
                                -12.07757
                            ],
                            [
                                34.5913,
                                -12.07489
                            ],
                            [
                                34.57404,
                                -12.01719
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                35.42514,
                                -21.72688
                            ],
                            [
                                35.46046,
                                -21.74694
                            ],
                            [
                                35.49607,
                                -21.64843
                            ],
                            [
                                35.43194,
                                -21.65798
                            ],
                            [
                                35.42514,
                                -21.72688
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "MMR",
                "Country": "Myanmar/Burma",
                "Total_3GHG": 0.64,
                "Total_3GHG_timeseries": [
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.004,
                    0.004,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0043,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0051,
                    0.0052,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0054,
                    0.0055,
                    0.0056,
                    0.0056,
                    0.0057,
                    0.0058,
                    0.0058,
                    0.0059,
                    0.006,
                    0.006,
                    0.0061,
                    0.0062,
                    0.0062,
                    0.0063,
                    0.0064,
                    0.0064,
                    0.0065,
                    0.0066,
                    0.0066,
                    0.0067,
                    0.0068,
                    0.0068,
                    0.0069,
                    0.007,
                    0.0071,
                    0.0072,
                    0.0072,
                    0.0073,
                    0.0074,
                    0.0075,
                    0.0076,
                    0.0077,
                    0.0078,
                    0.0079,
                    0.008,
                    0.0082,
                    0.0083,
                    0.0085,
                    0.0086,
                    0.0088,
                    0.0089,
                    0.0091,
                    0.0092,
                    0.0093,
                    0.0095,
                    0.0096,
                    0.0097,
                    0.0099,
                    0.01,
                    0.0101,
                    0.0102,
                    0.0103,
                    0.0104
                ],
                "Fossil_3GHG": 0.11,
                "Fossil_3GHG_timeseries": [
                    1.9921e-07,
                    3.9929e-07,
                    6.0024e-07,
                    8.0206e-07,
                    1.0047e-06,
                    1.2083e-06,
                    1.4126e-06,
                    1.6177e-06,
                    1.8237e-06,
                    2.0303e-06,
                    2.2376e-06,
                    2.4453e-06,
                    2.6536e-06,
                    2.8625e-06,
                    3.0719e-06,
                    3.2819e-06,
                    3.4924e-06,
                    3.7036e-06,
                    3.9153e-06,
                    4.1275e-06,
                    4.3886e-06,
                    4.6993e-06,
                    5.0601e-06,
                    5.4717e-06,
                    5.9343e-06,
                    6.4483e-06,
                    7.0141e-06,
                    7.6318e-06,
                    8.3017e-06,
                    9.0238e-06,
                    9.7983e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012
                ],
                "Land_3GHG": 1.6,
                "Land_3GHG_timeseries": [
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.004,
                    0.004,
                    0.004,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0045,
                    0.0046,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0048,
                    0.0049,
                    0.0049,
                    0.005,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0052,
                    0.0053,
                    0.0053,
                    0.0054,
                    0.0054,
                    0.0055,
                    0.0055,
                    0.0056,
                    0.0056,
                    0.0057,
                    0.0057,
                    0.0058,
                    0.0058,
                    0.0059,
                    0.006,
                    0.006,
                    0.0061,
                    0.0061,
                    0.0062,
                    0.0062,
                    0.0063,
                    0.0064,
                    0.0064,
                    0.0065,
                    0.0066,
                    0.0067,
                    0.0067,
                    0.0068,
                    0.0069,
                    0.007,
                    0.0071,
                    0.0071,
                    0.0072,
                    0.0073,
                    0.0074,
                    0.0076,
                    0.0077,
                    0.0078,
                    0.008,
                    0.0081,
                    0.0082,
                    0.0083,
                    0.0084,
                    0.0085,
                    0.0086,
                    0.0087,
                    0.0089,
                    0.0089,
                    0.009,
                    0.0091,
                    0.0092,
                    0.0092
                ],
                "Total_CO2": 0.57,
                "Total_CO2_timeseries": [
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.004,
                    0.004,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0043,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0045,
                    0.0045,
                    0.0046,
                    0.0046,
                    0.0047,
                    0.0047,
                    0.0048,
                    0.0048,
                    0.0049,
                    0.0049,
                    0.005,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0052,
                    0.0053,
                    0.0053,
                    0.0054,
                    0.0055,
                    0.0056,
                    0.0057,
                    0.0057,
                    0.0058,
                    0.0059,
                    0.0059,
                    0.006,
                    0.0061,
                    0.0061,
                    0.0062,
                    0.0063,
                    0.0063,
                    0.0064,
                    0.0064,
                    0.0065
                ],
                "Fossil_CO2": 0.04,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.4223e-06,
                    2.7951e-06,
                    4.1844e-06,
                    5.5061e-06,
                    6.8475e-06,
                    8.1972e-06,
                    9.5766e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Land_CO2": 1.73,
                "Land_CO2_timeseries": [
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.004,
                    0.004,
                    0.004,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0043,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0045,
                    0.0046,
                    0.0046,
                    0.0047,
                    0.0047,
                    0.0048,
                    0.0048,
                    0.0049,
                    0.0049,
                    0.005,
                    0.005,
                    0.0051,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0054,
                    0.0055,
                    0.0056,
                    0.0056,
                    0.0057,
                    0.0057,
                    0.0058,
                    0.0058,
                    0.0059,
                    0.006,
                    0.006,
                    0.0061,
                    0.0061,
                    0.0062,
                    0.0062
                ],
                "Total_CH4": 0.83,
                "Total_CH4_timeseries": [
                    1.4767e-06,
                    2.9576e-06,
                    4.4427e-06,
                    5.9321e-06,
                    7.4258e-06,
                    8.9237e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0034
                ],
                "Fossil_CH4": 0.33,
                "Fossil_CH4_timeseries": [
                    1.8642e-07,
                    3.7347e-07,
                    5.6116e-07,
                    7.4951e-07,
                    9.385e-07,
                    1.1282e-06,
                    1.3185e-06,
                    1.5095e-06,
                    1.7012e-06,
                    1.8936e-06,
                    2.0865e-06,
                    2.2799e-06,
                    2.4738e-06,
                    2.6682e-06,
                    2.8632e-06,
                    3.0587e-06,
                    3.2548e-06,
                    3.4514e-06,
                    3.6486e-06,
                    3.8462e-06,
                    4.0925e-06,
                    4.3878e-06,
                    4.7325e-06,
                    5.1269e-06,
                    5.5713e-06,
                    6.066e-06,
                    6.6114e-06,
                    7.2079e-06,
                    7.8557e-06,
                    8.5553e-06,
                    9.3071e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009
                ],
                "Land_CH4": 1.65,
                "Land_CH4_timeseries": [
                    1.2903e-06,
                    2.5841e-06,
                    3.8816e-06,
                    5.1826e-06,
                    6.4873e-06,
                    7.7955e-06,
                    9.1074e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026
                ],
                "Total_N2O": 0.56,
                "Total_N2O_timeseries": [
                    7.7577e-07,
                    1.567e-06,
                    2.3732e-06,
                    3.1932e-06,
                    4.0259e-06,
                    4.87e-06,
                    5.7237e-06,
                    6.585e-06,
                    7.4519e-06,
                    8.3218e-06,
                    9.1932e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005
                ],
                "Fossil_N2O": 0.16,
                "Fossil_N2O_timeseries": [
                    1.279e-08,
                    2.5819e-08,
                    3.9079e-08,
                    5.2556e-08,
                    6.6233e-08,
                    8.0089e-08,
                    9.4099e-08,
                    1.0824e-07,
                    1.2247e-07,
                    1.3676e-07,
                    1.5109e-07,
                    1.6545e-07,
                    1.7984e-07,
                    1.9425e-07,
                    2.0868e-07,
                    2.2314e-07,
                    2.3762e-07,
                    2.5213e-07,
                    2.6668e-07,
                    2.8126e-07,
                    2.9607e-07,
                    3.1144e-07,
                    3.2761e-07,
                    3.4475e-07,
                    3.6298e-07,
                    3.823e-07,
                    4.0268e-07,
                    4.2397e-07,
                    4.4599e-07,
                    4.6846e-07,
                    4.9118e-07,
                    5.1412e-07,
                    5.3724e-07,
                    5.6053e-07,
                    5.8397e-07,
                    6.0755e-07,
                    6.3127e-07,
                    6.5513e-07,
                    6.7916e-07,
                    7.0497e-07,
                    7.3134e-07,
                    7.5831e-07,
                    7.8594e-07,
                    8.1426e-07,
                    8.4331e-07,
                    8.7312e-07,
                    9.0373e-07,
                    9.3519e-07,
                    9.6751e-07,
                    1.0007e-06,
                    1.035e-06,
                    1.0704e-06,
                    1.1071e-06,
                    1.1451e-06,
                    1.1846e-06,
                    1.2254e-06,
                    1.2676e-06,
                    1.311e-06,
                    1.3556e-06,
                    1.4011e-06,
                    1.4476e-06,
                    1.4948e-06,
                    1.5428e-06,
                    1.5915e-06,
                    1.641e-06,
                    1.6911e-06,
                    1.7419e-06,
                    1.7934e-06,
                    1.8455e-06,
                    1.8983e-06,
                    1.9518e-06,
                    2.0058e-06,
                    2.0604e-06,
                    2.1156e-06,
                    2.1714e-06,
                    2.2277e-06,
                    2.2846e-06,
                    2.3422e-06,
                    2.4004e-06,
                    2.4594e-06,
                    2.5193e-06,
                    2.5802e-06,
                    2.6424e-06,
                    2.706e-06,
                    2.771e-06,
                    2.8376e-06,
                    2.9058e-06,
                    2.9756e-06,
                    3.047e-06,
                    3.1199e-06,
                    3.1946e-06,
                    3.2717e-06,
                    3.3517e-06,
                    3.4349e-06,
                    3.5216e-06,
                    3.6119e-06,
                    3.7059e-06,
                    3.8036e-06,
                    3.9046e-06,
                    4.0089e-06,
                    4.1168e-06,
                    4.229e-06,
                    4.3465e-06,
                    4.4696e-06,
                    4.5988e-06,
                    4.7342e-06,
                    4.8757e-06,
                    5.0232e-06,
                    5.1761e-06,
                    5.3339e-06,
                    5.496e-06,
                    5.6621e-06,
                    5.8321e-06,
                    6.006e-06,
                    6.1841e-06,
                    6.3668e-06,
                    6.5546e-06,
                    6.7484e-06,
                    6.9489e-06,
                    7.1868e-06,
                    7.4263e-06,
                    7.6714e-06,
                    7.9175e-06,
                    8.173e-06,
                    8.4342e-06,
                    8.6988e-06,
                    8.9733e-06,
                    9.2544e-06,
                    9.5453e-06,
                    9.8432e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.71,
                "Land_N2O_timeseries": [
                    7.6299e-07,
                    1.5412e-06,
                    2.3341e-06,
                    3.1406e-06,
                    3.9597e-06,
                    4.7899e-06,
                    5.6296e-06,
                    6.4768e-06,
                    7.3294e-06,
                    8.185e-06,
                    9.0421e-06,
                    9.9002e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                98.75368,
                                10.38932
                            ],
                            [
                                98.79838,
                                10.4478
                            ],
                            [
                                98.82078,
                                10.52647
                            ],
                            [
                                98.80927,
                                10.59016
                            ],
                            [
                                98.77273,
                                10.62107
                            ],
                            [
                                98.78179,
                                10.68001
                            ],
                            [
                                98.84733,
                                10.7603
                            ],
                            [
                                98.92761,
                                10.82051
                            ],
                            [
                                99.00953,
                                10.85601
                            ],
                            [
                                99.00023,
                                10.92326
                            ],
                            [
                                99.06838,
                                10.94817
                            ],
                            [
                                99.10639,
                                11.01481
                            ],
                            [
                                99.1571,
                                11.0345
                            ],
                            [
                                99.22658,
                                11.11066
                            ],
                            [
                                99.26633,
                                11.21892
                            ],
                            [
                                99.32373,
                                11.28058
                            ],
                            [
                                99.31606,
                                11.31905
                            ],
                            [
                                99.40041,
                                11.3882
                            ],
                            [
                                99.39901,
                                11.4639
                            ],
                            [
                                99.4725,
                                11.53221
                            ],
                            [
                                99.45888,
                                11.58192
                            ],
                            [
                                99.50529,
                                11.6347
                            ],
                            [
                                99.56354,
                                11.62733
                            ],
                            [
                                99.64346,
                                11.78398
                            ],
                            [
                                99.62253,
                                11.85311
                            ],
                            [
                                99.58061,
                                11.9038
                            ],
                            [
                                99.59253,
                                11.99093
                            ],
                            [
                                99.53917,
                                12.01725
                            ],
                            [
                                99.53503,
                                12.06584
                            ],
                            [
                                99.56933,
                                12.14368
                            ],
                            [
                                99.50239,
                                12.14357
                            ],
                            [
                                99.44763,
                                12.31579
                            ],
                            [
                                99.44854,
                                12.40905
                            ],
                            [
                                99.40255,
                                12.46194
                            ],
                            [
                                99.43944,
                                12.55889
                            ],
                            [
                                99.41261,
                                12.61325
                            ],
                            [
                                99.2969,
                                12.67657
                            ],
                            [
                                99.23141,
                                12.74411
                            ],
                            [
                                99.22857,
                                12.80407
                            ],
                            [
                                99.18655,
                                12.84994
                            ],
                            [
                                99.19107,
                                12.99267
                            ],
                            [
                                99.10488,
                                13.06503
                            ],
                            [
                                99.13499,
                                13.13174
                            ],
                            [
                                99.12537,
                                13.19749
                            ],
                            [
                                99.21037,
                                13.19568
                            ],
                            [
                                99.2054,
                                13.4689
                            ],
                            [
                                99.16446,
                                13.57346
                            ],
                            [
                                99.17099,
                                13.73193
                            ],
                            [
                                99.12158,
                                13.77483
                            ],
                            [
                                99.07757,
                                13.89373
                            ],
                            [
                                99.0195,
                                13.9483
                            ],
                            [
                                98.96672,
                                14.08017
                            ],
                            [
                                98.89746,
                                14.11119
                            ],
                            [
                                98.83098,
                                14.17331
                            ],
                            [
                                98.59586,
                                14.32747
                            ],
                            [
                                98.49174,
                                14.53822
                            ],
                            [
                                98.43433,
                                14.61285
                            ],
                            [
                                98.31721,
                                14.72007
                            ],
                            [
                                98.24758,
                                14.83033
                            ],
                            [
                                98.24662,
                                14.91954
                            ],
                            [
                                98.20869,
                                14.98586
                            ],
                            [
                                98.23123,
                                15.04513
                            ],
                            [
                                98.18496,
                                15.10049
                            ],
                            [
                                98.21251,
                                15.2364
                            ],
                            [
                                98.26414,
                                15.24277
                            ],
                            [
                                98.30059,
                                15.31022
                            ],
                            [
                                98.39849,
                                15.25917
                            ],
                            [
                                98.4105,
                                15.35127
                            ],
                            [
                                98.49792,
                                15.38336
                            ],
                            [
                                98.56679,
                                15.34375
                            ],
                            [
                                98.58779,
                                15.45543
                            ],
                            [
                                98.55623,
                                15.5927
                            ],
                            [
                                98.55231,
                                15.68683
                            ],
                            [
                                98.60665,
                                15.86907
                            ],
                            [
                                98.58625,
                                15.915
                            ],
                            [
                                98.61742,
                                16.03753
                            ],
                            [
                                98.70791,
                                16.13337
                            ],
                            [
                                98.80839,
                                16.10103
                            ],
                            [
                                98.85912,
                                16.13453
                            ],
                            [
                                98.85862,
                                16.21482
                            ],
                            [
                                98.9145,
                                16.25956
                            ],
                            [
                                98.92573,
                                16.3914
                            ],
                            [
                                98.83739,
                                16.41783
                            ],
                            [
                                98.77375,
                                16.34877
                            ],
                            [
                                98.67548,
                                16.27668
                            ],
                            [
                                98.63997,
                                16.42004
                            ],
                            [
                                98.65459,
                                16.45377
                            ],
                            [
                                98.58129,
                                16.55852
                            ],
                            [
                                98.56996,
                                16.62758
                            ],
                            [
                                98.51562,
                                16.64902
                            ],
                            [
                                98.46642,
                                16.73215
                            ],
                            [
                                98.51881,
                                16.90322
                            ],
                            [
                                98.50372,
                                16.95087
                            ],
                            [
                                98.4088,
                                17.0518
                            ],
                            [
                                98.34685,
                                17.04953
                            ],
                            [
                                98.28309,
                                17.1169
                            ],
                            [
                                98.28716,
                                17.15417
                            ],
                            [
                                98.20201,
                                17.25051
                            ],
                            [
                                98.11099,
                                17.3252
                            ],
                            [
                                98.07775,
                                17.39596
                            ],
                            [
                                97.99242,
                                17.50862
                            ],
                            [
                                97.92619,
                                17.54002
                            ],
                            [
                                97.90249,
                                17.58582
                            ],
                            [
                                97.79662,
                                17.67899
                            ],
                            [
                                97.77073,
                                17.75516
                            ],
                            [
                                97.70447,
                                17.81728
                            ],
                            [
                                97.67391,
                                17.88358
                            ],
                            [
                                97.7365,
                                17.98046
                            ],
                            [
                                97.67838,
                                18.1164
                            ],
                            [
                                97.67492,
                                18.16047
                            ],
                            [
                                97.61792,
                                18.21977
                            ],
                            [
                                97.63735,
                                18.28985
                            ],
                            [
                                97.55082,
                                18.33129
                            ],
                            [
                                97.49961,
                                18.27064
                            ],
                            [
                                97.447,
                                18.33264
                            ],
                            [
                                97.38384,
                                18.50919
                            ],
                            [
                                97.4464,
                                18.49536
                            ],
                            [
                                97.60392,
                                18.53874
                            ],
                            [
                                97.66946,
                                18.57729
                            ],
                            [
                                97.76749,
                                18.58123
                            ],
                            [
                                97.77313,
                                18.68912
                            ],
                            [
                                97.73607,
                                18.88541
                            ],
                            [
                                97.66945,
                                18.93768
                            ],
                            [
                                97.73289,
                                18.97603
                            ],
                            [
                                97.73838,
                                19.03929
                            ],
                            [
                                97.83603,
                                19.09766
                            ],
                            [
                                97.84151,
                                19.29429
                            ],
                            [
                                97.80388,
                                19.34872
                            ],
                            [
                                97.83144,
                                19.44676
                            ],
                            [
                                97.88442,
                                19.49744
                            ],
                            [
                                97.87044,
                                19.5746
                            ],
                            [
                                97.9579,
                                19.59053
                            ],
                            [
                                98.0252,
                                19.63845
                            ],
                            [
                                98.03565,
                                19.8054
                            ],
                            [
                                98.08127,
                                19.80898
                            ],
                            [
                                98.22906,
                                19.7227
                            ],
                            [
                                98.25214,
                                19.67778
                            ],
                            [
                                98.32967,
                                19.69785
                            ],
                            [
                                98.43691,
                                19.68699
                            ],
                            [
                                98.58774,
                                19.71251
                            ],
                            [
                                98.71134,
                                19.76458
                            ],
                            [
                                98.74018,
                                19.74422
                            ],
                            [
                                98.83785,
                                19.81118
                            ],
                            [
                                98.9172,
                                19.75079
                            ],
                            [
                                99.00471,
                                19.78401
                            ],
                            [
                                99.07495,
                                20.09792
                            ],
                            [
                                99.15813,
                                20.13111
                            ],
                            [
                                99.25713,
                                20.11219
                            ],
                            [
                                99.33376,
                                20.06758
                            ],
                            [
                                99.43799,
                                20.08999
                            ],
                            [
                                99.5359,
                                20.15034
                            ],
                            [
                                99.56187,
                                20.20933
                            ],
                            [
                                99.5213,
                                20.23735
                            ],
                            [
                                99.50532,
                                20.32647
                            ],
                            [
                                99.52616,
                                20.35961
                            ],
                            [
                                99.68089,
                                20.31721
                            ],
                            [
                                99.73208,
                                20.34717
                            ],
                            [
                                99.81028,
                                20.33738
                            ],
                            [
                                99.87162,
                                20.44416
                            ],
                            [
                                99.96037,
                                20.46383
                            ],
                            [
                                100.08532,
                                20.35273
                            ],
                            [
                                100.12,
                                20.43891
                            ],
                            [
                                100.17726,
                                20.64008
                            ],
                            [
                                100.25437,
                                20.74966
                            ],
                            [
                                100.3597,
                                20.82161
                            ],
                            [
                                100.56973,
                                20.82353
                            ],
                            [
                                100.50994,
                                20.89372
                            ],
                            [
                                100.54644,
                                21.02367
                            ],
                            [
                                100.63761,
                                21.06213
                            ],
                            [
                                100.69807,
                                21.17873
                            ],
                            [
                                100.7354,
                                21.31472
                            ],
                            [
                                100.80656,
                                21.29365
                            ],
                            [
                                100.88568,
                                21.34894
                            ],
                            [
                                100.99974,
                                21.38696
                            ],
                            [
                                101.05938,
                                21.45461
                            ],
                            [
                                101.16202,
                                21.52428
                            ],
                            [
                                101.14319,
                                21.56406
                            ],
                            [
                                101.16862,
                                21.60519
                            ],
                            [
                                101.08723,
                                21.77394
                            ],
                            [
                                101.00962,
                                21.70922
                            ],
                            [
                                100.88366,
                                21.68468
                            ],
                            [
                                100.72522,
                                21.51579
                            ],
                            [
                                100.58284,
                                21.45314
                            ],
                            [
                                100.48062,
                                21.46028
                            ],
                            [
                                100.42902,
                                21.53985
                            ],
                            [
                                100.34875,
                                21.52941
                            ],
                            [
                                100.29868,
                                21.48281
                            ],
                            [
                                100.23435,
                                21.47239
                            ],
                            [
                                100.1271,
                                21.51304
                            ],
                            [
                                100.1097,
                                21.59481
                            ],
                            [
                                100.16695,
                                21.66692
                            ],
                            [
                                100.0955,
                                21.70358
                            ],
                            [
                                100.04737,
                                21.67294
                            ],
                            [
                                99.98589,
                                21.71638
                            ],
                            [
                                99.94518,
                                21.82669
                            ],
                            [
                                99.99681,
                                21.97353
                            ],
                            [
                                99.96693,
                                22.05444
                            ],
                            [
                                99.88004,
                                22.06869
                            ],
                            [
                                99.83777,
                                22.03048
                            ],
                            [
                                99.74547,
                                22.0729
                            ],
                            [
                                99.71679,
                                22.04608
                            ],
                            [
                                99.64554,
                                22.10364
                            ],
                            [
                                99.52218,
                                22.10196
                            ],
                            [
                                99.47623,
                                22.13439
                            ],
                            [
                                99.43313,
                                22.10765
                            ],
                            [
                                99.26781,
                                22.10535
                            ],
                            [
                                99.16948,
                                22.1508
                            ],
                            [
                                99.23074,
                                22.24746
                            ],
                            [
                                99.23655,
                                22.30058
                            ],
                            [
                                99.29447,
                                22.41404
                            ],
                            [
                                99.37923,
                                22.49872
                            ],
                            [
                                99.38246,
                                22.57169
                            ],
                            [
                                99.35948,
                                22.66185
                            ],
                            [
                                99.32083,
                                22.7295
                            ],
                            [
                                99.38348,
                                22.76902
                            ],
                            [
                                99.40028,
                                22.82564
                            ],
                            [
                                99.45805,
                                22.85014
                            ],
                            [
                                99.44348,
                                22.93721
                            ],
                            [
                                99.53208,
                                22.90295
                            ],
                            [
                                99.51264,
                                23.08158
                            ],
                            [
                                99.39153,
                                23.10067
                            ],
                            [
                                99.34304,
                                23.13515
                            ],
                            [
                                99.24378,
                                23.08414
                            ],
                            [
                                99.19985,
                                23.10877
                            ],
                            [
                                99.10643,
                                23.09421
                            ],
                            [
                                99.00531,
                                23.164
                            ],
                            [
                                98.88689,
                                23.19272
                            ],
                            [
                                98.94016,
                                23.30787
                            ],
                            [
                                98.91545,
                                23.33094
                            ],
                            [
                                98.91823,
                                23.41851
                            ],
                            [
                                98.87796,
                                23.48434
                            ],
                            [
                                98.82268,
                                23.48415
                            ],
                            [
                                98.8041,
                                23.53496
                            ],
                            [
                                98.88941,
                                23.61383
                            ],
                            [
                                98.84912,
                                23.64011
                            ],
                            [
                                98.80227,
                                23.77244
                            ],
                            [
                                98.69869,
                                23.78924
                            ],
                            [
                                98.68125,
                                23.91267
                            ],
                            [
                                98.70064,
                                23.98432
                            ],
                            [
                                98.75256,
                                23.9844
                            ],
                            [
                                98.8629,
                                24.06803
                            ],
                            [
                                98.84445,
                                24.13201
                            ],
                            [
                                98.71938,
                                24.12881
                            ],
                            [
                                98.60045,
                                24.08705
                            ],
                            [
                                98.53797,
                                24.12961
                            ],
                            [
                                98.35242,
                                24.10238
                            ],
                            [
                                98.22751,
                                24.11489
                            ],
                            [
                                98.03929,
                                24.07201
                            ],
                            [
                                97.90597,
                                24.01689
                            ],
                            [
                                97.89175,
                                23.97899
                            ],
                            [
                                97.79818,
                                23.95438
                            ],
                            [
                                97.76086,
                                23.91264
                            ],
                            [
                                97.64725,
                                23.85066
                            ],
                            [
                                97.62769,
                                23.8839
                            ],
                            [
                                97.53129,
                                23.93356
                            ],
                            [
                                97.63675,
                                24.04659
                            ],
                            [
                                97.72727,
                                24.11598
                            ],
                            [
                                97.75014,
                                24.16889
                            ],
                            [
                                97.72911,
                                24.22214
                            ],
                            [
                                97.76298,
                                24.26621
                            ],
                            [
                                97.67262,
                                24.30097
                            ],
                            [
                                97.7111,
                                24.37718
                            ],
                            [
                                97.66687,
                                24.4514
                            ],
                            [
                                97.53696,
                                24.44084
                            ],
                            [
                                97.55521,
                                24.49932
                            ],
                            [
                                97.57258,
                                24.66194
                            ],
                            [
                                97.5545,
                                24.74786
                            ],
                            [
                                97.69989,
                                24.83992
                            ],
                            [
                                97.7955,
                                24.85389
                            ],
                            [
                                97.73174,
                                24.91546
                            ],
                            [
                                97.71966,
                                25.01637
                            ],
                            [
                                97.79749,
                                25.16297
                            ],
                            [
                                97.83996,
                                25.26778
                            ],
                            [
                                97.9404,
                                25.21834
                            ],
                            [
                                98.01308,
                                25.30448
                            ],
                            [
                                98.0674,
                                25.31476
                            ],
                            [
                                98.15522,
                                25.45775
                            ],
                            [
                                98.12913,
                                25.51103
                            ],
                            [
                                98.18582,
                                25.57886
                            ],
                            [
                                98.24975,
                                25.60721
                            ],
                            [
                                98.31499,
                                25.55266
                            ],
                            [
                                98.40495,
                                25.60603
                            ],
                            [
                                98.41256,
                                25.66337
                            ],
                            [
                                98.45986,
                                25.69414
                            ],
                            [
                                98.49559,
                                25.81081
                            ],
                            [
                                98.54004,
                                25.84651
                            ],
                            [
                                98.63331,
                                25.80225
                            ],
                            [
                                98.7052,
                                25.85701
                            ],
                            [
                                98.68468,
                                25.93771
                            ],
                            [
                                98.61778,
                                25.97721
                            ],
                            [
                                98.57591,
                                26.11996
                            ],
                            [
                                98.63153,
                                26.14939
                            ],
                            [
                                98.71596,
                                26.13013
                            ],
                            [
                                98.73349,
                                26.18536
                            ],
                            [
                                98.67511,
                                26.24519
                            ],
                            [
                                98.68519,
                                26.31038
                            ],
                            [
                                98.73239,
                                26.35419
                            ],
                            [
                                98.75123,
                                26.42746
                            ],
                            [
                                98.75511,
                                26.56413
                            ],
                            [
                                98.78079,
                                26.62439
                            ],
                            [
                                98.74441,
                                26.71407
                            ],
                            [
                                98.76199,
                                26.80402
                            ],
                            [
                                98.70723,
                                27.17872
                            ],
                            [
                                98.74005,
                                27.32935
                            ],
                            [
                                98.70127,
                                27.38186
                            ],
                            [
                                98.68653,
                                27.49093
                            ],
                            [
                                98.70554,
                                27.56067
                            ],
                            [
                                98.58612,
                                27.59277
                            ],
                            [
                                98.4316,
                                27.65984
                            ],
                            [
                                98.42906,
                                27.55406
                            ],
                            [
                                98.37636,
                                27.51167
                            ],
                            [
                                98.31907,
                                27.52318
                            ],
                            [
                                98.30055,
                                27.63287
                            ],
                            [
                                98.22364,
                                27.71644
                            ],
                            [
                                98.2243,
                                27.81137
                            ],
                            [
                                98.1787,
                                27.83399
                            ],
                            [
                                98.20165,
                                27.90598
                            ],
                            [
                                98.14146,
                                27.95481
                            ],
                            [
                                98.14195,
                                28.14107
                            ],
                            [
                                97.95377,
                                28.30534
                            ],
                            [
                                97.90927,
                                28.36675
                            ],
                            [
                                97.79777,
                                28.33109
                            ],
                            [
                                97.73677,
                                28.39929
                            ],
                            [
                                97.72138,
                                28.49529
                            ],
                            [
                                97.65948,
                                28.53939
                            ],
                            [
                                97.5381,
                                28.52248
                            ],
                            [
                                97.49324,
                                28.36561
                            ],
                            [
                                97.50797,
                                28.30341
                            ],
                            [
                                97.34711,
                                28.20807
                            ],
                            [
                                97.35823,
                                28.16401
                            ],
                            [
                                97.32163,
                                28.05724
                            ],
                            [
                                97.41005,
                                28.01213
                            ],
                            [
                                97.3801,
                                27.96973
                            ],
                            [
                                97.38517,
                                27.89144
                            ],
                            [
                                97.25461,
                                27.89509
                            ],
                            [
                                97.09139,
                                27.74302
                            ],
                            [
                                97.01892,
                                27.73834
                            ],
                            [
                                96.97682,
                                27.67112
                            ],
                            [
                                96.89049,
                                27.61221
                            ],
                            [
                                96.92296,
                                27.5056
                            ],
                            [
                                96.90157,
                                27.46115
                            ],
                            [
                                96.96539,
                                27.36898
                            ],
                            [
                                97.16504,
                                27.12304
                            ],
                            [
                                97.13751,
                                27.09015
                            ],
                            [
                                96.91022,
                                27.15948
                            ],
                            [
                                96.85524,
                                27.20806
                            ],
                            [
                                96.84911,
                                27.27045
                            ],
                            [
                                96.78371,
                                27.34866
                            ],
                            [
                                96.62933,
                                27.36516
                            ],
                            [
                                96.56318,
                                27.30338
                            ],
                            [
                                96.43689,
                                27.30212
                            ],
                            [
                                96.38377,
                                27.28429
                            ],
                            [
                                96.23189,
                                27.27527
                            ],
                            [
                                96.09492,
                                27.22452
                            ],
                            [
                                96.02548,
                                27.17741
                            ],
                            [
                                95.92299,
                                27.03259
                            ],
                            [
                                95.80148,
                                27.00682
                            ],
                            [
                                95.74756,
                                26.91127
                            ],
                            [
                                95.67055,
                                26.89564
                            ],
                            [
                                95.59947,
                                26.81009
                            ],
                            [
                                95.50014,
                                26.80057
                            ],
                            [
                                95.42587,
                                26.69405
                            ],
                            [
                                95.27687,
                                26.64423
                            ],
                            [
                                95.23994,
                                26.67951
                            ],
                            [
                                95.15422,
                                26.62061
                            ],
                            [
                                95.15083,
                                26.58087
                            ],
                            [
                                95.07279,
                                26.45818
                            ],
                            [
                                95.0977,
                                26.40576
                            ],
                            [
                                95.07299,
                                26.33917
                            ],
                            [
                                95.08829,
                                26.23678
                            ],
                            [
                                95.12245,
                                26.19
                            ],
                            [
                                95.11642,
                                26.11261
                            ],
                            [
                                95.18208,
                                26.06318
                            ],
                            [
                                95.09276,
                                25.95744
                            ],
                            [
                                95.02403,
                                25.92248
                            ],
                            [
                                95.04269,
                                25.76587
                            ],
                            [
                                94.92594,
                                25.64572
                            ],
                            [
                                94.88091,
                                25.56337
                            ],
                            [
                                94.7793,
                                25.48376
                            ],
                            [
                                94.67988,
                                25.45348
                            ],
                            [
                                94.63124,
                                25.38619
                            ],
                            [
                                94.58298,
                                25.24975
                            ],
                            [
                                94.61036,
                                25.17043
                            ],
                            [
                                94.70937,
                                25.14417
                            ],
                            [
                                94.74273,
                                25.04303
                            ],
                            [
                                94.69501,
                                24.96751
                            ],
                            [
                                94.70035,
                                24.92053
                            ],
                            [
                                94.64459,
                                24.83605
                            ],
                            [
                                94.60361,
                                24.71112
                            ],
                            [
                                94.54576,
                                24.69382
                            ],
                            [
                                94.51475,
                                24.60413
                            ],
                            [
                                94.45133,
                                24.55585
                            ],
                            [
                                94.39842,
                                24.47065
                            ],
                            [
                                94.37225,
                                24.36946
                            ],
                            [
                                94.32174,
                                24.31599
                            ],
                            [
                                94.31376,
                                24.26403
                            ],
                            [
                                94.25598,
                                24.14876
                            ],
                            [
                                94.25234,
                                24.07218
                            ],
                            [
                                94.15981,
                                23.85605
                            ],
                            [
                                94.02265,
                                23.92192
                            ],
                            [
                                93.90561,
                                23.94974
                            ],
                            [
                                93.80892,
                                23.93373
                            ],
                            [
                                93.75544,
                                23.99954
                            ],
                            [
                                93.6221,
                                23.99954
                            ],
                            [
                                93.49989,
                                23.95353
                            ],
                            [
                                93.40551,
                                24.0749
                            ],
                            [
                                93.34079,
                                24.08526
                            ],
                            [
                                93.33319,
                                23.98176
                            ],
                            [
                                93.39193,
                                23.91837
                            ],
                            [
                                93.40024,
                                23.75196
                            ],
                            [
                                93.4358,
                                23.68132
                            ],
                            [
                                93.41788,
                                23.53805
                            ],
                            [
                                93.36146,
                                23.34667
                            ],
                            [
                                93.38348,
                                23.21893
                            ],
                            [
                                93.34653,
                                23.06858
                            ],
                            [
                                93.29295,
                                23.00519
                            ],
                            [
                                93.20555,
                                23.04612
                            ],
                            [
                                93.13159,
                                23.04115
                            ],
                            [
                                93.1626,
                                22.91074
                            ],
                            [
                                93.12187,
                                22.86513
                            ],
                            [
                                93.10119,
                                22.78177
                            ],
                            [
                                93.10591,
                                22.64613
                            ],
                            [
                                93.13767,
                                22.59051
                            ],
                            [
                                93.11217,
                                22.53391
                            ],
                            [
                                93.13323,
                                22.46564
                            ],
                            [
                                93.17925,
                                22.41962
                            ],
                            [
                                93.20126,
                                22.29939
                            ],
                            [
                                93.18575,
                                22.24701
                            ],
                            [
                                93.10834,
                                22.20282
                            ],
                            [
                                93.04884,
                                22.1972
                            ],
                            [
                                93.05213,
                                22.10277
                            ],
                            [
                                92.92853,
                                22.01137
                            ],
                            [
                                92.86392,
                                22.0586
                            ],
                            [
                                92.69582,
                                22.14814
                            ],
                            [
                                92.6771,
                                22.01547
                            ],
                            [
                                92.60676,
                                21.9712
                            ],
                            [
                                92.63344,
                                21.87414
                            ],
                            [
                                92.61694,
                                21.84653
                            ],
                            [
                                92.60172,
                                21.70194
                            ],
                            [
                                92.62515,
                                21.47214
                            ],
                            [
                                92.68006,
                                21.28635
                            ],
                            [
                                92.59809,
                                21.2424
                            ],
                            [
                                92.56131,
                                21.37953
                            ],
                            [
                                92.50129,
                                21.35146
                            ],
                            [
                                92.44175,
                                21.36566
                            ],
                            [
                                92.42265,
                                21.4376
                            ],
                            [
                                92.38133,
                                21.47818
                            ],
                            [
                                92.3299,
                                21.41751
                            ],
                            [
                                92.27383,
                                21.42493
                            ],
                            [
                                92.25924,
                                21.35824
                            ],
                            [
                                92.20265,
                                21.30405
                            ],
                            [
                                92.22254,
                                21.25406
                            ],
                            [
                                92.17522,
                                21.17825
                            ],
                            [
                                92.20214,
                                21.15074
                            ],
                            [
                                92.30491,
                                20.9904
                            ],
                            [
                                92.30595,
                                20.9247
                            ],
                            [
                                92.38368,
                                20.69478
                            ],
                            [
                                92.46063,
                                20.65926
                            ],
                            [
                                92.53082,
                                20.5441
                            ],
                            [
                                92.62683,
                                20.44864
                            ],
                            [
                                92.72809,
                                20.2615
                            ],
                            [
                                92.74647,
                                20.41611
                            ],
                            [
                                92.72234,
                                20.47619
                            ],
                            [
                                92.79687,
                                20.50535
                            ],
                            [
                                92.85238,
                                20.3638
                            ],
                            [
                                92.89646,
                                20.31582
                            ],
                            [
                                92.8018,
                                20.25419
                            ],
                            [
                                92.77723,
                                20.18854
                            ],
                            [
                                92.85403,
                                20.12526
                            ],
                            [
                                92.91711,
                                20.17696
                            ],
                            [
                                93.00507,
                                20.28486
                            ],
                            [
                                93.0357,
                                20.377
                            ],
                            [
                                93.1405,
                                20.38436
                            ],
                            [
                                93.13349,
                                20.3295
                            ],
                            [
                                93.21516,
                                20.33574
                            ],
                            [
                                93.21795,
                                20.29349
                            ],
                            [
                                93.1311,
                                20.2087
                            ],
                            [
                                93.17683,
                                20.19585
                            ],
                            [
                                93.21599,
                                20.23576
                            ],
                            [
                                93.27195,
                                20.26512
                            ],
                            [
                                93.35336,
                                20.07277
                            ],
                            [
                                93.40827,
                                19.98898
                            ],
                            [
                                93.47298,
                                20.00548
                            ],
                            [
                                93.56206,
                                19.89026
                            ],
                            [
                                93.73146,
                                19.92631
                            ],
                            [
                                93.78887,
                                19.85701
                            ],
                            [
                                93.78907,
                                19.76894
                            ],
                            [
                                93.73445,
                                19.75152
                            ],
                            [
                                93.70882,
                                19.70226
                            ],
                            [
                                93.73227,
                                19.61775
                            ],
                            [
                                93.90211,
                                19.49088
                            ],
                            [
                                93.81734,
                                19.47288
                            ],
                            [
                                93.7381,
                                19.54484
                            ],
                            [
                                93.67282,
                                19.55291
                            ],
                            [
                                93.65216,
                                19.4496
                            ],
                            [
                                93.71616,
                                19.42248
                            ],
                            [
                                93.74969,
                                19.3254
                            ],
                            [
                                93.78998,
                                19.27533
                            ],
                            [
                                93.86725,
                                19.31073
                            ],
                            [
                                93.87376,
                                19.24988
                            ],
                            [
                                93.81852,
                                19.2299
                            ],
                            [
                                93.72931,
                                19.25143
                            ],
                            [
                                93.66977,
                                19.28846
                            ],
                            [
                                93.60251,
                                19.40773
                            ],
                            [
                                93.53493,
                                19.4345
                            ],
                            [
                                93.47505,
                                19.36744
                            ],
                            [
                                93.56944,
                                19.22384
                            ],
                            [
                                93.59915,
                                19.15793
                            ],
                            [
                                93.66879,
                                19.08104
                            ],
                            [
                                93.67682,
                                19.0136
                            ],
                            [
                                93.7772,
                                18.96149
                            ],
                            [
                                93.93467,
                                18.85255
                            ],
                            [
                                93.98257,
                                18.9627
                            ],
                            [
                                93.95925,
                                19.01873
                            ],
                            [
                                93.95668,
                                19.14698
                            ],
                            [
                                94.03647,
                                19.17273
                            ],
                            [
                                94.05965,
                                19.07954
                            ],
                            [
                                94.03638,
                                18.90375
                            ],
                            [
                                94.11702,
                                18.87386
                            ],
                            [
                                94.16567,
                                18.83193
                            ],
                            [
                                94.22382,
                                18.72077
                            ],
                            [
                                94.21984,
                                18.66733
                            ],
                            [
                                94.25263,
                                18.60787
                            ],
                            [
                                94.25514,
                                18.5199
                            ],
                            [
                                94.32214,
                                18.43198
                            ],
                            [
                                94.34147,
                                18.36934
                            ],
                            [
                                94.3825,
                                18.36146
                            ],
                            [
                                94.38878,
                                18.28792
                            ],
                            [
                                94.48263,
                                18.05653
                            ],
                            [
                                94.44137,
                                17.98766
                            ],
                            [
                                94.48312,
                                17.89221
                            ],
                            [
                                94.49136,
                                17.7861
                            ],
                            [
                                94.54232,
                                17.73361
                            ],
                            [
                                94.58312,
                                17.62436
                            ],
                            [
                                94.54418,
                                17.54955
                            ],
                            [
                                94.56378,
                                17.50179
                            ],
                            [
                                94.57255,
                                17.32173
                            ],
                            [
                                94.50275,
                                17.2643
                            ],
                            [
                                94.532,
                                17.18124
                            ],
                            [
                                94.45653,
                                17.05999
                            ],
                            [
                                94.45708,
                                16.94364
                            ],
                            [
                                94.38128,
                                16.87125
                            ],
                            [
                                94.40233,
                                16.79049
                            ],
                            [
                                94.35953,
                                16.69966
                            ],
                            [
                                94.34806,
                                16.57078
                            ],
                            [
                                94.27534,
                                16.49445
                            ],
                            [
                                94.23301,
                                16.32872
                            ],
                            [
                                94.20045,
                                16.03644
                            ],
                            [
                                94.24668,
                                15.95693
                            ],
                            [
                                94.36751,
                                16.05033
                            ],
                            [
                                94.42894,
                                16.06766
                            ],
                            [
                                94.51014,
                                16.18321
                            ],
                            [
                                94.52041,
                                16.29052
                            ],
                            [
                                94.57132,
                                16.26443
                            ],
                            [
                                94.60845,
                                16.33277
                            ],
                            [
                                94.71705,
                                16.38189
                            ],
                            [
                                94.66907,
                                16.26279
                            ],
                            [
                                94.68611,
                                16.20056
                            ],
                            [
                                94.67644,
                                16.11252
                            ],
                            [
                                94.61818,
                                16.02201
                            ],
                            [
                                94.55863,
                                15.96244
                            ],
                            [
                                94.64357,
                                15.85776
                            ],
                            [
                                94.71887,
                                15.85354
                            ],
                            [
                                94.79656,
                                15.96719
                            ],
                            [
                                94.84411,
                                16.0687
                            ],
                            [
                                94.8785,
                                16.02055
                            ],
                            [
                                94.8291,
                                15.95465
                            ],
                            [
                                94.85035,
                                15.77259
                            ],
                            [
                                94.94521,
                                15.74487
                            ],
                            [
                                95.0362,
                                15.80861
                            ],
                            [
                                95.0682,
                                15.93925
                            ],
                            [
                                95.06109,
                                16.04586
                            ],
                            [
                                95.13556,
                                16.13244
                            ],
                            [
                                95.19207,
                                16.11685
                            ],
                            [
                                95.19134,
                                16.03726
                            ],
                            [
                                95.13298,
                                16.01201
                            ],
                            [
                                95.11063,
                                15.89131
                            ],
                            [
                                95.11331,
                                15.81314
                            ],
                            [
                                95.17581,
                                15.7706
                            ],
                            [
                                95.22079,
                                15.80293
                            ],
                            [
                                95.21395,
                                15.85717
                            ],
                            [
                                95.26384,
                                15.9519
                            ],
                            [
                                95.27414,
                                16.02611
                            ],
                            [
                                95.32398,
                                16.09047
                            ],
                            [
                                95.36572,
                                16.04097
                            ],
                            [
                                95.34513,
                                15.94436
                            ],
                            [
                                95.27192,
                                15.80555
                            ],
                            [
                                95.2904,
                                15.72187
                            ],
                            [
                                95.41948,
                                15.7198
                            ],
                            [
                                95.52052,
                                15.79365
                            ],
                            [
                                95.65341,
                                15.93416
                            ],
                            [
                                95.74506,
                                16.1412
                            ],
                            [
                                95.78088,
                                16.1336
                            ],
                            [
                                95.88987,
                                16.24857
                            ],
                            [
                                95.92373,
                                16.37714
                            ],
                            [
                                95.95717,
                                16.40714
                            ],
                            [
                                96.15943,
                                16.32603
                            ],
                            [
                                96.31882,
                                16.41988
                            ],
                            [
                                96.23716,
                                16.58714
                            ],
                            [
                                96.38467,
                                16.50097
                            ],
                            [
                                96.50118,
                                16.5073
                            ],
                            [
                                96.5963,
                                16.53836
                            ],
                            [
                                96.7728,
                                16.69678
                            ],
                            [
                                96.84872,
                                16.83942
                            ],
                            [
                                96.81817,
                                16.88983
                            ],
                            [
                                96.8743,
                                16.91939
                            ],
                            [
                                96.90976,
                                17.02044
                            ],
                            [
                                96.90127,
                                17.08148
                            ],
                            [
                                96.84084,
                                17.20556
                            ],
                            [
                                96.90064,
                                17.27418
                            ],
                            [
                                96.90249,
                                17.32174
                            ],
                            [
                                96.81913,
                                17.38626
                            ],
                            [
                                96.87045,
                                17.43442
                            ],
                            [
                                96.90836,
                                17.36515
                            ],
                            [
                                97.0571,
                                17.24776
                            ],
                            [
                                97.11786,
                                17.08207
                            ],
                            [
                                97.20129,
                                17.01109
                            ],
                            [
                                97.17343,
                                16.90492
                            ],
                            [
                                97.19995,
                                16.83528
                            ],
                            [
                                97.24454,
                                16.81434
                            ],
                            [
                                97.24509,
                                16.7562
                            ],
                            [
                                97.33104,
                                16.62488
                            ],
                            [
                                97.35471,
                                16.50863
                            ],
                            [
                                97.49931,
                                16.53503
                            ],
                            [
                                97.614,
                                16.52374
                            ],
                            [
                                97.63066,
                                16.49473
                            ],
                            [
                                97.61835,
                                16.35634
                            ],
                            [
                                97.64071,
                                16.27183
                            ],
                            [
                                97.60426,
                                16.09686
                            ],
                            [
                                97.56344,
                                16.06422
                            ],
                            [
                                97.61116,
                                15.95542
                            ],
                            [
                                97.68337,
                                15.90295
                            ],
                            [
                                97.71639,
                                15.83623
                            ],
                            [
                                97.70436,
                                15.75045
                            ],
                            [
                                97.75649,
                                15.53687
                            ],
                            [
                                97.74746,
                                15.48422
                            ],
                            [
                                97.7789,
                                15.40707
                            ],
                            [
                                97.72714,
                                15.33185
                            ],
                            [
                                97.73975,
                                15.24842
                            ],
                            [
                                97.80295,
                                15.14847
                            ],
                            [
                                97.7948,
                                14.87175
                            ],
                            [
                                97.82765,
                                14.74745
                            ],
                            [
                                97.90849,
                                14.61218
                            ],
                            [
                                97.97255,
                                14.42065
                            ],
                            [
                                97.9991,
                                14.29157
                            ],
                            [
                                98.09375,
                                14.16961
                            ],
                            [
                                98.09713,
                                14.10534
                            ],
                            [
                                98.06171,
                                14.03535
                            ],
                            [
                                98.0988,
                                13.79302
                            ],
                            [
                                98.07545,
                                13.7543
                            ],
                            [
                                98.14851,
                                13.6415
                            ],
                            [
                                98.18543,
                                13.65605
                            ],
                            [
                                98.17875,
                                13.73085
                            ],
                            [
                                98.24023,
                                13.71336
                            ],
                            [
                                98.36748,
                                13.5944
                            ],
                            [
                                98.42357,
                                13.47457
                            ],
                            [
                                98.49744,
                                13.24953
                            ],
                            [
                                98.56699,
                                13.19346
                            ],
                            [
                                98.59151,
                                13.05292
                            ],
                            [
                                98.59511,
                                12.93304
                            ],
                            [
                                98.64323,
                                12.81905
                            ],
                            [
                                98.6835,
                                12.79009
                            ],
                            [
                                98.69151,
                                12.71688
                            ],
                            [
                                98.65237,
                                12.65552
                            ],
                            [
                                98.62024,
                                12.55542
                            ],
                            [
                                98.67797,
                                12.51109
                            ],
                            [
                                98.60419,
                                12.47954
                            ],
                            [
                                98.53894,
                                12.36967
                            ],
                            [
                                98.56984,
                                12.29672
                            ],
                            [
                                98.52648,
                                12.25555
                            ],
                            [
                                98.56025,
                                12.20047
                            ],
                            [
                                98.61476,
                                12.20368
                            ],
                            [
                                98.64543,
                                12.16083
                            ],
                            [
                                98.62673,
                                12.09116
                            ],
                            [
                                98.72417,
                                12.00354
                            ],
                            [
                                98.69436,
                                11.93785
                            ],
                            [
                                98.61507,
                                11.87385
                            ],
                            [
                                98.6472,
                                11.836
                            ],
                            [
                                98.60006,
                                11.76293
                            ],
                            [
                                98.61561,
                                11.71742
                            ],
                            [
                                98.69121,
                                11.6768
                            ],
                            [
                                98.73686,
                                11.75649
                            ],
                            [
                                98.82024,
                                11.72589
                            ],
                            [
                                98.74125,
                                11.66155
                            ],
                            [
                                98.73737,
                                11.57954
                            ],
                            [
                                98.76658,
                                11.44911
                            ],
                            [
                                98.722,
                                11.3792
                            ],
                            [
                                98.76067,
                                11.26646
                            ],
                            [
                                98.73262,
                                11.17346
                            ],
                            [
                                98.66019,
                                11.12155
                            ],
                            [
                                98.71577,
                                11.05803
                            ],
                            [
                                98.71094,
                                10.91968
                            ],
                            [
                                98.63809,
                                10.91726
                            ],
                            [
                                98.59287,
                                10.83629
                            ],
                            [
                                98.56409,
                                10.73556
                            ],
                            [
                                98.47314,
                                10.74164
                            ],
                            [
                                98.46242,
                                10.62651
                            ],
                            [
                                98.48091,
                                10.60641
                            ],
                            [
                                98.50519,
                                10.41047
                            ],
                            [
                                98.5362,
                                10.3594
                            ],
                            [
                                98.51487,
                                10.24172
                            ],
                            [
                                98.48353,
                                10.19404
                            ],
                            [
                                98.51548,
                                10.15132
                            ],
                            [
                                98.51834,
                                10.04734
                            ],
                            [
                                98.55995,
                                9.9825
                            ],
                            [
                                98.61071,
                                10.10945
                            ],
                            [
                                98.69575,
                                10.22147
                            ],
                            [
                                98.75368,
                                10.38932
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                93.4832,
                                18.8667
                            ],
                            [
                                93.52486,
                                18.79156
                            ],
                            [
                                93.66578,
                                18.66952
                            ],
                            [
                                93.71998,
                                18.67613
                            ],
                            [
                                93.75242,
                                18.74717
                            ],
                            [
                                93.74117,
                                18.87161
                            ],
                            [
                                93.57953,
                                18.88527
                            ],
                            [
                                93.4832,
                                18.8667
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                98.36748,
                                12.66489
                            ],
                            [
                                98.29851,
                                12.64222
                            ],
                            [
                                98.33124,
                                12.45446
                            ],
                            [
                                98.31337,
                                12.3245
                            ],
                            [
                                98.3594,
                                12.32015
                            ],
                            [
                                98.46186,
                                12.46588
                            ],
                            [
                                98.38657,
                                12.57364
                            ],
                            [
                                98.40389,
                                12.62975
                            ],
                            [
                                98.36748,
                                12.66489
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                94.38279,
                                15.96756
                            ],
                            [
                                94.39172,
                                15.91063
                            ],
                            [
                                94.44768,
                                15.91724
                            ],
                            [
                                94.5068,
                                15.98053
                            ],
                            [
                                94.57226,
                                16.00283
                            ],
                            [
                                94.65148,
                                16.12284
                            ],
                            [
                                94.67162,
                                16.2014
                            ],
                            [
                                94.65024,
                                16.24395
                            ],
                            [
                                94.58716,
                                16.20088
                            ],
                            [
                                94.45666,
                                16.0235
                            ],
                            [
                                94.38279,
                                15.96756
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                98.37168,
                                11.77583
                            ],
                            [
                                98.37706,
                                11.66831
                            ],
                            [
                                98.45457,
                                11.56975
                            ],
                            [
                                98.50623,
                                11.55874
                            ],
                            [
                                98.55085,
                                11.61299
                            ],
                            [
                                98.54684,
                                11.77583
                            ],
                            [
                                98.52746,
                                11.80746
                            ],
                            [
                                98.37168,
                                11.77583
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                97.44225,
                                16.44519
                            ],
                            [
                                97.4774,
                                16.37973
                            ],
                            [
                                97.45771,
                                16.31604
                            ],
                            [
                                97.50119,
                                16.24663
                            ],
                            [
                                97.57143,
                                16.24484
                            ],
                            [
                                97.58011,
                                16.4
                            ],
                            [
                                97.60604,
                                16.48771
                            ],
                            [
                                97.50299,
                                16.51173
                            ],
                            [
                                97.44225,
                                16.44519
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                92.99582,
                                20.14537
                            ],
                            [
                                93.05993,
                                20.15937
                            ],
                            [
                                93.21171,
                                20.29343
                            ],
                            [
                                93.13593,
                                20.31136
                            ],
                            [
                                93.11433,
                                20.37278
                            ],
                            [
                                93.04345,
                                20.32844
                            ],
                            [
                                92.99703,
                                20.1954
                            ],
                            [
                                92.99582,
                                20.14537
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                98.16361,
                                11.45322
                            ],
                            [
                                98.27335,
                                11.47258
                            ],
                            [
                                98.3007,
                                11.69744
                            ],
                            [
                                98.31879,
                                11.73892
                            ],
                            [
                                98.28798,
                                11.80069
                            ],
                            [
                                98.23027,
                                11.66161
                            ],
                            [
                                98.16361,
                                11.45322
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                98.48973,
                                12.03435
                            ],
                            [
                                98.42564,
                                12.09109
                            ],
                            [
                                98.45501,
                                11.93128
                            ],
                            [
                                98.47959,
                                11.87673
                            ],
                            [
                                98.54724,
                                11.91038
                            ],
                            [
                                98.66195,
                                11.9241
                            ],
                            [
                                98.48973,
                                12.03435
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                92.97461,
                                20.12359
                            ],
                            [
                                92.98039,
                                20.06979
                            ],
                            [
                                93.10303,
                                19.94671
                            ],
                            [
                                93.14003,
                                19.99832
                            ],
                            [
                                93.06817,
                                20.11599
                            ],
                            [
                                92.97461,
                                20.12359
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                93.18563,
                                20.19137
                            ],
                            [
                                93.23994,
                                20.10225
                            ],
                            [
                                93.21758,
                                20.03883
                            ],
                            [
                                93.27372,
                                20.03342
                            ],
                            [
                                93.27617,
                                20.24279
                            ],
                            [
                                93.21785,
                                20.23374
                            ],
                            [
                                93.18563,
                                20.19137
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                98.08076,
                                10.88785
                            ],
                            [
                                98.16511,
                                10.91768
                            ],
                            [
                                98.25148,
                                10.81424
                            ],
                            [
                                98.2422,
                                10.71349
                            ],
                            [
                                98.29466,
                                10.73509
                            ],
                            [
                                98.27897,
                                10.81783
                            ],
                            [
                                98.24699,
                                10.85438
                            ],
                            [
                                98.22063,
                                10.94914
                            ],
                            [
                                98.17717,
                                10.98313
                            ],
                            [
                                98.08076,
                                10.88785
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                98.12088,
                                9.84918
                            ],
                            [
                                98.1766,
                                9.91563
                            ],
                            [
                                98.24956,
                                9.95166
                            ],
                            [
                                98.29685,
                                10.04141
                            ],
                            [
                                98.24341,
                                10.05189
                            ],
                            [
                                98.12999,
                                9.95411
                            ],
                            [
                                98.12088,
                                9.84918
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                95.92784,
                                16.21398
                            ],
                            [
                                95.98378,
                                16.2227
                            ],
                            [
                                96.08303,
                                16.31446
                            ],
                            [
                                95.9975,
                                16.38198
                            ],
                            [
                                95.97162,
                                16.34484
                            ],
                            [
                                95.95491,
                                16.24567
                            ],
                            [
                                95.92784,
                                16.21398
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                93.42804,
                                19.95358
                            ],
                            [
                                93.44611,
                                19.78653
                            ],
                            [
                                93.49927,
                                19.75432
                            ],
                            [
                                93.50989,
                                19.85969
                            ],
                            [
                                93.42804,
                                19.95358
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                92.76207,
                                20.34448
                            ],
                            [
                                92.77547,
                                20.28161
                            ],
                            [
                                92.86615,
                                20.31208
                            ],
                            [
                                92.82019,
                                20.42364
                            ],
                            [
                                92.76394,
                                20.43413
                            ],
                            [
                                92.76207,
                                20.34448
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                95.23634,
                                15.87443
                            ],
                            [
                                95.26078,
                                15.85829
                            ],
                            [
                                95.33774,
                                15.97188
                            ],
                            [
                                95.34557,
                                16.04437
                            ],
                            [
                                95.28035,
                                16.02275
                            ],
                            [
                                95.27281,
                                15.95644
                            ],
                            [
                                95.23634,
                                15.87443
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                93.0991,
                                20.15497
                            ],
                            [
                                93.12854,
                                20.09043
                            ],
                            [
                                93.18921,
                                20.06347
                            ],
                            [
                                93.23116,
                                20.11303
                            ],
                            [
                                93.1744,
                                20.1879
                            ],
                            [
                                93.0991,
                                20.15497
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                97.94197,
                                12.34406
                            ],
                            [
                                97.99452,
                                12.27952
                            ],
                            [
                                98.09714,
                                12.35552
                            ],
                            [
                                97.95673,
                                12.37731
                            ],
                            [
                                97.94197,
                                12.34406
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                98.04353,
                                12.2205
                            ],
                            [
                                98.0796,
                                12.15785
                            ],
                            [
                                98.11852,
                                12.15924
                            ],
                            [
                                98.12686,
                                12.28413
                            ],
                            [
                                98.07774,
                                12.29307
                            ],
                            [
                                98.04353,
                                12.2205
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                94.73064,
                                15.81403
                            ],
                            [
                                94.79701,
                                15.78467
                            ],
                            [
                                94.83927,
                                15.86374
                            ],
                            [
                                94.81473,
                                15.9368
                            ],
                            [
                                94.73064,
                                15.81403
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                98.2356,
                                13.18825
                            ],
                            [
                                98.26113,
                                13.05974
                            ],
                            [
                                98.29637,
                                13.08084
                            ],
                            [
                                98.2356,
                                13.18825
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                93.59158,
                                19.77761
                            ],
                            [
                                93.62566,
                                19.75119
                            ],
                            [
                                93.67538,
                                19.80171
                            ],
                            [
                                93.64421,
                                19.86093
                            ],
                            [
                                93.59158,
                                19.77761
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "NAM",
                "Country": "Namibia",
                "Total_3GHG": 0.03,
                "Total_3GHG_timeseries": [
                    1.7301e-07,
                    3.4844e-07,
                    5.262e-07,
                    7.0635e-07,
                    8.8928e-07,
                    1.075e-06,
                    1.2635e-06,
                    1.4545e-06,
                    1.6478e-06,
                    1.8452e-06,
                    2.0442e-06,
                    2.2468e-06,
                    2.4521e-06,
                    2.6608e-06,
                    2.8707e-06,
                    3.0828e-06,
                    3.2978e-06,
                    3.516e-06,
                    3.7376e-06,
                    3.9632e-06,
                    4.1929e-06,
                    4.4298e-06,
                    4.6757e-06,
                    4.9315e-06,
                    5.1995e-06,
                    5.4773e-06,
                    5.7654e-06,
                    6.0641e-06,
                    6.3706e-06,
                    6.6856e-06,
                    7.0059e-06,
                    7.3313e-06,
                    7.662e-06,
                    7.9982e-06,
                    8.342e-06,
                    8.6901e-06,
                    9.0433e-06,
                    9.4021e-06,
                    9.7681e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Fossil_3GHG": 0.01,
                "Fossil_3GHG_timeseries": [
                    1.1543e-08,
                    2.3275e-08,
                    3.5197e-08,
                    4.7307e-08,
                    5.9608e-08,
                    7.2098e-08,
                    8.4778e-08,
                    9.7648e-08,
                    1.1071e-07,
                    1.2395e-07,
                    1.3742e-07,
                    1.511e-07,
                    1.6503e-07,
                    1.7918e-07,
                    1.9355e-07,
                    2.0815e-07,
                    2.2296e-07,
                    2.38e-07,
                    2.5326e-07,
                    2.6875e-07,
                    2.8449e-07,
                    3.0051e-07,
                    3.1681e-07,
                    3.3339e-07,
                    3.5059e-07,
                    3.6808e-07,
                    3.8584e-07,
                    4.0388e-07,
                    4.2219e-07,
                    4.4076e-07,
                    4.5963e-07,
                    4.788e-07,
                    4.9823e-07,
                    5.1797e-07,
                    5.3799e-07,
                    5.5832e-07,
                    5.7893e-07,
                    5.9985e-07,
                    6.2106e-07,
                    6.426e-07,
                    6.6451e-07,
                    6.8678e-07,
                    7.0942e-07,
                    7.3243e-07,
                    7.555e-07,
                    7.7895e-07,
                    8.0278e-07,
                    8.2698e-07,
                    8.5158e-07,
                    8.7655e-07,
                    9.0199e-07,
                    9.2789e-07,
                    9.5427e-07,
                    9.8112e-07,
                    1.0084e-06,
                    1.0362e-06,
                    1.0645e-06,
                    1.0933e-06,
                    1.1225e-06,
                    1.1522e-06,
                    1.1824e-06,
                    1.2132e-06,
                    1.2446e-06,
                    1.2765e-06,
                    1.309e-06,
                    1.342e-06,
                    1.3756e-06,
                    1.4098e-06,
                    1.4445e-06,
                    1.4797e-06,
                    1.5157e-06,
                    1.5522e-06,
                    1.5895e-06,
                    1.6274e-06,
                    1.666e-06,
                    1.7053e-06,
                    1.7452e-06,
                    1.7858e-06,
                    1.8272e-06,
                    1.8691e-06,
                    1.912e-06,
                    1.9556e-06,
                    2.0002e-06,
                    2.0457e-06,
                    2.0921e-06,
                    2.1393e-06,
                    2.1876e-06,
                    2.2367e-06,
                    2.2867e-06,
                    2.3377e-06,
                    2.3906e-06,
                    2.4453e-06,
                    2.502e-06,
                    2.5607e-06,
                    2.6222e-06,
                    2.6863e-06,
                    2.7536e-06,
                    2.8242e-06,
                    2.8983e-06,
                    2.979e-06,
                    3.0636e-06,
                    3.1523e-06,
                    3.2453e-06,
                    3.3429e-06,
                    3.4453e-06,
                    3.5527e-06,
                    3.6653e-06,
                    3.7832e-06,
                    3.9067e-06,
                    4.036e-06,
                    4.1702e-06,
                    4.3098e-06,
                    4.4549e-06,
                    4.606e-06,
                    4.7625e-06,
                    4.925e-06,
                    5.0932e-06,
                    5.2675e-06,
                    5.4483e-06,
                    5.6296e-06,
                    5.8193e-06,
                    6.0158e-06,
                    6.218e-06,
                    6.4246e-06,
                    6.6359e-06,
                    6.8562e-06,
                    7.081e-06,
                    7.3122e-06,
                    7.5507e-06,
                    7.7959e-06,
                    8.0414e-06,
                    8.2947e-06,
                    8.556e-06,
                    8.8237e-06,
                    9.1023e-06,
                    9.393e-06,
                    9.7003e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_3GHG": 0.08,
                "Land_3GHG_timeseries": [
                    1.6147e-07,
                    3.2516e-07,
                    4.91e-07,
                    6.5904e-07,
                    8.2967e-07,
                    1.0029e-06,
                    1.1787e-06,
                    1.3569e-06,
                    1.5371e-06,
                    1.7212e-06,
                    1.9067e-06,
                    2.0957e-06,
                    2.2871e-06,
                    2.4816e-06,
                    2.6771e-06,
                    2.8747e-06,
                    3.0748e-06,
                    3.278e-06,
                    3.4843e-06,
                    3.6945e-06,
                    3.9084e-06,
                    4.1293e-06,
                    4.3589e-06,
                    4.5981e-06,
                    4.8489e-06,
                    5.1092e-06,
                    5.3795e-06,
                    5.6602e-06,
                    5.9484e-06,
                    6.2448e-06,
                    6.5463e-06,
                    6.8525e-06,
                    7.1638e-06,
                    7.4802e-06,
                    7.804e-06,
                    8.1317e-06,
                    8.4643e-06,
                    8.8023e-06,
                    9.147e-06,
                    9.5063e-06,
                    9.874e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Total_CO2": 0.01,
                "Total_CO2_timeseries": [
                    -0.00000013974,
                    -0.00000028224,
                    -0.00000042754,
                    -0.00000057547,
                    -0.00000072555,
                    -0.0000008776,
                    -0.0000010315,
                    -0.0000011874,
                    -0.0000013452,
                    -0.000001503,
                    -0.0000016636,
                    -0.0000018252,
                    -0.0000019888,
                    -0.0000021534,
                    -0.0000023214,
                    -0.0000024916,
                    -0.0000026635,
                    -0.0000028367,
                    -0.0000030111,
                    -0.0000031861,
                    -0.0000033638,
                    -0.0000035431,
                    -0.0000037241,
                    -0.0000039069,
                    -0.0000040902,
                    -0.0000042762,
                    -0.0000044641,
                    -0.0000046527,
                    -0.0000048434,
                    -0.000005034,
                    -0.0000052273,
                    -0.0000054234,
                    -0.0000056218,
                    -0.0000058222,
                    -0.0000060223,
                    -0.0000062256,
                    -0.000006431,
                    -0.0000066382,
                    -0.0000068458,
                    -0.0000070526,
                    -0.00000726,
                    -0.0000074716,
                    -0.0000076858,
                    -0.0000079022,
                    -0.0000081197,
                    -0.0000083385,
                    -0.0000085595,
                    -0.0000087792,
                    -0.0000090022,
                    -0.0000092266,
                    -0.0000094522,
                    -0.0000096794,
                    -0.0000099049,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    -0.0000098633,
                    -0.0000095834,
                    -0.0000093005,
                    -0.0000090242,
                    -0.0000087474,
                    -0.0000084102,
                    -0.0000080834,
                    -0.0000077358,
                    -0.0000073366,
                    -0.000006864,
                    -0.0000062971,
                    -0.0000056925,
                    -0.0000049679,
                    -0.0000040912,
                    -0.000002431,
                    -0.0000001285,
                    3.0035e-06,
                    6.4589e-06,
                    9.0726e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    4.752e-07,
                    9.933e-07,
                    1.6186e-06,
                    2.3265e-06,
                    3.0558e-06,
                    3.8313e-06,
                    4.6283e-06,
                    5.4466e-06,
                    6.1957e-06,
                    6.9184e-06,
                    7.8243e-06,
                    8.6295e-06,
                    9.4776e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CO2": 0.02,
                "Land_CO2_timeseries": [
                    -0.00000013974,
                    -0.00000028224,
                    -0.00000042754,
                    -0.00000057547,
                    -0.00000072555,
                    -0.0000008776,
                    -0.0000010315,
                    -0.0000011874,
                    -0.0000013452,
                    -0.000001503,
                    -0.0000016636,
                    -0.0000018252,
                    -0.0000019888,
                    -0.0000021534,
                    -0.0000023214,
                    -0.0000024916,
                    -0.0000026635,
                    -0.0000028367,
                    -0.0000030111,
                    -0.0000031861,
                    -0.0000033638,
                    -0.0000035431,
                    -0.0000037241,
                    -0.0000039069,
                    -0.0000040902,
                    -0.0000042762,
                    -0.0000044641,
                    -0.0000046527,
                    -0.0000048434,
                    -0.000005034,
                    -0.0000052273,
                    -0.0000054234,
                    -0.0000056218,
                    -0.0000058222,
                    -0.0000060223,
                    -0.0000062256,
                    -0.000006431,
                    -0.0000066382,
                    -0.0000068458,
                    -0.0000070526,
                    -0.00000726,
                    -0.0000074716,
                    -0.0000076858,
                    -0.0000079022,
                    -0.0000081197,
                    -0.0000083385,
                    -0.0000085595,
                    -0.0000087792,
                    -0.0000090022,
                    -0.0000092266,
                    -0.0000094522,
                    -0.0000096794,
                    -0.0000099049,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    -0.0000098633,
                    -0.0000095834,
                    -0.0000093005,
                    -0.0000090242,
                    -0.0000087474,
                    -0.0000084102,
                    -0.0000080834,
                    -0.0000077358,
                    -0.0000073366,
                    -0.000006864,
                    -0.0000062971,
                    -0.0000056925,
                    -0.0000049679,
                    -0.0000040912,
                    -0.0000029062,
                    -0.0000011218,
                    1.3848e-06,
                    4.1324e-06,
                    6.0168e-06,
                    8.0076e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_CH4": 0.07,
                "Total_CH4_timeseries": [
                    2.3835e-07,
                    4.804e-07,
                    7.2615e-07,
                    9.756e-07,
                    1.2288e-06,
                    1.4856e-06,
                    1.7462e-06,
                    2.0105e-06,
                    2.2784e-06,
                    2.5501e-06,
                    2.8263e-06,
                    3.1068e-06,
                    3.3919e-06,
                    3.6814e-06,
                    3.9754e-06,
                    4.2738e-06,
                    4.5767e-06,
                    4.884e-06,
                    5.1958e-06,
                    5.5121e-06,
                    5.8337e-06,
                    6.1607e-06,
                    6.493e-06,
                    6.8308e-06,
                    7.1742e-06,
                    7.523e-06,
                    7.8771e-06,
                    8.2366e-06,
                    8.6015e-06,
                    8.9717e-06,
                    9.3485e-06,
                    9.7318e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_CH4": 0.02,
                "Fossil_CH4_timeseries": [
                    1.0596e-08,
                    2.1368e-08,
                    3.2315e-08,
                    4.344e-08,
                    5.4742e-08,
                    6.6223e-08,
                    7.7883e-08,
                    8.9723e-08,
                    1.0174e-07,
                    1.1395e-07,
                    1.2636e-07,
                    1.3898e-07,
                    1.5185e-07,
                    1.6494e-07,
                    1.7824e-07,
                    1.9175e-07,
                    2.0548e-07,
                    2.1942e-07,
                    2.3359e-07,
                    2.4797e-07,
                    2.626e-07,
                    2.7748e-07,
                    2.926e-07,
                    3.0797e-07,
                    3.2391e-07,
                    3.4009e-07,
                    3.5651e-07,
                    3.7317e-07,
                    3.9006e-07,
                    4.072e-07,
                    4.2462e-07,
                    4.4232e-07,
                    4.6028e-07,
                    4.7853e-07,
                    4.9706e-07,
                    5.1588e-07,
                    5.3498e-07,
                    5.5437e-07,
                    5.7404e-07,
                    5.94e-07,
                    6.1431e-07,
                    6.3496e-07,
                    6.5596e-07,
                    6.773e-07,
                    6.9868e-07,
                    7.2041e-07,
                    7.425e-07,
                    7.6494e-07,
                    7.8774e-07,
                    8.1089e-07,
                    8.3448e-07,
                    8.585e-07,
                    8.8294e-07,
                    9.0782e-07,
                    9.3314e-07,
                    9.5889e-07,
                    9.8507e-07,
                    1.0117e-06,
                    1.0387e-06,
                    1.0662e-06,
                    1.0942e-06,
                    1.1228e-06,
                    1.1518e-06,
                    1.1815e-06,
                    1.2116e-06,
                    1.2423e-06,
                    1.2735e-06,
                    1.3052e-06,
                    1.3375e-06,
                    1.3703e-06,
                    1.4037e-06,
                    1.4377e-06,
                    1.4724e-06,
                    1.5078e-06,
                    1.5438e-06,
                    1.5804e-06,
                    1.6177e-06,
                    1.6556e-06,
                    1.6942e-06,
                    1.7334e-06,
                    1.7735e-06,
                    1.8143e-06,
                    1.8559e-06,
                    1.8983e-06,
                    1.9416e-06,
                    1.9856e-06,
                    2.0304e-06,
                    2.076e-06,
                    2.1225e-06,
                    2.1697e-06,
                    2.2187e-06,
                    2.2694e-06,
                    2.3218e-06,
                    2.376e-06,
                    2.4327e-06,
                    2.4919e-06,
                    2.5539e-06,
                    2.6191e-06,
                    2.6875e-06,
                    2.7624e-06,
                    2.841e-06,
                    2.9236e-06,
                    3.0103e-06,
                    3.1014e-06,
                    3.1972e-06,
                    3.2977e-06,
                    3.4033e-06,
                    3.5141e-06,
                    3.6303e-06,
                    3.7522e-06,
                    3.8788e-06,
                    4.0106e-06,
                    4.1477e-06,
                    4.2903e-06,
                    4.4383e-06,
                    4.5917e-06,
                    4.7505e-06,
                    4.915e-06,
                    5.0855e-06,
                    5.2561e-06,
                    5.4348e-06,
                    5.6202e-06,
                    5.8107e-06,
                    6.0053e-06,
                    6.2038e-06,
                    6.4106e-06,
                    6.6213e-06,
                    6.8375e-06,
                    7.0601e-06,
                    7.2886e-06,
                    7.518e-06,
                    7.7529e-06,
                    7.9942e-06,
                    8.2423e-06,
                    8.5011e-06,
                    8.7698e-06,
                    9.0535e-06,
                    9.3549e-06,
                    9.6695e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CH4": 0.15,
                "Land_CH4_timeseries": [
                    2.2775e-07,
                    4.5903e-07,
                    6.9383e-07,
                    9.3216e-07,
                    1.174e-06,
                    1.4194e-06,
                    1.6683e-06,
                    1.9207e-06,
                    2.1767e-06,
                    2.4362e-06,
                    2.6999e-06,
                    2.9679e-06,
                    3.24e-06,
                    3.5165e-06,
                    3.7972e-06,
                    4.0821e-06,
                    4.3712e-06,
                    4.6646e-06,
                    4.9622e-06,
                    5.2641e-06,
                    5.5711e-06,
                    5.8832e-06,
                    6.2004e-06,
                    6.5228e-06,
                    6.8503e-06,
                    7.1829e-06,
                    7.5206e-06,
                    7.8635e-06,
                    8.2115e-06,
                    8.5646e-06,
                    8.9239e-06,
                    9.2894e-06,
                    9.6612e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Total_N2O": 0.16,
                "Total_N2O_timeseries": [
                    7.44e-08,
                    1.5028e-07,
                    2.2758e-07,
                    3.0622e-07,
                    3.8607e-07,
                    4.67e-07,
                    5.4886e-07,
                    6.3145e-07,
                    7.1457e-07,
                    7.9798e-07,
                    8.8154e-07,
                    9.6521e-07,
                    1.049e-06,
                    1.1328e-06,
                    1.2167e-06,
                    1.3006e-06,
                    1.3846e-06,
                    1.4687e-06,
                    1.5528e-06,
                    1.6372e-06,
                    1.723e-06,
                    1.8123e-06,
                    1.9068e-06,
                    2.0077e-06,
                    2.1155e-06,
                    2.2305e-06,
                    2.3523e-06,
                    2.4801e-06,
                    2.6126e-06,
                    2.7478e-06,
                    2.8847e-06,
                    3.0229e-06,
                    3.1623e-06,
                    3.3026e-06,
                    3.4438e-06,
                    3.5859e-06,
                    3.7287e-06,
                    3.8725e-06,
                    4.0172e-06,
                    4.1695e-06,
                    4.3232e-06,
                    4.4785e-06,
                    4.6353e-06,
                    4.7938e-06,
                    4.954e-06,
                    5.116e-06,
                    5.2799e-06,
                    5.4456e-06,
                    5.6133e-06,
                    5.783e-06,
                    5.9546e-06,
                    6.1281e-06,
                    6.3035e-06,
                    6.4808e-06,
                    6.6602e-06,
                    6.8418e-06,
                    7.0259e-06,
                    7.2128e-06,
                    7.4029e-06,
                    7.5966e-06,
                    7.7957e-06,
                    8.0028e-06,
                    8.2202e-06,
                    8.4495e-06,
                    8.6921e-06,
                    8.9487e-06,
                    9.2196e-06,
                    9.5047e-06,
                    9.8033e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_N2O": 0.01,
                "Fossil_N2O_timeseries": [
                    9.4708e-10,
                    1.9076e-09,
                    2.8813e-09,
                    3.8677e-09,
                    4.866e-09,
                    5.8757e-09,
                    6.8957e-09,
                    7.9251e-09,
                    8.9628e-09,
                    1.0007e-08,
                    1.1058e-08,
                    1.2115e-08,
                    1.3177e-08,
                    1.4245e-08,
                    1.5319e-08,
                    1.6398e-08,
                    1.7483e-08,
                    1.8574e-08,
                    1.9671e-08,
                    2.0774e-08,
                    2.189e-08,
                    2.3031e-08,
                    2.4206e-08,
                    2.5421e-08,
                    2.668e-08,
                    2.7983e-08,
                    2.933e-08,
                    3.0714e-08,
                    3.213e-08,
                    3.3566e-08,
                    3.5016e-08,
                    3.6479e-08,
                    3.7954e-08,
                    3.9439e-08,
                    4.0935e-08,
                    4.244e-08,
                    4.3955e-08,
                    4.5481e-08,
                    4.7017e-08,
                    4.8598e-08,
                    5.0199e-08,
                    5.182e-08,
                    5.3464e-08,
                    5.513e-08,
                    5.682e-08,
                    5.8534e-08,
                    6.0274e-08,
                    6.204e-08,
                    6.3834e-08,
                    6.5656e-08,
                    6.751e-08,
                    6.94e-08,
                    7.1328e-08,
                    7.3298e-08,
                    7.5309e-08,
                    7.7363e-08,
                    7.9458e-08,
                    8.1592e-08,
                    8.3762e-08,
                    8.5965e-08,
                    8.8197e-08,
                    9.0457e-08,
                    9.2744e-08,
                    9.5057e-08,
                    9.7395e-08,
                    9.9759e-08,
                    1.0215e-07,
                    1.0456e-07,
                    1.07e-07,
                    1.0947e-07,
                    1.1197e-07,
                    1.1449e-07,
                    1.1704e-07,
                    1.1962e-07,
                    1.2222e-07,
                    1.2485e-07,
                    1.2752e-07,
                    1.3021e-07,
                    1.3293e-07,
                    1.3569e-07,
                    1.3849e-07,
                    1.4135e-07,
                    1.443e-07,
                    1.4734e-07,
                    1.5049e-07,
                    1.5376e-07,
                    1.5714e-07,
                    1.6065e-07,
                    1.6427e-07,
                    1.6802e-07,
                    1.719e-07,
                    1.7595e-07,
                    1.8022e-07,
                    1.8471e-07,
                    1.8945e-07,
                    1.9443e-07,
                    1.9965e-07,
                    2.051e-07,
                    2.1076e-07,
                    2.1659e-07,
                    2.2257e-07,
                    2.2872e-07,
                    2.3503e-07,
                    2.4151e-07,
                    2.4815e-07,
                    2.5496e-07,
                    2.6194e-07,
                    2.6907e-07,
                    2.7636e-07,
                    2.838e-07,
                    2.9141e-07,
                    2.9922e-07,
                    3.0728e-07,
                    3.1562e-07,
                    3.2428e-07,
                    3.333e-07,
                    3.4271e-07,
                    3.5254e-07,
                    3.6284e-07,
                    3.7348e-07,
                    3.8444e-07,
                    3.9569e-07,
                    4.073e-07,
                    4.193e-07,
                    4.3204e-07,
                    4.4557e-07,
                    4.5972e-07,
                    4.7466e-07,
                    4.9061e-07,
                    5.0731e-07,
                    5.2344e-07,
                    5.4185e-07,
                    5.6179e-07,
                    5.8134e-07,
                    6.0126e-07,
                    6.2317e-07,
                    6.4682e-07,
                    6.7061e-07,
                    6.9495e-07,
                    7.255e-07,
                    7.4775e-07,
                    7.7053e-07,
                    7.9478e-07,
                    8.2035e-07,
                    8.4703e-07,
                    8.9786e-07,
                    9.4785e-07,
                    9.9907e-07,
                    1.051e-06,
                    1.1036e-06,
                    1.1668e-06,
                    1.2243e-06,
                    1.2839e-06,
                    1.3461e-06,
                    1.4073e-06,
                    1.4683e-06,
                    1.5305e-06,
                    1.6035e-06,
                    1.6795e-06,
                    1.7576e-06,
                    1.8369e-06,
                    1.9199e-06,
                    2.0076e-06,
                    2.0998e-06,
                    2.1964e-06,
                    2.2957e-06,
                    2.395e-06,
                    2.4951e-06,
                    2.5953e-06,
                    2.6914e-06,
                    2.7888e-06,
                    2.8921e-06
                ],
                "Land_N2O": 0.21,
                "Land_N2O_timeseries": [
                    7.3453e-08,
                    1.4837e-07,
                    2.247e-07,
                    3.0235e-07,
                    3.812e-07,
                    4.6113e-07,
                    5.4196e-07,
                    6.2352e-07,
                    7.0561e-07,
                    7.8798e-07,
                    8.7049e-07,
                    9.531e-07,
                    1.0358e-06,
                    1.1185e-06,
                    1.2013e-06,
                    1.2842e-06,
                    1.3671e-06,
                    1.4501e-06,
                    1.5332e-06,
                    1.6164e-06,
                    1.7011e-06,
                    1.7893e-06,
                    1.8826e-06,
                    1.9822e-06,
                    2.0888e-06,
                    2.2025e-06,
                    2.323e-06,
                    2.4494e-06,
                    2.5804e-06,
                    2.7143e-06,
                    2.8497e-06,
                    2.9865e-06,
                    3.1243e-06,
                    3.2632e-06,
                    3.4029e-06,
                    3.5434e-06,
                    3.6848e-06,
                    3.827e-06,
                    3.9702e-06,
                    4.1209e-06,
                    4.273e-06,
                    4.4266e-06,
                    4.5818e-06,
                    4.7387e-06,
                    4.8972e-06,
                    5.0575e-06,
                    5.2196e-06,
                    5.3836e-06,
                    5.5494e-06,
                    5.7173e-06,
                    5.8871e-06,
                    6.0587e-06,
                    6.2322e-06,
                    6.4075e-06,
                    6.5849e-06,
                    6.7644e-06,
                    6.9464e-06,
                    7.1312e-06,
                    7.3191e-06,
                    7.5106e-06,
                    7.7075e-06,
                    7.9123e-06,
                    8.1274e-06,
                    8.3545e-06,
                    8.5947e-06,
                    8.8489e-06,
                    9.1175e-06,
                    9.4001e-06,
                    9.6963e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            19.99948,
                            -24.75195
                        ],
                        [
                            19.99949,
                            -24.35396
                        ],
                        [
                            19.99951,
                            -23.77825
                        ],
                        [
                            19.99958,
                            -22.00112
                        ],
                        [
                            20.99901,
                            -21.99793
                        ],
                        [
                            20.99916,
                            -21.40739
                        ],
                        [
                            20.99929,
                            -20.85069
                        ],
                        [
                            20.99947,
                            -20.14223
                        ],
                        [
                            20.99991,
                            -18.31956
                        ],
                        [
                            21.46297,
                            -18.30427
                        ],
                        [
                            22.0751,
                            -18.18912
                        ],
                        [
                            23.09784,
                            -18.00059
                        ],
                        [
                            23.29006,
                            -18.00027
                        ],
                        [
                            23.32457,
                            -18.08038
                        ],
                        [
                            23.37946,
                            -18.13716
                        ],
                        [
                            23.39872,
                            -18.20636
                        ],
                        [
                            23.499,
                            -18.24327
                        ],
                        [
                            23.55253,
                            -18.3245
                        ],
                        [
                            23.57291,
                            -18.46812
                        ],
                        [
                            23.63273,
                            -18.48876
                        ],
                        [
                            23.74882,
                            -18.41715
                        ],
                        [
                            23.81455,
                            -18.32214
                        ],
                        [
                            23.90812,
                            -18.25982
                        ],
                        [
                            23.93158,
                            -18.20507
                        ],
                        [
                            24.01733,
                            -18.14592
                        ],
                        [
                            24.12209,
                            -18.10242
                        ],
                        [
                            24.1916,
                            -18.02889
                        ],
                        [
                            24.29076,
                            -18.0392
                        ],
                        [
                            24.36918,
                            -17.9492
                        ],
                        [
                            24.42413,
                            -17.95293
                        ],
                        [
                            24.50543,
                            -18.06101
                        ],
                        [
                            24.57574,
                            -18.07145
                        ],
                        [
                            24.63029,
                            -17.98196
                        ],
                        [
                            24.70077,
                            -17.93986
                        ],
                        [
                            24.73397,
                            -17.8907
                        ],
                        [
                            24.8555,
                            -17.84769
                        ],
                        [
                            24.91175,
                            -17.81171
                        ],
                        [
                            25.01344,
                            -17.83729
                        ],
                        [
                            25.11483,
                            -17.8252
                        ],
                        [
                            25.16069,
                            -17.77975
                        ],
                        [
                            25.2628,
                            -17.79139
                        ],
                        [
                            25.18809,
                            -17.7664
                        ],
                        [
                            25.04638,
                            -17.59007
                        ],
                        [
                            24.87927,
                            -17.52722
                        ],
                        [
                            24.79931,
                            -17.53664
                        ],
                        [
                            24.70381,
                            -17.49735
                        ],
                        [
                            24.56285,
                            -17.53856
                        ],
                        [
                            24.47304,
                            -17.48584
                        ],
                        [
                            24.38833,
                            -17.46932
                        ],
                        [
                            24.32856,
                            -17.49169
                        ],
                        [
                            24.24673,
                            -17.47317
                        ],
                        [
                            23.42989,
                            -17.63446
                        ],
                        [
                            22.85778,
                            -17.74563
                        ],
                        [
                            22.0751,
                            -17.89762
                        ],
                        [
                            21.42651,
                            -18.0234
                        ],
                        [
                            21.25584,
                            -17.96234
                        ],
                        [
                            21.21303,
                            -17.92924
                        ],
                        [
                            20.97792,
                            -17.95823
                        ],
                        [
                            20.80549,
                            -18.03748
                        ],
                        [
                            20.74658,
                            -18.00189
                        ],
                        [
                            20.64417,
                            -17.97713
                        ],
                        [
                            20.5412,
                            -17.98218
                        ],
                        [
                            20.43854,
                            -17.90637
                        ],
                        [
                            20.32202,
                            -17.86193
                        ],
                        [
                            20.24539,
                            -17.89218
                        ],
                        [
                            20.17262,
                            -17.8768
                        ],
                        [
                            20.10965,
                            -17.91048
                        ],
                        [
                            19.91084,
                            -17.86265
                        ],
                        [
                            19.81151,
                            -17.86777
                        ],
                        [
                            19.76315,
                            -17.90674
                        ],
                        [
                            19.671,
                            -17.84905
                        ],
                        [
                            19.55029,
                            -17.87466
                        ],
                        [
                            19.43053,
                            -17.86926
                        ],
                        [
                            19.24652,
                            -17.81555
                        ],
                        [
                            19.14623,
                            -17.80841
                        ],
                        [
                            19.10456,
                            -17.83661
                        ],
                        [
                            18.9006,
                            -17.8176
                        ],
                        [
                            18.79092,
                            -17.76504
                        ],
                        [
                            18.56388,
                            -17.58041
                        ],
                        [
                            18.53508,
                            -17.52252
                        ],
                        [
                            18.41645,
                            -17.38833
                        ],
                        [
                            14.60215,
                            -17.38848
                        ],
                        [
                            14.22016,
                            -17.38849
                        ],
                        [
                            14.10157,
                            -17.43863
                        ],
                        [
                            14.01668,
                            -17.4145
                        ],
                        [
                            13.95539,
                            -17.43261
                        ],
                        [
                            13.91662,
                            -17.3784
                        ],
                        [
                            13.51614,
                            -17.13721
                        ],
                        [
                            13.52147,
                            -17.09137
                        ],
                        [
                            13.46158,
                            -17.0106
                        ],
                        [
                            13.35382,
                            -16.97475
                        ],
                        [
                            13.27554,
                            -16.99776
                        ],
                        [
                            13.16705,
                            -16.9635
                        ],
                        [
                            12.98382,
                            -16.98253
                        ],
                        [
                            12.91519,
                            -17.02194
                        ],
                        [
                            12.80495,
                            -17.11486
                        ],
                        [
                            12.61294,
                            -17.20865
                        ],
                        [
                            12.59619,
                            -17.23402
                        ],
                        [
                            12.4798,
                            -17.24241
                        ],
                        [
                            12.39745,
                            -17.20782
                        ],
                        [
                            12.25124,
                            -17.23926
                        ],
                        [
                            12.15693,
                            -17.16033
                        ],
                        [
                            12.07999,
                            -17.14252
                        ],
                        [
                            11.94206,
                            -17.18217
                        ],
                        [
                            11.79271,
                            -17.27288
                        ],
                        [
                            11.75086,
                            -17.25245
                        ],
                        [
                            11.73737,
                            -17.58483
                        ],
                        [
                            11.76904,
                            -17.78192
                        ],
                        [
                            11.80254,
                            -17.89435
                        ],
                        [
                            11.80421,
                            -17.97316
                        ],
                        [
                            11.85484,
                            -18.14056
                        ],
                        [
                            11.9573,
                            -18.26106
                        ],
                        [
                            11.99929,
                            -18.36798
                        ],
                        [
                            12.00382,
                            -18.43406
                        ],
                        [
                            12.0478,
                            -18.51121
                        ],
                        [
                            12.32559,
                            -18.73874
                        ],
                        [
                            12.46007,
                            -18.91827
                        ],
                        [
                            12.47633,
                            -18.99556
                        ],
                        [
                            12.56885,
                            -19.08558
                        ],
                        [
                            12.62177,
                            -19.19812
                        ],
                        [
                            12.69185,
                            -19.30527
                        ],
                        [
                            12.70434,
                            -19.37895
                        ],
                        [
                            12.9281,
                            -19.78072
                        ],
                        [
                            12.95466,
                            -19.85374
                        ],
                        [
                            13.03335,
                            -19.98648
                        ],
                        [
                            13.05427,
                            -20.06881
                        ],
                        [
                            13.19806,
                            -20.21742
                        ],
                        [
                            13.23946,
                            -20.322
                        ],
                        [
                            13.25041,
                            -20.45757
                        ],
                        [
                            13.33483,
                            -20.60624
                        ],
                        [
                            13.364,
                            -20.68738
                        ],
                        [
                            13.37823,
                            -20.79484
                        ],
                        [
                            13.41456,
                            -20.87281
                        ],
                        [
                            13.54882,
                            -21.04779
                        ],
                        [
                            13.57663,
                            -21.1344
                        ],
                        [
                            13.68375,
                            -21.25246
                        ],
                        [
                            13.70622,
                            -21.30421
                        ],
                        [
                            13.80493,
                            -21.42023
                        ],
                        [
                            13.86008,
                            -21.50589
                        ],
                        [
                            13.88194,
                            -21.58936
                        ],
                        [
                            13.97553,
                            -21.71686
                        ],
                        [
                            13.95433,
                            -21.77493
                        ],
                        [
                            14.05898,
                            -21.8629
                        ],
                        [
                            14.28351,
                            -22.12773
                        ],
                        [
                            14.29072,
                            -22.16554
                        ],
                        [
                            14.39299,
                            -22.28513
                        ],
                        [
                            14.46251,
                            -22.46964
                        ],
                        [
                            14.50875,
                            -22.55726
                        ],
                        [
                            14.52625,
                            -22.64787
                        ],
                        [
                            14.52363,
                            -22.75068
                        ],
                        [
                            14.53855,
                            -22.89477
                        ],
                        [
                            14.46321,
                            -23.01674
                        ],
                        [
                            14.40438,
                            -23.01149
                        ],
                        [
                            14.48154,
                            -23.24611
                        ],
                        [
                            14.49599,
                            -23.38656
                        ],
                        [
                            14.44344,
                            -23.44958
                        ],
                        [
                            14.51052,
                            -23.6286
                        ],
                        [
                            14.49945,
                            -23.7568
                        ],
                        [
                            14.51334,
                            -23.9097
                        ],
                        [
                            14.46312,
                            -23.95331
                        ],
                        [
                            14.4648,
                            -24.09409
                        ],
                        [
                            14.5052,
                            -24.22392
                        ],
                        [
                            14.60877,
                            -24.44518
                        ],
                        [
                            14.59887,
                            -24.55505
                        ],
                        [
                            14.73223,
                            -24.70859
                        ],
                        [
                            14.79719,
                            -24.83641
                        ],
                        [
                            14.79792,
                            -24.92233
                        ],
                        [
                            14.87313,
                            -25.09726
                        ],
                        [
                            14.80315,
                            -25.29359
                        ],
                        [
                            14.81252,
                            -25.38377
                        ],
                        [
                            14.88173,
                            -25.54876
                        ],
                        [
                            14.84483,
                            -25.63396
                        ],
                        [
                            14.83166,
                            -25.7477
                        ],
                        [
                            14.90718,
                            -25.85031
                        ],
                        [
                            14.91198,
                            -25.93219
                        ],
                        [
                            14.97926,
                            -26.07539
                        ],
                        [
                            14.9541,
                            -26.14052
                        ],
                        [
                            14.96724,
                            -26.19233
                        ],
                        [
                            14.95414,
                            -26.31412
                        ],
                        [
                            15.092,
                            -26.40513
                        ],
                        [
                            15.12091,
                            -26.44603
                        ],
                        [
                            15.15074,
                            -26.64291
                        ],
                        [
                            15.08119,
                            -26.68876
                        ],
                        [
                            15.15418,
                            -26.90155
                        ],
                        [
                            15.22023,
                            -26.92634
                        ],
                        [
                            15.23175,
                            -27.04559
                        ],
                        [
                            15.25514,
                            -27.09143
                        ],
                        [
                            15.26317,
                            -27.20949
                        ],
                        [
                            15.29191,
                            -27.31237
                        ],
                        [
                            15.37361,
                            -27.44044
                        ],
                        [
                            15.42258,
                            -27.48477
                        ],
                        [
                            15.5218,
                            -27.64115
                        ],
                        [
                            15.53447,
                            -27.72502
                        ],
                        [
                            15.67841,
                            -27.90265
                        ],
                        [
                            15.71833,
                            -28.00004
                        ],
                        [
                            15.85002,
                            -28.12693
                        ],
                        [
                            16.03888,
                            -28.27332
                        ],
                        [
                            16.32373,
                            -28.54652
                        ],
                        [
                            16.45563,
                            -28.63472
                        ],
                        [
                            16.49178,
                            -28.56733
                        ],
                        [
                            16.59964,
                            -28.53184
                        ],
                        [
                            16.68065,
                            -28.4709
                        ],
                        [
                            16.73623,
                            -28.49394
                        ],
                        [
                            16.80378,
                            -28.36245
                        ],
                        [
                            16.75516,
                            -28.30192
                        ],
                        [
                            16.82301,
                            -28.27068
                        ],
                        [
                            16.84554,
                            -28.16533
                        ],
                        [
                            16.88836,
                            -28.16958
                        ],
                        [
                            16.90076,
                            -28.07225
                        ],
                        [
                            17.08281,
                            -28.03378
                        ],
                        [
                            17.13678,
                            -28.0919
                        ],
                        [
                            17.19125,
                            -28.10781
                        ],
                        [
                            17.1827,
                            -28.2035
                        ],
                        [
                            17.21361,
                            -28.24647
                        ],
                        [
                            17.34478,
                            -28.23861
                        ],
                        [
                            17.40478,
                            -28.35656
                        ],
                        [
                            17.39048,
                            -28.43252
                        ],
                        [
                            17.33361,
                            -28.47582
                        ],
                        [
                            17.37905,
                            -28.56686
                        ],
                        [
                            17.4319,
                            -28.58285
                        ],
                        [
                            17.4122,
                            -28.71307
                        ],
                        [
                            17.49047,
                            -28.69433
                        ],
                        [
                            17.59967,
                            -28.69681
                        ],
                        [
                            17.61782,
                            -28.76321
                        ],
                        [
                            17.69438,
                            -28.7491
                        ],
                        [
                            17.9246,
                            -28.76927
                        ],
                        [
                            18.0769,
                            -28.87125
                        ],
                        [
                            18.18945,
                            -28.91707
                        ],
                        [
                            18.26381,
                            -28.87993
                        ],
                        [
                            18.42815,
                            -28.90033
                        ],
                        [
                            18.5122,
                            -28.88981
                        ],
                        [
                            18.63264,
                            -28.84063
                        ],
                        [
                            18.73103,
                            -28.83264
                        ],
                        [
                            18.93232,
                            -28.85656
                        ],
                        [
                            19.10448,
                            -28.9684
                        ],
                        [
                            19.28129,
                            -28.90824
                        ],
                        [
                            19.24139,
                            -28.80365
                        ],
                        [
                            19.26726,
                            -28.74835
                        ],
                        [
                            19.35134,
                            -28.74221
                        ],
                        [
                            19.46579,
                            -28.70617
                        ],
                        [
                            19.5023,
                            -28.60466
                        ],
                        [
                            19.54698,
                            -28.54445
                        ],
                        [
                            19.62435,
                            -28.5115
                        ],
                        [
                            19.66793,
                            -28.52942
                        ],
                        [
                            19.72729,
                            -28.49032
                        ],
                        [
                            19.81478,
                            -28.50665
                        ],
                        [
                            19.84754,
                            -28.46076
                        ],
                        [
                            19.99957,
                            -28.42638
                        ],
                        [
                            19.99984,
                            -27.28206
                        ],
                        [
                            19.99962,
                            -25.72045
                        ],
                        [
                            19.99956,
                            -25.30857
                        ],
                        [
                            19.99948,
                            -24.75195
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "NRU",
                "Country": "Nauru",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    1.2565e-10,
                    2.5342e-10,
                    3.8331e-10,
                    5.1531e-10,
                    6.4939e-10,
                    7.8556e-10,
                    9.2379e-10,
                    1.0641e-09,
                    1.2063e-09,
                    1.3506e-09,
                    1.4966e-09,
                    1.6442e-09,
                    1.7948e-09,
                    1.9472e-09,
                    2.1012e-09,
                    2.257e-09,
                    2.4146e-09,
                    2.5739e-09,
                    2.7351e-09,
                    2.8989e-09,
                    3.0688e-09,
                    3.2452e-09,
                    3.4284e-09,
                    3.6183e-09,
                    3.8151e-09,
                    4.0187e-09,
                    4.2293e-09,
                    4.4465e-09,
                    4.6703e-09,
                    4.9004e-09,
                    5.1359e-09,
                    5.3767e-09,
                    5.6217e-09,
                    5.8721e-09,
                    6.128e-09,
                    6.3893e-09,
                    6.6561e-09,
                    6.9283e-09,
                    7.2058e-09,
                    7.4893e-09,
                    7.7755e-09,
                    8.0648e-09,
                    8.3569e-09,
                    8.6523e-09,
                    8.9512e-09,
                    9.2536e-09,
                    9.5595e-09,
                    9.8691e-09,
                    1.0182e-08,
                    1.0499e-08,
                    1.0818e-08,
                    1.114e-08,
                    1.1463e-08,
                    1.179e-08,
                    1.2118e-08,
                    1.2449e-08,
                    1.2783e-08,
                    1.3119e-08,
                    1.3457e-08,
                    1.3798e-08,
                    1.4135e-08,
                    1.447e-08,
                    1.4802e-08,
                    1.5131e-08,
                    1.5458e-08,
                    1.5781e-08,
                    1.6102e-08,
                    1.6419e-08,
                    1.6734e-08,
                    1.7046e-08,
                    1.7364e-08,
                    1.7687e-08,
                    1.8015e-08,
                    1.835e-08,
                    1.869e-08,
                    1.9035e-08,
                    1.9386e-08,
                    1.9743e-08,
                    2.0105e-08,
                    2.0472e-08,
                    2.0851e-08,
                    2.1244e-08,
                    2.1651e-08,
                    2.2071e-08,
                    2.2504e-08,
                    2.295e-08,
                    2.341e-08,
                    2.3884e-08,
                    2.4372e-08,
                    2.4873e-08,
                    2.5388e-08,
                    2.5919e-08,
                    2.6466e-08,
                    2.703e-08,
                    2.761e-08,
                    2.8209e-08,
                    2.8826e-08,
                    2.9463e-08,
                    3.0117e-08,
                    3.079e-08,
                    3.1495e-08,
                    3.2235e-08,
                    3.3013e-08,
                    3.3831e-08,
                    3.4693e-08,
                    3.5602e-08,
                    3.6561e-08,
                    3.7572e-08,
                    3.8639e-08,
                    3.9765e-08,
                    4.1022e-08,
                    4.2342e-08,
                    4.3723e-08,
                    5.8366e-08,
                    7.4754e-08,
                    9.1206e-08,
                    1.1433e-07,
                    1.3755e-07,
                    1.6911e-07,
                    2.0069e-07,
                    2.4221e-07,
                    2.7886e-07,
                    3.189e-07,
                    3.656e-07,
                    4.14e-07,
                    4.6222e-07,
                    5.1527e-07,
                    5.6838e-07,
                    6.2155e-07,
                    6.7972e-07,
                    7.3796e-07,
                    7.9627e-07,
                    8.5462e-07,
                    9.1278e-07,
                    9.7099e-07,
                    1.0458e-06,
                    1.119e-06,
                    1.1923e-06,
                    1.2655e-06,
                    1.3241e-06,
                    1.3826e-06,
                    1.4396e-06,
                    1.4933e-06,
                    1.5453e-06,
                    1.5956e-06,
                    1.6444e-06,
                    1.6933e-06,
                    1.7404e-06,
                    1.7842e-06,
                    1.8245e-06,
                    1.8631e-06,
                    1.9e-06,
                    1.932e-06,
                    1.9641e-06,
                    1.9943e-06,
                    2.0162e-06,
                    2.0383e-06,
                    2.0606e-06,
                    2.0814e-06,
                    2.1038e-06,
                    2.1246e-06,
                    2.1471e-06,
                    2.1715e-06,
                    2.1979e-06,
                    2.2261e-06,
                    2.2526e-06,
                    2.2808e-06,
                    2.309e-06,
                    2.3375e-06,
                    2.3648e-06,
                    2.3931e-06,
                    2.421e-06
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    8.548e-11,
                    1.7255e-10,
                    2.612e-10,
                    3.5144e-10,
                    4.4326e-10,
                    5.3665e-10,
                    6.3161e-10,
                    7.2812e-10,
                    8.2618e-10,
                    9.2577e-10,
                    1.0267e-09,
                    1.1291e-09,
                    1.2339e-09,
                    1.3402e-09,
                    1.4479e-09,
                    1.5569e-09,
                    1.6674e-09,
                    1.7793e-09,
                    1.8926e-09,
                    2.0083e-09,
                    2.128e-09,
                    2.2519e-09,
                    2.3801e-09,
                    2.5126e-09,
                    2.6495e-09,
                    2.7907e-09,
                    2.9362e-09,
                    3.0861e-09,
                    3.2401e-09,
                    3.3982e-09,
                    3.5598e-09,
                    3.7247e-09,
                    3.8919e-09,
                    4.0626e-09,
                    4.2369e-09,
                    4.4148e-09,
                    4.5962e-09,
                    4.7812e-09,
                    4.9695e-09,
                    5.1608e-09,
                    5.3542e-09,
                    5.5498e-09,
                    5.7475e-09,
                    5.9476e-09,
                    6.1502e-09,
                    6.3553e-09,
                    6.5629e-09,
                    6.773e-09,
                    6.9857e-09,
                    7.2009e-09,
                    7.4174e-09,
                    7.635e-09,
                    7.854e-09,
                    8.0742e-09,
                    8.2955e-09,
                    8.518e-09,
                    8.7417e-09,
                    8.9666e-09,
                    9.1929e-09,
                    9.42e-09,
                    9.6454e-09,
                    9.8684e-09,
                    1.0089e-08,
                    1.0308e-08,
                    1.0525e-08,
                    1.0739e-08,
                    1.0952e-08,
                    1.1162e-08,
                    1.137e-08,
                    1.1576e-08,
                    1.1786e-08,
                    1.1999e-08,
                    1.2216e-08,
                    1.2436e-08,
                    1.266e-08,
                    1.2888e-08,
                    1.3119e-08,
                    1.3354e-08,
                    1.3592e-08,
                    1.3833e-08,
                    1.4083e-08,
                    1.4343e-08,
                    1.4611e-08,
                    1.4889e-08,
                    1.5176e-08,
                    1.5472e-08,
                    1.5777e-08,
                    1.6093e-08,
                    1.6417e-08,
                    1.6751e-08,
                    1.7098e-08,
                    1.7455e-08,
                    1.7827e-08,
                    1.8212e-08,
                    1.861e-08,
                    1.9023e-08,
                    1.9451e-08,
                    1.9894e-08,
                    2.0353e-08,
                    2.0827e-08,
                    2.1325e-08,
                    2.1849e-08,
                    2.2402e-08,
                    2.2986e-08,
                    2.3602e-08,
                    2.4254e-08,
                    2.4942e-08,
                    2.567e-08,
                    2.644e-08,
                    2.7254e-08,
                    2.811e-08,
                    2.9012e-08,
                    2.996e-08,
                    4.4161e-08,
                    6.0064e-08,
                    7.6021e-08,
                    9.8633e-08,
                    1.213e-07,
                    1.5227e-07,
                    1.8322e-07,
                    2.2409e-07,
                    2.6001e-07,
                    2.9925e-07,
                    3.4509e-07,
                    3.9258e-07,
                    4.4006e-07,
                    4.9247e-07,
                    5.4487e-07,
                    5.9726e-07,
                    6.5457e-07,
                    7.1188e-07,
                    7.6918e-07,
                    8.2647e-07,
                    8.8375e-07,
                    9.4103e-07,
                    1.0148e-06,
                    1.087e-06,
                    1.1591e-06,
                    1.2313e-06,
                    1.2887e-06,
                    1.3461e-06,
                    1.4019e-06,
                    1.4544e-06,
                    1.5053e-06,
                    1.5545e-06,
                    1.6022e-06,
                    1.6498e-06,
                    1.6958e-06,
                    1.7385e-06,
                    1.7777e-06,
                    1.8155e-06,
                    1.8516e-06,
                    1.8829e-06,
                    1.9141e-06,
                    1.9436e-06,
                    1.9647e-06,
                    1.9861e-06,
                    2.0077e-06,
                    2.0277e-06,
                    2.0495e-06,
                    2.0697e-06,
                    2.0917e-06,
                    2.1157e-06,
                    2.1417e-06,
                    2.1694e-06,
                    2.1955e-06,
                    2.2233e-06,
                    2.251e-06,
                    2.2791e-06,
                    2.3059e-06,
                    2.3338e-06,
                    2.3613e-06
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [
                    4.0172e-11,
                    8.0878e-11,
                    1.2211e-10,
                    1.6387e-10,
                    2.0614e-10,
                    2.4891e-10,
                    2.9218e-10,
                    3.3593e-10,
                    3.8015e-10,
                    4.2481e-10,
                    4.6983e-10,
                    5.1519e-10,
                    5.609e-10,
                    6.0696e-10,
                    6.5336e-10,
                    7.001e-10,
                    7.4719e-10,
                    7.9462e-10,
                    8.4241e-10,
                    8.9054e-10,
                    9.408e-10,
                    9.9335e-10,
                    1.0483e-09,
                    1.1057e-09,
                    1.1656e-09,
                    1.2281e-09,
                    1.293e-09,
                    1.3604e-09,
                    1.4302e-09,
                    1.5022e-09,
                    1.5761e-09,
                    1.652e-09,
                    1.7298e-09,
                    1.8095e-09,
                    1.8911e-09,
                    1.9745e-09,
                    2.0599e-09,
                    2.1472e-09,
                    2.2363e-09,
                    2.3285e-09,
                    2.4213e-09,
                    2.5149e-09,
                    2.6094e-09,
                    2.7047e-09,
                    2.801e-09,
                    2.8983e-09,
                    2.9966e-09,
                    3.0961e-09,
                    3.1966e-09,
                    3.2984e-09,
                    3.4011e-09,
                    3.5047e-09,
                    3.6095e-09,
                    3.7155e-09,
                    3.8228e-09,
                    3.9313e-09,
                    4.0411e-09,
                    4.1521e-09,
                    4.2643e-09,
                    4.3775e-09,
                    4.49e-09,
                    4.6018e-09,
                    4.7129e-09,
                    4.8232e-09,
                    4.9328e-09,
                    5.0417e-09,
                    5.1498e-09,
                    5.2572e-09,
                    5.3639e-09,
                    5.4698e-09,
                    5.5777e-09,
                    5.6876e-09,
                    5.7995e-09,
                    5.9134e-09,
                    6.0293e-09,
                    6.1472e-09,
                    6.267e-09,
                    6.3888e-09,
                    6.5125e-09,
                    6.638e-09,
                    6.7677e-09,
                    6.9016e-09,
                    7.0396e-09,
                    7.1817e-09,
                    7.328e-09,
                    7.4783e-09,
                    7.6328e-09,
                    7.7915e-09,
                    7.9543e-09,
                    8.1213e-09,
                    8.2908e-09,
                    8.4631e-09,
                    8.6386e-09,
                    8.8175e-09,
                    9e-09,
                    9.1861e-09,
                    9.3756e-09,
                    9.5686e-09,
                    9.7648e-09,
                    9.9638e-09,
                    1.017e-08,
                    1.0386e-08,
                    1.061e-08,
                    1.0845e-08,
                    1.1091e-08,
                    1.1348e-08,
                    1.1618e-08,
                    1.1902e-08,
                    1.2199e-08,
                    1.2511e-08,
                    1.2913e-08,
                    1.333e-08,
                    1.3763e-08,
                    1.4205e-08,
                    1.469e-08,
                    1.5185e-08,
                    1.5695e-08,
                    1.6249e-08,
                    1.6841e-08,
                    1.7464e-08,
                    1.8119e-08,
                    1.8842e-08,
                    1.9647e-08,
                    2.0518e-08,
                    2.1418e-08,
                    2.2161e-08,
                    2.2804e-08,
                    2.3511e-08,
                    2.4295e-08,
                    2.5142e-08,
                    2.6076e-08,
                    2.7085e-08,
                    2.8157e-08,
                    2.9034e-08,
                    2.996e-08,
                    3.0966e-08,
                    3.2034e-08,
                    3.3149e-08,
                    3.4222e-08,
                    3.5348e-08,
                    3.6515e-08,
                    3.7687e-08,
                    3.8865e-08,
                    3.9964e-08,
                    4.1022e-08,
                    4.22e-08,
                    4.3455e-08,
                    4.4632e-08,
                    4.5732e-08,
                    4.6754e-08,
                    4.7614e-08,
                    4.8397e-08,
                    4.9103e-08,
                    4.9963e-08,
                    5.0746e-08,
                    5.1451e-08,
                    5.2186e-08,
                    5.2926e-08,
                    5.3666e-08,
                    5.4324e-08,
                    5.4903e-08,
                    5.5404e-08,
                    5.5827e-08,
                    5.6251e-08,
                    5.6674e-08,
                    5.7098e-08,
                    5.7521e-08,
                    5.7961e-08,
                    5.8401e-08,
                    5.8847e-08,
                    5.9293e-08,
                    5.9746e-08
                ],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.32e-08,
                    2.805e-08,
                    4.29e-08,
                    6.435e-08,
                    8.58e-08,
                    1.155e-07,
                    1.452e-07,
                    1.848e-07,
                    2.1945e-07,
                    2.574e-07,
                    3.0195e-07,
                    3.4815e-07,
                    3.9435e-07,
                    4.455e-07,
                    4.9665e-07,
                    5.478e-07,
                    6.039e-07,
                    6.6e-07,
                    7.161e-07,
                    7.722e-07,
                    8.283e-07,
                    8.844e-07,
                    9.57e-07,
                    1.028e-06,
                    1.0989e-06,
                    1.1698e-06,
                    1.226e-06,
                    1.2821e-06,
                    1.3365e-06,
                    1.3876e-06,
                    1.4372e-06,
                    1.485e-06,
                    1.5312e-06,
                    1.5774e-06,
                    1.6219e-06,
                    1.6632e-06,
                    1.7012e-06,
                    1.7374e-06,
                    1.7721e-06,
                    1.8018e-06,
                    1.8315e-06,
                    1.8596e-06,
                    1.8794e-06,
                    1.8992e-06,
                    1.919e-06,
                    1.9371e-06,
                    1.9569e-06,
                    1.975e-06,
                    1.9949e-06,
                    2.0163e-06,
                    2.0394e-06,
                    2.0641e-06,
                    2.0872e-06,
                    2.112e-06,
                    2.1367e-06,
                    2.1615e-06,
                    2.1846e-06,
                    2.2087e-06,
                    2.2325e-06
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.32e-08,
                    2.805e-08,
                    4.29e-08,
                    6.435e-08,
                    8.58e-08,
                    1.155e-07,
                    1.452e-07,
                    1.848e-07,
                    2.1945e-07,
                    2.574e-07,
                    3.0195e-07,
                    3.4815e-07,
                    3.9435e-07,
                    4.455e-07,
                    4.9665e-07,
                    5.478e-07,
                    6.039e-07,
                    6.6e-07,
                    7.161e-07,
                    7.722e-07,
                    8.283e-07,
                    8.844e-07,
                    9.57e-07,
                    1.028e-06,
                    1.0989e-06,
                    1.1698e-06,
                    1.226e-06,
                    1.2821e-06,
                    1.3365e-06,
                    1.3876e-06,
                    1.4372e-06,
                    1.485e-06,
                    1.5312e-06,
                    1.5774e-06,
                    1.6219e-06,
                    1.6632e-06,
                    1.7012e-06,
                    1.7374e-06,
                    1.7721e-06,
                    1.8018e-06,
                    1.8315e-06,
                    1.8596e-06,
                    1.8794e-06,
                    1.8992e-06,
                    1.919e-06,
                    1.9371e-06,
                    1.9569e-06,
                    1.975e-06,
                    1.9949e-06,
                    2.0163e-06,
                    2.0394e-06,
                    2.0641e-06,
                    2.0872e-06,
                    2.112e-06,
                    2.1367e-06,
                    2.1615e-06,
                    2.1846e-06,
                    2.2087e-06,
                    2.2325e-06
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [
                    1.1424e-10,
                    2.3038e-10,
                    3.4841e-10,
                    4.6834e-10,
                    5.9019e-10,
                    7.1394e-10,
                    8.3961e-10,
                    9.6721e-10,
                    1.0967e-09,
                    1.2282e-09,
                    1.3613e-09,
                    1.4962e-09,
                    1.634e-09,
                    1.7734e-09,
                    1.9146e-09,
                    2.0576e-09,
                    2.2023e-09,
                    2.3487e-09,
                    2.4969e-09,
                    2.6478e-09,
                    2.8046e-09,
                    2.9673e-09,
                    3.136e-09,
                    3.3104e-09,
                    3.4907e-09,
                    3.6766e-09,
                    3.8685e-09,
                    4.0661e-09,
                    4.2695e-09,
                    4.4789e-09,
                    4.6933e-09,
                    4.9128e-09,
                    5.1365e-09,
                    5.3653e-09,
                    5.5995e-09,
                    5.839e-09,
                    6.0838e-09,
                    6.3339e-09,
                    6.5892e-09,
                    6.8491e-09,
                    7.1123e-09,
                    7.3788e-09,
                    7.6484e-09,
                    7.9215e-09,
                    8.1983e-09,
                    8.4786e-09,
                    8.7625e-09,
                    9.05e-09,
                    9.3411e-09,
                    9.6357e-09,
                    9.9323e-09,
                    1.0231e-08,
                    1.0531e-08,
                    1.0833e-08,
                    1.1136e-08,
                    1.1441e-08,
                    1.1748e-08,
                    1.2057e-08,
                    1.2367e-08,
                    1.2679e-08,
                    1.2988e-08,
                    1.3294e-08,
                    1.3596e-08,
                    1.3895e-08,
                    1.4191e-08,
                    1.4483e-08,
                    1.4773e-08,
                    1.5059e-08,
                    1.5342e-08,
                    1.5622e-08,
                    1.5906e-08,
                    1.6196e-08,
                    1.6491e-08,
                    1.6791e-08,
                    1.7096e-08,
                    1.7407e-08,
                    1.7722e-08,
                    1.8042e-08,
                    1.8368e-08,
                    1.8698e-08,
                    1.904e-08,
                    1.9396e-08,
                    1.9765e-08,
                    2.0147e-08,
                    2.0542e-08,
                    2.0949e-08,
                    2.137e-08,
                    2.1804e-08,
                    2.2251e-08,
                    2.2711e-08,
                    2.3184e-08,
                    2.367e-08,
                    2.4169e-08,
                    2.468e-08,
                    2.5204e-08,
                    2.5741e-08,
                    2.6293e-08,
                    2.6859e-08,
                    2.7441e-08,
                    2.8038e-08,
                    2.8665e-08,
                    2.9325e-08,
                    3.0022e-08,
                    3.0758e-08,
                    3.1537e-08,
                    3.236e-08,
                    3.3232e-08,
                    3.4155e-08,
                    3.5131e-08,
                    3.6164e-08,
                    3.732e-08,
                    3.8534e-08,
                    3.9805e-08,
                    4.1133e-08,
                    4.2551e-08,
                    4.4028e-08,
                    4.5569e-08,
                    4.7193e-08,
                    4.8906e-08,
                    5.0628e-08,
                    5.2392e-08,
                    5.4236e-08,
                    5.6155e-08,
                    5.8143e-08,
                    6.0161e-08,
                    6.2016e-08,
                    6.3753e-08,
                    6.5538e-08,
                    6.7369e-08,
                    6.9245e-08,
                    7.1196e-08,
                    7.3199e-08,
                    7.5246e-08,
                    7.7102e-08,
                    7.8999e-08,
                    8.0967e-08,
                    8.3007e-08,
                    8.5101e-08,
                    8.7158e-08,
                    8.9345e-08,
                    9.1589e-08,
                    9.3863e-08,
                    9.6157e-08,
                    9.8393e-08,
                    1.006e-07,
                    1.0298e-07,
                    1.0545e-07,
                    1.0785e-07,
                    1.1018e-07,
                    1.1227e-07,
                    1.1432e-07,
                    1.1639e-07,
                    1.1842e-07,
                    1.2058e-07,
                    1.2257e-07,
                    1.2437e-07,
                    1.2644e-07,
                    1.2875e-07,
                    1.3109e-07,
                    1.3347e-07,
                    1.3587e-07,
                    1.383e-07,
                    1.41e-07,
                    1.4407e-07,
                    1.4721e-07,
                    1.504e-07,
                    1.5359e-07,
                    1.5677e-07,
                    1.6032e-07,
                    1.6423e-07,
                    1.682e-07,
                    1.7205e-07
                ],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [
                    7.9193e-11,
                    1.5985e-10,
                    2.4197e-10,
                    3.2556e-10,
                    4.1063e-10,
                    4.9718e-10,
                    5.8522e-10,
                    6.7475e-10,
                    7.6578e-10,
                    8.5832e-10,
                    9.5221e-10,
                    1.0475e-09,
                    1.1453e-09,
                    1.2445e-09,
                    1.345e-09,
                    1.447e-09,
                    1.5504e-09,
                    1.6552e-09,
                    1.7614e-09,
                    1.87e-09,
                    1.9824e-09,
                    2.0987e-09,
                    2.2189e-09,
                    2.343e-09,
                    2.4707e-09,
                    2.6021e-09,
                    2.7374e-09,
                    2.8764e-09,
                    3.0192e-09,
                    3.1659e-09,
                    3.3158e-09,
                    3.469e-09,
                    3.6245e-09,
                    3.7833e-09,
                    3.9457e-09,
                    4.1115e-09,
                    4.2808e-09,
                    4.4536e-09,
                    4.6297e-09,
                    4.8086e-09,
                    4.9895e-09,
                    5.1726e-09,
                    5.3576e-09,
                    5.5449e-09,
                    5.7346e-09,
                    5.9266e-09,
                    6.1211e-09,
                    6.3179e-09,
                    6.5172e-09,
                    6.7187e-09,
                    6.9214e-09,
                    7.125e-09,
                    7.3297e-09,
                    7.5353e-09,
                    7.7418e-09,
                    7.949e-09,
                    8.1572e-09,
                    8.3664e-09,
                    8.5765e-09,
                    8.7873e-09,
                    8.9961e-09,
                    9.2021e-09,
                    9.4059e-09,
                    9.6072e-09,
                    9.806e-09,
                    1.0003e-08,
                    1.0197e-08,
                    1.0389e-08,
                    1.0578e-08,
                    1.0765e-08,
                    1.0955e-08,
                    1.1148e-08,
                    1.1345e-08,
                    1.1545e-08,
                    1.1749e-08,
                    1.1956e-08,
                    1.2165e-08,
                    1.2379e-08,
                    1.2595e-08,
                    1.2815e-08,
                    1.3042e-08,
                    1.3279e-08,
                    1.3525e-08,
                    1.3779e-08,
                    1.4042e-08,
                    1.4314e-08,
                    1.4595e-08,
                    1.4884e-08,
                    1.5183e-08,
                    1.549e-08,
                    1.5809e-08,
                    1.6137e-08,
                    1.6477e-08,
                    1.6826e-08,
                    1.7186e-08,
                    1.7558e-08,
                    1.7941e-08,
                    1.8337e-08,
                    1.8745e-08,
                    1.9167e-08,
                    1.9612e-08,
                    2.0082e-08,
                    2.0579e-08,
                    2.1106e-08,
                    2.1666e-08,
                    2.2259e-08,
                    2.2889e-08,
                    2.3556e-08,
                    2.4265e-08,
                    2.5016e-08,
                    2.5806e-08,
                    2.6639e-08,
                    2.7515e-08,
                    2.8438e-08,
                    2.9408e-08,
                    3.0426e-08,
                    3.1494e-08,
                    3.2613e-08,
                    3.3783e-08,
                    3.4932e-08,
                    3.609e-08,
                    3.7259e-08,
                    3.8436e-08,
                    3.9613e-08,
                    4.0794e-08,
                    4.1955e-08,
                    4.3098e-08,
                    4.4225e-08,
                    4.5334e-08,
                    4.6424e-08,
                    4.7502e-08,
                    4.857e-08,
                    4.9619e-08,
                    5.0659e-08,
                    5.1703e-08,
                    5.2752e-08,
                    5.381e-08,
                    5.4876e-08,
                    5.5945e-08,
                    5.7093e-08,
                    5.8256e-08,
                    5.9444e-08,
                    6.0646e-08,
                    6.1868e-08,
                    6.3108e-08,
                    6.4387e-08,
                    6.5696e-08,
                    6.7003e-08,
                    6.8321e-08,
                    6.947e-08,
                    7.0752e-08,
                    7.2119e-08,
                    7.3533e-08,
                    7.492e-08,
                    7.621e-08,
                    7.7394e-08,
                    7.884e-08,
                    8.0512e-08,
                    8.2228e-08,
                    8.4062e-08,
                    8.5992e-08,
                    8.8036e-08,
                    9.0418e-08,
                    9.3172e-08,
                    9.6e-08,
                    9.8882e-08,
                    1.0176e-07,
                    1.0461e-07,
                    1.0782e-07,
                    1.1141e-07,
                    1.1504e-07,
                    1.1855e-07
                ],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [
                    3.5051e-11,
                    7.0532e-11,
                    1.0644e-10,
                    1.4279e-10,
                    1.7956e-10,
                    2.1676e-10,
                    2.5439e-10,
                    2.9246e-10,
                    3.3095e-10,
                    3.6987e-10,
                    4.0914e-10,
                    4.4874e-10,
                    4.8869e-10,
                    5.2897e-10,
                    5.696e-10,
                    6.1056e-10,
                    6.5187e-10,
                    6.9352e-10,
                    7.3551e-10,
                    7.7784e-10,
                    8.222e-10,
                    8.686e-10,
                    9.1702e-10,
                    9.6749e-10,
                    1.02e-09,
                    1.0745e-09,
                    1.1311e-09,
                    1.1897e-09,
                    1.2503e-09,
                    1.313e-09,
                    1.3775e-09,
                    1.4438e-09,
                    1.512e-09,
                    1.582e-09,
                    1.6538e-09,
                    1.7275e-09,
                    1.803e-09,
                    1.8803e-09,
                    1.9595e-09,
                    2.0405e-09,
                    2.1227e-09,
                    2.2062e-09,
                    2.2908e-09,
                    2.3766e-09,
                    2.4637e-09,
                    2.5519e-09,
                    2.6414e-09,
                    2.732e-09,
                    2.8239e-09,
                    2.917e-09,
                    3.0109e-09,
                    3.1055e-09,
                    3.201e-09,
                    3.2973e-09,
                    3.3944e-09,
                    3.4922e-09,
                    3.5909e-09,
                    3.6904e-09,
                    3.7907e-09,
                    3.8917e-09,
                    3.992e-09,
                    4.0914e-09,
                    4.19e-09,
                    4.2877e-09,
                    4.3847e-09,
                    4.4807e-09,
                    4.576e-09,
                    4.6704e-09,
                    4.764e-09,
                    4.8568e-09,
                    4.9513e-09,
                    5.0477e-09,
                    5.1458e-09,
                    5.2457e-09,
                    5.3475e-09,
                    5.451e-09,
                    5.5563e-09,
                    5.6635e-09,
                    5.7724e-09,
                    5.8831e-09,
                    5.998e-09,
                    6.1171e-09,
                    6.2404e-09,
                    6.3679e-09,
                    6.4995e-09,
                    6.6354e-09,
                    6.7755e-09,
                    6.9197e-09,
                    7.0681e-09,
                    7.2208e-09,
                    7.3757e-09,
                    7.5328e-09,
                    7.6922e-09,
                    7.8538e-09,
                    8.0177e-09,
                    8.1838e-09,
                    8.3522e-09,
                    8.5228e-09,
                    8.6957e-09,
                    8.8708e-09,
                    9.0531e-09,
                    9.2435e-09,
                    9.4426e-09,
                    9.6515e-09,
                    9.8708e-09,
                    1.0101e-08,
                    1.0344e-08,
                    1.0598e-08,
                    1.0867e-08,
                    1.1149e-08,
                    1.1514e-08,
                    1.1894e-08,
                    1.229e-08,
                    1.2695e-08,
                    1.3144e-08,
                    1.3602e-08,
                    1.4075e-08,
                    1.458e-08,
                    1.5122e-08,
                    1.5697e-08,
                    1.6302e-08,
                    1.6976e-08,
                    1.7719e-08,
                    1.8529e-08,
                    1.9368e-08,
                    2.0062e-08,
                    2.0655e-08,
                    2.1313e-08,
                    2.2035e-08,
                    2.2821e-08,
                    2.3694e-08,
                    2.4629e-08,
                    2.5627e-08,
                    2.6443e-08,
                    2.7295e-08,
                    2.8215e-08,
                    2.9197e-08,
                    3.0226e-08,
                    3.1213e-08,
                    3.2252e-08,
                    3.3333e-08,
                    3.442e-08,
                    3.5511e-08,
                    3.6525e-08,
                    3.7497e-08,
                    3.8588e-08,
                    3.9757e-08,
                    4.0849e-08,
                    4.1862e-08,
                    4.2798e-08,
                    4.3573e-08,
                    4.4269e-08,
                    4.4889e-08,
                    4.5663e-08,
                    4.636e-08,
                    4.6979e-08,
                    4.7603e-08,
                    4.8233e-08,
                    4.8862e-08,
                    4.9409e-08,
                    4.9877e-08,
                    5.0268e-08,
                    5.0581e-08,
                    5.0894e-08,
                    5.1206e-08,
                    5.1519e-08,
                    5.1832e-08,
                    5.2161e-08,
                    5.2491e-08,
                    5.2826e-08,
                    5.3161e-08,
                    5.3504e-08
                ],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [
                    1.1409e-11,
                    2.3046e-11,
                    3.4901e-11,
                    4.6961e-11,
                    5.9209e-11,
                    7.1622e-11,
                    8.4178e-11,
                    9.6846e-11,
                    1.096e-10,
                    1.2239e-10,
                    1.352e-10,
                    1.4804e-10,
                    1.6088e-10,
                    1.7373e-10,
                    1.8659e-10,
                    1.9946e-10,
                    2.1234e-10,
                    2.2523e-10,
                    2.3813e-10,
                    2.5106e-10,
                    2.6421e-10,
                    2.7791e-10,
                    2.9241e-10,
                    3.0788e-10,
                    3.2444e-10,
                    3.421e-10,
                    3.6081e-10,
                    3.8044e-10,
                    4.008e-10,
                    4.2158e-10,
                    4.4262e-10,
                    4.6386e-10,
                    4.8528e-10,
                    5.0684e-10,
                    5.2854e-10,
                    5.5037e-10,
                    5.7232e-10,
                    5.9441e-10,
                    6.1665e-10,
                    6.4014e-10,
                    6.6323e-10,
                    6.8599e-10,
                    7.0848e-10,
                    7.3077e-10,
                    7.5291e-10,
                    7.7497e-10,
                    7.9701e-10,
                    8.1909e-10,
                    8.4126e-10,
                    8.6357e-10,
                    8.8616e-10,
                    9.092e-10,
                    9.3282e-10,
                    9.5714e-10,
                    9.822e-10,
                    1.008e-09,
                    1.0347e-09,
                    1.062e-09,
                    1.09e-09,
                    1.1184e-09,
                    1.1474e-09,
                    1.1767e-09,
                    1.2064e-09,
                    1.2364e-09,
                    1.2669e-09,
                    1.2977e-09,
                    1.3288e-09,
                    1.3604e-09,
                    1.3923e-09,
                    1.4246e-09,
                    1.4574e-09,
                    1.4906e-09,
                    1.5243e-09,
                    1.5586e-09,
                    1.5933e-09,
                    1.6286e-09,
                    1.6643e-09,
                    1.7004e-09,
                    1.737e-09,
                    1.7737e-09,
                    1.8108e-09,
                    1.8481e-09,
                    1.8858e-09,
                    1.9238e-09,
                    1.9622e-09,
                    2.001e-09,
                    2.0403e-09,
                    2.0802e-09,
                    2.1205e-09,
                    2.1615e-09,
                    2.2039e-09,
                    2.2487e-09,
                    2.2969e-09,
                    2.3493e-09,
                    2.4061e-09,
                    2.4675e-09,
                    2.5333e-09,
                    2.6033e-09,
                    2.6767e-09,
                    2.7525e-09,
                    2.8302e-09,
                    2.9096e-09,
                    2.9905e-09,
                    3.0729e-09,
                    3.1567e-09,
                    3.2419e-09,
                    3.3287e-09,
                    3.4172e-09,
                    3.5076e-09,
                    3.6001e-09,
                    3.7022e-09,
                    3.8077e-09,
                    3.9176e-09,
                    4.0325e-09,
                    4.1526e-09,
                    4.2781e-09,
                    4.4086e-09,
                    4.5561e-09,
                    4.7073e-09,
                    4.8602e-09,
                    5.015e-09,
                    5.1713e-09,
                    5.3412e-09,
                    5.5123e-09,
                    5.6843e-09,
                    5.8513e-09,
                    6.0193e-09,
                    6.1942e-09,
                    6.3822e-09,
                    6.5713e-09,
                    6.7618e-09,
                    6.9663e-09,
                    7.1784e-09,
                    7.3802e-09,
                    7.5961e-09,
                    7.8261e-09,
                    8.058e-09,
                    8.2917e-09,
                    8.5332e-09,
                    8.7636e-09,
                    8.9944e-09,
                    9.2257e-09,
                    9.4573e-09,
                    9.7139e-09,
                    9.9584e-09,
                    1.0191e-08,
                    1.0423e-08,
                    1.0643e-08,
                    1.0863e-08,
                    1.1071e-08,
                    1.1292e-08,
                    1.1522e-08,
                    1.1755e-08,
                    1.1986e-08,
                    1.221e-08,
                    1.244e-08,
                    1.2692e-08,
                    1.2933e-08,
                    1.3182e-08,
                    1.3429e-08,
                    1.368e-08,
                    1.3932e-08,
                    1.4185e-08,
                    1.444e-08,
                    1.4695e-08,
                    1.4952e-08,
                    1.5196e-08,
                    1.5441e-08,
                    1.5686e-08,
                    1.5931e-08,
                    1.6177e-08,
                    1.6421e-08
                ],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [
                    6.2874e-12,
                    1.27e-11,
                    1.9234e-11,
                    2.588e-11,
                    3.263e-11,
                    3.9471e-11,
                    4.639e-11,
                    5.3372e-11,
                    6.0398e-11,
                    6.7449e-11,
                    7.4511e-11,
                    8.1583e-11,
                    8.8661e-11,
                    9.5744e-11,
                    1.0283e-10,
                    1.0992e-10,
                    1.1702e-10,
                    1.2412e-10,
                    1.3124e-10,
                    1.3836e-10,
                    1.4561e-10,
                    1.5316e-10,
                    1.6115e-10,
                    1.6967e-10,
                    1.788e-10,
                    1.8853e-10,
                    1.9884e-10,
                    2.0966e-10,
                    2.2088e-10,
                    2.3233e-10,
                    2.4393e-10,
                    2.5563e-10,
                    2.6744e-10,
                    2.7932e-10,
                    2.9128e-10,
                    3.0331e-10,
                    3.1541e-10,
                    3.2758e-10,
                    3.3984e-10,
                    3.5219e-10,
                    3.6465e-10,
                    3.7721e-10,
                    3.8989e-10,
                    4.0267e-10,
                    4.1557e-10,
                    4.286e-10,
                    4.4176e-10,
                    4.5507e-10,
                    4.6852e-10,
                    4.8215e-10,
                    4.9597e-10,
                    5.1001e-10,
                    5.2431e-10,
                    5.3889e-10,
                    5.5377e-10,
                    5.6895e-10,
                    5.8444e-10,
                    6.0024e-10,
                    6.1634e-10,
                    6.3272e-10,
                    6.4937e-10,
                    6.663e-10,
                    6.835e-10,
                    7.0097e-10,
                    7.1872e-10,
                    7.3673e-10,
                    7.5502e-10,
                    7.7359e-10,
                    7.9243e-10,
                    8.1155e-10,
                    8.3096e-10,
                    8.5066e-10,
                    8.7065e-10,
                    8.9095e-10,
                    9.1154e-10,
                    9.3244e-10,
                    9.5362e-10,
                    9.7508e-10,
                    9.9682e-10,
                    1.0188e-09,
                    1.0411e-09,
                    1.0636e-09,
                    1.0866e-09,
                    1.11e-09,
                    1.1338e-09,
                    1.1581e-09,
                    1.1829e-09,
                    1.2084e-09,
                    1.2344e-09,
                    1.261e-09,
                    1.2888e-09,
                    1.3184e-09,
                    1.3505e-09,
                    1.3855e-09,
                    1.4237e-09,
                    1.4652e-09,
                    1.5099e-09,
                    1.5575e-09,
                    1.6076e-09,
                    1.6595e-09,
                    1.7129e-09,
                    1.7674e-09,
                    1.8229e-09,
                    1.8793e-09,
                    1.9366e-09,
                    1.9947e-09,
                    2.0538e-09,
                    2.1139e-09,
                    2.1753e-09,
                    2.2382e-09,
                    2.3034e-09,
                    2.3721e-09,
                    2.4451e-09,
                    2.5231e-09,
                    2.6064e-09,
                    2.6949e-09,
                    2.7886e-09,
                    2.8868e-09,
                    2.9889e-09,
                    3.0927e-09,
                    3.1983e-09,
                    3.3054e-09,
                    3.4138e-09,
                    3.5235e-09,
                    3.634e-09,
                    3.7518e-09,
                    3.8706e-09,
                    3.9963e-09,
                    4.1229e-09,
                    4.2505e-09,
                    4.3796e-09,
                    4.5102e-09,
                    4.6486e-09,
                    4.7889e-09,
                    4.9311e-09,
                    5.075e-09,
                    5.2208e-09,
                    5.3685e-09,
                    5.524e-09,
                    5.6682e-09,
                    5.813e-09,
                    5.9582e-09,
                    6.1038e-09,
                    6.2743e-09,
                    6.4328e-09,
                    6.579e-09,
                    6.7252e-09,
                    6.8591e-09,
                    6.9929e-09,
                    7.1148e-09,
                    7.2497e-09,
                    7.3937e-09,
                    7.5413e-09,
                    7.6861e-09,
                    7.8242e-09,
                    7.9681e-09,
                    8.1088e-09,
                    8.2397e-09,
                    8.3777e-09,
                    8.514e-09,
                    8.6543e-09,
                    8.7959e-09,
                    8.9386e-09,
                    9.0826e-09,
                    9.2274e-09,
                    9.373e-09,
                    9.5067e-09,
                    9.6408e-09,
                    9.7752e-09,
                    9.91e-09,
                    1.0045e-08,
                    1.0178e-08
                ],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": [
                    5.1214e-12,
                    1.0345e-11,
                    1.5667e-11,
                    2.1081e-11,
                    2.6579e-11,
                    3.2151e-11,
                    3.7787e-11,
                    4.3474e-11,
                    4.9197e-11,
                    5.494e-11,
                    6.0693e-11,
                    6.6453e-11,
                    7.2219e-11,
                    7.7988e-11,
                    8.3761e-11,
                    8.9537e-11,
                    9.5318e-11,
                    1.011e-10,
                    1.069e-10,
                    1.127e-10,
                    1.1861e-10,
                    1.2475e-10,
                    1.3126e-10,
                    1.3821e-10,
                    1.4564e-10,
                    1.5357e-10,
                    1.6197e-10,
                    1.7078e-10,
                    1.7992e-10,
                    1.8925e-10,
                    1.9869e-10,
                    2.0823e-10,
                    2.1784e-10,
                    2.2752e-10,
                    2.3726e-10,
                    2.4706e-10,
                    2.5692e-10,
                    2.6683e-10,
                    2.7681e-10,
                    2.8795e-10,
                    2.9858e-10,
                    3.0878e-10,
                    3.1859e-10,
                    3.281e-10,
                    3.3734e-10,
                    3.4637e-10,
                    3.5525e-10,
                    3.6402e-10,
                    3.7274e-10,
                    3.8143e-10,
                    3.902e-10,
                    3.9919e-10,
                    4.0851e-10,
                    4.1824e-10,
                    4.2843e-10,
                    4.3909e-10,
                    4.5022e-10,
                    4.6175e-10,
                    4.7362e-10,
                    4.8572e-10,
                    4.9798e-10,
                    5.1036e-10,
                    5.2286e-10,
                    5.3547e-10,
                    5.4816e-10,
                    5.6094e-10,
                    5.7381e-10,
                    5.8678e-10,
                    5.9986e-10,
                    6.1305e-10,
                    6.264e-10,
                    6.3993e-10,
                    6.5367e-10,
                    6.6762e-10,
                    6.8178e-10,
                    6.9614e-10,
                    7.1068e-10,
                    7.2536e-10,
                    7.4014e-10,
                    7.5494e-10,
                    7.6973e-10,
                    7.8449e-10,
                    7.992e-10,
                    8.1385e-10,
                    8.2843e-10,
                    8.4294e-10,
                    8.5739e-10,
                    8.7179e-10,
                    8.8616e-10,
                    9.0052e-10,
                    9.151e-10,
                    9.3031e-10,
                    9.4645e-10,
                    9.6375e-10,
                    9.8233e-10,
                    1.0022e-09,
                    1.0234e-09,
                    1.0458e-09,
                    1.0691e-09,
                    1.093e-09,
                    1.1174e-09,
                    1.1422e-09,
                    1.1676e-09,
                    1.1935e-09,
                    1.2201e-09,
                    1.2472e-09,
                    1.2749e-09,
                    1.3032e-09,
                    1.3322e-09,
                    1.3619e-09,
                    1.3987e-09,
                    1.4356e-09,
                    1.4725e-09,
                    1.5094e-09,
                    1.5463e-09,
                    1.5832e-09,
                    1.62e-09,
                    1.6692e-09,
                    1.7184e-09,
                    1.7676e-09,
                    1.8167e-09,
                    1.8659e-09,
                    1.9274e-09,
                    1.9889e-09,
                    2.0503e-09,
                    2.0995e-09,
                    2.1487e-09,
                    2.1979e-09,
                    2.2593e-09,
                    2.3208e-09,
                    2.3823e-09,
                    2.456e-09,
                    2.5298e-09,
                    2.5913e-09,
                    2.665e-09,
                    2.7511e-09,
                    2.8371e-09,
                    2.9232e-09,
                    3.0093e-09,
                    3.0953e-09,
                    3.1814e-09,
                    3.2674e-09,
                    3.3535e-09,
                    3.4395e-09,
                    3.5256e-09,
                    3.6117e-09,
                    3.6977e-09,
                    3.7838e-09,
                    3.8698e-09,
                    3.9559e-09,
                    4.0419e-09,
                    4.128e-09,
                    4.2141e-09,
                    4.3001e-09,
                    4.3862e-09,
                    4.4722e-09,
                    4.5829e-09,
                    4.6935e-09,
                    4.8042e-09,
                    4.9148e-09,
                    5.0255e-09,
                    5.1361e-09,
                    5.2467e-09,
                    5.3574e-09,
                    5.468e-09,
                    5.5787e-09,
                    5.6893e-09,
                    5.8e-09,
                    5.9106e-09,
                    6.0213e-09,
                    6.1319e-09,
                    6.2429e-09
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            166.90957,
                            -0.53229
                        ],
                        [
                            166.94904,
                            -0.54606
                        ],
                        [
                            166.95676,
                            -0.51132
                        ],
                        [
                            166.93451,
                            -0.50267
                        ],
                        [
                            166.90957,
                            -0.53229
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "NPL",
                "Country": "Nepal",
                "Total_3GHG": 0.13,
                "Total_3GHG_timeseries": [
                    2.955e-06,
                    5.8605e-06,
                    8.7427e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021
                ],
                "Fossil_3GHG": 0.04,
                "Fossil_3GHG_timeseries": [
                    2.4281e-07,
                    4.8631e-07,
                    7.305e-07,
                    9.7539e-07,
                    1.221e-06,
                    1.4672e-06,
                    1.7141e-06,
                    1.9617e-06,
                    2.2099e-06,
                    2.4587e-06,
                    2.7079e-06,
                    2.9574e-06,
                    3.2074e-06,
                    3.4577e-06,
                    3.7084e-06,
                    3.9595e-06,
                    4.211e-06,
                    4.4629e-06,
                    4.7152e-06,
                    4.9679e-06,
                    5.2241e-06,
                    5.4838e-06,
                    5.7472e-06,
                    6.0145e-06,
                    6.2858e-06,
                    6.5611e-06,
                    6.8404e-06,
                    7.1235e-06,
                    7.4103e-06,
                    7.7007e-06,
                    7.9946e-06,
                    8.2918e-06,
                    8.5924e-06,
                    8.8965e-06,
                    9.2039e-06,
                    9.5147e-06,
                    9.8289e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Land_3GHG": 0.3,
                "Land_3GHG_timeseries": [
                    2.7122e-06,
                    5.3742e-06,
                    8.0122e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017
                ],
                "Total_CO2": 0.07,
                "Total_CO2_timeseries": [
                    1.3062e-06,
                    2.5535e-06,
                    3.7684e-06,
                    4.9561e-06,
                    6.1185e-06,
                    7.2602e-06,
                    8.3836e-06,
                    9.5033e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008
                ],
                "Fossil_CO2": 0.01,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.155e-08,
                    2.475e-08,
                    3.795e-08,
                    5.445e-08,
                    7.26e-08,
                    9.24e-08,
                    1.1385e-07,
                    1.386e-07,
                    1.65e-07,
                    1.947e-07,
                    2.31e-07,
                    2.673e-07,
                    3.069e-07,
                    3.5145e-07,
                    4.191e-07,
                    4.9995e-07,
                    5.8575e-07,
                    6.8145e-07,
                    7.953e-07,
                    9.7515e-07,
                    1.0774e-06,
                    1.1666e-06,
                    1.287e-06,
                    1.4768e-06,
                    1.6681e-06,
                    1.8265e-06,
                    1.9534e-06,
                    2.1049e-06,
                    2.253e-06,
                    2.4838e-06,
                    2.7275e-06,
                    2.9316e-06,
                    3.1308e-06,
                    3.3526e-06,
                    3.6684e-06,
                    3.9729e-06,
                    4.2867e-06,
                    4.6743e-06,
                    5.1138e-06,
                    5.5162e-06,
                    5.8411e-06,
                    6.3033e-06,
                    6.8585e-06,
                    7.4878e-06,
                    8.217e-06,
                    9.2568e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CO2": 0.21,
                "Land_CO2_timeseries": [
                    1.3062e-06,
                    2.5535e-06,
                    3.7684e-06,
                    4.9561e-06,
                    6.1185e-06,
                    7.2602e-06,
                    8.3836e-06,
                    9.5033e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Total_CH4": 0.27,
                "Total_CH4_timeseries": [
                    1.3535e-06,
                    2.7105e-06,
                    4.071e-06,
                    5.4351e-06,
                    6.8027e-06,
                    8.1738e-06,
                    9.5486e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011
                ],
                "Fossil_CH4": 0.11,
                "Fossil_CH4_timeseries": [
                    2.2321e-07,
                    4.4683e-07,
                    6.7088e-07,
                    8.9536e-07,
                    1.1203e-06,
                    1.3457e-06,
                    1.5715e-06,
                    1.7977e-06,
                    2.0245e-06,
                    2.2517e-06,
                    2.4792e-06,
                    2.7069e-06,
                    2.9348e-06,
                    3.163e-06,
                    3.3915e-06,
                    3.6202e-06,
                    3.8492e-06,
                    4.0785e-06,
                    4.3081e-06,
                    4.538e-06,
                    4.771e-06,
                    5.0071e-06,
                    5.2462e-06,
                    5.4885e-06,
                    5.7339e-06,
                    5.9823e-06,
                    6.2339e-06,
                    6.4886e-06,
                    6.7465e-06,
                    7.0075e-06,
                    7.2716e-06,
                    7.5388e-06,
                    7.8093e-06,
                    8.0829e-06,
                    8.3597e-06,
                    8.6397e-06,
                    8.9228e-06,
                    9.2092e-06,
                    9.4987e-06,
                    9.7915e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Land_CH4": 0.53,
                "Land_CH4_timeseries": [
                    1.1303e-06,
                    2.2636e-06,
                    3.4001e-06,
                    4.5397e-06,
                    5.6824e-06,
                    6.8282e-06,
                    7.9771e-06,
                    9.1291e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008
                ],
                "Total_N2O": 0.21,
                "Total_N2O_timeseries": [
                    2.9539e-07,
                    5.9658e-07,
                    9.0331e-07,
                    1.2152e-06,
                    1.532e-06,
                    1.8529e-06,
                    2.1775e-06,
                    2.505e-06,
                    2.8347e-06,
                    3.1656e-06,
                    3.4971e-06,
                    3.8291e-06,
                    4.1616e-06,
                    4.4944e-06,
                    4.8275e-06,
                    5.1609e-06,
                    5.4947e-06,
                    5.8289e-06,
                    6.1636e-06,
                    6.4991e-06,
                    6.84e-06,
                    7.1947e-06,
                    7.5695e-06,
                    7.9687e-06,
                    8.3948e-06,
                    8.8485e-06,
                    9.3285e-06,
                    9.8315e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_N2O": 0.12,
                "Fossil_N2O_timeseries": [
                    1.9603e-08,
                    3.948e-08,
                    5.9623e-08,
                    8.0023e-08,
                    1.0067e-07,
                    1.2155e-07,
                    1.4264e-07,
                    1.6392e-07,
                    1.8538e-07,
                    2.0698e-07,
                    2.2871e-07,
                    2.5058e-07,
                    2.7256e-07,
                    2.9467e-07,
                    3.169e-07,
                    3.3926e-07,
                    3.6173e-07,
                    3.8433e-07,
                    4.0706e-07,
                    4.2993e-07,
                    4.5305e-07,
                    4.7667e-07,
                    5.0096e-07,
                    5.2604e-07,
                    5.5198e-07,
                    5.7879e-07,
                    6.0644e-07,
                    6.3484e-07,
                    6.6385e-07,
                    6.9327e-07,
                    7.2299e-07,
                    7.5296e-07,
                    7.8316e-07,
                    8.1359e-07,
                    8.4423e-07,
                    8.7507e-07,
                    9.0611e-07,
                    9.3736e-07,
                    9.6883e-07,
                    1.002e-06,
                    1.0357e-06,
                    1.07e-06,
                    1.105e-06,
                    1.1406e-06,
                    1.177e-06,
                    1.2141e-06,
                    1.252e-06,
                    1.2908e-06,
                    1.3303e-06,
                    1.3707e-06,
                    1.4121e-06,
                    1.4545e-06,
                    1.4981e-06,
                    1.5429e-06,
                    1.5889e-06,
                    1.6362e-06,
                    1.6847e-06,
                    1.7344e-06,
                    1.785e-06,
                    1.8366e-06,
                    1.8889e-06,
                    1.9419e-06,
                    1.9957e-06,
                    2.0501e-06,
                    2.1052e-06,
                    2.1609e-06,
                    2.2172e-06,
                    2.2741e-06,
                    2.3316e-06,
                    2.3897e-06,
                    2.4484e-06,
                    2.5076e-06,
                    2.5674e-06,
                    2.6276e-06,
                    2.6884e-06,
                    2.7496e-06,
                    2.8114e-06,
                    2.8738e-06,
                    2.9368e-06,
                    3.0005e-06,
                    3.065e-06,
                    3.1305e-06,
                    3.1972e-06,
                    3.2651e-06,
                    3.3344e-06,
                    3.4052e-06,
                    3.4775e-06,
                    3.5512e-06,
                    3.6263e-06,
                    3.7028e-06,
                    3.7808e-06,
                    3.8604e-06,
                    3.942e-06,
                    4.0256e-06,
                    4.1114e-06,
                    4.1995e-06,
                    4.29e-06,
                    4.3828e-06,
                    4.4781e-06,
                    4.5757e-06,
                    4.6761e-06,
                    4.7803e-06,
                    4.8889e-06,
                    5.0024e-06,
                    5.1211e-06,
                    5.2453e-06,
                    5.3748e-06,
                    5.5093e-06,
                    5.6485e-06,
                    5.7917e-06,
                    5.9382e-06,
                    6.0875e-06,
                    6.2394e-06,
                    6.3939e-06,
                    6.551e-06,
                    6.7112e-06,
                    6.8749e-06,
                    7.0428e-06,
                    7.2161e-06,
                    7.4052e-06,
                    7.5961e-06,
                    7.7904e-06,
                    7.9915e-06,
                    8.1969e-06,
                    8.4059e-06,
                    8.6204e-06,
                    8.8402e-06,
                    9.0661e-06,
                    9.2967e-06,
                    9.5366e-06,
                    9.782e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.25,
                "Land_N2O_timeseries": [
                    2.7579e-07,
                    5.571e-07,
                    8.4368e-07,
                    1.1352e-06,
                    1.4313e-06,
                    1.7314e-06,
                    2.0349e-06,
                    2.3411e-06,
                    2.6493e-06,
                    2.9586e-06,
                    3.2684e-06,
                    3.5786e-06,
                    3.889e-06,
                    4.1997e-06,
                    4.5106e-06,
                    4.8217e-06,
                    5.133e-06,
                    5.4446e-06,
                    5.7566e-06,
                    6.0691e-06,
                    6.387e-06,
                    6.7181e-06,
                    7.0685e-06,
                    7.4426e-06,
                    7.8429e-06,
                    8.2697e-06,
                    8.7221e-06,
                    9.1967e-06,
                    9.6887e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            81.03692,
                            30.20276
                        ],
                        [
                            80.96029,
                            30.18192
                        ],
                        [
                            80.90351,
                            30.21548
                        ],
                        [
                            80.87773,
                            30.12955
                        ],
                        [
                            80.77384,
                            30.05681
                        ],
                        [
                            80.67405,
                            29.95683
                        ],
                        [
                            80.60076,
                            29.95564
                        ],
                        [
                            80.55445,
                            29.85299
                        ],
                        [
                            80.49437,
                            29.79686
                        ],
                        [
                            80.43502,
                            29.80291
                        ],
                        [
                            80.3682,
                            29.74743
                        ],
                        [
                            80.41008,
                            29.59525
                        ],
                        [
                            80.34624,
                            29.51303
                        ],
                        [
                            80.25097,
                            29.4476
                        ],
                        [
                            80.28358,
                            29.3443
                        ],
                        [
                            80.31777,
                            29.31462
                        ],
                        [
                            80.26927,
                            29.14262
                        ],
                        [
                            80.18332,
                            29.13314
                        ],
                        [
                            80.14567,
                            29.10014
                        ],
                        [
                            80.13231,
                            29.00209
                        ],
                        [
                            80.06199,
                            28.91799
                        ],
                        [
                            80.06655,
                            28.84376
                        ],
                        [
                            80.12216,
                            28.82576
                        ],
                        [
                            80.26168,
                            28.72199
                        ],
                        [
                            80.31699,
                            28.6971
                        ],
                        [
                            80.37673,
                            28.62908
                        ],
                        [
                            80.42209,
                            28.63603
                        ],
                        [
                            80.47359,
                            28.58496
                        ],
                        [
                            80.52291,
                            28.583
                        ],
                        [
                            80.50773,
                            28.66471
                        ],
                        [
                            80.5866,
                            28.67964
                        ],
                        [
                            80.66778,
                            28.63918
                        ],
                        [
                            80.71299,
                            28.57163
                        ],
                        [
                            81.02542,
                            28.41636
                        ],
                        [
                            81.20151,
                            28.36913
                        ],
                        [
                            81.2386,
                            28.28314
                        ],
                        [
                            81.32025,
                            28.19655
                        ],
                        [
                            81.44689,
                            28.15854
                        ],
                        [
                            81.48594,
                            28.08188
                        ],
                        [
                            81.65139,
                            27.99274
                        ],
                        [
                            81.70319,
                            27.98519
                        ],
                        [
                            81.89168,
                            27.85606
                        ],
                        [
                            81.97295,
                            27.92588
                        ],
                        [
                            82.06514,
                            27.92151
                        ],
                        [
                            82.12363,
                            27.86588
                        ],
                        [
                            82.20487,
                            27.84424
                        ],
                        [
                            82.40033,
                            27.70875
                        ],
                        [
                            82.47542,
                            27.68091
                        ],
                        [
                            82.70656,
                            27.7171
                        ],
                        [
                            82.75516,
                            27.58746
                        ],
                        [
                            82.7645,
                            27.50264
                        ],
                        [
                            82.92648,
                            27.50043
                        ],
                        [
                            83.03172,
                            27.45036
                        ],
                        [
                            83.18442,
                            27.45376
                        ],
                        [
                            83.2688,
                            27.38737
                        ],
                        [
                            83.30533,
                            27.33432
                        ],
                        [
                            83.3571,
                            27.34228
                        ],
                        [
                            83.40808,
                            27.41341
                        ],
                        [
                            83.39591,
                            27.47811
                        ],
                        [
                            83.61992,
                            27.46791
                        ],
                        [
                            83.82566,
                            27.37681
                        ],
                        [
                            83.83782,
                            27.42532
                        ],
                        [
                            83.93764,
                            27.45098
                        ],
                        [
                            84.05591,
                            27.44692
                        ],
                        [
                            84.10601,
                            27.51742
                        ],
                        [
                            84.25601,
                            27.44604
                        ],
                        [
                            84.27948,
                            27.39664
                        ],
                        [
                            84.62416,
                            27.33512
                        ],
                        [
                            84.68658,
                            27.23517
                        ],
                        [
                            84.67554,
                            27.10011
                        ],
                        [
                            84.64931,
                            27.04635
                        ],
                        [
                            84.79471,
                            26.99769
                        ],
                        [
                            84.82873,
                            27.02105
                        ],
                        [
                            84.89206,
                            26.97089
                        ],
                        [
                            84.95951,
                            26.9597
                        ],
                        [
                            84.97306,
                            26.91913
                        ],
                        [
                            85.10469,
                            26.87175
                        ],
                        [
                            85.18756,
                            26.86956
                        ],
                        [
                            85.17866,
                            26.80845
                        ],
                        [
                            85.21178,
                            26.76217
                        ],
                        [
                            85.33434,
                            26.74525
                        ],
                        [
                            85.40707,
                            26.79204
                        ],
                        [
                            85.45639,
                            26.78591
                        ],
                        [
                            85.57876,
                            26.85902
                        ],
                        [
                            85.62708,
                            26.87137
                        ],
                        [
                            85.7052,
                            26.83555
                        ],
                        [
                            85.73784,
                            26.79316
                        ],
                        [
                            85.73992,
                            26.65338
                        ],
                        [
                            85.85364,
                            26.60885
                        ],
                        [
                            85.86531,
                            26.57233
                        ],
                        [
                            86.03611,
                            26.66537
                        ],
                        [
                            86.23538,
                            26.59385
                        ],
                        [
                            86.34139,
                            26.61893
                        ],
                        [
                            86.50106,
                            26.54365
                        ],
                        [
                            86.57604,
                            26.49408
                        ],
                        [
                            86.73287,
                            26.42497
                        ],
                        [
                            86.76798,
                            26.46043
                        ],
                        [
                            86.8416,
                            26.44348
                        ],
                        [
                            87.01631,
                            26.53267
                        ],
                        [
                            87.07277,
                            26.58398
                        ],
                        [
                            87.0931,
                            26.45497
                        ],
                        [
                            87.15665,
                            26.40741
                        ],
                        [
                            87.25028,
                            26.41315
                        ],
                        [
                            87.27042,
                            26.37499
                        ],
                        [
                            87.35686,
                            26.35944
                        ],
                        [
                            87.36923,
                            26.4056
                        ],
                        [
                            87.46401,
                            26.4391
                        ],
                        [
                            87.60649,
                            26.38129
                        ],
                        [
                            87.68182,
                            26.43249
                        ],
                        [
                            87.7653,
                            26.4083
                        ],
                        [
                            87.79065,
                            26.46553
                        ],
                        [
                            87.91829,
                            26.42943
                        ],
                        [
                            87.99751,
                            26.3648
                        ],
                        [
                            88.09275,
                            26.42881
                        ],
                        [
                            88.09621,
                            26.51092
                        ],
                        [
                            88.16494,
                            26.64486
                        ],
                        [
                            88.18828,
                            26.77067
                        ],
                        [
                            88.17245,
                            26.86448
                        ],
                        [
                            88.08052,
                            27.03332
                        ],
                        [
                            88.0394,
                            27.03639
                        ],
                        [
                            87.99673,
                            27.10381
                        ],
                        [
                            88.04424,
                            27.37069
                        ],
                        [
                            88.07433,
                            27.43072
                        ],
                        [
                            88.04492,
                            27.48492
                        ],
                        [
                            88.08584,
                            27.59103
                        ],
                        [
                            88.15268,
                            27.69201
                        ],
                        [
                            88.19502,
                            27.79003
                        ],
                        [
                            88.1968,
                            27.85301
                        ],
                        [
                            88.13508,
                            27.88193
                        ],
                        [
                            88.03365,
                            27.90253
                        ],
                        [
                            87.97995,
                            27.89006
                        ],
                        [
                            87.88091,
                            27.91292
                        ],
                        [
                            87.83413,
                            27.94953
                        ],
                        [
                            87.72171,
                            27.8083
                        ],
                        [
                            87.565,
                            27.8658
                        ],
                        [
                            87.45366,
                            27.82569
                        ],
                        [
                            87.42144,
                            27.86075
                        ],
                        [
                            87.35394,
                            27.82771
                        ],
                        [
                            87.29195,
                            27.84432
                        ],
                        [
                            87.2235,
                            27.81908
                        ],
                        [
                            87.11905,
                            27.84265
                        ],
                        [
                            87.03496,
                            27.94683
                        ],
                        [
                            86.93646,
                            27.96023
                        ],
                        [
                            86.85978,
                            28.02443
                        ],
                        [
                            86.78418,
                            28.02574
                        ],
                        [
                            86.70718,
                            28.1035
                        ],
                        [
                            86.64494,
                            28.07482
                        ],
                        [
                            86.56661,
                            28.10084
                        ],
                        [
                            86.51206,
                            27.96134
                        ],
                        [
                            86.4502,
                            27.91571
                        ],
                        [
                            86.23716,
                            27.97933
                        ],
                        [
                            86.20518,
                            28.01094
                        ],
                        [
                            86.20882,
                            28.10054
                        ],
                        [
                            86.17561,
                            28.15365
                        ],
                        [
                            86.08237,
                            28.08526
                        ],
                        [
                            86.08312,
                            28.01552
                        ],
                        [
                            86.12114,
                            27.93256
                        ],
                        [
                            86.04232,
                            27.9031
                        ],
                        [
                            85.95141,
                            27.94127
                        ],
                        [
                            85.97096,
                            27.99499
                        ],
                        [
                            85.90238,
                            28.05492
                        ],
                        [
                            85.84964,
                            28.17627
                        ],
                        [
                            85.75413,
                            28.22924
                        ],
                        [
                            85.72378,
                            28.35511
                        ],
                        [
                            85.68356,
                            28.37685
                        ],
                        [
                            85.64613,
                            28.28667
                        ],
                        [
                            85.49725,
                            28.33704
                        ],
                        [
                            85.42305,
                            28.33075
                        ],
                        [
                            85.37899,
                            28.28707
                        ],
                        [
                            85.24506,
                            28.28921
                        ],
                        [
                            85.20708,
                            28.33645
                        ],
                        [
                            85.12415,
                            28.33703
                        ],
                        [
                            85.10815,
                            28.46589
                        ],
                        [
                            85.18545,
                            28.54825
                        ],
                        [
                            85.19237,
                            28.62083
                        ],
                        [
                            85.11638,
                            28.68107
                        ],
                        [
                            85.05808,
                            28.67606
                        ],
                        [
                            84.98678,
                            28.59795
                        ],
                        [
                            84.85378,
                            28.57455
                        ],
                        [
                            84.70166,
                            28.6356
                        ],
                        [
                            84.69621,
                            28.67197
                        ],
                        [
                            84.59896,
                            28.73564
                        ],
                        [
                            84.51342,
                            28.71935
                        ],
                        [
                            84.42096,
                            28.74032
                        ],
                        [
                            84.43145,
                            28.81951
                        ],
                        [
                            84.38175,
                            28.86376
                        ],
                        [
                            84.22563,
                            28.90258
                        ],
                        [
                            84.24609,
                            29.02809
                        ],
                        [
                            84.19063,
                            29.05294
                        ],
                        [
                            84.20217,
                            29.12116
                        ],
                        [
                            84.103,
                            29.29472
                        ],
                        [
                            83.99893,
                            29.29877
                        ],
                        [
                            83.91127,
                            29.32597
                        ],
                        [
                            83.82047,
                            29.29765
                        ],
                        [
                            83.7934,
                            29.25236
                        ],
                        [
                            83.71431,
                            29.2414
                        ],
                        [
                            83.63266,
                            29.1686
                        ],
                        [
                            83.52457,
                            29.22497
                        ],
                        [
                            83.46799,
                            29.28527
                        ],
                        [
                            83.32283,
                            29.50387
                        ],
                        [
                            83.27522,
                            29.50948
                        ],
                        [
                            83.26425,
                            29.57274
                        ],
                        [
                            83.12261,
                            29.62486
                        ],
                        [
                            83.08015,
                            29.60989
                        ],
                        [
                            82.94217,
                            29.70995
                        ],
                        [
                            82.82927,
                            29.69197
                        ],
                        [
                            82.76966,
                            29.73285
                        ],
                        [
                            82.70503,
                            29.84736
                        ],
                        [
                            82.6455,
                            29.83496
                        ],
                        [
                            82.55601,
                            29.95888
                        ],
                        [
                            82.50775,
                            29.95172
                        ],
                        [
                            82.24629,
                            30.07308
                        ],
                        [
                            82.17616,
                            30.07222
                        ],
                        [
                            82.20469,
                            30.15416
                        ],
                        [
                            82.10819,
                            30.23483
                        ],
                        [
                            82.12777,
                            30.30765
                        ],
                        [
                            82.07885,
                            30.35374
                        ],
                        [
                            81.99337,
                            30.32547
                        ],
                        [
                            81.86718,
                            30.37546
                        ],
                        [
                            81.75055,
                            30.39066
                        ],
                        [
                            81.6295,
                            30.44776
                        ],
                        [
                            81.56417,
                            30.43032
                        ],
                        [
                            81.55058,
                            30.37335
                        ],
                        [
                            81.41614,
                            30.42206
                        ],
                        [
                            81.39789,
                            30.32482
                        ],
                        [
                            81.41595,
                            30.27557
                        ],
                        [
                            81.39477,
                            30.20938
                        ],
                        [
                            81.33199,
                            30.1561
                        ],
                        [
                            81.22605,
                            30.00953
                        ],
                        [
                            81.13146,
                            30.01886
                        ],
                        [
                            81.09701,
                            30.05094
                        ],
                        [
                            81.08057,
                            30.15108
                        ],
                        [
                            81.03692,
                            30.20276
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "NLD",
                "Country": "Netherlands",
                "Total_3GHG": 0.46,
                "Total_3GHG_timeseries": [
                    7.0336e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0055,
                    0.0056,
                    0.0057,
                    0.0058,
                    0.0059,
                    0.006,
                    0.0061,
                    0.0062,
                    0.0062,
                    0.0063,
                    0.0064,
                    0.0065,
                    0.0065,
                    0.0066,
                    0.0067,
                    0.0067,
                    0.0068,
                    0.0069,
                    0.0069,
                    0.007,
                    0.007,
                    0.0071,
                    0.0072,
                    0.0072,
                    0.0073,
                    0.0073,
                    0.0074,
                    0.0074,
                    0.0075,
                    0.0075,
                    0.0076
                ],
                "Fossil_3GHG": 0.6,
                "Fossil_3GHG_timeseries": [
                    3.2859e-06,
                    6.9517e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.005,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0053,
                    0.0054,
                    0.0055,
                    0.0055,
                    0.0056,
                    0.0057,
                    0.0057,
                    0.0058,
                    0.0058,
                    0.0059,
                    0.0059,
                    0.006,
                    0.006,
                    0.0061,
                    0.0061,
                    0.0062,
                    0.0062,
                    0.0063,
                    0.0063
                ],
                "Land_3GHG": 0.22,
                "Land_3GHG_timeseries": [
                    3.7477e-06,
                    7.4135e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013
                ],
                "Total_CO2": 0.51,
                "Total_CO2_timeseries": [
                    3.9695e-06,
                    8.1398e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0055,
                    0.0055,
                    0.0056,
                    0.0057,
                    0.0057,
                    0.0058
                ],
                "Fossil_CO2": 0.7,
                "Fossil_CO2_timeseries": [
                    1.4041e-06,
                    3.0987e-06,
                    4.9764e-06,
                    7.6544e-06,
                    9.7482e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0052,
                    0.0053,
                    0.0053,
                    0.0054
                ],
                "Land_CO2": 0.11,
                "Land_CO2_timeseries": [
                    2.5654e-06,
                    5.0411e-06,
                    7.6549e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Total_CH4": 0.3,
                "Total_CH4_timeseries": [
                    2.7146e-06,
                    5.5208e-06,
                    8.3856e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0012
                ],
                "Fossil_CH4": 0.25,
                "Fossil_CH4_timeseries": [
                    1.7323e-06,
                    3.5525e-06,
                    5.4273e-06,
                    7.4404e-06,
                    9.3707e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0006
                ],
                "Land_CH4": 0.37,
                "Land_CH4_timeseries": [
                    9.823e-07,
                    1.9684e-06,
                    2.9582e-06,
                    3.9518e-06,
                    4.9493e-06,
                    5.9504e-06,
                    6.9554e-06,
                    7.9641e-06,
                    8.9766e-06,
                    9.9929e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006
                ],
                "Total_N2O": 0.65,
                "Total_N2O_timeseries": [
                    3.4943e-07,
                    7.0458e-07,
                    1.0653e-06,
                    1.4313e-06,
                    1.8022e-06,
                    2.1776e-06,
                    2.557e-06,
                    2.9399e-06,
                    3.3256e-06,
                    3.7135e-06,
                    4.1029e-06,
                    4.494e-06,
                    4.8865e-06,
                    5.2804e-06,
                    5.6757e-06,
                    6.0724e-06,
                    6.4705e-06,
                    6.87e-06,
                    7.2712e-06,
                    7.674e-06,
                    8.0824e-06,
                    8.5028e-06,
                    8.9402e-06,
                    9.3982e-06,
                    9.8788e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Fossil_N2O": 1.1,
                "Fossil_N2O_timeseries": [
                    1.4942e-07,
                    3.0057e-07,
                    4.5343e-07,
                    6.0797e-07,
                    7.6416e-07,
                    9.2194e-07,
                    1.0813e-06,
                    1.2421e-06,
                    1.4043e-06,
                    1.5678e-06,
                    1.7326e-06,
                    1.8987e-06,
                    2.0661e-06,
                    2.2347e-06,
                    2.4045e-06,
                    2.5756e-06,
                    2.7479e-06,
                    2.9215e-06,
                    3.0964e-06,
                    3.2725e-06,
                    3.4504e-06,
                    3.6307e-06,
                    3.814e-06,
                    4.0007e-06,
                    4.191e-06,
                    4.3849e-06,
                    4.5824e-06,
                    4.7832e-06,
                    4.9868e-06,
                    5.1926e-06,
                    5.4001e-06,
                    5.6094e-06,
                    5.8202e-06,
                    6.0326e-06,
                    6.2466e-06,
                    6.462e-06,
                    6.679e-06,
                    6.8975e-06,
                    7.1175e-06,
                    7.3441e-06,
                    7.5735e-06,
                    7.8058e-06,
                    8.0412e-06,
                    8.2798e-06,
                    8.5217e-06,
                    8.7669e-06,
                    9.0156e-06,
                    9.2679e-06,
                    9.5239e-06,
                    9.7837e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003
                ],
                "Land_N2O": 0.48,
                "Land_N2O_timeseries": [
                    2.0001e-07,
                    4.0402e-07,
                    6.1185e-07,
                    8.2328e-07,
                    1.038e-06,
                    1.2556e-06,
                    1.4757e-06,
                    1.6978e-06,
                    1.9213e-06,
                    2.1456e-06,
                    2.3703e-06,
                    2.5952e-06,
                    2.8204e-06,
                    3.0457e-06,
                    3.2712e-06,
                    3.4968e-06,
                    3.7225e-06,
                    3.9485e-06,
                    4.1748e-06,
                    4.4015e-06,
                    4.632e-06,
                    4.8721e-06,
                    5.1262e-06,
                    5.3975e-06,
                    5.6878e-06,
                    5.9974e-06,
                    6.3254e-06,
                    6.6696e-06,
                    7.0264e-06,
                    7.3909e-06,
                    7.7596e-06,
                    8.132e-06,
                    8.5075e-06,
                    8.8855e-06,
                    9.266e-06,
                    9.6486e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                7.20894,
                                53.24306
                            ],
                            [
                                7.10454,
                                53.25267
                            ],
                            [
                                7.08459,
                                53.29481
                            ],
                            [
                                6.93247,
                                53.32719
                            ],
                            [
                                6.81673,
                                53.46251
                            ],
                            [
                                6.65825,
                                53.45742
                            ],
                            [
                                6.36694,
                                53.41526
                            ],
                            [
                                6.01561,
                                53.40348
                            ],
                            [
                                5.88345,
                                53.38497
                            ],
                            [
                                5.58552,
                                53.30039
                            ],
                            [
                                5.43696,
                                53.21016
                            ],
                            [
                                5.4082,
                                53.13169
                            ],
                            [
                                5.04155,
                                52.93351
                            ],
                            [
                                4.87432,
                                52.88985
                            ],
                            [
                                4.73366,
                                52.96242
                            ],
                            [
                                4.6396,
                                52.72812
                            ],
                            [
                                4.60876,
                                52.5664
                            ],
                            [
                                4.55119,
                                52.41584
                            ],
                            [
                                4.44524,
                                52.26425
                            ],
                            [
                                4.36557,
                                52.17865
                            ],
                            [
                                4.12779,
                                52.00054
                            ],
                            [
                                3.98339,
                                51.98384
                            ],
                            [
                                3.98234,
                                51.92443
                            ],
                            [
                                4.05451,
                                51.91556
                            ],
                            [
                                4.03296,
                                51.82643
                            ],
                            [
                                3.95924,
                                51.84222
                            ],
                            [
                                3.86772,
                                51.81788
                            ],
                            [
                                3.81321,
                                51.69565
                            ],
                            [
                                3.89236,
                                51.63337
                            ],
                            [
                                3.97141,
                                51.61449
                            ],
                            [
                                4.07361,
                                51.52775
                            ],
                            [
                                4.16377,
                                51.52233
                            ],
                            [
                                4.22252,
                                51.43877
                            ],
                            [
                                4.13322,
                                51.43269
                            ],
                            [
                                4.05231,
                                51.50245
                            ],
                            [
                                3.94018,
                                51.52666
                            ],
                            [
                                3.8741,
                                51.59111
                            ],
                            [
                                3.55602,
                                51.58944
                            ],
                            [
                                3.43373,
                                51.5283
                            ],
                            [
                                3.57406,
                                51.43965
                            ],
                            [
                                3.66157,
                                51.45799
                            ],
                            [
                                3.81631,
                                51.38499
                            ],
                            [
                                3.89919,
                                51.39455
                            ],
                            [
                                3.97545,
                                51.46115
                            ],
                            [
                                4.07919,
                                51.40784
                            ],
                            [
                                4.24367,
                                51.37473
                            ],
                            [
                                4.33314,
                                51.3774
                            ],
                            [
                                4.39118,
                                51.45137
                            ],
                            [
                                4.53676,
                                51.48211
                            ],
                            [
                                4.53545,
                                51.42289
                            ],
                            [
                                4.63997,
                                51.42275
                            ],
                            [
                                4.75061,
                                51.49799
                            ],
                            [
                                4.84139,
                                51.48071
                            ],
                            [
                                4.82916,
                                51.42253
                            ],
                            [
                                4.92871,
                                51.39608
                            ],
                            [
                                5.08015,
                                51.4698
                            ],
                            [
                                5.07105,
                                51.39342
                            ],
                            [
                                5.2411,
                                51.30566
                            ],
                            [
                                5.22658,
                                51.2692
                            ],
                            [
                                5.41738,
                                51.26223
                            ],
                            [
                                5.48488,
                                51.30005
                            ],
                            [
                                5.56008,
                                51.22279
                            ],
                            [
                                5.82648,
                                51.16676
                            ],
                            [
                                5.80032,
                                51.06411
                            ],
                            [
                                5.72087,
                                50.962
                            ],
                            [
                                5.72373,
                                50.91053
                            ],
                            [
                                5.64665,
                                50.87212
                            ],
                            [
                                5.65542,
                                50.81976
                            ],
                            [
                                5.73728,
                                50.75779
                            ],
                            [
                                5.88629,
                                50.76948
                            ],
                            [
                                6.021,
                                50.7543
                            ],
                            [
                                6.01999,
                                50.84613
                            ],
                            [
                                6.09047,
                                50.9178
                            ],
                            [
                                5.95482,
                                50.98836
                            ],
                            [
                                5.99657,
                                51.08327
                            ],
                            [
                                6.09252,
                                51.13457
                            ],
                            [
                                6.07266,
                                51.24259
                            ],
                            [
                                6.16978,
                                51.33218
                            ],
                            [
                                6.20569,
                                51.40071
                            ],
                            [
                                6.21148,
                                51.51454
                            ],
                            [
                                6.09243,
                                51.60554
                            ],
                            [
                                6.11714,
                                51.65599
                            ],
                            [
                                6.03197,
                                51.67618
                            ],
                            [
                                5.96283,
                                51.83617
                            ],
                            [
                                6.16641,
                                51.84083
                            ],
                            [
                                6.29894,
                                51.8679
                            ],
                            [
                                6.38954,
                                51.83327
                            ],
                            [
                                6.68259,
                                51.91721
                            ],
                            [
                                6.77092,
                                51.917
                            ],
                            [
                                6.82657,
                                51.99353
                            ],
                            [
                                6.68773,
                                52.0399
                            ],
                            [
                                6.76047,
                                52.11857
                            ],
                            [
                                6.84664,
                                52.11944
                            ],
                            [
                                6.99031,
                                52.22672
                            ],
                            [
                                7.07244,
                                52.37312
                            ],
                            [
                                6.99344,
                                52.46557
                            ],
                            [
                                6.93827,
                                52.43613
                            ],
                            [
                                6.69787,
                                52.48629
                            ],
                            [
                                6.74576,
                                52.64604
                            ],
                            [
                                7.05492,
                                52.64361
                            ],
                            [
                                7.07205,
                                52.81087
                            ],
                            [
                                7.18157,
                                52.9413
                            ],
                            [
                                7.2128,
                                53.01096
                            ],
                            [
                                7.20894,
                                53.24306
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                4.23482,
                                51.34825
                            ],
                            [
                                4.1127,
                                51.35312
                            ],
                            [
                                4.02093,
                                51.39819
                            ],
                            [
                                3.86572,
                                51.33661
                            ],
                            [
                                3.72411,
                                51.35006
                            ],
                            [
                                3.51666,
                                51.40764
                            ],
                            [
                                3.36579,
                                51.36984
                            ],
                            [
                                3.37609,
                                51.27795
                            ],
                            [
                                3.42795,
                                51.24516
                            ],
                            [
                                3.5898,
                                51.30523
                            ],
                            [
                                3.79409,
                                51.25619
                            ],
                            [
                                3.79076,
                                51.21439
                            ],
                            [
                                3.95849,
                                51.21649
                            ],
                            [
                                4.16576,
                                51.29273
                            ],
                            [
                                4.23482,
                                51.34825
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                4.87824,
                                53.1578
                            ],
                            [
                                4.75149,
                                53.09889
                            ],
                            [
                                4.70911,
                                53.02785
                            ],
                            [
                                4.78457,
                                53.00173
                            ],
                            [
                                4.89668,
                                53.0775
                            ],
                            [
                                4.87824,
                                53.1578
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                5.5474,
                                53.43931
                            ],
                            [
                                5.49049,
                                53.4442
                            ],
                            [
                                5.19952,
                                53.39552
                            ],
                            [
                                5.29287,
                                53.37028
                            ],
                            [
                                5.5474,
                                53.43931
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "NCL",
                "Country": "New Caledonia",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    9.9e-08,
                    2.2605e-07,
                    4.389e-07,
                    6.1875e-07,
                    8.5305e-07,
                    1.1682e-06,
                    1.6929e-06,
                    2.173e-06,
                    2.5064e-06,
                    2.772e-06,
                    3.1598e-06,
                    3.559e-06,
                    3.8132e-06,
                    4.092e-06,
                    4.587e-06,
                    5.1414e-06,
                    5.8212e-06,
                    6.4845e-06,
                    7.3128e-06,
                    8.014e-06,
                    9.0915e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_3GHG": 0.01,
                "Fossil_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    9.9e-08,
                    2.2605e-07,
                    4.389e-07,
                    6.1875e-07,
                    8.5305e-07,
                    1.1682e-06,
                    1.6929e-06,
                    2.173e-06,
                    2.5064e-06,
                    2.772e-06,
                    3.1598e-06,
                    3.559e-06,
                    3.8132e-06,
                    4.092e-06,
                    4.587e-06,
                    5.1414e-06,
                    5.8212e-06,
                    6.4845e-06,
                    7.3128e-06,
                    8.014e-06,
                    9.0915e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [],
                "Total_CO2": 0.01,
                "Total_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    9.9e-08,
                    2.2605e-07,
                    4.389e-07,
                    6.1875e-07,
                    8.5305e-07,
                    1.1682e-06,
                    1.6929e-06,
                    2.173e-06,
                    2.5064e-06,
                    2.772e-06,
                    3.1598e-06,
                    3.559e-06,
                    3.8132e-06,
                    4.092e-06,
                    4.587e-06,
                    5.1414e-06,
                    5.8212e-06,
                    6.4845e-06,
                    7.3128e-06,
                    8.014e-06,
                    9.0915e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_CO2": 0.01,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    9.9e-08,
                    2.2605e-07,
                    4.389e-07,
                    6.1875e-07,
                    8.5305e-07,
                    1.1682e-06,
                    1.6929e-06,
                    2.173e-06,
                    2.5064e-06,
                    2.772e-06,
                    3.1598e-06,
                    3.559e-06,
                    3.8132e-06,
                    4.092e-06,
                    4.587e-06,
                    5.1414e-06,
                    5.8212e-06,
                    6.4845e-06,
                    7.3128e-06,
                    8.014e-06,
                    9.0915e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": []
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                166.36096,
                                -21.68976
                            ],
                            [
                                166.33237,
                                -21.64353
                            ],
                            [
                                166.23932,
                                -21.61228
                            ],
                            [
                                166.11843,
                                -21.51714
                            ],
                            [
                                166.06371,
                                -21.49444
                            ],
                            [
                                165.97605,
                                -21.41381
                            ],
                            [
                                165.94676,
                                -21.44462
                            ],
                            [
                                165.88455,
                                -21.3598
                            ],
                            [
                                165.83804,
                                -21.38894
                            ],
                            [
                                165.76135,
                                -21.30249
                            ],
                            [
                                165.63304,
                                -21.267
                            ],
                            [
                                165.60782,
                                -21.18128
                            ],
                            [
                                165.49683,
                                -21.13136
                            ],
                            [
                                165.40775,
                                -21.05549
                            ],
                            [
                                165.41254,
                                -20.94813
                            ],
                            [
                                165.32635,
                                -20.93094
                            ],
                            [
                                165.25782,
                                -20.86664
                            ],
                            [
                                165.26193,
                                -20.79849
                            ],
                            [
                                165.19657,
                                -20.76267
                            ],
                            [
                                165.0379,
                                -20.72391
                            ],
                            [
                                164.86748,
                                -20.62846
                            ],
                            [
                                164.73072,
                                -20.47669
                            ],
                            [
                                164.59619,
                                -20.40276
                            ],
                            [
                                164.48934,
                                -20.29746
                            ],
                            [
                                164.35595,
                                -20.23702
                            ],
                            [
                                164.25637,
                                -20.28776
                            ],
                            [
                                164.16633,
                                -20.23118
                            ],
                            [
                                164.09614,
                                -20.15583
                            ],
                            [
                                164.07011,
                                -20.22771
                            ],
                            [
                                164.00515,
                                -20.25172
                            ],
                            [
                                164.03969,
                                -20.2976
                            ],
                            [
                                164.14141,
                                -20.3
                            ],
                            [
                                164.18046,
                                -20.33774
                            ],
                            [
                                164.16204,
                                -20.42942
                            ],
                            [
                                164.17852,
                                -20.48847
                            ],
                            [
                                164.24432,
                                -20.55573
                            ],
                            [
                                164.29885,
                                -20.5824
                            ],
                            [
                                164.32433,
                                -20.63738
                            ],
                            [
                                164.41745,
                                -20.72523
                            ],
                            [
                                164.41308,
                                -20.78231
                            ],
                            [
                                164.52591,
                                -20.89019
                            ],
                            [
                                164.67115,
                                -20.92397
                            ],
                            [
                                164.65751,
                                -20.98278
                            ],
                            [
                                164.71811,
                                -21.05911
                            ],
                            [
                                164.83194,
                                -21.05866
                            ],
                            [
                                164.86022,
                                -21.10491
                            ],
                            [
                                164.83213,
                                -21.17081
                            ],
                            [
                                164.91244,
                                -21.27741
                            ],
                            [
                                165.09914,
                                -21.37139
                            ],
                            [
                                165.16785,
                                -21.47672
                            ],
                            [
                                165.26095,
                                -21.5125
                            ],
                            [
                                165.28197,
                                -21.5684
                            ],
                            [
                                165.39808,
                                -21.61307
                            ],
                            [
                                165.4559,
                                -21.60891
                            ],
                            [
                                165.53346,
                                -21.69855
                            ],
                            [
                                165.66404,
                                -21.70967
                            ],
                            [
                                165.76973,
                                -21.80614
                            ],
                            [
                                165.90456,
                                -21.87128
                            ],
                            [
                                166.00487,
                                -21.95126
                            ],
                            [
                                166.11984,
                                -21.94344
                            ],
                            [
                                166.16593,
                                -22.02946
                            ],
                            [
                                166.15979,
                                -22.08714
                            ],
                            [
                                166.26657,
                                -22.16605
                            ],
                            [
                                166.35719,
                                -22.20336
                            ],
                            [
                                166.43264,
                                -22.20459
                            ],
                            [
                                166.56345,
                                -22.24188
                            ],
                            [
                                166.7451,
                                -22.34141
                            ],
                            [
                                166.87301,
                                -22.32449
                            ],
                            [
                                166.92319,
                                -22.39203
                            ],
                            [
                                167.00469,
                                -22.33123
                            ],
                            [
                                167.021,
                                -22.23555
                            ],
                            [
                                166.95675,
                                -22.16298
                            ],
                            [
                                166.93764,
                                -22.08624
                            ],
                            [
                                166.86349,
                                -22.03144
                            ],
                            [
                                166.76079,
                                -22.01065
                            ],
                            [
                                166.71362,
                                -21.95289
                            ],
                            [
                                166.62242,
                                -21.91845
                            ],
                            [
                                166.48442,
                                -21.79083
                            ],
                            [
                                166.41061,
                                -21.70323
                            ],
                            [
                                166.36096,
                                -21.68976
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                167.01269,
                                -20.91815
                            ],
                            [
                                167.13729,
                                -21.0772
                            ],
                            [
                                167.26072,
                                -21.0922
                            ],
                            [
                                167.33945,
                                -21.18129
                            ],
                            [
                                167.41222,
                                -21.16263
                            ],
                            [
                                167.4107,
                                -21.0977
                            ],
                            [
                                167.45221,
                                -21.05166
                            ],
                            [
                                167.38353,
                                -21.01446
                            ],
                            [
                                167.36999,
                                -20.94958
                            ],
                            [
                                167.25842,
                                -20.9089
                            ],
                            [
                                167.28955,
                                -20.87516
                            ],
                            [
                                167.27628,
                                -20.7678
                            ],
                            [
                                167.30139,
                                -20.74086
                            ],
                            [
                                167.22557,
                                -20.68371
                            ],
                            [
                                167.13399,
                                -20.7228
                            ],
                            [
                                167.17787,
                                -20.82932
                            ],
                            [
                                167.11817,
                                -20.91037
                            ],
                            [
                                167.01269,
                                -20.91815
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                167.80109,
                                -21.38191
                            ],
                            [
                                167.83287,
                                -21.48175
                            ],
                            [
                                167.90429,
                                -21.59703
                            ],
                            [
                                167.97872,
                                -21.65944
                            ],
                            [
                                168.11508,
                                -21.62728
                            ],
                            [
                                168.11925,
                                -21.4762
                            ],
                            [
                                168.08598,
                                -21.45368
                            ],
                            [
                                167.99901,
                                -21.45683
                            ],
                            [
                                167.95529,
                                -21.39612
                            ],
                            [
                                167.80109,
                                -21.38191
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                167.41523,
                                -22.60501
                            ],
                            [
                                167.42096,
                                -22.65007
                            ],
                            [
                                167.52017,
                                -22.67616
                            ],
                            [
                                167.54371,
                                -22.59448
                            ],
                            [
                                167.44615,
                                -22.5368
                            ],
                            [
                                167.41523,
                                -22.60501
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                166.47583,
                                -20.69764
                            ],
                            [
                                166.56857,
                                -20.68588
                            ],
                            [
                                166.60891,
                                -20.61549
                            ],
                            [
                                166.57002,
                                -20.58468
                            ],
                            [
                                166.52603,
                                -20.66063
                            ],
                            [
                                166.47583,
                                -20.69764
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "NZL",
                "Country": "New Zealand",
                "Total_3GHG": 0.31,
                "Total_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.004,
                    0.004,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0045,
                    0.0045,
                    0.0045,
                    0.0045,
                    0.0046,
                    0.0046,
                    0.0046,
                    0.0046,
                    0.0047,
                    0.0047,
                    0.0047,
                    0.0047,
                    0.0047,
                    0.0048,
                    0.0048,
                    0.0048,
                    0.0048,
                    0.0048,
                    0.0048,
                    0.0049,
                    0.0049,
                    0.0049,
                    0.0049,
                    0.0049,
                    0.0049,
                    0.005,
                    0.005,
                    0.005,
                    0.005,
                    0.005,
                    0.0051,
                    0.0051
                ],
                "Fossil_3GHG": 0.11,
                "Fossil_3GHG_timeseries": [
                    4.8168e-08,
                    9.7756e-08,
                    1.4879e-07,
                    2.0131e-07,
                    2.5532e-07,
                    3.1088e-07,
                    3.6802e-07,
                    4.2676e-07,
                    4.8711e-07,
                    5.4911e-07,
                    6.1457e-07,
                    6.8374e-07,
                    7.5684e-07,
                    8.3414e-07,
                    9.1592e-07,
                    1.0026e-06,
                    1.0944e-06,
                    1.1917e-06,
                    1.2949e-06,
                    1.4044e-06,
                    1.5176e-06,
                    1.6341e-06,
                    1.7543e-06,
                    1.8829e-06,
                    2.0216e-06,
                    2.1671e-06,
                    2.3159e-06,
                    2.7382e-06,
                    3.2781e-06,
                    3.9338e-06,
                    4.6517e-06,
                    5.4389e-06,
                    6.3013e-06,
                    7.2645e-06,
                    8.2793e-06,
                    9.3308e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012
                ],
                "Land_3GHG": 0.67,
                "Land_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039
                ],
                "Total_CO2": 0.24,
                "Total_CO2_timeseries": [
                    8.4924e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027
                ],
                "Fossil_CO2": 0.11,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.6005e-07,
                    3.8775e-07,
                    6.831e-07,
                    1.0147e-06,
                    1.3876e-06,
                    1.8051e-06,
                    2.2819e-06,
                    2.7901e-06,
                    3.3215e-06,
                    3.8791e-06,
                    4.4929e-06,
                    5.0837e-06,
                    5.7239e-06,
                    6.3954e-06,
                    7.0719e-06,
                    7.7665e-06,
                    8.4909e-06,
                    9.2219e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009
                ],
                "Land_CO2": 0.51,
                "Land_CO2_timeseries": [
                    8.4924e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0018,
                    0.0018
                ],
                "Total_CH4": 0.42,
                "Total_CH4_timeseries": [
                    2.206e-06,
                    4.4489e-06,
                    6.7287e-06,
                    9.0454e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017
                ],
                "Fossil_CH4": 0.12,
                "Fossil_CH4_timeseries": [
                    3.259e-08,
                    6.6403e-08,
                    1.0147e-07,
                    1.3782e-07,
                    1.7549e-07,
                    2.1454e-07,
                    2.55e-07,
                    2.9689e-07,
                    3.4027e-07,
                    3.8516e-07,
                    4.334e-07,
                    4.8522e-07,
                    5.4086e-07,
                    6.0059e-07,
                    6.6468e-07,
                    7.3352e-07,
                    8.0741e-07,
                    8.867e-07,
                    9.7176e-07,
                    1.063e-06,
                    1.1577e-06,
                    1.2555e-06,
                    1.3565e-06,
                    1.4653e-06,
                    1.5838e-06,
                    1.7086e-06,
                    1.8362e-06,
                    2.0766e-06,
                    2.3668e-06,
                    2.7047e-06,
                    3.0684e-06,
                    3.4599e-06,
                    3.8819e-06,
                    4.3451e-06,
                    4.8284e-06,
                    5.3251e-06,
                    5.8376e-06,
                    6.384e-06,
                    6.9108e-06,
                    7.4663e-06,
                    8.0407e-06,
                    8.6175e-06,
                    9.2068e-06,
                    9.8114e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Land_CH4": 0.91,
                "Land_CH4_timeseries": [
                    2.1734e-06,
                    4.3825e-06,
                    6.6272e-06,
                    8.9076e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014
                ],
                "Total_N2O": 0.73,
                "Total_N2O_timeseries": [
                    8.4288e-07,
                    1.7025e-06,
                    2.5782e-06,
                    3.4689e-06,
                    4.3733e-06,
                    5.2901e-06,
                    6.2172e-06,
                    7.1527e-06,
                    8.0942e-06,
                    9.039e-06,
                    9.9855e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006
                ],
                "Fossil_N2O": 0.07,
                "Fossil_N2O_timeseries": [
                    1.5577e-08,
                    3.1353e-08,
                    4.7324e-08,
                    6.3484e-08,
                    7.9826e-08,
                    9.6344e-08,
                    1.1303e-07,
                    1.2986e-07,
                    1.4684e-07,
                    1.6395e-07,
                    1.8117e-07,
                    1.9852e-07,
                    2.1598e-07,
                    2.3355e-07,
                    2.5124e-07,
                    2.6904e-07,
                    2.8695e-07,
                    3.0498e-07,
                    3.2313e-07,
                    3.414e-07,
                    3.5986e-07,
                    3.7865e-07,
                    3.9785e-07,
                    4.1754e-07,
                    4.3775e-07,
                    4.585e-07,
                    4.7976e-07,
                    5.0148e-07,
                    5.2359e-07,
                    5.4598e-07,
                    5.6858e-07,
                    5.9136e-07,
                    6.1432e-07,
                    6.3745e-07,
                    6.6075e-07,
                    6.842e-07,
                    7.0781e-07,
                    7.3159e-07,
                    7.5553e-07,
                    7.8034e-07,
                    8.055e-07,
                    8.3102e-07,
                    8.5691e-07,
                    8.8321e-07,
                    9.0991e-07,
                    9.3704e-07,
                    9.6462e-07,
                    9.9265e-07,
                    1.0212e-06,
                    1.0501e-06,
                    1.0797e-06,
                    1.1098e-06,
                    1.1405e-06,
                    1.172e-06,
                    1.2041e-06,
                    1.2369e-06,
                    1.2703e-06,
                    1.3044e-06,
                    1.3391e-06,
                    1.3742e-06,
                    1.4098e-06,
                    1.4459e-06,
                    1.4824e-06,
                    1.5193e-06,
                    1.5567e-06,
                    1.5945e-06,
                    1.6326e-06,
                    1.6711e-06,
                    1.7098e-06,
                    1.7488e-06,
                    1.7879e-06,
                    1.8272e-06,
                    1.8664e-06,
                    1.9057e-06,
                    1.945e-06,
                    1.9843e-06,
                    2.0236e-06,
                    2.063e-06,
                    2.1024e-06,
                    2.142e-06,
                    2.1819e-06,
                    2.2222e-06,
                    2.2631e-06,
                    2.3048e-06,
                    2.3473e-06,
                    2.3907e-06,
                    2.435e-06,
                    2.4804e-06,
                    2.5267e-06,
                    2.574e-06,
                    2.6224e-06,
                    2.6723e-06,
                    2.7239e-06,
                    2.7774e-06,
                    2.833e-06,
                    2.8906e-06,
                    2.9502e-06,
                    3.0119e-06,
                    3.0754e-06,
                    3.1406e-06,
                    3.2074e-06,
                    3.2757e-06,
                    3.3455e-06,
                    3.417e-06,
                    3.49e-06,
                    3.5646e-06,
                    3.6409e-06,
                    3.7189e-06,
                    3.7985e-06,
                    3.8799e-06,
                    3.9635e-06,
                    4.0501e-06,
                    4.1401e-06,
                    4.234e-06,
                    4.3318e-06,
                    4.4336e-06,
                    4.5391e-06,
                    4.6478e-06,
                    4.7591e-06,
                    4.868e-06,
                    4.9789e-06,
                    5.0987e-06,
                    5.2286e-06,
                    5.3723e-06,
                    5.5184e-06,
                    5.6687e-06,
                    5.8176e-06,
                    5.9662e-06,
                    6.1098e-06,
                    6.2557e-06,
                    6.4003e-06,
                    6.5632e-06,
                    6.7699e-06,
                    6.9436e-06,
                    7.1222e-06,
                    7.2942e-06,
                    7.4699e-06,
                    7.6446e-06,
                    7.8436e-06,
                    8.0556e-06,
                    8.2699e-06,
                    8.4935e-06,
                    8.7254e-06,
                    8.9659e-06,
                    9.213e-06,
                    9.4559e-06,
                    9.7009e-06,
                    9.9369e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.99,
                "Land_N2O_timeseries": [
                    8.2731e-07,
                    1.6712e-06,
                    2.5308e-06,
                    3.4054e-06,
                    4.2935e-06,
                    5.1937e-06,
                    6.1042e-06,
                    7.0228e-06,
                    7.9473e-06,
                    8.875e-06,
                    9.8044e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                168.96906,
                                -43.87335
                            ],
                            [
                                168.89093,
                                -43.89855
                            ],
                            [
                                168.82324,
                                -43.95824
                            ],
                            [
                                168.7241,
                                -43.98946
                            ],
                            [
                                168.56345,
                                -43.97663
                            ],
                            [
                                168.50703,
                                -43.99976
                            ],
                            [
                                168.38731,
                                -44.00264
                            ],
                            [
                                168.24798,
                                -44.14989
                            ],
                            [
                                168.10137,
                                -44.23799
                            ],
                            [
                                168.07761,
                                -44.32647
                            ],
                            [
                                167.86492,
                                -44.43723
                            ],
                            [
                                167.81875,
                                -44.49627
                            ],
                            [
                                167.81669,
                                -44.59198
                            ],
                            [
                                167.74963,
                                -44.58199
                            ],
                            [
                                167.56851,
                                -44.68287
                            ],
                            [
                                167.56134,
                                -44.71257
                            ],
                            [
                                167.26685,
                                -44.87173
                            ],
                            [
                                166.97566,
                                -45.13173
                            ],
                            [
                                166.96305,
                                -45.18617
                            ],
                            [
                                167.00556,
                                -45.31243
                            ],
                            [
                                166.83489,
                                -45.27698
                            ],
                            [
                                166.77595,
                                -45.33943
                            ],
                            [
                                166.6636,
                                -45.55419
                            ],
                            [
                                166.73202,
                                -45.57759
                            ],
                            [
                                166.72543,
                                -45.72354
                            ],
                            [
                                166.81436,
                                -45.70849
                            ],
                            [
                                166.86718,
                                -45.74542
                            ],
                            [
                                166.44232,
                                -45.82403
                            ],
                            [
                                166.42235,
                                -45.90637
                            ],
                            [
                                166.44337,
                                -45.99769
                            ],
                            [
                                166.50027,
                                -46.00193
                            ],
                            [
                                166.63952,
                                -45.9486
                            ],
                            [
                                166.56046,
                                -46.07737
                            ],
                            [
                                166.7286,
                                -46.04602
                            ],
                            [
                                166.69799,
                                -46.11073
                            ],
                            [
                                166.61639,
                                -46.14629
                            ],
                            [
                                166.64912,
                                -46.19658
                            ],
                            [
                                166.77556,
                                -46.22371
                            ],
                            [
                                166.85415,
                                -46.20868
                            ],
                            [
                                167.10203,
                                -46.25238
                            ],
                            [
                                167.31603,
                                -46.25033
                            ],
                            [
                                167.4116,
                                -46.15443
                            ],
                            [
                                167.50539,
                                -46.15806
                            ],
                            [
                                167.62363,
                                -46.20409
                            ],
                            [
                                167.71149,
                                -46.26418
                            ],
                            [
                                167.69073,
                                -46.31252
                            ],
                            [
                                167.77767,
                                -46.3837
                            ],
                            [
                                167.91708,
                                -46.35866
                            ],
                            [
                                168.00281,
                                -46.3797
                            ],
                            [
                                168.06964,
                                -46.34253
                            ],
                            [
                                168.15036,
                                -46.36014
                            ],
                            [
                                168.26892,
                                -46.46179
                            ],
                            [
                                168.29815,
                                -46.51397
                            ],
                            [
                                168.43655,
                                -46.60898
                            ],
                            [
                                168.51227,
                                -46.60905
                            ],
                            [
                                168.68418,
                                -46.57379
                            ],
                            [
                                168.77309,
                                -46.57735
                            ],
                            [
                                168.8673,
                                -46.65968
                            ],
                            [
                                169.0076,
                                -46.67121
                            ],
                            [
                                169.27122,
                                -46.62646
                            ],
                            [
                                169.3514,
                                -46.63471
                            ],
                            [
                                169.47398,
                                -46.55868
                            ],
                            [
                                169.58628,
                                -46.57189
                            ],
                            [
                                169.79985,
                                -46.44802
                            ],
                            [
                                169.79691,
                                -46.34921
                            ],
                            [
                                169.91553,
                                -46.30407
                            ],
                            [
                                170.1682,
                                -46.14932
                            ],
                            [
                                170.19551,
                                -46.0527
                            ],
                            [
                                170.29248,
                                -45.96476
                            ],
                            [
                                170.35627,
                                -45.93693
                            ],
                            [
                                170.66301,
                                -45.89868
                            ],
                            [
                                170.72036,
                                -45.84749
                            ],
                            [
                                170.70174,
                                -45.78205
                            ],
                            [
                                170.60572,
                                -45.73298
                            ],
                            [
                                170.66486,
                                -45.6196
                            ],
                            [
                                170.82263,
                                -45.4735
                            ],
                            [
                                170.86286,
                                -45.39137
                            ],
                            [
                                170.82526,
                                -45.32323
                            ],
                            [
                                170.9076,
                                -45.17113
                            ],
                            [
                                170.98587,
                                -45.08877
                            ],
                            [
                                171.08949,
                                -45.01453
                            ],
                            [
                                171.16199,
                                -44.89722
                            ],
                            [
                                171.1638,
                                -44.60268
                            ],
                            [
                                171.25574,
                                -44.44504
                            ],
                            [
                                171.25631,
                                -44.36505
                            ],
                            [
                                171.33578,
                                -44.28851
                            ],
                            [
                                171.62562,
                                -44.12638
                            ],
                            [
                                172.00937,
                                -43.96885
                            ],
                            [
                                172.14516,
                                -43.91962
                            ],
                            [
                                172.3751,
                                -43.85769
                            ],
                            [
                                172.72268,
                                -43.82425
                            ],
                            [
                                172.83865,
                                -43.88873
                            ],
                            [
                                172.93813,
                                -43.90019
                            ],
                            [
                                173.10001,
                                -43.8321
                            ],
                            [
                                173.13014,
                                -43.76899
                            ],
                            [
                                173.1023,
                                -43.69798
                            ],
                            [
                                173.04179,
                                -43.65604
                            ],
                            [
                                172.78653,
                                -43.59704
                            ],
                            [
                                172.71239,
                                -43.55434
                            ],
                            [
                                172.73138,
                                -43.50726
                            ],
                            [
                                172.70985,
                                -43.36438
                            ],
                            [
                                172.72376,
                                -43.2841
                            ],
                            [
                                172.80131,
                                -43.14273
                            ],
                            [
                                172.88845,
                                -43.10019
                            ],
                            [
                                173.07864,
                                -43.04934
                            ],
                            [
                                173.13995,
                                -42.99305
                            ],
                            [
                                173.22965,
                                -42.95905
                            ],
                            [
                                173.30681,
                                -42.89003
                            ],
                            [
                                173.46784,
                                -42.60876
                            ],
                            [
                                173.53566,
                                -42.47302
                            ],
                            [
                                173.68662,
                                -42.39624
                            ],
                            [
                                173.76378,
                                -42.28096
                            ],
                            [
                                173.93581,
                                -42.16047
                            ],
                            [
                                173.92723,
                                -42.11071
                            ],
                            [
                                173.96597,
                                -42.04348
                            ],
                            [
                                174.15319,
                                -41.87853
                            ],
                            [
                                174.26911,
                                -41.74884
                            ],
                            [
                                174.17226,
                                -41.70426
                            ],
                            [
                                174.14464,
                                -41.56459
                            ],
                            [
                                174.03037,
                                -41.47873
                            ],
                            [
                                174.06575,
                                -41.39195
                            ],
                            [
                                174.13951,
                                -41.29199
                            ],
                            [
                                174.1944,
                                -41.32499
                            ],
                            [
                                174.27239,
                                -41.27151
                            ],
                            [
                                174.10133,
                                -41.24756
                            ],
                            [
                                174.01477,
                                -41.28192
                            ],
                            [
                                173.97621,
                                -41.23506
                            ],
                            [
                                174.10819,
                                -41.22298
                            ],
                            [
                                174.24051,
                                -41.12505
                            ],
                            [
                                174.19861,
                                -41.01749
                            ],
                            [
                                174.15,
                                -40.99066
                            ],
                            [
                                174.04624,
                                -41.03062
                            ],
                            [
                                173.99314,
                                -41.10557
                            ],
                            [
                                173.87922,
                                -41.14141
                            ],
                            [
                                173.93955,
                                -41.20865
                            ],
                            [
                                173.86318,
                                -41.26076
                            ],
                            [
                                173.86236,
                                -41.10242
                            ],
                            [
                                173.82598,
                                -41.05894
                            ],
                            [
                                173.91523,
                                -40.99651
                            ],
                            [
                                173.76176,
                                -40.98348
                            ],
                            [
                                173.67787,
                                -41.03883
                            ],
                            [
                                173.59281,
                                -41.06259
                            ],
                            [
                                173.34361,
                                -41.19472
                            ],
                            [
                                173.30355,
                                -41.25303
                            ],
                            [
                                173.21526,
                                -41.297
                            ],
                            [
                                173.1364,
                                -41.29253
                            ],
                            [
                                173.0745,
                                -41.20288
                            ],
                            [
                                173.00694,
                                -41.14785
                            ],
                            [
                                173.02516,
                                -41.09552
                            ],
                            [
                                173.00308,
                                -41.014
                            ],
                            [
                                173.04827,
                                -40.94901
                            ],
                            [
                                173.05954,
                                -40.86514
                            ],
                            [
                                172.98924,
                                -40.78615
                            ],
                            [
                                172.84396,
                                -40.83848
                            ],
                            [
                                172.69604,
                                -40.72415
                            ],
                            [
                                172.69261,
                                -40.58245
                            ],
                            [
                                172.74498,
                                -40.51005
                            ],
                            [
                                172.64616,
                                -40.51068
                            ],
                            [
                                172.44626,
                                -40.63543
                            ],
                            [
                                172.14291,
                                -40.84514
                            ],
                            [
                                172.09686,
                                -40.91816
                            ],
                            [
                                172.10907,
                                -41.01715
                            ],
                            [
                                172.10558,
                                -41.20951
                            ],
                            [
                                172.05982,
                                -41.38557
                            ],
                            [
                                171.98053,
                                -41.45211
                            ],
                            [
                                171.84623,
                                -41.63356
                            ],
                            [
                                171.66668,
                                -41.73952
                            ],
                            [
                                171.45645,
                                -41.75325
                            ],
                            [
                                171.46331,
                                -41.82519
                            ],
                            [
                                171.40883,
                                -41.92149
                            ],
                            [
                                171.38442,
                                -42.026
                            ],
                            [
                                171.32762,
                                -42.11089
                            ],
                            [
                                171.30328,
                                -42.2685
                            ],
                            [
                                171.21659,
                                -42.38392
                            ],
                            [
                                171.13955,
                                -42.56016
                            ],
                            [
                                171.05387,
                                -42.65019
                            ],
                            [
                                170.9475,
                                -42.72606
                            ],
                            [
                                170.86062,
                                -42.82861
                            ],
                            [
                                170.72538,
                                -42.92734
                            ],
                            [
                                170.61587,
                                -42.98151
                            ],
                            [
                                170.44633,
                                -43.02497
                            ],
                            [
                                170.33867,
                                -43.0933
                            ],
                            [
                                170.26115,
                                -43.10541
                            ],
                            [
                                170.16336,
                                -43.21835
                            ],
                            [
                                169.91726,
                                -43.38601
                            ],
                            [
                                169.78987,
                                -43.41812
                            ],
                            [
                                169.67955,
                                -43.54595
                            ],
                            [
                                169.57749,
                                -43.60201
                            ],
                            [
                                169.41824,
                                -43.62185
                            ],
                            [
                                169.14225,
                                -43.75167
                            ],
                            [
                                168.96906,
                                -43.87335
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                174.57413,
                                -37.14985
                            ],
                            [
                                174.69089,
                                -37.36011
                            ],
                            [
                                174.69662,
                                -37.42421
                            ],
                            [
                                174.76529,
                                -37.55683
                            ],
                            [
                                174.84235,
                                -37.79918
                            ],
                            [
                                174.76715,
                                -37.84355
                            ],
                            [
                                174.78186,
                                -37.97601
                            ],
                            [
                                174.80821,
                                -38.00808
                            ],
                            [
                                174.78023,
                                -38.08547
                            ],
                            [
                                174.71042,
                                -38.18484
                            ],
                            [
                                174.70823,
                                -38.31165
                            ],
                            [
                                174.63562,
                                -38.38915
                            ],
                            [
                                174.64451,
                                -38.45264
                            ],
                            [
                                174.58597,
                                -38.78845
                            ],
                            [
                                174.53622,
                                -38.87005
                            ],
                            [
                                174.38416,
                                -38.98911
                            ],
                            [
                                174.18345,
                                -38.9952
                            ],
                            [
                                173.90465,
                                -39.1259
                            ],
                            [
                                173.7965,
                                -39.1962
                            ],
                            [
                                173.7492,
                                -39.28575
                            ],
                            [
                                173.78761,
                                -39.40871
                            ],
                            [
                                173.95049,
                                -39.53781
                            ],
                            [
                                174.19261,
                                -39.58331
                            ],
                            [
                                174.35249,
                                -39.66139
                            ],
                            [
                                174.44304,
                                -39.74733
                            ],
                            [
                                174.552,
                                -39.81252
                            ],
                            [
                                174.71566,
                                -39.86658
                            ],
                            [
                                174.82975,
                                -39.86503
                            ],
                            [
                                174.92305,
                                -39.89861
                            ],
                            [
                                175.04541,
                                -39.98753
                            ],
                            [
                                175.14983,
                                -40.09085
                            ],
                            [
                                175.20901,
                                -40.19696
                            ],
                            [
                                175.23176,
                                -40.37367
                            ],
                            [
                                175.197,
                                -40.55493
                            ],
                            [
                                175.15602,
                                -40.67694
                            ],
                            [
                                175.07332,
                                -40.81383
                            ],
                            [
                                174.98283,
                                -40.89173
                            ],
                            [
                                174.96692,
                                -40.96209
                            ],
                            [
                                174.84809,
                                -41.0953
                            ],
                            [
                                174.71291,
                                -41.21991
                            ],
                            [
                                174.6137,
                                -41.28843
                            ],
                            [
                                174.71046,
                                -41.36359
                            ],
                            [
                                174.81435,
                                -41.34883
                            ],
                            [
                                174.78959,
                                -41.27141
                            ],
                            [
                                174.85313,
                                -41.23134
                            ],
                            [
                                174.90263,
                                -41.28241
                            ],
                            [
                                174.84988,
                                -41.36101
                            ],
                            [
                                174.92029,
                                -41.44061
                            ],
                            [
                                175.04956,
                                -41.37925
                            ],
                            [
                                175.19484,
                                -41.42572
                            ],
                            [
                                175.19798,
                                -41.53252
                            ],
                            [
                                175.23613,
                                -41.60724
                            ],
                            [
                                175.33011,
                                -41.60856
                            ],
                            [
                                175.44412,
                                -41.57363
                            ],
                            [
                                175.51799,
                                -41.51214
                            ],
                            [
                                175.58912,
                                -41.48909
                            ],
                            [
                                175.67813,
                                -41.41934
                            ],
                            [
                                175.81202,
                                -41.3603
                            ],
                            [
                                175.88021,
                                -41.27929
                            ],
                            [
                                175.95891,
                                -41.24566
                            ],
                            [
                                176.06141,
                                -41.12768
                            ],
                            [
                                176.14596,
                                -40.95803
                            ],
                            [
                                176.21911,
                                -40.90897
                            ],
                            [
                                176.26639,
                                -40.78631
                            ],
                            [
                                176.50331,
                                -40.53112
                            ],
                            [
                                176.61169,
                                -40.49729
                            ],
                            [
                                176.62585,
                                -40.42775
                            ],
                            [
                                176.70397,
                                -40.24695
                            ],
                            [
                                176.78534,
                                -40.21886
                            ],
                            [
                                176.86573,
                                -40.13139
                            ],
                            [
                                176.88039,
                                -40.04158
                            ],
                            [
                                176.93029,
                                -39.93455
                            ],
                            [
                                176.9994,
                                -39.84216
                            ],
                            [
                                177.01407,
                                -39.73332
                            ],
                            [
                                177.07334,
                                -39.64183
                            ],
                            [
                                176.98708,
                                -39.64122
                            ],
                            [
                                176.9197,
                                -39.55108
                            ],
                            [
                                176.91876,
                                -39.48356
                            ],
                            [
                                176.87696,
                                -39.45195
                            ],
                            [
                                176.89384,
                                -39.3794
                            ],
                            [
                                176.98052,
                                -39.30126
                            ],
                            [
                                177.05198,
                                -39.19279
                            ],
                            [
                                177.28282,
                                -39.09814
                            ],
                            [
                                177.43985,
                                -39.0623
                            ],
                            [
                                177.63199,
                                -39.05162
                            ],
                            [
                                177.74759,
                                -39.05927
                            ],
                            [
                                177.86637,
                                -39.08766
                            ],
                            [
                                177.83389,
                                -39.15554
                            ],
                            [
                                177.84563,
                                -39.23558
                            ],
                            [
                                177.99531,
                                -39.10776
                            ],
                            [
                                177.91404,
                                -39.09034
                            ],
                            [
                                177.8871,
                                -39.00829
                            ],
                            [
                                177.90597,
                                -38.83412
                            ],
                            [
                                177.96477,
                                -38.75625
                            ],
                            [
                                177.95148,
                                -38.69872
                            ],
                            [
                                178.04794,
                                -38.69882
                            ],
                            [
                                178.14078,
                                -38.64763
                            ],
                            [
                                178.28548,
                                -38.52604
                            ],
                            [
                                178.27599,
                                -38.47572
                            ],
                            [
                                178.33297,
                                -38.4228
                            ],
                            [
                                178.31028,
                                -38.23582
                            ],
                            [
                                178.35466,
                                -38.18578
                            ],
                            [
                                178.32075,
                                -38.12821
                            ],
                            [
                                178.37037,
                                -38.09338
                            ],
                            [
                                178.3403,
                                -38.00956
                            ],
                            [
                                178.4021,
                                -37.95053
                            ],
                            [
                                178.40509,
                                -37.87405
                            ],
                            [
                                178.55355,
                                -37.69528
                            ],
                            [
                                178.47233,
                                -37.64367
                            ],
                            [
                                178.36857,
                                -37.62865
                            ],
                            [
                                178.30281,
                                -37.57605
                            ],
                            [
                                178.18562,
                                -37.53301
                            ],
                            [
                                178.02179,
                                -37.54677
                            ],
                            [
                                177.95785,
                                -37.60934
                            ],
                            [
                                177.86874,
                                -37.65022
                            ],
                            [
                                177.74246,
                                -37.67213
                            ],
                            [
                                177.68194,
                                -37.76773
                            ],
                            [
                                177.47584,
                                -37.95068
                            ],
                            [
                                177.38611,
                                -37.98225
                            ],
                            [
                                177.17861,
                                -37.98727
                            ],
                            [
                                177.03459,
                                -37.96027
                            ],
                            [
                                176.89597,
                                -37.91215
                            ],
                            [
                                176.63334,
                                -37.84432
                            ],
                            [
                                176.47511,
                                -37.7552
                            ],
                            [
                                176.40644,
                                -37.74569
                            ],
                            [
                                176.23068,
                                -37.66958
                            ],
                            [
                                176.08837,
                                -37.57672
                            ],
                            [
                                175.94012,
                                -37.39639
                            ],
                            [
                                175.93653,
                                -37.34137
                            ],
                            [
                                175.87832,
                                -37.21549
                            ],
                            [
                                175.88264,
                                -37.03826
                            ],
                            [
                                175.85323,
                                -37.01414
                            ],
                            [
                                175.85123,
                                -36.92664
                            ],
                            [
                                175.80666,
                                -36.84003
                            ],
                            [
                                175.70355,
                                -36.83073
                            ],
                            [
                                175.78242,
                                -36.69579
                            ],
                            [
                                175.67401,
                                -36.72981
                            ],
                            [
                                175.62017,
                                -36.71831
                            ],
                            [
                                175.52424,
                                -36.59479
                            ],
                            [
                                175.52956,
                                -36.54519
                            ],
                            [
                                175.32664,
                                -36.48382
                            ],
                            [
                                175.34182,
                                -36.55222
                            ],
                            [
                                175.40936,
                                -36.5875
                            ],
                            [
                                175.4406,
                                -36.66035
                            ],
                            [
                                175.42798,
                                -36.71227
                            ],
                            [
                                175.49281,
                                -36.76732
                            ],
                            [
                                175.41156,
                                -36.85374
                            ],
                            [
                                175.4965,
                                -36.98265
                            ],
                            [
                                175.52556,
                                -37.17292
                            ],
                            [
                                175.39248,
                                -37.22658
                            ],
                            [
                                175.31666,
                                -37.18572
                            ],
                            [
                                175.28206,
                                -36.99532
                            ],
                            [
                                175.18658,
                                -36.93572
                            ],
                            [
                                175.0824,
                                -36.94538
                            ],
                            [
                                175.02976,
                                -36.87673
                            ],
                            [
                                174.94421,
                                -36.89206
                            ],
                            [
                                174.8129,
                                -36.83772
                            ],
                            [
                                174.75267,
                                -36.73307
                            ],
                            [
                                174.72877,
                                -36.61711
                            ],
                            [
                                174.69563,
                                -36.59065
                            ],
                            [
                                174.69342,
                                -36.48035
                            ],
                            [
                                174.77023,
                                -36.44053
                            ],
                            [
                                174.74323,
                                -36.39134
                            ],
                            [
                                174.80871,
                                -36.28814
                            ],
                            [
                                174.71865,
                                -36.24022
                            ],
                            [
                                174.62292,
                                -36.1344
                            ],
                            [
                                174.58632,
                                -36.05545
                            ],
                            [
                                174.51064,
                                -36.03197
                            ],
                            [
                                174.45609,
                                -35.90717
                            ],
                            [
                                174.49906,
                                -35.83625
                            ],
                            [
                                174.55221,
                                -35.80182
                            ],
                            [
                                174.5558,
                                -35.74315
                            ],
                            [
                                174.5037,
                                -35.67521
                            ],
                            [
                                174.53688,
                                -35.60021
                            ],
                            [
                                174.46788,
                                -35.54729
                            ],
                            [
                                174.43378,
                                -35.4556
                            ],
                            [
                                174.36965,
                                -35.43176
                            ],
                            [
                                174.29744,
                                -35.22831
                            ],
                            [
                                174.19782,
                                -35.24956
                            ],
                            [
                                174.16667,
                                -35.31472
                            ],
                            [
                                174.10441,
                                -35.3266
                            ],
                            [
                                174.05705,
                                -35.2106
                            ],
                            [
                                174.11172,
                                -35.16376
                            ],
                            [
                                174.07669,
                                -35.12174
                            ],
                            [
                                173.97932,
                                -35.11954
                            ],
                            [
                                173.89719,
                                -35.01539
                            ],
                            [
                                173.76895,
                                -35.00355
                            ],
                            [
                                173.55952,
                                -34.92058
                            ],
                            [
                                173.51412,
                                -34.98282
                            ],
                            [
                                173.41992,
                                -34.97664
                            ],
                            [
                                173.36957,
                                -34.91475
                            ],
                            [
                                173.38614,
                                -34.82356
                            ],
                            [
                                173.2904,
                                -34.87941
                            ],
                            [
                                173.31799,
                                -34.95349
                            ],
                            [
                                173.25084,
                                -34.97501
                            ],
                            [
                                173.25573,
                                -34.88405
                            ],
                            [
                                173.14475,
                                -34.82596
                            ],
                            [
                                173.14322,
                                -34.76578
                            ],
                            [
                                173.05361,
                                -34.69442
                            ],
                            [
                                173.00641,
                                -34.61309
                            ],
                            [
                                172.95547,
                                -34.42172
                            ],
                            [
                                172.85715,
                                -34.41355
                            ],
                            [
                                172.79658,
                                -34.44873
                            ],
                            [
                                172.68972,
                                -34.42194
                            ],
                            [
                                172.68402,
                                -34.48864
                            ],
                            [
                                172.84976,
                                -34.631
                            ],
                            [
                                173.13182,
                                -34.96641
                            ],
                            [
                                173.17111,
                                -35.04881
                            ],
                            [
                                173.16132,
                                -35.13571
                            ],
                            [
                                173.05313,
                                -35.18957
                            ],
                            [
                                173.14679,
                                -35.27968
                            ],
                            [
                                173.2112,
                                -35.37458
                            ],
                            [
                                173.27597,
                                -35.43602
                            ],
                            [
                                173.55254,
                                -35.7591
                            ],
                            [
                                173.70224,
                                -35.91143
                            ],
                            [
                                173.91127,
                                -36.14948
                            ],
                            [
                                173.99055,
                                -36.25365
                            ],
                            [
                                174.05521,
                                -36.39521
                            ],
                            [
                                174.15298,
                                -36.38254
                            ],
                            [
                                174.17476,
                                -36.32894
                            ],
                            [
                                174.1455,
                                -36.27393
                            ],
                            [
                                174.07913,
                                -36.23717
                            ],
                            [
                                174.02005,
                                -36.16293
                            ],
                            [
                                174.11647,
                                -36.16992
                            ],
                            [
                                174.21709,
                                -36.25342
                            ],
                            [
                                174.28988,
                                -36.22501
                            ],
                            [
                                174.25512,
                                -36.37104
                            ],
                            [
                                174.35625,
                                -36.40362
                            ],
                            [
                                174.40018,
                                -36.3722
                            ],
                            [
                                174.43824,
                                -36.59412
                            ],
                            [
                                174.29711,
                                -36.53513
                            ],
                            [
                                174.23421,
                                -36.42894
                            ],
                            [
                                174.15578,
                                -36.4734
                            ],
                            [
                                174.28028,
                                -36.62622
                            ],
                            [
                                174.39737,
                                -36.78823
                            ],
                            [
                                174.46239,
                                -36.94749
                            ],
                            [
                                174.48372,
                                -37.043
                            ],
                            [
                                174.57413,
                                -37.14985
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                167.59942,
                                -47.24581
                            ],
                            [
                                167.66755,
                                -47.16668
                            ],
                            [
                                167.82018,
                                -47.18822
                            ],
                            [
                                167.99485,
                                -47.11491
                            ],
                            [
                                168.14813,
                                -47.11101
                            ],
                            [
                                168.22506,
                                -47.01529
                            ],
                            [
                                168.17873,
                                -46.97092
                            ],
                            [
                                168.02537,
                                -46.94637
                            ],
                            [
                                168.11049,
                                -46.90185
                            ],
                            [
                                168.0874,
                                -46.82837
                            ],
                            [
                                168.0017,
                                -46.78525
                            ],
                            [
                                167.97898,
                                -46.72101
                            ],
                            [
                                167.86183,
                                -46.6828
                            ],
                            [
                                167.72265,
                                -46.71024
                            ],
                            [
                                167.69903,
                                -46.79145
                            ],
                            [
                                167.76778,
                                -46.89187
                            ],
                            [
                                167.68453,
                                -46.9648
                            ],
                            [
                                167.69009,
                                -47.04364
                            ],
                            [
                                167.62375,
                                -47.03822
                            ],
                            [
                                167.56153,
                                -47.08877
                            ],
                            [
                                167.57092,
                                -47.16652
                            ],
                            [
                                167.46867,
                                -47.21465
                            ],
                            [
                                167.44704,
                                -47.26269
                            ],
                            [
                                167.5406,
                                -47.28459
                            ],
                            [
                                167.59942,
                                -47.24581
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -176.89544,
                                -43.82652
                            ],
                            [
                                -176.85675,
                                -43.84706
                            ],
                            [
                                -176.68912,
                                -43.80325
                            ],
                            [
                                -176.61057,
                                -43.81562
                            ],
                            [
                                -176.53717,
                                -43.92955
                            ],
                            [
                                -176.68546,
                                -44.01289
                            ],
                            [
                                -176.64361,
                                -44.10962
                            ],
                            [
                                -176.57674,
                                -44.13232
                            ],
                            [
                                -176.38405,
                                -44.02177
                            ],
                            [
                                -176.52603,
                                -43.85689
                            ],
                            [
                                -176.52323,
                                -43.80313
                            ],
                            [
                                -176.43806,
                                -43.75588
                            ],
                            [
                                -176.37227,
                                -43.80082
                            ],
                            [
                                -176.28596,
                                -43.7426
                            ],
                            [
                                -176.45034,
                                -43.74963
                            ],
                            [
                                -176.49852,
                                -43.72507
                            ],
                            [
                                -176.63775,
                                -43.70781
                            ],
                            [
                                -176.65629,
                                -43.74746
                            ],
                            [
                                -176.78614,
                                -43.76437
                            ],
                            [
                                -176.89544,
                                -43.82652
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                166.21074,
                                -50.78261
                            ],
                            [
                                166.18357,
                                -50.65659
                            ],
                            [
                                166.23616,
                                -50.61496
                            ],
                            [
                                166.21074,
                                -50.54728
                            ],
                            [
                                166.09538,
                                -50.55491
                            ],
                            [
                                166.0894,
                                -50.66884
                            ],
                            [
                                166.022,
                                -50.7205
                            ],
                            [
                                165.89558,
                                -50.7679
                            ],
                            [
                                165.88417,
                                -50.81206
                            ],
                            [
                                165.99677,
                                -50.85255
                            ],
                            [
                                166.06038,
                                -50.79428
                            ],
                            [
                                166.11198,
                                -50.83482
                            ],
                            [
                                166.21632,
                                -50.85637
                            ],
                            [
                                166.21074,
                                -50.78261
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                175.30625,
                                -36.204
                            ],
                            [
                                175.5183,
                                -36.34727
                            ],
                            [
                                175.53751,
                                -36.29434
                            ],
                            [
                                175.47346,
                                -36.23754
                            ],
                            [
                                175.48194,
                                -36.16907
                            ],
                            [
                                175.42383,
                                -36.1407
                            ],
                            [
                                175.39231,
                                -36.05409
                            ],
                            [
                                175.33795,
                                -36.06906
                            ],
                            [
                                175.34313,
                                -36.18704
                            ],
                            [
                                175.30625,
                                -36.204
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                166.68588,
                                -45.61126
                            ],
                            [
                                166.52736,
                                -45.62938
                            ],
                            [
                                166.50623,
                                -45.66306
                            ],
                            [
                                166.5772,
                                -45.72336
                            ],
                            [
                                166.67167,
                                -45.75193
                            ],
                            [
                                166.71504,
                                -45.70576
                            ],
                            [
                                166.68588,
                                -45.61126
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                173.77085,
                                -40.86511
                            ],
                            [
                                173.82823,
                                -40.9238
                            ],
                            [
                                173.93908,
                                -40.80181
                            ],
                            [
                                173.84013,
                                -40.75665
                            ],
                            [
                                173.77085,
                                -40.86511
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                169.01431,
                                -52.54775
                            ],
                            [
                                169.15926,
                                -52.60521
                            ],
                            [
                                169.25733,
                                -52.56137
                            ],
                            [
                                169.18871,
                                -52.4668
                            ],
                            [
                                169.10118,
                                -52.54897
                            ],
                            [
                                169.01431,
                                -52.54775
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                165.90997,
                                -50.85205
                            ],
                            [
                                165.95865,
                                -50.89907
                            ],
                            [
                                166.05649,
                                -50.91346
                            ],
                            [
                                166.06616,
                                -50.8471
                            ],
                            [
                                165.97293,
                                -50.8597
                            ],
                            [
                                165.90997,
                                -50.85205
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                174.97912,
                                -36.7841
                            ],
                            [
                                175.06664,
                                -36.83602
                            ],
                            [
                                175.16043,
                                -36.82744
                            ],
                            [
                                175.14775,
                                -36.75012
                            ],
                            [
                                175.06659,
                                -36.78516
                            ],
                            [
                                174.97912,
                                -36.7841
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                174.1792,
                                -41.24474
                            ],
                            [
                                174.37494,
                                -41.1902
                            ],
                            [
                                174.33117,
                                -41.13286
                            ],
                            [
                                174.1792,
                                -41.24474
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "NIC",
                "Country": "Nicaragua",
                "Total_3GHG": 0.13,
                "Total_3GHG_timeseries": [
                    2.6663e-06,
                    5.093e-06,
                    7.3361e-06,
                    9.4174e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022
                ],
                "Fossil_3GHG": 0.02,
                "Fossil_3GHG_timeseries": [
                    5.1493e-08,
                    1.023e-07,
                    1.5242e-07,
                    2.0186e-07,
                    2.5062e-07,
                    2.987e-07,
                    3.4612e-07,
                    3.9286e-07,
                    4.3893e-07,
                    4.8433e-07,
                    5.2879e-07,
                    5.723e-07,
                    6.1487e-07,
                    6.5651e-07,
                    6.9722e-07,
                    7.3702e-07,
                    7.759e-07,
                    8.1387e-07,
                    8.5094e-07,
                    8.8713e-07,
                    9.2474e-07,
                    9.6383e-07,
                    1.0044e-06,
                    1.0466e-06,
                    1.0902e-06,
                    1.1355e-06,
                    1.1824e-06,
                    1.2308e-06,
                    1.2808e-06,
                    1.3323e-06,
                    1.3855e-06,
                    1.4405e-06,
                    1.4973e-06,
                    1.5558e-06,
                    1.616e-06,
                    1.6781e-06,
                    1.7419e-06,
                    1.8076e-06,
                    1.875e-06,
                    1.9445e-06,
                    2.0148e-06,
                    2.0862e-06,
                    2.1585e-06,
                    2.2318e-06,
                    2.306e-06,
                    2.3813e-06,
                    2.4576e-06,
                    2.5349e-06,
                    2.6132e-06,
                    2.6926e-06,
                    2.7743e-06,
                    2.8585e-06,
                    2.9451e-06,
                    3.0343e-06,
                    3.126e-06,
                    3.2203e-06,
                    3.3171e-06,
                    3.4165e-06,
                    3.5185e-06,
                    3.6231e-06,
                    3.7303e-06,
                    3.8402e-06,
                    3.9527e-06,
                    4.0661e-06,
                    4.1838e-06,
                    4.3044e-06,
                    4.4277e-06,
                    4.554e-06,
                    4.683e-06,
                    4.8149e-06,
                    4.9483e-06,
                    5.0856e-06,
                    5.2244e-06,
                    5.367e-06,
                    5.511e-06,
                    5.6586e-06,
                    5.8075e-06,
                    5.9574e-06,
                    6.111e-06,
                    6.2655e-06,
                    6.4234e-06,
                    6.5816e-06,
                    6.7432e-06,
                    6.9093e-06,
                    7.0798e-06,
                    7.256e-06,
                    7.4382e-06,
                    7.624e-06,
                    7.8186e-06,
                    8.0193e-06,
                    8.2325e-06,
                    8.4589e-06,
                    8.7046e-06,
                    8.9627e-06,
                    9.2404e-06,
                    9.5361e-06,
                    9.854e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_3GHG": 0.34,
                "Land_3GHG_timeseries": [
                    2.6148e-06,
                    4.9907e-06,
                    7.1837e-06,
                    9.2155e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002
                ],
                "Total_CO2": 0.15,
                "Total_CO2_timeseries": [
                    2.3251e-06,
                    4.416e-06,
                    6.3289e-06,
                    8.0855e-06,
                    9.7037e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017
                ],
                "Fossil_CO2": 0.01,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    3.2734e-09,
                    4.9099e-09,
                    8.1834e-09,
                    9.8198e-09,
                    1.3093e-08,
                    1.6367e-08,
                    1.964e-08,
                    1.0541e-07,
                    1.9612e-07,
                    3.1983e-07,
                    4.4849e-07,
                    5.9035e-07,
                    7.6685e-07,
                    9.3672e-07,
                    1.1247e-06,
                    1.3953e-06,
                    1.6114e-06,
                    1.8506e-06,
                    2.1029e-06,
                    2.3999e-06,
                    2.7793e-06,
                    3.2065e-06,
                    3.5578e-06,
                    3.99e-06,
                    4.4766e-06,
                    5.0308e-06,
                    5.6097e-06,
                    6.2414e-06,
                    6.9194e-06,
                    7.6419e-06,
                    8.4649e-06,
                    9.3422e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CO2": 0.44,
                "Land_CO2_timeseries": [
                    2.3251e-06,
                    4.416e-06,
                    6.3289e-06,
                    8.0855e-06,
                    9.7037e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016
                ],
                "Total_CH4": 0.1,
                "Total_CH4_timeseries": [
                    3.2923e-07,
                    6.5276e-07,
                    9.7057e-07,
                    1.2827e-06,
                    1.5891e-06,
                    1.8898e-06,
                    2.1849e-06,
                    2.4742e-06,
                    2.7579e-06,
                    3.0359e-06,
                    3.3062e-06,
                    3.5687e-06,
                    3.8236e-06,
                    4.0707e-06,
                    4.3101e-06,
                    4.5418e-06,
                    4.7658e-06,
                    4.9822e-06,
                    5.1908e-06,
                    5.3918e-06,
                    5.6034e-06,
                    5.8256e-06,
                    6.0583e-06,
                    6.3017e-06,
                    6.5557e-06,
                    6.8203e-06,
                    7.0956e-06,
                    7.3815e-06,
                    7.6781e-06,
                    7.9854e-06,
                    8.3059e-06,
                    8.6398e-06,
                    8.9869e-06,
                    9.3474e-06,
                    9.7212e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Fossil_CH4": 0.04,
                "Fossil_CH4_timeseries": [
                    4.4625e-08,
                    8.848e-08,
                    1.3157e-07,
                    1.739e-07,
                    2.1548e-07,
                    2.5631e-07,
                    2.9639e-07,
                    3.3573e-07,
                    3.7434e-07,
                    4.1222e-07,
                    4.491e-07,
                    4.8497e-07,
                    5.1985e-07,
                    5.5374e-07,
                    5.8665e-07,
                    6.1858e-07,
                    6.4954e-07,
                    6.7954e-07,
                    7.0858e-07,
                    7.3668e-07,
                    7.6612e-07,
                    7.9692e-07,
                    8.2908e-07,
                    8.6261e-07,
                    8.9753e-07,
                    9.3383e-07,
                    9.7155e-07,
                    1.0107e-06,
                    1.0512e-06,
                    1.0932e-06,
                    1.1368e-06,
                    1.1821e-06,
                    1.2291e-06,
                    1.2778e-06,
                    1.3281e-06,
                    1.3802e-06,
                    1.434e-06,
                    1.4895e-06,
                    1.5467e-06,
                    1.6058e-06,
                    1.6656e-06,
                    1.7263e-06,
                    1.7878e-06,
                    1.8502e-06,
                    1.9135e-06,
                    1.9776e-06,
                    2.0426e-06,
                    2.1084e-06,
                    2.1752e-06,
                    2.2428e-06,
                    2.3127e-06,
                    2.3848e-06,
                    2.4591e-06,
                    2.5359e-06,
                    2.615e-06,
                    2.6965e-06,
                    2.7802e-06,
                    2.8664e-06,
                    2.955e-06,
                    3.046e-06,
                    3.1394e-06,
                    3.2354e-06,
                    3.3337e-06,
                    3.4329e-06,
                    3.5361e-06,
                    3.6421e-06,
                    3.7506e-06,
                    3.8619e-06,
                    3.9758e-06,
                    4.0924e-06,
                    4.2103e-06,
                    4.332e-06,
                    4.455e-06,
                    4.5815e-06,
                    4.7094e-06,
                    4.8407e-06,
                    4.9731e-06,
                    5.1063e-06,
                    5.243e-06,
                    5.3805e-06,
                    5.5211e-06,
                    5.662e-06,
                    5.806e-06,
                    5.9544e-06,
                    6.1068e-06,
                    6.2648e-06,
                    6.4288e-06,
                    6.5959e-06,
                    6.7717e-06,
                    6.9533e-06,
                    7.1471e-06,
                    7.3538e-06,
                    7.5759e-06,
                    7.8115e-06,
                    8.0645e-06,
                    8.3364e-06,
                    8.6283e-06,
                    8.9407e-06,
                    9.2726e-06,
                    9.6405e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CH4": 0.21,
                "Land_CH4_timeseries": [
                    2.8461e-07,
                    5.6428e-07,
                    8.39e-07,
                    1.1088e-06,
                    1.3736e-06,
                    1.6335e-06,
                    1.8885e-06,
                    2.1385e-06,
                    2.3835e-06,
                    2.6237e-06,
                    2.8571e-06,
                    3.0837e-06,
                    3.3037e-06,
                    3.5169e-06,
                    3.7234e-06,
                    3.9232e-06,
                    4.1163e-06,
                    4.3026e-06,
                    4.4822e-06,
                    4.6551e-06,
                    4.8373e-06,
                    5.0286e-06,
                    5.2292e-06,
                    5.4391e-06,
                    5.6582e-06,
                    5.8865e-06,
                    6.1241e-06,
                    6.3708e-06,
                    6.6269e-06,
                    6.8922e-06,
                    7.1691e-06,
                    7.4576e-06,
                    7.7578e-06,
                    8.0696e-06,
                    8.3931e-06,
                    8.7282e-06,
                    9.075e-06,
                    9.4334e-06,
                    9.8034e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Total_N2O": 0.08,
                "Total_N2O_timeseries": [
                    1.2013e-08,
                    2.4211e-08,
                    3.6587e-08,
                    4.9133e-08,
                    6.1841e-08,
                    7.4698e-08,
                    8.769e-08,
                    1.008e-07,
                    1.1401e-07,
                    1.273e-07,
                    1.4066e-07,
                    1.5409e-07,
                    1.6757e-07,
                    1.8112e-07,
                    1.9472e-07,
                    2.0839e-07,
                    2.2211e-07,
                    2.359e-07,
                    2.4975e-07,
                    2.6367e-07,
                    2.7777e-07,
                    2.9224e-07,
                    3.0721e-07,
                    3.2279e-07,
                    3.3903e-07,
                    3.5595e-07,
                    3.7352e-07,
                    3.9167e-07,
                    4.1028e-07,
                    4.2919e-07,
                    4.483e-07,
                    4.6757e-07,
                    4.87e-07,
                    5.0657e-07,
                    5.2627e-07,
                    5.461e-07,
                    5.6606e-07,
                    5.8614e-07,
                    6.0637e-07,
                    6.3192e-07,
                    6.578e-07,
                    6.8425e-07,
                    7.1149e-07,
                    7.3973e-07,
                    7.6913e-07,
                    7.9985e-07,
                    8.32e-07,
                    8.6569e-07,
                    9.01e-07,
                    9.3798e-07,
                    9.7723e-07,
                    1.0198e-06,
                    1.0663e-06,
                    1.1173e-06,
                    1.1731e-06,
                    1.2334e-06,
                    1.298e-06,
                    1.3663e-06,
                    1.4374e-06,
                    1.5102e-06,
                    1.584e-06,
                    1.6587e-06,
                    1.7344e-06,
                    1.8108e-06,
                    1.888e-06,
                    1.9659e-06,
                    2.0443e-06,
                    2.1233e-06,
                    2.2027e-06,
                    2.2824e-06,
                    2.3622e-06,
                    2.4417e-06,
                    2.5207e-06,
                    2.5991e-06,
                    2.6768e-06,
                    2.7537e-06,
                    2.83e-06,
                    2.9058e-06,
                    2.9813e-06,
                    3.0569e-06,
                    3.1331e-06,
                    3.2104e-06,
                    3.2894e-06,
                    3.3706e-06,
                    3.4542e-06,
                    3.5405e-06,
                    3.6295e-06,
                    3.7214e-06,
                    3.8161e-06,
                    3.9134e-06,
                    4.016e-06,
                    4.1291e-06,
                    4.2564e-06,
                    4.4007e-06,
                    4.5636e-06,
                    4.7455e-06,
                    4.9458e-06,
                    5.1626e-06,
                    5.3929e-06,
                    5.6327e-06,
                    5.8819e-06,
                    6.1446e-06,
                    6.4238e-06,
                    6.7217e-06,
                    7.0397e-06,
                    7.378e-06,
                    7.736e-06,
                    8.1121e-06,
                    8.5038e-06,
                    8.9076e-06,
                    9.3178e-06,
                    9.7455e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_N2O": 0.03,
                "Fossil_N2O_timeseries": [
                    6.8683e-09,
                    1.3818e-08,
                    2.0847e-08,
                    2.7955e-08,
                    3.5139e-08,
                    4.2398e-08,
                    4.9727e-08,
                    5.7125e-08,
                    6.4587e-08,
                    7.2109e-08,
                    7.9689e-08,
                    8.7326e-08,
                    9.5019e-08,
                    1.0277e-07,
                    1.1057e-07,
                    1.1844e-07,
                    1.2635e-07,
                    1.3433e-07,
                    1.4236e-07,
                    1.5045e-07,
                    1.5862e-07,
                    1.669e-07,
                    1.7534e-07,
                    1.8394e-07,
                    1.9271e-07,
                    2.0167e-07,
                    2.1081e-07,
                    2.201e-07,
                    2.2953e-07,
                    2.3907e-07,
                    2.4868e-07,
                    2.5838e-07,
                    2.6815e-07,
                    2.78e-07,
                    2.8791e-07,
                    2.979e-07,
                    3.0795e-07,
                    3.1807e-07,
                    3.2827e-07,
                    3.3869e-07,
                    3.4922e-07,
                    3.5987e-07,
                    3.7064e-07,
                    3.8154e-07,
                    3.9256e-07,
                    4.0372e-07,
                    4.1501e-07,
                    4.2645e-07,
                    4.3803e-07,
                    4.4976e-07,
                    4.6165e-07,
                    4.7371e-07,
                    4.8595e-07,
                    4.9839e-07,
                    5.1101e-07,
                    5.2384e-07,
                    5.3687e-07,
                    5.5009e-07,
                    5.635e-07,
                    5.771e-07,
                    5.9087e-07,
                    6.0482e-07,
                    6.1894e-07,
                    6.3323e-07,
                    6.4769e-07,
                    6.6232e-07,
                    6.7711e-07,
                    6.9208e-07,
                    7.0722e-07,
                    7.2252e-07,
                    7.38e-07,
                    7.5365e-07,
                    7.6947e-07,
                    7.8545e-07,
                    8.0161e-07,
                    8.1793e-07,
                    8.3443e-07,
                    8.5111e-07,
                    8.6796e-07,
                    8.85e-07,
                    9.0221e-07,
                    9.1961e-07,
                    9.372e-07,
                    9.5497e-07,
                    9.7294e-07,
                    9.911e-07,
                    1.0095e-06,
                    1.0281e-06,
                    1.0469e-06,
                    1.066e-06,
                    1.0854e-06,
                    1.1052e-06,
                    1.1255e-06,
                    1.1463e-06,
                    1.1678e-06,
                    1.1899e-06,
                    1.2126e-06,
                    1.236e-06,
                    1.2599e-06,
                    1.2845e-06,
                    1.3097e-06,
                    1.3357e-06,
                    1.3626e-06,
                    1.3904e-06,
                    1.4193e-06,
                    1.4493e-06,
                    1.4803e-06,
                    1.5125e-06,
                    1.5458e-06,
                    1.58e-06,
                    1.6152e-06,
                    1.6511e-06,
                    1.6879e-06,
                    1.7254e-06,
                    1.7637e-06,
                    1.803e-06,
                    1.8434e-06,
                    1.8851e-06,
                    1.9284e-06,
                    1.9723e-06,
                    2.0158e-06,
                    2.0598e-06,
                    2.1066e-06,
                    2.1555e-06,
                    2.2066e-06,
                    2.2607e-06,
                    2.3185e-06,
                    2.3752e-06,
                    2.4249e-06,
                    2.4779e-06,
                    2.5346e-06,
                    2.594e-06,
                    2.6589e-06,
                    2.7216e-06,
                    2.7839e-06,
                    2.852e-06,
                    2.9202e-06,
                    2.9854e-06,
                    3.0451e-06,
                    3.1084e-06,
                    3.1735e-06,
                    3.2394e-06,
                    3.3057e-06,
                    3.3747e-06,
                    3.4469e-06,
                    3.5233e-06,
                    3.607e-06,
                    3.6963e-06,
                    3.791e-06,
                    3.8857e-06,
                    3.9786e-06,
                    4.0721e-06,
                    4.1663e-06,
                    4.2638e-06,
                    4.3609e-06,
                    4.4618e-06,
                    4.5663e-06,
                    4.6692e-06,
                    4.7732e-06,
                    4.8793e-06,
                    4.9879e-06,
                    5.0991e-06,
                    5.2102e-06,
                    5.3256e-06,
                    5.4453e-06,
                    5.5679e-06,
                    5.6924e-06,
                    5.8137e-06,
                    5.939e-06,
                    6.0644e-06,
                    6.1959e-06,
                    6.3303e-06
                ],
                "Land_N2O": 0.1,
                "Land_N2O_timeseries": [
                    5.1451e-09,
                    1.0393e-08,
                    1.574e-08,
                    2.1179e-08,
                    2.6702e-08,
                    3.23e-08,
                    3.7963e-08,
                    4.3676e-08,
                    4.9425e-08,
                    5.5195e-08,
                    6.0975e-08,
                    6.6761e-08,
                    7.2554e-08,
                    7.835e-08,
                    8.4149e-08,
                    8.9952e-08,
                    9.576e-08,
                    1.0157e-07,
                    1.0739e-07,
                    1.1323e-07,
                    1.1915e-07,
                    1.2533e-07,
                    1.3187e-07,
                    1.3885e-07,
                    1.4632e-07,
                    1.5428e-07,
                    1.6272e-07,
                    1.7157e-07,
                    1.8075e-07,
                    1.9013e-07,
                    1.9961e-07,
                    2.0919e-07,
                    2.1885e-07,
                    2.2858e-07,
                    2.3836e-07,
                    2.4821e-07,
                    2.5811e-07,
                    2.6807e-07,
                    2.781e-07,
                    2.9323e-07,
                    3.0858e-07,
                    3.2438e-07,
                    3.4085e-07,
                    3.5819e-07,
                    3.7657e-07,
                    3.9613e-07,
                    4.1699e-07,
                    4.3925e-07,
                    4.6297e-07,
                    4.8822e-07,
                    5.1558e-07,
                    5.4605e-07,
                    5.8036e-07,
                    6.1895e-07,
                    6.6204e-07,
                    7.0955e-07,
                    7.6114e-07,
                    8.1622e-07,
                    8.7392e-07,
                    9.3312e-07,
                    9.9313e-07,
                    1.0539e-06,
                    1.1154e-06,
                    1.1776e-06,
                    1.2403e-06,
                    1.3035e-06,
                    1.3672e-06,
                    1.4312e-06,
                    1.4955e-06,
                    1.5599e-06,
                    1.6242e-06,
                    1.688e-06,
                    1.7513e-06,
                    1.8137e-06,
                    1.8752e-06,
                    1.9358e-06,
                    1.9956e-06,
                    2.0547e-06,
                    2.1134e-06,
                    2.1719e-06,
                    2.2309e-06,
                    2.2908e-06,
                    2.3522e-06,
                    2.4156e-06,
                    2.4813e-06,
                    2.5494e-06,
                    2.62e-06,
                    2.6933e-06,
                    2.7692e-06,
                    2.8474e-06,
                    2.9306e-06,
                    3.0239e-06,
                    3.1309e-06,
                    3.2544e-06,
                    3.3958e-06,
                    3.5557e-06,
                    3.7332e-06,
                    3.9266e-06,
                    4.133e-06,
                    4.3482e-06,
                    4.5722e-06,
                    4.8089e-06,
                    5.0612e-06,
                    5.3313e-06,
                    5.6204e-06,
                    5.9287e-06,
                    6.2556e-06,
                    6.5996e-06,
                    6.958e-06,
                    7.3276e-06,
                    7.7026e-06,
                    8.0943e-06,
                    8.5198e-06,
                    8.9643e-06,
                    9.4401e-06,
                    9.9341e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -83.14499,
                            14.99813
                        ],
                        [
                            -83.27118,
                            14.98362
                        ],
                        [
                            -83.40238,
                            15.02479
                        ],
                        [
                            -83.46551,
                            14.97604
                        ],
                        [
                            -83.50737,
                            14.99715
                        ],
                        [
                            -83.56615,
                            14.90709
                        ],
                        [
                            -83.68836,
                            14.86214
                        ],
                        [
                            -83.70679,
                            14.82733
                        ],
                        [
                            -83.78446,
                            14.8124
                        ],
                        [
                            -83.85138,
                            14.76812
                        ],
                        [
                            -83.93487,
                            14.76732
                        ],
                        [
                            -84.10052,
                            14.73713
                        ],
                        [
                            -84.17726,
                            14.70844
                        ],
                        [
                            -84.22504,
                            14.72943
                        ],
                        [
                            -84.25647,
                            14.67415
                        ],
                        [
                            -84.34579,
                            14.67513
                        ],
                        [
                            -84.49576,
                            14.62096
                        ],
                        [
                            -84.7125,
                            14.6878
                        ],
                        [
                            -84.75463,
                            14.76534
                        ],
                        [
                            -84.82137,
                            14.82268
                        ],
                        [
                            -84.90249,
                            14.80783
                        ],
                        [
                            -84.92872,
                            14.7588
                        ],
                        [
                            -85.02572,
                            14.69965
                        ],
                        [
                            -85.02671,
                            14.60111
                        ],
                        [
                            -85.13918,
                            14.51413
                        ],
                        [
                            -85.20683,
                            14.39028
                        ],
                        [
                            -85.16003,
                            14.29589
                        ],
                        [
                            -85.1839,
                            14.25129
                        ],
                        [
                            -85.33441,
                            14.24607
                        ],
                        [
                            -85.37548,
                            14.20751
                        ],
                        [
                            -85.39721,
                            14.13937
                        ],
                        [
                            -85.58346,
                            14.0468
                        ],
                        [
                            -85.67896,
                            13.98194
                        ],
                        [
                            -85.75504,
                            13.9615
                        ],
                        [
                            -85.77076,
                            13.84344
                        ],
                        [
                            -85.81645,
                            13.84363
                        ],
                        [
                            -85.85507,
                            13.91449
                        ],
                        [
                            -85.91543,
                            13.90655
                        ],
                        [
                            -86.01245,
                            13.98804
                        ],
                        [
                            -86.01468,
                            14.07551
                        ],
                        [
                            -86.09198,
                            14.06328
                        ],
                        [
                            -86.13834,
                            14.00163
                        ],
                        [
                            -86.29951,
                            13.84522
                        ],
                        [
                            -86.34812,
                            13.76157
                        ],
                        [
                            -86.4986,
                            13.76969
                        ],
                        [
                            -86.5358,
                            13.79766
                        ],
                        [
                            -86.76022,
                            13.77215
                        ],
                        [
                            -86.78312,
                            13.66937
                        ],
                        [
                            -86.75339,
                            13.63577
                        ],
                        [
                            -86.71047,
                            13.36654
                        ],
                        [
                            -86.70749,
                            13.29645
                        ],
                        [
                            -86.75498,
                            13.26826
                        ],
                        [
                            -86.81256,
                            13.30231
                        ],
                        [
                            -86.90413,
                            13.25814
                        ],
                        [
                            -86.9283,
                            13.17867
                        ],
                        [
                            -86.921,
                            13.08844
                        ],
                        [
                            -86.96323,
                            13.02946
                        ],
                        [
                            -87.03182,
                            12.98828
                        ],
                        [
                            -87.12162,
                            12.9979
                        ],
                        [
                            -87.31081,
                            12.98272
                        ],
                        [
                            -87.37079,
                            12.95075
                        ],
                        [
                            -87.47166,
                            12.9379
                        ],
                        [
                            -87.5157,
                            13.02392
                        ],
                        [
                            -87.5863,
                            13.05357
                        ],
                        [
                            -87.66133,
                            12.986
                        ],
                        [
                            -87.68969,
                            12.91386
                        ],
                        [
                            -87.52628,
                            12.8008
                        ],
                        [
                            -87.39823,
                            12.69174
                        ],
                        [
                            -87.34525,
                            12.60737
                        ],
                        [
                            -87.21202,
                            12.52868
                        ],
                        [
                            -87.17066,
                            12.45618
                        ],
                        [
                            -86.76677,
                            12.19138
                        ],
                        [
                            -86.73348,
                            12.09433
                        ],
                        [
                            -86.61487,
                            11.90535
                        ],
                        [
                            -86.52716,
                            11.81279
                        ],
                        [
                            -86.51802,
                            11.77563
                        ],
                        [
                            -86.40176,
                            11.69355
                        ],
                        [
                            -86.35348,
                            11.638
                        ],
                        [
                            -86.20852,
                            11.55066
                        ],
                        [
                            -86.1585,
                            11.48297
                        ],
                        [
                            -86.09196,
                            11.44613
                        ],
                        [
                            -85.99176,
                            11.34802
                        ],
                        [
                            -85.91996,
                            11.30291
                        ],
                        [
                            -85.81462,
                            11.17816
                        ],
                        [
                            -85.78941,
                            11.1178
                        ],
                        [
                            -85.69482,
                            11.08033
                        ],
                        [
                            -85.60969,
                            11.2168
                        ],
                        [
                            -85.55876,
                            11.20817
                        ],
                        [
                            -85.5196,
                            11.16228
                        ],
                        [
                            -85.41627,
                            11.12478
                        ],
                        [
                            -85.35611,
                            11.12346
                        ],
                        [
                            -85.20742,
                            11.05012
                        ],
                        [
                            -84.91425,
                            10.94139
                        ],
                        [
                            -84.6803,
                            11.07885
                        ],
                        [
                            -84.60873,
                            11.03924
                        ],
                        [
                            -84.48898,
                            11.001
                        ],
                        [
                            -84.41928,
                            10.95793
                        ],
                        [
                            -84.35935,
                            10.99208
                        ],
                        [
                            -84.32884,
                            10.91606
                        ],
                        [
                            -84.2241,
                            10.86477
                        ],
                        [
                            -84.23874,
                            10.81389
                        ],
                        [
                            -84.20274,
                            10.78156
                        ],
                        [
                            -84.136,
                            10.78771
                        ],
                        [
                            -84.07212,
                            10.76386
                        ],
                        [
                            -84.03463,
                            10.78702
                        ],
                        [
                            -83.9298,
                            10.70823
                        ],
                        [
                            -83.86712,
                            10.71933
                        ],
                        [
                            -83.79333,
                            10.76666
                        ],
                        [
                            -83.67767,
                            10.79499
                        ],
                        [
                            -83.67195,
                            10.88015
                        ],
                        [
                            -83.69285,
                            10.9389
                        ],
                        [
                            -83.75611,
                            10.97916
                        ],
                        [
                            -83.84004,
                            11.14681
                        ],
                        [
                            -83.87498,
                            11.29379
                        ],
                        [
                            -83.86528,
                            11.39625
                        ],
                        [
                            -83.79932,
                            11.44888
                        ],
                        [
                            -83.75169,
                            11.55807
                        ],
                        [
                            -83.65471,
                            11.63173
                        ],
                        [
                            -83.70434,
                            11.85205
                        ],
                        [
                            -83.77834,
                            11.80072
                        ],
                        [
                            -83.83701,
                            11.87517
                        ],
                        [
                            -83.77085,
                            11.95023
                        ],
                        [
                            -83.76346,
                            12.03104
                        ],
                        [
                            -83.68742,
                            12.01755
                        ],
                        [
                            -83.68536,
                            12.16695
                        ],
                        [
                            -83.65919,
                            12.3312
                        ],
                        [
                            -83.72752,
                            12.33625
                        ],
                        [
                            -83.73453,
                            12.46759
                        ],
                        [
                            -83.78177,
                            12.48844
                        ],
                        [
                            -83.75249,
                            12.54755
                        ],
                        [
                            -83.69967,
                            12.55347
                        ],
                        [
                            -83.60282,
                            12.62793
                        ],
                        [
                            -83.60331,
                            12.68978
                        ],
                        [
                            -83.65149,
                            12.79478
                        ],
                        [
                            -83.61492,
                            12.81908
                        ],
                        [
                            -83.54991,
                            12.79177
                        ],
                        [
                            -83.57102,
                            12.67588
                        ],
                        [
                            -83.56275,
                            12.59933
                        ],
                        [
                            -83.63573,
                            12.56515
                        ],
                        [
                            -83.63766,
                            12.48004
                        ],
                        [
                            -83.56482,
                            12.39223
                        ],
                        [
                            -83.49202,
                            12.39832
                        ],
                        [
                            -83.48892,
                            12.4641
                        ],
                        [
                            -83.52621,
                            12.52666
                        ],
                        [
                            -83.54464,
                            12.65557
                        ],
                        [
                            -83.50715,
                            12.89761
                        ],
                        [
                            -83.55428,
                            13.1121
                        ],
                        [
                            -83.57164,
                            13.31644
                        ],
                        [
                            -83.55759,
                            13.44212
                        ],
                        [
                            -83.52721,
                            13.53877
                        ],
                        [
                            -83.4966,
                            13.76821
                        ],
                        [
                            -83.44286,
                            13.93957
                        ],
                        [
                            -83.4026,
                            14.01804
                        ],
                        [
                            -83.3575,
                            14.04747
                        ],
                        [
                            -83.29177,
                            14.13861
                        ],
                        [
                            -83.21019,
                            14.29496
                        ],
                        [
                            -83.21786,
                            14.44632
                        ],
                        [
                            -83.27482,
                            14.60573
                        ],
                        [
                            -83.31,
                            14.77473
                        ],
                        [
                            -83.26449,
                            14.89475
                        ],
                        [
                            -83.14499,
                            14.99813
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "NER",
                "Country": "Niger",
                "Total_3GHG": 0.1,
                "Total_3GHG_timeseries": [
                    4.9952e-07,
                    9.8189e-07,
                    1.4516e-06,
                    1.9112e-06,
                    2.3626e-06,
                    2.8073e-06,
                    3.2461e-06,
                    3.6799e-06,
                    4.109e-06,
                    4.543e-06,
                    4.9822e-06,
                    5.425e-06,
                    5.8717e-06,
                    6.329e-06,
                    6.7835e-06,
                    7.2409e-06,
                    7.7072e-06,
                    8.1703e-06,
                    8.6344e-06,
                    9.1128e-06,
                    9.6014e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017
                ],
                "Fossil_3GHG": 0.02,
                "Fossil_3GHG_timeseries": [
                    3.5548e-08,
                    7.1189e-08,
                    1.0692e-07,
                    1.4274e-07,
                    1.7865e-07,
                    2.1464e-07,
                    2.5071e-07,
                    2.8685e-07,
                    3.2306e-07,
                    3.5932e-07,
                    3.9612e-07,
                    4.3344e-07,
                    4.7215e-07,
                    5.1139e-07,
                    5.5115e-07,
                    5.9145e-07,
                    6.3227e-07,
                    6.7362e-07,
                    7.1549e-07,
                    7.579e-07,
                    8.0089e-07,
                    8.4452e-07,
                    8.8882e-07,
                    9.3385e-07,
                    9.7961e-07,
                    1.0261e-06,
                    1.0733e-06,
                    1.1213e-06,
                    1.1699e-06,
                    1.2191e-06,
                    1.2685e-06,
                    1.318e-06,
                    1.3668e-06,
                    1.4173e-06,
                    1.4708e-06,
                    1.5275e-06,
                    1.5874e-06,
                    1.6506e-06,
                    1.7171e-06,
                    1.7872e-06,
                    1.8608e-06,
                    1.9381e-06,
                    2.019e-06,
                    2.1037e-06,
                    2.1923e-06,
                    2.2848e-06,
                    2.3814e-06,
                    2.4821e-06,
                    2.587e-06,
                    2.6962e-06,
                    2.812e-06,
                    2.9345e-06,
                    3.064e-06,
                    3.1993e-06,
                    3.3392e-06,
                    3.4839e-06,
                    3.6335e-06,
                    3.7883e-06,
                    3.9484e-06,
                    4.1139e-06,
                    4.2906e-06,
                    4.5041e-06,
                    4.7289e-06,
                    4.9654e-06,
                    5.2084e-06,
                    5.458e-06,
                    5.7142e-06,
                    5.9769e-06,
                    6.2461e-06,
                    6.5217e-06,
                    6.8029e-06,
                    7.0895e-06,
                    7.3814e-06,
                    7.6784e-06,
                    7.9803e-06,
                    8.2887e-06,
                    8.6305e-06,
                    9.0102e-06,
                    9.4214e-06,
                    9.8661e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_3GHG": 0.26,
                "Land_3GHG_timeseries": [
                    4.6397e-07,
                    9.107e-07,
                    1.3446e-06,
                    1.7685e-06,
                    2.184e-06,
                    2.5927e-06,
                    2.9954e-06,
                    3.3931e-06,
                    3.786e-06,
                    4.1837e-06,
                    4.5861e-06,
                    4.9916e-06,
                    5.3995e-06,
                    5.8176e-06,
                    6.2323e-06,
                    6.6495e-06,
                    7.075e-06,
                    7.4967e-06,
                    7.9189e-06,
                    8.3549e-06,
                    8.8005e-06,
                    9.2555e-06,
                    9.7236e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015
                ],
                "Total_CO2": 0.05,
                "Total_CO2_timeseries": [
                    1.0988e-07,
                    2.0081e-07,
                    2.7728e-07,
                    3.4207e-07,
                    3.971e-07,
                    4.4397e-07,
                    4.8371e-07,
                    5.1749e-07,
                    5.4572e-07,
                    5.7817e-07,
                    6.1071e-07,
                    6.4154e-07,
                    6.7022e-07,
                    7.0446e-07,
                    7.3063e-07,
                    7.5468e-07,
                    7.8239e-07,
                    8.0167e-07,
                    8.1676e-07,
                    8.409e-07,
                    8.6863e-07,
                    8.9739e-07,
                    9.2929e-07,
                    9.5839e-07,
                    9.862e-07,
                    1.0124e-06,
                    1.0418e-06,
                    1.0674e-06,
                    1.0899e-06,
                    1.1342e-06,
                    1.1851e-06,
                    1.2417e-06,
                    1.2938e-06,
                    1.3426e-06,
                    1.3943e-06,
                    1.4411e-06,
                    1.4855e-06,
                    1.5282e-06,
                    1.5715e-06,
                    1.6372e-06,
                    1.713e-06,
                    1.7948e-06,
                    1.8836e-06,
                    1.9674e-06,
                    2.0509e-06,
                    2.1466e-06,
                    2.2653e-06,
                    2.4357e-06,
                    2.6863e-06,
                    3.0958e-06,
                    3.705e-06,
                    4.5318e-06,
                    5.5866e-06,
                    6.8905e-06,
                    8.4524e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.2777e-08,
                    2.3461e-08,
                    3.5408e-08,
                    4.5334e-08,
                    5.7028e-08,
                    6.8686e-08,
                    8.2185e-08,
                    9.6009e-08,
                    1.0756e-07,
                    1.1746e-07,
                    1.3066e-07,
                    1.5541e-07,
                    1.8511e-07,
                    2.2471e-07,
                    2.6761e-07,
                    3.0886e-07,
                    3.6988e-07,
                    4.2924e-07,
                    5.018e-07,
                    5.8756e-07,
                    6.8486e-07,
                    7.886e-07,
                    9.0209e-07,
                    1.0493e-06,
                    1.1791e-06,
                    1.3289e-06,
                    1.4778e-06,
                    1.6414e-06,
                    1.8276e-06,
                    2.0419e-06,
                    2.2969e-06,
                    2.6033e-06,
                    2.9375e-06,
                    3.3689e-06,
                    3.8133e-06,
                    4.2591e-06,
                    4.6619e-06,
                    5.109e-06,
                    5.5517e-06,
                    6.0173e-06,
                    6.287e-06,
                    6.542e-06,
                    6.7782e-06,
                    7.0477e-06,
                    7.3076e-06,
                    7.5589e-06,
                    7.8466e-06,
                    8.1367e-06,
                    8.4502e-06,
                    8.7571e-06,
                    9.0665e-06,
                    9.3574e-06,
                    9.6657e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CO2": 0.17,
                "Land_CO2_timeseries": [
                    1.0988e-07,
                    2.0081e-07,
                    2.7728e-07,
                    3.4207e-07,
                    3.971e-07,
                    4.4397e-07,
                    4.8371e-07,
                    5.1749e-07,
                    5.4572e-07,
                    5.7817e-07,
                    6.1071e-07,
                    6.4154e-07,
                    6.7022e-07,
                    7.0446e-07,
                    7.3063e-07,
                    7.5468e-07,
                    7.8239e-07,
                    8.0167e-07,
                    8.1676e-07,
                    8.409e-07,
                    8.6863e-07,
                    8.9739e-07,
                    9.2929e-07,
                    9.5839e-07,
                    9.862e-07,
                    1.0124e-06,
                    1.0418e-06,
                    1.0674e-06,
                    1.0899e-06,
                    1.1342e-06,
                    1.1851e-06,
                    1.2417e-06,
                    1.2938e-06,
                    1.3426e-06,
                    1.3943e-06,
                    1.4411e-06,
                    1.4855e-06,
                    1.5282e-06,
                    1.5715e-06,
                    1.6372e-06,
                    1.713e-06,
                    1.7948e-06,
                    1.8836e-06,
                    1.9674e-06,
                    2.0509e-06,
                    2.1466e-06,
                    2.2653e-06,
                    2.4357e-06,
                    2.6863e-06,
                    3.0958e-06,
                    3.705e-06,
                    4.5318e-06,
                    5.5866e-06,
                    6.8905e-06,
                    8.4524e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006
                ],
                "Total_CH4": 0.21,
                "Total_CH4_timeseries": [
                    3.0996e-07,
                    6.2018e-07,
                    9.3065e-07,
                    1.2414e-06,
                    1.5524e-06,
                    1.8636e-06,
                    2.1751e-06,
                    2.4868e-06,
                    2.7988e-06,
                    3.1111e-06,
                    3.4284e-06,
                    3.7507e-06,
                    4.079e-06,
                    4.4124e-06,
                    4.7508e-06,
                    5.0943e-06,
                    5.4429e-06,
                    5.7965e-06,
                    6.1552e-06,
                    6.519e-06,
                    6.888e-06,
                    7.2621e-06,
                    7.6415e-06,
                    8.0261e-06,
                    8.4159e-06,
                    8.8109e-06,
                    9.2111e-06,
                    9.6165e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009
                ],
                "Fossil_CH4": 0.06,
                "Fossil_CH4_timeseries": [
                    3.0146e-08,
                    6.0311e-08,
                    9.0495e-08,
                    1.207e-07,
                    1.5092e-07,
                    1.8116e-07,
                    2.1142e-07,
                    2.417e-07,
                    2.72e-07,
                    3.0231e-07,
                    3.3312e-07,
                    3.6442e-07,
                    3.9707e-07,
                    4.3022e-07,
                    4.6385e-07,
                    4.9798e-07,
                    5.3261e-07,
                    5.6773e-07,
                    6.0334e-07,
                    6.3944e-07,
                    6.7605e-07,
                    7.1316e-07,
                    7.5078e-07,
                    7.8891e-07,
                    8.2754e-07,
                    8.6668e-07,
                    9.0632e-07,
                    9.4647e-07,
                    9.8713e-07,
                    1.0283e-06,
                    1.0695e-06,
                    1.1108e-06,
                    1.1514e-06,
                    1.1935e-06,
                    1.2387e-06,
                    1.2869e-06,
                    1.3383e-06,
                    1.3929e-06,
                    1.4508e-06,
                    1.5121e-06,
                    1.5768e-06,
                    1.6451e-06,
                    1.7169e-06,
                    1.7924e-06,
                    1.8716e-06,
                    1.9546e-06,
                    2.0416e-06,
                    2.1326e-06,
                    2.2277e-06,
                    2.3269e-06,
                    2.4326e-06,
                    2.5448e-06,
                    2.6638e-06,
                    2.7884e-06,
                    2.9174e-06,
                    3.051e-06,
                    3.1894e-06,
                    3.3327e-06,
                    3.4811e-06,
                    3.6348e-06,
                    3.7995e-06,
                    4.001e-06,
                    4.2136e-06,
                    4.4377e-06,
                    4.6682e-06,
                    4.9052e-06,
                    5.1486e-06,
                    5.3984e-06,
                    5.6545e-06,
                    5.917e-06,
                    6.1849e-06,
                    6.458e-06,
                    6.7363e-06,
                    7.0195e-06,
                    7.3076e-06,
                    7.602e-06,
                    7.9296e-06,
                    8.2949e-06,
                    8.6917e-06,
                    9.1217e-06,
                    9.5836e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_CH4": 0.45,
                "Land_CH4_timeseries": [
                    2.7982e-07,
                    5.5987e-07,
                    8.4016e-07,
                    1.1207e-06,
                    1.4014e-06,
                    1.6824e-06,
                    1.9637e-06,
                    2.2451e-06,
                    2.5268e-06,
                    2.8087e-06,
                    3.0952e-06,
                    3.3863e-06,
                    3.682e-06,
                    3.9822e-06,
                    4.287e-06,
                    4.5964e-06,
                    4.9103e-06,
                    5.2288e-06,
                    5.5519e-06,
                    5.8796e-06,
                    6.2119e-06,
                    6.549e-06,
                    6.8907e-06,
                    7.2372e-06,
                    7.5883e-06,
                    7.9442e-06,
                    8.3048e-06,
                    8.67e-06,
                    9.04e-06,
                    9.4146e-06,
                    9.79e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Total_N2O": 0.23,
                "Total_N2O_timeseries": [
                    7.9672e-08,
                    1.609e-07,
                    2.4363e-07,
                    3.2776e-07,
                    4.1318e-07,
                    4.9974e-07,
                    5.8728e-07,
                    6.7561e-07,
                    7.6452e-07,
                    8.5375e-07,
                    9.4317e-07,
                    1.0327e-06,
                    1.1224e-06,
                    1.2122e-06,
                    1.302e-06,
                    1.3919e-06,
                    1.482e-06,
                    1.5721e-06,
                    1.6624e-06,
                    1.7529e-06,
                    1.8448e-06,
                    1.9405e-06,
                    2.0416e-06,
                    2.1492e-06,
                    2.2641e-06,
                    2.3865e-06,
                    2.5158e-06,
                    2.6514e-06,
                    2.7919e-06,
                    2.9353e-06,
                    3.0803e-06,
                    3.2268e-06,
                    3.3745e-06,
                    3.5232e-06,
                    3.6729e-06,
                    3.8234e-06,
                    3.9749e-06,
                    4.1272e-06,
                    4.2806e-06,
                    4.4418e-06,
                    4.6045e-06,
                    4.7689e-06,
                    4.9349e-06,
                    5.1027e-06,
                    5.2724e-06,
                    5.4439e-06,
                    5.6174e-06,
                    5.7929e-06,
                    5.9705e-06,
                    6.1502e-06,
                    6.332e-06,
                    6.5158e-06,
                    6.7017e-06,
                    6.8897e-06,
                    7.0799e-06,
                    7.2725e-06,
                    7.4678e-06,
                    7.6661e-06,
                    7.8678e-06,
                    8.0732e-06,
                    8.2842e-06,
                    8.5035e-06,
                    8.7332e-06,
                    8.9751e-06,
                    9.2305e-06,
                    9.5002e-06,
                    9.7845e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_N2O": 0.04,
                "Fossil_N2O_timeseries": [
                    5.4022e-09,
                    1.0879e-08,
                    1.6428e-08,
                    2.2047e-08,
                    2.7733e-08,
                    3.3482e-08,
                    3.929e-08,
                    4.5152e-08,
                    5.1061e-08,
                    5.7011e-08,
                    6.2999e-08,
                    6.9022e-08,
                    7.508e-08,
                    8.1173e-08,
                    8.73e-08,
                    9.3462e-08,
                    9.9659e-08,
                    1.0589e-07,
                    1.1216e-07,
                    1.1846e-07,
                    1.2484e-07,
                    1.3135e-07,
                    1.3804e-07,
                    1.4494e-07,
                    1.5207e-07,
                    1.5943e-07,
                    1.6701e-07,
                    1.7479e-07,
                    1.8274e-07,
                    1.908e-07,
                    1.9893e-07,
                    2.0714e-07,
                    2.1541e-07,
                    2.2374e-07,
                    2.3213e-07,
                    2.4058e-07,
                    2.4908e-07,
                    2.5764e-07,
                    2.6625e-07,
                    2.7507e-07,
                    2.8398e-07,
                    2.93e-07,
                    3.0212e-07,
                    3.1135e-07,
                    3.207e-07,
                    3.3016e-07,
                    3.3975e-07,
                    3.4946e-07,
                    3.593e-07,
                    3.6929e-07,
                    3.7942e-07,
                    3.8972e-07,
                    4.0021e-07,
                    4.1089e-07,
                    4.2177e-07,
                    4.3285e-07,
                    4.4413e-07,
                    4.5561e-07,
                    4.6725e-07,
                    4.7906e-07,
                    4.9102e-07,
                    5.0311e-07,
                    5.1535e-07,
                    5.2772e-07,
                    5.4022e-07,
                    5.5286e-07,
                    5.6563e-07,
                    5.7853e-07,
                    5.9156e-07,
                    6.0474e-07,
                    6.1805e-07,
                    6.3151e-07,
                    6.4511e-07,
                    6.5885e-07,
                    6.7274e-07,
                    6.8677e-07,
                    7.0095e-07,
                    7.1528e-07,
                    7.2976e-07,
                    7.4441e-07,
                    7.5922e-07,
                    7.7422e-07,
                    7.8942e-07,
                    8.0485e-07,
                    8.2051e-07,
                    8.3643e-07,
                    8.5261e-07,
                    8.6907e-07,
                    8.8583e-07,
                    9.029e-07,
                    9.2039e-07,
                    9.3849e-07,
                    9.5738e-07,
                    9.7716e-07,
                    9.979e-07,
                    1.0196e-06,
                    1.0424e-06,
                    1.0661e-06,
                    1.0907e-06,
                    1.116e-06,
                    1.142e-06,
                    1.1687e-06,
                    1.1961e-06,
                    1.2242e-06,
                    1.253e-06,
                    1.2826e-06,
                    1.3128e-06,
                    1.3437e-06,
                    1.3753e-06,
                    1.4075e-06,
                    1.4405e-06,
                    1.4742e-06,
                    1.5088e-06,
                    1.5443e-06,
                    1.5808e-06,
                    1.6182e-06,
                    1.6568e-06,
                    1.6963e-06,
                    1.7369e-06,
                    1.7818e-06,
                    1.8279e-06,
                    1.8755e-06,
                    1.9247e-06,
                    1.9761e-06,
                    2.03e-06,
                    2.0885e-06,
                    2.1492e-06,
                    2.2129e-06,
                    2.2792e-06,
                    2.347e-06,
                    2.4177e-06,
                    2.4912e-06,
                    2.5678e-06,
                    2.6413e-06,
                    2.7145e-06,
                    2.797e-06,
                    2.8832e-06,
                    2.9711e-06,
                    3.0636e-06,
                    3.1519e-06,
                    3.2421e-06,
                    3.3353e-06,
                    3.431e-06,
                    3.5318e-06,
                    3.6364e-06,
                    3.7453e-06,
                    3.8661e-06,
                    3.9932e-06,
                    4.126e-06,
                    4.2278e-06,
                    4.3332e-06,
                    4.4423e-06,
                    4.5572e-06,
                    4.6789e-06,
                    4.8072e-06,
                    4.9407e-06,
                    5.0807e-06,
                    5.2281e-06,
                    5.3835e-06,
                    5.5478e-06,
                    5.7078e-06,
                    5.881e-06,
                    6.0741e-06,
                    6.275e-06,
                    6.483e-06,
                    6.6988e-06,
                    6.9233e-06,
                    7.1594e-06,
                    7.4019e-06,
                    7.6557e-06,
                    7.9172e-06,
                    8.1817e-06
                ],
                "Land_N2O": 0.31,
                "Land_N2O_timeseries": [
                    7.427e-08,
                    1.5003e-07,
                    2.272e-07,
                    3.0571e-07,
                    3.8544e-07,
                    4.6626e-07,
                    5.4799e-07,
                    6.3046e-07,
                    7.1346e-07,
                    7.9674e-07,
                    8.8017e-07,
                    9.637e-07,
                    1.0473e-06,
                    1.131e-06,
                    1.2147e-06,
                    1.2985e-06,
                    1.3823e-06,
                    1.4662e-06,
                    1.5502e-06,
                    1.6344e-06,
                    1.72e-06,
                    1.8092e-06,
                    1.9035e-06,
                    2.0043e-06,
                    2.1121e-06,
                    2.227e-06,
                    2.3488e-06,
                    2.4767e-06,
                    2.6091e-06,
                    2.7445e-06,
                    2.8814e-06,
                    3.0197e-06,
                    3.1591e-06,
                    3.2995e-06,
                    3.4408e-06,
                    3.5829e-06,
                    3.7258e-06,
                    3.8696e-06,
                    4.0143e-06,
                    4.1667e-06,
                    4.3206e-06,
                    4.4759e-06,
                    4.6328e-06,
                    4.7914e-06,
                    4.9517e-06,
                    5.1138e-06,
                    5.2777e-06,
                    5.4434e-06,
                    5.6112e-06,
                    5.7809e-06,
                    5.9526e-06,
                    6.1261e-06,
                    6.3015e-06,
                    6.4788e-06,
                    6.6581e-06,
                    6.8397e-06,
                    7.0237e-06,
                    7.2105e-06,
                    7.4005e-06,
                    7.5942e-06,
                    7.7932e-06,
                    8.0004e-06,
                    8.2178e-06,
                    8.4474e-06,
                    8.6903e-06,
                    8.9474e-06,
                    9.2189e-06,
                    9.5047e-06,
                    9.8041e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            0.22935,
                            14.98967
                        ],
                        [
                            0.23524,
                            14.88704
                        ],
                        [
                            0.20211,
                            14.84055
                        ],
                        [
                            0.2356,
                            14.74685
                        ],
                        [
                            0.16674,
                            14.53527
                        ],
                        [
                            0.19312,
                            14.45972
                        ],
                        [
                            0.32401,
                            14.36053
                        ],
                        [
                            0.40295,
                            14.24905
                        ],
                        [
                            0.35731,
                            14.14564
                        ],
                        [
                            0.4,
                            14.02618
                        ],
                        [
                            0.48244,
                            13.94907
                        ],
                        [
                            0.4744,
                            13.91532
                        ],
                        [
                            0.53058,
                            13.84108
                        ],
                        [
                            0.62487,
                            13.76408
                        ],
                        [
                            0.63736,
                            13.69347
                        ],
                        [
                            0.77419,
                            13.69096
                        ],
                        [
                            0.8266,
                            13.61933
                        ],
                        [
                            0.90627,
                            13.6184
                        ],
                        [
                            0.99098,
                            13.57487
                        ],
                        [
                            1.01529,
                            13.48758
                        ],
                        [
                            1.0884,
                            13.4599
                        ],
                        [
                            1.13698,
                            13.41447
                        ],
                        [
                            1.28154,
                            13.35649
                        ],
                        [
                            1.16964,
                            13.32278
                        ],
                        [
                            1.05413,
                            13.36799
                        ],
                        [
                            0.99259,
                            13.37046
                        ],
                        [
                            0.99789,
                            13.0008
                        ],
                        [
                            1.1193,
                            12.99868
                        ],
                        [
                            1.39001,
                            12.7779
                        ],
                        [
                            1.57697,
                            12.63329
                        ],
                        [
                            1.86456,
                            12.6059
                        ],
                        [
                            1.92468,
                            12.69179
                        ],
                        [
                            1.97882,
                            12.73653
                        ],
                        [
                            2.08153,
                            12.72174
                        ],
                        [
                            2.15938,
                            12.68786
                        ],
                        [
                            2.15266,
                            12.64906
                        ],
                        [
                            2.225,
                            12.58389
                        ],
                        [
                            2.2286,
                            12.52234
                        ],
                        [
                            2.26942,
                            12.47148
                        ],
                        [
                            2.25442,
                            12.41605
                        ],
                        [
                            2.17916,
                            12.42413
                        ],
                        [
                            2.08207,
                            12.39303
                        ],
                        [
                            2.06543,
                            12.35424
                        ],
                        [
                            2.40508,
                            11.89978
                        ],
                        [
                            2.39289,
                            11.92895
                        ],
                        [
                            2.46503,
                            11.98188
                        ],
                        [
                            2.39169,
                            12.1139
                        ],
                        [
                            2.38305,
                            12.25083
                        ],
                        [
                            2.46322,
                            12.25357
                        ],
                        [
                            2.66751,
                            12.30563
                        ],
                        [
                            2.8089,
                            12.39658
                        ],
                        [
                            2.8707,
                            12.38883
                        ],
                        [
                            2.96335,
                            12.28777
                        ],
                        [
                            3.01251,
                            12.26711
                        ],
                        [
                            3.0823,
                            12.17695
                        ],
                        [
                            3.12528,
                            12.15687
                        ],
                        [
                            3.26892,
                            12.01043
                        ],
                        [
                            3.31892,
                            11.88408
                        ],
                        [
                            3.38302,
                            11.88626
                        ],
                        [
                            3.48194,
                            11.86072
                        ],
                        [
                            3.558,
                            11.77866
                        ],
                        [
                            3.55534,
                            11.72598
                        ],
                        [
                            3.60507,
                            11.69697
                        ],
                        [
                            3.67507,
                            11.75523
                        ],
                        [
                            3.6665,
                            11.8083
                        ],
                        [
                            3.62235,
                            11.85628
                        ],
                        [
                            3.62152,
                            11.92686
                        ],
                        [
                            3.67466,
                            11.99821
                        ],
                        [
                            3.63726,
                            12.13187
                        ],
                        [
                            3.65716,
                            12.25209
                        ],
                        [
                            3.64984,
                            12.32986
                        ],
                        [
                            3.65868,
                            12.52071
                        ],
                        [
                            3.7774,
                            12.62535
                        ],
                        [
                            3.93496,
                            12.74738
                        ],
                        [
                            4.04325,
                            12.89339
                        ],
                        [
                            4.10284,
                            13.00218
                        ],
                        [
                            4.13414,
                            13.16618
                        ],
                        [
                            4.13486,
                            13.47046
                        ],
                        [
                            4.23295,
                            13.47477
                        ],
                        [
                            4.46086,
                            13.6749
                        ],
                        [
                            4.5715,
                            13.72506
                        ],
                        [
                            4.867,
                            13.7815
                        ],
                        [
                            4.9084,
                            13.74962
                        ],
                        [
                            5.0192,
                            13.73345
                        ],
                        [
                            5.08232,
                            13.74691
                        ],
                        [
                            5.27876,
                            13.74097
                        ],
                        [
                            5.35594,
                            13.83774
                        ],
                        [
                            5.52686,
                            13.90022
                        ],
                        [
                            5.77288,
                            13.8049
                        ],
                        [
                            6.07215,
                            13.71846
                        ],
                        [
                            6.13858,
                            13.68651
                        ],
                        [
                            6.26778,
                            13.71582
                        ],
                        [
                            6.41367,
                            13.63931
                        ],
                        [
                            6.49611,
                            13.55733
                        ],
                        [
                            6.52843,
                            13.50035
                        ],
                        [
                            6.67738,
                            13.35531
                        ],
                        [
                            6.81717,
                            13.12026
                        ],
                        [
                            6.93199,
                            12.98959
                        ],
                        [
                            7.06334,
                            13.00123
                        ],
                        [
                            7.15344,
                            13.03441
                        ],
                        [
                            7.22982,
                            13.11029
                        ],
                        [
                            7.3699,
                            13.09877
                        ],
                        [
                            7.42598,
                            13.11095
                        ],
                        [
                            7.82529,
                            13.33862
                        ],
                        [
                            8.06772,
                            13.30212
                        ],
                        [
                            8.25741,
                            13.20502
                        ],
                        [
                            8.41369,
                            13.05753
                        ],
                        [
                            8.5001,
                            13.06713
                        ],
                        [
                            8.565,
                            13.03776
                        ],
                        [
                            8.65273,
                            12.93726
                        ],
                        [
                            8.96888,
                            12.8344
                        ],
                        [
                            9.1512,
                            12.83404
                        ],
                        [
                            9.2852,
                            12.81332
                        ],
                        [
                            9.39746,
                            12.82276
                        ],
                        [
                            9.64662,
                            12.80444
                        ],
                        [
                            9.79091,
                            12.93907
                        ],
                        [
                            9.84712,
                            13.01463
                        ],
                        [
                            9.99602,
                            13.16189
                        ],
                        [
                            10.06282,
                            13.20402
                        ],
                        [
                            10.20532,
                            13.26644
                        ],
                        [
                            10.46401,
                            13.28273
                        ],
                        [
                            10.67236,
                            13.35687
                        ],
                        [
                            10.9857,
                            13.37355
                        ],
                        [
                            11.39044,
                            13.37026
                        ],
                        [
                            11.54376,
                            13.34606
                        ],
                        [
                            11.68968,
                            13.28887
                        ],
                        [
                            11.88243,
                            13.24667
                        ],
                        [
                            12.04463,
                            13.12869
                        ],
                        [
                            12.10957,
                            13.09255
                        ],
                        [
                            12.19805,
                            13.12614
                        ],
                        [
                            12.3296,
                            13.08428
                        ],
                        [
                            12.47522,
                            13.06536
                        ],
                        [
                            12.49141,
                            13.12451
                        ],
                        [
                            12.55255,
                            13.1619
                        ],
                        [
                            12.58881,
                            13.28457
                        ],
                        [
                            12.64099,
                            13.29363
                        ],
                        [
                            12.78133,
                            13.37977
                        ],
                        [
                            12.91824,
                            13.49014
                        ],
                        [
                            13.02238,
                            13.53291
                        ],
                        [
                            13.12804,
                            13.54063
                        ],
                        [
                            13.1906,
                            13.51982
                        ],
                        [
                            13.24732,
                            13.61601
                        ],
                        [
                            13.33764,
                            13.71318
                        ],
                        [
                            13.63455,
                            13.71068
                        ],
                        [
                            13.4856,
                            14.35837
                        ],
                        [
                            13.4735,
                            14.44268
                        ],
                        [
                            13.49333,
                            14.47453
                        ],
                        [
                            13.64082,
                            14.51384
                        ],
                        [
                            13.69502,
                            14.55095
                        ],
                        [
                            13.6789,
                            14.63781
                        ],
                        [
                            13.74417,
                            14.69692
                        ],
                        [
                            13.81027,
                            14.72332
                        ],
                        [
                            13.79011,
                            14.86331
                        ],
                        [
                            13.86867,
                            15.04142
                        ],
                        [
                            13.97086,
                            15.15756
                        ],
                        [
                            14.23565,
                            15.53498
                        ],
                        [
                            14.38375,
                            15.73009
                        ],
                        [
                            14.6943,
                            16.04474
                        ],
                        [
                            14.95782,
                            16.32654
                        ],
                        [
                            15.50531,
                            16.89879
                        ],
                        [
                            15.5386,
                            17.61201
                        ],
                        [
                            15.57047,
                            18.24916
                        ],
                        [
                            15.59375,
                            18.73013
                        ],
                        [
                            15.68984,
                            19.47779
                        ],
                        [
                            15.75473,
                            19.94957
                        ],
                        [
                            15.99468,
                            20.34763
                        ],
                        [
                            15.86586,
                            20.46195
                        ],
                        [
                            15.74425,
                            20.63111
                        ],
                        [
                            15.59066,
                            20.77402
                        ],
                        [
                            15.54665,
                            20.88109
                        ],
                        [
                            15.62418,
                            20.96496
                        ],
                        [
                            15.2892,
                            21.4311
                        ],
                        [
                            15.19888,
                            21.49194
                        ],
                        [
                            15.19184,
                            21.98989
                        ],
                        [
                            15.11438,
                            22.40494
                        ],
                        [
                            14.99842,
                            22.99718
                        ],
                        [
                            14.70357,
                            22.8742
                        ],
                        [
                            14.18933,
                            22.64455
                        ],
                        [
                            13.68032,
                            23.07229
                        ],
                        [
                            13.54501,
                            23.15684
                        ],
                        [
                            13.39798,
                            23.2175
                        ],
                        [
                            13.18777,
                            23.26074
                        ],
                        [
                            12.43499,
                            23.42203
                        ],
                        [
                            11.9985,
                            23.5127
                        ],
                        [
                            11.36313,
                            23.15256
                        ],
                        [
                            10.79315,
                            22.82406
                        ],
                        [
                            10.25713,
                            22.5149
                        ],
                        [
                            9.6516,
                            22.15752
                        ],
                        [
                            8.91646,
                            21.72254
                        ],
                        [
                            8.21619,
                            21.30133
                        ],
                        [
                            7.45937,
                            20.84132
                        ],
                        [
                            7.04491,
                            20.49229
                        ],
                        [
                            6.70447,
                            20.2039
                        ],
                        [
                            6.10689,
                            19.69413
                        ],
                        [
                            5.81302,
                            19.44127
                        ],
                        [
                            5.1955,
                            19.32392
                        ],
                        [
                            4.24295,
                            19.1389
                        ],
                        [
                            4.24487,
                            18.81029
                        ],
                        [
                            4.24091,
                            18.13597
                        ],
                        [
                            4.23929,
                            17.52425
                        ],
                        [
                            4.24117,
                            16.98993
                        ],
                        [
                            4.07695,
                            16.91076
                        ],
                        [
                            4.07967,
                            16.61159
                        ],
                        [
                            4.0761,
                            16.31883
                        ],
                        [
                            3.98833,
                            16.06212
                        ],
                        [
                            4.00394,
                            15.98611
                        ],
                        [
                            3.9477,
                            15.94183
                        ],
                        [
                            3.91519,
                            15.86429
                        ],
                        [
                            3.90512,
                            15.77222
                        ],
                        [
                            3.8736,
                            15.69364
                        ],
                        [
                            3.82382,
                            15.6641
                        ],
                        [
                            3.70832,
                            15.64059
                        ],
                        [
                            3.60616,
                            15.52498
                        ],
                        [
                            3.53645,
                            15.48643
                        ],
                        [
                            3.52558,
                            15.34169
                        ],
                        [
                            3.09896,
                            15.34166
                        ],
                        [
                            2.62737,
                            15.36699
                        ],
                        [
                            1.90956,
                            15.306
                        ],
                        [
                            1.32601,
                            15.26521
                        ],
                        [
                            1.28796,
                            15.24117
                        ],
                        [
                            0.97535,
                            14.98081
                        ],
                        [
                            0.72318,
                            14.95941
                        ],
                        [
                            0.70217,
                            14.94619
                        ],
                        [
                            0.51096,
                            15.00093
                        ],
                        [
                            0.4018,
                            14.96986
                        ],
                        [
                            0.22935,
                            14.98967
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "NGA",
                "Country": "Nigeria",
                "Total_3GHG": 1.18,
                "Total_3GHG_timeseries": [
                    2.7726e-06,
                    5.4273e-06,
                    8.0366e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.003,
                    0.0032,
                    0.0034,
                    0.0036,
                    0.0038,
                    0.004,
                    0.0043,
                    0.0046,
                    0.0049,
                    0.0053,
                    0.0057,
                    0.006,
                    0.0063,
                    0.0066,
                    0.0071,
                    0.0075,
                    0.0079,
                    0.0082,
                    0.0085,
                    0.0089,
                    0.0092,
                    0.0096,
                    0.0099,
                    0.0101,
                    0.0103,
                    0.0105,
                    0.0108,
                    0.0111,
                    0.0113,
                    0.0114,
                    0.0116,
                    0.0119,
                    0.0121,
                    0.0124,
                    0.0126,
                    0.0128,
                    0.0131,
                    0.0134,
                    0.0138,
                    0.0142,
                    0.0146,
                    0.0148,
                    0.0151,
                    0.0155,
                    0.0159,
                    0.0163,
                    0.0167,
                    0.017,
                    0.0173,
                    0.0176,
                    0.0178,
                    0.018,
                    0.0182,
                    0.0185,
                    0.0187,
                    0.0188,
                    0.0189,
                    0.019,
                    0.019,
                    0.019,
                    0.019,
                    0.0192,
                    0.0192,
                    0.0192,
                    0.0192
                ],
                "Fossil_3GHG": 1.1,
                "Fossil_3GHG_timeseries": [
                    4.3509e-07,
                    8.7734e-07,
                    1.3267e-06,
                    1.7832e-06,
                    2.2466e-06,
                    2.717e-06,
                    3.1941e-06,
                    3.6779e-06,
                    4.1682e-06,
                    4.6649e-06,
                    5.1717e-06,
                    5.6885e-06,
                    6.2177e-06,
                    6.7569e-06,
                    7.3061e-06,
                    7.8652e-06,
                    8.4342e-06,
                    9.0131e-06,
                    9.6019e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0013,
                    0.0016,
                    0.0019,
                    0.0021,
                    0.0023,
                    0.0025,
                    0.0028,
                    0.0031,
                    0.0035,
                    0.0038,
                    0.0041,
                    0.0045,
                    0.0048,
                    0.0051,
                    0.0055,
                    0.0058,
                    0.006,
                    0.0062,
                    0.0064,
                    0.0065,
                    0.0067,
                    0.0068,
                    0.0068,
                    0.0069,
                    0.0071,
                    0.0072,
                    0.0073,
                    0.0074,
                    0.0075,
                    0.0077,
                    0.0079,
                    0.0083,
                    0.0085,
                    0.0087,
                    0.0089,
                    0.0091,
                    0.0095,
                    0.0097,
                    0.0101,
                    0.0103,
                    0.0106,
                    0.0108,
                    0.011,
                    0.0112,
                    0.0113,
                    0.0115,
                    0.0116,
                    0.0118,
                    0.0119,
                    0.0119,
                    0.0119,
                    0.0118,
                    0.0118,
                    0.0118,
                    0.0118,
                    0.0117,
                    0.0117,
                    0.0117
                ],
                "Land_3GHG": 1.31,
                "Land_3GHG_timeseries": [
                    2.3375e-06,
                    4.5499e-06,
                    6.7099e-06,
                    8.8166e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.004,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0041,
                    0.0041,
                    0.0041,
                    0.0041,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.005,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0055,
                    0.0056,
                    0.0057,
                    0.0058,
                    0.0059,
                    0.006,
                    0.0061,
                    0.0062,
                    0.0063,
                    0.0063,
                    0.0064,
                    0.0065,
                    0.0066,
                    0.0066,
                    0.0067,
                    0.0067,
                    0.0068,
                    0.0069,
                    0.007,
                    0.007,
                    0.0071,
                    0.0072,
                    0.0072,
                    0.0073,
                    0.0074,
                    0.0074,
                    0.0075,
                    0.0076
                ],
                "Total_CO2": 0.63,
                "Total_CO2_timeseries": [
                    1.7861e-06,
                    3.4444e-06,
                    5.0473e-06,
                    6.5944e-06,
                    8.1429e-06,
                    9.6871e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0048,
                    0.0049,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0055,
                    0.0056,
                    0.0056,
                    0.0057,
                    0.0058,
                    0.0059,
                    0.006,
                    0.0061,
                    0.0062,
                    0.0062,
                    0.0062,
                    0.0063,
                    0.0064,
                    0.0065,
                    0.0065,
                    0.0066,
                    0.0067,
                    0.0067,
                    0.0068,
                    0.0068,
                    0.0069,
                    0.007,
                    0.007,
                    0.0071,
                    0.0072
                ],
                "Fossil_CO2": 0.26,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    8.25e-09,
                    3.795e-08,
                    1.386e-07,
                    3.1845e-07,
                    4.851e-07,
                    7.0455e-07,
                    9.6195e-07,
                    1.0989e-06,
                    1.3117e-06,
                    1.5559e-06,
                    1.8463e-06,
                    2.2407e-06,
                    2.6763e-06,
                    3.1119e-06,
                    3.531e-06,
                    3.9534e-06,
                    4.351e-06,
                    4.6563e-06,
                    4.9417e-06,
                    5.2569e-06,
                    5.5704e-06,
                    5.9252e-06,
                    6.3657e-06,
                    6.8046e-06,
                    7.1742e-06,
                    7.5504e-06,
                    7.9959e-06,
                    8.5553e-06,
                    9.169e-06,
                    9.9149e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002
                ],
                "Land_CO2": 1.44,
                "Land_CO2_timeseries": [
                    1.7861e-06,
                    3.4444e-06,
                    5.0473e-06,
                    6.5944e-06,
                    8.1429e-06,
                    9.6871e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0035,
                    0.0035,
                    0.0035,
                    0.0035,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0046,
                    0.0047,
                    0.0047,
                    0.0048,
                    0.0048,
                    0.0048,
                    0.0049,
                    0.0049,
                    0.005,
                    0.005,
                    0.005,
                    0.005,
                    0.005,
                    0.0051,
                    0.0051,
                    0.0051,
                    0.0051,
                    0.0051,
                    0.0051,
                    0.0051,
                    0.0051,
                    0.0051,
                    0.0052,
                    0.0052,
                    0.0052
                ],
                "Total_CH4": 2.73,
                "Total_CH4_timeseries": [
                    7.0568e-07,
                    1.4169e-06,
                    2.1337e-06,
                    2.856e-06,
                    3.5839e-06,
                    4.3172e-06,
                    5.0561e-06,
                    5.8005e-06,
                    6.5504e-06,
                    7.3057e-06,
                    8.0769e-06,
                    8.8639e-06,
                    9.6691e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0013,
                    0.0015,
                    0.0017,
                    0.002,
                    0.0022,
                    0.0024,
                    0.0027,
                    0.003,
                    0.0033,
                    0.0036,
                    0.004,
                    0.0042,
                    0.0046,
                    0.0049,
                    0.0052,
                    0.0056,
                    0.0059,
                    0.0061,
                    0.0062,
                    0.0064,
                    0.0066,
                    0.0067,
                    0.0068,
                    0.0068,
                    0.0069,
                    0.0071,
                    0.0072,
                    0.0073,
                    0.0075,
                    0.0076,
                    0.0077,
                    0.008,
                    0.0083,
                    0.0085,
                    0.0087,
                    0.0089,
                    0.0091,
                    0.0094,
                    0.0097,
                    0.01,
                    0.0103,
                    0.0105,
                    0.0107,
                    0.0109,
                    0.0111,
                    0.0112,
                    0.0114,
                    0.0115,
                    0.0116,
                    0.0117,
                    0.0117,
                    0.0117,
                    0.0116,
                    0.0115,
                    0.0115,
                    0.0115,
                    0.0115,
                    0.0114,
                    0.0114
                ],
                "Fossil_CH4": 3.66,
                "Fossil_CH4_timeseries": [
                    2.8081e-07,
                    5.6682e-07,
                    8.5802e-07,
                    1.1544e-06,
                    1.456e-06,
                    1.7627e-06,
                    2.0746e-06,
                    2.3916e-06,
                    2.7137e-06,
                    3.041e-06,
                    3.3771e-06,
                    3.7222e-06,
                    4.0785e-06,
                    4.4437e-06,
                    4.8177e-06,
                    5.2005e-06,
                    5.5921e-06,
                    5.9924e-06,
                    6.4016e-06,
                    6.8195e-06,
                    7.2416e-06,
                    7.6679e-06,
                    8.0983e-06,
                    8.533e-06,
                    8.9718e-06,
                    9.4148e-06,
                    9.8619e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0009,
                    0.001,
                    0.0012,
                    0.0015,
                    0.0018,
                    0.002,
                    0.0022,
                    0.0024,
                    0.0027,
                    0.0029,
                    0.0033,
                    0.0036,
                    0.0039,
                    0.0042,
                    0.0045,
                    0.0048,
                    0.0051,
                    0.0054,
                    0.0056,
                    0.0058,
                    0.0059,
                    0.006,
                    0.0061,
                    0.0062,
                    0.0062,
                    0.0063,
                    0.0064,
                    0.0065,
                    0.0066,
                    0.0067,
                    0.0068,
                    0.0069,
                    0.0071,
                    0.0074,
                    0.0076,
                    0.0078,
                    0.0079,
                    0.0081,
                    0.0084,
                    0.0086,
                    0.0089,
                    0.0091,
                    0.0093,
                    0.0095,
                    0.0097,
                    0.0098,
                    0.0099,
                    0.01,
                    0.0101,
                    0.0102,
                    0.0102,
                    0.0102,
                    0.0101,
                    0.01,
                    0.0099,
                    0.0098,
                    0.0098,
                    0.0097,
                    0.0095,
                    0.0095
                ],
                "Land_CH4": 1.19,
                "Land_CH4_timeseries": [
                    4.2487e-07,
                    8.5009e-07,
                    1.2757e-06,
                    1.7016e-06,
                    2.1279e-06,
                    2.5546e-06,
                    2.9816e-06,
                    3.4089e-06,
                    3.8367e-06,
                    4.2647e-06,
                    4.6998e-06,
                    5.1417e-06,
                    5.5906e-06,
                    6.0465e-06,
                    6.5093e-06,
                    6.979e-06,
                    7.4557e-06,
                    7.9393e-06,
                    8.4299e-06,
                    8.9274e-06,
                    9.432e-06,
                    9.9438e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019
                ],
                "Total_N2O": 0.86,
                "Total_N2O_timeseries": [
                    2.8074e-07,
                    5.6599e-07,
                    8.5559e-07,
                    1.1493e-06,
                    1.447e-06,
                    1.7482e-06,
                    2.0527e-06,
                    2.3599e-06,
                    2.6694e-06,
                    2.9807e-06,
                    3.2933e-06,
                    3.6074e-06,
                    3.9226e-06,
                    4.2391e-06,
                    4.5569e-06,
                    4.8758e-06,
                    5.1959e-06,
                    5.5173e-06,
                    5.8401e-06,
                    6.1643e-06,
                    6.4929e-06,
                    6.8307e-06,
                    7.1817e-06,
                    7.5483e-06,
                    7.9322e-06,
                    8.3337e-06,
                    8.7521e-06,
                    9.1853e-06,
                    9.6303e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Fossil_N2O": 0.89,
                "Fossil_N2O_timeseries": [
                    1.5427e-07,
                    3.1052e-07,
                    4.6871e-07,
                    6.2877e-07,
                    7.9066e-07,
                    9.5427e-07,
                    1.1195e-06,
                    1.2863e-06,
                    1.4545e-06,
                    1.6239e-06,
                    1.7946e-06,
                    1.9663e-06,
                    2.1393e-06,
                    2.3133e-06,
                    2.4884e-06,
                    2.6647e-06,
                    2.8421e-06,
                    3.0207e-06,
                    3.2004e-06,
                    3.3812e-06,
                    3.564e-06,
                    3.7501e-06,
                    3.9403e-06,
                    4.1354e-06,
                    4.3357e-06,
                    4.5415e-06,
                    4.7524e-06,
                    4.968e-06,
                    5.1874e-06,
                    5.4096e-06,
                    5.6339e-06,
                    5.8601e-06,
                    6.088e-06,
                    6.3176e-06,
                    6.5488e-06,
                    6.7816e-06,
                    7.016e-06,
                    7.2519e-06,
                    7.4896e-06,
                    7.7354e-06,
                    7.9846e-06,
                    8.2373e-06,
                    8.4937e-06,
                    8.7539e-06,
                    9.018e-06,
                    9.2863e-06,
                    9.5588e-06,
                    9.8357e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_N2O": 0.85,
                "Land_N2O_timeseries": [
                    1.2647e-07,
                    2.5547e-07,
                    3.8689e-07,
                    5.2057e-07,
                    6.5634e-07,
                    7.9395e-07,
                    9.3313e-07,
                    1.0736e-06,
                    1.2149e-06,
                    1.3567e-06,
                    1.4988e-06,
                    1.641e-06,
                    1.7834e-06,
                    1.9259e-06,
                    2.0684e-06,
                    2.2111e-06,
                    2.3538e-06,
                    2.4967e-06,
                    2.6398e-06,
                    2.7831e-06,
                    2.9289e-06,
                    3.0807e-06,
                    3.2414e-06,
                    3.4129e-06,
                    3.5965e-06,
                    3.7922e-06,
                    3.9997e-06,
                    4.2173e-06,
                    4.4429e-06,
                    4.6734e-06,
                    4.9065e-06,
                    5.142e-06,
                    5.3794e-06,
                    5.6185e-06,
                    5.859e-06,
                    6.101e-06,
                    6.3443e-06,
                    6.5892e-06,
                    6.8357e-06,
                    7.0952e-06,
                    7.3571e-06,
                    7.6216e-06,
                    7.8889e-06,
                    8.1589e-06,
                    8.4318e-06,
                    8.7078e-06,
                    8.9869e-06,
                    9.2692e-06,
                    9.5548e-06,
                    9.8438e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                13.63455,
                                13.71068
                            ],
                            [
                                13.33764,
                                13.71318
                            ],
                            [
                                13.24732,
                                13.61601
                            ],
                            [
                                13.1906,
                                13.51982
                            ],
                            [
                                13.12804,
                                13.54063
                            ],
                            [
                                13.02238,
                                13.53291
                            ],
                            [
                                12.91824,
                                13.49014
                            ],
                            [
                                12.78133,
                                13.37977
                            ],
                            [
                                12.64099,
                                13.29363
                            ],
                            [
                                12.58881,
                                13.28457
                            ],
                            [
                                12.55255,
                                13.1619
                            ],
                            [
                                12.49141,
                                13.12451
                            ],
                            [
                                12.47522,
                                13.06536
                            ],
                            [
                                12.3296,
                                13.08428
                            ],
                            [
                                12.19805,
                                13.12614
                            ],
                            [
                                12.10957,
                                13.09255
                            ],
                            [
                                12.04463,
                                13.12869
                            ],
                            [
                                11.88243,
                                13.24667
                            ],
                            [
                                11.68968,
                                13.28887
                            ],
                            [
                                11.54376,
                                13.34606
                            ],
                            [
                                11.39044,
                                13.37026
                            ],
                            [
                                10.9857,
                                13.37355
                            ],
                            [
                                10.67236,
                                13.35687
                            ],
                            [
                                10.46401,
                                13.28273
                            ],
                            [
                                10.20532,
                                13.26644
                            ],
                            [
                                10.06282,
                                13.20402
                            ],
                            [
                                9.99602,
                                13.16189
                            ],
                            [
                                9.84712,
                                13.01463
                            ],
                            [
                                9.79091,
                                12.93907
                            ],
                            [
                                9.64662,
                                12.80444
                            ],
                            [
                                9.39746,
                                12.82276
                            ],
                            [
                                9.2852,
                                12.81332
                            ],
                            [
                                9.1512,
                                12.83404
                            ],
                            [
                                8.96888,
                                12.8344
                            ],
                            [
                                8.65273,
                                12.93726
                            ],
                            [
                                8.565,
                                13.03776
                            ],
                            [
                                8.5001,
                                13.06713
                            ],
                            [
                                8.41369,
                                13.05753
                            ],
                            [
                                8.25741,
                                13.20502
                            ],
                            [
                                8.06772,
                                13.30212
                            ],
                            [
                                7.82529,
                                13.33862
                            ],
                            [
                                7.42598,
                                13.11095
                            ],
                            [
                                7.3699,
                                13.09877
                            ],
                            [
                                7.22982,
                                13.11029
                            ],
                            [
                                7.15344,
                                13.03441
                            ],
                            [
                                7.06334,
                                13.00123
                            ],
                            [
                                6.93199,
                                12.98959
                            ],
                            [
                                6.81717,
                                13.12026
                            ],
                            [
                                6.67738,
                                13.35531
                            ],
                            [
                                6.52843,
                                13.50035
                            ],
                            [
                                6.49611,
                                13.55733
                            ],
                            [
                                6.41367,
                                13.63931
                            ],
                            [
                                6.26778,
                                13.71582
                            ],
                            [
                                6.13858,
                                13.68651
                            ],
                            [
                                6.07215,
                                13.71846
                            ],
                            [
                                5.77288,
                                13.8049
                            ],
                            [
                                5.52686,
                                13.90022
                            ],
                            [
                                5.35594,
                                13.83774
                            ],
                            [
                                5.27876,
                                13.74097
                            ],
                            [
                                5.08232,
                                13.74691
                            ],
                            [
                                5.0192,
                                13.73345
                            ],
                            [
                                4.9084,
                                13.74962
                            ],
                            [
                                4.867,
                                13.7815
                            ],
                            [
                                4.5715,
                                13.72506
                            ],
                            [
                                4.46086,
                                13.6749
                            ],
                            [
                                4.23295,
                                13.47477
                            ],
                            [
                                4.13486,
                                13.47046
                            ],
                            [
                                4.13414,
                                13.16618
                            ],
                            [
                                4.10284,
                                13.00218
                            ],
                            [
                                4.04325,
                                12.89339
                            ],
                            [
                                3.93496,
                                12.74738
                            ],
                            [
                                3.7774,
                                12.62535
                            ],
                            [
                                3.65868,
                                12.52071
                            ],
                            [
                                3.64984,
                                12.32986
                            ],
                            [
                                3.65716,
                                12.25209
                            ],
                            [
                                3.63726,
                                12.13187
                            ],
                            [
                                3.67466,
                                11.99821
                            ],
                            [
                                3.62152,
                                11.92686
                            ],
                            [
                                3.62235,
                                11.85628
                            ],
                            [
                                3.6665,
                                11.8083
                            ],
                            [
                                3.67507,
                                11.75523
                            ],
                            [
                                3.60507,
                                11.69697
                            ],
                            [
                                3.55742,
                                11.6306
                            ],
                            [
                                3.47198,
                                11.44811
                            ],
                            [
                                3.69048,
                                11.13036
                            ],
                            [
                                3.72695,
                                11.11622
                            ],
                            [
                                3.71715,
                                11.02604
                            ],
                            [
                                3.75724,
                                11.00077
                            ],
                            [
                                3.77109,
                                10.93057
                            ],
                            [
                                3.74989,
                                10.82441
                            ],
                            [
                                3.79631,
                                10.73686
                            ],
                            [
                                3.84089,
                                10.70417
                            ],
                            [
                                3.85153,
                                10.60552
                            ],
                            [
                                3.8012,
                                10.48509
                            ],
                            [
                                3.78606,
                                10.4068
                            ],
                            [
                                3.68859,
                                10.45571
                            ],
                            [
                                3.6457,
                                10.4346
                            ],
                            [
                                3.58465,
                                10.27607
                            ],
                            [
                                3.6787,
                                10.16981
                            ],
                            [
                                3.66234,
                                10.10697
                            ],
                            [
                                3.61144,
                                10.05986
                            ],
                            [
                                3.59526,
                                9.94562
                            ],
                            [
                                3.53258,
                                9.86435
                            ],
                            [
                                3.47531,
                                9.8629
                            ],
                            [
                                3.35725,
                                9.82576
                            ],
                            [
                                3.33001,
                                9.79869
                            ],
                            [
                                3.34857,
                                9.68612
                            ],
                            [
                                3.28096,
                                9.66164
                            ],
                            [
                                3.19482,
                                9.51557
                            ],
                            [
                                3.1313,
                                9.43807
                            ],
                            [
                                3.15775,
                                9.28756
                            ],
                            [
                                3.08697,
                                9.1009
                            ],
                            [
                                3.00847,
                                9.07416
                            ],
                            [
                                2.95195,
                                9.09236
                            ],
                            [
                                2.87093,
                                9.0629
                            ],
                            [
                                2.78383,
                                9.06508
                            ],
                            [
                                2.78819,
                                8.97025
                            ],
                            [
                                2.7626,
                                8.80913
                            ],
                            [
                                2.72893,
                                8.773
                            ],
                            [
                                2.76115,
                                8.52248
                            ],
                            [
                                2.73924,
                                8.44297
                            ],
                            [
                                2.70784,
                                8.42108
                            ],
                            [
                                2.69846,
                                8.30674
                            ],
                            [
                                2.75305,
                                8.21064
                            ],
                            [
                                2.69589,
                                7.93323
                            ],
                            [
                                2.66958,
                                7.88913
                            ],
                            [
                                2.73217,
                                7.77247
                            ],
                            [
                                2.72557,
                                7.64849
                            ],
                            [
                                2.75057,
                                7.5264
                            ],
                            [
                                2.79238,
                                7.49436
                            ],
                            [
                                2.79802,
                                7.42568
                            ],
                            [
                                2.74758,
                                7.41317
                            ],
                            [
                                2.7496,
                                7.26185
                            ],
                            [
                                2.7847,
                                7.16125
                            ],
                            [
                                2.74902,
                                7.10375
                            ],
                            [
                                2.79139,
                                7.04124
                            ],
                            [
                                2.72063,
                                6.98446
                            ],
                            [
                                2.74733,
                                6.92755
                            ],
                            [
                                2.74007,
                                6.76539
                            ],
                            [
                                2.78638,
                                6.69663
                            ],
                            [
                                2.7319,
                                6.62872
                            ],
                            [
                                2.75308,
                                6.57031
                            ],
                            [
                                2.72939,
                                6.53446
                            ],
                            [
                                2.70938,
                                6.37568
                            ],
                            [
                                2.85272,
                                6.39243
                            ],
                            [
                                3.2388,
                                6.40468
                            ],
                            [
                                3.38033,
                                6.39619
                            ],
                            [
                                3.43632,
                                6.42138
                            ],
                            [
                                3.68718,
                                6.42678
                            ],
                            [
                                3.81239,
                                6.43833
                            ],
                            [
                                3.93745,
                                6.43356
                            ],
                            [
                                4.32865,
                                6.37421
                            ],
                            [
                                4.56488,
                                6.29885
                            ],
                            [
                                4.64081,
                                6.24677
                            ],
                            [
                                4.64733,
                                6.20919
                            ],
                            [
                                4.81724,
                                6.06422
                            ],
                            [
                                4.9474,
                                5.93091
                            ],
                            [
                                5.12799,
                                5.64311
                            ],
                            [
                                5.18278,
                                5.59986
                            ],
                            [
                                5.31197,
                                5.63775
                            ],
                            [
                                5.33305,
                                5.58532
                            ],
                            [
                                5.21187,
                                5.59682
                            ],
                            [
                                5.16259,
                                5.53853
                            ],
                            [
                                5.25539,
                                5.43414
                            ],
                            [
                                5.3458,
                                5.39605
                            ],
                            [
                                5.42215,
                                5.38993
                            ],
                            [
                                5.51323,
                                5.44178
                            ],
                            [
                                5.54312,
                                5.39188
                            ],
                            [
                                5.42814,
                                5.36224
                            ],
                            [
                                5.32779,
                                5.35691
                            ],
                            [
                                5.35446,
                                5.17726
                            ],
                            [
                                5.43527,
                                4.99245
                            ],
                            [
                                5.44153,
                                4.94618
                            ],
                            [
                                5.54675,
                                4.72345
                            ],
                            [
                                5.67262,
                                4.55369
                            ],
                            [
                                5.88355,
                                4.37525
                            ],
                            [
                                5.99369,
                                4.30656
                            ],
                            [
                                6.11154,
                                4.27105
                            ],
                            [
                                6.99576,
                                4.3794
                            ],
                            [
                                7.02847,
                                4.44198
                            ],
                            [
                                7.1481,
                                4.46606
                            ],
                            [
                                7.1732,
                                4.57835
                            ],
                            [
                                7.20481,
                                4.58728
                            ],
                            [
                                7.26977,
                                4.50376
                            ],
                            [
                                7.33203,
                                4.51773
                            ],
                            [
                                7.35559,
                                4.44215
                            ],
                            [
                                7.41657,
                                4.43579
                            ],
                            [
                                7.57728,
                                4.45326
                            ],
                            [
                                7.70722,
                                4.50553
                            ],
                            [
                                7.93357,
                                4.53613
                            ],
                            [
                                8.1561,
                                4.54561
                            ],
                            [
                                8.25664,
                                4.53517
                            ],
                            [
                                8.24135,
                                4.59148
                            ],
                            [
                                8.30263,
                                4.62643
                            ],
                            [
                                8.26839,
                                4.69124
                            ],
                            [
                                8.28591,
                                4.75219
                            ],
                            [
                                8.25588,
                                4.80898
                            ],
                            [
                                8.23337,
                                4.92093
                            ],
                            [
                                8.28961,
                                4.92484
                            ],
                            [
                                8.38551,
                                4.8679
                            ],
                            [
                                8.41125,
                                4.82277
                            ],
                            [
                                8.42402,
                                4.73004
                            ],
                            [
                                8.49311,
                                4.78652
                            ],
                            [
                                8.61678,
                                4.81776
                            ],
                            [
                                8.62202,
                                4.90613
                            ],
                            [
                                8.69557,
                                4.98723
                            ],
                            [
                                8.75051,
                                5.10128
                            ],
                            [
                                8.81867,
                                5.18189
                            ],
                            [
                                8.81612,
                                5.27964
                            ],
                            [
                                8.8357,
                                5.43308
                            ],
                            [
                                8.91791,
                                5.56427
                            ],
                            [
                                8.90338,
                                5.61798
                            ],
                            [
                                8.83492,
                                5.69362
                            ],
                            [
                                8.88024,
                                5.79729
                            ],
                            [
                                8.84438,
                                5.82509
                            ],
                            [
                                9.14877,
                                6.08911
                            ],
                            [
                                9.17251,
                                6.13084
                            ],
                            [
                                9.26422,
                                6.18568
                            ],
                            [
                                9.3333,
                                6.29216
                            ],
                            [
                                9.34673,
                                6.35033
                            ],
                            [
                                9.43209,
                                6.31915
                            ],
                            [
                                9.46579,
                                6.45205
                            ],
                            [
                                9.52575,
                                6.44616
                            ],
                            [
                                9.58381,
                                6.47693
                            ],
                            [
                                9.59886,
                                6.52754
                            ],
                            [
                                9.70377,
                                6.51255
                            ],
                            [
                                9.75168,
                                6.65526
                            ],
                            [
                                9.77819,
                                6.78978
                            ],
                            [
                                9.86938,
                                6.77546
                            ],
                            [
                                10.15068,
                                7.03571
                            ],
                            [
                                10.17516,
                                6.93998
                            ],
                            [
                                10.21791,
                                6.88687
                            ],
                            [
                                10.49012,
                                6.87285
                            ],
                            [
                                10.54095,
                                6.94247
                            ],
                            [
                                10.55985,
                                7.03013
                            ],
                            [
                                10.59769,
                                7.07807
                            ],
                            [
                                10.76224,
                                6.95854
                            ],
                            [
                                10.83759,
                                6.936
                            ],
                            [
                                10.81611,
                                6.85699
                            ],
                            [
                                10.8375,
                                6.81364
                            ],
                            [
                                10.91304,
                                6.75487
                            ],
                            [
                                10.9203,
                                6.70684
                            ],
                            [
                                10.98734,
                                6.68752
                            ],
                            [
                                11.06703,
                                6.70747
                            ],
                            [
                                11.09528,
                                6.6712
                            ],
                            [
                                11.09561,
                                6.53277
                            ],
                            [
                                11.16704,
                                6.50181
                            ],
                            [
                                11.20121,
                                6.53555
                            ],
                            [
                                11.27502,
                                6.53606
                            ],
                            [
                                11.31727,
                                6.50771
                            ],
                            [
                                11.42377,
                                6.53228
                            ],
                            [
                                11.41589,
                                6.5971
                            ],
                            [
                                11.49397,
                                6.60101
                            ],
                            [
                                11.55164,
                                6.66585
                            ],
                            [
                                11.58917,
                                6.80261
                            ],
                            [
                                11.55554,
                                6.8607
                            ],
                            [
                                11.60534,
                                6.91322
                            ],
                            [
                                11.63513,
                                6.98849
                            ],
                            [
                                11.80254,
                                7.07983
                            ],
                            [
                                11.86435,
                                7.07841
                            ],
                            [
                                11.84458,
                                7.26962
                            ],
                            [
                                11.92584,
                                7.39378
                            ],
                            [
                                11.91763,
                                7.4691
                            ],
                            [
                                12.0219,
                                7.52738
                            ],
                            [
                                12.00657,
                                7.58116
                            ],
                            [
                                12.01475,
                                7.681
                            ],
                            [
                                12.07052,
                                7.79378
                            ],
                            [
                                12.19042,
                                7.9404
                            ],
                            [
                                12.2095,
                                7.98806
                            ],
                            [
                                12.19211,
                                8.1012
                            ],
                            [
                                12.23375,
                                8.16541
                            ],
                            [
                                12.24197,
                                8.36552
                            ],
                            [
                                12.26193,
                                8.44107
                            ],
                            [
                                12.36773,
                                8.42467
                            ],
                            [
                                12.40485,
                                8.47145
                            ],
                            [
                                12.41253,
                                8.5378
                            ],
                            [
                                12.45543,
                                8.55452
                            ],
                            [
                                12.4367,
                                8.6184
                            ],
                            [
                                12.50301,
                                8.64042
                            ],
                            [
                                12.59973,
                                8.59418
                            ],
                            [
                                12.61218,
                                8.63612
                            ],
                            [
                                12.69643,
                                8.66792
                            ],
                            [
                                12.71981,
                                8.75935
                            ],
                            [
                                12.78438,
                                8.74932
                            ],
                            [
                                12.82467,
                                8.97184
                            ],
                            [
                                12.86421,
                                9.01769
                            ],
                            [
                                12.89786,
                                9.11608
                            ],
                            [
                                12.89058,
                                9.18048
                            ],
                            [
                                12.9151,
                                9.24816
                            ],
                            [
                                12.90439,
                                9.35329
                            ],
                            [
                                12.93817,
                                9.41759
                            ],
                            [
                                13.03256,
                                9.50364
                            ],
                            [
                                13.20826,
                                9.5582
                            ],
                            [
                                13.23446,
                                9.62019
                            ],
                            [
                                13.26106,
                                9.77473
                            ],
                            [
                                13.29985,
                                9.82572
                            ],
                            [
                                13.24707,
                                9.86101
                            ],
                            [
                                13.23813,
                                9.91105
                            ],
                            [
                                13.2871,
                                9.9712
                            ],
                            [
                                13.25082,
                                10.001
                            ],
                            [
                                13.31324,
                                10.10616
                            ],
                            [
                                13.43008,
                                10.12122
                            ],
                            [
                                13.42661,
                                10.15555
                            ],
                            [
                                13.49879,
                                10.20796
                            ],
                            [
                                13.54123,
                                10.35934
                            ],
                            [
                                13.52131,
                                10.45247
                            ],
                            [
                                13.56804,
                                10.56187
                            ],
                            [
                                13.58225,
                                10.68712
                            ],
                            [
                                13.62547,
                                10.71081
                            ],
                            [
                                13.64872,
                                10.8065
                            ],
                            [
                                13.71798,
                                10.86629
                            ],
                            [
                                13.71221,
                                10.95467
                            ],
                            [
                                13.74104,
                                11.005
                            ],
                            [
                                13.79351,
                                11.00726
                            ],
                            [
                                13.94813,
                                11.24097
                            ],
                            [
                                14.00557,
                                11.30578
                            ],
                            [
                                14.178,
                                11.24031
                            ],
                            [
                                14.36973,
                                11.36667
                            ],
                            [
                                14.38592,
                                11.42674
                            ],
                            [
                                14.45992,
                                11.46369
                            ],
                            [
                                14.56726,
                                11.47986
                            ],
                            [
                                14.61246,
                                11.51119
                            ],
                            [
                                14.64561,
                                11.58208
                            ],
                            [
                                14.64088,
                                11.65558
                            ],
                            [
                                14.55422,
                                11.71427
                            ],
                            [
                                14.61467,
                                11.7834
                            ],
                            [
                                14.60578,
                                11.86958
                            ],
                            [
                                14.65508,
                                11.96176
                            ],
                            [
                                14.62312,
                                12.04397
                            ],
                            [
                                14.67475,
                                12.15741
                            ],
                            [
                                14.65828,
                                12.19661
                            ],
                            [
                                14.54991,
                                12.2373
                            ],
                            [
                                14.51409,
                                12.32911
                            ],
                            [
                                14.46337,
                                12.35948
                            ],
                            [
                                14.32975,
                                12.37501
                            ],
                            [
                                14.22328,
                                12.36207
                            ],
                            [
                                14.17485,
                                12.40999
                            ],
                            [
                                14.20303,
                                12.53883
                            ],
                            [
                                14.08543,
                                13.07806
                            ],
                            [
                                13.89132,
                                13.34334
                            ],
                            [
                                13.63455,
                                13.71068
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                7.28307,
                                4.46809
                            ],
                            [
                                7.16838,
                                4.44088
                            ],
                            [
                                7.13605,
                                4.38519
                            ],
                            [
                                7.21461,
                                4.38115
                            ],
                            [
                                7.32468,
                                4.416
                            ],
                            [
                                7.28307,
                                4.46809
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "NIU",
                "Country": "Niue",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    8.9542e-10,
                    1.7928e-09,
                    2.6865e-09,
                    3.5822e-09,
                    4.4743e-09,
                    5.3573e-09,
                    6.2421e-09,
                    7.1233e-09,
                    7.9952e-09,
                    8.8635e-09,
                    9.7226e-09,
                    1.0578e-08,
                    1.143e-08,
                    1.2278e-08,
                    1.3128e-08,
                    1.3969e-08,
                    1.4811e-08,
                    1.5656e-08,
                    1.6491e-08,
                    1.7329e-08,
                    1.8168e-08,
                    1.9015e-08,
                    1.9865e-08,
                    2.0717e-08,
                    2.1583e-08,
                    2.2452e-08,
                    2.333e-08,
                    2.4221e-08,
                    2.5119e-08,
                    2.6026e-08,
                    2.6941e-08,
                    2.7864e-08,
                    2.8795e-08,
                    2.9734e-08,
                    3.0687e-08,
                    3.1647e-08,
                    3.2621e-08,
                    3.3609e-08,
                    3.461e-08,
                    3.5633e-08,
                    3.6667e-08,
                    3.7719e-08,
                    3.8784e-08,
                    3.9867e-08,
                    4.0974e-08,
                    4.2098e-08,
                    4.3247e-08,
                    4.442e-08,
                    4.5616e-08,
                    4.6837e-08,
                    4.8089e-08,
                    4.9368e-08,
                    5.0679e-08,
                    5.2016e-08,
                    5.3391e-08,
                    5.4799e-08,
                    5.6239e-08,
                    5.7722e-08,
                    5.9242e-08,
                    6.08e-08,
                    6.2398e-08,
                    6.4037e-08,
                    6.5715e-08,
                    6.7429e-08,
                    6.9188e-08,
                    7.0993e-08,
                    7.2832e-08,
                    7.4718e-08,
                    7.6654e-08,
                    7.8631e-08,
                    8.0658e-08,
                    8.273e-08,
                    8.4837e-08,
                    8.6995e-08,
                    8.916e-08,
                    9.1348e-08,
                    9.3565e-08,
                    9.5778e-08,
                    9.8009e-08,
                    1.0025e-07,
                    1.025e-07,
                    1.048e-07,
                    1.0713e-07,
                    1.0953e-07,
                    1.12e-07,
                    1.1448e-07,
                    1.17e-07,
                    1.1958e-07,
                    1.2222e-07,
                    1.2494e-07,
                    1.2775e-07,
                    1.3067e-07,
                    1.337e-07,
                    1.3687e-07,
                    1.4019e-07,
                    1.4371e-07,
                    1.4744e-07,
                    1.5139e-07,
                    1.5556e-07,
                    1.5999e-07,
                    1.6467e-07,
                    1.6967e-07,
                    1.7496e-07,
                    1.8047e-07,
                    1.8611e-07,
                    1.9192e-07,
                    1.9779e-07,
                    2.0367e-07,
                    2.0949e-07,
                    2.1499e-07,
                    2.2035e-07,
                    2.2516e-07,
                    2.2933e-07,
                    2.3308e-07,
                    2.3686e-07,
                    2.4087e-07,
                    2.4548e-07,
                    2.5101e-07,
                    2.576e-07,
                    2.6622e-07,
                    2.7577e-07,
                    2.8731e-07,
                    3.021e-07,
                    3.1816e-07,
                    3.352e-07,
                    3.5237e-07,
                    3.6834e-07,
                    3.8177e-07,
                    3.9373e-07,
                    4.0377e-07,
                    4.1204e-07,
                    4.1877e-07,
                    4.2455e-07,
                    4.2955e-07,
                    4.3374e-07,
                    4.3762e-07,
                    4.4163e-07,
                    4.4659e-07,
                    4.5183e-07,
                    4.5883e-07,
                    4.6539e-07,
                    4.7174e-07,
                    4.7621e-07,
                    4.7981e-07,
                    4.8285e-07,
                    4.8551e-07,
                    4.8782e-07,
                    4.9061e-07,
                    4.9329e-07,
                    4.9638e-07,
                    4.9944e-07,
                    5.0244e-07,
                    5.0364e-07,
                    5.0487e-07,
                    5.0665e-07,
                    5.0893e-07,
                    5.1166e-07,
                    5.1637e-07,
                    5.1957e-07,
                    5.2256e-07,
                    5.2667e-07,
                    5.3056e-07,
                    5.3434e-07,
                    5.3959e-07,
                    5.431e-07,
                    5.4658e-07,
                    5.5005e-07,
                    5.5514e-07,
                    5.5849e-07,
                    5.6171e-07,
                    5.6494e-07,
                    5.6809e-07
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    6.207e-11,
                    1.2444e-10,
                    1.8712e-10,
                    2.5009e-10,
                    3.1336e-10,
                    3.7694e-10,
                    4.408e-10,
                    5.0496e-10,
                    5.6942e-10,
                    6.3416e-10,
                    6.9921e-10,
                    7.6455e-10,
                    8.3019e-10,
                    8.9613e-10,
                    9.6236e-10,
                    1.0289e-09,
                    1.0957e-09,
                    1.1628e-09,
                    1.2303e-09,
                    1.298e-09,
                    1.366e-09,
                    1.4343e-09,
                    1.503e-09,
                    1.572e-09,
                    1.6414e-09,
                    1.7111e-09,
                    1.7811e-09,
                    1.8515e-09,
                    1.9222e-09,
                    1.9932e-09,
                    2.0636e-09,
                    2.1332e-09,
                    2.2023e-09,
                    2.2706e-09,
                    2.3383e-09,
                    2.4053e-09,
                    2.4717e-09,
                    2.5374e-09,
                    2.6024e-09,
                    2.6668e-09,
                    2.7304e-09,
                    2.7933e-09,
                    2.8554e-09,
                    2.9168e-09,
                    2.9775e-09,
                    3.0374e-09,
                    3.0966e-09,
                    3.155e-09,
                    3.2127e-09,
                    3.2697e-09,
                    3.3227e-09,
                    3.3718e-09,
                    3.417e-09,
                    3.4582e-09,
                    3.4954e-09,
                    3.5286e-09,
                    3.5578e-09,
                    3.5829e-09,
                    3.6039e-09,
                    3.6209e-09,
                    3.6333e-09,
                    3.6412e-09,
                    3.6445e-09,
                    3.6433e-09,
                    3.6375e-09,
                    3.6272e-09,
                    3.6122e-09,
                    3.5927e-09,
                    3.5686e-09,
                    3.5399e-09,
                    3.5185e-09,
                    3.5046e-09,
                    3.4982e-09,
                    3.4993e-09,
                    3.5079e-09,
                    3.524e-09,
                    3.5476e-09,
                    3.5789e-09,
                    3.6177e-09,
                    3.6642e-09,
                    3.7187e-09,
                    3.7812e-09,
                    3.8516e-09,
                    3.9301e-09,
                    4.0166e-09,
                    4.1111e-09,
                    4.2136e-09,
                    4.3242e-09,
                    4.4429e-09,
                    4.5742e-09,
                    4.7166e-09,
                    4.8704e-09,
                    5.0354e-09,
                    5.2119e-09,
                    5.3946e-09,
                    5.5833e-09,
                    5.778e-09,
                    5.9784e-09,
                    6.1842e-09,
                    6.3953e-09,
                    6.6126e-09,
                    6.8345e-09,
                    7.0601e-09,
                    7.2892e-09,
                    7.5223e-09,
                    7.7602e-09,
                    8.0043e-09,
                    8.2556e-09,
                    8.5153e-09,
                    8.7801e-09,
                    9.0366e-09,
                    9.2849e-09,
                    9.5254e-09,
                    9.7578e-09,
                    9.9722e-09,
                    1.0169e-08,
                    1.0346e-08,
                    1.0502e-08,
                    1.0628e-08,
                    1.2406e-08,
                    1.414e-08,
                    1.5817e-08,
                    1.7433e-08,
                    1.8994e-08,
                    2.0509e-08,
                    2.1983e-08,
                    2.3423e-08,
                    2.4833e-08,
                    2.6209e-08,
                    2.7554e-08,
                    2.8871e-08,
                    3.0154e-08,
                    3.141e-08,
                    3.2631e-08,
                    3.3837e-08,
                    3.5032e-08,
                    3.6219e-08,
                    3.7401e-08,
                    3.8589e-08,
                    4.1415e-08,
                    4.4267e-08,
                    4.7171e-08,
                    5.0119e-08,
                    5.311e-08,
                    5.6132e-08,
                    5.9184e-08,
                    6.2253e-08,
                    6.5333e-08,
                    6.8428e-08,
                    7.1541e-08,
                    7.4668e-08,
                    7.7821e-08,
                    7.9338e-08,
                    8.0881e-08,
                    8.2439e-08,
                    8.4015e-08,
                    8.5608e-08,
                    8.8865e-08,
                    9.0479e-08,
                    9.2101e-08,
                    9.5379e-08,
                    9.8652e-08,
                    1.0193e-07,
                    1.0686e-07,
                    1.1014e-07,
                    1.1343e-07,
                    1.1672e-07,
                    1.2166e-07,
                    1.2496e-07,
                    1.2826e-07,
                    1.3172e-07,
                    1.3513e-07
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [
                    8.3335e-10,
                    1.6683e-09,
                    2.4994e-09,
                    3.3321e-09,
                    4.161e-09,
                    4.9804e-09,
                    5.8013e-09,
                    6.6183e-09,
                    7.4258e-09,
                    8.2293e-09,
                    9.0234e-09,
                    9.8135e-09,
                    1.06e-08,
                    1.1382e-08,
                    1.2166e-08,
                    1.294e-08,
                    1.3716e-08,
                    1.4493e-08,
                    1.5261e-08,
                    1.6031e-08,
                    1.6802e-08,
                    1.7581e-08,
                    1.8362e-08,
                    1.9145e-08,
                    1.9942e-08,
                    2.0741e-08,
                    2.1549e-08,
                    2.2369e-08,
                    2.3197e-08,
                    2.4033e-08,
                    2.4877e-08,
                    2.5731e-08,
                    2.6593e-08,
                    2.7463e-08,
                    2.8348e-08,
                    2.9242e-08,
                    3.015e-08,
                    3.1072e-08,
                    3.2008e-08,
                    3.2966e-08,
                    3.3937e-08,
                    3.4926e-08,
                    3.5929e-08,
                    3.695e-08,
                    3.7996e-08,
                    3.9061e-08,
                    4.015e-08,
                    4.1265e-08,
                    4.2403e-08,
                    4.3567e-08,
                    4.4766e-08,
                    4.5996e-08,
                    4.7262e-08,
                    4.8558e-08,
                    4.9896e-08,
                    5.127e-08,
                    5.2681e-08,
                    5.4139e-08,
                    5.5638e-08,
                    5.7179e-08,
                    5.8765e-08,
                    6.0396e-08,
                    6.2071e-08,
                    6.3785e-08,
                    6.555e-08,
                    6.7366e-08,
                    6.922e-08,
                    7.1125e-08,
                    7.3085e-08,
                    7.5091e-08,
                    7.7139e-08,
                    7.9226e-08,
                    8.1339e-08,
                    8.3496e-08,
                    8.5652e-08,
                    8.7824e-08,
                    9.0018e-08,
                    9.2199e-08,
                    9.4391e-08,
                    9.6582e-08,
                    9.8779e-08,
                    1.0102e-07,
                    1.0328e-07,
                    1.056e-07,
                    1.0798e-07,
                    1.1037e-07,
                    1.1278e-07,
                    1.1525e-07,
                    1.1778e-07,
                    1.2036e-07,
                    1.2303e-07,
                    1.258e-07,
                    1.2867e-07,
                    1.3165e-07,
                    1.348e-07,
                    1.3813e-07,
                    1.4166e-07,
                    1.4542e-07,
                    1.4938e-07,
                    1.5359e-07,
                    1.5805e-07,
                    1.6284e-07,
                    1.679e-07,
                    1.7318e-07,
                    1.7859e-07,
                    1.8416e-07,
                    1.8978e-07,
                    1.9541e-07,
                    2.0098e-07,
                    2.0621e-07,
                    2.1132e-07,
                    2.1588e-07,
                    2.198e-07,
                    2.2333e-07,
                    2.2689e-07,
                    2.307e-07,
                    2.3514e-07,
                    2.405e-07,
                    2.4697e-07,
                    2.5381e-07,
                    2.6163e-07,
                    2.715e-07,
                    2.8467e-07,
                    2.9916e-07,
                    3.1469e-07,
                    3.3039e-07,
                    3.4492e-07,
                    3.5693e-07,
                    3.6752e-07,
                    3.7622e-07,
                    3.8317e-07,
                    3.8862e-07,
                    3.9314e-07,
                    3.9692e-07,
                    3.9991e-07,
                    4.0259e-07,
                    4.0541e-07,
                    4.0919e-07,
                    4.1325e-07,
                    4.1742e-07,
                    4.2112e-07,
                    4.2456e-07,
                    4.2609e-07,
                    4.267e-07,
                    4.2671e-07,
                    4.2633e-07,
                    4.2556e-07,
                    4.2527e-07,
                    4.2486e-07,
                    4.2484e-07,
                    4.2477e-07,
                    4.2462e-07,
                    4.243e-07,
                    4.2399e-07,
                    4.2421e-07,
                    4.2491e-07,
                    4.2605e-07,
                    4.275e-07,
                    4.2909e-07,
                    4.3045e-07,
                    4.3129e-07,
                    4.3191e-07,
                    4.3241e-07,
                    4.3273e-07,
                    4.3296e-07,
                    4.3315e-07,
                    4.3334e-07,
                    4.3348e-07,
                    4.3353e-07,
                    4.3344e-07,
                    4.3323e-07,
                    4.3296e-07
                ],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    5.61e-10,
                    1.122e-09,
                    1.6775e-09,
                    2.233e-09,
                    2.783e-09,
                    3.322e-09,
                    3.861e-09,
                    4.3945e-09,
                    4.917e-09,
                    5.434e-09,
                    5.94e-09,
                    6.4405e-09,
                    6.9355e-09,
                    7.425e-09,
                    7.9145e-09,
                    8.393e-09,
                    8.8715e-09,
                    9.35e-09,
                    9.8175e-09,
                    1.0285e-08,
                    1.0752e-08,
                    1.1226e-08,
                    1.1699e-08,
                    1.2172e-08,
                    1.2656e-08,
                    1.3139e-08,
                    1.3629e-08,
                    1.4129e-08,
                    1.4636e-08,
                    1.5147e-08,
                    1.567e-08,
                    1.6203e-08,
                    1.6748e-08,
                    1.7303e-08,
                    1.7875e-08,
                    1.8458e-08,
                    1.9058e-08,
                    1.9674e-08,
                    2.0306e-08,
                    2.0961e-08,
                    2.1632e-08,
                    2.2324e-08,
                    2.3034e-08,
                    2.3765e-08,
                    2.4524e-08,
                    2.5306e-08,
                    2.6114e-08,
                    2.695e-08,
                    2.7813e-08,
                    2.8705e-08,
                    2.9628e-08,
                    3.058e-08,
                    3.1564e-08,
                    3.2577e-08,
                    3.3627e-08,
                    3.471e-08,
                    3.5827e-08,
                    3.6987e-08,
                    3.8187e-08,
                    3.9424e-08,
                    4.0706e-08,
                    4.2031e-08,
                    4.34e-08,
                    4.4808e-08,
                    4.6266e-08,
                    4.7773e-08,
                    4.9318e-08,
                    5.0913e-08,
                    5.2563e-08,
                    5.4257e-08,
                    5.5995e-08,
                    5.7772e-08,
                    5.9576e-08,
                    6.1424e-08,
                    6.3272e-08,
                    6.5136e-08,
                    6.7023e-08,
                    6.8898e-08,
                    7.0785e-08,
                    7.2671e-08,
                    7.4564e-08,
                    7.6494e-08,
                    7.8452e-08,
                    8.0465e-08,
                    8.2538e-08,
                    8.4672e-08,
                    8.6883e-08,
                    8.9204e-08,
                    9.163e-08,
                    9.4176e-08,
                    9.6855e-08,
                    9.9687e-08,
                    1.0267e-07,
                    1.0583e-07,
                    1.092e-07,
                    1.128e-07,
                    1.1667e-07,
                    1.2081e-07,
                    1.2521e-07,
                    1.2993e-07,
                    1.3494e-07,
                    1.4034e-07,
                    1.4607e-07,
                    1.521e-07,
                    1.583e-07,
                    1.6468e-07,
                    1.7112e-07,
                    1.7756e-07,
                    1.8395e-07,
                    1.9001e-07,
                    1.9545e-07,
                    2.0018e-07,
                    2.0415e-07,
                    2.0758e-07,
                    2.1075e-07,
                    2.141e-07,
                    2.1795e-07,
                    2.2242e-07,
                    2.2747e-07,
                    2.347e-07,
                    2.4248e-07,
                    2.5227e-07,
                    2.6424e-07,
                    2.7756e-07,
                    2.9179e-07,
                    3.0606e-07,
                    3.1893e-07,
                    3.2993e-07,
                    3.3944e-07,
                    3.4757e-07,
                    3.543e-07,
                    3.5966e-07,
                    3.6412e-07,
                    3.6807e-07,
                    3.7162e-07,
                    3.7503e-07,
                    3.7885e-07,
                    3.8402e-07,
                    3.9003e-07,
                    3.9787e-07,
                    4.0555e-07,
                    4.1292e-07,
                    4.1929e-07,
                    4.2456e-07,
                    4.2928e-07,
                    4.3368e-07,
                    4.3786e-07,
                    4.4193e-07,
                    4.4588e-07,
                    4.4974e-07,
                    4.5348e-07,
                    4.571e-07,
                    4.5894e-07,
                    4.6066e-07,
                    4.6267e-07,
                    4.6504e-07,
                    4.6761e-07,
                    4.7197e-07,
                    4.7473e-07,
                    4.7704e-07,
                    4.8051e-07,
                    4.8375e-07,
                    4.8687e-07,
                    4.9152e-07,
                    4.9439e-07,
                    4.9723e-07,
                    5.0001e-07,
                    5.044e-07,
                    5.0702e-07,
                    5.0953e-07,
                    5.1212e-07,
                    5.1461e-07
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.65e-09,
                    3.3e-09,
                    4.95e-09,
                    6.6e-09,
                    8.25e-09,
                    9.9e-09,
                    1.155e-08,
                    1.32e-08,
                    1.485e-08,
                    1.65e-08,
                    1.815e-08,
                    1.98e-08,
                    2.145e-08,
                    2.31e-08,
                    2.475e-08,
                    2.64e-08,
                    2.805e-08,
                    2.97e-08,
                    3.135e-08,
                    3.3e-08,
                    3.63e-08,
                    3.96e-08,
                    4.29e-08,
                    4.62e-08,
                    4.95e-08,
                    5.28e-08,
                    5.61e-08,
                    5.94e-08,
                    6.27e-08,
                    6.6e-08,
                    6.93e-08,
                    7.26e-08,
                    7.59e-08,
                    7.755e-08,
                    7.92e-08,
                    8.085e-08,
                    8.25e-08,
                    8.415e-08,
                    8.745e-08,
                    8.91e-08,
                    9.075e-08,
                    9.405e-08,
                    9.735e-08,
                    1.0065e-07,
                    1.056e-07,
                    1.089e-07,
                    1.122e-07,
                    1.155e-07,
                    1.2045e-07,
                    1.2375e-07,
                    1.2705e-07,
                    1.3049e-07,
                    1.339e-07
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [
                    5.61e-10,
                    1.122e-09,
                    1.6775e-09,
                    2.233e-09,
                    2.783e-09,
                    3.322e-09,
                    3.861e-09,
                    4.3945e-09,
                    4.917e-09,
                    5.434e-09,
                    5.94e-09,
                    6.4405e-09,
                    6.9355e-09,
                    7.425e-09,
                    7.9145e-09,
                    8.393e-09,
                    8.8715e-09,
                    9.35e-09,
                    9.8175e-09,
                    1.0285e-08,
                    1.0752e-08,
                    1.1226e-08,
                    1.1699e-08,
                    1.2172e-08,
                    1.2656e-08,
                    1.3139e-08,
                    1.3629e-08,
                    1.4129e-08,
                    1.4636e-08,
                    1.5147e-08,
                    1.567e-08,
                    1.6203e-08,
                    1.6748e-08,
                    1.7303e-08,
                    1.7875e-08,
                    1.8458e-08,
                    1.9058e-08,
                    1.9674e-08,
                    2.0306e-08,
                    2.0961e-08,
                    2.1632e-08,
                    2.2324e-08,
                    2.3034e-08,
                    2.3765e-08,
                    2.4524e-08,
                    2.5306e-08,
                    2.6114e-08,
                    2.695e-08,
                    2.7813e-08,
                    2.8705e-08,
                    2.9628e-08,
                    3.058e-08,
                    3.1564e-08,
                    3.2577e-08,
                    3.3627e-08,
                    3.471e-08,
                    3.5827e-08,
                    3.6987e-08,
                    3.8187e-08,
                    3.9424e-08,
                    4.0706e-08,
                    4.2031e-08,
                    4.34e-08,
                    4.4808e-08,
                    4.6266e-08,
                    4.7773e-08,
                    4.9318e-08,
                    5.0913e-08,
                    5.2563e-08,
                    5.4257e-08,
                    5.5995e-08,
                    5.7772e-08,
                    5.9576e-08,
                    6.1424e-08,
                    6.3272e-08,
                    6.5136e-08,
                    6.7023e-08,
                    6.8898e-08,
                    7.0785e-08,
                    7.2671e-08,
                    7.4564e-08,
                    7.6494e-08,
                    7.8452e-08,
                    8.0465e-08,
                    8.2538e-08,
                    8.4672e-08,
                    8.6883e-08,
                    8.9204e-08,
                    9.163e-08,
                    9.4176e-08,
                    9.6855e-08,
                    9.9687e-08,
                    1.0267e-07,
                    1.0583e-07,
                    1.092e-07,
                    1.128e-07,
                    1.1667e-07,
                    1.2081e-07,
                    1.2521e-07,
                    1.2993e-07,
                    1.3494e-07,
                    1.4034e-07,
                    1.4607e-07,
                    1.521e-07,
                    1.583e-07,
                    1.6468e-07,
                    1.7112e-07,
                    1.7756e-07,
                    1.8395e-07,
                    1.9001e-07,
                    1.9545e-07,
                    2.0018e-07,
                    2.0415e-07,
                    2.0758e-07,
                    2.1075e-07,
                    2.141e-07,
                    2.1795e-07,
                    2.2242e-07,
                    2.2747e-07,
                    2.3305e-07,
                    2.3918e-07,
                    2.4732e-07,
                    2.5764e-07,
                    2.6931e-07,
                    2.8189e-07,
                    2.9451e-07,
                    3.0573e-07,
                    3.1508e-07,
                    3.2294e-07,
                    3.2942e-07,
                    3.345e-07,
                    3.3821e-07,
                    3.4102e-07,
                    3.4332e-07,
                    3.4522e-07,
                    3.4698e-07,
                    3.4915e-07,
                    3.5267e-07,
                    3.5703e-07,
                    3.6157e-07,
                    3.6595e-07,
                    3.7002e-07,
                    3.7309e-07,
                    3.7506e-07,
                    3.7648e-07,
                    3.7757e-07,
                    3.7846e-07,
                    3.7923e-07,
                    3.7989e-07,
                    3.8044e-07,
                    3.8088e-07,
                    3.812e-07,
                    3.8139e-07,
                    3.8146e-07,
                    3.8182e-07,
                    3.8254e-07,
                    3.8346e-07,
                    3.8452e-07,
                    3.8563e-07,
                    3.8629e-07,
                    3.8646e-07,
                    3.864e-07,
                    3.8622e-07,
                    3.8592e-07,
                    3.855e-07,
                    3.8503e-07,
                    3.8451e-07,
                    3.8395e-07,
                    3.8327e-07,
                    3.8248e-07,
                    3.8163e-07,
                    3.8072e-07
                ],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [
                    3.2535e-10,
                    6.5244e-10,
                    9.8129e-10,
                    1.3119e-09,
                    1.6442e-09,
                    1.9783e-09,
                    2.3142e-09,
                    2.6517e-09,
                    2.9911e-09,
                    3.3322e-09,
                    3.6751e-09,
                    4.0198e-09,
                    4.3664e-09,
                    4.7148e-09,
                    5.0651e-09,
                    5.4172e-09,
                    5.7711e-09,
                    6.1269e-09,
                    6.4845e-09,
                    6.8439e-09,
                    7.2052e-09,
                    7.5685e-09,
                    7.9337e-09,
                    8.3008e-09,
                    8.6698e-09,
                    9.0408e-09,
                    9.4137e-09,
                    9.7885e-09,
                    1.0165e-08,
                    1.0544e-08,
                    1.0919e-08,
                    1.1292e-08,
                    1.1661e-08,
                    1.2028e-08,
                    1.2391e-08,
                    1.2751e-08,
                    1.3109e-08,
                    1.3463e-08,
                    1.3814e-08,
                    1.4162e-08,
                    1.4507e-08,
                    1.4848e-08,
                    1.5186e-08,
                    1.552e-08,
                    1.5851e-08,
                    1.6179e-08,
                    1.6503e-08,
                    1.6824e-08,
                    1.7141e-08,
                    1.7455e-08,
                    1.7768e-08,
                    1.8079e-08,
                    1.8389e-08,
                    1.8697e-08,
                    1.9003e-08,
                    1.9308e-08,
                    1.9612e-08,
                    1.9914e-08,
                    2.0214e-08,
                    2.0513e-08,
                    2.0808e-08,
                    2.1098e-08,
                    2.1385e-08,
                    2.1668e-08,
                    2.1947e-08,
                    2.2222e-08,
                    2.2493e-08,
                    2.276e-08,
                    2.3023e-08,
                    2.3282e-08,
                    2.3548e-08,
                    2.382e-08,
                    2.4098e-08,
                    2.4383e-08,
                    2.4674e-08,
                    2.4972e-08,
                    2.5277e-08,
                    2.5588e-08,
                    2.5906e-08,
                    2.623e-08,
                    2.6563e-08,
                    2.6905e-08,
                    2.7256e-08,
                    2.7615e-08,
                    2.7983e-08,
                    2.8306e-08,
                    2.8585e-08,
                    2.8819e-08,
                    2.9008e-08,
                    2.9156e-08,
                    2.926e-08,
                    2.9322e-08,
                    2.934e-08,
                    2.9314e-08,
                    2.9239e-08,
                    2.9114e-08,
                    2.8938e-08,
                    2.8712e-08,
                    2.8434e-08,
                    2.8104e-08,
                    2.7723e-08,
                    2.7286e-08,
                    2.6789e-08,
                    2.6234e-08,
                    2.562e-08,
                    2.5002e-08,
                    2.4382e-08,
                    2.3764e-08,
                    2.3151e-08,
                    2.2539e-08,
                    2.235e-08,
                    2.2329e-08,
                    2.2418e-08,
                    2.2648e-08,
                    2.3122e-08,
                    2.3656e-08,
                    2.4279e-08,
                    2.5175e-08,
                    2.652e-08,
                    2.7738e-08,
                    2.9319e-08,
                    3.0872e-08,
                    3.3401e-08,
                    3.5846e-08,
                    3.835e-08,
                    4.094e-08,
                    4.3721e-08,
                    4.5884e-08,
                    4.8073e-08,
                    4.9755e-08,
                    5.1063e-08,
                    5.2213e-08,
                    5.3306e-08,
                    5.4132e-08,
                    5.457e-08,
                    5.4837e-08,
                    5.4879e-08,
                    5.4533e-08,
                    5.3638e-08,
                    5.2691e-08,
                    5.1465e-08,
                    5.0333e-08,
                    4.8327e-08,
                    4.653e-08,
                    4.4712e-08,
                    4.2851e-08,
                    4.084e-08,
                    3.9436e-08,
                    3.8031e-08,
                    3.7131e-08,
                    3.6319e-08,
                    3.5533e-08,
                    3.4725e-08,
                    3.4068e-08,
                    3.3671e-08,
                    3.3405e-08,
                    3.3406e-08,
                    3.3545e-08,
                    3.3816e-08,
                    3.4301e-08,
                    3.4779e-08,
                    3.5248e-08,
                    3.5739e-08,
                    3.6164e-08,
                    3.6617e-08,
                    3.7082e-08,
                    3.7579e-08,
                    3.81e-08,
                    3.8637e-08,
                    3.9164e-08,
                    3.9624e-08,
                    4.0098e-08
                ],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [
                    6.1606e-11,
                    1.235e-10,
                    1.857e-10,
                    2.4818e-10,
                    3.1095e-10,
                    3.7402e-10,
                    4.3738e-10,
                    5.0102e-10,
                    5.6496e-10,
                    6.2918e-10,
                    6.937e-10,
                    7.5852e-10,
                    8.2364e-10,
                    8.8906e-10,
                    9.5477e-10,
                    1.0208e-09,
                    1.0871e-09,
                    1.1537e-09,
                    1.2206e-09,
                    1.2877e-09,
                    1.3552e-09,
                    1.423e-09,
                    1.4911e-09,
                    1.5595e-09,
                    1.6282e-09,
                    1.6971e-09,
                    1.7664e-09,
                    1.836e-09,
                    1.9059e-09,
                    1.976e-09,
                    2.0455e-09,
                    2.1144e-09,
                    2.1825e-09,
                    2.25e-09,
                    2.3168e-09,
                    2.3829e-09,
                    2.4484e-09,
                    2.5132e-09,
                    2.5773e-09,
                    2.6408e-09,
                    2.7035e-09,
                    2.7654e-09,
                    2.8266e-09,
                    2.8871e-09,
                    2.9468e-09,
                    3.0057e-09,
                    3.0639e-09,
                    3.1214e-09,
                    3.1781e-09,
                    3.234e-09,
                    3.286e-09,
                    3.3341e-09,
                    3.3782e-09,
                    3.4184e-09,
                    3.4545e-09,
                    3.4865e-09,
                    3.5146e-09,
                    3.5385e-09,
                    3.5584e-09,
                    3.5741e-09,
                    3.5853e-09,
                    3.5919e-09,
                    3.594e-09,
                    3.5915e-09,
                    3.5844e-09,
                    3.5727e-09,
                    3.5564e-09,
                    3.5355e-09,
                    3.51e-09,
                    3.4799e-09,
                    3.4571e-09,
                    3.4418e-09,
                    3.4339e-09,
                    3.4334e-09,
                    3.4405e-09,
                    3.455e-09,
                    3.4771e-09,
                    3.5068e-09,
                    3.544e-09,
                    3.5889e-09,
                    3.6417e-09,
                    3.7025e-09,
                    3.7713e-09,
                    3.8481e-09,
                    3.9329e-09,
                    4.0257e-09,
                    4.1266e-09,
                    4.2354e-09,
                    4.3523e-09,
                    4.4818e-09,
                    4.6224e-09,
                    4.7742e-09,
                    4.9371e-09,
                    5.1112e-09,
                    5.2914e-09,
                    5.4774e-09,
                    5.6691e-09,
                    5.8663e-09,
                    6.0688e-09,
                    6.2765e-09,
                    6.4902e-09,
                    6.7084e-09,
                    6.9303e-09,
                    7.1556e-09,
                    7.3849e-09,
                    7.6189e-09,
                    7.859e-09,
                    8.1062e-09,
                    8.3618e-09,
                    8.6224e-09,
                    8.8745e-09,
                    9.1183e-09,
                    9.354e-09,
                    9.5814e-09,
                    9.7906e-09,
                    9.9813e-09,
                    1.0153e-08,
                    1.0303e-08,
                    1.0423e-08,
                    1.0544e-08,
                    1.0622e-08,
                    1.0642e-08,
                    1.0601e-08,
                    1.0506e-08,
                    1.0363e-08,
                    1.018e-08,
                    9.9627e-09,
                    9.7153e-09,
                    9.4339e-09,
                    9.1211e-09,
                    8.7803e-09,
                    8.4057e-09,
                    8.0033e-09,
                    7.5665e-09,
                    7.1146e-09,
                    6.6517e-09,
                    6.1801e-09,
                    5.7046e-09,
                    5.2338e-09,
                    4.752e-09,
                    4.2959e-09,
                    3.891e-09,
                    3.5306e-09,
                    3.2139e-09,
                    2.9278e-09,
                    2.6716e-09,
                    2.4324e-09,
                    2.2048e-09,
                    1.9917e-09,
                    1.7957e-09,
                    1.6145e-09,
                    1.4593e-09,
                    1.3179e-09,
                    1.2029e-09,
                    1.1034e-09,
                    1.0216e-09,
                    9.5616e-10,
                    9.0525e-10,
                    8.6211e-10,
                    8.262e-10,
                    7.9598e-10,
                    7.604e-10,
                    7.3018e-10,
                    6.9996e-10,
                    6.7543e-10,
                    6.5126e-10,
                    6.3277e-10,
                    6.2033e-10,
                    6.1357e-10,
                    6.0717e-10,
                    6.0646e-10,
                    6.0799e-10
                ],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [
                    2.6374e-10,
                    5.2894e-10,
                    7.9559e-10,
                    1.0637e-09,
                    1.3333e-09,
                    1.6043e-09,
                    1.8768e-09,
                    2.1507e-09,
                    2.4261e-09,
                    2.703e-09,
                    2.9814e-09,
                    3.2613e-09,
                    3.5428e-09,
                    3.8258e-09,
                    4.1103e-09,
                    4.3964e-09,
                    4.684e-09,
                    4.9732e-09,
                    5.2639e-09,
                    5.5561e-09,
                    5.85e-09,
                    6.1455e-09,
                    6.4426e-09,
                    6.7413e-09,
                    7.0417e-09,
                    7.3436e-09,
                    7.6472e-09,
                    7.9525e-09,
                    8.2593e-09,
                    8.5678e-09,
                    8.8739e-09,
                    9.1776e-09,
                    9.4789e-09,
                    9.7778e-09,
                    1.0074e-08,
                    1.0369e-08,
                    1.066e-08,
                    1.095e-08,
                    1.1237e-08,
                    1.1521e-08,
                    1.1803e-08,
                    1.2083e-08,
                    1.2359e-08,
                    1.2633e-08,
                    1.2905e-08,
                    1.3173e-08,
                    1.3439e-08,
                    1.3703e-08,
                    1.3963e-08,
                    1.4221e-08,
                    1.4482e-08,
                    1.4745e-08,
                    1.501e-08,
                    1.5278e-08,
                    1.5549e-08,
                    1.5822e-08,
                    1.6097e-08,
                    1.6375e-08,
                    1.6656e-08,
                    1.6939e-08,
                    1.7222e-08,
                    1.7507e-08,
                    1.7791e-08,
                    1.8077e-08,
                    1.8363e-08,
                    1.865e-08,
                    1.8937e-08,
                    1.9225e-08,
                    1.9513e-08,
                    1.9803e-08,
                    2.0091e-08,
                    2.0378e-08,
                    2.0664e-08,
                    2.095e-08,
                    2.1234e-08,
                    2.1517e-08,
                    2.18e-08,
                    2.2081e-08,
                    2.2362e-08,
                    2.2641e-08,
                    2.2922e-08,
                    2.3202e-08,
                    2.3484e-08,
                    2.3767e-08,
                    2.405e-08,
                    2.4281e-08,
                    2.4459e-08,
                    2.4584e-08,
                    2.4656e-08,
                    2.4674e-08,
                    2.4638e-08,
                    2.4548e-08,
                    2.4403e-08,
                    2.4203e-08,
                    2.3947e-08,
                    2.3636e-08,
                    2.3269e-08,
                    2.2845e-08,
                    2.2365e-08,
                    2.1828e-08,
                    2.1233e-08,
                    2.0577e-08,
                    1.9859e-08,
                    1.9078e-08,
                    1.8235e-08,
                    1.7383e-08,
                    1.6523e-08,
                    1.5658e-08,
                    1.4789e-08,
                    1.3917e-08,
                    1.3475e-08,
                    1.3211e-08,
                    1.3064e-08,
                    1.3067e-08,
                    1.3331e-08,
                    1.3675e-08,
                    1.4126e-08,
                    1.4872e-08,
                    1.6097e-08,
                    1.7194e-08,
                    1.8698e-08,
                    2.023e-08,
                    2.28e-08,
                    2.534e-08,
                    2.7987e-08,
                    3.076e-08,
                    3.3758e-08,
                    3.6168e-08,
                    3.8639e-08,
                    4.0634e-08,
                    4.2283e-08,
                    4.3807e-08,
                    4.5302e-08,
                    4.6566e-08,
                    4.7455e-08,
                    4.8186e-08,
                    4.8699e-08,
                    4.8828e-08,
                    4.8404e-08,
                    4.7939e-08,
                    4.7169e-08,
                    4.6442e-08,
                    4.4797e-08,
                    4.3316e-08,
                    4.1784e-08,
                    4.0179e-08,
                    3.8408e-08,
                    3.7231e-08,
                    3.6039e-08,
                    3.5335e-08,
                    3.4704e-08,
                    3.4074e-08,
                    3.3407e-08,
                    3.2865e-08,
                    3.2567e-08,
                    3.2383e-08,
                    3.245e-08,
                    3.264e-08,
                    3.2953e-08,
                    3.3475e-08,
                    3.3983e-08,
                    3.4488e-08,
                    3.5009e-08,
                    3.5464e-08,
                    3.5942e-08,
                    3.643e-08,
                    3.6947e-08,
                    3.7479e-08,
                    3.8023e-08,
                    3.8556e-08,
                    3.9017e-08,
                    3.949e-08
                ],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [
                    9.074e-12,
                    1.833e-11,
                    2.7759e-11,
                    3.7351e-11,
                    4.7092e-11,
                    5.6965e-11,
                    6.6951e-11,
                    7.7027e-11,
                    8.7167e-11,
                    9.7343e-11,
                    1.0754e-10,
                    1.1774e-10,
                    1.2796e-10,
                    1.3818e-10,
                    1.4841e-10,
                    1.5864e-10,
                    1.6888e-10,
                    1.7914e-10,
                    1.894e-10,
                    1.9969e-10,
                    2.1014e-10,
                    2.2104e-10,
                    2.3257e-10,
                    2.4488e-10,
                    2.5804e-10,
                    2.7209e-10,
                    2.8697e-10,
                    3.0259e-10,
                    3.1878e-10,
                    3.3531e-10,
                    3.5204e-10,
                    3.6893e-10,
                    3.8597e-10,
                    4.0312e-10,
                    4.2038e-10,
                    4.3774e-10,
                    4.552e-10,
                    4.7277e-10,
                    4.9046e-10,
                    5.1009e-10,
                    5.2889e-10,
                    5.4695e-10,
                    5.6439e-10,
                    5.8131e-10,
                    5.978e-10,
                    6.1395e-10,
                    6.2985e-10,
                    6.4558e-10,
                    6.6122e-10,
                    6.7684e-10,
                    6.926e-10,
                    7.0876e-10,
                    7.2549e-10,
                    7.4293e-10,
                    7.6116e-10,
                    7.8021e-10,
                    8.0005e-10,
                    8.2061e-10,
                    8.4176e-10,
                    8.6331e-10,
                    8.8515e-10,
                    9.0722e-10,
                    9.2951e-10,
                    9.5198e-10,
                    9.7464e-10,
                    9.9746e-10,
                    1.0205e-09,
                    1.0436e-09,
                    1.067e-09,
                    1.0906e-09,
                    1.1145e-09,
                    1.1387e-09,
                    1.1632e-09,
                    1.1882e-09,
                    1.2135e-09,
                    1.2392e-09,
                    1.2652e-09,
                    1.2915e-09,
                    1.3179e-09,
                    1.3445e-09,
                    1.371e-09,
                    1.3974e-09,
                    1.4238e-09,
                    1.4501e-09,
                    1.4763e-09,
                    1.5024e-09,
                    1.5284e-09,
                    1.5544e-09,
                    1.5803e-09,
                    1.6062e-09,
                    1.6326e-09,
                    1.6601e-09,
                    1.6894e-09,
                    1.7208e-09,
                    1.7546e-09,
                    1.7908e-09,
                    1.8294e-09,
                    1.8701e-09,
                    1.9126e-09,
                    1.9563e-09,
                    2.0008e-09,
                    2.0463e-09,
                    2.0926e-09,
                    2.14e-09,
                    2.1884e-09,
                    2.2379e-09,
                    2.2885e-09,
                    2.3402e-09,
                    2.3931e-09,
                    2.4471e-09,
                    2.5498e-09,
                    2.6528e-09,
                    2.7559e-09,
                    2.8592e-09,
                    2.9875e-09,
                    3.1159e-09,
                    3.2569e-09,
                    3.4105e-09,
                    3.6011e-09,
                    3.7797e-09,
                    3.9706e-09,
                    4.174e-09,
                    4.4637e-09,
                    4.7534e-09,
                    5.0556e-09,
                    5.3702e-09,
                    5.6849e-09,
                    5.9505e-09,
                    6.2162e-09,
                    6.4451e-09,
                    6.6741e-09,
                    6.9032e-09,
                    7.1324e-09,
                    7.3493e-09,
                    7.554e-09,
                    7.7465e-09,
                    7.9022e-09,
                    8.0456e-09,
                    8.1644e-09,
                    8.271e-09,
                    8.3775e-09,
                    8.4843e-09,
                    8.5908e-09,
                    8.7219e-09,
                    8.853e-09,
                    8.9841e-09,
                    9.1152e-09,
                    9.2462e-09,
                    9.3772e-09,
                    9.5082e-09,
                    9.6396e-09,
                    9.8077e-09,
                    9.9757e-09,
                    1.0144e-08,
                    1.0311e-08,
                    1.0479e-08,
                    1.0647e-08,
                    1.0851e-08,
                    1.1031e-08,
                    1.1211e-08,
                    1.1379e-08,
                    1.156e-08,
                    1.174e-08,
                    1.1908e-08,
                    1.2088e-08,
                    1.2269e-08,
                    1.2461e-08,
                    1.2641e-08,
                    1.2834e-08,
                    1.3014e-08,
                    1.3195e-08,
                    1.3376e-08
                ],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [
                    4.6447e-13,
                    9.3823e-13,
                    1.4209e-12,
                    1.9119e-12,
                    2.4105e-12,
                    2.9159e-12,
                    3.427e-12,
                    3.9428e-12,
                    4.4618e-12,
                    4.9827e-12,
                    5.5044e-12,
                    6.0268e-12,
                    6.5497e-12,
                    7.0729e-12,
                    7.5965e-12,
                    8.1204e-12,
                    8.6446e-12,
                    9.1694e-12,
                    9.6949e-12,
                    1.0221e-11,
                    1.0757e-11,
                    1.1314e-11,
                    1.1904e-11,
                    1.2534e-11,
                    1.3208e-11,
                    1.3927e-11,
                    1.4689e-11,
                    1.5489e-11,
                    1.6317e-11,
                    1.7163e-11,
                    1.802e-11,
                    1.8885e-11,
                    1.9756e-11,
                    2.0634e-11,
                    2.1518e-11,
                    2.2406e-11,
                    2.33e-11,
                    2.4199e-11,
                    2.5105e-11,
                    2.6018e-11,
                    2.6938e-11,
                    2.7867e-11,
                    2.8803e-11,
                    2.9748e-11,
                    3.0702e-11,
                    3.1665e-11,
                    3.2638e-11,
                    3.3621e-11,
                    3.4616e-11,
                    3.5624e-11,
                    3.6646e-11,
                    3.7684e-11,
                    3.8742e-11,
                    3.9821e-11,
                    4.0921e-11,
                    4.2044e-11,
                    4.319e-11,
                    4.4359e-11,
                    4.555e-11,
                    4.6762e-11,
                    4.7994e-11,
                    4.9247e-11,
                    5.052e-11,
                    5.1812e-11,
                    5.3125e-11,
                    5.4459e-11,
                    5.5812e-11,
                    5.7186e-11,
                    5.858e-11,
                    5.9994e-11,
                    6.143e-11,
                    6.2887e-11,
                    6.4366e-11,
                    6.5868e-11,
                    6.7391e-11,
                    6.8936e-11,
                    7.0502e-11,
                    7.209e-11,
                    7.3696e-11,
                    7.5322e-11,
                    7.6964e-11,
                    7.862e-11,
                    8.0289e-11,
                    8.1969e-11,
                    8.3661e-11,
                    8.5365e-11,
                    8.7085e-11,
                    8.8822e-11,
                    9.0581e-11,
                    9.2367e-11,
                    9.4214e-11,
                    9.6178e-11,
                    9.8304e-11,
                    1.0062e-10,
                    1.0316e-10,
                    1.0591e-10,
                    1.0888e-10,
                    1.1205e-10,
                    1.1539e-10,
                    1.1886e-10,
                    1.2243e-10,
                    1.2608e-10,
                    1.2979e-10,
                    1.3358e-10,
                    1.3742e-10,
                    1.4132e-10,
                    1.4529e-10,
                    1.4933e-10,
                    1.5346e-10,
                    1.577e-10,
                    1.6207e-10,
                    1.6662e-10,
                    1.7139e-10,
                    1.7641e-10,
                    1.8168e-10,
                    1.872e-10,
                    1.9299e-10,
                    1.9901e-10,
                    2.0524e-10,
                    2.1166e-10,
                    2.1822e-10,
                    2.2493e-10,
                    2.3179e-10,
                    2.3878e-10,
                    2.459e-10,
                    2.5314e-10,
                    2.6049e-10,
                    2.6794e-10,
                    2.7549e-10,
                    2.8312e-10,
                    2.9082e-10,
                    2.9861e-10,
                    3.0647e-10,
                    3.1441e-10,
                    3.2242e-10,
                    3.305e-10,
                    3.3862e-10,
                    3.4679e-10,
                    3.5499e-10,
                    3.6321e-10,
                    3.7142e-10,
                    3.7982e-10,
                    3.8801e-10,
                    3.9619e-10,
                    4.0434e-10,
                    4.1247e-10,
                    4.2058e-10,
                    4.2868e-10,
                    4.3676e-10,
                    4.4484e-10,
                    4.5326e-10,
                    4.6157e-10,
                    4.6973e-10,
                    4.7785e-10,
                    4.8571e-10,
                    4.9355e-10,
                    5.014e-10,
                    5.0931e-10,
                    5.173e-10,
                    5.2525e-10,
                    5.3333e-10,
                    5.4139e-10,
                    5.4961e-10,
                    5.578e-10,
                    5.6605e-10,
                    5.7425e-10,
                    5.8237e-10,
                    5.9059e-10,
                    5.9881e-10,
                    6.0704e-10,
                    6.1526e-10,
                    6.2347e-10
                ],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": [
                    8.6096e-12,
                    1.7391e-11,
                    2.6338e-11,
                    3.5439e-11,
                    4.4681e-11,
                    5.405e-11,
                    6.3524e-11,
                    7.3085e-11,
                    8.2706e-11,
                    9.236e-11,
                    1.0203e-10,
                    1.1171e-10,
                    1.2141e-10,
                    1.3111e-10,
                    1.4081e-10,
                    1.5052e-10,
                    1.6024e-10,
                    1.6997e-10,
                    1.7971e-10,
                    1.8946e-10,
                    1.9939e-10,
                    2.0972e-10,
                    2.2066e-10,
                    2.3234e-10,
                    2.4484e-10,
                    2.5816e-10,
                    2.7228e-10,
                    2.871e-10,
                    3.0246e-10,
                    3.1815e-10,
                    3.3402e-10,
                    3.5005e-10,
                    3.6621e-10,
                    3.8249e-10,
                    3.9886e-10,
                    4.1533e-10,
                    4.319e-10,
                    4.4857e-10,
                    4.6535e-10,
                    4.8407e-10,
                    5.0195e-10,
                    5.1909e-10,
                    5.3559e-10,
                    5.5156e-10,
                    5.671e-10,
                    5.8229e-10,
                    5.9722e-10,
                    6.1196e-10,
                    6.2661e-10,
                    6.4121e-10,
                    6.5596e-10,
                    6.7108e-10,
                    6.8675e-10,
                    7.0311e-10,
                    7.2024e-10,
                    7.3816e-10,
                    7.5686e-10,
                    7.7625e-10,
                    7.9621e-10,
                    8.1655e-10,
                    8.3715e-10,
                    8.5798e-10,
                    8.7899e-10,
                    9.0017e-10,
                    9.2151e-10,
                    9.43e-10,
                    9.6464e-10,
                    9.8644e-10,
                    1.0084e-09,
                    1.0306e-09,
                    1.053e-09,
                    1.0758e-09,
                    1.0989e-09,
                    1.1223e-09,
                    1.1461e-09,
                    1.1703e-09,
                    1.1947e-09,
                    1.2194e-09,
                    1.2442e-09,
                    1.2691e-09,
                    1.294e-09,
                    1.3188e-09,
                    1.3435e-09,
                    1.3682e-09,
                    1.3927e-09,
                    1.4171e-09,
                    1.4414e-09,
                    1.4656e-09,
                    1.4897e-09,
                    1.5139e-09,
                    1.5384e-09,
                    1.5639e-09,
                    1.5911e-09,
                    1.6202e-09,
                    1.6514e-09,
                    1.6849e-09,
                    1.7205e-09,
                    1.7581e-09,
                    1.7972e-09,
                    1.8374e-09,
                    1.8784e-09,
                    1.9202e-09,
                    1.9628e-09,
                    2.0065e-09,
                    2.051e-09,
                    2.0966e-09,
                    2.1432e-09,
                    2.1909e-09,
                    2.2396e-09,
                    2.2894e-09,
                    2.3878e-09,
                    2.4861e-09,
                    2.5845e-09,
                    2.6828e-09,
                    2.8058e-09,
                    2.9287e-09,
                    3.0639e-09,
                    3.2115e-09,
                    3.3959e-09,
                    3.568e-09,
                    3.7524e-09,
                    3.9491e-09,
                    4.2319e-09,
                    4.5146e-09,
                    4.8097e-09,
                    5.117e-09,
                    5.4244e-09,
                    5.6826e-09,
                    5.9407e-09,
                    6.162e-09,
                    6.3833e-09,
                    6.6046e-09,
                    6.8259e-09,
                    7.0349e-09,
                    7.2316e-09,
                    7.416e-09,
                    7.5635e-09,
                    7.6988e-09,
                    7.8094e-09,
                    7.9078e-09,
                    8.0061e-09,
                    8.1045e-09,
                    8.2028e-09,
                    8.3258e-09,
                    8.4487e-09,
                    8.5716e-09,
                    8.6946e-09,
                    8.8175e-09,
                    8.9405e-09,
                    9.0634e-09,
                    9.1863e-09,
                    9.3462e-09,
                    9.506e-09,
                    9.6658e-09,
                    9.8256e-09,
                    9.9854e-09,
                    1.0145e-08,
                    1.0342e-08,
                    1.0514e-08,
                    1.0686e-08,
                    1.0846e-08,
                    1.1018e-08,
                    1.119e-08,
                    1.135e-08,
                    1.1522e-08,
                    1.1694e-08,
                    1.1879e-08,
                    1.2051e-08,
                    1.2235e-08,
                    1.2407e-08,
                    1.2579e-08,
                    1.2753e-08
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -169.95198,
                            -19.0746
                        ],
                        [
                            -169.878,
                            -19.15535
                        ],
                        [
                            -169.84396,
                            -19.14686
                        ],
                        [
                            -169.77447,
                            -19.05761
                        ],
                        [
                            -169.81084,
                            -18.96028
                        ],
                        [
                            -169.89176,
                            -18.96896
                        ],
                        [
                            -169.95198,
                            -19.0746
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "PRK",
                "Country": "North Korea",
                "Total_3GHG": 0.24,
                "Total_3GHG_timeseries": [
                    2.9243e-06,
                    5.8025e-06,
                    8.7026e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.0039
                ],
                "Fossil_3GHG": 0.3,
                "Fossil_3GHG_timeseries": [
                    8.8666e-07,
                    1.7879e-06,
                    2.7038e-06,
                    3.6342e-06,
                    4.5793e-06,
                    5.539e-06,
                    6.5133e-06,
                    7.5023e-06,
                    8.5059e-06,
                    9.524e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0031
                ],
                "Land_3GHG": 0.13,
                "Land_3GHG_timeseries": [
                    2.0376e-06,
                    4.0146e-06,
                    5.9989e-06,
                    7.9457e-06,
                    9.8806e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008
                ],
                "Total_CO2": 0.25,
                "Total_CO2_timeseries": [
                    1.6814e-06,
                    3.2972e-06,
                    4.9155e-06,
                    6.4914e-06,
                    8.0506e-06,
                    9.5364e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029
                ],
                "Fossil_CO2": 0.3,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    6.2528e-09,
                    6.2528e-09,
                    6.2528e-09,
                    6.2528e-09,
                    7.3469e-08,
                    1.5788e-07,
                    2.5792e-07,
                    3.8297e-07,
                    5.2835e-07,
                    7.3625e-07,
                    9.9573e-07,
                    1.2114e-06,
                    1.2114e-06,
                    1.424e-06,
                    1.6757e-06,
                    2.0024e-06,
                    2.3541e-06,
                    2.7136e-06,
                    3.1435e-06,
                    3.5953e-06,
                    4.3159e-06,
                    5.0896e-06,
                    5.8915e-06,
                    6.8154e-06,
                    7.8768e-06,
                    8.8772e-06,
                    9.937e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023
                ],
                "Land_CO2": 0.15,
                "Land_CO2_timeseries": [
                    1.6814e-06,
                    3.2972e-06,
                    4.9155e-06,
                    6.4914e-06,
                    8.0506e-06,
                    9.5364e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Total_CH4": 0.21,
                "Total_CH4_timeseries": [
                    1.162e-06,
                    2.3425e-06,
                    3.5415e-06,
                    4.7589e-06,
                    5.9948e-06,
                    7.2492e-06,
                    8.5222e-06,
                    9.8136e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009
                ],
                "Fossil_CH4": 0.28,
                "Fossil_CH4_timeseries": [
                    8.2485e-07,
                    1.6636e-06,
                    2.5163e-06,
                    3.3829e-06,
                    4.2635e-06,
                    5.1581e-06,
                    6.0667e-06,
                    6.9892e-06,
                    7.9259e-06,
                    8.8765e-06,
                    9.8416e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0,
                    0,
                    0,
                    0,
                    0,
                    9.7121e-06,
                    9.3403e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Land_CH4": 0.09,
                "Land_CH4_timeseries": [
                    3.3719e-07,
                    6.7891e-07,
                    1.0252e-06,
                    1.3759e-06,
                    1.7313e-06,
                    2.0911e-06,
                    2.4555e-06,
                    2.8244e-06,
                    3.1978e-06,
                    3.5758e-06,
                    3.9583e-06,
                    4.3453e-06,
                    4.7369e-06,
                    5.133e-06,
                    5.5336e-06,
                    5.9388e-06,
                    6.3485e-06,
                    6.7627e-06,
                    7.1814e-06,
                    7.6047e-06,
                    8.0253e-06,
                    8.4433e-06,
                    8.8587e-06,
                    9.2715e-06,
                    9.6816e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_N2O": 0.18,
                "Total_N2O_timeseries": [
                    8.0842e-08,
                    1.6274e-07,
                    2.4568e-07,
                    3.2963e-07,
                    4.1454e-07,
                    5.0037e-07,
                    5.8707e-07,
                    6.7457e-07,
                    7.628e-07,
                    8.5167e-07,
                    9.4114e-07,
                    1.0312e-06,
                    1.1218e-06,
                    1.213e-06,
                    1.3048e-06,
                    1.3971e-06,
                    1.49e-06,
                    1.5834e-06,
                    1.6775e-06,
                    1.7721e-06,
                    1.8678e-06,
                    1.9653e-06,
                    2.0651e-06,
                    2.1676e-06,
                    2.2732e-06,
                    2.3817e-06,
                    2.4932e-06,
                    2.6073e-06,
                    2.7235e-06,
                    2.8413e-06,
                    2.9602e-06,
                    3.0801e-06,
                    3.2009e-06,
                    3.3226e-06,
                    3.4452e-06,
                    3.5686e-06,
                    3.6928e-06,
                    3.8179e-06,
                    3.9439e-06,
                    4.0737e-06,
                    4.2053e-06,
                    4.3386e-06,
                    4.4737e-06,
                    4.6106e-06,
                    4.7494e-06,
                    4.8901e-06,
                    5.0328e-06,
                    5.1775e-06,
                    5.3243e-06,
                    5.4731e-06,
                    5.6241e-06,
                    5.7772e-06,
                    5.9327e-06,
                    6.0905e-06,
                    6.2507e-06,
                    6.4134e-06,
                    6.5785e-06,
                    6.7463e-06,
                    6.9166e-06,
                    7.0896e-06,
                    7.2654e-06,
                    7.4442e-06,
                    7.626e-06,
                    7.8111e-06,
                    7.9994e-06,
                    8.1911e-06,
                    8.3863e-06,
                    8.5848e-06,
                    8.7868e-06,
                    8.9921e-06,
                    9.2006e-06,
                    9.4125e-06,
                    9.6276e-06,
                    9.846e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002
                ],
                "Fossil_N2O": 0.28,
                "Fossil_N2O_timeseries": [
                    6.1812e-08,
                    1.243e-07,
                    1.8747e-07,
                    2.513e-07,
                    3.1578e-07,
                    3.8091e-07,
                    4.4667e-07,
                    5.1304e-07,
                    5.8e-07,
                    6.4753e-07,
                    7.1563e-07,
                    7.8428e-07,
                    8.5348e-07,
                    9.2323e-07,
                    9.9354e-07,
                    1.0644e-06,
                    1.1358e-06,
                    1.2078e-06,
                    1.2803e-06,
                    1.3534e-06,
                    1.4271e-06,
                    1.5017e-06,
                    1.5773e-06,
                    1.6541e-06,
                    1.732e-06,
                    1.8111e-06,
                    1.8914e-06,
                    1.9727e-06,
                    2.055e-06,
                    2.1381e-06,
                    2.2219e-06,
                    2.3064e-06,
                    2.3915e-06,
                    2.4772e-06,
                    2.5636e-06,
                    2.6506e-06,
                    2.7382e-06,
                    2.8264e-06,
                    2.9153e-06,
                    3.0052e-06,
                    3.0958e-06,
                    3.1872e-06,
                    3.2794e-06,
                    3.3723e-06,
                    3.4661e-06,
                    3.5606e-06,
                    3.656e-06,
                    3.7522e-06,
                    3.8492e-06,
                    3.9471e-06,
                    4.046e-06,
                    4.1457e-06,
                    4.2465e-06,
                    4.3484e-06,
                    4.4513e-06,
                    4.5552e-06,
                    4.6602e-06,
                    4.7663e-06,
                    4.8733e-06,
                    4.9813e-06,
                    5.0903e-06,
                    5.2001e-06,
                    5.3108e-06,
                    5.4225e-06,
                    5.535e-06,
                    5.6484e-06,
                    5.7627e-06,
                    5.8778e-06,
                    5.9938e-06,
                    6.1106e-06,
                    6.2282e-06,
                    6.3467e-06,
                    6.4659e-06,
                    6.586e-06,
                    6.7069e-06,
                    6.8286e-06,
                    6.9512e-06,
                    7.0745e-06,
                    7.1986e-06,
                    7.3236e-06,
                    7.4495e-06,
                    7.5769e-06,
                    7.7059e-06,
                    7.8369e-06,
                    7.9701e-06,
                    8.1055e-06,
                    8.2434e-06,
                    8.3837e-06,
                    8.5264e-06,
                    8.6714e-06,
                    8.8189e-06,
                    8.9695e-06,
                    9.1236e-06,
                    9.2816e-06,
                    9.4438e-06,
                    9.6104e-06,
                    9.7816e-06,
                    9.9575e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_N2O": 0.14,
                "Land_N2O_timeseries": [
                    1.9029e-08,
                    3.8439e-08,
                    5.8213e-08,
                    7.8329e-08,
                    9.8757e-08,
                    1.1946e-07,
                    1.4041e-07,
                    1.6154e-07,
                    1.828e-07,
                    2.0414e-07,
                    2.2552e-07,
                    2.4692e-07,
                    2.6834e-07,
                    2.8978e-07,
                    3.1123e-07,
                    3.3269e-07,
                    3.5417e-07,
                    3.7567e-07,
                    3.972e-07,
                    4.1877e-07,
                    4.407e-07,
                    4.6354e-07,
                    4.8772e-07,
                    5.1354e-07,
                    5.4115e-07,
                    5.7061e-07,
                    6.0182e-07,
                    6.3456e-07,
                    6.6851e-07,
                    7.0318e-07,
                    7.3827e-07,
                    7.737e-07,
                    8.0942e-07,
                    8.4539e-07,
                    8.8159e-07,
                    9.1799e-07,
                    9.5461e-07,
                    9.9145e-07,
                    1.0285e-06,
                    1.0685e-06,
                    1.1094e-06,
                    1.1513e-06,
                    1.1943e-06,
                    1.2382e-06,
                    1.2833e-06,
                    1.3295e-06,
                    1.3768e-06,
                    1.4253e-06,
                    1.475e-06,
                    1.526e-06,
                    1.5781e-06,
                    1.6315e-06,
                    1.6862e-06,
                    1.7421e-06,
                    1.7994e-06,
                    1.8581e-06,
                    1.9183e-06,
                    1.98e-06,
                    2.0433e-06,
                    2.1083e-06,
                    2.1752e-06,
                    2.2441e-06,
                    2.3152e-06,
                    2.3886e-06,
                    2.4644e-06,
                    2.5428e-06,
                    2.6236e-06,
                    2.707e-06,
                    2.793e-06,
                    2.8815e-06,
                    2.9724e-06,
                    3.0658e-06,
                    3.1617e-06,
                    3.26e-06,
                    3.3608e-06,
                    3.4642e-06,
                    3.5702e-06,
                    3.6792e-06,
                    3.7911e-06,
                    3.9061e-06,
                    4.0246e-06,
                    4.1467e-06,
                    4.2725e-06,
                    4.4023e-06,
                    4.5363e-06,
                    4.6747e-06,
                    4.8176e-06,
                    4.9653e-06,
                    5.118e-06,
                    5.2758e-06,
                    5.4411e-06,
                    5.6176e-06,
                    5.8085e-06,
                    6.0161e-06,
                    6.2419e-06,
                    6.4867e-06,
                    6.7504e-06,
                    7.0322e-06,
                    7.3306e-06,
                    7.6432e-06,
                    7.9687e-06,
                    8.3074e-06,
                    8.6595e-06,
                    9.0254e-06,
                    9.4051e-06,
                    9.7991e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            124.35829,
                            40.0
                        ],
                        [
                            124.36861,
                            39.95842
                        ],
                        [
                            124.31962,
                            39.90349
                        ],
                        [
                            124.39504,
                            39.85718
                        ],
                        [
                            124.53417,
                            39.80824
                        ],
                        [
                            124.64238,
                            39.67321
                        ],
                        [
                            124.64645,
                            39.60145
                        ],
                        [
                            124.75869,
                            39.67144
                        ],
                        [
                            124.76385,
                            39.73961
                        ],
                        [
                            124.88799,
                            39.69546
                        ],
                        [
                            124.91362,
                            39.64996
                        ],
                        [
                            125.0983,
                            39.61176
                        ],
                        [
                            125.1352,
                            39.56821
                        ],
                        [
                            125.21976,
                            39.57755
                        ],
                        [
                            125.28072,
                            39.52196
                        ],
                        [
                            125.36969,
                            39.55441
                        ],
                        [
                            125.39596,
                            39.49882
                        ],
                        [
                            125.34236,
                            39.45011
                        ],
                        [
                            125.41852,
                            39.31624
                        ],
                        [
                            125.39931,
                            39.25715
                        ],
                        [
                            125.30273,
                            39.16939
                        ],
                        [
                            125.29122,
                            39.10009
                        ],
                        [
                            125.21166,
                            38.99815
                        ],
                        [
                            125.15442,
                            38.8876
                        ],
                        [
                            125.13983,
                            38.81153
                        ],
                        [
                            125.28088,
                            38.69107
                        ],
                        [
                            125.45912,
                            38.73812
                        ],
                        [
                            125.47816,
                            38.69556
                        ],
                        [
                            125.32682,
                            38.66872
                        ],
                        [
                            125.17602,
                            38.65664
                        ],
                        [
                            125.1358,
                            38.57173
                        ],
                        [
                            125.00421,
                            38.57618
                        ],
                        [
                            125.00894,
                            38.48793
                        ],
                        [
                            124.94074,
                            38.43811
                        ],
                        [
                            124.86064,
                            38.33754
                        ],
                        [
                            124.86506,
                            38.23218
                        ],
                        [
                            124.79927,
                            38.17114
                        ],
                        [
                            124.66848,
                            38.11791
                        ],
                        [
                            124.78543,
                            38.09469
                        ],
                        [
                            124.89399,
                            38.12253
                        ],
                        [
                            125.00679,
                            38.06539
                        ],
                        [
                            125.12825,
                            38.09044
                        ],
                        [
                            125.06436,
                            37.97858
                        ],
                        [
                            124.99337,
                            37.9542
                        ],
                        [
                            125.01482,
                            37.90648
                        ],
                        [
                            125.12992,
                            37.86555
                        ],
                        [
                            125.23194,
                            37.90182
                        ],
                        [
                            125.29152,
                            37.89848
                        ],
                        [
                            125.30638,
                            37.82958
                        ],
                        [
                            125.40005,
                            37.80574
                        ],
                        [
                            125.37323,
                            37.72276
                        ],
                        [
                            125.46925,
                            37.72603
                        ],
                        [
                            125.52829,
                            37.76569
                        ],
                        [
                            125.60976,
                            37.76027
                        ],
                        [
                            125.63478,
                            37.85541
                        ],
                        [
                            125.70254,
                            37.95189
                        ],
                        [
                            125.63146,
                            37.96769
                        ],
                        [
                            125.58801,
                            38.03798
                        ],
                        [
                            125.74814,
                            38.01354
                        ],
                        [
                            125.79667,
                            37.95042
                        ],
                        [
                            125.95657,
                            37.82947
                        ],
                        [
                            126.06086,
                            37.85594
                        ],
                        [
                            126.09971,
                            37.75238
                        ],
                        [
                            126.16241,
                            37.74422
                        ],
                        [
                            126.15665,
                            37.83466
                        ],
                        [
                            126.26389,
                            37.84322
                        ],
                        [
                            126.39263,
                            37.8852
                        ],
                        [
                            126.4733,
                            37.81683
                        ],
                        [
                            126.59486,
                            37.77015
                        ],
                        [
                            126.66583,
                            37.83302
                        ],
                        [
                            126.70615,
                            37.95046
                        ],
                        [
                            126.82127,
                            38.00255
                        ],
                        [
                            126.88058,
                            38.0981
                        ],
                        [
                            126.97066,
                            38.14319
                        ],
                        [
                            126.96754,
                            38.18841
                        ],
                        [
                            127.04492,
                            38.25644
                        ],
                        [
                            127.24368,
                            38.32998
                        ],
                        [
                            127.30189,
                            38.31023
                        ],
                        [
                            127.38707,
                            38.33279
                        ],
                        [
                            127.50179,
                            38.29732
                        ],
                        [
                            127.58099,
                            38.33279
                        ],
                        [
                            127.74217,
                            38.33743
                        ],
                        [
                            127.82489,
                            38.3015
                        ],
                        [
                            127.88775,
                            38.32808
                        ],
                        [
                            128.0894,
                            38.31427
                        ],
                        [
                            128.21511,
                            38.36891
                        ],
                        [
                            128.28416,
                            38.43486
                        ],
                        [
                            128.31794,
                            38.59229
                        ],
                        [
                            128.36132,
                            38.61495
                        ],
                        [
                            128.35644,
                            38.67507
                        ],
                        [
                            128.25942,
                            38.7327
                        ],
                        [
                            128.21942,
                            38.7289
                        ],
                        [
                            128.06078,
                            38.84871
                        ],
                        [
                            128.00136,
                            38.856
                        ],
                        [
                            127.85487,
                            38.97727
                        ],
                        [
                            127.74437,
                            39.1251
                        ],
                        [
                            127.66927,
                            39.10198
                        ],
                        [
                            127.58313,
                            39.14438
                        ],
                        [
                            127.44712,
                            39.1562
                        ],
                        [
                            127.37858,
                            39.2034
                        ],
                        [
                            127.37413,
                            39.27974
                        ],
                        [
                            127.46082,
                            39.33009
                        ],
                        [
                            127.4485,
                            39.40803
                        ],
                        [
                            127.52,
                            39.44351
                        ],
                        [
                            127.51556,
                            39.50255
                        ],
                        [
                            127.57114,
                            39.58574
                        ],
                        [
                            127.50022,
                            39.63937
                        ],
                        [
                            127.49332,
                            39.70331
                        ],
                        [
                            127.57129,
                            39.7957
                        ],
                        [
                            127.7767,
                            39.85055
                        ],
                        [
                            127.87259,
                            39.89789
                        ],
                        [
                            127.89947,
                            39.97692
                        ],
                        [
                            127.9639,
                            40.00463
                        ],
                        [
                            128.32258,
                            40.00596
                        ],
                        [
                            128.36434,
                            40.09158
                        ],
                        [
                            128.44233,
                            40.10341
                        ],
                        [
                            128.66485,
                            40.2074
                        ],
                        [
                            128.62641,
                            40.29769
                        ],
                        [
                            128.80757,
                            40.3519
                        ],
                        [
                            128.95999,
                            40.44974
                        ],
                        [
                            129.1039,
                            40.49743
                        ],
                        [
                            129.1664,
                            40.56969
                        ],
                        [
                            129.22474,
                            40.6996
                        ],
                        [
                            129.30065,
                            40.67934
                        ],
                        [
                            129.34824,
                            40.73766
                        ],
                        [
                            129.51608,
                            40.79263
                        ],
                        [
                            129.57014,
                            40.83232
                        ],
                        [
                            129.71732,
                            40.83439
                        ],
                        [
                            129.7611,
                            40.93612
                        ],
                        [
                            129.72667,
                            40.9833
                        ],
                        [
                            129.72186,
                            41.18953
                        ],
                        [
                            129.80642,
                            41.37491
                        ],
                        [
                            129.67809,
                            41.44378
                        ],
                        [
                            129.65102,
                            41.54667
                        ],
                        [
                            129.6886,
                            41.63438
                        ],
                        [
                            129.74218,
                            41.68849
                        ],
                        [
                            129.76107,
                            41.75638
                        ],
                        [
                            129.86743,
                            41.79208
                        ],
                        [
                            129.89838,
                            41.90255
                        ],
                        [
                            129.95882,
                            41.9013
                        ],
                        [
                            129.98148,
                            41.9809
                        ],
                        [
                            130.0761,
                            42.0737
                        ],
                        [
                            130.19145,
                            42.09878
                        ],
                        [
                            130.20998,
                            42.15651
                        ],
                        [
                            130.28118,
                            42.21488
                        ],
                        [
                            130.33006,
                            42.19203
                        ],
                        [
                            130.4049,
                            42.32891
                        ],
                        [
                            130.50892,
                            42.33341
                        ],
                        [
                            130.63643,
                            42.26905
                        ],
                        [
                            130.67486,
                            42.28361
                        ],
                        [
                            130.63393,
                            42.41417
                        ],
                        [
                            130.57848,
                            42.43282
                        ],
                        [
                            130.51205,
                            42.61446
                        ],
                        [
                            130.38066,
                            42.60191
                        ],
                        [
                            130.25234,
                            42.71009
                        ],
                        [
                            130.22944,
                            42.78781
                        ],
                        [
                            130.25971,
                            42.90283
                        ],
                        [
                            130.1381,
                            42.9042
                        ],
                        [
                            130.117,
                            42.98634
                        ],
                        [
                            129.98525,
                            42.97203
                        ],
                        [
                            129.90745,
                            43.00618
                        ],
                        [
                            129.85218,
                            42.96041
                        ],
                        [
                            129.83709,
                            42.86747
                        ],
                        [
                            129.76072,
                            42.70906
                        ],
                        [
                            129.78023,
                            42.68792
                        ],
                        [
                            129.73767,
                            42.57422
                        ],
                        [
                            129.74197,
                            42.46856
                        ],
                        [
                            129.69478,
                            42.42703
                        ],
                        [
                            129.5935,
                            42.41264
                        ],
                        [
                            129.55123,
                            42.36517
                        ],
                        [
                            129.44634,
                            42.44024
                        ],
                        [
                            129.30867,
                            42.42089
                        ],
                        [
                            129.24902,
                            42.33627
                        ],
                        [
                            129.18666,
                            42.18991
                        ],
                        [
                            129.11148,
                            42.13964
                        ],
                        [
                            128.96031,
                            42.09047
                        ],
                        [
                            128.91455,
                            42.01064
                        ],
                        [
                            128.73132,
                            42.04726
                        ],
                        [
                            128.68452,
                            42.01333
                        ],
                        [
                            128.49042,
                            41.99849
                        ],
                        [
                            128.44146,
                            42.02856
                        ],
                        [
                            128.23959,
                            42.03066
                        ],
                        [
                            128.06783,
                            41.96053
                        ],
                        [
                            128.09814,
                            41.89555
                        ],
                        [
                            128.10593,
                            41.79269
                        ],
                        [
                            128.16284,
                            41.71282
                        ],
                        [
                            128.26215,
                            41.66387
                        ],
                        [
                            128.3107,
                            41.58662
                        ],
                        [
                            128.20279,
                            41.41053
                        ],
                        [
                            128.03433,
                            41.39123
                        ],
                        [
                            127.92627,
                            41.44305
                        ],
                        [
                            127.86764,
                            41.41486
                        ],
                        [
                            127.74054,
                            41.42386
                        ],
                        [
                            127.64793,
                            41.40373
                        ],
                        [
                            127.4956,
                            41.47466
                        ],
                        [
                            127.33725,
                            41.46313
                        ],
                        [
                            127.16221,
                            41.53851
                        ],
                        [
                            127.14261,
                            41.58267
                        ],
                        [
                            127.0348,
                            41.66896
                        ],
                        [
                            127.05084,
                            41.70413
                        ],
                        [
                            126.94178,
                            41.80542
                        ],
                        [
                            126.88328,
                            41.78897
                        ],
                        [
                            126.79622,
                            41.69696
                        ],
                        [
                            126.72427,
                            41.70735
                        ],
                        [
                            126.58862,
                            41.61797
                        ],
                        [
                            126.58487,
                            41.56625
                        ],
                        [
                            126.50269,
                            41.43236
                        ],
                        [
                            126.49261,
                            41.37158
                        ],
                        [
                            126.43321,
                            41.35115
                        ],
                        [
                            126.31591,
                            41.22592
                        ],
                        [
                            126.26821,
                            41.15303
                        ],
                        [
                            126.16499,
                            41.09244
                        ],
                        [
                            126.06372,
                            40.98946
                        ],
                        [
                            126.03173,
                            40.92688
                        ],
                        [
                            125.93273,
                            40.87729
                        ],
                        [
                            125.87125,
                            40.903
                        ],
                        [
                            125.71061,
                            40.86746
                        ],
                        [
                            125.64243,
                            40.8155
                        ],
                        [
                            125.67039,
                            40.76217
                        ],
                        [
                            125.54889,
                            40.75857
                        ],
                        [
                            125.44805,
                            40.6698
                        ],
                        [
                            125.32649,
                            40.63855
                        ],
                        [
                            125.27009,
                            40.64601
                        ],
                        [
                            125.00848,
                            40.52394
                        ],
                        [
                            125.03436,
                            40.48666
                        ],
                        [
                            124.76035,
                            40.38457
                        ],
                        [
                            124.71904,
                            40.32017
                        ],
                        [
                            124.61184,
                            40.28417
                        ],
                        [
                            124.52222,
                            40.22825
                        ],
                        [
                            124.34821,
                            40.07885
                        ],
                        [
                            124.35829,
                            40.0
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "MKD",
                "Country": "North Macedonia",
                "Total_3GHG": 0.03,
                "Total_3GHG_timeseries": [
                    6.0059e-07,
                    1.2008e-06,
                    1.7981e-06,
                    2.3933e-06,
                    2.9864e-06,
                    3.5778e-06,
                    4.1686e-06,
                    4.7585e-06,
                    5.3458e-06,
                    5.9834e-06,
                    6.644e-06,
                    7.318e-06,
                    8.0047e-06,
                    8.7028e-06,
                    9.4127e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Fossil_3GHG": 0.03,
                "Fossil_3GHG_timeseries": [
                    2.3085e-08,
                    4.6319e-08,
                    6.9703e-08,
                    9.3236e-08,
                    1.1691e-07,
                    1.4074e-07,
                    1.6471e-07,
                    1.8881e-07,
                    2.1306e-07,
                    2.3745e-07,
                    2.6249e-07,
                    2.8818e-07,
                    3.1453e-07,
                    3.4153e-07,
                    3.6918e-07,
                    3.9748e-07,
                    4.2643e-07,
                    4.5603e-07,
                    4.8628e-07,
                    5.1717e-07,
                    5.4881e-07,
                    5.8122e-07,
                    6.1441e-07,
                    6.4838e-07,
                    6.8315e-07,
                    7.1871e-07,
                    7.5507e-07,
                    7.9221e-07,
                    8.3011e-07,
                    8.6876e-07,
                    9.0775e-07,
                    9.4708e-07,
                    9.8674e-07,
                    1.0267e-06,
                    1.0685e-06,
                    1.1091e-06,
                    1.1501e-06,
                    1.1914e-06,
                    1.233e-06,
                    1.2792e-06,
                    1.3265e-06,
                    1.3747e-06,
                    1.4275e-06,
                    1.4896e-06,
                    1.552e-06,
                    1.6169e-06,
                    1.6775e-06,
                    1.7468e-06,
                    1.8205e-06,
                    1.9048e-06,
                    1.9905e-06,
                    2.0714e-06,
                    2.1535e-06,
                    2.2363e-06,
                    2.3205e-06,
                    2.4124e-06,
                    2.503e-06,
                    2.5958e-06,
                    2.6879e-06,
                    2.7761e-06,
                    2.8676e-06,
                    2.9587e-06,
                    3.1756e-06,
                    3.1862e-06,
                    3.1944e-06,
                    3.1998e-06,
                    3.2034e-06,
                    3.2031e-06,
                    3.3448e-06,
                    3.5297e-06,
                    3.732e-06,
                    4.1001e-06,
                    4.5043e-06,
                    4.9262e-06,
                    5.3925e-06,
                    5.8588e-06,
                    6.3834e-06,
                    6.9536e-06,
                    7.5966e-06,
                    8.2256e-06,
                    8.7981e-06,
                    9.3526e-06,
                    9.8657e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Land_3GHG": 0.02,
                "Land_3GHG_timeseries": [
                    5.775e-07,
                    1.1544e-06,
                    1.7284e-06,
                    2.3001e-06,
                    2.8695e-06,
                    3.437e-06,
                    4.0039e-06,
                    4.5696e-06,
                    5.1327e-06,
                    5.7459e-06,
                    6.3815e-06,
                    7.0298e-06,
                    7.6902e-06,
                    8.3612e-06,
                    9.0435e-06,
                    9.7381e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_CO2": 0.03,
                "Total_CO2_timeseries": [
                    4.2777e-07,
                    8.5389e-07,
                    1.276e-06,
                    1.6947e-06,
                    2.1101e-06,
                    2.5226e-06,
                    2.9335e-06,
                    3.3423e-06,
                    3.7475e-06,
                    4.202e-06,
                    4.6738e-06,
                    5.1534e-06,
                    5.6401e-06,
                    6.1324e-06,
                    6.631e-06,
                    7.1369e-06,
                    7.646e-06,
                    8.1583e-06,
                    8.6747e-06,
                    9.215e-06,
                    9.7665e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_CO2": 0.03,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.1645e-09,
                    1.1645e-09,
                    1.1645e-09,
                    1.1645e-09,
                    1.1645e-09,
                    4.6582e-09,
                    8.7341e-09,
                    1.3247e-08,
                    2.1253e-08,
                    3.6538e-08,
                    5.1822e-08,
                    6.8854e-08,
                    8.21e-08,
                    1.0219e-07,
                    1.2562e-07,
                    1.5736e-07,
                    1.92e-07,
                    2.2446e-07,
                    2.5969e-07,
                    2.9725e-07,
                    3.3801e-07,
                    3.8677e-07,
                    4.3641e-07,
                    4.8983e-07,
                    5.4471e-07,
                    5.9901e-07,
                    6.5782e-07,
                    7.1808e-07,
                    8.8359e-07,
                    8.8359e-07,
                    8.8359e-07,
                    8.8359e-07,
                    8.8359e-07,
                    8.8359e-07,
                    1.0022e-06,
                    1.1597e-06,
                    1.3274e-06,
                    1.5711e-06,
                    1.8369e-06,
                    2.1094e-06,
                    2.4085e-06,
                    2.6998e-06,
                    3.0289e-06,
                    3.3865e-06,
                    3.7942e-06,
                    4.1779e-06,
                    4.5145e-06,
                    4.8245e-06,
                    5.1106e-06,
                    5.4085e-06,
                    5.7186e-06,
                    6.0272e-06,
                    6.3728e-06,
                    6.6973e-06,
                    7.0395e-06,
                    7.4488e-06,
                    7.4488e-06,
                    7.4488e-06,
                    7.449e-06,
                    7.4527e-06,
                    7.6568e-06,
                    8.0534e-06,
                    8.5967e-06,
                    9.2133e-06,
                    9.9192e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_CO2": 0.02,
                "Land_CO2_timeseries": [
                    4.2777e-07,
                    8.5389e-07,
                    1.276e-06,
                    1.6947e-06,
                    2.1101e-06,
                    2.5226e-06,
                    2.9335e-06,
                    3.3423e-06,
                    3.7475e-06,
                    4.202e-06,
                    4.6738e-06,
                    5.1534e-06,
                    5.6401e-06,
                    6.1324e-06,
                    6.631e-06,
                    7.1369e-06,
                    7.646e-06,
                    8.1583e-06,
                    8.6747e-06,
                    9.215e-06,
                    9.7665e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_CH4": 0.02,
                "Total_CH4_timeseries": [
                    1.5327e-07,
                    3.0744e-07,
                    4.6251e-07,
                    6.1848e-07,
                    7.7536e-07,
                    9.3314e-07,
                    1.0918e-06,
                    1.2514e-06,
                    1.4119e-06,
                    1.5733e-06,
                    1.7402e-06,
                    1.9128e-06,
                    2.0909e-06,
                    2.2745e-06,
                    2.4638e-06,
                    2.6586e-06,
                    2.8589e-06,
                    3.0649e-06,
                    3.2764e-06,
                    3.4934e-06,
                    3.7169e-06,
                    3.9468e-06,
                    4.183e-06,
                    4.4257e-06,
                    4.6747e-06,
                    4.9301e-06,
                    5.1919e-06,
                    5.4601e-06,
                    5.7347e-06,
                    6.0156e-06,
                    6.2996e-06,
                    6.5865e-06,
                    6.8764e-06,
                    7.1692e-06,
                    7.4653e-06,
                    7.7642e-06,
                    8.0659e-06,
                    8.3707e-06,
                    8.6784e-06,
                    8.9899e-06,
                    9.3048e-06,
                    9.6231e-06,
                    9.9454e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_CH4": 0.02,
                "Fossil_CH4_timeseries": [
                    1.684e-08,
                    3.3761e-08,
                    5.0763e-08,
                    6.7845e-08,
                    8.5008e-08,
                    1.0225e-07,
                    1.1957e-07,
                    1.3697e-07,
                    1.5445e-07,
                    1.7201e-07,
                    1.9017e-07,
                    2.0893e-07,
                    2.2829e-07,
                    2.4824e-07,
                    2.6879e-07,
                    2.8993e-07,
                    3.1167e-07,
                    3.34e-07,
                    3.5693e-07,
                    3.8044e-07,
                    4.0464e-07,
                    4.2951e-07,
                    4.5505e-07,
                    4.8126e-07,
                    5.0815e-07,
                    5.3571e-07,
                    5.6393e-07,
                    5.9283e-07,
                    6.2239e-07,
                    6.5261e-07,
                    6.8311e-07,
                    7.1387e-07,
                    7.4491e-07,
                    7.762e-07,
                    8.0802e-07,
                    8.3985e-07,
                    8.7194e-07,
                    9.0429e-07,
                    9.369e-07,
                    9.7054e-07,
                    1.0046e-06,
                    1.039e-06,
                    1.0745e-06,
                    1.1118e-06,
                    1.1495e-06,
                    1.1878e-06,
                    1.2255e-06,
                    1.265e-06,
                    1.3055e-06,
                    1.3481e-06,
                    1.3892e-06,
                    1.4276e-06,
                    1.4643e-06,
                    1.4992e-06,
                    1.5322e-06,
                    1.5649e-06,
                    1.5952e-06,
                    1.6239e-06,
                    1.6504e-06,
                    1.6734e-06,
                    1.6951e-06,
                    1.7148e-06,
                    1.7551e-06,
                    1.7544e-06,
                    1.7512e-06,
                    1.7452e-06,
                    1.7373e-06,
                    1.7254e-06,
                    1.7367e-06,
                    1.7523e-06,
                    1.7751e-06,
                    1.8875e-06,
                    2.0138e-06,
                    2.151e-06,
                    2.3059e-06,
                    2.4685e-06,
                    2.6515e-06,
                    2.8516e-06,
                    3.0741e-06,
                    3.3066e-06,
                    3.5297e-06,
                    3.7612e-06,
                    3.975e-06,
                    4.2367e-06,
                    4.5116e-06,
                    4.801e-06,
                    5.1094e-06,
                    5.4123e-06,
                    5.7062e-06,
                    6.0191e-06,
                    6.2463e-06,
                    6.4042e-06,
                    6.5634e-06,
                    6.7298e-06,
                    6.9337e-06,
                    7.1828e-06,
                    7.4574e-06,
                    7.7426e-06,
                    8.0394e-06,
                    8.3593e-06,
                    8.6937e-06,
                    9.0256e-06,
                    9.3765e-06,
                    9.7587e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CH4": 0.03,
                "Land_CH4_timeseries": [
                    1.3643e-07,
                    2.7368e-07,
                    4.1175e-07,
                    5.5064e-07,
                    6.9035e-07,
                    8.3089e-07,
                    9.7225e-07,
                    1.1144e-06,
                    1.2574e-06,
                    1.4013e-06,
                    1.5501e-06,
                    1.7038e-06,
                    1.8626e-06,
                    2.0263e-06,
                    2.195e-06,
                    2.3686e-06,
                    2.5473e-06,
                    2.7309e-06,
                    2.9194e-06,
                    3.113e-06,
                    3.3123e-06,
                    3.5173e-06,
                    3.728e-06,
                    3.9444e-06,
                    4.1665e-06,
                    4.3944e-06,
                    4.628e-06,
                    4.8673e-06,
                    5.1123e-06,
                    5.363e-06,
                    5.6164e-06,
                    5.8726e-06,
                    6.1315e-06,
                    6.393e-06,
                    6.6573e-06,
                    6.9243e-06,
                    7.194e-06,
                    7.4664e-06,
                    7.7415e-06,
                    8.0194e-06,
                    8.3002e-06,
                    8.5841e-06,
                    8.8709e-06,
                    9.1608e-06,
                    9.4536e-06,
                    9.7495e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_N2O": 0.04,
                "Total_N2O_timeseries": [
                    1.9546e-08,
                    3.9428e-08,
                    5.9633e-08,
                    8.0144e-08,
                    1.0094e-07,
                    1.22e-07,
                    1.4328e-07,
                    1.6476e-07,
                    1.8639e-07,
                    2.0813e-07,
                    2.2995e-07,
                    2.5185e-07,
                    2.7381e-07,
                    2.9585e-07,
                    3.1794e-07,
                    3.401e-07,
                    3.6233e-07,
                    3.8463e-07,
                    4.07e-07,
                    4.2945e-07,
                    4.5223e-07,
                    4.7574e-07,
                    5.0028e-07,
                    5.2609e-07,
                    5.5327e-07,
                    5.8187e-07,
                    6.1182e-07,
                    6.4295e-07,
                    6.7502e-07,
                    7.0768e-07,
                    7.407e-07,
                    7.7403e-07,
                    8.0763e-07,
                    8.4147e-07,
                    8.7553e-07,
                    9.0979e-07,
                    9.4427e-07,
                    9.7897e-07,
                    1.0139e-06,
                    1.0518e-06,
                    1.0879e-06,
                    1.1224e-06,
                    1.1552e-06,
                    1.1866e-06,
                    1.2166e-06,
                    1.2456e-06,
                    1.2737e-06,
                    1.3011e-06,
                    1.3281e-06,
                    1.3551e-06,
                    1.3822e-06,
                    1.4095e-06,
                    1.437e-06,
                    1.4647e-06,
                    1.4929e-06,
                    1.5213e-06,
                    1.5502e-06,
                    1.5796e-06,
                    1.6095e-06,
                    1.6398e-06,
                    1.6713e-06,
                    1.7048e-06,
                    1.7412e-06,
                    1.7812e-06,
                    1.8254e-06,
                    1.8742e-06,
                    1.9279e-06,
                    1.9866e-06,
                    2.0503e-06,
                    2.1191e-06,
                    2.1936e-06,
                    2.2753e-06,
                    2.3654e-06,
                    2.4643e-06,
                    2.5721e-06,
                    2.6882e-06,
                    2.8117e-06,
                    2.9411e-06,
                    3.0745e-06,
                    3.2093e-06,
                    3.3427e-06,
                    3.4716e-06,
                    3.5941e-06,
                    3.7088e-06,
                    3.8148e-06,
                    3.9123e-06,
                    4.0019e-06,
                    4.0851e-06,
                    4.1639e-06,
                    4.2413e-06,
                    4.3235e-06,
                    4.4189e-06,
                    4.5338e-06,
                    4.6725e-06,
                    4.8376e-06,
                    5.0295e-06,
                    5.2468e-06,
                    5.4861e-06,
                    5.7421e-06,
                    6.0075e-06,
                    6.2779e-06,
                    6.5525e-06,
                    6.8311e-06,
                    7.1132e-06,
                    7.3985e-06,
                    7.687e-06,
                    7.9784e-06,
                    8.2728e-06,
                    8.5703e-06,
                    8.871e-06,
                    9.198e-06,
                    9.5378e-06,
                    9.8677e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_N2O": 0.02,
                "Fossil_N2O_timeseries": [
                    6.2446e-09,
                    1.2558e-08,
                    1.894e-08,
                    2.539e-08,
                    3.1907e-08,
                    3.8488e-08,
                    4.5134e-08,
                    5.1841e-08,
                    5.8608e-08,
                    6.5432e-08,
                    7.2312e-08,
                    7.9248e-08,
                    8.624e-08,
                    9.3287e-08,
                    1.0039e-07,
                    1.0755e-07,
                    1.1476e-07,
                    1.2203e-07,
                    1.2935e-07,
                    1.3673e-07,
                    1.4418e-07,
                    1.5171e-07,
                    1.5936e-07,
                    1.6712e-07,
                    1.75e-07,
                    1.8301e-07,
                    1.9114e-07,
                    1.9938e-07,
                    2.0772e-07,
                    2.1615e-07,
                    2.2464e-07,
                    2.332e-07,
                    2.4183e-07,
                    2.5053e-07,
                    2.5928e-07,
                    2.681e-07,
                    2.7698e-07,
                    2.8593e-07,
                    2.9493e-07,
                    3.0404e-07,
                    3.1322e-07,
                    3.2247e-07,
                    3.318e-07,
                    3.4121e-07,
                    3.5069e-07,
                    3.6026e-07,
                    3.699e-07,
                    3.7963e-07,
                    3.8944e-07,
                    3.9933e-07,
                    4.0931e-07,
                    4.1939e-07,
                    4.2957e-07,
                    4.3986e-07,
                    4.5024e-07,
                    4.6074e-07,
                    4.7134e-07,
                    4.8204e-07,
                    4.9284e-07,
                    5.0374e-07,
                    5.1472e-07,
                    5.258e-07,
                    5.3697e-07,
                    5.4823e-07,
                    5.5957e-07,
                    5.71e-07,
                    5.8253e-07,
                    5.9414e-07,
                    6.0584e-07,
                    6.1763e-07,
                    6.2952e-07,
                    6.415e-07,
                    6.5359e-07,
                    6.6578e-07,
                    6.7807e-07,
                    6.9047e-07,
                    7.0297e-07,
                    7.1557e-07,
                    7.2827e-07,
                    7.4106e-07,
                    7.5396e-07,
                    7.6694e-07,
                    7.8001e-07,
                    7.9318e-07,
                    8.0645e-07,
                    8.1981e-07,
                    8.3328e-07,
                    8.4686e-07,
                    8.6056e-07,
                    8.7439e-07,
                    8.884e-07,
                    9.0269e-07,
                    9.1733e-07,
                    9.3238e-07,
                    9.4789e-07,
                    9.6387e-07,
                    9.8032e-07,
                    9.9723e-07,
                    1.0146e-06,
                    1.0323e-06,
                    1.0503e-06,
                    1.0687e-06,
                    1.0874e-06,
                    1.1065e-06,
                    1.126e-06,
                    1.1459e-06,
                    1.1662e-06,
                    1.187e-06,
                    1.2082e-06,
                    1.23e-06,
                    1.2524e-06,
                    1.2753e-06,
                    1.2989e-06,
                    1.3233e-06,
                    1.3484e-06,
                    1.3745e-06,
                    1.4017e-06,
                    1.4301e-06,
                    1.4598e-06,
                    1.4922e-06,
                    1.5246e-06,
                    1.556e-06,
                    1.5892e-06,
                    1.6244e-06,
                    1.6601e-06,
                    1.6963e-06,
                    1.7338e-06,
                    1.773e-06,
                    1.8129e-06,
                    1.8524e-06,
                    1.8973e-06,
                    1.942e-06,
                    1.9881e-06,
                    2.036e-06,
                    2.0863e-06,
                    2.14e-06,
                    2.1901e-06,
                    2.2399e-06,
                    2.2907e-06,
                    2.3543e-06,
                    2.4122e-06,
                    2.4687e-06,
                    2.5364e-06,
                    2.5934e-06,
                    2.6626e-06,
                    2.7349e-06,
                    2.805e-06,
                    2.8647e-06,
                    2.9233e-06,
                    2.979e-06,
                    3.0319e-06,
                    3.0832e-06,
                    3.1371e-06,
                    3.1902e-06,
                    3.2426e-06,
                    3.2955e-06,
                    3.3508e-06,
                    3.4055e-06,
                    3.4582e-06,
                    3.5111e-06,
                    3.5679e-06,
                    3.624e-06,
                    3.6783e-06,
                    3.732e-06,
                    3.7853e-06,
                    3.8384e-06,
                    3.8934e-06,
                    3.9458e-06,
                    4.0011e-06,
                    4.0531e-06,
                    4.108e-06,
                    4.1624e-06
                ],
                "Land_N2O": 0.04,
                "Land_N2O_timeseries": [
                    1.3302e-08,
                    2.687e-08,
                    4.0692e-08,
                    5.4753e-08,
                    6.9033e-08,
                    8.3507e-08,
                    9.8146e-08,
                    1.1292e-07,
                    1.2778e-07,
                    1.427e-07,
                    1.5764e-07,
                    1.726e-07,
                    1.8757e-07,
                    2.0256e-07,
                    2.1755e-07,
                    2.3256e-07,
                    2.4757e-07,
                    2.626e-07,
                    2.7765e-07,
                    2.9272e-07,
                    3.0805e-07,
                    3.2402e-07,
                    3.4093e-07,
                    3.5897e-07,
                    3.7827e-07,
                    3.9886e-07,
                    4.2068e-07,
                    4.4357e-07,
                    4.673e-07,
                    4.9154e-07,
                    5.1606e-07,
                    5.4083e-07,
                    5.658e-07,
                    5.9094e-07,
                    6.1624e-07,
                    6.4169e-07,
                    6.6729e-07,
                    6.9304e-07,
                    7.1897e-07,
                    7.4777e-07,
                    7.7471e-07,
                    7.9989e-07,
                    8.2339e-07,
                    8.4536e-07,
                    8.6595e-07,
                    8.8535e-07,
                    9.0378e-07,
                    9.2147e-07,
                    9.3871e-07,
                    9.5579e-07,
                    9.729e-07,
                    9.9008e-07,
                    1.0074e-06,
                    1.0249e-06,
                    1.0426e-06,
                    1.0606e-06,
                    1.0789e-06,
                    1.0976e-06,
                    1.1166e-06,
                    1.1361e-06,
                    1.1566e-06,
                    1.179e-06,
                    1.2043e-06,
                    1.233e-06,
                    1.2659e-06,
                    1.3032e-06,
                    1.3453e-06,
                    1.3924e-06,
                    1.4445e-06,
                    1.5014e-06,
                    1.564e-06,
                    1.6338e-06,
                    1.7118e-06,
                    1.7985e-06,
                    1.894e-06,
                    1.9977e-06,
                    2.1087e-06,
                    2.2255e-06,
                    2.3462e-06,
                    2.4683e-06,
                    2.5887e-06,
                    2.7047e-06,
                    2.8141e-06,
                    2.9156e-06,
                    3.0084e-06,
                    3.0925e-06,
                    3.1686e-06,
                    3.2382e-06,
                    3.3034e-06,
                    3.3669e-06,
                    3.4351e-06,
                    3.5162e-06,
                    3.6165e-06,
                    3.7402e-06,
                    3.8897e-06,
                    4.0656e-06,
                    4.2665e-06,
                    4.4888e-06,
                    4.7275e-06,
                    4.9752e-06,
                    5.2275e-06,
                    5.4838e-06,
                    5.7437e-06,
                    6.0066e-06,
                    6.2725e-06,
                    6.5411e-06,
                    6.8122e-06,
                    7.0858e-06,
                    7.362e-06,
                    7.641e-06,
                    7.9456e-06,
                    8.2624e-06,
                    8.5687e-06,
                    8.8765e-06,
                    9.185e-06,
                    9.5151e-06,
                    9.8548e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            22.36021,
                            42.31116
                        ],
                        [
                            22.28805,
                            42.37188
                        ],
                        [
                            22.22883,
                            42.33549
                        ],
                        [
                            22.03136,
                            42.29872
                        ],
                        [
                            21.94691,
                            42.34364
                        ],
                        [
                            21.84996,
                            42.32553
                        ],
                        [
                            21.69796,
                            42.23282
                        ],
                        [
                            21.44504,
                            42.27698
                        ],
                        [
                            21.31939,
                            42.173
                        ],
                        [
                            21.29621,
                            42.11076
                        ],
                        [
                            21.22311,
                            42.09556
                        ],
                        [
                            21.16184,
                            42.19646
                        ],
                        [
                            21.09927,
                            42.20343
                        ],
                        [
                            21.02644,
                            42.15225
                        ],
                        [
                            20.9447,
                            42.13754
                        ],
                        [
                            20.75996,
                            42.05347
                        ],
                        [
                            20.7489,
                            41.98449
                        ],
                        [
                            20.77652,
                            41.91849
                        ],
                        [
                            20.72797,
                            41.86428
                        ],
                        [
                            20.59429,
                            41.87733
                        ],
                        [
                            20.57239,
                            41.78788
                        ],
                        [
                            20.51446,
                            41.72184
                        ],
                        [
                            20.55777,
                            41.58187
                        ],
                        [
                            20.45628,
                            41.55402
                        ],
                        [
                            20.51399,
                            41.43809
                        ],
                        [
                            20.56003,
                            41.40367
                        ],
                        [
                            20.51657,
                            41.33753
                        ],
                        [
                            20.5164,
                            41.23053
                        ],
                        [
                            20.59676,
                            41.12984
                        ],
                        [
                            20.67063,
                            41.08735
                        ],
                        [
                            20.73227,
                            40.91173
                        ],
                        [
                            20.80197,
                            40.89825
                        ],
                        [
                            20.84752,
                            40.93705
                        ],
                        [
                            20.93896,
                            40.92408
                        ],
                        [
                            20.9802,
                            40.85566
                        ],
                        [
                            21.25947,
                            40.8595
                        ],
                        [
                            21.36295,
                            40.8796
                        ],
                        [
                            21.41725,
                            40.9177
                        ],
                        [
                            21.53137,
                            40.90751
                        ],
                        [
                            21.56701,
                            40.86698
                        ],
                        [
                            21.68449,
                            40.94028
                        ],
                        [
                            21.75645,
                            40.92566
                        ],
                        [
                            21.79982,
                            40.97543
                        ],
                        [
                            21.91178,
                            41.04942
                        ],
                        [
                            21.9089,
                            41.09085
                        ],
                        [
                            22.07839,
                            41.15301
                        ],
                        [
                            22.12906,
                            41.12335
                        ],
                        [
                            22.21622,
                            41.17046
                        ],
                        [
                            22.3265,
                            41.12337
                        ],
                        [
                            22.46525,
                            41.11743
                        ],
                        [
                            22.61767,
                            41.13392
                        ],
                        [
                            22.66647,
                            41.18634
                        ],
                        [
                            22.74686,
                            41.16298
                        ],
                        [
                            22.76867,
                            41.32523
                        ],
                        [
                            22.92759,
                            41.33854
                        ],
                        [
                            22.97257,
                            41.56086
                        ],
                        [
                            22.94931,
                            41.59866
                        ],
                        [
                            23.03412,
                            41.70944
                        ],
                        [
                            22.96867,
                            41.77099
                        ],
                        [
                            22.87345,
                            41.9361
                        ],
                        [
                            22.86721,
                            42.0222
                        ],
                        [
                            22.67777,
                            42.06437
                        ],
                        [
                            22.5288,
                            42.13993
                        ],
                        [
                            22.50086,
                            42.19621
                        ],
                        [
                            22.36021,
                            42.31116
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "NOR",
                "Country": "Norway",
                "Total_3GHG": 0.17,
                "Total_3GHG_timeseries": [
                    4.0569e-06,
                    8.0977e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028
                ],
                "Fossil_3GHG": 0.21,
                "Fossil_3GHG_timeseries": [
                    2.0857e-07,
                    4.1967e-07,
                    6.4061e-07,
                    9.014e-07,
                    1.1763e-06,
                    1.4801e-06,
                    1.7862e-06,
                    2.0739e-06,
                    2.3985e-06,
                    2.7309e-06,
                    3.1149e-06,
                    3.4662e-06,
                    3.816e-06,
                    4.2306e-06,
                    4.641e-06,
                    5.0776e-06,
                    5.5664e-06,
                    6.059e-06,
                    6.5081e-06,
                    6.9938e-06,
                    7.4663e-06,
                    7.9607e-06,
                    8.4544e-06,
                    9.0269e-06,
                    9.7096e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023
                ],
                "Land_3GHG": 0.1,
                "Land_3GHG_timeseries": [
                    3.8483e-06,
                    7.6781e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006
                ],
                "Total_CO2": 0.14,
                "Total_CO2_timeseries": [
                    3.1727e-06,
                    6.3154e-06,
                    9.4565e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016
                ],
                "Fossil_CO2": 0.16,
                "Fossil_CO2_timeseries": [
                    6.765e-08,
                    1.353e-07,
                    2.0955e-07,
                    3.1515e-07,
                    4.3065e-07,
                    5.676e-07,
                    7.0455e-07,
                    8.25e-07,
                    9.7185e-07,
                    1.122e-06,
                    1.3151e-06,
                    1.4817e-06,
                    1.6451e-06,
                    1.8612e-06,
                    2.0741e-06,
                    2.3084e-06,
                    2.5872e-06,
                    2.8726e-06,
                    3.1218e-06,
                    3.4056e-06,
                    3.6811e-06,
                    3.9765e-06,
                    4.2735e-06,
                    4.6415e-06,
                    5.1035e-06,
                    5.511e-06,
                    6.0604e-06,
                    6.5505e-06,
                    7.0653e-06,
                    7.628e-06,
                    8.2104e-06,
                    8.8473e-06,
                    9.5337e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012
                ],
                "Land_CO2": 0.09,
                "Land_CO2_timeseries": [
                    3.1051e-06,
                    6.1801e-06,
                    9.2469e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Total_CH4": 0.25,
                "Total_CH4_timeseries": [
                    7.5732e-07,
                    1.5265e-06,
                    2.3081e-06,
                    3.1076e-06,
                    3.9206e-06,
                    4.7504e-06,
                    5.5918e-06,
                    6.4405e-06,
                    7.3093e-06,
                    8.1919e-06,
                    9.0826e-06,
                    9.9666e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001
                ],
                "Fossil_CH4": 0.35,
                "Fossil_CH4_timeseries": [
                    9.8076e-08,
                    1.982e-07,
                    3.0108e-07,
                    4.1199e-07,
                    5.2668e-07,
                    6.483e-07,
                    7.7183e-07,
                    8.9296e-07,
                    1.0242e-06,
                    1.1597e-06,
                    1.3033e-06,
                    1.4404e-06,
                    1.5789e-06,
                    1.729e-06,
                    1.8778e-06,
                    2.031e-06,
                    2.1916e-06,
                    2.3489e-06,
                    2.4987e-06,
                    2.65e-06,
                    2.7959e-06,
                    2.9433e-06,
                    3.0874e-06,
                    3.2386e-06,
                    3.4049e-06,
                    3.5563e-06,
                    3.7343e-06,
                    3.904e-06,
                    4.0714e-06,
                    4.2441e-06,
                    4.4076e-06,
                    4.5816e-06,
                    4.7597e-06,
                    4.9269e-06,
                    5.1118e-06,
                    5.287e-06,
                    5.4484e-06,
                    5.6299e-06,
                    5.8415e-06,
                    6.0349e-06,
                    6.2594e-06,
                    6.4828e-06,
                    6.7048e-06,
                    6.951e-06,
                    7.1944e-06,
                    7.4517e-06,
                    7.7066e-06,
                    7.9731e-06,
                    8.2937e-06,
                    8.6169e-06,
                    8.9163e-06,
                    9.2415e-06,
                    9.5568e-06,
                    9.8642e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009
                ],
                "Land_CH4": 0.07,
                "Land_CH4_timeseries": [
                    6.5924e-07,
                    1.3283e-06,
                    2.007e-06,
                    2.6956e-06,
                    3.3939e-06,
                    4.1021e-06,
                    4.8199e-06,
                    5.5476e-06,
                    6.285e-06,
                    7.0322e-06,
                    7.7792e-06,
                    8.5261e-06,
                    9.2729e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_N2O": 0.27,
                "Total_N2O_timeseries": [
                    1.2685e-07,
                    2.5586e-07,
                    3.8695e-07,
                    5.2003e-07,
                    6.5496e-07,
                    7.9156e-07,
                    9.2964e-07,
                    1.069e-06,
                    1.2093e-06,
                    1.3504e-06,
                    1.492e-06,
                    1.6341e-06,
                    1.7766e-06,
                    1.9196e-06,
                    2.063e-06,
                    2.2068e-06,
                    2.3511e-06,
                    2.4958e-06,
                    2.641e-06,
                    2.7868e-06,
                    2.9347e-06,
                    3.0872e-06,
                    3.2464e-06,
                    3.4138e-06,
                    3.59e-06,
                    3.7753e-06,
                    3.9693e-06,
                    4.1709e-06,
                    4.3785e-06,
                    4.59e-06,
                    4.8037e-06,
                    5.0195e-06,
                    5.237e-06,
                    5.4561e-06,
                    5.6765e-06,
                    5.8984e-06,
                    6.1216e-06,
                    6.3462e-06,
                    6.5724e-06,
                    6.7806e-06,
                    7.0097e-06,
                    7.2584e-06,
                    7.5254e-06,
                    7.8088e-06,
                    8.107e-06,
                    8.4178e-06,
                    8.7389e-06,
                    9.0681e-06,
                    9.4025e-06,
                    9.7393e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_N2O": 0.51,
                "Fossil_N2O_timeseries": [
                    4.2843e-08,
                    8.6172e-08,
                    1.2998e-07,
                    1.7426e-07,
                    2.1901e-07,
                    2.6421e-07,
                    3.0985e-07,
                    3.5591e-07,
                    4.0238e-07,
                    4.4923e-07,
                    4.9647e-07,
                    5.4407e-07,
                    5.9205e-07,
                    6.4039e-07,
                    6.8911e-07,
                    7.3819e-07,
                    7.8764e-07,
                    8.3746e-07,
                    8.8765e-07,
                    9.3822e-07,
                    9.8927e-07,
                    1.041e-06,
                    1.0935e-06,
                    1.1469e-06,
                    1.2012e-06,
                    1.2565e-06,
                    1.3126e-06,
                    1.3697e-06,
                    1.4275e-06,
                    1.4859e-06,
                    1.5448e-06,
                    1.6041e-06,
                    1.664e-06,
                    1.7242e-06,
                    1.7849e-06,
                    1.8461e-06,
                    1.9076e-06,
                    1.9696e-06,
                    2.0321e-06,
                    2.0961e-06,
                    2.1608e-06,
                    2.2262e-06,
                    2.2924e-06,
                    2.3594e-06,
                    2.4273e-06,
                    2.496e-06,
                    2.5655e-06,
                    2.636e-06,
                    2.7073e-06,
                    2.7796e-06,
                    2.8529e-06,
                    2.9273e-06,
                    3.0029e-06,
                    3.0796e-06,
                    3.1576e-06,
                    3.2368e-06,
                    3.3172e-06,
                    3.3987e-06,
                    3.4813e-06,
                    3.5649e-06,
                    3.6493e-06,
                    3.7345e-06,
                    3.8204e-06,
                    3.9072e-06,
                    3.9946e-06,
                    4.0828e-06,
                    4.1717e-06,
                    4.2614e-06,
                    4.3518e-06,
                    4.4431e-06,
                    4.5354e-06,
                    4.6286e-06,
                    4.723e-06,
                    4.8186e-06,
                    4.9153e-06,
                    5.0131e-06,
                    5.112e-06,
                    5.2119e-06,
                    5.3126e-06,
                    5.4141e-06,
                    5.5197e-06,
                    5.6361e-06,
                    5.7686e-06,
                    5.9213e-06,
                    6.0974e-06,
                    6.2987e-06,
                    6.526e-06,
                    6.7789e-06,
                    7.0559e-06,
                    7.3543e-06,
                    7.6713e-06,
                    8.0052e-06,
                    8.355e-06,
                    8.7207e-06,
                    9.1027e-06,
                    9.5025e-06,
                    9.9222e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_N2O": 0.17,
                "Land_N2O_timeseries": [
                    8.4002e-08,
                    1.6968e-07,
                    2.5697e-07,
                    3.4577e-07,
                    4.3595e-07,
                    5.2735e-07,
                    6.1979e-07,
                    7.1307e-07,
                    8.0694e-07,
                    9.0114e-07,
                    9.955e-07,
                    1.09e-06,
                    1.1845e-06,
                    1.2792e-06,
                    1.3739e-06,
                    1.4686e-06,
                    1.5634e-06,
                    1.6583e-06,
                    1.7534e-06,
                    1.8486e-06,
                    1.9454e-06,
                    2.0462e-06,
                    2.153e-06,
                    2.2669e-06,
                    2.3888e-06,
                    2.5188e-06,
                    2.6566e-06,
                    2.8012e-06,
                    2.951e-06,
                    3.1041e-06,
                    3.259e-06,
                    3.4154e-06,
                    3.573e-06,
                    3.7318e-06,
                    3.8916e-06,
                    4.0523e-06,
                    4.214e-06,
                    4.3766e-06,
                    4.5404e-06,
                    4.6846e-06,
                    4.849e-06,
                    5.0322e-06,
                    5.2329e-06,
                    5.4494e-06,
                    5.6797e-06,
                    5.9218e-06,
                    6.1734e-06,
                    6.4321e-06,
                    6.6951e-06,
                    6.9597e-06,
                    7.2227e-06,
                    7.4816e-06,
                    7.7345e-06,
                    7.9801e-06,
                    8.2176e-06,
                    8.4472e-06,
                    8.6695e-06,
                    8.8857e-06,
                    9.0978e-06,
                    9.3083e-06,
                    9.5191e-06,
                    9.7303e-06,
                    9.9422e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                18.48916,
                                77.9761
                            ],
                            [
                                18.53721,
                                78.04126
                            ],
                            [
                                18.96959,
                                78.04904
                            ],
                            [
                                19.11219,
                                78.20095
                            ],
                            [
                                18.96451,
                                78.28673
                            ],
                            [
                                19.03819,
                                78.33355
                            ],
                            [
                                18.97487,
                                78.44642
                            ],
                            [
                                19.41073,
                                78.48659
                            ],
                            [
                                19.7835,
                                78.48455
                            ],
                            [
                                19.80966,
                                78.59757
                            ],
                            [
                                20.19492,
                                78.63603
                            ],
                            [
                                20.61876,
                                78.63858
                            ],
                            [
                                20.75708,
                                78.70085
                            ],
                            [
                                21.07898,
                                78.64328
                            ],
                            [
                                21.37975,
                                78.66734
                            ],
                            [
                                21.56983,
                                78.74434
                            ],
                            [
                                21.59149,
                                78.81171
                            ],
                            [
                                21.322,
                                78.85983
                            ],
                            [
                                20.95867,
                                78.86224
                            ],
                            [
                                20.30179,
                                78.98977
                            ],
                            [
                                20.00824,
                                78.99698
                            ],
                            [
                                19.95047,
                                79.05413
                            ],
                            [
                                19.63598,
                                79.15089
                            ],
                            [
                                19.40499,
                                79.18322
                            ],
                            [
                                19.13568,
                                79.14902
                            ],
                            [
                                18.93739,
                                79.21932
                            ],
                            [
                                18.60918,
                                79.25732
                            ],
                            [
                                18.80958,
                                79.29306
                            ],
                            [
                                18.8642,
                                79.4412
                            ],
                            [
                                18.66388,
                                79.56171
                            ],
                            [
                                18.26118,
                                79.62909
                            ],
                            [
                                18.09414,
                                79.59643
                            ],
                            [
                                18.02639,
                                79.48741
                            ],
                            [
                                17.78348,
                                79.46692
                            ],
                            [
                                17.70238,
                                79.60722
                            ],
                            [
                                18.05724,
                                79.71347
                            ],
                            [
                                17.56878,
                                79.88962
                            ],
                            [
                                17.01948,
                                79.95762
                            ],
                            [
                                16.84599,
                                79.91782
                            ],
                            [
                                16.55298,
                                80.00002
                            ],
                            [
                                16.56061,
                                80.03956
                            ],
                            [
                                16.14619,
                                80.05722
                            ],
                            [
                                15.92188,
                                79.93347
                            ],
                            [
                                16.06207,
                                79.8631
                            ],
                            [
                                15.64768,
                                79.86322
                            ],
                            [
                                15.66003,
                                79.69317
                            ],
                            [
                                15.77495,
                                79.63488
                            ],
                            [
                                15.94716,
                                79.30059
                            ],
                            [
                                16.12341,
                                79.22227
                            ],
                            [
                                16.37008,
                                78.97864
                            ],
                            [
                                16.17259,
                                78.97106
                            ],
                            [
                                15.75253,
                                79.23656
                            ],
                            [
                                15.41675,
                                79.36651
                            ],
                            [
                                15.39626,
                                79.47203
                            ],
                            [
                                15.21457,
                                79.52673
                            ],
                            [
                                15.16376,
                                79.62279
                            ],
                            [
                                14.82745,
                                79.76737
                            ],
                            [
                                14.48534,
                                79.79437
                            ],
                            [
                                13.87392,
                                79.54685
                            ],
                            [
                                14.01248,
                                79.45042
                            ],
                            [
                                13.90809,
                                79.3764
                            ],
                            [
                                13.59088,
                                79.48507
                            ],
                            [
                                13.22472,
                                79.47788
                            ],
                            [
                                13.4883,
                                79.57476
                            ],
                            [
                                13.27668,
                                79.59621
                            ],
                            [
                                12.68116,
                                79.59907
                            ],
                            [
                                13.03664,
                                79.69562
                            ],
                            [
                                13.68631,
                                79.69676
                            ],
                            [
                                13.88327,
                                79.73634
                            ],
                            [
                                13.97082,
                                79.80869
                            ],
                            [
                                13.85503,
                                79.86735
                            ],
                            [
                                13.39723,
                                79.85461
                            ],
                            [
                                12.84552,
                                79.776
                            ],
                            [
                                11.96347,
                                79.74702
                            ],
                            [
                                11.83895,
                                79.83878
                            ],
                            [
                                11.49663,
                                79.80738
                            ],
                            [
                                11.17891,
                                79.72911
                            ],
                            [
                                11.36398,
                                79.63372
                            ],
                            [
                                10.97038,
                                79.64205
                            ],
                            [
                                10.64328,
                                79.55261
                            ],
                            [
                                10.89698,
                                79.48024
                            ],
                            [
                                10.84028,
                                79.32329
                            ],
                            [
                                11.11797,
                                79.23799
                            ],
                            [
                                11.16511,
                                79.11589
                            ],
                            [
                                11.33373,
                                79.10361
                            ],
                            [
                                12.00459,
                                79.23648
                            ],
                            [
                                11.68747,
                                79.06868
                            ],
                            [
                                11.93447,
                                79.01337
                            ],
                            [
                                12.08649,
                                78.93469
                            ],
                            [
                                11.44935,
                                78.97978
                            ],
                            [
                                11.38422,
                                78.92348
                            ],
                            [
                                11.83112,
                                78.83104
                            ],
                            [
                                11.64651,
                                78.76459
                            ],
                            [
                                12.04553,
                                78.59615
                            ],
                            [
                                12.39588,
                                78.53301
                            ],
                            [
                                12.33008,
                                78.48491
                            ],
                            [
                                12.47789,
                                78.41698
                            ],
                            [
                                12.88546,
                                78.29052
                            ],
                            [
                                12.91072,
                                78.21378
                            ],
                            [
                                13.14087,
                                78.21877
                            ],
                            [
                                13.67789,
                                78.19167
                            ],
                            [
                                13.917,
                                78.2177
                            ],
                            [
                                14.32272,
                                78.30432
                            ],
                            [
                                14.2591,
                                78.36716
                            ],
                            [
                                14.78376,
                                78.38887
                            ],
                            [
                                14.44695,
                                78.52234
                            ],
                            [
                                15.00723,
                                78.59545
                            ],
                            [
                                15.43031,
                                78.45596
                            ],
                            [
                                15.94634,
                                78.48355
                            ],
                            [
                                16.27664,
                                78.55899
                            ],
                            [
                                16.3798,
                                78.65467
                            ],
                            [
                                16.74016,
                                78.6447
                            ],
                            [
                                16.45418,
                                78.53694
                            ],
                            [
                                16.34979,
                                78.43164
                            ],
                            [
                                17.02136,
                                78.3732
                            ],
                            [
                                16.47483,
                                78.33462
                            ],
                            [
                                16.21303,
                                78.37187
                            ],
                            [
                                15.8292,
                                78.35222
                            ],
                            [
                                15.53815,
                                78.29448
                            ],
                            [
                                14.97509,
                                78.14757
                            ],
                            [
                                14.46428,
                                78.10605
                            ],
                            [
                                13.93626,
                                78.10573
                            ],
                            [
                                13.55989,
                                78.05545
                            ],
                            [
                                13.54986,
                                77.96064
                            ],
                            [
                                13.71972,
                                77.7764
                            ],
                            [
                                14.06385,
                                77.78428
                            ],
                            [
                                14.39514,
                                77.75876
                            ],
                            [
                                15.13182,
                                77.81204
                            ],
                            [
                                15.50875,
                                77.87793
                            ],
                            [
                                15.57269,
                                77.84033
                            ],
                            [
                                16.62053,
                                77.85196
                            ],
                            [
                                16.11163,
                                77.7883
                            ],
                            [
                                15.25804,
                                77.74953
                            ],
                            [
                                14.73022,
                                77.68299
                            ],
                            [
                                14.78253,
                                77.64088
                            ],
                            [
                                15.19655,
                                77.62421
                            ],
                            [
                                14.63722,
                                77.55628
                            ],
                            [
                                14.33111,
                                77.61639
                            ],
                            [
                                13.8988,
                                77.54737
                            ],
                            [
                                14.04579,
                                77.4622
                            ],
                            [
                                13.90395,
                                77.40341
                            ],
                            [
                                14.04612,
                                77.37437
                            ],
                            [
                                14.35799,
                                77.18279
                            ],
                            [
                                14.65477,
                                77.18077
                            ],
                            [
                                15.03386,
                                77.11804
                            ],
                            [
                                14.9715,
                                77.05637
                            ],
                            [
                                15.21651,
                                76.99699
                            ],
                            [
                                15.65361,
                                76.97706
                            ],
                            [
                                15.46768,
                                76.92062
                            ],
                            [
                                15.55144,
                                76.83612
                            ],
                            [
                                16.28952,
                                76.75134
                            ],
                            [
                                16.26249,
                                76.62613
                            ],
                            [
                                16.32829,
                                76.58954
                            ],
                            [
                                16.74939,
                                76.58343
                            ],
                            [
                                17.11892,
                                76.64314
                            ],
                            [
                                17.22724,
                                76.75125
                            ],
                            [
                                17.08524,
                                76.81712
                            ],
                            [
                                17.07883,
                                76.87663
                            ],
                            [
                                17.27789,
                                76.94878
                            ],
                            [
                                17.20902,
                                77.03649
                            ],
                            [
                                17.36468,
                                77.11579
                            ],
                            [
                                17.48564,
                                77.30188
                            ],
                            [
                                17.61808,
                                77.42893
                            ],
                            [
                                17.77226,
                                77.50002
                            ],
                            [
                                18.17301,
                                77.48992
                            ],
                            [
                                18.29097,
                                77.54402
                            ],
                            [
                                18.37519,
                                77.69326
                            ],
                            [
                                18.47696,
                                77.74227
                            ],
                            [
                                18.37635,
                                77.92783
                            ],
                            [
                                18.48916,
                                77.9761
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                24.14946,
                                80.26043
                            ],
                            [
                                23.77453,
                                80.28309
                            ],
                            [
                                23.71189,
                                80.23068
                            ],
                            [
                                23.15042,
                                80.15408
                            ],
                            [
                                23.05232,
                                80.23827
                            ],
                            [
                                23.31035,
                                80.31007
                            ],
                            [
                                23.20975,
                                80.35793
                            ],
                            [
                                23.32065,
                                80.42649
                            ],
                            [
                                22.82847,
                                80.43096
                            ],
                            [
                                22.36531,
                                80.40503
                            ],
                            [
                                22.46895,
                                80.27072
                            ],
                            [
                                22.38156,
                                80.15139
                            ],
                            [
                                22.45684,
                                80.08315
                            ],
                            [
                                22.13125,
                                80.05242
                            ],
                            [
                                22.04999,
                                80.11764
                            ],
                            [
                                21.84245,
                                80.1426
                            ],
                            [
                                21.85723,
                                80.25258
                            ],
                            [
                                21.49319,
                                80.26213
                            ],
                            [
                                20.89331,
                                80.19868
                            ],
                            [
                                20.57975,
                                80.28146
                            ],
                            [
                                20.5313,
                                80.34734
                            ],
                            [
                                20.30425,
                                80.41228
                            ],
                            [
                                20.0891,
                                80.39619
                            ],
                            [
                                19.67007,
                                80.5049
                            ],
                            [
                                19.4011,
                                80.43388
                            ],
                            [
                                19.46607,
                                80.3891
                            ],
                            [
                                19.91007,
                                80.3734
                            ],
                            [
                                19.58467,
                                80.22298
                            ],
                            [
                                19.23251,
                                80.33782
                            ],
                            [
                                19.00007,
                                80.34462
                            ],
                            [
                                19.17828,
                                80.19881
                            ],
                            [
                                19.49686,
                                80.16438
                            ],
                            [
                                19.23556,
                                80.09429
                            ],
                            [
                                18.91684,
                                80.17539
                            ],
                            [
                                18.43363,
                                80.19307
                            ],
                            [
                                17.82969,
                                80.16591
                            ],
                            [
                                18.12641,
                                80.06832
                            ],
                            [
                                18.72133,
                                80.03475
                            ],
                            [
                                18.78888,
                                79.97482
                            ],
                            [
                                18.24573,
                                79.93991
                            ],
                            [
                                18.09946,
                                79.90128
                            ],
                            [
                                18.32694,
                                79.82585
                            ],
                            [
                                18.97175,
                                79.73282
                            ],
                            [
                                19.66714,
                                79.7211
                            ],
                            [
                                20.26421,
                                79.77468
                            ],
                            [
                                20.77114,
                                79.78623
                            ],
                            [
                                21.45868,
                                79.82412
                            ],
                            [
                                21.56259,
                                79.69722
                            ],
                            [
                                21.27818,
                                79.70528
                            ],
                            [
                                20.47963,
                                79.67267
                            ],
                            [
                                20.55878,
                                79.62908
                            ],
                            [
                                20.33451,
                                79.58966
                            ],
                            [
                                19.97675,
                                79.63504
                            ],
                            [
                                19.69031,
                                79.62327
                            ],
                            [
                                19.66283,
                                79.56862
                            ],
                            [
                                20.15382,
                                79.46461
                            ],
                            [
                                20.7647,
                                79.40997
                            ],
                            [
                                20.93977,
                                79.34868
                            ],
                            [
                                21.50329,
                                79.37442
                            ],
                            [
                                21.90289,
                                79.35333
                            ],
                            [
                                22.25909,
                                79.38942
                            ],
                            [
                                22.75849,
                                79.40432
                            ],
                            [
                                22.65519,
                                79.33952
                            ],
                            [
                                22.87079,
                                79.29012
                            ],
                            [
                                23.63078,
                                79.22028
                            ],
                            [
                                24.15489,
                                79.23736
                            ],
                            [
                                24.19647,
                                79.29431
                            ],
                            [
                                24.72029,
                                79.37712
                            ],
                            [
                                25.10698,
                                79.33289
                            ],
                            [
                                25.61999,
                                79.41172
                            ],
                            [
                                25.87878,
                                79.51983
                            ],
                            [
                                25.7511,
                                79.63493
                            ],
                            [
                                26.36264,
                                79.72716
                            ],
                            [
                                27.12308,
                                79.90342
                            ],
                            [
                                26.96531,
                                79.97517
                            ],
                            [
                                27.22532,
                                80.04915
                            ],
                            [
                                26.80527,
                                80.15806
                            ],
                            [
                                26.34487,
                                80.17983
                            ],
                            [
                                25.78163,
                                80.15996
                            ],
                            [
                                25.27748,
                                80.22848
                            ],
                            [
                                24.84754,
                                80.25411
                            ],
                            [
                                24.48957,
                                80.34806
                            ],
                            [
                                24.14946,
                                80.26043
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                24.00732,
                                77.55943
                            ],
                            [
                                24.30991,
                                77.67839
                            ],
                            [
                                24.15034,
                                77.75173
                            ],
                            [
                                24.32222,
                                77.84123
                            ],
                            [
                                24.04332,
                                77.87663
                            ],
                            [
                                23.74967,
                                77.84727
                            ],
                            [
                                23.32638,
                                77.96049
                            ],
                            [
                                23.12961,
                                78.10141
                            ],
                            [
                                23.26144,
                                78.15757
                            ],
                            [
                                22.84091,
                                78.25805
                            ],
                            [
                                22.38254,
                                78.19877
                            ],
                            [
                                21.77699,
                                78.21631
                            ],
                            [
                                21.38558,
                                78.18837
                            ],
                            [
                                20.84269,
                                78.1216
                            ],
                            [
                                20.80888,
                                78.08005
                            ],
                            [
                                21.22318,
                                77.96853
                            ],
                            [
                                21.55288,
                                77.91009
                            ],
                            [
                                21.2309,
                                77.75141
                            ],
                            [
                                21.15677,
                                77.61149
                            ],
                            [
                                20.95364,
                                77.59243
                            ],
                            [
                                20.86875,
                                77.44091
                            ],
                            [
                                21.1705,
                                77.45234
                            ],
                            [
                                21.57648,
                                77.50183
                            ],
                            [
                                21.78239,
                                77.49736
                            ],
                            [
                                22.51737,
                                77.61321
                            ],
                            [
                                22.76565,
                                77.44217
                            ],
                            [
                                22.55482,
                                77.29298
                            ],
                            [
                                22.59386,
                                77.25522
                            ],
                            [
                                23.01763,
                                77.3061
                            ],
                            [
                                23.1358,
                                77.37252
                            ],
                            [
                                23.46084,
                                77.43142
                            ],
                            [
                                23.81403,
                                77.55806
                            ],
                            [
                                24.00732,
                                77.55943
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                20.16931,
                                78.49836
                            ],
                            [
                                20.58661,
                                78.43007
                            ],
                            [
                                20.62007,
                                78.35129
                            ],
                            [
                                21.00148,
                                78.20037
                            ],
                            [
                                21.6789,
                                78.25917
                            ],
                            [
                                22.15923,
                                78.25861
                            ],
                            [
                                22.25227,
                                78.39949
                            ],
                            [
                                22.1534,
                                78.4304
                            ],
                            [
                                22.02737,
                                78.57749
                            ],
                            [
                                21.69215,
                                78.62027
                            ],
                            [
                                21.19887,
                                78.64284
                            ],
                            [
                                21.0617,
                                78.58405
                            ],
                            [
                                20.25539,
                                78.52097
                            ],
                            [
                                20.16931,
                                78.49836
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                10.91999,
                                78.80983
                            ],
                            [
                                10.74061,
                                78.88781
                            ],
                            [
                                10.53868,
                                78.86382
                            ],
                            [
                                10.50599,
                                78.79972
                            ],
                            [
                                10.92498,
                                78.58501
                            ],
                            [
                                11.03504,
                                78.47595
                            ],
                            [
                                11.30553,
                                78.45743
                            ],
                            [
                                11.81977,
                                78.30538
                            ],
                            [
                                12.08695,
                                78.28922
                            ],
                            [
                                11.86266,
                                78.40401
                            ],
                            [
                                11.30633,
                                78.54778
                            ],
                            [
                                11.06094,
                                78.68557
                            ],
                            [
                                11.19113,
                                78.73709
                            ],
                            [
                                10.91999,
                                78.80983
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -9.07843,
                                70.86831
                            ],
                            [
                                -8.98733,
                                70.82758
                            ],
                            [
                                -8.70315,
                                70.92725
                            ],
                            [
                                -8.49693,
                                70.97004
                            ],
                            [
                                -7.99524,
                                71.02136
                            ],
                            [
                                -7.99863,
                                71.11342
                            ],
                            [
                                -8.07418,
                                71.16102
                            ],
                            [
                                -8.38501,
                                71.08734
                            ],
                            [
                                -8.49954,
                                70.99678
                            ],
                            [
                                -8.86418,
                                70.93814
                            ],
                            [
                                -9.07843,
                                70.86831
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                28.09637,
                                78.79793
                            ],
                            [
                                28.38913,
                                78.88167
                            ],
                            [
                                28.80536,
                                78.90908
                            ],
                            [
                                29.32634,
                                78.84682
                            ],
                            [
                                29.33471,
                                78.89618
                            ],
                            [
                                28.9924,
                                78.91887
                            ],
                            [
                                28.94937,
                                78.95699
                            ],
                            [
                                28.45422,
                                78.96082
                            ],
                            [
                                28.02605,
                                78.87336
                            ],
                            [
                                28.09637,
                                78.79793
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                31.85352,
                                80.09
                            ],
                            [
                                32.34706,
                                80.08086
                            ],
                            [
                                33.19349,
                                80.19644
                            ],
                            [
                                32.74938,
                                80.19618
                            ],
                            [
                                31.85352,
                                80.09
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                20.07158,
                                79.06495
                            ],
                            [
                                20.31632,
                                79.00395
                            ],
                            [
                                20.75415,
                                79.01383
                            ],
                            [
                                20.9193,
                                79.069
                            ],
                            [
                                20.61654,
                                79.12358
                            ],
                            [
                                20.16062,
                                79.135
                            ],
                            [
                                20.07158,
                                79.06495
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                27.7167,
                                80.18772
                            ],
                            [
                                27.81073,
                                80.08673
                            ],
                            [
                                28.11852,
                                80.04974
                            ],
                            [
                                28.35109,
                                80.12652
                            ],
                            [
                                28.0293,
                                80.19427
                            ],
                            [
                                27.7167,
                                80.18772
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                18.75455,
                                74.47051
                            ],
                            [
                                19.02499,
                                74.35237
                            ],
                            [
                                19.14237,
                                74.35874
                            ],
                            [
                                19.26561,
                                74.46283
                            ],
                            [
                                19.11407,
                                74.51044
                            ],
                            [
                                18.75455,
                                74.47051
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                26.57648,
                                78.80908
                            ],
                            [
                                26.39929,
                                78.78113
                            ],
                            [
                                26.46912,
                                78.7027
                            ],
                            [
                                26.75518,
                                78.64567
                            ],
                            [
                                26.95032,
                                78.6861
                            ],
                            [
                                26.57648,
                                78.80908
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                18.44949,
                                80.25572
                            ],
                            [
                                18.52019,
                                80.35782
                            ],
                            [
                                18.16869,
                                80.36582
                            ],
                            [
                                18.06858,
                                80.29292
                            ],
                            [
                                18.44949,
                                80.25572
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                24.90954,
                                76.48332
                            ],
                            [
                                25.49983,
                                76.68305
                            ],
                            [
                                25.35967,
                                76.68522
                            ],
                            [
                                24.90954,
                                76.48332
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                28.92968,
                                69.0519
                            ],
                            [
                                29.05713,
                                69.01565
                            ],
                            [
                                29.24139,
                                69.11271
                            ],
                            [
                                29.31223,
                                69.23773
                            ],
                            [
                                29.28616,
                                69.29347
                            ],
                            [
                                29.39572,
                                69.32324
                            ],
                            [
                                29.56954,
                                69.31786
                            ],
                            [
                                29.84705,
                                69.4217
                            ],
                            [
                                30.02229,
                                69.42012
                            ],
                            [
                                30.11594,
                                69.46944
                            ],
                            [
                                30.2247,
                                69.65289
                            ],
                            [
                                30.51595,
                                69.54082
                            ],
                            [
                                30.81725,
                                69.52916
                            ],
                            [
                                30.93842,
                                69.56169
                            ],
                            [
                                30.94408,
                                69.67476
                            ],
                            [
                                30.86536,
                                69.75959
                            ],
                            [
                                30.79802,
                                69.79082
                            ],
                            [
                                30.50306,
                                69.82343
                            ],
                            [
                                30.26996,
                                69.88021
                            ],
                            [
                                30.13429,
                                69.85169
                            ],
                            [
                                30.19788,
                                69.77205
                            ],
                            [
                                29.95708,
                                69.76591
                            ],
                            [
                                29.87971,
                                69.73153
                            ],
                            [
                                29.66868,
                                69.73572
                            ],
                            [
                                29.75897,
                                69.88174
                            ],
                            [
                                29.60341,
                                69.91466
                            ],
                            [
                                29.65522,
                                69.96574
                            ],
                            [
                                29.10563,
                                70.05882
                            ],
                            [
                                28.85057,
                                70.07292
                            ],
                            [
                                28.76538,
                                70.16939
                            ],
                            [
                                29.02062,
                                70.12343
                            ],
                            [
                                29.11336,
                                70.13082
                            ],
                            [
                                29.41604,
                                70.09447
                            ],
                            [
                                29.90279,
                                70.06064
                            ],
                            [
                                30.35728,
                                70.13803
                            ],
                            [
                                30.36726,
                                70.19904
                            ],
                            [
                                30.56681,
                                70.24784
                            ],
                            [
                                31.06211,
                                70.28903
                            ],
                            [
                                31.05384,
                                70.36054
                            ],
                            [
                                30.96495,
                                70.44037
                            ],
                            [
                                30.38534,
                                70.55171
                            ],
                            [
                                30.33133,
                                70.61288
                            ],
                            [
                                30.17478,
                                70.68472
                            ],
                            [
                                29.97669,
                                70.70803
                            ],
                            [
                                29.81049,
                                70.69352
                            ],
                            [
                                29.727,
                                70.73591
                            ],
                            [
                                29.35359,
                                70.69654
                            ],
                            [
                                29.27483,
                                70.74564
                            ],
                            [
                                29.23266,
                                70.85246
                            ],
                            [
                                28.96232,
                                70.88423
                            ],
                            [
                                28.83411,
                                70.8773
                            ],
                            [
                                28.51879,
                                70.72931
                            ],
                            [
                                28.46957,
                                70.5982
                            ],
                            [
                                28.35995,
                                70.51616
                            ],
                            [
                                27.89683,
                                70.51211
                            ],
                            [
                                28.20951,
                                70.59836
                            ],
                            [
                                28.29739,
                                70.66057
                            ],
                            [
                                28.27771,
                                70.72079
                            ],
                            [
                                28.08739,
                                70.75519
                            ],
                            [
                                28.45494,
                                70.87573
                            ],
                            [
                                28.52122,
                                70.98894
                            ],
                            [
                                28.32358,
                                71.00255
                            ],
                            [
                                28.24323,
                                71.0854
                            ],
                            [
                                27.92719,
                                71.06346
                            ],
                            [
                                27.66186,
                                71.12709
                            ],
                            [
                                27.50643,
                                71.08696
                            ],
                            [
                                27.50233,
                                71.0097
                            ],
                            [
                                27.26993,
                                71.04305
                            ],
                            [
                                27.10561,
                                70.93106
                            ],
                            [
                                27.18085,
                                70.90101
                            ],
                            [
                                27.52528,
                                70.86494
                            ],
                            [
                                27.2829,
                                70.76449
                            ],
                            [
                                27.11526,
                                70.75283
                            ],
                            [
                                27.15307,
                                70.68952
                            ],
                            [
                                26.96033,
                                70.57582
                            ],
                            [
                                27.03174,
                                70.48205
                            ],
                            [
                                26.95443,
                                70.45578
                            ],
                            [
                                26.50714,
                                70.42286
                            ],
                            [
                                26.58273,
                                70.47909
                            ],
                            [
                                26.63741,
                                70.64785
                            ],
                            [
                                26.51373,
                                70.69665
                            ],
                            [
                                26.68207,
                                70.74891
                            ],
                            [
                                26.72638,
                                70.84156
                            ],
                            [
                                26.71635,
                                70.94341
                            ],
                            [
                                26.56388,
                                70.95272
                            ],
                            [
                                26.03193,
                                70.71417
                            ],
                            [
                                25.98572,
                                70.61117
                            ],
                            [
                                25.67068,
                                70.49318
                            ],
                            [
                                25.55053,
                                70.39766
                            ],
                            [
                                25.38968,
                                70.32853
                            ],
                            [
                                25.4763,
                                70.26774
                            ],
                            [
                                25.31947,
                                70.18681
                            ],
                            [
                                25.21655,
                                70.08948
                            ],
                            [
                                25.05419,
                                70.14258
                            ],
                            [
                                24.90224,
                                70.15215
                            ],
                            [
                                24.94165,
                                70.23139
                            ],
                            [
                                25.17157,
                                70.29436
                            ],
                            [
                                25.08921,
                                70.36607
                            ],
                            [
                                25.22908,
                                70.45568
                            ],
                            [
                                25.23299,
                                70.56622
                            ],
                            [
                                25.40001,
                                70.65314
                            ],
                            [
                                25.75103,
                                70.78915
                            ],
                            [
                                25.893,
                                70.86027
                            ],
                            [
                                25.85679,
                                70.90234
                            ],
                            [
                                25.54436,
                                70.91285
                            ],
                            [
                                25.42966,
                                70.96198
                            ],
                            [
                                25.32949,
                                70.82955
                            ],
                            [
                                25.19372,
                                70.89888
                            ],
                            [
                                24.91613,
                                70.88388
                            ],
                            [
                                24.76061,
                                70.96461
                            ],
                            [
                                24.537,
                                70.96877
                            ],
                            [
                                24.56031,
                                70.86291
                            ],
                            [
                                24.42999,
                                70.82761
                            ],
                            [
                                24.24492,
                                70.84126
                            ],
                            [
                                24.24607,
                                70.77927
                            ],
                            [
                                24.53018,
                                70.7208
                            ],
                            [
                                24.69505,
                                70.63189
                            ],
                            [
                                24.60696,
                                70.61546
                            ],
                            [
                                24.45252,
                                70.68297
                            ],
                            [
                                24.3126,
                                70.68742
                            ],
                            [
                                24.23652,
                                70.6039
                            ],
                            [
                                24.04348,
                                70.51206
                            ],
                            [
                                23.85401,
                                70.49437
                            ],
                            [
                                23.44589,
                                70.33087
                            ],
                            [
                                23.40186,
                                70.22751
                            ],
                            [
                                23.19909,
                                70.21511
                            ],
                            [
                                23.34583,
                                70.09963
                            ],
                            [
                                23.13553,
                                70.08554
                            ],
                            [
                                23.46462,
                                69.97933
                            ],
                            [
                                23.09095,
                                69.94596
                            ],
                            [
                                23.10139,
                                70.00184
                            ],
                            [
                                22.99674,
                                70.05819
                            ],
                            [
                                22.92691,
                                70.20477
                            ],
                            [
                                22.61015,
                                70.22339
                            ],
                            [
                                21.9787,
                                70.32886
                            ],
                            [
                                21.79039,
                                70.26588
                            ],
                            [
                                21.47541,
                                70.29819
                            ],
                            [
                                21.18842,
                                70.21815
                            ],
                            [
                                21.45704,
                                70.10034
                            ],
                            [
                                21.59264,
                                70.08414
                            ],
                            [
                                21.866,
                                70.0108
                            ],
                            [
                                21.91115,
                                69.875
                            ],
                            [
                                21.99711,
                                69.86335
                            ],
                            [
                                21.93075,
                                69.7785
                            ],
                            [
                                21.76309,
                                69.87836
                            ],
                            [
                                21.57657,
                                69.91467
                            ],
                            [
                                21.43423,
                                70.01386
                            ],
                            [
                                21.2436,
                                70.00878
                            ],
                            [
                                21.19093,
                                69.88513
                            ],
                            [
                                20.92441,
                                69.8024
                            ],
                            [
                                20.86075,
                                69.84948
                            ],
                            [
                                20.48622,
                                69.74691
                            ],
                            [
                                20.52786,
                                69.7085
                            ],
                            [
                                20.32093,
                                69.45784
                            ],
                            [
                                20.22252,
                                69.57527
                            ],
                            [
                                20.31494,
                                69.78312
                            ],
                            [
                                20.39327,
                                69.89052
                            ],
                            [
                                20.28789,
                                69.97529
                            ],
                            [
                                20.12676,
                                69.93199
                            ],
                            [
                                19.98394,
                                69.76855
                            ],
                            [
                                19.85044,
                                69.7697
                            ],
                            [
                                19.77481,
                                69.67806
                            ],
                            [
                                19.6493,
                                69.66324
                            ],
                            [
                                19.73056,
                                69.80478
                            ],
                            [
                                19.68576,
                                69.81622
                            ],
                            [
                                19.0959,
                                69.73389
                            ],
                            [
                                18.94588,
                                69.62659
                            ],
                            [
                                18.94394,
                                69.56046
                            ],
                            [
                                18.446,
                                69.51039
                            ],
                            [
                                18.45575,
                                69.45659
                            ],
                            [
                                18.60979,
                                69.37891
                            ],
                            [
                                18.8013,
                                69.33516
                            ],
                            [
                                18.61727,
                                69.29653
                            ],
                            [
                                18.39741,
                                69.39552
                            ],
                            [
                                18.36566,
                                69.4589
                            ],
                            [
                                18.13315,
                                69.45637
                            ],
                            [
                                18.10957,
                                69.34883
                            ],
                            [
                                17.98686,
                                69.30795
                            ],
                            [
                                17.97597,
                                69.22654
                            ],
                            [
                                18.05292,
                                69.18312
                            ],
                            [
                                17.78871,
                                69.11611
                            ],
                            [
                                17.47615,
                                68.99137
                            ],
                            [
                                17.5135,
                                68.90778
                            ],
                            [
                                17.62408,
                                68.89101
                            ],
                            [
                                17.46515,
                                68.81987
                            ],
                            [
                                17.12136,
                                68.71426
                            ],
                            [
                                16.96709,
                                68.71378
                            ],
                            [
                                16.61481,
                                68.643
                            ],
                            [
                                16.56523,
                                68.5832
                            ],
                            [
                                16.46477,
                                68.53498
                            ],
                            [
                                16.52474,
                                68.48849
                            ],
                            [
                                16.5152,
                                68.45247
                            ],
                            [
                                16.87166,
                                68.46982
                            ],
                            [
                                16.93842,
                                68.51409
                            ],
                            [
                                17.247,
                                68.46346
                            ],
                            [
                                17.42225,
                                68.52353
                            ],
                            [
                                17.4729,
                                68.46646
                            ],
                            [
                                17.25096,
                                68.39513
                            ],
                            [
                                16.88359,
                                68.39086
                            ],
                            [
                                16.75691,
                                68.42017
                            ],
                            [
                                16.49661,
                                68.40954
                            ],
                            [
                                16.27721,
                                68.37145
                            ],
                            [
                                16.14664,
                                68.28548
                            ],
                            [
                                16.3319,
                                68.27066
                            ],
                            [
                                16.47871,
                                68.18753
                            ],
                            [
                                16.30643,
                                68.14048
                            ],
                            [
                                16.4051,
                                68.02315
                            ],
                            [
                                16.23445,
                                68.02828
                            ],
                            [
                                16.11135,
                                68.08492
                            ],
                            [
                                16.13875,
                                68.18729
                            ],
                            [
                                16.06075,
                                68.25476
                            ],
                            [
                                15.85364,
                                68.20005
                            ],
                            [
                                15.89481,
                                68.13257
                            ],
                            [
                                15.73738,
                                68.08734
                            ],
                            [
                                15.7112,
                                68.17071
                            ],
                            [
                                15.34405,
                                68.10407
                            ],
                            [
                                15.2941,
                                68.02633
                            ],
                            [
                                15.5928,
                                68.07369
                            ],
                            [
                                15.81009,
                                68.03052
                            ],
                            [
                                15.96668,
                                67.9767
                            ],
                            [
                                15.87302,
                                67.93914
                            ],
                            [
                                15.73588,
                                67.96965
                            ],
                            [
                                15.44457,
                                67.92942
                            ],
                            [
                                15.26994,
                                67.88404
                            ],
                            [
                                15.00626,
                                67.90588
                            ],
                            [
                                14.87391,
                                67.88302
                            ],
                            [
                                14.7622,
                                67.80664
                            ],
                            [
                                14.96799,
                                67.75063
                            ],
                            [
                                14.74601,
                                67.68044
                            ],
                            [
                                14.91748,
                                67.66021
                            ],
                            [
                                15.16575,
                                67.71877
                            ],
                            [
                                15.19937,
                                67.75388
                            ],
                            [
                                15.42208,
                                67.81754
                            ],
                            [
                                15.50849,
                                67.76764
                            ],
                            [
                                15.31352,
                                67.73765
                            ],
                            [
                                15.16217,
                                67.6337
                            ],
                            [
                                14.93514,
                                67.57596
                            ],
                            [
                                14.65487,
                                67.47805
                            ],
                            [
                                14.62935,
                                67.38545
                            ],
                            [
                                14.31805,
                                67.26501
                            ],
                            [
                                14.59121,
                                67.27767
                            ],
                            [
                                14.72372,
                                67.24148
                            ],
                            [
                                14.8758,
                                67.29769
                            ],
                            [
                                15.15212,
                                67.32988
                            ],
                            [
                                15.25155,
                                67.27013
                            ],
                            [
                                15.41471,
                                67.24196
                            ],
                            [
                                15.41809,
                                67.16838
                            ],
                            [
                                15.09346,
                                67.2357
                            ],
                            [
                                14.94995,
                                67.20419
                            ],
                            [
                                14.82341,
                                67.24022
                            ],
                            [
                                14.70883,
                                67.21236
                            ],
                            [
                                14.59002,
                                67.23785
                            ],
                            [
                                14.36257,
                                67.21096
                            ],
                            [
                                14.21364,
                                66.9931
                            ],
                            [
                                14.10147,
                                67.05596
                            ],
                            [
                                13.81028,
                                66.98552
                            ],
                            [
                                13.60753,
                                66.95159
                            ],
                            [
                                13.7033,
                                66.81292
                            ],
                            [
                                13.50153,
                                66.80309
                            ],
                            [
                                13.52382,
                                66.72458
                            ],
                            [
                                13.2768,
                                66.73412
                            ],
                            [
                                13.21853,
                                66.67514
                            ],
                            [
                                13.20471,
                                66.55713
                            ],
                            [
                                13.35246,
                                66.54324
                            ],
                            [
                                13.27569,
                                66.48543
                            ],
                            [
                                13.09,
                                66.54738
                            ],
                            [
                                12.97881,
                                66.52184
                            ],
                            [
                                13.14825,
                                66.43828
                            ],
                            [
                                13.15762,
                                66.40566
                            ],
                            [
                                13.00235,
                                66.33299
                            ],
                            [
                                13.31879,
                                66.25017
                            ],
                            [
                                13.23742,
                                66.18855
                            ],
                            [
                                12.82833,
                                66.12646
                            ],
                            [
                                12.67848,
                                66.06721
                            ],
                            [
                                12.94798,
                                66.04669
                            ],
                            [
                                12.89843,
                                65.98394
                            ],
                            [
                                12.66841,
                                65.92154
                            ],
                            [
                                12.58191,
                                65.76716
                            ],
                            [
                                12.42858,
                                65.69522
                            ],
                            [
                                12.35073,
                                65.62937
                            ],
                            [
                                12.4506,
                                65.47752
                            ],
                            [
                                12.23946,
                                65.55865
                            ],
                            [
                                12.21155,
                                65.41997
                            ],
                            [
                                12.12407,
                                65.34209
                            ],
                            [
                                12.10188,
                                65.21634
                            ],
                            [
                                12.20748,
                                65.24593
                            ],
                            [
                                12.42077,
                                65.36259
                            ],
                            [
                                12.45474,
                                65.20759
                            ],
                            [
                                12.35336,
                                65.15845
                            ],
                            [
                                12.49794,
                                65.13541
                            ],
                            [
                                12.32958,
                                65.08014
                            ],
                            [
                                12.26521,
                                65.19113
                            ],
                            [
                                12.12477,
                                65.19015
                            ],
                            [
                                12.07003,
                                65.09016
                            ],
                            [
                                12.00158,
                                65.08991
                            ],
                            [
                                11.77397,
                                64.99498
                            ],
                            [
                                11.51161,
                                64.9504
                            ],
                            [
                                11.28235,
                                64.86639
                            ],
                            [
                                11.37645,
                                64.80408
                            ],
                            [
                                11.63813,
                                64.83803
                            ],
                            [
                                11.73242,
                                64.78075
                            ],
                            [
                                11.55218,
                                64.75342
                            ],
                            [
                                11.40781,
                                64.70287
                            ],
                            [
                                11.40483,
                                64.62766
                            ],
                            [
                                11.51116,
                                64.57027
                            ],
                            [
                                11.44103,
                                64.49825
                            ],
                            [
                                11.51861,
                                64.44934
                            ],
                            [
                                11.35696,
                                64.41795
                            ],
                            [
                                11.18672,
                                64.48235
                            ],
                            [
                                10.973,
                                64.53714
                            ],
                            [
                                10.8794,
                                64.49766
                            ],
                            [
                                10.70366,
                                64.47554
                            ],
                            [
                                10.6036,
                                64.38969
                            ],
                            [
                                10.44796,
                                64.35155
                            ],
                            [
                                10.45249,
                                64.30805
                            ],
                            [
                                10.20084,
                                64.19981
                            ],
                            [
                                10.00781,
                                64.0184
                            ],
                            [
                                10.10996,
                                63.92183
                            ],
                            [
                                9.68478,
                                63.84572
                            ],
                            [
                                9.57255,
                                63.77922
                            ],
                            [
                                9.55482,
                                63.72108
                            ],
                            [
                                9.66477,
                                63.67518
                            ],
                            [
                                9.86149,
                                63.72166
                            ],
                            [
                                9.81164,
                                63.62664
                            ],
                            [
                                9.94601,
                                63.49824
                            ],
                            [
                                10.12658,
                                63.50305
                            ],
                            [
                                10.23007,
                                63.55532
                            ],
                            [
                                10.42189,
                                63.57242
                            ],
                            [
                                10.61656,
                                63.66829
                            ],
                            [
                                10.92676,
                                63.73529
                            ],
                            [
                                11.06825,
                                63.84206
                            ],
                            [
                                10.96397,
                                63.90553
                            ],
                            [
                                11.01927,
                                63.95538
                            ],
                            [
                                11.28159,
                                64.03581
                            ],
                            [
                                11.29069,
                                63.97509
                            ],
                            [
                                11.0715,
                                63.8687
                            ],
                            [
                                11.24331,
                                63.86886
                            ],
                            [
                                11.40698,
                                63.84486
                            ],
                            [
                                11.43812,
                                63.77922
                            ],
                            [
                                11.21301,
                                63.72133
                            ],
                            [
                                10.95335,
                                63.6999
                            ],
                            [
                                10.84295,
                                63.63842
                            ],
                            [
                                10.67309,
                                63.58181
                            ],
                            [
                                10.75721,
                                63.50237
                            ],
                            [
                                10.89343,
                                63.44817
                            ],
                            [
                                10.52137,
                                63.4315
                            ],
                            [
                                10.4495,
                                63.45688
                            ],
                            [
                                10.18348,
                                63.44896
                            ],
                            [
                                10.06776,
                                63.40297
                            ],
                            [
                                9.85123,
                                63.48496
                            ],
                            [
                                9.75971,
                                63.58338
                            ],
                            [
                                9.7467,
                                63.64488
                            ],
                            [
                                9.53116,
                                63.59993
                            ],
                            [
                                9.15095,
                                63.48798
                            ],
                            [
                                8.9823,
                                63.4213
                            ],
                            [
                                8.66478,
                                63.41084
                            ],
                            [
                                8.75449,
                                63.33696
                            ],
                            [
                                8.50115,
                                63.28971
                            ],
                            [
                                8.5826,
                                63.2161
                            ],
                            [
                                8.57648,
                                63.12891
                            ],
                            [
                                8.33118,
                                63.14898
                            ],
                            [
                                8.16161,
                                63.12486
                            ],
                            [
                                8.31129,
                                63.0091
                            ],
                            [
                                8.54166,
                                62.87959
                            ],
                            [
                                8.45357,
                                62.84741
                            ],
                            [
                                8.28628,
                                62.92749
                            ],
                            [
                                8.33093,
                                62.96338
                            ],
                            [
                                8.13353,
                                63.03472
                            ],
                            [
                                8.07048,
                                63.11008
                            ],
                            [
                                7.98098,
                                63.08864
                            ],
                            [
                                7.99099,
                                63.01075
                            ],
                            [
                                8.13597,
                                62.94642
                            ],
                            [
                                8.15863,
                                62.85619
                            ],
                            [
                                8.53023,
                                62.73439
                            ],
                            [
                                8.50575,
                                62.71694
                            ],
                            [
                                8.17405,
                                62.80198
                            ],
                            [
                                8.03831,
                                62.96336
                            ],
                            [
                                7.83648,
                                62.94983
                            ],
                            [
                                7.68633,
                                62.96858
                            ],
                            [
                                7.53699,
                                62.91216
                            ],
                            [
                                7.44774,
                                62.90654
                            ],
                            [
                                7.41325,
                                62.95706
                            ],
                            [
                                7.28817,
                                63.00872
                            ],
                            [
                                7.11498,
                                62.98709
                            ],
                            [
                                6.90277,
                                62.91012
                            ],
                            [
                                7.00664,
                                62.84787
                            ],
                            [
                                6.98462,
                                62.72482
                            ],
                            [
                                7.36971,
                                62.73921
                            ],
                            [
                                7.45564,
                                62.68497
                            ],
                            [
                                7.35864,
                                62.60675
                            ],
                            [
                                7.23409,
                                62.61076
                            ],
                            [
                                7.08043,
                                62.6534
                            ],
                            [
                                6.75597,
                                62.65326
                            ],
                            [
                                6.25973,
                                62.582
                            ],
                            [
                                6.27179,
                                62.52975
                            ],
                            [
                                6.54463,
                                62.54257
                            ],
                            [
                                6.3714,
                                62.47676
                            ],
                            [
                                6.34826,
                                62.43446
                            ],
                            [
                                6.54824,
                                62.40917
                            ],
                            [
                                6.23105,
                                62.35685
                            ],
                            [
                                5.98284,
                                62.26812
                            ],
                            [
                                5.91427,
                                62.18883
                            ],
                            [
                                5.56251,
                                62.16732
                            ],
                            [
                                5.49142,
                                62.1994
                            ],
                            [
                                5.40707,
                                62.12736
                            ],
                            [
                                5.54391,
                                62.10106
                            ],
                            [
                                5.52731,
                                62.04769
                            ],
                            [
                                5.31729,
                                62.12213
                            ],
                            [
                                5.32725,
                                62.1655
                            ],
                            [
                                5.18258,
                                62.21374
                            ],
                            [
                                5.09975,
                                62.19176
                            ],
                            [
                                5.12615,
                                62.1011
                            ],
                            [
                                5.23531,
                                62.10268
                            ],
                            [
                                5.34201,
                                62.05917
                            ],
                            [
                                5.33355,
                                61.99532
                            ],
                            [
                                5.15864,
                                61.97832
                            ],
                            [
                                5.12578,
                                61.9218
                            ],
                            [
                                5.32443,
                                61.91021
                            ],
                            [
                                5.44472,
                                61.93939
                            ],
                            [
                                5.71063,
                                61.91075
                            ],
                            [
                                5.70536,
                                61.884
                            ],
                            [
                                5.4327,
                                61.91634
                            ],
                            [
                                5.31186,
                                61.86896
                            ],
                            [
                                5.30812,
                                61.82656
                            ],
                            [
                                5.15921,
                                61.80719
                            ],
                            [
                                4.99375,
                                61.73999
                            ],
                            [
                                4.97083,
                                61.6765
                            ],
                            [
                                5.04761,
                                61.59074
                            ],
                            [
                                5.20221,
                                61.59936
                            ],
                            [
                                5.17764,
                                61.51665
                            ],
                            [
                                5.34665,
                                61.46064
                            ],
                            [
                                5.08063,
                                61.45037
                            ],
                            [
                                4.97995,
                                61.42063
                            ],
                            [
                                5.07377,
                                61.32681
                            ],
                            [
                                4.98766,
                                61.28325
                            ],
                            [
                                5.07813,
                                61.18065
                            ],
                            [
                                5.2566,
                                61.10668
                            ],
                            [
                                5.32689,
                                61.12212
                            ],
                            [
                                5.44112,
                                61.0783
                            ],
                            [
                                5.72772,
                                61.16624
                            ],
                            [
                                6.20862,
                                61.16501
                            ],
                            [
                                6.37719,
                                61.11115
                            ],
                            [
                                6.53849,
                                61.1382
                            ],
                            [
                                6.59911,
                                61.20735
                            ],
                            [
                                6.84842,
                                61.18448
                            ],
                            [
                                6.94543,
                                61.11443
                            ],
                            [
                                7.176,
                                61.14513
                            ],
                            [
                                7.35414,
                                61.19738
                            ],
                            [
                                7.45719,
                                61.17639
                            ],
                            [
                                7.38168,
                                61.12228
                            ],
                            [
                                7.21531,
                                61.11835
                            ],
                            [
                                7.02771,
                                61.08605
                            ],
                            [
                                6.88064,
                                61.08964
                            ],
                            [
                                6.85188,
                                61.14521
                            ],
                            [
                                6.63478,
                                61.17434
                            ],
                            [
                                6.58907,
                                61.0906
                            ],
                            [
                                6.34557,
                                61.07004
                            ],
                            [
                                6.19286,
                                61.11415
                            ],
                            [
                                5.80322,
                                61.12544
                            ],
                            [
                                5.6494,
                                61.10156
                            ],
                            [
                                5.46283,
                                61.02916
                            ],
                            [
                                5.32541,
                                61.03203
                            ],
                            [
                                5.16204,
                                61.0794
                            ],
                            [
                                5.0482,
                                61.05978
                            ],
                            [
                                5.01258,
                                60.96549
                            ],
                            [
                                5.06795,
                                60.84344
                            ],
                            [
                                5.30992,
                                60.80957
                            ],
                            [
                                5.27419,
                                60.75998
                            ],
                            [
                                4.94803,
                                60.79512
                            ],
                            [
                                5.17371,
                                60.69205
                            ],
                            [
                                5.28335,
                                60.54215
                            ],
                            [
                                5.49747,
                                60.62997
                            ],
                            [
                                5.55203,
                                60.69916
                            ],
                            [
                                5.73666,
                                60.68983
                            ],
                            [
                                5.7204,
                                60.53855
                            ],
                            [
                                5.73688,
                                60.45796
                            ],
                            [
                                5.52239,
                                60.42239
                            ],
                            [
                                5.36111,
                                60.51084
                            ],
                            [
                                5.25711,
                                60.47901
                            ],
                            [
                                5.31153,
                                60.38983
                            ],
                            [
                                5.1738,
                                60.37041
                            ],
                            [
                                5.20971,
                                60.27874
                            ],
                            [
                                5.32618,
                                60.25539
                            ],
                            [
                                5.42675,
                                60.14333
                            ],
                            [
                                5.53491,
                                60.19962
                            ],
                            [
                                5.59978,
                                60.14468
                            ],
                            [
                                5.72399,
                                60.16888
                            ],
                            [
                                5.76145,
                                60.12901
                            ],
                            [
                                5.70987,
                                60.03925
                            ],
                            [
                                5.82734,
                                59.98288
                            ],
                            [
                                5.92097,
                                60.04413
                            ],
                            [
                                5.90232,
                                60.15738
                            ],
                            [
                                6.01842,
                                60.26901
                            ],
                            [
                                6.15633,
                                60.24603
                            ],
                            [
                                6.25066,
                                60.37233
                            ],
                            [
                                6.53422,
                                60.45867
                            ],
                            [
                                6.49546,
                                60.38358
                            ],
                            [
                                6.35116,
                                60.36863
                            ],
                            [
                                6.24464,
                                60.3013
                            ],
                            [
                                6.17713,
                                60.21638
                            ],
                            [
                                6.08388,
                                60.19175
                            ],
                            [
                                6.20459,
                                60.11639
                            ],
                            [
                                6.04033,
                                60.06744
                            ],
                            [
                                5.91932,
                                59.95442
                            ],
                            [
                                5.77349,
                                59.91201
                            ],
                            [
                                5.70131,
                                59.85844
                            ],
                            [
                                5.88142,
                                59.77073
                            ],
                            [
                                5.78423,
                                59.68063
                            ],
                            [
                                5.79787,
                                59.64259
                            ],
                            [
                                5.49732,
                                59.71624
                            ],
                            [
                                5.43653,
                                59.67996
                            ],
                            [
                                5.47339,
                                59.62514
                            ],
                            [
                                5.32152,
                                59.6203
                            ],
                            [
                                5.2255,
                                59.50257
                            ],
                            [
                                5.34867,
                                59.27279
                            ],
                            [
                                5.45406,
                                59.29743
                            ],
                            [
                                5.5552,
                                59.27532
                            ],
                            [
                                5.61254,
                                59.33255
                            ],
                            [
                                5.74519,
                                59.32837
                            ],
                            [
                                5.94701,
                                59.3593
                            ],
                            [
                                6.1347,
                                59.31574
                            ],
                            [
                                6.16828,
                                59.26231
                            ],
                            [
                                6.02436,
                                59.14443
                            ],
                            [
                                5.89211,
                                59.08369
                            ],
                            [
                                5.96205,
                                58.94484
                            ],
                            [
                                5.84795,
                                58.93249
                            ],
                            [
                                5.59962,
                                59.03086
                            ],
                            [
                                5.57841,
                                58.9004
                            ],
                            [
                                5.53126,
                                58.77835
                            ],
                            [
                                5.4911,
                                58.75346
                            ],
                            [
                                5.54395,
                                58.67004
                            ],
                            [
                                5.65857,
                                58.55723
                            ],
                            [
                                5.87736,
                                58.46502
                            ],
                            [
                                5.97912,
                                58.46842
                            ],
                            [
                                6.04916,
                                58.37675
                            ],
                            [
                                6.36626,
                                58.27932
                            ],
                            [
                                6.73961,
                                58.21495
                            ],
                            [
                                6.62559,
                                58.17727
                            ],
                            [
                                6.56118,
                                58.11098
                            ],
                            [
                                6.73119,
                                58.06546
                            ],
                            [
                                6.94437,
                                58.06981
                            ],
                            [
                                7.01477,
                                58.03336
                            ],
                            [
                                7.19646,
                                58.04924
                            ],
                            [
                                7.50791,
                                58.00524
                            ],
                            [
                                7.66592,
                                58.01455
                            ],
                            [
                                7.75659,
                                58.07239
                            ],
                            [
                                7.91052,
                                58.07044
                            ],
                            [
                                7.98795,
                                58.14202
                            ],
                            [
                                8.14619,
                                58.10667
                            ],
                            [
                                8.25172,
                                58.13336
                            ],
                            [
                                8.39317,
                                58.25289
                            ],
                            [
                                8.51824,
                                58.2626
                            ],
                            [
                                8.6009,
                                58.34256
                            ],
                            [
                                8.70989,
                                58.3771
                            ],
                            [
                                8.81514,
                                58.47028
                            ],
                            [
                                8.97009,
                                58.53085
                            ],
                            [
                                9.01564,
                                58.6118
                            ],
                            [
                                9.20084,
                                58.66674
                            ],
                            [
                                9.23706,
                                58.72801
                            ],
                            [
                                9.34918,
                                58.75605
                            ],
                            [
                                9.45781,
                                58.82624
                            ],
                            [
                                9.4044,
                                58.86543
                            ],
                            [
                                9.54765,
                                58.89717
                            ],
                            [
                                9.59295,
                                58.94529
                            ],
                            [
                                9.69676,
                                58.97094
                            ],
                            [
                                9.70214,
                                59.04477
                            ],
                            [
                                9.82777,
                                59.03236
                            ],
                            [
                                9.90075,
                                58.96826
                            ],
                            [
                                10.15678,
                                59.00809
                            ],
                            [
                                10.30985,
                                59.09071
                            ],
                            [
                                10.33118,
                                59.15985
                            ],
                            [
                                10.4346,
                                59.16558
                            ],
                            [
                                10.51977,
                                59.2955
                            ],
                            [
                                10.46839,
                                59.35388
                            ],
                            [
                                10.49461,
                                59.43333
                            ],
                            [
                                10.38132,
                                59.44058
                            ],
                            [
                                10.33504,
                                59.53224
                            ],
                            [
                                10.46408,
                                59.51778
                            ],
                            [
                                10.61623,
                                59.57099
                            ],
                            [
                                10.60148,
                                59.6624
                            ],
                            [
                                10.52356,
                                59.68767
                            ],
                            [
                                10.47845,
                                59.82083
                            ],
                            [
                                10.567,
                                59.88898
                            ],
                            [
                                10.64787,
                                59.84762
                            ],
                            [
                                10.58309,
                                59.76233
                            ],
                            [
                                10.68029,
                                59.51375
                            ],
                            [
                                10.66039,
                                59.33648
                            ],
                            [
                                10.82646,
                                59.16798
                            ],
                            [
                                10.98257,
                                59.18696
                            ],
                            [
                                11.03488,
                                59.13306
                            ],
                            [
                                11.16297,
                                59.1619
                            ],
                            [
                                11.22259,
                                59.08918
                            ],
                            [
                                11.36456,
                                59.11886
                            ],
                            [
                                11.46083,
                                58.98866
                            ],
                            [
                                11.45745,
                                58.88844
                            ],
                            [
                                11.63175,
                                58.90834
                            ],
                            [
                                11.71051,
                                59.03368
                            ],
                            [
                                11.77524,
                                59.08705
                            ],
                            [
                                11.78349,
                                59.20718
                            ],
                            [
                                11.82959,
                                59.24317
                            ],
                            [
                                11.81613,
                                59.34445
                            ],
                            [
                                11.69153,
                                59.58894
                            ],
                            [
                                11.71845,
                                59.62387
                            ],
                            [
                                11.85658,
                                59.64898
                            ],
                            [
                                11.93794,
                                59.69459
                            ],
                            [
                                11.92548,
                                59.79393
                            ],
                            [
                                11.83973,
                                59.84077
                            ],
                            [
                                11.98422,
                                59.90028
                            ],
                            [
                                12.17124,
                                59.88932
                            ],
                            [
                                12.34077,
                                59.96572
                            ],
                            [
                                12.44962,
                                60.0403
                            ],
                            [
                                12.54156,
                                60.19319
                            ],
                            [
                                12.49928,
                                60.32346
                            ],
                            [
                                12.60583,
                                60.4062
                            ],
                            [
                                12.60684,
                                60.51158
                            ],
                            [
                                12.51084,
                                60.64216
                            ],
                            [
                                12.39533,
                                60.73423
                            ],
                            [
                                12.33263,
                                60.88986
                            ],
                            [
                                12.22399,
                                61.01308
                            ],
                            [
                                12.44797,
                                61.05067
                            ],
                            [
                                12.68264,
                                61.06165
                            ],
                            [
                                12.70736,
                                61.14321
                            ],
                            [
                                12.79003,
                                61.19699
                            ],
                            [
                                12.87085,
                                61.35649
                            ],
                            [
                                12.56958,
                                61.56828
                            ],
                            [
                                12.41971,
                                61.56339
                            ],
                            [
                                12.13804,
                                61.72458
                            ],
                            [
                                12.29937,
                                62.26749
                            ],
                            [
                                12.05663,
                                62.6115
                            ],
                            [
                                12.13638,
                                62.74792
                            ],
                            [
                                12.07469,
                                62.90254
                            ],
                            [
                                12.21757,
                                63.00067
                            ],
                            [
                                11.97458,
                                63.26923
                            ],
                            [
                                12.2123,
                                63.47834
                            ],
                            [
                                12.14977,
                                63.59395
                            ],
                            [
                                12.3315,
                                63.71568
                            ],
                            [
                                12.68357,
                                63.97422
                            ],
                            [
                                12.92679,
                                64.05784
                            ],
                            [
                                13.21111,
                                64.09537
                            ],
                            [
                                13.71279,
                                64.04655
                            ],
                            [
                                13.96787,
                                64.00906
                            ],
                            [
                                14.15638,
                                64.19494
                            ],
                            [
                                14.11391,
                                64.46173
                            ],
                            [
                                13.89091,
                                64.5073
                            ],
                            [
                                13.65503,
                                64.58054
                            ],
                            [
                                13.70608,
                                64.64042
                            ],
                            [
                                14.07755,
                                64.93912
                            ],
                            [
                                14.32599,
                                65.11892
                            ],
                            [
                                14.379,
                                65.24742
                            ],
                            [
                                14.5065,
                                65.31002
                            ],
                            [
                                14.499,
                                65.52218
                            ],
                            [
                                14.54129,
                                65.69987
                            ],
                            [
                                14.62506,
                                65.81153
                            ],
                            [
                                14.51737,
                                66.13243
                            ],
                            [
                                15.03577,
                                66.15399
                            ],
                            [
                                15.48167,
                                66.28177
                            ],
                            [
                                15.37776,
                                66.48413
                            ],
                            [
                                15.62209,
                                66.59494
                            ],
                            [
                                16.03992,
                                66.91294
                            ],
                            [
                                16.38763,
                                67.04601
                            ],
                            [
                                16.40334,
                                67.20547
                            ],
                            [
                                16.09041,
                                67.43577
                            ],
                            [
                                16.15859,
                                67.51898
                            ],
                            [
                                16.40767,
                                67.5341
                            ],
                            [
                                16.55628,
                                67.64719
                            ],
                            [
                                16.74003,
                                67.91482
                            ],
                            [
                                17.18051,
                                68.05046
                            ],
                            [
                                17.28152,
                                68.11881
                            ],
                            [
                                17.66475,
                                68.03838
                            ],
                            [
                                17.89976,
                                67.96937
                            ],
                            [
                                18.15135,
                                68.19879
                            ],
                            [
                                18.10109,
                                68.40604
                            ],
                            [
                                18.12592,
                                68.53652
                            ],
                            [
                                18.40555,
                                68.5816
                            ],
                            [
                                18.62103,
                                68.50723
                            ],
                            [
                                18.98545,
                                68.51666
                            ],
                            [
                                19.92026,
                                68.35633
                            ],
                            [
                                20.22654,
                                68.49081
                            ],
                            [
                                19.9375,
                                68.55794
                            ],
                            [
                                20.20328,
                                68.66645
                            ],
                            [
                                20.33527,
                                68.8018
                            ],
                            [
                                20.30612,
                                68.92618
                            ],
                            [
                                20.06005,
                                69.04576
                            ],
                            [
                                20.54864,
                                69.05997
                            ],
                            [
                                20.71671,
                                69.1194
                            ],
                            [
                                21.05772,
                                69.03686
                            ],
                            [
                                21.10809,
                                69.1036
                            ],
                            [
                                20.9881,
                                69.19166
                            ],
                            [
                                21.09714,
                                69.26116
                            ],
                            [
                                21.27882,
                                69.31188
                            ],
                            [
                                21.62709,
                                69.27659
                            ],
                            [
                                22.17589,
                                68.95584
                            ],
                            [
                                22.34061,
                                68.82707
                            ],
                            [
                                22.375,
                                68.71706
                            ],
                            [
                                22.53534,
                                68.74425
                            ],
                            [
                                22.7989,
                                68.68795
                            ],
                            [
                                23.04562,
                                68.68914
                            ],
                            [
                                23.16901,
                                68.62893
                            ],
                            [
                                23.44031,
                                68.69201
                            ],
                            [
                                23.67334,
                                68.70578
                            ],
                            [
                                23.77541,
                                68.81845
                            ],
                            [
                                23.98335,
                                68.82692
                            ],
                            [
                                24.29653,
                                68.71845
                            ],
                            [
                                24.60752,
                                68.68197
                            ],
                            [
                                24.91875,
                                68.60538
                            ],
                            [
                                25.11586,
                                68.6396
                            ],
                            [
                                25.12195,
                                68.74633
                            ],
                            [
                                25.24372,
                                68.84137
                            ],
                            [
                                25.4807,
                                68.90489
                            ],
                            [
                                25.62719,
                                68.89321
                            ],
                            [
                                25.77717,
                                69.01799
                            ],
                            [
                                25.69309,
                                69.19717
                            ],
                            [
                                25.79696,
                                69.41943
                            ],
                            [
                                25.97623,
                                69.61052
                            ],
                            [
                                25.89971,
                                69.65838
                            ],
                            [
                                26.10873,
                                69.73018
                            ],
                            [
                                26.38556,
                                69.8554
                            ],
                            [
                                26.46678,
                                69.9397
                            ],
                            [
                                26.67652,
                                69.96424
                            ],
                            [
                                26.98692,
                                69.93458
                            ],
                            [
                                27.30524,
                                69.95754
                            ],
                            [
                                27.42676,
                                70.01857
                            ],
                            [
                                27.66927,
                                70.07723
                            ],
                            [
                                27.96056,
                                70.08996
                            ],
                            [
                                27.98464,
                                70.01432
                            ],
                            [
                                28.16107,
                                69.9211
                            ],
                            [
                                28.34536,
                                69.88079
                            ],
                            [
                                28.40418,
                                69.81865
                            ],
                            [
                                29.13254,
                                69.69557
                            ],
                            [
                                29.33593,
                                69.47765
                            ],
                            [
                                29.22032,
                                69.39803
                            ],
                            [
                                28.83217,
                                69.22409
                            ],
                            [
                                28.80628,
                                69.11107
                            ],
                            [
                                28.92968,
                                69.0519
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                15.75665,
                                68.95628
                            ],
                            [
                                15.64251,
                                68.9539
                            ],
                            [
                                15.59505,
                                68.83974
                            ],
                            [
                                15.46183,
                                68.81213
                            ],
                            [
                                15.43868,
                                68.70861
                            ],
                            [
                                15.5063,
                                68.6444
                            ],
                            [
                                15.19087,
                                68.5319
                            ],
                            [
                                15.22855,
                                68.4699
                            ],
                            [
                                15.04441,
                                68.33956
                            ],
                            [
                                15.25477,
                                68.36857
                            ],
                            [
                                15.66154,
                                68.31375
                            ],
                            [
                                15.72438,
                                68.38244
                            ],
                            [
                                15.87437,
                                68.38218
                            ],
                            [
                                16.24099,
                                68.56394
                            ],
                            [
                                16.50848,
                                68.56546
                            ],
                            [
                                16.59384,
                                68.65304
                            ],
                            [
                                16.59745,
                                68.78862
                            ],
                            [
                                16.30146,
                                68.89128
                            ],
                            [
                                16.00659,
                                68.7817
                            ],
                            [
                                15.88704,
                                68.79188
                            ],
                            [
                                15.95779,
                                68.88901
                            ],
                            [
                                15.90486,
                                68.96487
                            ],
                            [
                                15.75665,
                                68.95628
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                17.67654,
                                69.48306
                            ],
                            [
                                17.49145,
                                69.49763
                            ],
                            [
                                17.28697,
                                69.48383
                            ],
                            [
                                17.17,
                                69.41567
                            ],
                            [
                                16.99096,
                                69.39304
                            ],
                            [
                                17.03785,
                                69.33087
                            ],
                            [
                                16.90859,
                                69.23579
                            ],
                            [
                                17.02966,
                                69.13737
                            ],
                            [
                                16.81507,
                                69.12198
                            ],
                            [
                                17.08327,
                                69.0075
                            ],
                            [
                                17.40239,
                                69.1587
                            ],
                            [
                                17.65187,
                                69.15189
                            ],
                            [
                                17.9584,
                                69.17709
                            ],
                            [
                                17.94161,
                                69.27353
                            ],
                            [
                                17.87736,
                                69.31679
                            ],
                            [
                                18.07819,
                                69.35129
                            ],
                            [
                                18.06414,
                                69.48981
                            ],
                            [
                                17.88919,
                                69.57381
                            ],
                            [
                                17.75766,
                                69.54306
                            ],
                            [
                                17.67654,
                                69.48306
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                23.38238,
                                70.8295
                            ],
                            [
                                23.10949,
                                70.75351
                            ],
                            [
                                23.0286,
                                70.69868
                            ],
                            [
                                22.75941,
                                70.76608
                            ],
                            [
                                22.6826,
                                70.74123
                            ],
                            [
                                22.81373,
                                70.64825
                            ],
                            [
                                22.55518,
                                70.65653
                            ],
                            [
                                22.54054,
                                70.71788
                            ],
                            [
                                22.17038,
                                70.61045
                            ],
                            [
                                22.25653,
                                70.55672
                            ],
                            [
                                22.12112,
                                70.48622
                            ],
                            [
                                22.45118,
                                70.48963
                            ],
                            [
                                22.82962,
                                70.51642
                            ],
                            [
                                23.06275,
                                70.57094
                            ],
                            [
                                23.24906,
                                70.69602
                            ],
                            [
                                23.39683,
                                70.73909
                            ],
                            [
                                23.38238,
                                70.8295
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                15.18129,
                                68.98536
                            ],
                            [
                                15.00853,
                                68.94478
                            ],
                            [
                                15.08891,
                                68.88754
                            ],
                            [
                                14.9251,
                                68.79903
                            ],
                            [
                                14.68659,
                                68.76529
                            ],
                            [
                                14.54624,
                                68.80784
                            ],
                            [
                                14.37855,
                                68.68944
                            ],
                            [
                                14.42781,
                                68.62171
                            ],
                            [
                                14.81563,
                                68.64327
                            ],
                            [
                                14.86312,
                                68.5867
                            ],
                            [
                                15.03577,
                                68.57852
                            ],
                            [
                                15.37286,
                                68.66604
                            ],
                            [
                                15.40394,
                                68.73229
                            ],
                            [
                                15.29894,
                                68.76189
                            ],
                            [
                                15.39166,
                                68.84277
                            ],
                            [
                                15.17783,
                                68.93046
                            ],
                            [
                                15.18129,
                                68.98536
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                18.82483,
                                69.854
                            ],
                            [
                                18.48092,
                                69.769
                            ],
                            [
                                18.30353,
                                69.77046
                            ],
                            [
                                18.3412,
                                69.68852
                            ],
                            [
                                18.26199,
                                69.63109
                            ],
                            [
                                18.06076,
                                69.62043
                            ],
                            [
                                18.01214,
                                69.58243
                            ],
                            [
                                18.20547,
                                69.5203
                            ],
                            [
                                18.73044,
                                69.55794
                            ],
                            [
                                18.79511,
                                69.58151
                            ],
                            [
                                18.78288,
                                69.68067
                            ],
                            [
                                18.92499,
                                69.70267
                            ],
                            [
                                19.05346,
                                69.77322
                            ],
                            [
                                18.99343,
                                69.81941
                            ],
                            [
                                18.82483,
                                69.854
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                19.2031,
                                70.06963
                            ],
                            [
                                19.0987,
                                70.07955
                            ],
                            [
                                18.96598,
                                70.02351
                            ],
                            [
                                18.81343,
                                70.01044
                            ],
                            [
                                18.81959,
                                69.94734
                            ],
                            [
                                18.70642,
                                69.92266
                            ],
                            [
                                18.99001,
                                69.84222
                            ],
                            [
                                19.06804,
                                69.79156
                            ],
                            [
                                19.34517,
                                69.82369
                            ],
                            [
                                19.48285,
                                69.90847
                            ],
                            [
                                19.67296,
                                69.99666
                            ],
                            [
                                19.45248,
                                70.05123
                            ],
                            [
                                19.34551,
                                69.99427
                            ],
                            [
                                19.2031,
                                70.06963
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                23.42637,
                                70.62447
                            ],
                            [
                                23.46179,
                                70.56363
                            ],
                            [
                                23.12363,
                                70.53566
                            ],
                            [
                                22.86581,
                                70.44247
                            ],
                            [
                                22.89368,
                                70.36286
                            ],
                            [
                                23.14197,
                                70.27316
                            ],
                            [
                                23.3213,
                                70.30233
                            ],
                            [
                                23.63782,
                                70.43943
                            ],
                            [
                                23.53099,
                                70.52341
                            ],
                            [
                                23.58457,
                                70.58328
                            ],
                            [
                                23.42637,
                                70.62447
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                15.19039,
                                68.47271
                            ],
                            [
                                14.8117,
                                68.43421
                            ],
                            [
                                14.6057,
                                68.43488
                            ],
                            [
                                14.41627,
                                68.39175
                            ],
                            [
                                14.31124,
                                68.31839
                            ],
                            [
                                14.23044,
                                68.16913
                            ],
                            [
                                14.66696,
                                68.23935
                            ],
                            [
                                15.05252,
                                68.37429
                            ],
                            [
                                15.19039,
                                68.47271
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                16.16322,
                                69.29057
                            ],
                            [
                                16.10609,
                                69.31422
                            ],
                            [
                                15.89553,
                                69.26352
                            ],
                            [
                                15.74842,
                                69.14324
                            ],
                            [
                                15.56746,
                                69.10455
                            ],
                            [
                                15.42686,
                                68.97693
                            ],
                            [
                                15.60051,
                                68.97977
                            ],
                            [
                                15.87187,
                                69.02709
                            ],
                            [
                                15.91803,
                                69.08118
                            ],
                            [
                                16.08696,
                                69.15423
                            ],
                            [
                                16.16322,
                                69.29057
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.83403,
                                63.65847
                            ],
                            [
                                8.66903,
                                63.63905
                            ],
                            [
                                8.30697,
                                63.49347
                            ],
                            [
                                8.38994,
                                63.42798
                            ],
                            [
                                8.53463,
                                63.42847
                            ],
                            [
                                8.61213,
                                63.45845
                            ],
                            [
                                8.84651,
                                63.47634
                            ],
                            [
                                9.07572,
                                63.51511
                            ],
                            [
                                9.19334,
                                63.55742
                            ],
                            [
                                9.02193,
                                63.5987
                            ],
                            [
                                8.94564,
                                63.65298
                            ],
                            [
                                8.83403,
                                63.65847
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                25.68367,
                                71.15164
                            ],
                            [
                                25.26298,
                                71.06251
                            ],
                            [
                                25.55621,
                                70.9329
                            ],
                            [
                                25.71025,
                                70.97507
                            ],
                            [
                                25.90707,
                                70.96773
                            ],
                            [
                                26.11557,
                                70.99241
                            ],
                            [
                                25.84306,
                                71.07158
                            ],
                            [
                                25.68367,
                                71.15164
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                13.96194,
                                68.34465
                            ],
                            [
                                13.82253,
                                68.28797
                            ],
                            [
                                13.65487,
                                68.30803
                            ],
                            [
                                13.52611,
                                68.19804
                            ],
                            [
                                13.46524,
                                68.08181
                            ],
                            [
                                13.72751,
                                68.08916
                            ],
                            [
                                13.85863,
                                68.12952
                            ],
                            [
                                13.84363,
                                68.17013
                            ],
                            [
                                14.03544,
                                68.19278
                            ],
                            [
                                14.16499,
                                68.25962
                            ],
                            [
                                13.96194,
                                68.34465
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                23.72934,
                                70.74675
                            ],
                            [
                                23.62501,
                                70.69941
                            ],
                            [
                                23.73441,
                                70.52444
                            ],
                            [
                                23.89296,
                                70.50606
                            ],
                            [
                                24.12719,
                                70.6013
                            ],
                            [
                                23.98957,
                                70.70204
                            ],
                            [
                                23.72934,
                                70.74675
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                20.74321,
                                70.23053
                            ],
                            [
                                20.53983,
                                70.22382
                            ],
                            [
                                20.41146,
                                70.17704
                            ],
                            [
                                20.36707,
                                70.08401
                            ],
                            [
                                20.56379,
                                70.03229
                            ],
                            [
                                20.78947,
                                70.05139
                            ],
                            [
                                20.74837,
                                70.09834
                            ],
                            [
                                20.80815,
                                70.18596
                            ],
                            [
                                20.74321,
                                70.23053
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                22.71277,
                                70.35397
                            ],
                            [
                                22.55522,
                                70.38246
                            ],
                            [
                                22.34491,
                                70.34306
                            ],
                            [
                                22.39859,
                                70.29656
                            ],
                            [
                                22.74369,
                                70.24681
                            ],
                            [
                                23.00725,
                                70.26242
                            ],
                            [
                                22.86901,
                                70.34062
                            ],
                            [
                                22.71277,
                                70.35397
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                5.67462,
                                60.68743
                            ],
                            [
                                5.58583,
                                60.62169
                            ],
                            [
                                5.50856,
                                60.60941
                            ],
                            [
                                5.36062,
                                60.52504
                            ],
                            [
                                5.53463,
                                60.43012
                            ],
                            [
                                5.71028,
                                60.48512
                            ],
                            [
                                5.73305,
                                60.67322
                            ],
                            [
                                5.67462,
                                60.68743
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                19.64519,
                                70.28167
                            ],
                            [
                                19.50388,
                                70.23249
                            ],
                            [
                                19.70073,
                                70.12927
                            ],
                            [
                                19.70928,
                                70.0706
                            ],
                            [
                                19.88632,
                                70.04722
                            ],
                            [
                                19.99695,
                                70.0844
                            ],
                            [
                                19.83238,
                                70.20848
                            ],
                            [
                                19.64519,
                                70.28167
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                7.99594,
                                63.46506
                            ],
                            [
                                7.80943,
                                63.41712
                            ],
                            [
                                7.78559,
                                63.36191
                            ],
                            [
                                7.86602,
                                63.33013
                            ],
                            [
                                8.06685,
                                63.33066
                            ],
                            [
                                8.20542,
                                63.37119
                            ],
                            [
                                8.1031,
                                63.46669
                            ],
                            [
                                7.99594,
                                63.46506
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                11.11883,
                                64.97765
                            ],
                            [
                                11.08027,
                                64.98588
                            ],
                            [
                                10.74704,
                                64.89062
                            ],
                            [
                                10.74397,
                                64.85198
                            ],
                            [
                                11.0428,
                                64.89177
                            ],
                            [
                                11.143,
                                64.82636
                            ],
                            [
                                11.2923,
                                64.89277
                            ],
                            [
                                11.11883,
                                64.97765
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                16.41198,
                                68.54326
                            ],
                            [
                                16.2319,
                                68.54301
                            ],
                            [
                                16.14923,
                                68.49458
                            ],
                            [
                                16.10085,
                                68.40037
                            ],
                            [
                                16.41339,
                                68.422
                            ],
                            [
                                16.5081,
                                68.46643
                            ],
                            [
                                16.41198,
                                68.54326
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                13.13697,
                                68.09922
                            ],
                            [
                                13.04848,
                                68.07439
                            ],
                            [
                                12.84934,
                                67.9005
                            ],
                            [
                                13.03841,
                                67.88771
                            ],
                            [
                                13.18547,
                                67.97694
                            ],
                            [
                                13.13697,
                                68.09922
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                5.32735,
                                59.9684
                            ],
                            [
                                5.28658,
                                59.87227
                            ],
                            [
                                5.33738,
                                59.78579
                            ],
                            [
                                5.45368,
                                59.74732
                            ],
                            [
                                5.53923,
                                59.78903
                            ],
                            [
                                5.52413,
                                59.88421
                            ],
                            [
                                5.45088,
                                59.93743
                            ],
                            [
                                5.32735,
                                59.9684
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                19.71904,
                                69.85506
                            ],
                            [
                                19.88071,
                                69.97522
                            ],
                            [
                                19.77405,
                                70.00674
                            ],
                            [
                                19.6222,
                                69.93804
                            ],
                            [
                                19.52279,
                                69.91941
                            ],
                            [
                                19.4075,
                                69.84155
                            ],
                            [
                                19.71904,
                                69.85506
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                5.70425,
                                60.05415
                            ],
                            [
                                5.56316,
                                60.07815
                            ],
                            [
                                5.3801,
                                59.98755
                            ],
                            [
                                5.54086,
                                59.89503
                            ],
                            [
                                5.69869,
                                59.99604
                            ],
                            [
                                5.70425,
                                60.05415
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                5.20775,
                                59.85813
                            ],
                            [
                                5.11337,
                                59.7865
                            ],
                            [
                                5.17654,
                                59.75317
                            ],
                            [
                                5.15441,
                                59.65275
                            ],
                            [
                                5.32331,
                                59.73401
                            ],
                            [
                                5.31418,
                                59.78802
                            ],
                            [
                                5.20775,
                                59.85813
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                5.08883,
                                60.3582
                            ],
                            [
                                4.94885,
                                60.28552
                            ],
                            [
                                4.99932,
                                60.21178
                            ],
                            [
                                5.13083,
                                60.17966
                            ],
                            [
                                5.08883,
                                60.3582
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.76415,
                                63.78676
                            ],
                            [
                                8.48299,
                                63.66465
                            ],
                            [
                                8.83071,
                                63.7014
                            ],
                            [
                                8.76415,
                                63.78676
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                5.95695,
                                62.42443
                            ],
                            [
                                5.81712,
                                62.37348
                            ],
                            [
                                5.83502,
                                62.30028
                            ],
                            [
                                5.91016,
                                62.25223
                            ],
                            [
                                6.07996,
                                62.33917
                            ],
                            [
                                5.95695,
                                62.42443
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                17.27592,
                                68.92606
                            ],
                            [
                                17.10012,
                                68.90897
                            ],
                            [
                                17.18522,
                                68.80603
                            ],
                            [
                                17.25575,
                                68.79665
                            ],
                            [
                                17.48542,
                                68.87612
                            ],
                            [
                                17.27592,
                                68.92606
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.89906,
                                66.01883
                            ],
                            [
                                12.60741,
                                66.01915
                            ],
                            [
                                12.46272,
                                65.95872
                            ],
                            [
                                12.53706,
                                65.89796
                            ],
                            [
                                12.89906,
                                66.01883
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                29.84697,
                                69.90789
                            ],
                            [
                                29.79602,
                                69.81376
                            ],
                            [
                                29.8509,
                                69.76042
                            ],
                            [
                                30.07672,
                                69.81148
                            ],
                            [
                                29.94186,
                                69.90126
                            ],
                            [
                                29.84697,
                                69.90789
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                7.65929,
                                63.09932
                            ],
                            [
                                7.57018,
                                63.04835
                            ],
                            [
                                7.4661,
                                63.05638
                            ],
                            [
                                7.3715,
                                62.97517
                            ],
                            [
                                7.53658,
                                62.94193
                            ],
                            [
                                7.69068,
                                62.98678
                            ],
                            [
                                7.65929,
                                63.09932
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                5.28448,
                                59.35741
                            ],
                            [
                                5.17162,
                                59.22806
                            ],
                            [
                                5.19577,
                                59.14756
                            ],
                            [
                                5.31048,
                                59.16812
                            ],
                            [
                                5.32879,
                                59.27034
                            ],
                            [
                                5.28448,
                                59.35741
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.60669,
                                66.21704
                            ],
                            [
                                12.46585,
                                66.10953
                            ],
                            [
                                12.64303,
                                66.09299
                            ],
                            [
                                12.60669,
                                66.21704
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                11.13823,
                                64.63479
                            ],
                            [
                                11.10625,
                                64.58526
                            ],
                            [
                                11.19591,
                                64.50666
                            ],
                            [
                                11.39033,
                                64.48593
                            ],
                            [
                                11.45209,
                                64.52279
                            ],
                            [
                                11.13823,
                                64.63479
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                5.08565,
                                61.87796
                            ],
                            [
                                4.95249,
                                61.90865
                            ],
                            [
                                4.88602,
                                61.84707
                            ],
                            [
                                4.93037,
                                61.78284
                            ],
                            [
                                5.25237,
                                61.86348
                            ],
                            [
                                5.08565,
                                61.87796
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.47956,
                                63.25698
                            ],
                            [
                                8.33118,
                                63.25535
                            ],
                            [
                                8.26669,
                                63.21557
                            ],
                            [
                                8.34673,
                                63.16519
                            ],
                            [
                                8.56904,
                                63.17762
                            ],
                            [
                                8.47956,
                                63.25698
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                16.35763,
                                68.98638
                            ],
                            [
                                16.34979,
                                68.93722
                            ],
                            [
                                16.56615,
                                68.87573
                            ],
                            [
                                16.62917,
                                68.93862
                            ],
                            [
                                16.35763,
                                68.98638
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                5.73274,
                                62.28601
                            ],
                            [
                                5.57251,
                                62.2947
                            ],
                            [
                                5.5331,
                                62.22494
                            ],
                            [
                                5.60701,
                                62.18781
                            ],
                            [
                                5.76129,
                                62.20421
                            ],
                            [
                                5.82978,
                                62.27466
                            ],
                            [
                                5.73274,
                                62.28601
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.02274,
                                65.70551
                            ],
                            [
                                11.82511,
                                65.69308
                            ],
                            [
                                11.74556,
                                65.61185
                            ],
                            [
                                11.89781,
                                65.60234
                            ],
                            [
                                12.02521,
                                65.66047
                            ],
                            [
                                12.02274,
                                65.70551
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                17.04093,
                                68.86273
                            ],
                            [
                                16.84628,
                                68.72607
                            ],
                            [
                                17.11629,
                                68.74896
                            ],
                            [
                                17.18388,
                                68.78185
                            ],
                            [
                                17.04093,
                                68.86273
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                13.40407,
                                68.06663
                            ],
                            [
                                13.45207,
                                68.14627
                            ],
                            [
                                13.32541,
                                68.16835
                            ],
                            [
                                13.19824,
                                68.0753
                            ],
                            [
                                13.26117,
                                68.00145
                            ],
                            [
                                13.40407,
                                68.06663
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.74365,
                                68.57721
                            ],
                            [
                                14.61622,
                                68.55243
                            ],
                            [
                                14.73563,
                                68.49486
                            ],
                            [
                                14.89958,
                                68.5001
                            ],
                            [
                                14.99787,
                                68.55425
                            ],
                            [
                                14.74365,
                                68.57721
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                24.0619,
                                71.0199
                            ],
                            [
                                23.89543,
                                70.96144
                            ],
                            [
                                24.0138,
                                70.91518
                            ],
                            [
                                24.19337,
                                70.94214
                            ],
                            [
                                24.0619,
                                71.0199
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.24195,
                                67.117
                            ],
                            [
                                14.06797,
                                67.1619
                            ],
                            [
                                14.01829,
                                67.10767
                            ],
                            [
                                14.21992,
                                67.0178
                            ],
                            [
                                14.24195,
                                67.117
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                20.94058,
                                69.97894
                            ],
                            [
                                20.84333,
                                70.0325
                            ],
                            [
                                20.71438,
                                70.00473
                            ],
                            [
                                20.78487,
                                69.9342
                            ],
                            [
                                20.94058,
                                69.97894
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                19.21651,
                                70.25009
                            ],
                            [
                                18.97991,
                                70.15326
                            ],
                            [
                                19.11676,
                                70.11029
                            ],
                            [
                                19.22681,
                                70.13293
                            ],
                            [
                                19.21651,
                                70.25009
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                4.94801,
                                61.13597
                            ],
                            [
                                4.82466,
                                61.14532
                            ],
                            [
                                4.83498,
                                61.07197
                            ],
                            [
                                4.92008,
                                61.0716
                            ],
                            [
                                4.94801,
                                61.13597
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                18.77568,
                                70.10612
                            ],
                            [
                                18.65389,
                                70.03184
                            ],
                            [
                                18.69068,
                                69.98908
                            ],
                            [
                                18.97255,
                                70.08415
                            ],
                            [
                                18.77568,
                                70.10612
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                20.71703,
                                69.89449
                            ],
                            [
                                20.58809,
                                69.90677
                            ],
                            [
                                20.51664,
                                69.83355
                            ],
                            [
                                20.73375,
                                69.83054
                            ],
                            [
                                20.71703,
                                69.89449
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                4.92385,
                                60.73645
                            ],
                            [
                                4.88549,
                                60.69935
                            ],
                            [
                                5.10004,
                                60.60762
                            ],
                            [
                                5.18349,
                                60.61727
                            ],
                            [
                                5.00461,
                                60.72258
                            ],
                            [
                                4.92385,
                                60.73645
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.02456,
                                65.14969
                            ],
                            [
                                11.95155,
                                65.15342
                            ],
                            [
                                11.74988,
                                65.04159
                            ],
                            [
                                11.84712,
                                65.03709
                            ],
                            [
                                12.00858,
                                65.10081
                            ],
                            [
                                12.02456,
                                65.14969
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.17467,
                                63.18367
                            ],
                            [
                                8.13568,
                                63.22976
                            ],
                            [
                                7.94896,
                                63.19349
                            ],
                            [
                                7.95628,
                                63.1461
                            ],
                            [
                                8.17467,
                                63.18367
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                5.03474,
                                60.52911
                            ],
                            [
                                5.14405,
                                60.42431
                            ],
                            [
                                5.21934,
                                60.48696
                            ],
                            [
                                5.03474,
                                60.52911
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                15.12473,
                                67.99352
                            ],
                            [
                                14.98991,
                                67.97383
                            ],
                            [
                                14.97686,
                                67.91766
                            ],
                            [
                                15.25334,
                                67.91698
                            ],
                            [
                                15.12473,
                                67.99352
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                7.88613,
                                63.10022
                            ],
                            [
                                7.72024,
                                63.08499
                            ],
                            [
                                7.8107,
                                63.02357
                            ],
                            [
                                7.88613,
                                63.10022
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "PSE",
                "Country": "Palestine",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    -0.000000000946,
                    -0.0000000020515,
                    -0.0000000033,
                    -0.0000000046805,
                    -0.0000000061985,
                    -0.0000000078375,
                    -0.000000009603,
                    -0.0000000115,
                    -0.000000013519,
                    -0.000000015966,
                    -0.000000018799,
                    -0.000000022017,
                    -0.000000025597,
                    -0.000000029535,
                    -0.000000033809,
                    -0.000000038417,
                    -0.00000004334,
                    -0.000000048559,
                    -0.000000054065,
                    -0.000000059763,
                    -0.000000065697,
                    -0.000000071874,
                    -0.000000078292,
                    -0.000000084942,
                    -0.000000091811,
                    -0.000000098895,
                    -0.00000010618,
                    -0.00000011367,
                    -0.00000012134,
                    -0.00000012899,
                    -0.00000013671,
                    -0.00000014451,
                    -0.00000015243,
                    -0.00000016046,
                    -0.0000001686,
                    -0.00000017686,
                    -0.00000018524,
                    -0.00000019373,
                    -0.00000020234,
                    -0.00000021145,
                    -0.00000022094,
                    -0.00000023074,
                    -0.00000024081,
                    -0.00000025114,
                    -0.0000002617,
                    -0.00000027246,
                    -0.00000028342,
                    -0.00000029456,
                    -0.00000030587,
                    -0.00000031694,
                    -0.00000032785,
                    -0.00000033879,
                    -0.00000034945,
                    -0.00000036048,
                    -0.00000037149,
                    -0.00000038255,
                    -0.00000039366,
                    -0.00000040484,
                    -0.00000041615,
                    -0.00000042385,
                    -0.00000042969,
                    -0.00000043392,
                    -0.00000043695,
                    -0.00000043906,
                    -0.00000044022,
                    -0.00000044108,
                    -0.00000044118,
                    -0.00000044079,
                    -0.00000043992,
                    -0.00000043867,
                    -0.00000043683,
                    -0.00000043454,
                    -0.00000043169,
                    -0.00000042848,
                    -0.00000042462,
                    -0.00000042057,
                    -0.00000041623,
                    -0.00000041163,
                    -0.00000040679,
                    -0.00000040127,
                    -0.00000039549,
                    -0.00000038895,
                    -0.00000038205,
                    -0.00000037555,
                    -0.00000036878,
                    -0.00000036196,
                    -0.0000003551,
                    -0.00000034857,
                    -0.00000034201,
                    -0.00000033643,
                    -0.00000033145,
                    -0.0000003268,
                    -0.00000032255,
                    -0.00000031901,
                    -0.0000003154,
                    -0.00000031191,
                    -0.00000030884,
                    -0.00000030644,
                    -0.00000030471,
                    -0.00000028393,
                    -0.00000023785,
                    -0.00000019743,
                    -0.00000015788,
                    -0.00000012162,
                    -0.000000091685,
                    -0.000000067633,
                    -0.000000044385,
                    -0.000000025647,
                    -0.000000013343,
                    8.2775e-09,
                    9.625e-09,
                    2.4778e-08,
                    3.1003e-08,
                    2.5696e-08,
                    3.0679e-08,
                    2.9073e-08,
                    2.2781e-08,
                    1.4888e-08,
                    1.1941e-08,
                    1.2281e-08,
                    1.2293e-08,
                    2.3848e-08,
                    3.6426e-08,
                    3.7719e-08,
                    3.7884e-08,
                    4.086e-08,
                    4.4187e-08,
                    4.9297e-08,
                    5.2993e-08,
                    5.9928e-08,
                    6.9113e-08,
                    7.3079e-08,
                    7.8177e-08,
                    9.6838e-08,
                    1.1463e-07,
                    1.2992e-07,
                    1.4134e-07,
                    1.437e-07,
                    1.3775e-07,
                    1.2868e-07,
                    1.4313e-07,
                    1.4955e-07,
                    1.4485e-07,
                    1.3997e-07,
                    1.236e-07,
                    1.0867e-07,
                    9.4276e-08,
                    9.7592e-08,
                    1.0605e-07,
                    1.2313e-07,
                    1.1776e-07,
                    6.8497e-08,
                    1.8722e-08,
                    -0.000000030684,
                    -0.00000007595,
                    -0.0000001183,
                    -0.00000015626,
                    -0.00000017368,
                    -0.00000020203,
                    -0.00000022677,
                    -0.00000023558,
                    -0.00000023515,
                    -0.00000023695,
                    -0.00000022758,
                    -0.00000022978,
                    -0.00000015459,
                    -0.000000092658,
                    -0.000000059922,
                    -0.000000027033,
                    -0.0000000072215,
                    2.9722e-08,
                    5.6469e-08
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [
                    -0.000000000946,
                    -0.0000000020515,
                    -0.0000000033,
                    -0.0000000046805,
                    -0.0000000061985,
                    -0.0000000078375,
                    -0.000000009603,
                    -0.0000000115,
                    -0.000000013519,
                    -0.000000015966,
                    -0.000000018799,
                    -0.000000022017,
                    -0.000000025597,
                    -0.000000029535,
                    -0.000000033809,
                    -0.000000038417,
                    -0.00000004334,
                    -0.000000048559,
                    -0.000000054065,
                    -0.000000059763,
                    -0.000000065697,
                    -0.000000071874,
                    -0.000000078292,
                    -0.000000084942,
                    -0.000000091811,
                    -0.000000098895,
                    -0.00000010618,
                    -0.00000011367,
                    -0.00000012134,
                    -0.00000012899,
                    -0.00000013671,
                    -0.00000014451,
                    -0.00000015243,
                    -0.00000016046,
                    -0.0000001686,
                    -0.00000017686,
                    -0.00000018524,
                    -0.00000019373,
                    -0.00000020234,
                    -0.00000021145,
                    -0.00000022094,
                    -0.00000023074,
                    -0.00000024081,
                    -0.00000025114,
                    -0.0000002617,
                    -0.00000027246,
                    -0.00000028342,
                    -0.00000029456,
                    -0.00000030587,
                    -0.00000031694,
                    -0.00000032785,
                    -0.00000033879,
                    -0.00000034945,
                    -0.00000036048,
                    -0.00000037149,
                    -0.00000038255,
                    -0.00000039366,
                    -0.00000040484,
                    -0.00000041615,
                    -0.00000042385,
                    -0.00000042969,
                    -0.00000043392,
                    -0.00000043695,
                    -0.00000043906,
                    -0.00000044022,
                    -0.00000044108,
                    -0.00000044118,
                    -0.00000044079,
                    -0.00000043992,
                    -0.00000043867,
                    -0.00000043683,
                    -0.00000043454,
                    -0.00000043169,
                    -0.00000042848,
                    -0.00000042462,
                    -0.00000042057,
                    -0.00000041623,
                    -0.00000041163,
                    -0.00000040679,
                    -0.00000040127,
                    -0.00000039549,
                    -0.00000038895,
                    -0.00000038205,
                    -0.00000037555,
                    -0.00000036878,
                    -0.00000036196,
                    -0.0000003551,
                    -0.00000034857,
                    -0.00000034201,
                    -0.00000033643,
                    -0.00000033145,
                    -0.0000003268,
                    -0.00000032255,
                    -0.00000031901,
                    -0.0000003154,
                    -0.00000031191,
                    -0.00000030884,
                    -0.00000030644,
                    -0.00000030471,
                    -0.00000028393,
                    -0.00000023785,
                    -0.00000019743,
                    -0.00000015788,
                    -0.00000012162,
                    -0.000000091685,
                    -0.000000067633,
                    -0.000000044385,
                    -0.000000025647,
                    -0.000000013343,
                    8.2775e-09,
                    9.625e-09,
                    2.4778e-08,
                    3.1003e-08,
                    2.5696e-08,
                    3.0679e-08,
                    2.9073e-08,
                    2.2781e-08,
                    1.4888e-08,
                    1.1941e-08,
                    1.2281e-08,
                    1.2293e-08,
                    2.3848e-08,
                    3.6426e-08,
                    3.7719e-08,
                    3.7884e-08,
                    4.086e-08,
                    4.4187e-08,
                    4.9297e-08,
                    5.2993e-08,
                    5.9928e-08,
                    6.9113e-08,
                    7.3079e-08,
                    7.8177e-08,
                    9.6838e-08,
                    1.1463e-07,
                    1.2992e-07,
                    1.4134e-07,
                    1.437e-07,
                    1.3775e-07,
                    1.2868e-07,
                    1.4313e-07,
                    1.4955e-07,
                    1.4485e-07,
                    1.3997e-07,
                    1.236e-07,
                    1.0867e-07,
                    9.4276e-08,
                    9.7592e-08,
                    1.0605e-07,
                    1.2313e-07,
                    1.1776e-07,
                    6.8497e-08,
                    1.8722e-08,
                    -0.000000030684,
                    -0.00000007595,
                    -0.0000001183,
                    -0.00000015626,
                    -0.00000017368,
                    -0.00000020203,
                    -0.00000022677,
                    -0.00000023558,
                    -0.00000023515,
                    -0.00000023695,
                    -0.00000022758,
                    -0.00000022978,
                    -0.00000015459,
                    -0.000000092658,
                    -0.000000059922,
                    -0.000000027033,
                    -0.0000000072215,
                    2.9722e-08,
                    5.6469e-08
                ],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    -0.000000000946,
                    -0.0000000020515,
                    -0.0000000033,
                    -0.0000000046805,
                    -0.0000000061985,
                    -0.0000000078375,
                    -0.000000009603,
                    -0.0000000115,
                    -0.000000013519,
                    -0.000000015966,
                    -0.000000018799,
                    -0.000000022017,
                    -0.000000025597,
                    -0.000000029535,
                    -0.000000033809,
                    -0.000000038417,
                    -0.00000004334,
                    -0.000000048559,
                    -0.000000054065,
                    -0.000000059763,
                    -0.000000065697,
                    -0.000000071874,
                    -0.000000078292,
                    -0.000000084942,
                    -0.000000091811,
                    -0.000000098895,
                    -0.00000010618,
                    -0.00000011367,
                    -0.00000012134,
                    -0.00000012899,
                    -0.00000013671,
                    -0.00000014451,
                    -0.00000015243,
                    -0.00000016046,
                    -0.0000001686,
                    -0.00000017686,
                    -0.00000018524,
                    -0.00000019373,
                    -0.00000020234,
                    -0.00000021145,
                    -0.00000022094,
                    -0.00000023074,
                    -0.00000024081,
                    -0.00000025114,
                    -0.0000002617,
                    -0.00000027246,
                    -0.00000028342,
                    -0.00000029456,
                    -0.00000030587,
                    -0.00000031694,
                    -0.00000032785,
                    -0.00000033879,
                    -0.00000034945,
                    -0.00000036048,
                    -0.00000037149,
                    -0.00000038255,
                    -0.00000039366,
                    -0.00000040484,
                    -0.00000041615,
                    -0.00000042385,
                    -0.00000042969,
                    -0.00000043392,
                    -0.00000043695,
                    -0.00000043906,
                    -0.00000044022,
                    -0.00000044108,
                    -0.00000044118,
                    -0.00000044079,
                    -0.00000043992,
                    -0.00000043867,
                    -0.00000043683,
                    -0.00000043454,
                    -0.00000043169,
                    -0.00000042848,
                    -0.00000042462,
                    -0.00000042057,
                    -0.00000041623,
                    -0.00000041163,
                    -0.00000040679,
                    -0.00000040127,
                    -0.00000039549,
                    -0.00000038895,
                    -0.00000038205,
                    -0.00000037555,
                    -0.00000036878,
                    -0.00000036196,
                    -0.0000003551,
                    -0.00000034857,
                    -0.00000034201,
                    -0.00000033643,
                    -0.00000033145,
                    -0.0000003268,
                    -0.00000032255,
                    -0.00000031901,
                    -0.0000003154,
                    -0.00000031191,
                    -0.00000030884,
                    -0.00000030644,
                    -0.00000030471,
                    -0.00000028393,
                    -0.00000023785,
                    -0.00000019743,
                    -0.00000015788,
                    -0.00000012162,
                    -0.000000091685,
                    -0.000000067633,
                    -0.000000044385,
                    -0.000000025647,
                    -0.000000013343,
                    8.2775e-09,
                    9.625e-09,
                    2.4778e-08,
                    3.1003e-08,
                    2.5696e-08,
                    3.0679e-08,
                    2.9073e-08,
                    2.2781e-08,
                    1.4888e-08,
                    1.1941e-08,
                    1.2281e-08,
                    1.2293e-08,
                    2.3848e-08,
                    3.6426e-08,
                    3.7719e-08,
                    3.7884e-08,
                    4.086e-08,
                    4.4187e-08,
                    4.9297e-08,
                    5.2993e-08,
                    5.9928e-08,
                    6.9113e-08,
                    7.3079e-08,
                    7.8177e-08,
                    9.6838e-08,
                    1.1463e-07,
                    1.2992e-07,
                    1.4134e-07,
                    1.437e-07,
                    1.3775e-07,
                    1.2868e-07,
                    1.4313e-07,
                    1.4955e-07,
                    1.4485e-07,
                    1.3997e-07,
                    1.236e-07,
                    1.0867e-07,
                    9.4276e-08,
                    9.7592e-08,
                    1.0605e-07,
                    1.2313e-07,
                    1.1776e-07,
                    6.8497e-08,
                    1.8722e-08,
                    -0.000000030684,
                    -0.00000007595,
                    -0.0000001183,
                    -0.00000015626,
                    -0.00000017368,
                    -0.00000020203,
                    -0.00000022677,
                    -0.00000023558,
                    -0.00000023515,
                    -0.00000023695,
                    -0.00000022758,
                    -0.00000022978,
                    -0.00000015459,
                    -0.000000092658,
                    -0.000000059922,
                    -0.000000027033,
                    -0.0000000072215,
                    2.9722e-08,
                    5.6469e-08
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [
                    -0.000000000946,
                    -0.0000000020515,
                    -0.0000000033,
                    -0.0000000046805,
                    -0.0000000061985,
                    -0.0000000078375,
                    -0.000000009603,
                    -0.0000000115,
                    -0.000000013519,
                    -0.000000015966,
                    -0.000000018799,
                    -0.000000022017,
                    -0.000000025597,
                    -0.000000029535,
                    -0.000000033809,
                    -0.000000038417,
                    -0.00000004334,
                    -0.000000048559,
                    -0.000000054065,
                    -0.000000059763,
                    -0.000000065697,
                    -0.000000071874,
                    -0.000000078292,
                    -0.000000084942,
                    -0.000000091811,
                    -0.000000098895,
                    -0.00000010618,
                    -0.00000011367,
                    -0.00000012134,
                    -0.00000012899,
                    -0.00000013671,
                    -0.00000014451,
                    -0.00000015243,
                    -0.00000016046,
                    -0.0000001686,
                    -0.00000017686,
                    -0.00000018524,
                    -0.00000019373,
                    -0.00000020234,
                    -0.00000021145,
                    -0.00000022094,
                    -0.00000023074,
                    -0.00000024081,
                    -0.00000025114,
                    -0.0000002617,
                    -0.00000027246,
                    -0.00000028342,
                    -0.00000029456,
                    -0.00000030587,
                    -0.00000031694,
                    -0.00000032785,
                    -0.00000033879,
                    -0.00000034945,
                    -0.00000036048,
                    -0.00000037149,
                    -0.00000038255,
                    -0.00000039366,
                    -0.00000040484,
                    -0.00000041615,
                    -0.00000042385,
                    -0.00000042969,
                    -0.00000043392,
                    -0.00000043695,
                    -0.00000043906,
                    -0.00000044022,
                    -0.00000044108,
                    -0.00000044118,
                    -0.00000044079,
                    -0.00000043992,
                    -0.00000043867,
                    -0.00000043683,
                    -0.00000043454,
                    -0.00000043169,
                    -0.00000042848,
                    -0.00000042462,
                    -0.00000042057,
                    -0.00000041623,
                    -0.00000041163,
                    -0.00000040679,
                    -0.00000040127,
                    -0.00000039549,
                    -0.00000038895,
                    -0.00000038205,
                    -0.00000037555,
                    -0.00000036878,
                    -0.00000036196,
                    -0.0000003551,
                    -0.00000034857,
                    -0.00000034201,
                    -0.00000033643,
                    -0.00000033145,
                    -0.0000003268,
                    -0.00000032255,
                    -0.00000031901,
                    -0.0000003154,
                    -0.00000031191,
                    -0.00000030884,
                    -0.00000030644,
                    -0.00000030471,
                    -0.00000028393,
                    -0.00000023785,
                    -0.00000019743,
                    -0.00000015788,
                    -0.00000012162,
                    -0.000000091685,
                    -0.000000067633,
                    -0.000000044385,
                    -0.000000025647,
                    -0.000000013343,
                    8.2775e-09,
                    9.625e-09,
                    2.4778e-08,
                    3.1003e-08,
                    2.5696e-08,
                    3.0679e-08,
                    2.9073e-08,
                    2.2781e-08,
                    1.4888e-08,
                    1.1941e-08,
                    1.2281e-08,
                    1.2293e-08,
                    2.3848e-08,
                    3.6426e-08,
                    3.7719e-08,
                    3.7884e-08,
                    4.086e-08,
                    4.4187e-08,
                    4.9297e-08,
                    5.2993e-08,
                    5.9928e-08,
                    6.9113e-08,
                    7.3079e-08,
                    7.8177e-08,
                    9.6838e-08,
                    1.1463e-07,
                    1.2992e-07,
                    1.4134e-07,
                    1.437e-07,
                    1.3775e-07,
                    1.2868e-07,
                    1.4313e-07,
                    1.4955e-07,
                    1.4485e-07,
                    1.3997e-07,
                    1.236e-07,
                    1.0867e-07,
                    9.4276e-08,
                    9.7592e-08,
                    1.0605e-07,
                    1.2313e-07,
                    1.1776e-07,
                    6.8497e-08,
                    1.8722e-08,
                    -0.000000030684,
                    -0.00000007595,
                    -0.0000001183,
                    -0.00000015626,
                    -0.00000017368,
                    -0.00000020203,
                    -0.00000022677,
                    -0.00000023558,
                    -0.00000023515,
                    -0.00000023695,
                    -0.00000022758,
                    -0.00000022978,
                    -0.00000015459,
                    -0.000000092658,
                    -0.000000059922,
                    -0.000000027033,
                    -0.0000000072215,
                    2.9722e-08,
                    5.6469e-08
                ],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": []
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                35.55512,
                                32.389
                            ],
                            [
                                35.41296,
                                32.43138
                            ],
                            [
                                35.4009,
                                32.50144
                            ],
                            [
                                35.25086,
                                32.5248
                            ],
                            [
                                35.22439,
                                32.55068
                            ],
                            [
                                35.06855,
                                32.45284
                            ],
                            [
                                35.01613,
                                32.33341
                            ],
                            [
                                35.01956,
                                32.23669
                            ],
                            [
                                34.961,
                                32.17567
                            ],
                            [
                                34.98819,
                                32.14412
                            ],
                            [
                                35.00307,
                                32.0268
                            ],
                            [
                                34.99258,
                                31.93338
                            ],
                            [
                                35.05001,
                                31.84411
                            ],
                            [
                                35.1655,
                                31.80506
                            ],
                            [
                                35.11894,
                                31.70956
                            ],
                            [
                                34.99979,
                                31.65019
                            ],
                            [
                                34.9577,
                                31.58968
                            ],
                            [
                                34.94637,
                                31.50372
                            ],
                            [
                                34.87955,
                                31.39774
                            ],
                            [
                                34.92841,
                                31.34551
                            ],
                            [
                                35.14635,
                                31.35821
                            ],
                            [
                                35.22778,
                                31.37521
                            ],
                            [
                                35.40134,
                                31.49375
                            ],
                            [
                                35.47596,
                                31.49051
                            ],
                            [
                                35.48965,
                                31.6188
                            ],
                            [
                                35.55833,
                                31.76142
                            ],
                            [
                                35.52487,
                                31.9063
                            ],
                            [
                                35.54789,
                                31.971
                            ],
                            [
                                35.51994,
                                32.04726
                            ],
                            [
                                35.54468,
                                32.0834
                            ],
                            [
                                35.57306,
                                32.21208
                            ],
                            [
                                35.55512,
                                32.389
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                34.26884,
                                31.22053
                            ],
                            [
                                34.37355,
                                31.30794
                            ],
                            [
                                34.38351,
                                31.39265
                            ],
                            [
                                34.56529,
                                31.54315
                            ],
                            [
                                34.49086,
                                31.59587
                            ],
                            [
                                34.33639,
                                31.42398
                            ],
                            [
                                34.2198,
                                31.32169
                            ],
                            [
                                34.26884,
                                31.22053
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "OMN",
                "Country": "Oman",
                "Total_3GHG": 0.13,
                "Total_3GHG_timeseries": [
                    5.162e-08,
                    1.0332e-07,
                    1.5511e-07,
                    2.0699e-07,
                    2.5896e-07,
                    3.1102e-07,
                    3.6318e-07,
                    4.1543e-07,
                    4.6776e-07,
                    5.2019e-07,
                    5.7271e-07,
                    6.2533e-07,
                    6.7805e-07,
                    7.3087e-07,
                    7.8379e-07,
                    8.3682e-07,
                    8.8996e-07,
                    9.4321e-07,
                    9.9657e-07,
                    1.05e-06,
                    1.1034e-06,
                    1.157e-06,
                    1.2108e-06,
                    1.265e-06,
                    1.3195e-06,
                    1.3743e-06,
                    1.4295e-06,
                    1.4849e-06,
                    1.5407e-06,
                    1.597e-06,
                    1.6548e-06,
                    1.7141e-06,
                    1.7747e-06,
                    1.8366e-06,
                    1.8999e-06,
                    1.9645e-06,
                    2.0304e-06,
                    2.0976e-06,
                    2.1662e-06,
                    2.2359e-06,
                    2.307e-06,
                    2.3794e-06,
                    2.4532e-06,
                    2.5284e-06,
                    2.6051e-06,
                    2.6832e-06,
                    2.7628e-06,
                    2.8437e-06,
                    2.9262e-06,
                    3.01e-06,
                    3.0862e-06,
                    3.1551e-06,
                    3.2165e-06,
                    3.2704e-06,
                    3.3166e-06,
                    3.3552e-06,
                    3.3861e-06,
                    3.4092e-06,
                    3.4244e-06,
                    3.4304e-06,
                    3.4255e-06,
                    3.4099e-06,
                    3.3839e-06,
                    3.3474e-06,
                    3.3007e-06,
                    3.2436e-06,
                    3.1764e-06,
                    3.0991e-06,
                    3.0116e-06,
                    2.914e-06,
                    2.8136e-06,
                    2.7104e-06,
                    2.6045e-06,
                    2.4962e-06,
                    2.3856e-06,
                    2.2727e-06,
                    2.1576e-06,
                    2.0403e-06,
                    1.921e-06,
                    1.7988e-06,
                    1.6761e-06,
                    1.5531e-06,
                    1.4299e-06,
                    1.3065e-06,
                    1.183e-06,
                    1.0589e-06,
                    9.3398e-07,
                    8.0846e-07,
                    6.8233e-07,
                    5.6237e-07,
                    4.4926e-07,
                    3.4357e-07,
                    2.457e-07,
                    1.5591e-07,
                    7.4875e-08,
                    2.645e-09,
                    -0.000000060776,
                    -0.00000011549,
                    -0.00000016171,
                    -0.00000019966,
                    -0.00000022703,
                    -0.0000002434,
                    -0.00000024859,
                    -0.00000024259,
                    -0.00000022497,
                    -0.00000019646,
                    -0.00000015828,
                    -0.00000011282,
                    -0.00000006841,
                    -0.0000000082052,
                    1.1018e-07,
                    2.444e-07,
                    3.9724e-07,
                    5.6893e-07,
                    7.639e-07,
                    9.845e-07,
                    1.2725e-06,
                    1.5854e-06,
                    1.9544e-06,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021
                ],
                "Fossil_3GHG": 0.2,
                "Fossil_3GHG_timeseries": [
                    4.0955e-08,
                    8.2071e-08,
                    1.2334e-07,
                    1.6477e-07,
                    2.0636e-07,
                    2.4809e-07,
                    2.8997e-07,
                    3.3199e-07,
                    3.7414e-07,
                    4.1642e-07,
                    4.5883e-07,
                    5.0137e-07,
                    5.4404e-07,
                    5.8683e-07,
                    6.2974e-07,
                    6.7278e-07,
                    7.1595e-07,
                    7.5924e-07,
                    8.0266e-07,
                    8.4621e-07,
                    8.8987e-07,
                    9.3369e-07,
                    9.7772e-07,
                    1.022e-06,
                    1.0665e-06,
                    1.1113e-06,
                    1.1563e-06,
                    1.2016e-06,
                    1.2471e-06,
                    1.2927e-06,
                    1.3393e-06,
                    1.3868e-06,
                    1.4354e-06,
                    1.4849e-06,
                    1.5354e-06,
                    1.5868e-06,
                    1.6392e-06,
                    1.6926e-06,
                    1.7469e-06,
                    1.8023e-06,
                    1.8587e-06,
                    1.9162e-06,
                    1.9748e-06,
                    2.0344e-06,
                    2.0952e-06,
                    2.1571e-06,
                    2.2201e-06,
                    2.2842e-06,
                    2.3494e-06,
                    2.4157e-06,
                    2.4745e-06,
                    2.5258e-06,
                    2.5696e-06,
                    2.6058e-06,
                    2.6343e-06,
                    2.6551e-06,
                    2.6681e-06,
                    2.6733e-06,
                    2.6706e-06,
                    2.6599e-06,
                    2.6398e-06,
                    2.6101e-06,
                    2.5709e-06,
                    2.5223e-06,
                    2.4642e-06,
                    2.3967e-06,
                    2.3197e-06,
                    2.2333e-06,
                    2.1375e-06,
                    2.0323e-06,
                    1.9251e-06,
                    1.8158e-06,
                    1.7047e-06,
                    1.5917e-06,
                    1.4769e-06,
                    1.3604e-06,
                    1.2423e-06,
                    1.1225e-06,
                    1.0012e-06,
                    8.7836e-07,
                    7.5546e-07,
                    6.3249e-07,
                    5.0947e-07,
                    3.8644e-07,
                    2.6341e-07,
                    1.404e-07,
                    1.7405e-08,
                    -0.00000010556,
                    -0.00000022849,
                    -0.00000034382,
                    -0.00000045121,
                    -0.00000055041,
                    -0.00000064124,
                    -0.00000072357,
                    -0.00000079691,
                    -0.00000086123,
                    -0.00000091657,
                    -0.00000096302,
                    -0.0000010007,
                    -0.0000010299,
                    -0.0000010493,
                    -0.0000010588,
                    -0.0000010581,
                    -0.0000010469,
                    -0.0000010252,
                    -0.00000099277,
                    -0.00000094936,
                    -0.0000008948,
                    -0.00000082882,
                    -0.00000075824,
                    -0.00000068278,
                    -0.0000006017,
                    -0.00000051431,
                    -0.00000041492,
                    -0.00000030165,
                    -0.00000017892,
                    6.9643e-10,
                    2.0104e-07,
                    4.4449e-07,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021
                ],
                "Land_3GHG": 0.01,
                "Land_3GHG_timeseries": [
                    1.0665e-08,
                    2.1251e-08,
                    3.1764e-08,
                    4.2212e-08,
                    5.2599e-08,
                    6.2929e-08,
                    7.3209e-08,
                    8.3442e-08,
                    9.3624e-08,
                    1.0377e-07,
                    1.1388e-07,
                    1.2396e-07,
                    1.3401e-07,
                    1.4405e-07,
                    1.5405e-07,
                    1.6404e-07,
                    1.7401e-07,
                    1.8397e-07,
                    1.9391e-07,
                    2.0374e-07,
                    2.1352e-07,
                    2.2329e-07,
                    2.331e-07,
                    2.4298e-07,
                    2.5293e-07,
                    2.6298e-07,
                    2.7311e-07,
                    2.8333e-07,
                    2.9359e-07,
                    3.0432e-07,
                    3.1557e-07,
                    3.2725e-07,
                    3.3931e-07,
                    3.5176e-07,
                    3.6455e-07,
                    3.777e-07,
                    3.9121e-07,
                    4.0505e-07,
                    4.1924e-07,
                    4.3365e-07,
                    4.4829e-07,
                    4.6321e-07,
                    4.7843e-07,
                    4.9399e-07,
                    5.0988e-07,
                    5.261e-07,
                    5.4266e-07,
                    5.5957e-07,
                    5.7682e-07,
                    5.943e-07,
                    6.1174e-07,
                    6.2926e-07,
                    6.4689e-07,
                    6.6456e-07,
                    6.8225e-07,
                    7.0005e-07,
                    7.1794e-07,
                    7.3586e-07,
                    7.5381e-07,
                    7.7044e-07,
                    7.8573e-07,
                    7.998e-07,
                    8.1294e-07,
                    8.2514e-07,
                    8.3647e-07,
                    8.4698e-07,
                    8.5675e-07,
                    8.658e-07,
                    8.7412e-07,
                    8.8174e-07,
                    8.8853e-07,
                    8.9454e-07,
                    8.9985e-07,
                    9.0454e-07,
                    9.0868e-07,
                    9.1227e-07,
                    9.1533e-07,
                    9.1786e-07,
                    9.1984e-07,
                    9.2047e-07,
                    9.2069e-07,
                    9.2066e-07,
                    9.2045e-07,
                    9.201e-07,
                    9.1964e-07,
                    9.1846e-07,
                    9.1658e-07,
                    9.1402e-07,
                    9.1082e-07,
                    9.062e-07,
                    9.0047e-07,
                    8.9397e-07,
                    8.8693e-07,
                    8.7948e-07,
                    8.7178e-07,
                    8.6387e-07,
                    8.5579e-07,
                    8.4752e-07,
                    8.3901e-07,
                    8.3022e-07,
                    8.223e-07,
                    8.1541e-07,
                    8.0948e-07,
                    8.0435e-07,
                    8.0027e-07,
                    7.9631e-07,
                    7.9108e-07,
                    7.8198e-07,
                    7.6041e-07,
                    7.5003e-07,
                    7.9296e-07,
                    8.461e-07,
                    9.1156e-07,
                    9.8385e-07,
                    1.0656e-06,
                    1.1634e-06,
                    1.2718e-06,
                    1.3844e-06,
                    1.51e-06,
                    1.6423e-06,
                    1.7934e-06,
                    1.9789e-06,
                    2.2057e-06,
                    2.4839e-06,
                    2.8124e-06,
                    3.1953e-06,
                    3.631e-06,
                    4.0944e-06,
                    4.599e-06,
                    5.1547e-06,
                    5.7201e-06,
                    6.3193e-06,
                    6.9471e-06,
                    7.5696e-06,
                    8.2599e-06,
                    8.9564e-06,
                    9.6684e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_CO2": 0.06,
                "Total_CO2_timeseries": [
                    -0.0000000039545,
                    -0.000000008052,
                    -0.000000012287,
                    -0.000000016648,
                    -0.000000021131,
                    -0.000000025729,
                    -0.000000030431,
                    -0.000000035233,
                    -0.000000040134,
                    -0.000000045117,
                    -0.000000050176,
                    -0.000000055308,
                    -0.000000060505,
                    -0.000000065764,
                    -0.000000071093,
                    -0.000000076483,
                    -0.000000081928,
                    -0.000000087434,
                    -0.000000092994,
                    -0.000000098703,
                    -0.00000010452,
                    -0.00000011043,
                    -0.00000011641,
                    -0.00000012245,
                    -0.00000012856,
                    -0.00000013473,
                    -0.00000014095,
                    -0.00000014721,
                    -0.00000015353,
                    -0.00000015946,
                    -0.00000016523,
                    -0.00000017093,
                    -0.00000017659,
                    -0.00000018223,
                    -0.00000018786,
                    -0.00000019348,
                    -0.00000019911,
                    -0.00000020474,
                    -0.00000021037,
                    -0.00000021624,
                    -0.00000022225,
                    -0.00000022837,
                    -0.00000023456,
                    -0.00000024082,
                    -0.00000024712,
                    -0.00000025348,
                    -0.00000025988,
                    -0.00000026633,
                    -0.00000027283,
                    -0.00000027948,
                    -0.00000028631,
                    -0.00000029318,
                    -0.00000030009,
                    -0.00000030708,
                    -0.00000031419,
                    -0.00000032133,
                    -0.00000032852,
                    -0.00000033582,
                    -0.00000034322,
                    -0.00000035209,
                    -0.00000036176,
                    -0.00000037211,
                    -0.00000038287,
                    -0.00000039401,
                    -0.0000004055,
                    -0.00000041727,
                    -0.00000042925,
                    -0.00000044143,
                    -0.00000045382,
                    -0.00000046639,
                    -0.00000047934,
                    -0.00000049267,
                    -0.00000050636,
                    -0.00000052037,
                    -0.00000053465,
                    -0.00000054921,
                    -0.00000056404,
                    -0.00000057912,
                    -0.00000059446,
                    -0.00000061082,
                    -0.00000062784,
                    -0.00000064533,
                    -0.00000066322,
                    -0.00000068148,
                    -0.00000070007,
                    -0.00000071892,
                    -0.00000073801,
                    -0.00000075732,
                    -0.00000077683,
                    -0.00000079732,
                    -0.00000081853,
                    -0.00000084028,
                    -0.00000086247,
                    -0.00000088507,
                    -0.00000090794,
                    -0.00000093107,
                    -0.0000009544,
                    -0.00000097787,
                    -0.0000010014,
                    -0.000001025,
                    -0.000001049,
                    -0.0000010737,
                    -0.0000010996,
                    -0.000001127,
                    -0.0000011559,
                    -0.0000011879,
                    -0.0000012246,
                    -0.0000012685,
                    -0.0000013284,
                    -0.0000013806,
                    -0.0000014266,
                    -0.0000014663,
                    -0.0000014976,
                    -0.0000015212,
                    -0.0000015337,
                    -0.0000015329,
                    -0.000001478,
                    -0.0000014118,
                    -0.0000013045,
                    -0.0000011987,
                    -0.00000024967,
                    6.9917e-07,
                    1.6587e-06,
                    2.7209e-06,
                    5.9982e-06,
                    9.7592e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007
                ],
                "Fossil_CO2": 0.09,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    4.95e-09,
                    1.65e-08,
                    2.97e-08,
                    9.075e-08,
                    1.6335e-07,
                    2.6895e-07,
                    3.7455e-07,
                    1.3167e-06,
                    2.2572e-06,
                    3.2076e-06,
                    4.2587e-06,
                    7.524e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [
                    -0.0000000039545,
                    -0.000000008052,
                    -0.000000012287,
                    -0.000000016648,
                    -0.000000021131,
                    -0.000000025729,
                    -0.000000030431,
                    -0.000000035233,
                    -0.000000040134,
                    -0.000000045117,
                    -0.000000050176,
                    -0.000000055308,
                    -0.000000060505,
                    -0.000000065764,
                    -0.000000071093,
                    -0.000000076483,
                    -0.000000081928,
                    -0.000000087434,
                    -0.000000092994,
                    -0.000000098703,
                    -0.00000010452,
                    -0.00000011043,
                    -0.00000011641,
                    -0.00000012245,
                    -0.00000012856,
                    -0.00000013473,
                    -0.00000014095,
                    -0.00000014721,
                    -0.00000015353,
                    -0.00000015946,
                    -0.00000016523,
                    -0.00000017093,
                    -0.00000017659,
                    -0.00000018223,
                    -0.00000018786,
                    -0.00000019348,
                    -0.00000019911,
                    -0.00000020474,
                    -0.00000021037,
                    -0.00000021624,
                    -0.00000022225,
                    -0.00000022837,
                    -0.00000023456,
                    -0.00000024082,
                    -0.00000024712,
                    -0.00000025348,
                    -0.00000025988,
                    -0.00000026633,
                    -0.00000027283,
                    -0.00000027948,
                    -0.00000028631,
                    -0.00000029318,
                    -0.00000030009,
                    -0.00000030708,
                    -0.00000031419,
                    -0.00000032133,
                    -0.00000032852,
                    -0.00000033582,
                    -0.00000034322,
                    -0.00000035209,
                    -0.00000036176,
                    -0.00000037211,
                    -0.00000038287,
                    -0.00000039401,
                    -0.0000004055,
                    -0.00000041727,
                    -0.00000042925,
                    -0.00000044143,
                    -0.00000045382,
                    -0.00000046639,
                    -0.00000047934,
                    -0.00000049267,
                    -0.00000050636,
                    -0.00000052037,
                    -0.00000053465,
                    -0.00000054921,
                    -0.00000056404,
                    -0.00000057912,
                    -0.00000059446,
                    -0.00000061082,
                    -0.00000062784,
                    -0.00000064533,
                    -0.00000066322,
                    -0.00000068148,
                    -0.00000070007,
                    -0.00000071892,
                    -0.00000073801,
                    -0.00000075732,
                    -0.00000077683,
                    -0.00000079732,
                    -0.00000081853,
                    -0.00000084028,
                    -0.00000086247,
                    -0.00000088507,
                    -0.00000090794,
                    -0.00000093107,
                    -0.0000009544,
                    -0.00000097787,
                    -0.0000010014,
                    -0.000001025,
                    -0.000001049,
                    -0.0000010737,
                    -0.0000010996,
                    -0.000001127,
                    -0.0000011559,
                    -0.0000011879,
                    -0.0000012246,
                    -0.0000012685,
                    -0.0000013284,
                    -0.0000013806,
                    -0.0000014266,
                    -0.0000014663,
                    -0.0000014976,
                    -0.0000015262,
                    -0.0000015502,
                    -0.0000015626,
                    -0.0000015687,
                    -0.0000015752,
                    -0.0000015735,
                    -0.0000015732,
                    -0.0000015664,
                    -0.000001558,
                    -0.0000015489,
                    -0.0000015377,
                    -0.0000015258,
                    -0.0000015119,
                    -0.0000014939,
                    -0.0000014807,
                    -0.0000014694,
                    -0.0000014595,
                    -0.0000014488,
                    -0.0000014207,
                    -0.0000013833,
                    -0.0000013429,
                    -0.0000012836,
                    -0.0000012247,
                    -0.0000011637,
                    -0.000001096,
                    -0.0000010294,
                    -0.00000097418,
                    -0.00000092214,
                    -0.00000089516,
                    -0.00000087287,
                    -0.00000085621,
                    -0.00000084113,
                    -0.00000082927,
                    -0.00000081404,
                    -0.00000079099,
                    -0.00000076731,
                    -0.00000075462,
                    -0.00000075276,
                    -0.00000076646,
                    -0.00000079422,
                    -0.00000083948,
                    -0.00000088656,
                    -0.00000092302,
                    -0.00000094949,
                    -0.00000095102,
                    -0.00000095941,
                    -0.00000095446,
                    -0.00000095701,
                    -0.00000096384,
                    -0.00000096446,
                    -0.00000091192,
                    -0.00000085714,
                    -0.00000074155,
                    -0.00000063374,
                    -0.00000051851,
                    -0.00000039443,
                    -0.00000026032,
                    -0.0000001257,
                    9.7955e-09
                ],
                "Total_CH4": 0.35,
                "Total_CH4_timeseries": [
                    5.0449e-08,
                    1.0104e-07,
                    1.5177e-07,
                    2.0265e-07,
                    2.5366e-07,
                    3.0482e-07,
                    3.5612e-07,
                    4.0757e-07,
                    4.5915e-07,
                    5.1087e-07,
                    5.6274e-07,
                    6.1476e-07,
                    6.6692e-07,
                    7.1923e-07,
                    7.7168e-07,
                    8.2427e-07,
                    8.7701e-07,
                    9.299e-07,
                    9.8293e-07,
                    1.0361e-06,
                    1.0894e-06,
                    1.1427e-06,
                    1.1961e-06,
                    1.2496e-06,
                    1.3032e-06,
                    1.3568e-06,
                    1.4106e-06,
                    1.4644e-06,
                    1.5182e-06,
                    1.5722e-06,
                    1.6274e-06,
                    1.6839e-06,
                    1.7417e-06,
                    1.8007e-06,
                    1.8609e-06,
                    1.9224e-06,
                    1.9852e-06,
                    2.0493e-06,
                    2.1146e-06,
                    2.1811e-06,
                    2.2491e-06,
                    2.3185e-06,
                    2.3893e-06,
                    2.4615e-06,
                    2.5351e-06,
                    2.6102e-06,
                    2.6866e-06,
                    2.7645e-06,
                    2.8438e-06,
                    2.9245e-06,
                    2.9978e-06,
                    3.0636e-06,
                    3.1219e-06,
                    3.1726e-06,
                    3.2156e-06,
                    3.2509e-06,
                    3.2784e-06,
                    3.2981e-06,
                    3.3099e-06,
                    3.3138e-06,
                    3.3074e-06,
                    3.291e-06,
                    3.2643e-06,
                    3.2276e-06,
                    3.1807e-06,
                    3.1237e-06,
                    3.0567e-06,
                    2.9795e-06,
                    2.8923e-06,
                    2.795e-06,
                    2.695e-06,
                    2.5924e-06,
                    2.4873e-06,
                    2.3796e-06,
                    2.2695e-06,
                    2.157e-06,
                    2.0423e-06,
                    1.9252e-06,
                    1.806e-06,
                    1.6847e-06,
                    1.5632e-06,
                    1.4416e-06,
                    1.3198e-06,
                    1.1978e-06,
                    1.0757e-06,
                    9.5277e-07,
                    8.2897e-07,
                    7.0432e-07,
                    5.7881e-07,
                    4.6001e-07,
                    3.4808e-07,
                    2.4302e-07,
                    1.4482e-07,
                    5.3463e-08,
                    -0.000000030616,
                    -0.00000010742,
                    -0.00000017696,
                    -0.00000023923,
                    -0.00000029424,
                    -0.00000034198,
                    -0.00000037947,
                    -0.00000040602,
                    -0.00000042106,
                    -0.00000042415,
                    -0.00000041494,
                    -0.00000039249,
                    -0.00000035649,
                    -0.00000030665,
                    -0.00000024262,
                    -0.00000017111,
                    -0.000000054409,
                    7.0097e-08,
                    2.0268e-07,
                    3.4394e-07,
                    4.9436e-07,
                    6.5384e-07,
                    8.2308e-07,
                    1.0023e-06,
                    1.1924e-06,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015
                ],
                "Fossil_CH4": 0.55,
                "Fossil_CH4_timeseries": [
                    3.7107e-08,
                    7.4318e-08,
                    1.1163e-07,
                    1.4905e-07,
                    1.8656e-07,
                    2.2419e-07,
                    2.6191e-07,
                    2.9973e-07,
                    3.3766e-07,
                    3.7569e-07,
                    4.1383e-07,
                    4.5207e-07,
                    4.9042e-07,
                    5.2887e-07,
                    5.6742e-07,
                    6.0608e-07,
                    6.4485e-07,
                    6.8372e-07,
                    7.2269e-07,
                    7.6177e-07,
                    8.0091e-07,
                    8.401e-07,
                    8.7935e-07,
                    9.1865e-07,
                    9.5801e-07,
                    9.9742e-07,
                    1.0369e-06,
                    1.0764e-06,
                    1.116e-06,
                    1.1556e-06,
                    1.1962e-06,
                    1.2377e-06,
                    1.2801e-06,
                    1.3234e-06,
                    1.3677e-06,
                    1.4129e-06,
                    1.459e-06,
                    1.506e-06,
                    1.554e-06,
                    1.6029e-06,
                    1.6528e-06,
                    1.7038e-06,
                    1.7558e-06,
                    1.8088e-06,
                    1.8629e-06,
                    1.918e-06,
                    1.9742e-06,
                    2.0314e-06,
                    2.0896e-06,
                    2.1489e-06,
                    2.2007e-06,
                    2.2448e-06,
                    2.2813e-06,
                    2.3101e-06,
                    2.3312e-06,
                    2.3444e-06,
                    2.3497e-06,
                    2.347e-06,
                    2.3364e-06,
                    2.3177e-06,
                    2.2893e-06,
                    2.2514e-06,
                    2.2039e-06,
                    2.1468e-06,
                    2.0802e-06,
                    2.004e-06,
                    1.9182e-06,
                    1.823e-06,
                    1.7182e-06,
                    1.604e-06,
                    1.4875e-06,
                    1.369e-06,
                    1.2485e-06,
                    1.126e-06,
                    1.0016e-06,
                    8.7539e-07,
                    7.474e-07,
                    6.1769e-07,
                    4.8634e-07,
                    3.5341e-07,
                    2.2026e-07,
                    8.6903e-08,
                    -0.000000046677,
                    -0.00000018048,
                    -0.00000031451,
                    -0.00000044876,
                    -0.00000058325,
                    -0.00000071797,
                    -0.00000085293,
                    -0.00000098057,
                    -0.0000011007,
                    -0.0000012132,
                    -0.0000013183,
                    -0.0000014158,
                    -0.0000015053,
                    -0.000001587,
                    -0.0000016606,
                    -0.0000017264,
                    -0.0000017842,
                    -0.000001834,
                    -0.0000018746,
                    -0.0000019056,
                    -0.0000019267,
                    -0.0000019377,
                    -0.0000019384,
                    -0.0000019287,
                    -0.0000019083,
                    -0.0000018771,
                    -0.000001835,
                    -0.0000017887,
                    -0.0000017383,
                    -0.0000016836,
                    -0.0000016243,
                    -0.00000156,
                    -0.000001491,
                    -0.0000014169,
                    -0.0000013368,
                    -0.0000012509,
                    -0.0000011583,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014
                ],
                "Land_CH4": 0.03,
                "Land_CH4_timeseries": [
                    1.3342e-08,
                    2.6723e-08,
                    4.0143e-08,
                    5.3602e-08,
                    6.7101e-08,
                    8.0638e-08,
                    9.4215e-08,
                    1.0783e-07,
                    1.2149e-07,
                    1.3518e-07,
                    1.4891e-07,
                    1.6269e-07,
                    1.765e-07,
                    1.9036e-07,
                    2.0425e-07,
                    2.1819e-07,
                    2.3216e-07,
                    2.4618e-07,
                    2.6024e-07,
                    2.7433e-07,
                    2.8845e-07,
                    3.026e-07,
                    3.1676e-07,
                    3.3095e-07,
                    3.4517e-07,
                    3.594e-07,
                    3.7366e-07,
                    3.8794e-07,
                    4.0225e-07,
                    4.1658e-07,
                    4.3124e-07,
                    4.4623e-07,
                    4.6156e-07,
                    4.7723e-07,
                    4.9323e-07,
                    5.0956e-07,
                    5.2623e-07,
                    5.4323e-07,
                    5.6056e-07,
                    5.7823e-07,
                    5.9627e-07,
                    6.1469e-07,
                    6.3349e-07,
                    6.5266e-07,
                    6.7221e-07,
                    6.9214e-07,
                    7.1244e-07,
                    7.3312e-07,
                    7.5417e-07,
                    7.756e-07,
                    7.9714e-07,
                    8.188e-07,
                    8.4057e-07,
                    8.6245e-07,
                    8.8444e-07,
                    9.0655e-07,
                    9.2877e-07,
                    9.5111e-07,
                    9.7355e-07,
                    9.9611e-07,
                    1.0181e-06,
                    1.0396e-06,
                    1.0604e-06,
                    1.0808e-06,
                    1.1005e-06,
                    1.1198e-06,
                    1.1384e-06,
                    1.1565e-06,
                    1.1741e-06,
                    1.191e-06,
                    1.2075e-06,
                    1.2234e-06,
                    1.2388e-06,
                    1.2536e-06,
                    1.2679e-06,
                    1.2816e-06,
                    1.2949e-06,
                    1.3075e-06,
                    1.3197e-06,
                    1.3313e-06,
                    1.343e-06,
                    1.3547e-06,
                    1.3665e-06,
                    1.3783e-06,
                    1.3902e-06,
                    1.4015e-06,
                    1.4122e-06,
                    1.4223e-06,
                    1.4317e-06,
                    1.4406e-06,
                    1.4488e-06,
                    1.4563e-06,
                    1.4631e-06,
                    1.4692e-06,
                    1.4747e-06,
                    1.4795e-06,
                    1.4837e-06,
                    1.4871e-06,
                    1.4899e-06,
                    1.492e-06,
                    1.4951e-06,
                    1.4995e-06,
                    1.5056e-06,
                    1.5135e-06,
                    1.5235e-06,
                    1.5362e-06,
                    1.5518e-06,
                    1.5705e-06,
                    1.5923e-06,
                    1.6176e-06,
                    1.6839e-06,
                    1.7537e-06,
                    1.827e-06,
                    1.904e-06,
                    1.9853e-06,
                    2.0707e-06,
                    2.1599e-06,
                    2.2531e-06,
                    2.3507e-06,
                    2.4554e-06,
                    2.571e-06,
                    2.7158e-06,
                    2.8962e-06,
                    3.1202e-06,
                    3.3877e-06,
                    3.7024e-06,
                    4.0605e-06,
                    4.449e-06,
                    4.8752e-06,
                    5.3493e-06,
                    5.8296e-06,
                    6.3257e-06,
                    6.8416e-06,
                    7.349e-06,
                    7.8994e-06,
                    8.456e-06,
                    9.0238e-06,
                    9.5969e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_N2O": 0.02,
                "Total_N2O_timeseries": [
                    5.1253e-09,
                    1.0333e-08,
                    1.5622e-08,
                    2.0986e-08,
                    2.6422e-08,
                    3.1924e-08,
                    3.7484e-08,
                    4.3095e-08,
                    4.8748e-08,
                    5.4433e-08,
                    6.0143e-08,
                    6.5876e-08,
                    7.1633e-08,
                    7.7411e-08,
                    8.321e-08,
                    8.9031e-08,
                    9.4874e-08,
                    1.0074e-07,
                    1.0663e-07,
                    1.1255e-07,
                    1.1854e-07,
                    1.2471e-07,
                    1.3112e-07,
                    1.3782e-07,
                    1.4484e-07,
                    1.5219e-07,
                    1.5985e-07,
                    1.6779e-07,
                    1.7594e-07,
                    1.8424e-07,
                    1.9262e-07,
                    2.0108e-07,
                    2.0961e-07,
                    2.182e-07,
                    2.2685e-07,
                    2.3555e-07,
                    2.4431e-07,
                    2.5312e-07,
                    2.6199e-07,
                    2.7103e-07,
                    2.8013e-07,
                    2.8928e-07,
                    2.985e-07,
                    3.0777e-07,
                    3.1711e-07,
                    3.2652e-07,
                    3.36e-07,
                    3.4556e-07,
                    3.5519e-07,
                    3.6491e-07,
                    3.7472e-07,
                    3.8464e-07,
                    3.9468e-07,
                    4.0485e-07,
                    4.1514e-07,
                    4.2558e-07,
                    4.3615e-07,
                    4.4687e-07,
                    4.5772e-07,
                    4.687e-07,
                    4.7981e-07,
                    4.9104e-07,
                    5.0239e-07,
                    5.1386e-07,
                    5.2546e-07,
                    5.3719e-07,
                    5.4904e-07,
                    5.6103e-07,
                    5.7316e-07,
                    5.8543e-07,
                    5.979e-07,
                    6.1062e-07,
                    6.2364e-07,
                    6.3701e-07,
                    6.5074e-07,
                    6.6486e-07,
                    6.7936e-07,
                    6.9422e-07,
                    7.0943e-07,
                    7.2495e-07,
                    7.4076e-07,
                    7.5688e-07,
                    7.7335e-07,
                    7.9018e-07,
                    8.0739e-07,
                    8.25e-07,
                    8.4302e-07,
                    8.6147e-07,
                    8.8035e-07,
                    8.9969e-07,
                    9.1971e-07,
                    9.4083e-07,
                    9.6335e-07,
                    9.8751e-07,
                    1.0134e-06,
                    1.0411e-06,
                    1.0706e-06,
                    1.1016e-06,
                    1.134e-06,
                    1.1673e-06,
                    1.2014e-06,
                    1.2364e-06,
                    1.2721e-06,
                    1.3086e-06,
                    1.3459e-06,
                    1.384e-06,
                    1.4228e-06,
                    1.4623e-06,
                    1.5026e-06,
                    1.5435e-06,
                    1.5912e-06,
                    1.6406e-06,
                    1.6921e-06,
                    1.7462e-06,
                    1.8033e-06,
                    1.8636e-06,
                    1.9274e-06,
                    1.995e-06,
                    2.0665e-06,
                    2.1277e-06,
                    2.1909e-06,
                    2.2587e-06,
                    2.3327e-06,
                    2.4155e-06,
                    2.5451e-06,
                    2.69e-06,
                    2.8456e-06,
                    2.9908e-06,
                    3.1368e-06,
                    3.2722e-06,
                    3.4171e-06,
                    3.5602e-06,
                    3.7111e-06,
                    3.8621e-06,
                    4.0174e-06,
                    4.1779e-06,
                    4.3403e-06,
                    4.5125e-06,
                    4.6879e-06,
                    4.8737e-06,
                    5.0785e-06,
                    5.2934e-06,
                    5.5156e-06,
                    5.75e-06,
                    5.9978e-06,
                    6.2526e-06,
                    6.5161e-06,
                    6.7932e-06,
                    7.0822e-06,
                    7.3557e-06,
                    7.6446e-06,
                    7.9389e-06,
                    8.2384e-06,
                    8.5539e-06,
                    8.8795e-06,
                    9.2258e-06,
                    9.5966e-06,
                    9.9781e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_N2O": 0.04,
                "Fossil_N2O_timeseries": [
                    3.8478e-09,
                    7.753e-09,
                    1.1714e-08,
                    1.5728e-08,
                    1.9792e-08,
                    2.3904e-08,
                    2.8059e-08,
                    3.2251e-08,
                    3.6476e-08,
                    4.0728e-08,
                    4.5003e-08,
                    4.93e-08,
                    5.3619e-08,
                    5.7957e-08,
                    6.2317e-08,
                    6.6697e-08,
                    7.1098e-08,
                    7.5521e-08,
                    7.9965e-08,
                    8.4433e-08,
                    8.8956e-08,
                    9.359e-08,
                    9.8377e-08,
                    1.0335e-07,
                    1.0851e-07,
                    1.1388e-07,
                    1.1945e-07,
                    1.2519e-07,
                    1.3106e-07,
                    1.3703e-07,
                    1.4306e-07,
                    1.4914e-07,
                    1.5527e-07,
                    1.6145e-07,
                    1.6767e-07,
                    1.7392e-07,
                    1.8022e-07,
                    1.8656e-07,
                    1.9294e-07,
                    1.9938e-07,
                    2.0586e-07,
                    2.124e-07,
                    2.1899e-07,
                    2.2563e-07,
                    2.3233e-07,
                    2.3908e-07,
                    2.4589e-07,
                    2.5277e-07,
                    2.5971e-07,
                    2.6673e-07,
                    2.7382e-07,
                    2.81e-07,
                    2.8828e-07,
                    2.9566e-07,
                    3.0315e-07,
                    3.1075e-07,
                    3.1847e-07,
                    3.263e-07,
                    3.3423e-07,
                    3.4228e-07,
                    3.5042e-07,
                    3.5867e-07,
                    3.6702e-07,
                    3.7548e-07,
                    3.8403e-07,
                    3.9269e-07,
                    4.0145e-07,
                    4.1031e-07,
                    4.1927e-07,
                    4.2834e-07,
                    4.3752e-07,
                    4.468e-07,
                    4.5619e-07,
                    4.6569e-07,
                    4.7531e-07,
                    4.8503e-07,
                    4.9486e-07,
                    5.0479e-07,
                    5.1482e-07,
                    5.2495e-07,
                    5.3519e-07,
                    5.4558e-07,
                    5.5615e-07,
                    5.6692e-07,
                    5.7792e-07,
                    5.8916e-07,
                    6.0065e-07,
                    6.1242e-07,
                    6.2445e-07,
                    6.3675e-07,
                    6.4946e-07,
                    6.6283e-07,
                    6.7703e-07,
                    6.9221e-07,
                    7.0844e-07,
                    7.2574e-07,
                    7.4407e-07,
                    7.6335e-07,
                    7.8344e-07,
                    8.0412e-07,
                    8.2525e-07,
                    8.4676e-07,
                    8.686e-07,
                    8.9074e-07,
                    9.1317e-07,
                    9.359e-07,
                    9.5894e-07,
                    9.8233e-07,
                    1.0061e-06,
                    1.0304e-06,
                    1.0555e-06,
                    1.0819e-06,
                    1.11e-06,
                    1.1402e-06,
                    1.1728e-06,
                    1.2083e-06,
                    1.2468e-06,
                    1.2885e-06,
                    1.3338e-06,
                    1.3676e-06,
                    1.4022e-06,
                    1.4376e-06,
                    1.4743e-06,
                    1.514e-06,
                    1.5947e-06,
                    1.6851e-06,
                    1.7813e-06,
                    1.8648e-06,
                    1.9435e-06,
                    2.0073e-06,
                    2.0778e-06,
                    2.1459e-06,
                    2.2223e-06,
                    2.2986e-06,
                    2.3733e-06,
                    2.4528e-06,
                    2.5321e-06,
                    2.6157e-06,
                    2.7011e-06,
                    2.7888e-06,
                    2.8888e-06,
                    2.9913e-06,
                    3.0949e-06,
                    3.2009e-06,
                    3.3163e-06,
                    3.4371e-06,
                    3.5648e-06,
                    3.6929e-06,
                    3.8287e-06,
                    3.9527e-06,
                    4.0827e-06,
                    4.2195e-06,
                    4.3621e-06,
                    4.5062e-06,
                    4.6421e-06,
                    4.795e-06,
                    4.9701e-06,
                    5.1438e-06,
                    5.3152e-06,
                    5.4995e-06,
                    5.7035e-06,
                    5.9283e-06,
                    6.1744e-06,
                    6.4331e-06,
                    6.7006e-06,
                    6.9683e-06,
                    7.2432e-06,
                    7.5277e-06,
                    7.8227e-06,
                    8.1177e-06,
                    8.4347e-06,
                    8.7658e-06
                ],
                "Land_N2O": 0.01,
                "Land_N2O_timeseries": [
                    1.2775e-09,
                    2.5805e-09,
                    3.908e-09,
                    5.2584e-09,
                    6.6298e-09,
                    8.0198e-09,
                    9.4257e-09,
                    1.0844e-08,
                    1.2272e-08,
                    1.3704e-08,
                    1.5139e-08,
                    1.6576e-08,
                    1.8014e-08,
                    1.9453e-08,
                    2.0893e-08,
                    2.2334e-08,
                    2.3776e-08,
                    2.5219e-08,
                    2.6665e-08,
                    2.8113e-08,
                    2.9585e-08,
                    3.1118e-08,
                    3.2742e-08,
                    3.4475e-08,
                    3.6329e-08,
                    3.8306e-08,
                    4.0401e-08,
                    4.26e-08,
                    4.4879e-08,
                    4.7206e-08,
                    4.9562e-08,
                    5.194e-08,
                    5.4338e-08,
                    5.6753e-08,
                    5.9183e-08,
                    6.1627e-08,
                    6.4085e-08,
                    6.6558e-08,
                    6.9049e-08,
                    7.1656e-08,
                    7.4268e-08,
                    7.6886e-08,
                    7.951e-08,
                    8.2144e-08,
                    8.4787e-08,
                    8.7442e-08,
                    9.0108e-08,
                    9.2787e-08,
                    9.5479e-08,
                    9.8184e-08,
                    1.0091e-07,
                    1.0364e-07,
                    1.064e-07,
                    1.0919e-07,
                    1.1199e-07,
                    1.1483e-07,
                    1.1769e-07,
                    1.2057e-07,
                    1.2348e-07,
                    1.2642e-07,
                    1.2938e-07,
                    1.3236e-07,
                    1.3536e-07,
                    1.3839e-07,
                    1.4143e-07,
                    1.445e-07,
                    1.4759e-07,
                    1.5072e-07,
                    1.5388e-07,
                    1.5709e-07,
                    1.6038e-07,
                    1.6382e-07,
                    1.6745e-07,
                    1.7131e-07,
                    1.7544e-07,
                    1.7983e-07,
                    1.845e-07,
                    1.8944e-07,
                    1.9461e-07,
                    2e-07,
                    2.0556e-07,
                    2.113e-07,
                    2.172e-07,
                    2.2326e-07,
                    2.2947e-07,
                    2.3584e-07,
                    2.4237e-07,
                    2.4905e-07,
                    2.5591e-07,
                    2.6294e-07,
                    2.7025e-07,
                    2.78e-07,
                    2.8632e-07,
                    2.953e-07,
                    3.0499e-07,
                    3.154e-07,
                    3.2651e-07,
                    3.3825e-07,
                    3.5052e-07,
                    3.6317e-07,
                    3.7618e-07,
                    3.896e-07,
                    4.0349e-07,
                    4.1786e-07,
                    4.3274e-07,
                    4.4808e-07,
                    4.6386e-07,
                    4.8001e-07,
                    4.9645e-07,
                    5.1306e-07,
                    5.3569e-07,
                    5.5873e-07,
                    5.8217e-07,
                    6.0606e-07,
                    6.3045e-07,
                    6.5531e-07,
                    6.8061e-07,
                    7.0641e-07,
                    7.3275e-07,
                    7.6002e-07,
                    7.8875e-07,
                    8.2115e-07,
                    8.5833e-07,
                    9.0146e-07,
                    9.504e-07,
                    1.0049e-06,
                    1.0643e-06,
                    1.1261e-06,
                    1.1933e-06,
                    1.2649e-06,
                    1.3393e-06,
                    1.4143e-06,
                    1.4888e-06,
                    1.5635e-06,
                    1.6441e-06,
                    1.7251e-06,
                    1.8083e-06,
                    1.8969e-06,
                    1.9868e-06,
                    2.0849e-06,
                    2.1897e-06,
                    2.3021e-06,
                    2.4208e-06,
                    2.5491e-06,
                    2.6815e-06,
                    2.8156e-06,
                    2.9513e-06,
                    3.1003e-06,
                    3.2535e-06,
                    3.403e-06,
                    3.5619e-06,
                    3.7194e-06,
                    3.8763e-06,
                    4.0477e-06,
                    4.2374e-06,
                    4.4308e-06,
                    4.6265e-06,
                    4.8344e-06,
                    5.0384e-06,
                    5.2521e-06,
                    5.4694e-06,
                    5.6915e-06,
                    5.9475e-06,
                    6.1991e-06,
                    6.458e-06,
                    6.7201e-06,
                    6.9865e-06,
                    7.2614e-06,
                    7.5412e-06,
                    7.8283e-06,
                    8.1197e-06,
                    8.4167e-06
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                53.10703,
                                16.65439
                            ],
                            [
                                53.19344,
                                16.69317
                            ],
                            [
                                53.34542,
                                16.73564
                            ],
                            [
                                53.51097,
                                16.763
                            ],
                            [
                                53.587,
                                16.75247
                            ],
                            [
                                53.67121,
                                16.78395
                            ],
                            [
                                53.76156,
                                16.87539
                            ],
                            [
                                53.9438,
                                16.90149
                            ],
                            [
                                54.03649,
                                16.98573
                            ],
                            [
                                54.27833,
                                17.02523
                            ],
                            [
                                54.50938,
                                17.0331
                            ],
                            [
                                54.67419,
                                17.01604
                            ],
                            [
                                54.68947,
                                16.97889
                            ],
                            [
                                54.80244,
                                16.94166
                            ],
                            [
                                54.90315,
                                16.9652
                            ],
                            [
                                55.08365,
                                17.04751
                            ],
                            [
                                55.14681,
                                17.12816
                            ],
                            [
                                55.19245,
                                17.14143
                            ],
                            [
                                55.26102,
                                17.24321
                            ],
                            [
                                55.24427,
                                17.26542
                            ],
                            [
                                55.30268,
                                17.39577
                            ],
                            [
                                55.24183,
                                17.45647
                            ],
                            [
                                55.22587,
                                17.51127
                            ],
                            [
                                55.26594,
                                17.60522
                            ],
                            [
                                55.37737,
                                17.68257
                            ],
                            [
                                55.42853,
                                17.819
                            ],
                            [
                                55.53034,
                                17.86583
                            ],
                            [
                                55.73087,
                                17.90125
                            ],
                            [
                                55.91748,
                                17.89838
                            ],
                            [
                                55.98003,
                                17.92825
                            ],
                            [
                                56.10405,
                                17.92189
                            ],
                            [
                                56.18844,
                                17.93995
                            ],
                            [
                                56.34938,
                                17.92216
                            ],
                            [
                                56.35733,
                                17.96165
                            ],
                            [
                                56.43707,
                                18.04927
                            ],
                            [
                                56.54878,
                                18.12771
                            ],
                            [
                                56.54616,
                                18.18203
                            ],
                            [
                                56.59922,
                                18.29886
                            ],
                            [
                                56.63183,
                                18.44831
                            ],
                            [
                                56.64612,
                                18.58251
                            ],
                            [
                                56.77677,
                                18.72807
                            ],
                            [
                                56.844,
                                18.78077
                            ],
                            [
                                57.03383,
                                18.86024
                            ],
                            [
                                57.26551,
                                18.91733
                            ],
                            [
                                57.47403,
                                18.94051
                            ],
                            [
                                57.6878,
                                18.94033
                            ],
                            [
                                57.80302,
                                18.97311
                            ],
                            [
                                57.83804,
                                19.00001
                            ],
                            [
                                57.79731,
                                19.07642
                            ],
                            [
                                57.79916,
                                19.15903
                            ],
                            [
                                57.76603,
                                19.17719
                            ],
                            [
                                57.74119,
                                19.30626
                            ],
                            [
                                57.75975,
                                19.39646
                            ],
                            [
                                57.69814,
                                19.52748
                            ],
                            [
                                57.72064,
                                19.65325
                            ],
                            [
                                57.68213,
                                19.67755
                            ],
                            [
                                57.68828,
                                19.74721
                            ],
                            [
                                57.73608,
                                19.80498
                            ],
                            [
                                57.80867,
                                19.98505
                            ],
                            [
                                57.8314,
                                20.11587
                            ],
                            [
                                57.825,
                                20.20017
                            ],
                            [
                                57.85257,
                                20.245
                            ],
                            [
                                57.94651,
                                20.30568
                            ],
                            [
                                57.94081,
                                20.37226
                            ],
                            [
                                57.98433,
                                20.42618
                            ],
                            [
                                58.05975,
                                20.45945
                            ],
                            [
                                58.08043,
                                20.55653
                            ],
                            [
                                58.17706,
                                20.60684
                            ],
                            [
                                58.27459,
                                20.56552
                            ],
                            [
                                58.20686,
                                20.39532
                            ],
                            [
                                58.28272,
                                20.36771
                            ],
                            [
                                58.34624,
                                20.37706
                            ],
                            [
                                58.44518,
                                20.35446
                            ],
                            [
                                58.52571,
                                20.43236
                            ],
                            [
                                58.53856,
                                20.51298
                            ],
                            [
                                58.58638,
                                20.62898
                            ],
                            [
                                58.67573,
                                20.70909
                            ],
                            [
                                58.66995,
                                20.78833
                            ],
                            [
                                58.73804,
                                20.8522
                            ],
                            [
                                58.79799,
                                20.93756
                            ],
                            [
                                58.80162,
                                20.98752
                            ],
                            [
                                58.84875,
                                21.05752
                            ],
                            [
                                59.04608,
                                21.26049
                            ],
                            [
                                59.19467,
                                21.36508
                            ],
                            [
                                59.30138,
                                21.40634
                            ],
                            [
                                59.4535,
                                21.63161
                            ],
                            [
                                59.49916,
                                21.76096
                            ],
                            [
                                59.64368,
                                21.93416
                            ],
                            [
                                59.67629,
                                22.06601
                            ],
                            [
                                59.80683,
                                22.22816
                            ],
                            [
                                59.83502,
                                22.42845
                            ],
                            [
                                59.79068,
                                22.5314
                            ],
                            [
                                59.73558,
                                22.52743
                            ],
                            [
                                59.6439,
                                22.55631
                            ],
                            [
                                59.52387,
                                22.57224
                            ],
                            [
                                59.38677,
                                22.67308
                            ],
                            [
                                59.33583,
                                22.74345
                            ],
                            [
                                59.28999,
                                22.75924
                            ],
                            [
                                59.19411,
                                22.95664
                            ],
                            [
                                59.06623,
                                23.04647
                            ],
                            [
                                58.99525,
                                23.15327
                            ],
                            [
                                58.98786,
                                23.20653
                            ],
                            [
                                58.93583,
                                23.24416
                            ],
                            [
                                58.91164,
                                23.3172
                            ],
                            [
                                58.8132,
                                23.38565
                            ],
                            [
                                58.74723,
                                23.51856
                            ],
                            [
                                58.61913,
                                23.56569
                            ],
                            [
                                58.56366,
                                23.63115
                            ],
                            [
                                58.48822,
                                23.64076
                            ],
                            [
                                58.44232,
                                23.61035
                            ],
                            [
                                58.29979,
                                23.6077
                            ],
                            [
                                58.18704,
                                23.67903
                            ],
                            [
                                58.0797,
                                23.71163
                            ],
                            [
                                57.88556,
                                23.70671
                            ],
                            [
                                57.80002,
                                23.75437
                            ],
                            [
                                57.66941,
                                23.77102
                            ],
                            [
                                57.19528,
                                23.9266
                            ],
                            [
                                56.9391,
                                24.11693
                            ],
                            [
                                56.7161,
                                24.40558
                            ],
                            [
                                56.61756,
                                24.48802
                            ],
                            [
                                56.53264,
                                24.60601
                            ],
                            [
                                56.48439,
                                24.69906
                            ],
                            [
                                56.3829,
                                24.9351
                            ],
                            [
                                56.37424,
                                24.98035
                            ],
                            [
                                56.32705,
                                24.89668
                            ],
                            [
                                56.20771,
                                24.84958
                            ],
                            [
                                56.19961,
                                24.78456
                            ],
                            [
                                56.11095,
                                24.73901
                            ],
                            [
                                55.98133,
                                24.87612
                            ],
                            [
                                56.0605,
                                24.94473
                            ],
                            [
                                55.96363,
                                25.00414
                            ],
                            [
                                55.85178,
                                24.96358
                            ],
                            [
                                55.81335,
                                24.90584
                            ],
                            [
                                55.83572,
                                24.6741
                            ],
                            [
                                55.76575,
                                24.53417
                            ],
                            [
                                55.83414,
                                24.40739
                            ],
                            [
                                55.83432,
                                24.32956
                            ],
                            [
                                55.77797,
                                24.2338
                            ],
                            [
                                55.83305,
                                24.20206
                            ],
                            [
                                55.95288,
                                24.22225
                            ],
                            [
                                56.01703,
                                24.0689
                            ],
                            [
                                55.90549,
                                24.04707
                            ],
                            [
                                55.83222,
                                24.01528
                            ],
                            [
                                55.73132,
                                24.05696
                            ],
                            [
                                55.63077,
                                24.0188
                            ],
                            [
                                55.48657,
                                23.93879
                            ],
                            [
                                55.5348,
                                23.84048
                            ],
                            [
                                55.53311,
                                23.75904
                            ],
                            [
                                55.57192,
                                23.70225
                            ],
                            [
                                55.57184,
                                23.62937
                            ],
                            [
                                55.39947,
                                23.38802
                            ],
                            [
                                55.2986,
                                23.20622
                            ],
                            [
                                55.23431,
                                23.11355
                            ],
                            [
                                55.21404,
                                22.93465
                            ],
                            [
                                55.22805,
                                22.79153
                            ],
                            [
                                55.20833,
                                22.70833
                            ],
                            [
                                55.66667,
                                22.0
                            ],
                            [
                                55.43211,
                                21.30133
                            ],
                            [
                                55.24454,
                                20.7394
                            ],
                            [
                                54.99985,
                                19.99997
                            ],
                            [
                                54.26002,
                                19.75912
                            ],
                            [
                                53.51335,
                                19.51222
                            ],
                            [
                                52.75638,
                                19.25798
                            ],
                            [
                                52.0,
                                19.0
                            ],
                            [
                                52.26345,
                                18.4459
                            ],
                            [
                                52.58793,
                                17.76096
                            ],
                            [
                                52.78077,
                                17.35266
                            ],
                            [
                                52.74876,
                                17.29411
                            ],
                            [
                                52.81289,
                                17.28387
                            ],
                            [
                                53.10703,
                                16.65439
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                56.26584,
                                25.62472
                            ],
                            [
                                56.27475,
                                25.7152
                            ],
                            [
                                56.36002,
                                25.80448
                            ],
                            [
                                56.39992,
                                25.88914
                            ],
                            [
                                56.42828,
                                26.0422
                            ],
                            [
                                56.34881,
                                26.16774
                            ],
                            [
                                56.41066,
                                26.17321
                            ],
                            [
                                56.42683,
                                26.23178
                            ],
                            [
                                56.3974,
                                26.28179
                            ],
                            [
                                56.43975,
                                26.33181
                            ],
                            [
                                56.36451,
                                26.37162
                            ],
                            [
                                56.29845,
                                26.21195
                            ],
                            [
                                56.18138,
                                26.22703
                            ],
                            [
                                56.086,
                                26.05065
                            ],
                            [
                                56.15345,
                                26.06864
                            ],
                            [
                                56.19074,
                                25.9717
                            ],
                            [
                                56.14165,
                                25.82377
                            ],
                            [
                                56.17884,
                                25.6236
                            ],
                            [
                                56.26584,
                                25.62472
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                58.6216,
                                20.26545
                            ],
                            [
                                58.66689,
                                20.18843
                            ],
                            [
                                58.77913,
                                20.27473
                            ],
                            [
                                58.82219,
                                20.41664
                            ],
                            [
                                58.94417,
                                20.49482
                            ],
                            [
                                58.89972,
                                20.62037
                            ],
                            [
                                58.81705,
                                20.57756
                            ],
                            [
                                58.78102,
                                20.46568
                            ],
                            [
                                58.7083,
                                20.42979
                            ],
                            [
                                58.631,
                                20.34164
                            ],
                            [
                                58.6216,
                                20.26545
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                56.22338,
                                25.26201
                            ],
                            [
                                56.28226,
                                25.23678
                            ],
                            [
                                56.35056,
                                25.30419
                            ],
                            [
                                56.27596,
                                25.3373
                            ],
                            [
                                56.22338,
                                25.26201
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                55.96212,
                                17.50837
                            ],
                            [
                                56.0502,
                                17.48389
                            ],
                            [
                                56.05535,
                                17.54827
                            ],
                            [
                                55.96212,
                                17.50837
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "PAK",
                "Country": "Pakistan",
                "Total_3GHG": 0.76,
                "Total_3GHG_timeseries": [
                    9.6004e-06,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0047,
                    0.0048,
                    0.005,
                    0.0051,
                    0.0053,
                    0.0055,
                    0.0057,
                    0.0058,
                    0.006,
                    0.0062,
                    0.0064,
                    0.0066,
                    0.0068,
                    0.0071,
                    0.0073,
                    0.0075,
                    0.0078,
                    0.008,
                    0.0083,
                    0.0085,
                    0.0088,
                    0.009,
                    0.0093,
                    0.0096,
                    0.0099,
                    0.0101,
                    0.0105,
                    0.0108,
                    0.0111,
                    0.0114,
                    0.0118,
                    0.0121,
                    0.0125
                ],
                "Fossil_3GHG": 0.52,
                "Fossil_3GHG_timeseries": [
                    1.1356e-06,
                    2.2845e-06,
                    3.4467e-06,
                    4.6224e-06,
                    5.8115e-06,
                    7.014e-06,
                    8.2299e-06,
                    9.4593e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0044,
                    0.0045,
                    0.0047,
                    0.0048,
                    0.005,
                    0.0051,
                    0.0053,
                    0.0055
                ],
                "Land_3GHG": 1.22,
                "Land_3GHG_timeseries": [
                    8.4648e-06,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0055,
                    0.0056,
                    0.0058,
                    0.0059,
                    0.0061,
                    0.0063,
                    0.0064,
                    0.0066,
                    0.0068,
                    0.007
                ],
                "Total_CO2": 0.3,
                "Total_CO2_timeseries": [
                    3.1652e-06,
                    6.347e-06,
                    9.5372e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034
                ],
                "Fossil_CO2": 0.32,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2.8535e-07,
                    5.8044e-07,
                    9.0558e-07,
                    1.367e-06,
                    3.7784e-06,
                    6.7563e-06,
                    9.9011e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025
                ],
                "Land_CO2": 0.26,
                "Land_CO2_timeseries": [
                    3.1652e-06,
                    6.347e-06,
                    9.5372e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009
                ],
                "Total_CH4": 1.91,
                "Total_CH4_timeseries": [
                    5.4406e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0046,
                    0.0047,
                    0.0049,
                    0.005,
                    0.0052,
                    0.0054,
                    0.0055,
                    0.0057,
                    0.0058,
                    0.006,
                    0.0062,
                    0.0064,
                    0.0066,
                    0.0067,
                    0.0069,
                    0.0071,
                    0.0073,
                    0.0075,
                    0.0078,
                    0.008
                ],
                "Fossil_CH4": 1.09,
                "Fossil_CH4_timeseries": [
                    1.0504e-06,
                    2.1129e-06,
                    3.1876e-06,
                    4.2746e-06,
                    5.374e-06,
                    6.4858e-06,
                    7.61e-06,
                    8.7469e-06,
                    9.8964e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028
                ],
                "Land_CH4": 3.27,
                "Land_CH4_timeseries": [
                    4.3902e-06,
                    8.8182e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0044,
                    0.0045,
                    0.0047,
                    0.0048,
                    0.005,
                    0.0051
                ],
                "Total_N2O": 1.34,
                "Total_N2O_timeseries": [
                    9.9456e-07,
                    2.0085e-06,
                    3.041e-06,
                    4.0909e-06,
                    5.1569e-06,
                    6.2371e-06,
                    7.3295e-06,
                    8.4318e-06,
                    9.5413e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011
                ],
                "Fossil_N2O": 0.73,
                "Fossil_N2O_timeseries": [
                    8.519e-08,
                    1.7157e-07,
                    2.5911e-07,
                    3.4777e-07,
                    4.375e-07,
                    5.2823e-07,
                    6.199e-07,
                    7.124e-07,
                    8.0565e-07,
                    8.9954e-07,
                    9.94e-07,
                    1.089e-06,
                    1.1846e-06,
                    1.2806e-06,
                    1.3772e-06,
                    1.4744e-06,
                    1.572e-06,
                    1.6703e-06,
                    1.769e-06,
                    1.8683e-06,
                    1.9688e-06,
                    2.0715e-06,
                    2.1771e-06,
                    2.2861e-06,
                    2.3988e-06,
                    2.5154e-06,
                    2.6357e-06,
                    2.7592e-06,
                    2.8855e-06,
                    3.0135e-06,
                    3.1428e-06,
                    3.2732e-06,
                    3.4046e-06,
                    3.537e-06,
                    3.6703e-06,
                    3.8044e-06,
                    3.9395e-06,
                    4.0755e-06,
                    4.2124e-06,
                    4.3545e-06,
                    4.4987e-06,
                    4.645e-06,
                    4.7935e-06,
                    4.9444e-06,
                    5.0978e-06,
                    5.2537e-06,
                    5.4124e-06,
                    5.5737e-06,
                    5.738e-06,
                    5.9053e-06,
                    6.0758e-06,
                    6.25e-06,
                    6.4282e-06,
                    6.6107e-06,
                    6.7975e-06,
                    6.9886e-06,
                    7.184e-06,
                    7.3834e-06,
                    7.5865e-06,
                    7.7929e-06,
                    8.0022e-06,
                    8.2143e-06,
                    8.4291e-06,
                    8.6465e-06,
                    8.8665e-06,
                    9.0889e-06,
                    9.3138e-06,
                    9.5411e-06,
                    9.7708e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_N2O": 1.58,
                "Land_N2O_timeseries": [
                    9.0937e-07,
                    1.8369e-06,
                    2.7819e-06,
                    3.7432e-06,
                    4.7194e-06,
                    5.7089e-06,
                    6.7096e-06,
                    7.7194e-06,
                    8.7356e-06,
                    9.7554e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            61.61045,
                            25.19495
                        ],
                        [
                            61.7775,
                            25.16131
                        ],
                        [
                            61.78587,
                            25.12554
                        ],
                        [
                            61.73111,
                            25.03407
                        ],
                        [
                            61.84807,
                            25.03888
                        ],
                        [
                            61.86842,
                            25.09093
                        ],
                        [
                            61.9326,
                            25.1101
                        ],
                        [
                            62.07826,
                            25.10597
                        ],
                        [
                            62.05641,
                            25.15583
                        ],
                        [
                            62.13505,
                            25.21687
                        ],
                        [
                            62.26917,
                            25.20165
                        ],
                        [
                            62.31641,
                            25.13562
                        ],
                        [
                            62.4773,
                            25.25587
                        ],
                        [
                            62.60637,
                            25.26874
                        ],
                        [
                            62.79036,
                            25.25022
                        ],
                        [
                            62.99782,
                            25.21195
                        ],
                        [
                            63.13255,
                            25.25605
                        ],
                        [
                            63.4867,
                            25.2078
                        ],
                        [
                            63.46212,
                            25.28548
                        ],
                        [
                            63.59078,
                            25.37139
                        ],
                        [
                            63.74683,
                            25.38081
                        ],
                        [
                            63.89462,
                            25.34207
                        ],
                        [
                            64.02597,
                            25.32744
                        ],
                        [
                            64.03579,
                            25.40209
                        ],
                        [
                            63.96696,
                            25.39162
                        ],
                        [
                            63.92163,
                            25.4213
                        ],
                        [
                            63.97435,
                            25.47986
                        ],
                        [
                            64.03593,
                            25.47151
                        ],
                        [
                            64.11793,
                            25.49612
                        ],
                        [
                            64.21339,
                            25.47503
                        ],
                        [
                            64.21158,
                            25.42295
                        ],
                        [
                            64.1158,
                            25.32608
                        ],
                        [
                            64.20835,
                            25.31539
                        ],
                        [
                            64.39791,
                            25.24059
                        ],
                        [
                            64.51651,
                            25.27245
                        ],
                        [
                            64.61384,
                            25.22138
                        ],
                        [
                            64.71768,
                            25.31033
                        ],
                        [
                            64.80165,
                            25.32544
                        ],
                        [
                            65.0251,
                            25.31874
                        ],
                        [
                            65.11528,
                            25.30417
                        ],
                        [
                            65.2224,
                            25.31814
                        ],
                        [
                            65.27151,
                            25.37782
                        ],
                        [
                            65.46022,
                            25.38851
                        ],
                        [
                            65.64031,
                            25.35556
                        ],
                        [
                            65.77056,
                            25.38578
                        ],
                        [
                            65.81924,
                            25.41502
                        ],
                        [
                            65.98056,
                            25.41735
                        ],
                        [
                            66.12427,
                            25.44809
                        ],
                        [
                            66.27499,
                            25.46653
                        ],
                        [
                            66.39388,
                            25.44872
                        ],
                        [
                            66.47814,
                            25.41106
                        ],
                        [
                            66.51157,
                            25.48977
                        ],
                        [
                            66.38741,
                            25.49711
                        ],
                        [
                            66.34531,
                            25.54213
                        ],
                        [
                            66.21664,
                            25.49184
                        ],
                        [
                            66.10685,
                            25.4649
                        ],
                        [
                            66.1401,
                            25.54614
                        ],
                        [
                            66.29147,
                            25.61686
                        ],
                        [
                            66.49433,
                            25.56894
                        ],
                        [
                            66.54603,
                            25.54201
                        ],
                        [
                            66.58899,
                            25.42413
                        ],
                        [
                            66.56751,
                            25.3444
                        ],
                        [
                            66.69958,
                            25.24298
                        ],
                        [
                            66.74479,
                            25.17925
                        ],
                        [
                            66.70615,
                            25.08508
                        ],
                        [
                            66.69125,
                            24.89598
                        ],
                        [
                            66.67252,
                            24.82811
                        ],
                        [
                            66.88303,
                            24.86371
                        ],
                        [
                            66.97704,
                            24.85388
                        ],
                        [
                            67.08086,
                            24.75085
                        ],
                        [
                            67.17384,
                            24.80443
                        ],
                        [
                            67.24666,
                            24.81604
                        ],
                        [
                            67.33208,
                            24.78893
                        ],
                        [
                            67.47331,
                            24.77898
                        ],
                        [
                            67.50567,
                            24.73181
                        ],
                        [
                            67.46373,
                            24.54821
                        ],
                        [
                            67.4803,
                            24.48821
                        ],
                        [
                            67.45222,
                            24.45276
                        ],
                        [
                            67.54103,
                            24.41463
                        ],
                        [
                            67.57974,
                            24.33403
                        ],
                        [
                            67.53879,
                            24.28253
                        ],
                        [
                            67.50777,
                            24.17906
                        ],
                        [
                            67.54709,
                            24.13426
                        ],
                        [
                            67.5223,
                            24.04309
                        ],
                        [
                            67.59983,
                            24.01983
                        ],
                        [
                            67.73858,
                            24.07087
                        ],
                        [
                            67.77545,
                            24.17854
                        ],
                        [
                            67.81071,
                            24.19387
                        ],
                        [
                            67.94666,
                            24.16973
                        ],
                        [
                            68.00053,
                            24.12945
                        ],
                        [
                            68.12116,
                            24.14331
                        ],
                        [
                            68.21207,
                            24.23317
                        ],
                        [
                            68.2487,
                            24.1015
                        ],
                        [
                            68.40088,
                            24.15547
                        ],
                        [
                            68.43998,
                            24.12917
                        ],
                        [
                            68.58218,
                            24.20838
                        ],
                        [
                            68.56636,
                            24.32984
                        ],
                        [
                            68.68656,
                            24.38955
                        ],
                        [
                            68.77251,
                            24.32844
                        ],
                        [
                            68.85224,
                            24.32711
                        ],
                        [
                            68.88792,
                            24.26189
                        ],
                        [
                            68.95753,
                            24.26084
                        ],
                        [
                            68.95822,
                            24.25881
                        ],
                        [
                            69.01284,
                            24.22898
                        ],
                        [
                            69.08508,
                            24.26808
                        ],
                        [
                            69.18811,
                            24.23639
                        ],
                        [
                            69.31004,
                            24.27665
                        ],
                        [
                            69.50203,
                            24.26298
                        ],
                        [
                            69.58931,
                            24.28644
                        ],
                        [
                            69.72605,
                            24.17516
                        ],
                        [
                            69.91251,
                            24.16421
                        ],
                        [
                            70.02418,
                            24.16941
                        ],
                        [
                            70.08288,
                            24.22552
                        ],
                        [
                            70.09373,
                            24.29732
                        ],
                        [
                            70.15888,
                            24.28909
                        ],
                        [
                            70.21762,
                            24.32967
                        ],
                        [
                            70.37087,
                            24.35687
                        ],
                        [
                            70.6156,
                            24.42333
                        ],
                        [
                            70.58015,
                            24.34868
                        ],
                        [
                            70.57629,
                            24.25263
                        ],
                        [
                            70.66091,
                            24.22315
                        ],
                        [
                            70.8069,
                            24.22412
                        ],
                        [
                            70.89918,
                            24.26119
                        ],
                        [
                            70.87274,
                            24.30493
                        ],
                        [
                            70.98087,
                            24.36332
                        ],
                        [
                            71.051,
                            24.36302
                        ],
                        [
                            71.0924,
                            24.4357
                        ],
                        [
                            71.02195,
                            24.43352
                        ],
                        [
                            70.9944,
                            24.47477
                        ],
                        [
                            70.99048,
                            24.60555
                        ],
                        [
                            71.08603,
                            24.69326
                        ],
                        [
                            70.96257,
                            24.88726
                        ],
                        [
                            70.91786,
                            24.98666
                        ],
                        [
                            70.88117,
                            25.14603
                        ],
                        [
                            70.7526,
                            25.27163
                        ],
                        [
                            70.73709,
                            25.32581
                        ],
                        [
                            70.6659,
                            25.39603
                        ],
                        [
                            70.67241,
                            25.66128
                        ],
                        [
                            70.63984,
                            25.71545
                        ],
                        [
                            70.52651,
                            25.68856
                        ],
                        [
                            70.37449,
                            25.68133
                        ],
                        [
                            70.2755,
                            25.7113
                        ],
                        [
                            70.22511,
                            25.79242
                        ],
                        [
                            70.1451,
                            25.86846
                        ],
                        [
                            70.09131,
                            25.96519
                        ],
                        [
                            70.08071,
                            26.05858
                        ],
                        [
                            70.14528,
                            26.16633
                        ],
                        [
                            70.17264,
                            26.24502
                        ],
                        [
                            70.18388,
                            26.48691
                        ],
                        [
                            70.16784,
                            26.55043
                        ],
                        [
                            70.10695,
                            26.58948
                        ],
                        [
                            70.02492,
                            26.59871
                        ],
                        [
                            69.85542,
                            26.58295
                        ],
                        [
                            69.77206,
                            26.61368
                        ],
                        [
                            69.699,
                            26.66495
                        ],
                        [
                            69.51711,
                            26.73916
                        ],
                        [
                            69.48395,
                            26.80734
                        ],
                        [
                            69.5133,
                            27.01639
                        ],
                        [
                            69.57723,
                            27.1635
                        ],
                        [
                            69.66524,
                            27.25074
                        ],
                        [
                            69.86183,
                            27.4029
                        ],
                        [
                            69.9371,
                            27.50251
                        ],
                        [
                            70.0163,
                            27.5565
                        ],
                        [
                            70.1076,
                            27.76614
                        ],
                        [
                            70.20763,
                            27.88511
                        ],
                        [
                            70.36786,
                            28.00851
                        ],
                        [
                            70.47678,
                            28.03322
                        ],
                        [
                            70.5624,
                            28.01963
                        ],
                        [
                            70.67067,
                            27.91628
                        ],
                        [
                            70.67896,
                            27.83826
                        ],
                        [
                            70.75716,
                            27.71835
                        ],
                        [
                            70.88874,
                            27.70666
                        ],
                        [
                            71.21782,
                            27.8414
                        ],
                        [
                            71.35287,
                            27.86605
                        ],
                        [
                            71.67419,
                            27.88555
                        ],
                        [
                            71.89978,
                            27.96663
                        ],
                        [
                            71.92325,
                            28.11508
                        ],
                        [
                            71.99276,
                            28.20398
                        ],
                        [
                            72.18553,
                            28.36029
                        ],
                        [
                            72.21011,
                            28.40363
                        ],
                        [
                            72.30173,
                            28.66343
                        ],
                        [
                            72.41169,
                            28.78562
                        ],
                        [
                            72.47587,
                            28.80734
                        ],
                        [
                            72.7309,
                            28.95025
                        ],
                        [
                            72.94406,
                            29.03464
                        ],
                        [
                            73.00172,
                            29.1513
                        ],
                        [
                            73.09641,
                            29.25581
                        ],
                        [
                            73.27232,
                            29.55188
                        ],
                        [
                            73.39724,
                            29.93917
                        ],
                        [
                            73.61714,
                            30.02217
                        ],
                        [
                            73.80228,
                            30.06934
                        ],
                        [
                            73.96365,
                            30.19016
                        ],
                        [
                            73.9442,
                            30.30462
                        ],
                        [
                            73.87575,
                            30.3617
                        ],
                        [
                            73.98218,
                            30.49883
                        ],
                        [
                            74.09661,
                            30.56479
                        ],
                        [
                            74.1035,
                            30.61167
                        ],
                        [
                            74.18693,
                            30.66057
                        ],
                        [
                            74.23214,
                            30.71912
                        ],
                        [
                            74.28146,
                            30.73101
                        ],
                        [
                            74.32103,
                            30.84428
                        ],
                        [
                            74.4163,
                            30.90713
                        ],
                        [
                            74.47126,
                            30.96591
                        ],
                        [
                            74.61792,
                            31.02749
                        ],
                        [
                            74.67176,
                            31.09967
                        ],
                        [
                            74.54599,
                            31.13317
                        ],
                        [
                            74.53389,
                            31.19423
                        ],
                        [
                            74.55102,
                            31.29634
                        ],
                        [
                            74.64073,
                            31.46536
                        ],
                        [
                            74.57921,
                            31.6218
                        ],
                        [
                            74.51771,
                            31.72253
                        ],
                        [
                            74.57231,
                            31.82308
                        ],
                        [
                            74.70166,
                            31.92398
                        ],
                        [
                            74.80422,
                            31.94699
                        ],
                        [
                            74.83143,
                            31.9989
                        ],
                        [
                            74.92129,
                            32.05656
                        ],
                        [
                            75.00416,
                            32.02887
                        ],
                        [
                            75.12763,
                            32.07366
                        ],
                        [
                            75.23944,
                            32.08751
                        ],
                        [
                            75.31355,
                            32.15883
                        ],
                        [
                            75.38074,
                            32.26454
                        ],
                        [
                            75.32601,
                            32.3346
                        ],
                        [
                            75.18717,
                            32.42383
                        ],
                        [
                            75.13288,
                            32.41849
                        ],
                        [
                            75.08532,
                            32.47736
                        ],
                        [
                            75.03071,
                            32.491
                        ],
                        [
                            74.97647,
                            32.44818
                        ],
                        [
                            74.81924,
                            32.49541
                        ],
                        [
                            74.70237,
                            32.48456
                        ],
                        [
                            74.64267,
                            32.60846
                        ],
                        [
                            74.67532,
                            32.65785
                        ],
                        [
                            74.65079,
                            32.71894
                        ],
                        [
                            74.69509,
                            32.81143
                        ],
                        [
                            74.64128,
                            32.82104
                        ],
                        [
                            74.61303,
                            32.75829
                        ],
                        [
                            74.53112,
                            32.74211
                        ],
                        [
                            74.4611,
                            32.79057
                        ],
                        [
                            74.45725561909687,
                            32.791915165784467
                        ],
                        [
                            74.399390124854619,
                            32.924345015280878
                        ],
                        [
                            74.310022827950945,
                            32.90945046579693
                        ],
                        [
                            74.339811926918841,
                            33.013712312184545
                        ],
                        [
                            74.20576098156333,
                            33.043501411152434
                        ],
                        [
                            74.146182783627552,
                            33.147763257540049
                        ],
                        [
                            74.012131838272055,
                            33.207341455475827
                        ],
                        [
                            74.027026387755996,
                            33.266919653411605
                        ],
                        [
                            74.086604585691774,
                            33.266919653411605
                        ],
                        [
                            74.161077333111507,
                            33.326497851347384
                        ],
                        [
                            74.190866432079389,
                            33.460548796702881
                        ],
                        [
                            74.11639368465967,
                            33.564810643090496
                        ],
                        [
                            74.027026387755996,
                            33.594599742058385
                        ],
                        [
                            73.967448189820217,
                            33.758439786381771
                        ],
                        [
                            74.086604585691774,
                            33.832912533801498
                        ],
                        [
                            74.161077333111507,
                            33.847807083285446
                        ],
                        [
                            74.250444630015167,
                            33.922279830705165
                        ],
                        [
                            74.220655531047285,
                            34.02654167709278
                        ],
                        [
                            74.11639368465967,
                            34.041436226576721
                        ],
                        [
                            74.027026387755996,
                            34.011647127608832
                        ],
                        [
                            73.878080892916557,
                            34.07122532554461
                        ],
                        [
                            73.967448189820217,
                            34.264854468835892
                        ],
                        [
                            73.892975442400498,
                            34.369116315223501
                        ],
                        [
                            73.773819046528942,
                            34.35422176573956
                        ],
                        [
                            73.803608145496838,
                            34.443589062643227
                        ],
                        [
                            73.878080892916557,
                            34.488272711095057
                        ],
                        [
                            73.892975442400498,
                            34.547850909030842
                        ],
                        [
                            73.967448189820217,
                            34.592534557482672
                        ],
                        [
                            73.967448189820217,
                            34.711690953354228
                        ],
                        [
                            74.161077333111507,
                            34.696796403870287
                        ],
                        [
                            74.369601025886723,
                            34.801058250257896
                        ],
                        [
                            74.593019268145895,
                            34.756374601806066
                        ],
                        [
                            74.712175664017451,
                            34.696796403870287
                        ],
                        [
                            74.920699356792682,
                            34.681901854386339
                        ],
                        [
                            75.084539401116061,
                            34.637218205934509
                        ],
                        [
                            75.129223049567898,
                            34.681901854386339
                        ],
                        [
                            75.293063093891291,
                            34.65211275541845
                        ],
                        [
                            75.382430390794966,
                            34.547850909030842
                        ],
                        [
                            75.784583226861457,
                            34.532956359546894
                        ],
                        [
                            76.097368766024303,
                            34.681901854386339
                        ],
                        [
                            76.156946963960081,
                            34.637218205934509
                        ],
                        [
                            76.484627052606854,
                            34.801058250257896
                        ],
                        [
                            76.559099800026587,
                            34.756374601806066
                        ],
                        [
                            76.708045294866025,
                            34.756374601806066
                        ],
                        [
                            76.782518042285744,
                            34.920214646129452
                        ],
                        [
                            76.901674438157315,
                            34.964898294581289
                        ],
                        [
                            77.005936284544916,
                            34.9351091956134
                        ],
                        [
                            77.035725383512812,
                            35.024476492517067
                        ],
                        [
                            77.110198130932531,
                            35.039371042001008
                        ],
                        [
                            77.557034615450874,
                            35.292578383228069
                        ],
                        [
                            77.823537740956311,
                            35.511491664893249
                        ],
                        [
                            77.81381,
                            35.51865
                        ],
                        [
                            77.69007,
                            35.44961
                        ],
                        [
                            77.51561,
                            35.48268
                        ],
                        [
                            77.39486,
                            35.46879
                        ],
                        [
                            77.30636,
                            35.54061
                        ],
                        [
                            77.19353,
                            35.52026
                        ],
                        [
                            76.99806,
                            35.61172
                        ],
                        [
                            76.95541,
                            35.59387
                        ],
                        [
                            76.84682,
                            35.66815
                        ],
                        [
                            76.75968,
                            35.6568
                        ],
                        [
                            76.68988,
                            35.7482
                        ],
                        [
                            76.59179,
                            35.77307
                        ],
                        [
                            76.56445,
                            35.81927
                        ],
                        [
                            76.59432,
                            35.89643
                        ],
                        [
                            76.54781,
                            35.92051
                        ],
                        [
                            76.36075,
                            35.82585
                        ],
                        [
                            76.29012,
                            35.84192
                        ],
                        [
                            76.17257,
                            35.82311
                        ],
                        [
                            76.16026,
                            35.91579
                        ],
                        [
                            76.10013,
                            36.0195
                        ],
                        [
                            75.98246,
                            36.03091
                        ],
                        [
                            75.94074,
                            36.1386
                        ],
                        [
                            76.01299,
                            36.1669
                        ],
                        [
                            76.05252,
                            36.25253
                        ],
                        [
                            75.9892,
                            36.35383
                        ],
                        [
                            76.03132,
                            36.40814
                        ],
                        [
                            75.93977,
                            36.59996
                        ],
                        [
                            75.85528,
                            36.67178
                        ],
                        [
                            75.72122,
                            36.75047
                        ],
                        [
                            75.53548,
                            36.77303
                        ],
                        [
                            75.45518,
                            36.72204
                        ],
                        [
                            75.42068,
                            36.78559
                        ],
                        [
                            75.42658,
                            36.87334
                        ],
                        [
                            75.40434,
                            36.95635
                        ],
                        [
                            75.23486,
                            36.96506
                        ],
                        [
                            75.16792,
                            37.01407
                        ],
                        [
                            75.02982,
                            37.01667
                        ],
                        [
                            74.92496,
                            36.97541
                        ],
                        [
                            74.8415,
                            37.01457
                        ],
                        [
                            74.73893,
                            37.02782
                        ],
                        [
                            74.70569,
                            37.08477
                        ],
                        [
                            74.56463,
                            37.03085
                        ],
                        [
                            74.42567,
                            37.0103
                        ],
                        [
                            74.30822,
                            36.91893
                        ],
                        [
                            74.23926,
                            36.89504
                        ],
                        [
                            74.17661,
                            36.91616
                        ],
                        [
                            74.12075,
                            36.83894
                        ],
                        [
                            74.0463,
                            36.82646
                        ],
                        [
                            73.95782,
                            36.84301
                        ],
                        [
                            73.8907,
                            36.91217
                        ],
                        [
                            73.60066,
                            36.90775
                        ],
                        [
                            73.37599,
                            36.87988
                        ],
                        [
                            73.2681,
                            36.89042
                        ],
                        [
                            73.06919,
                            36.88515
                        ],
                        [
                            72.93059,
                            36.8446
                        ],
                        [
                            72.7175,
                            36.83837
                        ],
                        [
                            72.65077,
                            36.85071
                        ],
                        [
                            72.56055,
                            36.82716
                        ],
                        [
                            72.49848,
                            36.78032
                        ],
                        [
                            72.24847,
                            36.75079
                        ],
                        [
                            72.18804,
                            36.71334
                        ],
                        [
                            72.20715,
                            36.66853
                        ],
                        [
                            72.09799,
                            36.64559
                        ],
                        [
                            72.08177,
                            36.59046
                        ],
                        [
                            71.93895,
                            36.54641
                        ],
                        [
                            71.91233,
                            36.5087
                        ],
                        [
                            71.8075,
                            36.50466
                        ],
                        [
                            71.80567,
                            36.40138
                        ],
                        [
                            71.65778,
                            36.48092
                        ],
                        [
                            71.57651,
                            36.32989
                        ],
                        [
                            71.44606,
                            36.26782
                        ],
                        [
                            71.43248,
                            36.23124
                        ],
                        [
                            71.25656,
                            36.13339
                        ],
                        [
                            71.19915,
                            36.05262
                        ],
                        [
                            71.32124,
                            35.961
                        ],
                        [
                            71.3821,
                            35.9564
                        ],
                        [
                            71.49148,
                            35.75456
                        ],
                        [
                            71.55152,
                            35.724
                        ],
                        [
                            71.50091,
                            35.62914
                        ],
                        [
                            71.61733,
                            35.55293
                        ],
                        [
                            71.59443,
                            35.50067
                        ],
                        [
                            71.65675,
                            35.44195
                        ],
                        [
                            71.54416,
                            35.31044
                        ],
                        [
                            71.63234,
                            35.22665
                        ],
                        [
                            71.68074,
                            35.20874
                        ],
                        [
                            71.62387,
                            35.14011
                        ],
                        [
                            71.53319,
                            35.09157
                        ],
                        [
                            71.54674,
                            35.01995
                        ],
                        [
                            71.47282,
                            34.94979
                        ],
                        [
                            71.34816,
                            34.91205
                        ],
                        [
                            71.29665,
                            34.87565
                        ],
                        [
                            71.28103,
                            34.80561
                        ],
                        [
                            71.08932,
                            34.67545
                        ],
                        [
                            71.11615,
                            34.62812
                        ],
                        [
                            71.01222,
                            34.53499
                        ],
                        [
                            71.0242,
                            34.45182
                        ],
                        [
                            71.10793,
                            34.43238
                        ],
                        [
                            71.11698,
                            34.37659
                        ],
                        [
                            71.1754,
                            34.36279
                        ],
                        [
                            71.12014,
                            34.24119
                        ],
                        [
                            71.12937,
                            34.16458
                        ],
                        [
                            71.07136,
                            34.1089
                        ],
                        [
                            71.08182,
                            34.06302
                        ],
                        [
                            70.96841,
                            34.02955
                        ],
                        [
                            70.88214,
                            33.97382
                        ],
                        [
                            70.49637,
                            33.94015
                        ],
                        [
                            70.41928,
                            33.96647
                        ],
                        [
                            70.20056,
                            33.98153
                        ],
                        [
                            69.99156,
                            34.04723
                        ],
                        [
                            69.88932,
                            34.01821
                        ],
                        [
                            69.86001,
                            33.92544
                        ],
                        [
                            69.91057,
                            33.89548
                        ],
                        [
                            69.96359,
                            33.77128
                        ],
                        [
                            70.00191,
                            33.73335
                        ],
                        [
                            70.14179,
                            33.72423
                        ],
                        [
                            70.14498,
                            33.65768
                        ],
                        [
                            70.1978,
                            33.61738
                        ],
                        [
                            70.17363,
                            33.51801
                        ],
                        [
                            70.25379,
                            33.43706
                        ],
                        [
                            70.29623,
                            33.42993
                        ],
                        [
                            70.32446,
                            33.35483
                        ],
                        [
                            70.16103,
                            33.21833
                        ],
                        [
                            70.07059,
                            33.2168
                        ],
                        [
                            70.02134,
                            33.14134
                        ],
                        [
                            69.87318,
                            33.0956
                        ],
                        [
                            69.79566,
                            33.12978
                        ],
                        [
                            69.71319,
                            33.09138
                        ],
                        [
                            69.57969,
                            33.0998
                        ],
                        [
                            69.50067,
                            33.02295
                        ],
                        [
                            69.50095,
                            32.8875
                        ],
                        [
                            69.38997,
                            32.77359
                        ],
                        [
                            69.45037,
                            32.65572
                        ],
                        [
                            69.38105,
                            32.56339
                        ],
                        [
                            69.28015,
                            32.52754
                        ],
                        [
                            69.24017,
                            32.459
                        ],
                        [
                            69.27522,
                            32.36752
                        ],
                        [
                            69.27184,
                            32.15087
                        ],
                        [
                            69.29535,
                            32.01561
                        ],
                        [
                            69.32578,
                            31.93228
                        ],
                        [
                            69.19944,
                            31.85274
                        ],
                        [
                            69.11603,
                            31.70494
                        ],
                        [
                            69.0167,
                            31.63136
                        ],
                        [
                            68.96303,
                            31.64536
                        ],
                        [
                            68.91229,
                            31.59926
                        ],
                        [
                            68.79168,
                            31.62552
                        ],
                        [
                            68.72912,
                            31.69681
                        ],
                        [
                            68.70648,
                            31.76677
                        ],
                        [
                            68.64204,
                            31.7806
                        ],
                        [
                            68.57627,
                            31.82973
                        ],
                        [
                            68.42481,
                            31.75524
                        ],
                        [
                            68.2832,
                            31.75909
                        ],
                        [
                            68.25787,
                            31.80252
                        ],
                        [
                            68.17007,
                            31.83006
                        ],
                        [
                            68.06692,
                            31.69646
                        ],
                        [
                            67.97825,
                            31.64333
                        ],
                        [
                            67.82385,
                            31.60161
                        ],
                        [
                            67.71376,
                            31.51535
                        ],
                        [
                            67.57358,
                            31.52178
                        ],
                        [
                            67.60349,
                            31.4253
                        ],
                        [
                            67.65578,
                            31.39417
                        ],
                        [
                            67.74655,
                            31.41472
                        ],
                        [
                            67.79485,
                            31.38042
                        ],
                        [
                            67.7855,
                            31.33316
                        ],
                        [
                            67.72275,
                            31.3255
                        ],
                        [
                            67.64877,
                            31.27886
                        ],
                        [
                            67.54882,
                            31.26165
                        ],
                        [
                            67.39614,
                            31.21154
                        ],
                        [
                            67.26901,
                            31.20072
                        ],
                        [
                            67.17013,
                            31.24229
                        ],
                        [
                            67.0654,
                            31.21702
                        ],
                        [
                            67.0263,
                            31.25653
                        ],
                        [
                            67.03613,
                            31.30997
                        ],
                        [
                            66.95415,
                            31.30633
                        ],
                        [
                            66.83316,
                            31.26242
                        ],
                        [
                            66.81106,
                            31.22256
                        ],
                        [
                            66.72992,
                            31.20588
                        ],
                        [
                            66.66934,
                            31.06392
                        ],
                        [
                            66.58085,
                            30.97965
                        ],
                        [
                            66.3926,
                            30.93813
                        ],
                        [
                            66.29056,
                            30.58483
                        ],
                        [
                            66.28808,
                            30.52817
                        ],
                        [
                            66.3548,
                            30.48085
                        ],
                        [
                            66.32461,
                            30.24757
                        ],
                        [
                            66.23806,
                            30.05932
                        ],
                        [
                            66.37034,
                            29.96891
                        ],
                        [
                            66.24423,
                            29.84758
                        ],
                        [
                            65.52252,
                            29.65316
                        ],
                        [
                            65.06677,
                            29.53042
                        ],
                        [
                            64.58163,
                            29.5848
                        ],
                        [
                            64.25094,
                            29.51678
                        ],
                        [
                            64.14243,
                            29.43625
                        ],
                        [
                            64.09844,
                            29.38016
                        ],
                        [
                            64.05234,
                            29.40741
                        ],
                        [
                            63.57599,
                            29.4869
                        ],
                        [
                            62.46983,
                            29.38894
                        ],
                        [
                            61.64878,
                            29.63315
                        ],
                        [
                            60.87297,
                            29.85847
                        ],
                        [
                            61.19034,
                            29.50491
                        ],
                        [
                            61.37155,
                            29.34875
                        ],
                        [
                            61.35904,
                            29.28063
                        ],
                        [
                            61.42703,
                            29.19435
                        ],
                        [
                            61.5035,
                            29.05355
                        ],
                        [
                            61.50603,
                            29.00627
                        ],
                        [
                            61.682,
                            28.77021
                        ],
                        [
                            61.80465,
                            28.64089
                        ],
                        [
                            61.95664,
                            28.54944
                        ],
                        [
                            62.11239,
                            28.48639
                        ],
                        [
                            62.2957,
                            28.46337
                        ],
                        [
                            62.44134,
                            28.40534
                        ],
                        [
                            62.59281,
                            28.25572
                        ],
                        [
                            62.78378,
                            28.28071
                        ],
                        [
                            62.79634,
                            28.20782
                        ],
                        [
                            62.76854,
                            28.03159
                        ],
                        [
                            62.79009,
                            27.97703
                        ],
                        [
                            62.82019,
                            27.80243
                        ],
                        [
                            62.85526,
                            27.46715
                        ],
                        [
                            62.80812,
                            27.34125
                        ],
                        [
                            62.82054,
                            27.21282
                        ],
                        [
                            62.9781,
                            27.19564
                        ],
                        [
                            63.05661,
                            27.23217
                        ],
                        [
                            63.18532,
                            27.24068
                        ],
                        [
                            63.29723,
                            27.18022
                        ],
                        [
                            63.31685,
                            27.13892
                        ],
                        [
                            63.2561,
                            27.0817
                        ],
                        [
                            63.25683,
                            26.92971
                        ],
                        [
                            63.27369,
                            26.86451
                        ],
                        [
                            63.19281,
                            26.84293
                        ],
                        [
                            63.20011,
                            26.74132
                        ],
                        [
                            63.16155,
                            26.64412
                        ],
                        [
                            62.77869,
                            26.65211
                        ],
                        [
                            62.60748,
                            26.58514
                        ],
                        [
                            62.43691,
                            26.56874
                        ],
                        [
                            62.40272,
                            26.53942
                        ],
                        [
                            62.30501,
                            26.52264
                        ],
                        [
                            62.30723,
                            26.47462
                        ],
                        [
                            62.26546,
                            26.41243
                        ],
                        [
                            62.2825,
                            26.35917
                        ],
                        [
                            62.12817,
                            26.37881
                        ],
                        [
                            62.12037,
                            26.31704
                        ],
                        [
                            62.06058,
                            26.3149
                        ],
                        [
                            61.84794,
                            26.22724
                        ],
                        [
                            61.76591,
                            25.80134
                        ],
                        [
                            61.68955,
                            25.79771
                        ],
                        [
                            61.70216,
                            25.67105
                        ],
                        [
                            61.68072,
                            25.65421
                        ],
                        [
                            61.66982,
                            25.4219
                        ],
                        [
                            61.65561,
                            25.2975
                        ],
                        [
                            61.61045,
                            25.19495
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "PLW",
                "Country": "Palau",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    4.1409e-09,
                    8.3348e-09,
                    1.2582e-08,
                    1.6882e-08,
                    2.1234e-08,
                    2.5639e-08,
                    3.0096e-08,
                    3.4604e-08,
                    3.9163e-08,
                    4.3771e-08,
                    4.8423e-08,
                    5.312e-08,
                    5.7861e-08,
                    6.2647e-08,
                    6.7478e-08,
                    7.2354e-08,
                    7.7276e-08,
                    8.2244e-08,
                    8.7259e-08,
                    9.2321e-08,
                    9.7429e-08,
                    1.0259e-07,
                    1.0783e-07,
                    1.1313e-07,
                    1.1851e-07,
                    1.2397e-07,
                    1.2951e-07,
                    1.3511e-07,
                    1.4078e-07,
                    1.465e-07,
                    1.5225e-07,
                    1.5805e-07,
                    1.6391e-07,
                    1.6983e-07,
                    1.7581e-07,
                    1.8184e-07,
                    1.8792e-07,
                    1.9407e-07,
                    2.0028e-07,
                    2.0666e-07,
                    2.131e-07,
                    2.1959e-07,
                    2.2614e-07,
                    2.3275e-07,
                    2.3943e-07,
                    2.4617e-07,
                    2.5299e-07,
                    2.5987e-07,
                    2.6683e-07,
                    2.7386e-07,
                    2.8099e-07,
                    2.8822e-07,
                    2.9553e-07,
                    3.0295e-07,
                    3.1046e-07,
                    3.1807e-07,
                    3.2577e-07,
                    3.3355e-07,
                    3.4141e-07,
                    3.4933e-07,
                    3.5731e-07,
                    3.6537e-07,
                    3.7349e-07,
                    3.8167e-07,
                    3.8992e-07,
                    3.9822e-07,
                    4.0657e-07,
                    4.1496e-07,
                    4.2339e-07,
                    4.3185e-07,
                    4.4034e-07,
                    4.4883e-07,
                    4.5731e-07,
                    4.6578e-07,
                    4.7424e-07,
                    4.8268e-07,
                    4.9112e-07,
                    4.9955e-07,
                    5.0797e-07,
                    5.1642e-07,
                    5.2492e-07,
                    5.3349e-07,
                    5.4213e-07,
                    5.5087e-07,
                    5.5971e-07,
                    5.6866e-07,
                    5.7772e-07,
                    5.8691e-07,
                    5.9622e-07,
                    6.0564e-07,
                    6.1518e-07,
                    6.2485e-07,
                    6.3466e-07,
                    6.4461e-07,
                    6.55e-07,
                    6.6584e-07,
                    6.7707e-07,
                    6.8869e-07,
                    7.0068e-07,
                    7.1305e-07,
                    7.2589e-07,
                    7.3927e-07,
                    7.5324e-07,
                    7.6784e-07,
                    7.8328e-07,
                    7.9945e-07,
                    8.1647e-07,
                    8.3428e-07,
                    8.529e-07,
                    8.7233e-07,
                    8.9403e-07,
                    9.1671e-07,
                    9.4057e-07,
                    9.6564e-07,
                    9.9193e-07,
                    1.019e-06,
                    1.0475e-06,
                    1.0771e-06,
                    1.1122e-06,
                    1.3683e-06,
                    1.6244e-06,
                    1.8805e-06,
                    2.1365e-06,
                    2.3923e-06,
                    2.6477e-06,
                    2.903e-06,
                    3.1578e-06,
                    3.4122e-06,
                    3.6662e-06,
                    3.9197e-06,
                    4.1755e-06,
                    4.4291e-06,
                    4.6922e-06,
                    4.9833e-06,
                    5.217e-06,
                    5.472e-06,
                    5.739e-06,
                    5.9935e-06,
                    6.2547e-06,
                    6.3131e-06,
                    6.3688e-06,
                    6.4902e-06,
                    6.6172e-06,
                    6.8754e-06,
                    7.0458e-06,
                    7.1914e-06,
                    7.3082e-06,
                    7.3884e-06,
                    7.5046e-06,
                    7.536e-06,
                    7.5646e-06,
                    7.52e-06,
                    7.4781e-06,
                    7.4191e-06,
                    7.4706e-06,
                    7.5023e-06,
                    7.4984e-06,
                    7.4871e-06,
                    7.4984e-06,
                    7.4842e-06,
                    7.4669e-06,
                    7.4919e-06,
                    7.4453e-06,
                    7.2813e-06,
                    7.1977e-06,
                    7.1374e-06,
                    7.113e-06,
                    7.115e-06,
                    7.0908e-06,
                    7.1409e-06,
                    7.2004e-06,
                    7.3206e-06
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    4.1386e-09,
                    8.3301e-09,
                    1.2575e-08,
                    1.6872e-08,
                    2.1222e-08,
                    2.5625e-08,
                    3.0079e-08,
                    3.4585e-08,
                    3.914e-08,
                    4.3746e-08,
                    4.8396e-08,
                    5.309e-08,
                    5.7828e-08,
                    6.2612e-08,
                    6.744e-08,
                    7.2313e-08,
                    7.7233e-08,
                    8.2198e-08,
                    8.721e-08,
                    9.227e-08,
                    9.7375e-08,
                    1.0254e-07,
                    1.0777e-07,
                    1.1307e-07,
                    1.1845e-07,
                    1.239e-07,
                    1.2943e-07,
                    1.3503e-07,
                    1.407e-07,
                    1.4642e-07,
                    1.5216e-07,
                    1.5796e-07,
                    1.6382e-07,
                    1.6973e-07,
                    1.757e-07,
                    1.8172e-07,
                    1.8781e-07,
                    1.9395e-07,
                    2.0016e-07,
                    2.0653e-07,
                    2.1296e-07,
                    2.1945e-07,
                    2.26e-07,
                    2.326e-07,
                    2.3928e-07,
                    2.4601e-07,
                    2.5282e-07,
                    2.5971e-07,
                    2.6666e-07,
                    2.7369e-07,
                    2.8082e-07,
                    2.8803e-07,
                    2.9535e-07,
                    3.0276e-07,
                    3.1026e-07,
                    3.1787e-07,
                    3.2556e-07,
                    3.3334e-07,
                    3.4119e-07,
                    3.4911e-07,
                    3.5709e-07,
                    3.6514e-07,
                    3.7325e-07,
                    3.8143e-07,
                    3.8967e-07,
                    3.9796e-07,
                    4.0631e-07,
                    4.1469e-07,
                    4.2312e-07,
                    4.3157e-07,
                    4.4005e-07,
                    4.4853e-07,
                    4.5701e-07,
                    4.6548e-07,
                    4.7394e-07,
                    4.8237e-07,
                    4.9079e-07,
                    4.9922e-07,
                    5.0764e-07,
                    5.1607e-07,
                    5.2457e-07,
                    5.3313e-07,
                    5.4177e-07,
                    5.505e-07,
                    5.5933e-07,
                    5.6827e-07,
                    5.7733e-07,
                    5.8651e-07,
                    5.9581e-07,
                    6.0523e-07,
                    6.1476e-07,
                    6.2443e-07,
                    6.3423e-07,
                    6.4418e-07,
                    6.5456e-07,
                    6.6538e-07,
                    6.7661e-07,
                    6.8821e-07,
                    7.002e-07,
                    7.1255e-07,
                    7.2538e-07,
                    7.3876e-07,
                    7.5271e-07,
                    7.6729e-07,
                    7.8272e-07,
                    7.9888e-07,
                    8.1589e-07,
                    8.3369e-07,
                    8.5229e-07,
                    8.7171e-07,
                    8.934e-07,
                    9.1606e-07,
                    9.399e-07,
                    9.6496e-07,
                    9.9123e-07,
                    1.0183e-06,
                    1.0467e-06,
                    1.0763e-06,
                    1.1114e-06,
                    1.3675e-06,
                    1.6236e-06,
                    1.8797e-06,
                    2.1356e-06,
                    2.3914e-06,
                    2.6468e-06,
                    2.902e-06,
                    3.1568e-06,
                    3.4112e-06,
                    3.6652e-06,
                    3.9186e-06,
                    4.1744e-06,
                    4.428e-06,
                    4.6911e-06,
                    4.9821e-06,
                    5.2158e-06,
                    5.4709e-06,
                    5.7378e-06,
                    5.9922e-06,
                    6.2534e-06,
                    6.3118e-06,
                    6.3675e-06,
                    6.4889e-06,
                    6.6159e-06,
                    6.8714e-06,
                    7.036e-06,
                    7.1786e-06,
                    7.2855e-06,
                    7.36e-06,
                    7.4677e-06,
                    7.4932e-06,
                    7.5154e-06,
                    7.464e-06,
                    7.4148e-06,
                    7.3477e-06,
                    7.3905e-06,
                    7.413e-06,
                    7.3994e-06,
                    7.378e-06,
                    7.3787e-06,
                    7.3534e-06,
                    7.3245e-06,
                    7.3375e-06,
                    7.2784e-06,
                    7.1038e-06,
                    7.0123e-06,
                    6.9409e-06,
                    6.9114e-06,
                    6.9039e-06,
                    6.8721e-06,
                    6.912e-06,
                    6.9611e-06,
                    7.0711e-06
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [
                    2.3264e-12,
                    4.6993e-12,
                    7.1168e-12,
                    9.576e-12,
                    1.2073e-11,
                    1.4605e-11,
                    1.7165e-11,
                    1.9748e-11,
                    2.2348e-11,
                    2.4957e-11,
                    2.757e-11,
                    3.0187e-11,
                    3.2806e-11,
                    3.5426e-11,
                    3.8049e-11,
                    4.0673e-11,
                    4.3299e-11,
                    4.5927e-11,
                    4.8559e-11,
                    5.1196e-11,
                    5.3877e-11,
                    5.667e-11,
                    5.9626e-11,
                    6.2782e-11,
                    6.6158e-11,
                    6.9759e-11,
                    7.3574e-11,
                    7.7578e-11,
                    8.1728e-11,
                    8.5967e-11,
                    9.0256e-11,
                    9.4588e-11,
                    9.8955e-11,
                    1.0335e-10,
                    1.0778e-10,
                    1.1223e-10,
                    1.167e-10,
                    1.2121e-10,
                    1.2574e-10,
                    1.308e-10,
                    1.3563e-10,
                    1.4026e-10,
                    1.4472e-10,
                    1.4904e-10,
                    1.5324e-10,
                    1.5734e-10,
                    1.6137e-10,
                    1.6536e-10,
                    1.6932e-10,
                    1.7326e-10,
                    1.7725e-10,
                    1.8133e-10,
                    1.8557e-10,
                    1.8999e-10,
                    1.9462e-10,
                    1.9946e-10,
                    2.0451e-10,
                    2.0975e-10,
                    2.1514e-10,
                    2.2064e-10,
                    2.2621e-10,
                    2.3184e-10,
                    2.3751e-10,
                    2.4324e-10,
                    2.49e-10,
                    2.5481e-10,
                    2.6066e-10,
                    2.6655e-10,
                    2.7249e-10,
                    2.7848e-10,
                    2.8454e-10,
                    2.9069e-10,
                    2.9693e-10,
                    3.0327e-10,
                    3.097e-10,
                    3.1623e-10,
                    3.2283e-10,
                    3.295e-10,
                    3.3621e-10,
                    3.4293e-10,
                    3.4965e-10,
                    3.5636e-10,
                    3.6304e-10,
                    3.6969e-10,
                    3.7632e-10,
                    3.8291e-10,
                    3.8947e-10,
                    3.9602e-10,
                    4.0254e-10,
                    4.0906e-10,
                    4.1569e-10,
                    4.226e-10,
                    4.2993e-10,
                    4.3779e-10,
                    4.4623e-10,
                    4.5527e-10,
                    4.649e-10,
                    4.7506e-10,
                    4.8563e-10,
                    4.9649e-10,
                    5.0756e-10,
                    5.1885e-10,
                    5.3039e-10,
                    5.4217e-10,
                    5.5421e-10,
                    5.6653e-10,
                    5.7913e-10,
                    5.9201e-10,
                    6.0517e-10,
                    6.1863e-10,
                    6.3261e-10,
                    6.4749e-10,
                    6.6358e-10,
                    6.8104e-10,
                    6.9996e-10,
                    7.2031e-10,
                    7.4196e-10,
                    7.6469e-10,
                    7.8815e-10,
                    8.1218e-10,
                    8.3624e-10,
                    8.6034e-10,
                    8.8313e-10,
                    9.0657e-10,
                    9.3089e-10,
                    9.5529e-10,
                    9.7862e-10,
                    1.0015e-09,
                    1.0243e-09,
                    1.0473e-09,
                    1.0703e-09,
                    1.0933e-09,
                    1.1159e-09,
                    1.1391e-09,
                    1.1629e-09,
                    1.1869e-09,
                    1.2106e-09,
                    1.2348e-09,
                    1.2596e-09,
                    1.285e-09,
                    1.3099e-09,
                    1.334e-09,
                    1.3576e-09,
                    3.928e-09,
                    9.8269e-09,
                    1.2813e-08,
                    2.2682e-08,
                    2.8437e-08,
                    3.6844e-08,
                    4.2763e-08,
                    4.9126e-08,
                    5.5963e-08,
                    6.3337e-08,
                    7.1337e-08,
                    8.0088e-08,
                    8.9291e-08,
                    9.8965e-08,
                    1.0911e-07,
                    1.1972e-07,
                    1.3081e-07,
                    1.4236e-07,
                    1.5439e-07,
                    1.6689e-07,
                    1.7747e-07,
                    1.854e-07,
                    1.9653e-07,
                    2.0168e-07,
                    2.1116e-07,
                    2.1862e-07,
                    2.2889e-07,
                    2.3923e-07,
                    2.4958e-07
                ],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    8.91e-08,
                    1.782e-07,
                    2.673e-07,
                    3.564e-07,
                    4.455e-07,
                    5.346e-07,
                    6.237e-07,
                    7.128e-07,
                    8.0685e-07,
                    9.042e-07,
                    9.999e-07,
                    1.0956e-06,
                    1.1929e-06,
                    1.2919e-06,
                    1.3943e-06,
                    1.5081e-06,
                    1.6005e-06,
                    1.6896e-06,
                    1.7837e-06,
                    1.881e-06,
                    1.9816e-06,
                    2.084e-06,
                    2.1829e-06,
                    2.2754e-06,
                    2.371e-06,
                    2.4684e-06,
                    2.5641e-06,
                    2.6631e-06,
                    2.7588e-06,
                    2.8587e-06,
                    2.9574e-06
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    8.91e-08,
                    1.782e-07,
                    2.673e-07,
                    3.564e-07,
                    4.455e-07,
                    5.346e-07,
                    6.237e-07,
                    7.128e-07,
                    8.0685e-07,
                    9.042e-07,
                    9.999e-07,
                    1.0956e-06,
                    1.1929e-06,
                    1.2919e-06,
                    1.3943e-06,
                    1.5081e-06,
                    1.6005e-06,
                    1.6896e-06,
                    1.7837e-06,
                    1.881e-06,
                    1.9816e-06,
                    2.084e-06,
                    2.1829e-06,
                    2.2754e-06,
                    2.371e-06,
                    2.4684e-06,
                    2.5641e-06,
                    2.6631e-06,
                    2.7588e-06,
                    2.8587e-06,
                    2.9574e-06
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [
                    1.797e-10,
                    3.6915e-10,
                    5.687e-10,
                    7.7871e-10,
                    9.9955e-10,
                    1.2316e-09,
                    1.4753e-09,
                    1.7309e-09,
                    1.9991e-09,
                    2.28e-09,
                    2.5692e-09,
                    2.8669e-09,
                    3.1734e-09,
                    3.489e-09,
                    3.8141e-09,
                    4.1491e-09,
                    4.4943e-09,
                    4.85e-09,
                    5.2168e-09,
                    5.5948e-09,
                    5.9757e-09,
                    6.3594e-09,
                    6.7459e-09,
                    7.1353e-09,
                    7.5276e-09,
                    7.923e-09,
                    8.3215e-09,
                    8.7233e-09,
                    9.1283e-09,
                    9.5366e-09,
                    9.9238e-09,
                    1.0326e-08,
                    1.0743e-08,
                    1.1176e-08,
                    1.1626e-08,
                    1.2093e-08,
                    1.2579e-08,
                    1.3084e-08,
                    1.3608e-08,
                    1.4154e-08,
                    1.4686e-08,
                    1.5204e-08,
                    1.5708e-08,
                    1.6198e-08,
                    1.6673e-08,
                    1.7137e-08,
                    1.7589e-08,
                    1.8028e-08,
                    1.8456e-08,
                    1.887e-08,
                    1.9288e-08,
                    1.9694e-08,
                    2.0088e-08,
                    2.0467e-08,
                    2.0832e-08,
                    2.1179e-08,
                    2.1509e-08,
                    2.1819e-08,
                    2.2109e-08,
                    2.2377e-08,
                    2.2633e-08,
                    2.2879e-08,
                    2.3113e-08,
                    2.3337e-08,
                    2.355e-08,
                    2.3749e-08,
                    2.3936e-08,
                    2.4109e-08,
                    2.4269e-08,
                    2.4416e-08,
                    2.4568e-08,
                    2.4699e-08,
                    2.4813e-08,
                    2.4912e-08,
                    2.4995e-08,
                    2.5053e-08,
                    2.5097e-08,
                    2.5129e-08,
                    2.5137e-08,
                    2.5133e-08,
                    2.5145e-08,
                    2.5156e-08,
                    2.517e-08,
                    2.5186e-08,
                    2.5206e-08,
                    2.5228e-08,
                    2.5253e-08,
                    2.5282e-08,
                    2.5314e-08,
                    2.5348e-08,
                    2.5373e-08,
                    2.5398e-08,
                    2.5417e-08,
                    2.543e-08,
                    2.5714e-08,
                    2.6278e-08,
                    2.7062e-08,
                    2.8051e-08,
                    2.9238e-08,
                    3.0615e-08,
                    3.2279e-08,
                    3.4279e-08,
                    3.6647e-08,
                    3.9415e-08,
                    4.2804e-08,
                    4.669e-08,
                    5.119e-08,
                    5.6254e-08,
                    6.1902e-08,
                    6.815e-08,
                    7.645e-08,
                    8.5502e-08,
                    9.5497e-08,
                    1.0648e-07,
                    1.1844e-07,
                    1.3099e-07,
                    1.4468e-07,
                    1.5935e-07,
                    1.7938e-07,
                    4.1991e-07,
                    6.6054e-07,
                    9.0109e-07,
                    1.1416e-06,
                    1.3819e-06,
                    1.6218e-06,
                    1.8616e-06,
                    2.1009e-06,
                    2.3398e-06,
                    2.5784e-06,
                    2.8165e-06,
                    3.0567e-06,
                    3.2949e-06,
                    3.5419e-06,
                    3.8152e-06,
                    4.0345e-06,
                    4.2737e-06,
                    4.524e-06,
                    4.7625e-06,
                    5.0072e-06,
                    5.0481e-06,
                    5.0866e-06,
                    5.1021e-06,
                    5.1227e-06,
                    5.265e-06,
                    5.3233e-06,
                    5.3578e-06,
                    5.3596e-06,
                    5.3263e-06,
                    5.3272e-06,
                    5.2466e-06,
                    5.1578e-06,
                    5.0048e-06,
                    4.8513e-06,
                    4.6812e-06,
                    4.6181e-06,
                    4.5329e-06,
                    4.4033e-06,
                    4.2875e-06,
                    4.193e-06,
                    4.0688e-06,
                    3.9339e-06,
                    3.8304e-06,
                    3.6687e-06,
                    3.3943e-06,
                    3.2077e-06,
                    3.0413e-06,
                    2.9084e-06,
                    2.8034e-06,
                    2.669e-06,
                    2.6125e-06,
                    2.5607e-06,
                    2.5706e-06
                ],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [
                    1.797e-10,
                    3.6915e-10,
                    5.687e-10,
                    7.7871e-10,
                    9.9955e-10,
                    1.2316e-09,
                    1.4753e-09,
                    1.7309e-09,
                    1.9991e-09,
                    2.28e-09,
                    2.5692e-09,
                    2.8669e-09,
                    3.1734e-09,
                    3.489e-09,
                    3.8141e-09,
                    4.1491e-09,
                    4.4943e-09,
                    4.85e-09,
                    5.2168e-09,
                    5.5948e-09,
                    5.9757e-09,
                    6.3594e-09,
                    6.7459e-09,
                    7.1353e-09,
                    7.5276e-09,
                    7.923e-09,
                    8.3215e-09,
                    8.7233e-09,
                    9.1283e-09,
                    9.5366e-09,
                    9.9238e-09,
                    1.0326e-08,
                    1.0743e-08,
                    1.1176e-08,
                    1.1626e-08,
                    1.2093e-08,
                    1.2579e-08,
                    1.3084e-08,
                    1.3608e-08,
                    1.4154e-08,
                    1.4686e-08,
                    1.5204e-08,
                    1.5708e-08,
                    1.6198e-08,
                    1.6673e-08,
                    1.7137e-08,
                    1.7589e-08,
                    1.8028e-08,
                    1.8456e-08,
                    1.887e-08,
                    1.9288e-08,
                    1.9694e-08,
                    2.0088e-08,
                    2.0467e-08,
                    2.0832e-08,
                    2.1179e-08,
                    2.1509e-08,
                    2.1819e-08,
                    2.2109e-08,
                    2.2377e-08,
                    2.2633e-08,
                    2.2879e-08,
                    2.3113e-08,
                    2.3337e-08,
                    2.355e-08,
                    2.3749e-08,
                    2.3936e-08,
                    2.4109e-08,
                    2.4269e-08,
                    2.4416e-08,
                    2.4568e-08,
                    2.4699e-08,
                    2.4813e-08,
                    2.4912e-08,
                    2.4995e-08,
                    2.5053e-08,
                    2.5097e-08,
                    2.5129e-08,
                    2.5137e-08,
                    2.5133e-08,
                    2.5145e-08,
                    2.5156e-08,
                    2.517e-08,
                    2.5186e-08,
                    2.5206e-08,
                    2.5228e-08,
                    2.5253e-08,
                    2.5282e-08,
                    2.5314e-08,
                    2.5348e-08,
                    2.5373e-08,
                    2.5398e-08,
                    2.5417e-08,
                    2.543e-08,
                    2.5714e-08,
                    2.6278e-08,
                    2.7062e-08,
                    2.8051e-08,
                    2.9238e-08,
                    3.0615e-08,
                    3.2279e-08,
                    3.4279e-08,
                    3.6647e-08,
                    3.9415e-08,
                    4.2804e-08,
                    4.669e-08,
                    5.119e-08,
                    5.6254e-08,
                    6.1902e-08,
                    6.815e-08,
                    7.645e-08,
                    8.5502e-08,
                    9.5497e-08,
                    1.0648e-07,
                    1.1844e-07,
                    1.3099e-07,
                    1.4468e-07,
                    1.5935e-07,
                    1.7938e-07,
                    4.1991e-07,
                    6.6054e-07,
                    9.0109e-07,
                    1.1416e-06,
                    1.3819e-06,
                    1.6218e-06,
                    1.8616e-06,
                    2.1009e-06,
                    2.3398e-06,
                    2.5784e-06,
                    2.8165e-06,
                    3.0567e-06,
                    3.2949e-06,
                    3.5419e-06,
                    3.8152e-06,
                    4.0345e-06,
                    4.2737e-06,
                    4.524e-06,
                    4.7625e-06,
                    5.0072e-06,
                    5.0481e-06,
                    5.0866e-06,
                    5.1021e-06,
                    5.1227e-06,
                    5.2624e-06,
                    5.3149e-06,
                    5.3464e-06,
                    5.3383e-06,
                    5.2994e-06,
                    5.2919e-06,
                    5.2054e-06,
                    5.1102e-06,
                    4.9504e-06,
                    4.7896e-06,
                    4.6115e-06,
                    4.5397e-06,
                    4.4453e-06,
                    4.3061e-06,
                    4.1801e-06,
                    4.075e-06,
                    3.9397e-06,
                    3.7933e-06,
                    3.6778e-06,
                    3.5037e-06,
                    3.2188e-06,
                    3.0242e-06,
                    2.8467e-06,
                    2.7087e-06,
                    2.5943e-06,
                    2.4524e-06,
                    2.3857e-06,
                    2.3235e-06,
                    2.3232e-06
                ],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2.5468e-09,
                    8.421e-09,
                    1.1383e-08,
                    2.1227e-08,
                    2.6957e-08,
                    3.534e-08,
                    4.1234e-08,
                    4.7572e-08,
                    5.4385e-08,
                    6.1734e-08,
                    6.971e-08,
                    7.8436e-08,
                    8.7614e-08,
                    9.7263e-08,
                    1.0738e-07,
                    1.1797e-07,
                    1.2903e-07,
                    1.4056e-07,
                    1.5256e-07,
                    1.6504e-07,
                    1.7559e-07,
                    1.835e-07,
                    1.946e-07,
                    1.9973e-07,
                    2.0918e-07,
                    2.1662e-07,
                    2.2686e-07,
                    2.3715e-07,
                    2.4747e-07
                ],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [
                    3.9612e-09,
                    7.9657e-09,
                    1.2013e-08,
                    1.6103e-08,
                    2.0235e-08,
                    2.4408e-08,
                    2.8621e-08,
                    3.2873e-08,
                    3.7164e-08,
                    4.1491e-08,
                    4.5854e-08,
                    5.0253e-08,
                    5.4688e-08,
                    5.9158e-08,
                    6.3664e-08,
                    6.8205e-08,
                    7.2782e-08,
                    7.7394e-08,
                    8.2042e-08,
                    8.6726e-08,
                    9.1453e-08,
                    9.6235e-08,
                    1.0108e-07,
                    1.06e-07,
                    1.1098e-07,
                    1.1605e-07,
                    1.2118e-07,
                    1.2639e-07,
                    1.3165e-07,
                    1.3697e-07,
                    1.4233e-07,
                    1.4773e-07,
                    1.5317e-07,
                    1.5866e-07,
                    1.6418e-07,
                    1.6974e-07,
                    1.7535e-07,
                    1.8099e-07,
                    1.8667e-07,
                    1.9251e-07,
                    1.9841e-07,
                    2.0439e-07,
                    2.1043e-07,
                    2.1656e-07,
                    2.2276e-07,
                    2.2904e-07,
                    2.354e-07,
                    2.4184e-07,
                    2.4838e-07,
                    2.5499e-07,
                    2.6171e-07,
                    2.6852e-07,
                    2.7544e-07,
                    2.8248e-07,
                    2.8963e-07,
                    2.9689e-07,
                    3.0426e-07,
                    3.1173e-07,
                    3.193e-07,
                    3.2695e-07,
                    3.3468e-07,
                    3.4249e-07,
                    3.5037e-07,
                    3.5833e-07,
                    3.6637e-07,
                    3.7447e-07,
                    3.8263e-07,
                    3.9085e-07,
                    3.9912e-07,
                    4.0743e-07,
                    4.1577e-07,
                    4.2413e-07,
                    4.325e-07,
                    4.4087e-07,
                    4.4925e-07,
                    4.5763e-07,
                    4.6602e-07,
                    4.7442e-07,
                    4.8284e-07,
                    4.9128e-07,
                    4.9978e-07,
                    5.0833e-07,
                    5.1696e-07,
                    5.2568e-07,
                    5.345e-07,
                    5.4343e-07,
                    5.5247e-07,
                    5.6163e-07,
                    5.709e-07,
                    5.8029e-07,
                    5.898e-07,
                    5.9945e-07,
                    6.0924e-07,
                    6.1918e-07,
                    6.2929e-07,
                    6.3956e-07,
                    6.5001e-07,
                    6.6064e-07,
                    6.7144e-07,
                    6.8243e-07,
                    6.9361e-07,
                    7.05e-07,
                    7.166e-07,
                    7.2842e-07,
                    7.4047e-07,
                    7.5276e-07,
                    7.6528e-07,
                    7.7802e-07,
                    7.9099e-07,
                    8.0418e-07,
                    8.1758e-07,
                    8.3121e-07,
                    8.4507e-07,
                    8.5916e-07,
                    8.7349e-07,
                    8.8803e-07,
                    9.0278e-07,
                    9.1771e-07,
                    9.3281e-07,
                    9.4835e-07,
                    9.6391e-07,
                    9.7942e-07,
                    9.9492e-07,
                    1.0104e-06,
                    1.0259e-06,
                    1.0414e-06,
                    1.0569e-06,
                    1.0724e-06,
                    1.0879e-06,
                    1.1032e-06,
                    1.1187e-06,
                    1.1342e-06,
                    1.1504e-06,
                    1.1681e-06,
                    1.1825e-06,
                    1.1983e-06,
                    1.215e-06,
                    1.2309e-06,
                    1.2475e-06,
                    1.265e-06,
                    1.2823e-06,
                    1.299e-06,
                    1.3164e-06,
                    1.3431e-06,
                    1.3661e-06,
                    1.3881e-06,
                    1.414e-06,
                    1.4384e-06,
                    1.4646e-06,
                    1.4825e-06,
                    1.5026e-06,
                    1.5153e-06,
                    1.5312e-06,
                    1.5449e-06,
                    1.5605e-06,
                    1.5751e-06,
                    1.587e-06,
                    1.5991e-06,
                    1.6158e-06,
                    1.6318e-06,
                    1.652e-06,
                    1.6799e-06,
                    1.6927e-06,
                    1.704e-06,
                    1.7146e-06,
                    1.7251e-06,
                    1.7362e-06,
                    1.7475e-06,
                    1.7587e-06,
                    1.7696e-06,
                    1.781e-06,
                    1.7926e-06
                ],
                "Fossil_N2O": 0.01,
                "Fossil_N2O_timeseries": [
                    3.9589e-09,
                    7.961e-09,
                    1.2006e-08,
                    1.6094e-08,
                    2.0223e-08,
                    2.4393e-08,
                    2.8604e-08,
                    3.2854e-08,
                    3.7141e-08,
                    4.1466e-08,
                    4.5827e-08,
                    5.0223e-08,
                    5.4655e-08,
                    5.9123e-08,
                    6.3626e-08,
                    6.8164e-08,
                    7.2738e-08,
                    7.7348e-08,
                    8.1993e-08,
                    8.6675e-08,
                    9.1399e-08,
                    9.6178e-08,
                    1.0102e-07,
                    1.0593e-07,
                    1.1092e-07,
                    1.1598e-07,
                    1.2111e-07,
                    1.2631e-07,
                    1.3157e-07,
                    1.3688e-07,
                    1.4224e-07,
                    1.4763e-07,
                    1.5307e-07,
                    1.5855e-07,
                    1.6407e-07,
                    1.6963e-07,
                    1.7523e-07,
                    1.8087e-07,
                    1.8655e-07,
                    1.9238e-07,
                    1.9828e-07,
                    2.0425e-07,
                    2.1029e-07,
                    2.1641e-07,
                    2.226e-07,
                    2.2888e-07,
                    2.3524e-07,
                    2.4168e-07,
                    2.4821e-07,
                    2.5482e-07,
                    2.6153e-07,
                    2.6834e-07,
                    2.7526e-07,
                    2.8229e-07,
                    2.8943e-07,
                    2.9669e-07,
                    3.0405e-07,
                    3.1152e-07,
                    3.1909e-07,
                    3.2673e-07,
                    3.3446e-07,
                    3.4226e-07,
                    3.5014e-07,
                    3.5809e-07,
                    3.6612e-07,
                    3.7421e-07,
                    3.8237e-07,
                    3.9058e-07,
                    3.9885e-07,
                    4.0715e-07,
                    4.1548e-07,
                    4.2384e-07,
                    4.322e-07,
                    4.4057e-07,
                    4.4894e-07,
                    4.5732e-07,
                    4.657e-07,
                    4.7409e-07,
                    4.825e-07,
                    4.9094e-07,
                    4.9943e-07,
                    5.0797e-07,
                    5.166e-07,
                    5.2531e-07,
                    5.3413e-07,
                    5.4305e-07,
                    5.5208e-07,
                    5.6123e-07,
                    5.705e-07,
                    5.7988e-07,
                    5.8939e-07,
                    5.9903e-07,
                    6.0881e-07,
                    6.1875e-07,
                    6.2884e-07,
                    6.3911e-07,
                    6.4954e-07,
                    6.6016e-07,
                    6.7096e-07,
                    6.8194e-07,
                    6.931e-07,
                    7.0448e-07,
                    7.1607e-07,
                    7.2788e-07,
                    7.3992e-07,
                    7.5219e-07,
                    7.647e-07,
                    7.7743e-07,
                    7.9039e-07,
                    8.0356e-07,
                    8.1695e-07,
                    8.3056e-07,
                    8.4441e-07,
                    8.5848e-07,
                    8.7279e-07,
                    8.8731e-07,
                    9.0204e-07,
                    9.1695e-07,
                    9.3202e-07,
                    9.4754e-07,
                    9.6307e-07,
                    9.7856e-07,
                    9.9403e-07,
                    1.0095e-06,
                    1.025e-06,
                    1.0405e-06,
                    1.0559e-06,
                    1.0714e-06,
                    1.0868e-06,
                    1.1021e-06,
                    1.1177e-06,
                    1.1331e-06,
                    1.1492e-06,
                    1.167e-06,
                    1.1813e-06,
                    1.1971e-06,
                    1.2138e-06,
                    1.2297e-06,
                    1.2463e-06,
                    1.2637e-06,
                    1.281e-06,
                    1.2977e-06,
                    1.315e-06,
                    1.3417e-06,
                    1.3647e-06,
                    1.3866e-06,
                    1.4126e-06,
                    1.4369e-06,
                    1.4631e-06,
                    1.481e-06,
                    1.501e-06,
                    1.5138e-06,
                    1.5296e-06,
                    1.5433e-06,
                    1.5588e-06,
                    1.5735e-06,
                    1.5853e-06,
                    1.5974e-06,
                    1.6141e-06,
                    1.63e-06,
                    1.6502e-06,
                    1.6781e-06,
                    1.6908e-06,
                    1.7021e-06,
                    1.7127e-06,
                    1.7232e-06,
                    1.7343e-06,
                    1.7455e-06,
                    1.7567e-06,
                    1.7676e-06,
                    1.7789e-06,
                    1.7905e-06
                ],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": [
                    2.3264e-12,
                    4.6993e-12,
                    7.1168e-12,
                    9.576e-12,
                    1.2073e-11,
                    1.4605e-11,
                    1.7165e-11,
                    1.9748e-11,
                    2.2348e-11,
                    2.4957e-11,
                    2.757e-11,
                    3.0187e-11,
                    3.2806e-11,
                    3.5426e-11,
                    3.8049e-11,
                    4.0673e-11,
                    4.3299e-11,
                    4.5927e-11,
                    4.8559e-11,
                    5.1196e-11,
                    5.3877e-11,
                    5.667e-11,
                    5.9626e-11,
                    6.2782e-11,
                    6.6158e-11,
                    6.9759e-11,
                    7.3574e-11,
                    7.7578e-11,
                    8.1728e-11,
                    8.5967e-11,
                    9.0256e-11,
                    9.4588e-11,
                    9.8955e-11,
                    1.0335e-10,
                    1.0778e-10,
                    1.1223e-10,
                    1.167e-10,
                    1.2121e-10,
                    1.2574e-10,
                    1.308e-10,
                    1.3563e-10,
                    1.4026e-10,
                    1.4472e-10,
                    1.4904e-10,
                    1.5324e-10,
                    1.5734e-10,
                    1.6137e-10,
                    1.6536e-10,
                    1.6932e-10,
                    1.7326e-10,
                    1.7725e-10,
                    1.8133e-10,
                    1.8557e-10,
                    1.8999e-10,
                    1.9462e-10,
                    1.9946e-10,
                    2.0451e-10,
                    2.0975e-10,
                    2.1514e-10,
                    2.2064e-10,
                    2.2621e-10,
                    2.3184e-10,
                    2.3751e-10,
                    2.4324e-10,
                    2.49e-10,
                    2.5481e-10,
                    2.6066e-10,
                    2.6655e-10,
                    2.7249e-10,
                    2.7848e-10,
                    2.8454e-10,
                    2.9069e-10,
                    2.9693e-10,
                    3.0327e-10,
                    3.097e-10,
                    3.1623e-10,
                    3.2283e-10,
                    3.295e-10,
                    3.3621e-10,
                    3.4293e-10,
                    3.4965e-10,
                    3.5636e-10,
                    3.6304e-10,
                    3.6969e-10,
                    3.7632e-10,
                    3.8291e-10,
                    3.8947e-10,
                    3.9602e-10,
                    4.0254e-10,
                    4.0906e-10,
                    4.1569e-10,
                    4.226e-10,
                    4.2993e-10,
                    4.3779e-10,
                    4.4623e-10,
                    4.5527e-10,
                    4.649e-10,
                    4.7506e-10,
                    4.8563e-10,
                    4.9649e-10,
                    5.0756e-10,
                    5.1885e-10,
                    5.3039e-10,
                    5.4217e-10,
                    5.5421e-10,
                    5.6653e-10,
                    5.7913e-10,
                    5.9201e-10,
                    6.0517e-10,
                    6.1863e-10,
                    6.3261e-10,
                    6.4749e-10,
                    6.6358e-10,
                    6.8104e-10,
                    6.9996e-10,
                    7.2031e-10,
                    7.4196e-10,
                    7.6469e-10,
                    7.8815e-10,
                    8.1218e-10,
                    8.3624e-10,
                    8.6034e-10,
                    8.8313e-10,
                    9.0657e-10,
                    9.3089e-10,
                    9.5529e-10,
                    9.7862e-10,
                    1.0015e-09,
                    1.0243e-09,
                    1.0473e-09,
                    1.0703e-09,
                    1.0933e-09,
                    1.1159e-09,
                    1.1391e-09,
                    1.1629e-09,
                    1.1869e-09,
                    1.2106e-09,
                    1.2348e-09,
                    1.2596e-09,
                    1.285e-09,
                    1.3099e-09,
                    1.334e-09,
                    1.3576e-09,
                    1.3813e-09,
                    1.4058e-09,
                    1.4304e-09,
                    1.455e-09,
                    1.4796e-09,
                    1.5042e-09,
                    1.5288e-09,
                    1.5534e-09,
                    1.5781e-09,
                    1.6028e-09,
                    1.6276e-09,
                    1.6524e-09,
                    1.6772e-09,
                    1.702e-09,
                    1.7269e-09,
                    1.7518e-09,
                    1.7768e-09,
                    1.8017e-09,
                    1.8268e-09,
                    1.8518e-09,
                    1.8769e-09,
                    1.902e-09,
                    1.9271e-09,
                    1.9523e-09,
                    1.9775e-09,
                    2.0028e-09,
                    2.0281e-09,
                    2.078e-09,
                    2.1099e-09
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            134.46509,
                            7.44567
                        ],
                        [
                            134.50772,
                            7.36256
                        ],
                        [
                            134.55741,
                            7.3536
                        ],
                        [
                            134.63648,
                            7.49614
                        ],
                        [
                            134.64572,
                            7.64009
                        ],
                        [
                            134.53915,
                            7.59835
                        ],
                        [
                            134.53786,
                            7.56297
                        ],
                        [
                            134.46509,
                            7.44567
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "PAN",
                "Country": "Panama",
                "Total_3GHG": 0.07,
                "Total_3GHG_timeseries": [
                    1.362e-06,
                    2.5664e-06,
                    3.863e-06,
                    5.3158e-06,
                    6.5858e-06,
                    7.6311e-06,
                    8.7916e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012
                ],
                "Fossil_3GHG": 0.02,
                "Fossil_3GHG_timeseries": [
                    2.3953e-08,
                    4.8419e-08,
                    7.3405e-08,
                    9.8918e-08,
                    1.2497e-07,
                    1.5156e-07,
                    1.7869e-07,
                    2.0639e-07,
                    2.3465e-07,
                    2.6347e-07,
                    2.9279e-07,
                    3.2263e-07,
                    3.5298e-07,
                    3.8386e-07,
                    4.1527e-07,
                    4.4723e-07,
                    4.7975e-07,
                    5.1283e-07,
                    5.4649e-07,
                    5.8074e-07,
                    6.152e-07,
                    6.4989e-07,
                    6.8483e-07,
                    7.2004e-07,
                    7.5553e-07,
                    7.913e-07,
                    8.2736e-07,
                    8.6369e-07,
                    9.0028e-07,
                    9.3713e-07,
                    9.7463e-07,
                    1.0128e-06,
                    1.0516e-06,
                    1.091e-06,
                    1.1311e-06,
                    1.1719e-06,
                    1.2133e-06,
                    1.2554e-06,
                    1.2982e-06,
                    1.3417e-06,
                    1.3862e-06,
                    1.4315e-06,
                    1.4779e-06,
                    1.5251e-06,
                    1.5733e-06,
                    1.6225e-06,
                    1.6727e-06,
                    1.7238e-06,
                    1.7759e-06,
                    1.8289e-06,
                    1.8844e-06,
                    1.9422e-06,
                    2.0024e-06,
                    2.0649e-06,
                    2.1298e-06,
                    2.1971e-06,
                    2.2669e-06,
                    2.3392e-06,
                    2.414e-06,
                    2.4914e-06,
                    2.5714e-06,
                    2.6542e-06,
                    2.7396e-06,
                    2.8304e-06,
                    2.9271e-06,
                    3.0297e-06,
                    3.1388e-06,
                    3.2542e-06,
                    3.3765e-06,
                    3.506e-06,
                    3.6345e-06,
                    3.762e-06,
                    3.8884e-06,
                    4.0138e-06,
                    4.1381e-06,
                    4.2614e-06,
                    4.3836e-06,
                    4.5047e-06,
                    4.6245e-06,
                    4.745e-06,
                    4.8697e-06,
                    4.9995e-06,
                    5.1347e-06,
                    5.2728e-06,
                    5.4133e-06,
                    5.5559e-06,
                    5.7e-06,
                    5.8463e-06,
                    5.9937e-06,
                    6.1497e-06,
                    6.3188e-06,
                    6.5105e-06,
                    6.7156e-06,
                    6.9245e-06,
                    7.1456e-06,
                    7.3765e-06,
                    7.6232e-06,
                    7.8968e-06,
                    8.1891e-06,
                    8.7535e-06,
                    9.3499e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_3GHG": 0.16,
                "Land_3GHG_timeseries": [
                    1.338e-06,
                    2.5179e-06,
                    3.7896e-06,
                    5.2169e-06,
                    6.4609e-06,
                    7.4796e-06,
                    8.613e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009
                ],
                "Total_CO2": 0.08,
                "Total_CO2_timeseries": [
                    1.2399e-06,
                    2.3192e-06,
                    3.4879e-06,
                    4.8098e-06,
                    5.9459e-06,
                    6.8544e-06,
                    7.8752e-06,
                    9.3168e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009
                ],
                "Fossil_CO2": 0.02,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    9.8198e-09,
                    2.1276e-08,
                    2.5713e-07,
                    5.0945e-07,
                    8.3597e-07,
                    1.1609e-06,
                    1.4478e-06,
                    1.7695e-06,
                    2.0564e-06,
                    2.4011e-06,
                    2.8201e-06,
                    3.2687e-06,
                    3.7173e-06,
                    4.2138e-06,
                    4.7498e-06,
                    5.2825e-06,
                    5.8416e-06,
                    6.5294e-06,
                    7.2749e-06,
                    8.0385e-06,
                    8.9474e-06,
                    9.8711e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002
                ],
                "Land_CO2": 0.22,
                "Land_CO2_timeseries": [
                    1.2399e-06,
                    2.3192e-06,
                    3.4879e-06,
                    4.8098e-06,
                    5.9459e-06,
                    6.8544e-06,
                    7.8752e-06,
                    9.3168e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008
                ],
                "Total_CH4": 0.05,
                "Total_CH4_timeseries": [
                    1.1376e-07,
                    2.3034e-07,
                    3.4974e-07,
                    4.7197e-07,
                    5.9704e-07,
                    7.2496e-07,
                    8.5573e-07,
                    9.8937e-07,
                    1.1259e-06,
                    1.2653e-06,
                    1.4071e-06,
                    1.5514e-06,
                    1.6981e-06,
                    1.8472e-06,
                    1.9989e-06,
                    2.153e-06,
                    2.3096e-06,
                    2.4687e-06,
                    2.6303e-06,
                    2.7944e-06,
                    2.9581e-06,
                    3.1214e-06,
                    3.2843e-06,
                    3.4469e-06,
                    3.609e-06,
                    3.7708e-06,
                    3.9322e-06,
                    4.0932e-06,
                    4.2538e-06,
                    4.414e-06,
                    4.5784e-06,
                    4.747e-06,
                    4.9197e-06,
                    5.0966e-06,
                    5.2777e-06,
                    5.463e-06,
                    5.6524e-06,
                    5.8461e-06,
                    6.0439e-06,
                    6.2459e-06,
                    6.4547e-06,
                    6.6702e-06,
                    6.8925e-06,
                    7.1215e-06,
                    7.3573e-06,
                    7.5998e-06,
                    7.8492e-06,
                    8.1053e-06,
                    8.3681e-06,
                    8.6378e-06,
                    8.9218e-06,
                    9.2203e-06,
                    9.5331e-06,
                    9.8602e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_CH4": 0.03,
                "Fossil_CH4_timeseries": [
                    1.8728e-08,
                    3.7908e-08,
                    5.755e-08,
                    7.7661e-08,
                    9.825e-08,
                    1.1933e-07,
                    1.409e-07,
                    1.6297e-07,
                    1.8556e-07,
                    2.0867e-07,
                    2.3223e-07,
                    2.5625e-07,
                    2.8075e-07,
                    3.0574e-07,
                    3.3121e-07,
                    3.5719e-07,
                    3.8367e-07,
                    4.1068e-07,
                    4.3822e-07,
                    4.6631e-07,
                    4.9454e-07,
                    5.2292e-07,
                    5.5146e-07,
                    5.8015e-07,
                    6.0901e-07,
                    6.3802e-07,
                    6.672e-07,
                    6.9655e-07,
                    7.2607e-07,
                    7.5577e-07,
                    7.8605e-07,
                    8.1693e-07,
                    8.484e-07,
                    8.8047e-07,
                    9.1315e-07,
                    9.4643e-07,
                    9.8032e-07,
                    1.0148e-06,
                    1.0499e-06,
                    1.0857e-06,
                    1.1223e-06,
                    1.1597e-06,
                    1.198e-06,
                    1.2372e-06,
                    1.2772e-06,
                    1.3181e-06,
                    1.3599e-06,
                    1.4026e-06,
                    1.4461e-06,
                    1.4905e-06,
                    1.5372e-06,
                    1.5862e-06,
                    1.6374e-06,
                    1.6909e-06,
                    1.7465e-06,
                    1.8044e-06,
                    1.8649e-06,
                    1.9275e-06,
                    1.9926e-06,
                    2.0602e-06,
                    2.1302e-06,
                    2.203e-06,
                    2.2782e-06,
                    2.3588e-06,
                    2.445e-06,
                    2.5372e-06,
                    2.6357e-06,
                    2.7404e-06,
                    2.8519e-06,
                    2.9705e-06,
                    3.0879e-06,
                    3.2043e-06,
                    3.3194e-06,
                    3.4334e-06,
                    3.5463e-06,
                    3.658e-06,
                    3.7685e-06,
                    3.8778e-06,
                    3.9856e-06,
                    4.0941e-06,
                    4.2066e-06,
                    4.3241e-06,
                    4.447e-06,
                    4.5726e-06,
                    4.7005e-06,
                    4.8303e-06,
                    4.9616e-06,
                    5.0948e-06,
                    5.2291e-06,
                    5.3717e-06,
                    5.5274e-06,
                    5.7053e-06,
                    5.8963e-06,
                    6.0908e-06,
                    6.2971e-06,
                    6.5128e-06,
                    6.7439e-06,
                    6.9916e-06,
                    7.2561e-06,
                    7.5679e-06,
                    7.8949e-06,
                    8.2404e-06,
                    8.5973e-06,
                    8.9653e-06,
                    9.3514e-06,
                    9.7524e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CH4": 0.08,
                "Land_CH4_timeseries": [
                    9.5036e-08,
                    1.9243e-07,
                    2.9219e-07,
                    3.9431e-07,
                    4.9879e-07,
                    6.0563e-07,
                    7.1483e-07,
                    8.264e-07,
                    9.4032e-07,
                    1.0566e-06,
                    1.1749e-06,
                    1.2951e-06,
                    1.4173e-06,
                    1.5415e-06,
                    1.6677e-06,
                    1.7958e-06,
                    1.9259e-06,
                    2.058e-06,
                    2.192e-06,
                    2.3281e-06,
                    2.4636e-06,
                    2.5985e-06,
                    2.7329e-06,
                    2.8667e-06,
                    3e-06,
                    3.1328e-06,
                    3.265e-06,
                    3.3966e-06,
                    3.5277e-06,
                    3.6582e-06,
                    3.7924e-06,
                    3.9301e-06,
                    4.0713e-06,
                    4.2162e-06,
                    4.3646e-06,
                    4.5166e-06,
                    4.6721e-06,
                    4.8313e-06,
                    4.994e-06,
                    5.1602e-06,
                    5.3324e-06,
                    5.5105e-06,
                    5.6944e-06,
                    5.8843e-06,
                    6.0801e-06,
                    6.2817e-06,
                    6.4892e-06,
                    6.7027e-06,
                    6.922e-06,
                    7.1472e-06,
                    7.3846e-06,
                    7.6341e-06,
                    7.8957e-06,
                    8.1694e-06,
                    8.4552e-06,
                    8.7532e-06,
                    9.0632e-06,
                    9.3854e-06,
                    9.7197e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_N2O": 0.04,
                "Total_N2O_timeseries": [
                    8.3321e-09,
                    1.6786e-08,
                    2.5359e-08,
                    3.4045e-08,
                    4.2839e-08,
                    5.1734e-08,
                    6.0722e-08,
                    6.9792e-08,
                    7.8933e-08,
                    8.8133e-08,
                    9.7385e-08,
                    1.0669e-07,
                    1.1604e-07,
                    1.2543e-07,
                    1.3487e-07,
                    1.4436e-07,
                    1.539e-07,
                    1.6348e-07,
                    1.7312e-07,
                    1.828e-07,
                    1.9261e-07,
                    2.0264e-07,
                    2.13e-07,
                    2.2373e-07,
                    2.3487e-07,
                    2.4644e-07,
                    2.5841e-07,
                    2.7074e-07,
                    2.8336e-07,
                    2.9617e-07,
                    3.0911e-07,
                    3.2216e-07,
                    3.3532e-07,
                    3.4857e-07,
                    3.6191e-07,
                    3.7534e-07,
                    3.8886e-07,
                    4.0247e-07,
                    4.1617e-07,
                    4.3309e-07,
                    4.5021e-07,
                    4.6769e-07,
                    4.8565e-07,
                    5.0422e-07,
                    5.235e-07,
                    5.4358e-07,
                    5.6454e-07,
                    5.8643e-07,
                    6.0931e-07,
                    6.332e-07,
                    6.5847e-07,
                    6.8572e-07,
                    7.1541e-07,
                    7.4781e-07,
                    7.8304e-07,
                    8.2107e-07,
                    8.6169e-07,
                    9.0454e-07,
                    9.4909e-07,
                    9.9466e-07,
                    1.0408e-06,
                    1.0876e-06,
                    1.1349e-06,
                    1.1827e-06,
                    1.231e-06,
                    1.2796e-06,
                    1.3287e-06,
                    1.378e-06,
                    1.4277e-06,
                    1.4775e-06,
                    1.5273e-06,
                    1.5771e-06,
                    1.6265e-06,
                    1.6755e-06,
                    1.7242e-06,
                    1.7724e-06,
                    1.8202e-06,
                    1.8677e-06,
                    1.915e-06,
                    1.9624e-06,
                    2.0101e-06,
                    2.0586e-06,
                    2.1081e-06,
                    2.1589e-06,
                    2.2111e-06,
                    2.265e-06,
                    2.3205e-06,
                    2.3778e-06,
                    2.4368e-06,
                    2.4973e-06,
                    2.5611e-06,
                    2.6312e-06,
                    2.7099e-06,
                    2.7988e-06,
                    2.899e-06,
                    3.0108e-06,
                    3.1336e-06,
                    3.2664e-06,
                    3.4074e-06,
                    3.5541e-06,
                    3.7065e-06,
                    3.8669e-06,
                    4.0374e-06,
                    4.2191e-06,
                    4.4129e-06,
                    4.6189e-06,
                    4.8367e-06,
                    5.0654e-06,
                    5.3035e-06,
                    5.5489e-06,
                    5.793e-06,
                    6.0627e-06,
                    6.3352e-06,
                    6.6194e-06,
                    6.9114e-06,
                    7.2169e-06,
                    7.5232e-06,
                    7.8585e-06,
                    8.2075e-06,
                    8.5597e-06,
                    8.9229e-06,
                    9.2977e-06,
                    9.67e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_N2O": 0.02,
                "Fossil_N2O_timeseries": [
                    5.2252e-09,
                    1.051e-08,
                    1.5854e-08,
                    2.1257e-08,
                    2.6716e-08,
                    3.223e-08,
                    3.7798e-08,
                    4.3418e-08,
                    4.9088e-08,
                    5.4804e-08,
                    6.0566e-08,
                    6.6373e-08,
                    7.2225e-08,
                    7.8121e-08,
                    8.4061e-08,
                    9.0046e-08,
                    9.6076e-08,
                    1.0215e-07,
                    1.0827e-07,
                    1.1443e-07,
                    1.2066e-07,
                    1.2696e-07,
                    1.3337e-07,
                    1.3989e-07,
                    1.4652e-07,
                    1.5328e-07,
                    1.6015e-07,
                    1.6714e-07,
                    1.7421e-07,
                    1.8136e-07,
                    1.8857e-07,
                    1.9584e-07,
                    2.0317e-07,
                    2.1055e-07,
                    2.1798e-07,
                    2.2547e-07,
                    2.33e-07,
                    2.406e-07,
                    2.4824e-07,
                    2.5602e-07,
                    2.6388e-07,
                    2.7182e-07,
                    2.7983e-07,
                    2.8793e-07,
                    2.9611e-07,
                    3.0439e-07,
                    3.1275e-07,
                    3.212e-07,
                    3.2975e-07,
                    3.3839e-07,
                    3.4714e-07,
                    3.5599e-07,
                    3.6497e-07,
                    3.7406e-07,
                    3.8327e-07,
                    3.9262e-07,
                    4.0208e-07,
                    4.1167e-07,
                    4.2138e-07,
                    4.3121e-07,
                    4.4115e-07,
                    4.512e-07,
                    4.6136e-07,
                    4.7164e-07,
                    4.8202e-07,
                    4.9251e-07,
                    5.0311e-07,
                    5.1382e-07,
                    5.2464e-07,
                    5.3556e-07,
                    5.466e-07,
                    5.5775e-07,
                    5.6901e-07,
                    5.8037e-07,
                    5.9185e-07,
                    6.0344e-07,
                    6.1513e-07,
                    6.2694e-07,
                    6.3887e-07,
                    6.5091e-07,
                    6.6306e-07,
                    6.7533e-07,
                    6.8772e-07,
                    7.0022e-07,
                    7.1284e-07,
                    7.2559e-07,
                    7.3846e-07,
                    7.5148e-07,
                    7.6463e-07,
                    7.7794e-07,
                    7.9144e-07,
                    8.052e-07,
                    8.1928e-07,
                    8.337e-07,
                    8.4851e-07,
                    8.6372e-07,
                    8.7933e-07,
                    8.9534e-07,
                    9.1174e-07,
                    9.2848e-07,
                    9.456e-07,
                    9.6316e-07,
                    9.8123e-07,
                    9.9984e-07,
                    1.019e-06,
                    1.0388e-06,
                    1.0593e-06,
                    1.0803e-06,
                    1.1019e-06,
                    1.1242e-06,
                    1.1469e-06,
                    1.1701e-06,
                    1.1938e-06,
                    1.218e-06,
                    1.2427e-06,
                    1.2679e-06,
                    1.2939e-06,
                    1.3206e-06,
                    1.3482e-06,
                    1.376e-06,
                    1.4043e-06,
                    1.4329e-06,
                    1.4633e-06,
                    1.4957e-06,
                    1.5294e-06,
                    1.5646e-06,
                    1.6011e-06,
                    1.6373e-06,
                    1.6739e-06,
                    1.7113e-06,
                    1.749e-06,
                    1.7896e-06,
                    1.8338e-06,
                    1.8756e-06,
                    1.9175e-06,
                    1.9612e-06,
                    2.004e-06,
                    2.0442e-06,
                    2.088e-06,
                    2.1321e-06,
                    2.1801e-06,
                    2.2333e-06,
                    2.2875e-06,
                    2.3419e-06,
                    2.3969e-06,
                    2.4565e-06,
                    2.5195e-06,
                    2.5947e-06,
                    2.6714e-06,
                    2.7338e-06,
                    2.8033e-06,
                    2.8717e-06,
                    2.9466e-06,
                    3.0186e-06,
                    3.0956e-06,
                    3.1761e-06,
                    3.2546e-06,
                    3.333e-06,
                    3.4202e-06,
                    3.5115e-06,
                    3.6068e-06,
                    3.7019e-06,
                    3.7987e-06,
                    3.9005e-06,
                    3.999e-06,
                    4.1039e-06,
                    4.2086e-06,
                    4.307e-06,
                    4.4189e-06,
                    4.5237e-06,
                    4.6382e-06,
                    4.7553e-06
                ],
                "Land_N2O": 0.05,
                "Land_N2O_timeseries": [
                    3.1068e-09,
                    6.2758e-09,
                    9.5042e-09,
                    1.2788e-08,
                    1.6124e-08,
                    1.9504e-08,
                    2.2923e-08,
                    2.6373e-08,
                    2.9845e-08,
                    3.3329e-08,
                    3.6819e-08,
                    4.0313e-08,
                    4.3811e-08,
                    4.7311e-08,
                    5.0813e-08,
                    5.4317e-08,
                    5.7824e-08,
                    6.1334e-08,
                    6.4849e-08,
                    6.837e-08,
                    7.195e-08,
                    7.568e-08,
                    7.9628e-08,
                    8.3843e-08,
                    8.8351e-08,
                    9.316e-08,
                    9.8256e-08,
                    1.036e-07,
                    1.0914e-07,
                    1.1481e-07,
                    1.2053e-07,
                    1.2632e-07,
                    1.3215e-07,
                    1.3802e-07,
                    1.4393e-07,
                    1.4988e-07,
                    1.5585e-07,
                    1.6187e-07,
                    1.6793e-07,
                    1.7706e-07,
                    1.8633e-07,
                    1.9587e-07,
                    2.0582e-07,
                    2.1629e-07,
                    2.2739e-07,
                    2.392e-07,
                    2.5179e-07,
                    2.6523e-07,
                    2.7956e-07,
                    2.9481e-07,
                    3.1133e-07,
                    3.2973e-07,
                    3.5044e-07,
                    3.7375e-07,
                    3.9977e-07,
                    4.2845e-07,
                    4.5961e-07,
                    4.9287e-07,
                    5.2771e-07,
                    5.6345e-07,
                    5.9969e-07,
                    6.364e-07,
                    6.7353e-07,
                    7.1106e-07,
                    7.4894e-07,
                    7.8713e-07,
                    8.2558e-07,
                    8.6423e-07,
                    9.0303e-07,
                    9.4191e-07,
                    9.8073e-07,
                    1.0193e-06,
                    1.0575e-06,
                    1.0952e-06,
                    1.1323e-06,
                    1.1689e-06,
                    1.205e-06,
                    1.2407e-06,
                    1.2761e-06,
                    1.3115e-06,
                    1.3471e-06,
                    1.3833e-06,
                    1.4204e-06,
                    1.4587e-06,
                    1.4983e-06,
                    1.5394e-06,
                    1.5821e-06,
                    1.6263e-06,
                    1.6721e-06,
                    1.7194e-06,
                    1.7696e-06,
                    1.8259e-06,
                    1.8906e-06,
                    1.9651e-06,
                    2.0505e-06,
                    2.147e-06,
                    2.2543e-06,
                    2.371e-06,
                    2.4957e-06,
                    2.6256e-06,
                    2.7609e-06,
                    2.9038e-06,
                    3.0562e-06,
                    3.2193e-06,
                    3.3938e-06,
                    3.58e-06,
                    3.7774e-06,
                    3.9851e-06,
                    4.2015e-06,
                    4.4247e-06,
                    4.6461e-06,
                    4.8925e-06,
                    5.1414e-06,
                    5.4014e-06,
                    5.6688e-06,
                    5.949e-06,
                    6.2293e-06,
                    6.538e-06,
                    6.8593e-06,
                    7.1837e-06,
                    7.5187e-06,
                    7.8648e-06,
                    8.2067e-06,
                    8.5576e-06,
                    8.911e-06,
                    9.2613e-06,
                    9.6122e-06,
                    9.968e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -82.90039,
                                8.03978
                            ],
                            [
                                -82.85566,
                                8.06863
                            ],
                            [
                                -82.87608,
                                8.22464
                            ],
                            [
                                -82.83347,
                                8.29306
                            ],
                            [
                                -82.73419,
                                8.32222
                            ],
                            [
                                -82.64239,
                                8.32246
                            ],
                            [
                                -82.48423,
                                8.27196
                            ],
                            [
                                -82.413,
                                8.28899
                            ],
                            [
                                -82.2621,
                                8.29727
                            ],
                            [
                                -82.20208,
                                8.3142
                            ],
                            [
                                -82.22221,
                                8.22461
                            ],
                            [
                                -82.03552,
                                8.2167
                            ],
                            [
                                -81.90593,
                                8.18514
                            ],
                            [
                                -81.77778,
                                8.13332
                            ],
                            [
                                -81.72866,
                                8.14783
                            ],
                            [
                                -81.7278,
                                8.07249
                            ],
                            [
                                -81.62512,
                                7.93584
                            ],
                            [
                                -81.57498,
                                7.76561
                            ],
                            [
                                -81.50622,
                                7.76245
                            ],
                            [
                                -81.50251,
                                7.70812
                            ],
                            [
                                -81.30105,
                                7.65652
                            ],
                            [
                                -81.23139,
                                7.61569
                            ],
                            [
                                -81.20212,
                                7.64523
                            ],
                            [
                                -81.21677,
                                7.73357
                            ],
                            [
                                -81.17177,
                                7.7776
                            ],
                            [
                                -81.17577,
                                7.86222
                            ],
                            [
                                -81.06197,
                                7.83859
                            ],
                            [
                                -81.08507,
                                7.77445
                            ],
                            [
                                -81.03821,
                                7.74599
                            ],
                            [
                                -81.04758,
                                7.66779
                            ],
                            [
                                -80.98062,
                                7.60652
                            ],
                            [
                                -80.95318,
                                7.54876
                            ],
                            [
                                -80.96823,
                                7.50262
                            ],
                            [
                                -80.91092,
                                7.43857
                            ],
                            [
                                -80.92394,
                                7.40301
                            ],
                            [
                                -80.88927,
                                7.33652
                            ],
                            [
                                -80.93349,
                                7.25762
                            ],
                            [
                                -80.88295,
                                7.21055
                            ],
                            [
                                -80.71008,
                                7.21017
                            ],
                            [
                                -80.50276,
                                7.24839
                            ],
                            [
                                -80.4378,
                                7.24516
                            ],
                            [
                                -80.35835,
                                7.36513
                            ],
                            [
                                -80.31518,
                                7.40743
                            ],
                            [
                                -80.19834,
                                7.42892
                            ],
                            [
                                -80.16083,
                                7.41537
                            ],
                            [
                                -80.02739,
                                7.45414
                            ],
                            [
                                -79.99713,
                                7.51583
                            ],
                            [
                                -80.05162,
                                7.6377
                            ],
                            [
                                -80.12275,
                                7.69928
                            ],
                            [
                                -80.22389,
                                7.82184
                            ],
                            [
                                -80.29023,
                                7.86476
                            ],
                            [
                                -80.36066,
                                7.99435
                            ],
                            [
                                -80.44515,
                                8.02791
                            ],
                            [
                                -80.47995,
                                8.0888
                            ],
                            [
                                -80.47505,
                                8.21665
                            ],
                            [
                                -80.39249,
                                8.30258
                            ],
                            [
                                -80.21824,
                                8.31103
                            ],
                            [
                                -80.01564,
                                8.42456
                            ],
                            [
                                -79.86388,
                                8.54982
                            ],
                            [
                                -79.78184,
                                8.57954
                            ],
                            [
                                -79.82484,
                                8.63233
                            ],
                            [
                                -79.74886,
                                8.72222
                            ],
                            [
                                -79.76744,
                                8.78432
                            ],
                            [
                                -79.705,
                                8.87059
                            ],
                            [
                                -79.58048,
                                8.89463
                            ],
                            [
                                -79.47696,
                                9.00791
                            ],
                            [
                                -79.34978,
                                9.02525
                            ],
                            [
                                -79.15412,
                                9.01081
                            ],
                            [
                                -79.03398,
                                8.97654
                            ],
                            [
                                -78.91452,
                                8.92308
                            ],
                            [
                                -78.86178,
                                8.83327
                            ],
                            [
                                -78.77945,
                                8.82529
                            ],
                            [
                                -78.73081,
                                8.76163
                            ],
                            [
                                -78.6163,
                                8.67658
                            ],
                            [
                                -78.52643,
                                8.63826
                            ],
                            [
                                -78.53915,
                                8.57862
                            ],
                            [
                                -78.49988,
                                8.51646
                            ],
                            [
                                -78.50427,
                                8.46483
                            ],
                            [
                                -78.41826,
                                8.35157
                            ],
                            [
                                -78.32244,
                                8.47943
                            ],
                            [
                                -78.19343,
                                8.41103
                            ],
                            [
                                -78.16095,
                                8.46941
                            ],
                            [
                                -78.07439,
                                8.39847
                            ],
                            [
                                -78.07902,
                                8.33542
                            ],
                            [
                                -78.16286,
                                8.37648
                            ],
                            [
                                -78.18781,
                                8.3033
                            ],
                            [
                                -78.25186,
                                8.29029
                            ],
                            [
                                -78.30022,
                                8.23985
                            ],
                            [
                                -78.24893,
                                8.18328
                            ],
                            [
                                -78.26386,
                                8.11334
                            ],
                            [
                                -78.34087,
                                8.06316
                            ],
                            [
                                -78.44566,
                                8.05846
                            ],
                            [
                                -78.39871,
                                7.91779
                            ],
                            [
                                -78.34612,
                                7.86993
                            ],
                            [
                                -78.28893,
                                7.7583
                            ],
                            [
                                -78.29474,
                                7.7029
                            ],
                            [
                                -78.17588,
                                7.57707
                            ],
                            [
                                -78.18066,
                                7.52093
                            ],
                            [
                                -78.13401,
                                7.49392
                            ],
                            [
                                -78.01772,
                                7.33542
                            ],
                            [
                                -77.893,
                                7.22175
                            ],
                            [
                                -77.79321,
                                7.4775
                            ],
                            [
                                -77.74671,
                                7.46097
                            ],
                            [
                                -77.70441,
                                7.52106
                            ],
                            [
                                -77.74741,
                                7.6136
                            ],
                            [
                                -77.71862,
                                7.69547
                            ],
                            [
                                -77.6472,
                                7.65378
                            ],
                            [
                                -77.60994,
                                7.54257
                            ],
                            [
                                -77.56574,
                                7.50646
                            ],
                            [
                                -77.39097,
                                7.75794
                            ],
                            [
                                -77.33516,
                                7.89439
                            ],
                            [
                                -77.1886,
                                7.92464
                            ],
                            [
                                -77.16627,
                                7.9689
                            ],
                            [
                                -77.22661,
                                8.03028
                            ],
                            [
                                -77.21858,
                                8.08808
                            ],
                            [
                                -77.26586,
                                8.21539
                            ],
                            [
                                -77.33673,
                                8.27561
                            ],
                            [
                                -77.3572,
                                8.38997
                            ],
                            [
                                -77.39582,
                                8.45882
                            ],
                            [
                                -77.45504,
                                8.50775
                            ],
                            [
                                -77.36751,
                                8.67285
                            ],
                            [
                                -77.44701,
                                8.66457
                            ],
                            [
                                -77.54004,
                                8.70991
                            ],
                            [
                                -77.53664,
                                8.75304
                            ],
                            [
                                -77.61027,
                                8.82095
                            ],
                            [
                                -77.64375,
                                8.82396
                            ],
                            [
                                -77.71616,
                                8.89364
                            ],
                            [
                                -77.74712,
                                8.96961
                            ],
                            [
                                -77.86181,
                                9.10362
                            ],
                            [
                                -77.89196,
                                9.09366
                            ],
                            [
                                -78.04727,
                                9.24398
                            ],
                            [
                                -78.21238,
                                9.29162
                            ],
                            [
                                -78.43557,
                                9.40377
                            ],
                            [
                                -78.57152,
                                9.44272
                            ],
                            [
                                -78.61691,
                                9.41998
                            ],
                            [
                                -78.73039,
                                9.45399
                            ],
                            [
                                -78.8608,
                                9.42005
                            ],
                            [
                                -78.96081,
                                9.45748
                            ],
                            [
                                -79.05039,
                                9.43889
                            ],
                            [
                                -79.07522,
                                9.50264
                            ],
                            [
                                -79.03987,
                                9.56404
                            ],
                            [
                                -79.20206,
                                9.54105
                            ],
                            [
                                -79.32546,
                                9.57708
                            ],
                            [
                                -79.50918,
                                9.59045
                            ],
                            [
                                -79.54319,
                                9.63016
                            ],
                            [
                                -79.62481,
                                9.61264
                            ],
                            [
                                -79.6734,
                                9.53192
                            ],
                            [
                                -79.74547,
                                9.44944
                            ],
                            [
                                -79.8209,
                                9.39093
                            ],
                            [
                                -79.8759,
                                9.40085
                            ],
                            [
                                -79.92065,
                                9.3131
                            ],
                            [
                                -79.98401,
                                9.35462
                            ],
                            [
                                -80.09649,
                                9.22716
                            ],
                            [
                                -80.29615,
                                9.15692
                            ],
                            [
                                -80.4074,
                                9.14184
                            ],
                            [
                                -80.52637,
                                9.10381
                            ],
                            [
                                -80.73441,
                                8.99376
                            ],
                            [
                                -80.83062,
                                8.89244
                            ],
                            [
                                -80.89123,
                                8.88502
                            ],
                            [
                                -81.00022,
                                8.83416
                            ],
                            [
                                -81.20024,
                                8.78775
                            ],
                            [
                                -81.3478,
                                8.78352
                            ],
                            [
                                -81.49953,
                                8.8011
                            ],
                            [
                                -81.60356,
                                8.87883
                            ],
                            [
                                -81.72222,
                                9.03294
                            ],
                            [
                                -81.82311,
                                9.06543
                            ],
                            [
                                -81.88019,
                                9.17974
                            ],
                            [
                                -81.93501,
                                9.1303
                            ],
                            [
                                -81.83077,
                                9.02718
                            ],
                            [
                                -81.77884,
                                9.00289
                            ],
                            [
                                -81.8159,
                                8.94006
                            ],
                            [
                                -81.90104,
                                8.97851
                            ],
                            [
                                -81.96523,
                                8.93221
                            ],
                            [
                                -82.00778,
                                8.9567
                            ],
                            [
                                -82.07825,
                                8.92554
                            ],
                            [
                                -82.13763,
                                8.98724
                            ],
                            [
                                -82.24222,
                                9.00065
                            ],
                            [
                                -82.26873,
                                9.14596
                            ],
                            [
                                -82.24063,
                                9.17118
                            ],
                            [
                                -82.10354,
                                9.13376
                            ],
                            [
                                -82.08078,
                                9.1762
                            ],
                            [
                                -82.14111,
                                9.2287
                            ],
                            [
                                -82.26018,
                                9.18257
                            ],
                            [
                                -82.33269,
                                9.19502
                            ],
                            [
                                -82.36511,
                                9.22772
                            ],
                            [
                                -82.35521,
                                9.38347
                            ],
                            [
                                -82.56464,
                                9.57195
                            ],
                            [
                                -82.60407,
                                9.50928
                            ],
                            [
                                -82.68516,
                                9.50792
                            ],
                            [
                                -82.69506,
                                9.54345
                            ],
                            [
                                -82.76473,
                                9.58925
                            ],
                            [
                                -82.85464,
                                9.61913
                            ],
                            [
                                -82.8834,
                                9.5654
                            ],
                            [
                                -82.84233,
                                9.49731
                            ],
                            [
                                -82.93559,
                                9.47303
                            ],
                            [
                                -82.93598,
                                9.08434
                            ],
                            [
                                -82.80051,
                                9.00447
                            ],
                            [
                                -82.75017,
                                8.99013
                            ],
                            [
                                -82.71292,
                                8.92344
                            ],
                            [
                                -82.78052,
                                8.87598
                            ],
                            [
                                -82.85467,
                                8.85542
                            ],
                            [
                                -82.86653,
                                8.80467
                            ],
                            [
                                -82.91704,
                                8.74372
                            ],
                            [
                                -82.83033,
                                8.63281
                            ],
                            [
                                -82.83183,
                                8.50319
                            ],
                            [
                                -82.86797,
                                8.44028
                            ],
                            [
                                -82.9305,
                                8.43411
                            ],
                            [
                                -83.04501,
                                8.31904
                            ],
                            [
                                -82.9415,
                                8.26878
                            ],
                            [
                                -82.93529,
                                8.20969
                            ],
                            [
                                -82.8869,
                                8.10703
                            ],
                            [
                                -82.90039,
                                8.03978
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -81.88686,
                                7.51598
                            ],
                            [
                                -81.85831,
                                7.44075
                            ],
                            [
                                -81.75787,
                                7.3513
                            ],
                            [
                                -81.64229,
                                7.31787
                            ],
                            [
                                -81.63027,
                                7.39292
                            ],
                            [
                                -81.68759,
                                7.38772
                            ],
                            [
                                -81.72563,
                                7.43823
                            ],
                            [
                                -81.71089,
                                7.54365
                            ],
                            [
                                -81.76186,
                                7.64508
                            ],
                            [
                                -81.88686,
                                7.51598
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -78.97445,
                                8.44565
                            ],
                            [
                                -78.9451,
                                8.34029
                            ],
                            [
                                -78.8568,
                                8.29665
                            ],
                            [
                                -78.83624,
                                8.39037
                            ],
                            [
                                -78.86467,
                                8.45574
                            ],
                            [
                                -78.90988,
                                8.47005
                            ],
                            [
                                -78.97445,
                                8.44565
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -82.3254,
                                8.25205
                            ],
                            [
                                -82.34323,
                                8.28906
                            ],
                            [
                                -82.41508,
                                8.2746
                            ],
                            [
                                -82.39097,
                                8.22055
                            ],
                            [
                                -82.3254,
                                8.25205
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "PNG",
                "Country": "Papua New Guinea",
                "Total_3GHG": 0.07,
                "Total_3GHG_timeseries": [
                    -0.0000016817,
                    -0.0000019243,
                    -0.0000022432,
                    -0.0000026712,
                    -0.000002372,
                    -0.0000029475,
                    -0.0000032718,
                    -0.0000052738,
                    -0.0000072198,
                    -0.0000075247,
                    -0.0000076385,
                    -0.0000080174,
                    -0.0000079744,
                    -0.0000086244,
                    -0.0000088488,
                    -0.0000089221,
                    -0.0000099783,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    -0.0000091677,
                    -0.0000063055,
                    -0.0000037783,
                    -0.0000012639,
                    1.7239e-06,
                    3.8952e-06,
                    5.6814e-06,
                    7.8308e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011
                ],
                "Fossil_3GHG": 0.02,
                "Fossil_3GHG_timeseries": [
                    1.1051e-07,
                    2.3047e-07,
                    3.6032e-07,
                    5.0046e-07,
                    6.5135e-07,
                    8.1343e-07,
                    9.8719e-07,
                    1.1731e-06,
                    1.3717e-06,
                    1.5835e-06,
                    1.804e-06,
                    2.0336e-06,
                    2.2726e-06,
                    2.5214e-06,
                    2.7805e-06,
                    3.0502e-06,
                    3.331e-06,
                    3.6233e-06,
                    3.9276e-06,
                    4.2443e-06,
                    4.5655e-06,
                    4.8912e-06,
                    5.2214e-06,
                    5.5563e-06,
                    5.896e-06,
                    6.2407e-06,
                    6.5903e-06,
                    6.9451e-06,
                    7.3052e-06,
                    7.6706e-06,
                    8.0156e-06,
                    8.3778e-06,
                    8.7579e-06,
                    9.157e-06,
                    9.5758e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_3GHG": 0.16,
                "Land_3GHG_timeseries": [
                    -0.0000017922,
                    -0.0000021548,
                    -0.0000026035,
                    -0.0000031716,
                    -0.0000030233,
                    -0.000003761,
                    -0.0000042589,
                    -0.000006447,
                    -0.0000085916,
                    -0.0000091082,
                    -0.0000094425,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    -0.0000097224,
                    -0.0000080151,
                    -0.0000060789,
                    -0.0000054554,
                    -0.0000051162,
                    -0.0000042079,
                    -0.0000036035,
                    -0.0000038564,
                    -0.0000040676,
                    -0.0000037381,
                    -0.0000035623,
                    -0.000002577,
                    -0.0000024545,
                    -0.0000021457,
                    -0.0000016538,
                    -0.0000014168,
                    -0.00000084545,
                    -0.00000014413,
                    -0.000000056986,
                    6.2659e-07,
                    1.9795e-06,
                    3.7082e-06,
                    5.0271e-06,
                    6.6482e-06,
                    8.1195e-06,
                    9.5413e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009
                ],
                "Total_CO2": 0.08,
                "Total_CO2_timeseries": [
                    -0.0000018942,
                    -0.0000023598,
                    -0.0000029126,
                    -0.0000035858,
                    -0.0000035436,
                    -0.0000043883,
                    -0.0000049943,
                    -0.0000072911,
                    -0.0000095455,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    -0.0000095879,
                    -0.0000090994,
                    -0.0000094692,
                    -0.0000097985,
                    -0.0000095884,
                    -0.0000095333,
                    -0.0000086705,
                    -0.0000086721,
                    -0.0000084894,
                    -0.0000081259,
                    -0.0000080204,
                    -0.0000075842,
                    -0.0000070221,
                    -0.0000070787,
                    -0.0000065434,
                    -0.0000053433,
                    -0.0000037717,
                    -0.0000026139,
                    -0.0000011574,
                    1.455e-07,
                    1.3951e-06,
                    2.8223e-06,
                    4.3342e-06,
                    5.8412e-06,
                    7.3617e-06,
                    8.9703e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009
                ],
                "Fossil_CO2": 0.01,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2.475e-08,
                    5.28e-08,
                    9.075e-08,
                    1.3365e-07,
                    1.7655e-07,
                    2.343e-07,
                    2.9205e-07,
                    3.5805e-07,
                    4.2405e-07,
                    4.9665e-07,
                    5.775e-07,
                    6.6825e-07,
                    7.5735e-07,
                    8.7285e-07,
                    9.933e-07,
                    1.1303e-06,
                    1.2837e-06,
                    1.48e-06,
                    1.7061e-06,
                    1.9569e-06,
                    2.2688e-06,
                    2.64e-06,
                    3.2109e-06,
                    3.8164e-06,
                    4.5309e-06,
                    5.2206e-06,
                    5.9284e-06,
                    6.6396e-06,
                    7.3936e-06,
                    8.2022e-06,
                    9.0255e-06,
                    9.895e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CO2": 0.23,
                "Land_CO2_timeseries": [
                    -0.0000018942,
                    -0.0000023598,
                    -0.0000029126,
                    -0.0000035858,
                    -0.0000035436,
                    -0.0000043883,
                    -0.0000049943,
                    -0.0000072911,
                    -0.0000095455,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    -0.0000095879,
                    -0.0000090994,
                    -0.0000094692,
                    -0.0000097985,
                    -0.0000095884,
                    -0.0000095333,
                    -0.0000086705,
                    -0.0000086721,
                    -0.0000084894,
                    -0.0000081259,
                    -0.0000080204,
                    -0.0000075842,
                    -0.0000070221,
                    -0.0000070787,
                    -0.0000065434,
                    -0.0000053433,
                    -0.0000037717,
                    -0.0000026139,
                    -0.0000011574,
                    1.455e-07,
                    1.3951e-06,
                    2.8223e-06,
                    4.3342e-06,
                    5.8412e-06,
                    7.3617e-06,
                    8.9703e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008
                ],
                "Total_CH4": 0.04,
                "Total_CH4_timeseries": [
                    1.9565e-07,
                    4.015e-07,
                    6.1794e-07,
                    8.4542e-07,
                    1.0844e-06,
                    1.3352e-06,
                    1.5985e-06,
                    1.8747e-06,
                    2.1643e-06,
                    2.4678e-06,
                    2.7788e-06,
                    3.0978e-06,
                    3.425e-06,
                    3.7608e-06,
                    4.1057e-06,
                    4.4601e-06,
                    4.8243e-06,
                    5.1989e-06,
                    5.5842e-06,
                    5.9809e-06,
                    6.3806e-06,
                    6.7835e-06,
                    7.1895e-06,
                    7.5988e-06,
                    8.0115e-06,
                    8.4277e-06,
                    8.8475e-06,
                    9.2711e-06,
                    9.6985e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_CH4": 0.05,
                "Fossil_CH4_timeseries": [
                    1.084e-07,
                    2.2624e-07,
                    3.5394e-07,
                    4.919e-07,
                    6.4059e-07,
                    8.0045e-07,
                    9.7197e-07,
                    1.1556e-06,
                    1.3519e-06,
                    1.5614e-06,
                    1.7796e-06,
                    2.0069e-06,
                    2.2435e-06,
                    2.49e-06,
                    2.7467e-06,
                    3.014e-06,
                    3.2923e-06,
                    3.5822e-06,
                    3.884e-06,
                    4.1982e-06,
                    4.5169e-06,
                    4.8401e-06,
                    5.1677e-06,
                    5.5e-06,
                    5.8371e-06,
                    6.179e-06,
                    6.5258e-06,
                    6.8778e-06,
                    7.235e-06,
                    7.5975e-06,
                    7.9395e-06,
                    8.2987e-06,
                    8.6759e-06,
                    9.072e-06,
                    9.4878e-06,
                    9.9244e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CH4": 0.03,
                "Land_CH4_timeseries": [
                    8.725e-08,
                    1.7525e-07,
                    2.6401e-07,
                    3.5351e-07,
                    4.4377e-07,
                    5.3478e-07,
                    6.2655e-07,
                    7.1906e-07,
                    8.1233e-07,
                    9.0635e-07,
                    9.9921e-07,
                    1.0909e-06,
                    1.1814e-06,
                    1.2708e-06,
                    1.359e-06,
                    1.4461e-06,
                    1.532e-06,
                    1.6167e-06,
                    1.7002e-06,
                    1.7826e-06,
                    1.8637e-06,
                    1.9434e-06,
                    2.0217e-06,
                    2.0987e-06,
                    2.1744e-06,
                    2.2487e-06,
                    2.3217e-06,
                    2.3933e-06,
                    2.4635e-06,
                    2.5324e-06,
                    2.6016e-06,
                    2.6712e-06,
                    2.741e-06,
                    2.8111e-06,
                    2.8815e-06,
                    2.9522e-06,
                    3.0232e-06,
                    3.0945e-06,
                    3.1661e-06,
                    3.238e-06,
                    3.3102e-06,
                    3.3827e-06,
                    3.4556e-06,
                    3.5287e-06,
                    3.6022e-06,
                    3.676e-06,
                    3.7501e-06,
                    3.8245e-06,
                    3.8992e-06,
                    3.9742e-06,
                    4.0489e-06,
                    4.1233e-06,
                    4.1973e-06,
                    4.271e-06,
                    4.3443e-06,
                    4.4173e-06,
                    4.49e-06,
                    4.5624e-06,
                    4.6344e-06,
                    4.706e-06,
                    4.7772e-06,
                    4.8481e-06,
                    4.9184e-06,
                    4.9884e-06,
                    5.0579e-06,
                    5.1271e-06,
                    5.1957e-06,
                    5.264e-06,
                    5.3318e-06,
                    5.3993e-06,
                    5.4669e-06,
                    5.5347e-06,
                    5.6027e-06,
                    5.6709e-06,
                    5.7394e-06,
                    5.808e-06,
                    5.8768e-06,
                    5.9459e-06,
                    6.0151e-06,
                    6.0845e-06,
                    6.1543e-06,
                    6.2243e-06,
                    6.2947e-06,
                    6.3654e-06,
                    6.4363e-06,
                    6.5008e-06,
                    6.5589e-06,
                    6.6103e-06,
                    6.6552e-06,
                    6.6935e-06,
                    6.7251e-06,
                    6.75e-06,
                    6.7682e-06,
                    6.7795e-06,
                    6.7841e-06,
                    6.7817e-06,
                    6.7724e-06,
                    6.7562e-06,
                    6.7329e-06,
                    6.7026e-06,
                    6.6698e-06,
                    6.6345e-06,
                    6.5969e-06,
                    6.5569e-06,
                    6.5148e-06,
                    6.4771e-06,
                    6.444e-06,
                    6.4158e-06,
                    6.3926e-06,
                    6.3747e-06,
                    6.4332e-06,
                    6.5182e-06,
                    6.6312e-06,
                    6.7738e-06,
                    6.9512e-06,
                    7.1609e-06,
                    7.4049e-06,
                    7.7025e-06,
                    8.0429e-06,
                    8.45e-06,
                    8.8916e-06,
                    9.463e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_N2O": 0.06,
                "Total_N2O_timeseries": [
                    1.6843e-08,
                    3.4005e-08,
                    5.1474e-08,
                    6.923e-08,
                    8.7253e-08,
                    1.0551e-07,
                    1.2398e-07,
                    1.4261e-07,
                    1.6136e-07,
                    1.802e-07,
                    1.9907e-07,
                    2.1799e-07,
                    2.3694e-07,
                    2.5592e-07,
                    2.7492e-07,
                    2.9395e-07,
                    3.1302e-07,
                    3.3211e-07,
                    3.5125e-07,
                    3.7043e-07,
                    3.8992e-07,
                    4.1015e-07,
                    4.3146e-07,
                    4.5409e-07,
                    4.7816e-07,
                    5.0371e-07,
                    5.3067e-07,
                    5.5887e-07,
                    5.8804e-07,
                    6.1781e-07,
                    6.4791e-07,
                    6.7831e-07,
                    7.0896e-07,
                    7.3982e-07,
                    7.7088e-07,
                    8.0212e-07,
                    8.3355e-07,
                    8.6517e-07,
                    8.9701e-07,
                    9.3189e-07,
                    9.6709e-07,
                    1.0027e-06,
                    1.0389e-06,
                    1.0758e-06,
                    1.1133e-06,
                    1.1517e-06,
                    1.191e-06,
                    1.2311e-06,
                    1.2722e-06,
                    1.3144e-06,
                    1.3575e-06,
                    1.4019e-06,
                    1.4475e-06,
                    1.4947e-06,
                    1.5433e-06,
                    1.5937e-06,
                    1.6459e-06,
                    1.7002e-06,
                    1.7565e-06,
                    1.8152e-06,
                    1.8767e-06,
                    1.9417e-06,
                    2.0109e-06,
                    2.0847e-06,
                    2.1634e-06,
                    2.2471e-06,
                    2.3358e-06,
                    2.4293e-06,
                    2.5272e-06,
                    2.6292e-06,
                    2.7348e-06,
                    2.8441e-06,
                    2.957e-06,
                    3.0735e-06,
                    3.1934e-06,
                    3.3166e-06,
                    3.4429e-06,
                    3.5721e-06,
                    3.7039e-06,
                    3.838e-06,
                    3.9742e-06,
                    4.1127e-06,
                    4.2533e-06,
                    4.3961e-06,
                    4.5409e-06,
                    4.6874e-06,
                    4.8354e-06,
                    4.9845e-06,
                    5.1344e-06,
                    5.2846e-06,
                    5.4412e-06,
                    5.6151e-06,
                    5.8143e-06,
                    6.0443e-06,
                    6.3079e-06,
                    6.605e-06,
                    6.933e-06,
                    7.2865e-06,
                    7.6573e-06,
                    8.0346e-06,
                    8.4126e-06,
                    8.7927e-06,
                    9.1755e-06,
                    9.5618e-06,
                    9.9522e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_N2O": 0.02,
                "Fossil_N2O_timeseries": [
                    2.1027e-09,
                    4.23e-09,
                    6.3816e-09,
                    8.5569e-09,
                    1.0756e-08,
                    1.2977e-08,
                    1.522e-08,
                    1.7483e-08,
                    1.9767e-08,
                    2.2069e-08,
                    2.4389e-08,
                    2.6727e-08,
                    2.9082e-08,
                    3.1454e-08,
                    3.3844e-08,
                    3.6252e-08,
                    3.8676e-08,
                    4.1119e-08,
                    4.3579e-08,
                    4.6057e-08,
                    4.8559e-08,
                    5.1096e-08,
                    5.3676e-08,
                    5.6306e-08,
                    5.8988e-08,
                    6.1722e-08,
                    6.4509e-08,
                    6.7342e-08,
                    7.0216e-08,
                    7.3122e-08,
                    7.6052e-08,
                    7.9007e-08,
                    8.1984e-08,
                    8.4983e-08,
                    8.8004e-08,
                    9.1046e-08,
                    9.4109e-08,
                    9.7194e-08,
                    1.003e-07,
                    1.0349e-07,
                    1.0672e-07,
                    1.0999e-07,
                    1.133e-07,
                    1.1665e-07,
                    1.2004e-07,
                    1.2348e-07,
                    1.2697e-07,
                    1.305e-07,
                    1.3409e-07,
                    1.3772e-07,
                    1.4141e-07,
                    1.4516e-07,
                    1.4897e-07,
                    1.5285e-07,
                    1.568e-07,
                    1.6081e-07,
                    1.6489e-07,
                    1.6904e-07,
                    1.7325e-07,
                    1.7752e-07,
                    1.8183e-07,
                    1.862e-07,
                    1.9062e-07,
                    1.9508e-07,
                    1.9958e-07,
                    2.0413e-07,
                    2.0873e-07,
                    2.1337e-07,
                    2.1807e-07,
                    2.2283e-07,
                    2.2766e-07,
                    2.3256e-07,
                    2.3756e-07,
                    2.4265e-07,
                    2.4785e-07,
                    2.5315e-07,
                    2.5856e-07,
                    2.6408e-07,
                    2.6969e-07,
                    2.7541e-07,
                    2.8122e-07,
                    2.8713e-07,
                    2.9315e-07,
                    2.9928e-07,
                    3.0552e-07,
                    3.1186e-07,
                    3.1829e-07,
                    3.2479e-07,
                    3.3136e-07,
                    3.3796e-07,
                    3.4457e-07,
                    3.5118e-07,
                    3.5775e-07,
                    3.6428e-07,
                    3.7076e-07,
                    3.7719e-07,
                    3.8359e-07,
                    3.8998e-07,
                    3.9637e-07,
                    4.0279e-07,
                    4.0933e-07,
                    4.1608e-07,
                    4.2313e-07,
                    4.3056e-07,
                    4.3841e-07,
                    4.4673e-07,
                    4.5555e-07,
                    4.6487e-07,
                    4.747e-07,
                    4.8499e-07,
                    4.957e-07,
                    5.0676e-07,
                    5.1812e-07,
                    5.2982e-07,
                    5.4189e-07,
                    5.5442e-07,
                    5.6756e-07,
                    5.8148e-07,
                    5.9637e-07,
                    6.1183e-07,
                    6.2757e-07,
                    6.4431e-07,
                    6.6173e-07,
                    6.8029e-07,
                    6.9971e-07,
                    7.1944e-07,
                    7.4137e-07,
                    7.6327e-07,
                    7.8637e-07,
                    8.11e-07,
                    8.3655e-07,
                    8.7487e-07,
                    9.2112e-07,
                    9.7536e-07,
                    1.016e-06,
                    1.0848e-06,
                    1.1453e-06,
                    1.2056e-06,
                    1.2465e-06,
                    1.288e-06,
                    1.3298e-06,
                    1.3726e-06,
                    1.4158e-06,
                    1.4583e-06,
                    1.5141e-06,
                    1.5755e-06,
                    1.6386e-06,
                    1.7039e-06,
                    1.7676e-06,
                    1.8335e-06,
                    1.904e-06,
                    1.9775e-06,
                    2.0548e-06,
                    2.1366e-06,
                    2.218e-06,
                    2.2986e-06,
                    2.3825e-06,
                    2.4646e-06,
                    2.5471e-06,
                    2.628e-06,
                    2.7028e-06,
                    2.7838e-06,
                    2.8687e-06,
                    2.9577e-06,
                    3.0466e-06,
                    3.1419e-06,
                    3.2354e-06,
                    3.3286e-06,
                    3.4224e-06,
                    3.507e-06,
                    3.5931e-06,
                    3.6821e-06
                ],
                "Land_N2O": 0.08,
                "Land_N2O_timeseries": [
                    1.474e-08,
                    2.9775e-08,
                    4.5092e-08,
                    6.0674e-08,
                    7.6497e-08,
                    9.2536e-08,
                    1.0876e-07,
                    1.2513e-07,
                    1.416e-07,
                    1.5813e-07,
                    1.7468e-07,
                    1.9126e-07,
                    2.0786e-07,
                    2.2446e-07,
                    2.4108e-07,
                    2.577e-07,
                    2.7434e-07,
                    2.9099e-07,
                    3.0767e-07,
                    3.2438e-07,
                    3.4136e-07,
                    3.5906e-07,
                    3.7779e-07,
                    3.9778e-07,
                    4.1917e-07,
                    4.4199e-07,
                    4.6616e-07,
                    4.9153e-07,
                    5.1783e-07,
                    5.4469e-07,
                    5.7186e-07,
                    5.9931e-07,
                    6.2698e-07,
                    6.5484e-07,
                    6.8288e-07,
                    7.1108e-07,
                    7.3944e-07,
                    7.6798e-07,
                    7.9671e-07,
                    8.284e-07,
                    8.6037e-07,
                    8.9275e-07,
                    9.2563e-07,
                    9.5912e-07,
                    9.9329e-07,
                    1.0282e-06,
                    1.064e-06,
                    1.1006e-06,
                    1.1382e-06,
                    1.1766e-06,
                    1.2161e-06,
                    1.2567e-06,
                    1.2986e-06,
                    1.3418e-06,
                    1.3865e-06,
                    1.4329e-06,
                    1.481e-06,
                    1.5311e-06,
                    1.5833e-06,
                    1.6377e-06,
                    1.6948e-06,
                    1.7555e-06,
                    1.8203e-06,
                    1.8896e-06,
                    1.9638e-06,
                    2.0429e-06,
                    2.127e-06,
                    2.2159e-06,
                    2.3092e-06,
                    2.4063e-06,
                    2.5071e-06,
                    2.6115e-06,
                    2.7194e-06,
                    2.8308e-06,
                    2.9456e-06,
                    3.0635e-06,
                    3.1844e-06,
                    3.308e-06,
                    3.4342e-06,
                    3.5625e-06,
                    3.693e-06,
                    3.8255e-06,
                    3.9602e-06,
                    4.0968e-06,
                    4.2354e-06,
                    4.3755e-06,
                    4.5171e-06,
                    4.6597e-06,
                    4.8031e-06,
                    4.9467e-06,
                    5.0967e-06,
                    5.2639e-06,
                    5.4565e-06,
                    5.68e-06,
                    5.9371e-06,
                    6.2278e-06,
                    6.5494e-06,
                    6.8965e-06,
                    7.2609e-06,
                    7.6318e-06,
                    8.0033e-06,
                    8.3766e-06,
                    8.7524e-06,
                    9.1313e-06,
                    9.5137e-06,
                    9.9e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                141.01944,
                                -9.12962
                            ],
                            [
                                141.12105,
                                -9.2289
                            ],
                            [
                                141.18498,
                                -9.23852
                            ],
                            [
                                141.26384,
                                -9.20131
                            ],
                            [
                                141.32931,
                                -9.1393
                            ],
                            [
                                141.47274,
                                -9.15104
                            ],
                            [
                                141.52541,
                                -9.19953
                            ],
                            [
                                141.62986,
                                -9.21302
                            ],
                            [
                                141.77734,
                                -9.18335
                            ],
                            [
                                141.88263,
                                -9.20297
                            ],
                            [
                                141.96248,
                                -9.17464
                            ],
                            [
                                142.08087,
                                -9.17839
                            ],
                            [
                                142.21871,
                                -9.14774
                            ],
                            [
                                142.29887,
                                -9.1981
                            ],
                            [
                                142.45368,
                                -9.23507
                            ],
                            [
                                142.57476,
                                -9.32415
                            ],
                            [
                                142.6398,
                                -9.33292
                            ],
                            [
                                142.7052,
                                -9.30533
                            ],
                            [
                                142.93338,
                                -9.1711
                            ],
                            [
                                143.0249,
                                -9.09785
                            ],
                            [
                                143.14134,
                                -9.0699
                            ],
                            [
                                143.27108,
                                -9.01905
                            ],
                            [
                                143.33978,
                                -9.0243
                            ],
                            [
                                143.42442,
                                -8.96087
                            ],
                            [
                                143.39377,
                                -8.7433
                            ],
                            [
                                143.257,
                                -8.57382
                            ],
                            [
                                143.10965,
                                -8.45603
                            ],
                            [
                                142.93345,
                                -8.42391
                            ],
                            [
                                142.75442,
                                -8.31774
                            ],
                            [
                                142.6748,
                                -8.30734
                            ],
                            [
                                142.52187,
                                -8.36837
                            ],
                            [
                                142.45785,
                                -8.37012
                            ],
                            [
                                142.40555,
                                -8.32571
                            ],
                            [
                                142.37167,
                                -8.19447
                            ],
                            [
                                142.40777,
                                -8.1948
                            ],
                            [
                                142.42848,
                                -8.30066
                            ],
                            [
                                142.52381,
                                -8.33102
                            ],
                            [
                                142.66609,
                                -8.2686
                            ],
                            [
                                142.76353,
                                -8.27929
                            ],
                            [
                                142.86496,
                                -8.32684
                            ],
                            [
                                142.91717,
                                -8.31172
                            ],
                            [
                                142.99983,
                                -8.33695
                            ],
                            [
                                143.0948,
                                -8.3041
                            ],
                            [
                                143.29162,
                                -8.26995
                            ],
                            [
                                143.35391,
                                -8.24728
                            ],
                            [
                                143.58839,
                                -8.24013
                            ],
                            [
                                143.61758,
                                -8.2014
                            ],
                            [
                                143.5373,
                                -8.04645
                            ],
                            [
                                143.54689,
                                -8.00642
                            ],
                            [
                                143.61244,
                                -7.98991
                            ],
                            [
                                143.74372,
                                -8.04779
                            ],
                            [
                                143.86821,
                                -8.04573
                            ],
                            [
                                143.90825,
                                -7.94621
                            ],
                            [
                                143.84873,
                                -7.84215
                            ],
                            [
                                143.81489,
                                -7.70971
                            ],
                            [
                                143.74113,
                                -7.58681
                            ],
                            [
                                143.76066,
                                -7.52517
                            ],
                            [
                                143.82116,
                                -7.64593
                            ],
                            [
                                143.89882,
                                -7.7061
                            ],
                            [
                                144.14468,
                                -7.78631
                            ],
                            [
                                144.21645,
                                -7.67897
                            ],
                            [
                                144.28794,
                                -7.63506
                            ],
                            [
                                144.43025,
                                -7.7401
                            ],
                            [
                                144.44838,
                                -7.65666
                            ],
                            [
                                144.50284,
                                -7.61889
                            ],
                            [
                                144.53656,
                                -7.54843
                            ],
                            [
                                144.58152,
                                -7.63786
                            ],
                            [
                                144.66614,
                                -7.64359
                            ],
                            [
                                144.66516,
                                -7.55652
                            ],
                            [
                                144.75396,
                                -7.66061
                            ],
                            [
                                144.86081,
                                -7.70199
                            ],
                            [
                                144.87697,
                                -7.77534
                            ],
                            [
                                145.09017,
                                -7.80283
                            ],
                            [
                                145.16528,
                                -7.84233
                            ],
                            [
                                145.34153,
                                -7.86458
                            ],
                            [
                                145.43105,
                                -7.94665
                            ],
                            [
                                145.61035,
                                -7.93739
                            ],
                            [
                                145.768,
                                -7.96511
                            ],
                            [
                                145.85974,
                                -8.03874
                            ],
                            [
                                146.00278,
                                -8.05758
                            ],
                            [
                                146.07268,
                                -8.09225
                            ],
                            [
                                146.1149,
                                -8.18547
                            ],
                            [
                                146.26073,
                                -8.29673
                            ],
                            [
                                146.27619,
                                -8.4129
                            ],
                            [
                                146.31003,
                                -8.48419
                            ],
                            [
                                146.38865,
                                -8.59198
                            ],
                            [
                                146.44192,
                                -8.62158
                            ],
                            [
                                146.51901,
                                -8.70907
                            ],
                            [
                                146.57153,
                                -8.81338
                            ],
                            [
                                146.55703,
                                -8.88648
                            ],
                            [
                                146.59789,
                                -8.99534
                            ],
                            [
                                146.64187,
                                -9.02886
                            ],
                            [
                                146.78623,
                                -9.0579
                            ],
                            [
                                146.89113,
                                -9.11453
                            ],
                            [
                                146.91676,
                                -9.15832
                            ],
                            [
                                146.91184,
                                -9.27144
                            ],
                            [
                                146.976,
                                -9.28245
                            ],
                            [
                                147.01555,
                                -9.38493
                            ],
                            [
                                147.07694,
                                -9.46471
                            ],
                            [
                                147.12374,
                                -9.42711
                            ],
                            [
                                147.23987,
                                -9.53492
                            ],
                            [
                                147.26432,
                                -9.49325
                            ],
                            [
                                147.48686,
                                -9.75193
                            ],
                            [
                                147.51842,
                                -9.86828
                            ],
                            [
                                147.63463,
                                -9.98926
                            ],
                            [
                                147.7082,
                                -10.01947
                            ],
                            [
                                147.72906,
                                -10.09455
                            ],
                            [
                                147.78731,
                                -10.05366
                            ],
                            [
                                147.93366,
                                -10.09798
                            ],
                            [
                                147.97819,
                                -10.1573
                            ],
                            [
                                148.09688,
                                -10.13622
                            ],
                            [
                                148.16706,
                                -10.09265
                            ],
                            [
                                148.22037,
                                -10.09643
                            ],
                            [
                                148.33491,
                                -10.1455
                            ],
                            [
                                148.40436,
                                -10.2041
                            ],
                            [
                                148.50819,
                                -10.19922
                            ],
                            [
                                148.56659,
                                -10.17622
                            ],
                            [
                                148.65216,
                                -10.18991
                            ],
                            [
                                148.72063,
                                -10.17659
                            ],
                            [
                                148.80025,
                                -10.24556
                            ],
                            [
                                148.86832,
                                -10.23551
                            ],
                            [
                                148.96792,
                                -10.28459
                            ],
                            [
                                149.03917,
                                -10.23902
                            ],
                            [
                                149.0903,
                                -10.23456
                            ],
                            [
                                149.32328,
                                -10.3114
                            ],
                            [
                                149.36759,
                                -10.28036
                            ],
                            [
                                149.44792,
                                -10.33216
                            ],
                            [
                                149.53871,
                                -10.36153
                            ],
                            [
                                149.57601,
                                -10.34533
                            ],
                            [
                                149.70571,
                                -10.34303
                            ],
                            [
                                149.79848,
                                -10.3685
                            ],
                            [
                                149.87118,
                                -10.41404
                            ],
                            [
                                150.05929,
                                -10.47537
                            ],
                            [
                                149.98576,
                                -10.5222
                            ],
                            [
                                149.91839,
                                -10.5196
                            ],
                            [
                                149.88307,
                                -10.56528
                            ],
                            [
                                150.01759,
                                -10.57963
                            ],
                            [
                                150.07514,
                                -10.64822
                            ],
                            [
                                150.14348,
                                -10.65349
                            ],
                            [
                                150.20712,
                                -10.70019
                            ],
                            [
                                150.3506,
                                -10.66218
                            ],
                            [
                                150.41069,
                                -10.68329
                            ],
                            [
                                150.47194,
                                -10.62449
                            ],
                            [
                                150.53744,
                                -10.62317
                            ],
                            [
                                150.60599,
                                -10.58349
                            ],
                            [
                                150.69211,
                                -10.56155
                            ],
                            [
                                150.64725,
                                -10.47875
                            ],
                            [
                                150.49205,
                                -10.426
                            ],
                            [
                                150.34329,
                                -10.39782
                            ],
                            [
                                150.35432,
                                -10.33163
                            ],
                            [
                                150.40829,
                                -10.29757
                            ],
                            [
                                150.55413,
                                -10.34463
                            ],
                            [
                                150.62781,
                                -10.35045
                            ],
                            [
                                150.76108,
                                -10.29785
                            ],
                            [
                                150.70041,
                                -10.25731
                            ],
                            [
                                150.61389,
                                -10.28297
                            ],
                            [
                                150.57369,
                                -10.23144
                            ],
                            [
                                150.51782,
                                -10.22979
                            ],
                            [
                                150.30022,
                                -10.18677
                            ],
                            [
                                150.16493,
                                -10.0937
                            ],
                            [
                                149.99385,
                                -10.08387
                            ],
                            [
                                149.93081,
                                -10.0598
                            ],
                            [
                                149.7594,
                                -9.89995
                            ],
                            [
                                149.7161,
                                -9.8491
                            ],
                            [
                                149.73178,
                                -9.80135
                            ],
                            [
                                149.92413,
                                -9.77039
                            ],
                            [
                                150.05026,
                                -9.72418
                            ],
                            [
                                150.011,
                                -9.63911
                            ],
                            [
                                149.88004,
                                -9.64662
                            ],
                            [
                                149.75699,
                                -9.59901
                            ],
                            [
                                149.62203,
                                -9.62564
                            ],
                            [
                                149.55994,
                                -9.6067
                            ],
                            [
                                149.45445,
                                -9.61434
                            ],
                            [
                                149.35615,
                                -9.52483
                            ],
                            [
                                149.26908,
                                -9.51129
                            ],
                            [
                                149.20249,
                                -9.4508
                            ],
                            [
                                149.18163,
                                -9.35588
                            ],
                            [
                                149.22172,
                                -9.31108
                            ],
                            [
                                149.26361,
                                -9.17815
                            ],
                            [
                                149.32532,
                                -9.12108
                            ],
                            [
                                149.2958,
                                -9.02424
                            ],
                            [
                                149.24778,
                                -9.00503
                            ],
                            [
                                149.01385,
                                -9.06466
                            ],
                            [
                                148.91383,
                                -9.05022
                            ],
                            [
                                148.87484,
                                -9.0862
                            ],
                            [
                                148.76685,
                                -9.11326
                            ],
                            [
                                148.58973,
                                -9.07069
                            ],
                            [
                                148.53158,
                                -9.00286
                            ],
                            [
                                148.52031,
                                -8.92091
                            ],
                            [
                                148.49167,
                                -8.89244
                            ],
                            [
                                148.47367,
                                -8.7545
                            ],
                            [
                                148.43729,
                                -8.68908
                            ],
                            [
                                148.3495,
                                -8.6291
                            ],
                            [
                                148.27884,
                                -8.61406
                            ],
                            [
                                148.22751,
                                -8.56339
                            ],
                            [
                                148.23444,
                                -8.45653
                            ],
                            [
                                148.20897,
                                -8.4015
                            ],
                            [
                                148.19944,
                                -8.28097
                            ],
                            [
                                148.1457,
                                -8.15305
                            ],
                            [
                                148.12766,
                                -8.06486
                            ],
                            [
                                147.99301,
                                -8.07283
                            ],
                            [
                                147.95728,
                                -8.00195
                            ],
                            [
                                147.87107,
                                -7.94284
                            ],
                            [
                                147.75833,
                                -7.95113
                            ],
                            [
                                147.69133,
                                -7.90496
                            ],
                            [
                                147.66412,
                                -7.79463
                            ],
                            [
                                147.6118,
                                -7.82007
                            ],
                            [
                                147.57191,
                                -7.70645
                            ],
                            [
                                147.51656,
                                -7.70168
                            ],
                            [
                                147.50877,
                                -7.64908
                            ],
                            [
                                147.37342,
                                -7.52704
                            ],
                            [
                                147.22279,
                                -7.46549
                            ],
                            [
                                147.14563,
                                -7.37625
                            ],
                            [
                                147.14705,
                                -7.30573
                            ],
                            [
                                147.11828,
                                -7.19638
                            ],
                            [
                                147.05572,
                                -7.1446
                            ],
                            [
                                147.06891,
                                -7.08259
                            ],
                            [
                                146.95454,
                                -6.9794
                            ],
                            [
                                146.94638,
                                -6.82366
                            ],
                            [
                                146.96594,
                                -6.74299
                            ],
                            [
                                147.14705,
                                -6.70096
                            ],
                            [
                                147.20136,
                                -6.73452
                            ],
                            [
                                147.3381,
                                -6.74444
                            ],
                            [
                                147.38558,
                                -6.71936
                            ],
                            [
                                147.56666,
                                -6.74165
                            ],
                            [
                                147.57341,
                                -6.712
                            ],
                            [
                                147.80114,
                                -6.68943
                            ],
                            [
                                147.86041,
                                -6.62831
                            ],
                            [
                                147.83322,
                                -6.50624
                            ],
                            [
                                147.85015,
                                -6.43147
                            ],
                            [
                                147.80662,
                                -6.32277
                            ],
                            [
                                147.69902,
                                -6.25709
                            ],
                            [
                                147.66914,
                                -6.17918
                            ],
                            [
                                147.57358,
                                -6.05641
                            ],
                            [
                                147.50222,
                                -6.02191
                            ],
                            [
                                147.44741,
                                -5.96872
                            ],
                            [
                                147.37096,
                                -5.9594
                            ],
                            [
                                147.26294,
                                -5.91695
                            ],
                            [
                                147.20752,
                                -5.96188
                            ],
                            [
                                147.1079,
                                -5.95995
                            ],
                            [
                                147.03704,
                                -5.91316
                            ],
                            [
                                146.99987,
                                -5.93647
                            ],
                            [
                                146.92985,
                                -5.90017
                            ],
                            [
                                146.86617,
                                -5.8361
                            ],
                            [
                                146.79745,
                                -5.85621
                            ],
                            [
                                146.70294,
                                -5.77407
                            ],
                            [
                                146.63113,
                                -5.76034
                            ],
                            [
                                146.53857,
                                -5.66538
                            ],
                            [
                                146.44731,
                                -5.60363
                            ],
                            [
                                146.3807,
                                -5.61332
                            ],
                            [
                                146.34283,
                                -5.57243
                            ],
                            [
                                146.26974,
                                -5.57399
                            ],
                            [
                                146.12101,
                                -5.53601
                            ],
                            [
                                145.98323,
                                -5.47118
                            ],
                            [
                                145.91436,
                                -5.49198
                            ],
                            [
                                145.83268,
                                -5.47346
                            ],
                            [
                                145.79132,
                                -5.49222
                            ],
                            [
                                145.73455,
                                -5.42017
                            ],
                            [
                                145.7556,
                                -5.31135
                            ],
                            [
                                145.798,
                                -5.21264
                            ],
                            [
                                145.81279,
                                -5.06116
                            ],
                            [
                                145.78076,
                                -4.94141
                            ],
                            [
                                145.80187,
                                -4.84908
                            ],
                            [
                                145.66933,
                                -4.75155
                            ],
                            [
                                145.59747,
                                -4.67442
                            ],
                            [
                                145.55033,
                                -4.58899
                            ],
                            [
                                145.4543,
                                -4.49523
                            ],
                            [
                                145.36486,
                                -4.44192
                            ],
                            [
                                145.33161,
                                -4.39149
                            ],
                            [
                                145.28331,
                                -4.37946
                            ],
                            [
                                145.18508,
                                -4.39996
                            ],
                            [
                                145.02811,
                                -4.34383
                            ],
                            [
                                144.91096,
                                -4.20185
                            ],
                            [
                                144.85182,
                                -4.18904
                            ],
                            [
                                144.84893,
                                -4.11644
                            ],
                            [
                                144.65227,
                                -4.01454
                            ],
                            [
                                144.58109,
                                -4.0076
                            ],
                            [
                                144.51707,
                                -3.95084
                            ],
                            [
                                144.55329,
                                -3.88901
                            ],
                            [
                                144.52281,
                                -3.81832
                            ],
                            [
                                144.3828,
                                -3.78996
                            ],
                            [
                                144.2441,
                                -3.8147
                            ],
                            [
                                144.16829,
                                -3.84204
                            ],
                            [
                                144.11566,
                                -3.80373
                            ],
                            [
                                143.97273,
                                -3.78859
                            ],
                            [
                                143.88941,
                                -3.69828
                            ],
                            [
                                143.8313,
                                -3.67842
                            ],
                            [
                                143.78395,
                                -3.62583
                            ],
                            [
                                143.60123,
                                -3.5469
                            ],
                            [
                                143.51298,
                                -3.44471
                            ],
                            [
                                143.41289,
                                -3.41105
                            ],
                            [
                                143.23933,
                                -3.39113
                            ],
                            [
                                143.10951,
                                -3.35437
                            ],
                            [
                                143.04474,
                                -3.36358
                            ],
                            [
                                142.87062,
                                -3.32947
                            ],
                            [
                                142.6146,
                                -3.24644
                            ],
                            [
                                142.53373,
                                -3.23286
                            ],
                            [
                                142.34189,
                                -3.12656
                            ],
                            [
                                142.2078,
                                -3.10402
                            ],
                            [
                                142.12135,
                                -3.05906
                            ],
                            [
                                142.00658,
                                -2.97435
                            ],
                            [
                                141.88045,
                                -2.97525
                            ],
                            [
                                141.82028,
                                -2.91982
                            ],
                            [
                                141.73765,
                                -2.88997
                            ],
                            [
                                141.50911,
                                -2.77218
                            ],
                            [
                                141.33671,
                                -2.71583
                            ],
                            [
                                141.20517,
                                -2.63707
                            ],
                            [
                                141.1595,
                                -2.64246
                            ],
                            [
                                141.05987,
                                -2.60964
                            ],
                            [
                                141.0,
                                -2.6087
                            ],
                            [
                                140.99982,
                                -6.3088
                            ],
                            [
                                140.92677,
                                -6.45858
                            ],
                            [
                                140.92742,
                                -6.56182
                            ],
                            [
                                140.8687,
                                -6.61808
                            ],
                            [
                                140.84935,
                                -6.71828
                            ],
                            [
                                140.89718,
                                -6.75302
                            ],
                            [
                                140.90171,
                                -6.84922
                            ],
                            [
                                141.01822,
                                -6.89888
                            ],
                            [
                                141.01843,
                                -7.2958
                            ],
                            [
                                141.01915,
                                -8.59413
                            ],
                            [
                                141.01944,
                                -9.12962
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                150.13288,
                                -6.25924
                            ],
                            [
                                150.18605,
                                -6.23761
                            ],
                            [
                                150.23823,
                                -6.28153
                            ],
                            [
                                150.45611,
                                -6.24883
                            ],
                            [
                                150.55589,
                                -6.15512
                            ],
                            [
                                150.7562,
                                -6.10487
                            ],
                            [
                                150.76845,
                                -6.03972
                            ],
                            [
                                150.90412,
                                -6.012
                            ],
                            [
                                151.00887,
                                -6.03092
                            ],
                            [
                                151.072,
                                -5.97384
                            ],
                            [
                                151.1452,
                                -5.9445
                            ],
                            [
                                151.37482,
                                -5.80419
                            ],
                            [
                                151.41572,
                                -5.70156
                            ],
                            [
                                151.50257,
                                -5.6777
                            ],
                            [
                                151.45682,
                                -5.62544
                            ],
                            [
                                151.44411,
                                -5.5698
                            ],
                            [
                                151.48553,
                                -5.51613
                            ],
                            [
                                151.58711,
                                -5.53364
                            ],
                            [
                                151.72949,
                                -5.5196
                            ],
                            [
                                151.80597,
                                -5.58619
                            ],
                            [
                                151.9561,
                                -5.51392
                            ],
                            [
                                152.04955,
                                -5.4472
                            ],
                            [
                                152.12485,
                                -5.37381
                            ],
                            [
                                152.11691,
                                -5.30831
                            ],
                            [
                                152.06288,
                                -5.24067
                            ],
                            [
                                151.99335,
                                -5.20061
                            ],
                            [
                                151.94811,
                                -5.14411
                            ],
                            [
                                151.9507,
                                -4.99874
                            ],
                            [
                                152.05664,
                                -4.97213
                            ],
                            [
                                152.14021,
                                -4.99224
                            ],
                            [
                                152.21865,
                                -4.97193
                            ],
                            [
                                152.32658,
                                -4.83837
                            ],
                            [
                                152.35904,
                                -4.7683
                            ],
                            [
                                152.37487,
                                -4.61745
                            ],
                            [
                                152.3278,
                                -4.5045
                            ],
                            [
                                152.39789,
                                -4.33647
                            ],
                            [
                                152.27302,
                                -4.34422
                            ],
                            [
                                152.14729,
                                -4.23407
                            ],
                            [
                                152.21802,
                                -4.21437
                            ],
                            [
                                152.15947,
                                -4.14146
                            ],
                            [
                                152.11923,
                                -4.2077
                            ],
                            [
                                152.03163,
                                -4.19658
                            ],
                            [
                                152.02824,
                                -4.26043
                            ],
                            [
                                151.99599,
                                -4.3087
                            ],
                            [
                                151.92897,
                                -4.34186
                            ],
                            [
                                151.83911,
                                -4.27559
                            ],
                            [
                                151.84287,
                                -4.22777
                            ],
                            [
                                151.66335,
                                -4.19818
                            ],
                            [
                                151.52938,
                                -4.18901
                            ],
                            [
                                151.48722,
                                -4.22445
                            ],
                            [
                                151.51701,
                                -4.29511
                            ],
                            [
                                151.53206,
                                -4.39076
                            ],
                            [
                                151.61803,
                                -4.48165
                            ],
                            [
                                151.60968,
                                -4.56485
                            ],
                            [
                                151.65127,
                                -4.61474
                            ],
                            [
                                151.6548,
                                -4.76741
                            ],
                            [
                                151.68023,
                                -4.87607
                            ],
                            [
                                151.646,
                                -4.93297
                            ],
                            [
                                151.58101,
                                -4.97025
                            ],
                            [
                                151.52333,
                                -4.92858
                            ],
                            [
                                151.48512,
                                -4.95314
                            ],
                            [
                                151.35447,
                                -4.91329
                            ],
                            [
                                151.34199,
                                -4.95743
                            ],
                            [
                                151.23236,
                                -5.00864
                            ],
                            [
                                151.1625,
                                -5.09224
                            ],
                            [
                                151.08409,
                                -5.14987
                            ],
                            [
                                151.00775,
                                -5.3079
                            ],
                            [
                                151.00608,
                                -5.37434
                            ],
                            [
                                150.89851,
                                -5.48319
                            ],
                            [
                                150.83234,
                                -5.48258
                            ],
                            [
                                150.75345,
                                -5.45086
                            ],
                            [
                                150.73328,
                                -5.49898
                            ],
                            [
                                150.67527,
                                -5.54457
                            ],
                            [
                                150.61771,
                                -5.54735
                            ],
                            [
                                150.57181,
                                -5.47902
                            ],
                            [
                                150.51399,
                                -5.43554
                            ],
                            [
                                150.40891,
                                -5.43652
                            ],
                            [
                                150.28324,
                                -5.55752
                            ],
                            [
                                150.1454,
                                -5.54819
                            ],
                            [
                                150.0977,
                                -5.49597
                            ],
                            [
                                150.07724,
                                -5.40087
                            ],
                            [
                                150.04441,
                                -5.35972
                            ],
                            [
                                150.02348,
                                -5.27627
                            ],
                            [
                                150.07492,
                                -5.25738
                            ],
                            [
                                150.05435,
                                -5.17492
                            ],
                            [
                                150.08661,
                                -5.12175
                            ],
                            [
                                150.17202,
                                -5.08989
                            ],
                            [
                                150.18461,
                                -5.04937
                            ],
                            [
                                150.11936,
                                -5.00441
                            ],
                            [
                                150.03477,
                                -5.0124
                            ],
                            [
                                150.02544,
                                -5.10191
                            ],
                            [
                                149.99897,
                                -5.15538
                            ],
                            [
                                150.02257,
                                -5.20237
                            ],
                            [
                                149.90358,
                                -5.33467
                            ],
                            [
                                149.9661,
                                -5.40353
                            ],
                            [
                                149.9426,
                                -5.45962
                            ],
                            [
                                149.85529,
                                -5.51828
                            ],
                            [
                                149.79893,
                                -5.48874
                            ],
                            [
                                149.71269,
                                -5.54174
                            ],
                            [
                                149.66434,
                                -5.4924
                            ],
                            [
                                149.57052,
                                -5.49768
                            ],
                            [
                                149.48379,
                                -5.55545
                            ],
                            [
                                149.29133,
                                -5.56108
                            ],
                            [
                                149.20471,
                                -5.57729
                            ],
                            [
                                149.06962,
                                -5.49031
                            ],
                            [
                                148.9565,
                                -5.46013
                            ],
                            [
                                148.87622,
                                -5.48241
                            ],
                            [
                                148.79794,
                                -5.5282
                            ],
                            [
                                148.72206,
                                -5.48128
                            ],
                            [
                                148.654,
                                -5.47825
                            ],
                            [
                                148.5793,
                                -5.52922
                            ],
                            [
                                148.5226,
                                -5.52729
                            ],
                            [
                                148.4915,
                                -5.474
                            ],
                            [
                                148.41887,
                                -5.44409
                            ],
                            [
                                148.34816,
                                -5.48389
                            ],
                            [
                                148.3085,
                                -5.64182
                            ],
                            [
                                148.3244,
                                -5.69819
                            ],
                            [
                                148.39002,
                                -5.76459
                            ],
                            [
                                148.48282,
                                -5.79025
                            ],
                            [
                                148.56003,
                                -5.83282
                            ],
                            [
                                148.60241,
                                -5.80968
                            ],
                            [
                                148.64548,
                                -5.84888
                            ],
                            [
                                148.7467,
                                -5.86978
                            ],
                            [
                                148.87128,
                                -5.98449
                            ],
                            [
                                149.02426,
                                -6.04455
                            ],
                            [
                                149.01412,
                                -6.08707
                            ],
                            [
                                149.09785,
                                -6.14473
                            ],
                            [
                                149.15507,
                                -6.08804
                            ],
                            [
                                149.23046,
                                -6.09591
                            ],
                            [
                                149.25251,
                                -6.06446
                            ],
                            [
                                149.33281,
                                -6.05623
                            ],
                            [
                                149.46335,
                                -6.0972
                            ],
                            [
                                149.5526,
                                -6.24438
                            ],
                            [
                                149.60305,
                                -6.28707
                            ],
                            [
                                149.74338,
                                -6.27042
                            ],
                            [
                                149.89741,
                                -6.29178
                            ],
                            [
                                149.95079,
                                -6.25521
                            ],
                            [
                                150.00275,
                                -6.30685
                            ],
                            [
                                150.13288,
                                -6.25924
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                155.32088,
                                -6.70945
                            ],
                            [
                                155.51072,
                                -6.83926
                            ],
                            [
                                155.70052,
                                -6.88041
                            ],
                            [
                                155.81428,
                                -6.76483
                            ],
                            [
                                155.90531,
                                -6.79818
                            ],
                            [
                                155.96236,
                                -6.70728
                            ],
                            [
                                155.91875,
                                -6.60048
                            ],
                            [
                                155.91894,
                                -6.51361
                            ],
                            [
                                155.86149,
                                -6.47124
                            ],
                            [
                                155.81035,
                                -6.36319
                            ],
                            [
                                155.75579,
                                -6.34075
                            ],
                            [
                                155.69942,
                                -6.26996
                            ],
                            [
                                155.63251,
                                -6.21754
                            ],
                            [
                                155.56016,
                                -6.21963
                            ],
                            [
                                155.53918,
                                -6.17703
                            ],
                            [
                                155.45979,
                                -6.15573
                            ],
                            [
                                155.41887,
                                -6.09865
                            ],
                            [
                                155.39726,
                                -5.99391
                            ],
                            [
                                155.17999,
                                -5.83939
                            ],
                            [
                                155.17079,
                                -5.74906
                            ],
                            [
                                155.0782,
                                -5.62659
                            ],
                            [
                                155.03277,
                                -5.53489
                            ],
                            [
                                154.87128,
                                -5.53094
                            ],
                            [
                                154.77263,
                                -5.47403
                            ],
                            [
                                154.71075,
                                -5.40948
                            ],
                            [
                                154.66955,
                                -5.43779
                            ],
                            [
                                154.75311,
                                -5.52659
                            ],
                            [
                                154.75694,
                                -5.57082
                            ],
                            [
                                154.70809,
                                -5.66903
                            ],
                            [
                                154.69617,
                                -5.76599
                            ],
                            [
                                154.74516,
                                -5.86888
                            ],
                            [
                                154.74092,
                                -5.94244
                            ],
                            [
                                154.81587,
                                -6.02654
                            ],
                            [
                                154.90521,
                                -6.07218
                            ],
                            [
                                154.95795,
                                -6.128
                            ],
                            [
                                154.96824,
                                -6.1999
                            ],
                            [
                                155.03792,
                                -6.25075
                            ],
                            [
                                155.15643,
                                -6.2764
                            ],
                            [
                                155.20547,
                                -6.31436
                            ],
                            [
                                155.22453,
                                -6.43696
                            ],
                            [
                                155.19585,
                                -6.52381
                            ],
                            [
                                155.16039,
                                -6.53419
                            ],
                            [
                                155.32088,
                                -6.70945
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                152.7077,
                                -3.87665
                            ],
                            [
                                152.63518,
                                -3.82395
                            ],
                            [
                                152.55378,
                                -3.81174
                            ],
                            [
                                152.53818,
                                -3.738
                            ],
                            [
                                152.47674,
                                -3.63675
                            ],
                            [
                                152.41656,
                                -3.66833
                            ],
                            [
                                152.34927,
                                -3.53536
                            ],
                            [
                                152.19965,
                                -3.45019
                            ],
                            [
                                152.03848,
                                -3.24158
                            ],
                            [
                                151.95645,
                                -3.237
                            ],
                            [
                                151.93447,
                                -3.2027
                            ],
                            [
                                151.80186,
                                -3.18961
                            ],
                            [
                                151.76993,
                                -3.13552
                            ],
                            [
                                151.72012,
                                -3.12246
                            ],
                            [
                                151.66837,
                                -3.04801
                            ],
                            [
                                151.4827,
                                -2.97402
                            ],
                            [
                                151.41479,
                                -2.90615
                            ],
                            [
                                151.34435,
                                -2.9066
                            ],
                            [
                                151.29901,
                                -2.87335
                            ],
                            [
                                151.24918,
                                -2.88326
                            ],
                            [
                                151.18565,
                                -2.85447
                            ],
                            [
                                151.18374,
                                -2.80646
                            ],
                            [
                                151.05756,
                                -2.74654
                            ],
                            [
                                151.02358,
                                -2.69396
                            ],
                            [
                                150.95041,
                                -2.68731
                            ],
                            [
                                150.81718,
                                -2.57309
                            ],
                            [
                                150.77943,
                                -2.61822
                            ],
                            [
                                150.84503,
                                -2.66574
                            ],
                            [
                                150.78392,
                                -2.73791
                            ],
                            [
                                150.8088,
                                -2.79113
                            ],
                            [
                                150.90525,
                                -2.76785
                            ],
                            [
                                150.98043,
                                -2.78983
                            ],
                            [
                                151.02777,
                                -2.83034
                            ],
                            [
                                151.09726,
                                -2.84887
                            ],
                            [
                                151.14304,
                                -2.9052
                            ],
                            [
                                151.42352,
                                -3.05774
                            ],
                            [
                                151.46653,
                                -3.1154
                            ],
                            [
                                151.60953,
                                -3.17442
                            ],
                            [
                                151.72187,
                                -3.30209
                            ],
                            [
                                151.79534,
                                -3.33963
                            ],
                            [
                                151.91001,
                                -3.42895
                            ],
                            [
                                151.97781,
                                -3.45481
                            ],
                            [
                                152.14547,
                                -3.48489
                            ],
                            [
                                152.26713,
                                -3.57172
                            ],
                            [
                                152.33843,
                                -3.64073
                            ],
                            [
                                152.35274,
                                -3.70713
                            ],
                            [
                                152.44563,
                                -3.82365
                            ],
                            [
                                152.49925,
                                -3.85837
                            ],
                            [
                                152.58356,
                                -3.99175
                            ],
                            [
                                152.61091,
                                -4.09317
                            ],
                            [
                                152.67722,
                                -4.18503
                            ],
                            [
                                152.68223,
                                -4.29842
                            ],
                            [
                                152.6689,
                                -4.42458
                            ],
                            [
                                152.64863,
                                -4.45797
                            ],
                            [
                                152.71386,
                                -4.64891
                            ],
                            [
                                152.7658,
                                -4.68724
                            ],
                            [
                                152.86863,
                                -4.81782
                            ],
                            [
                                152.95711,
                                -4.75504
                            ],
                            [
                                153.0524,
                                -4.6004
                            ],
                            [
                                153.05283,
                                -4.53212
                            ],
                            [
                                153.02166,
                                -4.47741
                            ],
                            [
                                153.10418,
                                -4.38686
                            ],
                            [
                                153.10799,
                                -4.27594
                            ],
                            [
                                153.03041,
                                -4.19306
                            ],
                            [
                                153.00198,
                                -4.10921
                            ],
                            [
                                152.93986,
                                -4.04634
                            ],
                            [
                                152.94063,
                                -4.00195
                            ],
                            [
                                152.85038,
                                -3.97583
                            ],
                            [
                                152.79895,
                                -3.8592
                            ],
                            [
                                152.7077,
                                -3.87665
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                147.28345,
                                -2.0323
                            ],
                            [
                                147.15617,
                                -1.98648
                            ],
                            [
                                147.07815,
                                -1.97436
                            ],
                            [
                                146.90165,
                                -1.97147
                            ],
                            [
                                146.84781,
                                -1.95575
                            ],
                            [
                                146.75598,
                                -1.99817
                            ],
                            [
                                146.63766,
                                -1.97302
                            ],
                            [
                                146.56561,
                                -2.04411
                            ],
                            [
                                146.6088,
                                -2.11533
                            ],
                            [
                                146.51703,
                                -2.14246
                            ],
                            [
                                146.50673,
                                -2.20445
                            ],
                            [
                                146.55173,
                                -2.25273
                            ],
                            [
                                146.60033,
                                -2.18402
                            ],
                            [
                                146.65033,
                                -2.20649
                            ],
                            [
                                146.78636,
                                -2.17937
                            ],
                            [
                                146.96835,
                                -2.21564
                            ],
                            [
                                147.06312,
                                -2.20589
                            ],
                            [
                                147.10753,
                                -2.17455
                            ],
                            [
                                147.19414,
                                -2.2047
                            ],
                            [
                                147.2563,
                                -2.152
                            ],
                            [
                                147.28345,
                                -2.0323
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                150.64725,
                                -9.66641
                            ],
                            [
                                150.80449,
                                -9.66569
                            ],
                            [
                                150.92602,
                                -9.68353
                            ],
                            [
                                150.93219,
                                -9.64777
                            ],
                            [
                                150.87387,
                                -9.59645
                            ],
                            [
                                150.89217,
                                -9.52949
                            ],
                            [
                                150.84152,
                                -9.49214
                            ],
                            [
                                150.79465,
                                -9.41689
                            ],
                            [
                                150.67551,
                                -9.43871
                            ],
                            [
                                150.60189,
                                -9.38004
                            ],
                            [
                                150.48317,
                                -9.33123
                            ],
                            [
                                150.42267,
                                -9.38051
                            ],
                            [
                                150.43108,
                                -9.43479
                            ],
                            [
                                150.50976,
                                -9.50945
                            ],
                            [
                                150.51671,
                                -9.56278
                            ],
                            [
                                150.45967,
                                -9.58481
                            ],
                            [
                                150.45438,
                                -9.64657
                            ],
                            [
                                150.55524,
                                -9.62848
                            ],
                            [
                                150.64725,
                                -9.66641
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                149.97246,
                                -2.4823
                            ],
                            [
                                150.05654,
                                -2.53691
                            ],
                            [
                                150.08265,
                                -2.59914
                            ],
                            [
                                150.16795,
                                -2.68268
                            ],
                            [
                                150.26637,
                                -2.66349
                            ],
                            [
                                150.34489,
                                -2.68262
                            ],
                            [
                                150.43826,
                                -2.65705
                            ],
                            [
                                150.43248,
                                -2.48114
                            ],
                            [
                                150.26649,
                                -2.41521
                            ],
                            [
                                150.19162,
                                -2.36155
                            ],
                            [
                                150.15062,
                                -2.39339
                            ],
                            [
                                150.06498,
                                -2.40942
                            ],
                            [
                                149.97246,
                                -2.4823
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                150.74279,
                                -9.73991
                            ],
                            [
                                150.87054,
                                -9.88741
                            ],
                            [
                                150.88995,
                                -9.99022
                            ],
                            [
                                150.94853,
                                -10.02374
                            ],
                            [
                                150.9635,
                                -10.10477
                            ],
                            [
                                151.06443,
                                -10.11397
                            ],
                            [
                                151.15433,
                                -10.15055
                            ],
                            [
                                151.22258,
                                -10.1519
                            ],
                            [
                                151.29263,
                                -9.97285
                            ],
                            [
                                151.2684,
                                -9.91996
                            ],
                            [
                                151.18156,
                                -9.94254
                            ],
                            [
                                151.14127,
                                -10.03279
                            ],
                            [
                                151.08657,
                                -10.03041
                            ],
                            [
                                151.03266,
                                -9.9866
                            ],
                            [
                                150.99455,
                                -9.91918
                            ],
                            [
                                150.89793,
                                -9.81973
                            ],
                            [
                                150.85587,
                                -9.8065
                            ],
                            [
                                150.81595,
                                -9.74017
                            ],
                            [
                                150.74279,
                                -9.73991
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                147.74913,
                                -5.52307
                            ],
                            [
                                147.75944,
                                -5.60544
                            ],
                            [
                                147.85801,
                                -5.69619
                            ],
                            [
                                147.86203,
                                -5.74226
                            ],
                            [
                                148.03406,
                                -5.8183
                            ],
                            [
                                148.08776,
                                -5.64214
                            ],
                            [
                                148.04772,
                                -5.58218
                            ],
                            [
                                147.96919,
                                -5.53215
                            ],
                            [
                                147.88424,
                                -5.51509
                            ],
                            [
                                147.84537,
                                -5.46497
                            ],
                            [
                                147.7741,
                                -5.45812
                            ],
                            [
                                147.74913,
                                -5.52307
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                152.7077,
                                -9.01398
                            ],
                            [
                                152.61699,
                                -8.98762
                            ],
                            [
                                152.50846,
                                -8.99544
                            ],
                            [
                                152.55616,
                                -9.05605
                            ],
                            [
                                152.68919,
                                -9.14986
                            ],
                            [
                                152.71447,
                                -9.2327
                            ],
                            [
                                152.75708,
                                -9.22485
                            ],
                            [
                                152.82892,
                                -9.264
                            ],
                            [
                                152.89231,
                                -9.25249
                            ],
                            [
                                152.97827,
                                -9.20096
                            ],
                            [
                                153.00247,
                                -9.15011
                            ],
                            [
                                152.9472,
                                -9.09108
                            ],
                            [
                                152.83773,
                                -9.07378
                            ],
                            [
                                152.79367,
                                -9.01008
                            ],
                            [
                                152.7077,
                                -9.01398
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                153.17335,
                                -11.36821
                            ],
                            [
                                153.2199,
                                -11.43905
                            ],
                            [
                                153.33064,
                                -11.50024
                            ],
                            [
                                153.35406,
                                -11.55801
                            ],
                            [
                                153.52673,
                                -11.61675
                            ],
                            [
                                153.75932,
                                -11.62623
                            ],
                            [
                                153.77115,
                                -11.60482
                            ],
                            [
                                153.68668,
                                -11.51483
                            ],
                            [
                                153.56306,
                                -11.48023
                            ],
                            [
                                153.34759,
                                -11.40506
                            ],
                            [
                                153.1928,
                                -11.32776
                            ],
                            [
                                153.17335,
                                -11.36821
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                150.31696,
                                -9.25358
                            ],
                            [
                                150.20926,
                                -9.1985
                            ],
                            [
                                150.15656,
                                -9.22126
                            ],
                            [
                                150.09518,
                                -9.31216
                            ],
                            [
                                150.10744,
                                -9.36878
                            ],
                            [
                                150.16707,
                                -9.43843
                            ],
                            [
                                150.24081,
                                -9.45559
                            ],
                            [
                                150.30802,
                                -9.5246
                            ],
                            [
                                150.38442,
                                -9.39102
                            ],
                            [
                                150.31696,
                                -9.25358
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                154.51344,
                                -5.12856
                            ],
                            [
                                154.56607,
                                -5.20681
                            ],
                            [
                                154.54562,
                                -5.23208
                            ],
                            [
                                154.57454,
                                -5.35679
                            ],
                            [
                                154.61279,
                                -5.41997
                            ],
                            [
                                154.67081,
                                -5.42972
                            ],
                            [
                                154.70738,
                                -5.18563
                            ],
                            [
                                154.66556,
                                -5.13914
                            ],
                            [
                                154.67445,
                                -5.09067
                            ],
                            [
                                154.6464,
                                -5.024
                            ],
                            [
                                154.60724,
                                -5.01014
                            ],
                            [
                                154.51344,
                                -5.12856
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                146.98911,
                                -5.27885
                            ],
                            [
                                146.99924,
                                -5.3596
                            ],
                            [
                                147.11671,
                                -5.43713
                            ],
                            [
                                147.20265,
                                -5.38225
                            ],
                            [
                                147.17556,
                                -5.28419
                            ],
                            [
                                147.08755,
                                -5.20686
                            ],
                            [
                                146.98911,
                                -5.27885
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                145.88019,
                                -4.66094
                            ],
                            [
                                145.88927,
                                -4.73001
                            ],
                            [
                                145.92963,
                                -4.75517
                            ],
                            [
                                146.04195,
                                -4.72199
                            ],
                            [
                                146.06889,
                                -4.64631
                            ],
                            [
                                146.0621,
                                -4.58024
                            ],
                            [
                                145.99286,
                                -4.51913
                            ],
                            [
                                145.89796,
                                -4.58824
                            ],
                            [
                                145.88019,
                                -4.66094
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                149.50256,
                                -1.42579
                            ],
                            [
                                149.6243,
                                -1.52588
                            ],
                            [
                                149.71488,
                                -1.49615
                            ],
                            [
                                149.67723,
                                -1.39429
                            ],
                            [
                                149.57777,
                                -1.32364
                            ],
                            [
                                149.50256,
                                -1.42579
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                143.18651,
                                -8.42525
                            ],
                            [
                                143.22708,
                                -8.46264
                            ],
                            [
                                143.35655,
                                -8.52621
                            ],
                            [
                                143.39487,
                                -8.57382
                            ],
                            [
                                143.58105,
                                -8.66278
                            ],
                            [
                                143.64504,
                                -8.65936
                            ],
                            [
                                143.48541,
                                -8.53347
                            ],
                            [
                                143.3876,
                                -8.48369
                            ],
                            [
                                143.27202,
                                -8.46162
                            ],
                            [
                                143.22273,
                                -8.40941
                            ],
                            [
                                143.18651,
                                -8.42525
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                153.97004,
                                -11.37269
                            ],
                            [
                                154.02324,
                                -11.41655
                            ],
                            [
                                154.0858,
                                -11.42609
                            ],
                            [
                                154.19359,
                                -11.39442
                            ],
                            [
                                154.24671,
                                -11.41984
                            ],
                            [
                                154.28165,
                                -11.3803
                            ],
                            [
                                154.24906,
                                -11.32165
                            ],
                            [
                                154.11507,
                                -11.29762
                            ],
                            [
                                154.11937,
                                -11.35048
                            ],
                            [
                                153.97004,
                                -11.37269
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                143.31884,
                                -8.37398
                            ],
                            [
                                143.40616,
                                -8.42861
                            ],
                            [
                                143.52803,
                                -8.48231
                            ],
                            [
                                143.59329,
                                -8.48227
                            ],
                            [
                                143.61315,
                                -8.41106
                            ],
                            [
                                143.56002,
                                -8.36153
                            ],
                            [
                                143.31884,
                                -8.37398
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                150.99406,
                                -8.53369
                            ],
                            [
                                151.08996,
                                -8.55366
                            ],
                            [
                                151.13405,
                                -8.59557
                            ],
                            [
                                151.09678,
                                -8.67096
                            ],
                            [
                                151.04316,
                                -8.72994
                            ],
                            [
                                151.09588,
                                -8.7689
                            ],
                            [
                                151.1214,
                                -8.63897
                            ],
                            [
                                151.14637,
                                -8.60451
                            ],
                            [
                                151.13135,
                                -8.42808
                            ],
                            [
                                151.08087,
                                -8.41139
                            ],
                            [
                                151.03712,
                                -8.43904
                            ],
                            [
                                150.99406,
                                -8.53369
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                152.7077,
                                -10.64998
                            ],
                            [
                                152.67208,
                                -10.66151
                            ],
                            [
                                152.54036,
                                -10.61588
                            ],
                            [
                                152.54894,
                                -10.65651
                            ],
                            [
                                152.74552,
                                -10.72262
                            ],
                            [
                                152.87715,
                                -10.67492
                            ],
                            [
                                152.78905,
                                -10.61446
                            ],
                            [
                                152.7077,
                                -10.64998
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                152.63367,
                                -3.1154
                            ],
                            [
                                152.63355,
                                -3.0398
                            ],
                            [
                                152.56584,
                                -3.0441
                            ],
                            [
                                152.52571,
                                -3.11019
                            ],
                            [
                                152.62093,
                                -3.22562
                            ],
                            [
                                152.64509,
                                -3.20732
                            ],
                            [
                                152.63367,
                                -3.1154
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                151.90502,
                                -2.80259
                            ],
                            [
                                151.92891,
                                -2.84835
                            ],
                            [
                                151.99364,
                                -2.83598
                            ],
                            [
                                152.00773,
                                -2.77976
                            ],
                            [
                                151.95076,
                                -2.7133
                            ],
                            [
                                151.90502,
                                -2.80259
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                151.94382,
                                -2.88702
                            ],
                            [
                                151.98352,
                                -2.90573
                            ],
                            [
                                152.00128,
                                -2.96812
                            ],
                            [
                                152.04125,
                                -3.00219
                            ],
                            [
                                152.07335,
                                -2.93251
                            ],
                            [
                                151.94382,
                                -2.88702
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                150.90136,
                                -10.6292
                            ],
                            [
                                151.04079,
                                -10.64339
                            ],
                            [
                                151.02582,
                                -10.58195
                            ],
                            [
                                150.95863,
                                -10.59219
                            ],
                            [
                                150.90136,
                                -10.6292
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                147.70404,
                                -2.37055
                            ],
                            [
                                147.72829,
                                -2.34639
                            ],
                            [
                                147.81413,
                                -2.35072
                            ],
                            [
                                147.8775,
                                -2.2996
                            ],
                            [
                                147.81816,
                                -2.24165
                            ],
                            [
                                147.76903,
                                -2.32796
                            ],
                            [
                                147.7356,
                                -2.31877
                            ],
                            [
                                147.70404,
                                -2.37055
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                150.75869,
                                -10.62204
                            ],
                            [
                                150.87927,
                                -10.65381
                            ],
                            [
                                150.88059,
                                -10.54159
                            ],
                            [
                                150.83633,
                                -10.5526
                            ],
                            [
                                150.82881,
                                -10.60844
                            ],
                            [
                                150.75869,
                                -10.62204
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                143.54477,
                                -8.02953
                            ],
                            [
                                143.57285,
                                -8.07966
                            ],
                            [
                                143.70592,
                                -8.08033
                            ],
                            [
                                143.59584,
                                -8.01207
                            ],
                            [
                                143.54477,
                                -8.02953
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                143.53377,
                                -8.34308
                            ],
                            [
                                143.5777,
                                -8.36077
                            ],
                            [
                                143.64835,
                                -8.42637
                            ],
                            [
                                143.66672,
                                -8.3609
                            ],
                            [
                                143.61748,
                                -8.33369
                            ],
                            [
                                143.53377,
                                -8.34308
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                153.5641,
                                -4.09883
                            ],
                            [
                                153.63391,
                                -4.13812
                            ],
                            [
                                153.65794,
                                -4.10273
                            ],
                            [
                                153.61198,
                                -4.03403
                            ],
                            [
                                153.5641,
                                -4.09883
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                144.98533,
                                -4.07017
                            ],
                            [
                                144.99492,
                                -4.11314
                            ],
                            [
                                145.07694,
                                -4.1006
                            ],
                            [
                                145.05005,
                                -4.03403
                            ],
                            [
                                144.98533,
                                -4.07017
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                143.58125,
                                -8.10503
                            ],
                            [
                                143.6527,
                                -8.17522
                            ],
                            [
                                143.69866,
                                -8.13645
                            ],
                            [
                                143.65387,
                                -8.09552
                            ],
                            [
                                143.58125,
                                -8.10503
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                153.07521,
                                -11.19661
                            ],
                            [
                                153.18177,
                                -11.26855
                            ],
                            [
                                153.20177,
                                -11.23136
                            ],
                            [
                                153.11384,
                                -11.1802
                            ],
                            [
                                153.07521,
                                -11.19661
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                143.85084,
                                -7.71607
                            ],
                            [
                                143.90098,
                                -7.78968
                            ],
                            [
                                143.94155,
                                -7.75439
                            ],
                            [
                                143.85084,
                                -7.71607
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                151.11154,
                                -4.92479
                            ],
                            [
                                151.16449,
                                -4.96262
                            ],
                            [
                                151.23051,
                                -4.92419
                            ],
                            [
                                151.18004,
                                -4.88829
                            ],
                            [
                                151.11154,
                                -4.92479
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                143.61839,
                                -8.23592
                            ],
                            [
                                143.71243,
                                -8.22757
                            ],
                            [
                                143.72024,
                                -8.1876
                            ],
                            [
                                143.62059,
                                -8.18186
                            ],
                            [
                                143.61839,
                                -8.23592
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                149.43069,
                                -4.6926
                            ],
                            [
                                149.5466,
                                -4.69668
                            ],
                            [
                                149.49203,
                                -4.64113
                            ],
                            [
                                149.43069,
                                -4.6926
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                152.4083,
                                -4.16794
                            ],
                            [
                                152.45082,
                                -4.2167
                            ],
                            [
                                152.49099,
                                -4.18469
                            ],
                            [
                                152.45923,
                                -4.13103
                            ],
                            [
                                152.4083,
                                -4.16794
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "PRY",
                "Country": "Paraguay",
                "Total_3GHG": 0.2,
                "Total_3GHG_timeseries": [
                    1.654e-06,
                    3.2506e-06,
                    4.8052e-06,
                    6.3259e-06,
                    7.8203e-06,
                    9.282e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033
                ],
                "Fossil_3GHG": 0.02,
                "Fossil_3GHG_timeseries": [
                    7.9053e-08,
                    1.5624e-07,
                    2.3158e-07,
                    3.0509e-07,
                    3.7677e-07,
                    4.4644e-07,
                    5.1412e-07,
                    5.7981e-07,
                    6.4351e-07,
                    7.0523e-07,
                    7.6439e-07,
                    8.21e-07,
                    8.7508e-07,
                    9.2665e-07,
                    9.7572e-07,
                    1.0223e-06,
                    1.0662e-06,
                    1.1074e-06,
                    1.146e-06,
                    1.1819e-06,
                    1.2173e-06,
                    1.2524e-06,
                    1.2871e-06,
                    1.3216e-06,
                    1.3559e-06,
                    1.3901e-06,
                    1.4243e-06,
                    1.4583e-06,
                    1.4923e-06,
                    1.526e-06,
                    1.5602e-06,
                    1.5948e-06,
                    1.6297e-06,
                    1.6651e-06,
                    1.7009e-06,
                    1.7372e-06,
                    1.7742e-06,
                    1.8119e-06,
                    1.8503e-06,
                    1.8897e-06,
                    1.9303e-06,
                    1.9722e-06,
                    2.0153e-06,
                    2.0596e-06,
                    2.1052e-06,
                    2.1521e-06,
                    2.2003e-06,
                    2.2498e-06,
                    2.3007e-06,
                    2.3529e-06,
                    2.4116e-06,
                    2.477e-06,
                    2.5492e-06,
                    2.6283e-06,
                    2.7143e-06,
                    2.8072e-06,
                    2.9072e-06,
                    3.0146e-06,
                    3.1295e-06,
                    3.2519e-06,
                    3.3822e-06,
                    3.5206e-06,
                    3.6676e-06,
                    3.8232e-06,
                    3.9875e-06,
                    4.161e-06,
                    4.344e-06,
                    4.5365e-06,
                    4.7388e-06,
                    4.9511e-06,
                    5.1693e-06,
                    5.3936e-06,
                    5.624e-06,
                    5.8608e-06,
                    6.1042e-06,
                    6.354e-06,
                    6.6103e-06,
                    6.8731e-06,
                    7.1423e-06,
                    7.4184e-06,
                    7.7021e-06,
                    7.9933e-06,
                    8.2922e-06,
                    8.5988e-06,
                    8.9132e-06,
                    9.2355e-06,
                    9.5661e-06,
                    9.9057e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_3GHG": 0.54,
                "Land_3GHG_timeseries": [
                    1.5749e-06,
                    3.0943e-06,
                    4.5737e-06,
                    6.0208e-06,
                    7.4436e-06,
                    8.8356e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031
                ],
                "Total_CO2": 0.18,
                "Total_CO2_timeseries": [
                    7.5903e-07,
                    1.4829e-06,
                    2.1873e-06,
                    2.8799e-06,
                    3.5686e-06,
                    4.2471e-06,
                    4.9176e-06,
                    5.5857e-06,
                    6.2523e-06,
                    6.8879e-06,
                    7.5011e-06,
                    8.1051e-06,
                    8.7003e-06,
                    9.2904e-06,
                    9.8824e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021
                ],
                "Fossil_CO2": 0.01,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2.805e-08,
                    4.95e-08,
                    9.5686e-08,
                    1.5014e-07,
                    2.3262e-07,
                    3.184e-07,
                    4.0747e-07,
                    5.0314e-07,
                    6.1203e-07,
                    7.4895e-07,
                    8.8588e-07,
                    1.0492e-06,
                    1.2257e-06,
                    1.4105e-06,
                    1.6052e-06,
                    1.8526e-06,
                    2.0835e-06,
                    2.303e-06,
                    2.5686e-06,
                    2.8028e-06,
                    3.1376e-06,
                    3.4229e-06,
                    3.7443e-06,
                    4.1349e-06,
                    4.5632e-06,
                    4.9399e-06,
                    5.4037e-06,
                    5.923e-06,
                    6.5776e-06,
                    7.1745e-06,
                    7.8434e-06,
                    8.4663e-06,
                    9.0798e-06,
                    9.7139e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CO2": 0.56,
                "Land_CO2_timeseries": [
                    7.5903e-07,
                    1.4829e-06,
                    2.1873e-06,
                    2.8799e-06,
                    3.5686e-06,
                    4.2471e-06,
                    4.9176e-06,
                    5.5857e-06,
                    6.2523e-06,
                    6.8879e-06,
                    7.5011e-06,
                    8.1051e-06,
                    8.7003e-06,
                    9.2904e-06,
                    9.8824e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002
                ],
                "Total_CH4": 0.25,
                "Total_CH4_timeseries": [
                    8.7547e-07,
                    1.7283e-06,
                    2.5584e-06,
                    3.3658e-06,
                    4.1506e-06,
                    4.9126e-06,
                    5.6518e-06,
                    6.3682e-06,
                    7.0618e-06,
                    7.7326e-06,
                    8.3724e-06,
                    8.9812e-06,
                    9.559e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001
                ],
                "Fossil_CH4": 0.05,
                "Fossil_CH4_timeseries": [
                    7.665e-08,
                    1.514e-07,
                    2.2426e-07,
                    2.9524e-07,
                    3.6437e-07,
                    4.3146e-07,
                    4.9653e-07,
                    5.5959e-07,
                    6.2063e-07,
                    6.7968e-07,
                    7.3616e-07,
                    7.9008e-07,
                    8.4147e-07,
                    8.9033e-07,
                    9.3668e-07,
                    9.8056e-07,
                    1.0217e-06,
                    1.0602e-06,
                    1.096e-06,
                    1.1291e-06,
                    1.1617e-06,
                    1.1939e-06,
                    1.2256e-06,
                    1.257e-06,
                    1.288e-06,
                    1.3187e-06,
                    1.3492e-06,
                    1.3795e-06,
                    1.4096e-06,
                    1.4394e-06,
                    1.4696e-06,
                    1.5001e-06,
                    1.5311e-06,
                    1.5623e-06,
                    1.5941e-06,
                    1.6262e-06,
                    1.659e-06,
                    1.6926e-06,
                    1.7268e-06,
                    1.7617e-06,
                    1.7978e-06,
                    1.8351e-06,
                    1.8736e-06,
                    1.9132e-06,
                    1.954e-06,
                    1.9959e-06,
                    2.0391e-06,
                    2.0835e-06,
                    2.1291e-06,
                    2.176e-06,
                    2.2292e-06,
                    2.289e-06,
                    2.3554e-06,
                    2.4286e-06,
                    2.5084e-06,
                    2.595e-06,
                    2.6886e-06,
                    2.7893e-06,
                    2.8975e-06,
                    3.0128e-06,
                    3.136e-06,
                    3.2673e-06,
                    3.4069e-06,
                    3.5549e-06,
                    3.7115e-06,
                    3.8773e-06,
                    4.0523e-06,
                    4.2366e-06,
                    4.4307e-06,
                    4.6346e-06,
                    4.8443e-06,
                    5.0599e-06,
                    5.2815e-06,
                    5.5094e-06,
                    5.7437e-06,
                    5.9842e-06,
                    6.2312e-06,
                    6.4845e-06,
                    6.744e-06,
                    7.0103e-06,
                    7.284e-06,
                    7.5651e-06,
                    7.8537e-06,
                    8.1499e-06,
                    8.4536e-06,
                    8.7651e-06,
                    9.0847e-06,
                    9.4131e-06,
                    9.7498e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CH4": 0.58,
                "Land_CH4_timeseries": [
                    7.9882e-07,
                    1.5769e-06,
                    2.3341e-06,
                    3.0706e-06,
                    3.7863e-06,
                    4.4812e-06,
                    5.1553e-06,
                    5.8086e-06,
                    6.4412e-06,
                    7.053e-06,
                    7.6363e-06,
                    8.1911e-06,
                    8.7175e-06,
                    9.2154e-06,
                    9.6848e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009
                ],
                "Total_N2O": 0.22,
                "Total_N2O_timeseries": [
                    1.9499e-08,
                    3.938e-08,
                    5.9627e-08,
                    8.0217e-08,
                    1.0112e-07,
                    1.2231e-07,
                    1.4373e-07,
                    1.6535e-07,
                    1.8711e-07,
                    2.0895e-07,
                    2.3083e-07,
                    2.5275e-07,
                    2.747e-07,
                    2.9667e-07,
                    3.1865e-07,
                    3.4066e-07,
                    3.627e-07,
                    3.8476e-07,
                    4.0686e-07,
                    4.29e-07,
                    4.5151e-07,
                    4.7493e-07,
                    4.9966e-07,
                    5.2601e-07,
                    5.5413e-07,
                    5.8407e-07,
                    6.1573e-07,
                    6.4892e-07,
                    6.8329e-07,
                    7.1838e-07,
                    7.5389e-07,
                    7.8974e-07,
                    8.2588e-07,
                    8.6228e-07,
                    8.9891e-07,
                    9.3575e-07,
                    9.7281e-07,
                    1.0101e-06,
                    1.0476e-06,
                    1.1023e-06,
                    1.1578e-06,
                    1.2149e-06,
                    1.2743e-06,
                    1.3366e-06,
                    1.4025e-06,
                    1.4724e-06,
                    1.5468e-06,
                    1.6258e-06,
                    1.7099e-06,
                    1.7992e-06,
                    1.8956e-06,
                    2.0025e-06,
                    2.1222e-06,
                    2.2564e-06,
                    2.4057e-06,
                    2.5699e-06,
                    2.7478e-06,
                    2.9374e-06,
                    3.1359e-06,
                    3.3396e-06,
                    3.5461e-06,
                    3.7553e-06,
                    3.9671e-06,
                    4.1811e-06,
                    4.3973e-06,
                    4.6152e-06,
                    4.8347e-06,
                    5.0555e-06,
                    5.2773e-06,
                    5.4996e-06,
                    5.7218e-06,
                    5.9427e-06,
                    6.1616e-06,
                    6.3779e-06,
                    6.5914e-06,
                    6.802e-06,
                    7.0101e-06,
                    7.216e-06,
                    7.4206e-06,
                    7.625e-06,
                    7.8308e-06,
                    8.0401e-06,
                    8.2546e-06,
                    8.4756e-06,
                    8.7043e-06,
                    8.9414e-06,
                    9.1873e-06,
                    9.442e-06,
                    9.7054e-06,
                    9.9769e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_N2O": 0.04,
                "Fossil_N2O_timeseries": [
                    2.403e-09,
                    4.8458e-09,
                    7.327e-09,
                    9.8447e-09,
                    1.2397e-08,
                    1.498e-08,
                    1.7591e-08,
                    2.0225e-08,
                    2.2879e-08,
                    2.5548e-08,
                    2.8227e-08,
                    3.0917e-08,
                    3.3616e-08,
                    3.6325e-08,
                    3.9043e-08,
                    4.177e-08,
                    4.4507e-08,
                    4.7253e-08,
                    5.001e-08,
                    5.2779e-08,
                    5.5585e-08,
                    5.8476e-08,
                    6.1486e-08,
                    6.4641e-08,
                    6.7953e-08,
                    7.1427e-08,
                    7.5055e-08,
                    7.8819e-08,
                    8.2691e-08,
                    8.6632e-08,
                    9.0615e-08,
                    9.4635e-08,
                    9.8687e-08,
                    1.0277e-07,
                    1.0688e-07,
                    1.1101e-07,
                    1.1517e-07,
                    1.1936e-07,
                    1.2357e-07,
                    1.2798e-07,
                    1.3247e-07,
                    1.3703e-07,
                    1.4167e-07,
                    1.4641e-07,
                    1.5123e-07,
                    1.5616e-07,
                    1.6118e-07,
                    1.6632e-07,
                    1.7156e-07,
                    1.7692e-07,
                    1.824e-07,
                    1.8803e-07,
                    1.9381e-07,
                    1.9976e-07,
                    2.0588e-07,
                    2.1217e-07,
                    2.1863e-07,
                    2.2526e-07,
                    2.3206e-07,
                    2.3902e-07,
                    2.4612e-07,
                    2.5337e-07,
                    2.6077e-07,
                    2.683e-07,
                    2.7598e-07,
                    2.8379e-07,
                    2.9175e-07,
                    2.9985e-07,
                    3.0808e-07,
                    3.1646e-07,
                    3.2499e-07,
                    3.3365e-07,
                    3.4246e-07,
                    3.514e-07,
                    3.6049e-07,
                    3.6972e-07,
                    3.791e-07,
                    3.8862e-07,
                    3.9829e-07,
                    4.0812e-07,
                    4.181e-07,
                    4.2824e-07,
                    4.3853e-07,
                    4.4899e-07,
                    4.5961e-07,
                    4.7041e-07,
                    4.814e-07,
                    4.9258e-07,
                    5.0399e-07,
                    5.1562e-07,
                    5.2758e-07,
                    5.3997e-07,
                    5.529e-07,
                    5.6646e-07,
                    5.807e-07,
                    5.9567e-07,
                    6.1136e-07,
                    6.2778e-07,
                    6.4489e-07,
                    6.6263e-07,
                    6.8106e-07,
                    7.0034e-07,
                    7.206e-07,
                    7.4194e-07,
                    7.6445e-07,
                    7.8817e-07,
                    8.1312e-07,
                    8.3931e-07,
                    8.6669e-07,
                    8.9521e-07,
                    9.2476e-07,
                    9.5525e-07,
                    9.8665e-07,
                    1.019e-06,
                    1.0523e-06,
                    1.0867e-06,
                    1.1225e-06,
                    1.1598e-06,
                    1.1989e-06,
                    1.2527e-06,
                    1.3067e-06,
                    1.3617e-06,
                    1.4197e-06,
                    1.479e-06,
                    1.5364e-06,
                    1.5978e-06,
                    1.6639e-06,
                    1.7361e-06,
                    1.8096e-06,
                    1.8886e-06,
                    1.969e-06,
                    2.0567e-06,
                    2.1606e-06,
                    2.279e-06,
                    2.3761e-06,
                    2.4926e-06,
                    2.6217e-06,
                    2.7758e-06,
                    2.8978e-06,
                    3.0199e-06,
                    3.1472e-06,
                    3.2772e-06,
                    3.4125e-06,
                    3.5557e-06,
                    3.712e-06,
                    3.8733e-06,
                    4.0451e-06,
                    4.2163e-06,
                    4.3801e-06,
                    4.5269e-06,
                    4.6766e-06,
                    4.8257e-06,
                    4.9783e-06,
                    5.1294e-06,
                    5.2761e-06,
                    5.4316e-06,
                    5.5937e-06,
                    5.7616e-06,
                    5.9224e-06,
                    6.0904e-06,
                    6.2587e-06,
                    6.4255e-06,
                    6.5917e-06,
                    6.7636e-06,
                    6.9391e-06,
                    7.1504e-06,
                    7.3725e-06,
                    7.5966e-06,
                    7.8136e-06,
                    8.0288e-06,
                    8.2606e-06,
                    8.4794e-06
                ],
                "Land_N2O": 0.28,
                "Land_N2O_timeseries": [
                    1.7096e-08,
                    3.4534e-08,
                    5.23e-08,
                    7.0372e-08,
                    8.8725e-08,
                    1.0733e-07,
                    1.2614e-07,
                    1.4513e-07,
                    1.6423e-07,
                    1.834e-07,
                    2.0261e-07,
                    2.2183e-07,
                    2.4108e-07,
                    2.6034e-07,
                    2.7961e-07,
                    2.9889e-07,
                    3.1819e-07,
                    3.3751e-07,
                    3.5685e-07,
                    3.7623e-07,
                    3.9593e-07,
                    4.1645e-07,
                    4.3818e-07,
                    4.6137e-07,
                    4.8618e-07,
                    5.1264e-07,
                    5.4068e-07,
                    5.701e-07,
                    6.006e-07,
                    6.3175e-07,
                    6.6327e-07,
                    6.951e-07,
                    7.272e-07,
                    7.5951e-07,
                    7.9203e-07,
                    8.2474e-07,
                    8.5764e-07,
                    8.9074e-07,
                    9.2406e-07,
                    9.7435e-07,
                    1.0253e-06,
                    1.0778e-06,
                    1.1326e-06,
                    1.1902e-06,
                    1.2513e-06,
                    1.3163e-06,
                    1.3856e-06,
                    1.4595e-06,
                    1.5384e-06,
                    1.6223e-06,
                    1.7132e-06,
                    1.8144e-06,
                    1.9284e-06,
                    2.0567e-06,
                    2.1998e-06,
                    2.3577e-06,
                    2.5291e-06,
                    2.7121e-06,
                    2.9039e-06,
                    3.1006e-06,
                    3.3e-06,
                    3.502e-06,
                    3.7063e-06,
                    3.9128e-06,
                    4.1213e-06,
                    4.3314e-06,
                    4.543e-06,
                    4.7557e-06,
                    4.9692e-06,
                    5.1831e-06,
                    5.3968e-06,
                    5.609e-06,
                    5.8191e-06,
                    6.0265e-06,
                    6.2309e-06,
                    6.4323e-06,
                    6.631e-06,
                    6.8274e-06,
                    7.0223e-06,
                    7.2169e-06,
                    7.4127e-06,
                    7.6119e-06,
                    7.8161e-06,
                    8.0267e-06,
                    8.2447e-06,
                    8.471e-06,
                    8.7059e-06,
                    8.9494e-06,
                    9.2014e-06,
                    9.4612e-06,
                    9.7379e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -54.5941,
                            -25.59227
                        ],
                        [
                            -54.61608,
                            -25.45846
                        ],
                        [
                            -54.49736,
                            -25.28152
                        ],
                        [
                            -54.43739,
                            -25.15864
                        ],
                        [
                            -54.45801,
                            -25.03268
                        ],
                        [
                            -54.40513,
                            -24.83594
                        ],
                        [
                            -54.33135,
                            -24.61738
                        ],
                        [
                            -54.33348,
                            -24.49452
                        ],
                        [
                            -54.26037,
                            -24.36521
                        ],
                        [
                            -54.27871,
                            -24.28977
                        ],
                        [
                            -54.32403,
                            -24.24509
                        ],
                        [
                            -54.33119,
                            -24.15088
                        ],
                        [
                            -54.28542,
                            -24.08669
                        ],
                        [
                            -54.31708,
                            -24.01452
                        ],
                        [
                            -54.36794,
                            -23.99967
                        ],
                        [
                            -54.39961,
                            -23.94108
                        ],
                        [
                            -54.48318,
                            -23.88527
                        ],
                        [
                            -54.67804,
                            -23.81813
                        ],
                        [
                            -54.7028,
                            -23.86128
                        ],
                        [
                            -54.76132,
                            -23.8578
                        ],
                        [
                            -54.92187,
                            -23.92496
                        ],
                        [
                            -54.93406,
                            -23.96436
                        ],
                        [
                            -55.00519,
                            -23.9585
                        ],
                        [
                            -55.05342,
                            -23.98892
                        ],
                        [
                            -55.11301,
                            -23.964
                        ],
                        [
                            -55.23187,
                            -24.01061
                        ],
                        [
                            -55.31346,
                            -23.95977
                        ],
                        [
                            -55.33419,
                            -23.98903
                        ],
                        [
                            -55.41296,
                            -23.95999
                        ],
                        [
                            -55.44123,
                            -23.91129
                        ],
                        [
                            -55.43207,
                            -23.78049
                        ],
                        [
                            -55.47667,
                            -23.6452
                        ],
                        [
                            -55.53497,
                            -23.61309
                        ],
                        [
                            -55.53605,
                            -23.44456
                        ],
                        [
                            -55.50223,
                            -23.38021
                        ],
                        [
                            -55.54806,
                            -23.31857
                        ],
                        [
                            -55.52115,
                            -23.26267
                        ],
                        [
                            -55.5452,
                            -23.1596
                        ],
                        [
                            -55.59508,
                            -23.14287
                        ],
                        [
                            -55.64278,
                            -23.02216
                        ],
                        [
                            -55.62536,
                            -22.98202
                        ],
                        [
                            -55.66667,
                            -22.86249
                        ],
                        [
                            -55.61489,
                            -22.72089
                        ],
                        [
                            -55.6299,
                            -22.61879
                        ],
                        [
                            -55.7239,
                            -22.54803
                        ],
                        [
                            -55.74581,
                            -22.48394
                        ],
                        [
                            -55.74123,
                            -22.39457
                        ],
                        [
                            -55.78863,
                            -22.38287
                        ],
                        [
                            -55.85913,
                            -22.27994
                        ],
                        [
                            -56.06111,
                            -22.29291
                        ],
                        [
                            -56.20754,
                            -22.28088
                        ],
                        [
                            -56.24972,
                            -22.2395
                        ],
                        [
                            -56.34072,
                            -22.20616
                        ],
                        [
                            -56.40499,
                            -22.07783
                        ],
                        [
                            -56.51746,
                            -22.10227
                        ],
                        [
                            -56.56657,
                            -22.19262
                        ],
                        [
                            -56.61811,
                            -22.23462
                        ],
                        [
                            -56.72042,
                            -22.25604
                        ],
                        [
                            -56.74823,
                            -22.23926
                        ],
                        [
                            -56.83846,
                            -22.29962
                        ],
                        [
                            -56.88353,
                            -22.25667
                        ],
                        [
                            -57.00266,
                            -22.22553
                        ],
                        [
                            -57.11019,
                            -22.22375
                        ],
                        [
                            -57.2428,
                            -22.24402
                        ],
                        [
                            -57.31869,
                            -22.23235
                        ],
                        [
                            -57.52099,
                            -22.17389
                        ],
                        [
                            -57.58469,
                            -22.16574
                        ],
                        [
                            -57.61791,
                            -22.09657
                        ],
                        [
                            -57.69945,
                            -22.09264
                        ],
                        [
                            -57.80359,
                            -22.14618
                        ],
                        [
                            -57.92473,
                            -22.12041
                        ],
                        [
                            -57.98792,
                            -22.08379
                        ],
                        [
                            -57.9234,
                            -21.87434
                        ],
                        [
                            -57.94366,
                            -21.75169
                        ],
                        [
                            -57.89935,
                            -21.70433
                        ],
                        [
                            -57.92904,
                            -21.65581
                        ],
                        [
                            -57.92554,
                            -21.57865
                        ],
                        [
                            -57.96217,
                            -21.51165
                        ],
                        [
                            -57.85531,
                            -21.33826
                        ],
                        [
                            -57.91702,
                            -21.27925
                        ],
                        [
                            -57.86477,
                            -21.24092
                        ],
                        [
                            -57.84786,
                            -21.09948
                        ],
                        [
                            -57.86617,
                            -21.04636
                        ],
                        [
                            -57.82028,
                            -20.98483
                        ],
                        [
                            -57.91817,
                            -20.88238
                        ],
                        [
                            -57.86019,
                            -20.84997
                        ],
                        [
                            -57.87536,
                            -20.74366
                        ],
                        [
                            -57.92072,
                            -20.66782
                        ],
                        [
                            -58.0141,
                            -20.60911
                        ],
                        [
                            -58.01807,
                            -20.51257
                        ],
                        [
                            -57.99619,
                            -20.44415
                        ],
                        [
                            -58.07962,
                            -20.37548
                        ],
                        [
                            -58.08826,
                            -20.26646
                        ],
                        [
                            -58.16346,
                            -20.16246
                        ],
                        [
                            -58.1381,
                            -20.11786
                        ],
                        [
                            -58.194,
                            -19.96315
                        ],
                        [
                            -58.20134,
                            -19.86431
                        ],
                        [
                            -58.16373,
                            -19.82634
                        ],
                        [
                            -58.23579,
                            -19.77232
                        ],
                        [
                            -59.06623,
                            -19.28776
                        ],
                        [
                            -59.9767,
                            -19.29231
                        ],
                        [
                            -60.604,
                            -19.45724
                        ],
                        [
                            -61.45804,
                            -19.59828
                        ],
                        [
                            -61.73015,
                            -19.64319
                        ],
                        [
                            -61.92173,
                            -20.0869
                        ],
                        [
                            -62.26587,
                            -20.56136
                        ],
                        [
                            -62.26134,
                            -21.05557
                        ],
                        [
                            -62.50488,
                            -21.81403
                        ],
                        [
                            -62.6452,
                            -22.25047
                        ],
                        [
                            -62.53612,
                            -22.36783
                        ],
                        [
                            -62.47548,
                            -22.37685
                        ],
                        [
                            -62.38323,
                            -22.45901
                        ],
                        [
                            -62.35311,
                            -22.45621
                        ],
                        [
                            -62.2275,
                            -22.55177
                        ],
                        [
                            -62.25896,
                            -22.59425
                        ],
                        [
                            -62.20064,
                            -22.66492
                        ],
                        [
                            -62.19822,
                            -22.71328
                        ],
                        [
                            -62.04771,
                            -22.87209
                        ],
                        [
                            -61.9886,
                            -23.02152
                        ],
                        [
                            -61.86785,
                            -23.09103
                        ],
                        [
                            -61.77632,
                            -23.16954
                        ],
                        [
                            -61.73616,
                            -23.23882
                        ],
                        [
                            -61.67086,
                            -23.28388
                        ],
                        [
                            -61.58164,
                            -23.3061
                        ],
                        [
                            -61.49114,
                            -23.41938
                        ],
                        [
                            -61.39708,
                            -23.4602
                        ],
                        [
                            -61.35943,
                            -23.45173
                        ],
                        [
                            -61.23822,
                            -23.54824
                        ],
                        [
                            -61.17336,
                            -23.5527
                        ],
                        [
                            -61.09765,
                            -23.61558
                        ],
                        [
                            -61.09793,
                            -23.65925
                        ],
                        [
                            -61.00638,
                            -23.78824
                        ],
                        [
                            -60.93005,
                            -23.80697
                        ],
                        [
                            -60.8369,
                            -23.87059
                        ],
                        [
                            -60.76505,
                            -23.87235
                        ],
                        [
                            -60.66274,
                            -23.90536
                        ],
                        [
                            -60.60313,
                            -23.90437
                        ],
                        [
                            -60.56745,
                            -23.9554
                        ],
                        [
                            -60.45327,
                            -23.96513
                        ],
                        [
                            -60.37365,
                            -24.02532
                        ],
                        [
                            -60.2985,
                            -24.04816
                        ],
                        [
                            -60.1221,
                            -24.03959
                        ],
                        [
                            -60.02568,
                            -24.00746
                        ],
                        [
                            -59.47575,
                            -24.33226
                        ],
                        [
                            -59.34616,
                            -24.485
                        ],
                        [
                            -59.18753,
                            -24.56406
                        ],
                        [
                            -59.12407,
                            -24.61815
                        ],
                        [
                            -58.97421,
                            -24.66288
                        ],
                        [
                            -58.80622,
                            -24.77123
                        ],
                        [
                            -58.72607,
                            -24.77719
                        ],
                        [
                            -58.67133,
                            -24.83031
                        ],
                        [
                            -58.57232,
                            -24.82191
                        ],
                        [
                            -58.44335,
                            -24.88043
                        ],
                        [
                            -58.39055,
                            -24.95254
                        ],
                        [
                            -58.31146,
                            -24.98634
                        ],
                        [
                            -58.25522,
                            -24.93382
                        ],
                        [
                            -58.15258,
                            -24.97461
                        ],
                        [
                            -58.07015,
                            -25.04237
                        ],
                        [
                            -57.99842,
                            -25.07164
                        ],
                        [
                            -57.86172,
                            -25.08372
                        ],
                        [
                            -57.83676,
                            -25.1286
                        ],
                        [
                            -57.75552,
                            -25.17719
                        ],
                        [
                            -57.75584,
                            -25.2149
                        ],
                        [
                            -57.69212,
                            -25.28306
                        ],
                        [
                            -57.64298,
                            -25.37998
                        ],
                        [
                            -57.556,
                            -25.44637
                        ],
                        [
                            -57.61291,
                            -25.61175
                        ],
                        [
                            -57.7477,
                            -25.65759
                        ],
                        [
                            -57.73297,
                            -25.72352
                        ],
                        [
                            -57.81847,
                            -25.78248
                        ],
                        [
                            -57.83828,
                            -25.90335
                        ],
                        [
                            -57.89427,
                            -25.95667
                        ],
                        [
                            -57.85257,
                            -26.00492
                        ],
                        [
                            -58.12073,
                            -26.15909
                        ],
                        [
                            -58.11164,
                            -26.24207
                        ],
                        [
                            -58.15928,
                            -26.26085
                        ],
                        [
                            -58.17353,
                            -26.36289
                        ],
                        [
                            -58.21233,
                            -26.37965
                        ],
                        [
                            -58.22063,
                            -26.54549
                        ],
                        [
                            -58.19341,
                            -26.59145
                        ],
                        [
                            -58.24601,
                            -26.74232
                        ],
                        [
                            -58.3356,
                            -26.81965
                        ],
                        [
                            -58.38406,
                            -26.89209
                        ],
                        [
                            -58.46076,
                            -26.92915
                        ],
                        [
                            -58.46865,
                            -26.99094
                        ],
                        [
                            -58.55144,
                            -27.03454
                        ],
                        [
                            -58.55499,
                            -27.1086
                        ],
                        [
                            -58.65153,
                            -27.13089
                        ],
                        [
                            -58.6541,
                            -27.19245
                        ],
                        [
                            -58.59441,
                            -27.22503
                        ],
                        [
                            -58.60618,
                            -27.29672
                        ],
                        [
                            -58.41252,
                            -27.27777
                        ],
                        [
                            -58.29835,
                            -27.25373
                        ],
                        [
                            -58.14443,
                            -27.26993
                        ],
                        [
                            -57.89831,
                            -27.27026
                        ],
                        [
                            -57.82872,
                            -27.3192
                        ],
                        [
                            -57.72826,
                            -27.33062
                        ],
                        [
                            -57.5937,
                            -27.38013
                        ],
                        [
                            -57.39396,
                            -27.41671
                        ],
                        [
                            -57.32652,
                            -27.41293
                        ],
                        [
                            -57.23377,
                            -27.46627
                        ],
                        [
                            -57.05521,
                            -27.48216
                        ],
                        [
                            -56.93348,
                            -27.41301
                        ],
                        [
                            -56.88857,
                            -27.41359
                        ],
                        [
                            -56.76169,
                            -27.49472
                        ],
                        [
                            -56.69185,
                            -27.44363
                        ],
                        [
                            -56.59845,
                            -27.43169
                        ],
                        [
                            -56.5398,
                            -27.45868
                        ],
                        [
                            -56.47995,
                            -27.56159
                        ],
                        [
                            -56.37368,
                            -27.57524
                        ],
                        [
                            -56.29751,
                            -27.49276
                        ],
                        [
                            -56.3143,
                            -27.42421
                        ],
                        [
                            -56.26874,
                            -27.38286
                        ],
                        [
                            -56.19853,
                            -27.37626
                        ],
                        [
                            -56.18447,
                            -27.33636
                        ],
                        [
                            -56.08155,
                            -27.30514
                        ],
                        [
                            -55.98541,
                            -27.33797
                        ],
                        [
                            -55.89448,
                            -27.34078
                        ],
                        [
                            -55.85922,
                            -27.39791
                        ],
                        [
                            -55.73572,
                            -27.44275
                        ],
                        [
                            -55.6863,
                            -27.38027
                        ],
                        [
                            -55.60362,
                            -27.34032
                        ],
                        [
                            -55.58561,
                            -27.2324
                        ],
                        [
                            -55.6069,
                            -27.16299
                        ],
                        [
                            -55.54488,
                            -27.10274
                        ],
                        [
                            -55.45489,
                            -27.10251
                        ],
                        [
                            -55.45341,
                            -27.04399
                        ],
                        [
                            -55.37994,
                            -26.96735
                        ],
                        [
                            -55.2413,
                            -26.94174
                        ],
                        [
                            -55.13949,
                            -26.9507
                        ],
                        [
                            -55.14096,
                            -26.86525
                        ],
                        [
                            -55.05289,
                            -26.7974
                        ],
                        [
                            -54.94993,
                            -26.7685
                        ],
                        [
                            -54.94087,
                            -26.68143
                        ],
                        [
                            -54.81291,
                            -26.66731
                        ],
                        [
                            -54.78551,
                            -26.60626
                        ],
                        [
                            -54.78377,
                            -26.5116
                        ],
                        [
                            -54.71871,
                            -26.4613
                        ],
                        [
                            -54.6966,
                            -26.37658
                        ],
                        [
                            -54.64972,
                            -26.31379
                        ],
                        [
                            -54.67682,
                            -26.25942
                        ],
                        [
                            -54.62419,
                            -26.22309
                        ],
                        [
                            -54.6742,
                            -26.14192
                        ],
                        [
                            -54.6503,
                            -26.06605
                        ],
                        [
                            -54.67759,
                            -26.01578
                        ],
                        [
                            -54.62275,
                            -25.98508
                        ],
                        [
                            -54.62257,
                            -25.91502
                        ],
                        [
                            -54.58905,
                            -25.83895
                        ],
                        [
                            -54.65854,
                            -25.68032
                        ],
                        [
                            -54.58206,
                            -25.65676
                        ],
                        [
                            -54.5941,
                            -25.59227
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "PER",
                "Country": "Peru",
                "Total_3GHG": 0.32,
                "Total_3GHG_timeseries": [
                    4.6691e-06,
                    9.6973e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.004,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0048,
                    0.0049,
                    0.005,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0052
                ],
                "Fossil_3GHG": 0.16,
                "Fossil_3GHG_timeseries": [
                    3.0214e-07,
                    6.0941e-07,
                    9.2188e-07,
                    1.2396e-06,
                    1.5626e-06,
                    1.8928e-06,
                    2.2272e-06,
                    2.5658e-06,
                    2.9094e-06,
                    3.258e-06,
                    3.6101e-06,
                    3.9658e-06,
                    4.3252e-06,
                    4.6883e-06,
                    5.0552e-06,
                    5.426e-06,
                    5.8009e-06,
                    6.1801e-06,
                    6.5636e-06,
                    6.9515e-06,
                    7.3463e-06,
                    7.7481e-06,
                    8.157e-06,
                    8.5733e-06,
                    8.997e-06,
                    9.4275e-06,
                    9.8676e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017
                ],
                "Land_3GHG": 0.62,
                "Land_3GHG_timeseries": [
                    4.367e-06,
                    9.0879e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0035,
                    0.0035,
                    0.0036
                ],
                "Total_CO2": 0.3,
                "Total_CO2_timeseries": [
                    3.069e-06,
                    6.4706e-06,
                    9.5121e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034
                ],
                "Fossil_CO2": 0.12,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.65e-09,
                    3.3e-09,
                    6.6e-09,
                    9.9e-09,
                    1.32e-08,
                    1.65e-08,
                    2.145e-08,
                    4.29e-08,
                    7.26e-08,
                    9.405e-08,
                    1.122e-07,
                    1.3035e-07,
                    1.485e-07,
                    1.6665e-07,
                    2.0625e-07,
                    2.7885e-07,
                    3.894e-07,
                    4.9665e-07,
                    5.412e-07,
                    6.369e-07,
                    7.623e-07,
                    9.207e-07,
                    1.1137e-06,
                    1.4735e-06,
                    2.0196e-06,
                    2.6994e-06,
                    3.2983e-06,
                    3.9765e-06,
                    4.6332e-06,
                    5.3411e-06,
                    6.0357e-06,
                    6.8855e-06,
                    7.7698e-06,
                    8.6724e-06,
                    9.5486e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009
                ],
                "Land_CO2": 0.7,
                "Land_CO2_timeseries": [
                    3.069e-06,
                    6.4706e-06,
                    9.5121e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025
                ],
                "Total_CH4": 0.38,
                "Total_CH4_timeseries": [
                    1.5371e-06,
                    3.0998e-06,
                    4.6881e-06,
                    6.302e-06,
                    7.9417e-06,
                    9.609e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016
                ],
                "Fossil_CH4": 0.29,
                "Fossil_CH4_timeseries": [
                    2.6766e-07,
                    5.4003e-07,
                    8.1717e-07,
                    1.0991e-06,
                    1.386e-06,
                    1.6797e-06,
                    1.9772e-06,
                    2.2787e-06,
                    2.5848e-06,
                    2.8956e-06,
                    3.2096e-06,
                    3.5269e-06,
                    3.8477e-06,
                    4.1719e-06,
                    4.4996e-06,
                    4.8309e-06,
                    5.1661e-06,
                    5.5054e-06,
                    5.8486e-06,
                    6.1961e-06,
                    6.5499e-06,
                    6.91e-06,
                    7.2766e-06,
                    7.6495e-06,
                    8.0288e-06,
                    8.4138e-06,
                    8.8075e-06,
                    9.2098e-06,
                    9.6198e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Land_CH4": 0.54,
                "Land_CH4_timeseries": [
                    1.2695e-06,
                    2.5598e-06,
                    3.8709e-06,
                    5.2029e-06,
                    6.5557e-06,
                    7.9293e-06,
                    9.3238e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008
                ],
                "Total_N2O": 0.29,
                "Total_N2O_timeseries": [
                    6.2968e-08,
                    1.2693e-07,
                    1.9185e-07,
                    2.5769e-07,
                    3.2439e-07,
                    3.9189e-07,
                    4.6011e-07,
                    5.2894e-07,
                    5.983e-07,
                    6.6806e-07,
                    7.3815e-07,
                    8.0855e-07,
                    8.7926e-07,
                    9.5025e-07,
                    1.0215e-06,
                    1.0931e-06,
                    1.1649e-06,
                    1.2371e-06,
                    1.3096e-06,
                    1.3824e-06,
                    1.4562e-06,
                    1.5319e-06,
                    1.6106e-06,
                    1.6926e-06,
                    1.7783e-06,
                    1.8679e-06,
                    1.9611e-06,
                    2.0575e-06,
                    2.1565e-06,
                    2.2571e-06,
                    2.3588e-06,
                    2.4614e-06,
                    2.5648e-06,
                    2.669e-06,
                    2.7739e-06,
                    2.8794e-06,
                    2.9856e-06,
                    3.0925e-06,
                    3.2001e-06,
                    3.3372e-06,
                    3.4761e-06,
                    3.6182e-06,
                    3.7646e-06,
                    3.9164e-06,
                    4.0747e-06,
                    4.2403e-06,
                    4.4138e-06,
                    4.5958e-06,
                    4.7868e-06,
                    4.9869e-06,
                    5.1997e-06,
                    5.4306e-06,
                    5.6837e-06,
                    5.9617e-06,
                    6.2656e-06,
                    6.5951e-06,
                    6.9483e-06,
                    7.322e-06,
                    7.7112e-06,
                    8.1097e-06,
                    8.5137e-06,
                    8.9229e-06,
                    9.3371e-06,
                    9.7558e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_N2O": 0.16,
                "Fossil_N2O_timeseries": [
                    3.4481e-08,
                    6.9384e-08,
                    1.047e-07,
                    1.4043e-07,
                    1.7655e-07,
                    2.1305e-07,
                    2.4992e-07,
                    2.8712e-07,
                    3.2464e-07,
                    3.6246e-07,
                    4.0055e-07,
                    4.3891e-07,
                    4.7755e-07,
                    5.1645e-07,
                    5.5562e-07,
                    5.9505e-07,
                    6.3475e-07,
                    6.7472e-07,
                    7.1497e-07,
                    7.5549e-07,
                    7.9643e-07,
                    8.3802e-07,
                    8.8044e-07,
                    9.2382e-07,
                    9.6823e-07,
                    1.0137e-06,
                    1.0601e-06,
                    1.1075e-06,
                    1.1557e-06,
                    1.2044e-06,
                    1.2536e-06,
                    1.3031e-06,
                    1.3531e-06,
                    1.4034e-06,
                    1.4541e-06,
                    1.5051e-06,
                    1.5565e-06,
                    1.6083e-06,
                    1.6604e-06,
                    1.7137e-06,
                    1.7676e-06,
                    1.8222e-06,
                    1.8774e-06,
                    1.9332e-06,
                    1.9898e-06,
                    2.047e-06,
                    2.1051e-06,
                    2.1638e-06,
                    2.2234e-06,
                    2.2838e-06,
                    2.345e-06,
                    2.4072e-06,
                    2.4704e-06,
                    2.5347e-06,
                    2.6001e-06,
                    2.6665e-06,
                    2.7341e-06,
                    2.8028e-06,
                    2.8725e-06,
                    2.9433e-06,
                    3.015e-06,
                    3.0877e-06,
                    3.1613e-06,
                    3.2359e-06,
                    3.3115e-06,
                    3.388e-06,
                    3.4654e-06,
                    3.5437e-06,
                    3.623e-06,
                    3.7033e-06,
                    3.7845e-06,
                    3.8666e-06,
                    3.9497e-06,
                    4.0337e-06,
                    4.1187e-06,
                    4.2046e-06,
                    4.2915e-06,
                    4.3793e-06,
                    4.4682e-06,
                    4.558e-06,
                    4.649e-06,
                    4.7411e-06,
                    4.8346e-06,
                    4.9296e-06,
                    5.0261e-06,
                    5.1243e-06,
                    5.2241e-06,
                    5.3257e-06,
                    5.4292e-06,
                    5.5344e-06,
                    5.6419e-06,
                    5.7522e-06,
                    5.8657e-06,
                    5.983e-06,
                    6.1043e-06,
                    6.2298e-06,
                    6.3597e-06,
                    6.494e-06,
                    6.6326e-06,
                    6.7753e-06,
                    6.9233e-06,
                    7.0789e-06,
                    7.2438e-06,
                    7.4197e-06,
                    7.6077e-06,
                    7.8085e-06,
                    8.0225e-06,
                    8.2498e-06,
                    8.49e-06,
                    8.7424e-06,
                    9.0061e-06,
                    9.2808e-06,
                    9.5664e-06,
                    9.863e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.34,
                "Land_N2O_timeseries": [
                    2.8487e-08,
                    5.7544e-08,
                    8.7146e-08,
                    1.1726e-07,
                    1.4784e-07,
                    1.7884e-07,
                    2.1019e-07,
                    2.4182e-07,
                    2.7366e-07,
                    3.056e-07,
                    3.376e-07,
                    3.6964e-07,
                    4.0171e-07,
                    4.338e-07,
                    4.6591e-07,
                    4.9804e-07,
                    5.302e-07,
                    5.6238e-07,
                    5.9461e-07,
                    6.269e-07,
                    6.5973e-07,
                    6.9393e-07,
                    7.3013e-07,
                    7.6877e-07,
                    8.1011e-07,
                    8.5421e-07,
                    9.0093e-07,
                    9.4995e-07,
                    1.0008e-06,
                    1.0527e-06,
                    1.1052e-06,
                    1.1582e-06,
                    1.2117e-06,
                    1.2656e-06,
                    1.3197e-06,
                    1.3742e-06,
                    1.4291e-06,
                    1.4842e-06,
                    1.5398e-06,
                    1.6235e-06,
                    1.7085e-06,
                    1.796e-06,
                    1.8872e-06,
                    1.9832e-06,
                    2.085e-06,
                    2.1933e-06,
                    2.3088e-06,
                    2.432e-06,
                    2.5634e-06,
                    2.7031e-06,
                    2.8546e-06,
                    3.0233e-06,
                    3.2133e-06,
                    3.427e-06,
                    3.6655e-06,
                    3.9286e-06,
                    4.2142e-06,
                    4.5192e-06,
                    4.8387e-06,
                    5.1664e-06,
                    5.4987e-06,
                    5.8353e-06,
                    6.1758e-06,
                    6.5199e-06,
                    6.8672e-06,
                    7.2174e-06,
                    7.5699e-06,
                    7.9243e-06,
                    8.2801e-06,
                    8.6366e-06,
                    8.9926e-06,
                    9.3463e-06,
                    9.6963e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -69.47262,
                            -17.49896
                        ],
                        [
                            -69.46502,
                            -17.3744
                        ],
                        [
                            -69.57213,
                            -17.29019
                        ],
                        [
                            -69.63442,
                            -17.28663
                        ],
                        [
                            -69.55242,
                            -17.16301
                        ],
                        [
                            -69.45462,
                            -17.10347
                        ],
                        [
                            -69.37661,
                            -17.07875
                        ],
                        [
                            -69.38918,
                            -17.01881
                        ],
                        [
                            -69.18341,
                            -16.79404
                        ],
                        [
                            -69.174,
                            -16.74409
                        ],
                        [
                            -69.00794,
                            -16.67534
                        ],
                        [
                            -69.03163,
                            -16.56395
                        ],
                        [
                            -68.98431,
                            -16.43699
                        ],
                        [
                            -68.82231,
                            -16.34551
                        ],
                        [
                            -68.8227,
                            -16.31081
                        ],
                        [
                            -68.96189,
                            -16.19009
                        ],
                        [
                            -69.00883,
                            -16.21466
                        ],
                        [
                            -69.09732,
                            -16.21877
                        ],
                        [
                            -69.23592,
                            -16.14172
                        ],
                        [
                            -69.29859,
                            -15.93722
                        ],
                        [
                            -69.41265,
                            -15.62168
                        ],
                        [
                            -69.29815,
                            -15.42064
                        ],
                        [
                            -69.26456,
                            -15.33673
                        ],
                        [
                            -69.18519,
                            -15.26258
                        ],
                        [
                            -69.12704,
                            -15.25513
                        ],
                        [
                            -69.19256,
                            -15.16271
                        ],
                        [
                            -69.28022,
                            -15.11085
                        ],
                        [
                            -69.37344,
                            -14.9504
                        ],
                        [
                            -69.34985,
                            -14.90453
                        ],
                        [
                            -69.36184,
                            -14.80354
                        ],
                        [
                            -69.23751,
                            -14.73729
                        ],
                        [
                            -69.2367,
                            -14.6053
                        ],
                        [
                            -69.14659,
                            -14.57499
                        ],
                        [
                            -69.15019,
                            -14.506
                        ],
                        [
                            -68.98066,
                            -14.38672
                        ],
                        [
                            -68.99596,
                            -14.30004
                        ],
                        [
                            -68.98031,
                            -14.23688
                        ],
                        [
                            -68.85674,
                            -14.21984
                        ],
                        [
                            -68.83979,
                            -14.19391
                        ],
                        [
                            -68.88271,
                            -14.06343
                        ],
                        [
                            -68.96483,
                            -13.97285
                        ],
                        [
                            -68.96013,
                            -13.87665
                        ],
                        [
                            -68.99912,
                            -13.8011
                        ],
                        [
                            -68.99559,
                            -13.7549
                        ],
                        [
                            -69.05086,
                            -13.71737
                        ],
                        [
                            -69.07012,
                            -13.64545
                        ],
                        [
                            -68.99973,
                            -13.65319
                        ],
                        [
                            -68.94272,
                            -13.4891
                        ],
                        [
                            -68.95368,
                            -13.39695
                        ],
                        [
                            -68.94219,
                            -13.25695
                        ],
                        [
                            -68.95104,
                            -13.01994
                        ],
                        [
                            -68.96905,
                            -13.0025
                        ],
                        [
                            -68.96119,
                            -12.85507
                        ],
                        [
                            -68.93497,
                            -12.84401
                        ],
                        [
                            -68.84884,
                            -12.72923
                        ],
                        [
                            -68.7519,
                            -12.71873
                        ],
                        [
                            -68.7694,
                            -12.64601
                        ],
                        [
                            -68.7052,
                            -12.55936
                        ],
                        [
                            -68.68142,
                            -12.4936
                        ],
                        [
                            -68.92433,
                            -11.99408
                        ],
                        [
                            -69.03132,
                            -11.81178
                        ],
                        [
                            -69.32722,
                            -11.3355
                        ],
                        [
                            -69.56644,
                            -10.95666
                        ],
                        [
                            -69.72912,
                            -10.97261
                        ],
                        [
                            -69.77326,
                            -10.93495
                        ],
                        [
                            -69.94646,
                            -10.92984
                        ],
                        [
                            -70.13302,
                            -11.02417
                        ],
                        [
                            -70.33324,
                            -11.06644
                        ],
                        [
                            -70.43062,
                            -11.03055
                        ],
                        [
                            -70.49743,
                            -10.94671
                        ],
                        [
                            -70.53333,
                            -10.94239
                        ],
                        [
                            -70.6175,
                            -11.00575
                        ],
                        [
                            -70.62138,
                            -10.71009
                        ],
                        [
                            -70.62189,
                            -9.85045
                        ],
                        [
                            -70.52032,
                            -9.72851
                        ],
                        [
                            -70.58529,
                            -9.63285
                        ],
                        [
                            -70.57011,
                            -9.53082
                        ],
                        [
                            -70.51591,
                            -9.48979
                        ],
                        [
                            -70.50892,
                            -9.43197
                        ],
                        [
                            -70.59343,
                            -9.44845
                        ],
                        [
                            -70.6635,
                            -9.52907
                        ],
                        [
                            -70.74671,
                            -9.57151
                        ],
                        [
                            -70.79389,
                            -9.6367
                        ],
                        [
                            -70.87441,
                            -9.67737
                        ],
                        [
                            -70.98441,
                            -9.81436
                        ],
                        [
                            -71.1295,
                            -9.86092
                        ],
                        [
                            -71.18107,
                            -9.94151
                        ],
                        [
                            -71.28997,
                            -9.99625
                        ],
                        [
                            -71.36536,
                            -10.00049
                        ],
                        [
                            -72.16035,
                            -10.00153
                        ],
                        [
                            -72.14675,
                            -9.88505
                        ],
                        [
                            -72.17962,
                            -9.79614
                        ],
                        [
                            -72.26186,
                            -9.73878
                        ],
                        [
                            -72.24846,
                            -9.66168
                        ],
                        [
                            -72.29232,
                            -9.59053
                        ],
                        [
                            -72.28707,
                            -9.55312
                        ],
                        [
                            -72.36271,
                            -9.49273
                        ],
                        [
                            -72.43252,
                            -9.47587
                        ],
                        [
                            -72.52265,
                            -9.48083
                        ],
                        [
                            -72.62193,
                            -9.43844
                        ],
                        [
                            -72.72708,
                            -9.41743
                        ],
                        [
                            -73.19418,
                            -9.41598
                        ],
                        [
                            -73.181,
                            -9.37534
                        ],
                        [
                            -73.11604,
                            -9.32282
                        ],
                        [
                            -73.07275,
                            -9.24412
                        ],
                        [
                            -73.0285,
                            -9.23158
                        ],
                        [
                            -73.01104,
                            -9.17422
                        ],
                        [
                            -72.96736,
                            -9.15534
                        ],
                        [
                            -72.94814,
                            -9.10056
                        ],
                        [
                            -72.94911,
                            -8.98995
                        ],
                        [
                            -72.99415,
                            -8.93079
                        ],
                        [
                            -73.05804,
                            -8.90358
                        ],
                        [
                            -73.1519,
                            -8.72422
                        ],
                        [
                            -73.25671,
                            -8.68609
                        ],
                        [
                            -73.34309,
                            -8.58385
                        ],
                        [
                            -73.32884,
                            -8.50171
                        ],
                        [
                            -73.41733,
                            -8.41608
                        ],
                        [
                            -73.52369,
                            -8.36908
                        ],
                        [
                            -73.53624,
                            -8.26795
                        ],
                        [
                            -73.58303,
                            -8.20023
                        ],
                        [
                            -73.59076,
                            -8.11864
                        ],
                        [
                            -73.63133,
                            -8.02615
                        ],
                        [
                            -73.76488,
                            -7.93673
                        ],
                        [
                            -73.76509,
                            -7.86501
                        ],
                        [
                            -73.70991,
                            -7.87289
                        ],
                        [
                            -73.68622,
                            -7.80543
                        ],
                        [
                            -73.71862,
                            -7.76293
                        ],
                        [
                            -73.81907,
                            -7.71686
                        ],
                        [
                            -73.97559,
                            -7.55963
                        ],
                        [
                            -73.91784,
                            -7.45877
                        ],
                        [
                            -73.95222,
                            -7.3512
                        ],
                        [
                            -73.88357,
                            -7.37422
                        ],
                        [
                            -73.82794,
                            -7.34316
                        ],
                        [
                            -73.73305,
                            -7.33802
                        ],
                        [
                            -73.69078,
                            -7.29923
                        ],
                        [
                            -73.71053,
                            -7.23141
                        ],
                        [
                            -73.79383,
                            -7.11269
                        ],
                        [
                            -73.76011,
                            -7.0514
                        ],
                        [
                            -73.7443,
                            -6.90724
                        ],
                        [
                            -73.66732,
                            -6.81146
                        ],
                        [
                            -73.57113,
                            -6.72207
                        ],
                        [
                            -73.50855,
                            -6.69827
                        ],
                        [
                            -73.38582,
                            -6.60559
                        ],
                        [
                            -73.35071,
                            -6.56306
                        ],
                        [
                            -73.21442,
                            -6.52805
                        ],
                        [
                            -73.16393,
                            -6.48226
                        ],
                        [
                            -73.12662,
                            -6.39408
                        ],
                        [
                            -73.15726,
                            -6.20508
                        ],
                        [
                            -73.18015,
                            -6.16471
                        ],
                        [
                            -73.18214,
                            -6.03937
                        ],
                        [
                            -73.13251,
                            -5.98538
                        ],
                        [
                            -73.11296,
                            -5.8662
                        ],
                        [
                            -73.0315,
                            -5.78451
                        ],
                        [
                            -72.97799,
                            -5.70783
                        ],
                        [
                            -72.93479,
                            -5.52956
                        ],
                        [
                            -72.94566,
                            -5.45102
                        ],
                        [
                            -72.90643,
                            -5.31044
                        ],
                        [
                            -72.87461,
                            -5.2513
                        ],
                        [
                            -72.86861,
                            -5.18229
                        ],
                        [
                            -72.8931,
                            -5.13858
                        ],
                        [
                            -72.82251,
                            -5.08716
                        ],
                        [
                            -72.72843,
                            -5.04529
                        ],
                        [
                            -72.62129,
                            -5.06072
                        ],
                        [
                            -72.57699,
                            -4.99546
                        ],
                        [
                            -72.45669,
                            -4.9576
                        ],
                        [
                            -72.37505,
                            -4.88185
                        ],
                        [
                            -72.3526,
                            -4.80531
                        ],
                        [
                            -72.31027,
                            -4.77245
                        ],
                        [
                            -72.21467,
                            -4.76079
                        ],
                        [
                            -72.11497,
                            -4.7199
                        ],
                        [
                            -72.04396,
                            -4.62745
                        ],
                        [
                            -71.94176,
                            -4.60327
                        ],
                        [
                            -71.89255,
                            -4.51329
                        ],
                        [
                            -71.85802,
                            -4.51786
                        ],
                        [
                            -71.74211,
                            -4.47416
                        ],
                        [
                            -71.70765,
                            -4.50193
                        ],
                        [
                            -71.61284,
                            -4.52032
                        ],
                        [
                            -71.55066,
                            -4.47854
                        ],
                        [
                            -71.50094,
                            -4.47547
                        ],
                        [
                            -71.47209,
                            -4.4309
                        ],
                        [
                            -71.33167,
                            -4.43808
                        ],
                        [
                            -71.26836,
                            -4.38272
                        ],
                        [
                            -71.17994,
                            -4.3919
                        ],
                        [
                            -70.93478,
                            -4.37792
                        ],
                        [
                            -70.87629,
                            -4.3147
                        ],
                        [
                            -70.76372,
                            -4.15771
                        ],
                        [
                            -70.61362,
                            -4.18475
                        ],
                        [
                            -70.535,
                            -4.13612
                        ],
                        [
                            -70.49112,
                            -4.16241
                        ],
                        [
                            -70.43071,
                            -4.12615
                        ],
                        [
                            -70.31658,
                            -4.13925
                        ],
                        [
                            -70.28713,
                            -4.16876
                        ],
                        [
                            -70.27952,
                            -4.28358
                        ],
                        [
                            -70.19933,
                            -4.34432
                        ],
                        [
                            -70.15002,
                            -4.2677
                        ],
                        [
                            -70.10743,
                            -4.25904
                        ],
                        [
                            -70.04128,
                            -4.32876
                        ],
                        [
                            -69.98742,
                            -4.31521
                        ],
                        [
                            -69.95342,
                            -4.23049
                        ],
                        [
                            -70.09081,
                            -4.03228
                        ],
                        [
                            -70.15172,
                            -3.98481
                        ],
                        [
                            -70.18701,
                            -3.89182
                        ],
                        [
                            -70.24281,
                            -3.87035
                        ],
                        [
                            -70.29578,
                            -3.81282
                        ],
                        [
                            -70.35802,
                            -3.80699
                        ],
                        [
                            -70.46236,
                            -3.87962
                        ],
                        [
                            -70.5216,
                            -3.87879
                        ],
                        [
                            -70.56648,
                            -3.83697
                        ],
                        [
                            -70.61356,
                            -3.84254
                        ],
                        [
                            -70.7023,
                            -3.79344
                        ],
                        [
                            -70.03665,
                            -2.76463
                        ],
                        [
                            -70.07219,
                            -2.67206
                        ],
                        [
                            -70.16158,
                            -2.69196
                        ],
                        [
                            -70.22427,
                            -2.62414
                        ],
                        [
                            -70.23251,
                            -2.56496
                        ],
                        [
                            -70.31472,
                            -2.57478
                        ],
                        [
                            -70.36676,
                            -2.49426
                        ],
                        [
                            -70.41908,
                            -2.52379
                        ],
                        [
                            -70.46146,
                            -2.45712
                        ],
                        [
                            -70.5211,
                            -2.45314
                        ],
                        [
                            -70.58176,
                            -2.48339
                        ],
                        [
                            -70.62793,
                            -2.45545
                        ],
                        [
                            -70.67523,
                            -2.34077
                        ],
                        [
                            -70.76584,
                            -2.28789
                        ],
                        [
                            -70.82767,
                            -2.2742
                        ],
                        [
                            -70.87963,
                            -2.21678
                        ],
                        [
                            -70.92526,
                            -2.24506
                        ],
                        [
                            -70.9598,
                            -2.20895
                        ],
                        [
                            -71.04861,
                            -2.26409
                        ],
                        [
                            -71.1142,
                            -2.28343
                        ],
                        [
                            -71.15252,
                            -2.34553
                        ],
                        [
                            -71.26481,
                            -2.33839
                        ],
                        [
                            -71.36536,
                            -2.39704
                        ],
                        [
                            -71.37712,
                            -2.34587
                        ],
                        [
                            -71.44482,
                            -2.26332
                        ],
                        [
                            -71.62941,
                            -2.19134
                        ],
                        [
                            -71.69162,
                            -2.21627
                        ],
                        [
                            -71.70994,
                            -2.13587
                        ],
                        [
                            -71.79413,
                            -2.19354
                        ],
                        [
                            -71.8223,
                            -2.18878
                        ],
                        [
                            -71.85233,
                            -2.27932
                        ],
                        [
                            -71.93255,
                            -2.35324
                        ],
                        [
                            -71.98367,
                            -2.363
                        ],
                        [
                            -72.03383,
                            -2.33162
                        ],
                        [
                            -72.11523,
                            -2.42515
                        ],
                        [
                            -72.23983,
                            -2.43892
                        ],
                        [
                            -72.34462,
                            -2.4895
                        ],
                        [
                            -72.38445,
                            -2.41716
                        ],
                        [
                            -72.44197,
                            -2.43163
                        ],
                        [
                            -72.55727,
                            -2.425
                        ],
                        [
                            -72.58786,
                            -2.39763
                        ],
                        [
                            -72.65644,
                            -2.47193
                        ],
                        [
                            -72.69232,
                            -2.42507
                        ],
                        [
                            -72.75317,
                            -2.42602
                        ],
                        [
                            -72.90469,
                            -2.49421
                        ],
                        [
                            -72.96099,
                            -2.38453
                        ],
                        [
                            -73.01274,
                            -2.35745
                        ],
                        [
                            -73.11052,
                            -2.36018
                        ],
                        [
                            -73.15558,
                            -2.24553
                        ],
                        [
                            -73.10031,
                            -2.16843
                        ],
                        [
                            -73.08652,
                            -2.06555
                        ],
                        [
                            -73.11266,
                            -2.03187
                        ],
                        [
                            -73.10055,
                            -1.92439
                        ],
                        [
                            -73.14115,
                            -1.89325
                        ],
                        [
                            -73.14375,
                            -1.83399
                        ],
                        [
                            -73.21328,
                            -1.77835
                        ],
                        [
                            -73.32885,
                            -1.83419
                        ],
                        [
                            -73.50025,
                            -1.76145
                        ],
                        [
                            -73.5315,
                            -1.73316
                        ],
                        [
                            -73.50396,
                            -1.65788
                        ],
                        [
                            -73.49037,
                            -1.51683
                        ],
                        [
                            -73.52547,
                            -1.4946
                        ],
                        [
                            -73.62191,
                            -1.29445
                        ],
                        [
                            -73.68264,
                            -1.25871
                        ],
                        [
                            -73.8106,
                            -1.26582
                        ],
                        [
                            -73.86222,
                            -1.24866
                        ],
                        [
                            -73.9014,
                            -1.1568
                        ],
                        [
                            -74.01272,
                            -1.12146
                        ],
                        [
                            -74.15848,
                            -1.03637
                        ],
                        [
                            -74.27121,
                            -1.00231
                        ],
                        [
                            -74.26095,
                            -0.84219
                        ],
                        [
                            -74.29179,
                            -0.83345
                        ],
                        [
                            -74.37756,
                            -0.74552
                        ],
                        [
                            -74.34152,
                            -0.69995
                        ],
                        [
                            -74.42173,
                            -0.51629
                        ],
                        [
                            -74.53328,
                            -0.46374
                        ],
                        [
                            -74.57432,
                            -0.40093
                        ],
                        [
                            -74.66081,
                            -0.3314
                        ],
                        [
                            -74.79912,
                            -0.29114
                        ],
                        [
                            -74.77738,
                            -0.26511
                        ],
                        [
                            -74.80442,
                            -0.16256
                        ],
                        [
                            -74.87524,
                            -0.1876
                        ],
                        [
                            -74.95709,
                            -0.16656
                        ],
                        [
                            -75.02044,
                            -0.09991
                        ],
                        [
                            -75.1143,
                            -0.03924
                        ],
                        [
                            -75.20623,
                            -0.0134
                        ],
                        [
                            -75.2882,
                            -0.09369
                        ],
                        [
                            -75.30445,
                            -0.13307
                        ],
                        [
                            -75.41206,
                            -0.14819
                        ],
                        [
                            -75.47864,
                            -0.11898
                        ],
                        [
                            -75.62064,
                            -0.10969
                        ],
                        [
                            -75.62583,
                            -0.24941
                        ],
                        [
                            -75.53546,
                            -0.32636
                        ],
                        [
                            -75.44909,
                            -0.32933
                        ],
                        [
                            -75.41355,
                            -0.42415
                        ],
                        [
                            -75.35751,
                            -0.44281
                        ],
                        [
                            -75.24497,
                            -0.53624
                        ],
                        [
                            -75.27979,
                            -0.71216
                        ],
                        [
                            -75.25157,
                            -0.7529
                        ],
                        [
                            -75.19871,
                            -0.97594
                        ],
                        [
                            -75.30127,
                            -0.97975
                        ],
                        [
                            -75.36497,
                            -0.9581
                        ],
                        [
                            -75.53855,
                            -1.53599
                        ],
                        [
                            -75.61937,
                            -1.5867
                        ],
                        [
                            -76.04376,
                            -2.12652
                        ],
                        [
                            -76.63384,
                            -2.59343
                        ],
                        [
                            -77.09918,
                            -2.75358
                        ],
                        [
                            -77.75898,
                            -2.97265
                        ],
                        [
                            -77.83613,
                            -3.00532
                        ],
                        [
                            -77.99495,
                            -3.13441
                        ],
                        [
                            -78.13996,
                            -3.31737
                        ],
                        [
                            -78.19036,
                            -3.35717
                        ],
                        [
                            -78.13122,
                            -3.46626
                        ],
                        [
                            -78.14023,
                            -3.52361
                        ],
                        [
                            -78.24341,
                            -3.51481
                        ],
                        [
                            -78.24088,
                            -3.45455
                        ],
                        [
                            -78.29798,
                            -3.41433
                        ],
                        [
                            -78.33686,
                            -3.46522
                        ],
                        [
                            -78.35054,
                            -3.67764
                        ],
                        [
                            -78.37657,
                            -3.78495
                        ],
                        [
                            -78.47368,
                            -3.9071
                        ],
                        [
                            -78.5501,
                            -4.06624
                        ],
                        [
                            -78.57505,
                            -4.15876
                        ],
                        [
                            -78.56867,
                            -4.23493
                        ],
                        [
                            -78.62648,
                            -4.31654
                        ],
                        [
                            -78.61901,
                            -4.4918
                        ],
                        [
                            -78.7328,
                            -4.65031
                        ],
                        [
                            -78.83773,
                            -4.68065
                        ],
                        [
                            -78.88425,
                            -4.72537
                        ],
                        [
                            -78.91322,
                            -4.82555
                        ],
                        [
                            -78.96297,
                            -4.88527
                        ],
                        [
                            -78.9868,
                            -4.96034
                        ],
                        [
                            -79.03589,
                            -4.99791
                        ],
                        [
                            -79.07115,
                            -4.97033
                        ],
                        [
                            -79.2587,
                            -4.96711
                        ],
                        [
                            -79.29821,
                            -4.90013
                        ],
                        [
                            -79.41558,
                            -4.79887
                        ],
                        [
                            -79.50723,
                            -4.51395
                        ],
                        [
                            -79.54055,
                            -4.52653
                        ],
                        [
                            -79.61548,
                            -4.44152
                        ],
                        [
                            -79.81053,
                            -4.48635
                        ],
                        [
                            -79.86794,
                            -4.411
                        ],
                        [
                            -79.91458,
                            -4.3826
                        ],
                        [
                            -79.9909,
                            -4.37583
                        ],
                        [
                            -80.06045,
                            -4.30685
                        ],
                        [
                            -80.15509,
                            -4.30273
                        ],
                        [
                            -80.24568,
                            -4.39731
                        ],
                        [
                            -80.33515,
                            -4.46962
                        ],
                        [
                            -80.38821,
                            -4.48217
                        ],
                        [
                            -80.44233,
                            -4.43782
                        ],
                        [
                            -80.4428,
                            -4.3704
                        ],
                        [
                            -80.33217,
                            -4.22938
                        ],
                        [
                            -80.36726,
                            -4.19761
                        ],
                        [
                            -80.44259,
                            -4.19433
                        ],
                        [
                            -80.44473,
                            -4.1225
                        ],
                        [
                            -80.48085,
                            -4.08343
                        ],
                        [
                            -80.42997,
                            -3.99227
                        ],
                        [
                            -80.36292,
                            -3.98425
                        ],
                        [
                            -80.28751,
                            -4.01733
                        ],
                        [
                            -80.23108,
                            -3.95005
                        ],
                        [
                            -80.16322,
                            -3.92097
                        ],
                        [
                            -80.16257,
                            -3.80756
                        ],
                        [
                            -80.18929,
                            -3.77112
                        ],
                        [
                            -80.19184,
                            -3.6015
                        ],
                        [
                            -80.21537,
                            -3.57487
                        ],
                        [
                            -80.21999,
                            -3.44066
                        ],
                        [
                            -80.28275,
                            -3.42911
                        ],
                        [
                            -80.39163,
                            -3.49951
                        ],
                        [
                            -80.49957,
                            -3.50441
                        ],
                        [
                            -80.57901,
                            -3.63137
                        ],
                        [
                            -80.75293,
                            -3.71865
                        ],
                        [
                            -80.79616,
                            -3.76373
                        ],
                        [
                            -80.84591,
                            -3.8847
                        ],
                        [
                            -80.96253,
                            -3.95959
                        ],
                        [
                            -81.05339,
                            -4.1003
                        ],
                        [
                            -81.12888,
                            -4.17238
                        ],
                        [
                            -81.24069,
                            -4.25597
                        ],
                        [
                            -81.26863,
                            -4.43453
                        ],
                        [
                            -81.3023,
                            -4.48054
                        ],
                        [
                            -81.2821,
                            -4.52866
                        ],
                        [
                            -81.32564,
                            -4.68303
                        ],
                        [
                            -81.09004,
                            -4.96357
                        ],
                        [
                            -81.06472,
                            -5.05208
                        ],
                        [
                            -81.16861,
                            -5.09026
                        ],
                        [
                            -81.18573,
                            -5.22312
                        ],
                        [
                            -81.10839,
                            -5.31094
                        ],
                        [
                            -81.04746,
                            -5.3362
                        ],
                        [
                            -80.95786,
                            -5.4249
                        ],
                        [
                            -80.89905,
                            -5.50944
                        ],
                        [
                            -80.85598,
                            -5.62374
                        ],
                        [
                            -80.86196,
                            -5.74928
                        ],
                        [
                            -80.89122,
                            -5.80796
                        ],
                        [
                            -80.95293,
                            -5.84543
                        ],
                        [
                            -81.02409,
                            -5.82834
                        ],
                        [
                            -81.06455,
                            -5.79067
                        ],
                        [
                            -81.14671,
                            -5.88897
                        ],
                        [
                            -81.14712,
                            -5.98418
                        ],
                        [
                            -81.08934,
                            -6.08283
                        ],
                        [
                            -80.87793,
                            -6.21598
                        ],
                        [
                            -80.78313,
                            -6.29869
                        ],
                        [
                            -80.53814,
                            -6.4143
                        ],
                        [
                            -80.2692,
                            -6.55432
                        ],
                        [
                            -80.07674,
                            -6.67459
                        ],
                        [
                            -79.98262,
                            -6.75182
                        ],
                        [
                            -79.93463,
                            -6.8616
                        ],
                        [
                            -79.86,
                            -6.95266
                        ],
                        [
                            -79.74527,
                            -7.05245
                        ],
                        [
                            -79.69188,
                            -7.11503
                        ],
                        [
                            -79.68715,
                            -7.17931
                        ],
                        [
                            -79.61752,
                            -7.256
                        ],
                        [
                            -79.57134,
                            -7.38718
                        ],
                        [
                            -79.57543,
                            -7.46097
                        ],
                        [
                            -79.43951,
                            -7.6695
                        ],
                        [
                            -79.46066,
                            -7.71987
                        ],
                        [
                            -79.39161,
                            -7.79041
                        ],
                        [
                            -79.37045,
                            -7.84885
                        ],
                        [
                            -79.30296,
                            -7.92833
                        ],
                        [
                            -79.13259,
                            -8.05909
                        ],
                        [
                            -79.11485,
                            -8.09693
                        ],
                        [
                            -78.98903,
                            -8.20899
                        ],
                        [
                            -78.95455,
                            -8.29579
                        ],
                        [
                            -78.8972,
                            -8.38308
                        ],
                        [
                            -78.9122,
                            -8.46103
                        ],
                        [
                            -78.7781,
                            -8.5701
                        ],
                        [
                            -78.74749,
                            -8.62555
                        ],
                        [
                            -78.73964,
                            -8.72022
                        ],
                        [
                            -78.7586,
                            -8.77458
                        ],
                        [
                            -78.65929,
                            -8.90423
                        ],
                        [
                            -78.62434,
                            -9.01676
                        ],
                        [
                            -78.5415,
                            -9.17621
                        ],
                        [
                            -78.48628,
                            -9.21586
                        ],
                        [
                            -78.50174,
                            -9.28673
                        ],
                        [
                            -78.42924,
                            -9.3425
                        ],
                        [
                            -78.42231,
                            -9.41552
                        ],
                        [
                            -78.36842,
                            -9.56096
                        ],
                        [
                            -78.36405,
                            -9.62471
                        ],
                        [
                            -78.22783,
                            -9.79608
                        ],
                        [
                            -78.24187,
                            -9.86669
                        ],
                        [
                            -78.22976,
                            -9.95014
                        ],
                        [
                            -78.17627,
                            -10.0464
                        ],
                        [
                            -78.16041,
                            -10.14872
                        ],
                        [
                            -78.10122,
                            -10.20472
                        ],
                        [
                            -78.05234,
                            -10.34484
                        ],
                        [
                            -77.96258,
                            -10.49219
                        ],
                        [
                            -77.90916,
                            -10.54452
                        ],
                        [
                            -77.88128,
                            -10.61914
                        ],
                        [
                            -77.81068,
                            -10.70192
                        ],
                        [
                            -77.70731,
                            -10.85361
                        ],
                        [
                            -77.66029,
                            -10.94331
                        ],
                        [
                            -77.63042,
                            -11.09364
                        ],
                        [
                            -77.59717,
                            -11.16335
                        ],
                        [
                            -77.64384,
                            -11.22077
                        ],
                        [
                            -77.64037,
                            -11.30623
                        ],
                        [
                            -77.36118,
                            -11.46085
                        ],
                        [
                            -77.30393,
                            -11.51576
                        ],
                        [
                            -77.27518,
                            -11.59069
                        ],
                        [
                            -77.21962,
                            -11.63695
                        ],
                        [
                            -77.16951,
                            -11.74309
                        ],
                        [
                            -77.1946,
                            -11.78168
                        ],
                        [
                            -77.14887,
                            -11.89724
                        ],
                        [
                            -77.13256,
                            -12.07154
                        ],
                        [
                            -77.02904,
                            -12.14321
                        ],
                        [
                            -77.03247,
                            -12.20574
                        ],
                        [
                            -76.85495,
                            -12.30151
                        ],
                        [
                            -76.77958,
                            -12.39589
                        ],
                        [
                            -76.79988,
                            -12.50711
                        ],
                        [
                            -76.74236,
                            -12.54358
                        ],
                        [
                            -76.67356,
                            -12.62944
                        ],
                        [
                            -76.63149,
                            -12.74647
                        ],
                        [
                            -76.52149,
                            -12.85021
                        ],
                        [
                            -76.51238,
                            -12.95981
                        ],
                        [
                            -76.48508,
                            -13.03545
                        ],
                        [
                            -76.25822,
                            -13.30444
                        ],
                        [
                            -76.186,
                            -13.45345
                        ],
                        [
                            -76.19984,
                            -13.64512
                        ],
                        [
                            -76.26537,
                            -13.86106
                        ],
                        [
                            -76.36786,
                            -13.80914
                        ],
                        [
                            -76.39092,
                            -13.90785
                        ],
                        [
                            -76.32606,
                            -13.9202
                        ],
                        [
                            -76.2714,
                            -13.97431
                        ],
                        [
                            -76.2637,
                            -14.05566
                        ],
                        [
                            -76.28732,
                            -14.09253
                        ],
                        [
                            -76.27345,
                            -14.19245
                        ],
                        [
                            -76.22734,
                            -14.15195
                        ],
                        [
                            -76.15123,
                            -14.2225
                        ],
                        [
                            -76.10924,
                            -14.29748
                        ],
                        [
                            -76.12217,
                            -14.35963
                        ],
                        [
                            -76.07043,
                            -14.38467
                        ],
                        [
                            -75.97516,
                            -14.469
                        ],
                        [
                            -75.97139,
                            -14.52402
                        ],
                        [
                            -75.93274,
                            -14.57054
                        ],
                        [
                            -75.9173,
                            -14.65585
                        ],
                        [
                            -75.84813,
                            -14.71868
                        ],
                        [
                            -75.67906,
                            -14.81829
                        ],
                        [
                            -75.55044,
                            -14.88155
                        ],
                        [
                            -75.44241,
                            -15.00427
                        ],
                        [
                            -75.37208,
                            -15.12953
                        ],
                        [
                            -75.23377,
                            -15.20255
                        ],
                        [
                            -75.22613,
                            -15.28467
                        ],
                        [
                            -75.16532,
                            -15.31251
                        ],
                        [
                            -75.13831,
                            -15.40471
                        ],
                        [
                            -75.05584,
                            -15.45364
                        ],
                        [
                            -74.87775,
                            -15.5305
                        ],
                        [
                            -74.83602,
                            -15.56695
                        ],
                        [
                            -74.66496,
                            -15.65101
                        ],
                        [
                            -74.46436,
                            -15.72799
                        ],
                        [
                            -74.39823,
                            -15.8263
                        ],
                        [
                            -74.29137,
                            -15.83896
                        ],
                        [
                            -74.04427,
                            -15.96384
                        ],
                        [
                            -74.01817,
                            -16.03261
                        ],
                        [
                            -73.86227,
                            -16.13911
                        ],
                        [
                            -73.70133,
                            -16.22039
                        ],
                        [
                            -73.55614,
                            -16.247
                        ],
                        [
                            -73.31387,
                            -16.34015
                        ],
                        [
                            -73.28913,
                            -16.40231
                        ],
                        [
                            -73.20687,
                            -16.4021
                        ],
                        [
                            -73.04884,
                            -16.49823
                        ],
                        [
                            -72.91923,
                            -16.51987
                        ],
                        [
                            -72.77648,
                            -16.62543
                        ],
                        [
                            -72.70514,
                            -16.65311
                        ],
                        [
                            -72.60594,
                            -16.66521
                        ],
                        [
                            -72.44861,
                            -16.70302
                        ],
                        [
                            -72.34902,
                            -16.77201
                        ],
                        [
                            -72.27646,
                            -16.87511
                        ],
                        [
                            -72.21277,
                            -16.903
                        ],
                        [
                            -72.09044,
                            -17.01307
                        ],
                        [
                            -72.04356,
                            -17.01742
                        ],
                        [
                            -71.93276,
                            -17.07896
                        ],
                        [
                            -71.87412,
                            -17.1432
                        ],
                        [
                            -71.79119,
                            -17.19102
                        ],
                        [
                            -71.68833,
                            -17.21294
                        ],
                        [
                            -71.47455,
                            -17.29679
                        ],
                        [
                            -71.39605,
                            -17.38928
                        ],
                        [
                            -71.36355,
                            -17.49102
                        ],
                        [
                            -71.34258,
                            -17.63266
                        ],
                        [
                            -71.37017,
                            -17.68026
                        ],
                        [
                            -71.18661,
                            -17.78076
                        ],
                        [
                            -71.0936,
                            -17.86752
                        ],
                        [
                            -71.00599,
                            -17.87925
                        ],
                        [
                            -70.89116,
                            -17.97073
                        ],
                        [
                            -70.88464,
                            -18.00957
                        ],
                        [
                            -70.76098,
                            -18.0802
                        ],
                        [
                            -70.68226,
                            -18.15841
                        ],
                        [
                            -70.48482,
                            -18.27139
                        ],
                        [
                            -70.37617,
                            -18.35358
                        ],
                        [
                            -70.3047,
                            -18.30556
                        ],
                        [
                            -70.19095,
                            -18.31919
                        ],
                        [
                            -70.0487,
                            -18.26488
                        ],
                        [
                            -69.93636,
                            -18.23737
                        ],
                        [
                            -69.81895,
                            -18.11862
                        ],
                        [
                            -69.75551,
                            -17.9919
                        ],
                        [
                            -69.74695,
                            -17.93922
                        ],
                        [
                            -69.79241,
                            -17.86959
                        ],
                        [
                            -69.82127,
                            -17.70107
                        ],
                        [
                            -69.7946,
                            -17.64793
                        ],
                        [
                            -69.66191,
                            -17.6578
                        ],
                        [
                            -69.5565,
                            -17.58354
                        ],
                        [
                            -69.47262,
                            -17.49896
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "PHL",
                "Country": "Philippines",
                "Total_3GHG": 0.68,
                "Total_3GHG_timeseries": [
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0055,
                    0.0056,
                    0.0058,
                    0.0059,
                    0.0061,
                    0.0062,
                    0.0064,
                    0.0065,
                    0.0066,
                    0.0067,
                    0.0069,
                    0.007,
                    0.0071,
                    0.0072,
                    0.0073,
                    0.0074,
                    0.0075,
                    0.0076,
                    0.0077,
                    0.0078,
                    0.0079,
                    0.0079,
                    0.008,
                    0.0081,
                    0.0082,
                    0.0083,
                    0.0084,
                    0.0084,
                    0.0085,
                    0.0086,
                    0.0087,
                    0.0088,
                    0.009,
                    0.0091,
                    0.0092,
                    0.0093,
                    0.0094,
                    0.0096,
                    0.0097,
                    0.0099,
                    0.01,
                    0.0101,
                    0.0102,
                    0.0104,
                    0.0105,
                    0.0107,
                    0.0108,
                    0.0109,
                    0.0111,
                    0.0112
                ],
                "Fossil_3GHG": 0.3,
                "Fossil_3GHG_timeseries": [
                    5.6906e-07,
                    1.1481e-06,
                    1.7372e-06,
                    2.3364e-06,
                    2.9458e-06,
                    3.5656e-06,
                    4.1957e-06,
                    4.8362e-06,
                    5.4872e-06,
                    6.1487e-06,
                    6.8174e-06,
                    7.4934e-06,
                    8.1767e-06,
                    8.8675e-06,
                    9.5659e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0032
                ],
                "Land_3GHG": 1.4,
                "Land_3GHG_timeseries": [
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.005,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0055,
                    0.0056,
                    0.0057,
                    0.0058,
                    0.0059,
                    0.006,
                    0.0061,
                    0.0062,
                    0.0062,
                    0.0063,
                    0.0064,
                    0.0064,
                    0.0065,
                    0.0066,
                    0.0066,
                    0.0066,
                    0.0067,
                    0.0067,
                    0.0068,
                    0.0068,
                    0.0068,
                    0.0068,
                    0.0069,
                    0.0069,
                    0.007,
                    0.007,
                    0.0071,
                    0.0071,
                    0.0072,
                    0.0073,
                    0.0074,
                    0.0074,
                    0.0075,
                    0.0076,
                    0.0076,
                    0.0077,
                    0.0077,
                    0.0078,
                    0.0078,
                    0.0079,
                    0.0079,
                    0.008,
                    0.008,
                    0.008,
                    0.008
                ],
                "Total_CO2": 0.62,
                "Total_CO2_timeseries": [
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.005,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0052,
                    0.0053,
                    0.0053,
                    0.0054,
                    0.0054,
                    0.0055,
                    0.0055,
                    0.0056,
                    0.0056,
                    0.0057,
                    0.0057,
                    0.0058,
                    0.0059,
                    0.0059,
                    0.006,
                    0.0061,
                    0.0061,
                    0.0062,
                    0.0063,
                    0.0064,
                    0.0064,
                    0.0065,
                    0.0066,
                    0.0066,
                    0.0067,
                    0.0068,
                    0.0068,
                    0.0069,
                    0.007,
                    0.0071
                ],
                "Fossil_CO2": 0.21,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    3.3e-09,
                    1.155e-08,
                    3.63e-08,
                    5.94e-08,
                    7.59e-08,
                    7.755e-08,
                    8.085e-08,
                    8.91e-08,
                    1.1385e-07,
                    1.3695e-07,
                    1.419e-07,
                    1.551e-07,
                    1.815e-07,
                    2.277e-07,
                    2.5905e-07,
                    2.937e-07,
                    3.2835e-07,
                    3.663e-07,
                    4.0425e-07,
                    4.2735e-07,
                    4.455e-07,
                    4.8168e-07,
                    5.1289e-07,
                    5.523e-07,
                    5.8843e-07,
                    6.2782e-07,
                    6.623e-07,
                    7.0172e-07,
                    7.4607e-07,
                    8.0028e-07,
                    8.5446e-07,
                    9.2511e-07,
                    9.6306e-07,
                    1.0142e-06,
                    1.0551e-06,
                    1.0551e-06,
                    1.0551e-06,
                    1.0551e-06,
                    1.0617e-06,
                    1.1127e-06,
                    1.2016e-06,
                    1.2987e-06,
                    1.4419e-06,
                    3.065e-06,
                    4.6649e-06,
                    6.4892e-06,
                    8.3054e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017
                ],
                "Land_CO2": 1.5,
                "Land_CO2_timeseries": [
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0045,
                    0.0046,
                    0.0046,
                    0.0047,
                    0.0047,
                    0.0048,
                    0.0048,
                    0.0048,
                    0.0048,
                    0.0049,
                    0.0049,
                    0.0049,
                    0.0049,
                    0.0049,
                    0.0049,
                    0.005,
                    0.005,
                    0.005,
                    0.0051,
                    0.0051,
                    0.0051,
                    0.0052,
                    0.0052,
                    0.0052,
                    0.0053,
                    0.0053,
                    0.0053,
                    0.0053,
                    0.0053,
                    0.0054,
                    0.0054,
                    0.0054,
                    0.0054,
                    0.0054,
                    0.0054
                ],
                "Total_CH4": 0.92,
                "Total_CH4_timeseries": [
                    3.4152e-06,
                    6.8977e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038
                ],
                "Fossil_CH4": 0.55,
                "Fossil_CH4_timeseries": [
                    4.7494e-07,
                    9.5879e-07,
                    1.4516e-06,
                    1.9535e-06,
                    2.4646e-06,
                    2.9851e-06,
                    3.5148e-06,
                    4.0541e-06,
                    4.603e-06,
                    5.1616e-06,
                    5.7266e-06,
                    6.2979e-06,
                    6.8759e-06,
                    7.4605e-06,
                    8.0518e-06,
                    8.6501e-06,
                    9.2554e-06,
                    9.8679e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014
                ],
                "Land_CH4": 1.53,
                "Land_CH4_timeseries": [
                    2.9403e-06,
                    5.939e-06,
                    8.9959e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024
                ],
                "Total_N2O": 0.38,
                "Total_N2O_timeseries": [
                    1.4879e-07,
                    2.9976e-07,
                    4.5283e-07,
                    6.0792e-07,
                    7.6494e-07,
                    9.2376e-07,
                    1.0842e-06,
                    1.2462e-06,
                    1.4094e-06,
                    1.5736e-06,
                    1.7388e-06,
                    1.9049e-06,
                    2.0719e-06,
                    2.2397e-06,
                    2.4083e-06,
                    2.5778e-06,
                    2.7481e-06,
                    2.9193e-06,
                    3.0914e-06,
                    3.2644e-06,
                    3.4395e-06,
                    3.6187e-06,
                    3.8036e-06,
                    3.9951e-06,
                    4.194e-06,
                    4.4002e-06,
                    4.6136e-06,
                    4.8334e-06,
                    5.0583e-06,
                    5.2866e-06,
                    5.5172e-06,
                    5.7498e-06,
                    5.9843e-06,
                    6.2204e-06,
                    6.4582e-06,
                    6.6975e-06,
                    6.9384e-06,
                    7.1809e-06,
                    7.425e-06,
                    7.6824e-06,
                    7.9422e-06,
                    8.2048e-06,
                    8.4707e-06,
                    8.7402e-06,
                    9.0137e-06,
                    9.2915e-06,
                    9.574e-06,
                    9.8612e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_N2O": 0.32,
                "Fossil_N2O_timeseries": [
                    9.4119e-08,
                    1.8931e-07,
                    2.8557e-07,
                    3.8287e-07,
                    4.8119e-07,
                    5.8051e-07,
                    6.808e-07,
                    7.8202e-07,
                    8.8414e-07,
                    9.871e-07,
                    1.0909e-06,
                    1.1955e-06,
                    1.3009e-06,
                    1.4071e-06,
                    1.5141e-06,
                    1.6219e-06,
                    1.7305e-06,
                    1.8399e-06,
                    1.9501e-06,
                    2.0612e-06,
                    2.1733e-06,
                    2.2869e-06,
                    2.4023e-06,
                    2.5196e-06,
                    2.6391e-06,
                    2.7608e-06,
                    2.8845e-06,
                    3.0102e-06,
                    3.1375e-06,
                    3.2662e-06,
                    3.396e-06,
                    3.5268e-06,
                    3.6586e-06,
                    3.7914e-06,
                    3.9252e-06,
                    4.0599e-06,
                    4.1956e-06,
                    4.3322e-06,
                    4.4698e-06,
                    4.6097e-06,
                    4.7508e-06,
                    4.8933e-06,
                    5.0372e-06,
                    5.1825e-06,
                    5.3293e-06,
                    5.4775e-06,
                    5.6273e-06,
                    5.7787e-06,
                    5.9316e-06,
                    6.0862e-06,
                    6.2426e-06,
                    6.4008e-06,
                    6.5611e-06,
                    6.7234e-06,
                    6.8878e-06,
                    7.0544e-06,
                    7.2231e-06,
                    7.3939e-06,
                    7.5667e-06,
                    7.7414e-06,
                    7.9179e-06,
                    8.0961e-06,
                    8.276e-06,
                    8.4575e-06,
                    8.6407e-06,
                    8.8255e-06,
                    9.012e-06,
                    9.2002e-06,
                    9.3902e-06,
                    9.5822e-06,
                    9.7763e-06,
                    9.9727e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_N2O": 0.4,
                "Land_N2O_timeseries": [
                    5.4675e-08,
                    1.1044e-07,
                    1.6726e-07,
                    2.2506e-07,
                    2.8375e-07,
                    3.4324e-07,
                    4.0341e-07,
                    4.6413e-07,
                    5.2522e-07,
                    5.8654e-07,
                    6.4795e-07,
                    7.0945e-07,
                    7.71e-07,
                    8.3259e-07,
                    8.9422e-07,
                    9.5589e-07,
                    1.0176e-06,
                    1.0794e-06,
                    1.1412e-06,
                    1.2032e-06,
                    1.2662e-06,
                    1.3318e-06,
                    1.4013e-06,
                    1.4755e-06,
                    1.5548e-06,
                    1.6395e-06,
                    1.7291e-06,
                    1.8232e-06,
                    1.9208e-06,
                    2.0204e-06,
                    2.1212e-06,
                    2.223e-06,
                    2.3256e-06,
                    2.429e-06,
                    2.533e-06,
                    2.6376e-06,
                    2.7428e-06,
                    2.8487e-06,
                    2.9552e-06,
                    3.0728e-06,
                    3.1914e-06,
                    3.3115e-06,
                    3.4334e-06,
                    3.5577e-06,
                    3.6844e-06,
                    3.814e-06,
                    3.9466e-06,
                    4.0825e-06,
                    4.2217e-06,
                    4.3645e-06,
                    4.5109e-06,
                    4.6616e-06,
                    4.8168e-06,
                    4.9771e-06,
                    5.143e-06,
                    5.315e-06,
                    5.4936e-06,
                    5.6794e-06,
                    5.8729e-06,
                    6.0747e-06,
                    6.2866e-06,
                    6.5116e-06,
                    6.7519e-06,
                    7.0091e-06,
                    7.2842e-06,
                    7.5778e-06,
                    7.8898e-06,
                    8.2194e-06,
                    8.5653e-06,
                    8.9258e-06,
                    9.2997e-06,
                    9.6869e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                119.76688,
                                15.92648
                            ],
                            [
                                119.84995,
                                15.96229
                            ],
                            [
                                119.9088,
                                15.84411
                            ],
                            [
                                119.8693,
                                15.73454
                            ],
                            [
                                119.93179,
                                15.67436
                            ],
                            [
                                119.90517,
                                15.61381
                            ],
                            [
                                119.96292,
                                15.51292
                            ],
                            [
                                119.90251,
                                15.47067
                            ],
                            [
                                119.89373,
                                15.42647
                            ],
                            [
                                120.0172,
                                15.26196
                            ],
                            [
                                120.06327,
                                15.02876
                            ],
                            [
                                120.05268,
                                14.89055
                            ],
                            [
                                120.08696,
                                14.7864
                            ],
                            [
                                120.15662,
                                14.74435
                            ],
                            [
                                120.19383,
                                14.77008
                            ],
                            [
                                120.22989,
                                14.87525
                            ],
                            [
                                120.29141,
                                14.79837
                            ],
                            [
                                120.24658,
                                14.7584
                            ],
                            [
                                120.24954,
                                14.69041
                            ],
                            [
                                120.38815,
                                14.57872
                            ],
                            [
                                120.38755,
                                14.46634
                            ],
                            [
                                120.4672,
                                14.41865
                            ],
                            [
                                120.58804,
                                14.44643
                            ],
                            [
                                120.60762,
                                14.51805
                            ],
                            [
                                120.58049,
                                14.64781
                            ],
                            [
                                120.54487,
                                14.69216
                            ],
                            [
                                120.54398,
                                14.78366
                            ],
                            [
                                120.60465,
                                14.81947
                            ],
                            [
                                120.66346,
                                14.76747
                            ],
                            [
                                120.83566,
                                14.7565
                            ],
                            [
                                120.90761,
                                14.70391
                            ],
                            [
                                120.95642,
                                14.63709
                            ],
                            [
                                120.99224,
                                14.53256
                            ],
                            [
                                120.95186,
                                14.46639
                            ],
                            [
                                120.87551,
                                14.4472
                            ],
                            [
                                120.71248,
                                14.28525
                            ],
                            [
                                120.64983,
                                14.27968
                            ],
                            [
                                120.59129,
                                14.22086
                            ],
                            [
                                120.58056,
                                14.13587
                            ],
                            [
                                120.61681,
                                14.11426
                            ],
                            [
                                120.62782,
                                13.98348
                            ],
                            [
                                120.61558,
                                13.84209
                            ],
                            [
                                120.70763,
                                13.84636
                            ],
                            [
                                120.70126,
                                13.89752
                            ],
                            [
                                120.74921,
                                13.93401
                            ],
                            [
                                120.87322,
                                13.90463
                            ],
                            [
                                120.91179,
                                13.87291
                            ],
                            [
                                120.92622,
                                13.77383
                            ],
                            [
                                121.04029,
                                13.76644
                            ],
                            [
                                121.05774,
                                13.72587
                            ],
                            [
                                121.04401,
                                13.63442
                            ],
                            [
                                121.08486,
                                13.62304
                            ],
                            [
                                121.1818,
                                13.64248
                            ],
                            [
                                121.28305,
                                13.59867
                            ],
                            [
                                121.3363,
                                13.641
                            ],
                            [
                                121.46007,
                                13.68135
                            ],
                            [
                                121.43746,
                                13.79119
                            ],
                            [
                                121.49516,
                                13.85204
                            ],
                            [
                                121.69522,
                                13.92447
                            ],
                            [
                                121.71465,
                                13.96875
                            ],
                            [
                                121.81488,
                                13.93621
                            ],
                            [
                                121.82145,
                                13.9026
                            ],
                            [
                                121.97163,
                                13.83841
                            ],
                            [
                                121.98454,
                                13.80397
                            ],
                            [
                                122.06976,
                                13.79258
                            ],
                            [
                                122.12846,
                                13.74369
                            ],
                            [
                                122.20824,
                                13.60313
                            ],
                            [
                                122.31696,
                                13.58911
                            ],
                            [
                                122.39659,
                                13.52284
                            ],
                            [
                                122.48441,
                                13.40966
                            ],
                            [
                                122.51755,
                                13.34009
                            ],
                            [
                                122.50453,
                                13.2431
                            ],
                            [
                                122.56427,
                                13.17912
                            ],
                            [
                                122.62034,
                                13.17014
                            ],
                            [
                                122.70058,
                                13.23398
                            ],
                            [
                                122.68056,
                                13.27509
                            ],
                            [
                                122.67442,
                                13.38317
                            ],
                            [
                                122.60644,
                                13.49729
                            ],
                            [
                                122.63173,
                                13.52919
                            ],
                            [
                                122.55634,
                                13.5807
                            ],
                            [
                                122.49812,
                                13.64953
                            ],
                            [
                                122.48071,
                                13.70284
                            ],
                            [
                                122.51889,
                                13.73494
                            ],
                            [
                                122.49556,
                                13.84265
                            ],
                            [
                                122.42357,
                                13.93066
                            ],
                            [
                                122.52398,
                                13.92705
                            ],
                            [
                                122.63325,
                                13.88174
                            ],
                            [
                                122.65678,
                                13.81881
                            ],
                            [
                                122.73489,
                                13.81364
                            ],
                            [
                                122.8332,
                                13.73357
                            ],
                            [
                                122.82504,
                                13.65583
                            ],
                            [
                                122.88846,
                                13.57957
                            ],
                            [
                                122.97315,
                                13.52307
                            ],
                            [
                                123.05577,
                                13.50104
                            ],
                            [
                                123.18848,
                                13.42916
                            ],
                            [
                                123.24014,
                                13.28952
                            ],
                            [
                                123.32288,
                                13.19908
                            ],
                            [
                                123.29004,
                                13.14403
                            ],
                            [
                                123.28516,
                                13.06263
                            ],
                            [
                                123.32701,
                                13.01186
                            ],
                            [
                                123.37695,
                                13.04024
                            ],
                            [
                                123.4494,
                                13.02628
                            ],
                            [
                                123.5267,
                                12.94398
                            ],
                            [
                                123.65766,
                                12.87704
                            ],
                            [
                                123.73033,
                                12.85413
                            ],
                            [
                                123.8298,
                                12.88264
                            ],
                            [
                                123.88676,
                                12.97402
                            ],
                            [
                                124.02727,
                                12.96528
                            ],
                            [
                                124.01138,
                                12.88002
                            ],
                            [
                                123.91647,
                                12.84499
                            ],
                            [
                                123.86448,
                                12.87637
                            ],
                            [
                                123.83183,
                                12.83578
                            ],
                            [
                                123.85042,
                                12.72433
                            ],
                            [
                                123.8802,
                                12.65786
                            ],
                            [
                                124.00187,
                                12.54277
                            ],
                            [
                                124.07887,
                                12.54111
                            ],
                            [
                                124.09926,
                                12.63731
                            ],
                            [
                                124.13634,
                                12.66438
                            ],
                            [
                                124.13375,
                                12.73721
                            ],
                            [
                                124.15751,
                                12.8328
                            ],
                            [
                                124.14468,
                                12.89215
                            ],
                            [
                                124.1588,
                                12.99681
                            ],
                            [
                                124.19472,
                                13.02249
                            ],
                            [
                                124.14033,
                                13.07828
                            ],
                            [
                                124.09465,
                                13.01566
                            ],
                            [
                                123.99005,
                                13.09535
                            ],
                            [
                                123.90372,
                                13.14015
                            ],
                            [
                                123.86745,
                                13.13597
                            ],
                            [
                                123.80523,
                                13.05392
                            ],
                            [
                                123.76181,
                                13.06206
                            ],
                            [
                                123.75704,
                                13.17895
                            ],
                            [
                                123.77438,
                                13.22606
                            ],
                            [
                                123.8652,
                                13.23418
                            ],
                            [
                                123.74417,
                                13.32573
                            ],
                            [
                                123.67787,
                                13.47532
                            ],
                            [
                                123.62629,
                                13.49175
                            ],
                            [
                                123.57963,
                                13.55455
                            ],
                            [
                                123.53282,
                                13.5685
                            ],
                            [
                                123.53913,
                                13.63959
                            ],
                            [
                                123.5907,
                                13.72472
                            ],
                            [
                                123.68597,
                                13.71953
                            ],
                            [
                                123.80721,
                                13.6894
                            ],
                            [
                                123.86687,
                                13.73345
                            ],
                            [
                                123.97505,
                                13.72144
                            ],
                            [
                                123.92189,
                                13.79278
                            ],
                            [
                                123.81713,
                                13.82857
                            ],
                            [
                                123.75534,
                                13.87227
                            ],
                            [
                                123.53678,
                                13.91603
                            ],
                            [
                                123.41132,
                                13.98218
                            ],
                            [
                                123.33853,
                                14.07287
                            ],
                            [
                                123.29182,
                                14.06021
                            ],
                            [
                                123.23342,
                                14.00306
                            ],
                            [
                                123.29278,
                                13.92607
                            ],
                            [
                                123.31898,
                                13.82458
                            ],
                            [
                                123.26839,
                                13.74749
                            ],
                            [
                                123.20723,
                                13.72828
                            ],
                            [
                                123.11847,
                                13.73189
                            ],
                            [
                                123.04521,
                                13.79941
                            ],
                            [
                                123.09288,
                                13.89264
                            ],
                            [
                                123.07752,
                                13.98772
                            ],
                            [
                                123.03288,
                                14.03525
                            ],
                            [
                                123.04245,
                                14.10016
                            ],
                            [
                                122.98717,
                                14.12409
                            ],
                            [
                                122.91845,
                                14.22343
                            ],
                            [
                                122.84152,
                                14.28127
                            ],
                            [
                                122.70786,
                                14.33462
                            ],
                            [
                                122.63971,
                                14.27726
                            ],
                            [
                                122.5172,
                                14.34376
                            ],
                            [
                                122.41571,
                                14.31186
                            ],
                            [
                                122.3327,
                                14.19808
                            ],
                            [
                                122.34017,
                                14.11641
                            ],
                            [
                                122.26777,
                                14.13511
                            ],
                            [
                                122.2293,
                                14.19154
                            ],
                            [
                                122.16524,
                                14.1335
                            ],
                            [
                                122.19813,
                                14.08788
                            ],
                            [
                                122.28131,
                                14.03682
                            ],
                            [
                                122.28865,
                                13.96297
                            ],
                            [
                                122.23079,
                                13.89992
                            ],
                            [
                                122.02132,
                                13.95553
                            ],
                            [
                                121.89783,
                                14.0216
                            ],
                            [
                                121.76851,
                                14.12917
                            ],
                            [
                                121.73534,
                                14.18422
                            ],
                            [
                                121.75842,
                                14.23118
                            ],
                            [
                                121.72516,
                                14.32201
                            ],
                            [
                                121.65782,
                                14.40107
                            ],
                            [
                                121.60482,
                                14.6558
                            ],
                            [
                                121.72125,
                                14.71261
                            ],
                            [
                                121.60355,
                                14.82643
                            ],
                            [
                                121.5654,
                                14.96855
                            ],
                            [
                                121.49981,
                                15.0738
                            ],
                            [
                                121.48087,
                                15.1817
                            ],
                            [
                                121.41081,
                                15.22773
                            ],
                            [
                                121.37213,
                                15.31739
                            ],
                            [
                                121.47236,
                                15.41787
                            ],
                            [
                                121.49356,
                                15.51936
                            ],
                            [
                                121.6171,
                                15.65713
                            ],
                            [
                                121.62998,
                                15.75293
                            ],
                            [
                                121.57032,
                                15.75807
                            ],
                            [
                                121.54959,
                                15.80491
                            ],
                            [
                                121.55196,
                                15.89451
                            ],
                            [
                                121.74735,
                                16.07125
                            ],
                            [
                                121.78303,
                                16.0665
                            ],
                            [
                                121.86898,
                                16.12029
                            ],
                            [
                                121.96434,
                                16.13579
                            ],
                            [
                                122.02127,
                                16.17719
                            ],
                            [
                                122.20211,
                                16.23651
                            ],
                            [
                                122.18526,
                                16.30129
                            ],
                            [
                                122.22721,
                                16.35956
                            ],
                            [
                                122.20529,
                                16.43576
                            ],
                            [
                                122.30034,
                                16.55045
                            ],
                            [
                                122.36779,
                                16.68618
                            ],
                            [
                                122.43599,
                                16.79461
                            ],
                            [
                                122.478,
                                16.94266
                            ],
                            [
                                122.4704,
                                16.97342
                            ],
                            [
                                122.52553,
                                17.09508
                            ],
                            [
                                122.43581,
                                17.12424
                            ],
                            [
                                122.40853,
                                17.33471
                            ],
                            [
                                122.29305,
                                17.34065
                            ],
                            [
                                122.25358,
                                17.38542
                            ],
                            [
                                122.19231,
                                17.50516
                            ],
                            [
                                122.16484,
                                17.6167
                            ],
                            [
                                122.16471,
                                17.70083
                            ],
                            [
                                122.13985,
                                17.7903
                            ],
                            [
                                122.167,
                                17.84692
                            ],
                            [
                                122.18968,
                                18.01029
                            ],
                            [
                                122.16999,
                                18.08262
                            ],
                            [
                                122.26178,
                                18.16625
                            ],
                            [
                                122.33034,
                                18.27076
                            ],
                            [
                                122.32463,
                                18.36464
                            ],
                            [
                                122.26555,
                                18.42893
                            ],
                            [
                                122.22296,
                                18.52112
                            ],
                            [
                                122.16991,
                                18.5193
                            ],
                            [
                                122.12647,
                                18.4282
                            ],
                            [
                                122.12815,
                                18.38173
                            ],
                            [
                                122.0186,
                                18.29376
                            ],
                            [
                                121.8966,
                                18.2697
                            ],
                            [
                                121.64537,
                                18.35852
                            ],
                            [
                                121.52399,
                                18.41096
                            ],
                            [
                                121.36055,
                                18.49788
                            ],
                            [
                                121.22279,
                                18.59402
                            ],
                            [
                                121.13363,
                                18.62982
                            ],
                            [
                                121.03212,
                                18.6164
                            ],
                            [
                                120.95438,
                                18.5618
                            ],
                            [
                                120.90894,
                                18.5673
                            ],
                            [
                                120.85307,
                                18.64378
                            ],
                            [
                                120.79708,
                                18.63246
                            ],
                            [
                                120.76936,
                                18.54777
                            ],
                            [
                                120.7239,
                                18.52799
                            ],
                            [
                                120.62629,
                                18.54556
                            ],
                            [
                                120.56613,
                                18.49548
                            ],
                            [
                                120.59422,
                                18.41057
                            ],
                            [
                                120.59517,
                                18.33135
                            ],
                            [
                                120.52051,
                                18.1959
                            ],
                            [
                                120.47273,
                                18.08402
                            ],
                            [
                                120.49478,
                                17.99758
                            ],
                            [
                                120.43093,
                                17.91187
                            ],
                            [
                                120.45271,
                                17.82346
                            ],
                            [
                                120.40607,
                                17.80041
                            ],
                            [
                                120.43297,
                                17.73493
                            ],
                            [
                                120.3686,
                                17.68457
                            ],
                            [
                                120.33615,
                                17.57078
                            ],
                            [
                                120.41045,
                                17.52201
                            ],
                            [
                                120.45625,
                                17.41388
                            ],
                            [
                                120.42657,
                                17.32911
                            ],
                            [
                                120.41505,
                                17.1989
                            ],
                            [
                                120.44729,
                                17.02455
                            ],
                            [
                                120.44392,
                                16.97773
                            ],
                            [
                                120.39154,
                                16.87475
                            ],
                            [
                                120.3356,
                                16.8325
                            ],
                            [
                                120.34167,
                                16.71077
                            ],
                            [
                                120.29758,
                                16.59918
                            ],
                            [
                                120.32977,
                                16.46272
                            ],
                            [
                                120.3432,
                                16.29701
                            ],
                            [
                                120.40077,
                                16.24502
                            ],
                            [
                                120.42314,
                                16.17832
                            ],
                            [
                                120.32933,
                                16.06651
                            ],
                            [
                                120.17968,
                                16.02973
                            ],
                            [
                                120.10307,
                                16.06364
                            ],
                            [
                                120.09294,
                                16.15769
                            ],
                            [
                                119.90227,
                                16.25016
                            ],
                            [
                                119.92917,
                                16.35504
                            ],
                            [
                                119.88878,
                                16.38924
                            ],
                            [
                                119.78877,
                                16.32449
                            ],
                            [
                                119.75893,
                                16.17411
                            ],
                            [
                                119.77736,
                                16.13051
                            ],
                            [
                                119.75038,
                                15.96549
                            ],
                            [
                                119.76688,
                                15.92648
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                125.59237,
                                5.84392
                            ],
                            [
                                125.68704,
                                5.98628
                            ],
                            [
                                125.71128,
                                6.10694
                            ],
                            [
                                125.6984,
                                6.21932
                            ],
                            [
                                125.63616,
                                6.36275
                            ],
                            [
                                125.58188,
                                6.44349
                            ],
                            [
                                125.55993,
                                6.52818
                            ],
                            [
                                125.44322,
                                6.5918
                            ],
                            [
                                125.38442,
                                6.60568
                            ],
                            [
                                125.37115,
                                6.72056
                            ],
                            [
                                125.3837,
                                6.79987
                            ],
                            [
                                125.48662,
                                6.91922
                            ],
                            [
                                125.48448,
                                6.97196
                            ],
                            [
                                125.55255,
                                7.04666
                            ],
                            [
                                125.6115,
                                7.05847
                            ],
                            [
                                125.65996,
                                7.15978
                            ],
                            [
                                125.65247,
                                7.24351
                            ],
                            [
                                125.69453,
                                7.28895
                            ],
                            [
                                125.81889,
                                7.36543
                            ],
                            [
                                125.84543,
                                7.36152
                            ],
                            [
                                125.83839,
                                7.2539
                            ],
                            [
                                125.88728,
                                7.16677
                            ],
                            [
                                125.88455,
                                7.12279
                            ],
                            [
                                125.98103,
                                7.01483
                            ],
                            [
                                125.97927,
                                6.92167
                            ],
                            [
                                126.0595,
                                6.86479
                            ],
                            [
                                126.09138,
                                6.73551
                            ],
                            [
                                126.06819,
                                6.65733
                            ],
                            [
                                126.08341,
                                6.52728
                            ],
                            [
                                126.14443,
                                6.42042
                            ],
                            [
                                126.13555,
                                6.38346
                            ],
                            [
                                126.1947,
                                6.34913
                            ],
                            [
                                126.21698,
                                6.43831
                            ],
                            [
                                126.21893,
                                6.63695
                            ],
                            [
                                126.2535,
                                6.75243
                            ],
                            [
                                126.15783,
                                6.89058
                            ],
                            [
                                126.18792,
                                6.93975
                            ],
                            [
                                126.29229,
                                6.90203
                            ],
                            [
                                126.33125,
                                6.99948
                            ],
                            [
                                126.3921,
                                6.99323
                            ],
                            [
                                126.44442,
                                7.02052
                            ],
                            [
                                126.47765,
                                7.10937
                            ],
                            [
                                126.5246,
                                7.14869
                            ],
                            [
                                126.59858,
                                7.27628
                            ],
                            [
                                126.55346,
                                7.30978
                            ],
                            [
                                126.59975,
                                7.49989
                            ],
                            [
                                126.56008,
                                7.58205
                            ],
                            [
                                126.55172,
                                7.69693
                            ],
                            [
                                126.44532,
                                7.80663
                            ],
                            [
                                126.38118,
                                7.8335
                            ],
                            [
                                126.35987,
                                7.88796
                            ],
                            [
                                126.40561,
                                7.95899
                            ],
                            [
                                126.44996,
                                8.17838
                            ],
                            [
                                126.44357,
                                8.24837
                            ],
                            [
                                126.34985,
                                8.18933
                            ],
                            [
                                126.3204,
                                8.22771
                            ],
                            [
                                126.38318,
                                8.2979
                            ],
                            [
                                126.33624,
                                8.34579
                            ],
                            [
                                126.37794,
                                8.4087
                            ],
                            [
                                126.38652,
                                8.51694
                            ],
                            [
                                126.2108,
                                8.55962
                            ],
                            [
                                126.14548,
                                8.5328
                            ],
                            [
                                126.10762,
                                8.64766
                            ],
                            [
                                126.19092,
                                8.69637
                            ],
                            [
                                126.24199,
                                8.75835
                            ],
                            [
                                126.29327,
                                8.77572
                            ],
                            [
                                126.33393,
                                8.84486
                            ],
                            [
                                126.32589,
                                8.91744
                            ],
                            [
                                126.16301,
                                9.10304
                            ],
                            [
                                126.1828,
                                9.24433
                            ],
                            [
                                126.12975,
                                9.2669
                            ],
                            [
                                126.05105,
                                9.23899
                            ],
                            [
                                125.98638,
                                9.32215
                            ],
                            [
                                125.97126,
                                9.37585
                            ],
                            [
                                125.89666,
                                9.42214
                            ],
                            [
                                125.93253,
                                9.46088
                            ],
                            [
                                125.86234,
                                9.53923
                            ],
                            [
                                125.74346,
                                9.57096
                            ],
                            [
                                125.60822,
                                9.64192
                            ],
                            [
                                125.55577,
                                9.76499
                            ],
                            [
                                125.46349,
                                9.80185
                            ],
                            [
                                125.39948,
                                9.76462
                            ],
                            [
                                125.39239,
                                9.65365
                            ],
                            [
                                125.44979,
                                9.46925
                            ],
                            [
                                125.47165,
                                9.36763
                            ],
                            [
                                125.50689,
                                9.29791
                            ],
                            [
                                125.53222,
                                9.19409
                            ],
                            [
                                125.53612,
                                9.07081
                            ],
                            [
                                125.51935,
                                9.01336
                            ],
                            [
                                125.42749,
                                8.97691
                            ],
                            [
                                125.28408,
                                8.99402
                            ],
                            [
                                125.18682,
                                9.07402
                            ],
                            [
                                125.17474,
                                9.01021
                            ],
                            [
                                125.18744,
                                8.90765
                            ],
                            [
                                125.16812,
                                8.84981
                            ],
                            [
                                125.09529,
                                8.82774
                            ],
                            [
                                125.0257,
                                8.91853
                            ],
                            [
                                124.88233,
                                9.0037
                            ],
                            [
                                124.80513,
                                9.00179
                            ],
                            [
                                124.77434,
                                8.95806
                            ],
                            [
                                124.79069,
                                8.87956
                            ],
                            [
                                124.74396,
                                8.69027
                            ],
                            [
                                124.76983,
                                8.59379
                            ],
                            [
                                124.75003,
                                8.5007
                            ],
                            [
                                124.70705,
                                8.47602
                            ],
                            [
                                124.65405,
                                8.51633
                            ],
                            [
                                124.5769,
                                8.52417
                            ],
                            [
                                124.44592,
                                8.62051
                            ],
                            [
                                124.31199,
                                8.533
                            ],
                            [
                                124.28455,
                                8.40085
                            ],
                            [
                                124.25124,
                                8.32939
                            ],
                            [
                                124.26236,
                                8.28134
                            ],
                            [
                                124.22848,
                                8.22012
                            ],
                            [
                                124.15997,
                                8.19004
                            ],
                            [
                                124.0324,
                                8.1984
                            ],
                            [
                                123.95903,
                                8.16887
                            ],
                            [
                                123.90423,
                                8.11915
                            ],
                            [
                                123.77447,
                                8.06478
                            ],
                            [
                                123.87105,
                                8.17355
                            ],
                            [
                                123.84082,
                                8.42647
                            ],
                            [
                                123.78904,
                                8.5304
                            ],
                            [
                                123.69398,
                                8.6343
                            ],
                            [
                                123.63069,
                                8.64351
                            ],
                            [
                                123.51175,
                                8.62652
                            ],
                            [
                                123.45946,
                                8.68825
                            ],
                            [
                                123.3991,
                                8.62858
                            ],
                            [
                                123.35747,
                                8.63259
                            ],
                            [
                                123.33139,
                                8.55826
                            ],
                            [
                                123.26965,
                                8.51612
                            ],
                            [
                                123.18967,
                                8.53361
                            ],
                            [
                                123.07149,
                                8.51882
                            ],
                            [
                                122.98238,
                                8.40755
                            ],
                            [
                                122.9887,
                                8.3515
                            ],
                            [
                                122.94352,
                                8.30628
                            ],
                            [
                                122.99444,
                                8.24709
                            ],
                            [
                                122.98663,
                                8.20141
                            ],
                            [
                                122.9215,
                                8.15294
                            ],
                            [
                                122.81626,
                                8.12134
                            ],
                            [
                                122.73514,
                                8.11413
                            ],
                            [
                                122.66418,
                                8.1575
                            ],
                            [
                                122.57476,
                                8.08192
                            ],
                            [
                                122.46202,
                                8.07096
                            ],
                            [
                                122.34807,
                                8.03723
                            ],
                            [
                                122.25493,
                                7.98672
                            ],
                            [
                                122.21889,
                                7.90555
                            ],
                            [
                                122.16362,
                                7.86212
                            ],
                            [
                                122.09339,
                                7.73838
                            ],
                            [
                                122.12835,
                                7.68722
                            ],
                            [
                                122.11126,
                                7.59619
                            ],
                            [
                                122.13106,
                                7.56173
                            ],
                            [
                                122.07569,
                                7.51402
                            ],
                            [
                                122.03348,
                                7.35049
                            ],
                            [
                                122.05501,
                                7.30715
                            ],
                            [
                                121.96065,
                                7.23434
                            ],
                            [
                                121.90112,
                                7.14377
                            ],
                            [
                                121.89893,
                                7.06463
                            ],
                            [
                                121.95207,
                                6.9515
                            ],
                            [
                                122.09744,
                                6.8916
                            ],
                            [
                                122.17915,
                                6.95787
                            ],
                            [
                                122.20702,
                                7.06628
                            ],
                            [
                                122.25019,
                                7.11025
                            ],
                            [
                                122.2515,
                                7.19398
                            ],
                            [
                                122.29347,
                                7.31631
                            ],
                            [
                                122.36668,
                                7.34961
                            ],
                            [
                                122.3547,
                                7.4614
                            ],
                            [
                                122.45448,
                                7.53566
                            ],
                            [
                                122.43526,
                                7.5839
                            ],
                            [
                                122.55082,
                                7.73112
                            ],
                            [
                                122.63611,
                                7.77595
                            ],
                            [
                                122.69991,
                                7.78447
                            ],
                            [
                                122.80444,
                                7.75199
                            ],
                            [
                                122.78656,
                                7.67453
                            ],
                            [
                                122.82783,
                                7.52568
                            ],
                            [
                                122.86767,
                                7.46041
                            ],
                            [
                                122.9006,
                                7.53774
                            ],
                            [
                                122.98939,
                                7.46436
                            ],
                            [
                                123.02873,
                                7.55742
                            ],
                            [
                                123.04402,
                                7.65416
                            ],
                            [
                                123.08478,
                                7.6857
                            ],
                            [
                                123.17342,
                                7.6326
                            ],
                            [
                                123.18002,
                                7.57792
                            ],
                            [
                                123.11295,
                                7.55652
                            ],
                            [
                                123.1187,
                                7.51601
                            ],
                            [
                                123.17817,
                                7.47044
                            ],
                            [
                                123.22263,
                                7.53111
                            ],
                            [
                                123.29512,
                                7.52616
                            ],
                            [
                                123.28932,
                                7.46974
                            ],
                            [
                                123.33161,
                                7.41845
                            ],
                            [
                                123.41367,
                                7.36234
                            ],
                            [
                                123.44263,
                                7.43987
                            ],
                            [
                                123.39702,
                                7.46476
                            ],
                            [
                                123.34628,
                                7.57083
                            ],
                            [
                                123.44976,
                                7.6279
                            ],
                            [
                                123.47781,
                                7.73048
                            ],
                            [
                                123.42948,
                                7.77076
                            ],
                            [
                                123.43185,
                                7.8126
                            ],
                            [
                                123.54311,
                                7.85071
                            ],
                            [
                                123.68639,
                                7.81168
                            ],
                            [
                                123.77761,
                                7.70853
                            ],
                            [
                                123.91563,
                                7.69062
                            ],
                            [
                                124.01769,
                                7.63892
                            ],
                            [
                                124.16578,
                                7.42074
                            ],
                            [
                                124.23471,
                                7.41261
                            ],
                            [
                                124.20441,
                                7.35062
                            ],
                            [
                                124.20433,
                                7.26789
                            ],
                            [
                                124.14788,
                                7.17676
                            ],
                            [
                                124.06141,
                                7.14055
                            ],
                            [
                                124.0003,
                                7.04093
                            ],
                            [
                                123.95741,
                                6.90272
                            ],
                            [
                                123.96032,
                                6.79318
                            ],
                            [
                                124.02997,
                                6.77493
                            ],
                            [
                                124.01826,
                                6.73028
                            ],
                            [
                                124.04823,
                                6.5985
                            ],
                            [
                                124.02089,
                                6.52439
                            ],
                            [
                                124.03622,
                                6.42312
                            ],
                            [
                                124.10415,
                                6.32268
                            ],
                            [
                                124.16298,
                                6.26722
                            ],
                            [
                                124.18198,
                                6.21417
                            ],
                            [
                                124.32055,
                                6.12111
                            ],
                            [
                                124.415,
                                6.09242
                            ],
                            [
                                124.52519,
                                6.02325
                            ],
                            [
                                124.83143,
                                5.88941
                            ],
                            [
                                124.92302,
                                5.86043
                            ],
                            [
                                125.07311,
                                5.86447
                            ],
                            [
                                125.10006,
                                5.95376
                            ],
                            [
                                125.1663,
                                6.10596
                            ],
                            [
                                125.25493,
                                6.09439
                            ],
                            [
                                125.28504,
                                5.97953
                            ],
                            [
                                125.26602,
                                5.92289
                            ],
                            [
                                125.21693,
                                5.89043
                            ],
                            [
                                125.18484,
                                5.77839
                            ],
                            [
                                125.28218,
                                5.69611
                            ],
                            [
                                125.29375,
                                5.58676
                            ],
                            [
                                125.33048,
                                5.55951
                            ],
                            [
                                125.41139,
                                5.57481
                            ],
                            [
                                125.51169,
                                5.74434
                            ],
                            [
                                125.59237,
                                5.84392
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                122.56098,
                                9.47098
                            ],
                            [
                                122.6755,
                                9.38536
                            ],
                            [
                                122.80533,
                                9.3608
                            ],
                            [
                                122.87374,
                                9.31411
                            ],
                            [
                                122.87657,
                                9.24216
                            ],
                            [
                                122.94133,
                                9.07958
                            ],
                            [
                                123.0168,
                                9.03949
                            ],
                            [
                                123.0814,
                                9.0644
                            ],
                            [
                                123.12722,
                                9.04723
                            ],
                            [
                                123.20651,
                                9.09762
                            ],
                            [
                                123.28631,
                                9.20706
                            ],
                            [
                                123.31501,
                                9.31732
                            ],
                            [
                                123.17272,
                                9.52972
                            ],
                            [
                                123.11675,
                                9.55414
                            ],
                            [
                                123.16187,
                                9.70711
                            ],
                            [
                                123.13777,
                                9.83169
                            ],
                            [
                                123.1535,
                                9.8999
                            ],
                            [
                                123.23063,
                                10.00516
                            ],
                            [
                                123.32881,
                                10.25733
                            ],
                            [
                                123.32927,
                                10.34693
                            ],
                            [
                                123.36151,
                                10.43893
                            ],
                            [
                                123.46348,
                                10.52584
                            ],
                            [
                                123.5086,
                                10.70122
                            ],
                            [
                                123.56458,
                                10.80314
                            ],
                            [
                                123.50631,
                                10.93618
                            ],
                            [
                                123.38425,
                                10.95899
                            ],
                            [
                                123.32199,
                                10.95466
                            ],
                            [
                                123.19447,
                                11.00272
                            ],
                            [
                                123.06924,
                                10.91423
                            ],
                            [
                                122.95521,
                                10.89444
                            ],
                            [
                                122.96365,
                                10.73853
                            ],
                            [
                                122.9197,
                                10.6135
                            ],
                            [
                                122.86628,
                                10.55447
                            ],
                            [
                                122.79774,
                                10.52706
                            ],
                            [
                                122.86718,
                                10.36528
                            ],
                            [
                                122.84382,
                                10.29629
                            ],
                            [
                                122.86358,
                                10.0939
                            ],
                            [
                                122.82758,
                                10.06186
                            ],
                            [
                                122.74897,
                                10.04359
                            ],
                            [
                                122.65456,
                                9.97603
                            ],
                            [
                                122.45523,
                                9.97771
                            ],
                            [
                                122.4396,
                                9.91532
                            ],
                            [
                                122.38222,
                                9.84077
                            ],
                            [
                                122.40404,
                                9.75398
                            ],
                            [
                                122.3853,
                                9.7107
                            ],
                            [
                                122.56098,
                                9.47098
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                125.45501,
                                11.9888
                            ],
                            [
                                125.51217,
                                12.05883
                            ],
                            [
                                125.44416,
                                12.12681
                            ],
                            [
                                125.51685,
                                12.19273
                            ],
                            [
                                125.42022,
                                12.28319
                            ],
                            [
                                125.3767,
                                12.27431
                            ],
                            [
                                125.30715,
                                12.32972
                            ],
                            [
                                125.30948,
                                12.3969
                            ],
                            [
                                125.25943,
                                12.49552
                            ],
                            [
                                125.14933,
                                12.57943
                            ],
                            [
                                125.07583,
                                12.57375
                            ],
                            [
                                125.02002,
                                12.60021
                            ],
                            [
                                124.85463,
                                12.53634
                            ],
                            [
                                124.61626,
                                12.51693
                            ],
                            [
                                124.43665,
                                12.53554
                            ],
                            [
                                124.38999,
                                12.5628
                            ],
                            [
                                124.33308,
                                12.54345
                            ],
                            [
                                124.2655,
                                12.55598
                            ],
                            [
                                124.28508,
                                12.47242
                            ],
                            [
                                124.33808,
                                12.37588
                            ],
                            [
                                124.34433,
                                12.29683
                            ],
                            [
                                124.39633,
                                12.19185
                            ],
                            [
                                124.53311,
                                12.06454
                            ],
                            [
                                124.64639,
                                12.04281
                            ],
                            [
                                124.69612,
                                12.00209
                            ],
                            [
                                124.74436,
                                11.90209
                            ],
                            [
                                124.83124,
                                11.83594
                            ],
                            [
                                124.91887,
                                11.74541
                            ],
                            [
                                125.00654,
                                11.78105
                            ],
                            [
                                125.03776,
                                11.75974
                            ],
                            [
                                124.97846,
                                11.67571
                            ],
                            [
                                124.99301,
                                11.6216
                            ],
                            [
                                124.95323,
                                11.57935
                            ],
                            [
                                124.88618,
                                11.57635
                            ],
                            [
                                124.82688,
                                11.51362
                            ],
                            [
                                124.847,
                                11.47
                            ],
                            [
                                124.91316,
                                11.47069
                            ],
                            [
                                124.98868,
                                11.42848
                            ],
                            [
                                124.97456,
                                11.31556
                            ],
                            [
                                125.00473,
                                11.27201
                            ],
                            [
                                125.08707,
                                11.29492
                            ],
                            [
                                125.14631,
                                11.27649
                            ],
                            [
                                125.17473,
                                11.23421
                            ],
                            [
                                125.20846,
                                11.10761
                            ],
                            [
                                125.26999,
                                11.13615
                            ],
                            [
                                125.36002,
                                11.12102
                            ],
                            [
                                125.41128,
                                11.08675
                            ],
                            [
                                125.46451,
                                11.12504
                            ],
                            [
                                125.56738,
                                11.14814
                            ],
                            [
                                125.58061,
                                11.11219
                            ],
                            [
                                125.65981,
                                11.14109
                            ],
                            [
                                125.68731,
                                11.04062
                            ],
                            [
                                125.75705,
                                11.05446
                            ],
                            [
                                125.66,
                                11.20437
                            ],
                            [
                                125.59224,
                                11.18482
                            ],
                            [
                                125.53643,
                                11.20101
                            ],
                            [
                                125.54921,
                                11.26181
                            ],
                            [
                                125.60622,
                                11.3018
                            ],
                            [
                                125.62678,
                                11.36711
                            ],
                            [
                                125.54275,
                                11.41473
                            ],
                            [
                                125.51489,
                                11.49207
                            ],
                            [
                                125.44757,
                                11.60294
                            ],
                            [
                                125.48299,
                                11.67294
                            ],
                            [
                                125.44464,
                                11.78084
                            ],
                            [
                                125.42477,
                                11.90519
                            ],
                            [
                                125.45501,
                                11.9888
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                122.56098,
                                10.69203
                            ],
                            [
                                122.62186,
                                10.7811
                            ],
                            [
                                122.73271,
                                10.78698
                            ],
                            [
                                122.78513,
                                10.85971
                            ],
                            [
                                122.78445,
                                10.98631
                            ],
                            [
                                122.83689,
                                10.99977
                            ],
                            [
                                122.91962,
                                11.05867
                            ],
                            [
                                123.0093,
                                11.09337
                            ],
                            [
                                123.03079,
                                11.16574
                            ],
                            [
                                123.11564,
                                11.16193
                            ],
                            [
                                123.09393,
                                11.22733
                            ],
                            [
                                123.10743,
                                11.30346
                            ],
                            [
                                123.14996,
                                11.39077
                            ],
                            [
                                123.12438,
                                11.56924
                            ],
                            [
                                123.00641,
                                11.49378
                            ],
                            [
                                122.91996,
                                11.48145
                            ],
                            [
                                122.82432,
                                11.61002
                            ],
                            [
                                122.72191,
                                11.58033
                            ],
                            [
                                122.59624,
                                11.51109
                            ],
                            [
                                122.57345,
                                11.56741
                            ],
                            [
                                122.46069,
                                11.63136
                            ],
                            [
                                122.37595,
                                11.73922
                            ],
                            [
                                122.3304,
                                11.73602
                            ],
                            [
                                122.25572,
                                11.79429
                            ],
                            [
                                122.16204,
                                11.82813
                            ],
                            [
                                122.10799,
                                11.82688
                            ],
                            [
                                121.95599,
                                11.93983
                            ],
                            [
                                121.88981,
                                11.90213
                            ],
                            [
                                121.88173,
                                11.81839
                            ],
                            [
                                121.92233,
                                11.76967
                            ],
                            [
                                122.07057,
                                11.74296
                            ],
                            [
                                122.09848,
                                11.70637
                            ],
                            [
                                122.08362,
                                11.51076
                            ],
                            [
                                122.05463,
                                11.46836
                            ],
                            [
                                122.05236,
                                11.25939
                            ],
                            [
                                122.03331,
                                11.18832
                            ],
                            [
                                122.05314,
                                11.03944
                            ],
                            [
                                121.99221,
                                10.93696
                            ],
                            [
                                121.92887,
                                10.76522
                            ],
                            [
                                121.96817,
                                10.72033
                            ],
                            [
                                121.97945,
                                10.6374
                            ],
                            [
                                121.96552,
                                10.56895
                            ],
                            [
                                121.92156,
                                10.50225
                            ],
                            [
                                121.91771,
                                10.44858
                            ],
                            [
                                121.96051,
                                10.418
                            ],
                            [
                                122.06354,
                                10.50346
                            ],
                            [
                                122.09714,
                                10.57607
                            ],
                            [
                                122.27434,
                                10.65603
                            ],
                            [
                                122.47812,
                                10.68887
                            ],
                            [
                                122.56098,
                                10.69203
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                118.01792,
                                8.90981
                            ],
                            [
                                118.09919,
                                9.05622
                            ],
                            [
                                118.12469,
                                9.14101
                            ],
                            [
                                118.28864,
                                9.18201
                            ],
                            [
                                118.34379,
                                9.18241
                            ],
                            [
                                118.43072,
                                9.27877
                            ],
                            [
                                118.48937,
                                9.30169
                            ],
                            [
                                118.53674,
                                9.39098
                            ],
                            [
                                118.65446,
                                9.55407
                            ],
                            [
                                118.74594,
                                9.66549
                            ],
                            [
                                118.69725,
                                9.71833
                            ],
                            [
                                118.76936,
                                9.73481
                            ],
                            [
                                118.73986,
                                9.89442
                            ],
                            [
                                118.78332,
                                9.94304
                            ],
                            [
                                118.85984,
                                9.97582
                            ],
                            [
                                118.97381,
                                9.98308
                            ],
                            [
                                119.19928,
                                10.05081
                            ],
                            [
                                119.2304,
                                10.17518
                            ],
                            [
                                119.32115,
                                10.31041
                            ],
                            [
                                119.456,
                                10.37526
                            ],
                            [
                                119.56653,
                                10.37681
                            ],
                            [
                                119.58287,
                                10.41348
                            ],
                            [
                                119.70663,
                                10.50384
                            ],
                            [
                                119.63176,
                                10.6252
                            ],
                            [
                                119.5789,
                                10.66623
                            ],
                            [
                                119.59926,
                                10.72876
                            ],
                            [
                                119.59223,
                                10.83038
                            ],
                            [
                                119.51376,
                                10.83342
                            ],
                            [
                                119.48908,
                                10.8906
                            ],
                            [
                                119.49584,
                                10.99423
                            ],
                            [
                                119.56502,
                                11.01781
                            ],
                            [
                                119.50331,
                                11.1318
                            ],
                            [
                                119.55364,
                                11.22002
                            ],
                            [
                                119.56512,
                                11.29374
                            ],
                            [
                                119.50993,
                                11.33421
                            ],
                            [
                                119.50276,
                                11.41217
                            ],
                            [
                                119.41276,
                                11.31279
                            ],
                            [
                                119.41975,
                                11.2299
                            ],
                            [
                                119.38162,
                                11.17362
                            ],
                            [
                                119.41881,
                                11.13807
                            ],
                            [
                                119.41092,
                                11.05122
                            ],
                            [
                                119.30387,
                                11.00449
                            ],
                            [
                                119.33586,
                                10.89569
                            ],
                            [
                                119.43274,
                                10.84713
                            ],
                            [
                                119.45517,
                                10.74576
                            ],
                            [
                                119.39533,
                                10.76065
                            ],
                            [
                                119.31513,
                                10.84024
                            ],
                            [
                                119.25563,
                                10.83108
                            ],
                            [
                                119.2729,
                                10.77231
                            ],
                            [
                                119.33942,
                                10.73206
                            ],
                            [
                                119.31547,
                                10.59445
                            ],
                            [
                                119.13612,
                                10.39084
                            ],
                            [
                                119.07154,
                                10.41924
                            ],
                            [
                                118.99119,
                                10.40677
                            ],
                            [
                                119.02184,
                                10.34408
                            ],
                            [
                                118.94421,
                                10.26255
                            ],
                            [
                                118.93316,
                                10.20992
                            ],
                            [
                                118.86545,
                                10.20696
                            ],
                            [
                                118.80341,
                                10.17388
                            ],
                            [
                                118.8268,
                                10.10381
                            ],
                            [
                                118.80188,
                                10.03241
                            ],
                            [
                                118.71783,
                                10.03778
                            ],
                            [
                                118.64801,
                                9.99851
                            ],
                            [
                                118.60468,
                                9.91182
                            ],
                            [
                                118.50932,
                                9.7634
                            ],
                            [
                                118.44485,
                                9.72552
                            ],
                            [
                                118.40338,
                                9.66726
                            ],
                            [
                                118.33345,
                                9.63572
                            ],
                            [
                                118.32876,
                                9.58736
                            ],
                            [
                                118.20933,
                                9.4859
                            ],
                            [
                                118.17921,
                                9.4117
                            ],
                            [
                                118.13093,
                                9.3967
                            ],
                            [
                                118.12092,
                                9.34468
                            ],
                            [
                                118.01571,
                                9.24718
                            ],
                            [
                                117.91978,
                                9.26374
                            ],
                            [
                                117.7782,
                                9.16754
                            ],
                            [
                                117.74582,
                                9.07248
                            ],
                            [
                                117.68907,
                                9.08541
                            ],
                            [
                                117.64026,
                                9.0531
                            ],
                            [
                                117.61555,
                                8.99528
                            ],
                            [
                                117.54999,
                                8.95286
                            ],
                            [
                                117.42061,
                                8.75975
                            ],
                            [
                                117.34652,
                                8.72704
                            ],
                            [
                                117.21868,
                                8.52393
                            ],
                            [
                                117.2114,
                                8.44603
                            ],
                            [
                                117.17696,
                                8.3745
                            ],
                            [
                                117.20074,
                                8.33376
                            ],
                            [
                                117.26079,
                                8.41016
                            ],
                            [
                                117.37238,
                                8.49107
                            ],
                            [
                                117.49538,
                                8.50366
                            ],
                            [
                                117.5393,
                                8.57463
                            ],
                            [
                                117.56391,
                                8.66731
                            ],
                            [
                                117.6294,
                                8.65736
                            ],
                            [
                                117.74231,
                                8.68765
                            ],
                            [
                                117.88216,
                                8.82172
                            ],
                            [
                                117.99898,
                                8.88273
                            ],
                            [
                                118.01792,
                                8.90981
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                121.1252,
                                12.24415
                            ],
                            [
                                121.20108,
                                12.23984
                            ],
                            [
                                121.24433,
                                12.21256
                            ],
                            [
                                121.27457,
                                12.28257
                            ],
                            [
                                121.38707,
                                12.31432
                            ],
                            [
                                121.41163,
                                12.44755
                            ],
                            [
                                121.44338,
                                12.52158
                            ],
                            [
                                121.50727,
                                12.55706
                            ],
                            [
                                121.55644,
                                12.61579
                            ],
                            [
                                121.54734,
                                12.67405
                            ],
                            [
                                121.47831,
                                12.77843
                            ],
                            [
                                121.49739,
                                12.94593
                            ],
                            [
                                121.48572,
                                13.01281
                            ],
                            [
                                121.55769,
                                13.12054
                            ],
                            [
                                121.5099,
                                13.14991
                            ],
                            [
                                121.4432,
                                13.14365
                            ],
                            [
                                121.43974,
                                13.2238
                            ],
                            [
                                121.38034,
                                13.24419
                            ],
                            [
                                121.29858,
                                13.35032
                            ],
                            [
                                121.20649,
                                13.42251
                            ],
                            [
                                121.06655,
                                13.4065
                            ],
                            [
                                120.92163,
                                13.5133
                            ],
                            [
                                120.77752,
                                13.46662
                            ],
                            [
                                120.55986,
                                13.51035
                            ],
                            [
                                120.47625,
                                13.50704
                            ],
                            [
                                120.41629,
                                13.52988
                            ],
                            [
                                120.35,
                                13.50918
                            ],
                            [
                                120.29838,
                                13.4421
                            ],
                            [
                                120.34397,
                                13.38307
                            ],
                            [
                                120.46015,
                                13.41427
                            ],
                            [
                                120.47988,
                                13.29382
                            ],
                            [
                                120.54403,
                                13.22908
                            ],
                            [
                                120.63913,
                                13.19342
                            ],
                            [
                                120.6886,
                                13.13502
                            ],
                            [
                                120.76467,
                                12.99983
                            ],
                            [
                                120.78273,
                                12.90263
                            ],
                            [
                                120.77115,
                                12.84591
                            ],
                            [
                                120.79527,
                                12.7278
                            ],
                            [
                                120.8537,
                                12.7215
                            ],
                            [
                                120.93482,
                                12.57588
                            ],
                            [
                                120.91878,
                                12.52985
                            ],
                            [
                                120.97477,
                                12.42838
                            ],
                            [
                                121.03157,
                                12.36825
                            ],
                            [
                                121.09825,
                                12.33179
                            ],
                            [
                                121.1252,
                                12.24415
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                125.25842,
                                10.35596
                            ],
                            [
                                125.18572,
                                10.4314
                            ],
                            [
                                125.1694,
                                10.52908
                            ],
                            [
                                125.18935,
                                10.58987
                            ],
                            [
                                125.11509,
                                10.66235
                            ],
                            [
                                125.11435,
                                10.70001
                            ],
                            [
                                125.0152,
                                10.75666
                            ],
                            [
                                125.00616,
                                10.82721
                            ],
                            [
                                125.04216,
                                10.9841
                            ],
                            [
                                125.04113,
                                11.06285
                            ],
                            [
                                125.00705,
                                11.15091
                            ],
                            [
                                125.027,
                                11.2009
                            ],
                            [
                                124.97877,
                                11.25902
                            ],
                            [
                                124.96325,
                                11.31616
                            ],
                            [
                                124.98043,
                                11.39907
                            ],
                            [
                                124.82043,
                                11.43091
                            ],
                            [
                                124.80627,
                                11.38567
                            ],
                            [
                                124.70091,
                                11.30576
                            ],
                            [
                                124.5896,
                                11.30794
                            ],
                            [
                                124.55231,
                                11.34562
                            ],
                            [
                                124.52678,
                                11.43366
                            ],
                            [
                                124.45035,
                                11.41947
                            ],
                            [
                                124.40788,
                                11.48106
                            ],
                            [
                                124.31789,
                                11.56381
                            ],
                            [
                                124.28795,
                                11.52905
                            ],
                            [
                                124.34303,
                                11.31915
                            ],
                            [
                                124.40156,
                                11.24089
                            ],
                            [
                                124.38753,
                                11.17568
                            ],
                            [
                                124.4042,
                                11.1186
                            ],
                            [
                                124.37608,
                                11.06471
                            ],
                            [
                                124.43611,
                                10.91757
                            ],
                            [
                                124.51278,
                                10.86452
                            ],
                            [
                                124.55061,
                                10.92789
                            ],
                            [
                                124.54202,
                                10.97457
                            ],
                            [
                                124.61318,
                                10.99711
                            ],
                            [
                                124.68543,
                                10.93249
                            ],
                            [
                                124.78805,
                                10.77072
                            ],
                            [
                                124.80515,
                                10.6637
                            ],
                            [
                                124.77251,
                                10.61936
                            ],
                            [
                                124.76792,
                                10.54268
                            ],
                            [
                                124.72606,
                                10.48587
                            ],
                            [
                                124.72803,
                                10.39868
                            ],
                            [
                                124.79531,
                                10.31351
                            ],
                            [
                                124.75668,
                                10.18518
                            ],
                            [
                                124.80816,
                                10.13149
                            ],
                            [
                                124.88759,
                                10.12461
                            ],
                            [
                                124.97893,
                                10.04097
                            ],
                            [
                                125.03044,
                                10.04528
                            ],
                            [
                                124.98199,
                                10.21384
                            ],
                            [
                                124.97526,
                                10.33404
                            ],
                            [
                                125.02762,
                                10.36289
                            ],
                            [
                                125.08391,
                                10.22485
                            ],
                            [
                                125.12524,
                                10.17094
                            ],
                            [
                                125.13868,
                                10.06813
                            ],
                            [
                                125.18727,
                                10.03873
                            ],
                            [
                                125.27083,
                                9.90937
                            ],
                            [
                                125.29981,
                                9.93129
                            ],
                            [
                                125.21566,
                                10.12695
                            ],
                            [
                                125.14004,
                                10.17841
                            ],
                            [
                                125.1336,
                                10.27541
                            ],
                            [
                                125.20984,
                                10.24947
                            ],
                            [
                                125.2588,
                                10.2649
                            ],
                            [
                                125.25842,
                                10.35596
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                124.03475,
                                10.52908
                            ],
                            [
                                124.00777,
                                10.75641
                            ],
                            [
                                124.05248,
                                10.88666
                            ],
                            [
                                124.03309,
                                10.93851
                            ],
                            [
                                124.03952,
                                11.05254
                            ],
                            [
                                123.98276,
                                11.07587
                            ],
                            [
                                124.03324,
                                11.14402
                            ],
                            [
                                124.0577,
                                11.27926
                            ],
                            [
                                124.00191,
                                11.27042
                            ],
                            [
                                123.95834,
                                11.20226
                            ],
                            [
                                123.90779,
                                11.03443
                            ],
                            [
                                123.93196,
                                10.99537
                            ],
                            [
                                123.8332,
                                10.74048
                            ],
                            [
                                123.80332,
                                10.72207
                            ],
                            [
                                123.71369,
                                10.56635
                            ],
                            [
                                123.7127,
                                10.50267
                            ],
                            [
                                123.66538,
                                10.41946
                            ],
                            [
                                123.58667,
                                10.33589
                            ],
                            [
                                123.57787,
                                10.25562
                            ],
                            [
                                123.51366,
                                10.14869
                            ],
                            [
                                123.414,
                                10.04853
                            ],
                            [
                                123.39814,
                                9.88
                            ],
                            [
                                123.34676,
                                9.78392
                            ],
                            [
                                123.30145,
                                9.51183
                            ],
                            [
                                123.30611,
                                9.42161
                            ],
                            [
                                123.3495,
                                9.41771
                            ],
                            [
                                123.47029,
                                9.57097
                            ],
                            [
                                123.5376,
                                9.75806
                            ],
                            [
                                123.54009,
                                9.80083
                            ],
                            [
                                123.61159,
                                9.87858
                            ],
                            [
                                123.62063,
                                10.00551
                            ],
                            [
                                123.64557,
                                10.08078
                            ],
                            [
                                123.77485,
                                10.22662
                            ],
                            [
                                123.86036,
                                10.24676
                            ],
                            [
                                123.8791,
                                10.28339
                            ],
                            [
                                123.99139,
                                10.35674
                            ],
                            [
                                124.03475,
                                10.52908
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                124.5232,
                                9.84358
                            ],
                            [
                                124.56476,
                                9.8711
                            ],
                            [
                                124.55286,
                                9.93041
                            ],
                            [
                                124.56869,
                                10.025
                            ],
                            [
                                124.39087,
                                10.11257
                            ],
                            [
                                124.32348,
                                10.15968
                            ],
                            [
                                124.15185,
                                10.15064
                            ],
                            [
                                124.13615,
                                10.11061
                            ],
                            [
                                124.06326,
                                10.0659
                            ],
                            [
                                124.05204,
                                9.99411
                            ],
                            [
                                123.86938,
                                9.91153
                            ],
                            [
                                123.78836,
                                9.79203
                            ],
                            [
                                123.79378,
                                9.73785
                            ],
                            [
                                123.86423,
                                9.7178
                            ],
                            [
                                123.84735,
                                9.67285
                            ],
                            [
                                123.88658,
                                9.62718
                            ],
                            [
                                124.08819,
                                9.59138
                            ],
                            [
                                124.18342,
                                9.61242
                            ],
                            [
                                124.24506,
                                9.60049
                            ],
                            [
                                124.39891,
                                9.65992
                            ],
                            [
                                124.41164,
                                9.71273
                            ],
                            [
                                124.50003,
                                9.76138
                            ],
                            [
                                124.57824,
                                9.73438
                            ],
                            [
                                124.59393,
                                9.81285
                            ],
                            [
                                124.5232,
                                9.84358
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                123.21667,
                                11.95974
                            ],
                            [
                                123.29691,
                                12.02399
                            ],
                            [
                                123.42472,
                                12.1994
                            ],
                            [
                                123.53816,
                                12.20665
                            ],
                            [
                                123.59405,
                                12.14264
                            ],
                            [
                                123.60772,
                                12.07539
                            ],
                            [
                                123.72763,
                                11.99103
                            ],
                            [
                                123.72982,
                                11.93399
                            ],
                            [
                                123.86225,
                                11.90502
                            ],
                            [
                                124.01043,
                                11.79145
                            ],
                            [
                                124.05709,
                                11.80006
                            ],
                            [
                                124.06869,
                                11.85715
                            ],
                            [
                                124.00233,
                                11.98997
                            ],
                            [
                                124.00857,
                                12.02555
                            ],
                            [
                                123.9236,
                                12.15071
                            ],
                            [
                                123.80562,
                                12.24574
                            ],
                            [
                                123.77425,
                                12.2141
                            ],
                            [
                                123.69513,
                                12.33367
                            ],
                            [
                                123.64986,
                                12.34765
                            ],
                            [
                                123.52637,
                                12.45767
                            ],
                            [
                                123.43329,
                                12.52223
                            ],
                            [
                                123.35553,
                                12.49512
                            ],
                            [
                                123.31355,
                                12.57756
                            ],
                            [
                                123.23361,
                                12.58535
                            ],
                            [
                                123.25038,
                                12.46293
                            ],
                            [
                                123.28285,
                                12.43907
                            ],
                            [
                                123.265,
                                12.3399
                            ],
                            [
                                123.22012,
                                12.25606
                            ],
                            [
                                123.26184,
                                12.24448
                            ],
                            [
                                123.27596,
                                12.15875
                            ],
                            [
                                123.21468,
                                12.12439
                            ],
                            [
                                123.1894,
                                12.01512
                            ],
                            [
                                123.21667,
                                11.95974
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                124.02583,
                                13.66303
                            ],
                            [
                                124.05852,
                                13.61374
                            ],
                            [
                                124.18839,
                                13.52238
                            ],
                            [
                                124.23191,
                                13.58639
                            ],
                            [
                                124.34856,
                                13.59694
                            ],
                            [
                                124.34556,
                                13.64721
                            ],
                            [
                                124.41381,
                                13.66878
                            ],
                            [
                                124.39091,
                                13.73261
                            ],
                            [
                                124.42139,
                                13.79779
                            ],
                            [
                                124.40611,
                                13.88348
                            ],
                            [
                                124.30543,
                                13.92355
                            ],
                            [
                                124.26124,
                                14.03578
                            ],
                            [
                                124.21697,
                                14.08055
                            ],
                            [
                                124.12347,
                                14.05046
                            ],
                            [
                                124.14627,
                                13.92904
                            ],
                            [
                                124.1342,
                                13.80053
                            ],
                            [
                                124.09148,
                                13.70415
                            ],
                            [
                                124.02583,
                                13.66303
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                121.79324,
                                6.62907
                            ],
                            [
                                121.79569,
                                6.59812
                            ],
                            [
                                121.87596,
                                6.55468
                            ],
                            [
                                121.86443,
                                6.51357
                            ],
                            [
                                121.9625,
                                6.40431
                            ],
                            [
                                122.04326,
                                6.41026
                            ],
                            [
                                122.19367,
                                6.46779
                            ],
                            [
                                122.21411,
                                6.58041
                            ],
                            [
                                122.30198,
                                6.59053
                            ],
                            [
                                122.30231,
                                6.64385
                            ],
                            [
                                122.1365,
                                6.67714
                            ],
                            [
                                122.06445,
                                6.74862
                            ],
                            [
                                121.98001,
                                6.75364
                            ],
                            [
                                121.93565,
                                6.67289
                            ],
                            [
                                121.85016,
                                6.67917
                            ],
                            [
                                121.79324,
                                6.62907
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                120.31983,
                                12.04281
                            ],
                            [
                                120.32215,
                                12.09425
                            ],
                            [
                                120.25749,
                                12.12552
                            ],
                            [
                                120.16511,
                                12.12017
                            ],
                            [
                                120.0903,
                                12.17193
                            ],
                            [
                                120.00471,
                                12.25666
                            ],
                            [
                                119.94274,
                                12.26893
                            ],
                            [
                                119.91761,
                                12.31891
                            ],
                            [
                                119.86748,
                                12.31372
                            ],
                            [
                                119.85913,
                                12.25261
                            ],
                            [
                                119.9807,
                                12.00842
                            ],
                            [
                                120.13368,
                                12.02618
                            ],
                            [
                                120.22276,
                                11.98969
                            ],
                            [
                                120.33284,
                                11.99556
                            ],
                            [
                                120.31983,
                                12.04281
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                121.81198,
                                13.45233
                            ],
                            [
                                121.82212,
                                13.34163
                            ],
                            [
                                121.86785,
                                13.2837
                            ],
                            [
                                121.94719,
                                13.25069
                            ],
                            [
                                121.98037,
                                13.2089
                            ],
                            [
                                122.03623,
                                13.20337
                            ],
                            [
                                122.07456,
                                13.30594
                            ],
                            [
                                122.14968,
                                13.36722
                            ],
                            [
                                122.05499,
                                13.47623
                            ],
                            [
                                122.03053,
                                13.53042
                            ],
                            [
                                121.85964,
                                13.52063
                            ],
                            [
                                121.81198,
                                13.45233
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                121.19059,
                                5.94494
                            ],
                            [
                                121.2358,
                                5.89488
                            ],
                            [
                                121.30394,
                                5.88138
                            ],
                            [
                                121.4286,
                                5.96786
                            ],
                            [
                                121.41554,
                                5.99634
                            ],
                            [
                                121.2936,
                                6.01824
                            ],
                            [
                                121.21323,
                                5.99501
                            ],
                            [
                                121.15168,
                                6.07698
                            ],
                            [
                                121.03233,
                                6.0893
                            ],
                            [
                                120.91237,
                                6.0243
                            ],
                            [
                                120.8708,
                                5.94906
                            ],
                            [
                                120.92271,
                                5.89254
                            ],
                            [
                                121.02682,
                                5.92369
                            ],
                            [
                                121.05963,
                                5.88675
                            ],
                            [
                                121.19059,
                                5.94494
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                125.63491,
                                10.46983
                            ],
                            [
                                125.60018,
                                10.37187
                            ],
                            [
                                125.55073,
                                10.3664
                            ],
                            [
                                125.52021,
                                10.32066
                            ],
                            [
                                125.51836,
                                10.24193
                            ],
                            [
                                125.48415,
                                10.11462
                            ],
                            [
                                125.50391,
                                10.07453
                            ],
                            [
                                125.58503,
                                10.0803
                            ],
                            [
                                125.57393,
                                10.02214
                            ],
                            [
                                125.64357,
                                9.93046
                            ],
                            [
                                125.69514,
                                10.05877
                            ],
                            [
                                125.65106,
                                10.1799
                            ],
                            [
                                125.6503,
                                10.30475
                            ],
                            [
                                125.67927,
                                10.39276
                            ],
                            [
                                125.63491,
                                10.46983
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                121.9216,
                                12.30264
                            ],
                            [
                                122.01352,
                                12.23904
                            ],
                            [
                                121.9691,
                                12.21051
                            ],
                            [
                                122.00453,
                                12.12314
                            ],
                            [
                                122.04657,
                                12.17778
                            ],
                            [
                                122.04364,
                                12.2266
                            ],
                            [
                                122.08628,
                                12.31448
                            ],
                            [
                                122.1164,
                                12.51471
                            ],
                            [
                                122.13788,
                                12.54426
                            ],
                            [
                                122.11276,
                                12.65489
                            ],
                            [
                                121.99987,
                                12.59567
                            ],
                            [
                                122.01514,
                                12.4929
                            ],
                            [
                                121.97698,
                                12.4021
                            ],
                            [
                                121.94135,
                                12.38751
                            ],
                            [
                                121.9216,
                                12.30264
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                121.80158,
                                14.9337
                            ],
                            [
                                121.84931,
                                14.92294
                            ],
                            [
                                121.87865,
                                14.83453
                            ],
                            [
                                121.93777,
                                14.72013
                            ],
                            [
                                121.90288,
                                14.68684
                            ],
                            [
                                121.93249,
                                14.63019
                            ],
                            [
                                121.97664,
                                14.64373
                            ],
                            [
                                122.0337,
                                14.71528
                            ],
                            [
                                122.01837,
                                14.81318
                            ],
                            [
                                121.96538,
                                14.89145
                            ],
                            [
                                121.98923,
                                14.95811
                            ],
                            [
                                122.04639,
                                15.00535
                            ],
                            [
                                121.9523,
                                15.0566
                            ],
                            [
                                121.83929,
                                15.0369
                            ],
                            [
                                121.80158,
                                14.9337
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                119.81829,
                                5.08539
                            ],
                            [
                                119.85229,
                                5.05122
                            ],
                            [
                                119.96344,
                                5.08403
                            ],
                            [
                                120.03685,
                                5.17756
                            ],
                            [
                                120.09424,
                                5.15279
                            ],
                            [
                                120.11821,
                                5.18893
                            ],
                            [
                                120.18492,
                                5.13034
                            ],
                            [
                                120.21935,
                                5.14296
                            ],
                            [
                                120.24959,
                                5.22322
                            ],
                            [
                                120.21835,
                                5.32859
                            ],
                            [
                                120.16913,
                                5.34092
                            ],
                            [
                                120.02167,
                                5.23018
                            ],
                            [
                                119.97768,
                                5.23649
                            ],
                            [
                                119.88921,
                                5.16248
                            ],
                            [
                                119.83799,
                                5.15262
                            ],
                            [
                                119.81829,
                                5.08539
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                122.56098,
                                10.43371
                            ],
                            [
                                122.64439,
                                10.45349
                            ],
                            [
                                122.68259,
                                10.50763
                            ],
                            [
                                122.72662,
                                10.62009
                            ],
                            [
                                122.71058,
                                10.72214
                            ],
                            [
                                122.6617,
                                10.75646
                            ],
                            [
                                122.61516,
                                10.69055
                            ],
                            [
                                122.52812,
                                10.61778
                            ],
                            [
                                122.48023,
                                10.50424
                            ],
                            [
                                122.5237,
                                10.40933
                            ],
                            [
                                122.56098,
                                10.43371
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                124.56191,
                                11.47478
                            ],
                            [
                                124.60816,
                                11.49514
                            ],
                            [
                                124.53574,
                                11.67687
                            ],
                            [
                                124.46504,
                                11.708
                            ],
                            [
                                124.37286,
                                11.69478
                            ],
                            [
                                124.35043,
                                11.66705
                            ],
                            [
                                124.39147,
                                11.56281
                            ],
                            [
                                124.44832,
                                11.4831
                            ],
                            [
                                124.56191,
                                11.47478
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                122.43231,
                                12.46259
                            ],
                            [
                                122.431,
                                12.41615
                            ],
                            [
                                122.52019,
                                12.37041
                            ],
                            [
                                122.55878,
                                12.31176
                            ],
                            [
                                122.61905,
                                12.28579
                            ],
                            [
                                122.68037,
                                12.32598
                            ],
                            [
                                122.69749,
                                12.39774
                            ],
                            [
                                122.63064,
                                12.49416
                            ],
                            [
                                122.484,
                                12.49981
                            ],
                            [
                                122.43231,
                                12.46259
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                125.95274,
                                9.84574
                            ],
                            [
                                126.01518,
                                9.76275
                            ],
                            [
                                126.10235,
                                9.75088
                            ],
                            [
                                126.16027,
                                9.7857
                            ],
                            [
                                126.08468,
                                10.01215
                            ],
                            [
                                126.03486,
                                10.00412
                            ],
                            [
                                125.97655,
                                9.92279
                            ],
                            [
                                125.95274,
                                9.84574
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                122.93252,
                                13.10899
                            ],
                            [
                                122.98762,
                                13.00976
                            ],
                            [
                                123.06341,
                                13.00152
                            ],
                            [
                                123.07446,
                                12.96036
                            ],
                            [
                                123.16995,
                                12.88614
                            ],
                            [
                                123.19843,
                                12.84399
                            ],
                            [
                                123.28654,
                                12.82243
                            ],
                            [
                                123.27503,
                                12.89287
                            ],
                            [
                                123.17914,
                                12.91756
                            ],
                            [
                                123.13235,
                                13.00875
                            ],
                            [
                                123.0343,
                                13.1398
                            ],
                            [
                                122.95235,
                                13.14394
                            ],
                            [
                                122.93252,
                                13.10899
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                119.84526,
                                11.95155
                            ],
                            [
                                119.93739,
                                11.73023
                            ],
                            [
                                119.95243,
                                11.66354
                            ],
                            [
                                120.0474,
                                11.72323
                            ],
                            [
                                120.06979,
                                11.86523
                            ],
                            [
                                119.95203,
                                11.91585
                            ],
                            [
                                119.89875,
                                11.98326
                            ],
                            [
                                119.84526,
                                11.95155
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                123.58338,
                                12.63196
                            ],
                            [
                                123.63546,
                                12.54442
                            ],
                            [
                                123.78546,
                                12.34221
                            ],
                            [
                                123.76771,
                                12.49958
                            ],
                            [
                                123.72823,
                                12.61191
                            ],
                            [
                                123.63089,
                                12.68905
                            ],
                            [
                                123.58338,
                                12.63196
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                119.76688,
                                10.49258
                            ],
                            [
                                119.81422,
                                10.44616
                            ],
                            [
                                119.91535,
                                10.47649
                            ],
                            [
                                120.00436,
                                10.56657
                            ],
                            [
                                119.98804,
                                10.59686
                            ],
                            [
                                119.83609,
                                10.6214
                            ],
                            [
                                119.76409,
                                10.53334
                            ],
                            [
                                119.76688,
                                10.49258
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                123.45519,
                                9.19133
                            ],
                            [
                                123.5626,
                                9.10082
                            ],
                            [
                                123.68923,
                                9.12389
                            ],
                            [
                                123.6491,
                                9.28199
                            ],
                            [
                                123.56012,
                                9.22758
                            ],
                            [
                                123.45519,
                                9.19133
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                116.94833,
                                7.91484
                            ],
                            [
                                116.9954,
                                7.83472
                            ],
                            [
                                117.05709,
                                7.83442
                            ],
                            [
                                117.08825,
                                7.9007
                            ],
                            [
                                117.07245,
                                8.07406
                            ],
                            [
                                116.99977,
                                8.06388
                            ],
                            [
                                116.95765,
                                8.0
                            ],
                            [
                                116.94833,
                                7.91484
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                124.63335,
                                9.18506
                            ],
                            [
                                124.69319,
                                9.1114
                            ],
                            [
                                124.78197,
                                9.08057
                            ],
                            [
                                124.80804,
                                9.12532
                            ],
                            [
                                124.78357,
                                9.20138
                            ],
                            [
                                124.74516,
                                9.2446
                            ],
                            [
                                124.67683,
                                9.25639
                            ],
                            [
                                124.63335,
                                9.18506
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                125.66113,
                                7.10281
                            ],
                            [
                                125.70895,
                                7.07222
                            ],
                            [
                                125.72308,
                                6.96359
                            ],
                            [
                                125.78855,
                                6.93966
                            ],
                            [
                                125.77479,
                                7.02515
                            ],
                            [
                                125.79662,
                                7.117
                            ],
                            [
                                125.76145,
                                7.16412
                            ],
                            [
                                125.69267,
                                7.18622
                            ],
                            [
                                125.66113,
                                7.10281
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                121.34931,
                                19.35994
                            ],
                            [
                                121.39262,
                                19.30237
                            ],
                            [
                                121.50792,
                                19.25005
                            ],
                            [
                                121.54132,
                                19.27685
                            ],
                            [
                                121.53269,
                                19.35215
                            ],
                            [
                                121.40895,
                                19.39441
                            ],
                            [
                                121.34931,
                                19.35994
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                120.07826,
                                13.84524
                            ],
                            [
                                120.10126,
                                13.78662
                            ],
                            [
                                120.16671,
                                13.74302
                            ],
                            [
                                120.25435,
                                13.73402
                            ],
                            [
                                120.24931,
                                13.79061
                            ],
                            [
                                120.14599,
                                13.85204
                            ],
                            [
                                120.07826,
                                13.84524
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                122.78243,
                                7.35709
                            ],
                            [
                                122.8072,
                                7.30869
                            ],
                            [
                                122.89522,
                                7.31768
                            ],
                            [
                                122.93826,
                                7.37272
                            ],
                            [
                                122.93275,
                                7.4224
                            ],
                            [
                                122.80776,
                                7.42723
                            ],
                            [
                                122.78243,
                                7.35709
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                121.91028,
                                14.19812
                            ],
                            [
                                121.99262,
                                14.10693
                            ],
                            [
                                122.16411,
                                14.0008
                            ],
                            [
                                122.18284,
                                14.02832
                            ],
                            [
                                121.92902,
                                14.23255
                            ],
                            [
                                121.91028,
                                14.19812
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                121.82708,
                                18.8618
                            ],
                            [
                                121.89356,
                                18.86951
                            ],
                            [
                                121.98367,
                                18.9394
                            ],
                            [
                                121.94473,
                                19.00125
                            ],
                            [
                                121.86824,
                                18.97471
                            ],
                            [
                                121.8645,
                                18.8839
                            ],
                            [
                                121.82708,
                                18.8618
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                125.96072,
                                9.69597
                            ],
                            [
                                125.90875,
                                9.7206
                            ],
                            [
                                125.91624,
                                9.58773
                            ],
                            [
                                125.96474,
                                9.57411
                            ],
                            [
                                125.98966,
                                9.65116
                            ],
                            [
                                125.96072,
                                9.69597
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                117.25898,
                                8.21645
                            ],
                            [
                                117.29332,
                                8.18081
                            ],
                            [
                                117.34688,
                                8.21114
                            ],
                            [
                                117.34363,
                                8.30602
                            ],
                            [
                                117.27324,
                                8.32025
                            ],
                            [
                                117.25898,
                                8.21645
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                123.68786,
                                11.22208
                            ],
                            [
                                123.72367,
                                11.13634
                            ],
                            [
                                123.80658,
                                11.16853
                            ],
                            [
                                123.77022,
                                11.20836
                            ],
                            [
                                123.75082,
                                11.28375
                            ],
                            [
                                123.68786,
                                11.22208
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                124.38799,
                                10.64951
                            ],
                            [
                                124.49464,
                                10.63829
                            ],
                            [
                                124.48833,
                                10.70024
                            ],
                            [
                                124.41343,
                                10.71088
                            ],
                            [
                                124.38799,
                                10.64951
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                125.66238,
                                10.78879
                            ],
                            [
                                125.66932,
                                10.75322
                            ],
                            [
                                125.75441,
                                10.69167
                            ],
                            [
                                125.72626,
                                10.79134
                            ],
                            [
                                125.66238,
                                10.78879
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                124.27406,
                                10.59776
                            ],
                            [
                                124.38372,
                                10.62424
                            ],
                            [
                                124.37891,
                                10.68647
                            ],
                            [
                                124.31047,
                                10.70184
                            ],
                            [
                                124.27406,
                                10.59776
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                121.2766,
                                18.85985
                            ],
                            [
                                121.29528,
                                18.84315
                            ],
                            [
                                121.44602,
                                18.85608
                            ],
                            [
                                121.41563,
                                18.90716
                            ],
                            [
                                121.2766,
                                18.85985
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                122.09496,
                                14.84094
                            ],
                            [
                                122.10856,
                                14.80409
                            ],
                            [
                                122.22993,
                                14.75046
                            ],
                            [
                                122.23225,
                                14.78954
                            ],
                            [
                                122.09496,
                                14.84094
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                123.72188,
                                9.59124
                            ],
                            [
                                123.75594,
                                9.54716
                            ],
                            [
                                123.8065,
                                9.55261
                            ],
                            [
                                123.87215,
                                9.60343
                            ],
                            [
                                123.8457,
                                9.64421
                            ],
                            [
                                123.72188,
                                9.59124
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                121.78398,
                                20.72464
                            ],
                            [
                                121.854,
                                20.72277
                            ],
                            [
                                121.87904,
                                20.82218
                            ],
                            [
                                121.83805,
                                20.82702
                            ],
                            [
                                121.78398,
                                20.72464
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                120.47475,
                                6.265
                            ],
                            [
                                120.57089,
                                6.2497
                            ],
                            [
                                120.59698,
                                6.3883
                            ],
                            [
                                120.56277,
                                6.38235
                            ],
                            [
                                120.51015,
                                6.2613
                            ],
                            [
                                120.47475,
                                6.265
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                122.24443,
                                12.57146
                            ],
                            [
                                122.27866,
                                12.48126
                            ],
                            [
                                122.32347,
                                12.54296
                            ],
                            [
                                122.29008,
                                12.61244
                            ],
                            [
                                122.24443,
                                12.57146
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                121.89333,
                                19.54545
                            ],
                            [
                                121.96828,
                                19.47674
                            ],
                            [
                                121.99525,
                                19.5171
                            ],
                            [
                                121.96987,
                                19.57696
                            ],
                            [
                                121.89333,
                                19.54545
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                120.81104,
                                5.53771
                            ],
                            [
                                120.8485,
                                5.48868
                            ],
                            [
                                120.90509,
                                5.53706
                            ],
                            [
                                120.86475,
                                5.58287
                            ],
                            [
                                120.81104,
                                5.53771
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                121.91552,
                                20.34754
                            ],
                            [
                                121.98059,
                                20.384
                            ],
                            [
                                122.02372,
                                20.45313
                            ],
                            [
                                122.00347,
                                20.48809
                            ],
                            [
                                121.92895,
                                20.40462
                            ],
                            [
                                121.91552,
                                20.34754
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                121.1252,
                                12.15324
                            ],
                            [
                                121.0787,
                                12.28827
                            ],
                            [
                                121.03239,
                                12.26974
                            ],
                            [
                                121.1252,
                                12.15324
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                118.4214,
                                7.01574
                            ],
                            [
                                118.50612,
                                6.96347
                            ],
                            [
                                118.52265,
                                7.03645
                            ],
                            [
                                118.4214,
                                7.01574
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                122.3069,
                                14.6819
                            ],
                            [
                                122.42105,
                                14.68625
                            ],
                            [
                                122.3967,
                                14.73423
                            ],
                            [
                                122.3069,
                                14.6819
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "POL",
                "Country": "Poland",
                "Total_3GHG": 0.99,
                "Total_3GHG_timeseries": [
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.0051,
                    0.0052,
                    0.0054,
                    0.0056,
                    0.0058,
                    0.006,
                    0.0062,
                    0.0064,
                    0.0067,
                    0.0069,
                    0.0072,
                    0.0075,
                    0.0078,
                    0.0082,
                    0.0085,
                    0.0089,
                    0.0092,
                    0.0096,
                    0.0099,
                    0.0103,
                    0.0107,
                    0.0111,
                    0.0115,
                    0.0119,
                    0.0123,
                    0.0127,
                    0.013,
                    0.0133,
                    0.0136,
                    0.0139,
                    0.0142,
                    0.0144,
                    0.0147,
                    0.0149,
                    0.0151,
                    0.0152,
                    0.0153,
                    0.0154,
                    0.0155,
                    0.0155,
                    0.0156,
                    0.0156,
                    0.0157,
                    0.0157,
                    0.0157,
                    0.0156,
                    0.0156,
                    0.0156,
                    0.0156,
                    0.0155,
                    0.0155,
                    0.0155,
                    0.0155,
                    0.0155,
                    0.0154,
                    0.0155,
                    0.0155,
                    0.0156,
                    0.0156,
                    0.0157,
                    0.0157,
                    0.0158,
                    0.0158,
                    0.0159,
                    0.016,
                    0.0161,
                    0.0162,
                    0.0163
                ],
                "Fossil_3GHG": 1.44,
                "Fossil_3GHG_timeseries": [
                    5.155e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0037,
                    0.0039,
                    0.004,
                    0.0042,
                    0.0044,
                    0.0046,
                    0.0048,
                    0.0051,
                    0.0053,
                    0.0056,
                    0.0059,
                    0.0062,
                    0.0065,
                    0.0069,
                    0.0072,
                    0.0076,
                    0.0079,
                    0.0082,
                    0.0086,
                    0.009,
                    0.0093,
                    0.0097,
                    0.0101,
                    0.0105,
                    0.0108,
                    0.0111,
                    0.0114,
                    0.0117,
                    0.012,
                    0.0123,
                    0.0126,
                    0.0128,
                    0.0131,
                    0.0133,
                    0.0134,
                    0.0135,
                    0.0136,
                    0.0137,
                    0.0138,
                    0.0139,
                    0.0139,
                    0.014,
                    0.014,
                    0.014,
                    0.014,
                    0.0141,
                    0.0141,
                    0.0141,
                    0.0141,
                    0.0141,
                    0.0141,
                    0.0141,
                    0.0142,
                    0.0142,
                    0.0142,
                    0.0143,
                    0.0144,
                    0.0145,
                    0.0145,
                    0.0146,
                    0.0146,
                    0.0147,
                    0.0148,
                    0.0149,
                    0.015,
                    0.0151,
                    0.0152
                ],
                "Land_3GHG": 0.18,
                "Land_3GHG_timeseries": [
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011
                ],
                "Total_CO2": 1.1,
                "Total_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0048,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0053,
                    0.0054,
                    0.0056,
                    0.0058,
                    0.006,
                    0.0061,
                    0.0063,
                    0.0065,
                    0.0067,
                    0.0069,
                    0.007,
                    0.0072,
                    0.0074,
                    0.0076,
                    0.0078,
                    0.008,
                    0.0081,
                    0.0083,
                    0.0084,
                    0.0086,
                    0.0087,
                    0.0089,
                    0.0091,
                    0.0092,
                    0.0094,
                    0.0095,
                    0.0096,
                    0.0098,
                    0.0099,
                    0.01,
                    0.0101,
                    0.0103,
                    0.0104,
                    0.0105,
                    0.0107,
                    0.0108,
                    0.0109,
                    0.011,
                    0.0112,
                    0.0113,
                    0.0114,
                    0.0115,
                    0.0117,
                    0.0118,
                    0.0119,
                    0.0121,
                    0.0122,
                    0.0123,
                    0.0125
                ],
                "Fossil_CO2": 1.65,
                "Fossil_CO2_timeseries": [
                    1.5576e-06,
                    3.4171e-06,
                    5.3608e-06,
                    7.5125e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0045,
                    0.0046,
                    0.0048,
                    0.0049,
                    0.0051,
                    0.0053,
                    0.0055,
                    0.0057,
                    0.0059,
                    0.0061,
                    0.0063,
                    0.0064,
                    0.0066,
                    0.0068,
                    0.007,
                    0.0072,
                    0.0074,
                    0.0076,
                    0.0078,
                    0.008,
                    0.0082,
                    0.0083,
                    0.0085,
                    0.0087,
                    0.0088,
                    0.009,
                    0.0092,
                    0.0093,
                    0.0095,
                    0.0096,
                    0.0097,
                    0.0099,
                    0.01,
                    0.0102,
                    0.0103,
                    0.0105,
                    0.0106,
                    0.0108,
                    0.0109,
                    0.0111,
                    0.0112,
                    0.0114,
                    0.0115,
                    0.0116,
                    0.0118,
                    0.0119,
                    0.0121,
                    0.0122,
                    0.0124,
                    0.0125,
                    0.0127,
                    0.0128
                ],
                "Land_CO2": -0.1,
                "Land_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0,
                    0,
                    0,
                    6.9142e-06,
                    -0.0000090476,
                    0,
                    0,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0001,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0002,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003,
                    -0.0003
                ],
                "Total_CH4": 0.64,
                "Total_CH4_timeseries": [
                    7.9584e-06,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0025,
                    0.0027,
                    0.0029,
                    0.0031,
                    0.0033,
                    0.0035,
                    0.0037,
                    0.0039,
                    0.0041,
                    0.0043,
                    0.0046,
                    0.0048,
                    0.005,
                    0.0052,
                    0.0054,
                    0.0056,
                    0.0057,
                    0.0059,
                    0.006,
                    0.0061,
                    0.0062,
                    0.0063,
                    0.0063,
                    0.0064,
                    0.0064,
                    0.0064,
                    0.0064,
                    0.0063,
                    0.0062,
                    0.0061,
                    0.006,
                    0.0059,
                    0.0058,
                    0.0057,
                    0.0055,
                    0.0053,
                    0.0052,
                    0.005,
                    0.0048,
                    0.0047,
                    0.0045,
                    0.0043,
                    0.0042,
                    0.004,
                    0.0039,
                    0.0037,
                    0.0036,
                    0.0035,
                    0.0034,
                    0.0033,
                    0.0032,
                    0.0031,
                    0.003,
                    0.003,
                    0.0029,
                    0.0028,
                    0.0028,
                    0.0027,
                    0.0027
                ],
                "Fossil_CH4": 0.77,
                "Fossil_CH4_timeseries": [
                    3.2543e-06,
                    6.6565e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0018,
                    0.002,
                    0.0021,
                    0.0023,
                    0.0026,
                    0.0027,
                    0.0029,
                    0.0031,
                    0.0033,
                    0.0035,
                    0.0037,
                    0.0039,
                    0.004,
                    0.0042,
                    0.0044,
                    0.0045,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.005,
                    0.005,
                    0.0051,
                    0.0051,
                    0.0052,
                    0.0052,
                    0.0051,
                    0.0051,
                    0.005,
                    0.0049,
                    0.0049,
                    0.0048,
                    0.0047,
                    0.0046,
                    0.0044,
                    0.0043,
                    0.0041,
                    0.004,
                    0.0039,
                    0.0038,
                    0.0036,
                    0.0035,
                    0.0033,
                    0.0032,
                    0.0031,
                    0.0029,
                    0.0028,
                    0.0027,
                    0.0027,
                    0.0026,
                    0.0025,
                    0.0024,
                    0.0023,
                    0.0023,
                    0.0022,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.002
                ],
                "Land_CH4": 0.43,
                "Land_CH4_timeseries": [
                    4.7041e-06,
                    9.5926e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Total_N2O": 1.34,
                "Total_N2O_timeseries": [
                    6.4831e-07,
                    1.3064e-06,
                    1.9741e-06,
                    2.6509e-06,
                    3.3363e-06,
                    4.0297e-06,
                    4.7304e-06,
                    5.4375e-06,
                    6.1501e-06,
                    6.8671e-06,
                    7.5878e-06,
                    8.312e-06,
                    9.0397e-06,
                    9.7707e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011
                ],
                "Fossil_N2O": 1.71,
                "Fossil_N2O_timeseries": [
                    3.4312e-07,
                    6.8996e-07,
                    1.0405e-06,
                    1.3947e-06,
                    1.7525e-06,
                    2.1138e-06,
                    2.4786e-06,
                    2.8469e-06,
                    3.2184e-06,
                    3.5931e-06,
                    3.971e-06,
                    4.352e-06,
                    4.7361e-06,
                    5.1233e-06,
                    5.5136e-06,
                    5.907e-06,
                    6.3035e-06,
                    6.7032e-06,
                    7.1059e-06,
                    7.5118e-06,
                    7.9214e-06,
                    8.3356e-06,
                    8.7552e-06,
                    9.1806e-06,
                    9.6121e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Land_N2O": 1.2,
                "Land_N2O_timeseries": [
                    3.0519e-07,
                    6.1648e-07,
                    9.3361e-07,
                    1.2562e-06,
                    1.5839e-06,
                    1.9159e-06,
                    2.2518e-06,
                    2.5907e-06,
                    2.9317e-06,
                    3.274e-06,
                    3.6168e-06,
                    3.96e-06,
                    4.3036e-06,
                    4.6474e-06,
                    4.9914e-06,
                    5.3356e-06,
                    5.6801e-06,
                    6.0249e-06,
                    6.3702e-06,
                    6.7161e-06,
                    7.0678e-06,
                    7.4342e-06,
                    7.822e-06,
                    8.236e-06,
                    8.6789e-06,
                    9.1513e-06,
                    9.6518e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            19.63903,
                            54.45829
                        ],
                        [
                            19.38366,
                            54.37541
                        ],
                        [
                            19.22746,
                            54.35461
                        ],
                        [
                            18.88064,
                            54.34811
                        ],
                        [
                            18.73729,
                            54.37453
                        ],
                        [
                            18.59116,
                            54.43019
                        ],
                        [
                            18.54173,
                            54.58448
                        ],
                        [
                            18.47885,
                            54.63056
                        ],
                        [
                            18.47215,
                            54.69439
                        ],
                        [
                            18.39414,
                            54.73074
                        ],
                        [
                            18.42423,
                            54.78808
                        ],
                        [
                            18.32803,
                            54.8346
                        ],
                        [
                            17.96782,
                            54.83083
                        ],
                        [
                            17.61322,
                            54.77445
                        ],
                        [
                            17.25398,
                            54.73236
                        ],
                        [
                            17.0463,
                            54.66778
                        ],
                        [
                            16.95094,
                            54.61215
                        ],
                        [
                            16.76295,
                            54.5696
                        ],
                        [
                            16.52969,
                            54.54042
                        ],
                        [
                            16.43186,
                            54.48719
                        ],
                        [
                            16.31437,
                            54.38392
                        ],
                        [
                            16.09074,
                            54.27145
                        ],
                        [
                            15.85815,
                            54.24244
                        ],
                        [
                            15.48547,
                            54.16645
                        ],
                        [
                            15.28646,
                            54.14696
                        ],
                        [
                            14.50031,
                            53.96365
                        ],
                        [
                            14.34216,
                            53.87347
                        ],
                        [
                            14.54343,
                            53.85808
                        ],
                        [
                            14.60712,
                            53.82043
                        ],
                        [
                            14.5065,
                            53.66628
                        ],
                        [
                            14.34792,
                            53.71137
                        ],
                        [
                            14.26754,
                            53.69781
                        ],
                        [
                            14.31659,
                            53.61717
                        ],
                        [
                            14.30344,
                            53.55424
                        ],
                        [
                            14.37106,
                            53.45532
                        ],
                        [
                            14.3903,
                            53.35375
                        ],
                        [
                            14.4502,
                            53.26154
                        ],
                        [
                            14.37775,
                            53.20156
                        ],
                        [
                            14.38648,
                            53.14253
                        ],
                        [
                            14.3442,
                            53.05088
                        ],
                        [
                            14.14366,
                            52.96137
                        ],
                        [
                            14.1423,
                            52.82416
                        ],
                        [
                            14.21555,
                            52.81713
                        ],
                        [
                            14.35084,
                            52.75131
                        ],
                        [
                            14.46825,
                            52.65974
                        ],
                        [
                            14.59668,
                            52.61001
                        ],
                        [
                            14.63754,
                            52.56666
                        ],
                        [
                            14.63,
                            52.48708
                        ],
                        [
                            14.53436,
                            52.39501
                        ],
                        [
                            14.59328,
                            52.2746
                        ],
                        [
                            14.69269,
                            52.25574
                        ],
                        [
                            14.68278,
                            52.1138
                        ],
                        [
                            14.74481,
                            52.08229
                        ],
                        [
                            14.69284,
                            51.90128
                        ],
                        [
                            14.61126,
                            51.85622
                        ],
                        [
                            14.66772,
                            51.72681
                        ],
                        [
                            14.73714,
                            51.68768
                        ],
                        [
                            14.76504,
                            51.6082
                        ],
                        [
                            14.73669,
                            51.52598
                        ],
                        [
                            14.94801,
                            51.47126
                        ],
                        [
                            14.9814,
                            51.33552
                        ],
                        [
                            15.03268,
                            51.29359
                        ],
                        [
                            14.97886,
                            51.07783
                        ],
                        [
                            14.89534,
                            50.93948
                        ],
                        [
                            14.82336,
                            50.87055
                        ],
                        [
                            15.00195,
                            50.87018
                        ],
                        [
                            15.01433,
                            50.93981
                        ],
                        [
                            14.985,
                            51.01091
                        ],
                        [
                            15.10463,
                            50.9921
                        ],
                        [
                            15.23706,
                            50.99826
                        ],
                        [
                            15.26737,
                            50.92024
                        ],
                        [
                            15.37416,
                            50.82147
                        ],
                        [
                            15.52438,
                            50.77761
                        ],
                        [
                            15.60374,
                            50.77619
                        ],
                        [
                            15.74013,
                            50.73614
                        ],
                        [
                            15.81601,
                            50.75472
                        ],
                        [
                            15.86285,
                            50.68115
                        ],
                        [
                            15.96675,
                            50.69151
                        ],
                        [
                            16.00208,
                            50.6445
                        ],
                        [
                            16.23347,
                            50.67039
                        ],
                        [
                            16.34087,
                            50.66205
                        ],
                        [
                            16.44492,
                            50.57957
                        ],
                        [
                            16.34415,
                            50.49689
                        ],
                        [
                            16.20505,
                            50.44842
                        ],
                        [
                            16.22186,
                            50.40692
                        ],
                        [
                            16.36099,
                            50.37924
                        ],
                        [
                            16.55656,
                            50.22028
                        ],
                        [
                            16.562,
                            50.16408
                        ],
                        [
                            16.63419,
                            50.11187
                        ],
                        [
                            16.72028,
                            50.10295
                        ],
                        [
                            16.80107,
                            50.17998
                        ],
                        [
                            16.91792,
                            50.22594
                        ],
                        [
                            16.99735,
                            50.21759
                        ],
                        [
                            17.01927,
                            50.27818
                        ],
                        [
                            16.94736,
                            50.31518
                        ],
                        [
                            16.91019,
                            50.38933
                        ],
                        [
                            16.97457,
                            50.41846
                        ],
                        [
                            17.18497,
                            50.3895
                        ],
                        [
                            17.34241,
                            50.28044
                        ],
                        [
                            17.61732,
                            50.26695
                        ],
                        [
                            17.7184,
                            50.32095
                        ],
                        [
                            17.75778,
                            50.20701
                        ],
                        [
                            17.60434,
                            50.17048
                        ],
                        [
                            17.61036,
                            50.14083
                        ],
                        [
                            17.73092,
                            50.09717
                        ],
                        [
                            17.77877,
                            50.02017
                        ],
                        [
                            17.86174,
                            49.97976
                        ],
                        [
                            18.03374,
                            50.01079
                        ],
                        [
                            18.42999,
                            49.93782
                        ],
                        [
                            18.60292,
                            49.85723
                        ],
                        [
                            18.56958,
                            49.83365
                        ],
                        [
                            18.62647,
                            49.7228
                        ],
                        [
                            18.80699,
                            49.65114
                        ],
                        [
                            18.85155,
                            49.51719
                        ],
                        [
                            18.94659,
                            49.51737
                        ],
                        [
                            18.98814,
                            49.43088
                        ],
                        [
                            19.15414,
                            49.40421
                        ],
                        [
                            19.19648,
                            49.41525
                        ],
                        [
                            19.26071,
                            49.53122
                        ],
                        [
                            19.46739,
                            49.61377
                        ],
                        [
                            19.52948,
                            49.57317
                        ],
                        [
                            19.5806,
                            49.46064
                        ],
                        [
                            19.70481,
                            49.39645
                        ],
                        [
                            19.79013,
                            49.41018
                        ],
                        [
                            19.80455,
                            49.32277
                        ],
                        [
                            19.76355,
                            49.20742
                        ],
                        [
                            19.86837,
                            49.19651
                        ],
                        [
                            19.98209,
                            49.23128
                        ],
                        [
                            20.07108,
                            49.18023
                        ],
                        [
                            20.14685,
                            49.31792
                        ],
                        [
                            20.22143,
                            49.35126
                        ],
                        [
                            20.32291,
                            49.3514
                        ],
                        [
                            20.47431,
                            49.41464
                        ],
                        [
                            20.575,
                            49.3766
                        ],
                        [
                            20.69369,
                            49.41962
                        ],
                        [
                            20.9319,
                            49.29727
                        ],
                        [
                            21.04466,
                            49.36524
                        ],
                        [
                            21.05527,
                            49.42131
                        ],
                        [
                            21.12315,
                            49.43582
                        ],
                        [
                            21.19147,
                            49.4014
                        ],
                        [
                            21.27659,
                            49.46044
                        ],
                        [
                            21.43028,
                            49.41413
                        ],
                        [
                            21.63003,
                            49.44684
                        ],
                        [
                            21.76297,
                            49.38326
                        ],
                        [
                            21.84046,
                            49.39083
                        ],
                        [
                            21.96409,
                            49.34655
                        ],
                        [
                            22.03396,
                            49.27811
                        ],
                        [
                            22.03489,
                            49.22246
                        ],
                        [
                            22.41306,
                            49.1028
                        ],
                        [
                            22.56684,
                            49.08838
                        ],
                        [
                            22.6825,
                            49.03891
                        ],
                        [
                            22.86811,
                            49.07683
                        ],
                        [
                            22.74112,
                            49.21846
                        ],
                        [
                            22.7443,
                            49.36916
                        ],
                        [
                            22.70006,
                            49.48885
                        ],
                        [
                            22.64151,
                            49.52921
                        ],
                        [
                            23.03327,
                            49.88133
                        ],
                        [
                            23.27859,
                            50.08627
                        ],
                        [
                            23.47043,
                            50.21778
                        ],
                        [
                            23.58121,
                            50.26647
                        ],
                        [
                            23.70343,
                            50.37534
                        ],
                        [
                            23.80338,
                            50.40476
                        ],
                        [
                            23.99708,
                            50.41266
                        ],
                        [
                            24.0911,
                            50.56212
                        ],
                        [
                            24.07433,
                            50.71013
                        ],
                        [
                            24.01872,
                            50.72431
                        ],
                        [
                            23.95854,
                            50.79404
                        ],
                        [
                            24.02177,
                            50.84121
                        ],
                        [
                            24.13209,
                            50.8493
                        ],
                        [
                            23.97014,
                            50.95167
                        ],
                        [
                            23.87287,
                            51.0836
                        ],
                        [
                            23.86184,
                            51.15662
                        ],
                        [
                            23.74287,
                            51.21396
                        ],
                        [
                            23.63788,
                            51.33039
                        ],
                        [
                            23.70018,
                            51.4034
                        ],
                        [
                            23.61744,
                            51.50954
                        ],
                        [
                            23.54133,
                            51.60191
                        ],
                        [
                            23.55969,
                            51.76105
                        ],
                        [
                            23.63036,
                            51.78054
                        ],
                        [
                            23.6076,
                            51.87584
                        ],
                        [
                            23.68858,
                            51.99107
                        ],
                        [
                            23.59605,
                            52.1174
                        ],
                        [
                            23.39317,
                            52.20025
                        ],
                        [
                            23.20421,
                            52.22664
                        ],
                        [
                            23.21635,
                            52.33047
                        ],
                        [
                            23.35672,
                            52.46889
                        ],
                        [
                            23.46692,
                            52.54914
                        ],
                        [
                            23.64273,
                            52.60755
                        ],
                        [
                            23.76604,
                            52.61834
                        ],
                        [
                            23.93835,
                            52.71346
                        ],
                        [
                            23.91688,
                            52.93862
                        ],
                        [
                            23.9255,
                            53.02348
                        ],
                        [
                            23.87233,
                            53.0834
                        ],
                        [
                            23.91491,
                            53.14282
                        ],
                        [
                            23.818,
                            53.24527
                        ],
                        [
                            23.65965,
                            53.52176
                        ],
                        [
                            23.54901,
                            53.76883
                        ],
                        [
                            23.51465,
                            53.95656
                        ],
                        [
                            23.48151,
                            53.99788
                        ],
                        [
                            23.52816,
                            54.06624
                        ],
                        [
                            23.48604,
                            54.15234
                        ],
                        [
                            23.34047,
                            54.25013
                        ],
                        [
                            23.09311,
                            54.2987
                        ],
                        [
                            22.98221,
                            54.38957
                        ],
                        [
                            22.83594,
                            54.40558
                        ],
                        [
                            22.7921,
                            54.36336
                        ],
                        [
                            22.31591,
                            54.34062
                        ],
                        [
                            21.49542,
                            54.32384
                        ],
                        [
                            21.27454,
                            54.32862
                        ],
                        [
                            21.00608,
                            54.35357
                        ],
                        [
                            20.51337,
                            54.38099
                        ],
                        [
                            19.80377,
                            54.44241
                        ],
                        [
                            19.75426,
                            54.43288
                        ],
                        [
                            19.64577,
                            54.34523
                        ],
                        [
                            19.50226,
                            54.32159
                        ],
                        [
                            19.39936,
                            54.26243
                        ],
                        [
                            19.27769,
                            54.27777
                        ],
                        [
                            19.24795,
                            54.32867
                        ],
                        [
                            19.5925,
                            54.42463
                        ],
                        [
                            19.64852,
                            54.45334
                        ],
                        [
                            19.63903,
                            54.45829
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "PRT",
                "Country": "Portugal",
                "Total_3GHG": 0.12,
                "Total_3GHG_timeseries": [
                    1.828e-06,
                    3.6498e-06,
                    5.4761e-06,
                    7.3081e-06,
                    9.1451e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019
                ],
                "Fossil_3GHG": 0.15,
                "Fossil_3GHG_timeseries": [
                    3.1809e-07,
                    6.4092e-07,
                    9.6839e-07,
                    1.3002e-06,
                    1.6365e-06,
                    1.9772e-06,
                    2.3227e-06,
                    2.6749e-06,
                    3.034e-06,
                    3.3998e-06,
                    3.7764e-06,
                    4.1608e-06,
                    4.5514e-06,
                    4.9502e-06,
                    5.3558e-06,
                    5.7682e-06,
                    6.1874e-06,
                    6.6135e-06,
                    7.0465e-06,
                    7.4998e-06,
                    7.9644e-06,
                    8.7271e-06,
                    9.6183e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015
                ],
                "Land_3GHG": 0.06,
                "Land_3GHG_timeseries": [
                    1.5099e-06,
                    3.0089e-06,
                    4.5078e-06,
                    6.0078e-06,
                    7.5086e-06,
                    9.0131e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Total_CO2": 0.11,
                "Total_CO2_timeseries": [
                    7.5644e-07,
                    1.4888e-06,
                    2.208e-06,
                    2.9153e-06,
                    3.6105e-06,
                    4.2966e-06,
                    4.972e-06,
                    5.6377e-06,
                    6.2907e-06,
                    7.0206e-06,
                    7.787e-06,
                    8.5719e-06,
                    9.3691e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013
                ],
                "Fossil_CO2": 0.16,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    9.9e-09,
                    2.64e-08,
                    2.607e-07,
                    5.874e-07,
                    8.2665e-07,
                    1.353e-06,
                    1.8694e-06,
                    2.1714e-06,
                    2.4602e-06,
                    2.7786e-06,
                    3.1746e-06,
                    3.5756e-06,
                    4.064e-06,
                    4.5771e-06,
                    5.1183e-06,
                    5.6199e-06,
                    6.1743e-06,
                    6.7452e-06,
                    7.3607e-06,
                    8.0685e-06,
                    8.8242e-06,
                    9.608e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012
                ],
                "Land_CO2": 0.02,
                "Land_CO2_timeseries": [
                    7.5644e-07,
                    1.4888e-06,
                    2.208e-06,
                    2.9153e-06,
                    3.6105e-06,
                    4.2966e-06,
                    4.972e-06,
                    5.6377e-06,
                    6.2907e-06,
                    7.0206e-06,
                    7.787e-06,
                    8.5719e-06,
                    9.3691e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_CH4": 0.12,
                "Total_CH4_timeseries": [
                    9.712e-07,
                    1.9584e-06,
                    2.9617e-06,
                    3.9806e-06,
                    5.0154e-06,
                    6.0659e-06,
                    7.1326e-06,
                    8.2175e-06,
                    9.3207e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Fossil_CH4": 0.11,
                "Fossil_CH4_timeseries": [
                    2.8872e-07,
                    5.8175e-07,
                    8.7901e-07,
                    1.1803e-06,
                    1.4856e-06,
                    1.795e-06,
                    2.1088e-06,
                    2.4291e-06,
                    2.756e-06,
                    3.0894e-06,
                    3.4334e-06,
                    3.7851e-06,
                    4.1426e-06,
                    4.5084e-06,
                    4.8806e-06,
                    5.2595e-06,
                    5.6451e-06,
                    6.0373e-06,
                    6.4363e-06,
                    6.8455e-06,
                    7.2589e-06,
                    7.752e-06,
                    8.2801e-06,
                    8.7791e-06,
                    9.3829e-06,
                    9.9854e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Land_CH4": 0.13,
                "Land_CH4_timeseries": [
                    6.8249e-07,
                    1.3767e-06,
                    2.0827e-06,
                    2.8003e-06,
                    3.5298e-06,
                    4.2709e-06,
                    5.0238e-06,
                    5.7884e-06,
                    6.5648e-06,
                    7.3529e-06,
                    8.1559e-06,
                    8.974e-06,
                    9.807e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Total_N2O": 0.17,
                "Total_N2O_timeseries": [
                    1.0036e-07,
                    2.0255e-07,
                    3.0651e-07,
                    4.1213e-07,
                    5.193e-07,
                    6.2785e-07,
                    7.376e-07,
                    8.4834e-07,
                    9.5984e-07,
                    1.0718e-06,
                    1.1842e-06,
                    1.2968e-06,
                    1.4096e-06,
                    1.5227e-06,
                    1.636e-06,
                    1.7496e-06,
                    1.8634e-06,
                    1.9774e-06,
                    2.0917e-06,
                    2.2064e-06,
                    2.3228e-06,
                    2.4434e-06,
                    2.5701e-06,
                    2.704e-06,
                    2.846e-06,
                    2.9963e-06,
                    3.1545e-06,
                    3.3195e-06,
                    3.49e-06,
                    3.6638e-06,
                    3.8396e-06,
                    4.0171e-06,
                    4.196e-06,
                    4.3762e-06,
                    4.5576e-06,
                    4.74e-06,
                    4.9235e-06,
                    5.1082e-06,
                    5.2942e-06,
                    5.4662e-06,
                    5.6562e-06,
                    5.8631e-06,
                    6.0858e-06,
                    6.3228e-06,
                    6.5726e-06,
                    6.8336e-06,
                    7.1038e-06,
                    7.3812e-06,
                    7.6637e-06,
                    7.9487e-06,
                    8.2339e-06,
                    8.5174e-06,
                    8.7975e-06,
                    9.0734e-06,
                    9.3444e-06,
                    9.6107e-06,
                    9.8726e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_N2O": 0.22,
                "Fossil_N2O_timeseries": [
                    2.9378e-08,
                    5.9174e-08,
                    8.9375e-08,
                    1.1997e-07,
                    1.5093e-07,
                    1.8225e-07,
                    2.1389e-07,
                    2.4581e-07,
                    2.78e-07,
                    3.104e-07,
                    3.4299e-07,
                    3.7576e-07,
                    4.0872e-07,
                    4.4185e-07,
                    4.7516e-07,
                    5.0864e-07,
                    5.423e-07,
                    5.7615e-07,
                    6.1017e-07,
                    6.4439e-07,
                    6.7902e-07,
                    7.1441e-07,
                    7.5085e-07,
                    7.8853e-07,
                    8.2756e-07,
                    8.6796e-07,
                    9.0969e-07,
                    9.5259e-07,
                    9.9645e-07,
                    1.0409e-06,
                    1.0859e-06,
                    1.1312e-06,
                    1.1769e-06,
                    1.2229e-06,
                    1.2693e-06,
                    1.3159e-06,
                    1.3629e-06,
                    1.4101e-06,
                    1.4577e-06,
                    1.5079e-06,
                    1.559e-06,
                    1.611e-06,
                    1.6641e-06,
                    1.7182e-06,
                    1.7734e-06,
                    1.8298e-06,
                    1.8874e-06,
                    1.9463e-06,
                    2.0065e-06,
                    2.068e-06,
                    2.131e-06,
                    2.1956e-06,
                    2.2621e-06,
                    2.3304e-06,
                    2.4008e-06,
                    2.473e-06,
                    2.5471e-06,
                    2.623e-06,
                    2.7005e-06,
                    2.7794e-06,
                    2.8594e-06,
                    2.9405e-06,
                    3.0227e-06,
                    3.1057e-06,
                    3.1897e-06,
                    3.2747e-06,
                    3.3605e-06,
                    3.4474e-06,
                    3.5352e-06,
                    3.6243e-06,
                    3.7146e-06,
                    3.8065e-06,
                    3.9002e-06,
                    3.9956e-06,
                    4.0928e-06,
                    4.1918e-06,
                    4.2925e-06,
                    4.3945e-06,
                    4.4978e-06,
                    4.6019e-06,
                    4.7074e-06,
                    4.8159e-06,
                    4.9285e-06,
                    5.0462e-06,
                    5.1697e-06,
                    5.2993e-06,
                    5.4352e-06,
                    5.5774e-06,
                    5.7255e-06,
                    5.8789e-06,
                    6.0371e-06,
                    6.1999e-06,
                    6.3674e-06,
                    6.5398e-06,
                    6.7173e-06,
                    6.9002e-06,
                    7.0891e-06,
                    7.2845e-06,
                    7.4874e-06,
                    7.6984e-06,
                    7.921e-06,
                    8.1607e-06,
                    8.422e-06,
                    8.7086e-06,
                    9.0234e-06,
                    9.3686e-06,
                    9.7454e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_N2O": 0.15,
                "Land_N2O_timeseries": [
                    7.0979e-08,
                    1.4338e-07,
                    2.1714e-07,
                    2.9217e-07,
                    3.6836e-07,
                    4.456e-07,
                    5.2371e-07,
                    6.0253e-07,
                    6.8184e-07,
                    7.6144e-07,
                    8.4117e-07,
                    9.21e-07,
                    1.0009e-06,
                    1.0809e-06,
                    1.1609e-06,
                    1.2409e-06,
                    1.321e-06,
                    1.4012e-06,
                    1.4815e-06,
                    1.562e-06,
                    1.6438e-06,
                    1.729e-06,
                    1.8192e-06,
                    1.9155e-06,
                    2.0185e-06,
                    2.1284e-06,
                    2.2448e-06,
                    2.3669e-06,
                    2.4935e-06,
                    2.6229e-06,
                    2.7537e-06,
                    2.8859e-06,
                    3.0191e-06,
                    3.1533e-06,
                    3.2883e-06,
                    3.4241e-06,
                    3.5607e-06,
                    3.6981e-06,
                    3.8365e-06,
                    3.9583e-06,
                    4.0972e-06,
                    4.2521e-06,
                    4.4217e-06,
                    4.6046e-06,
                    4.7992e-06,
                    5.0038e-06,
                    5.2164e-06,
                    5.4349e-06,
                    5.6572e-06,
                    5.8807e-06,
                    6.103e-06,
                    6.3218e-06,
                    6.5355e-06,
                    6.743e-06,
                    6.9437e-06,
                    7.1377e-06,
                    7.3255e-06,
                    7.5082e-06,
                    7.6874e-06,
                    7.8653e-06,
                    8.0434e-06,
                    8.2218e-06,
                    8.4009e-06,
                    8.5808e-06,
                    8.7617e-06,
                    8.9438e-06,
                    9.1271e-06,
                    9.3118e-06,
                    9.498e-06,
                    9.6856e-06,
                    9.875e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -7.40192,
                                37.17483
                            ],
                            [
                                -7.44203,
                                37.31517
                            ],
                            [
                                -7.45693,
                                37.45158
                            ],
                            [
                                -7.52294,
                                37.55345
                            ],
                            [
                                -7.44532,
                                37.66527
                            ],
                            [
                                -7.41986,
                                37.74521
                            ],
                            [
                                -7.32491,
                                37.81607
                            ],
                            [
                                -7.24939,
                                37.95516
                            ],
                            [
                                -7.20262,
                                38.0028
                            ],
                            [
                                -7.13612,
                                37.99969
                            ],
                            [
                                -7.09878,
                                38.04323
                            ],
                            [
                                -7.00753,
                                38.02127
                            ],
                            [
                                -6.96853,
                                38.16537
                            ],
                            [
                                -7.10795,
                                38.18812
                            ],
                            [
                                -7.15224,
                                38.27541
                            ],
                            [
                                -7.31702,
                                38.43926
                            ],
                            [
                                -7.30365,
                                38.54165
                            ],
                            [
                                -7.25516,
                                38.72519
                            ],
                            [
                                -7.03388,
                                38.87776
                            ],
                            [
                                -7.05103,
                                38.90608
                            ],
                            [
                                -6.95265,
                                39.02336
                            ],
                            [
                                -6.98191,
                                39.0884
                            ],
                            [
                                -7.05078,
                                39.11811
                            ],
                            [
                                -7.14388,
                                39.10932
                            ],
                            [
                                -7.13729,
                                39.17195
                            ],
                            [
                                -7.24143,
                                39.20861
                            ],
                            [
                                -7.23147,
                                39.27843
                            ],
                            [
                                -7.30879,
                                39.33766
                            ],
                            [
                                -7.29554,
                                39.45596
                            ],
                            [
                                -7.38926,
                                39.50326
                            ],
                            [
                                -7.49862,
                                39.58939
                            ],
                            [
                                -7.53599,
                                39.66775
                            ],
                            [
                                -7.33392,
                                39.64155
                            ],
                            [
                                -7.24534,
                                39.66692
                            ],
                            [
                                -7.1467,
                                39.65303
                            ],
                            [
                                -7.01563,
                                39.67172
                            ],
                            [
                                -6.98216,
                                39.81832
                            ],
                            [
                                -6.90389,
                                39.87337
                            ],
                            [
                                -6.8742,
                                39.99584
                            ],
                            [
                                -6.94268,
                                40.11252
                            ],
                            [
                                -6.99586,
                                40.11903
                            ],
                            [
                                -7.02769,
                                40.18696
                            ],
                            [
                                -6.9513,
                                40.25745
                            ],
                            [
                                -6.86108,
                                40.29976
                            ],
                            [
                                -6.78191,
                                40.36556
                            ],
                            [
                                -6.84925,
                                40.45118
                            ],
                            [
                                -6.79583,
                                40.5119
                            ],
                            [
                                -6.84464,
                                40.56679
                            ],
                            [
                                -6.79924,
                                40.65448
                            ],
                            [
                                -6.82959,
                                40.74118
                            ],
                            [
                                -6.8022,
                                40.84514
                            ],
                            [
                                -6.86068,
                                40.94946
                            ],
                            [
                                -6.93072,
                                41.01689
                            ],
                            [
                                -6.83292,
                                41.02911
                            ],
                            [
                                -6.77476,
                                41.0739
                            ],
                            [
                                -6.76982,
                                41.12431
                            ],
                            [
                                -6.6479,
                                41.24727
                            ],
                            [
                                -6.55248,
                                41.24543
                            ],
                            [
                                -6.43929,
                                41.30472
                            ],
                            [
                                -6.39147,
                                41.38375
                            ],
                            [
                                -6.29663,
                                41.43328
                            ],
                            [
                                -6.18935,
                                41.57505
                            ],
                            [
                                -6.25472,
                                41.63392
                            ],
                            [
                                -6.35415,
                                41.67633
                            ],
                            [
                                -6.44624,
                                41.68417
                            ],
                            [
                                -6.5121,
                                41.66126
                            ],
                            [
                                -6.55667,
                                41.73741
                            ],
                            [
                                -6.51673,
                                41.8729
                            ],
                            [
                                -6.59873,
                                41.9494
                            ],
                            [
                                -6.69541,
                                41.9337
                            ],
                            [
                                -6.82093,
                                41.94728
                            ],
                            [
                                -7.07531,
                                41.95134
                            ],
                            [
                                -7.18473,
                                41.97246
                            ],
                            [
                                -7.19569,
                                41.88203
                            ],
                            [
                                -7.31401,
                                41.84366
                            ],
                            [
                                -7.45278,
                                41.86516
                            ],
                            [
                                -7.57352,
                                41.83044
                            ],
                            [
                                -7.5846,
                                41.87703
                            ],
                            [
                                -7.70408,
                                41.90785
                            ],
                            [
                                -7.84544,
                                41.8646
                            ],
                            [
                                -7.98822,
                                41.8675
                            ],
                            [
                                -8.01347,
                                41.82976
                            ],
                            [
                                -8.12906,
                                41.80907
                            ],
                            [
                                -8.21653,
                                41.91299
                            ],
                            [
                                -8.16232,
                                41.9827
                            ],
                            [
                                -8.08599,
                                42.01699
                            ],
                            [
                                -8.11848,
                                42.08212
                            ],
                            [
                                -8.24326,
                                42.13912
                            ],
                            [
                                -8.33894,
                                42.08459
                            ],
                            [
                                -8.52722,
                                42.07702
                            ],
                            [
                                -8.63304,
                                42.04876
                            ],
                            [
                                -8.66217,
                                42.00354
                            ],
                            [
                                -8.86319,
                                41.87207
                            ],
                            [
                                -8.88056,
                                41.752
                            ],
                            [
                                -8.8264,
                                41.64807
                            ],
                            [
                                -8.77732,
                                41.47958
                            ],
                            [
                                -8.78901,
                                41.41631
                            ],
                            [
                                -8.70651,
                                41.18735
                            ],
                            [
                                -8.66785,
                                41.13912
                            ],
                            [
                                -8.64497,
                                41.01597
                            ],
                            [
                                -8.66845,
                                40.90011
                            ],
                            [
                                -8.75492,
                                40.6465
                            ],
                            [
                                -8.84633,
                                40.32688
                            ],
                            [
                                -8.90808,
                                40.19004
                            ],
                            [
                                -8.86313,
                                40.13718
                            ],
                            [
                                -8.89493,
                                40.0455
                            ],
                            [
                                -9.03061,
                                39.76711
                            ],
                            [
                                -9.08532,
                                39.61502
                            ],
                            [
                                -9.07798,
                                39.58985
                            ],
                            [
                                -9.22663,
                                39.43684
                            ],
                            [
                                -9.36594,
                                39.34838
                            ],
                            [
                                -9.33582,
                                39.27359
                            ],
                            [
                                -9.3604,
                                39.1705
                            ],
                            [
                                -9.42145,
                                39.07474
                            ],
                            [
                                -9.41663,
                                38.95274
                            ],
                            [
                                -9.49992,
                                38.78071
                            ],
                            [
                                -9.48594,
                                38.71047
                            ],
                            [
                                -9.31837,
                                38.67578
                            ],
                            [
                                -9.13137,
                                38.7076
                            ],
                            [
                                -9.09096,
                                38.75934
                            ],
                            [
                                -9.05891,
                                38.85914
                            ],
                            [
                                -8.98824,
                                38.91403
                            ],
                            [
                                -8.93122,
                                38.7687
                            ],
                            [
                                -9.04503,
                                38.71507
                            ],
                            [
                                -9.01297,
                                38.67192
                            ],
                            [
                                -9.25772,
                                38.66447
                            ],
                            [
                                -9.18782,
                                38.55032
                            ],
                            [
                                -9.1848,
                                38.48803
                            ],
                            [
                                -9.22153,
                                38.41356
                            ],
                            [
                                -9.06543,
                                38.43533
                            ],
                            [
                                -8.88786,
                                38.52048
                            ],
                            [
                                -8.8315,
                                38.49359
                            ],
                            [
                                -8.74829,
                                38.55123
                            ],
                            [
                                -8.7198,
                                38.44091
                            ],
                            [
                                -8.79819,
                                38.39483
                            ],
                            [
                                -8.77582,
                                38.245
                            ],
                            [
                                -8.78259,
                                38.17278
                            ],
                            [
                                -8.82562,
                                38.04929
                            ],
                            [
                                -8.88302,
                                37.95045
                            ],
                            [
                                -8.81047,
                                37.92769
                            ],
                            [
                                -8.79068,
                                37.83778
                            ],
                            [
                                -8.81153,
                                37.74646
                            ],
                            [
                                -8.78666,
                                37.71455
                            ],
                            [
                                -8.81839,
                                37.5978
                            ],
                            [
                                -8.79295,
                                37.5588
                            ],
                            [
                                -8.80719,
                                37.41877
                            ],
                            [
                                -8.86953,
                                37.32441
                            ],
                            [
                                -8.86078,
                                37.26815
                            ],
                            [
                                -8.90325,
                                37.16897
                            ],
                            [
                                -8.99451,
                                37.02379
                            ],
                            [
                                -8.94889,
                                37.00698
                            ],
                            [
                                -8.82242,
                                37.06476
                            ],
                            [
                                -8.68553,
                                37.08515
                            ],
                            [
                                -8.60226,
                                37.12299
                            ],
                            [
                                -8.44391,
                                37.08664
                            ],
                            [
                                -8.36936,
                                37.10168
                            ],
                            [
                                -8.3089,
                                37.07553
                            ],
                            [
                                -8.1848,
                                37.09034
                            ],
                            [
                                -8.09663,
                                37.06444
                            ],
                            [
                                -7.97937,
                                36.9975
                            ],
                            [
                                -7.89784,
                                36.96982
                            ],
                            [
                                -7.85669,
                                37.02096
                            ],
                            [
                                -7.79791,
                                37.01308
                            ],
                            [
                                -7.57036,
                                37.14804
                            ],
                            [
                                -7.40192,
                                37.17483
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -25.76603,
                                37.90617
                            ],
                            [
                                -25.85359,
                                37.86027
                            ],
                            [
                                -25.84102,
                                37.82901
                            ],
                            [
                                -25.69684,
                                37.73617
                            ],
                            [
                                -25.63007,
                                37.75004
                            ],
                            [
                                -25.48374,
                                37.71788
                            ],
                            [
                                -25.3688,
                                37.71401
                            ],
                            [
                                -25.14979,
                                37.75874
                            ],
                            [
                                -25.14993,
                                37.85027
                            ],
                            [
                                -25.26194,
                                37.862
                            ],
                            [
                                -25.45566,
                                37.82319
                            ],
                            [
                                -25.50049,
                                37.84297
                            ],
                            [
                                -25.58528,
                                37.81414
                            ],
                            [
                                -25.69064,
                                37.84295
                            ],
                            [
                                -25.76603,
                                37.90617
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -17.1936,
                                32.87035
                            ],
                            [
                                -17.26489,
                                32.81473
                            ],
                            [
                                -17.2118,
                                32.737
                            ],
                            [
                                -17.01964,
                                32.65364
                            ],
                            [
                                -16.94354,
                                32.63321
                            ],
                            [
                                -16.83189,
                                32.64153
                            ],
                            [
                                -16.7734,
                                32.69204
                            ],
                            [
                                -16.74507,
                                32.75513
                            ],
                            [
                                -16.82231,
                                32.76844
                            ],
                            [
                                -16.9072,
                                32.83645
                            ],
                            [
                                -17.05103,
                                32.80889
                            ],
                            [
                                -17.1936,
                                32.87035
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -28.39031,
                                38.55814
                            ],
                            [
                                -28.47558,
                                38.56035
                            ],
                            [
                                -28.53477,
                                38.53272
                            ],
                            [
                                -28.51613,
                                38.45266
                            ],
                            [
                                -28.41134,
                                38.42762
                            ],
                            [
                                -28.08178,
                                38.40023
                            ],
                            [
                                -28.05826,
                                38.44293
                            ],
                            [
                                -28.19124,
                                38.46298
                            ],
                            [
                                -28.39031,
                                38.55814
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -27.2567,
                                38.80249
                            ],
                            [
                                -27.33284,
                                38.79339
                            ],
                            [
                                -27.37905,
                                38.7475
                            ],
                            [
                                -27.35137,
                                38.68739
                            ],
                            [
                                -27.27683,
                                38.65301
                            ],
                            [
                                -27.07995,
                                38.64409
                            ],
                            [
                                -27.06838,
                                38.76559
                            ],
                            [
                                -27.2567,
                                38.80249
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -28.08982,
                                38.6874
                            ],
                            [
                                -28.19055,
                                38.66702
                            ],
                            [
                                -28.02578,
                                38.60236
                            ],
                            [
                                -27.94371,
                                38.58951
                            ],
                            [
                                -27.82792,
                                38.53384
                            ],
                            [
                                -27.82269,
                                38.57971
                            ],
                            [
                                -28.02492,
                                38.67202
                            ],
                            [
                                -28.08982,
                                38.6874
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -28.62162,
                                38.61113
                            ],
                            [
                                -28.71477,
                                38.64369
                            ],
                            [
                                -28.81361,
                                38.58094
                            ],
                            [
                                -28.72085,
                                38.51779
                            ],
                            [
                                -28.62752,
                                38.52543
                            ],
                            [
                                -28.62162,
                                38.61113
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -31.20754,
                                39.52349
                            ],
                            [
                                -31.26791,
                                39.4519
                            ],
                            [
                                -31.24811,
                                39.37615
                            ],
                            [
                                -31.17596,
                                39.37535
                            ],
                            [
                                -31.12837,
                                39.44851
                            ],
                            [
                                -31.20754,
                                39.52349
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -25.08718,
                                37.01588
                            ],
                            [
                                -25.18492,
                                36.98499
                            ],
                            [
                                -25.16669,
                                36.945
                            ],
                            [
                                -25.01953,
                                36.96327
                            ],
                            [
                                -25.08718,
                                37.01588
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "QAT",
                "Country": "Qatar",
                "Total_3GHG": 0.24,
                "Total_3GHG_timeseries": [
                    9.4664e-09,
                    1.9042e-08,
                    2.8731e-08,
                    3.8523e-08,
                    4.8408e-08,
                    5.838e-08,
                    6.8438e-08,
                    7.8569e-08,
                    8.8769e-08,
                    9.9018e-08,
                    1.0922e-07,
                    1.1938e-07,
                    1.2948e-07,
                    1.3955e-07,
                    1.4956e-07,
                    1.5952e-07,
                    1.6944e-07,
                    1.793e-07,
                    1.8913e-07,
                    1.9891e-07,
                    2.0869e-07,
                    2.1856e-07,
                    2.286e-07,
                    2.3884e-07,
                    2.4933e-07,
                    2.6005e-07,
                    2.71e-07,
                    2.8215e-07,
                    2.9344e-07,
                    3.0479e-07,
                    3.1624e-07,
                    3.2777e-07,
                    3.3937e-07,
                    3.5105e-07,
                    3.6278e-07,
                    3.7458e-07,
                    3.8643e-07,
                    3.9836e-07,
                    4.1035e-07,
                    4.2243e-07,
                    4.346e-07,
                    4.4684e-07,
                    4.5915e-07,
                    4.7155e-07,
                    4.8403e-07,
                    4.9659e-07,
                    5.0924e-07,
                    5.2199e-07,
                    5.3483e-07,
                    5.4778e-07,
                    5.6072e-07,
                    5.7368e-07,
                    5.8669e-07,
                    5.9973e-07,
                    6.1284e-07,
                    6.26e-07,
                    6.3923e-07,
                    6.5253e-07,
                    6.6589e-07,
                    6.7946e-07,
                    6.9329e-07,
                    7.0736e-07,
                    7.2165e-07,
                    7.3616e-07,
                    7.5087e-07,
                    7.658e-07,
                    7.8094e-07,
                    7.9629e-07,
                    8.1185e-07,
                    8.2771e-07,
                    8.4397e-07,
                    8.6061e-07,
                    8.7764e-07,
                    8.9505e-07,
                    9.1286e-07,
                    9.3106e-07,
                    9.4963e-07,
                    9.6859e-07,
                    9.8791e-07,
                    1.0077e-06,
                    1.0278e-06,
                    1.0481e-06,
                    1.0686e-06,
                    1.0893e-06,
                    1.1102e-06,
                    1.1317e-06,
                    1.1538e-06,
                    1.1764e-06,
                    1.1998e-06,
                    1.224e-06,
                    1.2497e-06,
                    1.2771e-06,
                    1.3066e-06,
                    1.3384e-06,
                    1.3725e-06,
                    1.4088e-06,
                    1.4472e-06,
                    1.4878e-06,
                    4.2202e-06,
                    7.9121e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0019,
                    0.0021,
                    0.0022,
                    0.0024,
                    0.0026,
                    0.0028,
                    0.003,
                    0.0032,
                    0.0033,
                    0.0035,
                    0.0036,
                    0.0038,
                    0.004
                ],
                "Fossil_3GHG": 0.37,
                "Fossil_3GHG_timeseries": [
                    8.1419e-09,
                    1.6377e-08,
                    2.4702e-08,
                    3.3114e-08,
                    4.161e-08,
                    5.0182e-08,
                    5.8826e-08,
                    6.7534e-08,
                    7.6297e-08,
                    8.5108e-08,
                    9.3901e-08,
                    1.0267e-07,
                    1.1143e-07,
                    1.2016e-07,
                    1.2887e-07,
                    1.3756e-07,
                    1.4624e-07,
                    1.5489e-07,
                    1.6352e-07,
                    1.7214e-07,
                    1.8079e-07,
                    1.8954e-07,
                    1.9847e-07,
                    2.0762e-07,
                    2.1701e-07,
                    2.2664e-07,
                    2.3651e-07,
                    2.4659e-07,
                    2.5682e-07,
                    2.6713e-07,
                    2.7753e-07,
                    2.8801e-07,
                    2.9856e-07,
                    3.0917e-07,
                    3.1985e-07,
                    3.3058e-07,
                    3.4137e-07,
                    3.5222e-07,
                    3.6314e-07,
                    3.7413e-07,
                    3.8519e-07,
                    3.9633e-07,
                    4.0754e-07,
                    4.1883e-07,
                    4.302e-07,
                    4.4165e-07,
                    4.5319e-07,
                    4.6482e-07,
                    4.7654e-07,
                    4.8837e-07,
                    5.0019e-07,
                    5.1202e-07,
                    5.2389e-07,
                    5.3579e-07,
                    5.4774e-07,
                    5.5975e-07,
                    5.7183e-07,
                    5.8396e-07,
                    5.9615e-07,
                    6.084e-07,
                    6.2078e-07,
                    6.333e-07,
                    6.4595e-07,
                    6.5874e-07,
                    6.7166e-07,
                    6.8472e-07,
                    6.9792e-07,
                    7.1126e-07,
                    7.2474e-07,
                    7.3836e-07,
                    7.5224e-07,
                    7.6639e-07,
                    7.8081e-07,
                    7.955e-07,
                    8.1045e-07,
                    8.2567e-07,
                    8.4115e-07,
                    8.5689e-07,
                    8.7287e-07,
                    8.8911e-07,
                    9.0551e-07,
                    9.2207e-07,
                    9.3878e-07,
                    9.5566e-07,
                    9.727e-07,
                    9.8992e-07,
                    1.0073e-06,
                    1.0249e-06,
                    1.0428e-06,
                    1.061e-06,
                    1.0801e-06,
                    1.1005e-06,
                    1.1225e-06,
                    1.1463e-06,
                    1.1717e-06,
                    1.1988e-06,
                    1.2276e-06,
                    1.258e-06,
                    3.9796e-06,
                    7.6598e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0019,
                    0.0021,
                    0.0022,
                    0.0024,
                    0.0026,
                    0.0028,
                    0.003,
                    0.0032,
                    0.0033,
                    0.0035,
                    0.0036,
                    0.0038,
                    0.004
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [
                    1.3245e-09,
                    2.6658e-09,
                    4.029e-09,
                    5.4085e-09,
                    6.7983e-09,
                    8.1979e-09,
                    9.6123e-09,
                    1.1035e-08,
                    1.2472e-08,
                    1.391e-08,
                    1.5321e-08,
                    1.6705e-08,
                    1.8057e-08,
                    1.9387e-08,
                    2.069e-08,
                    2.196e-08,
                    2.3204e-08,
                    2.4414e-08,
                    2.5604e-08,
                    2.6766e-08,
                    2.7905e-08,
                    2.9021e-08,
                    3.0127e-08,
                    3.1226e-08,
                    3.232e-08,
                    3.341e-08,
                    3.449e-08,
                    3.5562e-08,
                    3.6621e-08,
                    3.7661e-08,
                    3.8707e-08,
                    3.9759e-08,
                    4.0815e-08,
                    4.1876e-08,
                    4.2934e-08,
                    4.3997e-08,
                    4.5063e-08,
                    4.6132e-08,
                    4.7206e-08,
                    4.8304e-08,
                    4.9404e-08,
                    5.0505e-08,
                    5.1609e-08,
                    5.2715e-08,
                    5.3824e-08,
                    5.4936e-08,
                    5.6051e-08,
                    5.7169e-08,
                    5.8291e-08,
                    5.941e-08,
                    6.0534e-08,
                    6.1661e-08,
                    6.28e-08,
                    6.3943e-08,
                    6.5092e-08,
                    6.6247e-08,
                    6.7408e-08,
                    6.8575e-08,
                    6.9743e-08,
                    7.1059e-08,
                    7.2511e-08,
                    7.406e-08,
                    7.5699e-08,
                    7.7418e-08,
                    7.9211e-08,
                    8.108e-08,
                    8.3018e-08,
                    8.5028e-08,
                    8.711e-08,
                    8.9354e-08,
                    9.1728e-08,
                    9.4213e-08,
                    9.6824e-08,
                    9.9552e-08,
                    1.0241e-07,
                    1.0539e-07,
                    1.0848e-07,
                    1.117e-07,
                    1.1504e-07,
                    1.186e-07,
                    1.2226e-07,
                    1.2599e-07,
                    1.2979e-07,
                    1.3363e-07,
                    1.3749e-07,
                    1.4176e-07,
                    1.4644e-07,
                    1.5152e-07,
                    1.5699e-07,
                    1.6304e-07,
                    1.6956e-07,
                    1.7657e-07,
                    1.8411e-07,
                    1.9217e-07,
                    2.008e-07,
                    2.0996e-07,
                    2.1963e-07,
                    2.2987e-07,
                    2.4063e-07,
                    2.5226e-07,
                    2.6595e-07,
                    2.8144e-07,
                    2.9856e-07,
                    3.1723e-07,
                    3.3753e-07,
                    3.5916e-07,
                    3.8207e-07,
                    4.0633e-07,
                    4.3023e-07,
                    4.5806e-07,
                    4.863e-07,
                    5.1631e-07,
                    5.4787e-07,
                    5.8108e-07,
                    6.1486e-07,
                    6.5073e-07,
                    6.8851e-07,
                    7.2745e-07,
                    7.6738e-07,
                    8.0883e-07,
                    8.4997e-07,
                    8.9247e-07,
                    9.3907e-07,
                    9.8257e-07,
                    1.0278e-06,
                    1.0757e-06,
                    1.1282e-06,
                    1.1795e-06,
                    1.2456e-06,
                    1.3116e-06,
                    1.3775e-06,
                    1.4084e-06,
                    1.4442e-06,
                    1.4858e-06,
                    1.5584e-06,
                    1.6688e-06,
                    1.7962e-06,
                    1.9228e-06,
                    2.0589e-06,
                    2.2072e-06,
                    2.38e-06,
                    2.5822e-06,
                    2.8082e-06,
                    3.0668e-06,
                    3.337e-06,
                    3.5943e-06,
                    3.8492e-06,
                    4.108e-06,
                    4.3617e-06,
                    4.6175e-06,
                    4.7749e-06,
                    4.9687e-06,
                    5.1568e-06,
                    5.3407e-06,
                    5.4261e-06,
                    5.5079e-06,
                    5.6053e-06,
                    5.6996e-06,
                    5.8713e-06,
                    6.048e-06,
                    6.2581e-06,
                    6.4833e-06,
                    6.7426e-06,
                    6.892e-06,
                    7.2592e-06,
                    7.7362e-06,
                    8.2777e-06,
                    8.9254e-06,
                    9.6056e-06,
                    0,
                    0,
                    0
                ],
                "Total_CO2": 0.09,
                "Total_CO2_timeseries": [
                    -0.000000000121,
                    -0.0000000002365,
                    -0.000000000341,
                    -0.00000000044,
                    -0.000000000539,
                    -0.000000000638,
                    -0.0000000007315,
                    -0.000000000825,
                    -0.000000000913,
                    -0.0000000010065,
                    -0.0000000011,
                    -0.0000000011935,
                    -0.0000000012925,
                    -0.000000001386,
                    -0.0000000014795,
                    -0.0000000015785,
                    -0.0000000016775,
                    -0.000000001782,
                    -0.000000001881,
                    -0.00000000198,
                    -0.000000002079,
                    -0.0000000021835,
                    -0.000000002288,
                    -0.0000000023925,
                    -0.000000002497,
                    -0.0000000026015,
                    -0.0000000027115,
                    -0.0000000028215,
                    -0.0000000029315,
                    -0.0000000030415,
                    -0.0000000031515,
                    -0.0000000032615,
                    -0.0000000033715,
                    -0.0000000034815,
                    -0.000000003597,
                    -0.0000000037125,
                    -0.000000003828,
                    -0.0000000039435,
                    -0.000000004059,
                    -0.0000000041745,
                    -0.00000000429,
                    -0.0000000044055,
                    -0.000000004521,
                    -0.0000000046365,
                    -0.000000004752,
                    -0.0000000048675,
                    -0.000000004983,
                    -0.0000000050985,
                    -0.000000005214,
                    -0.000000005335,
                    -0.000000005456,
                    -0.000000005577,
                    -0.0000000056925,
                    -0.000000005808,
                    -0.0000000059235,
                    -0.000000006039,
                    -0.0000000061545,
                    -0.00000000627,
                    -0.000000006391,
                    -0.000000006369,
                    -0.0000000062755,
                    -0.000000006149,
                    -0.000000005995,
                    -0.0000000058245,
                    -0.000000005643,
                    -0.0000000054505,
                    -0.0000000052525,
                    -0.000000005049,
                    -0.00000000484,
                    -0.0000000045375,
                    -0.0000000041855,
                    -0.000000003817,
                    -0.0000000034265,
                    -0.0000000030305,
                    -0.000000002618,
                    -0.000000002211,
                    -0.000000001804,
                    -0.0000000013915,
                    -0.000000000979,
                    -0.00000000044,
                    1.375e-10,
                    7.425e-10,
                    1.364e-09,
                    1.9745e-09,
                    2.5685e-09,
                    3.1625e-09,
                    3.7455e-09,
                    4.3065e-09,
                    4.84e-09,
                    5.511e-09,
                    6.1985e-09,
                    6.8695e-09,
                    7.535e-09,
                    8.1675e-09,
                    8.7835e-09,
                    9.361e-09,
                    9.867e-09,
                    1.0357e-08,
                    1.2796e-07,
                    2.8716e-07,
                    4.6271e-07,
                    5.5042e-07,
                    7.1517e-07,
                    9.883e-07,
                    1.1752e-06,
                    1.4015e-06,
                    1.5397e-06,
                    1.613e-06,
                    1.69e-06,
                    1.7646e-06,
                    1.8331e-06,
                    1.9155e-06,
                    4.6747e-06,
                    7.4954e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001
                ],
                "Fossil_CO2": 0.13,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.1715e-07,
                    2.7555e-07,
                    4.5045e-07,
                    5.379e-07,
                    7.029e-07,
                    9.768e-07,
                    1.1649e-06,
                    1.3926e-06,
                    1.5329e-06,
                    1.6088e-06,
                    1.6912e-06,
                    1.7704e-06,
                    1.8431e-06,
                    1.9289e-06,
                    4.691e-06,
                    7.5141e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [
                    -0.000000000121,
                    -0.0000000002365,
                    -0.000000000341,
                    -0.00000000044,
                    -0.000000000539,
                    -0.000000000638,
                    -0.0000000007315,
                    -0.000000000825,
                    -0.000000000913,
                    -0.0000000010065,
                    -0.0000000011,
                    -0.0000000011935,
                    -0.0000000012925,
                    -0.000000001386,
                    -0.0000000014795,
                    -0.0000000015785,
                    -0.0000000016775,
                    -0.000000001782,
                    -0.000000001881,
                    -0.00000000198,
                    -0.000000002079,
                    -0.0000000021835,
                    -0.000000002288,
                    -0.0000000023925,
                    -0.000000002497,
                    -0.0000000026015,
                    -0.0000000027115,
                    -0.0000000028215,
                    -0.0000000029315,
                    -0.0000000030415,
                    -0.0000000031515,
                    -0.0000000032615,
                    -0.0000000033715,
                    -0.0000000034815,
                    -0.000000003597,
                    -0.0000000037125,
                    -0.000000003828,
                    -0.0000000039435,
                    -0.000000004059,
                    -0.0000000041745,
                    -0.00000000429,
                    -0.0000000044055,
                    -0.000000004521,
                    -0.0000000046365,
                    -0.000000004752,
                    -0.0000000048675,
                    -0.000000004983,
                    -0.0000000050985,
                    -0.000000005214,
                    -0.000000005335,
                    -0.000000005456,
                    -0.000000005577,
                    -0.0000000056925,
                    -0.000000005808,
                    -0.0000000059235,
                    -0.000000006039,
                    -0.0000000061545,
                    -0.00000000627,
                    -0.000000006391,
                    -0.000000006369,
                    -0.0000000062755,
                    -0.000000006149,
                    -0.000000005995,
                    -0.0000000058245,
                    -0.000000005643,
                    -0.0000000054505,
                    -0.0000000052525,
                    -0.000000005049,
                    -0.00000000484,
                    -0.0000000045375,
                    -0.0000000041855,
                    -0.000000003817,
                    -0.0000000034265,
                    -0.0000000030305,
                    -0.000000002618,
                    -0.000000002211,
                    -0.000000001804,
                    -0.0000000013915,
                    -0.000000000979,
                    -0.00000000044,
                    1.375e-10,
                    7.425e-10,
                    1.364e-09,
                    1.9745e-09,
                    2.5685e-09,
                    3.1625e-09,
                    3.7455e-09,
                    4.3065e-09,
                    4.84e-09,
                    5.511e-09,
                    6.1985e-09,
                    6.8695e-09,
                    7.535e-09,
                    8.1675e-09,
                    8.7835e-09,
                    9.361e-09,
                    9.867e-09,
                    1.0357e-08,
                    1.0813e-08,
                    1.1605e-08,
                    1.2265e-08,
                    1.2523e-08,
                    1.2271e-08,
                    1.1495e-08,
                    1.0345e-08,
                    8.8605e-09,
                    6.897e-09,
                    4.2625e-09,
                    -0.000000001221,
                    -0.000000005896,
                    -0.000000009922,
                    -0.000000013354,
                    -0.000000016275,
                    -0.000000018749,
                    -0.000000020873,
                    -0.000000022688,
                    -0.000000024227,
                    -0.000000025536,
                    -0.000000026625,
                    -0.000000027544,
                    -0.000000028358,
                    -0.000000027962,
                    -0.000000024112,
                    -0.000000021621,
                    -0.000000019459,
                    -0.000000017446,
                    -0.000000015339,
                    -0.000000007986,
                    5.6925e-09,
                    2.0444e-08,
                    3.7466e-08,
                    5.6001e-08,
                    7.3678e-08,
                    8.8775e-08,
                    1.0618e-07,
                    1.2361e-07,
                    1.3603e-07,
                    1.464e-07,
                    1.5841e-07,
                    1.7016e-07,
                    1.9206e-07,
                    2.1338e-07,
                    2.3064e-07,
                    2.4704e-07,
                    2.6302e-07,
                    2.7496e-07,
                    2.8492e-07,
                    2.939e-07,
                    3.0128e-07,
                    3.0865e-07,
                    3.1241e-07,
                    3.1623e-07,
                    3.1968e-07,
                    3.2229e-07,
                    3.2992e-07,
                    3.3666e-07,
                    3.4693e-07,
                    3.5309e-07,
                    3.6104e-07,
                    3.657e-07,
                    3.7459e-07,
                    3.8826e-07,
                    3.955e-07,
                    4.0219e-07,
                    4.0571e-07,
                    4.0863e-07,
                    4.1053e-07,
                    4.1182e-07,
                    4.1272e-07,
                    4.1345e-07,
                    4.1406e-07,
                    4.1457e-07
                ],
                "Total_CH4": 0.7,
                "Total_CH4_timeseries": [
                    2.9024e-09,
                    5.8117e-09,
                    8.7278e-09,
                    1.1651e-08,
                    1.4581e-08,
                    1.7517e-08,
                    2.046e-08,
                    2.3409e-08,
                    2.6365e-08,
                    2.9327e-08,
                    3.2203e-08,
                    3.4992e-08,
                    3.7696e-08,
                    4.0313e-08,
                    4.2845e-08,
                    4.5292e-08,
                    4.7653e-08,
                    4.9928e-08,
                    5.2119e-08,
                    5.4225e-08,
                    5.624e-08,
                    5.8165e-08,
                    6e-08,
                    6.1746e-08,
                    6.3401e-08,
                    6.4968e-08,
                    6.6445e-08,
                    6.7832e-08,
                    6.9132e-08,
                    7.0342e-08,
                    7.1545e-08,
                    7.274e-08,
                    7.3928e-08,
                    7.5108e-08,
                    7.628e-08,
                    7.7445e-08,
                    7.8602e-08,
                    7.9752e-08,
                    8.0894e-08,
                    8.2028e-08,
                    8.3153e-08,
                    8.4271e-08,
                    8.5379e-08,
                    8.6479e-08,
                    8.757e-08,
                    8.8653e-08,
                    8.9727e-08,
                    9.0792e-08,
                    9.1849e-08,
                    9.2896e-08,
                    9.3818e-08,
                    9.4616e-08,
                    9.5291e-08,
                    9.5847e-08,
                    9.6285e-08,
                    9.6607e-08,
                    9.6816e-08,
                    9.6914e-08,
                    9.6902e-08,
                    9.6783e-08,
                    9.6699e-08,
                    9.665e-08,
                    9.6636e-08,
                    9.6659e-08,
                    9.6719e-08,
                    9.6816e-08,
                    9.6952e-08,
                    9.7127e-08,
                    9.7343e-08,
                    9.7599e-08,
                    9.8019e-08,
                    9.8602e-08,
                    9.9348e-08,
                    1.0026e-07,
                    1.0133e-07,
                    1.0255e-07,
                    1.0394e-07,
                    1.0549e-07,
                    1.072e-07,
                    1.0907e-07,
                    1.1098e-07,
                    1.1293e-07,
                    1.1493e-07,
                    1.1697e-07,
                    1.1906e-07,
                    1.2156e-07,
                    1.2448e-07,
                    1.2783e-07,
                    1.3161e-07,
                    1.359e-07,
                    1.4113e-07,
                    1.4728e-07,
                    1.5438e-07,
                    1.6243e-07,
                    1.7123e-07,
                    1.8078e-07,
                    1.9107e-07,
                    2.0209e-07,
                    2.7866e-06,
                    6.2881e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0018,
                    0.0019,
                    0.0021,
                    0.0022,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029
                ],
                "Fossil_CH4": 1.12,
                "Fossil_CH4_timeseries": [
                    1.7165e-09,
                    3.4339e-09,
                    5.1521e-09,
                    6.8711e-09,
                    8.5908e-09,
                    1.0311e-08,
                    1.2032e-08,
                    1.3753e-08,
                    1.5474e-08,
                    1.7196e-08,
                    1.8859e-08,
                    2.0463e-08,
                    2.2008e-08,
                    2.3494e-08,
                    2.4923e-08,
                    2.6292e-08,
                    2.7604e-08,
                    2.8858e-08,
                    3.0054e-08,
                    3.1193e-08,
                    3.227e-08,
                    3.3286e-08,
                    3.4241e-08,
                    3.5135e-08,
                    3.5968e-08,
                    3.6742e-08,
                    3.7455e-08,
                    3.8108e-08,
                    3.8701e-08,
                    3.9234e-08,
                    3.9759e-08,
                    4.0276e-08,
                    4.0785e-08,
                    4.1286e-08,
                    4.1778e-08,
                    4.2262e-08,
                    4.2737e-08,
                    4.3205e-08,
                    4.3663e-08,
                    4.4114e-08,
                    4.4555e-08,
                    4.4987e-08,
                    4.541e-08,
                    4.5823e-08,
                    4.6227e-08,
                    4.6622e-08,
                    4.7008e-08,
                    4.7384e-08,
                    4.775e-08,
                    4.8107e-08,
                    4.8338e-08,
                    4.8444e-08,
                    4.8426e-08,
                    4.8289e-08,
                    4.8033e-08,
                    4.766e-08,
                    4.7174e-08,
                    4.6575e-08,
                    4.5867e-08,
                    4.505e-08,
                    4.4209e-08,
                    4.3344e-08,
                    4.2456e-08,
                    4.1545e-08,
                    4.0611e-08,
                    3.9656e-08,
                    3.868e-08,
                    3.7685e-08,
                    3.667e-08,
                    3.5637e-08,
                    3.4704e-08,
                    3.3869e-08,
                    3.3133e-08,
                    3.2494e-08,
                    3.1952e-08,
                    3.1507e-08,
                    3.1157e-08,
                    3.0902e-08,
                    3.0742e-08,
                    3.0677e-08,
                    3.0639e-08,
                    3.0628e-08,
                    3.0646e-08,
                    3.0696e-08,
                    3.0779e-08,
                    3.0896e-08,
                    3.1049e-08,
                    3.124e-08,
                    3.1471e-08,
                    3.1824e-08,
                    3.2692e-08,
                    3.4082e-08,
                    3.5997e-08,
                    3.8444e-08,
                    4.1213e-08,
                    4.4291e-08,
                    4.7666e-08,
                    5.1325e-08,
                    2.6281e-06,
                    6.1213e-06,
                    9.9909e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0018,
                    0.0019,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029
                ],
                "Land_CH4": 0.01,
                "Land_CH4_timeseries": [
                    1.1859e-09,
                    2.3778e-09,
                    3.5757e-09,
                    4.7797e-09,
                    5.9898e-09,
                    7.2059e-09,
                    8.428e-09,
                    9.6562e-09,
                    1.089e-08,
                    1.2131e-08,
                    1.3344e-08,
                    1.4529e-08,
                    1.5688e-08,
                    1.6819e-08,
                    1.7923e-08,
                    1.8999e-08,
                    2.0048e-08,
                    2.107e-08,
                    2.2065e-08,
                    2.3032e-08,
                    2.397e-08,
                    2.488e-08,
                    2.576e-08,
                    2.6611e-08,
                    2.7433e-08,
                    2.8226e-08,
                    2.899e-08,
                    2.9725e-08,
                    3.0431e-08,
                    3.1108e-08,
                    3.1785e-08,
                    3.2463e-08,
                    3.3142e-08,
                    3.3822e-08,
                    3.4502e-08,
                    3.5183e-08,
                    3.5865e-08,
                    3.6547e-08,
                    3.723e-08,
                    3.7914e-08,
                    3.8598e-08,
                    3.9283e-08,
                    3.9969e-08,
                    4.0656e-08,
                    4.1343e-08,
                    4.2031e-08,
                    4.2719e-08,
                    4.3408e-08,
                    4.4098e-08,
                    4.4789e-08,
                    4.548e-08,
                    4.6172e-08,
                    4.6865e-08,
                    4.7558e-08,
                    4.8252e-08,
                    4.8947e-08,
                    4.9642e-08,
                    5.0339e-08,
                    5.1035e-08,
                    5.1733e-08,
                    5.2489e-08,
                    5.3305e-08,
                    5.418e-08,
                    5.5114e-08,
                    5.6108e-08,
                    5.716e-08,
                    5.8272e-08,
                    5.9443e-08,
                    6.0673e-08,
                    6.1962e-08,
                    6.3315e-08,
                    6.4733e-08,
                    6.6215e-08,
                    6.7762e-08,
                    6.9373e-08,
                    7.1048e-08,
                    7.2787e-08,
                    7.4591e-08,
                    7.6459e-08,
                    7.8392e-08,
                    8.034e-08,
                    8.2302e-08,
                    8.428e-08,
                    8.6273e-08,
                    8.8281e-08,
                    9.0666e-08,
                    9.3433e-08,
                    9.6588e-08,
                    1.0014e-07,
                    1.0408e-07,
                    1.0843e-07,
                    1.132e-07,
                    1.1838e-07,
                    1.2399e-07,
                    1.3002e-07,
                    1.3649e-07,
                    1.434e-07,
                    1.5076e-07,
                    1.5857e-07,
                    1.6684e-07,
                    1.7723e-07,
                    1.8973e-07,
                    2.0428e-07,
                    2.208e-07,
                    2.3923e-07,
                    2.5922e-07,
                    2.8089e-07,
                    3.045e-07,
                    3.3055e-07,
                    3.5968e-07,
                    3.8819e-07,
                    4.1775e-07,
                    4.4822e-07,
                    4.7977e-07,
                    5.1146e-07,
                    5.4476e-07,
                    5.7949e-07,
                    6.1502e-07,
                    6.5121e-07,
                    6.8858e-07,
                    7.2539e-07,
                    7.6213e-07,
                    7.9927e-07,
                    8.3465e-07,
                    8.7129e-07,
                    9.0999e-07,
                    9.5276e-07,
                    9.8923e-07,
                    1.0324e-06,
                    1.0733e-06,
                    1.1118e-06,
                    1.1174e-06,
                    1.1278e-06,
                    1.1455e-06,
                    1.1891e-06,
                    1.2684e-06,
                    1.367e-06,
                    1.466e-06,
                    1.5695e-06,
                    1.6843e-06,
                    1.8115e-06,
                    1.9661e-06,
                    2.1456e-06,
                    2.3461e-06,
                    2.5571e-06,
                    2.7707e-06,
                    2.9838e-06,
                    3.2027e-06,
                    3.4176e-06,
                    3.634e-06,
                    3.7621e-06,
                    3.9248e-06,
                    4.0824e-06,
                    4.2362e-06,
                    4.2904e-06,
                    4.3403e-06,
                    4.4002e-06,
                    4.4598e-06,
                    4.5883e-06,
                    4.7229e-06,
                    4.8833e-06,
                    5.0498e-06,
                    5.2489e-06,
                    5.3388e-06,
                    5.6389e-06,
                    6.0393e-06,
                    6.5017e-06,
                    7.0662e-06,
                    7.6615e-06,
                    8.2538e-06,
                    8.8757e-06,
                    9.5528e-06
                ],
                "Total_N2O": 0.01,
                "Total_N2O_timeseries": [
                    6.685e-09,
                    1.3467e-08,
                    2.0344e-08,
                    2.7312e-08,
                    3.4366e-08,
                    4.1501e-08,
                    4.871e-08,
                    5.5985e-08,
                    6.3317e-08,
                    7.0697e-08,
                    7.8119e-08,
                    8.5581e-08,
                    9.3081e-08,
                    1.0062e-07,
                    1.082e-07,
                    1.1581e-07,
                    1.2346e-07,
                    1.3116e-07,
                    1.3889e-07,
                    1.4666e-07,
                    1.5453e-07,
                    1.6258e-07,
                    1.7089e-07,
                    1.7949e-07,
                    1.8842e-07,
                    1.9769e-07,
                    2.0727e-07,
                    2.1714e-07,
                    2.2724e-07,
                    2.3749e-07,
                    2.4784e-07,
                    2.5829e-07,
                    2.6882e-07,
                    2.7942e-07,
                    2.901e-07,
                    3.0084e-07,
                    3.1166e-07,
                    3.2255e-07,
                    3.3351e-07,
                    3.4458e-07,
                    3.5573e-07,
                    3.6697e-07,
                    3.7829e-07,
                    3.8971e-07,
                    4.0121e-07,
                    4.128e-07,
                    4.245e-07,
                    4.3629e-07,
                    4.482e-07,
                    4.6022e-07,
                    4.7236e-07,
                    4.8465e-07,
                    4.9709e-07,
                    5.0969e-07,
                    5.2247e-07,
                    5.3543e-07,
                    5.4857e-07,
                    5.6189e-07,
                    5.7538e-07,
                    5.8905e-07,
                    6.0287e-07,
                    6.1686e-07,
                    6.3101e-07,
                    6.4532e-07,
                    6.598e-07,
                    6.7444e-07,
                    6.8924e-07,
                    7.0421e-07,
                    7.1934e-07,
                    7.3465e-07,
                    7.5014e-07,
                    7.6582e-07,
                    7.8171e-07,
                    7.9782e-07,
                    8.1416e-07,
                    8.3071e-07,
                    8.4749e-07,
                    8.6449e-07,
                    8.8169e-07,
                    8.9908e-07,
                    9.1665e-07,
                    9.3439e-07,
                    9.5229e-07,
                    9.7034e-07,
                    9.8856e-07,
                    1.007e-06,
                    1.0255e-06,
                    1.0443e-06,
                    1.0633e-06,
                    1.0826e-06,
                    1.1023e-06,
                    1.1229e-06,
                    1.1447e-06,
                    1.1678e-06,
                    1.1925e-06,
                    1.2186e-06,
                    1.2463e-06,
                    1.2754e-06,
                    1.3056e-06,
                    1.3368e-06,
                    1.3687e-06,
                    1.4012e-06,
                    1.4343e-06,
                    1.4679e-06,
                    1.502e-06,
                    1.5366e-06,
                    1.5717e-06,
                    1.6075e-06,
                    1.6439e-06,
                    1.681e-06,
                    1.7193e-06,
                    1.7591e-06,
                    1.8004e-06,
                    1.8435e-06,
                    1.8885e-06,
                    1.9354e-06,
                    1.9845e-06,
                    2.0355e-06,
                    2.0882e-06,
                    2.1264e-06,
                    2.1727e-06,
                    2.2274e-06,
                    2.2881e-06,
                    2.3421e-06,
                    2.3959e-06,
                    2.4497e-06,
                    2.5023e-06,
                    2.5595e-06,
                    2.6161e-06,
                    2.6685e-06,
                    2.7157e-06,
                    2.7638e-06,
                    2.8105e-06,
                    2.8669e-06,
                    2.925e-06,
                    2.9868e-06,
                    3.0518e-06,
                    3.1197e-06,
                    3.1946e-06,
                    3.268e-06,
                    3.3442e-06,
                    3.424e-06,
                    3.5091e-06,
                    3.6105e-06,
                    3.7176e-06,
                    3.8196e-06,
                    3.9359e-06,
                    4.0545e-06,
                    4.1741e-06,
                    4.287e-06,
                    4.3939e-06,
                    4.5173e-06,
                    4.644e-06,
                    4.7772e-06,
                    4.9184e-06,
                    5.0758e-06,
                    5.2595e-06,
                    5.46e-06,
                    5.6691e-06,
                    5.9027e-06,
                    6.1461e-06,
                    6.403e-06,
                    6.6857e-06,
                    6.9941e-06,
                    7.3227e-06,
                    7.6648e-06,
                    8.0156e-06,
                    8.368e-06,
                    8.733e-06,
                    9.1079e-06,
                    9.4937e-06,
                    9.8995e-06
                ],
                "Fossil_N2O": 0.04,
                "Fossil_N2O_timeseries": [
                    6.4254e-09,
                    1.2943e-08,
                    1.955e-08,
                    2.6243e-08,
                    3.3019e-08,
                    3.9871e-08,
                    4.6794e-08,
                    5.3781e-08,
                    6.0823e-08,
                    6.7912e-08,
                    7.5042e-08,
                    8.2211e-08,
                    8.942e-08,
                    9.6666e-08,
                    1.0395e-07,
                    1.1127e-07,
                    1.1863e-07,
                    1.2603e-07,
                    1.3347e-07,
                    1.4095e-07,
                    1.4852e-07,
                    1.5626e-07,
                    1.6423e-07,
                    1.7248e-07,
                    1.8104e-07,
                    1.899e-07,
                    1.9906e-07,
                    2.0848e-07,
                    2.1812e-07,
                    2.2789e-07,
                    2.3777e-07,
                    2.4773e-07,
                    2.5777e-07,
                    2.6789e-07,
                    2.7807e-07,
                    2.8832e-07,
                    2.9863e-07,
                    3.0902e-07,
                    3.1948e-07,
                    3.3002e-07,
                    3.4064e-07,
                    3.5134e-07,
                    3.6213e-07,
                    3.7301e-07,
                    3.8397e-07,
                    3.9503e-07,
                    4.0618e-07,
                    4.1743e-07,
                    4.2879e-07,
                    4.4026e-07,
                    4.5185e-07,
                    4.6358e-07,
                    4.7546e-07,
                    4.875e-07,
                    4.9971e-07,
                    5.1209e-07,
                    5.2465e-07,
                    5.3738e-07,
                    5.5028e-07,
                    5.6335e-07,
                    5.7657e-07,
                    5.8996e-07,
                    6.035e-07,
                    6.172e-07,
                    6.3105e-07,
                    6.4507e-07,
                    6.5924e-07,
                    6.7357e-07,
                    6.8807e-07,
                    7.0272e-07,
                    7.1754e-07,
                    7.3252e-07,
                    7.4768e-07,
                    7.63e-07,
                    7.785e-07,
                    7.9416e-07,
                    8.0999e-07,
                    8.2598e-07,
                    8.4213e-07,
                    8.5843e-07,
                    8.7487e-07,
                    8.9144e-07,
                    9.0814e-07,
                    9.2496e-07,
                    9.4192e-07,
                    9.5902e-07,
                    9.7627e-07,
                    9.9369e-07,
                    1.0113e-06,
                    1.0291e-06,
                    1.0474e-06,
                    1.0664e-06,
                    1.0865e-06,
                    1.1078e-06,
                    1.1305e-06,
                    1.1545e-06,
                    1.1799e-06,
                    1.2066e-06,
                    1.2344e-06,
                    1.263e-06,
                    1.2922e-06,
                    1.322e-06,
                    1.3522e-06,
                    1.3829e-06,
                    1.414e-06,
                    1.4455e-06,
                    1.4775e-06,
                    1.5099e-06,
                    1.543e-06,
                    1.5767e-06,
                    1.6113e-06,
                    1.6472e-06,
                    1.6845e-06,
                    1.7234e-06,
                    1.7642e-06,
                    1.8068e-06,
                    1.8512e-06,
                    1.8975e-06,
                    1.9454e-06,
                    1.9787e-06,
                    2.0198e-06,
                    2.0691e-06,
                    2.1242e-06,
                    2.1726e-06,
                    2.2199e-06,
                    2.2666e-06,
                    2.3115e-06,
                    2.3612e-06,
                    2.4086e-06,
                    2.4506e-06,
                    2.4875e-06,
                    2.5288e-06,
                    2.5678e-06,
                    2.6154e-06,
                    2.6619e-06,
                    2.7099e-06,
                    2.7586e-06,
                    2.8094e-06,
                    2.8636e-06,
                    2.9152e-06,
                    2.9677e-06,
                    3.0213e-06,
                    3.0772e-06,
                    3.1368e-06,
                    3.2008e-06,
                    3.271e-06,
                    3.3554e-06,
                    3.4431e-06,
                    3.5313e-06,
                    3.6122e-06,
                    3.6934e-06,
                    3.7896e-06,
                    3.8893e-06,
                    3.995e-06,
                    4.1126e-06,
                    4.2449e-06,
                    4.4013e-06,
                    4.5732e-06,
                    4.7471e-06,
                    4.9433e-06,
                    5.1459e-06,
                    5.3578e-06,
                    5.5876e-06,
                    5.8432e-06,
                    6.1081e-06,
                    6.3765e-06,
                    6.6501e-06,
                    6.9206e-06,
                    7.2015e-06,
                    7.4905e-06,
                    7.7959e-06,
                    8.1152e-06
                ],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": [
                    2.5965e-10,
                    5.245e-10,
                    7.9432e-10,
                    1.0688e-09,
                    1.3475e-09,
                    1.6301e-09,
                    1.9158e-09,
                    2.2041e-09,
                    2.4943e-09,
                    2.7855e-09,
                    3.0772e-09,
                    3.3692e-09,
                    3.6615e-09,
                    3.954e-09,
                    4.2467e-09,
                    4.5396e-09,
                    4.8326e-09,
                    5.126e-09,
                    5.4198e-09,
                    5.714e-09,
                    6.0133e-09,
                    6.325e-09,
                    6.6549e-09,
                    7.0072e-09,
                    7.384e-09,
                    7.7859e-09,
                    8.2118e-09,
                    8.6586e-09,
                    9.1218e-09,
                    9.5949e-09,
                    1.0074e-08,
                    1.0557e-08,
                    1.1045e-08,
                    1.1535e-08,
                    1.2029e-08,
                    1.2526e-08,
                    1.3026e-08,
                    1.3528e-08,
                    1.4035e-08,
                    1.4565e-08,
                    1.5095e-08,
                    1.5627e-08,
                    1.6161e-08,
                    1.6696e-08,
                    1.7233e-08,
                    1.7773e-08,
                    1.8315e-08,
                    1.8859e-08,
                    1.9407e-08,
                    1.9956e-08,
                    2.051e-08,
                    2.1066e-08,
                    2.1627e-08,
                    2.2193e-08,
                    2.2764e-08,
                    2.3339e-08,
                    2.392e-08,
                    2.4507e-08,
                    2.5099e-08,
                    2.5696e-08,
                    2.6297e-08,
                    2.6903e-08,
                    2.7514e-08,
                    2.8128e-08,
                    2.8746e-08,
                    2.937e-08,
                    2.9999e-08,
                    3.0634e-08,
                    3.1278e-08,
                    3.193e-08,
                    3.2599e-08,
                    3.3297e-08,
                    3.4035e-08,
                    3.4821e-08,
                    3.5659e-08,
                    3.6552e-08,
                    3.7501e-08,
                    3.8504e-08,
                    3.9556e-08,
                    4.065e-08,
                    4.1782e-08,
                    4.2948e-08,
                    4.4147e-08,
                    4.5379e-08,
                    4.6642e-08,
                    4.7936e-08,
                    4.9262e-08,
                    5.0621e-08,
                    5.2014e-08,
                    5.3444e-08,
                    5.4929e-08,
                    5.6505e-08,
                    5.8196e-08,
                    6.0022e-08,
                    6.1991e-08,
                    6.4107e-08,
                    6.6365e-08,
                    6.8751e-08,
                    7.1245e-08,
                    7.3817e-08,
                    7.646e-08,
                    7.9188e-08,
                    8.2011e-08,
                    8.4933e-08,
                    8.7956e-08,
                    9.1075e-08,
                    9.4282e-08,
                    9.7565e-08,
                    1.0091e-07,
                    1.0428e-07,
                    1.0803e-07,
                    1.1192e-07,
                    1.1592e-07,
                    1.2007e-07,
                    1.2427e-07,
                    1.2866e-07,
                    1.3325e-07,
                    1.3797e-07,
                    1.428e-07,
                    1.4779e-07,
                    1.5294e-07,
                    1.583e-07,
                    1.6391e-07,
                    1.6954e-07,
                    1.7599e-07,
                    1.8311e-07,
                    1.9082e-07,
                    1.9829e-07,
                    2.0753e-07,
                    2.1794e-07,
                    2.2819e-07,
                    2.3499e-07,
                    2.4274e-07,
                    2.515e-07,
                    2.6311e-07,
                    2.7684e-07,
                    2.9323e-07,
                    3.1036e-07,
                    3.3102e-07,
                    3.5283e-07,
                    3.7642e-07,
                    4.0268e-07,
                    4.3187e-07,
                    4.7367e-07,
                    5.1684e-07,
                    5.4865e-07,
                    5.8049e-07,
                    6.1143e-07,
                    6.4283e-07,
                    6.7481e-07,
                    7.0044e-07,
                    7.2767e-07,
                    7.5467e-07,
                    7.8222e-07,
                    8.0581e-07,
                    8.3095e-07,
                    8.5817e-07,
                    8.8673e-07,
                    9.2205e-07,
                    9.594e-07,
                    1.0002e-06,
                    1.0453e-06,
                    1.0981e-06,
                    1.1509e-06,
                    1.2146e-06,
                    1.2883e-06,
                    1.3655e-06,
                    1.4474e-06,
                    1.5314e-06,
                    1.6173e-06,
                    1.6978e-06,
                    1.7843e-06
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            50.81503,
                            24.73945
                        ],
                        [
                            50.92889,
                            24.54528
                        ],
                        [
                            51.0,
                            24.5
                        ],
                        [
                            51.09861,
                            24.47111
                        ],
                        [
                            51.30552,
                            24.5063
                        ],
                        [
                            51.31725,
                            24.58959
                        ],
                        [
                            51.44139,
                            24.65476
                        ],
                        [
                            51.51827,
                            24.84113
                        ],
                        [
                            51.5752,
                            24.90815
                        ],
                        [
                            51.63271,
                            25.01345
                        ],
                        [
                            51.62855,
                            25.18293
                        ],
                        [
                            51.6116,
                            25.26417
                        ],
                        [
                            51.53315,
                            25.29538
                        ],
                        [
                            51.52975,
                            25.43505
                        ],
                        [
                            51.48588,
                            25.5092
                        ],
                        [
                            51.50243,
                            25.59533
                        ],
                        [
                            51.54982,
                            25.62017
                        ],
                        [
                            51.52293,
                            25.69006
                        ],
                        [
                            51.60077,
                            25.8093
                        ],
                        [
                            51.57983,
                            25.90529
                        ],
                        [
                            51.51885,
                            25.94743
                        ],
                        [
                            51.41883,
                            25.96079
                        ],
                        [
                            51.35987,
                            26.1011
                        ],
                        [
                            51.26258,
                            26.15032
                        ],
                        [
                            51.19512,
                            26.13509
                        ],
                        [
                            51.15748,
                            26.08832
                        ],
                        [
                            51.05398,
                            26.0445
                        ],
                        [
                            51.04661,
                            25.97531
                        ],
                        [
                            50.99874,
                            25.96929
                        ],
                        [
                            50.96836,
                            25.83113
                        ],
                        [
                            50.91641,
                            25.77278
                        ],
                        [
                            50.90574,
                            25.66111
                        ],
                        [
                            50.82353,
                            25.61343
                        ],
                        [
                            50.82977,
                            25.52453
                        ],
                        [
                            50.7701,
                            25.49912
                        ],
                        [
                            50.76088,
                            25.41767
                        ],
                        [
                            50.77458,
                            25.30447
                        ],
                        [
                            50.77981,
                            25.11095
                        ],
                        [
                            50.81799,
                            25.03761
                        ],
                        [
                            50.80727,
                            24.98327
                        ],
                        [
                            50.86339,
                            24.89765
                        ],
                        [
                            50.86478,
                            24.76234
                        ],
                        [
                            50.81503,
                            24.73945
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "ROU",
                "Country": "Romania",
                "Total_3GHG": 0.36,
                "Total_3GHG_timeseries": [
                    9.2079e-06,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.004,
                    0.0041,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.0051,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0053,
                    0.0053,
                    0.0054,
                    0.0054,
                    0.0054,
                    0.0054,
                    0.0054,
                    0.0054,
                    0.0055,
                    0.0055,
                    0.0055,
                    0.0055,
                    0.0055,
                    0.0055,
                    0.0055,
                    0.0055,
                    0.0055,
                    0.0055,
                    0.0056,
                    0.0056,
                    0.0056,
                    0.0056,
                    0.0057,
                    0.0057,
                    0.0057,
                    0.0058,
                    0.0058,
                    0.0058,
                    0.0059,
                    0.0059
                ],
                "Fossil_3GHG": 0.46,
                "Fossil_3GHG_timeseries": [
                    9.0503e-07,
                    1.8213e-06,
                    2.7488e-06,
                    3.6875e-06,
                    4.6374e-06,
                    5.5987e-06,
                    6.5714e-06,
                    7.5609e-06,
                    8.5617e-06,
                    9.5738e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.004,
                    0.004,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0041,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0043,
                    0.0043,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0045,
                    0.0045,
                    0.0046,
                    0.0046,
                    0.0046,
                    0.0047,
                    0.0047,
                    0.0048,
                    0.0048,
                    0.0048
                ],
                "Land_3GHG": 0.18,
                "Land_3GHG_timeseries": [
                    8.3029e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011
                ],
                "Total_CO2": 0.38,
                "Total_CO2_timeseries": [
                    5.6272e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.004,
                    0.004,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0043,
                    0.0043,
                    0.0043
                ],
                "Fossil_CO2": 0.51,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.65e-09,
                    3.3e-09,
                    4.95e-09,
                    8.25e-09,
                    1.32e-08,
                    1.815e-08,
                    2.475e-08,
                    3.135e-08,
                    3.96e-08,
                    4.95e-08,
                    6.105e-08,
                    7.26e-08,
                    8.91e-08,
                    1.0725e-07,
                    1.254e-07,
                    1.452e-07,
                    1.65e-07,
                    1.8645e-07,
                    2.079e-07,
                    2.2935e-07,
                    2.508e-07,
                    2.7225e-07,
                    2.937e-07,
                    3.168e-07,
                    4.1745e-07,
                    6.006e-07,
                    8.1345e-07,
                    1.0164e-06,
                    1.2342e-06,
                    1.4718e-06,
                    1.7556e-06,
                    2.046e-06,
                    2.409e-06,
                    2.9122e-06,
                    3.3858e-06,
                    3.8973e-06,
                    4.3659e-06,
                    4.851e-06,
                    5.3542e-06,
                    5.9383e-06,
                    6.7089e-06,
                    7.4349e-06,
                    7.9926e-06,
                    8.7104e-06,
                    9.4265e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.0039
                ],
                "Land_CO2": 0.11,
                "Land_CO2_timeseries": [
                    5.6272e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Total_CH4": 0.26,
                "Total_CH4_timeseries": [
                    3.3705e-06,
                    6.7838e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0015,
                    0.0015,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0013,
                    0.0013,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011
                ],
                "Fossil_CH4": 0.28,
                "Fossil_CH4_timeseries": [
                    7.9898e-07,
                    1.608e-06,
                    2.4271e-06,
                    3.2562e-06,
                    4.0953e-06,
                    4.9448e-06,
                    5.8046e-06,
                    6.6784e-06,
                    7.5625e-06,
                    8.457e-06,
                    9.3643e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Land_CH4": 0.23,
                "Land_CH4_timeseries": [
                    2.5716e-06,
                    5.1758e-06,
                    7.8126e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Total_N2O": 0.57,
                "Total_N2O_timeseries": [
                    2.1014e-07,
                    4.2356e-07,
                    6.4016e-07,
                    8.598e-07,
                    1.0823e-06,
                    1.3074e-06,
                    1.5349e-06,
                    1.7645e-06,
                    1.9959e-06,
                    2.2286e-06,
                    2.4624e-06,
                    2.6973e-06,
                    2.9332e-06,
                    3.1702e-06,
                    3.4081e-06,
                    3.647e-06,
                    3.8869e-06,
                    4.1278e-06,
                    4.3698e-06,
                    4.613e-06,
                    4.8593e-06,
                    5.1123e-06,
                    5.3745e-06,
                    5.6478e-06,
                    5.9332e-06,
                    6.2311e-06,
                    6.5408e-06,
                    6.861e-06,
                    7.1897e-06,
                    7.5237e-06,
                    7.8612e-06,
                    8.2018e-06,
                    8.5452e-06,
                    8.8909e-06,
                    9.239e-06,
                    9.5893e-06,
                    9.9419e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Fossil_N2O": 0.8,
                "Fossil_N2O_timeseries": [
                    1.0604e-07,
                    2.1329e-07,
                    3.2172e-07,
                    4.3131e-07,
                    5.4206e-07,
                    6.5392e-07,
                    7.6687e-07,
                    8.8087e-07,
                    9.9588e-07,
                    1.1118e-06,
                    1.2287e-06,
                    1.3466e-06,
                    1.4653e-06,
                    1.585e-06,
                    1.7056e-06,
                    1.827e-06,
                    1.9494e-06,
                    2.0728e-06,
                    2.197e-06,
                    2.3222e-06,
                    2.4486e-06,
                    2.5766e-06,
                    2.7065e-06,
                    2.8386e-06,
                    2.973e-06,
                    3.1097e-06,
                    3.2487e-06,
                    3.3898e-06,
                    3.5327e-06,
                    3.6771e-06,
                    3.8227e-06,
                    3.9695e-06,
                    4.1174e-06,
                    4.2664e-06,
                    4.4165e-06,
                    4.5676e-06,
                    4.7198e-06,
                    4.8731e-06,
                    5.0275e-06,
                    5.1837e-06,
                    5.3411e-06,
                    5.4998e-06,
                    5.6599e-06,
                    5.8213e-06,
                    5.984e-06,
                    6.1482e-06,
                    6.3138e-06,
                    6.4809e-06,
                    6.6494e-06,
                    6.8195e-06,
                    6.9912e-06,
                    7.1646e-06,
                    7.3398e-06,
                    7.5169e-06,
                    7.6959e-06,
                    7.8768e-06,
                    8.0597e-06,
                    8.2444e-06,
                    8.431e-06,
                    8.6193e-06,
                    8.8092e-06,
                    9.0008e-06,
                    9.194e-06,
                    9.3887e-06,
                    9.5851e-06,
                    9.783e-06,
                    9.9826e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_N2O": 0.48,
                "Land_N2O_timeseries": [
                    1.041e-07,
                    2.1028e-07,
                    3.1845e-07,
                    4.2848e-07,
                    5.4023e-07,
                    6.535e-07,
                    7.6806e-07,
                    8.8365e-07,
                    9.9998e-07,
                    1.1167e-06,
                    1.2336e-06,
                    1.3507e-06,
                    1.4679e-06,
                    1.5852e-06,
                    1.7025e-06,
                    1.8199e-06,
                    1.9374e-06,
                    2.055e-06,
                    2.1728e-06,
                    2.2908e-06,
                    2.4108e-06,
                    2.5357e-06,
                    2.668e-06,
                    2.8092e-06,
                    2.9603e-06,
                    3.1214e-06,
                    3.2921e-06,
                    3.4713e-06,
                    3.657e-06,
                    3.8466e-06,
                    4.0386e-06,
                    4.2324e-06,
                    4.4278e-06,
                    4.6246e-06,
                    4.8226e-06,
                    5.0217e-06,
                    5.222e-06,
                    5.4236e-06,
                    5.6265e-06,
                    5.8518e-06,
                    6.0627e-06,
                    6.2597e-06,
                    6.4436e-06,
                    6.6155e-06,
                    6.7767e-06,
                    6.9285e-06,
                    7.0727e-06,
                    7.2112e-06,
                    7.3461e-06,
                    7.4798e-06,
                    7.6136e-06,
                    7.7481e-06,
                    7.8836e-06,
                    8.0205e-06,
                    8.1592e-06,
                    8.3e-06,
                    8.4432e-06,
                    8.5892e-06,
                    8.7383e-06,
                    8.8908e-06,
                    9.0511e-06,
                    9.2267e-06,
                    9.4242e-06,
                    9.6493e-06,
                    9.9062e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            28.21136,
                            45.46728
                        ],
                        [
                            28.16514,
                            45.54254
                        ],
                        [
                            28.09343,
                            45.59767
                        ],
                        [
                            28.17305,
                            45.64703
                        ],
                        [
                            28.16629,
                            45.73585
                        ],
                        [
                            28.11195,
                            45.82133
                        ],
                        [
                            28.13144,
                            45.87552
                        ],
                        [
                            28.08707,
                            46.00791
                        ],
                        [
                            28.1415,
                            46.19035
                        ],
                        [
                            28.11142,
                            46.23182
                        ],
                        [
                            28.20674,
                            46.31799
                        ],
                        [
                            28.1932,
                            46.35612
                        ],
                        [
                            28.26003,
                            46.4375
                        ],
                        [
                            28.22275,
                            46.51216
                        ],
                        [
                            28.25115,
                            46.61188
                        ],
                        [
                            28.17524,
                            46.77778
                        ],
                        [
                            28.11546,
                            46.82134
                        ],
                        [
                            28.11143,
                            46.92011
                        ],
                        [
                            28.0807,
                            46.98997
                        ],
                        [
                            27.89756,
                            47.07378
                        ],
                        [
                            27.79569,
                            47.14872
                        ],
                        [
                            27.8014,
                            47.18889
                        ],
                        [
                            27.72849,
                            47.29445
                        ],
                        [
                            27.60067,
                            47.32931
                        ],
                        [
                            27.55818,
                            47.44647
                        ],
                        [
                            27.47337,
                            47.48684
                        ],
                        [
                            27.40291,
                            47.58332
                        ],
                        [
                            27.31659,
                            47.64151
                        ],
                        [
                            27.26669,
                            47.71179
                        ],
                        [
                            27.2782,
                            47.76367
                        ],
                        [
                            27.21433,
                            47.82285
                        ],
                        [
                            27.17814,
                            47.94693
                        ],
                        [
                            27.03977,
                            48.10736
                        ],
                        [
                            26.93922,
                            48.1977
                        ],
                        [
                            26.80742,
                            48.25446
                        ],
                        [
                            26.63056,
                            48.25975
                        ],
                        [
                            26.53025,
                            48.21032
                        ],
                        [
                            26.47193,
                            48.21944
                        ],
                        [
                            26.33883,
                            48.18322
                        ],
                        [
                            26.19002,
                            47.99756
                        ],
                        [
                            25.86123,
                            47.9699
                        ],
                        [
                            25.77463,
                            47.93937
                        ],
                        [
                            25.59327,
                            47.93881
                        ],
                        [
                            25.31089,
                            47.91432
                        ],
                        [
                            25.22158,
                            47.85919
                        ],
                        [
                            25.11498,
                            47.75512
                        ],
                        [
                            25.03908,
                            47.72593
                        ],
                        [
                            24.88314,
                            47.72435
                        ],
                        [
                            24.82719,
                            47.82
                        ],
                        [
                            24.67089,
                            47.86528
                        ],
                        [
                            24.62275,
                            47.9514
                        ],
                        [
                            24.43414,
                            47.96971
                        ],
                        [
                            24.38029,
                            47.92646
                        ],
                        [
                            24.21928,
                            47.89797
                        ],
                        [
                            24.1097,
                            47.91657
                        ],
                        [
                            24.00891,
                            47.96683
                        ],
                        [
                            23.84459,
                            47.94173
                        ],
                        [
                            23.77079,
                            47.99467
                        ],
                        [
                            23.66833,
                            47.98421
                        ],
                        [
                            23.54213,
                            48.00942
                        ],
                        [
                            23.49361,
                            47.96781
                        ],
                        [
                            23.33963,
                            48.01879
                        ],
                        [
                            23.24602,
                            48.09262
                        ],
                        [
                            23.14647,
                            48.10057
                        ],
                        [
                            23.08969,
                            48.00545
                        ],
                        [
                            22.99423,
                            48.00236
                        ],
                        [
                            22.89627,
                            47.95412
                        ],
                        [
                            22.84747,
                            47.90884
                        ],
                        [
                            22.76039,
                            47.89483
                        ],
                        [
                            22.6825,
                            47.79033
                        ],
                        [
                            22.54954,
                            47.77266
                        ],
                        [
                            22.48143,
                            47.81091
                        ],
                        [
                            22.42646,
                            47.7523
                        ],
                        [
                            22.34778,
                            47.7523
                        ],
                        [
                            22.23321,
                            47.69366
                        ],
                        [
                            22.17131,
                            47.59184
                        ],
                        [
                            22.02297,
                            47.51781
                        ],
                        [
                            22.01212,
                            47.37672
                        ],
                        [
                            21.93933,
                            47.37281
                        ],
                        [
                            21.85196,
                            47.23892
                        ],
                        [
                            21.79284,
                            47.10724
                        ],
                        [
                            21.72614,
                            47.09861
                        ],
                        [
                            21.6686,
                            46.97093
                        ],
                        [
                            21.60604,
                            46.93235
                        ],
                        [
                            21.59505,
                            46.86093
                        ],
                        [
                            21.52112,
                            46.83742
                        ],
                        [
                            21.48348,
                            46.76464
                        ],
                        [
                            21.52865,
                            46.72052
                        ],
                        [
                            21.41641,
                            46.64183
                        ],
                        [
                            21.32758,
                            46.63
                        ],
                        [
                            21.26087,
                            46.50214
                        ],
                        [
                            21.31748,
                            46.45066
                        ],
                        [
                            21.20625,
                            46.40219
                        ],
                        [
                            21.17955,
                            46.3043
                        ],
                        [
                            21.02477,
                            46.26578
                        ],
                        [
                            20.92223,
                            46.26176
                        ],
                        [
                            20.87341,
                            46.28742
                        ],
                        [
                            20.74938,
                            46.25041
                        ],
                        [
                            20.71455,
                            46.16767
                        ],
                        [
                            20.63409,
                            46.12668
                        ],
                        [
                            20.50153,
                            46.18994
                        ],
                        [
                            20.45954,
                            46.14347
                        ],
                        [
                            20.35565,
                            46.1696
                        ],
                        [
                            20.2643,
                            46.12637
                        ],
                        [
                            20.34588,
                            46.04742
                        ],
                        [
                            20.34974,
                            45.99894
                        ],
                        [
                            20.48291,
                            45.95284
                        ],
                        [
                            20.51556,
                            45.89296
                        ],
                        [
                            20.65864,
                            45.83037
                        ],
                        [
                            20.70073,
                            45.75131
                        ],
                        [
                            20.80289,
                            45.73784
                        ],
                        [
                            20.80499,
                            45.65723
                        ],
                        [
                            20.76573,
                            45.61257
                        ],
                        [
                            20.83163,
                            45.53637
                        ],
                        [
                            20.83412,
                            45.4793
                        ],
                        [
                            20.95836,
                            45.36846
                        ],
                        [
                            21.09716,
                            45.29668
                        ],
                        [
                            21.18002,
                            45.31258
                        ],
                        [
                            21.21899,
                            45.25058
                        ],
                        [
                            21.4044,
                            45.22839
                        ],
                        [
                            21.5156,
                            45.1699
                        ],
                        [
                            21.45461,
                            45.04037
                        ],
                        [
                            21.36023,
                            45.02043
                        ],
                        [
                            21.43594,
                            44.96178
                        ],
                        [
                            21.54668,
                            44.93052
                        ],
                        [
                            21.55945,
                            44.88947
                        ],
                        [
                            21.37034,
                            44.866
                        ],
                        [
                            21.39832,
                            44.77851
                        ],
                        [
                            21.58779,
                            44.75842
                        ],
                        [
                            21.63827,
                            44.65971
                        ],
                        [
                            21.79175,
                            44.66371
                        ],
                        [
                            21.99785,
                            44.62913
                        ],
                        [
                            22.03653,
                            44.54303
                        ],
                        [
                            22.1277,
                            44.47436
                        ],
                        [
                            22.18243,
                            44.48239
                        ],
                        [
                            22.27544,
                            44.62631
                        ],
                        [
                            22.3325,
                            44.6754
                        ],
                        [
                            22.48297,
                            44.70814
                        ],
                        [
                            22.62075,
                            44.61521
                        ],
                        [
                            22.66842,
                            44.61868
                        ],
                        [
                            22.75787,
                            44.56055
                        ],
                        [
                            22.6986,
                            44.51699
                        ],
                        [
                            22.61784,
                            44.55218
                        ],
                        [
                            22.54935,
                            44.48215
                        ],
                        [
                            22.45787,
                            44.46642
                        ],
                        [
                            22.5593,
                            44.30881
                        ],
                        [
                            22.6826,
                            44.2744
                        ],
                        [
                            22.67516,
                            44.21566
                        ],
                        [
                            22.93286,
                            44.09842
                        ],
                        [
                            23.0229,
                            44.08838
                        ],
                        [
                            23.01055,
                            44.01206
                        ],
                        [
                            22.89237,
                            43.99138
                        ],
                        [
                            22.84214,
                            43.86928
                        ],
                        [
                            22.87971,
                            43.8336
                        ],
                        [
                            23.05203,
                            43.79636
                        ],
                        [
                            23.13939,
                            43.80476
                        ],
                        [
                            23.26097,
                            43.84499
                        ],
                        [
                            23.43386,
                            43.85275
                        ],
                        [
                            23.55778,
                            43.80175
                        ],
                        [
                            23.70063,
                            43.80675
                        ],
                        [
                            23.87499,
                            43.75095
                        ],
                        [
                            23.97772,
                            43.74832
                        ],
                        [
                            24.08068,
                            43.70414
                        ],
                        [
                            24.1958,
                            43.68363
                        ],
                        [
                            24.34076,
                            43.69696
                        ],
                        [
                            24.48327,
                            43.76002
                        ],
                        [
                            24.59958,
                            43.74941
                        ],
                        [
                            24.69967,
                            43.69521
                        ],
                        [
                            24.9969,
                            43.72767
                        ],
                        [
                            25.05635,
                            43.69404
                        ],
                        [
                            25.17971,
                            43.70028
                        ],
                        [
                            25.3658,
                            43.62461
                        ],
                        [
                            25.56173,
                            43.64713
                        ],
                        [
                            25.65714,
                            43.6852
                        ],
                        [
                            25.77684,
                            43.70671
                        ],
                        [
                            25.87287,
                            43.7727
                        ],
                        [
                            25.95283,
                            43.859
                        ],
                        [
                            26.06076,
                            43.9086
                        ],
                        [
                            26.1008,
                            43.96721
                        ],
                        [
                            26.34596,
                            44.03636
                        ],
                        [
                            26.63306,
                            44.05853
                        ],
                        [
                            26.77211,
                            44.07955
                        ],
                        [
                            26.92368,
                            44.14015
                        ],
                        [
                            27.13497,
                            44.14051
                        ],
                        [
                            27.26376,
                            44.12566
                        ],
                        [
                            27.29177,
                            44.07552
                        ],
                        [
                            27.39862,
                            44.01333
                        ],
                        [
                            27.61204,
                            44.01221
                        ],
                        [
                            27.67365,
                            44.02978
                        ],
                        [
                            27.71,
                            43.95932
                        ],
                        [
                            27.94431,
                            43.98478
                        ],
                        [
                            27.99426,
                            43.84296
                        ],
                        [
                            28.23614,
                            43.75852
                        ],
                        [
                            28.44558,
                            43.7338
                        ],
                        [
                            28.57888,
                            43.73874
                        ],
                        [
                            28.57753,
                            43.79672
                        ],
                        [
                            28.66723,
                            43.98738
                        ],
                        [
                            28.64186,
                            44.05519
                        ],
                        [
                            28.65704,
                            44.19953
                        ],
                        [
                            28.62205,
                            44.27257
                        ],
                        [
                            28.63811,
                            44.32184
                        ],
                        [
                            28.86741,
                            44.52351
                        ],
                        [
                            28.93837,
                            44.62251
                        ],
                        [
                            29.10634,
                            44.75966
                        ],
                        [
                            29.24537,
                            44.79678
                        ],
                        [
                            29.5529,
                            44.82392
                        ],
                        [
                            29.62196,
                            44.8849
                        ],
                        [
                            29.65352,
                            45.09621
                        ],
                        [
                            29.70747,
                            45.16656
                        ],
                        [
                            29.67964,
                            45.21184
                        ],
                        [
                            29.6549,
                            45.33589
                        ],
                        [
                            29.55278,
                            45.40695
                        ],
                        [
                            29.42641,
                            45.442
                        ],
                        [
                            29.28227,
                            45.42701
                        ],
                        [
                            28.96416,
                            45.32947
                        ],
                        [
                            28.93392,
                            45.28081
                        ],
                        [
                            28.84207,
                            45.31878
                        ],
                        [
                            28.75084,
                            45.28186
                        ],
                        [
                            28.70008,
                            45.2254
                        ],
                        [
                            28.56838,
                            45.24799
                        ],
                        [
                            28.34494,
                            45.32255
                        ],
                        [
                            28.26195,
                            45.45492
                        ],
                        [
                            28.21136,
                            45.46728
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "RUS",
                "Country": "Russian Federation",
                "Total_3GHG": 6.42,
                "Total_3GHG_timeseries": [
                    0.0002,
                    0.0004,
                    0.0006,
                    0.0008,
                    0.001,
                    0.0012,
                    0.0014,
                    0.0017,
                    0.0019,
                    0.0021,
                    0.0023,
                    0.0025,
                    0.0027,
                    0.0029,
                    0.0031,
                    0.0033,
                    0.0035,
                    0.0037,
                    0.0039,
                    0.0041,
                    0.0043,
                    0.0046,
                    0.0048,
                    0.005,
                    0.0053,
                    0.0055,
                    0.0058,
                    0.006,
                    0.0063,
                    0.0065,
                    0.0068,
                    0.0071,
                    0.0073,
                    0.0076,
                    0.0079,
                    0.0082,
                    0.0085,
                    0.0088,
                    0.0091,
                    0.0094,
                    0.0098,
                    0.0102,
                    0.0105,
                    0.0109,
                    0.0113,
                    0.0116,
                    0.012,
                    0.0124,
                    0.0128,
                    0.0132,
                    0.0136,
                    0.0141,
                    0.0145,
                    0.015,
                    0.0154,
                    0.0159,
                    0.0164,
                    0.0169,
                    0.0174,
                    0.0178,
                    0.0182,
                    0.0186,
                    0.019,
                    0.0194,
                    0.0197,
                    0.02,
                    0.0203,
                    0.0206,
                    0.0208,
                    0.0211,
                    0.0213,
                    0.0216,
                    0.0219,
                    0.0222,
                    0.0224,
                    0.0227,
                    0.0231,
                    0.0234,
                    0.0237,
                    0.0241,
                    0.0246,
                    0.0251,
                    0.0256,
                    0.0262,
                    0.0268,
                    0.0274,
                    0.0281,
                    0.0288,
                    0.0296,
                    0.0303,
                    0.0309,
                    0.0313,
                    0.0318,
                    0.0323,
                    0.0327,
                    0.033,
                    0.0334,
                    0.0338,
                    0.0342,
                    0.0347,
                    0.0352,
                    0.0357,
                    0.0363,
                    0.037,
                    0.0377,
                    0.0385,
                    0.0393,
                    0.0402,
                    0.0413,
                    0.0422,
                    0.0432,
                    0.0442,
                    0.0452,
                    0.0462,
                    0.0472,
                    0.0483,
                    0.0494,
                    0.0504,
                    0.0515,
                    0.0526,
                    0.0537,
                    0.0549,
                    0.0561,
                    0.0573,
                    0.0586,
                    0.0598,
                    0.0611,
                    0.0624,
                    0.0637,
                    0.0651,
                    0.0664,
                    0.0677,
                    0.0691,
                    0.0704,
                    0.0719,
                    0.0733,
                    0.0748,
                    0.0763,
                    0.0779,
                    0.0795,
                    0.0809,
                    0.0821,
                    0.0831,
                    0.0839,
                    0.0846,
                    0.0855,
                    0.086,
                    0.0865,
                    0.087,
                    0.0875,
                    0.088,
                    0.0885,
                    0.089,
                    0.0896,
                    0.0901,
                    0.0906,
                    0.0912,
                    0.0918,
                    0.0923,
                    0.093,
                    0.0937,
                    0.0946,
                    0.0954,
                    0.0962,
                    0.0972,
                    0.0983,
                    0.0994,
                    0.1006,
                    0.1018,
                    0.1029,
                    0.104,
                    0.1051
                ],
                "Fossil_3GHG": 6.85,
                "Fossil_3GHG_timeseries": [
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.004,
                    0.0041,
                    0.0043,
                    0.0045,
                    0.0047,
                    0.0049,
                    0.0052,
                    0.0055,
                    0.0058,
                    0.0061,
                    0.0064,
                    0.0066,
                    0.0068,
                    0.0071,
                    0.0073,
                    0.0076,
                    0.0079,
                    0.0082,
                    0.0085,
                    0.0089,
                    0.0092,
                    0.0096,
                    0.01,
                    0.0105,
                    0.011,
                    0.0115,
                    0.0121,
                    0.0127,
                    0.0133,
                    0.014,
                    0.0147,
                    0.0154,
                    0.0162,
                    0.017,
                    0.0179,
                    0.0187,
                    0.0196,
                    0.0204,
                    0.0212,
                    0.0221,
                    0.023,
                    0.024,
                    0.025,
                    0.026,
                    0.0271,
                    0.0281,
                    0.0292,
                    0.0303,
                    0.0314,
                    0.0325,
                    0.0337,
                    0.0348,
                    0.036,
                    0.0372,
                    0.0385,
                    0.0398,
                    0.0412,
                    0.0426,
                    0.044,
                    0.0454,
                    0.0465,
                    0.0475,
                    0.0483,
                    0.0491,
                    0.0499,
                    0.0505,
                    0.0512,
                    0.0519,
                    0.0525,
                    0.0532,
                    0.0539,
                    0.0547,
                    0.0554,
                    0.0562,
                    0.057,
                    0.0578,
                    0.0585,
                    0.0593,
                    0.0601,
                    0.0609,
                    0.0618,
                    0.0628,
                    0.0638,
                    0.0648,
                    0.0658,
                    0.0669,
                    0.068,
                    0.0692,
                    0.0703,
                    0.0714,
                    0.0725
                ],
                "Land_3GHG": 5.64,
                "Land_3GHG_timeseries": [
                    0.0002,
                    0.0004,
                    0.0005,
                    0.0007,
                    0.0009,
                    0.0011,
                    0.0013,
                    0.0015,
                    0.0017,
                    0.0019,
                    0.002,
                    0.0022,
                    0.0024,
                    0.0026,
                    0.0027,
                    0.0029,
                    0.0031,
                    0.0033,
                    0.0035,
                    0.0037,
                    0.0038,
                    0.0041,
                    0.0043,
                    0.0045,
                    0.0047,
                    0.0049,
                    0.0051,
                    0.0053,
                    0.0055,
                    0.0058,
                    0.006,
                    0.0062,
                    0.0065,
                    0.0067,
                    0.007,
                    0.0072,
                    0.0075,
                    0.0077,
                    0.008,
                    0.0083,
                    0.0086,
                    0.0089,
                    0.0092,
                    0.0095,
                    0.0098,
                    0.0101,
                    0.0104,
                    0.0107,
                    0.0111,
                    0.0114,
                    0.0117,
                    0.0121,
                    0.0124,
                    0.0128,
                    0.0132,
                    0.0136,
                    0.014,
                    0.0144,
                    0.0148,
                    0.0151,
                    0.0154,
                    0.0157,
                    0.016,
                    0.0163,
                    0.0165,
                    0.0168,
                    0.017,
                    0.0172,
                    0.0174,
                    0.0177,
                    0.0179,
                    0.0182,
                    0.0184,
                    0.0187,
                    0.019,
                    0.0192,
                    0.0195,
                    0.0198,
                    0.0201,
                    0.0204,
                    0.0207,
                    0.0211,
                    0.0215,
                    0.0219,
                    0.0223,
                    0.0227,
                    0.0232,
                    0.0236,
                    0.0241,
                    0.0244,
                    0.0247,
                    0.025,
                    0.0252,
                    0.0254,
                    0.0256,
                    0.0257,
                    0.0259,
                    0.0259,
                    0.026,
                    0.0261,
                    0.0263,
                    0.0265,
                    0.0267,
                    0.027,
                    0.0272,
                    0.0275,
                    0.0278,
                    0.0281,
                    0.0285,
                    0.0289,
                    0.0292,
                    0.0295,
                    0.0297,
                    0.03,
                    0.0302,
                    0.0304,
                    0.0306,
                    0.0309,
                    0.0311,
                    0.0314,
                    0.0316,
                    0.0319,
                    0.0321,
                    0.0323,
                    0.0326,
                    0.0328,
                    0.033,
                    0.0332,
                    0.0334,
                    0.0337,
                    0.0339,
                    0.0341,
                    0.0343,
                    0.0345,
                    0.0346,
                    0.0348,
                    0.035,
                    0.0351,
                    0.0353,
                    0.0354,
                    0.0355,
                    0.0356,
                    0.0356,
                    0.0356,
                    0.0355,
                    0.0356,
                    0.0355,
                    0.0353,
                    0.0352,
                    0.035,
                    0.0348,
                    0.0346,
                    0.0344,
                    0.0341,
                    0.0339,
                    0.0337,
                    0.0334,
                    0.0332,
                    0.0331,
                    0.033,
                    0.0328,
                    0.0327,
                    0.0326,
                    0.0325,
                    0.0325,
                    0.0325,
                    0.0325,
                    0.0326,
                    0.0326,
                    0.0326,
                    0.0326,
                    0.0326
                ],
                "Total_CO2": 7.12,
                "Total_CO2_timeseries": [
                    0.0001,
                    0.0003,
                    0.0005,
                    0.0006,
                    0.0008,
                    0.0009,
                    0.0011,
                    0.0013,
                    0.0014,
                    0.0016,
                    0.0017,
                    0.0019,
                    0.002,
                    0.0022,
                    0.0023,
                    0.0025,
                    0.0026,
                    0.0028,
                    0.0029,
                    0.0031,
                    0.0033,
                    0.0034,
                    0.0036,
                    0.0038,
                    0.004,
                    0.0041,
                    0.0043,
                    0.0045,
                    0.0047,
                    0.0049,
                    0.0051,
                    0.0053,
                    0.0055,
                    0.0057,
                    0.0059,
                    0.0061,
                    0.0063,
                    0.0065,
                    0.0067,
                    0.007,
                    0.0073,
                    0.0075,
                    0.0078,
                    0.0081,
                    0.0083,
                    0.0086,
                    0.0089,
                    0.0092,
                    0.0095,
                    0.0098,
                    0.0101,
                    0.0104,
                    0.0107,
                    0.011,
                    0.0114,
                    0.0117,
                    0.0121,
                    0.0124,
                    0.0128,
                    0.0131,
                    0.0134,
                    0.0136,
                    0.0139,
                    0.0141,
                    0.0143,
                    0.0145,
                    0.0147,
                    0.0149,
                    0.0151,
                    0.0153,
                    0.0155,
                    0.0158,
                    0.016,
                    0.0162,
                    0.0165,
                    0.0167,
                    0.017,
                    0.0173,
                    0.0175,
                    0.0179,
                    0.0182,
                    0.0186,
                    0.019,
                    0.0195,
                    0.0199,
                    0.0204,
                    0.0208,
                    0.0213,
                    0.0218,
                    0.0222,
                    0.0225,
                    0.0228,
                    0.023,
                    0.0232,
                    0.0235,
                    0.0237,
                    0.0239,
                    0.024,
                    0.0242,
                    0.0245,
                    0.0248,
                    0.0252,
                    0.0256,
                    0.0261,
                    0.0266,
                    0.0271,
                    0.0277,
                    0.0284,
                    0.0292,
                    0.0299,
                    0.0306,
                    0.0312,
                    0.0319,
                    0.0325,
                    0.0332,
                    0.0339,
                    0.0346,
                    0.0354,
                    0.0361,
                    0.0369,
                    0.0377,
                    0.0386,
                    0.0395,
                    0.0403,
                    0.0413,
                    0.0422,
                    0.0432,
                    0.0442,
                    0.0452,
                    0.0463,
                    0.0473,
                    0.0483,
                    0.0494,
                    0.0504,
                    0.0515,
                    0.0526,
                    0.0537,
                    0.0549,
                    0.056,
                    0.0572,
                    0.0583,
                    0.0592,
                    0.06,
                    0.0608,
                    0.0615,
                    0.0623,
                    0.0629,
                    0.0636,
                    0.0642,
                    0.0648,
                    0.0654,
                    0.066,
                    0.0666,
                    0.0673,
                    0.0679,
                    0.0686,
                    0.0693,
                    0.07,
                    0.0707,
                    0.0715,
                    0.0722,
                    0.073,
                    0.0738,
                    0.0745,
                    0.0754,
                    0.0762,
                    0.077,
                    0.0778,
                    0.0786,
                    0.0794,
                    0.0802,
                    0.0809
                ],
                "Fossil_CO2": 6.92,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    9.4804e-08,
                    9.4804e-08,
                    9.4804e-08,
                    2.2793e-07,
                    3.6913e-07,
                    5.5571e-07,
                    7.9272e-07,
                    1.0065e-06,
                    1.2304e-06,
                    1.4816e-06,
                    1.7216e-06,
                    2.48e-06,
                    3.3504e-06,
                    4.0745e-06,
                    5.0569e-06,
                    6.1229e-06,
                    7.5621e-06,
                    9.0396e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0027,
                    0.0028,
                    0.003,
                    0.0032,
                    0.0034,
                    0.0037,
                    0.0039,
                    0.0042,
                    0.0045,
                    0.0048,
                    0.0052,
                    0.0056,
                    0.006,
                    0.0064,
                    0.0068,
                    0.0073,
                    0.0078,
                    0.0083,
                    0.0089,
                    0.0094,
                    0.01,
                    0.0106,
                    0.0113,
                    0.012,
                    0.0127,
                    0.0135,
                    0.0142,
                    0.0151,
                    0.0159,
                    0.0168,
                    0.0177,
                    0.0186,
                    0.0196,
                    0.0205,
                    0.0215,
                    0.0225,
                    0.0235,
                    0.0245,
                    0.0256,
                    0.0266,
                    0.0277,
                    0.0288,
                    0.03,
                    0.031,
                    0.0319,
                    0.0328,
                    0.0335,
                    0.0342,
                    0.0349,
                    0.0356,
                    0.0363,
                    0.0369,
                    0.0376,
                    0.0383,
                    0.039,
                    0.0397,
                    0.0404,
                    0.0411,
                    0.0418,
                    0.0425,
                    0.0433,
                    0.044,
                    0.0447,
                    0.0455,
                    0.0462,
                    0.047,
                    0.0477,
                    0.0484,
                    0.0492,
                    0.0499,
                    0.0507,
                    0.0515,
                    0.0522,
                    0.053,
                    0.0537
                ],
                "Land_CO2": 7.55,
                "Land_CO2_timeseries": [
                    0.0001,
                    0.0003,
                    0.0005,
                    0.0006,
                    0.0008,
                    0.0009,
                    0.0011,
                    0.0013,
                    0.0014,
                    0.0016,
                    0.0017,
                    0.0019,
                    0.002,
                    0.0022,
                    0.0023,
                    0.0025,
                    0.0026,
                    0.0028,
                    0.0029,
                    0.0031,
                    0.0032,
                    0.0034,
                    0.0036,
                    0.0038,
                    0.0039,
                    0.0041,
                    0.0043,
                    0.0045,
                    0.0047,
                    0.0049,
                    0.005,
                    0.0052,
                    0.0054,
                    0.0056,
                    0.0058,
                    0.006,
                    0.0062,
                    0.0065,
                    0.0067,
                    0.0069,
                    0.0072,
                    0.0074,
                    0.0077,
                    0.0079,
                    0.0082,
                    0.0085,
                    0.0087,
                    0.009,
                    0.0093,
                    0.0095,
                    0.0098,
                    0.0101,
                    0.0104,
                    0.0107,
                    0.011,
                    0.0114,
                    0.0117,
                    0.012,
                    0.0124,
                    0.0126,
                    0.0129,
                    0.0131,
                    0.0133,
                    0.0135,
                    0.0137,
                    0.0139,
                    0.0141,
                    0.0143,
                    0.0144,
                    0.0146,
                    0.0148,
                    0.0151,
                    0.0153,
                    0.0155,
                    0.0157,
                    0.016,
                    0.0162,
                    0.0164,
                    0.0167,
                    0.017,
                    0.0173,
                    0.0176,
                    0.018,
                    0.0183,
                    0.0187,
                    0.019,
                    0.0194,
                    0.0198,
                    0.0201,
                    0.0204,
                    0.0206,
                    0.0208,
                    0.021,
                    0.0211,
                    0.0212,
                    0.0213,
                    0.0213,
                    0.0214,
                    0.0214,
                    0.0215,
                    0.0216,
                    0.0218,
                    0.022,
                    0.0222,
                    0.0224,
                    0.0226,
                    0.0229,
                    0.0232,
                    0.0236,
                    0.0239,
                    0.0242,
                    0.0244,
                    0.0246,
                    0.0248,
                    0.0249,
                    0.0251,
                    0.0252,
                    0.0253,
                    0.0255,
                    0.0257,
                    0.0258,
                    0.0259,
                    0.026,
                    0.0261,
                    0.0262,
                    0.0263,
                    0.0264,
                    0.0265,
                    0.0266,
                    0.0267,
                    0.0267,
                    0.0268,
                    0.0269,
                    0.027,
                    0.027,
                    0.0271,
                    0.0271,
                    0.0271,
                    0.0272,
                    0.0272,
                    0.0273,
                    0.0273,
                    0.0273,
                    0.0273,
                    0.0272,
                    0.0273,
                    0.0273,
                    0.0273,
                    0.0273,
                    0.0272,
                    0.0271,
                    0.027,
                    0.027,
                    0.0269,
                    0.0268,
                    0.0268,
                    0.0267,
                    0.0267,
                    0.0267,
                    0.0268,
                    0.0267,
                    0.0268,
                    0.0268,
                    0.0268,
                    0.0269,
                    0.027,
                    0.027,
                    0.0271,
                    0.0272,
                    0.0272,
                    0.0272,
                    0.0272
                ],
                "Total_CH4": 4.85,
                "Total_CH4_timeseries": [
                    0,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0051,
                    0.0052,
                    0.0052,
                    0.0052,
                    0.0053,
                    0.0053,
                    0.0053,
                    0.0054,
                    0.0054,
                    0.0054,
                    0.0055,
                    0.0055,
                    0.0056,
                    0.0056,
                    0.0057,
                    0.0058,
                    0.006,
                    0.0061,
                    0.0063,
                    0.0065,
                    0.0067,
                    0.007,
                    0.0072,
                    0.0075,
                    0.0077,
                    0.0079,
                    0.0081,
                    0.0083,
                    0.0085,
                    0.0086,
                    0.0088,
                    0.009,
                    0.0091,
                    0.0093,
                    0.0095,
                    0.0096,
                    0.0098,
                    0.01,
                    0.0102,
                    0.0104,
                    0.0106,
                    0.0108,
                    0.0111,
                    0.0113,
                    0.0116,
                    0.0119,
                    0.0122,
                    0.0125,
                    0.0129,
                    0.0132,
                    0.0135,
                    0.0137,
                    0.014,
                    0.0142,
                    0.0145,
                    0.0148,
                    0.015,
                    0.0153,
                    0.0156,
                    0.0158,
                    0.0161,
                    0.0163,
                    0.0165,
                    0.0168,
                    0.017,
                    0.0172,
                    0.0175,
                    0.0178,
                    0.018,
                    0.0183,
                    0.0187,
                    0.019,
                    0.0194,
                    0.0197,
                    0.0199,
                    0.02,
                    0.0201,
                    0.0201,
                    0.02,
                    0.0199,
                    0.0198,
                    0.0196,
                    0.0195,
                    0.0193,
                    0.0192,
                    0.0191,
                    0.0189,
                    0.0188,
                    0.0186,
                    0.0185,
                    0.0183,
                    0.0181,
                    0.018,
                    0.0179,
                    0.0179,
                    0.0179,
                    0.018,
                    0.0182,
                    0.0184,
                    0.0186,
                    0.0189,
                    0.0193,
                    0.0196,
                    0.0199,
                    0.0202
                ],
                "Fossil_CH4": 6.69,
                "Fossil_CH4_timeseries": [
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0032,
                    0.0033,
                    0.0035,
                    0.0036,
                    0.0038,
                    0.004,
                    0.0042,
                    0.0043,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0054,
                    0.0055,
                    0.0057,
                    0.0058,
                    0.006,
                    0.0062,
                    0.0064,
                    0.0066,
                    0.0068,
                    0.007,
                    0.0072,
                    0.0075,
                    0.0077,
                    0.008,
                    0.0083,
                    0.0086,
                    0.0088,
                    0.009,
                    0.0092,
                    0.0094,
                    0.0096,
                    0.0098,
                    0.0099,
                    0.0101,
                    0.0103,
                    0.0105,
                    0.0106,
                    0.0108,
                    0.0109,
                    0.011,
                    0.0112,
                    0.0113,
                    0.0115,
                    0.0116,
                    0.0118,
                    0.012,
                    0.0122,
                    0.0125,
                    0.0128,
                    0.0131,
                    0.0133,
                    0.0135,
                    0.0136,
                    0.0137,
                    0.0138,
                    0.0138,
                    0.0138,
                    0.0138,
                    0.0138,
                    0.0138,
                    0.0138,
                    0.0138,
                    0.0138,
                    0.0139,
                    0.0139,
                    0.014,
                    0.014,
                    0.014,
                    0.0141,
                    0.0141,
                    0.0142,
                    0.0143,
                    0.0145,
                    0.0147,
                    0.015,
                    0.0153,
                    0.0156,
                    0.0159,
                    0.0163,
                    0.0167,
                    0.017,
                    0.0174
                ],
                "Land_CH4": 1.8,
                "Land_CH4_timeseries": [
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.004,
                    0.004,
                    0.004,
                    0.004,
                    0.004,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0041,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0055,
                    0.0056,
                    0.0057,
                    0.0058,
                    0.0059,
                    0.006,
                    0.006,
                    0.0061,
                    0.0062,
                    0.0062,
                    0.0063,
                    0.0064,
                    0.0064,
                    0.0064,
                    0.0064,
                    0.0063,
                    0.0062,
                    0.0061,
                    0.006,
                    0.0058,
                    0.0057,
                    0.0055,
                    0.0054,
                    0.0052,
                    0.005,
                    0.0048,
                    0.0047,
                    0.0045,
                    0.0043,
                    0.0041,
                    0.0039,
                    0.0037,
                    0.0036,
                    0.0034,
                    0.0033,
                    0.0032,
                    0.0031,
                    0.003,
                    0.003,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029
                ],
                "Total_N2O": 4.81,
                "Total_N2O_timeseries": [
                    4.5873e-06,
                    9.2531e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.004
                ],
                "Fossil_N2O": 6.25,
                "Fossil_N2O_timeseries": [
                    1.4153e-06,
                    2.8457e-06,
                    4.2911e-06,
                    5.7514e-06,
                    7.2263e-06,
                    8.7157e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014
                ],
                "Land_N2O": 4.26,
                "Land_N2O_timeseries": [
                    3.172e-06,
                    6.4074e-06,
                    9.7035e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                130.67486,
                                42.28361
                            ],
                            [
                                130.74005,
                                42.34277
                            ],
                            [
                                130.78597,
                                42.46521
                            ],
                            [
                                130.84814,
                                42.48222
                            ],
                            [
                                130.83434,
                                42.56133
                            ],
                            [
                                130.66127,
                                42.662
                            ],
                            [
                                130.7226,
                                42.69409
                            ],
                            [
                                130.83838,
                                42.69988
                            ],
                            [
                                130.915,
                                42.59322
                            ],
                            [
                                130.98558,
                                42.64185
                            ],
                            [
                                131.08241,
                                42.64155
                            ],
                            [
                                131.20209,
                                42.55253
                            ],
                            [
                                131.26343,
                                42.77013
                            ],
                            [
                                131.3496,
                                42.79303
                            ],
                            [
                                131.43146,
                                42.8688
                            ],
                            [
                                131.4255,
                                42.9243
                            ],
                            [
                                131.50397,
                                42.94684
                            ],
                            [
                                131.4966,
                                42.99603
                            ],
                            [
                                131.65289,
                                43.10208
                            ],
                            [
                                131.74288,
                                43.2121
                            ],
                            [
                                131.76484,
                                43.31337
                            ],
                            [
                                132.068,
                                43.31422
                            ],
                            [
                                132.00527,
                                43.23651
                            ],
                            [
                                131.91773,
                                43.19729
                            ],
                            [
                                131.88099,
                                43.12834
                            ],
                            [
                                131.92946,
                                43.06155
                            ],
                            [
                                132.11681,
                                43.18249
                            ],
                            [
                                132.21814,
                                43.2171
                            ],
                            [
                                132.3172,
                                43.22669
                            ],
                            [
                                132.40099,
                                43.18614
                            ],
                            [
                                132.34097,
                                43.14482
                            ],
                            [
                                132.3073,
                                43.05534
                            ],
                            [
                                132.31984,
                                42.98309
                            ],
                            [
                                132.30237,
                                42.86875
                            ],
                            [
                                132.37118,
                                42.85092
                            ],
                            [
                                132.4237,
                                42.93715
                            ],
                            [
                                132.52216,
                                42.89438
                            ],
                            [
                                132.54112,
                                42.84699
                            ],
                            [
                                132.69823,
                                42.85248
                            ],
                            [
                                132.74389,
                                42.90559
                            ],
                            [
                                132.81671,
                                42.76273
                            ],
                            [
                                132.86195,
                                42.73697
                            ],
                            [
                                132.91077,
                                42.82597
                            ],
                            [
                                132.98365,
                                42.83424
                            ],
                            [
                                133.07191,
                                42.75956
                            ],
                            [
                                133.01343,
                                42.70813
                            ],
                            [
                                133.04759,
                                42.67646
                            ],
                            [
                                133.16222,
                                42.6896
                            ],
                            [
                                133.23905,
                                42.7481
                            ],
                            [
                                133.4794,
                                42.79515
                            ],
                            [
                                133.66018,
                                42.86195
                            ],
                            [
                                133.71798,
                                42.81527
                            ],
                            [
                                133.87418,
                                42.90485
                            ],
                            [
                                133.92898,
                                42.87185
                            ],
                            [
                                134.02945,
                                42.95754
                            ],
                            [
                                134.1212,
                                42.99184
                            ],
                            [
                                134.19394,
                                43.06825
                            ],
                            [
                                134.35049,
                                43.1133
                            ],
                            [
                                134.48736,
                                43.17834
                            ],
                            [
                                134.56655,
                                43.23412
                            ],
                            [
                                134.70111,
                                43.29193
                            ],
                            [
                                134.77526,
                                43.30473
                            ],
                            [
                                134.85461,
                                43.38695
                            ],
                            [
                                135.15181,
                                43.51689
                            ],
                            [
                                135.18375,
                                43.60871
                            ],
                            [
                                135.22253,
                                43.63632
                            ],
                            [
                                135.23064,
                                43.72386
                            ],
                            [
                                135.30157,
                                43.69046
                            ],
                            [
                                135.4324,
                                43.76222
                            ],
                            [
                                135.50847,
                                43.84676
                            ],
                            [
                                135.46627,
                                43.93995
                            ],
                            [
                                135.53846,
                                43.99678
                            ],
                            [
                                135.63493,
                                44.03518
                            ],
                            [
                                135.65711,
                                44.16687
                            ],
                            [
                                135.73081,
                                44.23767
                            ],
                            [
                                135.79953,
                                44.26628
                            ],
                            [
                                135.88663,
                                44.40027
                            ],
                            [
                                136.0412,
                                44.44587
                            ],
                            [
                                136.15633,
                                44.49962
                            ],
                            [
                                136.2361,
                                44.662
                            ],
                            [
                                136.33198,
                                44.71464
                            ],
                            [
                                136.35896,
                                44.79088
                            ],
                            [
                                136.44261,
                                44.81961
                            ],
                            [
                                136.54676,
                                44.90516
                            ],
                            [
                                136.63896,
                                45.0281
                            ],
                            [
                                136.75961,
                                45.08658
                            ],
                            [
                                136.7974,
                                45.17707
                            ],
                            [
                                137.08562,
                                45.35212
                            ],
                            [
                                137.14938,
                                45.37206
                            ],
                            [
                                137.30237,
                                45.5185
                            ],
                            [
                                137.36647,
                                45.6052
                            ],
                            [
                                137.49726,
                                45.6684
                            ],
                            [
                                137.68732,
                                45.7983
                            ],
                            [
                                137.77715,
                                45.93706
                            ],
                            [
                                138.11049,
                                46.23561
                            ],
                            [
                                138.1249,
                                46.34381
                            ],
                            [
                                138.18946,
                                46.44604
                            ],
                            [
                                138.35115,
                                46.53481
                            ],
                            [
                                138.35108,
                                46.627
                            ],
                            [
                                138.38998,
                                46.74733
                            ],
                            [
                                138.50275,
                                46.8746
                            ],
                            [
                                138.50714,
                                46.92964
                            ],
                            [
                                138.57548,
                                47.03301
                            ],
                            [
                                138.68763,
                                47.11607
                            ],
                            [
                                138.84444,
                                47.26615
                            ],
                            [
                                138.99844,
                                47.3535
                            ],
                            [
                                139.05708,
                                47.40542
                            ],
                            [
                                139.06525,
                                47.47354
                            ],
                            [
                                139.28801,
                                47.81199
                            ],
                            [
                                139.41563,
                                47.92109
                            ],
                            [
                                139.53542,
                                47.96455
                            ],
                            [
                                139.72158,
                                48.16517
                            ],
                            [
                                139.92355,
                                48.30391
                            ],
                            [
                                140.03054,
                                48.33527
                            ],
                            [
                                140.08297,
                                48.40534
                            ],
                            [
                                140.16068,
                                48.44066
                            ],
                            [
                                140.18582,
                                48.57361
                            ],
                            [
                                140.17749,
                                48.70011
                            ],
                            [
                                140.23784,
                                48.84195
                            ],
                            [
                                140.35851,
                                48.92525
                            ],
                            [
                                140.38327,
                                48.97415
                            ],
                            [
                                140.27978,
                                49.08815
                            ],
                            [
                                140.35242,
                                49.14918
                            ],
                            [
                                140.31268,
                                49.2121
                            ],
                            [
                                140.41895,
                                49.29937
                            ],
                            [
                                140.4154,
                                49.4044
                            ],
                            [
                                140.54172,
                                49.56796
                            ],
                            [
                                140.49963,
                                49.69768
                            ],
                            [
                                140.52974,
                                49.77306
                            ],
                            [
                                140.45758,
                                49.80847
                            ],
                            [
                                140.40607,
                                49.88157
                            ],
                            [
                                140.49274,
                                49.99416
                            ],
                            [
                                140.62979,
                                50.04506
                            ],
                            [
                                140.68425,
                                50.09059
                            ],
                            [
                                140.54667,
                                50.11669
                            ],
                            [
                                140.49875,
                                50.20363
                            ],
                            [
                                140.52434,
                                50.34001
                            ],
                            [
                                140.4829,
                                50.4604
                            ],
                            [
                                140.42216,
                                50.53945
                            ],
                            [
                                140.48897,
                                50.62568
                            ],
                            [
                                140.43823,
                                50.70758
                            ],
                            [
                                140.56096,
                                50.92376
                            ],
                            [
                                140.65045,
                                50.96065
                            ],
                            [
                                140.67765,
                                51.05442
                            ],
                            [
                                140.64553,
                                51.11537
                            ],
                            [
                                140.69135,
                                51.24917
                            ],
                            [
                                140.67178,
                                51.32241
                            ],
                            [
                                140.79277,
                                51.33496
                            ],
                            [
                                140.85468,
                                51.42132
                            ],
                            [
                                140.78392,
                                51.47126
                            ],
                            [
                                140.89246,
                                51.5232
                            ],
                            [
                                140.87593,
                                51.62588
                            ],
                            [
                                141.10154,
                                51.71215
                            ],
                            [
                                141.19099,
                                51.84659
                            ],
                            [
                                141.41476,
                                51.95052
                            ],
                            [
                                141.34303,
                                51.99031
                            ],
                            [
                                141.33721,
                                52.09763
                            ],
                            [
                                141.41888,
                                52.14498
                            ],
                            [
                                141.54445,
                                52.15379
                            ],
                            [
                                141.51773,
                                52.21389
                            ],
                            [
                                141.3965,
                                52.21686
                            ],
                            [
                                141.1209,
                                52.39449
                            ],
                            [
                                141.11316,
                                52.48351
                            ],
                            [
                                141.22312,
                                52.51679
                            ],
                            [
                                141.26366,
                                52.59041
                            ],
                            [
                                141.24336,
                                52.73155
                            ],
                            [
                                141.16653,
                                52.80165
                            ],
                            [
                                141.206,
                                52.84965
                            ],
                            [
                                140.95653,
                                52.93841
                            ],
                            [
                                140.92047,
                                53.03218
                            ],
                            [
                                140.81496,
                                53.05525
                            ],
                            [
                                140.73513,
                                53.10679
                            ],
                            [
                                140.81789,
                                53.13128
                            ],
                            [
                                140.86821,
                                53.08148
                            ],
                            [
                                140.95508,
                                53.06751
                            ],
                            [
                                141.13965,
                                52.98927
                            ],
                            [
                                141.36243,
                                53.08117
                            ],
                            [
                                141.3545,
                                53.12999
                            ],
                            [
                                141.44085,
                                53.16324
                            ],
                            [
                                141.36203,
                                53.24123
                            ],
                            [
                                141.41004,
                                53.28871
                            ],
                            [
                                141.18785,
                                53.31117
                            ],
                            [
                                141.10549,
                                53.39116
                            ],
                            [
                                140.90183,
                                53.43294
                            ],
                            [
                                140.94306,
                                53.49493
                            ],
                            [
                                140.61061,
                                53.60877
                            ],
                            [
                                140.51004,
                                53.66843
                            ],
                            [
                                140.51591,
                                53.70472
                            ],
                            [
                                140.33259,
                                53.78187
                            ],
                            [
                                140.2492,
                                53.87062
                            ],
                            [
                                140.30674,
                                53.95899
                            ],
                            [
                                140.20763,
                                53.99447
                            ],
                            [
                                140.18662,
                                54.05312
                            ],
                            [
                                139.97036,
                                54.11521
                            ],
                            [
                                139.77906,
                                54.21454
                            ],
                            [
                                139.7276,
                                54.29168
                            ],
                            [
                                139.62036,
                                54.24287
                            ],
                            [
                                139.44539,
                                54.19286
                            ],
                            [
                                139.32295,
                                54.17693
                            ],
                            [
                                139.17678,
                                54.18752
                            ],
                            [
                                138.92047,
                                54.24057
                            ],
                            [
                                138.7646,
                                54.2894
                            ],
                            [
                                138.72273,
                                54.14066
                            ],
                            [
                                138.75971,
                                54.08797
                            ],
                            [
                                138.76639,
                                53.98471
                            ],
                            [
                                138.70388,
                                53.88994
                            ],
                            [
                                138.6603,
                                53.70802
                            ],
                            [
                                138.49216,
                                53.53423
                            ],
                            [
                                138.36162,
                                53.50058
                            ],
                            [
                                138.27504,
                                53.50956
                            ],
                            [
                                138.36099,
                                53.60404
                            ],
                            [
                                138.34889,
                                53.63717
                            ],
                            [
                                138.52041,
                                53.75943
                            ],
                            [
                                138.58768,
                                53.86239
                            ],
                            [
                                138.56536,
                                53.98917
                            ],
                            [
                                138.37004,
                                53.90005
                            ],
                            [
                                138.30221,
                                53.73073
                            ],
                            [
                                138.1705,
                                53.66632
                            ],
                            [
                                138.00466,
                                53.61866
                            ],
                            [
                                137.96352,
                                53.57898
                            ],
                            [
                                137.69836,
                                53.54417
                            ],
                            [
                                137.31807,
                                53.52909
                            ],
                            [
                                137.22104,
                                53.58495
                            ],
                            [
                                137.27052,
                                53.62751
                            ],
                            [
                                137.4002,
                                53.66977
                            ],
                            [
                                137.47857,
                                53.6712
                            ],
                            [
                                137.61002,
                                53.78125
                            ],
                            [
                                137.66753,
                                53.86783
                            ],
                            [
                                137.81042,
                                53.9049
                            ],
                            [
                                137.77318,
                                53.95705
                            ],
                            [
                                137.53435,
                                53.97769
                            ],
                            [
                                137.44752,
                                54.03382
                            ],
                            [
                                137.30334,
                                54.05549
                            ],
                            [
                                137.34524,
                                54.12713
                            ],
                            [
                                137.47628,
                                54.12538
                            ],
                            [
                                137.67903,
                                54.26712
                            ],
                            [
                                137.45986,
                                54.31085
                            ],
                            [
                                137.2193,
                                54.21938
                            ],
                            [
                                137.09615,
                                54.13857
                            ],
                            [
                                137.20414,
                                54.03497
                            ],
                            [
                                137.29187,
                                54.01686
                            ],
                            [
                                137.20557,
                                53.88559
                            ],
                            [
                                137.12635,
                                53.80599
                            ],
                            [
                                137.06773,
                                53.84092
                            ],
                            [
                                136.94786,
                                53.85011
                            ],
                            [
                                136.86722,
                                53.82518
                            ],
                            [
                                136.80775,
                                53.76325
                            ],
                            [
                                136.71508,
                                53.79286
                            ],
                            [
                                136.6793,
                                53.91917
                            ],
                            [
                                136.70156,
                                54.01339
                            ],
                            [
                                136.76924,
                                54.04598
                            ],
                            [
                                136.81506,
                                54.14295
                            ],
                            [
                                136.75637,
                                54.28735
                            ],
                            [
                                136.76866,
                                54.42264
                            ],
                            [
                                136.87166,
                                54.57737
                            ],
                            [
                                136.76838,
                                54.61892
                            ],
                            [
                                136.6521,
                                54.61684
                            ],
                            [
                                136.50502,
                                54.5831
                            ],
                            [
                                136.2676,
                                54.58685
                            ],
                            [
                                136.22586,
                                54.60609
                            ],
                            [
                                135.97664,
                                54.56034
                            ],
                            [
                                135.74955,
                                54.55598
                            ],
                            [
                                135.70249,
                                54.64031
                            ],
                            [
                                135.28,
                                54.7201
                            ],
                            [
                                135.17855,
                                54.82281
                            ],
                            [
                                135.20688,
                                54.88396
                            ],
                            [
                                135.36204,
                                54.98585
                            ],
                            [
                                135.55064,
                                55.08493
                            ],
                            [
                                135.87331,
                                55.16854
                            ],
                            [
                                136.06894,
                                55.28052
                            ],
                            [
                                136.14387,
                                55.28638
                            ],
                            [
                                136.2974,
                                55.4189
                            ],
                            [
                                136.35074,
                                55.51442
                            ],
                            [
                                136.44129,
                                55.57126
                            ],
                            [
                                136.53474,
                                55.57687
                            ],
                            [
                                136.80801,
                                55.6956
                            ],
                            [
                                136.90705,
                                55.76373
                            ],
                            [
                                137.05311,
                                55.78429
                            ],
                            [
                                137.09412,
                                55.85127
                            ],
                            [
                                137.31429,
                                55.96256
                            ],
                            [
                                137.41968,
                                55.96966
                            ],
                            [
                                137.42426,
                                56.04164
                            ],
                            [
                                137.54255,
                                56.11703
                            ],
                            [
                                137.70883,
                                56.13585
                            ],
                            [
                                137.83305,
                                56.23241
                            ],
                            [
                                137.91928,
                                56.36999
                            ],
                            [
                                138.03578,
                                56.3825
                            ],
                            [
                                138.15343,
                                56.45411
                            ],
                            [
                                138.10671,
                                56.53275
                            ],
                            [
                                138.12277,
                                56.58785
                            ],
                            [
                                138.24244,
                                56.62633
                            ],
                            [
                                138.27942,
                                56.68788
                            ],
                            [
                                138.39378,
                                56.73677
                            ],
                            [
                                138.46039,
                                56.81313
                            ],
                            [
                                138.55564,
                                56.85598
                            ],
                            [
                                138.618,
                                56.95406
                            ],
                            [
                                138.68338,
                                56.98382
                            ],
                            [
                                138.87949,
                                57.01295
                            ],
                            [
                                138.92845,
                                57.05712
                            ],
                            [
                                138.93057,
                                57.1294
                            ],
                            [
                                139.00765,
                                57.15042
                            ],
                            [
                                139.18019,
                                57.26435
                            ],
                            [
                                139.4153,
                                57.29847
                            ],
                            [
                                139.50634,
                                57.3406
                            ],
                            [
                                139.60849,
                                57.45799
                            ],
                            [
                                139.78917,
                                57.48379
                            ],
                            [
                                139.87892,
                                57.60283
                            ],
                            [
                                140.05163,
                                57.72777
                            ],
                            [
                                140.33365,
                                57.78212
                            ],
                            [
                                140.48484,
                                57.84261
                            ],
                            [
                                140.50071,
                                57.90872
                            ],
                            [
                                140.6558,
                                58.16656
                            ],
                            [
                                140.77696,
                                58.30076
                            ],
                            [
                                141.03748,
                                58.441
                            ],
                            [
                                141.19123,
                                58.47026
                            ],
                            [
                                141.36678,
                                58.52733
                            ],
                            [
                                141.55349,
                                58.60658
                            ],
                            [
                                141.74459,
                                58.72989
                            ],
                            [
                                141.9721,
                                58.95542
                            ],
                            [
                                142.20035,
                                59.09485
                            ],
                            [
                                142.4717,
                                59.20231
                            ],
                            [
                                143.24327,
                                59.35806
                            ],
                            [
                                143.3906,
                                59.3267
                            ],
                            [
                                143.52204,
                                59.3279
                            ],
                            [
                                143.7381,
                                59.3793
                            ],
                            [
                                144.04503,
                                59.40008
                            ],
                            [
                                144.29046,
                                59.3734
                            ],
                            [
                                144.8622,
                                59.36202
                            ],
                            [
                                144.99518,
                                59.36703
                            ],
                            [
                                145.25457,
                                59.41786
                            ],
                            [
                                145.3535,
                                59.38703
                            ],
                            [
                                145.69182,
                                59.42167
                            ],
                            [
                                145.96538,
                                59.40057
                            ],
                            [
                                145.94694,
                                59.34599
                            ],
                            [
                                145.85497,
                                59.29684
                            ],
                            [
                                145.84186,
                                59.23305
                            ],
                            [
                                146.05207,
                                59.14365
                            ],
                            [
                                146.20787,
                                59.20588
                            ],
                            [
                                146.3536,
                                59.2207
                            ],
                            [
                                146.30831,
                                59.27426
                            ],
                            [
                                146.30932,
                                59.39303
                            ],
                            [
                                146.45497,
                                59.46167
                            ],
                            [
                                146.6262,
                                59.44293
                            ],
                            [
                                146.70589,
                                59.39065
                            ],
                            [
                                146.86353,
                                59.36266
                            ],
                            [
                                147.01305,
                                59.36698
                            ],
                            [
                                147.17473,
                                59.31955
                            ],
                            [
                                147.28917,
                                59.3285
                            ],
                            [
                                147.49151,
                                59.23949
                            ],
                            [
                                147.64304,
                                59.30068
                            ],
                            [
                                147.74838,
                                59.26356
                            ],
                            [
                                147.8493,
                                59.37446
                            ],
                            [
                                148.21113,
                                59.40825
                            ],
                            [
                                148.40499,
                                59.37531
                            ],
                            [
                                148.45488,
                                59.28144
                            ],
                            [
                                148.56832,
                                59.24159
                            ],
                            [
                                148.80981,
                                59.27211
                            ],
                            [
                                148.93149,
                                59.30816
                            ],
                            [
                                148.98179,
                                59.37501
                            ],
                            [
                                148.73793,
                                59.36319
                            ],
                            [
                                148.76117,
                                59.48011
                            ],
                            [
                                148.88104,
                                59.50234
                            ],
                            [
                                148.93978,
                                59.4571
                            ],
                            [
                                149.09517,
                                59.48664
                            ],
                            [
                                149.08875,
                                59.62201
                            ],
                            [
                                149.31433,
                                59.70937
                            ],
                            [
                                149.50261,
                                59.75171
                            ],
                            [
                                149.68038,
                                59.75317
                            ],
                            [
                                149.81898,
                                59.73326
                            ],
                            [
                                150.14528,
                                59.65616
                            ],
                            [
                                150.45223,
                                59.61429
                            ],
                            [
                                150.58529,
                                59.5448
                            ],
                            [
                                150.74088,
                                59.56498
                            ],
                            [
                                150.77278,
                                59.43556
                            ],
                            [
                                150.93244,
                                59.44693
                            ],
                            [
                                150.89944,
                                59.5486
                            ],
                            [
                                151.04977,
                                59.57748
                            ],
                            [
                                151.28546,
                                59.55671
                            ],
                            [
                                151.4406,
                                59.58585
                            ],
                            [
                                151.50308,
                                59.51753
                            ],
                            [
                                151.64762,
                                59.4672
                            ],
                            [
                                151.77235,
                                59.3536
                            ],
                            [
                                151.76587,
                                59.29857
                            ],
                            [
                                151.90637,
                                59.30373
                            ],
                            [
                                152.01083,
                                59.26704
                            ],
                            [
                                152.17286,
                                59.29041
                            ],
                            [
                                152.28387,
                                59.2423
                            ],
                            [
                                152.08656,
                                59.14662
                            ],
                            [
                                151.76295,
                                59.12982
                            ],
                            [
                                151.65392,
                                59.15817
                            ],
                            [
                                151.436,
                                59.16355
                            ],
                            [
                                151.36525,
                                59.11832
                            ],
                            [
                                151.21331,
                                59.08361
                            ],
                            [
                                151.16672,
                                59.03382
                            ],
                            [
                                151.24306,
                                58.99186
                            ],
                            [
                                151.25647,
                                58.93622
                            ],
                            [
                                151.36122,
                                58.86395
                            ],
                            [
                                151.6779,
                                58.84405
                            ],
                            [
                                151.82869,
                                58.87835
                            ],
                            [
                                152.00062,
                                58.8794
                            ],
                            [
                                152.13045,
                                58.90494
                            ],
                            [
                                152.15118,
                                58.9737
                            ],
                            [
                                152.27789,
                                59.0107
                            ],
                            [
                                152.42262,
                                59.02049
                            ],
                            [
                                152.56248,
                                58.95135
                            ],
                            [
                                152.72999,
                                58.91118
                            ],
                            [
                                152.90958,
                                58.93381
                            ],
                            [
                                153.01775,
                                59.06253
                            ],
                            [
                                153.11073,
                                59.08621
                            ],
                            [
                                153.32413,
                                59.08673
                            ],
                            [
                                153.39327,
                                59.23856
                            ],
                            [
                                153.60276,
                                59.19505
                            ],
                            [
                                153.83574,
                                59.16582
                            ],
                            [
                                153.92879,
                                59.07247
                            ],
                            [
                                154.04313,
                                59.04881
                            ],
                            [
                                154.17112,
                                59.08984
                            ],
                            [
                                154.35166,
                                59.11208
                            ],
                            [
                                154.33239,
                                59.18991
                            ],
                            [
                                154.49406,
                                59.21693
                            ],
                            [
                                154.62717,
                                59.16178
                            ],
                            [
                                154.79667,
                                59.1285
                            ],
                            [
                                154.79342,
                                59.18163
                            ],
                            [
                                155.01829,
                                59.17276
                            ],
                            [
                                155.1969,
                                59.23708
                            ],
                            [
                                155.18133,
                                59.36664
                            ],
                            [
                                155.09335,
                                59.39099
                            ],
                            [
                                154.98019,
                                59.49115
                            ],
                            [
                                154.79666,
                                59.46657
                            ],
                            [
                                154.66708,
                                59.53105
                            ],
                            [
                                154.45474,
                                59.51898
                            ],
                            [
                                154.52795,
                                59.43645
                            ],
                            [
                                154.43266,
                                59.41866
                            ],
                            [
                                154.1405,
                                59.45455
                            ],
                            [
                                154.10001,
                                59.53853
                            ],
                            [
                                154.18805,
                                59.57632
                            ],
                            [
                                154.21394,
                                59.66017
                            ],
                            [
                                154.28107,
                                59.66843
                            ],
                            [
                                154.21608,
                                59.77628
                            ],
                            [
                                154.22475,
                                59.87185
                            ],
                            [
                                154.31831,
                                59.89457
                            ],
                            [
                                154.48598,
                                59.88415
                            ],
                            [
                                154.41874,
                                60.06516
                            ],
                            [
                                154.57136,
                                60.09573
                            ],
                            [
                                154.78278,
                                60.2441
                            ],
                            [
                                154.82982,
                                60.29986
                            ],
                            [
                                154.98394,
                                60.36826
                            ],
                            [
                                155.16184,
                                60.41481
                            ],
                            [
                                155.33086,
                                60.51889
                            ],
                            [
                                155.4766,
                                60.53449
                            ],
                            [
                                155.49034,
                                60.57596
                            ],
                            [
                                155.62825,
                                60.64097
                            ],
                            [
                                155.72252,
                                60.65119
                            ],
                            [
                                155.84125,
                                60.72965
                            ],
                            [
                                155.91523,
                                60.71933
                            ],
                            [
                                155.92793,
                                60.86634
                            ],
                            [
                                156.12099,
                                61.01646
                            ],
                            [
                                156.39214,
                                61.14681
                            ],
                            [
                                156.54053,
                                61.20174
                            ],
                            [
                                156.66571,
                                61.21259
                            ],
                            [
                                156.63396,
                                61.28421
                            ],
                            [
                                156.67347,
                                61.48776
                            ],
                            [
                                156.96939,
                                61.55635
                            ],
                            [
                                157.05674,
                                61.64502
                            ],
                            [
                                157.27234,
                                61.69206
                            ],
                            [
                                157.37413,
                                61.69327
                            ],
                            [
                                157.45054,
                                61.76915
                            ],
                            [
                                157.56716,
                                61.78835
                            ],
                            [
                                157.82484,
                                61.77847
                            ],
                            [
                                158.04386,
                                61.72718
                            ],
                            [
                                158.2556,
                                61.81371
                            ],
                            [
                                158.71004,
                                61.83422
                            ],
                            [
                                158.85037,
                                61.81523
                            ],
                            [
                                158.90543,
                                61.89674
                            ],
                            [
                                159.02213,
                                61.91971
                            ],
                            [
                                159.19724,
                                61.91717
                            ],
                            [
                                159.39796,
                                61.87523
                            ],
                            [
                                159.43046,
                                61.7829
                            ],
                            [
                                159.52848,
                                61.79664
                            ],
                            [
                                159.5302,
                                61.68766
                            ],
                            [
                                159.58375,
                                61.65422
                            ],
                            [
                                159.80655,
                                61.70695
                            ],
                            [
                                159.89612,
                                61.70624
                            ],
                            [
                                160.05242,
                                61.84246
                            ],
                            [
                                160.30803,
                                61.93628
                            ],
                            [
                                160.40394,
                                61.88059
                            ],
                            [
                                160.42262,
                                61.762
                            ],
                            [
                                160.32253,
                                61.6805
                            ],
                            [
                                160.22989,
                                61.51334
                            ],
                            [
                                160.04693,
                                61.44825
                            ],
                            [
                                160.10343,
                                61.40981
                            ],
                            [
                                159.98712,
                                61.33775
                            ],
                            [
                                159.79949,
                                61.25951
                            ],
                            [
                                159.97857,
                                61.17606
                            ],
                            [
                                160.00658,
                                61.10754
                            ],
                            [
                                159.93565,
                                61.02149
                            ],
                            [
                                159.84533,
                                60.97411
                            ],
                            [
                                159.95188,
                                60.94146
                            ],
                            [
                                160.20058,
                                61.03792
                            ],
                            [
                                160.42846,
                                61.03567
                            ],
                            [
                                160.43174,
                                60.98677
                            ],
                            [
                                160.19105,
                                60.82318
                            ],
                            [
                                160.25491,
                                60.77739
                            ],
                            [
                                160.25385,
                                60.70526
                            ],
                            [
                                160.16859,
                                60.64218
                            ],
                            [
                                160.27832,
                                60.60112
                            ],
                            [
                                160.42042,
                                60.70277
                            ],
                            [
                                160.70457,
                                60.76263
                            ],
                            [
                                160.7997,
                                60.71812
                            ],
                            [
                                160.92629,
                                60.88738
                            ],
                            [
                                161.19091,
                                60.9901
                            ],
                            [
                                161.21615,
                                61.04521
                            ],
                            [
                                161.31423,
                                61.0583
                            ],
                            [
                                161.45415,
                                61.12072
                            ],
                            [
                                161.49607,
                                61.19585
                            ],
                            [
                                161.60508,
                                61.25227
                            ],
                            [
                                161.79506,
                                61.30297
                            ],
                            [
                                161.98692,
                                61.37353
                            ],
                            [
                                162.33503,
                                61.58308
                            ],
                            [
                                162.43873,
                                61.6677
                            ],
                            [
                                162.63587,
                                61.65616
                            ],
                            [
                                162.84099,
                                61.70906
                            ],
                            [
                                162.94401,
                                61.64458
                            ],
                            [
                                163.02156,
                                61.5127
                            ],
                            [
                                163.12187,
                                61.54434
                            ],
                            [
                                163.11954,
                                61.61141
                            ],
                            [
                                163.32498,
                                61.6539
                            ],
                            [
                                163.2919,
                                61.72155
                            ],
                            [
                                163.0908,
                                61.75511
                            ],
                            [
                                162.98928,
                                61.80298
                            ],
                            [
                                163.14778,
                                62.02583
                            ],
                            [
                                163.14992,
                                62.12398
                            ],
                            [
                                163.09959,
                                62.21385
                            ],
                            [
                                163.25229,
                                62.31157
                            ],
                            [
                                163.2647,
                                62.37239
                            ],
                            [
                                163.20497,
                                62.43257
                            ],
                            [
                                163.33301,
                                62.52995
                            ],
                            [
                                163.60578,
                                62.5734
                            ],
                            [
                                163.85175,
                                62.59808
                            ],
                            [
                                163.94734,
                                62.58441
                            ],
                            [
                                164.05791,
                                62.64584
                            ],
                            [
                                164.2856,
                                62.65497
                            ],
                            [
                                164.37853,
                                62.68365
                            ],
                            [
                                164.60445,
                                62.67429
                            ],
                            [
                                164.73463,
                                62.56845
                            ],
                            [
                                164.91497,
                                62.54111
                            ],
                            [
                                165.10528,
                                62.48516
                            ],
                            [
                                165.06612,
                                62.41593
                            ],
                            [
                                164.80613,
                                62.43319
                            ],
                            [
                                164.74326,
                                62.45233
                            ],
                            [
                                164.54381,
                                62.43775
                            ],
                            [
                                164.45964,
                                62.36374
                            ],
                            [
                                164.25397,
                                62.3095
                            ],
                            [
                                164.17264,
                                62.26894
                            ],
                            [
                                164.09504,
                                62.09132
                            ],
                            [
                                164.12659,
                                62.01798
                            ],
                            [
                                164.08339,
                                61.98276
                            ],
                            [
                                164.10656,
                                61.89432
                            ],
                            [
                                164.06245,
                                61.67981
                            ],
                            [
                                163.88116,
                                61.6442
                            ],
                            [
                                163.85677,
                                61.56227
                            ],
                            [
                                163.7591,
                                61.46136
                            ],
                            [
                                163.96783,
                                61.4173
                            ],
                            [
                                164.03728,
                                61.34105
                            ],
                            [
                                163.92889,
                                61.21457
                            ],
                            [
                                163.77682,
                                61.17286
                            ],
                            [
                                163.63457,
                                61.10647
                            ],
                            [
                                163.62482,
                                61.05273
                            ],
                            [
                                163.50784,
                                61.00578
                            ],
                            [
                                163.78477,
                                60.91868
                            ],
                            [
                                163.64427,
                                60.86606
                            ],
                            [
                                163.39925,
                                60.80202
                            ],
                            [
                                163.18871,
                                60.79825
                            ],
                            [
                                163.07877,
                                60.7494
                            ],
                            [
                                162.91058,
                                60.74971
                            ],
                            [
                                162.80747,
                                60.64627
                            ],
                            [
                                162.71185,
                                60.60108
                            ],
                            [
                                162.53452,
                                60.60374
                            ],
                            [
                                162.41829,
                                60.53978
                            ],
                            [
                                162.22408,
                                60.51922
                            ],
                            [
                                162.16907,
                                60.47866
                            ],
                            [
                                161.96002,
                                60.41543
                            ],
                            [
                                161.92752,
                                60.20727
                            ],
                            [
                                161.77901,
                                60.12247
                            ],
                            [
                                161.51062,
                                60.04048
                            ],
                            [
                                161.3525,
                                59.92993
                            ],
                            [
                                161.28225,
                                59.84684
                            ],
                            [
                                161.00487,
                                59.71118
                            ],
                            [
                                160.89601,
                                59.62606
                            ],
                            [
                                160.48245,
                                59.53348
                            ],
                            [
                                160.40902,
                                59.40002
                            ],
                            [
                                160.30369,
                                59.3428
                            ],
                            [
                                160.20226,
                                59.32867
                            ],
                            [
                                159.93226,
                                59.12034
                            ],
                            [
                                159.72877,
                                58.99052
                            ],
                            [
                                159.75905,
                                58.94625
                            ],
                            [
                                159.72986,
                                58.86544
                            ],
                            [
                                159.3354,
                                58.606
                            ],
                            [
                                159.17154,
                                58.5193
                            ],
                            [
                                159.14057,
                                58.47077
                            ],
                            [
                                159.02403,
                                58.40392
                            ],
                            [
                                158.72078,
                                58.28583
                            ],
                            [
                                158.34765,
                                58.07975
                            ],
                            [
                                158.10191,
                                57.99673
                            ],
                            [
                                157.93485,
                                57.97362
                            ],
                            [
                                157.6777,
                                58.00992
                            ],
                            [
                                157.58235,
                                57.93034
                            ],
                            [
                                157.54503,
                                57.83707
                            ],
                            [
                                157.32431,
                                57.77061
                            ],
                            [
                                157.0866,
                                57.79502
                            ],
                            [
                                157.00724,
                                57.85717
                            ],
                            [
                                156.86646,
                                57.80388
                            ],
                            [
                                156.79121,
                                57.73355
                            ],
                            [
                                156.88673,
                                57.69903
                            ],
                            [
                                156.96239,
                                57.60667
                            ],
                            [
                                157.00731,
                                57.45547
                            ],
                            [
                                156.97351,
                                57.3815
                            ],
                            [
                                156.78156,
                                57.16207
                            ],
                            [
                                156.68663,
                                57.09051
                            ],
                            [
                                156.56152,
                                57.10645
                            ],
                            [
                                156.55356,
                                57.04704
                            ],
                            [
                                156.48156,
                                56.96272
                            ],
                            [
                                156.36823,
                                56.90404
                            ],
                            [
                                156.12267,
                                56.81786
                            ],
                            [
                                155.98697,
                                56.6836
                            ],
                            [
                                155.75487,
                                56.15294
                            ],
                            [
                                155.66177,
                                55.98884
                            ],
                            [
                                155.61384,
                                55.60747
                            ],
                            [
                                155.54727,
                                55.38591
                            ],
                            [
                                155.5521,
                                55.19281
                            ],
                            [
                                155.62244,
                                54.83738
                            ],
                            [
                                155.72637,
                                54.4381
                            ],
                            [
                                155.89115,
                                53.99194
                            ],
                            [
                                155.99929,
                                53.59109
                            ],
                            [
                                156.07212,
                                53.26416
                            ],
                            [
                                156.12441,
                                52.92056
                            ],
                            [
                                156.16679,
                                52.77266
                            ],
                            [
                                156.3716,
                                52.39035
                            ],
                            [
                                156.46223,
                                52.12496
                            ],
                            [
                                156.49522,
                                51.92203
                            ],
                            [
                                156.49773,
                                51.71238
                            ],
                            [
                                156.47967,
                                51.56231
                            ],
                            [
                                156.54007,
                                51.29511
                            ],
                            [
                                156.64737,
                                51.2472
                            ],
                            [
                                156.71727,
                                51.16888
                            ],
                            [
                                156.70278,
                                51.09517
                            ],
                            [
                                156.75969,
                                51.06786
                            ],
                            [
                                156.77958,
                                50.94091
                            ],
                            [
                                157.09597,
                                51.15221
                            ],
                            [
                                157.22883,
                                51.21486
                            ],
                            [
                                157.33798,
                                51.32327
                            ],
                            [
                                157.46617,
                                51.36286
                            ],
                            [
                                157.50326,
                                51.45267
                            ],
                            [
                                157.61715,
                                51.52893
                            ],
                            [
                                157.73847,
                                51.5457
                            ],
                            [
                                157.903,
                                51.63915
                            ],
                            [
                                158.03157,
                                51.78515
                            ],
                            [
                                158.27961,
                                51.96329
                            ],
                            [
                                158.33576,
                                52.131
                            ],
                            [
                                158.38227,
                                52.20115
                            ],
                            [
                                158.51604,
                                52.2641
                            ],
                            [
                                158.56905,
                                52.31418
                            ],
                            [
                                158.53787,
                                52.3549
                            ],
                            [
                                158.51478,
                                52.5524
                            ],
                            [
                                158.42175,
                                52.62081
                            ],
                            [
                                158.55657,
                                52.61866
                            ],
                            [
                                158.60074,
                                52.67983
                            ],
                            [
                                158.48285,
                                52.76177
                            ],
                            [
                                158.64077,
                                52.83572
                            ],
                            [
                                158.62882,
                                52.90841
                            ],
                            [
                                158.43595,
                                52.88925
                            ],
                            [
                                158.47117,
                                52.95564
                            ],
                            [
                                158.42414,
                                53.00434
                            ],
                            [
                                158.57602,
                                53.05527
                            ],
                            [
                                158.64073,
                                53.02101
                            ],
                            [
                                158.73969,
                                52.89126
                            ],
                            [
                                158.90071,
                                53.01612
                            ],
                            [
                                159.0674,
                                53.09268
                            ],
                            [
                                159.31194,
                                53.15802
                            ],
                            [
                                159.38996,
                                53.14762
                            ],
                            [
                                159.48928,
                                53.22225
                            ],
                            [
                                159.62468,
                                53.24921
                            ],
                            [
                                159.74916,
                                53.19198
                            ],
                            [
                                160.03177,
                                53.09262
                            ],
                            [
                                160.0394,
                                53.20562
                            ],
                            [
                                159.90701,
                                53.24883
                            ],
                            [
                                159.97345,
                                53.31073
                            ],
                            [
                                159.84004,
                                53.44441
                            ],
                            [
                                159.96307,
                                53.49221
                            ],
                            [
                                159.95699,
                                53.57589
                            ],
                            [
                                159.84553,
                                53.71546
                            ],
                            [
                                159.85476,
                                53.83584
                            ],
                            [
                                159.96176,
                                54.02295
                            ],
                            [
                                159.99369,
                                54.11245
                            ],
                            [
                                160.11019,
                                54.20829
                            ],
                            [
                                160.2842,
                                54.2836
                            ],
                            [
                                160.409,
                                54.37784
                            ],
                            [
                                160.58872,
                                54.47112
                            ],
                            [
                                160.94654,
                                54.58298
                            ],
                            [
                                161.11317,
                                54.5905
                            ],
                            [
                                161.20016,
                                54.57245
                            ],
                            [
                                161.20573,
                                54.52273
                            ],
                            [
                                161.28375,
                                54.4786
                            ],
                            [
                                161.47415,
                                54.5142
                            ],
                            [
                                161.72967,
                                54.51286
                            ],
                            [
                                161.82739,
                                54.59893
                            ],
                            [
                                162.12028,
                                54.75272
                            ],
                            [
                                162.09879,
                                54.8031
                            ],
                            [
                                162.15164,
                                54.84773
                            ],
                            [
                                162.07277,
                                54.8899
                            ],
                            [
                                162.04226,
                                54.94706
                            ],
                            [
                                161.92774,
                                55.04889
                            ],
                            [
                                161.87945,
                                55.06346
                            ],
                            [
                                161.79436,
                                55.18315
                            ],
                            [
                                161.73772,
                                55.35981
                            ],
                            [
                                161.75073,
                                55.56199
                            ],
                            [
                                161.78757,
                                55.64569
                            ],
                            [
                                161.91365,
                                55.78783
                            ],
                            [
                                161.91976,
                                55.8293
                            ],
                            [
                                162.01358,
                                55.93189
                            ],
                            [
                                162.09443,
                                56.08311
                            ],
                            [
                                162.21902,
                                56.14713
                            ],
                            [
                                162.59742,
                                56.23255
                            ],
                            [
                                162.6599,
                                56.21594
                            ],
                            [
                                162.8329,
                                56.06283
                            ],
                            [
                                163.00136,
                                56.01227
                            ],
                            [
                                163.0616,
                                56.02272
                            ],
                            [
                                163.20723,
                                56.14181
                            ],
                            [
                                163.3682,
                                56.18624
                            ],
                            [
                                163.3394,
                                56.26757
                            ],
                            [
                                163.36056,
                                56.32513
                            ],
                            [
                                163.27907,
                                56.46755
                            ],
                            [
                                163.24907,
                                56.63939
                            ],
                            [
                                163.28863,
                                56.68963
                            ],
                            [
                                163.24412,
                                56.73967
                            ],
                            [
                                163.08524,
                                56.74264
                            ],
                            [
                                162.93449,
                                56.6971
                            ],
                            [
                                162.8478,
                                56.72599
                            ],
                            [
                                162.79022,
                                56.78928
                            ],
                            [
                                162.86107,
                                57.01897
                            ],
                            [
                                162.77979,
                                57.185
                            ],
                            [
                                162.78835,
                                57.34166
                            ],
                            [
                                162.91723,
                                57.4317
                            ],
                            [
                                163.09626,
                                57.47691
                            ],
                            [
                                163.15887,
                                57.56997
                            ],
                            [
                                163.24584,
                                57.61617
                            ],
                            [
                                163.22762,
                                57.65754
                            ],
                            [
                                163.29883,
                                57.73172
                            ],
                            [
                                163.20975,
                                57.81464
                            ],
                            [
                                163.03882,
                                57.81923
                            ],
                            [
                                162.87235,
                                57.89417
                            ],
                            [
                                162.73848,
                                57.92631
                            ],
                            [
                                162.56704,
                                57.92928
                            ],
                            [
                                162.50152,
                                57.86746
                            ],
                            [
                                162.51412,
                                57.77453
                            ],
                            [
                                162.38746,
                                57.77995
                            ],
                            [
                                162.14321,
                                57.84226
                            ],
                            [
                                162.04578,
                                57.92361
                            ],
                            [
                                162.00306,
                                58.01117
                            ],
                            [
                                162.01565,
                                58.13568
                            ],
                            [
                                162.16126,
                                58.38589
                            ],
                            [
                                162.28959,
                                58.53051
                            ],
                            [
                                162.45074,
                                58.67826
                            ],
                            [
                                162.56298,
                                58.74834
                            ],
                            [
                                162.79576,
                                58.82951
                            ],
                            [
                                162.86816,
                                58.89829
                            ],
                            [
                                163.06499,
                                58.97788
                            ],
                            [
                                162.91903,
                                59.11933
                            ],
                            [
                                162.99221,
                                59.15578
                            ],
                            [
                                163.12172,
                                59.1331
                            ],
                            [
                                163.0873,
                                59.24488
                            ],
                            [
                                163.20302,
                                59.28295
                            ],
                            [
                                163.34072,
                                59.28283
                            ],
                            [
                                163.35803,
                                59.35268
                            ],
                            [
                                163.30862,
                                59.43158
                            ],
                            [
                                163.21861,
                                59.47977
                            ],
                            [
                                163.23052,
                                59.57511
                            ],
                            [
                                163.37408,
                                59.59253
                            ],
                            [
                                163.42243,
                                59.65272
                            ],
                            [
                                163.39551,
                                59.78174
                            ],
                            [
                                163.52371,
                                59.88725
                            ],
                            [
                                163.70772,
                                59.88141
                            ],
                            [
                                163.88003,
                                60.00337
                            ],
                            [
                                164.1425,
                                60.00898
                            ],
                            [
                                164.21201,
                                59.9627
                            ],
                            [
                                164.33889,
                                59.99653
                            ],
                            [
                                164.32641,
                                60.06871
                            ],
                            [
                                164.51241,
                                60.09747
                            ],
                            [
                                164.6234,
                                60.02405
                            ],
                            [
                                164.71493,
                                60.00113
                            ],
                            [
                                164.7984,
                                59.92225
                            ],
                            [
                                164.81614,
                                59.82294
                            ],
                            [
                                165.10194,
                                59.86273
                            ],
                            [
                                165.17911,
                                59.9693
                            ],
                            [
                                165.11668,
                                60.0849
                            ],
                            [
                                165.22909,
                                60.08962
                            ],
                            [
                                165.37635,
                                60.16631
                            ],
                            [
                                165.76272,
                                60.26986
                            ],
                            [
                                165.83057,
                                60.31476
                            ],
                            [
                                166.00069,
                                60.35883
                            ],
                            [
                                166.14259,
                                60.43892
                            ],
                            [
                                166.26526,
                                60.46716
                            ],
                            [
                                166.36601,
                                60.40369
                            ],
                            [
                                166.2502,
                                60.36469
                            ],
                            [
                                166.3018,
                                60.19582
                            ],
                            [
                                166.21532,
                                60.1378
                            ],
                            [
                                166.17517,
                                59.98134
                            ],
                            [
                                166.09931,
                                59.88384
                            ],
                            [
                                166.08828,
                                59.81919
                            ],
                            [
                                166.27113,
                                59.81825
                            ],
                            [
                                166.41352,
                                59.93201
                            ],
                            [
                                166.73569,
                                60.10719
                            ],
                            [
                                166.77404,
                                60.15691
                            ],
                            [
                                166.97798,
                                60.29989
                            ],
                            [
                                167.06558,
                                60.31128
                            ],
                            [
                                167.03881,
                                60.38059
                            ],
                            [
                                167.2158,
                                60.34236
                            ],
                            [
                                167.31942,
                                60.38584
                            ],
                            [
                                167.61289,
                                60.43975
                            ],
                            [
                                168.07246,
                                60.55853
                            ],
                            [
                                168.34062,
                                60.5958
                            ],
                            [
                                168.52073,
                                60.59717
                            ],
                            [
                                168.70776,
                                60.54513
                            ],
                            [
                                168.79519,
                                60.56623
                            ],
                            [
                                169.08261,
                                60.55883
                            ],
                            [
                                169.41384,
                                60.51399
                            ],
                            [
                                169.75329,
                                60.38001
                            ],
                            [
                                169.79081,
                                60.26514
                            ],
                            [
                                169.87195,
                                60.23374
                            ],
                            [
                                169.95692,
                                60.07975
                            ],
                            [
                                170.15778,
                                60.01613
                            ],
                            [
                                170.13771,
                                59.97251
                            ],
                            [
                                170.29102,
                                59.92866
                            ],
                            [
                                170.42961,
                                59.97008
                            ],
                            [
                                170.50095,
                                60.22179
                            ],
                            [
                                170.57502,
                                60.27883
                            ],
                            [
                                170.69794,
                                60.31155
                            ],
                            [
                                170.63579,
                                60.35223
                            ],
                            [
                                170.66814,
                                60.41015
                            ],
                            [
                                170.80229,
                                60.42357
                            ],
                            [
                                170.86793,
                                60.48622
                            ],
                            [
                                171.15355,
                                60.54972
                            ],
                            [
                                171.39286,
                                60.61702
                            ],
                            [
                                171.42194,
                                60.66781
                            ],
                            [
                                171.52802,
                                60.7142
                            ],
                            [
                                171.62822,
                                60.7175
                            ],
                            [
                                171.62735,
                                60.7804
                            ],
                            [
                                171.72321,
                                60.83399
                            ],
                            [
                                171.89262,
                                60.81846
                            ],
                            [
                                172.06551,
                                60.83997
                            ],
                            [
                                172.14032,
                                60.92315
                            ],
                            [
                                172.28417,
                                61.00873
                            ],
                            [
                                172.41019,
                                61.01107
                            ],
                            [
                                172.48053,
                                61.04483
                            ],
                            [
                                172.43513,
                                61.14133
                            ],
                            [
                                172.51794,
                                61.17442
                            ],
                            [
                                172.6631,
                                61.17234
                            ],
                            [
                                172.79255,
                                61.27145
                            ],
                            [
                                172.89425,
                                61.2591
                            ],
                            [
                                172.933,
                                61.33945
                            ],
                            [
                                172.749,
                                61.39592
                            ],
                            [
                                172.91072,
                                61.46221
                            ],
                            [
                                173.01346,
                                61.40592
                            ],
                            [
                                173.15217,
                                61.39135
                            ],
                            [
                                173.31195,
                                61.45759
                            ],
                            [
                                173.35819,
                                61.53466
                            ],
                            [
                                173.50569,
                                61.56455
                            ],
                            [
                                173.50625,
                                61.70825
                            ],
                            [
                                173.63285,
                                61.7396
                            ],
                            [
                                173.81712,
                                61.67288
                            ],
                            [
                                174.00718,
                                61.70368
                            ],
                            [
                                174.15968,
                                61.83373
                            ],
                            [
                                174.23609,
                                61.80481
                            ],
                            [
                                174.60766,
                                61.82523
                            ],
                            [
                                174.92169,
                                61.94515
                            ],
                            [
                                175.23668,
                                62.01367
                            ],
                            [
                                175.46225,
                                62.11599
                            ],
                            [
                                175.71875,
                                62.18916
                            ],
                            [
                                175.99341,
                                62.24613
                            ],
                            [
                                176.25003,
                                62.27762
                            ],
                            [
                                176.54901,
                                62.40935
                            ],
                            [
                                176.93355,
                                62.50381
                            ],
                            [
                                177.12464,
                                62.53166
                            ],
                            [
                                177.56676,
                                62.55282
                            ],
                            [
                                178.07554,
                                62.5212
                            ],
                            [
                                178.20713,
                                62.4748
                            ],
                            [
                                178.8042,
                                62.36377
                            ],
                            [
                                179.17416,
                                62.31013
                            ],
                            [
                                179.18203,
                                62.38318
                            ],
                            [
                                179.11373,
                                62.41346
                            ],
                            [
                                179.21514,
                                62.48288
                            ],
                            [
                                179.36295,
                                62.46986
                            ],
                            [
                                179.44838,
                                62.52553
                            ],
                            [
                                179.46299,
                                62.58576
                            ],
                            [
                                179.5826,
                                62.61129
                            ],
                            [
                                179.62764,
                                62.68155
                            ],
                            [
                                179.56217,
                                62.83703
                            ],
                            [
                                179.31587,
                                62.88833
                            ],
                            [
                                179.26813,
                                62.99452
                            ],
                            [
                                179.32402,
                                63.04719
                            ],
                            [
                                179.46307,
                                63.05616
                            ],
                            [
                                179.45038,
                                63.10919
                            ],
                            [
                                179.32815,
                                63.19118
                            ],
                            [
                                179.0966,
                                63.26338
                            ],
                            [
                                179.00452,
                                63.32245
                            ],
                            [
                                178.84131,
                                63.48366
                            ],
                            [
                                178.79795,
                                63.68602
                            ],
                            [
                                178.65553,
                                64.02324
                            ],
                            [
                                178.33063,
                                64.33371
                            ],
                            [
                                178.25376,
                                64.28016
                            ],
                            [
                                178.05382,
                                64.19449
                            ],
                            [
                                177.81409,
                                64.25169
                            ],
                            [
                                177.50175,
                                64.40865
                            ],
                            [
                                177.42958,
                                64.48264
                            ],
                            [
                                177.42346,
                                64.55665
                            ],
                            [
                                177.49743,
                                64.62192
                            ],
                            [
                                177.49573,
                                64.73847
                            ],
                            [
                                177.35974,
                                64.7468
                            ],
                            [
                                177.18951,
                                64.69526
                            ],
                            [
                                177.08127,
                                64.7013
                            ],
                            [
                                176.80251,
                                64.54086
                            ],
                            [
                                176.7131,
                                64.61704
                            ],
                            [
                                176.45354,
                                64.67163
                            ],
                            [
                                176.32713,
                                64.75919
                            ],
                            [
                                176.22226,
                                64.86983
                            ],
                            [
                                176.07299,
                                64.8976
                            ],
                            [
                                176.05575,
                                64.93953
                            ],
                            [
                                176.43054,
                                64.8472
                            ],
                            [
                                176.56295,
                                64.79705
                            ],
                            [
                                176.67522,
                                64.84934
                            ],
                            [
                                176.96035,
                                64.82169
                            ],
                            [
                                176.99203,
                                64.77835
                            ],
                            [
                                177.18783,
                                64.76348
                            ],
                            [
                                177.28688,
                                64.82602
                            ],
                            [
                                177.2859,
                                64.9096
                            ],
                            [
                                177.51375,
                                64.90676
                            ],
                            [
                                177.49021,
                                64.818
                            ],
                            [
                                177.72535,
                                64.68791
                            ],
                            [
                                178.16872,
                                64.6676
                            ],
                            [
                                178.32811,
                                64.63689
                            ],
                            [
                                178.76309,
                                64.6687
                            ],
                            [
                                178.80852,
                                64.64307
                            ],
                            [
                                179.13661,
                                64.7522
                            ],
                            [
                                179.52903,
                                64.79894
                            ],
                            [
                                179.85006,
                                64.98778
                            ],
                            [
                                179.99621,
                                65.02696
                            ],
                            [
                                179.99791,
                                66.83283
                            ],
                            [
                                179.99865,
                                67.58162
                            ],
                            [
                                179.99371,
                                68.97977
                            ],
                            [
                                179.42415,
                                69.22088
                            ],
                            [
                                178.82902,
                                69.38383
                            ],
                            [
                                178.41922,
                                69.44733
                            ],
                            [
                                178.0962,
                                69.45066
                            ],
                            [
                                177.8817,
                                69.48453
                            ],
                            [
                                177.46812,
                                69.58546
                            ],
                            [
                                177.14525,
                                69.60344
                            ],
                            [
                                176.89424,
                                69.63675
                            ],
                            [
                                176.42492,
                                69.73515
                            ],
                            [
                                176.13521,
                                69.86922
                            ],
                            [
                                175.80746,
                                69.87836
                            ],
                            [
                                175.09674,
                                69.83732
                            ],
                            [
                                174.81745,
                                69.83852
                            ],
                            [
                                174.35491,
                                69.86758
                            ],
                            [
                                174.09206,
                                69.86696
                            ],
                            [
                                173.79386,
                                69.80499
                            ],
                            [
                                173.69877,
                                69.87447
                            ],
                            [
                                173.48676,
                                69.93409
                            ],
                            [
                                173.27322,
                                69.90658
                            ],
                            [
                                173.20578,
                                69.83655
                            ],
                            [
                                173.04462,
                                69.85034
                            ],
                            [
                                172.8436,
                                69.90037
                            ],
                            [
                                172.75373,
                                69.96201
                            ],
                            [
                                172.52058,
                                69.93293
                            ],
                            [
                                172.26804,
                                69.96745
                            ],
                            [
                                172.03235,
                                69.97432
                            ],
                            [
                                171.45575,
                                70.05172
                            ],
                            [
                                171.02039,
                                70.08725
                            ],
                            [
                                170.81495,
                                70.0824
                            ],
                            [
                                170.58603,
                                70.12487
                            ],
                            [
                                170.61391,
                                70.03869
                            ],
                            [
                                170.55553,
                                69.90757
                            ],
                            [
                                170.62083,
                                69.74924
                            ],
                            [
                                170.3076,
                                69.6983
                            ],
                            [
                                170.20375,
                                69.58995
                            ],
                            [
                                170.36058,
                                69.57658
                            ],
                            [
                                170.57692,
                                69.59352
                            ],
                            [
                                170.68349,
                                69.56319
                            ],
                            [
                                170.78902,
                                69.45393
                            ],
                            [
                                170.78905,
                                69.3839
                            ],
                            [
                                170.93711,
                                69.29124
                            ],
                            [
                                170.89985,
                                69.17259
                            ],
                            [
                                171.02029,
                                69.14062
                            ],
                            [
                                171.06056,
                                69.0499
                            ],
                            [
                                170.85943,
                                68.95111
                            ],
                            [
                                170.60631,
                                68.8944
                            ],
                            [
                                170.35608,
                                68.80725
                            ],
                            [
                                169.75894,
                                68.75856
                            ],
                            [
                                169.51497,
                                68.79662
                            ],
                            [
                                169.44513,
                                68.85652
                            ],
                            [
                                169.48012,
                                68.93114
                            ],
                            [
                                169.41124,
                                69.05608
                            ],
                            [
                                169.11621,
                                69.09536
                            ],
                            [
                                168.73571,
                                69.19884
                            ],
                            [
                                168.35826,
                                69.20791
                            ],
                            [
                                168.23658,
                                69.28547
                            ],
                            [
                                168.22827,
                                69.39332
                            ],
                            [
                                168.27934,
                                69.5459
                            ],
                            [
                                168.13112,
                                69.57338
                            ],
                            [
                                167.96425,
                                69.63912
                            ],
                            [
                                167.94941,
                                69.70785
                            ],
                            [
                                167.75166,
                                69.76382
                            ],
                            [
                                167.20444,
                                69.54658
                            ],
                            [
                                166.96203,
                                69.47427
                            ],
                            [
                                166.23702,
                                69.50065
                            ],
                            [
                                165.83682,
                                69.56078
                            ],
                            [
                                165.46053,
                                69.56461
                            ],
                            [
                                165.20156,
                                69.5833
                            ],
                            [
                                164.97251,
                                69.55597
                            ],
                            [
                                164.59725,
                                69.57401
                            ],
                            [
                                164.42164,
                                69.61102
                            ],
                            [
                                164.02192,
                                69.74884
                            ],
                            [
                                163.85295,
                                69.68142
                            ],
                            [
                                163.48687,
                                69.66995
                            ],
                            [
                                163.30557,
                                69.70153
                            ],
                            [
                                162.88008,
                                69.63607
                            ],
                            [
                                162.62639,
                                69.6608
                            ],
                            [
                                162.40766,
                                69.6575
                            ],
                            [
                                162.06931,
                                69.56033
                            ],
                            [
                                162.03325,
                                69.51564
                            ],
                            [
                                161.83265,
                                69.49539
                            ],
                            [
                                161.60903,
                                69.39088
                            ],
                            [
                                161.47695,
                                69.36303
                            ],
                            [
                                161.33116,
                                69.39456
                            ],
                            [
                                161.3476,
                                69.4197
                            ],
                            [
                                161.4265,
                                69.45542
                            ],
                            [
                                161.40454,
                                69.47419
                            ],
                            [
                                161.42369,
                                69.50474
                            ],
                            [
                                161.40163,
                                69.52548
                            ],
                            [
                                161.09436,
                                69.44557
                            ],
                            [
                                161.08692,
                                69.39003
                            ],
                            [
                                161.17716,
                                69.28664
                            ],
                            [
                                161.03875,
                                69.23626
                            ],
                            [
                                160.97327,
                                69.44635
                            ],
                            [
                                161.01264,
                                69.5413
                            ],
                            [
                                160.95012,
                                69.62573
                            ],
                            [
                                160.62765,
                                69.64364
                            ],
                            [
                                160.25077,
                                69.70808
                            ],
                            [
                                160.15658,
                                69.70575
                            ],
                            [
                                159.86736,
                                69.77558
                            ],
                            [
                                159.69531,
                                69.87174
                            ],
                            [
                                159.88932,
                                69.97773
                            ],
                            [
                                159.97471,
                                70.07637
                            ],
                            [
                                159.9722,
                                70.13555
                            ],
                            [
                                160.11535,
                                70.25719
                            ],
                            [
                                160.07367,
                                70.34837
                            ],
                            [
                                159.88557,
                                70.54423
                            ],
                            [
                                159.65254,
                                70.67155
                            ],
                            [
                                159.13228,
                                70.8346
                            ],
                            [
                                158.7044,
                                70.9238
                            ],
                            [
                                158.15244,
                                70.99989
                            ],
                            [
                                157.33865,
                                71.06983
                            ],
                            [
                                156.91247,
                                71.09032
                            ],
                            [
                                156.57931,
                                71.07372
                            ],
                            [
                                156.16854,
                                71.08388
                            ],
                            [
                                155.55852,
                                71.06233
                            ],
                            [
                                155.44263,
                                71.03725
                            ],
                            [
                                155.12506,
                                71.03066
                            ],
                            [
                                154.98888,
                                71.00789
                            ],
                            [
                                154.35528,
                                70.95285
                            ],
                            [
                                153.88328,
                                70.88137
                            ],
                            [
                                153.59591,
                                70.87045
                            ],
                            [
                                152.99357,
                                70.82287
                            ],
                            [
                                152.56435,
                                70.81945
                            ],
                            [
                                152.12197,
                                70.89535
                            ],
                            [
                                151.92978,
                                70.97475
                            ],
                            [
                                152.1382,
                                70.99507
                            ],
                            [
                                151.86933,
                                71.1245
                            ],
                            [
                                151.65629,
                                71.29105
                            ],
                            [
                                151.4728,
                                71.33832
                            ],
                            [
                                151.15684,
                                71.36925
                            ],
                            [
                                151.10988,
                                71.39342
                            ],
                            [
                                150.77678,
                                71.3585
                            ],
                            [
                                150.71,
                                71.38047
                            ],
                            [
                                150.70181,
                                71.49316
                            ],
                            [
                                150.59013,
                                71.51367
                            ],
                            [
                                150.29138,
                                71.51386
                            ],
                            [
                                150.18812,
                                71.58927
                            ],
                            [
                                149.93279,
                                71.66998
                            ],
                            [
                                149.46225,
                                71.6479
                            ],
                            [
                                149.02127,
                                71.71243
                            ],
                            [
                                149.39059,
                                71.88733
                            ],
                            [
                                149.50059,
                                71.85972
                            ],
                            [
                                149.70957,
                                71.75216
                            ],
                            [
                                150.06149,
                                71.82839
                            ],
                            [
                                150.10615,
                                71.85991
                            ],
                            [
                                149.9691,
                                72.00818
                            ],
                            [
                                149.5781,
                                72.15027
                            ],
                            [
                                149.20761,
                                72.22263
                            ],
                            [
                                148.78526,
                                72.26835
                            ],
                            [
                                148.46514,
                                72.31791
                            ],
                            [
                                147.9301,
                                72.31758
                            ],
                            [
                                147.45711,
                                72.32728
                            ],
                            [
                                147.08766,
                                72.29621
                            ],
                            [
                                146.81457,
                                72.3704
                            ],
                            [
                                146.09383,
                                72.48444
                            ],
                            [
                                145.51749,
                                72.55237
                            ],
                            [
                                144.74398,
                                72.6008
                            ],
                            [
                                144.09498,
                                72.66013
                            ],
                            [
                                143.77841,
                                72.66247
                            ],
                            [
                                143.55088,
                                72.69033
                            ],
                            [
                                142.6825,
                                72.69832
                            ],
                            [
                                141.97011,
                                72.722
                            ],
                            [
                                141.74128,
                                72.74385
                            ],
                            [
                                141.31338,
                                72.8543
                            ],
                            [
                                140.75971,
                                72.88193
                            ],
                            [
                                140.75409,
                                72.83191
                            ],
                            [
                                140.99707,
                                72.70461
                            ],
                            [
                                141.16561,
                                72.64976
                            ],
                            [
                                141.23529,
                                72.58561
                            ],
                            [
                                141.015,
                                72.55656
                            ],
                            [
                                140.73082,
                                72.49033
                            ],
                            [
                                140.48844,
                                72.46721
                            ],
                            [
                                140.12897,
                                72.47004
                            ],
                            [
                                139.87726,
                                72.4953
                            ],
                            [
                                139.61626,
                                72.48614
                            ],
                            [
                                139.278,
                                72.35581
                            ],
                            [
                                139.16958,
                                72.26314
                            ],
                            [
                                139.18427,
                                72.18944
                            ],
                            [
                                139.42752,
                                72.14388
                            ],
                            [
                                139.61911,
                                72.21667
                            ],
                            [
                                140.14521,
                                72.21523
                            ],
                            [
                                140.28809,
                                72.17241
                            ],
                            [
                                139.92006,
                                72.09632
                            ],
                            [
                                139.7813,
                                72.04343
                            ],
                            [
                                139.7029,
                                71.94774
                            ],
                            [
                                139.79515,
                                71.76598
                            ],
                            [
                                139.77582,
                                71.68513
                            ],
                            [
                                139.88012,
                                71.58637
                            ],
                            [
                                140.06984,
                                71.49782
                            ],
                            [
                                139.79764,
                                71.44759
                            ],
                            [
                                139.48714,
                                71.48569
                            ],
                            [
                                139.44399,
                                71.42382
                            ],
                            [
                                139.17781,
                                71.41992
                            ],
                            [
                                139.13809,
                                71.5748
                            ],
                            [
                                138.85139,
                                71.62899
                            ],
                            [
                                138.45262,
                                71.58002
                            ],
                            [
                                138.13319,
                                71.56712
                            ],
                            [
                                138.08622,
                                71.46894
                            ],
                            [
                                137.93627,
                                71.34959
                            ],
                            [
                                138.19056,
                                71.23579
                            ],
                            [
                                138.01937,
                                71.21013
                            ],
                            [
                                137.87545,
                                71.25157
                            ],
                            [
                                137.54943,
                                71.26918
                            ],
                            [
                                137.58912,
                                71.35236
                            ],
                            [
                                137.33123,
                                71.4016
                            ],
                            [
                                137.13685,
                                71.4133
                            ],
                            [
                                136.85647,
                                71.52556
                            ],
                            [
                                136.66482,
                                71.51849
                            ],
                            [
                                136.43874,
                                71.57319
                            ],
                            [
                                136.03412,
                                71.62547
                            ],
                            [
                                135.503,
                                71.60503
                            ],
                            [
                                135.28714,
                                71.54359
                            ],
                            [
                                134.94965,
                                71.49239
                            ],
                            [
                                134.71342,
                                71.39087
                            ],
                            [
                                134.35208,
                                71.35895
                            ],
                            [
                                134.07365,
                                71.37754
                            ],
                            [
                                133.54578,
                                71.46458
                            ],
                            [
                                133.20054,
                                71.58073
                            ],
                            [
                                132.96435,
                                71.73316
                            ],
                            [
                                132.78376,
                                71.76467
                            ],
                            [
                                132.78736,
                                71.91229
                            ],
                            [
                                132.573,
                                71.87852
                            ],
                            [
                                132.34367,
                                71.71968
                            ],
                            [
                                132.17896,
                                71.56127
                            ],
                            [
                                132.01366,
                                71.28592
                            ],
                            [
                                131.77088,
                                71.11276
                            ],
                            [
                                131.75756,
                                70.98075
                            ],
                            [
                                131.61411,
                                70.8767
                            ],
                            [
                                131.41047,
                                70.78459
                            ],
                            [
                                131.19787,
                                70.71596
                            ],
                            [
                                131.06245,
                                70.70418
                            ],
                            [
                                130.95979,
                                70.7479
                            ],
                            [
                                130.94155,
                                70.83295
                            ],
                            [
                                130.58612,
                                70.85279
                            ],
                            [
                                130.56778,
                                70.89876
                            ],
                            [
                                130.36783,
                                70.89909
                            ],
                            [
                                130.17513,
                                71.0683
                            ],
                            [
                                129.81941,
                                71.12972
                            ],
                            [
                                129.75474,
                                71.21523
                            ],
                            [
                                129.47804,
                                71.29608
                            ],
                            [
                                129.33642,
                                71.52316
                            ],
                            [
                                129.23849,
                                71.59465
                            ],
                            [
                                128.93168,
                                71.57417
                            ],
                            [
                                128.93296,
                                71.6812
                            ],
                            [
                                129.51646,
                                71.73404
                            ],
                            [
                                129.36559,
                                71.79717
                            ],
                            [
                                128.98767,
                                71.72354
                            ],
                            [
                                128.79151,
                                71.7459
                            ],
                            [
                                128.68887,
                                71.86207
                            ],
                            [
                                128.50521,
                                71.9588
                            ],
                            [
                                128.69123,
                                72.0566
                            ],
                            [
                                128.99718,
                                72.04075
                            ],
                            [
                                129.44312,
                                72.08777
                            ],
                            [
                                129.38862,
                                72.15602
                            ],
                            [
                                129.5252,
                                72.22631
                            ],
                            [
                                129.5483,
                                72.30675
                            ],
                            [
                                129.43192,
                                72.43975
                            ],
                            [
                                128.97389,
                                72.47449
                            ],
                            [
                                128.83583,
                                72.55962
                            ],
                            [
                                129.12188,
                                72.60003
                            ],
                            [
                                129.4313,
                                72.60192
                            ],
                            [
                                129.53113,
                                72.6489
                            ],
                            [
                                129.45875,
                                72.68926
                            ],
                            [
                                129.25266,
                                72.71191
                            ],
                            [
                                129.37687,
                                72.78394
                            ],
                            [
                                129.40584,
                                72.86952
                            ],
                            [
                                129.21433,
                                72.92581
                            ],
                            [
                                129.52793,
                                72.93624
                            ],
                            [
                                129.27184,
                                73.08835
                            ],
                            [
                                128.94715,
                                73.11087
                            ],
                            [
                                128.8318,
                                73.15231
                            ],
                            [
                                128.88122,
                                73.21286
                            ],
                            [
                                128.77439,
                                73.24611
                            ],
                            [
                                128.46244,
                                73.23753
                            ],
                            [
                                128.5096,
                                73.30018
                            ],
                            [
                                128.38089,
                                73.36438
                            ],
                            [
                                128.05288,
                                73.33554
                            ],
                            [
                                127.89036,
                                73.46641
                            ],
                            [
                                127.45,
                                73.47611
                            ],
                            [
                                127.36309,
                                73.51415
                            ],
                            [
                                127.0241,
                                73.52303
                            ],
                            [
                                126.97346,
                                73.41942
                            ],
                            [
                                126.42596,
                                73.35611
                            ],
                            [
                                126.45464,
                                73.51145
                            ],
                            [
                                126.18898,
                                73.5024
                            ],
                            [
                                125.73775,
                                73.43382
                            ],
                            [
                                125.62354,
                                73.54209
                            ],
                            [
                                125.36303,
                                73.52941
                            ],
                            [
                                125.20745,
                                73.61644
                            ],
                            [
                                124.8232,
                                73.70208
                            ],
                            [
                                124.42156,
                                73.76551
                            ],
                            [
                                124.06714,
                                73.66471
                            ],
                            [
                                124.04732,
                                73.62399
                            ],
                            [
                                123.78628,
                                73.58615
                            ],
                            [
                                123.67306,
                                73.63506
                            ],
                            [
                                123.48017,
                                73.62475
                            ],
                            [
                                123.34578,
                                73.54748
                            ],
                            [
                                123.47744,
                                73.40938
                            ],
                            [
                                123.38663,
                                73.34522
                            ],
                            [
                                123.5779,
                                73.26903
                            ],
                            [
                                123.5252,
                                73.1712
                            ],
                            [
                                123.64494,
                                73.1198
                            ],
                            [
                                123.41116,
                                73.05442
                            ],
                            [
                                123.44082,
                                72.991
                            ],
                            [
                                123.31485,
                                72.91887
                            ],
                            [
                                122.75365,
                                72.96657
                            ],
                            [
                                122.59506,
                                72.91934
                            ],
                            [
                                122.29395,
                                72.97938
                            ],
                            [
                                121.89619,
                                72.95652
                            ],
                            [
                                121.43879,
                                72.96649
                            ],
                            [
                                121.17935,
                                72.93375
                            ],
                            [
                                120.83115,
                                72.9524
                            ],
                            [
                                120.65318,
                                72.9811
                            ],
                            [
                                120.15526,
                                72.99504
                            ],
                            [
                                119.88433,
                                73.022
                            ],
                            [
                                119.69102,
                                73.00252
                            ],
                            [
                                119.47434,
                                73.05709
                            ],
                            [
                                119.12535,
                                73.09048
                            ],
                            [
                                118.95699,
                                73.12667
                            ],
                            [
                                118.52877,
                                73.17997
                            ],
                            [
                                118.37671,
                                73.29285
                            ],
                            [
                                118.48226,
                                73.35003
                            ],
                            [
                                118.4144,
                                73.41047
                            ],
                            [
                                118.60914,
                                73.46378
                            ],
                            [
                                118.77963,
                                73.42945
                            ],
                            [
                                118.96297,
                                73.46228
                            ],
                            [
                                118.8089,
                                73.53557
                            ],
                            [
                                118.61608,
                                73.56676
                            ],
                            [
                                118.02372,
                                73.58254
                            ],
                            [
                                117.84008,
                                73.56641
                            ],
                            [
                                117.28091,
                                73.58467
                            ],
                            [
                                116.51784,
                                73.67057
                            ],
                            [
                                116.35818,
                                73.65594
                            ],
                            [
                                115.99419,
                                73.69195
                            ],
                            [
                                115.56151,
                                73.71043
                            ],
                            [
                                115.32276,
                                73.70229
                            ],
                            [
                                114.89264,
                                73.60211
                            ],
                            [
                                114.524,
                                73.58281
                            ],
                            [
                                114.2478,
                                73.60073
                            ],
                            [
                                113.54278,
                                73.49629
                            ],
                            [
                                113.6005,
                                73.42527
                            ],
                            [
                                113.89824,
                                73.34074
                            ],
                            [
                                113.55166,
                                73.32575
                            ],
                            [
                                113.33198,
                                73.37409
                            ],
                            [
                                113.20983,
                                73.43436
                            ],
                            [
                                113.27717,
                                73.52667
                            ],
                            [
                                113.45627,
                                73.62479
                            ],
                            [
                                113.16569,
                                73.86209
                            ],
                            [
                                112.80492,
                                73.9643
                            ],
                            [
                                112.99048,
                                73.78924
                            ],
                            [
                                112.79339,
                                73.71498
                            ],
                            [
                                112.33525,
                                73.69966
                            ],
                            [
                                111.87435,
                                73.72602
                            ],
                            [
                                111.52957,
                                73.78139
                            ],
                            [
                                111.29917,
                                73.85541
                            ],
                            [
                                111.19889,
                                73.94647
                            ],
                            [
                                111.57541,
                                74.00564
                            ],
                            [
                                111.52353,
                                74.04449
                            ],
                            [
                                111.13314,
                                74.0158
                            ],
                            [
                                110.9181,
                                73.90142
                            ],
                            [
                                110.49952,
                                73.99786
                            ],
                            [
                                110.27861,
                                74.02007
                            ],
                            [
                                109.99083,
                                74.00238
                            ],
                            [
                                109.80327,
                                73.86554
                            ],
                            [
                                109.53336,
                                73.8182
                            ],
                            [
                                109.62435,
                                73.69227
                            ],
                            [
                                110.09928,
                                73.70312
                            ],
                            [
                                110.24173,
                                73.6836
                            ],
                            [
                                110.67381,
                                73.79228
                            ],
                            [
                                110.88916,
                                73.76335
                            ],
                            [
                                110.79694,
                                73.66018
                            ],
                            [
                                110.44945,
                                73.63851
                            ],
                            [
                                110.10052,
                                73.49563
                            ],
                            [
                                109.74709,
                                73.43065
                            ],
                            [
                                109.48193,
                                73.44731
                            ],
                            [
                                109.41601,
                                73.39357
                            ],
                            [
                                108.65585,
                                73.31293
                            ],
                            [
                                108.25713,
                                73.2859
                            ],
                            [
                                108.43802,
                                73.244
                            ],
                            [
                                108.38086,
                                73.08975
                            ],
                            [
                                108.23253,
                                73.12196
                            ],
                            [
                                108.16267,
                                73.19933
                            ],
                            [
                                108.01923,
                                73.21661
                            ],
                            [
                                107.7658,
                                73.147
                            ],
                            [
                                107.13935,
                                73.15366
                            ],
                            [
                                106.87366,
                                73.12385
                            ],
                            [
                                106.61659,
                                73.13793
                            ],
                            [
                                106.36452,
                                73.17713
                            ],
                            [
                                106.20075,
                                73.09312
                            ],
                            [
                                106.21914,
                                72.96615
                            ],
                            [
                                105.99342,
                                72.91304
                            ],
                            [
                                105.73234,
                                72.7968
                            ],
                            [
                                105.4767,
                                72.73555
                            ],
                            [
                                105.25761,
                                72.78093
                            ],
                            [
                                105.7221,
                                72.88166
                            ],
                            [
                                105.76724,
                                72.94335
                            ],
                            [
                                105.91386,
                                73.00437
                            ],
                            [
                                105.90059,
                                73.07188
                            ],
                            [
                                106.1042,
                                73.24583
                            ],
                            [
                                106.30015,
                                73.31015
                            ],
                            [
                                106.64506,
                                73.29425
                            ],
                            [
                                106.85973,
                                73.34895
                            ],
                            [
                                106.87894,
                                73.43555
                            ],
                            [
                                107.03709,
                                73.47575
                            ],
                            [
                                107.06541,
                                73.5533
                            ],
                            [
                                106.49815,
                                73.64644
                            ],
                            [
                                107.50579,
                                73.61322
                            ],
                            [
                                107.84208,
                                73.61855
                            ],
                            [
                                108.21132,
                                73.66624
                            ],
                            [
                                108.52881,
                                73.78611
                            ],
                            [
                                108.73072,
                                73.8955
                            ],
                            [
                                109.0831,
                                74.04646
                            ],
                            [
                                109.51905,
                                74.08003
                            ],
                            [
                                109.91163,
                                74.22148
                            ],
                            [
                                109.89648,
                                74.31985
                            ],
                            [
                                110.16009,
                                74.3794
                            ],
                            [
                                110.54425,
                                74.49203
                            ],
                            [
                                110.98839,
                                74.53957
                            ],
                            [
                                111.35841,
                                74.67234
                            ],
                            [
                                111.56798,
                                74.6903
                            ],
                            [
                                111.80307,
                                74.65721
                            ],
                            [
                                112.1952,
                                74.87816
                            ],
                            [
                                112.76972,
                                74.94249
                            ],
                            [
                                112.91901,
                                75.01593
                            ],
                            [
                                113.50824,
                                75.20988
                            ],
                            [
                                113.67171,
                                75.31064
                            ],
                            [
                                113.74761,
                                75.43278
                            ],
                            [
                                113.70232,
                                75.505
                            ],
                            [
                                113.37912,
                                75.52001
                            ],
                            [
                                113.22524,
                                75.66478
                            ],
                            [
                                113.0066,
                                75.61888
                            ],
                            [
                                112.86752,
                                75.6334
                            ],
                            [
                                112.83818,
                                75.73958
                            ],
                            [
                                113.06403,
                                75.73241
                            ],
                            [
                                113.1416,
                                75.68579
                            ],
                            [
                                113.60859,
                                75.64964
                            ],
                            [
                                113.3945,
                                75.54086
                            ],
                            [
                                113.55334,
                                75.53825
                            ],
                            [
                                113.71348,
                                75.61749
                            ],
                            [
                                113.91522,
                                75.82436
                            ],
                            [
                                113.88597,
                                75.92203
                            ],
                            [
                                113.58531,
                                75.92887
                            ],
                            [
                                113.44734,
                                76.18315
                            ],
                            [
                                113.29628,
                                76.25286
                            ],
                            [
                                113.01188,
                                76.24259
                            ],
                            [
                                113.18702,
                                76.15087
                            ],
                            [
                                112.84374,
                                76.0785
                            ],
                            [
                                112.79652,
                                76.17659
                            ],
                            [
                                112.6338,
                                76.17601
                            ],
                            [
                                112.8286,
                                76.3224
                            ],
                            [
                                112.26325,
                                76.45596
                            ],
                            [
                                112.04042,
                                76.55833
                            ],
                            [
                                111.59735,
                                76.6375
                            ],
                            [
                                111.7243,
                                76.68776
                            ],
                            [
                                111.26265,
                                76.71489
                            ],
                            [
                                111.17728,
                                76.77391
                            ],
                            [
                                110.94542,
                                76.7356
                            ],
                            [
                                110.65644,
                                76.77178
                            ],
                            [
                                110.13253,
                                76.71215
                            ],
                            [
                                109.84451,
                                76.71699
                            ],
                            [
                                109.69519,
                                76.75502
                            ],
                            [
                                109.10459,
                                76.74969
                            ],
                            [
                                108.68672,
                                76.70614
                            ],
                            [
                                108.0359,
                                76.73319
                            ],
                            [
                                107.97712,
                                76.55039
                            ],
                            [
                                107.7129,
                                76.49313
                            ],
                            [
                                107.3643,
                                76.5201
                            ],
                            [
                                106.641,
                                76.47701
                            ],
                            [
                                106.49908,
                                76.5018
                            ],
                            [
                                106.56153,
                                76.57723
                            ],
                            [
                                106.76053,
                                76.56872
                            ],
                            [
                                106.94239,
                                76.71318
                            ],
                            [
                                107.10519,
                                76.794
                            ],
                            [
                                107.38071,
                                76.86779
                            ],
                            [
                                107.27678,
                                77.00667
                            ],
                            [
                                107.08135,
                                76.98716
                            ],
                            [
                                106.85867,
                                77.04808
                            ],
                            [
                                106.60799,
                                77.02422
                            ],
                            [
                                106.22144,
                                77.05483
                            ],
                            [
                                105.91882,
                                76.98804
                            ],
                            [
                                105.69191,
                                77.01157
                            ],
                            [
                                105.8749,
                                77.09896
                            ],
                            [
                                105.08063,
                                77.05305
                            ],
                            [
                                104.53708,
                                77.08137
                            ],
                            [
                                104.77219,
                                77.16051
                            ],
                            [
                                104.92987,
                                77.14996
                            ],
                            [
                                105.41876,
                                77.20112
                            ],
                            [
                                105.54581,
                                77.28
                            ],
                            [
                                105.8326,
                                77.3588
                            ],
                            [
                                106.14137,
                                77.35086
                            ],
                            [
                                105.84662,
                                77.56007
                            ],
                            [
                                105.35809,
                                77.55133
                            ],
                            [
                                104.85345,
                                77.61425
                            ],
                            [
                                104.80909,
                                77.68533
                            ],
                            [
                                104.38416,
                                77.66861
                            ],
                            [
                                104.10748,
                                77.72834
                            ],
                            [
                                103.67614,
                                77.62713
                            ],
                            [
                                103.25961,
                                77.63576
                            ],
                            [
                                103.04195,
                                77.55122
                            ],
                            [
                                102.70771,
                                77.49399
                            ],
                            [
                                102.47484,
                                77.38987
                            ],
                            [
                                102.16692,
                                77.36177
                            ],
                            [
                                101.41742,
                                77.10569
                            ],
                            [
                                101.26666,
                                76.94605
                            ],
                            [
                                101.0961,
                                76.94458
                            ],
                            [
                                100.9526,
                                76.84145
                            ],
                            [
                                101.08541,
                                76.75419
                            ],
                            [
                                101.28962,
                                76.73209
                            ],
                            [
                                101.13345,
                                76.54784
                            ],
                            [
                                100.83427,
                                76.48821
                            ],
                            [
                                100.32151,
                                76.4425
                            ],
                            [
                                100.06406,
                                76.45792
                            ],
                            [
                                99.72771,
                                76.43688
                            ],
                            [
                                99.41597,
                                76.44345
                            ],
                            [
                                99.02617,
                                76.49337
                            ],
                            [
                                98.89004,
                                76.45595
                            ],
                            [
                                99.09409,
                                76.33981
                            ],
                            [
                                99.29346,
                                76.33011
                            ],
                            [
                                99.55952,
                                76.24382
                            ],
                            [
                                99.77475,
                                76.13091
                            ],
                            [
                                99.27053,
                                76.11815
                            ],
                            [
                                99.33915,
                                76.1766
                            ],
                            [
                                98.68516,
                                76.22758
                            ],
                            [
                                98.4317,
                                76.16483
                            ],
                            [
                                98.04794,
                                76.13039
                            ],
                            [
                                98.19796,
                                76.08347
                            ],
                            [
                                97.26971,
                                75.95175
                            ],
                            [
                                97.15129,
                                75.98698
                            ],
                            [
                                96.77681,
                                75.88473
                            ],
                            [
                                96.67936,
                                75.94472
                            ],
                            [
                                96.44371,
                                76.00388
                            ],
                            [
                                96.35739,
                                75.94156
                            ],
                            [
                                96.04413,
                                75.99159
                            ],
                            [
                                96.18463,
                                76.0899
                            ],
                            [
                                95.86131,
                                76.137
                            ],
                            [
                                95.44707,
                                76.16006
                            ],
                            [
                                95.31035,
                                76.10632
                            ],
                            [
                                95.08072,
                                76.09529
                            ],
                            [
                                94.8727,
                                76.1528
                            ],
                            [
                                94.60911,
                                76.1542
                            ],
                            [
                                94.56697,
                                76.08066
                            ],
                            [
                                94.31318,
                                76.12423
                            ],
                            [
                                93.88769,
                                76.10999
                            ],
                            [
                                93.98793,
                                76.04337
                            ],
                            [
                                93.11064,
                                76.02219
                            ],
                            [
                                92.88698,
                                75.95614
                            ],
                            [
                                92.98175,
                                75.92714
                            ],
                            [
                                93.24819,
                                75.9619
                            ],
                            [
                                93.43981,
                                75.88076
                            ],
                            [
                                93.39363,
                                75.82388
                            ],
                            [
                                92.49136,
                                75.77683
                            ],
                            [
                                92.44449,
                                75.74306
                            ],
                            [
                                91.85553,
                                75.71437
                            ],
                            [
                                91.67828,
                                75.62398
                            ],
                            [
                                91.51128,
                                75.65543
                            ],
                            [
                                91.28649,
                                75.6241
                            ],
                            [
                                91.14552,
                                75.65291
                            ],
                            [
                                90.85326,
                                75.64465
                            ],
                            [
                                90.46728,
                                75.58224
                            ],
                            [
                                90.29259,
                                75.59687
                            ],
                            [
                                89.96754,
                                75.54807
                            ],
                            [
                                90.02238,
                                75.49374
                            ],
                            [
                                89.72159,
                                75.48476
                            ],
                            [
                                89.62119,
                                75.43571
                            ],
                            [
                                89.22933,
                                75.48444
                            ],
                            [
                                89.07697,
                                75.41034
                            ],
                            [
                                88.61329,
                                75.31639
                            ],
                            [
                                88.30742,
                                75.19855
                            ],
                            [
                                88.34258,
                                75.15197
                            ],
                            [
                                87.95128,
                                75.10826
                            ],
                            [
                                87.30423,
                                75.14592
                            ],
                            [
                                86.99063,
                                75.13574
                            ],
                            [
                                86.87626,
                                75.08757
                            ],
                            [
                                87.60399,
                                75.03001
                            ],
                            [
                                87.75037,
                                74.99696
                            ],
                            [
                                87.54933,
                                74.93818
                            ],
                            [
                                87.42286,
                                75.00187
                            ],
                            [
                                87.20078,
                                74.97856
                            ],
                            [
                                87.26733,
                                74.90376
                            ],
                            [
                                87.08698,
                                74.8609
                            ],
                            [
                                87.03213,
                                74.77189
                            ],
                            [
                                86.75661,
                                74.69849
                            ],
                            [
                                86.51078,
                                74.73616
                            ],
                            [
                                86.34387,
                                74.70695
                            ],
                            [
                                86.24447,
                                74.80642
                            ],
                            [
                                85.76234,
                                74.64826
                            ],
                            [
                                86.02877,
                                74.62071
                            ],
                            [
                                86.40472,
                                74.60953
                            ],
                            [
                                86.65622,
                                74.50456
                            ],
                            [
                                86.31122,
                                74.45401
                            ],
                            [
                                86.26106,
                                74.40391
                            ],
                            [
                                85.95686,
                                74.38853
                            ],
                            [
                                85.96752,
                                74.29226
                            ],
                            [
                                86.60288,
                                74.24335
                            ],
                            [
                                86.77954,
                                74.1858
                            ],
                            [
                                86.7176,
                                74.13002
                            ],
                            [
                                86.85144,
                                74.09863
                            ],
                            [
                                86.98234,
                                73.9735
                            ],
                            [
                                87.07819,
                                73.96357
                            ],
                            [
                                87.17446,
                                73.87232
                            ],
                            [
                                86.5137,
                                73.87579
                            ],
                            [
                                86.11226,
                                73.85441
                            ],
                            [
                                85.92715,
                                73.81457
                            ],
                            [
                                85.68149,
                                73.81051
                            ],
                            [
                                85.51945,
                                73.76988
                            ],
                            [
                                85.49256,
                                73.71052
                            ],
                            [
                                85.19822,
                                73.69403
                            ],
                            [
                                84.94237,
                                73.73877
                            ],
                            [
                                84.71771,
                                73.74657
                            ],
                            [
                                84.40238,
                                73.70372
                            ],
                            [
                                84.16903,
                                73.69324
                            ],
                            [
                                83.47863,
                                73.6338
                            ],
                            [
                                83.07471,
                                73.62923
                            ],
                            [
                                82.35801,
                                73.63955
                            ],
                            [
                                81.66491,
                                73.61633
                            ],
                            [
                                81.2911,
                                73.56429
                            ],
                            [
                                80.55116,
                                73.54683
                            ],
                            [
                                80.50899,
                                73.50183
                            ],
                            [
                                80.65134,
                                73.43894
                            ],
                            [
                                80.64862,
                                73.38923
                            ],
                            [
                                80.44822,
                                73.35287
                            ],
                            [
                                80.36098,
                                73.28503
                            ],
                            [
                                80.62739,
                                73.25388
                            ],
                            [
                                80.69585,
                                73.18458
                            ],
                            [
                                80.56118,
                                73.06558
                            ],
                            [
                                80.70144,
                                73.05101
                            ],
                            [
                                80.88657,
                                72.91813
                            ],
                            [
                                80.84554,
                                72.79423
                            ],
                            [
                                80.69652,
                                72.724
                            ],
                            [
                                80.70631,
                                72.61858
                            ],
                            [
                                80.84589,
                                72.61678
                            ],
                            [
                                80.7813,
                                72.49362
                            ],
                            [
                                80.92115,
                                72.41456
                            ],
                            [
                                81.30076,
                                72.34297
                            ],
                            [
                                81.64717,
                                72.33862
                            ],
                            [
                                82.27052,
                                72.24543
                            ],
                            [
                                82.4456,
                                72.12747
                            ],
                            [
                                82.29983,
                                72.07332
                            ],
                            [
                                82.51415,
                                72.02719
                            ],
                            [
                                82.67463,
                                71.87691
                            ],
                            [
                                83.04642,
                                71.87251
                            ],
                            [
                                83.30803,
                                71.83513
                            ],
                            [
                                83.43547,
                                71.78005
                            ],
                            [
                                83.39788,
                                71.72812
                            ],
                            [
                                83.65168,
                                71.62661
                            ],
                            [
                                83.55289,
                                71.49427
                            ],
                            [
                                83.43397,
                                71.47061
                            ],
                            [
                                83.32483,
                                71.29442
                            ],
                            [
                                83.1545,
                                71.23394
                            ],
                            [
                                83.25269,
                                71.15424
                            ],
                            [
                                83.17215,
                                71.09015
                            ],
                            [
                                83.42091,
                                70.99327
                            ],
                            [
                                83.52995,
                                70.86775
                            ],
                            [
                                83.60129,
                                70.69869
                            ],
                            [
                                83.7688,
                                70.52689
                            ],
                            [
                                83.78131,
                                70.45809
                            ],
                            [
                                83.59809,
                                70.35043
                            ],
                            [
                                83.37863,
                                70.30981
                            ],
                            [
                                82.99332,
                                70.27807
                            ],
                            [
                                83.14696,
                                70.17817
                            ],
                            [
                                83.14425,
                                70.08025
                            ],
                            [
                                83.43947,
                                70.04422
                            ],
                            [
                                83.70326,
                                69.86319
                            ],
                            [
                                83.91609,
                                69.79244
                            ],
                            [
                                84.06956,
                                69.71165
                            ],
                            [
                                84.3138,
                                69.69353
                            ],
                            [
                                84.5514,
                                69.6089
                            ],
                            [
                                84.41236,
                                69.56291
                            ],
                            [
                                84.26955,
                                69.5588
                            ],
                            [
                                84.13196,
                                69.59597
                            ],
                            [
                                83.97124,
                                69.72369
                            ],
                            [
                                83.54075,
                                69.72121
                            ],
                            [
                                83.42326,
                                69.8062
                            ],
                            [
                                83.16239,
                                69.9296
                            ],
                            [
                                82.96617,
                                69.96992
                            ],
                            [
                                82.99356,
                                70.02306
                            ],
                            [
                                82.7359,
                                70.12761
                            ],
                            [
                                82.3597,
                                70.16644
                            ],
                            [
                                82.27162,
                                70.29769
                            ],
                            [
                                82.15497,
                                70.38557
                            ],
                            [
                                82.16232,
                                70.49965
                            ],
                            [
                                82.08852,
                                70.56075
                            ],
                            [
                                82.22161,
                                70.60434
                            ],
                            [
                                82.26213,
                                70.68058
                            ],
                            [
                                82.41394,
                                70.75293
                            ],
                            [
                                82.22055,
                                70.95326
                            ],
                            [
                                82.21519,
                                71.02163
                            ],
                            [
                                82.32551,
                                71.06947
                            ],
                            [
                                82.24256,
                                71.25027
                            ],
                            [
                                82.72291,
                                71.36247
                            ],
                            [
                                83.00287,
                                71.40675
                            ],
                            [
                                82.97599,
                                71.52677
                            ],
                            [
                                83.14008,
                                71.55556
                            ],
                            [
                                83.30515,
                                71.64918
                            ],
                            [
                                83.21752,
                                71.71289
                            ],
                            [
                                82.70864,
                                71.75779
                            ],
                            [
                                82.24216,
                                71.69616
                            ],
                            [
                                81.84745,
                                71.67702
                            ],
                            [
                                81.66209,
                                71.68451
                            ],
                            [
                                81.32871,
                                71.74676
                            ],
                            [
                                81.24425,
                                71.83793
                            ],
                            [
                                80.74742,
                                72.00006
                            ],
                            [
                                80.60577,
                                72.0996
                            ],
                            [
                                79.90064,
                                72.20714
                            ],
                            [
                                79.47041,
                                72.34508
                            ],
                            [
                                79.20036,
                                72.36236
                            ],
                            [
                                78.51064,
                                72.37994
                            ],
                            [
                                78.4125,
                                72.31513
                            ],
                            [
                                78.09845,
                                72.34553
                            ],
                            [
                                77.88376,
                                72.30933
                            ],
                            [
                                77.73362,
                                72.2083
                            ],
                            [
                                77.50609,
                                72.17363
                            ],
                            [
                                77.39403,
                                72.10507
                            ],
                            [
                                77.52396,
                                72.05576
                            ],
                            [
                                77.73551,
                                72.09839
                            ],
                            [
                                78.04016,
                                72.08896
                            ],
                            [
                                78.21706,
                                71.99999
                            ],
                            [
                                78.24704,
                                71.95103
                            ],
                            [
                                78.10917,
                                71.86155
                            ],
                            [
                                77.82837,
                                71.81198
                            ],
                            [
                                77.50486,
                                71.83538
                            ],
                            [
                                77.35915,
                                71.90488
                            ],
                            [
                                77.05644,
                                71.98281
                            ],
                            [
                                76.88659,
                                72.05541
                            ],
                            [
                                76.47354,
                                72.02235
                            ],
                            [
                                76.16243,
                                71.91225
                            ],
                            [
                                76.00417,
                                71.8857
                            ],
                            [
                                76.1588,
                                71.74799
                            ],
                            [
                                76.30399,
                                71.65729
                            ],
                            [
                                76.32791,
                                71.56229
                            ],
                            [
                                76.50757,
                                71.52943
                            ],
                            [
                                76.69687,
                                71.45958
                            ],
                            [
                                77.14759,
                                71.39939
                            ],
                            [
                                77.29595,
                                71.3192
                            ],
                            [
                                77.70698,
                                71.25761
                            ],
                            [
                                77.75847,
                                71.30438
                            ],
                            [
                                78.27445,
                                71.23889
                            ],
                            [
                                78.22027,
                                71.10351
                            ],
                            [
                                78.24553,
                                71.06272
                            ],
                            [
                                78.4321,
                                70.99946
                            ],
                            [
                                78.32447,
                                70.90948
                            ],
                            [
                                77.91203,
                                70.96416
                            ],
                            [
                                77.89798,
                                71.03365
                            ],
                            [
                                77.77482,
                                71.11058
                            ],
                            [
                                77.41716,
                                71.14662
                            ],
                            [
                                77.2377,
                                71.13633
                            ],
                            [
                                76.63216,
                                71.17009
                            ],
                            [
                                76.31485,
                                71.16914
                            ],
                            [
                                75.89429,
                                71.19742
                            ],
                            [
                                75.58164,
                                71.26934
                            ],
                            [
                                75.39461,
                                71.28852
                            ],
                            [
                                75.20341,
                                71.41471
                            ],
                            [
                                75.49113,
                                71.51488
                            ],
                            [
                                75.40943,
                                71.57391
                            ],
                            [
                                75.46522,
                                71.62803
                            ],
                            [
                                75.26577,
                                71.71945
                            ],
                            [
                                75.21726,
                                71.77426
                            ],
                            [
                                75.24793,
                                71.92497
                            ],
                            [
                                75.37627,
                                71.93812
                            ],
                            [
                                75.37261,
                                72.01198
                            ],
                            [
                                75.50896,
                                72.19833
                            ],
                            [
                                75.68033,
                                72.26156
                            ],
                            [
                                75.54348,
                                72.37512
                            ],
                            [
                                75.47718,
                                72.48608
                            ],
                            [
                                75.63199,
                                72.53442
                            ],
                            [
                                75.29366,
                                72.70862
                            ],
                            [
                                75.42644,
                                72.75367
                            ],
                            [
                                75.00207,
                                72.86501
                            ],
                            [
                                74.76644,
                                72.79481
                            ],
                            [
                                74.87902,
                                72.73023
                            ],
                            [
                                74.98855,
                                72.6044
                            ],
                            [
                                75.06473,
                                72.43746
                            ],
                            [
                                75.07339,
                                72.28694
                            ],
                            [
                                74.99339,
                                72.17088
                            ],
                            [
                                74.84492,
                                72.09424
                            ],
                            [
                                74.53049,
                                71.98805
                            ],
                            [
                                73.81532,
                                71.86251
                            ],
                            [
                                73.55524,
                                71.80477
                            ],
                            [
                                73.54938,
                                71.70745
                            ],
                            [
                                73.42212,
                                71.58724
                            ],
                            [
                                73.11773,
                                71.47947
                            ],
                            [
                                72.98917,
                                71.39984
                            ],
                            [
                                73.31261,
                                71.31841
                            ],
                            [
                                73.62162,
                                71.16385
                            ],
                            [
                                73.68992,
                                71.06037
                            ],
                            [
                                73.92638,
                                70.94429
                            ],
                            [
                                73.8896,
                                70.87709
                            ],
                            [
                                73.96604,
                                70.80889
                            ],
                            [
                                74.22756,
                                70.68321
                            ],
                            [
                                74.29715,
                                70.62848
                            ],
                            [
                                74.26616,
                                70.45378
                            ],
                            [
                                74.06831,
                                70.30628
                            ],
                            [
                                73.91149,
                                70.23884
                            ],
                            [
                                73.69453,
                                70.10708
                            ],
                            [
                                73.79782,
                                70.06026
                            ],
                            [
                                73.6592,
                                69.81727
                            ],
                            [
                                73.54334,
                                69.76406
                            ],
                            [
                                73.63123,
                                69.62091
                            ],
                            [
                                73.83082,
                                69.52213
                            ],
                            [
                                73.91062,
                                69.42473
                            ],
                            [
                                73.88438,
                                69.32166
                            ],
                            [
                                73.77857,
                                69.20682
                            ],
                            [
                                73.89349,
                                69.09603
                            ],
                            [
                                74.05056,
                                69.0916
                            ],
                            [
                                74.21773,
                                69.13754
                            ],
                            [
                                74.50226,
                                69.15117
                            ],
                            [
                                74.79605,
                                69.1011
                            ],
                            [
                                75.16248,
                                69.11952
                            ],
                            [
                                75.19297,
                                69.16705
                            ],
                            [
                                75.51124,
                                69.26471
                            ],
                            [
                                76.11197,
                                69.23606
                            ],
                            [
                                76.44483,
                                69.14769
                            ],
                            [
                                76.71462,
                                69.13098
                            ],
                            [
                                76.94429,
                                69.02045
                            ],
                            [
                                77.21589,
                                68.97941
                            ],
                            [
                                77.3401,
                                68.9374
                            ],
                            [
                                77.64788,
                                68.88457
                            ],
                            [
                                77.66605,
                                68.80185
                            ],
                            [
                                77.74959,
                                68.71675
                            ],
                            [
                                77.71855,
                                68.60095
                            ],
                            [
                                77.78797,
                                68.51665
                            ],
                            [
                                77.93357,
                                68.49089
                            ],
                            [
                                77.89851,
                                68.43747
                            ],
                            [
                                78.03456,
                                68.35937
                            ],
                            [
                                78.12871,
                                68.24925
                            ],
                            [
                                77.99242,
                                68.22333
                            ],
                            [
                                77.76042,
                                68.229
                            ],
                            [
                                77.58997,
                                68.1848
                            ],
                            [
                                77.46778,
                                68.10154
                            ],
                            [
                                77.50107,
                                67.90918
                            ],
                            [
                                77.44616,
                                67.85824
                            ],
                            [
                                77.44628,
                                67.75974
                            ],
                            [
                                77.51356,
                                67.72752
                            ],
                            [
                                77.9418,
                                67.70427
                            ],
                            [
                                78.09117,
                                67.63254
                            ],
                            [
                                78.32609,
                                67.6535
                            ],
                            [
                                78.39268,
                                67.63047
                            ],
                            [
                                78.57644,
                                67.6579
                            ],
                            [
                                78.94928,
                                67.58688
                            ],
                            [
                                78.8128,
                                67.56189
                            ],
                            [
                                78.72238,
                                67.49448
                            ],
                            [
                                78.58063,
                                67.5269
                            ],
                            [
                                78.33173,
                                67.52189
                            ],
                            [
                                78.24043,
                                67.55758
                            ],
                            [
                                77.89198,
                                67.48984
                            ],
                            [
                                77.792,
                                67.4111
                            ],
                            [
                                77.65222,
                                67.4358
                            ],
                            [
                                77.68021,
                                67.57802
                            ],
                            [
                                77.52656,
                                67.64567
                            ],
                            [
                                77.14704,
                                67.73047
                            ],
                            [
                                77.04405,
                                67.7856
                            ],
                            [
                                77.19871,
                                67.81064
                            ],
                            [
                                77.27238,
                                67.885
                            ],
                            [
                                77.18744,
                                67.94416
                            ],
                            [
                                77.1906,
                                68.12241
                            ],
                            [
                                77.31408,
                                68.23216
                            ],
                            [
                                77.12727,
                                68.29827
                            ],
                            [
                                77.25105,
                                68.37836
                            ],
                            [
                                77.20223,
                                68.45554
                            ],
                            [
                                77.28962,
                                68.50482
                            ],
                            [
                                76.61066,
                                68.75521
                            ],
                            [
                                76.63985,
                                68.88528
                            ],
                            [
                                76.55482,
                                68.98733
                            ],
                            [
                                76.18819,
                                68.99408
                            ],
                            [
                                75.63649,
                                68.9086
                            ],
                            [
                                75.45012,
                                68.90495
                            ],
                            [
                                74.60716,
                                68.76417
                            ],
                            [
                                74.43935,
                                68.66271
                            ],
                            [
                                74.46564,
                                68.53167
                            ],
                            [
                                74.43642,
                                68.4663
                            ],
                            [
                                74.31642,
                                68.36264
                            ],
                            [
                                74.59129,
                                68.2507
                            ],
                            [
                                74.74555,
                                68.10621
                            ],
                            [
                                74.80395,
                                68.01155
                            ],
                            [
                                74.77822,
                                67.74283
                            ],
                            [
                                74.70668,
                                67.65315
                            ],
                            [
                                74.27301,
                                67.49268
                            ],
                            [
                                74.1024,
                                67.41348
                            ],
                            [
                                73.92942,
                                67.28308
                            ],
                            [
                                73.96658,
                                67.18724
                            ],
                            [
                                73.8691,
                                66.98625
                            ],
                            [
                                73.62453,
                                66.91936
                            ],
                            [
                                73.50797,
                                66.82363
                            ],
                            [
                                73.08702,
                                66.73455
                            ],
                            [
                                72.92297,
                                66.63911
                            ],
                            [
                                72.49904,
                                66.59012
                            ],
                            [
                                72.33318,
                                66.49926
                            ],
                            [
                                72.42649,
                                66.35625
                            ],
                            [
                                72.32601,
                                66.2876
                            ],
                            [
                                72.08452,
                                66.2246
                            ],
                            [
                                71.77287,
                                66.2511
                            ],
                            [
                                71.72088,
                                66.29301
                            ],
                            [
                                71.41577,
                                66.33607
                            ],
                            [
                                71.00332,
                                66.35063
                            ],
                            [
                                70.39154,
                                66.32131
                            ],
                            [
                                70.07495,
                                66.37986
                            ],
                            [
                                69.94683,
                                66.38942
                            ],
                            [
                                69.82654,
                                66.45186
                            ],
                            [
                                69.38522,
                                66.50562
                            ],
                            [
                                69.13272,
                                66.61609
                            ],
                            [
                                69.18222,
                                66.72349
                            ],
                            [
                                69.06762,
                                66.81401
                            ],
                            [
                                69.12785,
                                66.91065
                            ],
                            [
                                69.3267,
                                66.85395
                            ],
                            [
                                69.5077,
                                66.84419
                            ],
                            [
                                69.65601,
                                66.81048
                            ],
                            [
                                69.87705,
                                66.80823
                            ],
                            [
                                70.10876,
                                66.73807
                            ],
                            [
                                70.31553,
                                66.76008
                            ],
                            [
                                70.50676,
                                66.73022
                            ],
                            [
                                70.78542,
                                66.76885
                            ],
                            [
                                70.87169,
                                66.81566
                            ],
                            [
                                71.06083,
                                66.80742
                            ],
                            [
                                71.20201,
                                66.86795
                            ],
                            [
                                71.32138,
                                66.873
                            ],
                            [
                                71.45277,
                                66.95377
                            ],
                            [
                                71.68508,
                                66.935
                            ],
                            [
                                71.81984,
                                66.94987
                            ],
                            [
                                71.98231,
                                67.02869
                            ],
                            [
                                71.99085,
                                67.11343
                            ],
                            [
                                72.10627,
                                67.14971
                            ],
                            [
                                72.23966,
                                67.13643
                            ],
                            [
                                72.21609,
                                67.24279
                            ],
                            [
                                72.14909,
                                67.28462
                            ],
                            [
                                72.40232,
                                67.30559
                            ],
                            [
                                72.46415,
                                67.37773
                            ],
                            [
                                72.45199,
                                67.46305
                            ],
                            [
                                72.56444,
                                67.49794
                            ],
                            [
                                72.5911,
                                67.56816
                            ],
                            [
                                72.88621,
                                67.62668
                            ],
                            [
                                72.91218,
                                67.68362
                            ],
                            [
                                73.12154,
                                67.73005
                            ],
                            [
                                73.08621,
                                67.7962
                            ],
                            [
                                73.20252,
                                67.84193
                            ],
                            [
                                73.18801,
                                67.95013
                            ],
                            [
                                73.04281,
                                68.07975
                            ],
                            [
                                73.10376,
                                68.13464
                            ],
                            [
                                73.13117,
                                68.24326
                            ],
                            [
                                73.42572,
                                68.36661
                            ],
                            [
                                73.4672,
                                68.45057
                            ],
                            [
                                73.599,
                                68.47677
                            ],
                            [
                                73.47469,
                                68.57702
                            ],
                            [
                                73.12708,
                                68.7072
                            ],
                            [
                                72.81123,
                                68.79726
                            ],
                            [
                                72.5837,
                                68.92386
                            ],
                            [
                                72.48755,
                                69.0918
                            ],
                            [
                                72.51141,
                                69.20409
                            ],
                            [
                                72.63238,
                                69.26734
                            ],
                            [
                                72.62318,
                                69.32612
                            ],
                            [
                                72.52004,
                                69.4343
                            ],
                            [
                                72.69099,
                                69.45103
                            ],
                            [
                                72.51897,
                                69.63139
                            ],
                            [
                                72.68286,
                                69.75994
                            ],
                            [
                                72.66141,
                                69.85334
                            ],
                            [
                                72.4907,
                                69.98831
                            ],
                            [
                                72.57724,
                                70.14443
                            ],
                            [
                                72.40837,
                                70.25746
                            ],
                            [
                                72.63861,
                                70.37142
                            ],
                            [
                                72.76023,
                                70.3877
                            ],
                            [
                                72.76848,
                                70.50482
                            ],
                            [
                                72.71315,
                                70.5472
                            ],
                            [
                                72.77386,
                                70.65531
                            ],
                            [
                                72.82501,
                                70.87177
                            ],
                            [
                                72.59181,
                                70.99547
                            ],
                            [
                                72.65363,
                                71.07498
                            ],
                            [
                                72.55375,
                                71.15112
                            ],
                            [
                                72.28903,
                                71.19337
                            ],
                            [
                                72.03358,
                                71.29342
                            ],
                            [
                                71.86859,
                                71.41779
                            ],
                            [
                                71.87936,
                                71.51627
                            ],
                            [
                                72.17878,
                                71.59046
                            ],
                            [
                                72.21157,
                                71.65965
                            ],
                            [
                                72.33471,
                                71.70645
                            ],
                            [
                                72.34905,
                                71.8595
                            ],
                            [
                                72.46443,
                                71.8776
                            ],
                            [
                                72.54166,
                                71.95178
                            ],
                            [
                                72.56957,
                                72.05751
                            ],
                            [
                                72.68481,
                                72.11148
                            ],
                            [
                                72.68414,
                                72.18588
                            ],
                            [
                                72.8149,
                                72.26056
                            ],
                            [
                                72.75073,
                                72.48646
                            ],
                            [
                                72.67823,
                                72.59019
                            ],
                            [
                                72.77245,
                                72.62012
                            ],
                            [
                                72.63058,
                                72.73058
                            ],
                            [
                                71.88004,
                                72.82898
                            ],
                            [
                                71.55233,
                                72.88471
                            ],
                            [
                                71.18856,
                                72.88577
                            ],
                            [
                                70.71198,
                                72.8653
                            ],
                            [
                                70.5027,
                                72.88654
                            ],
                            [
                                69.59587,
                                72.85009
                            ],
                            [
                                69.68776,
                                72.90558
                            ],
                            [
                                69.61128,
                                72.94918
                            ],
                            [
                                69.3163,
                                72.92238
                            ],
                            [
                                69.16274,
                                72.76251
                            ],
                            [
                                68.93761,
                                72.65812
                            ],
                            [
                                68.89545,
                                72.53309
                            ],
                            [
                                68.81219,
                                72.44124
                            ],
                            [
                                68.75087,
                                72.24343
                            ],
                            [
                                68.50828,
                                71.82568
                            ],
                            [
                                68.26121,
                                71.63696
                            ],
                            [
                                67.95503,
                                71.50641
                            ],
                            [
                                67.60715,
                                71.42699
                            ],
                            [
                                67.51991,
                                71.38078
                            ],
                            [
                                66.96031,
                                71.26274
                            ],
                            [
                                66.76906,
                                71.10586
                            ],
                            [
                                66.88665,
                                71.07575
                            ],
                            [
                                66.91071,
                                71.01113
                            ],
                            [
                                66.74902,
                                70.89241
                            ],
                            [
                                66.64697,
                                70.86055
                            ],
                            [
                                66.77746,
                                70.77022
                            ],
                            [
                                67.05145,
                                70.8165
                            ],
                            [
                                67.27721,
                                70.82249
                            ],
                            [
                                67.3905,
                                70.71192
                            ],
                            [
                                67.20975,
                                70.52908
                            ],
                            [
                                67.32568,
                                70.43972
                            ],
                            [
                                67.22479,
                                70.37135
                            ],
                            [
                                67.12802,
                                70.21263
                            ],
                            [
                                67.25225,
                                70.21117
                            ],
                            [
                                67.29915,
                                70.12344
                            ],
                            [
                                67.43619,
                                70.02796
                            ],
                            [
                                67.25824,
                                69.95701
                            ],
                            [
                                66.8872,
                                69.95956
                            ],
                            [
                                66.8276,
                                69.84528
                            ],
                            [
                                66.80774,
                                69.70307
                            ],
                            [
                                66.90215,
                                69.61283
                            ],
                            [
                                67.02665,
                                69.63471
                            ],
                            [
                                67.05608,
                                69.68991
                            ],
                            [
                                67.39138,
                                69.60102
                            ],
                            [
                                67.50097,
                                69.61254
                            ],
                            [
                                67.65807,
                                69.57455
                            ],
                            [
                                67.81269,
                                69.50254
                            ],
                            [
                                67.98595,
                                69.46915
                            ],
                            [
                                68.1283,
                                69.48098
                            ],
                            [
                                68.12041,
                                69.37181
                            ],
                            [
                                68.02651,
                                69.33319
                            ],
                            [
                                68.11555,
                                69.22151
                            ],
                            [
                                68.38941,
                                69.05799
                            ],
                            [
                                68.48619,
                                68.96775
                            ],
                            [
                                68.70442,
                                68.90688
                            ],
                            [
                                68.84959,
                                68.90156
                            ],
                            [
                                69.11468,
                                68.85516
                            ],
                            [
                                68.9982,
                                68.7378
                            ],
                            [
                                68.94772,
                                68.63477
                            ],
                            [
                                68.8548,
                                68.54479
                            ],
                            [
                                68.59967,
                                68.36039
                            ],
                            [
                                68.57208,
                                68.29392
                            ],
                            [
                                68.332,
                                68.17046
                            ],
                            [
                                68.20435,
                                68.26228
                            ],
                            [
                                68.27501,
                                68.31144
                            ],
                            [
                                68.17311,
                                68.38612
                            ],
                            [
                                67.97352,
                                68.43249
                            ],
                            [
                                67.79972,
                                68.44599
                            ],
                            [
                                67.69278,
                                68.5417
                            ],
                            [
                                67.36768,
                                68.6623
                            ],
                            [
                                67.2022,
                                68.69216
                            ],
                            [
                                67.02344,
                                68.83941
                            ],
                            [
                                66.6564,
                                68.87817
                            ],
                            [
                                66.4041,
                                68.92701
                            ],
                            [
                                66.09472,
                                69.02679
                            ],
                            [
                                65.72365,
                                69.07329
                            ],
                            [
                                65.77518,
                                69.10534
                            ],
                            [
                                65.28306,
                                69.19
                            ],
                            [
                                65.12993,
                                69.25058
                            ],
                            [
                                64.95809,
                                69.2508
                            ],
                            [
                                64.85603,
                                69.32302
                            ],
                            [
                                64.38458,
                                69.47655
                            ],
                            [
                                63.78718,
                                69.58812
                            ],
                            [
                                63.00145,
                                69.69699
                            ],
                            [
                                62.67752,
                                69.72263
                            ],
                            [
                                62.14834,
                                69.7307
                            ],
                            [
                                61.35318,
                                69.78699
                            ],
                            [
                                61.30124,
                                69.81824
                            ],
                            [
                                61.04776,
                                69.82981
                            ],
                            [
                                60.89623,
                                69.85895
                            ],
                            [
                                60.72153,
                                69.79893
                            ],
                            [
                                60.77409,
                                69.73499
                            ],
                            [
                                60.62791,
                                69.65497
                            ],
                            [
                                60.34632,
                                69.66128
                            ],
                            [
                                60.20487,
                                69.61135
                            ],
                            [
                                60.18401,
                                69.55111
                            ],
                            [
                                60.51499,
                                69.31837
                            ],
                            [
                                60.63588,
                                69.25142
                            ],
                            [
                                60.63215,
                                69.14483
                            ],
                            [
                                60.7125,
                                69.09939
                            ],
                            [
                                60.84709,
                                69.14526
                            ],
                            [
                                60.96152,
                                69.0638
                            ],
                            [
                                60.93469,
                                68.9259
                            ],
                            [
                                61.2087,
                                68.83142
                            ],
                            [
                                60.79462,
                                68.85759
                            ],
                            [
                                60.63898,
                                68.74919
                            ],
                            [
                                60.37399,
                                68.67791
                            ],
                            [
                                60.07398,
                                68.67452
                            ],
                            [
                                59.94027,
                                68.70322
                            ],
                            [
                                59.80073,
                                68.60345
                            ],
                            [
                                59.94636,
                                68.44139
                            ],
                            [
                                59.87941,
                                68.38628
                            ],
                            [
                                59.67116,
                                68.34083
                            ],
                            [
                                59.47205,
                                68.34228
                            ],
                            [
                                59.16713,
                                68.38339
                            ],
                            [
                                59.10032,
                                68.42097
                            ],
                            [
                                59.14916,
                                68.51163
                            ],
                            [
                                59.07449,
                                68.56493
                            ],
                            [
                                59.18413,
                                68.66252
                            ],
                            [
                                59.44908,
                                68.66859
                            ],
                            [
                                59.51673,
                                68.72868
                            ],
                            [
                                59.40899,
                                68.80821
                            ],
                            [
                                58.99435,
                                68.91797
                            ],
                            [
                                59.11657,
                                68.98372
                            ],
                            [
                                58.7759,
                                68.96455
                            ],
                            [
                                58.40874,
                                68.88431
                            ],
                            [
                                58.06803,
                                68.82895
                            ],
                            [
                                58.0027,
                                68.74672
                            ],
                            [
                                57.90418,
                                68.76058
                            ],
                            [
                                57.65348,
                                68.73382
                            ],
                            [
                                57.30813,
                                68.52857
                            ],
                            [
                                57.04813,
                                68.5177
                            ],
                            [
                                56.61499,
                                68.61797
                            ],
                            [
                                56.43965,
                                68.58842
                            ],
                            [
                                56.21879,
                                68.59608
                            ],
                            [
                                56.0678,
                                68.64338
                            ],
                            [
                                55.95496,
                                68.63833
                            ],
                            [
                                55.65711,
                                68.54608
                            ],
                            [
                                55.37284,
                                68.54403
                            ],
                            [
                                55.01482,
                                68.42474
                            ],
                            [
                                54.86906,
                                68.29745
                            ],
                            [
                                54.96254,
                                68.24415
                            ],
                            [
                                54.83836,
                                68.15153
                            ],
                            [
                                54.71253,
                                68.15575
                            ],
                            [
                                54.49378,
                                68.29445
                            ],
                            [
                                54.08744,
                                68.18062
                            ],
                            [
                                53.82171,
                                68.23719
                            ],
                            [
                                53.60444,
                                68.24702
                            ],
                            [
                                53.15706,
                                68.22026
                            ],
                            [
                                53.32091,
                                68.33451
                            ],
                            [
                                53.43784,
                                68.36712
                            ],
                            [
                                53.77092,
                                68.33844
                            ],
                            [
                                53.94612,
                                68.3898
                            ],
                            [
                                53.94935,
                                68.46748
                            ],
                            [
                                53.88905,
                                68.53401
                            ],
                            [
                                53.73133,
                                68.59731
                            ],
                            [
                                53.85857,
                                68.68675
                            ],
                            [
                                53.88747,
                                68.78699
                            ],
                            [
                                54.00457,
                                68.83046
                            ],
                            [
                                53.6749,
                                68.89521
                            ],
                            [
                                54.34181,
                                68.94891
                            ],
                            [
                                54.24619,
                                68.98632
                            ],
                            [
                                53.8761,
                                68.95946
                            ],
                            [
                                53.36111,
                                68.88238
                            ],
                            [
                                52.82724,
                                68.7451
                            ],
                            [
                                52.29299,
                                68.59169
                            ],
                            [
                                52.45304,
                                68.58674
                            ],
                            [
                                52.59336,
                                68.5169
                            ],
                            [
                                52.76306,
                                68.47002
                            ],
                            [
                                52.7032,
                                68.41661
                            ],
                            [
                                52.31556,
                                68.30989
                            ],
                            [
                                52.1764,
                                68.35574
                            ],
                            [
                                52.31942,
                                68.42909
                            ],
                            [
                                52.2972,
                                68.46806
                            ],
                            [
                                52.13517,
                                68.50295
                            ],
                            [
                                51.87924,
                                68.50725
                            ],
                            [
                                51.57875,
                                68.48224
                            ],
                            [
                                51.30312,
                                68.38667
                            ],
                            [
                                50.89655,
                                68.34209
                            ],
                            [
                                50.80024,
                                68.3655
                            ],
                            [
                                50.27052,
                                68.1712
                            ],
                            [
                                50.0715,
                                68.10767
                            ],
                            [
                                49.97014,
                                68.01828
                            ],
                            [
                                49.84685,
                                68.03363
                            ],
                            [
                                49.58048,
                                67.95588
                            ],
                            [
                                49.15776,
                                67.85304
                            ],
                            [
                                48.76707,
                                67.83405
                            ],
                            [
                                48.74507,
                                67.67043
                            ],
                            [
                                48.60105,
                                67.67978
                            ],
                            [
                                48.46361,
                                67.63959
                            ],
                            [
                                48.35417,
                                67.66323
                            ],
                            [
                                48.14916,
                                67.61878
                            ],
                            [
                                47.99392,
                                67.63469
                            ],
                            [
                                47.85603,
                                67.58676
                            ],
                            [
                                47.91923,
                                67.47453
                            ],
                            [
                                47.89526,
                                67.40885
                            ],
                            [
                                47.77745,
                                67.34133
                            ],
                            [
                                47.76321,
                                67.23034
                            ],
                            [
                                47.68292,
                                67.19713
                            ],
                            [
                                47.75542,
                                67.14171
                            ],
                            [
                                47.7441,
                                67.01685
                            ],
                            [
                                47.59982,
                                66.9359
                            ],
                            [
                                47.3965,
                                66.92351
                            ],
                            [
                                47.06542,
                                66.85668
                            ],
                            [
                                46.6545,
                                66.8238
                            ],
                            [
                                46.55319,
                                66.86552
                            ],
                            [
                                46.21102,
                                66.82936
                            ],
                            [
                                46.01784,
                                66.8311
                            ],
                            [
                                45.80511,
                                66.90516
                            ],
                            [
                                45.61491,
                                67.06218
                            ],
                            [
                                45.59158,
                                67.15645
                            ],
                            [
                                45.1618,
                                67.24745
                            ],
                            [
                                44.95184,
                                67.31511
                            ],
                            [
                                44.90728,
                                67.37292
                            ],
                            [
                                44.94824,
                                67.45945
                            ],
                            [
                                45.13922,
                                67.55911
                            ],
                            [
                                45.3035,
                                67.57751
                            ],
                            [
                                45.32595,
                                67.69275
                            ],
                            [
                                45.51212,
                                67.7451
                            ],
                            [
                                45.85222,
                                67.75468
                            ],
                            [
                                46.32902,
                                67.82089
                            ],
                            [
                                46.64741,
                                67.80573
                            ],
                            [
                                46.67792,
                                67.90498
                            ],
                            [
                                46.54741,
                                68.0119
                            ],
                            [
                                46.53966,
                                68.1112
                            ],
                            [
                                46.32269,
                                68.17838
                            ],
                            [
                                45.87104,
                                68.4182
                            ],
                            [
                                45.70286,
                                68.47329
                            ],
                            [
                                45.21188,
                                68.52436
                            ],
                            [
                                44.69859,
                                68.54042
                            ],
                            [
                                44.09511,
                                68.53287
                            ],
                            [
                                43.81196,
                                68.58357
                            ],
                            [
                                43.44339,
                                68.67192
                            ],
                            [
                                43.25915,
                                68.64352
                            ],
                            [
                                43.55132,
                                68.52332
                            ],
                            [
                                44.01291,
                                68.38571
                            ],
                            [
                                44.22026,
                                68.275
                            ],
                            [
                                44.20642,
                                68.14037
                            ],
                            [
                                44.23875,
                                68.04654
                            ],
                            [
                                44.11079,
                                67.83629
                            ],
                            [
                                44.17068,
                                67.78439
                            ],
                            [
                                44.0875,
                                67.65356
                            ],
                            [
                                43.89922,
                                67.48266
                            ],
                            [
                                43.79847,
                                67.33056
                            ],
                            [
                                43.77308,
                                67.19401
                            ],
                            [
                                43.87522,
                                67.15177
                            ],
                            [
                                44.03247,
                                67.16157
                            ],
                            [
                                44.27782,
                                67.06844
                            ],
                            [
                                44.51889,
                                66.90409
                            ],
                            [
                                44.49602,
                                66.83958
                            ],
                            [
                                44.36217,
                                66.77379
                            ],
                            [
                                44.4835,
                                66.66918
                            ],
                            [
                                44.37224,
                                66.49614
                            ],
                            [
                                44.28463,
                                66.46391
                            ],
                            [
                                44.06419,
                                66.2293
                            ],
                            [
                                44.16357,
                                66.08319
                            ],
                            [
                                43.97185,
                                66.09229
                            ],
                            [
                                43.83969,
                                66.18545
                            ],
                            [
                                43.70931,
                                66.18989
                            ],
                            [
                                43.60336,
                                66.28739
                            ],
                            [
                                43.35919,
                                66.32563
                            ],
                            [
                                43.29242,
                                66.39687
                            ],
                            [
                                43.17983,
                                66.4112
                            ],
                            [
                                42.82971,
                                66.38909
                            ],
                            [
                                42.64996,
                                66.39478
                            ],
                            [
                                42.58761,
                                66.44117
                            ],
                            [
                                42.31238,
                                66.50955
                            ],
                            [
                                42.10531,
                                66.48478
                            ],
                            [
                                41.94702,
                                66.33259
                            ],
                            [
                                41.86233,
                                66.32292
                            ],
                            [
                                41.76774,
                                66.24517
                            ],
                            [
                                41.49923,
                                66.11199
                            ],
                            [
                                41.27592,
                                66.05021
                            ],
                            [
                                41.01965,
                                66.0102
                            ],
                            [
                                40.74215,
                                65.98373
                            ],
                            [
                                40.47717,
                                65.80604
                            ],
                            [
                                40.18434,
                                65.69681
                            ],
                            [
                                39.88425,
                                65.63559
                            ],
                            [
                                39.79345,
                                65.58915
                            ],
                            [
                                39.71835,
                                65.4931
                            ],
                            [
                                39.72255,
                                65.3396
                            ],
                            [
                                40.03646,
                                65.13998
                            ],
                            [
                                40.04846,
                                65.10293
                            ],
                            [
                                40.27295,
                                65.01827
                            ],
                            [
                                40.394,
                                64.92439
                            ],
                            [
                                40.43572,
                                64.78446
                            ],
                            [
                                40.41873,
                                64.69133
                            ],
                            [
                                40.51842,
                                64.52495
                            ],
                            [
                                40.418,
                                64.52348
                            ],
                            [
                                40.32285,
                                64.55366
                            ],
                            [
                                40.15431,
                                64.55076
                            ],
                            [
                                40.08333,
                                64.60903
                            ],
                            [
                                39.81725,
                                64.63819
                            ],
                            [
                                39.71269,
                                64.55297
                            ],
                            [
                                39.51309,
                                64.55348
                            ],
                            [
                                39.32096,
                                64.63961
                            ],
                            [
                                39.11905,
                                64.66594
                            ],
                            [
                                38.88077,
                                64.74152
                            ],
                            [
                                38.49331,
                                64.78821
                            ],
                            [
                                38.49834,
                                64.73674
                            ],
                            [
                                38.32562,
                                64.74153
                            ],
                            [
                                38.1144,
                                64.6802
                            ],
                            [
                                38.0163,
                                64.75702
                            ],
                            [
                                38.2911,
                                64.80456
                            ],
                            [
                                38.04235,
                                64.854
                            ],
                            [
                                37.78907,
                                64.92753
                            ],
                            [
                                37.70664,
                                65.01656
                            ],
                            [
                                37.38651,
                                65.09837
                            ],
                            [
                                37.02876,
                                65.16415
                            ],
                            [
                                36.82943,
                                65.14731
                            ],
                            [
                                36.80672,
                                64.95881
                            ],
                            [
                                36.45697,
                                64.85191
                            ],
                            [
                                36.55822,
                                64.81246
                            ],
                            [
                                36.5754,
                                64.72041
                            ],
                            [
                                36.7285,
                                64.69033
                            ],
                            [
                                36.78444,
                                64.63079
                            ],
                            [
                                37.10593,
                                64.4109
                            ],
                            [
                                37.33099,
                                64.34324
                            ],
                            [
                                37.63396,
                                64.39797
                            ],
                            [
                                37.78663,
                                64.38105
                            ],
                            [
                                38.03398,
                                64.32456
                            ],
                            [
                                37.8947,
                                64.20529
                            ],
                            [
                                37.99248,
                                64.14599
                            ],
                            [
                                38.06293,
                                64.05258
                            ],
                            [
                                38.06704,
                                63.98859
                            ],
                            [
                                37.87734,
                                63.89117
                            ],
                            [
                                37.6379,
                                63.88035
                            ],
                            [
                                37.6079,
                                63.81334
                            ],
                            [
                                37.44537,
                                63.78544
                            ],
                            [
                                37.25767,
                                63.81588
                            ],
                            [
                                37.22671,
                                63.86765
                            ],
                            [
                                37.11091,
                                63.88775
                            ],
                            [
                                36.87433,
                                63.88666
                            ],
                            [
                                36.65827,
                                63.91273
                            ],
                            [
                                36.53727,
                                63.94936
                            ],
                            [
                                36.28504,
                                63.98124
                            ],
                            [
                                36.22048,
                                64.1399
                            ],
                            [
                                35.91678,
                                64.26018
                            ],
                            [
                                35.70291,
                                64.36005
                            ],
                            [
                                35.40952,
                                64.28784
                            ],
                            [
                                35.33643,
                                64.34195
                            ],
                            [
                                35.14457,
                                64.35136
                            ],
                            [
                                35.12067,
                                64.41566
                            ],
                            [
                                34.97668,
                                64.42137
                            ],
                            [
                                34.95039,
                                64.4909
                            ],
                            [
                                34.78097,
                                64.51524
                            ],
                            [
                                34.96535,
                                64.60423
                            ],
                            [
                                34.77767,
                                64.74646
                            ],
                            [
                                34.94278,
                                64.82563
                            ],
                            [
                                34.77442,
                                64.94726
                            ],
                            [
                                34.7839,
                                65.06069
                            ],
                            [
                                34.68828,
                                65.07637
                            ],
                            [
                                34.66595,
                                65.16333
                            ],
                            [
                                34.59119,
                                65.2224
                            ],
                            [
                                34.47701,
                                65.24283
                            ],
                            [
                                34.40566,
                                65.4008
                            ],
                            [
                                34.67257,
                                65.43746
                            ],
                            [
                                34.79422,
                                65.58642
                            ],
                            [
                                34.70219,
                                65.67409
                            ],
                            [
                                34.6498,
                                65.7827
                            ],
                            [
                                34.80701,
                                65.83006
                            ],
                            [
                                34.82651,
                                65.88182
                            ],
                            [
                                34.667,
                                65.9003
                            ],
                            [
                                34.69883,
                                65.98248
                            ],
                            [
                                34.51912,
                                66.07683
                            ],
                            [
                                34.08968,
                                66.22446
                            ],
                            [
                                33.95349,
                                66.21966
                            ],
                            [
                                33.74823,
                                66.27108
                            ],
                            [
                                33.56415,
                                66.39752
                            ],
                            [
                                33.29341,
                                66.4747
                            ],
                            [
                                33.20758,
                                66.52474
                            ],
                            [
                                33.0436,
                                66.5048
                            ],
                            [
                                33.03552,
                                66.58491
                            ],
                            [
                                33.11981,
                                66.64452
                            ],
                            [
                                32.96084,
                                66.69805
                            ],
                            [
                                32.91516,
                                66.75538
                            ],
                            [
                                32.76081,
                                66.77561
                            ],
                            [
                                32.5407,
                                66.87429
                            ],
                            [
                                32.51054,
                                67.0202
                            ],
                            [
                                32.32623,
                                67.04466
                            ],
                            [
                                32.27052,
                                67.12771
                            ],
                            [
                                32.62495,
                                67.11701
                            ],
                            [
                                32.76368,
                                67.0754
                            ],
                            [
                                32.85107,
                                66.9707
                            ],
                            [
                                32.98917,
                                66.89925
                            ],
                            [
                                33.42166,
                                66.74241
                            ],
                            [
                                33.56114,
                                66.71892
                            ],
                            [
                                33.6218,
                                66.81807
                            ],
                            [
                                33.83439,
                                66.76119
                            ],
                            [
                                33.83559,
                                66.71983
                            ],
                            [
                                33.96959,
                                66.68258
                            ],
                            [
                                34.14574,
                                66.69043
                            ],
                            [
                                34.3995,
                                66.64921
                            ],
                            [
                                34.40194,
                                66.5835
                            ],
                            [
                                34.48671,
                                66.53781
                            ],
                            [
                                34.71455,
                                66.58942
                            ],
                            [
                                34.92718,
                                66.58278
                            ],
                            [
                                35.16629,
                                66.4942
                            ],
                            [
                                35.32825,
                                66.4599
                            ],
                            [
                                35.48541,
                                66.38817
                            ],
                            [
                                36.08934,
                                66.33221
                            ],
                            [
                                36.53771,
                                66.27969
                            ],
                            [
                                36.87418,
                                66.27564
                            ],
                            [
                                37.12146,
                                66.24031
                            ],
                            [
                                37.73755,
                                66.09911
                            ],
                            [
                                38.28143,
                                66.04559
                            ],
                            [
                                38.67976,
                                66.05438
                            ],
                            [
                                38.89884,
                                66.09722
                            ],
                            [
                                39.10978,
                                66.09384
                            ],
                            [
                                39.45666,
                                66.17519
                            ],
                            [
                                39.73517,
                                66.2056
                            ],
                            [
                                39.99587,
                                66.25167
                            ],
                            [
                                40.16938,
                                66.32926
                            ],
                            [
                                40.46821,
                                66.41015
                            ],
                            [
                                40.5943,
                                66.50679
                            ],
                            [
                                41.20061,
                                66.81856
                            ],
                            [
                                41.23182,
                                66.89286
                            ],
                            [
                                41.33541,
                                66.98288
                            ],
                            [
                                41.29439,
                                67.14232
                            ],
                            [
                                41.33482,
                                67.18315
                            ],
                            [
                                41.07711,
                                67.25642
                            ],
                            [
                                41.11089,
                                67.40683
                            ],
                            [
                                40.97813,
                                67.46618
                            ],
                            [
                                40.98235,
                                67.5591
                            ],
                            [
                                41.04115,
                                67.62602
                            ],
                            [
                                40.96302,
                                67.70237
                            ],
                            [
                                40.77786,
                                67.72281
                            ],
                            [
                                40.66146,
                                67.79487
                            ],
                            [
                                40.41888,
                                67.75481
                            ],
                            [
                                40.28486,
                                67.83603
                            ],
                            [
                                40.38463,
                                67.88224
                            ],
                            [
                                40.14402,
                                67.93894
                            ],
                            [
                                39.83974,
                                68.03392
                            ],
                            [
                                39.61286,
                                68.02477
                            ],
                            [
                                39.15485,
                                68.19021
                            ],
                            [
                                38.77884,
                                68.3027
                            ],
                            [
                                38.44102,
                                68.33691
                            ],
                            [
                                38.30984,
                                68.41777
                            ],
                            [
                                38.09344,
                                68.48021
                            ],
                            [
                                37.97678,
                                68.56693
                            ],
                            [
                                37.54144,
                                68.72553
                            ],
                            [
                                37.44079,
                                68.73627
                            ],
                            [
                                37.18032,
                                68.83586
                            ],
                            [
                                36.70847,
                                68.95701
                            ],
                            [
                                36.57298,
                                69.00895
                            ],
                            [
                                36.02165,
                                69.12386
                            ],
                            [
                                35.81695,
                                69.18132
                            ],
                            [
                                35.37572,
                                69.21721
                            ],
                            [
                                35.15799,
                                69.17793
                            ],
                            [
                                35.04569,
                                69.20672
                            ],
                            [
                                34.82183,
                                69.21578
                            ],
                            [
                                34.36792,
                                69.26613
                            ],
                            [
                                34.19462,
                                69.29851
                            ],
                            [
                                33.9542,
                                69.30852
                            ],
                            [
                                33.39336,
                                69.22325
                            ],
                            [
                                33.38298,
                                69.29311
                            ],
                            [
                                33.47839,
                                69.32645
                            ],
                            [
                                33.42422,
                                69.41856
                            ],
                            [
                                32.99785,
                                69.36621
                            ],
                            [
                                33.07317,
                                69.4472
                            ],
                            [
                                32.58492,
                                69.44601
                            ],
                            [
                                32.41597,
                                69.55757
                            ],
                            [
                                32.04081,
                                69.60801
                            ],
                            [
                                32.44084,
                                69.62649
                            ],
                            [
                                32.5186,
                                69.59839
                            ],
                            [
                                32.85361,
                                69.56347
                            ],
                            [
                                32.95897,
                                69.58129
                            ],
                            [
                                33.10945,
                                69.67892
                            ],
                            [
                                32.94588,
                                69.76891
                            ],
                            [
                                32.56343,
                                69.7944
                            ],
                            [
                                32.41131,
                                69.86278
                            ],
                            [
                                32.06032,
                                69.94184
                            ],
                            [
                                31.89817,
                                69.9086
                            ],
                            [
                                32.08911,
                                69.76787
                            ],
                            [
                                31.78487,
                                69.83027
                            ],
                            [
                                31.72239,
                                69.8044
                            ],
                            [
                                31.71143,
                                69.6705
                            ],
                            [
                                31.4407,
                                69.69314
                            ],
                            [
                                31.24825,
                                69.74462
                            ],
                            [
                                31.00165,
                                69.7765
                            ],
                            [
                                30.86536,
                                69.75959
                            ],
                            [
                                30.94408,
                                69.67476
                            ],
                            [
                                30.93842,
                                69.56169
                            ],
                            [
                                30.81725,
                                69.52916
                            ],
                            [
                                30.51595,
                                69.54082
                            ],
                            [
                                30.2247,
                                69.65289
                            ],
                            [
                                30.11594,
                                69.46944
                            ],
                            [
                                30.02229,
                                69.42012
                            ],
                            [
                                29.84705,
                                69.4217
                            ],
                            [
                                29.56954,
                                69.31786
                            ],
                            [
                                29.39572,
                                69.32324
                            ],
                            [
                                29.28616,
                                69.29347
                            ],
                            [
                                29.31223,
                                69.23773
                            ],
                            [
                                29.24139,
                                69.11271
                            ],
                            [
                                29.05713,
                                69.01565
                            ],
                            [
                                28.92968,
                                69.0519
                            ],
                            [
                                28.49577,
                                68.93013
                            ],
                            [
                                28.47003,
                                68.88548
                            ],
                            [
                                28.80016,
                                68.86872
                            ],
                            [
                                28.70617,
                                68.7322
                            ],
                            [
                                28.43392,
                                68.53967
                            ],
                            [
                                28.64614,
                                68.1963
                            ],
                            [
                                29.32661,
                                68.07446
                            ],
                            [
                                29.6594,
                                67.80296
                            ],
                            [
                                30.01704,
                                67.67356
                            ],
                            [
                                29.93022,
                                67.52253
                            ],
                            [
                                29.71064,
                                67.38964
                            ],
                            [
                                29.52334,
                                67.30969
                            ],
                            [
                                29.51492,
                                67.27962
                            ],
                            [
                                29.07402,
                                66.99661
                            ],
                            [
                                29.03362,
                                66.92462
                            ],
                            [
                                29.11796,
                                66.80159
                            ],
                            [
                                29.35482,
                                66.64108
                            ],
                            [
                                29.5197,
                                66.4961
                            ],
                            [
                                29.71116,
                                66.26713
                            ],
                            [
                                29.92368,
                                66.12643
                            ],
                            [
                                29.99719,
                                65.97937
                            ],
                            [
                                30.06827,
                                65.89527
                            ],
                            [
                                30.13398,
                                65.70002
                            ],
                            [
                                30.01636,
                                65.69615
                            ],
                            [
                                29.72189,
                                65.63709
                            ],
                            [
                                29.86392,
                                65.56045
                            ],
                            [
                                29.73307,
                                65.4725
                            ],
                            [
                                29.7466,
                                65.34741
                            ],
                            [
                                29.60181,
                                65.25994
                            ],
                            [
                                29.89311,
                                65.1933
                            ],
                            [
                                29.73173,
                                65.09089
                            ],
                            [
                                29.62796,
                                65.06072
                            ],
                            [
                                29.59977,
                                64.99508
                            ],
                            [
                                29.64496,
                                64.8668
                            ],
                            [
                                29.74051,
                                64.78993
                            ],
                            [
                                30.04142,
                                64.79275
                            ],
                            [
                                30.04194,
                                64.74013
                            ],
                            [
                                30.13511,
                                64.64944
                            ],
                            [
                                29.9898,
                                64.58715
                            ],
                            [
                                30.05785,
                                64.45159
                            ],
                            [
                                30.04572,
                                64.40174
                            ],
                            [
                                30.48263,
                                64.26172
                            ],
                            [
                                30.46722,
                                64.20381
                            ],
                            [
                                30.5529,
                                64.13233
                            ],
                            [
                                30.52687,
                                64.04786
                            ],
                            [
                                30.32145,
                                63.9098
                            ],
                            [
                                30.26131,
                                63.82331
                            ],
                            [
                                29.97192,
                                63.75717
                            ],
                            [
                                30.24267,
                                63.60802
                            ],
                            [
                                30.3846,
                                63.54527
                            ],
                            [
                                30.48478,
                                63.46662
                            ],
                            [
                                30.78667,
                                63.4054
                            ],
                            [
                                31.23894,
                                63.21813
                            ],
                            [
                                31.2653,
                                63.11565
                            ],
                            [
                                31.46144,
                                63.02497
                            ],
                            [
                                31.58601,
                                62.90847
                            ],
                            [
                                31.43834,
                                62.78352
                            ],
                            [
                                31.34699,
                                62.643
                            ],
                            [
                                31.22247,
                                62.49952
                            ],
                            [
                                31.13809,
                                62.44198
                            ],
                            [
                                30.60312,
                                62.1421
                            ],
                            [
                                30.306,
                                61.96426
                            ],
                            [
                                30.03728,
                                61.76498
                            ],
                            [
                                29.82001,
                                61.65591
                            ],
                            [
                                29.74073,
                                61.57612
                            ],
                            [
                                29.50236,
                                61.46102
                            ],
                            [
                                29.32498,
                                61.34934
                            ],
                            [
                                29.24365,
                                61.27028
                            ],
                            [
                                28.8197,
                                61.12147
                            ],
                            [
                                28.71513,
                                61.04435
                            ],
                            [
                                28.65564,
                                60.95072
                            ],
                            [
                                28.52405,
                                60.95555
                            ],
                            [
                                28.13488,
                                60.74072
                            ],
                            [
                                27.87349,
                                60.60446
                            ],
                            [
                                27.80357,
                                60.54862
                            ],
                            [
                                27.87054,
                                60.51795
                            ],
                            [
                                28.0645,
                                60.50522
                            ],
                            [
                                28.23994,
                                60.53431
                            ],
                            [
                                28.38393,
                                60.64194
                            ],
                            [
                                28.55314,
                                60.68004
                            ],
                            [
                                28.62408,
                                60.66793
                            ],
                            [
                                28.76299,
                                60.71972
                            ],
                            [
                                28.70303,
                                60.59728
                            ],
                            [
                                28.55759,
                                60.60151
                            ],
                            [
                                28.69711,
                                60.5
                            ],
                            [
                                28.67557,
                                60.43396
                            ],
                            [
                                28.597,
                                60.37403
                            ],
                            [
                                28.79893,
                                60.32696
                            ],
                            [
                                28.99876,
                                60.22799
                            ],
                            [
                                29.01914,
                                60.18577
                            ],
                            [
                                29.14672,
                                60.16221
                            ],
                            [
                                29.44095,
                                60.16205
                            ],
                            [
                                29.5808,
                                60.19858
                            ],
                            [
                                29.72156,
                                60.1886
                            ],
                            [
                                29.93062,
                                60.14158
                            ],
                            [
                                29.97171,
                                60.01206
                            ],
                            [
                                30.24997,
                                59.96908
                            ],
                            [
                                30.16546,
                                59.85915
                            ],
                            [
                                30.04338,
                                59.86208
                            ],
                            [
                                29.77555,
                                59.93236
                            ],
                            [
                                29.6306,
                                59.9346
                            ],
                            [
                                29.2272,
                                59.994
                            ],
                            [
                                29.06657,
                                59.9617
                            ],
                            [
                                29.05933,
                                59.86369
                            ],
                            [
                                28.9859,
                                59.81456
                            ],
                            [
                                28.72275,
                                59.7788
                            ],
                            [
                                28.55812,
                                59.84771
                            ],
                            [
                                28.44961,
                                59.79774
                            ],
                            [
                                28.42991,
                                59.67787
                            ],
                            [
                                28.24349,
                                59.68109
                            ],
                            [
                                28.19716,
                                59.77265
                            ],
                            [
                                28.11273,
                                59.79472
                            ],
                            [
                                28.01543,
                                59.70354
                            ],
                            [
                                28.10295,
                                59.58699
                            ],
                            [
                                28.04192,
                                59.47012
                            ],
                            [
                                28.20959,
                                59.37058
                            ],
                            [
                                28.12187,
                                59.28979
                            ],
                            [
                                27.957,
                                59.27157
                            ],
                            [
                                27.80822,
                                59.12874
                            ],
                            [
                                27.72762,
                                58.97157
                            ],
                            [
                                27.35705,
                                58.78714
                            ],
                            [
                                27.55321,
                                58.36598
                            ],
                            [
                                27.49075,
                                58.22512
                            ],
                            [
                                27.63412,
                                58.0973
                            ],
                            [
                                27.62105,
                                58.00511
                            ],
                            [
                                27.68118,
                                57.92423
                            ],
                            [
                                27.81772,
                                57.89052
                            ],
                            [
                                27.77569,
                                57.83436
                            ],
                            [
                                27.56487,
                                57.83146
                            ],
                            [
                                27.37785,
                                57.67202
                            ],
                            [
                                27.4042,
                                57.61284
                            ],
                            [
                                27.32008,
                                57.57898
                            ],
                            [
                                27.35158,
                                57.51824
                            ],
                            [
                                27.5041,
                                57.54
                            ],
                            [
                                27.56647,
                                57.51375
                            ],
                            [
                                27.51821,
                                57.42741
                            ],
                            [
                                27.6709,
                                57.3948
                            ],
                            [
                                27.78326,
                                57.32124
                            ],
                            [
                                27.86722,
                                57.29686
                            ],
                            [
                                27.81777,
                                57.1434
                            ],
                            [
                                27.75794,
                                57.13075
                            ],
                            [
                                27.76808,
                                57.00292
                            ],
                            [
                                27.73776,
                                56.92159
                            ],
                            [
                                27.65944,
                                56.83437
                            ],
                            [
                                27.8719,
                                56.86661
                            ],
                            [
                                27.89947,
                                56.75271
                            ],
                            [
                                28.01224,
                                56.67242
                            ],
                            [
                                28.0429,
                                56.59097
                            ],
                            [
                                28.12591,
                                56.58215
                            ],
                            [
                                28.10014,
                                56.50971
                            ],
                            [
                                28.19356,
                                56.44074
                            ],
                            [
                                28.16383,
                                56.37865
                            ],
                            [
                                28.24058,
                                56.27606
                            ],
                            [
                                28.15456,
                                56.16984
                            ],
                            [
                                28.3099,
                                56.05136
                            ],
                            [
                                28.37895,
                                56.09041
                            ],
                            [
                                28.52819,
                                56.10513
                            ],
                            [
                                28.65,
                                56.09124
                            ],
                            [
                                28.74611,
                                55.9561
                            ],
                            [
                                29.05944,
                                56.03277
                            ],
                            [
                                29.41007,
                                55.95791
                            ],
                            [
                                29.35979,
                                55.7968
                            ],
                            [
                                29.485,
                                55.69221
                            ],
                            [
                                29.65638,
                                55.76527
                            ],
                            [
                                29.97252,
                                55.85637
                            ],
                            [
                                30.24583,
                                55.85444
                            ],
                            [
                                30.49152,
                                55.79902
                            ],
                            [
                                30.7575,
                                55.597
                            ],
                            [
                                30.92625,
                                55.60257
                            ],
                            [
                                30.93581,
                                55.39929
                            ],
                            [
                                30.81653,
                                55.30185
                            ],
                            [
                                30.97698,
                                55.15344
                            ],
                            [
                                31.02696,
                                55.04847
                            ],
                            [
                                30.9405,
                                54.96425
                            ],
                            [
                                30.86508,
                                54.94699
                            ],
                            [
                                30.78326,
                                54.79957
                            ],
                            [
                                31.00642,
                                54.71026
                            ],
                            [
                                31.1028,
                                54.64546
                            ],
                            [
                                31.13768,
                                54.57669
                            ],
                            [
                                31.09268,
                                54.4935
                            ],
                            [
                                31.22666,
                                54.45818
                            ],
                            [
                                31.31153,
                                54.34174
                            ],
                            [
                                31.32943,
                                54.24306
                            ],
                            [
                                31.52395,
                                54.15098
                            ],
                            [
                                31.67555,
                                54.10685
                            ],
                            [
                                31.756,
                                54.10454
                            ],
                            [
                                31.84593,
                                54.05972
                            ],
                            [
                                31.865,
                                54.0064
                            ],
                            [
                                31.82874,
                                53.88644
                            ],
                            [
                                31.76547,
                                53.80433
                            ],
                            [
                                31.89038,
                                53.77842
                            ],
                            [
                                32.12077,
                                53.81959
                            ],
                            [
                                32.45711,
                                53.72431
                            ],
                            [
                                32.50346,
                                53.68199
                            ],
                            [
                                32.42054,
                                53.64756
                            ],
                            [
                                32.47374,
                                53.55277
                            ],
                            [
                                32.74006,
                                53.45881
                            ],
                            [
                                32.72443,
                                53.36028
                            ],
                            [
                                32.61194,
                                53.31305
                            ],
                            [
                                32.29888,
                                53.13193
                            ],
                            [
                                32.11528,
                                53.08747
                            ],
                            [
                                31.91987,
                                53.09821
                            ],
                            [
                                31.80051,
                                53.13216
                            ],
                            [
                                31.77541,
                                53.19268
                            ],
                            [
                                31.62544,
                                53.21738
                            ],
                            [
                                31.42478,
                                53.20792
                            ],
                            [
                                31.38566,
                                53.10332
                            ],
                            [
                                31.26757,
                                53.0232
                            ],
                            [
                                31.38966,
                                52.91135
                            ],
                            [
                                31.53846,
                                52.8542
                            ],
                            [
                                31.59307,
                                52.73679
                            ],
                            [
                                31.50603,
                                52.68735
                            ],
                            [
                                31.58676,
                                52.59232
                            ],
                            [
                                31.62865,
                                52.3676
                            ],
                            [
                                31.59382,
                                52.31312
                            ],
                            [
                                31.78604,
                                52.15756
                            ],
                            [
                                31.78688,
                                52.11145
                            ],
                            [
                                31.93054,
                                52.0904
                            ],
                            [
                                31.96408,
                                52.0531
                            ],
                            [
                                32.09493,
                                52.03397
                            ],
                            [
                                32.28931,
                                52.1032
                            ],
                            [
                                32.39956,
                                52.24739
                            ],
                            [
                                32.35347,
                                52.31602
                            ],
                            [
                                32.55034,
                                52.3253
                            ],
                            [
                                32.7023,
                                52.25053
                            ],
                            [
                                32.88298,
                                52.27299
                            ],
                            [
                                32.90248,
                                52.24605
                            ],
                            [
                                33.08189,
                                52.30881
                            ],
                            [
                                33.17045,
                                52.37223
                            ],
                            [
                                33.34957,
                                52.35338
                            ],
                            [
                                33.51905,
                                52.35392
                            ],
                            [
                                33.55921,
                                52.30224
                            ],
                            [
                                33.68151,
                                52.35686
                            ],
                            [
                                33.83558,
                                52.36076
                            ],
                            [
                                33.93788,
                                52.24997
                            ],
                            [
                                34.05226,
                                52.20098
                            ],
                            [
                                34.1149,
                                52.14129
                            ],
                            [
                                34.0805,
                                52.07046
                            ],
                            [
                                34.14359,
                                51.96865
                            ],
                            [
                                34.41257,
                                51.82652
                            ],
                            [
                                34.4209,
                                51.72285
                            ],
                            [
                                34.21544,
                                51.70238
                            ],
                            [
                                34.16705,
                                51.6443
                            ],
                            [
                                34.30569,
                                51.51292
                            ],
                            [
                                34.2232,
                                51.4284
                            ],
                            [
                                34.33754,
                                51.35704
                            ],
                            [
                                34.23902,
                                51.29254
                            ],
                            [
                                34.30815,
                                51.23839
                            ],
                            [
                                34.38148,
                                51.27226
                            ],
                            [
                                34.57948,
                                51.23424
                            ],
                            [
                                34.81734,
                                51.16939
                            ],
                            [
                                34.9533,
                                51.22726
                            ],
                            [
                                35.1476,
                                51.22423
                            ],
                            [
                                35.12452,
                                51.16326
                            ],
                            [
                                35.2098,
                                51.04771
                            ],
                            [
                                35.30545,
                                51.07723
                            ],
                            [
                                35.40579,
                                51.02587
                            ],
                            [
                                35.33275,
                                50.9942
                            ],
                            [
                                35.39112,
                                50.92329
                            ],
                            [
                                35.41368,
                                50.80164
                            ],
                            [
                                35.48664,
                                50.77611
                            ],
                            [
                                35.45958,
                                50.66456
                            ],
                            [
                                35.40211,
                                50.65515
                            ],
                            [
                                35.39382,
                                50.57991
                            ],
                            [
                                35.47669,
                                50.48867
                            ],
                            [
                                35.5855,
                                50.44955
                            ],
                            [
                                35.62561,
                                50.3526
                            ],
                            [
                                35.73897,
                                50.35516
                            ],
                            [
                                35.83028,
                                50.43252
                            ],
                            [
                                36.06426,
                                50.45044
                            ],
                            [
                                36.15774,
                                50.43209
                            ],
                            [
                                36.28216,
                                50.33662
                            ],
                            [
                                36.29682,
                                50.29194
                            ],
                            [
                                36.48617,
                                50.31137
                            ],
                            [
                                36.64902,
                                50.21809
                            ],
                            [
                                36.68966,
                                50.26749
                            ],
                            [
                                36.93745,
                                50.35001
                            ],
                            [
                                37.10409,
                                50.35173
                            ],
                            [
                                37.29281,
                                50.40152
                            ],
                            [
                                37.35143,
                                50.43693
                            ],
                            [
                                37.46576,
                                50.43005
                            ],
                            [
                                37.52098,
                                50.33698
                            ],
                            [
                                37.63534,
                                50.31094
                            ],
                            [
                                37.61507,
                                50.21722
                            ],
                            [
                                37.75507,
                                50.07897
                            ],
                            [
                                37.92513,
                                50.03463
                            ],
                            [
                                37.96461,
                                49.97961
                            ],
                            [
                                38.0577,
                                49.92378
                            ],
                            [
                                38.16976,
                                49.94132
                            ],
                            [
                                38.22126,
                                49.979
                            ],
                            [
                                38.17913,
                                50.07931
                            ],
                            [
                                38.32975,
                                50.08346
                            ],
                            [
                                38.35315,
                                50.00555
                            ],
                            [
                                38.48835,
                                49.96403
                            ],
                            [
                                38.58208,
                                49.977
                            ],
                            [
                                38.83798,
                                49.86736
                            ],
                            [
                                38.90106,
                                49.86905
                            ],
                            [
                                38.94904,
                                49.79656
                            ],
                            [
                                39.06697,
                                49.81592
                            ],
                            [
                                39.1802,
                                49.88783
                            ],
                            [
                                39.28609,
                                49.75558
                            ],
                            [
                                39.37823,
                                49.73895
                            ],
                            [
                                39.4434,
                                49.75983
                            ],
                            [
                                39.59182,
                                49.71847
                            ],
                            [
                                39.65936,
                                49.61573
                            ],
                            [
                                39.80553,
                                49.55861
                            ],
                            [
                                39.89319,
                                49.55899
                            ],
                            [
                                39.95247,
                                49.59673
                            ],
                            [
                                40.13469,
                                49.61595
                            ],
                            [
                                40.16852,
                                49.56936
                            ],
                            [
                                40.03974,
                                49.52045
                            ],
                            [
                                40.03005,
                                49.45427
                            ],
                            [
                                40.1981,
                                49.34601
                            ],
                            [
                                40.18596,
                                49.2837
                            ],
                            [
                                40.0793,
                                49.18899
                            ],
                            [
                                40.03099,
                                49.17895
                            ],
                            [
                                39.93743,
                                49.05669
                            ],
                            [
                                39.69143,
                                49.04979
                            ],
                            [
                                39.66425,
                                49.00061
                            ],
                            [
                                39.75886,
                                48.97479
                            ],
                            [
                                39.78341,
                                48.91581
                            ],
                            [
                                39.8539,
                                48.89073
                            ],
                            [
                                40.05985,
                                48.9088
                            ],
                            [
                                40.07964,
                                48.87016
                            ],
                            [
                                39.97571,
                                48.79292
                            ],
                            [
                                39.80083,
                                48.84224
                            ],
                            [
                                39.72192,
                                48.68382
                            ],
                            [
                                39.661,
                                48.60928
                            ],
                            [
                                39.84626,
                                48.57039
                            ],
                            [
                                39.94253,
                                48.3465
                            ],
                            [
                                39.84898,
                                48.33361
                            ],
                            [
                                39.94207,
                                48.22867
                            ],
                            [
                                39.93684,
                                48.18072
                            ],
                            [
                                39.87164,
                                48.11628
                            ],
                            [
                                39.88311,
                                48.04177
                            ],
                            [
                                39.8145,
                                48.00133
                            ],
                            [
                                39.79463,
                                47.87056
                            ],
                            [
                                39.737,
                                47.82805
                            ],
                            [
                                39.52136,
                                47.8271
                            ],
                            [
                                39.47835,
                                47.85922
                            ],
                            [
                                39.24173,
                                47.86687
                            ],
                            [
                                39.14803,
                                47.8423
                            ],
                            [
                                39.07361,
                                47.86941
                            ],
                            [
                                38.88055,
                                47.87585
                            ],
                            [
                                38.78986,
                                47.81423
                            ],
                            [
                                38.77205,
                                47.68625
                            ],
                            [
                                38.66709,
                                47.69816
                            ],
                            [
                                38.60932,
                                47.64422
                            ],
                            [
                                38.45658,
                                47.64408
                            ],
                            [
                                38.35026,
                                47.61699
                            ],
                            [
                                38.28539,
                                47.54323
                            ],
                            [
                                38.30271,
                                47.39285
                            ],
                            [
                                38.22081,
                                47.30587
                            ],
                            [
                                38.33357,
                                47.30433
                            ],
                            [
                                38.32521,
                                47.25817
                            ],
                            [
                                38.23432,
                                47.22966
                            ],
                            [
                                38.23026,
                                47.11935
                            ],
                            [
                                38.43676,
                                47.1467
                            ],
                            [
                                38.54944,
                                47.11554
                            ],
                            [
                                38.94754,
                                47.20121
                            ],
                            [
                                38.94363,
                                47.24984
                            ],
                            [
                                39.09622,
                                47.28888
                            ],
                            [
                                39.23494,
                                47.2535
                            ],
                            [
                                39.22351,
                                47.19564
                            ],
                            [
                                39.3004,
                                47.02319
                            ],
                            [
                                39.08997,
                                47.03044
                            ],
                            [
                                38.85873,
                                46.91831
                            ],
                            [
                                38.72903,
                                46.87423
                            ],
                            [
                                38.58803,
                                46.85859
                            ],
                            [
                                38.50992,
                                46.87345
                            ],
                            [
                                38.42253,
                                46.81686
                            ],
                            [
                                38.39884,
                                46.75586
                            ],
                            [
                                38.52063,
                                46.74253
                            ],
                            [
                                38.58938,
                                46.70921
                            ],
                            [
                                38.58049,
                                46.65757
                            ],
                            [
                                38.48421,
                                46.63997
                            ],
                            [
                                38.35088,
                                46.66065
                            ],
                            [
                                38.23099,
                                46.70075
                            ],
                            [
                                38.13103,
                                46.68566
                            ],
                            [
                                38.03378,
                                46.6365
                            ],
                            [
                                37.90491,
                                46.63326
                            ],
                            [
                                37.74945,
                                46.66427
                            ],
                            [
                                37.87485,
                                46.44566
                            ],
                            [
                                37.97408,
                                46.36968
                            ],
                            [
                                38.01411,
                                46.40359
                            ],
                            [
                                38.10558,
                                46.39099
                            ],
                            [
                                38.28103,
                                46.26956
                            ],
                            [
                                38.23908,
                                46.16955
                            ],
                            [
                                38.18099,
                                46.11401
                            ],
                            [
                                38.14583,
                                46.00238
                            ],
                            [
                                38.07848,
                                46.05563
                            ],
                            [
                                37.97051,
                                46.02707
                            ],
                            [
                                37.92077,
                                45.97203
                            ],
                            [
                                37.85272,
                                45.78562
                            ],
                            [
                                37.7454,
                                45.71175
                            ],
                            [
                                37.62326,
                                45.67348
                            ],
                            [
                                37.59727,
                                45.6283
                            ],
                            [
                                37.59897,
                                45.487
                            ],
                            [
                                37.56765,
                                45.40156
                            ],
                            [
                                37.37209,
                                45.32404
                            ],
                            [
                                37.15072,
                                45.33913
                            ],
                            [
                                36.91272,
                                45.42734
                            ],
                            [
                                36.77704,
                                45.42741
                            ],
                            [
                                36.80292,
                                45.3032
                            ],
                            [
                                36.92525,
                                45.32326
                            ],
                            [
                                36.98585,
                                45.28282
                            ],
                            [
                                36.73781,
                                45.21409
                            ],
                            [
                                36.60882,
                                45.20713
                            ],
                            [
                                36.63059,
                                45.14168
                            ],
                            [
                                36.73823,
                                45.10848
                            ],
                            [
                                36.88601,
                                45.10445
                            ],
                            [
                                37.14152,
                                45.03163
                            ],
                            [
                                37.22358,
                                44.99589
                            ],
                            [
                                37.31526,
                                44.92077
                            ],
                            [
                                37.30274,
                                44.88748
                            ],
                            [
                                37.4553,
                                44.70842
                            ],
                            [
                                37.54866,
                                44.67562
                            ],
                            [
                                37.72873,
                                44.64766
                            ],
                            [
                                37.83705,
                                44.71712
                            ],
                            [
                                37.93227,
                                44.65184
                            ],
                            [
                                37.97401,
                                44.57667
                            ],
                            [
                                38.03227,
                                44.5652
                            ],
                            [
                                38.21531,
                                44.41096
                            ],
                            [
                                38.37131,
                                44.36659
                            ],
                            [
                                38.56509,
                                44.34687
                            ],
                            [
                                38.74495,
                                44.29675
                            ],
                            [
                                38.8869,
                                44.18598
                            ],
                            [
                                38.98814,
                                44.16052
                            ],
                            [
                                39.03771,
                                44.09918
                            ],
                            [
                                39.29436,
                                43.9429
                            ],
                            [
                                39.60784,
                                43.673
                            ],
                            [
                                39.68403,
                                43.63271
                            ],
                            [
                                39.73052,
                                43.56993
                            ],
                            [
                                39.87306,
                                43.49934
                            ],
                            [
                                39.91042,
                                43.43052
                            ],
                            [
                                40.0103,
                                43.38529
                            ],
                            [
                                40.1077,
                                43.56858
                            ],
                            [
                                40.25687,
                                43.58548
                            ],
                            [
                                40.47953,
                                43.54759
                            ],
                            [
                                40.56718,
                                43.52004
                            ],
                            [
                                40.66426,
                                43.56225
                            ],
                            [
                                40.69487,
                                43.5348
                            ],
                            [
                                40.87573,
                                43.48554
                            ],
                            [
                                40.95174,
                                43.41982
                            ],
                            [
                                41.04442,
                                43.39755
                            ],
                            [
                                41.15071,
                                43.40313
                            ],
                            [
                                41.2916,
                                43.33872
                            ],
                            [
                                41.36565,
                                43.36886
                            ],
                            [
                                41.42415,
                                43.31422
                            ],
                            [
                                41.62137,
                                43.22284
                            ],
                            [
                                41.72305,
                                43.23996
                            ],
                            [
                                41.80679,
                                43.20395
                            ],
                            [
                                41.86588,
                                43.24171
                            ],
                            [
                                42.09262,
                                43.21218
                            ],
                            [
                                42.21264,
                                43.22952
                            ],
                            [
                                42.25939,
                                43.21281
                            ],
                            [
                                42.44212,
                                43.25009
                            ],
                            [
                                42.45962,
                                43.21286
                            ],
                            [
                                42.67152,
                                43.1361
                            ],
                            [
                                42.68073,
                                43.17098
                            ],
                            [
                                42.85861,
                                43.17774
                            ],
                            [
                                42.99162,
                                43.11766
                            ],
                            [
                                43.03686,
                                43.02972
                            ],
                            [
                                43.18685,
                                42.93837
                            ],
                            [
                                43.56121,
                                42.86678
                            ],
                            [
                                43.61109,
                                42.81395
                            ],
                            [
                                43.77642,
                                42.75941
                            ],
                            [
                                43.80316,
                                42.71595
                            ],
                            [
                                43.71743,
                                42.63207
                            ],
                            [
                                43.76833,
                                42.59012
                            ],
                            [
                                43.83933,
                                42.59683
                            ],
                            [
                                43.96335,
                                42.54747
                            ],
                            [
                                44.00869,
                                42.58954
                            ],
                            [
                                44.22358,
                                42.63052
                            ],
                            [
                                44.31494,
                                42.72215
                            ],
                            [
                                44.41877,
                                42.71908
                            ],
                            [
                                44.67879,
                                42.75624
                            ],
                            [
                                44.75004,
                                42.71644
                            ],
                            [
                                44.7669,
                                42.64294
                            ],
                            [
                                44.85711,
                                42.67837
                            ],
                            [
                                44.88739,
                                42.74622
                            ],
                            [
                                44.98003,
                                42.74434
                            ],
                            [
                                45.03691,
                                42.6932
                            ],
                            [
                                45.15924,
                                42.70729
                            ],
                            [
                                45.28345,
                                42.60611
                            ],
                            [
                                45.35386,
                                42.52243
                            ],
                            [
                                45.40482,
                                42.54892
                            ],
                            [
                                45.57242,
                                42.54791
                            ],
                            [
                                45.68543,
                                42.50588
                            ],
                            [
                                45.78073,
                                42.44807
                            ],
                            [
                                45.73561,
                                42.37765
                            ],
                            [
                                45.75163,
                                42.30773
                            ],
                            [
                                45.65075,
                                42.29091
                            ],
                            [
                                45.60948,
                                42.21144
                            ],
                            [
                                45.74561,
                                42.14865
                            ],
                            [
                                45.78548,
                                42.10268
                            ],
                            [
                                45.89759,
                                42.10518
                            ],
                            [
                                46.10761,
                                41.98709
                            ],
                            [
                                46.22633,
                                42.01471
                            ],
                            [
                                46.28671,
                                41.94491
                            ],
                            [
                                46.39798,
                                41.94031
                            ],
                            [
                                46.4205,
                                41.90428
                            ],
                            [
                                46.53991,
                                41.87105
                            ],
                            [
                                46.57972,
                                41.80755
                            ],
                            [
                                46.76165,
                                41.85155
                            ],
                            [
                                46.78226,
                                41.78459
                            ],
                            [
                                46.8953,
                                41.73132
                            ],
                            [
                                47.00948,
                                41.55705
                            ],
                            [
                                47.1001,
                                41.58659
                            ],
                            [
                                47.2269,
                                41.44189
                            ],
                            [
                                47.26188,
                                41.32741
                            ],
                            [
                                47.40423,
                                41.26661
                            ],
                            [
                                47.48402,
                                41.26635
                            ],
                            [
                                47.53703,
                                41.20719
                            ],
                            [
                                47.61257,
                                41.23556
                            ],
                            [
                                47.71969,
                                41.19793
                            ],
                            [
                                47.89229,
                                41.2268
                            ],
                            [
                                47.94188,
                                41.36107
                            ],
                            [
                                47.98712,
                                41.38755
                            ],
                            [
                                48.05414,
                                41.49169
                            ],
                            [
                                48.19196,
                                41.50316
                            ],
                            [
                                48.402,
                                41.61279
                            ],
                            [
                                48.42476,
                                41.66015
                            ],
                            [
                                48.55571,
                                41.78287
                            ],
                            [
                                48.58352,
                                41.83464
                            ],
                            [
                                48.54933,
                                41.87508
                            ],
                            [
                                48.40831,
                                41.90764
                            ],
                            [
                                48.36487,
                                41.95308
                            ],
                            [
                                48.30368,
                                42.09492
                            ],
                            [
                                48.23003,
                                42.15662
                            ],
                            [
                                48.11636,
                                42.32561
                            ],
                            [
                                47.94615,
                                42.45921
                            ],
                            [
                                47.88654,
                                42.56005
                            ],
                            [
                                47.83221,
                                42.60557
                            ],
                            [
                                47.72926,
                                42.64605
                            ],
                            [
                                47.70631,
                                42.71044
                            ],
                            [
                                47.70247,
                                42.85544
                            ],
                            [
                                47.54162,
                                42.94896
                            ],
                            [
                                47.4647,
                                43.01305
                            ],
                            [
                                47.45436,
                                43.08495
                            ],
                            [
                                47.4909,
                                43.21967
                            ],
                            [
                                47.48388,
                                43.43297
                            ],
                            [
                                47.52463,
                                43.51164
                            ],
                            [
                                47.53246,
                                43.59491
                            ],
                            [
                                47.63248,
                                43.80876
                            ],
                            [
                                47.69628,
                                43.86764
                            ],
                            [
                                47.60737,
                                43.89765
                            ],
                            [
                                47.53666,
                                43.84708
                            ],
                            [
                                47.50763,
                                43.68012
                            ],
                            [
                                47.47285,
                                43.62949
                            ],
                            [
                                47.46162,
                                43.52736
                            ],
                            [
                                47.3635,
                                43.5889
                            ],
                            [
                                47.45111,
                                43.68046
                            ],
                            [
                                47.44075,
                                43.73693
                            ],
                            [
                                47.50106,
                                43.76839
                            ],
                            [
                                47.46066,
                                43.85424
                            ],
                            [
                                47.34995,
                                44.02456
                            ],
                            [
                                47.29009,
                                44.08568
                            ],
                            [
                                47.24094,
                                44.2176
                            ],
                            [
                                47.1522,
                                44.20143
                            ],
                            [
                                47.08104,
                                44.25278
                            ],
                            [
                                47.03204,
                                44.34989
                            ],
                            [
                                46.83949,
                                44.39348
                            ],
                            [
                                46.76173,
                                44.39019
                            ],
                            [
                                46.7019,
                                44.43809
                            ],
                            [
                                46.68158,
                                44.50141
                            ],
                            [
                                46.76422,
                                44.68121
                            ],
                            [
                                46.96005,
                                44.76448
                            ],
                            [
                                47.00906,
                                44.82177
                            ],
                            [
                                47.07544,
                                44.78356
                            ],
                            [
                                47.11574,
                                44.8622
                            ],
                            [
                                47.09893,
                                44.94802
                            ],
                            [
                                47.19591,
                                44.96711
                            ],
                            [
                                47.29499,
                                45.18013
                            ],
                            [
                                47.36261,
                                45.17697
                            ],
                            [
                                47.37826,
                                45.27301
                            ],
                            [
                                47.50214,
                                45.47718
                            ],
                            [
                                47.56894,
                                45.55712
                            ],
                            [
                                47.6244,
                                45.70672
                            ],
                            [
                                47.76692,
                                45.67405
                            ],
                            [
                                47.94173,
                                45.72055
                            ],
                            [
                                48.00406,
                                45.70187
                            ],
                            [
                                48.06273,
                                45.74155
                            ],
                            [
                                48.1841,
                                45.73479
                            ],
                            [
                                48.26956,
                                45.77185
                            ],
                            [
                                48.2886,
                                45.83028
                            ],
                            [
                                48.46084,
                                45.93385
                            ],
                            [
                                48.59199,
                                45.95506
                            ],
                            [
                                48.68455,
                                45.86462
                            ],
                            [
                                48.74853,
                                45.83924
                            ],
                            [
                                48.75788,
                                45.93691
                            ],
                            [
                                48.69962,
                                45.98357
                            ],
                            [
                                48.71728,
                                46.12626
                            ],
                            [
                                48.82695,
                                46.05414
                            ],
                            [
                                48.95332,
                                46.09454
                            ],
                            [
                                48.93687,
                                46.13677
                            ],
                            [
                                49.03878,
                                46.1924
                            ],
                            [
                                49.12292,
                                46.1603
                            ],
                            [
                                49.11868,
                                46.29779
                            ],
                            [
                                49.23013,
                                46.26793
                            ],
                            [
                                49.21362,
                                46.33324
                            ],
                            [
                                49.14863,
                                46.3701
                            ],
                            [
                                48.82236,
                                46.47751
                            ],
                            [
                                48.7751,
                                46.53522
                            ],
                            [
                                48.67087,
                                46.56377
                            ],
                            [
                                48.64114,
                                46.60686
                            ],
                            [
                                48.56039,
                                46.60849
                            ],
                            [
                                48.48107,
                                46.65835
                            ],
                            [
                                48.51008,
                                46.73144
                            ],
                            [
                                48.58226,
                                46.77387
                            ],
                            [
                                48.65804,
                                46.77059
                            ],
                            [
                                48.75044,
                                46.68869
                            ],
                            [
                                48.91443,
                                46.69364
                            ],
                            [
                                49.00487,
                                46.76645
                            ],
                            [
                                48.97074,
                                46.83517
                            ],
                            [
                                48.78232,
                                47.01004
                            ],
                            [
                                48.66181,
                                47.2084
                            ],
                            [
                                48.60749,
                                47.41357
                            ],
                            [
                                48.38094,
                                47.4345
                            ],
                            [
                                48.27824,
                                47.54552
                            ],
                            [
                                48.1841,
                                47.67579
                            ],
                            [
                                48.05556,
                                47.76089
                            ],
                            [
                                47.66299,
                                47.74834
                            ],
                            [
                                47.40734,
                                47.80957
                            ],
                            [
                                47.37532,
                                47.67772
                            ],
                            [
                                47.19697,
                                47.74892
                            ],
                            [
                                47.11889,
                                47.81343
                            ],
                            [
                                47.15898,
                                47.83939
                            ],
                            [
                                47.01932,
                                47.99795
                            ],
                            [
                                47.13607,
                                48.03911
                            ],
                            [
                                47.09632,
                                48.10713
                            ],
                            [
                                47.09613,
                                48.21131
                            ],
                            [
                                47.0369,
                                48.23016
                            ],
                            [
                                46.92931,
                                48.32098
                            ],
                            [
                                46.80059,
                                48.34895
                            ],
                            [
                                46.49334,
                                48.444
                            ],
                            [
                                46.6005,
                                48.64528
                            ],
                            [
                                46.77661,
                                48.93558
                            ],
                            [
                                46.93721,
                                49.00399
                            ],
                            [
                                47.00334,
                                49.06047
                            ],
                            [
                                47.05208,
                                49.16498
                            ],
                            [
                                47.02154,
                                49.20832
                            ],
                            [
                                46.78406,
                                49.33305
                            ],
                            [
                                46.8193,
                                49.55403
                            ],
                            [
                                46.85942,
                                49.6093
                            ],
                            [
                                46.89359,
                                49.83964
                            ],
                            [
                                47.16204,
                                49.92633
                            ],
                            [
                                47.26516,
                                50.00674
                            ],
                            [
                                47.33706,
                                50.10185
                            ],
                            [
                                47.26234,
                                50.19905
                            ],
                            [
                                47.32017,
                                50.33075
                            ],
                            [
                                47.40534,
                                50.33923
                            ],
                            [
                                47.44435,
                                50.41561
                            ],
                            [
                                47.5519,
                                50.46202
                            ],
                            [
                                47.74064,
                                50.38024
                            ],
                            [
                                47.81544,
                                50.33051
                            ],
                            [
                                47.98417,
                                50.17669
                            ],
                            [
                                48.09645,
                                50.08998
                            ],
                            [
                                48.13051,
                                49.99506
                            ],
                            [
                                48.21639,
                                49.90959
                            ],
                            [
                                48.34795,
                                49.83179
                            ],
                            [
                                48.4407,
                                49.83981
                            ],
                            [
                                48.73609,
                                49.92811
                            ],
                            [
                                48.86284,
                                50.00779
                            ],
                            [
                                48.84943,
                                50.08475
                            ],
                            [
                                48.75755,
                                50.10909
                            ],
                            [
                                48.77802,
                                50.18059
                            ],
                            [
                                48.71766,
                                50.25595
                            ],
                            [
                                48.63726,
                                50.53954
                            ],
                            [
                                48.70015,
                                50.62393
                            ],
                            [
                                48.82578,
                                50.60217
                            ],
                            [
                                48.94145,
                                50.66125
                            ],
                            [
                                49.0984,
                                50.78567
                            ],
                            [
                                49.42046,
                                50.87723
                            ],
                            [
                                49.32832,
                                50.98748
                            ],
                            [
                                49.42068,
                                51.12759
                            ],
                            [
                                49.50907,
                                51.10868
                            ],
                            [
                                49.59647,
                                51.12421
                            ],
                            [
                                49.73639,
                                51.11556
                            ],
                            [
                                49.95785,
                                51.24179
                            ],
                            [
                                50.22407,
                                51.29548
                            ],
                            [
                                50.36632,
                                51.34077
                            ],
                            [
                                50.36703,
                                51.4365
                            ],
                            [
                                50.45645,
                                51.43923
                            ],
                            [
                                50.51053,
                                51.47702
                            ],
                            [
                                50.51634,
                                51.60121
                            ],
                            [
                                50.56695,
                                51.64056
                            ],
                            [
                                50.7145,
                                51.62733
                            ],
                            [
                                50.74272,
                                51.76268
                            ],
                            [
                                50.86089,
                                51.73904
                            ],
                            [
                                50.89105,
                                51.68113
                            ],
                            [
                                51.06414,
                                51.66866
                            ],
                            [
                                51.26248,
                                51.68918
                            ],
                            [
                                51.35573,
                                51.6529
                            ],
                            [
                                51.36414,
                                51.57975
                            ],
                            [
                                51.2542,
                                51.56166
                            ],
                            [
                                51.27819,
                                51.49995
                            ],
                            [
                                51.43564,
                                51.48477
                            ],
                            [
                                51.55998,
                                51.56069
                            ],
                            [
                                51.6424,
                                51.51764
                            ],
                            [
                                51.64797,
                                51.46943
                            ],
                            [
                                51.78389,
                                51.51695
                            ],
                            [
                                51.7586,
                                51.59528
                            ],
                            [
                                51.85569,
                                51.68129
                            ],
                            [
                                52.02839,
                                51.65282
                            ],
                            [
                                52.1398,
                                51.66804
                            ],
                            [
                                52.17583,
                                51.71942
                            ],
                            [
                                52.36714,
                                51.7397
                            ],
                            [
                                52.3851,
                                51.65492
                            ],
                            [
                                52.5016,
                                51.54913
                            ],
                            [
                                52.55056,
                                51.46548
                            ],
                            [
                                52.63041,
                                51.45712
                            ],
                            [
                                52.7716,
                                51.51524
                            ],
                            [
                                52.91534,
                                51.49647
                            ],
                            [
                                52.9548,
                                51.46345
                            ],
                            [
                                53.14688,
                                51.51332
                            ],
                            [
                                53.29381,
                                51.48815
                            ],
                            [
                                53.37397,
                                51.51475
                            ],
                            [
                                53.45022,
                                51.46416
                            ],
                            [
                                53.57385,
                                51.42957
                            ],
                            [
                                53.63829,
                                51.37875
                            ],
                            [
                                53.6117,
                                51.31948
                            ],
                            [
                                53.67496,
                                51.22943
                            ],
                            [
                                53.75173,
                                51.20538
                            ],
                            [
                                53.89974,
                                51.20042
                            ],
                            [
                                54.12725,
                                51.11933
                            ],
                            [
                                54.16811,
                                51.0208
                            ],
                            [
                                54.32262,
                                50.87812
                            ],
                            [
                                54.44646,
                                50.871
                            ],
                            [
                                54.51485,
                                50.82996
                            ],
                            [
                                54.4532,
                                50.73703
                            ],
                            [
                                54.42544,
                                50.62088
                            ],
                            [
                                54.51351,
                                50.53986
                            ],
                            [
                                54.62665,
                                50.55276
                            ],
                            [
                                54.72646,
                                50.63078
                            ],
                            [
                                54.65615,
                                50.8072
                            ],
                            [
                                54.70762,
                                50.89221
                            ],
                            [
                                54.90149,
                                50.86419
                            ],
                            [
                                55.08291,
                                50.91999
                            ],
                            [
                                55.0678,
                                50.82175
                            ],
                            [
                                55.35566,
                                50.66045
                            ],
                            [
                                55.49956,
                                50.64711
                            ],
                            [
                                55.66248,
                                50.5732
                            ],
                            [
                                55.81404,
                                50.63824
                            ],
                            [
                                55.96931,
                                50.68377
                            ],
                            [
                                56.1378,
                                50.77183
                            ],
                            [
                                56.17334,
                                50.91684
                            ],
                            [
                                56.38251,
                                50.92566
                            ],
                            [
                                56.47739,
                                50.98096
                            ],
                            [
                                56.53901,
                                51.04731
                            ],
                            [
                                56.63513,
                                50.99103
                            ],
                            [
                                56.73062,
                                50.97243
                            ],
                            [
                                56.72308,
                                51.07265
                            ],
                            [
                                56.80761,
                                51.08372
                            ],
                            [
                                56.90019,
                                51.05394
                            ],
                            [
                                57.05386,
                                51.05716
                            ],
                            [
                                57.18488,
                                51.09424
                            ],
                            [
                                57.29429,
                                51.01382
                            ],
                            [
                                57.32058,
                                50.95433
                            ],
                            [
                                57.4407,
                                50.89074
                            ],
                            [
                                57.65242,
                                50.94297
                            ],
                            [
                                57.73186,
                                50.93268
                            ],
                            [
                                57.75433,
                                51.12738
                            ],
                            [
                                57.81761,
                                51.1391
                            ],
                            [
                                58.00058,
                                51.08463
                            ],
                            [
                                58.08892,
                                51.12531
                            ],
                            [
                                58.17664,
                                51.06837
                            ],
                            [
                                58.21554,
                                51.13198
                            ],
                            [
                                58.32517,
                                51.15244
                            ],
                            [
                                58.35725,
                                51.0915
                            ],
                            [
                                58.54266,
                                51.07517
                            ],
                            [
                                58.59794,
                                51.02409
                            ],
                            [
                                58.56687,
                                50.93943
                            ],
                            [
                                58.59111,
                                50.8369
                            ],
                            [
                                58.65393,
                                50.81621
                            ],
                            [
                                58.78732,
                                50.82998
                            ],
                            [
                                58.79712,
                                50.76659
                            ],
                            [
                                58.94105,
                                50.69439
                            ],
                            [
                                59.10308,
                                50.68479
                            ],
                            [
                                59.39024,
                                50.64838
                            ],
                            [
                                59.48559,
                                50.65486
                            ],
                            [
                                59.53633,
                                50.6113
                            ],
                            [
                                59.51833,
                                50.52424
                            ],
                            [
                                59.83142,
                                50.5837
                            ],
                            [
                                59.93468,
                                50.70703
                            ],
                            [
                                60.00373,
                                50.82881
                            ],
                            [
                                60.06936,
                                50.86543
                            ],
                            [
                                60.19124,
                                50.83514
                            ],
                            [
                                60.19487,
                                50.78932
                            ],
                            [
                                60.34761,
                                50.68094
                            ],
                            [
                                60.5841,
                                50.6645
                            ],
                            [
                                60.82785,
                                50.66117
                            ],
                            [
                                61.00955,
                                50.68657
                            ],
                            [
                                61.3566,
                                50.77334
                            ],
                            [
                                61.45035,
                                50.80728
                            ],
                            [
                                61.57971,
                                51.23134
                            ],
                            [
                                61.67621,
                                51.26487
                            ],
                            [
                                61.55262,
                                51.34082
                            ],
                            [
                                61.50968,
                                51.41456
                            ],
                            [
                                61.28912,
                                51.41019
                            ],
                            [
                                61.18005,
                                51.45642
                            ],
                            [
                                61.00366,
                                51.4655
                            ],
                            [
                                60.96255,
                                51.49735
                            ],
                            [
                                60.90352,
                                51.61412
                            ],
                            [
                                60.60301,
                                51.61491
                            ],
                            [
                                60.49085,
                                51.6389
                            ],
                            [
                                60.39436,
                                51.70285
                            ],
                            [
                                60.52252,
                                51.78318
                            ],
                            [
                                60.40309,
                                51.81384
                            ],
                            [
                                60.18158,
                                51.9031
                            ],
                            [
                                60.06043,
                                51.91899
                            ],
                            [
                                60.08439,
                                51.99476
                            ],
                            [
                                60.2268,
                                52.00032
                            ],
                            [
                                60.32438,
                                52.0393
                            ],
                            [
                                60.49282,
                                52.14994
                            ],
                            [
                                60.55649,
                                52.16847
                            ],
                            [
                                60.72205,
                                52.16876
                            ],
                            [
                                60.79515,
                                52.23072
                            ],
                            [
                                60.96251,
                                52.27307
                            ],
                            [
                                61.07106,
                                52.3373
                            ],
                            [
                                60.96563,
                                52.50591
                            ],
                            [
                                60.8435,
                                52.52667
                            ],
                            [
                                60.84112,
                                52.61753
                            ],
                            [
                                60.7147,
                                52.65541
                            ],
                            [
                                60.71701,
                                52.74026
                            ],
                            [
                                60.8247,
                                52.76241
                            ],
                            [
                                60.89714,
                                52.81847
                            ],
                            [
                                61.07237,
                                52.91081
                            ],
                            [
                                61.11524,
                                52.97061
                            ],
                            [
                                61.23724,
                                53.03149
                            ],
                            [
                                61.37368,
                                52.98707
                            ],
                            [
                                61.45381,
                                53.03241
                            ],
                            [
                                61.5365,
                                53.01827
                            ],
                            [
                                61.64488,
                                52.9625
                            ],
                            [
                                61.71465,
                                52.99656
                            ],
                            [
                                61.89421,
                                53.00938
                            ],
                            [
                                62.0067,
                                52.95176
                            ],
                            [
                                62.13703,
                                53.00658
                            ],
                            [
                                62.11008,
                                53.11662
                            ],
                            [
                                61.94635,
                                53.12924
                            ],
                            [
                                61.8005,
                                53.16054
                            ],
                            [
                                61.66847,
                                53.25138
                            ],
                            [
                                61.60898,
                                53.21531
                            ],
                            [
                                61.4633,
                                53.22403
                            ],
                            [
                                61.39437,
                                53.26725
                            ],
                            [
                                61.24406,
                                53.27298
                            ],
                            [
                                61.17279,
                                53.30512
                            ],
                            [
                                61.16188,
                                53.39254
                            ],
                            [
                                61.23453,
                                53.43733
                            ],
                            [
                                61.2555,
                                53.50193
                            ],
                            [
                                61.48258,
                                53.46179
                            ],
                            [
                                61.58527,
                                53.50545
                            ],
                            [
                                61.55551,
                                53.57486
                            ],
                            [
                                61.4328,
                                53.5918
                            ],
                            [
                                61.35492,
                                53.55941
                            ],
                            [
                                61.17276,
                                53.56802
                            ],
                            [
                                61.11081,
                                53.59751
                            ],
                            [
                                60.91651,
                                53.61695
                            ],
                            [
                                61.1104,
                                53.71626
                            ],
                            [
                                61.21825,
                                53.81546
                            ],
                            [
                                61.13466,
                                53.88134
                            ],
                            [
                                60.98944,
                                53.89795
                            ],
                            [
                                61.03561,
                                53.95382
                            ],
                            [
                                61.27503,
                                53.98493
                            ],
                            [
                                61.2565,
                                54.03403
                            ],
                            [
                                61.33194,
                                54.07954
                            ],
                            [
                                61.46096,
                                54.08353
                            ],
                            [
                                61.49565,
                                54.01966
                            ],
                            [
                                61.5801,
                                53.9959
                            ],
                            [
                                61.73711,
                                54.0287
                            ],
                            [
                                61.79455,
                                53.98461
                            ],
                            [
                                61.95287,
                                53.94582
                            ],
                            [
                                62.04111,
                                53.97225
                            ],
                            [
                                62.00406,
                                54.0294
                            ],
                            [
                                62.08841,
                                54.05744
                            ],
                            [
                                62.19813,
                                54.03308
                            ],
                            [
                                62.34014,
                                54.0353
                            ],
                            [
                                62.45558,
                                53.92567
                            ],
                            [
                                62.5317,
                                53.90051
                            ],
                            [
                                62.59232,
                                53.98321
                            ],
                            [
                                62.80128,
                                54.08213
                            ],
                            [
                                62.82315,
                                54.11618
                            ],
                            [
                                63.06049,
                                54.1006
                            ],
                            [
                                63.16154,
                                54.12724
                            ],
                            [
                                63.16952,
                                54.19245
                            ],
                            [
                                63.51706,
                                54.20621
                            ],
                            [
                                63.88097,
                                54.2855
                            ],
                            [
                                64.02991,
                                54.28177
                            ],
                            [
                                64.07977,
                                54.31736
                            ],
                            [
                                64.18701,
                                54.30799
                            ],
                            [
                                64.45815,
                                54.3365
                            ],
                            [
                                64.62146,
                                54.39513
                            ],
                            [
                                64.74246,
                                54.40408
                            ],
                            [
                                64.81213,
                                54.36763
                            ],
                            [
                                64.98038,
                                54.41843
                            ],
                            [
                                65.12437,
                                54.3381
                            ],
                            [
                                65.23991,
                                54.36686
                            ],
                            [
                                65.19059,
                                54.45789
                            ],
                            [
                                65.20273,
                                54.52557
                            ],
                            [
                                65.35309,
                                54.57996
                            ],
                            [
                                65.4563,
                                54.56959
                            ],
                            [
                                65.50366,
                                54.65056
                            ],
                            [
                                65.72958,
                                54.60557
                            ],
                            [
                                65.8027,
                                54.62922
                            ],
                            [
                                65.83903,
                                54.69249
                            ],
                            [
                                65.96319,
                                54.70876
                            ],
                            [
                                65.95338,
                                54.63069
                            ],
                            [
                                66.01834,
                                54.61814
                            ],
                            [
                                66.34788,
                                54.6894
                            ],
                            [
                                66.77979,
                                54.75895
                            ],
                            [
                                67.27864,
                                54.82068
                            ],
                            [
                                67.302,
                                54.85889
                            ],
                            [
                                67.55107,
                                54.8388
                            ],
                            [
                                67.76838,
                                54.887
                            ],
                            [
                                67.7929,
                                54.94042
                            ],
                            [
                                67.88617,
                                54.97825
                            ],
                            [
                                68.00651,
                                54.94568
                            ],
                            [
                                68.19642,
                                54.95779
                            ],
                            [
                                68.28253,
                                55.06331
                            ],
                            [
                                68.17889,
                                55.18094
                            ],
                            [
                                68.29377,
                                55.19687
                            ],
                            [
                                68.61722,
                                55.18985
                            ],
                            [
                                68.74671,
                                55.35424
                            ],
                            [
                                68.85149,
                                55.34097
                            ],
                            [
                                68.97304,
                                55.29257
                            ],
                            [
                                68.93876,
                                55.42893
                            ],
                            [
                                69.05386,
                                55.41958
                            ],
                            [
                                69.19514,
                                55.33608
                            ],
                            [
                                69.33015,
                                55.36232
                            ],
                            [
                                69.48657,
                                55.34175
                            ],
                            [
                                69.66581,
                                55.34299
                            ],
                            [
                                69.83047,
                                55.30241
                            ],
                            [
                                69.91844,
                                55.21755
                            ],
                            [
                                70.05088,
                                55.18747
                            ],
                            [
                                70.13025,
                                55.14056
                            ],
                            [
                                70.23614,
                                55.13927
                            ],
                            [
                                70.41172,
                                55.21026
                            ],
                            [
                                70.45941,
                                55.2755
                            ],
                            [
                                70.57756,
                                55.25863
                            ],
                            [
                                70.81911,
                                55.2976
                            ],
                            [
                                70.83094,
                                55.25741
                            ],
                            [
                                71.01481,
                                55.07257
                            ],
                            [
                                71.00177,
                                54.8769
                            ],
                            [
                                71.05091,
                                54.7913
                            ],
                            [
                                71.13627,
                                54.70887
                            ],
                            [
                                71.29507,
                                54.66605
                            ],
                            [
                                71.29334,
                                54.61444
                            ],
                            [
                                71.20739,
                                54.59488
                            ],
                            [
                                71.18855,
                                54.54021
                            ],
                            [
                                71.23188,
                                54.3918
                            ],
                            [
                                71.19006,
                                54.31945
                            ],
                            [
                                71.02931,
                                54.34793
                            ],
                            [
                                71.01563,
                                54.30522
                            ],
                            [
                                71.10978,
                                54.25242
                            ],
                            [
                                71.07442,
                                54.21667
                            ],
                            [
                                71.20975,
                                54.1111
                            ],
                            [
                                71.35265,
                                54.18323
                            ],
                            [
                                71.49008,
                                54.15936
                            ],
                            [
                                71.51466,
                                54.10957
                            ],
                            [
                                71.65615,
                                54.10344
                            ],
                            [
                                71.73793,
                                54.12946
                            ],
                            [
                                71.72623,
                                54.19506
                            ],
                            [
                                71.77112,
                                54.2481
                            ],
                            [
                                72.00461,
                                54.2267
                            ],
                            [
                                72.09681,
                                54.15451
                            ],
                            [
                                72.19332,
                                54.18574
                            ],
                            [
                                72.08333,
                                54.23718
                            ],
                            [
                                72.12569,
                                54.28995
                            ],
                            [
                                72.06347,
                                54.36395
                            ],
                            [
                                72.17754,
                                54.35833
                            ],
                            [
                                72.26346,
                                54.31886
                            ],
                            [
                                72.29988,
                                54.19781
                            ],
                            [
                                72.40043,
                                54.1542
                            ],
                            [
                                72.37079,
                                54.10428
                            ],
                            [
                                72.4192,
                                54.03949
                            ],
                            [
                                72.37931,
                                53.95264
                            ],
                            [
                                72.4943,
                                53.91557
                            ],
                            [
                                72.5546,
                                53.98847
                            ],
                            [
                                72.72136,
                                53.95141
                            ],
                            [
                                72.66259,
                                54.04726
                            ],
                            [
                                72.52117,
                                54.0486
                            ],
                            [
                                72.60372,
                                54.1336
                            ],
                            [
                                72.97747,
                                54.09855
                            ],
                            [
                                73.08739,
                                53.9903
                            ],
                            [
                                73.29425,
                                53.95324
                            ],
                            [
                                73.50859,
                                53.95275
                            ],
                            [
                                73.51205,
                                54.00453
                            ],
                            [
                                73.68868,
                                54.07101
                            ],
                            [
                                73.74799,
                                54.05387
                            ],
                            [
                                73.69084,
                                53.86345
                            ],
                            [
                                73.46429,
                                53.88132
                            ],
                            [
                                73.45362,
                                53.81338
                            ],
                            [
                                73.34925,
                                53.79383
                            ],
                            [
                                73.32889,
                                53.6886
                            ],
                            [
                                73.24782,
                                53.57386
                            ],
                            [
                                73.40017,
                                53.53086
                            ],
                            [
                                73.38109,
                                53.47659
                            ],
                            [
                                73.44715,
                                53.44602
                            ],
                            [
                                73.6494,
                                53.56097
                            ],
                            [
                                73.6762,
                                53.62342
                            ],
                            [
                                73.8337,
                                53.5874
                            ],
                            [
                                73.89193,
                                53.63969
                            ],
                            [
                                74.07225,
                                53.62527
                            ],
                            [
                                74.06836,
                                53.55592
                            ],
                            [
                                74.26794,
                                53.56255
                            ],
                            [
                                74.28324,
                                53.48908
                            ],
                            [
                                74.40359,
                                53.46226
                            ],
                            [
                                74.48412,
                                53.57996
                            ],
                            [
                                74.44268,
                                53.59638
                            ],
                            [
                                74.47273,
                                53.68251
                            ],
                            [
                                74.64204,
                                53.66821
                            ],
                            [
                                74.68621,
                                53.75523
                            ],
                            [
                                74.77889,
                                53.76593
                            ],
                            [
                                74.80241,
                                53.81361
                            ],
                            [
                                74.93819,
                                53.81534
                            ],
                            [
                                75.03888,
                                53.79114
                            ],
                            [
                                75.21833,
                                53.8797
                            ],
                            [
                                75.4533,
                                53.96937
                            ],
                            [
                                75.48217,
                                54.01001
                            ],
                            [
                                75.40047,
                                54.08297
                            ],
                            [
                                75.5288,
                                54.12166
                            ],
                            [
                                75.6135,
                                54.10667
                            ],
                            [
                                76.22511,
                                54.27377
                            ],
                            [
                                76.23315,
                                54.35412
                            ],
                            [
                                76.3289,
                                54.33323
                            ],
                            [
                                76.50377,
                                54.32694
                            ],
                            [
                                76.65145,
                                54.34655
                            ],
                            [
                                76.7467,
                                54.41968
                            ],
                            [
                                76.91131,
                                54.45742
                            ],
                            [
                                76.93243,
                                54.42569
                            ],
                            [
                                76.86207,
                                54.35226
                            ],
                            [
                                76.84192,
                                54.23433
                            ],
                            [
                                76.74757,
                                54.16015
                            ],
                            [
                                76.65223,
                                54.12648
                            ],
                            [
                                76.44049,
                                54.1723
                            ],
                            [
                                76.43088,
                                54.13245
                            ],
                            [
                                76.58235,
                                53.96877
                            ],
                            [
                                76.76111,
                                53.86965
                            ],
                            [
                                77.56995,
                                53.48111
                            ],
                            [
                                77.90886,
                                53.2804
                            ],
                            [
                                78.25047,
                                52.95348
                            ],
                            [
                                78.62473,
                                52.54558
                            ],
                            [
                                78.89338,
                                52.25645
                            ],
                            [
                                79.21626,
                                51.88191
                            ],
                            [
                                79.70403,
                                51.24697
                            ],
                            [
                                79.9691,
                                50.89039
                            ],
                            [
                                80.09443,
                                50.83165
                            ],
                            [
                                80.19113,
                                50.83207
                            ],
                            [
                                80.19884,
                                50.90515
                            ],
                            [
                                80.37596,
                                50.93643
                            ],
                            [
                                80.46801,
                                50.97497
                            ],
                            [
                                80.47379,
                                51.10128
                            ],
                            [
                                80.44152,
                                51.20607
                            ],
                            [
                                80.62261,
                                51.20754
                            ],
                            [
                                80.67079,
                                51.30757
                            ],
                            [
                                80.9212,
                                51.254
                            ],
                            [
                                80.93005,
                                51.21682
                            ],
                            [
                                81.07468,
                                51.17322
                            ],
                            [
                                81.15763,
                                51.18671
                            ],
                            [
                                81.13627,
                                51.0861
                            ],
                            [
                                81.09007,
                                51.03944
                            ],
                            [
                                81.07421,
                                50.94662
                            ],
                            [
                                81.172,
                                50.9438
                            ],
                            [
                                81.40346,
                                50.98186
                            ],
                            [
                                81.4772,
                                50.81781
                            ],
                            [
                                81.4541,
                                50.76144
                            ],
                            [
                                81.59898,
                                50.75339
                            ],
                            [
                                81.75941,
                                50.77174
                            ],
                            [
                                81.88327,
                                50.81056
                            ],
                            [
                                82.00529,
                                50.79975
                            ],
                            [
                                82.14097,
                                50.74098
                            ],
                            [
                                82.28291,
                                50.77543
                            ],
                            [
                                82.57034,
                                50.75988
                            ],
                            [
                                82.72214,
                                50.84344
                            ],
                            [
                                82.76696,
                                50.93705
                            ],
                            [
                                82.98891,
                                50.90076
                            ],
                            [
                                83.11353,
                                50.99064
                            ],
                            [
                                83.29401,
                                51.01406
                            ],
                            [
                                83.49029,
                                50.95616
                            ],
                            [
                                83.5825,
                                50.9502
                            ],
                            [
                                83.69308,
                                50.90124
                            ],
                            [
                                83.83457,
                                50.87298
                            ],
                            [
                                83.9623,
                                50.78124
                            ],
                            [
                                83.97996,
                                50.71994
                            ],
                            [
                                84.21802,
                                50.53253
                            ],
                            [
                                84.21263,
                                50.47283
                            ],
                            [
                                84.26236,
                                50.27011
                            ],
                            [
                                84.32245,
                                50.2259
                            ],
                            [
                                84.47758,
                                50.2496
                            ],
                            [
                                84.56069,
                                50.20214
                            ],
                            [
                                84.66789,
                                50.18177
                            ],
                            [
                                84.8508,
                                50.09394
                            ],
                            [
                                84.93037,
                                50.09076
                            ],
                            [
                                85.03098,
                                50.01667
                            ],
                            [
                                84.97757,
                                49.95863
                            ],
                            [
                                84.99575,
                                49.90193
                            ],
                            [
                                85.09117,
                                49.87928
                            ],
                            [
                                85.19552,
                                49.73836
                            ],
                            [
                                85.21474,
                                49.6261
                            ],
                            [
                                85.28918,
                                49.58886
                            ],
                            [
                                85.42326,
                                49.56526
                            ],
                            [
                                85.52699,
                                49.60451
                            ],
                            [
                                85.69504,
                                49.55775
                            ],
                            [
                                85.9233,
                                49.55337
                            ],
                            [
                                85.97756,
                                49.48709
                            ],
                            [
                                86.10221,
                                49.51654
                            ],
                            [
                                86.15685,
                                49.46601
                            ],
                            [
                                86.25277,
                                49.58792
                            ],
                            [
                                86.42638,
                                49.6392
                            ],
                            [
                                86.5889,
                                49.74309
                            ],
                            [
                                86.64161,
                                49.8058
                            ],
                            [
                                86.80048,
                                49.80273
                            ],
                            [
                                86.78058,
                                49.70984
                            ],
                            [
                                86.66833,
                                49.67957
                            ],
                            [
                                86.61839,
                                49.63112
                            ],
                            [
                                86.65612,
                                49.56755
                            ],
                            [
                                86.79258,
                                49.54835
                            ],
                            [
                                86.82455,
                                49.44351
                            ],
                            [
                                86.90924,
                                49.41243
                            ],
                            [
                                86.90275,
                                49.35183
                            ],
                            [
                                86.94497,
                                49.30231
                            ],
                            [
                                87.04962,
                                49.25489
                            ],
                            [
                                87.17381,
                                49.25128
                            ],
                            [
                                87.26857,
                                49.2161
                            ],
                            [
                                87.31258,
                                49.09969
                            ],
                            [
                                87.43458,
                                49.0727
                            ],
                            [
                                87.52915,
                                49.14487
                            ],
                            [
                                87.66824,
                                49.1538
                            ],
                            [
                                87.82497,
                                49.18332
                            ],
                            [
                                87.89911,
                                49.16721
                            ],
                            [
                                87.99419,
                                49.18699
                            ],
                            [
                                88.05494,
                                49.26588
                            ],
                            [
                                88.1268,
                                49.24482
                            ],
                            [
                                88.19294,
                                49.28402
                            ],
                            [
                                88.09695,
                                49.37296
                            ],
                            [
                                88.18798,
                                49.43048
                            ],
                            [
                                88.22228,
                                49.48942
                            ],
                            [
                                88.33949,
                                49.50775
                            ],
                            [
                                88.45178,
                                49.47925
                            ],
                            [
                                88.55556,
                                49.48524
                            ],
                            [
                                88.64915,
                                49.52047
                            ],
                            [
                                88.68301,
                                49.47368
                            ],
                            [
                                88.86766,
                                49.45689
                            ],
                            [
                                88.8462,
                                49.50694
                            ],
                            [
                                88.89106,
                                49.55554
                            ],
                            [
                                88.96861,
                                49.48075
                            ],
                            [
                                89.12678,
                                49.50692
                            ],
                            [
                                89.2236,
                                49.56537
                            ],
                            [
                                89.22296,
                                49.6454
                            ],
                            [
                                89.36816,
                                49.59749
                            ],
                            [
                                89.44673,
                                49.65909
                            ],
                            [
                                89.6806,
                                49.71015
                            ],
                            [
                                89.73776,
                                49.79548
                            ],
                            [
                                89.65299,
                                49.81586
                            ],
                            [
                                89.63781,
                                49.90593
                            ],
                            [
                                89.70832,
                                49.95826
                            ],
                            [
                                89.94313,
                                49.97482
                            ],
                            [
                                90.00878,
                                50.00113
                            ],
                            [
                                90.01729,
                                50.07419
                            ],
                            [
                                90.13719,
                                50.11596
                            ],
                            [
                                90.28163,
                                50.13364
                            ],
                            [
                                90.39945,
                                50.20967
                            ],
                            [
                                90.55345,
                                50.25083
                            ],
                            [
                                90.67497,
                                50.22796
                            ],
                            [
                                90.70241,
                                50.30939
                            ],
                            [
                                90.82031,
                                50.36085
                            ],
                            [
                                90.8976,
                                50.35929
                            ],
                            [
                                90.94925,
                                50.43783
                            ],
                            [
                                91.13955,
                                50.43299
                            ],
                            [
                                91.28836,
                                50.47987
                            ],
                            [
                                91.42399,
                                50.45865
                            ],
                            [
                                91.44087,
                                50.54611
                            ],
                            [
                                91.6477,
                                50.57777
                            ],
                            [
                                91.6567,
                                50.66022
                            ],
                            [
                                91.75748,
                                50.7199
                            ],
                            [
                                91.88359,
                                50.73014
                            ],
                            [
                                92.02177,
                                50.68408
                            ],
                            [
                                92.19507,
                                50.68516
                            ],
                            [
                                92.28931,
                                50.72564
                            ],
                            [
                                92.28765,
                                50.80842
                            ],
                            [
                                92.32258,
                                50.88078
                            ],
                            [
                                92.40096,
                                50.8811
                            ],
                            [
                                92.4131,
                                50.8153
                            ],
                            [
                                92.46627,
                                50.77955
                            ],
                            [
                                92.58958,
                                50.7703
                            ],
                            [
                                92.60764,
                                50.71622
                            ],
                            [
                                92.74774,
                                50.7101
                            ],
                            [
                                92.7498,
                                50.7541
                            ],
                            [
                                92.84642,
                                50.79397
                            ],
                            [
                                92.99213,
                                50.78834
                            ],
                            [
                                93.03189,
                                50.7616
                            ],
                            [
                                92.98313,
                                50.65901
                            ],
                            [
                                93.00227,
                                50.60329
                            ],
                            [
                                93.10905,
                                50.56615
                            ],
                            [
                                93.40273,
                                50.5857
                            ],
                            [
                                93.6737,
                                50.57816
                            ],
                            [
                                93.9534,
                                50.59117
                            ],
                            [
                                94.22204,
                                50.58261
                            ],
                            [
                                94.30303,
                                50.55201
                            ],
                            [
                                94.34858,
                                50.46366
                            ],
                            [
                                94.39844,
                                50.23594
                            ],
                            [
                                94.51115,
                                50.16839
                            ],
                            [
                                94.52949,
                                50.12401
                            ],
                            [
                                94.6436,
                                50.02928
                            ],
                            [
                                94.83913,
                                50.06204
                            ],
                            [
                                94.98198,
                                50.05724
                            ],
                            [
                                95.03991,
                                49.98372
                            ],
                            [
                                95.13285,
                                49.94898
                            ],
                            [
                                95.33382,
                                49.95126
                            ],
                            [
                                95.47546,
                                49.92298
                            ],
                            [
                                95.72168,
                                49.96191
                            ],
                            [
                                95.76129,
                                50.01328
                            ],
                            [
                                95.8629,
                                50.04086
                            ],
                            [
                                95.96958,
                                49.98052
                            ],
                            [
                                96.07674,
                                50.01953
                            ],
                            [
                                96.29369,
                                49.99035
                            ],
                            [
                                96.40421,
                                49.90512
                            ],
                            [
                                96.53567,
                                49.95666
                            ],
                            [
                                96.66015,
                                49.97471
                            ],
                            [
                                96.71609,
                                49.90792
                            ],
                            [
                                96.84107,
                                49.94315
                            ],
                            [
                                96.9986,
                                49.91526
                            ],
                            [
                                97.09218,
                                49.83889
                            ],
                            [
                                97.21906,
                                49.76891
                            ],
                            [
                                97.31547,
                                49.75772
                            ],
                            [
                                97.42825,
                                49.78795
                            ],
                            [
                                97.7619,
                                49.9829
                            ],
                            [
                                97.87538,
                                49.95263
                            ],
                            [
                                97.91669,
                                49.99639
                            ],
                            [
                                98.05964,
                                50.05507
                            ],
                            [
                                98.15092,
                                50.17746
                            ],
                            [
                                98.25493,
                                50.25699
                            ],
                            [
                                98.27781,
                                50.3148
                            ],
                            [
                                98.25729,
                                50.4117
                            ],
                            [
                                98.32338,
                                50.53725
                            ],
                            [
                                98.26456,
                                50.57444
                            ],
                            [
                                98.12943,
                                50.59862
                            ],
                            [
                                98.04855,
                                50.65359
                            ],
                            [
                                97.95557,
                                50.78125
                            ],
                            [
                                98.01068,
                                50.87512
                            ],
                            [
                                97.86868,
                                50.95007
                            ],
                            [
                                97.83003,
                                51.00397
                            ],
                            [
                                97.86689,
                                51.04557
                            ],
                            [
                                97.90902,
                                51.17246
                            ],
                            [
                                97.95251,
                                51.23144
                            ],
                            [
                                97.94655,
                                51.32435
                            ],
                            [
                                98.05205,
                                51.43958
                            ],
                            [
                                98.23397,
                                51.4629
                            ],
                            [
                                98.24161,
                                51.56777
                            ],
                            [
                                98.34539,
                                51.73555
                            ],
                            [
                                98.69443,
                                51.81986
                            ],
                            [
                                98.73014,
                                51.85099
                            ],
                            [
                                98.88018,
                                52.13929
                            ],
                            [
                                98.95903,
                                52.14429
                            ],
                            [
                                99.05163,
                                52.07122
                            ],
                            [
                                99.28544,
                                52.00743
                            ],
                            [
                                99.29479,
                                51.97642
                            ],
                            [
                                99.57184,
                                51.9182
                            ],
                            [
                                99.72811,
                                51.90101
                            ],
                            [
                                99.89412,
                                51.78902
                            ],
                            [
                                99.99134,
                                51.75446
                            ],
                            [
                                100.12587,
                                51.7602
                            ],
                            [
                                100.28254,
                                51.745
                            ],
                            [
                                100.51896,
                                51.74923
                            ],
                            [
                                100.70032,
                                51.70465
                            ],
                            [
                                100.74866,
                                51.67668
                            ],
                            [
                                100.94622,
                                51.625
                            ],
                            [
                                101.14183,
                                51.54395
                            ],
                            [
                                101.26354,
                                51.53567
                            ],
                            [
                                101.34541,
                                51.47239
                            ],
                            [
                                101.5346,
                                51.50294
                            ],
                            [
                                101.64149,
                                51.45817
                            ],
                            [
                                101.74914,
                                51.46015
                            ],
                            [
                                101.85465,
                                51.42215
                            ],
                            [
                                102.06463,
                                51.39681
                            ],
                            [
                                102.21351,
                                51.31388
                            ],
                            [
                                102.15218,
                                51.2659
                            ],
                            [
                                102.19434,
                                51.07261
                            ],
                            [
                                102.26562,
                                50.9695
                            ],
                            [
                                102.23272,
                                50.82751
                            ],
                            [
                                102.33699,
                                50.76498
                            ],
                            [
                                102.35223,
                                50.72493
                            ],
                            [
                                102.28978,
                                50.62893
                            ],
                            [
                                102.3356,
                                50.57673
                            ],
                            [
                                102.50356,
                                50.54055
                            ],
                            [
                                102.6435,
                                50.42917
                            ],
                            [
                                102.82609,
                                50.37747
                            ],
                            [
                                102.8894,
                                50.32605
                            ],
                            [
                                102.97936,
                                50.30454
                            ],
                            [
                                103.20601,
                                50.31184
                            ],
                            [
                                103.28753,
                                50.21943
                            ],
                            [
                                103.44103,
                                50.21473
                            ],
                            [
                                103.69128,
                                50.13801
                            ],
                            [
                                103.75974,
                                50.19511
                            ],
                            [
                                103.84557,
                                50.20463
                            ],
                            [
                                104.06304,
                                50.15505
                            ],
                            [
                                104.24778,
                                50.1987
                            ],
                            [
                                104.28337,
                                50.25093
                            ],
                            [
                                104.39991,
                                50.30348
                            ],
                            [
                                104.59354,
                                50.31467
                            ],
                            [
                                104.72185,
                                50.3548
                            ],
                            [
                                104.82175,
                                50.35598
                            ],
                            [
                                104.91136,
                                50.38795
                            ],
                            [
                                105.09412,
                                50.39117
                            ],
                            [
                                105.28321,
                                50.46615
                            ],
                            [
                                105.38734,
                                50.47869
                            ],
                            [
                                105.61242,
                                50.43261
                            ],
                            [
                                105.84385,
                                50.43004
                            ],
                            [
                                106.0297,
                                50.41241
                            ],
                            [
                                106.09525,
                                50.35089
                            ],
                            [
                                106.27626,
                                50.29688
                            ],
                            [
                                106.47605,
                                50.33682
                            ],
                            [
                                106.59705,
                                50.34441
                            ],
                            [
                                106.75933,
                                50.32081
                            ],
                            [
                                106.92207,
                                50.24856
                            ],
                            [
                                106.99682,
                                50.19219
                            ],
                            [
                                107.03714,
                                50.1111
                            ],
                            [
                                107.14636,
                                50.02045
                            ],
                            [
                                107.58446,
                                49.95876
                            ],
                            [
                                107.75744,
                                49.9775
                            ],
                            [
                                107.85524,
                                49.9219
                            ],
                            [
                                107.97644,
                                49.90329
                            ],
                            [
                                107.95221,
                                49.82449
                            ],
                            [
                                107.981,
                                49.74248
                            ],
                            [
                                107.93991,
                                49.70048
                            ],
                            [
                                108.05258,
                                49.60037
                            ],
                            [
                                108.15644,
                                49.55429
                            ],
                            [
                                108.28466,
                                49.52753
                            ],
                            [
                                108.36984,
                                49.44243
                            ],
                            [
                                108.54556,
                                49.33679
                            ],
                            [
                                108.8765,
                                49.34274
                            ],
                            [
                                108.96102,
                                49.35906
                            ],
                            [
                                109.04617,
                                49.33664
                            ],
                            [
                                109.18499,
                                49.35994
                            ],
                            [
                                109.32656,
                                49.34164
                            ],
                            [
                                109.48379,
                                49.28747
                            ],
                            [
                                109.5878,
                                49.22287
                            ],
                            [
                                109.69893,
                                49.23136
                            ],
                            [
                                110.05159,
                                49.195
                            ],
                            [
                                110.18292,
                                49.16791
                            ],
                            [
                                110.29988,
                                49.18104
                            ],
                            [
                                110.41605,
                                49.25025
                            ],
                            [
                                110.59645,
                                49.16235
                            ],
                            [
                                110.76441,
                                49.14523
                            ],
                            [
                                110.9925,
                                49.20033
                            ],
                            [
                                111.17003,
                                49.30023
                            ],
                            [
                                111.32273,
                                49.3348
                            ],
                            [
                                111.39578,
                                49.37214
                            ],
                            [
                                111.50485,
                                49.34427
                            ],
                            [
                                111.72751,
                                49.40591
                            ],
                            [
                                111.89574,
                                49.39178
                            ],
                            [
                                112.12829,
                                49.43535
                            ],
                            [
                                112.28772,
                                49.49004
                            ],
                            [
                                112.50967,
                                49.54577
                            ],
                            [
                                112.65106,
                                49.52694
                            ],
                            [
                                112.7438,
                                49.49065
                            ],
                            [
                                112.96871,
                                49.58701
                            ],
                            [
                                113.08395,
                                49.60768
                            ],
                            [
                                113.18522,
                                49.79921
                            ],
                            [
                                113.23205,
                                49.83563
                            ],
                            [
                                113.53147,
                                49.97738
                            ],
                            [
                                113.59871,
                                50.02167
                            ],
                            [
                                113.77981,
                                50.09009
                            ],
                            [
                                113.8689,
                                50.08566
                            ],
                            [
                                114.02016,
                                50.17981
                            ],
                            [
                                114.19739,
                                50.24754
                            ],
                            [
                                114.34412,
                                50.28233
                            ],
                            [
                                114.50604,
                                50.23741
                            ],
                            [
                                114.67278,
                                50.25602
                            ],
                            [
                                114.9666,
                                50.19228
                            ],
                            [
                                115.23473,
                                49.98164
                            ],
                            [
                                115.37255,
                                49.90921
                            ],
                            [
                                115.77549,
                                49.89318
                            ],
                            [
                                116.02437,
                                49.99756
                            ],
                            [
                                116.20434,
                                50.0314
                            ],
                            [
                                116.44647,
                                49.96358
                            ],
                            [
                                116.60721,
                                49.93963
                            ],
                            [
                                116.72094,
                                49.84979
                            ],
                            [
                                117.06505,
                                49.6925
                            ],
                            [
                                117.27115,
                                49.63486
                            ],
                            [
                                117.47809,
                                49.63041
                            ],
                            [
                                117.80308,
                                49.51991
                            ],
                            [
                                117.86714,
                                49.59614
                            ],
                            [
                                117.97767,
                                49.62458
                            ],
                            [
                                118.07275,
                                49.61957
                            ],
                            [
                                118.11483,
                                49.67307
                            ],
                            [
                                118.19268,
                                49.68646
                            ],
                            [
                                118.22986,
                                49.74018
                            ],
                            [
                                118.37438,
                                49.78296
                            ],
                            [
                                118.41752,
                                49.82852
                            ],
                            [
                                118.54967,
                                49.90347
                            ],
                            [
                                118.56153,
                                49.93449
                            ],
                            [
                                118.73232,
                                49.95195
                            ],
                            [
                                118.92542,
                                49.99413
                            ],
                            [
                                119.08326,
                                49.99499
                            ],
                            [
                                119.28716,
                                50.11286
                            ],
                            [
                                119.35269,
                                50.35619
                            ],
                            [
                                119.15634,
                                50.35867
                            ],
                            [
                                119.2532,
                                50.46877
                            ],
                            [
                                119.28336,
                                50.61196
                            ],
                            [
                                119.42976,
                                50.68643
                            ],
                            [
                                119.50693,
                                50.8018
                            ],
                            [
                                119.49029,
                                50.88058
                            ],
                            [
                                119.58742,
                                50.98111
                            ],
                            [
                                119.67889,
                                51.01896
                            ],
                            [
                                119.75881,
                                51.09032
                            ],
                            [
                                119.76039,
                                51.21303
                            ],
                            [
                                119.99368,
                                51.45661
                            ],
                            [
                                119.97834,
                                51.50308
                            ],
                            [
                                120.04287,
                                51.55344
                            ],
                            [
                                120.05816,
                                51.63502
                            ],
                            [
                                120.18109,
                                51.68331
                            ],
                            [
                                120.31409,
                                51.78377
                            ],
                            [
                                120.655,
                                51.92985
                            ],
                            [
                                120.71012,
                                52.01189
                            ],
                            [
                                120.68778,
                                52.05737
                            ],
                            [
                                120.7782,
                                52.16486
                            ],
                            [
                                120.74972,
                                52.25025
                            ],
                            [
                                120.62779,
                                52.32185
                            ],
                            [
                                120.68035,
                                52.4252
                            ],
                            [
                                120.68919,
                                52.51993
                            ],
                            [
                                120.66196,
                                52.56562
                            ],
                            [
                                120.47658,
                                52.63701
                            ],
                            [
                                120.28465,
                                52.6235
                            ],
                            [
                                120.19381,
                                52.58262
                            ],
                            [
                                120.05304,
                                52.59552
                            ],
                            [
                                120.06189,
                                52.70427
                            ],
                            [
                                120.02958,
                                52.77688
                            ],
                            [
                                120.18249,
                                52.8108
                            ],
                            [
                                120.3468,
                                52.90964
                            ],
                            [
                                120.55309,
                                53.07684
                            ],
                            [
                                120.63986,
                                53.10661
                            ],
                            [
                                120.73864,
                                53.20751
                            ],
                            [
                                120.88068,
                                53.29104
                            ],
                            [
                                121.23484,
                                53.27836
                            ],
                            [
                                121.34869,
                                53.32202
                            ],
                            [
                                121.45434,
                                53.32275
                            ],
                            [
                                121.87081,
                                53.42367
                            ],
                            [
                                122.11901,
                                53.429
                            ],
                            [
                                122.16096,
                                53.46805
                            ],
                            [
                                122.25385,
                                53.45902
                            ],
                            [
                                122.31601,
                                53.49396
                            ],
                            [
                                122.46116,
                                53.4435
                            ],
                            [
                                122.59429,
                                53.46224
                            ],
                            [
                                122.85745,
                                53.45734
                            ],
                            [
                                123.04993,
                                53.50527
                            ],
                            [
                                123.1697,
                                53.5066
                            ],
                            [
                                123.29512,
                                53.55761
                            ],
                            [
                                123.38866,
                                53.53578
                            ],
                            [
                                123.53068,
                                53.55434
                            ],
                            [
                                123.66063,
                                53.53255
                            ],
                            [
                                123.6891,
                                53.4982
                            ],
                            [
                                123.87533,
                                53.48163
                            ],
                            [
                                124.11326,
                                53.34521
                            ],
                            [
                                124.23965,
                                53.37439
                            ],
                            [
                                124.35689,
                                53.27008
                            ],
                            [
                                124.50508,
                                53.20279
                            ],
                            [
                                124.6524,
                                53.20566
                            ],
                            [
                                124.73169,
                                53.14296
                            ],
                            [
                                124.82373,
                                53.1447
                            ],
                            [
                                124.96528,
                                53.19568
                            ],
                            [
                                125.1562,
                                53.20108
                            ],
                            [
                                125.303,
                                53.14343
                            ],
                            [
                                125.58798,
                                53.08058
                            ],
                            [
                                125.73279,
                                52.98522
                            ],
                            [
                                125.65161,
                                52.91577
                            ],
                            [
                                125.83654,
                                52.88368
                            ],
                            [
                                125.94609,
                                52.76365
                            ],
                            [
                                126.01092,
                                52.79138
                            ],
                            [
                                126.05849,
                                52.69608
                            ],
                            [
                                125.99106,
                                52.67816
                            ],
                            [
                                125.96441,
                                52.61678
                            ],
                            [
                                126.06913,
                                52.60215
                            ],
                            [
                                126.19804,
                                52.52603
                            ],
                            [
                                126.33923,
                                52.38524
                            ],
                            [
                                126.3108,
                                52.19809
                            ],
                            [
                                126.50079,
                                52.15451
                            ],
                            [
                                126.55252,
                                52.12116
                            ],
                            [
                                126.51074,
                                52.03737
                            ],
                            [
                                126.43748,
                                52.00752
                            ],
                            [
                                126.45681,
                                51.94024
                            ],
                            [
                                126.54817,
                                51.86143
                            ],
                            [
                                126.6043,
                                51.77678
                            ],
                            [
                                126.70013,
                                51.73007
                            ],
                            [
                                126.7272,
                                51.65005
                            ],
                            [
                                126.6845,
                                51.57842
                            ],
                            [
                                126.82448,
                                51.53504
                            ],
                            [
                                126.76921,
                                51.446
                            ],
                            [
                                126.88448,
                                51.40836
                            ],
                            [
                                126.90921,
                                51.35888
                            ],
                            [
                                126.8045,
                                51.32494
                            ],
                            [
                                126.81309,
                                51.26563
                            ],
                            [
                                126.88967,
                                51.21005
                            ],
                            [
                                126.91107,
                                51.06115
                            ],
                            [
                                127.03486,
                                50.95879
                            ],
                            [
                                127.13415,
                                50.90688
                            ],
                            [
                                127.23405,
                                50.77466
                            ],
                            [
                                127.28674,
                                50.75294
                            ],
                            [
                                127.28601,
                                50.66455
                            ],
                            [
                                127.35876,
                                50.58608
                            ],
                            [
                                127.28452,
                                50.46147
                            ],
                            [
                                127.35777,
                                50.40785
                            ],
                            [
                                127.32066,
                                50.3327
                            ],
                            [
                                127.37528,
                                50.28303
                            ],
                            [
                                127.59871,
                                50.23112
                            ],
                            [
                                127.57044,
                                50.13037
                            ],
                            [
                                127.511,
                                50.08028
                            ],
                            [
                                127.48357,
                                49.99976
                            ],
                            [
                                127.53848,
                                49.93354
                            ],
                            [
                                127.52057,
                                49.85679
                            ],
                            [
                                127.57425,
                                49.78522
                            ],
                            [
                                127.66512,
                                49.77026
                            ],
                            [
                                127.67485,
                                49.6965
                            ],
                            [
                                127.81749,
                                49.59099
                            ],
                            [
                                127.94784,
                                49.59945
                            ],
                            [
                                128.07966,
                                49.55218
                            ],
                            [
                                128.21011,
                                49.54192
                            ],
                            [
                                128.37486,
                                49.58417
                            ],
                            [
                                128.53106,
                                49.60227
                            ],
                            [
                                128.6707,
                                49.56962
                            ],
                            [
                                128.78798,
                                49.58371
                            ],
                            [
                                128.7494,
                                49.50634
                            ],
                            [
                                129.01699,
                                49.44611
                            ],
                            [
                                129.05381,
                                49.3725
                            ],
                            [
                                129.11429,
                                49.35223
                            ],
                            [
                                129.20675,
                                49.39662
                            ],
                            [
                                129.36961,
                                49.35913
                            ],
                            [
                                129.36929,
                                49.41332
                            ],
                            [
                                129.43522,
                                49.44144
                            ],
                            [
                                129.5387,
                                49.38945
                            ],
                            [
                                129.58013,
                                49.2771
                            ],
                            [
                                129.70316,
                                49.29435
                            ],
                            [
                                129.74239,
                                49.21499
                            ],
                            [
                                129.85536,
                                49.1629
                            ],
                            [
                                129.92479,
                                49.04118
                            ],
                            [
                                130.01864,
                                49.015
                            ],
                            [
                                130.05584,
                                48.97315
                            ],
                            [
                                130.29323,
                                48.86905
                            ],
                            [
                                130.46576,
                                48.90138
                            ],
                            [
                                130.53447,
                                48.8544
                            ],
                            [
                                130.63662,
                                48.88306
                            ],
                            [
                                130.6339,
                                48.80597
                            ],
                            [
                                130.53335,
                                48.60731
                            ],
                            [
                                130.60982,
                                48.56967
                            ],
                            [
                                130.61301,
                                48.50469
                            ],
                            [
                                130.70665,
                                48.50849
                            ],
                            [
                                130.77133,
                                48.36012
                            ],
                            [
                                130.83562,
                                48.29245
                            ],
                            [
                                130.77375,
                                48.2493
                            ],
                            [
                                130.75661,
                                48.18675
                            ],
                            [
                                130.67087,
                                48.13041
                            ],
                            [
                                130.69657,
                                48.04006
                            ],
                            [
                                130.88306,
                                47.92508
                            ],
                            [
                                130.95485,
                                47.82215
                            ],
                            [
                                130.95901,
                                47.7321
                            ],
                            [
                                131.04114,
                                47.6894
                            ],
                            [
                                131.16972,
                                47.69822
                            ],
                            [
                                131.26162,
                                47.73714
                            ],
                            [
                                131.5202,
                                47.73832
                            ],
                            [
                                131.5894,
                                47.66163
                            ],
                            [
                                131.68054,
                                47.70274
                            ],
                            [
                                131.82293,
                                47.67235
                            ],
                            [
                                131.95575,
                                47.66816
                            ],
                            [
                                131.99434,
                                47.70364
                            ],
                            [
                                132.24497,
                                47.70829
                            ],
                            [
                                132.29665,
                                47.75066
                            ],
                            [
                                132.37553,
                                47.75603
                            ],
                            [
                                132.46483,
                                47.72194
                            ],
                            [
                                132.59054,
                                47.73482
                            ],
                            [
                                132.61588,
                                47.82736
                            ],
                            [
                                132.67838,
                                47.88155
                            ],
                            [
                                132.65452,
                                47.94209
                            ],
                            [
                                132.7128,
                                47.96048
                            ],
                            [
                                132.81231,
                                47.93559
                            ],
                            [
                                132.87635,
                                48.00012
                            ],
                            [
                                132.97375,
                                48.02964
                            ],
                            [
                                133.09252,
                                48.12608
                            ],
                            [
                                133.21076,
                                48.12948
                            ],
                            [
                                133.29646,
                                48.10103
                            ],
                            [
                                133.39529,
                                48.12147
                            ],
                            [
                                133.50319,
                                48.11273
                            ],
                            [
                                133.59538,
                                48.19251
                            ],
                            [
                                133.68581,
                                48.18533
                            ],
                            [
                                133.73328,
                                48.25196
                            ],
                            [
                                134.06222,
                                48.33551
                            ],
                            [
                                134.19611,
                                48.37968
                            ],
                            [
                                134.34808,
                                48.36797
                            ],
                            [
                                134.44149,
                                48.4038
                            ],
                            [
                                134.6913,
                                48.40408
                            ],
                            [
                                134.72998,
                                48.37816
                            ],
                            [
                                134.72405,
                                48.27641
                            ],
                            [
                                134.67864,
                                48.25518
                            ],
                            [
                                134.66047,
                                48.13917
                            ],
                            [
                                134.54862,
                                48.01998
                            ],
                            [
                                134.60484,
                                47.92348
                            ],
                            [
                                134.67263,
                                47.88661
                            ],
                            [
                                134.68049,
                                47.81974
                            ],
                            [
                                134.77837,
                                47.7237
                            ],
                            [
                                134.67997,
                                47.62901
                            ],
                            [
                                134.68276,
                                47.59754
                            ],
                            [
                                134.49124,
                                47.43995
                            ],
                            [
                                134.31799,
                                47.43361
                            ],
                            [
                                134.24331,
                                47.35482
                            ],
                            [
                                134.17473,
                                47.32696
                            ],
                            [
                                134.15057,
                                47.25893
                            ],
                            [
                                134.21942,
                                47.19108
                            ],
                            [
                                134.22546,
                                47.10877
                            ],
                            [
                                134.11298,
                                47.06296
                            ],
                            [
                                134.01742,
                                46.81313
                            ],
                            [
                                134.04429,
                                46.78442
                            ],
                            [
                                134.01078,
                                46.6455
                            ],
                            [
                                133.90648,
                                46.58381
                            ],
                            [
                                133.83937,
                                46.47093
                            ],
                            [
                                133.93809,
                                46.3953
                            ],
                            [
                                133.90456,
                                46.25301
                            ],
                            [
                                133.81606,
                                46.2257
                            ],
                            [
                                133.68068,
                                46.12948
                            ],
                            [
                                133.73265,
                                46.05875
                            ],
                            [
                                133.61656,
                                45.94166
                            ],
                            [
                                133.5807,
                                45.86911
                            ],
                            [
                                133.51471,
                                45.8908
                            ],
                            [
                                133.456,
                                45.83119
                            ],
                            [
                                133.46912,
                                45.6566
                            ],
                            [
                                133.29485,
                                45.53941
                            ],
                            [
                                133.19411,
                                45.51436
                            ],
                            [
                                133.09207,
                                45.3113
                            ],
                            [
                                133.08607,
                                45.25327
                            ],
                            [
                                133.12508,
                                45.13705
                            ],
                            [
                                133.02594,
                                45.05552
                            ],
                            [
                                132.93441,
                                45.01889
                            ],
                            [
                                132.84186,
                                45.06071
                            ],
                            [
                                132.00453,
                                45.24861
                            ],
                            [
                                131.93342,
                                45.28319
                            ],
                            [
                                131.91374,
                                45.33486
                            ],
                            [
                                131.82475,
                                45.31337
                            ],
                            [
                                131.78162,
                                45.24745
                            ],
                            [
                                131.67431,
                                45.21263
                            ],
                            [
                                131.6447,
                                45.16319
                            ],
                            [
                                131.67812,
                                45.11834
                            ],
                            [
                                131.46562,
                                44.96076
                            ],
                            [
                                131.33873,
                                44.98253
                            ],
                            [
                                131.29315,
                                44.93968
                            ],
                            [
                                131.20143,
                                44.91712
                            ],
                            [
                                131.13746,
                                44.94302
                            ],
                            [
                                131.0902,
                                44.89515
                            ],
                            [
                                130.97862,
                                44.86419
                            ],
                            [
                                131.01535,
                                44.77843
                            ],
                            [
                                131.09999,
                                44.7061
                            ],
                            [
                                131.29799,
                                44.05048
                            ],
                            [
                                131.23112,
                                43.96143
                            ],
                            [
                                131.2532,
                                43.91981
                            ],
                            [
                                131.20049,
                                43.8327
                            ],
                            [
                                131.22117,
                                43.66355
                            ],
                            [
                                131.19514,
                                43.53827
                            ],
                            [
                                131.31051,
                                43.48251
                            ],
                            [
                                131.30679,
                                43.39538
                            ],
                            [
                                131.26869,
                                43.37097
                            ],
                            [
                                131.24775,
                                43.26464
                            ],
                            [
                                131.20524,
                                43.23455
                            ],
                            [
                                131.20441,
                                43.1325
                            ],
                            [
                                131.09222,
                                43.02335
                            ],
                            [
                                131.14596,
                                42.95805
                            ],
                            [
                                131.03464,
                                42.86696
                            ],
                            [
                                130.88509,
                                42.85202
                            ],
                            [
                                130.82307,
                                42.87735
                            ],
                            [
                                130.7652,
                                42.83348
                            ],
                            [
                                130.66026,
                                42.84108
                            ],
                            [
                                130.39715,
                                42.72396
                            ],
                            [
                                130.45223,
                                42.68293
                            ],
                            [
                                130.52325,
                                42.69746
                            ],
                            [
                                130.59039,
                                42.65752
                            ],
                            [
                                130.6266,
                                42.58457
                            ],
                            [
                                130.56751,
                                42.5364
                            ],
                            [
                                130.5893,
                                42.44655
                            ],
                            [
                                130.63393,
                                42.41417
                            ],
                            [
                                130.67486,
                                42.28361
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -179.68137,
                                68.89712
                            ],
                            [
                                -180,
                                68.97953
                            ],
                            [
                                -180,
                                68.82082
                            ],
                            [
                                -180,
                                68.66096
                            ],
                            [
                                -180,
                                68.49996
                            ],
                            [
                                -180,
                                68.3378
                            ],
                            [
                                -180,
                                68.17447
                            ],
                            [
                                -180,
                                68.00998
                            ],
                            [
                                -180,
                                67.8443
                            ],
                            [
                                -180,
                                67.67744
                            ],
                            [
                                -180,
                                67.50939
                            ],
                            [
                                -180,
                                67.34014
                            ],
                            [
                                -180,
                                67.16969
                            ],
                            [
                                -180,
                                66.99802
                            ],
                            [
                                -180,
                                66.82513
                            ],
                            [
                                -180,
                                66.65101
                            ],
                            [
                                -180,
                                66.47566
                            ],
                            [
                                -180,
                                66.29907
                            ],
                            [
                                -180,
                                66.12123
                            ],
                            [
                                -180,
                                65.94213
                            ],
                            [
                                -180,
                                65.76177
                            ],
                            [
                                -180,
                                65.58014
                            ],
                            [
                                -180,
                                65.39724
                            ],
                            [
                                -180,
                                65.21305
                            ],
                            [
                                -180,
                                65.02757
                            ],
                            [
                                -179.76049,
                                65.12655
                            ],
                            [
                                -179.66493,
                                65.1344
                            ],
                            [
                                -179.52954,
                                65.23373
                            ],
                            [
                                -179.47659,
                                65.40082
                            ],
                            [
                                -179.2632,
                                65.52721
                            ],
                            [
                                -179.32523,
                                65.56856
                            ],
                            [
                                -179.27306,
                                65.61886
                            ],
                            [
                                -179.57271,
                                65.719
                            ],
                            [
                                -179.67409,
                                65.77567
                            ],
                            [
                                -179.76561,
                                65.88826
                            ],
                            [
                                -179.77909,
                                65.97117
                            ],
                            [
                                -179.74406,
                                66.07968
                            ],
                            [
                                -179.63248,
                                66.16541
                            ],
                            [
                                -179.5013,
                                66.10491
                            ],
                            [
                                -179.29291,
                                66.12088
                            ],
                            [
                                -179.19409,
                                66.18
                            ],
                            [
                                -179.28814,
                                66.24884
                            ],
                            [
                                -179.07034,
                                66.23136
                            ],
                            [
                                -178.9356,
                                66.15198
                            ],
                            [
                                -178.7201,
                                66.18487
                            ],
                            [
                                -178.57783,
                                66.34716
                            ],
                            [
                                -178.45753,
                                66.38015
                            ],
                            [
                                -178.44592,
                                66.21645
                            ],
                            [
                                -178.47841,
                                66.12262
                            ],
                            [
                                -178.65079,
                                66.08414
                            ],
                            [
                                -178.66043,
                                66.0136
                            ],
                            [
                                -178.8533,
                                65.90166
                            ],
                            [
                                -178.69783,
                                65.84246
                            ],
                            [
                                -178.58845,
                                65.73682
                            ],
                            [
                                -178.46511,
                                65.74772
                            ],
                            [
                                -178.39551,
                                65.68952
                            ],
                            [
                                -178.52811,
                                65.50231
                            ],
                            [
                                -178.25005,
                                65.44824
                            ],
                            [
                                -178.11692,
                                65.46337
                            ],
                            [
                                -177.74146,
                                65.44408
                            ],
                            [
                                -177.46269,
                                65.45941
                            ],
                            [
                                -177.31374,
                                65.4837
                            ],
                            [
                                -177.11076,
                                65.5866
                            ],
                            [
                                -176.928,
                                65.59911
                            ],
                            [
                                -176.40594,
                                65.50039
                            ],
                            [
                                -176.0781,
                                65.45317
                            ],
                            [
                                -175.92281,
                                65.4163
                            ],
                            [
                                -175.84465,
                                65.29165
                            ],
                            [
                                -175.85397,
                                65.23911
                            ],
                            [
                                -175.73465,
                                65.15284
                            ],
                            [
                                -175.77531,
                                65.03451
                            ],
                            [
                                -175.86412,
                                65.00384
                            ],
                            [
                                -175.75069,
                                64.94748
                            ],
                            [
                                -175.46927,
                                64.88495
                            ],
                            [
                                -175.42698,
                                64.80958
                            ],
                            [
                                -175.31829,
                                64.78871
                            ],
                            [
                                -175.04052,
                                64.7741
                            ],
                            [
                                -174.94698,
                                64.79769
                            ],
                            [
                                -174.78491,
                                64.77413
                            ],
                            [
                                -174.62618,
                                64.71545
                            ],
                            [
                                -174.34344,
                                64.6391
                            ],
                            [
                                -174.03798,
                                64.53927
                            ],
                            [
                                -173.98025,
                                64.42412
                            ],
                            [
                                -173.64244,
                                64.33018
                            ],
                            [
                                -173.42669,
                                64.37359
                            ],
                            [
                                -173.36598,
                                64.29651
                            ],
                            [
                                -173.16708,
                                64.25204
                            ],
                            [
                                -172.94318,
                                64.26189
                            ],
                            [
                                -172.84269,
                                64.30084
                            ],
                            [
                                -172.79087,
                                64.42985
                            ],
                            [
                                -172.95234,
                                64.49243
                            ],
                            [
                                -172.75368,
                                64.50402
                            ],
                            [
                                -172.71411,
                                64.40079
                            ],
                            [
                                -172.59389,
                                64.3757
                            ],
                            [
                                -172.4349,
                                64.40522
                            ],
                            [
                                -172.27949,
                                64.40338
                            ],
                            [
                                -172.42881,
                                64.54609
                            ],
                            [
                                -172.56865,
                                64.55492
                            ],
                            [
                                -172.71497,
                                64.60897
                            ],
                            [
                                -172.82498,
                                64.61668
                            ],
                            [
                                -172.83244,
                                64.70092
                            ],
                            [
                                -172.74267,
                                64.76877
                            ],
                            [
                                -172.75349,
                                64.83848
                            ],
                            [
                                -172.53629,
                                64.90306
                            ],
                            [
                                -172.38565,
                                64.91761
                            ],
                            [
                                -172.11661,
                                65.04419
                            ],
                            [
                                -172.19855,
                                65.20302
                            ],
                            [
                                -172.18493,
                                65.37264
                            ],
                            [
                                -172.24471,
                                65.42002
                            ],
                            [
                                -172.37551,
                                65.42905
                            ],
                            [
                                -172.38549,
                                65.57768
                            ],
                            [
                                -172.6429,
                                65.62455
                            ],
                            [
                                -172.587,
                                65.69043
                            ],
                            [
                                -172.31583,
                                65.65333
                            ],
                            [
                                -172.14837,
                                65.53184
                            ],
                            [
                                -171.74163,
                                65.49951
                            ],
                            [
                                -171.26162,
                                65.52654
                            ],
                            [
                                -171.05096,
                                65.46444
                            ],
                            [
                                -170.9879,
                                65.49561
                            ],
                            [
                                -170.98759,
                                65.58852
                            ],
                            [
                                -171.22806,
                                65.65414
                            ],
                            [
                                -171.41395,
                                65.78598
                            ],
                            [
                                -171.23573,
                                65.76851
                            ],
                            [
                                -171.16203,
                                65.70113
                            ],
                            [
                                -170.86816,
                                65.64947
                            ],
                            [
                                -170.85152,
                                65.62065
                            ],
                            [
                                -170.61288,
                                65.60095
                            ],
                            [
                                -170.50751,
                                65.65495
                            ],
                            [
                                -170.52694,
                                65.86694
                            ],
                            [
                                -170.15074,
                                66.01548
                            ],
                            [
                                -169.9095,
                                66.04921
                            ],
                            [
                                -169.71314,
                                66.01547
                            ],
                            [
                                -169.65899,
                                66.0836
                            ],
                            [
                                -169.7488,
                                66.16173
                            ],
                            [
                                -169.85474,
                                66.1505
                            ],
                            [
                                -170.10568,
                                66.1803
                            ],
                            [
                                -170.20427,
                                66.28101
                            ],
                            [
                                -170.56862,
                                66.35149
                            ],
                            [
                                -170.65344,
                                66.41102
                            ],
                            [
                                -170.96963,
                                66.53739
                            ],
                            [
                                -171.13223,
                                66.58182
                            ],
                            [
                                -171.35144,
                                66.67181
                            ],
                            [
                                -171.3318,
                                66.75108
                            ],
                            [
                                -171.68948,
                                66.87274
                            ],
                            [
                                -171.63289,
                                66.91766
                            ],
                            [
                                -171.72201,
                                66.95502
                            ],
                            [
                                -171.94073,
                                66.96835
                            ],
                            [
                                -172.07896,
                                66.95112
                            ],
                            [
                                -172.38575,
                                66.97782
                            ],
                            [
                                -172.79039,
                                67.03803
                            ],
                            [
                                -173.02981,
                                67.04584
                            ],
                            [
                                -173.37488,
                                67.07672
                            ],
                            [
                                -173.65051,
                                67.11497
                            ],
                            [
                                -173.72559,
                                67.07773
                            ],
                            [
                                -174.08939,
                                67.08569
                            ],
                            [
                                -174.59847,
                                67.06757
                            ],
                            [
                                -174.48584,
                                67.02529
                            ],
                            [
                                -174.21188,
                                67.05427
                            ],
                            [
                                -174.20194,
                                66.99135
                            ],
                            [
                                -174.02893,
                                66.969
                            ],
                            [
                                -173.94745,
                                66.83814
                            ],
                            [
                                -173.91497,
                                66.6769
                            ],
                            [
                                -174.1862,
                                66.5953
                            ],
                            [
                                -174.18966,
                                66.55405
                            ],
                            [
                                -173.84842,
                                66.5109
                            ],
                            [
                                -173.68415,
                                66.43695
                            ],
                            [
                                -173.73762,
                                66.34621
                            ],
                            [
                                -173.86038,
                                66.31648
                            ],
                            [
                                -174.02546,
                                66.46808
                            ],
                            [
                                -174.36052,
                                66.33666
                            ],
                            [
                                -174.46686,
                                66.38729
                            ],
                            [
                                -174.42424,
                                66.52283
                            ],
                            [
                                -174.6821,
                                66.59428
                            ],
                            [
                                -174.81228,
                                66.59243
                            ],
                            [
                                -174.93449,
                                66.65618
                            ],
                            [
                                -174.70645,
                                66.77031
                            ],
                            [
                                -174.78118,
                                66.93401
                            ],
                            [
                                -174.89696,
                                67.03345
                            ],
                            [
                                -174.86768,
                                67.27058
                            ],
                            [
                                -174.74737,
                                67.30726
                            ],
                            [
                                -174.80177,
                                67.36948
                            ],
                            [
                                -175.23962,
                                67.54346
                            ],
                            [
                                -175.26127,
                                67.64755
                            ],
                            [
                                -175.62305,
                                67.74521
                            ],
                            [
                                -175.88759,
                                67.84153
                            ],
                            [
                                -176.04533,
                                67.86745
                            ],
                            [
                                -176.45884,
                                67.98073
                            ],
                            [
                                -176.79509,
                                68.08377
                            ],
                            [
                                -177.41182,
                                68.24624
                            ],
                            [
                                -177.85736,
                                68.3962
                            ],
                            [
                                -178.53788,
                                68.60419
                            ],
                            [
                                -178.83259,
                                68.74514
                            ],
                            [
                                -179.30017,
                                68.85188
                            ],
                            [
                                -179.48334,
                                68.91898
                            ],
                            [
                                -179.68137,
                                68.89712
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                67.7989,
                                76.99537
                            ],
                            [
                                67.5382,
                                76.99086
                            ],
                            [
                                67.2528,
                                76.9336
                            ],
                            [
                                66.43897,
                                76.82986
                            ],
                            [
                                66.12661,
                                76.73626
                            ],
                            [
                                65.9694,
                                76.73467
                            ],
                            [
                                65.7971,
                                76.65529
                            ],
                            [
                                66.06044,
                                76.52079
                            ],
                            [
                                65.94642,
                                76.50414
                            ],
                            [
                                65.55268,
                                76.56561
                            ],
                            [
                                65.34385,
                                76.4941
                            ],
                            [
                                64.82456,
                                76.47195
                            ],
                            [
                                64.64353,
                                76.3774
                            ],
                            [
                                64.31816,
                                76.34912
                            ],
                            [
                                64.07281,
                                76.29272
                            ],
                            [
                                63.69514,
                                76.32262
                            ],
                            [
                                62.98596,
                                76.19275
                            ],
                            [
                                62.84051,
                                76.24509
                            ],
                            [
                                62.654,
                                76.19847
                            ],
                            [
                                62.41721,
                                76.24227
                            ],
                            [
                                61.95028,
                                76.25991
                            ],
                            [
                                61.69336,
                                76.29622
                            ],
                            [
                                61.53899,
                                76.27051
                            ],
                            [
                                61.07911,
                                76.26259
                            ],
                            [
                                60.94248,
                                76.13359
                            ],
                            [
                                61.14102,
                                76.13612
                            ],
                            [
                                61.09156,
                                76.05964
                            ],
                            [
                                60.84314,
                                76.04824
                            ],
                            [
                                60.7749,
                                75.9867
                            ],
                            [
                                60.50904,
                                75.97357
                            ],
                            [
                                60.66856,
                                76.07222
                            ],
                            [
                                60.52044,
                                76.12175
                            ],
                            [
                                60.08352,
                                76.04495
                            ],
                            [
                                60.36139,
                                75.9911
                            ],
                            [
                                59.70388,
                                75.90185
                            ],
                            [
                                59.50742,
                                75.9254
                            ],
                            [
                                59.37543,
                                75.8768
                            ],
                            [
                                59.07928,
                                75.84263
                            ],
                            [
                                58.87195,
                                75.85024
                            ],
                            [
                                58.63295,
                                75.77468
                            ],
                            [
                                58.66029,
                                75.72148
                            ],
                            [
                                58.26311,
                                75.66753
                            ],
                            [
                                58.03614,
                                75.65496
                            ],
                            [
                                57.99478,
                                75.55651
                            ],
                            [
                                57.56554,
                                75.47523
                            ],
                            [
                                57.70319,
                                75.43295
                            ],
                            [
                                57.74041,
                                75.34747
                            ],
                            [
                                57.57781,
                                75.30933
                            ],
                            [
                                57.05717,
                                75.37286
                            ],
                            [
                                56.7418,
                                75.29395
                            ],
                            [
                                56.95364,
                                75.24337
                            ],
                            [
                                56.89022,
                                75.19937
                            ],
                            [
                                56.45408,
                                75.06634
                            ],
                            [
                                56.23949,
                                75.14931
                            ],
                            [
                                56.00531,
                                75.192
                            ],
                            [
                                55.84264,
                                75.13592
                            ],
                            [
                                55.98078,
                                75.05426
                            ],
                            [
                                55.90338,
                                74.96421
                            ],
                            [
                                56.36452,
                                75.02028
                            ],
                            [
                                56.17782,
                                74.87463
                            ],
                            [
                                55.88697,
                                74.80916
                            ],
                            [
                                56.03229,
                                74.76271
                            ],
                            [
                                56.53155,
                                74.78288
                            ],
                            [
                                56.62491,
                                74.65567
                            ],
                            [
                                56.36938,
                                74.7032
                            ],
                            [
                                55.91576,
                                74.65317
                            ],
                            [
                                55.80284,
                                74.68339
                            ],
                            [
                                55.57689,
                                74.62881
                            ],
                            [
                                55.54269,
                                74.55009
                            ],
                            [
                                56.0131,
                                74.52159
                            ],
                            [
                                56.09972,
                                74.45607
                            ],
                            [
                                55.34911,
                                74.40954
                            ],
                            [
                                55.27926,
                                74.35766
                            ],
                            [
                                55.55506,
                                74.34452
                            ],
                            [
                                55.76216,
                                74.28463
                            ],
                            [
                                55.25236,
                                74.25689
                            ],
                            [
                                55.64266,
                                74.1356
                            ],
                            [
                                55.3552,
                                74.12248
                            ],
                            [
                                55.17975,
                                74.15879
                            ],
                            [
                                54.90682,
                                74.11914
                            ],
                            [
                                54.6025,
                                74.01964
                            ],
                            [
                                54.69586,
                                73.95915
                            ],
                            [
                                54.32382,
                                73.92021
                            ],
                            [
                                54.06339,
                                73.84669
                            ],
                            [
                                53.91364,
                                73.76683
                            ],
                            [
                                53.68514,
                                73.72339
                            ],
                            [
                                53.86334,
                                73.68421
                            ],
                            [
                                53.97026,
                                73.62229
                            ],
                            [
                                54.33532,
                                73.62069
                            ],
                            [
                                54.52436,
                                73.68813
                            ],
                            [
                                54.78375,
                                73.69102
                            ],
                            [
                                54.68695,
                                73.61657
                            ],
                            [
                                54.37751,
                                73.56383
                            ],
                            [
                                54.20705,
                                73.48686
                            ],
                            [
                                54.34165,
                                73.44666
                            ],
                            [
                                54.09727,
                                73.3969
                            ],
                            [
                                54.04764,
                                73.34012
                            ],
                            [
                                54.25034,
                                73.31475
                            ],
                            [
                                54.49949,
                                73.38668
                            ],
                            [
                                54.87548,
                                73.43841
                            ],
                            [
                                55.07002,
                                73.42211
                            ],
                            [
                                55.39348,
                                73.32967
                            ],
                            [
                                55.6368,
                                73.34254
                            ],
                            [
                                55.96008,
                                73.31491
                            ],
                            [
                                56.14369,
                                73.2596
                            ],
                            [
                                56.64617,
                                73.23594
                            ],
                            [
                                56.79966,
                                73.29579
                            ],
                            [
                                56.98961,
                                73.32666
                            ],
                            [
                                57.22079,
                                73.48511
                            ],
                            [
                                57.24048,
                                73.54379
                            ],
                            [
                                57.50495,
                                73.57607
                            ],
                            [
                                57.67482,
                                73.71297
                            ],
                            [
                                57.89787,
                                73.77664
                            ],
                            [
                                57.88872,
                                73.90245
                            ],
                            [
                                57.61342,
                                74.01876
                            ],
                            [
                                57.50963,
                                74.11176
                            ],
                            [
                                57.65166,
                                74.11353
                            ],
                            [
                                57.71369,
                                74.04474
                            ],
                            [
                                57.93366,
                                73.99792
                            ],
                            [
                                58.27338,
                                73.99347
                            ],
                            [
                                58.16446,
                                74.10893
                            ],
                            [
                                58.55107,
                                74.15692
                            ],
                            [
                                58.67806,
                                74.27681
                            ],
                            [
                                58.6387,
                                74.40525
                            ],
                            [
                                58.53355,
                                74.51757
                            ],
                            [
                                58.91307,
                                74.43514
                            ],
                            [
                                59.08303,
                                74.48133
                            ],
                            [
                                59.23028,
                                74.64593
                            ],
                            [
                                59.31862,
                                74.68126
                            ],
                            [
                                59.6103,
                                74.57398
                            ],
                            [
                                59.87197,
                                74.61663
                            ],
                            [
                                59.87157,
                                74.71531
                            ],
                            [
                                60.30906,
                                74.74075
                            ],
                            [
                                60.22831,
                                74.84503
                            ],
                            [
                                60.56803,
                                74.84955
                            ],
                            [
                                60.612,
                                74.94072
                            ],
                            [
                                60.21987,
                                74.93904
                            ],
                            [
                                60.18082,
                                74.97336
                            ],
                            [
                                60.8134,
                                75.04623
                            ],
                            [
                                60.81238,
                                75.1242
                            ],
                            [
                                61.17757,
                                75.19996
                            ],
                            [
                                61.25539,
                                75.26172
                            ],
                            [
                                61.51951,
                                75.22588
                            ],
                            [
                                62.00938,
                                75.44185
                            ],
                            [
                                62.30911,
                                75.43251
                            ],
                            [
                                62.57116,
                                75.49313
                            ],
                            [
                                62.99913,
                                75.56052
                            ],
                            [
                                63.28324,
                                75.58224
                            ],
                            [
                                63.66889,
                                75.67911
                            ],
                            [
                                63.91665,
                                75.67034
                            ],
                            [
                                64.09953,
                                75.71257
                            ],
                            [
                                64.32041,
                                75.71747
                            ],
                            [
                                64.88025,
                                75.79194
                            ],
                            [
                                65.0394,
                                75.78918
                            ],
                            [
                                65.42342,
                                75.86825
                            ],
                            [
                                65.94302,
                                75.93431
                            ],
                            [
                                66.50088,
                                75.98936
                            ],
                            [
                                66.72167,
                                76.04107
                            ],
                            [
                                67.05941,
                                76.06733
                            ],
                            [
                                67.43588,
                                76.15146
                            ],
                            [
                                68.10464,
                                76.24924
                            ],
                            [
                                68.58242,
                                76.40749
                            ],
                            [
                                68.7436,
                                76.49492
                            ],
                            [
                                68.85268,
                                76.63372
                            ],
                            [
                                68.99538,
                                76.67219
                            ],
                            [
                                68.96185,
                                76.78689
                            ],
                            [
                                68.83509,
                                76.86453
                            ],
                            [
                                68.52057,
                                76.92049
                            ],
                            [
                                68.48479,
                                76.95621
                            ],
                            [
                                67.7989,
                                76.99537
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                142.78914,
                                54.29421
                            ],
                            [
                                142.71583,
                                54.40466
                            ],
                            [
                                142.60501,
                                54.3108
                            ],
                            [
                                142.49125,
                                54.27705
                            ],
                            [
                                142.32879,
                                54.26157
                            ],
                            [
                                142.41892,
                                54.14852
                            ],
                            [
                                142.68443,
                                53.94141
                            ],
                            [
                                142.65902,
                                53.80961
                            ],
                            [
                                142.74944,
                                53.80875
                            ],
                            [
                                142.78795,
                                53.70424
                            ],
                            [
                                142.72988,
                                53.63397
                            ],
                            [
                                142.63862,
                                53.67119
                            ],
                            [
                                142.48724,
                                53.6547
                            ],
                            [
                                142.49249,
                                53.56075
                            ],
                            [
                                142.59172,
                                53.55952
                            ],
                            [
                                142.45277,
                                53.37236
                            ],
                            [
                                142.30156,
                                53.3596
                            ],
                            [
                                142.23515,
                                53.37647
                            ],
                            [
                                142.22735,
                                53.5299
                            ],
                            [
                                141.85951,
                                53.42815
                            ],
                            [
                                141.76791,
                                53.37982
                            ],
                            [
                                141.78394,
                                53.25857
                            ],
                            [
                                141.84232,
                                53.13601
                            ],
                            [
                                141.91746,
                                53.05309
                            ],
                            [
                                141.84696,
                                52.84797
                            ],
                            [
                                141.82132,
                                52.55512
                            ],
                            [
                                141.75998,
                                52.46109
                            ],
                            [
                                141.65071,
                                52.39243
                            ],
                            [
                                141.62471,
                                52.32024
                            ],
                            [
                                141.63935,
                                52.22939
                            ],
                            [
                                141.68523,
                                52.15912
                            ],
                            [
                                141.62736,
                                52.0712
                            ],
                            [
                                141.68009,
                                51.96845
                            ],
                            [
                                141.63756,
                                51.87754
                            ],
                            [
                                141.73228,
                                51.85485
                            ],
                            [
                                141.8174,
                                51.79276
                            ],
                            [
                                141.76365,
                                51.71599
                            ],
                            [
                                141.89048,
                                51.60241
                            ],
                            [
                                142.07676,
                                51.47018
                            ],
                            [
                                142.06572,
                                51.42636
                            ],
                            [
                                142.17111,
                                51.31091
                            ],
                            [
                                142.16374,
                                51.2698
                            ],
                            [
                                142.24759,
                                51.14979
                            ],
                            [
                                142.24319,
                                51.03356
                            ],
                            [
                                142.16937,
                                50.92417
                            ],
                            [
                                142.11733,
                                50.8908
                            ],
                            [
                                142.0873,
                                50.71459
                            ],
                            [
                                142.04075,
                                50.55104
                            ],
                            [
                                142.13685,
                                50.38088
                            ],
                            [
                                142.16671,
                                50.14066
                            ],
                            [
                                142.12693,
                                49.88586
                            ],
                            [
                                142.1583,
                                49.79483
                            ],
                            [
                                142.12546,
                                49.45503
                            ],
                            [
                                142.0708,
                                49.35251
                            ],
                            [
                                142.08636,
                                49.21819
                            ],
                            [
                                142.03123,
                                49.14333
                            ],
                            [
                                142.03546,
                                49.0819
                            ],
                            [
                                141.97151,
                                48.87522
                            ],
                            [
                                141.84291,
                                48.76971
                            ],
                            [
                                141.86927,
                                48.67668
                            ],
                            [
                                141.94646,
                                48.56509
                            ],
                            [
                                142.07723,
                                48.42251
                            ],
                            [
                                142.13984,
                                48.32836
                            ],
                            [
                                142.16603,
                                48.20801
                            ],
                            [
                                142.19322,
                                47.94765
                            ],
                            [
                                142.1016,
                                47.87166
                            ],
                            [
                                142.06889,
                                47.77344
                            ],
                            [
                                141.96824,
                                47.61497
                            ],
                            [
                                141.96974,
                                47.44791
                            ],
                            [
                                142.00153,
                                47.36157
                            ],
                            [
                                141.97321,
                                47.30535
                            ],
                            [
                                142.0589,
                                47.16321
                            ],
                            [
                                142.05815,
                                47.07975
                            ],
                            [
                                141.98909,
                                46.90336
                            ],
                            [
                                141.92324,
                                46.81353
                            ],
                            [
                                141.84777,
                                46.62278
                            ],
                            [
                                141.8159,
                                46.59266
                            ],
                            [
                                141.82566,
                                46.47374
                            ],
                            [
                                141.88672,
                                46.3165
                            ],
                            [
                                141.93222,
                                46.1026
                            ],
                            [
                                141.92461,
                                46.04248
                            ],
                            [
                                142.0364,
                                45.92613
                            ],
                            [
                                142.17477,
                                46.0134
                            ],
                            [
                                142.2432,
                                46.16974
                            ],
                            [
                                142.25736,
                                46.2839
                            ],
                            [
                                142.45948,
                                46.64513
                            ],
                            [
                                142.59389,
                                46.71682
                            ],
                            [
                                142.72951,
                                46.73604
                            ],
                            [
                                142.76941,
                                46.60876
                            ],
                            [
                                142.88946,
                                46.62059
                            ],
                            [
                                143.06727,
                                46.5915
                            ],
                            [
                                143.14366,
                                46.60307
                            ],
                            [
                                143.24017,
                                46.5584
                            ],
                            [
                                143.33343,
                                46.46945
                            ],
                            [
                                143.33811,
                                46.38023
                            ],
                            [
                                143.42331,
                                46.20197
                            ],
                            [
                                143.39897,
                                46.09792
                            ],
                            [
                                143.46654,
                                46.09887
                            ],
                            [
                                143.46814,
                                46.19084
                            ],
                            [
                                143.61209,
                                46.38214
                            ],
                            [
                                143.56415,
                                46.4088
                            ],
                            [
                                143.48262,
                                46.81369
                            ],
                            [
                                143.29806,
                                46.79858
                            ],
                            [
                                143.17968,
                                46.84787
                            ],
                            [
                                143.10112,
                                46.94297
                            ],
                            [
                                143.0259,
                                47.07772
                            ],
                            [
                                143.04715,
                                47.14445
                            ],
                            [
                                143.02148,
                                47.25386
                            ],
                            [
                                142.94056,
                                47.35496
                            ],
                            [
                                142.72992,
                                47.46818
                            ],
                            [
                                142.65269,
                                47.55006
                            ],
                            [
                                142.57253,
                                47.67602
                            ],
                            [
                                142.52535,
                                47.89214
                            ],
                            [
                                142.56661,
                                48.11135
                            ],
                            [
                                142.67624,
                                48.32835
                            ],
                            [
                                142.74388,
                                48.52153
                            ],
                            [
                                142.81367,
                                48.66696
                            ],
                            [
                                142.97297,
                                48.89027
                            ],
                            [
                                142.94845,
                                49.01821
                            ],
                            [
                                142.96815,
                                49.10712
                            ],
                            [
                                143.08284,
                                49.20583
                            ],
                            [
                                143.32313,
                                49.29573
                            ],
                            [
                                143.57486,
                                49.31927
                            ],
                            [
                                143.85193,
                                49.29607
                            ],
                            [
                                144.02992,
                                49.26031
                            ],
                            [
                                144.13225,
                                49.22441
                            ],
                            [
                                144.28198,
                                49.0801
                            ],
                            [
                                144.42934,
                                49.00394
                            ],
                            [
                                144.57876,
                                48.87153
                            ],
                            [
                                144.64479,
                                48.78942
                            ],
                            [
                                144.68961,
                                48.86213
                            ],
                            [
                                144.40619,
                                49.0292
                            ],
                            [
                                144.2861,
                                49.24914
                            ],
                            [
                                144.22061,
                                49.42493
                            ],
                            [
                                144.23637,
                                49.50951
                            ],
                            [
                                144.13772,
                                49.62136
                            ],
                            [
                                144.12401,
                                49.74093
                            ],
                            [
                                143.99624,
                                49.96595
                            ],
                            [
                                143.99193,
                                50.01603
                            ],
                            [
                                143.83817,
                                50.22665
                            ],
                            [
                                143.71849,
                                50.4966
                            ],
                            [
                                143.69276,
                                50.66002
                            ],
                            [
                                143.60656,
                                50.97808
                            ],
                            [
                                143.5249,
                                51.22462
                            ],
                            [
                                143.37731,
                                51.34963
                            ],
                            [
                                143.45253,
                                51.42765
                            ],
                            [
                                143.4255,
                                51.50722
                            ],
                            [
                                143.20776,
                                51.51645
                            ],
                            [
                                143.24777,
                                51.68494
                            ],
                            [
                                143.2879,
                                51.76766
                            ],
                            [
                                143.23495,
                                51.85212
                            ],
                            [
                                143.16251,
                                51.86469
                            ],
                            [
                                143.10543,
                                51.93422
                            ],
                            [
                                143.13832,
                                51.98328
                            ],
                            [
                                143.11985,
                                52.10217
                            ],
                            [
                                143.17448,
                                52.31593
                            ],
                            [
                                143.11659,
                                52.3483
                            ],
                            [
                                143.21659,
                                52.49601
                            ],
                            [
                                143.23188,
                                52.58935
                            ],
                            [
                                143.29081,
                                52.58492
                            ],
                            [
                                143.32391,
                                52.83145
                            ],
                            [
                                143.16272,
                                52.93562
                            ],
                            [
                                143.05115,
                                53.23972
                            ],
                            [
                                143.12284,
                                53.27135
                            ],
                            [
                                143.14949,
                                53.18153
                            ],
                            [
                                143.25752,
                                53.15785
                            ],
                            [
                                143.19988,
                                53.31167
                            ],
                            [
                                143.0671,
                                53.53423
                            ],
                            [
                                142.98973,
                                53.52972
                            ],
                            [
                                143.00501,
                                53.63809
                            ],
                            [
                                142.93514,
                                53.74439
                            ],
                            [
                                142.87935,
                                53.88869
                            ],
                            [
                                142.90094,
                                53.97976
                            ],
                            [
                                142.9907,
                                54.07715
                            ],
                            [
                                142.96191,
                                54.1422
                            ],
                            [
                                142.78914,
                                54.29421
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                55.20047,
                                73.37458
                            ],
                            [
                                54.90237,
                                73.42569
                            ],
                            [
                                54.50507,
                                73.36152
                            ],
                            [
                                54.373,
                                73.28801
                            ],
                            [
                                54.21659,
                                73.25292
                            ],
                            [
                                53.89447,
                                73.29007
                            ],
                            [
                                53.55276,
                                73.22055
                            ],
                            [
                                53.38007,
                                73.219
                            ],
                            [
                                53.16851,
                                73.12761
                            ],
                            [
                                53.08468,
                                72.93016
                            ],
                            [
                                52.57148,
                                72.84734
                            ],
                            [
                                52.4807,
                                72.79277
                            ],
                            [
                                52.46089,
                                72.70877
                            ],
                            [
                                52.56246,
                                72.66074
                            ],
                            [
                                52.81607,
                                72.64729
                            ],
                            [
                                52.78239,
                                72.54029
                            ],
                            [
                                52.88224,
                                72.49429
                            ],
                            [
                                52.69566,
                                72.40968
                            ],
                            [
                                52.63022,
                                72.33611
                            ],
                            [
                                52.70464,
                                72.28921
                            ],
                            [
                                52.49648,
                                72.26195
                            ],
                            [
                                52.36044,
                                72.04236
                            ],
                            [
                                52.21487,
                                72.08598
                            ],
                            [
                                51.94749,
                                72.10273
                            ],
                            [
                                51.87383,
                                72.1487
                            ],
                            [
                                51.5795,
                                72.06172
                            ],
                            [
                                51.50071,
                                71.96791
                            ],
                            [
                                51.42876,
                                71.7938
                            ],
                            [
                                51.61489,
                                71.53974
                            ],
                            [
                                51.90082,
                                71.45922
                            ],
                            [
                                52.09276,
                                71.45827
                            ],
                            [
                                52.40933,
                                71.50235
                            ],
                            [
                                52.52028,
                                71.56907
                            ],
                            [
                                52.71245,
                                71.52426
                            ],
                            [
                                52.7337,
                                71.46198
                            ],
                            [
                                53.15861,
                                71.44956
                            ],
                            [
                                53.29107,
                                71.42642
                            ],
                            [
                                53.33159,
                                71.3344
                            ],
                            [
                                53.55823,
                                71.19235
                            ],
                            [
                                53.72226,
                                71.15245
                            ],
                            [
                                53.83012,
                                71.17218
                            ],
                            [
                                54.11748,
                                71.09818
                            ],
                            [
                                53.55407,
                                71.03492
                            ],
                            [
                                53.75756,
                                70.94942
                            ],
                            [
                                53.63404,
                                70.86049
                            ],
                            [
                                53.75026,
                                70.77548
                            ],
                            [
                                53.91676,
                                70.78517
                            ],
                            [
                                54.01055,
                                70.72757
                            ],
                            [
                                54.44835,
                                70.73031
                            ],
                            [
                                54.68083,
                                70.74396
                            ],
                            [
                                54.74041,
                                70.66663
                            ],
                            [
                                55.15525,
                                70.54865
                            ],
                            [
                                55.31526,
                                70.6013
                            ],
                            [
                                55.23619,
                                70.63934
                            ],
                            [
                                55.45806,
                                70.69636
                            ],
                            [
                                55.59476,
                                70.6826
                            ],
                            [
                                55.88275,
                                70.58093
                            ],
                            [
                                56.07809,
                                70.65268
                            ],
                            [
                                56.38489,
                                70.56741
                            ],
                            [
                                56.51928,
                                70.58678
                            ],
                            [
                                56.35518,
                                70.70048
                            ],
                            [
                                56.71362,
                                70.61759
                            ],
                            [
                                57.09082,
                                70.55716
                            ],
                            [
                                57.13014,
                                70.61196
                            ],
                            [
                                57.40716,
                                70.61833
                            ],
                            [
                                57.5731,
                                70.71973
                            ],
                            [
                                57.403,
                                70.79897
                            ],
                            [
                                57.04129,
                                70.84908
                            ],
                            [
                                56.86913,
                                70.9295
                            ],
                            [
                                56.61799,
                                71.01247
                            ],
                            [
                                56.36228,
                                71.13297
                            ],
                            [
                                56.19991,
                                71.18553
                            ],
                            [
                                56.03352,
                                71.30768
                            ],
                            [
                                55.9166,
                                71.42903
                            ],
                            [
                                55.73108,
                                71.55663
                            ],
                            [
                                55.57676,
                                71.70597
                            ],
                            [
                                55.53452,
                                71.84667
                            ],
                            [
                                55.34083,
                                71.9751
                            ],
                            [
                                55.42593,
                                72.04129
                            ],
                            [
                                55.41983,
                                72.11686
                            ],
                            [
                                55.57351,
                                72.17114
                            ],
                            [
                                55.32959,
                                72.28843
                            ],
                            [
                                55.46817,
                                72.36233
                            ],
                            [
                                55.45011,
                                72.43791
                            ],
                            [
                                55.51751,
                                72.5304
                            ],
                            [
                                55.63817,
                                72.54377
                            ],
                            [
                                55.64945,
                                72.64564
                            ],
                            [
                                55.90526,
                                72.65238
                            ],
                            [
                                55.8407,
                                72.78719
                            ],
                            [
                                56.09807,
                                72.78261
                            ],
                            [
                                56.20886,
                                72.85434
                            ],
                            [
                                56.1758,
                                72.96003
                            ],
                            [
                                55.87948,
                                72.92596
                            ],
                            [
                                55.80455,
                                72.95877
                            ],
                            [
                                56.41407,
                                73.02236
                            ],
                            [
                                56.19755,
                                73.06603
                            ],
                            [
                                56.54171,
                                73.10482
                            ],
                            [
                                56.54944,
                                73.15745
                            ],
                            [
                                56.34636,
                                73.22807
                            ],
                            [
                                56.00082,
                                73.24828
                            ],
                            [
                                55.68351,
                                73.32661
                            ],
                            [
                                55.39754,
                                73.3185
                            ],
                            [
                                55.20047,
                                73.37458
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                139.15663,
                                76.19615
                            ],
                            [
                                138.84585,
                                76.20018
                            ],
                            [
                                138.32615,
                                76.12603
                            ],
                            [
                                138.10273,
                                76.00136
                            ],
                            [
                                137.66621,
                                75.99199
                            ],
                            [
                                137.44061,
                                75.89109
                            ],
                            [
                                137.62335,
                                75.79342
                            ],
                            [
                                137.49793,
                                75.75089
                            ],
                            [
                                137.26477,
                                75.76324
                            ],
                            [
                                137.16732,
                                75.72028
                            ],
                            [
                                137.28267,
                                75.61177
                            ],
                            [
                                137.20363,
                                75.54806
                            ],
                            [
                                137.30813,
                                75.47712
                            ],
                            [
                                137.18221,
                                75.42882
                            ],
                            [
                                137.20743,
                                75.37707
                            ],
                            [
                                136.95284,
                                75.34382
                            ],
                            [
                                136.9796,
                                75.25175
                            ],
                            [
                                137.37271,
                                75.06467
                            ],
                            [
                                137.89161,
                                74.93994
                            ],
                            [
                                138.02304,
                                74.83576
                            ],
                            [
                                138.19962,
                                74.76112
                            ],
                            [
                                138.78021,
                                74.70687
                            ],
                            [
                                139.06766,
                                74.6423
                            ],
                            [
                                139.24701,
                                74.64291
                            ],
                            [
                                139.46834,
                                74.70473
                            ],
                            [
                                139.5976,
                                74.79658
                            ],
                            [
                                139.57949,
                                74.93171
                            ],
                            [
                                139.80334,
                                74.95592
                            ],
                            [
                                140.05694,
                                74.88711
                            ],
                            [
                                140.10486,
                                74.80119
                            ],
                            [
                                140.65385,
                                74.86724
                            ],
                            [
                                141.6246,
                                74.94132
                            ],
                            [
                                141.8839,
                                75.00462
                            ],
                            [
                                142.10274,
                                74.99891
                            ],
                            [
                                142.00385,
                                74.92591
                            ],
                            [
                                142.43185,
                                74.80753
                            ],
                            [
                                142.5676,
                                74.80418
                            ],
                            [
                                142.93314,
                                74.8728
                            ],
                            [
                                143.5572,
                                74.90166
                            ],
                            [
                                143.70268,
                                74.93698
                            ],
                            [
                                143.52284,
                                75.05939
                            ],
                            [
                                143.79079,
                                75.07061
                            ],
                            [
                                143.98192,
                                75.01278
                            ],
                            [
                                144.4062,
                                75.05156
                            ],
                            [
                                144.74159,
                                75.14878
                            ],
                            [
                                144.85936,
                                75.29379
                            ],
                            [
                                144.79178,
                                75.3743
                            ],
                            [
                                144.8755,
                                75.42565
                            ],
                            [
                                145.20197,
                                75.50356
                            ],
                            [
                                145.40233,
                                75.51682
                            ],
                            [
                                145.14659,
                                75.59736
                            ],
                            [
                                144.89819,
                                75.63051
                            ],
                            [
                                144.68306,
                                75.69862
                            ],
                            [
                                144.34281,
                                75.7214
                            ],
                            [
                                144.0672,
                                75.80471
                            ],
                            [
                                143.5327,
                                75.85396
                            ],
                            [
                                143.19148,
                                75.80043
                            ],
                            [
                                142.63918,
                                75.85558
                            ],
                            [
                                142.11803,
                                76.00677
                            ],
                            [
                                141.81108,
                                76.11165
                            ],
                            [
                                141.31229,
                                76.05364
                            ],
                            [
                                141.06129,
                                76.05844
                            ],
                            [
                                140.92928,
                                75.89144
                            ],
                            [
                                140.92497,
                                75.62799
                            ],
                            [
                                140.72585,
                                75.70398
                            ],
                            [
                                140.5792,
                                75.70804
                            ],
                            [
                                140.50996,
                                75.78223
                            ],
                            [
                                140.16524,
                                75.80345
                            ],
                            [
                                139.85722,
                                75.87251
                            ],
                            [
                                139.98557,
                                75.95315
                            ],
                            [
                                139.60168,
                                75.99057
                            ],
                            [
                                139.45075,
                                76.05063
                            ],
                            [
                                139.07914,
                                76.1301
                            ],
                            [
                                139.15663,
                                76.19615
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                97.27003,
                                80.15694
                            ],
                            [
                                96.48055,
                                80.09475
                            ],
                            [
                                95.50829,
                                80.10282
                            ],
                            [
                                94.77467,
                                80.04197
                            ],
                            [
                                94.35162,
                                79.89418
                            ],
                            [
                                94.73726,
                                79.80861
                            ],
                            [
                                94.10744,
                                79.76994
                            ],
                            [
                                93.81416,
                                79.66541
                            ],
                            [
                                93.32049,
                                79.552
                            ],
                            [
                                93.71963,
                                79.56044
                            ],
                            [
                                93.94254,
                                79.52626
                            ],
                            [
                                93.79733,
                                79.47734
                            ],
                            [
                                94.38136,
                                79.48773
                            ],
                            [
                                94.46521,
                                79.27853
                            ],
                            [
                                94.40609,
                                79.23746
                            ],
                            [
                                94.7282,
                                79.17971
                            ],
                            [
                                94.67959,
                                79.1202
                            ],
                            [
                                94.88011,
                                79.05277
                            ],
                            [
                                95.10611,
                                79.02619
                            ],
                            [
                                95.63862,
                                79.09742
                            ],
                            [
                                95.73829,
                                78.99421
                            ],
                            [
                                96.0321,
                                78.97951
                            ],
                            [
                                96.32399,
                                79.01357
                            ],
                            [
                                96.50784,
                                78.98209
                            ],
                            [
                                96.96387,
                                78.98717
                            ],
                            [
                                96.98321,
                                78.93491
                            ],
                            [
                                97.37404,
                                78.87769
                            ],
                            [
                                97.66571,
                                78.80882
                            ],
                            [
                                97.92927,
                                78.83043
                            ],
                            [
                                98.33823,
                                78.80132
                            ],
                            [
                                99.17771,
                                78.80096
                            ],
                            [
                                99.59459,
                                78.84308
                            ],
                            [
                                100.04856,
                                78.94768
                            ],
                            [
                                99.93197,
                                79.09415
                            ],
                            [
                                99.77655,
                                79.14903
                            ],
                            [
                                99.31422,
                                79.24509
                            ],
                            [
                                99.84324,
                                79.27595
                            ],
                            [
                                99.81951,
                                79.44379
                            ],
                            [
                                99.99582,
                                79.74898
                            ],
                            [
                                100.155,
                                79.78369
                            ],
                            [
                                99.91974,
                                79.90048
                            ],
                            [
                                99.29663,
                                80.06159
                            ],
                            [
                                98.73182,
                                80.06145
                            ],
                            [
                                98.48676,
                                80.03335
                            ],
                            [
                                98.2755,
                                79.8244
                            ],
                            [
                                97.85331,
                                79.79321
                            ],
                            [
                                97.26977,
                                79.78566
                            ],
                            [
                                97.97374,
                                79.90339
                            ],
                            [
                                97.92267,
                                80.01135
                            ],
                            [
                                98.10124,
                                80.04054
                            ],
                            [
                                97.68404,
                                80.15608
                            ],
                            [
                                97.27003,
                                80.15694
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                102.96878,
                                79.32158
                            ],
                            [
                                102.90274,
                                79.35937
                            ],
                            [
                                102.33249,
                                79.39671
                            ],
                            [
                                102.23792,
                                79.33415
                            ],
                            [
                                102.33791,
                                79.19818
                            ],
                            [
                                102.03371,
                                79.21938
                            ],
                            [
                                101.90634,
                                79.34048
                            ],
                            [
                                101.68743,
                                79.32189
                            ],
                            [
                                101.69363,
                                79.21108
                            ],
                            [
                                101.40951,
                                79.2043
                            ],
                            [
                                101.16439,
                                79.07084
                            ],
                            [
                                100.87148,
                                78.83869
                            ],
                            [
                                100.43191,
                                78.66196
                            ],
                            [
                                100.1518,
                                78.41513
                            ],
                            [
                                100.09227,
                                78.30577
                            ],
                            [
                                99.74734,
                                78.18579
                            ],
                            [
                                99.49361,
                                78.02908
                            ],
                            [
                                99.58192,
                                77.96459
                            ],
                            [
                                100.09215,
                                77.94947
                            ],
                            [
                                100.62288,
                                78.05195
                            ],
                            [
                                100.87667,
                                78.08087
                            ],
                            [
                                101.27165,
                                78.16978
                            ],
                            [
                                101.591,
                                78.19356
                            ],
                            [
                                103.26749,
                                78.21053
                            ],
                            [
                                103.73088,
                                78.23801
                            ],
                            [
                                104.33311,
                                78.31588
                            ],
                            [
                                104.85316,
                                78.3134
                            ],
                            [
                                105.15602,
                                78.41092
                            ],
                            [
                                105.35427,
                                78.5034
                            ],
                            [
                                105.32235,
                                78.69913
                            ],
                            [
                                105.19815,
                                78.79547
                            ],
                            [
                                104.8604,
                                78.84609
                            ],
                            [
                                104.48147,
                                78.84235
                            ],
                            [
                                104.51953,
                                78.91989
                            ],
                            [
                                104.38866,
                                78.97001
                            ],
                            [
                                103.99321,
                                79.04749
                            ],
                            [
                                104.05048,
                                79.1164
                            ],
                            [
                                103.82092,
                                79.13111
                            ],
                            [
                                103.3675,
                                79.07844
                            ],
                            [
                                102.97772,
                                79.00099
                            ],
                            [
                                102.74907,
                                79.04931
                            ],
                            [
                                102.85199,
                                79.1524
                            ],
                            [
                                103.18465,
                                79.29423
                            ],
                            [
                                102.96878,
                                79.32158
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                96.00128,
                                81.21071
                            ],
                            [
                                95.88139,
                                81.25647
                            ],
                            [
                                95.17862,
                                81.24311
                            ],
                            [
                                95.36203,
                                81.18988
                            ],
                            [
                                94.91033,
                                81.1044
                            ],
                            [
                                93.82746,
                                81.01472
                            ],
                            [
                                93.19494,
                                80.93827
                            ],
                            [
                                93.14677,
                                80.86255
                            ],
                            [
                                92.88475,
                                80.82983
                            ],
                            [
                                92.62755,
                                80.70206
                            ],
                            [
                                93.33992,
                                80.72476
                            ],
                            [
                                92.95342,
                                80.62164
                            ],
                            [
                                92.89187,
                                80.48662
                            ],
                            [
                                91.98887,
                                80.40812
                            ],
                            [
                                92.57638,
                                80.36534
                            ],
                            [
                                91.73264,
                                80.32555
                            ],
                            [
                                91.48977,
                                80.26992
                            ],
                            [
                                92.00155,
                                80.26495
                            ],
                            [
                                92.35108,
                                80.21822
                            ],
                            [
                                92.45824,
                                80.12277
                            ],
                            [
                                92.73789,
                                80.12372
                            ],
                            [
                                93.591,
                                80.0118
                            ],
                            [
                                93.8231,
                                80.00943
                            ],
                            [
                                94.34901,
                                80.06677
                            ],
                            [
                                94.49984,
                                80.12223
                            ],
                            [
                                95.40147,
                                80.1656
                            ],
                            [
                                95.67613,
                                80.20179
                            ],
                            [
                                96.98736,
                                80.21615
                            ],
                            [
                                97.46785,
                                80.28972
                            ],
                            [
                                97.26391,
                                80.33443
                            ],
                            [
                                97.24902,
                                80.43117
                            ],
                            [
                                97.11954,
                                80.51254
                            ],
                            [
                                97.24382,
                                80.61293
                            ],
                            [
                                97.78648,
                                80.6359
                            ],
                            [
                                98.01993,
                                80.66844
                            ],
                            [
                                97.8164,
                                80.78816
                            ],
                            [
                                97.46549,
                                80.81437
                            ],
                            [
                                96.86243,
                                80.90118
                            ],
                            [
                                96.7763,
                                80.98332
                            ],
                            [
                                96.27895,
                                81.10578
                            ],
                            [
                                96.00128,
                                81.21071
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                147.02431,
                                75.32186
                            ],
                            [
                                146.80961,
                                75.34967
                            ],
                            [
                                146.66068,
                                75.43062
                            ],
                            [
                                146.76081,
                                75.50997
                            ],
                            [
                                146.53139,
                                75.58918
                            ],
                            [
                                146.40188,
                                75.54368
                            ],
                            [
                                146.37479,
                                75.44436
                            ],
                            [
                                146.24215,
                                75.38895
                            ],
                            [
                                146.31312,
                                75.27683
                            ],
                            [
                                146.17528,
                                75.21955
                            ],
                            [
                                146.3457,
                                75.16455
                            ],
                            [
                                146.75115,
                                75.10852
                            ],
                            [
                                147.10716,
                                75.01321
                            ],
                            [
                                147.70153,
                                74.95062
                            ],
                            [
                                148.07444,
                                74.80962
                            ],
                            [
                                148.22695,
                                74.77566
                            ],
                            [
                                148.72251,
                                74.7361
                            ],
                            [
                                149.23547,
                                74.73124
                            ],
                            [
                                149.64894,
                                74.7612
                            ],
                            [
                                150.09156,
                                74.81552
                            ],
                            [
                                150.66398,
                                74.86643
                            ],
                            [
                                150.69643,
                                74.9967
                            ],
                            [
                                150.9759,
                                75.12002
                            ],
                            [
                                150.82764,
                                75.14605
                            ],
                            [
                                150.53626,
                                75.09611
                            ],
                            [
                                150.15126,
                                75.20702
                            ],
                            [
                                149.79489,
                                75.22333
                            ],
                            [
                                149.33324,
                                75.26397
                            ],
                            [
                                148.69395,
                                75.19477
                            ],
                            [
                                148.58561,
                                75.21549
                            ],
                            [
                                148.51277,
                                75.3017
                            ],
                            [
                                148.57373,
                                75.37393
                            ],
                            [
                                148.40021,
                                75.40408
                            ],
                            [
                                148.02442,
                                75.39291
                            ],
                            [
                                147.6299,
                                75.44245
                            ],
                            [
                                147.42179,
                                75.42892
                            ],
                            [
                                147.16598,
                                75.32234
                            ],
                            [
                                147.02431,
                                75.32186
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                22.7921,
                                54.36336
                            ],
                            [
                                22.70276,
                                54.45354
                            ],
                            [
                                22.68519,
                                54.58916
                            ],
                            [
                                22.75638,
                                54.65324
                            ],
                            [
                                22.72449,
                                54.68594
                            ],
                            [
                                22.77536,
                                54.75105
                            ],
                            [
                                22.87254,
                                54.79743
                            ],
                            [
                                22.85403,
                                54.88754
                            ],
                            [
                                22.64298,
                                54.98319
                            ],
                            [
                                22.58897,
                                55.07025
                            ],
                            [
                                22.46304,
                                55.04444
                            ],
                            [
                                22.29129,
                                55.06474
                            ],
                            [
                                22.03126,
                                55.05391
                            ],
                            [
                                21.72084,
                                55.13396
                            ],
                            [
                                21.65107,
                                55.17998
                            ],
                            [
                                21.50239,
                                55.18677
                            ],
                            [
                                21.38282,
                                55.29441
                            ],
                            [
                                21.27351,
                                55.24565
                            ],
                            [
                                21.17983,
                                55.19304
                            ],
                            [
                                21.22428,
                                55.01031
                            ],
                            [
                                21.21554,
                                54.92386
                            ],
                            [
                                20.99074,
                                54.89262
                            ],
                            [
                                20.85645,
                                54.90704
                            ],
                            [
                                20.81745,
                                54.93779
                            ],
                            [
                                20.60348,
                                54.94282
                            ],
                            [
                                20.54193,
                                54.97338
                            ],
                            [
                                20.3621,
                                54.94202
                            ],
                            [
                                20.03248,
                                54.94638
                            ],
                            [
                                19.95221,
                                54.93233
                            ],
                            [
                                19.93209,
                                54.86491
                            ],
                            [
                                19.99894,
                                54.72291
                            ],
                            [
                                20.26705,
                                54.68905
                            ],
                            [
                                20.37773,
                                54.65774
                            ],
                            [
                                20.03611,
                                54.56388
                            ],
                            [
                                19.80377,
                                54.44241
                            ],
                            [
                                20.51337,
                                54.38099
                            ],
                            [
                                21.00608,
                                54.35357
                            ],
                            [
                                21.27454,
                                54.32862
                            ],
                            [
                                21.49542,
                                54.32384
                            ],
                            [
                                22.31591,
                                54.34062
                            ],
                            [
                                22.7921,
                                54.36336
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                142.29732,
                                73.86272
                            ],
                            [
                                142.09027,
                                73.91753
                            ],
                            [
                                141.86092,
                                73.90912
                            ],
                            [
                                141.3092,
                                73.8423
                            ],
                            [
                                141.1651,
                                73.8659
                            ],
                            [
                                140.90115,
                                73.74306
                            ],
                            [
                                140.81035,
                                73.6225
                            ],
                            [
                                140.62028,
                                73.51381
                            ],
                            [
                                140.37302,
                                73.44149
                            ],
                            [
                                139.85939,
                                73.43423
                            ],
                            [
                                139.80386,
                                73.40452
                            ],
                            [
                                139.98825,
                                73.34155
                            ],
                            [
                                140.39117,
                                73.40982
                            ],
                            [
                                140.65473,
                                73.43062
                            ],
                            [
                                140.89128,
                                73.41892
                            ],
                            [
                                141.42117,
                                73.31982
                            ],
                            [
                                141.63269,
                                73.29378
                            ],
                            [
                                142.49231,
                                73.22533
                            ],
                            [
                                142.77414,
                                73.23201
                            ],
                            [
                                143.27298,
                                73.1795
                            ],
                            [
                                143.56802,
                                73.2389
                            ],
                            [
                                143.49909,
                                73.34854
                            ],
                            [
                                143.60069,
                                73.44124
                            ],
                            [
                                143.46347,
                                73.54661
                            ],
                            [
                                143.27245,
                                73.62724
                            ],
                            [
                                142.52553,
                                73.84579
                            ],
                            [
                                142.29732,
                                73.86272
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                50.97471,
                                80.85143
                            ],
                            [
                                50.88911,
                                80.94348
                            ],
                            [
                                50.23305,
                                80.8751
                            ],
                            [
                                50.16446,
                                80.9441
                            ],
                            [
                                49.80821,
                                80.9077
                            ],
                            [
                                49.64589,
                                80.84912
                            ],
                            [
                                49.15351,
                                80.77745
                            ],
                            [
                                49.32948,
                                80.69927
                            ],
                            [
                                49.15117,
                                80.51345
                            ],
                            [
                                48.33509,
                                80.54781
                            ],
                            [
                                47.9541,
                                80.52997
                            ],
                            [
                                47.6108,
                                80.48304
                            ],
                            [
                                48.20006,
                                80.45192
                            ],
                            [
                                47.96342,
                                80.39837
                            ],
                            [
                                47.60607,
                                80.39411
                            ],
                            [
                                48.03073,
                                80.29961
                            ],
                            [
                                47.32124,
                                80.30883
                            ],
                            [
                                47.18348,
                                80.37587
                            ],
                            [
                                46.7551,
                                80.31496
                            ],
                            [
                                47.11424,
                                80.16099
                            ],
                            [
                                47.38585,
                                80.22286
                            ],
                            [
                                47.85678,
                                80.24577
                            ],
                            [
                                47.85256,
                                80.16356
                            ],
                            [
                                47.65475,
                                80.07497
                            ],
                            [
                                48.51957,
                                80.12288
                            ],
                            [
                                49.1131,
                                80.16957
                            ],
                            [
                                48.852,
                                80.21237
                            ],
                            [
                                48.89261,
                                80.28072
                            ],
                            [
                                48.52641,
                                80.28039
                            ],
                            [
                                48.77239,
                                80.36782
                            ],
                            [
                                49.57387,
                                80.34701
                            ],
                            [
                                49.74936,
                                80.3682
                            ],
                            [
                                49.66563,
                                80.4779
                            ],
                            [
                                50.21856,
                                80.51922
                            ],
                            [
                                50.84142,
                                80.53148
                            ],
                            [
                                51.05658,
                                80.55867
                            ],
                            [
                                51.80116,
                                80.71231
                            ],
                            [
                                51.29361,
                                80.7962
                            ],
                            [
                                50.28518,
                                80.74555
                            ],
                            [
                                50.97471,
                                80.85143
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -179.09829,
                                71.58748
                            ],
                            [
                                -179.32103,
                                71.53504
                            ],
                            [
                                -179.74712,
                                71.57231
                            ],
                            [
                                -179.84067,
                                71.52291
                            ],
                            [
                                -179.99495,
                                71.52959
                            ],
                            [
                                -180,
                                70.97519
                            ],
                            [
                                -180,
                                70.97481
                            ],
                            [
                                -179.69451,
                                70.94787
                            ],
                            [
                                -179.48002,
                                70.88182
                            ],
                            [
                                -179.14333,
                                70.89931
                            ],
                            [
                                -178.77378,
                                70.95591
                            ],
                            [
                                -177.92398,
                                71.02734
                            ],
                            [
                                -177.59643,
                                71.10877
                            ],
                            [
                                -177.4621,
                                71.21829
                            ],
                            [
                                -177.52901,
                                71.2724
                            ],
                            [
                                -177.73178,
                                71.30124
                            ],
                            [
                                -177.90242,
                                71.3942
                            ],
                            [
                                -178.05966,
                                71.42466
                            ],
                            [
                                -178.11039,
                                71.47559
                            ],
                            [
                                -178.54982,
                                71.55617
                            ],
                            [
                                -179.09829,
                                71.58748
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                49.97657,
                                69.31154
                            ],
                            [
                                49.39565,
                                69.47695
                            ],
                            [
                                49.1997,
                                69.50808
                            ],
                            [
                                48.91174,
                                69.49613
                            ],
                            [
                                48.66856,
                                69.44768
                            ],
                            [
                                48.41371,
                                69.34759
                            ],
                            [
                                48.27804,
                                69.22055
                            ],
                            [
                                48.22673,
                                69.10615
                            ],
                            [
                                48.20641,
                                68.88889
                            ],
                            [
                                48.37361,
                                68.80114
                            ],
                            [
                                48.66933,
                                68.70664
                            ],
                            [
                                49.18387,
                                68.76271
                            ],
                            [
                                49.65567,
                                68.85672
                            ],
                            [
                                49.87857,
                                68.98475
                            ],
                            [
                                49.94503,
                                69.05933
                            ],
                            [
                                50.06938,
                                69.07775
                            ],
                            [
                                50.28865,
                                69.15842
                            ],
                            [
                                50.14847,
                                69.25824
                            ],
                            [
                                49.97657,
                                69.31154
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                62.14025,
                                80.82697
                            ],
                            [
                                62.0436,
                                80.85971
                            ],
                            [
                                61.57595,
                                80.86211
                            ],
                            [
                                61.35648,
                                80.81578
                            ],
                            [
                                60.41339,
                                80.77422
                            ],
                            [
                                60.11684,
                                80.82726
                            ],
                            [
                                59.59972,
                                80.77857
                            ],
                            [
                                59.47147,
                                80.69057
                            ],
                            [
                                59.33807,
                                80.48501
                            ],
                            [
                                59.66539,
                                80.38683
                            ],
                            [
                                60.35282,
                                80.45086
                            ],
                            [
                                60.59775,
                                80.39465
                            ],
                            [
                                61.0877,
                                80.36245
                            ],
                            [
                                61.42174,
                                80.44909
                            ],
                            [
                                61.64702,
                                80.46838
                            ],
                            [
                                61.66028,
                                80.55506
                            ],
                            [
                                62.01151,
                                80.57804
                            ],
                            [
                                62.17843,
                                80.66008
                            ],
                            [
                                62.14025,
                                80.82697
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                64.85752,
                                81.17282
                            ],
                            [
                                64.57553,
                                81.19016
                            ],
                            [
                                64.18954,
                                81.13591
                            ],
                            [
                                64.18832,
                                81.00669
                            ],
                            [
                                63.96778,
                                80.95466
                            ],
                            [
                                63.38316,
                                80.95625
                            ],
                            [
                                62.65315,
                                80.8281
                            ],
                            [
                                62.5206,
                                80.78021
                            ],
                            [
                                63.16407,
                                80.63787
                            ],
                            [
                                63.59866,
                                80.68243
                            ],
                            [
                                64.41569,
                                80.70524
                            ],
                            [
                                64.97897,
                                80.77968
                            ],
                            [
                                65.38487,
                                80.91269
                            ],
                            [
                                65.22106,
                                80.98125
                            ],
                            [
                                65.40277,
                                81.01405
                            ],
                            [
                                65.23464,
                                81.12386
                            ],
                            [
                                64.85752,
                                81.17282
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                59.07317,
                                70.46749
                            ],
                            [
                                58.81023,
                                70.42666
                            ],
                            [
                                58.78733,
                                70.3719
                            ],
                            [
                                58.6463,
                                70.31548
                            ],
                            [
                                58.74474,
                                70.24551
                            ],
                            [
                                58.51916,
                                70.25468
                            ],
                            [
                                58.44556,
                                70.22182
                            ],
                            [
                                58.61123,
                                70.14201
                            ],
                            [
                                58.63227,
                                70.05854
                            ],
                            [
                                58.80465,
                                69.96742
                            ],
                            [
                                59.11376,
                                69.89734
                            ],
                            [
                                59.53877,
                                69.86456
                            ],
                            [
                                59.7144,
                                69.78086
                            ],
                            [
                                59.59049,
                                69.72395
                            ],
                            [
                                59.98985,
                                69.65796
                            ],
                            [
                                60.02032,
                                69.71819
                            ],
                            [
                                60.21968,
                                69.67918
                            ],
                            [
                                60.41548,
                                69.72015
                            ],
                            [
                                60.55338,
                                69.8014
                            ],
                            [
                                60.44468,
                                69.93133
                            ],
                            [
                                60.24752,
                                69.98411
                            ],
                            [
                                60.04674,
                                70.0686
                            ],
                            [
                                59.80114,
                                70.12757
                            ],
                            [
                                59.60324,
                                70.20753
                            ],
                            [
                                59.36542,
                                70.34748
                            ],
                            [
                                59.09314,
                                70.43149
                            ],
                            [
                                59.07317,
                                70.46749
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                91.95702,
                                80.07327
                            ],
                            [
                                91.32714,
                                80.06551
                            ],
                            [
                                91.25717,
                                79.9513
                            ],
                            [
                                91.28956,
                                79.83908
                            ],
                            [
                                92.35432,
                                79.7884
                            ],
                            [
                                91.98175,
                                79.71259
                            ],
                            [
                                91.28042,
                                79.74824
                            ],
                            [
                                91.36073,
                                79.70512
                            ],
                            [
                                91.76268,
                                79.64987
                            ],
                            [
                                92.1084,
                                79.6888
                            ],
                            [
                                92.49236,
                                79.67776
                            ],
                            [
                                93.13337,
                                79.71275
                            ],
                            [
                                93.73138,
                                79.83411
                            ],
                            [
                                93.8983,
                                79.92051
                            ],
                            [
                                93.36176,
                                79.99988
                            ],
                            [
                                93.00912,
                                80.0267
                            ],
                            [
                                92.0495,
                                80.04775
                            ],
                            [
                                91.95702,
                                80.07327
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                179.98062,
                                71.52198
                            ],
                            [
                                179.73007,
                                71.44265
                            ],
                            [
                                179.43836,
                                71.40383
                            ],
                            [
                                179.15963,
                                71.27363
                            ],
                            [
                                178.87942,
                                71.2162
                            ],
                            [
                                178.86083,
                                71.17818
                            ],
                            [
                                178.613,
                                71.07447
                            ],
                            [
                                178.64132,
                                70.97041
                            ],
                            [
                                178.77823,
                                70.80559
                            ],
                            [
                                178.90029,
                                70.81012
                            ],
                            [
                                179.2339,
                                70.87463
                            ],
                            [
                                179.58381,
                                70.86626
                            ],
                            [
                                179.99885,
                                70.97561
                            ],
                            [
                                179.98062,
                                71.52198
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                112.4941,
                                74.52492
                            ],
                            [
                                112.08107,
                                74.55195
                            ],
                            [
                                111.98061,
                                74.51049
                            ],
                            [
                                112.01218,
                                74.38038
                            ],
                            [
                                111.51564,
                                74.33911
                            ],
                            [
                                111.493,
                                74.29145
                            ],
                            [
                                111.65814,
                                74.24374
                            ],
                            [
                                111.94637,
                                74.21988
                            ],
                            [
                                112.2032,
                                74.13365
                            ],
                            [
                                112.8262,
                                74.08087
                            ],
                            [
                                113.01173,
                                74.18935
                            ],
                            [
                                113.17578,
                                74.19295
                            ],
                            [
                                113.46305,
                                74.3755
                            ],
                            [
                                113.34364,
                                74.47245
                            ],
                            [
                                113.16125,
                                74.50501
                            ],
                            [
                                112.4941,
                                74.52492
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                71.30615,
                                73.29132
                            ],
                            [
                                71.39004,
                                73.33486
                            ],
                            [
                                71.2718,
                                73.42784
                            ],
                            [
                                70.99068,
                                73.48076
                            ],
                            [
                                70.78895,
                                73.49098
                            ],
                            [
                                70.30744,
                                73.45113
                            ],
                            [
                                69.98758,
                                73.3863
                            ],
                            [
                                70.02629,
                                73.25238
                            ],
                            [
                                69.9243,
                                73.07234
                            ],
                            [
                                70.1807,
                                73.01979
                            ],
                            [
                                70.44232,
                                73.01966
                            ],
                            [
                                70.89449,
                                73.11356
                            ],
                            [
                                71.14497,
                                73.10964
                            ],
                            [
                                71.36049,
                                73.16282
                            ],
                            [
                                71.64119,
                                73.16548
                            ],
                            [
                                71.62511,
                                73.21927
                            ],
                            [
                                71.46148,
                                73.32386
                            ],
                            [
                                71.30615,
                                73.29132
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                47.66463,
                                80.83551
                            ],
                            [
                                46.11489,
                                80.66221
                            ],
                            [
                                45.52645,
                                80.64761
                            ],
                            [
                                45.01783,
                                80.61579
                            ],
                            [
                                45.02211,
                                80.57333
                            ],
                            [
                                45.4172,
                                80.54842
                            ],
                            [
                                46.08322,
                                80.54927
                            ],
                            [
                                46.03299,
                                80.45152
                            ],
                            [
                                46.27543,
                                80.44253
                            ],
                            [
                                46.52895,
                                80.52761
                            ],
                            [
                                46.87369,
                                80.55471
                            ],
                            [
                                47.26575,
                                80.64582
                            ],
                            [
                                47.52565,
                                80.67323
                            ],
                            [
                                47.6052,
                                80.76295
                            ],
                            [
                                47.98328,
                                80.72226
                            ],
                            [
                                48.13746,
                                80.64836
                            ],
                            [
                                48.71748,
                                80.62302
                            ],
                            [
                                48.59597,
                                80.7754
                            ],
                            [
                                48.2192,
                                80.81463
                            ],
                            [
                                47.9469,
                                80.79729
                            ],
                            [
                                47.66463,
                                80.83551
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                168.37031,
                                70.01519
                            ],
                            [
                                168.26252,
                                70.0123
                            ],
                            [
                                167.92063,
                                69.91222
                            ],
                            [
                                167.77912,
                                69.81005
                            ],
                            [
                                168.10464,
                                69.7353
                            ],
                            [
                                168.16017,
                                69.68455
                            ],
                            [
                                168.37754,
                                69.63092
                            ],
                            [
                                168.91861,
                                69.55373
                            ],
                            [
                                169.2135,
                                69.5537
                            ],
                            [
                                169.29273,
                                69.62032
                            ],
                            [
                                169.28803,
                                69.7633
                            ],
                            [
                                169.45839,
                                69.81152
                            ],
                            [
                                169.41678,
                                69.86022
                            ],
                            [
                                168.83648,
                                69.92549
                            ],
                            [
                                168.37031,
                                70.01519
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                54.92433,
                                81.07724
                            ],
                            [
                                54.46266,
                                81.0276
                            ],
                            [
                                55.03567,
                                80.93301
                            ],
                            [
                                55.3911,
                                80.92236
                            ],
                            [
                                55.77313,
                                80.84556
                            ],
                            [
                                56.66917,
                                80.78156
                            ],
                            [
                                57.01117,
                                80.68407
                            ],
                            [
                                57.60182,
                                80.70351
                            ],
                            [
                                57.81297,
                                80.75616
                            ],
                            [
                                57.58589,
                                80.82012
                            ],
                            [
                                56.8932,
                                80.8758
                            ],
                            [
                                56.65491,
                                80.9575
                            ],
                            [
                                56.02511,
                                81.02355
                            ],
                            [
                                55.49912,
                                80.99964
                            ],
                            [
                                55.24357,
                                81.05718
                            ],
                            [
                                54.92433,
                                81.07724
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                58.07914,
                                80.47579
                            ],
                            [
                                57.0061,
                                80.44643
                            ],
                            [
                                57.29404,
                                80.3464
                            ],
                            [
                                57.34968,
                                80.15301
                            ],
                            [
                                57.85688,
                                80.09329
                            ],
                            [
                                58.43116,
                                80.14239
                            ],
                            [
                                58.4911,
                                80.19812
                            ],
                            [
                                58.10131,
                                80.23098
                            ],
                            [
                                58.64825,
                                80.3253
                            ],
                            [
                                59.31664,
                                80.32091
                            ],
                            [
                                58.91483,
                                80.41884
                            ],
                            [
                                58.07914,
                                80.47579
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                164.61377,
                                59.22999
                            ],
                            [
                                164.40021,
                                59.16822
                            ],
                            [
                                164.31754,
                                59.10766
                            ],
                            [
                                164.20923,
                                59.08775
                            ],
                            [
                                163.92876,
                                58.99523
                            ],
                            [
                                163.77724,
                                58.88476
                            ],
                            [
                                163.74901,
                                58.76314
                            ],
                            [
                                163.64423,
                                58.67356
                            ],
                            [
                                163.68387,
                                58.5961
                            ],
                            [
                                163.88806,
                                58.69991
                            ],
                            [
                                164.20544,
                                58.81587
                            ],
                            [
                                164.46744,
                                58.86566
                            ],
                            [
                                164.65572,
                                58.87013
                            ],
                            [
                                164.71907,
                                58.92288
                            ],
                            [
                                164.7515,
                                59.02874
                            ],
                            [
                                164.65839,
                                59.13033
                            ],
                            [
                                164.61377,
                                59.22999
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                57.00427,
                                80.3502
                            ],
                            [
                                56.70038,
                                80.31416
                            ],
                            [
                                56.24053,
                                80.33121
                            ],
                            [
                                55.94101,
                                80.29647
                            ],
                            [
                                56.15249,
                                80.17767
                            ],
                            [
                                55.82717,
                                80.09042
                            ],
                            [
                                56.10083,
                                80.06165
                            ],
                            [
                                57.02041,
                                80.05735
                            ],
                            [
                                57.17096,
                                80.31636
                            ],
                            [
                                57.00427,
                                80.3502
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                78.34057,
                                72.46002
                            ],
                            [
                                78.19519,
                                72.55318
                            ],
                            [
                                77.74374,
                                72.5999
                            ],
                            [
                                77.53201,
                                72.58376
                            ],
                            [
                                77.30488,
                                72.50375
                            ],
                            [
                                77.20542,
                                72.42377
                            ],
                            [
                                76.94218,
                                72.35877
                            ],
                            [
                                76.92614,
                                72.27283
                            ],
                            [
                                77.24399,
                                72.28887
                            ],
                            [
                                77.80084,
                                72.28541
                            ],
                            [
                                77.87292,
                                72.34818
                            ],
                            [
                                78.0959,
                                72.38881
                            ],
                            [
                                78.34057,
                                72.46002
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                56.64146,
                                81.40962
                            ],
                            [
                                56.31684,
                                81.26844
                            ],
                            [
                                55.5915,
                                81.32063
                            ],
                            [
                                55.46009,
                                81.26488
                            ],
                            [
                                55.56345,
                                81.20875
                            ],
                            [
                                56.35083,
                                81.16482
                            ],
                            [
                                56.65232,
                                81.16628
                            ],
                            [
                                57.53085,
                                81.30691
                            ],
                            [
                                57.01288,
                                81.38755
                            ],
                            [
                                56.64146,
                                81.40962
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                140.80928,
                                73.96209
                            ],
                            [
                                141.07066,
                                74.01833
                            ],
                            [
                                141.06177,
                                74.12039
                            ],
                            [
                                141.12494,
                                74.20307
                            ],
                            [
                                140.85419,
                                74.27442
                            ],
                            [
                                140.41437,
                                74.25797
                            ],
                            [
                                140.24562,
                                74.22035
                            ],
                            [
                                140.20303,
                                74.07412
                            ],
                            [
                                140.41075,
                                73.93491
                            ],
                            [
                                140.52539,
                                73.90745
                            ],
                            [
                                140.80928,
                                73.96209
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                137.76354,
                                55.13959
                            ],
                            [
                                137.63565,
                                55.19453
                            ],
                            [
                                137.5586,
                                55.18108
                            ],
                            [
                                137.48793,
                                55.03961
                            ],
                            [
                                137.34308,
                                54.93187
                            ],
                            [
                                137.27966,
                                54.85193
                            ],
                            [
                                137.26289,
                                54.75353
                            ],
                            [
                                137.4904,
                                54.8567
                            ],
                            [
                                137.61786,
                                54.72605
                            ],
                            [
                                137.6714,
                                54.63999
                            ],
                            [
                                137.73471,
                                54.63882
                            ],
                            [
                                137.95325,
                                54.74792
                            ],
                            [
                                138.01098,
                                54.79057
                            ],
                            [
                                137.9957,
                                54.91046
                            ],
                            [
                                138.11209,
                                54.99212
                            ],
                            [
                                138.05504,
                                55.05472
                            ],
                            [
                                137.88334,
                                55.12583
                            ],
                            [
                                137.76354,
                                55.13959
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                156.10611,
                                50.75447
                            ],
                            [
                                155.97792,
                                50.74581
                            ],
                            [
                                155.85236,
                                50.64376
                            ],
                            [
                                155.83183,
                                50.56323
                            ],
                            [
                                155.7332,
                                50.43949
                            ],
                            [
                                155.63553,
                                50.37597
                            ],
                            [
                                155.41286,
                                50.34886
                            ],
                            [
                                155.37057,
                                50.29301
                            ],
                            [
                                155.23662,
                                50.30603
                            ],
                            [
                                155.21066,
                                50.24628
                            ],
                            [
                                155.26088,
                                50.15334
                            ],
                            [
                                155.21111,
                                50.07046
                            ],
                            [
                                155.31168,
                                50.06127
                            ],
                            [
                                155.42416,
                                50.01759
                            ],
                            [
                                155.46429,
                                50.10423
                            ],
                            [
                                155.61588,
                                50.1867
                            ],
                            [
                                155.76593,
                                50.18123
                            ],
                            [
                                155.88977,
                                50.24759
                            ],
                            [
                                156.02294,
                                50.39807
                            ],
                            [
                                156.05243,
                                50.4761
                            ],
                            [
                                156.1653,
                                50.51106
                            ],
                            [
                                156.16921,
                                50.59876
                            ],
                            [
                                156.1215,
                                50.66107
                            ],
                            [
                                156.10611,
                                50.75447
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                53.38873,
                                80.37885
                            ],
                            [
                                53.0352,
                                80.38749
                            ],
                            [
                                52.64268,
                                80.26153
                            ],
                            [
                                52.25038,
                                80.22454
                            ],
                            [
                                52.69177,
                                80.15437
                            ],
                            [
                                53.54458,
                                80.1433
                            ],
                            [
                                53.94748,
                                80.23
                            ],
                            [
                                53.45349,
                                80.32196
                            ],
                            [
                                53.38873,
                                80.37885
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                79.29539,
                                73.0955
                            ],
                            [
                                79.08047,
                                73.06674
                            ],
                            [
                                78.96854,
                                72.99382
                            ],
                            [
                                78.62011,
                                72.85558
                            ],
                            [
                                78.62593,
                                72.80331
                            ],
                            [
                                79.02739,
                                72.72019
                            ],
                            [
                                79.36137,
                                72.69948
                            ],
                            [
                                79.55907,
                                72.74577
                            ],
                            [
                                79.49922,
                                72.80003
                            ],
                            [
                                79.50804,
                                72.9204
                            ],
                            [
                                79.29539,
                                73.0955
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                91.09909,
                                81.205
                            ],
                            [
                                90.23936,
                                81.183
                            ],
                            [
                                90.09769,
                                81.13507
                            ],
                            [
                                90.20686,
                                81.06922
                            ],
                            [
                                90.71327,
                                81.03595
                            ],
                            [
                                91.34191,
                                81.03793
                            ],
                            [
                                91.7236,
                                81.11284
                            ],
                            [
                                91.60179,
                                81.17816
                            ],
                            [
                                91.09909,
                                81.205
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                61.27189,
                                81.10889
                            ],
                            [
                                60.70746,
                                81.07187
                            ],
                            [
                                60.00123,
                                80.97356
                            ],
                            [
                                60.41786,
                                80.90425
                            ],
                            [
                                60.77781,
                                80.88869
                            ],
                            [
                                61.20644,
                                80.92112
                            ],
                            [
                                61.58058,
                                81.01769
                            ],
                            [
                                61.27189,
                                81.10889
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                56.44807,
                                81.08428
                            ],
                            [
                                56.77804,
                                81.02196
                            ],
                            [
                                57.32783,
                                80.85795
                            ],
                            [
                                57.84867,
                                80.81545
                            ],
                            [
                                58.34104,
                                80.90477
                            ],
                            [
                                57.86559,
                                80.95063
                            ],
                            [
                                57.61823,
                                81.02342
                            ],
                            [
                                57.00882,
                                81.04381
                            ],
                            [
                                56.44807,
                                81.08428
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                57.66722,
                                81.56279
                            ],
                            [
                                57.03513,
                                81.54119
                            ],
                            [
                                56.90556,
                                81.44522
                            ],
                            [
                                57.46053,
                                81.43568
                            ],
                            [
                                57.84022,
                                81.37808
                            ],
                            [
                                58.30226,
                                81.37794
                            ],
                            [
                                58.55337,
                                81.40597
                            ],
                            [
                                58.3592,
                                81.47955
                            ],
                            [
                                58.05547,
                                81.48724
                            ],
                            [
                                57.66722,
                                81.56279
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                52.76552,
                                71.38485
                            ],
                            [
                                52.45733,
                                71.36362
                            ],
                            [
                                52.26482,
                                71.32495
                            ],
                            [
                                52.25927,
                                71.26819
                            ],
                            [
                                52.37526,
                                71.21974
                            ],
                            [
                                52.6091,
                                71.2257
                            ],
                            [
                                52.80342,
                                71.12007
                            ],
                            [
                                52.80692,
                                71.06872
                            ],
                            [
                                52.95379,
                                71.03735
                            ],
                            [
                                53.1809,
                                71.0797
                            ],
                            [
                                53.23901,
                                71.14306
                            ],
                            [
                                53.19255,
                                71.22172
                            ],
                            [
                                52.93484,
                                71.35067
                            ],
                            [
                                52.76552,
                                71.38485
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                165.91998,
                                55.37676
                            ],
                            [
                                165.74829,
                                55.31088
                            ],
                            [
                                165.92811,
                                55.2308
                            ],
                            [
                                166.06418,
                                55.11454
                            ],
                            [
                                166.07646,
                                55.03768
                            ],
                            [
                                166.16542,
                                54.94714
                            ],
                            [
                                166.34048,
                                54.83553
                            ],
                            [
                                166.6767,
                                54.68216
                            ],
                            [
                                166.63138,
                                54.85613
                            ],
                            [
                                166.43298,
                                54.94905
                            ],
                            [
                                166.33486,
                                55.08373
                            ],
                            [
                                166.21718,
                                55.18234
                            ],
                            [
                                166.2064,
                                55.27864
                            ],
                            [
                                166.26646,
                                55.31303
                            ],
                            [
                                166.05881,
                                55.34064
                            ],
                            [
                                165.91998,
                                55.37676
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                56.39553,
                                80.76003
                            ],
                            [
                                55.98804,
                                80.75028
                            ],
                            [
                                55.75112,
                                80.71448
                            ],
                            [
                                55.571,
                                80.62773
                            ],
                            [
                                56.37092,
                                80.59515
                            ],
                            [
                                56.89234,
                                80.62186
                            ],
                            [
                                56.89856,
                                80.71507
                            ],
                            [
                                56.39553,
                                80.76003
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                136.00341,
                                75.45489
                            ],
                            [
                                135.9772,
                                75.48544
                            ],
                            [
                                136.2377,
                                75.62291
                            ],
                            [
                                135.95039,
                                75.69093
                            ],
                            [
                                135.73215,
                                75.82234
                            ],
                            [
                                135.61781,
                                75.65523
                            ],
                            [
                                135.6586,
                                75.60432
                            ],
                            [
                                135.52687,
                                75.39849
                            ],
                            [
                                135.58006,
                                75.36471
                            ],
                            [
                                135.89487,
                                75.37653
                            ],
                            [
                                136.00341,
                                75.45489
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                55.3124,
                                80.83966
                            ],
                            [
                                55.19493,
                                80.87105
                            ],
                            [
                                54.37969,
                                80.86187
                            ],
                            [
                                54.05098,
                                80.80013
                            ],
                            [
                                54.31351,
                                80.77171
                            ],
                            [
                                54.68797,
                                80.77824
                            ],
                            [
                                54.8834,
                                80.71099
                            ],
                            [
                                55.96635,
                                80.76589
                            ],
                            [
                                55.3124,
                                80.83966
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                71.55034,
                                66.86461
                            ],
                            [
                                71.20848,
                                66.8508
                            ],
                            [
                                71.08179,
                                66.79661
                            ],
                            [
                                70.8732,
                                66.80289
                            ],
                            [
                                70.75986,
                                66.75053
                            ],
                            [
                                70.75951,
                                66.66084
                            ],
                            [
                                70.99796,
                                66.5911
                            ],
                            [
                                71.18207,
                                66.59803
                            ],
                            [
                                71.26952,
                                66.63666
                            ],
                            [
                                71.44028,
                                66.61044
                            ],
                            [
                                71.60722,
                                66.64089
                            ],
                            [
                                71.62199,
                                66.71576
                            ],
                            [
                                71.4976,
                                66.82808
                            ],
                            [
                                71.55034,
                                66.86461
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                59.09676,
                                81.85737
                            ],
                            [
                                57.91254,
                                81.81088
                            ],
                            [
                                57.97629,
                                81.71384
                            ],
                            [
                                59.23719,
                                81.73444
                            ],
                            [
                                59.37563,
                                81.8244
                            ],
                            [
                                59.09676,
                                81.85737
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                150.54,
                                46.20383
                            ],
                            [
                                150.35601,
                                46.22436
                            ],
                            [
                                150.19169,
                                46.15838
                            ],
                            [
                                150.19278,
                                46.10158
                            ],
                            [
                                150.0612,
                                46.08758
                            ],
                            [
                                149.89055,
                                45.9571
                            ],
                            [
                                149.81164,
                                45.86533
                            ],
                            [
                                149.68763,
                                45.84967
                            ],
                            [
                                149.60162,
                                45.77435
                            ],
                            [
                                149.55658,
                                45.69983
                            ],
                            [
                                149.4932,
                                45.66408
                            ],
                            [
                                149.44723,
                                45.5902
                            ],
                            [
                                149.54401,
                                45.56914
                            ],
                            [
                                149.68511,
                                45.62054
                            ],
                            [
                                149.9393,
                                45.8116
                            ],
                            [
                                150.01254,
                                45.8168
                            ],
                            [
                                150.14296,
                                45.89035
                            ],
                            [
                                150.2331,
                                46.01969
                            ],
                            [
                                150.54,
                                46.20383
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                63.65099,
                                81.69156
                            ],
                            [
                                63.34746,
                                81.71003
                            ],
                            [
                                62.5078,
                                81.70231
                            ],
                            [
                                62.69377,
                                81.59949
                            ],
                            [
                                63.46041,
                                81.56913
                            ],
                            [
                                63.7918,
                                81.61296
                            ],
                            [
                                63.65099,
                                81.69156
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                80.0,
                                80.83291
                            ],
                            [
                                80.44571,
                                80.8959
                            ],
                            [
                                80.29324,
                                80.94324
                            ],
                            [
                                79.71453,
                                80.9659
                            ],
                            [
                                79.34283,
                                80.94142
                            ],
                            [
                                79.13251,
                                80.83166
                            ],
                            [
                                80.0,
                                80.83291
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                95.89699,
                                76.26224
                            ],
                            [
                                95.32633,
                                76.22073
                            ],
                            [
                                95.79572,
                                76.14561
                            ],
                            [
                                96.13799,
                                76.1534
                            ],
                            [
                                96.34027,
                                76.11814
                            ],
                            [
                                96.68193,
                                76.25356
                            ],
                            [
                                96.2589,
                                76.28661
                            ],
                            [
                                95.89699,
                                76.26224
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                51.20563,
                                80.05699
                            ],
                            [
                                50.7095,
                                80.04507
                            ],
                            [
                                50.37814,
                                79.93946
                            ],
                            [
                                51.10721,
                                79.90611
                            ],
                            [
                                51.20563,
                                80.05699
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                76.40615,
                                79.62194
                            ],
                            [
                                76.12139,
                                79.59885
                            ],
                            [
                                76.3045,
                                79.53863
                            ],
                            [
                                76.67018,
                                79.53455
                            ],
                            [
                                76.77868,
                                79.47266
                            ],
                            [
                                77.46839,
                                79.47825
                            ],
                            [
                                77.36752,
                                79.53048
                            ],
                            [
                                76.65739,
                                79.61798
                            ],
                            [
                                76.40615,
                                79.62194
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                59.89949,
                                79.99926
                            ],
                            [
                                59.86492,
                                80.05119
                            ],
                            [
                                59.46488,
                                80.08682
                            ],
                            [
                                58.81329,
                                80.01279
                            ],
                            [
                                59.30059,
                                79.93801
                            ],
                            [
                                59.72016,
                                79.93801
                            ],
                            [
                                59.89949,
                                79.99926
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                82.40954,
                                70.59597
                            ],
                            [
                                82.24527,
                                70.54706
                            ],
                            [
                                82.2238,
                                70.42877
                            ],
                            [
                                82.46577,
                                70.35239
                            ],
                            [
                                82.56943,
                                70.25697
                            ],
                            [
                                82.69653,
                                70.26006
                            ],
                            [
                                82.9246,
                                70.35689
                            ],
                            [
                                82.61848,
                                70.45986
                            ],
                            [
                                82.59368,
                                70.53257
                            ],
                            [
                                82.40954,
                                70.59597
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                58.88537,
                                80.86864
                            ],
                            [
                                58.16574,
                                80.84745
                            ],
                            [
                                57.94642,
                                80.75665
                            ],
                            [
                                58.56964,
                                80.72396
                            ],
                            [
                                58.97101,
                                80.76165
                            ],
                            [
                                58.88537,
                                80.86864
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                96.24406,
                                77.01675
                            ],
                            [
                                96.46114,
                                77.06666
                            ],
                            [
                                96.57082,
                                77.15204
                            ],
                            [
                                96.46553,
                                77.18909
                            ],
                            [
                                95.9443,
                                77.08854
                            ],
                            [
                                95.67698,
                                77.06876
                            ],
                            [
                                95.42734,
                                77.00712
                            ],
                            [
                                95.6271,
                                76.98463
                            ],
                            [
                                96.24406,
                                77.01675
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                74.67924,
                                73.09159
                            ],
                            [
                                74.32806,
                                73.11214
                            ],
                            [
                                74.15361,
                                73.06254
                            ],
                            [
                                74.07414,
                                72.98733
                            ],
                            [
                                74.17447,
                                72.94105
                            ],
                            [
                                74.54711,
                                72.84631
                            ],
                            [
                                74.67267,
                                72.87005
                            ],
                            [
                                74.60629,
                                72.92706
                            ],
                            [
                                74.71966,
                                73.07527
                            ],
                            [
                                74.67924,
                                73.09159
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                137.517,
                                71.58967
                            ],
                            [
                                137.38565,
                                71.58655
                            ],
                            [
                                137.04385,
                                71.51491
                            ],
                            [
                                137.63982,
                                71.46352
                            ],
                            [
                                137.86984,
                                71.41649
                            ],
                            [
                                138.02654,
                                71.49716
                            ],
                            [
                                137.97107,
                                71.56958
                            ],
                            [
                                137.62302,
                                71.56502
                            ],
                            [
                                137.517,
                                71.58967
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                82.62659,
                                70.74138
                            ],
                            [
                                82.53163,
                                70.74129
                            ],
                            [
                                82.44113,
                                70.66272
                            ],
                            [
                                82.69604,
                                70.45235
                            ],
                            [
                                82.97587,
                                70.38228
                            ],
                            [
                                83.05112,
                                70.44952
                            ],
                            [
                                82.97527,
                                70.54879
                            ],
                            [
                                82.75225,
                                70.69084
                            ],
                            [
                                82.62659,
                                70.74138
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                107.68148,
                                78.16719
                            ],
                            [
                                107.30784,
                                78.15808
                            ],
                            [
                                106.84126,
                                78.1797
                            ],
                            [
                                106.55674,
                                78.15047
                            ],
                            [
                                106.73717,
                                78.10305
                            ],
                            [
                                107.33784,
                                78.07666
                            ],
                            [
                                107.71885,
                                78.09235
                            ],
                            [
                                107.68148,
                                78.16719
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                135.51627,
                                74.23098
                            ],
                            [
                                135.47511,
                                74.16216
                            ],
                            [
                                135.75065,
                                74.0883
                            ],
                            [
                                135.77896,
                                74.04005
                            ],
                            [
                                136.09641,
                                73.94619
                            ],
                            [
                                136.3378,
                                73.92088
                            ],
                            [
                                136.12682,
                                74.05769
                            ],
                            [
                                135.7185,
                                74.1853
                            ],
                            [
                                135.51627,
                                74.23098
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                50.33484,
                                80.12986
                            ],
                            [
                                50.38718,
                                80.19159
                            ],
                            [
                                50.07868,
                                80.22756
                            ],
                            [
                                49.552,
                                80.15917
                            ],
                            [
                                49.88568,
                                80.05477
                            ],
                            [
                                50.14775,
                                80.06069
                            ],
                            [
                                50.33484,
                                80.12986
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                82.84261,
                                70.94206
                            ],
                            [
                                82.654,
                                70.7597
                            ],
                            [
                                82.83211,
                                70.64803
                            ],
                            [
                                82.91298,
                                70.69491
                            ],
                            [
                                83.05266,
                                70.71745
                            ],
                            [
                                83.13869,
                                70.76667
                            ],
                            [
                                83.12383,
                                70.84508
                            ],
                            [
                                82.95312,
                                70.8761
                            ],
                            [
                                82.84261,
                                70.94206
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                57.91278,
                                81.22372
                            ],
                            [
                                57.35968,
                                81.20103
                            ],
                            [
                                56.92448,
                                81.14384
                            ],
                            [
                                57.30901,
                                81.10117
                            ],
                            [
                                57.78496,
                                81.10649
                            ],
                            [
                                58.04689,
                                81.21007
                            ],
                            [
                                57.91278,
                                81.22372
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                82.11555,
                                75.40289
                            ],
                            [
                                81.59265,
                                75.34559
                            ],
                            [
                                81.61918,
                                75.2895
                            ],
                            [
                                81.89774,
                                75.28703
                            ],
                            [
                                82.3124,
                                75.35681
                            ],
                            [
                                82.11555,
                                75.40289
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                70.6888,
                                66.66479
                            ],
                            [
                                70.46533,
                                66.66453
                            ],
                            [
                                70.31042,
                                66.63291
                            ],
                            [
                                70.33683,
                                66.56591
                            ],
                            [
                                70.69722,
                                66.4893
                            ],
                            [
                                70.98688,
                                66.52675
                            ],
                            [
                                71.00215,
                                66.58167
                            ],
                            [
                                70.6888,
                                66.66479
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                87.07515,
                                74.9773
                            ],
                            [
                                86.68189,
                                74.93657
                            ],
                            [
                                86.65349,
                                74.89208
                            ],
                            [
                                86.33157,
                                74.91137
                            ],
                            [
                                86.35421,
                                74.84694
                            ],
                            [
                                86.84524,
                                74.82976
                            ],
                            [
                                87.10268,
                                74.89041
                            ],
                            [
                                87.19686,
                                74.94369
                            ],
                            [
                                87.07515,
                                74.9773
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                58.2356,
                                81.07849
                            ],
                            [
                                57.87572,
                                81.04782
                            ],
                            [
                                58.33477,
                                80.93351
                            ],
                            [
                                58.60607,
                                80.93355
                            ],
                            [
                                58.75993,
                                81.00426
                            ],
                            [
                                58.2356,
                                81.07849
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                59.02835,
                                81.42189
                            ],
                            [
                                58.52932,
                                81.34549
                            ],
                            [
                                59.02835,
                                81.29302
                            ],
                            [
                                59.35772,
                                81.33433
                            ],
                            [
                                59.02835,
                                81.42189
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                54.36905,
                                80.49377
                            ],
                            [
                                53.96683,
                                80.51906
                            ],
                            [
                                53.8903,
                                80.4479
                            ],
                            [
                                54.26911,
                                80.41428
                            ],
                            [
                                54.36905,
                                80.49377
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                112.3534,
                                76.64754
                            ],
                            [
                                112.03442,
                                76.6142
                            ],
                            [
                                112.1076,
                                76.55265
                            ],
                            [
                                112.38342,
                                76.50771
                            ],
                            [
                                112.45202,
                                76.43961
                            ],
                            [
                                112.66515,
                                76.44013
                            ],
                            [
                                112.56575,
                                76.63108
                            ],
                            [
                                112.3534,
                                76.64754
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                50.74806,
                                81.18752
                            ],
                            [
                                50.36763,
                                81.14917
                            ],
                            [
                                50.5177,
                                81.04899
                            ],
                            [
                                51.01709,
                                81.12228
                            ],
                            [
                                50.74806,
                                81.18752
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                154.88512,
                                49.61303
                            ],
                            [
                                154.78031,
                                49.59406
                            ],
                            [
                                154.7012,
                                49.46074
                            ],
                            [
                                154.61095,
                                49.35821
                            ],
                            [
                                154.62324,
                                49.27856
                            ],
                            [
                                154.71459,
                                49.25735
                            ],
                            [
                                154.81081,
                                49.28329
                            ],
                            [
                                154.84793,
                                49.35092
                            ],
                            [
                                154.81384,
                                49.46803
                            ],
                            [
                                154.88956,
                                49.53681
                            ],
                            [
                                154.88512,
                                49.61303
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                57.89858,
                                80.62055
                            ],
                            [
                                57.4747,
                                80.61167
                            ],
                            [
                                57.31754,
                                80.56048
                            ],
                            [
                                57.5932,
                                80.52236
                            ],
                            [
                                57.90759,
                                80.53236
                            ],
                            [
                                57.89858,
                                80.62055
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                137.19664,
                                55.10755
                            ],
                            [
                                137.02216,
                                55.09862
                            ],
                            [
                                136.69371,
                                54.94517
                            ],
                            [
                                136.67682,
                                54.89357
                            ],
                            [
                                136.90342,
                                54.95287
                            ],
                            [
                                136.94558,
                                54.91146
                            ],
                            [
                                137.04245,
                                54.90607
                            ],
                            [
                                137.0605,
                                54.97387
                            ],
                            [
                                137.19664,
                                55.10755
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                89.72755,
                                77.27952
                            ],
                            [
                                89.53043,
                                77.30156
                            ],
                            [
                                89.28462,
                                77.26801
                            ],
                            [
                                89.21948,
                                77.20212
                            ],
                            [
                                89.57143,
                                77.16909
                            ],
                            [
                                89.72755,
                                77.27952
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                156.49982,
                                50.78698
                            ],
                            [
                                156.47096,
                                50.87102
                            ],
                            [
                                156.38762,
                                50.85326
                            ],
                            [
                                156.21234,
                                50.7772
                            ],
                            [
                                156.17039,
                                50.70231
                            ],
                            [
                                156.27515,
                                50.63749
                            ],
                            [
                                156.3998,
                                50.63486
                            ],
                            [
                                156.51031,
                                50.76626
                            ],
                            [
                                156.49982,
                                50.78698
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                149.40489,
                                76.74354
                            ],
                            [
                                148.8546,
                                76.72395
                            ],
                            [
                                148.53832,
                                76.63433
                            ],
                            [
                                149.07983,
                                76.65736
                            ],
                            [
                                149.40489,
                                76.74354
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -172.34893,
                                64.83621
                            ],
                            [
                                -172.49828,
                                64.81716
                            ],
                            [
                                -172.6356,
                                64.707
                            ],
                            [
                                -172.58704,
                                64.68289
                            ],
                            [
                                -172.34498,
                                64.70824
                            ],
                            [
                                -172.09529,
                                64.78157
                            ],
                            [
                                -172.34893,
                                64.83621
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                35.82385,
                                65.12709
                            ],
                            [
                                35.75071,
                                65.17257
                            ],
                            [
                                35.51447,
                                65.06939
                            ],
                            [
                                35.67262,
                                65.03033
                            ],
                            [
                                35.7176,
                                64.96037
                            ],
                            [
                                35.85933,
                                65.02183
                            ],
                            [
                                35.76955,
                                65.06654
                            ],
                            [
                                35.82385,
                                65.12709
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                69.69094,
                                66.67343
                            ],
                            [
                                69.48344,
                                66.748
                            ],
                            [
                                69.63623,
                                66.58634
                            ],
                            [
                                69.82799,
                                66.61828
                            ],
                            [
                                69.69094,
                                66.67343
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                86.16433,
                                74.54427
                            ],
                            [
                                85.96929,
                                74.59539
                            ],
                            [
                                85.75833,
                                74.55343
                            ],
                            [
                                85.75868,
                                74.46074
                            ],
                            [
                                86.04629,
                                74.49198
                            ],
                            [
                                86.16433,
                                74.54427
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                69.6287,
                                66.74964
                            ],
                            [
                                69.60997,
                                66.70579
                            ],
                            [
                                69.84305,
                                66.62027
                            ],
                            [
                                70.13259,
                                66.62183
                            ],
                            [
                                70.1607,
                                66.66403
                            ],
                            [
                                69.6287,
                                66.74964
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                152.21713,
                                47.11449
                            ],
                            [
                                152.18852,
                                47.14887
                            ],
                            [
                                152.06829,
                                46.99548
                            ],
                            [
                                151.92267,
                                46.92683
                            ],
                            [
                                151.86797,
                                46.85115
                            ],
                            [
                                151.73375,
                                46.85502
                            ],
                            [
                                151.74415,
                                46.79131
                            ],
                            [
                                151.83553,
                                46.77275
                            ],
                            [
                                151.90346,
                                46.83899
                            ],
                            [
                                152.04199,
                                46.89958
                            ],
                            [
                                152.10251,
                                46.97096
                            ],
                            [
                                152.16592,
                                46.99043
                            ],
                            [
                                152.21713,
                                47.11449
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                106.58331,
                                78.33421
                            ],
                            [
                                106.25937,
                                78.19356
                            ],
                            [
                                106.8083,
                                78.28353
                            ],
                            [
                                106.58331,
                                78.33421
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                75.95248,
                                73.526
                            ],
                            [
                                75.5786,
                                73.50926
                            ],
                            [
                                75.56926,
                                73.4295
                            ],
                            [
                                75.87478,
                                73.43288
                            ],
                            [
                                75.95248,
                                73.526
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                85.33727,
                                74.57033
                            ],
                            [
                                85.18535,
                                74.54952
                            ],
                            [
                                85.17717,
                                74.47861
                            ],
                            [
                                85.42816,
                                74.45092
                            ],
                            [
                                85.66004,
                                74.51787
                            ],
                            [
                                85.48334,
                                74.57174
                            ],
                            [
                                85.33727,
                                74.57033
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                167.47088,
                                54.85229
                            ],
                            [
                                167.45507,
                                54.8029
                            ],
                            [
                                167.62024,
                                54.71763
                            ],
                            [
                                167.6921,
                                54.66182
                            ],
                            [
                                167.75336,
                                54.68887
                            ],
                            [
                                167.7238,
                                54.75225
                            ],
                            [
                                167.47088,
                                54.85229
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                67.35596,
                                69.57677
                            ],
                            [
                                67.22004,
                                69.57088
                            ],
                            [
                                67.03592,
                                69.47475
                            ],
                            [
                                67.31362,
                                69.44191
                            ],
                            [
                                67.39227,
                                69.52957
                            ],
                            [
                                67.35596,
                                69.57677
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                83.13272,
                                70.02807
                            ],
                            [
                                82.98824,
                                69.97318
                            ],
                            [
                                83.22263,
                                69.93551
                            ],
                            [
                                83.13272,
                                70.02807
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                83.59058,
                                74.09565
                            ],
                            [
                                83.24595,
                                74.13009
                            ],
                            [
                                83.09448,
                                74.08123
                            ],
                            [
                                83.28071,
                                74.04954
                            ],
                            [
                                83.59058,
                                74.09565
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                97.18136,
                                76.00488
                            ],
                            [
                                97.20676,
                                76.091
                            ],
                            [
                                96.73119,
                                75.99927
                            ],
                            [
                                96.8499,
                                75.97702
                            ],
                            [
                                97.18136,
                                76.00488
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                83.57146,
                                69.86017
                            ],
                            [
                                83.48265,
                                69.83009
                            ],
                            [
                                83.52295,
                                69.74702
                            ],
                            [
                                83.7389,
                                69.72893
                            ],
                            [
                                83.83773,
                                69.74867
                            ],
                            [
                                83.71864,
                                69.82017
                            ],
                            [
                                83.57146,
                                69.86017
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                96.95031,
                                76.30769
                            ],
                            [
                                96.70154,
                                76.20949
                            ],
                            [
                                96.8468,
                                76.19133
                            ],
                            [
                                97.11107,
                                76.27744
                            ],
                            [
                                96.95031,
                                76.30769
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                76.68906,
                                73.13342
                            ],
                            [
                                76.65643,
                                73.15966
                            ],
                            [
                                76.13069,
                                73.19925
                            ],
                            [
                                76.33224,
                                73.12859
                            ],
                            [
                                76.68906,
                                73.13342
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                82.738,
                                74.05112
                            ],
                            [
                                82.83401,
                                74.10941
                            ],
                            [
                                82.64334,
                                74.14094
                            ],
                            [
                                82.45586,
                                74.10066
                            ],
                            [
                                82.49993,
                                74.05453
                            ],
                            [
                                82.738,
                                74.05112
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                161.63665,
                                69.53654
                            ],
                            [
                                161.5155,
                                69.56991
                            ],
                            [
                                161.4659,
                                69.5387
                            ],
                            [
                                161.46005,
                                69.50382
                            ],
                            [
                                161.41718,
                                69.47259
                            ],
                            [
                                161.44451,
                                69.44136
                            ],
                            [
                                161.34346,
                                69.40805
                            ],
                            [
                                161.3824,
                                69.39074
                            ],
                            [
                                161.48731,
                                69.41035
                            ],
                            [
                                161.64129,
                                69.46359
                            ],
                            [
                                161.63665,
                                69.53654
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                51.47596,
                                68.46375
                            ],
                            [
                                51.20016,
                                68.49201
                            ],
                            [
                                51.03485,
                                68.43612
                            ],
                            [
                                51.47596,
                                68.46375
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                83.14592,
                                70.51416
                            ],
                            [
                                83.09696,
                                70.42693
                            ],
                            [
                                83.30386,
                                70.44925
                            ],
                            [
                                83.14592,
                                70.51416
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                79.36234,
                                74.61076
                            ],
                            [
                                79.27782,
                                74.53522
                            ],
                            [
                                79.46799,
                                74.50829
                            ],
                            [
                                79.57759,
                                74.58665
                            ],
                            [
                                79.36234,
                                74.61076
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                83.35441,
                                70.75539
                            ],
                            [
                                83.22615,
                                70.67279
                            ],
                            [
                                83.36443,
                                70.65308
                            ],
                            [
                                83.45023,
                                70.73629
                            ],
                            [
                                83.35441,
                                70.75539
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                152.84471,
                                76.18893
                            ],
                            [
                                152.57987,
                                76.13597
                            ],
                            [
                                152.85617,
                                76.09781
                            ],
                            [
                                152.84471,
                                76.18893
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                120.32818,
                                73.06366
                            ],
                            [
                                120.28902,
                                73.12534
                            ],
                            [
                                119.98212,
                                73.07873
                            ],
                            [
                                120.0441,
                                73.03574
                            ],
                            [
                                120.32818,
                                73.06366
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                69.68022,
                                66.56019
                            ],
                            [
                                69.87498,
                                66.46627
                            ],
                            [
                                69.96327,
                                66.53184
                            ],
                            [
                                69.77209,
                                66.57583
                            ],
                            [
                                69.68022,
                                66.56019
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                155.53093,
                                50.92401
                            ],
                            [
                                155.453,
                                50.88427
                            ],
                            [
                                155.51935,
                                50.81303
                            ],
                            [
                                155.66827,
                                50.82571
                            ],
                            [
                                155.65259,
                                50.90824
                            ],
                            [
                                155.53093,
                                50.92401
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                34.38789,
                                69.33125
                            ],
                            [
                                34.18858,
                                69.37696
                            ],
                            [
                                33.97588,
                                69.35139
                            ],
                            [
                                34.15622,
                                69.30591
                            ],
                            [
                                34.38789,
                                69.33125
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                124.81374,
                                73.91159
                            ],
                            [
                                124.49228,
                                73.90104
                            ],
                            [
                                124.6764,
                                73.84549
                            ],
                            [
                                124.81374,
                                73.91159
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                150.76711,
                                59.08227
                            ],
                            [
                                150.54907,
                                59.06941
                            ],
                            [
                                150.47279,
                                59.01594
                            ],
                            [
                                150.61722,
                                59.00408
                            ],
                            [
                                150.76711,
                                59.08227
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                160.50532,
                                70.90413
                            ],
                            [
                                160.58962,
                                70.87341
                            ],
                            [
                                160.51981,
                                70.80635
                            ],
                            [
                                160.76279,
                                70.78893
                            ],
                            [
                                160.7001,
                                70.87342
                            ],
                            [
                                160.50532,
                                70.90413
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                83.03576,
                                70.56338
                            ],
                            [
                                83.10496,
                                70.69329
                            ],
                            [
                                82.91456,
                                70.68774
                            ],
                            [
                                83.03576,
                                70.56338
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                82.96241,
                                70.21703
                            ],
                            [
                                82.93054,
                                70.11891
                            ],
                            [
                                83.11584,
                                70.14887
                            ],
                            [
                                82.96241,
                                70.21703
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                86.83534,
                                74.78593
                            ],
                            [
                                86.48757,
                                74.82951
                            ],
                            [
                                86.53512,
                                74.75094
                            ],
                            [
                                86.83534,
                                74.78593
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                40.31943,
                                64.76891
                            ],
                            [
                                40.19824,
                                64.72528
                            ],
                            [
                                40.40482,
                                64.66959
                            ],
                            [
                                40.31943,
                                64.76891
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                122.39388,
                                73.09129
                            ],
                            [
                                122.28674,
                                73.08462
                            ],
                            [
                                122.27624,
                                73.00115
                            ],
                            [
                                122.52468,
                                73.01832
                            ],
                            [
                                122.39388,
                                73.09129
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                82.37167,
                                70.97243
                            ],
                            [
                                82.29358,
                                70.93194
                            ],
                            [
                                82.41749,
                                70.85497
                            ],
                            [
                                82.50684,
                                70.94634
                            ],
                            [
                                82.37167,
                                70.97243
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                56.89133,
                                70.57619
                            ],
                            [
                                56.84985,
                                70.53683
                            ],
                            [
                                57.06893,
                                70.48194
                            ],
                            [
                                57.17103,
                                70.51629
                            ],
                            [
                                56.89133,
                                70.57619
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                138.89562,
                                71.70394
                            ],
                            [
                                138.60468,
                                71.70639
                            ],
                            [
                                138.57554,
                                71.64601
                            ],
                            [
                                138.89562,
                                71.70394
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                154.0692,
                                48.7827
                            ],
                            [
                                154.15874,
                                48.81668
                            ],
                            [
                                154.22104,
                                48.88576
                            ],
                            [
                                154.10074,
                                48.8866
                            ],
                            [
                                154.0692,
                                48.7827
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                131.87124,
                                43.05758
                            ],
                            [
                                131.75209,
                                42.98253
                            ],
                            [
                                131.85705,
                                42.95375
                            ],
                            [
                                131.93495,
                                42.99182
                            ],
                            [
                                131.87124,
                                43.05758
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                40.32229,
                                64.63251
                            ],
                            [
                                40.28506,
                                64.58804
                            ],
                            [
                                40.40525,
                                64.53227
                            ],
                            [
                                40.47488,
                                64.578
                            ],
                            [
                                40.32229,
                                64.63251
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -172.67107,
                                64.64885
                            ],
                            [
                                -172.66614,
                                64.60277
                            ],
                            [
                                -172.48708,
                                64.59479
                            ],
                            [
                                -172.49782,
                                64.6517
                            ],
                            [
                                -172.67107,
                                64.64885
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                48.72478,
                                45.69789
                            ],
                            [
                                48.72106,
                                45.72529
                            ],
                            [
                                48.60892,
                                45.79919
                            ],
                            [
                                48.59743,
                                45.74208
                            ],
                            [
                                48.72478,
                                45.69789
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                152.53462,
                                47.30168
                            ],
                            [
                                152.53513,
                                47.36422
                            ],
                            [
                                152.44357,
                                47.3696
                            ],
                            [
                                152.44296,
                                47.29719
                            ],
                            [
                                152.53462,
                                47.30168
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                147.34654,
                                44.7146
                            ],
                            [
                                147.48827,
                                44.78209
                            ],
                            [
                                147.59396,
                                44.85113
                            ],
                            [
                                147.65015,
                                44.91995
                            ],
                            [
                                147.64524,
                                44.98865
                            ],
                            [
                                147.69963,
                                45.00555
                            ],
                            [
                                147.78438,
                                44.94827
                            ],
                            [
                                147.89785,
                                44.9621
                            ],
                            [
                                147.98326,
                                45.004
                            ],
                            [
                                148.09685,
                                45.11049
                            ],
                            [
                                148.31319,
                                45.21953
                            ],
                            [
                                148.49579,
                                45.25802
                            ],
                            [
                                148.63724,
                                45.33403
                            ],
                            [
                                148.84268,
                                45.33727
                            ],
                            [
                                148.87566,
                                45.38813
                            ],
                            [
                                148.82929,
                                45.42854
                            ],
                            [
                                148.88976,
                                45.51647
                            ],
                            [
                                148.83041,
                                45.54801
                            ],
                            [
                                148.65416,
                                45.53741
                            ],
                            [
                                148.48565,
                                45.41817
                            ],
                            [
                                148.45847,
                                45.36017
                            ],
                            [
                                148.33797,
                                45.28896
                            ],
                            [
                                148.12494,
                                45.25666
                            ],
                            [
                                148.03331,
                                45.26927
                            ],
                            [
                                147.92549,
                                45.43713
                            ],
                            [
                                147.84976,
                                45.36614
                            ],
                            [
                                147.86903,
                                45.22339
                            ],
                            [
                                147.73233,
                                45.1918
                            ],
                            [
                                147.65175,
                                45.07902
                            ],
                            [
                                147.5526,
                                45.10835
                            ],
                            [
                                147.51278,
                                45.0252
                            ],
                            [
                                147.37996,
                                44.90994
                            ],
                            [
                                147.26433,
                                44.86382
                            ],
                            [
                                147.17704,
                                44.68757
                            ],
                            [
                                147.12762,
                                44.65125
                            ],
                            [
                                147.03176,
                                44.63691
                            ],
                            [
                                147.02565,
                                44.59907
                            ],
                            [
                                146.87733,
                                44.4999
                            ],
                            [
                                146.90687,
                                44.42992
                            ],
                            [
                                146.98666,
                                44.45025
                            ],
                            [
                                147.02336,
                                44.51367
                            ],
                            [
                                147.10653,
                                44.56793
                            ],
                            [
                                147.2068,
                                44.5712
                            ],
                            [
                                147.34654,
                                44.7146
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                145.57795,
                                43.84442
                            ],
                            [
                                145.63704,
                                43.90032
                            ],
                            [
                                145.77861,
                                43.93499
                            ],
                            [
                                145.81684,
                                44.01914
                            ],
                            [
                                145.98388,
                                44.16919
                            ],
                            [
                                146.04456,
                                44.18632
                            ],
                            [
                                146.10528,
                                44.25894
                            ],
                            [
                                146.2932,
                                44.27701
                            ],
                            [
                                146.38558,
                                44.35613
                            ],
                            [
                                146.53094,
                                44.3804
                            ],
                            [
                                146.53561,
                                44.4344
                            ],
                            [
                                146.34076,
                                44.41833
                            ],
                            [
                                146.24562,
                                44.45357
                            ],
                            [
                                146.16905,
                                44.51515
                            ],
                            [
                                146.08356,
                                44.47433
                            ],
                            [
                                146.00886,
                                44.38144
                            ],
                            [
                                145.98604,
                                44.31728
                            ],
                            [
                                145.89014,
                                44.24973
                            ],
                            [
                                145.74665,
                                44.10466
                            ],
                            [
                                145.73812,
                                44.04988
                            ],
                            [
                                145.47363,
                                43.89802
                            ],
                            [
                                145.40038,
                                43.82773
                            ],
                            [
                                145.43174,
                                43.72402
                            ],
                            [
                                145.54434,
                                43.73188
                            ],
                            [
                                145.57795,
                                43.84442
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                146.91103,
                                43.84442
                            ],
                            [
                                146.82442,
                                43.88857
                            ],
                            [
                                146.58631,
                                43.80455
                            ],
                            [
                                146.63176,
                                43.72208
                            ],
                            [
                                146.78513,
                                43.7588
                            ],
                            [
                                146.91103,
                                43.84442
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "RWA",
                "Country": "Rwanda",
                "Total_3GHG": 0.03,
                "Total_3GHG_timeseries": [
                    4.8081e-07,
                    9.5457e-07,
                    1.4202e-06,
                    1.8837e-06,
                    2.3462e-06,
                    2.8163e-06,
                    3.283e-06,
                    3.7491e-06,
                    4.2156e-06,
                    4.6839e-06,
                    5.1538e-06,
                    5.6254e-06,
                    6.0994e-06,
                    6.575e-06,
                    7.0672e-06,
                    7.5514e-06,
                    8.0348e-06,
                    8.5188e-06,
                    9.0043e-06,
                    9.4932e-06,
                    9.9853e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Fossil_3GHG": 0.02,
                "Fossil_3GHG_timeseries": [
                    2.0719e-08,
                    4.2051e-08,
                    6.4003e-08,
                    8.6575e-08,
                    1.0977e-07,
                    1.3359e-07,
                    1.5803e-07,
                    1.8309e-07,
                    2.0876e-07,
                    2.3506e-07,
                    2.6211e-07,
                    2.8992e-07,
                    3.1902e-07,
                    3.489e-07,
                    3.7956e-07,
                    4.11e-07,
                    4.4325e-07,
                    4.7629e-07,
                    5.1015e-07,
                    5.4483e-07,
                    5.7995e-07,
                    6.1561e-07,
                    6.519e-07,
                    6.8885e-07,
                    7.2651e-07,
                    7.6488e-07,
                    8.0395e-07,
                    8.4367e-07,
                    8.8399e-07,
                    9.2483e-07,
                    9.66e-07,
                    1.0075e-06,
                    1.0488e-06,
                    1.0904e-06,
                    1.1323e-06,
                    1.1746e-06,
                    1.2171e-06,
                    1.2599e-06,
                    1.3031e-06,
                    1.347e-06,
                    1.3913e-06,
                    1.4361e-06,
                    1.4813e-06,
                    1.5271e-06,
                    1.5733e-06,
                    1.62e-06,
                    1.6673e-06,
                    1.7151e-06,
                    1.7634e-06,
                    1.8123e-06,
                    1.8622e-06,
                    1.913e-06,
                    1.965e-06,
                    2.018e-06,
                    2.0721e-06,
                    2.1273e-06,
                    2.1837e-06,
                    2.2412e-06,
                    2.2998e-06,
                    2.3594e-06,
                    2.4252e-06,
                    2.4971e-06,
                    2.5752e-06,
                    2.6593e-06,
                    2.7497e-06,
                    2.8462e-06,
                    2.9488e-06,
                    3.0578e-06,
                    3.1729e-06,
                    3.2944e-06,
                    3.4249e-06,
                    3.5644e-06,
                    3.7131e-06,
                    3.8709e-06,
                    4.0381e-06,
                    4.2147e-06,
                    4.4007e-06,
                    4.5971e-06,
                    4.804e-06,
                    5.0214e-06,
                    5.2479e-06,
                    5.4837e-06,
                    5.7292e-06,
                    5.9844e-06,
                    6.2497e-06,
                    6.5252e-06,
                    6.8112e-06,
                    7.1078e-06,
                    7.4153e-06,
                    7.7338e-06,
                    8.0655e-06,
                    8.4107e-06,
                    8.77e-06,
                    9.1435e-06,
                    9.5954e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_3GHG": 0.06,
                "Land_3GHG_timeseries": [
                    4.6009e-07,
                    9.1252e-07,
                    1.3562e-06,
                    1.7971e-06,
                    2.2365e-06,
                    2.6827e-06,
                    3.125e-06,
                    3.566e-06,
                    4.0068e-06,
                    4.4488e-06,
                    4.8917e-06,
                    5.3355e-06,
                    5.7803e-06,
                    6.2261e-06,
                    6.6877e-06,
                    7.1404e-06,
                    7.5915e-06,
                    8.0426e-06,
                    8.4942e-06,
                    8.9484e-06,
                    9.4054e-06,
                    9.8648e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Total_CO2": 0.03,
                "Total_CO2_timeseries": [
                    4.3368e-07,
                    8.5948e-07,
                    1.2764e-06,
                    1.6902e-06,
                    2.1024e-06,
                    2.5213e-06,
                    2.9361e-06,
                    3.3494e-06,
                    3.7625e-06,
                    4.1768e-06,
                    4.5916e-06,
                    5.0071e-06,
                    5.4234e-06,
                    5.8402e-06,
                    6.2727e-06,
                    6.696e-06,
                    7.1174e-06,
                    7.5385e-06,
                    7.9598e-06,
                    8.3835e-06,
                    8.8095e-06,
                    9.2372e-06,
                    9.6662e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    7.5898e-09,
                    1.518e-08,
                    2.9275e-08,
                    4.2287e-08,
                    4.7708e-08,
                    5.4214e-08,
                    6.1804e-08,
                    7.0478e-08,
                    7.9152e-08,
                    1.1277e-07,
                    1.4421e-07,
                    1.8541e-07,
                    2.2336e-07,
                    2.6131e-07,
                    2.7781e-07,
                    2.9926e-07,
                    3.1906e-07,
                    3.3721e-07,
                    3.6196e-07,
                    3.8836e-07,
                    4.1476e-07,
                    4.4281e-07,
                    4.7251e-07,
                    5.0386e-07,
                    5.3686e-07,
                    6.1606e-07,
                    7.3651e-07,
                    8.5696e-07,
                    9.8731e-07,
                    1.121e-06,
                    1.3437e-06,
                    1.6143e-06,
                    1.8882e-06,
                    2.2017e-06,
                    2.4872e-06,
                    2.7644e-06,
                    3.0333e-06,
                    3.3087e-06,
                    3.6204e-06,
                    3.9286e-06,
                    4.1645e-06,
                    4.3771e-06,
                    4.593e-06,
                    4.8105e-06,
                    5.0186e-06,
                    5.2234e-06,
                    5.4324e-06,
                    5.6496e-06,
                    5.8665e-06,
                    6.0928e-06,
                    6.3248e-06,
                    6.5601e-06,
                    6.7937e-06,
                    7.023e-06,
                    7.2552e-06,
                    7.4868e-06,
                    7.7185e-06,
                    7.9626e-06,
                    8.2003e-06,
                    8.4517e-06,
                    8.7133e-06,
                    9.0032e-06,
                    9.3267e-06,
                    9.679e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CO2": 0.08,
                "Land_CO2_timeseries": [
                    4.3368e-07,
                    8.5948e-07,
                    1.2764e-06,
                    1.6902e-06,
                    2.1024e-06,
                    2.5213e-06,
                    2.9361e-06,
                    3.3494e-06,
                    3.7625e-06,
                    4.1768e-06,
                    4.5916e-06,
                    5.0071e-06,
                    5.4234e-06,
                    5.8402e-06,
                    6.2727e-06,
                    6.696e-06,
                    7.1174e-06,
                    7.5385e-06,
                    7.9598e-06,
                    8.3835e-06,
                    8.8095e-06,
                    9.2372e-06,
                    9.6662e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Total_CH4": 0.05,
                "Total_CH4_timeseries": [
                    2.7913e-08,
                    5.6329e-08,
                    8.5255e-08,
                    1.147e-07,
                    1.4466e-07,
                    1.7516e-07,
                    2.0619e-07,
                    2.3777e-07,
                    2.6989e-07,
                    3.0258e-07,
                    3.3622e-07,
                    3.7083e-07,
                    4.0694e-07,
                    4.4404e-07,
                    4.8212e-07,
                    5.2119e-07,
                    5.6128e-07,
                    6.0237e-07,
                    6.4447e-07,
                    6.876e-07,
                    7.3133e-07,
                    7.7565e-07,
                    8.2058e-07,
                    8.661e-07,
                    9.1222e-07,
                    9.5895e-07,
                    1.0063e-06,
                    1.0542e-06,
                    1.1027e-06,
                    1.1519e-06,
                    1.2012e-06,
                    1.2509e-06,
                    1.3002e-06,
                    1.3499e-06,
                    1.3997e-06,
                    1.4499e-06,
                    1.5003e-06,
                    1.5509e-06,
                    1.6018e-06,
                    1.6529e-06,
                    1.7044e-06,
                    1.756e-06,
                    1.808e-06,
                    1.8602e-06,
                    1.9127e-06,
                    1.9655e-06,
                    2.0186e-06,
                    2.072e-06,
                    2.1256e-06,
                    2.1796e-06,
                    2.2344e-06,
                    2.2901e-06,
                    2.3467e-06,
                    2.4041e-06,
                    2.4625e-06,
                    2.5218e-06,
                    2.582e-06,
                    2.6432e-06,
                    2.7053e-06,
                    2.7685e-06,
                    2.8466e-06,
                    2.9397e-06,
                    3.0478e-06,
                    3.1708e-06,
                    3.309e-06,
                    3.4621e-06,
                    3.6304e-06,
                    3.8137e-06,
                    4.0122e-06,
                    4.2259e-06,
                    4.4609e-06,
                    4.7174e-06,
                    4.9955e-06,
                    5.2951e-06,
                    5.6165e-06,
                    5.9597e-06,
                    6.3247e-06,
                    6.7125e-06,
                    7.123e-06,
                    7.5564e-06,
                    8.0082e-06,
                    8.4784e-06,
                    8.9672e-06,
                    9.4748e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_CH4": 0.06,
                "Fossil_CH4_timeseries": [
                    1.1544e-08,
                    2.3577e-08,
                    3.6107e-08,
                    4.9139e-08,
                    6.2681e-08,
                    7.6739e-08,
                    9.132e-08,
                    1.0643e-07,
                    1.2208e-07,
                    1.3827e-07,
                    1.5515e-07,
                    1.7274e-07,
                    1.9155e-07,
                    2.1108e-07,
                    2.3133e-07,
                    2.5231e-07,
                    2.7403e-07,
                    2.9649e-07,
                    3.1969e-07,
                    3.4365e-07,
                    3.6794e-07,
                    3.9255e-07,
                    4.1748e-07,
                    4.4273e-07,
                    4.6831e-07,
                    4.9422e-07,
                    5.2045e-07,
                    5.4701e-07,
                    5.7389e-07,
                    6.0111e-07,
                    6.2853e-07,
                    6.5614e-07,
                    6.8347e-07,
                    7.11e-07,
                    7.3874e-07,
                    7.6668e-07,
                    7.9483e-07,
                    8.2319e-07,
                    8.5177e-07,
                    8.8056e-07,
                    9.0957e-07,
                    9.388e-07,
                    9.6825e-07,
                    9.9794e-07,
                    1.0279e-06,
                    1.058e-06,
                    1.0884e-06,
                    1.119e-06,
                    1.1499e-06,
                    1.1811e-06,
                    1.2128e-06,
                    1.2452e-06,
                    1.2782e-06,
                    1.3118e-06,
                    1.3462e-06,
                    1.3812e-06,
                    1.4169e-06,
                    1.4533e-06,
                    1.4904e-06,
                    1.5283e-06,
                    1.572e-06,
                    1.6216e-06,
                    1.677e-06,
                    1.7384e-06,
                    1.8056e-06,
                    1.8788e-06,
                    1.958e-06,
                    2.0431e-06,
                    2.1343e-06,
                    2.2315e-06,
                    2.3374e-06,
                    2.4521e-06,
                    2.5757e-06,
                    2.7083e-06,
                    2.8499e-06,
                    3.0006e-06,
                    3.1606e-06,
                    3.3306e-06,
                    3.5107e-06,
                    3.701e-06,
                    3.9001e-06,
                    4.1081e-06,
                    4.3251e-06,
                    4.5513e-06,
                    4.7869e-06,
                    5.032e-06,
                    5.2869e-06,
                    5.5517e-06,
                    5.8266e-06,
                    6.1117e-06,
                    6.4091e-06,
                    6.719e-06,
                    7.0415e-06,
                    7.3769e-06,
                    7.789e-06,
                    8.2844e-06,
                    8.8696e-06,
                    9.5512e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002
                ],
                "Land_CH4": 0.05,
                "Land_CH4_timeseries": [
                    1.6369e-08,
                    3.2752e-08,
                    4.9148e-08,
                    6.5559e-08,
                    8.1983e-08,
                    9.842e-08,
                    1.1487e-07,
                    1.3134e-07,
                    1.4782e-07,
                    1.6431e-07,
                    1.8107e-07,
                    1.981e-07,
                    2.1539e-07,
                    2.3295e-07,
                    2.5078e-07,
                    2.6888e-07,
                    2.8725e-07,
                    3.0588e-07,
                    3.2478e-07,
                    3.4395e-07,
                    3.6339e-07,
                    3.8311e-07,
                    4.031e-07,
                    4.2337e-07,
                    4.4391e-07,
                    4.6473e-07,
                    4.8582e-07,
                    5.0719e-07,
                    5.2883e-07,
                    5.5075e-07,
                    5.7271e-07,
                    5.9472e-07,
                    6.1677e-07,
                    6.3886e-07,
                    6.61e-07,
                    6.8319e-07,
                    7.0542e-07,
                    7.2769e-07,
                    7.5001e-07,
                    7.7238e-07,
                    7.9479e-07,
                    8.1724e-07,
                    8.3974e-07,
                    8.6229e-07,
                    8.8488e-07,
                    9.0752e-07,
                    9.302e-07,
                    9.5293e-07,
                    9.7571e-07,
                    9.9853e-07,
                    1.0216e-06,
                    1.0449e-06,
                    1.0685e-06,
                    1.0923e-06,
                    1.1163e-06,
                    1.1406e-06,
                    1.1651e-06,
                    1.1899e-06,
                    1.2149e-06,
                    1.2402e-06,
                    1.2746e-06,
                    1.3181e-06,
                    1.3707e-06,
                    1.4325e-06,
                    1.5033e-06,
                    1.5833e-06,
                    1.6724e-06,
                    1.7706e-06,
                    1.878e-06,
                    1.9944e-06,
                    2.1235e-06,
                    2.2653e-06,
                    2.4197e-06,
                    2.5869e-06,
                    2.7666e-06,
                    2.9591e-06,
                    3.1642e-06,
                    3.3819e-06,
                    3.6123e-06,
                    3.8554e-06,
                    4.1081e-06,
                    4.3703e-06,
                    4.6421e-06,
                    4.9235e-06,
                    5.2145e-06,
                    5.5113e-06,
                    5.8138e-06,
                    6.1217e-06,
                    6.4348e-06,
                    6.7528e-06,
                    7.0791e-06,
                    7.4133e-06,
                    7.755e-06,
                    8.104e-06,
                    8.46e-06,
                    8.8225e-06,
                    9.1913e-06,
                    9.566e-06,
                    9.9463e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_N2O": 0.04,
                "Total_N2O_timeseries": [
                    1.9214e-08,
                    3.8754e-08,
                    5.8609e-08,
                    7.8761e-08,
                    9.9192e-08,
                    1.1988e-07,
                    1.4078e-07,
                    1.6188e-07,
                    1.8313e-07,
                    2.0449e-07,
                    2.2593e-07,
                    2.4745e-07,
                    2.6904e-07,
                    2.907e-07,
                    3.1243e-07,
                    3.3422e-07,
                    3.5608e-07,
                    3.7801e-07,
                    4.0002e-07,
                    4.2211e-07,
                    4.4452e-07,
                    4.6763e-07,
                    4.9174e-07,
                    5.1706e-07,
                    5.437e-07,
                    5.7171e-07,
                    6.0101e-07,
                    6.3145e-07,
                    6.628e-07,
                    6.9472e-07,
                    7.2698e-07,
                    7.5955e-07,
                    7.9238e-07,
                    8.2544e-07,
                    8.5872e-07,
                    8.922e-07,
                    9.2589e-07,
                    9.598e-07,
                    9.9394e-07,
                    1.0297e-06,
                    1.0658e-06,
                    1.1023e-06,
                    1.1394e-06,
                    1.1768e-06,
                    1.2148e-06,
                    1.2533e-06,
                    1.2923e-06,
                    1.3319e-06,
                    1.372e-06,
                    1.4127e-06,
                    1.454e-06,
                    1.496e-06,
                    1.5386e-06,
                    1.5819e-06,
                    1.6259e-06,
                    1.6707e-06,
                    1.7163e-06,
                    1.7626e-06,
                    1.8098e-06,
                    1.8577e-06,
                    1.9067e-06,
                    1.957e-06,
                    2.009e-06,
                    2.0629e-06,
                    2.1188e-06,
                    2.1768e-06,
                    2.2371e-06,
                    2.2995e-06,
                    2.364e-06,
                    2.4304e-06,
                    2.4989e-06,
                    2.5695e-06,
                    2.6425e-06,
                    2.7178e-06,
                    2.7955e-06,
                    2.8752e-06,
                    2.9569e-06,
                    3.0402e-06,
                    3.1247e-06,
                    3.2098e-06,
                    3.2951e-06,
                    3.3803e-06,
                    3.4652e-06,
                    3.5495e-06,
                    3.6333e-06,
                    3.7165e-06,
                    3.7994e-06,
                    3.8821e-06,
                    3.965e-06,
                    4.0485e-06,
                    4.1381e-06,
                    4.2427e-06,
                    4.3691e-06,
                    4.522e-06,
                    4.7037e-06,
                    4.9142e-06,
                    5.1516e-06,
                    5.4115e-06,
                    5.6874e-06,
                    5.9706e-06,
                    6.2534e-06,
                    6.5317e-06,
                    6.8022e-06,
                    7.0629e-06,
                    7.3127e-06,
                    7.5515e-06,
                    7.7805e-06,
                    8.0017e-06,
                    8.2182e-06,
                    8.4344e-06,
                    8.6719e-06,
                    8.9168e-06,
                    9.1673e-06,
                    9.4193e-06,
                    9.672e-06,
                    9.9436e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_N2O": 0.04,
                "Fossil_N2O_timeseries": [
                    9.1745e-09,
                    1.8474e-08,
                    2.7896e-08,
                    3.7436e-08,
                    4.7088e-08,
                    5.6848e-08,
                    6.6707e-08,
                    7.6657e-08,
                    8.6688e-08,
                    9.6789e-08,
                    1.0695e-07,
                    1.1718e-07,
                    1.2747e-07,
                    1.3782e-07,
                    1.4823e-07,
                    1.5869e-07,
                    1.6922e-07,
                    1.7981e-07,
                    1.9046e-07,
                    2.0117e-07,
                    2.1201e-07,
                    2.2307e-07,
                    2.3442e-07,
                    2.4612e-07,
                    2.582e-07,
                    2.7066e-07,
                    2.835e-07,
                    2.9666e-07,
                    3.101e-07,
                    3.2372e-07,
                    3.3748e-07,
                    3.5135e-07,
                    3.6533e-07,
                    3.7942e-07,
                    3.936e-07,
                    4.0787e-07,
                    4.2225e-07,
                    4.3671e-07,
                    4.5128e-07,
                    4.664e-07,
                    4.8173e-07,
                    4.973e-07,
                    5.131e-07,
                    5.2915e-07,
                    5.4546e-07,
                    5.6204e-07,
                    5.789e-07,
                    5.9605e-07,
                    6.135e-07,
                    6.3127e-07,
                    6.4937e-07,
                    6.6786e-07,
                    6.8677e-07,
                    7.0611e-07,
                    7.2591e-07,
                    7.4615e-07,
                    7.6682e-07,
                    7.8791e-07,
                    8.0936e-07,
                    8.3114e-07,
                    8.5321e-07,
                    8.7554e-07,
                    8.9813e-07,
                    9.2096e-07,
                    9.4403e-07,
                    9.6734e-07,
                    9.9088e-07,
                    1.0147e-06,
                    1.0387e-06,
                    1.063e-06,
                    1.0875e-06,
                    1.1123e-06,
                    1.1374e-06,
                    1.1627e-06,
                    1.1882e-06,
                    1.2141e-06,
                    1.2402e-06,
                    1.2666e-06,
                    1.2933e-06,
                    1.3203e-06,
                    1.3478e-06,
                    1.3757e-06,
                    1.4041e-06,
                    1.4331e-06,
                    1.4628e-06,
                    1.4932e-06,
                    1.5243e-06,
                    1.5561e-06,
                    1.5887e-06,
                    1.6221e-06,
                    1.6563e-06,
                    1.6917e-06,
                    1.7284e-06,
                    1.7666e-06,
                    1.8063e-06,
                    1.8477e-06,
                    1.8907e-06,
                    1.9354e-06,
                    1.9816e-06,
                    2.0293e-06,
                    2.0784e-06,
                    2.1293e-06,
                    2.1818e-06,
                    2.2362e-06,
                    2.2925e-06,
                    2.3506e-06,
                    2.4104e-06,
                    2.472e-06,
                    2.5351e-06,
                    2.5995e-06,
                    2.6652e-06,
                    2.732e-06,
                    2.8e-06,
                    2.8692e-06,
                    2.9397e-06,
                    3.0116e-06,
                    3.0849e-06,
                    3.1598e-06,
                    3.2365e-06,
                    3.3147e-06,
                    3.3932e-06,
                    3.474e-06,
                    3.5568e-06,
                    3.6422e-06,
                    3.731e-06,
                    3.8219e-06,
                    3.9163e-06,
                    4.0125e-06,
                    4.0985e-06,
                    4.1879e-06,
                    4.2809e-06,
                    4.3767e-06,
                    4.4765e-06,
                    4.5816e-06,
                    4.6905e-06,
                    4.7998e-06,
                    4.9125e-06,
                    5.0246e-06,
                    5.145e-06,
                    5.2375e-06,
                    5.3276e-06,
                    5.4137e-06,
                    5.4956e-06,
                    5.5762e-06,
                    5.6736e-06,
                    5.776e-06,
                    5.8974e-06,
                    6.0052e-06,
                    6.1198e-06,
                    6.2118e-06,
                    6.3049e-06,
                    6.399e-06,
                    6.4943e-06,
                    6.5906e-06,
                    6.6826e-06,
                    6.7773e-06,
                    6.8749e-06,
                    6.9761e-06,
                    7.0817e-06,
                    7.1908e-06,
                    7.3039e-06,
                    7.4208e-06,
                    7.5405e-06,
                    7.6631e-06,
                    7.7889e-06,
                    7.9178e-06,
                    8.0497e-06,
                    8.1845e-06,
                    8.324e-06,
                    8.4674e-06,
                    8.6131e-06,
                    8.7604e-06
                ],
                "Land_N2O": 0.05,
                "Land_N2O_timeseries": [
                    1.004e-08,
                    2.028e-08,
                    3.0713e-08,
                    4.1326e-08,
                    5.2104e-08,
                    6.3028e-08,
                    7.4077e-08,
                    8.5225e-08,
                    9.6444e-08,
                    1.077e-07,
                    1.1898e-07,
                    1.3027e-07,
                    1.4157e-07,
                    1.5288e-07,
                    1.642e-07,
                    1.7552e-07,
                    1.8686e-07,
                    1.982e-07,
                    2.0956e-07,
                    2.2094e-07,
                    2.3251e-07,
                    2.4456e-07,
                    2.5732e-07,
                    2.7094e-07,
                    2.8551e-07,
                    3.0105e-07,
                    3.1751e-07,
                    3.3479e-07,
                    3.527e-07,
                    3.7099e-07,
                    3.895e-07,
                    4.082e-07,
                    4.2704e-07,
                    4.4602e-07,
                    4.6512e-07,
                    4.8433e-07,
                    5.0364e-07,
                    5.2308e-07,
                    5.4265e-07,
                    5.6325e-07,
                    5.8405e-07,
                    6.0504e-07,
                    6.2626e-07,
                    6.4769e-07,
                    6.6936e-07,
                    6.9127e-07,
                    7.1343e-07,
                    7.3584e-07,
                    7.5851e-07,
                    7.8145e-07,
                    8.0466e-07,
                    8.2812e-07,
                    8.5183e-07,
                    8.7579e-07,
                    9.0004e-07,
                    9.2458e-07,
                    9.4945e-07,
                    9.7471e-07,
                    1.0004e-06,
                    1.0266e-06,
                    1.0535e-06,
                    1.0815e-06,
                    1.1109e-06,
                    1.1419e-06,
                    1.1747e-06,
                    1.2095e-06,
                    1.2462e-06,
                    1.2848e-06,
                    1.3253e-06,
                    1.3675e-06,
                    1.4114e-06,
                    1.4572e-06,
                    1.5052e-06,
                    1.5552e-06,
                    1.6072e-06,
                    1.6612e-06,
                    1.7168e-06,
                    1.7736e-06,
                    1.8314e-06,
                    1.8895e-06,
                    1.9474e-06,
                    2.0047e-06,
                    2.0611e-06,
                    2.1164e-06,
                    2.1705e-06,
                    2.2233e-06,
                    2.2751e-06,
                    2.326e-06,
                    2.3763e-06,
                    2.4264e-06,
                    2.4817e-06,
                    2.5509e-06,
                    2.6407e-06,
                    2.7554e-06,
                    2.8973e-06,
                    3.0665e-06,
                    3.2609e-06,
                    3.4761e-06,
                    3.7058e-06,
                    3.9413e-06,
                    4.1749e-06,
                    4.4024e-06,
                    4.6204e-06,
                    4.8267e-06,
                    5.0202e-06,
                    5.201e-06,
                    5.3701e-06,
                    5.5297e-06,
                    5.6831e-06,
                    5.8349e-06,
                    6.0067e-06,
                    6.1848e-06,
                    6.3673e-06,
                    6.5501e-06,
                    6.7323e-06,
                    6.932e-06,
                    7.1516e-06,
                    7.3562e-06,
                    7.5736e-06,
                    7.8058e-06,
                    8.0425e-06,
                    8.2779e-06,
                    8.5199e-06,
                    8.7525e-06,
                    8.9892e-06,
                    9.2196e-06,
                    9.4536e-06,
                    9.6964e-06,
                    9.942e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            29.58951,
                            -1.38662
                        ],
                        [
                            29.52667,
                            -1.41286
                        ],
                        [
                            29.45129,
                            -1.50547
                        ],
                        [
                            29.36117,
                            -1.50721
                        ],
                        [
                            29.25511,
                            -1.65925
                        ],
                        [
                            29.24329,
                            -1.69948
                        ],
                        [
                            29.15032,
                            -1.80436
                        ],
                        [
                            29.1276,
                            -1.85937
                        ],
                        [
                            29.13542,
                            -1.97652
                        ],
                        [
                            29.16814,
                            -2.12509
                        ],
                        [
                            29.11505,
                            -2.24768
                        ],
                        [
                            29.01979,
                            -2.27856
                        ],
                        [
                            28.95732,
                            -2.36163
                        ],
                        [
                            28.89892,
                            -2.36375
                        ],
                        [
                            28.86549,
                            -2.40474
                        ],
                        [
                            28.89221,
                            -2.48663
                        ],
                        [
                            28.89281,
                            -2.56174
                        ],
                        [
                            28.91907,
                            -2.67962
                        ],
                        [
                            28.99732,
                            -2.70042
                        ],
                        [
                            29.04064,
                            -2.74384
                        ],
                        [
                            29.06217,
                            -2.60344
                        ],
                        [
                            29.08489,
                            -2.59379
                        ],
                        [
                            29.22594,
                            -2.62922
                        ],
                        [
                            29.26435,
                            -2.61913
                        ],
                        [
                            29.32738,
                            -2.6548
                        ],
                        [
                            29.33415,
                            -2.74689
                        ],
                        [
                            29.37102,
                            -2.83898
                        ],
                        [
                            29.43971,
                            -2.79764
                        ],
                        [
                            29.5214,
                            -2.8294
                        ],
                        [
                            29.66622,
                            -2.79
                        ],
                        [
                            29.70852,
                            -2.81824
                        ],
                        [
                            29.79618,
                            -2.7583
                        ],
                        [
                            29.88956,
                            -2.75072
                        ],
                        [
                            29.93551,
                            -2.64299
                        ],
                        [
                            29.92157,
                            -2.55768
                        ],
                        [
                            29.96511,
                            -2.48774
                        ],
                        [
                            29.94372,
                            -2.36955
                        ],
                        [
                            29.95765,
                            -2.3286
                        ],
                        [
                            30.03103,
                            -2.3487
                        ],
                        [
                            30.13119,
                            -2.43747
                        ],
                        [
                            30.18318,
                            -2.42794
                        ],
                        [
                            30.23212,
                            -2.35177
                        ],
                        [
                            30.27951,
                            -2.37493
                        ],
                        [
                            30.37226,
                            -2.35549
                        ],
                        [
                            30.40903,
                            -2.30993
                        ],
                        [
                            30.54325,
                            -2.41324
                        ],
                        [
                            30.65768,
                            -2.41264
                        ],
                        [
                            30.71464,
                            -2.35617
                        ],
                        [
                            30.77667,
                            -2.38804
                        ],
                        [
                            30.85272,
                            -2.32038
                        ],
                        [
                            30.84476,
                            -2.20581
                        ],
                        [
                            30.8993,
                            -2.07635
                        ],
                        [
                            30.80804,
                            -1.93745
                        ],
                        [
                            30.8314,
                            -1.81291
                        ],
                        [
                            30.82189,
                            -1.69789
                        ],
                        [
                            30.84476,
                            -1.65645
                        ],
                        [
                            30.74709,
                            -1.52119
                        ],
                        [
                            30.73804,
                            -1.44697
                        ],
                        [
                            30.68526,
                            -1.39837
                        ],
                        [
                            30.63235,
                            -1.39079
                        ],
                        [
                            30.56969,
                            -1.3367
                        ],
                        [
                            30.55108,
                            -1.25117
                        ],
                        [
                            30.50905,
                            -1.17143
                        ],
                        [
                            30.47696,
                            -1.16035
                        ],
                        [
                            30.45345,
                            -1.08165
                        ],
                        [
                            30.47352,
                            -1.05741
                        ],
                        [
                            30.35276,
                            -1.06881
                        ],
                        [
                            30.34323,
                            -1.12653
                        ],
                        [
                            30.21238,
                            -1.27325
                        ],
                        [
                            30.16924,
                            -1.33974
                        ],
                        [
                            30.01582,
                            -1.41286
                        ],
                        [
                            29.97845,
                            -1.45675
                        ],
                        [
                            29.90034,
                            -1.46245
                        ],
                        [
                            29.86314,
                            -1.35834
                        ],
                        [
                            29.73213,
                            -1.3424
                        ],
                        [
                            29.67778,
                            -1.38374
                        ],
                        [
                            29.58951,
                            -1.38662
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "SHN",
                "Country": "Saint Helena, Ascension and Tristan Da Cunha",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    4.95e-09,
                    6.6e-09,
                    8.25e-09,
                    9.9e-09,
                    1.155e-08,
                    1.32e-08,
                    1.485e-08,
                    1.815e-08,
                    2.145e-08,
                    2.475e-08,
                    2.805e-08,
                    3.135e-08,
                    3.63e-08,
                    4.125e-08,
                    4.62e-08,
                    5.115e-08,
                    5.61e-08,
                    6.105e-08,
                    6.6e-08,
                    7.095e-08,
                    7.59e-08,
                    8.085e-08,
                    8.58e-08,
                    9.075e-08,
                    9.57e-08,
                    1.0065e-07,
                    1.056e-07,
                    1.1055e-07,
                    1.155e-07,
                    1.2045e-07,
                    1.254e-07,
                    1.3035e-07,
                    1.353e-07,
                    1.4025e-07,
                    1.452e-07,
                    1.518e-07,
                    1.5675e-07,
                    1.617e-07,
                    1.683e-07,
                    1.7655e-07,
                    1.845e-07,
                    1.9252e-07
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    4.95e-09,
                    6.6e-09,
                    8.25e-09,
                    9.9e-09,
                    1.155e-08,
                    1.32e-08,
                    1.485e-08,
                    1.815e-08,
                    2.145e-08,
                    2.475e-08,
                    2.805e-08,
                    3.135e-08,
                    3.63e-08,
                    4.125e-08,
                    4.62e-08,
                    5.115e-08,
                    5.61e-08,
                    6.105e-08,
                    6.6e-08,
                    7.095e-08,
                    7.59e-08,
                    8.085e-08,
                    8.58e-08,
                    9.075e-08,
                    9.57e-08,
                    1.0065e-07,
                    1.056e-07,
                    1.1055e-07,
                    1.155e-07,
                    1.2045e-07,
                    1.254e-07,
                    1.3035e-07,
                    1.353e-07,
                    1.4025e-07,
                    1.452e-07,
                    1.518e-07,
                    1.5675e-07,
                    1.617e-07,
                    1.683e-07,
                    1.7655e-07,
                    1.845e-07,
                    1.9252e-07
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    4.95e-09,
                    6.6e-09,
                    8.25e-09,
                    9.9e-09,
                    1.155e-08,
                    1.32e-08,
                    1.485e-08,
                    1.815e-08,
                    2.145e-08,
                    2.475e-08,
                    2.805e-08,
                    3.135e-08,
                    3.63e-08,
                    4.125e-08,
                    4.62e-08,
                    5.115e-08,
                    5.61e-08,
                    6.105e-08,
                    6.6e-08,
                    7.095e-08,
                    7.59e-08,
                    8.085e-08,
                    8.58e-08,
                    9.075e-08,
                    9.57e-08,
                    1.0065e-07,
                    1.056e-07,
                    1.1055e-07,
                    1.155e-07,
                    1.2045e-07,
                    1.254e-07,
                    1.3035e-07,
                    1.353e-07,
                    1.4025e-07,
                    1.452e-07,
                    1.518e-07,
                    1.5675e-07,
                    1.617e-07,
                    1.683e-07,
                    1.7655e-07,
                    1.845e-07,
                    1.9252e-07
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    4.95e-09,
                    6.6e-09,
                    8.25e-09,
                    9.9e-09,
                    1.155e-08,
                    1.32e-08,
                    1.485e-08,
                    1.815e-08,
                    2.145e-08,
                    2.475e-08,
                    2.805e-08,
                    3.135e-08,
                    3.63e-08,
                    4.125e-08,
                    4.62e-08,
                    5.115e-08,
                    5.61e-08,
                    6.105e-08,
                    6.6e-08,
                    7.095e-08,
                    7.59e-08,
                    8.085e-08,
                    8.58e-08,
                    9.075e-08,
                    9.57e-08,
                    1.0065e-07,
                    1.056e-07,
                    1.1055e-07,
                    1.155e-07,
                    1.2045e-07,
                    1.254e-07,
                    1.3035e-07,
                    1.353e-07,
                    1.4025e-07,
                    1.452e-07,
                    1.518e-07,
                    1.5675e-07,
                    1.617e-07,
                    1.683e-07,
                    1.7655e-07,
                    1.845e-07,
                    1.9252e-07
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": []
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -5.7883,
                                -15.99408
                            ],
                            [
                                -5.74186,
                                -16.02501
                            ],
                            [
                                -5.63618,
                                -15.97387
                            ],
                            [
                                -5.65687,
                                -15.91149
                            ],
                            [
                                -5.71229,
                                -15.91937
                            ],
                            [
                                -5.7883,
                                -15.99408
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -12.35042,
                                -37.1185
                            ],
                            [
                                -12.27122,
                                -37.16769
                            ],
                            [
                                -12.21523,
                                -37.11407
                            ],
                            [
                                -12.26295,
                                -37.06212
                            ],
                            [
                                -12.31439,
                                -37.06341
                            ],
                            [
                                -12.35042,
                                -37.1185
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -14.42021,
                                -7.94164
                            ],
                            [
                                -14.39416,
                                -7.99214
                            ],
                            [
                                -14.30913,
                                -7.95402
                            ],
                            [
                                -14.37795,
                                -7.89002
                            ],
                            [
                                -14.42021,
                                -7.94164
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -10.01851,
                                -40.3105
                            ],
                            [
                                -9.91271,
                                -40.36681
                            ],
                            [
                                -9.8759,
                                -40.34649
                            ],
                            [
                                -9.93171,
                                -40.27658
                            ],
                            [
                                -10.01851,
                                -40.3105
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "KNA",
                "Country": "Saint Kitts and Nevis",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    2.2563e-08,
                    4.1087e-08,
                    5.8229e-08,
                    7.4093e-08,
                    8.8742e-08,
                    1.0566e-07,
                    1.2494e-07,
                    1.4667e-07,
                    1.7096e-07,
                    2.0541e-07,
                    2.4678e-07,
                    2.9343e-07,
                    3.4508e-07,
                    4.0143e-07,
                    4.6021e-07,
                    5.213e-07,
                    5.8467e-07,
                    6.5025e-07,
                    7.1699e-07,
                    7.7917e-07,
                    8.4392e-07,
                    9.1121e-07,
                    9.7917e-07,
                    1.048e-06,
                    1.1175e-06,
                    1.1845e-06,
                    1.249e-06,
                    1.3107e-06,
                    1.3696e-06,
                    1.4267e-06,
                    1.4803e-06,
                    1.5339e-06,
                    1.5855e-06,
                    1.6329e-06,
                    1.6773e-06,
                    1.7187e-06,
                    1.7581e-06,
                    1.7951e-06,
                    1.8315e-06,
                    1.8693e-06,
                    1.9046e-06,
                    1.9393e-06,
                    1.9742e-06,
                    2.0091e-06,
                    2.044e-06,
                    2.079e-06,
                    2.1141e-06,
                    2.1499e-06,
                    2.1866e-06,
                    2.2187e-06,
                    2.2504e-06,
                    2.2781e-06,
                    2.3032e-06,
                    2.3279e-06,
                    2.353e-06,
                    2.3785e-06,
                    2.4031e-06,
                    2.4275e-06,
                    2.4506e-06,
                    2.4663e-06,
                    2.4782e-06,
                    2.485e-06,
                    2.4866e-06,
                    2.4818e-06,
                    2.4709e-06,
                    2.4542e-06,
                    2.4316e-06,
                    2.4032e-06,
                    2.3687e-06,
                    2.3342e-06,
                    2.2962e-06,
                    2.2567e-06,
                    2.2148e-06,
                    2.17e-06,
                    2.1223e-06,
                    2.0732e-06,
                    2.0223e-06,
                    1.9701e-06,
                    1.9163e-06,
                    1.8616e-06,
                    1.8098e-06,
                    1.7597e-06,
                    1.711e-06,
                    1.6646e-06,
                    1.6204e-06,
                    1.5783e-06,
                    1.5379e-06,
                    1.5e-06,
                    1.4652e-06,
                    1.4438e-06,
                    1.4358e-06,
                    1.4374e-06,
                    1.4459e-06,
                    1.4627e-06,
                    1.4828e-06,
                    1.5067e-06,
                    1.5343e-06,
                    1.5643e-06,
                    1.5966e-06,
                    1.618e-06,
                    1.6315e-06,
                    1.6407e-06,
                    1.646e-06,
                    1.6479e-06,
                    1.6461e-06,
                    1.6399e-06,
                    1.629e-06,
                    1.6104e-06,
                    1.5991e-06,
                    1.5776e-06,
                    1.544e-06,
                    1.4991e-06,
                    1.4483e-06,
                    1.3916e-06,
                    1.3342e-06,
                    1.2748e-06,
                    1.2141e-06,
                    1.137e-06,
                    1.0678e-06,
                    9.9919e-07,
                    9.3966e-07,
                    8.8638e-07,
                    8.3808e-07,
                    7.9674e-07,
                    7.6169e-07,
                    7.3441e-07,
                    7.1377e-07,
                    6.9839e-07,
                    6.8805e-07,
                    6.8152e-07,
                    6.9793e-07,
                    7.2424e-07,
                    7.4091e-07,
                    7.5992e-07,
                    7.755e-07,
                    7.9511e-07,
                    8.1355e-07,
                    8.3605e-07,
                    8.5285e-07,
                    8.9218e-07,
                    9.2843e-07,
                    9.6838e-07,
                    1.0018e-06,
                    1.0396e-06,
                    1.0748e-06,
                    1.1159e-06,
                    1.1665e-06,
                    1.2448e-06,
                    1.3145e-06,
                    1.3897e-06,
                    1.4655e-06,
                    1.5513e-06,
                    1.64e-06,
                    1.7249e-06,
                    1.8068e-06,
                    1.8917e-06,
                    1.9868e-06,
                    2.0928e-06,
                    2.2084e-06,
                    2.3296e-06,
                    2.4496e-06,
                    2.551e-06,
                    2.6519e-06,
                    2.7547e-06,
                    2.8594e-06,
                    2.9664e-06,
                    3.0714e-06,
                    3.179e-06,
                    3.2904e-06,
                    3.3894e-06,
                    3.485e-06,
                    3.5815e-06
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    1.6995e-08,
                    3.0615e-08,
                    4.3307e-08,
                    5.5076e-08,
                    6.5926e-08,
                    7.9292e-08,
                    9.5244e-08,
                    1.1385e-07,
                    1.3518e-07,
                    1.5931e-07,
                    1.8708e-07,
                    2.1836e-07,
                    2.5341e-07,
                    2.922e-07,
                    3.3262e-07,
                    3.7467e-07,
                    4.1837e-07,
                    4.6375e-07,
                    5.0978e-07,
                    5.5647e-07,
                    6.078e-07,
                    6.626e-07,
                    7.186e-07,
                    7.7583e-07,
                    8.3394e-07,
                    8.8975e-07,
                    9.4322e-07,
                    9.9391e-07,
                    1.0418e-06,
                    1.0868e-06,
                    1.128e-06,
                    1.1692e-06,
                    1.2084e-06,
                    1.2436e-06,
                    1.2759e-06,
                    1.3052e-06,
                    1.3328e-06,
                    1.3581e-06,
                    1.3829e-06,
                    1.4123e-06,
                    1.4405e-06,
                    1.4689e-06,
                    1.498e-06,
                    1.5275e-06,
                    1.5573e-06,
                    1.5875e-06,
                    1.6181e-06,
                    1.6495e-06,
                    1.6821e-06,
                    1.7096e-06,
                    1.7366e-06,
                    1.7597e-06,
                    1.7803e-06,
                    1.8006e-06,
                    1.8214e-06,
                    1.8426e-06,
                    1.863e-06,
                    1.8832e-06,
                    1.9023e-06,
                    1.9154e-06,
                    1.9257e-06,
                    1.932e-06,
                    1.9339e-06,
                    1.9304e-06,
                    1.9216e-06,
                    1.9078e-06,
                    1.8889e-06,
                    1.8649e-06,
                    1.8355e-06,
                    1.8067e-06,
                    1.7747e-06,
                    1.7417e-06,
                    1.7068e-06,
                    1.6693e-06,
                    1.6295e-06,
                    1.5886e-06,
                    1.5462e-06,
                    1.5029e-06,
                    1.4584e-06,
                    1.4135e-06,
                    1.3711e-06,
                    1.3307e-06,
                    1.2916e-06,
                    1.2548e-06,
                    1.2201e-06,
                    1.1876e-06,
                    1.1569e-06,
                    1.1285e-06,
                    1.1033e-06,
                    1.0804e-06,
                    1.0644e-06,
                    1.0539e-06,
                    1.0471e-06,
                    1.0458e-06,
                    1.0451e-06,
                    1.0459e-06,
                    1.0483e-06,
                    1.0509e-06,
                    1.054e-06,
                    1.0558e-06,
                    1.0524e-06,
                    1.0443e-06,
                    1.0314e-06,
                    1.014e-06,
                    9.9218e-07,
                    9.6569e-07,
                    9.3528e-07,
                    9.0048e-07,
                    8.6115e-07,
                    8.1831e-07,
                    7.6726e-07,
                    7.0834e-07,
                    6.4536e-07,
                    5.7785e-07,
                    5.1084e-07,
                    4.4281e-07,
                    3.7459e-07,
                    3.0728e-07,
                    2.4126e-07,
                    1.7574e-07,
                    1.199e-07,
                    7.0102e-08,
                    2.5884e-08,
                    -0.000000011766,
                    -0.000000043061,
                    -0.000000066449,
                    -0.000000083029,
                    -0.000000094327,
                    -0.00000010067,
                    -0.00000010314,
                    -0.00000007748,
                    -0.000000043378,
                    -0.000000015519,
                    1.3999e-08,
                    4.3395e-08,
                    7.6051e-08,
                    1.0614e-07,
                    1.4056e-07,
                    1.7396e-07,
                    2.276e-07,
                    2.7747e-07,
                    3.3049e-07,
                    3.8553e-07,
                    4.4352e-07,
                    5.0573e-07,
                    5.6848e-07,
                    6.378e-07,
                    7.1008e-07,
                    7.8661e-07,
                    8.7066e-07,
                    9.5839e-07,
                    1.0573e-06,
                    1.1583e-06,
                    1.2679e-06,
                    1.3706e-06,
                    1.4737e-06,
                    1.5853e-06,
                    1.6981e-06,
                    1.8157e-06,
                    1.9312e-06,
                    2.052e-06,
                    2.1666e-06,
                    2.2837e-06,
                    2.4052e-06,
                    2.5285e-06,
                    2.6536e-06,
                    2.7776e-06,
                    2.9052e-06,
                    3.0368e-06,
                    3.1571e-06,
                    3.2736e-06,
                    3.3906e-06
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [
                    5.5678e-09,
                    1.0472e-08,
                    1.4922e-08,
                    1.9017e-08,
                    2.2817e-08,
                    2.6365e-08,
                    2.9696e-08,
                    3.2824e-08,
                    3.5779e-08,
                    4.6094e-08,
                    5.9703e-08,
                    7.507e-08,
                    9.1669e-08,
                    1.0923e-07,
                    1.2759e-07,
                    1.4664e-07,
                    1.663e-07,
                    1.865e-07,
                    2.0721e-07,
                    2.227e-07,
                    2.3612e-07,
                    2.4862e-07,
                    2.6057e-07,
                    2.7217e-07,
                    2.8354e-07,
                    2.9474e-07,
                    3.0582e-07,
                    3.1682e-07,
                    3.2777e-07,
                    3.399e-07,
                    3.523e-07,
                    3.6471e-07,
                    3.7705e-07,
                    3.8929e-07,
                    4.0141e-07,
                    4.1341e-07,
                    4.2528e-07,
                    4.37e-07,
                    4.4858e-07,
                    4.57e-07,
                    4.6405e-07,
                    4.7037e-07,
                    4.7619e-07,
                    4.816e-07,
                    4.8669e-07,
                    4.915e-07,
                    4.9607e-07,
                    5.0042e-07,
                    5.0458e-07,
                    5.0913e-07,
                    5.1374e-07,
                    5.1831e-07,
                    5.2283e-07,
                    5.2727e-07,
                    5.3164e-07,
                    5.3593e-07,
                    5.4014e-07,
                    5.4426e-07,
                    5.483e-07,
                    5.5098e-07,
                    5.5253e-07,
                    5.5306e-07,
                    5.5267e-07,
                    5.514e-07,
                    5.493e-07,
                    5.4643e-07,
                    5.4274e-07,
                    5.3831e-07,
                    5.3319e-07,
                    5.2754e-07,
                    5.2147e-07,
                    5.1496e-07,
                    5.0798e-07,
                    5.0062e-07,
                    4.9283e-07,
                    4.8464e-07,
                    4.761e-07,
                    4.6719e-07,
                    4.5785e-07,
                    4.4816e-07,
                    4.386e-07,
                    4.2899e-07,
                    4.1941e-07,
                    4.098e-07,
                    4.0024e-07,
                    3.9071e-07,
                    3.8107e-07,
                    3.7149e-07,
                    3.6185e-07,
                    3.6343e-07,
                    3.7139e-07,
                    3.8346e-07,
                    3.9878e-07,
                    4.1698e-07,
                    4.377e-07,
                    4.608e-07,
                    4.8607e-07,
                    5.1338e-07,
                    5.4259e-07,
                    5.6214e-07,
                    5.791e-07,
                    5.9641e-07,
                    6.1465e-07,
                    6.339e-07,
                    6.5389e-07,
                    6.7422e-07,
                    6.9372e-07,
                    7.0996e-07,
                    7.3796e-07,
                    7.5932e-07,
                    7.7678e-07,
                    7.908e-07,
                    8.029e-07,
                    8.1375e-07,
                    8.2332e-07,
                    8.3198e-07,
                    8.3948e-07,
                    8.297e-07,
                    8.2654e-07,
                    8.2346e-07,
                    8.1977e-07,
                    8.1628e-07,
                    8.122e-07,
                    8.0851e-07,
                    8.0475e-07,
                    8.0086e-07,
                    7.968e-07,
                    7.9272e-07,
                    7.8872e-07,
                    7.8466e-07,
                    7.7541e-07,
                    7.6762e-07,
                    7.5642e-07,
                    7.4592e-07,
                    7.3211e-07,
                    7.1906e-07,
                    7.0741e-07,
                    6.9549e-07,
                    6.789e-07,
                    6.6458e-07,
                    6.5097e-07,
                    6.3788e-07,
                    6.1627e-07,
                    5.9604e-07,
                    5.6908e-07,
                    5.4745e-07,
                    5.2867e-07,
                    5.3473e-07,
                    5.2785e-07,
                    5.1902e-07,
                    5.0709e-07,
                    4.9401e-07,
                    4.8171e-07,
                    4.57e-07,
                    4.3624e-07,
                    4.1793e-07,
                    4.0147e-07,
                    3.9466e-07,
                    3.9277e-07,
                    3.9839e-07,
                    3.9763e-07,
                    3.8432e-07,
                    3.6824e-07,
                    3.4953e-07,
                    3.3086e-07,
                    3.1279e-07,
                    2.9374e-07,
                    2.7387e-07,
                    2.5361e-07,
                    2.3228e-07,
                    2.1143e-07,
                    1.9096e-07
                ],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    2.5905e-09,
                    4.576e-09,
                    6.1655e-09,
                    7.458e-09,
                    8.514e-09,
                    9.3775e-09,
                    1.0081e-08,
                    1.0642e-08,
                    1.1088e-08,
                    1.8953e-08,
                    2.9898e-08,
                    4.2389e-08,
                    5.5896e-08,
                    7.0152e-08,
                    8.4997e-08,
                    1.0031e-07,
                    1.1603e-07,
                    1.3208e-07,
                    1.4841e-07,
                    1.5932e-07,
                    1.6806e-07,
                    1.7577e-07,
                    1.8285e-07,
                    1.8948e-07,
                    1.9577e-07,
                    2.0179e-07,
                    2.076e-07,
                    2.1323e-07,
                    2.1871e-07,
                    2.2528e-07,
                    2.3227e-07,
                    2.3943e-07,
                    2.4669e-07,
                    2.54e-07,
                    2.6135e-07,
                    2.6875e-07,
                    2.7616e-07,
                    2.836e-07,
                    2.9105e-07,
                    2.9547e-07,
                    2.986e-07,
                    3.0108e-07,
                    3.0313e-07,
                    3.0487e-07,
                    3.0636e-07,
                    3.0765e-07,
                    3.0877e-07,
                    3.0975e-07,
                    3.1061e-07,
                    3.1193e-07,
                    3.134e-07,
                    3.1491e-07,
                    3.1643e-07,
                    3.1794e-07,
                    3.1944e-07,
                    3.2093e-07,
                    3.224e-07,
                    3.2386e-07,
                    3.253e-07,
                    3.2548e-07,
                    3.248e-07,
                    3.2338e-07,
                    3.213e-07,
                    3.1863e-07,
                    3.154e-07,
                    3.1167e-07,
                    3.074e-07,
                    3.0267e-07,
                    2.9752e-07,
                    2.9213e-07,
                    2.8654e-07,
                    2.8074e-07,
                    2.7472e-07,
                    2.6856e-07,
                    2.622e-07,
                    2.5567e-07,
                    2.4904e-07,
                    2.4228e-07,
                    2.3531e-07,
                    2.2824e-07,
                    2.2119e-07,
                    2.1399e-07,
                    2.0672e-07,
                    1.993e-07,
                    1.9182e-07,
                    1.8432e-07,
                    1.7665e-07,
                    1.6899e-07,
                    1.612e-07,
                    1.6458e-07,
                    1.735e-07,
                    1.8566e-07,
                    2.0019e-07,
                    2.1669e-07,
                    2.3482e-07,
                    2.544e-07,
                    2.7527e-07,
                    2.9729e-07,
                    3.2036e-07,
                    3.3294e-07,
                    3.4275e-07,
                    3.5256e-07,
                    3.6281e-07,
                    3.735e-07,
                    3.8433e-07,
                    3.9484e-07,
                    4.0389e-07,
                    4.0914e-07,
                    4.257e-07,
                    4.353e-07,
                    4.4001e-07,
                    4.4305e-07,
                    4.4511e-07,
                    4.4647e-07,
                    4.4747e-07,
                    4.4813e-07,
                    4.4849e-07,
                    4.3209e-07,
                    4.2307e-07,
                    4.1476e-07,
                    4.0616e-07,
                    3.9777e-07,
                    3.8942e-07,
                    3.8166e-07,
                    3.7421e-07,
                    3.6688e-07,
                    3.5993e-07,
                    3.5318e-07,
                    3.4696e-07,
                    3.4069e-07,
                    3.5551e-07,
                    3.7562e-07,
                    3.8543e-07,
                    3.9598e-07,
                    4.0289e-07,
                    4.1402e-07,
                    4.2451e-07,
                    4.4057e-07,
                    4.5295e-07,
                    4.8673e-07,
                    5.2118e-07,
                    5.5852e-07,
                    5.8863e-07,
                    6.2369e-07,
                    6.5532e-07,
                    6.9309e-07,
                    7.3762e-07,
                    8.0928e-07,
                    8.7159e-07,
                    9.351e-07,
                    9.9705e-07,
                    1.0697e-06,
                    1.1432e-06,
                    1.2105e-06,
                    1.2735e-06,
                    1.3409e-06,
                    1.4149e-06,
                    1.4952e-06,
                    1.5829e-06,
                    1.6754e-06,
                    1.7677e-06,
                    1.8561e-06,
                    1.944e-06,
                    2.035e-06,
                    2.127e-06,
                    2.2227e-06,
                    2.3194e-06,
                    2.4176e-06,
                    2.5194e-06,
                    2.6117e-06,
                    2.7006e-06,
                    2.7908e-06
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2.475e-08,
                    5.445e-08,
                    7.755e-08,
                    1.0065e-07,
                    1.2375e-07,
                    1.5015e-07,
                    1.749e-07,
                    2.046e-07,
                    2.343e-07,
                    2.8215e-07,
                    3.3e-07,
                    3.795e-07,
                    4.3065e-07,
                    4.851e-07,
                    5.4285e-07,
                    6.0225e-07,
                    6.666e-07,
                    7.3425e-07,
                    8.0685e-07,
                    8.844e-07,
                    9.636e-07,
                    1.0527e-06,
                    1.1418e-06,
                    1.2375e-06,
                    1.3266e-06,
                    1.4174e-06,
                    1.5147e-06,
                    1.6121e-06,
                    1.7127e-06,
                    1.8117e-06,
                    1.9157e-06,
                    2.0146e-06,
                    2.1153e-06,
                    2.2192e-06,
                    2.3248e-06,
                    2.4321e-06,
                    2.541e-06,
                    2.6516e-06,
                    2.7654e-06,
                    2.8693e-06,
                    2.9695e-06,
                    3.0706e-06
                ],
                "Land_CO2": -0,
                "Land_CO2_timeseries": [
                    2.5905e-09,
                    4.576e-09,
                    6.1655e-09,
                    7.458e-09,
                    8.514e-09,
                    9.3775e-09,
                    1.0081e-08,
                    1.0642e-08,
                    1.1088e-08,
                    1.8953e-08,
                    2.9898e-08,
                    4.2389e-08,
                    5.5896e-08,
                    7.0152e-08,
                    8.4997e-08,
                    1.0031e-07,
                    1.1603e-07,
                    1.3208e-07,
                    1.4841e-07,
                    1.5932e-07,
                    1.6806e-07,
                    1.7577e-07,
                    1.8285e-07,
                    1.8948e-07,
                    1.9577e-07,
                    2.0179e-07,
                    2.076e-07,
                    2.1323e-07,
                    2.1871e-07,
                    2.2528e-07,
                    2.3227e-07,
                    2.3943e-07,
                    2.4669e-07,
                    2.54e-07,
                    2.6135e-07,
                    2.6875e-07,
                    2.7616e-07,
                    2.836e-07,
                    2.9105e-07,
                    2.9547e-07,
                    2.986e-07,
                    3.0108e-07,
                    3.0313e-07,
                    3.0487e-07,
                    3.0636e-07,
                    3.0765e-07,
                    3.0877e-07,
                    3.0975e-07,
                    3.1061e-07,
                    3.1193e-07,
                    3.134e-07,
                    3.1491e-07,
                    3.1643e-07,
                    3.1794e-07,
                    3.1944e-07,
                    3.2093e-07,
                    3.224e-07,
                    3.2386e-07,
                    3.253e-07,
                    3.2548e-07,
                    3.248e-07,
                    3.2338e-07,
                    3.213e-07,
                    3.1863e-07,
                    3.154e-07,
                    3.1167e-07,
                    3.074e-07,
                    3.0267e-07,
                    2.9752e-07,
                    2.9213e-07,
                    2.8654e-07,
                    2.8074e-07,
                    2.7472e-07,
                    2.6856e-07,
                    2.622e-07,
                    2.5567e-07,
                    2.4904e-07,
                    2.4228e-07,
                    2.3531e-07,
                    2.2824e-07,
                    2.2119e-07,
                    2.1399e-07,
                    2.0672e-07,
                    1.993e-07,
                    1.9182e-07,
                    1.8432e-07,
                    1.7665e-07,
                    1.6899e-07,
                    1.612e-07,
                    1.6458e-07,
                    1.735e-07,
                    1.8566e-07,
                    2.0019e-07,
                    2.1669e-07,
                    2.3482e-07,
                    2.544e-07,
                    2.7527e-07,
                    2.9729e-07,
                    3.2036e-07,
                    3.3294e-07,
                    3.4275e-07,
                    3.5256e-07,
                    3.6281e-07,
                    3.735e-07,
                    3.8433e-07,
                    3.9484e-07,
                    4.0389e-07,
                    4.0914e-07,
                    4.257e-07,
                    4.353e-07,
                    4.4001e-07,
                    4.4305e-07,
                    4.4511e-07,
                    4.4647e-07,
                    4.4747e-07,
                    4.4813e-07,
                    4.4849e-07,
                    4.3209e-07,
                    4.2307e-07,
                    4.1476e-07,
                    4.0616e-07,
                    3.9777e-07,
                    3.8942e-07,
                    3.8166e-07,
                    3.7421e-07,
                    3.6688e-07,
                    3.5993e-07,
                    3.5318e-07,
                    3.4696e-07,
                    3.4069e-07,
                    3.3076e-07,
                    3.2117e-07,
                    3.0788e-07,
                    2.9533e-07,
                    2.7914e-07,
                    2.6387e-07,
                    2.4961e-07,
                    2.3597e-07,
                    2.1865e-07,
                    2.0458e-07,
                    1.9118e-07,
                    1.7902e-07,
                    1.5798e-07,
                    1.3859e-07,
                    1.1248e-07,
                    9.0843e-08,
                    7.1021e-08,
                    7.5025e-08,
                    6.474e-08,
                    5.0699e-08,
                    3.3451e-08,
                    1.7039e-08,
                    1.4135e-09,
                    -0.000000027016,
                    -0.000000053125,
                    -0.000000076411,
                    -0.000000099847,
                    -0.00000011683,
                    -0.00000012979,
                    -0.00000013626,
                    -0.000000148,
                    -0.00000015859,
                    -0.00000017135,
                    -0.00000018421,
                    -0.00000019789,
                    -0.00000020942,
                    -0.0000002216,
                    -0.00000023394,
                    -0.00000024597,
                    -0.00000025764,
                    -0.00000026897,
                    -0.00000027985
                ],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [
                    1.9699e-08,
                    3.5962e-08,
                    5.1236e-08,
                    6.5525e-08,
                    7.8833e-08,
                    9.4597e-08,
                    1.1288e-07,
                    1.3376e-07,
                    1.5731e-07,
                    1.8359e-07,
                    2.1372e-07,
                    2.4758e-07,
                    2.8541e-07,
                    3.272e-07,
                    3.7082e-07,
                    4.1629e-07,
                    4.6362e-07,
                    5.1284e-07,
                    5.6293e-07,
                    6.1388e-07,
                    6.6957e-07,
                    7.2881e-07,
                    7.8936e-07,
                    8.5122e-07,
                    9.1406e-07,
                    9.7469e-07,
                    1.0331e-06,
                    1.0888e-06,
                    1.1417e-06,
                    1.1919e-06,
                    1.2381e-06,
                    1.2842e-06,
                    1.3282e-06,
                    1.3679e-06,
                    1.4045e-06,
                    1.4381e-06,
                    1.4698e-06,
                    1.4989e-06,
                    1.5274e-06,
                    1.5604e-06,
                    1.5921e-06,
                    1.6239e-06,
                    1.6563e-06,
                    1.6889e-06,
                    1.7219e-06,
                    1.7552e-06,
                    1.7887e-06,
                    1.823e-06,
                    1.8583e-06,
                    1.8885e-06,
                    1.9182e-06,
                    1.9438e-06,
                    1.9668e-06,
                    1.9893e-06,
                    2.0123e-06,
                    2.0356e-06,
                    2.0581e-06,
                    2.0802e-06,
                    2.101e-06,
                    2.1158e-06,
                    2.1276e-06,
                    2.135e-06,
                    2.1378e-06,
                    2.1349e-06,
                    2.1264e-06,
                    2.1127e-06,
                    2.0935e-06,
                    2.069e-06,
                    2.0388e-06,
                    2.0088e-06,
                    1.9755e-06,
                    1.941e-06,
                    1.9043e-06,
                    1.8647e-06,
                    1.8226e-06,
                    1.7792e-06,
                    1.7341e-06,
                    1.6878e-06,
                    1.6401e-06,
                    1.5917e-06,
                    1.546e-06,
                    1.5022e-06,
                    1.4601e-06,
                    1.4201e-06,
                    1.3825e-06,
                    1.347e-06,
                    1.3134e-06,
                    1.2822e-06,
                    1.2541e-06,
                    1.2284e-06,
                    1.2104e-06,
                    1.1987e-06,
                    1.1915e-06,
                    1.1905e-06,
                    1.191e-06,
                    1.1937e-06,
                    1.1988e-06,
                    1.2049e-06,
                    1.2122e-06,
                    1.219e-06,
                    1.2207e-06,
                    1.2179e-06,
                    1.2108e-06,
                    1.1996e-06,
                    1.1844e-06,
                    1.1651e-06,
                    1.1424e-06,
                    1.1157e-06,
                    1.0849e-06,
                    1.0507e-06,
                    1.0092e-06,
                    9.5816e-07,
                    9.0209e-07,
                    8.4093e-07,
                    7.7935e-07,
                    7.1617e-07,
                    6.5187e-07,
                    5.8793e-07,
                    5.2439e-07,
                    4.6079e-07,
                    4.0657e-07,
                    3.5822e-07,
                    3.1487e-07,
                    2.7796e-07,
                    2.4659e-07,
                    2.2299e-07,
                    2.056e-07,
                    1.9327e-07,
                    1.855e-07,
                    1.8155e-07,
                    1.7922e-07,
                    1.8152e-07,
                    1.8453e-07,
                    1.8879e-07,
                    1.9326e-07,
                    1.9762e-07,
                    2.014e-07,
                    2.0364e-07,
                    2.0414e-07,
                    2.0571e-07,
                    2.0318e-07,
                    2.0143e-07,
                    1.9953e-07,
                    1.9706e-07,
                    1.9579e-07,
                    1.9406e-07,
                    1.9452e-07,
                    1.9553e-07,
                    1.9722e-07,
                    2.0263e-07,
                    2.1019e-07,
                    2.1891e-07,
                    2.2953e-07,
                    2.4244e-07,
                    2.5663e-07,
                    2.698e-07,
                    2.8658e-07,
                    3.0752e-07,
                    3.3065e-07,
                    3.5418e-07,
                    3.7682e-07,
                    3.8555e-07,
                    3.9446e-07,
                    4.0204e-07,
                    4.1064e-07,
                    4.1782e-07,
                    4.2296e-07,
                    4.2933e-07,
                    4.3513e-07,
                    4.3819e-07,
                    4.4101e-07,
                    4.4338e-07
                ],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [
                    1.6756e-08,
                    3.0136e-08,
                    4.2585e-08,
                    5.4108e-08,
                    6.471e-08,
                    7.7826e-08,
                    9.3524e-08,
                    1.1187e-07,
                    1.3295e-07,
                    1.5682e-07,
                    1.8432e-07,
                    2.1534e-07,
                    2.5013e-07,
                    2.8865e-07,
                    3.2879e-07,
                    3.7057e-07,
                    4.14e-07,
                    4.5909e-07,
                    5.0485e-07,
                    5.5126e-07,
                    6.023e-07,
                    6.5681e-07,
                    7.1252e-07,
                    7.6945e-07,
                    8.2727e-07,
                    8.8278e-07,
                    9.3594e-07,
                    9.8633e-07,
                    1.0339e-06,
                    1.0786e-06,
                    1.1194e-06,
                    1.1603e-06,
                    1.1993e-06,
                    1.2341e-06,
                    1.2661e-06,
                    1.2951e-06,
                    1.3224e-06,
                    1.3473e-06,
                    1.3718e-06,
                    1.4009e-06,
                    1.4287e-06,
                    1.4568e-06,
                    1.4855e-06,
                    1.5146e-06,
                    1.5441e-06,
                    1.574e-06,
                    1.6042e-06,
                    1.6352e-06,
                    1.6674e-06,
                    1.6946e-06,
                    1.7213e-06,
                    1.744e-06,
                    1.7642e-06,
                    1.7841e-06,
                    1.8045e-06,
                    1.8253e-06,
                    1.8454e-06,
                    1.8652e-06,
                    1.8839e-06,
                    1.8966e-06,
                    1.9065e-06,
                    1.9124e-06,
                    1.9139e-06,
                    1.91e-06,
                    1.9008e-06,
                    1.8866e-06,
                    1.8673e-06,
                    1.8429e-06,
                    1.8131e-06,
                    1.7838e-06,
                    1.7515e-06,
                    1.718e-06,
                    1.6827e-06,
                    1.6448e-06,
                    1.6045e-06,
                    1.5632e-06,
                    1.5204e-06,
                    1.4766e-06,
                    1.4317e-06,
                    1.3863e-06,
                    1.3435e-06,
                    1.3026e-06,
                    1.2631e-06,
                    1.2258e-06,
                    1.1907e-06,
                    1.1577e-06,
                    1.1265e-06,
                    1.0977e-06,
                    1.072e-06,
                    1.0486e-06,
                    1.0322e-06,
                    1.0212e-06,
                    1.0139e-06,
                    1.012e-06,
                    1.0108e-06,
                    1.0111e-06,
                    1.013e-06,
                    1.0151e-06,
                    1.0176e-06,
                    1.0189e-06,
                    1.0149e-06,
                    1.0063e-06,
                    9.9281e-07,
                    9.7486e-07,
                    9.525e-07,
                    9.2544e-07,
                    8.9446e-07,
                    8.5908e-07,
                    8.1916e-07,
                    7.7573e-07,
                    7.2409e-07,
                    6.6457e-07,
                    6.0097e-07,
                    5.3284e-07,
                    4.652e-07,
                    3.9653e-07,
                    3.2767e-07,
                    2.597e-07,
                    1.9302e-07,
                    1.269e-07,
                    7.0466e-08,
                    1.9908e-08,
                    -0.000000025024,
                    -0.000000063309,
                    -0.000000095442,
                    -0.00000011955,
                    -0.00000013693,
                    -0.00000014901,
                    -0.00000015612,
                    -0.00000015937,
                    -0.00000015923,
                    -0.00000015558,
                    -0.00000015152,
                    -0.00000014591,
                    -0.00000014042,
                    -0.00000013489,
                    -0.00000013034,
                    -0.00000012648,
                    -0.00000012366,
                    -0.00000011891,
                    -0.00000011804,
                    -0.0000001157,
                    -0.00000011313,
                    -0.00000011109,
                    -0.00000010801,
                    -0.0000001061,
                    -0.00000010258,
                    -0.000000099476,
                    -0.000000096959,
                    -0.000000092361,
                    -0.000000085745,
                    -0.000000077938,
                    -0.000000068251,
                    -0.00000005665,
                    -0.000000045267,
                    -0.000000034725,
                    -0.000000022432,
                    -0.000000009004,
                    5.6819e-09,
                    1.9766e-08,
                    3.4046e-08,
                    4.7205e-08,
                    6.1019e-08,
                    7.5991e-08,
                    9.1102e-08,
                    1.0628e-07,
                    1.1972e-07,
                    1.3503e-07,
                    1.5045e-07,
                    1.645e-07,
                    1.7823e-07,
                    1.9151e-07
                ],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [
                    2.9429e-09,
                    5.8267e-09,
                    8.6515e-09,
                    1.1417e-08,
                    1.4124e-08,
                    1.6772e-08,
                    1.936e-08,
                    2.189e-08,
                    2.436e-08,
                    2.6772e-08,
                    2.9397e-08,
                    3.2235e-08,
                    3.5287e-08,
                    3.8552e-08,
                    4.203e-08,
                    4.5722e-08,
                    4.9627e-08,
                    5.3746e-08,
                    5.8078e-08,
                    6.2624e-08,
                    6.7265e-08,
                    7.2002e-08,
                    7.6835e-08,
                    8.1764e-08,
                    8.6789e-08,
                    9.1909e-08,
                    9.7126e-08,
                    1.0244e-07,
                    1.0785e-07,
                    1.1335e-07,
                    1.1869e-07,
                    1.2388e-07,
                    1.289e-07,
                    1.3376e-07,
                    1.3847e-07,
                    1.4301e-07,
                    1.4739e-07,
                    1.5161e-07,
                    1.5567e-07,
                    1.5958e-07,
                    1.6339e-07,
                    1.6712e-07,
                    1.7077e-07,
                    1.7433e-07,
                    1.7781e-07,
                    1.8121e-07,
                    1.8451e-07,
                    1.8774e-07,
                    1.9087e-07,
                    1.9393e-07,
                    1.9689e-07,
                    1.9975e-07,
                    2.0252e-07,
                    2.0519e-07,
                    2.0777e-07,
                    2.1026e-07,
                    2.1265e-07,
                    2.1495e-07,
                    2.1715e-07,
                    2.1925e-07,
                    2.2108e-07,
                    2.2263e-07,
                    2.239e-07,
                    2.2489e-07,
                    2.256e-07,
                    2.2604e-07,
                    2.2619e-07,
                    2.2607e-07,
                    2.2566e-07,
                    2.2498e-07,
                    2.2407e-07,
                    2.2292e-07,
                    2.2154e-07,
                    2.1993e-07,
                    2.1809e-07,
                    2.1601e-07,
                    2.137e-07,
                    2.1116e-07,
                    2.0839e-07,
                    2.0539e-07,
                    2.0248e-07,
                    1.9967e-07,
                    1.9696e-07,
                    1.9434e-07,
                    1.9182e-07,
                    1.8933e-07,
                    1.8689e-07,
                    1.8448e-07,
                    1.8212e-07,
                    1.798e-07,
                    1.7828e-07,
                    1.7756e-07,
                    1.7764e-07,
                    1.7851e-07,
                    1.8017e-07,
                    1.826e-07,
                    1.8582e-07,
                    1.8981e-07,
                    1.9458e-07,
                    2.001e-07,
                    2.0576e-07,
                    2.1168e-07,
                    2.1798e-07,
                    2.2472e-07,
                    2.3195e-07,
                    2.3971e-07,
                    2.4797e-07,
                    2.5666e-07,
                    2.6571e-07,
                    2.7499e-07,
                    2.8514e-07,
                    2.936e-07,
                    3.0112e-07,
                    3.0809e-07,
                    3.1415e-07,
                    3.1964e-07,
                    3.242e-07,
                    3.2822e-07,
                    3.3137e-07,
                    3.3389e-07,
                    3.361e-07,
                    3.3831e-07,
                    3.3989e-07,
                    3.4127e-07,
                    3.4203e-07,
                    3.4255e-07,
                    3.4253e-07,
                    3.4228e-07,
                    3.4162e-07,
                    3.4091e-07,
                    3.3846e-07,
                    3.371e-07,
                    3.3605e-07,
                    3.347e-07,
                    3.3368e-07,
                    3.3251e-07,
                    3.3173e-07,
                    3.3012e-07,
                    3.2779e-07,
                    3.2461e-07,
                    3.2122e-07,
                    3.1714e-07,
                    3.1267e-07,
                    3.0815e-07,
                    3.0381e-07,
                    3.0015e-07,
                    2.9709e-07,
                    2.9501e-07,
                    2.9418e-07,
                    2.9499e-07,
                    2.9593e-07,
                    2.9685e-07,
                    2.9778e-07,
                    2.9909e-07,
                    3.019e-07,
                    3.0452e-07,
                    3.0901e-07,
                    3.1653e-07,
                    3.2497e-07,
                    3.3442e-07,
                    3.4277e-07,
                    3.3835e-07,
                    3.3344e-07,
                    3.2605e-07,
                    3.1954e-07,
                    3.1155e-07,
                    3.0325e-07,
                    2.9431e-07,
                    2.8468e-07,
                    2.7369e-07,
                    2.6278e-07,
                    2.5186e-07
                ],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [
                    2.7271e-10,
                    5.486e-10,
                    8.2761e-10,
                    1.1097e-09,
                    1.3948e-09,
                    1.6828e-09,
                    1.9736e-09,
                    2.2671e-09,
                    2.5632e-09,
                    2.8618e-09,
                    3.1626e-09,
                    3.4658e-09,
                    3.7712e-09,
                    4.0789e-09,
                    4.3889e-09,
                    4.7011e-09,
                    5.0157e-09,
                    5.3325e-09,
                    5.6516e-09,
                    5.9731e-09,
                    6.2977e-09,
                    6.6268e-09,
                    6.9614e-09,
                    7.3022e-09,
                    7.6496e-09,
                    8.0038e-09,
                    8.3645e-09,
                    8.7312e-09,
                    9.1031e-09,
                    9.479e-09,
                    9.8581e-09,
                    1.024e-08,
                    1.0626e-08,
                    1.1014e-08,
                    1.1404e-08,
                    1.1798e-08,
                    1.2194e-08,
                    1.2593e-08,
                    1.2995e-08,
                    1.3434e-08,
                    1.3877e-08,
                    1.4325e-08,
                    1.478e-08,
                    1.5243e-08,
                    1.5716e-08,
                    1.6199e-08,
                    1.6694e-08,
                    1.72e-08,
                    1.7719e-08,
                    1.8251e-08,
                    1.8799e-08,
                    1.9371e-08,
                    1.9971e-08,
                    2.0603e-08,
                    2.1268e-08,
                    2.1966e-08,
                    2.2693e-08,
                    2.3447e-08,
                    2.4221e-08,
                    2.5008e-08,
                    2.5804e-08,
                    2.6607e-08,
                    2.7418e-08,
                    2.8236e-08,
                    2.9061e-08,
                    2.9892e-08,
                    3.0729e-08,
                    3.1571e-08,
                    3.2417e-08,
                    3.3267e-08,
                    3.4119e-08,
                    3.4972e-08,
                    3.5823e-08,
                    3.6671e-08,
                    3.7516e-08,
                    3.8358e-08,
                    3.9197e-08,
                    4.0034e-08,
                    4.0872e-08,
                    4.1711e-08,
                    4.2556e-08,
                    4.341e-08,
                    4.4277e-08,
                    4.5159e-08,
                    4.6059e-08,
                    4.6978e-08,
                    4.7918e-08,
                    4.8877e-08,
                    4.9857e-08,
                    5.0855e-08,
                    5.1891e-08,
                    5.2999e-08,
                    5.4206e-08,
                    5.553e-08,
                    5.6982e-08,
                    5.8565e-08,
                    6.0275e-08,
                    6.2098e-08,
                    6.4015e-08,
                    6.5996e-08,
                    6.8041e-08,
                    7.0176e-08,
                    7.242e-08,
                    7.4788e-08,
                    7.7287e-08,
                    7.992e-08,
                    8.2681e-08,
                    8.5562e-08,
                    8.8544e-08,
                    9.1607e-08,
                    9.4797e-08,
                    9.7933e-08,
                    1.0105e-07,
                    1.0419e-07,
                    1.0733e-07,
                    1.1047e-07,
                    1.1372e-07,
                    1.1697e-07,
                    1.2035e-07,
                    1.2365e-07,
                    1.2694e-07,
                    1.304e-07,
                    1.338e-07,
                    1.3712e-07,
                    1.4089e-07,
                    1.4454e-07,
                    1.4825e-07,
                    1.5194e-07,
                    1.556e-07,
                    1.5928e-07,
                    1.632e-07,
                    1.6709e-07,
                    1.7095e-07,
                    1.7515e-07,
                    1.7936e-07,
                    1.8348e-07,
                    1.8764e-07,
                    1.9185e-07,
                    1.9577e-07,
                    1.9974e-07,
                    2.0407e-07,
                    2.0842e-07,
                    2.1363e-07,
                    2.1882e-07,
                    2.237e-07,
                    2.2878e-07,
                    2.3434e-07,
                    2.4001e-07,
                    2.4566e-07,
                    2.5195e-07,
                    2.5825e-07,
                    2.6268e-07,
                    2.6726e-07,
                    2.7197e-07,
                    2.767e-07,
                    2.8093e-07,
                    2.8538e-07,
                    2.9004e-07,
                    2.9486e-07,
                    2.9996e-07,
                    3.0513e-07,
                    3.0934e-07,
                    3.1351e-07,
                    3.1763e-07,
                    3.218e-07,
                    3.259e-07,
                    3.29e-07,
                    3.3209e-07,
                    3.3585e-07,
                    3.3952e-07,
                    3.4344e-07,
                    3.474e-07
                ],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [
                    2.3829e-10,
                    4.7905e-10,
                    7.2229e-10,
                    9.6799e-10,
                    1.2161e-09,
                    1.4667e-09,
                    1.7196e-09,
                    1.9749e-09,
                    2.2325e-09,
                    2.4924e-09,
                    2.7546e-09,
                    3.019e-09,
                    3.2857e-09,
                    3.5547e-09,
                    3.8258e-09,
                    4.0993e-09,
                    4.3749e-09,
                    4.6529e-09,
                    4.9331e-09,
                    5.2155e-09,
                    5.5004e-09,
                    5.7882e-09,
                    6.079e-09,
                    6.3731e-09,
                    6.6706e-09,
                    6.9715e-09,
                    7.2757e-09,
                    7.5832e-09,
                    7.8937e-09,
                    8.2068e-09,
                    8.5225e-09,
                    8.8406e-09,
                    9.1612e-09,
                    9.4841e-09,
                    9.8094e-09,
                    1.0137e-08,
                    1.0467e-08,
                    1.08e-08,
                    1.1135e-08,
                    1.1472e-08,
                    1.1812e-08,
                    1.2154e-08,
                    1.2499e-08,
                    1.2846e-08,
                    1.3196e-08,
                    1.3549e-08,
                    1.3904e-08,
                    1.4261e-08,
                    1.4621e-08,
                    1.4984e-08,
                    1.5349e-08,
                    1.5717e-08,
                    1.6088e-08,
                    1.6462e-08,
                    1.6838e-08,
                    1.7218e-08,
                    1.76e-08,
                    1.7986e-08,
                    1.8374e-08,
                    1.8765e-08,
                    1.9159e-08,
                    1.9555e-08,
                    1.9955e-08,
                    2.0357e-08,
                    2.0762e-08,
                    2.117e-08,
                    2.1581e-08,
                    2.1994e-08,
                    2.2411e-08,
                    2.283e-08,
                    2.3252e-08,
                    2.3677e-08,
                    2.4105e-08,
                    2.4535e-08,
                    2.4969e-08,
                    2.5405e-08,
                    2.5844e-08,
                    2.6286e-08,
                    2.6731e-08,
                    2.7178e-08,
                    2.7629e-08,
                    2.8082e-08,
                    2.8538e-08,
                    2.8996e-08,
                    2.9457e-08,
                    2.992e-08,
                    3.0387e-08,
                    3.0856e-08,
                    3.1328e-08,
                    3.1803e-08,
                    3.2282e-08,
                    3.2766e-08,
                    3.3257e-08,
                    3.3755e-08,
                    3.426e-08,
                    3.4774e-08,
                    3.5295e-08,
                    3.5824e-08,
                    3.636e-08,
                    3.6902e-08,
                    3.7448e-08,
                    3.7999e-08,
                    3.8555e-08,
                    3.9115e-08,
                    3.968e-08,
                    4.025e-08,
                    4.0824e-08,
                    4.1403e-08,
                    4.1987e-08,
                    4.2577e-08,
                    4.3173e-08,
                    4.3776e-08,
                    4.4387e-08,
                    4.5007e-08,
                    4.5636e-08,
                    4.6273e-08,
                    4.692e-08,
                    4.7576e-08,
                    4.8241e-08,
                    4.8836e-08,
                    4.9433e-08,
                    5.0194e-08,
                    5.0908e-08,
                    5.1543e-08,
                    5.2381e-08,
                    5.3104e-08,
                    5.39e-08,
                    5.4685e-08,
                    5.5453e-08,
                    5.6231e-08,
                    5.7004e-08,
                    5.775e-08,
                    5.8456e-08,
                    5.9262e-08,
                    6.0068e-08,
                    6.0796e-08,
                    6.158e-08,
                    6.2443e-08,
                    6.3313e-08,
                    6.4355e-08,
                    6.5505e-08,
                    6.6695e-08,
                    6.801e-08,
                    6.9518e-08,
                    7.0896e-08,
                    7.2326e-08,
                    7.3775e-08,
                    7.5304e-08,
                    7.6723e-08,
                    7.8616e-08,
                    8.0538e-08,
                    8.2555e-08,
                    8.474e-08,
                    8.7041e-08,
                    8.9223e-08,
                    9.1114e-08,
                    9.3074e-08,
                    9.5084e-08,
                    9.7274e-08,
                    9.9731e-08,
                    1.0228e-07,
                    1.0478e-07,
                    1.0736e-07,
                    1.0994e-07,
                    1.1259e-07,
                    1.1523e-07,
                    1.1691e-07,
                    1.1858e-07,
                    1.2095e-07,
                    1.2329e-07,
                    1.2582e-07,
                    1.2845e-07
                ],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": [
                    3.4427e-11,
                    6.9542e-11,
                    1.0532e-10,
                    1.4171e-10,
                    1.7867e-10,
                    2.1613e-10,
                    2.5401e-10,
                    2.9224e-10,
                    3.3071e-10,
                    3.6932e-10,
                    4.0799e-10,
                    4.4671e-10,
                    4.8547e-10,
                    5.2425e-10,
                    5.6306e-10,
                    6.0189e-10,
                    6.4074e-10,
                    6.7964e-10,
                    7.1859e-10,
                    7.5761e-10,
                    7.9728e-10,
                    8.3861e-10,
                    8.8236e-10,
                    9.2906e-10,
                    9.7902e-10,
                    1.0323e-09,
                    1.0888e-09,
                    1.148e-09,
                    1.2094e-09,
                    1.2722e-09,
                    1.3356e-09,
                    1.3997e-09,
                    1.4644e-09,
                    1.5294e-09,
                    1.5949e-09,
                    1.6608e-09,
                    1.727e-09,
                    1.7937e-09,
                    1.8608e-09,
                    1.9621e-09,
                    2.0647e-09,
                    2.1705e-09,
                    2.2807e-09,
                    2.3967e-09,
                    2.5197e-09,
                    2.6506e-09,
                    2.7901e-09,
                    2.9391e-09,
                    3.0978e-09,
                    3.2668e-09,
                    3.4498e-09,
                    3.6537e-09,
                    3.8833e-09,
                    4.1415e-09,
                    4.4298e-09,
                    4.7477e-09,
                    5.0929e-09,
                    5.4615e-09,
                    5.8476e-09,
                    6.2436e-09,
                    6.6452e-09,
                    7.0519e-09,
                    7.4634e-09,
                    7.8793e-09,
                    8.299e-09,
                    8.7222e-09,
                    9.1482e-09,
                    9.5765e-09,
                    1.0006e-08,
                    1.0437e-08,
                    1.0868e-08,
                    1.1295e-08,
                    1.1718e-08,
                    1.2136e-08,
                    1.2547e-08,
                    1.2953e-08,
                    1.3353e-08,
                    1.3748e-08,
                    1.4141e-08,
                    1.4533e-08,
                    1.4927e-08,
                    1.5328e-08,
                    1.5739e-08,
                    1.6163e-08,
                    1.6602e-08,
                    1.7058e-08,
                    1.7531e-08,
                    1.8021e-08,
                    1.8529e-08,
                    1.9052e-08,
                    1.9609e-08,
                    2.0233e-08,
                    2.095e-08,
                    2.1776e-08,
                    2.2722e-08,
                    2.3791e-08,
                    2.4979e-08,
                    2.6274e-08,
                    2.7654e-08,
                    2.9095e-08,
                    3.0593e-08,
                    3.2177e-08,
                    3.3865e-08,
                    3.5673e-08,
                    3.7607e-08,
                    3.967e-08,
                    4.1857e-08,
                    4.4159e-08,
                    4.6557e-08,
                    4.903e-08,
                    5.1624e-08,
                    5.4157e-08,
                    5.6665e-08,
                    5.9185e-08,
                    6.1693e-08,
                    6.4201e-08,
                    6.6795e-08,
                    6.9389e-08,
                    7.2106e-08,
                    7.4811e-08,
                    7.7503e-08,
                    8.0208e-08,
                    8.2888e-08,
                    8.558e-08,
                    8.8506e-08,
                    9.1432e-08,
                    9.4346e-08,
                    9.7259e-08,
                    1.0015e-07,
                    1.0305e-07,
                    1.062e-07,
                    1.0934e-07,
                    1.1249e-07,
                    1.1588e-07,
                    1.1929e-07,
                    1.2268e-07,
                    1.2606e-07,
                    1.2941e-07,
                    1.3246e-07,
                    1.3538e-07,
                    1.3857e-07,
                    1.4173e-07,
                    1.4562e-07,
                    1.493e-07,
                    1.528e-07,
                    1.5645e-07,
                    1.6056e-07,
                    1.647e-07,
                    1.6893e-07,
                    1.7333e-07,
                    1.7771e-07,
                    1.8012e-07,
                    1.8252e-07,
                    1.8493e-07,
                    1.8747e-07,
                    1.8982e-07,
                    1.923e-07,
                    1.9496e-07,
                    1.9759e-07,
                    2.0023e-07,
                    2.0285e-07,
                    2.0456e-07,
                    2.0615e-07,
                    2.0768e-07,
                    2.0921e-07,
                    2.1067e-07,
                    2.121e-07,
                    2.1351e-07,
                    2.149e-07,
                    2.1623e-07,
                    2.1762e-07,
                    2.1895e-07
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -62.8645,
                                17.37033
                            ],
                            [
                                -62.7673,
                                17.29409
                            ],
                            [
                                -62.70413,
                                17.33453
                            ],
                            [
                                -62.80819,
                                17.41643
                            ],
                            [
                                -62.8645,
                                17.37033
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -62.6335,
                                17.13292
                            ],
                            [
                                -62.60593,
                                17.09522
                            ],
                            [
                                -62.54748,
                                17.11444
                            ],
                            [
                                -62.5456,
                                17.18068
                            ],
                            [
                                -62.60821,
                                17.20585
                            ],
                            [
                                -62.6335,
                                17.13292
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "LCA",
                "Country": "Saint Lucia",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    7.3082e-09,
                    1.4785e-08,
                    2.2376e-08,
                    2.9542e-08,
                    3.5773e-08,
                    4.3318e-08,
                    5.0665e-08,
                    5.6692e-08,
                    6.399e-08,
                    7.0996e-08,
                    7.9767e-08,
                    8.762e-08,
                    9.527e-08,
                    1.0182e-07,
                    1.1032e-07,
                    1.1693e-07,
                    1.2458e-07,
                    1.3176e-07,
                    1.3903e-07,
                    1.4697e-07,
                    1.5579e-07,
                    1.6207e-07,
                    1.6848e-07,
                    1.7576e-07,
                    1.8364e-07,
                    1.9156e-07,
                    1.9882e-07,
                    2.0615e-07,
                    2.1366e-07,
                    2.2103e-07,
                    2.2866e-07,
                    2.37e-07,
                    2.4578e-07,
                    2.5384e-07,
                    2.624e-07,
                    2.7138e-07,
                    2.8045e-07,
                    2.8981e-07,
                    2.9929e-07,
                    3.1113e-07,
                    3.2269e-07,
                    3.3453e-07,
                    3.4696e-07,
                    3.6042e-07,
                    3.7417e-07,
                    3.8649e-07,
                    3.9887e-07,
                    4.1206e-07,
                    4.2528e-07,
                    4.4108e-07,
                    4.5686e-07,
                    4.7216e-07,
                    4.8782e-07,
                    5.0408e-07,
                    5.2089e-07,
                    5.3797e-07,
                    5.547e-07,
                    5.7213e-07,
                    5.8988e-07,
                    6.0257e-07,
                    6.148e-07,
                    6.2758e-07,
                    6.3986e-07,
                    6.5224e-07,
                    6.6458e-07,
                    6.7712e-07,
                    6.898e-07,
                    7.0261e-07,
                    7.1542e-07,
                    7.2799e-07,
                    7.4012e-07,
                    7.5174e-07,
                    7.624e-07,
                    7.7223e-07,
                    7.8099e-07,
                    7.8871e-07,
                    7.9571e-07,
                    8.0204e-07,
                    8.0802e-07,
                    8.1497e-07,
                    8.2198e-07,
                    8.2932e-07,
                    8.3684e-07,
                    8.4538e-07,
                    8.5507e-07,
                    8.6581e-07,
                    8.7821e-07,
                    8.9234e-07,
                    9.0838e-07,
                    9.257e-07,
                    9.5355e-07,
                    9.9233e-07,
                    1.0423e-06,
                    1.1037e-06,
                    1.1777e-06,
                    1.2652e-06,
                    1.367e-06,
                    1.4833e-06,
                    1.6148e-06,
                    1.7719e-06,
                    1.9387e-06,
                    2.1134e-06,
                    2.2923e-06,
                    2.4717e-06,
                    2.6513e-06,
                    2.8321e-06,
                    3.0121e-06,
                    3.1901e-06,
                    3.378e-06,
                    3.5439e-06,
                    3.6993e-06,
                    3.8891e-06,
                    4.0438e-06,
                    4.1795e-06,
                    4.3182e-06,
                    4.494e-06,
                    4.6235e-06,
                    4.7345e-06,
                    4.8558e-06,
                    5.0023e-06,
                    5.1165e-06,
                    5.2195e-06,
                    5.319e-06,
                    5.4115e-06,
                    5.4926e-06,
                    5.5732e-06,
                    5.6521e-06,
                    5.7665e-06,
                    5.9111e-06,
                    6.0477e-06,
                    6.1841e-06,
                    6.3383e-06,
                    6.4966e-06,
                    6.6593e-06,
                    6.8134e-06,
                    6.9542e-06,
                    7.0938e-06,
                    7.241e-06,
                    7.3889e-06,
                    7.5475e-06,
                    7.7107e-06,
                    7.8857e-06,
                    8.0708e-06,
                    8.252e-06,
                    8.4368e-06,
                    8.6276e-06,
                    8.805e-06,
                    9.005e-06,
                    9.1939e-06,
                    9.3775e-06,
                    9.5535e-06,
                    9.7197e-06,
                    9.8892e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    3.3293e-10,
                    6.558e-10,
                    9.8119e-10,
                    1.3091e-09,
                    1.6395e-09,
                    1.9897e-09,
                    2.3601e-09,
                    2.7506e-09,
                    3.1615e-09,
                    3.5929e-09,
                    4.023e-09,
                    4.4508e-09,
                    4.877e-09,
                    5.3012e-09,
                    5.7135e-09,
                    6.114e-09,
                    6.5028e-09,
                    6.8801e-09,
                    7.2419e-09,
                    7.5882e-09,
                    7.9798e-09,
                    8.412e-09,
                    8.8738e-09,
                    9.3658e-09,
                    9.8868e-09,
                    1.0421e-08,
                    1.0967e-08,
                    1.1524e-08,
                    1.209e-08,
                    1.2665e-08,
                    1.3262e-08,
                    1.3901e-08,
                    1.457e-08,
                    1.5263e-08,
                    1.5984e-08,
                    1.6733e-08,
                    1.7515e-08,
                    1.8327e-08,
                    1.9177e-08,
                    2.0091e-08,
                    2.1007e-08,
                    2.193e-08,
                    2.2864e-08,
                    2.3807e-08,
                    2.4759e-08,
                    2.572e-08,
                    2.6691e-08,
                    2.7673e-08,
                    2.8668e-08,
                    2.9645e-08,
                    3.0638e-08,
                    3.1631e-08,
                    3.2631e-08,
                    3.3649e-08,
                    3.4689e-08,
                    3.5749e-08,
                    3.6826e-08,
                    3.7921e-08,
                    3.903e-08,
                    4.0131e-08,
                    4.1243e-08,
                    4.236e-08,
                    4.3479e-08,
                    4.4593e-08,
                    4.5698e-08,
                    4.6798e-08,
                    4.7888e-08,
                    4.8971e-08,
                    5.0041e-08,
                    5.1131e-08,
                    5.2248e-08,
                    5.3413e-08,
                    5.4619e-08,
                    5.5857e-08,
                    5.7129e-08,
                    5.8453e-08,
                    5.9822e-08,
                    6.1243e-08,
                    6.2715e-08,
                    6.4246e-08,
                    6.5838e-08,
                    6.7477e-08,
                    6.9161e-08,
                    7.089e-08,
                    7.2664e-08,
                    7.4485e-08,
                    7.6377e-08,
                    7.8353e-08,
                    8.043e-08,
                    8.2555e-08,
                    8.9777e-08,
                    1.0206e-07,
                    1.1912e-07,
                    1.4097e-07,
                    1.6844e-07,
                    2.0211e-07,
                    2.4225e-07,
                    2.8903e-07,
                    3.4274e-07,
                    4.0507e-07,
                    4.7276e-07,
                    5.3998e-07,
                    6.0967e-07,
                    6.7792e-07,
                    7.4784e-07,
                    8.1741e-07,
                    8.8649e-07,
                    9.5503e-07,
                    1.0231e-06,
                    1.0924e-06,
                    1.1582e-06,
                    1.2191e-06,
                    1.2776e-06,
                    1.3323e-06,
                    1.3845e-06,
                    1.4343e-06,
                    1.4816e-06,
                    1.5266e-06,
                    1.5802e-06,
                    1.624e-06,
                    1.6731e-06,
                    1.7257e-06,
                    1.7807e-06,
                    1.8333e-06,
                    1.8892e-06,
                    1.9502e-06,
                    2.0071e-06,
                    2.0796e-06,
                    2.1776e-06,
                    2.2613e-06,
                    2.3388e-06,
                    2.4267e-06,
                    2.5108e-06,
                    2.6016e-06,
                    2.7005e-06,
                    2.8021e-06,
                    2.911e-06,
                    3.0292e-06,
                    3.147e-06,
                    3.2818e-06,
                    3.4176e-06,
                    3.564e-06,
                    3.7197e-06,
                    3.8873e-06,
                    4.0615e-06,
                    4.2437e-06,
                    4.4264e-06,
                    4.6219e-06,
                    4.8214e-06,
                    5.0266e-06,
                    5.2333e-06,
                    5.4354e-06,
                    5.6435e-06,
                    5.8593e-06,
                    6.0638e-06,
                    6.2745e-06,
                    6.4875e-06,
                    6.6967e-06,
                    6.9009e-06,
                    7.1263e-06,
                    7.3552e-06,
                    7.5846e-06,
                    7.8123e-06,
                    8.0384e-06,
                    8.2612e-06,
                    8.4816e-06,
                    8.7079e-06,
                    8.9416e-06,
                    9.1684e-06,
                    9.3843e-06,
                    9.5952e-06,
                    9.8117e-06
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [
                    6.9753e-09,
                    1.4129e-08,
                    2.1395e-08,
                    2.8233e-08,
                    3.4134e-08,
                    4.1329e-08,
                    4.8305e-08,
                    5.3942e-08,
                    6.0828e-08,
                    6.7403e-08,
                    7.5744e-08,
                    8.317e-08,
                    9.0393e-08,
                    9.6524e-08,
                    1.046e-07,
                    1.1082e-07,
                    1.1808e-07,
                    1.2488e-07,
                    1.3179e-07,
                    1.3938e-07,
                    1.4781e-07,
                    1.5365e-07,
                    1.596e-07,
                    1.6639e-07,
                    1.7375e-07,
                    1.8114e-07,
                    1.8785e-07,
                    1.9463e-07,
                    2.0157e-07,
                    2.0836e-07,
                    2.154e-07,
                    2.231e-07,
                    2.3121e-07,
                    2.3857e-07,
                    2.4642e-07,
                    2.5465e-07,
                    2.6293e-07,
                    2.7148e-07,
                    2.8011e-07,
                    2.9104e-07,
                    3.0168e-07,
                    3.1259e-07,
                    3.241e-07,
                    3.3661e-07,
                    3.4941e-07,
                    3.6077e-07,
                    3.7218e-07,
                    3.8439e-07,
                    3.9662e-07,
                    4.1144e-07,
                    4.2623e-07,
                    4.4053e-07,
                    4.5519e-07,
                    4.7043e-07,
                    4.862e-07,
                    5.0222e-07,
                    5.1787e-07,
                    5.3421e-07,
                    5.5085e-07,
                    5.6243e-07,
                    5.7355e-07,
                    5.8522e-07,
                    5.9638e-07,
                    6.0765e-07,
                    6.1888e-07,
                    6.3033e-07,
                    6.4191e-07,
                    6.5364e-07,
                    6.6538e-07,
                    6.7686e-07,
                    6.8787e-07,
                    6.9833e-07,
                    7.0778e-07,
                    7.1637e-07,
                    7.2386e-07,
                    7.3025e-07,
                    7.3589e-07,
                    7.408e-07,
                    7.453e-07,
                    7.5072e-07,
                    7.5614e-07,
                    7.6185e-07,
                    7.6768e-07,
                    7.7449e-07,
                    7.824e-07,
                    7.9132e-07,
                    8.0183e-07,
                    8.1399e-07,
                    8.2795e-07,
                    8.4314e-07,
                    8.6377e-07,
                    8.9027e-07,
                    9.2315e-07,
                    9.6272e-07,
                    1.0092e-06,
                    1.0631e-06,
                    1.1247e-06,
                    1.1943e-06,
                    1.2721e-06,
                    1.3668e-06,
                    1.466e-06,
                    1.5734e-06,
                    1.6826e-06,
                    1.7937e-06,
                    1.9035e-06,
                    2.0147e-06,
                    2.1257e-06,
                    2.2351e-06,
                    2.3549e-06,
                    2.4516e-06,
                    2.5412e-06,
                    2.67e-06,
                    2.7662e-06,
                    2.8471e-06,
                    2.9336e-06,
                    3.0598e-06,
                    3.1419e-06,
                    3.2079e-06,
                    3.2756e-06,
                    3.3783e-06,
                    3.4433e-06,
                    3.4938e-06,
                    3.5383e-06,
                    3.5781e-06,
                    3.6034e-06,
                    3.623e-06,
                    3.645e-06,
                    3.6869e-06,
                    3.7335e-06,
                    3.7865e-06,
                    3.8453e-06,
                    3.9116e-06,
                    3.9858e-06,
                    4.0577e-06,
                    4.113e-06,
                    4.1522e-06,
                    4.1828e-06,
                    4.2118e-06,
                    4.2419e-06,
                    4.2658e-06,
                    4.2931e-06,
                    4.3218e-06,
                    4.3511e-06,
                    4.3647e-06,
                    4.3754e-06,
                    4.3839e-06,
                    4.3785e-06,
                    4.3831e-06,
                    4.3725e-06,
                    4.3509e-06,
                    4.3202e-06,
                    4.2843e-06,
                    4.2456e-06,
                    4.2123e-06,
                    4.1762e-06,
                    4.1528e-06,
                    4.1154e-06,
                    4.097e-06,
                    4.0651e-06,
                    4.0418e-06,
                    4.0221e-06,
                    4.0016e-06,
                    3.9781e-06,
                    3.9529e-06,
                    3.9322e-06,
                    3.9112e-06,
                    3.8882e-06,
                    3.8628e-06,
                    3.835e-06,
                    3.818e-06,
                    3.7992e-06,
                    3.7815e-06
                ],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    6.864e-09,
                    1.3904e-08,
                    2.1054e-08,
                    2.7775e-08,
                    3.3555e-08,
                    4.0629e-08,
                    4.7482e-08,
                    5.2993e-08,
                    5.9752e-08,
                    6.6198e-08,
                    7.4421e-08,
                    8.1736e-08,
                    8.8858e-08,
                    9.4897e-08,
                    1.0289e-07,
                    1.0904e-07,
                    1.1623e-07,
                    1.2297e-07,
                    1.2984e-07,
                    1.374e-07,
                    1.4578e-07,
                    1.5155e-07,
                    1.574e-07,
                    1.6408e-07,
                    1.7131e-07,
                    1.7855e-07,
                    1.8509e-07,
                    1.9168e-07,
                    1.984e-07,
                    2.0497e-07,
                    2.1176e-07,
                    2.1918e-07,
                    2.2699e-07,
                    2.3404e-07,
                    2.4154e-07,
                    2.494e-07,
                    2.573e-07,
                    2.6544e-07,
                    2.7363e-07,
                    2.8405e-07,
                    2.9418e-07,
                    3.0458e-07,
                    3.1556e-07,
                    3.2754e-07,
                    3.398e-07,
                    3.5061e-07,
                    3.6144e-07,
                    3.7307e-07,
                    3.847e-07,
                    3.9891e-07,
                    4.1308e-07,
                    4.2673e-07,
                    4.4072e-07,
                    4.5525e-07,
                    4.7028e-07,
                    4.8551e-07,
                    5.0036e-07,
                    5.1586e-07,
                    5.3164e-07,
                    5.4237e-07,
                    5.5263e-07,
                    5.6344e-07,
                    5.7375e-07,
                    5.8417e-07,
                    5.9456e-07,
                    6.0517e-07,
                    6.1592e-07,
                    6.2682e-07,
                    6.3773e-07,
                    6.484e-07,
                    6.5858e-07,
                    6.6818e-07,
                    6.7677e-07,
                    6.8448e-07,
                    6.9108e-07,
                    6.9656e-07,
                    7.0127e-07,
                    7.0524e-07,
                    7.0879e-07,
                    7.1323e-07,
                    7.1766e-07,
                    7.2233e-07,
                    7.271e-07,
                    7.3282e-07,
                    7.3959e-07,
                    7.473e-07,
                    7.5654e-07,
                    7.6735e-07,
                    7.7989e-07,
                    7.9361e-07,
                    8.0978e-07,
                    8.2873e-07,
                    8.5085e-07,
                    8.7638e-07,
                    9.0546e-07,
                    9.3837e-07,
                    9.7561e-07,
                    1.0171e-06,
                    1.0633e-06,
                    1.1245e-06,
                    1.1924e-06,
                    1.2661e-06,
                    1.3423e-06,
                    1.418e-06,
                    1.4931e-06,
                    1.569e-06,
                    1.6438e-06,
                    1.7162e-06,
                    1.7982e-06,
                    1.8578e-06,
                    1.9175e-06,
                    2.0176e-06,
                    2.0877e-06,
                    2.1435e-06,
                    2.209e-06,
                    2.318e-06,
                    2.3876e-06,
                    2.4472e-06,
                    2.5249e-06,
                    2.6459e-06,
                    2.7322e-06,
                    2.8089e-06,
                    2.8821e-06,
                    2.9487e-06,
                    3.0027e-06,
                    3.0535e-06,
                    3.0979e-06,
                    3.1767e-06,
                    3.2812e-06,
                    3.3759e-06,
                    3.4628e-06,
                    3.5635e-06,
                    3.6669e-06,
                    3.7714e-06,
                    3.8654e-06,
                    3.946e-06,
                    4.0239e-06,
                    4.1069e-06,
                    4.1857e-06,
                    4.263e-06,
                    4.3467e-06,
                    4.441e-06,
                    4.5478e-06,
                    4.6533e-06,
                    4.7635e-06,
                    4.8812e-06,
                    4.9883e-06,
                    5.118e-06,
                    5.2396e-06,
                    5.3648e-06,
                    5.4899e-06,
                    5.6102e-06,
                    5.7371e-06,
                    5.8826e-06,
                    6.0185e-06,
                    6.1776e-06,
                    6.3292e-06,
                    6.4998e-06,
                    6.6562e-06,
                    6.8492e-06,
                    7.046e-06,
                    7.2432e-06,
                    7.4361e-06,
                    7.6236e-06,
                    7.8136e-06,
                    8.0026e-06,
                    8.1965e-06,
                    8.3964e-06,
                    8.5908e-06,
                    8.781e-06,
                    8.9621e-06,
                    9.1477e-06
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.65e-09,
                    6.6e-09,
                    9.9e-09,
                    1.485e-08,
                    1.815e-08,
                    2.31e-08,
                    2.805e-08,
                    3.3e-08,
                    3.795e-08,
                    4.29e-08,
                    4.95e-08,
                    5.775e-08,
                    6.6e-08,
                    7.59e-08,
                    8.58e-08,
                    9.735e-08,
                    1.1055e-07,
                    1.254e-07,
                    1.419e-07,
                    1.6995e-07,
                    1.9965e-07,
                    2.31e-07,
                    2.6565e-07,
                    3.0195e-07,
                    3.3495e-07,
                    3.696e-07,
                    4.0755e-07,
                    4.389e-07,
                    4.8345e-07,
                    5.511e-07,
                    6.0225e-07,
                    6.4515e-07,
                    6.963e-07,
                    7.425e-07,
                    7.9365e-07,
                    8.514e-07,
                    9.108e-07,
                    9.768e-07,
                    1.0511e-06,
                    1.1253e-06,
                    1.2062e-06,
                    1.2919e-06,
                    1.3876e-06,
                    1.4933e-06,
                    1.6104e-06,
                    1.7341e-06,
                    1.8661e-06,
                    1.9998e-06,
                    2.1467e-06,
                    2.2984e-06,
                    2.4552e-06,
                    2.6169e-06,
                    2.7786e-06,
                    2.9485e-06,
                    3.1301e-06,
                    3.305e-06,
                    3.4897e-06,
                    3.6811e-06,
                    3.8725e-06,
                    4.064e-06,
                    4.2834e-06,
                    4.5028e-06,
                    4.7239e-06,
                    4.9434e-06,
                    5.1612e-06,
                    5.3774e-06,
                    5.5918e-06,
                    5.8129e-06,
                    6.0423e-06,
                    6.2683e-06,
                    6.4861e-06,
                    6.696e-06,
                    6.9078e-06
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [
                    6.864e-09,
                    1.3904e-08,
                    2.1054e-08,
                    2.7775e-08,
                    3.3555e-08,
                    4.0629e-08,
                    4.7482e-08,
                    5.2993e-08,
                    5.9752e-08,
                    6.6198e-08,
                    7.4421e-08,
                    8.1736e-08,
                    8.8858e-08,
                    9.4897e-08,
                    1.0289e-07,
                    1.0904e-07,
                    1.1623e-07,
                    1.2297e-07,
                    1.2984e-07,
                    1.374e-07,
                    1.4578e-07,
                    1.5155e-07,
                    1.574e-07,
                    1.6408e-07,
                    1.7131e-07,
                    1.7855e-07,
                    1.8509e-07,
                    1.9168e-07,
                    1.984e-07,
                    2.0497e-07,
                    2.1176e-07,
                    2.1918e-07,
                    2.2699e-07,
                    2.3404e-07,
                    2.4154e-07,
                    2.494e-07,
                    2.573e-07,
                    2.6544e-07,
                    2.7363e-07,
                    2.8405e-07,
                    2.9418e-07,
                    3.0458e-07,
                    3.1556e-07,
                    3.2754e-07,
                    3.398e-07,
                    3.5061e-07,
                    3.6144e-07,
                    3.7307e-07,
                    3.847e-07,
                    3.9891e-07,
                    4.1308e-07,
                    4.2673e-07,
                    4.4072e-07,
                    4.5525e-07,
                    4.7028e-07,
                    4.8551e-07,
                    5.0036e-07,
                    5.1586e-07,
                    5.3164e-07,
                    5.4237e-07,
                    5.5263e-07,
                    5.6344e-07,
                    5.7375e-07,
                    5.8417e-07,
                    5.9456e-07,
                    6.0517e-07,
                    6.1592e-07,
                    6.2682e-07,
                    6.3773e-07,
                    6.484e-07,
                    6.5858e-07,
                    6.6818e-07,
                    6.7677e-07,
                    6.8448e-07,
                    6.9108e-07,
                    6.9656e-07,
                    7.0127e-07,
                    7.0524e-07,
                    7.0879e-07,
                    7.1323e-07,
                    7.1766e-07,
                    7.2233e-07,
                    7.271e-07,
                    7.3282e-07,
                    7.3959e-07,
                    7.473e-07,
                    7.5654e-07,
                    7.6735e-07,
                    7.7989e-07,
                    7.9361e-07,
                    8.0978e-07,
                    8.2873e-07,
                    8.5085e-07,
                    8.7638e-07,
                    9.0546e-07,
                    9.3837e-07,
                    9.7561e-07,
                    1.0171e-06,
                    1.0633e-06,
                    1.1228e-06,
                    1.1858e-06,
                    1.2562e-06,
                    1.3274e-06,
                    1.3998e-06,
                    1.47e-06,
                    1.5409e-06,
                    1.6108e-06,
                    1.6783e-06,
                    1.7553e-06,
                    1.8083e-06,
                    1.8597e-06,
                    1.9516e-06,
                    2.0118e-06,
                    2.0577e-06,
                    2.1117e-06,
                    2.2075e-06,
                    2.2622e-06,
                    2.3053e-06,
                    2.3549e-06,
                    2.4462e-06,
                    2.5012e-06,
                    2.5433e-06,
                    2.5802e-06,
                    2.6138e-06,
                    2.6331e-06,
                    2.646e-06,
                    2.659e-06,
                    2.6932e-06,
                    2.7301e-06,
                    2.7737e-06,
                    2.8177e-06,
                    2.8672e-06,
                    2.9244e-06,
                    2.9778e-06,
                    3.014e-06,
                    3.0352e-06,
                    3.0471e-06,
                    3.0558e-06,
                    3.0604e-06,
                    3.0569e-06,
                    3.0548e-06,
                    3.0533e-06,
                    3.0545e-06,
                    3.0429e-06,
                    3.0294e-06,
                    3.015e-06,
                    2.9885e-06,
                    2.9714e-06,
                    2.9412e-06,
                    2.9096e-06,
                    2.873e-06,
                    2.8316e-06,
                    2.7885e-06,
                    2.7526e-06,
                    2.7136e-06,
                    2.6879e-06,
                    2.6481e-06,
                    2.6273e-06,
                    2.5922e-06,
                    2.5658e-06,
                    2.5431e-06,
                    2.5193e-06,
                    2.4927e-06,
                    2.4624e-06,
                    2.4363e-06,
                    2.4108e-06,
                    2.3836e-06,
                    2.3541e-06,
                    2.3225e-06,
                    2.2948e-06,
                    2.2661e-06,
                    2.2398e-06
                ],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [
                    1.1415e-10,
                    2.1633e-10,
                    3.1918e-10,
                    4.2271e-10,
                    5.2697e-10,
                    6.4939e-10,
                    7.9022e-10,
                    9.4971e-10,
                    1.1281e-09,
                    1.3257e-09,
                    1.5102e-09,
                    1.6806e-09,
                    1.8379e-09,
                    1.9813e-09,
                    2.1012e-09,
                    2.1975e-09,
                    2.2706e-09,
                    2.3204e-09,
                    2.3428e-09,
                    2.3381e-09,
                    2.3913e-09,
                    2.4966e-09,
                    2.6423e-09,
                    2.8285e-09,
                    3.0537e-09,
                    3.3017e-09,
                    3.5723e-09,
                    3.8636e-09,
                    4.1756e-09,
                    4.5081e-09,
                    4.8824e-09,
                    5.3163e-09,
                    5.8011e-09,
                    6.3281e-09,
                    6.9025e-09,
                    7.524e-09,
                    8.1979e-09,
                    8.9215e-09,
                    9.7026e-09,
                    1.0565e-08,
                    1.1426e-08,
                    1.2292e-08,
                    1.3164e-08,
                    1.4043e-08,
                    1.4927e-08,
                    1.5817e-08,
                    1.6712e-08,
                    1.7616e-08,
                    1.853e-08,
                    1.9421e-08,
                    2.0314e-08,
                    2.1194e-08,
                    2.2066e-08,
                    2.2941e-08,
                    2.3823e-08,
                    2.4711e-08,
                    2.5601e-08,
                    2.6495e-08,
                    2.7388e-08,
                    2.8258e-08,
                    2.9125e-08,
                    2.9982e-08,
                    3.0828e-08,
                    3.1652e-08,
                    3.2455e-08,
                    3.3237e-08,
                    3.3997e-08,
                    3.4733e-08,
                    3.5443e-08,
                    3.6158e-08,
                    3.6918e-08,
                    3.7744e-08,
                    3.8628e-08,
                    3.9562e-08,
                    4.0549e-08,
                    4.1605e-08,
                    4.2724e-08,
                    4.3912e-08,
                    4.5169e-08,
                    4.6504e-08,
                    4.7913e-08,
                    4.9382e-08,
                    5.091e-08,
                    5.2496e-08,
                    5.4142e-08,
                    5.5872e-08,
                    5.7711e-08,
                    5.9673e-08,
                    6.1774e-08,
                    6.3963e-08,
                    7.4161e-08,
                    9.24e-08,
                    1.1847e-07,
                    1.5245e-07,
                    1.9523e-07,
                    2.4748e-07,
                    3.0951e-07,
                    3.8159e-07,
                    4.6407e-07,
                    5.5707e-07,
                    6.5294e-07,
                    7.5072e-07,
                    8.5e-07,
                    9.5011e-07,
                    1.0508e-06,
                    1.1518e-06,
                    1.2529e-06,
                    1.354e-06,
                    1.4553e-06,
                    1.557e-06,
                    1.6477e-06,
                    1.7323e-06,
                    1.8116e-06,
                    1.886e-06,
                    1.9533e-06,
                    2.014e-06,
                    2.067e-06,
                    2.1113e-06,
                    2.1474e-06,
                    2.1651e-06,
                    2.1852e-06,
                    2.2036e-06,
                    2.2215e-06,
                    2.2391e-06,
                    2.2576e-06,
                    2.2787e-06,
                    2.3031e-06,
                    2.3309e-06,
                    2.3623e-06,
                    2.3968e-06,
                    2.4383e-06,
                    2.4825e-06,
                    2.5284e-06,
                    2.5764e-06,
                    2.6257e-06,
                    2.6756e-06,
                    2.7267e-06,
                    2.78e-06,
                    2.8346e-06,
                    2.9026e-06,
                    2.9669e-06,
                    3.0328e-06,
                    3.0989e-06,
                    3.1655e-06,
                    3.2319e-06,
                    3.2967e-06,
                    3.3589e-06,
                    3.4189e-06,
                    3.4765e-06,
                    3.5245e-06,
                    3.5672e-06,
                    3.6046e-06,
                    3.6374e-06,
                    3.6648e-06,
                    3.6875e-06,
                    3.706e-06,
                    3.7207e-06,
                    3.7316e-06,
                    3.7379e-06,
                    3.7364e-06,
                    3.7382e-06,
                    3.7391e-06,
                    3.7398e-06,
                    3.7421e-06,
                    3.7425e-06,
                    3.7418e-06,
                    3.7418e-06,
                    3.7406e-06,
                    3.7341e-06,
                    3.732e-06,
                    3.7319e-06,
                    3.7339e-06
                ],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [
                    5.4983e-11,
                    9.6804e-11,
                    1.3808e-10,
                    1.7885e-10,
                    2.1914e-10,
                    2.7639e-10,
                    3.5086e-10,
                    4.4278e-10,
                    5.5243e-10,
                    6.8006e-10,
                    8.0383e-10,
                    9.2283e-10,
                    1.0379e-09,
                    1.1484e-09,
                    1.2446e-09,
                    1.3265e-09,
                    1.3944e-09,
                    1.4483e-09,
                    1.4841e-09,
                    1.502e-09,
                    1.5622e-09,
                    1.6589e-09,
                    1.7804e-09,
                    1.9268e-09,
                    2.0966e-09,
                    2.2735e-09,
                    2.4575e-09,
                    2.6466e-09,
                    2.8408e-09,
                    3.0397e-09,
                    3.2584e-09,
                    3.5146e-09,
                    3.7996e-09,
                    4.1047e-09,
                    4.4349e-09,
                    4.7902e-09,
                    5.1757e-09,
                    5.5888e-09,
                    6.0373e-09,
                    6.5453e-09,
                    7.0511e-09,
                    7.5613e-09,
                    8.0786e-09,
                    8.6014e-09,
                    9.1297e-09,
                    9.6635e-09,
                    1.0203e-08,
                    1.075e-08,
                    1.1306e-08,
                    1.1841e-08,
                    1.2386e-08,
                    1.2929e-08,
                    1.3473e-08,
                    1.403e-08,
                    1.4604e-08,
                    1.5194e-08,
                    1.5796e-08,
                    1.6411e-08,
                    1.7035e-08,
                    1.7646e-08,
                    1.8264e-08,
                    1.8882e-08,
                    1.9498e-08,
                    2.0103e-08,
                    2.0697e-08,
                    2.1279e-08,
                    2.1848e-08,
                    2.2405e-08,
                    2.2945e-08,
                    2.3499e-08,
                    2.4077e-08,
                    2.4699e-08,
                    2.5355e-08,
                    2.604e-08,
                    2.6755e-08,
                    2.7516e-08,
                    2.8318e-08,
                    2.9167e-08,
                    3.0063e-08,
                    3.1014e-08,
                    3.202e-08,
                    3.307e-08,
                    3.4159e-08,
                    3.529e-08,
                    3.6461e-08,
                    3.7675e-08,
                    3.8955e-08,
                    4.0315e-08,
                    4.1769e-08,
                    4.3267e-08,
                    4.9852e-08,
                    6.1486e-08,
                    7.789e-08,
                    9.9062e-08,
                    1.2584e-07,
                    1.588e-07,
                    1.9821e-07,
                    2.4424e-07,
                    2.9718e-07,
                    3.5708e-07,
                    4.1904e-07,
                    4.8215e-07,
                    5.4608e-07,
                    6.102e-07,
                    6.7432e-07,
                    7.3807e-07,
                    8.0132e-07,
                    8.6402e-07,
                    9.2618e-07,
                    9.8796e-07,
                    1.0446e-06,
                    1.0963e-06,
                    1.1439e-06,
                    1.1877e-06,
                    1.2273e-06,
                    1.2628e-06,
                    1.2942e-06,
                    1.3217e-06,
                    1.346e-06,
                    1.3589e-06,
                    1.3754e-06,
                    1.392e-06,
                    1.4093e-06,
                    1.4277e-06,
                    1.4475e-06,
                    1.4693e-06,
                    1.4934e-06,
                    1.5198e-06,
                    1.5487e-06,
                    1.5797e-06,
                    1.613e-06,
                    1.6483e-06,
                    1.6848e-06,
                    1.7229e-06,
                    1.7624e-06,
                    1.8028e-06,
                    1.8438e-06,
                    1.8855e-06,
                    1.9268e-06,
                    1.9783e-06,
                    2.0256e-06,
                    2.0736e-06,
                    2.1211e-06,
                    2.1687e-06,
                    2.2163e-06,
                    2.2635e-06,
                    2.3097e-06,
                    2.3552e-06,
                    2.3999e-06,
                    2.4448e-06,
                    2.4858e-06,
                    2.5227e-06,
                    2.5569e-06,
                    2.587e-06,
                    2.6124e-06,
                    2.634e-06,
                    2.6514e-06,
                    2.6648e-06,
                    2.6731e-06,
                    2.6738e-06,
                    2.6779e-06,
                    2.681e-06,
                    2.6838e-06,
                    2.6867e-06,
                    2.6878e-06,
                    2.6883e-06,
                    2.6895e-06,
                    2.6897e-06,
                    2.685e-06,
                    2.6777e-06,
                    2.673e-06,
                    2.6717e-06
                ],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [
                    5.9166e-11,
                    1.1953e-10,
                    1.811e-10,
                    2.4386e-10,
                    3.0783e-10,
                    3.7299e-10,
                    4.3936e-10,
                    5.0693e-10,
                    5.7569e-10,
                    6.4566e-10,
                    7.0637e-10,
                    7.5781e-10,
                    8e-10,
                    8.3294e-10,
                    8.5661e-10,
                    8.7102e-10,
                    8.7617e-10,
                    8.7207e-10,
                    8.5871e-10,
                    8.3608e-10,
                    8.2907e-10,
                    8.3766e-10,
                    8.6187e-10,
                    9.0168e-10,
                    9.571e-10,
                    1.0281e-09,
                    1.1148e-09,
                    1.217e-09,
                    1.3349e-09,
                    1.4683e-09,
                    1.6239e-09,
                    1.8016e-09,
                    2.0015e-09,
                    2.2235e-09,
                    2.4676e-09,
                    2.7338e-09,
                    3.0222e-09,
                    3.3327e-09,
                    3.6653e-09,
                    4.0201e-09,
                    4.3751e-09,
                    4.7303e-09,
                    5.0858e-09,
                    5.4415e-09,
                    5.7974e-09,
                    6.1535e-09,
                    6.5099e-09,
                    6.8665e-09,
                    7.2234e-09,
                    7.5804e-09,
                    7.9277e-09,
                    8.2652e-09,
                    8.5928e-09,
                    8.9107e-09,
                    9.2187e-09,
                    9.517e-09,
                    9.8054e-09,
                    1.0084e-08,
                    1.0353e-08,
                    1.0612e-08,
                    1.0861e-08,
                    1.11e-08,
                    1.133e-08,
                    1.1549e-08,
                    1.1759e-08,
                    1.1958e-08,
                    1.2148e-08,
                    1.2328e-08,
                    1.2498e-08,
                    1.2658e-08,
                    1.2841e-08,
                    1.3046e-08,
                    1.3273e-08,
                    1.3522e-08,
                    1.3794e-08,
                    1.4089e-08,
                    1.4406e-08,
                    1.4745e-08,
                    1.5106e-08,
                    1.549e-08,
                    1.5892e-08,
                    1.6312e-08,
                    1.675e-08,
                    1.7206e-08,
                    1.768e-08,
                    1.8197e-08,
                    1.8756e-08,
                    1.9359e-08,
                    2.0005e-08,
                    2.0696e-08,
                    2.4309e-08,
                    3.0914e-08,
                    4.0583e-08,
                    5.3386e-08,
                    6.9394e-08,
                    8.8678e-08,
                    1.1131e-07,
                    1.3735e-07,
                    1.6689e-07,
                    1.9998e-07,
                    2.339e-07,
                    2.6857e-07,
                    3.0392e-07,
                    3.3991e-07,
                    3.7653e-07,
                    4.1373e-07,
                    4.5154e-07,
                    4.8998e-07,
                    5.2912e-07,
                    5.6902e-07,
                    6.0319e-07,
                    6.3605e-07,
                    6.6775e-07,
                    6.9829e-07,
                    7.2597e-07,
                    7.5116e-07,
                    7.7281e-07,
                    7.8961e-07,
                    8.0134e-07,
                    8.062e-07,
                    8.0984e-07,
                    8.116e-07,
                    8.1216e-07,
                    8.1139e-07,
                    8.1006e-07,
                    8.094e-07,
                    8.0973e-07,
                    8.1111e-07,
                    8.1356e-07,
                    8.1711e-07,
                    8.2537e-07,
                    8.3422e-07,
                    8.4359e-07,
                    8.5352e-07,
                    8.6335e-07,
                    8.7284e-07,
                    8.8294e-07,
                    8.9453e-07,
                    9.0781e-07,
                    9.2434e-07,
                    9.4127e-07,
                    9.5927e-07,
                    9.7778e-07,
                    9.9679e-07,
                    1.0157e-06,
                    1.0332e-06,
                    1.0492e-06,
                    1.0637e-06,
                    1.0765e-06,
                    1.0798e-06,
                    1.0813e-06,
                    1.0819e-06,
                    1.0805e-06,
                    1.0778e-06,
                    1.0751e-06,
                    1.072e-06,
                    1.0692e-06,
                    1.0668e-06,
                    1.0648e-06,
                    1.0625e-06,
                    1.0603e-06,
                    1.0581e-06,
                    1.0561e-06,
                    1.0554e-06,
                    1.0547e-06,
                    1.0535e-06,
                    1.0524e-06,
                    1.0509e-06,
                    1.0491e-06,
                    1.0543e-06,
                    1.0588e-06,
                    1.0621e-06
                ],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [
                    3.3007e-10,
                    6.6427e-10,
                    1.0025e-09,
                    1.3448e-09,
                    1.6908e-09,
                    2.0405e-09,
                    2.3937e-09,
                    2.7502e-09,
                    3.1097e-09,
                    3.4719e-09,
                    3.8368e-09,
                    4.2041e-09,
                    4.574e-09,
                    4.9464e-09,
                    5.3212e-09,
                    5.6985e-09,
                    6.0783e-09,
                    6.4607e-09,
                    6.8455e-09,
                    7.233e-09,
                    7.6245e-09,
                    8.0226e-09,
                    8.4291e-09,
                    8.8454e-09,
                    9.2722e-09,
                    9.7097e-09,
                    1.0158e-08,
                    1.0615e-08,
                    1.108e-08,
                    1.1551e-08,
                    1.2026e-08,
                    1.2505e-08,
                    1.2988e-08,
                    1.3474e-08,
                    1.3964e-08,
                    1.4457e-08,
                    1.4953e-08,
                    1.5453e-08,
                    1.5956e-08,
                    1.6516e-08,
                    1.7081e-08,
                    1.7655e-08,
                    1.8238e-08,
                    1.8834e-08,
                    1.9444e-08,
                    2.0069e-08,
                    2.0712e-08,
                    2.1372e-08,
                    2.2051e-08,
                    2.2749e-08,
                    2.3473e-08,
                    2.4233e-08,
                    2.5037e-08,
                    2.5888e-08,
                    2.679e-08,
                    2.7742e-08,
                    2.874e-08,
                    2.9778e-08,
                    3.0847e-08,
                    3.1936e-08,
                    3.3039e-08,
                    3.4153e-08,
                    3.5279e-08,
                    3.6417e-08,
                    3.7565e-08,
                    3.8722e-08,
                    3.9888e-08,
                    4.1063e-08,
                    4.2244e-08,
                    4.3431e-08,
                    4.4622e-08,
                    4.5813e-08,
                    4.7002e-08,
                    4.8187e-08,
                    4.9368e-08,
                    5.0545e-08,
                    5.1717e-08,
                    5.2887e-08,
                    5.4058e-08,
                    5.5232e-08,
                    5.6414e-08,
                    5.7611e-08,
                    5.8827e-08,
                    6.0067e-08,
                    6.1335e-08,
                    6.2632e-08,
                    6.396e-08,
                    6.5319e-08,
                    6.6709e-08,
                    6.8129e-08,
                    6.9608e-08,
                    7.12e-08,
                    7.2945e-08,
                    7.4872e-08,
                    7.6999e-08,
                    7.933e-08,
                    8.1859e-08,
                    8.4565e-08,
                    8.7419e-08,
                    9.0376e-08,
                    9.3434e-08,
                    9.6634e-08,
                    1.0001e-07,
                    1.0358e-07,
                    1.0735e-07,
                    1.1134e-07,
                    1.1553e-07,
                    1.1991e-07,
                    1.2446e-07,
                    1.2913e-07,
                    1.341e-07,
                    1.3921e-07,
                    1.4451e-07,
                    1.5001e-07,
                    1.5586e-07,
                    1.6202e-07,
                    1.6883e-07,
                    1.7604e-07,
                    1.8358e-07,
                    1.9137e-07,
                    1.9905e-07,
                    2.0699e-07,
                    2.1537e-07,
                    2.2361e-07,
                    2.3231e-07,
                    2.4102e-07,
                    2.5105e-07,
                    2.5892e-07,
                    2.6771e-07,
                    2.7498e-07,
                    2.8288e-07,
                    2.923e-07,
                    3.013e-07,
                    3.1148e-07,
                    3.2227e-07,
                    3.3265e-07,
                    3.4318e-07,
                    3.5405e-07,
                    3.6864e-07,
                    3.8191e-07,
                    3.9704e-07,
                    4.1193e-07,
                    4.2407e-07,
                    4.3313e-07,
                    4.414e-07,
                    4.4979e-07,
                    4.5776e-07,
                    4.6804e-07,
                    4.7776e-07,
                    4.8816e-07,
                    4.964e-07,
                    5.0485e-07,
                    5.1475e-07,
                    5.2418e-07,
                    5.3402e-07,
                    5.4356e-07,
                    5.5303e-07,
                    5.6231e-07,
                    5.7199e-07,
                    5.8258e-07,
                    5.9309e-07,
                    6.0393e-07,
                    6.1445e-07,
                    6.2572e-07,
                    6.3722e-07,
                    6.4827e-07,
                    6.5782e-07,
                    6.6742e-07,
                    6.7848e-07,
                    6.8938e-07,
                    7.0044e-07,
                    7.1161e-07
                ],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [
                    2.7795e-10,
                    5.59e-10,
                    8.4311e-10,
                    1.1302e-09,
                    1.4203e-09,
                    1.7134e-09,
                    2.0092e-09,
                    2.3078e-09,
                    2.6091e-09,
                    2.9129e-09,
                    3.2192e-09,
                    3.5279e-09,
                    3.8391e-09,
                    4.1528e-09,
                    4.4689e-09,
                    4.7874e-09,
                    5.1084e-09,
                    5.4318e-09,
                    5.7578e-09,
                    6.0861e-09,
                    6.4176e-09,
                    6.7531e-09,
                    7.0934e-09,
                    7.439e-09,
                    7.7902e-09,
                    8.1471e-09,
                    8.5095e-09,
                    8.877e-09,
                    9.2491e-09,
                    9.6249e-09,
                    1.0004e-08,
                    1.0386e-08,
                    1.0771e-08,
                    1.1159e-08,
                    1.1549e-08,
                    1.1943e-08,
                    1.2339e-08,
                    1.2738e-08,
                    1.314e-08,
                    1.3546e-08,
                    1.3956e-08,
                    1.4369e-08,
                    1.4786e-08,
                    1.5206e-08,
                    1.5629e-08,
                    1.6057e-08,
                    1.6488e-08,
                    1.6923e-08,
                    1.7362e-08,
                    1.7804e-08,
                    1.8251e-08,
                    1.8702e-08,
                    1.9158e-08,
                    1.9619e-08,
                    2.0084e-08,
                    2.0555e-08,
                    2.103e-08,
                    2.151e-08,
                    2.1995e-08,
                    2.2485e-08,
                    2.2979e-08,
                    2.3478e-08,
                    2.3981e-08,
                    2.4489e-08,
                    2.5002e-08,
                    2.5519e-08,
                    2.604e-08,
                    2.6566e-08,
                    2.7096e-08,
                    2.7631e-08,
                    2.8171e-08,
                    2.8715e-08,
                    2.9263e-08,
                    2.9817e-08,
                    3.0375e-08,
                    3.0937e-08,
                    3.1504e-08,
                    3.2076e-08,
                    3.2652e-08,
                    3.3233e-08,
                    3.3818e-08,
                    3.4408e-08,
                    3.5002e-08,
                    3.56e-08,
                    3.6203e-08,
                    3.681e-08,
                    3.7422e-08,
                    3.8039e-08,
                    3.8661e-08,
                    3.9289e-08,
                    3.9924e-08,
                    4.0571e-08,
                    4.1232e-08,
                    4.1909e-08,
                    4.2603e-08,
                    4.3315e-08,
                    4.4046e-08,
                    4.4793e-08,
                    4.5556e-08,
                    4.6333e-08,
                    4.7123e-08,
                    4.7926e-08,
                    4.8743e-08,
                    4.9576e-08,
                    5.0424e-08,
                    5.1288e-08,
                    5.2169e-08,
                    5.3066e-08,
                    5.3981e-08,
                    5.4912e-08,
                    5.5861e-08,
                    5.6828e-08,
                    5.7815e-08,
                    5.8822e-08,
                    5.9851e-08,
                    6.0902e-08,
                    6.1979e-08,
                    6.3081e-08,
                    6.4212e-08,
                    6.5452e-08,
                    6.6716e-08,
                    6.8078e-08,
                    6.9417e-08,
                    7.065e-08,
                    7.2086e-08,
                    7.3394e-08,
                    7.4835e-08,
                    7.634e-08,
                    7.7826e-08,
                    7.93e-08,
                    8.0647e-08,
                    8.2134e-08,
                    8.3502e-08,
                    8.501e-08,
                    8.6695e-08,
                    8.8482e-08,
                    9.0387e-08,
                    9.2609e-08,
                    9.4937e-08,
                    9.7338e-08,
                    1e-07,
                    1.0275e-07,
                    1.053e-07,
                    1.0814e-07,
                    1.1108e-07,
                    1.1406e-07,
                    1.1696e-07,
                    1.2002e-07,
                    1.2297e-07,
                    1.2665e-07,
                    1.3053e-07,
                    1.3408e-07,
                    1.3813e-07,
                    1.4226e-07,
                    1.4649e-07,
                    1.5069e-07,
                    1.5494e-07,
                    1.5932e-07,
                    1.6388e-07,
                    1.6905e-07,
                    1.744e-07,
                    1.797e-07,
                    1.8512e-07,
                    1.9055e-07,
                    1.96e-07,
                    2.0138e-07,
                    2.0554e-07,
                    2.0963e-07,
                    2.1508e-07,
                    2.2045e-07,
                    2.2617e-07,
                    2.3207e-07
                ],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": [
                    5.2114e-11,
                    1.0527e-10,
                    1.5942e-10,
                    2.1451e-10,
                    2.7046e-10,
                    3.2717e-10,
                    3.8452e-10,
                    4.4239e-10,
                    5.0062e-10,
                    5.5906e-10,
                    6.176e-10,
                    6.7622e-10,
                    7.3488e-10,
                    7.9359e-10,
                    8.5234e-10,
                    9.1112e-10,
                    9.6994e-10,
                    1.0288e-09,
                    1.0878e-09,
                    1.1468e-09,
                    1.2069e-09,
                    1.2695e-09,
                    1.3357e-09,
                    1.4064e-09,
                    1.482e-09,
                    1.5627e-09,
                    1.6481e-09,
                    1.7378e-09,
                    1.8308e-09,
                    1.9258e-09,
                    2.0218e-09,
                    2.1189e-09,
                    2.2167e-09,
                    2.3152e-09,
                    2.4143e-09,
                    2.514e-09,
                    2.6143e-09,
                    2.7152e-09,
                    2.8168e-09,
                    2.9701e-09,
                    3.1255e-09,
                    3.2856e-09,
                    3.4525e-09,
                    3.6281e-09,
                    3.8142e-09,
                    4.0123e-09,
                    4.2236e-09,
                    4.4491e-09,
                    4.6894e-09,
                    4.9451e-09,
                    5.2223e-09,
                    5.5309e-09,
                    5.8784e-09,
                    6.2693e-09,
                    6.7057e-09,
                    7.1869e-09,
                    7.7095e-09,
                    8.2674e-09,
                    8.8519e-09,
                    9.4514e-09,
                    1.0059e-08,
                    1.0675e-08,
                    1.1298e-08,
                    1.1927e-08,
                    1.2563e-08,
                    1.3203e-08,
                    1.3848e-08,
                    1.4497e-08,
                    1.5147e-08,
                    1.58e-08,
                    1.6451e-08,
                    1.7098e-08,
                    1.7738e-08,
                    1.8371e-08,
                    1.8994e-08,
                    1.9608e-08,
                    2.0213e-08,
                    2.0812e-08,
                    2.1406e-08,
                    2.1999e-08,
                    2.2596e-08,
                    2.3203e-08,
                    2.3826e-08,
                    2.4468e-08,
                    2.5132e-08,
                    2.5822e-08,
                    2.6538e-08,
                    2.728e-08,
                    2.8048e-08,
                    2.8841e-08,
                    2.9684e-08,
                    3.0629e-08,
                    3.1713e-08,
                    3.2963e-08,
                    3.4396e-08,
                    3.6015e-08,
                    3.7813e-08,
                    3.9772e-08,
                    4.1862e-08,
                    4.4043e-08,
                    4.6311e-08,
                    4.8708e-08,
                    5.1264e-08,
                    5.4e-08,
                    5.6928e-08,
                    6.0051e-08,
                    6.3362e-08,
                    6.6846e-08,
                    7.0477e-08,
                    7.422e-08,
                    7.8241e-08,
                    8.2384e-08,
                    8.6699e-08,
                    9.1186e-08,
                    9.6005e-08,
                    1.0112e-07,
                    1.0685e-07,
                    1.1296e-07,
                    1.1936e-07,
                    1.2592e-07,
                    1.3233e-07,
                    1.3891e-07,
                    1.4596e-07,
                    1.5296e-07,
                    1.6023e-07,
                    1.6763e-07,
                    1.7621e-07,
                    1.8258e-07,
                    1.8988e-07,
                    1.9568e-07,
                    2.0224e-07,
                    2.1017e-07,
                    2.178e-07,
                    2.2647e-07,
                    2.3558e-07,
                    2.4417e-07,
                    2.5279e-07,
                    2.6144e-07,
                    2.737e-07,
                    2.8457e-07,
                    2.9704e-07,
                    3.0918e-07,
                    3.1877e-07,
                    3.2499e-07,
                    3.3032e-07,
                    3.3574e-07,
                    3.408e-07,
                    3.4802e-07,
                    3.5479e-07,
                    3.6151e-07,
                    3.6587e-07,
                    3.7077e-07,
                    3.7661e-07,
                    3.8191e-07,
                    3.8753e-07,
                    3.9287e-07,
                    3.9809e-07,
                    4.0299e-07,
                    4.0811e-07,
                    4.1353e-07,
                    4.187e-07,
                    4.2423e-07,
                    4.2933e-07,
                    4.3517e-07,
                    4.4122e-07,
                    4.4689e-07,
                    4.5227e-07,
                    4.5779e-07,
                    4.634e-07,
                    4.6893e-07,
                    4.7427e-07,
                    4.7954e-07
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -61.07922,
                            13.87934
                        ],
                        [
                            -61.0773,
                            13.80762
                        ],
                        [
                            -61.02978,
                            13.75473
                        ],
                        [
                            -60.94638,
                            13.72362
                        ],
                        [
                            -60.90555,
                            13.766
                        ],
                        [
                            -60.87508,
                            13.94768
                        ],
                        [
                            -60.8849,
                            14.05168
                        ],
                        [
                            -60.94425,
                            14.10826
                        ],
                        [
                            -60.97338,
                            14.03568
                        ],
                        [
                            -61.0586,
                            13.93259
                        ],
                        [
                            -61.07922,
                            13.87934
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "SPM",
                "Country": "Saint Pierre and Miquelon",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    6.6e-09,
                    1.65e-08,
                    3.135e-08,
                    4.455e-08,
                    5.94e-08,
                    7.59e-08,
                    9.075e-08,
                    1.089e-07,
                    1.2705e-07,
                    1.419e-07,
                    1.584e-07,
                    1.7985e-07,
                    1.947e-07,
                    2.112e-07,
                    2.3265e-07,
                    2.508e-07,
                    2.706e-07,
                    2.937e-07,
                    3.1185e-07,
                    3.267e-07,
                    3.432e-07,
                    3.6465e-07,
                    3.96e-07,
                    4.1415e-07,
                    4.3395e-07,
                    4.488e-07,
                    4.7025e-07,
                    4.8675e-07,
                    5.016e-07,
                    5.181e-07,
                    5.346e-07,
                    5.5275e-07,
                    5.709e-07,
                    5.8575e-07,
                    6.0225e-07,
                    6.171e-07,
                    6.3855e-07,
                    6.6165e-07,
                    6.9135e-07,
                    7.3755e-07,
                    7.788e-07,
                    8.25e-07,
                    8.679e-07,
                    9.009e-07,
                    9.3225e-07,
                    9.636e-07,
                    9.9495e-07,
                    1.0164e-06,
                    1.0411e-06,
                    1.0659e-06,
                    1.0907e-06,
                    1.1154e-06,
                    1.1418e-06,
                    1.1698e-06,
                    1.1962e-06,
                    1.2243e-06,
                    1.254e-06,
                    1.2837e-06,
                    1.3134e-06,
                    1.3431e-06,
                    1.3728e-06,
                    1.4025e-06,
                    1.4322e-06,
                    1.4619e-06,
                    1.4916e-06,
                    1.5213e-06,
                    1.551e-06,
                    1.5807e-06,
                    1.6071e-06,
                    1.6368e-06,
                    1.6649e-06,
                    1.6919e-06,
                    1.7192e-06
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    6.6e-09,
                    1.65e-08,
                    3.135e-08,
                    4.455e-08,
                    5.94e-08,
                    7.59e-08,
                    9.075e-08,
                    1.089e-07,
                    1.2705e-07,
                    1.419e-07,
                    1.584e-07,
                    1.7985e-07,
                    1.947e-07,
                    2.112e-07,
                    2.3265e-07,
                    2.508e-07,
                    2.706e-07,
                    2.937e-07,
                    3.1185e-07,
                    3.267e-07,
                    3.432e-07,
                    3.6465e-07,
                    3.96e-07,
                    4.1415e-07,
                    4.3395e-07,
                    4.488e-07,
                    4.7025e-07,
                    4.8675e-07,
                    5.016e-07,
                    5.181e-07,
                    5.346e-07,
                    5.5275e-07,
                    5.709e-07,
                    5.8575e-07,
                    6.0225e-07,
                    6.171e-07,
                    6.3855e-07,
                    6.6165e-07,
                    6.9135e-07,
                    7.3755e-07,
                    7.788e-07,
                    8.25e-07,
                    8.679e-07,
                    9.009e-07,
                    9.3225e-07,
                    9.636e-07,
                    9.9495e-07,
                    1.0164e-06,
                    1.0411e-06,
                    1.0659e-06,
                    1.0907e-06,
                    1.1154e-06,
                    1.1418e-06,
                    1.1698e-06,
                    1.1962e-06,
                    1.2243e-06,
                    1.254e-06,
                    1.2837e-06,
                    1.3134e-06,
                    1.3431e-06,
                    1.3728e-06,
                    1.4025e-06,
                    1.4322e-06,
                    1.4619e-06,
                    1.4916e-06,
                    1.5213e-06,
                    1.551e-06,
                    1.5807e-06,
                    1.6071e-06,
                    1.6368e-06,
                    1.6649e-06,
                    1.6919e-06,
                    1.7192e-06
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    6.6e-09,
                    1.65e-08,
                    3.135e-08,
                    4.455e-08,
                    5.94e-08,
                    7.59e-08,
                    9.075e-08,
                    1.089e-07,
                    1.2705e-07,
                    1.419e-07,
                    1.584e-07,
                    1.7985e-07,
                    1.947e-07,
                    2.112e-07,
                    2.3265e-07,
                    2.508e-07,
                    2.706e-07,
                    2.937e-07,
                    3.1185e-07,
                    3.267e-07,
                    3.432e-07,
                    3.6465e-07,
                    3.96e-07,
                    4.1415e-07,
                    4.3395e-07,
                    4.488e-07,
                    4.7025e-07,
                    4.8675e-07,
                    5.016e-07,
                    5.181e-07,
                    5.346e-07,
                    5.5275e-07,
                    5.709e-07,
                    5.8575e-07,
                    6.0225e-07,
                    6.171e-07,
                    6.3855e-07,
                    6.6165e-07,
                    6.9135e-07,
                    7.3755e-07,
                    7.788e-07,
                    8.25e-07,
                    8.679e-07,
                    9.009e-07,
                    9.3225e-07,
                    9.636e-07,
                    9.9495e-07,
                    1.0164e-06,
                    1.0411e-06,
                    1.0659e-06,
                    1.0907e-06,
                    1.1154e-06,
                    1.1418e-06,
                    1.1698e-06,
                    1.1962e-06,
                    1.2243e-06,
                    1.254e-06,
                    1.2837e-06,
                    1.3134e-06,
                    1.3431e-06,
                    1.3728e-06,
                    1.4025e-06,
                    1.4322e-06,
                    1.4619e-06,
                    1.4916e-06,
                    1.5213e-06,
                    1.551e-06,
                    1.5807e-06,
                    1.6071e-06,
                    1.6368e-06,
                    1.6649e-06,
                    1.6919e-06,
                    1.7192e-06
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    6.6e-09,
                    1.65e-08,
                    3.135e-08,
                    4.455e-08,
                    5.94e-08,
                    7.59e-08,
                    9.075e-08,
                    1.089e-07,
                    1.2705e-07,
                    1.419e-07,
                    1.584e-07,
                    1.7985e-07,
                    1.947e-07,
                    2.112e-07,
                    2.3265e-07,
                    2.508e-07,
                    2.706e-07,
                    2.937e-07,
                    3.1185e-07,
                    3.267e-07,
                    3.432e-07,
                    3.6465e-07,
                    3.96e-07,
                    4.1415e-07,
                    4.3395e-07,
                    4.488e-07,
                    4.7025e-07,
                    4.8675e-07,
                    5.016e-07,
                    5.181e-07,
                    5.346e-07,
                    5.5275e-07,
                    5.709e-07,
                    5.8575e-07,
                    6.0225e-07,
                    6.171e-07,
                    6.3855e-07,
                    6.6165e-07,
                    6.9135e-07,
                    7.3755e-07,
                    7.788e-07,
                    8.25e-07,
                    8.679e-07,
                    9.009e-07,
                    9.3225e-07,
                    9.636e-07,
                    9.9495e-07,
                    1.0164e-06,
                    1.0411e-06,
                    1.0659e-06,
                    1.0907e-06,
                    1.1154e-06,
                    1.1418e-06,
                    1.1698e-06,
                    1.1962e-06,
                    1.2243e-06,
                    1.254e-06,
                    1.2837e-06,
                    1.3134e-06,
                    1.3431e-06,
                    1.3728e-06,
                    1.4025e-06,
                    1.4322e-06,
                    1.4619e-06,
                    1.4916e-06,
                    1.5213e-06,
                    1.551e-06,
                    1.5807e-06,
                    1.6071e-06,
                    1.6368e-06,
                    1.6649e-06,
                    1.6919e-06,
                    1.7192e-06
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": []
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -56.40527,
                            46.83647
                        ],
                        [
                            -56.32891,
                            46.79223
                        ],
                        [
                            -56.23963,
                            46.87071
                        ],
                        [
                            -56.32259,
                            46.91254
                        ],
                        [
                            -56.2539,
                            47.05865
                        ],
                        [
                            -56.36523,
                            47.09522
                        ],
                        [
                            -56.38264,
                            47.01919
                        ],
                        [
                            -56.33058,
                            46.89778
                        ],
                        [
                            -56.40527,
                            46.83647
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "VCT",
                "Country": "Saint Vincent and The Grenadines",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    8.4699e-09,
                    1.6446e-08,
                    2.4327e-08,
                    3.212e-08,
                    3.9808e-08,
                    4.8013e-08,
                    5.6689e-08,
                    6.5783e-08,
                    7.5447e-08,
                    8.5664e-08,
                    9.6312e-08,
                    1.0722e-07,
                    1.1846e-07,
                    1.2997e-07,
                    1.4161e-07,
                    1.5319e-07,
                    1.6485e-07,
                    1.7653e-07,
                    1.8813e-07,
                    1.9967e-07,
                    2.119e-07,
                    2.2448e-07,
                    2.3722e-07,
                    2.5016e-07,
                    2.6325e-07,
                    2.7597e-07,
                    2.8829e-07,
                    3.0018e-07,
                    3.1165e-07,
                    3.2266e-07,
                    3.3339e-07,
                    3.4442e-07,
                    3.5544e-07,
                    3.6614e-07,
                    3.7676e-07,
                    3.873e-07,
                    3.979e-07,
                    4.0849e-07,
                    4.1933e-07,
                    4.3119e-07,
                    4.4311e-07,
                    4.5526e-07,
                    4.6776e-07,
                    4.8059e-07,
                    4.9371e-07,
                    5.0705e-07,
                    5.2067e-07,
                    5.3471e-07,
                    5.4913e-07,
                    5.6323e-07,
                    5.7779e-07,
                    5.9236e-07,
                    6.0715e-07,
                    6.2247e-07,
                    6.3843e-07,
                    6.5505e-07,
                    6.721e-07,
                    6.897e-07,
                    7.0775e-07,
                    7.2469e-07,
                    7.4151e-07,
                    7.5818e-07,
                    7.7466e-07,
                    7.9078e-07,
                    8.065e-07,
                    8.218e-07,
                    8.3661e-07,
                    8.5092e-07,
                    8.6461e-07,
                    8.7838e-07,
                    8.9136e-07,
                    9.0386e-07,
                    9.1561e-07,
                    9.2645e-07,
                    9.3643e-07,
                    9.4585e-07,
                    9.5459e-07,
                    9.628e-07,
                    9.7053e-07,
                    9.7807e-07,
                    9.8586e-07,
                    9.9382e-07,
                    1.002e-06,
                    1.0107e-06,
                    1.0201e-06,
                    1.0305e-06,
                    1.0418e-06,
                    1.0547e-06,
                    1.0692e-06,
                    1.0849e-06,
                    1.1022e-06,
                    1.121e-06,
                    1.141e-06,
                    1.1627e-06,
                    1.1863e-06,
                    1.2122e-06,
                    1.2405e-06,
                    1.2711e-06,
                    1.3036e-06,
                    1.3437e-06,
                    1.3883e-06,
                    1.4405e-06,
                    1.4942e-06,
                    1.5504e-06,
                    1.6083e-06,
                    1.667e-06,
                    1.7258e-06,
                    1.7849e-06,
                    1.8444e-06,
                    1.8947e-06,
                    1.9414e-06,
                    2.0317e-06,
                    2.0902e-06,
                    2.1414e-06,
                    2.188e-06,
                    2.2346e-06,
                    2.2758e-06,
                    2.3141e-06,
                    2.3546e-06,
                    2.3953e-06,
                    2.4356e-06,
                    2.4736e-06,
                    2.5148e-06,
                    2.5547e-06,
                    2.598e-06,
                    2.6745e-06,
                    2.7369e-06,
                    2.8426e-06,
                    2.9209e-06,
                    2.9948e-06,
                    3.0658e-06,
                    3.1773e-06,
                    3.2674e-06,
                    3.3636e-06,
                    3.4942e-06,
                    3.5908e-06,
                    3.6801e-06,
                    3.7645e-06,
                    3.8401e-06,
                    3.9141e-06,
                    3.9844e-06,
                    4.0543e-06,
                    4.1314e-06,
                    4.2153e-06,
                    4.297e-06,
                    4.3859e-06,
                    4.4747e-06,
                    4.5745e-06,
                    4.668e-06,
                    4.7515e-06,
                    4.8482e-06,
                    4.944e-06,
                    5.0421e-06,
                    5.1514e-06,
                    5.2628e-06,
                    5.3757e-06,
                    5.5115e-06,
                    5.6383e-06,
                    5.7983e-06,
                    5.9219e-06,
                    6.0451e-06,
                    6.174e-06,
                    6.3371e-06,
                    6.482e-06,
                    6.6087e-06,
                    6.7365e-06,
                    6.8497e-06,
                    6.9734e-06,
                    7.0887e-06,
                    7.2117e-06,
                    7.3332e-06,
                    7.4541e-06
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    3.716e-09,
                    7.0134e-09,
                    1.0254e-08,
                    1.3437e-08,
                    1.6563e-08,
                    2.015e-08,
                    2.4211e-08,
                    2.8762e-08,
                    3.3815e-08,
                    3.9387e-08,
                    4.5272e-08,
                    5.1447e-08,
                    5.7943e-08,
                    6.4745e-08,
                    7.1546e-08,
                    7.8348e-08,
                    8.5154e-08,
                    9.1967e-08,
                    9.8651e-08,
                    1.0521e-07,
                    1.1237e-07,
                    1.1996e-07,
                    1.2766e-07,
                    1.3546e-07,
                    1.4332e-07,
                    1.5076e-07,
                    1.5777e-07,
                    1.6429e-07,
                    1.7031e-07,
                    1.7581e-07,
                    1.8096e-07,
                    1.8628e-07,
                    1.9152e-07,
                    1.9639e-07,
                    2.0109e-07,
                    2.056e-07,
                    2.1008e-07,
                    2.1446e-07,
                    2.1897e-07,
                    2.2431e-07,
                    2.2959e-07,
                    2.3502e-07,
                    2.4065e-07,
                    2.4645e-07,
                    2.5242e-07,
                    2.5856e-07,
                    2.6486e-07,
                    2.714e-07,
                    2.7821e-07,
                    2.8446e-07,
                    2.9105e-07,
                    2.9751e-07,
                    3.0403e-07,
                    3.1092e-07,
                    3.1828e-07,
                    3.2608e-07,
                    3.3419e-07,
                    3.4267e-07,
                    3.5139e-07,
                    3.5971e-07,
                    3.681e-07,
                    3.7636e-07,
                    3.8446e-07,
                    3.9219e-07,
                    3.9954e-07,
                    4.0656e-07,
                    4.132e-07,
                    4.1945e-07,
                    4.2526e-07,
                    4.3142e-07,
                    4.3714e-07,
                    4.4281e-07,
                    4.4826e-07,
                    4.5335e-07,
                    4.581e-07,
                    4.6281e-07,
                    4.6737e-07,
                    4.7187e-07,
                    4.763e-07,
                    4.8078e-07,
                    4.8558e-07,
                    4.9051e-07,
                    4.9551e-07,
                    5.0064e-07,
                    5.0591e-07,
                    5.1135e-07,
                    5.1686e-07,
                    5.2267e-07,
                    5.2895e-07,
                    5.3499e-07,
                    5.408e-07,
                    5.4613e-07,
                    5.5054e-07,
                    5.5449e-07,
                    5.5799e-07,
                    5.6131e-07,
                    5.6447e-07,
                    5.6726e-07,
                    5.6973e-07,
                    5.7324e-07,
                    5.7659e-07,
                    5.8321e-07,
                    5.8784e-07,
                    5.9219e-07,
                    5.962e-07,
                    5.9975e-07,
                    6.0294e-07,
                    6.0726e-07,
                    6.1086e-07,
                    6.1442e-07,
                    6.1786e-07,
                    6.2121e-07,
                    6.2699e-07,
                    6.3507e-07,
                    6.4287e-07,
                    6.5317e-07,
                    6.6447e-07,
                    6.787e-07,
                    6.9765e-07,
                    7.1725e-07,
                    7.3947e-07,
                    7.6548e-07,
                    7.9462e-07,
                    8.2178e-07,
                    8.5034e-07,
                    8.8029e-07,
                    9.119e-07,
                    9.4652e-07,
                    9.7966e-07,
                    1.0174e-06,
                    1.057e-06,
                    1.0995e-06,
                    1.1461e-06,
                    1.2021e-06,
                    1.2584e-06,
                    1.3149e-06,
                    1.3763e-06,
                    1.4329e-06,
                    1.4944e-06,
                    1.5612e-06,
                    1.628e-06,
                    1.6956e-06,
                    1.7705e-06,
                    1.8537e-06,
                    1.9407e-06,
                    2.0289e-06,
                    2.117e-06,
                    2.2187e-06,
                    2.3212e-06,
                    2.4159e-06,
                    2.5249e-06,
                    2.6381e-06,
                    2.7569e-06,
                    2.8857e-06,
                    3.0146e-06,
                    3.1424e-06,
                    3.2789e-06,
                    3.4082e-06,
                    3.5644e-06,
                    3.69e-06,
                    3.8174e-06,
                    3.9512e-06,
                    4.0804e-06,
                    4.2253e-06,
                    4.3613e-06,
                    4.5013e-06,
                    4.6284e-06,
                    4.7671e-06,
                    4.8996e-06,
                    5.0388e-06,
                    5.1745e-06,
                    5.3103e-06
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [
                    4.7539e-09,
                    9.4323e-09,
                    1.4074e-08,
                    1.8684e-08,
                    2.3246e-08,
                    2.7864e-08,
                    3.2478e-08,
                    3.7022e-08,
                    4.1632e-08,
                    4.6277e-08,
                    5.1041e-08,
                    5.5774e-08,
                    6.0516e-08,
                    6.5228e-08,
                    7.0069e-08,
                    7.4842e-08,
                    7.97e-08,
                    8.4567e-08,
                    8.9475e-08,
                    9.4464e-08,
                    9.9538e-08,
                    1.0452e-07,
                    1.0957e-07,
                    1.147e-07,
                    1.1993e-07,
                    1.2521e-07,
                    1.3051e-07,
                    1.3589e-07,
                    1.4134e-07,
                    1.4685e-07,
                    1.5243e-07,
                    1.5813e-07,
                    1.6392e-07,
                    1.6974e-07,
                    1.7567e-07,
                    1.8171e-07,
                    1.8782e-07,
                    1.9404e-07,
                    2.0035e-07,
                    2.0689e-07,
                    2.1351e-07,
                    2.2024e-07,
                    2.2711e-07,
                    2.3414e-07,
                    2.4129e-07,
                    2.4849e-07,
                    2.5581e-07,
                    2.6331e-07,
                    2.7091e-07,
                    2.7876e-07,
                    2.8674e-07,
                    2.9485e-07,
                    3.0311e-07,
                    3.1155e-07,
                    3.2016e-07,
                    3.2896e-07,
                    3.379e-07,
                    3.4703e-07,
                    3.5637e-07,
                    3.6498e-07,
                    3.7341e-07,
                    3.8182e-07,
                    3.902e-07,
                    3.9859e-07,
                    4.0696e-07,
                    4.1524e-07,
                    4.2341e-07,
                    4.3146e-07,
                    4.3935e-07,
                    4.4696e-07,
                    4.5422e-07,
                    4.6105e-07,
                    4.6735e-07,
                    4.731e-07,
                    4.7833e-07,
                    4.8304e-07,
                    4.8722e-07,
                    4.9093e-07,
                    4.9423e-07,
                    4.9729e-07,
                    5.0028e-07,
                    5.033e-07,
                    5.0653e-07,
                    5.1008e-07,
                    5.1422e-07,
                    5.1914e-07,
                    5.2496e-07,
                    5.3199e-07,
                    5.4027e-07,
                    5.4996e-07,
                    5.6141e-07,
                    5.7486e-07,
                    5.9044e-07,
                    6.0823e-07,
                    6.2831e-07,
                    6.5088e-07,
                    6.7606e-07,
                    7.038e-07,
                    7.3385e-07,
                    7.7046e-07,
                    8.1172e-07,
                    8.5729e-07,
                    9.0636e-07,
                    9.5824e-07,
                    1.0121e-06,
                    1.0672e-06,
                    1.1229e-06,
                    1.1776e-06,
                    1.2335e-06,
                    1.2803e-06,
                    1.3236e-06,
                    1.4105e-06,
                    1.4632e-06,
                    1.5063e-06,
                    1.5452e-06,
                    1.5815e-06,
                    1.6113e-06,
                    1.6354e-06,
                    1.657e-06,
                    1.678e-06,
                    1.6961e-06,
                    1.7081e-06,
                    1.7202e-06,
                    1.7329e-06,
                    1.7476e-06,
                    1.7943e-06,
                    1.825e-06,
                    1.8961e-06,
                    1.9412e-06,
                    1.9774e-06,
                    2.0088e-06,
                    2.0778e-06,
                    2.1213e-06,
                    2.1615e-06,
                    2.2358e-06,
                    2.2759e-06,
                    2.3039e-06,
                    2.3316e-06,
                    2.3456e-06,
                    2.3529e-06,
                    2.3564e-06,
                    2.3587e-06,
                    2.3609e-06,
                    2.3616e-06,
                    2.3563e-06,
                    2.357e-06,
                    2.3577e-06,
                    2.3558e-06,
                    2.3468e-06,
                    2.3356e-06,
                    2.3234e-06,
                    2.3059e-06,
                    2.2853e-06,
                    2.2657e-06,
                    2.2482e-06,
                    2.2333e-06,
                    2.2326e-06,
                    2.2301e-06,
                    2.2339e-06,
                    2.2318e-06,
                    2.2277e-06,
                    2.2228e-06,
                    2.2567e-06,
                    2.2567e-06,
                    2.2473e-06,
                    2.2353e-06,
                    2.2213e-06,
                    2.2064e-06,
                    2.1891e-06,
                    2.1729e-06,
                    2.1587e-06,
                    2.1438e-06
                ],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    2.7995e-09,
                    5.5165e-09,
                    8.1895e-09,
                    1.0824e-08,
                    1.3403e-08,
                    1.6033e-08,
                    1.865e-08,
                    2.1192e-08,
                    2.3793e-08,
                    2.6422e-08,
                    2.9161e-08,
                    3.1861e-08,
                    3.4562e-08,
                    3.7224e-08,
                    4.0007e-08,
                    4.2713e-08,
                    4.5496e-08,
                    4.8279e-08,
                    5.1095e-08,
                    5.3983e-08,
                    5.6947e-08,
                    5.9812e-08,
                    6.2722e-08,
                    6.5714e-08,
                    6.8783e-08,
                    7.1896e-08,
                    7.5025e-08,
                    7.821e-08,
                    8.1461e-08,
                    8.4755e-08,
                    8.8121e-08,
                    9.1592e-08,
                    9.5145e-08,
                    9.8725e-08,
                    1.024e-07,
                    1.0618e-07,
                    1.1003e-07,
                    1.1397e-07,
                    1.18e-07,
                    1.2221e-07,
                    1.2651e-07,
                    1.3089e-07,
                    1.3541e-07,
                    1.4007e-07,
                    1.4484e-07,
                    1.4964e-07,
                    1.5455e-07,
                    1.5962e-07,
                    1.6477e-07,
                    1.7016e-07,
                    1.7565e-07,
                    1.8125e-07,
                    1.8697e-07,
                    1.9282e-07,
                    1.9881e-07,
                    2.0496e-07,
                    2.1122e-07,
                    2.1763e-07,
                    2.2422e-07,
                    2.3007e-07,
                    2.358e-07,
                    2.4154e-07,
                    2.4731e-07,
                    2.5314e-07,
                    2.5899e-07,
                    2.6481e-07,
                    2.7058e-07,
                    2.7627e-07,
                    2.8185e-07,
                    2.8721e-07,
                    2.9228e-07,
                    2.9697e-07,
                    3.0119e-07,
                    3.0493e-07,
                    3.0821e-07,
                    3.1103e-07,
                    3.1338e-07,
                    3.1532e-07,
                    3.1691e-07,
                    3.1832e-07,
                    3.1965e-07,
                    3.2102e-07,
                    3.2257e-07,
                    3.2443e-07,
                    3.2688e-07,
                    3.2994e-07,
                    3.3373e-07,
                    3.3858e-07,
                    3.445e-07,
                    3.5169e-07,
                    3.6044e-07,
                    3.7099e-07,
                    3.8344e-07,
                    3.9784e-07,
                    4.1427e-07,
                    4.3293e-07,
                    4.5394e-07,
                    4.7725e-07,
                    5.0265e-07,
                    5.3605e-07,
                    5.7356e-07,
                    6.1806e-07,
                    6.6372e-07,
                    7.1146e-07,
                    7.6045e-07,
                    8.0997e-07,
                    8.5934e-07,
                    9.0883e-07,
                    9.589e-07,
                    9.9921e-07,
                    1.0366e-06,
                    1.1167e-06,
                    1.1648e-06,
                    1.2049e-06,
                    1.239e-06,
                    1.2689e-06,
                    1.2938e-06,
                    1.3163e-06,
                    1.3397e-06,
                    1.3611e-06,
                    1.3806e-06,
                    1.3975e-06,
                    1.4156e-06,
                    1.4309e-06,
                    1.4475e-06,
                    1.4959e-06,
                    1.5277e-06,
                    1.6014e-06,
                    1.6461e-06,
                    1.6852e-06,
                    1.7175e-06,
                    1.7892e-06,
                    1.8368e-06,
                    1.8875e-06,
                    1.9749e-06,
                    2.0325e-06,
                    2.0842e-06,
                    2.1256e-06,
                    2.1619e-06,
                    2.1979e-06,
                    2.2331e-06,
                    2.267e-06,
                    2.3078e-06,
                    2.3554e-06,
                    2.4007e-06,
                    2.4541e-06,
                    2.508e-06,
                    2.5722e-06,
                    2.6315e-06,
                    2.6815e-06,
                    2.7466e-06,
                    2.8143e-06,
                    2.8873e-06,
                    2.9724e-06,
                    3.0575e-06,
                    3.1417e-06,
                    3.2452e-06,
                    3.3429e-06,
                    3.4716e-06,
                    3.5671e-06,
                    3.6576e-06,
                    3.7558e-06,
                    3.8912e-06,
                    4.009e-06,
                    4.11e-06,
                    4.2124e-06,
                    4.3023e-06,
                    4.4025e-06,
                    4.4943e-06,
                    4.5944e-06,
                    4.6917e-06,
                    4.7884e-06
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.65e-09,
                    3.3e-09,
                    8.25e-09,
                    1.155e-08,
                    1.485e-08,
                    1.815e-08,
                    2.145e-08,
                    2.475e-08,
                    2.97e-08,
                    3.465e-08,
                    3.96e-08,
                    4.455e-08,
                    4.95e-08,
                    5.61e-08,
                    6.435e-08,
                    7.095e-08,
                    7.92e-08,
                    8.745e-08,
                    9.735e-08,
                    1.1055e-07,
                    1.2375e-07,
                    1.3695e-07,
                    1.5345e-07,
                    1.716e-07,
                    1.8645e-07,
                    2.013e-07,
                    2.1615e-07,
                    2.31e-07,
                    2.475e-07,
                    2.607e-07,
                    2.772e-07,
                    2.937e-07,
                    3.1185e-07,
                    3.333e-07,
                    3.63e-07,
                    3.927e-07,
                    4.224e-07,
                    4.5705e-07,
                    4.8675e-07,
                    5.214e-07,
                    5.577e-07,
                    5.9565e-07,
                    6.336e-07,
                    6.798e-07,
                    7.3425e-07,
                    7.92e-07,
                    8.514e-07,
                    9.108e-07,
                    9.834e-07,
                    1.0576e-06,
                    1.1237e-06,
                    1.2045e-06,
                    1.2886e-06,
                    1.3778e-06,
                    1.4768e-06,
                    1.5757e-06,
                    1.6731e-06,
                    1.7787e-06,
                    1.8777e-06,
                    2.0031e-06,
                    2.1021e-06,
                    2.1995e-06,
                    2.3034e-06,
                    2.4024e-06,
                    2.5162e-06,
                    2.6219e-06,
                    2.7308e-06,
                    2.8281e-06,
                    2.937e-06,
                    3.0393e-06,
                    3.1499e-06,
                    3.2564e-06,
                    3.3639e-06
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [
                    2.7995e-09,
                    5.5165e-09,
                    8.1895e-09,
                    1.0824e-08,
                    1.3403e-08,
                    1.6033e-08,
                    1.865e-08,
                    2.1192e-08,
                    2.3793e-08,
                    2.6422e-08,
                    2.9161e-08,
                    3.1861e-08,
                    3.4562e-08,
                    3.7224e-08,
                    4.0007e-08,
                    4.2713e-08,
                    4.5496e-08,
                    4.8279e-08,
                    5.1095e-08,
                    5.3983e-08,
                    5.6947e-08,
                    5.9812e-08,
                    6.2722e-08,
                    6.5714e-08,
                    6.8783e-08,
                    7.1896e-08,
                    7.5025e-08,
                    7.821e-08,
                    8.1461e-08,
                    8.4755e-08,
                    8.8121e-08,
                    9.1592e-08,
                    9.5145e-08,
                    9.8725e-08,
                    1.024e-07,
                    1.0618e-07,
                    1.1003e-07,
                    1.1397e-07,
                    1.18e-07,
                    1.2221e-07,
                    1.2651e-07,
                    1.3089e-07,
                    1.3541e-07,
                    1.4007e-07,
                    1.4484e-07,
                    1.4964e-07,
                    1.5455e-07,
                    1.5962e-07,
                    1.6477e-07,
                    1.7016e-07,
                    1.7565e-07,
                    1.8125e-07,
                    1.8697e-07,
                    1.9282e-07,
                    1.9881e-07,
                    2.0496e-07,
                    2.1122e-07,
                    2.1763e-07,
                    2.2422e-07,
                    2.3007e-07,
                    2.358e-07,
                    2.4154e-07,
                    2.4731e-07,
                    2.5314e-07,
                    2.5899e-07,
                    2.6481e-07,
                    2.7058e-07,
                    2.7627e-07,
                    2.8185e-07,
                    2.8721e-07,
                    2.9228e-07,
                    2.9697e-07,
                    3.0119e-07,
                    3.0493e-07,
                    3.0821e-07,
                    3.1103e-07,
                    3.1338e-07,
                    3.1532e-07,
                    3.1691e-07,
                    3.1832e-07,
                    3.1965e-07,
                    3.2102e-07,
                    3.2257e-07,
                    3.2443e-07,
                    3.2688e-07,
                    3.2994e-07,
                    3.3373e-07,
                    3.3858e-07,
                    3.445e-07,
                    3.5169e-07,
                    3.6044e-07,
                    3.7099e-07,
                    3.8344e-07,
                    3.9784e-07,
                    4.1427e-07,
                    4.3293e-07,
                    4.5394e-07,
                    4.7725e-07,
                    5.0265e-07,
                    5.344e-07,
                    5.7026e-07,
                    6.0981e-07,
                    6.5217e-07,
                    6.9661e-07,
                    7.423e-07,
                    7.8852e-07,
                    8.3459e-07,
                    8.7913e-07,
                    9.2425e-07,
                    9.5961e-07,
                    9.9207e-07,
                    1.0672e-06,
                    1.1087e-06,
                    1.1406e-06,
                    1.168e-06,
                    1.1897e-06,
                    1.2063e-06,
                    1.2189e-06,
                    1.2292e-06,
                    1.2374e-06,
                    1.2437e-06,
                    1.244e-06,
                    1.244e-06,
                    1.2444e-06,
                    1.2462e-06,
                    1.2797e-06,
                    1.2967e-06,
                    1.3539e-06,
                    1.3854e-06,
                    1.408e-06,
                    1.4238e-06,
                    1.4773e-06,
                    1.5035e-06,
                    1.5245e-06,
                    1.5822e-06,
                    1.6101e-06,
                    1.6271e-06,
                    1.6389e-06,
                    1.6405e-06,
                    1.6402e-06,
                    1.6374e-06,
                    1.6334e-06,
                    1.628e-06,
                    1.6212e-06,
                    1.6087e-06,
                    1.6027e-06,
                    1.5972e-06,
                    1.5888e-06,
                    1.5738e-06,
                    1.5578e-06,
                    1.5421e-06,
                    1.5257e-06,
                    1.5096e-06,
                    1.4956e-06,
                    1.4817e-06,
                    1.4686e-06,
                    1.4665e-06,
                    1.4652e-06,
                    1.4685e-06,
                    1.465e-06,
                    1.4581e-06,
                    1.4524e-06,
                    1.4888e-06,
                    1.4927e-06,
                    1.4881e-06,
                    1.4817e-06,
                    1.4742e-06,
                    1.4655e-06,
                    1.455e-06,
                    1.4446e-06,
                    1.4353e-06,
                    1.4245e-06
                ],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [
                    5.4422e-09,
                    1.047e-08,
                    1.5444e-08,
                    2.0366e-08,
                    2.5235e-08,
                    3.0569e-08,
                    3.6382e-08,
                    4.2688e-08,
                    4.9502e-08,
                    5.6839e-08,
                    6.4496e-08,
                    7.245e-08,
                    8.0731e-08,
                    8.9326e-08,
                    9.7925e-08,
                    1.0653e-07,
                    1.1515e-07,
                    1.2379e-07,
                    1.323e-07,
                    1.4069e-07,
                    1.4968e-07,
                    1.5912e-07,
                    1.6867e-07,
                    1.7833e-07,
                    1.8805e-07,
                    1.9735e-07,
                    2.0623e-07,
                    2.1462e-07,
                    2.2251e-07,
                    2.2989e-07,
                    2.3693e-07,
                    2.4415e-07,
                    2.5128e-07,
                    2.5806e-07,
                    2.6466e-07,
                    2.7108e-07,
                    2.7748e-07,
                    2.8378e-07,
                    2.9023e-07,
                    2.975e-07,
                    3.0472e-07,
                    3.1209e-07,
                    3.1967e-07,
                    3.2742e-07,
                    3.3535e-07,
                    3.4345e-07,
                    3.5172e-07,
                    3.6023e-07,
                    3.6902e-07,
                    3.7725e-07,
                    3.8581e-07,
                    3.9427e-07,
                    4.0278e-07,
                    4.1166e-07,
                    4.2102e-07,
                    4.3083e-07,
                    4.4094e-07,
                    4.5143e-07,
                    4.6216e-07,
                    4.725e-07,
                    4.8285e-07,
                    4.9301e-07,
                    5.0295e-07,
                    5.1247e-07,
                    5.2155e-07,
                    5.3024e-07,
                    5.3848e-07,
                    5.4629e-07,
                    5.5359e-07,
                    5.6119e-07,
                    5.6828e-07,
                    5.7527e-07,
                    5.8198e-07,
                    5.8826e-07,
                    5.9414e-07,
                    5.9993e-07,
                    6.055e-07,
                    6.1096e-07,
                    6.1628e-07,
                    6.2159e-07,
                    6.2723e-07,
                    6.3299e-07,
                    6.388e-07,
                    6.4476e-07,
                    6.5085e-07,
                    6.5724e-07,
                    6.6386e-07,
                    6.709e-07,
                    6.7857e-07,
                    6.8613e-07,
                    6.936e-07,
                    7.0074e-07,
                    7.0708e-07,
                    7.1309e-07,
                    7.1879e-07,
                    7.2443e-07,
                    7.3005e-07,
                    7.3543e-07,
                    7.4061e-07,
                    7.4532e-07,
                    7.5035e-07,
                    7.5587e-07,
                    7.6161e-07,
                    7.6768e-07,
                    7.7405e-07,
                    7.8049e-07,
                    7.8709e-07,
                    7.937e-07,
                    8.001e-07,
                    8.0693e-07,
                    8.1211e-07,
                    8.1804e-07,
                    8.2414e-07,
                    8.3071e-07,
                    8.3881e-07,
                    8.5081e-07,
                    8.6189e-07,
                    8.7222e-07,
                    8.831e-07,
                    8.9528e-07,
                    9.0903e-07,
                    9.2309e-07,
                    9.3854e-07,
                    9.5511e-07,
                    9.7292e-07,
                    9.9223e-07,
                    1.0129e-06,
                    1.0351e-06,
                    1.0588e-06,
                    1.0837e-06,
                    1.1123e-06,
                    1.1419e-06,
                    1.1742e-06,
                    1.2089e-06,
                    1.2414e-06,
                    1.2697e-06,
                    1.2966e-06,
                    1.3284e-06,
                    1.3594e-06,
                    1.3918e-06,
                    1.4215e-06,
                    1.4519e-06,
                    1.4814e-06,
                    1.5105e-06,
                    1.5396e-06,
                    1.5676e-06,
                    1.5952e-06,
                    1.6223e-06,
                    1.6482e-06,
                    1.6736e-06,
                    1.697e-06,
                    1.7199e-06,
                    1.74e-06,
                    1.7589e-06,
                    1.7799e-06,
                    1.8031e-06,
                    1.8299e-06,
                    1.8533e-06,
                    1.8783e-06,
                    1.9002e-06,
                    1.9271e-06,
                    1.9517e-06,
                    1.9738e-06,
                    1.9952e-06,
                    2.0153e-06,
                    2.0351e-06,
                    2.0538e-06,
                    2.0726e-06,
                    2.0908e-06,
                    2.1084e-06,
                    2.1272e-06,
                    2.1457e-06
                ],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [
                    3.5207e-09,
                    6.6203e-09,
                    9.6606e-09,
                    1.2642e-08,
                    1.5563e-08,
                    1.8944e-08,
                    2.2797e-08,
                    2.7137e-08,
                    3.1978e-08,
                    3.7336e-08,
                    4.3006e-08,
                    4.8964e-08,
                    5.524e-08,
                    6.1823e-08,
                    6.8401e-08,
                    7.4979e-08,
                    8.156e-08,
                    8.8146e-08,
                    9.4602e-08,
                    1.0093e-07,
                    1.0785e-07,
                    1.1521e-07,
                    1.2267e-07,
                    1.3023e-07,
                    1.3784e-07,
                    1.4503e-07,
                    1.5178e-07,
                    1.5804e-07,
                    1.6378e-07,
                    1.6901e-07,
                    1.7389e-07,
                    1.7894e-07,
                    1.839e-07,
                    1.885e-07,
                    1.9291e-07,
                    1.9714e-07,
                    2.0133e-07,
                    2.0543e-07,
                    2.0965e-07,
                    2.1469e-07,
                    2.1968e-07,
                    2.2481e-07,
                    2.3014e-07,
                    2.3564e-07,
                    2.413e-07,
                    2.4713e-07,
                    2.5312e-07,
                    2.5934e-07,
                    2.6583e-07,
                    2.7176e-07,
                    2.7802e-07,
                    2.8415e-07,
                    2.9034e-07,
                    2.9689e-07,
                    3.039e-07,
                    3.1136e-07,
                    3.1912e-07,
                    3.2724e-07,
                    3.356e-07,
                    3.4356e-07,
                    3.5157e-07,
                    3.5946e-07,
                    3.6718e-07,
                    3.7453e-07,
                    3.8151e-07,
                    3.8813e-07,
                    3.9438e-07,
                    4.0024e-07,
                    4.0565e-07,
                    4.114e-07,
                    4.1671e-07,
                    4.2197e-07,
                    4.2701e-07,
                    4.3167e-07,
                    4.36e-07,
                    4.4029e-07,
                    4.4441e-07,
                    4.4848e-07,
                    4.5246e-07,
                    4.565e-07,
                    4.6086e-07,
                    4.6534e-07,
                    4.6987e-07,
                    4.7455e-07,
                    4.7936e-07,
                    4.8432e-07,
                    4.8937e-07,
                    4.9469e-07,
                    5.005e-07,
                    5.0604e-07,
                    5.1136e-07,
                    5.1619e-07,
                    5.2008e-07,
                    5.2349e-07,
                    5.2645e-07,
                    5.2919e-07,
                    5.3177e-07,
                    5.3396e-07,
                    5.3581e-07,
                    5.3704e-07,
                    5.3809e-07,
                    5.3911e-07,
                    5.3976e-07,
                    5.4012e-07,
                    5.4012e-07,
                    5.3964e-07,
                    5.3878e-07,
                    5.3739e-07,
                    5.3525e-07,
                    5.3306e-07,
                    5.3073e-07,
                    5.2829e-07,
                    5.2661e-07,
                    5.2555e-07,
                    5.2586e-07,
                    5.2698e-07,
                    5.2908e-07,
                    5.3243e-07,
                    5.3717e-07,
                    5.4251e-07,
                    5.5049e-07,
                    5.5901e-07,
                    5.6898e-07,
                    5.8031e-07,
                    5.9301e-07,
                    6.0717e-07,
                    6.2291e-07,
                    6.4005e-07,
                    6.5896e-07,
                    6.792e-07,
                    7.012e-07,
                    7.2456e-07,
                    7.488e-07,
                    7.7409e-07,
                    7.9966e-07,
                    8.2551e-07,
                    8.5123e-07,
                    8.771e-07,
                    9.0286e-07,
                    9.3206e-07,
                    9.5965e-07,
                    9.8783e-07,
                    1.0153e-06,
                    1.0424e-06,
                    1.0697e-06,
                    1.0967e-06,
                    1.1236e-06,
                    1.1506e-06,
                    1.1768e-06,
                    1.2037e-06,
                    1.2298e-06,
                    1.2568e-06,
                    1.2843e-06,
                    1.3117e-06,
                    1.3391e-06,
                    1.3671e-06,
                    1.3955e-06,
                    1.4233e-06,
                    1.4507e-06,
                    1.4744e-06,
                    1.5016e-06,
                    1.5282e-06,
                    1.5555e-06,
                    1.5836e-06,
                    1.6111e-06,
                    1.6392e-06,
                    1.6669e-06,
                    1.6946e-06,
                    1.7222e-06,
                    1.7481e-06,
                    1.7746e-06,
                    1.8e-06
                ],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [
                    1.9215e-09,
                    3.8495e-09,
                    5.7838e-09,
                    7.7244e-09,
                    9.6715e-09,
                    1.1625e-08,
                    1.3585e-08,
                    1.5551e-08,
                    1.7524e-08,
                    1.9503e-08,
                    2.149e-08,
                    2.3486e-08,
                    2.549e-08,
                    2.7503e-08,
                    2.9524e-08,
                    3.1554e-08,
                    3.3592e-08,
                    3.5639e-08,
                    3.7694e-08,
                    3.9758e-08,
                    4.183e-08,
                    4.3911e-08,
                    4.6001e-08,
                    4.81e-08,
                    5.0208e-08,
                    5.2324e-08,
                    5.445e-08,
                    5.6584e-08,
                    5.8727e-08,
                    6.0878e-08,
                    6.3037e-08,
                    6.5204e-08,
                    6.7378e-08,
                    6.9559e-08,
                    7.1748e-08,
                    7.3944e-08,
                    7.6148e-08,
                    7.8359e-08,
                    8.0577e-08,
                    8.2803e-08,
                    8.5037e-08,
                    8.7278e-08,
                    8.9527e-08,
                    9.1783e-08,
                    9.4047e-08,
                    9.6319e-08,
                    9.8599e-08,
                    1.0089e-07,
                    1.0318e-07,
                    1.0548e-07,
                    1.0779e-07,
                    1.1011e-07,
                    1.1244e-07,
                    1.1477e-07,
                    1.1712e-07,
                    1.1947e-07,
                    1.2182e-07,
                    1.2419e-07,
                    1.2656e-07,
                    1.2895e-07,
                    1.3127e-07,
                    1.3355e-07,
                    1.3577e-07,
                    1.3793e-07,
                    1.4004e-07,
                    1.421e-07,
                    1.441e-07,
                    1.4605e-07,
                    1.4795e-07,
                    1.4979e-07,
                    1.5157e-07,
                    1.533e-07,
                    1.5497e-07,
                    1.5658e-07,
                    1.5814e-07,
                    1.5965e-07,
                    1.6109e-07,
                    1.6248e-07,
                    1.6382e-07,
                    1.651e-07,
                    1.6637e-07,
                    1.6765e-07,
                    1.6893e-07,
                    1.7021e-07,
                    1.7149e-07,
                    1.7292e-07,
                    1.7449e-07,
                    1.7621e-07,
                    1.7807e-07,
                    1.8008e-07,
                    1.8224e-07,
                    1.8455e-07,
                    1.87e-07,
                    1.896e-07,
                    1.9235e-07,
                    1.9524e-07,
                    1.9828e-07,
                    2.0147e-07,
                    2.048e-07,
                    2.0828e-07,
                    2.1225e-07,
                    2.1676e-07,
                    2.2185e-07,
                    2.2757e-07,
                    2.3394e-07,
                    2.4085e-07,
                    2.4831e-07,
                    2.5631e-07,
                    2.6484e-07,
                    2.7386e-07,
                    2.8138e-07,
                    2.8975e-07,
                    2.9753e-07,
                    3.0516e-07,
                    3.1295e-07,
                    3.2382e-07,
                    3.3281e-07,
                    3.3979e-07,
                    3.4593e-07,
                    3.5276e-07,
                    3.5854e-07,
                    3.6408e-07,
                    3.6956e-07,
                    3.748e-07,
                    3.7991e-07,
                    3.8506e-07,
                    3.9003e-07,
                    3.9502e-07,
                    3.9981e-07,
                    4.0447e-07,
                    4.1106e-07,
                    4.1732e-07,
                    4.2543e-07,
                    4.348e-07,
                    4.4178e-07,
                    4.4416e-07,
                    4.4534e-07,
                    4.5127e-07,
                    4.5654e-07,
                    4.5977e-07,
                    4.6185e-07,
                    4.6403e-07,
                    4.6615e-07,
                    4.6813e-07,
                    4.6984e-07,
                    4.7092e-07,
                    4.7159e-07,
                    4.7171e-07,
                    4.7138e-07,
                    4.6992e-07,
                    4.6723e-07,
                    4.6304e-07,
                    4.5572e-07,
                    4.4723e-07,
                    4.408e-07,
                    4.3599e-07,
                    4.3441e-07,
                    4.3007e-07,
                    4.2755e-07,
                    4.2579e-07,
                    4.2555e-07,
                    4.2354e-07,
                    4.1829e-07,
                    4.116e-07,
                    4.0416e-07,
                    3.959e-07,
                    3.8687e-07,
                    3.78e-07,
                    3.6862e-07,
                    3.603e-07,
                    3.5259e-07,
                    3.4577e-07
                ],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [
                    2.2826e-10,
                    4.5946e-10,
                    6.9354e-10,
                    9.3043e-10,
                    1.17e-09,
                    1.4122e-09,
                    1.6568e-09,
                    1.9036e-09,
                    2.1525e-09,
                    2.4033e-09,
                    2.6558e-09,
                    2.91e-09,
                    3.1658e-09,
                    3.4233e-09,
                    3.6825e-09,
                    3.9432e-09,
                    4.2057e-09,
                    4.4697e-09,
                    4.7355e-09,
                    5.003e-09,
                    5.2734e-09,
                    5.5486e-09,
                    5.8302e-09,
                    6.1191e-09,
                    6.416e-09,
                    6.721e-09,
                    7.0338e-09,
                    7.3537e-09,
                    7.6794e-09,
                    8.0092e-09,
                    8.3421e-09,
                    8.6779e-09,
                    9.0162e-09,
                    9.3571e-09,
                    9.7003e-09,
                    1.0046e-08,
                    1.0394e-08,
                    1.0744e-08,
                    1.1097e-08,
                    1.1486e-08,
                    1.188e-08,
                    1.2279e-08,
                    1.2686e-08,
                    1.3101e-08,
                    1.3525e-08,
                    1.396e-08,
                    1.4406e-08,
                    1.4865e-08,
                    1.5336e-08,
                    1.582e-08,
                    1.6321e-08,
                    1.6846e-08,
                    1.74e-08,
                    1.7985e-08,
                    1.8603e-08,
                    1.9254e-08,
                    1.9936e-08,
                    2.0644e-08,
                    2.1373e-08,
                    2.2115e-08,
                    2.2867e-08,
                    2.3628e-08,
                    2.4398e-08,
                    2.5175e-08,
                    2.5961e-08,
                    2.6753e-08,
                    2.7552e-08,
                    2.8357e-08,
                    2.9167e-08,
                    2.9983e-08,
                    3.0802e-08,
                    3.1622e-08,
                    3.2442e-08,
                    3.326e-08,
                    3.4077e-08,
                    3.4892e-08,
                    3.5706e-08,
                    3.652e-08,
                    3.7335e-08,
                    3.8153e-08,
                    3.8977e-08,
                    3.9812e-08,
                    4.0661e-08,
                    4.1525e-08,
                    4.2408e-08,
                    4.3311e-08,
                    4.4234e-08,
                    4.5179e-08,
                    4.6145e-08,
                    4.7132e-08,
                    4.8158e-08,
                    4.9258e-08,
                    5.046e-08,
                    5.1783e-08,
                    5.3237e-08,
                    5.4826e-08,
                    5.6545e-08,
                    5.8383e-08,
                    6.0319e-08,
                    6.2325e-08,
                    6.44e-08,
                    6.6571e-08,
                    6.8858e-08,
                    7.1275e-08,
                    7.3832e-08,
                    7.6529e-08,
                    7.9365e-08,
                    8.2327e-08,
                    8.5402e-08,
                    8.8567e-08,
                    9.2696e-08,
                    9.698e-08,
                    1.0132e-07,
                    1.0575e-07,
                    1.1024e-07,
                    1.1496e-07,
                    1.2007e-07,
                    1.2558e-07,
                    1.3181e-07,
                    1.3888e-07,
                    1.4594e-07,
                    1.53e-07,
                    1.6069e-07,
                    1.6868e-07,
                    1.7755e-07,
                    1.8643e-07,
                    1.9623e-07,
                    2.0607e-07,
                    2.1599e-07,
                    2.2597e-07,
                    2.3601e-07,
                    2.4618e-07,
                    2.5645e-07,
                    2.6715e-07,
                    2.778e-07,
                    2.8863e-07,
                    2.9939e-07,
                    3.105e-07,
                    3.1875e-07,
                    3.2437e-07,
                    3.2984e-07,
                    3.3548e-07,
                    3.4221e-07,
                    3.4938e-07,
                    3.5679e-07,
                    3.6412e-07,
                    3.7156e-07,
                    3.8003e-07,
                    3.8839e-07,
                    3.9644e-07,
                    4.0465e-07,
                    4.0977e-07,
                    4.1484e-07,
                    4.2015e-07,
                    4.2548e-07,
                    4.3087e-07,
                    4.3638e-07,
                    4.42e-07,
                    4.4847e-07,
                    4.5454e-07,
                    4.604e-07,
                    4.665e-07,
                    4.7206e-07,
                    4.7773e-07,
                    4.8344e-07,
                    4.8899e-07,
                    4.9367e-07,
                    4.9834e-07,
                    5.036e-07,
                    5.0882e-07,
                    5.1436e-07,
                    5.1994e-07
                ],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [
                    1.9539e-10,
                    3.9307e-10,
                    5.93e-10,
                    7.9514e-10,
                    9.9945e-10,
                    1.2058e-09,
                    1.4143e-09,
                    1.6246e-09,
                    1.8368e-09,
                    2.0507e-09,
                    2.2663e-09,
                    2.4835e-09,
                    2.7024e-09,
                    2.9228e-09,
                    3.1449e-09,
                    3.3686e-09,
                    3.594e-09,
                    3.8209e-09,
                    4.0495e-09,
                    4.2798e-09,
                    4.5123e-09,
                    4.748e-09,
                    4.9878e-09,
                    5.2322e-09,
                    5.4814e-09,
                    5.7355e-09,
                    5.9944e-09,
                    6.2577e-09,
                    6.5248e-09,
                    6.7947e-09,
                    7.0671e-09,
                    7.3416e-09,
                    7.6182e-09,
                    7.8969e-09,
                    8.1776e-09,
                    8.4603e-09,
                    8.745e-09,
                    9.0316e-09,
                    9.3203e-09,
                    9.6133e-09,
                    9.9089e-09,
                    1.0207e-08,
                    1.0508e-08,
                    1.0812e-08,
                    1.1119e-08,
                    1.1429e-08,
                    1.1743e-08,
                    1.2059e-08,
                    1.2378e-08,
                    1.2701e-08,
                    1.3028e-08,
                    1.3358e-08,
                    1.3693e-08,
                    1.4031e-08,
                    1.4374e-08,
                    1.4722e-08,
                    1.5073e-08,
                    1.543e-08,
                    1.579e-08,
                    1.6155e-08,
                    1.6523e-08,
                    1.6896e-08,
                    1.7273e-08,
                    1.7653e-08,
                    1.8038e-08,
                    1.8426e-08,
                    1.8818e-08,
                    1.9214e-08,
                    1.9615e-08,
                    2.0019e-08,
                    2.0427e-08,
                    2.0839e-08,
                    2.1255e-08,
                    2.1675e-08,
                    2.2099e-08,
                    2.2527e-08,
                    2.2959e-08,
                    2.3395e-08,
                    2.3835e-08,
                    2.4279e-08,
                    2.4727e-08,
                    2.5179e-08,
                    2.5635e-08,
                    2.6094e-08,
                    2.6558e-08,
                    2.7026e-08,
                    2.7498e-08,
                    2.7975e-08,
                    2.8456e-08,
                    2.8943e-08,
                    2.9437e-08,
                    2.9942e-08,
                    3.0461e-08,
                    3.0994e-08,
                    3.1545e-08,
                    3.2113e-08,
                    3.2698e-08,
                    3.33e-08,
                    3.3918e-08,
                    3.4549e-08,
                    3.5194e-08,
                    3.5853e-08,
                    3.6528e-08,
                    3.722e-08,
                    3.7929e-08,
                    3.8657e-08,
                    3.9404e-08,
                    4.017e-08,
                    4.0955e-08,
                    4.1759e-08,
                    4.2581e-08,
                    4.3422e-08,
                    4.4282e-08,
                    4.5163e-08,
                    4.6064e-08,
                    4.6989e-08,
                    4.794e-08,
                    4.8919e-08,
                    4.9928e-08,
                    5.0984e-08,
                    5.2031e-08,
                    5.3019e-08,
                    5.4037e-08,
                    5.5022e-08,
                    5.6034e-08,
                    5.6974e-08,
                    5.7985e-08,
                    5.8969e-08,
                    6.0004e-08,
                    6.1041e-08,
                    6.2062e-08,
                    6.3095e-08,
                    6.4042e-08,
                    6.5034e-08,
                    6.6022e-08,
                    6.6999e-08,
                    6.7978e-08,
                    6.9005e-08,
                    7.0183e-08,
                    7.1425e-08,
                    7.2719e-08,
                    7.4175e-08,
                    7.5418e-08,
                    7.7092e-08,
                    7.8959e-08,
                    8.0738e-08,
                    8.264e-08,
                    8.4757e-08,
                    8.6798e-08,
                    8.8578e-08,
                    9.0546e-08,
                    9.2571e-08,
                    9.4825e-08,
                    9.728e-08,
                    9.9757e-08,
                    1.0222e-07,
                    1.047e-07,
                    1.0723e-07,
                    1.1061e-07,
                    1.1352e-07,
                    1.1635e-07,
                    1.1958e-07,
                    1.2243e-07,
                    1.2539e-07,
                    1.2837e-07,
                    1.3131e-07,
                    1.3339e-07,
                    1.3545e-07,
                    1.3814e-07,
                    1.4078e-07,
                    1.4358e-07,
                    1.4644e-07
                ],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": [
                    3.2866e-11,
                    6.639e-11,
                    1.0054e-10,
                    1.3529e-10,
                    1.7057e-10,
                    2.0633e-10,
                    2.425e-10,
                    2.79e-10,
                    3.1572e-10,
                    3.5258e-10,
                    3.895e-10,
                    4.2646e-10,
                    4.6346e-10,
                    5.0049e-10,
                    5.3753e-10,
                    5.746e-10,
                    6.117e-10,
                    6.4883e-10,
                    6.8602e-10,
                    7.2327e-10,
                    7.6115e-10,
                    8.006e-10,
                    8.4236e-10,
                    8.8695e-10,
                    9.3464e-10,
                    9.8552e-10,
                    1.0394e-09,
                    1.096e-09,
                    1.1546e-09,
                    1.2145e-09,
                    1.2751e-09,
                    1.3363e-09,
                    1.398e-09,
                    1.4601e-09,
                    1.5226e-09,
                    1.5855e-09,
                    1.6487e-09,
                    1.7124e-09,
                    1.7765e-09,
                    1.8731e-09,
                    1.9711e-09,
                    2.0721e-09,
                    2.1773e-09,
                    2.2881e-09,
                    2.4055e-09,
                    2.5304e-09,
                    2.6637e-09,
                    2.8058e-09,
                    2.9574e-09,
                    3.1187e-09,
                    3.2935e-09,
                    3.4881e-09,
                    3.7072e-09,
                    3.9538e-09,
                    4.229e-09,
                    4.5325e-09,
                    4.8621e-09,
                    5.2139e-09,
                    5.5825e-09,
                    5.9606e-09,
                    6.344e-09,
                    6.7323e-09,
                    7.1251e-09,
                    7.5221e-09,
                    7.9229e-09,
                    8.3269e-09,
                    8.7336e-09,
                    9.1425e-09,
                    9.5529e-09,
                    9.9642e-09,
                    1.0375e-08,
                    1.0783e-08,
                    1.1187e-08,
                    1.1586e-08,
                    1.1978e-08,
                    1.2366e-08,
                    1.2748e-08,
                    1.3125e-08,
                    1.35e-08,
                    1.3874e-08,
                    1.425e-08,
                    1.4633e-08,
                    1.5026e-08,
                    1.5431e-08,
                    1.585e-08,
                    1.6285e-08,
                    1.6736e-08,
                    1.7205e-08,
                    1.7689e-08,
                    1.8189e-08,
                    1.8721e-08,
                    1.9316e-08,
                    2e-08,
                    2.0789e-08,
                    2.1692e-08,
                    2.2713e-08,
                    2.3847e-08,
                    2.5083e-08,
                    2.6401e-08,
                    2.7776e-08,
                    2.9207e-08,
                    3.0718e-08,
                    3.233e-08,
                    3.4056e-08,
                    3.5902e-08,
                    3.7872e-08,
                    3.996e-08,
                    4.2157e-08,
                    4.4447e-08,
                    4.6808e-08,
                    5.0115e-08,
                    5.3557e-08,
                    5.7036e-08,
                    6.0589e-08,
                    6.4179e-08,
                    6.7966e-08,
                    7.2133e-08,
                    7.6658e-08,
                    8.1882e-08,
                    8.7894e-08,
                    9.3906e-08,
                    9.9979e-08,
                    1.0665e-07,
                    1.1366e-07,
                    1.2152e-07,
                    1.2946e-07,
                    1.3825e-07,
                    1.471e-07,
                    1.5599e-07,
                    1.6493e-07,
                    1.7395e-07,
                    1.8309e-07,
                    1.924e-07,
                    2.0212e-07,
                    2.1178e-07,
                    2.2163e-07,
                    2.3141e-07,
                    2.4149e-07,
                    2.4856e-07,
                    2.5294e-07,
                    2.5712e-07,
                    2.613e-07,
                    2.668e-07,
                    2.7229e-07,
                    2.7784e-07,
                    2.8338e-07,
                    2.8892e-07,
                    2.9527e-07,
                    3.0159e-07,
                    3.0786e-07,
                    3.141e-07,
                    3.172e-07,
                    3.2002e-07,
                    3.2287e-07,
                    3.2572e-07,
                    3.2866e-07,
                    3.3168e-07,
                    3.3477e-07,
                    3.3787e-07,
                    3.4101e-07,
                    3.4405e-07,
                    3.4692e-07,
                    3.4963e-07,
                    3.5235e-07,
                    3.5507e-07,
                    3.5768e-07,
                    3.6028e-07,
                    3.629e-07,
                    3.6545e-07,
                    3.6804e-07,
                    3.7078e-07,
                    3.7351e-07
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -61.27934,
                            13.20702
                        ],
                        [
                            -61.24597,
                            13.15557
                        ],
                        [
                            -61.16808,
                            13.12364
                        ],
                        [
                            -61.11487,
                            13.24013
                        ],
                        [
                            -61.11852,
                            13.32989
                        ],
                        [
                            -61.14192,
                            13.3788
                        ],
                        [
                            -61.20154,
                            13.37143
                        ],
                        [
                            -61.27299,
                            13.25517
                        ],
                        [
                            -61.27934,
                            13.20702
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "WSM",
                "Country": "Samoa",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    3.9564e-08,
                    7.9315e-08,
                    1.1936e-07,
                    1.5977e-07,
                    2.005e-07,
                    2.4159e-07,
                    2.8305e-07,
                    3.2485e-07,
                    3.6699e-07,
                    4.1023e-07,
                    4.5475e-07,
                    5.0029e-07,
                    5.4675e-07,
                    5.9405e-07,
                    6.4218e-07,
                    6.9111e-07,
                    7.4085e-07,
                    7.9136e-07,
                    8.4265e-07,
                    8.9509e-07,
                    9.487e-07,
                    1.0033e-06,
                    1.0589e-06,
                    1.1155e-06,
                    1.1731e-06,
                    1.2317e-06,
                    1.2912e-06,
                    1.3517e-06,
                    1.4131e-06,
                    1.4757e-06,
                    1.539e-06,
                    1.6034e-06,
                    1.6687e-06,
                    1.7349e-06,
                    1.8021e-06,
                    1.8702e-06,
                    1.9392e-06,
                    2.0092e-06,
                    2.0802e-06,
                    2.1525e-06,
                    2.2257e-06,
                    2.2996e-06,
                    2.3743e-06,
                    2.4497e-06,
                    2.5258e-06,
                    2.6028e-06,
                    2.6805e-06,
                    2.759e-06,
                    2.8384e-06,
                    2.9149e-06,
                    2.987e-06,
                    3.0554e-06,
                    3.1211e-06,
                    3.1838e-06,
                    3.2434e-06,
                    3.3008e-06,
                    3.3561e-06,
                    3.4093e-06,
                    3.4596e-06,
                    3.5148e-06,
                    3.5773e-06,
                    3.6448e-06,
                    3.7172e-06,
                    3.7932e-06,
                    3.8724e-06,
                    3.9553e-06,
                    4.0412e-06,
                    4.1299e-06,
                    4.2216e-06,
                    4.3192e-06,
                    4.4237e-06,
                    4.5343e-06,
                    4.6494e-06,
                    4.7704e-06,
                    4.8955e-06,
                    5.0258e-06,
                    5.1614e-06,
                    5.3014e-06,
                    5.445e-06,
                    5.5959e-06,
                    5.7536e-06,
                    5.9161e-06,
                    6.0831e-06,
                    6.2536e-06,
                    6.4285e-06,
                    6.6059e-06,
                    6.7867e-06,
                    6.9717e-06,
                    7.1588e-06,
                    7.3529e-06,
                    7.5554e-06,
                    7.7648e-06,
                    7.979e-06,
                    8.1993e-06,
                    8.4251e-06,
                    8.6555e-06,
                    8.8905e-06,
                    9.1291e-06,
                    9.3709e-06,
                    9.6192e-06,
                    9.8689e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    1.3891e-09,
                    2.832e-09,
                    4.3306e-09,
                    5.8866e-09,
                    7.5021e-09,
                    9.179e-09,
                    1.0919e-08,
                    1.2725e-08,
                    1.4598e-08,
                    1.6542e-08,
                    1.8603e-08,
                    2.0784e-08,
                    2.309e-08,
                    2.5521e-08,
                    2.8081e-08,
                    3.0773e-08,
                    3.36e-08,
                    3.6566e-08,
                    3.9674e-08,
                    4.2926e-08,
                    4.6296e-08,
                    4.9786e-08,
                    5.34e-08,
                    5.7139e-08,
                    6.1006e-08,
                    6.5005e-08,
                    6.9137e-08,
                    7.3404e-08,
                    7.7808e-08,
                    8.2349e-08,
                    8.682e-08,
                    9.1445e-08,
                    9.623e-08,
                    1.0118e-07,
                    1.0631e-07,
                    1.1162e-07,
                    1.1712e-07,
                    1.2282e-07,
                    1.2873e-07,
                    1.3486e-07,
                    1.4098e-07,
                    1.4709e-07,
                    1.5319e-07,
                    1.5927e-07,
                    1.6533e-07,
                    1.714e-07,
                    1.7746e-07,
                    1.8352e-07,
                    1.8958e-07,
                    1.9562e-07,
                    2.0112e-07,
                    2.0601e-07,
                    2.1027e-07,
                    2.1388e-07,
                    2.1684e-07,
                    2.1911e-07,
                    2.207e-07,
                    2.2157e-07,
                    2.2171e-07,
                    2.211e-07,
                    2.2077e-07,
                    2.207e-07,
                    2.2091e-07,
                    2.2138e-07,
                    2.2211e-07,
                    2.2309e-07,
                    2.243e-07,
                    2.2575e-07,
                    2.2744e-07,
                    2.2937e-07,
                    2.3234e-07,
                    2.3615e-07,
                    2.4083e-07,
                    2.4639e-07,
                    2.5284e-07,
                    2.6007e-07,
                    2.6819e-07,
                    2.7721e-07,
                    2.8701e-07,
                    2.9772e-07,
                    3.0893e-07,
                    3.2044e-07,
                    3.3228e-07,
                    3.4447e-07,
                    3.5698e-07,
                    3.6983e-07,
                    3.8302e-07,
                    3.9653e-07,
                    4.1037e-07,
                    4.2454e-07,
                    4.393e-07,
                    4.5473e-07,
                    4.708e-07,
                    4.8752e-07,
                    5.0458e-07,
                    5.2224e-07,
                    5.3989e-07,
                    5.5755e-07,
                    5.7537e-07,
                    5.9513e-07,
                    6.1531e-07,
                    6.3778e-07,
                    6.6079e-07,
                    6.8604e-07,
                    7.1184e-07,
                    7.3825e-07,
                    7.671e-07,
                    7.9509e-07,
                    8.2572e-07,
                    8.5741e-07,
                    8.9156e-07,
                    9.2662e-07,
                    9.6436e-07,
                    1.0048e-06,
                    1.0482e-06,
                    1.0911e-06,
                    1.1356e-06,
                    1.1833e-06,
                    1.2323e-06,
                    1.2797e-06,
                    1.3311e-06,
                    1.3822e-06,
                    1.4331e-06,
                    1.4871e-06,
                    1.5471e-06,
                    1.5999e-06,
                    1.666e-06,
                    1.7427e-06,
                    1.8119e-06,
                    1.8767e-06,
                    1.9404e-06,
                    1.9982e-06,
                    2.0545e-06,
                    2.1097e-06,
                    2.1682e-06,
                    2.2265e-06,
                    2.2834e-06,
                    2.3404e-06,
                    2.3964e-06,
                    2.4555e-06,
                    2.5168e-06,
                    2.5794e-06,
                    2.6438e-06,
                    2.7049e-06,
                    2.7794e-06,
                    2.8606e-06,
                    2.9416e-06,
                    3.0304e-06,
                    3.1161e-06,
                    3.2058e-06,
                    3.3008e-06,
                    3.3991e-06,
                    3.4961e-06,
                    3.5957e-06,
                    3.6973e-06,
                    3.801e-06,
                    3.9079e-06,
                    4.007e-06,
                    4.109e-06,
                    4.2179e-06,
                    4.33e-06,
                    4.4402e-06,
                    4.5552e-06,
                    4.6734e-06,
                    4.7994e-06,
                    4.929e-06,
                    5.0623e-06,
                    5.1922e-06,
                    5.3376e-06,
                    5.4687e-06,
                    5.6047e-06,
                    5.739e-06
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [
                    3.8174e-08,
                    7.6483e-08,
                    1.1503e-07,
                    1.5388e-07,
                    1.93e-07,
                    2.3242e-07,
                    2.7213e-07,
                    3.1212e-07,
                    3.5239e-07,
                    3.9369e-07,
                    4.3614e-07,
                    4.7951e-07,
                    5.2366e-07,
                    5.6853e-07,
                    6.141e-07,
                    6.6034e-07,
                    7.0725e-07,
                    7.548e-07,
                    8.0297e-07,
                    8.5216e-07,
                    9.024e-07,
                    9.5353e-07,
                    1.0055e-06,
                    1.0584e-06,
                    1.1121e-06,
                    1.1667e-06,
                    1.2221e-06,
                    1.2783e-06,
                    1.3353e-06,
                    1.3933e-06,
                    1.4522e-06,
                    1.5119e-06,
                    1.5725e-06,
                    1.6338e-06,
                    1.6958e-06,
                    1.7586e-06,
                    1.8221e-06,
                    1.8864e-06,
                    1.9514e-06,
                    2.0177e-06,
                    2.0847e-06,
                    2.1525e-06,
                    2.2211e-06,
                    2.2904e-06,
                    2.3605e-06,
                    2.4314e-06,
                    2.503e-06,
                    2.5755e-06,
                    2.6488e-06,
                    2.7193e-06,
                    2.7859e-06,
                    2.8494e-06,
                    2.9108e-06,
                    2.9699e-06,
                    3.0266e-06,
                    3.0817e-06,
                    3.1354e-06,
                    3.1877e-06,
                    3.2379e-06,
                    3.2937e-06,
                    3.3565e-06,
                    3.4241e-06,
                    3.4962e-06,
                    3.5718e-06,
                    3.6502e-06,
                    3.7323e-06,
                    3.8169e-06,
                    3.9041e-06,
                    3.9942e-06,
                    4.0898e-06,
                    4.1913e-06,
                    4.2981e-06,
                    4.4086e-06,
                    4.524e-06,
                    4.6427e-06,
                    4.7657e-06,
                    4.8932e-06,
                    5.0242e-06,
                    5.158e-06,
                    5.2982e-06,
                    5.4447e-06,
                    5.5957e-06,
                    5.7508e-06,
                    5.9092e-06,
                    6.0715e-06,
                    6.2361e-06,
                    6.4036e-06,
                    6.5752e-06,
                    6.7484e-06,
                    6.9284e-06,
                    7.1161e-06,
                    7.31e-06,
                    7.5082e-06,
                    7.7117e-06,
                    7.9205e-06,
                    8.1333e-06,
                    8.3506e-06,
                    8.5715e-06,
                    8.7955e-06,
                    9.0241e-06,
                    9.2535e-06,
                    9.4866e-06,
                    9.7223e-06,
                    9.9634e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    3.4749e-08,
                    6.9597e-08,
                    1.0465e-07,
                    1.3998e-07,
                    1.7553e-07,
                    2.1136e-07,
                    2.4747e-07,
                    2.8382e-07,
                    3.2043e-07,
                    3.5806e-07,
                    3.9671e-07,
                    4.3616e-07,
                    4.7627e-07,
                    5.1698e-07,
                    5.5826e-07,
                    6.001e-07,
                    6.4248e-07,
                    6.8538e-07,
                    7.2879e-07,
                    7.7309e-07,
                    8.1827e-07,
                    8.6415e-07,
                    9.1069e-07,
                    9.5786e-07,
                    1.0056e-06,
                    1.054e-06,
                    1.103e-06,
                    1.1525e-06,
                    1.2027e-06,
                    1.2536e-06,
                    1.3054e-06,
                    1.3579e-06,
                    1.4111e-06,
                    1.465e-06,
                    1.5195e-06,
                    1.5748e-06,
                    1.6307e-06,
                    1.6873e-06,
                    1.7446e-06,
                    1.8028e-06,
                    1.8618e-06,
                    1.9216e-06,
                    1.9821e-06,
                    2.0435e-06,
                    2.1055e-06,
                    2.1683e-06,
                    2.2319e-06,
                    2.2962e-06,
                    2.3613e-06,
                    2.4236e-06,
                    2.4828e-06,
                    2.5397e-06,
                    2.5953e-06,
                    2.6495e-06,
                    2.7019e-06,
                    2.7536e-06,
                    2.8046e-06,
                    2.8551e-06,
                    2.9042e-06,
                    2.9598e-06,
                    3.0219e-06,
                    3.0884e-06,
                    3.1591e-06,
                    3.2328e-06,
                    3.3089e-06,
                    3.3882e-06,
                    3.4697e-06,
                    3.5534e-06,
                    3.6396e-06,
                    3.7309e-06,
                    3.8265e-06,
                    3.9259e-06,
                    4.0274e-06,
                    4.1323e-06,
                    4.2389e-06,
                    4.3483e-06,
                    4.4606e-06,
                    4.5748e-06,
                    4.6904e-06,
                    4.8108e-06,
                    4.9368e-06,
                    5.0666e-06,
                    5.1999e-06,
                    5.3357e-06,
                    5.4748e-06,
                    5.6155e-06,
                    5.7585e-06,
                    5.9047e-06,
                    6.052e-06,
                    6.2053e-06,
                    6.3652e-06,
                    6.5302e-06,
                    6.6982e-06,
                    6.8703e-06,
                    7.0464e-06,
                    7.2251e-06,
                    7.407e-06,
                    7.5913e-06,
                    7.7775e-06,
                    7.9686e-06,
                    8.1599e-06,
                    8.3557e-06,
                    8.5533e-06,
                    8.7569e-06,
                    8.9633e-06,
                    9.1724e-06,
                    9.3878e-06,
                    9.6076e-06,
                    9.8352e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.65e-09,
                    3.3e-09,
                    6.6e-09,
                    9.9e-09,
                    1.485e-08,
                    1.98e-08,
                    2.475e-08,
                    3.135e-08,
                    3.63e-08,
                    4.29e-08,
                    4.95e-08,
                    5.775e-08,
                    6.6e-08,
                    7.59e-08,
                    8.745e-08,
                    1.0065e-07,
                    1.122e-07,
                    1.2375e-07,
                    1.3695e-07,
                    1.5015e-07,
                    1.6335e-07,
                    1.7985e-07,
                    1.9635e-07,
                    2.1285e-07,
                    2.3265e-07,
                    2.5905e-07,
                    2.7885e-07,
                    3.1185e-07,
                    3.564e-07,
                    3.9435e-07,
                    4.29e-07,
                    4.6365e-07,
                    4.9335e-07,
                    5.2305e-07,
                    5.5275e-07,
                    5.874e-07,
                    6.237e-07,
                    6.6e-07,
                    6.9795e-07,
                    7.359e-07,
                    7.755e-07,
                    8.184e-07,
                    8.6295e-07,
                    9.0915e-07,
                    9.5205e-07,
                    1.0032e-06,
                    1.0593e-06,
                    1.1154e-06,
                    1.1798e-06,
                    1.2408e-06,
                    1.3051e-06,
                    1.3745e-06,
                    1.447e-06,
                    1.518e-06,
                    1.5923e-06,
                    1.6682e-06,
                    1.7457e-06,
                    1.8265e-06,
                    1.8992e-06,
                    1.975e-06,
                    2.0575e-06,
                    2.1433e-06,
                    2.2275e-06,
                    2.315e-06,
                    2.4057e-06,
                    2.508e-06,
                    2.6153e-06,
                    2.7258e-06,
                    2.833e-06,
                    2.9551e-06,
                    3.064e-06,
                    3.1777e-06,
                    3.29e-06
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [
                    3.4749e-08,
                    6.9597e-08,
                    1.0465e-07,
                    1.3998e-07,
                    1.7553e-07,
                    2.1136e-07,
                    2.4747e-07,
                    2.8382e-07,
                    3.2043e-07,
                    3.5806e-07,
                    3.9671e-07,
                    4.3616e-07,
                    4.7627e-07,
                    5.1698e-07,
                    5.5826e-07,
                    6.001e-07,
                    6.4248e-07,
                    6.8538e-07,
                    7.2879e-07,
                    7.7309e-07,
                    8.1827e-07,
                    8.6415e-07,
                    9.1069e-07,
                    9.5786e-07,
                    1.0056e-06,
                    1.054e-06,
                    1.103e-06,
                    1.1525e-06,
                    1.2027e-06,
                    1.2536e-06,
                    1.3054e-06,
                    1.3579e-06,
                    1.4111e-06,
                    1.465e-06,
                    1.5195e-06,
                    1.5748e-06,
                    1.6307e-06,
                    1.6873e-06,
                    1.7446e-06,
                    1.8028e-06,
                    1.8618e-06,
                    1.9216e-06,
                    1.9821e-06,
                    2.0435e-06,
                    2.1055e-06,
                    2.1683e-06,
                    2.2319e-06,
                    2.2962e-06,
                    2.3613e-06,
                    2.4236e-06,
                    2.4828e-06,
                    2.5397e-06,
                    2.5953e-06,
                    2.6495e-06,
                    2.7019e-06,
                    2.7536e-06,
                    2.8046e-06,
                    2.8551e-06,
                    2.9042e-06,
                    2.9598e-06,
                    3.0219e-06,
                    3.0884e-06,
                    3.1591e-06,
                    3.2328e-06,
                    3.3089e-06,
                    3.3882e-06,
                    3.4697e-06,
                    3.5534e-06,
                    3.6396e-06,
                    3.7309e-06,
                    3.8265e-06,
                    3.9259e-06,
                    4.0274e-06,
                    4.1323e-06,
                    4.2389e-06,
                    4.3483e-06,
                    4.4606e-06,
                    4.5748e-06,
                    4.6904e-06,
                    4.8108e-06,
                    4.9368e-06,
                    5.0666e-06,
                    5.1999e-06,
                    5.3357e-06,
                    5.4748e-06,
                    5.6155e-06,
                    5.7585e-06,
                    5.9047e-06,
                    6.052e-06,
                    6.2053e-06,
                    6.3652e-06,
                    6.5302e-06,
                    6.6982e-06,
                    6.8703e-06,
                    7.0464e-06,
                    7.2251e-06,
                    7.407e-06,
                    7.5913e-06,
                    7.7775e-06,
                    7.967e-06,
                    8.1566e-06,
                    8.3491e-06,
                    8.5434e-06,
                    8.7421e-06,
                    8.9435e-06,
                    9.1476e-06,
                    9.3565e-06,
                    9.5713e-06,
                    9.7923e-06,
                    9.9977e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [
                    3.5365e-09,
                    7.1375e-09,
                    1.0805e-08,
                    1.454e-08,
                    1.8346e-08,
                    2.2223e-08,
                    2.6175e-08,
                    3.0204e-08,
                    3.4312e-08,
                    3.85e-08,
                    4.2926e-08,
                    4.7592e-08,
                    5.25e-08,
                    5.7653e-08,
                    6.3055e-08,
                    6.8708e-08,
                    7.4615e-08,
                    8.078e-08,
                    8.7206e-08,
                    9.3896e-08,
                    1.0084e-07,
                    1.0805e-07,
                    1.1551e-07,
                    1.2323e-07,
                    1.3122e-07,
                    1.3947e-07,
                    1.4799e-07,
                    1.5677e-07,
                    1.6584e-07,
                    1.7517e-07,
                    1.845e-07,
                    1.9405e-07,
                    2.0381e-07,
                    2.138e-07,
                    2.2403e-07,
                    2.345e-07,
                    2.4523e-07,
                    2.5621e-07,
                    2.6747e-07,
                    2.79e-07,
                    2.906e-07,
                    3.0225e-07,
                    3.1396e-07,
                    3.2572e-07,
                    3.3753e-07,
                    3.494e-07,
                    3.6135e-07,
                    3.7336e-07,
                    3.8542e-07,
                    3.9755e-07,
                    4.0825e-07,
                    4.1747e-07,
                    4.2517e-07,
                    4.3135e-07,
                    4.36e-07,
                    4.3908e-07,
                    4.4059e-07,
                    4.4051e-07,
                    4.3882e-07,
                    4.3551e-07,
                    4.3284e-07,
                    4.3083e-07,
                    4.2946e-07,
                    4.2874e-07,
                    4.2866e-07,
                    4.292e-07,
                    4.3036e-07,
                    4.3214e-07,
                    4.3454e-07,
                    4.3755e-07,
                    4.4312e-07,
                    4.5104e-07,
                    4.6134e-07,
                    4.7403e-07,
                    4.8912e-07,
                    5.0649e-07,
                    5.2627e-07,
                    5.4845e-07,
                    5.7293e-07,
                    5.9983e-07,
                    6.2792e-07,
                    6.5699e-07,
                    6.8709e-07,
                    7.1822e-07,
                    7.5036e-07,
                    7.8352e-07,
                    8.1771e-07,
                    8.5292e-07,
                    8.8916e-07,
                    9.2641e-07,
                    9.6527e-07,
                    1.0058e-06,
                    1.048e-06,
                    1.0918e-06,
                    1.137e-06,
                    1.1838e-06,
                    1.2315e-06,
                    1.2803e-06,
                    1.3303e-06,
                    1.3815e-06,
                    1.4338e-06,
                    1.4875e-06,
                    1.5424e-06,
                    1.5986e-06,
                    1.6562e-06,
                    1.7153e-06,
                    1.776e-06,
                    1.8387e-06,
                    1.9035e-06,
                    1.9707e-06,
                    2.0378e-06,
                    2.1045e-06,
                    2.182e-06,
                    2.2598e-06,
                    2.337e-06,
                    2.413e-06,
                    2.4947e-06,
                    2.5808e-06,
                    2.6679e-06,
                    2.7548e-06,
                    2.8409e-06,
                    2.9255e-06,
                    3.0101e-06,
                    3.1007e-06,
                    3.1993e-06,
                    3.2996e-06,
                    3.3977e-06,
                    3.4979e-06,
                    3.6012e-06,
                    3.7083e-06,
                    3.8217e-06,
                    3.9431e-06,
                    4.0554e-06,
                    4.1729e-06,
                    4.306e-06,
                    4.4651e-06,
                    4.6403e-06,
                    4.8095e-06,
                    4.9736e-06,
                    5.1315e-06,
                    5.2873e-06,
                    5.4343e-06,
                    5.5853e-06,
                    5.7327e-06,
                    5.8675e-06,
                    5.9999e-06,
                    6.1318e-06,
                    6.2621e-06,
                    6.3872e-06,
                    6.5088e-06,
                    6.6482e-06,
                    6.7787e-06,
                    6.9099e-06,
                    7.0368e-06,
                    7.1482e-06,
                    7.2343e-06,
                    7.2837e-06,
                    7.3281e-06,
                    7.3852e-06,
                    7.4716e-06,
                    7.5724e-06,
                    7.6884e-06,
                    7.8058e-06,
                    7.9202e-06,
                    8.06e-06,
                    8.1627e-06,
                    8.2428e-06,
                    8.2954e-06,
                    8.3031e-06,
                    8.3324e-06,
                    8.3653e-06,
                    8.3814e-06
                ],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [
                    1.2095e-09,
                    2.4706e-09,
                    3.7851e-09,
                    5.1549e-09,
                    6.5821e-09,
                    8.0686e-09,
                    9.6166e-09,
                    1.1228e-08,
                    1.2906e-08,
                    1.4652e-08,
                    1.6515e-08,
                    1.8497e-08,
                    2.06e-08,
                    2.2829e-08,
                    2.5185e-08,
                    2.7672e-08,
                    3.0293e-08,
                    3.3051e-08,
                    3.5949e-08,
                    3.8992e-08,
                    4.2149e-08,
                    4.5422e-08,
                    4.8814e-08,
                    5.2326e-08,
                    5.5961e-08,
                    5.9721e-08,
                    6.3608e-08,
                    6.7624e-08,
                    7.1773e-08,
                    7.6057e-08,
                    8.0267e-08,
                    8.4629e-08,
                    8.915e-08,
                    9.3836e-08,
                    9.8694e-08,
                    1.0373e-07,
                    1.0896e-07,
                    1.1439e-07,
                    1.2002e-07,
                    1.2587e-07,
                    1.3171e-07,
                    1.3753e-07,
                    1.4334e-07,
                    1.4913e-07,
                    1.549e-07,
                    1.6066e-07,
                    1.6642e-07,
                    1.7218e-07,
                    1.7792e-07,
                    1.8365e-07,
                    1.8883e-07,
                    1.934e-07,
                    1.9733e-07,
                    2.0061e-07,
                    2.0323e-07,
                    2.0516e-07,
                    2.064e-07,
                    2.0691e-07,
                    2.067e-07,
                    2.0573e-07,
                    2.0503e-07,
                    2.0459e-07,
                    2.0442e-07,
                    2.0451e-07,
                    2.0486e-07,
                    2.0545e-07,
                    2.0627e-07,
                    2.0733e-07,
                    2.0862e-07,
                    2.1015e-07,
                    2.1272e-07,
                    2.1612e-07,
                    2.2039e-07,
                    2.2554e-07,
                    2.3158e-07,
                    2.3839e-07,
                    2.4609e-07,
                    2.5469e-07,
                    2.6407e-07,
                    2.7435e-07,
                    2.8513e-07,
                    2.9621e-07,
                    3.0761e-07,
                    3.1934e-07,
                    3.3139e-07,
                    3.4377e-07,
                    3.5646e-07,
                    3.6948e-07,
                    3.8281e-07,
                    3.9645e-07,
                    4.1067e-07,
                    4.2554e-07,
                    4.4103e-07,
                    4.5713e-07,
                    4.7355e-07,
                    4.9055e-07,
                    5.0749e-07,
                    5.2443e-07,
                    5.415e-07,
                    5.5884e-07,
                    5.7658e-07,
                    5.9495e-07,
                    6.1384e-07,
                    6.3332e-07,
                    6.5334e-07,
                    6.7394e-07,
                    6.9533e-07,
                    7.1749e-07,
                    7.4062e-07,
                    7.648e-07,
                    7.8977e-07,
                    8.1559e-07,
                    8.4239e-07,
                    8.7017e-07,
                    8.9923e-07,
                    9.2935e-07,
                    9.6099e-07,
                    9.9408e-07,
                    1.0284e-06,
                    1.0613e-06,
                    1.0947e-06,
                    1.1279e-06,
                    1.1608e-06,
                    1.1933e-06,
                    1.2252e-06,
                    1.2565e-06,
                    1.2876e-06,
                    1.318e-06,
                    1.3472e-06,
                    1.3754e-06,
                    1.4024e-06,
                    1.4282e-06,
                    1.4527e-06,
                    1.4758e-06,
                    1.4973e-06,
                    1.517e-06,
                    1.5353e-06,
                    1.552e-06,
                    1.5676e-06,
                    1.5845e-06,
                    1.6005e-06,
                    1.6161e-06,
                    1.6316e-06,
                    1.6471e-06,
                    1.6675e-06,
                    1.6896e-06,
                    1.7113e-06,
                    1.7325e-06,
                    1.7538e-06,
                    1.7757e-06,
                    1.7978e-06,
                    1.82e-06,
                    1.8423e-06,
                    1.864e-06,
                    1.8859e-06,
                    1.9084e-06,
                    1.9306e-06,
                    1.953e-06,
                    1.9752e-06,
                    1.9975e-06,
                    2.0198e-06,
                    2.0416e-06,
                    2.0649e-06,
                    2.0881e-06,
                    2.1071e-06,
                    2.1247e-06,
                    2.1423e-06,
                    2.1598e-06,
                    2.1779e-06,
                    2.1952e-06,
                    2.2125e-06,
                    2.2294e-06
                ],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [
                    2.327e-09,
                    4.6668e-09,
                    7.0195e-09,
                    9.3851e-09,
                    1.1763e-08,
                    1.4155e-08,
                    1.6559e-08,
                    1.8976e-08,
                    2.1406e-08,
                    2.3848e-08,
                    2.6412e-08,
                    2.9095e-08,
                    3.19e-08,
                    3.4825e-08,
                    3.787e-08,
                    4.1036e-08,
                    4.4322e-08,
                    4.7729e-08,
                    5.1257e-08,
                    5.4905e-08,
                    5.8693e-08,
                    6.2623e-08,
                    6.6692e-08,
                    7.0903e-08,
                    7.5254e-08,
                    7.9746e-08,
                    8.4378e-08,
                    8.9151e-08,
                    9.4064e-08,
                    9.9118e-08,
                    1.0424e-07,
                    1.0942e-07,
                    1.1466e-07,
                    1.1997e-07,
                    1.2534e-07,
                    1.3077e-07,
                    1.3627e-07,
                    1.4182e-07,
                    1.4745e-07,
                    1.5313e-07,
                    1.5889e-07,
                    1.6472e-07,
                    1.7062e-07,
                    1.7659e-07,
                    1.8263e-07,
                    1.8874e-07,
                    1.9492e-07,
                    2.0118e-07,
                    2.075e-07,
                    2.139e-07,
                    2.1942e-07,
                    2.2407e-07,
                    2.2784e-07,
                    2.3074e-07,
                    2.3277e-07,
                    2.3392e-07,
                    2.3419e-07,
                    2.336e-07,
                    2.3212e-07,
                    2.2978e-07,
                    2.2781e-07,
                    2.2623e-07,
                    2.2504e-07,
                    2.2422e-07,
                    2.238e-07,
                    2.2375e-07,
                    2.2409e-07,
                    2.2481e-07,
                    2.2592e-07,
                    2.274e-07,
                    2.3041e-07,
                    2.3492e-07,
                    2.4095e-07,
                    2.4848e-07,
                    2.5754e-07,
                    2.681e-07,
                    2.8017e-07,
                    2.9376e-07,
                    3.0886e-07,
                    3.2548e-07,
                    3.4278e-07,
                    3.6079e-07,
                    3.7948e-07,
                    3.9888e-07,
                    4.1896e-07,
                    4.3976e-07,
                    4.6125e-07,
                    4.8345e-07,
                    5.0635e-07,
                    5.2996e-07,
                    5.546e-07,
                    5.8027e-07,
                    6.0696e-07,
                    6.3468e-07,
                    6.6343e-07,
                    6.9322e-07,
                    7.2403e-07,
                    7.5588e-07,
                    7.8876e-07,
                    8.2267e-07,
                    8.5725e-07,
                    8.9253e-07,
                    9.2853e-07,
                    9.653e-07,
                    1.0029e-06,
                    1.0413e-06,
                    1.0807e-06,
                    1.1212e-06,
                    1.1629e-06,
                    1.2059e-06,
                    1.2481e-06,
                    1.2889e-06,
                    1.3396e-06,
                    1.3897e-06,
                    1.4377e-06,
                    1.4836e-06,
                    1.5337e-06,
                    1.5867e-06,
                    1.6395e-06,
                    1.6935e-06,
                    1.7461e-06,
                    1.7976e-06,
                    1.8493e-06,
                    1.9073e-06,
                    1.9741e-06,
                    2.043e-06,
                    2.11e-06,
                    2.1799e-06,
                    2.2539e-06,
                    2.3329e-06,
                    2.4193e-06,
                    2.5148e-06,
                    2.6027e-06,
                    2.6971e-06,
                    2.8087e-06,
                    2.9481e-06,
                    3.105e-06,
                    3.2575e-06,
                    3.406e-06,
                    3.5469e-06,
                    3.6868e-06,
                    3.8182e-06,
                    3.9537e-06,
                    4.0856e-06,
                    4.2e-06,
                    4.3103e-06,
                    4.4205e-06,
                    4.5296e-06,
                    4.6334e-06,
                    4.7331e-06,
                    4.8504e-06,
                    4.9587e-06,
                    5.0676e-06,
                    5.1728e-06,
                    5.2622e-06,
                    5.3259e-06,
                    5.3532e-06,
                    5.375e-06,
                    5.4099e-06,
                    5.4741e-06,
                    5.5526e-06,
                    5.6467e-06,
                    5.7409e-06,
                    5.8322e-06,
                    5.9529e-06,
                    6.038e-06,
                    6.1006e-06,
                    6.1356e-06,
                    6.1252e-06,
                    6.1372e-06,
                    6.1528e-06,
                    6.152e-06
                ],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [
                    1.278e-09,
                    2.5803e-09,
                    3.9058e-09,
                    5.2532e-09,
                    6.6208e-09,
                    8.0065e-09,
                    9.4076e-09,
                    1.0821e-08,
                    1.2245e-08,
                    1.3674e-08,
                    1.5106e-08,
                    1.6541e-08,
                    1.7979e-08,
                    1.9419e-08,
                    2.0861e-08,
                    2.2305e-08,
                    2.3752e-08,
                    2.5201e-08,
                    2.6653e-08,
                    2.8108e-08,
                    2.9587e-08,
                    3.1122e-08,
                    3.2739e-08,
                    3.4456e-08,
                    3.6283e-08,
                    3.8223e-08,
                    4.0269e-08,
                    4.241e-08,
                    4.4625e-08,
                    4.6884e-08,
                    4.917e-08,
                    5.1478e-08,
                    5.3804e-08,
                    5.6147e-08,
                    5.8505e-08,
                    6.0877e-08,
                    6.3263e-08,
                    6.5664e-08,
                    6.8081e-08,
                    7.075e-08,
                    7.3315e-08,
                    7.5788e-08,
                    7.8184e-08,
                    8.0515e-08,
                    8.2793e-08,
                    8.503e-08,
                    8.7238e-08,
                    8.9426e-08,
                    9.1604e-08,
                    9.3782e-08,
                    9.5981e-08,
                    9.8232e-08,
                    1.0056e-07,
                    1.0298e-07,
                    1.055e-07,
                    1.0813e-07,
                    1.1087e-07,
                    1.1369e-07,
                    1.166e-07,
                    1.1956e-07,
                    1.2255e-07,
                    1.2558e-07,
                    1.2863e-07,
                    1.3172e-07,
                    1.3482e-07,
                    1.3795e-07,
                    1.411e-07,
                    1.4428e-07,
                    1.4748e-07,
                    1.5071e-07,
                    1.5398e-07,
                    1.5729e-07,
                    1.6064e-07,
                    1.6405e-07,
                    1.675e-07,
                    1.7099e-07,
                    1.7453e-07,
                    1.781e-07,
                    1.8169e-07,
                    1.8529e-07,
                    1.8889e-07,
                    1.925e-07,
                    1.9609e-07,
                    1.9969e-07,
                    2.0328e-07,
                    2.0687e-07,
                    2.1046e-07,
                    2.1405e-07,
                    2.1764e-07,
                    2.2124e-07,
                    2.2491e-07,
                    2.2873e-07,
                    2.3278e-07,
                    2.371e-07,
                    2.4173e-07,
                    2.4667e-07,
                    2.5191e-07,
                    2.5744e-07,
                    2.6318e-07,
                    2.6908e-07,
                    2.7509e-07,
                    2.8122e-07,
                    2.8748e-07,
                    2.9387e-07,
                    3.0039e-07,
                    3.0706e-07,
                    3.1387e-07,
                    3.2083e-07,
                    3.2794e-07,
                    3.3521e-07,
                    3.427e-07,
                    3.5029e-07,
                    3.5867e-07,
                    3.6716e-07,
                    3.7572e-07,
                    3.8432e-07,
                    3.9339e-07,
                    4.0283e-07,
                    4.1239e-07,
                    4.221e-07,
                    4.3189e-07,
                    4.4183e-07,
                    4.5198e-07,
                    4.6281e-07,
                    4.7454e-07,
                    4.8658e-07,
                    4.9878e-07,
                    5.1116e-07,
                    5.2414e-07,
                    5.3719e-07,
                    5.5062e-07,
                    5.639e-07,
                    5.7701e-07,
                    5.9036e-07,
                    6.043e-07,
                    6.1942e-07,
                    6.3585e-07,
                    6.5228e-07,
                    6.6868e-07,
                    6.8495e-07,
                    7.0135e-07,
                    7.1731e-07,
                    7.338e-07,
                    7.5067e-07,
                    7.6749e-07,
                    7.8446e-07,
                    8.0155e-07,
                    8.1914e-07,
                    8.3685e-07,
                    8.5479e-07,
                    8.7385e-07,
                    8.9305e-07,
                    9.1265e-07,
                    9.3256e-07,
                    9.5251e-07,
                    9.7233e-07,
                    9.919e-07,
                    1.0113e-06,
                    1.0322e-06,
                    1.0548e-06,
                    1.0786e-06,
                    1.1031e-06,
                    1.128e-06,
                    1.1532e-06,
                    1.1808e-06,
                    1.2059e-06,
                    1.2301e-06,
                    1.2529e-06,
                    1.2732e-06,
                    1.2956e-06,
                    1.3187e-06,
                    1.3409e-06
                ],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [
                    1.7954e-10,
                    3.6136e-10,
                    5.4543e-10,
                    7.3167e-10,
                    9.2003e-10,
                    1.1104e-09,
                    1.3027e-09,
                    1.4967e-09,
                    1.6924e-09,
                    1.8896e-09,
                    2.0881e-09,
                    2.288e-09,
                    2.4892e-09,
                    2.6917e-09,
                    2.8956e-09,
                    3.1007e-09,
                    3.3072e-09,
                    3.515e-09,
                    3.7242e-09,
                    3.9348e-09,
                    4.1476e-09,
                    4.3641e-09,
                    4.5854e-09,
                    4.8123e-09,
                    5.0452e-09,
                    5.2843e-09,
                    5.5293e-09,
                    5.7797e-09,
                    6.0345e-09,
                    6.2925e-09,
                    6.5529e-09,
                    6.8155e-09,
                    7.0801e-09,
                    7.3467e-09,
                    7.6151e-09,
                    7.8854e-09,
                    8.1575e-09,
                    8.4315e-09,
                    8.7074e-09,
                    8.9885e-09,
                    9.2723e-09,
                    9.5592e-09,
                    9.849e-09,
                    1.0142e-08,
                    1.0438e-08,
                    1.0737e-08,
                    1.104e-08,
                    1.1347e-08,
                    1.1657e-08,
                    1.197e-08,
                    1.2288e-08,
                    1.2611e-08,
                    1.2938e-08,
                    1.327e-08,
                    1.3608e-08,
                    1.3951e-08,
                    1.43e-08,
                    1.4653e-08,
                    1.5011e-08,
                    1.5374e-08,
                    1.574e-08,
                    1.6111e-08,
                    1.6486e-08,
                    1.6865e-08,
                    1.7249e-08,
                    1.7636e-08,
                    1.8026e-08,
                    1.8421e-08,
                    1.8818e-08,
                    1.9219e-08,
                    1.9623e-08,
                    2.003e-08,
                    2.0439e-08,
                    2.085e-08,
                    2.1263e-08,
                    2.1679e-08,
                    2.2097e-08,
                    2.2517e-08,
                    2.294e-08,
                    2.3366e-08,
                    2.3795e-08,
                    2.4231e-08,
                    2.4675e-08,
                    2.5128e-08,
                    2.5592e-08,
                    2.6068e-08,
                    2.6556e-08,
                    2.7056e-08,
                    2.7568e-08,
                    2.8092e-08,
                    2.8631e-08,
                    2.9191e-08,
                    2.9775e-08,
                    3.0386e-08,
                    3.1027e-08,
                    3.1698e-08,
                    3.2397e-08,
                    3.3124e-08,
                    3.3875e-08,
                    3.4645e-08,
                    3.543e-08,
                    3.6229e-08,
                    3.7042e-08,
                    3.7868e-08,
                    3.8707e-08,
                    3.9558e-08,
                    4.0422e-08,
                    4.1301e-08,
                    4.2195e-08,
                    4.3107e-08,
                    4.4046e-08,
                    4.503e-08,
                    4.607e-08,
                    4.7175e-08,
                    4.8349e-08,
                    4.9591e-08,
                    5.0898e-08,
                    5.226e-08,
                    5.3666e-08,
                    5.5056e-08,
                    5.6481e-08,
                    5.7981e-08,
                    5.9506e-08,
                    6.111e-08,
                    6.2829e-08,
                    6.4554e-08,
                    6.6513e-08,
                    6.8372e-08,
                    7.0306e-08,
                    7.2298e-08,
                    7.4363e-08,
                    7.6583e-08,
                    7.8763e-08,
                    8.1133e-08,
                    8.3513e-08,
                    8.5724e-08,
                    8.8082e-08,
                    9.0433e-08,
                    9.2917e-08,
                    9.5415e-08,
                    9.7912e-08,
                    1.004e-07,
                    1.0304e-07,
                    1.0573e-07,
                    1.0864e-07,
                    1.1168e-07,
                    1.1486e-07,
                    1.1823e-07,
                    1.2155e-07,
                    1.2497e-07,
                    1.2849e-07,
                    1.3209e-07,
                    1.358e-07,
                    1.3946e-07,
                    1.4317e-07,
                    1.4686e-07,
                    1.5082e-07,
                    1.5485e-07,
                    1.5873e-07,
                    1.628e-07,
                    1.6693e-07,
                    1.7112e-07,
                    1.7531e-07,
                    1.7957e-07,
                    1.8433e-07,
                    1.8912e-07,
                    1.9426e-07,
                    1.9936e-07,
                    2.0456e-07,
                    2.0945e-07,
                    2.1446e-07,
                    2.1954e-07
                ],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": [
                    1.0985e-09,
                    2.2189e-09,
                    3.3604e-09,
                    4.5216e-09,
                    5.7008e-09,
                    6.8961e-09,
                    8.1049e-09,
                    9.3247e-09,
                    1.0552e-08,
                    1.1784e-08,
                    1.3018e-08,
                    1.4253e-08,
                    1.549e-08,
                    1.6728e-08,
                    1.7966e-08,
                    1.9205e-08,
                    2.0445e-08,
                    2.1686e-08,
                    2.2928e-08,
                    2.4173e-08,
                    2.5439e-08,
                    2.6758e-08,
                    2.8154e-08,
                    2.9644e-08,
                    3.1238e-08,
                    3.2938e-08,
                    3.474e-08,
                    3.663e-08,
                    3.859e-08,
                    4.0592e-08,
                    4.2617e-08,
                    4.4662e-08,
                    4.6724e-08,
                    4.8801e-08,
                    5.089e-08,
                    5.2992e-08,
                    5.5105e-08,
                    5.7232e-08,
                    5.9373e-08,
                    6.1762e-08,
                    6.4043e-08,
                    6.6229e-08,
                    6.8335e-08,
                    7.0373e-08,
                    7.2355e-08,
                    7.4293e-08,
                    7.6197e-08,
                    7.8079e-08,
                    7.9947e-08,
                    8.1811e-08,
                    8.3692e-08,
                    8.5621e-08,
                    8.7621e-08,
                    8.9708e-08,
                    9.1893e-08,
                    9.418e-08,
                    9.6566e-08,
                    9.904e-08,
                    1.0159e-07,
                    1.0418e-07,
                    1.0681e-07,
                    1.0947e-07,
                    1.1215e-07,
                    1.1485e-07,
                    1.1757e-07,
                    1.2032e-07,
                    1.2308e-07,
                    1.2586e-07,
                    1.2866e-07,
                    1.3149e-07,
                    1.3436e-07,
                    1.3726e-07,
                    1.402e-07,
                    1.432e-07,
                    1.4623e-07,
                    1.4931e-07,
                    1.5243e-07,
                    1.5558e-07,
                    1.5875e-07,
                    1.6193e-07,
                    1.651e-07,
                    1.6826e-07,
                    1.7142e-07,
                    1.7456e-07,
                    1.7769e-07,
                    1.808e-07,
                    1.839e-07,
                    1.8699e-07,
                    1.9007e-07,
                    1.9315e-07,
                    1.9628e-07,
                    1.9954e-07,
                    2.03e-07,
                    2.0671e-07,
                    2.107e-07,
                    2.1497e-07,
                    2.1952e-07,
                    2.2431e-07,
                    2.2931e-07,
                    2.3443e-07,
                    2.3966e-07,
                    2.4499e-07,
                    2.5044e-07,
                    2.56e-07,
                    2.6169e-07,
                    2.675e-07,
                    2.7345e-07,
                    2.7953e-07,
                    2.8575e-07,
                    2.921e-07,
                    2.9866e-07,
                    3.0526e-07,
                    3.126e-07,
                    3.1999e-07,
                    3.2737e-07,
                    3.3473e-07,
                    3.425e-07,
                    3.5057e-07,
                    3.5872e-07,
                    3.6705e-07,
                    3.7541e-07,
                    3.8385e-07,
                    3.9247e-07,
                    4.017e-07,
                    4.1171e-07,
                    4.2203e-07,
                    4.3227e-07,
                    4.4279e-07,
                    4.5383e-07,
                    4.6489e-07,
                    4.7625e-07,
                    4.8732e-07,
                    4.9825e-07,
                    5.0923e-07,
                    5.2078e-07,
                    5.3369e-07,
                    5.4777e-07,
                    5.6184e-07,
                    5.7576e-07,
                    5.8953e-07,
                    6.0344e-07,
                    6.1691e-07,
                    6.3076e-07,
                    6.4494e-07,
                    6.5886e-07,
                    6.7277e-07,
                    6.8669e-07,
                    7.0091e-07,
                    7.153e-07,
                    7.2982e-07,
                    7.4536e-07,
                    7.6096e-07,
                    7.7685e-07,
                    7.9309e-07,
                    8.0933e-07,
                    8.2548e-07,
                    8.4108e-07,
                    8.5647e-07,
                    8.7347e-07,
                    8.9201e-07,
                    9.1166e-07,
                    9.3195e-07,
                    9.5273e-07,
                    9.7358e-07,
                    9.9644e-07,
                    1.0168e-06,
                    1.0358e-06,
                    1.0536e-06,
                    1.0687e-06,
                    1.0861e-06,
                    1.1042e-06,
                    1.1214e-06
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -172.8031,
                                -13.51619
                            ],
                            [
                                -172.68451,
                                -13.62031
                            ],
                            [
                                -172.52928,
                                -13.8024
                            ],
                            [
                                -172.28999,
                                -13.75972
                            ],
                            [
                                -172.21917,
                                -13.73635
                            ],
                            [
                                -172.17504,
                                -13.66816
                            ],
                            [
                                -172.21101,
                                -13.57996
                            ],
                            [
                                -172.30617,
                                -13.45992
                            ],
                            [
                                -172.35579,
                                -13.44048
                            ],
                            [
                                -172.47928,
                                -13.46176
                            ],
                            [
                                -172.70303,
                                -13.51856
                            ],
                            [
                                -172.75712,
                                -13.49067
                            ],
                            [
                                -172.8031,
                                -13.51619
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -172.07184,
                                -13.86618
                            ],
                            [
                                -172.06574,
                                -13.89274
                            ],
                            [
                                -171.97285,
                                -13.93503
                            ],
                            [
                                -171.91265,
                                -14.00483
                            ],
                            [
                                -171.8574,
                                -13.98419
                            ],
                            [
                                -171.76741,
                                -14.04151
                            ],
                            [
                                -171.43912,
                                -14.04728
                            ],
                            [
                                -171.44118,
                                -13.97671
                            ],
                            [
                                -171.57091,
                                -13.88879
                            ],
                            [
                                -171.70745,
                                -13.86317
                            ],
                            [
                                -171.83077,
                                -13.7939
                            ],
                            [
                                -172.02977,
                                -13.8268
                            ],
                            [
                                -172.07184,
                                -13.86618
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "STP",
                "Country": "S\xe3o Tom\xe9 and Pr\xedncipe",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    1.0438e-08,
                    2.2067e-08,
                    3.2334e-08,
                    4.3259e-08,
                    5.3972e-08,
                    6.5331e-08,
                    7.6131e-08,
                    8.7867e-08,
                    9.7993e-08,
                    1.0956e-07,
                    1.2202e-07,
                    1.3663e-07,
                    1.4719e-07,
                    1.5846e-07,
                    1.7097e-07,
                    1.8328e-07,
                    1.9628e-07,
                    2.0777e-07,
                    2.1955e-07,
                    2.3272e-07,
                    2.4582e-07,
                    2.5904e-07,
                    2.7259e-07,
                    2.8597e-07,
                    2.995e-07,
                    3.1572e-07,
                    3.3126e-07,
                    3.4689e-07,
                    3.5981e-07,
                    3.7419e-07,
                    3.8879e-07,
                    4.0384e-07,
                    4.1878e-07,
                    4.324e-07,
                    4.4575e-07,
                    4.5932e-07,
                    4.7401e-07,
                    4.9016e-07,
                    5.0549e-07,
                    5.2213e-07,
                    5.4003e-07,
                    5.5494e-07,
                    5.7299e-07,
                    5.904e-07,
                    6.0749e-07,
                    6.2478e-07,
                    6.4181e-07,
                    6.5934e-07,
                    6.7697e-07,
                    6.9545e-07,
                    7.1427e-07,
                    7.3328e-07,
                    7.5251e-07,
                    7.719e-07,
                    7.915e-07,
                    8.1124e-07,
                    8.312e-07,
                    8.5128e-07,
                    8.7156e-07,
                    8.9242e-07,
                    9.1365e-07,
                    9.3523e-07,
                    9.5696e-07,
                    9.7895e-07,
                    1.0012e-06,
                    1.0236e-06,
                    1.0462e-06,
                    1.0691e-06,
                    1.0922e-06,
                    1.1166e-06,
                    1.1414e-06,
                    1.1665e-06,
                    1.192e-06,
                    1.2177e-06,
                    1.2437e-06,
                    1.27e-06,
                    1.2966e-06,
                    1.3235e-06,
                    1.3507e-06,
                    1.378e-06,
                    1.4054e-06,
                    1.4307e-06,
                    1.4564e-06,
                    1.4825e-06,
                    1.5089e-06,
                    1.5357e-06,
                    1.5631e-06,
                    1.5911e-06,
                    1.6197e-06,
                    1.6433e-06,
                    1.6649e-06,
                    1.6856e-06,
                    1.706e-06,
                    1.7264e-06,
                    1.7467e-06,
                    1.7672e-06,
                    1.7878e-06,
                    1.8083e-06,
                    1.829e-06,
                    1.8535e-06,
                    1.874e-06,
                    1.8909e-06,
                    1.9082e-06,
                    1.9301e-06,
                    1.9613e-06,
                    1.9991e-06,
                    2.0449e-06,
                    2.0866e-06,
                    2.124e-06,
                    2.1581e-06,
                    2.1896e-06,
                    2.219e-06,
                    2.2427e-06,
                    2.2872e-06,
                    2.3187e-06,
                    2.3438e-06,
                    2.3691e-06,
                    2.3955e-06,
                    2.421e-06,
                    2.4693e-06,
                    2.5014e-06,
                    2.5285e-06,
                    2.5567e-06,
                    2.5856e-06,
                    2.6148e-06,
                    2.6616e-06,
                    2.7005e-06,
                    2.7392e-06,
                    2.7769e-06,
                    2.8168e-06,
                    2.862e-06,
                    2.9089e-06,
                    2.9629e-06,
                    3.04e-06,
                    3.1084e-06,
                    3.1726e-06,
                    3.236e-06,
                    3.3854e-06,
                    3.4854e-06,
                    3.5774e-06,
                    3.664e-06,
                    3.7497e-06,
                    3.8798e-06,
                    4.0063e-06,
                    4.1148e-06,
                    4.2366e-06,
                    4.3384e-06,
                    4.5401e-06,
                    4.6975e-06,
                    4.8599e-06,
                    4.9894e-06,
                    5.1614e-06,
                    5.2852e-06,
                    5.3974e-06,
                    5.5078e-06,
                    5.6212e-06,
                    5.7291e-06,
                    5.8434e-06,
                    5.9573e-06,
                    6.0898e-06,
                    6.2029e-06,
                    6.316e-06,
                    6.4279e-06,
                    6.5517e-06,
                    6.6863e-06,
                    6.8268e-06,
                    6.9651e-06,
                    7.1035e-06,
                    7.242e-06,
                    7.3811e-06,
                    7.5243e-06,
                    7.6615e-06
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    1.609e-09,
                    3.2353e-09,
                    4.8788e-09,
                    6.5395e-09,
                    8.2174e-09,
                    9.9125e-09,
                    1.1625e-08,
                    1.3354e-08,
                    1.51e-08,
                    1.6863e-08,
                    1.8644e-08,
                    2.0444e-08,
                    2.2262e-08,
                    2.4099e-08,
                    2.5954e-08,
                    2.7828e-08,
                    2.9721e-08,
                    3.1632e-08,
                    3.3561e-08,
                    3.5509e-08,
                    3.7484e-08,
                    3.948e-08,
                    4.1498e-08,
                    4.354e-08,
                    4.5604e-08,
                    4.7691e-08,
                    4.9802e-08,
                    5.1935e-08,
                    5.409e-08,
                    5.6266e-08,
                    5.8465e-08,
                    6.0687e-08,
                    6.2932e-08,
                    6.52e-08,
                    6.7491e-08,
                    6.9804e-08,
                    7.214e-08,
                    7.4498e-08,
                    7.688e-08,
                    7.9287e-08,
                    8.1716e-08,
                    8.4171e-08,
                    8.6652e-08,
                    8.916e-08,
                    9.1694e-08,
                    9.4255e-08,
                    9.6843e-08,
                    9.9457e-08,
                    1.021e-07,
                    1.0477e-07,
                    1.0753e-07,
                    1.104e-07,
                    1.1337e-07,
                    1.1644e-07,
                    1.1962e-07,
                    1.229e-07,
                    1.2629e-07,
                    1.2979e-07,
                    1.334e-07,
                    1.3712e-07,
                    1.4096e-07,
                    1.4492e-07,
                    1.4899e-07,
                    1.5319e-07,
                    1.5752e-07,
                    1.6199e-07,
                    1.6659e-07,
                    1.7133e-07,
                    1.7622e-07,
                    1.8125e-07,
                    1.8643e-07,
                    1.9176e-07,
                    1.9726e-07,
                    2.0292e-07,
                    2.0877e-07,
                    2.148e-07,
                    2.2103e-07,
                    2.2746e-07,
                    2.3412e-07,
                    2.4099e-07,
                    2.4808e-07,
                    2.554e-07,
                    2.6296e-07,
                    2.7076e-07,
                    2.7881e-07,
                    2.8713e-07,
                    2.9571e-07,
                    3.0467e-07,
                    3.1396e-07,
                    3.2358e-07,
                    3.3339e-07,
                    3.434e-07,
                    3.5362e-07,
                    3.6403e-07,
                    3.7461e-07,
                    3.8533e-07,
                    3.9618e-07,
                    4.0712e-07,
                    4.1813e-07,
                    4.292e-07,
                    4.4218e-07,
                    4.548e-07,
                    4.6715e-07,
                    4.7935e-07,
                    4.9161e-07,
                    5.0634e-07,
                    5.2369e-07,
                    5.3902e-07,
                    5.5455e-07,
                    5.7237e-07,
                    5.8984e-07,
                    6.0665e-07,
                    6.2042e-07,
                    6.3583e-07,
                    6.5086e-07,
                    6.6581e-07,
                    6.8091e-07,
                    6.9859e-07,
                    7.1654e-07,
                    7.3526e-07,
                    7.5267e-07,
                    7.7122e-07,
                    7.9203e-07,
                    8.1507e-07,
                    8.3908e-07,
                    8.6805e-07,
                    8.9691e-07,
                    9.2879e-07,
                    9.6104e-07,
                    9.9653e-07,
                    1.0366e-06,
                    1.0787e-06,
                    1.1268e-06,
                    1.1748e-06,
                    1.2254e-06,
                    1.2754e-06,
                    1.3269e-06,
                    1.3772e-06,
                    1.4283e-06,
                    1.4891e-06,
                    1.5516e-06,
                    1.6145e-06,
                    1.6782e-06,
                    1.7432e-06,
                    1.8097e-06,
                    1.8766e-06,
                    1.9443e-06,
                    2.0125e-06,
                    2.0844e-06,
                    2.1577e-06,
                    2.2315e-06,
                    2.311e-06,
                    2.3955e-06,
                    2.4851e-06,
                    2.579e-06,
                    2.6777e-06,
                    2.7771e-06,
                    2.8781e-06,
                    2.984e-06,
                    3.0886e-06,
                    3.1927e-06,
                    3.301e-06,
                    3.4112e-06,
                    3.532e-06,
                    3.6581e-06,
                    3.7929e-06,
                    3.9238e-06,
                    4.0559e-06,
                    4.1887e-06,
                    4.3215e-06,
                    4.4585e-06,
                    4.589e-06
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [
                    8.8288e-09,
                    1.8831e-08,
                    2.7456e-08,
                    3.672e-08,
                    4.5755e-08,
                    5.5418e-08,
                    6.4506e-08,
                    7.4513e-08,
                    8.2893e-08,
                    9.2693e-08,
                    1.0338e-07,
                    1.1619e-07,
                    1.2493e-07,
                    1.3436e-07,
                    1.4502e-07,
                    1.5545e-07,
                    1.6655e-07,
                    1.7614e-07,
                    1.8599e-07,
                    1.9721e-07,
                    2.0833e-07,
                    2.1956e-07,
                    2.3109e-07,
                    2.4243e-07,
                    2.539e-07,
                    2.6803e-07,
                    2.8146e-07,
                    2.9496e-07,
                    3.0572e-07,
                    3.1793e-07,
                    3.3033e-07,
                    3.4315e-07,
                    3.5585e-07,
                    3.672e-07,
                    3.7826e-07,
                    3.8952e-07,
                    4.0187e-07,
                    4.1566e-07,
                    4.2861e-07,
                    4.4284e-07,
                    4.5832e-07,
                    4.7076e-07,
                    4.8634e-07,
                    5.0124e-07,
                    5.158e-07,
                    5.3053e-07,
                    5.4497e-07,
                    5.5989e-07,
                    5.7487e-07,
                    5.9068e-07,
                    6.0673e-07,
                    6.2288e-07,
                    6.3914e-07,
                    6.5546e-07,
                    6.7189e-07,
                    6.8835e-07,
                    7.0491e-07,
                    7.215e-07,
                    7.3816e-07,
                    7.553e-07,
                    7.7269e-07,
                    7.9031e-07,
                    8.0797e-07,
                    8.2575e-07,
                    8.4364e-07,
                    8.6159e-07,
                    8.7964e-07,
                    8.978e-07,
                    9.1598e-07,
                    9.3534e-07,
                    9.5497e-07,
                    9.7475e-07,
                    9.947e-07,
                    1.0148e-06,
                    1.0349e-06,
                    1.0552e-06,
                    1.0756e-06,
                    1.096e-06,
                    1.1166e-06,
                    1.137e-06,
                    1.1573e-06,
                    1.1753e-06,
                    1.1934e-06,
                    1.2117e-06,
                    1.2301e-06,
                    1.2486e-06,
                    1.2674e-06,
                    1.2864e-06,
                    1.3057e-06,
                    1.3197e-06,
                    1.3315e-06,
                    1.3422e-06,
                    1.3524e-06,
                    1.3623e-06,
                    1.3721e-06,
                    1.3819e-06,
                    1.3916e-06,
                    1.4012e-06,
                    1.4109e-06,
                    1.4243e-06,
                    1.4318e-06,
                    1.4361e-06,
                    1.441e-06,
                    1.4508e-06,
                    1.4697e-06,
                    1.4927e-06,
                    1.5212e-06,
                    1.5476e-06,
                    1.5695e-06,
                    1.5857e-06,
                    1.5997e-06,
                    1.6124e-06,
                    1.6223e-06,
                    1.6514e-06,
                    1.6679e-06,
                    1.678e-06,
                    1.6881e-06,
                    1.6969e-06,
                    1.7044e-06,
                    1.734e-06,
                    1.7487e-06,
                    1.7572e-06,
                    1.7646e-06,
                    1.7705e-06,
                    1.7758e-06,
                    1.7935e-06,
                    1.8036e-06,
                    1.8104e-06,
                    1.8159e-06,
                    1.8203e-06,
                    1.8254e-06,
                    1.8301e-06,
                    1.8362e-06,
                    1.8653e-06,
                    1.883e-06,
                    1.8972e-06,
                    1.9091e-06,
                    2.0082e-06,
                    2.0571e-06,
                    2.0883e-06,
                    2.1123e-06,
                    2.1352e-06,
                    2.2015e-06,
                    2.2631e-06,
                    2.3051e-06,
                    2.36e-06,
                    2.3941e-06,
                    2.5276e-06,
                    2.6131e-06,
                    2.7022e-06,
                    2.758e-06,
                    2.8504e-06,
                    2.8897e-06,
                    2.9123e-06,
                    2.9288e-06,
                    2.9436e-06,
                    2.9519e-06,
                    2.9653e-06,
                    2.9733e-06,
                    3.0012e-06,
                    3.0102e-06,
                    3.015e-06,
                    3.0167e-06,
                    3.0197e-06,
                    3.0282e-06,
                    3.0339e-06,
                    3.0413e-06,
                    3.0476e-06,
                    3.0532e-06,
                    3.0596e-06,
                    3.0658e-06,
                    3.0725e-06
                ],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    8.1895e-09,
                    1.7545e-08,
                    2.5514e-08,
                    3.4116e-08,
                    4.2482e-08,
                    5.1469e-08,
                    5.9873e-08,
                    6.919e-08,
                    7.6874e-08,
                    8.597e-08,
                    9.5948e-08,
                    1.0804e-07,
                    1.1606e-07,
                    1.2476e-07,
                    1.3468e-07,
                    1.4437e-07,
                    1.5473e-07,
                    1.6356e-07,
                    1.7265e-07,
                    1.8311e-07,
                    1.9345e-07,
                    2.0389e-07,
                    2.1462e-07,
                    2.2514e-07,
                    2.3577e-07,
                    2.4906e-07,
                    2.6162e-07,
                    2.7424e-07,
                    2.841e-07,
                    2.954e-07,
                    3.0688e-07,
                    3.1878e-07,
                    3.3054e-07,
                    3.4095e-07,
                    3.5106e-07,
                    3.6136e-07,
                    3.7274e-07,
                    3.8554e-07,
                    3.975e-07,
                    4.1073e-07,
                    4.2519e-07,
                    4.3661e-07,
                    4.5114e-07,
                    4.6499e-07,
                    4.7849e-07,
                    4.9215e-07,
                    5.055e-07,
                    5.1933e-07,
                    5.332e-07,
                    5.479e-07,
                    5.6282e-07,
                    5.7783e-07,
                    5.9293e-07,
                    6.0809e-07,
                    6.2334e-07,
                    6.3861e-07,
                    6.5397e-07,
                    6.6934e-07,
                    6.8478e-07,
                    7.0068e-07,
                    7.1681e-07,
                    7.3315e-07,
                    7.495e-07,
                    7.6596e-07,
                    7.8248e-07,
                    7.9904e-07,
                    8.1567e-07,
                    8.3239e-07,
                    8.4909e-07,
                    8.6694e-07,
                    8.8504e-07,
                    9.0326e-07,
                    9.2161e-07,
                    9.4003e-07,
                    9.5855e-07,
                    9.7712e-07,
                    9.9576e-07,
                    1.0145e-06,
                    1.0333e-06,
                    1.0519e-06,
                    1.0705e-06,
                    1.0867e-06,
                    1.103e-06,
                    1.1195e-06,
                    1.1361e-06,
                    1.1527e-06,
                    1.1694e-06,
                    1.1861e-06,
                    1.2029e-06,
                    1.2142e-06,
                    1.2231e-06,
                    1.2307e-06,
                    1.2373e-06,
                    1.2434e-06,
                    1.2489e-06,
                    1.254e-06,
                    1.2586e-06,
                    1.2628e-06,
                    1.2668e-06,
                    1.2743e-06,
                    1.2776e-06,
                    1.2777e-06,
                    1.2784e-06,
                    1.2839e-06,
                    1.2985e-06,
                    1.3188e-06,
                    1.3462e-06,
                    1.3698e-06,
                    1.3887e-06,
                    1.4036e-06,
                    1.4166e-06,
                    1.4282e-06,
                    1.4365e-06,
                    1.467e-06,
                    1.486e-06,
                    1.4997e-06,
                    1.5125e-06,
                    1.5257e-06,
                    1.5384e-06,
                    1.5736e-06,
                    1.5929e-06,
                    1.6074e-06,
                    1.6218e-06,
                    1.6372e-06,
                    1.6518e-06,
                    1.683e-06,
                    1.7072e-06,
                    1.73e-06,
                    1.7518e-06,
                    1.7759e-06,
                    1.8018e-06,
                    1.8287e-06,
                    1.8591e-06,
                    1.9098e-06,
                    1.9496e-06,
                    1.9834e-06,
                    2.0156e-06,
                    2.1331e-06,
                    2.2e-06,
                    2.2485e-06,
                    2.2891e-06,
                    2.3271e-06,
                    2.4092e-06,
                    2.4858e-06,
                    2.5429e-06,
                    2.6134e-06,
                    2.6628e-06,
                    2.8118e-06,
                    2.9128e-06,
                    3.017e-06,
                    3.0894e-06,
                    3.2008e-06,
                    3.2618e-06,
                    3.3109e-06,
                    3.3564e-06,
                    3.4046e-06,
                    3.4462e-06,
                    3.4933e-06,
                    3.5381e-06,
                    3.6087e-06,
                    3.6591e-06,
                    3.71e-06,
                    3.7567e-06,
                    3.8126e-06,
                    3.8775e-06,
                    3.9459e-06,
                    4.01e-06,
                    4.0734e-06,
                    4.1379e-06,
                    4.2017e-06,
                    4.2675e-06,
                    4.3278e-06
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.65e-09,
                    3.3e-09,
                    4.95e-09,
                    6.6e-09,
                    8.25e-09,
                    1.155e-08,
                    1.65e-08,
                    1.98e-08,
                    2.31e-08,
                    2.805e-08,
                    3.3e-08,
                    3.795e-08,
                    4.125e-08,
                    4.62e-08,
                    5.115e-08,
                    5.61e-08,
                    6.105e-08,
                    6.765e-08,
                    7.425e-08,
                    8.085e-08,
                    8.58e-08,
                    9.075e-08,
                    9.735e-08,
                    1.056e-07,
                    1.1385e-07,
                    1.2705e-07,
                    1.4025e-07,
                    1.551e-07,
                    1.6995e-07,
                    1.881e-07,
                    2.079e-07,
                    2.2935e-07,
                    2.541e-07,
                    2.772e-07,
                    3.0195e-07,
                    3.2505e-07,
                    3.4815e-07,
                    3.696e-07,
                    3.9105e-07,
                    4.125e-07,
                    4.3395e-07,
                    4.554e-07,
                    4.7685e-07,
                    4.983e-07,
                    5.1975e-07,
                    5.412e-07,
                    5.6265e-07,
                    5.841e-07,
                    6.0555e-07,
                    6.27e-07,
                    6.501e-07,
                    6.765e-07,
                    7.062e-07,
                    7.392e-07,
                    7.7385e-07,
                    8.118e-07,
                    8.4975e-07,
                    8.877e-07,
                    9.2895e-07,
                    9.7515e-07,
                    1.0197e-06,
                    1.0692e-06,
                    1.1187e-06,
                    1.1764e-06,
                    1.2375e-06,
                    1.3051e-06,
                    1.3678e-06,
                    1.4306e-06,
                    1.4949e-06,
                    1.5576e-06,
                    1.6232e-06,
                    1.6828e-06
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [
                    8.1895e-09,
                    1.7545e-08,
                    2.5514e-08,
                    3.4116e-08,
                    4.2482e-08,
                    5.1469e-08,
                    5.9873e-08,
                    6.919e-08,
                    7.6874e-08,
                    8.597e-08,
                    9.5948e-08,
                    1.0804e-07,
                    1.1606e-07,
                    1.2476e-07,
                    1.3468e-07,
                    1.4437e-07,
                    1.5473e-07,
                    1.6356e-07,
                    1.7265e-07,
                    1.8311e-07,
                    1.9345e-07,
                    2.0389e-07,
                    2.1462e-07,
                    2.2514e-07,
                    2.3577e-07,
                    2.4906e-07,
                    2.6162e-07,
                    2.7424e-07,
                    2.841e-07,
                    2.954e-07,
                    3.0688e-07,
                    3.1878e-07,
                    3.3054e-07,
                    3.4095e-07,
                    3.5106e-07,
                    3.6136e-07,
                    3.7274e-07,
                    3.8554e-07,
                    3.975e-07,
                    4.1073e-07,
                    4.2519e-07,
                    4.3661e-07,
                    4.5114e-07,
                    4.6499e-07,
                    4.7849e-07,
                    4.9215e-07,
                    5.055e-07,
                    5.1933e-07,
                    5.332e-07,
                    5.479e-07,
                    5.6282e-07,
                    5.7783e-07,
                    5.9293e-07,
                    6.0809e-07,
                    6.2334e-07,
                    6.3861e-07,
                    6.5397e-07,
                    6.6934e-07,
                    6.8478e-07,
                    7.0068e-07,
                    7.1681e-07,
                    7.3315e-07,
                    7.495e-07,
                    7.6596e-07,
                    7.8248e-07,
                    7.9904e-07,
                    8.1567e-07,
                    8.3239e-07,
                    8.4909e-07,
                    8.6694e-07,
                    8.8504e-07,
                    9.0326e-07,
                    9.2161e-07,
                    9.4003e-07,
                    9.5855e-07,
                    9.7712e-07,
                    9.9576e-07,
                    1.0145e-06,
                    1.0333e-06,
                    1.0519e-06,
                    1.0705e-06,
                    1.0867e-06,
                    1.103e-06,
                    1.1195e-06,
                    1.1361e-06,
                    1.1527e-06,
                    1.1694e-06,
                    1.1861e-06,
                    1.2029e-06,
                    1.2142e-06,
                    1.2231e-06,
                    1.2307e-06,
                    1.2373e-06,
                    1.2434e-06,
                    1.2489e-06,
                    1.254e-06,
                    1.2586e-06,
                    1.2628e-06,
                    1.2668e-06,
                    1.2743e-06,
                    1.276e-06,
                    1.2744e-06,
                    1.2734e-06,
                    1.2773e-06,
                    1.2902e-06,
                    1.3073e-06,
                    1.3297e-06,
                    1.35e-06,
                    1.3656e-06,
                    1.3755e-06,
                    1.3836e-06,
                    1.3902e-06,
                    1.3952e-06,
                    1.4208e-06,
                    1.4349e-06,
                    1.4436e-06,
                    1.4514e-06,
                    1.458e-06,
                    1.4642e-06,
                    1.4928e-06,
                    1.5071e-06,
                    1.5166e-06,
                    1.5245e-06,
                    1.5316e-06,
                    1.5379e-06,
                    1.556e-06,
                    1.567e-06,
                    1.5749e-06,
                    1.5819e-06,
                    1.5878e-06,
                    1.5939e-06,
                    1.5993e-06,
                    1.605e-06,
                    1.6326e-06,
                    1.6476e-06,
                    1.6584e-06,
                    1.6675e-06,
                    1.7635e-06,
                    1.8089e-06,
                    1.836e-06,
                    1.8552e-06,
                    1.8717e-06,
                    1.9323e-06,
                    1.9875e-06,
                    2.0232e-06,
                    2.0722e-06,
                    2.1002e-06,
                    2.2277e-06,
                    2.3072e-06,
                    2.39e-06,
                    2.4393e-06,
                    2.5243e-06,
                    2.5556e-06,
                    2.5717e-06,
                    2.5825e-06,
                    2.5928e-06,
                    2.5965e-06,
                    2.6056e-06,
                    2.6091e-06,
                    2.6335e-06,
                    2.6394e-06,
                    2.6408e-06,
                    2.638e-06,
                    2.6361e-06,
                    2.64e-06,
                    2.6407e-06,
                    2.6421e-06,
                    2.6429e-06,
                    2.643e-06,
                    2.6441e-06,
                    2.6442e-06,
                    2.645e-06
                ],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [
                    2.0247e-09,
                    4.0709e-09,
                    6.1385e-09,
                    8.2276e-09,
                    1.0338e-08,
                    1.247e-08,
                    1.4624e-08,
                    1.6799e-08,
                    1.8995e-08,
                    2.1213e-08,
                    2.3455e-08,
                    2.572e-08,
                    2.801e-08,
                    3.0323e-08,
                    3.266e-08,
                    3.5022e-08,
                    3.7407e-08,
                    3.9815e-08,
                    4.2248e-08,
                    4.4705e-08,
                    4.7194e-08,
                    4.9709e-08,
                    5.225e-08,
                    5.4818e-08,
                    5.7412e-08,
                    6.0033e-08,
                    6.2679e-08,
                    6.5352e-08,
                    6.8052e-08,
                    7.0778e-08,
                    7.3533e-08,
                    7.6317e-08,
                    7.913e-08,
                    8.1973e-08,
                    8.4845e-08,
                    8.7746e-08,
                    9.0676e-08,
                    9.3636e-08,
                    9.6624e-08,
                    9.9642e-08,
                    1.0269e-07,
                    1.0577e-07,
                    1.0888e-07,
                    1.1202e-07,
                    1.152e-07,
                    1.184e-07,
                    1.2165e-07,
                    1.2492e-07,
                    1.2823e-07,
                    1.3156e-07,
                    1.3501e-07,
                    1.3856e-07,
                    1.4221e-07,
                    1.4598e-07,
                    1.4985e-07,
                    1.5383e-07,
                    1.5793e-07,
                    1.6215e-07,
                    1.6648e-07,
                    1.7092e-07,
                    1.7549e-07,
                    1.8019e-07,
                    1.8502e-07,
                    1.8997e-07,
                    1.9506e-07,
                    2.003e-07,
                    2.0568e-07,
                    2.1121e-07,
                    2.1689e-07,
                    2.2273e-07,
                    2.2872e-07,
                    2.3487e-07,
                    2.4119e-07,
                    2.477e-07,
                    2.5439e-07,
                    2.6128e-07,
                    2.6838e-07,
                    2.7569e-07,
                    2.8322e-07,
                    2.9099e-07,
                    2.9898e-07,
                    3.0719e-07,
                    3.1564e-07,
                    3.2434e-07,
                    3.333e-07,
                    3.4269e-07,
                    3.5253e-07,
                    3.6294e-07,
                    3.7386e-07,
                    3.853e-07,
                    3.9706e-07,
                    4.0915e-07,
                    4.2157e-07,
                    4.3431e-07,
                    4.4733e-07,
                    4.6062e-07,
                    4.7416e-07,
                    4.879e-07,
                    5.0184e-07,
                    5.1596e-07,
                    5.3036e-07,
                    5.4442e-07,
                    5.5827e-07,
                    5.7211e-07,
                    5.8621e-07,
                    6.0124e-07,
                    6.1739e-07,
                    6.3334e-07,
                    6.4965e-07,
                    6.6669e-07,
                    6.8291e-07,
                    6.9839e-07,
                    7.115e-07,
                    7.2339e-07,
                    7.3378e-07,
                    7.4324e-07,
                    7.5362e-07,
                    7.6471e-07,
                    7.7544e-07,
                    7.8644e-07,
                    7.9725e-07,
                    8.0794e-07,
                    8.1962e-07,
                    8.3127e-07,
                    8.4383e-07,
                    8.5679e-07,
                    8.6919e-07,
                    8.8271e-07,
                    8.9634e-07,
                    9.0974e-07,
                    9.2656e-07,
                    9.4403e-07,
                    9.6499e-07,
                    9.8866e-07,
                    1.0145e-06,
                    1.042e-06,
                    1.0703e-06,
                    1.099e-06,
                    1.1292e-06,
                    1.1693e-06,
                    1.2117e-06,
                    1.2558e-06,
                    1.3002e-06,
                    1.3464e-06,
                    1.394e-06,
                    1.4414e-06,
                    1.4898e-06,
                    1.5385e-06,
                    1.5908e-06,
                    1.6447e-06,
                    1.6973e-06,
                    1.7528e-06,
                    1.8101e-06,
                    1.8675e-06,
                    1.9266e-06,
                    1.9859e-06,
                    2.0458e-06,
                    2.1064e-06,
                    2.1686e-06,
                    2.2235e-06,
                    2.2788e-06,
                    2.3336e-06,
                    2.3908e-06,
                    2.4505e-06,
                    2.5118e-06,
                    2.5752e-06,
                    2.6402e-06,
                    2.7062e-06,
                    2.7709e-06,
                    2.8369e-06,
                    2.9046e-06,
                    2.9716e-06
                ],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [
                    1.4853e-09,
                    2.9864e-09,
                    4.5033e-09,
                    6.0359e-09,
                    7.5842e-09,
                    9.1484e-09,
                    1.0728e-08,
                    1.2324e-08,
                    1.3935e-08,
                    1.5563e-08,
                    1.7207e-08,
                    1.887e-08,
                    2.055e-08,
                    2.2247e-08,
                    2.3962e-08,
                    2.5694e-08,
                    2.7444e-08,
                    2.9212e-08,
                    3.0997e-08,
                    3.28e-08,
                    3.4627e-08,
                    3.6475e-08,
                    3.8341e-08,
                    4.0227e-08,
                    4.2132e-08,
                    4.4056e-08,
                    4.6e-08,
                    4.7962e-08,
                    4.9945e-08,
                    5.1946e-08,
                    5.3969e-08,
                    5.6013e-08,
                    5.8079e-08,
                    6.0166e-08,
                    6.2275e-08,
                    6.4405e-08,
                    6.6557e-08,
                    6.8729e-08,
                    7.0924e-08,
                    7.3139e-08,
                    7.5374e-08,
                    7.7633e-08,
                    7.9915e-08,
                    8.2221e-08,
                    8.4552e-08,
                    8.6906e-08,
                    8.9284e-08,
                    9.1686e-08,
                    9.4112e-08,
                    9.6562e-08,
                    9.9107e-08,
                    1.0175e-07,
                    1.0449e-07,
                    1.0733e-07,
                    1.1026e-07,
                    1.1331e-07,
                    1.1645e-07,
                    1.197e-07,
                    1.2306e-07,
                    1.2652e-07,
                    1.301e-07,
                    1.338e-07,
                    1.3761e-07,
                    1.4154e-07,
                    1.456e-07,
                    1.498e-07,
                    1.5412e-07,
                    1.5859e-07,
                    1.632e-07,
                    1.6795e-07,
                    1.7284e-07,
                    1.7789e-07,
                    1.8309e-07,
                    1.8846e-07,
                    1.9401e-07,
                    1.9975e-07,
                    2.0568e-07,
                    2.1181e-07,
                    2.1816e-07,
                    2.2472e-07,
                    2.315e-07,
                    2.385e-07,
                    2.4573e-07,
                    2.5321e-07,
                    2.6093e-07,
                    2.689e-07,
                    2.7714e-07,
                    2.8575e-07,
                    2.9468e-07,
                    3.0393e-07,
                    3.1337e-07,
                    3.23e-07,
                    3.3281e-07,
                    3.4282e-07,
                    3.5297e-07,
                    3.6325e-07,
                    3.7365e-07,
                    3.8413e-07,
                    3.9466e-07,
                    4.0523e-07,
                    4.1606e-07,
                    4.2651e-07,
                    4.3667e-07,
                    4.4668e-07,
                    4.5672e-07,
                    4.6757e-07,
                    4.7937e-07,
                    4.9079e-07,
                    5.0239e-07,
                    5.1462e-07,
                    5.265e-07,
                    5.3771e-07,
                    5.475e-07,
                    5.5728e-07,
                    5.6667e-07,
                    5.7597e-07,
                    5.854e-07,
                    5.9575e-07,
                    6.0635e-07,
                    6.1761e-07,
                    6.292e-07,
                    6.4192e-07,
                    6.5524e-07,
                    6.6916e-07,
                    6.8401e-07,
                    6.9881e-07,
                    7.1345e-07,
                    7.294e-07,
                    7.457e-07,
                    7.6188e-07,
                    7.809e-07,
                    8.0039e-07,
                    8.2241e-07,
                    8.4594e-07,
                    8.7049e-07,
                    8.9603e-07,
                    9.2299e-07,
                    9.5031e-07,
                    9.7846e-07,
                    1.0161e-06,
                    1.0554e-06,
                    1.095e-06,
                    1.1355e-06,
                    1.1771e-06,
                    1.2202e-06,
                    1.2637e-06,
                    1.3079e-06,
                    1.3527e-06,
                    1.4011e-06,
                    1.4508e-06,
                    1.4993e-06,
                    1.5502e-06,
                    1.6026e-06,
                    1.6566e-06,
                    1.7133e-06,
                    1.7712e-06,
                    1.8299e-06,
                    1.89e-06,
                    1.9516e-06,
                    2.0068e-06,
                    2.0631e-06,
                    2.1186e-06,
                    2.176e-06,
                    2.2356e-06,
                    2.2971e-06,
                    2.3605e-06,
                    2.4249e-06,
                    2.4905e-06,
                    2.555e-06,
                    2.621e-06,
                    2.6883e-06,
                    2.7551e-06
                ],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [
                    5.3937e-10,
                    1.0844e-09,
                    1.6352e-09,
                    2.1917e-09,
                    2.7539e-09,
                    3.3217e-09,
                    3.8953e-09,
                    4.4746e-09,
                    5.0596e-09,
                    5.6503e-09,
                    6.2473e-09,
                    6.8506e-09,
                    7.4603e-09,
                    8.0763e-09,
                    8.6986e-09,
                    9.3273e-09,
                    9.9623e-09,
                    1.0604e-08,
                    1.1251e-08,
                    1.1905e-08,
                    1.2566e-08,
                    1.3234e-08,
                    1.3909e-08,
                    1.4591e-08,
                    1.5281e-08,
                    1.5977e-08,
                    1.668e-08,
                    1.739e-08,
                    1.8107e-08,
                    1.8831e-08,
                    1.9564e-08,
                    2.0303e-08,
                    2.1051e-08,
                    2.1806e-08,
                    2.257e-08,
                    2.3341e-08,
                    2.412e-08,
                    2.4906e-08,
                    2.5701e-08,
                    2.6503e-08,
                    2.7314e-08,
                    2.8134e-08,
                    2.8962e-08,
                    2.9799e-08,
                    3.0644e-08,
                    3.1498e-08,
                    3.2361e-08,
                    3.3233e-08,
                    3.4113e-08,
                    3.5002e-08,
                    3.59e-08,
                    3.6807e-08,
                    3.7724e-08,
                    3.865e-08,
                    3.9585e-08,
                    4.0529e-08,
                    4.1483e-08,
                    4.2445e-08,
                    4.3417e-08,
                    4.4399e-08,
                    4.539e-08,
                    4.6392e-08,
                    4.7404e-08,
                    4.8426e-08,
                    4.9459e-08,
                    5.0502e-08,
                    5.1555e-08,
                    5.2619e-08,
                    5.3693e-08,
                    5.4777e-08,
                    5.5873e-08,
                    5.6981e-08,
                    5.8101e-08,
                    5.9232e-08,
                    6.0375e-08,
                    6.1531e-08,
                    6.2698e-08,
                    6.3876e-08,
                    6.5067e-08,
                    6.627e-08,
                    6.7478e-08,
                    6.8692e-08,
                    6.9912e-08,
                    7.1137e-08,
                    7.2368e-08,
                    7.3785e-08,
                    7.539e-08,
                    7.7187e-08,
                    7.918e-08,
                    8.137e-08,
                    8.3696e-08,
                    8.6159e-08,
                    8.8757e-08,
                    9.1491e-08,
                    9.436e-08,
                    9.7364e-08,
                    1.005e-07,
                    1.0378e-07,
                    1.0719e-07,
                    1.1073e-07,
                    1.143e-07,
                    1.1791e-07,
                    1.216e-07,
                    1.2544e-07,
                    1.2949e-07,
                    1.3367e-07,
                    1.3802e-07,
                    1.4256e-07,
                    1.4726e-07,
                    1.5206e-07,
                    1.5641e-07,
                    1.6068e-07,
                    1.64e-07,
                    1.6611e-07,
                    1.6711e-07,
                    1.6727e-07,
                    1.6822e-07,
                    1.6897e-07,
                    1.6909e-07,
                    1.6882e-07,
                    1.6805e-07,
                    1.6602e-07,
                    1.6438e-07,
                    1.6211e-07,
                    1.5982e-07,
                    1.5798e-07,
                    1.5574e-07,
                    1.5331e-07,
                    1.5064e-07,
                    1.4786e-07,
                    1.4566e-07,
                    1.4364e-07,
                    1.4258e-07,
                    1.4272e-07,
                    1.4398e-07,
                    1.4601e-07,
                    1.4729e-07,
                    1.4874e-07,
                    1.5077e-07,
                    1.532e-07,
                    1.5628e-07,
                    1.6074e-07,
                    1.6469e-07,
                    1.6924e-07,
                    1.7374e-07,
                    1.7772e-07,
                    1.8185e-07,
                    1.8579e-07,
                    1.8975e-07,
                    1.939e-07,
                    1.9805e-07,
                    2.0263e-07,
                    2.0755e-07,
                    2.1089e-07,
                    2.1336e-07,
                    2.1468e-07,
                    2.1588e-07,
                    2.1643e-07,
                    2.1696e-07,
                    2.1666e-07,
                    2.1577e-07,
                    2.15e-07,
                    2.1484e-07,
                    2.1487e-07,
                    2.146e-07,
                    2.147e-07,
                    2.1527e-07,
                    2.157e-07,
                    2.1596e-07,
                    2.1595e-07,
                    2.1636e-07,
                    2.165e-07
                ],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [
                    2.2363e-10,
                    4.5077e-10,
                    6.8133e-10,
                    9.1514e-10,
                    1.152e-09,
                    1.3917e-09,
                    1.6339e-09,
                    1.8784e-09,
                    2.1247e-09,
                    2.3724e-09,
                    2.6213e-09,
                    2.8713e-09,
                    3.1224e-09,
                    3.3745e-09,
                    3.6277e-09,
                    3.8819e-09,
                    4.1371e-09,
                    4.3934e-09,
                    4.6508e-09,
                    4.9094e-09,
                    5.1714e-09,
                    5.4406e-09,
                    5.7198e-09,
                    6.011e-09,
                    6.3154e-09,
                    6.6332e-09,
                    6.9638e-09,
                    7.3059e-09,
                    7.657e-09,
                    8.014e-09,
                    8.3748e-09,
                    8.7388e-09,
                    9.1057e-09,
                    9.4753e-09,
                    9.8473e-09,
                    1.0222e-08,
                    1.0598e-08,
                    1.0978e-08,
                    1.136e-08,
                    1.1756e-08,
                    1.2158e-08,
                    1.2563e-08,
                    1.2973e-08,
                    1.3388e-08,
                    1.3808e-08,
                    1.4233e-08,
                    1.4663e-08,
                    1.5098e-08,
                    1.5539e-08,
                    1.5986e-08,
                    1.6439e-08,
                    1.6898e-08,
                    1.7363e-08,
                    1.7835e-08,
                    1.8314e-08,
                    1.8799e-08,
                    1.9293e-08,
                    1.9794e-08,
                    2.0302e-08,
                    2.0819e-08,
                    2.1346e-08,
                    2.1887e-08,
                    2.2444e-08,
                    2.302e-08,
                    2.3616e-08,
                    2.4234e-08,
                    2.4874e-08,
                    2.5535e-08,
                    2.6218e-08,
                    2.692e-08,
                    2.7642e-08,
                    2.8385e-08,
                    2.9152e-08,
                    2.9943e-08,
                    3.0756e-08,
                    3.1591e-08,
                    3.2445e-08,
                    3.3315e-08,
                    3.4197e-08,
                    3.5085e-08,
                    3.5975e-08,
                    3.6864e-08,
                    3.7748e-08,
                    3.8626e-08,
                    3.9499e-08,
                    4.0365e-08,
                    4.1227e-08,
                    4.2086e-08,
                    4.2946e-08,
                    4.3811e-08,
                    4.4736e-08,
                    4.5809e-08,
                    4.7099e-08,
                    4.865e-08,
                    5.0486e-08,
                    5.2608e-08,
                    5.4996e-08,
                    5.7606e-08,
                    6.0373e-08,
                    6.3211e-08,
                    6.6044e-08,
                    6.883e-08,
                    7.1535e-08,
                    7.414e-08,
                    7.6633e-08,
                    7.9015e-08,
                    8.1295e-08,
                    8.3496e-08,
                    8.5648e-08,
                    8.7795e-08,
                    9.0077e-08,
                    9.2443e-08,
                    9.4747e-08,
                    9.6865e-08,
                    9.8921e-08,
                    1.0089e-07,
                    1.0299e-07,
                    1.0507e-07,
                    1.0711e-07,
                    1.0921e-07,
                    1.1124e-07,
                    1.1316e-07,
                    1.1522e-07,
                    1.171e-07,
                    1.1924e-07,
                    1.2175e-07,
                    1.2409e-07,
                    1.2644e-07,
                    1.2876e-07,
                    1.3109e-07,
                    1.336e-07,
                    1.3615e-07,
                    1.3879e-07,
                    1.4156e-07,
                    1.4433e-07,
                    1.4718e-07,
                    1.5015e-07,
                    1.5317e-07,
                    1.5626e-07,
                    1.5955e-07,
                    1.6315e-07,
                    1.6682e-07,
                    1.7034e-07,
                    1.7409e-07,
                    1.7793e-07,
                    1.8184e-07,
                    1.8579e-07,
                    1.8976e-07,
                    1.9388e-07,
                    1.9817e-07,
                    2.0272e-07,
                    2.0781e-07,
                    2.1321e-07,
                    2.1894e-07,
                    2.248e-07,
                    2.3077e-07,
                    2.3702e-07,
                    2.4365e-07,
                    2.5065e-07,
                    2.5768e-07,
                    2.6495e-07,
                    2.7244e-07,
                    2.8039e-07,
                    2.8858e-07,
                    2.9705e-07,
                    3.0563e-07,
                    3.1488e-07,
                    3.2392e-07,
                    3.3308e-07,
                    3.4243e-07,
                    3.5223e-07,
                    3.6214e-07
                ],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [
                    1.2365e-10,
                    2.4883e-10,
                    3.755e-10,
                    5.0363e-10,
                    6.3317e-10,
                    7.6408e-10,
                    8.9629e-10,
                    1.0297e-09,
                    1.1643e-09,
                    1.2999e-09,
                    1.4365e-09,
                    1.5741e-09,
                    1.7126e-09,
                    1.8522e-09,
                    1.9926e-09,
                    2.134e-09,
                    2.2764e-09,
                    2.4197e-09,
                    2.5641e-09,
                    2.7094e-09,
                    2.8562e-09,
                    3.0053e-09,
                    3.1575e-09,
                    3.3131e-09,
                    3.4723e-09,
                    3.6354e-09,
                    3.8021e-09,
                    3.9721e-09,
                    4.1449e-09,
                    4.3198e-09,
                    4.4962e-09,
                    4.6741e-09,
                    4.8533e-09,
                    5.0339e-09,
                    5.2158e-09,
                    5.3989e-09,
                    5.5832e-09,
                    5.7689e-09,
                    5.9559e-09,
                    6.1478e-09,
                    6.3419e-09,
                    6.5383e-09,
                    6.7372e-09,
                    6.9386e-09,
                    7.1426e-09,
                    7.3493e-09,
                    7.5588e-09,
                    7.7711e-09,
                    7.9864e-09,
                    8.2047e-09,
                    8.4262e-09,
                    8.6514e-09,
                    8.8806e-09,
                    9.1138e-09,
                    9.3512e-09,
                    9.5927e-09,
                    9.8383e-09,
                    1.0088e-08,
                    1.0341e-08,
                    1.0597e-08,
                    1.0856e-08,
                    1.1118e-08,
                    1.1382e-08,
                    1.1649e-08,
                    1.1919e-08,
                    1.219e-08,
                    1.2465e-08,
                    1.2741e-08,
                    1.3021e-08,
                    1.3303e-08,
                    1.3587e-08,
                    1.3874e-08,
                    1.4164e-08,
                    1.4457e-08,
                    1.4752e-08,
                    1.505e-08,
                    1.535e-08,
                    1.5654e-08,
                    1.596e-08,
                    1.627e-08,
                    1.6584e-08,
                    1.6901e-08,
                    1.7224e-08,
                    1.7552e-08,
                    1.7886e-08,
                    1.8225e-08,
                    1.8571e-08,
                    1.8924e-08,
                    1.9283e-08,
                    1.9649e-08,
                    2.0023e-08,
                    2.0407e-08,
                    2.0803e-08,
                    2.1212e-08,
                    2.1635e-08,
                    2.2072e-08,
                    2.2525e-08,
                    2.2991e-08,
                    2.3472e-08,
                    2.3965e-08,
                    2.4471e-08,
                    2.4991e-08,
                    2.5526e-08,
                    2.6077e-08,
                    2.6643e-08,
                    2.7225e-08,
                    2.7821e-08,
                    2.8432e-08,
                    2.9057e-08,
                    2.9693e-08,
                    3.0339e-08,
                    3.0997e-08,
                    3.1666e-08,
                    3.2345e-08,
                    3.3037e-08,
                    3.3741e-08,
                    3.4459e-08,
                    3.5191e-08,
                    3.5939e-08,
                    3.6799e-08,
                    3.7663e-08,
                    3.8552e-08,
                    3.9437e-08,
                    4.0312e-08,
                    4.122e-08,
                    4.2193e-08,
                    4.3216e-08,
                    4.429e-08,
                    4.5391e-08,
                    4.6544e-08,
                    4.7764e-08,
                    4.8976e-08,
                    5.0249e-08,
                    5.1624e-08,
                    5.2977e-08,
                    5.4346e-08,
                    5.5807e-08,
                    5.7277e-08,
                    5.8789e-08,
                    6.0475e-08,
                    6.2299e-08,
                    6.4075e-08,
                    6.5829e-08,
                    6.7738e-08,
                    6.9714e-08,
                    7.1701e-08,
                    7.3684e-08,
                    7.5698e-08,
                    7.7812e-08,
                    7.9941e-08,
                    8.2093e-08,
                    8.4342e-08,
                    8.6707e-08,
                    8.9243e-08,
                    9.1904e-08,
                    9.4639e-08,
                    9.7448e-08,
                    1.0038e-07,
                    1.0345e-07,
                    1.0663e-07,
                    1.0993e-07,
                    1.132e-07,
                    1.1652e-07,
                    1.199e-07,
                    1.2347e-07,
                    1.272e-07,
                    1.31e-07,
                    1.3487e-07,
                    1.3884e-07,
                    1.4289e-07,
                    1.4706e-07,
                    1.5114e-07
                ],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": [
                    9.9973e-11,
                    2.0195e-10,
                    3.0583e-10,
                    4.1151e-10,
                    5.1884e-10,
                    6.2762e-10,
                    7.3764e-10,
                    8.4865e-10,
                    9.6037e-10,
                    1.0725e-09,
                    1.1848e-09,
                    1.2972e-09,
                    1.4098e-09,
                    1.5224e-09,
                    1.6351e-09,
                    1.7478e-09,
                    1.8607e-09,
                    1.9736e-09,
                    2.0867e-09,
                    2.2e-09,
                    2.3153e-09,
                    2.4353e-09,
                    2.5623e-09,
                    2.6979e-09,
                    2.843e-09,
                    2.9978e-09,
                    3.1617e-09,
                    3.3338e-09,
                    3.5121e-09,
                    3.6943e-09,
                    3.8786e-09,
                    4.0647e-09,
                    4.2524e-09,
                    4.4414e-09,
                    4.6315e-09,
                    4.8228e-09,
                    5.0152e-09,
                    5.2087e-09,
                    5.4036e-09,
                    5.6087e-09,
                    5.8158e-09,
                    6.0249e-09,
                    6.2361e-09,
                    6.4496e-09,
                    6.6653e-09,
                    6.8835e-09,
                    7.1041e-09,
                    7.3273e-09,
                    7.5531e-09,
                    7.7815e-09,
                    8.0126e-09,
                    8.2462e-09,
                    8.4823e-09,
                    8.721e-09,
                    8.9624e-09,
                    9.2067e-09,
                    9.4544e-09,
                    9.7059e-09,
                    9.9617e-09,
                    1.0222e-08,
                    1.049e-08,
                    1.0769e-08,
                    1.1062e-08,
                    1.1371e-08,
                    1.1698e-08,
                    1.2044e-08,
                    1.2409e-08,
                    1.2794e-08,
                    1.3197e-08,
                    1.3617e-08,
                    1.4054e-08,
                    1.4511e-08,
                    1.4988e-08,
                    1.5486e-08,
                    1.6005e-08,
                    1.6542e-08,
                    1.7095e-08,
                    1.7661e-08,
                    1.8236e-08,
                    1.8815e-08,
                    1.9391e-08,
                    1.9962e-08,
                    2.0524e-08,
                    2.1074e-08,
                    2.1613e-08,
                    2.214e-08,
                    2.2655e-08,
                    2.3162e-08,
                    2.3663e-08,
                    2.4162e-08,
                    2.4712e-08,
                    2.5402e-08,
                    2.6296e-08,
                    2.7438e-08,
                    2.8851e-08,
                    3.0536e-08,
                    3.2471e-08,
                    3.4614e-08,
                    3.6902e-08,
                    3.9246e-08,
                    4.1573e-08,
                    4.3838e-08,
                    4.6009e-08,
                    4.8063e-08,
                    4.999e-08,
                    5.179e-08,
                    5.3474e-08,
                    5.5063e-08,
                    5.6591e-08,
                    5.8102e-08,
                    5.9737e-08,
                    6.1446e-08,
                    6.3081e-08,
                    6.452e-08,
                    6.5884e-08,
                    6.7151e-08,
                    6.8527e-08,
                    6.988e-08,
                    7.1171e-08,
                    7.2412e-08,
                    7.358e-08,
                    7.4613e-08,
                    7.5781e-08,
                    7.6789e-08,
                    7.8018e-08,
                    7.9555e-08,
                    8.0871e-08,
                    8.2149e-08,
                    8.3366e-08,
                    8.4546e-08,
                    8.5837e-08,
                    8.7177e-08,
                    8.8542e-08,
                    8.9931e-08,
                    9.1357e-08,
                    9.2833e-08,
                    9.4345e-08,
                    9.5894e-08,
                    9.7467e-08,
                    9.9078e-08,
                    1.0085e-07,
                    1.0274e-07,
                    1.0451e-07,
                    1.0636e-07,
                    1.0821e-07,
                    1.1014e-07,
                    1.1211e-07,
                    1.1406e-07,
                    1.1607e-07,
                    1.1823e-07,
                    1.2063e-07,
                    1.2347e-07,
                    1.2651e-07,
                    1.297e-07,
                    1.329e-07,
                    1.3613e-07,
                    1.3957e-07,
                    1.4327e-07,
                    1.472e-07,
                    1.5104e-07,
                    1.5503e-07,
                    1.5923e-07,
                    1.6387e-07,
                    1.6867e-07,
                    1.7358e-07,
                    1.7844e-07,
                    1.8388e-07,
                    1.8906e-07,
                    1.9425e-07,
                    1.9953e-07,
                    2.0517e-07,
                    2.11e-07
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                6.46208,
                                0.24342
                            ],
                            [
                                6.47943,
                                0.14656
                            ],
                            [
                                6.55685,
                                0.03671
                            ],
                            [
                                6.74778,
                                0.24125
                            ],
                            [
                                6.75974,
                                0.29259
                            ],
                            [
                                6.68811,
                                0.40446
                            ],
                            [
                                6.61109,
                                0.40628
                            ],
                            [
                                6.49262,
                                0.3178
                            ],
                            [
                                6.46208,
                                0.24342
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                7.32867,
                                1.6004
                            ],
                            [
                                7.38279,
                                1.53737
                            ],
                            [
                                7.46134,
                                1.62554
                            ],
                            [
                                7.39453,
                                1.69229
                            ],
                            [
                                7.36325,
                                1.6054
                            ],
                            [
                                7.32867,
                                1.6004
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "SAU",
                "Country": "Saudi Arabia",
                "Total_3GHG": 0.79,
                "Total_3GHG_timeseries": [
                    -0.0000007172,
                    -0.0000013451,
                    -0.0000018942,
                    -0.0000023749,
                    -0.0000027966,
                    -0.0000031672,
                    -0.0000034935,
                    -0.0000037814,
                    -0.0000040361,
                    -0.0000042628,
                    -0.0000044649,
                    -0.0000046456,
                    -0.0000048075,
                    -0.000004953,
                    -0.000005084,
                    -0.0000052023,
                    -0.0000053095,
                    -0.0000054069,
                    -0.0000054956,
                    -0.0000055746,
                    -0.0000056483,
                    -0.0000057178,
                    -0.0000057828,
                    -0.0000058432,
                    -0.0000058986,
                    -0.0000059491,
                    -0.0000059947,
                    -0.0000060356,
                    -0.0000060721,
                    -0.0000061051,
                    -0.0000061356,
                    -0.000006164,
                    -0.00000619,
                    -0.0000062134,
                    -0.000006234,
                    -0.0000062517,
                    -0.0000062662,
                    -0.0000062776,
                    -0.0000062855,
                    -0.0000062906,
                    -0.0000062949,
                    -0.0000062983,
                    -0.0000063003,
                    -0.0000063009,
                    -0.0000062998,
                    -0.000006297,
                    -0.0000062922,
                    -0.0000062854,
                    -0.0000062765,
                    -0.0000062668,
                    -0.0000062726,
                    -0.0000062887,
                    -0.0000063127,
                    -0.0000063503,
                    -0.0000064,
                    -0.0000064622,
                    -0.0000065346,
                    -0.0000066212,
                    -0.0000067214,
                    -0.0000068327,
                    -0.0000069429,
                    -0.0000070532,
                    -0.0000071616,
                    -0.0000072726,
                    -0.0000073869,
                    -0.0000075034,
                    -0.0000076233,
                    -0.0000077474,
                    -0.000007878,
                    -0.0000080093,
                    -0.0000081526,
                    -0.0000083122,
                    -0.000008484,
                    -0.0000086667,
                    -0.0000088553,
                    -0.0000090492,
                    -0.0000092475,
                    -0.0000094477,
                    -0.0000096483,
                    -0.0000098524,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    -0.0000014152,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0006,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0014,
                    0.0015,
                    0.0017,
                    0.0019,
                    0.0021,
                    0.0022,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0028,
                    0.003,
                    0.0031,
                    0.0033,
                    0.0035,
                    0.0037,
                    0.0039,
                    0.0041,
                    0.0043,
                    0.0045,
                    0.0047,
                    0.0048,
                    0.005,
                    0.0051,
                    0.0053,
                    0.0054,
                    0.0057,
                    0.0059,
                    0.0062,
                    0.0065,
                    0.0068,
                    0.0071,
                    0.0074,
                    0.0077,
                    0.0081,
                    0.0084,
                    0.0087,
                    0.0091,
                    0.0095,
                    0.0099,
                    0.0103,
                    0.0108,
                    0.0112,
                    0.0117,
                    0.0121,
                    0.0125,
                    0.0129
                ],
                "Fossil_3GHG": 1.2,
                "Fossil_3GHG_timeseries": [
                    1.3724e-07,
                    2.7517e-07,
                    4.1379e-07,
                    5.5308e-07,
                    6.9303e-07,
                    8.3362e-07,
                    9.7483e-07,
                    1.1166e-06,
                    1.259e-06,
                    1.4019e-06,
                    1.5453e-06,
                    1.6891e-06,
                    1.8335e-06,
                    1.9784e-06,
                    2.1238e-06,
                    2.2696e-06,
                    2.416e-06,
                    2.5628e-06,
                    2.7101e-06,
                    2.858e-06,
                    3.0076e-06,
                    3.1594e-06,
                    3.3135e-06,
                    3.47e-06,
                    3.6292e-06,
                    3.791e-06,
                    3.9553e-06,
                    4.122e-06,
                    4.2911e-06,
                    4.4621e-06,
                    4.6353e-06,
                    4.8106e-06,
                    4.9881e-06,
                    5.1676e-06,
                    5.3492e-06,
                    5.5329e-06,
                    5.7187e-06,
                    5.9066e-06,
                    6.0965e-06,
                    6.2886e-06,
                    6.4818e-06,
                    6.6761e-06,
                    6.8716e-06,
                    7.0682e-06,
                    7.266e-06,
                    7.4649e-06,
                    7.665e-06,
                    7.8663e-06,
                    8.0688e-06,
                    8.2726e-06,
                    8.4644e-06,
                    8.6443e-06,
                    8.8124e-06,
                    8.9686e-06,
                    9.1129e-06,
                    9.2455e-06,
                    9.3662e-06,
                    9.475e-06,
                    9.5719e-06,
                    9.6568e-06,
                    9.7292e-06,
                    9.7888e-06,
                    9.8359e-06,
                    9.8703e-06,
                    9.8921e-06,
                    9.9012e-06,
                    9.8977e-06,
                    9.8816e-06,
                    9.8528e-06,
                    9.8114e-06,
                    9.7716e-06,
                    9.7334e-06,
                    9.6967e-06,
                    9.6615e-06,
                    9.6278e-06,
                    9.5955e-06,
                    9.5646e-06,
                    9.535e-06,
                    9.5067e-06,
                    9.4796e-06,
                    9.4546e-06,
                    9.4321e-06,
                    9.4123e-06,
                    9.3954e-06,
                    9.3816e-06,
                    9.4107e-06,
                    9.5424e-06,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0003,
                    0.0004,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0006,
                    0.0006,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0014,
                    0.0015,
                    0.0017,
                    0.0019,
                    0.0021,
                    0.0022,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0028,
                    0.0029,
                    0.0031,
                    0.0032,
                    0.0034,
                    0.0036,
                    0.0038,
                    0.004,
                    0.0042,
                    0.0044,
                    0.0046,
                    0.0047,
                    0.0049,
                    0.005,
                    0.0052,
                    0.0053,
                    0.0056,
                    0.0058,
                    0.0061,
                    0.0064,
                    0.0067,
                    0.007,
                    0.0073,
                    0.0076,
                    0.008,
                    0.0083,
                    0.0086,
                    0.009,
                    0.0094,
                    0.0098,
                    0.0102,
                    0.0106,
                    0.0111,
                    0.0115,
                    0.0119,
                    0.0123,
                    0.0127
                ],
                "Land_3GHG": 0.03,
                "Land_3GHG_timeseries": [
                    -0.00000085444,
                    -0.0000016203,
                    -0.000002308,
                    -0.000002928,
                    -0.0000034896,
                    -0.0000040008,
                    -0.0000044683,
                    -0.000004898,
                    -0.0000052951,
                    -0.0000056646,
                    -0.0000060102,
                    -0.0000063348,
                    -0.0000066411,
                    -0.0000069314,
                    -0.0000072077,
                    -0.0000074719,
                    -0.0000077255,
                    -0.0000079697,
                    -0.0000082057,
                    -0.0000084326,
                    -0.0000086559,
                    -0.0000088772,
                    -0.0000090963,
                    -0.0000093132,
                    -0.0000095278,
                    -0.0000097401,
                    -0.00000995,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    -0.0000086738,
                    -0.0000050151,
                    -0.0000010564,
                    3.0112e-06,
                    6.8296e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_CO2": 0.69,
                "Total_CO2_timeseries": [
                    -0.00000092886,
                    -0.0000017694,
                    -0.0000025321,
                    -0.0000032275,
                    -0.0000038647,
                    -0.0000044518,
                    -0.0000049954,
                    -0.0000055015,
                    -0.000005975,
                    -0.0000064213,
                    -0.0000068437,
                    -0.0000072453,
                    -0.0000076287,
                    -0.0000079963,
                    -0.0000083501,
                    -0.0000086919,
                    -0.0000090232,
                    -0.0000093452,
                    -0.0000096592,
                    -0.0000099643,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    4.9274e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0017,
                    0.0018,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0031,
                    0.0033,
                    0.0034,
                    0.0036,
                    0.0038,
                    0.004,
                    0.0042,
                    0.0045,
                    0.0047,
                    0.0049,
                    0.0052,
                    0.0055,
                    0.0058,
                    0.0061,
                    0.0064,
                    0.0067,
                    0.007,
                    0.0073,
                    0.0076,
                    0.0079
                ],
                "Fossil_CO2": 1.02,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    3.3e-09,
                    1.485e-08,
                    1.0725e-07,
                    8.514e-07,
                    1.8183e-06,
                    2.6334e-06,
                    3.4897e-06,
                    4.3873e-06,
                    5.8559e-06,
                    9.8241e-06,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0016,
                    0.0017,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.003,
                    0.0031,
                    0.0033,
                    0.0035,
                    0.0037,
                    0.0039,
                    0.0041,
                    0.0043,
                    0.0045,
                    0.0047,
                    0.005,
                    0.0052,
                    0.0055,
                    0.0058,
                    0.0061,
                    0.0064,
                    0.0067,
                    0.0071,
                    0.0073,
                    0.0076,
                    0.0079
                ],
                "Land_CO2": -0.01,
                "Land_CO2_timeseries": [
                    -0.00000092886,
                    -0.0000017694,
                    -0.0000025321,
                    -0.0000032275,
                    -0.0000038647,
                    -0.0000044518,
                    -0.0000049954,
                    -0.0000055015,
                    -0.000005975,
                    -0.0000064213,
                    -0.0000068437,
                    -0.0000072453,
                    -0.0000076287,
                    -0.0000079963,
                    -0.0000083501,
                    -0.0000086919,
                    -0.0000090232,
                    -0.0000093452,
                    -0.0000096592,
                    -0.0000099643,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_CH4": 1.16,
                "Total_CH4_timeseries": [
                    1.5929e-07,
                    3.1882e-07,
                    4.786e-07,
                    6.3863e-07,
                    7.989e-07,
                    9.5942e-07,
                    1.1202e-06,
                    1.2812e-06,
                    1.4424e-06,
                    1.6039e-06,
                    1.7657e-06,
                    1.9277e-06,
                    2.0899e-06,
                    2.2523e-06,
                    2.415e-06,
                    2.578e-06,
                    2.7412e-06,
                    2.9046e-06,
                    3.0683e-06,
                    3.2322e-06,
                    3.3982e-06,
                    3.5664e-06,
                    3.7368e-06,
                    3.9092e-06,
                    4.0838e-06,
                    4.2606e-06,
                    4.4394e-06,
                    4.6204e-06,
                    4.8036e-06,
                    4.9888e-06,
                    5.1768e-06,
                    5.3676e-06,
                    5.561e-06,
                    5.7572e-06,
                    5.9561e-06,
                    6.1578e-06,
                    6.3622e-06,
                    6.5693e-06,
                    6.7791e-06,
                    6.9917e-06,
                    7.2053e-06,
                    7.42e-06,
                    7.6357e-06,
                    7.8525e-06,
                    8.0704e-06,
                    8.2893e-06,
                    8.5093e-06,
                    8.7304e-06,
                    8.9525e-06,
                    9.1756e-06,
                    9.386e-06,
                    9.5836e-06,
                    9.7683e-06,
                    9.9402e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0003,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0006,
                    0.0005,
                    0.0005,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0048
                ],
                "Fossil_CH4": 1.82,
                "Fossil_CH4_timeseries": [
                    9.3746e-08,
                    1.8761e-07,
                    2.8158e-07,
                    3.7566e-07,
                    4.6986e-07,
                    5.6417e-07,
                    6.5859e-07,
                    7.5312e-07,
                    8.4776e-07,
                    9.4251e-07,
                    1.0374e-06,
                    1.1323e-06,
                    1.2274e-06,
                    1.3226e-06,
                    1.4179e-06,
                    1.5133e-06,
                    1.6087e-06,
                    1.7043e-06,
                    1.8e-06,
                    1.8958e-06,
                    1.9929e-06,
                    2.0912e-06,
                    2.1907e-06,
                    2.2914e-06,
                    2.3934e-06,
                    2.4966e-06,
                    2.6011e-06,
                    2.7068e-06,
                    2.8137e-06,
                    2.9218e-06,
                    3.0316e-06,
                    3.1429e-06,
                    3.2558e-06,
                    3.3702e-06,
                    3.4863e-06,
                    3.6039e-06,
                    3.7231e-06,
                    3.8439e-06,
                    3.9663e-06,
                    4.0902e-06,
                    4.2147e-06,
                    4.3398e-06,
                    4.4654e-06,
                    4.5916e-06,
                    4.7184e-06,
                    4.8458e-06,
                    4.9737e-06,
                    5.1022e-06,
                    5.2312e-06,
                    5.3609e-06,
                    5.4778e-06,
                    5.5821e-06,
                    5.6738e-06,
                    5.7527e-06,
                    5.8189e-06,
                    5.8724e-06,
                    5.9132e-06,
                    5.9411e-06,
                    5.9563e-06,
                    5.9586e-06,
                    5.9475e-06,
                    5.9229e-06,
                    5.8848e-06,
                    5.8332e-06,
                    5.7682e-06,
                    5.6896e-06,
                    5.5976e-06,
                    5.4921e-06,
                    5.3732e-06,
                    5.2407e-06,
                    5.109e-06,
                    4.9781e-06,
                    4.8478e-06,
                    4.7181e-06,
                    4.589e-06,
                    4.4604e-06,
                    4.3324e-06,
                    4.2049e-06,
                    4.0778e-06,
                    3.9511e-06,
                    3.8255e-06,
                    3.701e-06,
                    3.5775e-06,
                    3.455e-06,
                    3.3334e-06,
                    3.249e-06,
                    3.2566e-06,
                    4.1575e-06,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0003,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0005,
                    0.0005,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047
                ],
                "Land_CH4": 0.08,
                "Land_CH4_timeseries": [
                    6.5542e-08,
                    1.3122e-07,
                    1.9703e-07,
                    2.6297e-07,
                    3.2904e-07,
                    3.9525e-07,
                    4.6159e-07,
                    5.2807e-07,
                    5.9468e-07,
                    6.6142e-07,
                    7.283e-07,
                    7.9532e-07,
                    8.6247e-07,
                    9.2976e-07,
                    9.9718e-07,
                    1.0647e-06,
                    1.1324e-06,
                    1.2003e-06,
                    1.2682e-06,
                    1.3363e-06,
                    1.4054e-06,
                    1.4753e-06,
                    1.5461e-06,
                    1.6178e-06,
                    1.6904e-06,
                    1.7639e-06,
                    1.8383e-06,
                    1.9136e-06,
                    1.9899e-06,
                    2.067e-06,
                    2.1453e-06,
                    2.2247e-06,
                    2.3053e-06,
                    2.387e-06,
                    2.4699e-06,
                    2.5539e-06,
                    2.639e-06,
                    2.7254e-06,
                    2.8128e-06,
                    2.9015e-06,
                    2.9906e-06,
                    3.0802e-06,
                    3.1703e-06,
                    3.2609e-06,
                    3.352e-06,
                    3.4435e-06,
                    3.5356e-06,
                    3.6282e-06,
                    3.7212e-06,
                    3.8148e-06,
                    3.9082e-06,
                    4.0014e-06,
                    4.0945e-06,
                    4.1875e-06,
                    4.2803e-06,
                    4.373e-06,
                    4.4655e-06,
                    4.5579e-06,
                    4.6501e-06,
                    4.7422e-06,
                    4.8337e-06,
                    4.9245e-06,
                    5.0147e-06,
                    5.1042e-06,
                    5.1931e-06,
                    5.2814e-06,
                    5.369e-06,
                    5.4559e-06,
                    5.5423e-06,
                    5.628e-06,
                    5.7154e-06,
                    5.8046e-06,
                    5.8956e-06,
                    5.9883e-06,
                    6.0828e-06,
                    6.179e-06,
                    6.277e-06,
                    6.3767e-06,
                    6.4782e-06,
                    6.5814e-06,
                    6.687e-06,
                    6.795e-06,
                    6.9053e-06,
                    7.0181e-06,
                    7.1331e-06,
                    7.2433e-06,
                    7.3486e-06,
                    7.4488e-06,
                    7.544e-06,
                    7.634e-06,
                    7.717e-06,
                    7.7931e-06,
                    7.8622e-06,
                    7.9241e-06,
                    7.9789e-06,
                    8.0263e-06,
                    8.0665e-06,
                    8.0992e-06,
                    8.1244e-06,
                    8.1421e-06,
                    8.1679e-06,
                    8.2031e-06,
                    8.2487e-06,
                    8.3047e-06,
                    8.3711e-06,
                    8.4546e-06,
                    8.5556e-06,
                    8.6748e-06,
                    8.8135e-06,
                    8.9734e-06,
                    9.4156e-06,
                    9.8858e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_N2O": 0.2,
                "Total_N2O_timeseries": [
                    5.237e-08,
                    1.055e-07,
                    1.5937e-07,
                    2.1397e-07,
                    2.6925e-07,
                    3.252e-07,
                    3.8176e-07,
                    4.3888e-07,
                    4.9652e-07,
                    5.5461e-07,
                    6.1311e-07,
                    6.7202e-07,
                    7.3132e-07,
                    7.9102e-07,
                    8.5111e-07,
                    9.1159e-07,
                    9.7246e-07,
                    1.0337e-06,
                    1.0954e-06,
                    1.1575e-06,
                    1.2203e-06,
                    1.2845e-06,
                    1.3503e-06,
                    1.4182e-06,
                    1.4883e-06,
                    1.5606e-06,
                    1.635e-06,
                    1.7113e-06,
                    1.7893e-06,
                    1.8683e-06,
                    1.9482e-06,
                    2.0287e-06,
                    2.11e-06,
                    2.1918e-06,
                    2.2743e-06,
                    2.3573e-06,
                    2.441e-06,
                    2.5252e-06,
                    2.6101e-06,
                    2.6964e-06,
                    2.7832e-06,
                    2.8707e-06,
                    2.9588e-06,
                    3.0475e-06,
                    3.1368e-06,
                    3.2269e-06,
                    3.3176e-06,
                    3.409e-06,
                    3.5012e-06,
                    3.5941e-06,
                    3.6879e-06,
                    3.7825e-06,
                    3.8781e-06,
                    3.9747e-06,
                    4.0724e-06,
                    4.1711e-06,
                    4.271e-06,
                    4.3719e-06,
                    4.4738e-06,
                    4.5769e-06,
                    4.6809e-06,
                    4.7859e-06,
                    4.8919e-06,
                    4.9989e-06,
                    5.1069e-06,
                    5.2159e-06,
                    5.3259e-06,
                    5.437e-06,
                    5.5492e-06,
                    5.6625e-06,
                    5.7773e-06,
                    5.8939e-06,
                    6.0128e-06,
                    6.1341e-06,
                    6.2582e-06,
                    6.385e-06,
                    6.5145e-06,
                    6.6467e-06,
                    6.7815e-06,
                    6.9185e-06,
                    7.0578e-06,
                    7.1996e-06,
                    7.3443e-06,
                    7.4921e-06,
                    7.6431e-06,
                    7.7976e-06,
                    7.9555e-06,
                    8.1169e-06,
                    8.2819e-06,
                    8.4505e-06,
                    8.624e-06,
                    8.8048e-06,
                    8.995e-06,
                    9.1958e-06,
                    9.4079e-06,
                    9.6315e-06,
                    9.8663e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_N2O": 0.45,
                "Fossil_N2O_timeseries": [
                    4.3491e-08,
                    8.7565e-08,
                    1.3221e-07,
                    1.7742e-07,
                    2.2318e-07,
                    2.6946e-07,
                    3.1624e-07,
                    3.6351e-07,
                    4.1123e-07,
                    4.5936e-07,
                    5.0789e-07,
                    5.5681e-07,
                    6.0612e-07,
                    6.5582e-07,
                    7.059e-07,
                    7.5636e-07,
                    8.0721e-07,
                    8.5845e-07,
                    9.1009e-07,
                    9.6212e-07,
                    1.0147e-06,
                    1.0682e-06,
                    1.1228e-06,
                    1.1786e-06,
                    1.2358e-06,
                    1.2943e-06,
                    1.3542e-06,
                    1.4153e-06,
                    1.4774e-06,
                    1.5402e-06,
                    1.6037e-06,
                    1.6677e-06,
                    1.7323e-06,
                    1.7974e-06,
                    1.8629e-06,
                    1.929e-06,
                    1.9956e-06,
                    2.0626e-06,
                    2.1302e-06,
                    2.1983e-06,
                    2.267e-06,
                    2.3363e-06,
                    2.4061e-06,
                    2.4765e-06,
                    2.5475e-06,
                    2.6191e-06,
                    2.6913e-06,
                    2.7641e-06,
                    2.8376e-06,
                    2.9117e-06,
                    2.9865e-06,
                    3.0621e-06,
                    3.1386e-06,
                    3.2158e-06,
                    3.294e-06,
                    3.3731e-06,
                    3.453e-06,
                    3.5339e-06,
                    3.6156e-06,
                    3.6982e-06,
                    3.7817e-06,
                    3.866e-06,
                    3.9511e-06,
                    4.0371e-06,
                    4.1239e-06,
                    4.2116e-06,
                    4.3001e-06,
                    4.3894e-06,
                    4.4796e-06,
                    4.5707e-06,
                    4.6626e-06,
                    4.7553e-06,
                    4.849e-06,
                    4.9435e-06,
                    5.0388e-06,
                    5.1351e-06,
                    5.2322e-06,
                    5.3301e-06,
                    5.4289e-06,
                    5.5285e-06,
                    5.6291e-06,
                    5.7311e-06,
                    5.8348e-06,
                    5.9404e-06,
                    6.0482e-06,
                    6.1584e-06,
                    6.271e-06,
                    6.3859e-06,
                    6.5033e-06,
                    6.623e-06,
                    6.7457e-06,
                    6.8727e-06,
                    7.005e-06,
                    7.1433e-06,
                    7.2881e-06,
                    7.4394e-06,
                    7.597e-06,
                    7.7603e-06,
                    7.9287e-06,
                    8.1008e-06,
                    8.276e-06,
                    8.4539e-06,
                    8.6343e-06,
                    8.8172e-06,
                    9.0024e-06,
                    9.1901e-06,
                    9.3805e-06,
                    9.5738e-06,
                    9.7703e-06,
                    9.9706e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_N2O": 0.11,
                "Land_N2O_timeseries": [
                    8.8788e-09,
                    1.7935e-08,
                    2.7161e-08,
                    3.6547e-08,
                    4.6079e-08,
                    5.574e-08,
                    6.5511e-08,
                    7.537e-08,
                    8.5292e-08,
                    9.5248e-08,
                    1.0522e-07,
                    1.1521e-07,
                    1.252e-07,
                    1.3521e-07,
                    1.4521e-07,
                    1.5523e-07,
                    1.6525e-07,
                    1.7528e-07,
                    1.8533e-07,
                    1.9539e-07,
                    2.0562e-07,
                    2.1628e-07,
                    2.2756e-07,
                    2.3961e-07,
                    2.5249e-07,
                    2.6624e-07,
                    2.808e-07,
                    2.9608e-07,
                    3.1192e-07,
                    3.2809e-07,
                    3.4446e-07,
                    3.61e-07,
                    3.7766e-07,
                    3.9445e-07,
                    4.1133e-07,
                    4.2832e-07,
                    4.4541e-07,
                    4.626e-07,
                    4.799e-07,
                    4.9803e-07,
                    5.1618e-07,
                    5.3437e-07,
                    5.5262e-07,
                    5.7092e-07,
                    5.8929e-07,
                    6.0774e-07,
                    6.2627e-07,
                    6.4489e-07,
                    6.636e-07,
                    6.824e-07,
                    7.0131e-07,
                    7.2035e-07,
                    7.3954e-07,
                    7.5888e-07,
                    7.7839e-07,
                    7.9808e-07,
                    8.1795e-07,
                    8.38e-07,
                    8.5824e-07,
                    8.7865e-07,
                    8.9923e-07,
                    9.1995e-07,
                    9.4082e-07,
                    9.6182e-07,
                    9.8297e-07,
                    1.0043e-06,
                    1.0258e-06,
                    1.0475e-06,
                    1.0695e-06,
                    1.0918e-06,
                    1.1147e-06,
                    1.1386e-06,
                    1.1638e-06,
                    1.1907e-06,
                    1.2193e-06,
                    1.2499e-06,
                    1.2823e-06,
                    1.3166e-06,
                    1.3526e-06,
                    1.39e-06,
                    1.4287e-06,
                    1.4686e-06,
                    1.5096e-06,
                    1.5517e-06,
                    1.5949e-06,
                    1.6392e-06,
                    1.6845e-06,
                    1.731e-06,
                    1.7786e-06,
                    1.8275e-06,
                    1.8783e-06,
                    1.9322e-06,
                    1.99e-06,
                    2.0524e-06,
                    2.1198e-06,
                    2.1921e-06,
                    2.2693e-06,
                    2.3509e-06,
                    2.4362e-06,
                    2.5241e-06,
                    2.6145e-06,
                    2.7078e-06,
                    2.8043e-06,
                    2.9043e-06,
                    3.0076e-06,
                    3.1143e-06,
                    3.2239e-06,
                    3.3362e-06,
                    3.4504e-06,
                    3.5659e-06,
                    3.7115e-06,
                    3.8599e-06,
                    4.0126e-06,
                    4.1706e-06,
                    4.3342e-06,
                    4.5073e-06,
                    4.6742e-06,
                    4.8529e-06,
                    5.0379e-06,
                    5.2306e-06,
                    5.4328e-06,
                    5.6357e-06,
                    5.8687e-06,
                    6.1435e-06,
                    6.4417e-06,
                    6.7754e-06,
                    7.1125e-06,
                    7.5014e-06,
                    7.9402e-06,
                    8.4147e-06,
                    8.9229e-06,
                    9.551e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                52.0,
                                19.0
                            ],
                            [
                                52.75638,
                                19.25798
                            ],
                            [
                                53.51335,
                                19.51222
                            ],
                            [
                                54.26002,
                                19.75912
                            ],
                            [
                                54.99985,
                                19.99997
                            ],
                            [
                                55.24454,
                                20.7394
                            ],
                            [
                                55.43211,
                                21.30133
                            ],
                            [
                                55.66667,
                                22.0
                            ],
                            [
                                55.20833,
                                22.70833
                            ],
                            [
                                55.13722,
                                22.62806
                            ],
                            [
                                54.50632,
                                22.70409
                            ],
                            [
                                54.06808,
                                22.75687
                            ],
                            [
                                53.4375,
                                22.83279
                            ],
                            [
                                52.58111,
                                22.93583
                            ],
                            [
                                52.06633,
                                23.55332
                            ],
                            [
                                51.59056,
                                24.12333
                            ],
                            [
                                51.59056,
                                24.24297
                            ],
                            [
                                51.54832,
                                24.23999
                            ],
                            [
                                51.497,
                                24.3005
                            ],
                            [
                                51.39231,
                                24.30886
                            ],
                            [
                                51.3,
                                24.29696
                            ],
                            [
                                51.33068,
                                24.41932
                            ],
                            [
                                51.40089,
                                24.47216
                            ],
                            [
                                51.46375,
                                24.5553
                            ],
                            [
                                51.41103,
                                24.60542
                            ],
                            [
                                51.35606,
                                24.5294
                            ],
                            [
                                51.30552,
                                24.5063
                            ],
                            [
                                51.09861,
                                24.47111
                            ],
                            [
                                51.0,
                                24.5
                            ],
                            [
                                50.92889,
                                24.54528
                            ],
                            [
                                50.81503,
                                24.73945
                            ],
                            [
                                50.7761,
                                24.72676
                            ],
                            [
                                50.73126,
                                24.86627
                            ],
                            [
                                50.57246,
                                25.06927
                            ],
                            [
                                50.53457,
                                25.29773
                            ],
                            [
                                50.49334,
                                25.40044
                            ],
                            [
                                50.39719,
                                25.48071
                            ],
                            [
                                50.37104,
                                25.45275
                            ],
                            [
                                50.16008,
                                25.70039
                            ],
                            [
                                50.18556,
                                25.76664
                            ],
                            [
                                50.11804,
                                25.87744
                            ],
                            [
                                50.12241,
                                25.96219
                            ],
                            [
                                50.0515,
                                26.0087
                            ],
                            [
                                49.99946,
                                26.11624
                            ],
                            [
                                50.028,
                                26.17828
                            ],
                            [
                                50.08681,
                                26.13111
                            ],
                            [
                                50.15925,
                                26.03888
                            ],
                            [
                                50.1764,
                                26.1328
                            ],
                            [
                                50.22573,
                                26.18665
                            ],
                            [
                                50.23304,
                                26.34082
                            ],
                            [
                                50.19505,
                                26.40253
                            ],
                            [
                                50.06833,
                                26.47001
                            ],
                            [
                                50.03002,
                                26.52567
                            ],
                            [
                                50.01617,
                                26.64533
                            ],
                            [
                                50.07967,
                                26.7241
                            ],
                            [
                                50.00432,
                                26.81398
                            ],
                            [
                                49.93811,
                                26.8522
                            ],
                            [
                                49.79287,
                                26.89645
                            ],
                            [
                                49.6891,
                                26.96782
                            ],
                            [
                                49.59115,
                                27.0923
                            ],
                            [
                                49.5798,
                                27.16751
                            ],
                            [
                                49.53286,
                                27.1799
                            ],
                            [
                                49.49012,
                                27.1254
                            ],
                            [
                                49.39327,
                                27.12438
                            ],
                            [
                                49.41516,
                                27.1767
                            ],
                            [
                                49.33316,
                                27.19331
                            ],
                            [
                                49.32104,
                                27.32353
                            ],
                            [
                                49.16353,
                                27.40637
                            ],
                            [
                                49.31234,
                                27.46587
                            ],
                            [
                                49.25976,
                                27.52023
                            ],
                            [
                                49.04639,
                                27.56375
                            ],
                            [
                                48.97925,
                                27.6161
                            ],
                            [
                                48.92579,
                                27.59357
                            ],
                            [
                                48.85359,
                                27.60418
                            ],
                            [
                                48.86003,
                                27.68452
                            ],
                            [
                                48.81405,
                                27.7311
                            ],
                            [
                                48.83644,
                                27.86605
                            ],
                            [
                                48.75422,
                                27.95635
                            ],
                            [
                                48.76256,
                                28.00632
                            ],
                            [
                                48.69596,
                                28.02138
                            ],
                            [
                                48.63174,
                                28.07625
                            ],
                            [
                                48.61152,
                                28.1299
                            ],
                            [
                                48.63053,
                                28.20062
                            ],
                            [
                                48.54467,
                                28.28274
                            ],
                            [
                                48.51804,
                                28.3322
                            ],
                            [
                                48.54121,
                                28.39784
                            ],
                            [
                                48.49934,
                                28.4857
                            ],
                            [
                                48.43327,
                                28.5314
                            ],
                            [
                                47.70776,
                                28.52214
                            ],
                            [
                                47.60783,
                                28.65441
                            ],
                            [
                                47.58946,
                                28.83349
                            ],
                            [
                                47.46915,
                                28.99625
                            ],
                            [
                                46.57574,
                                29.09639
                            ],
                            [
                                46.55304,
                                29.10117
                            ],
                            [
                                46.42582,
                                29.06123
                            ],
                            [
                                45.58497,
                                29.13172
                            ],
                            [
                                44.72188,
                                29.19849
                            ],
                            [
                                44.42686,
                                29.41796
                            ],
                            [
                                43.81722,
                                29.86853
                            ],
                            [
                                43.30307,
                                30.24366
                            ],
                            [
                                42.7836,
                                30.61738
                            ],
                            [
                                42.08558,
                                31.11167
                            ],
                            [
                                41.44081,
                                31.37318
                            ],
                            [
                                40.93185,
                                31.65986
                            ],
                            [
                                40.41331,
                                31.94805
                            ],
                            [
                                39.79102,
                                32.05549
                            ],
                            [
                                39.20094,
                                32.15433
                            ],
                            [
                                39.13036,
                                32.13472
                            ],
                            [
                                39.10447,
                                32.08216
                            ],
                            [
                                38.99789,
                                32.00001
                            ],
                            [
                                37.95146,
                                31.74293
                            ],
                            [
                                37.00269,
                                31.50055
                            ],
                            [
                                37.22905,
                                31.27403
                            ],
                            [
                                37.72802,
                                30.77275
                            ],
                            [
                                37.99773,
                                30.5007
                            ],
                            [
                                37.66721,
                                30.3332
                            ],
                            [
                                37.49837,
                                30.00087
                            ],
                            [
                                36.75119,
                                29.86655
                            ],
                            [
                                36.49907,
                                29.49969
                            ],
                            [
                                36.06849,
                                29.18524
                            ],
                            [
                                35.43036,
                                29.28396
                            ],
                            [
                                34.95704,
                                29.35671
                            ],
                            [
                                34.93868,
                                29.24136
                            ],
                            [
                                34.91146,
                                29.2237
                            ],
                            [
                                34.8553,
                                29.0338
                            ],
                            [
                                34.86375,
                                28.99899
                            ],
                            [
                                34.82708,
                                28.88404
                            ],
                            [
                                34.83273,
                                28.80938
                            ],
                            [
                                34.77808,
                                28.66815
                            ],
                            [
                                34.80436,
                                28.52445
                            ],
                            [
                                34.77264,
                                28.477
                            ],
                            [
                                34.66029,
                                28.20614
                            ],
                            [
                                34.58262,
                                28.11793
                            ],
                            [
                                34.65526,
                                28.09562
                            ],
                            [
                                34.68566,
                                28.13324
                            ],
                            [
                                34.85165,
                                28.07481
                            ],
                            [
                                35.06025,
                                28.11123
                            ],
                            [
                                35.16894,
                                28.01322
                            ],
                            [
                                35.26219,
                                27.95214
                            ],
                            [
                                35.34641,
                                27.85039
                            ],
                            [
                                35.36184,
                                27.79735
                            ],
                            [
                                35.42034,
                                27.77526
                            ],
                            [
                                35.48354,
                                27.65531
                            ],
                            [
                                35.5247,
                                27.61014
                            ],
                            [
                                35.54106,
                                27.52241
                            ],
                            [
                                35.63965,
                                27.38605
                            ],
                            [
                                35.74228,
                                27.32131
                            ],
                            [
                                35.81755,
                                27.19506
                            ],
                            [
                                35.80785,
                                27.11099
                            ],
                            [
                                35.9197,
                                26.99699
                            ],
                            [
                                36.00598,
                                26.92848
                            ],
                            [
                                36.09938,
                                26.73952
                            ],
                            [
                                36.22836,
                                26.63731
                            ],
                            [
                                36.34912,
                                26.42478
                            ],
                            [
                                36.35252,
                                26.39207
                            ],
                            [
                                36.48406,
                                26.17741
                            ],
                            [
                                36.49923,
                                26.11522
                            ],
                            [
                                36.5782,
                                26.05942
                            ],
                            [
                                36.6541,
                                26.05669
                            ],
                            [
                                36.7044,
                                26.02705
                            ],
                            [
                                36.70124,
                                25.92768
                            ],
                            [
                                36.64943,
                                25.85319
                            ],
                            [
                                36.70007,
                                25.8169
                            ],
                            [
                                36.71598,
                                25.74222
                            ],
                            [
                                36.8192,
                                25.74755
                            ],
                            [
                                36.87229,
                                25.67248
                            ],
                            [
                                36.92435,
                                25.65499
                            ],
                            [
                                36.99953,
                                25.54258
                            ],
                            [
                                37.01053,
                                25.49041
                            ],
                            [
                                37.07374,
                                25.43902
                            ],
                            [
                                37.06131,
                                25.40579
                            ],
                            [
                                37.1234,
                                25.29597
                            ],
                            [
                                37.22796,
                                25.19894
                            ],
                            [
                                37.26597,
                                25.10477
                            ],
                            [
                                37.25158,
                                25.04868
                            ],
                            [
                                37.28394,
                                24.98482
                            ],
                            [
                                37.2517,
                                24.9108
                            ],
                            [
                                37.26131,
                                24.86795
                            ],
                            [
                                37.15429,
                                24.83004
                            ],
                            [
                                37.21489,
                                24.75821
                            ],
                            [
                                37.22938,
                                24.7075
                            ],
                            [
                                37.29366,
                                24.67179
                            ],
                            [
                                37.45713,
                                24.43747
                            ],
                            [
                                37.42664,
                                24.38686
                            ],
                            [
                                37.4998,
                                24.29025
                            ],
                            [
                                37.57956,
                                24.24654
                            ],
                            [
                                37.62058,
                                24.28595
                            ],
                            [
                                37.68555,
                                24.29251
                            ],
                            [
                                37.7504,
                                24.25614
                            ],
                            [
                                37.83615,
                                24.1615
                            ],
                            [
                                37.94573,
                                24.13166
                            ],
                            [
                                38.03044,
                                24.07001
                            ],
                            [
                                38.07322,
                                24.06996
                            ],
                            [
                                38.16086,
                                23.99768
                            ],
                            [
                                38.28395,
                                23.93324
                            ],
                            [
                                38.44226,
                                23.7929
                            ],
                            [
                                38.48444,
                                23.66167
                            ],
                            [
                                38.54044,
                                23.54356
                            ],
                            [
                                38.59291,
                                23.56807
                            ],
                            [
                                38.62666,
                                23.50404
                            ],
                            [
                                38.64895,
                                23.37749
                            ],
                            [
                                38.68106,
                                23.29302
                            ],
                            [
                                38.78707,
                                23.13977
                            ],
                            [
                                38.78904,
                                23.02753
                            ],
                            [
                                38.91094,
                                22.96145
                            ],
                            [
                                38.96394,
                                22.86958
                            ],
                            [
                                38.90048,
                                22.84863
                            ],
                            [
                                38.99355,
                                22.71947
                            ],
                            [
                                39.07663,
                                22.56197
                            ],
                            [
                                39.07233,
                                22.25532
                            ],
                            [
                                39.03764,
                                22.19536
                            ],
                            [
                                39.0444,
                                22.06334
                            ],
                            [
                                38.98103,
                                21.97119
                            ],
                            [
                                39.00625,
                                21.86499
                            ],
                            [
                                39.07852,
                                21.71098
                            ],
                            [
                                39.11159,
                                21.54335
                            ],
                            [
                                39.17242,
                                21.4935
                            ],
                            [
                                39.18645,
                                21.40448
                            ],
                            [
                                39.10881,
                                21.30395
                            ],
                            [
                                39.24419,
                                21.06163
                            ],
                            [
                                39.30299,
                                20.93628
                            ],
                            [
                                39.34713,
                                20.92249
                            ],
                            [
                                39.43308,
                                20.78518
                            ],
                            [
                                39.48718,
                                20.76489
                            ],
                            [
                                39.49036,
                                20.71307
                            ],
                            [
                                39.57144,
                                20.59092
                            ],
                            [
                                39.59577,
                                20.57948
                            ],
                            [
                                39.66572,
                                20.44948
                            ],
                            [
                                39.73557,
                                20.38425
                            ],
                            [
                                39.91939,
                                20.26565
                            ],
                            [
                                40.05999,
                                20.28064
                            ],
                            [
                                40.1035,
                                20.26797
                            ],
                            [
                                40.17072,
                                20.19077
                            ],
                            [
                                40.22947,
                                20.1844
                            ],
                            [
                                40.28459,
                                20.10314
                            ],
                            [
                                40.36477,
                                20.07421
                            ],
                            [
                                40.52899,
                                19.97046
                            ],
                            [
                                40.54208,
                                19.90523
                            ],
                            [
                                40.6304,
                                19.78121
                            ],
                            [
                                40.72774,
                                19.79538
                            ],
                            [
                                40.78573,
                                19.73423
                            ],
                            [
                                40.80496,
                                19.57842
                            ],
                            [
                                40.91604,
                                19.53103
                            ],
                            [
                                40.95297,
                                19.4948
                            ],
                            [
                                40.95664,
                                19.35492
                            ],
                            [
                                41.0426,
                                19.25708
                            ],
                            [
                                41.06979,
                                19.12876
                            ],
                            [
                                41.15907,
                                19.07693
                            ],
                            [
                                41.13192,
                                18.95942
                            ],
                            [
                                41.16266,
                                18.88504
                            ],
                            [
                                41.23644,
                                18.84602
                            ],
                            [
                                41.20714,
                                18.72824
                            ],
                            [
                                41.25405,
                                18.62396
                            ],
                            [
                                41.35248,
                                18.58063
                            ],
                            [
                                41.4137,
                                18.51656
                            ],
                            [
                                41.44936,
                                18.42521
                            ],
                            [
                                41.47735,
                                18.29505
                            ],
                            [
                                41.57288,
                                18.15201
                            ],
                            [
                                41.58803,
                                18.09476
                            ],
                            [
                                41.64089,
                                18.04687
                            ],
                            [
                                41.63898,
                                18.00245
                            ],
                            [
                                41.79705,
                                17.84618
                            ],
                            [
                                41.88334,
                                17.81391
                            ],
                            [
                                41.8967,
                                17.78297
                            ],
                            [
                                42.0272,
                                17.69694
                            ],
                            [
                                42.3065,
                                17.44737
                            ],
                            [
                                42.30895,
                                17.34259
                            ],
                            [
                                42.36681,
                                17.10467
                            ],
                            [
                                42.54704,
                                17.00306
                            ],
                            [
                                42.53326,
                                16.88979
                            ],
                            [
                                42.66402,
                                16.78844
                            ],
                            [
                                42.72713,
                                16.67547
                            ],
                            [
                                42.7079,
                                16.58239
                            ],
                            [
                                42.77121,
                                16.47598
                            ],
                            [
                                42.76391,
                                16.40456
                            ],
                            [
                                42.83278,
                                16.38002
                            ],
                            [
                                42.93985,
                                16.41095
                            ],
                            [
                                42.95264,
                                16.49813
                            ],
                            [
                                42.99269,
                                16.5208
                            ],
                            [
                                43.11996,
                                16.53065
                            ],
                            [
                                43.16022,
                                16.66617
                            ],
                            [
                                43.22765,
                                16.69934
                            ],
                            [
                                43.26466,
                                16.79613
                            ],
                            [
                                43.14881,
                                16.88127
                            ],
                            [
                                43.14622,
                                16.92537
                            ],
                            [
                                43.22639,
                                17.07421
                            ],
                            [
                                43.16047,
                                17.09006
                            ],
                            [
                                43.1529,
                                17.17146
                            ],
                            [
                                43.20031,
                                17.24285
                            ],
                            [
                                43.32287,
                                17.33002
                            ],
                            [
                                43.23075,
                                17.38435
                            ],
                            [
                                43.24359,
                                17.48105
                            ],
                            [
                                43.35371,
                                17.55445
                            ],
                            [
                                43.42161,
                                17.56503
                            ],
                            [
                                43.48144,
                                17.546
                            ],
                            [
                                43.5658,
                                17.48368
                            ],
                            [
                                43.68187,
                                17.36863
                            ],
                            [
                                43.78647,
                                17.37441
                            ],
                            [
                                43.83476,
                                17.33928
                            ],
                            [
                                43.96469,
                                17.33166
                            ],
                            [
                                44.01124,
                                17.40018
                            ],
                            [
                                44.36529,
                                17.43319
                            ],
                            [
                                44.46647,
                                17.43314
                            ],
                            [
                                44.56656,
                                17.40601
                            ],
                            [
                                44.65209,
                                17.43329
                            ],
                            [
                                45.21263,
                                17.43333
                            ],
                            [
                                45.39935,
                                17.33385
                            ],
                            [
                                46.1,
                                17.25
                            ],
                            [
                                46.36667,
                                17.23333
                            ],
                            [
                                46.75,
                                17.28333
                            ],
                            [
                                47.0,
                                16.95
                            ],
                            [
                                47.18517,
                                16.95114
                            ],
                            [
                                47.46637,
                                17.11701
                            ],
                            [
                                47.60086,
                                17.45094
                            ],
                            [
                                48.18448,
                                18.1671
                            ],
                            [
                                48.49494,
                                18.31687
                            ],
                            [
                                49.11668,
                                18.61642
                            ],
                            [
                                49.91066,
                                18.69998
                            ],
                            [
                                50.7836,
                                18.78898
                            ],
                            [
                                51.1347,
                                18.84992
                            ],
                            [
                                52.0,
                                19.0
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                41.74727,
                                16.89521
                            ],
                            [
                                41.83472,
                                16.7601
                            ],
                            [
                                41.94862,
                                16.67863
                            ],
                            [
                                42.05313,
                                16.70064
                            ],
                            [
                                42.15959,
                                16.5904
                            ],
                            [
                                42.18682,
                                16.59558
                            ],
                            [
                                42.17519,
                                16.726
                            ],
                            [
                                42.11974,
                                16.75488
                            ],
                            [
                                42.09605,
                                16.8069
                            ],
                            [
                                42.04805,
                                16.80478
                            ],
                            [
                                42.02423,
                                16.72173
                            ],
                            [
                                41.89692,
                                16.75526
                            ],
                            [
                                41.84656,
                                16.84799
                            ],
                            [
                                41.74727,
                                16.89521
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                41.8305,
                                16.90605
                            ],
                            [
                                41.8809,
                                16.82539
                            ],
                            [
                                41.9694,
                                16.8792
                            ],
                            [
                                41.88393,
                                16.92642
                            ],
                            [
                                41.8305,
                                16.90605
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "SEN",
                "Country": "Senegal",
                "Total_3GHG": 0.06,
                "Total_3GHG_timeseries": [
                    3.9819e-07,
                    8.0177e-07,
                    1.2091e-06,
                    1.6193e-06,
                    2.032e-06,
                    2.4468e-06,
                    2.8634e-06,
                    3.2816e-06,
                    3.701e-06,
                    4.1221e-06,
                    4.5463e-06,
                    4.9742e-06,
                    5.4058e-06,
                    5.8415e-06,
                    6.2813e-06,
                    6.7253e-06,
                    7.1735e-06,
                    7.626e-06,
                    8.0827e-06,
                    8.5535e-06,
                    9.0337e-06,
                    9.5231e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009
                ],
                "Fossil_3GHG": 0.03,
                "Fossil_3GHG_timeseries": [
                    5.8345e-08,
                    1.1834e-07,
                    1.7999e-07,
                    2.4329e-07,
                    3.0825e-07,
                    3.7487e-07,
                    4.4315e-07,
                    5.1309e-07,
                    5.8468e-07,
                    6.5793e-07,
                    7.3327e-07,
                    8.1071e-07,
                    8.9024e-07,
                    9.7188e-07,
                    1.0556e-06,
                    1.1415e-06,
                    1.2295e-06,
                    1.3196e-06,
                    1.4118e-06,
                    1.5062e-06,
                    1.6012e-06,
                    1.697e-06,
                    1.7935e-06,
                    1.8909e-06,
                    1.989e-06,
                    2.088e-06,
                    2.1878e-06,
                    2.2884e-06,
                    2.3898e-06,
                    2.4918e-06,
                    2.5942e-06,
                    2.6969e-06,
                    2.8e-06,
                    2.9035e-06,
                    3.0074e-06,
                    3.1116e-06,
                    3.2163e-06,
                    3.3212e-06,
                    3.4266e-06,
                    3.5325e-06,
                    3.6389e-06,
                    3.7459e-06,
                    3.8534e-06,
                    3.9614e-06,
                    4.0701e-06,
                    4.1794e-06,
                    4.2895e-06,
                    4.4004e-06,
                    4.5121e-06,
                    4.6256e-06,
                    4.7558e-06,
                    4.9027e-06,
                    5.0666e-06,
                    5.2477e-06,
                    5.4461e-06,
                    5.6622e-06,
                    5.896e-06,
                    6.1479e-06,
                    6.4179e-06,
                    6.7063e-06,
                    7.0191e-06,
                    7.3729e-06,
                    7.7688e-06,
                    8.2083e-06,
                    8.6927e-06,
                    9.2235e-06,
                    9.8028e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Land_3GHG": 0.12,
                "Land_3GHG_timeseries": [
                    3.3984e-07,
                    6.8343e-07,
                    1.0291e-06,
                    1.3761e-06,
                    1.7238e-06,
                    2.0719e-06,
                    2.4203e-06,
                    2.7685e-06,
                    3.1164e-06,
                    3.4641e-06,
                    3.813e-06,
                    4.1635e-06,
                    4.5156e-06,
                    4.8696e-06,
                    5.2257e-06,
                    5.5838e-06,
                    5.944e-06,
                    6.3064e-06,
                    6.6709e-06,
                    7.0473e-06,
                    7.4324e-06,
                    7.8261e-06,
                    8.2285e-06,
                    8.6401e-06,
                    9.0611e-06,
                    9.4912e-06,
                    9.9301e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007
                ],
                "Total_CO2": 0.03,
                "Total_CO2_timeseries": [
                    1.4077e-07,
                    2.8395e-07,
                    4.2796e-07,
                    5.7198e-07,
                    7.1565e-07,
                    8.5876e-07,
                    1.0012e-06,
                    1.1428e-06,
                    1.2835e-06,
                    1.4237e-06,
                    1.5627e-06,
                    1.7009e-06,
                    1.8385e-06,
                    1.9756e-06,
                    2.1125e-06,
                    2.2492e-06,
                    2.3857e-06,
                    2.522e-06,
                    2.658e-06,
                    2.8036e-06,
                    2.9545e-06,
                    3.1086e-06,
                    3.2649e-06,
                    3.4227e-06,
                    3.5819e-06,
                    3.7419e-06,
                    3.9029e-06,
                    4.0643e-06,
                    4.2263e-06,
                    4.4027e-06,
                    4.5871e-06,
                    4.7767e-06,
                    4.97e-06,
                    5.166e-06,
                    5.3643e-06,
                    5.5646e-06,
                    5.7664e-06,
                    5.9694e-06,
                    6.1735e-06,
                    6.3986e-06,
                    6.6368e-06,
                    6.8833e-06,
                    7.1744e-06,
                    7.4446e-06,
                    7.7115e-06,
                    7.9787e-06,
                    8.2469e-06,
                    8.5166e-06,
                    8.7882e-06,
                    9.4559e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Fossil_CO2": 0.02,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.6289e-07,
                    2.9899e-07,
                    4.4604e-07,
                    5.6953e-07,
                    7.1248e-07,
                    8.441e-07,
                    9.9784e-07,
                    1.1541e-06,
                    1.3139e-06,
                    1.4885e-06,
                    1.8611e-06,
                    2.227e-06,
                    2.593e-06,
                    2.9804e-06,
                    3.3958e-06,
                    4.1578e-06,
                    4.9313e-06,
                    5.2461e-06,
                    5.2903e-06,
                    5.511e-06,
                    6.0997e-06,
                    6.7081e-06,
                    7.3625e-06,
                    8.0599e-06,
                    8.8926e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CO2": 0.07,
                "Land_CO2_timeseries": [
                    1.4077e-07,
                    2.8395e-07,
                    4.2796e-07,
                    5.7198e-07,
                    7.1565e-07,
                    8.5876e-07,
                    1.0012e-06,
                    1.1428e-06,
                    1.2835e-06,
                    1.4237e-06,
                    1.5627e-06,
                    1.7009e-06,
                    1.8385e-06,
                    1.9756e-06,
                    2.1125e-06,
                    2.2492e-06,
                    2.3857e-06,
                    2.522e-06,
                    2.658e-06,
                    2.8036e-06,
                    2.9545e-06,
                    3.1086e-06,
                    3.2649e-06,
                    3.4227e-06,
                    3.5819e-06,
                    3.7419e-06,
                    3.9029e-06,
                    4.0643e-06,
                    4.2263e-06,
                    4.4027e-06,
                    4.5871e-06,
                    4.7767e-06,
                    4.97e-06,
                    5.166e-06,
                    5.3643e-06,
                    5.5646e-06,
                    5.7664e-06,
                    5.9694e-06,
                    6.1735e-06,
                    6.3986e-06,
                    6.6368e-06,
                    6.8833e-06,
                    7.1744e-06,
                    7.4446e-06,
                    7.7115e-06,
                    7.9787e-06,
                    8.2469e-06,
                    8.5166e-06,
                    8.7882e-06,
                    9.4559e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Total_CH4": 0.11,
                "Total_CH4_timeseries": [
                    1.9302e-07,
                    3.8776e-07,
                    5.8421e-07,
                    7.8238e-07,
                    9.8228e-07,
                    1.1839e-06,
                    1.3873e-06,
                    1.5924e-06,
                    1.7992e-06,
                    2.0078e-06,
                    2.2208e-06,
                    2.4381e-06,
                    2.6597e-06,
                    2.8856e-06,
                    3.116e-06,
                    3.3506e-06,
                    3.5897e-06,
                    3.8331e-06,
                    4.0809e-06,
                    4.333e-06,
                    4.5881e-06,
                    4.8461e-06,
                    5.107e-06,
                    5.3708e-06,
                    5.6375e-06,
                    5.9072e-06,
                    6.1798e-06,
                    6.4553e-06,
                    6.7337e-06,
                    7.015e-06,
                    7.297e-06,
                    7.5797e-06,
                    7.863e-06,
                    8.1471e-06,
                    8.4319e-06,
                    8.7174e-06,
                    9.0037e-06,
                    9.2906e-06,
                    9.5783e-06,
                    9.8667e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Fossil_CH4": 0.06,
                "Fossil_CH4_timeseries": [
                    5.5119e-08,
                    1.1183e-07,
                    1.7015e-07,
                    2.3007e-07,
                    2.916e-07,
                    3.5475e-07,
                    4.1952e-07,
                    4.8591e-07,
                    5.5394e-07,
                    6.236e-07,
                    6.9534e-07,
                    7.6917e-07,
                    8.4508e-07,
                    9.2308e-07,
                    1.0032e-06,
                    1.0854e-06,
                    1.1697e-06,
                    1.2561e-06,
                    1.3447e-06,
                    1.4354e-06,
                    1.5266e-06,
                    1.6185e-06,
                    1.711e-06,
                    1.8041e-06,
                    1.8977e-06,
                    1.992e-06,
                    2.0869e-06,
                    2.1824e-06,
                    2.2785e-06,
                    2.3752e-06,
                    2.4721e-06,
                    2.5694e-06,
                    2.667e-06,
                    2.7649e-06,
                    2.8632e-06,
                    2.9618e-06,
                    3.0608e-06,
                    3.16e-06,
                    3.2597e-06,
                    3.3596e-06,
                    3.4601e-06,
                    3.5609e-06,
                    3.6623e-06,
                    3.7641e-06,
                    3.8664e-06,
                    3.9693e-06,
                    4.0729e-06,
                    4.1771e-06,
                    4.282e-06,
                    4.3886e-06,
                    4.5118e-06,
                    4.6515e-06,
                    4.8081e-06,
                    4.9816e-06,
                    5.1724e-06,
                    5.3806e-06,
                    5.6063e-06,
                    5.8499e-06,
                    6.1115e-06,
                    6.3913e-06,
                    6.6955e-06,
                    7.0404e-06,
                    7.4274e-06,
                    7.8578e-06,
                    8.3331e-06,
                    8.8545e-06,
                    9.4244e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_CH4": 0.19,
                "Land_CH4_timeseries": [
                    1.379e-07,
                    2.7592e-07,
                    4.1406e-07,
                    5.5231e-07,
                    6.9068e-07,
                    8.2916e-07,
                    9.6776e-07,
                    1.1065e-06,
                    1.2453e-06,
                    1.3842e-06,
                    1.5254e-06,
                    1.6689e-06,
                    1.8146e-06,
                    1.9626e-06,
                    2.1128e-06,
                    2.2652e-06,
                    2.42e-06,
                    2.5769e-06,
                    2.7362e-06,
                    2.8977e-06,
                    3.0614e-06,
                    3.2276e-06,
                    3.396e-06,
                    3.5667e-06,
                    3.7398e-06,
                    3.9152e-06,
                    4.0929e-06,
                    4.2729e-06,
                    4.4552e-06,
                    4.6399e-06,
                    4.8249e-06,
                    5.0103e-06,
                    5.196e-06,
                    5.3822e-06,
                    5.5687e-06,
                    5.7556e-06,
                    5.9429e-06,
                    6.1306e-06,
                    6.3186e-06,
                    6.507e-06,
                    6.6958e-06,
                    6.885e-06,
                    7.0746e-06,
                    7.2645e-06,
                    7.4548e-06,
                    7.6456e-06,
                    7.8367e-06,
                    8.0281e-06,
                    8.22e-06,
                    8.4123e-06,
                    8.5968e-06,
                    8.7736e-06,
                    8.9427e-06,
                    9.1041e-06,
                    9.2578e-06,
                    9.4038e-06,
                    9.542e-06,
                    9.6725e-06,
                    9.7953e-06,
                    9.9104e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Total_N2O": 0.16,
                "Total_N2O_timeseries": [
                    6.439e-08,
                    1.3006e-07,
                    1.9695e-07,
                    2.6499e-07,
                    3.3408e-07,
                    4.0411e-07,
                    4.7493e-07,
                    5.4639e-07,
                    6.1831e-07,
                    6.9049e-07,
                    7.6279e-07,
                    8.352e-07,
                    9.0768e-07,
                    9.8022e-07,
                    1.0528e-06,
                    1.1255e-06,
                    1.1982e-06,
                    1.271e-06,
                    1.3438e-06,
                    1.4169e-06,
                    1.4911e-06,
                    1.5684e-06,
                    1.6502e-06,
                    1.7374e-06,
                    1.8307e-06,
                    1.9301e-06,
                    2.0353e-06,
                    2.1457e-06,
                    2.2601e-06,
                    2.3769e-06,
                    2.4951e-06,
                    2.6144e-06,
                    2.7347e-06,
                    2.8559e-06,
                    2.9779e-06,
                    3.1005e-06,
                    3.2239e-06,
                    3.348e-06,
                    3.473e-06,
                    3.6044e-06,
                    3.737e-06,
                    3.8711e-06,
                    4.0064e-06,
                    4.1433e-06,
                    4.2816e-06,
                    4.4216e-06,
                    4.5631e-06,
                    4.7063e-06,
                    4.8512e-06,
                    4.9978e-06,
                    5.1462e-06,
                    5.2963e-06,
                    5.4481e-06,
                    5.6016e-06,
                    5.757e-06,
                    5.9145e-06,
                    6.0741e-06,
                    6.2362e-06,
                    6.4011e-06,
                    6.5691e-06,
                    6.7417e-06,
                    6.9212e-06,
                    7.1092e-06,
                    7.3073e-06,
                    7.5166e-06,
                    7.7376e-06,
                    7.9706e-06,
                    8.2155e-06,
                    8.4718e-06,
                    8.7385e-06,
                    9.0159e-06,
                    9.3053e-06,
                    9.6074e-06,
                    9.9224e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_N2O": 0.03,
                "Fossil_N2O_timeseries": [
                    3.2253e-09,
                    6.5053e-09,
                    9.8383e-09,
                    1.3221e-08,
                    1.6651e-08,
                    2.0124e-08,
                    2.3634e-08,
                    2.7176e-08,
                    3.0743e-08,
                    3.4329e-08,
                    3.7929e-08,
                    4.1541e-08,
                    4.5166e-08,
                    4.8801e-08,
                    5.2447e-08,
                    5.6105e-08,
                    5.9774e-08,
                    6.3455e-08,
                    6.7148e-08,
                    7.0856e-08,
                    7.4617e-08,
                    7.8496e-08,
                    8.2543e-08,
                    8.6795e-08,
                    9.1271e-08,
                    9.5976e-08,
                    1.009e-07,
                    1.0602e-07,
                    1.1128e-07,
                    1.1665e-07,
                    1.2207e-07,
                    1.2755e-07,
                    1.3306e-07,
                    1.3862e-07,
                    1.4421e-07,
                    1.4984e-07,
                    1.5551e-07,
                    1.612e-07,
                    1.6694e-07,
                    1.7286e-07,
                    1.7885e-07,
                    1.8492e-07,
                    1.9108e-07,
                    1.9733e-07,
                    2.0368e-07,
                    2.1012e-07,
                    2.1667e-07,
                    2.2332e-07,
                    2.3009e-07,
                    2.3697e-07,
                    2.4399e-07,
                    2.5116e-07,
                    2.585e-07,
                    2.6603e-07,
                    2.7373e-07,
                    2.8163e-07,
                    2.897e-07,
                    2.9796e-07,
                    3.0638e-07,
                    3.1494e-07,
                    3.2364e-07,
                    3.3246e-07,
                    3.4141e-07,
                    3.5047e-07,
                    3.5966e-07,
                    3.6896e-07,
                    3.7838e-07,
                    3.8791e-07,
                    3.9757e-07,
                    4.0735e-07,
                    4.1726e-07,
                    4.273e-07,
                    4.3746e-07,
                    4.4776e-07,
                    4.5818e-07,
                    4.6873e-07,
                    4.7942e-07,
                    4.9024e-07,
                    5.0121e-07,
                    5.1231e-07,
                    5.2357e-07,
                    5.35e-07,
                    5.4662e-07,
                    5.5844e-07,
                    5.7047e-07,
                    5.8274e-07,
                    5.9526e-07,
                    6.0805e-07,
                    6.2111e-07,
                    6.3447e-07,
                    6.4826e-07,
                    6.6269e-07,
                    6.7794e-07,
                    6.9415e-07,
                    7.114e-07,
                    7.2972e-07,
                    7.4911e-07,
                    7.6953e-07,
                    7.9086e-07,
                    8.1297e-07,
                    8.3578e-07,
                    8.593e-07,
                    8.8353e-07,
                    9.0847e-07,
                    9.3412e-07,
                    9.6048e-07,
                    9.8754e-07,
                    1.0153e-06,
                    1.0437e-06,
                    1.0729e-06,
                    1.1027e-06,
                    1.1334e-06,
                    1.165e-06,
                    1.1977e-06,
                    1.2314e-06,
                    1.2661e-06,
                    1.3021e-06,
                    1.3391e-06,
                    1.3772e-06,
                    1.4205e-06,
                    1.4646e-06,
                    1.5089e-06,
                    1.5558e-06,
                    1.6042e-06,
                    1.6536e-06,
                    1.7039e-06,
                    1.7548e-06,
                    1.8067e-06,
                    1.8609e-06,
                    1.9161e-06,
                    1.9734e-06,
                    2.0469e-06,
                    2.117e-06,
                    2.1848e-06,
                    2.2625e-06,
                    2.3351e-06,
                    2.4063e-06,
                    2.4872e-06,
                    2.5686e-06,
                    2.6516e-06,
                    2.7357e-06,
                    2.8211e-06,
                    2.9063e-06,
                    2.9919e-06,
                    3.0794e-06,
                    3.17e-06,
                    3.2643e-06,
                    3.3639e-06,
                    3.4663e-06,
                    3.5632e-06,
                    3.6629e-06,
                    3.7648e-06,
                    3.8657e-06,
                    3.9724e-06,
                    4.0826e-06,
                    4.1997e-06,
                    4.3264e-06,
                    4.4609e-06,
                    4.6141e-06,
                    4.7694e-06,
                    4.9308e-06,
                    5.0943e-06,
                    5.25e-06,
                    5.4132e-06,
                    5.5796e-06,
                    5.7542e-06,
                    5.925e-06,
                    6.0996e-06,
                    6.2863e-06,
                    6.4761e-06,
                    6.6743e-06,
                    6.8778e-06
                ],
                "Land_N2O": 0.22,
                "Land_N2O_timeseries": [
                    6.1165e-08,
                    1.2355e-07,
                    1.8711e-07,
                    2.5177e-07,
                    3.1743e-07,
                    3.8399e-07,
                    4.513e-07,
                    5.1922e-07,
                    5.8757e-07,
                    6.5616e-07,
                    7.2487e-07,
                    7.9366e-07,
                    8.6251e-07,
                    9.3142e-07,
                    1.0004e-06,
                    1.0694e-06,
                    1.1384e-06,
                    1.2075e-06,
                    1.2767e-06,
                    1.346e-06,
                    1.4165e-06,
                    1.4899e-06,
                    1.5677e-06,
                    1.6506e-06,
                    1.7394e-06,
                    1.8341e-06,
                    1.9344e-06,
                    2.0397e-06,
                    2.1488e-06,
                    2.2602e-06,
                    2.373e-06,
                    2.4869e-06,
                    2.6017e-06,
                    2.7173e-06,
                    2.8336e-06,
                    2.9507e-06,
                    3.0684e-06,
                    3.1868e-06,
                    3.306e-06,
                    3.4315e-06,
                    3.5582e-06,
                    3.6861e-06,
                    3.8154e-06,
                    3.946e-06,
                    4.078e-06,
                    4.2114e-06,
                    4.3464e-06,
                    4.483e-06,
                    4.6211e-06,
                    4.7609e-06,
                    4.9022e-06,
                    5.0452e-06,
                    5.1896e-06,
                    5.3356e-06,
                    5.4833e-06,
                    5.6328e-06,
                    5.7844e-06,
                    5.9382e-06,
                    6.0947e-06,
                    6.2542e-06,
                    6.4181e-06,
                    6.5887e-06,
                    6.7678e-06,
                    6.9569e-06,
                    7.1569e-06,
                    7.3686e-06,
                    7.5922e-06,
                    7.8276e-06,
                    8.0742e-06,
                    8.3311e-06,
                    8.5986e-06,
                    8.878e-06,
                    9.1699e-06,
                    9.4747e-06,
                    9.7918e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -12.23916,
                                14.75937
                            ],
                            [
                                -12.3262,
                                14.82579
                            ],
                            [
                                -12.37749,
                                14.83682
                            ],
                            [
                                -12.44684,
                                14.88958
                            ],
                            [
                                -12.4612,
                                14.97906
                            ],
                            [
                                -12.60721,
                                15.08314
                            ],
                            [
                                -12.68991,
                                15.09104
                            ],
                            [
                                -12.84778,
                                15.20455
                            ],
                            [
                                -12.83607,
                                15.2897
                            ],
                            [
                                -12.94403,
                                15.36265
                            ],
                            [
                                -12.96089,
                                15.49854
                            ],
                            [
                                -13.0601,
                                15.48209
                            ],
                            [
                                -13.10146,
                                15.5075
                            ],
                            [
                                -13.09155,
                                15.58266
                            ],
                            [
                                -13.1814,
                                15.62427
                            ],
                            [
                                -13.20985,
                                15.69513
                            ],
                            [
                                -13.27511,
                                15.75385
                            ],
                            [
                                -13.31378,
                                15.92378
                            ],
                            [
                                -13.35953,
                                15.96573
                            ],
                            [
                                -13.37913,
                                16.05828
                            ],
                            [
                                -13.57189,
                                16.13468
                            ],
                            [
                                -13.68031,
                                16.0986
                            ],
                            [
                                -13.72477,
                                16.17663
                            ],
                            [
                                -13.84172,
                                16.11145
                            ],
                            [
                                -13.9541,
                                16.26985
                            ],
                            [
                                -13.96606,
                                16.32882
                            ],
                            [
                                -14.02938,
                                16.3525
                            ],
                            [
                                -14.22215,
                                16.54372
                            ],
                            [
                                -14.3325,
                                16.5791
                            ],
                            [
                                -14.33379,
                                16.63927
                            ],
                            [
                                -14.49731,
                                16.61618
                            ],
                            [
                                -15.00383,
                                16.64508
                            ],
                            [
                                -15.1143,
                                16.63412
                            ],
                            [
                                -15.2277,
                                16.55689
                            ],
                            [
                                -15.30861,
                                16.57461
                            ],
                            [
                                -15.40394,
                                16.53711
                            ],
                            [
                                -15.46772,
                                16.59138
                            ],
                            [
                                -15.54939,
                                16.51258
                            ],
                            [
                                -15.60842,
                                16.53784
                            ],
                            [
                                -15.63137,
                                16.49161
                            ],
                            [
                                -15.70928,
                                16.47437
                            ],
                            [
                                -15.81168,
                                16.50803
                            ],
                            [
                                -15.91759,
                                16.51194
                            ],
                            [
                                -15.9507,
                                16.49066
                            ],
                            [
                                -16.05954,
                                16.48353
                            ],
                            [
                                -16.11611,
                                16.5554
                            ],
                            [
                                -16.28531,
                                16.50509
                            ],
                            [
                                -16.35593,
                                16.28085
                            ],
                            [
                                -16.41478,
                                16.21945
                            ],
                            [
                                -16.41565,
                                16.10279
                            ],
                            [
                                -16.4985,
                                16.02001
                            ],
                            [
                                -16.51144,
                                15.8546
                            ],
                            [
                                -16.54151,
                                15.7678
                            ],
                            [
                                -16.60946,
                                15.63441
                            ],
                            [
                                -16.87273,
                                15.2329
                            ],
                            [
                                -16.96259,
                                15.11588
                            ],
                            [
                                -17.09985,
                                14.96065
                            ],
                            [
                                -17.12939,
                                14.91308
                            ],
                            [
                                -17.30677,
                                14.8204
                            ],
                            [
                                -17.52634,
                                14.74506
                            ],
                            [
                                -17.46831,
                                14.67854
                            ],
                            [
                                -17.38199,
                                14.73854
                            ],
                            [
                                -17.26203,
                                14.70645
                            ],
                            [
                                -17.20082,
                                14.66413
                            ],
                            [
                                -17.05088,
                                14.45406
                            ],
                            [
                                -16.9668,
                                14.40168
                            ],
                            [
                                -16.92782,
                                14.29383
                            ],
                            [
                                -16.86103,
                                14.18268
                            ],
                            [
                                -16.81045,
                                14.1658
                            ],
                            [
                                -16.74755,
                                14.02293
                            ],
                            [
                                -16.71399,
                                14.07436
                            ],
                            [
                                -16.66473,
                                14.07908
                            ],
                            [
                                -16.65526,
                                14.14292
                            ],
                            [
                                -16.59785,
                                14.16962
                            ],
                            [
                                -16.55636,
                                14.22731
                            ],
                            [
                                -16.50201,
                                14.16756
                            ],
                            [
                                -16.39029,
                                14.15739
                            ],
                            [
                                -16.32255,
                                14.18774
                            ],
                            [
                                -16.39227,
                                14.05593
                            ],
                            [
                                -16.46465,
                                14.04953
                            ],
                            [
                                -16.49543,
                                13.93212
                            ],
                            [
                                -16.48343,
                                13.85315
                            ],
                            [
                                -16.57275,
                                13.82166
                            ],
                            [
                                -16.62102,
                                13.76845
                            ],
                            [
                                -16.63333,
                                13.69355
                            ],
                            [
                                -16.55745,
                                13.60265
                            ],
                            [
                                -16.50677,
                                13.59091
                            ],
                            [
                                -15.72535,
                                13.5919
                            ],
                            [
                                -15.47965,
                                13.58296
                            ],
                            [
                                -15.45146,
                                13.67838
                            ],
                            [
                                -15.38613,
                                13.76269
                            ],
                            [
                                -15.30667,
                                13.78427
                            ],
                            [
                                -15.22426,
                                13.74609
                            ],
                            [
                                -15.11102,
                                13.80467
                            ],
                            [
                                -15.04125,
                                13.81561
                            ],
                            [
                                -14.89388,
                                13.79779
                            ],
                            [
                                -14.82189,
                                13.75351
                            ],
                            [
                                -14.80044,
                                13.65507
                            ],
                            [
                                -14.6817,
                                13.62161
                            ],
                            [
                                -14.57826,
                                13.65545
                            ],
                            [
                                -14.50051,
                                13.6133
                            ],
                            [
                                -14.42533,
                                13.49883
                            ],
                            [
                                -14.33315,
                                13.44671
                            ],
                            [
                                -14.24685,
                                13.45469
                            ],
                            [
                                -14.17718,
                                13.51338
                            ],
                            [
                                -14.10036,
                                13.54165
                            ],
                            [
                                -14.03189,
                                13.54009
                            ],
                            [
                                -13.93783,
                                13.56536
                            ],
                            [
                                -13.87613,
                                13.53146
                            ],
                            [
                                -13.81034,
                                13.44532
                            ],
                            [
                                -13.80266,
                                13.39923
                            ],
                            [
                                -13.83786,
                                13.33585
                            ],
                            [
                                -13.95367,
                                13.33079
                            ],
                            [
                                -14.00955,
                                13.30137
                            ],
                            [
                                -14.12119,
                                13.28398
                            ],
                            [
                                -14.20634,
                                13.22556
                            ],
                            [
                                -14.27216,
                                13.24385
                            ],
                            [
                                -14.36005,
                                13.23557
                            ],
                            [
                                -14.45821,
                                13.29406
                            ],
                            [
                                -14.54876,
                                13.32794
                            ],
                            [
                                -14.57642,
                                13.36581
                            ],
                            [
                                -14.6817,
                                13.3505
                            ],
                            [
                                -14.75635,
                                13.43329
                            ],
                            [
                                -14.90663,
                                13.45551
                            ],
                            [
                                -15.00411,
                                13.49621
                            ],
                            [
                                -15.07213,
                                13.59749
                            ],
                            [
                                -15.21732,
                                13.538
                            ],
                            [
                                -15.215,
                                13.4451
                            ],
                            [
                                -15.23881,
                                13.39666
                            ],
                            [
                                -15.32873,
                                13.34751
                            ],
                            [
                                -15.37508,
                                13.34787
                            ],
                            [
                                -15.52075,
                                13.40144
                            ],
                            [
                                -15.62901,
                                13.35975
                            ],
                            [
                                -15.67276,
                                13.37453
                            ],
                            [
                                -15.80247,
                                13.34642
                            ],
                            [
                                -15.80431,
                                13.16703
                            ],
                            [
                                -16.67247,
                                13.16669
                            ],
                            [
                                -16.74704,
                                13.06367
                            ],
                            [
                                -16.7357,
                                13.02573
                            ],
                            [
                                -16.79148,
                                12.76602
                            ],
                            [
                                -16.78839,
                                12.69683
                            ],
                            [
                                -16.74969,
                                12.54593
                            ],
                            [
                                -16.78994,
                                12.45743
                            ],
                            [
                                -16.77212,
                                12.40561
                            ],
                            [
                                -16.70743,
                                12.33864
                            ],
                            [
                                -16.67242,
                                12.35589
                            ],
                            [
                                -16.59481,
                                12.34637
                            ],
                            [
                                -16.39011,
                                12.36058
                            ],
                            [
                                -16.21484,
                                12.45637
                            ],
                            [
                                -16.06272,
                                12.46929
                            ],
                            [
                                -15.95786,
                                12.44045
                            ],
                            [
                                -15.86137,
                                12.44387
                            ],
                            [
                                -15.69041,
                                12.42412
                            ],
                            [
                                -15.63493,
                                12.43822
                            ],
                            [
                                -15.43457,
                                12.53232
                            ],
                            [
                                -15.32897,
                                12.612
                            ],
                            [
                                -15.17882,
                                12.68045
                            ],
                            [
                                -14.94283,
                                12.67746
                            ],
                            [
                                -14.38088,
                                12.67721
                            ],
                            [
                                -13.70827,
                                12.67621
                            ],
                            [
                                -13.57843,
                                12.67492
                            ],
                            [
                                -13.28782,
                                12.65209
                            ],
                            [
                                -13.18662,
                                12.62809
                            ],
                            [
                                -13.07429,
                                12.63854
                            ],
                            [
                                -13.05133,
                                12.58512
                            ],
                            [
                                -13.0711,
                                12.49185
                            ],
                            [
                                -12.96782,
                                12.46265
                            ],
                            [
                                -12.92992,
                                12.53112
                            ],
                            [
                                -12.88783,
                                12.54011
                            ],
                            [
                                -12.83274,
                                12.48634
                            ],
                            [
                                -12.73616,
                                12.42958
                            ],
                            [
                                -12.63257,
                                12.43064
                            ],
                            [
                                -12.56218,
                                12.36847
                            ],
                            [
                                -12.50521,
                                12.39713
                            ],
                            [
                                -12.40217,
                                12.36705
                            ],
                            [
                                -12.33139,
                                12.31138
                            ],
                            [
                                -12.23536,
                                12.35467
                            ],
                            [
                                -12.15948,
                                12.36864
                            ],
                            [
                                -12.09592,
                                12.4212
                            ],
                            [
                                -12.01259,
                                12.39666
                            ],
                            [
                                -11.89476,
                                12.42731
                            ],
                            [
                                -11.86154,
                                12.40258
                            ],
                            [
                                -11.75896,
                                12.38843
                            ],
                            [
                                -11.66249,
                                12.42318
                            ],
                            [
                                -11.45984,
                                12.441
                            ],
                            [
                                -11.37946,
                                12.41356
                            ],
                            [
                                -11.35586,
                                12.4978
                            ],
                            [
                                -11.44,
                                12.56557
                            ],
                            [
                                -11.40458,
                                12.58814
                            ],
                            [
                                -11.44245,
                                12.66286
                            ],
                            [
                                -11.42256,
                                12.72716
                            ],
                            [
                                -11.38079,
                                12.72833
                            ],
                            [
                                -11.38416,
                                12.82721
                            ],
                            [
                                -11.40844,
                                12.8472
                            ],
                            [
                                -11.38028,
                                12.99172
                            ],
                            [
                                -11.51751,
                                13.15853
                            ],
                            [
                                -11.52365,
                                13.25695
                            ],
                            [
                                -11.58758,
                                13.31043
                            ],
                            [
                                -11.59768,
                                13.36448
                            ],
                            [
                                -11.64304,
                                13.39494
                            ],
                            [
                                -11.74384,
                                13.40793
                            ],
                            [
                                -11.79908,
                                13.311
                            ],
                            [
                                -11.88738,
                                13.38704
                            ],
                            [
                                -11.86745,
                                13.46043
                            ],
                            [
                                -11.9694,
                                13.53497
                            ],
                            [
                                -12.03604,
                                13.62248
                            ],
                            [
                                -12.07213,
                                13.71962
                            ],
                            [
                                -11.94833,
                                13.80781
                            ],
                            [
                                -11.93376,
                                13.92121
                            ],
                            [
                                -12.01405,
                                14.00101
                            ],
                            [
                                -11.98743,
                                14.16674
                            ],
                            [
                                -12.02626,
                                14.28565
                            ],
                            [
                                -12.09282,
                                14.30656
                            ],
                            [
                                -12.12721,
                                14.3857
                            ],
                            [
                                -12.19173,
                                14.40282
                            ],
                            [
                                -12.21599,
                                14.54857
                            ],
                            [
                                -12.18635,
                                14.55682
                            ],
                            [
                                -12.14481,
                                14.64597
                            ],
                            [
                                -12.21263,
                                14.70322
                            ],
                            [
                                -12.23916,
                                14.75937
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -16.58773,
                                13.84325
                            ],
                            [
                                -16.49195,
                                13.95692
                            ],
                            [
                                -16.47247,
                                14.04989
                            ],
                            [
                                -16.37622,
                                14.09155
                            ],
                            [
                                -16.38779,
                                14.14009
                            ],
                            [
                                -16.48343,
                                14.12301
                            ],
                            [
                                -16.62063,
                                13.97626
                            ],
                            [
                                -16.69188,
                                13.9972
                            ],
                            [
                                -16.73769,
                                13.95129
                            ],
                            [
                                -16.7288,
                                13.83491
                            ],
                            [
                                -16.68328,
                                13.78531
                            ],
                            [
                                -16.58773,
                                13.84325
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -16.58773,
                                14.04843
                            ],
                            [
                                -16.65281,
                                14.07182
                            ],
                            [
                                -16.6806,
                                14.01566
                            ],
                            [
                                -16.61947,
                                13.99926
                            ],
                            [
                                -16.58773,
                                14.04843
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "SRB",
                "Country": "Serbia",
                "Total_3GHG": 0.13,
                "Total_3GHG_timeseries": [
                    3.693e-06,
                    7.4161e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002
                ],
                "Fossil_3GHG": 0.15,
                "Fossil_3GHG_timeseries": [
                    4.6691e-08,
                    9.3778e-08,
                    1.4126e-07,
                    1.8913e-07,
                    2.3737e-07,
                    2.8599e-07,
                    3.3497e-07,
                    3.8429e-07,
                    4.3395e-07,
                    4.8393e-07,
                    5.3487e-07,
                    5.8677e-07,
                    6.3962e-07,
                    6.9342e-07,
                    7.4818e-07,
                    8.0388e-07,
                    8.6053e-07,
                    9.1812e-07,
                    9.7666e-07,
                    1.0362e-06,
                    1.0968e-06,
                    1.1587e-06,
                    1.2219e-06,
                    1.2867e-06,
                    1.3528e-06,
                    1.4205e-06,
                    1.4897e-06,
                    1.5602e-06,
                    1.6321e-06,
                    1.7052e-06,
                    1.7789e-06,
                    1.8533e-06,
                    1.9283e-06,
                    2.0038e-06,
                    2.086e-06,
                    2.1627e-06,
                    2.2401e-06,
                    2.318e-06,
                    2.3965e-06,
                    2.4939e-06,
                    2.595e-06,
                    2.699e-06,
                    2.8219e-06,
                    2.9831e-06,
                    3.1451e-06,
                    3.3168e-06,
                    3.4696e-06,
                    3.6586e-06,
                    3.8657e-06,
                    4.1164e-06,
                    4.3781e-06,
                    4.6242e-06,
                    4.8804e-06,
                    5.1443e-06,
                    5.4202e-06,
                    5.7331e-06,
                    6.0459e-06,
                    6.3736e-06,
                    6.704e-06,
                    7.0261e-06,
                    7.3669e-06,
                    7.7104e-06,
                    8.5937e-06,
                    8.6144e-06,
                    8.6299e-06,
                    8.6399e-06,
                    8.645e-06,
                    8.6438e-06,
                    9.2509e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016
                ],
                "Land_3GHG": 0.08,
                "Land_3GHG_timeseries": [
                    3.6463e-06,
                    7.3223e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Total_CO2": 0.13,
                "Total_CO2_timeseries": [
                    2.8657e-06,
                    5.7556e-06,
                    8.6765e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015
                ],
                "Fossil_CO2": 0.17,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    5.906e-09,
                    5.906e-09,
                    5.906e-09,
                    5.906e-09,
                    5.906e-09,
                    2.3624e-08,
                    4.4295e-08,
                    6.7181e-08,
                    1.0778e-07,
                    1.853e-07,
                    2.6282e-07,
                    3.4919e-07,
                    4.1637e-07,
                    5.1825e-07,
                    6.3711e-07,
                    7.9805e-07,
                    9.7376e-07,
                    1.1384e-06,
                    1.317e-06,
                    1.5075e-06,
                    1.7142e-06,
                    1.9615e-06,
                    2.2133e-06,
                    2.4842e-06,
                    2.7625e-06,
                    3.0379e-06,
                    3.3362e-06,
                    3.6418e-06,
                    4.4812e-06,
                    4.4812e-06,
                    4.4812e-06,
                    4.4812e-06,
                    4.4812e-06,
                    4.4812e-06,
                    5.0829e-06,
                    5.8817e-06,
                    6.7321e-06,
                    7.968e-06,
                    9.316e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013
                ],
                "Land_CO2": 0.04,
                "Land_CO2_timeseries": [
                    2.8657e-06,
                    5.7556e-06,
                    8.6765e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Total_CH4": 0.1,
                "Total_CH4_timeseries": [
                    7.44e-07,
                    1.4924e-06,
                    2.2453e-06,
                    3.0027e-06,
                    3.7645e-06,
                    4.5307e-06,
                    5.3014e-06,
                    6.0765e-06,
                    6.8561e-06,
                    7.6401e-06,
                    8.4512e-06,
                    9.2895e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Fossil_CH4": 0.09,
                "Fossil_CH4_timeseries": [
                    2.0153e-08,
                    4.0392e-08,
                    6.0719e-08,
                    8.1132e-08,
                    1.0163e-07,
                    1.2222e-07,
                    1.4289e-07,
                    1.6364e-07,
                    1.8448e-07,
                    2.0541e-07,
                    2.2707e-07,
                    2.4946e-07,
                    2.7259e-07,
                    2.9645e-07,
                    3.2104e-07,
                    3.4636e-07,
                    3.724e-07,
                    3.9917e-07,
                    4.2667e-07,
                    4.5488e-07,
                    4.8393e-07,
                    5.138e-07,
                    5.4451e-07,
                    5.7603e-07,
                    6.0838e-07,
                    6.4155e-07,
                    6.7554e-07,
                    7.1035e-07,
                    7.4597e-07,
                    7.824e-07,
                    8.1915e-07,
                    8.5623e-07,
                    8.9363e-07,
                    9.3136e-07,
                    9.6952e-07,
                    1.0079e-06,
                    1.0465e-06,
                    1.0855e-06,
                    1.1248e-06,
                    1.1648e-06,
                    1.2052e-06,
                    1.246e-06,
                    1.2875e-06,
                    1.3301e-06,
                    1.373e-06,
                    1.4164e-06,
                    1.4598e-06,
                    1.5043e-06,
                    1.5494e-06,
                    1.5957e-06,
                    1.6377e-06,
                    1.6748e-06,
                    1.7074e-06,
                    1.7353e-06,
                    1.7584e-06,
                    1.7775e-06,
                    1.7914e-06,
                    1.8005e-06,
                    1.8043e-06,
                    1.8023e-06,
                    1.7957e-06,
                    1.784e-06,
                    1.7779e-06,
                    1.7481e-06,
                    1.7127e-06,
                    1.6714e-06,
                    1.6247e-06,
                    1.5713e-06,
                    1.524e-06,
                    1.4738e-06,
                    1.4332e-06,
                    1.4155e-06,
                    1.4089e-06,
                    1.4124e-06,
                    1.5363e-06,
                    1.677e-06,
                    1.841e-06,
                    2.0267e-06,
                    2.2372e-06,
                    2.4681e-06,
                    2.7058e-06,
                    2.9628e-06,
                    3.2257e-06,
                    3.5258e-06,
                    3.8474e-06,
                    4.1929e-06,
                    4.5629e-06,
                    4.9421e-06,
                    5.3336e-06,
                    5.7508e-06,
                    6.1375e-06,
                    6.5254e-06,
                    6.9256e-06,
                    7.3419e-06,
                    7.6863e-06,
                    8.0553e-06,
                    8.4398e-06,
                    8.8316e-06,
                    9.2321e-06,
                    9.6655e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_CH4": 0.12,
                "Land_CH4_timeseries": [
                    7.2385e-07,
                    1.4521e-06,
                    2.1846e-06,
                    2.9215e-06,
                    3.6628e-06,
                    4.4085e-06,
                    5.1585e-06,
                    5.9129e-06,
                    6.6716e-06,
                    7.4347e-06,
                    8.2242e-06,
                    9.04e-06,
                    9.8823e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Total_N2O": 0.19,
                "Total_N2O_timeseries": [
                    8.3339e-08,
                    1.6812e-07,
                    2.543e-07,
                    3.418e-07,
                    4.3053e-07,
                    5.2036e-07,
                    6.1118e-07,
                    7.0282e-07,
                    7.9512e-07,
                    8.8786e-07,
                    9.8095e-07,
                    1.0743e-06,
                    1.168e-06,
                    1.2619e-06,
                    1.3561e-06,
                    1.4506e-06,
                    1.5453e-06,
                    1.6403e-06,
                    1.7356e-06,
                    1.8313e-06,
                    1.9283e-06,
                    2.0285e-06,
                    2.1333e-06,
                    2.2435e-06,
                    2.3598e-06,
                    2.4822e-06,
                    2.6105e-06,
                    2.744e-06,
                    2.8816e-06,
                    3.0218e-06,
                    3.1635e-06,
                    3.3065e-06,
                    3.4507e-06,
                    3.5959e-06,
                    3.742e-06,
                    3.8891e-06,
                    4.0371e-06,
                    4.1859e-06,
                    4.3359e-06,
                    4.4985e-06,
                    4.6536e-06,
                    4.8015e-06,
                    4.9427e-06,
                    5.0776e-06,
                    5.207e-06,
                    5.3317e-06,
                    5.4527e-06,
                    5.5709e-06,
                    5.6876e-06,
                    5.8041e-06,
                    5.921e-06,
                    6.0389e-06,
                    6.1578e-06,
                    6.2779e-06,
                    6.3996e-06,
                    6.5231e-06,
                    6.6484e-06,
                    6.7757e-06,
                    6.9053e-06,
                    7.0372e-06,
                    7.1738e-06,
                    7.3192e-06,
                    7.477e-06,
                    7.6503e-06,
                    7.8414e-06,
                    8.0522e-06,
                    8.2839e-06,
                    8.5372e-06,
                    8.8122e-06,
                    9.1085e-06,
                    9.4294e-06,
                    9.7816e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_N2O": 0.17,
                "Fossil_N2O_timeseries": [
                    2.6538e-08,
                    5.3386e-08,
                    8.054e-08,
                    1.0799e-07,
                    1.3574e-07,
                    1.6377e-07,
                    1.9208e-07,
                    2.2065e-07,
                    2.4947e-07,
                    2.7852e-07,
                    3.078e-07,
                    3.373e-07,
                    3.6703e-07,
                    3.9697e-07,
                    4.2713e-07,
                    4.5752e-07,
                    4.8812e-07,
                    5.1895e-07,
                    5.4999e-07,
                    5.8127e-07,
                    6.1285e-07,
                    6.4487e-07,
                    6.7744e-07,
                    7.1062e-07,
                    7.4446e-07,
                    7.7897e-07,
                    8.1413e-07,
                    8.4988e-07,
                    8.8614e-07,
                    9.228e-07,
                    9.5978e-07,
                    9.9705e-07,
                    1.0346e-06,
                    1.0725e-06,
                    1.1106e-06,
                    1.149e-06,
                    1.1876e-06,
                    1.2265e-06,
                    1.2657e-06,
                    1.3054e-06,
                    1.3455e-06,
                    1.3859e-06,
                    1.4266e-06,
                    1.4678e-06,
                    1.5093e-06,
                    1.5511e-06,
                    1.5934e-06,
                    1.6361e-06,
                    1.6792e-06,
                    1.7227e-06,
                    1.7666e-06,
                    1.811e-06,
                    1.856e-06,
                    1.9015e-06,
                    1.9475e-06,
                    1.9941e-06,
                    2.0413e-06,
                    2.089e-06,
                    2.1372e-06,
                    2.1858e-06,
                    2.235e-06,
                    2.2846e-06,
                    2.3346e-06,
                    2.3851e-06,
                    2.436e-06,
                    2.4873e-06,
                    2.5391e-06,
                    2.5913e-06,
                    2.644e-06,
                    2.6971e-06,
                    2.7507e-06,
                    2.8048e-06,
                    2.8595e-06,
                    2.9146e-06,
                    2.9703e-06,
                    3.0266e-06,
                    3.0834e-06,
                    3.1407e-06,
                    3.1985e-06,
                    3.2568e-06,
                    3.3161e-06,
                    3.3769e-06,
                    3.4401e-06,
                    3.506e-06,
                    3.5751e-06,
                    3.6475e-06,
                    3.7235e-06,
                    3.803e-06,
                    3.8859e-06,
                    3.9718e-06,
                    4.061e-06,
                    4.1537e-06,
                    4.2502e-06,
                    4.351e-06,
                    4.4564e-06,
                    4.5667e-06,
                    4.682e-06,
                    4.8028e-06,
                    4.9293e-06,
                    5.0617e-06,
                    5.2019e-06,
                    5.3534e-06,
                    5.5191e-06,
                    5.7016e-06,
                    5.9029e-06,
                    6.1246e-06,
                    6.3682e-06,
                    6.6342e-06,
                    6.9231e-06,
                    7.2348e-06,
                    7.5707e-06,
                    7.9333e-06,
                    8.3249e-06,
                    8.7475e-06,
                    9.2024e-06,
                    9.6908e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.2,
                "Land_N2O_timeseries": [
                    5.6801e-08,
                    1.1474e-07,
                    1.7376e-07,
                    2.3381e-07,
                    2.9478e-07,
                    3.5659e-07,
                    4.191e-07,
                    4.8217e-07,
                    5.4565e-07,
                    6.0934e-07,
                    6.7315e-07,
                    7.3703e-07,
                    8.0098e-07,
                    8.6496e-07,
                    9.2899e-07,
                    9.9306e-07,
                    1.0572e-06,
                    1.1213e-06,
                    1.1856e-06,
                    1.25e-06,
                    1.3154e-06,
                    1.3836e-06,
                    1.4558e-06,
                    1.5329e-06,
                    1.6153e-06,
                    1.7032e-06,
                    1.7964e-06,
                    1.8941e-06,
                    1.9955e-06,
                    2.099e-06,
                    2.2037e-06,
                    2.3094e-06,
                    2.4161e-06,
                    2.5234e-06,
                    2.6315e-06,
                    2.7401e-06,
                    2.8494e-06,
                    2.9594e-06,
                    3.0701e-06,
                    3.1931e-06,
                    3.3082e-06,
                    3.4157e-06,
                    3.516e-06,
                    3.6098e-06,
                    3.6978e-06,
                    3.7806e-06,
                    3.8593e-06,
                    3.9349e-06,
                    4.0085e-06,
                    4.0814e-06,
                    4.1544e-06,
                    4.2278e-06,
                    4.3018e-06,
                    4.3765e-06,
                    4.4521e-06,
                    4.5289e-06,
                    4.6071e-06,
                    4.6868e-06,
                    4.7681e-06,
                    4.8514e-06,
                    4.9388e-06,
                    5.0346e-06,
                    5.1424e-06,
                    5.2652e-06,
                    5.4054e-06,
                    5.5648e-06,
                    5.7448e-06,
                    5.9459e-06,
                    6.1683e-06,
                    6.4114e-06,
                    6.6787e-06,
                    6.9767e-06,
                    7.3098e-06,
                    7.6801e-06,
                    8.0876e-06,
                    8.5305e-06,
                    9.0045e-06,
                    9.5034e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            20.2643,
                            46.12637
                        ],
                        [
                            20.18215,
                            46.15931
                        ],
                        [
                            20.06374,
                            46.14366
                        ],
                        [
                            19.93704,
                            46.17621
                        ],
                        [
                            19.81723,
                            46.12854
                        ],
                        [
                            19.6981,
                            46.18793
                        ],
                        [
                            19.56694,
                            46.17825
                        ],
                        [
                            19.50354,
                            46.14177
                        ],
                        [
                            19.41475,
                            46.04585
                        ],
                        [
                            19.36417,
                            46.05216
                        ],
                        [
                            19.28534,
                            45.99676
                        ],
                        [
                            19.14773,
                            45.9961
                        ],
                        [
                            19.10458,
                            46.03998
                        ],
                        [
                            18.98695,
                            45.93172
                        ],
                        [
                            18.88973,
                            45.92118
                        ],
                        [
                            18.85679,
                            45.86003
                        ],
                        [
                            18.97665,
                            45.73908
                        ],
                        [
                            18.92848,
                            45.68941
                        ],
                        [
                            18.9269,
                            45.54408
                        ],
                        [
                            19.09478,
                            45.51951
                        ],
                        [
                            18.99207,
                            45.48039
                        ],
                        [
                            19.00221,
                            45.35862
                        ],
                        [
                            19.09169,
                            45.33511
                        ],
                        [
                            19.11122,
                            45.29466
                        ],
                        [
                            19.26204,
                            45.24232
                        ],
                        [
                            19.42013,
                            45.23318
                        ],
                        [
                            19.41769,
                            45.16624
                        ],
                        [
                            19.23776,
                            45.17601
                        ],
                        [
                            19.14341,
                            45.13108
                        ],
                        [
                            19.09187,
                            44.99497
                        ],
                        [
                            19.14216,
                            44.94088
                        ],
                        [
                            18.98989,
                            44.90611
                        ],
                        [
                            19.02207,
                            44.85535
                        ],
                        [
                            19.17159,
                            44.92054
                        ],
                        [
                            19.31033,
                            44.90767
                        ],
                        [
                            19.36707,
                            44.87966
                        ],
                        [
                            19.30555,
                            44.79419
                        ],
                        [
                            19.29799,
                            44.68766
                        ],
                        [
                            19.16625,
                            44.52386
                        ],
                        [
                            19.12346,
                            44.49957
                        ],
                        [
                            19.14889,
                            44.43714
                        ],
                        [
                            19.10302,
                            44.37237
                        ],
                        [
                            19.13281,
                            44.31671
                        ],
                        [
                            19.24272,
                            44.26167
                        ],
                        [
                            19.32531,
                            44.27088
                        ],
                        [
                            19.35917,
                            44.18467
                        ],
                        [
                            19.59908,
                            44.07014
                        ],
                        [
                            19.61717,
                            44.01367
                        ],
                        [
                            19.52783,
                            43.95697
                        ],
                        [
                            19.3863,
                            43.96091
                        ],
                        [
                            19.23652,
                            43.98839
                        ],
                        [
                            19.39561,
                            43.79835
                        ],
                        [
                            19.51799,
                            43.71422
                        ],
                        [
                            19.5259,
                            43.6502
                        ],
                        [
                            19.47925,
                            43.57225
                        ],
                        [
                            19.36839,
                            43.60998
                        ],
                        [
                            19.27216,
                            43.59636
                        ],
                        [
                            19.22407,
                            43.52754
                        ],
                        [
                            19.22251,
                            43.48269
                        ],
                        [
                            19.34894,
                            43.41698
                        ],
                        [
                            19.44842,
                            43.38749
                        ],
                        [
                            19.52247,
                            43.32015
                        ],
                        [
                            19.54523,
                            43.24785
                        ],
                        [
                            19.61698,
                            43.23051
                        ],
                        [
                            19.6859,
                            43.16861
                        ],
                        [
                            19.77038,
                            43.16551
                        ],
                        [
                            19.78859,
                            43.12573
                        ],
                        [
                            19.96844,
                            43.08569
                        ],
                        [
                            20.11878,
                            42.96542
                        ],
                        [
                            20.15395,
                            42.97608
                        ],
                        [
                            20.34453,
                            42.9092
                        ],
                        [
                            20.35293,
                            42.83338
                        ],
                        [
                            20.25542,
                            42.81343
                        ],
                        [
                            20.19031,
                            42.747
                        ],
                        [
                            20.05722,
                            42.77806
                        ],
                        [
                            20.03466,
                            42.69801
                        ],
                        [
                            20.11194,
                            42.6554
                        ],
                        [
                            20.0763,
                            42.55582
                        ],
                        [
                            20.16495,
                            42.50593
                        ],
                        [
                            20.21848,
                            42.43544
                        ],
                        [
                            20.26033,
                            42.31916
                        ],
                        [
                            20.32479,
                            42.32597
                        ],
                        [
                            20.4567,
                            42.27187
                        ],
                        [
                            20.55799,
                            42.14669
                        ],
                        [
                            20.55555,
                            42.08404
                        ],
                        [
                            20.62603,
                            41.96333
                        ],
                        [
                            20.59429,
                            41.87733
                        ],
                        [
                            20.72797,
                            41.86428
                        ],
                        [
                            20.77652,
                            41.91849
                        ],
                        [
                            20.7489,
                            41.98449
                        ],
                        [
                            20.75996,
                            42.05347
                        ],
                        [
                            20.9447,
                            42.13754
                        ],
                        [
                            21.02644,
                            42.15225
                        ],
                        [
                            21.09927,
                            42.20343
                        ],
                        [
                            21.16184,
                            42.19646
                        ],
                        [
                            21.22311,
                            42.09556
                        ],
                        [
                            21.29621,
                            42.11076
                        ],
                        [
                            21.31939,
                            42.173
                        ],
                        [
                            21.44504,
                            42.27698
                        ],
                        [
                            21.69796,
                            42.23282
                        ],
                        [
                            21.84996,
                            42.32553
                        ],
                        [
                            21.94691,
                            42.34364
                        ],
                        [
                            22.03136,
                            42.29872
                        ],
                        [
                            22.22883,
                            42.33549
                        ],
                        [
                            22.28805,
                            42.37188
                        ],
                        [
                            22.36021,
                            42.31116
                        ],
                        [
                            22.45553,
                            42.33366
                        ],
                        [
                            22.51809,
                            42.39666
                        ],
                        [
                            22.54632,
                            42.50821
                        ],
                        [
                            22.43914,
                            42.56646
                        ],
                        [
                            22.47642,
                            42.71056
                        ],
                        [
                            22.50092,
                            42.73918
                        ],
                        [
                            22.44091,
                            42.80688
                        ],
                        [
                            22.53745,
                            42.88128
                        ],
                        [
                            22.6172,
                            42.8957
                        ],
                        [
                            22.67518,
                            42.86678
                        ],
                        [
                            22.74431,
                            42.88658
                        ],
                        [
                            22.78545,
                            42.98139
                        ],
                        [
                            22.89704,
                            43.03563
                        ],
                        [
                            22.98264,
                            43.11165
                        ],
                        [
                            22.98371,
                            43.20193
                        ],
                        [
                            22.89768,
                            43.22652
                        ],
                        [
                            22.82621,
                            43.3304
                        ],
                        [
                            22.76843,
                            43.37533
                        ],
                        [
                            22.68034,
                            43.39447
                        ],
                        [
                            22.5349,
                            43.47127
                        ],
                        [
                            22.48817,
                            43.56743
                        ],
                        [
                            22.4787,
                            43.65602
                        ],
                        [
                            22.40784,
                            43.69597
                        ],
                        [
                            22.3575,
                            43.81003
                        ],
                        [
                            22.40847,
                            43.94116
                        ],
                        [
                            22.41103,
                            44.0047
                        ],
                        [
                            22.53106,
                            44.02083
                        ],
                        [
                            22.62121,
                            44.06338
                        ],
                        [
                            22.61427,
                            44.165
                        ],
                        [
                            22.67516,
                            44.21566
                        ],
                        [
                            22.6826,
                            44.2744
                        ],
                        [
                            22.5593,
                            44.30881
                        ],
                        [
                            22.45787,
                            44.46642
                        ],
                        [
                            22.54935,
                            44.48215
                        ],
                        [
                            22.61784,
                            44.55218
                        ],
                        [
                            22.6986,
                            44.51699
                        ],
                        [
                            22.75787,
                            44.56055
                        ],
                        [
                            22.66842,
                            44.61868
                        ],
                        [
                            22.62075,
                            44.61521
                        ],
                        [
                            22.48297,
                            44.70814
                        ],
                        [
                            22.3325,
                            44.6754
                        ],
                        [
                            22.27544,
                            44.62631
                        ],
                        [
                            22.18243,
                            44.48239
                        ],
                        [
                            22.1277,
                            44.47436
                        ],
                        [
                            22.03653,
                            44.54303
                        ],
                        [
                            21.99785,
                            44.62913
                        ],
                        [
                            21.79175,
                            44.66371
                        ],
                        [
                            21.63827,
                            44.65971
                        ],
                        [
                            21.58779,
                            44.75842
                        ],
                        [
                            21.39832,
                            44.77851
                        ],
                        [
                            21.37034,
                            44.866
                        ],
                        [
                            21.55945,
                            44.88947
                        ],
                        [
                            21.54668,
                            44.93052
                        ],
                        [
                            21.43594,
                            44.96178
                        ],
                        [
                            21.36023,
                            45.02043
                        ],
                        [
                            21.45461,
                            45.04037
                        ],
                        [
                            21.5156,
                            45.1699
                        ],
                        [
                            21.4044,
                            45.22839
                        ],
                        [
                            21.21899,
                            45.25058
                        ],
                        [
                            21.18002,
                            45.31258
                        ],
                        [
                            21.09716,
                            45.29668
                        ],
                        [
                            20.95836,
                            45.36846
                        ],
                        [
                            20.83412,
                            45.4793
                        ],
                        [
                            20.83163,
                            45.53637
                        ],
                        [
                            20.76573,
                            45.61257
                        ],
                        [
                            20.80499,
                            45.65723
                        ],
                        [
                            20.80289,
                            45.73784
                        ],
                        [
                            20.70073,
                            45.75131
                        ],
                        [
                            20.65864,
                            45.83037
                        ],
                        [
                            20.51556,
                            45.89296
                        ],
                        [
                            20.48291,
                            45.95284
                        ],
                        [
                            20.34974,
                            45.99894
                        ],
                        [
                            20.34588,
                            46.04742
                        ],
                        [
                            20.2643,
                            46.12637
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "SYC",
                "Country": "Seychelles",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    6.5524e-10,
                    1.3127e-09,
                    1.9724e-09,
                    2.6343e-09,
                    3.299e-09,
                    3.9666e-09,
                    4.6369e-09,
                    5.31e-09,
                    5.9856e-09,
                    6.6637e-09,
                    7.3515e-09,
                    8.0487e-09,
                    8.8077e-09,
                    9.576e-09,
                    1.0354e-08,
                    1.1141e-08,
                    1.1937e-08,
                    1.2743e-08,
                    1.3558e-08,
                    1.4383e-08,
                    1.5207e-08,
                    1.6043e-08,
                    1.6892e-08,
                    1.7755e-08,
                    1.8632e-08,
                    1.9521e-08,
                    2.0425e-08,
                    2.134e-08,
                    2.2268e-08,
                    2.3207e-08,
                    2.4149e-08,
                    2.5094e-08,
                    2.5994e-08,
                    2.6897e-08,
                    2.7803e-08,
                    2.8713e-08,
                    2.9626e-08,
                    3.0541e-08,
                    3.146e-08,
                    3.2385e-08,
                    3.3314e-08,
                    3.4247e-08,
                    3.5183e-08,
                    3.6123e-08,
                    3.7068e-08,
                    3.8016e-08,
                    3.8969e-08,
                    3.9926e-08,
                    4.0887e-08,
                    4.1853e-08,
                    4.2819e-08,
                    4.379e-08,
                    4.4764e-08,
                    4.5741e-08,
                    4.672e-08,
                    4.7703e-08,
                    4.869e-08,
                    4.9681e-08,
                    5.0676e-08,
                    5.1675e-08,
                    5.2801e-08,
                    5.4052e-08,
                    5.5434e-08,
                    5.6946e-08,
                    5.8587e-08,
                    6.0359e-08,
                    6.2259e-08,
                    6.429e-08,
                    6.6449e-08,
                    6.8738e-08,
                    7.1189e-08,
                    7.3827e-08,
                    7.6631e-08,
                    7.9599e-08,
                    8.2732e-08,
                    8.6029e-08,
                    8.9489e-08,
                    9.3112e-08,
                    9.6896e-08,
                    1.0084e-07,
                    1.0486e-07,
                    1.0896e-07,
                    1.1313e-07,
                    1.1737e-07,
                    1.2169e-07,
                    1.2606e-07,
                    1.3047e-07,
                    1.3493e-07,
                    1.3944e-07,
                    1.44e-07,
                    1.4863e-07,
                    1.5334e-07,
                    1.5818e-07,
                    1.6316e-07,
                    1.6894e-07,
                    1.7557e-07,
                    1.8305e-07,
                    1.9141e-07,
                    2.0066e-07,
                    2.1079e-07,
                    2.219e-07,
                    2.34e-07,
                    2.4712e-07,
                    2.6127e-07,
                    2.7645e-07,
                    2.9274e-07,
                    3.1016e-07,
                    3.288e-07,
                    3.488e-07,
                    3.703e-07,
                    3.942e-07,
                    4.1981e-07,
                    4.5104e-07,
                    4.8433e-07,
                    5.1925e-07,
                    5.56e-07,
                    5.9443e-07,
                    6.3476e-07,
                    6.7707e-07,
                    7.2528e-07,
                    7.8126e-07,
                    8.4504e-07,
                    9.1305e-07,
                    9.873e-07,
                    1.0664e-06,
                    1.1574e-06,
                    1.2512e-06,
                    1.3435e-06,
                    1.4574e-06,
                    1.561e-06,
                    1.6654e-06,
                    1.7637e-06,
                    1.8669e-06,
                    1.9679e-06,
                    2.0913e-06,
                    2.2195e-06,
                    2.3627e-06,
                    2.5041e-06,
                    2.6596e-06,
                    2.7812e-06,
                    2.91e-06,
                    3.0354e-06,
                    3.1647e-06,
                    3.3004e-06,
                    3.4315e-06,
                    3.5776e-06,
                    3.7423e-06,
                    3.9119e-06,
                    4.0872e-06,
                    4.2711e-06,
                    4.4675e-06,
                    4.6666e-06,
                    4.8619e-06,
                    5.0756e-06,
                    5.2945e-06,
                    5.5177e-06,
                    5.7493e-06,
                    5.9861e-06,
                    6.2357e-06,
                    6.4864e-06,
                    6.7192e-06,
                    6.9624e-06,
                    7.2003e-06,
                    7.4612e-06,
                    7.7432e-06,
                    8.0532e-06,
                    8.3734e-06,
                    8.7044e-06,
                    9.0326e-06,
                    9.3665e-06,
                    9.7271e-06,
                    0
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    4.9392e-10,
                    9.8932e-10,
                    1.4862e-09,
                    1.9846e-09,
                    2.4852e-09,
                    2.9881e-09,
                    3.4932e-09,
                    4.0006e-09,
                    4.5103e-09,
                    5.0221e-09,
                    5.5416e-09,
                    6.0683e-09,
                    6.6546e-09,
                    7.2481e-09,
                    7.8488e-09,
                    8.4568e-09,
                    9.072e-09,
                    9.6945e-09,
                    1.0324e-08,
                    1.0961e-08,
                    1.1595e-08,
                    1.2237e-08,
                    1.2887e-08,
                    1.3547e-08,
                    1.4214e-08,
                    1.489e-08,
                    1.5574e-08,
                    1.6266e-08,
                    1.6965e-08,
                    1.7672e-08,
                    1.8382e-08,
                    1.9094e-08,
                    1.9759e-08,
                    2.0427e-08,
                    2.1098e-08,
                    2.1771e-08,
                    2.2446e-08,
                    2.3123e-08,
                    2.3803e-08,
                    2.4486e-08,
                    2.5171e-08,
                    2.586e-08,
                    2.6551e-08,
                    2.7244e-08,
                    2.7941e-08,
                    2.8641e-08,
                    2.9343e-08,
                    3.0049e-08,
                    3.0758e-08,
                    3.1471e-08,
                    3.2182e-08,
                    3.2897e-08,
                    3.3613e-08,
                    3.4332e-08,
                    3.5052e-08,
                    3.5773e-08,
                    3.6498e-08,
                    3.7225e-08,
                    3.7954e-08,
                    3.8686e-08,
                    3.9508e-08,
                    4.042e-08,
                    4.1423e-08,
                    4.2517e-08,
                    4.3702e-08,
                    4.4978e-08,
                    4.6342e-08,
                    4.7797e-08,
                    4.9342e-08,
                    5.0977e-08,
                    5.2728e-08,
                    5.4619e-08,
                    5.6627e-08,
                    5.8753e-08,
                    6.0997e-08,
                    6.3358e-08,
                    6.5835e-08,
                    6.8431e-08,
                    7.1144e-08,
                    7.3975e-08,
                    7.6864e-08,
                    7.9814e-08,
                    8.2821e-08,
                    8.5888e-08,
                    8.9014e-08,
                    9.22e-08,
                    9.5448e-08,
                    9.8755e-08,
                    1.0212e-07,
                    1.0555e-07,
                    1.0908e-07,
                    1.1267e-07,
                    1.1637e-07,
                    1.2016e-07,
                    1.2472e-07,
                    1.3006e-07,
                    1.3622e-07,
                    1.4324e-07,
                    1.5114e-07,
                    1.5994e-07,
                    1.6977e-07,
                    1.8064e-07,
                    1.926e-07,
                    2.0567e-07,
                    2.1987e-07,
                    2.3523e-07,
                    2.518e-07,
                    2.6963e-07,
                    2.8885e-07,
                    3.0959e-07,
                    3.3194e-07,
                    3.5608e-07,
                    3.8554e-07,
                    4.1703e-07,
                    4.5002e-07,
                    4.8453e-07,
                    5.206e-07,
                    5.5828e-07,
                    5.9771e-07,
                    6.4281e-07,
                    6.9512e-07,
                    7.5449e-07,
                    8.1782e-07,
                    8.869e-07,
                    9.6036e-07,
                    1.0456e-06,
                    1.1343e-06,
                    1.2209e-06,
                    1.3285e-06,
                    1.4254e-06,
                    1.523e-06,
                    1.6132e-06,
                    1.7101e-06,
                    1.8058e-06,
                    1.9229e-06,
                    2.0447e-06,
                    2.1816e-06,
                    2.3165e-06,
                    2.4652e-06,
                    2.5788e-06,
                    2.6996e-06,
                    2.8178e-06,
                    2.9403e-06,
                    3.0694e-06,
                    3.1944e-06,
                    3.3355e-06,
                    3.4945e-06,
                    3.6596e-06,
                    3.831e-06,
                    4.0127e-06,
                    4.2093e-06,
                    4.4075e-06,
                    4.6015e-06,
                    4.8145e-06,
                    5.034e-06,
                    5.2585e-06,
                    5.4911e-06,
                    5.7299e-06,
                    5.9824e-06,
                    6.2376e-06,
                    6.4751e-06,
                    6.7232e-06,
                    6.9659e-06,
                    7.2312e-06,
                    7.5172e-06,
                    7.8307e-06,
                    8.1542e-06,
                    8.4884e-06,
                    8.8193e-06,
                    9.1552e-06,
                    9.5166e-06,
                    9.8771e-06
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [
                    1.6132e-10,
                    3.234e-10,
                    4.862e-10,
                    6.4968e-10,
                    8.138e-10,
                    9.785e-10,
                    1.1437e-09,
                    1.3093e-09,
                    1.4753e-09,
                    1.6415e-09,
                    1.8099e-09,
                    1.9804e-09,
                    2.1531e-09,
                    2.3279e-09,
                    2.5049e-09,
                    2.6839e-09,
                    2.8652e-09,
                    3.0485e-09,
                    3.234e-09,
                    3.4217e-09,
                    3.6122e-09,
                    3.8064e-09,
                    4.005e-09,
                    4.2086e-09,
                    4.4173e-09,
                    4.6314e-09,
                    4.8506e-09,
                    5.0745e-09,
                    5.3027e-09,
                    5.5342e-09,
                    5.7668e-09,
                    6.0004e-09,
                    6.2348e-09,
                    6.4699e-09,
                    6.7058e-09,
                    6.9424e-09,
                    7.1797e-09,
                    7.4177e-09,
                    7.6566e-09,
                    7.899e-09,
                    8.1425e-09,
                    8.387e-09,
                    8.6325e-09,
                    8.8791e-09,
                    9.1268e-09,
                    9.3756e-09,
                    9.6256e-09,
                    9.8767e-09,
                    1.0129e-08,
                    1.0383e-08,
                    1.0637e-08,
                    1.0893e-08,
                    1.1151e-08,
                    1.1409e-08,
                    1.1669e-08,
                    1.1929e-08,
                    1.2192e-08,
                    1.2456e-08,
                    1.2721e-08,
                    1.2989e-08,
                    1.3292e-08,
                    1.3633e-08,
                    1.4011e-08,
                    1.4429e-08,
                    1.4885e-08,
                    1.5381e-08,
                    1.5917e-08,
                    1.6492e-08,
                    1.7107e-08,
                    1.7761e-08,
                    1.8461e-08,
                    1.9208e-08,
                    2.0003e-08,
                    2.0845e-08,
                    2.1735e-08,
                    2.2671e-08,
                    2.3654e-08,
                    2.4681e-08,
                    2.5752e-08,
                    2.6865e-08,
                    2.7995e-08,
                    2.9143e-08,
                    3.0306e-08,
                    3.1484e-08,
                    3.2677e-08,
                    3.3857e-08,
                    3.5024e-08,
                    3.6178e-08,
                    3.7318e-08,
                    3.8445e-08,
                    3.9552e-08,
                    4.0667e-08,
                    4.181e-08,
                    4.2994e-08,
                    4.4226e-08,
                    4.5506e-08,
                    4.6825e-08,
                    4.8171e-08,
                    4.9521e-08,
                    5.0847e-08,
                    5.2132e-08,
                    5.336e-08,
                    5.4518e-08,
                    5.5594e-08,
                    5.6581e-08,
                    5.7502e-08,
                    5.8361e-08,
                    5.9169e-08,
                    5.9944e-08,
                    6.071e-08,
                    6.2252e-08,
                    6.3729e-08,
                    6.5501e-08,
                    6.7294e-08,
                    6.9225e-08,
                    7.1469e-08,
                    7.3835e-08,
                    7.6483e-08,
                    7.9357e-08,
                    8.2473e-08,
                    8.614e-08,
                    9.0553e-08,
                    9.5228e-08,
                    1.004e-07,
                    1.0603e-07,
                    1.1173e-07,
                    1.1689e-07,
                    1.2259e-07,
                    1.2881e-07,
                    1.3558e-07,
                    1.4238e-07,
                    1.505e-07,
                    1.568e-07,
                    1.6213e-07,
                    1.6834e-07,
                    1.7479e-07,
                    1.8117e-07,
                    1.8765e-07,
                    1.944e-07,
                    2.0239e-07,
                    2.1042e-07,
                    2.1751e-07,
                    2.2441e-07,
                    2.3096e-07,
                    2.3704e-07,
                    2.4216e-07,
                    2.4772e-07,
                    2.5231e-07,
                    2.5621e-07,
                    2.5841e-07,
                    2.5819e-07,
                    2.591e-07,
                    2.604e-07,
                    2.6104e-07,
                    2.6051e-07,
                    2.5915e-07,
                    2.5822e-07,
                    2.5621e-07,
                    2.5324e-07,
                    2.4883e-07,
                    2.4404e-07,
                    2.3912e-07,
                    2.344e-07,
                    2.3002e-07,
                    2.26e-07,
                    2.2254e-07,
                    2.1915e-07,
                    2.1603e-07,
                    2.1328e-07,
                    2.1127e-07,
                    2.1046e-07,
                    2.0926e-07
                ],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    3.3e-09,
                    6.6e-09,
                    9.9e-09,
                    1.32e-08,
                    1.65e-08,
                    1.98e-08,
                    2.31e-08,
                    3.63e-08,
                    5.115e-08,
                    7.095e-08,
                    9.24e-08,
                    1.1715e-07,
                    1.4355e-07,
                    1.7985e-07,
                    2.178e-07,
                    2.5245e-07,
                    3.069e-07,
                    3.498e-07,
                    3.9435e-07,
                    4.323e-07,
                    4.7685e-07,
                    5.214e-07,
                    5.8905e-07,
                    6.633e-07,
                    7.5405e-07,
                    8.4315e-07,
                    9.4875e-07,
                    1.0164e-06,
                    1.0939e-06,
                    1.1715e-06,
                    1.254e-06,
                    1.3447e-06,
                    1.4339e-06,
                    1.5394e-06,
                    1.6632e-06,
                    1.7935e-06,
                    1.9305e-06,
                    2.0724e-06,
                    2.2275e-06,
                    2.3843e-06,
                    2.5377e-06,
                    2.7044e-06,
                    2.8759e-06,
                    3.0492e-06,
                    3.2307e-06,
                    3.4171e-06,
                    3.6152e-06,
                    3.8148e-06,
                    3.998e-06,
                    4.1893e-06,
                    4.3758e-06,
                    4.582e-06,
                    4.8065e-06,
                    5.0556e-06,
                    5.3147e-06,
                    5.5852e-06,
                    5.8526e-06,
                    6.1264e-06,
                    6.4248e-06,
                    6.7215e-06
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    3.3e-09,
                    6.6e-09,
                    9.9e-09,
                    1.32e-08,
                    1.65e-08,
                    1.98e-08,
                    2.31e-08,
                    3.63e-08,
                    5.115e-08,
                    7.095e-08,
                    9.24e-08,
                    1.1715e-07,
                    1.4355e-07,
                    1.7985e-07,
                    2.178e-07,
                    2.5245e-07,
                    3.069e-07,
                    3.498e-07,
                    3.9435e-07,
                    4.323e-07,
                    4.7685e-07,
                    5.214e-07,
                    5.8905e-07,
                    6.633e-07,
                    7.5405e-07,
                    8.4315e-07,
                    9.4875e-07,
                    1.0164e-06,
                    1.0939e-06,
                    1.1715e-06,
                    1.254e-06,
                    1.3447e-06,
                    1.4339e-06,
                    1.5394e-06,
                    1.6632e-06,
                    1.7935e-06,
                    1.9305e-06,
                    2.0724e-06,
                    2.2275e-06,
                    2.3843e-06,
                    2.5377e-06,
                    2.7044e-06,
                    2.8759e-06,
                    3.0492e-06,
                    3.2307e-06,
                    3.4171e-06,
                    3.6152e-06,
                    3.8148e-06,
                    3.998e-06,
                    4.1893e-06,
                    4.3758e-06,
                    4.582e-06,
                    4.8065e-06,
                    5.0556e-06,
                    5.3147e-06,
                    5.5852e-06,
                    5.8526e-06,
                    6.1264e-06,
                    6.4248e-06,
                    6.7215e-06
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [
                    4.8573e-10,
                    9.7157e-10,
                    1.4575e-09,
                    1.9436e-09,
                    2.4306e-09,
                    2.9186e-09,
                    3.4075e-09,
                    3.8974e-09,
                    4.3884e-09,
                    4.8804e-09,
                    5.3809e-09,
                    5.8894e-09,
                    6.4584e-09,
                    7.0355e-09,
                    7.6207e-09,
                    8.214e-09,
                    8.8154e-09,
                    9.4249e-09,
                    1.0043e-08,
                    1.0668e-08,
                    1.1291e-08,
                    1.1923e-08,
                    1.2563e-08,
                    1.3212e-08,
                    1.3869e-08,
                    1.4534e-08,
                    1.5207e-08,
                    1.5888e-08,
                    1.6576e-08,
                    1.7273e-08,
                    1.797e-08,
                    1.8669e-08,
                    1.932e-08,
                    1.9973e-08,
                    2.0628e-08,
                    2.1284e-08,
                    2.1941e-08,
                    2.2599e-08,
                    2.3259e-08,
                    2.3919e-08,
                    2.4581e-08,
                    2.5245e-08,
                    2.5909e-08,
                    2.6576e-08,
                    2.7244e-08,
                    2.7913e-08,
                    2.8584e-08,
                    2.9257e-08,
                    2.9931e-08,
                    3.0607e-08,
                    3.128e-08,
                    3.1956e-08,
                    3.2631e-08,
                    3.3306e-08,
                    3.3981e-08,
                    3.4655e-08,
                    3.5331e-08,
                    3.6007e-08,
                    3.6684e-08,
                    3.7361e-08,
                    3.8161e-08,
                    3.9081e-08,
                    4.0125e-08,
                    4.1291e-08,
                    4.258e-08,
                    4.399e-08,
                    4.5522e-08,
                    4.7176e-08,
                    4.895e-08,
                    5.0847e-08,
                    5.2899e-08,
                    5.513e-08,
                    5.7517e-08,
                    6.006e-08,
                    6.276e-08,
                    6.5616e-08,
                    6.8627e-08,
                    7.1795e-08,
                    7.512e-08,
                    7.8602e-08,
                    8.2157e-08,
                    8.579e-08,
                    8.9497e-08,
                    9.3279e-08,
                    9.7137e-08,
                    1.0104e-07,
                    1.05e-07,
                    1.09e-07,
                    1.1305e-07,
                    1.1714e-07,
                    1.2129e-07,
                    1.2547e-07,
                    1.297e-07,
                    1.3399e-07,
                    1.3899e-07,
                    1.4474e-07,
                    1.5125e-07,
                    1.5857e-07,
                    1.6672e-07,
                    1.7574e-07,
                    1.8573e-07,
                    1.9673e-07,
                    2.0877e-07,
                    2.2187e-07,
                    2.3604e-07,
                    2.5135e-07,
                    2.6783e-07,
                    2.8556e-07,
                    3.0464e-07,
                    3.2524e-07,
                    3.4803e-07,
                    3.7259e-07,
                    3.9934e-07,
                    4.2814e-07,
                    4.5855e-07,
                    4.9067e-07,
                    5.2446e-07,
                    5.6003e-07,
                    5.9753e-07,
                    6.3088e-07,
                    6.7011e-07,
                    7.119e-07,
                    7.5618e-07,
                    8.0324e-07,
                    8.5322e-07,
                    9.0511e-07,
                    9.5842e-07,
                    1.0133e-06,
                    1.0696e-06,
                    1.127e-06,
                    1.1836e-06,
                    1.2386e-06,
                    1.2925e-06,
                    1.3447e-06,
                    1.3959e-06,
                    1.4452e-06,
                    1.4926e-06,
                    1.5393e-06,
                    1.5834e-06,
                    1.6315e-06,
                    1.6755e-06,
                    1.7169e-06,
                    1.7572e-06,
                    1.7953e-06,
                    1.83e-06,
                    1.8636e-06,
                    1.8972e-06,
                    1.9293e-06,
                    1.9605e-06,
                    1.9929e-06,
                    2.0248e-06,
                    2.0586e-06,
                    2.0918e-06,
                    2.1281e-06,
                    2.1656e-06,
                    2.2051e-06,
                    2.2463e-06,
                    2.2874e-06,
                    2.3293e-06,
                    2.3718e-06,
                    2.4132e-06,
                    2.4563e-06,
                    2.4999e-06,
                    2.5454e-06,
                    2.5934e-06,
                    2.6433e-06,
                    2.6933e-06,
                    2.7432e-06,
                    2.7941e-06,
                    2.8441e-06,
                    2.8959e-06,
                    2.9479e-06
                ],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [
                    3.5659e-10,
                    7.1319e-10,
                    1.0698e-09,
                    1.4264e-09,
                    1.7838e-09,
                    2.1421e-09,
                    2.5012e-09,
                    2.8613e-09,
                    3.2222e-09,
                    3.5841e-09,
                    3.9524e-09,
                    4.3265e-09,
                    4.7591e-09,
                    5.1976e-09,
                    5.6422e-09,
                    6.0927e-09,
                    6.5492e-09,
                    7.0118e-09,
                    7.4803e-09,
                    7.9549e-09,
                    8.4245e-09,
                    8.9007e-09,
                    9.3833e-09,
                    9.8724e-09,
                    1.0367e-08,
                    1.0868e-08,
                    1.1374e-08,
                    1.1886e-08,
                    1.2404e-08,
                    1.2928e-08,
                    1.3452e-08,
                    1.3977e-08,
                    1.4455e-08,
                    1.4933e-08,
                    1.5413e-08,
                    1.5894e-08,
                    1.6376e-08,
                    1.6858e-08,
                    1.7342e-08,
                    1.7826e-08,
                    1.8311e-08,
                    1.8797e-08,
                    1.9285e-08,
                    1.9773e-08,
                    2.0263e-08,
                    2.0754e-08,
                    2.1246e-08,
                    2.1739e-08,
                    2.2234e-08,
                    2.273e-08,
                    2.3222e-08,
                    2.3717e-08,
                    2.4211e-08,
                    2.4705e-08,
                    2.5198e-08,
                    2.569e-08,
                    2.6183e-08,
                    2.6676e-08,
                    2.717e-08,
                    2.7663e-08,
                    2.8245e-08,
                    2.8915e-08,
                    2.9675e-08,
                    3.0523e-08,
                    3.1461e-08,
                    3.2487e-08,
                    3.36e-08,
                    3.4802e-08,
                    3.6092e-08,
                    3.747e-08,
                    3.8962e-08,
                    4.0593e-08,
                    4.2339e-08,
                    4.42e-08,
                    4.6177e-08,
                    4.827e-08,
                    5.0477e-08,
                    5.28e-08,
                    5.5239e-08,
                    5.7794e-08,
                    6.0405e-08,
                    6.3074e-08,
                    6.5798e-08,
                    6.858e-08,
                    7.1418e-08,
                    7.4314e-08,
                    7.7268e-08,
                    8.0279e-08,
                    8.3349e-08,
                    8.6477e-08,
                    8.9695e-08,
                    9.2981e-08,
                    9.6359e-08,
                    9.9831e-08,
                    1.0405e-07,
                    1.0906e-07,
                    1.1488e-07,
                    1.2154e-07,
                    1.2908e-07,
                    1.3753e-07,
                    1.4698e-07,
                    1.5748e-07,
                    1.6906e-07,
                    1.8175e-07,
                    1.9556e-07,
                    2.1052e-07,
                    2.2668e-07,
                    2.4411e-07,
                    2.6292e-07,
                    2.8324e-07,
                    3.0517e-07,
                    3.2888e-07,
                    3.546e-07,
                    3.8235e-07,
                    4.1159e-07,
                    4.4235e-07,
                    4.7465e-07,
                    5.0856e-07,
                    5.4422e-07,
                    5.7554e-07,
                    6.1241e-07,
                    6.5137e-07,
                    6.9262e-07,
                    7.3627e-07,
                    7.8254e-07,
                    8.306e-07,
                    8.8029e-07,
                    9.3117e-07,
                    9.8311e-07,
                    1.0357e-06,
                    1.0878e-06,
                    1.1389e-06,
                    1.1895e-06,
                    1.2387e-06,
                    1.2862e-06,
                    1.3317e-06,
                    1.3754e-06,
                    1.4182e-06,
                    1.4585e-06,
                    1.5016e-06,
                    1.5407e-06,
                    1.5779e-06,
                    1.6144e-06,
                    1.6493e-06,
                    1.6814e-06,
                    1.7131e-06,
                    1.7446e-06,
                    1.7755e-06,
                    1.8062e-06,
                    1.8392e-06,
                    1.8734e-06,
                    1.9083e-06,
                    1.9425e-06,
                    1.9801e-06,
                    2.02e-06,
                    2.0628e-06,
                    2.1069e-06,
                    2.1518e-06,
                    2.1982e-06,
                    2.2464e-06,
                    2.2941e-06,
                    2.3433e-06,
                    2.3928e-06,
                    2.4439e-06,
                    2.4972e-06,
                    2.5518e-06,
                    2.6064e-06,
                    2.6607e-06,
                    2.7155e-06,
                    2.7687e-06,
                    2.8225e-06,
                    2.877e-06
                ],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [
                    1.2914e-10,
                    2.5839e-10,
                    3.8774e-10,
                    5.1721e-10,
                    6.4678e-10,
                    7.7646e-10,
                    9.0625e-10,
                    1.0361e-09,
                    1.1662e-09,
                    1.2963e-09,
                    1.4285e-09,
                    1.5628e-09,
                    1.6993e-09,
                    1.8378e-09,
                    1.9785e-09,
                    2.1213e-09,
                    2.2662e-09,
                    2.4132e-09,
                    2.5623e-09,
                    2.7135e-09,
                    2.8669e-09,
                    3.0224e-09,
                    3.1801e-09,
                    3.34e-09,
                    3.5021e-09,
                    3.6663e-09,
                    3.8327e-09,
                    4.0013e-09,
                    4.172e-09,
                    4.345e-09,
                    4.5182e-09,
                    4.6918e-09,
                    4.8658e-09,
                    5.0401e-09,
                    5.2148e-09,
                    5.3898e-09,
                    5.5652e-09,
                    5.7409e-09,
                    5.917e-09,
                    6.0934e-09,
                    6.2702e-09,
                    6.4474e-09,
                    6.6249e-09,
                    6.8028e-09,
                    6.981e-09,
                    7.1596e-09,
                    7.3386e-09,
                    7.5179e-09,
                    7.6976e-09,
                    7.8776e-09,
                    8.058e-09,
                    8.2388e-09,
                    8.4199e-09,
                    8.6014e-09,
                    8.7833e-09,
                    8.9655e-09,
                    9.1482e-09,
                    9.3311e-09,
                    9.5145e-09,
                    9.6982e-09,
                    9.9154e-09,
                    1.0166e-08,
                    1.045e-08,
                    1.0768e-08,
                    1.1119e-08,
                    1.1504e-08,
                    1.1922e-08,
                    1.2374e-08,
                    1.2859e-08,
                    1.3377e-08,
                    1.3937e-08,
                    1.4537e-08,
                    1.5178e-08,
                    1.586e-08,
                    1.6583e-08,
                    1.7346e-08,
                    1.815e-08,
                    1.8995e-08,
                    1.9881e-08,
                    2.0808e-08,
                    2.1753e-08,
                    2.2716e-08,
                    2.3699e-08,
                    2.4699e-08,
                    2.5719e-08,
                    2.6729e-08,
                    2.7731e-08,
                    2.8721e-08,
                    2.97e-08,
                    3.0667e-08,
                    3.1597e-08,
                    3.249e-08,
                    3.3345e-08,
                    3.4161e-08,
                    3.4938e-08,
                    3.5675e-08,
                    3.6372e-08,
                    3.7028e-08,
                    3.7641e-08,
                    3.8213e-08,
                    3.8749e-08,
                    3.9248e-08,
                    3.9707e-08,
                    4.0122e-08,
                    4.0488e-08,
                    4.083e-08,
                    4.1147e-08,
                    4.1443e-08,
                    4.1726e-08,
                    4.2005e-08,
                    4.2859e-08,
                    4.3709e-08,
                    4.4744e-08,
                    4.5787e-08,
                    4.6955e-08,
                    4.8326e-08,
                    4.9808e-08,
                    5.1471e-08,
                    5.3312e-08,
                    5.5335e-08,
                    5.7698e-08,
                    6.0526e-08,
                    6.3565e-08,
                    6.6969e-08,
                    7.0676e-08,
                    7.4511e-08,
                    7.813e-08,
                    8.2141e-08,
                    8.6515e-08,
                    9.1266e-08,
                    9.5884e-08,
                    9.9743e-08,
                    1.0299e-07,
                    1.06e-07,
                    1.0968e-07,
                    1.1349e-07,
                    1.1724e-07,
                    1.2107e-07,
                    1.2493e-07,
                    1.2989e-07,
                    1.3481e-07,
                    1.3897e-07,
                    1.4279e-07,
                    1.4606e-07,
                    1.4867e-07,
                    1.5055e-07,
                    1.5256e-07,
                    1.5381e-07,
                    1.5437e-07,
                    1.5372e-07,
                    1.5144e-07,
                    1.5026e-07,
                    1.4932e-07,
                    1.4803e-07,
                    1.4558e-07,
                    1.4234e-07,
                    1.394e-07,
                    1.3563e-07,
                    1.3117e-07,
                    1.254e-07,
                    1.1907e-07,
                    1.1294e-07,
                    1.0713e-07,
                    1.0153e-07,
                    9.6236e-08,
                    9.149e-08,
                    8.6849e-08,
                    8.2538e-08,
                    7.8555e-08,
                    7.5372e-08,
                    7.3367e-08,
                    7.0984e-08
                ],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [
                    1.6951e-10,
                    3.4115e-10,
                    5.1488e-10,
                    6.9066e-10,
                    8.684e-10,
                    1.048e-09,
                    1.2295e-09,
                    1.4126e-09,
                    1.5972e-09,
                    1.7833e-09,
                    1.9707e-09,
                    2.1593e-09,
                    2.3493e-09,
                    2.5405e-09,
                    2.733e-09,
                    2.9268e-09,
                    3.1218e-09,
                    3.3181e-09,
                    3.5157e-09,
                    3.7147e-09,
                    3.9157e-09,
                    4.1201e-09,
                    4.3289e-09,
                    4.5428e-09,
                    4.7622e-09,
                    4.9872e-09,
                    5.2175e-09,
                    5.4527e-09,
                    5.692e-09,
                    5.9342e-09,
                    6.1787e-09,
                    6.4251e-09,
                    6.6735e-09,
                    6.9238e-09,
                    7.1757e-09,
                    7.4295e-09,
                    7.6849e-09,
                    7.9421e-09,
                    8.2012e-09,
                    8.4658e-09,
                    8.7327e-09,
                    9.0019e-09,
                    9.2736e-09,
                    9.5476e-09,
                    9.8242e-09,
                    1.0103e-08,
                    1.0385e-08,
                    1.0669e-08,
                    1.0956e-08,
                    1.1246e-08,
                    1.1539e-08,
                    1.1834e-08,
                    1.2133e-08,
                    1.2434e-08,
                    1.2739e-08,
                    1.3047e-08,
                    1.3359e-08,
                    1.3673e-08,
                    1.3992e-08,
                    1.4314e-08,
                    1.464e-08,
                    1.4972e-08,
                    1.531e-08,
                    1.5655e-08,
                    1.6007e-08,
                    1.6368e-08,
                    1.6737e-08,
                    1.7114e-08,
                    1.7499e-08,
                    1.7891e-08,
                    1.829e-08,
                    1.8698e-08,
                    1.9114e-08,
                    1.9539e-08,
                    1.9972e-08,
                    2.0413e-08,
                    2.0862e-08,
                    2.1316e-08,
                    2.1775e-08,
                    2.2238e-08,
                    2.2702e-08,
                    2.3166e-08,
                    2.363e-08,
                    2.4092e-08,
                    2.4554e-08,
                    2.5014e-08,
                    2.5473e-08,
                    2.5932e-08,
                    2.6393e-08,
                    2.6855e-08,
                    2.7338e-08,
                    2.7871e-08,
                    2.8475e-08,
                    2.9166e-08,
                    2.995e-08,
                    3.083e-08,
                    3.1797e-08,
                    3.2839e-08,
                    3.3933e-08,
                    3.5051e-08,
                    3.6169e-08,
                    3.7272e-08,
                    3.8351e-08,
                    3.9398e-08,
                    4.0409e-08,
                    4.1385e-08,
                    4.2328e-08,
                    4.3247e-08,
                    4.4152e-08,
                    4.5056e-08,
                    4.6167e-08,
                    4.7223e-08,
                    4.8396e-08,
                    4.9588e-08,
                    5.0799e-08,
                    5.2128e-08,
                    5.3476e-08,
                    5.493e-08,
                    5.6441e-08,
                    5.8109e-08,
                    6.0003e-08,
                    6.2194e-08,
                    6.4468e-08,
                    6.6915e-08,
                    6.9615e-08,
                    7.2418e-08,
                    7.497e-08,
                    7.7767e-08,
                    8.0837e-08,
                    8.4172e-08,
                    8.7427e-08,
                    9.2725e-08,
                    9.7553e-08,
                    1.018e-07,
                    1.0628e-07,
                    1.1096e-07,
                    1.1607e-07,
                    1.2174e-07,
                    1.2739e-07,
                    1.3334e-07,
                    1.405e-07,
                    1.4693e-07,
                    1.5351e-07,
                    1.6032e-07,
                    1.6756e-07,
                    1.7452e-07,
                    1.8191e-07,
                    1.8899e-07,
                    1.9612e-07,
                    2.0578e-07,
                    2.1513e-07,
                    2.237e-07,
                    2.3237e-07,
                    2.431e-07,
                    2.5297e-07,
                    2.6334e-07,
                    2.7225e-07,
                    2.8149e-07,
                    2.9119e-07,
                    2.998e-07,
                    3.0804e-07,
                    3.1671e-07,
                    3.2453e-07,
                    3.3371e-07,
                    3.4334e-07,
                    3.5434e-07,
                    3.6541e-07,
                    3.7596e-07,
                    3.8596e-07,
                    3.9598e-07,
                    4.0634e-07,
                    4.1685e-07
                ],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [
                    1.3732e-10,
                    2.7614e-10,
                    4.1643e-10,
                    5.5818e-10,
                    7.0138e-10,
                    8.4599e-10,
                    9.92e-10,
                    1.1394e-09,
                    1.2881e-09,
                    1.438e-09,
                    1.5893e-09,
                    1.7417e-09,
                    1.8955e-09,
                    2.0504e-09,
                    2.2067e-09,
                    2.3641e-09,
                    2.5228e-09,
                    2.6828e-09,
                    2.844e-09,
                    3.0064e-09,
                    3.1703e-09,
                    3.3361e-09,
                    3.504e-09,
                    3.6743e-09,
                    3.847e-09,
                    4.0221e-09,
                    4.1997e-09,
                    4.3795e-09,
                    4.5614e-09,
                    4.7449e-09,
                    4.93e-09,
                    5.1166e-09,
                    5.3046e-09,
                    5.494e-09,
                    5.6847e-09,
                    5.8769e-09,
                    6.0704e-09,
                    6.2653e-09,
                    6.4616e-09,
                    6.6602e-09,
                    6.8604e-09,
                    7.0624e-09,
                    7.266e-09,
                    7.4713e-09,
                    7.6784e-09,
                    7.8873e-09,
                    8.0979e-09,
                    8.3104e-09,
                    8.5248e-09,
                    8.741e-09,
                    8.9592e-09,
                    9.1796e-09,
                    9.4021e-09,
                    9.6269e-09,
                    9.8539e-09,
                    1.0083e-08,
                    1.0315e-08,
                    1.0549e-08,
                    1.0785e-08,
                    1.1023e-08,
                    1.1263e-08,
                    1.1505e-08,
                    1.1748e-08,
                    1.1994e-08,
                    1.2242e-08,
                    1.2491e-08,
                    1.2742e-08,
                    1.2995e-08,
                    1.325e-08,
                    1.3507e-08,
                    1.3766e-08,
                    1.4026e-08,
                    1.4289e-08,
                    1.4553e-08,
                    1.482e-08,
                    1.5088e-08,
                    1.5358e-08,
                    1.563e-08,
                    1.5905e-08,
                    1.6181e-08,
                    1.6459e-08,
                    1.674e-08,
                    1.7023e-08,
                    1.7308e-08,
                    1.7596e-08,
                    1.7887e-08,
                    1.818e-08,
                    1.8476e-08,
                    1.8775e-08,
                    1.9077e-08,
                    1.9383e-08,
                    1.9693e-08,
                    2.001e-08,
                    2.0333e-08,
                    2.0663e-08,
                    2.1e-08,
                    2.1344e-08,
                    2.1695e-08,
                    2.2053e-08,
                    2.2417e-08,
                    2.2786e-08,
                    2.316e-08,
                    2.3539e-08,
                    2.3925e-08,
                    2.4316e-08,
                    2.4712e-08,
                    2.5114e-08,
                    2.5521e-08,
                    2.5934e-08,
                    2.6351e-08,
                    2.6774e-08,
                    2.7203e-08,
                    2.7638e-08,
                    2.808e-08,
                    2.8529e-08,
                    2.8985e-08,
                    2.9448e-08,
                    2.9919e-08,
                    3.0397e-08,
                    3.097e-08,
                    3.1561e-08,
                    3.2167e-08,
                    3.2806e-08,
                    3.3482e-08,
                    3.4265e-08,
                    3.5199e-08,
                    3.6213e-08,
                    3.7315e-08,
                    3.854e-08,
                    3.9859e-08,
                    4.0926e-08,
                    4.197e-08,
                    4.3749e-08,
                    4.5668e-08,
                    4.7623e-08,
                    4.9658e-08,
                    5.2136e-08,
                    5.5162e-08,
                    5.7913e-08,
                    6.0833e-08,
                    6.4883e-08,
                    6.8394e-08,
                    7.1899e-08,
                    7.5424e-08,
                    7.9187e-08,
                    8.291e-08,
                    8.6748e-08,
                    9.0483e-08,
                    9.4286e-08,
                    1.0109e-07,
                    1.0838e-07,
                    1.1487e-07,
                    1.2129e-07,
                    1.3009e-07,
                    1.3804e-07,
                    1.4653e-07,
                    1.5343e-07,
                    1.6092e-07,
                    1.6911e-07,
                    1.7636e-07,
                    1.8307e-07,
                    1.9053e-07,
                    1.9726e-07,
                    2.0522e-07,
                    2.1357e-07,
                    2.233e-07,
                    2.3311e-07,
                    2.4246e-07,
                    2.5124e-07,
                    2.6007e-07,
                    2.6925e-07,
                    2.7858e-07
                ],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": [
                    3.2184e-11,
                    6.5012e-11,
                    9.8455e-11,
                    1.3248e-10,
                    1.6703e-10,
                    2.0205e-10,
                    2.3747e-10,
                    2.732e-10,
                    3.0917e-10,
                    3.4526e-10,
                    3.8141e-10,
                    4.1761e-10,
                    4.5384e-10,
                    4.901e-10,
                    5.2637e-10,
                    5.6267e-10,
                    5.99e-10,
                    6.3536e-10,
                    6.7177e-10,
                    7.0825e-10,
                    7.4534e-10,
                    7.8398e-10,
                    8.2488e-10,
                    8.6853e-10,
                    9.1524e-10,
                    9.6506e-10,
                    1.0178e-09,
                    1.0732e-09,
                    1.1306e-09,
                    1.1893e-09,
                    1.2486e-09,
                    1.3085e-09,
                    1.369e-09,
                    1.4298e-09,
                    1.491e-09,
                    1.5526e-09,
                    1.6145e-09,
                    1.6768e-09,
                    1.7396e-09,
                    1.8056e-09,
                    1.8723e-09,
                    1.9396e-09,
                    2.0076e-09,
                    2.0763e-09,
                    2.1458e-09,
                    2.216e-09,
                    2.287e-09,
                    2.3589e-09,
                    2.4315e-09,
                    2.5051e-09,
                    2.5795e-09,
                    2.6547e-09,
                    2.7307e-09,
                    2.8075e-09,
                    2.8852e-09,
                    2.9639e-09,
                    3.0436e-09,
                    3.1246e-09,
                    3.2069e-09,
                    3.2908e-09,
                    3.3771e-09,
                    3.4669e-09,
                    3.5611e-09,
                    3.6606e-09,
                    3.7658e-09,
                    3.8772e-09,
                    3.9949e-09,
                    4.1187e-09,
                    4.2485e-09,
                    4.3837e-09,
                    4.5244e-09,
                    4.6714e-09,
                    4.8251e-09,
                    4.9854e-09,
                    5.1523e-09,
                    5.3252e-09,
                    5.5034e-09,
                    5.6857e-09,
                    5.8708e-09,
                    6.057e-09,
                    6.2426e-09,
                    6.4263e-09,
                    6.6071e-09,
                    6.7844e-09,
                    6.9578e-09,
                    7.1273e-09,
                    7.2933e-09,
                    7.4565e-09,
                    7.6177e-09,
                    7.7784e-09,
                    7.9556e-09,
                    8.1775e-09,
                    8.4652e-09,
                    8.833e-09,
                    9.2879e-09,
                    9.8303e-09,
                    1.0453e-08,
                    1.1143e-08,
                    1.188e-08,
                    1.2634e-08,
                    1.3384e-08,
                    1.4113e-08,
                    1.4812e-08,
                    1.5473e-08,
                    1.6093e-08,
                    1.6673e-08,
                    1.7215e-08,
                    1.7726e-08,
                    1.8218e-08,
                    1.8705e-08,
                    1.9393e-08,
                    2.002e-08,
                    2.0758e-08,
                    2.1508e-08,
                    2.227e-08,
                    2.3143e-08,
                    2.4028e-08,
                    2.5011e-08,
                    2.6044e-08,
                    2.7138e-08,
                    2.8441e-08,
                    3.0027e-08,
                    3.1662e-08,
                    3.3433e-08,
                    3.5351e-08,
                    3.7219e-08,
                    3.8756e-08,
                    4.0453e-08,
                    4.2297e-08,
                    4.4313e-08,
                    4.6501e-08,
                    5.0755e-08,
                    5.3804e-08,
                    5.6127e-08,
                    5.866e-08,
                    6.1303e-08,
                    6.3934e-08,
                    6.6577e-08,
                    6.9479e-08,
                    7.2503e-08,
                    7.5613e-08,
                    7.8539e-08,
                    8.1613e-08,
                    8.4895e-08,
                    8.8374e-08,
                    9.1608e-08,
                    9.5161e-08,
                    9.8505e-08,
                    1.0184e-07,
                    1.0469e-07,
                    1.0675e-07,
                    1.0883e-07,
                    1.1108e-07,
                    1.1301e-07,
                    1.1493e-07,
                    1.1681e-07,
                    1.1881e-07,
                    1.2057e-07,
                    1.2207e-07,
                    1.2344e-07,
                    1.2496e-07,
                    1.2618e-07,
                    1.2727e-07,
                    1.2849e-07,
                    1.2977e-07,
                    1.3105e-07,
                    1.323e-07,
                    1.3349e-07,
                    1.3472e-07,
                    1.359e-07,
                    1.371e-07,
                    1.3827e-07
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            55.47216,
                            -4.64044
                        ],
                        [
                            55.42822,
                            -4.61241
                        ],
                        [
                            55.3879,
                            -4.64645
                        ],
                        [
                            55.48022,
                            -4.70909
                        ],
                        [
                            55.47216,
                            -4.64044
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "SLE",
                "Country": "Sierra Leone",
                "Total_3GHG": 0.06,
                "Total_3GHG_timeseries": [
                    4.9692e-07,
                    1.0535e-06,
                    1.6692e-06,
                    2.3034e-06,
                    2.9555e-06,
                    3.6331e-06,
                    4.3244e-06,
                    5.0268e-06,
                    5.7435e-06,
                    6.3368e-06,
                    6.9196e-06,
                    7.5009e-06,
                    8.0823e-06,
                    8.6365e-06,
                    9.2064e-06,
                    9.7784e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009
                ],
                "Fossil_3GHG": 0.01,
                "Fossil_3GHG_timeseries": [
                    2.8339e-08,
                    5.6772e-08,
                    8.5296e-08,
                    1.1391e-07,
                    1.4261e-07,
                    1.7139e-07,
                    2.0025e-07,
                    2.2919e-07,
                    2.5819e-07,
                    2.8725e-07,
                    3.1673e-07,
                    3.4661e-07,
                    3.7691e-07,
                    4.0762e-07,
                    4.3873e-07,
                    4.7026e-07,
                    5.022e-07,
                    5.3454e-07,
                    5.673e-07,
                    6.0047e-07,
                    6.341e-07,
                    6.6826e-07,
                    7.0301e-07,
                    7.3838e-07,
                    7.7438e-07,
                    8.1103e-07,
                    8.4832e-07,
                    8.8621e-07,
                    9.2469e-07,
                    9.6369e-07,
                    1.0029e-06,
                    1.0422e-06,
                    1.0817e-06,
                    1.1213e-06,
                    1.161e-06,
                    1.2009e-06,
                    1.2409e-06,
                    1.281e-06,
                    1.3213e-06,
                    1.3622e-06,
                    1.4032e-06,
                    1.4447e-06,
                    1.4868e-06,
                    1.5295e-06,
                    1.5729e-06,
                    1.6174e-06,
                    1.663e-06,
                    1.7271e-06,
                    1.8167e-06,
                    1.9393e-06,
                    2.1078e-06,
                    2.3091e-06,
                    2.5196e-06,
                    2.7398e-06,
                    2.9699e-06,
                    3.2102e-06,
                    3.4611e-06,
                    3.7229e-06,
                    3.996e-06,
                    4.2807e-06,
                    4.5659e-06,
                    4.8599e-06,
                    5.1658e-06,
                    5.4835e-06,
                    5.813e-06,
                    6.1544e-06,
                    6.5076e-06,
                    6.8564e-06,
                    7.1945e-06,
                    7.5148e-06,
                    7.8088e-06,
                    8.0903e-06,
                    8.3817e-06,
                    8.683e-06,
                    8.9942e-06,
                    9.3155e-06,
                    9.6469e-06,
                    9.9885e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_3GHG": 0.14,
                "Land_3GHG_timeseries": [
                    4.6858e-07,
                    9.9678e-07,
                    1.5839e-06,
                    2.1895e-06,
                    2.8129e-06,
                    3.4618e-06,
                    4.1241e-06,
                    4.7976e-06,
                    5.4853e-06,
                    6.0495e-06,
                    6.6029e-06,
                    7.1542e-06,
                    7.7053e-06,
                    8.2289e-06,
                    8.7677e-06,
                    9.3082e-06,
                    9.8244e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008
                ],
                "Total_CO2": 0.06,
                "Total_CO2_timeseries": [
                    4.0724e-07,
                    8.7383e-07,
                    1.3991e-06,
                    1.9426e-06,
                    2.5037e-06,
                    3.09e-06,
                    3.6897e-06,
                    4.3003e-06,
                    4.9251e-06,
                    5.4263e-06,
                    5.9157e-06,
                    6.4024e-06,
                    6.8879e-06,
                    7.345e-06,
                    7.8166e-06,
                    8.289e-06,
                    8.7364e-06,
                    9.2219e-06,
                    9.6878e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    7.095e-08,
                    1.1385e-07,
                    1.947e-07,
                    2.706e-07,
                    3.267e-07,
                    4.092e-07,
                    4.9005e-07,
                    6.6495e-07,
                    7.59e-07,
                    8.646e-07,
                    1.1864e-06,
                    1.3167e-06,
                    1.4635e-06,
                    1.6302e-06,
                    1.7672e-06,
                    1.8942e-06,
                    2.0295e-06,
                    2.1433e-06,
                    2.3067e-06,
                    2.7951e-06,
                    3.1812e-06,
                    3.5426e-06,
                    3.8478e-06,
                    4.0903e-06,
                    4.3247e-06,
                    4.5606e-06,
                    4.7636e-06,
                    4.9946e-06,
                    5.3147e-06,
                    5.6199e-06,
                    5.8938e-06,
                    6.2056e-06,
                    6.4548e-06,
                    6.765e-06,
                    7.0422e-06,
                    7.3409e-06,
                    7.6444e-06,
                    7.8689e-06,
                    8.0751e-06,
                    8.2434e-06,
                    8.4678e-06,
                    8.7186e-06,
                    8.8457e-06,
                    8.9645e-06,
                    9.0882e-06,
                    9.1888e-06,
                    9.2928e-06,
                    9.3852e-06,
                    9.4842e-06,
                    9.5634e-06,
                    9.6855e-06,
                    9.8522e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CO2": 0.19,
                "Land_CO2_timeseries": [
                    4.0724e-07,
                    8.7383e-07,
                    1.3991e-06,
                    1.9426e-06,
                    2.5037e-06,
                    3.09e-06,
                    3.6897e-06,
                    4.3003e-06,
                    4.9251e-06,
                    5.4263e-06,
                    5.9157e-06,
                    6.4024e-06,
                    6.8879e-06,
                    7.345e-06,
                    7.8166e-06,
                    8.289e-06,
                    8.7364e-06,
                    9.2219e-06,
                    9.6878e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Total_CH4": 0.05,
                "Total_CH4_timeseries": [
                    7.3354e-08,
                    1.4677e-07,
                    2.2025e-07,
                    2.9379e-07,
                    3.6739e-07,
                    4.4105e-07,
                    5.1477e-07,
                    5.8856e-07,
                    6.624e-07,
                    7.3631e-07,
                    8.1142e-07,
                    8.8773e-07,
                    9.6524e-07,
                    1.0439e-06,
                    1.1238e-06,
                    1.205e-06,
                    1.2873e-06,
                    1.3708e-06,
                    1.4555e-06,
                    1.5414e-06,
                    1.6285e-06,
                    1.7169e-06,
                    1.8065e-06,
                    1.8974e-06,
                    1.9896e-06,
                    2.083e-06,
                    2.1777e-06,
                    2.2736e-06,
                    2.3708e-06,
                    2.4692e-06,
                    2.5679e-06,
                    2.6668e-06,
                    2.766e-06,
                    2.8653e-06,
                    2.9649e-06,
                    3.0646e-06,
                    3.1646e-06,
                    3.2648e-06,
                    3.3653e-06,
                    3.4659e-06,
                    3.5668e-06,
                    3.6681e-06,
                    3.7699e-06,
                    3.8723e-06,
                    3.9755e-06,
                    4.0795e-06,
                    4.1847e-06,
                    4.3083e-06,
                    4.4573e-06,
                    4.6392e-06,
                    4.8669e-06,
                    5.1273e-06,
                    5.3967e-06,
                    5.6756e-06,
                    5.9642e-06,
                    6.2629e-06,
                    6.572e-06,
                    6.8919e-06,
                    7.2229e-06,
                    7.5654e-06,
                    7.9214e-06,
                    8.299e-06,
                    8.7014e-06,
                    9.1286e-06,
                    9.5806e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_CH4": 0.04,
                "Fossil_CH4_timeseries": [
                    2.291e-08,
                    4.5838e-08,
                    6.8786e-08,
                    9.1752e-08,
                    1.1474e-07,
                    1.3774e-07,
                    1.6077e-07,
                    1.8381e-07,
                    2.0687e-07,
                    2.2996e-07,
                    2.5342e-07,
                    2.7725e-07,
                    3.0146e-07,
                    3.2604e-07,
                    3.51e-07,
                    3.7633e-07,
                    4.0204e-07,
                    4.2812e-07,
                    4.5458e-07,
                    4.8141e-07,
                    5.0862e-07,
                    5.3624e-07,
                    5.6427e-07,
                    5.9271e-07,
                    6.2156e-07,
                    6.5082e-07,
                    6.8049e-07,
                    7.1058e-07,
                    7.4108e-07,
                    7.72e-07,
                    8.0301e-07,
                    8.341e-07,
                    8.6526e-07,
                    8.9651e-07,
                    9.2784e-07,
                    9.5924e-07,
                    9.9073e-07,
                    1.0223e-06,
                    1.0539e-06,
                    1.0857e-06,
                    1.1175e-06,
                    1.1496e-06,
                    1.1821e-06,
                    1.215e-06,
                    1.2485e-06,
                    1.2828e-06,
                    1.3181e-06,
                    1.3716e-06,
                    1.4504e-06,
                    1.562e-06,
                    1.7193e-06,
                    1.909e-06,
                    2.1077e-06,
                    2.3157e-06,
                    2.5332e-06,
                    2.7607e-06,
                    2.9985e-06,
                    3.2469e-06,
                    3.5063e-06,
                    3.777e-06,
                    4.0482e-06,
                    4.3279e-06,
                    4.6193e-06,
                    4.9224e-06,
                    5.2372e-06,
                    5.5637e-06,
                    5.9018e-06,
                    6.2354e-06,
                    6.5581e-06,
                    6.8629e-06,
                    7.1412e-06,
                    7.4068e-06,
                    7.6822e-06,
                    7.9673e-06,
                    8.2622e-06,
                    8.567e-06,
                    8.8817e-06,
                    9.2064e-06,
                    9.541e-06,
                    9.8857e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CH4": 0.06,
                "Land_CH4_timeseries": [
                    5.0445e-08,
                    1.0093e-07,
                    1.5146e-07,
                    2.0203e-07,
                    2.5265e-07,
                    3.033e-07,
                    3.54e-07,
                    4.0474e-07,
                    4.5553e-07,
                    5.0635e-07,
                    5.58e-07,
                    6.1048e-07,
                    6.6378e-07,
                    7.179e-07,
                    7.7285e-07,
                    8.2862e-07,
                    8.8522e-07,
                    9.4264e-07,
                    1.0009e-06,
                    1.06e-06,
                    1.1199e-06,
                    1.1806e-06,
                    1.2422e-06,
                    1.3047e-06,
                    1.368e-06,
                    1.4322e-06,
                    1.4972e-06,
                    1.563e-06,
                    1.6297e-06,
                    1.6972e-06,
                    1.7649e-06,
                    1.8327e-06,
                    1.9007e-06,
                    1.9688e-06,
                    2.037e-06,
                    2.1054e-06,
                    2.1739e-06,
                    2.2425e-06,
                    2.3113e-06,
                    2.3802e-06,
                    2.4493e-06,
                    2.5185e-06,
                    2.5879e-06,
                    2.6573e-06,
                    2.727e-06,
                    2.7967e-06,
                    2.8666e-06,
                    2.9367e-06,
                    3.0069e-06,
                    3.0772e-06,
                    3.1477e-06,
                    3.2183e-06,
                    3.289e-06,
                    3.3599e-06,
                    3.431e-06,
                    3.5022e-06,
                    3.5735e-06,
                    3.645e-06,
                    3.7166e-06,
                    3.7884e-06,
                    3.8732e-06,
                    3.9711e-06,
                    4.0821e-06,
                    4.2062e-06,
                    4.3434e-06,
                    4.4937e-06,
                    4.657e-06,
                    4.8334e-06,
                    5.0229e-06,
                    5.2255e-06,
                    5.4441e-06,
                    5.6785e-06,
                    5.9289e-06,
                    6.1953e-06,
                    6.4776e-06,
                    6.7758e-06,
                    7.0899e-06,
                    7.42e-06,
                    7.766e-06,
                    8.128e-06,
                    8.4972e-06,
                    8.8736e-06,
                    9.2573e-06,
                    9.6482e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_N2O": 0.04,
                "Total_N2O_timeseries": [
                    1.6328e-08,
                    3.2948e-08,
                    4.9849e-08,
                    6.7016e-08,
                    8.443e-08,
                    1.0207e-07,
                    1.199e-07,
                    1.3789e-07,
                    1.56e-07,
                    1.742e-07,
                    1.9246e-07,
                    2.1077e-07,
                    2.2913e-07,
                    2.4753e-07,
                    2.6598e-07,
                    2.8446e-07,
                    3.0299e-07,
                    3.2157e-07,
                    3.402e-07,
                    3.5889e-07,
                    3.7786e-07,
                    3.9749e-07,
                    4.1806e-07,
                    4.3977e-07,
                    4.6274e-07,
                    4.87e-07,
                    5.1249e-07,
                    5.3905e-07,
                    5.6647e-07,
                    5.9441e-07,
                    6.2267e-07,
                    6.5119e-07,
                    6.7995e-07,
                    7.0891e-07,
                    7.3805e-07,
                    7.6738e-07,
                    7.9688e-07,
                    8.2656e-07,
                    8.5645e-07,
                    8.879e-07,
                    9.1971e-07,
                    9.5191e-07,
                    9.8451e-07,
                    1.0175e-06,
                    1.051e-06,
                    1.0849e-06,
                    1.1193e-06,
                    1.1542e-06,
                    1.1896e-06,
                    1.2256e-06,
                    1.262e-06,
                    1.299e-06,
                    1.3366e-06,
                    1.3748e-06,
                    1.4136e-06,
                    1.4531e-06,
                    1.4932e-06,
                    1.5341e-06,
                    1.5756e-06,
                    1.618e-06,
                    1.6613e-06,
                    1.706e-06,
                    1.7523e-06,
                    1.8006e-06,
                    1.851e-06,
                    1.9036e-06,
                    1.9585e-06,
                    2.0157e-06,
                    2.075e-06,
                    2.1363e-06,
                    2.1996e-06,
                    2.2653e-06,
                    2.3333e-06,
                    2.4038e-06,
                    2.4766e-06,
                    2.5517e-06,
                    2.6287e-06,
                    2.7074e-06,
                    2.7872e-06,
                    2.8676e-06,
                    2.9481e-06,
                    3.0283e-06,
                    3.1079e-06,
                    3.1868e-06,
                    3.2649e-06,
                    3.3423e-06,
                    3.419e-06,
                    3.4953e-06,
                    3.5716e-06,
                    3.6483e-06,
                    3.7312e-06,
                    3.83e-06,
                    3.9519e-06,
                    4.1018e-06,
                    4.2822e-06,
                    4.4931e-06,
                    4.7323e-06,
                    4.9952e-06,
                    5.2748e-06,
                    5.5617e-06,
                    5.8477e-06,
                    6.1283e-06,
                    6.3998e-06,
                    6.6601e-06,
                    6.908e-06,
                    7.1435e-06,
                    7.3677e-06,
                    7.5829e-06,
                    7.7926e-06,
                    8.0013e-06,
                    8.2222e-06,
                    8.4471e-06,
                    8.6773e-06,
                    8.9117e-06,
                    9.1522e-06,
                    9.3976e-06,
                    9.6477e-06,
                    9.8984e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_N2O": 0.03,
                "Fossil_N2O_timeseries": [
                    5.4296e-09,
                    1.0934e-08,
                    1.651e-08,
                    2.2157e-08,
                    2.7871e-08,
                    3.3649e-08,
                    3.9485e-08,
                    4.5375e-08,
                    5.1313e-08,
                    5.7293e-08,
                    6.331e-08,
                    6.9363e-08,
                    7.5452e-08,
                    8.1576e-08,
                    8.7735e-08,
                    9.3928e-08,
                    1.0016e-07,
                    1.0642e-07,
                    1.1272e-07,
                    1.1906e-07,
                    1.2547e-07,
                    1.3202e-07,
                    1.3874e-07,
                    1.4567e-07,
                    1.5282e-07,
                    1.6021e-07,
                    1.6783e-07,
                    1.7564e-07,
                    1.8361e-07,
                    1.9169e-07,
                    1.9986e-07,
                    2.0809e-07,
                    2.1639e-07,
                    2.2475e-07,
                    2.3317e-07,
                    2.4164e-07,
                    2.5017e-07,
                    2.5875e-07,
                    2.674e-07,
                    2.7648e-07,
                    2.8572e-07,
                    2.9513e-07,
                    3.047e-07,
                    3.1446e-07,
                    3.2441e-07,
                    3.3456e-07,
                    3.4492e-07,
                    3.5549e-07,
                    3.6628e-07,
                    3.7729e-07,
                    3.8856e-07,
                    4.001e-07,
                    4.1196e-07,
                    4.2413e-07,
                    4.3663e-07,
                    4.4946e-07,
                    4.626e-07,
                    4.7603e-07,
                    4.8972e-07,
                    5.0363e-07,
                    5.1774e-07,
                    5.3202e-07,
                    5.4647e-07,
                    5.6108e-07,
                    5.7583e-07,
                    5.9074e-07,
                    6.0579e-07,
                    6.21e-07,
                    6.3636e-07,
                    6.5189e-07,
                    6.6758e-07,
                    6.8344e-07,
                    6.9945e-07,
                    7.1563e-07,
                    7.3198e-07,
                    7.485e-07,
                    7.652e-07,
                    7.821e-07,
                    7.9921e-07,
                    8.1656e-07,
                    8.3419e-07,
                    8.5218e-07,
                    8.7059e-07,
                    8.8946e-07,
                    9.0886e-07,
                    9.288e-07,
                    9.4931e-07,
                    9.7041e-07,
                    9.9211e-07,
                    1.0144e-06,
                    1.0373e-06,
                    1.061e-06,
                    1.0855e-06,
                    1.1108e-06,
                    1.1371e-06,
                    1.1644e-06,
                    1.1926e-06,
                    1.2219e-06,
                    1.2522e-06,
                    1.2834e-06,
                    1.3158e-06,
                    1.3494e-06,
                    1.3844e-06,
                    1.4207e-06,
                    1.4586e-06,
                    1.4978e-06,
                    1.5385e-06,
                    1.5804e-06,
                    1.6235e-06,
                    1.6675e-06,
                    1.7123e-06,
                    1.7578e-06,
                    1.8038e-06,
                    1.8505e-06,
                    1.8977e-06,
                    1.9456e-06,
                    1.9943e-06,
                    2.0439e-06,
                    2.0946e-06,
                    2.1493e-06,
                    2.202e-06,
                    2.2556e-06,
                    2.3094e-06,
                    2.3626e-06,
                    2.4168e-06,
                    2.4726e-06,
                    2.529e-06,
                    2.5869e-06,
                    2.6446e-06,
                    2.7019e-06,
                    2.7582e-06,
                    2.8244e-06,
                    2.8895e-06,
                    2.9547e-06,
                    3.0189e-06,
                    3.0853e-06,
                    3.1543e-06,
                    3.219e-06,
                    3.2857e-06,
                    3.355e-06,
                    3.4251e-06,
                    3.4903e-06,
                    3.5536e-06,
                    3.6178e-06,
                    3.6863e-06,
                    3.7544e-06,
                    3.8253e-06,
                    3.8975e-06,
                    3.9743e-06,
                    4.0534e-06,
                    4.1336e-06,
                    4.2151e-06,
                    4.2988e-06,
                    4.3853e-06,
                    4.4744e-06,
                    4.5667e-06,
                    4.6604e-06,
                    4.7555e-06,
                    4.8531e-06,
                    4.9532e-06,
                    5.0568e-06,
                    5.1638e-06,
                    5.2741e-06,
                    5.387e-06,
                    5.4995e-06,
                    5.6145e-06,
                    5.7314e-06,
                    5.8505e-06,
                    5.9729e-06,
                    6.0978e-06,
                    6.2246e-06,
                    6.3556e-06
                ],
                "Land_N2O": 0.04,
                "Land_N2O_timeseries": [
                    1.0898e-08,
                    2.2014e-08,
                    3.3339e-08,
                    4.4859e-08,
                    5.6559e-08,
                    6.8417e-08,
                    8.041e-08,
                    9.2512e-08,
                    1.0469e-07,
                    1.1691e-07,
                    1.2915e-07,
                    1.4141e-07,
                    1.5368e-07,
                    1.6596e-07,
                    1.7824e-07,
                    1.9053e-07,
                    2.0283e-07,
                    2.1515e-07,
                    2.2748e-07,
                    2.3983e-07,
                    2.5239e-07,
                    2.6547e-07,
                    2.7932e-07,
                    2.941e-07,
                    3.0992e-07,
                    3.2679e-07,
                    3.4466e-07,
                    3.6342e-07,
                    3.8286e-07,
                    4.0272e-07,
                    4.2281e-07,
                    4.431e-07,
                    4.6356e-07,
                    4.8416e-07,
                    5.0489e-07,
                    5.2574e-07,
                    5.4671e-07,
                    5.6781e-07,
                    5.8905e-07,
                    6.1141e-07,
                    6.3398e-07,
                    6.5678e-07,
                    6.798e-07,
                    7.0307e-07,
                    7.2659e-07,
                    7.5038e-07,
                    7.7443e-07,
                    7.9875e-07,
                    8.2337e-07,
                    8.4827e-07,
                    8.7346e-07,
                    8.9892e-07,
                    9.2466e-07,
                    9.5068e-07,
                    9.7699e-07,
                    1.0036e-06,
                    1.0306e-06,
                    1.058e-06,
                    1.0859e-06,
                    1.1143e-06,
                    1.1436e-06,
                    1.1739e-06,
                    1.2059e-06,
                    1.2395e-06,
                    1.2752e-06,
                    1.3129e-06,
                    1.3527e-06,
                    1.3947e-06,
                    1.4386e-06,
                    1.4844e-06,
                    1.5321e-06,
                    1.5818e-06,
                    1.6339e-06,
                    1.6882e-06,
                    1.7447e-06,
                    1.8032e-06,
                    1.8636e-06,
                    1.9253e-06,
                    1.988e-06,
                    2.051e-06,
                    2.1139e-06,
                    2.1761e-06,
                    2.2373e-06,
                    2.2973e-06,
                    2.356e-06,
                    2.4135e-06,
                    2.4697e-06,
                    2.5249e-06,
                    2.5795e-06,
                    2.6339e-06,
                    2.6939e-06,
                    2.7691e-06,
                    2.8665e-06,
                    2.991e-06,
                    3.1451e-06,
                    3.3287e-06,
                    3.5397e-06,
                    3.7733e-06,
                    4.0227e-06,
                    4.2783e-06,
                    4.5319e-06,
                    4.7789e-06,
                    5.0155e-06,
                    5.2394e-06,
                    5.4495e-06,
                    5.6457e-06,
                    5.8292e-06,
                    6.0025e-06,
                    6.1691e-06,
                    6.3338e-06,
                    6.5099e-06,
                    6.6893e-06,
                    6.8735e-06,
                    7.0613e-06,
                    7.2545e-06,
                    7.452e-06,
                    7.6534e-06,
                    7.8546e-06,
                    8.0601e-06,
                    8.2747e-06,
                    8.485e-06,
                    8.6934e-06,
                    8.9183e-06,
                    9.1033e-06,
                    9.3051e-06,
                    9.5139e-06,
                    9.7544e-06,
                    9.9664e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -10.28204,
                                8.48795
                            ],
                            [
                                -10.38598,
                                8.49278
                            ],
                            [
                                -10.44569,
                                8.40359
                            ],
                            [
                                -10.5593,
                                8.30586
                            ],
                            [
                                -10.6722,
                                8.34019
                            ],
                            [
                                -10.64953,
                                8.47466
                            ],
                            [
                                -10.58071,
                                8.59363
                            ],
                            [
                                -10.48173,
                                8.63832
                            ],
                            [
                                -10.47033,
                                8.67416
                            ],
                            [
                                -10.58401,
                                8.82285
                            ],
                            [
                                -10.59811,
                                8.97485
                            ],
                            [
                                -10.58556,
                                9.04386
                            ],
                            [
                                -10.6599,
                                9.08111
                            ],
                            [
                                -10.73257,
                                9.08397
                            ],
                            [
                                -10.72286,
                                9.18319
                            ],
                            [
                                -10.67052,
                                9.20221
                            ],
                            [
                                -10.66997,
                                9.31001
                            ],
                            [
                                -10.73067,
                                9.37893
                            ],
                            [
                                -10.81559,
                                9.39382
                            ],
                            [
                                -10.8424,
                                9.44246
                            ],
                            [
                                -10.86101,
                                9.55877
                            ],
                            [
                                -11.03989,
                                9.79866
                            ],
                            [
                                -11.16077,
                                9.89452
                            ],
                            [
                                -11.17401,
                                9.97226
                            ],
                            [
                                -11.21438,
                                10.00031
                            ],
                            [
                                -11.88126,
                                9.99727
                            ],
                            [
                                -11.90746,
                                9.93632
                            ],
                            [
                                -12.12482,
                                9.87227
                            ],
                            [
                                -12.22723,
                                9.92399
                            ],
                            [
                                -12.43029,
                                9.88146
                            ],
                            [
                                -12.4912,
                                9.8158
                            ],
                            [
                                -12.53634,
                                9.71879
                            ],
                            [
                                -12.62105,
                                9.59982
                            ],
                            [
                                -12.68779,
                                9.40939
                            ],
                            [
                                -12.75455,
                                9.39252
                            ],
                            [
                                -12.81403,
                                9.28756
                            ],
                            [
                                -12.87254,
                                9.29696
                            ],
                            [
                                -12.94436,
                                9.2734
                            ],
                            [
                                -12.9559,
                                9.18569
                            ],
                            [
                                -13.00622,
                                9.09492
                            ],
                            [
                                -13.08599,
                                9.04896
                            ],
                            [
                                -13.17755,
                                9.09058
                            ],
                            [
                                -13.30266,
                                9.04041
                            ],
                            [
                                -13.28742,
                                8.96476
                            ],
                            [
                                -13.16108,
                                8.91194
                            ],
                            [
                                -13.24359,
                                8.8168
                            ],
                            [
                                -13.24074,
                                8.66336
                            ],
                            [
                                -13.17451,
                                8.5381
                            ],
                            [
                                -13.11506,
                                8.5971
                            ],
                            [
                                -13.02059,
                                8.55735
                            ],
                            [
                                -13.14043,
                                8.42975
                            ],
                            [
                                -13.20864,
                                8.48947
                            ],
                            [
                                -13.27692,
                                8.48579
                            ],
                            [
                                -13.28777,
                                8.42479
                            ],
                            [
                                -13.17153,
                                8.28011
                            ],
                            [
                                -13.14718,
                                8.18097
                            ],
                            [
                                -13.0672,
                                8.2335
                            ],
                            [
                                -12.9926,
                                8.23058
                            ],
                            [
                                -12.90131,
                                8.0852
                            ],
                            [
                                -12.88719,
                                7.97458
                            ],
                            [
                                -12.94968,
                                7.91611
                            ],
                            [
                                -12.86479,
                                7.82262
                            ],
                            [
                                -12.81267,
                                7.79598
                            ],
                            [
                                -12.7074,
                                7.70593
                            ],
                            [
                                -12.58711,
                                7.68929
                            ],
                            [
                                -12.47644,
                                7.60604
                            ],
                            [
                                -12.45819,
                                7.50009
                            ],
                            [
                                -12.50491,
                                7.38672
                            ],
                            [
                                -12.30868,
                                7.32687
                            ],
                            [
                                -11.90613,
                                7.16859
                            ],
                            [
                                -11.66511,
                                7.04158
                            ],
                            [
                                -11.60477,
                                6.98502
                            ],
                            [
                                -11.49748,
                                6.92344
                            ],
                            [
                                -11.46102,
                                6.92358
                            ],
                            [
                                -11.3713,
                                7.01814
                            ],
                            [
                                -11.35035,
                                7.13952
                            ],
                            [
                                -11.30835,
                                7.20971
                            ],
                            [
                                -11.18495,
                                7.26261
                            ],
                            [
                                -11.10149,
                                7.38808
                            ],
                            [
                                -11.05973,
                                7.40298
                            ],
                            [
                                -10.93689,
                                7.50962
                            ],
                            [
                                -10.92005,
                                7.49876
                            ],
                            [
                                -10.79127,
                                7.59895
                            ],
                            [
                                -10.69873,
                                7.73628
                            ],
                            [
                                -10.60581,
                                7.77498
                            ],
                            [
                                -10.60486,
                                8.03662
                            ],
                            [
                                -10.52602,
                                8.12618
                            ],
                            [
                                -10.46321,
                                8.15617
                            ],
                            [
                                -10.35281,
                                8.15065
                            ],
                            [
                                -10.29581,
                                8.22307
                            ],
                            [
                                -10.3024,
                                8.29651
                            ],
                            [
                                -10.27215,
                                8.44242
                            ],
                            [
                                -10.28204,
                                8.48795
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -12.95665,
                                7.57169
                            ],
                            [
                                -12.70194,
                                7.50495
                            ],
                            [
                                -12.58533,
                                7.45476
                            ],
                            [
                                -12.49224,
                                7.50342
                            ],
                            [
                                -12.49453,
                                7.56653
                            ],
                            [
                                -12.59047,
                                7.63599
                            ],
                            [
                                -12.79484,
                                7.62929
                            ],
                            [
                                -12.90538,
                                7.60515
                            ],
                            [
                                -12.95665,
                                7.57169
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "SGP",
                "Country": "Singapore",
                "Total_3GHG": 0.08,
                "Total_3GHG_timeseries": [
                    1.4965e-07,
                    4.343e-07,
                    6.195e-07,
                    7.7645e-07,
                    1.0688e-06,
                    1.2588e-06,
                    1.4175e-06,
                    1.5657e-06,
                    1.7984e-06,
                    1.9725e-06,
                    2.1318e-06,
                    2.2864e-06,
                    2.4394e-06,
                    2.5911e-06,
                    2.7404e-06,
                    2.9305e-06,
                    3.0957e-06,
                    3.2545e-06,
                    3.4097e-06,
                    3.5546e-06,
                    3.6924e-06,
                    3.8262e-06,
                    3.9583e-06,
                    4.0883e-06,
                    4.216e-06,
                    4.3424e-06,
                    4.4675e-06,
                    4.5918e-06,
                    4.7126e-06,
                    4.8367e-06,
                    4.9603e-06,
                    5.0829e-06,
                    5.2054e-06,
                    5.3271e-06,
                    5.4458e-06,
                    5.5678e-06,
                    5.6889e-06,
                    5.8102e-06,
                    5.9306e-06,
                    6.0485e-06,
                    6.1647e-06,
                    6.2794e-06,
                    6.393e-06,
                    6.5068e-06,
                    6.619e-06,
                    6.731e-06,
                    6.8466e-06,
                    6.958e-06,
                    7.0686e-06,
                    7.1815e-06,
                    7.2955e-06,
                    7.4105e-06,
                    7.5267e-06,
                    7.6448e-06,
                    7.7639e-06,
                    7.8801e-06,
                    7.9944e-06,
                    8.1118e-06,
                    8.2338e-06,
                    8.358e-06,
                    8.4844e-06,
                    8.6126e-06,
                    8.7415e-06,
                    8.8728e-06,
                    9.0058e-06,
                    9.1403e-06,
                    9.2761e-06,
                    9.4521e-06,
                    9.6042e-06,
                    9.7404e-06,
                    9.8787e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013
                ],
                "Fossil_3GHG": 0.12,
                "Fossil_3GHG_timeseries": [
                    1.9052e-08,
                    3.8461e-08,
                    5.8227e-08,
                    7.8349e-08,
                    9.8826e-08,
                    1.1966e-07,
                    1.4084e-07,
                    1.6238e-07,
                    1.8426e-07,
                    2.065e-07,
                    2.2915e-07,
                    2.5222e-07,
                    2.7571e-07,
                    2.9962e-07,
                    3.2394e-07,
                    3.4869e-07,
                    3.7385e-07,
                    3.9943e-07,
                    4.2544e-07,
                    4.5186e-07,
                    4.7881e-07,
                    5.063e-07,
                    5.3435e-07,
                    5.6297e-07,
                    5.9216e-07,
                    6.2193e-07,
                    6.5228e-07,
                    6.8319e-07,
                    7.1465e-07,
                    7.4666e-07,
                    7.793e-07,
                    8.1259e-07,
                    8.4654e-07,
                    8.8113e-07,
                    9.1637e-07,
                    9.5226e-07,
                    9.888e-07,
                    1.026e-06,
                    1.0638e-06,
                    1.1024e-06,
                    1.1418e-06,
                    1.182e-06,
                    1.223e-06,
                    1.2648e-06,
                    1.3075e-06,
                    1.351e-06,
                    1.3952e-06,
                    1.4404e-06,
                    1.4863e-06,
                    1.5331e-06,
                    1.5809e-06,
                    1.6298e-06,
                    1.6797e-06,
                    1.7307e-06,
                    1.7827e-06,
                    1.8358e-06,
                    1.89e-06,
                    1.9452e-06,
                    2.0015e-06,
                    2.0588e-06,
                    2.1174e-06,
                    2.1773e-06,
                    2.2385e-06,
                    2.301e-06,
                    2.3648e-06,
                    2.4299e-06,
                    2.4963e-06,
                    2.5639e-06,
                    2.6329e-06,
                    2.7032e-06,
                    2.7778e-06,
                    2.8567e-06,
                    2.9399e-06,
                    3.0275e-06,
                    3.1194e-06,
                    3.2156e-06,
                    3.3161e-06,
                    3.421e-06,
                    3.5302e-06,
                    3.6437e-06,
                    3.7623e-06,
                    3.891e-06,
                    4.0339e-06,
                    4.1942e-06,
                    4.3743e-06,
                    4.5756e-06,
                    4.7988e-06,
                    5.0434e-06,
                    5.3084e-06,
                    5.5917e-06,
                    5.8936e-06,
                    6.213e-06,
                    6.5496e-06,
                    6.9032e-06,
                    7.2792e-06,
                    7.679e-06,
                    8.1045e-06,
                    8.558e-06,
                    9.0425e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [
                    1.3059e-07,
                    3.9584e-07,
                    5.6127e-07,
                    6.981e-07,
                    9.7e-07,
                    1.1392e-06,
                    1.2767e-06,
                    1.4033e-06,
                    1.6141e-06,
                    1.766e-06,
                    1.9026e-06,
                    2.0342e-06,
                    2.1637e-06,
                    2.2915e-06,
                    2.4165e-06,
                    2.5818e-06,
                    2.7219e-06,
                    2.8551e-06,
                    2.9843e-06,
                    3.1027e-06,
                    3.2135e-06,
                    3.3199e-06,
                    3.4239e-06,
                    3.5253e-06,
                    3.6238e-06,
                    3.7205e-06,
                    3.8153e-06,
                    3.9087e-06,
                    3.998e-06,
                    4.0901e-06,
                    4.181e-06,
                    4.2703e-06,
                    4.3588e-06,
                    4.446e-06,
                    4.5294e-06,
                    4.6155e-06,
                    4.7001e-06,
                    4.7842e-06,
                    4.8668e-06,
                    4.9461e-06,
                    5.0229e-06,
                    5.0975e-06,
                    5.17e-06,
                    5.242e-06,
                    5.3115e-06,
                    5.38e-06,
                    5.4514e-06,
                    5.5176e-06,
                    5.5823e-06,
                    5.6484e-06,
                    5.7146e-06,
                    5.7807e-06,
                    5.847e-06,
                    5.9141e-06,
                    5.9812e-06,
                    6.0443e-06,
                    6.1044e-06,
                    6.1665e-06,
                    6.2323e-06,
                    6.2992e-06,
                    6.3669e-06,
                    6.4353e-06,
                    6.5029e-06,
                    6.5718e-06,
                    6.641e-06,
                    6.7104e-06,
                    6.7798e-06,
                    6.8881e-06,
                    6.9713e-06,
                    7.0372e-06,
                    7.1009e-06,
                    7.1654e-06,
                    7.2319e-06,
                    7.3011e-06,
                    7.3733e-06,
                    7.4483e-06,
                    7.5268e-06,
                    7.6091e-06,
                    7.6945e-06,
                    7.7892e-06,
                    7.887e-06,
                    7.9875e-06,
                    8.0908e-06,
                    8.1965e-06,
                    8.3048e-06,
                    8.4159e-06,
                    8.53e-06,
                    8.6475e-06,
                    8.7677e-06,
                    8.8929e-06,
                    9.0218e-06,
                    9.1557e-06,
                    9.295e-06,
                    9.4403e-06,
                    9.5962e-06,
                    9.7553e-06,
                    9.9203e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_CO2": 0.09,
                "Total_CO2_timeseries": [
                    1.2294e-07,
                    3.8032e-07,
                    5.3768e-07,
                    6.6623e-07,
                    9.2964e-07,
                    1.0901e-06,
                    1.2187e-06,
                    1.3362e-06,
                    1.5378e-06,
                    1.6802e-06,
                    1.8071e-06,
                    1.9286e-06,
                    2.0479e-06,
                    2.1653e-06,
                    2.2795e-06,
                    2.4339e-06,
                    2.5627e-06,
                    2.6845e-06,
                    2.802e-06,
                    2.9084e-06,
                    3.007e-06,
                    3.1007e-06,
                    3.1916e-06,
                    3.2796e-06,
                    3.3642e-06,
                    3.4466e-06,
                    3.5267e-06,
                    3.605e-06,
                    3.6788e-06,
                    3.7551e-06,
                    3.8298e-06,
                    3.9024e-06,
                    3.9738e-06,
                    4.0434e-06,
                    4.1089e-06,
                    4.1766e-06,
                    4.2423e-06,
                    4.3072e-06,
                    4.3701e-06,
                    4.4291e-06,
                    4.4852e-06,
                    4.5383e-06,
                    4.5889e-06,
                    4.6383e-06,
                    4.6847e-06,
                    4.7295e-06,
                    4.7766e-06,
                    4.818e-06,
                    4.8572e-06,
                    4.8973e-06,
                    4.9366e-06,
                    4.9751e-06,
                    5.013e-06,
                    5.0509e-06,
                    5.0881e-06,
                    5.1205e-06,
                    5.1491e-06,
                    5.1788e-06,
                    5.2114e-06,
                    5.2442e-06,
                    5.2768e-06,
                    5.3089e-06,
                    5.3391e-06,
                    5.3693e-06,
                    5.3987e-06,
                    5.427e-06,
                    5.4541e-06,
                    5.5189e-06,
                    5.5573e-06,
                    5.5773e-06,
                    5.5917e-06,
                    5.6034e-06,
                    5.6137e-06,
                    5.6232e-06,
                    5.6322e-06,
                    5.6408e-06,
                    5.6493e-06,
                    5.6582e-06,
                    5.6669e-06,
                    5.6814e-06,
                    5.6974e-06,
                    5.7143e-06,
                    5.7321e-06,
                    5.7506e-06,
                    5.7699e-06,
                    5.7897e-06,
                    5.8098e-06,
                    5.8311e-06,
                    5.8524e-06,
                    5.8763e-06,
                    5.9008e-06,
                    5.9262e-06,
                    5.9525e-06,
                    5.9798e-06,
                    6.0125e-06,
                    6.0432e-06,
                    6.0746e-06,
                    6.1092e-06,
                    6.1518e-06,
                    7.051e-06,
                    8.3611e-06,
                    9.9497e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001
                ],
                "Fossil_CO2": 0.13,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    8.619e-07,
                    2.1344e-06,
                    3.6841e-06,
                    5.252e-06,
                    6.9504e-06,
                    8.7755e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [
                    1.2294e-07,
                    3.8032e-07,
                    5.3768e-07,
                    6.6623e-07,
                    9.2964e-07,
                    1.0901e-06,
                    1.2187e-06,
                    1.3362e-06,
                    1.5378e-06,
                    1.6802e-06,
                    1.8071e-06,
                    1.9286e-06,
                    2.0479e-06,
                    2.1653e-06,
                    2.2795e-06,
                    2.4339e-06,
                    2.5627e-06,
                    2.6845e-06,
                    2.802e-06,
                    2.9084e-06,
                    3.007e-06,
                    3.1007e-06,
                    3.1916e-06,
                    3.2796e-06,
                    3.3642e-06,
                    3.4466e-06,
                    3.5267e-06,
                    3.605e-06,
                    3.6788e-06,
                    3.7551e-06,
                    3.8298e-06,
                    3.9024e-06,
                    3.9738e-06,
                    4.0434e-06,
                    4.1089e-06,
                    4.1766e-06,
                    4.2423e-06,
                    4.3072e-06,
                    4.3701e-06,
                    4.4291e-06,
                    4.4852e-06,
                    4.5383e-06,
                    4.5889e-06,
                    4.6383e-06,
                    4.6847e-06,
                    4.7295e-06,
                    4.7766e-06,
                    4.818e-06,
                    4.8572e-06,
                    4.8973e-06,
                    4.9366e-06,
                    4.9751e-06,
                    5.013e-06,
                    5.0509e-06,
                    5.0881e-06,
                    5.1205e-06,
                    5.1491e-06,
                    5.1788e-06,
                    5.2114e-06,
                    5.2442e-06,
                    5.2768e-06,
                    5.3089e-06,
                    5.3391e-06,
                    5.3693e-06,
                    5.3987e-06,
                    5.427e-06,
                    5.4541e-06,
                    5.5189e-06,
                    5.5573e-06,
                    5.5773e-06,
                    5.5917e-06,
                    5.6034e-06,
                    5.6137e-06,
                    5.6232e-06,
                    5.6322e-06,
                    5.6408e-06,
                    5.6493e-06,
                    5.6582e-06,
                    5.6669e-06,
                    5.6814e-06,
                    5.6974e-06,
                    5.7143e-06,
                    5.7321e-06,
                    5.7506e-06,
                    5.7699e-06,
                    5.7897e-06,
                    5.8098e-06,
                    5.8311e-06,
                    5.8524e-06,
                    5.8763e-06,
                    5.9008e-06,
                    5.9262e-06,
                    5.9525e-06,
                    5.9798e-06,
                    6.0125e-06,
                    6.0432e-06,
                    6.0746e-06,
                    6.1092e-06,
                    6.1518e-06,
                    6.1891e-06,
                    6.2267e-06,
                    6.2656e-06,
                    6.3046e-06,
                    6.3413e-06,
                    6.3766e-06,
                    6.4049e-06,
                    6.428e-06,
                    6.4497e-06,
                    6.3695e-06,
                    6.3395e-06,
                    6.332e-06,
                    6.3327e-06,
                    6.3339e-06,
                    6.3514e-06,
                    6.3474e-06,
                    6.3505e-06,
                    6.347e-06,
                    6.3377e-06,
                    6.3398e-06,
                    6.3244e-06,
                    6.3264e-06,
                    6.3238e-06,
                    6.3074e-06,
                    6.3002e-06,
                    6.2918e-06,
                    6.29e-06,
                    6.2756e-06,
                    6.2872e-06,
                    6.2807e-06,
                    6.282e-06,
                    6.2733e-06,
                    6.2747e-06,
                    6.2687e-06,
                    6.3179e-06,
                    6.3703e-06,
                    6.4395e-06,
                    6.5029e-06,
                    6.5619e-06,
                    6.6014e-06,
                    6.6256e-06,
                    6.6436e-06,
                    6.6782e-06,
                    6.7124e-06,
                    6.8038e-06,
                    6.8611e-06,
                    6.9085e-06,
                    6.9481e-06,
                    6.9939e-06,
                    7.0254e-06,
                    7.0504e-06,
                    7.0944e-06,
                    7.1383e-06,
                    7.1725e-06,
                    7.194e-06,
                    7.2172e-06,
                    7.2348e-06,
                    7.26e-06,
                    7.2917e-06,
                    7.3291e-06,
                    7.371e-06,
                    7.4342e-06,
                    7.4947e-06,
                    7.5417e-06,
                    7.6478e-06,
                    7.6971e-06,
                    7.742e-06,
                    7.8034e-06,
                    7.8601e-06,
                    7.9209e-06,
                    7.9818e-06,
                    8.0436e-06,
                    8.1051e-06
                ],
                "Total_CH4": 0.05,
                "Total_CH4_timeseries": [
                    1.5216e-08,
                    3.0868e-08,
                    4.6957e-08,
                    6.3483e-08,
                    8.0446e-08,
                    9.7847e-08,
                    1.1569e-07,
                    1.3396e-07,
                    1.5267e-07,
                    1.7183e-07,
                    1.9154e-07,
                    2.1183e-07,
                    2.3268e-07,
                    2.541e-07,
                    2.7608e-07,
                    2.9863e-07,
                    3.2175e-07,
                    3.4543e-07,
                    3.6968e-07,
                    3.9451e-07,
                    4.2006e-07,
                    4.4635e-07,
                    4.7336e-07,
                    5.0112e-07,
                    5.296e-07,
                    5.5882e-07,
                    5.8877e-07,
                    6.1946e-07,
                    6.5088e-07,
                    6.8304e-07,
                    7.1613e-07,
                    7.5018e-07,
                    7.8518e-07,
                    8.2114e-07,
                    8.5805e-07,
                    8.9592e-07,
                    9.3475e-07,
                    9.7453e-07,
                    1.0153e-06,
                    1.057e-06,
                    1.0999e-06,
                    1.1441e-06,
                    1.1894e-06,
                    1.236e-06,
                    1.2838e-06,
                    1.3329e-06,
                    1.3831e-06,
                    1.4346e-06,
                    1.4873e-06,
                    1.5412e-06,
                    1.5967e-06,
                    1.6538e-06,
                    1.7125e-06,
                    1.7728e-06,
                    1.8346e-06,
                    1.8981e-06,
                    1.9631e-06,
                    2.0297e-06,
                    2.0979e-06,
                    2.1676e-06,
                    2.2394e-06,
                    2.3133e-06,
                    2.3892e-06,
                    2.4671e-06,
                    2.5471e-06,
                    2.6292e-06,
                    2.7133e-06,
                    2.7994e-06,
                    2.8876e-06,
                    2.9778e-06,
                    3.0754e-06,
                    3.1803e-06,
                    3.2926e-06,
                    3.4122e-06,
                    3.5391e-06,
                    3.6734e-06,
                    3.815e-06,
                    3.9639e-06,
                    4.1202e-06,
                    4.2838e-06,
                    4.4512e-06,
                    4.6223e-06,
                    4.7971e-06,
                    4.9756e-06,
                    5.1579e-06,
                    5.3446e-06,
                    5.5358e-06,
                    5.7315e-06,
                    5.9317e-06,
                    6.1365e-06,
                    6.3485e-06,
                    6.5681e-06,
                    6.7953e-06,
                    7.0305e-06,
                    7.2787e-06,
                    7.5404e-06,
                    7.8162e-06,
                    8.1066e-06,
                    8.4121e-06,
                    8.8862e-06,
                    9.4897e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_CH4": 0.08,
                "Fossil_CH4_timeseries": [
                    8.5631e-09,
                    1.7373e-08,
                    2.6429e-08,
                    3.5733e-08,
                    4.5283e-08,
                    5.5081e-08,
                    6.5126e-08,
                    7.5419e-08,
                    8.5959e-08,
                    9.6748e-08,
                    1.0786e-07,
                    1.1929e-07,
                    1.3103e-07,
                    1.431e-07,
                    1.5549e-07,
                    1.6821e-07,
                    1.8124e-07,
                    1.9459e-07,
                    2.0827e-07,
                    2.2227e-07,
                    2.3668e-07,
                    2.5151e-07,
                    2.6675e-07,
                    2.824e-07,
                    2.9847e-07,
                    3.1496e-07,
                    3.3186e-07,
                    3.4918e-07,
                    3.6691e-07,
                    3.8506e-07,
                    4.0374e-07,
                    4.2296e-07,
                    4.4272e-07,
                    4.6302e-07,
                    4.8387e-07,
                    5.0526e-07,
                    5.2719e-07,
                    5.4968e-07,
                    5.7271e-07,
                    5.9629e-07,
                    6.2056e-07,
                    6.4552e-07,
                    6.7116e-07,
                    6.975e-07,
                    7.2452e-07,
                    7.5223e-07,
                    7.8063e-07,
                    8.0971e-07,
                    8.3949e-07,
                    8.6995e-07,
                    9.0131e-07,
                    9.3357e-07,
                    9.6672e-07,
                    1.0008e-06,
                    1.0357e-06,
                    1.0716e-06,
                    1.1083e-06,
                    1.1459e-06,
                    1.1844e-06,
                    1.2238e-06,
                    1.2644e-06,
                    1.3061e-06,
                    1.349e-06,
                    1.393e-06,
                    1.4382e-06,
                    1.4845e-06,
                    1.532e-06,
                    1.5806e-06,
                    1.6304e-06,
                    1.6813e-06,
                    1.7364e-06,
                    1.7956e-06,
                    1.859e-06,
                    1.9265e-06,
                    1.9981e-06,
                    2.0738e-06,
                    2.1537e-06,
                    2.2377e-06,
                    2.3258e-06,
                    2.418e-06,
                    2.5124e-06,
                    2.6088e-06,
                    2.7073e-06,
                    2.808e-06,
                    2.9107e-06,
                    3.0155e-06,
                    3.1224e-06,
                    3.2315e-06,
                    3.3426e-06,
                    3.4558e-06,
                    3.5735e-06,
                    3.696e-06,
                    3.8234e-06,
                    3.9558e-06,
                    4.0982e-06,
                    4.2512e-06,
                    4.4152e-06,
                    4.5907e-06,
                    4.7781e-06,
                    5.1309e-06,
                    5.6042e-06,
                    6.181e-06,
                    6.8081e-06,
                    7.5144e-06,
                    8.2951e-06,
                    9.1261e-06,
                    9.6106e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [
                    6.6525e-09,
                    1.3495e-08,
                    2.0528e-08,
                    2.7751e-08,
                    3.5163e-08,
                    4.2766e-08,
                    5.0559e-08,
                    5.8542e-08,
                    6.6715e-08,
                    7.5079e-08,
                    8.3688e-08,
                    9.2543e-08,
                    1.0164e-07,
                    1.1099e-07,
                    1.2058e-07,
                    1.3042e-07,
                    1.4051e-07,
                    1.5084e-07,
                    1.6142e-07,
                    1.7224e-07,
                    1.8338e-07,
                    1.9484e-07,
                    2.0662e-07,
                    2.1871e-07,
                    2.3113e-07,
                    2.4386e-07,
                    2.5691e-07,
                    2.7028e-07,
                    2.8397e-07,
                    2.9798e-07,
                    3.1239e-07,
                    3.2722e-07,
                    3.4247e-07,
                    3.5812e-07,
                    3.7419e-07,
                    3.9066e-07,
                    4.0755e-07,
                    4.2486e-07,
                    4.4257e-07,
                    4.6069e-07,
                    4.7935e-07,
                    4.9855e-07,
                    5.1827e-07,
                    5.3853e-07,
                    5.5932e-07,
                    5.8064e-07,
                    6.025e-07,
                    6.2489e-07,
                    6.4782e-07,
                    6.7127e-07,
                    6.9542e-07,
                    7.2025e-07,
                    7.4578e-07,
                    7.72e-07,
                    7.989e-07,
                    8.265e-07,
                    8.5479e-07,
                    8.8376e-07,
                    9.1343e-07,
                    9.4378e-07,
                    9.7503e-07,
                    1.0072e-06,
                    1.0402e-06,
                    1.0741e-06,
                    1.109e-06,
                    1.1447e-06,
                    1.1813e-06,
                    1.2188e-06,
                    1.2572e-06,
                    1.2964e-06,
                    1.3389e-06,
                    1.3846e-06,
                    1.4336e-06,
                    1.4857e-06,
                    1.541e-06,
                    1.5995e-06,
                    1.6613e-06,
                    1.7263e-06,
                    1.7944e-06,
                    1.8658e-06,
                    1.9388e-06,
                    2.0135e-06,
                    2.0898e-06,
                    2.1677e-06,
                    2.2472e-06,
                    2.3291e-06,
                    2.4134e-06,
                    2.5001e-06,
                    2.5891e-06,
                    2.6807e-06,
                    2.775e-06,
                    2.872e-06,
                    2.9719e-06,
                    3.0747e-06,
                    3.1805e-06,
                    3.2892e-06,
                    3.401e-06,
                    3.5159e-06,
                    3.634e-06,
                    3.7553e-06,
                    3.8855e-06,
                    4.0264e-06,
                    4.1793e-06,
                    4.3455e-06,
                    4.5259e-06,
                    4.7205e-06,
                    4.9294e-06,
                    5.1527e-06,
                    5.3898e-06,
                    5.6398e-06,
                    5.8936e-06,
                    6.1843e-06,
                    6.4401e-06,
                    6.5871e-06,
                    6.8366e-06,
                    7.1076e-06,
                    7.3785e-06,
                    7.6058e-06,
                    7.8202e-06,
                    8.0533e-06,
                    8.2908e-06,
                    8.5516e-06,
                    8.8607e-06,
                    9.111e-06,
                    9.2858e-06,
                    9.4446e-06,
                    9.6636e-06,
                    9.8005e-06,
                    9.9413e-06,
                    0,
                    0,
                    9.925e-06,
                    9.8709e-06,
                    9.911e-06,
                    9.7984e-06,
                    9.5837e-06,
                    9.3374e-06,
                    9.0634e-06,
                    8.8075e-06,
                    8.5053e-06,
                    8.0567e-06,
                    7.5736e-06,
                    7.0319e-06,
                    6.5308e-06,
                    6.0847e-06,
                    5.6388e-06,
                    5.1191e-06,
                    4.66e-06,
                    4.1818e-06,
                    3.7649e-06,
                    3.3899e-06,
                    3.0576e-06,
                    2.7253e-06,
                    2.3941e-06,
                    2.11e-06,
                    1.8966e-06,
                    1.7071e-06,
                    1.5758e-06,
                    1.4328e-06,
                    1.3106e-06,
                    1.3118e-06,
                    1.3134e-06,
                    1.315e-06,
                    1.3165e-06,
                    1.3183e-06,
                    1.3192e-06,
                    1.3212e-06,
                    1.3236e-06,
                    1.3258e-06,
                    1.328e-06,
                    1.3302e-06,
                    1.3319e-06
                ],
                "Total_N2O": 0.11,
                "Total_N2O_timeseries": [
                    1.149e-08,
                    2.311e-08,
                    3.486e-08,
                    4.6737e-08,
                    5.8738e-08,
                    7.0861e-08,
                    8.3102e-08,
                    9.5456e-08,
                    1.0792e-07,
                    1.2049e-07,
                    1.3316e-07,
                    1.4592e-07,
                    1.5879e-07,
                    1.7175e-07,
                    1.8482e-07,
                    1.9798e-07,
                    2.1124e-07,
                    2.246e-07,
                    2.3806e-07,
                    2.5162e-07,
                    2.6531e-07,
                    2.7918e-07,
                    2.9326e-07,
                    3.0758e-07,
                    3.2215e-07,
                    3.3699e-07,
                    3.5207e-07,
                    3.6739e-07,
                    3.829e-07,
                    3.9858e-07,
                    4.1439e-07,
                    4.3033e-07,
                    4.464e-07,
                    4.6258e-07,
                    4.7887e-07,
                    4.9529e-07,
                    5.1182e-07,
                    5.2846e-07,
                    5.4523e-07,
                    5.6237e-07,
                    5.7966e-07,
                    5.971e-07,
                    6.147e-07,
                    6.3247e-07,
                    6.5041e-07,
                    6.6855e-07,
                    6.8687e-07,
                    7.0539e-07,
                    7.2412e-07,
                    7.4304e-07,
                    7.6218e-07,
                    7.8155e-07,
                    8.0117e-07,
                    8.2104e-07,
                    8.4117e-07,
                    8.6159e-07,
                    8.8229e-07,
                    9.0328e-07,
                    9.2458e-07,
                    9.4618e-07,
                    9.6811e-07,
                    9.9042e-07,
                    1.0132e-06,
                    1.0363e-06,
                    1.06e-06,
                    1.0841e-06,
                    1.1087e-06,
                    1.1338e-06,
                    1.1593e-06,
                    1.1853e-06,
                    1.2116e-06,
                    1.2384e-06,
                    1.2656e-06,
                    1.2932e-06,
                    1.3213e-06,
                    1.3498e-06,
                    1.3787e-06,
                    1.408e-06,
                    1.4376e-06,
                    1.4676e-06,
                    1.5008e-06,
                    1.542e-06,
                    1.5955e-06,
                    1.6645e-06,
                    1.7512e-06,
                    1.8573e-06,
                    1.9831e-06,
                    2.1284e-06,
                    2.292e-06,
                    2.4718e-06,
                    2.6661e-06,
                    2.8744e-06,
                    3.0967e-06,
                    3.3331e-06,
                    3.5841e-06,
                    3.8507e-06,
                    4.134e-06,
                    4.4356e-06,
                    4.7574e-06,
                    5.1015e-06,
                    5.4746e-06,
                    5.8865e-06,
                    6.3459e-06,
                    6.8598e-06,
                    7.4341e-06,
                    8.073e-06,
                    8.7796e-06,
                    9.5555e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_N2O": 0.39,
                "Fossil_N2O_timeseries": [
                    1.0489e-08,
                    2.1088e-08,
                    3.1798e-08,
                    4.2617e-08,
                    5.3543e-08,
                    6.4577e-08,
                    7.5716e-08,
                    8.696e-08,
                    9.8305e-08,
                    1.0975e-07,
                    1.2129e-07,
                    1.3293e-07,
                    1.4467e-07,
                    1.5651e-07,
                    1.6845e-07,
                    1.8048e-07,
                    1.9261e-07,
                    2.0484e-07,
                    2.1717e-07,
                    2.2959e-07,
                    2.4213e-07,
                    2.5479e-07,
                    2.676e-07,
                    2.8057e-07,
                    2.9369e-07,
                    3.0697e-07,
                    3.2042e-07,
                    3.3401e-07,
                    3.4774e-07,
                    3.6159e-07,
                    3.7556e-07,
                    3.8964e-07,
                    4.0382e-07,
                    4.1811e-07,
                    4.325e-07,
                    4.47e-07,
                    4.6161e-07,
                    4.7631e-07,
                    4.9113e-07,
                    5.0612e-07,
                    5.2123e-07,
                    5.3647e-07,
                    5.5184e-07,
                    5.6734e-07,
                    5.8296e-07,
                    5.9872e-07,
                    6.1462e-07,
                    6.3065e-07,
                    6.4683e-07,
                    6.6314e-07,
                    6.796e-07,
                    6.9621e-07,
                    7.1299e-07,
                    7.2992e-07,
                    7.4702e-07,
                    7.6429e-07,
                    7.8172e-07,
                    7.9931e-07,
                    8.1706e-07,
                    8.3497e-07,
                    8.5302e-07,
                    8.7121e-07,
                    8.8955e-07,
                    9.0802e-07,
                    9.2664e-07,
                    9.4539e-07,
                    9.6428e-07,
                    9.8332e-07,
                    1.0025e-06,
                    1.0218e-06,
                    1.0414e-06,
                    1.061e-06,
                    1.0809e-06,
                    1.101e-06,
                    1.1213e-06,
                    1.1417e-06,
                    1.1624e-06,
                    1.1833e-06,
                    1.2044e-06,
                    1.2257e-06,
                    1.25e-06,
                    1.2822e-06,
                    1.3266e-06,
                    1.3863e-06,
                    1.4636e-06,
                    1.5601e-06,
                    1.6763e-06,
                    1.812e-06,
                    1.9659e-06,
                    2.1359e-06,
                    2.32e-06,
                    2.517e-06,
                    2.7262e-06,
                    2.9474e-06,
                    3.1809e-06,
                    3.4278e-06,
                    3.6893e-06,
                    3.9673e-06,
                    4.2643e-06,
                    4.5833e-06,
                    4.9311e-06,
                    5.3177e-06,
                    5.7516e-06,
                    6.2398e-06,
                    6.788e-06,
                    7.4008e-06,
                    8.0809e-06,
                    8.83e-06,
                    9.6485e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": [
                    1.001e-09,
                    2.0219e-09,
                    3.0621e-09,
                    4.1201e-09,
                    5.1947e-09,
                    6.2838e-09,
                    7.3854e-09,
                    8.4969e-09,
                    9.6154e-09,
                    1.0738e-08,
                    1.1862e-08,
                    1.2988e-08,
                    1.4115e-08,
                    1.5242e-08,
                    1.6371e-08,
                    1.75e-08,
                    1.8629e-08,
                    1.976e-08,
                    2.0893e-08,
                    2.2027e-08,
                    2.3181e-08,
                    2.4382e-08,
                    2.5654e-08,
                    2.7012e-08,
                    2.8465e-08,
                    3.0014e-08,
                    3.1656e-08,
                    3.3378e-08,
                    3.5164e-08,
                    3.6988e-08,
                    3.8833e-08,
                    4.0697e-08,
                    4.2576e-08,
                    4.4468e-08,
                    4.6372e-08,
                    4.8287e-08,
                    5.0213e-08,
                    5.2151e-08,
                    5.4102e-08,
                    5.6254e-08,
                    5.8425e-08,
                    6.0624e-08,
                    6.2857e-08,
                    6.5131e-08,
                    6.7451e-08,
                    6.9824e-08,
                    7.2252e-08,
                    7.4739e-08,
                    7.7288e-08,
                    7.9901e-08,
                    8.2583e-08,
                    8.534e-08,
                    8.8182e-08,
                    9.1118e-08,
                    9.4155e-08,
                    9.7304e-08,
                    1.0057e-07,
                    1.0397e-07,
                    1.0752e-07,
                    1.1121e-07,
                    1.1509e-07,
                    1.1921e-07,
                    1.2361e-07,
                    1.2832e-07,
                    1.3335e-07,
                    1.3873e-07,
                    1.4444e-07,
                    1.5047e-07,
                    1.5681e-07,
                    1.6341e-07,
                    1.7025e-07,
                    1.7734e-07,
                    1.8467e-07,
                    1.9223e-07,
                    2.0002e-07,
                    2.0803e-07,
                    2.1624e-07,
                    2.2464e-07,
                    2.332e-07,
                    2.4192e-07,
                    2.5078e-07,
                    2.5978e-07,
                    2.6892e-07,
                    2.782e-07,
                    2.8761e-07,
                    2.9713e-07,
                    3.0674e-07,
                    3.1643e-07,
                    3.2616e-07,
                    3.3591e-07,
                    3.461e-07,
                    3.5745e-07,
                    3.7054e-07,
                    3.8571e-07,
                    4.0317e-07,
                    4.2291e-07,
                    4.4475e-07,
                    4.6832e-07,
                    4.9307e-07,
                    5.1825e-07,
                    5.4348e-07,
                    5.6883e-07,
                    5.9435e-07,
                    6.2008e-07,
                    6.4605e-07,
                    6.7228e-07,
                    6.9876e-07,
                    7.255e-07,
                    7.5245e-07,
                    7.7959e-07,
                    8.0902e-07,
                    8.406e-07,
                    8.714e-07,
                    8.9827e-07,
                    9.3122e-07,
                    9.6598e-07,
                    1.0016e-06,
                    1.0367e-06,
                    1.0727e-06,
                    1.1104e-06,
                    1.1501e-06,
                    1.1891e-06,
                    1.2328e-06,
                    1.2747e-06,
                    1.3144e-06,
                    1.356e-06,
                    1.4022e-06,
                    1.4462e-06,
                    1.4923e-06,
                    1.5354e-06,
                    1.575e-06,
                    1.6092e-06,
                    1.6442e-06,
                    1.6783e-06,
                    1.7093e-06,
                    1.7372e-06,
                    1.7633e-06,
                    1.7839e-06,
                    1.8051e-06,
                    1.8248e-06,
                    1.8359e-06,
                    1.8465e-06,
                    1.8568e-06,
                    1.8687e-06,
                    1.882e-06,
                    1.8944e-06,
                    1.9037e-06,
                    1.9143e-06,
                    1.9246e-06,
                    1.9331e-06,
                    1.9411e-06,
                    1.947e-06,
                    1.9533e-06,
                    1.9593e-06,
                    1.9652e-06,
                    1.9712e-06,
                    1.9777e-06,
                    1.9841e-06,
                    1.9909e-06,
                    1.9979e-06,
                    2.0047e-06,
                    2.0118e-06,
                    2.019e-06,
                    2.0261e-06,
                    2.0333e-06,
                    2.0406e-06,
                    2.0483e-06,
                    2.0561e-06,
                    2.064e-06,
                    2.072e-06,
                    2.08e-06,
                    2.0883e-06
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            103.63877,
                            1.33089
                        ],
                        [
                            103.66388,
                            1.29273
                        ],
                        [
                            103.75666,
                            1.30465
                        ],
                        [
                            103.81039,
                            1.25942
                        ],
                        [
                            103.95408,
                            1.30557
                        ],
                        [
                            103.96099,
                            1.37609
                        ],
                        [
                            103.80352,
                            1.46575
                        ],
                        [
                            103.74372,
                            1.42672
                        ],
                        [
                            103.68264,
                            1.42661
                        ],
                        [
                            103.63877,
                            1.33089
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "SXM",
                "Country": "Sint-Maarten",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2.506e-08,
                    5.1894e-08,
                    1.1399e-07,
                    1.9159e-07,
                    2.9258e-07,
                    3.7646e-07,
                    4.5853e-07,
                    5.4634e-07,
                    6.4345e-07,
                    7.5226e-07,
                    8.7051e-07,
                    1.0086e-06,
                    1.1583e-06,
                    1.298e-06,
                    1.4109e-06,
                    1.5485e-06,
                    1.6287e-06,
                    1.7581e-06,
                    1.9205e-06,
                    2.1091e-06,
                    2.3206e-06,
                    2.5602e-06,
                    2.8056e-06,
                    2.8056e-06,
                    3.113e-06,
                    3.5977e-06,
                    3.8776e-06,
                    4.2016e-06,
                    4.8568e-06,
                    5.3988e-06,
                    6.0997e-06,
                    6.5785e-06,
                    6.9979e-06,
                    7.5377e-06,
                    8.0019e-06,
                    8.4863e-06,
                    9.0183e-06,
                    9.5279e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2.506e-08,
                    5.1894e-08,
                    1.1399e-07,
                    1.9159e-07,
                    2.9258e-07,
                    3.7646e-07,
                    4.5853e-07,
                    5.4634e-07,
                    6.4345e-07,
                    7.5226e-07,
                    8.7051e-07,
                    1.0086e-06,
                    1.1583e-06,
                    1.298e-06,
                    1.4109e-06,
                    1.5485e-06,
                    1.6287e-06,
                    1.7581e-06,
                    1.9205e-06,
                    2.1091e-06,
                    2.3206e-06,
                    2.5602e-06,
                    2.8056e-06,
                    2.8056e-06,
                    3.113e-06,
                    3.5977e-06,
                    3.8776e-06,
                    4.2016e-06,
                    4.8568e-06,
                    5.3988e-06,
                    6.0997e-06,
                    6.5785e-06,
                    6.9979e-06,
                    7.5377e-06,
                    8.0019e-06,
                    8.4863e-06,
                    9.0183e-06,
                    9.5279e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2.506e-08,
                    5.1894e-08,
                    1.1399e-07,
                    1.9159e-07,
                    2.9258e-07,
                    3.7646e-07,
                    4.5853e-07,
                    5.4634e-07,
                    6.4345e-07,
                    7.5226e-07,
                    8.7051e-07,
                    1.0086e-06,
                    1.1583e-06,
                    1.298e-06,
                    1.4109e-06,
                    1.5485e-06,
                    1.6287e-06,
                    1.7581e-06,
                    1.9205e-06,
                    2.1091e-06,
                    2.3206e-06,
                    2.5602e-06,
                    2.8056e-06,
                    2.8056e-06,
                    3.113e-06,
                    3.5977e-06,
                    3.8776e-06,
                    4.2016e-06,
                    4.8568e-06,
                    5.3988e-06,
                    6.0997e-06,
                    6.5785e-06,
                    6.9979e-06,
                    7.5377e-06,
                    8.0019e-06,
                    8.4863e-06,
                    9.0183e-06,
                    9.5279e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2.506e-08,
                    5.1894e-08,
                    1.1399e-07,
                    1.9159e-07,
                    2.9258e-07,
                    3.7646e-07,
                    4.5853e-07,
                    5.4634e-07,
                    6.4345e-07,
                    7.5226e-07,
                    8.7051e-07,
                    1.0086e-06,
                    1.1583e-06,
                    1.298e-06,
                    1.4109e-06,
                    1.5485e-06,
                    1.6287e-06,
                    1.7581e-06,
                    1.9205e-06,
                    2.1091e-06,
                    2.3206e-06,
                    2.5602e-06,
                    2.8056e-06,
                    2.8056e-06,
                    3.113e-06,
                    3.5977e-06,
                    3.8776e-06,
                    4.2016e-06,
                    4.8568e-06,
                    5.3988e-06,
                    6.0997e-06,
                    6.5785e-06,
                    6.9979e-06,
                    7.5377e-06,
                    8.0019e-06,
                    8.4863e-06,
                    9.0183e-06,
                    9.5279e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": []
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -63.08825,
                            18.04626
                        ],
                        [
                            -63.02823,
                            18.01822
                        ],
                        [
                            -63.01907,
                            18.0563
                        ],
                        [
                            -63.08825,
                            18.04626
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "SVK",
                "Country": "Slovakia",
                "Total_3GHG": 0.13,
                "Total_3GHG_timeseries": [
                    2.1518e-06,
                    4.2872e-06,
                    6.4261e-06,
                    8.5361e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022
                ],
                "Fossil_3GHG": 0.19,
                "Fossil_3GHG_timeseries": [
                    2.7218e-07,
                    5.466e-07,
                    8.2333e-07,
                    1.1024e-06,
                    1.3839e-06,
                    1.6679e-06,
                    1.9545e-06,
                    2.2437e-06,
                    2.5355e-06,
                    2.8617e-06,
                    3.2596e-06,
                    3.7297e-06,
                    4.2719e-06,
                    4.8864e-06,
                    5.5731e-06,
                    6.3321e-06,
                    7.1631e-06,
                    8.0665e-06,
                    9.0423e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002
                ],
                "Land_3GHG": 0.02,
                "Land_3GHG_timeseries": [
                    1.8796e-06,
                    3.7405e-06,
                    5.6028e-06,
                    7.4337e-06,
                    9.2126e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_CO2": 0.16,
                "Total_CO2_timeseries": [
                    1.4142e-06,
                    2.8067e-06,
                    4.1972e-06,
                    5.5534e-06,
                    6.8545e-06,
                    8.1372e-06,
                    9.4067e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018
                ],
                "Fossil_CO2": 0.23,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2.931e-08,
                    1.2567e-07,
                    2.8948e-07,
                    5.2075e-07,
                    8.1947e-07,
                    1.1856e-06,
                    1.6193e-06,
                    2.1199e-06,
                    2.6881e-06,
                    3.3237e-06,
                    4.0267e-06,
                    4.7972e-06,
                    5.6347e-06,
                    6.5397e-06,
                    7.5121e-06,
                    8.552e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018
                ],
                "Land_CO2": 0.01,
                "Land_CO2_timeseries": [
                    1.4142e-06,
                    2.8067e-06,
                    4.1972e-06,
                    5.5534e-06,
                    6.8545e-06,
                    8.1372e-06,
                    9.4067e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_CH4": 0.06,
                "Total_CH4_timeseries": [
                    6.7498e-07,
                    1.3544e-06,
                    2.0384e-06,
                    2.727e-06,
                    3.4203e-06,
                    4.1184e-06,
                    4.8212e-06,
                    5.529e-06,
                    6.2417e-06,
                    6.9618e-06,
                    7.6832e-06,
                    8.406e-06,
                    9.1303e-06,
                    9.8562e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_CH4": 0.08,
                "Fossil_CH4_timeseries": [
                    2.3407e-07,
                    4.6996e-07,
                    7.0774e-07,
                    9.4747e-07,
                    1.1892e-06,
                    1.4331e-06,
                    1.6791e-06,
                    1.9273e-06,
                    2.1779e-06,
                    2.4332e-06,
                    2.6927e-06,
                    2.9566e-06,
                    3.2249e-06,
                    3.4977e-06,
                    3.7749e-06,
                    4.0566e-06,
                    4.3428e-06,
                    4.6337e-06,
                    4.9293e-06,
                    5.2295e-06,
                    5.5341e-06,
                    5.8422e-06,
                    6.1528e-06,
                    6.4651e-06,
                    6.7783e-06,
                    7.1448e-06,
                    7.512e-06,
                    7.8791e-06,
                    8.2495e-06,
                    8.6184e-06,
                    8.9867e-06,
                    9.3478e-06,
                    9.7096e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_CH4": 0.03,
                "Land_CH4_timeseries": [
                    4.4091e-07,
                    8.8447e-07,
                    1.3307e-06,
                    1.7796e-06,
                    2.2311e-06,
                    2.6853e-06,
                    3.1421e-06,
                    3.6016e-06,
                    4.0638e-06,
                    4.5286e-06,
                    4.9905e-06,
                    5.4494e-06,
                    5.9054e-06,
                    6.3585e-06,
                    6.8086e-06,
                    7.2559e-06,
                    7.7001e-06,
                    8.1415e-06,
                    8.5799e-06,
                    9.0154e-06,
                    9.4475e-06,
                    9.8763e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_N2O": 0.14,
                "Total_N2O_timeseries": [
                    6.2582e-08,
                    1.2607e-07,
                    1.9045e-07,
                    2.5567e-07,
                    3.217e-07,
                    3.8849e-07,
                    4.5596e-07,
                    5.2406e-07,
                    5.9269e-07,
                    6.6177e-07,
                    7.3124e-07,
                    8.0109e-07,
                    8.7131e-07,
                    9.4188e-07,
                    1.0128e-06,
                    1.0841e-06,
                    1.1557e-06,
                    1.2278e-06,
                    1.3002e-06,
                    1.3729e-06,
                    1.4466e-06,
                    1.522e-06,
                    1.5997e-06,
                    1.6802e-06,
                    1.7638e-06,
                    1.8505e-06,
                    1.9401e-06,
                    2.0324e-06,
                    2.1268e-06,
                    2.2227e-06,
                    2.3195e-06,
                    2.4171e-06,
                    2.5156e-06,
                    2.6147e-06,
                    2.7145e-06,
                    2.815e-06,
                    2.9161e-06,
                    3.0179e-06,
                    3.1204e-06,
                    3.2289e-06,
                    3.3344e-06,
                    3.4372e-06,
                    3.5373e-06,
                    3.6351e-06,
                    3.7309e-06,
                    3.825e-06,
                    3.9179e-06,
                    4.0099e-06,
                    4.1016e-06,
                    4.1936e-06,
                    4.2862e-06,
                    4.3795e-06,
                    4.4738e-06,
                    4.569e-06,
                    4.6653e-06,
                    4.7628e-06,
                    4.8615e-06,
                    4.9616e-06,
                    5.063e-06,
                    5.1658e-06,
                    5.271e-06,
                    5.3803e-06,
                    5.4954e-06,
                    5.6175e-06,
                    5.7475e-06,
                    5.8864e-06,
                    6.0347e-06,
                    6.1927e-06,
                    6.3603e-06,
                    6.5374e-06,
                    6.7256e-06,
                    6.9277e-06,
                    7.1454e-06,
                    7.3798e-06,
                    7.631e-06,
                    7.898e-06,
                    8.1791e-06,
                    8.4716e-06,
                    8.7718e-06,
                    9.0751e-06,
                    9.3767e-06,
                    9.6723e-06,
                    9.959e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_N2O": 0.24,
                "Fossil_N2O_timeseries": [
                    3.8111e-08,
                    7.6642e-08,
                    1.1559e-07,
                    1.5494e-07,
                    1.947e-07,
                    2.3486e-07,
                    2.7541e-07,
                    3.1633e-07,
                    3.5762e-07,
                    3.9926e-07,
                    4.4124e-07,
                    4.8357e-07,
                    5.2624e-07,
                    5.6925e-07,
                    6.1259e-07,
                    6.5628e-07,
                    7.0031e-07,
                    7.4467e-07,
                    7.8938e-07,
                    8.3444e-07,
                    8.7991e-07,
                    9.2591e-07,
                    9.7254e-07,
                    1.0199e-06,
                    1.0679e-06,
                    1.1167e-06,
                    1.1662e-06,
                    1.2164e-06,
                    1.2671e-06,
                    1.3184e-06,
                    1.3701e-06,
                    1.4222e-06,
                    1.4747e-06,
                    1.5276e-06,
                    1.5808e-06,
                    1.6345e-06,
                    1.6885e-06,
                    1.743e-06,
                    1.7978e-06,
                    1.8533e-06,
                    1.9092e-06,
                    1.9656e-06,
                    2.0226e-06,
                    2.08e-06,
                    2.1379e-06,
                    2.1963e-06,
                    2.2552e-06,
                    2.3147e-06,
                    2.3747e-06,
                    2.4353e-06,
                    2.4964e-06,
                    2.5581e-06,
                    2.6205e-06,
                    2.6835e-06,
                    2.7473e-06,
                    2.8117e-06,
                    2.8767e-06,
                    2.9425e-06,
                    3.0088e-06,
                    3.0758e-06,
                    3.1433e-06,
                    3.2114e-06,
                    3.28e-06,
                    3.3491e-06,
                    3.4188e-06,
                    3.489e-06,
                    3.5598e-06,
                    3.6311e-06,
                    3.7029e-06,
                    3.7753e-06,
                    3.8484e-06,
                    3.922e-06,
                    3.9962e-06,
                    4.0712e-06,
                    4.1467e-06,
                    4.223e-06,
                    4.2999e-06,
                    4.3774e-06,
                    4.4556e-06,
                    4.5344e-06,
                    4.6144e-06,
                    4.6966e-06,
                    4.782e-06,
                    4.8712e-06,
                    4.9648e-06,
                    5.063e-06,
                    5.1661e-06,
                    5.2741e-06,
                    5.3866e-06,
                    5.5034e-06,
                    5.6243e-06,
                    5.7495e-06,
                    5.8793e-06,
                    6.014e-06,
                    6.1539e-06,
                    6.2995e-06,
                    6.4511e-06,
                    6.6091e-06,
                    6.7742e-06,
                    6.9468e-06,
                    7.1298e-06,
                    7.3279e-06,
                    7.5455e-06,
                    7.7859e-06,
                    8.0522e-06,
                    8.3467e-06,
                    8.671e-06,
                    9.0261e-06,
                    9.4126e-06,
                    9.8301e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_N2O": 0.1,
                "Land_N2O_timeseries": [
                    2.4471e-08,
                    4.9431e-08,
                    7.4859e-08,
                    1.0073e-07,
                    1.27e-07,
                    1.5362e-07,
                    1.8055e-07,
                    2.0773e-07,
                    2.3507e-07,
                    2.6251e-07,
                    2.9e-07,
                    3.1752e-07,
                    3.4507e-07,
                    3.7264e-07,
                    4.0022e-07,
                    4.2782e-07,
                    4.5544e-07,
                    4.8309e-07,
                    5.1078e-07,
                    5.3851e-07,
                    5.6671e-07,
                    5.9609e-07,
                    6.2718e-07,
                    6.6038e-07,
                    6.9589e-07,
                    7.3377e-07,
                    7.739e-07,
                    8.1602e-07,
                    8.5967e-07,
                    9.0426e-07,
                    9.4938e-07,
                    9.9494e-07,
                    1.0409e-06,
                    1.0871e-06,
                    1.1337e-06,
                    1.1805e-06,
                    1.2276e-06,
                    1.275e-06,
                    1.3227e-06,
                    1.3756e-06,
                    1.4252e-06,
                    1.4715e-06,
                    1.5148e-06,
                    1.5552e-06,
                    1.593e-06,
                    1.6287e-06,
                    1.6626e-06,
                    1.6952e-06,
                    1.7269e-06,
                    1.7583e-06,
                    1.7898e-06,
                    1.8214e-06,
                    1.8533e-06,
                    1.8854e-06,
                    1.918e-06,
                    1.9511e-06,
                    1.9848e-06,
                    2.0191e-06,
                    2.0542e-06,
                    2.09e-06,
                    2.1277e-06,
                    2.169e-06,
                    2.2154e-06,
                    2.2683e-06,
                    2.3287e-06,
                    2.3974e-06,
                    2.4749e-06,
                    2.5616e-06,
                    2.6574e-06,
                    2.7621e-06,
                    2.8773e-06,
                    3.0057e-06,
                    3.1492e-06,
                    3.3087e-06,
                    3.4843e-06,
                    3.6751e-06,
                    3.8793e-06,
                    4.0942e-06,
                    4.3162e-06,
                    4.5408e-06,
                    4.7623e-06,
                    4.9757e-06,
                    5.177e-06,
                    5.3636e-06,
                    5.5343e-06,
                    5.6891e-06,
                    5.8292e-06,
                    5.9572e-06,
                    6.0771e-06,
                    6.1939e-06,
                    6.3194e-06,
                    6.4686e-06,
                    6.653e-06,
                    6.8806e-06,
                    7.1557e-06,
                    7.4793e-06,
                    7.8488e-06,
                    8.2579e-06,
                    8.6969e-06,
                    9.1527e-06,
                    9.6168e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            22.56684,
                            49.08838
                        ],
                        [
                            22.41306,
                            49.1028
                        ],
                        [
                            22.03489,
                            49.22246
                        ],
                        [
                            22.03396,
                            49.27811
                        ],
                        [
                            21.96409,
                            49.34655
                        ],
                        [
                            21.84046,
                            49.39083
                        ],
                        [
                            21.76297,
                            49.38326
                        ],
                        [
                            21.63003,
                            49.44684
                        ],
                        [
                            21.43028,
                            49.41413
                        ],
                        [
                            21.27659,
                            49.46044
                        ],
                        [
                            21.19147,
                            49.4014
                        ],
                        [
                            21.12315,
                            49.43582
                        ],
                        [
                            21.05527,
                            49.42131
                        ],
                        [
                            21.04466,
                            49.36524
                        ],
                        [
                            20.9319,
                            49.29727
                        ],
                        [
                            20.69369,
                            49.41962
                        ],
                        [
                            20.575,
                            49.3766
                        ],
                        [
                            20.47431,
                            49.41464
                        ],
                        [
                            20.32291,
                            49.3514
                        ],
                        [
                            20.22143,
                            49.35126
                        ],
                        [
                            20.14685,
                            49.31792
                        ],
                        [
                            20.07108,
                            49.18023
                        ],
                        [
                            19.98209,
                            49.23128
                        ],
                        [
                            19.86837,
                            49.19651
                        ],
                        [
                            19.76355,
                            49.20742
                        ],
                        [
                            19.80455,
                            49.32277
                        ],
                        [
                            19.79013,
                            49.41018
                        ],
                        [
                            19.70481,
                            49.39645
                        ],
                        [
                            19.5806,
                            49.46064
                        ],
                        [
                            19.52948,
                            49.57317
                        ],
                        [
                            19.46739,
                            49.61377
                        ],
                        [
                            19.26071,
                            49.53122
                        ],
                        [
                            19.19648,
                            49.41525
                        ],
                        [
                            19.15414,
                            49.40421
                        ],
                        [
                            18.98814,
                            49.43088
                        ],
                        [
                            18.94659,
                            49.51737
                        ],
                        [
                            18.85155,
                            49.51719
                        ],
                        [
                            18.54568,
                            49.50026
                        ],
                        [
                            18.47584,
                            49.40926
                        ],
                        [
                            18.40838,
                            49.38979
                        ],
                        [
                            18.379,
                            49.33098
                        ],
                        [
                            18.18419,
                            49.28672
                        ],
                        [
                            18.14706,
                            49.24637
                        ],
                        [
                            18.11545,
                            49.09266
                        ],
                        [
                            18.0689,
                            49.03726
                        ],
                        [
                            17.91258,
                            49.00724
                        ],
                        [
                            17.88491,
                            48.92775
                        ],
                        [
                            17.78295,
                            48.92496
                        ],
                        [
                            17.70321,
                            48.86023
                        ],
                        [
                            17.52041,
                            48.8129
                        ],
                        [
                            17.45177,
                            48.84588
                        ],
                        [
                            17.3618,
                            48.81362
                        ],
                        [
                            17.19345,
                            48.87503
                        ],
                        [
                            17.04594,
                            48.76618
                        ],
                        [
                            16.94028,
                            48.61725
                        ],
                        [
                            16.95311,
                            48.54395
                        ],
                        [
                            16.85067,
                            48.44878
                        ],
                        [
                            16.84665,
                            48.34955
                        ],
                        [
                            16.95718,
                            48.26348
                        ],
                        [
                            16.9762,
                            48.17224
                        ],
                        [
                            17.05738,
                            48.14179
                        ],
                        [
                            17.06863,
                            48.03179
                        ],
                        [
                            17.1608,
                            48.00666
                        ],
                        [
                            17.3368,
                            47.99168
                        ],
                        [
                            17.45134,
                            47.888
                        ],
                        [
                            17.52684,
                            47.86544
                        ],
                        [
                            17.71231,
                            47.75551
                        ],
                        [
                            17.89392,
                            47.73946
                        ],
                        [
                            18.0875,
                            47.75636
                        ],
                        [
                            18.29298,
                            47.7314
                        ],
                        [
                            18.43067,
                            47.75614
                        ],
                        [
                            18.67026,
                            47.76316
                        ],
                        [
                            18.82088,
                            47.85089
                        ],
                        [
                            18.75865,
                            47.92031
                        ],
                        [
                            18.8207,
                            48.03854
                        ],
                        [
                            19.13517,
                            48.07399
                        ],
                        [
                            19.24636,
                            48.05674
                        ],
                        [
                            19.30033,
                            48.08799
                        ],
                        [
                            19.4858,
                            48.09971
                        ],
                        [
                            19.52657,
                            48.20313
                        ],
                        [
                            19.63082,
                            48.25008
                        ],
                        [
                            19.69217,
                            48.20446
                        ],
                        [
                            19.76118,
                            48.2131
                        ],
                        [
                            19.89874,
                            48.16632
                        ],
                        [
                            20.02919,
                            48.17718
                        ],
                        [
                            20.24042,
                            48.28023
                        ],
                        [
                            20.28619,
                            48.26199
                        ],
                        [
                            20.41182,
                            48.36974
                        ],
                        [
                            20.41773,
                            48.41993
                        ],
                        [
                            20.50525,
                            48.48901
                        ],
                        [
                            20.50294,
                            48.52931
                        ],
                        [
                            20.7085,
                            48.56945
                        ],
                        [
                            20.84939,
                            48.57922
                        ],
                        [
                            20.95837,
                            48.52144
                        ],
                        [
                            21.01552,
                            48.53182
                        ],
                        [
                            21.13348,
                            48.49555
                        ],
                        [
                            21.23928,
                            48.53967
                        ],
                        [
                            21.42147,
                            48.5641
                        ],
                        [
                            21.61135,
                            48.51008
                        ],
                        [
                            21.6695,
                            48.38955
                        ],
                        [
                            21.7656,
                            48.33906
                        ],
                        [
                            22.02818,
                            48.39183
                        ],
                        [
                            22.15531,
                            48.4034
                        ],
                        [
                            22.16099,
                            48.56725
                        ],
                        [
                            22.18958,
                            48.60933
                        ],
                        [
                            22.34082,
                            48.68707
                        ],
                        [
                            22.34594,
                            48.7659
                        ],
                        [
                            22.42826,
                            48.93181
                        ],
                        [
                            22.47959,
                            48.99268
                        ],
                        [
                            22.54477,
                            49.00827
                        ],
                        [
                            22.56684,
                            49.08838
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "SVN",
                "Country": "Slovenia",
                "Total_3GHG": 0.04,
                "Total_3GHG_timeseries": [
                    4.6151e-07,
                    9.3864e-07,
                    1.4093e-06,
                    1.8656e-06,
                    2.3358e-06,
                    2.8137e-06,
                    3.3074e-06,
                    3.8028e-06,
                    4.2772e-06,
                    4.7895e-06,
                    5.294e-06,
                    5.8118e-06,
                    6.3295e-06,
                    6.8544e-06,
                    7.3975e-06,
                    7.9605e-06,
                    8.5332e-06,
                    9.1095e-06,
                    9.7111e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Fossil_3GHG": 0.05,
                "Fossil_3GHG_timeseries": [
                    4.0987e-08,
                    8.2269e-08,
                    1.2384e-07,
                    1.6571e-07,
                    2.0787e-07,
                    2.5032e-07,
                    2.9304e-07,
                    3.3606e-07,
                    3.7934e-07,
                    4.2291e-07,
                    4.6756e-07,
                    5.1329e-07,
                    5.6012e-07,
                    6.0802e-07,
                    6.5702e-07,
                    7.0709e-07,
                    7.5824e-07,
                    8.1048e-07,
                    8.638e-07,
                    9.182e-07,
                    9.7384e-07,
                    1.0308e-06,
                    1.089e-06,
                    1.1485e-06,
                    1.2094e-06,
                    1.2716e-06,
                    1.3351e-06,
                    1.3999e-06,
                    1.466e-06,
                    1.5334e-06,
                    1.6014e-06,
                    1.67e-06,
                    1.7392e-06,
                    1.809e-06,
                    1.8814e-06,
                    1.9524e-06,
                    2.0241e-06,
                    2.0963e-06,
                    2.1691e-06,
                    2.2485e-06,
                    2.3294e-06,
                    2.4118e-06,
                    2.5007e-06,
                    2.6023e-06,
                    2.7047e-06,
                    2.8106e-06,
                    2.9108e-06,
                    3.0232e-06,
                    3.1418e-06,
                    3.2749e-06,
                    3.4106e-06,
                    3.5403e-06,
                    3.6723e-06,
                    3.8058e-06,
                    3.9419e-06,
                    4.0891e-06,
                    4.2351e-06,
                    4.3849e-06,
                    4.5344e-06,
                    4.6794e-06,
                    4.8299e-06,
                    4.9807e-06,
                    5.3043e-06,
                    5.3479e-06,
                    5.3892e-06,
                    5.4278e-06,
                    5.4648e-06,
                    5.4978e-06,
                    5.7255e-06,
                    6.0138e-06,
                    6.3227e-06,
                    6.7634e-06,
                    7.2448e-06,
                    7.7413e-06,
                    8.2862e-06,
                    8.8811e-06,
                    9.5481e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Land_3GHG": 0.03,
                "Land_3GHG_timeseries": [
                    4.2052e-07,
                    8.5637e-07,
                    1.2855e-06,
                    1.6998e-06,
                    2.1279e-06,
                    2.5634e-06,
                    3.0144e-06,
                    3.4668e-06,
                    3.8978e-06,
                    4.3666e-06,
                    4.8264e-06,
                    5.2985e-06,
                    5.7694e-06,
                    6.2464e-06,
                    6.7405e-06,
                    7.2534e-06,
                    7.7749e-06,
                    8.299e-06,
                    8.8473e-06,
                    9.3972e-06,
                    9.9665e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Total_CO2": 0.04,
                "Total_CO2_timeseries": [
                    2.6443e-07,
                    5.4303e-07,
                    8.1377e-07,
                    1.0686e-06,
                    1.3361e-06,
                    1.6099e-06,
                    1.8982e-06,
                    2.1869e-06,
                    2.4533e-06,
                    2.7565e-06,
                    3.0455e-06,
                    3.3418e-06,
                    3.6316e-06,
                    3.9224e-06,
                    4.2251e-06,
                    4.5415e-06,
                    4.8613e-06,
                    5.1785e-06,
                    5.5148e-06,
                    5.8476e-06,
                    6.1936e-06,
                    6.5672e-06,
                    6.9438e-06,
                    7.3113e-06,
                    7.6985e-06,
                    8.0981e-06,
                    8.5189e-06,
                    8.9419e-06,
                    9.3489e-06,
                    9.7985e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Fossil_CO2": 0.05,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.6847e-09,
                    1.6847e-09,
                    1.6847e-09,
                    1.6847e-09,
                    1.6847e-09,
                    6.7383e-09,
                    1.2634e-08,
                    1.9162e-08,
                    3.0744e-08,
                    5.2854e-08,
                    7.4964e-08,
                    9.9601e-08,
                    1.1876e-07,
                    1.4782e-07,
                    1.8172e-07,
                    2.2763e-07,
                    2.7774e-07,
                    3.247e-07,
                    3.7566e-07,
                    4.2999e-07,
                    4.8895e-07,
                    5.5949e-07,
                    6.313e-07,
                    7.0858e-07,
                    7.8796e-07,
                    8.6651e-07,
                    9.5158e-07,
                    1.0388e-06,
                    1.2782e-06,
                    1.2782e-06,
                    1.2782e-06,
                    1.2782e-06,
                    1.2782e-06,
                    1.2782e-06,
                    1.4498e-06,
                    1.6776e-06,
                    1.9202e-06,
                    2.2727e-06,
                    2.6572e-06,
                    3.0514e-06,
                    3.4841e-06,
                    3.9055e-06,
                    4.3816e-06,
                    4.9197e-06,
                    5.5095e-06,
                    6.0645e-06,
                    6.5746e-06,
                    7.0401e-06,
                    7.4706e-06,
                    7.9188e-06,
                    8.3877e-06,
                    8.8505e-06,
                    9.3665e-06,
                    9.8547e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Land_CO2": 0.02,
                "Land_CO2_timeseries": [
                    2.6443e-07,
                    5.4303e-07,
                    8.1377e-07,
                    1.0686e-06,
                    1.3361e-06,
                    1.6099e-06,
                    1.8982e-06,
                    2.1869e-06,
                    2.4533e-06,
                    2.7565e-06,
                    3.0455e-06,
                    3.3418e-06,
                    3.6316e-06,
                    3.9224e-06,
                    4.2251e-06,
                    4.5415e-06,
                    4.8613e-06,
                    5.1785e-06,
                    5.5148e-06,
                    5.8476e-06,
                    6.1936e-06,
                    6.5672e-06,
                    6.9438e-06,
                    7.3113e-06,
                    7.6985e-06,
                    8.0981e-06,
                    8.5189e-06,
                    8.9419e-06,
                    9.3489e-06,
                    9.7985e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_CH4": 0.04,
                "Total_CH4_timeseries": [
                    1.6771e-07,
                    3.364e-07,
                    5.0609e-07,
                    6.7677e-07,
                    8.4843e-07,
                    1.0211e-06,
                    1.1947e-06,
                    1.3694e-06,
                    1.545e-06,
                    1.7216e-06,
                    1.9043e-06,
                    2.0931e-06,
                    2.288e-06,
                    2.489e-06,
                    2.6961e-06,
                    2.9093e-06,
                    3.1286e-06,
                    3.354e-06,
                    3.5855e-06,
                    3.823e-06,
                    4.0676e-06,
                    4.3191e-06,
                    4.5777e-06,
                    4.8433e-06,
                    5.1158e-06,
                    5.3954e-06,
                    5.6819e-06,
                    5.9754e-06,
                    6.2759e-06,
                    6.5835e-06,
                    6.8942e-06,
                    7.2083e-06,
                    7.5256e-06,
                    7.8462e-06,
                    8.1703e-06,
                    8.4974e-06,
                    8.8277e-06,
                    9.1614e-06,
                    9.4983e-06,
                    9.8392e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_CH4": 0.04,
                "Fossil_CH4_timeseries": [
                    2.6609e-08,
                    5.3359e-08,
                    8.0249e-08,
                    1.0728e-07,
                    1.3445e-07,
                    1.6176e-07,
                    1.892e-07,
                    2.1679e-07,
                    2.4451e-07,
                    2.7238e-07,
                    3.012e-07,
                    3.3097e-07,
                    3.617e-07,
                    3.9338e-07,
                    4.2602e-07,
                    4.596e-07,
                    4.9414e-07,
                    5.2963e-07,
                    5.6607e-07,
                    6.0345e-07,
                    6.4192e-07,
                    6.8148e-07,
                    7.2212e-07,
                    7.6385e-07,
                    8.0665e-07,
                    8.5054e-07,
                    8.9551e-07,
                    9.4155e-07,
                    9.8867e-07,
                    1.0369e-06,
                    1.0855e-06,
                    1.1347e-06,
                    1.1843e-06,
                    1.2343e-06,
                    1.2851e-06,
                    1.336e-06,
                    1.3875e-06,
                    1.4394e-06,
                    1.4917e-06,
                    1.5453e-06,
                    1.5995e-06,
                    1.6543e-06,
                    1.7103e-06,
                    1.7685e-06,
                    1.8272e-06,
                    1.8867e-06,
                    1.9459e-06,
                    2.007e-06,
                    2.0694e-06,
                    2.1342e-06,
                    2.1971e-06,
                    2.257e-06,
                    2.3149e-06,
                    2.3707e-06,
                    2.4243e-06,
                    2.4772e-06,
                    2.5274e-06,
                    2.5757e-06,
                    2.6214e-06,
                    2.6632e-06,
                    2.7038e-06,
                    2.7424e-06,
                    2.8014e-06,
                    2.8196e-06,
                    2.8353e-06,
                    2.8481e-06,
                    2.8591e-06,
                    2.866e-06,
                    2.8957e-06,
                    2.9296e-06,
                    2.9692e-06,
                    3.0304e-06,
                    3.1001e-06,
                    3.1751e-06,
                    3.2596e-06,
                    3.4053e-06,
                    3.5682e-06,
                    3.7457e-06,
                    3.9431e-06,
                    4.1447e-06,
                    4.3435e-06,
                    4.5452e-06,
                    4.7288e-06,
                    4.9589e-06,
                    5.2012e-06,
                    5.4528e-06,
                    5.7226e-06,
                    5.9971e-06,
                    6.2609e-06,
                    6.5416e-06,
                    6.7468e-06,
                    6.954e-06,
                    7.1752e-06,
                    7.4148e-06,
                    7.7288e-06,
                    8.0776e-06,
                    8.5017e-06,
                    8.9883e-06,
                    9.5438e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CH4": 0.03,
                "Land_CH4_timeseries": [
                    1.411e-07,
                    2.8304e-07,
                    4.2584e-07,
                    5.6949e-07,
                    7.1399e-07,
                    8.5933e-07,
                    1.0055e-06,
                    1.1526e-06,
                    1.3005e-06,
                    1.4492e-06,
                    1.6031e-06,
                    1.7621e-06,
                    1.9263e-06,
                    2.0956e-06,
                    2.2701e-06,
                    2.4497e-06,
                    2.6345e-06,
                    2.8243e-06,
                    3.0194e-06,
                    3.2196e-06,
                    3.4257e-06,
                    3.6377e-06,
                    3.8556e-06,
                    4.0794e-06,
                    4.3092e-06,
                    4.5448e-06,
                    4.7864e-06,
                    5.0339e-06,
                    5.2873e-06,
                    5.5466e-06,
                    5.8087e-06,
                    6.0736e-06,
                    6.3413e-06,
                    6.6119e-06,
                    6.8852e-06,
                    7.1613e-06,
                    7.4403e-06,
                    7.722e-06,
                    8.0065e-06,
                    8.2939e-06,
                    8.5843e-06,
                    8.8779e-06,
                    9.1746e-06,
                    9.4743e-06,
                    9.7772e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_N2O": 0.05,
                "Total_N2O_timeseries": [
                    2.9376e-08,
                    5.9206e-08,
                    8.9477e-08,
                    1.2017e-07,
                    1.5126e-07,
                    1.8272e-07,
                    2.145e-07,
                    2.4658e-07,
                    2.7891e-07,
                    3.1142e-07,
                    3.441e-07,
                    3.7693e-07,
                    4.0991e-07,
                    4.4303e-07,
                    4.7629e-07,
                    5.097e-07,
                    5.4325e-07,
                    5.7694e-07,
                    6.1079e-07,
                    6.448e-07,
                    6.7926e-07,
                    7.1462e-07,
                    7.5125e-07,
                    7.8941e-07,
                    8.2923e-07,
                    8.7075e-07,
                    9.139e-07,
                    9.585e-07,
                    1.0042e-06,
                    1.0507e-06,
                    1.0977e-06,
                    1.1451e-06,
                    1.1929e-06,
                    1.241e-06,
                    1.2895e-06,
                    1.3382e-06,
                    1.3873e-06,
                    1.4367e-06,
                    1.4864e-06,
                    1.5396e-06,
                    1.5908e-06,
                    1.6403e-06,
                    1.688e-06,
                    1.7341e-06,
                    1.7789e-06,
                    1.8226e-06,
                    1.8653e-06,
                    1.9073e-06,
                    1.949e-06,
                    1.9908e-06,
                    2.0327e-06,
                    2.075e-06,
                    2.1176e-06,
                    2.1607e-06,
                    2.2042e-06,
                    2.2483e-06,
                    2.2929e-06,
                    2.3381e-06,
                    2.3841e-06,
                    2.4307e-06,
                    2.4786e-06,
                    2.5289e-06,
                    2.5826e-06,
                    2.6404e-06,
                    2.703e-06,
                    2.7709e-06,
                    2.8444e-06,
                    2.9236e-06,
                    3.0087e-06,
                    3.0994e-06,
                    3.1968e-06,
                    3.3025e-06,
                    3.4176e-06,
                    3.5427e-06,
                    3.678e-06,
                    3.8227e-06,
                    3.976e-06,
                    4.136e-06,
                    4.3005e-06,
                    4.4669e-06,
                    4.6316e-06,
                    4.7915e-06,
                    4.9443e-06,
                    5.0883e-06,
                    5.2228e-06,
                    5.3479e-06,
                    5.4642e-06,
                    5.5735e-06,
                    5.678e-06,
                    5.7811e-06,
                    5.8898e-06,
                    6.0137e-06,
                    6.1599e-06,
                    6.3333e-06,
                    6.5367e-06,
                    6.7708e-06,
                    7.0339e-06,
                    7.3222e-06,
                    7.6298e-06,
                    7.9484e-06,
                    8.273e-06,
                    8.6029e-06,
                    8.9379e-06,
                    9.2775e-06,
                    9.6215e-06,
                    9.9697e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_N2O": 0.04,
                "Fossil_N2O_timeseries": [
                    1.4377e-08,
                    2.891e-08,
                    4.3596e-08,
                    5.8434e-08,
                    7.3423e-08,
                    8.8559e-08,
                    1.0384e-07,
                    1.1927e-07,
                    1.3483e-07,
                    1.5053e-07,
                    1.6636e-07,
                    1.8232e-07,
                    1.9842e-07,
                    2.1464e-07,
                    2.31e-07,
                    2.4748e-07,
                    2.641e-07,
                    2.8085e-07,
                    2.9773e-07,
                    3.1475e-07,
                    3.3192e-07,
                    3.4927e-07,
                    3.6685e-07,
                    3.8466e-07,
                    4.0272e-07,
                    4.2102e-07,
                    4.3958e-07,
                    4.5836e-07,
                    4.7735e-07,
                    4.9651e-07,
                    5.1584e-07,
                    5.3531e-07,
                    5.5494e-07,
                    5.7471e-07,
                    5.9463e-07,
                    6.1469e-07,
                    6.3489e-07,
                    6.5524e-07,
                    6.7573e-07,
                    6.9645e-07,
                    7.1733e-07,
                    7.3837e-07,
                    7.5959e-07,
                    7.8098e-07,
                    8.0255e-07,
                    8.243e-07,
                    8.4622e-07,
                    8.6833e-07,
                    8.9062e-07,
                    9.131e-07,
                    9.3578e-07,
                    9.5866e-07,
                    9.8176e-07,
                    1.0051e-06,
                    1.0286e-06,
                    1.0524e-06,
                    1.0764e-06,
                    1.1006e-06,
                    1.125e-06,
                    1.1497e-06,
                    1.1745e-06,
                    1.1995e-06,
                    1.2247e-06,
                    1.2501e-06,
                    1.2757e-06,
                    1.3015e-06,
                    1.3275e-06,
                    1.3536e-06,
                    1.38e-06,
                    1.4065e-06,
                    1.4333e-06,
                    1.4603e-06,
                    1.4874e-06,
                    1.5148e-06,
                    1.5425e-06,
                    1.5703e-06,
                    1.5984e-06,
                    1.6266e-06,
                    1.6551e-06,
                    1.6838e-06,
                    1.7127e-06,
                    1.7419e-06,
                    1.7713e-06,
                    1.8009e-06,
                    1.8308e-06,
                    1.861e-06,
                    1.8915e-06,
                    1.9223e-06,
                    1.9534e-06,
                    1.9848e-06,
                    2.0167e-06,
                    2.0491e-06,
                    2.0822e-06,
                    2.1161e-06,
                    2.1509e-06,
                    2.1867e-06,
                    2.2233e-06,
                    2.2609e-06,
                    2.2994e-06,
                    2.3387e-06,
                    2.3788e-06,
                    2.4198e-06,
                    2.4618e-06,
                    2.5048e-06,
                    2.549e-06,
                    2.5945e-06,
                    2.6413e-06,
                    2.6894e-06,
                    2.7391e-06,
                    2.7902e-06,
                    2.843e-06,
                    2.8975e-06,
                    2.9538e-06,
                    3.0121e-06,
                    3.0726e-06,
                    3.1356e-06,
                    3.2013e-06,
                    3.2701e-06,
                    3.3424e-06,
                    3.4188e-06,
                    3.4954e-06,
                    3.5661e-06,
                    3.6402e-06,
                    3.7201e-06,
                    3.7997e-06,
                    3.8774e-06,
                    3.9577e-06,
                    4.0409e-06,
                    4.1213e-06,
                    4.199e-06,
                    4.282e-06,
                    4.3632e-06,
                    4.4451e-06,
                    4.526e-06,
                    4.6098e-06,
                    4.7028e-06,
                    4.7875e-06,
                    4.8986e-06,
                    5.0151e-06,
                    5.1283e-06,
                    5.2324e-06,
                    5.3269e-06,
                    5.4276e-06,
                    5.532e-06,
                    5.6415e-06,
                    5.7558e-06,
                    5.8715e-06,
                    5.9908e-06,
                    6.1055e-06,
                    6.2264e-06,
                    6.3502e-06,
                    6.4721e-06,
                    6.5946e-06,
                    6.7163e-06,
                    6.8399e-06,
                    6.9631e-06,
                    7.0898e-06,
                    7.2239e-06,
                    7.3469e-06,
                    7.4724e-06,
                    7.6005e-06,
                    7.7274e-06,
                    7.8528e-06,
                    7.9749e-06,
                    8.0965e-06,
                    8.2209e-06,
                    8.3455e-06,
                    8.4683e-06,
                    8.5877e-06,
                    8.7005e-06,
                    8.8174e-06,
                    8.937e-06
                ],
                "Land_N2O": 0.05,
                "Land_N2O_timeseries": [
                    1.4998e-08,
                    3.0296e-08,
                    4.5882e-08,
                    6.1736e-08,
                    7.7837e-08,
                    9.4156e-08,
                    1.1066e-07,
                    1.2732e-07,
                    1.4408e-07,
                    1.609e-07,
                    1.7774e-07,
                    1.9461e-07,
                    2.115e-07,
                    2.2839e-07,
                    2.453e-07,
                    2.6221e-07,
                    2.7914e-07,
                    2.9609e-07,
                    3.1306e-07,
                    3.3005e-07,
                    3.4734e-07,
                    3.6534e-07,
                    3.844e-07,
                    4.0475e-07,
                    4.2651e-07,
                    4.4973e-07,
                    4.7433e-07,
                    5.0014e-07,
                    5.2689e-07,
                    5.5422e-07,
                    5.8188e-07,
                    6.098e-07,
                    6.3795e-07,
                    6.663e-07,
                    6.9483e-07,
                    7.2353e-07,
                    7.5239e-07,
                    7.8143e-07,
                    8.1066e-07,
                    8.4313e-07,
                    8.7351e-07,
                    9.0189e-07,
                    9.284e-07,
                    9.5316e-07,
                    9.7638e-07,
                    9.9826e-07,
                    1.019e-06,
                    1.039e-06,
                    1.0584e-06,
                    1.0777e-06,
                    1.097e-06,
                    1.1163e-06,
                    1.1359e-06,
                    1.1556e-06,
                    1.1756e-06,
                    1.1959e-06,
                    1.2165e-06,
                    1.2375e-06,
                    1.259e-06,
                    1.281e-06,
                    1.3041e-06,
                    1.3294e-06,
                    1.3578e-06,
                    1.3903e-06,
                    1.4273e-06,
                    1.4694e-06,
                    1.5169e-06,
                    1.57e-06,
                    1.6287e-06,
                    1.6929e-06,
                    1.7635e-06,
                    1.8422e-06,
                    1.9301e-06,
                    2.0279e-06,
                    2.1355e-06,
                    2.2525e-06,
                    2.3776e-06,
                    2.5093e-06,
                    2.6454e-06,
                    2.783e-06,
                    2.9188e-06,
                    3.0496e-06,
                    3.173e-06,
                    3.2874e-06,
                    3.392e-06,
                    3.4869e-06,
                    3.5727e-06,
                    3.6512e-06,
                    3.7246e-06,
                    3.7962e-06,
                    3.8732e-06,
                    3.9646e-06,
                    4.0777e-06,
                    4.2171e-06,
                    4.3858e-06,
                    4.5841e-06,
                    4.8105e-06,
                    5.0613e-06,
                    5.3304e-06,
                    5.6097e-06,
                    5.8942e-06,
                    6.1832e-06,
                    6.4761e-06,
                    6.7727e-06,
                    7.0724e-06,
                    7.3752e-06,
                    7.6809e-06,
                    7.9894e-06,
                    8.3009e-06,
                    8.6155e-06,
                    8.9591e-06,
                    9.3153e-06,
                    9.6593e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            16.59681,
                            46.4759
                        ],
                        [
                            16.52522,
                            46.50455
                        ],
                        [
                            16.4198,
                            46.65848
                        ],
                        [
                            16.42662,
                            46.69188
                        ],
                        [
                            16.31873,
                            46.75561
                        ],
                        [
                            16.3472,
                            46.84044
                        ],
                        [
                            16.24176,
                            46.87629
                        ],
                        [
                            16.11385,
                            46.86907
                        ],
                        [
                            15.99624,
                            46.8354
                        ],
                        [
                            15.98362,
                            46.68461
                        ],
                        [
                            15.8623,
                            46.72207
                        ],
                        [
                            15.7257,
                            46.69617
                        ],
                        [
                            15.64999,
                            46.70576
                        ],
                        [
                            15.54628,
                            46.67015
                        ],
                        [
                            15.46268,
                            46.61643
                        ],
                        [
                            15.41919,
                            46.65489
                        ],
                        [
                            15.23619,
                            46.63968
                        ],
                        [
                            15.10869,
                            46.65891
                        ],
                        [
                            15.01599,
                            46.64021
                        ],
                        [
                            14.97932,
                            46.6014
                        ],
                        [
                            14.86817,
                            46.6052
                        ],
                        [
                            14.81861,
                            46.50938
                        ],
                        [
                            14.74147,
                            46.50459
                        ],
                        [
                            14.67458,
                            46.45069
                        ],
                        [
                            14.4472,
                            46.42197
                        ],
                        [
                            14.1534,
                            46.43678
                        ],
                        [
                            14.12014,
                            46.47667
                        ],
                        [
                            14.00652,
                            46.48136
                        ],
                        [
                            13.91256,
                            46.52072
                        ],
                        [
                            13.81254,
                            46.50642
                        ],
                        [
                            13.71419,
                            46.5227
                        ],
                        [
                            13.69277,
                            46.4432
                        ],
                        [
                            13.59709,
                            46.43855
                        ],
                        [
                            13.56616,
                            46.39886
                        ],
                        [
                            13.43747,
                            46.35437
                        ],
                        [
                            13.39141,
                            46.28294
                        ],
                        [
                            13.44404,
                            46.22543
                        ],
                        [
                            13.63361,
                            46.19179
                        ],
                        [
                            13.64376,
                            46.13735
                        ],
                        [
                            13.53024,
                            46.06738
                        ],
                        [
                            13.47711,
                            46.00625
                        ],
                        [
                            13.52912,
                            45.96715
                        ],
                        [
                            13.64206,
                            45.98275
                        ],
                        [
                            13.57605,
                            45.85353
                        ],
                        [
                            13.6248,
                            45.79681
                        ],
                        [
                            13.79568,
                            45.7432
                        ],
                        [
                            13.83388,
                            45.68726
                        ],
                        [
                            13.91808,
                            45.6332
                        ],
                        [
                            13.83876,
                            45.58228
                        ],
                        [
                            13.72282,
                            45.59473
                        ],
                        [
                            13.71911,
                            45.5436
                        ],
                        [
                            13.60218,
                            45.53637
                        ],
                        [
                            13.58553,
                            45.49768
                        ],
                        [
                            13.60136,
                            45.46792
                        ],
                        [
                            13.6513,
                            45.45405
                        ],
                        [
                            13.78616,
                            45.46643
                        ],
                        [
                            13.81494,
                            45.43433
                        ],
                        [
                            13.98581,
                            45.45735
                        ],
                        [
                            14.01101,
                            45.51988
                        ],
                        [
                            14.14147,
                            45.47519
                        ],
                        [
                            14.24499,
                            45.50538
                        ],
                        [
                            14.32278,
                            45.47041
                        ],
                        [
                            14.48835,
                            45.53685
                        ],
                        [
                            14.51354,
                            45.60734
                        ],
                        [
                            14.59671,
                            45.62756
                        ],
                        [
                            14.6772,
                            45.58911
                        ],
                        [
                            14.8173,
                            45.46156
                        ],
                        [
                            14.98692,
                            45.49667
                        ],
                        [
                            15.04978,
                            45.49309
                        ],
                        [
                            15.15752,
                            45.42489
                        ],
                        [
                            15.32893,
                            45.45295
                        ],
                        [
                            15.38454,
                            45.48848
                        ],
                        [
                            15.29907,
                            45.54701
                        ],
                        [
                            15.30147,
                            45.62848
                        ],
                        [
                            15.39949,
                            45.65081
                        ],
                        [
                            15.29901,
                            45.75348
                        ],
                        [
                            15.57831,
                            45.84946
                        ],
                        [
                            15.69257,
                            45.84335
                        ],
                        [
                            15.71465,
                            46.05942
                        ],
                        [
                            15.60455,
                            46.11225
                        ],
                        [
                            15.60831,
                            46.16763
                        ],
                        [
                            15.67485,
                            46.22712
                        ],
                        [
                            15.78642,
                            46.2174
                        ],
                        [
                            15.79148,
                            46.25933
                        ],
                        [
                            16.00315,
                            46.30764
                        ],
                        [
                            16.14148,
                            46.40506
                        ],
                        [
                            16.18963,
                            46.37835
                        ],
                        [
                            16.30155,
                            46.37829
                        ],
                        [
                            16.24163,
                            46.49835
                        ],
                        [
                            16.34313,
                            46.54103
                        ],
                        [
                            16.46292,
                            46.52064
                        ],
                        [
                            16.51161,
                            46.47962
                        ],
                        [
                            16.59681,
                            46.4759
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "SLB",
                "Country": "Solomon Islands",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    9.4838e-08,
                    1.9345e-07,
                    1.3719e-07,
                    2.4689e-07,
                    2.8792e-07,
                    3.3663e-07,
                    4.0426e-07,
                    4.3447e-07,
                    5.3636e-07,
                    4.7862e-07,
                    6.1196e-07,
                    6.2528e-07,
                    7.27e-07,
                    6.8243e-07,
                    7.6486e-07,
                    8.1665e-07,
                    9.2247e-07,
                    1.0347e-06,
                    1.06e-06,
                    1.2441e-06,
                    1.4291e-06,
                    1.517e-06,
                    1.5857e-06,
                    1.6343e-06,
                    1.7182e-06,
                    1.8088e-06,
                    1.9584e-06,
                    2.1453e-06,
                    2.303e-06,
                    2.5333e-06,
                    2.6542e-06,
                    2.7362e-06,
                    2.8843e-06,
                    3.0766e-06,
                    3.2924e-06,
                    3.4378e-06,
                    3.5249e-06,
                    3.6194e-06,
                    3.6497e-06,
                    3.7201e-06,
                    3.7884e-06,
                    3.8845e-06,
                    3.9895e-06,
                    4.1376e-06,
                    4.3012e-06,
                    4.431e-06,
                    4.675e-06,
                    4.7231e-06,
                    4.7913e-06,
                    4.971e-06,
                    5.0677e-06,
                    5.1499e-06,
                    5.2126e-06,
                    5.248e-06,
                    5.2702e-06,
                    5.2995e-06,
                    5.3824e-06,
                    5.4107e-06,
                    5.5018e-06,
                    5.6293e-06,
                    5.7993e-06,
                    5.9099e-06,
                    6.0199e-06,
                    6.1294e-06,
                    6.3002e-06,
                    6.4173e-06,
                    6.4688e-06,
                    6.5969e-06,
                    6.7506e-06,
                    6.8814e-06,
                    7.0194e-06,
                    7.154e-06,
                    7.2692e-06,
                    7.4089e-06,
                    7.5793e-06,
                    7.7417e-06,
                    7.9651e-06,
                    8.1304e-06,
                    8.283e-06,
                    8.4019e-06,
                    8.5222e-06,
                    8.6929e-06,
                    8.8599e-06,
                    9.0598e-06,
                    9.2567e-06,
                    9.4832e-06,
                    9.6025e-06,
                    9.6828e-06,
                    9.8207e-06,
                    9.9447e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    1.481e-09,
                    3.088e-09,
                    4.8257e-09,
                    6.6991e-09,
                    8.7133e-09,
                    1.0874e-08,
                    1.3185e-08,
                    1.5654e-08,
                    1.8286e-08,
                    2.1087e-08,
                    2.401e-08,
                    2.7061e-08,
                    3.0245e-08,
                    3.3564e-08,
                    3.7026e-08,
                    4.0635e-08,
                    4.4396e-08,
                    4.8315e-08,
                    5.2398e-08,
                    5.665e-08,
                    6.0964e-08,
                    6.534e-08,
                    6.9783e-08,
                    7.4294e-08,
                    7.8875e-08,
                    8.3528e-08,
                    8.8254e-08,
                    9.3055e-08,
                    9.7931e-08,
                    1.0288e-07,
                    1.0756e-07,
                    1.1245e-07,
                    1.1757e-07,
                    1.2293e-07,
                    1.2853e-07,
                    1.344e-07,
                    1.4053e-07,
                    1.4695e-07,
                    1.5367e-07,
                    1.6071e-07,
                    1.6758e-07,
                    1.7429e-07,
                    1.8083e-07,
                    1.8719e-07,
                    1.9338e-07,
                    1.9943e-07,
                    2.0534e-07,
                    2.1111e-07,
                    2.1673e-07,
                    2.222e-07,
                    2.2781e-07,
                    2.3339e-07,
                    2.3892e-07,
                    2.4438e-07,
                    2.4976e-07,
                    2.5504e-07,
                    2.6022e-07,
                    2.6527e-07,
                    2.7017e-07,
                    2.7492e-07,
                    2.798e-07,
                    2.8483e-07,
                    2.9e-07,
                    2.9532e-07,
                    3.0078e-07,
                    3.0634e-07,
                    3.1201e-07,
                    3.1777e-07,
                    3.2365e-07,
                    3.2962e-07,
                    3.3574e-07,
                    3.4156e-07,
                    3.4717e-07,
                    3.5258e-07,
                    3.578e-07,
                    3.6258e-07,
                    3.6718e-07,
                    3.7159e-07,
                    3.7558e-07,
                    3.7939e-07,
                    3.8337e-07,
                    3.8714e-07,
                    3.9079e-07,
                    3.9431e-07,
                    3.9771e-07,
                    4.0099e-07,
                    4.0417e-07,
                    4.0723e-07,
                    4.1017e-07,
                    4.1301e-07,
                    4.1573e-07,
                    4.1848e-07,
                    4.212e-07,
                    4.2388e-07,
                    4.261e-07,
                    4.283e-07,
                    4.2956e-07,
                    4.2997e-07,
                    4.2979e-07,
                    4.2903e-07,
                    4.2849e-07,
                    4.3022e-07,
                    4.3243e-07,
                    4.3513e-07,
                    4.4173e-07,
                    4.4884e-07,
                    4.5649e-07,
                    4.647e-07,
                    4.7349e-07,
                    4.8287e-07,
                    4.9457e-07,
                    5.0698e-07,
                    5.2015e-07,
                    5.3579e-07,
                    5.5604e-07,
                    5.7737e-07,
                    6.0381e-07,
                    6.3369e-07,
                    6.6534e-07,
                    7.0353e-07,
                    7.4802e-07,
                    7.9728e-07,
                    8.5294e-07,
                    9.1032e-07,
                    9.6577e-07,
                    1.025e-06,
                    1.095e-06,
                    1.1593e-06,
                    1.2477e-06,
                    1.3358e-06,
                    1.4425e-06,
                    1.546e-06,
                    1.6629e-06,
                    1.7831e-06,
                    1.9104e-06,
                    2.0424e-06,
                    2.1814e-06,
                    2.3225e-06,
                    2.4681e-06,
                    2.6075e-06,
                    2.753e-06,
                    2.9042e-06,
                    3.0637e-06,
                    3.2319e-06,
                    3.4162e-06,
                    3.6099e-06,
                    3.8083e-06,
                    4.0139e-06,
                    4.2209e-06,
                    4.429e-06,
                    4.6416e-06,
                    4.8604e-06,
                    5.0879e-06,
                    5.3281e-06,
                    5.5753e-06,
                    5.8323e-06,
                    6.0982e-06,
                    6.374e-06,
                    6.6573e-06,
                    6.9525e-06,
                    7.2645e-06,
                    7.5849e-06,
                    7.9264e-06,
                    8.2538e-06,
                    8.5627e-06,
                    8.8724e-06,
                    9.19e-06,
                    9.5157e-06,
                    9.8481e-06,
                    0,
                    0,
                    0
                ],
                "Land_3GHG": 0.01,
                "Land_3GHG_timeseries": [
                    9.3357e-08,
                    1.9037e-07,
                    1.3237e-07,
                    2.4019e-07,
                    2.7921e-07,
                    3.2575e-07,
                    3.9108e-07,
                    4.1882e-07,
                    5.1807e-07,
                    4.5753e-07,
                    5.8795e-07,
                    5.9822e-07,
                    6.9675e-07,
                    6.4887e-07,
                    7.2783e-07,
                    7.7601e-07,
                    8.7807e-07,
                    9.8639e-07,
                    1.0076e-06,
                    1.1874e-06,
                    1.3682e-06,
                    1.4517e-06,
                    1.516e-06,
                    1.56e-06,
                    1.6394e-06,
                    1.7253e-06,
                    1.8701e-06,
                    2.0522e-06,
                    2.2051e-06,
                    2.4304e-06,
                    2.5466e-06,
                    2.6237e-06,
                    2.7667e-06,
                    2.9537e-06,
                    3.1639e-06,
                    3.3034e-06,
                    3.3844e-06,
                    3.4725e-06,
                    3.4961e-06,
                    3.5594e-06,
                    3.6208e-06,
                    3.7102e-06,
                    3.8087e-06,
                    3.9504e-06,
                    4.1078e-06,
                    4.2315e-06,
                    4.4696e-06,
                    4.512e-06,
                    4.5746e-06,
                    4.7488e-06,
                    4.8399e-06,
                    4.9165e-06,
                    4.9737e-06,
                    5.0036e-06,
                    5.0205e-06,
                    5.0445e-06,
                    5.1221e-06,
                    5.1454e-06,
                    5.2316e-06,
                    5.3544e-06,
                    5.5195e-06,
                    5.6251e-06,
                    5.7299e-06,
                    5.8341e-06,
                    5.9995e-06,
                    6.111e-06,
                    6.1568e-06,
                    6.2791e-06,
                    6.427e-06,
                    6.5517e-06,
                    6.6836e-06,
                    6.8124e-06,
                    6.9221e-06,
                    7.0563e-06,
                    7.2215e-06,
                    7.3791e-06,
                    7.5979e-06,
                    7.7588e-06,
                    7.9074e-06,
                    8.0225e-06,
                    8.1389e-06,
                    8.3057e-06,
                    8.4691e-06,
                    8.6655e-06,
                    8.859e-06,
                    9.0823e-06,
                    9.1983e-06,
                    9.2755e-06,
                    9.4105e-06,
                    9.5317e-06,
                    9.6522e-06,
                    9.732e-06,
                    9.8721e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_CO2": 0.01,
                "Total_CO2_timeseries": [
                    8.8908e-08,
                    1.8144e-07,
                    1.1894e-07,
                    2.2223e-07,
                    2.5669e-07,
                    2.9865e-07,
                    3.5936e-07,
                    3.8247e-07,
                    4.7706e-07,
                    4.1184e-07,
                    5.3761e-07,
                    5.4326e-07,
                    6.3721e-07,
                    5.8478e-07,
                    6.5924e-07,
                    7.0294e-07,
                    8.0055e-07,
                    9.0446e-07,
                    9.2126e-07,
                    1.0968e-06,
                    1.2732e-06,
                    1.3525e-06,
                    1.4125e-06,
                    1.4523e-06,
                    1.5274e-06,
                    1.6092e-06,
                    1.7499e-06,
                    1.9278e-06,
                    2.0766e-06,
                    2.2978e-06,
                    2.4099e-06,
                    2.4829e-06,
                    2.6218e-06,
                    2.8046e-06,
                    3.0106e-06,
                    3.1459e-06,
                    3.2227e-06,
                    3.3066e-06,
                    3.326e-06,
                    3.3851e-06,
                    3.4422e-06,
                    3.5273e-06,
                    3.6215e-06,
                    3.7589e-06,
                    3.9121e-06,
                    4.0315e-06,
                    4.2653e-06,
                    4.3034e-06,
                    4.3617e-06,
                    4.5316e-06,
                    4.6183e-06,
                    4.6905e-06,
                    4.7434e-06,
                    4.7688e-06,
                    4.7813e-06,
                    4.8008e-06,
                    4.874e-06,
                    4.8927e-06,
                    4.9743e-06,
                    5.0925e-06,
                    5.2528e-06,
                    5.3532e-06,
                    5.4526e-06,
                    5.5511e-06,
                    5.7106e-06,
                    5.8158e-06,
                    5.8551e-06,
                    5.9707e-06,
                    6.1115e-06,
                    6.2289e-06,
                    6.3532e-06,
                    6.474e-06,
                    6.5754e-06,
                    6.701e-06,
                    6.8574e-06,
                    7.0057e-06,
                    7.2149e-06,
                    7.366e-06,
                    7.5045e-06,
                    7.609e-06,
                    7.7149e-06,
                    7.871e-06,
                    8.0236e-06,
                    8.2091e-06,
                    8.3916e-06,
                    8.6049e-06,
                    8.7122e-06,
                    8.7818e-06,
                    8.9103e-06,
                    9.0263e-06,
                    9.1427e-06,
                    9.2198e-06,
                    9.3583e-06,
                    9.5058e-06,
                    9.6293e-06,
                    9.7782e-06,
                    9.9909e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.65e-09,
                    3.3e-09,
                    4.95e-09,
                    9.9e-09,
                    1.485e-08,
                    1.98e-08,
                    2.475e-08,
                    2.97e-08,
                    3.465e-08,
                    4.125e-08,
                    4.785e-08,
                    5.445e-08,
                    6.27e-08,
                    7.425e-08,
                    8.58e-08,
                    1.0065e-07,
                    1.1715e-07,
                    1.3365e-07,
                    1.518e-07,
                    1.7325e-07,
                    1.98e-07,
                    2.277e-07,
                    2.574e-07,
                    2.838e-07,
                    3.1185e-07,
                    3.4815e-07,
                    3.762e-07,
                    4.257e-07,
                    4.719e-07,
                    5.3295e-07,
                    5.874e-07,
                    6.5175e-07,
                    7.161e-07,
                    7.8375e-07,
                    8.5305e-07,
                    9.2565e-07,
                    9.966e-07,
                    1.0692e-06,
                    1.1352e-06,
                    1.2062e-06,
                    1.2788e-06,
                    1.3563e-06,
                    1.4388e-06,
                    1.5246e-06,
                    1.6137e-06,
                    1.7061e-06,
                    1.8035e-06,
                    1.9008e-06,
                    2.0015e-06,
                    2.1071e-06,
                    2.2176e-06,
                    2.3331e-06,
                    2.4569e-06,
                    2.5839e-06,
                    2.7142e-06,
                    2.8496e-06,
                    2.9881e-06,
                    3.1317e-06,
                    3.2802e-06,
                    3.4353e-06,
                    3.5921e-06,
                    3.7603e-06,
                    3.9088e-06,
                    4.0408e-06,
                    4.1712e-06,
                    4.2999e-06,
                    4.4302e-06,
                    4.5623e-06,
                    4.6926e-06,
                    4.8286e-06,
                    4.9631e-06
                ],
                "Land_CO2": 0.02,
                "Land_CO2_timeseries": [
                    8.8908e-08,
                    1.8144e-07,
                    1.1894e-07,
                    2.2223e-07,
                    2.5669e-07,
                    2.9865e-07,
                    3.5936e-07,
                    3.8247e-07,
                    4.7706e-07,
                    4.1184e-07,
                    5.3761e-07,
                    5.4326e-07,
                    6.3721e-07,
                    5.8478e-07,
                    6.5924e-07,
                    7.0294e-07,
                    8.0055e-07,
                    9.0446e-07,
                    9.2126e-07,
                    1.0968e-06,
                    1.2732e-06,
                    1.3525e-06,
                    1.4125e-06,
                    1.4523e-06,
                    1.5274e-06,
                    1.6092e-06,
                    1.7499e-06,
                    1.9278e-06,
                    2.0766e-06,
                    2.2978e-06,
                    2.4099e-06,
                    2.4829e-06,
                    2.6218e-06,
                    2.8046e-06,
                    3.0106e-06,
                    3.1459e-06,
                    3.2227e-06,
                    3.3066e-06,
                    3.326e-06,
                    3.3851e-06,
                    3.4422e-06,
                    3.5273e-06,
                    3.6215e-06,
                    3.7589e-06,
                    3.9121e-06,
                    4.0315e-06,
                    4.2653e-06,
                    4.3034e-06,
                    4.3617e-06,
                    4.5316e-06,
                    4.6183e-06,
                    4.6905e-06,
                    4.7434e-06,
                    4.7688e-06,
                    4.7813e-06,
                    4.8008e-06,
                    4.874e-06,
                    4.8927e-06,
                    4.9743e-06,
                    5.0925e-06,
                    5.2528e-06,
                    5.3532e-06,
                    5.4526e-06,
                    5.5511e-06,
                    5.7106e-06,
                    5.8158e-06,
                    5.8551e-06,
                    5.9707e-06,
                    6.1115e-06,
                    6.2289e-06,
                    6.3532e-06,
                    6.474e-06,
                    6.5754e-06,
                    6.701e-06,
                    6.8574e-06,
                    7.0057e-06,
                    7.2149e-06,
                    7.366e-06,
                    7.5045e-06,
                    7.609e-06,
                    7.7149e-06,
                    7.871e-06,
                    8.0236e-06,
                    8.2091e-06,
                    8.3916e-06,
                    8.6049e-06,
                    8.7122e-06,
                    8.7818e-06,
                    8.9103e-06,
                    9.0263e-06,
                    9.1427e-06,
                    9.2198e-06,
                    9.3583e-06,
                    9.5058e-06,
                    9.6293e-06,
                    9.7782e-06,
                    9.9909e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [
                    5.5975e-09,
                    1.1342e-08,
                    1.724e-08,
                    2.3294e-08,
                    2.9511e-08,
                    3.5896e-08,
                    4.2454e-08,
                    4.9192e-08,
                    5.6115e-08,
                    6.3229e-08,
                    7.043e-08,
                    7.7724e-08,
                    8.5114e-08,
                    9.2605e-08,
                    1.002e-07,
                    1.0791e-07,
                    1.1574e-07,
                    1.2369e-07,
                    1.3176e-07,
                    1.3997e-07,
                    1.4821e-07,
                    1.5646e-07,
                    1.6473e-07,
                    1.7303e-07,
                    1.8135e-07,
                    1.897e-07,
                    1.9808e-07,
                    2.0649e-07,
                    2.1493e-07,
                    2.2341e-07,
                    2.3162e-07,
                    2.4005e-07,
                    2.4873e-07,
                    2.5765e-07,
                    2.6683e-07,
                    2.7629e-07,
                    2.8603e-07,
                    2.9606e-07,
                    3.064e-07,
                    3.1707e-07,
                    3.2759e-07,
                    3.3795e-07,
                    3.4815e-07,
                    3.5819e-07,
                    3.6806e-07,
                    3.778e-07,
                    3.8742e-07,
                    3.9691e-07,
                    4.0625e-07,
                    4.1545e-07,
                    4.2481e-07,
                    4.3415e-07,
                    4.4343e-07,
                    4.5266e-07,
                    4.6182e-07,
                    4.709e-07,
                    4.7987e-07,
                    4.8873e-07,
                    4.9745e-07,
                    5.0601e-07,
                    5.1499e-07,
                    5.2437e-07,
                    5.3417e-07,
                    5.4437e-07,
                    5.5499e-07,
                    5.6597e-07,
                    5.7732e-07,
                    5.8904e-07,
                    6.0113e-07,
                    6.136e-07,
                    6.2651e-07,
                    6.3942e-07,
                    6.5244e-07,
                    6.6556e-07,
                    6.788e-07,
                    6.919e-07,
                    7.0513e-07,
                    7.1847e-07,
                    7.317e-07,
                    7.4506e-07,
                    7.5869e-07,
                    7.7221e-07,
                    7.8572e-07,
                    7.992e-07,
                    8.1266e-07,
                    8.2489e-07,
                    8.3586e-07,
                    8.4556e-07,
                    8.5396e-07,
                    8.6104e-07,
                    8.6675e-07,
                    8.7123e-07,
                    8.7436e-07,
                    8.7612e-07,
                    8.7605e-07,
                    8.7455e-07,
                    8.707e-07,
                    8.6454e-07,
                    8.5632e-07,
                    8.4601e-07,
                    8.3472e-07,
                    8.2285e-07,
                    8.1027e-07,
                    7.9694e-07,
                    7.8293e-07,
                    7.6923e-07,
                    7.5584e-07,
                    7.4271e-07,
                    7.2981e-07,
                    7.171e-07,
                    7.2172e-07,
                    7.2877e-07,
                    7.4161e-07,
                    7.5714e-07,
                    7.8117e-07,
                    8.0817e-07,
                    8.4329e-07,
                    8.9652e-07,
                    9.6117e-07,
                    1.0329e-06,
                    1.1214e-06,
                    1.2115e-06,
                    1.3104e-06,
                    1.4268e-06,
                    1.554e-06,
                    1.6993e-06,
                    1.8603e-06,
                    2.0365e-06,
                    2.2126e-06,
                    2.4063e-06,
                    2.5926e-06,
                    2.7722e-06,
                    2.9413e-06,
                    3.1104e-06,
                    3.2745e-06,
                    3.4338e-06,
                    3.5412e-06,
                    3.6352e-06,
                    3.7241e-06,
                    3.8165e-06,
                    3.9013e-06,
                    3.9912e-06,
                    4.0791e-06,
                    4.1549e-06,
                    4.2352e-06,
                    4.3066e-06,
                    4.3667e-06,
                    4.4151e-06,
                    4.4724e-06,
                    4.5181e-06,
                    4.5541e-06,
                    4.6002e-06,
                    4.6615e-06,
                    4.7337e-06,
                    4.8152e-06,
                    4.9108e-06,
                    5.0586e-06,
                    5.2178e-06,
                    5.38e-06,
                    5.5455e-06,
                    5.7172e-06,
                    5.8967e-06,
                    6.0866e-06,
                    6.2854e-06,
                    6.4827e-06,
                    6.6825e-06,
                    6.8926e-06,
                    7.1114e-06,
                    7.332e-06,
                    7.5593e-06,
                    7.7997e-06,
                    8.0469e-06
                ],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [
                    1.3358e-09,
                    2.7955e-09,
                    4.3839e-09,
                    6.106e-09,
                    7.9672e-09,
                    9.9727e-09,
                    1.2128e-08,
                    1.4439e-08,
                    1.6912e-08,
                    1.9553e-08,
                    2.2315e-08,
                    2.5204e-08,
                    2.8224e-08,
                    3.138e-08,
                    3.4678e-08,
                    3.8121e-08,
                    4.1716e-08,
                    4.5467e-08,
                    4.9381e-08,
                    5.3464e-08,
                    5.7607e-08,
                    6.1808e-08,
                    6.6071e-08,
                    7.0395e-08,
                    7.4784e-08,
                    7.9238e-08,
                    8.3759e-08,
                    8.8348e-08,
                    9.3008e-08,
                    9.774e-08,
                    1.022e-07,
                    1.0687e-07,
                    1.1176e-07,
                    1.1689e-07,
                    1.2226e-07,
                    1.279e-07,
                    1.338e-07,
                    1.3999e-07,
                    1.4648e-07,
                    1.5328e-07,
                    1.5991e-07,
                    1.6637e-07,
                    1.7266e-07,
                    1.7877e-07,
                    1.8471e-07,
                    1.905e-07,
                    1.9616e-07,
                    2.0166e-07,
                    2.0702e-07,
                    2.1221e-07,
                    2.1755e-07,
                    2.2285e-07,
                    2.281e-07,
                    2.3327e-07,
                    2.3836e-07,
                    2.4334e-07,
                    2.4821e-07,
                    2.5295e-07,
                    2.5755e-07,
                    2.6197e-07,
                    2.6654e-07,
                    2.7124e-07,
                    2.7608e-07,
                    2.8106e-07,
                    2.8618e-07,
                    2.914e-07,
                    2.9672e-07,
                    3.0213e-07,
                    3.0765e-07,
                    3.1327e-07,
                    3.1903e-07,
                    3.2448e-07,
                    3.2973e-07,
                    3.3478e-07,
                    3.3962e-07,
                    3.4404e-07,
                    3.4826e-07,
                    3.5229e-07,
                    3.5591e-07,
                    3.5934e-07,
                    3.6293e-07,
                    3.6631e-07,
                    3.6955e-07,
                    3.7267e-07,
                    3.7565e-07,
                    3.785e-07,
                    3.8123e-07,
                    3.8383e-07,
                    3.8631e-07,
                    3.8867e-07,
                    3.9088e-07,
                    3.9312e-07,
                    3.9529e-07,
                    3.9739e-07,
                    3.99e-07,
                    4.0054e-07,
                    4.0113e-07,
                    4.0082e-07,
                    3.999e-07,
                    3.9838e-07,
                    3.9706e-07,
                    3.9634e-07,
                    3.961e-07,
                    3.9633e-07,
                    3.9714e-07,
                    3.9845e-07,
                    4.0029e-07,
                    4.0267e-07,
                    4.0561e-07,
                    4.0912e-07,
                    4.1328e-07,
                    4.1809e-07,
                    4.236e-07,
                    4.2987e-07,
                    4.3736e-07,
                    4.4587e-07,
                    4.5611e-07,
                    4.6807e-07,
                    4.8177e-07,
                    5.0019e-07,
                    5.2156e-07,
                    5.4428e-07,
                    5.6834e-07,
                    5.9399e-07,
                    6.2094e-07,
                    6.4998e-07,
                    6.8127e-07,
                    7.1514e-07,
                    7.5154e-07,
                    7.9079e-07,
                    8.3346e-07,
                    8.7937e-07,
                    9.2863e-07,
                    9.8109e-07,
                    1.0374e-06,
                    1.0965e-06,
                    1.1591e-06,
                    1.225e-06,
                    1.2941e-06,
                    1.3635e-06,
                    1.434e-06,
                    1.5083e-06,
                    1.586e-06,
                    1.6673e-06,
                    1.7609e-06,
                    1.8602e-06,
                    1.9608e-06,
                    2.0633e-06,
                    2.1674e-06,
                    2.2693e-06,
                    2.3705e-06,
                    2.4727e-06,
                    2.5787e-06,
                    2.6889e-06,
                    2.8028e-06,
                    2.923e-06,
                    3.0468e-06,
                    3.1772e-06,
                    3.3102e-06,
                    3.4499e-06,
                    3.5996e-06,
                    3.756e-06,
                    3.9218e-06,
                    4.0933e-06,
                    4.2628e-06,
                    4.435e-06,
                    4.6159e-06,
                    4.8032e-06,
                    4.9957e-06,
                    5.1978e-06,
                    5.4079e-06,
                    5.6251e-06
                ],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [
                    4.2617e-09,
                    8.5469e-09,
                    1.2856e-08,
                    1.7188e-08,
                    2.1544e-08,
                    2.5923e-08,
                    3.0326e-08,
                    3.4753e-08,
                    3.9203e-08,
                    4.3676e-08,
                    4.8115e-08,
                    5.252e-08,
                    5.689e-08,
                    6.1225e-08,
                    6.5525e-08,
                    6.9791e-08,
                    7.4023e-08,
                    7.822e-08,
                    8.2382e-08,
                    8.651e-08,
                    9.0599e-08,
                    9.4649e-08,
                    9.8661e-08,
                    1.0263e-07,
                    1.0657e-07,
                    1.1047e-07,
                    1.1432e-07,
                    1.1814e-07,
                    1.2192e-07,
                    1.2567e-07,
                    1.2942e-07,
                    1.3319e-07,
                    1.3697e-07,
                    1.4076e-07,
                    1.4457e-07,
                    1.4839e-07,
                    1.5222e-07,
                    1.5607e-07,
                    1.5992e-07,
                    1.638e-07,
                    1.6768e-07,
                    1.7158e-07,
                    1.7549e-07,
                    1.7941e-07,
                    1.8335e-07,
                    1.873e-07,
                    1.9127e-07,
                    1.9524e-07,
                    1.9924e-07,
                    2.0324e-07,
                    2.0726e-07,
                    2.1129e-07,
                    2.1534e-07,
                    2.194e-07,
                    2.2347e-07,
                    2.2756e-07,
                    2.3166e-07,
                    2.3577e-07,
                    2.399e-07,
                    2.4404e-07,
                    2.4845e-07,
                    2.5314e-07,
                    2.5809e-07,
                    2.6331e-07,
                    2.6881e-07,
                    2.7457e-07,
                    2.806e-07,
                    2.8691e-07,
                    2.9348e-07,
                    3.0033e-07,
                    3.0748e-07,
                    3.1494e-07,
                    3.2271e-07,
                    3.3079e-07,
                    3.3917e-07,
                    3.4787e-07,
                    3.5687e-07,
                    3.6618e-07,
                    3.758e-07,
                    3.8572e-07,
                    3.9576e-07,
                    4.0591e-07,
                    4.1616e-07,
                    4.2653e-07,
                    4.3701e-07,
                    4.4639e-07,
                    4.5464e-07,
                    4.6173e-07,
                    4.6765e-07,
                    4.7237e-07,
                    4.7587e-07,
                    4.7811e-07,
                    4.7908e-07,
                    4.7873e-07,
                    4.7705e-07,
                    4.7401e-07,
                    4.6957e-07,
                    4.6372e-07,
                    4.5641e-07,
                    4.4763e-07,
                    4.3766e-07,
                    4.2651e-07,
                    4.1417e-07,
                    4.0061e-07,
                    3.8579e-07,
                    3.7078e-07,
                    3.5555e-07,
                    3.4004e-07,
                    3.242e-07,
                    3.0798e-07,
                    3.0844e-07,
                    3.1067e-07,
                    3.1801e-07,
                    3.2727e-07,
                    3.4381e-07,
                    3.623e-07,
                    3.8718e-07,
                    4.2845e-07,
                    4.794e-07,
                    5.3275e-07,
                    5.9981e-07,
                    6.6718e-07,
                    7.4204e-07,
                    8.3285e-07,
                    9.3304e-07,
                    1.0493e-06,
                    1.179e-06,
                    1.3213e-06,
                    1.461e-06,
                    1.6155e-06,
                    1.7591e-06,
                    1.8929e-06,
                    2.0127e-06,
                    2.1293e-06,
                    2.2371e-06,
                    2.3373e-06,
                    2.3821e-06,
                    2.4101e-06,
                    2.43e-06,
                    2.453e-06,
                    2.4672e-06,
                    2.4829e-06,
                    2.4932e-06,
                    2.4876e-06,
                    2.4743e-06,
                    2.4464e-06,
                    2.4059e-06,
                    2.3518e-06,
                    2.3051e-06,
                    2.2489e-06,
                    2.1836e-06,
                    2.1274e-06,
                    2.0828e-06,
                    2.0448e-06,
                    2.0124e-06,
                    1.9878e-06,
                    2.0118e-06,
                    2.0406e-06,
                    2.0698e-06,
                    2.0957e-06,
                    2.1176e-06,
                    2.1407e-06,
                    2.1648e-06,
                    2.1921e-06,
                    2.2199e-06,
                    2.2476e-06,
                    2.2767e-06,
                    2.3082e-06,
                    2.3363e-06,
                    2.3616e-06,
                    2.3918e-06,
                    2.4218e-06
                ],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [
                    3.3315e-10,
                    6.721e-10,
                    1.0166e-09,
                    1.3665e-09,
                    1.7212e-09,
                    2.0804e-09,
                    2.4436e-09,
                    2.81e-09,
                    3.1791e-09,
                    3.5499e-09,
                    3.9221e-09,
                    4.2954e-09,
                    4.6699e-09,
                    5.0453e-09,
                    5.4218e-09,
                    5.7993e-09,
                    6.1779e-09,
                    6.5576e-09,
                    6.9385e-09,
                    7.3207e-09,
                    7.7085e-09,
                    8.1091e-09,
                    8.5279e-09,
                    8.9689e-09,
                    9.4342e-09,
                    9.9243e-09,
                    1.0438e-08,
                    1.0973e-08,
                    1.1524e-08,
                    1.2086e-08,
                    1.2653e-08,
                    1.3227e-08,
                    1.3804e-08,
                    1.4386e-08,
                    1.4972e-08,
                    1.5561e-08,
                    1.6154e-08,
                    1.675e-08,
                    1.7351e-08,
                    1.7999e-08,
                    1.8631e-08,
                    1.9249e-08,
                    1.9857e-08,
                    2.0455e-08,
                    2.1047e-08,
                    2.1635e-08,
                    2.222e-08,
                    2.2805e-08,
                    2.339e-08,
                    2.3979e-08,
                    2.4574e-08,
                    2.5182e-08,
                    2.5807e-08,
                    2.6452e-08,
                    2.712e-08,
                    2.781e-08,
                    2.8522e-08,
                    2.9254e-08,
                    3.0004e-08,
                    3.0766e-08,
                    3.1539e-08,
                    3.232e-08,
                    3.3109e-08,
                    3.3907e-08,
                    3.4712e-08,
                    3.5523e-08,
                    3.6342e-08,
                    3.7168e-08,
                    3.8002e-08,
                    3.8843e-08,
                    3.9692e-08,
                    4.0551e-08,
                    4.142e-08,
                    4.2299e-08,
                    4.3188e-08,
                    4.4086e-08,
                    4.4994e-08,
                    4.5909e-08,
                    4.683e-08,
                    4.7755e-08,
                    4.8683e-08,
                    4.9616e-08,
                    5.0555e-08,
                    5.1502e-08,
                    5.2457e-08,
                    5.3421e-08,
                    5.4396e-08,
                    5.5381e-08,
                    5.6378e-08,
                    5.7386e-08,
                    5.8419e-08,
                    5.9497e-08,
                    6.0637e-08,
                    6.1852e-08,
                    6.3147e-08,
                    6.4526e-08,
                    6.5985e-08,
                    6.7517e-08,
                    6.9111e-08,
                    7.0749e-08,
                    7.2422e-08,
                    7.4128e-08,
                    7.5868e-08,
                    7.7642e-08,
                    7.945e-08,
                    8.1295e-08,
                    8.3176e-08,
                    8.5096e-08,
                    8.7056e-08,
                    8.9058e-08,
                    9.2267e-08,
                    9.5561e-08,
                    9.9225e-08,
                    1.03e-07,
                    1.0732e-07,
                    1.1176e-07,
                    1.1668e-07,
                    1.2212e-07,
                    1.2808e-07,
                    1.3451e-07,
                    1.4156e-07,
                    1.4936e-07,
                    1.5776e-07,
                    1.6748e-07,
                    1.7773e-07,
                    1.8859e-07,
                    1.9999e-07,
                    2.1161e-07,
                    2.2268e-07,
                    2.3413e-07,
                    2.4612e-07,
                    2.5823e-07,
                    2.7028e-07,
                    2.8231e-07,
                    2.9439e-07,
                    3.0576e-07,
                    3.1554e-07,
                    3.2544e-07,
                    3.3516e-07,
                    3.4492e-07,
                    3.5479e-07,
                    3.649e-07,
                    3.7514e-07,
                    3.8535e-07,
                    3.9616e-07,
                    4.0729e-07,
                    4.1864e-07,
                    4.3019e-07,
                    4.4167e-07,
                    4.5316e-07,
                    4.6487e-07,
                    4.7675e-07,
                    4.8884e-07,
                    5.012e-07,
                    5.1372e-07,
                    5.2644e-07,
                    5.3973e-07,
                    5.5316e-07,
                    5.6639e-07,
                    5.7994e-07,
                    5.9359e-07,
                    6.0748e-07,
                    6.2161e-07,
                    6.3576e-07,
                    6.5031e-07,
                    6.6433e-07,
                    6.79e-07,
                    6.9733e-07,
                    7.1254e-07,
                    7.276e-07,
                    7.4238e-07,
                    7.5729e-07
                ],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [
                    1.4525e-10,
                    2.9254e-10,
                    4.4183e-10,
                    5.9305e-10,
                    7.4609e-10,
                    9.0085e-10,
                    1.0572e-09,
                    1.215e-09,
                    1.3741e-09,
                    1.5342e-09,
                    1.6953e-09,
                    1.8573e-09,
                    2.0202e-09,
                    2.184e-09,
                    2.3487e-09,
                    2.5143e-09,
                    2.6808e-09,
                    2.8482e-09,
                    3.0165e-09,
                    3.1857e-09,
                    3.357e-09,
                    3.532e-09,
                    3.7121e-09,
                    3.8982e-09,
                    4.0908e-09,
                    4.2901e-09,
                    4.4958e-09,
                    4.7072e-09,
                    4.9232e-09,
                    5.1424e-09,
                    5.3637e-09,
                    5.587e-09,
                    5.812e-09,
                    6.0386e-09,
                    6.2668e-09,
                    6.4965e-09,
                    6.7277e-09,
                    6.9605e-09,
                    7.1949e-09,
                    7.4342e-09,
                    7.6761e-09,
                    7.9205e-09,
                    8.1678e-09,
                    8.4179e-09,
                    8.6709e-09,
                    8.927e-09,
                    9.1863e-09,
                    9.4489e-09,
                    9.7149e-09,
                    9.9846e-09,
                    1.0258e-08,
                    1.0536e-08,
                    1.0819e-08,
                    1.1107e-08,
                    1.1401e-08,
                    1.17e-08,
                    1.2004e-08,
                    1.2313e-08,
                    1.2627e-08,
                    1.2946e-08,
                    1.3268e-08,
                    1.3595e-08,
                    1.3926e-08,
                    1.4261e-08,
                    1.46e-08,
                    1.4943e-08,
                    1.529e-08,
                    1.564e-08,
                    1.5994e-08,
                    1.635e-08,
                    1.671e-08,
                    1.7072e-08,
                    1.7437e-08,
                    1.7804e-08,
                    1.8174e-08,
                    1.8546e-08,
                    1.892e-08,
                    1.9296e-08,
                    1.9675e-08,
                    2.0057e-08,
                    2.0442e-08,
                    2.0834e-08,
                    2.1233e-08,
                    2.1643e-08,
                    2.2063e-08,
                    2.2495e-08,
                    2.2939e-08,
                    2.3396e-08,
                    2.3865e-08,
                    2.4347e-08,
                    2.4845e-08,
                    2.5365e-08,
                    2.5913e-08,
                    2.6493e-08,
                    2.7106e-08,
                    2.7754e-08,
                    2.8436e-08,
                    2.9148e-08,
                    2.9888e-08,
                    3.0649e-08,
                    3.1427e-08,
                    3.2221e-08,
                    3.303e-08,
                    3.3852e-08,
                    3.4688e-08,
                    3.5538e-08,
                    3.6401e-08,
                    3.7281e-08,
                    3.8177e-08,
                    3.9093e-08,
                    4.0039e-08,
                    4.1035e-08,
                    4.2092e-08,
                    4.322e-08,
                    4.4424e-08,
                    4.5703e-08,
                    4.7054e-08,
                    4.8465e-08,
                    4.9925e-08,
                    5.1549e-08,
                    5.3216e-08,
                    5.5002e-08,
                    5.6906e-08,
                    5.893e-08,
                    6.1032e-08,
                    6.3197e-08,
                    6.5593e-08,
                    6.7993e-08,
                    7.0494e-08,
                    7.3116e-08,
                    7.6133e-08,
                    7.9249e-08,
                    8.2539e-08,
                    8.59e-08,
                    8.9325e-08,
                    9.2842e-08,
                    9.6667e-08,
                    1.0084e-07,
                    1.0483e-07,
                    1.0881e-07,
                    1.1285e-07,
                    1.1708e-07,
                    1.214e-07,
                    1.2574e-07,
                    1.3067e-07,
                    1.3592e-07,
                    1.4139e-07,
                    1.4708e-07,
                    1.5271e-07,
                    1.583e-07,
                    1.6407e-07,
                    1.7e-07,
                    1.7611e-07,
                    1.8232e-07,
                    1.8864e-07,
                    1.9502e-07,
                    2.0181e-07,
                    2.0869e-07,
                    2.1536e-07,
                    2.2238e-07,
                    2.2953e-07,
                    2.368e-07,
                    2.4425e-07,
                    2.5167e-07,
                    2.5899e-07,
                    2.6626e-07,
                    2.7419e-07,
                    2.8221e-07,
                    2.9017e-07,
                    2.9791e-07,
                    3.0581e-07,
                    3.1381e-07
                ],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": [
                    1.879e-10,
                    3.7955e-10,
                    5.7481e-10,
                    7.7343e-10,
                    9.7514e-10,
                    1.1796e-09,
                    1.3864e-09,
                    1.595e-09,
                    1.805e-09,
                    2.0157e-09,
                    2.2268e-09,
                    2.4381e-09,
                    2.6496e-09,
                    2.8613e-09,
                    3.0731e-09,
                    3.285e-09,
                    3.4971e-09,
                    3.7094e-09,
                    3.922e-09,
                    4.135e-09,
                    4.3515e-09,
                    4.5771e-09,
                    4.8158e-09,
                    5.0707e-09,
                    5.3434e-09,
                    5.6342e-09,
                    5.9424e-09,
                    6.2658e-09,
                    6.601e-09,
                    6.9433e-09,
                    7.2898e-09,
                    7.6396e-09,
                    7.9923e-09,
                    8.3475e-09,
                    8.7049e-09,
                    9.0644e-09,
                    9.426e-09,
                    9.7898e-09,
                    1.0156e-08,
                    1.0565e-08,
                    1.0955e-08,
                    1.1329e-08,
                    1.1689e-08,
                    1.2038e-08,
                    1.2377e-08,
                    1.2708e-08,
                    1.3034e-08,
                    1.3356e-08,
                    1.3675e-08,
                    1.3994e-08,
                    1.4316e-08,
                    1.4646e-08,
                    1.4988e-08,
                    1.5345e-08,
                    1.5719e-08,
                    1.611e-08,
                    1.6518e-08,
                    1.6941e-08,
                    1.7377e-08,
                    1.7821e-08,
                    1.827e-08,
                    1.8725e-08,
                    1.9183e-08,
                    1.9646e-08,
                    2.0111e-08,
                    2.058e-08,
                    2.1053e-08,
                    2.1528e-08,
                    2.2008e-08,
                    2.2492e-08,
                    2.2982e-08,
                    2.3478e-08,
                    2.3982e-08,
                    2.4494e-08,
                    2.5014e-08,
                    2.5541e-08,
                    2.6074e-08,
                    2.6613e-08,
                    2.7155e-08,
                    2.7698e-08,
                    2.8241e-08,
                    2.8782e-08,
                    2.9322e-08,
                    2.9859e-08,
                    3.0394e-08,
                    3.0927e-08,
                    3.1457e-08,
                    3.1985e-08,
                    3.2512e-08,
                    3.3039e-08,
                    3.3574e-08,
                    3.4132e-08,
                    3.4724e-08,
                    3.5359e-08,
                    3.6041e-08,
                    3.6771e-08,
                    3.7549e-08,
                    3.8369e-08,
                    3.9224e-08,
                    4.0101e-08,
                    4.0995e-08,
                    4.1907e-08,
                    4.2838e-08,
                    4.379e-08,
                    4.4762e-08,
                    4.5757e-08,
                    4.6775e-08,
                    4.7815e-08,
                    4.8878e-08,
                    4.9965e-08,
                    5.2227e-08,
                    5.4526e-08,
                    5.7133e-08,
                    5.9776e-08,
                    6.2899e-08,
                    6.6058e-08,
                    6.9623e-08,
                    7.3656e-08,
                    7.8155e-08,
                    8.2962e-08,
                    8.8347e-08,
                    9.4359e-08,
                    1.0085e-07,
                    1.0855e-07,
                    1.167e-07,
                    1.2539e-07,
                    1.344e-07,
                    1.4362e-07,
                    1.5219e-07,
                    1.6102e-07,
                    1.6999e-07,
                    1.7898e-07,
                    1.8774e-07,
                    1.9641e-07,
                    2.0507e-07,
                    2.1292e-07,
                    2.1887e-07,
                    2.246e-07,
                    2.3033e-07,
                    2.3611e-07,
                    2.4195e-07,
                    2.4782e-07,
                    2.5374e-07,
                    2.5961e-07,
                    2.6549e-07,
                    2.7137e-07,
                    2.7726e-07,
                    2.8311e-07,
                    2.8896e-07,
                    2.9486e-07,
                    3.008e-07,
                    3.0675e-07,
                    3.1272e-07,
                    3.1888e-07,
                    3.2508e-07,
                    3.3142e-07,
                    3.3793e-07,
                    3.4447e-07,
                    3.5103e-07,
                    3.5756e-07,
                    3.6406e-07,
                    3.7068e-07,
                    3.7737e-07,
                    3.8409e-07,
                    3.9132e-07,
                    3.9807e-07,
                    4.0482e-07,
                    4.1512e-07,
                    4.2237e-07,
                    4.2969e-07,
                    4.3657e-07,
                    4.4348e-07
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                160.70894,
                                -9.90753
                            ],
                            [
                                160.79934,
                                -9.88255
                            ],
                            [
                                160.82916,
                                -9.79853
                            ],
                            [
                                160.71129,
                                -9.70664
                            ],
                            [
                                160.66299,
                                -9.70034
                            ],
                            [
                                160.65929,
                                -9.63903
                            ],
                            [
                                160.57766,
                                -9.54945
                            ],
                            [
                                160.49285,
                                -9.53405
                            ],
                            [
                                160.45234,
                                -9.4764
                            ],
                            [
                                160.35261,
                                -9.4113
                            ],
                            [
                                160.21569,
                                -9.42557
                            ],
                            [
                                160.15655,
                                -9.40569
                            ],
                            [
                                160.11618,
                                -9.42836
                            ],
                            [
                                160.02864,
                                -9.40638
                            ],
                            [
                                159.97315,
                                -9.43379
                            ],
                            [
                                159.90692,
                                -9.42429
                            ],
                            [
                                159.7845,
                                -9.29774
                            ],
                            [
                                159.68399,
                                -9.25194
                            ],
                            [
                                159.59704,
                                -9.3066
                            ],
                            [
                                159.58572,
                                -9.36593
                            ],
                            [
                                159.61024,
                                -9.49506
                            ],
                            [
                                159.71514,
                                -9.69369
                            ],
                            [
                                159.79016,
                                -9.77663
                            ],
                            [
                                159.83834,
                                -9.8004
                            ],
                            [
                                159.92401,
                                -9.79931
                            ],
                            [
                                160.06646,
                                -9.82686
                            ],
                            [
                                160.26469,
                                -9.80917
                            ],
                            [
                                160.36481,
                                -9.8316
                            ],
                            [
                                160.42546,
                                -9.89402
                            ],
                            [
                                160.47512,
                                -9.88884
                            ],
                            [
                                160.62779,
                                -9.94486
                            ],
                            [
                                160.70894,
                                -9.90753
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                160.70894,
                                -8.7965
                            ],
                            [
                                160.74764,
                                -8.86022
                            ],
                            [
                                160.75856,
                                -8.95333
                            ],
                            [
                                160.80455,
                                -9.06971
                            ],
                            [
                                160.88559,
                                -9.16926
                            ],
                            [
                                160.93506,
                                -9.18123
                            ],
                            [
                                161.02676,
                                -9.29696
                            ],
                            [
                                161.08336,
                                -9.30983
                            ],
                            [
                                161.2011,
                                -9.39145
                            ],
                            [
                                161.30327,
                                -9.53927
                            ],
                            [
                                161.38173,
                                -9.59231
                            ],
                            [
                                161.44481,
                                -9.67204
                            ],
                            [
                                161.48233,
                                -9.63263
                            ],
                            [
                                161.53004,
                                -9.70014
                            ],
                            [
                                161.57926,
                                -9.69785
                            ],
                            [
                                161.55659,
                                -9.57526
                            ],
                            [
                                161.39279,
                                -9.36268
                            ],
                            [
                                161.36546,
                                -9.4784
                            ],
                            [
                                161.26201,
                                -9.29668
                            ],
                            [
                                161.24446,
                                -9.16613
                            ],
                            [
                                161.20195,
                                -9.14116
                            ],
                            [
                                161.18796,
                                -9.05865
                            ],
                            [
                                161.15034,
                                -8.96827
                            ],
                            [
                                161.09908,
                                -8.91066
                            ],
                            [
                                160.94413,
                                -8.8213
                            ],
                            [
                                160.94946,
                                -8.70452
                            ],
                            [
                                161.00156,
                                -8.65284
                            ],
                            [
                                160.89608,
                                -8.50016
                            ],
                            [
                                160.84774,
                                -8.4635
                            ],
                            [
                                160.81286,
                                -8.39159
                            ],
                            [
                                160.73597,
                                -8.32036
                            ],
                            [
                                160.70894,
                                -8.3735
                            ],
                            [
                                160.59832,
                                -8.32998
                            ],
                            [
                                160.5907,
                                -8.41033
                            ],
                            [
                                160.63784,
                                -8.44013
                            ],
                            [
                                160.72394,
                                -8.55674
                            ],
                            [
                                160.65474,
                                -8.60946
                            ],
                            [
                                160.68329,
                                -8.68895
                            ],
                            [
                                160.67315,
                                -8.751
                            ],
                            [
                                160.70894,
                                -8.7965
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                159.35837,
                                -7.99828
                            ],
                            [
                                159.29468,
                                -7.99317
                            ],
                            [
                                159.25429,
                                -7.95935
                            ],
                            [
                                159.10545,
                                -7.91865
                            ],
                            [
                                159.03579,
                                -7.84133
                            ],
                            [
                                159.00163,
                                -7.8439
                            ],
                            [
                                158.92263,
                                -7.74305
                            ],
                            [
                                158.87136,
                                -7.73658
                            ],
                            [
                                158.73235,
                                -7.58393
                            ],
                            [
                                158.68133,
                                -7.59545
                            ],
                            [
                                158.60747,
                                -7.55399
                            ],
                            [
                                158.57894,
                                -7.58341
                            ],
                            [
                                158.47317,
                                -7.54273
                            ],
                            [
                                158.41636,
                                -7.58697
                            ],
                            [
                                158.36506,
                                -7.55703
                            ],
                            [
                                158.3257,
                                -7.59093
                            ],
                            [
                                158.56277,
                                -7.67258
                            ],
                            [
                                158.5884,
                                -7.74536
                            ],
                            [
                                158.68056,
                                -7.79588
                            ],
                            [
                                158.82304,
                                -7.9413
                            ],
                            [
                                158.89747,
                                -7.98066
                            ],
                            [
                                159.01973,
                                -8.07569
                            ],
                            [
                                159.17494,
                                -8.15304
                            ],
                            [
                                159.39206,
                                -8.28593
                            ],
                            [
                                159.44704,
                                -8.30094
                            ],
                            [
                                159.56297,
                                -8.3793
                            ],
                            [
                                159.62282,
                                -8.37136
                            ],
                            [
                                159.70577,
                                -8.45392
                            ],
                            [
                                159.78252,
                                -8.49741
                            ],
                            [
                                159.86566,
                                -8.57412
                            ],
                            [
                                159.86873,
                                -8.49233
                            ],
                            [
                                159.81358,
                                -8.43393
                            ],
                            [
                                159.85008,
                                -8.34156
                            ],
                            [
                                159.7538,
                                -8.27167
                            ],
                            [
                                159.62683,
                                -8.15844
                            ],
                            [
                                159.55339,
                                -8.12384
                            ],
                            [
                                159.51594,
                                -8.07912
                            ],
                            [
                                159.35837,
                                -7.99828
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                157.2867,
                                -7.21429
                            ],
                            [
                                157.17613,
                                -7.15715
                            ],
                            [
                                157.13464,
                                -7.11273
                            ],
                            [
                                157.10469,
                                -6.97217
                            ],
                            [
                                156.95907,
                                -6.86127
                            ],
                            [
                                156.86621,
                                -6.82794
                            ],
                            [
                                156.82985,
                                -6.79279
                            ],
                            [
                                156.67907,
                                -6.73735
                            ],
                            [
                                156.63162,
                                -6.66013
                            ],
                            [
                                156.54921,
                                -6.63794
                            ],
                            [
                                156.50108,
                                -6.59401
                            ],
                            [
                                156.43922,
                                -6.5995
                            ],
                            [
                                156.39302,
                                -6.64481
                            ],
                            [
                                156.41122,
                                -6.73571
                            ],
                            [
                                156.50579,
                                -6.79917
                            ],
                            [
                                156.52075,
                                -6.83397
                            ],
                            [
                                156.65348,
                                -6.90238
                            ],
                            [
                                156.86826,
                                -7.16841
                            ],
                            [
                                157.15622,
                                -7.33866
                            ],
                            [
                                157.30073,
                                -7.36655
                            ],
                            [
                                157.33878,
                                -7.4021
                            ],
                            [
                                157.56829,
                                -7.44809
                            ],
                            [
                                157.55123,
                                -7.31454
                            ],
                            [
                                157.51387,
                                -7.28953
                            ],
                            [
                                157.449,
                                -7.31946
                            ],
                            [
                                157.3233,
                                -7.26582
                            ],
                            [
                                157.2867,
                                -7.21429
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                162.09165,
                                -10.48751
                            ],
                            [
                                161.997,
                                -10.49596
                            ],
                            [
                                161.95427,
                                -10.45838
                            ],
                            [
                                161.84177,
                                -10.45623
                            ],
                            [
                                161.78934,
                                -10.41264
                            ],
                            [
                                161.71821,
                                -10.40742
                            ],
                            [
                                161.68807,
                                -10.36573
                            ],
                            [
                                161.46081,
                                -10.22921
                            ],
                            [
                                161.3402,
                                -10.18881
                            ],
                            [
                                161.27854,
                                -10.21371
                            ],
                            [
                                161.27369,
                                -10.33681
                            ],
                            [
                                161.37897,
                                -10.33498
                            ],
                            [
                                161.49156,
                                -10.37832
                            ],
                            [
                                161.49379,
                                -10.4553
                            ],
                            [
                                161.63307,
                                -10.63772
                            ],
                            [
                                161.70558,
                                -10.66829
                            ],
                            [
                                161.80027,
                                -10.75077
                            ],
                            [
                                161.9383,
                                -10.79325
                            ],
                            [
                                162.00911,
                                -10.78974
                            ],
                            [
                                162.11757,
                                -10.83993
                            ],
                            [
                                162.24649,
                                -10.79811
                            ],
                            [
                                162.27811,
                                -10.77098
                            ],
                            [
                                162.26126,
                                -10.69322
                            ],
                            [
                                162.22341,
                                -10.68656
                            ],
                            [
                                162.18689,
                                -10.61697
                            ],
                            [
                                162.09165,
                                -10.48751
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                157.2867,
                                -8.17935
                            ],
                            [
                                157.18222,
                                -8.18687
                            ],
                            [
                                157.1338,
                                -8.14988
                            ],
                            [
                                157.09255,
                                -8.19031
                            ],
                            [
                                157.14043,
                                -8.26902
                            ],
                            [
                                157.20515,
                                -8.2771
                            ],
                            [
                                157.2867,
                                -8.33103
                            ],
                            [
                                157.3389,
                                -8.27407
                            ],
                            [
                                157.41332,
                                -8.27644
                            ],
                            [
                                157.53845,
                                -8.25615
                            ],
                            [
                                157.58766,
                                -8.35888
                            ],
                            [
                                157.56829,
                                -8.42156
                            ],
                            [
                                157.67818,
                                -8.51097
                            ],
                            [
                                157.73473,
                                -8.51484
                            ],
                            [
                                157.78854,
                                -8.5829
                            ],
                            [
                                157.87406,
                                -8.53213
                            ],
                            [
                                157.90216,
                                -8.47759
                            ],
                            [
                                157.77669,
                                -8.28558
                            ],
                            [
                                157.76575,
                                -8.23743
                            ],
                            [
                                157.60834,
                                -8.16175
                            ],
                            [
                                157.60631,
                                -8.0488
                            ],
                            [
                                157.50493,
                                -7.96415
                            ],
                            [
                                157.4053,
                                -7.99289
                            ],
                            [
                                157.36032,
                                -8.04273
                            ],
                            [
                                157.2867,
                                -8.17935
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                156.93817,
                                -7.97486
                            ],
                            [
                                156.9897,
                                -8.08817
                            ],
                            [
                                157.06607,
                                -8.12053
                            ],
                            [
                                157.1573,
                                -8.13392
                            ],
                            [
                                157.19705,
                                -8.05483
                            ],
                            [
                                157.17158,
                                -7.90573
                            ],
                            [
                                157.1129,
                                -7.85003
                            ],
                            [
                                157.0294,
                                -7.8532
                            ],
                            [
                                156.94933,
                                -7.9264
                            ],
                            [
                                156.93817,
                                -7.97486
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                156.77392,
                                -7.78201
                            ],
                            [
                                156.79038,
                                -7.73362
                            ],
                            [
                                156.70978,
                                -7.70009
                            ],
                            [
                                156.63595,
                                -7.61343
                            ],
                            [
                                156.56903,
                                -7.57431
                            ],
                            [
                                156.50774,
                                -7.61715
                            ],
                            [
                                156.5024,
                                -7.68415
                            ],
                            [
                                156.5729,
                                -7.77619
                            ],
                            [
                                156.60422,
                                -7.79098
                            ],
                            [
                                156.60523,
                                -7.87757
                            ],
                            [
                                156.699,
                                -7.89885
                            ],
                            [
                                156.71952,
                                -7.83629
                            ],
                            [
                                156.77392,
                                -7.78201
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                159.95468,
                                -11.50062
                            ],
                            [
                                159.96893,
                                -11.55663
                            ],
                            [
                                160.03232,
                                -11.61667
                            ],
                            [
                                160.06205,
                                -11.60272
                            ],
                            [
                                160.18297,
                                -11.68461
                            ],
                            [
                                160.26602,
                                -11.65214
                            ],
                            [
                                160.40628,
                                -11.75075
                            ],
                            [
                                160.43518,
                                -11.72797
                            ],
                            [
                                160.21116,
                                -11.56719
                            ],
                            [
                                160.1501,
                                -11.5443
                            ],
                            [
                                160.09974,
                                -11.4928
                            ],
                            [
                                159.97931,
                                -11.46946
                            ],
                            [
                                159.95468,
                                -11.50062
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                157.95726,
                                -8.57537
                            ],
                            [
                                157.87488,
                                -8.60567
                            ],
                            [
                                157.87113,
                                -8.66819
                            ],
                            [
                                157.94881,
                                -8.75798
                            ],
                            [
                                158.02645,
                                -8.76696
                            ],
                            [
                                158.1001,
                                -8.67594
                            ],
                            [
                                158.08488,
                                -8.63548
                            ],
                            [
                                158.11902,
                                -8.54442
                            ],
                            [
                                157.98008,
                                -8.50817
                            ],
                            [
                                157.95726,
                                -8.57537
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                165.75057,
                                -10.78858
                            ],
                            [
                                165.77087,
                                -10.83353
                            ],
                            [
                                165.87727,
                                -10.83552
                            ],
                            [
                                165.95151,
                                -10.7549
                            ],
                            [
                                166.05113,
                                -10.78345
                            ],
                            [
                                166.13991,
                                -10.69694
                            ],
                            [
                                166.03462,
                                -10.6514
                            ],
                            [
                                165.88433,
                                -10.6571
                            ],
                            [
                                165.82434,
                                -10.75819
                            ],
                            [
                                165.75057,
                                -10.78858
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                157.2867,
                                -8.46198
                            ],
                            [
                                157.19541,
                                -8.56736
                            ],
                            [
                                157.20317,
                                -8.58671
                            ],
                            [
                                157.34589,
                                -8.68925
                            ],
                            [
                                157.34457,
                                -8.56704
                            ],
                            [
                                157.40907,
                                -8.49555
                            ],
                            [
                                157.35847,
                                -8.40183
                            ],
                            [
                                157.2867,
                                -8.46198
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                160.06604,
                                -9.04603
                            ],
                            [
                                160.09751,
                                -9.08931
                            ],
                            [
                                160.18735,
                                -9.09156
                            ],
                            [
                                160.21197,
                                -9.12323
                            ],
                            [
                                160.33372,
                                -9.18324
                            ],
                            [
                                160.35429,
                                -9.11407
                            ],
                            [
                                160.23909,
                                -9.00993
                            ],
                            [
                                160.06604,
                                -9.04603
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                155.63371,
                                -7.06649
                            ],
                            [
                                155.71634,
                                -7.10294
                            ],
                            [
                                155.84795,
                                -7.11997
                            ],
                            [
                                155.8632,
                                -7.03908
                            ],
                            [
                                155.80161,
                                -7.01592
                            ],
                            [
                                155.74375,
                                -6.96367
                            ],
                            [
                                155.68209,
                                -7.05973
                            ],
                            [
                                155.63371,
                                -7.06649
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                159.51785,
                                -8.43371
                            ],
                            [
                                159.53612,
                                -8.4815
                            ],
                            [
                                159.67351,
                                -8.55274
                            ],
                            [
                                159.70116,
                                -8.51686
                            ],
                            [
                                159.63909,
                                -8.47482
                            ],
                            [
                                159.64047,
                                -8.39228
                            ],
                            [
                                159.5924,
                                -8.37549
                            ],
                            [
                                159.51785,
                                -8.43371
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                166.79306,
                                -11.62294
                            ],
                            [
                                166.82426,
                                -11.67941
                            ],
                            [
                                166.89373,
                                -11.7219
                            ],
                            [
                                166.93883,
                                -11.61597
                            ],
                            [
                                166.82346,
                                -11.58964
                            ],
                            [
                                166.79306,
                                -11.62294
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                156.50892,
                                -7.94874
                            ],
                            [
                                156.53328,
                                -7.98685
                            ],
                            [
                                156.53216,
                                -8.08868
                            ],
                            [
                                156.57964,
                                -8.1824
                            ],
                            [
                                156.6158,
                                -8.13882
                            ],
                            [
                                156.57501,
                                -7.97682
                            ],
                            [
                                156.50892,
                                -7.94874
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                159.02905,
                                -9.07516
                            ],
                            [
                                159.08743,
                                -9.12356
                            ],
                            [
                                159.14462,
                                -9.11404
                            ],
                            [
                                159.13523,
                                -9.03368
                            ],
                            [
                                159.10608,
                                -8.99788
                            ],
                            [
                                159.02905,
                                -9.07516
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                157.445,
                                -8.72027
                            ],
                            [
                                157.62315,
                                -8.79963
                            ],
                            [
                                157.65594,
                                -8.77239
                            ],
                            [
                                157.54732,
                                -8.69387
                            ],
                            [
                                157.445,
                                -8.72027
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                158.19297,
                                -7.43777
                            ],
                            [
                                158.241,
                                -7.47736
                            ],
                            [
                                158.40241,
                                -7.56249
                            ],
                            [
                                158.42073,
                                -7.52133
                            ],
                            [
                                158.27406,
                                -7.45531
                            ],
                            [
                                158.26005,
                                -7.39504
                            ],
                            [
                                158.19297,
                                -7.43777
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                158.12981,
                                -8.79049
                            ],
                            [
                                158.18819,
                                -8.83158
                            ],
                            [
                                158.21552,
                                -8.77559
                            ],
                            [
                                158.18931,
                                -8.72384
                            ],
                            [
                                158.12981,
                                -8.79049
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                157.71102,
                                -7.44015
                            ],
                            [
                                157.75472,
                                -7.47738
                            ],
                            [
                                157.82536,
                                -7.47011
                            ],
                            [
                                157.80826,
                                -7.41785
                            ],
                            [
                                157.75786,
                                -7.38983
                            ],
                            [
                                157.71102,
                                -7.44015
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                166.47565,
                                -11.25105
                            ],
                            [
                                166.50269,
                                -11.30824
                            ],
                            [
                                166.5722,
                                -11.28095
                            ],
                            [
                                166.57253,
                                -11.23203
                            ],
                            [
                                166.50176,
                                -11.21515
                            ],
                            [
                                166.47565,
                                -11.25105
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                157.00727,
                                -8.19202
                            ],
                            [
                                157.09576,
                                -8.28369
                            ],
                            [
                                157.09574,
                                -8.21073
                            ],
                            [
                                157.00727,
                                -8.19202
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "SOM",
                "Country": "Somalia",
                "Total_3GHG": 0.09,
                "Total_3GHG_timeseries": [
                    9.7817e-07,
                    1.9619e-06,
                    2.9517e-06,
                    3.9475e-06,
                    4.9494e-06,
                    5.957e-06,
                    6.9704e-06,
                    7.9891e-06,
                    9.0131e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015
                ],
                "Fossil_3GHG": 0.03,
                "Fossil_3GHG_timeseries": [
                    4.1361e-08,
                    8.3371e-08,
                    1.2662e-07,
                    1.7112e-07,
                    2.1689e-07,
                    2.6395e-07,
                    3.1231e-07,
                    3.6198e-07,
                    4.13e-07,
                    4.6536e-07,
                    5.1934e-07,
                    5.7495e-07,
                    6.3382e-07,
                    6.9438e-07,
                    7.5663e-07,
                    8.206e-07,
                    8.863e-07,
                    9.5376e-07,
                    1.023e-06,
                    1.094e-06,
                    1.1669e-06,
                    1.2413e-06,
                    1.3167e-06,
                    1.3932e-06,
                    1.4707e-06,
                    1.5492e-06,
                    1.6288e-06,
                    1.7094e-06,
                    1.7911e-06,
                    1.8737e-06,
                    1.9571e-06,
                    2.0413e-06,
                    2.1247e-06,
                    2.2089e-06,
                    2.2939e-06,
                    2.3796e-06,
                    2.4662e-06,
                    2.5535e-06,
                    2.6416e-06,
                    2.7308e-06,
                    2.8209e-06,
                    2.9118e-06,
                    3.0037e-06,
                    3.0965e-06,
                    3.1902e-06,
                    3.2849e-06,
                    3.3806e-06,
                    3.4773e-06,
                    3.5751e-06,
                    3.6738e-06,
                    3.7771e-06,
                    3.8852e-06,
                    3.9982e-06,
                    4.1162e-06,
                    4.2394e-06,
                    4.3679e-06,
                    4.502e-06,
                    4.6417e-06,
                    4.7872e-06,
                    4.9386e-06,
                    5.1005e-06,
                    5.2731e-06,
                    5.4565e-06,
                    5.6507e-06,
                    5.856e-06,
                    6.0725e-06,
                    6.3006e-06,
                    6.5407e-06,
                    6.7933e-06,
                    7.0585e-06,
                    7.3384e-06,
                    7.6335e-06,
                    7.9436e-06,
                    8.2691e-06,
                    8.6105e-06,
                    8.9682e-06,
                    9.3426e-06,
                    9.7343e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Land_3GHG": 0.22,
                "Land_3GHG_timeseries": [
                    9.3681e-07,
                    1.8785e-06,
                    2.8251e-06,
                    3.7764e-06,
                    4.7325e-06,
                    5.6931e-06,
                    6.658e-06,
                    7.6271e-06,
                    8.6001e-06,
                    9.5868e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013
                ],
                "Total_CO2": 0.03,
                "Total_CO2_timeseries": [
                    -0.000000023094,
                    -0.000000046882,
                    -0.000000071302,
                    -0.000000096289,
                    -0.00000012181,
                    -0.0000001478,
                    -0.00000017427,
                    -0.00000020117,
                    -0.0000002285,
                    -0.00000024594,
                    -0.00000026049,
                    -0.00000027564,
                    -0.00000029196,
                    -0.00000030957,
                    -0.00000032848,
                    -0.00000034865,
                    -0.00000037,
                    -0.00000039246,
                    -0.00000041594,
                    -0.00000043875,
                    -0.00000046192,
                    -0.00000048606,
                    -0.00000051123,
                    -0.00000053738,
                    -0.00000056446,
                    -0.00000059243,
                    -0.00000062124,
                    -0.00000065083,
                    -0.00000068116,
                    -0.00000070997,
                    -0.00000073877,
                    -0.0000007683,
                    -0.00000079865,
                    -0.00000082984,
                    -0.00000086184,
                    -0.00000089462,
                    -0.00000092814,
                    -0.00000096237,
                    -0.00000099729,
                    -0.0000010301,
                    -0.0000010627,
                    -0.0000010959,
                    -0.00000113,
                    -0.0000011649,
                    -0.0000012006,
                    -0.0000012371,
                    -0.0000012743,
                    -0.0000013119,
                    -0.0000013497,
                    -0.0000013855,
                    -0.0000014207,
                    -0.0000014546,
                    -0.0000014878,
                    -0.0000015177,
                    -0.0000015447,
                    -0.0000015684,
                    -0.0000015891,
                    -0.0000016083,
                    -0.0000016226,
                    -0.0000015852,
                    -0.0000015275,
                    -0.0000014653,
                    -0.0000014061,
                    -0.0000013553,
                    -0.0000013066,
                    -0.0000012581,
                    -0.0000012099,
                    -0.0000011621,
                    -0.0000011135,
                    -0.0000010509,
                    -0.0000009701,
                    -0.00000086066,
                    -0.00000070817,
                    -0.00000053269,
                    -0.00000031354,
                    -0.000000053955,
                    2.4207e-07,
                    5.6931e-07,
                    9.4085e-07,
                    1.3595e-06,
                    1.8042e-06,
                    2.2851e-06,
                    2.7937e-06,
                    3.3322e-06,
                    3.9001e-06,
                    4.4967e-06,
                    5.1159e-06,
                    5.7612e-06,
                    6.4259e-06,
                    7.1291e-06,
                    7.8649e-06,
                    8.6219e-06,
                    9.3985e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2.145e-08,
                    4.29e-08,
                    6.435e-08,
                    8.58e-08,
                    1.0725e-07,
                    1.3695e-07,
                    1.683e-07,
                    2.013e-07,
                    2.3925e-07,
                    2.7885e-07,
                    3.168e-07,
                    3.564e-07,
                    4.0425e-07,
                    4.5045e-07,
                    5.115e-07,
                    5.709e-07,
                    6.336e-07,
                    7.359e-07,
                    8.052e-07,
                    8.778e-07,
                    9.7515e-07,
                    1.0593e-06,
                    1.1649e-06,
                    1.2837e-06,
                    1.4322e-06,
                    1.6582e-06,
                    1.8744e-06,
                    2.2341e-06,
                    2.4849e-06,
                    2.7044e-06,
                    3.0706e-06,
                    3.1944e-06,
                    3.5178e-06,
                    3.9385e-06,
                    4.2603e-06,
                    4.6464e-06,
                    5.0622e-06,
                    5.5094e-06,
                    5.9613e-06,
                    6.3901e-06,
                    6.7423e-06,
                    7.0593e-06,
                    7.3593e-06,
                    7.6411e-06,
                    7.9196e-06,
                    8.1832e-06,
                    8.4422e-06,
                    8.6831e-06,
                    8.9108e-06,
                    9.1303e-06,
                    9.3448e-06,
                    9.5692e-06,
                    9.82e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CO2": 0.08,
                "Land_CO2_timeseries": [
                    -0.000000023094,
                    -0.000000046882,
                    -0.000000071302,
                    -0.000000096289,
                    -0.00000012181,
                    -0.0000001478,
                    -0.00000017427,
                    -0.00000020117,
                    -0.0000002285,
                    -0.00000024594,
                    -0.00000026049,
                    -0.00000027564,
                    -0.00000029196,
                    -0.00000030957,
                    -0.00000032848,
                    -0.00000034865,
                    -0.00000037,
                    -0.00000039246,
                    -0.00000041594,
                    -0.00000043875,
                    -0.00000046192,
                    -0.00000048606,
                    -0.00000051123,
                    -0.00000053738,
                    -0.00000056446,
                    -0.00000059243,
                    -0.00000062124,
                    -0.00000065083,
                    -0.00000068116,
                    -0.00000070997,
                    -0.00000073877,
                    -0.0000007683,
                    -0.00000079865,
                    -0.00000082984,
                    -0.00000086184,
                    -0.00000089462,
                    -0.00000092814,
                    -0.00000096237,
                    -0.00000099729,
                    -0.0000010301,
                    -0.0000010627,
                    -0.0000010959,
                    -0.00000113,
                    -0.0000011649,
                    -0.0000012006,
                    -0.0000012371,
                    -0.0000012743,
                    -0.0000013119,
                    -0.0000013497,
                    -0.0000013855,
                    -0.0000014207,
                    -0.0000014546,
                    -0.0000014878,
                    -0.0000015177,
                    -0.0000015447,
                    -0.0000015684,
                    -0.0000015891,
                    -0.0000016083,
                    -0.0000016226,
                    -0.0000015852,
                    -0.0000015275,
                    -0.0000014653,
                    -0.0000014061,
                    -0.0000013553,
                    -0.0000013066,
                    -0.0000012581,
                    -0.0000012099,
                    -0.0000011621,
                    -0.0000011135,
                    -0.0000010509,
                    -0.0000009701,
                    -0.00000086066,
                    -0.00000070817,
                    -0.00000053269,
                    -0.00000031354,
                    -0.000000053955,
                    2.4207e-07,
                    5.6931e-07,
                    9.4085e-07,
                    1.3595e-06,
                    1.8042e-06,
                    2.2851e-06,
                    2.7937e-06,
                    3.3322e-06,
                    3.9001e-06,
                    4.4967e-06,
                    5.1159e-06,
                    5.7612e-06,
                    6.4259e-06,
                    7.1291e-06,
                    7.8649e-06,
                    8.6219e-06,
                    9.3985e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Total_CH4": 0.24,
                "Total_CH4_timeseries": [
                    8.9557e-07,
                    1.7953e-06,
                    2.6998e-06,
                    3.609e-06,
                    4.523e-06,
                    5.4418e-06,
                    6.3654e-06,
                    7.2938e-06,
                    8.2271e-06,
                    9.1653e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001
                ],
                "Fossil_CH4": 0.1,
                "Fossil_CH4_timeseries": [
                    3.6371e-08,
                    7.3328e-08,
                    1.1146e-07,
                    1.5078e-07,
                    1.9132e-07,
                    2.3309e-07,
                    2.7611e-07,
                    3.204e-07,
                    3.6597e-07,
                    4.1286e-07,
                    4.6132e-07,
                    5.1137e-07,
                    5.6466e-07,
                    6.1958e-07,
                    6.7617e-07,
                    7.3443e-07,
                    7.944e-07,
                    8.5608e-07,
                    9.195e-07,
                    9.8469e-07,
                    1.0517e-06,
                    1.12e-06,
                    1.1893e-06,
                    1.2594e-06,
                    1.3305e-06,
                    1.4024e-06,
                    1.4752e-06,
                    1.5489e-06,
                    1.6235e-06,
                    1.6989e-06,
                    1.7751e-06,
                    1.8521e-06,
                    1.9282e-06,
                    2.005e-06,
                    2.0825e-06,
                    2.1608e-06,
                    2.2398e-06,
                    2.3195e-06,
                    2.4e-06,
                    2.4813e-06,
                    2.5633e-06,
                    2.6461e-06,
                    2.7297e-06,
                    2.8141e-06,
                    2.8993e-06,
                    2.9854e-06,
                    3.0723e-06,
                    3.1601e-06,
                    3.2487e-06,
                    3.3382e-06,
                    3.4321e-06,
                    3.5306e-06,
                    3.6337e-06,
                    3.7417e-06,
                    3.8547e-06,
                    3.9728e-06,
                    4.0962e-06,
                    4.225e-06,
                    4.3595e-06,
                    4.4998e-06,
                    4.6504e-06,
                    4.8116e-06,
                    4.9833e-06,
                    5.1659e-06,
                    5.3594e-06,
                    5.564e-06,
                    5.7801e-06,
                    6.0081e-06,
                    6.2484e-06,
                    6.5013e-06,
                    6.7687e-06,
                    7.0512e-06,
                    7.3486e-06,
                    7.6613e-06,
                    7.9898e-06,
                    8.3344e-06,
                    8.6956e-06,
                    9.0739e-06,
                    9.4698e-06,
                    9.8838e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003
                ],
                "Land_CH4": 0.48,
                "Land_CH4_timeseries": [
                    8.592e-07,
                    1.722e-06,
                    2.5883e-06,
                    3.4582e-06,
                    4.3317e-06,
                    5.2087e-06,
                    6.0893e-06,
                    6.9735e-06,
                    7.8612e-06,
                    8.7525e-06,
                    9.6547e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008
                ],
                "Total_N2O": 0.27,
                "Total_N2O_timeseries": [
                    1.0569e-07,
                    2.1346e-07,
                    3.2322e-07,
                    4.3485e-07,
                    5.4819e-07,
                    6.6305e-07,
                    7.7922e-07,
                    8.9643e-07,
                    1.0144e-06,
                    1.1328e-06,
                    1.2514e-06,
                    1.3703e-06,
                    1.4892e-06,
                    1.6083e-06,
                    1.7275e-06,
                    1.8468e-06,
                    1.9662e-06,
                    2.0857e-06,
                    2.2055e-06,
                    2.3255e-06,
                    2.4474e-06,
                    2.5743e-06,
                    2.7085e-06,
                    2.8514e-06,
                    3.004e-06,
                    3.1665e-06,
                    3.3384e-06,
                    3.5187e-06,
                    3.7054e-06,
                    3.896e-06,
                    4.0889e-06,
                    4.2836e-06,
                    4.48e-06,
                    4.6777e-06,
                    4.8767e-06,
                    5.0769e-06,
                    5.2782e-06,
                    5.4807e-06,
                    5.6847e-06,
                    5.8992e-06,
                    6.1158e-06,
                    6.3346e-06,
                    6.5556e-06,
                    6.779e-06,
                    7.0049e-06,
                    7.2333e-06,
                    7.4643e-06,
                    7.6981e-06,
                    7.9346e-06,
                    8.1739e-06,
                    8.4161e-06,
                    8.661e-06,
                    8.9086e-06,
                    9.159e-06,
                    9.4124e-06,
                    9.669e-06,
                    9.9292e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_N2O": 0.04,
                "Fossil_N2O_timeseries": [
                    4.9899e-09,
                    1.0043e-08,
                    1.5158e-08,
                    2.0333e-08,
                    2.5566e-08,
                    3.0855e-08,
                    3.6197e-08,
                    4.1588e-08,
                    4.7025e-08,
                    5.2503e-08,
                    5.8019e-08,
                    6.3574e-08,
                    6.9166e-08,
                    7.4796e-08,
                    8.0462e-08,
                    8.6165e-08,
                    9.1905e-08,
                    9.7683e-08,
                    1.035e-07,
                    1.0935e-07,
                    1.1527e-07,
                    1.2129e-07,
                    1.2744e-07,
                    1.3374e-07,
                    1.402e-07,
                    1.4683e-07,
                    1.5362e-07,
                    1.6056e-07,
                    1.6761e-07,
                    1.7476e-07,
                    1.8196e-07,
                    1.8923e-07,
                    1.9656e-07,
                    2.0394e-07,
                    2.1137e-07,
                    2.1885e-07,
                    2.2639e-07,
                    2.3397e-07,
                    2.4161e-07,
                    2.4953e-07,
                    2.5756e-07,
                    2.657e-07,
                    2.7396e-07,
                    2.8235e-07,
                    2.9087e-07,
                    2.9952e-07,
                    3.0832e-07,
                    3.1726e-07,
                    3.2636e-07,
                    3.356e-07,
                    3.4501e-07,
                    3.5461e-07,
                    3.6442e-07,
                    3.7443e-07,
                    3.8466e-07,
                    3.9511e-07,
                    4.0576e-07,
                    4.1661e-07,
                    4.2763e-07,
                    4.3881e-07,
                    4.5012e-07,
                    4.6156e-07,
                    4.7312e-07,
                    4.848e-07,
                    4.9658e-07,
                    5.0848e-07,
                    5.2049e-07,
                    5.3261e-07,
                    5.4484e-07,
                    5.5719e-07,
                    5.6967e-07,
                    5.8226e-07,
                    5.9497e-07,
                    6.078e-07,
                    6.2075e-07,
                    6.3382e-07,
                    6.4703e-07,
                    6.6037e-07,
                    6.7386e-07,
                    6.8752e-07,
                    7.0136e-07,
                    7.1543e-07,
                    7.2977e-07,
                    7.444e-07,
                    7.5936e-07,
                    7.7466e-07,
                    7.9033e-07,
                    8.0635e-07,
                    8.2276e-07,
                    8.3953e-07,
                    8.5672e-07,
                    8.7439e-07,
                    8.926e-07,
                    9.1141e-07,
                    9.3085e-07,
                    9.5094e-07,
                    9.7171e-07,
                    9.9315e-07,
                    1.0152e-06,
                    1.038e-06,
                    1.0614e-06,
                    1.0856e-06,
                    1.1106e-06,
                    1.1366e-06,
                    1.1634e-06,
                    1.191e-06,
                    1.2196e-06,
                    1.2489e-06,
                    1.2789e-06,
                    1.3096e-06,
                    1.3407e-06,
                    1.3724e-06,
                    1.4044e-06,
                    1.4369e-06,
                    1.4698e-06,
                    1.5032e-06,
                    1.5372e-06,
                    1.5718e-06,
                    1.6072e-06,
                    1.6486e-06,
                    1.6908e-06,
                    1.7341e-06,
                    1.7788e-06,
                    1.8271e-06,
                    1.8763e-06,
                    1.9285e-06,
                    1.9813e-06,
                    2.037e-06,
                    2.0963e-06,
                    2.1591e-06,
                    2.2239e-06,
                    2.2937e-06,
                    2.3677e-06,
                    2.4476e-06,
                    2.5246e-06,
                    2.6038e-06,
                    2.6838e-06,
                    2.7666e-06,
                    2.8482e-06,
                    2.9371e-06,
                    3.0272e-06,
                    3.1196e-06,
                    3.2124e-06,
                    3.3094e-06,
                    3.4114e-06,
                    3.5163e-06,
                    3.624e-06,
                    3.7356e-06,
                    3.8568e-06,
                    3.9924e-06,
                    4.1332e-06,
                    4.2792e-06,
                    4.4349e-06,
                    4.5971e-06,
                    4.7675e-06,
                    4.9464e-06,
                    5.1278e-06,
                    5.3211e-06,
                    5.5235e-06,
                    5.7337e-06,
                    5.9527e-06,
                    6.1756e-06,
                    6.3999e-06,
                    6.6273e-06,
                    6.8618e-06,
                    7.1053e-06,
                    7.3581e-06,
                    7.6175e-06,
                    7.8849e-06,
                    8.1613e-06,
                    8.4436e-06,
                    8.7274e-06
                ],
                "Land_N2O": 0.36,
                "Land_N2O_timeseries": [
                    1.007e-07,
                    2.0342e-07,
                    3.0806e-07,
                    4.1452e-07,
                    5.2262e-07,
                    6.322e-07,
                    7.4302e-07,
                    8.5484e-07,
                    9.6738e-07,
                    1.0803e-06,
                    1.1934e-06,
                    1.3067e-06,
                    1.4201e-06,
                    1.5335e-06,
                    1.647e-06,
                    1.7606e-06,
                    1.8743e-06,
                    1.988e-06,
                    2.102e-06,
                    2.2161e-06,
                    2.3322e-06,
                    2.4531e-06,
                    2.581e-06,
                    2.7176e-06,
                    2.8638e-06,
                    3.0196e-06,
                    3.1848e-06,
                    3.3581e-06,
                    3.5377e-06,
                    3.7212e-06,
                    3.9069e-06,
                    4.0944e-06,
                    4.2834e-06,
                    4.4738e-06,
                    4.6653e-06,
                    4.858e-06,
                    5.0518e-06,
                    5.2468e-06,
                    5.4431e-06,
                    5.6497e-06,
                    5.8583e-06,
                    6.0689e-06,
                    6.2816e-06,
                    6.4967e-06,
                    6.714e-06,
                    6.9338e-06,
                    7.156e-06,
                    7.3808e-06,
                    7.6082e-06,
                    7.8383e-06,
                    8.0711e-06,
                    8.3064e-06,
                    8.5442e-06,
                    8.7846e-06,
                    9.0278e-06,
                    9.2739e-06,
                    9.5235e-06,
                    9.7768e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            43.26032,
                            11.46059
                        ],
                        [
                            42.96806,
                            10.99743
                        ],
                        [
                            42.76652,
                            10.72181
                        ],
                        [
                            42.6837,
                            10.59139
                        ],
                        [
                            42.74646,
                            10.51192
                        ],
                        [
                            42.83269,
                            10.27778
                        ],
                        [
                            42.88104,
                            10.20724
                        ],
                        [
                            43.01747,
                            10.0806
                        ],
                        [
                            43.08583,
                            9.90899
                        ],
                        [
                            43.14993,
                            9.89936
                        ],
                        [
                            43.25682,
                            9.84261
                        ],
                        [
                            43.29921,
                            9.6112
                        ],
                        [
                            43.39812,
                            9.55287
                        ],
                        [
                            43.44554,
                            9.4449
                        ],
                        [
                            43.51976,
                            9.38727
                        ],
                        [
                            43.65502,
                            9.3514
                        ],
                        [
                            44.0054,
                            8.99716
                        ],
                        [
                            44.51871,
                            8.83072
                        ],
                        [
                            44.87246,
                            8.70888
                        ],
                        [
                            45.23622,
                            8.58765
                        ],
                        [
                            45.60838,
                            8.46884
                        ],
                        [
                            45.93109,
                            8.35875
                        ],
                        [
                            46.57755,
                            8.14643
                        ],
                        [
                            46.99187,
                            8.00059
                        ],
                        [
                            47.6747,
                            7.99822
                        ],
                        [
                            47.97214,
                            7.98785
                        ],
                        [
                            47.6747,
                            7.68201
                        ],
                        [
                            47.17975,
                            7.17262
                        ],
                        [
                            46.75709,
                            6.73976
                        ],
                        [
                            46.11145,
                            6.07779
                        ],
                        [
                            45.47467,
                            5.4241
                        ],
                        [
                            44.98487,
                            4.92081
                        ],
                        [
                            44.75004,
                            4.9285
                        ],
                        [
                            44.01521,
                            4.96043
                        ],
                        [
                            43.65893,
                            4.86799
                        ],
                        [
                            43.43513,
                            4.79469
                        ],
                        [
                            43.17062,
                            4.66019
                        ],
                        [
                            43.04524,
                            4.57287
                        ],
                        [
                            43.00731,
                            4.46833
                        ],
                        [
                            42.89779,
                            4.31845
                        ],
                        [
                            42.81607,
                            4.26498
                        ],
                        [
                            42.70786,
                            4.26122
                        ],
                        [
                            42.55075,
                            4.20581
                        ],
                        [
                            42.19704,
                            4.179
                        ],
                        [
                            42.08755,
                            4.17897
                        ],
                        [
                            41.94735,
                            4.05561
                        ],
                        [
                            41.91012,
                            3.98232
                        ],
                        [
                            41.64906,
                            3.60858
                        ],
                        [
                            41.33322,
                            3.15642
                        ],
                        [
                            40.99565,
                            2.82169
                        ],
                        [
                            40.99492,
                            2.34004
                        ],
                        [
                            40.99565,
                            1.69952
                        ],
                        [
                            40.99565,
                            1.23274
                        ],
                        [
                            40.99565,
                            0.69407
                        ],
                        [
                            40.99565,
                            0.08363
                        ],
                        [
                            40.99565,
                            -0.83324
                        ],
                        [
                            41.2222,
                            -1.1391
                        ],
                        [
                            41.56449,
                            -1.60122
                        ],
                        [
                            41.56449,
                            -1.65575
                        ],
                        [
                            41.78337,
                            -1.34239
                        ],
                        [
                            41.83373,
                            -1.25402
                        ],
                        [
                            41.92748,
                            -1.13711
                        ],
                        [
                            41.98306,
                            -1.01815
                        ],
                        [
                            42.08447,
                            -0.89723
                        ],
                        [
                            42.11486,
                            -0.84214
                        ],
                        [
                            42.17529,
                            -0.81008
                        ],
                        [
                            42.42052,
                            -0.49453
                        ],
                        [
                            42.58128,
                            -0.3089
                        ],
                        [
                            42.8819,
                            -0.00918
                        ],
                        [
                            43.3702,
                            0.52703
                        ],
                        [
                            43.49103,
                            0.6501
                        ],
                        [
                            43.77722,
                            0.90898
                        ],
                        [
                            43.93312,
                            1.02309
                        ],
                        [
                            44.32217,
                            1.37699
                        ],
                        [
                            44.6626,
                            1.6397
                        ],
                        [
                            45.04779,
                            1.88639
                        ],
                        [
                            45.22387,
                            1.9652
                        ],
                        [
                            45.3933,
                            2.05379
                        ],
                        [
                            45.79001,
                            2.29469
                        ],
                        [
                            45.89996,
                            2.35203
                        ],
                        [
                            46.01956,
                            2.43747
                        ],
                        [
                            46.10526,
                            2.51757
                        ],
                        [
                            46.21931,
                            2.65659
                        ],
                        [
                            46.29525,
                            2.71055
                        ],
                        [
                            46.33987,
                            2.78218
                        ],
                        [
                            46.57461,
                            2.97801
                        ],
                        [
                            46.68837,
                            3.08505
                        ],
                        [
                            46.8403,
                            3.25083
                        ],
                        [
                            46.92743,
                            3.36115
                        ],
                        [
                            47.08684,
                            3.52327
                        ],
                        [
                            47.2165,
                            3.67059
                        ],
                        [
                            47.4637,
                            3.91445
                        ],
                        [
                            47.58533,
                            4.06602
                        ],
                        [
                            47.74716,
                            4.23716
                        ],
                        [
                            47.80715,
                            4.31319
                        ],
                        [
                            47.94318,
                            4.45435
                        ],
                        [
                            48.08142,
                            4.67108
                        ],
                        [
                            48.19809,
                            4.89338
                        ],
                        [
                            48.27769,
                            5.01253
                        ],
                        [
                            48.62255,
                            5.46551
                        ],
                        [
                            48.91287,
                            5.92279
                        ],
                        [
                            49.05036,
                            6.20777
                        ],
                        [
                            49.0774,
                            6.29519
                        ],
                        [
                            49.08444,
                            6.41612
                        ],
                        [
                            49.14366,
                            6.58234
                        ],
                        [
                            49.21495,
                            6.75179
                        ],
                        [
                            49.31939,
                            6.93314
                        ],
                        [
                            49.4757,
                            7.17023
                        ],
                        [
                            49.56819,
                            7.29152
                        ],
                        [
                            49.68489,
                            7.46552
                        ],
                        [
                            49.75478,
                            7.60808
                        ],
                        [
                            49.77085,
                            7.66946
                        ],
                        [
                            49.82207,
                            7.73878
                        ],
                        [
                            49.80453,
                            7.83798
                        ],
                        [
                            49.82247,
                            7.92576
                        ],
                        [
                            49.96928,
                            8.0802
                        ],
                        [
                            50.12401,
                            8.19276
                        ],
                        [
                            50.16284,
                            8.31413
                        ],
                        [
                            50.24127,
                            8.43732
                        ],
                        [
                            50.29753,
                            8.49218
                        ],
                        [
                            50.33326,
                            8.56102
                        ],
                        [
                            50.33512,
                            8.63588
                        ],
                        [
                            50.38297,
                            8.70311
                        ],
                        [
                            50.4123,
                            8.83282
                        ],
                        [
                            50.45098,
                            8.90095
                        ],
                        [
                            50.63533,
                            9.07167
                        ],
                        [
                            50.65793,
                            9.20633
                        ],
                        [
                            50.75094,
                            9.30088
                        ],
                        [
                            50.84291,
                            9.45171
                        ],
                        [
                            50.80661,
                            9.51578
                        ],
                        [
                            50.85252,
                            9.85361
                        ],
                        [
                            50.89879,
                            9.99629
                        ],
                        [
                            50.88659,
                            10.09665
                        ],
                        [
                            50.90397,
                            10.18274
                        ],
                        [
                            50.90246,
                            10.31376
                        ],
                        [
                            50.93951,
                            10.34373
                        ],
                        [
                            51.0918,
                            10.40699
                        ],
                        [
                            51.22961,
                            10.42443
                        ],
                        [
                            51.275,
                            10.3781
                        ],
                        [
                            51.37208,
                            10.3684
                        ],
                        [
                            51.41252,
                            10.4407
                        ],
                        [
                            51.38733,
                            10.47778
                        ],
                        [
                            51.30589,
                            10.47637
                        ],
                        [
                            51.20679,
                            10.5284
                        ],
                        [
                            51.23285,
                            10.43445
                        ],
                        [
                            51.13673,
                            10.43105
                        ],
                        [
                            51.08449,
                            10.46602
                        ],
                        [
                            51.10645,
                            10.5412
                        ],
                        [
                            51.16855,
                            10.57541
                        ],
                        [
                            51.12771,
                            10.71525
                        ],
                        [
                            51.11877,
                            10.94832
                        ],
                        [
                            51.1347,
                            11.03887
                        ],
                        [
                            51.1796,
                            11.1425
                        ],
                        [
                            51.11232,
                            11.16201
                        ],
                        [
                            51.07777,
                            11.23746
                        ],
                        [
                            51.08231,
                            11.31894
                        ],
                        [
                            51.11425,
                            11.40345
                        ],
                        [
                            51.12641,
                            11.50097
                        ],
                        [
                            51.25367,
                            11.67486
                        ],
                        [
                            51.2828,
                            11.80601
                        ],
                        [
                            51.14204,
                            11.87191
                        ],
                        [
                            51.05538,
                            11.87415
                        ],
                        [
                            50.97313,
                            11.91976
                        ],
                        [
                            50.85233,
                            11.95062
                        ],
                        [
                            50.79804,
                            11.98349
                        ],
                        [
                            50.6845,
                            11.93842
                        ],
                        [
                            50.63536,
                            11.94101
                        ],
                        [
                            50.5676,
                            11.90048
                        ],
                        [
                            50.50488,
                            11.75216
                        ],
                        [
                            50.44793,
                            11.68689
                        ],
                        [
                            50.26639,
                            11.58655
                        ],
                        [
                            50.07024,
                            11.50821
                        ],
                        [
                            49.94271,
                            11.51337
                        ],
                        [
                            49.82544,
                            11.46092
                        ],
                        [
                            49.69025,
                            11.47845
                        ],
                        [
                            49.55146,
                            11.44325
                        ],
                        [
                            49.5112,
                            11.38539
                        ],
                        [
                            49.43199,
                            11.33947
                        ],
                        [
                            49.30325,
                            11.33374
                        ],
                        [
                            49.25034,
                            11.30293
                        ],
                        [
                            48.96085,
                            11.24108
                        ],
                        [
                            48.88723,
                            11.24704
                        ],
                        [
                            48.66164,
                            11.32322
                        ],
                        [
                            48.52473,
                            11.3091
                        ],
                        [
                            48.46764,
                            11.28431
                        ],
                        [
                            48.35611,
                            11.26861
                        ],
                        [
                            48.30637,
                            11.22388
                        ],
                        [
                            48.23913,
                            11.20345
                        ],
                        [
                            48.16489,
                            11.13897
                        ],
                        [
                            47.9648,
                            11.11516
                        ],
                        [
                            47.7948,
                            11.12061
                        ],
                        [
                            47.70659,
                            11.09293
                        ],
                        [
                            47.63127,
                            11.11499
                        ],
                        [
                            47.51178,
                            11.18291
                        ],
                        [
                            47.41233,
                            11.17603
                        ],
                        [
                            47.15173,
                            11.06346
                        ],
                        [
                            47.09696,
                            10.98634
                        ],
                        [
                            47.01164,
                            10.96017
                        ],
                        [
                            46.80928,
                            10.82338
                        ],
                        [
                            46.62301,
                            10.73005
                        ],
                        [
                            46.5322,
                            10.71667
                        ],
                        [
                            46.43745,
                            10.68283
                        ],
                        [
                            46.35934,
                            10.68763
                        ],
                        [
                            46.26849,
                            10.76271
                        ],
                        [
                            46.20307,
                            10.78186
                        ],
                        [
                            46.09928,
                            10.76455
                        ],
                        [
                            45.98191,
                            10.77867
                        ],
                        [
                            45.81086,
                            10.86338
                        ],
                        [
                            45.6679,
                            10.78196
                        ],
                        [
                            45.59819,
                            10.7619
                        ],
                        [
                            45.57018,
                            10.72165
                        ],
                        [
                            45.4635,
                            10.66649
                        ],
                        [
                            45.32355,
                            10.6602
                        ],
                        [
                            45.23526,
                            10.5633
                        ],
                        [
                            45.08731,
                            10.50706
                        ],
                        [
                            44.95077,
                            10.41098
                        ],
                        [
                            44.74944,
                            10.41782
                        ],
                        [
                            44.56808,
                            10.37932
                        ],
                        [
                            44.45559,
                            10.39984
                        ],
                        [
                            44.40563,
                            10.3922
                        ],
                        [
                            44.2835,
                            10.43521
                        ],
                        [
                            44.20062,
                            10.50712
                        ],
                        [
                            43.89302,
                            10.73273
                        ],
                        [
                            43.77368,
                            10.85009
                        ],
                        [
                            43.65958,
                            10.98479
                        ],
                        [
                            43.57759,
                            11.12108
                        ],
                        [
                            43.52143,
                            11.18977
                        ],
                        [
                            43.48013,
                            11.32613
                        ],
                        [
                            43.38582,
                            11.38153
                        ],
                        [
                            43.31137,
                            11.46211
                        ],
                        [
                            43.26032,
                            11.46059
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "ZAF",
                "Country": "South Africa",
                "Total_3GHG": 1.04,
                "Total_3GHG_timeseries": [
                    1.3434e-06,
                    2.8111e-06,
                    4.3906e-06,
                    6.0868e-06,
                    7.8891e-06,
                    9.8022e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0053,
                    0.0054,
                    0.0056,
                    0.0057,
                    0.0058,
                    0.006,
                    0.0061,
                    0.0063,
                    0.0065,
                    0.0067,
                    0.0069,
                    0.0071,
                    0.0073,
                    0.0075,
                    0.0078,
                    0.008,
                    0.0082,
                    0.0085,
                    0.0087,
                    0.009,
                    0.0092,
                    0.0095,
                    0.0097,
                    0.01,
                    0.0102,
                    0.0105,
                    0.0108,
                    0.011,
                    0.0113,
                    0.0116,
                    0.0118,
                    0.0121,
                    0.0124,
                    0.0126,
                    0.0129,
                    0.0132,
                    0.0135,
                    0.0138,
                    0.014,
                    0.0143,
                    0.0146,
                    0.0148,
                    0.0151,
                    0.0154,
                    0.0156,
                    0.0159,
                    0.0161,
                    0.0163,
                    0.0166,
                    0.0168,
                    0.017
                ],
                "Fossil_3GHG": 1.26,
                "Fossil_3GHG_timeseries": [
                    4.3975e-07,
                    9.0544e-07,
                    1.3973e-06,
                    1.9155e-06,
                    2.4602e-06,
                    3.0318e-06,
                    3.6303e-06,
                    4.256e-06,
                    4.909e-06,
                    5.5897e-06,
                    6.2967e-06,
                    7.0305e-06,
                    7.7913e-06,
                    8.5794e-06,
                    9.3951e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0035,
                    0.0036,
                    0.0038,
                    0.004,
                    0.0042,
                    0.0044,
                    0.0046,
                    0.0048,
                    0.005,
                    0.0052,
                    0.0055,
                    0.0057,
                    0.0059,
                    0.0061,
                    0.0063,
                    0.0065,
                    0.0068,
                    0.007,
                    0.0072,
                    0.0075,
                    0.0077,
                    0.008,
                    0.0082,
                    0.0084,
                    0.0087,
                    0.0089,
                    0.0092,
                    0.0094,
                    0.0097,
                    0.01,
                    0.0102,
                    0.0105,
                    0.0107,
                    0.011,
                    0.0113,
                    0.0115,
                    0.0118,
                    0.012,
                    0.0123,
                    0.0125,
                    0.0127,
                    0.013,
                    0.0132,
                    0.0134
                ],
                "Land_3GHG": 0.63,
                "Land_3GHG_timeseries": [
                    9.0368e-07,
                    1.9057e-06,
                    2.9934e-06,
                    4.1713e-06,
                    5.4288e-06,
                    6.7704e-06,
                    8.1934e-06,
                    9.6961e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0035,
                    0.0035,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0036
                ],
                "Total_CO2": 1.06,
                "Total_CO2_timeseries": [
                    4.6658e-07,
                    9.608e-07,
                    1.4704e-06,
                    2.0001e-06,
                    2.5398e-06,
                    3.0944e-06,
                    3.6619e-06,
                    4.2414e-06,
                    4.8291e-06,
                    5.5696e-06,
                    6.3846e-06,
                    7.2488e-06,
                    8.1512e-06,
                    9.0738e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0047,
                    0.0048,
                    0.005,
                    0.0051,
                    0.0053,
                    0.0055,
                    0.0056,
                    0.0058,
                    0.006,
                    0.0061,
                    0.0063,
                    0.0065,
                    0.0066,
                    0.0068,
                    0.007,
                    0.0072,
                    0.0074,
                    0.0076,
                    0.0078,
                    0.0079,
                    0.0081,
                    0.0083,
                    0.0085,
                    0.0087,
                    0.009,
                    0.0092,
                    0.0094,
                    0.0096,
                    0.0098,
                    0.01,
                    0.0102,
                    0.0105,
                    0.0107,
                    0.0109,
                    0.0111,
                    0.0113,
                    0.0115,
                    0.0117,
                    0.0119,
                    0.012
                ],
                "Fossil_CO2": 1.27,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    9.9e-09,
                    2.64e-08,
                    4.785e-08,
                    6.93e-08,
                    1.056e-07,
                    1.65e-07,
                    2.9865e-07,
                    4.323e-07,
                    6.4845e-07,
                    1.4586e-06,
                    2.5542e-06,
                    4.0574e-06,
                    5.9746e-06,
                    8.1263e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.003,
                    0.0031,
                    0.0033,
                    0.0034,
                    0.0036,
                    0.0037,
                    0.0039,
                    0.004,
                    0.0042,
                    0.0043,
                    0.0045,
                    0.0046,
                    0.0048,
                    0.005,
                    0.0051,
                    0.0053,
                    0.0055,
                    0.0056,
                    0.0058,
                    0.006,
                    0.0062,
                    0.0064,
                    0.0066,
                    0.0068,
                    0.007,
                    0.0072,
                    0.0074,
                    0.0076,
                    0.0078,
                    0.0081,
                    0.0083,
                    0.0085,
                    0.0087,
                    0.0089,
                    0.0091,
                    0.0093,
                    0.0095,
                    0.0097,
                    0.0098
                ],
                "Land_CO2": 0.61,
                "Land_CO2_timeseries": [
                    4.6658e-07,
                    9.608e-07,
                    1.4704e-06,
                    2.0001e-06,
                    2.5398e-06,
                    3.0944e-06,
                    3.6619e-06,
                    4.2414e-06,
                    4.8291e-06,
                    5.5696e-06,
                    6.3846e-06,
                    7.2488e-06,
                    8.1512e-06,
                    9.0738e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022
                ],
                "Total_CH4": 1.01,
                "Total_CH4_timeseries": [
                    3.2754e-07,
                    7.4304e-07,
                    1.2468e-06,
                    1.839e-06,
                    2.5199e-06,
                    3.2898e-06,
                    4.1489e-06,
                    5.0975e-06,
                    6.136e-06,
                    7.2645e-06,
                    8.4797e-06,
                    9.7817e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.004,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0042,
                    0.0042
                ],
                "Fossil_CH4": 1.28,
                "Fossil_CH4_timeseries": [
                    1.7388e-07,
                    3.7076e-07,
                    5.9087e-07,
                    8.3448e-07,
                    1.1018e-06,
                    1.3932e-06,
                    1.7088e-06,
                    2.049e-06,
                    2.414e-06,
                    2.804e-06,
                    3.2182e-06,
                    3.6566e-06,
                    4.1198e-06,
                    4.6079e-06,
                    5.1212e-06,
                    5.6601e-06,
                    6.225e-06,
                    6.8161e-06,
                    7.4337e-06,
                    8.0765e-06,
                    8.7507e-06,
                    9.4566e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0033,
                    0.0033
                ],
                "Land_CH4": 0.57,
                "Land_CH4_timeseries": [
                    1.5366e-07,
                    3.7229e-07,
                    6.5589e-07,
                    1.0045e-06,
                    1.418e-06,
                    1.8966e-06,
                    2.4401e-06,
                    3.0486e-06,
                    3.722e-06,
                    4.4605e-06,
                    5.2615e-06,
                    6.1251e-06,
                    7.0513e-06,
                    8.0401e-06,
                    9.0915e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009
                ],
                "Total_N2O": 0.89,
                "Total_N2O_timeseries": [
                    5.4933e-07,
                    1.1073e-06,
                    1.6735e-06,
                    2.2477e-06,
                    2.8294e-06,
                    3.4181e-06,
                    4.0129e-06,
                    4.6132e-06,
                    5.218e-06,
                    5.8264e-06,
                    6.4377e-06,
                    7.0518e-06,
                    7.6686e-06,
                    8.2879e-06,
                    8.9098e-06,
                    9.5343e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Fossil_N2O": 0.95,
                "Fossil_N2O_timeseries": [
                    2.6587e-07,
                    5.3468e-07,
                    8.0639e-07,
                    1.081e-06,
                    1.3584e-06,
                    1.6386e-06,
                    1.9215e-06,
                    2.207e-06,
                    2.4951e-06,
                    2.7856e-06,
                    3.0785e-06,
                    3.3738e-06,
                    3.6715e-06,
                    3.9715e-06,
                    4.2739e-06,
                    4.5787e-06,
                    4.8858e-06,
                    5.1952e-06,
                    5.5071e-06,
                    5.8213e-06,
                    6.1385e-06,
                    6.4594e-06,
                    6.7848e-06,
                    7.1151e-06,
                    7.4505e-06,
                    7.7912e-06,
                    8.1369e-06,
                    8.4874e-06,
                    8.8421e-06,
                    9.2003e-06,
                    9.5615e-06,
                    9.9255e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_N2O": 0.87,
                "Land_N2O_timeseries": [
                    2.8345e-07,
                    5.7257e-07,
                    8.6712e-07,
                    1.1668e-06,
                    1.471e-06,
                    1.7795e-06,
                    2.0914e-06,
                    2.4062e-06,
                    2.7229e-06,
                    3.0408e-06,
                    3.3592e-06,
                    3.678e-06,
                    3.9971e-06,
                    4.3164e-06,
                    4.6359e-06,
                    4.9556e-06,
                    5.2755e-06,
                    5.5958e-06,
                    5.9165e-06,
                    6.2377e-06,
                    6.5644e-06,
                    6.9047e-06,
                    7.2649e-06,
                    7.6494e-06,
                    8.0607e-06,
                    8.4995e-06,
                    8.9644e-06,
                    9.4522e-06,
                    9.9578e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                16.45563,
                                -28.63472
                            ],
                            [
                                16.56671,
                                -28.72555
                            ],
                            [
                                16.6043,
                                -28.8727
                            ],
                            [
                                16.68616,
                                -28.9245
                            ],
                            [
                                16.74177,
                                -29.03385
                            ],
                            [
                                16.81522,
                                -29.09373
                            ],
                            [
                                16.84174,
                                -29.21632
                            ],
                            [
                                16.93581,
                                -29.36312
                            ],
                            [
                                16.96924,
                                -29.43704
                            ],
                            [
                                17.05449,
                                -29.68983
                            ],
                            [
                                17.05931,
                                -29.74965
                            ],
                            [
                                17.11892,
                                -29.93088
                            ],
                            [
                                17.15772,
                                -29.98274
                            ],
                            [
                                17.19457,
                                -30.1305
                            ],
                            [
                                17.25763,
                                -30.25753
                            ],
                            [
                                17.27596,
                                -30.33908
                            ],
                            [
                                17.44,
                                -30.5946
                            ],
                            [
                                17.47255,
                                -30.68302
                            ],
                            [
                                17.52236,
                                -30.73549
                            ],
                            [
                                17.60367,
                                -30.91264
                            ],
                            [
                                17.68119,
                                -31.00316
                            ],
                            [
                                17.74692,
                                -31.13806
                            ],
                            [
                                17.86537,
                                -31.26184
                            ],
                            [
                                17.88069,
                                -31.31901
                            ],
                            [
                                18.00987,
                                -31.47297
                            ],
                            [
                                18.09324,
                                -31.55498
                            ],
                            [
                                18.22078,
                                -31.74373
                            ],
                            [
                                18.23428,
                                -31.81912
                            ],
                            [
                                18.27822,
                                -31.90631
                            ],
                            [
                                18.26706,
                                -31.94063
                            ],
                            [
                                18.31249,
                                -32.06874
                            ],
                            [
                                18.31152,
                                -32.17329
                            ],
                            [
                                18.3437,
                                -32.28208
                            ],
                            [
                                18.31553,
                                -32.3221
                            ],
                            [
                                18.33395,
                                -32.46798
                            ],
                            [
                                18.28299,
                                -32.62663
                            ],
                            [
                                18.16244,
                                -32.75695
                            ],
                            [
                                18.0555,
                                -32.78054
                            ],
                            [
                                17.98028,
                                -32.72376
                            ],
                            [
                                17.92421,
                                -32.71855
                            ],
                            [
                                17.89226,
                                -32.80547
                            ],
                            [
                                17.87504,
                                -32.99577
                            ],
                            [
                                17.9159,
                                -33.04712
                            ],
                            [
                                17.99037,
                                -32.99936
                            ],
                            [
                                18.04151,
                                -33.05349
                            ],
                            [
                                17.95701,
                                -33.10811
                            ],
                            [
                                18.10641,
                                -33.24137
                            ],
                            [
                                18.16633,
                                -33.36896
                            ],
                            [
                                18.27465,
                                -33.44615
                            ],
                            [
                                18.35344,
                                -33.5796
                            ],
                            [
                                18.42024,
                                -33.65881
                            ],
                            [
                                18.48439,
                                -33.88533
                            ],
                            [
                                18.37757,
                                -33.92761
                            ],
                            [
                                18.31342,
                                -34.03786
                            ],
                            [
                                18.36462,
                                -34.06064
                            ],
                            [
                                18.32223,
                                -34.14796
                            ],
                            [
                                18.36846,
                                -34.19522
                            ],
                            [
                                18.38238,
                                -34.27084
                            ],
                            [
                                18.45523,
                                -34.33976
                            ],
                            [
                                18.47349,
                                -34.23225
                            ],
                            [
                                18.42826,
                                -34.18384
                            ],
                            [
                                18.43752,
                                -34.13804
                            ],
                            [
                                18.51067,
                                -34.09689
                            ],
                            [
                                18.71395,
                                -34.07349
                            ],
                            [
                                18.81388,
                                -34.10316
                            ],
                            [
                                18.86276,
                                -34.15797
                            ],
                            [
                                18.81504,
                                -34.30201
                            ],
                            [
                                18.82809,
                                -34.38434
                            ],
                            [
                                19.04144,
                                -34.34319
                            ],
                            [
                                19.12183,
                                -34.41056
                            ],
                            [
                                19.21454,
                                -34.43588
                            ],
                            [
                                19.28135,
                                -34.41314
                            ],
                            [
                                19.34557,
                                -34.46844
                            ],
                            [
                                19.37604,
                                -34.53906
                            ],
                            [
                                19.33165,
                                -34.60179
                            ],
                            [
                                19.4122,
                                -34.60963
                            ],
                            [
                                19.63154,
                                -34.75806
                            ],
                            [
                                19.86955,
                                -34.76764
                            ],
                            [
                                20.00331,
                                -34.83164
                            ],
                            [
                                20.05949,
                                -34.80209
                            ],
                            [
                                20.06882,
                                -34.74719
                            ],
                            [
                                20.39719,
                                -34.57049
                            ],
                            [
                                20.43093,
                                -34.52434
                            ],
                            [
                                20.5356,
                                -34.47001
                            ],
                            [
                                20.64241,
                                -34.45084
                            ],
                            [
                                20.81593,
                                -34.47005
                            ],
                            [
                                20.89837,
                                -34.37539
                            ],
                            [
                                21.00164,
                                -34.36562
                            ],
                            [
                                21.1251,
                                -34.38207
                            ],
                            [
                                21.30249,
                                -34.43719
                            ],
                            [
                                21.37342,
                                -34.41973
                            ],
                            [
                                21.45307,
                                -34.36794
                            ],
                            [
                                21.58104,
                                -34.36402
                            ],
                            [
                                21.701,
                                -34.39444
                            ],
                            [
                                21.7997,
                                -34.38188
                            ],
                            [
                                21.90806,
                                -34.34012
                            ],
                            [
                                21.91608,
                                -34.26627
                            ],
                            [
                                21.9616,
                                -34.22728
                            ],
                            [
                                22.14299,
                                -34.19528
                            ],
                            [
                                22.1275,
                                -34.11419
                            ],
                            [
                                22.21905,
                                -34.06233
                            ],
                            [
                                22.48395,
                                -34.04907
                            ],
                            [
                                22.55763,
                                -33.99987
                            ],
                            [
                                22.79217,
                                -34.03108
                            ],
                            [
                                22.9709,
                                -34.08811
                            ],
                            [
                                23.1932,
                                -34.08518
                            ],
                            [
                                23.37565,
                                -34.1025
                            ],
                            [
                                23.4087,
                                -34.02241
                            ],
                            [
                                23.55792,
                                -33.98339
                            ],
                            [
                                23.65185,
                                -33.98147
                            ],
                            [
                                23.77537,
                                -34.00721
                            ],
                            [
                                24.18988,
                                -34.05978
                            ],
                            [
                                24.31113,
                                -34.10085
                            ],
                            [
                                24.38205,
                                -34.1045
                            ],
                            [
                                24.47439,
                                -34.16078
                            ],
                            [
                                24.60371,
                                -34.18967
                            ],
                            [
                                24.65288,
                                -34.1744
                            ],
                            [
                                24.8335,
                                -34.2117
                            ],
                            [
                                24.84079,
                                -34.14759
                            ],
                            [
                                24.92124,
                                -34.07851
                            ],
                            [
                                24.93204,
                                -34.01184
                            ],
                            [
                                24.97551,
                                -33.98534
                            ],
                            [
                                25.12636,
                                -33.96257
                            ],
                            [
                                25.21271,
                                -33.96913
                            ],
                            [
                                25.40904,
                                -34.0349
                            ],
                            [
                                25.58799,
                                -34.04986
                            ],
                            [
                                25.6737,
                                -33.98665
                            ],
                            [
                                25.61446,
                                -33.94776
                            ],
                            [
                                25.63302,
                                -33.8655
                            ],
                            [
                                25.7002,
                                -33.79384
                            ],
                            [
                                25.78954,
                                -33.74372
                            ],
                            [
                                25.90653,
                                -33.71325
                            ],
                            [
                                26.04206,
                                -33.7053
                            ],
                            [
                                26.19019,
                                -33.72688
                            ],
                            [
                                26.28987,
                                -33.76201
                            ],
                            [
                                26.46703,
                                -33.7721
                            ],
                            [
                                26.55476,
                                -33.74868
                            ],
                            [
                                26.74255,
                                -33.65342
                            ],
                            [
                                26.86605,
                                -33.62561
                            ],
                            [
                                26.93911,
                                -33.58151
                            ],
                            [
                                27.11014,
                                -33.52425
                            ],
                            [
                                27.35674,
                                -33.36387
                            ],
                            [
                                27.60525,
                                -33.21929
                            ],
                            [
                                27.73179,
                                -33.11987
                            ],
                            [
                                27.91719,
                                -33.03062
                            ],
                            [
                                27.96132,
                                -32.97913
                            ],
                            [
                                28.07773,
                                -32.9122
                            ],
                            [
                                28.11953,
                                -32.82938
                            ],
                            [
                                28.17071,
                                -32.78964
                            ],
                            [
                                28.36909,
                                -32.70629
                            ],
                            [
                                28.43336,
                                -32.63313
                            ],
                            [
                                28.51016,
                                -32.60283
                            ],
                            [
                                28.60873,
                                -32.49843
                            ],
                            [
                                28.74441,
                                -32.39348
                            ],
                            [
                                28.78631,
                                -32.34282
                            ],
                            [
                                28.88083,
                                -32.27996
                            ],
                            [
                                29.0186,
                                -32.12472
                            ],
                            [
                                29.06168,
                                -32.10026
                            ],
                            [
                                29.18345,
                                -31.95219
                            ],
                            [
                                29.42687,
                                -31.69024
                            ],
                            [
                                29.48747,
                                -31.67163
                            ],
                            [
                                29.62261,
                                -31.5858
                            ],
                            [
                                29.74125,
                                -31.46437
                            ],
                            [
                                29.83789,
                                -31.44008
                            ],
                            [
                                29.95563,
                                -31.3457
                            ],
                            [
                                30.2242,
                                -31.06032
                            ],
                            [
                                30.30761,
                                -30.93871
                            ],
                            [
                                30.39209,
                                -30.84448
                            ],
                            [
                                30.54307,
                                -30.63055
                            ],
                            [
                                30.70565,
                                -30.37255
                            ],
                            [
                                30.88976,
                                -30.05319
                            ],
                            [
                                31.03274,
                                -29.9117
                            ],
                            [
                                31.0472,
                                -29.79773
                            ],
                            [
                                31.12913,
                                -29.65255
                            ],
                            [
                                31.34272,
                                -29.38116
                            ],
                            [
                                31.45454,
                                -29.26757
                            ],
                            [
                                31.56976,
                                -29.16918
                            ],
                            [
                                31.759,
                                -28.97027
                            ],
                            [
                                32.01149,
                                -28.87699
                            ],
                            [
                                32.35649,
                                -28.58104
                            ],
                            [
                                32.39887,
                                -28.52575
                            ],
                            [
                                32.43445,
                                -28.36231
                            ],
                            [
                                32.55639,
                                -28.14451
                            ],
                            [
                                32.59413,
                                -27.93858
                            ],
                            [
                                32.60947,
                                -27.78105
                            ],
                            [
                                32.71439,
                                -27.42999
                            ],
                            [
                                32.86669,
                                -27.01615
                            ],
                            [
                                32.89152,
                                -26.85833
                            ],
                            [
                                32.84763,
                                -26.86805
                            ],
                            [
                                32.35484,
                                -26.861
                            ],
                            [
                                32.22658,
                                -26.83282
                            ],
                            [
                                32.13366,
                                -26.83498
                            ],
                            [
                                32.10045,
                                -26.80715
                            ],
                            [
                                32.0132,
                                -26.81444
                            ],
                            [
                                31.98334,
                                -27.05837
                            ],
                            [
                                31.9746,
                                -27.31618
                            ],
                            [
                                31.50179,
                                -27.31511
                            ],
                            [
                                31.15156,
                                -27.19509
                            ],
                            [
                                31.06876,
                                -27.09781
                            ],
                            [
                                30.97619,
                                -27.01413
                            ],
                            [
                                30.98599,
                                -26.93268
                            ],
                            [
                                30.91095,
                                -26.84679
                            ],
                            [
                                30.81285,
                                -26.82596
                            ],
                            [
                                30.79774,
                                -26.72059
                            ],
                            [
                                30.79573,
                                -26.56506
                            ],
                            [
                                30.82082,
                                -26.44593
                            ],
                            [
                                30.89708,
                                -26.32246
                            ],
                            [
                                30.96696,
                                -26.25952
                            ],
                            [
                                31.1178,
                                -25.98637
                            ],
                            [
                                31.14403,
                                -25.90652
                            ],
                            [
                                31.26159,
                                -25.81647
                            ],
                            [
                                31.31863,
                                -25.74555
                            ],
                            [
                                31.42566,
                                -25.72057
                            ],
                            [
                                31.86935,
                                -25.99792
                            ],
                            [
                                31.98213,
                                -25.95205
                            ],
                            [
                                31.93807,
                                -25.83085
                            ],
                            [
                                32.01255,
                                -25.63768
                            ],
                            [
                                31.98929,
                                -25.44544
                            ],
                            [
                                32.02489,
                                -25.37267
                            ],
                            [
                                32.04428,
                                -25.12604
                            ],
                            [
                                32.0011,
                                -24.68219
                            ],
                            [
                                32.01144,
                                -24.47614
                            ],
                            [
                                31.98672,
                                -24.30244
                            ],
                            [
                                31.91349,
                                -24.18986
                            ],
                            [
                                31.89172,
                                -24.00184
                            ],
                            [
                                31.87462,
                                -23.95158
                            ],
                            [
                                31.7617,
                                -23.87948
                            ],
                            [
                                31.69573,
                                -23.72082
                            ],
                            [
                                31.6888,
                                -23.61923
                            ],
                            [
                                31.56612,
                                -23.48547
                            ],
                            [
                                31.54583,
                                -23.40272
                            ],
                            [
                                31.5582,
                                -23.1774
                            ],
                            [
                                31.3101,
                                -22.43587
                            ],
                            [
                                31.31127,
                                -22.41774
                            ],
                            [
                                31.25068,
                                -22.35796
                            ],
                            [
                                31.1449,
                                -22.32709
                            ],
                            [
                                31.07723,
                                -22.34382
                            ],
                            [
                                30.93035,
                                -22.30031
                            ],
                            [
                                30.81017,
                                -22.29274
                            ],
                            [
                                30.70896,
                                -22.31501
                            ],
                            [
                                30.48442,
                                -22.31449
                            ],
                            [
                                30.40579,
                                -22.33998
                            ],
                            [
                                30.27428,
                                -22.34446
                            ],
                            [
                                30.22395,
                                -22.2944
                            ],
                            [
                                30.12474,
                                -22.30825
                            ],
                            [
                                30.0092,
                                -22.23001
                            ],
                            [
                                29.87581,
                                -22.19025
                            ],
                            [
                                29.7641,
                                -22.14138
                            ],
                            [
                                29.64762,
                                -22.12718
                            ],
                            [
                                29.51818,
                                -22.17569
                            ],
                            [
                                29.45962,
                                -22.1677
                            ],
                            [
                                29.36078,
                                -22.19663
                            ],
                            [
                                29.18866,
                                -22.18572
                            ],
                            [
                                29.15039,
                                -22.21375
                            ],
                            [
                                29.01477,
                                -22.23109
                            ],
                            [
                                28.96152,
                                -22.33281
                            ],
                            [
                                28.97071,
                                -22.37508
                            ],
                            [
                                28.91609,
                                -22.45844
                            ],
                            [
                                28.86377,
                                -22.44763
                            ],
                            [
                                28.82494,
                                -22.48674
                            ],
                            [
                                28.70857,
                                -22.51446
                            ],
                            [
                                28.62752,
                                -22.55928
                            ],
                            [
                                28.51217,
                                -22.58608
                            ],
                            [
                                28.34934,
                                -22.57682
                            ],
                            [
                                28.20193,
                                -22.67175
                            ],
                            [
                                28.16309,
                                -22.75329
                            ],
                            [
                                28.0441,
                                -22.85233
                            ],
                            [
                                28.04312,
                                -22.91068
                            ],
                            [
                                27.94001,
                                -22.97067
                            ],
                            [
                                27.9313,
                                -23.06165
                            ],
                            [
                                27.78742,
                                -23.14946
                            ],
                            [
                                27.7205,
                                -23.23995
                            ],
                            [
                                27.68983,
                                -23.20742
                            ],
                            [
                                27.60957,
                                -23.22419
                            ],
                            [
                                27.56384,
                                -23.35178
                            ],
                            [
                                27.51991,
                                -23.38868
                            ],
                            [
                                27.33188,
                                -23.40769
                            ],
                            [
                                27.2764,
                                -23.47895
                            ],
                            [
                                27.21302,
                                -23.4931
                            ],
                            [
                                27.18906,
                                -23.53941
                            ],
                            [
                                27.00858,
                                -23.64532
                            ],
                            [
                                26.97814,
                                -23.70695
                            ],
                            [
                                26.93917,
                                -23.85425
                            ],
                            [
                                26.95397,
                                -23.87736
                            ],
                            [
                                26.91577,
                                -23.9847
                            ],
                            [
                                26.85313,
                                -24.2695
                            ],
                            [
                                26.67936,
                                -24.34828
                            ],
                            [
                                26.66853,
                                -24.38905
                            ],
                            [
                                26.59621,
                                -24.4089
                            ],
                            [
                                26.51884,
                                -24.48857
                            ],
                            [
                                26.47481,
                                -24.58762
                            ],
                            [
                                26.42083,
                                -24.63477
                            ],
                            [
                                26.02444,
                                -24.71876
                            ],
                            [
                                25.93736,
                                -24.72078
                            ],
                            [
                                25.86215,
                                -24.77161
                            ],
                            [
                                25.89074,
                                -24.85564
                            ],
                            [
                                25.85823,
                                -24.95879
                            ],
                            [
                                25.74815,
                                -25.22938
                            ],
                            [
                                25.70877,
                                -25.2838
                            ],
                            [
                                25.64914,
                                -25.50863
                            ],
                            [
                                25.5819,
                                -25.6336
                            ],
                            [
                                25.42367,
                                -25.73499
                            ],
                            [
                                25.34334,
                                -25.76729
                            ],
                            [
                                25.13038,
                                -25.75796
                            ],
                            [
                                25.04375,
                                -25.72307
                            ],
                            [
                                24.90199,
                                -25.81195
                            ],
                            [
                                24.68618,
                                -25.82282
                            ],
                            [
                                24.44907,
                                -25.73828
                            ],
                            [
                                24.37065,
                                -25.76229
                            ],
                            [
                                24.2909,
                                -25.7236
                            ],
                            [
                                24.19165,
                                -25.62267
                            ],
                            [
                                24.05855,
                                -25.65187
                            ],
                            [
                                23.97312,
                                -25.61791
                            ],
                            [
                                23.91363,
                                -25.62722
                            ],
                            [
                                23.815,
                                -25.54617
                            ],
                            [
                                23.75207,
                                -25.4693
                            ],
                            [
                                23.63975,
                                -25.43016
                            ],
                            [
                                23.55785,
                                -25.35624
                            ],
                            [
                                23.44232,
                                -25.27701
                            ],
                            [
                                23.41758,
                                -25.30758
                            ],
                            [
                                23.27669,
                                -25.26961
                            ],
                            [
                                23.19865,
                                -25.27318
                            ],
                            [
                                23.08287,
                                -25.32453
                            ],
                            [
                                23.01161,
                                -25.29575
                            ],
                            [
                                22.97064,
                                -25.37941
                            ],
                            [
                                22.91281,
                                -25.41965
                            ],
                            [
                                22.82072,
                                -25.58341
                            ],
                            [
                                22.82466,
                                -25.69509
                            ],
                            [
                                22.77777,
                                -25.7342
                            ],
                            [
                                22.72152,
                                -25.90198
                            ],
                            [
                                22.72294,
                                -26.01986
                            ],
                            [
                                22.58216,
                                -26.14768
                            ],
                            [
                                22.54258,
                                -26.22884
                            ],
                            [
                                22.47567,
                                -26.20827
                            ],
                            [
                                22.4222,
                                -26.23049
                            ],
                            [
                                22.35317,
                                -26.32924
                            ],
                            [
                                22.25407,
                                -26.35329
                            ],
                            [
                                22.19989,
                                -26.3981
                            ],
                            [
                                22.15949,
                                -26.50859
                            ],
                            [
                                22.04657,
                                -26.63354
                            ],
                            [
                                21.94366,
                                -26.67241
                            ],
                            [
                                21.81785,
                                -26.66612
                            ],
                            [
                                21.78071,
                                -26.68593
                            ],
                            [
                                21.78124,
                                -26.79768
                            ],
                            [
                                21.71263,
                                -26.85236
                            ],
                            [
                                21.52479,
                                -26.86076
                            ],
                            [
                                21.42636,
                                -26.82717
                            ],
                            [
                                21.21503,
                                -26.84954
                            ],
                            [
                                21.1429,
                                -26.87303
                            ],
                            [
                                21.02023,
                                -26.84804
                            ],
                            [
                                20.97381,
                                -26.80969
                            ],
                            [
                                20.89989,
                                -26.79682
                            ],
                            [
                                20.72341,
                                -26.87211
                            ],
                            [
                                20.66127,
                                -26.84216
                            ],
                            [
                                20.61866,
                                -26.7123
                            ],
                            [
                                20.62942,
                                -26.59358
                            ],
                            [
                                20.60568,
                                -26.53199
                            ],
                            [
                                20.62326,
                                -26.4419
                            ],
                            [
                                20.68932,
                                -26.39651
                            ],
                            [
                                20.72064,
                                -26.33625
                            ],
                            [
                                20.78706,
                                -26.27348
                            ],
                            [
                                20.82143,
                                -26.18003
                            ],
                            [
                                20.86091,
                                -26.13306
                            ],
                            [
                                20.81853,
                                -26.00474
                            ],
                            [
                                20.78849,
                                -25.80752
                            ],
                            [
                                20.73493,
                                -25.76729
                            ],
                            [
                                20.67733,
                                -25.67452
                            ],
                            [
                                20.69227,
                                -25.5849
                            ],
                            [
                                20.63269,
                                -25.51659
                            ],
                            [
                                20.64486,
                                -25.47517
                            ],
                            [
                                20.56561,
                                -25.38391
                            ],
                            [
                                20.45133,
                                -25.19358
                            ],
                            [
                                20.38092,
                                -25.03223
                            ],
                            [
                                20.29465,
                                -24.97628
                            ],
                            [
                                20.26144,
                                -24.92464
                            ],
                            [
                                20.12333,
                                -24.87952
                            ],
                            [
                                19.99948,
                                -24.75195
                            ],
                            [
                                19.99956,
                                -25.30857
                            ],
                            [
                                19.99962,
                                -25.72045
                            ],
                            [
                                19.99984,
                                -27.28206
                            ],
                            [
                                19.99957,
                                -28.42638
                            ],
                            [
                                19.84754,
                                -28.46076
                            ],
                            [
                                19.81478,
                                -28.50665
                            ],
                            [
                                19.72729,
                                -28.49032
                            ],
                            [
                                19.66793,
                                -28.52942
                            ],
                            [
                                19.62435,
                                -28.5115
                            ],
                            [
                                19.54698,
                                -28.54445
                            ],
                            [
                                19.5023,
                                -28.60466
                            ],
                            [
                                19.46579,
                                -28.70617
                            ],
                            [
                                19.35134,
                                -28.74221
                            ],
                            [
                                19.26726,
                                -28.74835
                            ],
                            [
                                19.24139,
                                -28.80365
                            ],
                            [
                                19.28129,
                                -28.90824
                            ],
                            [
                                19.10448,
                                -28.9684
                            ],
                            [
                                18.93232,
                                -28.85656
                            ],
                            [
                                18.73103,
                                -28.83264
                            ],
                            [
                                18.63264,
                                -28.84063
                            ],
                            [
                                18.5122,
                                -28.88981
                            ],
                            [
                                18.42815,
                                -28.90033
                            ],
                            [
                                18.26381,
                                -28.87993
                            ],
                            [
                                18.18945,
                                -28.91707
                            ],
                            [
                                18.0769,
                                -28.87125
                            ],
                            [
                                17.9246,
                                -28.76927
                            ],
                            [
                                17.69438,
                                -28.7491
                            ],
                            [
                                17.61782,
                                -28.76321
                            ],
                            [
                                17.59967,
                                -28.69681
                            ],
                            [
                                17.49047,
                                -28.69433
                            ],
                            [
                                17.4122,
                                -28.71307
                            ],
                            [
                                17.4319,
                                -28.58285
                            ],
                            [
                                17.37905,
                                -28.56686
                            ],
                            [
                                17.33361,
                                -28.47582
                            ],
                            [
                                17.39048,
                                -28.43252
                            ],
                            [
                                17.40478,
                                -28.35656
                            ],
                            [
                                17.34478,
                                -28.23861
                            ],
                            [
                                17.21361,
                                -28.24647
                            ],
                            [
                                17.1827,
                                -28.2035
                            ],
                            [
                                17.19125,
                                -28.10781
                            ],
                            [
                                17.13678,
                                -28.0919
                            ],
                            [
                                17.08281,
                                -28.03378
                            ],
                            [
                                16.90076,
                                -28.07225
                            ],
                            [
                                16.88836,
                                -28.16958
                            ],
                            [
                                16.84554,
                                -28.16533
                            ],
                            [
                                16.82301,
                                -28.27068
                            ],
                            [
                                16.75516,
                                -28.30192
                            ],
                            [
                                16.80378,
                                -28.36245
                            ],
                            [
                                16.73623,
                                -28.49394
                            ],
                            [
                                16.68065,
                                -28.4709
                            ],
                            [
                                16.59964,
                                -28.53184
                            ],
                            [
                                16.49178,
                                -28.56733
                            ],
                            [
                                16.45563,
                                -28.63472
                            ]
                        ],
                        [
                            [
                                27.02982,
                                -29.61713
                            ],
                            [
                                27.0719,
                                -29.62444
                            ],
                            [
                                27.16344,
                                -29.55619
                            ],
                            [
                                27.25333,
                                -29.54793
                            ],
                            [
                                27.3679,
                                -29.4771
                            ],
                            [
                                27.43075,
                                -29.40464
                            ],
                            [
                                27.45027,
                                -29.3299
                            ],
                            [
                                27.54475,
                                -29.25488
                            ],
                            [
                                27.53039,
                                -29.21617
                            ],
                            [
                                27.62298,
                                -29.15088
                            ],
                            [
                                27.68122,
                                -29.07565
                            ],
                            [
                                27.68379,
                                -29.02619
                            ],
                            [
                                27.77339,
                                -28.92095
                            ],
                            [
                                27.87468,
                                -28.9143
                            ],
                            [
                                27.94388,
                                -28.85187
                            ],
                            [
                                28.03916,
                                -28.8724
                            ],
                            [
                                28.12259,
                                -28.74244
                            ],
                            [
                                28.19364,
                                -28.69072
                            ],
                            [
                                28.29205,
                                -28.70729
                            ],
                            [
                                28.3632,
                                -28.69777
                            ],
                            [
                                28.41393,
                                -28.6194
                            ],
                            [
                                28.58563,
                                -28.60281
                            ],
                            [
                                28.6534,
                                -28.57244
                            ],
                            [
                                28.70473,
                                -28.6102
                            ],
                            [
                                28.7376,
                                -28.68746
                            ],
                            [
                                28.80834,
                                -28.70353
                            ],
                            [
                                28.82994,
                                -28.75763
                            ],
                            [
                                28.91535,
                                -28.79514
                            ],
                            [
                                28.9991,
                                -28.91249
                            ],
                            [
                                29.2243,
                                -29.03604
                            ],
                            [
                                29.26114,
                                -29.08835
                            ],
                            [
                                29.32277,
                                -29.08425
                            ],
                            [
                                29.39156,
                                -29.19501
                            ],
                            [
                                29.46537,
                                -29.3514
                            ],
                            [
                                29.42706,
                                -29.43169
                            ],
                            [
                                29.30485,
                                -29.49594
                            ],
                            [
                                29.29986,
                                -29.62349
                            ],
                            [
                                29.18473,
                                -29.66518
                            ],
                            [
                                29.15002,
                                -29.72029
                            ],
                            [
                                29.1353,
                                -29.8539
                            ],
                            [
                                29.17426,
                                -29.91286
                            ],
                            [
                                29.04978,
                                -29.98928
                            ],
                            [
                                28.84893,
                                -30.09421
                            ],
                            [
                                28.68225,
                                -30.13805
                            ],
                            [
                                28.55732,
                                -30.11845
                            ],
                            [
                                28.47498,
                                -30.15637
                            ],
                            [
                                28.3744,
                                -30.16575
                            ],
                            [
                                28.31645,
                                -30.25237
                            ],
                            [
                                28.22438,
                                -30.29824
                            ],
                            [
                                28.27922,
                                -30.3623
                            ],
                            [
                                28.24111,
                                -30.41051
                            ],
                            [
                                28.16104,
                                -30.45257
                            ],
                            [
                                28.18549,
                                -30.49316
                            ],
                            [
                                28.16077,
                                -30.56134
                            ],
                            [
                                28.08932,
                                -30.64974
                            ],
                            [
                                27.92922,
                                -30.64164
                            ],
                            [
                                27.86482,
                                -30.61102
                            ],
                            [
                                27.75024,
                                -30.59423
                            ],
                            [
                                27.68767,
                                -30.52117
                            ],
                            [
                                27.62065,
                                -30.48271
                            ],
                            [
                                27.57104,
                                -30.40091
                            ],
                            [
                                27.51437,
                                -30.37677
                            ],
                            [
                                27.46328,
                                -30.3118
                            ],
                            [
                                27.40892,
                                -30.33133
                            ],
                            [
                                27.37481,
                                -30.26947
                            ],
                            [
                                27.40229,
                                -30.14197
                            ],
                            [
                                27.33572,
                                -30.1503
                            ],
                            [
                                27.31194,
                                -30.06864
                            ],
                            [
                                27.23696,
                                -30.00296
                            ],
                            [
                                27.12345,
                                -29.7558
                            ],
                            [
                                27.03006,
                                -29.64694
                            ],
                            [
                                27.02982,
                                -29.61713
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                37.58174,
                                -46.93544
                            ],
                            [
                                37.65703,
                                -46.97314
                            ],
                            [
                                37.77775,
                                -46.96247
                            ],
                            [
                                37.82958,
                                -46.98123
                            ],
                            [
                                37.90659,
                                -46.89972
                            ],
                            [
                                37.84304,
                                -46.85138
                            ],
                            [
                                37.70765,
                                -46.82375
                            ],
                            [
                                37.59782,
                                -46.89613
                            ],
                            [
                                37.58174,
                                -46.93544
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "KOR",
                "Country": "South Korea",
                "Total_3GHG": 0.68,
                "Total_3GHG_timeseries": [
                    3.4382e-06,
                    6.7246e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0031,
                    0.0032,
                    0.0034,
                    0.0035,
                    0.0037,
                    0.0039,
                    0.0041,
                    0.0043,
                    0.0045,
                    0.0047,
                    0.0049,
                    0.0051,
                    0.0053,
                    0.0056,
                    0.0058,
                    0.006,
                    0.0062,
                    0.0065,
                    0.0067,
                    0.007,
                    0.0072,
                    0.0075,
                    0.0078,
                    0.0081,
                    0.0084,
                    0.0087,
                    0.009,
                    0.0093,
                    0.0096,
                    0.0099,
                    0.0102,
                    0.0105,
                    0.0108,
                    0.011
                ],
                "Fossil_3GHG": 0.95,
                "Fossil_3GHG_timeseries": [
                    1.0885e-06,
                    2.1792e-06,
                    3.2721e-06,
                    4.3674e-06,
                    5.465e-06,
                    6.5649e-06,
                    7.6671e-06,
                    8.7717e-06,
                    9.8786e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0022,
                    0.0023,
                    0.0025,
                    0.0027,
                    0.0028,
                    0.003,
                    0.0032,
                    0.0035,
                    0.0036,
                    0.0038,
                    0.0041,
                    0.0043,
                    0.0045,
                    0.0048,
                    0.005,
                    0.0052,
                    0.0055,
                    0.0057,
                    0.0059,
                    0.0062,
                    0.0065,
                    0.0067,
                    0.007,
                    0.0073,
                    0.0076,
                    0.0079,
                    0.0083,
                    0.0086,
                    0.0089,
                    0.0092,
                    0.0095,
                    0.0098,
                    0.01
                ],
                "Land_3GHG": 0.17,
                "Land_3GHG_timeseries": [
                    2.3498e-06,
                    4.5454e-06,
                    6.7551e-06,
                    8.9538e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001
                ],
                "Total_CO2": 0.81,
                "Total_CO2_timeseries": [
                    2.0959e-06,
                    4.0366e-06,
                    5.9904e-06,
                    7.9324e-06,
                    9.8639e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0025,
                    0.0027,
                    0.0029,
                    0.003,
                    0.0032,
                    0.0034,
                    0.0036,
                    0.0038,
                    0.004,
                    0.0042,
                    0.0044,
                    0.0046,
                    0.0049,
                    0.0051,
                    0.0053,
                    0.0056,
                    0.0058,
                    0.0061,
                    0.0064,
                    0.0067,
                    0.007,
                    0.0072,
                    0.0075,
                    0.0078,
                    0.0081,
                    0.0084,
                    0.0087,
                    0.0089,
                    0.0092
                ],
                "Fossil_CO2": 1.13,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    3.472e-10,
                    3.472e-10,
                    3.472e-10,
                    3.472e-10,
                    4.0813e-09,
                    8.7706e-09,
                    1.4329e-08,
                    2.1276e-08,
                    2.9352e-08,
                    4.0902e-08,
                    5.5318e-08,
                    6.7302e-08,
                    6.7302e-08,
                    7.9113e-08,
                    9.3094e-08,
                    1.1124e-07,
                    1.3078e-07,
                    1.5076e-07,
                    1.7464e-07,
                    1.9974e-07,
                    2.3977e-07,
                    2.8276e-07,
                    3.2731e-07,
                    3.7863e-07,
                    4.376e-07,
                    4.9318e-07,
                    5.5206e-07,
                    6.2144e-07,
                    7.0325e-07,
                    8.1204e-07,
                    9.4e-07,
                    1.0902e-06,
                    1.2509e-06,
                    1.4659e-06,
                    1.7465e-06,
                    2.1075e-06,
                    2.5101e-06,
                    2.9545e-06,
                    3.3852e-06,
                    3.8403e-06,
                    3.8419e-06,
                    4.0613e-06,
                    4.4656e-06,
                    5.2179e-06,
                    6.198e-06,
                    7.1814e-06,
                    8.498e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0017,
                    0.0018,
                    0.002,
                    0.0021,
                    0.0023,
                    0.0025,
                    0.0027,
                    0.0029,
                    0.0031,
                    0.0033,
                    0.0035,
                    0.0037,
                    0.0039,
                    0.0042,
                    0.0044,
                    0.0046,
                    0.0049,
                    0.0051,
                    0.0054,
                    0.0057,
                    0.0059,
                    0.0062,
                    0.0065,
                    0.0068,
                    0.0071,
                    0.0074,
                    0.0077,
                    0.008,
                    0.0082,
                    0.0085,
                    0.0088
                ],
                "Land_CO2": 0.11,
                "Land_CO2_timeseries": [
                    2.0959e-06,
                    4.0366e-06,
                    5.9904e-06,
                    7.9324e-06,
                    9.8639e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Total_CH4": 0.37,
                "Total_CH4_timeseries": [
                    1.2718e-06,
                    2.5457e-06,
                    3.8216e-06,
                    5.0998e-06,
                    6.3801e-06,
                    7.6626e-06,
                    8.9475e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015
                ],
                "Fossil_CH4": 0.42,
                "Fossil_CH4_timeseries": [
                    1.0486e-06,
                    2.0988e-06,
                    3.1508e-06,
                    4.2046e-06,
                    5.2602e-06,
                    6.3176e-06,
                    7.3769e-06,
                    8.4382e-06,
                    9.5015e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011
                ],
                "Land_CH4": 0.29,
                "Land_CH4_timeseries": [
                    2.2323e-07,
                    4.4683e-07,
                    6.7081e-07,
                    8.9517e-07,
                    1.1199e-06,
                    1.345e-06,
                    1.5705e-06,
                    1.7964e-06,
                    2.0226e-06,
                    2.2492e-06,
                    2.4763e-06,
                    2.7036e-06,
                    2.9314e-06,
                    3.1596e-06,
                    3.3881e-06,
                    3.6171e-06,
                    3.8464e-06,
                    4.0761e-06,
                    4.3062e-06,
                    4.5366e-06,
                    4.757e-06,
                    4.9672e-06,
                    5.1674e-06,
                    5.3574e-06,
                    5.5373e-06,
                    5.7072e-06,
                    5.8669e-06,
                    6.0165e-06,
                    6.156e-06,
                    6.2854e-06,
                    6.4159e-06,
                    6.5474e-06,
                    6.6799e-06,
                    6.8135e-06,
                    6.9482e-06,
                    7.0839e-06,
                    7.2206e-06,
                    7.3584e-06,
                    7.4973e-06,
                    7.6372e-06,
                    7.788e-06,
                    7.9497e-06,
                    8.1224e-06,
                    8.306e-06,
                    8.5006e-06,
                    8.706e-06,
                    8.9224e-06,
                    9.1497e-06,
                    9.3879e-06,
                    9.6371e-06,
                    9.8906e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005
                ],
                "Total_N2O": 0.37,
                "Total_N2O_timeseries": [
                    7.0577e-08,
                    1.4232e-07,
                    2.1517e-07,
                    2.891e-07,
                    3.6402e-07,
                    4.3986e-07,
                    5.1651e-07,
                    5.9386e-07,
                    6.7178e-07,
                    7.5012e-07,
                    8.2879e-07,
                    9.0778e-07,
                    9.8706e-07,
                    1.0666e-06,
                    1.1465e-06,
                    1.2266e-06,
                    1.307e-06,
                    1.3877e-06,
                    1.4687e-06,
                    1.55e-06,
                    1.6325e-06,
                    1.7174e-06,
                    1.8058e-06,
                    1.8983e-06,
                    1.9954e-06,
                    2.0972e-06,
                    2.2035e-06,
                    2.3137e-06,
                    2.427e-06,
                    2.5423e-06,
                    2.6588e-06,
                    2.7765e-06,
                    2.895e-06,
                    3.0144e-06,
                    3.1346e-06,
                    3.2556e-06,
                    3.3773e-06,
                    3.4998e-06,
                    3.6231e-06,
                    3.7536e-06,
                    3.8854e-06,
                    4.0186e-06,
                    4.1535e-06,
                    4.2903e-06,
                    4.4293e-06,
                    4.5706e-06,
                    4.7143e-06,
                    4.8607e-06,
                    5.0097e-06,
                    5.1616e-06,
                    5.3165e-06,
                    5.4748e-06,
                    5.6368e-06,
                    5.8029e-06,
                    5.9733e-06,
                    6.1485e-06,
                    6.3286e-06,
                    6.5139e-06,
                    6.7048e-06,
                    6.9015e-06,
                    7.105e-06,
                    7.3168e-06,
                    7.5382e-06,
                    7.7701e-06,
                    8.013e-06,
                    8.2674e-06,
                    8.533e-06,
                    8.8096e-06,
                    9.0964e-06,
                    9.3926e-06,
                    9.6974e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_N2O": 0.71,
                "Fossil_N2O_timeseries": [
                    3.99e-08,
                    8.0347e-08,
                    1.2133e-07,
                    1.6283e-07,
                    2.0482e-07,
                    2.4727e-07,
                    2.9016e-07,
                    3.3345e-07,
                    3.7709e-07,
                    4.2103e-07,
                    4.6524e-07,
                    5.0973e-07,
                    5.5447e-07,
                    5.9948e-07,
                    6.4473e-07,
                    6.9025e-07,
                    7.3602e-07,
                    7.8206e-07,
                    8.2837e-07,
                    8.7495e-07,
                    9.2206e-07,
                    9.7015e-07,
                    1.0195e-06,
                    1.0705e-06,
                    1.1231e-06,
                    1.1774e-06,
                    1.2333e-06,
                    1.2907e-06,
                    1.3493e-06,
                    1.4087e-06,
                    1.4687e-06,
                    1.5292e-06,
                    1.5902e-06,
                    1.6516e-06,
                    1.7134e-06,
                    1.7757e-06,
                    1.8384e-06,
                    1.9015e-06,
                    1.965e-06,
                    2.0296e-06,
                    2.0947e-06,
                    2.1606e-06,
                    2.227e-06,
                    2.2942e-06,
                    2.362e-06,
                    2.4306e-06,
                    2.5e-06,
                    2.5701e-06,
                    2.641e-06,
                    2.7128e-06,
                    2.7855e-06,
                    2.8593e-06,
                    2.9342e-06,
                    3.0103e-06,
                    3.0877e-06,
                    3.1663e-06,
                    3.2462e-06,
                    3.3273e-06,
                    3.4097e-06,
                    3.4931e-06,
                    3.5777e-06,
                    3.6633e-06,
                    3.7498e-06,
                    3.8374e-06,
                    3.926e-06,
                    4.0156e-06,
                    4.1062e-06,
                    4.1979e-06,
                    4.2906e-06,
                    4.3845e-06,
                    4.4796e-06,
                    4.5761e-06,
                    4.674e-06,
                    4.7734e-06,
                    4.8743e-06,
                    4.9769e-06,
                    5.081e-06,
                    5.1867e-06,
                    5.2939e-06,
                    5.4025e-06,
                    5.5125e-06,
                    5.6239e-06,
                    5.7368e-06,
                    5.8511e-06,
                    5.967e-06,
                    6.0843e-06,
                    6.2031e-06,
                    6.3232e-06,
                    6.4447e-06,
                    6.5674e-06,
                    6.692e-06,
                    6.8197e-06,
                    6.9515e-06,
                    7.0879e-06,
                    7.2296e-06,
                    7.3768e-06,
                    7.5293e-06,
                    7.687e-06,
                    7.8494e-06,
                    8.0156e-06,
                    8.1856e-06,
                    8.36e-06,
                    8.5394e-06,
                    8.7242e-06,
                    8.9149e-06,
                    9.112e-06,
                    9.3158e-06,
                    9.5266e-06,
                    9.7447e-06,
                    9.9703e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_N2O": 0.24,
                "Land_N2O_timeseries": [
                    3.0677e-08,
                    6.1968e-08,
                    9.3845e-08,
                    1.2627e-07,
                    1.5921e-07,
                    1.9259e-07,
                    2.2635e-07,
                    2.6041e-07,
                    2.9469e-07,
                    3.2909e-07,
                    3.6355e-07,
                    3.9805e-07,
                    4.3259e-07,
                    4.6715e-07,
                    5.0173e-07,
                    5.3633e-07,
                    5.7095e-07,
                    6.0561e-07,
                    6.4032e-07,
                    6.7509e-07,
                    7.1044e-07,
                    7.4727e-07,
                    7.8625e-07,
                    8.2787e-07,
                    8.7238e-07,
                    9.1987e-07,
                    9.7018e-07,
                    1.023e-06,
                    1.0777e-06,
                    1.1336e-06,
                    1.1902e-06,
                    1.2473e-06,
                    1.3049e-06,
                    1.3628e-06,
                    1.4212e-06,
                    1.4799e-06,
                    1.5389e-06,
                    1.5983e-06,
                    1.6581e-06,
                    1.7241e-06,
                    1.7906e-06,
                    1.858e-06,
                    1.9264e-06,
                    1.9961e-06,
                    2.0672e-06,
                    2.1399e-06,
                    2.2144e-06,
                    2.2906e-06,
                    2.3687e-06,
                    2.4488e-06,
                    2.531e-06,
                    2.6155e-06,
                    2.7026e-06,
                    2.7926e-06,
                    2.8856e-06,
                    2.9821e-06,
                    3.0824e-06,
                    3.1866e-06,
                    3.2951e-06,
                    3.4083e-06,
                    3.5273e-06,
                    3.6535e-06,
                    3.7883e-06,
                    3.9326e-06,
                    4.087e-06,
                    4.2518e-06,
                    4.4268e-06,
                    4.6117e-06,
                    4.8058e-06,
                    5.0081e-06,
                    5.2178e-06,
                    5.4351e-06,
                    5.6597e-06,
                    5.8915e-06,
                    6.1303e-06,
                    6.3757e-06,
                    6.6273e-06,
                    6.8846e-06,
                    7.1472e-06,
                    7.4144e-06,
                    7.6858e-06,
                    7.9617e-06,
                    8.242e-06,
                    8.5263e-06,
                    8.8146e-06,
                    9.1063e-06,
                    9.401e-06,
                    9.6978e-06,
                    9.9962e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                126.66583,
                                37.83302
                            ],
                            [
                                126.60579,
                                37.75262
                            ],
                            [
                                126.52428,
                                37.71579
                            ],
                            [
                                126.53957,
                                37.64562
                            ],
                            [
                                126.66569,
                                37.53442
                            ],
                            [
                                126.59902,
                                37.48166
                            ],
                            [
                                126.66997,
                                37.39271
                            ],
                            [
                                126.75887,
                                37.33903
                            ],
                            [
                                126.75204,
                                37.25382
                            ],
                            [
                                126.66899,
                                37.23525
                            ],
                            [
                                126.68639,
                                37.11527
                            ],
                            [
                                126.76334,
                                37.11096
                            ],
                            [
                                126.74826,
                                37.04105
                            ],
                            [
                                126.9095,
                                36.91829
                            ],
                            [
                                126.82345,
                                36.87869
                            ],
                            [
                                126.77295,
                                36.97331
                            ],
                            [
                                126.67139,
                                36.96038
                            ],
                            [
                                126.589,
                                36.99225
                            ],
                            [
                                126.51133,
                                36.98604
                            ],
                            [
                                126.47036,
                                36.94104
                            ],
                            [
                                126.38811,
                                37.00318
                            ],
                            [
                                126.35675,
                                36.9419
                            ],
                            [
                                126.42172,
                                36.90108
                            ],
                            [
                                126.33667,
                                36.8096
                            ],
                            [
                                126.2975,
                                36.85424
                            ],
                            [
                                126.20682,
                                36.89914
                            ],
                            [
                                126.17961,
                                36.75201
                            ],
                            [
                                126.20787,
                                36.71007
                            ],
                            [
                                126.33806,
                                36.73702
                            ],
                            [
                                126.41694,
                                36.65981
                            ],
                            [
                                126.47848,
                                36.65051
                            ],
                            [
                                126.45818,
                                36.58986
                            ],
                            [
                                126.49905,
                                36.43653
                            ],
                            [
                                126.49165,
                                36.38887
                            ],
                            [
                                126.54919,
                                36.34499
                            ],
                            [
                                126.54043,
                                36.16824
                            ],
                            [
                                126.61159,
                                36.10074
                            ],
                            [
                                126.66507,
                                36.00846
                            ],
                            [
                                126.60752,
                                35.93743
                            ],
                            [
                                126.61226,
                                35.88923
                            ],
                            [
                                126.75746,
                                35.89125
                            ],
                            [
                                126.62281,
                                35.79215
                            ],
                            [
                                126.59093,
                                35.70958
                            ],
                            [
                                126.46236,
                                35.63488
                            ],
                            [
                                126.50142,
                                35.5789
                            ],
                            [
                                126.63285,
                                35.59313
                            ],
                            [
                                126.59093,
                                35.53796
                            ],
                            [
                                126.48069,
                                35.51159
                            ],
                            [
                                126.40396,
                                35.39237
                            ],
                            [
                                126.36988,
                                35.28115
                            ],
                            [
                                126.32135,
                                35.20672
                            ],
                            [
                                126.45463,
                                35.06639
                            ],
                            [
                                126.30015,
                                34.96269
                            ],
                            [
                                126.4087,
                                34.84375
                            ],
                            [
                                126.55996,
                                34.65136
                            ],
                            [
                                126.50856,
                                34.6308
                            ],
                            [
                                126.43794,
                                34.66152
                            ],
                            [
                                126.3818,
                                34.6099
                            ],
                            [
                                126.33476,
                                34.66164
                            ],
                            [
                                126.34727,
                                34.7048
                            ],
                            [
                                126.27979,
                                34.73626
                            ],
                            [
                                126.25945,
                                34.66642
                            ],
                            [
                                126.30664,
                                34.57444
                            ],
                            [
                                126.44135,
                                34.53411
                            ],
                            [
                                126.45449,
                                34.44452
                            ],
                            [
                                126.51096,
                                34.41168
                            ],
                            [
                                126.52252,
                                34.28845
                            ],
                            [
                                126.60206,
                                34.3087
                            ],
                            [
                                126.62456,
                                34.39447
                            ],
                            [
                                126.78915,
                                34.46799
                            ],
                            [
                                126.93073,
                                34.44754
                            ],
                            [
                                126.96984,
                                34.47699
                            ],
                            [
                                126.99693,
                                34.60001
                            ],
                            [
                                127.1262,
                                34.69394
                            ],
                            [
                                127.18443,
                                34.69203
                            ],
                            [
                                127.22164,
                                34.75366
                            ],
                            [
                                127.32835,
                                34.73698
                            ],
                            [
                                127.3133,
                                34.66982
                            ],
                            [
                                127.11987,
                                34.55478
                            ],
                            [
                                127.25624,
                                34.51069
                            ],
                            [
                                127.31424,
                                34.44481
                            ],
                            [
                                127.38003,
                                34.48143
                            ],
                            [
                                127.42675,
                                34.54599
                            ],
                            [
                                127.50849,
                                34.58785
                            ],
                            [
                                127.49182,
                                34.62333
                            ],
                            [
                                127.38148,
                                34.71394
                            ],
                            [
                                127.42984,
                                34.84012
                            ],
                            [
                                127.50744,
                                34.88021
                            ],
                            [
                                127.62075,
                                34.70401
                            ],
                            [
                                127.75405,
                                34.73457
                            ],
                            [
                                127.75812,
                                34.8583
                            ],
                            [
                                127.63077,
                                34.8273
                            ],
                            [
                                127.57117,
                                34.89021
                            ],
                            [
                                127.6597,
                                34.90172
                            ],
                            [
                                127.74413,
                                34.95929
                            ],
                            [
                                127.90006,
                                34.95522
                            ],
                            [
                                128.00477,
                                34.98532
                            ],
                            [
                                128.05353,
                                34.92771
                            ],
                            [
                                128.13435,
                                34.89062
                            ],
                            [
                                128.20789,
                                34.93146
                            ],
                            [
                                128.32547,
                                34.94817
                            ],
                            [
                                128.38987,
                                34.8688
                            ],
                            [
                                128.43787,
                                34.96875
                            ],
                            [
                                128.49061,
                                35.00312
                            ],
                            [
                                128.45984,
                                35.09362
                            ],
                            [
                                128.53647,
                                35.10481
                            ],
                            [
                                128.56856,
                                35.17468
                            ],
                            [
                                128.7258,
                                35.0883
                            ],
                            [
                                128.95246,
                                35.09096
                            ],
                            [
                                129.00763,
                                35.07549
                            ],
                            [
                                129.09486,
                                35.10349
                            ],
                            [
                                129.14115,
                                35.1515
                            ],
                            [
                                129.2258,
                                35.18223
                            ],
                            [
                                129.27017,
                                35.30931
                            ],
                            [
                                129.36072,
                                35.35423
                            ],
                            [
                                129.36067,
                                35.45726
                            ],
                            [
                                129.43482,
                                35.47714
                            ],
                            [
                                129.47789,
                                35.68135
                            ],
                            [
                                129.53587,
                                35.86384
                            ],
                            [
                                129.52892,
                                35.92363
                            ],
                            [
                                129.58317,
                                36.01802
                            ],
                            [
                                129.54221,
                                36.07277
                            ],
                            [
                                129.44855,
                                35.99076
                            ],
                            [
                                129.38194,
                                36.02264
                            ],
                            [
                                129.42766,
                                36.09974
                            ],
                            [
                                129.37599,
                                36.19622
                            ],
                            [
                                129.38511,
                                36.33502
                            ],
                            [
                                129.44924,
                                36.5035
                            ],
                            [
                                129.41473,
                                36.58425
                            ],
                            [
                                129.46698,
                                36.67724
                            ],
                            [
                                129.47205,
                                36.76848
                            ],
                            [
                                129.42314,
                                36.86677
                            ],
                            [
                                129.41087,
                                36.97178
                            ],
                            [
                                129.42363,
                                37.05986
                            ],
                            [
                                129.34337,
                                37.17153
                            ],
                            [
                                129.34872,
                                37.23582
                            ],
                            [
                                129.2739,
                                37.31416
                            ],
                            [
                                129.13135,
                                37.49799
                            ],
                            [
                                129.11363,
                                37.56641
                            ],
                            [
                                129.04696,
                                37.62767
                            ],
                            [
                                129.05144,
                                37.67244
                            ],
                            [
                                128.88843,
                                37.814
                            ],
                            [
                                128.61994,
                                38.13124
                            ],
                            [
                                128.58933,
                                38.22059
                            ],
                            [
                                128.36132,
                                38.61495
                            ],
                            [
                                128.31794,
                                38.59229
                            ],
                            [
                                128.28416,
                                38.43486
                            ],
                            [
                                128.21511,
                                38.36891
                            ],
                            [
                                128.0894,
                                38.31427
                            ],
                            [
                                127.88775,
                                38.32808
                            ],
                            [
                                127.82489,
                                38.3015
                            ],
                            [
                                127.74217,
                                38.33743
                            ],
                            [
                                127.58099,
                                38.33279
                            ],
                            [
                                127.50179,
                                38.29732
                            ],
                            [
                                127.38707,
                                38.33279
                            ],
                            [
                                127.30189,
                                38.31023
                            ],
                            [
                                127.24368,
                                38.32998
                            ],
                            [
                                127.04492,
                                38.25644
                            ],
                            [
                                126.96754,
                                38.18841
                            ],
                            [
                                126.97066,
                                38.14319
                            ],
                            [
                                126.88058,
                                38.0981
                            ],
                            [
                                126.82127,
                                38.00255
                            ],
                            [
                                126.70615,
                                37.95046
                            ],
                            [
                                126.66583,
                                37.83302
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                126.81409,
                                33.29882
                            ],
                            [
                                126.90325,
                                33.39014
                            ],
                            [
                                126.91392,
                                33.50008
                            ],
                            [
                                126.82346,
                                33.55685
                            ],
                            [
                                126.76733,
                                33.56447
                            ],
                            [
                                126.51251,
                                33.51424
                            ],
                            [
                                126.31559,
                                33.4646
                            ],
                            [
                                126.1661,
                                33.33318
                            ],
                            [
                                126.16433,
                                33.2845
                            ],
                            [
                                126.27274,
                                33.1917
                            ],
                            [
                                126.32987,
                                33.23432
                            ],
                            [
                                126.47526,
                                33.22308
                            ],
                            [
                                126.61409,
                                33.23582
                            ],
                            [
                                126.65316,
                                33.26311
                            ],
                            [
                                126.81409,
                                33.29882
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                128.47543,
                                34.87461
                            ],
                            [
                                128.51322,
                                34.80765
                            ],
                            [
                                128.60993,
                                34.69942
                            ],
                            [
                                128.66163,
                                34.73412
                            ],
                            [
                                128.67151,
                                34.80671
                            ],
                            [
                                128.72492,
                                34.93797
                            ],
                            [
                                128.69694,
                                34.97259
                            ],
                            [
                                128.58823,
                                34.94337
                            ],
                            [
                                128.47543,
                                34.87461
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                126.34656,
                                34.4173
                            ],
                            [
                                126.37807,
                                34.50218
                            ],
                            [
                                126.29143,
                                34.5716
                            ],
                            [
                                126.26908,
                                34.53087
                            ],
                            [
                                126.12355,
                                34.46096
                            ],
                            [
                                126.09329,
                                34.41164
                            ],
                            [
                                126.18414,
                                34.34859
                            ],
                            [
                                126.34656,
                                34.4173
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                127.80871,
                                34.85202
                            ],
                            [
                                127.86108,
                                34.72084
                            ],
                            [
                                127.94667,
                                34.72849
                            ],
                            [
                                128.04161,
                                34.69883
                            ],
                            [
                                128.06574,
                                34.81358
                            ],
                            [
                                127.96564,
                                34.80821
                            ],
                            [
                                127.9107,
                                34.83212
                            ],
                            [
                                127.87133,
                                34.93473
                            ],
                            [
                                127.80871,
                                34.85202
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                126.34855,
                                37.71063
                            ],
                            [
                                126.41123,
                                37.65121
                            ],
                            [
                                126.40894,
                                37.58981
                            ],
                            [
                                126.50771,
                                37.5938
                            ],
                            [
                                126.53315,
                                37.63122
                            ],
                            [
                                126.50276,
                                37.78428
                            ],
                            [
                                126.43018,
                                37.82413
                            ],
                            [
                                126.35679,
                                37.78034
                            ],
                            [
                                126.34855,
                                37.71063
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                126.31049,
                                36.5773
                            ],
                            [
                                126.33617,
                                36.43877
                            ],
                            [
                                126.41565,
                                36.43605
                            ],
                            [
                                126.40391,
                                36.49774
                            ],
                            [
                                126.31049,
                                36.5773
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                126.63808,
                                34.37254
                            ],
                            [
                                126.69496,
                                34.28439
                            ],
                            [
                                126.74445,
                                34.28545
                            ],
                            [
                                126.72266,
                                34.37787
                            ],
                            [
                                126.63808,
                                34.37254
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                130.88832,
                                37.46439
                            ],
                            [
                                130.91301,
                                37.54277
                            ],
                            [
                                130.79398,
                                37.51527
                            ],
                            [
                                130.80986,
                                37.46902
                            ],
                            [
                                130.88832,
                                37.46439
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                127.71357,
                                34.61458
                            ],
                            [
                                127.79343,
                                34.57951
                            ],
                            [
                                127.79952,
                                34.66218
                            ],
                            [
                                127.71357,
                                34.61458
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                127.9633,
                                34.85859
                            ],
                            [
                                128.08051,
                                34.82561
                            ],
                            [
                                128.01448,
                                34.91463
                            ],
                            [
                                127.9633,
                                34.85859
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                126.15485,
                                34.86256
                            ],
                            [
                                126.06223,
                                34.84838
                            ],
                            [
                                126.09962,
                                34.79587
                            ],
                            [
                                126.15485,
                                34.86256
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "SSD",
                "Country": "South Sudan",
                "Total_3GHG": 0.16,
                "Total_3GHG_timeseries": [
                    2.3687e-06,
                    4.7407e-06,
                    7.1167e-06,
                    9.4962e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026
                ],
                "Fossil_3GHG": 0.02,
                "Fossil_3GHG_timeseries": [
                    2.2477e-08,
                    4.534e-08,
                    6.861e-08,
                    9.2309e-08,
                    1.1646e-07,
                    1.4108e-07,
                    1.6618e-07,
                    1.918e-07,
                    2.1793e-07,
                    2.446e-07,
                    2.7203e-07,
                    3.0024e-07,
                    3.2926e-07,
                    3.591e-07,
                    3.8979e-07,
                    4.2135e-07,
                    4.538e-07,
                    4.8718e-07,
                    5.215e-07,
                    5.5679e-07,
                    6.2192e-07,
                    6.8698e-07,
                    7.5201e-07,
                    8.1703e-07,
                    8.8205e-07,
                    9.4708e-07,
                    1.0121e-06,
                    1.0771e-06,
                    1.1419e-06,
                    1.2067e-06,
                    1.2711e-06,
                    1.3351e-06,
                    1.3988e-06,
                    1.4622e-06,
                    1.5251e-06,
                    1.5877e-06,
                    1.6499e-06,
                    1.7117e-06,
                    1.7731e-06,
                    1.8342e-06,
                    1.8697e-06,
                    1.9057e-06,
                    1.9423e-06,
                    1.9794e-06,
                    2.017e-06,
                    2.0553e-06,
                    2.094e-06,
                    2.1333e-06,
                    2.1732e-06,
                    2.2137e-06,
                    2.2547e-06,
                    2.2963e-06,
                    2.3386e-06,
                    2.3814e-06,
                    2.4249e-06,
                    2.4691e-06,
                    2.5138e-06,
                    2.5592e-06,
                    2.6052e-06,
                    2.6519e-06,
                    2.7e-06,
                    2.7497e-06,
                    2.8008e-06,
                    2.8535e-06,
                    2.9095e-06,
                    2.9686e-06,
                    3.0311e-06,
                    3.0968e-06,
                    3.166e-06,
                    3.2386e-06,
                    3.3149e-06,
                    3.3948e-06,
                    3.4784e-06,
                    3.5658e-06,
                    3.657e-06,
                    3.7522e-06,
                    3.851e-06,
                    3.9537e-06,
                    4.0602e-06,
                    4.1706e-06,
                    4.2842e-06,
                    4.4012e-06,
                    4.5216e-06,
                    4.6454e-06,
                    4.7712e-06,
                    4.899e-06,
                    5.0285e-06,
                    5.1695e-06,
                    5.3147e-06,
                    5.4643e-06,
                    5.6189e-06,
                    5.7787e-06,
                    5.9441e-06,
                    6.1153e-06,
                    6.2842e-06,
                    6.4507e-06,
                    6.6153e-06,
                    6.776e-06,
                    6.933e-06,
                    7.107e-06,
                    7.293e-06,
                    7.4715e-06,
                    7.6434e-06,
                    7.8024e-06,
                    7.9535e-06,
                    8.0915e-06,
                    8.2276e-06,
                    8.3482e-06,
                    8.4581e-06,
                    8.5543e-06,
                    8.6382e-06,
                    8.7111e-06,
                    8.7768e-06,
                    8.8354e-06,
                    8.9095e-06,
                    8.9868e-06,
                    9.0796e-06,
                    9.1669e-06,
                    9.292e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_3GHG": 0.42,
                "Land_3GHG_timeseries": [
                    2.3462e-06,
                    4.6954e-06,
                    7.0481e-06,
                    9.4039e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024
                ],
                "Total_CO2": 0.05,
                "Total_CO2_timeseries": [
                    2.0593e-06,
                    4.1159e-06,
                    6.1705e-06,
                    8.2231e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2.0611e-08,
                    4.7679e-08,
                    7.6122e-08,
                    1.0731e-07,
                    1.3795e-07,
                    1.7272e-07,
                    2.0638e-07,
                    2.4967e-07,
                    2.9803e-07,
                    3.4928e-07,
                    4.0026e-07,
                    4.522e-07,
                    5.0785e-07,
                    5.7078e-07,
                    6.4045e-07,
                    7.3141e-07,
                    8.3048e-07,
                    9.4988e-07,
                    1.0663e-06,
                    1.223e-06,
                    1.405e-06,
                    1.5917e-06,
                    1.7933e-06,
                    1.9966e-06,
                    2.2096e-06,
                    2.3685e-06,
                    2.5092e-06,
                    2.6518e-06,
                    2.7807e-06,
                    2.9145e-06,
                    3.0549e-06,
                    3.1914e-06,
                    3.3348e-06,
                    3.4813e-06,
                    3.6127e-06,
                    3.7653e-06,
                    3.9246e-06,
                    4.0502e-06,
                    4.2318e-06,
                    4.3727e-06,
                    4.568e-06,
                    4.7511e-06,
                    4.9147e-06,
                    5.0275e-06,
                    5.1827e-06,
                    5.343e-06,
                    5.5084e-06,
                    5.711e-06,
                    5.8866e-06,
                    6.077e-06,
                    6.2841e-06,
                    6.5224e-06,
                    6.826e-06,
                    7.1653e-06,
                    7.594e-06,
                    8.0047e-06,
                    8.4544e-06,
                    8.9827e-06,
                    9.5407e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CO2": 0.16,
                "Land_CO2_timeseries": [
                    2.0593e-06,
                    4.1159e-06,
                    6.1705e-06,
                    8.2231e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006
                ],
                "Total_CH4": 0.34,
                "Total_CH4_timeseries": [
                    1.9096e-08,
                    3.8522e-08,
                    5.8303e-08,
                    7.8462e-08,
                    9.9024e-08,
                    1.2001e-07,
                    1.4145e-07,
                    1.6336e-07,
                    1.8576e-07,
                    2.0868e-07,
                    2.3235e-07,
                    2.5677e-07,
                    2.8199e-07,
                    3.0802e-07,
                    3.3488e-07,
                    3.626e-07,
                    3.912e-07,
                    4.2071e-07,
                    4.5115e-07,
                    4.8254e-07,
                    5.4371e-07,
                    6.0471e-07,
                    6.655e-07,
                    7.261e-07,
                    7.8648e-07,
                    8.4665e-07,
                    9.066e-07,
                    9.6632e-07,
                    1.0258e-06,
                    1.0851e-06,
                    1.1439e-06,
                    1.2024e-06,
                    1.2604e-06,
                    1.3181e-06,
                    1.3753e-06,
                    1.4322e-06,
                    1.4885e-06,
                    1.5445e-06,
                    1.6e-06,
                    1.655e-06,
                    1.6844e-06,
                    1.7142e-06,
                    1.7445e-06,
                    1.7752e-06,
                    1.8064e-06,
                    1.838e-06,
                    1.8701e-06,
                    1.9026e-06,
                    1.9356e-06,
                    1.969e-06,
                    2.0029e-06,
                    2.0372e-06,
                    2.072e-06,
                    2.1072e-06,
                    2.1428e-06,
                    2.1789e-06,
                    2.2155e-06,
                    2.2525e-06,
                    2.2899e-06,
                    2.3279e-06,
                    2.3672e-06,
                    2.4079e-06,
                    2.45e-06,
                    2.4935e-06,
                    2.5402e-06,
                    2.5899e-06,
                    2.6428e-06,
                    2.699e-06,
                    2.7584e-06,
                    2.8211e-06,
                    2.8874e-06,
                    2.9572e-06,
                    3.0305e-06,
                    3.1076e-06,
                    3.1883e-06,
                    3.2728e-06,
                    3.3609e-06,
                    3.4527e-06,
                    3.5481e-06,
                    3.6473e-06,
                    3.7496e-06,
                    3.8551e-06,
                    3.9638e-06,
                    4.0758e-06,
                    4.1895e-06,
                    4.3049e-06,
                    4.4218e-06,
                    4.5499e-06,
                    4.682e-06,
                    4.8182e-06,
                    4.9589e-06,
                    5.1043e-06,
                    5.2544e-06,
                    5.4094e-06,
                    5.5613e-06,
                    5.7097e-06,
                    5.8552e-06,
                    5.9958e-06,
                    6.1318e-06,
                    6.2635e-06,
                    6.4e-06,
                    6.527e-06,
                    6.6439e-06,
                    6.7479e-06,
                    6.839e-06,
                    6.9175e-06,
                    6.9837e-06,
                    7.0286e-06,
                    7.0594e-06,
                    7.076e-06,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014
                ],
                "Fossil_CH4": 0.07,
                "Fossil_CH4_timeseries": [
                    1.9096e-08,
                    3.8522e-08,
                    5.8303e-08,
                    7.8462e-08,
                    9.9024e-08,
                    1.2001e-07,
                    1.4145e-07,
                    1.6336e-07,
                    1.8576e-07,
                    2.0868e-07,
                    2.3235e-07,
                    2.5677e-07,
                    2.8199e-07,
                    3.0802e-07,
                    3.3488e-07,
                    3.626e-07,
                    3.912e-07,
                    4.2071e-07,
                    4.5115e-07,
                    4.8254e-07,
                    5.4371e-07,
                    6.0471e-07,
                    6.655e-07,
                    7.261e-07,
                    7.8648e-07,
                    8.4665e-07,
                    9.066e-07,
                    9.6632e-07,
                    1.0258e-06,
                    1.0851e-06,
                    1.1439e-06,
                    1.2024e-06,
                    1.2604e-06,
                    1.3181e-06,
                    1.3753e-06,
                    1.4322e-06,
                    1.4885e-06,
                    1.5445e-06,
                    1.6e-06,
                    1.655e-06,
                    1.6844e-06,
                    1.7142e-06,
                    1.7445e-06,
                    1.7752e-06,
                    1.8064e-06,
                    1.838e-06,
                    1.8701e-06,
                    1.9026e-06,
                    1.9356e-06,
                    1.969e-06,
                    2.0029e-06,
                    2.0372e-06,
                    2.072e-06,
                    2.1072e-06,
                    2.1428e-06,
                    2.1789e-06,
                    2.2155e-06,
                    2.2525e-06,
                    2.2899e-06,
                    2.3279e-06,
                    2.3672e-06,
                    2.4079e-06,
                    2.45e-06,
                    2.4935e-06,
                    2.5402e-06,
                    2.5899e-06,
                    2.6428e-06,
                    2.699e-06,
                    2.7584e-06,
                    2.8211e-06,
                    2.8874e-06,
                    2.9572e-06,
                    3.0305e-06,
                    3.1076e-06,
                    3.1883e-06,
                    3.2728e-06,
                    3.3609e-06,
                    3.4527e-06,
                    3.5481e-06,
                    3.6473e-06,
                    3.7496e-06,
                    3.8551e-06,
                    3.9638e-06,
                    4.0758e-06,
                    4.1895e-06,
                    4.3049e-06,
                    4.4218e-06,
                    4.5499e-06,
                    4.682e-06,
                    4.8182e-06,
                    4.9589e-06,
                    5.1043e-06,
                    5.2544e-06,
                    5.4094e-06,
                    5.5613e-06,
                    5.7097e-06,
                    5.8552e-06,
                    5.9958e-06,
                    6.1318e-06,
                    6.2635e-06,
                    6.4e-06,
                    6.527e-06,
                    6.6439e-06,
                    6.7479e-06,
                    6.839e-06,
                    6.9175e-06,
                    6.9837e-06,
                    7.0286e-06,
                    7.0594e-06,
                    7.076e-06,
                    7.0787e-06,
                    7.0659e-06,
                    7.0377e-06,
                    6.9948e-06,
                    6.9451e-06,
                    6.8895e-06,
                    6.828e-06,
                    6.763e-06,
                    6.6944e-06,
                    9.9093e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_CH4": 0.78,
                "Land_CH4_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012
                ],
                "Total_N2O": 0.72,
                "Total_N2O_timeseries": [
                    2.9024e-07,
                    5.8627e-07,
                    8.8784e-07,
                    1.1946e-06,
                    1.5061e-06,
                    1.8219e-06,
                    2.1413e-06,
                    2.4635e-06,
                    2.7878e-06,
                    3.1132e-06,
                    3.4392e-06,
                    3.7656e-06,
                    4.0923e-06,
                    4.4193e-06,
                    4.7465e-06,
                    5.0739e-06,
                    5.4015e-06,
                    5.7295e-06,
                    6.0579e-06,
                    6.3869e-06,
                    6.7214e-06,
                    7.0699e-06,
                    7.4386e-06,
                    7.8322e-06,
                    8.2531e-06,
                    8.702e-06,
                    9.1775e-06,
                    9.6764e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006
                ],
                "Fossil_N2O": 0.03,
                "Fossil_N2O_timeseries": [
                    3.3813e-09,
                    6.8176e-09,
                    1.0307e-08,
                    1.3847e-08,
                    1.7434e-08,
                    2.1065e-08,
                    2.4734e-08,
                    2.8437e-08,
                    3.2168e-08,
                    3.5919e-08,
                    3.9687e-08,
                    4.347e-08,
                    4.7268e-08,
                    5.1079e-08,
                    5.4905e-08,
                    5.8745e-08,
                    6.2599e-08,
                    6.6468e-08,
                    7.0352e-08,
                    7.4253e-08,
                    7.8207e-08,
                    8.2276e-08,
                    8.6506e-08,
                    9.0931e-08,
                    9.5569e-08,
                    1.0043e-07,
                    1.0549e-07,
                    1.1074e-07,
                    1.1613e-07,
                    1.2162e-07,
                    1.2717e-07,
                    1.3277e-07,
                    1.3841e-07,
                    1.4409e-07,
                    1.4981e-07,
                    1.5557e-07,
                    1.6136e-07,
                    1.6719e-07,
                    1.7306e-07,
                    1.7911e-07,
                    1.8524e-07,
                    1.9146e-07,
                    1.9776e-07,
                    2.0415e-07,
                    2.1063e-07,
                    2.1722e-07,
                    2.2391e-07,
                    2.3071e-07,
                    2.3762e-07,
                    2.4465e-07,
                    2.5182e-07,
                    2.5913e-07,
                    2.6662e-07,
                    2.7428e-07,
                    2.8213e-07,
                    2.9016e-07,
                    2.9837e-07,
                    3.0676e-07,
                    3.153e-07,
                    3.2399e-07,
                    3.3281e-07,
                    3.4176e-07,
                    3.5082e-07,
                    3.6e-07,
                    3.693e-07,
                    3.7871e-07,
                    3.8823e-07,
                    3.9787e-07,
                    4.0763e-07,
                    4.1751e-07,
                    4.2751e-07,
                    4.3763e-07,
                    4.4788e-07,
                    4.5826e-07,
                    4.6876e-07,
                    4.7939e-07,
                    4.9015e-07,
                    5.0104e-07,
                    5.1207e-07,
                    5.2324e-07,
                    5.3457e-07,
                    5.4606e-07,
                    5.5774e-07,
                    5.6963e-07,
                    5.8174e-07,
                    5.9408e-07,
                    6.0668e-07,
                    6.1954e-07,
                    6.3268e-07,
                    6.4612e-07,
                    6.5997e-07,
                    6.7443e-07,
                    6.8967e-07,
                    7.058e-07,
                    7.2291e-07,
                    7.4103e-07,
                    7.6016e-07,
                    7.8024e-07,
                    8.0121e-07,
                    8.2291e-07,
                    8.4529e-07,
                    8.6837e-07,
                    8.9214e-07,
                    9.1661e-07,
                    9.4179e-07,
                    9.6768e-07,
                    9.9426e-07,
                    1.0215e-06,
                    1.0495e-06,
                    1.078e-06,
                    1.1073e-06,
                    1.1374e-06,
                    1.1683e-06,
                    1.2001e-06,
                    1.233e-06,
                    1.2668e-06,
                    1.3017e-06,
                    1.3376e-06,
                    1.3746e-06,
                    1.4116e-06,
                    1.4489e-06,
                    1.487e-06,
                    1.5268e-06,
                    1.5678e-06,
                    1.6078e-06,
                    1.6474e-06,
                    1.6877e-06,
                    1.7303e-06,
                    1.7727e-06,
                    1.8162e-06,
                    1.8609e-06,
                    1.9299e-06,
                    1.9958e-06,
                    2.0609e-06,
                    2.134e-06,
                    2.2062e-06,
                    2.2794e-06,
                    2.3529e-06,
                    2.4258e-06,
                    2.5026e-06,
                    2.5801e-06,
                    2.6598e-06,
                    2.7394e-06,
                    2.8278e-06,
                    2.9175e-06,
                    3.01e-06,
                    3.1056e-06,
                    3.2022e-06,
                    3.3076e-06,
                    3.4115e-06,
                    3.5174e-06,
                    3.628e-06,
                    3.7377e-06,
                    3.8474e-06,
                    3.9582e-06,
                    4.0745e-06,
                    4.1862e-06,
                    4.2959e-06,
                    4.4041e-06,
                    4.5106e-06,
                    4.6194e-06,
                    4.7327e-06,
                    4.8841e-06,
                    5.0383e-06,
                    5.1976e-06,
                    5.3624e-06,
                    5.5236e-06,
                    5.6827e-06,
                    5.8473e-06,
                    6.0147e-06,
                    6.1896e-06,
                    6.3794e-06
                ],
                "Land_N2O": 0.98,
                "Land_N2O_timeseries": [
                    2.8686e-07,
                    5.7945e-07,
                    8.7753e-07,
                    1.1808e-06,
                    1.4887e-06,
                    1.8008e-06,
                    2.1165e-06,
                    2.4351e-06,
                    2.7556e-06,
                    3.0773e-06,
                    3.3995e-06,
                    3.7221e-06,
                    4.0451e-06,
                    4.3682e-06,
                    4.6916e-06,
                    5.0151e-06,
                    5.3389e-06,
                    5.663e-06,
                    5.9875e-06,
                    6.3126e-06,
                    6.6432e-06,
                    6.9876e-06,
                    7.3521e-06,
                    7.7412e-06,
                    8.1575e-06,
                    8.6015e-06,
                    9.072e-06,
                    9.5657e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            28.97701,
                            9.64116
                        ],
                        [
                            28.976950703582929,
                            9.657365361982636
                        ],
                        [
                            27.904844580645356,
                            9.615045383445628
                        ],
                        [
                            27.82226,
                            9.60209
                        ],
                        [
                            27.48027,
                            9.61969
                        ],
                        [
                            27.13576,
                            9.62386
                        ],
                        [
                            26.99252,
                            9.59366
                        ],
                        [
                            26.85175,
                            9.53117
                        ],
                        [
                            26.70444,
                            9.48868
                        ],
                        [
                            26.55902,
                            9.51663
                        ],
                        [
                            26.39433,
                            9.56666
                        ],
                        [
                            26.31285,
                            9.6385
                        ],
                        [
                            26.21114,
                            9.91299
                        ],
                        [
                            26.11759,
                            9.99381
                        ],
                        [
                            26.06051,
                            10.10112
                        ],
                        [
                            25.99992,
                            10.15661
                        ],
                        [
                            25.93144,
                            10.1823
                        ],
                        [
                            25.93242,
                            10.37334
                        ],
                        [
                            25.92088,
                            10.40398
                        ],
                        [
                            25.81261,
                            10.43893
                        ],
                        [
                            25.74447,
                            10.40581
                        ],
                        [
                            25.62434,
                            10.39572
                        ],
                        [
                            25.53703,
                            10.36141
                        ],
                        [
                            25.46288,
                            10.37348
                        ],
                        [
                            25.3392,
                            10.33646
                        ],
                        [
                            25.25047,
                            10.35102
                        ],
                        [
                            25.18459,
                            10.32183
                        ],
                        [
                            25.10008,
                            10.31428
                        ],
                        [
                            25.03373,
                            10.17966
                        ],
                        [
                            25.05903,
                            10.12108
                        ],
                        [
                            24.94818,
                            9.93413
                        ],
                        [
                            24.85252,
                            9.87503
                        ],
                        [
                            24.73915,
                            9.71394
                        ],
                        [
                            24.73296,
                            9.62581
                        ],
                        [
                            24.75326,
                            9.58172
                        ],
                        [
                            24.73785,
                            9.48141
                        ],
                        [
                            24.59651,
                            9.37571
                        ],
                        [
                            24.62576,
                            9.322
                        ],
                        [
                            24.56612,
                            9.1863
                        ],
                        [
                            24.54348,
                            9.0631
                        ],
                        [
                            24.57828,
                            8.92285
                        ],
                        [
                            24.52582,
                            8.8445
                        ],
                        [
                            24.38356,
                            8.78946
                        ],
                        [
                            24.24424,
                            8.64871
                        ],
                        [
                            24.22336,
                            8.64215
                        ],
                        [
                            24.25439,
                            8.59311
                        ],
                        [
                            24.203,
                            8.50025
                        ],
                        [
                            24.16339,
                            8.48075
                        ],
                        [
                            24.15569,
                            8.37084
                        ],
                        [
                            24.20381,
                            8.30517
                        ],
                        [
                            24.3602,
                            8.25172
                        ],
                        [
                            24.48037,
                            8.28339
                        ],
                        [
                            24.4953,
                            8.236
                        ],
                        [
                            24.56069,
                            8.20244
                        ],
                        [
                            24.64461,
                            8.22132
                        ],
                        [
                            24.74895,
                            8.18408
                        ],
                        [
                            24.85914,
                            8.17309
                        ],
                        [
                            24.90156,
                            8.05176
                        ],
                        [
                            24.94161,
                            8.03591
                        ],
                        [
                            24.97895,
                            7.95889
                        ],
                        [
                            25.03598,
                            7.94828
                        ],
                        [
                            25.08518,
                            7.8956
                        ],
                        [
                            25.16917,
                            7.91326
                        ],
                        [
                            25.21871,
                            7.88026
                        ],
                        [
                            25.28312,
                            7.79417
                        ],
                        [
                            25.28682,
                            7.65694
                        ],
                        [
                            25.16725,
                            7.57944
                        ],
                        [
                            25.2029,
                            7.49329
                        ],
                        [
                            25.28053,
                            7.4721
                        ],
                        [
                            25.33302,
                            7.42684
                        ],
                        [
                            25.35811,
                            7.34685
                        ],
                        [
                            25.44897,
                            7.3062
                        ],
                        [
                            25.49942,
                            7.30483
                        ],
                        [
                            25.62001,
                            7.21962
                        ],
                        [
                            25.82184,
                            7.1537
                        ],
                        [
                            25.86948,
                            7.0812
                        ],
                        [
                            25.98152,
                            7.03997
                        ],
                        [
                            26.03783,
                            6.97181
                        ],
                        [
                            26.07093,
                            6.83049
                        ],
                        [
                            26.17181,
                            6.8115
                        ],
                        [
                            26.20851,
                            6.74759
                        ],
                        [
                            26.25754,
                            6.73869
                        ],
                        [
                            26.4117,
                            6.65303
                        ],
                        [
                            26.379,
                            6.58177
                        ],
                        [
                            26.29863,
                            6.48658
                        ],
                        [
                            26.33671,
                            6.38097
                        ],
                        [
                            26.39372,
                            6.30527
                        ],
                        [
                            26.47942,
                            6.27595
                        ],
                        [
                            26.53289,
                            6.23224
                        ],
                        [
                            26.51623,
                            6.11382
                        ],
                        [
                            26.57444,
                            6.02734
                        ],
                        [
                            26.67299,
                            5.99205
                        ],
                        [
                            26.78462,
                            6.00936
                        ],
                        [
                            26.84542,
                            5.9828
                        ],
                        [
                            26.86607,
                            5.90283
                        ],
                        [
                            27.01718,
                            5.84783
                        ],
                        [
                            27.05215,
                            5.79155
                        ],
                        [
                            27.16048,
                            5.75966
                        ],
                        [
                            27.21778,
                            5.68793
                        ],
                        [
                            27.23189,
                            5.61163
                        ],
                        [
                            27.283,
                            5.58581
                        ],
                        [
                            27.23291,
                            5.42625
                        ],
                        [
                            27.24953,
                            5.32846
                        ],
                        [
                            27.30367,
                            5.22577
                        ],
                        [
                            27.39533,
                            5.15424
                        ],
                        [
                            27.45331,
                            5.07567
                        ],
                        [
                            27.44361,
                            5.01944
                        ],
                        [
                            27.52007,
                            4.97545
                        ],
                        [
                            27.58069,
                            4.88695
                        ],
                        [
                            27.65715,
                            4.89237
                        ],
                        [
                            27.72748,
                            4.78625
                        ],
                        [
                            27.76767,
                            4.78561
                        ],
                        [
                            27.78735,
                            4.62618
                        ],
                        [
                            27.86922,
                            4.54912
                        ],
                        [
                            27.94129,
                            4.56783
                        ],
                        [
                            28.04268,
                            4.54369
                        ],
                        [
                            28.04118,
                            4.45565
                        ],
                        [
                            28.20338,
                            4.34844
                        ],
                        [
                            28.35158,
                            4.34942
                        ],
                        [
                            28.36733,
                            4.28661
                        ],
                        [
                            28.41241,
                            4.27353
                        ],
                        [
                            28.48557,
                            4.31245
                        ],
                        [
                            28.51195,
                            4.36916
                        ],
                        [
                            28.57966,
                            4.37595
                        ],
                        [
                            28.5999,
                            4.41346
                        ],
                        [
                            28.66258,
                            4.42051
                        ],
                        [
                            28.71349,
                            4.53184
                        ],
                        [
                            28.78918,
                            4.55692
                        ],
                        [
                            28.8057,
                            4.49285
                        ],
                        [
                            28.90244,
                            4.47282
                        ],
                        [
                            29.03732,
                            4.48124
                        ],
                        [
                            29.07882,
                            4.43066
                        ],
                        [
                            29.13387,
                            4.40875
                        ],
                        [
                            29.20427,
                            4.34114
                        ],
                        [
                            29.2658,
                            4.39278
                        ],
                        [
                            29.34157,
                            4.40633
                        ],
                        [
                            29.36849,
                            4.46837
                        ],
                        [
                            29.40844,
                            4.4833
                        ],
                        [
                            29.47299,
                            4.59358
                        ],
                        [
                            29.4634,
                            4.66328
                        ],
                        [
                            29.61129,
                            4.66011
                        ],
                        [
                            29.70857,
                            4.61721
                        ],
                        [
                            29.73211,
                            4.57869
                        ],
                        [
                            29.81769,
                            4.56203
                        ],
                        [
                            29.79316,
                            4.50977
                        ],
                        [
                            29.80021,
                            4.36714
                        ],
                        [
                            29.84194,
                            4.33781
                        ],
                        [
                            29.89764,
                            4.34688
                        ],
                        [
                            29.96386,
                            4.28065
                        ],
                        [
                            29.94458,
                            4.24386
                        ],
                        [
                            30.03821,
                            4.19
                        ],
                        [
                            30.0786,
                            4.11632
                        ],
                        [
                            30.15902,
                            4.09285
                        ],
                        [
                            30.22482,
                            3.93927
                        ],
                        [
                            30.26529,
                            3.95651
                        ],
                        [
                            30.49519,
                            3.85819
                        ],
                        [
                            30.55238,
                            3.86353
                        ],
                        [
                            30.59528,
                            3.59598
                        ],
                        [
                            30.67324,
                            3.63806
                        ],
                        [
                            30.71263,
                            3.62328
                        ],
                        [
                            30.78496,
                            3.65802
                        ],
                        [
                            30.79085,
                            3.60529
                        ],
                        [
                            30.85574,
                            3.56956
                        ],
                        [
                            30.85453,
                            3.48747
                        ],
                        [
                            30.91271,
                            3.56858
                        ],
                        [
                            30.97873,
                            3.69692
                        ],
                        [
                            31.00109,
                            3.68854
                        ],
                        [
                            31.17488,
                            3.79295
                        ],
                        [
                            31.28599,
                            3.79133
                        ],
                        [
                            31.53873,
                            3.6549
                        ],
                        [
                            31.58095,
                            3.68224
                        ],
                        [
                            31.70997,
                            3.71755
                        ],
                        [
                            31.8019,
                            3.79999
                        ],
                        [
                            31.85423,
                            3.7895
                        ],
                        [
                            31.91952,
                            3.70926
                        ],
                        [
                            31.95026,
                            3.58753
                        ],
                        [
                            32.0393,
                            3.5865
                        ],
                        [
                            32.08598,
                            3.53351
                        ],
                        [
                            32.20142,
                            3.50558
                        ],
                        [
                            32.21589,
                            3.57567
                        ],
                        [
                            32.17673,
                            3.61226
                        ],
                        [
                            32.4062,
                            3.74694
                        ],
                        [
                            32.72048,
                            3.76542
                        ],
                        [
                            32.9011,
                            3.81537
                        ],
                        [
                            33.02755,
                            3.87295
                        ],
                        [
                            33.17782,
                            3.77409
                        ],
                        [
                            33.50845,
                            3.74941
                        ],
                        [
                            33.99449,
                            4.21443
                        ],
                        [
                            34.26496,
                            4.48864
                        ],
                        [
                            34.37846,
                            4.62
                        ],
                        [
                            34.47629,
                            4.72405
                        ],
                        [
                            34.50003,
                            4.73842
                        ],
                        [
                            34.7125,
                            4.79807
                        ],
                        [
                            35.00015,
                            4.90625
                        ],
                        [
                            35.15209,
                            4.9888
                        ],
                        [
                            35.16307,
                            4.98071
                        ],
                        [
                            35.19674,
                            4.95591
                        ],
                        [
                            35.23255,
                            4.97759
                        ],
                        [
                            35.28618,
                            5.01086
                        ],
                        [
                            35.30941,
                            5.02164
                        ],
                        [
                            35.32701,
                            5.02303
                        ],
                        [
                            35.3369,
                            5.0187
                        ],
                        [
                            35.34632,
                            5.00772
                        ],
                        [
                            35.33188,
                            4.9812
                        ],
                        [
                            35.31118,
                            4.9199
                        ],
                        [
                            35.31037,
                            4.90757
                        ],
                        [
                            35.4571,
                            4.92248
                        ],
                        [
                            35.4694,
                            4.92107
                        ],
                        [
                            35.47635,
                            4.91413
                        ],
                        [
                            35.47684,
                            4.90255
                        ],
                        [
                            35.4209,
                            4.7711
                        ],
                        [
                            35.50877,
                            4.62
                        ],
                        [
                            35.9477,
                            4.62
                        ],
                        [
                            35.81718,
                            4.77921
                        ],
                        [
                            35.81828,
                            5.1048
                        ],
                        [
                            35.86338,
                            5.17599
                        ],
                        [
                            35.82928,
                            5.23693
                        ],
                        [
                            35.86095,
                            5.28962
                        ],
                        [
                            35.83934,
                            5.32974
                        ],
                        [
                            35.71767,
                            5.38919
                        ],
                        [
                            35.62698,
                            5.37836
                        ],
                        [
                            35.58732,
                            5.41325
                        ],
                        [
                            35.47242,
                            5.40665
                        ],
                        [
                            35.33968,
                            5.33105
                        ],
                        [
                            35.30275,
                            5.34795
                        ],
                        [
                            35.30905,
                            5.49783
                        ],
                        [
                            35.13933,
                            5.61241
                        ],
                        [
                            35.12906,
                            5.6926
                        ],
                        [
                            35.00169,
                            5.89697
                        ],
                        [
                            34.99988,
                            6.07208
                        ],
                        [
                            34.96939,
                            6.09225
                        ],
                        [
                            34.97397,
                            6.18432
                        ],
                        [
                            34.95246,
                            6.24323
                        ],
                        [
                            34.98583,
                            6.29849
                        ],
                        [
                            35.01314,
                            6.46179
                        ],
                        [
                            34.93824,
                            6.55047
                        ],
                        [
                            34.86131,
                            6.60425
                        ],
                        [
                            34.7684,
                            6.59493
                        ],
                        [
                            34.70615,
                            6.68549
                        ],
                        [
                            34.52895,
                            6.75215
                        ],
                        [
                            34.53866,
                            6.81872
                        ],
                        [
                            34.4634,
                            6.92345
                        ],
                        [
                            34.30546,
                            6.96065
                        ],
                        [
                            34.19412,
                            7.04079
                        ],
                        [
                            34.19074,
                            7.11994
                        ],
                        [
                            34.10334,
                            7.1705
                        ],
                        [
                            34.01253,
                            7.25639
                        ],
                        [
                            34.03097,
                            7.35985
                        ],
                        [
                            33.95876,
                            7.44667
                        ],
                        [
                            33.94395,
                            7.50391
                        ],
                        [
                            33.87494,
                            7.51557
                        ],
                        [
                            33.79664,
                            7.60129
                        ],
                        [
                            33.74295,
                            7.6224
                        ],
                        [
                            33.67077,
                            7.69116
                        ],
                        [
                            33.57063,
                            7.68869
                        ],
                        [
                            33.51406,
                            7.72895
                        ],
                        [
                            33.43117,
                            7.74915
                        ],
                        [
                            33.32315,
                            7.70532
                        ],
                        [
                            33.23797,
                            7.7714
                        ],
                        [
                            33.16214,
                            7.79281
                        ],
                        [
                            33.04805,
                            7.79014
                        ],
                        [
                            33.00277,
                            7.8702
                        ],
                        [
                            33.0015,
                            7.93804
                        ],
                        [
                            33.08598,
                            8.07078
                        ],
                        [
                            33.18741,
                            8.12709
                        ],
                        [
                            33.17004,
                            8.2932
                        ],
                        [
                            33.18827,
                            8.38028
                        ],
                        [
                            33.24921,
                            8.44311
                        ],
                        [
                            33.31143,
                            8.45716
                        ],
                        [
                            33.39335,
                            8.42258
                        ],
                        [
                            33.49023,
                            8.46751
                        ],
                        [
                            33.62577,
                            8.46523
                        ],
                        [
                            33.67639,
                            8.43917
                        ],
                        [
                            33.6927,
                            8.37824
                        ],
                        [
                            33.76792,
                            8.36335
                        ],
                        [
                            33.89875,
                            8.47943
                        ],
                        [
                            34.01225,
                            8.48609
                        ],
                        [
                            34.13902,
                            8.5951
                        ],
                        [
                            34.14425,
                            8.70757
                        ],
                        [
                            34.14273,
                            9.04435
                        ],
                        [
                            34.11325,
                            9.49864
                        ],
                        [
                            33.91392,
                            9.4999
                        ],
                        [
                            33.89062,
                            9.54139
                        ],
                        [
                            33.8893,
                            9.62869
                        ],
                        [
                            33.91631,
                            9.74485
                        ],
                        [
                            33.96311,
                            9.8034
                        ],
                        [
                            33.99128,
                            9.91527
                        ],
                        [
                            33.99403,
                            10.05229
                        ],
                        [
                            33.96617,
                            10.14814
                        ],
                        [
                            33.89713,
                            10.17181
                        ],
                        [
                            33.79234,
                            10.33658
                        ],
                        [
                            33.66262,
                            10.44831
                        ],
                        [
                            33.48531,
                            10.65164
                        ],
                        [
                            33.22725,
                            10.74015
                        ],
                        [
                            33.26199,
                            10.84633
                        ],
                        [
                            33.13819,
                            11.62378
                        ],
                        [
                            33.17753,
                            11.7542
                        ],
                        [
                            33.25455,
                            12.14958
                        ],
                        [
                            33.28395,
                            12.21315
                        ],
                        [
                            32.98373,
                            12.2281
                        ],
                        [
                            32.74379,
                            12.23184
                        ],
                        [
                            32.75674,
                            12.01004
                        ],
                        [
                            32.73743,
                            11.95123
                        ],
                        [
                            32.13189,
                            11.93821
                        ],
                        [
                            32.36093,
                            11.72494
                        ],
                        [
                            32.3845,
                            11.69114
                        ],
                        [
                            32.39338,
                            11.59814
                        ],
                        [
                            32.39549,
                            11.2113
                        ],
                        [
                            32.46183,
                            11.04329
                        ],
                        [
                            32.15273,
                            10.74379
                        ],
                        [
                            32.02157,
                            10.66935
                        ],
                        [
                            31.96465,
                            10.61101
                        ],
                        [
                            31.85716,
                            10.40846
                        ],
                        [
                            31.78991,
                            10.30674
                        ],
                        [
                            31.6884,
                            10.20252
                        ],
                        [
                            31.51251,
                            10.00385
                        ],
                        [
                            31.35686,
                            9.80996
                        ],
                        [
                            31.27468,
                            9.75994
                        ],
                        [
                            31.186,
                            9.75038
                        ],
                        [
                            30.90157,
                            9.74802
                        ],
                        [
                            30.82675,
                            9.72389
                        ],
                        [
                            30.52297,
                            9.96437
                        ],
                        [
                            30.00449,
                            10.28309
                        ],
                        [
                            29.94745,
                            10.28621
                        ],
                        [
                            29.54207,
                            10.08093
                        ],
                        [
                            29.53396,
                            9.75208
                        ],
                        [
                            29.08876,
                            9.75175
                        ],
                        [
                            29.01974,
                            9.70051
                        ],
                        [
                            28.97701,
                            9.64116
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "ESP",
                "Country": "Spain",
                "Total_3GHG": 0.61,
                "Total_3GHG_timeseries": [
                    9.2626e-06,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0053,
                    0.0054,
                    0.0055,
                    0.0057,
                    0.0058,
                    0.006,
                    0.0061,
                    0.0063,
                    0.0064,
                    0.0066,
                    0.0068,
                    0.0069,
                    0.0071,
                    0.0073,
                    0.0075,
                    0.0077,
                    0.0079,
                    0.0081,
                    0.0082,
                    0.0084,
                    0.0085,
                    0.0087,
                    0.0088,
                    0.0089,
                    0.0091,
                    0.0092,
                    0.0093,
                    0.0095,
                    0.0096,
                    0.0097,
                    0.0098,
                    0.0099
                ],
                "Fossil_3GHG": 0.77,
                "Fossil_3GHG_timeseries": [
                    7.8666e-07,
                    1.6075e-06,
                    2.5168e-06,
                    3.3823e-06,
                    4.2672e-06,
                    5.2869e-06,
                    6.3764e-06,
                    7.661e-06,
                    9.2413e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0047,
                    0.0048,
                    0.005,
                    0.0051,
                    0.0053,
                    0.0055,
                    0.0056,
                    0.0058,
                    0.006,
                    0.0062,
                    0.0063,
                    0.0065,
                    0.0066,
                    0.0068,
                    0.0069,
                    0.0071,
                    0.0072,
                    0.0073,
                    0.0074,
                    0.0076,
                    0.0077,
                    0.0078,
                    0.0079,
                    0.008,
                    0.0081
                ],
                "Land_3GHG": 0.31,
                "Land_3GHG_timeseries": [
                    8.4759e-06,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018
                ],
                "Total_CO2": 0.63,
                "Total_CO2_timeseries": [
                    6.302e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0044,
                    0.0045,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.0051,
                    0.0053,
                    0.0054,
                    0.0056,
                    0.0057,
                    0.0058,
                    0.0059,
                    0.0061,
                    0.0062,
                    0.0063,
                    0.0064,
                    0.0065,
                    0.0066,
                    0.0067,
                    0.0068,
                    0.0069,
                    0.007,
                    0.0071
                ],
                "Fossil_CO2": 0.89,
                "Fossil_CO2_timeseries": [
                    2.2935e-07,
                    4.7025e-07,
                    7.6395e-07,
                    1.0115e-06,
                    1.2606e-06,
                    1.6005e-06,
                    1.9833e-06,
                    2.5014e-06,
                    3.2357e-06,
                    4.1052e-06,
                    5.0077e-06,
                    5.9928e-06,
                    7.0884e-06,
                    8.1395e-06,
                    9.1773e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0043,
                    0.0044,
                    0.0046,
                    0.0048,
                    0.0049,
                    0.0051,
                    0.0052,
                    0.0054,
                    0.0055,
                    0.0056,
                    0.0058,
                    0.0059,
                    0.006,
                    0.0061,
                    0.0062,
                    0.0063,
                    0.0065,
                    0.0066,
                    0.0067,
                    0.0068,
                    0.0069
                ],
                "Land_CO2": 0.06,
                "Land_CO2_timeseries": [
                    6.0726e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Total_CH4": 0.5,
                "Total_CH4_timeseries": [
                    2.4369e-06,
                    5.0399e-06,
                    7.8222e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021
                ],
                "Fossil_CH4": 0.38,
                "Fossil_CH4_timeseries": [
                    3.0406e-07,
                    6.2752e-07,
                    9.8351e-07,
                    1.3388e-06,
                    1.7089e-06,
                    2.1201e-06,
                    2.5556e-06,
                    3.0484e-06,
                    3.6184e-06,
                    4.2428e-06,
                    4.8583e-06,
                    5.4838e-06,
                    6.1299e-06,
                    6.7453e-06,
                    7.334e-06,
                    7.9072e-06,
                    8.51e-06,
                    9.1103e-06,
                    9.689e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001
                ],
                "Land_CH4": 0.69,
                "Land_CH4_timeseries": [
                    2.1329e-06,
                    4.4124e-06,
                    6.8386e-06,
                    9.4115e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011
                ],
                "Total_N2O": 0.89,
                "Total_N2O_timeseries": [
                    5.2369e-07,
                    1.056e-06,
                    1.5967e-06,
                    2.1453e-06,
                    2.7013e-06,
                    3.2641e-06,
                    3.8329e-06,
                    4.4069e-06,
                    4.9851e-06,
                    5.5665e-06,
                    6.1503e-06,
                    6.7365e-06,
                    7.3247e-06,
                    7.9151e-06,
                    8.5075e-06,
                    9.1019e-06,
                    9.6984e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Fossil_N2O": 1.15,
                "Fossil_N2O_timeseries": [
                    2.5325e-07,
                    5.0972e-07,
                    7.6935e-07,
                    1.0321e-06,
                    1.2977e-06,
                    1.5663e-06,
                    1.8375e-06,
                    2.1112e-06,
                    2.3872e-06,
                    2.6653e-06,
                    2.9454e-06,
                    3.2273e-06,
                    3.5112e-06,
                    3.7968e-06,
                    4.0844e-06,
                    4.3738e-06,
                    4.665e-06,
                    4.9582e-06,
                    5.2532e-06,
                    5.5502e-06,
                    5.8504e-06,
                    6.1557e-06,
                    6.4679e-06,
                    6.788e-06,
                    7.1166e-06,
                    7.4538e-06,
                    7.7994e-06,
                    8.1526e-06,
                    8.5121e-06,
                    8.876e-06,
                    9.2433e-06,
                    9.6137e-06,
                    9.987e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Land_N2O": 0.79,
                "Land_N2O_timeseries": [
                    2.7044e-07,
                    5.4629e-07,
                    8.2731e-07,
                    1.1132e-06,
                    1.4035e-06,
                    1.6978e-06,
                    1.9954e-06,
                    2.2957e-06,
                    2.5979e-06,
                    2.9012e-06,
                    3.205e-06,
                    3.5091e-06,
                    3.8136e-06,
                    4.1182e-06,
                    4.4231e-06,
                    4.7281e-06,
                    5.0334e-06,
                    5.3389e-06,
                    5.6449e-06,
                    5.9514e-06,
                    6.2631e-06,
                    6.5877e-06,
                    6.9314e-06,
                    7.2982e-06,
                    7.6907e-06,
                    8.1093e-06,
                    8.5528e-06,
                    9.0183e-06,
                    9.5007e-06,
                    9.9935e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -1.78598,
                                43.35048
                            ],
                            [
                                -1.88483,
                                43.35002
                            ],
                            [
                                -2.17732,
                                43.28821
                            ],
                            [
                                -2.28505,
                                43.29472
                            ],
                            [
                                -2.464,
                                43.33868
                            ],
                            [
                                -2.50835,
                                43.37601
                            ],
                            [
                                -2.80537,
                                43.43132
                            ],
                            [
                                -2.94518,
                                43.43482
                            ],
                            [
                                -3.03739,
                                43.37272
                            ],
                            [
                                -3.16291,
                                43.3519
                            ],
                            [
                                -3.22523,
                                43.39476
                            ],
                            [
                                -3.42155,
                                43.4131
                            ],
                            [
                                -3.43559,
                                43.46435
                            ],
                            [
                                -3.59431,
                                43.51319
                            ],
                            [
                                -3.71926,
                                43.47468
                            ],
                            [
                                -3.94585,
                                43.46931
                            ],
                            [
                                -4.17356,
                                43.40246
                            ],
                            [
                                -4.32448,
                                43.38925
                            ],
                            [
                                -4.61815,
                                43.39641
                            ],
                            [
                                -5.12324,
                                43.48426
                            ],
                            [
                                -5.21487,
                                43.47371
                            ],
                            [
                                -5.29374,
                                43.53458
                            ],
                            [
                                -5.41022,
                                43.55583
                            ],
                            [
                                -5.64989,
                                43.54263
                            ],
                            [
                                -5.75801,
                                43.58555
                            ],
                            [
                                -5.81143,
                                43.64153
                            ],
                            [
                                -5.91362,
                                43.62364
                            ],
                            [
                                -6.12129,
                                43.55569
                            ],
                            [
                                -6.24671,
                                43.58446
                            ],
                            [
                                -6.35523,
                                43.55107
                            ],
                            [
                                -6.53576,
                                43.54653
                            ],
                            [
                                -6.94443,
                                43.57388
                            ],
                            [
                                -7.03184,
                                43.54447
                            ],
                            [
                                -7.24382,
                                43.56553
                            ],
                            [
                                -7.35715,
                                43.67065
                            ],
                            [
                                -7.55303,
                                43.72967
                            ],
                            [
                                -7.71475,
                                43.76492
                            ],
                            [
                                -7.82751,
                                43.70991
                            ],
                            [
                                -7.86642,
                                43.76922
                            ],
                            [
                                -8.07439,
                                43.65964
                            ],
                            [
                                -8.1869,
                                43.61888
                            ],
                            [
                                -8.32492,
                                43.52211
                            ],
                            [
                                -8.32606,
                                43.4832
                            ],
                            [
                                -8.25725,
                                43.42082
                            ],
                            [
                                -8.33808,
                                43.37847
                            ],
                            [
                                -8.4397,
                                43.38069
                            ],
                            [
                                -8.54768,
                                43.31169
                            ],
                            [
                                -8.70915,
                                43.28994
                            ],
                            [
                                -8.82799,
                                43.32884
                            ],
                            [
                                -8.95637,
                                43.2931
                            ],
                            [
                                -8.9377,
                                43.23272
                            ],
                            [
                                -9.08032,
                                43.18127
                            ],
                            [
                                -9.17461,
                                43.18515
                            ],
                            [
                                -9.21351,
                                43.10275
                            ],
                            [
                                -9.28575,
                                43.04116
                            ],
                            [
                                -9.25712,
                                43.00249
                            ],
                            [
                                -9.297,
                                42.92362
                            ],
                            [
                                -9.13314,
                                42.91013
                            ],
                            [
                                -9.10998,
                                42.84039
                            ],
                            [
                                -9.15008,
                                42.79966
                            ],
                            [
                                -9.10007,
                                42.75417
                            ],
                            [
                                -8.9527,
                                42.78299
                            ],
                            [
                                -9.02885,
                                42.70117
                            ],
                            [
                                -9.05827,
                                42.57709
                            ],
                            [
                                -8.99098,
                                42.55691
                            ],
                            [
                                -8.89913,
                                42.64028
                            ],
                            [
                                -8.80427,
                                42.63812
                            ],
                            [
                                -8.7674,
                                42.60305
                            ],
                            [
                                -8.83788,
                                42.55299
                            ],
                            [
                                -8.81985,
                                42.45878
                            ],
                            [
                                -8.87973,
                                42.41605
                            ],
                            [
                                -8.77625,
                                42.3892
                            ],
                            [
                                -8.75286,
                                42.3438
                            ],
                            [
                                -8.81923,
                                42.31323
                            ],
                            [
                                -8.79285,
                                42.2485
                            ],
                            [
                                -8.81908,
                                42.13089
                            ],
                            [
                                -8.89567,
                                42.11229
                            ],
                            [
                                -8.86319,
                                41.87207
                            ],
                            [
                                -8.66217,
                                42.00354
                            ],
                            [
                                -8.63304,
                                42.04876
                            ],
                            [
                                -8.52722,
                                42.07702
                            ],
                            [
                                -8.33894,
                                42.08459
                            ],
                            [
                                -8.24326,
                                42.13912
                            ],
                            [
                                -8.11848,
                                42.08212
                            ],
                            [
                                -8.08599,
                                42.01699
                            ],
                            [
                                -8.16232,
                                41.9827
                            ],
                            [
                                -8.21653,
                                41.91299
                            ],
                            [
                                -8.12906,
                                41.80907
                            ],
                            [
                                -8.01347,
                                41.82976
                            ],
                            [
                                -7.98822,
                                41.8675
                            ],
                            [
                                -7.84544,
                                41.8646
                            ],
                            [
                                -7.70408,
                                41.90785
                            ],
                            [
                                -7.5846,
                                41.87703
                            ],
                            [
                                -7.57352,
                                41.83044
                            ],
                            [
                                -7.45278,
                                41.86516
                            ],
                            [
                                -7.31401,
                                41.84366
                            ],
                            [
                                -7.19569,
                                41.88203
                            ],
                            [
                                -7.18473,
                                41.97246
                            ],
                            [
                                -7.07531,
                                41.95134
                            ],
                            [
                                -6.82093,
                                41.94728
                            ],
                            [
                                -6.69541,
                                41.9337
                            ],
                            [
                                -6.59873,
                                41.9494
                            ],
                            [
                                -6.51673,
                                41.8729
                            ],
                            [
                                -6.55667,
                                41.73741
                            ],
                            [
                                -6.5121,
                                41.66126
                            ],
                            [
                                -6.44624,
                                41.68417
                            ],
                            [
                                -6.35415,
                                41.67633
                            ],
                            [
                                -6.25472,
                                41.63392
                            ],
                            [
                                -6.18935,
                                41.57505
                            ],
                            [
                                -6.29663,
                                41.43328
                            ],
                            [
                                -6.39147,
                                41.38375
                            ],
                            [
                                -6.43929,
                                41.30472
                            ],
                            [
                                -6.55248,
                                41.24543
                            ],
                            [
                                -6.6479,
                                41.24727
                            ],
                            [
                                -6.76982,
                                41.12431
                            ],
                            [
                                -6.77476,
                                41.0739
                            ],
                            [
                                -6.83292,
                                41.02911
                            ],
                            [
                                -6.93072,
                                41.01689
                            ],
                            [
                                -6.86068,
                                40.94946
                            ],
                            [
                                -6.8022,
                                40.84514
                            ],
                            [
                                -6.82959,
                                40.74118
                            ],
                            [
                                -6.79924,
                                40.65448
                            ],
                            [
                                -6.84464,
                                40.56679
                            ],
                            [
                                -6.79583,
                                40.5119
                            ],
                            [
                                -6.84925,
                                40.45118
                            ],
                            [
                                -6.78191,
                                40.36556
                            ],
                            [
                                -6.86108,
                                40.29976
                            ],
                            [
                                -6.9513,
                                40.25745
                            ],
                            [
                                -7.02769,
                                40.18696
                            ],
                            [
                                -6.99586,
                                40.11903
                            ],
                            [
                                -6.94268,
                                40.11252
                            ],
                            [
                                -6.8742,
                                39.99584
                            ],
                            [
                                -6.90389,
                                39.87337
                            ],
                            [
                                -6.98216,
                                39.81832
                            ],
                            [
                                -7.01563,
                                39.67172
                            ],
                            [
                                -7.1467,
                                39.65303
                            ],
                            [
                                -7.24534,
                                39.66692
                            ],
                            [
                                -7.33392,
                                39.64155
                            ],
                            [
                                -7.53599,
                                39.66775
                            ],
                            [
                                -7.49862,
                                39.58939
                            ],
                            [
                                -7.38926,
                                39.50326
                            ],
                            [
                                -7.29554,
                                39.45596
                            ],
                            [
                                -7.30879,
                                39.33766
                            ],
                            [
                                -7.23147,
                                39.27843
                            ],
                            [
                                -7.24143,
                                39.20861
                            ],
                            [
                                -7.13729,
                                39.17195
                            ],
                            [
                                -7.14388,
                                39.10932
                            ],
                            [
                                -7.05078,
                                39.11811
                            ],
                            [
                                -6.98191,
                                39.0884
                            ],
                            [
                                -6.95265,
                                39.02336
                            ],
                            [
                                -7.05103,
                                38.90608
                            ],
                            [
                                -7.03388,
                                38.87776
                            ],
                            [
                                -7.25516,
                                38.72519
                            ],
                            [
                                -7.30365,
                                38.54165
                            ],
                            [
                                -7.31702,
                                38.43926
                            ],
                            [
                                -7.15224,
                                38.27541
                            ],
                            [
                                -7.10795,
                                38.18812
                            ],
                            [
                                -6.96853,
                                38.16537
                            ],
                            [
                                -7.00753,
                                38.02127
                            ],
                            [
                                -7.09878,
                                38.04323
                            ],
                            [
                                -7.13612,
                                37.99969
                            ],
                            [
                                -7.20262,
                                38.0028
                            ],
                            [
                                -7.24939,
                                37.95516
                            ],
                            [
                                -7.32491,
                                37.81607
                            ],
                            [
                                -7.41986,
                                37.74521
                            ],
                            [
                                -7.44532,
                                37.66527
                            ],
                            [
                                -7.52294,
                                37.55345
                            ],
                            [
                                -7.45693,
                                37.45158
                            ],
                            [
                                -7.44203,
                                37.31517
                            ],
                            [
                                -7.40192,
                                37.17483
                            ],
                            [
                                -7.28481,
                                37.20061
                            ],
                            [
                                -7.02771,
                                37.20318
                            ],
                            [
                                -6.76021,
                                37.10538
                            ],
                            [
                                -6.5092,
                                36.96765
                            ],
                            [
                                -6.44778,
                                36.90544
                            ],
                            [
                                -6.39551,
                                36.80626
                            ],
                            [
                                -6.43945,
                                36.71997
                            ],
                            [
                                -6.38837,
                                36.62925
                            ],
                            [
                                -6.29905,
                                36.61755
                            ],
                            [
                                -6.22443,
                                36.56089
                            ],
                            [
                                -6.24995,
                                36.45074
                            ],
                            [
                                -6.14263,
                                36.2967
                            ],
                            [
                                -6.05483,
                                36.20578
                            ],
                            [
                                -5.97757,
                                36.17737
                            ],
                            [
                                -5.91506,
                                36.18458
                            ],
                            [
                                -5.79699,
                                36.07884
                            ],
                            [
                                -5.64446,
                                36.04809
                            ],
                            [
                                -5.6082,
                                36.00846
                            ],
                            [
                                -5.42744,
                                36.0757
                            ],
                            [
                                -5.44661,
                                36.14052
                            ],
                            [
                                -5.35152,
                                36.15257
                            ],
                            [
                                -5.33922,
                                36.15203
                            ],
                            [
                                -5.3127,
                                36.23605
                            ],
                            [
                                -5.17591,
                                36.4147
                            ],
                            [
                                -5.00559,
                                36.45956
                            ],
                            [
                                -4.93511,
                                36.49939
                            ],
                            [
                                -4.85564,
                                36.50665
                            ],
                            [
                                -4.75864,
                                36.48609
                            ],
                            [
                                -4.63964,
                                36.50702
                            ],
                            [
                                -4.58992,
                                36.57134
                            ],
                            [
                                -4.50951,
                                36.59935
                            ],
                            [
                                -4.43317,
                                36.70171
                            ],
                            [
                                -4.39106,
                                36.7221
                            ],
                            [
                                -4.2505,
                                36.71025
                            ],
                            [
                                -4.11039,
                                36.72503
                            ],
                            [
                                -4.07961,
                                36.74672
                            ],
                            [
                                -3.95728,
                                36.7261
                            ],
                            [
                                -3.83565,
                                36.75359
                            ],
                            [
                                -3.76692,
                                36.72922
                            ],
                            [
                                -3.60172,
                                36.74382
                            ],
                            [
                                -3.55074,
                                36.71491
                            ],
                            [
                                -3.42038,
                                36.69458
                            ],
                            [
                                -3.3384,
                                36.7384
                            ],
                            [
                                -3.24951,
                                36.75455
                            ],
                            [
                                -2.97679,
                                36.73844
                            ],
                            [
                                -2.91612,
                                36.74889
                            ],
                            [
                                -2.85789,
                                36.69928
                            ],
                            [
                                -2.77216,
                                36.68164
                            ],
                            [
                                -2.64636,
                                36.70259
                            ],
                            [
                                -2.56215,
                                36.81602
                            ],
                            [
                                -2.47298,
                                36.83655
                            ],
                            [
                                -2.42793,
                                36.81074
                            ],
                            [
                                -2.36766,
                                36.84133
                            ],
                            [
                                -2.25982,
                                36.79425
                            ],
                            [
                                -2.19346,
                                36.72266
                            ],
                            [
                                -2.13542,
                                36.72977
                            ],
                            [
                                -1.9454,
                                36.93225
                            ],
                            [
                                -1.84985,
                                37.0684
                            ],
                            [
                                -1.8031,
                                37.22102
                            ],
                            [
                                -1.67416,
                                37.35499
                            ],
                            [
                                -1.51753,
                                37.4317
                            ],
                            [
                                -1.45364,
                                37.491
                            ],
                            [
                                -1.3256,
                                37.56198
                            ],
                            [
                                -1.20285,
                                37.57338
                            ],
                            [
                                -1.16489,
                                37.54233
                            ],
                            [
                                -1.07351,
                                37.58274
                            ],
                            [
                                -0.9209,
                                37.55654
                            ],
                            [
                                -0.72074,
                                37.60651
                            ],
                            [
                                -0.85998,
                                37.72145
                            ],
                            [
                                -0.77588,
                                37.8189
                            ],
                            [
                                -0.75026,
                                37.89757
                            ],
                            [
                                -0.64773,
                                38.0021
                            ],
                            [
                                -0.6369,
                                38.13592
                            ],
                            [
                                -0.58876,
                                38.18943
                            ],
                            [
                                -0.50754,
                                38.21087
                            ],
                            [
                                -0.50992,
                                38.32672
                            ],
                            [
                                -0.44565,
                                38.36208
                            ],
                            [
                                -0.37408,
                                38.44233
                            ],
                            [
                                -0.1544,
                                38.53355
                            ],
                            [
                                -0.09688,
                                38.5248
                            ],
                            [
                                -0.02931,
                                38.61804
                            ],
                            [
                                0.06828,
                                38.63933
                            ],
                            [
                                0.15416,
                                38.68645
                            ],
                            [
                                0.22247,
                                38.76235
                            ],
                            [
                                0.19758,
                                38.80354
                            ],
                            [
                                0.09276,
                                38.85459
                            ],
                            [
                                -0.02303,
                                38.87625
                            ],
                            [
                                -0.14687,
                                38.9834
                            ],
                            [
                                -0.23688,
                                39.13908
                            ],
                            [
                                -0.21965,
                                39.18128
                            ],
                            [
                                -0.29075,
                                39.3061
                            ],
                            [
                                -0.33443,
                                39.42324
                            ],
                            [
                                -0.32095,
                                39.50799
                            ],
                            [
                                -0.25882,
                                39.61493
                            ],
                            [
                                -0.21081,
                                39.65443
                            ],
                            [
                                -0.17747,
                                39.74031
                            ],
                            [
                                -0.07866,
                                39.86066
                            ],
                            [
                                -0.01002,
                                39.91104
                            ],
                            [
                                0.0518,
                                40.03737
                            ],
                            [
                                0.12017,
                                40.06271
                            ],
                            [
                                0.20122,
                                40.18075
                            ],
                            [
                                0.2646,
                                40.21052
                            ],
                            [
                                0.40416,
                                40.36226
                            ],
                            [
                                0.53858,
                                40.56732
                            ],
                            [
                                0.60314,
                                40.62191
                            ],
                            [
                                0.74604,
                                40.63618
                            ],
                            [
                                0.84914,
                                40.67958
                            ],
                            [
                                0.83488,
                                40.73148
                            ],
                            [
                                0.70042,
                                40.80341
                            ],
                            [
                                0.79232,
                                40.86735
                            ],
                            [
                                0.9656,
                                41.02757
                            ],
                            [
                                1.04936,
                                41.06393
                            ],
                            [
                                1.18049,
                                41.06298
                            ],
                            [
                                1.21818,
                                41.10523
                            ],
                            [
                                1.40739,
                                41.14078
                            ],
                            [
                                1.52722,
                                41.18085
                            ],
                            [
                                1.67315,
                                41.19825
                            ],
                            [
                                1.92235,
                                41.26001
                            ],
                            [
                                2.11957,
                                41.29206
                            ],
                            [
                                2.25368,
                                41.4487
                            ],
                            [
                                2.53216,
                                41.57
                            ],
                            [
                                2.77851,
                                41.64881
                            ],
                            [
                                2.854,
                                41.69955
                            ],
                            [
                                2.93361,
                                41.71579
                            ],
                            [
                                3.0562,
                                41.78754
                            ],
                            [
                                3.10002,
                                41.84308
                            ],
                            [
                                3.17742,
                                41.86787
                            ],
                            [
                                3.23136,
                                41.96727
                            ],
                            [
                                3.17598,
                                42.11112
                            ],
                            [
                                3.1245,
                                42.12841
                            ],
                            [
                                3.11749,
                                42.2226
                            ],
                            [
                                3.28062,
                                42.25492
                            ],
                            [
                                3.30479,
                                42.32682
                            ],
                            [
                                3.16417,
                                42.36062
                            ],
                            [
                                3.1748,
                                42.43537
                            ],
                            [
                                3.08597,
                                42.42578
                            ],
                            [
                                3.0402,
                                42.47353
                            ],
                            [
                                2.84002,
                                42.45875
                            ],
                            [
                                2.65427,
                                42.38602
                            ],
                            [
                                2.48271,
                                42.34035
                            ],
                            [
                                2.43188,
                                42.39359
                            ],
                            [
                                2.25711,
                                42.43867
                            ],
                            [
                                2.13309,
                                42.41455
                            ],
                            [
                                2.1154,
                                42.38292
                            ],
                            [
                                2.01171,
                                42.3527
                            ],
                            [
                                1.94286,
                                42.44443
                            ],
                            [
                                1.7258,
                                42.5044
                            ],
                            [
                                1.6627,
                                42.49326
                            ],
                            [
                                1.5519,
                                42.43343
                            ],
                            [
                                1.44945,
                                42.43839
                            ],
                            [
                                1.46726,
                                42.51108
                            ],
                            [
                                1.44257,
                                42.60367
                            ],
                            [
                                1.3573,
                                42.71942
                            ],
                            [
                                1.17077,
                                42.70814
                            ],
                            [
                                1.07207,
                                42.7828
                            ],
                            [
                                0.70843,
                                42.86125
                            ],
                            [
                                0.66254,
                                42.84124
                            ],
                            [
                                0.66948,
                                42.68959
                            ],
                            [
                                0.52637,
                                42.70252
                            ],
                            [
                                0.43631,
                                42.6897
                            ],
                            [
                                0.36013,
                                42.72435
                            ],
                            [
                                0.25991,
                                42.71601
                            ],
                            [
                                0.1769,
                                42.73652
                            ],
                            [
                                -0.01009,
                                42.68477
                            ],
                            [
                                -0.06158,
                                42.69468
                            ],
                            [
                                -0.15466,
                                42.78212
                            ],
                            [
                                -0.27811,
                                42.83581
                            ],
                            [
                                -0.3943,
                                42.79961
                            ],
                            [
                                -0.51018,
                                42.82502
                            ],
                            [
                                -0.57514,
                                42.80778
                            ],
                            [
                                -0.679,
                                42.88383
                            ],
                            [
                                -0.73232,
                                42.89744
                            ],
                            [
                                -0.75354,
                                42.96733
                            ],
                            [
                                -0.94518,
                                42.95384
                            ],
                            [
                                -1.1147,
                                43.02313
                            ],
                            [
                                -1.24777,
                                43.0429
                            ],
                            [
                                -1.34563,
                                43.092
                            ],
                            [
                                -1.35373,
                                43.02798
                            ],
                            [
                                -1.4719,
                                43.08126
                            ],
                            [
                                -1.38235,
                                43.18902
                            ],
                            [
                                -1.38451,
                                43.25337
                            ],
                            [
                                -1.53544,
                                43.29435
                            ],
                            [
                                -1.57477,
                                43.25042
                            ],
                            [
                                -1.66629,
                                43.31418
                            ],
                            [
                                -1.7289,
                                43.29609
                            ],
                            [
                                -1.78598,
                                43.35048
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                3.17671,
                                39.95323
                            ],
                            [
                                3.06268,
                                39.92127
                            ],
                            [
                                2.94949,
                                39.91853
                            ],
                            [
                                2.84401,
                                39.86192
                            ],
                            [
                                2.779,
                                39.85533
                            ],
                            [
                                2.66953,
                                39.79237
                            ],
                            [
                                2.58698,
                                39.71759
                            ],
                            [
                                2.52762,
                                39.70104
                            ],
                            [
                                2.34486,
                                39.58795
                            ],
                            [
                                2.36765,
                                39.53706
                            ],
                            [
                                2.53938,
                                39.52261
                            ],
                            [
                                2.64151,
                                39.56787
                            ],
                            [
                                2.72032,
                                39.53439
                            ],
                            [
                                2.73963,
                                39.41106
                            ],
                            [
                                2.78767,
                                39.36346
                            ],
                            [
                                2.95876,
                                39.36181
                            ],
                            [
                                3.06967,
                                39.26766
                            ],
                            [
                                3.11904,
                                39.31221
                            ],
                            [
                                3.22946,
                                39.36021
                            ],
                            [
                                3.29642,
                                39.49905
                            ],
                            [
                                3.37416,
                                39.55885
                            ],
                            [
                                3.40363,
                                39.63541
                            ],
                            [
                                3.45567,
                                39.65747
                            ],
                            [
                                3.43424,
                                39.74468
                            ],
                            [
                                3.34717,
                                39.78818
                            ],
                            [
                                3.25249,
                                39.72985
                            ],
                            [
                                3.1449,
                                39.77385
                            ],
                            [
                                3.08636,
                                39.90858
                            ],
                            [
                                3.17671,
                                39.95323
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -16.12726,
                                28.5703
                            ],
                            [
                                -16.3324,
                                28.5717
                            ],
                            [
                                -16.52321,
                                28.4176
                            ],
                            [
                                -16.60298,
                                28.39431
                            ],
                            [
                                -16.67373,
                                28.4003
                            ],
                            [
                                -16.75123,
                                28.37163
                            ],
                            [
                                -16.8298,
                                28.39234
                            ],
                            [
                                -16.90565,
                                28.33791
                            ],
                            [
                                -16.83849,
                                28.25724
                            ],
                            [
                                -16.83579,
                                28.2075
                            ],
                            [
                                -16.73846,
                                28.08756
                            ],
                            [
                                -16.70724,
                                28.01051
                            ],
                            [
                                -16.64457,
                                28.00394
                            ],
                            [
                                -16.54094,
                                28.0418
                            ],
                            [
                                -16.42676,
                                28.15163
                            ],
                            [
                                -16.42406,
                                28.20531
                            ],
                            [
                                -16.36252,
                                28.30469
                            ],
                            [
                                -16.35995,
                                28.3786
                            ],
                            [
                                -16.24976,
                                28.45585
                            ],
                            [
                                -16.23504,
                                28.48583
                            ],
                            [
                                -16.12921,
                                28.53695
                            ],
                            [
                                -16.12726,
                                28.5703
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -13.87753,
                                28.75074
                            ],
                            [
                                -13.97792,
                                28.7332
                            ],
                            [
                                -14.10114,
                                28.47537
                            ],
                            [
                                -14.14588,
                                28.43852
                            ],
                            [
                                -14.20086,
                                28.33107
                            ],
                            [
                                -14.2156,
                                28.22807
                            ],
                            [
                                -14.31095,
                                28.14717
                            ],
                            [
                                -14.49349,
                                28.08538
                            ],
                            [
                                -14.33075,
                                28.04518
                            ],
                            [
                                -14.22141,
                                28.16296
                            ],
                            [
                                -14.01155,
                                28.20831
                            ],
                            [
                                -13.91504,
                                28.25779
                            ],
                            [
                                -13.85066,
                                28.42046
                            ],
                            [
                                -13.86725,
                                28.48069
                            ],
                            [
                                -13.82604,
                                28.55347
                            ],
                            [
                                -13.84326,
                                28.72598
                            ],
                            [
                                -13.87753,
                                28.75074
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -15.42884,
                                28.12927
                            ],
                            [
                                -15.52525,
                                28.15408
                            ],
                            [
                                -15.69709,
                                28.151
                            ],
                            [
                                -15.70924,
                                28.08671
                            ],
                            [
                                -15.81831,
                                28.00385
                            ],
                            [
                                -15.83356,
                                27.91209
                            ],
                            [
                                -15.78811,
                                27.8357
                            ],
                            [
                                -15.67307,
                                27.74974
                            ],
                            [
                                -15.6003,
                                27.73541
                            ],
                            [
                                -15.44169,
                                27.79997
                            ],
                            [
                                -15.38597,
                                27.85795
                            ],
                            [
                                -15.38255,
                                27.97277
                            ],
                            [
                                -15.42884,
                                28.12927
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -13.46423,
                                29.12811
                            ],
                            [
                                -13.41999,
                                29.20144
                            ],
                            [
                                -13.49622,
                                29.21815
                            ],
                            [
                                -13.54113,
                                29.1232
                            ],
                            [
                                -13.60422,
                                29.13519
                            ],
                            [
                                -13.70766,
                                29.08018
                            ],
                            [
                                -13.75223,
                                29.07881
                            ],
                            [
                                -13.82923,
                                29.00827
                            ],
                            [
                                -13.83013,
                                28.92887
                            ],
                            [
                                -13.87165,
                                28.8557
                            ],
                            [
                                -13.79186,
                                28.85152
                            ],
                            [
                                -13.73897,
                                28.90433
                            ],
                            [
                                -13.64298,
                                28.91982
                            ],
                            [
                                -13.47808,
                                29.0043
                            ],
                            [
                                -13.44844,
                                29.08952
                            ],
                            [
                                -13.46423,
                                29.12811
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                4.09361,
                                40.06178
                            ],
                            [
                                3.82214,
                                40.05018
                            ],
                            [
                                3.82036,
                                39.92802
                            ],
                            [
                                4.02072,
                                39.92179
                            ],
                            [
                                4.20709,
                                39.82582
                            ],
                            [
                                4.2726,
                                39.80931
                            ],
                            [
                                4.31256,
                                39.88165
                            ],
                            [
                                4.25713,
                                39.96461
                            ],
                            [
                                4.09361,
                                40.06178
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -17.90411,
                                28.84816
                            ],
                            [
                                -18.00303,
                                28.78611
                            ],
                            [
                                -17.96342,
                                28.66764
                            ],
                            [
                                -17.83379,
                                28.45776
                            ],
                            [
                                -17.75948,
                                28.57382
                            ],
                            [
                                -17.77028,
                                28.67604
                            ],
                            [
                                -17.7246,
                                28.74111
                            ],
                            [
                                -17.77803,
                                28.83872
                            ],
                            [
                                -17.90411,
                                28.84816
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                1.54109,
                                39.11581
                            ],
                            [
                                1.35926,
                                39.07417
                            ],
                            [
                                1.29207,
                                39.02876
                            ],
                            [
                                1.30673,
                                38.97756
                            ],
                            [
                                1.21605,
                                38.95823
                            ],
                            [
                                1.21411,
                                38.89885
                            ],
                            [
                                1.34393,
                                38.87011
                            ],
                            [
                                1.52639,
                                38.94606
                            ],
                            [
                                1.61845,
                                39.03323
                            ],
                            [
                                1.60213,
                                39.09076
                            ],
                            [
                                1.54109,
                                39.11581
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -17.25067,
                                28.20501
                            ],
                            [
                                -17.31725,
                                28.20433
                            ],
                            [
                                -17.34846,
                                28.09986
                            ],
                            [
                                -17.24547,
                                28.02046
                            ],
                            [
                                -17.16776,
                                28.04107
                            ],
                            [
                                -17.09959,
                                28.09495
                            ],
                            [
                                -17.11899,
                                28.15144
                            ],
                            [
                                -17.1958,
                                28.19867
                            ],
                            [
                                -17.25067,
                                28.20501
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -17.90513,
                                27.84169
                            ],
                            [
                                -17.95807,
                                27.84125
                            ],
                            [
                                -17.99612,
                                27.79261
                            ],
                            [
                                -18.06871,
                                27.75373
                            ],
                            [
                                -18.15097,
                                27.75971
                            ],
                            [
                                -18.15836,
                                27.7129
                            ],
                            [
                                -18.0509,
                                27.69271
                            ],
                            [
                                -17.9715,
                                27.64815
                            ],
                            [
                                -17.88385,
                                27.81221
                            ],
                            [
                                -17.90513,
                                27.84169
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "LKA",
                "Country": "Sri Lanka",
                "Total_3GHG": 0.1,
                "Total_3GHG_timeseries": [
                    5.5005e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016
                ],
                "Fossil_3GHG": 0.06,
                "Fossil_3GHG_timeseries": [
                    2.8657e-07,
                    5.717e-07,
                    8.5542e-07,
                    1.1378e-06,
                    1.417e-06,
                    1.6932e-06,
                    1.9664e-06,
                    2.2395e-06,
                    2.5127e-06,
                    2.7861e-06,
                    3.0568e-06,
                    3.3244e-06,
                    3.5888e-06,
                    3.8501e-06,
                    4.106e-06,
                    4.3566e-06,
                    4.6017e-06,
                    4.8566e-06,
                    5.123e-06,
                    5.4026e-06,
                    5.7184e-06,
                    6.0247e-06,
                    6.3215e-06,
                    6.609e-06,
                    6.889e-06,
                    7.1614e-06,
                    7.4264e-06,
                    7.681e-06,
                    7.9249e-06,
                    8.158e-06,
                    8.3892e-06,
                    8.6195e-06,
                    8.8491e-06,
                    9.0783e-06,
                    9.3084e-06,
                    9.5396e-06,
                    9.7721e-06,
                    9.9927e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006
                ],
                "Land_3GHG": 0.17,
                "Land_3GHG_timeseries": [
                    5.214e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001
                ],
                "Total_CO2": 0.08,
                "Total_CO2_timeseries": [
                    4.3842e-06,
                    8.603e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001
                ],
                "Fossil_CO2": 0.03,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    7.326e-07,
                    1.4288e-06,
                    2.3015e-06,
                    3.232e-06,
                    4.0354e-06,
                    4.7844e-06,
                    5.4228e-06,
                    6.4671e-06,
                    7.3448e-06,
                    8.2702e-06,
                    9.2865e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_CO2": 0.2,
                "Land_CO2_timeseries": [
                    4.3842e-06,
                    8.603e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Total_CH4": 0.13,
                "Total_CH4_timeseries": [
                    9.4639e-07,
                    1.8873e-06,
                    2.8229e-06,
                    3.7531e-06,
                    4.6763e-06,
                    5.5924e-06,
                    6.5015e-06,
                    7.4067e-06,
                    8.308e-06,
                    9.2057e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Fossil_CH4": 0.13,
                "Fossil_CH4_timeseries": [
                    2.6476e-07,
                    5.278e-07,
                    7.8916e-07,
                    1.0489e-06,
                    1.3052e-06,
                    1.5583e-06,
                    1.808e-06,
                    2.0576e-06,
                    2.307e-06,
                    2.5565e-06,
                    2.8031e-06,
                    3.0463e-06,
                    3.2863e-06,
                    3.523e-06,
                    3.7542e-06,
                    3.9798e-06,
                    4.1999e-06,
                    4.4296e-06,
                    4.6705e-06,
                    4.9246e-06,
                    5.2146e-06,
                    5.4946e-06,
                    5.7645e-06,
                    6.0244e-06,
                    6.2759e-06,
                    6.5192e-06,
                    6.7543e-06,
                    6.9782e-06,
                    7.191e-06,
                    7.3925e-06,
                    7.5918e-06,
                    7.79e-06,
                    7.9872e-06,
                    8.1838e-06,
                    8.381e-06,
                    8.5791e-06,
                    8.7783e-06,
                    8.9654e-06,
                    9.1396e-06,
                    9.298e-06,
                    9.4754e-06,
                    9.6732e-06,
                    9.8905e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Land_CH4": 0.14,
                "Land_CH4_timeseries": [
                    6.8163e-07,
                    1.3595e-06,
                    2.0337e-06,
                    2.7042e-06,
                    3.371e-06,
                    4.0341e-06,
                    4.6934e-06,
                    5.3491e-06,
                    6.001e-06,
                    6.6492e-06,
                    7.2873e-06,
                    7.9152e-06,
                    8.533e-06,
                    9.1406e-06,
                    9.7382e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Total_N2O": 0.11,
                "Total_N2O_timeseries": [
                    1.6991e-07,
                    3.4307e-07,
                    5.1934e-07,
                    6.9853e-07,
                    8.8042e-07,
                    1.0647e-06,
                    1.2511e-06,
                    1.4391e-06,
                    1.6284e-06,
                    1.8185e-06,
                    2.0089e-06,
                    2.1998e-06,
                    2.391e-06,
                    2.5824e-06,
                    2.7741e-06,
                    2.9661e-06,
                    3.1583e-06,
                    3.3509e-06,
                    3.5438e-06,
                    3.7372e-06,
                    3.9337e-06,
                    4.1378e-06,
                    4.3529e-06,
                    4.5815e-06,
                    4.8248e-06,
                    5.0832e-06,
                    5.356e-06,
                    5.6415e-06,
                    5.9369e-06,
                    6.2383e-06,
                    6.5433e-06,
                    6.8512e-06,
                    7.1616e-06,
                    7.4742e-06,
                    7.7887e-06,
                    8.1051e-06,
                    8.4234e-06,
                    8.7437e-06,
                    9.0662e-06,
                    9.4012e-06,
                    9.7373e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_N2O": 0.1,
                "Fossil_N2O_timeseries": [
                    2.1808e-08,
                    4.3898e-08,
                    6.6265e-08,
                    8.89e-08,
                    1.1179e-07,
                    1.3493e-07,
                    1.5831e-07,
                    1.819e-07,
                    2.0568e-07,
                    2.2965e-07,
                    2.5377e-07,
                    2.7806e-07,
                    3.025e-07,
                    3.271e-07,
                    3.5186e-07,
                    3.7677e-07,
                    4.0184e-07,
                    4.2707e-07,
                    4.5245e-07,
                    4.78e-07,
                    5.0383e-07,
                    5.3013e-07,
                    5.5703e-07,
                    5.8465e-07,
                    6.1304e-07,
                    6.4221e-07,
                    6.7214e-07,
                    7.0275e-07,
                    7.3393e-07,
                    7.655e-07,
                    7.9737e-07,
                    8.2951e-07,
                    8.619e-07,
                    8.9453e-07,
                    9.2738e-07,
                    9.6046e-07,
                    9.9376e-07,
                    1.0273e-06,
                    1.0611e-06,
                    1.096e-06,
                    1.1315e-06,
                    1.1675e-06,
                    1.204e-06,
                    1.2411e-06,
                    1.2787e-06,
                    1.317e-06,
                    1.3558e-06,
                    1.3953e-06,
                    1.4355e-06,
                    1.4764e-06,
                    1.518e-06,
                    1.5605e-06,
                    1.6039e-06,
                    1.6482e-06,
                    1.6935e-06,
                    1.7398e-06,
                    1.787e-06,
                    1.8351e-06,
                    1.884e-06,
                    1.9337e-06,
                    1.984e-06,
                    2.035e-06,
                    2.0865e-06,
                    2.1386e-06,
                    2.1913e-06,
                    2.2446e-06,
                    2.2984e-06,
                    2.3527e-06,
                    2.4075e-06,
                    2.4629e-06,
                    2.5188e-06,
                    2.5751e-06,
                    2.632e-06,
                    2.6894e-06,
                    2.7472e-06,
                    2.8055e-06,
                    2.8643e-06,
                    2.9236e-06,
                    2.9834e-06,
                    3.0438e-06,
                    3.105e-06,
                    3.1668e-06,
                    3.2296e-06,
                    3.2934e-06,
                    3.3582e-06,
                    3.4241e-06,
                    3.4911e-06,
                    3.5592e-06,
                    3.6284e-06,
                    3.6986e-06,
                    3.7701e-06,
                    3.8431e-06,
                    3.9179e-06,
                    3.9947e-06,
                    4.0737e-06,
                    4.1548e-06,
                    4.2383e-06,
                    4.3239e-06,
                    4.4117e-06,
                    4.5016e-06,
                    4.5936e-06,
                    4.6885e-06,
                    4.7866e-06,
                    4.8883e-06,
                    4.9938e-06,
                    5.1031e-06,
                    5.2163e-06,
                    5.3332e-06,
                    5.4536e-06,
                    5.577e-06,
                    5.703e-06,
                    5.8316e-06,
                    5.9626e-06,
                    6.0961e-06,
                    6.2321e-06,
                    6.371e-06,
                    6.5131e-06,
                    6.6588e-06,
                    6.8087e-06,
                    6.9691e-06,
                    7.1274e-06,
                    7.2952e-06,
                    7.4621e-06,
                    7.627e-06,
                    7.797e-06,
                    7.9676e-06,
                    8.1429e-06,
                    8.3289e-06,
                    8.5233e-06,
                    8.7166e-06,
                    8.9134e-06,
                    9.119e-06,
                    9.3289e-06,
                    9.5468e-06,
                    9.7651e-06,
                    9.9875e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.12,
                "Land_N2O_timeseries": [
                    1.481e-07,
                    2.9917e-07,
                    4.5307e-07,
                    6.0963e-07,
                    7.6862e-07,
                    9.2977e-07,
                    1.0928e-06,
                    1.2572e-06,
                    1.4227e-06,
                    1.5888e-06,
                    1.7552e-06,
                    1.9217e-06,
                    2.0885e-06,
                    2.2553e-06,
                    2.4223e-06,
                    2.5893e-06,
                    2.7565e-06,
                    2.9238e-06,
                    3.0914e-06,
                    3.2592e-06,
                    3.4299e-06,
                    3.6077e-06,
                    3.7959e-06,
                    3.9968e-06,
                    4.2117e-06,
                    4.441e-06,
                    4.6839e-06,
                    4.9388e-06,
                    5.203e-06,
                    5.4728e-06,
                    5.7459e-06,
                    6.0217e-06,
                    6.2997e-06,
                    6.5796e-06,
                    6.8613e-06,
                    7.1447e-06,
                    7.4297e-06,
                    7.7164e-06,
                    8.0051e-06,
                    8.3052e-06,
                    8.6058e-06,
                    8.9071e-06,
                    9.2091e-06,
                    9.5118e-06,
                    9.8152e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                81.01759,
                                8.91639
                            ],
                            [
                                80.8794,
                                9.12674
                            ],
                            [
                                80.80787,
                                9.29275
                            ],
                            [
                                80.62369,
                                9.45941
                            ],
                            [
                                80.36273,
                                9.66514
                            ],
                            [
                                80.25243,
                                9.82132
                            ],
                            [
                                80.20962,
                                9.83351
                            ],
                            [
                                80.10334,
                                9.8111
                            ],
                            [
                                79.98803,
                                9.81071
                            ],
                            [
                                79.90887,
                                9.75954
                            ],
                            [
                                79.94566,
                                9.69345
                            ],
                            [
                                80.12552,
                                9.60955
                            ],
                            [
                                80.17845,
                                9.65168
                            ],
                            [
                                80.33029,
                                9.5692
                            ],
                            [
                                80.39105,
                                9.51161
                            ],
                            [
                                80.33014,
                                9.4584
                            ],
                            [
                                80.28155,
                                9.45585
                            ],
                            [
                                80.23201,
                                9.52934
                            ],
                            [
                                80.16715,
                                9.54698
                            ],
                            [
                                80.17735,
                                9.47195
                            ],
                            [
                                80.06233,
                                9.39538
                            ],
                            [
                                80.06609,
                                9.33324
                            ],
                            [
                                80.11945,
                                9.29633
                            ],
                            [
                                80.11761,
                                9.21697
                            ],
                            [
                                80.06643,
                                9.06341
                            ],
                            [
                                79.98478,
                                8.9733
                            ],
                            [
                                79.92117,
                                8.94302
                            ],
                            [
                                79.92097,
                                8.81822
                            ],
                            [
                                79.95613,
                                8.72295
                            ],
                            [
                                79.94569,
                                8.62872
                            ],
                            [
                                79.91696,
                                8.55551
                            ],
                            [
                                79.87156,
                                8.53253
                            ],
                            [
                                79.84416,
                                8.4249
                            ],
                            [
                                79.83442,
                                8.3002
                            ],
                            [
                                79.80943,
                                8.2429
                            ],
                            [
                                79.83007,
                                8.13131
                            ],
                            [
                                79.79514,
                                8.08159
                            ],
                            [
                                79.83225,
                                8.0146
                            ],
                            [
                                79.75867,
                                7.9877
                            ],
                            [
                                79.72912,
                                8.13194
                            ],
                            [
                                79.74312,
                                8.20655
                            ],
                            [
                                79.69786,
                                8.20723
                            ],
                            [
                                79.70795,
                                8.05262
                            ],
                            [
                                79.78291,
                                7.78156
                            ],
                            [
                                79.79974,
                                7.64102
                            ],
                            [
                                79.78964,
                                7.54421
                            ],
                            [
                                79.8346,
                                7.32118
                            ],
                            [
                                79.83731,
                                7.2221
                            ],
                            [
                                79.81872,
                                7.19464
                            ],
                            [
                                79.86817,
                                6.98542
                            ],
                            [
                                79.84326,
                                6.93073
                            ],
                            [
                                79.86623,
                                6.81662
                            ],
                            [
                                79.97781,
                                6.52241
                            ],
                            [
                                79.99396,
                                6.42837
                            ],
                            [
                                80.06324,
                                6.19313
                            ],
                            [
                                80.12773,
                                6.09718
                            ],
                            [
                                80.26465,
                                5.99923
                            ],
                            [
                                80.47007,
                                5.93844
                            ],
                            [
                                80.62584,
                                5.94547
                            ],
                            [
                                80.71529,
                                5.96118
                            ],
                            [
                                80.80989,
                                6.03682
                            ],
                            [
                                80.9997,
                                6.10036
                            ],
                            [
                                81.12732,
                                6.12138
                            ],
                            [
                                81.18316,
                                6.1574
                            ],
                            [
                                81.32316,
                                6.20218
                            ],
                            [
                                81.3994,
                                6.25029
                            ],
                            [
                                81.50215,
                                6.34938
                            ],
                            [
                                81.55889,
                                6.36978
                            ],
                            [
                                81.6988,
                                6.49247
                            ],
                            [
                                81.7596,
                                6.59688
                            ],
                            [
                                81.77282,
                                6.6712
                            ],
                            [
                                81.82208,
                                6.76271
                            ],
                            [
                                81.84552,
                                6.90909
                            ],
                            [
                                81.87751,
                                7.02155
                            ],
                            [
                                81.85739,
                                7.10692
                            ],
                            [
                                81.86342,
                                7.33508
                            ],
                            [
                                81.82305,
                                7.44112
                            ],
                            [
                                81.78683,
                                7.59836
                            ],
                            [
                                81.70365,
                                7.74574
                            ],
                            [
                                81.58259,
                                7.84458
                            ],
                            [
                                81.54206,
                                7.97271
                            ],
                            [
                                81.47446,
                                8.0416
                            ],
                            [
                                81.41158,
                                8.23469
                            ],
                            [
                                81.35101,
                                8.49518
                            ],
                            [
                                81.2274,
                                8.46267
                            ],
                            [
                                81.18439,
                                8.53309
                            ],
                            [
                                81.22409,
                                8.65519
                            ],
                            [
                                81.17304,
                                8.73338
                            ],
                            [
                                81.01759,
                                8.91639
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                79.69844,
                                9.09725
                            ],
                            [
                                79.84168,
                                9.01435
                            ],
                            [
                                79.85442,
                                9.07778
                            ],
                            [
                                79.73002,
                                9.10725
                            ],
                            [
                                79.69844,
                                9.09725
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "SDN",
                "Country": "Sudan",
                "Total_3GHG": 0.28,
                "Total_3GHG_timeseries": [
                    3.0724e-06,
                    6.1646e-06,
                    9.2738e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0046
                ],
                "Fossil_3GHG": 0.09,
                "Fossil_3GHG_timeseries": [
                    4.9834e-07,
                    1.0103e-06,
                    1.5361e-06,
                    2.0759e-06,
                    2.6297e-06,
                    3.1978e-06,
                    3.7802e-06,
                    4.3772e-06,
                    4.9888e-06,
                    5.6153e-06,
                    6.2584e-06,
                    6.9185e-06,
                    7.5956e-06,
                    8.29e-06,
                    9.0017e-06,
                    9.7309e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009
                ],
                "Land_3GHG": 0.64,
                "Land_3GHG_timeseries": [
                    2.5741e-06,
                    5.1542e-06,
                    7.7377e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037
                ],
                "Total_CO2": 0.13,
                "Total_CO2_timeseries": [
                    1.9059e-07,
                    3.782e-07,
                    5.6013e-07,
                    7.3698e-07,
                    9.0751e-07,
                    1.0718e-06,
                    1.2332e-06,
                    1.3967e-06,
                    1.5564e-06,
                    1.7135e-06,
                    1.8685e-06,
                    2.0189e-06,
                    2.1688e-06,
                    2.3137e-06,
                    2.4586e-06,
                    2.6006e-06,
                    2.7408e-06,
                    2.8803e-06,
                    3.0155e-06,
                    3.1602e-06,
                    3.308e-06,
                    3.4583e-06,
                    3.6145e-06,
                    3.7705e-06,
                    3.9221e-06,
                    4.0732e-06,
                    4.2399e-06,
                    4.4306e-06,
                    4.6514e-06,
                    4.9061e-06,
                    5.1977e-06,
                    5.5323e-06,
                    5.9219e-06,
                    6.3657e-06,
                    6.8597e-06,
                    7.4054e-06,
                    8.0079e-06,
                    8.6729e-06,
                    9.3992e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015
                ],
                "Fossil_CO2": 0.03,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2.2689e-07,
                    5.2487e-07,
                    8.3798e-07,
                    1.1813e-06,
                    1.5186e-06,
                    1.9012e-06,
                    2.2717e-06,
                    2.7481e-06,
                    3.2804e-06,
                    3.8445e-06,
                    4.4055e-06,
                    4.9771e-06,
                    5.5896e-06,
                    6.2822e-06,
                    7.049e-06,
                    8.0502e-06,
                    9.1406e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_CO2": 0.36,
                "Land_CO2_timeseries": [
                    1.9059e-07,
                    3.782e-07,
                    5.6013e-07,
                    7.3698e-07,
                    9.0751e-07,
                    1.0718e-06,
                    1.2332e-06,
                    1.3967e-06,
                    1.5564e-06,
                    1.7135e-06,
                    1.8685e-06,
                    2.0189e-06,
                    2.1688e-06,
                    2.3137e-06,
                    2.4586e-06,
                    2.6006e-06,
                    2.7408e-06,
                    2.8803e-06,
                    3.0155e-06,
                    3.1602e-06,
                    3.308e-06,
                    3.4583e-06,
                    3.6145e-06,
                    3.7705e-06,
                    3.9221e-06,
                    4.0732e-06,
                    4.2399e-06,
                    4.4306e-06,
                    4.6514e-06,
                    4.9061e-06,
                    5.1977e-06,
                    5.5323e-06,
                    5.9219e-06,
                    6.3657e-06,
                    6.8597e-06,
                    7.4054e-06,
                    8.0079e-06,
                    8.6729e-06,
                    9.3992e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013
                ],
                "Total_CH4": 0.62,
                "Total_CH4_timeseries": [
                    2.7491e-06,
                    5.5183e-06,
                    8.3078e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026
                ],
                "Fossil_CH4": 0.26,
                "Fossil_CH4_timeseries": [
                    4.8874e-07,
                    9.9097e-07,
                    1.5069e-06,
                    2.0365e-06,
                    2.5802e-06,
                    3.138e-06,
                    3.71e-06,
                    4.2964e-06,
                    4.8975e-06,
                    5.5133e-06,
                    6.1457e-06,
                    6.7951e-06,
                    7.4614e-06,
                    8.1449e-06,
                    8.8458e-06,
                    9.5642e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Land_CH4": 1.21,
                "Land_CH4_timeseries": [
                    2.2604e-06,
                    4.5273e-06,
                    6.8009e-06,
                    9.0812e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019
                ],
                "Total_N2O": 0.63,
                "Total_N2O_timeseries": [
                    1.3272e-07,
                    2.6806e-07,
                    4.0591e-07,
                    5.4611e-07,
                    6.8847e-07,
                    8.3275e-07,
                    9.7867e-07,
                    1.1259e-06,
                    1.2741e-06,
                    1.4228e-06,
                    1.5718e-06,
                    1.721e-06,
                    1.8704e-06,
                    2.0199e-06,
                    2.1696e-06,
                    2.3193e-06,
                    2.4692e-06,
                    2.6193e-06,
                    2.7697e-06,
                    2.9203e-06,
                    3.0734e-06,
                    3.2327e-06,
                    3.4012e-06,
                    3.5808e-06,
                    3.7727e-06,
                    3.9771e-06,
                    4.1934e-06,
                    4.4202e-06,
                    4.6552e-06,
                    4.8952e-06,
                    5.138e-06,
                    5.3832e-06,
                    5.6304e-06,
                    5.8793e-06,
                    6.1298e-06,
                    6.3818e-06,
                    6.6352e-06,
                    6.8902e-06,
                    7.1469e-06,
                    7.4168e-06,
                    7.6893e-06,
                    7.9646e-06,
                    8.2428e-06,
                    8.524e-06,
                    8.8084e-06,
                    9.096e-06,
                    9.3869e-06,
                    9.6813e-06,
                    9.9793e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Fossil_N2O": 0.1,
                "Fossil_N2O_timeseries": [
                    9.5991e-09,
                    1.9355e-08,
                    2.9263e-08,
                    3.9315e-08,
                    4.9502e-08,
                    5.9813e-08,
                    7.0234e-08,
                    8.0751e-08,
                    9.1345e-08,
                    1.02e-07,
                    1.127e-07,
                    1.2344e-07,
                    1.3422e-07,
                    1.4504e-07,
                    1.559e-07,
                    1.668e-07,
                    1.7774e-07,
                    1.8871e-07,
                    1.9974e-07,
                    2.1081e-07,
                    2.2203e-07,
                    2.3358e-07,
                    2.4559e-07,
                    2.5817e-07,
                    2.7135e-07,
                    2.8517e-07,
                    2.9959e-07,
                    3.1453e-07,
                    3.299e-07,
                    3.4554e-07,
                    3.6134e-07,
                    3.7729e-07,
                    3.9336e-07,
                    4.0955e-07,
                    4.2585e-07,
                    4.4225e-07,
                    4.5875e-07,
                    4.7536e-07,
                    4.9209e-07,
                    5.0938e-07,
                    5.2691e-07,
                    5.4469e-07,
                    5.6274e-07,
                    5.8106e-07,
                    5.9968e-07,
                    6.1859e-07,
                    6.3783e-07,
                    6.5739e-07,
                    6.773e-07,
                    6.9757e-07,
                    7.1824e-07,
                    7.3938e-07,
                    7.6102e-07,
                    7.832e-07,
                    8.0594e-07,
                    8.2923e-07,
                    8.5307e-07,
                    8.7744e-07,
                    9.0228e-07,
                    9.2754e-07,
                    9.5319e-07,
                    9.7921e-07,
                    1.0056e-06,
                    1.0323e-06,
                    1.0593e-06,
                    1.0867e-06,
                    1.1144e-06,
                    1.1424e-06,
                    1.1708e-06,
                    1.1995e-06,
                    1.2286e-06,
                    1.2581e-06,
                    1.2879e-06,
                    1.3181e-06,
                    1.3486e-06,
                    1.3796e-06,
                    1.4109e-06,
                    1.4426e-06,
                    1.4747e-06,
                    1.5072e-06,
                    1.5402e-06,
                    1.5737e-06,
                    1.6078e-06,
                    1.6425e-06,
                    1.678e-06,
                    1.7142e-06,
                    1.7511e-06,
                    1.7889e-06,
                    1.8276e-06,
                    1.8672e-06,
                    1.908e-06,
                    1.9506e-06,
                    1.9955e-06,
                    2.0429e-06,
                    2.0931e-06,
                    2.1463e-06,
                    2.2024e-06,
                    2.2612e-06,
                    2.3226e-06,
                    2.3862e-06,
                    2.4518e-06,
                    2.5196e-06,
                    2.5895e-06,
                    2.6616e-06,
                    2.7358e-06,
                    2.8123e-06,
                    2.8909e-06,
                    2.9716e-06,
                    3.0543e-06,
                    3.139e-06,
                    3.2257e-06,
                    3.3146e-06,
                    3.4059e-06,
                    3.4999e-06,
                    3.5966e-06,
                    3.6962e-06,
                    3.7987e-06,
                    3.9042e-06,
                    4.0128e-06,
                    4.1256e-06,
                    4.2411e-06,
                    4.3605e-06,
                    4.4871e-06,
                    4.6193e-06,
                    4.7506e-06,
                    4.8819e-06,
                    5.0178e-06,
                    5.1639e-06,
                    5.3124e-06,
                    5.4675e-06,
                    5.6293e-06,
                    5.876e-06,
                    6.1148e-06,
                    6.3507e-06,
                    6.6137e-06,
                    6.872e-06,
                    7.1344e-06,
                    7.4062e-06,
                    7.6847e-06,
                    7.981e-06,
                    8.2792e-06,
                    8.5853e-06,
                    8.8904e-06,
                    9.2302e-06,
                    9.574e-06,
                    9.9289e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.84,
                "Land_N2O_timeseries": [
                    1.2312e-07,
                    2.4871e-07,
                    3.7665e-07,
                    5.068e-07,
                    6.3897e-07,
                    7.7294e-07,
                    9.0844e-07,
                    1.0452e-06,
                    1.1827e-06,
                    1.3208e-06,
                    1.4591e-06,
                    1.5976e-06,
                    1.7362e-06,
                    1.8749e-06,
                    2.0137e-06,
                    2.1525e-06,
                    2.2915e-06,
                    2.4306e-06,
                    2.5699e-06,
                    2.7095e-06,
                    2.8514e-06,
                    2.9992e-06,
                    3.1556e-06,
                    3.3226e-06,
                    3.5013e-06,
                    3.6919e-06,
                    3.8938e-06,
                    4.1057e-06,
                    4.3253e-06,
                    4.5497e-06,
                    4.7767e-06,
                    5.0059e-06,
                    5.237e-06,
                    5.4698e-06,
                    5.704e-06,
                    5.9395e-06,
                    6.1764e-06,
                    6.4148e-06,
                    6.6548e-06,
                    6.9074e-06,
                    7.1624e-06,
                    7.4199e-06,
                    7.6801e-06,
                    7.943e-06,
                    8.2087e-06,
                    8.4774e-06,
                    8.7491e-06,
                    9.0239e-06,
                    9.302e-06,
                    9.5833e-06,
                    9.8679e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            33.18263,
                            22.00166
                        ],
                        [
                            32.98994,
                            22.00148
                        ],
                        [
                            31.89442,
                            22.00059
                        ],
                        [
                            31.41624,
                            22.00021
                        ],
                        [
                            31.43444,
                            22.07908
                        ],
                        [
                            31.51234,
                            22.18007
                        ],
                        [
                            31.47426,
                            22.22439
                        ],
                        [
                            31.35782,
                            22.11605
                        ],
                        [
                            31.31441,
                            22.0002
                        ],
                        [
                            30.80672,
                            22.00011
                        ],
                        [
                            30.23152,
                            22.0
                        ],
                        [
                            29.61829,
                            22.0
                        ],
                        [
                            27.48027,
                            22.0
                        ],
                        [
                            26.18588,
                            22.0
                        ],
                        [
                            25.39306,
                            22.0
                        ],
                        [
                            25.0,
                            22.0
                        ],
                        [
                            24.99999,
                            21.30133
                        ],
                        [
                            24.99997,
                            19.99805
                        ],
                        [
                            24.0001,
                            19.99789
                        ],
                        [
                            24.0,
                            19.5
                        ],
                        [
                            23.99954,
                            17.17533
                        ],
                        [
                            23.99925,
                            15.71572
                        ],
                        [
                            23.96409,
                            15.71159
                        ],
                        [
                            23.81772,
                            15.75025
                        ],
                        [
                            23.58607,
                            15.76239
                        ],
                        [
                            23.44139,
                            15.71031
                        ],
                        [
                            23.35187,
                            15.69459
                        ],
                        [
                            23.12633,
                            15.71834
                        ],
                        [
                            23.03185,
                            15.62771
                        ],
                        [
                            22.92794,
                            15.55145
                        ],
                        [
                            22.9255,
                            15.47181
                        ],
                        [
                            22.98498,
                            15.41734
                        ],
                        [
                            23.00272,
                            15.2349
                        ],
                        [
                            22.93369,
                            15.16575
                        ],
                        [
                            22.93373,
                            15.10032
                        ],
                        [
                            22.8815,
                            15.08849
                        ],
                        [
                            22.75066,
                            14.96734
                        ],
                        [
                            22.75724,
                            14.90643
                        ],
                        [
                            22.68199,
                            14.87787
                        ],
                        [
                            22.664,
                            14.84221
                        ],
                        [
                            22.71375,
                            14.69685
                        ],
                        [
                            22.58078,
                            14.64731
                        ],
                        [
                            22.51702,
                            14.64164
                        ],
                        [
                            22.4119,
                            14.59873
                        ],
                        [
                            22.38287,
                            14.51605
                        ],
                        [
                            22.44178,
                            14.48279
                        ],
                        [
                            22.43353,
                            14.41097
                        ],
                        [
                            22.45351,
                            14.3294
                        ],
                        [
                            22.42669,
                            14.2915
                        ],
                        [
                            22.46503,
                            14.24366
                        ],
                        [
                            22.54291,
                            14.23485
                        ],
                        [
                            22.56647,
                            14.18114
                        ],
                        [
                            22.53363,
                            14.11121
                        ],
                        [
                            22.48615,
                            14.10424
                        ],
                        [
                            22.44039,
                            14.05406
                        ],
                        [
                            22.32323,
                            14.01143
                        ],
                        [
                            22.29367,
                            13.96556
                        ],
                        [
                            22.22884,
                            13.95324
                        ],
                        [
                            22.07406,
                            13.77997
                        ],
                        [
                            22.12545,
                            13.73148
                        ],
                        [
                            22.11602,
                            13.68328
                        ],
                        [
                            22.16667,
                            13.59567
                        ],
                        [
                            22.22438,
                            13.54675
                        ],
                        [
                            22.21858,
                            13.46599
                        ],
                        [
                            22.28931,
                            13.35501
                        ],
                        [
                            22.18331,
                            13.24963
                        ],
                        [
                            22.13596,
                            13.17245
                        ],
                        [
                            22.01076,
                            13.14172
                        ],
                        [
                            21.97423,
                            13.07639
                        ],
                        [
                            21.92948,
                            13.0514
                        ],
                        [
                            21.84801,
                            12.84106
                        ],
                        [
                            21.81705,
                            12.80365
                        ],
                        [
                            21.86138,
                            12.72899
                        ],
                        [
                            21.94762,
                            12.62569
                        ],
                        [
                            22.15073,
                            12.67427
                        ],
                        [
                            22.19654,
                            12.75376
                        ],
                        [
                            22.31251,
                            12.688
                        ],
                        [
                            22.4559,
                            12.63314
                        ],
                        [
                            22.42465,
                            12.51559
                        ],
                        [
                            22.38542,
                            12.46088
                        ],
                        [
                            22.42925,
                            12.38952
                        ],
                        [
                            22.44964,
                            12.26452
                        ],
                        [
                            22.49557,
                            12.15867
                        ],
                        [
                            22.47834,
                            12.03417
                        ],
                        [
                            22.63896,
                            12.06793
                        ],
                        [
                            22.58325,
                            11.8524
                        ],
                        [
                            22.55633,
                            11.71002
                        ],
                        [
                            22.56328,
                            11.62908
                        ],
                        [
                            22.65546,
                            11.5185
                        ],
                        [
                            22.73742,
                            11.48911
                        ],
                        [
                            22.7891,
                            11.40698
                        ],
                        [
                            22.93989,
                            11.42344
                        ],
                        [
                            22.93517,
                            11.32093
                        ],
                        [
                            22.98109,
                            11.29625
                        ],
                        [
                            22.98643,
                            11.21621
                        ],
                        [
                            22.9314,
                            11.10076
                        ],
                        [
                            22.87551,
                            10.93137
                        ],
                        [
                            23.00728,
                            10.70964
                        ],
                        [
                            23.1156,
                            10.64839
                        ],
                        [
                            23.15124,
                            10.5939
                        ],
                        [
                            23.3185,
                            10.4638
                        ],
                        [
                            23.67133,
                            9.901
                        ],
                        [
                            23.69866,
                            9.67857
                        ],
                        [
                            23.63144,
                            9.56108
                        ],
                        [
                            23.63214,
                            9.49146
                        ],
                        [
                            23.67143,
                            9.44881
                        ],
                        [
                            23.63869,
                            9.37571
                        ],
                        [
                            23.65876,
                            9.28955
                        ],
                        [
                            23.59293,
                            9.20933
                        ],
                        [
                            23.4821,
                            9.17233
                        ],
                        [
                            23.45234,
                            8.97906
                        ],
                        [
                            23.50475,
                            8.9519
                        ],
                        [
                            23.58876,
                            8.97298
                        ],
                        [
                            23.49849,
                            8.80897
                        ],
                        [
                            23.54586,
                            8.70096
                        ],
                        [
                            23.62527,
                            8.75411
                        ],
                        [
                            23.67732,
                            8.72573
                        ],
                        [
                            23.77671,
                            8.70719
                        ],
                        [
                            23.85451,
                            8.72931
                        ],
                        [
                            23.94856,
                            8.71369
                        ],
                        [
                            23.96455,
                            8.65512
                        ],
                        [
                            24.0528,
                            8.69354
                        ],
                        [
                            24.14226,
                            8.6822
                        ],
                        [
                            24.2301,
                            8.69942
                        ],
                        [
                            24.22336,
                            8.64215
                        ],
                        [
                            24.24424,
                            8.64871
                        ],
                        [
                            24.38356,
                            8.78946
                        ],
                        [
                            24.52582,
                            8.8445
                        ],
                        [
                            24.57828,
                            8.92285
                        ],
                        [
                            24.54348,
                            9.0631
                        ],
                        [
                            24.56612,
                            9.1863
                        ],
                        [
                            24.62576,
                            9.322
                        ],
                        [
                            24.59651,
                            9.37571
                        ],
                        [
                            24.73785,
                            9.48141
                        ],
                        [
                            24.75326,
                            9.58172
                        ],
                        [
                            24.73296,
                            9.62581
                        ],
                        [
                            24.73915,
                            9.71394
                        ],
                        [
                            24.85252,
                            9.87503
                        ],
                        [
                            24.94818,
                            9.93413
                        ],
                        [
                            25.05903,
                            10.12108
                        ],
                        [
                            25.03373,
                            10.17966
                        ],
                        [
                            25.10008,
                            10.31428
                        ],
                        [
                            25.18459,
                            10.32183
                        ],
                        [
                            25.25047,
                            10.35102
                        ],
                        [
                            25.3392,
                            10.33646
                        ],
                        [
                            25.46288,
                            10.37348
                        ],
                        [
                            25.53703,
                            10.36141
                        ],
                        [
                            25.62434,
                            10.39572
                        ],
                        [
                            25.74447,
                            10.40581
                        ],
                        [
                            25.81261,
                            10.43893
                        ],
                        [
                            25.92088,
                            10.40398
                        ],
                        [
                            25.93242,
                            10.37334
                        ],
                        [
                            25.93144,
                            10.1823
                        ],
                        [
                            25.99992,
                            10.15661
                        ],
                        [
                            26.06051,
                            10.10112
                        ],
                        [
                            26.11759,
                            9.99381
                        ],
                        [
                            26.21114,
                            9.91299
                        ],
                        [
                            26.31285,
                            9.6385
                        ],
                        [
                            26.39433,
                            9.56666
                        ],
                        [
                            26.55902,
                            9.51663
                        ],
                        [
                            26.70444,
                            9.48868
                        ],
                        [
                            26.85175,
                            9.53117
                        ],
                        [
                            26.99252,
                            9.59366
                        ],
                        [
                            27.13576,
                            9.62386
                        ],
                        [
                            27.48027,
                            9.61969
                        ],
                        [
                            27.82226,
                            9.60209
                        ],
                        [
                            27.907523925041129,
                            9.610373223130296
                        ],
                        [
                            28.037559993860189,
                            9.620565239335034
                        ],
                        [
                            28.602172380280489,
                            9.643645871324781
                        ],
                        [
                            28.977173098740405,
                            9.657351235287267
                        ],
                        [
                            28.97701,
                            9.64116
                        ],
                        [
                            29.01974,
                            9.70051
                        ],
                        [
                            29.08876,
                            9.75175
                        ],
                        [
                            29.53396,
                            9.75208
                        ],
                        [
                            29.54207,
                            10.08093
                        ],
                        [
                            29.94745,
                            10.28621
                        ],
                        [
                            30.00449,
                            10.28309
                        ],
                        [
                            30.52297,
                            9.96437
                        ],
                        [
                            30.82675,
                            9.72389
                        ],
                        [
                            30.90157,
                            9.74802
                        ],
                        [
                            31.186,
                            9.75038
                        ],
                        [
                            31.27468,
                            9.75994
                        ],
                        [
                            31.35686,
                            9.80996
                        ],
                        [
                            31.51251,
                            10.00385
                        ],
                        [
                            31.6884,
                            10.20252
                        ],
                        [
                            31.78991,
                            10.30674
                        ],
                        [
                            31.85716,
                            10.40846
                        ],
                        [
                            31.96465,
                            10.61101
                        ],
                        [
                            32.02157,
                            10.66935
                        ],
                        [
                            32.15273,
                            10.74379
                        ],
                        [
                            32.46183,
                            11.04329
                        ],
                        [
                            32.39549,
                            11.2113
                        ],
                        [
                            32.39338,
                            11.59814
                        ],
                        [
                            32.3845,
                            11.69114
                        ],
                        [
                            32.36093,
                            11.72494
                        ],
                        [
                            32.13189,
                            11.93821
                        ],
                        [
                            32.73743,
                            11.95123
                        ],
                        [
                            32.75674,
                            12.01004
                        ],
                        [
                            32.74379,
                            12.23184
                        ],
                        [
                            32.98373,
                            12.2281
                        ],
                        [
                            33.28395,
                            12.21315
                        ],
                        [
                            33.25455,
                            12.14958
                        ],
                        [
                            33.17753,
                            11.7542
                        ],
                        [
                            33.13819,
                            11.62378
                        ],
                        [
                            33.26199,
                            10.84633
                        ],
                        [
                            33.22725,
                            10.74015
                        ],
                        [
                            33.48531,
                            10.65164
                        ],
                        [
                            33.66262,
                            10.44831
                        ],
                        [
                            33.79234,
                            10.33658
                        ],
                        [
                            33.89713,
                            10.17181
                        ],
                        [
                            33.96617,
                            10.14814
                        ],
                        [
                            33.99403,
                            10.05229
                        ],
                        [
                            33.99128,
                            9.91527
                        ],
                        [
                            33.96311,
                            9.8034
                        ],
                        [
                            33.91631,
                            9.74485
                        ],
                        [
                            33.8893,
                            9.62869
                        ],
                        [
                            33.89062,
                            9.54139
                        ],
                        [
                            33.91392,
                            9.4999
                        ],
                        [
                            34.11325,
                            9.49864
                        ],
                        [
                            34.1086,
                            9.5745
                        ],
                        [
                            34.2227,
                            9.89366
                        ],
                        [
                            34.22148,
                            9.98346
                        ],
                        [
                            34.24978,
                            10.06127
                        ],
                        [
                            34.33065,
                            10.12358
                        ],
                        [
                            34.34985,
                            10.20939
                        ],
                        [
                            34.29593,
                            10.39453
                        ],
                        [
                            34.32539,
                            10.47539
                        ],
                        [
                            34.28296,
                            10.52722
                        ],
                        [
                            34.29982,
                            10.58758
                        ],
                        [
                            34.38438,
                            10.67234
                        ],
                        [
                            34.47214,
                            10.81603
                        ],
                        [
                            34.60204,
                            10.90406
                        ],
                        [
                            34.6991,
                            10.8284
                        ],
                        [
                            34.77734,
                            10.71287
                        ],
                        [
                            34.85473,
                            10.74559
                        ],
                        [
                            34.97222,
                            10.9005
                        ],
                        [
                            34.95253,
                            10.96768
                        ],
                        [
                            35.00692,
                            11.15981
                        ],
                        [
                            34.95572,
                            11.25391
                        ],
                        [
                            35.05933,
                            11.43764
                        ],
                        [
                            35.08955,
                            11.54633
                        ],
                        [
                            35.0924,
                            11.62338
                        ],
                        [
                            35.05483,
                            11.7346
                        ],
                        [
                            35.10967,
                            11.81589
                        ],
                        [
                            35.27515,
                            11.93593
                        ],
                        [
                            35.30232,
                            12.01235
                        ],
                        [
                            35.42854,
                            12.24779
                        ],
                        [
                            35.64177,
                            12.60188
                        ],
                        [
                            35.68195,
                            12.60756
                        ],
                        [
                            35.71311,
                            12.67167
                        ],
                        [
                            35.78603,
                            12.66438
                        ],
                        [
                            36.01939,
                            12.72491
                        ],
                        [
                            36.07729,
                            12.72343
                        ],
                        [
                            36.15249,
                            12.6814
                        ],
                        [
                            36.17349,
                            12.74078
                        ],
                        [
                            36.18202,
                            12.88794
                        ],
                        [
                            36.1506,
                            12.94105
                        ],
                        [
                            36.18034,
                            13.01357
                        ],
                        [
                            36.24705,
                            13.27192
                        ],
                        [
                            36.29208,
                            13.32392
                        ],
                        [
                            36.37346,
                            13.52891
                        ],
                        [
                            36.37538,
                            13.5821
                        ],
                        [
                            36.42214,
                            13.72757
                        ],
                        [
                            36.50018,
                            13.83228
                        ],
                        [
                            36.45231,
                            13.97755
                        ],
                        [
                            36.49795,
                            14.06382
                        ],
                        [
                            36.56034,
                            14.25771
                        ],
                        [
                            36.52633,
                            14.33341
                        ],
                        [
                            36.51018,
                            14.46501
                        ],
                        [
                            36.46828,
                            14.94534
                        ],
                        [
                            36.43937,
                            15.15644
                        ],
                        [
                            36.4782,
                            15.20369
                        ],
                        [
                            36.54779,
                            15.23869
                        ],
                        [
                            36.61337,
                            15.41353
                        ],
                        [
                            36.6997,
                            15.71252
                        ],
                        [
                            36.76844,
                            15.83155
                        ],
                        [
                            36.81546,
                            15.95598
                        ],
                        [
                            36.8928,
                            16.21393
                        ],
                        [
                            36.95597,
                            16.27918
                        ],
                        [
                            36.93405,
                            16.35032
                        ],
                        [
                            36.96496,
                            16.42938
                        ],
                        [
                            36.89906,
                            16.4994
                        ],
                        [
                            36.88792,
                            16.54868
                        ],
                        [
                            36.90223,
                            16.67505
                        ],
                        [
                            36.99132,
                            16.72873
                        ],
                        [
                            37.00466,
                            16.93612
                        ],
                        [
                            36.98374,
                            16.97294
                        ],
                        [
                            37.03256,
                            17.10017
                        ],
                        [
                            37.13105,
                            17.05755
                        ],
                        [
                            37.31271,
                            17.09389
                        ],
                        [
                            37.39424,
                            17.04821
                        ],
                        [
                            37.48537,
                            17.18844
                        ],
                        [
                            37.51667,
                            17.33716
                        ],
                        [
                            37.61442,
                            17.37444
                        ],
                        [
                            37.76412,
                            17.38418
                        ],
                        [
                            37.78855,
                            17.49602
                        ],
                        [
                            37.83938,
                            17.49881
                        ],
                        [
                            37.87187,
                            17.45273
                        ],
                        [
                            37.97687,
                            17.49115
                        ],
                        [
                            38.00386,
                            17.55702
                        ],
                        [
                            38.1661,
                            17.57298
                        ],
                        [
                            38.26005,
                            17.5586
                        ],
                        [
                            38.28066,
                            17.62563
                        ],
                        [
                            38.34152,
                            17.64959
                        ],
                        [
                            38.45238,
                            17.89829
                        ],
                        [
                            38.56955,
                            18.00504
                        ],
                        [
                            38.54691,
                            18.07744
                        ],
                        [
                            38.49742,
                            18.05513
                        ],
                        [
                            38.46298,
                            18.12007
                        ],
                        [
                            38.40985,
                            18.11727
                        ],
                        [
                            38.39957,
                            18.18349
                        ],
                        [
                            38.34299,
                            18.17273
                        ],
                        [
                            38.1146,
                            18.26783
                        ],
                        [
                            38.07942,
                            18.35841
                        ],
                        [
                            38.11363,
                            18.41456
                        ],
                        [
                            37.99747,
                            18.49381
                        ],
                        [
                            37.90697,
                            18.58382
                        ],
                        [
                            37.74315,
                            18.63105
                        ],
                        [
                            37.74856,
                            18.69436
                        ],
                        [
                            37.65825,
                            18.72476
                        ],
                        [
                            37.58246,
                            18.71462
                        ],
                        [
                            37.50867,
                            18.73285
                        ],
                        [
                            37.43368,
                            18.83817
                        ],
                        [
                            37.39735,
                            18.94949
                        ],
                        [
                            37.39224,
                            19.02289
                        ],
                        [
                            37.3387,
                            19.14148
                        ],
                        [
                            37.3282,
                            19.29673
                        ],
                        [
                            37.29447,
                            19.47761
                        ],
                        [
                            37.23591,
                            19.59043
                        ],
                        [
                            37.25624,
                            19.67175
                        ],
                        [
                            37.2677,
                            19.8263
                        ],
                        [
                            37.18209,
                            20.03555
                        ],
                        [
                            37.21734,
                            20.10642
                        ],
                        [
                            37.20353,
                            20.28742
                        ],
                        [
                            37.18844,
                            20.33531
                        ],
                        [
                            37.23667,
                            20.46442
                        ],
                        [
                            37.23608,
                            20.56594
                        ],
                        [
                            37.18047,
                            20.69065
                        ],
                        [
                            37.16986,
                            20.875
                        ],
                        [
                            37.12847,
                            20.99504
                        ],
                        [
                            37.09643,
                            21.03666
                        ],
                        [
                            37.12893,
                            21.08693
                        ],
                        [
                            37.1577,
                            21.21788
                        ],
                        [
                            37.23668,
                            21.13287
                        ],
                        [
                            37.25325,
                            21.00145
                        ],
                        [
                            37.3154,
                            21.06876
                        ],
                        [
                            37.19233,
                            21.2208
                        ],
                        [
                            37.1343,
                            21.26702
                        ],
                        [
                            37.01718,
                            21.41418
                        ],
                        [
                            36.9181,
                            21.60054
                        ],
                        [
                            36.86601,
                            21.97458
                        ],
                        [
                            36.8825,
                            22.00513
                        ],
                        [
                            36.38683,
                            22.00467
                        ],
                        [
                            35.78326,
                            22.0041
                        ],
                        [
                            35.16307,
                            22.00352
                        ],
                        [
                            34.23122,
                            22.00264
                        ],
                        [
                            34.08653,
                            22.00251
                        ],
                        [
                            33.546850960223466,
                            22.00084540543315
                        ],
                        [
                            33.18263,
                            22.00166
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "SUR",
                "Country": "Suriname",
                "Total_3GHG": 0.01,
                "Total_3GHG_timeseries": [
                    1.0585e-07,
                    2.1261e-07,
                    3.1928e-07,
                    4.2586e-07,
                    5.3353e-07,
                    6.4072e-07,
                    7.4801e-07,
                    8.56e-07,
                    9.6534e-07,
                    1.0812e-06,
                    1.2004e-06,
                    1.3403e-06,
                    1.473e-06,
                    1.6021e-06,
                    1.7309e-06,
                    1.8618e-06,
                    1.9936e-06,
                    2.1261e-06,
                    2.2593e-06,
                    2.395e-06,
                    2.5306e-06,
                    2.6686e-06,
                    2.8085e-06,
                    2.9486e-06,
                    3.0905e-06,
                    3.2324e-06,
                    3.3758e-06,
                    3.5206e-06,
                    3.6846e-06,
                    3.8365e-06,
                    3.9847e-06,
                    4.1479e-06,
                    4.3017e-06,
                    4.4511e-06,
                    4.6013e-06,
                    4.7518e-06,
                    4.9029e-06,
                    5.0551e-06,
                    5.2081e-06,
                    5.3647e-06,
                    5.5233e-06,
                    5.683e-06,
                    5.8442e-06,
                    6.0069e-06,
                    6.1712e-06,
                    6.3362e-06,
                    6.5026e-06,
                    6.6709e-06,
                    6.8429e-06,
                    7.0144e-06,
                    7.1858e-06,
                    7.3593e-06,
                    7.5344e-06,
                    7.7213e-06,
                    7.9025e-06,
                    8.0915e-06,
                    8.2773e-06,
                    8.4627e-06,
                    8.6496e-06,
                    8.8564e-06,
                    9.0777e-06,
                    9.3082e-06,
                    9.5479e-06,
                    9.7923e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_3GHG": 0.01,
                "Fossil_3GHG_timeseries": [
                    4.9369e-09,
                    9.9149e-09,
                    1.4934e-08,
                    1.9994e-08,
                    2.5095e-08,
                    3.0237e-08,
                    3.5418e-08,
                    4.064e-08,
                    4.5901e-08,
                    5.1188e-08,
                    5.6568e-08,
                    6.2042e-08,
                    6.7596e-08,
                    7.3232e-08,
                    7.8948e-08,
                    8.4746e-08,
                    9.0652e-08,
                    9.6666e-08,
                    1.0279e-07,
                    1.0902e-07,
                    1.1548e-07,
                    1.222e-07,
                    1.2918e-07,
                    1.3634e-07,
                    1.4369e-07,
                    1.5123e-07,
                    1.5895e-07,
                    1.6682e-07,
                    1.7484e-07,
                    1.8299e-07,
                    1.9125e-07,
                    1.9963e-07,
                    2.0813e-07,
                    2.1676e-07,
                    2.2551e-07,
                    2.3437e-07,
                    2.4332e-07,
                    2.5231e-07,
                    2.6135e-07,
                    2.7045e-07,
                    2.7951e-07,
                    2.8857e-07,
                    2.9764e-07,
                    3.0678e-07,
                    3.16e-07,
                    3.253e-07,
                    3.3468e-07,
                    3.4418e-07,
                    3.5382e-07,
                    3.6359e-07,
                    3.7341e-07,
                    3.8326e-07,
                    3.9315e-07,
                    4.0309e-07,
                    4.1307e-07,
                    4.231e-07,
                    4.3339e-07,
                    4.4396e-07,
                    4.5482e-07,
                    4.6576e-07,
                    4.7705e-07,
                    4.8869e-07,
                    5.007e-07,
                    5.1306e-07,
                    5.2575e-07,
                    5.3891e-07,
                    5.5251e-07,
                    5.6648e-07,
                    5.8131e-07,
                    5.9682e-07,
                    6.1321e-07,
                    6.3014e-07,
                    6.4759e-07,
                    6.6568e-07,
                    6.8442e-07,
                    7.0379e-07,
                    7.2362e-07,
                    7.4388e-07,
                    7.6458e-07,
                    7.8592e-07,
                    8.0758e-07,
                    8.295e-07,
                    8.5164e-07,
                    8.7403e-07,
                    8.9666e-07,
                    9.1943e-07,
                    9.4243e-07,
                    9.6573e-07,
                    9.8885e-07,
                    1.0121e-06,
                    1.0365e-06,
                    1.0617e-06,
                    1.0892e-06,
                    1.1182e-06,
                    1.1504e-06,
                    1.1859e-06,
                    1.2248e-06,
                    1.2673e-06,
                    1.3135e-06,
                    1.468e-06,
                    1.6392e-06,
                    1.8341e-06,
                    2.0533e-06,
                    2.2967e-06,
                    2.5314e-06,
                    2.7865e-06,
                    3.0659e-06,
                    3.327e-06,
                    3.6206e-06,
                    3.956e-06,
                    4.2983e-06,
                    4.6831e-06,
                    5.0949e-06,
                    5.5575e-06,
                    6.1261e-06,
                    6.8622e-06,
                    7.7266e-06,
                    8.6652e-06,
                    9.649e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_3GHG": 0.02,
                "Land_3GHG_timeseries": [
                    1.0091e-07,
                    2.027e-07,
                    3.0434e-07,
                    4.0586e-07,
                    5.0843e-07,
                    6.1049e-07,
                    7.1259e-07,
                    8.1536e-07,
                    9.1944e-07,
                    1.0301e-06,
                    1.1438e-06,
                    1.2782e-06,
                    1.4054e-06,
                    1.5289e-06,
                    1.6519e-06,
                    1.777e-06,
                    1.903e-06,
                    2.0294e-06,
                    2.1565e-06,
                    2.286e-06,
                    2.4152e-06,
                    2.5464e-06,
                    2.6793e-06,
                    2.8123e-06,
                    2.9468e-06,
                    3.0812e-06,
                    3.2168e-06,
                    3.3538e-06,
                    3.5098e-06,
                    3.6535e-06,
                    3.7935e-06,
                    3.9483e-06,
                    4.0935e-06,
                    4.2344e-06,
                    4.3758e-06,
                    4.5175e-06,
                    4.6596e-06,
                    4.8028e-06,
                    4.9467e-06,
                    5.0943e-06,
                    5.2438e-06,
                    5.3944e-06,
                    5.5466e-06,
                    5.7001e-06,
                    5.8552e-06,
                    6.0109e-06,
                    6.1679e-06,
                    6.3267e-06,
                    6.4891e-06,
                    6.6508e-06,
                    6.8124e-06,
                    6.9761e-06,
                    7.1412e-06,
                    7.3182e-06,
                    7.4894e-06,
                    7.6684e-06,
                    7.8439e-06,
                    8.0187e-06,
                    8.1947e-06,
                    8.3906e-06,
                    8.6006e-06,
                    8.8195e-06,
                    9.0472e-06,
                    9.2792e-06,
                    9.5164e-06,
                    9.7595e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_CO2": 0.01,
                "Total_CO2_timeseries": [
                    7.8364e-08,
                    1.5744e-07,
                    2.3621e-07,
                    3.1469e-07,
                    3.9406e-07,
                    4.7275e-07,
                    5.5134e-07,
                    6.3042e-07,
                    7.1065e-07,
                    7.9727e-07,
                    8.8632e-07,
                    9.9538e-07,
                    1.0966e-06,
                    1.1933e-06,
                    1.2889e-06,
                    1.3859e-06,
                    1.4831e-06,
                    1.5801e-06,
                    1.677e-06,
                    1.7757e-06,
                    1.8732e-06,
                    1.972e-06,
                    2.0717e-06,
                    2.1707e-06,
                    2.2704e-06,
                    2.3691e-06,
                    2.4682e-06,
                    2.5679e-06,
                    2.6857e-06,
                    2.7906e-06,
                    2.8913e-06,
                    3.0063e-06,
                    3.1114e-06,
                    3.2116e-06,
                    3.3119e-06,
                    3.4121e-06,
                    3.5123e-06,
                    3.6132e-06,
                    3.7144e-06,
                    3.8184e-06,
                    3.924e-06,
                    4.0301e-06,
                    4.1373e-06,
                    4.2453e-06,
                    4.3544e-06,
                    4.4635e-06,
                    4.5733e-06,
                    4.6845e-06,
                    4.7986e-06,
                    4.9116e-06,
                    5.0237e-06,
                    5.1372e-06,
                    5.2515e-06,
                    5.3768e-06,
                    5.4955e-06,
                    5.6212e-06,
                    5.7427e-06,
                    5.8629e-06,
                    5.9835e-06,
                    6.1233e-06,
                    6.2748e-06,
                    6.4325e-06,
                    6.5965e-06,
                    6.7622e-06,
                    6.9306e-06,
                    7.1022e-06,
                    7.2766e-06,
                    7.4556e-06,
                    7.6376e-06,
                    7.8379e-06,
                    8.0473e-06,
                    8.2522e-06,
                    8.4572e-06,
                    8.6644e-06,
                    8.8738e-06,
                    9.0893e-06,
                    9.3093e-06,
                    9.5306e-06,
                    9.7551e-06,
                    9.9547e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_CO2": 0.01,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    9.57e-08,
                    2.013e-07,
                    3.2175e-07,
                    4.62e-07,
                    6.138e-07,
                    7.5405e-07,
                    9.075e-07,
                    1.0758e-06,
                    1.2194e-06,
                    1.3843e-06,
                    1.579e-06,
                    1.7721e-06,
                    1.9949e-06,
                    2.2341e-06,
                    2.5064e-06,
                    2.8644e-06,
                    3.3578e-06,
                    3.9583e-06,
                    4.6118e-06,
                    5.2965e-06,
                    6.0209e-06,
                    6.793e-06,
                    7.5782e-06,
                    8.5269e-06,
                    9.2479e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CO2": 0.02,
                "Land_CO2_timeseries": [
                    7.8364e-08,
                    1.5744e-07,
                    2.3621e-07,
                    3.1469e-07,
                    3.9406e-07,
                    4.7275e-07,
                    5.5134e-07,
                    6.3042e-07,
                    7.1065e-07,
                    7.9727e-07,
                    8.8632e-07,
                    9.9538e-07,
                    1.0966e-06,
                    1.1933e-06,
                    1.2889e-06,
                    1.3859e-06,
                    1.4831e-06,
                    1.5801e-06,
                    1.677e-06,
                    1.7757e-06,
                    1.8732e-06,
                    1.972e-06,
                    2.0717e-06,
                    2.1707e-06,
                    2.2704e-06,
                    2.3691e-06,
                    2.4682e-06,
                    2.5679e-06,
                    2.6857e-06,
                    2.7906e-06,
                    2.8913e-06,
                    3.0063e-06,
                    3.1114e-06,
                    3.2116e-06,
                    3.3119e-06,
                    3.4121e-06,
                    3.5123e-06,
                    3.6132e-06,
                    3.7144e-06,
                    3.8184e-06,
                    3.924e-06,
                    4.0301e-06,
                    4.1373e-06,
                    4.2453e-06,
                    4.3544e-06,
                    4.4635e-06,
                    4.5733e-06,
                    4.6845e-06,
                    4.7986e-06,
                    4.9116e-06,
                    5.0237e-06,
                    5.1372e-06,
                    5.2515e-06,
                    5.3768e-06,
                    5.4955e-06,
                    5.6212e-06,
                    5.7427e-06,
                    5.8629e-06,
                    5.9835e-06,
                    6.1233e-06,
                    6.2748e-06,
                    6.4325e-06,
                    6.5965e-06,
                    6.7622e-06,
                    6.9306e-06,
                    7.1022e-06,
                    7.2766e-06,
                    7.4556e-06,
                    7.6376e-06,
                    7.8379e-06,
                    8.0473e-06,
                    8.2522e-06,
                    8.4572e-06,
                    8.6644e-06,
                    8.8738e-06,
                    9.0893e-06,
                    9.3093e-06,
                    9.5306e-06,
                    9.7551e-06,
                    9.9547e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_CH4": 0.01,
                "Total_CH4_timeseries": [
                    2.5717e-08,
                    5.1617e-08,
                    7.77e-08,
                    1.0396e-07,
                    1.3041e-07,
                    1.5704e-07,
                    1.8386e-07,
                    2.1086e-07,
                    2.3804e-07,
                    2.6539e-07,
                    2.935e-07,
                    3.2237e-07,
                    3.52e-07,
                    3.8237e-07,
                    4.1349e-07,
                    4.4537e-07,
                    4.7801e-07,
                    5.1144e-07,
                    5.4564e-07,
                    5.8062e-07,
                    6.1661e-07,
                    6.5361e-07,
                    6.9163e-07,
                    7.306e-07,
                    7.7051e-07,
                    8.1137e-07,
                    8.5317e-07,
                    8.9588e-07,
                    9.3949e-07,
                    9.8402e-07,
                    1.0291e-06,
                    1.0746e-06,
                    1.1207e-06,
                    1.1674e-06,
                    1.2145e-06,
                    1.2622e-06,
                    1.3104e-06,
                    1.359e-06,
                    1.4082e-06,
                    1.4577e-06,
                    1.5077e-06,
                    1.5581e-06,
                    1.609e-06,
                    1.6604e-06,
                    1.7124e-06,
                    1.7648e-06,
                    1.8178e-06,
                    1.8714e-06,
                    1.9256e-06,
                    1.9803e-06,
                    2.0356e-06,
                    2.0915e-06,
                    2.1478e-06,
                    2.2048e-06,
                    2.2622e-06,
                    2.3202e-06,
                    2.3789e-06,
                    2.4385e-06,
                    2.4988e-06,
                    2.5597e-06,
                    2.6234e-06,
                    2.69e-06,
                    2.7595e-06,
                    2.8318e-06,
                    2.907e-06,
                    2.9851e-06,
                    3.0661e-06,
                    3.1501e-06,
                    3.2374e-06,
                    3.3279e-06,
                    3.4224e-06,
                    3.5206e-06,
                    3.6226e-06,
                    3.7283e-06,
                    3.8379e-06,
                    3.9512e-06,
                    4.0682e-06,
                    4.1888e-06,
                    4.313e-06,
                    4.441e-06,
                    4.5702e-06,
                    4.7005e-06,
                    4.8319e-06,
                    4.9644e-06,
                    5.098e-06,
                    5.2312e-06,
                    5.364e-06,
                    5.4964e-06,
                    5.6279e-06,
                    5.7588e-06,
                    5.8912e-06,
                    6.0248e-06,
                    6.1607e-06,
                    6.2984e-06,
                    6.4393e-06,
                    6.5836e-06,
                    6.7312e-06,
                    6.8823e-06,
                    7.037e-06,
                    7.2041e-06,
                    7.3858e-06,
                    7.5829e-06,
                    7.7904e-06,
                    8.0162e-06,
                    8.251e-06,
                    8.5012e-06,
                    8.7695e-06,
                    9.0534e-06,
                    9.3579e-06,
                    9.6839e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_CH4": 0.01,
                "Fossil_CH4_timeseries": [
                    3.4644e-09,
                    6.9536e-09,
                    1.0468e-08,
                    1.4007e-08,
                    1.7571e-08,
                    2.116e-08,
                    2.4774e-08,
                    2.8414e-08,
                    3.2079e-08,
                    3.5756e-08,
                    3.9514e-08,
                    4.3352e-08,
                    4.7257e-08,
                    5.1231e-08,
                    5.5273e-08,
                    5.9384e-08,
                    6.359e-08,
                    6.789e-08,
                    7.2285e-08,
                    7.6776e-08,
                    8.1486e-08,
                    8.6424e-08,
                    9.1599e-08,
                    9.693e-08,
                    1.0242e-07,
                    1.0806e-07,
                    1.1387e-07,
                    1.1979e-07,
                    1.2583e-07,
                    1.32e-07,
                    1.3825e-07,
                    1.446e-07,
                    1.5106e-07,
                    1.5763e-07,
                    1.6431e-07,
                    1.7109e-07,
                    1.7794e-07,
                    1.8481e-07,
                    1.9172e-07,
                    1.9866e-07,
                    2.0554e-07,
                    2.124e-07,
                    2.1924e-07,
                    2.2614e-07,
                    2.331e-07,
                    2.401e-07,
                    2.4718e-07,
                    2.5435e-07,
                    2.6164e-07,
                    2.6902e-07,
                    2.7644e-07,
                    2.8386e-07,
                    2.913e-07,
                    2.9874e-07,
                    3.0621e-07,
                    3.1369e-07,
                    3.214e-07,
                    3.2936e-07,
                    3.3759e-07,
                    3.4586e-07,
                    3.5445e-07,
                    3.6338e-07,
                    3.7264e-07,
                    3.8222e-07,
                    3.9211e-07,
                    4.0245e-07,
                    4.1319e-07,
                    4.2428e-07,
                    4.362e-07,
                    4.4878e-07,
                    4.6221e-07,
                    4.7614e-07,
                    4.9058e-07,
                    5.0563e-07,
                    5.2129e-07,
                    5.3757e-07,
                    5.5427e-07,
                    5.7139e-07,
                    5.889e-07,
                    6.0704e-07,
                    6.2546e-07,
                    6.4411e-07,
                    6.6297e-07,
                    6.8203e-07,
                    7.0132e-07,
                    7.207e-07,
                    7.4029e-07,
                    7.6015e-07,
                    7.798e-07,
                    7.9953e-07,
                    8.2037e-07,
                    8.4199e-07,
                    8.6573e-07,
                    8.9094e-07,
                    9.1928e-07,
                    9.5079e-07,
                    9.8566e-07,
                    1.024e-06,
                    1.066e-06,
                    1.1205e-06,
                    1.1816e-06,
                    1.2516e-06,
                    1.3259e-06,
                    1.4127e-06,
                    1.5023e-06,
                    1.5989e-06,
                    1.7049e-06,
                    1.8171e-06,
                    1.9403e-06,
                    2.0755e-06,
                    2.2191e-06,
                    2.3752e-06,
                    2.5419e-06,
                    2.7263e-06,
                    2.9306e-06,
                    3.1671e-06,
                    3.4244e-06,
                    3.703e-06,
                    3.9952e-06,
                    4.2847e-06,
                    4.5871e-06,
                    4.8904e-06,
                    5.2173e-06,
                    5.5189e-06,
                    5.8208e-06,
                    6.1156e-06,
                    6.4515e-06,
                    6.7584e-06,
                    7.0675e-06,
                    7.3818e-06,
                    7.6693e-06,
                    7.951e-06,
                    8.2165e-06,
                    8.4412e-06,
                    8.6202e-06,
                    8.7858e-06,
                    8.9392e-06,
                    9.1041e-06,
                    9.2864e-06,
                    9.4695e-06,
                    9.6324e-06,
                    9.8752e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CH4": 0.01,
                "Land_CH4_timeseries": [
                    2.2253e-08,
                    4.4663e-08,
                    6.7232e-08,
                    8.9958e-08,
                    1.1284e-07,
                    1.3588e-07,
                    1.5908e-07,
                    1.8244e-07,
                    2.0596e-07,
                    2.2963e-07,
                    2.5399e-07,
                    2.7902e-07,
                    3.0474e-07,
                    3.3114e-07,
                    3.5822e-07,
                    3.8598e-07,
                    4.1442e-07,
                    4.4355e-07,
                    4.7336e-07,
                    5.0385e-07,
                    5.3512e-07,
                    5.6718e-07,
                    6.0003e-07,
                    6.3367e-07,
                    6.6809e-07,
                    7.033e-07,
                    7.393e-07,
                    7.7609e-07,
                    8.1366e-07,
                    8.5202e-07,
                    8.908e-07,
                    9.3002e-07,
                    9.6965e-07,
                    1.0097e-06,
                    1.0502e-06,
                    1.0911e-06,
                    1.1325e-06,
                    1.1742e-06,
                    1.2164e-06,
                    1.2591e-06,
                    1.3021e-06,
                    1.3457e-06,
                    1.3898e-06,
                    1.4343e-06,
                    1.4793e-06,
                    1.5247e-06,
                    1.5707e-06,
                    1.6171e-06,
                    1.664e-06,
                    1.7113e-06,
                    1.7592e-06,
                    1.8076e-06,
                    1.8565e-06,
                    1.906e-06,
                    1.956e-06,
                    2.0065e-06,
                    2.0575e-06,
                    2.1091e-06,
                    2.1612e-06,
                    2.2138e-06,
                    2.269e-06,
                    2.3267e-06,
                    2.3869e-06,
                    2.4496e-06,
                    2.5148e-06,
                    2.5826e-06,
                    2.653e-06,
                    2.7258e-06,
                    2.8012e-06,
                    2.8791e-06,
                    2.9602e-06,
                    3.0445e-06,
                    3.132e-06,
                    3.2227e-06,
                    3.3166e-06,
                    3.4137e-06,
                    3.5139e-06,
                    3.6174e-06,
                    3.7241e-06,
                    3.834e-06,
                    3.9448e-06,
                    4.0564e-06,
                    4.169e-06,
                    4.2824e-06,
                    4.3967e-06,
                    4.5105e-06,
                    4.6237e-06,
                    4.7362e-06,
                    4.8481e-06,
                    4.9593e-06,
                    5.0709e-06,
                    5.1828e-06,
                    5.295e-06,
                    5.4074e-06,
                    5.52e-06,
                    5.6328e-06,
                    5.7455e-06,
                    5.8583e-06,
                    5.971e-06,
                    6.0836e-06,
                    6.2042e-06,
                    6.3314e-06,
                    6.4645e-06,
                    6.6035e-06,
                    6.7488e-06,
                    6.9023e-06,
                    7.0646e-06,
                    7.2363e-06,
                    7.4176e-06,
                    7.6084e-06,
                    7.7972e-06,
                    8.0048e-06,
                    8.2159e-06,
                    8.4671e-06,
                    8.7747e-06,
                    9.0189e-06,
                    9.3402e-06,
                    9.6819e-06,
                    9.9507e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_N2O": 0.01,
                "Total_N2O_timeseries": [
                    1.767e-09,
                    3.5563e-09,
                    5.3675e-09,
                    7.2001e-09,
                    9.0532e-09,
                    1.0926e-08,
                    1.2818e-08,
                    1.4727e-08,
                    1.6652e-08,
                    1.8592e-08,
                    2.0545e-08,
                    2.2512e-08,
                    2.4492e-08,
                    2.6486e-08,
                    2.8492e-08,
                    3.0512e-08,
                    3.2545e-08,
                    3.4591e-08,
                    3.665e-08,
                    3.8724e-08,
                    4.0819e-08,
                    4.295e-08,
                    4.5127e-08,
                    4.7358e-08,
                    4.9646e-08,
                    5.1994e-08,
                    5.4398e-08,
                    5.6853e-08,
                    5.9351e-08,
                    6.1881e-08,
                    6.4433e-08,
                    6.7006e-08,
                    6.96e-08,
                    7.2213e-08,
                    7.4844e-08,
                    7.7493e-08,
                    8.016e-08,
                    8.2846e-08,
                    8.5551e-08,
                    8.8579e-08,
                    9.1639e-08,
                    9.4745e-08,
                    9.791e-08,
                    1.0115e-07,
                    1.0446e-07,
                    1.0787e-07,
                    1.1137e-07,
                    1.1498e-07,
                    1.1869e-07,
                    1.2251e-07,
                    1.2648e-07,
                    1.3066e-07,
                    1.3508e-07,
                    1.3978e-07,
                    1.4476e-07,
                    1.5003e-07,
                    1.5556e-07,
                    1.6132e-07,
                    1.6726e-07,
                    1.7332e-07,
                    1.7945e-07,
                    1.8565e-07,
                    1.9192e-07,
                    1.9825e-07,
                    2.0464e-07,
                    2.1109e-07,
                    2.1759e-07,
                    2.2413e-07,
                    2.3072e-07,
                    2.3734e-07,
                    2.4398e-07,
                    2.5063e-07,
                    2.5727e-07,
                    2.6388e-07,
                    2.7047e-07,
                    2.7704e-07,
                    2.8359e-07,
                    2.9012e-07,
                    2.9666e-07,
                    3.0322e-07,
                    3.0983e-07,
                    3.1653e-07,
                    3.2334e-07,
                    3.3029e-07,
                    3.3739e-07,
                    3.4467e-07,
                    3.5213e-07,
                    3.5976e-07,
                    3.6758e-07,
                    3.7557e-07,
                    3.839e-07,
                    3.9286e-07,
                    4.0268e-07,
                    4.1353e-07,
                    4.255e-07,
                    4.3862e-07,
                    4.5285e-07,
                    4.6808e-07,
                    4.8414e-07,
                    5.0079e-07,
                    5.1803e-07,
                    5.3609e-07,
                    5.5516e-07,
                    5.7537e-07,
                    5.968e-07,
                    6.1947e-07,
                    6.4334e-07,
                    6.6831e-07,
                    6.9426e-07,
                    7.2098e-07,
                    7.4874e-07,
                    7.7733e-07,
                    8.0647e-07,
                    8.3644e-07,
                    8.6784e-07,
                    8.9992e-07,
                    9.3448e-07,
                    9.6943e-07,
                    1.0031e-06,
                    1.0394e-06,
                    1.0782e-06,
                    1.1176e-06,
                    1.1582e-06,
                    1.1991e-06,
                    1.2372e-06,
                    1.2774e-06,
                    1.3195e-06,
                    1.3633e-06,
                    1.4051e-06,
                    1.4467e-06,
                    1.4996e-06,
                    1.5622e-06,
                    1.6347e-06,
                    1.7152e-06,
                    1.7841e-06,
                    1.8576e-06,
                    1.9444e-06,
                    2.0077e-06,
                    2.0691e-06,
                    2.1341e-06,
                    2.199e-06,
                    2.2692e-06,
                    2.3364e-06,
                    2.4035e-06,
                    2.4724e-06,
                    2.5479e-06,
                    2.6242e-06,
                    2.6987e-06,
                    2.773e-06,
                    2.8491e-06,
                    2.9233e-06,
                    2.9938e-06,
                    3.0679e-06,
                    3.1541e-06,
                    3.232e-06,
                    3.321e-06,
                    3.4011e-06,
                    3.5049e-06,
                    3.5985e-06,
                    3.6997e-06,
                    3.7982e-06,
                    3.9002e-06,
                    3.9919e-06,
                    4.0956e-06,
                    4.1932e-06,
                    4.3081e-06,
                    4.4231e-06,
                    4.5179e-06,
                    4.6232e-06,
                    4.744e-06,
                    4.8591e-06,
                    4.9748e-06
                ],
                "Fossil_N2O": 0.01,
                "Fossil_N2O_timeseries": [
                    1.4725e-09,
                    2.9613e-09,
                    4.4665e-09,
                    5.9876e-09,
                    7.5246e-09,
                    9.0769e-09,
                    1.0644e-08,
                    1.2226e-08,
                    1.3822e-08,
                    1.5432e-08,
                    1.7055e-08,
                    1.869e-08,
                    2.0339e-08,
                    2.2001e-08,
                    2.3675e-08,
                    2.5362e-08,
                    2.7063e-08,
                    2.8776e-08,
                    3.0502e-08,
                    3.2242e-08,
                    3.3998e-08,
                    3.5775e-08,
                    3.7578e-08,
                    3.9409e-08,
                    4.127e-08,
                    4.3162e-08,
                    4.5083e-08,
                    4.7031e-08,
                    4.9004e-08,
                    5.0996e-08,
                    5.3005e-08,
                    5.5031e-08,
                    5.7071e-08,
                    5.9127e-08,
                    6.1198e-08,
                    6.3284e-08,
                    6.5384e-08,
                    6.75e-08,
                    6.963e-08,
                    7.1792e-08,
                    7.3974e-08,
                    7.6175e-08,
                    7.8397e-08,
                    8.064e-08,
                    8.2904e-08,
                    8.5191e-08,
                    8.7499e-08,
                    8.9831e-08,
                    9.2186e-08,
                    9.4565e-08,
                    9.6969e-08,
                    9.94e-08,
                    1.0186e-07,
                    1.0435e-07,
                    1.0686e-07,
                    1.0941e-07,
                    1.1199e-07,
                    1.146e-07,
                    1.1723e-07,
                    1.199e-07,
                    1.2259e-07,
                    1.2531e-07,
                    1.2806e-07,
                    1.3083e-07,
                    1.3364e-07,
                    1.3646e-07,
                    1.3932e-07,
                    1.422e-07,
                    1.4511e-07,
                    1.4804e-07,
                    1.5101e-07,
                    1.5399e-07,
                    1.5701e-07,
                    1.6005e-07,
                    1.6312e-07,
                    1.6622e-07,
                    1.6935e-07,
                    1.725e-07,
                    1.7568e-07,
                    1.7889e-07,
                    1.8212e-07,
                    1.8538e-07,
                    1.8868e-07,
                    1.92e-07,
                    1.9535e-07,
                    1.9872e-07,
                    2.0213e-07,
                    2.0558e-07,
                    2.0906e-07,
                    2.1257e-07,
                    2.1613e-07,
                    2.1975e-07,
                    2.2345e-07,
                    2.2723e-07,
                    2.311e-07,
                    2.3507e-07,
                    2.3913e-07,
                    2.4329e-07,
                    2.4754e-07,
                    2.5186e-07,
                    2.5628e-07,
                    2.6079e-07,
                    2.6542e-07,
                    2.7017e-07,
                    2.7505e-07,
                    2.8006e-07,
                    2.8521e-07,
                    2.9051e-07,
                    2.9593e-07,
                    3.0149e-07,
                    3.0717e-07,
                    3.1297e-07,
                    3.1888e-07,
                    3.2491e-07,
                    3.3107e-07,
                    3.3736e-07,
                    3.4382e-07,
                    3.5045e-07,
                    3.5729e-07,
                    3.6409e-07,
                    3.7079e-07,
                    3.78e-07,
                    3.8511e-07,
                    3.9165e-07,
                    3.9927e-07,
                    4.0646e-07,
                    4.1416e-07,
                    4.2178e-07,
                    4.2936e-07,
                    4.3709e-07,
                    4.4363e-07,
                    4.5457e-07,
                    4.7539e-07,
                    4.9395e-07,
                    5.0701e-07,
                    5.2358e-07,
                    5.5261e-07,
                    5.7021e-07,
                    5.8501e-07,
                    6.0034e-07,
                    6.1632e-07,
                    6.3221e-07,
                    6.4677e-07,
                    6.6123e-07,
                    6.769e-07,
                    6.9248e-07,
                    7.0799e-07,
                    7.2423e-07,
                    7.3969e-07,
                    7.5803e-07,
                    7.7567e-07,
                    7.9806e-07,
                    8.2181e-07,
                    8.4784e-07,
                    8.775e-07,
                    9.0645e-07,
                    9.3272e-07,
                    9.5973e-07,
                    9.8636e-07,
                    1.0176e-06,
                    1.0464e-06,
                    1.0832e-06,
                    1.1165e-06,
                    1.1507e-06,
                    1.1855e-06,
                    1.2272e-06,
                    1.2653e-06,
                    1.2995e-06,
                    1.3414e-06,
                    1.3846e-06,
                    1.4353e-06,
                    1.4862e-06
                ],
                "Land_N2O": 0.01,
                "Land_N2O_timeseries": [
                    2.9455e-10,
                    5.9498e-10,
                    9.0106e-10,
                    1.2124e-09,
                    1.5286e-09,
                    1.8491e-09,
                    2.1733e-09,
                    2.5003e-09,
                    2.8295e-09,
                    3.1598e-09,
                    3.4907e-09,
                    3.8219e-09,
                    4.1535e-09,
                    4.4853e-09,
                    4.8173e-09,
                    5.1496e-09,
                    5.482e-09,
                    5.8148e-09,
                    6.148e-09,
                    6.4819e-09,
                    6.8213e-09,
                    7.1749e-09,
                    7.5492e-09,
                    7.9488e-09,
                    8.3762e-09,
                    8.8321e-09,
                    9.3152e-09,
                    9.8221e-09,
                    1.0348e-08,
                    1.0884e-08,
                    1.1427e-08,
                    1.1976e-08,
                    1.2529e-08,
                    1.3085e-08,
                    1.3646e-08,
                    1.4209e-08,
                    1.4776e-08,
                    1.5346e-08,
                    1.592e-08,
                    1.6787e-08,
                    1.7665e-08,
                    1.857e-08,
                    1.9513e-08,
                    2.0506e-08,
                    2.1558e-08,
                    2.2677e-08,
                    2.3872e-08,
                    2.5146e-08,
                    2.6504e-08,
                    2.7949e-08,
                    2.9516e-08,
                    3.126e-08,
                    3.3224e-08,
                    3.5434e-08,
                    3.79e-08,
                    4.062e-08,
                    4.3574e-08,
                    4.6727e-08,
                    5.003e-08,
                    5.3419e-08,
                    5.6855e-08,
                    6.0334e-08,
                    6.3855e-08,
                    6.7413e-08,
                    7.1004e-08,
                    7.4625e-08,
                    7.827e-08,
                    8.1934e-08,
                    8.5612e-08,
                    8.9299e-08,
                    9.298e-08,
                    9.6637e-08,
                    1.0026e-07,
                    1.0383e-07,
                    1.0735e-07,
                    1.1082e-07,
                    1.1424e-07,
                    1.1763e-07,
                    1.2099e-07,
                    1.2434e-07,
                    1.2771e-07,
                    1.3114e-07,
                    1.3466e-07,
                    1.3829e-07,
                    1.4205e-07,
                    1.4594e-07,
                    1.4999e-07,
                    1.5419e-07,
                    1.5853e-07,
                    1.63e-07,
                    1.6777e-07,
                    1.7311e-07,
                    1.7924e-07,
                    1.8631e-07,
                    1.944e-07,
                    2.0355e-07,
                    2.1372e-07,
                    2.2479e-07,
                    2.366e-07,
                    2.4893e-07,
                    2.6175e-07,
                    2.753e-07,
                    2.8974e-07,
                    3.0521e-07,
                    3.2176e-07,
                    3.3941e-07,
                    3.5812e-07,
                    3.7781e-07,
                    3.9833e-07,
                    4.1949e-07,
                    4.4157e-07,
                    4.6436e-07,
                    4.876e-07,
                    5.1153e-07,
                    5.3677e-07,
                    5.6255e-07,
                    5.9066e-07,
                    6.1898e-07,
                    6.458e-07,
                    6.7534e-07,
                    7.0745e-07,
                    7.3964e-07,
                    7.7304e-07,
                    8.0742e-07,
                    8.3793e-07,
                    8.7093e-07,
                    9.053e-07,
                    9.4153e-07,
                    9.7572e-07,
                    1.0096e-06,
                    1.056e-06,
                    1.1076e-06,
                    1.1594e-06,
                    1.2212e-06,
                    1.2771e-06,
                    1.334e-06,
                    1.3918e-06,
                    1.4375e-06,
                    1.4841e-06,
                    1.5338e-06,
                    1.5827e-06,
                    1.6369e-06,
                    1.6896e-06,
                    1.7423e-06,
                    1.7955e-06,
                    1.8554e-06,
                    1.9162e-06,
                    1.9745e-06,
                    2.0334e-06,
                    2.0911e-06,
                    2.1476e-06,
                    2.1958e-06,
                    2.2461e-06,
                    2.3063e-06,
                    2.3545e-06,
                    2.4145e-06,
                    2.4684e-06,
                    2.5452e-06,
                    2.6122e-06,
                    2.6821e-06,
                    2.7518e-06,
                    2.817e-06,
                    2.8755e-06,
                    2.9449e-06,
                    3.0077e-06,
                    3.0808e-06,
                    3.1578e-06,
                    3.2184e-06,
                    3.2819e-06,
                    3.3594e-06,
                    3.4239e-06,
                    3.4886e-06
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -54.58789,
                            2.32207
                        ],
                        [
                            -54.50825,
                            2.33845
                        ],
                        [
                            -54.47514,
                            2.43418
                        ],
                        [
                            -54.4202,
                            2.438
                        ],
                        [
                            -54.35077,
                            2.52278
                        ],
                        [
                            -54.31731,
                            2.6286
                        ],
                        [
                            -54.26376,
                            2.72314
                        ],
                        [
                            -54.22504,
                            2.75363
                        ],
                        [
                            -54.18051,
                            2.85921
                        ],
                        [
                            -54.17362,
                            2.9397
                        ],
                        [
                            -54.1932,
                            3.06304
                        ],
                        [
                            -54.17505,
                            3.1068
                        ],
                        [
                            -54.21235,
                            3.15205
                        ],
                        [
                            -54.13808,
                            3.26333
                        ],
                        [
                            -54.06566,
                            3.31084
                        ],
                        [
                            -54.05827,
                            3.38321
                        ],
                        [
                            -54.0216,
                            3.41217
                        ],
                        [
                            -54.00797,
                            3.53854
                        ],
                        [
                            -53.98159,
                            3.60555
                        ],
                        [
                            -54.08284,
                            3.67655
                        ],
                        [
                            -54.12267,
                            3.7933
                        ],
                        [
                            -54.20119,
                            3.82324
                        ],
                        [
                            -54.24988,
                            3.90853
                        ],
                        [
                            -54.29556,
                            3.94888
                        ],
                        [
                            -54.35643,
                            4.0515
                        ],
                        [
                            -54.32405,
                            4.14841
                        ],
                        [
                            -54.39489,
                            4.19931
                        ],
                        [
                            -54.38739,
                            4.35402
                        ],
                        [
                            -54.432,
                            4.41227
                        ],
                        [
                            -54.4495,
                            4.52596
                        ],
                        [
                            -54.41568,
                            4.60567
                        ],
                        [
                            -54.43757,
                            4.64055
                        ],
                        [
                            -54.42808,
                            4.71621
                        ],
                        [
                            -54.46579,
                            4.73928
                        ],
                        [
                            -54.46711,
                            4.87206
                        ],
                        [
                            -54.41555,
                            5.08374
                        ],
                        [
                            -54.36966,
                            5.13052
                        ],
                        [
                            -54.27815,
                            5.26314
                        ],
                        [
                            -54.18335,
                            5.32468
                        ],
                        [
                            -54.11733,
                            5.41725
                        ],
                        [
                            -54.01813,
                            5.52295
                        ],
                        [
                            -54.00565,
                            5.60254
                        ],
                        [
                            -54.03577,
                            5.65733
                        ],
                        [
                            -53.98982,
                            5.74902
                        ],
                        [
                            -54.0282,
                            5.83048
                        ],
                        [
                            -54.10593,
                            5.84537
                        ],
                        [
                            -54.2787,
                            5.90398
                        ],
                        [
                            -54.65607,
                            5.97276
                        ],
                        [
                            -54.98885,
                            5.99391
                        ],
                        [
                            -55.11975,
                            5.97852
                        ],
                        [
                            -55.22013,
                            5.90266
                        ],
                        [
                            -55.34966,
                            5.96442
                        ],
                        [
                            -55.54675,
                            5.99736
                        ],
                        [
                            -55.82685,
                            5.98111
                        ],
                        [
                            -55.89598,
                            5.9626
                        ],
                        [
                            -55.94573,
                            5.89936
                        ],
                        [
                            -55.94146,
                            5.80308
                        ],
                        [
                            -56.01081,
                            5.80799
                        ],
                        [
                            -56.17486,
                            5.85728
                        ],
                        [
                            -56.39066,
                            5.90863
                        ],
                        [
                            -56.56397,
                            5.93985
                        ],
                        [
                            -56.66829,
                            5.97948
                        ],
                        [
                            -56.86322,
                            5.98478
                        ],
                        [
                            -56.96308,
                            6.0048
                        ],
                        [
                            -57.06282,
                            5.9439
                        ],
                        [
                            -57.134,
                            5.83738
                        ],
                        [
                            -57.13782,
                            5.69648
                        ],
                        [
                            -57.16165,
                            5.6059
                        ],
                        [
                            -57.26104,
                            5.4813
                        ],
                        [
                            -57.27273,
                            5.38322
                        ],
                        [
                            -57.32306,
                            5.34822
                        ],
                        [
                            -57.2403,
                            5.27501
                        ],
                        [
                            -57.18161,
                            5.19619
                        ],
                        [
                            -57.18152,
                            5.16066
                        ],
                        [
                            -57.29645,
                            5.16755
                        ],
                        [
                            -57.32148,
                            5.09289
                        ],
                        [
                            -57.30284,
                            5.01514
                        ],
                        [
                            -57.38196,
                            5.0144
                        ],
                        [
                            -57.41446,
                            4.98949
                        ],
                        [
                            -57.52229,
                            5.00864
                        ],
                        [
                            -57.60993,
                            4.99194
                        ],
                        [
                            -57.67257,
                            5.00844
                        ],
                        [
                            -57.75126,
                            4.94947
                        ],
                        [
                            -57.83856,
                            4.92302
                        ],
                        [
                            -57.92333,
                            4.80566
                        ],
                        [
                            -57.88678,
                            4.77695
                        ],
                        [
                            -57.82766,
                            4.66431
                        ],
                        [
                            -57.9188,
                            4.44829
                        ],
                        [
                            -57.95997,
                            4.39496
                        ],
                        [
                            -57.94771,
                            4.31552
                        ],
                        [
                            -58.01996,
                            4.23413
                        ],
                        [
                            -58.04868,
                            4.15363
                        ],
                        [
                            -58.02375,
                            4.10933
                        ],
                        [
                            -58.02702,
                            3.98589
                        ],
                        [
                            -57.9925,
                            3.98144
                        ],
                        [
                            -57.89156,
                            3.84412
                        ],
                        [
                            -57.85408,
                            3.81574
                        ],
                        [
                            -57.83593,
                            3.68408
                        ],
                        [
                            -57.74381,
                            3.62689
                        ],
                        [
                            -57.71441,
                            3.5777
                        ],
                        [
                            -57.64774,
                            3.54934
                        ],
                        [
                            -57.62318,
                            3.4602
                        ],
                        [
                            -57.67835,
                            3.39585
                        ],
                        [
                            -57.56878,
                            3.35698
                        ],
                        [
                            -57.48292,
                            3.34287
                        ],
                        [
                            -57.41838,
                            3.38496
                        ],
                        [
                            -57.38949,
                            3.36701
                        ],
                        [
                            -57.3056,
                            3.38667
                        ],
                        [
                            -57.28326,
                            3.33218
                        ],
                        [
                            -57.29936,
                            3.17936
                        ],
                        [
                            -57.25719,
                            3.09816
                        ],
                        [
                            -57.19349,
                            3.02668
                        ],
                        [
                            -57.22126,
                            2.97596
                        ],
                        [
                            -57.21854,
                            2.89845
                        ],
                        [
                            -57.16886,
                            2.81219
                        ],
                        [
                            -57.01926,
                            2.64293
                        ],
                        [
                            -57.01818,
                            2.57434
                        ],
                        [
                            -56.98858,
                            2.50514
                        ],
                        [
                            -56.91726,
                            2.43305
                        ],
                        [
                            -56.92762,
                            2.39451
                        ],
                        [
                            -56.86891,
                            2.33964
                        ],
                        [
                            -56.87392,
                            2.29384
                        ],
                        [
                            -56.80774,
                            2.26183
                        ],
                        [
                            -56.81177,
                            2.21532
                        ],
                        [
                            -56.68156,
                            2.01671
                        ],
                        [
                            -56.54043,
                            2.01736
                        ],
                        [
                            -56.47737,
                            1.94594
                        ],
                        [
                            -56.41109,
                            1.92545
                        ],
                        [
                            -56.35928,
                            1.93923
                        ],
                        [
                            -56.2664,
                            1.88933
                        ],
                        [
                            -56.18852,
                            1.89165
                        ],
                        [
                            -56.02717,
                            1.83559
                        ],
                        [
                            -55.97376,
                            1.83689
                        ],
                        [
                            -55.90712,
                            1.89199
                        ],
                        [
                            -55.9236,
                            2.05724
                        ],
                        [
                            -56.05065,
                            2.18715
                        ],
                        [
                            -56.0483,
                            2.22587
                        ],
                        [
                            -56.13337,
                            2.25945
                        ],
                        [
                            -56.09101,
                            2.35084
                        ],
                        [
                            -56.04742,
                            2.3434
                        ],
                        [
                            -55.99428,
                            2.40659
                        ],
                        [
                            -55.988,
                            2.51456
                        ],
                        [
                            -55.9384,
                            2.53103
                        ],
                        [
                            -55.83292,
                            2.46478
                        ],
                        [
                            -55.78452,
                            2.45435
                        ],
                        [
                            -55.7271,
                            2.39952
                        ],
                        [
                            -55.59238,
                            2.4331
                        ],
                        [
                            -55.42892,
                            2.43937
                        ],
                        [
                            -55.36579,
                            2.41233
                        ],
                        [
                            -55.35819,
                            2.48603
                        ],
                        [
                            -55.30076,
                            2.5223
                        ],
                        [
                            -55.25966,
                            2.49485
                        ],
                        [
                            -55.18637,
                            2.55388
                        ],
                        [
                            -55.13006,
                            2.5707
                        ],
                        [
                            -55.10197,
                            2.523
                        ],
                        [
                            -54.97282,
                            2.6047
                        ],
                        [
                            -54.9578,
                            2.54025
                        ],
                        [
                            -54.85654,
                            2.43495
                        ],
                        [
                            -54.74383,
                            2.47675
                        ],
                        [
                            -54.68957,
                            2.4495
                        ],
                        [
                            -54.72405,
                            2.40014
                        ],
                        [
                            -54.68378,
                            2.32872
                        ],
                        [
                            -54.58789,
                            2.32207
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "SWZ",
                "Country": "Eswatini",
                "Total_3GHG": 0.01,
                "Total_3GHG_timeseries": [
                    1.2662e-07,
                    2.5162e-07,
                    3.7355e-07,
                    4.9568e-07,
                    6.1978e-07,
                    7.4316e-07,
                    8.6752e-07,
                    9.9141e-07,
                    1.1189e-06,
                    1.2494e-06,
                    1.3819e-06,
                    1.5165e-06,
                    1.6505e-06,
                    1.7863e-06,
                    1.9233e-06,
                    2.0614e-06,
                    2.2017e-06,
                    2.3488e-06,
                    2.4928e-06,
                    2.6481e-06,
                    2.8065e-06,
                    2.9717e-06,
                    3.136e-06,
                    3.3041e-06,
                    3.4742e-06,
                    3.6455e-06,
                    3.8224e-06,
                    3.9991e-06,
                    4.1796e-06,
                    4.3595e-06,
                    4.5396e-06,
                    4.7211e-06,
                    4.9068e-06,
                    5.0954e-06,
                    5.2838e-06,
                    5.4772e-06,
                    5.6749e-06,
                    5.8736e-06,
                    6.0724e-06,
                    6.2825e-06,
                    6.5022e-06,
                    6.7264e-06,
                    6.9552e-06,
                    7.1901e-06,
                    7.4251e-06,
                    7.6622e-06,
                    7.9019e-06,
                    8.1459e-06,
                    8.3947e-06,
                    8.654e-06,
                    8.9359e-06,
                    9.2076e-06,
                    9.4842e-06,
                    9.7723e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    1.379e-08,
                    2.7905e-08,
                    4.2345e-08,
                    5.7112e-08,
                    7.2204e-08,
                    8.7624e-08,
                    1.0337e-07,
                    1.1945e-07,
                    1.3585e-07,
                    1.5258e-07,
                    1.6971e-07,
                    1.8724e-07,
                    2.0519e-07,
                    2.2354e-07,
                    2.4229e-07,
                    2.6146e-07,
                    2.8104e-07,
                    3.0104e-07,
                    3.2146e-07,
                    3.4229e-07,
                    3.6365e-07,
                    3.8554e-07,
                    4.0799e-07,
                    4.3099e-07,
                    4.5457e-07,
                    4.7871e-07,
                    5.0343e-07,
                    5.287e-07,
                    5.5453e-07,
                    5.8091e-07,
                    6.0795e-07,
                    6.3567e-07,
                    6.6405e-07,
                    6.9311e-07,
                    7.2284e-07,
                    7.5324e-07,
                    7.8432e-07,
                    8.1608e-07,
                    8.4851e-07,
                    8.8174e-07,
                    9.1586e-07,
                    9.5089e-07,
                    9.8682e-07,
                    1.0237e-06,
                    1.0614e-06,
                    1.1001e-06,
                    1.1397e-06,
                    1.1802e-06,
                    1.2217e-06,
                    1.264e-06,
                    1.3076e-06,
                    1.3524e-06,
                    1.3984e-06,
                    1.4456e-06,
                    1.494e-06,
                    1.5436e-06,
                    1.5945e-06,
                    1.6466e-06,
                    1.6999e-06,
                    1.7544e-06,
                    1.8104e-06,
                    1.8679e-06,
                    1.927e-06,
                    1.9876e-06,
                    2.0497e-06,
                    2.1133e-06,
                    2.1784e-06,
                    2.2451e-06,
                    2.3133e-06,
                    2.383e-06,
                    2.4549e-06,
                    2.5289e-06,
                    2.605e-06,
                    2.6832e-06,
                    2.7637e-06,
                    2.8462e-06,
                    2.931e-06,
                    3.018e-06,
                    3.1071e-06,
                    3.1985e-06,
                    3.2928e-06,
                    3.39e-06,
                    3.49e-06,
                    3.5931e-06,
                    3.6992e-06,
                    3.8083e-06,
                    3.9204e-06,
                    4.0356e-06,
                    4.1539e-06,
                    4.2753e-06,
                    4.4103e-06,
                    4.5588e-06,
                    4.7211e-06,
                    4.897e-06,
                    5.0896e-06,
                    5.2991e-06,
                    5.5257e-06,
                    5.7698e-06,
                    6.0317e-06,
                    6.3153e-06,
                    6.6085e-06,
                    6.9124e-06,
                    7.228e-06,
                    7.5564e-06,
                    7.8987e-06,
                    8.2558e-06,
                    8.6286e-06,
                    9.0176e-06,
                    9.4232e-06,
                    9.8493e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_3GHG": 0.02,
                "Land_3GHG_timeseries": [
                    1.1283e-07,
                    2.2372e-07,
                    3.3121e-07,
                    4.3857e-07,
                    5.4758e-07,
                    6.5554e-07,
                    7.6414e-07,
                    8.7196e-07,
                    9.8303e-07,
                    1.0968e-06,
                    1.2122e-06,
                    1.3292e-06,
                    1.4453e-06,
                    1.5628e-06,
                    1.681e-06,
                    1.7999e-06,
                    1.9207e-06,
                    2.0477e-06,
                    2.1713e-06,
                    2.3058e-06,
                    2.4428e-06,
                    2.5862e-06,
                    2.7281e-06,
                    2.8731e-06,
                    3.0197e-06,
                    3.1668e-06,
                    3.319e-06,
                    3.4704e-06,
                    3.6251e-06,
                    3.7786e-06,
                    3.9317e-06,
                    4.0855e-06,
                    4.2427e-06,
                    4.4023e-06,
                    4.561e-06,
                    4.7239e-06,
                    4.8906e-06,
                    5.0575e-06,
                    5.2239e-06,
                    5.4008e-06,
                    5.5863e-06,
                    5.7755e-06,
                    5.9684e-06,
                    6.1664e-06,
                    6.3637e-06,
                    6.5621e-06,
                    6.7622e-06,
                    6.9657e-06,
                    7.173e-06,
                    7.3899e-06,
                    7.6282e-06,
                    7.8553e-06,
                    8.0858e-06,
                    8.3267e-06,
                    8.5739e-06,
                    8.8332e-06,
                    9.0964e-06,
                    9.3596e-06,
                    9.6326e-06,
                    9.9063e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    8.3908e-08,
                    1.6522e-07,
                    2.4249e-07,
                    3.1901e-07,
                    3.9653e-07,
                    4.7241e-07,
                    5.4834e-07,
                    6.2291e-07,
                    7.0017e-07,
                    7.7962e-07,
                    8.5998e-07,
                    9.4142e-07,
                    1.0212e-06,
                    1.1017e-06,
                    1.1824e-06,
                    1.263e-06,
                    1.3449e-06,
                    1.4324e-06,
                    1.5158e-06,
                    1.6095e-06,
                    1.7046e-06,
                    1.8049e-06,
                    1.9024e-06,
                    2.0016e-06,
                    2.1007e-06,
                    2.1988e-06,
                    2.3005e-06,
                    2.3999e-06,
                    2.5013e-06,
                    2.6005e-06,
                    2.6979e-06,
                    2.7947e-06,
                    2.8939e-06,
                    2.9942e-06,
                    3.0925e-06,
                    3.1938e-06,
                    3.2977e-06,
                    3.4006e-06,
                    3.5019e-06,
                    3.6118e-06,
                    3.7288e-06,
                    3.8478e-06,
                    3.9691e-06,
                    4.0938e-06,
                    4.2162e-06,
                    4.3381e-06,
                    4.4601e-06,
                    4.5839e-06,
                    4.7099e-06,
                    4.8439e-06,
                    4.9972e-06,
                    5.1372e-06,
                    5.2787e-06,
                    5.4285e-06,
                    5.5825e-06,
                    5.7465e-06,
                    5.9124e-06,
                    6.0761e-06,
                    6.2473e-06,
                    6.4172e-06,
                    6.5845e-06,
                    6.751e-06,
                    6.9303e-06,
                    7.1089e-06,
                    7.2947e-06,
                    7.4709e-06,
                    7.6598e-06,
                    7.8541e-06,
                    8.0333e-06,
                    8.2394e-06,
                    8.452e-06,
                    8.6702e-06,
                    8.8893e-06,
                    9.1136e-06,
                    9.3448e-06,
                    9.5685e-06,
                    9.803e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [],
                "Land_CO2": 0.01,
                "Land_CO2_timeseries": [
                    8.3908e-08,
                    1.6522e-07,
                    2.4249e-07,
                    3.1901e-07,
                    3.9653e-07,
                    4.7241e-07,
                    5.4834e-07,
                    6.2291e-07,
                    7.0017e-07,
                    7.7962e-07,
                    8.5998e-07,
                    9.4142e-07,
                    1.0212e-06,
                    1.1017e-06,
                    1.1824e-06,
                    1.263e-06,
                    1.3449e-06,
                    1.4324e-06,
                    1.5158e-06,
                    1.6095e-06,
                    1.7046e-06,
                    1.8049e-06,
                    1.9024e-06,
                    2.0016e-06,
                    2.1007e-06,
                    2.1988e-06,
                    2.3005e-06,
                    2.3999e-06,
                    2.5013e-06,
                    2.6005e-06,
                    2.6979e-06,
                    2.7947e-06,
                    2.8939e-06,
                    2.9942e-06,
                    3.0925e-06,
                    3.1938e-06,
                    3.2977e-06,
                    3.4006e-06,
                    3.5019e-06,
                    3.6118e-06,
                    3.7288e-06,
                    3.8478e-06,
                    3.9691e-06,
                    4.0938e-06,
                    4.2162e-06,
                    4.3381e-06,
                    4.4601e-06,
                    4.5839e-06,
                    4.7099e-06,
                    4.8439e-06,
                    4.9972e-06,
                    5.1372e-06,
                    5.2787e-06,
                    5.4285e-06,
                    5.5825e-06,
                    5.7465e-06,
                    5.9124e-06,
                    6.0761e-06,
                    6.2473e-06,
                    6.4172e-06,
                    6.5845e-06,
                    6.751e-06,
                    6.9303e-06,
                    7.1089e-06,
                    7.2947e-06,
                    7.4709e-06,
                    7.6598e-06,
                    7.8541e-06,
                    8.0333e-06,
                    8.2394e-06,
                    8.452e-06,
                    8.6702e-06,
                    8.8893e-06,
                    9.1136e-06,
                    9.3448e-06,
                    9.5685e-06,
                    9.803e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_CH4": 0.02,
                "Total_CH4_timeseries": [
                    3.3834e-08,
                    6.8474e-08,
                    1.0392e-07,
                    1.4017e-07,
                    1.7723e-07,
                    2.151e-07,
                    2.5379e-07,
                    2.9328e-07,
                    3.3359e-07,
                    3.7472e-07,
                    4.1689e-07,
                    4.6009e-07,
                    5.0434e-07,
                    5.4963e-07,
                    5.9596e-07,
                    6.4334e-07,
                    6.9178e-07,
                    7.4126e-07,
                    7.9179e-07,
                    8.4338e-07,
                    8.9631e-07,
                    9.5057e-07,
                    1.0062e-06,
                    1.0631e-06,
                    1.1214e-06,
                    1.181e-06,
                    1.2419e-06,
                    1.3042e-06,
                    1.3679e-06,
                    1.4329e-06,
                    1.4996e-06,
                    1.5681e-06,
                    1.6383e-06,
                    1.7102e-06,
                    1.7839e-06,
                    1.8593e-06,
                    1.9365e-06,
                    2.0154e-06,
                    2.0961e-06,
                    2.1785e-06,
                    2.2632e-06,
                    2.3501e-06,
                    2.4394e-06,
                    2.5309e-06,
                    2.6247e-06,
                    2.7207e-06,
                    2.8191e-06,
                    2.9197e-06,
                    3.0226e-06,
                    3.1278e-06,
                    3.2359e-06,
                    3.347e-06,
                    3.4612e-06,
                    3.5782e-06,
                    3.6983e-06,
                    3.8214e-06,
                    3.9474e-06,
                    4.0764e-06,
                    4.2084e-06,
                    4.3434e-06,
                    4.4824e-06,
                    4.6252e-06,
                    4.7719e-06,
                    4.9225e-06,
                    5.0771e-06,
                    5.2356e-06,
                    5.3979e-06,
                    5.5643e-06,
                    5.7345e-06,
                    5.9087e-06,
                    6.0881e-06,
                    6.2729e-06,
                    6.4629e-06,
                    6.6582e-06,
                    6.8589e-06,
                    7.0649e-06,
                    7.2762e-06,
                    7.4928e-06,
                    7.7149e-06,
                    7.9423e-06,
                    8.1767e-06,
                    8.4181e-06,
                    8.6665e-06,
                    8.922e-06,
                    9.1845e-06,
                    9.4574e-06,
                    9.7407e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_CH4": 0.01,
                "Fossil_CH4_timeseries": [
                    1.2488e-08,
                    2.5282e-08,
                    3.8382e-08,
                    5.1792e-08,
                    6.5511e-08,
                    7.9541e-08,
                    9.3885e-08,
                    1.0854e-07,
                    1.2352e-07,
                    1.3881e-07,
                    1.5449e-07,
                    1.7058e-07,
                    1.8706e-07,
                    2.0394e-07,
                    2.2122e-07,
                    2.3891e-07,
                    2.57e-07,
                    2.755e-07,
                    2.944e-07,
                    3.1373e-07,
                    3.3355e-07,
                    3.5387e-07,
                    3.747e-07,
                    3.9603e-07,
                    4.1787e-07,
                    4.4021e-07,
                    4.6306e-07,
                    4.8642e-07,
                    5.1029e-07,
                    5.3467e-07,
                    5.5971e-07,
                    5.854e-07,
                    6.1174e-07,
                    6.3874e-07,
                    6.6639e-07,
                    6.9471e-07,
                    7.2369e-07,
                    7.5333e-07,
                    7.8363e-07,
                    8.146e-07,
                    8.4642e-07,
                    8.791e-07,
                    9.1263e-07,
                    9.4702e-07,
                    9.8227e-07,
                    1.0184e-06,
                    1.0554e-06,
                    1.0932e-06,
                    1.1319e-06,
                    1.1715e-06,
                    1.2122e-06,
                    1.254e-06,
                    1.2969e-06,
                    1.341e-06,
                    1.3861e-06,
                    1.4324e-06,
                    1.4799e-06,
                    1.5285e-06,
                    1.5782e-06,
                    1.629e-06,
                    1.6813e-06,
                    1.7351e-06,
                    1.7904e-06,
                    1.8471e-06,
                    1.9053e-06,
                    1.965e-06,
                    2.0262e-06,
                    2.0888e-06,
                    2.153e-06,
                    2.2186e-06,
                    2.2864e-06,
                    2.3561e-06,
                    2.428e-06,
                    2.502e-06,
                    2.5781e-06,
                    2.6563e-06,
                    2.7366e-06,
                    2.8191e-06,
                    2.9038e-06,
                    2.9906e-06,
                    3.0801e-06,
                    3.1725e-06,
                    3.2676e-06,
                    3.3656e-06,
                    3.4663e-06,
                    3.5699e-06,
                    3.6764e-06,
                    3.7857e-06,
                    3.8979e-06,
                    4.0129e-06,
                    4.1414e-06,
                    4.2831e-06,
                    4.4383e-06,
                    4.607e-06,
                    4.7919e-06,
                    4.9935e-06,
                    5.2119e-06,
                    5.4474e-06,
                    5.7005e-06,
                    5.975e-06,
                    6.2588e-06,
                    6.5528e-06,
                    6.8581e-06,
                    7.1758e-06,
                    7.507e-06,
                    7.8525e-06,
                    8.2133e-06,
                    8.5899e-06,
                    8.9829e-06,
                    9.3959e-06,
                    9.8102e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CH4": 0.02,
                "Land_CH4_timeseries": [
                    2.1347e-08,
                    4.3192e-08,
                    6.5536e-08,
                    8.8379e-08,
                    1.1172e-07,
                    1.3556e-07,
                    1.599e-07,
                    1.8474e-07,
                    2.1008e-07,
                    2.3591e-07,
                    2.6239e-07,
                    2.8951e-07,
                    3.1728e-07,
                    3.4569e-07,
                    3.7474e-07,
                    4.0444e-07,
                    4.3478e-07,
                    4.6576e-07,
                    4.9739e-07,
                    5.2966e-07,
                    5.6276e-07,
                    5.967e-07,
                    6.3147e-07,
                    6.6707e-07,
                    7.0351e-07,
                    7.4078e-07,
                    7.7888e-07,
                    8.1782e-07,
                    8.5759e-07,
                    8.982e-07,
                    9.3989e-07,
                    9.8266e-07,
                    1.0265e-06,
                    1.0715e-06,
                    1.1175e-06,
                    1.1646e-06,
                    1.2128e-06,
                    1.2621e-06,
                    1.3124e-06,
                    1.3639e-06,
                    1.4168e-06,
                    1.471e-06,
                    1.5267e-06,
                    1.5839e-06,
                    1.6424e-06,
                    1.7023e-06,
                    1.7637e-06,
                    1.8265e-06,
                    1.8907e-06,
                    1.9563e-06,
                    2.0238e-06,
                    2.0931e-06,
                    2.1643e-06,
                    2.2373e-06,
                    2.3122e-06,
                    2.3889e-06,
                    2.4675e-06,
                    2.548e-06,
                    2.6303e-06,
                    2.7144e-06,
                    2.801e-06,
                    2.8901e-06,
                    2.9815e-06,
                    3.0754e-06,
                    3.1718e-06,
                    3.2706e-06,
                    3.3718e-06,
                    3.4754e-06,
                    3.5815e-06,
                    3.69e-06,
                    3.8018e-06,
                    3.9167e-06,
                    4.0349e-06,
                    4.1562e-06,
                    4.2808e-06,
                    4.4086e-06,
                    4.5395e-06,
                    4.6737e-06,
                    4.8111e-06,
                    4.9517e-06,
                    5.0966e-06,
                    5.2456e-06,
                    5.3989e-06,
                    5.5564e-06,
                    5.7182e-06,
                    5.8875e-06,
                    6.0644e-06,
                    6.2491e-06,
                    6.4418e-06,
                    6.6427e-06,
                    6.8712e-06,
                    7.1279e-06,
                    7.4133e-06,
                    7.7278e-06,
                    8.072e-06,
                    8.4462e-06,
                    8.8511e-06,
                    9.2871e-06,
                    9.7547e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_N2O": 0.02,
                "Total_N2O_timeseries": [
                    8.879e-09,
                    1.7928e-08,
                    2.7141e-08,
                    3.6507e-08,
                    4.6015e-08,
                    5.5649e-08,
                    6.5391e-08,
                    7.5221e-08,
                    8.5115e-08,
                    9.5049e-08,
                    1.0501e-07,
                    1.1498e-07,
                    1.2497e-07,
                    1.3498e-07,
                    1.4499e-07,
                    1.5502e-07,
                    1.6506e-07,
                    1.7512e-07,
                    1.852e-07,
                    1.953e-07,
                    2.0557e-07,
                    2.1623e-07,
                    2.2748e-07,
                    2.3943e-07,
                    2.5216e-07,
                    2.6569e-07,
                    2.7998e-07,
                    2.9494e-07,
                    3.1042e-07,
                    3.2621e-07,
                    3.4219e-07,
                    3.5833e-07,
                    3.7459e-07,
                    3.9097e-07,
                    4.0746e-07,
                    4.2404e-07,
                    4.4072e-07,
                    4.575e-07,
                    4.744e-07,
                    4.9221e-07,
                    5.102e-07,
                    5.284e-07,
                    5.4681e-07,
                    5.6544e-07,
                    5.8429e-07,
                    6.0339e-07,
                    6.2273e-07,
                    6.4233e-07,
                    6.6219e-07,
                    6.8231e-07,
                    7.0271e-07,
                    7.2338e-07,
                    7.4432e-07,
                    7.6556e-07,
                    7.871e-07,
                    8.0896e-07,
                    8.3116e-07,
                    8.5373e-07,
                    8.767e-07,
                    9.0011e-07,
                    9.2412e-07,
                    9.49e-07,
                    9.7499e-07,
                    1.0023e-06,
                    1.0309e-06,
                    1.0611e-06,
                    1.0927e-06,
                    1.1259e-06,
                    1.1605e-06,
                    1.1964e-06,
                    1.2337e-06,
                    1.2725e-06,
                    1.3129e-06,
                    1.3549e-06,
                    1.3985e-06,
                    1.4436e-06,
                    1.49e-06,
                    1.5374e-06,
                    1.5855e-06,
                    1.6339e-06,
                    1.6823e-06,
                    1.7303e-06,
                    1.7779e-06,
                    1.8247e-06,
                    1.8708e-06,
                    1.9163e-06,
                    1.961e-06,
                    2.0053e-06,
                    2.0494e-06,
                    2.0936e-06,
                    2.1418e-06,
                    2.2008e-06,
                    2.2756e-06,
                    2.3695e-06,
                    2.4842e-06,
                    2.6198e-06,
                    2.7747e-06,
                    2.9457e-06,
                    3.1278e-06,
                    3.3147e-06,
                    3.5005e-06,
                    3.682e-06,
                    3.8568e-06,
                    4.0232e-06,
                    4.1803e-06,
                    4.3283e-06,
                    4.4679e-06,
                    4.6007e-06,
                    4.7293e-06,
                    4.8568e-06,
                    5.0056e-06,
                    5.1568e-06,
                    5.3051e-06,
                    5.4577e-06,
                    5.6039e-06,
                    5.747e-06,
                    5.8958e-06,
                    6.0466e-06,
                    6.2047e-06,
                    6.3674e-06,
                    6.5323e-06,
                    6.6987e-06,
                    6.8765e-06,
                    7.0558e-06,
                    7.2393e-06,
                    7.4223e-06,
                    7.6064e-06,
                    7.7987e-06,
                    7.9986e-06,
                    8.2035e-06,
                    8.4035e-06,
                    8.6015e-06,
                    8.8091e-06,
                    8.9973e-06,
                    9.1936e-06,
                    9.3942e-06,
                    9.5959e-06,
                    9.7977e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_N2O": 0.01,
                "Fossil_N2O_timeseries": [
                    1.3023e-09,
                    2.6234e-09,
                    3.9628e-09,
                    5.3199e-09,
                    6.6937e-09,
                    8.0831e-09,
                    9.4869e-09,
                    1.0904e-08,
                    1.2332e-08,
                    1.3769e-08,
                    1.5214e-08,
                    1.6668e-08,
                    1.8129e-08,
                    1.9597e-08,
                    2.1073e-08,
                    2.2557e-08,
                    2.4048e-08,
                    2.5547e-08,
                    2.7054e-08,
                    2.8569e-08,
                    3.0102e-08,
                    3.1671e-08,
                    3.3288e-08,
                    3.4963e-08,
                    3.67e-08,
                    3.8501e-08,
                    4.0363e-08,
                    4.228e-08,
                    4.4242e-08,
                    4.6232e-08,
                    4.8243e-08,
                    5.0271e-08,
                    5.2315e-08,
                    5.4374e-08,
                    5.6447e-08,
                    5.8534e-08,
                    6.0634e-08,
                    6.2748e-08,
                    6.4877e-08,
                    6.7136e-08,
                    6.9439e-08,
                    7.1789e-08,
                    7.4188e-08,
                    7.6639e-08,
                    7.9144e-08,
                    8.1707e-08,
                    8.4328e-08,
                    8.7011e-08,
                    8.9758e-08,
                    9.2569e-08,
                    9.5453e-08,
                    9.8418e-08,
                    1.0147e-07,
                    1.0462e-07,
                    1.0786e-07,
                    1.112e-07,
                    1.1463e-07,
                    1.1814e-07,
                    1.2173e-07,
                    1.2538e-07,
                    1.2909e-07,
                    1.3284e-07,
                    1.3664e-07,
                    1.4048e-07,
                    1.4437e-07,
                    1.4829e-07,
                    1.5226e-07,
                    1.5627e-07,
                    1.6032e-07,
                    1.6441e-07,
                    1.6856e-07,
                    1.7274e-07,
                    1.7697e-07,
                    1.8125e-07,
                    1.8557e-07,
                    1.8994e-07,
                    1.9436e-07,
                    1.9884e-07,
                    2.0337e-07,
                    2.0798e-07,
                    2.1267e-07,
                    2.1748e-07,
                    2.2243e-07,
                    2.2755e-07,
                    2.3285e-07,
                    2.3835e-07,
                    2.4405e-07,
                    2.4996e-07,
                    2.5608e-07,
                    2.624e-07,
                    2.6893e-07,
                    2.757e-07,
                    2.8274e-07,
                    2.9005e-07,
                    2.9766e-07,
                    3.0557e-07,
                    3.138e-07,
                    3.2233e-07,
                    3.3118e-07,
                    3.4032e-07,
                    3.4979e-07,
                    3.5964e-07,
                    3.6989e-07,
                    3.8058e-07,
                    3.9171e-07,
                    4.0327e-07,
                    4.1526e-07,
                    4.2763e-07,
                    4.4035e-07,
                    4.5334e-07,
                    4.6658e-07,
                    4.8003e-07,
                    4.9369e-07,
                    5.0757e-07,
                    5.2169e-07,
                    5.3607e-07,
                    5.5078e-07,
                    5.6587e-07,
                    5.8142e-07,
                    5.9768e-07,
                    6.1411e-07,
                    6.3113e-07,
                    6.4869e-07,
                    6.6696e-07,
                    6.8597e-07,
                    7.0543e-07,
                    7.2508e-07,
                    7.4637e-07,
                    7.6833e-07,
                    7.9126e-07,
                    8.1486e-07,
                    8.3876e-07,
                    8.6292e-07,
                    8.8559e-07,
                    9.0906e-07,
                    9.3342e-07,
                    9.5753e-07,
                    9.8209e-07,
                    1.008e-06,
                    1.0375e-06,
                    1.0674e-06,
                    1.0961e-06,
                    1.1241e-06,
                    1.155e-06,
                    1.1855e-06,
                    1.2155e-06,
                    1.2465e-06,
                    1.2785e-06,
                    1.311e-06,
                    1.345e-06,
                    1.3794e-06,
                    1.4141e-06,
                    1.4483e-06,
                    1.4822e-06,
                    1.5177e-06,
                    1.5556e-06,
                    1.5944e-06,
                    1.6331e-06,
                    1.6739e-06,
                    1.713e-06,
                    1.7513e-06,
                    1.7887e-06,
                    1.8294e-06,
                    1.8689e-06,
                    1.9098e-06,
                    1.9496e-06,
                    1.9899e-06,
                    2.0312e-06,
                    2.0727e-06,
                    2.1135e-06,
                    2.1545e-06,
                    2.1963e-06
                ],
                "Land_N2O": 0.02,
                "Land_N2O_timeseries": [
                    7.5767e-09,
                    1.5305e-08,
                    2.3178e-08,
                    3.1187e-08,
                    3.9321e-08,
                    4.7565e-08,
                    5.5904e-08,
                    6.4317e-08,
                    7.2784e-08,
                    8.128e-08,
                    8.9791e-08,
                    9.8313e-08,
                    1.0684e-07,
                    1.1538e-07,
                    1.2392e-07,
                    1.3246e-07,
                    1.4102e-07,
                    1.4958e-07,
                    1.5815e-07,
                    1.6674e-07,
                    1.7547e-07,
                    1.8456e-07,
                    1.9419e-07,
                    2.0447e-07,
                    2.1546e-07,
                    2.2719e-07,
                    2.3962e-07,
                    2.5266e-07,
                    2.6617e-07,
                    2.7998e-07,
                    2.9395e-07,
                    3.0806e-07,
                    3.2228e-07,
                    3.366e-07,
                    3.5101e-07,
                    3.6551e-07,
                    3.8009e-07,
                    3.9476e-07,
                    4.0953e-07,
                    4.2507e-07,
                    4.4076e-07,
                    4.5661e-07,
                    4.7262e-07,
                    4.888e-07,
                    5.0515e-07,
                    5.2168e-07,
                    5.384e-07,
                    5.5532e-07,
                    5.7243e-07,
                    5.8974e-07,
                    6.0726e-07,
                    6.2496e-07,
                    6.4285e-07,
                    6.6094e-07,
                    6.7923e-07,
                    6.9775e-07,
                    7.1653e-07,
                    7.3559e-07,
                    7.5497e-07,
                    7.7472e-07,
                    7.9503e-07,
                    8.1616e-07,
                    8.3835e-07,
                    8.6177e-07,
                    8.8655e-07,
                    9.1277e-07,
                    9.4047e-07,
                    9.6963e-07,
                    1.0002e-06,
                    1.032e-06,
                    1.0651e-06,
                    1.0997e-06,
                    1.1359e-06,
                    1.1737e-06,
                    1.2129e-06,
                    1.2537e-06,
                    1.2956e-06,
                    1.3385e-06,
                    1.3821e-06,
                    1.4259e-06,
                    1.4696e-06,
                    1.5129e-06,
                    1.5554e-06,
                    1.5972e-06,
                    1.638e-06,
                    1.6779e-06,
                    1.717e-06,
                    1.7554e-06,
                    1.7933e-06,
                    1.8312e-06,
                    1.8729e-06,
                    1.9251e-06,
                    1.9929e-06,
                    2.0794e-06,
                    2.1865e-06,
                    2.3142e-06,
                    2.4609e-06,
                    2.6233e-06,
                    2.7967e-06,
                    2.9744e-06,
                    3.1507e-06,
                    3.3224e-06,
                    3.4869e-06,
                    3.6426e-06,
                    3.7886e-06,
                    3.925e-06,
                    4.0526e-06,
                    4.1731e-06,
                    4.2889e-06,
                    4.4034e-06,
                    4.539e-06,
                    4.6768e-06,
                    4.8114e-06,
                    4.9502e-06,
                    5.0822e-06,
                    5.211e-06,
                    5.345e-06,
                    5.4808e-06,
                    5.6233e-06,
                    5.7697e-06,
                    5.9182e-06,
                    6.0675e-06,
                    6.2278e-06,
                    6.3889e-06,
                    6.5534e-06,
                    6.7169e-06,
                    6.8813e-06,
                    7.0523e-06,
                    7.2302e-06,
                    7.4122e-06,
                    7.5887e-06,
                    7.7627e-06,
                    7.9462e-06,
                    8.1117e-06,
                    8.2845e-06,
                    8.4608e-06,
                    8.6383e-06,
                    8.8156e-06,
                    9.0004e-06,
                    9.1938e-06,
                    9.388e-06,
                    9.5906e-06,
                    9.7637e-06,
                    9.9287e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            32.13366,
                            -26.83498
                        ],
                        [
                            32.13648,
                            -26.53607
                        ],
                        [
                            32.08104,
                            -26.41111
                        ],
                        [
                            32.07523,
                            -26.31163
                        ],
                        [
                            32.10778,
                            -26.16602
                        ],
                        [
                            32.08816,
                            -26.01386
                        ],
                        [
                            32.00495,
                            -25.99025
                        ],
                        [
                            31.98213,
                            -25.95205
                        ],
                        [
                            31.86935,
                            -25.99792
                        ],
                        [
                            31.42566,
                            -25.72057
                        ],
                        [
                            31.31863,
                            -25.74555
                        ],
                        [
                            31.26159,
                            -25.81647
                        ],
                        [
                            31.14403,
                            -25.90652
                        ],
                        [
                            31.1178,
                            -25.98637
                        ],
                        [
                            30.96696,
                            -26.25952
                        ],
                        [
                            30.89708,
                            -26.32246
                        ],
                        [
                            30.82082,
                            -26.44593
                        ],
                        [
                            30.79573,
                            -26.56506
                        ],
                        [
                            30.79774,
                            -26.72059
                        ],
                        [
                            30.81285,
                            -26.82596
                        ],
                        [
                            30.91095,
                            -26.84679
                        ],
                        [
                            30.98599,
                            -26.93268
                        ],
                        [
                            30.97619,
                            -27.01413
                        ],
                        [
                            31.06876,
                            -27.09781
                        ],
                        [
                            31.15156,
                            -27.19509
                        ],
                        [
                            31.50179,
                            -27.31511
                        ],
                        [
                            31.9746,
                            -27.31618
                        ],
                        [
                            31.98334,
                            -27.05837
                        ],
                        [
                            32.0132,
                            -26.81444
                        ],
                        [
                            32.10045,
                            -26.80715
                        ],
                        [
                            32.13366,
                            -26.83498
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "SWE",
                "Country": "Sweden",
                "Total_3GHG": 0.24,
                "Total_3GHG_timeseries": [
                    8.77e-06,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039
                ],
                "Fossil_3GHG": 0.27,
                "Fossil_3GHG_timeseries": [
                    5.1348e-07,
                    1.0322e-06,
                    1.5612e-06,
                    2.1547e-06,
                    2.7466e-06,
                    3.4228e-06,
                    4.1642e-06,
                    4.8703e-06,
                    5.7053e-06,
                    6.5593e-06,
                    7.5287e-06,
                    8.5143e-06,
                    9.5116e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029
                ],
                "Land_3GHG": 0.18,
                "Land_3GHG_timeseries": [
                    8.2565e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001
                ],
                "Total_CO2": 0.26,
                "Total_CO2_timeseries": [
                    7.4519e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003
                ],
                "Fossil_CO2": 0.29,
                "Fossil_CO2_timeseries": [
                    9.735e-08,
                    1.947e-07,
                    2.97e-07,
                    4.488e-07,
                    5.907e-07,
                    8.052e-07,
                    1.0807e-06,
                    1.3117e-06,
                    1.6517e-06,
                    1.9899e-06,
                    2.4255e-06,
                    2.8693e-06,
                    3.3132e-06,
                    3.7802e-06,
                    4.2669e-06,
                    4.7685e-06,
                    5.2354e-06,
                    5.7865e-06,
                    6.2766e-06,
                    6.8805e-06,
                    7.5256e-06,
                    8.2962e-06,
                    9.0783e-06,
                    9.9214e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023
                ],
                "Land_CO2": 0.2,
                "Land_CO2_timeseries": [
                    7.3546e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Total_CH4": 0.15,
                "Total_CH4_timeseries": [
                    1.0481e-06,
                    2.0961e-06,
                    3.1441e-06,
                    4.2018e-06,
                    5.2625e-06,
                    6.3298e-06,
                    7.3961e-06,
                    8.4665e-06,
                    9.5518e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006
                ],
                "Fossil_CH4": 0.17,
                "Fossil_CH4_timeseries": [
                    2.8746e-07,
                    5.7865e-07,
                    8.7351e-07,
                    1.182e-06,
                    1.4973e-06,
                    1.8229e-06,
                    2.1513e-06,
                    2.4877e-06,
                    2.8428e-06,
                    3.2176e-06,
                    3.6092e-06,
                    4.0079e-06,
                    4.4172e-06,
                    4.8327e-06,
                    5.2539e-06,
                    5.6822e-06,
                    6.1094e-06,
                    6.5193e-06,
                    6.9066e-06,
                    7.2928e-06,
                    7.6694e-06,
                    8.0541e-06,
                    8.4422e-06,
                    8.8256e-06,
                    9.218e-06,
                    9.607e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0004
                ],
                "Land_CH4": 0.11,
                "Land_CH4_timeseries": [
                    7.6065e-07,
                    1.5175e-06,
                    2.2705e-06,
                    3.0198e-06,
                    3.7652e-06,
                    4.5069e-06,
                    5.2447e-06,
                    5.9788e-06,
                    6.709e-06,
                    7.4355e-06,
                    8.1799e-06,
                    8.9421e-06,
                    9.7223e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Total_N2O": 0.37,
                "Total_N2O_timeseries": [
                    2.6994e-07,
                    5.4426e-07,
                    8.2282e-07,
                    1.1054e-06,
                    1.3918e-06,
                    1.6816e-06,
                    1.9745e-06,
                    2.2701e-06,
                    2.5679e-06,
                    2.8674e-06,
                    3.1681e-06,
                    3.4701e-06,
                    3.7733e-06,
                    4.0776e-06,
                    4.3831e-06,
                    4.6896e-06,
                    4.9973e-06,
                    5.3062e-06,
                    5.6163e-06,
                    5.9278e-06,
                    6.2435e-06,
                    6.5683e-06,
                    6.906e-06,
                    7.2591e-06,
                    7.6293e-06,
                    8.0168e-06,
                    8.4209e-06,
                    8.8397e-06,
                    9.2701e-06,
                    9.7079e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_N2O": 0.59,
                "Fossil_N2O_timeseries": [
                    1.2867e-07,
                    2.5889e-07,
                    3.9065e-07,
                    5.239e-07,
                    6.5861e-07,
                    7.9472e-07,
                    9.3217e-07,
                    1.0709e-06,
                    1.2108e-06,
                    1.3519e-06,
                    1.4939e-06,
                    1.6371e-06,
                    1.7812e-06,
                    1.9264e-06,
                    2.0726e-06,
                    2.2198e-06,
                    2.368e-06,
                    2.5173e-06,
                    2.6676e-06,
                    2.8189e-06,
                    2.9718e-06,
                    3.127e-06,
                    3.2852e-06,
                    3.4467e-06,
                    3.6119e-06,
                    3.7808e-06,
                    3.9532e-06,
                    4.1288e-06,
                    4.3072e-06,
                    4.4876e-06,
                    4.6697e-06,
                    4.8532e-06,
                    5.0382e-06,
                    5.2245e-06,
                    5.4122e-06,
                    5.6011e-06,
                    5.7914e-06,
                    5.983e-06,
                    6.176e-06,
                    6.377e-06,
                    6.5809e-06,
                    6.7881e-06,
                    6.9986e-06,
                    7.2126e-06,
                    7.4302e-06,
                    7.6515e-06,
                    7.8768e-06,
                    8.1061e-06,
                    8.3395e-06,
                    8.5771e-06,
                    8.8193e-06,
                    9.0665e-06,
                    9.3193e-06,
                    9.5778e-06,
                    9.8421e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_N2O": 0.29,
                "Land_N2O_timeseries": [
                    1.4127e-07,
                    2.8537e-07,
                    4.3217e-07,
                    5.815e-07,
                    7.3316e-07,
                    8.8687e-07,
                    1.0423e-06,
                    1.1992e-06,
                    1.3571e-06,
                    1.5155e-06,
                    1.6742e-06,
                    1.8331e-06,
                    1.9921e-06,
                    2.1513e-06,
                    2.3105e-06,
                    2.4698e-06,
                    2.6293e-06,
                    2.7889e-06,
                    2.9487e-06,
                    3.1088e-06,
                    3.2717e-06,
                    3.4412e-06,
                    3.6208e-06,
                    3.8124e-06,
                    4.0174e-06,
                    4.2361e-06,
                    4.4678e-06,
                    4.7109e-06,
                    4.9629e-06,
                    5.2203e-06,
                    5.4808e-06,
                    5.7438e-06,
                    6.009e-06,
                    6.276e-06,
                    6.5447e-06,
                    6.815e-06,
                    7.0869e-06,
                    7.3604e-06,
                    7.6358e-06,
                    7.8783e-06,
                    8.1548e-06,
                    8.463e-06,
                    8.8005e-06,
                    9.1645e-06,
                    9.5519e-06,
                    9.959e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                24.15513,
                                65.81603
                            ],
                            [
                                24.14976,
                                65.86469
                            ],
                            [
                                24.04517,
                                66.00137
                            ],
                            [
                                23.93898,
                                66.07815
                            ],
                            [
                                23.92788,
                                66.15066
                            ],
                            [
                                23.7295,
                                66.19475
                            ],
                            [
                                23.64593,
                                66.30207
                            ],
                            [
                                23.6854,
                                66.37729
                            ],
                            [
                                23.65074,
                                66.45497
                            ],
                            [
                                23.85617,
                                66.55702
                            ],
                            [
                                23.87701,
                                66.75385
                            ],
                            [
                                23.99448,
                                66.8225
                            ],
                            [
                                23.55177,
                                67.17127
                            ],
                            [
                                23.57814,
                                67.26909
                            ],
                            [
                                23.72202,
                                67.2827
                            ],
                            [
                                23.75954,
                                67.43348
                            ],
                            [
                                23.41262,
                                67.46691
                            ],
                            [
                                23.40598,
                                67.5011
                            ],
                            [
                                23.54435,
                                67.58305
                            ],
                            [
                                23.49144,
                                67.66648
                            ],
                            [
                                23.47801,
                                67.84253
                            ],
                            [
                                23.64348,
                                67.91743
                            ],
                            [
                                23.6358,
                                67.96608
                            ],
                            [
                                23.40128,
                                68.04311
                            ],
                            [
                                23.28408,
                                68.1556
                            ],
                            [
                                23.14138,
                                68.15468
                            ],
                            [
                                23.14243,
                                68.24602
                            ],
                            [
                                23.06864,
                                68.29863
                            ],
                            [
                                22.64508,
                                68.41843
                            ],
                            [
                                22.34364,
                                68.48143
                            ],
                            [
                                22.04317,
                                68.48088
                            ],
                            [
                                21.90027,
                                68.5795
                            ],
                            [
                                21.71653,
                                68.59161
                            ],
                            [
                                21.61948,
                                68.66315
                            ],
                            [
                                21.42935,
                                68.69249
                            ],
                            [
                                21.38929,
                                68.76377
                            ],
                            [
                                20.84476,
                                68.93622
                            ],
                            [
                                20.91147,
                                68.96815
                            ],
                            [
                                20.77368,
                                69.03262
                            ],
                            [
                                20.54864,
                                69.05997
                            ],
                            [
                                20.06005,
                                69.04576
                            ],
                            [
                                20.30612,
                                68.92618
                            ],
                            [
                                20.33527,
                                68.8018
                            ],
                            [
                                20.20328,
                                68.66645
                            ],
                            [
                                19.9375,
                                68.55794
                            ],
                            [
                                20.22654,
                                68.49081
                            ],
                            [
                                19.92026,
                                68.35633
                            ],
                            [
                                18.98545,
                                68.51666
                            ],
                            [
                                18.62103,
                                68.50723
                            ],
                            [
                                18.40555,
                                68.5816
                            ],
                            [
                                18.12592,
                                68.53652
                            ],
                            [
                                18.10109,
                                68.40604
                            ],
                            [
                                18.15135,
                                68.19879
                            ],
                            [
                                17.89976,
                                67.96937
                            ],
                            [
                                17.66475,
                                68.03838
                            ],
                            [
                                17.28152,
                                68.11881
                            ],
                            [
                                17.18051,
                                68.05046
                            ],
                            [
                                16.74003,
                                67.91482
                            ],
                            [
                                16.55628,
                                67.64719
                            ],
                            [
                                16.40767,
                                67.5341
                            ],
                            [
                                16.15859,
                                67.51898
                            ],
                            [
                                16.09041,
                                67.43577
                            ],
                            [
                                16.40334,
                                67.20547
                            ],
                            [
                                16.38763,
                                67.04601
                            ],
                            [
                                16.03992,
                                66.91294
                            ],
                            [
                                15.62209,
                                66.59494
                            ],
                            [
                                15.37776,
                                66.48413
                            ],
                            [
                                15.48167,
                                66.28177
                            ],
                            [
                                15.03577,
                                66.15399
                            ],
                            [
                                14.51737,
                                66.13243
                            ],
                            [
                                14.62506,
                                65.81153
                            ],
                            [
                                14.54129,
                                65.69987
                            ],
                            [
                                14.499,
                                65.52218
                            ],
                            [
                                14.5065,
                                65.31002
                            ],
                            [
                                14.379,
                                65.24742
                            ],
                            [
                                14.32599,
                                65.11892
                            ],
                            [
                                14.07755,
                                64.93912
                            ],
                            [
                                13.70608,
                                64.64042
                            ],
                            [
                                13.65503,
                                64.58054
                            ],
                            [
                                13.89091,
                                64.5073
                            ],
                            [
                                14.11391,
                                64.46173
                            ],
                            [
                                14.15638,
                                64.19494
                            ],
                            [
                                13.96787,
                                64.00906
                            ],
                            [
                                13.71279,
                                64.04655
                            ],
                            [
                                13.21111,
                                64.09537
                            ],
                            [
                                12.92679,
                                64.05784
                            ],
                            [
                                12.68357,
                                63.97422
                            ],
                            [
                                12.3315,
                                63.71568
                            ],
                            [
                                12.14977,
                                63.59395
                            ],
                            [
                                12.2123,
                                63.47834
                            ],
                            [
                                11.97458,
                                63.26923
                            ],
                            [
                                12.21757,
                                63.00067
                            ],
                            [
                                12.07469,
                                62.90254
                            ],
                            [
                                12.13638,
                                62.74792
                            ],
                            [
                                12.05663,
                                62.6115
                            ],
                            [
                                12.29937,
                                62.26749
                            ],
                            [
                                12.13804,
                                61.72458
                            ],
                            [
                                12.41971,
                                61.56339
                            ],
                            [
                                12.56958,
                                61.56828
                            ],
                            [
                                12.87085,
                                61.35649
                            ],
                            [
                                12.79003,
                                61.19699
                            ],
                            [
                                12.70736,
                                61.14321
                            ],
                            [
                                12.68264,
                                61.06165
                            ],
                            [
                                12.44797,
                                61.05067
                            ],
                            [
                                12.22399,
                                61.01308
                            ],
                            [
                                12.33263,
                                60.88986
                            ],
                            [
                                12.39533,
                                60.73423
                            ],
                            [
                                12.51084,
                                60.64216
                            ],
                            [
                                12.60684,
                                60.51158
                            ],
                            [
                                12.60583,
                                60.4062
                            ],
                            [
                                12.49928,
                                60.32346
                            ],
                            [
                                12.54156,
                                60.19319
                            ],
                            [
                                12.44962,
                                60.0403
                            ],
                            [
                                12.34077,
                                59.96572
                            ],
                            [
                                12.17124,
                                59.88932
                            ],
                            [
                                11.98422,
                                59.90028
                            ],
                            [
                                11.83973,
                                59.84077
                            ],
                            [
                                11.92548,
                                59.79393
                            ],
                            [
                                11.93794,
                                59.69459
                            ],
                            [
                                11.85658,
                                59.64898
                            ],
                            [
                                11.71845,
                                59.62387
                            ],
                            [
                                11.69153,
                                59.58894
                            ],
                            [
                                11.81613,
                                59.34445
                            ],
                            [
                                11.82959,
                                59.24317
                            ],
                            [
                                11.78349,
                                59.20718
                            ],
                            [
                                11.77524,
                                59.08705
                            ],
                            [
                                11.71051,
                                59.03368
                            ],
                            [
                                11.63175,
                                58.90834
                            ],
                            [
                                11.45745,
                                58.88844
                            ],
                            [
                                11.46083,
                                58.98866
                            ],
                            [
                                11.34069,
                                59.11057
                            ],
                            [
                                11.18938,
                                59.07554
                            ],
                            [
                                11.12122,
                                58.96485
                            ],
                            [
                                11.24659,
                                58.81083
                            ],
                            [
                                11.17491,
                                58.71917
                            ],
                            [
                                11.25814,
                                58.67746
                            ],
                            [
                                11.27633,
                                58.58826
                            ],
                            [
                                11.23659,
                                58.54918
                            ],
                            [
                                11.32394,
                                58.46476
                            ],
                            [
                                11.22229,
                                58.41234
                            ],
                            [
                                11.36986,
                                58.36256
                            ],
                            [
                                11.3968,
                                58.31809
                            ],
                            [
                                11.56196,
                                58.26168
                            ],
                            [
                                11.63875,
                                58.26277
                            ],
                            [
                                11.7206,
                                58.3381
                            ],
                            [
                                11.81006,
                                58.32413
                            ],
                            [
                                11.89308,
                                58.20354
                            ],
                            [
                                11.81453,
                                58.07626
                            ],
                            [
                                11.78456,
                                57.92084
                            ],
                            [
                                11.69248,
                                57.86125
                            ],
                            [
                                11.74658,
                                57.79876
                            ],
                            [
                                11.70508,
                                57.70683
                            ],
                            [
                                11.85538,
                                57.67718
                            ],
                            [
                                11.93362,
                                57.57384
                            ],
                            [
                                11.90565,
                                57.43895
                            ],
                            [
                                11.94421,
                                57.36587
                            ],
                            [
                                12.02339,
                                57.37459
                            ],
                            [
                                12.10509,
                                57.43444
                            ],
                            [
                                12.16278,
                                57.28581
                            ],
                            [
                                12.09594,
                                57.23403
                            ],
                            [
                                12.22486,
                                57.15477
                            ],
                            [
                                12.20437,
                                57.11681
                            ],
                            [
                                12.33934,
                                57.01751
                            ],
                            [
                                12.36213,
                                56.91951
                            ],
                            [
                                12.47014,
                                56.89434
                            ],
                            [
                                12.59371,
                                56.83121
                            ],
                            [
                                12.62548,
                                56.74233
                            ],
                            [
                                12.72984,
                                56.65816
                            ],
                            [
                                12.88032,
                                56.64894
                            ],
                            [
                                12.93614,
                                56.58735
                            ],
                            [
                                12.94021,
                                56.50659
                            ],
                            [
                                12.85098,
                                56.4311
                            ],
                            [
                                12.74683,
                                56.46796
                            ],
                            [
                                12.65698,
                                56.45495
                            ],
                            [
                                12.6382,
                                56.38939
                            ],
                            [
                                12.73525,
                                56.36185
                            ],
                            [
                                12.82603,
                                56.28277
                            ],
                            [
                                12.78267,
                                56.21934
                            ],
                            [
                                12.5155,
                                56.2946
                            ],
                            [
                                12.56773,
                                56.14567
                            ],
                            [
                                12.74769,
                                55.98965
                            ],
                            [
                                12.813,
                                55.87631
                            ],
                            [
                                12.91298,
                                55.83493
                            ],
                            [
                                12.9692,
                                55.7253
                            ],
                            [
                                13.04903,
                                55.69798
                            ],
                            [
                                13.00909,
                                55.63701
                            ],
                            [
                                12.89408,
                                55.56722
                            ],
                            [
                                12.96818,
                                55.45632
                            ],
                            [
                                12.96448,
                                55.40142
                            ],
                            [
                                13.07608,
                                55.3679
                            ],
                            [
                                13.36277,
                                55.33771
                            ],
                            [
                                13.50976,
                                55.38587
                            ],
                            [
                                13.71525,
                                55.427
                            ],
                            [
                                13.92068,
                                55.43442
                            ],
                            [
                                14.05427,
                                55.38135
                            ],
                            [
                                14.19745,
                                55.38574
                            ],
                            [
                                14.36043,
                                55.55386
                            ],
                            [
                                14.20442,
                                55.70205
                            ],
                            [
                                14.22033,
                                55.83061
                            ],
                            [
                                14.33984,
                                55.95781
                            ],
                            [
                                14.55399,
                                56.04988
                            ],
                            [
                                14.67043,
                                55.99144
                            ],
                            [
                                14.72593,
                                56.06273
                            ],
                            [
                                14.67379,
                                56.14648
                            ],
                            [
                                14.86845,
                                56.16205
                            ],
                            [
                                15.21639,
                                56.15552
                            ],
                            [
                                15.30749,
                                56.17651
                            ],
                            [
                                15.54366,
                                56.18836
                            ],
                            [
                                15.72524,
                                56.16807
                            ],
                            [
                                15.83478,
                                56.08546
                            ],
                            [
                                16.03986,
                                56.25599
                            ],
                            [
                                16.09364,
                                56.41694
                            ],
                            [
                                16.22451,
                                56.60282
                            ],
                            [
                                16.29838,
                                56.65866
                            ],
                            [
                                16.3692,
                                56.66241
                            ],
                            [
                                16.39875,
                                56.78582
                            ],
                            [
                                16.51599,
                                57.05879
                            ],
                            [
                                16.4641,
                                57.16508
                            ],
                            [
                                16.50445,
                                57.23136
                            ],
                            [
                                16.48732,
                                57.28726
                            ],
                            [
                                16.72075,
                                57.44405
                            ],
                            [
                                16.62701,
                                57.55095
                            ],
                            [
                                16.63938,
                                57.67665
                            ],
                            [
                                16.71457,
                                57.7091
                            ],
                            [
                                16.52277,
                                57.82393
                            ],
                            [
                                16.52228,
                                57.90139
                            ],
                            [
                                16.75352,
                                57.86695
                            ],
                            [
                                16.76688,
                                57.96151
                            ],
                            [
                                16.65998,
                                57.97395
                            ],
                            [
                                16.80956,
                                58.06577
                            ],
                            [
                                16.77294,
                                58.10894
                            ],
                            [
                                16.85306,
                                58.19223
                            ],
                            [
                                16.80965,
                                58.23613
                            ],
                            [
                                16.79088,
                                58.35898
                            ],
                            [
                                16.70259,
                                58.4019
                            ],
                            [
                                16.84842,
                                58.44618
                            ],
                            [
                                16.87754,
                                58.51524
                            ],
                            [
                                16.79468,
                                58.59683
                            ],
                            [
                                16.55483,
                                58.63254
                            ],
                            [
                                16.35074,
                                58.63025
                            ],
                            [
                                16.34677,
                                58.66526
                            ],
                            [
                                16.90874,
                                58.61067
                            ],
                            [
                                17.01913,
                                58.62621
                            ],
                            [
                                17.11311,
                                58.72576
                            ],
                            [
                                17.26036,
                                58.72223
                            ],
                            [
                                17.39258,
                                58.76006
                            ],
                            [
                                17.61725,
                                58.94955
                            ],
                            [
                                17.61403,
                                59.03531
                            ],
                            [
                                17.74512,
                                59.05731
                            ],
                            [
                                17.73458,
                                58.93105
                            ],
                            [
                                17.89208,
                                58.83082
                            ],
                            [
                                17.96911,
                                58.92179
                            ],
                            [
                                18.02534,
                                59.04352
                            ],
                            [
                                18.43339,
                                59.14196
                            ],
                            [
                                18.3783,
                                59.18566
                            ],
                            [
                                18.70114,
                                59.27614
                            ],
                            [
                                18.62836,
                                59.36629
                            ],
                            [
                                18.53557,
                                59.3825
                            ],
                            [
                                18.41673,
                                59.35211
                            ],
                            [
                                18.30186,
                                59.36195
                            ],
                            [
                                18.15153,
                                59.33051
                            ],
                            [
                                18.15353,
                                59.39972
                            ],
                            [
                                18.28741,
                                59.38698
                            ],
                            [
                                18.29776,
                                59.45607
                            ],
                            [
                                18.41001,
                                59.47999
                            ],
                            [
                                18.66512,
                                59.57766
                            ],
                            [
                                18.76968,
                                59.68408
                            ],
                            [
                                19.06948,
                                59.71775
                            ],
                            [
                                19.07167,
                                59.76416
                            ],
                            [
                                18.87281,
                                59.79048
                            ],
                            [
                                18.94582,
                                59.86081
                            ],
                            [
                                18.9476,
                                59.91524
                            ],
                            [
                                18.81898,
                                60.09565
                            ],
                            [
                                18.44392,
                                60.17763
                            ],
                            [
                                18.61562,
                                60.23181
                            ],
                            [
                                18.4561,
                                60.33703
                            ],
                            [
                                18.24637,
                                60.35885
                            ],
                            [
                                18.01598,
                                60.5029
                            ],
                            [
                                17.98677,
                                60.60182
                            ],
                            [
                                17.77732,
                                60.5684
                            ],
                            [
                                17.67355,
                                60.50836
                            ],
                            [
                                17.59214,
                                60.58137
                            ],
                            [
                                17.61222,
                                60.64453
                            ],
                            [
                                17.43274,
                                60.63684
                            ],
                            [
                                17.2226,
                                60.68749
                            ],
                            [
                                17.35063,
                                60.75326
                            ],
                            [
                                17.26016,
                                60.8789
                            ],
                            [
                                17.13947,
                                60.95449
                            ],
                            [
                                17.24527,
                                61.00783
                            ],
                            [
                                17.15745,
                                61.14762
                            ],
                            [
                                17.25266,
                                61.30351
                            ],
                            [
                                17.12402,
                                61.36378
                            ],
                            [
                                17.08653,
                                61.41367
                            ],
                            [
                                17.15167,
                                61.51692
                            ],
                            [
                                17.06202,
                                61.54785
                            ],
                            [
                                17.1574,
                                61.61138
                            ],
                            [
                                17.19077,
                                61.70011
                            ],
                            [
                                17.35099,
                                61.70278
                            ],
                            [
                                17.44148,
                                61.62272
                            ],
                            [
                                17.50158,
                                61.7154
                            ],
                            [
                                17.37865,
                                61.73893
                            ],
                            [
                                17.39659,
                                61.8172
                            ],
                            [
                                17.33862,
                                61.90787
                            ],
                            [
                                17.46515,
                                62.04298
                            ],
                            [
                                17.47426,
                                62.12347
                            ],
                            [
                                17.65654,
                                62.23351
                            ],
                            [
                                17.45937,
                                62.26563
                            ],
                            [
                                17.37181,
                                62.31933
                            ],
                            [
                                17.386,
                                62.44323
                            ],
                            [
                                17.33398,
                                62.48379
                            ],
                            [
                                17.4235,
                                62.50277
                            ],
                            [
                                17.63648,
                                62.43107
                            ],
                            [
                                17.72356,
                                62.50716
                            ],
                            [
                                17.88323,
                                62.51409
                            ],
                            [
                                17.96851,
                                62.74516
                            ],
                            [
                                17.88799,
                                62.83311
                            ],
                            [
                                18.02278,
                                62.85252
                            ],
                            [
                                18.07256,
                                62.78442
                            ],
                            [
                                18.22307,
                                62.79849
                            ],
                            [
                                18.45128,
                                62.87575
                            ],
                            [
                                18.50751,
                                62.9299
                            ],
                            [
                                18.3891,
                                62.95897
                            ],
                            [
                                18.58793,
                                63.17355
                            ],
                            [
                                18.73293,
                                63.18196
                            ],
                            [
                                18.89586,
                                63.23108
                            ],
                            [
                                19.01204,
                                63.18883
                            ],
                            [
                                19.12089,
                                63.25731
                            ],
                            [
                                19.13286,
                                63.30533
                            ],
                            [
                                19.25064,
                                63.33275
                            ],
                            [
                                19.26188,
                                63.45406
                            ],
                            [
                                19.41605,
                                63.46231
                            ],
                            [
                                19.4521,
                                63.5717
                            ],
                            [
                                19.5803,
                                63.52524
                            ],
                            [
                                19.66269,
                                63.43322
                            ],
                            [
                                19.76303,
                                63.466
                            ],
                            [
                                19.72753,
                                63.51115
                            ],
                            [
                                20.00255,
                                63.66029
                            ],
                            [
                                20.30263,
                                63.65693
                            ],
                            [
                                20.4208,
                                63.69683
                            ],
                            [
                                20.439,
                                63.75769
                            ],
                            [
                                20.77235,
                                63.87517
                            ],
                            [
                                20.95699,
                                64.08018
                            ],
                            [
                                20.96434,
                                64.14297
                            ],
                            [
                                21.24812,
                                64.29358
                            ],
                            [
                                21.33759,
                                64.29576
                            ],
                            [
                                21.51041,
                                64.41045
                            ],
                            [
                                21.43463,
                                64.55857
                            ],
                            [
                                21.36723,
                                64.60316
                            ],
                            [
                                21.2455,
                                64.60699
                            ],
                            [
                                21.28663,
                                64.68448
                            ],
                            [
                                21.1318,
                                64.77636
                            ],
                            [
                                21.16281,
                                64.8621
                            ],
                            [
                                21.25027,
                                64.92224
                            ],
                            [
                                21.4626,
                                65.01761
                            ],
                            [
                                21.58607,
                                65.15277
                            ],
                            [
                                21.5368,
                                65.23216
                            ],
                            [
                                21.67531,
                                65.28784
                            ],
                            [
                                21.47387,
                                65.35966
                            ],
                            [
                                21.58516,
                                65.42109
                            ],
                            [
                                21.79389,
                                65.39902
                            ],
                            [
                                21.98846,
                                65.41425
                            ],
                            [
                                21.99735,
                                65.51372
                            ],
                            [
                                22.37276,
                                65.57802
                            ],
                            [
                                22.31474,
                                65.76847
                            ],
                            [
                                22.34365,
                                65.83321
                            ],
                            [
                                22.71124,
                                65.7885
                            ],
                            [
                                22.82757,
                                65.80801
                            ],
                            [
                                23.00841,
                                65.7518
                            ],
                            [
                                23.23052,
                                65.77113
                            ],
                            [
                                23.2508,
                                65.80564
                            ],
                            [
                                24.01066,
                                65.7958
                            ],
                            [
                                24.15513,
                                65.81603
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                18.78365,
                                57.84635
                            ],
                            [
                                18.69753,
                                57.92101
                            ],
                            [
                                18.56162,
                                57.84468
                            ],
                            [
                                18.46059,
                                57.81897
                            ],
                            [
                                18.33088,
                                57.67036
                            ],
                            [
                                18.10708,
                                57.53378
                            ],
                            [
                                18.11885,
                                57.44195
                            ],
                            [
                                18.18799,
                                57.38523
                            ],
                            [
                                18.16971,
                                57.3223
                            ],
                            [
                                18.10337,
                                57.28825
                            ],
                            [
                                18.14979,
                                57.16617
                            ],
                            [
                                18.21619,
                                57.09907
                            ],
                            [
                                18.21689,
                                57.02913
                            ],
                            [
                                18.12586,
                                56.91807
                            ],
                            [
                                18.2918,
                                56.93137
                            ],
                            [
                                18.38697,
                                56.99396
                            ],
                            [
                                18.34023,
                                57.06843
                            ],
                            [
                                18.40024,
                                57.13841
                            ],
                            [
                                18.70936,
                                57.24457
                            ],
                            [
                                18.66227,
                                57.29315
                            ],
                            [
                                18.75484,
                                57.36278
                            ],
                            [
                                18.91793,
                                57.40475
                            ],
                            [
                                18.76302,
                                57.4705
                            ],
                            [
                                18.81354,
                                57.55911
                            ],
                            [
                                18.76494,
                                57.61832
                            ],
                            [
                                18.83686,
                                57.73077
                            ],
                            [
                                18.89751,
                                57.7172
                            ],
                            [
                                19.0348,
                                57.76778
                            ],
                            [
                                19.02493,
                                57.90818
                            ],
                            [
                                18.84598,
                                57.91987
                            ],
                            [
                                18.78365,
                                57.84635
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                17.10066,
                                57.33602
                            ],
                            [
                                16.96066,
                                57.28922
                            ],
                            [
                                16.95807,
                                57.23183
                            ],
                            [
                                16.88383,
                                57.09748
                            ],
                            [
                                16.73363,
                                56.93044
                            ],
                            [
                                16.63292,
                                56.87565
                            ],
                            [
                                16.51601,
                                56.74474
                            ],
                            [
                                16.45915,
                                56.63519
                            ],
                            [
                                16.37107,
                                56.52749
                            ],
                            [
                                16.40651,
                                56.41144
                            ],
                            [
                                16.39218,
                                56.27083
                            ],
                            [
                                16.47894,
                                56.2376
                            ],
                            [
                                16.56749,
                                56.36996
                            ],
                            [
                                16.65095,
                                56.56289
                            ],
                            [
                                16.68436,
                                56.57694
                            ],
                            [
                                16.77387,
                                56.78265
                            ],
                            [
                                16.86272,
                                56.84313
                            ],
                            [
                                16.97579,
                                57.08318
                            ],
                            [
                                17.07054,
                                57.17911
                            ],
                            [
                                17.05913,
                                57.27765
                            ],
                            [
                                17.10066,
                                57.33602
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                11.70256,
                                58.30225
                            ],
                            [
                                11.6206,
                                58.24835
                            ],
                            [
                                11.49854,
                                58.20251
                            ],
                            [
                                11.41047,
                                58.14369
                            ],
                            [
                                11.54942,
                                58.08913
                            ],
                            [
                                11.62251,
                                58.13156
                            ],
                            [
                                11.73844,
                                58.11196
                            ],
                            [
                                11.84627,
                                58.15943
                            ],
                            [
                                11.83742,
                                58.23638
                            ],
                            [
                                11.70256,
                                58.30225
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                11.68952,
                                58.06623
                            ],
                            [
                                11.51196,
                                58.05163
                            ],
                            [
                                11.53683,
                                57.96125
                            ],
                            [
                                11.6663,
                                57.96359
                            ],
                            [
                                11.68952,
                                58.06623
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                17.3802,
                                62.47952
                            ],
                            [
                                17.42587,
                                62.35464
                            ],
                            [
                                17.52605,
                                62.36373
                            ],
                            [
                                17.45678,
                                62.46831
                            ],
                            [
                                17.3802,
                                62.47952
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                18.67942,
                                59.56136
                            ],
                            [
                                18.51409,
                                59.49138
                            ],
                            [
                                18.60628,
                                59.46148
                            ],
                            [
                                18.67942,
                                59.56136
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "CHE",
                "Country": "Switzerland",
                "Total_3GHG": 0.11,
                "Total_3GHG_timeseries": [
                    2.0151e-06,
                    4.0225e-06,
                    6.092e-06,
                    8.0538e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018
                ],
                "Fossil_3GHG": 0.14,
                "Fossil_3GHG_timeseries": [
                    1.3215e-07,
                    2.6465e-07,
                    3.972e-07,
                    5.3148e-07,
                    6.6737e-07,
                    8.0483e-07,
                    9.4351e-07,
                    1.1495e-06,
                    1.3829e-06,
                    1.6617e-06,
                    1.996e-06,
                    2.3509e-06,
                    2.7061e-06,
                    3.1082e-06,
                    3.5669e-06,
                    4.0222e-06,
                    4.4708e-06,
                    4.9627e-06,
                    5.4432e-06,
                    5.9937e-06,
                    6.6406e-06,
                    7.3636e-06,
                    8.072e-06,
                    8.7488e-06,
                    9.476e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015
                ],
                "Land_3GHG": 0.05,
                "Land_3GHG_timeseries": [
                    1.8829e-06,
                    3.7579e-06,
                    5.6948e-06,
                    7.5223e-06,
                    9.4471e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Total_CO2": 0.13,
                "Total_CO2_timeseries": [
                    1.1686e-06,
                    2.3329e-06,
                    3.563e-06,
                    4.6875e-06,
                    5.9132e-06,
                    7.0606e-06,
                    8.1075e-06,
                    9.2158e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014
                ],
                "Fossil_CO2": 0.18,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    6.6e-08,
                    1.584e-07,
                    2.9535e-07,
                    4.8675e-07,
                    6.9795e-07,
                    9.0915e-07,
                    1.1666e-06,
                    1.48e-06,
                    1.7902e-06,
                    2.0938e-06,
                    2.4403e-06,
                    2.7753e-06,
                    3.1795e-06,
                    3.6795e-06,
                    4.2537e-06,
                    4.8114e-06,
                    5.3377e-06,
                    5.9136e-06,
                    6.5868e-06,
                    7.2254e-06,
                    7.8359e-06,
                    8.4876e-06,
                    9.24e-06,
                    9.9445e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014
                ],
                "Land_CO2": 0.01,
                "Land_CO2_timeseries": [
                    1.1686e-06,
                    2.3329e-06,
                    3.563e-06,
                    4.6875e-06,
                    5.9132e-06,
                    7.0606e-06,
                    8.1075e-06,
                    9.1498e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_CH4": 0.06,
                "Total_CH4_timeseries": [
                    7.3444e-07,
                    1.4637e-06,
                    2.1875e-06,
                    2.9075e-06,
                    3.6236e-06,
                    4.3358e-06,
                    5.0438e-06,
                    5.7477e-06,
                    6.4472e-06,
                    7.1422e-06,
                    7.8379e-06,
                    8.5337e-06,
                    9.2296e-06,
                    9.9256e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_CH4": 0.03,
                "Fossil_CH4_timeseries": [
                    7.7962e-08,
                    1.5562e-07,
                    2.3268e-07,
                    3.1083e-07,
                    3.8998e-07,
                    4.701e-07,
                    5.5089e-07,
                    6.3247e-07,
                    7.145e-07,
                    7.9698e-07,
                    8.8004e-07,
                    9.6337e-07,
                    1.0467e-06,
                    1.1303e-06,
                    1.2139e-06,
                    1.297e-06,
                    1.3796e-06,
                    1.4622e-06,
                    1.5444e-06,
                    1.6269e-06,
                    1.7096e-06,
                    1.793e-06,
                    1.877e-06,
                    1.9594e-06,
                    2.0411e-06,
                    2.1216e-06,
                    2.2002e-06,
                    2.2766e-06,
                    2.3517e-06,
                    2.4258e-06,
                    2.497e-06,
                    2.5655e-06,
                    2.6318e-06,
                    2.6953e-06,
                    2.7561e-06,
                    2.8143e-06,
                    2.8705e-06,
                    2.9237e-06,
                    2.9747e-06,
                    3.0232e-06,
                    3.0684e-06,
                    3.1145e-06,
                    3.1603e-06,
                    3.2097e-06,
                    3.2607e-06,
                    3.3139e-06,
                    3.3699e-06,
                    3.429e-06,
                    3.4909e-06,
                    3.5555e-06,
                    3.6214e-06,
                    3.6904e-06,
                    3.7634e-06,
                    3.8404e-06,
                    3.9124e-06,
                    3.9984e-06,
                    4.0906e-06,
                    4.1859e-06,
                    4.2843e-06,
                    4.3846e-06,
                    4.4855e-06,
                    4.5833e-06,
                    4.6799e-06,
                    4.7677e-06,
                    4.8432e-06,
                    4.9111e-06,
                    4.9698e-06,
                    5.0197e-06,
                    5.0589e-06,
                    5.0978e-06,
                    5.1267e-06,
                    5.1531e-06,
                    5.1771e-06,
                    5.1959e-06,
                    5.2193e-06,
                    5.2288e-06,
                    5.2372e-06,
                    5.2446e-06,
                    5.2545e-06,
                    5.2615e-06,
                    5.2696e-06,
                    5.2787e-06,
                    5.2861e-06,
                    5.2969e-06,
                    5.3143e-06,
                    5.3336e-06,
                    5.3582e-06,
                    5.3856e-06,
                    5.4228e-06,
                    5.4428e-06,
                    5.5e-06,
                    5.5935e-06,
                    5.7265e-06,
                    5.8979e-06,
                    6.1188e-06,
                    6.4234e-06,
                    6.8107e-06,
                    7.276e-06,
                    7.8099e-06,
                    8.4353e-06,
                    9.1563e-06,
                    9.963e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CH4": 0.12,
                "Land_CH4_timeseries": [
                    6.5648e-07,
                    1.3081e-06,
                    1.9548e-06,
                    2.5966e-06,
                    3.2336e-06,
                    3.8657e-06,
                    4.4929e-06,
                    5.1152e-06,
                    5.7327e-06,
                    6.3453e-06,
                    6.9578e-06,
                    7.5703e-06,
                    8.1828e-06,
                    8.7953e-06,
                    9.4078e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Total_N2O": 0.13,
                "Total_N2O_timeseries": [
                    1.1205e-07,
                    2.2591e-07,
                    3.4152e-07,
                    4.5881e-07,
                    5.7766e-07,
                    6.9795e-07,
                    8.1953e-07,
                    9.4221e-07,
                    1.0658e-06,
                    1.1901e-06,
                    1.3149e-06,
                    1.4403e-06,
                    1.5661e-06,
                    1.6924e-06,
                    1.8192e-06,
                    1.9465e-06,
                    2.0742e-06,
                    2.2024e-06,
                    2.3311e-06,
                    2.4604e-06,
                    2.5915e-06,
                    2.7263e-06,
                    2.8664e-06,
                    3.013e-06,
                    3.1666e-06,
                    3.3274e-06,
                    3.495e-06,
                    3.6687e-06,
                    3.8473e-06,
                    4.0289e-06,
                    4.2124e-06,
                    4.3976e-06,
                    4.5844e-06,
                    4.7724e-06,
                    4.9617e-06,
                    5.1522e-06,
                    5.3439e-06,
                    5.5368e-06,
                    5.731e-06,
                    5.9146e-06,
                    6.1132e-06,
                    6.3259e-06,
                    6.5519e-06,
                    6.79e-06,
                    7.039e-06,
                    7.2975e-06,
                    7.564e-06,
                    7.8368e-06,
                    8.1141e-06,
                    8.3939e-06,
                    8.6745e-06,
                    8.954e-06,
                    9.2314e-06,
                    9.5058e-06,
                    9.7769e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_N2O": 0.16,
                "Fossil_N2O_timeseries": [
                    5.4187e-08,
                    1.0903e-07,
                    1.6452e-07,
                    2.2065e-07,
                    2.7739e-07,
                    3.3473e-07,
                    3.9263e-07,
                    4.5106e-07,
                    5.1e-07,
                    5.6941e-07,
                    6.2925e-07,
                    6.8953e-07,
                    7.5024e-07,
                    8.1137e-07,
                    8.7293e-07,
                    9.3492e-07,
                    9.9733e-07,
                    1.0602e-06,
                    1.1235e-06,
                    1.1872e-06,
                    1.2515e-06,
                    1.3169e-06,
                    1.3835e-06,
                    1.4516e-06,
                    1.5212e-06,
                    1.5925e-06,
                    1.6652e-06,
                    1.7393e-06,
                    1.8147e-06,
                    1.8909e-06,
                    1.9677e-06,
                    2.0452e-06,
                    2.1233e-06,
                    2.202e-06,
                    2.2812e-06,
                    2.361e-06,
                    2.4414e-06,
                    2.5223e-06,
                    2.6038e-06,
                    2.688e-06,
                    2.7733e-06,
                    2.8598e-06,
                    2.9476e-06,
                    3.0366e-06,
                    3.127e-06,
                    3.2187e-06,
                    3.3119e-06,
                    3.4065e-06,
                    3.5026e-06,
                    3.6003e-06,
                    3.6996e-06,
                    3.8008e-06,
                    3.9041e-06,
                    4.0094e-06,
                    4.1168e-06,
                    4.2263e-06,
                    4.3379e-06,
                    4.4515e-06,
                    4.5668e-06,
                    4.6837e-06,
                    4.8021e-06,
                    4.9217e-06,
                    5.0425e-06,
                    5.1645e-06,
                    5.2877e-06,
                    5.412e-06,
                    5.5375e-06,
                    5.6641e-06,
                    5.792e-06,
                    5.9213e-06,
                    6.0521e-06,
                    6.1847e-06,
                    6.3192e-06,
                    6.4556e-06,
                    6.5941e-06,
                    6.7345e-06,
                    6.8767e-06,
                    7.0206e-06,
                    7.1658e-06,
                    7.3122e-06,
                    7.4596e-06,
                    7.6087e-06,
                    7.7597e-06,
                    7.9129e-06,
                    8.0685e-06,
                    8.2267e-06,
                    8.3876e-06,
                    8.5509e-06,
                    8.7168e-06,
                    8.8849e-06,
                    9.0552e-06,
                    9.2279e-06,
                    9.4032e-06,
                    9.5812e-06,
                    9.7621e-06,
                    9.9461e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.12,
                "Land_N2O_timeseries": [
                    5.7858e-08,
                    1.1687e-07,
                    1.77e-07,
                    2.3816e-07,
                    3.0027e-07,
                    3.6323e-07,
                    4.269e-07,
                    4.9115e-07,
                    5.558e-07,
                    6.2068e-07,
                    6.8568e-07,
                    7.5075e-07,
                    8.1588e-07,
                    8.8106e-07,
                    9.4628e-07,
                    1.0115e-06,
                    1.0768e-06,
                    1.1422e-06,
                    1.2077e-06,
                    1.2732e-06,
                    1.3399e-06,
                    1.4094e-06,
                    1.4829e-06,
                    1.5614e-06,
                    1.6454e-06,
                    1.7349e-06,
                    1.8298e-06,
                    1.9294e-06,
                    2.0326e-06,
                    2.138e-06,
                    2.2447e-06,
                    2.3524e-06,
                    2.461e-06,
                    2.5704e-06,
                    2.6804e-06,
                    2.7911e-06,
                    2.9025e-06,
                    3.0145e-06,
                    3.1273e-06,
                    3.2266e-06,
                    3.3398e-06,
                    3.4661e-06,
                    3.6043e-06,
                    3.7534e-06,
                    3.912e-06,
                    4.0788e-06,
                    4.2521e-06,
                    4.4303e-06,
                    4.6114e-06,
                    4.7937e-06,
                    4.9748e-06,
                    5.1532e-06,
                    5.3274e-06,
                    5.4965e-06,
                    5.6601e-06,
                    5.8182e-06,
                    5.9713e-06,
                    6.1202e-06,
                    6.2663e-06,
                    6.4114e-06,
                    6.5565e-06,
                    6.702e-06,
                    6.848e-06,
                    6.9946e-06,
                    7.1421e-06,
                    7.2905e-06,
                    7.4399e-06,
                    7.5905e-06,
                    7.7422e-06,
                    7.8952e-06,
                    8.0496e-06,
                    8.206e-06,
                    8.3648e-06,
                    8.5263e-06,
                    8.6907e-06,
                    8.8583e-06,
                    9.029e-06,
                    9.2029e-06,
                    9.3799e-06,
                    9.5598e-06,
                    9.7428e-06,
                    9.9293e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            9.55872,
                            47.54189
                        ],
                        [
                            9.4956,
                            47.55145
                        ],
                        [
                            9.39471,
                            47.62033
                        ],
                        [
                            9.25656,
                            47.65871
                        ],
                        [
                            9.1708,
                            47.65528
                        ],
                        [
                            9.02157,
                            47.68643
                        ],
                        [
                            8.87489,
                            47.65467
                        ],
                        [
                            8.80644,
                            47.73831
                        ],
                        [
                            8.73629,
                            47.71615
                        ],
                        [
                            8.60161,
                            47.80269
                        ],
                        [
                            8.48754,
                            47.77217
                        ],
                        [
                            8.40641,
                            47.67548
                        ],
                        [
                            8.46507,
                            47.64542
                        ],
                        [
                            8.46412,
                            47.57221
                        ],
                        [
                            8.32519,
                            47.57251
                        ],
                        [
                            8.19753,
                            47.61857
                        ],
                        [
                            8.01956,
                            47.55059
                        ],
                        [
                            7.91659,
                            47.54827
                        ],
                        [
                            7.89411,
                            47.58637
                        ],
                        [
                            7.69704,
                            47.53316
                        ],
                        [
                            7.67303,
                            47.59212
                        ],
                        [
                            7.58904,
                            47.58988
                        ],
                        [
                            7.50789,
                            47.54476
                        ],
                        [
                            7.50996,
                            47.49683
                        ],
                        [
                            7.38089,
                            47.43189
                        ],
                        [
                            7.17042,
                            47.44345
                        ],
                        [
                            7.19119,
                            47.48768
                        ],
                        [
                            6.98291,
                            47.49427
                        ],
                        [
                            6.92108,
                            47.35564
                        ],
                        [
                            7.01234,
                            47.37279
                        ],
                        [
                            7.04618,
                            47.32728
                        ],
                        [
                            6.94714,
                            47.29089
                        ],
                        [
                            6.95514,
                            47.24317
                        ],
                        [
                            6.70426,
                            47.08194
                        ],
                        [
                            6.64216,
                            47.0048
                        ],
                        [
                            6.43275,
                            46.92846
                        ],
                        [
                            6.46393,
                            46.89098
                        ],
                        [
                            6.43463,
                            46.80204
                        ],
                        [
                            6.35242,
                            46.71514
                        ],
                        [
                            6.11096,
                            46.57666
                        ],
                        [
                            6.15646,
                            46.54526
                        ],
                        [
                            6.07358,
                            46.46527
                        ],
                        [
                            6.09682,
                            46.40875
                        ],
                        [
                            6.17014,
                            46.36644
                        ],
                        [
                            6.03372,
                            46.23843
                        ],
                        [
                            5.96514,
                            46.1452
                        ],
                        [
                            6.12662,
                            46.14047
                        ],
                        [
                            6.29446,
                            46.22493
                        ],
                        [
                            6.21955,
                            46.31188
                        ],
                        [
                            6.33519,
                            46.40372
                        ],
                        [
                            6.5191,
                            46.45637
                        ],
                        [
                            6.68186,
                            46.45433
                        ],
                        [
                            6.82106,
                            46.42715
                        ],
                        [
                            6.77076,
                            46.35474
                        ],
                        [
                            6.86418,
                            46.28032
                        ],
                        [
                            6.80356,
                            46.20314
                        ],
                        [
                            6.79827,
                            46.13709
                        ],
                        [
                            6.94974,
                            46.05173
                        ],
                        [
                            7.04489,
                            45.92241
                        ],
                        [
                            7.1181,
                            45.85976
                        ],
                        [
                            7.29444,
                            45.92178
                        ],
                        [
                            7.38248,
                            45.89697
                        ],
                        [
                            7.49882,
                            45.96169
                        ],
                        [
                            7.66506,
                            45.97521
                        ],
                        [
                            7.7351,
                            45.92399
                        ],
                        [
                            7.86408,
                            45.91675
                        ],
                        [
                            7.90868,
                            45.99694
                        ],
                        [
                            7.98909,
                            45.99593
                        ],
                        [
                            8.03476,
                            46.10084
                        ],
                        [
                            8.10823,
                            46.11163
                        ],
                        [
                            8.16455,
                            46.1829
                        ],
                        [
                            8.0813,
                            46.26028
                        ],
                        [
                            8.21145,
                            46.30958
                        ],
                        [
                            8.31874,
                            46.38613
                        ],
                        [
                            8.36365,
                            46.45046
                        ],
                        [
                            8.4658,
                            46.44263
                        ],
                        [
                            8.46396,
                            46.33301
                        ],
                        [
                            8.42774,
                            46.2983
                        ],
                        [
                            8.46868,
                            46.23289
                        ],
                        [
                            8.53682,
                            46.2037
                        ],
                        [
                            8.61379,
                            46.12173
                        ],
                        [
                            8.71394,
                            46.09727
                        ],
                        [
                            8.80791,
                            46.1004
                        ],
                        [
                            8.85459,
                            46.06159
                        ],
                        [
                            8.79309,
                            46.00811
                        ],
                        [
                            8.92484,
                            45.9037
                        ],
                        [
                            8.93141,
                            45.8598
                        ],
                        [
                            9.0318,
                            45.82514
                        ],
                        [
                            9.07645,
                            45.91076
                        ],
                        [
                            9.02204,
                            45.93809
                        ],
                        [
                            9.01782,
                            46.04977
                        ],
                        [
                            9.07252,
                            46.1181
                        ],
                        [
                            9.18352,
                            46.17053
                        ],
                        [
                            9.30014,
                            46.32646
                        ],
                        [
                            9.27453,
                            46.41885
                        ],
                        [
                            9.28274,
                            46.49669
                        ],
                        [
                            9.46504,
                            46.46945
                        ],
                        [
                            9.46786,
                            46.38953
                        ],
                        [
                            9.5345,
                            46.31172
                        ],
                        [
                            9.71415,
                            46.29271
                        ],
                        [
                            9.77027,
                            46.33599
                        ],
                        [
                            9.90783,
                            46.38051
                        ],
                        [
                            9.9955,
                            46.34261
                        ],
                        [
                            10.04462,
                            46.23054
                        ],
                        [
                            10.1232,
                            46.22424
                        ],
                        [
                            10.17652,
                            46.25828
                        ],
                        [
                            10.10508,
                            46.33331
                        ],
                        [
                            10.16553,
                            46.40885
                        ],
                        [
                            10.04264,
                            46.45298
                        ],
                        [
                            10.05214,
                            46.53202
                        ],
                        [
                            10.12934,
                            46.60586
                        ],
                        [
                            10.25795,
                            46.61043
                        ],
                        [
                            10.29707,
                            46.54972
                        ],
                        [
                            10.47159,
                            46.54399
                        ],
                        [
                            10.48582,
                            46.61668
                        ],
                        [
                            10.40321,
                            46.63669
                        ],
                        [
                            10.39374,
                            46.69015
                        ],
                        [
                            10.46965,
                            46.85491
                        ],
                        [
                            10.48935,
                            46.93779
                        ],
                        [
                            10.34898,
                            46.99061
                        ],
                        [
                            10.29361,
                            46.92181
                        ],
                        [
                            10.15781,
                            46.84857
                        ],
                        [
                            9.97789,
                            46.91589
                        ],
                        [
                            9.87615,
                            46.93464
                        ],
                        [
                            9.89167,
                            46.98948
                        ],
                        [
                            9.78334,
                            47.03846
                        ],
                        [
                            9.60708,
                            47.06077
                        ],
                        [
                            9.52005,
                            47.10343
                        ],
                        [
                            9.4862,
                            47.17833
                        ],
                        [
                            9.53075,
                            47.27058
                        ],
                        [
                            9.62448,
                            47.36614
                        ],
                        [
                            9.64434,
                            47.43516
                        ],
                        [
                            9.5658,
                            47.49237
                        ],
                        [
                            9.55872,
                            47.54189
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "SYR",
                "Country": "Syria",
                "Total_3GHG": 0.12,
                "Total_3GHG_timeseries": [
                    9.9073e-07,
                    1.9845e-06,
                    2.9809e-06,
                    3.9798e-06,
                    4.9806e-06,
                    5.9831e-06,
                    6.9872e-06,
                    7.9929e-06,
                    9.0003e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.002,
                    0.002,
                    0.002,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019
                ],
                "Fossil_3GHG": 0.14,
                "Fossil_3GHG_timeseries": [
                    2.0162e-07,
                    4.0338e-07,
                    6.0529e-07,
                    8.0733e-07,
                    1.0095e-06,
                    1.2118e-06,
                    1.4142e-06,
                    1.6167e-06,
                    1.8193e-06,
                    2.022e-06,
                    2.2247e-06,
                    2.4275e-06,
                    2.6303e-06,
                    2.8331e-06,
                    3.0359e-06,
                    3.2388e-06,
                    3.4417e-06,
                    3.6446e-06,
                    3.8475e-06,
                    4.0504e-06,
                    4.2723e-06,
                    4.5133e-06,
                    4.7733e-06,
                    5.0523e-06,
                    5.3503e-06,
                    5.6671e-06,
                    6.0029e-06,
                    6.3574e-06,
                    6.7305e-06,
                    7.1223e-06,
                    7.5322e-06,
                    7.9603e-06,
                    8.4064e-06,
                    8.8705e-06,
                    9.3525e-06,
                    9.8525e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    9.2153e-06,
                    8.3412e-06,
                    7.4262e-06,
                    6.5179e-06,
                    5.6163e-06,
                    4.7214e-06,
                    3.8334e-06,
                    2.9521e-06,
                    2.0777e-06,
                    1.2102e-06,
                    3.4966e-07,
                    -0.00000050398,
                    -0.0000013507,
                    -0.0000021424,
                    -0.0000028815,
                    -0.0000035738,
                    -0.0000042265,
                    -0.0000048408,
                    -0.0000054161,
                    -0.0000059487,
                    -0.0000064581,
                    -0.0000069505,
                    -0.0000073855,
                    -0.000007752,
                    -0.0000080351,
                    -0.0000082575,
                    -0.0000084194,
                    -0.0000084983,
                    -0.0000084921,
                    -0.0000084006,
                    -0.0000082252,
                    -0.0000079643,
                    -0.0000071304,
                    -0.0000062783,
                    -0.0000052687,
                    -0.0000041613,
                    -0.0000028888,
                    1.197e-08,
                    3.5513e-06,
                    7.2173e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0015,
                    0.0015,
                    0.0015
                ],
                "Land_3GHG": 0.07,
                "Land_3GHG_timeseries": [
                    7.8911e-07,
                    1.5811e-06,
                    2.3756e-06,
                    3.1724e-06,
                    3.9711e-06,
                    4.7713e-06,
                    5.573e-06,
                    6.3762e-06,
                    7.181e-06,
                    7.9876e-06,
                    8.7962e-06,
                    9.6068e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Total_CO2": 0.09,
                "Total_CO2_timeseries": [
                    6.7726e-07,
                    1.3566e-06,
                    2.0377e-06,
                    2.7202e-06,
                    3.4039e-06,
                    4.0885e-06,
                    4.774e-06,
                    5.4604e-06,
                    6.1479e-06,
                    6.8369e-06,
                    7.5276e-06,
                    8.2199e-06,
                    8.9135e-06,
                    9.6083e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001
                ],
                "Fossil_CO2": 0.11,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.6365e-09,
                    6.5464e-09,
                    1.3093e-08,
                    1.8003e-08,
                    2.4549e-08,
                    3.7642e-08,
                    6.5465e-08,
                    9.3287e-08,
                    1.1947e-07,
                    1.2929e-07,
                    1.3911e-07,
                    1.6366e-07,
                    1.8003e-07,
                    1.8821e-07,
                    1.9639e-07,
                    2.0621e-07,
                    2.1767e-07,
                    2.2913e-07,
                    2.4222e-07,
                    4.2855e-07,
                    6.0003e-07,
                    8.1425e-07,
                    1.0448e-06,
                    1.3051e-06,
                    2.0455e-06,
                    2.9474e-06,
                    3.8395e-06,
                    4.8156e-06,
                    5.818e-06,
                    7.2674e-06,
                    8.6459e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009
                ],
                "Land_CO2": 0.04,
                "Land_CO2_timeseries": [
                    6.7726e-07,
                    1.3566e-06,
                    2.0377e-06,
                    2.7202e-06,
                    3.4039e-06,
                    4.0885e-06,
                    4.774e-06,
                    5.4604e-06,
                    6.1479e-06,
                    6.8369e-06,
                    7.5276e-06,
                    8.2199e-06,
                    8.9135e-06,
                    9.6083e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_CH4": 0.18,
                "Total_CH4_timeseries": [
                    2.7996e-07,
                    5.6026e-07,
                    8.409e-07,
                    1.1219e-06,
                    1.4032e-06,
                    1.6848e-06,
                    1.9667e-06,
                    2.2489e-06,
                    2.5315e-06,
                    2.8144e-06,
                    3.0975e-06,
                    3.3809e-06,
                    3.6646e-06,
                    3.9486e-06,
                    4.2328e-06,
                    4.5172e-06,
                    4.802e-06,
                    5.0869e-06,
                    5.3722e-06,
                    5.6576e-06,
                    5.9695e-06,
                    6.3079e-06,
                    6.6725e-06,
                    7.0635e-06,
                    7.4807e-06,
                    7.9241e-06,
                    8.3936e-06,
                    8.8892e-06,
                    9.4108e-06,
                    9.9584e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    9.9971e-06,
                    9.116e-06,
                    8.2416e-06,
                    7.3738e-06,
                    6.5127e-06,
                    5.6582e-06,
                    4.9076e-06,
                    4.256e-06,
                    3.6985e-06,
                    3.2304e-06,
                    2.8468e-06,
                    2.5531e-06,
                    2.3454e-06,
                    2.2201e-06,
                    2.1733e-06,
                    2.2618e-06,
                    2.4579e-06,
                    2.762e-06,
                    3.1743e-06,
                    3.6948e-06,
                    4.3385e-06,
                    5.1064e-06,
                    5.9996e-06,
                    7.0192e-06,
                    8.1663e-06,
                    9.7583e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0011,
                    0.0011,
                    0.001,
                    0.001,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0008,
                    0.0008,
                    0.0008
                ],
                "Fossil_CH4": 0.23,
                "Fossil_CH4_timeseries": [
                    1.9552e-07,
                    3.911e-07,
                    5.8674e-07,
                    7.8244e-07,
                    9.782e-07,
                    1.174e-06,
                    1.3699e-06,
                    1.5658e-06,
                    1.7617e-06,
                    1.9577e-06,
                    2.1536e-06,
                    2.3496e-06,
                    2.5456e-06,
                    2.7415e-06,
                    2.9374e-06,
                    3.1333e-06,
                    3.3292e-06,
                    3.525e-06,
                    3.7208e-06,
                    3.9166e-06,
                    4.1313e-06,
                    4.3649e-06,
                    4.6174e-06,
                    4.8887e-06,
                    5.1787e-06,
                    5.4873e-06,
                    5.8146e-06,
                    6.1604e-06,
                    6.5248e-06,
                    6.9076e-06,
                    7.3085e-06,
                    7.7274e-06,
                    8.1644e-06,
                    8.6192e-06,
                    9.092e-06,
                    9.5825e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    9.4376e-06,
                    8.5918e-06,
                    7.7044e-06,
                    6.776e-06,
                    5.8542e-06,
                    4.9389e-06,
                    4.0302e-06,
                    3.1282e-06,
                    2.2329e-06,
                    1.3443e-06,
                    4.6239e-07,
                    -0.00000041271,
                    -0.000001281,
                    -0.0000021425,
                    -0.0000029513,
                    -0.0000037124,
                    -0.0000044307,
                    -0.0000051109,
                    -0.0000057577,
                    -0.0000063759,
                    -0.0000069701,
                    -0.0000075448,
                    -0.0000081045,
                    -0.0000085937,
                    -0.0000090177,
                    -0.0000093767,
                    -0.0000096711,
                    -0.0000099012,
                    0,
                    0,
                    0,
                    0,
                    -0.0000098587,
                    -0.000009291,
                    -0.0000086914,
                    -0.0000079781,
                    -0.0000071843,
                    -0.000006256,
                    -0.0000041804,
                    -0.0000016287,
                    1.0584e-06,
                    4.0759e-06,
                    7.298e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.001,
                    0.001,
                    0.001,
                    0.0009,
                    0.0009,
                    0.0008,
                    0.0008,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0006,
                    0.0006
                ],
                "Land_CH4": 0.11,
                "Land_CH4_timeseries": [
                    8.4447e-08,
                    1.6917e-07,
                    2.5416e-07,
                    3.3942e-07,
                    4.2495e-07,
                    5.1076e-07,
                    5.9683e-07,
                    6.8318e-07,
                    7.698e-07,
                    8.5669e-07,
                    9.4386e-07,
                    1.0313e-06,
                    1.119e-06,
                    1.2071e-06,
                    1.2954e-06,
                    1.3839e-06,
                    1.4728e-06,
                    1.5619e-06,
                    1.6513e-06,
                    1.741e-06,
                    1.8382e-06,
                    1.9429e-06,
                    2.0551e-06,
                    2.1749e-06,
                    2.3021e-06,
                    2.4368e-06,
                    2.579e-06,
                    2.7288e-06,
                    2.886e-06,
                    3.0508e-06,
                    3.223e-06,
                    3.4026e-06,
                    3.5897e-06,
                    3.7842e-06,
                    3.9861e-06,
                    4.1955e-06,
                    4.4123e-06,
                    4.6366e-06,
                    4.8683e-06,
                    5.1074e-06,
                    5.3358e-06,
                    5.5535e-06,
                    5.7605e-06,
                    5.9568e-06,
                    6.1424e-06,
                    6.3173e-06,
                    6.4815e-06,
                    6.635e-06,
                    6.7778e-06,
                    6.9098e-06,
                    7.0304e-06,
                    7.1395e-06,
                    7.2372e-06,
                    7.3233e-06,
                    7.398e-06,
                    7.4612e-06,
                    7.5129e-06,
                    7.5532e-06,
                    7.5819e-06,
                    7.5992e-06,
                    7.6156e-06,
                    7.6312e-06,
                    7.6458e-06,
                    7.6596e-06,
                    7.6725e-06,
                    7.6845e-06,
                    7.6957e-06,
                    7.706e-06,
                    7.7154e-06,
                    7.7239e-06,
                    7.7322e-06,
                    7.7405e-06,
                    7.7485e-06,
                    7.7564e-06,
                    7.7642e-06,
                    7.7718e-06,
                    7.7792e-06,
                    7.7865e-06,
                    7.7937e-06,
                    7.8006e-06,
                    7.8589e-06,
                    7.9684e-06,
                    8.1292e-06,
                    8.3412e-06,
                    8.6045e-06,
                    8.929e-06,
                    9.3155e-06,
                    9.7648e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Total_N2O": 0.14,
                "Total_N2O_timeseries": [
                    3.3504e-08,
                    6.7638e-08,
                    1.0237e-07,
                    1.3768e-07,
                    1.7351e-07,
                    2.0981e-07,
                    2.4651e-07,
                    2.8355e-07,
                    3.2084e-07,
                    3.5828e-07,
                    3.9581e-07,
                    4.3343e-07,
                    4.7112e-07,
                    5.0887e-07,
                    5.4669e-07,
                    5.8456e-07,
                    6.225e-07,
                    6.6051e-07,
                    6.986e-07,
                    7.368e-07,
                    7.756e-07,
                    8.1585e-07,
                    8.5821e-07,
                    9.0313e-07,
                    9.5089e-07,
                    1.0015e-06,
                    1.0549e-06,
                    1.1107e-06,
                    1.1684e-06,
                    1.2273e-06,
                    1.2869e-06,
                    1.347e-06,
                    1.4076e-06,
                    1.4686e-06,
                    1.5301e-06,
                    1.5919e-06,
                    1.654e-06,
                    1.7166e-06,
                    1.7796e-06,
                    1.8452e-06,
                    1.9109e-06,
                    1.9769e-06,
                    2.0431e-06,
                    2.1096e-06,
                    2.1764e-06,
                    2.2435e-06,
                    2.3109e-06,
                    2.3787e-06,
                    2.4469e-06,
                    2.5155e-06,
                    2.5846e-06,
                    2.6541e-06,
                    2.7243e-06,
                    2.795e-06,
                    2.8665e-06,
                    2.9386e-06,
                    3.0115e-06,
                    3.0851e-06,
                    3.1594e-06,
                    3.2343e-06,
                    3.31e-06,
                    3.3862e-06,
                    3.463e-06,
                    3.5404e-06,
                    3.6184e-06,
                    3.697e-06,
                    3.7764e-06,
                    3.8566e-06,
                    3.9377e-06,
                    4.0199e-06,
                    4.1041e-06,
                    4.1914e-06,
                    4.2832e-06,
                    4.38e-06,
                    4.4825e-06,
                    4.591e-06,
                    4.7056e-06,
                    4.8259e-06,
                    4.9516e-06,
                    5.0819e-06,
                    5.2167e-06,
                    5.3569e-06,
                    5.503e-06,
                    5.6555e-06,
                    5.8148e-06,
                    5.9812e-06,
                    6.1548e-06,
                    6.3358e-06,
                    6.5239e-06,
                    6.7191e-06,
                    6.9236e-06,
                    7.1413e-06,
                    7.3755e-06,
                    7.6281e-06,
                    7.9002e-06,
                    8.192e-06,
                    8.5025e-06,
                    8.8298e-06,
                    9.1711e-06,
                    9.5225e-06,
                    9.8825e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_N2O": 0.16,
                "Fossil_N2O_timeseries": [
                    6.1013e-09,
                    1.2284e-08,
                    1.8545e-08,
                    2.4883e-08,
                    3.1295e-08,
                    3.7777e-08,
                    4.4325e-08,
                    5.0932e-08,
                    5.7595e-08,
                    6.4305e-08,
                    7.106e-08,
                    7.7858e-08,
                    8.4699e-08,
                    9.1581e-08,
                    9.8505e-08,
                    1.0547e-07,
                    1.1248e-07,
                    1.1953e-07,
                    1.2662e-07,
                    1.3376e-07,
                    1.4098e-07,
                    1.4833e-07,
                    1.5587e-07,
                    1.6362e-07,
                    1.7161e-07,
                    1.7983e-07,
                    1.8828e-07,
                    1.9694e-07,
                    2.0576e-07,
                    2.147e-07,
                    2.2373e-07,
                    2.3283e-07,
                    2.4201e-07,
                    2.5125e-07,
                    2.6055e-07,
                    2.6992e-07,
                    2.7935e-07,
                    2.8885e-07,
                    2.9841e-07,
                    3.0807e-07,
                    3.1781e-07,
                    3.2763e-07,
                    3.3754e-07,
                    3.4752e-07,
                    3.576e-07,
                    3.6776e-07,
                    3.7802e-07,
                    3.8837e-07,
                    3.9883e-07,
                    4.0938e-07,
                    4.2005e-07,
                    4.3085e-07,
                    4.4178e-07,
                    4.5286e-07,
                    4.6409e-07,
                    4.7547e-07,
                    4.87e-07,
                    4.9869e-07,
                    5.1053e-07,
                    5.2252e-07,
                    5.3464e-07,
                    5.4691e-07,
                    5.5932e-07,
                    5.7188e-07,
                    5.8457e-07,
                    5.9741e-07,
                    6.1038e-07,
                    6.235e-07,
                    6.3676e-07,
                    6.5016e-07,
                    6.6369e-07,
                    6.7737e-07,
                    6.9119e-07,
                    7.0514e-07,
                    7.1924e-07,
                    7.3348e-07,
                    7.4785e-07,
                    7.6237e-07,
                    7.7702e-07,
                    7.918e-07,
                    8.0726e-07,
                    8.2433e-07,
                    8.4383e-07,
                    8.6636e-07,
                    8.9237e-07,
                    9.2216e-07,
                    9.5584e-07,
                    9.9336e-07,
                    1.0345e-06,
                    1.0789e-06,
                    1.1265e-06,
                    1.178e-06,
                    1.2336e-06,
                    1.2936e-06,
                    1.3579e-06,
                    1.4263e-06,
                    1.4985e-06,
                    1.574e-06,
                    1.6522e-06,
                    1.732e-06,
                    1.8131e-06,
                    1.8952e-06,
                    1.9782e-06,
                    2.0621e-06,
                    2.1469e-06,
                    2.2327e-06,
                    2.3194e-06,
                    2.4074e-06,
                    2.4967e-06,
                    2.5877e-06,
                    2.6837e-06,
                    2.7913e-06,
                    2.9172e-06,
                    3.0676e-06,
                    3.2491e-06,
                    3.4679e-06,
                    3.7302e-06,
                    4.0424e-06,
                    4.4104e-06,
                    4.7086e-06,
                    5.0173e-06,
                    5.3375e-06,
                    5.6769e-06,
                    6.0417e-06,
                    6.4182e-06,
                    6.8133e-06,
                    7.2252e-06,
                    7.6455e-06,
                    8.0869e-06,
                    8.5327e-06,
                    8.9959e-06,
                    9.4652e-06,
                    9.9495e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.13,
                "Land_N2O_timeseries": [
                    2.7403e-08,
                    5.5354e-08,
                    8.383e-08,
                    1.128e-07,
                    1.4222e-07,
                    1.7203e-07,
                    2.0219e-07,
                    2.3262e-07,
                    2.6324e-07,
                    2.9397e-07,
                    3.2475e-07,
                    3.5557e-07,
                    3.8642e-07,
                    4.1729e-07,
                    4.4818e-07,
                    4.7909e-07,
                    5.1002e-07,
                    5.4098e-07,
                    5.7198e-07,
                    6.0304e-07,
                    6.3462e-07,
                    6.6752e-07,
                    7.0234e-07,
                    7.3951e-07,
                    7.7928e-07,
                    8.217e-07,
                    8.6664e-07,
                    9.138e-07,
                    9.6269e-07,
                    1.0126e-06,
                    1.0631e-06,
                    1.1142e-06,
                    1.1656e-06,
                    1.2174e-06,
                    1.2695e-06,
                    1.322e-06,
                    1.3747e-06,
                    1.4277e-06,
                    1.4812e-06,
                    1.5371e-06,
                    1.5931e-06,
                    1.6493e-06,
                    1.7056e-06,
                    1.7621e-06,
                    1.8188e-06,
                    1.8757e-06,
                    1.9329e-06,
                    1.9904e-06,
                    2.0481e-06,
                    2.1061e-06,
                    2.1645e-06,
                    2.2233e-06,
                    2.2825e-06,
                    2.3422e-06,
                    2.4024e-06,
                    2.4632e-06,
                    2.5245e-06,
                    2.5864e-06,
                    2.6488e-06,
                    2.7118e-06,
                    2.7753e-06,
                    2.8393e-06,
                    2.9037e-06,
                    2.9685e-06,
                    3.0338e-06,
                    3.0996e-06,
                    3.166e-06,
                    3.2331e-06,
                    3.3009e-06,
                    3.3698e-06,
                    3.4404e-06,
                    3.5141e-06,
                    3.592e-06,
                    3.6749e-06,
                    3.7633e-06,
                    3.8576e-06,
                    3.9577e-06,
                    4.0636e-06,
                    4.1746e-06,
                    4.2901e-06,
                    4.4095e-06,
                    4.5326e-06,
                    4.6591e-06,
                    4.7891e-06,
                    4.9224e-06,
                    5.059e-06,
                    5.199e-06,
                    5.3424e-06,
                    5.4894e-06,
                    5.6403e-06,
                    5.797e-06,
                    5.9633e-06,
                    6.1418e-06,
                    6.3345e-06,
                    6.5424e-06,
                    6.7657e-06,
                    7.004e-06,
                    7.2558e-06,
                    7.5189e-06,
                    7.7904e-06,
                    8.0694e-06,
                    8.3573e-06,
                    8.6552e-06,
                    8.9636e-06,
                    9.2826e-06,
                    9.6118e-06,
                    9.9503e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            42.35569,
                            37.10804
                        ],
                        [
                            42.35063,
                            37.23148
                        ],
                        [
                            42.2936,
                            37.26981
                        ],
                        [
                            42.17886,
                            37.28859
                        ],
                        [
                            42.05531,
                            37.19228
                        ],
                        [
                            41.84092,
                            37.13022
                        ],
                        [
                            41.54707,
                            37.08521
                        ],
                        [
                            41.21644,
                            37.07267
                        ],
                        [
                            40.93031,
                            37.12954
                        ],
                        [
                            40.77239,
                            37.11822
                        ],
                        [
                            40.51431,
                            37.02373
                        ],
                        [
                            40.44554,
                            37.0143
                        ],
                        [
                            40.22603,
                            36.90137
                        ],
                        [
                            40.00772,
                            36.81473
                        ],
                        [
                            39.81825,
                            36.75377
                        ],
                        [
                            39.22554,
                            36.66564
                        ],
                        [
                            39.04392,
                            36.70799
                        ],
                        [
                            38.91809,
                            36.69518
                        ],
                        [
                            38.72642,
                            36.70358
                        ],
                        [
                            38.54188,
                            36.84354
                        ],
                        [
                            38.3868,
                            36.89813
                        ],
                        [
                            38.17955,
                            36.90519
                        ],
                        [
                            38.02341,
                            36.83065
                        ],
                        [
                            37.77758,
                            36.74828
                        ],
                        [
                            37.70773,
                            36.74762
                        ],
                        [
                            37.53183,
                            36.67763
                        ],
                        [
                            37.37614,
                            36.65568
                        ],
                        [
                            37.12746,
                            36.65962
                        ],
                        [
                            36.98527,
                            36.75856
                        ],
                        [
                            36.70532,
                            36.82886
                        ],
                        [
                            36.66192,
                            36.81363
                        ],
                        [
                            36.58648,
                            36.61979
                        ],
                        [
                            36.54989,
                            36.48743
                        ],
                        [
                            36.58222,
                            36.39839
                        ],
                        [
                            36.68944,
                            36.28633
                        ],
                        [
                            36.68278,
                            36.23349
                        ],
                        [
                            36.53182,
                            36.23526
                        ],
                        [
                            36.39255,
                            36.21284
                        ],
                        [
                            36.3751,
                            36.17564
                        ],
                        [
                            36.37506,
                            35.99906
                        ],
                        [
                            36.22303,
                            35.96112
                        ],
                        [
                            36.18222,
                            35.85482
                        ],
                        [
                            36.12857,
                            35.85145
                        ],
                        [
                            35.91681,
                            35.92852
                        ],
                        [
                            35.82225,
                            35.82651
                        ],
                        [
                            35.84577,
                            35.74906
                        ],
                        [
                            35.76754,
                            35.66607
                        ],
                        [
                            35.77958,
                            35.62524
                        ],
                        [
                            35.73502,
                            35.56169
                        ],
                        [
                            35.89867,
                            35.43703
                        ],
                        [
                            35.92486,
                            35.26843
                        ],
                        [
                            35.95378,
                            35.19727
                        ],
                        [
                            35.88766,
                            35.10544
                        ],
                        [
                            35.8987,
                            35.00594
                        ],
                        [
                            35.86561,
                            34.9067
                        ],
                        [
                            35.93071,
                            34.77401
                        ],
                        [
                            35.97558,
                            34.63341
                        ],
                        [
                            36.12573,
                            34.64
                        ],
                        [
                            36.29023,
                            34.63272
                        ],
                        [
                            36.3229,
                            34.68381
                        ],
                        [
                            36.38683,
                            34.63135
                        ],
                        [
                            36.46526,
                            34.46489
                        ],
                        [
                            36.55061,
                            34.42109
                        ],
                        [
                            36.53363,
                            34.36943
                        ],
                        [
                            36.58866,
                            34.22939
                        ],
                        [
                            36.62134,
                            34.2022
                        ],
                        [
                            36.51602,
                            34.09585
                        ],
                        [
                            36.4955,
                            34.03743
                        ],
                        [
                            36.42921,
                            34.05196
                        ],
                        [
                            36.30681,
                            33.94474
                        ],
                        [
                            36.28717,
                            33.90291
                        ],
                        [
                            36.36246,
                            33.87218
                        ],
                        [
                            36.36424,
                            33.81936
                        ],
                        [
                            36.24927,
                            33.85215
                        ],
                        [
                            36.15689,
                            33.85194
                        ],
                        [
                            36.07033,
                            33.81952
                        ],
                        [
                            36.01323,
                            33.76554
                        ],
                        [
                            35.96892,
                            33.68048
                        ],
                        [
                            35.97782,
                            33.63551
                        ],
                        [
                            36.05463,
                            33.5901
                        ],
                        [
                            36.02854,
                            33.54208
                        ],
                        [
                            35.94561,
                            33.52132
                        ],
                        [
                            35.94421,
                            33.46877
                        ],
                        [
                            35.8276,
                            33.39722
                        ],
                        [
                            35.81543,
                            33.36047
                        ],
                        [
                            35.72744,
                            33.32799
                        ],
                        [
                            35.62444,
                            33.24235
                        ],
                        [
                            35.67968,
                            33.24722
                        ],
                        [
                            35.63038,
                            33.01576
                        ],
                        [
                            35.62471,
                            32.91866
                        ],
                        [
                            35.67163,
                            32.69106
                        ],
                        [
                            35.79977,
                            32.75883
                        ],
                        [
                            35.84133,
                            32.72964
                        ],
                        [
                            35.93191,
                            32.72437
                        ],
                        [
                            35.97547,
                            32.66985
                        ],
                        [
                            36.03536,
                            32.65512
                        ],
                        [
                            36.03576,
                            32.60558
                        ],
                        [
                            36.09146,
                            32.51878
                        ],
                        [
                            36.20683,
                            32.52758
                        ],
                        [
                            36.4088,
                            32.38285
                        ],
                        [
                            36.50432,
                            32.36012
                        ],
                        [
                            36.83407,
                            32.3169
                        ],
                        [
                            36.86975,
                            32.3441
                        ],
                        [
                            37.72802,
                            32.80497
                        ],
                        [
                            38.32315,
                            33.12314
                        ],
                        [
                            38.7925,
                            33.37472
                        ],
                        [
                            39.19727,
                            33.56532
                        ],
                        [
                            39.90536,
                            33.89867
                        ],
                        [
                            40.63698,
                            34.24313
                        ],
                        [
                            41.01231,
                            34.41988
                        ],
                        [
                            41.13945,
                            34.66411
                        ],
                        [
                            41.23433,
                            34.77704
                        ],
                        [
                            41.21812,
                            35.13218
                        ],
                        [
                            41.24244,
                            35.28559
                        ],
                        [
                            41.2749,
                            35.38491
                        ],
                        [
                            41.28264,
                            35.48615
                        ],
                        [
                            41.39427,
                            35.63038
                        ],
                        [
                            41.38105,
                            35.83529
                        ],
                        [
                            41.25805,
                            36.05459
                        ],
                        [
                            41.29177,
                            36.26345
                        ],
                        [
                            41.29461,
                            36.35626
                        ],
                        [
                            41.41129,
                            36.52287
                        ],
                        [
                            41.70674,
                            36.56747
                        ],
                        [
                            41.82807,
                            36.59313
                        ],
                        [
                            41.93809,
                            36.67005
                        ],
                        [
                            42.24932,
                            36.95775
                        ],
                        [
                            42.3846,
                            37.06708
                        ],
                        [
                            42.35569,
                            37.10804
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "TJK",
                "Country": "Tajikistan",
                "Total_3GHG": 0.04,
                "Total_3GHG_timeseries": [
                    6.4192e-07,
                    1.2796e-06,
                    1.9163e-06,
                    2.5531e-06,
                    3.191e-06,
                    3.8289e-06,
                    4.4675e-06,
                    5.1074e-06,
                    5.7477e-06,
                    6.3928e-06,
                    7.049e-06,
                    7.7127e-06,
                    8.4118e-06,
                    9.1183e-06,
                    9.8318e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007
                ],
                "Fossil_3GHG": 0.03,
                "Fossil_3GHG_timeseries": [
                    1.697e-08,
                    3.3999e-08,
                    5.1083e-08,
                    6.8227e-08,
                    8.6045e-08,
                    1.0329e-07,
                    1.2059e-07,
                    1.3879e-07,
                    1.5709e-07,
                    1.7572e-07,
                    1.9577e-07,
                    2.1677e-07,
                    2.6688e-07,
                    3.1844e-07,
                    3.7121e-07,
                    4.2861e-07,
                    4.8801e-07,
                    5.4773e-07,
                    6.104e-07,
                    6.7484e-07,
                    7.4313e-07,
                    8.1308e-07,
                    8.8389e-07,
                    9.5807e-07,
                    1.0352e-06,
                    1.117e-06,
                    1.2005e-06,
                    1.2901e-06,
                    1.3816e-06,
                    1.4782e-06,
                    1.5764e-06,
                    1.6764e-06,
                    1.7545e-06,
                    1.8333e-06,
                    1.915e-06,
                    1.9973e-06,
                    2.0818e-06,
                    2.1682e-06,
                    2.2578e-06,
                    2.353e-06,
                    2.4528e-06,
                    2.5559e-06,
                    2.6687e-06,
                    2.7829e-06,
                    2.9065e-06,
                    3.0314e-06,
                    3.1684e-06,
                    3.3155e-06,
                    3.4787e-06,
                    3.6567e-06,
                    3.8379e-06,
                    4.0147e-06,
                    4.1885e-06,
                    4.3767e-06,
                    4.5504e-06,
                    4.7414e-06,
                    4.9495e-06,
                    5.1585e-06,
                    5.3761e-06,
                    5.5898e-06,
                    5.8108e-06,
                    6.0558e-06,
                    6.318e-06,
                    6.5604e-06,
                    6.787e-06,
                    7.0258e-06,
                    7.2494e-06,
                    7.3698e-06,
                    7.4787e-06,
                    7.5816e-06,
                    7.6899e-06,
                    7.8127e-06,
                    7.9457e-06,
                    8.0947e-06,
                    8.2466e-06,
                    8.4408e-06,
                    8.6688e-06,
                    8.9181e-06,
                    9.1839e-06,
                    9.5242e-06,
                    9.9199e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Land_3GHG": 0.06,
                "Land_3GHG_timeseries": [
                    6.2495e-07,
                    1.2456e-06,
                    1.8652e-06,
                    2.4849e-06,
                    3.105e-06,
                    3.7257e-06,
                    4.3469e-06,
                    4.9686e-06,
                    5.5906e-06,
                    6.2171e-06,
                    6.8532e-06,
                    7.496e-06,
                    8.1449e-06,
                    8.7999e-06,
                    9.4606e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Total_CO2": 0.03,
                "Total_CO2_timeseries": [
                    5.095e-07,
                    1.0136e-06,
                    1.5158e-06,
                    2.0171e-06,
                    2.5185e-06,
                    3.0191e-06,
                    3.5197e-06,
                    4.0209e-06,
                    4.522e-06,
                    5.0276e-06,
                    5.5376e-06,
                    6.0489e-06,
                    6.5611e-06,
                    7.074e-06,
                    7.5874e-06,
                    8.1039e-06,
                    8.6212e-06,
                    9.138e-06,
                    9.6563e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_CO2": 0.03,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    5.0707e-10,
                    5.0707e-10,
                    5.0707e-10,
                    1.219e-09,
                    1.9742e-09,
                    2.9722e-09,
                    4.2398e-09,
                    5.3837e-09,
                    6.5815e-09,
                    7.9249e-09,
                    9.2087e-09,
                    1.3266e-08,
                    1.7922e-08,
                    2.1795e-08,
                    2.705e-08,
                    3.2752e-08,
                    4.0451e-08,
                    4.8354e-08,
                    5.5772e-08,
                    6.4776e-08,
                    7.5139e-08,
                    8.8006e-08,
                    1.0114e-07,
                    1.183e-07,
                    1.3591e-07,
                    1.5656e-07,
                    1.7832e-07,
                    2.0124e-07,
                    2.2732e-07,
                    2.5381e-07,
                    2.8265e-07,
                    3.1224e-07,
                    3.4354e-07,
                    3.762e-07,
                    4.1146e-07,
                    4.514e-07,
                    4.9538e-07,
                    5.4192e-07,
                    5.9648e-07,
                    6.5205e-07,
                    7.159e-07,
                    7.8089e-07,
                    8.5604e-07,
                    9.4033e-07,
                    1.0381e-06,
                    1.1489e-06,
                    1.2626e-06,
                    1.3724e-06,
                    1.4798e-06,
                    1.5994e-06,
                    1.7061e-06,
                    1.8278e-06,
                    1.9641e-06,
                    2.1012e-06,
                    2.246e-06,
                    2.388e-06,
                    2.5352e-06,
                    2.7019e-06,
                    2.8831e-06,
                    3.0466e-06,
                    3.1966e-06,
                    3.3566e-06,
                    3.5037e-06,
                    3.5624e-06,
                    3.6126e-06,
                    3.6583e-06,
                    3.7079e-06,
                    3.7684e-06,
                    3.8352e-06,
                    3.9147e-06,
                    3.9933e-06,
                    4.1071e-06,
                    4.2486e-06,
                    4.4053e-06,
                    4.574e-06,
                    4.8038e-06,
                    5.0799e-06,
                    5.3908e-06,
                    5.7383e-06,
                    6.1586e-06,
                    6.634e-06,
                    7.1789e-06,
                    7.7363e-06,
                    8.3246e-06,
                    8.9202e-06,
                    9.6341e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_CO2": 0.03,
                "Land_CO2_timeseries": [
                    5.095e-07,
                    1.0136e-06,
                    1.5158e-06,
                    2.0171e-06,
                    2.518e-06,
                    3.0186e-06,
                    3.5192e-06,
                    4.0197e-06,
                    4.52e-06,
                    5.0246e-06,
                    5.5334e-06,
                    6.0435e-06,
                    6.5545e-06,
                    7.0661e-06,
                    7.5782e-06,
                    8.0906e-06,
                    8.6033e-06,
                    9.1162e-06,
                    9.6293e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_CH4": 0.06,
                "Total_CH4_timeseries": [
                    8.2582e-08,
                    1.6527e-07,
                    2.4805e-07,
                    3.3095e-07,
                    4.1405e-07,
                    4.9715e-07,
                    5.8035e-07,
                    6.638e-07,
                    7.4736e-07,
                    8.3107e-07,
                    9.2121e-07,
                    1.0177e-06,
                    1.1485e-06,
                    1.2859e-06,
                    1.4298e-06,
                    1.5808e-06,
                    1.7386e-06,
                    1.9027e-06,
                    2.0736e-06,
                    2.2511e-06,
                    2.4362e-06,
                    2.6285e-06,
                    2.8277e-06,
                    3.0344e-06,
                    3.2483e-06,
                    3.4699e-06,
                    3.6986e-06,
                    3.935e-06,
                    4.1786e-06,
                    4.4299e-06,
                    4.683e-06,
                    4.9382e-06,
                    5.1696e-06,
                    5.4026e-06,
                    5.6375e-06,
                    5.8737e-06,
                    6.1116e-06,
                    6.3516e-06,
                    6.5933e-06,
                    6.8374e-06,
                    7.0834e-06,
                    7.3316e-06,
                    7.5829e-06,
                    7.836e-06,
                    8.0917e-06,
                    8.3489e-06,
                    8.6095e-06,
                    8.8725e-06,
                    9.1395e-06,
                    9.4097e-06,
                    9.6817e-06,
                    9.9547e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003
                ],
                "Fossil_CH4": 0.03,
                "Fossil_CH4_timeseries": [
                    1.3907e-08,
                    2.783e-08,
                    4.1766e-08,
                    5.5723e-08,
                    6.9808e-08,
                    8.3794e-08,
                    9.7793e-08,
                    1.1196e-07,
                    1.2615e-07,
                    1.4041e-07,
                    1.5579e-07,
                    1.7223e-07,
                    2.1771e-07,
                    2.6447e-07,
                    3.1248e-07,
                    3.6234e-07,
                    4.1357e-07,
                    4.6588e-07,
                    5.1974e-07,
                    5.7491e-07,
                    6.3189e-07,
                    6.9025e-07,
                    7.4984e-07,
                    8.111e-07,
                    8.7385e-07,
                    9.3853e-07,
                    1.0046e-06,
                    1.0726e-06,
                    1.142e-06,
                    1.2133e-06,
                    1.2851e-06,
                    1.3576e-06,
                    1.4049e-06,
                    1.4524e-06,
                    1.5005e-06,
                    1.5484e-06,
                    1.5967e-06,
                    1.6456e-06,
                    1.6949e-06,
                    1.7452e-06,
                    1.796e-06,
                    1.8474e-06,
                    1.9004e-06,
                    1.9538e-06,
                    2.0082e-06,
                    2.0627e-06,
                    2.1191e-06,
                    2.1764e-06,
                    2.2362e-06,
                    2.2977e-06,
                    2.3594e-06,
                    2.4205e-06,
                    2.4809e-06,
                    2.5435e-06,
                    2.6042e-06,
                    2.6673e-06,
                    2.7326e-06,
                    2.7979e-06,
                    2.864e-06,
                    2.9289e-06,
                    2.9959e-06,
                    3.0672e-06,
                    3.1412e-06,
                    3.2131e-06,
                    3.2823e-06,
                    3.3539e-06,
                    3.423e-06,
                    3.4773e-06,
                    3.5285e-06,
                    3.578e-06,
                    3.6289e-06,
                    3.6832e-06,
                    3.7411e-06,
                    3.8018e-06,
                    3.8663e-06,
                    3.9372e-06,
                    4.0138e-06,
                    4.0961e-06,
                    4.1823e-06,
                    4.2814e-06,
                    4.389e-06,
                    4.502e-06,
                    4.6212e-06,
                    4.7579e-06,
                    4.9088e-06,
                    5.0724e-06,
                    5.2422e-06,
                    5.4331e-06,
                    5.6296e-06,
                    5.8476e-06,
                    6.056e-06,
                    6.2342e-06,
                    6.4378e-06,
                    6.6347e-06,
                    6.8516e-06,
                    7.0859e-06,
                    7.3495e-06,
                    7.6305e-06,
                    7.9417e-06,
                    8.2755e-06,
                    8.6423e-06,
                    9.0424e-06,
                    9.4737e-06,
                    9.9408e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CH4": 0.11,
                "Land_CH4_timeseries": [
                    6.8676e-08,
                    1.3744e-07,
                    2.0629e-07,
                    2.7522e-07,
                    3.4425e-07,
                    4.1336e-07,
                    4.8255e-07,
                    5.5184e-07,
                    6.2121e-07,
                    6.9066e-07,
                    7.6541e-07,
                    8.4545e-07,
                    9.3078e-07,
                    1.0214e-06,
                    1.1173e-06,
                    1.2185e-06,
                    1.325e-06,
                    1.4368e-06,
                    1.5539e-06,
                    1.6762e-06,
                    1.8044e-06,
                    1.9382e-06,
                    2.0779e-06,
                    2.2233e-06,
                    2.3744e-06,
                    2.5313e-06,
                    2.694e-06,
                    2.8624e-06,
                    3.0366e-06,
                    3.2166e-06,
                    3.3979e-06,
                    3.5806e-06,
                    3.7647e-06,
                    3.9502e-06,
                    4.1371e-06,
                    4.3253e-06,
                    4.515e-06,
                    4.706e-06,
                    4.8984e-06,
                    5.0922e-06,
                    5.2875e-06,
                    5.4842e-06,
                    5.6825e-06,
                    5.8822e-06,
                    6.0835e-06,
                    6.2862e-06,
                    6.4904e-06,
                    6.6961e-06,
                    6.9033e-06,
                    7.112e-06,
                    7.3223e-06,
                    7.5342e-06,
                    7.7478e-06,
                    7.9629e-06,
                    8.1796e-06,
                    8.3979e-06,
                    8.6179e-06,
                    8.8394e-06,
                    9.0625e-06,
                    9.2873e-06,
                    9.5178e-06,
                    9.754e-06,
                    9.996e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Total_N2O": 0.07,
                "Total_N2O_timeseries": [
                    4.9842e-08,
                    1.0066e-07,
                    1.5242e-07,
                    2.0506e-07,
                    2.585e-07,
                    3.1266e-07,
                    3.6744e-07,
                    4.2271e-07,
                    4.7834e-07,
                    5.3417e-07,
                    5.9011e-07,
                    6.4614e-07,
                    7.0224e-07,
                    7.5839e-07,
                    8.146e-07,
                    8.7085e-07,
                    9.2717e-07,
                    9.8355e-07,
                    1.04e-06,
                    1.0966e-06,
                    1.1541e-06,
                    1.214e-06,
                    1.2772e-06,
                    1.3446e-06,
                    1.4165e-06,
                    1.4931e-06,
                    1.5742e-06,
                    1.6591e-06,
                    1.7471e-06,
                    1.8369e-06,
                    1.9278e-06,
                    2.0196e-06,
                    2.1121e-06,
                    2.2053e-06,
                    2.2991e-06,
                    2.3934e-06,
                    2.4882e-06,
                    2.5837e-06,
                    2.6798e-06,
                    2.778e-06,
                    2.8778e-06,
                    2.9791e-06,
                    3.0819e-06,
                    3.1861e-06,
                    3.2915e-06,
                    3.3981e-06,
                    3.5057e-06,
                    3.6141e-06,
                    3.7231e-06,
                    3.8326e-06,
                    3.9422e-06,
                    4.0522e-06,
                    4.1623e-06,
                    4.2726e-06,
                    4.3831e-06,
                    4.4937e-06,
                    4.6046e-06,
                    4.7157e-06,
                    4.827e-06,
                    4.9387e-06,
                    5.0518e-06,
                    5.1684e-06,
                    5.2901e-06,
                    5.4179e-06,
                    5.5525e-06,
                    5.6941e-06,
                    5.8422e-06,
                    5.9963e-06,
                    6.155e-06,
                    6.3167e-06,
                    6.4804e-06,
                    6.646e-06,
                    6.8135e-06,
                    6.9828e-06,
                    7.1538e-06,
                    7.3264e-06,
                    7.5003e-06,
                    7.6755e-06,
                    7.8516e-06,
                    8.0284e-06,
                    8.2051e-06,
                    8.3806e-06,
                    8.5541e-06,
                    8.7252e-06,
                    8.8935e-06,
                    9.0592e-06,
                    9.2226e-06,
                    9.3842e-06,
                    9.5451e-06,
                    9.7062e-06,
                    9.8705e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_N2O": 0.03,
                "Fossil_N2O_timeseries": [
                    3.0632e-09,
                    6.1691e-09,
                    9.3165e-09,
                    1.2504e-08,
                    1.573e-08,
                    1.8992e-08,
                    2.2287e-08,
                    2.5613e-08,
                    2.8965e-08,
                    3.2341e-08,
                    3.5737e-08,
                    3.9153e-08,
                    4.2588e-08,
                    4.6043e-08,
                    4.9517e-08,
                    5.301e-08,
                    5.6523e-08,
                    6.0054e-08,
                    6.3606e-08,
                    6.7179e-08,
                    7.0794e-08,
                    7.4485e-08,
                    7.8279e-08,
                    8.2197e-08,
                    8.6248e-08,
                    9.0436e-08,
                    9.4754e-08,
                    9.9189e-08,
                    1.0372e-07,
                    1.0831e-07,
                    1.1295e-07,
                    1.1763e-07,
                    1.2235e-07,
                    1.271e-07,
                    1.3188e-07,
                    1.367e-07,
                    1.4154e-07,
                    1.4642e-07,
                    1.5134e-07,
                    1.5636e-07,
                    1.6145e-07,
                    1.6659e-07,
                    1.7179e-07,
                    1.7705e-07,
                    1.8238e-07,
                    1.8778e-07,
                    1.9325e-07,
                    1.9879e-07,
                    2.0441e-07,
                    2.1011e-07,
                    2.1589e-07,
                    2.2178e-07,
                    2.2777e-07,
                    2.3387e-07,
                    2.4008e-07,
                    2.4641e-07,
                    2.5286e-07,
                    2.5942e-07,
                    2.6609e-07,
                    2.7286e-07,
                    2.7972e-07,
                    2.8667e-07,
                    2.937e-07,
                    3.0081e-07,
                    3.0801e-07,
                    3.1528e-07,
                    3.2264e-07,
                    3.3009e-07,
                    3.3765e-07,
                    3.4531e-07,
                    3.5312e-07,
                    3.6114e-07,
                    3.6944e-07,
                    3.7807e-07,
                    3.8707e-07,
                    3.9649e-07,
                    4.0637e-07,
                    4.1672e-07,
                    4.2759e-07,
                    4.3897e-07,
                    4.5099e-07,
                    4.6383e-07,
                    4.7762e-07,
                    4.9249e-07,
                    5.0853e-07,
                    5.2577e-07,
                    5.4424e-07,
                    5.6392e-07,
                    5.8477e-07,
                    6.067e-07,
                    6.2968e-07,
                    6.5377e-07,
                    6.7901e-07,
                    7.0545e-07,
                    7.3313e-07,
                    7.6212e-07,
                    7.9245e-07,
                    8.2417e-07,
                    8.5734e-07,
                    8.9199e-07,
                    9.2852e-07,
                    9.6748e-07,
                    1.0093e-06,
                    1.0542e-06,
                    1.1022e-06,
                    1.1532e-06,
                    1.207e-06,
                    1.2629e-06,
                    1.3204e-06,
                    1.3787e-06,
                    1.4369e-06,
                    1.4949e-06,
                    1.5522e-06,
                    1.6087e-06,
                    1.6644e-06,
                    1.7192e-06,
                    1.7731e-06,
                    1.8266e-06,
                    1.8797e-06,
                    1.9395e-06,
                    1.9996e-06,
                    2.0625e-06,
                    2.1282e-06,
                    2.1968e-06,
                    2.2858e-06,
                    2.3799e-06,
                    2.4766e-06,
                    2.5762e-06,
                    2.6788e-06,
                    2.7848e-06,
                    2.8913e-06,
                    2.999e-06,
                    3.1076e-06,
                    3.2176e-06,
                    3.3292e-06,
                    3.4417e-06,
                    3.5562e-06,
                    3.6714e-06,
                    3.7866e-06,
                    3.9026e-06,
                    4.0155e-06,
                    4.1253e-06,
                    4.228e-06,
                    4.3245e-06,
                    4.417e-06,
                    4.5063e-06,
                    4.5934e-06,
                    4.6778e-06,
                    4.7583e-06,
                    4.8343e-06,
                    4.9072e-06,
                    4.9766e-06,
                    5.0423e-06,
                    5.1055e-06,
                    5.1657e-06,
                    5.2237e-06,
                    5.2808e-06,
                    5.3347e-06,
                    5.385e-06,
                    5.4332e-06,
                    5.4796e-06,
                    5.5327e-06,
                    5.587e-06,
                    5.6479e-06,
                    5.7065e-06,
                    5.7668e-06,
                    5.8307e-06,
                    5.8985e-06,
                    5.9669e-06,
                    6.039e-06,
                    6.1155e-06,
                    6.1945e-06
                ],
                "Land_N2O": 0.08,
                "Land_N2O_timeseries": [
                    4.6779e-08,
                    9.4494e-08,
                    1.431e-07,
                    1.9255e-07,
                    2.4277e-07,
                    2.9367e-07,
                    3.4515e-07,
                    3.971e-07,
                    4.4937e-07,
                    5.0183e-07,
                    5.5438e-07,
                    6.0699e-07,
                    6.5965e-07,
                    7.1235e-07,
                    7.6508e-07,
                    8.1784e-07,
                    8.7064e-07,
                    9.235e-07,
                    9.7642e-07,
                    1.0294e-06,
                    1.0833e-06,
                    1.1395e-06,
                    1.199e-06,
                    1.2624e-06,
                    1.3303e-06,
                    1.4027e-06,
                    1.4794e-06,
                    1.5599e-06,
                    1.6434e-06,
                    1.7286e-06,
                    1.8149e-06,
                    1.902e-06,
                    1.9898e-06,
                    2.0782e-06,
                    2.1672e-06,
                    2.2567e-06,
                    2.3467e-06,
                    2.4373e-06,
                    2.5284e-06,
                    2.6217e-06,
                    2.7164e-06,
                    2.8126e-06,
                    2.9101e-06,
                    3.0091e-06,
                    3.1092e-06,
                    3.2104e-06,
                    3.3125e-06,
                    3.4153e-06,
                    3.5187e-06,
                    3.6224e-06,
                    3.7263e-06,
                    3.8304e-06,
                    3.9345e-06,
                    4.0387e-06,
                    4.143e-06,
                    4.2473e-06,
                    4.3517e-06,
                    4.4563e-06,
                    4.5609e-06,
                    4.6658e-06,
                    4.7721e-06,
                    4.8817e-06,
                    4.9964e-06,
                    5.1171e-06,
                    5.2445e-06,
                    5.3788e-06,
                    5.5196e-06,
                    5.6662e-06,
                    5.8174e-06,
                    5.9714e-06,
                    6.1273e-06,
                    6.2848e-06,
                    6.444e-06,
                    6.6047e-06,
                    6.7667e-06,
                    6.9299e-06,
                    7.094e-06,
                    7.2588e-06,
                    7.424e-06,
                    7.5894e-06,
                    7.7541e-06,
                    7.9167e-06,
                    8.0765e-06,
                    8.2327e-06,
                    8.385e-06,
                    8.5335e-06,
                    8.6783e-06,
                    8.8203e-06,
                    8.9603e-06,
                    9.0995e-06,
                    9.2408e-06,
                    9.3875e-06,
                    9.5425e-06,
                    9.7077e-06,
                    9.8845e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                67.77866,
                                37.17963
                            ],
                            [
                                67.815,
                                37.07021
                            ],
                            [
                                67.89875,
                                37.02998
                            ],
                            [
                                68.02029,
                                36.92467
                            ],
                            [
                                68.12129,
                                36.96246
                            ],
                            [
                                68.18961,
                                37.02082
                            ],
                            [
                                68.28256,
                                37.02474
                            ],
                            [
                                68.29798,
                                37.10553
                            ],
                            [
                                68.42024,
                                37.11074
                            ],
                            [
                                68.42737,
                                37.14423
                            ],
                            [
                                68.53939,
                                37.1645
                            ],
                            [
                                68.64424,
                                37.20835
                            ],
                            [
                                68.81951,
                                37.3117
                            ],
                            [
                                68.97059,
                                37.31957
                            ],
                            [
                                69.08637,
                                37.2253
                            ],
                            [
                                69.11687,
                                37.17559
                            ],
                            [
                                69.25536,
                                37.09443
                            ],
                            [
                                69.40044,
                                37.16634
                            ],
                            [
                                69.45202,
                                37.23181
                            ],
                            [
                                69.3805,
                                37.32505
                            ],
                            [
                                69.3948,
                                37.44963
                            ],
                            [
                                69.49239,
                                37.52366
                            ],
                            [
                                69.5317,
                                37.58877
                            ],
                            [
                                69.62122,
                                37.57426
                            ],
                            [
                                69.74663,
                                37.58727
                            ],
                            [
                                69.79983,
                                37.57052
                            ],
                            [
                                69.91048,
                                37.61891
                            ],
                            [
                                69.9597,
                                37.56472
                            ],
                            [
                                70.1161,
                                37.52448
                            ],
                            [
                                70.17001,
                                37.53206
                            ],
                            [
                                70.29938,
                                37.69032
                            ],
                            [
                                70.27772,
                                37.81314
                            ],
                            [
                                70.18812,
                                37.8492
                            ],
                            [
                                70.20975,
                                37.9253
                            ],
                            [
                                70.32864,
                                38.00116
                            ],
                            [
                                70.36764,
                                38.0533
                            ],
                            [
                                70.5029,
                                38.12341
                            ],
                            [
                                70.50366,
                                38.16298
                            ],
                            [
                                70.613,
                                38.34501
                            ],
                            [
                                70.6841,
                                38.36491
                            ],
                            [
                                70.68233,
                                38.40985
                            ],
                            [
                                70.77428,
                                38.45345
                            ],
                            [
                                70.92827,
                                38.43334
                            ],
                            [
                                70.99068,
                                38.4881
                            ],
                            [
                                71.04615,
                                38.4136
                            ],
                            [
                                71.10219,
                                38.42055
                            ],
                            [
                                71.18525,
                                38.34713
                            ],
                            [
                                71.3255,
                                38.30266
                            ],
                            [
                                71.37083,
                                38.25722
                            ],
                            [
                                71.35281,
                                38.1489
                            ],
                            [
                                71.28603,
                                38.03965
                            ],
                            [
                                71.2579,
                                37.92538
                            ],
                            [
                                71.3324,
                                37.88778
                            ],
                            [
                                71.50664,
                                37.95175
                            ],
                            [
                                71.59009,
                                37.91912
                            ],
                            [
                                71.59373,
                                37.80547
                            ],
                            [
                                71.53624,
                                37.764
                            ],
                            [
                                71.54991,
                                37.71398
                            ],
                            [
                                71.49576,
                                37.54202
                            ],
                            [
                                71.52365,
                                37.47687
                            ],
                            [
                                71.48945,
                                37.33459
                            ],
                            [
                                71.5034,
                                37.31092
                            ],
                            [
                                71.4563,
                                37.21006
                            ],
                            [
                                71.43064,
                                37.06803
                            ],
                            [
                                71.46787,
                                36.95322
                            ],
                            [
                                71.54048,
                                36.84469
                            ],
                            [
                                71.56784,
                                36.76387
                            ],
                            [
                                71.67472,
                                36.67517
                            ],
                            [
                                71.84304,
                                36.68265
                            ],
                            [
                                72.02144,
                                36.81137
                            ],
                            [
                                72.10849,
                                36.84494
                            ],
                            [
                                72.21066,
                                36.92518
                            ],
                            [
                                72.34337,
                                36.98752
                            ],
                            [
                                72.47564,
                                36.99462
                            ],
                            [
                                72.67486,
                                37.02278
                            ],
                            [
                                72.77437,
                                37.19091
                            ],
                            [
                                72.93741,
                                37.28115
                            ],
                            [
                                73.09212,
                                37.32398
                            ],
                            [
                                73.15207,
                                37.4032
                            ],
                            [
                                73.21596,
                                37.40613
                            ],
                            [
                                73.30323,
                                37.46215
                            ],
                            [
                                73.37391,
                                37.44353
                            ],
                            [
                                73.45334,
                                37.4735
                            ],
                            [
                                73.53384,
                                37.47077
                            ],
                            [
                                73.64363,
                                37.43655
                            ],
                            [
                                73.77332,
                                37.43749
                            ],
                            [
                                73.77188,
                                37.34008
                            ],
                            [
                                73.63023,
                                37.28046
                            ],
                            [
                                73.75529,
                                37.22368
                            ],
                            [
                                74.06498,
                                37.32467
                            ],
                            [
                                74.20037,
                                37.33695
                            ],
                            [
                                74.24911,
                                37.37927
                            ],
                            [
                                74.37124,
                                37.4236
                            ],
                            [
                                74.5666,
                                37.37379
                            ],
                            [
                                74.6756,
                                37.39022
                            ],
                            [
                                74.80243,
                                37.35481
                            ],
                            [
                                74.88986,
                                37.23409
                            ],
                            [
                                74.93372,
                                37.28884
                            ],
                            [
                                75.00396,
                                37.2911
                            ],
                            [
                                75.12349,
                                37.32782
                            ],
                            [
                                75.1012,
                                37.37335
                            ],
                            [
                                75.13345,
                                37.43759
                            ],
                            [
                                75.05475,
                                37.52716
                            ],
                            [
                                74.92878,
                                37.5562
                            ],
                            [
                                74.89673,
                                37.65826
                            ],
                            [
                                74.99337,
                                37.76178
                            ],
                            [
                                74.91353,
                                37.82973
                            ],
                            [
                                74.91402,
                                38.00942
                            ],
                            [
                                74.86042,
                                38.03057
                            ],
                            [
                                74.78638,
                                38.18404
                            ],
                            [
                                74.80196,
                                38.22482
                            ],
                            [
                                74.7875,
                                38.35397
                            ],
                            [
                                74.86931,
                                38.4053
                            ],
                            [
                                74.83824,
                                38.4857
                            ],
                            [
                                74.7172,
                                38.52314
                            ],
                            [
                                74.64295,
                                38.57818
                            ],
                            [
                                74.5065,
                                38.62941
                            ],
                            [
                                74.3416,
                                38.65516
                            ],
                            [
                                74.13286,
                                38.66786
                            ],
                            [
                                74.06891,
                                38.53125
                            ],
                            [
                                73.92438,
                                38.53649
                            ],
                            [
                                73.88105,
                                38.57781
                            ],
                            [
                                73.79041,
                                38.60509
                            ],
                            [
                                73.75587,
                                38.77864
                            ],
                            [
                                73.70724,
                                38.88604
                            ],
                            [
                                73.74711,
                                38.93261
                            ],
                            [
                                73.84544,
                                38.94864
                            ],
                            [
                                73.81892,
                                39.03301
                            ],
                            [
                                73.74504,
                                39.03096
                            ],
                            [
                                73.68344,
                                39.16685
                            ],
                            [
                                73.61747,
                                39.23655
                            ],
                            [
                                73.56731,
                                39.24017
                            ],
                            [
                                73.6698,
                                39.39065
                            ],
                            [
                                73.65824,
                                39.46508
                            ],
                            [
                                73.50926,
                                39.46738
                            ],
                            [
                                73.38966,
                                39.44991
                            ],
                            [
                                73.31253,
                                39.38634
                            ],
                            [
                                73.24039,
                                39.40526
                            ],
                            [
                                73.21142,
                                39.35676
                            ],
                            [
                                73.09649,
                                39.37276
                            ],
                            [
                                73.03785,
                                39.35479
                            ],
                            [
                                72.76902,
                                39.35257
                            ],
                            [
                                72.68943,
                                39.38445
                            ],
                            [
                                72.59529,
                                39.35783
                            ],
                            [
                                72.49653,
                                39.37591
                            ],
                            [
                                72.46922,
                                39.34911
                            ],
                            [
                                72.34838,
                                39.32944
                            ],
                            [
                                72.26386,
                                39.21226
                            ],
                            [
                                72.16797,
                                39.26132
                            ],
                            [
                                72.10821,
                                39.26475
                            ],
                            [
                                72.0347,
                                39.36551
                            ],
                            [
                                71.95731,
                                39.33039
                            ],
                            [
                                71.91926,
                                39.2814
                            ],
                            [
                                71.7784,
                                39.28842
                            ],
                            [
                                71.75835,
                                39.3517
                            ],
                            [
                                71.80029,
                                39.38172
                            ],
                            [
                                71.78755,
                                39.4419
                            ],
                            [
                                71.70509,
                                39.45581
                            ],
                            [
                                71.57755,
                                39.44906
                            ],
                            [
                                71.54376,
                                39.50751
                            ],
                            [
                                71.5486,
                                39.58881
                            ],
                            [
                                71.49894,
                                39.61325
                            ],
                            [
                                71.41737,
                                39.57203
                            ],
                            [
                                71.35998,
                                39.57611
                            ],
                            [
                                71.29603,
                                39.51856
                            ],
                            [
                                71.08977,
                                39.49878
                            ],
                            [
                                71.06631,
                                39.41466
                            ],
                            [
                                70.91181,
                                39.38352
                            ],
                            [
                                70.78882,
                                39.38962
                            ],
                            [
                                70.76169,
                                39.46049
                            ],
                            [
                                70.66078,
                                39.56539
                            ],
                            [
                                70.48753,
                                39.61379
                            ],
                            [
                                70.45343,
                                39.57737
                            ],
                            [
                                70.37567,
                                39.59096
                            ],
                            [
                                70.27134,
                                39.52851
                            ],
                            [
                                70.10614,
                                39.58247
                            ],
                            [
                                70.03087,
                                39.54588
                            ],
                            [
                                69.90404,
                                39.56895
                            ],
                            [
                                69.81015,
                                39.56575
                            ],
                            [
                                69.71133,
                                39.59301
                            ],
                            [
                                69.62365,
                                39.58421
                            ],
                            [
                                69.48399,
                                39.52563
                            ],
                            [
                                69.34098,
                                39.53914
                            ],
                            [
                                69.32579,
                                39.69345
                            ],
                            [
                                69.27696,
                                39.79105
                            ],
                            [
                                69.35484,
                                39.97543
                            ],
                            [
                                69.42854,
                                39.90582
                            ],
                            [
                                69.53255,
                                39.93449
                            ],
                            [
                                69.50789,
                                40.03331
                            ],
                            [
                                69.56283,
                                40.10346
                            ],
                            [
                                69.70069,
                                40.11666
                            ],
                            [
                                69.79951,
                                40.15772
                            ],
                            [
                                70.04791,
                                40.23528
                            ],
                            [
                                70.2151,
                                40.12839
                            ],
                            [
                                70.26884,
                                40.13168
                            ],
                            [
                                70.43004,
                                40.06288
                            ],
                            [
                                70.56504,
                                40.0207
                            ],
                            [
                                70.45652,
                                39.94771
                            ],
                            [
                                70.57553,
                                39.94346
                            ],
                            [
                                70.64054,
                                39.97927
                            ],
                            [
                                70.65443,
                                40.06601
                            ],
                            [
                                70.75871,
                                40.08982
                            ],
                            [
                                70.82426,
                                40.15963
                            ],
                            [
                                70.96282,
                                40.1582
                            ],
                            [
                                70.96761,
                                40.22851
                            ],
                            [
                                70.86928,
                                40.2225
                            ],
                            [
                                70.77911,
                                40.18459
                            ],
                            [
                                70.6503,
                                40.16583
                            ],
                            [
                                70.56998,
                                40.24089
                            ],
                            [
                                70.5479,
                                40.34666
                            ],
                            [
                                70.37908,
                                40.38213
                            ],
                            [
                                70.33339,
                                40.44884
                            ],
                            [
                                70.48731,
                                40.50662
                            ],
                            [
                                70.51504,
                                40.55298
                            ],
                            [
                                70.58716,
                                40.56668
                            ],
                            [
                                70.62902,
                                40.61874
                            ],
                            [
                                70.7341,
                                40.65884
                            ],
                            [
                                70.78823,
                                40.72301
                            ],
                            [
                                70.53767,
                                40.98893
                            ],
                            [
                                70.44664,
                                41.04163
                            ],
                            [
                                70.35921,
                                40.88692
                            ],
                            [
                                70.21723,
                                40.82831
                            ],
                            [
                                70.15559,
                                40.8329
                            ],
                            [
                                70.08074,
                                40.76647
                            ],
                            [
                                69.92341,
                                40.70616
                            ],
                            [
                                69.8769,
                                40.7194
                            ],
                            [
                                69.76658,
                                40.68587
                            ],
                            [
                                69.7373,
                                40.64075
                            ],
                            [
                                69.66801,
                                40.63224
                            ],
                            [
                                69.57277,
                                40.70588
                            ],
                            [
                                69.53321,
                                40.76354
                            ],
                            [
                                69.4036,
                                40.78126
                            ],
                            [
                                69.34929,
                                40.71293
                            ],
                            [
                                69.3614,
                                40.61671
                            ],
                            [
                                69.3317,
                                40.5719
                            ],
                            [
                                69.23651,
                                40.52958
                            ],
                            [
                                69.30907,
                                40.37045
                            ],
                            [
                                69.33832,
                                40.34371
                            ],
                            [
                                69.25436,
                                40.25368
                            ],
                            [
                                69.17224,
                                40.20617
                            ],
                            [
                                69.05213,
                                40.21984
                            ],
                            [
                                68.77039,
                                40.19576
                            ],
                            [
                                68.54013,
                                40.13911
                            ],
                            [
                                68.60451,
                                40.09405
                            ],
                            [
                                68.68114,
                                40.10005
                            ],
                            [
                                68.87045,
                                40.14567
                            ],
                            [
                                68.97239,
                                40.15098
                            ],
                            [
                                69.0006,
                                40.06931
                            ],
                            [
                                68.89321,
                                40.06823
                            ],
                            [
                                68.81411,
                                40.00086
                            ],
                            [
                                68.90055,
                                39.92257
                            ],
                            [
                                68.82307,
                                39.89356
                            ],
                            [
                                68.7768,
                                39.83219
                            ],
                            [
                                68.72189,
                                39.8668
                            ],
                            [
                                68.6507,
                                39.80876
                            ],
                            [
                                68.59513,
                                39.72094
                            ],
                            [
                                68.62637,
                                39.65385
                            ],
                            [
                                68.51728,
                                39.53722
                            ],
                            [
                                68.35971,
                                39.53192
                            ],
                            [
                                67.93448,
                                39.59905
                            ],
                            [
                                67.79954,
                                39.65194
                            ],
                            [
                                67.70931,
                                39.65514
                            ],
                            [
                                67.62472,
                                39.60042
                            ],
                            [
                                67.50305,
                                39.57215
                            ],
                            [
                                67.4278,
                                39.49519
                            ],
                            [
                                67.51775,
                                39.33994
                            ],
                            [
                                67.39462,
                                39.29948
                            ],
                            [
                                67.44876,
                                39.20914
                            ],
                            [
                                67.61689,
                                39.17516
                            ],
                            [
                                67.68012,
                                39.13984
                            ],
                            [
                                67.68506,
                                39.02414
                            ],
                            [
                                67.71554,
                                39.00113
                            ],
                            [
                                67.87079,
                                39.00126
                            ],
                            [
                                67.9682,
                                39.03241
                            ],
                            [
                                68.11459,
                                39.0087
                            ],
                            [
                                68.19789,
                                38.92512
                            ],
                            [
                                68.19405,
                                38.85139
                            ],
                            [
                                68.08496,
                                38.81308
                            ],
                            [
                                68.1254,
                                38.74099
                            ],
                            [
                                68.0601,
                                38.70561
                            ],
                            [
                                68.08531,
                                38.64512
                            ],
                            [
                                68.06945,
                                38.54239
                            ],
                            [
                                68.14027,
                                38.47126
                            ],
                            [
                                68.11472,
                                38.42759
                            ],
                            [
                                68.19592,
                                38.40542
                            ],
                            [
                                68.23627,
                                38.32773
                            ],
                            [
                                68.32162,
                                38.29077
                            ],
                            [
                                68.40198,
                                38.19187
                            ],
                            [
                                68.36928,
                                38.07983
                            ],
                            [
                                68.28794,
                                37.98883
                            ],
                            [
                                68.27085,
                                37.91202
                            ],
                            [
                                68.1274,
                                37.87435
                            ],
                            [
                                68.04083,
                                37.73469
                            ],
                            [
                                67.94247,
                                37.64398
                            ],
                            [
                                67.85399,
                                37.52828
                            ],
                            [
                                67.8285,
                                37.46002
                            ],
                            [
                                67.8207,
                                37.23634
                            ],
                            [
                                67.77866,
                                37.17963
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                70.50396,
                                39.88347
                            ],
                            [
                                70.62796,
                                39.79871
                            ],
                            [
                                70.72545,
                                39.84998
                            ],
                            [
                                70.71713,
                                39.90257
                            ],
                            [
                                70.50396,
                                39.88347
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "TZA",
                "Country": "United Republic of Tanzania",
                "Total_3GHG": 0.43,
                "Total_3GHG_timeseries": [
                    2.9479e-06,
                    5.8535e-06,
                    8.7329e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0048,
                    0.0049,
                    0.005,
                    0.0052,
                    0.0053,
                    0.0055,
                    0.0056,
                    0.0058,
                    0.0059,
                    0.0061,
                    0.0062,
                    0.0063,
                    0.0065,
                    0.0066,
                    0.0067,
                    0.0069,
                    0.007
                ],
                "Fossil_3GHG": 0.09,
                "Fossil_3GHG_timeseries": [
                    1.0232e-07,
                    2.1124e-07,
                    3.2688e-07,
                    4.494e-07,
                    5.7895e-07,
                    7.1566e-07,
                    8.5969e-07,
                    1.0112e-06,
                    1.1703e-06,
                    1.3372e-06,
                    1.513e-06,
                    1.6977e-06,
                    1.8918e-06,
                    2.0952e-06,
                    2.3082e-06,
                    2.531e-06,
                    2.7638e-06,
                    3.0068e-06,
                    3.2603e-06,
                    3.5243e-06,
                    3.7937e-06,
                    4.0684e-06,
                    4.349e-06,
                    4.6354e-06,
                    4.9278e-06,
                    5.2264e-06,
                    5.5313e-06,
                    5.8424e-06,
                    6.1598e-06,
                    6.4834e-06,
                    6.8124e-06,
                    7.147e-06,
                    7.4871e-06,
                    7.833e-06,
                    8.1847e-06,
                    8.5424e-06,
                    8.9061e-06,
                    9.2761e-06,
                    9.6524e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009
                ],
                "Land_3GHG": 1.06,
                "Land_3GHG_timeseries": [
                    2.8455e-06,
                    5.6423e-06,
                    8.406e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0055,
                    0.0056,
                    0.0057,
                    0.0058,
                    0.0059,
                    0.006,
                    0.0061
                ],
                "Total_CO2": 0.38,
                "Total_CO2_timeseries": [
                    2.2153e-06,
                    4.3776e-06,
                    6.5028e-06,
                    8.6616e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0043
                ],
                "Fossil_CO2": 0.02,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2.244e-07,
                    4.257e-07,
                    6.6825e-07,
                    9.0585e-07,
                    1.1484e-06,
                    1.3992e-06,
                    1.6962e-06,
                    2.0394e-06,
                    2.4007e-06,
                    2.7109e-06,
                    3.0839e-06,
                    3.4006e-06,
                    3.7455e-06,
                    4.1069e-06,
                    4.5721e-06,
                    5.0952e-06,
                    5.7122e-06,
                    6.5039e-06,
                    7.2478e-06,
                    8.056e-06,
                    8.851e-06,
                    9.9595e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CO2": 1.15,
                "Land_CO2_timeseries": [
                    2.2153e-06,
                    4.3776e-06,
                    6.5028e-06,
                    8.6616e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.004,
                    0.004,
                    0.0041,
                    0.0041
                ],
                "Total_CH4": 0.53,
                "Total_CH4_timeseries": [
                    5.2066e-07,
                    1.048e-06,
                    1.5823e-06,
                    2.1236e-06,
                    2.6721e-06,
                    3.2279e-06,
                    3.7913e-06,
                    4.3623e-06,
                    4.9412e-06,
                    5.528e-06,
                    6.1308e-06,
                    6.7495e-06,
                    7.3845e-06,
                    8.0358e-06,
                    8.7038e-06,
                    9.3885e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022
                ],
                "Fossil_CH4": 0.29,
                "Fossil_CH4_timeseries": [
                    8.6184e-08,
                    1.7874e-07,
                    2.778e-07,
                    3.8354e-07,
                    4.961e-07,
                    6.1564e-07,
                    7.4233e-07,
                    8.7632e-07,
                    1.0178e-06,
                    1.1669e-06,
                    1.3248e-06,
                    1.4916e-06,
                    1.6675e-06,
                    1.8527e-06,
                    2.0474e-06,
                    2.2518e-06,
                    2.4661e-06,
                    2.6905e-06,
                    2.9252e-06,
                    3.1704e-06,
                    3.4207e-06,
                    3.676e-06,
                    3.9365e-06,
                    4.2024e-06,
                    4.4735e-06,
                    4.7502e-06,
                    5.0325e-06,
                    5.3204e-06,
                    5.6142e-06,
                    5.9138e-06,
                    6.2186e-06,
                    6.5288e-06,
                    6.8443e-06,
                    7.1654e-06,
                    7.4921e-06,
                    7.8247e-06,
                    8.1631e-06,
                    8.5076e-06,
                    8.8582e-06,
                    9.2152e-06,
                    9.5787e-06,
                    9.9487e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Land_CH4": 0.94,
                "Land_CH4_timeseries": [
                    4.3447e-07,
                    8.6931e-07,
                    1.3045e-06,
                    1.7401e-06,
                    2.176e-06,
                    2.6123e-06,
                    3.049e-06,
                    3.486e-06,
                    3.9234e-06,
                    4.3611e-06,
                    4.806e-06,
                    5.2579e-06,
                    5.717e-06,
                    6.1831e-06,
                    6.6564e-06,
                    7.1367e-06,
                    7.6242e-06,
                    8.1188e-06,
                    8.6204e-06,
                    9.1292e-06,
                    9.6452e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015
                ],
                "Total_N2O": 0.61,
                "Total_N2O_timeseries": [
                    2.1187e-07,
                    4.2787e-07,
                    6.4783e-07,
                    8.7152e-07,
                    1.0986e-06,
                    1.3288e-06,
                    1.5615e-06,
                    1.7963e-06,
                    2.0327e-06,
                    2.27e-06,
                    2.5077e-06,
                    2.7458e-06,
                    2.9843e-06,
                    3.223e-06,
                    3.4619e-06,
                    3.7011e-06,
                    3.9405e-06,
                    4.1803e-06,
                    4.4205e-06,
                    4.6611e-06,
                    4.9058e-06,
                    5.1602e-06,
                    5.4289e-06,
                    5.715e-06,
                    6.0203e-06,
                    6.3452e-06,
                    6.6888e-06,
                    7.0488e-06,
                    7.4216e-06,
                    7.8022e-06,
                    8.1873e-06,
                    8.5761e-06,
                    8.9681e-06,
                    9.3629e-06,
                    9.7602e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Fossil_N2O": 0.16,
                "Fossil_N2O_timeseries": [
                    1.614e-08,
                    3.2501e-08,
                    4.9077e-08,
                    6.5861e-08,
                    8.2845e-08,
                    1.0002e-07,
                    1.1736e-07,
                    1.3487e-07,
                    1.5252e-07,
                    1.7029e-07,
                    1.8817e-07,
                    2.0616e-07,
                    2.2426e-07,
                    2.4247e-07,
                    2.6078e-07,
                    2.7919e-07,
                    2.9771e-07,
                    3.1634e-07,
                    3.3507e-07,
                    3.5392e-07,
                    3.7299e-07,
                    3.9244e-07,
                    4.1241e-07,
                    4.33e-07,
                    4.5426e-07,
                    4.7619e-07,
                    4.9878e-07,
                    5.2196e-07,
                    5.4561e-07,
                    5.696e-07,
                    5.9381e-07,
                    6.1823e-07,
                    6.4285e-07,
                    6.6764e-07,
                    6.9261e-07,
                    7.1774e-07,
                    7.4304e-07,
                    7.6851e-07,
                    7.9416e-07,
                    8.2072e-07,
                    8.4765e-07,
                    8.7497e-07,
                    9.027e-07,
                    9.3085e-07,
                    9.5944e-07,
                    9.8849e-07,
                    1.018e-06,
                    1.048e-06,
                    1.0786e-06,
                    1.1096e-06,
                    1.1413e-06,
                    1.1736e-06,
                    1.2066e-06,
                    1.2404e-06,
                    1.2749e-06,
                    1.3102e-06,
                    1.3462e-06,
                    1.3829e-06,
                    1.4202e-06,
                    1.4582e-06,
                    1.4966e-06,
                    1.5355e-06,
                    1.5748e-06,
                    1.6145e-06,
                    1.6547e-06,
                    1.6953e-06,
                    1.7362e-06,
                    1.7776e-06,
                    1.8195e-06,
                    1.8618e-06,
                    1.9045e-06,
                    1.9477e-06,
                    1.9913e-06,
                    2.0353e-06,
                    2.0798e-06,
                    2.1248e-06,
                    2.1703e-06,
                    2.2163e-06,
                    2.2628e-06,
                    2.3099e-06,
                    2.3577e-06,
                    2.4068e-06,
                    2.4574e-06,
                    2.5097e-06,
                    2.564e-06,
                    2.6205e-06,
                    2.6791e-06,
                    2.74e-06,
                    2.8031e-06,
                    2.8683e-06,
                    2.9358e-06,
                    3.0062e-06,
                    3.0799e-06,
                    3.157e-06,
                    3.2378e-06,
                    3.3224e-06,
                    3.4107e-06,
                    3.5025e-06,
                    3.5975e-06,
                    3.6954e-06,
                    3.796e-06,
                    3.8996e-06,
                    4.0063e-06,
                    4.1161e-06,
                    4.2292e-06,
                    4.3454e-06,
                    4.4647e-06,
                    4.587e-06,
                    4.712e-06,
                    4.8396e-06,
                    4.9699e-06,
                    5.1032e-06,
                    5.2401e-06,
                    5.3811e-06,
                    5.5268e-06,
                    5.6779e-06,
                    5.8349e-06,
                    5.9987e-06,
                    6.1699e-06,
                    6.3455e-06,
                    6.5226e-06,
                    6.707e-06,
                    6.9e-06,
                    7.1027e-06,
                    7.3194e-06,
                    7.5432e-06,
                    7.7761e-06,
                    8.016e-06,
                    8.2636e-06,
                    8.5185e-06,
                    8.7796e-06,
                    9.1176e-06,
                    9.5109e-06,
                    9.8836e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.79,
                "Land_N2O_timeseries": [
                    1.9573e-07,
                    3.9537e-07,
                    5.9875e-07,
                    8.0565e-07,
                    1.0158e-06,
                    1.2287e-06,
                    1.4441e-06,
                    1.6615e-06,
                    1.8802e-06,
                    2.0997e-06,
                    2.3195e-06,
                    2.5397e-06,
                    2.76e-06,
                    2.9805e-06,
                    3.2011e-06,
                    3.4219e-06,
                    3.6428e-06,
                    3.8639e-06,
                    4.0854e-06,
                    4.3072e-06,
                    4.5328e-06,
                    4.7678e-06,
                    5.0165e-06,
                    5.282e-06,
                    5.566e-06,
                    5.869e-06,
                    6.19e-06,
                    6.5268e-06,
                    6.876e-06,
                    7.2326e-06,
                    7.5935e-06,
                    7.9579e-06,
                    8.3253e-06,
                    8.6953e-06,
                    9.0676e-06,
                    9.442e-06,
                    9.8187e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                34.95957,
                                -11.57333
                            ],
                            [
                                35.40843,
                                -11.57048
                            ],
                            [
                                35.50577,
                                -11.57861
                            ],
                            [
                                35.65574,
                                -11.54713
                            ],
                            [
                                35.7142,
                                -11.47777
                            ],
                            [
                                35.77625,
                                -11.46742
                            ],
                            [
                                35.84445,
                                -11.41259
                            ],
                            [
                                35.93099,
                                -11.43782
                            ],
                            [
                                36.03904,
                                -11.49357
                            ],
                            [
                                36.18745,
                                -11.60282
                            ],
                            [
                                36.18375,
                                -11.66189
                            ],
                            [
                                36.21591,
                                -11.7063
                            ],
                            [
                                36.29572,
                                -11.72084
                            ],
                            [
                                36.47261,
                                -11.68032
                            ],
                            [
                                36.5752,
                                -11.70049
                            ],
                            [
                                36.62314,
                                -11.73459
                            ],
                            [
                                36.76904,
                                -11.6443
                            ],
                            [
                                36.80123,
                                -11.57653
                            ],
                            [
                                36.91644,
                                -11.60411
                            ],
                            [
                                36.98595,
                                -11.58063
                            ],
                            [
                                37.08509,
                                -11.62592
                            ],
                            [
                                37.22142,
                                -11.65426
                            ],
                            [
                                37.30109,
                                -11.64241
                            ],
                            [
                                37.33237,
                                -11.67502
                            ],
                            [
                                37.41747,
                                -11.68273
                            ],
                            [
                                37.49978,
                                -11.61553
                            ],
                            [
                                37.58309,
                                -11.62572
                            ],
                            [
                                37.65759,
                                -11.5776
                            ],
                            [
                                37.73362,
                                -11.55447
                            ],
                            [
                                37.78428,
                                -11.50797
                            ],
                            [
                                37.77867,
                                -11.45397
                            ],
                            [
                                37.82703,
                                -11.36992
                            ],
                            [
                                37.83167,
                                -11.31122
                            ],
                            [
                                37.94636,
                                -11.25961
                            ],
                            [
                                38.0628,
                                -11.27596
                            ],
                            [
                                38.11249,
                                -11.25699
                            ],
                            [
                                38.26845,
                                -11.29116
                            ],
                            [
                                38.36892,
                                -11.37646
                            ],
                            [
                                38.49042,
                                -11.4166
                            ],
                            [
                                38.63454,
                                -11.2881
                            ],
                            [
                                38.75183,
                                -11.27128
                            ],
                            [
                                38.88411,
                                -11.17176
                            ],
                            [
                                39.03335,
                                -11.16905
                            ],
                            [
                                39.12331,
                                -11.1441
                            ],
                            [
                                39.2404,
                                -11.17331
                            ],
                            [
                                39.33025,
                                -11.10242
                            ],
                            [
                                39.62063,
                                -10.94497
                            ],
                            [
                                39.80877,
                                -10.89971
                            ],
                            [
                                39.86709,
                                -10.84925
                            ],
                            [
                                40.00074,
                                -10.8091
                            ],
                            [
                                40.04252,
                                -10.76509
                            ],
                            [
                                40.20141,
                                -10.64481
                            ],
                            [
                                40.21484,
                                -10.61257
                            ],
                            [
                                40.29645,
                                -10.56759
                            ],
                            [
                                40.35826,
                                -10.57244
                            ],
                            [
                                40.39442,
                                -10.51072
                            ],
                            [
                                40.42571,
                                -10.46743
                            ],
                            [
                                40.3869,
                                -10.36218
                            ],
                            [
                                40.33232,
                                -10.35334
                            ],
                            [
                                40.29144,
                                -10.27383
                            ],
                            [
                                40.21741,
                                -10.29714
                            ],
                            [
                                40.18466,
                                -10.2576
                            ],
                            [
                                40.13529,
                                -10.26819
                            ],
                            [
                                40.11223,
                                -10.17062
                            ],
                            [
                                39.96976,
                                -10.12795
                            ],
                            [
                                39.9036,
                                -10.03997
                            ],
                            [
                                39.8099,
                                -9.98327
                            ],
                            [
                                39.78583,
                                -9.92322
                            ],
                            [
                                39.80319,
                                -9.82015
                            ],
                            [
                                39.76355,
                                -9.78027
                            ],
                            [
                                39.74557,
                                -9.65766
                            ],
                            [
                                39.69991,
                                -9.52453
                            ],
                            [
                                39.62572,
                                -9.42715
                            ],
                            [
                                39.64949,
                                -9.36839
                            ],
                            [
                                39.63375,
                                -9.17631
                            ],
                            [
                                39.57616,
                                -9.10881
                            ],
                            [
                                39.50158,
                                -9.06587
                            ],
                            [
                                39.47723,
                                -8.96086
                            ],
                            [
                                39.40654,
                                -8.94801
                            ],
                            [
                                39.37373,
                                -8.8657
                            ],
                            [
                                39.45724,
                                -8.86987
                            ],
                            [
                                39.49942,
                                -8.82507
                            ],
                            [
                                39.43225,
                                -8.74897
                            ],
                            [
                                39.36801,
                                -8.71772
                            ],
                            [
                                39.3629,
                                -8.62325
                            ],
                            [
                                39.31231,
                                -8.56533
                            ],
                            [
                                39.27801,
                                -8.44938
                            ],
                            [
                                39.28783,
                                -8.3797
                            ],
                            [
                                39.23746,
                                -8.27619
                            ],
                            [
                                39.25027,
                                -8.21157
                            ],
                            [
                                39.32971,
                                -8.16563
                            ],
                            [
                                39.36989,
                                -8.08562
                            ],
                            [
                                39.40564,
                                -7.96028
                            ],
                            [
                                39.36274,
                                -7.87898
                            ],
                            [
                                39.22036,
                                -7.86384
                            ],
                            [
                                39.27509,
                                -7.78148
                            ],
                            [
                                39.28589,
                                -7.71386
                            ],
                            [
                                39.2704,
                                -7.61034
                            ],
                            [
                                39.31591,
                                -7.44086
                            ],
                            [
                                39.3476,
                                -7.4021
                            ],
                            [
                                39.3282,
                                -7.34948
                            ],
                            [
                                39.42741,
                                -7.18605
                            ],
                            [
                                39.51351,
                                -7.17279
                            ],
                            [
                                39.54039,
                                -7.1145
                            ],
                            [
                                39.54923,
                                -7.01302
                            ],
                            [
                                39.47601,
                                -6.87038
                            ],
                            [
                                39.37103,
                                -6.85212
                            ],
                            [
                                39.28427,
                                -6.79173
                            ],
                            [
                                39.23921,
                                -6.73359
                            ],
                            [
                                39.21644,
                                -6.66221
                            ],
                            [
                                39.08068,
                                -6.51423
                            ],
                            [
                                38.92143,
                                -6.44914
                            ],
                            [
                                38.86426,
                                -6.38189
                            ],
                            [
                                38.84352,
                                -6.3061
                            ],
                            [
                                38.86135,
                                -6.17198
                            ],
                            [
                                38.78508,
                                -6.08014
                            ],
                            [
                                38.78243,
                                -6.02285
                            ],
                            [
                                38.81982,
                                -5.92777
                            ],
                            [
                                38.82675,
                                -5.83928
                            ],
                            [
                                38.89335,
                                -5.71285
                            ],
                            [
                                38.89892,
                                -5.65094
                            ],
                            [
                                38.96777,
                                -5.54872
                            ],
                            [
                                39.08382,
                                -5.23246
                            ],
                            [
                                39.09684,
                                -5.15081
                            ],
                            [
                                39.12947,
                                -5.10402
                            ],
                            [
                                39.10509,
                                -5.02921
                            ],
                            [
                                39.14299,
                                -5.00613
                            ],
                            [
                                39.12659,
                                -4.92767
                            ],
                            [
                                39.16668,
                                -4.83709
                            ],
                            [
                                39.16107,
                                -4.78213
                            ],
                            [
                                39.20421,
                                -4.67031
                            ],
                            [
                                38.51215,
                                -4.18596
                            ],
                            [
                                37.78617,
                                -3.67838
                            ],
                            [
                                37.74609,
                                -3.54487
                            ],
                            [
                                37.61847,
                                -3.47973
                            ],
                            [
                                37.58662,
                                -3.4383
                            ],
                            [
                                37.70959,
                                -3.30841
                            ],
                            [
                                37.67141,
                                -3.06522
                            ],
                            [
                                37.50997,
                                -2.95481
                            ],
                            [
                                35.16307,
                                -1.63338
                            ],
                            [
                                34.09884,
                                -1.03383
                            ],
                            [
                                34.02449,
                                -1.00041
                            ],
                            [
                                33.93398,
                                -0.99989
                            ],
                            [
                                32.98994,
                                -0.99989
                            ],
                            [
                                31.89442,
                                -0.9999
                            ],
                            [
                                31.37269,
                                -0.9999
                            ],
                            [
                                30.80464,
                                -0.9999
                            ],
                            [
                                30.76708,
                                -0.98489
                            ],
                            [
                                30.66346,
                                -1.05787
                            ],
                            [
                                30.5394,
                                -1.07485
                            ],
                            [
                                30.47352,
                                -1.05741
                            ],
                            [
                                30.45345,
                                -1.08165
                            ],
                            [
                                30.47696,
                                -1.16035
                            ],
                            [
                                30.50905,
                                -1.17143
                            ],
                            [
                                30.55108,
                                -1.25117
                            ],
                            [
                                30.56969,
                                -1.3367
                            ],
                            [
                                30.63235,
                                -1.39079
                            ],
                            [
                                30.68526,
                                -1.39837
                            ],
                            [
                                30.73804,
                                -1.44697
                            ],
                            [
                                30.74709,
                                -1.52119
                            ],
                            [
                                30.84476,
                                -1.65645
                            ],
                            [
                                30.82189,
                                -1.69789
                            ],
                            [
                                30.8314,
                                -1.81291
                            ],
                            [
                                30.80804,
                                -1.93745
                            ],
                            [
                                30.8993,
                                -2.07635
                            ],
                            [
                                30.84476,
                                -2.20581
                            ],
                            [
                                30.85272,
                                -2.32038
                            ],
                            [
                                30.77667,
                                -2.38804
                            ],
                            [
                                30.71464,
                                -2.35617
                            ],
                            [
                                30.65768,
                                -2.41264
                            ],
                            [
                                30.54325,
                                -2.41324
                            ],
                            [
                                30.48401,
                                -2.55638
                            ],
                            [
                                30.42046,
                                -2.66144
                            ],
                            [
                                30.45864,
                                -2.69121
                            ],
                            [
                                30.43892,
                                -2.80041
                            ],
                            [
                                30.40692,
                                -2.86059
                            ],
                            [
                                30.4847,
                                -2.94727
                            ],
                            [
                                30.56695,
                                -2.89639
                            ],
                            [
                                30.61855,
                                -2.92751
                            ],
                            [
                                30.66969,
                                -2.99311
                            ],
                            [
                                30.74677,
                                -2.99729
                            ],
                            [
                                30.83636,
                                -2.97661
                            ],
                            [
                                30.81408,
                                -3.04188
                            ],
                            [
                                30.84601,
                                -3.20588
                            ],
                            [
                                30.82795,
                                -3.26334
                            ],
                            [
                                30.66632,
                                -3.32063
                            ],
                            [
                                30.63497,
                                -3.36092
                            ],
                            [
                                30.67178,
                                -3.41854
                            ],
                            [
                                30.61965,
                                -3.46532
                            ],
                            [
                                30.49259,
                                -3.52
                            ],
                            [
                                30.44763,
                                -3.56552
                            ],
                            [
                                30.38914,
                                -3.71398
                            ],
                            [
                                30.30772,
                                -3.8455
                            ],
                            [
                                30.25852,
                                -3.88154
                            ],
                            [
                                30.1598,
                                -4.11251
                            ],
                            [
                                30.077,
                                -4.16929
                            ],
                            [
                                30.05317,
                                -4.2553
                            ],
                            [
                                29.95937,
                                -4.32712
                            ],
                            [
                                29.85201,
                                -4.38066
                            ],
                            [
                                29.8128,
                                -4.36554
                            ],
                            [
                                29.76829,
                                -4.45609
                            ],
                            [
                                29.67372,
                                -4.44806
                            ],
                            [
                                29.42333,
                                -4.4475
                            ],
                            [
                                29.42972,
                                -4.54507
                            ],
                            [
                                29.35875,
                                -4.72972
                            ],
                            [
                                29.34194,
                                -4.88389
                            ],
                            [
                                29.36305,
                                -4.99528
                            ],
                            [
                                29.41416,
                                -5.12528
                            ],
                            [
                                29.4543,
                                -5.17667
                            ],
                            [
                                29.53444,
                                -5.44806
                            ],
                            [
                                29.5975,
                                -5.57917
                            ],
                            [
                                29.63,
                                -5.75486
                            ],
                            [
                                29.60875,
                                -5.80722
                            ],
                            [
                                29.50472,
                                -5.94583
                            ],
                            [
                                29.49833,
                                -6.05639
                            ],
                            [
                                29.54083,
                                -6.26306
                            ],
                            [
                                29.70389,
                                -6.58639
                            ],
                            [
                                29.73916,
                                -6.63458
                            ],
                            [
                                29.88542,
                                -6.75083
                            ],
                            [
                                30.03715,
                                -6.82264
                            ],
                            [
                                30.18833,
                                -6.9625
                            ],
                            [
                                30.315,
                                -7.14375
                            ],
                            [
                                30.40944,
                                -7.36431
                            ],
                            [
                                30.43972,
                                -7.53
                            ],
                            [
                                30.50972,
                                -7.67945
                            ],
                            [
                                30.65055,
                                -7.88042
                            ],
                            [
                                30.70722,
                                -7.995
                            ],
                            [
                                30.77124,
                                -8.19225
                            ],
                            [
                                30.81151,
                                -8.31612
                            ],
                            [
                                31.00379,
                                -8.56807
                            ],
                            [
                                31.10272,
                                -8.62977
                            ],
                            [
                                31.15068,
                                -8.63016
                            ],
                            [
                                31.2121,
                                -8.58827
                            ],
                            [
                                31.29124,
                                -8.62953
                            ],
                            [
                                31.35033,
                                -8.61459
                            ],
                            [
                                31.45709,
                                -8.64098
                            ],
                            [
                                31.4897,
                                -8.68198
                            ],
                            [
                                31.56281,
                                -8.70175
                            ],
                            [
                                31.58671,
                                -8.83926
                            ],
                            [
                                31.68044,
                                -8.90986
                            ],
                            [
                                31.73645,
                                -8.92061
                            ],
                            [
                                31.81729,
                                -8.89046
                            ],
                            [
                                31.94435,
                                -8.93609
                            ],
                            [
                                31.93221,
                                -8.98083
                            ],
                            [
                                31.96256,
                                -9.05332
                            ],
                            [
                                31.99837,
                                -9.0751
                            ],
                            [
                                32.06195,
                                -9.05145
                            ],
                            [
                                32.16053,
                                -9.06223
                            ],
                            [
                                32.266,
                                -9.13312
                            ],
                            [
                                32.43142,
                                -9.11893
                            ],
                            [
                                32.54157,
                                -9.25393
                            ],
                            [
                                32.7457,
                                -9.28149
                            ],
                            [
                                32.76919,
                                -9.31743
                            ],
                            [
                                32.8657,
                                -9.37318
                            ],
                            [
                                32.95351,
                                -9.40145
                            ],
                            [
                                32.98994,
                                -9.36968
                            ],
                            [
                                33.07969,
                                -9.44916
                            ],
                            [
                                33.20915,
                                -9.50851
                            ],
                            [
                                33.32874,
                                -9.49141
                            ],
                            [
                                33.39148,
                                -9.53802
                            ],
                            [
                                33.4439,
                                -9.61393
                            ],
                            [
                                33.51878,
                                -9.62664
                            ],
                            [
                                33.58914,
                                -9.58122
                            ],
                            [
                                33.70158,
                                -9.61729
                            ],
                            [
                                33.76412,
                                -9.58301
                            ],
                            [
                                33.91932,
                                -9.70753
                            ],
                            [
                                33.96676,
                                -9.62634
                            ],
                            [
                                33.96506,
                                -9.52848
                            ],
                            [
                                34.01475,
                                -9.49499
                            ],
                            [
                                34.17516,
                                -9.6129
                            ],
                            [
                                34.30642,
                                -9.74114
                            ],
                            [
                                34.33863,
                                -9.79904
                            ],
                            [
                                34.50334,
                                -9.97931
                            ],
                            [
                                34.53642,
                                -10.04847
                            ],
                            [
                                34.51864,
                                -10.1
                            ],
                            [
                                34.55346,
                                -10.18431
                            ],
                            [
                                34.56677,
                                -10.26944
                            ],
                            [
                                34.54199,
                                -10.41337
                            ],
                            [
                                34.57472,
                                -10.46814
                            ],
                            [
                                34.55911,
                                -10.55587
                            ],
                            [
                                34.62419,
                                -10.67839
                            ],
                            [
                                34.65121,
                                -10.75888
                            ],
                            [
                                34.63853,
                                -10.94328
                            ],
                            [
                                34.6046,
                                -10.98912
                            ],
                            [
                                34.62879,
                                -11.10321
                            ],
                            [
                                34.72987,
                                -11.18973
                            ],
                            [
                                34.80464,
                                -11.32148
                            ],
                            [
                                34.88116,
                                -11.35459
                            ],
                            [
                                34.92526,
                                -11.4136
                            ],
                            [
                                34.95957,
                                -11.57333
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                39.52089,
                                -6.47088
                            ],
                            [
                                39.5772,
                                -6.38598
                            ],
                            [
                                39.54017,
                                -6.29009
                            ],
                            [
                                39.53118,
                                -6.18045
                            ],
                            [
                                39.42358,
                                -6.17963
                            ],
                            [
                                39.42953,
                                -6.06785
                            ],
                            [
                                39.36051,
                                -5.92846
                            ],
                            [
                                39.35504,
                                -5.79657
                            ],
                            [
                                39.29363,
                                -5.79099
                            ],
                            [
                                39.27364,
                                -5.86143
                            ],
                            [
                                39.18289,
                                -5.95388
                            ],
                            [
                                39.21153,
                                -6.13426
                            ],
                            [
                                39.19031,
                                -6.1637
                            ],
                            [
                                39.21579,
                                -6.24736
                            ],
                            [
                                39.27212,
                                -6.31211
                            ],
                            [
                                39.31399,
                                -6.24399
                            ],
                            [
                                39.38002,
                                -6.32797
                            ],
                            [
                                39.42889,
                                -6.34327
                            ],
                            [
                                39.46706,
                                -6.44663
                            ],
                            [
                                39.52089,
                                -6.47088
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                39.85679,
                                -5.1673
                            ],
                            [
                                39.82264,
                                -5.1481
                            ],
                            [
                                39.83415,
                                -5.04194
                            ],
                            [
                                39.87404,
                                -4.9944
                            ],
                            [
                                39.86878,
                                -4.942
                            ],
                            [
                                39.80403,
                                -4.96219
                            ],
                            [
                                39.73832,
                                -4.90768
                            ],
                            [
                                39.67063,
                                -4.94156
                            ],
                            [
                                39.70658,
                                -5.05345
                            ],
                            [
                                39.69109,
                                -5.13285
                            ],
                            [
                                39.74259,
                                -5.17931
                            ],
                            [
                                39.71103,
                                -5.24915
                            ],
                            [
                                39.66638,
                                -5.28535
                            ],
                            [
                                39.63355,
                                -5.39998
                            ],
                            [
                                39.70631,
                                -5.45316
                            ],
                            [
                                39.7561,
                                -5.4394
                            ],
                            [
                                39.80718,
                                -5.35114
                            ],
                            [
                                39.85679,
                                -5.1673
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                39.59013,
                                -7.94558
                            ],
                            [
                                39.68719,
                                -7.99424
                            ],
                            [
                                39.78388,
                                -7.90067
                            ],
                            [
                                39.83322,
                                -7.91309
                            ],
                            [
                                39.89592,
                                -7.7624
                            ],
                            [
                                39.8469,
                                -7.73399
                            ],
                            [
                                39.80647,
                                -7.75519
                            ],
                            [
                                39.66691,
                                -7.9055
                            ],
                            [
                                39.59013,
                                -7.94558
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "THA",
                "Country": "Thailand",
                "Total_3GHG": 0.88,
                "Total_3GHG_timeseries": [
                    9.8477e-06,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0055,
                    0.0057,
                    0.0059,
                    0.0061,
                    0.0062,
                    0.0064,
                    0.0066,
                    0.0068,
                    0.0069,
                    0.0071,
                    0.0073,
                    0.0074,
                    0.0075,
                    0.0077,
                    0.0079,
                    0.008,
                    0.0082,
                    0.0083,
                    0.0085,
                    0.0086,
                    0.0088,
                    0.0089,
                    0.0091,
                    0.0093,
                    0.0094,
                    0.0095,
                    0.0097,
                    0.0098,
                    0.01,
                    0.0101,
                    0.0102,
                    0.0104,
                    0.0105,
                    0.0107,
                    0.0108,
                    0.011,
                    0.0112,
                    0.0114,
                    0.0117,
                    0.0119,
                    0.0122,
                    0.0124,
                    0.0126,
                    0.0129,
                    0.0131,
                    0.0133,
                    0.0135,
                    0.0137,
                    0.0139,
                    0.0141,
                    0.0143,
                    0.0144
                ],
                "Fossil_3GHG": 0.56,
                "Fossil_3GHG_timeseries": [
                    5.4072e-07,
                    1.0777e-06,
                    1.6109e-06,
                    2.1403e-06,
                    2.6659e-06,
                    3.1876e-06,
                    3.7055e-06,
                    4.2195e-06,
                    4.7295e-06,
                    5.2355e-06,
                    5.7359e-06,
                    6.2309e-06,
                    6.7204e-06,
                    7.2044e-06,
                    7.6829e-06,
                    8.1559e-06,
                    8.6234e-06,
                    9.0855e-06,
                    9.5421e-06,
                    9.9959e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.003,
                    0.0031,
                    0.0033,
                    0.0034,
                    0.0036,
                    0.0037,
                    0.0039,
                    0.0041,
                    0.0042,
                    0.0044,
                    0.0046,
                    0.0048,
                    0.005,
                    0.0052,
                    0.0053,
                    0.0055,
                    0.0056,
                    0.0058,
                    0.0059
                ],
                "Land_3GHG": 1.48,
                "Land_3GHG_timeseries": [
                    9.307e-06,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.0051,
                    0.0053,
                    0.0054,
                    0.0055,
                    0.0057,
                    0.0058,
                    0.006,
                    0.0061,
                    0.0062,
                    0.0063,
                    0.0064,
                    0.0065,
                    0.0067,
                    0.0068,
                    0.0069,
                    0.007,
                    0.0071,
                    0.0072,
                    0.0072,
                    0.0073,
                    0.0074,
                    0.0074,
                    0.0075,
                    0.0075,
                    0.0076,
                    0.0076,
                    0.0076,
                    0.0076,
                    0.0076,
                    0.0077,
                    0.0077,
                    0.0077,
                    0.0077,
                    0.0077,
                    0.0077,
                    0.0078,
                    0.0079,
                    0.0079,
                    0.008,
                    0.0081,
                    0.0082,
                    0.0082,
                    0.0083,
                    0.0083,
                    0.0083,
                    0.0084,
                    0.0084,
                    0.0084,
                    0.0084,
                    0.0085,
                    0.0085
                ],
                "Total_CO2": 0.79,
                "Total_CO2_timeseries": [
                    6.5547e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0055,
                    0.0055,
                    0.0056,
                    0.0057,
                    0.0058,
                    0.0059,
                    0.006,
                    0.0061,
                    0.0061,
                    0.0062,
                    0.0063,
                    0.0064,
                    0.0065,
                    0.0066,
                    0.0068,
                    0.0069,
                    0.0071,
                    0.0072,
                    0.0074,
                    0.0075,
                    0.0077,
                    0.0079,
                    0.008,
                    0.0082,
                    0.0083,
                    0.0084,
                    0.0086,
                    0.0087,
                    0.0088,
                    0.009
                ],
                "Fossil_CO2": 0.45,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.3093e-08,
                    2.4549e-08,
                    3.4369e-08,
                    4.5825e-08,
                    5.7282e-08,
                    7.0374e-08,
                    8.6741e-08,
                    1.0474e-07,
                    1.2602e-07,
                    1.5221e-07,
                    1.7839e-07,
                    1.7839e-07,
                    1.9312e-07,
                    1.9967e-07,
                    1.9967e-07,
                    1.9967e-07,
                    2.1276e-07,
                    2.3076e-07,
                    2.5859e-07,
                    6.8893e-07,
                    1.1801e-06,
                    1.7555e-06,
                    2.4958e-06,
                    3.4191e-06,
                    4.4876e-06,
                    5.6666e-06,
                    6.9826e-06,
                    8.3414e-06,
                    9.837e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0033,
                    0.0034,
                    0.0035
                ],
                "Land_CO2": 1.52,
                "Land_CO2_timeseries": [
                    6.5547e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0047,
                    0.0048,
                    0.0048,
                    0.0048,
                    0.0049,
                    0.0049,
                    0.0049,
                    0.0049,
                    0.0049,
                    0.005,
                    0.005,
                    0.005,
                    0.005,
                    0.005,
                    0.005,
                    0.005,
                    0.005,
                    0.005,
                    0.005,
                    0.005,
                    0.0051,
                    0.0051,
                    0.0052,
                    0.0052,
                    0.0053,
                    0.0053,
                    0.0054,
                    0.0054,
                    0.0054,
                    0.0054,
                    0.0054,
                    0.0054,
                    0.0054,
                    0.0055,
                    0.0055
                ],
                "Total_CH4": 1.19,
                "Total_CH4_timeseries": [
                    3.1443e-06,
                    6.2621e-06,
                    9.3535e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.004,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0048,
                    0.0048,
                    0.0049,
                    0.0049,
                    0.005
                ],
                "Fossil_CH4": 0.9,
                "Fossil_CH4_timeseries": [
                    4.869e-07,
                    9.693e-07,
                    1.4472e-06,
                    1.9207e-06,
                    2.3896e-06,
                    2.8541e-06,
                    3.3142e-06,
                    3.7698e-06,
                    4.221e-06,
                    4.6677e-06,
                    5.1086e-06,
                    5.5436e-06,
                    5.9727e-06,
                    6.3959e-06,
                    6.8134e-06,
                    7.2249e-06,
                    7.6307e-06,
                    8.0306e-06,
                    8.4248e-06,
                    8.8157e-06,
                    9.2141e-06,
                    9.6199e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023
                ],
                "Land_CH4": 1.68,
                "Land_CH4_timeseries": [
                    2.6574e-06,
                    5.2928e-06,
                    7.9063e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026
                ],
                "Total_N2O": 0.63,
                "Total_N2O_timeseries": [
                    1.4873e-07,
                    3.0009e-07,
                    4.5398e-07,
                    6.1026e-07,
                    7.6876e-07,
                    9.2928e-07,
                    1.0915e-06,
                    1.2553e-06,
                    1.4202e-06,
                    1.5859e-06,
                    1.7521e-06,
                    1.9188e-06,
                    2.086e-06,
                    2.2537e-06,
                    2.4217e-06,
                    2.5902e-06,
                    2.7591e-06,
                    2.9284e-06,
                    3.0983e-06,
                    3.2687e-06,
                    3.4417e-06,
                    3.6205e-06,
                    3.8077e-06,
                    4.005e-06,
                    4.2135e-06,
                    4.4335e-06,
                    4.6643e-06,
                    4.9047e-06,
                    5.1526e-06,
                    5.4053e-06,
                    5.6607e-06,
                    5.9186e-06,
                    6.1786e-06,
                    6.4404e-06,
                    6.7039e-06,
                    6.969e-06,
                    7.2357e-06,
                    7.5042e-06,
                    7.7744e-06,
                    8.0659e-06,
                    8.3602e-06,
                    8.6581e-06,
                    8.9604e-06,
                    9.2677e-06,
                    9.5807e-06,
                    9.8998e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Fossil_N2O": 0.55,
                "Fossil_N2O_timeseries": [
                    5.3826e-08,
                    1.0838e-07,
                    1.6365e-07,
                    2.1961e-07,
                    2.7623e-07,
                    3.3347e-07,
                    3.913e-07,
                    4.4966e-07,
                    5.085e-07,
                    5.6775e-07,
                    6.2738e-07,
                    6.8737e-07,
                    7.4773e-07,
                    8.0844e-07,
                    8.6951e-07,
                    9.3092e-07,
                    9.927e-07,
                    1.0548e-06,
                    1.1173e-06,
                    1.1802e-06,
                    1.2438e-06,
                    1.3087e-06,
                    1.3753e-06,
                    1.4439e-06,
                    1.5147e-06,
                    1.5877e-06,
                    1.6628e-06,
                    1.7399e-06,
                    1.8185e-06,
                    1.8983e-06,
                    1.9787e-06,
                    2.0599e-06,
                    2.1418e-06,
                    2.2242e-06,
                    2.3072e-06,
                    2.3907e-06,
                    2.4748e-06,
                    2.5595e-06,
                    2.6447e-06,
                    2.7322e-06,
                    2.8206e-06,
                    2.9101e-06,
                    3.0006e-06,
                    3.0924e-06,
                    3.1853e-06,
                    3.2794e-06,
                    3.3749e-06,
                    3.4716e-06,
                    3.5698e-06,
                    3.6694e-06,
                    3.7705e-06,
                    3.8735e-06,
                    3.9783e-06,
                    4.0851e-06,
                    4.194e-06,
                    4.305e-06,
                    4.4181e-06,
                    4.5332e-06,
                    4.6503e-06,
                    4.7691e-06,
                    4.8896e-06,
                    5.0117e-06,
                    5.1353e-06,
                    5.2604e-06,
                    5.3869e-06,
                    5.5149e-06,
                    5.6444e-06,
                    5.7756e-06,
                    5.9084e-06,
                    6.043e-06,
                    6.1797e-06,
                    6.3188e-06,
                    6.4605e-06,
                    6.605e-06,
                    6.7524e-06,
                    6.9028e-06,
                    7.0563e-06,
                    7.2127e-06,
                    7.372e-06,
                    7.534e-06,
                    7.6987e-06,
                    7.8664e-06,
                    8.0371e-06,
                    8.211e-06,
                    8.388e-06,
                    8.568e-06,
                    8.7509e-06,
                    8.9362e-06,
                    9.1238e-06,
                    9.3132e-06,
                    9.5044e-06,
                    9.6981e-06,
                    9.8948e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_N2O": 0.66,
                "Land_N2O_timeseries": [
                    9.4905e-08,
                    1.9171e-07,
                    2.9033e-07,
                    3.9065e-07,
                    4.9253e-07,
                    5.958e-07,
                    7.0025e-07,
                    8.0563e-07,
                    9.1168e-07,
                    1.0181e-06,
                    1.1247e-06,
                    1.2315e-06,
                    1.3383e-06,
                    1.4452e-06,
                    1.5522e-06,
                    1.6592e-06,
                    1.7664e-06,
                    1.8736e-06,
                    1.981e-06,
                    2.0885e-06,
                    2.1979e-06,
                    2.3118e-06,
                    2.4324e-06,
                    2.5612e-06,
                    2.6989e-06,
                    2.8458e-06,
                    3.0014e-06,
                    3.1648e-06,
                    3.3341e-06,
                    3.507e-06,
                    3.682e-06,
                    3.8587e-06,
                    4.0368e-06,
                    4.2162e-06,
                    4.3968e-06,
                    4.5783e-06,
                    4.7609e-06,
                    4.9447e-06,
                    5.1297e-06,
                    5.3337e-06,
                    5.5396e-06,
                    5.748e-06,
                    5.9598e-06,
                    6.1754e-06,
                    6.3954e-06,
                    6.6203e-06,
                    6.8505e-06,
                    7.0864e-06,
                    7.3281e-06,
                    7.5758e-06,
                    7.8301e-06,
                    8.0915e-06,
                    8.361e-06,
                    8.6393e-06,
                    8.9273e-06,
                    9.2258e-06,
                    9.5359e-06,
                    9.8583e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                100.12125,
                                6.42171
                            ],
                            [
                                100.16057,
                                6.48959
                            ],
                            [
                                100.18313,
                                6.57676
                            ],
                            [
                                100.17679,
                                6.6957
                            ],
                            [
                                100.29058,
                                6.7059
                            ],
                            [
                                100.323,
                                6.65728
                            ],
                            [
                                100.30971,
                                6.60752
                            ],
                            [
                                100.36569,
                                6.54264
                            ],
                            [
                                100.48868,
                                6.52447
                            ],
                            [
                                100.6542,
                                6.44548
                            ],
                            [
                                100.7089,
                                6.47257
                            ],
                            [
                                100.81609,
                                6.43634
                            ],
                            [
                                100.83731,
                                6.28983
                            ],
                            [
                                100.90084,
                                6.23607
                            ],
                            [
                                100.97711,
                                6.27856
                            ],
                            [
                                101.0198,
                                6.24796
                            ],
                            [
                                101.10758,
                                6.25109
                            ],
                            [
                                101.12139,
                                6.19324
                            ],
                            [
                                101.08041,
                                6.17253
                            ],
                            [
                                101.12735,
                                6.09663
                            ],
                            [
                                101.10338,
                                6.04995
                            ],
                            [
                                101.12133,
                                5.97487
                            ],
                            [
                                101.08872,
                                5.91418
                            ],
                            [
                                101.03095,
                                5.91247
                            ],
                            [
                                100.98834,
                                5.80205
                            ],
                            [
                                101.12105,
                                5.66937
                            ],
                            [
                                101.14496,
                                5.61571
                            ],
                            [
                                101.26024,
                                5.71289
                            ],
                            [
                                101.26877,
                                5.80171
                            ],
                            [
                                101.34362,
                                5.80852
                            ],
                            [
                                101.39657,
                                5.871
                            ],
                            [
                                101.48622,
                                5.87045
                            ],
                            [
                                101.58037,
                                5.93153
                            ],
                            [
                                101.65911,
                                5.87163
                            ],
                            [
                                101.67007,
                                5.79047
                            ],
                            [
                                101.75711,
                                5.79447
                            ],
                            [
                                101.81776,
                                5.73255
                            ],
                            [
                                101.83641,
                                5.78769
                            ],
                            [
                                101.94256,
                                5.87469
                            ],
                            [
                                101.92259,
                                5.91508
                            ],
                            [
                                101.94477,
                                5.98457
                            ],
                            [
                                102.0544,
                                6.08168
                            ],
                            [
                                102.09104,
                                6.14494
                            ],
                            [
                                102.09102,
                                6.24087
                            ],
                            [
                                101.95121,
                                6.33994
                            ],
                            [
                                101.87517,
                                6.42315
                            ],
                            [
                                101.80787,
                                6.46248
                            ],
                            [
                                101.62723,
                                6.72582
                            ],
                            [
                                101.55806,
                                6.84304
                            ],
                            [
                                101.38159,
                                6.89646
                            ],
                            [
                                101.33058,
                                6.87528
                            ],
                            [
                                101.26389,
                                6.90144
                            ],
                            [
                                101.16291,
                                6.86075
                            ],
                            [
                                101.02866,
                                6.85381
                            ],
                            [
                                100.92221,
                                6.89885
                            ],
                            [
                                100.85105,
                                6.95972
                            ],
                            [
                                100.81221,
                                6.95472
                            ],
                            [
                                100.74608,
                                7.00563
                            ],
                            [
                                100.59855,
                                7.21206
                            ],
                            [
                                100.53914,
                                7.26755
                            ],
                            [
                                100.4877,
                                7.3603
                            ],
                            [
                                100.43394,
                                7.51581
                            ],
                            [
                                100.33387,
                                7.94296
                            ],
                            [
                                100.2988,
                                8.15359
                            ],
                            [
                                100.25167,
                                8.34034
                            ],
                            [
                                100.21165,
                                8.44697
                            ],
                            [
                                100.16875,
                                8.50244
                            ],
                            [
                                100.14015,
                                8.3891
                            ],
                            [
                                100.08733,
                                8.41628
                            ],
                            [
                                100.04643,
                                8.51623
                            ],
                            [
                                99.95344,
                                8.63
                            ],
                            [
                                99.91765,
                                8.88887
                            ],
                            [
                                99.91093,
                                9.08622
                            ],
                            [
                                99.87797,
                                9.136
                            ],
                            [
                                99.87703,
                                9.21865
                            ],
                            [
                                99.83524,
                                9.30259
                            ],
                            [
                                99.74313,
                                9.32294
                            ],
                            [
                                99.64139,
                                9.29977
                            ],
                            [
                                99.60921,
                                9.26929
                            ],
                            [
                                99.52914,
                                9.2824
                            ],
                            [
                                99.46339,
                                9.2003
                            ],
                            [
                                99.37199,
                                9.19224
                            ],
                            [
                                99.3073,
                                9.23648
                            ],
                            [
                                99.22581,
                                9.25734
                            ],
                            [
                                99.21976,
                                9.3347
                            ],
                            [
                                99.30173,
                                9.40916
                            ],
                            [
                                99.26327,
                                9.44967
                            ],
                            [
                                99.16421,
                                9.67467
                            ],
                            [
                                99.13914,
                                9.80512
                            ],
                            [
                                99.16423,
                                9.86
                            ],
                            [
                                99.15141,
                                9.98914
                            ],
                            [
                                99.18124,
                                10.03878
                            ],
                            [
                                99.14911,
                                10.12497
                            ],
                            [
                                99.22118,
                                10.22844
                            ],
                            [
                                99.15276,
                                10.30233
                            ],
                            [
                                99.16456,
                                10.3631
                            ],
                            [
                                99.23828,
                                10.34706
                            ],
                            [
                                99.28135,
                                10.41157
                            ],
                            [
                                99.22899,
                                10.47372
                            ],
                            [
                                99.27387,
                                10.54526
                            ],
                            [
                                99.32007,
                                10.66904
                            ],
                            [
                                99.38082,
                                10.71105
                            ],
                            [
                                99.44105,
                                10.86756
                            ],
                            [
                                99.51752,
                                10.89926
                            ],
                            [
                                99.49111,
                                10.9436
                            ],
                            [
                                99.50166,
                                11.03836
                            ],
                            [
                                99.48752,
                                11.11164
                            ],
                            [
                                99.50508,
                                11.17681
                            ],
                            [
                                99.54425,
                                11.2066
                            ],
                            [
                                99.55452,
                                11.31381
                            ],
                            [
                                99.64046,
                                11.52055
                            ],
                            [
                                99.74592,
                                11.7047
                            ],
                            [
                                99.78719,
                                11.74126
                            ],
                            [
                                99.80102,
                                11.81736
                            ],
                            [
                                99.83389,
                                11.83755
                            ],
                            [
                                99.81889,
                                11.90738
                            ],
                            [
                                99.85965,
                                11.98735
                            ],
                            [
                                100.01752,
                                12.18723
                            ],
                            [
                                99.97486,
                                12.27609
                            ],
                            [
                                100.00038,
                                12.33546
                            ],
                            [
                                99.98046,
                                12.43031
                            ],
                            [
                                99.95625,
                                12.64121
                            ],
                            [
                                99.96682,
                                12.7398
                            ],
                            [
                                100.05067,
                                12.98254
                            ],
                            [
                                100.10015,
                                13.0527
                            ],
                            [
                                100.06686,
                                13.08247
                            ],
                            [
                                100.06841,
                                13.14948
                            ],
                            [
                                99.94741,
                                13.26556
                            ],
                            [
                                100.05976,
                                13.41616
                            ],
                            [
                                100.25841,
                                13.48021
                            ],
                            [
                                100.56297,
                                13.51359
                            ],
                            [
                                100.61685,
                                13.53175
                            ],
                            [
                                100.68124,
                                13.50688
                            ],
                            [
                                100.94095,
                                13.46359
                            ],
                            [
                                100.98359,
                                13.38567
                            ],
                            [
                                100.90082,
                                13.30621
                            ],
                            [
                                100.93531,
                                13.20472
                            ],
                            [
                                100.88021,
                                13.10768
                            ],
                            [
                                100.92641,
                                13.00817
                            ],
                            [
                                100.85777,
                                12.91332
                            ],
                            [
                                100.89698,
                                12.85681
                            ],
                            [
                                100.90276,
                                12.77961
                            ],
                            [
                                100.83567,
                                12.73283
                            ],
                            [
                                100.84283,
                                12.67717
                            ],
                            [
                                100.97986,
                                12.65076
                            ],
                            [
                                101.07101,
                                12.67421
                            ],
                            [
                                101.22961,
                                12.66526
                            ],
                            [
                                101.36881,
                                12.61852
                            ],
                            [
                                101.55398,
                                12.62835
                            ],
                            [
                                101.64275,
                                12.64515
                            ],
                            [
                                101.67515,
                                12.6837
                            ],
                            [
                                101.75818,
                                12.70513
                            ],
                            [
                                101.85704,
                                12.64649
                            ],
                            [
                                101.93029,
                                12.53796
                            ],
                            [
                                102.01886,
                                12.52223
                            ],
                            [
                                102.04698,
                                12.47441
                            ],
                            [
                                102.10357,
                                12.45144
                            ],
                            [
                                102.26127,
                                12.30499
                            ],
                            [
                                102.28644,
                                12.23307
                            ],
                            [
                                102.56161,
                                12.09804
                            ],
                            [
                                102.56353,
                                12.18672
                            ],
                            [
                                102.63057,
                                12.1465
                            ],
                            [
                                102.76344,
                                12.02567
                            ],
                            [
                                102.78535,
                                11.89597
                            ],
                            [
                                102.86955,
                                11.78928
                            ],
                            [
                                102.90503,
                                11.71475
                            ],
                            [
                                102.91095,
                                11.64721
                            ],
                            [
                                102.91619,
                                11.74686
                            ],
                            [
                                102.85233,
                                11.8308
                            ],
                            [
                                102.78416,
                                11.98159
                            ],
                            [
                                102.77978,
                                12.05071
                            ],
                            [
                                102.71646,
                                12.16918
                            ],
                            [
                                102.74431,
                                12.3657
                            ],
                            [
                                102.79214,
                                12.40969
                            ],
                            [
                                102.78066,
                                12.4577
                            ],
                            [
                                102.67524,
                                12.55083
                            ],
                            [
                                102.64148,
                                12.60353
                            ],
                            [
                                102.50715,
                                12.69299
                            ],
                            [
                                102.54302,
                                12.81103
                            ],
                            [
                                102.48802,
                                12.97509
                            ],
                            [
                                102.51536,
                                13.0038
                            ],
                            [
                                102.44387,
                                13.08247
                            ],
                            [
                                102.39674,
                                13.1678
                            ],
                            [
                                102.35343,
                                13.29287
                            ],
                            [
                                102.37238,
                                13.57328
                            ],
                            [
                                102.53492,
                                13.56345
                            ],
                            [
                                102.59102,
                                13.59911
                            ],
                            [
                                102.56372,
                                13.66925
                            ],
                            [
                                102.72426,
                                13.76246
                            ],
                            [
                                102.79289,
                                13.92902
                            ],
                            [
                                102.91163,
                                14.01798
                            ],
                            [
                                102.90747,
                                14.08235
                            ],
                            [
                                102.96359,
                                14.2007
                            ],
                            [
                                103.02002,
                                14.22457
                            ],
                            [
                                103.0753,
                                14.28177
                            ],
                            [
                                103.18259,
                                14.32818
                            ],
                            [
                                103.46775,
                                14.36311
                            ],
                            [
                                103.56159,
                                14.41918
                            ],
                            [
                                103.61902,
                                14.39874
                            ],
                            [
                                103.70398,
                                14.43028
                            ],
                            [
                                103.71345,
                                14.37871
                            ],
                            [
                                103.85017,
                                14.36704
                            ],
                            [
                                103.92758,
                                14.32763
                            ],
                            [
                                104.0268,
                                14.33361
                            ],
                            [
                                104.11747,
                                14.37042
                            ],
                            [
                                104.17199,
                                14.35234
                            ],
                            [
                                104.19906,
                                14.39579
                            ],
                            [
                                104.33637,
                                14.36569
                            ],
                            [
                                104.39825,
                                14.37037
                            ],
                            [
                                104.4733,
                                14.34449
                            ],
                            [
                                104.5125,
                                14.36904
                            ],
                            [
                                104.58019,
                                14.35688
                            ],
                            [
                                104.64621,
                                14.41978
                            ],
                            [
                                104.73667,
                                14.40098
                            ],
                            [
                                104.80445,
                                14.43315
                            ],
                            [
                                105.00001,
                                14.36688
                            ],
                            [
                                104.99806,
                                14.30874
                            ],
                            [
                                105.0302,
                                14.23411
                            ],
                            [
                                105.09906,
                                14.20857
                            ],
                            [
                                105.13595,
                                14.22596
                            ],
                            [
                                105.20007,
                                14.34271
                            ],
                            [
                                105.35724,
                                14.37546
                            ],
                            [
                                105.43267,
                                14.41673
                            ],
                            [
                                105.53782,
                                14.55535
                            ],
                            [
                                105.52496,
                                14.79826
                            ],
                            [
                                105.589,
                                14.94114
                            ],
                            [
                                105.52565,
                                15.07018
                            ],
                            [
                                105.4866,
                                15.09909
                            ],
                            [
                                105.4718,
                                15.16386
                            ],
                            [
                                105.53362,
                                15.24326
                            ],
                            [
                                105.59485,
                                15.27379
                            ],
                            [
                                105.57299,
                                15.32538
                            ],
                            [
                                105.50589,
                                15.31893
                            ],
                            [
                                105.50126,
                                15.39167
                            ],
                            [
                                105.59226,
                                15.42916
                            ],
                            [
                                105.59283,
                                15.51064
                            ],
                            [
                                105.63584,
                                15.63654
                            ],
                            [
                                105.59765,
                                15.72236
                            ],
                            [
                                105.50319,
                                15.76612
                            ],
                            [
                                105.44342,
                                15.75044
                            ],
                            [
                                105.3905,
                                15.80514
                            ],
                            [
                                105.3403,
                                15.92078
                            ],
                            [
                                105.41718,
                                16.01157
                            ],
                            [
                                105.20542,
                                16.05179
                            ],
                            [
                                105.04804,
                                16.10274
                            ],
                            [
                                105.01304,
                                16.18908
                            ],
                            [
                                105.01736,
                                16.23359
                            ],
                            [
                                104.88947,
                                16.35734
                            ],
                            [
                                104.83919,
                                16.45871
                            ],
                            [
                                104.74015,
                                16.53038
                            ],
                            [
                                104.75938,
                                16.69565
                            ],
                            [
                                104.73914,
                                16.80507
                            ],
                            [
                                104.76136,
                                16.84266
                            ],
                            [
                                104.73488,
                                16.90708
                            ],
                            [
                                104.72937,
                                17.00752
                            ],
                            [
                                104.80362,
                                17.2026
                            ],
                            [
                                104.79679,
                                17.3973
                            ],
                            [
                                104.69929,
                                17.52945
                            ],
                            [
                                104.47803,
                                17.64655
                            ],
                            [
                                104.34044,
                                17.83557
                            ],
                            [
                                104.2768,
                                17.86099
                            ],
                            [
                                104.22606,
                                17.97917
                            ],
                            [
                                104.11047,
                                18.10891
                            ],
                            [
                                104.06032,
                                18.2212
                            ],
                            [
                                103.98491,
                                18.32601
                            ],
                            [
                                103.92443,
                                18.32843
                            ],
                            [
                                103.85823,
                                18.28478
                            ],
                            [
                                103.83593,
                                18.32385
                            ],
                            [
                                103.69806,
                                18.34383
                            ],
                            [
                                103.62685,
                                18.39366
                            ],
                            [
                                103.40985,
                                18.44801
                            ],
                            [
                                103.30843,
                                18.43243
                            ],
                            [
                                103.24353,
                                18.36048
                            ],
                            [
                                103.27875,
                                18.29426
                            ],
                            [
                                103.18417,
                                18.26627
                            ],
                            [
                                103.13277,
                                18.16069
                            ],
                            [
                                103.0823,
                                18.12937
                            ],
                            [
                                103.07898,
                                18.04005
                            ],
                            [
                                103.01767,
                                17.97337
                            ],
                            [
                                102.95328,
                                18.00443
                            ],
                            [
                                102.85591,
                                17.97087
                            ],
                            [
                                102.76826,
                                17.90365
                            ],
                            [
                                102.70161,
                                17.87679
                            ],
                            [
                                102.67701,
                                17.80443
                            ],
                            [
                                102.59848,
                                17.83541
                            ],
                            [
                                102.59974,
                                17.95722
                            ],
                            [
                                102.46756,
                                17.96874
                            ],
                            [
                                102.345,
                                18.04517
                            ],
                            [
                                102.2953,
                                18.05206
                            ],
                            [
                                102.1889,
                                18.14644
                            ],
                            [
                                102.16125,
                                18.20209
                            ],
                            [
                                102.09554,
                                18.21433
                            ],
                            [
                                101.94653,
                                18.08823
                            ],
                            [
                                101.90601,
                                18.03197
                            ],
                            [
                                101.78009,
                                18.0647
                            ],
                            [
                                101.73163,
                                17.92433
                            ],
                            [
                                101.61786,
                                17.89237
                            ],
                            [
                                101.5537,
                                17.82356
                            ],
                            [
                                101.55157,
                                17.78728
                            ],
                            [
                                101.46682,
                                17.75426
                            ],
                            [
                                101.40913,
                                17.70203
                            ],
                            [
                                101.30952,
                                17.64996
                            ],
                            [
                                101.22789,
                                17.53709
                            ],
                            [
                                101.17838,
                                17.52492
                            ],
                            [
                                101.16033,
                                17.46907
                            ],
                            [
                                101.06565,
                                17.51196
                            ],
                            [
                                100.96914,
                                17.59037
                            ],
                            [
                                101.02983,
                                17.67655
                            ],
                            [
                                100.9786,
                                17.75432
                            ],
                            [
                                100.99539,
                                17.80849
                            ],
                            [
                                101.08658,
                                17.8459
                            ],
                            [
                                101.12078,
                                17.89862
                            ],
                            [
                                101.11979,
                                17.99565
                            ],
                            [
                                101.18475,
                                18.06578
                            ],
                            [
                                101.16072,
                                18.12874
                            ],
                            [
                                101.18906,
                                18.19617
                            ],
                            [
                                101.14853,
                                18.26238
                            ],
                            [
                                101.17783,
                                18.33349
                            ],
                            [
                                101.09153,
                                18.37897
                            ],
                            [
                                101.05364,
                                18.44351
                            ],
                            [
                                101.10243,
                                18.5205
                            ],
                            [
                                101.18331,
                                18.57791
                            ],
                            [
                                101.2569,
                                18.67745
                            ],
                            [
                                101.22415,
                                18.72771
                            ],
                            [
                                101.24965,
                                18.78068
                            ],
                            [
                                101.24569,
                                18.88997
                            ],
                            [
                                101.29305,
                                18.93865
                            ],
                            [
                                101.30884,
                                19.00042
                            ],
                            [
                                101.35389,
                                19.04827
                            ],
                            [
                                101.25607,
                                19.13057
                            ],
                            [
                                101.25787,
                                19.22954
                            ],
                            [
                                101.20538,
                                19.35136
                            ],
                            [
                                101.21279,
                                19.46544
                            ],
                            [
                                101.26387,
                                19.4648
                            ],
                            [
                                101.28614,
                                19.57016
                            ],
                            [
                                101.2414,
                                19.60283
                            ],
                            [
                                101.12264,
                                19.57366
                            ],
                            [
                                101.02978,
                                19.62928
                            ],
                            [
                                100.8962,
                                19.63364
                            ],
                            [
                                100.81568,
                                19.52697
                            ],
                            [
                                100.75589,
                                19.51122
                            ],
                            [
                                100.64889,
                                19.55662
                            ],
                            [
                                100.59764,
                                19.50684
                            ],
                            [
                                100.52096,
                                19.52089
                            ],
                            [
                                100.4743,
                                19.55837
                            ],
                            [
                                100.48956,
                                19.65269
                            ],
                            [
                                100.40876,
                                19.73523
                            ],
                            [
                                100.4423,
                                19.83732
                            ],
                            [
                                100.49815,
                                19.86793
                            ],
                            [
                                100.56954,
                                20.10153
                            ],
                            [
                                100.57643,
                                20.16914
                            ],
                            [
                                100.50843,
                                20.15121
                            ],
                            [
                                100.41456,
                                20.25471
                            ],
                            [
                                100.3747,
                                20.35
                            ],
                            [
                                100.33112,
                                20.39826
                            ],
                            [
                                100.27417,
                                20.40054
                            ],
                            [
                                100.16873,
                                20.24576
                            ],
                            [
                                100.09463,
                                20.26527
                            ],
                            [
                                100.08532,
                                20.35273
                            ],
                            [
                                99.96037,
                                20.46383
                            ],
                            [
                                99.87162,
                                20.44416
                            ],
                            [
                                99.81028,
                                20.33738
                            ],
                            [
                                99.73208,
                                20.34717
                            ],
                            [
                                99.68089,
                                20.31721
                            ],
                            [
                                99.52616,
                                20.35961
                            ],
                            [
                                99.50532,
                                20.32647
                            ],
                            [
                                99.5213,
                                20.23735
                            ],
                            [
                                99.56187,
                                20.20933
                            ],
                            [
                                99.5359,
                                20.15034
                            ],
                            [
                                99.43799,
                                20.08999
                            ],
                            [
                                99.33376,
                                20.06758
                            ],
                            [
                                99.25713,
                                20.11219
                            ],
                            [
                                99.15813,
                                20.13111
                            ],
                            [
                                99.07495,
                                20.09792
                            ],
                            [
                                99.00471,
                                19.78401
                            ],
                            [
                                98.9172,
                                19.75079
                            ],
                            [
                                98.83785,
                                19.81118
                            ],
                            [
                                98.74018,
                                19.74422
                            ],
                            [
                                98.71134,
                                19.76458
                            ],
                            [
                                98.58774,
                                19.71251
                            ],
                            [
                                98.43691,
                                19.68699
                            ],
                            [
                                98.32967,
                                19.69785
                            ],
                            [
                                98.25214,
                                19.67778
                            ],
                            [
                                98.22906,
                                19.7227
                            ],
                            [
                                98.08127,
                                19.80898
                            ],
                            [
                                98.03565,
                                19.8054
                            ],
                            [
                                98.0252,
                                19.63845
                            ],
                            [
                                97.9579,
                                19.59053
                            ],
                            [
                                97.87044,
                                19.5746
                            ],
                            [
                                97.88442,
                                19.49744
                            ],
                            [
                                97.83144,
                                19.44676
                            ],
                            [
                                97.80388,
                                19.34872
                            ],
                            [
                                97.84151,
                                19.29429
                            ],
                            [
                                97.83603,
                                19.09766
                            ],
                            [
                                97.73838,
                                19.03929
                            ],
                            [
                                97.73289,
                                18.97603
                            ],
                            [
                                97.66945,
                                18.93768
                            ],
                            [
                                97.73607,
                                18.88541
                            ],
                            [
                                97.77313,
                                18.68912
                            ],
                            [
                                97.76749,
                                18.58123
                            ],
                            [
                                97.66946,
                                18.57729
                            ],
                            [
                                97.60392,
                                18.53874
                            ],
                            [
                                97.4464,
                                18.49536
                            ],
                            [
                                97.38384,
                                18.50919
                            ],
                            [
                                97.447,
                                18.33264
                            ],
                            [
                                97.49961,
                                18.27064
                            ],
                            [
                                97.55082,
                                18.33129
                            ],
                            [
                                97.63735,
                                18.28985
                            ],
                            [
                                97.61792,
                                18.21977
                            ],
                            [
                                97.67492,
                                18.16047
                            ],
                            [
                                97.67838,
                                18.1164
                            ],
                            [
                                97.7365,
                                17.98046
                            ],
                            [
                                97.67391,
                                17.88358
                            ],
                            [
                                97.70447,
                                17.81728
                            ],
                            [
                                97.77073,
                                17.75516
                            ],
                            [
                                97.79662,
                                17.67899
                            ],
                            [
                                97.90249,
                                17.58582
                            ],
                            [
                                97.92619,
                                17.54002
                            ],
                            [
                                97.99242,
                                17.50862
                            ],
                            [
                                98.07775,
                                17.39596
                            ],
                            [
                                98.11099,
                                17.3252
                            ],
                            [
                                98.20201,
                                17.25051
                            ],
                            [
                                98.28716,
                                17.15417
                            ],
                            [
                                98.28309,
                                17.1169
                            ],
                            [
                                98.34685,
                                17.04953
                            ],
                            [
                                98.4088,
                                17.0518
                            ],
                            [
                                98.50372,
                                16.95087
                            ],
                            [
                                98.51881,
                                16.90322
                            ],
                            [
                                98.46642,
                                16.73215
                            ],
                            [
                                98.51562,
                                16.64902
                            ],
                            [
                                98.56996,
                                16.62758
                            ],
                            [
                                98.58129,
                                16.55852
                            ],
                            [
                                98.65459,
                                16.45377
                            ],
                            [
                                98.63997,
                                16.42004
                            ],
                            [
                                98.67548,
                                16.27668
                            ],
                            [
                                98.77375,
                                16.34877
                            ],
                            [
                                98.83739,
                                16.41783
                            ],
                            [
                                98.92573,
                                16.3914
                            ],
                            [
                                98.9145,
                                16.25956
                            ],
                            [
                                98.85862,
                                16.21482
                            ],
                            [
                                98.85912,
                                16.13453
                            ],
                            [
                                98.80839,
                                16.10103
                            ],
                            [
                                98.70791,
                                16.13337
                            ],
                            [
                                98.61742,
                                16.03753
                            ],
                            [
                                98.58625,
                                15.915
                            ],
                            [
                                98.60665,
                                15.86907
                            ],
                            [
                                98.55231,
                                15.68683
                            ],
                            [
                                98.55623,
                                15.5927
                            ],
                            [
                                98.58779,
                                15.45543
                            ],
                            [
                                98.56679,
                                15.34375
                            ],
                            [
                                98.49792,
                                15.38336
                            ],
                            [
                                98.4105,
                                15.35127
                            ],
                            [
                                98.39849,
                                15.25917
                            ],
                            [
                                98.30059,
                                15.31022
                            ],
                            [
                                98.26414,
                                15.24277
                            ],
                            [
                                98.21251,
                                15.2364
                            ],
                            [
                                98.18496,
                                15.10049
                            ],
                            [
                                98.23123,
                                15.04513
                            ],
                            [
                                98.20869,
                                14.98586
                            ],
                            [
                                98.24662,
                                14.91954
                            ],
                            [
                                98.24758,
                                14.83033
                            ],
                            [
                                98.31721,
                                14.72007
                            ],
                            [
                                98.43433,
                                14.61285
                            ],
                            [
                                98.49174,
                                14.53822
                            ],
                            [
                                98.59586,
                                14.32747
                            ],
                            [
                                98.83098,
                                14.17331
                            ],
                            [
                                98.89746,
                                14.11119
                            ],
                            [
                                98.96672,
                                14.08017
                            ],
                            [
                                99.0195,
                                13.9483
                            ],
                            [
                                99.07757,
                                13.89373
                            ],
                            [
                                99.12158,
                                13.77483
                            ],
                            [
                                99.17099,
                                13.73193
                            ],
                            [
                                99.16446,
                                13.57346
                            ],
                            [
                                99.2054,
                                13.4689
                            ],
                            [
                                99.21037,
                                13.19568
                            ],
                            [
                                99.12537,
                                13.19749
                            ],
                            [
                                99.13499,
                                13.13174
                            ],
                            [
                                99.10488,
                                13.06503
                            ],
                            [
                                99.19107,
                                12.99267
                            ],
                            [
                                99.18655,
                                12.84994
                            ],
                            [
                                99.22857,
                                12.80407
                            ],
                            [
                                99.23141,
                                12.74411
                            ],
                            [
                                99.2969,
                                12.67657
                            ],
                            [
                                99.41261,
                                12.61325
                            ],
                            [
                                99.43944,
                                12.55889
                            ],
                            [
                                99.40255,
                                12.46194
                            ],
                            [
                                99.44854,
                                12.40905
                            ],
                            [
                                99.44763,
                                12.31579
                            ],
                            [
                                99.50239,
                                12.14357
                            ],
                            [
                                99.56933,
                                12.14368
                            ],
                            [
                                99.53503,
                                12.06584
                            ],
                            [
                                99.53917,
                                12.01725
                            ],
                            [
                                99.59253,
                                11.99093
                            ],
                            [
                                99.58061,
                                11.9038
                            ],
                            [
                                99.62253,
                                11.85311
                            ],
                            [
                                99.64346,
                                11.78398
                            ],
                            [
                                99.56354,
                                11.62733
                            ],
                            [
                                99.50529,
                                11.6347
                            ],
                            [
                                99.45888,
                                11.58192
                            ],
                            [
                                99.4725,
                                11.53221
                            ],
                            [
                                99.39901,
                                11.4639
                            ],
                            [
                                99.40041,
                                11.3882
                            ],
                            [
                                99.31606,
                                11.31905
                            ],
                            [
                                99.32373,
                                11.28058
                            ],
                            [
                                99.26633,
                                11.21892
                            ],
                            [
                                99.22658,
                                11.11066
                            ],
                            [
                                99.1571,
                                11.0345
                            ],
                            [
                                99.10639,
                                11.01481
                            ],
                            [
                                99.06838,
                                10.94817
                            ],
                            [
                                99.00023,
                                10.92326
                            ],
                            [
                                99.00953,
                                10.85601
                            ],
                            [
                                98.92761,
                                10.82051
                            ],
                            [
                                98.84733,
                                10.7603
                            ],
                            [
                                98.78179,
                                10.68001
                            ],
                            [
                                98.77273,
                                10.62107
                            ],
                            [
                                98.80927,
                                10.59016
                            ],
                            [
                                98.82078,
                                10.52647
                            ],
                            [
                                98.79838,
                                10.4478
                            ],
                            [
                                98.75368,
                                10.38932
                            ],
                            [
                                98.71885,
                                10.23723
                            ],
                            [
                                98.67661,
                                10.1239
                            ],
                            [
                                98.61537,
                                10.01634
                            ],
                            [
                                98.58479,
                                9.93321
                            ],
                            [
                                98.52195,
                                9.85222
                            ],
                            [
                                98.54095,
                                9.79425
                            ],
                            [
                                98.50725,
                                9.744
                            ],
                            [
                                98.51139,
                                9.67941
                            ],
                            [
                                98.43776,
                                9.50486
                            ],
                            [
                                98.42678,
                                9.43571
                            ],
                            [
                                98.31734,
                                9.14814
                            ],
                            [
                                98.37554,
                                9.07761
                            ],
                            [
                                98.33333,
                                9.05721
                            ],
                            [
                                98.33417,
                                8.97891
                            ],
                            [
                                98.25183,
                                9.00529
                            ],
                            [
                                98.26604,
                                8.86973
                            ],
                            [
                                98.26098,
                                8.77192
                            ],
                            [
                                98.22657,
                                8.73063
                            ],
                            [
                                98.24557,
                                8.64541
                            ],
                            [
                                98.20757,
                                8.5509
                            ],
                            [
                                98.26978,
                                8.30314
                            ],
                            [
                                98.28379,
                                8.208
                            ],
                            [
                                98.35834,
                                8.18573
                            ],
                            [
                                98.42783,
                                8.13911
                            ],
                            [
                                98.46666,
                                8.22429
                            ],
                            [
                                98.47173,
                                8.30527
                            ],
                            [
                                98.62626,
                                8.37758
                            ],
                            [
                                98.62712,
                                8.30721
                            ],
                            [
                                98.7085,
                                8.2891
                            ],
                            [
                                98.74942,
                                8.19093
                            ],
                            [
                                98.74314,
                                8.07588
                            ],
                            [
                                98.84132,
                                8.00767
                            ],
                            [
                                98.91459,
                                8.03404
                            ],
                            [
                                98.96859,
                                7.94158
                            ],
                            [
                                99.05187,
                                7.90482
                            ],
                            [
                                99.02189,
                                7.81863
                            ],
                            [
                                99.04168,
                                7.70819
                            ],
                            [
                                99.09878,
                                7.69744
                            ],
                            [
                                99.11792,
                                7.76006
                            ],
                            [
                                99.25514,
                                7.66335
                            ],
                            [
                                99.34515,
                                7.43417
                            ],
                            [
                                99.34073,
                                7.38026
                            ],
                            [
                                99.39573,
                                7.31049
                            ],
                            [
                                99.52392,
                                7.25372
                            ],
                            [
                                99.57959,
                                7.1568
                            ],
                            [
                                99.6713,
                                7.11952
                            ],
                            [
                                99.68233,
                                6.89796
                            ],
                            [
                                99.69766,
                                6.86219
                            ],
                            [
                                99.78175,
                                6.83242
                            ],
                            [
                                100.05696,
                                6.51945
                            ],
                            [
                                100.09834,
                                6.52305
                            ],
                            [
                                100.12125,
                                6.42171
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                98.32982,
                                8.17455
                            ],
                            [
                                98.27351,
                                8.0715
                            ],
                            [
                                98.29455,
                                8.00008
                            ],
                            [
                                98.2985,
                                7.80359
                            ],
                            [
                                98.39612,
                                7.85051
                            ],
                            [
                                98.42531,
                                7.89743
                            ],
                            [
                                98.39756,
                                7.94941
                            ],
                            [
                                98.44153,
                                8.06748
                            ],
                            [
                                98.35382,
                                8.1144
                            ],
                            [
                                98.32982,
                                8.17455
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                99.9153,
                                9.5708
                            ],
                            [
                                99.93745,
                                9.42613
                            ],
                            [
                                100.01146,
                                9.42116
                            ],
                            [
                                100.05846,
                                9.52006
                            ],
                            [
                                99.98295,
                                9.58527
                            ],
                            [
                                99.9153,
                                9.5708
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                102.40056,
                                12.03435
                            ],
                            [
                                102.35287,
                                12.11125
                            ],
                            [
                                102.27338,
                                12.14441
                            ],
                            [
                                102.29508,
                                11.98325
                            ],
                            [
                                102.3756,
                                11.96417
                            ],
                            [
                                102.40056,
                                12.03435
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                99.02322,
                                7.64374
                            ],
                            [
                                99.03439,
                                7.56906
                            ],
                            [
                                99.07611,
                                7.5753
                            ],
                            [
                                99.12993,
                                7.64954
                            ],
                            [
                                99.10971,
                                7.685
                            ],
                            [
                                99.04059,
                                7.68202
                            ],
                            [
                                99.02322,
                                7.64374
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                99.59707,
                                6.60097
                            ],
                            [
                                99.64592,
                                6.51552
                            ],
                            [
                                99.69261,
                                6.5301
                            ],
                            [
                                99.6789,
                                6.69845
                            ],
                            [
                                99.61522,
                                6.65243
                            ],
                            [
                                99.59707,
                                6.60097
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                99.96117,
                                9.76998
                            ],
                            [
                                99.98403,
                                9.71067
                            ],
                            [
                                100.06853,
                                9.67687
                            ],
                            [
                                100.07158,
                                9.76646
                            ],
                            [
                                99.98237,
                                9.79861
                            ],
                            [
                                99.96117,
                                9.76998
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                102.52693,
                                11.65757
                            ],
                            [
                                102.58859,
                                11.61062
                            ],
                            [
                                102.60158,
                                11.67657
                            ],
                            [
                                102.55693,
                                11.75829
                            ],
                            [
                                102.52693,
                                11.65757
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                98.32982,
                                9.07452
                            ],
                            [
                                98.28954,
                                9.16675
                            ],
                            [
                                98.24986,
                                9.12224
                            ],
                            [
                                98.24771,
                                9.03613
                            ],
                            [
                                98.32982,
                                9.07452
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "TLS",
                "Country": "Timor-Leste",
                "Total_3GHG": 0.01,
                "Total_3GHG_timeseries": [
                    5.5397e-07,
                    1.1223e-06,
                    1.703e-06,
                    2.4085e-06,
                    3.0562e-06,
                    3.6911e-06,
                    4.3286e-06,
                    4.8909e-06,
                    5.6651e-06,
                    6.3197e-06,
                    6.8353e-06,
                    7.2985e-06,
                    7.7353e-06,
                    8.1559e-06,
                    8.687e-06,
                    9.2979e-06,
                    9.774e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_3GHG": 0.01,
                "Fossil_3GHG_timeseries": [
                    1.3853e-08,
                    2.796e-08,
                    4.2326e-08,
                    5.6958e-08,
                    7.1862e-08,
                    8.7044e-08,
                    1.0251e-07,
                    1.1827e-07,
                    1.3433e-07,
                    1.5069e-07,
                    1.6703e-07,
                    1.8335e-07,
                    1.9966e-07,
                    2.1595e-07,
                    2.3225e-07,
                    2.4855e-07,
                    2.6486e-07,
                    2.8118e-07,
                    2.9753e-07,
                    3.1392e-07,
                    3.3018e-07,
                    3.4635e-07,
                    3.6241e-07,
                    3.7838e-07,
                    3.9426e-07,
                    4.1005e-07,
                    4.2576e-07,
                    4.4137e-07,
                    4.569e-07,
                    4.7233e-07,
                    4.8749e-07,
                    5.0295e-07,
                    5.1873e-07,
                    5.3484e-07,
                    5.5128e-07,
                    5.6809e-07,
                    5.8526e-07,
                    6.0282e-07,
                    6.2079e-07,
                    6.3918e-07,
                    6.5743e-07,
                    6.7554e-07,
                    6.935e-07,
                    7.1132e-07,
                    7.2898e-07,
                    7.4654e-07,
                    7.6398e-07,
                    7.8132e-07,
                    7.9853e-07,
                    8.1561e-07,
                    8.3288e-07,
                    8.5012e-07,
                    8.673e-07,
                    8.8442e-07,
                    9.0145e-07,
                    9.1837e-07,
                    9.3517e-07,
                    9.5183e-07,
                    9.6831e-07,
                    9.846e-07,
                    1.0009e-06,
                    1.0171e-06,
                    1.0333e-06,
                    1.0494e-06,
                    1.0656e-06,
                    1.0816e-06,
                    1.0976e-06,
                    1.1135e-06,
                    1.1294e-06,
                    1.1451e-06,
                    1.1609e-06,
                    1.1762e-06,
                    1.1911e-06,
                    1.2057e-06,
                    1.2199e-06,
                    1.2335e-06,
                    1.2468e-06,
                    1.2597e-06,
                    1.2721e-06,
                    1.2841e-06,
                    1.2963e-06,
                    1.3084e-06,
                    1.3205e-06,
                    1.3324e-06,
                    1.3443e-06,
                    1.3561e-06,
                    1.3678e-06,
                    1.3795e-06,
                    1.3912e-06,
                    1.4028e-06,
                    1.4144e-06,
                    1.4263e-06,
                    1.4384e-06,
                    1.4507e-06,
                    1.4647e-06,
                    1.4809e-06,
                    1.4985e-06,
                    1.5175e-06,
                    1.5381e-06,
                    1.5602e-06,
                    1.5854e-06,
                    1.6139e-06,
                    1.6459e-06,
                    1.6815e-06,
                    1.7208e-06,
                    1.764e-06,
                    1.8113e-06,
                    1.8629e-06,
                    1.919e-06,
                    1.9797e-06,
                    2.0452e-06,
                    2.1157e-06,
                    2.1912e-06,
                    2.2722e-06,
                    2.3574e-06,
                    2.4465e-06,
                    2.5404e-06,
                    2.6392e-06,
                    2.7434e-06,
                    2.8329e-06,
                    2.9257e-06,
                    3.0211e-06,
                    3.1181e-06,
                    3.2151e-06,
                    3.3091e-06,
                    3.3962e-06,
                    3.4739e-06,
                    3.5415e-06,
                    3.5996e-06,
                    3.651e-06,
                    3.6996e-06,
                    3.7494e-06,
                    3.8007e-06,
                    3.8543e-06,
                    3.9109e-06,
                    3.9682e-06,
                    4.0255e-06,
                    4.0821e-06,
                    4.1391e-06,
                    4.2159e-06,
                    4.2949e-06,
                    4.3785e-06,
                    4.467e-06,
                    4.5591e-06,
                    4.6663e-06,
                    4.7815e-06,
                    4.9014e-06,
                    5.0521e-06,
                    5.2485e-06,
                    5.4814e-06,
                    5.6742e-06,
                    5.9367e-06,
                    6.1993e-06,
                    7.2816e-06,
                    8.8936e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_3GHG": 0.03,
                "Land_3GHG_timeseries": [
                    5.4011e-07,
                    1.0943e-06,
                    1.6607e-06,
                    2.3515e-06,
                    2.9844e-06,
                    3.6041e-06,
                    4.2261e-06,
                    4.7727e-06,
                    5.5307e-06,
                    6.169e-06,
                    6.6683e-06,
                    7.1152e-06,
                    7.5356e-06,
                    7.94e-06,
                    8.4548e-06,
                    9.0493e-06,
                    9.5091e-06,
                    9.9212e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_CO2": 0.01,
                "Total_CO2_timeseries": [
                    4.5057e-07,
                    9.1442e-07,
                    1.3896e-06,
                    1.9885e-06,
                    2.5287e-06,
                    3.0549e-06,
                    3.5827e-06,
                    4.0341e-06,
                    4.6964e-06,
                    5.2381e-06,
                    5.6419e-06,
                    5.9945e-06,
                    6.3219e-06,
                    6.6343e-06,
                    7.0583e-06,
                    7.5633e-06,
                    7.9346e-06,
                    8.2594e-06,
                    8.565e-06,
                    8.8602e-06,
                    9.2481e-06,
                    9.728e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2.7261e-08,
                    9.6149e-08,
                    1.9516e-07,
                    2.4868e-07,
                    3.6661e-07,
                    4.7853e-07,
                    7.0234e-07,
                    8.4696e-07,
                    9.8958e-07,
                    1.1193e-06,
                    1.2477e-06,
                    1.3926e-06,
                    1.5336e-06,
                    1.729e-06,
                    1.9953e-06,
                    2.2739e-06,
                    2.5551e-06,
                    2.8206e-06,
                    3.1101e-06,
                    3.4207e-06,
                    3.6986e-06,
                    4.0027e-06,
                    4.2939e-06,
                    4.5927e-06,
                    4.894e-06
                ],
                "Land_CO2": 0.03,
                "Land_CO2_timeseries": [
                    4.5057e-07,
                    9.1442e-07,
                    1.3896e-06,
                    1.9885e-06,
                    2.5287e-06,
                    3.0549e-06,
                    3.5827e-06,
                    4.0341e-06,
                    4.6964e-06,
                    5.2381e-06,
                    5.6419e-06,
                    5.9945e-06,
                    6.3219e-06,
                    6.6343e-06,
                    7.0583e-06,
                    7.5633e-06,
                    7.9346e-06,
                    8.2594e-06,
                    8.565e-06,
                    8.8602e-06,
                    9.2481e-06,
                    9.728e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_CH4": 0.03,
                "Total_CH4_timeseries": [
                    1.01e-07,
                    2.0301e-07,
                    3.0602e-07,
                    4.1004e-07,
                    5.1509e-07,
                    6.2117e-07,
                    7.2828e-07,
                    8.3643e-07,
                    9.4564e-07,
                    1.0559e-06,
                    1.165e-06,
                    1.2729e-06,
                    1.3796e-06,
                    1.4851e-06,
                    1.5895e-06,
                    1.6927e-06,
                    1.7947e-06,
                    1.8956e-06,
                    1.9954e-06,
                    2.094e-06,
                    2.1912e-06,
                    2.2868e-06,
                    2.3811e-06,
                    2.4738e-06,
                    2.5651e-06,
                    2.6549e-06,
                    2.7432e-06,
                    2.8301e-06,
                    2.9155e-06,
                    2.9995e-06,
                    3.0835e-06,
                    3.1681e-06,
                    3.2533e-06,
                    3.3391e-06,
                    3.4256e-06,
                    3.5127e-06,
                    3.6004e-06,
                    3.6889e-06,
                    3.7781e-06,
                    3.868e-06,
                    3.958e-06,
                    4.0482e-06,
                    4.1386e-06,
                    4.2291e-06,
                    4.3198e-06,
                    4.4107e-06,
                    4.5018e-06,
                    4.5931e-06,
                    4.6846e-06,
                    4.7762e-06,
                    4.8684e-06,
                    4.9608e-06,
                    5.0535e-06,
                    5.1464e-06,
                    5.2396e-06,
                    5.333e-06,
                    5.4265e-06,
                    5.5202e-06,
                    5.6141e-06,
                    5.7081e-06,
                    5.8023e-06,
                    5.8967e-06,
                    5.9912e-06,
                    6.086e-06,
                    6.181e-06,
                    6.2761e-06,
                    6.3713e-06,
                    6.4668e-06,
                    6.5623e-06,
                    6.6581e-06,
                    6.754e-06,
                    6.8498e-06,
                    6.9453e-06,
                    7.0408e-06,
                    7.1361e-06,
                    7.231e-06,
                    7.3259e-06,
                    7.4206e-06,
                    7.515e-06,
                    7.6093e-06,
                    7.7041e-06,
                    7.7992e-06,
                    7.8944e-06,
                    7.99e-06,
                    8.0858e-06,
                    8.182e-06,
                    8.2786e-06,
                    8.3757e-06,
                    8.4731e-06,
                    8.5709e-06,
                    8.6693e-06,
                    8.7683e-06,
                    8.868e-06,
                    8.9682e-06,
                    9.0706e-06,
                    9.1756e-06,
                    9.2823e-06,
                    9.3908e-06,
                    9.5013e-06,
                    9.6138e-06,
                    9.7343e-06,
                    9.8639e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_CH4": 0.03,
                "Fossil_CH4_timeseries": [
                    1.3545e-08,
                    2.7337e-08,
                    4.1384e-08,
                    5.5691e-08,
                    7.0265e-08,
                    8.5113e-08,
                    1.0024e-07,
                    1.1566e-07,
                    1.3138e-07,
                    1.474e-07,
                    1.6339e-07,
                    1.7936e-07,
                    1.9532e-07,
                    2.1127e-07,
                    2.2722e-07,
                    2.4317e-07,
                    2.5913e-07,
                    2.751e-07,
                    2.911e-07,
                    3.0713e-07,
                    3.2304e-07,
                    3.3884e-07,
                    3.5451e-07,
                    3.7007e-07,
                    3.8551e-07,
                    4.0084e-07,
                    4.1605e-07,
                    4.3116e-07,
                    4.4616e-07,
                    4.6105e-07,
                    4.7567e-07,
                    4.9058e-07,
                    5.058e-07,
                    5.2135e-07,
                    5.3724e-07,
                    5.5348e-07,
                    5.7008e-07,
                    5.8707e-07,
                    6.0446e-07,
                    6.2227e-07,
                    6.3993e-07,
                    6.5745e-07,
                    6.7482e-07,
                    6.9203e-07,
                    7.0908e-07,
                    7.2602e-07,
                    7.4284e-07,
                    7.5954e-07,
                    7.7611e-07,
                    7.9255e-07,
                    8.0916e-07,
                    8.2572e-07,
                    8.4223e-07,
                    8.5865e-07,
                    8.7497e-07,
                    8.9117e-07,
                    9.0723e-07,
                    9.2312e-07,
                    9.3884e-07,
                    9.5435e-07,
                    9.6981e-07,
                    9.8523e-07,
                    1.0006e-06,
                    1.0159e-06,
                    1.0312e-06,
                    1.0464e-06,
                    1.0616e-06,
                    1.0766e-06,
                    1.0915e-06,
                    1.1064e-06,
                    1.1213e-06,
                    1.1356e-06,
                    1.1496e-06,
                    1.1632e-06,
                    1.1764e-06,
                    1.189e-06,
                    1.2012e-06,
                    1.2131e-06,
                    1.2245e-06,
                    1.2354e-06,
                    1.2466e-06,
                    1.2576e-06,
                    1.2686e-06,
                    1.2794e-06,
                    1.2902e-06,
                    1.3008e-06,
                    1.3115e-06,
                    1.322e-06,
                    1.3325e-06,
                    1.3429e-06,
                    1.3533e-06,
                    1.3639e-06,
                    1.3747e-06,
                    1.3855e-06,
                    1.398e-06,
                    1.4125e-06,
                    1.4283e-06,
                    1.4454e-06,
                    1.464e-06,
                    1.484e-06,
                    1.5071e-06,
                    1.5334e-06,
                    1.5632e-06,
                    1.5965e-06,
                    1.6335e-06,
                    1.6743e-06,
                    1.7192e-06,
                    1.7683e-06,
                    1.8218e-06,
                    1.8799e-06,
                    1.9427e-06,
                    2.0103e-06,
                    2.0829e-06,
                    2.1608e-06,
                    2.2427e-06,
                    2.3284e-06,
                    2.4187e-06,
                    2.5138e-06,
                    2.6141e-06,
                    2.7001e-06,
                    2.7891e-06,
                    2.8807e-06,
                    2.9738e-06,
                    3.067e-06,
                    3.1573e-06,
                    3.2407e-06,
                    3.3148e-06,
                    3.3789e-06,
                    3.4335e-06,
                    3.4814e-06,
                    3.5265e-06,
                    3.5716e-06,
                    3.6189e-06,
                    3.6683e-06,
                    3.7203e-06,
                    3.7731e-06,
                    3.8258e-06,
                    3.8783e-06,
                    3.9306e-06,
                    4.0026e-06,
                    4.0768e-06,
                    4.1554e-06,
                    4.2387e-06,
                    4.3258e-06,
                    4.4274e-06,
                    4.537e-06,
                    4.6513e-06,
                    4.7694e-06,
                    4.8914e-06,
                    5.0192e-06,
                    5.1526e-06,
                    5.2911e-06,
                    5.4351e-06,
                    6.2862e-06,
                    7.7464e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CH4": 0.02,
                "Land_CH4_timeseries": [
                    8.7458e-08,
                    1.7567e-07,
                    2.6463e-07,
                    3.5435e-07,
                    4.4483e-07,
                    5.3605e-07,
                    6.2804e-07,
                    7.2077e-07,
                    8.1426e-07,
                    9.085e-07,
                    1.0016e-06,
                    1.0935e-06,
                    1.1842e-06,
                    1.2738e-06,
                    1.3622e-06,
                    1.4495e-06,
                    1.5356e-06,
                    1.6205e-06,
                    1.7043e-06,
                    1.7869e-06,
                    1.8681e-06,
                    1.948e-06,
                    2.0265e-06,
                    2.1037e-06,
                    2.1796e-06,
                    2.254e-06,
                    2.3272e-06,
                    2.399e-06,
                    2.4694e-06,
                    2.5384e-06,
                    2.6078e-06,
                    2.6775e-06,
                    2.7475e-06,
                    2.8177e-06,
                    2.8883e-06,
                    2.9592e-06,
                    3.0304e-06,
                    3.1018e-06,
                    3.1736e-06,
                    3.2457e-06,
                    3.3181e-06,
                    3.3908e-06,
                    3.4638e-06,
                    3.5371e-06,
                    3.6108e-06,
                    3.6847e-06,
                    3.759e-06,
                    3.8336e-06,
                    3.9085e-06,
                    3.9837e-06,
                    4.0592e-06,
                    4.1351e-06,
                    4.2113e-06,
                    4.2878e-06,
                    4.3646e-06,
                    4.4418e-06,
                    4.5193e-06,
                    4.5971e-06,
                    4.6753e-06,
                    4.7537e-06,
                    4.8325e-06,
                    4.9114e-06,
                    4.9906e-06,
                    5.0701e-06,
                    5.1497e-06,
                    5.2296e-06,
                    5.3098e-06,
                    5.3902e-06,
                    5.4708e-06,
                    5.5517e-06,
                    5.6328e-06,
                    5.7142e-06,
                    5.7958e-06,
                    5.8776e-06,
                    5.9597e-06,
                    6.042e-06,
                    6.1246e-06,
                    6.2074e-06,
                    6.2905e-06,
                    6.3738e-06,
                    6.4575e-06,
                    6.5415e-06,
                    6.6259e-06,
                    6.7106e-06,
                    6.7956e-06,
                    6.8812e-06,
                    6.9672e-06,
                    7.0537e-06,
                    7.1406e-06,
                    7.228e-06,
                    7.316e-06,
                    7.4044e-06,
                    7.4933e-06,
                    7.5827e-06,
                    7.6727e-06,
                    7.7631e-06,
                    7.854e-06,
                    7.9454e-06,
                    8.0373e-06,
                    8.1297e-06,
                    8.2273e-06,
                    8.3305e-06,
                    8.44e-06,
                    8.5564e-06,
                    8.6805e-06,
                    8.8127e-06,
                    8.9537e-06,
                    9.1041e-06,
                    9.2647e-06,
                    9.4358e-06,
                    9.619e-06,
                    9.7882e-06,
                    9.9818e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_N2O": 0.01,
                "Total_N2O_timeseries": [
                    2.3997e-09,
                    4.847e-09,
                    7.3397e-09,
                    9.8752e-09,
                    1.245e-08,
                    1.5059e-08,
                    1.7698e-08,
                    2.0361e-08,
                    2.3041e-08,
                    2.573e-08,
                    2.8425e-08,
                    3.1123e-08,
                    3.3824e-08,
                    3.6528e-08,
                    3.9233e-08,
                    4.1941e-08,
                    4.4651e-08,
                    4.7364e-08,
                    5.0081e-08,
                    5.2803e-08,
                    5.5571e-08,
                    5.8452e-08,
                    6.1499e-08,
                    6.4748e-08,
                    6.8221e-08,
                    7.1922e-08,
                    7.584e-08,
                    7.995e-08,
                    8.4207e-08,
                    8.8556e-08,
                    9.2955e-08,
                    9.7398e-08,
                    1.0188e-07,
                    1.0639e-07,
                    1.1093e-07,
                    1.1549e-07,
                    1.2008e-07,
                    1.247e-07,
                    1.2936e-07,
                    1.3443e-07,
                    1.3956e-07,
                    1.4474e-07,
                    1.5001e-07,
                    1.5537e-07,
                    1.6083e-07,
                    1.664e-07,
                    1.721e-07,
                    1.7793e-07,
                    1.8389e-07,
                    1.9e-07,
                    1.9626e-07,
                    2.0269e-07,
                    2.0931e-07,
                    2.1614e-07,
                    2.2319e-07,
                    2.305e-07,
                    2.3807e-07,
                    2.4593e-07,
                    2.541e-07,
                    2.6259e-07,
                    2.715e-07,
                    2.8091e-07,
                    2.9092e-07,
                    3.0159e-07,
                    3.1295e-07,
                    3.2504e-07,
                    3.3784e-07,
                    3.5133e-07,
                    3.6545e-07,
                    3.8015e-07,
                    3.9537e-07,
                    4.1111e-07,
                    4.2738e-07,
                    4.4415e-07,
                    4.6141e-07,
                    4.7913e-07,
                    4.973e-07,
                    5.1587e-07,
                    5.3482e-07,
                    5.5409e-07,
                    5.7366e-07,
                    5.9355e-07,
                    6.1375e-07,
                    6.3424e-07,
                    6.5501e-07,
                    6.7602e-07,
                    6.9724e-07,
                    7.1863e-07,
                    7.4013e-07,
                    7.6168e-07,
                    7.8417e-07,
                    8.0917e-07,
                    8.3785e-07,
                    8.7102e-07,
                    9.0907e-07,
                    9.52e-07,
                    9.9942e-07,
                    1.0506e-06,
                    1.1043e-06,
                    1.1589e-06,
                    1.2138e-06,
                    1.2689e-06,
                    1.3244e-06,
                    1.3805e-06,
                    1.437e-06,
                    1.4942e-06,
                    1.552e-06,
                    1.6103e-06,
                    1.6692e-06,
                    1.7285e-06,
                    1.7904e-06,
                    1.8515e-06,
                    1.915e-06,
                    1.9813e-06,
                    2.0519e-06,
                    2.1253e-06,
                    2.1925e-06,
                    2.2606e-06,
                    2.3293e-06,
                    2.4032e-06,
                    2.4803e-06,
                    2.5618e-06,
                    2.6431e-06,
                    2.7229e-06,
                    2.7945e-06,
                    2.858e-06,
                    2.9116e-06,
                    2.9579e-06,
                    2.9943e-06,
                    3.0256e-06,
                    3.0566e-06,
                    3.0906e-06,
                    3.1257e-06,
                    3.1614e-06,
                    3.1996e-06,
                    3.2389e-06,
                    3.279e-06,
                    3.3187e-06,
                    3.3638e-06,
                    3.4134e-06,
                    3.4679e-06,
                    3.5254e-06,
                    3.5871e-06,
                    3.6607e-06,
                    3.7355e-06,
                    3.8125e-06,
                    3.8923e-06,
                    3.9749e-06,
                    4.045e-06,
                    4.1199e-06,
                    4.2074e-06,
                    4.2973e-06,
                    4.3824e-06,
                    4.4665e-06,
                    4.5552e-06,
                    4.6465e-06,
                    4.737e-06,
                    4.8309e-06,
                    4.9269e-06,
                    5.0206e-06,
                    5.1151e-06,
                    5.2159e-06,
                    5.3187e-06,
                    5.4252e-06,
                    5.5425e-06,
                    5.6579e-06,
                    5.7738e-06,
                    5.8921e-06,
                    6.0215e-06,
                    6.1405e-06,
                    6.2532e-06,
                    6.366e-06
                ],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [
                    3.0849e-10,
                    6.227e-10,
                    9.4239e-10,
                    1.2672e-09,
                    1.5969e-09,
                    1.9308e-09,
                    2.2684e-09,
                    2.6091e-09,
                    2.9521e-09,
                    3.2966e-09,
                    3.642e-09,
                    3.9883e-09,
                    4.3352e-09,
                    4.6829e-09,
                    5.0311e-09,
                    5.38e-09,
                    5.7296e-09,
                    6.0798e-09,
                    6.431e-09,
                    6.7831e-09,
                    7.1407e-09,
                    7.5114e-09,
                    7.901e-09,
                    8.3136e-09,
                    8.7516e-09,
                    9.2155e-09,
                    9.7041e-09,
                    1.0214e-08,
                    1.0742e-08,
                    1.1279e-08,
                    1.1823e-08,
                    1.2373e-08,
                    1.2926e-08,
                    1.3484e-08,
                    1.4045e-08,
                    1.4609e-08,
                    1.5177e-08,
                    1.5749e-08,
                    1.6324e-08,
                    1.6906e-08,
                    1.7494e-08,
                    1.8088e-08,
                    1.8687e-08,
                    1.9292e-08,
                    1.9904e-08,
                    2.0522e-08,
                    2.1147e-08,
                    2.1779e-08,
                    2.2419e-08,
                    2.3068e-08,
                    2.3726e-08,
                    2.4396e-08,
                    2.5078e-08,
                    2.5774e-08,
                    2.6484e-08,
                    2.7208e-08,
                    2.7948e-08,
                    2.8701e-08,
                    2.947e-08,
                    3.0251e-08,
                    3.1045e-08,
                    3.1852e-08,
                    3.2671e-08,
                    3.3502e-08,
                    3.4346e-08,
                    3.5202e-08,
                    3.6071e-08,
                    3.6952e-08,
                    3.7846e-08,
                    3.8754e-08,
                    3.9675e-08,
                    4.0611e-08,
                    4.1562e-08,
                    4.2529e-08,
                    4.3512e-08,
                    4.4511e-08,
                    4.5525e-08,
                    4.6555e-08,
                    4.7599e-08,
                    4.8658e-08,
                    4.9729e-08,
                    5.0812e-08,
                    5.1905e-08,
                    5.3009e-08,
                    5.4124e-08,
                    5.525e-08,
                    5.6387e-08,
                    5.7536e-08,
                    5.8699e-08,
                    5.9878e-08,
                    6.1089e-08,
                    6.2362e-08,
                    6.372e-08,
                    6.5178e-08,
                    6.6747e-08,
                    6.8432e-08,
                    7.023e-08,
                    7.2133e-08,
                    7.4127e-08,
                    7.6191e-08,
                    7.8311e-08,
                    8.0483e-08,
                    8.2705e-08,
                    8.4976e-08,
                    8.7298e-08,
                    8.9672e-08,
                    9.2102e-08,
                    9.4592e-08,
                    9.7151e-08,
                    9.9784e-08,
                    1.0251e-07,
                    1.0535e-07,
                    1.0831e-07,
                    1.1142e-07,
                    1.1468e-07,
                    1.181e-07,
                    1.2167e-07,
                    1.2541e-07,
                    1.2931e-07,
                    1.3288e-07,
                    1.3654e-07,
                    1.4042e-07,
                    1.4426e-07,
                    1.4808e-07,
                    1.5186e-07,
                    1.5548e-07,
                    1.5905e-07,
                    1.626e-07,
                    1.661e-07,
                    1.6961e-07,
                    1.731e-07,
                    1.7783e-07,
                    1.8189e-07,
                    1.8598e-07,
                    1.9057e-07,
                    1.9508e-07,
                    1.9969e-07,
                    2.0373e-07,
                    2.0849e-07,
                    2.1322e-07,
                    2.1807e-07,
                    2.2309e-07,
                    2.2825e-07,
                    2.333e-07,
                    2.3886e-07,
                    2.4451e-07,
                    2.5005e-07,
                    2.5544e-07,
                    2.6097e-07,
                    2.67e-07,
                    2.7291e-07,
                    2.7894e-07,
                    2.8567e-07,
                    2.9311e-07,
                    3.0027e-07,
                    3.0751e-07,
                    3.1491e-07,
                    3.2256e-07,
                    3.3042e-07,
                    3.3855e-07,
                    3.47e-07,
                    3.5637e-07,
                    3.6713e-07,
                    3.7827e-07,
                    3.894e-07,
                    4.0031e-07,
                    4.12e-07,
                    4.237e-07,
                    4.3565e-07,
                    4.4744e-07,
                    4.5949e-07,
                    4.7164e-07
                ],
                "Land_N2O": 0.01,
                "Land_N2O_timeseries": [
                    2.0912e-09,
                    4.2243e-09,
                    6.3973e-09,
                    8.6079e-09,
                    1.0853e-08,
                    1.3128e-08,
                    1.543e-08,
                    1.7752e-08,
                    2.0089e-08,
                    2.2434e-08,
                    2.4783e-08,
                    2.7135e-08,
                    2.9489e-08,
                    3.1845e-08,
                    3.4202e-08,
                    3.6561e-08,
                    3.8921e-08,
                    4.1284e-08,
                    4.365e-08,
                    4.602e-08,
                    4.843e-08,
                    5.0941e-08,
                    5.3598e-08,
                    5.6435e-08,
                    5.9469e-08,
                    6.2706e-08,
                    6.6136e-08,
                    6.9735e-08,
                    7.3466e-08,
                    7.7276e-08,
                    8.1132e-08,
                    8.5025e-08,
                    8.8951e-08,
                    9.2904e-08,
                    9.6882e-08,
                    1.0088e-07,
                    1.0491e-07,
                    1.0896e-07,
                    1.1303e-07,
                    1.1753e-07,
                    1.2206e-07,
                    1.2666e-07,
                    1.3132e-07,
                    1.3607e-07,
                    1.4092e-07,
                    1.4588e-07,
                    1.5095e-07,
                    1.5615e-07,
                    1.6147e-07,
                    1.6693e-07,
                    1.7253e-07,
                    1.783e-07,
                    1.8423e-07,
                    1.9037e-07,
                    1.9671e-07,
                    2.0329e-07,
                    2.1012e-07,
                    2.1723e-07,
                    2.2463e-07,
                    2.3234e-07,
                    2.4045e-07,
                    2.4906e-07,
                    2.5825e-07,
                    2.6808e-07,
                    2.7861e-07,
                    2.8984e-07,
                    3.0177e-07,
                    3.1437e-07,
                    3.2761e-07,
                    3.4139e-07,
                    3.5569e-07,
                    3.705e-07,
                    3.8582e-07,
                    4.0162e-07,
                    4.179e-07,
                    4.3462e-07,
                    4.5178e-07,
                    4.6932e-07,
                    4.8722e-07,
                    5.0543e-07,
                    5.2394e-07,
                    5.4274e-07,
                    5.6185e-07,
                    5.8123e-07,
                    6.0088e-07,
                    6.2077e-07,
                    6.4085e-07,
                    6.6109e-07,
                    6.8143e-07,
                    7.018e-07,
                    7.2308e-07,
                    7.468e-07,
                    7.7413e-07,
                    8.0584e-07,
                    8.4232e-07,
                    8.8356e-07,
                    9.2919e-07,
                    9.7843e-07,
                    1.0301e-06,
                    1.0827e-06,
                    1.1355e-06,
                    1.1884e-06,
                    1.2417e-06,
                    1.2955e-06,
                    1.3497e-06,
                    1.4045e-06,
                    1.4599e-06,
                    1.5157e-06,
                    1.572e-06,
                    1.6287e-06,
                    1.6879e-06,
                    1.7462e-06,
                    1.8067e-06,
                    1.8699e-06,
                    1.9373e-06,
                    2.0072e-06,
                    2.0708e-06,
                    2.1352e-06,
                    2.2e-06,
                    2.2703e-06,
                    2.3438e-06,
                    2.4214e-06,
                    2.4988e-06,
                    2.5748e-06,
                    2.6426e-06,
                    2.7026e-06,
                    2.7526e-06,
                    2.7953e-06,
                    2.8282e-06,
                    2.856e-06,
                    2.8835e-06,
                    2.9128e-06,
                    2.9438e-06,
                    2.9754e-06,
                    3.009e-06,
                    3.0438e-06,
                    3.0793e-06,
                    3.1149e-06,
                    3.1553e-06,
                    3.2002e-06,
                    3.2499e-06,
                    3.3023e-06,
                    3.3589e-06,
                    3.4274e-06,
                    3.4966e-06,
                    3.568e-06,
                    3.6422e-06,
                    3.7195e-06,
                    3.784e-06,
                    3.8529e-06,
                    3.9345e-06,
                    4.0184e-06,
                    4.0967e-06,
                    4.1734e-06,
                    4.2549e-06,
                    4.339e-06,
                    4.4221e-06,
                    4.5083e-06,
                    4.5965e-06,
                    4.6821e-06,
                    4.7681e-06,
                    4.8595e-06,
                    4.9515e-06,
                    5.0469e-06,
                    5.1531e-06,
                    5.2576e-06,
                    5.3618e-06,
                    5.4684e-06,
                    5.5858e-06,
                    5.6931e-06,
                    5.7937e-06,
                    5.8944e-06
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                125.0819,
                                -9.44619
                            ],
                            [
                                125.20853,
                                -9.4107
                            ],
                            [
                                125.3727,
                                -9.27291
                            ],
                            [
                                125.44748,
                                -9.25561
                            ],
                            [
                                125.613,
                                -9.1856
                            ],
                            [
                                125.70069,
                                -9.19382
                            ],
                            [
                                125.72925,
                                -9.16644
                            ],
                            [
                                125.85103,
                                -9.1246
                            ],
                            [
                                125.94239,
                                -9.13274
                            ],
                            [
                                126.18559,
                                -8.97735
                            ],
                            [
                                126.30148,
                                -8.98191
                            ],
                            [
                                126.40963,
                                -8.94751
                            ],
                            [
                                126.47775,
                                -8.94664
                            ],
                            [
                                126.56317,
                                -8.82556
                            ],
                            [
                                126.66033,
                                -8.7713
                            ],
                            [
                                126.76525,
                                -8.74738
                            ],
                            [
                                126.81887,
                                -8.75929
                            ],
                            [
                                126.96679,
                                -8.6803
                            ],
                            [
                                127.01446,
                                -8.68236
                            ],
                            [
                                127.08696,
                                -8.59825
                            ],
                            [
                                127.29751,
                                -8.43246
                            ],
                            [
                                127.19382,
                                -8.33677
                            ],
                            [
                                127.13744,
                                -8.36415
                            ],
                            [
                                127.06614,
                                -8.3631
                            ],
                            [
                                126.99523,
                                -8.32339
                            ],
                            [
                                126.93921,
                                -8.33638
                            ],
                            [
                                126.78222,
                                -8.41759
                            ],
                            [
                                126.72922,
                                -8.40529
                            ],
                            [
                                126.55115,
                                -8.47889
                            ],
                            [
                                126.41537,
                                -8.41702
                            ],
                            [
                                126.36288,
                                -8.42687
                            ],
                            [
                                126.23648,
                                -8.50006
                            ],
                            [
                                126.16201,
                                -8.49666
                            ],
                            [
                                126.07084,
                                -8.5201
                            ],
                            [
                                125.94163,
                                -8.47807
                            ],
                            [
                                125.85478,
                                -8.47532
                            ],
                            [
                                125.68974,
                                -8.53617
                            ],
                            [
                                125.60969,
                                -8.52591
                            ],
                            [
                                125.48421,
                                -8.56671
                            ],
                            [
                                125.39641,
                                -8.56429
                            ],
                            [
                                125.29441,
                                -8.60216
                            ],
                            [
                                125.20789,
                                -8.6076
                            ],
                            [
                                125.12274,
                                -8.64236
                            ],
                            [
                                125.09892,
                                -8.69036
                            ],
                            [
                                125.09399,
                                -8.80019
                            ],
                            [
                                125.00513,
                                -8.86684
                            ],
                            [
                                124.95001,
                                -8.9581
                            ],
                            [
                                124.9417,
                                -9.04783
                            ],
                            [
                                125.00316,
                                -9.06287
                            ],
                            [
                                125.12037,
                                -8.97179
                            ],
                            [
                                125.18565,
                                -9.02865
                            ],
                            [
                                125.17513,
                                -9.17254
                            ],
                            [
                                125.10306,
                                -9.1965
                            ],
                            [
                                124.99531,
                                -9.17317
                            ],
                            [
                                124.97787,
                                -9.2315
                            ],
                            [
                                125.00642,
                                -9.29482
                            ],
                            [
                                125.05042,
                                -9.32681
                            ],
                            [
                                125.0819,
                                -9.44619
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                124.47717,
                                -9.175
                            ],
                            [
                                124.42677,
                                -9.16788
                            ],
                            [
                                124.31015,
                                -9.19929
                            ],
                            [
                                124.04496,
                                -9.34296
                            ],
                            [
                                124.13393,
                                -9.42517
                            ],
                            [
                                124.21668,
                                -9.36657
                            ],
                            [
                                124.26046,
                                -9.39624
                            ],
                            [
                                124.28869,
                                -9.50375
                            ],
                            [
                                124.35037,
                                -9.48428
                            ],
                            [
                                124.38037,
                                -9.35821
                            ],
                            [
                                124.46158,
                                -9.29397
                            ],
                            [
                                124.47717,
                                -9.175
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                125.50173,
                                -8.26472
                            ],
                            [
                                125.58233,
                                -8.30658
                            ],
                            [
                                125.64268,
                                -8.16289
                            ],
                            [
                                125.59146,
                                -8.16277
                            ],
                            [
                                125.50173,
                                -8.26472
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "TGO",
                "Country": "Togo",
                "Total_3GHG": 0.03,
                "Total_3GHG_timeseries": [
                    1.1228e-07,
                    2.2051e-07,
                    3.2422e-07,
                    4.2348e-07,
                    5.1851e-07,
                    6.0961e-07,
                    6.9706e-07,
                    7.811e-07,
                    8.6207e-07,
                    9.7678e-07,
                    1.107e-06,
                    1.2471e-06,
                    1.3965e-06,
                    1.5522e-06,
                    1.7133e-06,
                    1.8792e-06,
                    2.0494e-06,
                    2.2235e-06,
                    2.4012e-06,
                    2.5755e-06,
                    2.7484e-06,
                    2.9213e-06,
                    3.0946e-06,
                    3.2685e-06,
                    3.4433e-06,
                    3.6189e-06,
                    3.7953e-06,
                    3.9724e-06,
                    4.1499e-06,
                    4.3313e-06,
                    4.5143e-06,
                    4.6983e-06,
                    4.8815e-06,
                    5.0651e-06,
                    5.2491e-06,
                    5.4334e-06,
                    5.618e-06,
                    5.8026e-06,
                    5.9874e-06,
                    6.1768e-06,
                    6.3674e-06,
                    6.5584e-06,
                    6.7497e-06,
                    6.941e-06,
                    7.1324e-06,
                    7.3241e-06,
                    7.516e-06,
                    7.708e-06,
                    7.9003e-06,
                    8.0959e-06,
                    8.3013e-06,
                    8.5132e-06,
                    8.7295e-06,
                    8.95e-06,
                    9.1799e-06,
                    9.4154e-06,
                    9.6606e-06,
                    9.9152e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Fossil_3GHG": 0.02,
                "Fossil_3GHG_timeseries": [
                    2.4043e-08,
                    4.9771e-08,
                    7.719e-08,
                    1.063e-07,
                    1.3711e-07,
                    1.6962e-07,
                    2.0383e-07,
                    2.3975e-07,
                    2.7738e-07,
                    3.167e-07,
                    3.5791e-07,
                    4.0098e-07,
                    4.476e-07,
                    4.961e-07,
                    5.4648e-07,
                    5.9876e-07,
                    6.5294e-07,
                    7.0901e-07,
                    7.6698e-07,
                    8.2686e-07,
                    8.8713e-07,
                    9.4783e-07,
                    1.009e-06,
                    1.0705e-06,
                    1.1326e-06,
                    1.1951e-06,
                    1.2581e-06,
                    1.3215e-06,
                    1.3854e-06,
                    1.4497e-06,
                    1.5142e-06,
                    1.579e-06,
                    1.6425e-06,
                    1.7063e-06,
                    1.7703e-06,
                    1.8346e-06,
                    1.8992e-06,
                    1.9641e-06,
                    2.0292e-06,
                    2.0948e-06,
                    2.1607e-06,
                    2.2269e-06,
                    2.2935e-06,
                    2.3604e-06,
                    2.4278e-06,
                    2.4955e-06,
                    2.5636e-06,
                    2.6322e-06,
                    2.7012e-06,
                    2.7707e-06,
                    2.8453e-06,
                    2.9252e-06,
                    3.0104e-06,
                    3.101e-06,
                    3.1971e-06,
                    3.2989e-06,
                    3.4065e-06,
                    3.5199e-06,
                    3.6404e-06,
                    3.7681e-06,
                    3.906e-06,
                    4.0541e-06,
                    4.2126e-06,
                    4.3816e-06,
                    4.5614e-06,
                    4.7521e-06,
                    4.9539e-06,
                    5.1669e-06,
                    5.3914e-06,
                    5.6275e-06,
                    5.8682e-06,
                    6.1397e-06,
                    6.43e-06,
                    6.7102e-06,
                    6.9893e-06,
                    7.2643e-06,
                    7.5501e-06,
                    7.8472e-06,
                    8.1462e-06,
                    8.4531e-06,
                    8.7664e-06,
                    9.0807e-06,
                    9.3959e-06,
                    9.7169e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_3GHG": 0.05,
                "Land_3GHG_timeseries": [
                    8.8235e-08,
                    1.7074e-07,
                    2.4703e-07,
                    3.1718e-07,
                    3.814e-07,
                    4.3999e-07,
                    4.9322e-07,
                    5.4134e-07,
                    5.8469e-07,
                    6.6008e-07,
                    7.4905e-07,
                    8.461e-07,
                    9.489e-07,
                    1.0561e-06,
                    1.1668e-06,
                    1.2804e-06,
                    1.3964e-06,
                    1.5145e-06,
                    1.6342e-06,
                    1.7486e-06,
                    1.8613e-06,
                    1.9735e-06,
                    2.0856e-06,
                    2.198e-06,
                    2.3107e-06,
                    2.4238e-06,
                    2.5373e-06,
                    2.6509e-06,
                    2.7645e-06,
                    2.8817e-06,
                    3.0001e-06,
                    3.1193e-06,
                    3.2389e-06,
                    3.3588e-06,
                    3.4788e-06,
                    3.5988e-06,
                    3.7188e-06,
                    3.8386e-06,
                    3.9582e-06,
                    4.0821e-06,
                    4.2067e-06,
                    4.3315e-06,
                    4.4562e-06,
                    4.5806e-06,
                    4.7046e-06,
                    4.8286e-06,
                    4.9524e-06,
                    5.0758e-06,
                    5.1991e-06,
                    5.3252e-06,
                    5.456e-06,
                    5.588e-06,
                    5.7191e-06,
                    5.849e-06,
                    5.9827e-06,
                    6.1165e-06,
                    6.2541e-06,
                    6.3953e-06,
                    6.5434e-06,
                    7.1414e-06,
                    7.9485e-06,
                    8.8823e-06,
                    9.9114e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Total_CO2": 0.02,
                "Total_CO2_timeseries": [
                    6.2942e-08,
                    1.1992e-07,
                    1.7046e-07,
                    2.1463e-07,
                    2.5269e-07,
                    2.8494e-07,
                    3.1168e-07,
                    3.3318e-07,
                    3.4983e-07,
                    3.9845e-07,
                    4.6041e-07,
                    5.3021e-07,
                    6.0551e-07,
                    6.8496e-07,
                    7.6769e-07,
                    8.5308e-07,
                    9.4064e-07,
                    1.03e-06,
                    1.1208e-06,
                    1.206e-06,
                    1.2891e-06,
                    1.3708e-06,
                    1.4515e-06,
                    1.5312e-06,
                    1.61e-06,
                    1.6878e-06,
                    1.7647e-06,
                    1.8407e-06,
                    1.9157e-06,
                    1.9935e-06,
                    2.0724e-06,
                    2.1518e-06,
                    2.2314e-06,
                    2.3111e-06,
                    2.3907e-06,
                    2.4702e-06,
                    2.5494e-06,
                    2.6283e-06,
                    2.7069e-06,
                    2.7885e-06,
                    2.8707e-06,
                    2.9527e-06,
                    3.0343e-06,
                    3.1153e-06,
                    3.1958e-06,
                    3.2758e-06,
                    3.3553e-06,
                    3.4341e-06,
                    3.5125e-06,
                    3.5933e-06,
                    3.6781e-06,
                    3.7633e-06,
                    3.8469e-06,
                    3.9286e-06,
                    4.0134e-06,
                    4.0973e-06,
                    4.1843e-06,
                    4.274e-06,
                    4.3696e-06,
                    4.9142e-06,
                    5.663e-06,
                    6.5332e-06,
                    7.4931e-06,
                    8.5252e-06,
                    9.6235e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.155e-08,
                    2.31e-08,
                    4.29e-08,
                    5.61e-08,
                    7.095e-08,
                    8.91e-08,
                    1.0725e-07,
                    1.287e-07,
                    1.5015e-07,
                    1.749e-07,
                    2.046e-07,
                    2.4585e-07,
                    2.8545e-07,
                    3.333e-07,
                    3.927e-07,
                    4.521e-07,
                    5.3295e-07,
                    6.2205e-07,
                    7.095e-07,
                    8.184e-07,
                    9.4215e-07,
                    1.0841e-06,
                    1.2664e-06,
                    1.4518e-06,
                    1.6276e-06,
                    1.7679e-06,
                    1.9131e-06,
                    2.121e-06,
                    2.281e-06,
                    2.9031e-06,
                    3.2608e-06,
                    3.579e-06,
                    3.9473e-06,
                    4.2281e-06,
                    4.5409e-06,
                    4.8377e-06,
                    5.2195e-06,
                    5.6361e-06,
                    6.0699e-06,
                    6.5312e-06,
                    6.9714e-06,
                    7.4442e-06,
                    7.9082e-06,
                    8.3895e-06,
                    8.8429e-06,
                    9.3719e-06,
                    9.9416e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_CO2": 0.05,
                "Land_CO2_timeseries": [
                    6.2942e-08,
                    1.1992e-07,
                    1.7046e-07,
                    2.1463e-07,
                    2.5269e-07,
                    2.8494e-07,
                    3.1168e-07,
                    3.3318e-07,
                    3.4983e-07,
                    3.9845e-07,
                    4.6041e-07,
                    5.3021e-07,
                    6.0551e-07,
                    6.8496e-07,
                    7.6769e-07,
                    8.5308e-07,
                    9.4064e-07,
                    1.03e-06,
                    1.1208e-06,
                    1.206e-06,
                    1.2891e-06,
                    1.3708e-06,
                    1.4515e-06,
                    1.5312e-06,
                    1.61e-06,
                    1.6878e-06,
                    1.7647e-06,
                    1.8407e-06,
                    1.9157e-06,
                    1.9935e-06,
                    2.0724e-06,
                    2.1518e-06,
                    2.2314e-06,
                    2.3111e-06,
                    2.3907e-06,
                    2.4702e-06,
                    2.5494e-06,
                    2.6283e-06,
                    2.7069e-06,
                    2.7885e-06,
                    2.8707e-06,
                    2.9527e-06,
                    3.0343e-06,
                    3.1153e-06,
                    3.1958e-06,
                    3.2758e-06,
                    3.3553e-06,
                    3.4341e-06,
                    3.5125e-06,
                    3.5933e-06,
                    3.6781e-06,
                    3.7633e-06,
                    3.8469e-06,
                    3.9286e-06,
                    4.0134e-06,
                    4.0973e-06,
                    4.1843e-06,
                    4.274e-06,
                    4.3696e-06,
                    4.9142e-06,
                    5.663e-06,
                    6.5332e-06,
                    7.4931e-06,
                    8.5252e-06,
                    9.6235e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Total_CH4": 0.05,
                "Total_CH4_timeseries": [
                    3.6508e-08,
                    7.4687e-08,
                    1.1454e-07,
                    1.5608e-07,
                    1.9931e-07,
                    2.4422e-07,
                    2.9084e-07,
                    3.3915e-07,
                    3.8917e-07,
                    4.409e-07,
                    4.9472e-07,
                    5.5063e-07,
                    6.1031e-07,
                    6.721e-07,
                    7.36e-07,
                    8.0201e-07,
                    8.7013e-07,
                    9.4038e-07,
                    1.0128e-06,
                    1.0873e-06,
                    1.1624e-06,
                    1.2381e-06,
                    1.3144e-06,
                    1.3913e-06,
                    1.4688e-06,
                    1.5469e-06,
                    1.6256e-06,
                    1.705e-06,
                    1.7849e-06,
                    1.8654e-06,
                    1.9462e-06,
                    2.0273e-06,
                    2.1071e-06,
                    2.1872e-06,
                    2.2676e-06,
                    2.3482e-06,
                    2.4292e-06,
                    2.5105e-06,
                    2.592e-06,
                    2.674e-06,
                    2.7562e-06,
                    2.8388e-06,
                    2.9217e-06,
                    3.005e-06,
                    3.0887e-06,
                    3.1727e-06,
                    3.2572e-06,
                    3.3421e-06,
                    3.4273e-06,
                    3.5131e-06,
                    3.6043e-06,
                    3.7012e-06,
                    3.8038e-06,
                    3.9122e-06,
                    4.0264e-06,
                    4.1467e-06,
                    4.2731e-06,
                    4.4057e-06,
                    4.5458e-06,
                    4.6936e-06,
                    4.8554e-06,
                    5.0315e-06,
                    5.222e-06,
                    5.4271e-06,
                    5.6469e-06,
                    5.8816e-06,
                    6.1314e-06,
                    6.3965e-06,
                    6.677e-06,
                    6.9732e-06,
                    7.2784e-06,
                    7.6188e-06,
                    7.9824e-06,
                    8.3403e-06,
                    8.7015e-06,
                    9.0631e-06,
                    9.4398e-06,
                    9.8323e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_CH4": 0.06,
                "Fossil_CH4_timeseries": [
                    2.2443e-08,
                    4.6545e-08,
                    7.2313e-08,
                    9.9751e-08,
                    1.2886e-07,
                    1.5966e-07,
                    1.9213e-07,
                    2.263e-07,
                    2.6216e-07,
                    2.9971e-07,
                    3.3913e-07,
                    3.8042e-07,
                    4.2524e-07,
                    4.7193e-07,
                    5.2051e-07,
                    5.7097e-07,
                    6.2332e-07,
                    6.7756e-07,
                    7.3369e-07,
                    7.9172e-07,
                    8.5012e-07,
                    9.0889e-07,
                    9.6802e-07,
                    1.0275e-06,
                    1.0874e-06,
                    1.1476e-06,
                    1.2082e-06,
                    1.2692e-06,
                    1.3305e-06,
                    1.3922e-06,
                    1.4541e-06,
                    1.5163e-06,
                    1.5772e-06,
                    1.6383e-06,
                    1.6996e-06,
                    1.7612e-06,
                    1.8231e-06,
                    1.8852e-06,
                    1.9476e-06,
                    2.0103e-06,
                    2.0733e-06,
                    2.1366e-06,
                    2.2002e-06,
                    2.2641e-06,
                    2.3283e-06,
                    2.3929e-06,
                    2.4579e-06,
                    2.5233e-06,
                    2.589e-06,
                    2.6551e-06,
                    2.7263e-06,
                    2.8026e-06,
                    2.8842e-06,
                    2.9712e-06,
                    3.0636e-06,
                    3.1615e-06,
                    3.2651e-06,
                    3.3745e-06,
                    3.4908e-06,
                    3.6144e-06,
                    3.748e-06,
                    3.8918e-06,
                    4.0459e-06,
                    4.2106e-06,
                    4.3859e-06,
                    4.572e-06,
                    4.7692e-06,
                    4.9776e-06,
                    5.1974e-06,
                    5.4288e-06,
                    5.6646e-06,
                    5.9313e-06,
                    6.2167e-06,
                    6.4919e-06,
                    6.766e-06,
                    7.0359e-06,
                    7.3165e-06,
                    7.6084e-06,
                    7.9021e-06,
                    8.2036e-06,
                    8.5115e-06,
                    8.8202e-06,
                    9.1298e-06,
                    9.4451e-06,
                    9.7595e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002
                ],
                "Land_CH4": 0.04,
                "Land_CH4_timeseries": [
                    1.4065e-08,
                    2.8142e-08,
                    4.2231e-08,
                    5.6331e-08,
                    7.0443e-08,
                    8.4568e-08,
                    9.8703e-08,
                    1.1285e-07,
                    1.2701e-07,
                    1.4118e-07,
                    1.5558e-07,
                    1.7021e-07,
                    1.8508e-07,
                    2.0017e-07,
                    2.1549e-07,
                    2.3104e-07,
                    2.4682e-07,
                    2.6283e-07,
                    2.7907e-07,
                    2.9554e-07,
                    3.1224e-07,
                    3.2919e-07,
                    3.4636e-07,
                    3.6378e-07,
                    3.8143e-07,
                    3.9932e-07,
                    4.1744e-07,
                    4.358e-07,
                    4.544e-07,
                    4.7323e-07,
                    4.921e-07,
                    5.1101e-07,
                    5.2996e-07,
                    5.4894e-07,
                    5.6797e-07,
                    5.8703e-07,
                    6.0613e-07,
                    6.2527e-07,
                    6.4445e-07,
                    6.6366e-07,
                    6.8292e-07,
                    7.0221e-07,
                    7.2155e-07,
                    7.4092e-07,
                    7.6033e-07,
                    7.7979e-07,
                    7.9928e-07,
                    8.1881e-07,
                    8.3838e-07,
                    8.5798e-07,
                    8.7805e-07,
                    8.9857e-07,
                    9.1955e-07,
                    9.4098e-07,
                    9.6288e-07,
                    9.8522e-07,
                    1.008e-06,
                    1.0313e-06,
                    1.055e-06,
                    1.0792e-06,
                    1.1074e-06,
                    1.1397e-06,
                    1.1761e-06,
                    1.2165e-06,
                    1.261e-06,
                    1.3096e-06,
                    1.3622e-06,
                    1.4189e-06,
                    1.4796e-06,
                    1.5444e-06,
                    1.6137e-06,
                    1.6875e-06,
                    1.7657e-06,
                    1.8484e-06,
                    1.9356e-06,
                    2.0272e-06,
                    2.1233e-06,
                    2.2239e-06,
                    2.3289e-06,
                    2.4384e-06,
                    2.55e-06,
                    2.6636e-06,
                    2.7792e-06,
                    2.8969e-06,
                    3.0167e-06,
                    3.154e-06,
                    3.3095e-06,
                    3.4837e-06,
                    3.6772e-06,
                    3.8906e-06,
                    4.1251e-06,
                    4.3814e-06,
                    4.6603e-06,
                    4.9623e-06,
                    5.2882e-06,
                    5.6387e-06,
                    6.0143e-06,
                    6.4158e-06,
                    6.8439e-06,
                    7.2992e-06,
                    7.785e-06,
                    8.2947e-06,
                    8.8252e-06,
                    9.3762e-06,
                    9.9498e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_N2O": 0.04,
                "Total_N2O_timeseries": [
                    1.2828e-08,
                    2.5906e-08,
                    3.9224e-08,
                    5.2767e-08,
                    6.6516e-08,
                    8.045e-08,
                    9.4541e-08,
                    1.0876e-07,
                    1.2307e-07,
                    1.3743e-07,
                    1.5183e-07,
                    1.6625e-07,
                    1.8068e-07,
                    1.9514e-07,
                    2.096e-07,
                    2.2408e-07,
                    2.3858e-07,
                    2.531e-07,
                    2.6764e-07,
                    2.8222e-07,
                    2.9703e-07,
                    3.1243e-07,
                    3.287e-07,
                    3.4602e-07,
                    3.645e-07,
                    3.8417e-07,
                    4.0496e-07,
                    4.2676e-07,
                    4.4932e-07,
                    4.7236e-07,
                    4.9566e-07,
                    5.192e-07,
                    5.4292e-07,
                    5.6682e-07,
                    5.9086e-07,
                    6.1505e-07,
                    6.3937e-07,
                    6.6385e-07,
                    6.8849e-07,
                    7.1438e-07,
                    7.4053e-07,
                    7.6696e-07,
                    7.9366e-07,
                    8.2066e-07,
                    8.4797e-07,
                    8.756e-07,
                    9.0356e-07,
                    9.3186e-07,
                    9.6051e-07,
                    9.8953e-07,
                    1.0189e-06,
                    1.0486e-06,
                    1.0787e-06,
                    1.1092e-06,
                    1.1401e-06,
                    1.1714e-06,
                    1.2032e-06,
                    1.2354e-06,
                    1.2683e-06,
                    1.3017e-06,
                    1.3361e-06,
                    1.3717e-06,
                    1.4089e-06,
                    1.4481e-06,
                    1.4892e-06,
                    1.5326e-06,
                    1.5783e-06,
                    1.6261e-06,
                    1.6761e-06,
                    1.728e-06,
                    1.7819e-06,
                    1.838e-06,
                    1.8965e-06,
                    1.9575e-06,
                    2.0207e-06,
                    2.0861e-06,
                    2.1535e-06,
                    2.2223e-06,
                    2.2922e-06,
                    2.3625e-06,
                    2.4327e-06,
                    2.5023e-06,
                    2.571e-06,
                    2.6386e-06,
                    2.7049e-06,
                    2.7701e-06,
                    2.8341e-06,
                    2.8973e-06,
                    2.9599e-06,
                    3.0225e-06,
                    3.0911e-06,
                    3.1756e-06,
                    3.2834e-06,
                    3.4195e-06,
                    3.5864e-06,
                    3.7844e-06,
                    4.0109e-06,
                    4.2612e-06,
                    4.5281e-06,
                    4.8018e-06,
                    5.0739e-06,
                    5.3394e-06,
                    5.5946e-06,
                    5.8371e-06,
                    6.0657e-06,
                    6.2803e-06,
                    6.4823e-06,
                    6.674e-06,
                    6.8592e-06,
                    7.0428e-06,
                    7.2359e-06,
                    7.4337e-06,
                    7.6401e-06,
                    7.8555e-06,
                    8.0779e-06,
                    8.3043e-06,
                    8.5301e-06,
                    8.7606e-06,
                    8.9858e-06,
                    9.2262e-06,
                    9.4559e-06,
                    9.6975e-06,
                    9.9549e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_N2O": 0.02,
                "Fossil_N2O_timeseries": [
                    1.6004e-09,
                    3.2264e-09,
                    4.8772e-09,
                    6.5517e-09,
                    8.2483e-09,
                    9.9654e-09,
                    1.1701e-08,
                    1.3452e-08,
                    1.5216e-08,
                    1.699e-08,
                    1.8773e-08,
                    2.0563e-08,
                    2.236e-08,
                    2.4164e-08,
                    2.5975e-08,
                    2.7793e-08,
                    2.9619e-08,
                    3.1451e-08,
                    3.3291e-08,
                    3.5139e-08,
                    3.7012e-08,
                    3.8938e-08,
                    4.0939e-08,
                    4.3028e-08,
                    4.5216e-08,
                    4.7504e-08,
                    4.9888e-08,
                    5.2356e-08,
                    5.4892e-08,
                    5.7471e-08,
                    6.0077e-08,
                    6.2707e-08,
                    6.5358e-08,
                    6.8028e-08,
                    7.0715e-08,
                    7.342e-08,
                    7.6142e-08,
                    7.8881e-08,
                    8.164e-08,
                    8.4495e-08,
                    8.7391e-08,
                    9.033e-08,
                    9.3313e-08,
                    9.6342e-08,
                    9.942e-08,
                    1.0255e-07,
                    1.0573e-07,
                    1.0897e-07,
                    1.1226e-07,
                    1.1562e-07,
                    1.1904e-07,
                    1.2254e-07,
                    1.2613e-07,
                    1.298e-07,
                    1.3357e-07,
                    1.3743e-07,
                    1.4138e-07,
                    1.4542e-07,
                    1.4953e-07,
                    1.5372e-07,
                    1.5796e-07,
                    1.6227e-07,
                    1.6663e-07,
                    1.7105e-07,
                    1.7553e-07,
                    1.8005e-07,
                    1.8463e-07,
                    1.8927e-07,
                    1.9396e-07,
                    1.9871e-07,
                    2.0351e-07,
                    2.0838e-07,
                    2.133e-07,
                    2.1828e-07,
                    2.2333e-07,
                    2.2843e-07,
                    2.336e-07,
                    2.3882e-07,
                    2.4412e-07,
                    2.4949e-07,
                    2.5493e-07,
                    2.6046e-07,
                    2.6609e-07,
                    2.7183e-07,
                    2.7769e-07,
                    2.8368e-07,
                    2.898e-07,
                    2.9606e-07,
                    3.0247e-07,
                    3.0903e-07,
                    3.1579e-07,
                    3.2284e-07,
                    3.3025e-07,
                    3.3807e-07,
                    3.4633e-07,
                    3.5505e-07,
                    3.6423e-07,
                    3.7386e-07,
                    3.8389e-07,
                    3.9428e-07,
                    4.0501e-07,
                    4.1608e-07,
                    4.2752e-07,
                    4.3932e-07,
                    4.5149e-07,
                    4.6402e-07,
                    4.7692e-07,
                    4.9016e-07,
                    5.0374e-07,
                    5.1763e-07,
                    5.3185e-07,
                    5.4641e-07,
                    5.6136e-07,
                    5.7671e-07,
                    5.9249e-07,
                    6.0871e-07,
                    6.254e-07,
                    6.4255e-07,
                    6.6018e-07,
                    6.807e-07,
                    7.023e-07,
                    7.246e-07,
                    7.4681e-07,
                    7.6912e-07,
                    7.9198e-07,
                    8.1425e-07,
                    8.3715e-07,
                    8.6091e-07,
                    8.86e-07,
                    9.1196e-07,
                    9.3907e-07,
                    9.7492e-07,
                    1.0093e-06,
                    1.0414e-06,
                    1.0776e-06,
                    1.1154e-06,
                    1.1542e-06,
                    1.1922e-06,
                    1.2356e-06,
                    1.2802e-06,
                    1.3256e-06,
                    1.3719e-06,
                    1.4194e-06,
                    1.4711e-06,
                    1.5253e-06,
                    1.5849e-06,
                    1.6433e-06,
                    1.7048e-06,
                    1.7714e-06,
                    1.8389e-06,
                    1.9068e-06,
                    1.977e-06,
                    2.0506e-06,
                    2.1256e-06,
                    2.2027e-06,
                    2.2817e-06,
                    2.3637e-06,
                    2.4491e-06,
                    2.5515e-06,
                    2.6542e-06,
                    2.7586e-06,
                    2.8635e-06,
                    2.9686e-06,
                    3.0762e-06,
                    3.1876e-06,
                    3.3025e-06,
                    3.4191e-06,
                    3.5411e-06,
                    3.6681e-06,
                    3.8e-06,
                    3.9341e-06,
                    4.0749e-06
                ],
                "Land_N2O": 0.05,
                "Land_N2O_timeseries": [
                    1.1227e-08,
                    2.268e-08,
                    3.4346e-08,
                    4.6215e-08,
                    5.8268e-08,
                    7.0484e-08,
                    8.284e-08,
                    9.5308e-08,
                    1.0785e-07,
                    1.2044e-07,
                    1.3306e-07,
                    1.4568e-07,
                    1.5832e-07,
                    1.7097e-07,
                    1.8363e-07,
                    1.9629e-07,
                    2.0896e-07,
                    2.2165e-07,
                    2.3435e-07,
                    2.4708e-07,
                    2.6002e-07,
                    2.7349e-07,
                    2.8776e-07,
                    3.0299e-07,
                    3.1928e-07,
                    3.3666e-07,
                    3.5508e-07,
                    3.744e-07,
                    3.9443e-07,
                    4.1489e-07,
                    4.3559e-07,
                    4.5649e-07,
                    4.7757e-07,
                    4.9879e-07,
                    5.2014e-07,
                    5.4162e-07,
                    5.6323e-07,
                    5.8497e-07,
                    6.0685e-07,
                    6.2989e-07,
                    6.5314e-07,
                    6.7663e-07,
                    7.0035e-07,
                    7.2432e-07,
                    7.4855e-07,
                    7.7305e-07,
                    7.9783e-07,
                    8.2289e-07,
                    8.4825e-07,
                    8.7391e-07,
                    8.9986e-07,
                    9.2609e-07,
                    9.526e-07,
                    9.7941e-07,
                    1.0065e-06,
                    1.034e-06,
                    1.0618e-06,
                    1.09e-06,
                    1.1187e-06,
                    1.148e-06,
                    1.1781e-06,
                    1.2094e-06,
                    1.2423e-06,
                    1.277e-06,
                    1.3137e-06,
                    1.3526e-06,
                    1.3936e-06,
                    1.4368e-06,
                    1.4821e-06,
                    1.5293e-06,
                    1.5784e-06,
                    1.6296e-06,
                    1.6832e-06,
                    1.7392e-06,
                    1.7974e-06,
                    1.8577e-06,
                    1.9199e-06,
                    1.9835e-06,
                    2.048e-06,
                    2.113e-06,
                    2.1778e-06,
                    2.2418e-06,
                    2.3049e-06,
                    2.3668e-06,
                    2.4272e-06,
                    2.4864e-06,
                    2.5443e-06,
                    2.6012e-06,
                    2.6575e-06,
                    2.7135e-06,
                    2.7753e-06,
                    2.8527e-06,
                    2.9531e-06,
                    3.0814e-06,
                    3.2401e-06,
                    3.4293e-06,
                    3.6467e-06,
                    3.8874e-06,
                    4.1442e-06,
                    4.4076e-06,
                    4.6689e-06,
                    4.9233e-06,
                    5.167e-06,
                    5.3977e-06,
                    5.6142e-06,
                    5.8163e-06,
                    6.0054e-06,
                    6.1839e-06,
                    6.3555e-06,
                    6.5252e-06,
                    6.704e-06,
                    6.8873e-06,
                    7.0788e-06,
                    7.2787e-06,
                    7.4854e-06,
                    7.6956e-06,
                    7.9047e-06,
                    8.1181e-06,
                    8.3256e-06,
                    8.5455e-06,
                    8.7536e-06,
                    8.9729e-06,
                    9.2081e-06,
                    9.4078e-06,
                    9.6275e-06,
                    9.8538e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            1.62874,
                            6.23453
                        ],
                        [
                            1.77151,
                            6.28179
                        ],
                        [
                            1.78855,
                            6.35173
                        ],
                        [
                            1.74971,
                            6.46415
                        ],
                        [
                            1.69729,
                            6.5494
                        ],
                        [
                            1.61734,
                            6.59744
                        ],
                        [
                            1.58949,
                            6.68302
                        ],
                        [
                            1.61894,
                            6.74249
                        ],
                        [
                            1.5992,
                            6.8123
                        ],
                        [
                            1.60551,
                            6.90352
                        ],
                        [
                            1.55809,
                            6.99517
                        ],
                        [
                            1.64177,
                            6.99653
                        ],
                        [
                            1.63649,
                            7.41788
                        ],
                        [
                            1.65259,
                            7.53574
                        ],
                        [
                            1.63138,
                            7.66448
                        ],
                        [
                            1.63618,
                            7.98771
                        ],
                        [
                            1.63346,
                            8.31729
                        ],
                        [
                            1.62013,
                            8.3739
                        ],
                        [
                            1.64834,
                            8.49147
                        ],
                        [
                            1.63114,
                            8.52153
                        ],
                        [
                            1.63302,
                            8.79477
                        ],
                        [
                            1.61638,
                            9.07352
                        ],
                        [
                            1.55917,
                            9.16964
                        ],
                        [
                            1.42003,
                            9.30942
                        ],
                        [
                            1.39101,
                            9.49408
                        ],
                        [
                            1.34261,
                            9.54825
                        ],
                        [
                            1.36571,
                            9.61091
                        ],
                        [
                            1.35357,
                            10.00081
                        ],
                        [
                            1.13701,
                            10.1275
                        ],
                        [
                            1.01622,
                            10.20776
                        ],
                        [
                            0.77512,
                            10.38534
                        ],
                        [
                            0.78313,
                            10.51013
                        ],
                        [
                            0.80742,
                            10.5897
                        ],
                        [
                            0.81008,
                            10.73402
                        ],
                        [
                            0.87359,
                            10.80519
                        ],
                        [
                            0.90017,
                            10.88615
                        ],
                        [
                            0.91216,
                            10.99649
                        ],
                        [
                            0.65727,
                            10.99723
                        ],
                        [
                            0.49724,
                            10.93257
                        ],
                        [
                            0.50093,
                            11.00901
                        ],
                        [
                            -0.14201,
                            11.13898
                        ],
                        [
                            -0.11177,
                            11.09053
                        ],
                        [
                            -0.03635,
                            11.10499
                        ],
                        [
                            0.02268,
                            11.08069
                        ],
                        [
                            0.0327,
                            10.97987
                        ],
                        [
                            -0.00579,
                            10.95874
                        ],
                        [
                            -0.0226,
                            10.82025
                        ],
                        [
                            -0.08994,
                            10.70936
                        ],
                        [
                            -0.05969,
                            10.6325
                        ],
                        [
                            0.03896,
                            10.60033
                        ],
                        [
                            0.06286,
                            10.56025
                        ],
                        [
                            0.14325,
                            10.52471
                        ],
                        [
                            0.19464,
                            10.40138
                        ],
                        [
                            0.21892,
                            10.42271
                        ],
                        [
                            0.29487,
                            10.37483
                        ],
                        [
                            0.36234,
                            10.25832
                        ],
                        [
                            0.35163,
                            10.16646
                        ],
                        [
                            0.36034,
                            10.0288
                        ],
                        [
                            0.3848,
                            9.94812
                        ],
                        [
                            0.35158,
                            9.89737
                        ],
                        [
                            0.35702,
                            9.84327
                        ],
                        [
                            0.32121,
                            9.72518
                        ],
                        [
                            0.38175,
                            9.6408
                        ],
                        [
                            0.35682,
                            9.56927
                        ],
                        [
                            0.24364,
                            9.57111
                        ],
                        [
                            0.23184,
                            9.4627
                        ],
                        [
                            0.2848,
                            9.42932
                        ],
                        [
                            0.35963,
                            9.49776
                        ],
                        [
                            0.4872,
                            9.48619
                        ],
                        [
                            0.49902,
                            9.43781
                        ],
                        [
                            0.56382,
                            9.40264
                        ],
                        [
                            0.5548,
                            9.31677
                        ],
                        [
                            0.50386,
                            9.25493
                        ],
                        [
                            0.52992,
                            9.20526
                        ],
                        [
                            0.47581,
                            9.1447
                        ],
                        [
                            0.45533,
                            9.03687
                        ],
                        [
                            0.51072,
                            8.93721
                        ],
                        [
                            0.51982,
                            8.85721
                        ],
                        [
                            0.49713,
                            8.81469
                        ],
                        [
                            0.38161,
                            8.79077
                        ],
                        [
                            0.38199,
                            8.73909
                        ],
                        [
                            0.47152,
                            8.59588
                        ],
                        [
                            0.56941,
                            8.52594
                        ],
                        [
                            0.62633,
                            8.50859
                        ],
                        [
                            0.73043,
                            8.3458
                        ],
                        [
                            0.73104,
                            8.29182
                        ],
                        [
                            0.63863,
                            8.25825
                        ],
                        [
                            0.58361,
                            8.09393
                        ],
                        [
                            0.62392,
                            7.86632
                        ],
                        [
                            0.61966,
                            7.74649
                        ],
                        [
                            0.58719,
                            7.62718
                        ],
                        [
                            0.53004,
                            7.58398
                        ],
                        [
                            0.52081,
                            7.51608
                        ],
                        [
                            0.53837,
                            7.42485
                        ],
                        [
                            0.5677,
                            7.39565
                        ],
                        [
                            0.64268,
                            7.39982
                        ],
                        [
                            0.65842,
                            7.31871
                        ],
                        [
                            0.63731,
                            7.22555
                        ],
                        [
                            0.59299,
                            7.11422
                        ],
                        [
                            0.601,
                            7.02637
                        ],
                        [
                            0.52347,
                            6.97386
                        ],
                        [
                            0.56485,
                            6.9202
                        ],
                        [
                            0.53526,
                            6.8764
                        ],
                        [
                            0.58001,
                            6.76448
                        ],
                        [
                            0.64276,
                            6.72271
                        ],
                        [
                            0.63857,
                            6.63626
                        ],
                        [
                            0.74321,
                            6.55878
                        ],
                        [
                            0.71329,
                            6.5294
                        ],
                        [
                            0.74903,
                            6.44342
                        ],
                        [
                            0.85667,
                            6.38367
                        ],
                        [
                            0.89396,
                            6.33329
                        ],
                        [
                            1.00528,
                            6.33264
                        ],
                        [
                            1.02438,
                            6.25414
                        ],
                        [
                            1.08535,
                            6.16824
                        ],
                        [
                            1.2002,
                            6.16851
                        ],
                        [
                            1.19961,
                            6.11242
                        ],
                        [
                            1.38118,
                            6.17718
                        ],
                        [
                            1.62874,
                            6.23453
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "TON",
                "Country": "Tonga",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    2.6325e-08,
                    5.2683e-08,
                    7.9105e-08,
                    1.0561e-07,
                    1.3221e-07,
                    1.5893e-07,
                    1.8578e-07,
                    2.1276e-07,
                    2.3988e-07,
                    2.6679e-07,
                    2.9345e-07,
                    3.1998e-07,
                    3.4645e-07,
                    3.7289e-07,
                    3.9932e-07,
                    4.2578e-07,
                    4.5228e-07,
                    4.7884e-07,
                    5.0549e-07,
                    5.3227e-07,
                    5.5916e-07,
                    5.8621e-07,
                    6.1345e-07,
                    6.409e-07,
                    6.6859e-07,
                    6.9654e-07,
                    7.2474e-07,
                    7.5321e-07,
                    7.8192e-07,
                    8.1087e-07,
                    8.4012e-07,
                    8.6967e-07,
                    8.9953e-07,
                    9.2973e-07,
                    9.6026e-07,
                    9.9114e-07,
                    1.0224e-06,
                    1.054e-06,
                    1.0859e-06,
                    1.1183e-06,
                    1.1511e-06,
                    1.1842e-06,
                    1.2176e-06,
                    1.2515e-06,
                    1.2857e-06,
                    1.3204e-06,
                    1.3555e-06,
                    1.391e-06,
                    1.427e-06,
                    1.4634e-06,
                    1.5003e-06,
                    1.5376e-06,
                    1.5755e-06,
                    1.6138e-06,
                    1.6527e-06,
                    1.6922e-06,
                    1.7322e-06,
                    1.7728e-06,
                    1.8139e-06,
                    1.8555e-06,
                    1.8974e-06,
                    1.9398e-06,
                    1.9826e-06,
                    2.0259e-06,
                    2.0697e-06,
                    2.1141e-06,
                    2.1589e-06,
                    2.2044e-06,
                    2.2504e-06,
                    2.2969e-06,
                    2.344e-06,
                    2.3917e-06,
                    2.4399e-06,
                    2.4887e-06,
                    2.5381e-06,
                    2.5882e-06,
                    2.6389e-06,
                    2.6902e-06,
                    2.7422e-06,
                    2.7946e-06,
                    2.8479e-06,
                    2.9018e-06,
                    2.9565e-06,
                    3.0118e-06,
                    3.068e-06,
                    3.1247e-06,
                    3.182e-06,
                    3.24e-06,
                    3.2986e-06,
                    3.358e-06,
                    3.4185e-06,
                    3.4801e-06,
                    3.5428e-06,
                    3.6066e-06,
                    3.6719e-06,
                    3.7389e-06,
                    3.8077e-06,
                    3.878e-06,
                    3.95e-06,
                    4.0364e-06,
                    4.133e-06,
                    4.2357e-06,
                    4.3442e-06,
                    4.4556e-06,
                    4.5723e-06,
                    4.6936e-06,
                    4.8134e-06,
                    4.9371e-06,
                    5.0664e-06,
                    5.1965e-06,
                    5.3405e-06,
                    5.5025e-06,
                    5.6634e-06,
                    5.8382e-06,
                    6.0324e-06,
                    6.2245e-06,
                    6.4119e-06,
                    6.6154e-06,
                    6.7986e-06,
                    6.9734e-06,
                    7.1266e-06,
                    7.2618e-06,
                    7.396e-06,
                    7.5255e-06,
                    7.6564e-06,
                    7.7939e-06,
                    7.94e-06,
                    8.1152e-06,
                    8.3042e-06,
                    8.494e-06,
                    8.6993e-06,
                    8.8622e-06,
                    8.9935e-06,
                    9.1033e-06,
                    9.2306e-06,
                    9.3539e-06,
                    9.499e-06,
                    9.6485e-06,
                    9.7786e-06,
                    9.8981e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    2.8701e-09,
                    5.7663e-09,
                    8.688e-09,
                    1.1635e-08,
                    1.4606e-08,
                    1.7601e-08,
                    2.0617e-08,
                    2.3655e-08,
                    2.6713e-08,
                    2.9789e-08,
                    3.2849e-08,
                    3.5894e-08,
                    3.8923e-08,
                    4.1937e-08,
                    4.4935e-08,
                    4.7918e-08,
                    5.0886e-08,
                    5.3838e-08,
                    5.6776e-08,
                    5.97e-08,
                    6.2614e-08,
                    6.5535e-08,
                    6.8475e-08,
                    7.1443e-08,
                    7.4443e-08,
                    7.7476e-08,
                    8.0541e-08,
                    8.363e-08,
                    8.6735e-08,
                    8.9841e-08,
                    9.2961e-08,
                    9.6101e-08,
                    9.9261e-08,
                    1.0244e-07,
                    1.0564e-07,
                    1.0885e-07,
                    1.1208e-07,
                    1.1534e-07,
                    1.1861e-07,
                    1.219e-07,
                    1.2521e-07,
                    1.2853e-07,
                    1.3186e-07,
                    1.352e-07,
                    1.3857e-07,
                    1.4194e-07,
                    1.4533e-07,
                    1.4874e-07,
                    1.5217e-07,
                    1.5562e-07,
                    1.5909e-07,
                    1.6259e-07,
                    1.6612e-07,
                    1.6967e-07,
                    1.7326e-07,
                    1.7688e-07,
                    1.8053e-07,
                    1.8421e-07,
                    1.8793e-07,
                    1.9166e-07,
                    1.9542e-07,
                    1.9919e-07,
                    2.0297e-07,
                    2.0676e-07,
                    2.1057e-07,
                    2.144e-07,
                    2.1823e-07,
                    2.2208e-07,
                    2.2595e-07,
                    2.2983e-07,
                    2.3372e-07,
                    2.3762e-07,
                    2.4153e-07,
                    2.4546e-07,
                    2.4939e-07,
                    2.5333e-07,
                    2.5728e-07,
                    2.6124e-07,
                    2.652e-07,
                    2.6918e-07,
                    2.7318e-07,
                    2.772e-07,
                    2.8124e-07,
                    2.853e-07,
                    2.8939e-07,
                    2.9349e-07,
                    2.9763e-07,
                    3.0179e-07,
                    3.0599e-07,
                    3.1022e-07,
                    3.1466e-07,
                    3.1936e-07,
                    3.2439e-07,
                    3.2978e-07,
                    3.3595e-07,
                    3.4293e-07,
                    3.507e-07,
                    3.5926e-07,
                    3.6857e-07,
                    3.8215e-07,
                    3.9744e-07,
                    4.1435e-07,
                    4.3279e-07,
                    4.5266e-07,
                    4.7388e-07,
                    4.9642e-07,
                    5.2029e-07,
                    5.4561e-07,
                    5.7257e-07,
                    6.032e-07,
                    6.3601e-07,
                    6.7137e-07,
                    7.0954e-07,
                    7.5066e-07,
                    7.9433e-07,
                    8.4052e-07,
                    8.9087e-07,
                    9.4355e-07,
                    9.9669e-07,
                    1.0536e-06,
                    1.1078e-06,
                    1.1618e-06,
                    1.2156e-06,
                    1.266e-06,
                    1.3197e-06,
                    1.3709e-06,
                    1.4207e-06,
                    1.4731e-06,
                    1.5255e-06,
                    1.5758e-06,
                    1.6274e-06,
                    1.6747e-06,
                    1.7214e-06,
                    1.7649e-06,
                    1.8056e-06,
                    1.8429e-06,
                    1.8811e-06,
                    1.9231e-06,
                    1.9633e-06,
                    2.0108e-06,
                    2.059e-06,
                    2.0997e-06,
                    2.1481e-06,
                    2.2021e-06,
                    2.2585e-06,
                    2.3074e-06,
                    2.3666e-06,
                    2.4213e-06,
                    2.4865e-06,
                    2.5454e-06,
                    2.6017e-06,
                    2.6659e-06,
                    2.7382e-06,
                    2.808e-06,
                    2.8806e-06,
                    2.9613e-06,
                    3.035e-06,
                    3.1132e-06,
                    3.1974e-06,
                    3.2761e-06,
                    3.348e-06,
                    3.422e-06,
                    3.4988e-06,
                    3.5748e-06,
                    3.6524e-06,
                    3.7335e-06,
                    3.8201e-06,
                    3.9067e-06,
                    4.0045e-06,
                    4.1119e-06,
                    4.2228e-06,
                    4.3328e-06
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [
                    2.3455e-08,
                    4.6917e-08,
                    7.0417e-08,
                    9.3974e-08,
                    1.1761e-07,
                    1.4133e-07,
                    1.6516e-07,
                    1.891e-07,
                    2.1317e-07,
                    2.37e-07,
                    2.606e-07,
                    2.8409e-07,
                    3.0753e-07,
                    3.3095e-07,
                    3.5438e-07,
                    3.7786e-07,
                    4.0139e-07,
                    4.25e-07,
                    4.4871e-07,
                    4.7257e-07,
                    4.9655e-07,
                    5.2067e-07,
                    5.4497e-07,
                    5.6946e-07,
                    5.9415e-07,
                    6.1906e-07,
                    6.442e-07,
                    6.6957e-07,
                    6.9519e-07,
                    7.2103e-07,
                    7.4716e-07,
                    7.7356e-07,
                    8.0027e-07,
                    8.2729e-07,
                    8.5463e-07,
                    8.8229e-07,
                    9.1028e-07,
                    9.3862e-07,
                    9.6732e-07,
                    9.9642e-07,
                    1.0259e-06,
                    1.0556e-06,
                    1.0858e-06,
                    1.1163e-06,
                    1.1472e-06,
                    1.1784e-06,
                    1.2101e-06,
                    1.2423e-06,
                    1.2748e-06,
                    1.3078e-06,
                    1.3412e-06,
                    1.375e-06,
                    1.4093e-06,
                    1.4441e-06,
                    1.4795e-06,
                    1.5153e-06,
                    1.5517e-06,
                    1.5886e-06,
                    1.626e-06,
                    1.6638e-06,
                    1.702e-06,
                    1.7406e-06,
                    1.7796e-06,
                    1.8192e-06,
                    1.8591e-06,
                    1.8997e-06,
                    1.9407e-06,
                    1.9823e-06,
                    2.0244e-06,
                    2.0671e-06,
                    2.1103e-06,
                    2.1541e-06,
                    2.1983e-06,
                    2.2433e-06,
                    2.2888e-06,
                    2.3349e-06,
                    2.3816e-06,
                    2.429e-06,
                    2.477e-06,
                    2.5254e-06,
                    2.5747e-06,
                    2.6246e-06,
                    2.6753e-06,
                    2.7265e-06,
                    2.7786e-06,
                    2.8312e-06,
                    2.8844e-06,
                    2.9383e-06,
                    2.9927e-06,
                    3.0478e-06,
                    3.1038e-06,
                    3.1607e-06,
                    3.2184e-06,
                    3.2768e-06,
                    3.336e-06,
                    3.396e-06,
                    3.457e-06,
                    3.5188e-06,
                    3.5814e-06,
                    3.6543e-06,
                    3.7356e-06,
                    3.8214e-06,
                    3.9114e-06,
                    4.0029e-06,
                    4.0984e-06,
                    4.1972e-06,
                    4.2931e-06,
                    4.3915e-06,
                    4.4939e-06,
                    4.5933e-06,
                    4.7045e-06,
                    4.8312e-06,
                    4.9539e-06,
                    5.0875e-06,
                    5.238e-06,
                    5.384e-06,
                    5.521e-06,
                    5.6718e-06,
                    5.8019e-06,
                    5.9198e-06,
                    6.0188e-06,
                    6.1e-06,
                    6.1803e-06,
                    6.2595e-06,
                    6.3367e-06,
                    6.423e-06,
                    6.5192e-06,
                    6.6421e-06,
                    6.7786e-06,
                    6.9181e-06,
                    7.0718e-06,
                    7.1874e-06,
                    7.2721e-06,
                    7.3384e-06,
                    7.425e-06,
                    7.511e-06,
                    7.618e-06,
                    7.7254e-06,
                    7.8153e-06,
                    7.8873e-06,
                    7.9612e-06,
                    8.0404e-06,
                    8.1135e-06,
                    8.1902e-06,
                    8.2415e-06,
                    8.2626e-06,
                    8.2742e-06,
                    8.2586e-06,
                    8.2372e-06,
                    8.2173e-06,
                    8.1788e-06,
                    8.1559e-06,
                    8.1582e-06,
                    8.1799e-06,
                    8.1985e-06,
                    8.2138e-06,
                    8.2156e-06,
                    8.219e-06,
                    8.2334e-06,
                    8.2594e-06,
                    8.2972e-06,
                    8.3307e-06,
                    8.369e-06,
                    8.4145e-06,
                    8.4677e-06,
                    8.5193e-06,
                    8.568e-06,
                    8.6103e-06,
                    8.6453e-06,
                    8.6744e-06,
                    8.7024e-06,
                    8.728e-06
                ],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    2.0097e-08,
                    4.0178e-08,
                    6.0275e-08,
                    8.0404e-08,
                    1.0059e-07,
                    1.2085e-07,
                    1.4119e-07,
                    1.6162e-07,
                    1.8215e-07,
                    2.0244e-07,
                    2.2251e-07,
                    2.4251e-07,
                    2.6247e-07,
                    2.8244e-07,
                    3.0245e-07,
                    3.2253e-07,
                    3.4268e-07,
                    3.6294e-07,
                    3.8332e-07,
                    4.0388e-07,
                    4.2457e-07,
                    4.4543e-07,
                    4.6647e-07,
                    4.8769e-07,
                    5.0912e-07,
                    5.3077e-07,
                    5.5264e-07,
                    5.7475e-07,
                    5.9711e-07,
                    6.1971e-07,
                    6.4258e-07,
                    6.6572e-07,
                    6.8914e-07,
                    7.1287e-07,
                    7.3689e-07,
                    7.6123e-07,
                    7.8589e-07,
                    8.1088e-07,
                    8.3621e-07,
                    8.6188e-07,
                    8.879e-07,
                    9.1427e-07,
                    9.4101e-07,
                    9.6813e-07,
                    9.9565e-07,
                    1.0236e-06,
                    1.0519e-06,
                    1.0806e-06,
                    1.1098e-06,
                    1.1394e-06,
                    1.1694e-06,
                    1.1998e-06,
                    1.2307e-06,
                    1.262e-06,
                    1.2938e-06,
                    1.3261e-06,
                    1.3588e-06,
                    1.3921e-06,
                    1.4258e-06,
                    1.4599e-06,
                    1.4944e-06,
                    1.5294e-06,
                    1.5647e-06,
                    1.6006e-06,
                    1.6368e-06,
                    1.6737e-06,
                    1.7111e-06,
                    1.749e-06,
                    1.7875e-06,
                    1.8265e-06,
                    1.8661e-06,
                    1.9062e-06,
                    1.9468e-06,
                    1.9881e-06,
                    2.0299e-06,
                    2.0724e-06,
                    2.1155e-06,
                    2.1592e-06,
                    2.2036e-06,
                    2.2484e-06,
                    2.294e-06,
                    2.3403e-06,
                    2.3874e-06,
                    2.435e-06,
                    2.4834e-06,
                    2.5324e-06,
                    2.5821e-06,
                    2.6327e-06,
                    2.6838e-06,
                    2.7357e-06,
                    2.7887e-06,
                    2.8426e-06,
                    2.8973e-06,
                    2.9527e-06,
                    3.0089e-06,
                    3.066e-06,
                    3.1241e-06,
                    3.183e-06,
                    3.2428e-06,
                    3.3162e-06,
                    3.397e-06,
                    3.4816e-06,
                    3.5697e-06,
                    3.6586e-06,
                    3.7511e-06,
                    3.8464e-06,
                    3.9383e-06,
                    4.0322e-06,
                    4.1295e-06,
                    4.2247e-06,
                    4.3305e-06,
                    4.4435e-06,
                    4.5512e-06,
                    4.6709e-06,
                    4.8082e-06,
                    4.9335e-06,
                    5.057e-06,
                    5.1903e-06,
                    5.2988e-06,
                    5.3964e-06,
                    5.4759e-06,
                    5.5401e-06,
                    5.5956e-06,
                    5.6435e-06,
                    5.6811e-06,
                    5.7141e-06,
                    5.7428e-06,
                    5.771e-06,
                    5.8135e-06,
                    5.857e-06,
                    5.8977e-06,
                    5.9233e-06,
                    5.9492e-06,
                    5.9723e-06,
                    5.9932e-06,
                    6.0131e-06,
                    6.0354e-06,
                    6.0547e-06,
                    6.0752e-06,
                    6.1018e-06,
                    6.1294e-06,
                    6.1487e-06,
                    6.1783e-06,
                    6.2235e-06,
                    6.2656e-06,
                    6.2798e-06,
                    6.3076e-06,
                    6.3307e-06,
                    6.3562e-06,
                    6.375e-06,
                    6.3909e-06,
                    6.4135e-06,
                    6.4428e-06,
                    6.4731e-06,
                    6.5211e-06,
                    6.5791e-06,
                    6.6315e-06,
                    6.7006e-06,
                    6.7706e-06,
                    6.8347e-06,
                    6.9039e-06,
                    6.9734e-06,
                    7.0493e-06,
                    7.1284e-06,
                    7.2079e-06,
                    7.289e-06,
                    7.3711e-06,
                    7.4463e-06,
                    7.5279e-06,
                    7.6164e-06,
                    7.7066e-06,
                    7.7933e-06
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    3.3e-09,
                    6.6e-09,
                    9.9e-09,
                    1.32e-08,
                    1.65e-08,
                    1.98e-08,
                    2.31e-08,
                    2.64e-08,
                    2.97e-08,
                    3.3e-08,
                    3.795e-08,
                    4.29e-08,
                    4.785e-08,
                    5.28e-08,
                    5.775e-08,
                    6.27e-08,
                    6.765e-08,
                    7.425e-08,
                    8.085e-08,
                    8.58e-08,
                    9.735e-08,
                    1.056e-07,
                    1.155e-07,
                    1.2705e-07,
                    1.3695e-07,
                    1.518e-07,
                    1.65e-07,
                    1.782e-07,
                    1.947e-07,
                    2.1285e-07,
                    2.31e-07,
                    2.5245e-07,
                    2.7225e-07,
                    2.937e-07,
                    3.1515e-07,
                    3.366e-07,
                    3.5805e-07,
                    3.828e-07,
                    4.1415e-07,
                    4.455e-07,
                    4.8345e-07,
                    5.2305e-07,
                    5.544e-07,
                    5.9235e-07,
                    6.336e-07,
                    6.765e-07,
                    7.1115e-07,
                    7.557e-07,
                    7.953e-07,
                    8.448e-07,
                    8.877e-07,
                    9.273e-07,
                    9.735e-07,
                    1.0263e-06,
                    1.0758e-06,
                    1.127e-06,
                    1.1847e-06,
                    1.2358e-06,
                    1.2903e-06,
                    1.3497e-06,
                    1.4025e-06,
                    1.4487e-06,
                    1.4966e-06,
                    1.5477e-06,
                    1.5988e-06,
                    1.6517e-06,
                    1.7078e-06,
                    1.7688e-06,
                    1.8298e-06,
                    1.9025e-06,
                    1.9849e-06,
                    2.071e-06,
                    2.1562e-06
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [
                    2.0097e-08,
                    4.0178e-08,
                    6.0275e-08,
                    8.0404e-08,
                    1.0059e-07,
                    1.2085e-07,
                    1.4119e-07,
                    1.6162e-07,
                    1.8215e-07,
                    2.0244e-07,
                    2.2251e-07,
                    2.4251e-07,
                    2.6247e-07,
                    2.8244e-07,
                    3.0245e-07,
                    3.2253e-07,
                    3.4268e-07,
                    3.6294e-07,
                    3.8332e-07,
                    4.0388e-07,
                    4.2457e-07,
                    4.4543e-07,
                    4.6647e-07,
                    4.8769e-07,
                    5.0912e-07,
                    5.3077e-07,
                    5.5264e-07,
                    5.7475e-07,
                    5.9711e-07,
                    6.1971e-07,
                    6.4258e-07,
                    6.6572e-07,
                    6.8914e-07,
                    7.1287e-07,
                    7.3689e-07,
                    7.6123e-07,
                    7.8589e-07,
                    8.1088e-07,
                    8.3621e-07,
                    8.6188e-07,
                    8.879e-07,
                    9.1427e-07,
                    9.4101e-07,
                    9.6813e-07,
                    9.9565e-07,
                    1.0236e-06,
                    1.0519e-06,
                    1.0806e-06,
                    1.1098e-06,
                    1.1394e-06,
                    1.1694e-06,
                    1.1998e-06,
                    1.2307e-06,
                    1.262e-06,
                    1.2938e-06,
                    1.3261e-06,
                    1.3588e-06,
                    1.3921e-06,
                    1.4258e-06,
                    1.4599e-06,
                    1.4944e-06,
                    1.5294e-06,
                    1.5647e-06,
                    1.6006e-06,
                    1.6368e-06,
                    1.6737e-06,
                    1.7111e-06,
                    1.749e-06,
                    1.7875e-06,
                    1.8265e-06,
                    1.8661e-06,
                    1.9062e-06,
                    1.9468e-06,
                    1.9881e-06,
                    2.0299e-06,
                    2.0724e-06,
                    2.1155e-06,
                    2.1592e-06,
                    2.2036e-06,
                    2.2484e-06,
                    2.294e-06,
                    2.3403e-06,
                    2.3874e-06,
                    2.435e-06,
                    2.4834e-06,
                    2.5324e-06,
                    2.5821e-06,
                    2.6327e-06,
                    2.6838e-06,
                    2.7357e-06,
                    2.7887e-06,
                    2.8426e-06,
                    2.8973e-06,
                    2.9527e-06,
                    3.0089e-06,
                    3.066e-06,
                    3.1241e-06,
                    3.183e-06,
                    3.2428e-06,
                    3.3129e-06,
                    3.3904e-06,
                    3.4717e-06,
                    3.5565e-06,
                    3.6421e-06,
                    3.7313e-06,
                    3.8233e-06,
                    3.9119e-06,
                    4.0025e-06,
                    4.0965e-06,
                    4.1867e-06,
                    4.2876e-06,
                    4.3956e-06,
                    4.4984e-06,
                    4.6131e-06,
                    4.7455e-06,
                    4.8659e-06,
                    4.9827e-06,
                    5.1095e-06,
                    5.213e-06,
                    5.2991e-06,
                    5.3703e-06,
                    5.4246e-06,
                    5.4686e-06,
                    5.5066e-06,
                    5.5293e-06,
                    5.5491e-06,
                    5.5646e-06,
                    5.5763e-06,
                    5.6006e-06,
                    5.626e-06,
                    5.6452e-06,
                    5.6511e-06,
                    5.6555e-06,
                    5.6572e-06,
                    5.6566e-06,
                    5.6551e-06,
                    5.6526e-06,
                    5.6405e-06,
                    5.6297e-06,
                    5.6184e-06,
                    5.6063e-06,
                    5.5943e-06,
                    5.586e-06,
                    5.5899e-06,
                    5.5891e-06,
                    5.5686e-06,
                    5.5519e-06,
                    5.5354e-06,
                    5.5114e-06,
                    5.4873e-06,
                    5.4636e-06,
                    5.44e-06,
                    5.4165e-06,
                    5.3973e-06,
                    5.3942e-06,
                    5.3944e-06,
                    5.3956e-06,
                    5.4103e-06,
                    5.4209e-06,
                    5.4322e-06,
                    5.4552e-06,
                    5.4768e-06,
                    5.5016e-06,
                    5.5295e-06,
                    5.5562e-06,
                    5.5813e-06,
                    5.6023e-06,
                    5.6165e-06,
                    5.6255e-06,
                    5.6314e-06,
                    5.6356e-06,
                    5.6371e-06
                ],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [
                    5.367e-09,
                    1.0766e-08,
                    1.6197e-08,
                    2.1659e-08,
                    2.7154e-08,
                    3.2681e-08,
                    3.8241e-08,
                    4.3833e-08,
                    4.9457e-08,
                    5.5114e-08,
                    6.073e-08,
                    6.6305e-08,
                    7.1839e-08,
                    7.7333e-08,
                    8.2785e-08,
                    8.8197e-08,
                    9.3568e-08,
                    9.8899e-08,
                    1.0419e-07,
                    1.0944e-07,
                    1.1464e-07,
                    1.198e-07,
                    1.2491e-07,
                    1.2997e-07,
                    1.3498e-07,
                    1.3995e-07,
                    1.4487e-07,
                    1.4974e-07,
                    1.5457e-07,
                    1.5935e-07,
                    1.6414e-07,
                    1.6895e-07,
                    1.7378e-07,
                    1.7863e-07,
                    1.835e-07,
                    1.8839e-07,
                    1.9331e-07,
                    1.9824e-07,
                    2.032e-07,
                    2.0818e-07,
                    2.1317e-07,
                    2.1818e-07,
                    2.232e-07,
                    2.2823e-07,
                    2.3328e-07,
                    2.3834e-07,
                    2.4341e-07,
                    2.485e-07,
                    2.536e-07,
                    2.5871e-07,
                    2.6385e-07,
                    2.69e-07,
                    2.7417e-07,
                    2.7935e-07,
                    2.8454e-07,
                    2.8975e-07,
                    2.9498e-07,
                    3.0021e-07,
                    3.0547e-07,
                    3.1073e-07,
                    3.1597e-07,
                    3.212e-07,
                    3.264e-07,
                    3.3158e-07,
                    3.3674e-07,
                    3.4188e-07,
                    3.47e-07,
                    3.521e-07,
                    3.5717e-07,
                    3.6223e-07,
                    3.6726e-07,
                    3.7226e-07,
                    3.7724e-07,
                    3.8219e-07,
                    3.8711e-07,
                    3.92e-07,
                    3.9686e-07,
                    4.017e-07,
                    4.0651e-07,
                    4.1129e-07,
                    4.1609e-07,
                    4.2089e-07,
                    4.2571e-07,
                    4.3053e-07,
                    4.3537e-07,
                    4.4012e-07,
                    4.4478e-07,
                    4.4935e-07,
                    4.5383e-07,
                    4.5821e-07,
                    4.6263e-07,
                    4.6709e-07,
                    4.7157e-07,
                    4.7609e-07,
                    4.8104e-07,
                    4.8643e-07,
                    4.9225e-07,
                    4.9853e-07,
                    5.0526e-07,
                    5.127e-07,
                    5.2267e-07,
                    5.3498e-07,
                    5.494e-07,
                    5.6571e-07,
                    5.8372e-07,
                    6.0342e-07,
                    6.2482e-07,
                    6.4805e-07,
                    6.7343e-07,
                    7.0148e-07,
                    7.3247e-07,
                    7.7373e-07,
                    8.1878e-07,
                    8.6544e-07,
                    9.1363e-07,
                    9.7123e-07,
                    1.0258e-06,
                    1.0859e-06,
                    1.1504e-06,
                    1.2167e-06,
                    1.2796e-06,
                    1.3397e-06,
                    1.4068e-06,
                    1.4766e-06,
                    1.5571e-06,
                    1.6476e-06,
                    1.7501e-06,
                    1.8799e-06,
                    2.009e-06,
                    2.1376e-06,
                    2.2833e-06,
                    2.4022e-06,
                    2.49e-06,
                    2.5596e-06,
                    2.6472e-06,
                    2.7319e-06,
                    2.8347e-06,
                    2.9442e-06,
                    3.0325e-06,
                    3.1058e-06,
                    3.1806e-06,
                    3.2611e-06,
                    3.3327e-06,
                    3.3973e-06,
                    3.4426e-06,
                    3.4783e-06,
                    3.501e-06,
                    3.497e-06,
                    3.4949e-06,
                    3.4954e-06,
                    3.4775e-06,
                    3.4764e-06,
                    3.5016e-06,
                    3.5426e-06,
                    3.5654e-06,
                    3.5828e-06,
                    3.5857e-06,
                    3.5778e-06,
                    3.5861e-06,
                    3.6068e-06,
                    3.6274e-06,
                    3.6454e-06,
                    3.6644e-06,
                    3.6867e-06,
                    3.7178e-06,
                    3.7491e-06,
                    3.7817e-06,
                    3.8151e-06,
                    3.8459e-06,
                    3.8736e-06,
                    3.902e-06,
                    3.9306e-06
                ],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [
                    2.3169e-09,
                    4.6488e-09,
                    6.9958e-09,
                    9.358e-09,
                    1.1735e-08,
                    1.4128e-08,
                    1.6536e-08,
                    1.896e-08,
                    2.14e-08,
                    2.3855e-08,
                    2.6294e-08,
                    2.8717e-08,
                    3.1124e-08,
                    3.3514e-08,
                    3.5889e-08,
                    3.8248e-08,
                    4.0591e-08,
                    4.2918e-08,
                    4.523e-08,
                    4.7526e-08,
                    4.9803e-08,
                    5.206e-08,
                    5.4297e-08,
                    5.6515e-08,
                    5.8713e-08,
                    6.0892e-08,
                    6.3051e-08,
                    6.5191e-08,
                    6.7311e-08,
                    6.9411e-08,
                    7.1514e-08,
                    7.3627e-08,
                    7.5752e-08,
                    7.7888e-08,
                    8.0035e-08,
                    8.2194e-08,
                    8.4365e-08,
                    8.6548e-08,
                    8.8744e-08,
                    9.0952e-08,
                    9.3164e-08,
                    9.538e-08,
                    9.76e-08,
                    9.9824e-08,
                    1.0205e-07,
                    1.0428e-07,
                    1.0652e-07,
                    1.0876e-07,
                    1.1101e-07,
                    1.1326e-07,
                    1.1552e-07,
                    1.1778e-07,
                    1.2005e-07,
                    1.2233e-07,
                    1.2461e-07,
                    1.2689e-07,
                    1.2918e-07,
                    1.3147e-07,
                    1.3377e-07,
                    1.3607e-07,
                    1.3836e-07,
                    1.4064e-07,
                    1.4291e-07,
                    1.4517e-07,
                    1.4742e-07,
                    1.4966e-07,
                    1.5189e-07,
                    1.5411e-07,
                    1.5632e-07,
                    1.5852e-07,
                    1.607e-07,
                    1.6288e-07,
                    1.6503e-07,
                    1.6717e-07,
                    1.693e-07,
                    1.714e-07,
                    1.735e-07,
                    1.7557e-07,
                    1.7763e-07,
                    1.7968e-07,
                    1.8173e-07,
                    1.8378e-07,
                    1.8584e-07,
                    1.879e-07,
                    1.8996e-07,
                    1.9203e-07,
                    1.941e-07,
                    1.9618e-07,
                    1.9826e-07,
                    2.0034e-07,
                    2.0255e-07,
                    2.0489e-07,
                    2.0735e-07,
                    2.0995e-07,
                    2.1306e-07,
                    2.1672e-07,
                    2.2092e-07,
                    2.2566e-07,
                    2.3096e-07,
                    2.3706e-07,
                    2.4476e-07,
                    2.5399e-07,
                    2.6466e-07,
                    2.7669e-07,
                    2.8999e-07,
                    3.0454e-07,
                    3.2034e-07,
                    3.3751e-07,
                    3.5621e-07,
                    3.768e-07,
                    3.9941e-07,
                    4.2433e-07,
                    4.518e-07,
                    4.819e-07,
                    5.1424e-07,
                    5.4875e-07,
                    5.8546e-07,
                    6.242e-07,
                    6.6479e-07,
                    7.0222e-07,
                    7.4007e-07,
                    7.7602e-07,
                    8.1003e-07,
                    8.4218e-07,
                    8.7266e-07,
                    9.015e-07,
                    9.2892e-07,
                    9.5492e-07,
                    9.7923e-07,
                    1.0013e-06,
                    1.0212e-06,
                    1.0384e-06,
                    1.0524e-06,
                    1.0632e-06,
                    1.0709e-06,
                    1.0753e-06,
                    1.0768e-06,
                    1.0754e-06,
                    1.0711e-06,
                    1.0684e-06,
                    1.0645e-06,
                    1.0613e-06,
                    1.059e-06,
                    1.0581e-06,
                    1.0584e-06,
                    1.0596e-06,
                    1.0611e-06,
                    1.0632e-06,
                    1.066e-06,
                    1.0699e-06,
                    1.0745e-06,
                    1.0802e-06,
                    1.0872e-06,
                    1.0949e-06,
                    1.1037e-06,
                    1.1136e-06,
                    1.1237e-06,
                    1.135e-06,
                    1.1474e-06,
                    1.1611e-06,
                    1.1746e-06,
                    1.1886e-06,
                    1.2022e-06,
                    1.2149e-06,
                    1.2276e-06,
                    1.2405e-06,
                    1.2539e-06,
                    1.2674e-06,
                    1.2805e-06,
                    1.2935e-06,
                    1.3064e-06,
                    1.3195e-06
                ],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [
                    3.0501e-09,
                    6.117e-09,
                    9.2007e-09,
                    1.2301e-08,
                    1.5419e-08,
                    1.8553e-08,
                    2.1704e-08,
                    2.4872e-08,
                    2.8057e-08,
                    3.1259e-08,
                    3.4436e-08,
                    3.7588e-08,
                    4.0715e-08,
                    4.3818e-08,
                    4.6896e-08,
                    4.9949e-08,
                    5.2978e-08,
                    5.5981e-08,
                    5.896e-08,
                    6.1914e-08,
                    6.4841e-08,
                    6.774e-08,
                    7.0611e-08,
                    7.3455e-08,
                    7.6271e-08,
                    7.906e-08,
                    8.1821e-08,
                    8.4554e-08,
                    8.726e-08,
                    8.9938e-08,
                    9.2625e-08,
                    9.5322e-08,
                    9.8028e-08,
                    1.0074e-07,
                    1.0347e-07,
                    1.062e-07,
                    1.0894e-07,
                    1.117e-07,
                    1.1446e-07,
                    1.1723e-07,
                    1.2001e-07,
                    1.228e-07,
                    1.256e-07,
                    1.284e-07,
                    1.3122e-07,
                    1.3405e-07,
                    1.3689e-07,
                    1.3974e-07,
                    1.4259e-07,
                    1.4546e-07,
                    1.4833e-07,
                    1.5122e-07,
                    1.5412e-07,
                    1.5702e-07,
                    1.5994e-07,
                    1.6286e-07,
                    1.658e-07,
                    1.6874e-07,
                    1.717e-07,
                    1.7466e-07,
                    1.7762e-07,
                    1.8056e-07,
                    1.8349e-07,
                    1.8641e-07,
                    1.8932e-07,
                    1.9222e-07,
                    1.9511e-07,
                    1.9799e-07,
                    2.0085e-07,
                    2.0371e-07,
                    2.0655e-07,
                    2.0939e-07,
                    2.1221e-07,
                    2.1501e-07,
                    2.1781e-07,
                    2.2059e-07,
                    2.2337e-07,
                    2.2613e-07,
                    2.2888e-07,
                    2.3161e-07,
                    2.3436e-07,
                    2.3711e-07,
                    2.3987e-07,
                    2.4263e-07,
                    2.4541e-07,
                    2.4809e-07,
                    2.5067e-07,
                    2.5317e-07,
                    2.5557e-07,
                    2.5787e-07,
                    2.6008e-07,
                    2.622e-07,
                    2.6422e-07,
                    2.6615e-07,
                    2.6797e-07,
                    2.697e-07,
                    2.7134e-07,
                    2.7287e-07,
                    2.7431e-07,
                    2.7564e-07,
                    2.7791e-07,
                    2.8099e-07,
                    2.8474e-07,
                    2.8902e-07,
                    2.9373e-07,
                    2.9889e-07,
                    3.0448e-07,
                    3.1055e-07,
                    3.1722e-07,
                    3.2467e-07,
                    3.3306e-07,
                    3.494e-07,
                    3.6698e-07,
                    3.8354e-07,
                    3.9939e-07,
                    4.2249e-07,
                    4.4032e-07,
                    4.6171e-07,
                    4.8559e-07,
                    5.1453e-07,
                    5.3954e-07,
                    5.6368e-07,
                    5.9673e-07,
                    6.3444e-07,
                    6.8444e-07,
                    7.4609e-07,
                    8.2123e-07,
                    9.2501e-07,
                    1.0298e-06,
                    1.1363e-06,
                    1.2621e-06,
                    1.3638e-06,
                    1.4376e-06,
                    1.4964e-06,
                    1.5763e-06,
                    1.6565e-06,
                    1.7579e-06,
                    1.8688e-06,
                    1.9614e-06,
                    2.0374e-06,
                    2.116e-06,
                    2.1998e-06,
                    2.2737e-06,
                    2.3392e-06,
                    2.3842e-06,
                    2.4187e-06,
                    2.4398e-06,
                    2.4337e-06,
                    2.4289e-06,
                    2.4255e-06,
                    2.403e-06,
                    2.3961e-06,
                    2.4144e-06,
                    2.4477e-06,
                    2.4617e-06,
                    2.4692e-06,
                    2.462e-06,
                    2.4429e-06,
                    2.4387e-06,
                    2.4458e-06,
                    2.4528e-06,
                    2.4568e-06,
                    2.4622e-06,
                    2.4718e-06,
                    2.4902e-06,
                    2.5086e-06,
                    2.5278e-06,
                    2.5477e-06,
                    2.5654e-06,
                    2.5802e-06,
                    2.5956e-06,
                    2.6112e-06
                ],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [
                    8.6122e-10,
                    1.7396e-09,
                    2.6344e-09,
                    3.5447e-09,
                    4.4691e-09,
                    5.406e-09,
                    6.3535e-09,
                    7.3096e-09,
                    8.2719e-09,
                    9.2374e-09,
                    1.0205e-08,
                    1.1173e-08,
                    1.2143e-08,
                    1.3113e-08,
                    1.4084e-08,
                    1.5055e-08,
                    1.6027e-08,
                    1.7001e-08,
                    1.7975e-08,
                    1.8952e-08,
                    1.9944e-08,
                    2.0978e-08,
                    2.2072e-08,
                    2.324e-08,
                    2.4489e-08,
                    2.582e-08,
                    2.7231e-08,
                    2.8711e-08,
                    3.0245e-08,
                    3.1811e-08,
                    3.3396e-08,
                    3.4997e-08,
                    3.6611e-08,
                    3.8236e-08,
                    3.9871e-08,
                    4.1516e-08,
                    4.3171e-08,
                    4.4835e-08,
                    4.6511e-08,
                    4.8266e-08,
                    4.9999e-08,
                    5.1715e-08,
                    5.3418e-08,
                    5.5113e-08,
                    5.6802e-08,
                    5.8489e-08,
                    6.0179e-08,
                    6.1876e-08,
                    6.3582e-08,
                    6.5302e-08,
                    6.7043e-08,
                    6.8818e-08,
                    7.0636e-08,
                    7.2503e-08,
                    7.4423e-08,
                    7.6399e-08,
                    7.8429e-08,
                    8.0512e-08,
                    8.2641e-08,
                    8.4808e-08,
                    8.7009e-08,
                    8.9242e-08,
                    9.1506e-08,
                    9.3799e-08,
                    9.6122e-08,
                    9.8474e-08,
                    1.0086e-07,
                    1.0327e-07,
                    1.0571e-07,
                    1.0818e-07,
                    1.1069e-07,
                    1.1323e-07,
                    1.1581e-07,
                    1.1844e-07,
                    1.2109e-07,
                    1.2379e-07,
                    1.2653e-07,
                    1.2929e-07,
                    1.3209e-07,
                    1.3491e-07,
                    1.3774e-07,
                    1.406e-07,
                    1.4347e-07,
                    1.4635e-07,
                    1.4925e-07,
                    1.5216e-07,
                    1.5509e-07,
                    1.5804e-07,
                    1.6102e-07,
                    1.6404e-07,
                    1.6714e-07,
                    1.7043e-07,
                    1.7396e-07,
                    1.778e-07,
                    1.8197e-07,
                    1.8648e-07,
                    1.9133e-07,
                    1.9649e-07,
                    2.0191e-07,
                    2.0752e-07,
                    2.1328e-07,
                    2.1916e-07,
                    2.2515e-07,
                    2.3126e-07,
                    2.3747e-07,
                    2.4379e-07,
                    2.5022e-07,
                    2.5678e-07,
                    2.6349e-07,
                    2.7035e-07,
                    2.7757e-07,
                    2.8532e-07,
                    2.9349e-07,
                    3.0191e-07,
                    3.1053e-07,
                    3.1978e-07,
                    3.2918e-07,
                    3.3913e-07,
                    3.4944e-07,
                    3.6027e-07,
                    3.711e-07,
                    3.8206e-07,
                    3.9356e-07,
                    4.0534e-07,
                    4.1818e-07,
                    4.3222e-07,
                    4.4701e-07,
                    4.6426e-07,
                    4.8168e-07,
                    4.9933e-07,
                    5.1826e-07,
                    5.3663e-07,
                    5.5424e-07,
                    5.7143e-07,
                    5.9015e-07,
                    6.0887e-07,
                    6.2886e-07,
                    6.4969e-07,
                    6.7092e-07,
                    6.905e-07,
                    7.1021e-07,
                    7.3038e-07,
                    7.506e-07,
                    7.7155e-07,
                    7.9183e-07,
                    8.1206e-07,
                    8.3218e-07,
                    8.5228e-07,
                    8.7247e-07,
                    8.9227e-07,
                    9.1202e-07,
                    9.3189e-07,
                    9.5204e-07,
                    9.722e-07,
                    9.9258e-07,
                    1.0133e-06,
                    1.0334e-06,
                    1.0537e-06,
                    1.0741e-06,
                    1.094e-06,
                    1.1139e-06,
                    1.134e-06,
                    1.1541e-06,
                    1.1742e-06,
                    1.1944e-06,
                    1.2147e-06,
                    1.2353e-06,
                    1.2556e-06,
                    1.276e-06,
                    1.2963e-06,
                    1.3166e-06,
                    1.3369e-06
                ],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [
                    5.5321e-10,
                    1.1174e-09,
                    1.6922e-09,
                    2.2769e-09,
                    2.8706e-09,
                    3.4723e-09,
                    4.0809e-09,
                    4.695e-09,
                    5.313e-09,
                    5.9332e-09,
                    6.5545e-09,
                    7.1767e-09,
                    7.7994e-09,
                    8.4226e-09,
                    9.0463e-09,
                    9.6703e-09,
                    1.0295e-08,
                    1.092e-08,
                    1.1546e-08,
                    1.2174e-08,
                    1.2811e-08,
                    1.3475e-08,
                    1.4178e-08,
                    1.4928e-08,
                    1.573e-08,
                    1.6585e-08,
                    1.749e-08,
                    1.844e-08,
                    1.9424e-08,
                    2.0429e-08,
                    2.1447e-08,
                    2.2474e-08,
                    2.351e-08,
                    2.4553e-08,
                    2.5602e-08,
                    2.6658e-08,
                    2.7719e-08,
                    2.8788e-08,
                    2.9863e-08,
                    3.0948e-08,
                    3.2041e-08,
                    3.3145e-08,
                    3.4258e-08,
                    3.538e-08,
                    3.6514e-08,
                    3.7658e-08,
                    3.8814e-08,
                    3.9983e-08,
                    4.1165e-08,
                    4.2362e-08,
                    4.3576e-08,
                    4.4811e-08,
                    4.6068e-08,
                    4.7349e-08,
                    4.8657e-08,
                    4.9991e-08,
                    5.1353e-08,
                    5.2741e-08,
                    5.4156e-08,
                    5.5596e-08,
                    5.706e-08,
                    5.8548e-08,
                    6.006e-08,
                    6.1595e-08,
                    6.3154e-08,
                    6.4738e-08,
                    6.6345e-08,
                    6.7976e-08,
                    6.9632e-08,
                    7.1311e-08,
                    7.3016e-08,
                    7.4746e-08,
                    7.6502e-08,
                    7.8284e-08,
                    8.0091e-08,
                    8.1925e-08,
                    8.3784e-08,
                    8.5667e-08,
                    8.7573e-08,
                    8.9502e-08,
                    9.1451e-08,
                    9.3418e-08,
                    9.5403e-08,
                    9.7404e-08,
                    9.9424e-08,
                    1.0146e-07,
                    1.0352e-07,
                    1.0561e-07,
                    1.0773e-07,
                    1.0988e-07,
                    1.1211e-07,
                    1.1448e-07,
                    1.1704e-07,
                    1.1984e-07,
                    1.2289e-07,
                    1.2621e-07,
                    1.2978e-07,
                    1.336e-07,
                    1.3762e-07,
                    1.4179e-07,
                    1.4608e-07,
                    1.5046e-07,
                    1.5493e-07,
                    1.5947e-07,
                    1.6409e-07,
                    1.6878e-07,
                    1.7355e-07,
                    1.784e-07,
                    1.8336e-07,
                    1.8845e-07,
                    1.937e-07,
                    1.9919e-07,
                    2.0494e-07,
                    2.1101e-07,
                    2.174e-07,
                    2.2412e-07,
                    2.3116e-07,
                    2.385e-07,
                    2.461e-07,
                    2.5405e-07,
                    2.6212e-07,
                    2.7029e-07,
                    2.7855e-07,
                    2.8689e-07,
                    2.9527e-07,
                    3.0438e-07,
                    3.1361e-07,
                    3.2351e-07,
                    3.3347e-07,
                    3.435e-07,
                    3.5376e-07,
                    3.6414e-07,
                    3.753e-07,
                    3.8658e-07,
                    3.9805e-07,
                    4.0952e-07,
                    4.2143e-07,
                    4.3361e-07,
                    4.4664e-07,
                    4.5897e-07,
                    4.7142e-07,
                    4.8403e-07,
                    4.9676e-07,
                    5.1038e-07,
                    5.2361e-07,
                    5.3672e-07,
                    5.4976e-07,
                    5.6278e-07,
                    5.7563e-07,
                    5.8781e-07,
                    5.9993e-07,
                    6.1218e-07,
                    6.2471e-07,
                    6.3725e-07,
                    6.5001e-07,
                    6.6306e-07,
                    6.7547e-07,
                    6.879e-07,
                    7.0025e-07,
                    7.1254e-07,
                    7.2473e-07,
                    7.3687e-07,
                    7.4892e-07,
                    7.6102e-07,
                    7.731e-07,
                    7.8523e-07,
                    7.9743e-07,
                    8.0947e-07,
                    8.2156e-07,
                    8.3347e-07,
                    8.4529e-07,
                    8.5722e-07
                ],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": [
                    3.0801e-10,
                    6.2218e-10,
                    9.4224e-10,
                    1.2678e-09,
                    1.5985e-09,
                    1.9336e-09,
                    2.2726e-09,
                    2.6146e-09,
                    2.9588e-09,
                    3.3042e-09,
                    3.6502e-09,
                    3.9966e-09,
                    4.3434e-09,
                    4.6903e-09,
                    5.0375e-09,
                    5.3849e-09,
                    5.7326e-09,
                    6.0806e-09,
                    6.429e-09,
                    6.7781e-09,
                    7.1331e-09,
                    7.5029e-09,
                    7.8943e-09,
                    8.3121e-09,
                    8.7591e-09,
                    9.2358e-09,
                    9.741e-09,
                    1.0271e-08,
                    1.0821e-08,
                    1.1382e-08,
                    1.195e-08,
                    1.2523e-08,
                    1.3101e-08,
                    1.3684e-08,
                    1.4269e-08,
                    1.4859e-08,
                    1.5451e-08,
                    1.6048e-08,
                    1.6648e-08,
                    1.7318e-08,
                    1.7957e-08,
                    1.857e-08,
                    1.9161e-08,
                    1.9732e-08,
                    2.0288e-08,
                    2.0831e-08,
                    2.1365e-08,
                    2.1893e-08,
                    2.2417e-08,
                    2.294e-08,
                    2.3467e-08,
                    2.4008e-08,
                    2.4569e-08,
                    2.5154e-08,
                    2.5767e-08,
                    2.6408e-08,
                    2.7077e-08,
                    2.777e-08,
                    2.8484e-08,
                    2.9212e-08,
                    2.9949e-08,
                    3.0694e-08,
                    3.1446e-08,
                    3.2204e-08,
                    3.2967e-08,
                    3.3736e-08,
                    3.451e-08,
                    3.529e-08,
                    3.6076e-08,
                    3.687e-08,
                    3.7673e-08,
                    3.8487e-08,
                    3.9313e-08,
                    4.0152e-08,
                    4.1003e-08,
                    4.1867e-08,
                    4.2742e-08,
                    4.3625e-08,
                    4.4513e-08,
                    4.5403e-08,
                    4.6293e-08,
                    4.7181e-08,
                    4.8065e-08,
                    4.8946e-08,
                    4.9823e-08,
                    5.0696e-08,
                    5.1565e-08,
                    5.2431e-08,
                    5.3295e-08,
                    5.4159e-08,
                    5.5036e-08,
                    5.595e-08,
                    5.6921e-08,
                    5.7961e-08,
                    5.9079e-08,
                    6.0277e-08,
                    6.1552e-08,
                    6.2896e-08,
                    6.4296e-08,
                    6.5734e-08,
                    6.72e-08,
                    6.8695e-08,
                    7.0221e-08,
                    7.1781e-08,
                    7.3376e-08,
                    7.5007e-08,
                    7.6674e-08,
                    7.838e-08,
                    8.0123e-08,
                    8.1905e-08,
                    8.3872e-08,
                    8.6134e-08,
                    8.8544e-08,
                    9.0904e-08,
                    9.3129e-08,
                    9.5662e-08,
                    9.8022e-08,
                    1.0063e-07,
                    1.0333e-07,
                    1.0622e-07,
                    1.0898e-07,
                    1.1177e-07,
                    1.1501e-07,
                    1.1845e-07,
                    1.2292e-07,
                    1.2783e-07,
                    1.334e-07,
                    1.4076e-07,
                    1.4822e-07,
                    1.5583e-07,
                    1.6451e-07,
                    1.725e-07,
                    1.7894e-07,
                    1.8484e-07,
                    1.921e-07,
                    1.9935e-07,
                    2.0743e-07,
                    2.1608e-07,
                    2.2428e-07,
                    2.3153e-07,
                    2.3879e-07,
                    2.4635e-07,
                    2.5384e-07,
                    2.6116e-07,
                    2.6822e-07,
                    2.7534e-07,
                    2.8242e-07,
                    2.895e-07,
                    2.9684e-07,
                    3.0446e-07,
                    3.1208e-07,
                    3.1971e-07,
                    3.2733e-07,
                    3.3495e-07,
                    3.4257e-07,
                    3.502e-07,
                    3.5789e-07,
                    3.6585e-07,
                    3.738e-07,
                    3.8151e-07,
                    3.892e-07,
                    3.9713e-07,
                    4.0516e-07,
                    4.1318e-07,
                    4.2127e-07,
                    4.295e-07,
                    4.3785e-07,
                    4.4613e-07,
                    4.5446e-07,
                    4.6283e-07,
                    4.7127e-07,
                    4.7972e-07
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -175.35602,
                                -21.09467
                            ],
                            [
                                -175.34159,
                                -21.14979
                            ],
                            [
                                -175.27255,
                                -21.19844
                            ],
                            [
                                -175.19416,
                                -21.2227
                            ],
                            [
                                -175.12786,
                                -21.27295
                            ],
                            [
                                -175.04702,
                                -21.1328
                            ],
                            [
                                -175.12113,
                                -21.12934
                            ],
                            [
                                -175.19592,
                                -21.15719
                            ],
                            [
                                -175.23462,
                                -21.11575
                            ],
                            [
                                -175.28832,
                                -21.12656
                            ],
                            [
                                -175.35602,
                                -21.09467
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -174.06632,
                                -18.63364
                            ],
                            [
                                -174.01303,
                                -18.67618
                            ],
                            [
                                -173.91967,
                                -18.63592
                            ],
                            [
                                -173.924,
                                -18.58316
                            ],
                            [
                                -174.00106,
                                -18.57834
                            ],
                            [
                                -174.06632,
                                -18.63364
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -174.97535,
                                -21.38554
                            ],
                            [
                                -174.90119,
                                -21.45
                            ],
                            [
                                -174.90856,
                                -21.32362
                            ],
                            [
                                -174.97535,
                                -21.38554
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "TTO",
                "Country": "Trinidad and Tobago",
                "Total_3GHG": 0.1,
                "Total_3GHG_timeseries": [
                    2.1478e-07,
                    4.2748e-07,
                    6.4237e-07,
                    8.6094e-07,
                    1.0838e-06,
                    1.3127e-06,
                    1.5482e-06,
                    1.7904e-06,
                    2.0396e-06,
                    2.2882e-06,
                    2.5402e-06,
                    2.7968e-06,
                    3.059e-06,
                    3.3269e-06,
                    3.5999e-06,
                    3.8783e-06,
                    4.1619e-06,
                    4.4509e-06,
                    4.7451e-06,
                    5.1275e-06,
                    5.5528e-06,
                    6.0038e-06,
                    6.4734e-06,
                    6.9586e-06,
                    7.4573e-06,
                    7.9674e-06,
                    8.4876e-06,
                    9.0173e-06,
                    9.5559e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016
                ],
                "Fossil_3GHG": 0.15,
                "Fossil_3GHG_timeseries": [
                    2.9007e-08,
                    6.1262e-08,
                    9.7643e-08,
                    1.3814e-07,
                    1.8273e-07,
                    2.3286e-07,
                    2.886e-07,
                    3.5002e-07,
                    4.172e-07,
                    4.9021e-07,
                    5.6834e-07,
                    6.5151e-07,
                    7.3985e-07,
                    8.3333e-07,
                    9.31e-07,
                    1.033e-06,
                    1.1393e-06,
                    1.2499e-06,
                    1.3643e-06,
                    1.4826e-06,
                    1.6078e-06,
                    1.7394e-06,
                    1.8767e-06,
                    2.0197e-06,
                    2.1683e-06,
                    2.3213e-06,
                    2.4788e-06,
                    2.6405e-06,
                    2.8061e-06,
                    2.9757e-06,
                    3.1489e-06,
                    3.3282e-06,
                    3.5121e-06,
                    3.6997e-06,
                    3.8911e-06,
                    4.0861e-06,
                    4.2854e-06,
                    4.4887e-06,
                    4.6968e-06,
                    4.9132e-06,
                    5.1327e-06,
                    5.3562e-06,
                    5.5842e-06,
                    5.8163e-06,
                    6.0525e-06,
                    6.2925e-06,
                    6.5363e-06,
                    6.7843e-06,
                    7.0365e-06,
                    7.2885e-06,
                    7.5474e-06,
                    7.8115e-06,
                    8.0814e-06,
                    8.3586e-06,
                    8.6438e-06,
                    8.9372e-06,
                    9.2381e-06,
                    9.547e-06,
                    9.9072e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [
                    1.8578e-07,
                    3.6621e-07,
                    5.4473e-07,
                    7.228e-07,
                    9.0103e-07,
                    1.0798e-06,
                    1.2596e-06,
                    1.4404e-06,
                    1.6224e-06,
                    1.798e-06,
                    1.9718e-06,
                    2.1453e-06,
                    2.3191e-06,
                    2.4936e-06,
                    2.6689e-06,
                    2.8453e-06,
                    3.0226e-06,
                    3.2011e-06,
                    3.3808e-06,
                    3.6449e-06,
                    3.9451e-06,
                    4.2644e-06,
                    4.5967e-06,
                    4.9388e-06,
                    5.289e-06,
                    5.646e-06,
                    6.0088e-06,
                    6.3768e-06,
                    6.7498e-06,
                    7.0933e-06,
                    7.4268e-06,
                    7.757e-06,
                    8.0863e-06,
                    8.4159e-06,
                    8.7467e-06,
                    9.0788e-06,
                    9.4125e-06,
                    9.748e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_CO2": 0.07,
                "Total_CO2_timeseries": [
                    1.788e-07,
                    3.5183e-07,
                    5.2249e-07,
                    6.9226e-07,
                    8.6175e-07,
                    1.0314e-06,
                    1.2015e-06,
                    1.3722e-06,
                    1.5437e-06,
                    1.7084e-06,
                    1.8709e-06,
                    2.0326e-06,
                    2.1943e-06,
                    2.3561e-06,
                    2.5185e-06,
                    2.6815e-06,
                    2.845e-06,
                    3.0092e-06,
                    3.1743e-06,
                    3.4234e-06,
                    3.7078e-06,
                    4.0105e-06,
                    4.3253e-06,
                    4.6491e-06,
                    4.9801e-06,
                    5.3171e-06,
                    5.6591e-06,
                    6.0054e-06,
                    6.3559e-06,
                    6.6761e-06,
                    6.9857e-06,
                    7.2913e-06,
                    7.5952e-06,
                    7.8988e-06,
                    8.2029e-06,
                    8.5078e-06,
                    8.8135e-06,
                    9.1202e-06,
                    9.4284e-06,
                    9.6937e-06,
                    9.9421e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008
                ],
                "Fossil_CO2": 0.09,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.155e-08,
                    4.125e-08,
                    9.735e-08,
                    1.8645e-07,
                    2.871e-07,
                    4.1745e-07,
                    5.676e-07,
                    7.5405e-07,
                    9.9165e-07,
                    1.3382e-06,
                    1.6302e-06,
                    2.0212e-06,
                    2.4717e-06,
                    2.9139e-06,
                    3.4584e-06,
                    4.2042e-06,
                    5.0804e-06,
                    5.9631e-06,
                    6.9086e-06,
                    8.3638e-06,
                    9.9825e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Land_CO2": 0.01,
                "Land_CO2_timeseries": [
                    1.788e-07,
                    3.5183e-07,
                    5.2249e-07,
                    6.9226e-07,
                    8.6175e-07,
                    1.0314e-06,
                    1.2015e-06,
                    1.3722e-06,
                    1.5437e-06,
                    1.7084e-06,
                    1.8709e-06,
                    2.0326e-06,
                    2.1943e-06,
                    2.3561e-06,
                    2.5185e-06,
                    2.6815e-06,
                    2.845e-06,
                    3.0092e-06,
                    3.1743e-06,
                    3.4234e-06,
                    3.7078e-06,
                    4.0105e-06,
                    4.3253e-06,
                    4.6491e-06,
                    4.9801e-06,
                    5.3171e-06,
                    5.6591e-06,
                    6.0054e-06,
                    6.3559e-06,
                    6.6761e-06,
                    6.9857e-06,
                    7.2913e-06,
                    7.5952e-06,
                    7.8988e-06,
                    8.2029e-06,
                    8.5078e-06,
                    8.8135e-06,
                    9.1202e-06,
                    9.4284e-06,
                    9.6937e-06,
                    9.9421e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_CH4": 0.19,
                "Total_CH4_timeseries": [
                    2.5592e-08,
                    5.187e-08,
                    7.9713e-08,
                    1.0911e-07,
                    1.4004e-07,
                    1.7395e-07,
                    2.1091e-07,
                    2.5099e-07,
                    2.9428e-07,
                    3.4085e-07,
                    3.8994e-07,
                    4.4151e-07,
                    4.9566e-07,
                    5.5237e-07,
                    6.1069e-07,
                    6.7074e-07,
                    7.3253e-07,
                    7.9604e-07,
                    8.6083e-07,
                    9.2685e-07,
                    9.9757e-07,
                    1.0726e-06,
                    1.151e-06,
                    1.2329e-06,
                    1.3181e-06,
                    1.4056e-06,
                    1.4953e-06,
                    1.5869e-06,
                    1.6803e-06,
                    1.7755e-06,
                    1.8719e-06,
                    1.972e-06,
                    2.0746e-06,
                    2.1784e-06,
                    2.2837e-06,
                    2.3903e-06,
                    2.4989e-06,
                    2.609e-06,
                    2.7217e-06,
                    2.8403e-06,
                    2.9593e-06,
                    3.0796e-06,
                    3.2015e-06,
                    3.3249e-06,
                    3.4497e-06,
                    3.5755e-06,
                    3.7023e-06,
                    3.8305e-06,
                    3.9604e-06,
                    4.0871e-06,
                    4.2186e-06,
                    4.3528e-06,
                    4.4907e-06,
                    4.6336e-06,
                    4.7822e-06,
                    4.9366e-06,
                    5.0963e-06,
                    5.2616e-06,
                    5.4645e-06,
                    5.7018e-06,
                    5.9744e-06,
                    6.2814e-06,
                    6.6228e-06,
                    6.9968e-06,
                    7.4036e-06,
                    7.8432e-06,
                    8.3153e-06,
                    8.8201e-06,
                    9.3569e-06,
                    9.9305e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008
                ],
                "Fossil_CH4": 0.3,
                "Fossil_CH4_timeseries": [
                    1.8955e-08,
                    3.816e-08,
                    5.8493e-08,
                    7.9942e-08,
                    1.0249e-07,
                    1.2759e-07,
                    1.5529e-07,
                    1.8568e-07,
                    2.1884e-07,
                    2.5485e-07,
                    2.9297e-07,
                    3.3316e-07,
                    3.7552e-07,
                    4.2003e-07,
                    4.6574e-07,
                    5.1278e-07,
                    5.6114e-07,
                    6.1082e-07,
                    6.6137e-07,
                    7.1274e-07,
                    7.68e-07,
                    8.2674e-07,
                    8.8812e-07,
                    9.5216e-07,
                    1.0187e-06,
                    1.0867e-06,
                    1.1561e-06,
                    1.2267e-06,
                    1.2982e-06,
                    1.3706e-06,
                    1.4438e-06,
                    1.5198e-06,
                    1.5977e-06,
                    1.6761e-06,
                    1.7554e-06,
                    1.8353e-06,
                    1.9166e-06,
                    1.9987e-06,
                    2.0828e-06,
                    2.172e-06,
                    2.2614e-06,
                    2.3518e-06,
                    2.4435e-06,
                    2.5365e-06,
                    2.6306e-06,
                    2.7254e-06,
                    2.821e-06,
                    2.9177e-06,
                    3.0158e-06,
                    3.1105e-06,
                    3.2092e-06,
                    3.3099e-06,
                    3.4135e-06,
                    3.5214e-06,
                    3.6342e-06,
                    3.7521e-06,
                    3.8746e-06,
                    4.002e-06,
                    4.1661e-06,
                    4.364e-06,
                    4.5969e-06,
                    4.8639e-06,
                    5.1649e-06,
                    5.4984e-06,
                    5.8642e-06,
                    6.2626e-06,
                    6.6933e-06,
                    7.1563e-06,
                    7.6511e-06,
                    8.1823e-06,
                    8.7398e-06,
                    9.3268e-06,
                    9.9418e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008
                ],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [
                    6.6371e-09,
                    1.371e-08,
                    2.122e-08,
                    2.9166e-08,
                    3.7548e-08,
                    4.6367e-08,
                    5.5621e-08,
                    6.5312e-08,
                    7.5439e-08,
                    8.6003e-08,
                    9.6975e-08,
                    1.0836e-07,
                    1.2015e-07,
                    1.3234e-07,
                    1.4495e-07,
                    1.5796e-07,
                    1.7139e-07,
                    1.8522e-07,
                    1.9946e-07,
                    2.1411e-07,
                    2.2956e-07,
                    2.4582e-07,
                    2.6288e-07,
                    2.8075e-07,
                    2.9942e-07,
                    3.1889e-07,
                    3.3917e-07,
                    3.6025e-07,
                    3.8214e-07,
                    4.0483e-07,
                    4.2818e-07,
                    4.5221e-07,
                    4.7689e-07,
                    5.0224e-07,
                    5.2826e-07,
                    5.5494e-07,
                    5.8229e-07,
                    6.103e-07,
                    6.3898e-07,
                    6.6832e-07,
                    6.9794e-07,
                    7.2782e-07,
                    7.5798e-07,
                    7.884e-07,
                    8.191e-07,
                    8.5007e-07,
                    8.8131e-07,
                    9.1281e-07,
                    9.4459e-07,
                    9.7664e-07,
                    1.0094e-06,
                    1.043e-06,
                    1.0772e-06,
                    1.1122e-06,
                    1.148e-06,
                    1.1845e-06,
                    1.2217e-06,
                    1.2596e-06,
                    1.2984e-06,
                    1.3378e-06,
                    1.3775e-06,
                    1.4175e-06,
                    1.4579e-06,
                    1.4985e-06,
                    1.5393e-06,
                    1.5805e-06,
                    1.622e-06,
                    1.6637e-06,
                    1.7058e-06,
                    1.7481e-06,
                    1.7892e-06,
                    1.8289e-06,
                    1.8674e-06,
                    1.9046e-06,
                    1.9405e-06,
                    1.9752e-06,
                    2.0085e-06,
                    2.0406e-06,
                    2.0714e-06,
                    2.1009e-06,
                    2.1308e-06,
                    2.1613e-06,
                    2.1923e-06,
                    2.2238e-06,
                    2.2558e-06,
                    2.2875e-06,
                    2.3188e-06,
                    2.3497e-06,
                    2.3802e-06,
                    2.4102e-06,
                    2.4435e-06,
                    2.48e-06,
                    2.5197e-06,
                    2.5624e-06,
                    2.6082e-06,
                    2.6569e-06,
                    2.7085e-06,
                    2.763e-06,
                    2.8203e-06,
                    2.8803e-06,
                    2.9406e-06,
                    3.0022e-06,
                    3.0657e-06,
                    3.1316e-06,
                    3.2002e-06,
                    3.2721e-06,
                    3.3475e-06,
                    3.4258e-06,
                    3.5068e-06,
                    3.5899e-06,
                    3.6876e-06,
                    3.7838e-06,
                    3.8802e-06,
                    3.9774e-06,
                    4.0809e-06,
                    4.1853e-06,
                    4.2937e-06,
                    4.4045e-06,
                    4.5166e-06,
                    4.634e-06,
                    4.7578e-06,
                    4.892e-06,
                    5.0317e-06,
                    5.186e-06,
                    5.353e-06,
                    5.5167e-06,
                    5.6799e-06,
                    5.8257e-06,
                    5.9759e-06,
                    6.1092e-06,
                    6.2096e-06,
                    6.2981e-06,
                    6.3626e-06,
                    6.4143e-06,
                    6.4425e-06,
                    6.4735e-06,
                    6.5138e-06,
                    6.5287e-06,
                    6.5328e-06,
                    6.5125e-06,
                    6.4853e-06,
                    6.4224e-06,
                    6.353e-06,
                    6.2624e-06,
                    6.1432e-06,
                    6.0464e-06,
                    5.9292e-06,
                    5.8144e-06,
                    5.6896e-06,
                    5.5727e-06,
                    5.4769e-06,
                    5.4052e-06,
                    5.3343e-06,
                    5.2723e-06,
                    5.2263e-06,
                    5.173e-06,
                    5.105e-06,
                    5.0534e-06,
                    5.0092e-06,
                    4.9829e-06,
                    4.956e-06,
                    4.9537e-06,
                    4.9586e-06,
                    4.9673e-06,
                    4.9884e-06,
                    4.9762e-06,
                    4.9781e-06,
                    4.9833e-06,
                    4.9942e-06,
                    5.0133e-06,
                    5.024e-06,
                    5.0215e-06
                ],
                "Total_N2O": 0.06,
                "Total_N2O_timeseries": [
                    1.0386e-08,
                    2.3777e-08,
                    4.0172e-08,
                    5.9571e-08,
                    8.1973e-08,
                    1.0737e-07,
                    1.3578e-07,
                    1.6717e-07,
                    2.0157e-07,
                    2.3895e-07,
                    2.7932e-07,
                    3.2269e-07,
                    3.6904e-07,
                    4.1839e-07,
                    4.7072e-07,
                    5.2604e-07,
                    5.8435e-07,
                    6.4565e-07,
                    7.0994e-07,
                    7.7722e-07,
                    8.475e-07,
                    9.2082e-07,
                    9.9718e-07,
                    1.0766e-06,
                    1.1591e-06,
                    1.2446e-06,
                    1.3333e-06,
                    1.4249e-06,
                    1.5197e-06,
                    1.6174e-06,
                    1.7181e-06,
                    1.8219e-06,
                    1.9286e-06,
                    2.0384e-06,
                    2.1511e-06,
                    2.2669e-06,
                    2.3856e-06,
                    2.5074e-06,
                    2.6321e-06,
                    2.7602e-06,
                    2.8914e-06,
                    3.0255e-06,
                    3.1627e-06,
                    3.303e-06,
                    3.4464e-06,
                    3.5928e-06,
                    3.7424e-06,
                    3.895e-06,
                    4.0508e-06,
                    4.2097e-06,
                    4.3717e-06,
                    4.537e-06,
                    4.7056e-06,
                    4.8774e-06,
                    5.0526e-06,
                    5.2311e-06,
                    5.4129e-06,
                    5.598e-06,
                    5.7862e-06,
                    5.9776e-06,
                    6.1721e-06,
                    6.3697e-06,
                    6.5703e-06,
                    6.774e-06,
                    6.9807e-06,
                    7.1906e-06,
                    7.4034e-06,
                    7.6193e-06,
                    7.8383e-06,
                    8.0603e-06,
                    8.2853e-06,
                    8.5133e-06,
                    8.7443e-06,
                    8.9783e-06,
                    9.2152e-06,
                    9.4551e-06,
                    9.698e-06,
                    9.9439e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001
                ],
                "Fossil_N2O": 0.21,
                "Fossil_N2O_timeseries": [
                    1.0052e-08,
                    2.3102e-08,
                    3.9151e-08,
                    5.8197e-08,
                    8.0239e-08,
                    1.0528e-07,
                    1.3331e-07,
                    1.6434e-07,
                    1.9836e-07,
                    2.3537e-07,
                    2.7537e-07,
                    3.1836e-07,
                    3.6433e-07,
                    4.133e-07,
                    4.6525e-07,
                    5.202e-07,
                    5.7813e-07,
                    6.3906e-07,
                    7.0297e-07,
                    7.6987e-07,
                    8.3977e-07,
                    9.1268e-07,
                    9.8862e-07,
                    1.0676e-06,
                    1.1496e-06,
                    1.2346e-06,
                    1.3227e-06,
                    1.4138e-06,
                    1.5079e-06,
                    1.6051e-06,
                    1.7052e-06,
                    1.8083e-06,
                    1.9144e-06,
                    2.0236e-06,
                    2.1357e-06,
                    2.2508e-06,
                    2.3689e-06,
                    2.49e-06,
                    2.6141e-06,
                    2.7412e-06,
                    2.8713e-06,
                    3.0045e-06,
                    3.1406e-06,
                    3.2798e-06,
                    3.4219e-06,
                    3.5671e-06,
                    3.7153e-06,
                    3.8665e-06,
                    4.0208e-06,
                    4.178e-06,
                    4.3383e-06,
                    4.5016e-06,
                    4.6679e-06,
                    4.8372e-06,
                    5.0096e-06,
                    5.1851e-06,
                    5.3635e-06,
                    5.545e-06,
                    5.7295e-06,
                    5.9171e-06,
                    6.1076e-06,
                    6.3013e-06,
                    6.4979e-06,
                    6.6975e-06,
                    6.9002e-06,
                    7.1059e-06,
                    7.3147e-06,
                    7.5264e-06,
                    7.7412e-06,
                    7.959e-06,
                    8.1799e-06,
                    8.4037e-06,
                    8.6306e-06,
                    8.8605e-06,
                    9.0935e-06,
                    9.3295e-06,
                    9.5684e-06,
                    9.8105e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.01,
                "Land_N2O_timeseries": [
                    3.3399e-10,
                    6.7465e-10,
                    1.0217e-09,
                    1.3748e-09,
                    1.7333e-09,
                    2.0967e-09,
                    2.4643e-09,
                    2.8351e-09,
                    3.2083e-09,
                    3.5829e-09,
                    3.958e-09,
                    4.3337e-09,
                    4.7097e-09,
                    5.0859e-09,
                    5.4624e-09,
                    5.8391e-09,
                    6.2161e-09,
                    6.5934e-09,
                    6.9713e-09,
                    7.3498e-09,
                    7.7347e-09,
                    8.1356e-09,
                    8.56e-09,
                    9.0131e-09,
                    9.4978e-09,
                    1.0015e-08,
                    1.0563e-08,
                    1.1137e-08,
                    1.1733e-08,
                    1.2342e-08,
                    1.2957e-08,
                    1.3579e-08,
                    1.4206e-08,
                    1.4838e-08,
                    1.5473e-08,
                    1.6112e-08,
                    1.6754e-08,
                    1.7401e-08,
                    1.8052e-08,
                    1.9034e-08,
                    2.0031e-08,
                    2.1056e-08,
                    2.2126e-08,
                    2.3251e-08,
                    2.4444e-08,
                    2.5714e-08,
                    2.7068e-08,
                    2.8513e-08,
                    3.0053e-08,
                    3.1692e-08,
                    3.3468e-08,
                    3.5446e-08,
                    3.7673e-08,
                    4.0178e-08,
                    4.2975e-08,
                    4.6059e-08,
                    4.9408e-08,
                    5.2983e-08,
                    5.6729e-08,
                    6.0572e-08,
                    6.4467e-08,
                    6.8413e-08,
                    7.2405e-08,
                    7.6439e-08,
                    8.0512e-08,
                    8.4617e-08,
                    8.875e-08,
                    9.2905e-08,
                    9.7076e-08,
                    1.0126e-07,
                    1.0543e-07,
                    1.0958e-07,
                    1.1368e-07,
                    1.1773e-07,
                    1.2172e-07,
                    1.2566e-07,
                    1.2954e-07,
                    1.3338e-07,
                    1.3719e-07,
                    1.4099e-07,
                    1.4481e-07,
                    1.487e-07,
                    1.5269e-07,
                    1.5681e-07,
                    1.6107e-07,
                    1.6549e-07,
                    1.7007e-07,
                    1.7483e-07,
                    1.7975e-07,
                    1.8483e-07,
                    1.9024e-07,
                    1.9629e-07,
                    2.0324e-07,
                    2.1125e-07,
                    2.2043e-07,
                    2.3081e-07,
                    2.4233e-07,
                    2.5489e-07,
                    2.6828e-07,
                    2.8226e-07,
                    2.968e-07,
                    3.1216e-07,
                    3.2854e-07,
                    3.4607e-07,
                    3.6484e-07,
                    3.8485e-07,
                    4.0607e-07,
                    4.284e-07,
                    4.5166e-07,
                    4.7566e-07,
                    5.0255e-07,
                    5.2982e-07,
                    5.5763e-07,
                    5.8662e-07,
                    6.1729e-07,
                    6.5027e-07,
                    6.8757e-07,
                    7.2575e-07,
                    7.6489e-07,
                    8.0738e-07,
                    8.5167e-07,
                    8.9974e-07,
                    9.4881e-07,
                    9.9477e-07,
                    1.0392e-06,
                    1.0846e-06,
                    1.1311e-06,
                    1.1783e-06,
                    1.2257e-06,
                    1.2711e-06,
                    1.3139e-06,
                    1.3597e-06,
                    1.4059e-06,
                    1.4543e-06,
                    1.5029e-06,
                    1.5458e-06,
                    1.5893e-06,
                    1.6258e-06,
                    1.665e-06,
                    1.7146e-06,
                    1.7657e-06,
                    1.8175e-06,
                    1.8619e-06,
                    1.904e-06,
                    1.9491e-06,
                    2.0026e-06,
                    2.0538e-06,
                    2.1026e-06,
                    2.1525e-06,
                    2.2135e-06,
                    2.2655e-06,
                    2.3334e-06,
                    2.3957e-06,
                    2.4654e-06,
                    2.5354e-06,
                    2.6052e-06,
                    2.6753e-06,
                    2.7458e-06,
                    2.8198e-06,
                    2.8952e-06,
                    2.9709e-06,
                    3.05e-06,
                    3.1307e-06,
                    3.2115e-06,
                    3.2935e-06,
                    3.3762e-06,
                    3.4597e-06,
                    3.5452e-06,
                    3.6317e-06,
                    3.7197e-06,
                    3.8078e-06,
                    3.8968e-06
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -61.93006,
                                10.05318
                            ],
                            [
                                -61.82031,
                                10.0837
                            ],
                            [
                                -61.69275,
                                10.08581
                            ],
                            [
                                -61.62768,
                                10.05683
                            ],
                            [
                                -61.57312,
                                10.07346
                            ],
                            [
                                -61.33465,
                                10.07423
                            ],
                            [
                                -61.28099,
                                10.08569
                            ],
                            [
                                -61.16182,
                                10.0757
                            ],
                            [
                                -61.06304,
                                10.11488
                            ],
                            [
                                -61.02067,
                                10.15156
                            ],
                            [
                                -60.98677,
                                10.32402
                            ],
                            [
                                -61.0291,
                                10.4255
                            ],
                            [
                                -61.04066,
                                10.5096
                            ],
                            [
                                -61.01356,
                                10.5276
                            ],
                            [
                                -61.03561,
                                10.65521
                            ],
                            [
                                -60.95003,
                                10.76595
                            ],
                            [
                                -60.95678,
                                10.83414
                            ],
                            [
                                -61.01018,
                                10.84184
                            ],
                            [
                                -61.26765,
                                10.79393
                            ],
                            [
                                -61.35991,
                                10.81078
                            ],
                            [
                                -61.48376,
                                10.7562
                            ],
                            [
                                -61.61086,
                                10.74574
                            ],
                            [
                                -61.66834,
                                10.7069
                            ],
                            [
                                -61.54536,
                                10.67345
                            ],
                            [
                                -61.49831,
                                10.63876
                            ],
                            [
                                -61.464,
                                10.54301
                            ],
                            [
                                -61.49658,
                                10.42201
                            ],
                            [
                                -61.45781,
                                10.29875
                            ],
                            [
                                -61.53202,
                                10.23213
                            ],
                            [
                                -61.61687,
                                10.24978
                            ],
                            [
                                -61.702,
                                10.16481
                            ],
                            [
                                -61.82355,
                                10.13427
                            ],
                            [
                                -61.93006,
                                10.05318
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -60.84484,
                                11.14799
                            ],
                            [
                                -60.78657,
                                11.13498
                            ],
                            [
                                -60.74029,
                                11.18118
                            ],
                            [
                                -60.64227,
                                11.1922
                            ],
                            [
                                -60.58116,
                                11.24726
                            ],
                            [
                                -60.53557,
                                11.25507
                            ],
                            [
                                -60.51848,
                                11.32136
                            ],
                            [
                                -60.6114,
                                11.32199
                            ],
                            [
                                -60.74745,
                                11.24731
                            ],
                            [
                                -60.84484,
                                11.14799
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "TUN",
                "Country": "Tunisia",
                "Total_3GHG": 0.07,
                "Total_3GHG_timeseries": [
                    2.5054e-07,
                    5.051e-07,
                    7.6304e-07,
                    1.024e-06,
                    1.2876e-06,
                    1.5538e-06,
                    1.8224e-06,
                    2.0932e-06,
                    2.3661e-06,
                    2.6446e-06,
                    2.9363e-06,
                    3.2403e-06,
                    3.5627e-06,
                    3.897e-06,
                    4.243e-06,
                    4.6006e-06,
                    4.9698e-06,
                    5.3568e-06,
                    5.7619e-06,
                    6.1923e-06,
                    6.638e-06,
                    7.0983e-06,
                    7.5727e-06,
                    8.0613e-06,
                    8.5662e-06,
                    9.0873e-06,
                    9.6245e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012
                ],
                "Fossil_3GHG": 0.08,
                "Fossil_3GHG_timeseries": [
                    5.7009e-08,
                    1.1541e-07,
                    1.752e-07,
                    2.3635e-07,
                    2.9885e-07,
                    3.6268e-07,
                    4.2782e-07,
                    4.9423e-07,
                    5.6191e-07,
                    6.3083e-07,
                    7.032e-07,
                    7.7903e-07,
                    8.6463e-07,
                    9.5382e-07,
                    1.0466e-06,
                    1.1429e-06,
                    1.2427e-06,
                    1.3523e-06,
                    1.4721e-06,
                    1.6024e-06,
                    1.7344e-06,
                    1.8682e-06,
                    2.0039e-06,
                    2.1414e-06,
                    2.2832e-06,
                    2.4292e-06,
                    2.5794e-06,
                    2.7338e-06,
                    2.8924e-06,
                    3.0551e-06,
                    3.2204e-06,
                    3.3882e-06,
                    3.5527e-06,
                    3.7196e-06,
                    3.8889e-06,
                    4.0607e-06,
                    4.235e-06,
                    4.4058e-06,
                    4.5729e-06,
                    4.7362e-06,
                    4.9037e-06,
                    5.0754e-06,
                    5.2514e-06,
                    5.4317e-06,
                    5.6142e-06,
                    5.7989e-06,
                    5.986e-06,
                    6.1753e-06,
                    6.3669e-06,
                    6.5573e-06,
                    6.7523e-06,
                    6.9519e-06,
                    7.1563e-06,
                    7.3652e-06,
                    7.5787e-06,
                    7.7968e-06,
                    8.0186e-06,
                    8.244e-06,
                    8.4796e-06,
                    8.7217e-06,
                    8.9696e-06,
                    9.2044e-06,
                    9.425e-06,
                    9.6558e-06,
                    9.8971e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008
                ],
                "Land_3GHG": 0.07,
                "Land_3GHG_timeseries": [
                    1.9353e-07,
                    3.8969e-07,
                    5.8784e-07,
                    7.8762e-07,
                    9.8878e-07,
                    1.1912e-06,
                    1.3946e-06,
                    1.599e-06,
                    1.8042e-06,
                    2.0137e-06,
                    2.233e-06,
                    2.4613e-06,
                    2.6981e-06,
                    2.9431e-06,
                    3.1964e-06,
                    3.4577e-06,
                    3.7271e-06,
                    4.0045e-06,
                    4.2898e-06,
                    4.5899e-06,
                    4.9037e-06,
                    5.2301e-06,
                    5.5688e-06,
                    5.9198e-06,
                    6.283e-06,
                    6.6582e-06,
                    7.0452e-06,
                    7.4437e-06,
                    7.8532e-06,
                    8.2798e-06,
                    8.7153e-06,
                    9.1577e-06,
                    9.6064e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Total_CO2": 0.06,
                "Total_CO2_timeseries": [
                    7.854e-08,
                    1.5879e-07,
                    2.4015e-07,
                    3.2225e-07,
                    4.0489e-07,
                    4.8795e-07,
                    5.7132e-07,
                    6.5494e-07,
                    7.3875e-07,
                    8.2629e-07,
                    9.1578e-07,
                    1.0064e-06,
                    1.0977e-06,
                    1.1895e-06,
                    1.2818e-06,
                    1.3742e-06,
                    1.4669e-06,
                    1.5598e-06,
                    1.6529e-06,
                    1.7528e-06,
                    1.8567e-06,
                    1.9627e-06,
                    2.0702e-06,
                    2.1787e-06,
                    2.2879e-06,
                    2.3977e-06,
                    2.5079e-06,
                    2.6185e-06,
                    2.7294e-06,
                    2.8472e-06,
                    2.9688e-06,
                    3.0925e-06,
                    3.2177e-06,
                    3.3437e-06,
                    3.4705e-06,
                    3.5979e-06,
                    3.7256e-06,
                    3.8536e-06,
                    3.9819e-06,
                    4.125e-06,
                    4.2758e-06,
                    4.4309e-06,
                    4.5901e-06,
                    4.7566e-06,
                    4.9374e-06,
                    5.1434e-06,
                    5.3903e-06,
                    5.6959e-06,
                    6.0774e-06,
                    6.5663e-06,
                    7.1686e-06,
                    7.8869e-06,
                    8.7291e-06,
                    9.6931e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007
                ],
                "Fossil_CO2": 0.06,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    4.95e-09,
                    1.815e-08,
                    3.63e-08,
                    3.63e-08,
                    4.95e-08,
                    5.94e-08,
                    5.94e-08,
                    5.94e-08,
                    5.94e-08,
                    5.94e-08,
                    5.94e-08,
                    5.94e-08,
                    5.94e-08,
                    5.94e-08,
                    5.94e-08,
                    5.94e-08,
                    5.94e-08,
                    6.7583e-08,
                    7.5766e-08,
                    8.3949e-08,
                    9.5405e-08,
                    1.085e-07,
                    1.2323e-07,
                    1.3797e-07,
                    1.6425e-07,
                    2.252e-07,
                    2.9769e-07,
                    3.2075e-07,
                    3.6189e-07,
                    4.0468e-07,
                    4.6393e-07,
                    5.2147e-07,
                    5.8717e-07,
                    6.4462e-07,
                    1.1938e-06,
                    1.8138e-06,
                    2.4635e-06,
                    3.0835e-06,
                    3.7166e-06,
                    4.4353e-06,
                    5.1376e-06,
                    5.8463e-06,
                    6.4974e-06,
                    7.2127e-06,
                    7.9892e-06,
                    8.7839e-06,
                    9.5917e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Land_CO2": 0.06,
                "Land_CO2_timeseries": [
                    7.854e-08,
                    1.5879e-07,
                    2.4015e-07,
                    3.2225e-07,
                    4.0489e-07,
                    4.8795e-07,
                    5.7132e-07,
                    6.5494e-07,
                    7.3875e-07,
                    8.2629e-07,
                    9.1578e-07,
                    1.0064e-06,
                    1.0977e-06,
                    1.1895e-06,
                    1.2818e-06,
                    1.3742e-06,
                    1.4669e-06,
                    1.5598e-06,
                    1.6529e-06,
                    1.7528e-06,
                    1.8567e-06,
                    1.9627e-06,
                    2.0702e-06,
                    2.1787e-06,
                    2.2879e-06,
                    2.3977e-06,
                    2.5079e-06,
                    2.6185e-06,
                    2.7294e-06,
                    2.8472e-06,
                    2.9688e-06,
                    3.0925e-06,
                    3.2177e-06,
                    3.3437e-06,
                    3.4705e-06,
                    3.5979e-06,
                    3.7256e-06,
                    3.8536e-06,
                    3.9819e-06,
                    4.125e-06,
                    4.2758e-06,
                    4.4309e-06,
                    4.5901e-06,
                    4.7566e-06,
                    4.9374e-06,
                    5.1434e-06,
                    5.3903e-06,
                    5.6959e-06,
                    6.0774e-06,
                    6.5663e-06,
                    7.1686e-06,
                    7.8869e-06,
                    8.7291e-06,
                    9.6931e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Total_CH4": 0.11,
                "Total_CH4_timeseries": [
                    1.416e-07,
                    2.8497e-07,
                    4.301e-07,
                    5.7697e-07,
                    7.2557e-07,
                    8.7589e-07,
                    1.0279e-06,
                    1.1816e-06,
                    1.337e-06,
                    1.494e-06,
                    1.6622e-06,
                    1.8416e-06,
                    2.0384e-06,
                    2.2466e-06,
                    2.4661e-06,
                    2.6968e-06,
                    2.9388e-06,
                    3.1983e-06,
                    3.4757e-06,
                    3.7713e-06,
                    4.0779e-06,
                    4.3956e-06,
                    4.7243e-06,
                    5.0639e-06,
                    5.4169e-06,
                    5.7831e-06,
                    6.1627e-06,
                    6.5556e-06,
                    6.9618e-06,
                    7.3814e-06,
                    7.808e-06,
                    8.2415e-06,
                    8.676e-06,
                    9.1174e-06,
                    9.5656e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Fossil_CH4": 0.14,
                "Fossil_CH4_timeseries": [
                    4.7877e-08,
                    9.7031e-08,
                    1.4745e-07,
                    1.9912e-07,
                    2.5204e-07,
                    3.0617e-07,
                    3.6152e-07,
                    4.1806e-07,
                    4.7578e-07,
                    5.3466e-07,
                    5.9693e-07,
                    6.6258e-07,
                    7.3795e-07,
                    8.1684e-07,
                    8.9922e-07,
                    9.8509e-07,
                    1.0744e-06,
                    1.1735e-06,
                    1.2826e-06,
                    1.4022e-06,
                    1.5234e-06,
                    1.6462e-06,
                    1.7706e-06,
                    1.8966e-06,
                    2.0265e-06,
                    2.1602e-06,
                    2.2979e-06,
                    2.4395e-06,
                    2.585e-06,
                    2.7345e-06,
                    2.8864e-06,
                    3.0408e-06,
                    3.1917e-06,
                    3.345e-06,
                    3.5005e-06,
                    3.6585e-06,
                    3.8187e-06,
                    3.9755e-06,
                    4.1285e-06,
                    4.2773e-06,
                    4.4301e-06,
                    4.5869e-06,
                    4.7479e-06,
                    4.913e-06,
                    5.0801e-06,
                    5.2493e-06,
                    5.4205e-06,
                    5.5937e-06,
                    5.7691e-06,
                    5.943e-06,
                    6.1213e-06,
                    6.3039e-06,
                    6.4909e-06,
                    6.6823e-06,
                    6.8778e-06,
                    7.0777e-06,
                    7.2808e-06,
                    7.4874e-06,
                    7.7037e-06,
                    7.9264e-06,
                    8.1547e-06,
                    8.3696e-06,
                    8.5701e-06,
                    8.7807e-06,
                    9.0015e-06,
                    9.2328e-06,
                    9.4747e-06,
                    9.7274e-06,
                    9.991e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004
                ],
                "Land_CH4": 0.07,
                "Land_CH4_timeseries": [
                    9.3726e-08,
                    1.8794e-07,
                    2.8265e-07,
                    3.7785e-07,
                    4.7353e-07,
                    5.6971e-07,
                    6.6638e-07,
                    7.6354e-07,
                    8.612e-07,
                    9.5934e-07,
                    1.0653e-06,
                    1.179e-06,
                    1.3005e-06,
                    1.4298e-06,
                    1.5669e-06,
                    1.7117e-06,
                    1.8644e-06,
                    2.0248e-06,
                    2.1931e-06,
                    2.3691e-06,
                    2.5545e-06,
                    2.7494e-06,
                    2.9536e-06,
                    3.1673e-06,
                    3.3904e-06,
                    3.6229e-06,
                    3.8648e-06,
                    4.1161e-06,
                    4.3768e-06,
                    4.6469e-06,
                    4.9215e-06,
                    5.2007e-06,
                    5.4843e-06,
                    5.7724e-06,
                    6.0651e-06,
                    6.3622e-06,
                    6.6638e-06,
                    6.97e-06,
                    7.2806e-06,
                    7.5958e-06,
                    7.9162e-06,
                    8.2418e-06,
                    8.5727e-06,
                    8.9089e-06,
                    9.2503e-06,
                    9.597e-06,
                    9.9489e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_N2O": 0.1,
                "Total_N2O_timeseries": [
                    3.0396e-08,
                    6.1335e-08,
                    9.2798e-08,
                    1.2475e-07,
                    1.5717e-07,
                    1.9e-07,
                    2.2319e-07,
                    2.5668e-07,
                    2.904e-07,
                    3.2428e-07,
                    3.5827e-07,
                    3.9235e-07,
                    4.2653e-07,
                    4.6078e-07,
                    4.9512e-07,
                    5.2953e-07,
                    5.6403e-07,
                    5.9862e-07,
                    6.3331e-07,
                    6.6811e-07,
                    7.0343e-07,
                    7.3996e-07,
                    7.7825e-07,
                    8.1866e-07,
                    8.6141e-07,
                    9.0655e-07,
                    9.5396e-07,
                    1.0034e-06,
                    1.0544e-06,
                    1.1064e-06,
                    1.1589e-06,
                    1.212e-06,
                    1.2655e-06,
                    1.3193e-06,
                    1.3735e-06,
                    1.4281e-06,
                    1.4829e-06,
                    1.5382e-06,
                    1.5938e-06,
                    1.6519e-06,
                    1.7106e-06,
                    1.7699e-06,
                    1.8299e-06,
                    1.8905e-06,
                    1.9518e-06,
                    2.0138e-06,
                    2.0765e-06,
                    2.14e-06,
                    2.2043e-06,
                    2.2694e-06,
                    2.3352e-06,
                    2.4019e-06,
                    2.4695e-06,
                    2.5379e-06,
                    2.6071e-06,
                    2.6774e-06,
                    2.7487e-06,
                    2.8211e-06,
                    2.8946e-06,
                    2.9695e-06,
                    3.0461e-06,
                    3.1253e-06,
                    3.2077e-06,
                    3.2937e-06,
                    3.3838e-06,
                    3.478e-06,
                    3.5767e-06,
                    3.6796e-06,
                    3.7866e-06,
                    3.8975e-06,
                    4.0122e-06,
                    4.1313e-06,
                    4.2549e-06,
                    4.3832e-06,
                    4.5161e-06,
                    4.6532e-06,
                    4.7939e-06,
                    4.9377e-06,
                    5.0835e-06,
                    5.2303e-06,
                    5.3783e-06,
                    5.5293e-06,
                    5.6846e-06,
                    5.8454e-06,
                    6.0127e-06,
                    6.1873e-06,
                    6.3697e-06,
                    6.5601e-06,
                    6.7588e-06,
                    6.9656e-06,
                    7.1916e-06,
                    7.4566e-06,
                    7.775e-06,
                    8.1564e-06,
                    8.6055e-06,
                    9.122e-06,
                    9.7006e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_N2O": 0.12,
                "Fossil_N2O_timeseries": [
                    9.132e-09,
                    1.8382e-08,
                    2.7749e-08,
                    3.7227e-08,
                    4.6815e-08,
                    5.6505e-08,
                    6.6293e-08,
                    7.6172e-08,
                    8.6132e-08,
                    9.6167e-08,
                    1.0627e-07,
                    1.1644e-07,
                    1.2668e-07,
                    1.3698e-07,
                    1.4734e-07,
                    1.5778e-07,
                    1.6827e-07,
                    1.7884e-07,
                    1.8947e-07,
                    2.0016e-07,
                    2.1098e-07,
                    2.2199e-07,
                    2.3326e-07,
                    2.4482e-07,
                    2.5671e-07,
                    2.6894e-07,
                    2.8147e-07,
                    2.943e-07,
                    3.0736e-07,
                    3.2059e-07,
                    3.3395e-07,
                    3.4741e-07,
                    3.6098e-07,
                    3.7465e-07,
                    3.8842e-07,
                    4.0228e-07,
                    4.1623e-07,
                    4.3028e-07,
                    4.4443e-07,
                    4.5894e-07,
                    4.7361e-07,
                    4.8845e-07,
                    5.0347e-07,
                    5.1869e-07,
                    5.3409e-07,
                    5.497e-07,
                    5.6551e-07,
                    5.8154e-07,
                    5.9779e-07,
                    6.1427e-07,
                    6.31e-07,
                    6.48e-07,
                    6.6531e-07,
                    6.8294e-07,
                    7.0089e-07,
                    7.1916e-07,
                    7.3776e-07,
                    7.5665e-07,
                    7.7583e-07,
                    7.9525e-07,
                    8.1491e-07,
                    8.3479e-07,
                    8.5488e-07,
                    8.7517e-07,
                    8.9567e-07,
                    9.1636e-07,
                    9.3726e-07,
                    9.5836e-07,
                    9.7966e-07,
                    1.0012e-06,
                    1.0229e-06,
                    1.0449e-06,
                    1.067e-06,
                    1.0894e-06,
                    1.112e-06,
                    1.1348e-06,
                    1.1579e-06,
                    1.1811e-06,
                    1.2047e-06,
                    1.2284e-06,
                    1.2539e-06,
                    1.2835e-06,
                    1.3193e-06,
                    1.363e-06,
                    1.4157e-06,
                    1.4783e-06,
                    1.551e-06,
                    1.6337e-06,
                    1.7258e-06,
                    1.8264e-06,
                    1.9354e-06,
                    2.0537e-06,
                    2.182e-06,
                    2.3204e-06,
                    2.469e-06,
                    2.6271e-06,
                    2.7941e-06,
                    2.9687e-06,
                    3.1496e-06,
                    3.3347e-06,
                    3.5229e-06,
                    3.7137e-06,
                    3.9069e-06,
                    4.1021e-06,
                    4.2993e-06,
                    4.4986e-06,
                    4.7e-06,
                    4.9039e-06,
                    5.1105e-06,
                    5.3203e-06,
                    5.5359e-06,
                    5.7618e-06,
                    6.0025e-06,
                    6.2628e-06,
                    6.5472e-06,
                    6.8606e-06,
                    7.2076e-06,
                    7.5932e-06,
                    8.0222e-06,
                    8.3536e-06,
                    8.6997e-06,
                    9.0635e-06,
                    9.4571e-06,
                    9.8744e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.1,
                "Land_N2O_timeseries": [
                    2.1264e-08,
                    4.2953e-08,
                    6.5049e-08,
                    8.7527e-08,
                    1.1035e-07,
                    1.3349e-07,
                    1.5689e-07,
                    1.805e-07,
                    2.0427e-07,
                    2.2811e-07,
                    2.52e-07,
                    2.7591e-07,
                    2.9985e-07,
                    3.2381e-07,
                    3.4777e-07,
                    3.7176e-07,
                    3.9576e-07,
                    4.1978e-07,
                    4.4384e-07,
                    4.6794e-07,
                    4.9245e-07,
                    5.1797e-07,
                    5.4499e-07,
                    5.7384e-07,
                    6.047e-07,
                    6.3761e-07,
                    6.7249e-07,
                    7.0908e-07,
                    7.4701e-07,
                    7.8576e-07,
                    8.2496e-07,
                    8.6455e-07,
                    9.0447e-07,
                    9.4466e-07,
                    9.8511e-07,
                    1.0258e-06,
                    1.0667e-06,
                    1.1079e-06,
                    1.1493e-06,
                    1.193e-06,
                    1.237e-06,
                    1.2815e-06,
                    1.3264e-06,
                    1.3718e-06,
                    1.4177e-06,
                    1.4641e-06,
                    1.511e-06,
                    1.5585e-06,
                    1.6065e-06,
                    1.6551e-06,
                    1.7043e-06,
                    1.7539e-06,
                    1.8042e-06,
                    1.8549e-06,
                    1.9063e-06,
                    1.9582e-06,
                    2.0109e-06,
                    2.0644e-06,
                    2.1188e-06,
                    2.1743e-06,
                    2.2312e-06,
                    2.2905e-06,
                    2.3528e-06,
                    2.4185e-06,
                    2.4881e-06,
                    2.5617e-06,
                    2.6394e-06,
                    2.7212e-06,
                    2.807e-06,
                    2.8963e-06,
                    2.9893e-06,
                    3.0864e-06,
                    3.1879e-06,
                    3.2938e-06,
                    3.4041e-06,
                    3.5184e-06,
                    3.6361e-06,
                    3.7565e-06,
                    3.8788e-06,
                    4.0018e-06,
                    4.1245e-06,
                    4.2458e-06,
                    4.3653e-06,
                    4.4824e-06,
                    4.597e-06,
                    4.709e-06,
                    4.8187e-06,
                    4.9265e-06,
                    5.033e-06,
                    5.1391e-06,
                    5.2562e-06,
                    5.4029e-06,
                    5.593e-06,
                    5.8359e-06,
                    6.1365e-06,
                    6.4948e-06,
                    6.9065e-06,
                    7.3624e-06,
                    7.8488e-06,
                    8.3475e-06,
                    8.8425e-06,
                    9.3242e-06,
                    9.7859e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                9.55156,
                                30.24639
                            ],
                            [
                                9.6176,
                                30.25122
                            ],
                            [
                                9.7457,
                                30.31605
                            ],
                            [
                                9.88718,
                                30.34929
                            ],
                            [
                                9.94569,
                                30.39311
                            ],
                            [
                                10.0217,
                                30.50721
                            ],
                            [
                                10.21493,
                                30.71607
                            ],
                            [
                                10.27697,
                                30.82343
                            ],
                            [
                                10.30681,
                                30.90819
                            ],
                            [
                                10.27549,
                                31.02718
                            ],
                            [
                                10.28685,
                                31.0813
                            ],
                            [
                                10.15314,
                                31.39144
                            ],
                            [
                                10.14115,
                                31.49289
                            ],
                            [
                                10.29157,
                                31.68956
                            ],
                            [
                                10.37654,
                                31.73838
                            ],
                            [
                                10.45664,
                                31.72841
                            ],
                            [
                                10.53013,
                                31.7481
                            ],
                            [
                                10.63224,
                                31.86271
                            ],
                            [
                                10.6437,
                                31.97284
                            ],
                            [
                                10.79235,
                                31.99992
                            ],
                            [
                                10.8597,
                                32.11084
                            ],
                            [
                                10.97898,
                                32.18476
                            ],
                            [
                                11.20182,
                                32.27576
                            ],
                            [
                                11.36426,
                                32.32172
                            ],
                            [
                                11.52801,
                                32.40432
                            ],
                            [
                                11.59758,
                                32.52333
                            ],
                            [
                                11.50869,
                                32.61364
                            ],
                            [
                                11.48905,
                                32.66569
                            ],
                            [
                                11.50721,
                                32.84318
                            ],
                            [
                                11.48979,
                                32.89358
                            ],
                            [
                                11.52885,
                                33.07364
                            ],
                            [
                                11.56432,
                                33.16511
                            ],
                            [
                                11.43627,
                                33.19666
                            ],
                            [
                                11.3636,
                                33.18306
                            ],
                            [
                                11.19484,
                                33.20465
                            ],
                            [
                                11.1233,
                                33.28431
                            ],
                            [
                                11.18321,
                                33.32704
                            ],
                            [
                                11.09659,
                                33.43536
                            ],
                            [
                                11.11649,
                                33.48723
                            ],
                            [
                                11.10149,
                                33.56451
                            ],
                            [
                                11.00832,
                                33.63817
                            ],
                            [
                                10.91805,
                                33.60651
                            ],
                            [
                                10.94423,
                                33.56568
                            ],
                            [
                                10.89873,
                                33.52148
                            ],
                            [
                                10.75557,
                                33.47702
                            ],
                            [
                                10.68502,
                                33.54077
                            ],
                            [
                                10.73299,
                                33.60385
                            ],
                            [
                                10.7411,
                                33.6748
                            ],
                            [
                                10.69439,
                                33.70245
                            ],
                            [
                                10.4868,
                                33.63316
                            ],
                            [
                                10.33585,
                                33.70864
                            ],
                            [
                                10.14015,
                                33.86587
                            ],
                            [
                                10.06481,
                                33.96844
                            ],
                            [
                                10.02729,
                                34.08212
                            ],
                            [
                                10.03701,
                                34.18158
                            ],
                            [
                                10.12219,
                                34.31301
                            ],
                            [
                                10.3756,
                                34.42628
                            ],
                            [
                                10.43068,
                                34.48473
                            ],
                            [
                                10.59761,
                                34.54969
                            ],
                            [
                                10.64456,
                                34.62729
                            ],
                            [
                                10.72653,
                                34.65103
                            ],
                            [
                                10.75673,
                                34.71606
                            ],
                            [
                                10.91967,
                                34.88653
                            ],
                            [
                                10.93106,
                                34.9679
                            ],
                            [
                                11.00542,
                                35.01932
                            ],
                            [
                                11.03181,
                                35.11617
                            ],
                            [
                                11.12024,
                                35.21923
                            ],
                            [
                                11.03659,
                                35.34519
                            ],
                            [
                                11.06898,
                                35.50252
                            ],
                            [
                                11.03292,
                                35.57088
                            ],
                            [
                                11.04211,
                                35.62538
                            ],
                            [
                                10.83978,
                                35.69545
                            ],
                            [
                                10.83927,
                                35.76574
                            ],
                            [
                                10.71767,
                                35.7724
                            ],
                            [
                                10.6524,
                                35.81286
                            ],
                            [
                                10.5413,
                                35.96235
                            ],
                            [
                                10.49759,
                                35.99126
                            ],
                            [
                                10.46854,
                                36.15143
                            ],
                            [
                                10.48583,
                                36.25509
                            ],
                            [
                                10.57035,
                                36.3929
                            ],
                            [
                                10.63062,
                                36.39848
                            ],
                            [
                                10.80631,
                                36.45926
                            ],
                            [
                                10.93544,
                                36.67523
                            ],
                            [
                                11.02131,
                                36.78383
                            ],
                            [
                                11.11823,
                                36.83991
                            ],
                            [
                                11.13101,
                                36.87534
                            ],
                            [
                                11.03864,
                                37.08267
                            ],
                            [
                                10.91331,
                                37.04578
                            ],
                            [
                                10.87179,
                                36.9785
                            ],
                            [
                                10.70029,
                                36.88149
                            ],
                            [
                                10.61711,
                                36.87781
                            ],
                            [
                                10.53467,
                                36.7599
                            ],
                            [
                                10.40954,
                                36.71785
                            ],
                            [
                                10.34514,
                                36.73149
                            ],
                            [
                                10.29056,
                                36.78
                            ],
                            [
                                10.3481,
                                36.86919
                            ],
                            [
                                10.31292,
                                36.91522
                            ],
                            [
                                10.20919,
                                36.9804
                            ],
                            [
                                10.17925,
                                37.05794
                            ],
                            [
                                10.20276,
                                37.10848
                            ],
                            [
                                10.16019,
                                37.1646
                            ],
                            [
                                10.21723,
                                37.18857
                            ],
                            [
                                10.06459,
                                37.26322
                            ],
                            [
                                9.93044,
                                37.22114
                            ],
                            [
                                9.86994,
                                37.1393
                            ],
                            [
                                9.8109,
                                37.1494
                            ],
                            [
                                9.77457,
                                37.21694
                            ],
                            [
                                9.87539,
                                37.27342
                            ],
                            [
                                9.85372,
                                37.33246
                            ],
                            [
                                9.66656,
                                37.33603
                            ],
                            [
                                9.59294,
                                37.29924
                            ],
                            [
                                9.40489,
                                37.26681
                            ],
                            [
                                9.25011,
                                37.2182
                            ],
                            [
                                9.21121,
                                37.23474
                            ],
                            [
                                9.12376,
                                37.1657
                            ],
                            [
                                8.98673,
                                37.10621
                            ],
                            [
                                8.94773,
                                37.05779
                            ],
                            [
                                8.83127,
                                36.97412
                            ],
                            [
                                8.64209,
                                36.94115
                            ],
                            [
                                8.62675,
                                36.85677
                            ],
                            [
                                8.65594,
                                36.80934
                            ],
                            [
                                8.57145,
                                36.77315
                            ],
                            [
                                8.48653,
                                36.7781
                            ],
                            [
                                8.48635,
                                36.69434
                            ],
                            [
                                8.44635,
                                36.6196
                            ],
                            [
                                8.32888,
                                36.57377
                            ],
                            [
                                8.29043,
                                36.53889
                            ],
                            [
                                8.15563,
                                36.49607
                            ],
                            [
                                8.20988,
                                36.44713
                            ],
                            [
                                8.35562,
                                36.44362
                            ],
                            [
                                8.40421,
                                36.42183
                            ],
                            [
                                8.38914,
                                36.30432
                            ],
                            [
                                8.30762,
                                36.17184
                            ],
                            [
                                8.34414,
                                36.10256
                            ],
                            [
                                8.29797,
                                36.03958
                            ],
                            [
                                8.29064,
                                35.95772
                            ],
                            [
                                8.25557,
                                35.88559
                            ],
                            [
                                8.26616,
                                35.73023
                            ],
                            [
                                8.35552,
                                35.66799
                            ],
                            [
                                8.3609,
                                35.52365
                            ],
                            [
                                8.38382,
                                35.48586
                            ],
                            [
                                8.32994,
                                35.42257
                            ],
                            [
                                8.31238,
                                35.31434
                            ],
                            [
                                8.33435,
                                35.28009
                            ],
                            [
                                8.47271,
                                35.23691
                            ],
                            [
                                8.40217,
                                35.12943
                            ],
                            [
                                8.35692,
                                35.09632
                            ],
                            [
                                8.31665,
                                35.00977
                            ],
                            [
                                8.31372,
                                34.94796
                            ],
                            [
                                8.24807,
                                34.91995
                            ],
                            [
                                8.29628,
                                34.72938
                            ],
                            [
                                8.23745,
                                34.67605
                            ],
                            [
                                8.24337,
                                34.63153
                            ],
                            [
                                8.14662,
                                34.53337
                            ],
                            [
                                8.04028,
                                34.49001
                            ],
                            [
                                7.9338,
                                34.42078
                            ],
                            [
                                7.8563,
                                34.40314
                            ],
                            [
                                7.80349,
                                34.219
                            ],
                            [
                                7.72432,
                                34.16719
                            ],
                            [
                                7.65382,
                                34.19495
                            ],
                            [
                                7.60474,
                                34.11112
                            ],
                            [
                                7.53048,
                                34.05872
                            ],
                            [
                                7.55304,
                                34.01625
                            ],
                            [
                                7.52353,
                                33.90499
                            ],
                            [
                                7.52654,
                                33.7973
                            ],
                            [
                                7.58656,
                                33.75155
                            ],
                            [
                                7.59446,
                                33.6445
                            ],
                            [
                                7.62932,
                                33.5718
                            ],
                            [
                                7.74313,
                                33.42388
                            ],
                            [
                                7.81023,
                                33.20718
                            ],
                            [
                                8.14064,
                                33.0839
                            ],
                            [
                                8.10702,
                                33.04709
                            ],
                            [
                                8.3223,
                                32.82239
                            ],
                            [
                                8.35839,
                                32.50184
                            ],
                            [
                                9.07522,
                                32.08578
                            ],
                            [
                                9.31376,
                                31.16831
                            ],
                            [
                                9.47009,
                                30.56122
                            ],
                            [
                                9.55156,
                                30.24639
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                10.7281,
                                33.76379
                            ],
                            [
                                10.76178,
                                33.70047
                            ],
                            [
                                10.82699,
                                33.73774
                            ],
                            [
                                10.89061,
                                33.66438
                            ],
                            [
                                11.06108,
                                33.79137
                            ],
                            [
                                11.05503,
                                33.82561
                            ],
                            [
                                10.93292,
                                33.87707
                            ],
                            [
                                10.79502,
                                33.90167
                            ],
                            [
                                10.74577,
                                33.88872
                            ],
                            [
                                10.7281,
                                33.76379
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                11.12325,
                                34.67913
                            ],
                            [
                                11.24932,
                                34.71245
                            ],
                            [
                                11.29499,
                                34.7537
                            ],
                            [
                                11.25176,
                                34.82837
                            ],
                            [
                                11.12325,
                                34.67913
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "TKM",
                "Country": "Turkmenistan",
                "Total_3GHG": 0.23,
                "Total_3GHG_timeseries": [
                    2.0088e-06,
                    4.0288e-06,
                    6.0593e-06,
                    8.0997e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0037
                ],
                "Fossil_3GHG": 0.27,
                "Fossil_3GHG_timeseries": [
                    3.6782e-08,
                    7.3765e-08,
                    1.1095e-07,
                    1.4833e-07,
                    1.872e-07,
                    2.2496e-07,
                    2.6291e-07,
                    3.0287e-07,
                    3.4311e-07,
                    3.843e-07,
                    4.2787e-07,
                    4.7278e-07,
                    5.6737e-07,
                    6.6441e-07,
                    7.6329e-07,
                    8.713e-07,
                    9.8302e-07,
                    1.0953e-06,
                    1.213e-06,
                    1.3338e-06,
                    1.4616e-06,
                    1.5922e-06,
                    1.7252e-06,
                    1.8659e-06,
                    2.0148e-06,
                    2.1764e-06,
                    2.3452e-06,
                    2.5295e-06,
                    2.7214e-06,
                    2.9259e-06,
                    3.1431e-06,
                    3.3667e-06,
                    3.5579e-06,
                    3.7684e-06,
                    4.0005e-06,
                    4.2372e-06,
                    4.4981e-06,
                    4.7697e-06,
                    5.048e-06,
                    5.3607e-06,
                    5.7114e-06,
                    6.0744e-06,
                    6.4844e-06,
                    6.8797e-06,
                    7.3548e-06,
                    7.8269e-06,
                    8.3513e-06,
                    8.9284e-06,
                    9.5549e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028
                ],
                "Land_3GHG": 0.16,
                "Land_3GHG_timeseries": [
                    1.972e-06,
                    3.9551e-06,
                    5.9484e-06,
                    7.9514e-06,
                    9.9637e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009
                ],
                "Total_CO2": 0.15,
                "Total_CO2_timeseries": [
                    1.8256e-06,
                    3.6607e-06,
                    5.5046e-06,
                    7.3569e-06,
                    9.2185e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017
                ],
                "Fossil_CO2": 0.15,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    1.2983e-09,
                    1.2983e-09,
                    1.2983e-09,
                    3.1217e-09,
                    5.0554e-09,
                    7.6105e-09,
                    1.0856e-08,
                    1.3785e-08,
                    1.6851e-08,
                    2.029e-08,
                    2.3577e-08,
                    3.3964e-08,
                    4.5884e-08,
                    5.5801e-08,
                    6.9255e-08,
                    8.3854e-08,
                    1.0356e-07,
                    1.238e-07,
                    1.4279e-07,
                    1.6584e-07,
                    1.9238e-07,
                    2.2532e-07,
                    2.5894e-07,
                    3.0287e-07,
                    3.4796e-07,
                    4.0085e-07,
                    4.5655e-07,
                    5.1522e-07,
                    5.8201e-07,
                    6.4981e-07,
                    7.2367e-07,
                    7.9941e-07,
                    8.7956e-07,
                    9.6317e-07,
                    1.0535e-06,
                    1.1557e-06,
                    1.2683e-06,
                    1.3875e-06,
                    1.5272e-06,
                    1.6694e-06,
                    1.8329e-06,
                    1.9993e-06,
                    2.1917e-06,
                    2.4075e-06,
                    2.6578e-06,
                    2.9414e-06,
                    3.2325e-06,
                    3.5137e-06,
                    3.7888e-06,
                    4.0948e-06,
                    4.368e-06,
                    4.6795e-06,
                    5.0285e-06,
                    5.3797e-06,
                    5.7503e-06,
                    6.1139e-06,
                    6.4907e-06,
                    6.9177e-06,
                    7.3814e-06,
                    7.8e-06,
                    8.1842e-06,
                    8.5937e-06,
                    8.9705e-06,
                    9.1208e-06,
                    9.2492e-06,
                    9.3662e-06,
                    9.4932e-06,
                    9.648e-06,
                    9.819e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011
                ],
                "Land_CO2": 0.15,
                "Land_CO2_timeseries": [
                    1.8256e-06,
                    3.6607e-06,
                    5.5046e-06,
                    7.3569e-06,
                    9.2172e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Total_CH4": 0.47,
                "Total_CH4_timeseries": [
                    9.4966e-08,
                    1.9003e-07,
                    2.852e-07,
                    3.8048e-07,
                    4.7586e-07,
                    5.7134e-07,
                    6.6692e-07,
                    7.6261e-07,
                    8.5841e-07,
                    9.5448e-07,
                    1.0579e-06,
                    1.1686e-06,
                    1.3346e-06,
                    1.5083e-06,
                    1.6896e-06,
                    1.8787e-06,
                    2.0755e-06,
                    2.2806e-06,
                    2.4933e-06,
                    2.7136e-06,
                    2.9419e-06,
                    3.1786e-06,
                    3.4249e-06,
                    3.6809e-06,
                    3.9475e-06,
                    4.2264e-06,
                    4.5179e-06,
                    4.8205e-06,
                    5.1355e-06,
                    5.4615e-06,
                    5.7987e-06,
                    6.1406e-06,
                    6.4434e-06,
                    6.7658e-06,
                    7.1051e-06,
                    7.4485e-06,
                    7.813e-06,
                    8.1861e-06,
                    8.5605e-06,
                    8.9584e-06,
                    9.3853e-06,
                    9.8193e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019
                ],
                "Fossil_CH4": 0.64,
                "Fossil_CH4_timeseries": [
                    1.9451e-08,
                    3.8908e-08,
                    5.8373e-08,
                    7.7845e-08,
                    9.7332e-08,
                    1.1682e-07,
                    1.3631e-07,
                    1.5582e-07,
                    1.7534e-07,
                    1.9503e-07,
                    2.1625e-07,
                    2.3898e-07,
                    3.111e-07,
                    3.8514e-07,
                    4.6102e-07,
                    5.3879e-07,
                    6.1858e-07,
                    7.0076e-07,
                    7.8469e-07,
                    8.7041e-07,
                    9.5784e-07,
                    1.0473e-06,
                    1.1401e-06,
                    1.2362e-06,
                    1.3366e-06,
                    1.443e-06,
                    1.5556e-06,
                    1.673e-06,
                    1.7965e-06,
                    1.9245e-06,
                    2.0623e-06,
                    2.2034e-06,
                    2.3038e-06,
                    2.4222e-06,
                    2.556e-06,
                    2.6924e-06,
                    2.8484e-06,
                    3.0114e-06,
                    3.1743e-06,
                    3.3591e-06,
                    3.5713e-06,
                    3.7889e-06,
                    4.0327e-06,
                    4.2589e-06,
                    4.5435e-06,
                    4.8218e-06,
                    5.1261e-06,
                    5.4593e-06,
                    5.8071e-06,
                    6.2015e-06,
                    6.6257e-06,
                    7.021e-06,
                    7.3736e-06,
                    7.7191e-06,
                    7.9589e-06,
                    8.2267e-06,
                    8.4882e-06,
                    8.7402e-06,
                    9.0092e-06,
                    9.2655e-06,
                    9.4854e-06,
                    9.711e-06,
                    9.9074e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017
                ],
                "Land_CH4": 0.18,
                "Land_CH4_timeseries": [
                    7.5515e-08,
                    1.5113e-07,
                    2.2683e-07,
                    3.0263e-07,
                    3.7853e-07,
                    4.5452e-07,
                    5.3061e-07,
                    6.0679e-07,
                    6.8307e-07,
                    7.5945e-07,
                    8.4164e-07,
                    9.2965e-07,
                    1.0235e-06,
                    1.1231e-06,
                    1.2286e-06,
                    1.3399e-06,
                    1.457e-06,
                    1.5799e-06,
                    1.7086e-06,
                    1.8432e-06,
                    1.9841e-06,
                    2.1313e-06,
                    2.2848e-06,
                    2.4447e-06,
                    2.6109e-06,
                    2.7834e-06,
                    2.9623e-06,
                    3.1475e-06,
                    3.3391e-06,
                    3.5369e-06,
                    3.7363e-06,
                    3.9372e-06,
                    4.1397e-06,
                    4.3436e-06,
                    4.5491e-06,
                    4.7561e-06,
                    4.9646e-06,
                    5.1747e-06,
                    5.3862e-06,
                    5.5993e-06,
                    5.814e-06,
                    6.0304e-06,
                    6.2484e-06,
                    6.468e-06,
                    6.6893e-06,
                    6.9123e-06,
                    7.1368e-06,
                    7.363e-06,
                    7.5909e-06,
                    7.8203e-06,
                    8.0516e-06,
                    8.2846e-06,
                    8.5194e-06,
                    8.7559e-06,
                    8.9942e-06,
                    9.2343e-06,
                    9.4761e-06,
                    9.7197e-06,
                    9.9651e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Total_N2O": 0.16,
                "Total_N2O_timeseries": [
                    8.8235e-08,
                    1.7808e-07,
                    2.6948e-07,
                    3.6234e-07,
                    4.5655e-07,
                    5.5197e-07,
                    6.4845e-07,
                    7.4581e-07,
                    8.4383e-07,
                    9.4229e-07,
                    1.041e-06,
                    1.14e-06,
                    1.2393e-06,
                    1.3387e-06,
                    1.4383e-06,
                    1.5382e-06,
                    1.6382e-06,
                    1.7385e-06,
                    1.839e-06,
                    1.9398e-06,
                    2.0422e-06,
                    2.1482e-06,
                    2.2596e-06,
                    2.3773e-06,
                    2.5021e-06,
                    2.6342e-06,
                    2.7731e-06,
                    2.9181e-06,
                    3.0679e-06,
                    3.2205e-06,
                    3.375e-06,
                    3.5309e-06,
                    3.688e-06,
                    3.8463e-06,
                    4.0056e-06,
                    4.1659e-06,
                    4.3271e-06,
                    4.4893e-06,
                    4.6526e-06,
                    4.8196e-06,
                    4.9891e-06,
                    5.1611e-06,
                    5.3355e-06,
                    5.5122e-06,
                    5.691e-06,
                    5.8718e-06,
                    6.0543e-06,
                    6.2382e-06,
                    6.4233e-06,
                    6.6093e-06,
                    6.7959e-06,
                    6.983e-06,
                    7.1708e-06,
                    7.3591e-06,
                    7.5479e-06,
                    7.7372e-06,
                    7.9271e-06,
                    8.1176e-06,
                    8.3087e-06,
                    8.5005e-06,
                    8.6948e-06,
                    8.8945e-06,
                    9.1021e-06,
                    9.3191e-06,
                    9.5466e-06,
                    9.7848e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_N2O": 0.15,
                "Fossil_N2O_timeseries": [
                    1.7331e-08,
                    3.4856e-08,
                    5.2574e-08,
                    7.048e-08,
                    8.8573e-08,
                    1.0685e-07,
                    1.253e-07,
                    1.4392e-07,
                    1.6271e-07,
                    1.8166e-07,
                    2.0076e-07,
                    2.2002e-07,
                    2.3942e-07,
                    2.5898e-07,
                    2.7869e-07,
                    2.9855e-07,
                    3.1856e-07,
                    3.3872e-07,
                    3.5903e-07,
                    3.795e-07,
                    4.0016e-07,
                    4.2108e-07,
                    4.4231e-07,
                    4.6387e-07,
                    4.858e-07,
                    5.0809e-07,
                    5.3073e-07,
                    5.5371e-07,
                    5.7697e-07,
                    6.0047e-07,
                    6.2417e-07,
                    6.4805e-07,
                    6.7212e-07,
                    6.9637e-07,
                    7.208e-07,
                    7.454e-07,
                    7.7017e-07,
                    7.9512e-07,
                    8.2025e-07,
                    8.459e-07,
                    8.7183e-07,
                    8.9803e-07,
                    9.2452e-07,
                    9.5131e-07,
                    9.784e-07,
                    1.0058e-06,
                    1.0335e-06,
                    1.0616e-06,
                    1.09e-06,
                    1.1187e-06,
                    1.1478e-06,
                    1.1773e-06,
                    1.2072e-06,
                    1.2375e-06,
                    1.2683e-06,
                    1.2995e-06,
                    1.3311e-06,
                    1.3632e-06,
                    1.3957e-06,
                    1.4285e-06,
                    1.4617e-06,
                    1.4952e-06,
                    1.529e-06,
                    1.5631e-06,
                    1.5975e-06,
                    1.6322e-06,
                    1.6672e-06,
                    1.7025e-06,
                    1.7382e-06,
                    1.7744e-06,
                    1.8111e-06,
                    1.8487e-06,
                    1.8875e-06,
                    1.9278e-06,
                    1.9696e-06,
                    2.0133e-06,
                    2.059e-06,
                    2.1069e-06,
                    2.157e-06,
                    2.2095e-06,
                    2.265e-06,
                    2.3244e-06,
                    2.3888e-06,
                    2.4587e-06,
                    2.5347e-06,
                    2.617e-06,
                    2.7057e-06,
                    2.8006e-06,
                    2.9016e-06,
                    3.0081e-06,
                    3.1196e-06,
                    3.2359e-06,
                    3.3568e-06,
                    3.4823e-06,
                    3.6126e-06,
                    3.7478e-06,
                    3.8882e-06,
                    4.0344e-06,
                    4.1868e-06,
                    4.3463e-06,
                    4.5154e-06,
                    4.6985e-06,
                    4.8985e-06,
                    5.1175e-06,
                    5.3568e-06,
                    5.6163e-06,
                    5.8952e-06,
                    6.1917e-06,
                    6.5028e-06,
                    6.8246e-06,
                    7.1557e-06,
                    7.4976e-06,
                    7.851e-06,
                    8.2164e-06,
                    8.5935e-06,
                    8.9815e-06,
                    9.379e-06,
                    9.7844e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.16,
                "Land_N2O_timeseries": [
                    7.0904e-08,
                    1.4323e-07,
                    2.169e-07,
                    2.9186e-07,
                    3.6797e-07,
                    4.4512e-07,
                    5.2315e-07,
                    6.0189e-07,
                    6.8112e-07,
                    7.6063e-07,
                    8.4028e-07,
                    9.2002e-07,
                    9.9984e-07,
                    1.0797e-06,
                    1.1596e-06,
                    1.2396e-06,
                    1.3196e-06,
                    1.3998e-06,
                    1.48e-06,
                    1.5603e-06,
                    1.642e-06,
                    1.7272e-06,
                    1.8173e-06,
                    1.9134e-06,
                    2.0163e-06,
                    2.1261e-06,
                    2.2424e-06,
                    2.3644e-06,
                    2.4909e-06,
                    2.6201e-06,
                    2.7508e-06,
                    2.8828e-06,
                    3.0159e-06,
                    3.1499e-06,
                    3.2848e-06,
                    3.4205e-06,
                    3.5569e-06,
                    3.6942e-06,
                    3.8324e-06,
                    3.9737e-06,
                    4.1172e-06,
                    4.263e-06,
                    4.4109e-06,
                    4.5609e-06,
                    4.7126e-06,
                    4.866e-06,
                    5.0207e-06,
                    5.1766e-06,
                    5.3334e-06,
                    5.4906e-06,
                    5.6481e-06,
                    5.8057e-06,
                    5.9636e-06,
                    6.1215e-06,
                    6.2796e-06,
                    6.4377e-06,
                    6.596e-06,
                    6.7544e-06,
                    6.9131e-06,
                    7.072e-06,
                    7.2331e-06,
                    7.3993e-06,
                    7.573e-06,
                    7.756e-06,
                    7.9491e-06,
                    8.1527e-06,
                    8.3661e-06,
                    8.5883e-06,
                    8.8175e-06,
                    9.0509e-06,
                    9.2871e-06,
                    9.526e-06,
                    9.7673e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            66.55373,
                            37.35475
                        ],
                        [
                            66.52947,
                            37.40143
                        ],
                        [
                            66.63774,
                            37.4391
                        ],
                        [
                            66.63635,
                            37.48446
                        ],
                        [
                            66.53958,
                            37.57809
                        ],
                        [
                            66.53921,
                            37.7476
                        ],
                        [
                            66.56473,
                            37.82292
                        ],
                        [
                            66.67653,
                            37.9617
                        ],
                        [
                            66.5499,
                            38.0383
                        ],
                        [
                            66.40064,
                            38.03256
                        ],
                        [
                            66.31191,
                            38.07982
                        ],
                        [
                            66.23834,
                            38.15766
                        ],
                        [
                            65.85312,
                            38.2743
                        ],
                        [
                            65.79576,
                            38.23611
                        ],
                        [
                            65.69495,
                            38.25253
                        ],
                        [
                            65.48183,
                            38.31892
                        ],
                        [
                            65.30102,
                            38.4083
                        ],
                        [
                            65.03388,
                            38.60767
                        ],
                        [
                            64.82733,
                            38.67927
                        ],
                        [
                            64.52451,
                            38.83733
                        ],
                        [
                            64.33141,
                            38.9852
                        ],
                        [
                            64.22945,
                            38.95682
                        ],
                        [
                            64.15689,
                            38.9676
                        ],
                        [
                            63.74497,
                            39.20723
                        ],
                        [
                            63.53743,
                            39.38428
                        ],
                        [
                            63.17045,
                            39.57413
                        ],
                        [
                            62.79819,
                            39.77567
                        ],
                        [
                            62.49027,
                            39.95008
                        ],
                        [
                            62.44355,
                            39.99026
                        ],
                        [
                            62.39679,
                            40.09968
                        ],
                        [
                            62.4137,
                            40.17256
                        ],
                        [
                            62.39142,
                            40.31755
                        ],
                        [
                            62.33439,
                            40.3766
                        ],
                        [
                            62.34943,
                            40.43713
                        ],
                        [
                            62.2089,
                            40.50801
                        ],
                        [
                            62.11315,
                            40.59601
                        ],
                        [
                            62.00015,
                            40.82031
                        ],
                        [
                            61.97089,
                            41.0191
                        ],
                        [
                            61.90081,
                            41.0536
                        ],
                        [
                            61.88035,
                            41.1094
                        ],
                        [
                            61.66062,
                            41.2259
                        ],
                        [
                            61.62687,
                            41.26498
                        ],
                        [
                            61.42024,
                            41.28428
                        ],
                        [
                            61.38016,
                            41.1654
                        ],
                        [
                            61.30148,
                            41.14542
                        ],
                        [
                            61.16936,
                            41.1747
                        ],
                        [
                            61.04415,
                            41.23454
                        ],
                        [
                            60.46915,
                            41.22157
                        ],
                        [
                            60.13093,
                            41.39511
                        ],
                        [
                            60.09425,
                            41.43155
                        ],
                        [
                            60.11339,
                            41.54921
                        ],
                        [
                            60.16373,
                            41.6073
                        ],
                        [
                            60.06857,
                            41.72919
                        ],
                        [
                            60.08365,
                            41.80845
                        ],
                        [
                            60.28906,
                            41.75295
                        ],
                        [
                            60.25959,
                            41.81459
                        ],
                        [
                            60.18258,
                            41.83558
                        ],
                        [
                            60.11349,
                            41.8952
                        ],
                        [
                            59.94952,
                            41.97384
                        ],
                        [
                            60.02932,
                            42.0098
                        ],
                        [
                            59.97404,
                            42.14679
                        ],
                        [
                            60.0301,
                            42.20381
                        ],
                        [
                            59.93797,
                            42.23516
                        ],
                        [
                            59.82865,
                            42.30546
                        ],
                        [
                            59.73751,
                            42.28334
                        ],
                        [
                            59.44203,
                            42.27561
                        ],
                        [
                            59.27173,
                            42.39226
                        ],
                        [
                            59.277,
                            42.43895
                        ],
                        [
                            59.17118,
                            42.52734
                        ],
                        [
                            59.04904,
                            42.51074
                        ],
                        [
                            58.93425,
                            42.54403
                        ],
                        [
                            58.63724,
                            42.7874
                        ],
                        [
                            58.59424,
                            42.72868
                        ],
                        [
                            58.59504,
                            42.66595
                        ],
                        [
                            58.47248,
                            42.65056
                        ],
                        [
                            58.27974,
                            42.68892
                        ],
                        [
                            58.14843,
                            42.62329
                        ],
                        [
                            58.30456,
                            42.54993
                        ],
                        [
                            58.4089,
                            42.37042
                        ],
                        [
                            58.51651,
                            42.3224
                        ],
                        [
                            58.40633,
                            42.29228
                        ],
                        [
                            58.36818,
                            42.41997
                        ],
                        [
                            58.32653,
                            42.44673
                        ],
                        [
                            58.20017,
                            42.46689
                        ],
                        [
                            58.13768,
                            42.44356
                        ],
                        [
                            58.04963,
                            42.50453
                        ],
                        [
                            57.91759,
                            42.45743
                        ],
                        [
                            57.93882,
                            42.39071
                        ],
                        [
                            57.92686,
                            42.24378
                        ],
                        [
                            57.84687,
                            42.2456
                        ],
                        [
                            57.83587,
                            42.17301
                        ],
                        [
                            57.76738,
                            42.18087
                        ],
                        [
                            57.67567,
                            42.15218
                        ],
                        [
                            57.52207,
                            42.17402
                        ],
                        [
                            57.41097,
                            42.16947
                        ],
                        [
                            57.23793,
                            42.09387
                        ],
                        [
                            57.16736,
                            41.97511
                        ],
                        [
                            57.03723,
                            41.91757
                        ],
                        [
                            56.98447,
                            41.86821
                        ],
                        [
                            56.96782,
                            41.80532
                        ],
                        [
                            56.97237,
                            41.67255
                        ],
                        [
                            57.01869,
                            41.58779
                        ],
                        [
                            57.02283,
                            41.4963
                        ],
                        [
                            57.09001,
                            41.33461
                        ],
                        [
                            57.04339,
                            41.26443
                        ],
                        [
                            56.0006,
                            41.31805
                        ],
                        [
                            55.86738,
                            41.32203
                        ],
                        [
                            55.77979,
                            41.29468
                        ],
                        [
                            55.46618,
                            41.2757
                        ],
                        [
                            55.2832,
                            41.41594
                        ],
                        [
                            55.14612,
                            41.57655
                        ],
                        [
                            55.07109,
                            41.70891
                        ],
                        [
                            54.96858,
                            41.8014
                        ],
                        [
                            54.9576,
                            41.90978
                        ],
                        [
                            54.83604,
                            42.02234
                        ],
                        [
                            54.28725,
                            42.30537
                        ],
                        [
                            54.16777,
                            42.34333
                        ],
                        [
                            53.95281,
                            42.33612
                        ],
                        [
                            53.58719,
                            42.29277
                        ],
                        [
                            53.4215,
                            42.25904
                        ],
                        [
                            52.9583,
                            42.1025
                        ],
                        [
                            52.62846,
                            41.88163
                        ],
                        [
                            52.43217,
                            41.75973
                        ],
                        [
                            52.56402,
                            41.67728
                        ],
                        [
                            52.59118,
                            41.62867
                        ],
                        [
                            52.55879,
                            41.51402
                        ],
                        [
                            52.71477,
                            41.41994
                        ],
                        [
                            52.79165,
                            41.31916
                        ],
                        [
                            52.90083,
                            41.57129
                        ],
                        [
                            52.91585,
                            41.66669
                        ],
                        [
                            52.77742,
                            41.7172
                        ],
                        [
                            52.83963,
                            41.77849
                        ],
                        [
                            52.96581,
                            41.99052
                        ],
                        [
                            53.14827,
                            42.09257
                        ],
                        [
                            53.27944,
                            42.06889
                        ],
                        [
                            53.36272,
                            42.10241
                        ],
                        [
                            53.47229,
                            42.10755
                        ],
                        [
                            53.63377,
                            42.1385
                        ],
                        [
                            53.80762,
                            42.12008
                        ],
                        [
                            53.91083,
                            42.04596
                        ],
                        [
                            53.89878,
                            41.89514
                        ],
                        [
                            53.99463,
                            41.7893
                        ],
                        [
                            54.02456,
                            41.71274
                        ],
                        [
                            54.02106,
                            41.59146
                        ],
                        [
                            54.07181,
                            41.47595
                        ],
                        [
                            54.14286,
                            41.45231
                        ],
                        [
                            54.30141,
                            41.33259
                        ],
                        [
                            54.51064,
                            41.24692
                        ],
                        [
                            54.72872,
                            41.10349
                        ],
                        [
                            54.69273,
                            41.04967
                        ],
                        [
                            54.7599,
                            40.96478
                        ],
                        [
                            54.71076,
                            40.87702
                        ],
                        [
                            54.63253,
                            40.82971
                        ],
                        [
                            54.48868,
                            40.79836
                        ],
                        [
                            54.4692,
                            40.86161
                        ],
                        [
                            54.3175,
                            40.92351
                        ],
                        [
                            54.26876,
                            40.8381
                        ],
                        [
                            54.33129,
                            40.71068
                        ],
                        [
                            54.21747,
                            40.68078
                        ],
                        [
                            54.13602,
                            40.71125
                        ],
                        [
                            54.03136,
                            40.65306
                        ],
                        [
                            53.93902,
                            40.665
                        ],
                        [
                            53.86466,
                            40.62568
                        ],
                        [
                            53.74641,
                            40.61514
                        ],
                        [
                            53.72125,
                            40.68791
                        ],
                        [
                            53.65539,
                            40.77136
                        ],
                        [
                            53.65343,
                            40.85583
                        ],
                        [
                            53.58413,
                            40.88635
                        ],
                        [
                            53.55449,
                            40.76694
                        ],
                        [
                            53.47934,
                            40.7291
                        ],
                        [
                            53.33596,
                            40.77574
                        ],
                        [
                            53.25609,
                            40.75891
                        ],
                        [
                            53.12356,
                            40.76335
                        ],
                        [
                            53.06781,
                            40.82573
                        ],
                        [
                            53.01955,
                            40.9385
                        ],
                        [
                            52.93325,
                            40.98108
                        ],
                        [
                            52.82881,
                            40.71276
                        ],
                        [
                            52.86572,
                            40.66852
                        ],
                        [
                            52.74126,
                            40.50081
                        ],
                        [
                            52.69364,
                            40.27405
                        ],
                        [
                            52.76584,
                            40.15552
                        ],
                        [
                            52.74,
                            40.05987
                        ],
                        [
                            52.76508,
                            40.01937
                        ],
                        [
                            52.88803,
                            39.93228
                        ],
                        [
                            52.93938,
                            39.98021
                        ],
                        [
                            53.16638,
                            39.99089
                        ],
                        [
                            53.28188,
                            39.93876
                        ],
                        [
                            53.37478,
                            39.99159
                        ],
                        [
                            53.57263,
                            39.96021
                        ],
                        [
                            53.49,
                            39.87946
                        ],
                        [
                            53.39565,
                            39.75433
                        ],
                        [
                            53.40908,
                            39.67857
                        ],
                        [
                            53.4739,
                            39.68782
                        ],
                        [
                            53.56961,
                            39.61176
                        ],
                        [
                            53.63625,
                            39.60935
                        ],
                        [
                            53.65923,
                            39.54363
                        ],
                        [
                            53.59138,
                            39.51782
                        ],
                        [
                            53.56522,
                            39.46389
                        ],
                        [
                            53.48354,
                            39.47993
                        ],
                        [
                            53.44717,
                            39.5215
                        ],
                        [
                            53.37006,
                            39.5336
                        ],
                        [
                            53.18144,
                            39.51964
                        ],
                        [
                            53.09028,
                            39.40703
                        ],
                        [
                            53.16152,
                            39.34231
                        ],
                        [
                            53.23451,
                            39.35639
                        ],
                        [
                            53.33814,
                            39.33327
                        ],
                        [
                            53.53026,
                            39.32934
                        ],
                        [
                            53.57541,
                            39.31544
                        ],
                        [
                            53.57959,
                            39.19747
                        ],
                        [
                            53.64159,
                            39.12569
                        ],
                        [
                            53.7284,
                            39.09517
                        ],
                        [
                            53.76221,
                            39.03023
                        ],
                        [
                            53.86198,
                            39.02906
                        ],
                        [
                            53.89229,
                            38.97718
                        ],
                        [
                            53.98107,
                            38.90964
                        ],
                        [
                            53.92131,
                            38.75534
                        ],
                        [
                            53.85471,
                            38.66132
                        ],
                        [
                            53.82515,
                            38.50224
                        ],
                        [
                            53.8688,
                            38.3545
                        ],
                        [
                            53.85671,
                            38.20836
                        ],
                        [
                            53.80986,
                            38.02511
                        ],
                        [
                            53.80459,
                            37.88497
                        ],
                        [
                            53.81938,
                            37.73307
                        ],
                        [
                            53.88927,
                            37.49116
                        ],
                        [
                            53.90682,
                            37.33994
                        ],
                        [
                            54.24604,
                            37.31565
                        ],
                        [
                            54.41363,
                            37.36991
                        ],
                        [
                            54.5979,
                            37.4587
                        ],
                        [
                            54.666,
                            37.43629
                        ],
                        [
                            54.79857,
                            37.52438
                        ],
                        [
                            54.81863,
                            37.59295
                        ],
                        [
                            54.78619,
                            37.64207
                        ],
                        [
                            54.86789,
                            37.76722
                        ],
                        [
                            54.95403,
                            37.79988
                        ],
                        [
                            55.11072,
                            37.93666
                        ],
                        [
                            55.40221,
                            38.03567
                        ],
                        [
                            55.45763,
                            38.08689
                        ],
                        [
                            55.68017,
                            38.10282
                        ],
                        [
                            55.80657,
                            38.12437
                        ],
                        [
                            55.87164,
                            38.09355
                        ],
                        [
                            55.99989,
                            38.07337
                        ],
                        [
                            56.17249,
                            38.08932
                        ],
                        [
                            56.20072,
                            38.07033
                        ],
                        [
                            56.33853,
                            38.07906
                        ],
                        [
                            56.32329,
                            38.17234
                        ],
                        [
                            56.40782,
                            38.24452
                        ],
                        [
                            56.55202,
                            38.26822
                        ],
                        [
                            56.60024,
                            38.23869
                        ],
                        [
                            56.67129,
                            38.26795
                        ],
                        [
                            56.76935,
                            38.26882
                        ],
                        [
                            56.91575,
                            38.21621
                        ],
                        [
                            56.99946,
                            38.21801
                        ],
                        [
                            57.06502,
                            38.18589
                        ],
                        [
                            57.15605,
                            38.27432
                        ],
                        [
                            57.23894,
                            38.27434
                        ],
                        [
                            57.29512,
                            38.19542
                        ],
                        [
                            57.29272,
                            38.15446
                        ],
                        [
                            57.36294,
                            38.10101
                        ],
                        [
                            57.36073,
                            38.00211
                        ],
                        [
                            57.48542,
                            37.9182
                        ],
                        [
                            57.71054,
                            37.91532
                        ],
                        [
                            57.88593,
                            37.86648
                        ],
                        [
                            57.93823,
                            37.80587
                        ],
                        [
                            58.10738,
                            37.80167
                        ],
                        [
                            58.21545,
                            37.75302
                        ],
                        [
                            58.25975,
                            37.67107
                        ],
                        [
                            58.47227,
                            37.63583
                        ],
                        [
                            58.56594,
                            37.70371
                        ],
                        [
                            58.6251,
                            37.65984
                        ],
                        [
                            58.73974,
                            37.63118
                        ],
                        [
                            58.88813,
                            37.65742
                        ],
                        [
                            59.05318,
                            37.61468
                        ],
                        [
                            59.22068,
                            37.51146
                        ],
                        [
                            59.33354,
                            37.53932
                        ],
                        [
                            59.39203,
                            37.48125
                        ],
                        [
                            59.38869,
                            37.41205
                        ],
                        [
                            59.42188,
                            37.36344
                        ],
                        [
                            59.40768,
                            37.30647
                        ],
                        [
                            59.54854,
                            37.17367
                        ],
                        [
                            59.55658,
                            37.13187
                        ],
                        [
                            59.66551,
                            37.14155
                        ],
                        [
                            59.76932,
                            37.12454
                        ],
                        [
                            59.93678,
                            37.04006
                        ],
                        [
                            60.04518,
                            37.0195
                        ],
                        [
                            60.1641,
                            36.85281
                        ],
                        [
                            60.26734,
                            36.75685
                        ],
                        [
                            60.35235,
                            36.62886
                        ],
                        [
                            60.65727,
                            36.62207
                        ],
                        [
                            61.1026,
                            36.6438
                        ],
                        [
                            61.14995,
                            36.63757
                        ],
                        [
                            61.18356,
                            36.56991
                        ],
                        [
                            61.17343,
                            36.46313
                        ],
                        [
                            61.14126,
                            36.39098
                        ],
                        [
                            61.15814,
                            36.2971
                        ],
                        [
                            61.22565,
                            36.16232
                        ],
                        [
                            61.22595,
                            36.11165
                        ],
                        [
                            61.16438,
                            36.0341
                        ],
                        [
                            61.18894,
                            35.94289
                        ],
                        [
                            61.23225,
                            35.91032
                        ],
                        [
                            61.26249,
                            35.81863
                        ],
                        [
                            61.2495,
                            35.72878
                        ],
                        [
                            61.21583,
                            35.67804
                        ],
                        [
                            61.27413,
                            35.60515
                        ],
                        [
                            61.36418,
                            35.62499
                        ],
                        [
                            61.38649,
                            35.56794
                        ],
                        [
                            61.58912,
                            35.43678
                        ],
                        [
                            61.77905,
                            35.41144
                        ],
                        [
                            61.96773,
                            35.45367
                        ],
                        [
                            62.06341,
                            35.43433
                        ],
                        [
                            62.1532,
                            35.34156
                        ],
                        [
                            62.26542,
                            35.29491
                        ],
                        [
                            62.33123,
                            35.14947
                        ],
                        [
                            62.47723,
                            35.27805
                        ],
                        [
                            62.57809,
                            35.22172
                        ],
                        [
                            62.74615,
                            35.25379
                        ],
                        [
                            62.76401,
                            35.28709
                        ],
                        [
                            63.00478,
                            35.40815
                        ],
                        [
                            63.09949,
                            35.4197
                        ],
                        [
                            63.12952,
                            35.54245
                        ],
                        [
                            63.11453,
                            35.63453
                        ],
                        [
                            63.24762,
                            35.68224
                        ],
                        [
                            63.19467,
                            35.71426
                        ],
                        [
                            63.10085,
                            35.81647
                        ],
                        [
                            63.12157,
                            35.86263
                        ],
                        [
                            63.30599,
                            35.85813
                        ],
                        [
                            63.5306,
                            35.90233
                        ],
                        [
                            63.57229,
                            35.95147
                        ],
                        [
                            63.70478,
                            35.96798
                        ],
                        [
                            63.9872,
                            36.03569
                        ],
                        [
                            64.06867,
                            35.99821
                        ],
                        [
                            64.05782,
                            36.1004
                        ],
                        [
                            64.16048,
                            36.16007
                        ],
                        [
                            64.28326,
                            36.1521
                        ],
                        [
                            64.31547,
                            36.20728
                        ],
                        [
                            64.44537,
                            36.24313
                        ],
                        [
                            64.57784,
                            36.34982
                        ],
                        [
                            64.63596,
                            36.44298
                        ],
                        [
                            64.61894,
                            36.63719
                        ],
                        [
                            64.70645,
                            36.79511
                        ],
                        [
                            64.79765,
                            36.92269
                        ],
                        [
                            64.75796,
                            37.11379
                        ],
                        [
                            64.9894,
                            37.21802
                        ],
                        [
                            65.13009,
                            37.24554
                        ],
                        [
                            65.27058,
                            37.23289
                        ],
                        [
                            65.53126,
                            37.23865
                        ],
                        [
                            65.64229,
                            37.34273
                        ],
                        [
                            65.64665,
                            37.4419
                        ],
                        [
                            65.69959,
                            37.53235
                        ],
                        [
                            65.82199,
                            37.49756
                        ],
                        [
                            66.07059,
                            37.44881
                        ],
                        [
                            66.16319,
                            37.37558
                        ],
                        [
                            66.24604,
                            37.36375
                        ],
                        [
                            66.31489,
                            37.32202
                        ],
                        [
                            66.41647,
                            37.34685
                        ],
                        [
                            66.47556,
                            37.32925
                        ],
                        [
                            66.55373,
                            37.35475
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "TCA",
                "Country": "Turks and Caicos Islands",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    7.3105e-11,
                    1.453e-10,
                    2.1762e-10,
                    2.9005e-10,
                    3.6259e-10,
                    4.3672e-10,
                    5.1246e-10,
                    5.8985e-10,
                    6.6892e-10,
                    7.497e-10,
                    8.3164e-10,
                    9.147e-10,
                    9.9894e-10,
                    1.0843e-09,
                    1.17e-09,
                    1.2559e-09,
                    1.3421e-09,
                    1.4287e-09,
                    1.5151e-09,
                    1.6014e-09,
                    1.6898e-09,
                    1.7799e-09,
                    1.871e-09,
                    1.963e-09,
                    2.0559e-09,
                    2.1484e-09,
                    2.2403e-09,
                    2.3315e-09,
                    2.4217e-09,
                    2.511e-09,
                    2.5996e-09,
                    2.689e-09,
                    2.7785e-09,
                    2.8672e-09,
                    2.9557e-09,
                    3.0439e-09,
                    3.1324e-09,
                    3.2208e-09,
                    3.3099e-09,
                    3.4018e-09,
                    3.4938e-09,
                    3.5866e-09,
                    3.6804e-09,
                    3.7749e-09,
                    3.8704e-09,
                    3.9666e-09,
                    4.0638e-09,
                    4.162e-09,
                    4.2613e-09,
                    4.3594e-09,
                    4.4785e-09,
                    4.617e-09,
                    4.7751e-09,
                    4.9535e-09,
                    5.1522e-09,
                    5.371e-09,
                    5.6089e-09,
                    5.8659e-09,
                    6.1412e-09,
                    6.4327e-09,
                    6.7611e-09,
                    7.1261e-09,
                    7.5278e-09,
                    7.9637e-09,
                    8.4331e-09,
                    8.9362e-09,
                    9.4722e-09,
                    1.0041e-08,
                    1.0642e-08,
                    1.1277e-08,
                    1.1932e-08,
                    1.2615e-08,
                    1.3323e-08,
                    1.4052e-08,
                    1.4805e-08,
                    1.5587e-08,
                    1.6396e-08,
                    1.7236e-08,
                    1.8105e-08,
                    1.9007e-08,
                    1.9937e-08,
                    2.0889e-08,
                    2.186e-08,
                    2.2849e-08,
                    2.3855e-08,
                    2.488e-08,
                    2.5921e-08,
                    2.6985e-08,
                    2.8078e-08,
                    2.9193e-08,
                    3.0381e-08,
                    3.1643e-08,
                    3.2959e-08,
                    3.4346e-08,
                    3.5767e-08,
                    3.7239e-08,
                    3.8762e-08,
                    4.0325e-08,
                    4.193e-08,
                    4.3561e-08,
                    4.5118e-08,
                    4.6625e-08,
                    4.8099e-08,
                    4.9557e-08,
                    5.1009e-08,
                    5.2454e-08,
                    5.3894e-08,
                    5.5315e-08,
                    5.6702e-08,
                    5.8042e-08,
                    5.9258e-08,
                    6.0336e-08,
                    6.1297e-08,
                    6.2131e-08,
                    6.288e-08,
                    6.353e-08,
                    6.4091e-08,
                    6.459e-08,
                    6.5059e-08,
                    6.5947e-08,
                    6.7178e-08,
                    6.854e-08,
                    7.0083e-08,
                    7.1776e-08,
                    7.3608e-08,
                    7.5569e-08,
                    7.765e-08,
                    7.9857e-08,
                    8.2262e-08,
                    8.487e-08,
                    8.7913e-08,
                    9.1485e-08,
                    9.563e-08,
                    1.0039e-07,
                    1.0576e-07,
                    1.1171e-07,
                    1.1818e-07,
                    1.2525e-07,
                    1.3293e-07,
                    1.6937e-07,
                    2.0629e-07,
                    2.4564e-07,
                    2.8606e-07,
                    3.2907e-07,
                    3.7302e-07,
                    4.1751e-07,
                    4.6882e-07,
                    5.2225e-07,
                    5.816e-07,
                    6.4781e-07,
                    7.1665e-07,
                    8.0371e-07,
                    8.8403e-07,
                    9.7237e-07,
                    1.0758e-06,
                    1.1904e-06,
                    1.3219e-06,
                    1.4604e-06,
                    1.604e-06,
                    1.7488e-06,
                    1.8952e-06,
                    2.0416e-06,
                    2.1894e-06,
                    2.3434e-06,
                    2.4987e-06,
                    2.6588e-06,
                    2.8278e-06,
                    3.0015e-06,
                    3.1768e-06,
                    3.3484e-06,
                    3.5115e-06,
                    3.6732e-06
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    7.3105e-11,
                    1.453e-10,
                    2.1762e-10,
                    2.9005e-10,
                    3.6259e-10,
                    4.3672e-10,
                    5.1246e-10,
                    5.8985e-10,
                    6.6892e-10,
                    7.497e-10,
                    8.3164e-10,
                    9.147e-10,
                    9.9894e-10,
                    1.0843e-09,
                    1.17e-09,
                    1.2559e-09,
                    1.3421e-09,
                    1.4287e-09,
                    1.5151e-09,
                    1.6014e-09,
                    1.6898e-09,
                    1.7799e-09,
                    1.871e-09,
                    1.963e-09,
                    2.0559e-09,
                    2.1484e-09,
                    2.2403e-09,
                    2.3315e-09,
                    2.4217e-09,
                    2.511e-09,
                    2.5996e-09,
                    2.689e-09,
                    2.7785e-09,
                    2.8672e-09,
                    2.9557e-09,
                    3.0439e-09,
                    3.1324e-09,
                    3.2208e-09,
                    3.3099e-09,
                    3.4018e-09,
                    3.4938e-09,
                    3.5866e-09,
                    3.6804e-09,
                    3.7749e-09,
                    3.8704e-09,
                    3.9666e-09,
                    4.0638e-09,
                    4.162e-09,
                    4.2613e-09,
                    4.3594e-09,
                    4.4785e-09,
                    4.617e-09,
                    4.7751e-09,
                    4.9535e-09,
                    5.1522e-09,
                    5.371e-09,
                    5.6089e-09,
                    5.8659e-09,
                    6.1412e-09,
                    6.4327e-09,
                    6.7611e-09,
                    7.1261e-09,
                    7.5278e-09,
                    7.9637e-09,
                    8.4331e-09,
                    8.9362e-09,
                    9.4722e-09,
                    1.0041e-08,
                    1.0642e-08,
                    1.1277e-08,
                    1.1932e-08,
                    1.2615e-08,
                    1.3323e-08,
                    1.4052e-08,
                    1.4805e-08,
                    1.5587e-08,
                    1.6396e-08,
                    1.7236e-08,
                    1.8105e-08,
                    1.9007e-08,
                    1.9937e-08,
                    2.0889e-08,
                    2.186e-08,
                    2.2849e-08,
                    2.3855e-08,
                    2.488e-08,
                    2.5921e-08,
                    2.6985e-08,
                    2.8078e-08,
                    2.9193e-08,
                    3.0381e-08,
                    3.1643e-08,
                    3.2959e-08,
                    3.4346e-08,
                    3.5767e-08,
                    3.7239e-08,
                    3.8762e-08,
                    4.0325e-08,
                    4.193e-08,
                    4.3561e-08,
                    4.5118e-08,
                    4.6625e-08,
                    4.8099e-08,
                    4.9557e-08,
                    5.1009e-08,
                    5.2454e-08,
                    5.3894e-08,
                    5.5315e-08,
                    5.6702e-08,
                    5.8042e-08,
                    5.9258e-08,
                    6.0336e-08,
                    6.1297e-08,
                    6.2131e-08,
                    6.288e-08,
                    6.353e-08,
                    6.4091e-08,
                    6.459e-08,
                    6.5059e-08,
                    6.5947e-08,
                    6.7178e-08,
                    6.854e-08,
                    7.0083e-08,
                    7.1776e-08,
                    7.3608e-08,
                    7.5569e-08,
                    7.765e-08,
                    7.9857e-08,
                    8.2262e-08,
                    8.487e-08,
                    8.7913e-08,
                    9.1485e-08,
                    9.563e-08,
                    1.0039e-07,
                    1.0576e-07,
                    1.1171e-07,
                    1.1818e-07,
                    1.2525e-07,
                    1.3293e-07,
                    1.6935e-07,
                    2.0625e-07,
                    2.4558e-07,
                    2.8597e-07,
                    3.2896e-07,
                    3.7289e-07,
                    4.1738e-07,
                    4.6869e-07,
                    5.2212e-07,
                    5.8147e-07,
                    6.4768e-07,
                    7.1651e-07,
                    8.0357e-07,
                    8.839e-07,
                    9.7224e-07,
                    1.0757e-06,
                    1.1903e-06,
                    1.3218e-06,
                    1.4603e-06,
                    1.6033e-06,
                    1.7482e-06,
                    1.8946e-06,
                    2.0411e-06,
                    2.1889e-06,
                    2.3428e-06,
                    2.4981e-06,
                    2.6583e-06,
                    2.8273e-06,
                    3.0009e-06,
                    3.1762e-06,
                    3.3479e-06,
                    3.511e-06,
                    3.6726e-06
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2.2146e-11,
                    4.4292e-11,
                    6.6438e-11,
                    8.8584e-11,
                    1.1073e-10,
                    1.3288e-10,
                    1.3288e-10,
                    1.3288e-10,
                    1.3288e-10,
                    1.3288e-10,
                    1.3288e-10,
                    1.3288e-10,
                    1.3288e-10,
                    1.3288e-10,
                    1.3288e-10,
                    1.3288e-10,
                    1.3288e-10,
                    1.3288e-10,
                    1.3288e-10,
                    6.4524e-10,
                    6.2448e-10,
                    6.0372e-10,
                    5.8296e-10,
                    5.622e-10,
                    5.4144e-10,
                    5.2067e-10,
                    5.2067e-10,
                    5.2067e-10,
                    5.2067e-10,
                    5.2067e-10,
                    5.2067e-10,
                    5.2067e-10,
                    5.2067e-10
                ],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2.805e-08,
                    5.61e-08,
                    8.58e-08,
                    1.155e-07,
                    1.4685e-07,
                    1.782e-07,
                    2.0955e-07,
                    2.475e-07,
                    2.871e-07,
                    3.3165e-07,
                    3.8115e-07,
                    4.323e-07,
                    4.9995e-07,
                    5.709e-07,
                    6.435e-07,
                    7.293e-07,
                    8.2665e-07,
                    9.405e-07,
                    1.0593e-06,
                    1.1831e-06,
                    1.3101e-06,
                    1.4372e-06,
                    1.5642e-06,
                    1.6929e-06,
                    1.8315e-06,
                    1.9717e-06,
                    2.1203e-06,
                    2.2787e-06,
                    2.442e-06,
                    2.6053e-06,
                    2.7671e-06,
                    2.9229e-06,
                    3.0801e-06
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2.805e-08,
                    5.61e-08,
                    8.58e-08,
                    1.155e-07,
                    1.4685e-07,
                    1.782e-07,
                    2.0955e-07,
                    2.475e-07,
                    2.871e-07,
                    3.3165e-07,
                    3.8115e-07,
                    4.323e-07,
                    4.9995e-07,
                    5.709e-07,
                    6.435e-07,
                    7.293e-07,
                    8.2665e-07,
                    9.405e-07,
                    1.0593e-06,
                    1.1831e-06,
                    1.3101e-06,
                    1.4372e-06,
                    1.5642e-06,
                    1.6929e-06,
                    1.8315e-06,
                    1.9717e-06,
                    2.1203e-06,
                    2.2787e-06,
                    2.442e-06,
                    2.6053e-06,
                    2.7671e-06,
                    2.9229e-06,
                    3.0801e-06
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [
                    6.8335e-11,
                    1.3567e-10,
                    2.0303e-10,
                    2.7042e-10,
                    3.3784e-10,
                    4.0678e-10,
                    4.7727e-10,
                    5.4937e-10,
                    6.231e-10,
                    6.9853e-10,
                    7.7512e-10,
                    8.5281e-10,
                    9.3168e-10,
                    1.0117e-09,
                    1.092e-09,
                    1.1725e-09,
                    1.2534e-09,
                    1.3345e-09,
                    1.4155e-09,
                    1.4964e-09,
                    1.5793e-09,
                    1.6637e-09,
                    1.7487e-09,
                    1.8343e-09,
                    1.9203e-09,
                    2.0053e-09,
                    2.0895e-09,
                    2.1724e-09,
                    2.2542e-09,
                    2.3347e-09,
                    2.4145e-09,
                    2.4951e-09,
                    2.5756e-09,
                    2.6553e-09,
                    2.7347e-09,
                    2.8138e-09,
                    2.8931e-09,
                    2.9723e-09,
                    3.0521e-09,
                    3.1345e-09,
                    3.2171e-09,
                    3.3003e-09,
                    3.3843e-09,
                    3.4691e-09,
                    3.5546e-09,
                    3.6409e-09,
                    3.7278e-09,
                    3.8158e-09,
                    3.9047e-09,
                    3.9923e-09,
                    4.1006e-09,
                    4.2282e-09,
                    4.3751e-09,
                    4.5422e-09,
                    4.7293e-09,
                    4.9361e-09,
                    5.1619e-09,
                    5.4065e-09,
                    5.6692e-09,
                    5.9477e-09,
                    6.263e-09,
                    6.6146e-09,
                    7.0028e-09,
                    7.4248e-09,
                    7.8802e-09,
                    8.369e-09,
                    8.8906e-09,
                    9.4448e-09,
                    1.0031e-08,
                    1.0651e-08,
                    1.1291e-08,
                    1.1958e-08,
                    1.2649e-08,
                    1.3363e-08,
                    1.4099e-08,
                    1.4864e-08,
                    1.5657e-08,
                    1.6479e-08,
                    1.7331e-08,
                    1.8216e-08,
                    1.9128e-08,
                    2.0061e-08,
                    2.1014e-08,
                    2.1985e-08,
                    2.2974e-08,
                    2.398e-08,
                    2.5002e-08,
                    2.6047e-08,
                    2.712e-08,
                    2.8216e-08,
                    2.9384e-08,
                    3.0624e-08,
                    3.1917e-08,
                    3.3279e-08,
                    3.4673e-08,
                    3.6116e-08,
                    3.7606e-08,
                    3.9136e-08,
                    4.0705e-08,
                    4.23e-08,
                    4.3819e-08,
                    4.5287e-08,
                    4.672e-08,
                    4.8138e-08,
                    4.9548e-08,
                    5.095e-08,
                    5.2346e-08,
                    5.3723e-08,
                    5.5064e-08,
                    5.6356e-08,
                    5.7524e-08,
                    5.8551e-08,
                    5.946e-08,
                    6.0239e-08,
                    6.0929e-08,
                    6.1518e-08,
                    6.2015e-08,
                    6.2449e-08,
                    6.2849e-08,
                    6.3666e-08,
                    6.4823e-08,
                    6.6112e-08,
                    6.7579e-08,
                    6.9196e-08,
                    7.0949e-08,
                    7.283e-08,
                    7.483e-08,
                    7.6954e-08,
                    7.9274e-08,
                    8.1797e-08,
                    8.4755e-08,
                    8.824e-08,
                    9.2298e-08,
                    9.6962e-08,
                    1.0225e-07,
                    1.081e-07,
                    1.1448e-07,
                    1.2145e-07,
                    1.2904e-07,
                    1.3732e-07,
                    1.4609e-07,
                    1.5564e-07,
                    1.6625e-07,
                    1.7781e-07,
                    1.9028e-07,
                    2.0329e-07,
                    2.1652e-07,
                    2.302e-07,
                    2.4486e-07,
                    2.6133e-07,
                    2.7875e-07,
                    2.9787e-07,
                    3.0693e-07,
                    3.2232e-07,
                    3.3961e-07,
                    3.5644e-07,
                    3.7355e-07,
                    3.9276e-07,
                    4.1191e-07,
                    4.2909e-07,
                    4.4782e-07,
                    4.6657e-07,
                    4.8499e-07,
                    4.9965e-07,
                    5.1395e-07,
                    5.2489e-07,
                    5.3464e-07,
                    5.441e-07,
                    5.5515e-07,
                    5.6418e-07,
                    5.7055e-07,
                    5.7399e-07
                ],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [
                    6.8335e-11,
                    1.3567e-10,
                    2.0303e-10,
                    2.7042e-10,
                    3.3784e-10,
                    4.0678e-10,
                    4.7727e-10,
                    5.4937e-10,
                    6.231e-10,
                    6.9853e-10,
                    7.7512e-10,
                    8.5281e-10,
                    9.3168e-10,
                    1.0117e-09,
                    1.092e-09,
                    1.1725e-09,
                    1.2534e-09,
                    1.3345e-09,
                    1.4155e-09,
                    1.4964e-09,
                    1.5793e-09,
                    1.6637e-09,
                    1.7487e-09,
                    1.8343e-09,
                    1.9203e-09,
                    2.0053e-09,
                    2.0895e-09,
                    2.1724e-09,
                    2.2542e-09,
                    2.3347e-09,
                    2.4145e-09,
                    2.4951e-09,
                    2.5756e-09,
                    2.6553e-09,
                    2.7347e-09,
                    2.8138e-09,
                    2.8931e-09,
                    2.9723e-09,
                    3.0521e-09,
                    3.1345e-09,
                    3.2171e-09,
                    3.3003e-09,
                    3.3843e-09,
                    3.4691e-09,
                    3.5546e-09,
                    3.6409e-09,
                    3.7278e-09,
                    3.8158e-09,
                    3.9047e-09,
                    3.9923e-09,
                    4.1006e-09,
                    4.2282e-09,
                    4.3751e-09,
                    4.5422e-09,
                    4.7293e-09,
                    4.9361e-09,
                    5.1619e-09,
                    5.4065e-09,
                    5.6692e-09,
                    5.9477e-09,
                    6.263e-09,
                    6.6146e-09,
                    7.0028e-09,
                    7.4248e-09,
                    7.8802e-09,
                    8.369e-09,
                    8.8906e-09,
                    9.4448e-09,
                    1.0031e-08,
                    1.0651e-08,
                    1.1291e-08,
                    1.1958e-08,
                    1.2649e-08,
                    1.3363e-08,
                    1.4099e-08,
                    1.4864e-08,
                    1.5657e-08,
                    1.6479e-08,
                    1.7331e-08,
                    1.8216e-08,
                    1.9128e-08,
                    2.0061e-08,
                    2.1014e-08,
                    2.1985e-08,
                    2.2974e-08,
                    2.398e-08,
                    2.5002e-08,
                    2.6047e-08,
                    2.712e-08,
                    2.8216e-08,
                    2.9384e-08,
                    3.0624e-08,
                    3.1917e-08,
                    3.3279e-08,
                    3.4673e-08,
                    3.6116e-08,
                    3.7606e-08,
                    3.9136e-08,
                    4.0705e-08,
                    4.23e-08,
                    4.3819e-08,
                    4.5287e-08,
                    4.672e-08,
                    4.8138e-08,
                    4.9548e-08,
                    5.095e-08,
                    5.2346e-08,
                    5.3723e-08,
                    5.5064e-08,
                    5.6356e-08,
                    5.7524e-08,
                    5.8551e-08,
                    5.946e-08,
                    6.0239e-08,
                    6.0929e-08,
                    6.1518e-08,
                    6.2015e-08,
                    6.2449e-08,
                    6.2849e-08,
                    6.3666e-08,
                    6.4823e-08,
                    6.6112e-08,
                    6.7579e-08,
                    6.9196e-08,
                    7.0949e-08,
                    7.283e-08,
                    7.483e-08,
                    7.6954e-08,
                    7.9274e-08,
                    8.1797e-08,
                    8.4755e-08,
                    8.824e-08,
                    9.2298e-08,
                    9.6962e-08,
                    1.0225e-07,
                    1.081e-07,
                    1.1448e-07,
                    1.2145e-07,
                    1.2904e-07,
                    1.373e-07,
                    1.4605e-07,
                    1.5558e-07,
                    1.6616e-07,
                    1.777e-07,
                    1.9015e-07,
                    2.0315e-07,
                    2.1638e-07,
                    2.3007e-07,
                    2.4473e-07,
                    2.612e-07,
                    2.7862e-07,
                    2.9774e-07,
                    3.0679e-07,
                    3.2219e-07,
                    3.3948e-07,
                    3.563e-07,
                    3.7342e-07,
                    3.9263e-07,
                    4.1135e-07,
                    4.2855e-07,
                    4.473e-07,
                    4.6607e-07,
                    4.8452e-07,
                    4.9919e-07,
                    5.1352e-07,
                    5.2445e-07,
                    5.3421e-07,
                    5.4367e-07,
                    5.5471e-07,
                    5.6374e-07,
                    5.7012e-07,
                    5.7356e-07
                ],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2.2146e-11,
                    4.4292e-11,
                    6.6438e-11,
                    8.8584e-11,
                    1.1073e-10,
                    1.3288e-10,
                    1.3288e-10,
                    1.3288e-10,
                    1.3288e-10,
                    1.3288e-10,
                    1.3288e-10,
                    1.3288e-10,
                    1.3288e-10,
                    1.3288e-10,
                    1.3288e-10,
                    1.3288e-10,
                    1.3288e-10,
                    1.3288e-10,
                    1.3288e-10,
                    5.5919e-10,
                    5.3843e-10,
                    5.1766e-10,
                    4.969e-10,
                    4.7614e-10,
                    4.5538e-10,
                    4.3462e-10,
                    4.3462e-10,
                    4.3462e-10,
                    4.3462e-10,
                    4.3462e-10,
                    4.3462e-10,
                    4.3462e-10,
                    4.3462e-10
                ],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [
                    4.7696e-12,
                    9.6347e-12,
                    1.4591e-11,
                    1.9633e-11,
                    2.4753e-11,
                    2.9943e-11,
                    3.5192e-11,
                    4.0488e-11,
                    4.5818e-11,
                    5.1167e-11,
                    5.6525e-11,
                    6.1889e-11,
                    6.7259e-11,
                    7.2632e-11,
                    7.8008e-11,
                    8.3388e-11,
                    8.8771e-11,
                    9.416e-11,
                    9.9556e-11,
                    1.0496e-10,
                    1.1046e-10,
                    1.1618e-10,
                    1.2225e-10,
                    1.2872e-10,
                    1.3564e-10,
                    1.4302e-10,
                    1.5084e-10,
                    1.5905e-10,
                    1.6756e-10,
                    1.7625e-10,
                    1.8504e-10,
                    1.9393e-10,
                    2.0288e-10,
                    2.1189e-10,
                    2.2097e-10,
                    2.3009e-10,
                    2.3927e-10,
                    2.485e-10,
                    2.578e-10,
                    2.6722e-10,
                    2.7674e-10,
                    2.8635e-10,
                    2.9605e-10,
                    3.0586e-10,
                    3.1577e-10,
                    3.2579e-10,
                    3.3594e-10,
                    3.4621e-10,
                    3.5662e-10,
                    3.6717e-10,
                    3.779e-10,
                    3.8882e-10,
                    3.9996e-10,
                    4.1134e-10,
                    4.2297e-10,
                    4.3486e-10,
                    4.4701e-10,
                    4.5942e-10,
                    4.7208e-10,
                    4.8498e-10,
                    4.9812e-10,
                    5.1148e-10,
                    5.2506e-10,
                    5.3888e-10,
                    5.5292e-10,
                    5.6718e-10,
                    5.8168e-10,
                    5.964e-10,
                    6.1135e-10,
                    6.2653e-10,
                    6.4195e-10,
                    6.5761e-10,
                    6.7351e-10,
                    6.8966e-10,
                    7.0605e-10,
                    7.2269e-10,
                    7.3957e-10,
                    7.5668e-10,
                    7.7402e-10,
                    7.9157e-10,
                    8.0933e-10,
                    8.2726e-10,
                    8.4534e-10,
                    8.6358e-10,
                    8.8198e-10,
                    9.0054e-10,
                    9.1929e-10,
                    9.3827e-10,
                    9.575e-10,
                    9.7705e-10,
                    9.9726e-10,
                    1.0187e-09,
                    1.0418e-09,
                    1.0668e-09,
                    1.094e-09,
                    1.1235e-09,
                    1.1552e-09,
                    1.189e-09,
                    1.2245e-09,
                    1.2615e-09,
                    1.2995e-09,
                    1.3385e-09,
                    1.3785e-09,
                    1.4193e-09,
                    1.4611e-09,
                    1.5038e-09,
                    1.5474e-09,
                    1.5921e-09,
                    1.638e-09,
                    1.6851e-09,
                    1.7338e-09,
                    1.7845e-09,
                    1.8375e-09,
                    1.8929e-09,
                    1.951e-09,
                    2.0118e-09,
                    2.0753e-09,
                    2.1416e-09,
                    2.2103e-09,
                    2.2817e-09,
                    2.3544e-09,
                    2.4278e-09,
                    2.5038e-09,
                    2.5808e-09,
                    2.6593e-09,
                    2.7389e-09,
                    2.8203e-09,
                    2.9029e-09,
                    2.9873e-09,
                    3.0728e-09,
                    3.1582e-09,
                    3.245e-09,
                    3.3323e-09,
                    3.4229e-09,
                    3.5149e-09,
                    3.609e-09,
                    3.7031e-09,
                    3.7991e-09,
                    3.8957e-09,
                    3.9984e-09,
                    4.1014e-09,
                    4.2019e-09,
                    4.3065e-09,
                    4.4114e-09,
                    4.5413e-09,
                    4.673e-09,
                    4.807e-09,
                    4.9464e-09,
                    5.0883e-09,
                    5.3346e-09,
                    5.5941e-09,
                    5.8875e-09,
                    6.2047e-09,
                    6.5467e-09,
                    6.9238e-09,
                    7.3576e-09,
                    7.8473e-09,
                    8.3745e-09,
                    9.0296e-09,
                    9.657e-09,
                    1.0236e-08,
                    1.0866e-08,
                    1.1533e-08,
                    1.2244e-08,
                    1.2957e-08,
                    1.3702e-08,
                    1.453e-08,
                    1.536e-08,
                    1.6258e-08,
                    1.7148e-08,
                    1.8084e-08,
                    1.9051e-08
                ],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [
                    4.7696e-12,
                    9.6347e-12,
                    1.4591e-11,
                    1.9633e-11,
                    2.4753e-11,
                    2.9943e-11,
                    3.5192e-11,
                    4.0488e-11,
                    4.5818e-11,
                    5.1167e-11,
                    5.6525e-11,
                    6.1889e-11,
                    6.7259e-11,
                    7.2632e-11,
                    7.8008e-11,
                    8.3388e-11,
                    8.8771e-11,
                    9.416e-11,
                    9.9556e-11,
                    1.0496e-10,
                    1.1046e-10,
                    1.1618e-10,
                    1.2225e-10,
                    1.2872e-10,
                    1.3564e-10,
                    1.4302e-10,
                    1.5084e-10,
                    1.5905e-10,
                    1.6756e-10,
                    1.7625e-10,
                    1.8504e-10,
                    1.9393e-10,
                    2.0288e-10,
                    2.1189e-10,
                    2.2097e-10,
                    2.3009e-10,
                    2.3927e-10,
                    2.485e-10,
                    2.578e-10,
                    2.6722e-10,
                    2.7674e-10,
                    2.8635e-10,
                    2.9605e-10,
                    3.0586e-10,
                    3.1577e-10,
                    3.2579e-10,
                    3.3594e-10,
                    3.4621e-10,
                    3.5662e-10,
                    3.6717e-10,
                    3.779e-10,
                    3.8882e-10,
                    3.9996e-10,
                    4.1134e-10,
                    4.2297e-10,
                    4.3486e-10,
                    4.4701e-10,
                    4.5942e-10,
                    4.7208e-10,
                    4.8498e-10,
                    4.9812e-10,
                    5.1148e-10,
                    5.2506e-10,
                    5.3888e-10,
                    5.5292e-10,
                    5.6718e-10,
                    5.8168e-10,
                    5.964e-10,
                    6.1135e-10,
                    6.2653e-10,
                    6.4195e-10,
                    6.5761e-10,
                    6.7351e-10,
                    6.8966e-10,
                    7.0605e-10,
                    7.2269e-10,
                    7.3957e-10,
                    7.5668e-10,
                    7.7402e-10,
                    7.9157e-10,
                    8.0933e-10,
                    8.2726e-10,
                    8.4534e-10,
                    8.6358e-10,
                    8.8198e-10,
                    9.0054e-10,
                    9.1929e-10,
                    9.3827e-10,
                    9.575e-10,
                    9.7705e-10,
                    9.9726e-10,
                    1.0187e-09,
                    1.0418e-09,
                    1.0668e-09,
                    1.094e-09,
                    1.1235e-09,
                    1.1552e-09,
                    1.189e-09,
                    1.2245e-09,
                    1.2615e-09,
                    1.2995e-09,
                    1.3385e-09,
                    1.3785e-09,
                    1.4193e-09,
                    1.4611e-09,
                    1.5038e-09,
                    1.5474e-09,
                    1.5921e-09,
                    1.638e-09,
                    1.6851e-09,
                    1.7338e-09,
                    1.7845e-09,
                    1.8375e-09,
                    1.8929e-09,
                    1.951e-09,
                    2.0118e-09,
                    2.0753e-09,
                    2.1416e-09,
                    2.2103e-09,
                    2.2817e-09,
                    2.3544e-09,
                    2.4278e-09,
                    2.5038e-09,
                    2.5808e-09,
                    2.6593e-09,
                    2.7389e-09,
                    2.8203e-09,
                    2.9029e-09,
                    2.9873e-09,
                    3.0728e-09,
                    3.1582e-09,
                    3.245e-09,
                    3.3323e-09,
                    3.4229e-09,
                    3.5149e-09,
                    3.609e-09,
                    3.7031e-09,
                    3.7991e-09,
                    3.8957e-09,
                    3.9984e-09,
                    4.1014e-09,
                    4.2019e-09,
                    4.3065e-09,
                    4.4114e-09,
                    4.5413e-09,
                    4.673e-09,
                    4.807e-09,
                    4.9464e-09,
                    5.0883e-09,
                    5.3346e-09,
                    5.5941e-09,
                    5.8875e-09,
                    6.2047e-09,
                    6.5467e-09,
                    6.9238e-09,
                    7.3576e-09,
                    7.8473e-09,
                    8.3745e-09,
                    8.9436e-09,
                    9.5709e-09,
                    1.015e-08,
                    1.078e-08,
                    1.1447e-08,
                    1.2158e-08,
                    1.2871e-08,
                    1.3616e-08,
                    1.4444e-08,
                    1.5274e-08,
                    1.6172e-08,
                    1.7062e-08,
                    1.7998e-08,
                    1.8965e-08
                ],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    8.6058e-11,
                    8.6058e-11,
                    8.6058e-11,
                    8.6058e-11,
                    8.6058e-11,
                    8.6058e-11,
                    8.6058e-11,
                    8.6058e-11,
                    8.6058e-11,
                    8.6058e-11,
                    8.6058e-11,
                    8.6058e-11,
                    8.6058e-11,
                    8.6058e-11
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -72.04897,
                                21.92821
                            ],
                            [
                                -71.89026,
                                21.84645
                            ],
                            [
                                -71.92366,
                                21.94724
                            ],
                            [
                                -71.98877,
                                21.96178
                            ],
                            [
                                -72.04897,
                                21.92821
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -71.85323,
                                21.85018
                            ],
                            [
                                -71.83785,
                                21.78113
                            ],
                            [
                                -71.7007,
                                21.78511
                            ],
                            [
                                -71.69972,
                                21.8364
                            ],
                            [
                                -71.80542,
                                21.83297
                            ],
                            [
                                -71.85323,
                                21.85018
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -72.35392,
                                21.75622
                            ],
                            [
                                -72.28215,
                                21.73934
                            ],
                            [
                                -72.25862,
                                21.7923
                            ],
                            [
                                -72.32216,
                                21.85698
                            ],
                            [
                                -72.35392,
                                21.75622
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "TUV",
                "Country": "Tuvalu",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    3.7214e-10,
                    7.4985e-10,
                    1.1331e-09,
                    1.5218e-09,
                    1.916e-09,
                    2.3155e-09,
                    2.7203e-09,
                    3.1304e-09,
                    3.5456e-09,
                    3.9658e-09,
                    4.3901e-09,
                    4.8187e-09,
                    5.2514e-09,
                    5.6883e-09,
                    6.1293e-09,
                    6.5744e-09,
                    7.0237e-09,
                    7.4772e-09,
                    7.9348e-09,
                    8.3966e-09,
                    8.8777e-09,
                    9.379e-09,
                    9.9013e-09,
                    1.0445e-08,
                    1.1011e-08,
                    1.1598e-08,
                    1.2207e-08,
                    1.2838e-08,
                    1.3489e-08,
                    1.416e-08,
                    1.4849e-08,
                    1.5555e-08,
                    1.6278e-08,
                    1.7018e-08,
                    1.7775e-08,
                    1.8549e-08,
                    1.934e-08,
                    2.0148e-08,
                    2.0973e-08,
                    2.1822e-08,
                    2.2679e-08,
                    2.3544e-08,
                    2.4418e-08,
                    2.5301e-08,
                    2.6194e-08,
                    2.7096e-08,
                    2.8008e-08,
                    2.8931e-08,
                    2.9864e-08,
                    3.0809e-08,
                    3.176e-08,
                    3.2719e-08,
                    3.3686e-08,
                    3.4663e-08,
                    3.5648e-08,
                    3.6643e-08,
                    3.7647e-08,
                    3.866e-08,
                    3.9682e-08,
                    4.0711e-08,
                    4.1732e-08,
                    4.2745e-08,
                    4.375e-08,
                    4.4746e-08,
                    4.5733e-08,
                    4.6712e-08,
                    4.7682e-08,
                    4.8643e-08,
                    4.9596e-08,
                    5.0541e-08,
                    5.1504e-08,
                    5.2484e-08,
                    5.3482e-08,
                    5.4498e-08,
                    5.5532e-08,
                    5.6585e-08,
                    5.7655e-08,
                    5.8742e-08,
                    5.9847e-08,
                    6.0969e-08,
                    6.2131e-08,
                    6.3333e-08,
                    6.4575e-08,
                    6.5858e-08,
                    6.7181e-08,
                    6.8544e-08,
                    6.9947e-08,
                    7.139e-08,
                    7.2874e-08,
                    7.4399e-08,
                    7.5956e-08,
                    7.7551e-08,
                    7.9184e-08,
                    8.0859e-08,
                    8.2575e-08,
                    8.4333e-08,
                    8.6135e-08,
                    8.7978e-08,
                    8.9862e-08,
                    9.1785e-08,
                    9.3792e-08,
                    9.5894e-08,
                    9.8099e-08,
                    1.0042e-07,
                    1.0285e-07,
                    1.0542e-07,
                    1.0813e-07,
                    1.1098e-07,
                    1.1398e-07,
                    1.1714e-07,
                    1.2024e-07,
                    1.2336e-07,
                    1.2651e-07,
                    1.297e-07,
                    1.3292e-07,
                    1.3618e-07,
                    1.3949e-07,
                    1.4284e-07,
                    1.4623e-07,
                    1.4959e-07,
                    1.5285e-07,
                    1.5602e-07,
                    1.5909e-07,
                    1.6204e-07,
                    1.6488e-07,
                    1.6757e-07,
                    1.7023e-07,
                    1.7281e-07,
                    1.7551e-07,
                    1.7837e-07,
                    1.8084e-07,
                    1.8443e-07,
                    1.8761e-07,
                    1.9188e-07,
                    1.972e-07,
                    2.0247e-07,
                    2.0687e-07,
                    2.1117e-07,
                    2.1805e-07,
                    2.267e-07,
                    2.3681e-07,
                    2.4704e-07,
                    2.5693e-07,
                    2.6704e-07,
                    2.7715e-07,
                    2.8723e-07,
                    2.9742e-07,
                    3.1091e-07,
                    3.2434e-07,
                    3.3587e-07,
                    3.4947e-07,
                    3.624e-07,
                    3.7573e-07,
                    3.8813e-07,
                    3.9954e-07,
                    4.1102e-07,
                    4.2345e-07,
                    4.3618e-07,
                    4.4664e-07,
                    4.571e-07,
                    4.6641e-07,
                    4.7577e-07,
                    4.8557e-07,
                    4.9532e-07,
                    5.0531e-07,
                    5.1552e-07,
                    5.2569e-07,
                    5.3597e-07,
                    5.4622e-07,
                    5.566e-07,
                    5.6733e-07,
                    5.7776e-07
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    1.2558e-10,
                    2.5345e-10,
                    3.836e-10,
                    5.1603e-10,
                    6.5075e-10,
                    7.8774e-10,
                    9.27e-10,
                    1.0685e-09,
                    1.2123e-09,
                    1.3584e-09,
                    1.5064e-09,
                    1.6566e-09,
                    1.8087e-09,
                    1.9629e-09,
                    2.1191e-09,
                    2.2774e-09,
                    2.4377e-09,
                    2.6e-09,
                    2.7644e-09,
                    2.9308e-09,
                    3.1034e-09,
                    3.2823e-09,
                    3.4674e-09,
                    3.6589e-09,
                    3.8567e-09,
                    4.0609e-09,
                    4.2714e-09,
                    4.4882e-09,
                    4.7113e-09,
                    4.9406e-09,
                    5.1753e-09,
                    5.4154e-09,
                    5.661e-09,
                    5.912e-09,
                    6.1684e-09,
                    6.4302e-09,
                    6.6974e-09,
                    6.97e-09,
                    7.248e-09,
                    7.5315e-09,
                    7.8185e-09,
                    8.1093e-09,
                    8.4037e-09,
                    8.7018e-09,
                    9.0035e-09,
                    9.3089e-09,
                    9.6179e-09,
                    9.9306e-09,
                    1.0247e-08,
                    1.0567e-08,
                    1.0889e-08,
                    1.1212e-08,
                    1.1536e-08,
                    1.1862e-08,
                    1.2189e-08,
                    1.2518e-08,
                    1.2849e-08,
                    1.3181e-08,
                    1.3514e-08,
                    1.3849e-08,
                    1.418e-08,
                    1.4507e-08,
                    1.4829e-08,
                    1.5148e-08,
                    1.5463e-08,
                    1.5773e-08,
                    1.608e-08,
                    1.6382e-08,
                    1.6681e-08,
                    1.6975e-08,
                    1.7276e-08,
                    1.7581e-08,
                    1.7893e-08,
                    1.821e-08,
                    1.8533e-08,
                    1.8862e-08,
                    1.9196e-08,
                    1.9536e-08,
                    1.9882e-08,
                    2.0234e-08,
                    2.06e-08,
                    2.098e-08,
                    2.1376e-08,
                    2.1786e-08,
                    2.2212e-08,
                    2.2652e-08,
                    2.3107e-08,
                    2.3577e-08,
                    2.4063e-08,
                    2.4563e-08,
                    2.5081e-08,
                    2.5618e-08,
                    2.6175e-08,
                    2.6751e-08,
                    2.7348e-08,
                    2.7965e-08,
                    2.8603e-08,
                    2.9262e-08,
                    2.9942e-08,
                    3.0643e-08,
                    3.1382e-08,
                    3.2163e-08,
                    3.299e-08,
                    3.3866e-08,
                    3.4796e-08,
                    3.5783e-08,
                    3.683e-08,
                    3.7943e-08,
                    3.9123e-08,
                    4.0374e-08,
                    4.1692e-08,
                    4.308e-08,
                    4.4542e-08,
                    4.608e-08,
                    4.7698e-08,
                    4.9398e-08,
                    5.1182e-08,
                    5.3054e-08,
                    5.5014e-08,
                    5.6972e-08,
                    5.8924e-08,
                    6.0866e-08,
                    6.2795e-08,
                    6.471e-08,
                    6.6599e-08,
                    6.846e-08,
                    7.0291e-08,
                    7.2091e-08,
                    7.3857e-08,
                    7.5598e-08,
                    7.7314e-08,
                    7.9018e-08,
                    8.0708e-08,
                    8.2376e-08,
                    8.4024e-08,
                    8.564e-08,
                    8.7205e-08,
                    8.8718e-08,
                    9.0168e-08,
                    9.3292e-08,
                    9.6462e-08,
                    9.9665e-08,
                    1.0287e-07,
                    1.0612e-07,
                    1.0938e-07,
                    1.1259e-07,
                    1.1582e-07,
                    1.224e-07,
                    1.29e-07,
                    1.3394e-07,
                    1.4056e-07,
                    1.4724e-07,
                    1.5395e-07,
                    1.6073e-07,
                    1.675e-07,
                    1.7432e-07,
                    1.8126e-07,
                    1.8834e-07,
                    1.9544e-07,
                    2.026e-07,
                    2.0986e-07,
                    2.1717e-07,
                    2.2455e-07,
                    2.3197e-07,
                    2.3953e-07,
                    2.4727e-07,
                    2.5508e-07,
                    2.6291e-07,
                    2.7081e-07,
                    2.7878e-07,
                    2.8705e-07,
                    2.9521e-07
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [
                    2.4656e-10,
                    4.964e-10,
                    7.4948e-10,
                    1.0058e-09,
                    1.2652e-09,
                    1.5278e-09,
                    1.7933e-09,
                    2.0619e-09,
                    2.3333e-09,
                    2.6074e-09,
                    2.8837e-09,
                    3.1621e-09,
                    3.4427e-09,
                    3.7254e-09,
                    4.0101e-09,
                    4.297e-09,
                    4.586e-09,
                    4.8771e-09,
                    5.1704e-09,
                    5.4658e-09,
                    5.7742e-09,
                    6.0967e-09,
                    6.4338e-09,
                    6.7862e-09,
                    7.154e-09,
                    7.5373e-09,
                    7.936e-09,
                    8.3498e-09,
                    8.778e-09,
                    9.2199e-09,
                    9.6737e-09,
                    1.0139e-08,
                    1.0617e-08,
                    1.1106e-08,
                    1.1606e-08,
                    1.2119e-08,
                    1.2643e-08,
                    1.3178e-08,
                    1.3725e-08,
                    1.4291e-08,
                    1.4861e-08,
                    1.5435e-08,
                    1.6015e-08,
                    1.66e-08,
                    1.719e-08,
                    1.7787e-08,
                    1.839e-08,
                    1.9e-08,
                    1.9617e-08,
                    2.0242e-08,
                    2.0871e-08,
                    2.1507e-08,
                    2.215e-08,
                    2.2801e-08,
                    2.3459e-08,
                    2.4125e-08,
                    2.4798e-08,
                    2.548e-08,
                    2.6168e-08,
                    2.6862e-08,
                    2.7553e-08,
                    2.8239e-08,
                    2.892e-08,
                    2.9597e-08,
                    3.027e-08,
                    3.0938e-08,
                    3.1602e-08,
                    3.2261e-08,
                    3.2915e-08,
                    3.3566e-08,
                    3.4228e-08,
                    3.4902e-08,
                    3.5589e-08,
                    3.6288e-08,
                    3.6999e-08,
                    3.7723e-08,
                    3.8458e-08,
                    3.9206e-08,
                    3.9965e-08,
                    4.0735e-08,
                    4.1531e-08,
                    4.2353e-08,
                    4.3199e-08,
                    4.4072e-08,
                    4.4969e-08,
                    4.5892e-08,
                    4.6839e-08,
                    4.7813e-08,
                    4.8812e-08,
                    4.9836e-08,
                    5.0876e-08,
                    5.1933e-08,
                    5.301e-08,
                    5.4107e-08,
                    5.5227e-08,
                    5.6369e-08,
                    5.7532e-08,
                    5.8716e-08,
                    5.992e-08,
                    6.1142e-08,
                    6.241e-08,
                    6.373e-08,
                    6.5109e-08,
                    6.6549e-08,
                    6.8058e-08,
                    6.9638e-08,
                    7.1295e-08,
                    7.3033e-08,
                    7.4857e-08,
                    7.677e-08,
                    7.8545e-08,
                    8.0277e-08,
                    8.1968e-08,
                    8.3616e-08,
                    8.5222e-08,
                    8.6785e-08,
                    8.8306e-08,
                    8.9785e-08,
                    9.1221e-08,
                    9.2615e-08,
                    9.3929e-08,
                    9.5156e-08,
                    9.6293e-08,
                    9.7334e-08,
                    9.8276e-08,
                    9.9115e-08,
                    9.994e-08,
                    1.0071e-07,
                    1.0165e-07,
                    1.0277e-07,
                    1.0353e-07,
                    1.0542e-07,
                    1.069e-07,
                    1.0951e-07,
                    1.1318e-07,
                    1.1683e-07,
                    1.1967e-07,
                    1.2245e-07,
                    1.2788e-07,
                    1.3341e-07,
                    1.4035e-07,
                    1.4738e-07,
                    1.5406e-07,
                    1.6092e-07,
                    1.6777e-07,
                    1.7464e-07,
                    1.816e-07,
                    1.8851e-07,
                    1.9535e-07,
                    2.0193e-07,
                    2.0891e-07,
                    2.1516e-07,
                    2.2178e-07,
                    2.274e-07,
                    2.3204e-07,
                    2.367e-07,
                    2.4218e-07,
                    2.4783e-07,
                    2.5121e-07,
                    2.545e-07,
                    2.5655e-07,
                    2.586e-07,
                    2.6101e-07,
                    2.6335e-07,
                    2.6578e-07,
                    2.6825e-07,
                    2.7061e-07,
                    2.7306e-07,
                    2.7541e-07,
                    2.7782e-07,
                    2.8028e-07,
                    2.8255e-07
                ],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.65e-09,
                    3.3e-09,
                    4.95e-09,
                    6.6e-09,
                    8.25e-09,
                    9.9e-09,
                    1.155e-08,
                    1.32e-08,
                    1.815e-08,
                    2.31e-08,
                    2.64e-08,
                    3.135e-08,
                    3.63e-08,
                    4.125e-08,
                    4.62e-08,
                    5.115e-08,
                    5.61e-08,
                    6.105e-08,
                    6.6e-08,
                    7.095e-08,
                    7.59e-08,
                    8.085e-08,
                    8.58e-08,
                    9.075e-08,
                    9.57e-08,
                    1.0065e-07,
                    1.056e-07,
                    1.1055e-07,
                    1.155e-07,
                    1.2045e-07,
                    1.254e-07,
                    1.3057e-07,
                    1.3567e-07
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.65e-09,
                    3.3e-09,
                    4.95e-09,
                    6.6e-09,
                    8.25e-09,
                    9.9e-09,
                    1.155e-08,
                    1.32e-08,
                    1.815e-08,
                    2.31e-08,
                    2.64e-08,
                    3.135e-08,
                    3.63e-08,
                    4.125e-08,
                    4.62e-08,
                    5.115e-08,
                    5.61e-08,
                    6.105e-08,
                    6.6e-08,
                    7.095e-08,
                    7.59e-08,
                    8.085e-08,
                    8.58e-08,
                    9.075e-08,
                    9.57e-08,
                    1.0065e-07,
                    1.056e-07,
                    1.1055e-07,
                    1.155e-07,
                    1.2045e-07,
                    1.254e-07,
                    1.3057e-07,
                    1.3567e-07
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [
                    3.3843e-10,
                    6.8175e-10,
                    1.0299e-09,
                    1.383e-09,
                    1.741e-09,
                    2.1039e-09,
                    2.4716e-09,
                    2.8442e-09,
                    3.2217e-09,
                    3.6041e-09,
                    3.9906e-09,
                    4.3812e-09,
                    4.776e-09,
                    5.1749e-09,
                    5.5779e-09,
                    5.985e-09,
                    6.3962e-09,
                    6.8116e-09,
                    7.2311e-09,
                    7.6547e-09,
                    8.0969e-09,
                    8.5578e-09,
                    9.0372e-09,
                    9.5353e-09,
                    1.0052e-08,
                    1.0587e-08,
                    1.1141e-08,
                    1.1714e-08,
                    1.2305e-08,
                    1.2915e-08,
                    1.3541e-08,
                    1.4184e-08,
                    1.4844e-08,
                    1.552e-08,
                    1.6213e-08,
                    1.6922e-08,
                    1.7649e-08,
                    1.8392e-08,
                    1.9151e-08,
                    1.9927e-08,
                    2.0714e-08,
                    2.1512e-08,
                    2.2321e-08,
                    2.3142e-08,
                    2.3973e-08,
                    2.4815e-08,
                    2.5668e-08,
                    2.6532e-08,
                    2.7407e-08,
                    2.8294e-08,
                    2.9186e-08,
                    3.0085e-08,
                    3.099e-08,
                    3.1901e-08,
                    3.2819e-08,
                    3.3743e-08,
                    3.4674e-08,
                    3.561e-08,
                    3.6553e-08,
                    3.7502e-08,
                    3.8442e-08,
                    3.9373e-08,
                    4.0295e-08,
                    4.1207e-08,
                    4.211e-08,
                    4.3004e-08,
                    4.3889e-08,
                    4.4764e-08,
                    4.563e-08,
                    4.6487e-08,
                    4.7361e-08,
                    4.8251e-08,
                    4.9158e-08,
                    5.0081e-08,
                    5.1021e-08,
                    5.1978e-08,
                    5.2951e-08,
                    5.3941e-08,
                    5.4947e-08,
                    5.5971e-08,
                    5.7034e-08,
                    5.8137e-08,
                    5.9281e-08,
                    6.0465e-08,
                    6.1689e-08,
                    6.2953e-08,
                    6.4258e-08,
                    6.5603e-08,
                    6.6988e-08,
                    6.8413e-08,
                    6.9869e-08,
                    7.1358e-08,
                    7.2878e-08,
                    7.4431e-08,
                    7.6017e-08,
                    7.7636e-08,
                    7.9289e-08,
                    8.0975e-08,
                    8.2695e-08,
                    8.4449e-08,
                    8.6285e-08,
                    8.8211e-08,
                    9.0237e-08,
                    9.2371e-08,
                    9.4623e-08,
                    9.7e-08,
                    9.951e-08,
                    1.0216e-07,
                    1.0496e-07,
                    1.0792e-07,
                    1.108e-07,
                    1.1371e-07,
                    1.1665e-07,
                    1.1962e-07,
                    1.2262e-07,
                    1.2566e-07,
                    1.2874e-07,
                    1.3186e-07,
                    1.3503e-07,
                    1.3815e-07,
                    1.4119e-07,
                    1.4412e-07,
                    1.4696e-07,
                    1.4968e-07,
                    1.5228e-07,
                    1.5474e-07,
                    1.5715e-07,
                    1.5948e-07,
                    1.6193e-07,
                    1.6452e-07,
                    1.6673e-07,
                    1.7002e-07,
                    1.7291e-07,
                    1.7685e-07,
                    1.8181e-07,
                    1.867e-07,
                    1.9076e-07,
                    1.9472e-07,
                    2.0115e-07,
                    2.077e-07,
                    2.1566e-07,
                    2.2373e-07,
                    2.3147e-07,
                    2.3942e-07,
                    2.4738e-07,
                    2.553e-07,
                    2.6334e-07,
                    2.7136e-07,
                    2.7931e-07,
                    2.8699e-07,
                    2.9511e-07,
                    3.0253e-07,
                    3.1034e-07,
                    3.1722e-07,
                    3.231e-07,
                    3.2907e-07,
                    3.3598e-07,
                    3.4316e-07,
                    3.4807e-07,
                    3.5298e-07,
                    3.5676e-07,
                    3.6057e-07,
                    3.6482e-07,
                    3.6902e-07,
                    3.7346e-07,
                    3.7812e-07,
                    3.8272e-07,
                    3.8744e-07,
                    3.921e-07,
                    3.9689e-07,
                    4.0181e-07,
                    4.0649e-07
                ],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [
                    1.2362e-10,
                    2.4949e-10,
                    3.7761e-10,
                    5.0798e-10,
                    6.4059e-10,
                    7.7545e-10,
                    9.1256e-10,
                    1.0519e-09,
                    1.1935e-09,
                    1.3374e-09,
                    1.4832e-09,
                    1.6312e-09,
                    1.7811e-09,
                    1.9331e-09,
                    2.0871e-09,
                    2.2432e-09,
                    2.4013e-09,
                    2.5614e-09,
                    2.7236e-09,
                    2.8878e-09,
                    3.0581e-09,
                    3.2346e-09,
                    3.4173e-09,
                    3.6061e-09,
                    3.8011e-09,
                    4.0022e-09,
                    4.2095e-09,
                    4.4229e-09,
                    4.6425e-09,
                    4.8682e-09,
                    5.0994e-09,
                    5.3359e-09,
                    5.5778e-09,
                    5.8251e-09,
                    6.0777e-09,
                    6.3358e-09,
                    6.5992e-09,
                    6.868e-09,
                    7.1422e-09,
                    7.4218e-09,
                    7.705e-09,
                    7.9919e-09,
                    8.2823e-09,
                    8.5764e-09,
                    8.8741e-09,
                    9.1755e-09,
                    9.4804e-09,
                    9.789e-09,
                    1.0101e-08,
                    1.0417e-08,
                    1.0734e-08,
                    1.1053e-08,
                    1.1373e-08,
                    1.1694e-08,
                    1.2017e-08,
                    1.2341e-08,
                    1.2667e-08,
                    1.2994e-08,
                    1.3322e-08,
                    1.3652e-08,
                    1.3978e-08,
                    1.4299e-08,
                    1.4617e-08,
                    1.493e-08,
                    1.5239e-08,
                    1.5544e-08,
                    1.5845e-08,
                    1.6142e-08,
                    1.6434e-08,
                    1.6723e-08,
                    1.7017e-08,
                    1.7317e-08,
                    1.7622e-08,
                    1.7933e-08,
                    1.825e-08,
                    1.8572e-08,
                    1.8899e-08,
                    1.9233e-08,
                    1.9572e-08,
                    1.9916e-08,
                    2.0276e-08,
                    2.0649e-08,
                    2.1037e-08,
                    2.144e-08,
                    2.1857e-08,
                    2.2289e-08,
                    2.2735e-08,
                    2.3196e-08,
                    2.3671e-08,
                    2.4161e-08,
                    2.4668e-08,
                    2.5194e-08,
                    2.5737e-08,
                    2.63e-08,
                    2.6882e-08,
                    2.7482e-08,
                    2.8103e-08,
                    2.8743e-08,
                    2.9404e-08,
                    3.0085e-08,
                    3.0803e-08,
                    3.1563e-08,
                    3.2368e-08,
                    3.3223e-08,
                    3.413e-08,
                    3.5095e-08,
                    3.612e-08,
                    3.7209e-08,
                    3.8365e-08,
                    3.9593e-08,
                    4.0885e-08,
                    4.2246e-08,
                    4.3678e-08,
                    4.5184e-08,
                    4.6766e-08,
                    4.8428e-08,
                    5.0171e-08,
                    5.1998e-08,
                    5.3912e-08,
                    5.5825e-08,
                    5.7731e-08,
                    5.9625e-08,
                    6.1507e-08,
                    6.3374e-08,
                    6.5213e-08,
                    6.7025e-08,
                    6.8805e-08,
                    7.0554e-08,
                    7.2269e-08,
                    7.3957e-08,
                    7.562e-08,
                    7.727e-08,
                    7.8906e-08,
                    8.0519e-08,
                    8.2113e-08,
                    8.3673e-08,
                    8.5181e-08,
                    8.6638e-08,
                    8.8031e-08,
                    8.9448e-08,
                    9.091e-08,
                    9.2406e-08,
                    9.3903e-08,
                    9.5448e-08,
                    9.6995e-08,
                    9.8498e-08,
                    1.0002e-07,
                    1.016e-07,
                    1.0319e-07,
                    1.0477e-07,
                    1.0639e-07,
                    1.0806e-07,
                    1.0976e-07,
                    1.1152e-07,
                    1.1328e-07,
                    1.1508e-07,
                    1.1702e-07,
                    1.1908e-07,
                    1.2116e-07,
                    1.233e-07,
                    1.2554e-07,
                    1.2783e-07,
                    1.302e-07,
                    1.3259e-07,
                    1.3513e-07,
                    1.3785e-07,
                    1.4063e-07,
                    1.4344e-07,
                    1.4632e-07,
                    1.4926e-07,
                    1.5229e-07,
                    1.5526e-07
                ],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [
                    2.1481e-10,
                    4.3225e-10,
                    6.5233e-10,
                    8.7505e-10,
                    1.1004e-09,
                    1.3284e-09,
                    1.559e-09,
                    1.7923e-09,
                    2.0282e-09,
                    2.2667e-09,
                    2.5074e-09,
                    2.7501e-09,
                    2.9949e-09,
                    3.2418e-09,
                    3.4907e-09,
                    3.7418e-09,
                    3.995e-09,
                    4.2502e-09,
                    4.5075e-09,
                    4.7669e-09,
                    5.0388e-09,
                    5.3231e-09,
                    5.6199e-09,
                    5.9292e-09,
                    6.2509e-09,
                    6.5851e-09,
                    6.9317e-09,
                    7.2908e-09,
                    7.6624e-09,
                    8.0464e-09,
                    8.4417e-09,
                    8.8482e-09,
                    9.2659e-09,
                    9.6949e-09,
                    1.0135e-08,
                    1.0587e-08,
                    1.1049e-08,
                    1.1523e-08,
                    1.2009e-08,
                    1.2505e-08,
                    1.3009e-08,
                    1.352e-08,
                    1.4039e-08,
                    1.4565e-08,
                    1.5099e-08,
                    1.5639e-08,
                    1.6188e-08,
                    1.6743e-08,
                    1.7306e-08,
                    1.7877e-08,
                    1.8452e-08,
                    1.9032e-08,
                    1.9617e-08,
                    2.0207e-08,
                    2.0802e-08,
                    2.1402e-08,
                    2.2007e-08,
                    2.2616e-08,
                    2.3231e-08,
                    2.385e-08,
                    2.4465e-08,
                    2.5074e-08,
                    2.5678e-08,
                    2.6277e-08,
                    2.6871e-08,
                    2.746e-08,
                    2.8044e-08,
                    2.8622e-08,
                    2.9196e-08,
                    2.9764e-08,
                    3.0344e-08,
                    3.0934e-08,
                    3.1536e-08,
                    3.2148e-08,
                    3.2772e-08,
                    3.3406e-08,
                    3.4052e-08,
                    3.4708e-08,
                    3.5376e-08,
                    3.6054e-08,
                    3.6758e-08,
                    3.7488e-08,
                    3.8244e-08,
                    3.9025e-08,
                    3.9832e-08,
                    4.0665e-08,
                    4.1523e-08,
                    4.2407e-08,
                    4.3317e-08,
                    4.4252e-08,
                    4.5201e-08,
                    4.6164e-08,
                    4.7141e-08,
                    4.8131e-08,
                    4.9136e-08,
                    5.0154e-08,
                    5.1186e-08,
                    5.2232e-08,
                    5.3291e-08,
                    5.4364e-08,
                    5.5481e-08,
                    5.6648e-08,
                    5.7869e-08,
                    5.9149e-08,
                    6.0493e-08,
                    6.1905e-08,
                    6.339e-08,
                    6.4952e-08,
                    6.6596e-08,
                    6.8325e-08,
                    6.9916e-08,
                    7.1464e-08,
                    7.297e-08,
                    7.4434e-08,
                    7.5855e-08,
                    7.7234e-08,
                    7.8571e-08,
                    7.9865e-08,
                    8.1117e-08,
                    8.2327e-08,
                    8.3455e-08,
                    8.4498e-08,
                    8.5451e-08,
                    8.6308e-08,
                    8.7066e-08,
                    8.7719e-08,
                    8.8348e-08,
                    8.8926e-08,
                    8.9665e-08,
                    9.0561e-08,
                    9.1115e-08,
                    9.2754e-08,
                    9.4006e-08,
                    9.6331e-08,
                    9.9692e-08,
                    1.0303e-07,
                    1.0558e-07,
                    1.0808e-07,
                    1.1312e-07,
                    1.1825e-07,
                    1.2475e-07,
                    1.3132e-07,
                    1.3756e-07,
                    1.4398e-07,
                    1.5039e-07,
                    1.5681e-07,
                    1.6331e-07,
                    1.6976e-07,
                    1.7612e-07,
                    1.8222e-07,
                    1.8873e-07,
                    1.9447e-07,
                    2.0059e-07,
                    2.0569e-07,
                    2.0983e-07,
                    2.1399e-07,
                    2.1896e-07,
                    2.2408e-07,
                    2.2692e-07,
                    2.2968e-07,
                    2.3122e-07,
                    2.3273e-07,
                    2.3462e-07,
                    2.3643e-07,
                    2.3833e-07,
                    2.4027e-07,
                    2.4209e-07,
                    2.44e-07,
                    2.4578e-07,
                    2.4762e-07,
                    2.4952e-07,
                    2.5122e-07
                ],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [
                    3.3714e-11,
                    6.8101e-11,
                    1.0313e-10,
                    1.3877e-10,
                    1.7496e-10,
                    2.1165e-10,
                    2.4875e-10,
                    2.8619e-10,
                    3.2386e-10,
                    3.6167e-10,
                    3.9954e-10,
                    4.3745e-10,
                    4.7541e-10,
                    5.1339e-10,
                    5.5139e-10,
                    5.8941e-10,
                    6.2747e-10,
                    6.6556e-10,
                    7.037e-10,
                    7.4191e-10,
                    7.8076e-10,
                    8.2124e-10,
                    8.6408e-10,
                    9.0981e-10,
                    9.5873e-10,
                    1.0109e-09,
                    1.0662e-09,
                    1.1242e-09,
                    1.1844e-09,
                    1.2458e-09,
                    1.308e-09,
                    1.3707e-09,
                    1.434e-09,
                    1.4977e-09,
                    1.5619e-09,
                    1.6264e-09,
                    1.6912e-09,
                    1.7565e-09,
                    1.8222e-09,
                    1.8951e-09,
                    1.9649e-09,
                    2.0321e-09,
                    2.0969e-09,
                    2.1598e-09,
                    2.2211e-09,
                    2.2812e-09,
                    2.3403e-09,
                    2.3989e-09,
                    2.4571e-09,
                    2.5152e-09,
                    2.5739e-09,
                    2.634e-09,
                    2.6963e-09,
                    2.7612e-09,
                    2.829e-09,
                    2.8998e-09,
                    2.9736e-09,
                    3.05e-09,
                    3.1287e-09,
                    3.2088e-09,
                    3.29e-09,
                    3.372e-09,
                    3.4549e-09,
                    3.5385e-09,
                    3.6227e-09,
                    3.7076e-09,
                    3.7931e-09,
                    3.8793e-09,
                    3.9662e-09,
                    4.054e-09,
                    4.1428e-09,
                    4.2328e-09,
                    4.3242e-09,
                    4.417e-09,
                    4.5113e-09,
                    4.6069e-09,
                    4.7036e-09,
                    4.8013e-09,
                    4.8997e-09,
                    4.9983e-09,
                    5.097e-09,
                    5.1957e-09,
                    5.2944e-09,
                    5.393e-09,
                    5.4915e-09,
                    5.5901e-09,
                    5.6888e-09,
                    5.7875e-09,
                    5.8865e-09,
                    5.9859e-09,
                    6.0871e-09,
                    6.1931e-09,
                    6.3059e-09,
                    6.427e-09,
                    6.5573e-09,
                    6.6972e-09,
                    6.8461e-09,
                    7.0033e-09,
                    7.1673e-09,
                    7.3357e-09,
                    7.5075e-09,
                    7.6828e-09,
                    7.8617e-09,
                    8.0444e-09,
                    8.2309e-09,
                    8.4214e-09,
                    8.6161e-09,
                    8.815e-09,
                    9.0183e-09,
                    9.2262e-09,
                    9.4358e-09,
                    9.6473e-09,
                    9.8612e-09,
                    1.0078e-08,
                    1.0298e-08,
                    1.0521e-08,
                    1.0747e-08,
                    1.0976e-08,
                    1.1206e-08,
                    1.1436e-08,
                    1.1666e-08,
                    1.1898e-08,
                    1.213e-08,
                    1.2363e-08,
                    1.2596e-08,
                    1.2831e-08,
                    1.3078e-08,
                    1.3326e-08,
                    1.3574e-08,
                    1.3848e-08,
                    1.4109e-08,
                    1.4409e-08,
                    1.4697e-08,
                    1.5034e-08,
                    1.5397e-08,
                    1.5772e-08,
                    1.6111e-08,
                    1.6451e-08,
                    1.6901e-08,
                    1.7351e-08,
                    1.7851e-08,
                    1.8363e-08,
                    1.8863e-08,
                    1.9363e-08,
                    1.9863e-08,
                    2.0375e-08,
                    2.0887e-08,
                    2.1399e-08,
                    2.1936e-08,
                    2.2473e-08,
                    2.3011e-08,
                    2.3574e-08,
                    2.4139e-08,
                    2.4717e-08,
                    2.5284e-08,
                    2.5851e-08,
                    2.642e-08,
                    2.7014e-08,
                    2.7622e-08,
                    2.8218e-08,
                    2.8803e-08,
                    2.94e-08,
                    3e-08,
                    3.06e-08,
                    3.12e-08,
                    3.1801e-08,
                    3.2415e-08,
                    3.3029e-08,
                    3.3669e-08,
                    3.4309e-08,
                    3.4951e-08,
                    3.5596e-08
                ],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [
                    1.9569e-12,
                    3.9529e-12,
                    5.9864e-12,
                    8.055e-12,
                    1.0156e-11,
                    1.2285e-11,
                    1.4439e-11,
                    1.6612e-11,
                    1.8798e-11,
                    2.0993e-11,
                    2.3191e-11,
                    2.5392e-11,
                    2.7595e-11,
                    2.98e-11,
                    3.2005e-11,
                    3.4213e-11,
                    3.6421e-11,
                    3.8632e-11,
                    4.0846e-11,
                    4.3064e-11,
                    4.5319e-11,
                    4.7669e-11,
                    5.0155e-11,
                    5.281e-11,
                    5.565e-11,
                    5.8679e-11,
                    6.1888e-11,
                    6.5256e-11,
                    6.8747e-11,
                    7.2313e-11,
                    7.5921e-11,
                    7.9564e-11,
                    8.3237e-11,
                    8.6937e-11,
                    9.0659e-11,
                    9.4403e-11,
                    9.8168e-11,
                    1.0196e-10,
                    1.0577e-10,
                    1.0962e-10,
                    1.1349e-10,
                    1.1741e-10,
                    1.2135e-10,
                    1.2533e-10,
                    1.2934e-10,
                    1.334e-10,
                    1.375e-10,
                    1.4164e-10,
                    1.4582e-10,
                    1.5007e-10,
                    1.5437e-10,
                    1.5874e-10,
                    1.6319e-10,
                    1.6773e-10,
                    1.7236e-10,
                    1.7708e-10,
                    1.819e-10,
                    1.8682e-10,
                    1.9183e-10,
                    1.9693e-10,
                    2.0211e-10,
                    2.0738e-10,
                    2.1274e-10,
                    2.1817e-10,
                    2.237e-10,
                    2.293e-10,
                    2.35e-10,
                    2.4077e-10,
                    2.4664e-10,
                    2.5259e-10,
                    2.5863e-10,
                    2.6476e-10,
                    2.7098e-10,
                    2.773e-10,
                    2.8371e-10,
                    2.9021e-10,
                    2.9681e-10,
                    3.0349e-10,
                    3.1025e-10,
                    3.171e-10,
                    3.2406e-10,
                    3.3124e-10,
                    3.3869e-10,
                    3.4648e-10,
                    3.5465e-10,
                    3.6324e-10,
                    3.7226e-10,
                    3.8172e-10,
                    3.9162e-10,
                    4.0194e-10,
                    4.1281e-10,
                    4.245e-10,
                    4.372e-10,
                    4.5105e-10,
                    4.6613e-10,
                    4.8245e-10,
                    4.9998e-10,
                    5.1859e-10,
                    5.3812e-10,
                    5.5834e-10,
                    5.7906e-10,
                    6.002e-10,
                    6.2169e-10,
                    6.4349e-10,
                    6.656e-10,
                    6.88e-10,
                    7.1073e-10,
                    7.3384e-10,
                    7.5741e-10,
                    7.8153e-10,
                    8.0673e-10,
                    8.3381e-10,
                    8.6339e-10,
                    8.9586e-10,
                    9.3144e-10,
                    9.7012e-10,
                    1.0117e-09,
                    1.0558e-09,
                    1.1019e-09,
                    1.1471e-09,
                    1.1933e-09,
                    1.2402e-09,
                    1.2879e-09,
                    1.3364e-09,
                    1.3856e-09,
                    1.4354e-09,
                    1.4859e-09,
                    1.5371e-09,
                    1.5887e-09,
                    1.641e-09,
                    1.6939e-09,
                    1.7474e-09,
                    1.8015e-09,
                    1.8563e-09,
                    1.9116e-09,
                    1.9675e-09,
                    2.0237e-09,
                    2.0803e-09,
                    2.1372e-09,
                    2.1942e-09,
                    2.2513e-09,
                    2.3086e-09,
                    2.3658e-09,
                    2.4231e-09,
                    2.4804e-09,
                    2.5377e-09,
                    2.595e-09,
                    2.6522e-09,
                    2.7095e-09,
                    2.767e-09,
                    2.8252e-09,
                    2.8849e-09,
                    2.9456e-09,
                    3.0076e-09,
                    3.07e-09,
                    3.1335e-09,
                    3.198e-09,
                    3.2636e-09,
                    3.3302e-09,
                    3.3975e-09,
                    3.466e-09,
                    3.5354e-09,
                    3.6059e-09,
                    3.6771e-09,
                    3.749e-09,
                    3.8215e-09,
                    3.8941e-09,
                    3.9675e-09,
                    4.0416e-09,
                    4.1164e-09,
                    4.1929e-09,
                    4.2696e-09
                ],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": [
                    3.1757e-11,
                    6.4148e-11,
                    9.7148e-11,
                    1.3072e-10,
                    1.6481e-10,
                    1.9936e-10,
                    2.3431e-10,
                    2.6957e-10,
                    3.0506e-10,
                    3.4067e-10,
                    3.7635e-10,
                    4.1206e-10,
                    4.4781e-10,
                    4.8359e-10,
                    5.1938e-10,
                    5.552e-10,
                    5.9105e-10,
                    6.2693e-10,
                    6.6285e-10,
                    6.9885e-10,
                    7.3544e-10,
                    7.7357e-10,
                    8.1392e-10,
                    8.57e-10,
                    9.0308e-10,
                    9.5224e-10,
                    1.0043e-09,
                    1.059e-09,
                    1.1156e-09,
                    1.1735e-09,
                    1.232e-09,
                    1.2912e-09,
                    1.3508e-09,
                    1.4108e-09,
                    1.4712e-09,
                    1.532e-09,
                    1.5931e-09,
                    1.6546e-09,
                    1.7165e-09,
                    1.7855e-09,
                    1.8515e-09,
                    1.9147e-09,
                    1.9755e-09,
                    2.0345e-09,
                    2.0918e-09,
                    2.1478e-09,
                    2.2028e-09,
                    2.2572e-09,
                    2.3113e-09,
                    2.3651e-09,
                    2.4195e-09,
                    2.4753e-09,
                    2.5331e-09,
                    2.5934e-09,
                    2.6566e-09,
                    2.7227e-09,
                    2.7917e-09,
                    2.8632e-09,
                    2.9368e-09,
                    3.0119e-09,
                    3.0879e-09,
                    3.1647e-09,
                    3.2422e-09,
                    3.3203e-09,
                    3.399e-09,
                    3.4783e-09,
                    3.5581e-09,
                    3.6385e-09,
                    3.7196e-09,
                    3.8014e-09,
                    3.8842e-09,
                    3.9681e-09,
                    4.0532e-09,
                    4.1397e-09,
                    4.2276e-09,
                    4.3166e-09,
                    4.4068e-09,
                    4.4978e-09,
                    4.5894e-09,
                    4.6812e-09,
                    4.773e-09,
                    4.8645e-09,
                    4.9557e-09,
                    5.0465e-09,
                    5.1369e-09,
                    5.2269e-09,
                    5.3165e-09,
                    5.4058e-09,
                    5.4949e-09,
                    5.5839e-09,
                    5.6743e-09,
                    5.7686e-09,
                    5.8687e-09,
                    5.976e-09,
                    6.0912e-09,
                    6.2147e-09,
                    6.3462e-09,
                    6.4848e-09,
                    6.6291e-09,
                    6.7774e-09,
                    6.9285e-09,
                    7.0826e-09,
                    7.24e-09,
                    7.4009e-09,
                    7.5653e-09,
                    7.7334e-09,
                    7.9054e-09,
                    8.0812e-09,
                    8.2609e-09,
                    8.4446e-09,
                    8.629e-09,
                    8.8134e-09,
                    8.9979e-09,
                    9.1823e-09,
                    9.3667e-09,
                    9.5511e-09,
                    9.7355e-09,
                    9.9199e-09,
                    1.0104e-08,
                    1.0289e-08,
                    1.0473e-08,
                    1.0658e-08,
                    1.0842e-08,
                    1.1026e-08,
                    1.1211e-08,
                    1.1395e-08,
                    1.1592e-08,
                    1.1789e-08,
                    1.1985e-08,
                    1.2207e-08,
                    1.2416e-08,
                    1.2661e-08,
                    1.2895e-08,
                    1.3178e-08,
                    1.3485e-08,
                    1.3805e-08,
                    1.4088e-08,
                    1.437e-08,
                    1.4764e-08,
                    1.5157e-08,
                    1.56e-08,
                    1.6055e-08,
                    1.6497e-08,
                    1.694e-08,
                    1.7382e-08,
                    1.7837e-08,
                    1.8292e-08,
                    1.8747e-08,
                    1.9226e-08,
                    1.9706e-08,
                    2.0185e-08,
                    2.0689e-08,
                    2.1193e-08,
                    2.171e-08,
                    2.2214e-08,
                    2.2718e-08,
                    2.3222e-08,
                    2.3751e-08,
                    2.4292e-08,
                    2.482e-08,
                    2.5336e-08,
                    2.5865e-08,
                    2.6394e-08,
                    2.6922e-08,
                    2.7451e-08,
                    2.798e-08,
                    2.8521e-08,
                    2.9062e-08,
                    2.9627e-08,
                    3.0193e-08,
                    3.0758e-08,
                    3.1326e-08
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            177.13781,
                            -7.19289
                        ],
                        [
                            177.13952,
                            -7.23986
                        ],
                        [
                            177.16792,
                            -7.24389
                        ],
                        [
                            177.16362,
                            -7.20311
                        ],
                        [
                            177.13781,
                            -7.19289
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "TUR",
                "Country": "Turkey",
                "Total_3GHG": 0.65,
                "Total_3GHG_timeseries": [
                    7.0047e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0055,
                    0.0057,
                    0.0058,
                    0.006,
                    0.0061,
                    0.0063,
                    0.0064,
                    0.0066,
                    0.0068,
                    0.007,
                    0.0072,
                    0.0075,
                    0.0077,
                    0.008,
                    0.0083,
                    0.0086,
                    0.0089,
                    0.0092,
                    0.0095,
                    0.0097,
                    0.01,
                    0.0103,
                    0.0107
                ],
                "Fossil_3GHG": 0.76,
                "Fossil_3GHG_timeseries": [
                    4.8844e-07,
                    9.8693e-07,
                    1.4962e-06,
                    2.0165e-06,
                    2.5476e-06,
                    3.0897e-06,
                    3.6436e-06,
                    4.2071e-06,
                    4.7845e-06,
                    5.3737e-06,
                    5.9733e-06,
                    6.5835e-06,
                    7.2051e-06,
                    7.8373e-06,
                    8.5691e-06,
                    9.3468e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0027,
                    0.0028,
                    0.003,
                    0.0031,
                    0.0033,
                    0.0035,
                    0.0036,
                    0.0038,
                    0.004,
                    0.0042,
                    0.0044,
                    0.0046,
                    0.0048,
                    0.0051,
                    0.0053,
                    0.0056,
                    0.0058,
                    0.0061,
                    0.0064,
                    0.0067,
                    0.007,
                    0.0072,
                    0.0075,
                    0.0078,
                    0.0081
                ],
                "Land_3GHG": 0.45,
                "Land_3GHG_timeseries": [
                    6.5162e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026
                ],
                "Total_CO2": 0.56,
                "Total_CO2_timeseries": [
                    3.7976e-06,
                    7.3853e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0046,
                    0.0047,
                    0.0049,
                    0.0051,
                    0.0052,
                    0.0054,
                    0.0056,
                    0.0058,
                    0.006,
                    0.0061,
                    0.0063
                ],
                "Fossil_CO2": 0.68,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    6.765e-08,
                    1.617e-07,
                    2.64e-07,
                    3.432e-07,
                    4.6365e-07,
                    5.346e-07,
                    6.237e-07,
                    7.3425e-07,
                    8.415e-07,
                    9.57e-07,
                    1.1154e-06,
                    1.2392e-06,
                    1.4404e-06,
                    1.5873e-06,
                    1.6434e-06,
                    1.7061e-06,
                    1.7886e-06,
                    1.8579e-06,
                    1.9305e-06,
                    2.0097e-06,
                    2.0971e-06,
                    2.1582e-06,
                    2.2688e-06,
                    2.3892e-06,
                    2.5707e-06,
                    2.7357e-06,
                    2.9172e-06,
                    3.102e-06,
                    3.2934e-06,
                    3.47e-06,
                    3.6382e-06,
                    3.8379e-06,
                    3.9798e-06,
                    4.2158e-06,
                    4.5177e-06,
                    4.9846e-06,
                    5.412e-06,
                    5.8839e-06,
                    6.4267e-06,
                    7.0422e-06,
                    7.7319e-06,
                    8.4431e-06,
                    9.2895e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0029,
                    0.003,
                    0.0032,
                    0.0033,
                    0.0035,
                    0.0036,
                    0.0038,
                    0.004,
                    0.0042,
                    0.0044,
                    0.0045,
                    0.0047,
                    0.0049,
                    0.0051,
                    0.0053
                ],
                "Land_CO2": 0.29,
                "Land_CO2_timeseries": [
                    3.7976e-06,
                    7.3853e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.001,
                    0.001,
                    0.001
                ],
                "Total_CH4": 0.8,
                "Total_CH4_timeseries": [
                    2.6517e-06,
                    5.3199e-06,
                    8.0055e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033
                ],
                "Fossil_CH4": 0.96,
                "Fossil_CH4_timeseries": [
                    3.8385e-07,
                    7.7648e-07,
                    1.1787e-06,
                    1.5906e-06,
                    2.0123e-06,
                    2.4438e-06,
                    2.8859e-06,
                    3.3367e-06,
                    3.8004e-06,
                    4.2749e-06,
                    4.7591e-06,
                    5.253e-06,
                    5.7574e-06,
                    6.2716e-06,
                    6.8169e-06,
                    7.3809e-06,
                    7.9589e-06,
                    8.5416e-06,
                    9.1463e-06,
                    9.75e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025
                ],
                "Land_CH4": 0.52,
                "Land_CH4_timeseries": [
                    2.2678e-06,
                    4.5434e-06,
                    6.8268e-06,
                    9.118e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008
                ],
                "Total_N2O": 1.23,
                "Total_N2O_timeseries": [
                    5.5543e-07,
                    1.1211e-06,
                    1.6967e-06,
                    2.2816e-06,
                    2.8751e-06,
                    3.4762e-06,
                    4.0841e-06,
                    4.6975e-06,
                    5.315e-06,
                    5.9352e-06,
                    6.5571e-06,
                    7.1805e-06,
                    7.8052e-06,
                    8.4311e-06,
                    9.0581e-06,
                    9.6863e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001
                ],
                "Fossil_N2O": 1.22,
                "Fossil_N2O_timeseries": [
                    1.0459e-07,
                    2.1044e-07,
                    3.1753e-07,
                    4.2583e-07,
                    5.3532e-07,
                    6.4594e-07,
                    7.5765e-07,
                    8.704e-07,
                    9.8412e-07,
                    1.0987e-06,
                    1.2142e-06,
                    1.3306e-06,
                    1.4477e-06,
                    1.5657e-06,
                    1.6846e-06,
                    1.8042e-06,
                    1.9247e-06,
                    2.0461e-06,
                    2.1683e-06,
                    2.2913e-06,
                    2.4156e-06,
                    2.5418e-06,
                    2.6704e-06,
                    2.8016e-06,
                    2.9358e-06,
                    3.0729e-06,
                    3.2129e-06,
                    3.3554e-06,
                    3.5002e-06,
                    3.6467e-06,
                    3.7944e-06,
                    3.9434e-06,
                    4.0935e-06,
                    4.2447e-06,
                    4.397e-06,
                    4.5503e-06,
                    4.7048e-06,
                    4.8603e-06,
                    5.0169e-06,
                    5.1752e-06,
                    5.335e-06,
                    5.496e-06,
                    5.6584e-06,
                    5.8222e-06,
                    5.9875e-06,
                    6.1542e-06,
                    6.3225e-06,
                    6.4923e-06,
                    6.6637e-06,
                    6.8367e-06,
                    7.0115e-06,
                    7.1882e-06,
                    7.367e-06,
                    7.5479e-06,
                    7.7309e-06,
                    7.9162e-06,
                    8.1038e-06,
                    8.2936e-06,
                    8.4856e-06,
                    8.6797e-06,
                    8.8759e-06,
                    9.0743e-06,
                    9.2747e-06,
                    9.4772e-06,
                    9.6819e-06,
                    9.8886e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Land_N2O": 1.24,
                "Land_N2O_timeseries": [
                    4.5084e-07,
                    9.107e-07,
                    1.3792e-06,
                    1.8558e-06,
                    2.3397e-06,
                    2.8303e-06,
                    3.3265e-06,
                    3.8271e-06,
                    4.3309e-06,
                    4.8364e-06,
                    5.3429e-06,
                    5.8499e-06,
                    6.3575e-06,
                    6.8654e-06,
                    7.3735e-06,
                    7.882e-06,
                    8.3909e-06,
                    8.9003e-06,
                    9.4103e-06,
                    9.9213e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                41.54713,
                                41.52038
                            ],
                            [
                                41.40062,
                                41.3808
                            ],
                            [
                                41.34439,
                                41.37307
                            ],
                            [
                                41.15301,
                                41.28211
                            ],
                            [
                                41.0676,
                                41.22052
                            ],
                            [
                                40.93154,
                                41.17597
                            ],
                            [
                                40.80106,
                                41.16108
                            ],
                            [
                                40.71975,
                                41.08753
                            ],
                            [
                                40.54241,
                                41.02732
                            ],
                            [
                                40.38211,
                                41.02461
                            ],
                            [
                                40.2303,
                                40.92841
                            ],
                            [
                                40.12254,
                                40.91221
                            ],
                            [
                                40.03355,
                                40.95928
                            ],
                            [
                                39.8717,
                                40.95467
                            ],
                            [
                                39.78043,
                                41.00208
                            ],
                            [
                                39.66689,
                                40.99535
                            ],
                            [
                                39.56723,
                                41.02569
                            ],
                            [
                                39.48641,
                                41.09141
                            ],
                            [
                                39.40772,
                                41.10349
                            ],
                            [
                                39.25087,
                                41.04765
                            ],
                            [
                                39.16296,
                                41.07856
                            ],
                            [
                                39.05494,
                                41.03737
                            ],
                            [
                                38.91942,
                                41.03913
                            ],
                            [
                                38.81514,
                                41.00941
                            ],
                            [
                                38.71375,
                                40.95057
                            ],
                            [
                                38.62443,
                                40.97285
                            ],
                            [
                                38.53032,
                                40.91695
                            ],
                            [
                                38.36378,
                                40.90886
                            ],
                            [
                                38.28231,
                                40.94481
                            ],
                            [
                                38.19131,
                                40.93869
                            ],
                            [
                                37.99978,
                                40.98034
                            ],
                            [
                                37.87936,
                                40.98706
                            ],
                            [
                                37.80868,
                                41.02582
                            ],
                            [
                                37.78831,
                                41.10829
                            ],
                            [
                                37.65423,
                                41.11601
                            ],
                            [
                                37.61275,
                                41.05492
                            ],
                            [
                                37.53797,
                                41.02137
                            ],
                            [
                                37.39411,
                                41.10434
                            ],
                            [
                                37.29188,
                                41.1452
                            ],
                            [
                                37.13398,
                                41.14972
                            ],
                            [
                                37.02725,
                                41.195
                            ],
                            [
                                36.99626,
                                41.28362
                            ],
                            [
                                36.86218,
                                41.34086
                            ],
                            [
                                36.66239,
                                41.38037
                            ],
                            [
                                36.56825,
                                41.2889
                            ],
                            [
                                36.50143,
                                41.25437
                            ],
                            [
                                36.39799,
                                41.25106
                            ],
                            [
                                36.33469,
                                41.32125
                            ],
                            [
                                36.24162,
                                41.354
                            ],
                            [
                                36.13253,
                                41.46154
                            ],
                            [
                                36.11497,
                                41.62409
                            ],
                            [
                                36.05787,
                                41.68551
                            ],
                            [
                                35.95518,
                                41.73415
                            ],
                            [
                                35.75665,
                                41.66629
                            ],
                            [
                                35.56717,
                                41.63112
                            ],
                            [
                                35.45791,
                                41.65177
                            ],
                            [
                                35.2957,
                                41.70901
                            ],
                            [
                                35.20929,
                                41.76666
                            ],
                            [
                                35.08948,
                                41.92965
                            ],
                            [
                                35.1221,
                                42.01315
                            ],
                            [
                                35.04444,
                                42.04171
                            ],
                            [
                                35.01621,
                                42.09236
                            ],
                            [
                                34.94516,
                                42.0972
                            ],
                            [
                                34.9084,
                                42.025
                            ],
                            [
                                34.79857,
                                41.95517
                            ],
                            [
                                34.55801,
                                41.9468
                            ],
                            [
                                34.4764,
                                41.9665
                            ],
                            [
                                34.29132,
                                41.94189
                            ],
                            [
                                34.09655,
                                41.97881
                            ],
                            [
                                33.78313,
                                41.97356
                            ],
                            [
                                33.58297,
                                41.98874
                            ],
                            [
                                33.33841,
                                42.01967
                            ],
                            [
                                33.1645,
                                41.95426
                            ],
                            [
                                33.03141,
                                41.92784
                            ],
                            [
                                32.95574,
                                41.88609
                            ],
                            [
                                32.67272,
                                41.83001
                            ],
                            [
                                32.58094,
                                41.8269
                            ],
                            [
                                32.34206,
                                41.72497
                            ],
                            [
                                32.28424,
                                41.71968
                            ],
                            [
                                32.149,
                                41.60664
                            ],
                            [
                                32.03078,
                                41.57448
                            ],
                            [
                                31.87519,
                                41.51214
                            ],
                            [
                                31.61318,
                                41.38025
                            ],
                            [
                                31.39832,
                                41.31403
                            ],
                            [
                                31.4081,
                                41.21225
                            ],
                            [
                                31.33973,
                                41.13793
                            ],
                            [
                                31.21091,
                                41.09726
                            ],
                            [
                                31.01104,
                                41.07277
                            ],
                            [
                                30.75577,
                                41.08663
                            ],
                            [
                                30.65246,
                                41.12834
                            ],
                            [
                                30.40936,
                                41.16575
                            ],
                            [
                                30.26477,
                                41.2066
                            ],
                            [
                                30.15293,
                                41.13855
                            ],
                            [
                                29.8461,
                                41.13821
                            ],
                            [
                                29.76736,
                                41.16035
                            ],
                            [
                                29.58853,
                                41.17025
                            ],
                            [
                                29.25603,
                                41.23455
                            ],
                            [
                                29.16677,
                                41.22403
                            ],
                            [
                                29.0745,
                                41.16452
                            ],
                            [
                                29.09327,
                                41.1161
                            ],
                            [
                                29.03728,
                                40.97893
                            ],
                            [
                                29.14505,
                                40.90102
                            ],
                            [
                                29.28471,
                                40.85447
                            ],
                            [
                                29.3566,
                                40.75615
                            ],
                            [
                                29.48998,
                                40.77952
                            ],
                            [
                                29.57152,
                                40.76692
                            ],
                            [
                                29.71006,
                                40.77565
                            ],
                            [
                                29.76661,
                                40.7452
                            ],
                            [
                                29.9299,
                                40.75947
                            ],
                            [
                                29.93715,
                                40.72176
                            ],
                            [
                                29.81061,
                                40.7291
                            ],
                            [
                                29.56045,
                                40.68671
                            ],
                            [
                                29.50166,
                                40.72716
                            ],
                            [
                                29.27072,
                                40.65938
                            ],
                            [
                                28.9933,
                                40.64415
                            ],
                            [
                                28.8869,
                                40.58209
                            ],
                            [
                                28.8145,
                                40.56321
                            ],
                            [
                                28.78419,
                                40.51825
                            ],
                            [
                                28.97517,
                                40.45728
                            ],
                            [
                                29.08424,
                                40.47687
                            ],
                            [
                                29.06768,
                                40.37338
                            ],
                            [
                                28.92689,
                                40.35609
                            ],
                            [
                                28.7698,
                                40.39417
                            ],
                            [
                                28.65931,
                                40.35988
                            ],
                            [
                                28.50766,
                                40.39526
                            ],
                            [
                                28.18623,
                                40.39862
                            ],
                            [
                                27.95501,
                                40.35341
                            ],
                            [
                                27.89834,
                                40.39086
                            ],
                            [
                                28.01822,
                                40.44863
                            ],
                            [
                                28.01634,
                                40.48753
                            ],
                            [
                                27.87109,
                                40.51646
                            ],
                            [
                                27.71676,
                                40.52129
                            ],
                            [
                                27.68786,
                                40.47398
                            ],
                            [
                                27.7824,
                                40.40883
                            ],
                            [
                                27.87633,
                                40.38037
                            ],
                            [
                                27.76089,
                                40.30643
                            ],
                            [
                                27.62957,
                                40.32655
                            ],
                            [
                                27.53509,
                                40.30086
                            ],
                            [
                                27.34528,
                                40.361
                            ],
                            [
                                27.28471,
                                40.47451
                            ],
                            [
                                27.18919,
                                40.43328
                            ],
                            [
                                27.09119,
                                40.44176
                            ],
                            [
                                27.03228,
                                40.38974
                            ],
                            [
                                26.95201,
                                40.38457
                            ],
                            [
                                26.75162,
                                40.40197
                            ],
                            [
                                26.6927,
                                40.3657
                            ],
                            [
                                26.52263,
                                40.2181
                            ],
                            [
                                26.40648,
                                40.19649
                            ],
                            [
                                26.40762,
                                40.11766
                            ],
                            [
                                26.32437,
                                40.02055
                            ],
                            [
                                26.18069,
                                39.99275
                            ],
                            [
                                26.14013,
                                39.84186
                            ],
                            [
                                26.163,
                                39.66025
                            ],
                            [
                                26.10605,
                                39.5837
                            ],
                            [
                                26.06386,
                                39.48037
                            ],
                            [
                                26.13195,
                                39.4533
                            ],
                            [
                                26.32529,
                                39.48134
                            ],
                            [
                                26.48468,
                                39.52676
                            ],
                            [
                                26.87984,
                                39.58409
                            ],
                            [
                                26.94207,
                                39.56937
                            ],
                            [
                                26.92941,
                                39.48616
                            ],
                            [
                                26.86011,
                                39.47571
                            ],
                            [
                                26.80694,
                                39.39551
                            ],
                            [
                                26.62508,
                                39.3095
                            ],
                            [
                                26.64042,
                                39.26679
                            ],
                            [
                                26.73328,
                                39.23957
                            ],
                            [
                                26.77092,
                                39.16636
                            ],
                            [
                                26.83647,
                                39.14069
                            ],
                            [
                                26.88033,
                                39.06496
                            ],
                            [
                                26.80161,
                                39.03346
                            ],
                            [
                                26.80064,
                                38.95412
                            ],
                            [
                                26.86855,
                                38.91606
                            ],
                            [
                                26.91657,
                                38.93771
                            ],
                            [
                                27.01231,
                                38.91373
                            ],
                            [
                                27.01653,
                                38.86685
                            ],
                            [
                                26.89711,
                                38.81169
                            ],
                            [
                                26.89217,
                                38.73444
                            ],
                            [
                                26.82565,
                                38.76012
                            ],
                            [
                                26.7285,
                                38.72129
                            ],
                            [
                                26.76038,
                                38.61787
                            ],
                            [
                                26.84099,
                                38.58457
                            ],
                            [
                                26.8485,
                                38.54541
                            ],
                            [
                                26.92653,
                                38.45842
                            ],
                            [
                                27.02786,
                                38.46608
                            ],
                            [
                                27.14807,
                                38.44474
                            ],
                            [
                                27.08912,
                                38.40075
                            ],
                            [
                                27.01854,
                                38.4135
                            ],
                            [
                                26.94398,
                                38.38665
                            ],
                            [
                                26.76731,
                                38.36924
                            ],
                            [
                                26.72669,
                                38.42985
                            ],
                            [
                                26.64648,
                                38.34128
                            ],
                            [
                                26.59642,
                                38.46745
                            ],
                            [
                                26.62626,
                                38.52194
                            ],
                            [
                                26.47606,
                                38.6722
                            ],
                            [
                                26.41707,
                                38.67867
                            ],
                            [
                                26.35431,
                                38.64019
                            ],
                            [
                                26.37468,
                                38.52925
                            ],
                            [
                                26.51024,
                                38.43041
                            ],
                            [
                                26.44847,
                                38.34863
                            ],
                            [
                                26.27314,
                                38.29296
                            ],
                            [
                                26.3673,
                                38.2307
                            ],
                            [
                                26.51326,
                                38.17747
                            ],
                            [
                                26.59484,
                                38.10397
                            ],
                            [
                                26.63633,
                                38.19873
                            ],
                            [
                                26.72886,
                                38.20855
                            ],
                            [
                                26.8222,
                                38.15775
                            ],
                            [
                                26.9015,
                                38.06196
                            ],
                            [
                                26.97945,
                                38.07432
                            ],
                            [
                                27.07617,
                                38.01352
                            ],
                            [
                                27.27124,
                                37.95052
                            ],
                            [
                                27.25409,
                                37.75009
                            ],
                            [
                                27.20863,
                                37.70979
                            ],
                            [
                                27.01802,
                                37.64834
                            ],
                            [
                                27.1988,
                                37.60265
                            ],
                            [
                                27.19,
                                37.54424
                            ],
                            [
                                27.22467,
                                37.48319
                            ],
                            [
                                27.20549,
                                37.36587
                            ],
                            [
                                27.23476,
                                37.33995
                            ],
                            [
                                27.36369,
                                37.38062
                            ],
                            [
                                27.39057,
                                37.32335
                            ],
                            [
                                27.50402,
                                37.27666
                            ],
                            [
                                27.61406,
                                37.27275
                            ],
                            [
                                27.54243,
                                37.18276
                            ],
                            [
                                27.53795,
                                37.12559
                            ],
                            [
                                27.46952,
                                37.08256
                            ],
                            [
                                27.36799,
                                37.15378
                            ],
                            [
                                27.24107,
                                37.08032
                            ],
                            [
                                27.25836,
                                36.97435
                            ],
                            [
                                27.35071,
                                37.02031
                            ],
                            [
                                27.42745,
                                37.03331
                            ],
                            [
                                27.46994,
                                36.99901
                            ],
                            [
                                27.56481,
                                36.98107
                            ],
                            [
                                27.68437,
                                37.00109
                            ],
                            [
                                27.80451,
                                37.00009
                            ],
                            [
                                27.9262,
                                37.02781
                            ],
                            [
                                28.16442,
                                37.03023
                            ],
                            [
                                28.2182,
                                36.99488
                            ],
                            [
                                28.17003,
                                36.92625
                            ],
                            [
                                28.06347,
                                36.93719
                            ],
                            [
                                28.03295,
                                36.79269
                            ],
                            [
                                27.82153,
                                36.81137
                            ],
                            [
                                27.71745,
                                36.78535
                            ],
                            [
                                27.64695,
                                36.80448
                            ],
                            [
                                27.61125,
                                36.76736
                            ],
                            [
                                27.42907,
                                36.7475
                            ],
                            [
                                27.37159,
                                36.68707
                            ],
                            [
                                27.47827,
                                36.64992
                            ],
                            [
                                27.51534,
                                36.67582
                            ],
                            [
                                27.67447,
                                36.65991
                            ],
                            [
                                27.71075,
                                36.75016
                            ],
                            [
                                27.81352,
                                36.76254
                            ],
                            [
                                27.92808,
                                36.74328
                            ],
                            [
                                28.12965,
                                36.79415
                            ],
                            [
                                28.11882,
                                36.73395
                            ],
                            [
                                28.00052,
                                36.70286
                            ],
                            [
                                28.09268,
                                36.64479
                            ],
                            [
                                28.27213,
                                36.7473
                            ],
                            [
                                28.23483,
                                36.80384
                            ],
                            [
                                28.31188,
                                36.81592
                            ],
                            [
                                28.39847,
                                36.78567
                            ],
                            [
                                28.46562,
                                36.81195
                            ],
                            [
                                28.58588,
                                36.81535
                            ],
                            [
                                28.62006,
                                36.79372
                            ],
                            [
                                28.61588,
                                36.713
                            ],
                            [
                                28.78616,
                                36.68718
                            ],
                            [
                                28.87029,
                                36.69494
                            ],
                            [
                                28.95006,
                                36.73697
                            ],
                            [
                                29.01913,
                                36.71379
                            ],
                            [
                                29.07511,
                                36.64164
                            ],
                            [
                                29.02373,
                                36.58513
                            ],
                            [
                                29.12242,
                                36.54519
                            ],
                            [
                                29.10421,
                                36.40442
                            ],
                            [
                                29.13938,
                                36.36076
                            ],
                            [
                                29.24871,
                                36.31714
                            ],
                            [
                                29.35166,
                                36.23283
                            ],
                            [
                                29.41411,
                                36.25712
                            ],
                            [
                                29.49489,
                                36.20975
                            ],
                            [
                                29.56071,
                                36.20864
                            ],
                            [
                                29.68357,
                                36.13525
                            ],
                            [
                                29.78592,
                                36.14113
                            ],
                            [
                                29.92196,
                                36.23109
                            ],
                            [
                                29.97851,
                                36.2198
                            ],
                            [
                                30.06344,
                                36.25807
                            ],
                            [
                                30.113,
                                36.248
                            ],
                            [
                                30.15357,
                                36.3011
                            ],
                            [
                                30.2803,
                                36.31393
                            ],
                            [
                                30.43156,
                                36.23105
                            ],
                            [
                                30.52068,
                                36.33131
                            ],
                            [
                                30.48616,
                                36.4349
                            ],
                            [
                                30.58391,
                                36.57398
                            ],
                            [
                                30.55646,
                                36.64791
                            ],
                            [
                                30.57626,
                                36.79339
                            ],
                            [
                                30.61312,
                                36.84199
                            ],
                            [
                                30.69486,
                                36.88252
                            ],
                            [
                                30.75807,
                                36.84826
                            ],
                            [
                                31.00401,
                                36.85738
                            ],
                            [
                                31.30222,
                                36.81478
                            ],
                            [
                                31.38915,
                                36.76525
                            ],
                            [
                                31.52212,
                                36.72725
                            ],
                            [
                                31.66736,
                                36.64907
                            ],
                            [
                                31.98532,
                                36.54323
                            ],
                            [
                                32.02813,
                                36.53812
                            ],
                            [
                                32.1655,
                                36.41685
                            ],
                            [
                                32.2983,
                                36.23407
                            ],
                            [
                                32.38878,
                                36.16514
                            ],
                            [
                                32.52668,
                                36.0947
                            ],
                            [
                                32.56226,
                                36.0992
                            ],
                            [
                                32.66947,
                                36.0443
                            ],
                            [
                                32.80253,
                                36.01795
                            ],
                            [
                                32.8725,
                                36.07179
                            ],
                            [
                                32.95934,
                                36.10281
                            ],
                            [
                                33.08851,
                                36.07707
                            ],
                            [
                                33.12214,
                                36.12555
                            ],
                            [
                                33.39639,
                                36.12679
                            ],
                            [
                                33.46605,
                                36.15908
                            ],
                            [
                                33.56709,
                                36.13272
                            ],
                            [
                                33.64729,
                                36.19232
                            ],
                            [
                                33.67405,
                                36.14507
                            ],
                            [
                                33.80397,
                                36.23745
                            ],
                            [
                                33.86644,
                                36.3134
                            ],
                            [
                                33.93599,
                                36.28838
                            ],
                            [
                                34.07944,
                                36.33663
                            ],
                            [
                                34.07938,
                                36.40451
                            ],
                            [
                                34.16694,
                                36.46789
                            ],
                            [
                                34.27901,
                                36.58517
                            ],
                            [
                                34.42911,
                                36.66483
                            ],
                            [
                                34.56437,
                                36.76919
                            ],
                            [
                                34.65507,
                                36.8045
                            ],
                            [
                                34.74628,
                                36.81055
                            ],
                            [
                                34.83523,
                                36.78911
                            ],
                            [
                                34.90646,
                                36.72525
                            ],
                            [
                                34.99863,
                                36.71253
                            ],
                            [
                                35.31442,
                                36.564
                            ],
                            [
                                35.40991,
                                36.58513
                            ],
                            [
                                35.56271,
                                36.56561
                            ],
                            [
                                35.61582,
                                36.60193
                            ],
                            [
                                35.66566,
                                36.76585
                            ],
                            [
                                35.79189,
                                36.76702
                            ],
                            [
                                36.00567,
                                36.92966
                            ],
                            [
                                36.1484,
                                36.85514
                            ],
                            [
                                36.20554,
                                36.78266
                            ],
                            [
                                36.2152,
                                36.66129
                            ],
                            [
                                36.16208,
                                36.59463
                            ],
                            [
                                36.03757,
                                36.53352
                            ],
                            [
                                35.98265,
                                36.47474
                            ],
                            [
                                35.90208,
                                36.4376
                            ],
                            [
                                35.77999,
                                36.31847
                            ],
                            [
                                35.93329,
                                36.10265
                            ],
                            [
                                35.97895,
                                36.01851
                            ],
                            [
                                35.91681,
                                35.92852
                            ],
                            [
                                36.12857,
                                35.85145
                            ],
                            [
                                36.18222,
                                35.85482
                            ],
                            [
                                36.22303,
                                35.96112
                            ],
                            [
                                36.37506,
                                35.99906
                            ],
                            [
                                36.3751,
                                36.17564
                            ],
                            [
                                36.39255,
                                36.21284
                            ],
                            [
                                36.53182,
                                36.23526
                            ],
                            [
                                36.68278,
                                36.23349
                            ],
                            [
                                36.68944,
                                36.28633
                            ],
                            [
                                36.58222,
                                36.39839
                            ],
                            [
                                36.54989,
                                36.48743
                            ],
                            [
                                36.58648,
                                36.61979
                            ],
                            [
                                36.66192,
                                36.81363
                            ],
                            [
                                36.70532,
                                36.82886
                            ],
                            [
                                36.98527,
                                36.75856
                            ],
                            [
                                37.12746,
                                36.65962
                            ],
                            [
                                37.37614,
                                36.65568
                            ],
                            [
                                37.53183,
                                36.67763
                            ],
                            [
                                37.70773,
                                36.74762
                            ],
                            [
                                37.77758,
                                36.74828
                            ],
                            [
                                38.02341,
                                36.83065
                            ],
                            [
                                38.17955,
                                36.90519
                            ],
                            [
                                38.3868,
                                36.89813
                            ],
                            [
                                38.54188,
                                36.84354
                            ],
                            [
                                38.72642,
                                36.70358
                            ],
                            [
                                38.91809,
                                36.69518
                            ],
                            [
                                39.04392,
                                36.70799
                            ],
                            [
                                39.22554,
                                36.66564
                            ],
                            [
                                39.81825,
                                36.75377
                            ],
                            [
                                40.00772,
                                36.81473
                            ],
                            [
                                40.22603,
                                36.90137
                            ],
                            [
                                40.44554,
                                37.0143
                            ],
                            [
                                40.51431,
                                37.02373
                            ],
                            [
                                40.77239,
                                37.11822
                            ],
                            [
                                40.93031,
                                37.12954
                            ],
                            [
                                41.21644,
                                37.07267
                            ],
                            [
                                41.54707,
                                37.08521
                            ],
                            [
                                41.84092,
                                37.13022
                            ],
                            [
                                42.05531,
                                37.19228
                            ],
                            [
                                42.17886,
                                37.28859
                            ],
                            [
                                42.2936,
                                37.26981
                            ],
                            [
                                42.35063,
                                37.23148
                            ],
                            [
                                42.35569,
                                37.10804
                            ],
                            [
                                42.57898,
                                37.15411
                            ],
                            [
                                42.72385,
                                37.35073
                            ],
                            [
                                42.78669,
                                37.38304
                            ],
                            [
                                42.95922,
                                37.32379
                            ],
                            [
                                43.15771,
                                37.37338
                            ],
                            [
                                43.49055,
                                37.25124
                            ],
                            [
                                43.62146,
                                37.23027
                            ],
                            [
                                43.9129,
                                37.2271
                            ],
                            [
                                44.01095,
                                37.31793
                            ],
                            [
                                44.11832,
                                37.3156
                            ],
                            [
                                44.23063,
                                37.27574
                            ],
                            [
                                44.26238,
                                37.16426
                            ],
                            [
                                44.19656,
                                37.0963
                            ],
                            [
                                44.257,
                                36.98644
                            ],
                            [
                                44.31824,
                                36.97179
                            ],
                            [
                                44.35037,
                                37.03807
                            ],
                            [
                                44.48767,
                                37.09011
                            ],
                            [
                                44.64409,
                                37.18814
                            ],
                            [
                                44.79315,
                                37.17628
                            ],
                            [
                                44.82037,
                                37.26913
                            ],
                            [
                                44.8026,
                                37.32021
                            ],
                            [
                                44.64972,
                                37.4269
                            ],
                            [
                                44.58906,
                                37.44417
                            ],
                            [
                                44.58457,
                                37.61403
                            ],
                            [
                                44.61665,
                                37.7191
                            ],
                            [
                                44.57603,
                                37.76689
                            ],
                            [
                                44.22454,
                                37.89997
                            ],
                            [
                                44.24011,
                                37.96224
                            ],
                            [
                                44.47244,
                                38.31572
                            ],
                            [
                                44.43655,
                                38.39421
                            ],
                            [
                                44.32009,
                                38.38236
                            ],
                            [
                                44.30435,
                                38.44929
                            ],
                            [
                                44.31714,
                                38.61257
                            ],
                            [
                                44.26235,
                                38.72422
                            ],
                            [
                                44.30261,
                                38.80899
                            ],
                            [
                                44.28389,
                                38.86178
                            ],
                            [
                                44.21045,
                                38.8929
                            ],
                            [
                                44.16286,
                                39.00443
                            ],
                            [
                                44.21606,
                                39.13552
                            ],
                            [
                                44.03584,
                                39.37686
                            ],
                            [
                                44.07682,
                                39.41126
                            ],
                            [
                                44.20325,
                                39.41629
                            ],
                            [
                                44.30548,
                                39.38767
                            ],
                            [
                                44.42467,
                                39.43564
                            ],
                            [
                                44.47757,
                                39.63968
                            ],
                            [
                                44.47143,
                                39.69789
                            ],
                            [
                                44.60936,
                                39.77835
                            ],
                            [
                                44.7365,
                                39.7018
                            ],
                            [
                                44.81204,
                                39.63174
                            ],
                            [
                                44.76834,
                                39.71415
                            ],
                            [
                                44.5927,
                                39.83199
                            ],
                            [
                                44.48653,
                                39.96327
                            ],
                            [
                                44.28422,
                                40.04547
                            ],
                            [
                                44.04455,
                                40.01047
                            ],
                            [
                                43.91002,
                                40.01946
                            ],
                            [
                                43.67002,
                                40.10269
                            ],
                            [
                                43.71459,
                                40.15852
                            ],
                            [
                                43.60723,
                                40.36855
                            ],
                            [
                                43.59313,
                                40.5007
                            ],
                            [
                                43.65383,
                                40.53258
                            ],
                            [
                                43.74091,
                                40.66591
                            ],
                            [
                                43.75018,
                                40.74498
                            ],
                            [
                                43.67059,
                                40.92815
                            ],
                            [
                                43.59561,
                                40.99269
                            ],
                            [
                                43.48579,
                                41.02216
                            ],
                            [
                                43.47383,
                                41.1233
                            ],
                            [
                                43.4481,
                                41.17607
                            ],
                            [
                                43.37844,
                                41.20196
                            ],
                            [
                                43.23618,
                                41.18556
                            ],
                            [
                                43.19476,
                                41.25303
                            ],
                            [
                                43.21231,
                                41.28994
                            ],
                            [
                                43.02022,
                                41.3808
                            ],
                            [
                                42.96798,
                                41.45032
                            ],
                            [
                                42.79792,
                                41.51745
                            ],
                            [
                                42.77942,
                                41.57771
                            ],
                            [
                                42.69721,
                                41.60038
                            ],
                            [
                                42.60137,
                                41.58464
                            ],
                            [
                                42.57164,
                                41.50953
                            ],
                            [
                                42.46992,
                                41.43551
                            ],
                            [
                                42.28271,
                                41.49268
                            ],
                            [
                                41.9612,
                                41.52402
                            ],
                            [
                                41.82198,
                                41.43211
                            ],
                            [
                                41.78439,
                                41.46113
                            ],
                            [
                                41.63507,
                                41.48681
                            ],
                            [
                                41.54713,
                                41.52038
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                28.03551,
                                41.98308
                            ],
                            [
                                27.83516,
                                41.95035
                            ],
                            [
                                27.70215,
                                41.9766
                            ],
                            [
                                27.57497,
                                41.93682
                            ],
                            [
                                27.44835,
                                41.96724
                            ],
                            [
                                27.37642,
                                42.04614
                            ],
                            [
                                27.27067,
                                42.10432
                            ],
                            [
                                27.15962,
                                42.06566
                            ],
                            [
                                27.06709,
                                42.09318
                            ],
                            [
                                26.96411,
                                41.99707
                            ],
                            [
                                26.78741,
                                41.9896
                            ],
                            [
                                26.75382,
                                41.95843
                            ],
                            [
                                26.6176,
                                41.96533
                            ],
                            [
                                26.53861,
                                41.82348
                            ],
                            [
                                26.36906,
                                41.82068
                            ],
                            [
                                26.32843,
                                41.73698
                            ],
                            [
                                26.35788,
                                41.7111
                            ],
                            [
                                26.44349,
                                41.68575
                            ],
                            [
                                26.59979,
                                41.59728
                            ],
                            [
                                26.59236,
                                41.52985
                            ],
                            [
                                26.62845,
                                41.34644
                            ],
                            [
                                26.53209,
                                41.34195
                            ],
                            [
                                26.40633,
                                41.25517
                            ],
                            [
                                26.33328,
                                41.25837
                            ],
                            [
                                26.31106,
                                41.18049
                            ],
                            [
                                26.31366,
                                41.07568
                            ],
                            [
                                26.36378,
                                41.01038
                            ],
                            [
                                26.35526,
                                40.9479
                            ],
                            [
                                26.20935,
                                40.86042
                            ],
                            [
                                26.12338,
                                40.74477
                            ],
                            [
                                26.03276,
                                40.73026
                            ],
                            [
                                26.06229,
                                40.63706
                            ],
                            [
                                26.11048,
                                40.59782
                            ],
                            [
                                26.30343,
                                40.5906
                            ],
                            [
                                26.47598,
                                40.6126
                            ],
                            [
                                26.53351,
                                40.59177
                            ],
                            [
                                26.60951,
                                40.63625
                            ],
                            [
                                26.78117,
                                40.65665
                            ],
                            [
                                26.83221,
                                40.58043
                            ],
                            [
                                26.70336,
                                40.51226
                            ],
                            [
                                26.63039,
                                40.50819
                            ],
                            [
                                26.45019,
                                40.4379
                            ],
                            [
                                26.25979,
                                40.34386
                            ],
                            [
                                26.23412,
                                40.28743
                            ],
                            [
                                26.2786,
                                40.25168
                            ],
                            [
                                26.26574,
                                40.18759
                            ],
                            [
                                26.17032,
                                40.05812
                            ],
                            [
                                26.2238,
                                40.05055
                            ],
                            [
                                26.37711,
                                40.14306
                            ],
                            [
                                26.36121,
                                40.20129
                            ],
                            [
                                26.59169,
                                40.32255
                            ],
                            [
                                26.63984,
                                40.39995
                            ],
                            [
                                26.73736,
                                40.47448
                            ],
                            [
                                26.96865,
                                40.55337
                            ],
                            [
                                27.04172,
                                40.59748
                            ],
                            [
                                27.14442,
                                40.61463
                            ],
                            [
                                27.3093,
                                40.70286
                            ],
                            [
                                27.3374,
                                40.75816
                            ],
                            [
                                27.45505,
                                40.84581
                            ],
                            [
                                27.51318,
                                40.97459
                            ],
                            [
                                27.76023,
                                41.01389
                            ],
                            [
                                27.86816,
                                40.96908
                            ],
                            [
                                27.95626,
                                40.9641
                            ],
                            [
                                27.9911,
                                41.01834
                            ],
                            [
                                28.16842,
                                41.07267
                            ],
                            [
                                28.34198,
                                41.05798
                            ],
                            [
                                28.46064,
                                41.0266
                            ],
                            [
                                28.61963,
                                40.96097
                            ],
                            [
                                28.76376,
                                40.98079
                            ],
                            [
                                28.84037,
                                40.95884
                            ],
                            [
                                28.97719,
                                41.00129
                            ],
                            [
                                29.07153,
                                41.12256
                            ],
                            [
                                29.0396,
                                41.1563
                            ],
                            [
                                29.10701,
                                41.20799
                            ],
                            [
                                29.0775,
                                41.25341
                            ],
                            [
                                29.00245,
                                41.24562
                            ],
                            [
                                28.63024,
                                41.35048
                            ],
                            [
                                28.26534,
                                41.5003
                            ],
                            [
                                28.10353,
                                41.62665
                            ],
                            [
                                28.10485,
                                41.66781
                            ],
                            [
                                27.98365,
                                41.82049
                            ],
                            [
                                27.9786,
                                41.8654
                            ],
                            [
                                28.04486,
                                41.91331
                            ],
                            [
                                28.03551,
                                41.98308
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                25.94899,
                                40.23753
                            ],
                            [
                                25.79142,
                                40.21155
                            ],
                            [
                                25.67099,
                                40.15367
                            ],
                            [
                                25.73874,
                                40.09074
                            ],
                            [
                                25.94314,
                                40.12908
                            ],
                            [
                                25.94899,
                                40.23753
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                27.6469,
                                40.6591
                            ],
                            [
                                27.52621,
                                40.64153
                            ],
                            [
                                27.57521,
                                40.57551
                            ],
                            [
                                27.66029,
                                40.59044
                            ],
                            [
                                27.6469,
                                40.6591
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "USA",
                "Country": "United States",
                "Total_3GHG": 17.26,
                "Total_3GHG_timeseries": [
                    0.0005,
                    0.0009,
                    0.0014,
                    0.0019,
                    0.0024,
                    0.0029,
                    0.0035,
                    0.004,
                    0.0046,
                    0.0051,
                    0.0056,
                    0.0062,
                    0.0067,
                    0.0072,
                    0.0078,
                    0.0083,
                    0.0088,
                    0.0094,
                    0.0099,
                    0.0105,
                    0.0112,
                    0.0119,
                    0.0126,
                    0.0134,
                    0.0141,
                    0.0149,
                    0.0157,
                    0.0165,
                    0.0173,
                    0.0181,
                    0.0189,
                    0.0197,
                    0.0206,
                    0.0214,
                    0.0223,
                    0.0231,
                    0.024,
                    0.0249,
                    0.0258,
                    0.0268,
                    0.0278,
                    0.0287,
                    0.0297,
                    0.0307,
                    0.0317,
                    0.0328,
                    0.0338,
                    0.0349,
                    0.036,
                    0.0371,
                    0.0382,
                    0.0394,
                    0.0406,
                    0.0417,
                    0.043,
                    0.0443,
                    0.0456,
                    0.0469,
                    0.0482,
                    0.0496,
                    0.051,
                    0.0523,
                    0.0538,
                    0.0551,
                    0.0564,
                    0.0579,
                    0.0594,
                    0.0609,
                    0.0623,
                    0.0638,
                    0.0651,
                    0.0665,
                    0.0681,
                    0.0695,
                    0.071,
                    0.0725,
                    0.074,
                    0.0755,
                    0.0771,
                    0.0784,
                    0.0796,
                    0.0807,
                    0.0817,
                    0.0829,
                    0.0841,
                    0.0853,
                    0.0866,
                    0.0877,
                    0.0889,
                    0.0903,
                    0.0918,
                    0.0934,
                    0.095,
                    0.0967,
                    0.0984,
                    0.1,
                    0.1017,
                    0.1036,
                    0.1051,
                    0.1068,
                    0.1087,
                    0.1105,
                    0.1123,
                    0.1141,
                    0.1159,
                    0.1179,
                    0.1198,
                    0.1217,
                    0.1236,
                    0.1256,
                    0.1275,
                    0.1295,
                    0.1315,
                    0.1336,
                    0.1358,
                    0.1381,
                    0.1406,
                    0.1432,
                    0.1459,
                    0.1487,
                    0.1515,
                    0.1544,
                    0.1573,
                    0.1602,
                    0.163,
                    0.1658,
                    0.1687,
                    0.1715,
                    0.1744,
                    0.1772,
                    0.18,
                    0.1826,
                    0.185,
                    0.1875,
                    0.19,
                    0.1924,
                    0.1948,
                    0.1973,
                    0.1998,
                    0.2023,
                    0.2047,
                    0.2071,
                    0.2096,
                    0.2122,
                    0.2147,
                    0.2173,
                    0.22,
                    0.2227,
                    0.2253,
                    0.228,
                    0.2306,
                    0.2332,
                    0.2359,
                    0.2386,
                    0.2413,
                    0.244,
                    0.2468,
                    0.2495,
                    0.2519,
                    0.2544,
                    0.2568,
                    0.2591,
                    0.2615,
                    0.2639,
                    0.2662,
                    0.2685,
                    0.2707,
                    0.2732,
                    0.2756,
                    0.2777,
                    0.2801,
                    0.2824
                ],
                "Fossil_3GHG": 20.89,
                "Fossil_3GHG_timeseries": [
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0029,
                    0.0031,
                    0.0032,
                    0.0034,
                    0.0036,
                    0.0038,
                    0.004,
                    0.0042,
                    0.0045,
                    0.0047,
                    0.005,
                    0.0053,
                    0.0055,
                    0.0058,
                    0.0061,
                    0.0064,
                    0.0067,
                    0.007,
                    0.0074,
                    0.0078,
                    0.0082,
                    0.0086,
                    0.0092,
                    0.0097,
                    0.0103,
                    0.0109,
                    0.0116,
                    0.0123,
                    0.013,
                    0.0137,
                    0.0145,
                    0.0153,
                    0.0161,
                    0.0169,
                    0.0177,
                    0.0187,
                    0.0197,
                    0.0207,
                    0.0216,
                    0.0226,
                    0.0234,
                    0.0242,
                    0.0253,
                    0.0263,
                    0.0272,
                    0.0283,
                    0.0293,
                    0.0303,
                    0.0314,
                    0.0323,
                    0.033,
                    0.0335,
                    0.0342,
                    0.0348,
                    0.0356,
                    0.0364,
                    0.0372,
                    0.0379,
                    0.0387,
                    0.0396,
                    0.0406,
                    0.0418,
                    0.043,
                    0.0443,
                    0.0455,
                    0.0467,
                    0.048,
                    0.0494,
                    0.0505,
                    0.0519,
                    0.0535,
                    0.055,
                    0.0565,
                    0.058,
                    0.0597,
                    0.0613,
                    0.063,
                    0.0647,
                    0.0665,
                    0.0682,
                    0.07,
                    0.0718,
                    0.0736,
                    0.0756,
                    0.0777,
                    0.0799,
                    0.0822,
                    0.0845,
                    0.0871,
                    0.0897,
                    0.0924,
                    0.0951,
                    0.098,
                    0.1007,
                    0.1033,
                    0.106,
                    0.1088,
                    0.1116,
                    0.1144,
                    0.1172,
                    0.1198,
                    0.1223,
                    0.1247,
                    0.1272,
                    0.1296,
                    0.132,
                    0.1344,
                    0.1369,
                    0.1394,
                    0.1418,
                    0.1442,
                    0.1467,
                    0.1492,
                    0.1517,
                    0.1543,
                    0.1569,
                    0.1596,
                    0.1623,
                    0.1649,
                    0.1676,
                    0.1702,
                    0.1728,
                    0.1755,
                    0.1782,
                    0.1809,
                    0.1836,
                    0.1863,
                    0.189,
                    0.1913,
                    0.1938,
                    0.1962,
                    0.1985,
                    0.2008,
                    0.2032,
                    0.2055,
                    0.2077,
                    0.21,
                    0.2123,
                    0.2147,
                    0.2167,
                    0.2189,
                    0.2212
                ],
                "Land_3GHG": 10.58,
                "Land_3GHG_timeseries": [
                    0.0004,
                    0.0008,
                    0.0012,
                    0.0017,
                    0.0021,
                    0.0025,
                    0.003,
                    0.0035,
                    0.004,
                    0.0044,
                    0.0049,
                    0.0053,
                    0.0058,
                    0.0062,
                    0.0067,
                    0.0071,
                    0.0076,
                    0.008,
                    0.0085,
                    0.009,
                    0.0096,
                    0.0102,
                    0.0108,
                    0.0114,
                    0.012,
                    0.0127,
                    0.0133,
                    0.014,
                    0.0147,
                    0.0154,
                    0.016,
                    0.0167,
                    0.0173,
                    0.018,
                    0.0187,
                    0.0193,
                    0.02,
                    0.0207,
                    0.0214,
                    0.0221,
                    0.0228,
                    0.0235,
                    0.0242,
                    0.0249,
                    0.0257,
                    0.0264,
                    0.0271,
                    0.0279,
                    0.0286,
                    0.0293,
                    0.03,
                    0.0307,
                    0.0314,
                    0.032,
                    0.0327,
                    0.0334,
                    0.034,
                    0.0346,
                    0.0353,
                    0.0359,
                    0.0365,
                    0.0371,
                    0.0376,
                    0.0382,
                    0.0387,
                    0.0392,
                    0.0397,
                    0.0402,
                    0.0407,
                    0.0412,
                    0.0417,
                    0.0422,
                    0.0427,
                    0.0432,
                    0.0438,
                    0.0443,
                    0.0447,
                    0.0452,
                    0.0457,
                    0.0462,
                    0.0467,
                    0.0471,
                    0.0476,
                    0.048,
                    0.0485,
                    0.049,
                    0.0494,
                    0.0498,
                    0.0503,
                    0.0507,
                    0.0511,
                    0.0516,
                    0.052,
                    0.0524,
                    0.0529,
                    0.0533,
                    0.0537,
                    0.0541,
                    0.0545,
                    0.0549,
                    0.0552,
                    0.0555,
                    0.0558,
                    0.056,
                    0.0563,
                    0.0565,
                    0.0568,
                    0.057,
                    0.0572,
                    0.0574,
                    0.0575,
                    0.0577,
                    0.0579,
                    0.058,
                    0.0581,
                    0.0582,
                    0.0584,
                    0.0587,
                    0.0588,
                    0.059,
                    0.0591,
                    0.0592,
                    0.0594,
                    0.0595,
                    0.0597,
                    0.0598,
                    0.0599,
                    0.06,
                    0.06,
                    0.0601,
                    0.0602,
                    0.0603,
                    0.0603,
                    0.0604,
                    0.0604,
                    0.0604,
                    0.0604,
                    0.0604,
                    0.0604,
                    0.0604,
                    0.0604,
                    0.0604,
                    0.0604,
                    0.0604,
                    0.0604,
                    0.0604,
                    0.0604,
                    0.0604,
                    0.0604,
                    0.0605,
                    0.0605,
                    0.0604,
                    0.0604,
                    0.0604,
                    0.0604,
                    0.0605,
                    0.0605,
                    0.0605,
                    0.0606,
                    0.0606,
                    0.0606,
                    0.0606,
                    0.0607,
                    0.0607,
                    0.0607,
                    0.0607,
                    0.0608,
                    0.0608,
                    0.0609,
                    0.061,
                    0.0611,
                    0.0612
                ],
                "Total_CO2": 20.83,
                "Total_CO2_timeseries": [
                    0.0004,
                    0.0008,
                    0.0011,
                    0.0016,
                    0.002,
                    0.0024,
                    0.0028,
                    0.0033,
                    0.0037,
                    0.0042,
                    0.0046,
                    0.005,
                    0.0054,
                    0.0059,
                    0.0063,
                    0.0067,
                    0.0072,
                    0.0076,
                    0.008,
                    0.0086,
                    0.0091,
                    0.0097,
                    0.0103,
                    0.0109,
                    0.0116,
                    0.0122,
                    0.0129,
                    0.0135,
                    0.0143,
                    0.0149,
                    0.0156,
                    0.0163,
                    0.017,
                    0.0177,
                    0.0184,
                    0.0192,
                    0.0199,
                    0.0207,
                    0.0214,
                    0.0222,
                    0.023,
                    0.0238,
                    0.0247,
                    0.0255,
                    0.0264,
                    0.0272,
                    0.0281,
                    0.029,
                    0.0299,
                    0.0309,
                    0.0318,
                    0.0327,
                    0.0337,
                    0.0347,
                    0.0357,
                    0.0367,
                    0.0378,
                    0.0388,
                    0.0399,
                    0.041,
                    0.042,
                    0.0431,
                    0.0442,
                    0.0452,
                    0.0463,
                    0.0474,
                    0.0485,
                    0.0497,
                    0.0508,
                    0.0519,
                    0.053,
                    0.054,
                    0.0553,
                    0.0564,
                    0.0576,
                    0.0589,
                    0.0601,
                    0.0613,
                    0.0625,
                    0.0637,
                    0.0647,
                    0.0656,
                    0.0666,
                    0.0676,
                    0.0686,
                    0.0697,
                    0.0709,
                    0.0719,
                    0.073,
                    0.0742,
                    0.0754,
                    0.0767,
                    0.0781,
                    0.0795,
                    0.0809,
                    0.0822,
                    0.0836,
                    0.085,
                    0.0863,
                    0.0876,
                    0.089,
                    0.0902,
                    0.0915,
                    0.0927,
                    0.0941,
                    0.0954,
                    0.0967,
                    0.098,
                    0.0993,
                    0.1006,
                    0.1018,
                    0.1032,
                    0.1045,
                    0.1059,
                    0.1074,
                    0.1089,
                    0.1106,
                    0.1124,
                    0.1142,
                    0.1161,
                    0.118,
                    0.1201,
                    0.1222,
                    0.1242,
                    0.1261,
                    0.1282,
                    0.1304,
                    0.1326,
                    0.1348,
                    0.1369,
                    0.139,
                    0.1409,
                    0.1429,
                    0.145,
                    0.147,
                    0.1491,
                    0.1512,
                    0.1535,
                    0.1557,
                    0.158,
                    0.1602,
                    0.1625,
                    0.1649,
                    0.1673,
                    0.1697,
                    0.1722,
                    0.1747,
                    0.1772,
                    0.1798,
                    0.1825,
                    0.1852,
                    0.1878,
                    0.1905,
                    0.1931,
                    0.1959,
                    0.1985,
                    0.2012,
                    0.2038,
                    0.2062,
                    0.2087,
                    0.2112,
                    0.2135,
                    0.2159,
                    0.2183,
                    0.2207,
                    0.223,
                    0.2254,
                    0.2277,
                    0.2301,
                    0.2322,
                    0.2345,
                    0.2368
                ],
                "Fossil_CO2": 24.75,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0021,
                    0.0023,
                    0.0024,
                    0.0026,
                    0.0028,
                    0.003,
                    0.0032,
                    0.0034,
                    0.0037,
                    0.0039,
                    0.0041,
                    0.0044,
                    0.0047,
                    0.005,
                    0.0054,
                    0.0058,
                    0.0062,
                    0.0066,
                    0.0071,
                    0.0076,
                    0.0081,
                    0.0086,
                    0.0092,
                    0.0098,
                    0.0104,
                    0.011,
                    0.0116,
                    0.0122,
                    0.0129,
                    0.0137,
                    0.0145,
                    0.0151,
                    0.0159,
                    0.0166,
                    0.0172,
                    0.0181,
                    0.0188,
                    0.0196,
                    0.0205,
                    0.0213,
                    0.0221,
                    0.023,
                    0.0238,
                    0.0245,
                    0.025,
                    0.0256,
                    0.0263,
                    0.027,
                    0.0277,
                    0.0285,
                    0.0292,
                    0.03,
                    0.0308,
                    0.0317,
                    0.0327,
                    0.0338,
                    0.0349,
                    0.0359,
                    0.0369,
                    0.0381,
                    0.0392,
                    0.0402,
                    0.0413,
                    0.0425,
                    0.0437,
                    0.0448,
                    0.046,
                    0.0472,
                    0.0485,
                    0.0498,
                    0.051,
                    0.0523,
                    0.0536,
                    0.0549,
                    0.0562,
                    0.0576,
                    0.0591,
                    0.0606,
                    0.0622,
                    0.0639,
                    0.0656,
                    0.0675,
                    0.0694,
                    0.0714,
                    0.0734,
                    0.0756,
                    0.0777,
                    0.0797,
                    0.0818,
                    0.084,
                    0.0863,
                    0.0885,
                    0.0907,
                    0.0928,
                    0.0948,
                    0.0968,
                    0.0989,
                    0.101,
                    0.1031,
                    0.1053,
                    0.1075,
                    0.1098,
                    0.1121,
                    0.1144,
                    0.1168,
                    0.1191,
                    0.1215,
                    0.124,
                    0.1265,
                    0.1291,
                    0.1317,
                    0.1343,
                    0.137,
                    0.1396,
                    0.1423,
                    0.145,
                    0.1478,
                    0.1505,
                    0.1533,
                    0.156,
                    0.1587,
                    0.1612,
                    0.1637,
                    0.1662,
                    0.1686,
                    0.1711,
                    0.1736,
                    0.176,
                    0.1784,
                    0.1807,
                    0.1831,
                    0.1855,
                    0.1876,
                    0.1899,
                    0.1922
                ],
                "Land_CO2": 12.34,
                "Land_CO2_timeseries": [
                    0.0004,
                    0.0007,
                    0.0011,
                    0.0015,
                    0.0019,
                    0.0023,
                    0.0027,
                    0.0031,
                    0.0036,
                    0.004,
                    0.0044,
                    0.0048,
                    0.0052,
                    0.0056,
                    0.006,
                    0.0064,
                    0.0068,
                    0.0072,
                    0.0076,
                    0.0081,
                    0.0086,
                    0.0091,
                    0.0097,
                    0.0102,
                    0.0108,
                    0.0114,
                    0.012,
                    0.0126,
                    0.0132,
                    0.0138,
                    0.0144,
                    0.015,
                    0.0156,
                    0.0162,
                    0.0168,
                    0.0174,
                    0.018,
                    0.0186,
                    0.0191,
                    0.0198,
                    0.0204,
                    0.021,
                    0.0217,
                    0.0223,
                    0.0229,
                    0.0236,
                    0.0242,
                    0.0249,
                    0.0255,
                    0.0261,
                    0.0268,
                    0.0273,
                    0.0279,
                    0.0285,
                    0.0291,
                    0.0296,
                    0.0301,
                    0.0307,
                    0.0312,
                    0.0317,
                    0.0322,
                    0.0327,
                    0.0332,
                    0.0336,
                    0.034,
                    0.0344,
                    0.0348,
                    0.0352,
                    0.0356,
                    0.036,
                    0.0364,
                    0.0368,
                    0.0372,
                    0.0376,
                    0.038,
                    0.0384,
                    0.0388,
                    0.0392,
                    0.0395,
                    0.0399,
                    0.0403,
                    0.0406,
                    0.041,
                    0.0413,
                    0.0417,
                    0.042,
                    0.0423,
                    0.0427,
                    0.043,
                    0.0433,
                    0.0437,
                    0.044,
                    0.0443,
                    0.0446,
                    0.0449,
                    0.0452,
                    0.0455,
                    0.0458,
                    0.0461,
                    0.0463,
                    0.0464,
                    0.0466,
                    0.0467,
                    0.0468,
                    0.0469,
                    0.0469,
                    0.047,
                    0.047,
                    0.047,
                    0.047,
                    0.047,
                    0.0469,
                    0.0469,
                    0.0468,
                    0.0467,
                    0.0467,
                    0.0467,
                    0.0467,
                    0.0467,
                    0.0467,
                    0.0467,
                    0.0466,
                    0.0466,
                    0.0465,
                    0.0465,
                    0.0464,
                    0.0464,
                    0.0463,
                    0.0462,
                    0.0462,
                    0.0462,
                    0.0462,
                    0.0461,
                    0.0461,
                    0.0461,
                    0.046,
                    0.046,
                    0.0459,
                    0.0459,
                    0.0458,
                    0.0458,
                    0.0458,
                    0.0457,
                    0.0457,
                    0.0457,
                    0.0456,
                    0.0456,
                    0.0456,
                    0.0456,
                    0.0456,
                    0.0455,
                    0.0455,
                    0.0454,
                    0.0454,
                    0.0453,
                    0.0453,
                    0.0452,
                    0.0452,
                    0.0451,
                    0.045,
                    0.045,
                    0.0449,
                    0.0448,
                    0.0448,
                    0.0447,
                    0.0447,
                    0.0446,
                    0.0446,
                    0.0446,
                    0.0446,
                    0.0446,
                    0.0446
                ],
                "Total_CH4": 8.42,
                "Total_CH4_timeseries": [
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0003,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.005,
                    0.0051,
                    0.0053,
                    0.0055,
                    0.0056,
                    0.0058,
                    0.006,
                    0.0062,
                    0.0065,
                    0.0067,
                    0.0069,
                    0.0072,
                    0.0074,
                    0.0077,
                    0.008,
                    0.0082,
                    0.0085,
                    0.0088,
                    0.0091,
                    0.0094,
                    0.0098,
                    0.01,
                    0.0104,
                    0.0106,
                    0.0108,
                    0.0111,
                    0.0114,
                    0.0117,
                    0.0119,
                    0.0122,
                    0.0124,
                    0.0127,
                    0.0129,
                    0.013,
                    0.0131,
                    0.0132,
                    0.0133,
                    0.0134,
                    0.0135,
                    0.0136,
                    0.0137,
                    0.0138,
                    0.0139,
                    0.0141,
                    0.0144,
                    0.0146,
                    0.0149,
                    0.0151,
                    0.0154,
                    0.0156,
                    0.016,
                    0.0162,
                    0.0165,
                    0.017,
                    0.0174,
                    0.0179,
                    0.0183,
                    0.0189,
                    0.0194,
                    0.0199,
                    0.0204,
                    0.021,
                    0.0216,
                    0.0222,
                    0.0227,
                    0.0233,
                    0.0239,
                    0.0245,
                    0.0252,
                    0.0259,
                    0.0266,
                    0.0274,
                    0.0281,
                    0.0288,
                    0.0296,
                    0.0303,
                    0.031,
                    0.0317,
                    0.0323,
                    0.0329,
                    0.0335,
                    0.034,
                    0.0346,
                    0.0351,
                    0.0356,
                    0.036,
                    0.0363,
                    0.0366,
                    0.0368,
                    0.037,
                    0.0372,
                    0.0373,
                    0.0374,
                    0.0374,
                    0.0375,
                    0.0375,
                    0.0375,
                    0.0375,
                    0.0376,
                    0.0376,
                    0.0376,
                    0.0375,
                    0.0375,
                    0.0373,
                    0.0372,
                    0.0371,
                    0.0369,
                    0.0368,
                    0.0368,
                    0.0367,
                    0.0367,
                    0.0366,
                    0.0364,
                    0.0363,
                    0.0362,
                    0.036,
                    0.0359,
                    0.0357,
                    0.0355,
                    0.0354,
                    0.0353,
                    0.0353,
                    0.0352,
                    0.0351,
                    0.0351
                ],
                "Fossil_CH4": 9.38,
                "Fossil_CH4_timeseries": [
                    0,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0034,
                    0.0035,
                    0.0037,
                    0.0038,
                    0.004,
                    0.0042,
                    0.0043,
                    0.0045,
                    0.0047,
                    0.0049,
                    0.0051,
                    0.0054,
                    0.0056,
                    0.0058,
                    0.006,
                    0.0062,
                    0.0063,
                    0.0065,
                    0.0067,
                    0.0069,
                    0.0071,
                    0.0072,
                    0.0074,
                    0.0075,
                    0.0076,
                    0.0077,
                    0.0076,
                    0.0076,
                    0.0076,
                    0.0077,
                    0.0077,
                    0.0077,
                    0.0077,
                    0.0077,
                    0.0077,
                    0.0079,
                    0.008,
                    0.0081,
                    0.0083,
                    0.0085,
                    0.0086,
                    0.0088,
                    0.009,
                    0.0091,
                    0.0094,
                    0.0097,
                    0.01,
                    0.0104,
                    0.0107,
                    0.0111,
                    0.0114,
                    0.0118,
                    0.0122,
                    0.0126,
                    0.0131,
                    0.0135,
                    0.0139,
                    0.0143,
                    0.0147,
                    0.0152,
                    0.0157,
                    0.0163,
                    0.0169,
                    0.0176,
                    0.0182,
                    0.0188,
                    0.0194,
                    0.02,
                    0.0206,
                    0.0211,
                    0.0217,
                    0.0222,
                    0.0227,
                    0.0232,
                    0.0237,
                    0.0242,
                    0.0246,
                    0.0249,
                    0.0253,
                    0.0256,
                    0.0258,
                    0.026,
                    0.0261,
                    0.0263,
                    0.0264,
                    0.0265,
                    0.0266,
                    0.0266,
                    0.0267,
                    0.0268,
                    0.0269,
                    0.0269,
                    0.027,
                    0.0269,
                    0.0269,
                    0.0268,
                    0.0267,
                    0.0266,
                    0.0265,
                    0.0264,
                    0.0263,
                    0.0262,
                    0.0262,
                    0.026,
                    0.0259,
                    0.0258,
                    0.0256,
                    0.0254,
                    0.0253,
                    0.0251,
                    0.0249,
                    0.0248,
                    0.0246,
                    0.0246,
                    0.0245,
                    0.0244,
                    0.0244
                ],
                "Land_CH4": 6.83,
                "Land_CH4_timeseries": [
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0055,
                    0.0056,
                    0.0057,
                    0.0057,
                    0.0058,
                    0.0059,
                    0.006,
                    0.0061,
                    0.0062,
                    0.0063,
                    0.0064,
                    0.0065,
                    0.0066,
                    0.0067,
                    0.0068,
                    0.0069,
                    0.007,
                    0.0071,
                    0.0072,
                    0.0073,
                    0.0074,
                    0.0075,
                    0.0077,
                    0.0078,
                    0.0079,
                    0.0081,
                    0.0082,
                    0.0084,
                    0.0085,
                    0.0087,
                    0.0089,
                    0.009,
                    0.0092,
                    0.0093,
                    0.0095,
                    0.0096,
                    0.0097,
                    0.0098,
                    0.0099,
                    0.0101,
                    0.0102,
                    0.0103,
                    0.0104,
                    0.0106,
                    0.0107,
                    0.0107,
                    0.0108,
                    0.0109,
                    0.0109,
                    0.011,
                    0.011,
                    0.011,
                    0.011,
                    0.011,
                    0.011,
                    0.011,
                    0.011,
                    0.011,
                    0.011,
                    0.0109,
                    0.0109,
                    0.0108,
                    0.0108,
                    0.0107,
                    0.0107,
                    0.0107,
                    0.0106,
                    0.0106,
                    0.0106,
                    0.0106,
                    0.0105,
                    0.0105,
                    0.0105,
                    0.0104,
                    0.0105,
                    0.0105,
                    0.0105,
                    0.0105,
                    0.0106,
                    0.0106,
                    0.0106,
                    0.0106,
                    0.0106,
                    0.0106,
                    0.0106,
                    0.0106,
                    0.0106,
                    0.0107,
                    0.0107,
                    0.0107,
                    0.0107
                ],
                "Total_N2O": 12.78,
                "Total_N2O_timeseries": [
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0053,
                    0.0054,
                    0.0055,
                    0.0057,
                    0.0058,
                    0.0059,
                    0.006,
                    0.0061,
                    0.0063,
                    0.0064,
                    0.0065,
                    0.0066,
                    0.0067,
                    0.0068,
                    0.0069,
                    0.007,
                    0.0071,
                    0.0072,
                    0.0074,
                    0.0075,
                    0.0076,
                    0.0077,
                    0.0078,
                    0.0079,
                    0.008,
                    0.0082,
                    0.0083,
                    0.0084,
                    0.0085,
                    0.0086,
                    0.0087,
                    0.0089,
                    0.009,
                    0.0091,
                    0.0092,
                    0.0093,
                    0.0094,
                    0.0096,
                    0.0097,
                    0.0098,
                    0.0099,
                    0.01,
                    0.0101,
                    0.0102,
                    0.0103,
                    0.0105,
                    0.0106
                ],
                "Fossil_N2O": 20.42,
                "Fossil_N2O_timeseries": [
                    5.7146e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.004,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0045,
                    0.0045,
                    0.0046,
                    0.0046,
                    0.0047,
                    0.0047
                ],
                "Land_N2O": 9.84,
                "Land_N2O_timeseries": [
                    7.1791e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.004,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0054,
                    0.0055,
                    0.0056,
                    0.0057,
                    0.0057,
                    0.0058,
                    0.0059
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -75.84503,
                                36.32287
                            ],
                            [
                                -75.80763,
                                36.28859
                            ],
                            [
                                -75.74725,
                                36.1397
                            ],
                            [
                                -75.72592,
                                36.00913
                            ],
                            [
                                -75.66138,
                                36.02502
                            ],
                            [
                                -75.71592,
                                36.11067
                            ],
                            [
                                -75.80854,
                                36.32697
                            ],
                            [
                                -75.87804,
                                36.59764
                            ],
                            [
                                -75.94901,
                                36.76231
                            ],
                            [
                                -75.98982,
                                36.90671
                            ],
                            [
                                -76.10401,
                                36.90964
                            ],
                            [
                                -76.27664,
                                36.96553
                            ],
                            [
                                -76.32692,
                                36.91116
                            ],
                            [
                                -76.50912,
                                36.8845
                            ],
                            [
                                -76.49026,
                                36.95388
                            ],
                            [
                                -76.597,
                                37.0311
                            ],
                            [
                                -76.64803,
                                37.03929
                            ],
                            [
                                -76.67458,
                                37.16166
                            ],
                            [
                                -76.74495,
                                37.15176
                            ],
                            [
                                -76.74586,
                                37.21522
                            ],
                            [
                                -76.63886,
                                37.21438
                            ],
                            [
                                -76.61769,
                                37.12305
                            ],
                            [
                                -76.46191,
                                37.02273
                            ],
                            [
                                -76.4094,
                                36.96858
                            ],
                            [
                                -76.30492,
                                37.02456
                            ],
                            [
                                -76.27372,
                                37.08336
                            ],
                            [
                                -76.3062,
                                37.12349
                            ],
                            [
                                -76.41281,
                                37.16909
                            ],
                            [
                                -76.61804,
                                37.30179
                            ],
                            [
                                -76.71667,
                                37.45281
                            ],
                            [
                                -76.50161,
                                37.25161
                            ],
                            [
                                -76.45852,
                                37.30105
                            ],
                            [
                                -76.41987,
                                37.40473
                            ],
                            [
                                -76.30349,
                                37.33045
                            ],
                            [
                                -76.25247,
                                37.38412
                            ],
                            [
                                -76.25399,
                                37.43623
                            ],
                            [
                                -76.36748,
                                37.52062
                            ],
                            [
                                -76.30443,
                                37.55512
                            ],
                            [
                                -76.28539,
                                37.62081
                            ],
                            [
                                -76.31665,
                                37.78634
                            ],
                            [
                                -76.25268,
                                37.83672
                            ],
                            [
                                -76.24271,
                                37.88298
                            ],
                            [
                                -76.34679,
                                37.9467
                            ],
                            [
                                -76.41519,
                                37.96081
                            ],
                            [
                                -76.50943,
                                38.02267
                            ],
                            [
                                -76.62135,
                                38.14786
                            ],
                            [
                                -76.87519,
                                38.17401
                            ],
                            [
                                -76.96703,
                                38.21754
                            ],
                            [
                                -76.96502,
                                38.25721
                            ],
                            [
                                -77.0454,
                                38.31201
                            ],
                            [
                                -77.08461,
                                38.37075
                            ],
                            [
                                -77.24239,
                                38.33237
                            ],
                            [
                                -77.29051,
                                38.34169
                            ],
                            [
                                -77.3237,
                                38.45836
                            ],
                            [
                                -77.20392,
                                38.36333
                            ],
                            [
                                -77.09669,
                                38.40917
                            ],
                            [
                                -77.02968,
                                38.46688
                            ],
                            [
                                -76.97551,
                                38.34776
                            ],
                            [
                                -76.91824,
                                38.29089
                            ],
                            [
                                -76.75084,
                                38.22824
                            ],
                            [
                                -76.67996,
                                38.23747
                            ],
                            [
                                -76.53288,
                                38.18203
                            ],
                            [
                                -76.52396,
                                38.14066
                            ],
                            [
                                -76.43281,
                                38.12964
                            ],
                            [
                                -76.36087,
                                38.06421
                            ],
                            [
                                -76.32525,
                                38.14204
                            ],
                            [
                                -76.41953,
                                38.31344
                            ],
                            [
                                -76.38775,
                                38.38521
                            ],
                            [
                                -76.48854,
                                38.48002
                            ],
                            [
                                -76.51478,
                                38.53262
                            ],
                            [
                                -76.53006,
                                38.71897
                            ],
                            [
                                -76.56063,
                                38.76875
                            ],
                            [
                                -76.49398,
                                38.83537
                            ],
                            [
                                -76.51668,
                                38.92009
                            ],
                            [
                                -76.45735,
                                38.9399
                            ],
                            [
                                -76.41659,
                                38.99995
                            ],
                            [
                                -76.46592,
                                39.05982
                            ],
                            [
                                -76.43507,
                                39.12392
                            ],
                            [
                                -76.50714,
                                39.15164
                            ],
                            [
                                -76.40379,
                                39.23134
                            ],
                            [
                                -76.40567,
                                39.29704
                            ],
                            [
                                -76.30845,
                                39.38189
                            ],
                            [
                                -76.2921,
                                39.3104
                            ],
                            [
                                -76.1071,
                                39.43533
                            ],
                            [
                                -76.12472,
                                39.48666
                            ],
                            [
                                -76.03744,
                                39.56087
                            ],
                            [
                                -75.98171,
                                39.51911
                            ],
                            [
                                -76.04982,
                                39.38589
                            ],
                            [
                                -76.18111,
                                39.31058
                            ],
                            [
                                -76.26945,
                                39.1718
                            ],
                            [
                                -76.23148,
                                39.05922
                            ],
                            [
                                -76.29833,
                                39.03839
                            ],
                            [
                                -76.35935,
                                38.94148
                            ],
                            [
                                -76.24598,
                                38.97016
                            ],
                            [
                                -76.19377,
                                38.89735
                            ],
                            [
                                -76.2225,
                                38.81092
                            ],
                            [
                                -76.30189,
                                38.82104
                            ],
                            [
                                -76.33811,
                                38.75172
                            ],
                            [
                                -76.23613,
                                38.71757
                            ],
                            [
                                -76.20763,
                                38.66858
                            ],
                            [
                                -76.26762,
                                38.60805
                            ],
                            [
                                -76.27193,
                                38.54917
                            ],
                            [
                                -76.32384,
                                38.49336
                            ],
                            [
                                -76.27304,
                                38.38078
                            ],
                            [
                                -76.21379,
                                38.3699
                            ],
                            [
                                -76.08321,
                                38.2747
                            ],
                            [
                                -76.01128,
                                38.30587
                            ],
                            [
                                -75.9513,
                                38.239
                            ],
                            [
                                -75.87548,
                                38.25046
                            ],
                            [
                                -75.85134,
                                38.15111
                            ],
                            [
                                -75.8745,
                                37.92075
                            ],
                            [
                                -75.77956,
                                37.9704
                            ],
                            [
                                -75.68512,
                                37.89355
                            ],
                            [
                                -75.70999,
                                37.79445
                            ],
                            [
                                -75.80072,
                                37.74378
                            ],
                            [
                                -75.88499,
                                37.64785
                            ],
                            [
                                -75.95458,
                                37.50503
                            ],
                            [
                                -76.0215,
                                37.25808
                            ],
                            [
                                -75.97919,
                                37.15779
                            ],
                            [
                                -75.94672,
                                37.14714
                            ],
                            [
                                -75.91013,
                                37.32707
                            ],
                            [
                                -75.79964,
                                37.51611
                            ],
                            [
                                -75.75819,
                                37.52906
                            ],
                            [
                                -75.66053,
                                37.63421
                            ],
                            [
                                -75.49448,
                                37.8677
                            ],
                            [
                                -75.42024,
                                37.91535
                            ],
                            [
                                -75.42861,
                                37.97737
                            ],
                            [
                                -75.29696,
                                38.10589
                            ],
                            [
                                -75.2242,
                                38.25377
                            ],
                            [
                                -75.10012,
                                38.32887
                            ],
                            [
                                -75.13276,
                                38.39043
                            ],
                            [
                                -75.05713,
                                38.49987
                            ],
                            [
                                -75.14315,
                                38.68753
                            ],
                            [
                                -75.07062,
                                38.68942
                            ],
                            [
                                -75.09099,
                                38.7955
                            ],
                            [
                                -75.16263,
                                38.79222
                            ],
                            [
                                -75.30603,
                                38.91928
                            ],
                            [
                                -75.31559,
                                38.97642
                            ],
                            [
                                -75.40132,
                                39.06668
                            ],
                            [
                                -75.40758,
                                39.25913
                            ],
                            [
                                -75.58854,
                                39.4619
                            ],
                            [
                                -75.46581,
                                39.43708
                            ],
                            [
                                -75.37955,
                                39.35641
                            ],
                            [
                                -75.31899,
                                39.34063
                            ],
                            [
                                -75.18143,
                                39.24281
                            ],
                            [
                                -75.1605,
                                39.20202
                            ],
                            [
                                -75.0127,
                                39.2287
                            ],
                            [
                                -74.88473,
                                39.17311
                            ],
                            [
                                -74.89541,
                                39.10596
                            ],
                            [
                                -74.9677,
                                38.93986
                            ],
                            [
                                -74.85782,
                                38.94732
                            ],
                            [
                                -74.7924,
                                38.99847
                            ],
                            [
                                -74.8218,
                                39.04522
                            ],
                            [
                                -74.70858,
                                39.12833
                            ],
                            [
                                -74.70171,
                                39.18779
                            ],
                            [
                                -74.64055,
                                39.21656
                            ],
                            [
                                -74.62857,
                                39.30782
                            ],
                            [
                                -74.41464,
                                39.36501
                            ],
                            [
                                -74.48594,
                                39.40422
                            ],
                            [
                                -74.39874,
                                39.4442
                            ],
                            [
                                -74.38275,
                                39.54346
                            ],
                            [
                                -74.26697,
                                39.61203
                            ],
                            [
                                -74.16728,
                                39.70814
                            ],
                            [
                                -74.19178,
                                39.75003
                            ],
                            [
                                -74.11228,
                                39.92335
                            ],
                            [
                                -74.13968,
                                39.99754
                            ],
                            [
                                -74.05317,
                                40.04013
                            ],
                            [
                                -73.97353,
                                40.33483
                            ],
                            [
                                -73.9921,
                                40.40516
                            ],
                            [
                                -74.1293,
                                40.45268
                            ],
                            [
                                -74.20766,
                                40.44199
                            ],
                            [
                                -74.27544,
                                40.48666
                            ],
                            [
                                -74.10394,
                                40.55532
                            ],
                            [
                                -74.05551,
                                40.59863
                            ],
                            [
                                -74.06953,
                                40.68916
                            ],
                            [
                                -73.97827,
                                40.71589
                            ],
                            [
                                -73.93396,
                                40.78917
                            ],
                            [
                                -73.80553,
                                40.81387
                            ],
                            [
                                -73.81764,
                                40.86458
                            ],
                            [
                                -73.64599,
                                41.00092
                            ],
                            [
                                -73.4371,
                                41.05928
                            ],
                            [
                                -73.35376,
                                41.10632
                            ],
                            [
                                -73.25753,
                                41.12201
                            ],
                            [
                                -73.18633,
                                41.16287
                            ],
                            [
                                -73.132,
                                41.14924
                            ],
                            [
                                -73.05127,
                                41.20978
                            ],
                            [
                                -72.93365,
                                41.26278
                            ],
                            [
                                -72.8941,
                                41.24581
                            ],
                            [
                                -72.761,
                                41.26673
                            ],
                            [
                                -72.44639,
                                41.27704
                            ],
                            [
                                -72.38001,
                                41.26448
                            ],
                            [
                                -72.26848,
                                41.28415
                            ],
                            [
                                -72.17572,
                                41.3236
                            ],
                            [
                                -72.07772,
                                41.33406
                            ],
                            [
                                -72.0079,
                                41.31337
                            ],
                            [
                                -71.88318,
                                41.34002
                            ],
                            [
                                -71.84811,
                                41.31128
                            ],
                            [
                                -71.62999,
                                41.3589
                            ],
                            [
                                -71.48484,
                                41.36746
                            ],
                            [
                                -71.41996,
                                41.48063
                            ],
                            [
                                -71.41558,
                                41.6628
                            ],
                            [
                                -71.36517,
                                41.71516
                            ],
                            [
                                -71.23551,
                                41.70564
                            ],
                            [
                                -71.19277,
                                41.68087
                            ],
                            [
                                -71.21329,
                                41.55075
                            ],
                            [
                                -71.19345,
                                41.46475
                            ],
                            [
                                -71.0918,
                                41.50738
                            ],
                            [
                                -70.9535,
                                41.52562
                            ],
                            [
                                -70.9259,
                                41.60901
                            ],
                            [
                                -70.83601,
                                41.62681
                            ],
                            [
                                -70.71853,
                                41.68332
                            ],
                            [
                                -70.64802,
                                41.64152
                            ],
                            [
                                -70.63442,
                                41.53652
                            ],
                            [
                                -70.46502,
                                41.56926
                            ],
                            [
                                -70.36094,
                                41.62769
                            ],
                            [
                                -70.01502,
                                41.66966
                            ],
                            [
                                -69.93808,
                                41.80443
                            ],
                            [
                                -69.96271,
                                41.89463
                            ],
                            [
                                -70.0201,
                                41.99964
                            ],
                            [
                                -70.06413,
                                41.9279
                            ],
                            [
                                -70.0046,
                                41.89916
                            ],
                            [
                                -70.02666,
                                41.78808
                            ],
                            [
                                -70.33928,
                                41.70544
                            ],
                            [
                                -70.36714,
                                41.73844
                            ],
                            [
                                -70.4984,
                                41.77295
                            ],
                            [
                                -70.54015,
                                41.82143
                            ],
                            [
                                -70.54372,
                                41.92368
                            ],
                            [
                                -70.65056,
                                41.95283
                            ],
                            [
                                -70.67384,
                                42.01228
                            ],
                            [
                                -70.64332,
                                42.0862
                            ],
                            [
                                -70.7328,
                                42.15809
                            ],
                            [
                                -70.76573,
                                42.24649
                            ],
                            [
                                -70.99074,
                                42.26733
                            ],
                            [
                                -71.04166,
                                42.32529
                            ],
                            [
                                -70.97279,
                                42.37227
                            ],
                            [
                                -70.97475,
                                42.44454
                            ],
                            [
                                -70.85497,
                                42.4948
                            ],
                            [
                                -70.86423,
                                42.54628
                            ],
                            [
                                -70.70569,
                                42.57625
                            ],
                            [
                                -70.83203,
                                42.70137
                            ],
                            [
                                -70.79754,
                                42.76267
                            ],
                            [
                                -70.81723,
                                42.82711
                            ],
                            [
                                -70.79229,
                                42.93906
                            ],
                            [
                                -70.66943,
                                43.07611
                            ],
                            [
                                -70.57953,
                                43.22072
                            ],
                            [
                                -70.55514,
                                43.31854
                            ],
                            [
                                -70.46537,
                                43.34424
                            ],
                            [
                                -70.37038,
                                43.43164
                            ],
                            [
                                -70.38338,
                                43.4837
                            ],
                            [
                                -70.33943,
                                43.54091
                            ],
                            [
                                -70.21154,
                                43.55951
                            ],
                            [
                                -70.25212,
                                43.68377
                            ],
                            [
                                -70.18993,
                                43.76797
                            ],
                            [
                                -69.99617,
                                43.86243
                            ],
                            [
                                -69.86083,
                                43.874
                            ],
                            [
                                -69.85373,
                                43.72716
                            ],
                            [
                                -69.72287,
                                43.78555
                            ],
                            [
                                -69.71044,
                                43.84517
                            ],
                            [
                                -69.76505,
                                43.89397
                            ],
                            [
                                -69.67511,
                                43.97758
                            ],
                            [
                                -69.66111,
                                43.84982
                            ],
                            [
                                -69.49992,
                                43.84713
                            ],
                            [
                                -69.40661,
                                44.03108
                            ],
                            [
                                -69.36555,
                                43.98283
                            ],
                            [
                                -69.22789,
                                43.93825
                            ],
                            [
                                -69.16704,
                                44.00109
                            ],
                            [
                                -69.08188,
                                44.04359
                            ],
                            [
                                -69.10363,
                                44.11014
                            ],
                            [
                                -69.05455,
                                44.20955
                            ],
                            [
                                -68.95027,
                                44.34956
                            ],
                            [
                                -68.94656,
                                44.43079
                            ],
                            [
                                -68.86686,
                                44.47486
                            ],
                            [
                                -68.81488,
                                44.42465
                            ],
                            [
                                -68.81976,
                                44.3469
                            ],
                            [
                                -68.75442,
                                44.34033
                            ],
                            [
                                -68.55235,
                                44.24473
                            ],
                            [
                                -68.56479,
                                44.31568
                            ],
                            [
                                -68.53069,
                                44.40272
                            ],
                            [
                                -68.43044,
                                44.40407
                            ],
                            [
                                -68.34274,
                                44.45657
                            ],
                            [
                                -68.2301,
                                44.4692
                            ],
                            [
                                -68.19543,
                                44.51478
                            ],
                            [
                                -68.1042,
                                44.47137
                            ],
                            [
                                -68.10123,
                                44.3849
                            ],
                            [
                                -68.02963,
                                44.36399
                            ],
                            [
                                -67.98473,
                                44.44351
                            ],
                            [
                                -67.85304,
                                44.49052
                            ],
                            [
                                -67.8396,
                                44.5734
                            ],
                            [
                                -67.73835,
                                44.52475
                            ],
                            [
                                -67.57059,
                                44.53409
                            ],
                            [
                                -67.56117,
                                44.60233
                            ],
                            [
                                -67.41757,
                                44.60705
                            ],
                            [
                                -67.36888,
                                44.63152
                            ],
                            [
                                -67.38477,
                                44.69505
                            ],
                            [
                                -67.31242,
                                44.70593
                            ],
                            [
                                -67.29063,
                                44.63481
                            ],
                            [
                                -67.15794,
                                44.66825
                            ],
                            [
                                -66.98166,
                                44.80418
                            ],
                            [
                                -67.02028,
                                44.88266
                            ],
                            [
                                -67.09186,
                                44.86701
                            ],
                            [
                                -67.17821,
                                44.91219
                            ],
                            [
                                -67.05486,
                                44.98348
                            ],
                            [
                                -67.16122,
                                45.15238
                            ],
                            [
                                -67.27016,
                                45.18856
                            ],
                            [
                                -67.34474,
                                45.12729
                            ],
                            [
                                -67.41779,
                                45.18789
                            ],
                            [
                                -67.48228,
                                45.27874
                            ],
                            [
                                -67.4229,
                                45.37529
                            ],
                            [
                                -67.49401,
                                45.47825
                            ],
                            [
                                -67.40765,
                                45.55423
                            ],
                            [
                                -67.64598,
                                45.61643
                            ],
                            [
                                -67.70148,
                                45.65954
                            ],
                            [
                                -67.80411,
                                45.67694
                            ],
                            [
                                -67.81027,
                                45.79246
                            ],
                            [
                                -67.76323,
                                45.81899
                            ],
                            [
                                -67.80807,
                                45.87947
                            ],
                            [
                                -67.78339,
                                45.94168
                            ],
                            [
                                -67.78359,
                                46.48485
                            ],
                            [
                                -67.79107,
                                46.9792
                            ],
                            [
                                -67.78724,
                                47.06428
                            ],
                            [
                                -67.88605,
                                47.10423
                            ],
                            [
                                -67.95619,
                                47.19517
                            ],
                            [
                                -68.13297,
                                47.29558
                            ],
                            [
                                -68.16449,
                                47.32974
                            ],
                            [
                                -68.28995,
                                47.36443
                            ],
                            [
                                -68.38166,
                                47.34498
                            ],
                            [
                                -68.39026,
                                47.28748
                            ],
                            [
                                -68.51159,
                                47.2993
                            ],
                            [
                                -68.62592,
                                47.24324
                            ],
                            [
                                -68.7307,
                                47.23745
                            ],
                            [
                                -68.89612,
                                47.18039
                            ],
                            [
                                -69.0498,
                                47.25418
                            ],
                            [
                                -69.04529,
                                47.42642
                            ],
                            [
                                -69.22549,
                                47.45725
                            ],
                            [
                                -69.81351,
                                46.8734
                            ],
                            [
                                -69.99652,
                                46.68536
                            ],
                            [
                                -70.05683,
                                46.42604
                            ],
                            [
                                -70.21453,
                                46.30116
                            ],
                            [
                                -70.30098,
                                46.19217
                            ],
                            [
                                -70.24513,
                                46.14402
                            ],
                            [
                                -70.31072,
                                46.0213
                            ],
                            [
                                -70.23461,
                                45.93616
                            ],
                            [
                                -70.25936,
                                45.89088
                            ],
                            [
                                -70.40786,
                                45.79549
                            ],
                            [
                                -70.39708,
                                45.71995
                            ],
                            [
                                -70.55202,
                                45.66633
                            ],
                            [
                                -70.66542,
                                45.5792
                            ],
                            [
                                -70.70726,
                                45.48331
                            ],
                            [
                                -70.62942,
                                45.42262
                            ],
                            [
                                -70.71657,
                                45.38994
                            ],
                            [
                                -70.77935,
                                45.42689
                            ],
                            [
                                -70.80944,
                                45.30454
                            ],
                            [
                                -70.87883,
                                45.23469
                            ],
                            [
                                -70.91829,
                                45.31551
                            ],
                            [
                                -71.00743,
                                45.3456
                            ],
                            [
                                -71.09404,
                                45.30347
                            ],
                            [
                                -71.13217,
                                45.25094
                            ],
                            [
                                -71.21413,
                                45.25172
                            ],
                            [
                                -71.29253,
                                45.29973
                            ],
                            [
                                -71.35387,
                                45.27133
                            ],
                            [
                                -71.42095,
                                45.13149
                            ],
                            [
                                -71.51008,
                                45.06894
                            ],
                            [
                                -71.53998,
                                45.00005
                            ],
                            [
                                -72.23205,
                                45.00001
                            ],
                            [
                                -72.90278,
                                45.0
                            ],
                            [
                                -73.97656,
                                45.00054
                            ],
                            [
                                -74.63241,
                                45.00115
                            ],
                            [
                                -74.73025,
                                44.9913
                            ],
                            [
                                -74.83551,
                                45.01418
                            ],
                            [
                                -74.97531,
                                44.98265
                            ],
                            [
                                -75.06491,
                                44.9299
                            ],
                            [
                                -75.28591,
                                44.84774
                            ],
                            [
                                -75.50592,
                                44.70457
                            ],
                            [
                                -75.76656,
                                44.51541
                            ],
                            [
                                -75.82179,
                                44.43208
                            ],
                            [
                                -75.91111,
                                44.369
                            ],
                            [
                                -76.00181,
                                44.34729
                            ],
                            [
                                -76.16188,
                                44.27879
                            ],
                            [
                                -76.16507,
                                44.23962
                            ],
                            [
                                -76.31234,
                                44.19871
                            ],
                            [
                                -76.35322,
                                44.13448
                            ],
                            [
                                -76.43928,
                                44.09338
                            ],
                            [
                                -76.79669,
                                43.63114
                            ],
                            [
                                -77.57146,
                                43.63114
                            ],
                            [
                                -78.69039,
                                43.63114
                            ],
                            [
                                -79.19978,
                                43.44982
                            ],
                            [
                                -79.05592,
                                43.25369
                            ],
                            [
                                -79.04253,
                                43.14355
                            ],
                            [
                                -79.07491,
                                43.07993
                            ],
                            [
                                -79.01383,
                                43.06685
                            ],
                            [
                                -79.01598,
                                42.98439
                            ],
                            [
                                -78.9323,
                                42.95538
                            ],
                            [
                                -78.90581,
                                42.90319
                            ],
                            [
                                -78.93521,
                                42.82927
                            ],
                            [
                                -79.46157,
                                42.62887
                            ],
                            [
                                -80.07975,
                                42.39376
                            ],
                            [
                                -81.24626,
                                42.20719
                            ],
                            [
                                -81.79657,
                                41.95415
                            ],
                            [
                                -81.87195,
                                41.92497
                            ],
                            [
                                -82.39746,
                                41.67686
                            ],
                            [
                                -82.67987,
                                41.67691
                            ],
                            [
                                -83.06801,
                                41.86322
                            ],
                            [
                                -83.14922,
                                42.04044
                            ],
                            [
                                -83.11957,
                                42.12439
                            ],
                            [
                                -83.12576,
                                42.23922
                            ],
                            [
                                -83.06342,
                                42.3168
                            ],
                            [
                                -82.83002,
                                42.37405
                            ],
                            [
                                -82.64388,
                                42.55368
                            ],
                            [
                                -82.58816,
                                42.55213
                            ],
                            [
                                -82.52543,
                                42.60578
                            ],
                            [
                                -82.4677,
                                42.76266
                            ],
                            [
                                -82.48233,
                                42.80954
                            ],
                            [
                                -82.45653,
                                42.92414
                            ],
                            [
                                -82.12317,
                                43.59114
                            ],
                            [
                                -82.31958,
                                44.47163
                            ],
                            [
                                -82.51822,
                                45.33677
                            ],
                            [
                                -83.59543,
                                45.82062
                            ],
                            [
                                -83.43464,
                                45.9979
                            ],
                            [
                                -83.57194,
                                46.10544
                            ],
                            [
                                -83.65539,
                                46.12143
                            ],
                            [
                                -83.76024,
                                46.10303
                            ],
                            [
                                -83.82619,
                                46.11832
                            ],
                            [
                                -83.95538,
                                46.05751
                            ],
                            [
                                -84.00675,
                                46.1495
                            ],
                            [
                                -84.10743,
                                46.24057
                            ],
                            [
                                -84.1458,
                                46.41738
                            ],
                            [
                                -84.1116,
                                46.50359
                            ],
                            [
                                -84.22264,
                                46.53448
                            ],
                            [
                                -84.25539,
                                46.5008
                            ],
                            [
                                -84.42149,
                                46.49947
                            ],
                            [
                                -84.47727,
                                46.4536
                            ],
                            [
                                -84.55728,
                                46.46185
                            ],
                            [
                                -84.76242,
                                46.63467
                            ],
                            [
                                -84.86371,
                                46.88943
                            ],
                            [
                                -85.5895,
                                47.19145
                            ],
                            [
                                -87.11199,
                                47.81769
                            ],
                            [
                                -87.64885,
                                48.02928
                            ],
                            [
                                -88.36729,
                                48.30486
                            ],
                            [
                                -88.68008,
                                48.24414
                            ],
                            [
                                -89.33608,
                                47.97571
                            ],
                            [
                                -89.48578,
                                48.0135
                            ],
                            [
                                -89.57953,
                                47.99764
                            ],
                            [
                                -89.75134,
                                48.023
                            ],
                            [
                                -89.89534,
                                47.98863
                            ],
                            [
                                -89.99216,
                                48.02903
                            ],
                            [
                                -90.02589,
                                48.08559
                            ],
                            [
                                -90.13602,
                                48.11167
                            ],
                            [
                                -90.54988,
                                48.09688
                            ],
                            [
                                -90.58054,
                                48.12291
                            ],
                            [
                                -90.75139,
                                48.0921
                            ],
                            [
                                -90.8346,
                                48.17969
                            ],
                            [
                                -90.84032,
                                48.23946
                            ],
                            [
                                -90.95833,
                                48.22977
                            ],
                            [
                                -91.19995,
                                48.11981
                            ],
                            [
                                -91.24972,
                                48.08458
                            ],
                            [
                                -91.43811,
                                48.05151
                            ],
                            [
                                -91.55797,
                                48.10691
                            ],
                            [
                                -91.70793,
                                48.12103
                            ],
                            [
                                -91.71745,
                                48.19963
                            ],
                            [
                                -91.86222,
                                48.20775
                            ],
                            [
                                -92.00605,
                                48.267
                            ],
                            [
                                -92.00198,
                                48.32041
                            ],
                            [
                                -92.05724,
                                48.35891
                            ],
                            [
                                -92.29778,
                                48.35385
                            ],
                            [
                                -92.3187,
                                48.30381
                            ],
                            [
                                -92.2818,
                                48.2477
                            ],
                            [
                                -92.37606,
                                48.23054
                            ],
                            [
                                -92.51079,
                                48.44799
                            ],
                            [
                                -92.67372,
                                48.44176
                            ],
                            [
                                -92.74711,
                                48.54576
                            ],
                            [
                                -92.92915,
                                48.60626
                            ],
                            [
                                -92.9526,
                                48.63019
                            ],
                            [
                                -93.3508,
                                48.6314
                            ],
                            [
                                -93.46328,
                                48.59196
                            ],
                            [
                                -93.47534,
                                48.54667
                            ],
                            [
                                -93.6806,
                                48.52021
                            ],
                            [
                                -93.79845,
                                48.52413
                            ],
                            [
                                -93.85902,
                                48.63488
                            ],
                            [
                                -94.23516,
                                48.65188
                            ],
                            [
                                -94.29189,
                                48.70843
                            ],
                            [
                                -94.43872,
                                48.69622
                            ],
                            [
                                -94.58995,
                                48.72075
                            ],
                            [
                                -94.68905,
                                48.77718
                            ],
                            [
                                -94.70027,
                                48.89448
                            ],
                            [
                                -94.82058,
                                49.17039
                            ],
                            [
                                -94.83779,
                                49.31971
                            ],
                            [
                                -94.98185,
                                49.36324
                            ],
                            [
                                -95.08123,
                                49.35806
                            ],
                            [
                                -95.16837,
                                49.38336
                            ],
                            [
                                -95.16552,
                                48.99942
                            ],
                            [
                                -96.0729,
                                48.99595
                            ],
                            [
                                -96.70663,
                                48.99839
                            ],
                            [
                                -97.12064,
                                48.99405
                            ],
                            [
                                -98.31402,
                                48.99515
                            ],
                            [
                                -99.772,
                                48.9948
                            ],
                            [
                                -100.32384,
                                48.99281
                            ],
                            [
                                -101.26067,
                                48.9958
                            ],
                            [
                                -102.11605,
                                48.99596
                            ],
                            [
                                -102.71754,
                                48.99261
                            ],
                            [
                                -104.02361,
                                48.9903
                            ],
                            [
                                -104.6577,
                                48.99563
                            ],
                            [
                                -106.03911,
                                48.99464
                            ],
                            [
                                -106.9703,
                                48.99378
                            ],
                            [
                                -108.28253,
                                48.99571
                            ],
                            [
                                -108.85474,
                                48.99896
                            ],
                            [
                                -110.00001,
                                48.99657
                            ],
                            [
                                -110.58365,
                                49.00012
                            ],
                            [
                                -111.91277,
                                48.99669
                            ],
                            [
                                -112.8639,
                                48.99536
                            ],
                            [
                                -114.06876,
                                48.99898
                            ],
                            [
                                -115.04043,
                                48.99845
                            ],
                            [
                                -116.04198,
                                49.00033
                            ],
                            [
                                -117.02686,
                                48.99959
                            ],
                            [
                                -117.78806,
                                49.00279
                            ],
                            [
                                -118.52969,
                                49.00104
                            ],
                            [
                                -119.71965,
                                49.00013
                            ],
                            [
                                -121.09286,
                                48.99937
                            ],
                            [
                                -122.03869,
                                49.00122
                            ],
                            [
                                -122.75708,
                                49.00119
                            ],
                            [
                                -122.81612,
                                48.93875
                            ],
                            [
                                -122.79167,
                                48.89284
                            ],
                            [
                                -122.65015,
                                48.77005
                            ],
                            [
                                -122.53982,
                                48.77592
                            ],
                            [
                                -122.48995,
                                48.74669
                            ],
                            [
                                -122.5085,
                                48.66396
                            ],
                            [
                                -122.42605,
                                48.59778
                            ],
                            [
                                -122.48866,
                                48.55768
                            ],
                            [
                                -122.47481,
                                48.46538
                            ],
                            [
                                -122.51458,
                                48.45522
                            ],
                            [
                                -122.60864,
                                48.52095
                            ],
                            [
                                -122.67058,
                                48.48754
                            ],
                            [
                                -122.64396,
                                48.40797
                            ],
                            [
                                -122.54909,
                                48.44211
                            ],
                            [
                                -122.55322,
                                48.40727
                            ],
                            [
                                -122.41746,
                                48.332
                            ],
                            [
                                -122.46222,
                                48.26814
                            ],
                            [
                                -122.36959,
                                48.21363
                            ],
                            [
                                -122.36186,
                                48.12177
                            ],
                            [
                                -122.22038,
                                47.98258
                            ],
                            [
                                -122.30639,
                                47.94519
                            ],
                            [
                                -122.337,
                                47.85289
                            ],
                            [
                                -122.39234,
                                47.80515
                            ],
                            [
                                -122.37497,
                                47.73068
                            ],
                            [
                                -122.41575,
                                47.57487
                            ],
                            [
                                -122.32685,
                                47.39099
                            ],
                            [
                                -122.33671,
                                47.34346
                            ],
                            [
                                -122.51185,
                                47.30689
                            ],
                            [
                                -122.58401,
                                47.18532
                            ],
                            [
                                -122.68475,
                                47.10044
                            ],
                            [
                                -122.72674,
                                47.09733
                            ],
                            [
                                -122.81921,
                                47.17075
                            ],
                            [
                                -122.92639,
                                47.11499
                            ],
                            [
                                -122.96335,
                                47.1733
                            ],
                            [
                                -122.92178,
                                47.28194
                            ],
                            [
                                -122.82383,
                                47.32434
                            ],
                            [
                                -122.82733,
                                47.24274
                            ],
                            [
                                -122.7929,
                                47.19445
                            ],
                            [
                                -122.66751,
                                47.28567
                            ],
                            [
                                -122.57458,
                                47.26017
                            ],
                            [
                                -122.53123,
                                47.46565
                            ],
                            [
                                -122.55574,
                                47.58592
                            ],
                            [
                                -122.59546,
                                47.59319
                            ],
                            [
                                -122.61422,
                                47.65402
                            ],
                            [
                                -122.55366,
                                47.72984
                            ],
                            [
                                -122.47499,
                                47.75241
                            ],
                            [
                                -122.52996,
                                47.90965
                            ],
                            [
                                -122.67805,
                                47.80216
                            ],
                            [
                                -122.74627,
                                47.72095
                            ],
                            [
                                -122.75471,
                                47.66891
                            ],
                            [
                                -122.9137,
                                47.62089
                            ],
                            [
                                -122.86981,
                                47.80776
                            ],
                            [
                                -122.80378,
                                47.83379
                            ],
                            [
                                -122.68929,
                                47.83383
                            ],
                            [
                                -122.67115,
                                48.02
                            ],
                            [
                                -122.69124,
                                48.09992
                            ],
                            [
                                -122.75703,
                                48.14275
                            ],
                            [
                                -122.91922,
                                48.09418
                            ],
                            [
                                -123.01924,
                                48.08376
                            ],
                            [
                                -123.11341,
                                48.14875
                            ],
                            [
                                -123.24789,
                                48.11632
                            ],
                            [
                                -123.42002,
                                48.11755
                            ],
                            [
                                -123.69554,
                                48.16513
                            ],
                            [
                                -123.85791,
                                48.15526
                            ],
                            [
                                -124.04404,
                                48.1771
                            ],
                            [
                                -124.23854,
                                48.26138
                            ],
                            [
                                -124.39173,
                                48.28789
                            ],
                            [
                                -124.6566,
                                48.38967
                            ],
                            [
                                -124.69201,
                                48.21847
                            ],
                            [
                                -124.72962,
                                48.164
                            ],
                            [
                                -124.69052,
                                48.10233
                            ],
                            [
                                -124.67152,
                                47.96816
                            ],
                            [
                                -124.60773,
                                47.87638
                            ],
                            [
                                -124.49375,
                                47.81826
                            ],
                            [
                                -124.42499,
                                47.73611
                            ],
                            [
                                -124.36477,
                                47.57806
                            ],
                            [
                                -124.32087,
                                47.3653
                            ],
                            [
                                -124.21945,
                                47.24935
                            ],
                            [
                                -124.14875,
                                47.0218
                            ],
                            [
                                -124.03639,
                                47.03138
                            ],
                            [
                                -124.00982,
                                46.98779
                            ],
                            [
                                -123.83873,
                                46.9635
                            ],
                            [
                                -123.98616,
                                46.91909
                            ],
                            [
                                -124.10296,
                                46.8168
                            ],
                            [
                                -124.08245,
                                46.73857
                            ],
                            [
                                -123.98972,
                                46.70488
                            ],
                            [
                                -123.89746,
                                46.7473
                            ],
                            [
                                -123.95284,
                                46.60853
                            ],
                            [
                                -123.89826,
                                46.54642
                            ],
                            [
                                -123.91338,
                                46.45374
                            ],
                            [
                                -123.95706,
                                46.37435
                            ],
                            [
                                -124.01456,
                                46.3867
                            ],
                            [
                                -124.07613,
                                46.29721
                            ],
                            [
                                -123.97547,
                                46.30144
                            ],
                            [
                                -123.87505,
                                46.24431
                            ],
                            [
                                -123.70472,
                                46.30536
                            ],
                            [
                                -123.65851,
                                46.26623
                            ],
                            [
                                -123.49128,
                                46.27258
                            ],
                            [
                                -123.27602,
                                46.13492
                            ],
                            [
                                -123.37481,
                                46.14376
                            ],
                            [
                                -123.48531,
                                46.22753
                            ],
                            [
                                -123.61382,
                                46.18645
                            ],
                            [
                                -123.731,
                                46.17517
                            ],
                            [
                                -123.98812,
                                46.21214
                            ],
                            [
                                -123.92191,
                                46.01294
                            ],
                            [
                                -123.98858,
                                45.94283
                            ],
                            [
                                -123.96373,
                                45.87416
                            ],
                            [
                                -123.97682,
                                45.76702
                            ],
                            [
                                -123.92367,
                                45.68099
                            ],
                            [
                                -123.9539,
                                45.57821
                            ],
                            [
                                -123.88184,
                                45.50042
                            ],
                            [
                                -123.97379,
                                45.48171
                            ],
                            [
                                -123.93613,
                                45.40413
                            ],
                            [
                                -123.96661,
                                45.3143
                            ],
                            [
                                -123.97105,
                                45.16748
                            ],
                            [
                                -124.03216,
                                44.90145
                            ],
                            [
                                -124.07267,
                                44.77388
                            ],
                            [
                                -124.06159,
                                44.66465
                            ],
                            [
                                -124.08282,
                                44.42542
                            ],
                            [
                                -124.15578,
                                43.87753
                            ],
                            [
                                -124.23411,
                                43.55815
                            ],
                            [
                                -124.32567,
                                43.34052
                            ],
                            [
                                -124.3841,
                                43.26836
                            ],
                            [
                                -124.45674,
                                43.00498
                            ],
                            [
                                -124.54952,
                                42.84634
                            ],
                            [
                                -124.51244,
                                42.73799
                            ],
                            [
                                -124.41705,
                                42.65905
                            ],
                            [
                                -124.39257,
                                42.56719
                            ],
                            [
                                -124.43478,
                                42.43828
                            ],
                            [
                                -124.41083,
                                42.25187
                            ],
                            [
                                -124.36378,
                                42.18095
                            ],
                            [
                                -124.35241,
                                42.10595
                            ],
                            [
                                -124.22237,
                                42.00908
                            ],
                            [
                                -124.20021,
                                41.94048
                            ],
                            [
                                -124.25148,
                                41.77975
                            ],
                            [
                                -124.17073,
                                41.74187
                            ],
                            [
                                -124.08279,
                                41.54358
                            ],
                            [
                                -124.0641,
                                41.43965
                            ],
                            [
                                -124.10848,
                                41.22745
                            ],
                            [
                                -124.16256,
                                41.13089
                            ],
                            [
                                -124.11434,
                                41.02809
                            ],
                            [
                                -124.14898,
                                40.86211
                            ],
                            [
                                -124.21838,
                                40.737
                            ],
                            [
                                -124.29284,
                                40.67277
                            ],
                            [
                                -124.38225,
                                40.51754
                            ],
                            [
                                -124.40665,
                                40.43765
                            ],
                            [
                                -124.35037,
                                40.32026
                            ],
                            [
                                -124.35748,
                                40.25616
                            ],
                            [
                                -124.18576,
                                40.13166
                            ],
                            [
                                -124.10628,
                                40.09796
                            ],
                            [
                                -124.04857,
                                40.01946
                            ],
                            [
                                -123.85064,
                                39.82489
                            ],
                            [
                                -123.82934,
                                39.72733
                            ],
                            [
                                -123.79281,
                                39.67964
                            ],
                            [
                                -123.76881,
                                39.55725
                            ],
                            [
                                -123.81377,
                                39.44881
                            ],
                            [
                                -123.82354,
                                39.34998
                            ],
                            [
                                -123.76997,
                                39.19975
                            ],
                            [
                                -123.71924,
                                39.12818
                            ],
                            [
                                -123.69235,
                                39.02251
                            ],
                            [
                                -123.72565,
                                38.92377
                            ],
                            [
                                -123.59835,
                                38.80825
                            ],
                            [
                                -123.45631,
                                38.71083
                            ],
                            [
                                -123.33077,
                                38.56766
                            ],
                            [
                                -123.13479,
                                38.45224
                            ],
                            [
                                -123.06992,
                                38.34034
                            ],
                            [
                                -122.92641,
                                38.21014
                            ],
                            [
                                -123.01309,
                                37.99756
                            ],
                            [
                                -122.90641,
                                38.03898
                            ],
                            [
                                -122.82672,
                                37.99839
                            ],
                            [
                                -122.71962,
                                37.90309
                            ],
                            [
                                -122.66017,
                                37.90365
                            ],
                            [
                                -122.53546,
                                37.82664
                            ],
                            [
                                -122.48313,
                                37.82911
                            ],
                            [
                                -122.45238,
                                37.89325
                            ],
                            [
                                -122.49561,
                                37.9249
                            ],
                            [
                                -122.48797,
                                38.10444
                            ],
                            [
                                -122.4021,
                                38.14539
                            ],
                            [
                                -122.27247,
                                38.07075
                            ],
                            [
                                -122.1256,
                                38.05222
                            ],
                            [
                                -122.05769,
                                38.12897
                            ],
                            [
                                -121.97033,
                                38.07854
                            ],
                            [
                                -121.77836,
                                38.06042
                            ],
                            [
                                -121.80483,
                                38.01711
                            ],
                            [
                                -122.02566,
                                38.05592
                            ],
                            [
                                -122.14974,
                                38.02536
                            ],
                            [
                                -122.2599,
                                38.04853
                            ],
                            [
                                -122.36268,
                                38.00655
                            ],
                            [
                                -122.41196,
                                37.93832
                            ],
                            [
                                -122.32851,
                                37.90534
                            ],
                            [
                                -122.30098,
                                37.83301
                            ],
                            [
                                -122.32622,
                                37.78429
                            ],
                            [
                                -122.24743,
                                37.75434
                            ],
                            [
                                -122.15255,
                                37.63963
                            ],
                            [
                                -122.10647,
                                37.5061
                            ],
                            [
                                -122.11718,
                                37.47092
                            ],
                            [
                                -122.25808,
                                37.56757
                            ],
                            [
                                -122.35237,
                                37.59304
                            ],
                            [
                                -122.38673,
                                37.64045
                            ],
                            [
                                -122.36427,
                                37.72641
                            ],
                            [
                                -122.39052,
                                37.79146
                            ],
                            [
                                -122.46941,
                                37.8064
                            ],
                            [
                                -122.51123,
                                37.77505
                            ],
                            [
                                -122.49493,
                                37.64703
                            ],
                            [
                                -122.51658,
                                37.52824
                            ],
                            [
                                -122.45403,
                                37.48105
                            ],
                            [
                                -122.40368,
                                37.35868
                            ],
                            [
                                -122.40406,
                                37.19999
                            ],
                            [
                                -122.33158,
                                37.11836
                            ],
                            [
                                -122.27512,
                                37.08999
                            ],
                            [
                                -122.15134,
                                36.97817
                            ],
                            [
                                -122.0663,
                                36.95049
                            ],
                            [
                                -121.93007,
                                36.9759
                            ],
                            [
                                -121.86477,
                                36.93381
                            ],
                            [
                                -121.79097,
                                36.7993
                            ],
                            [
                                -121.8128,
                                36.69201
                            ],
                            [
                                -121.86016,
                                36.61317
                            ],
                            [
                                -121.93265,
                                36.63333
                            ],
                            [
                                -121.97145,
                                36.58013
                            ],
                            [
                                -121.90464,
                                36.38946
                            ],
                            [
                                -121.89606,
                                36.30595
                            ],
                            [
                                -121.83641,
                                36.25281
                            ],
                            [
                                -121.72846,
                                36.20041
                            ],
                            [
                                -121.63504,
                                36.12005
                            ],
                            [
                                -121.57271,
                                36.02571
                            ],
                            [
                                -121.50397,
                                35.99892
                            ],
                            [
                                -121.45921,
                                35.88638
                            ],
                            [
                                -121.33341,
                                35.78146
                            ],
                            [
                                -121.28282,
                                35.66837
                            ],
                            [
                                -121.16781,
                                35.63425
                            ],
                            [
                                -121.09613,
                                35.54556
                            ],
                            [
                                -121.00649,
                                35.46573
                            ],
                            [
                                -120.88842,
                                35.43205
                            ],
                            [
                                -120.83427,
                                35.33595
                            ],
                            [
                                -120.89512,
                                35.26473
                            ],
                            [
                                -120.86004,
                                35.21207
                            ],
                            [
                                -120.76488,
                                35.16361
                            ],
                            [
                                -120.65433,
                                35.14795
                            ],
                            [
                                -120.6312,
                                35.09802
                            ],
                            [
                                -120.66791,
                                34.90928
                            ],
                            [
                                -120.61257,
                                34.85669
                            ],
                            [
                                -120.63393,
                                34.75744
                            ],
                            [
                                -120.60334,
                                34.7016
                            ],
                            [
                                -120.64417,
                                34.57822
                            ],
                            [
                                -120.51884,
                                34.52651
                            ],
                            [
                                -120.45869,
                                34.4472
                            ],
                            [
                                -120.2962,
                                34.46906
                            ],
                            [
                                -120.141,
                                34.47252
                            ],
                            [
                                -120.00841,
                                34.45891
                            ],
                            [
                                -119.86867,
                                34.40779
                            ],
                            [
                                -119.79689,
                                34.4169
                            ],
                            [
                                -119.56369,
                                34.4129
                            ],
                            [
                                -119.45985,
                                34.3712
                            ],
                            [
                                -119.28478,
                                34.26977
                            ],
                            [
                                -119.22339,
                                34.155
                            ],
                            [
                                -119.12384,
                                34.10018
                            ],
                            [
                                -118.8066,
                                34.00529
                            ],
                            [
                                -118.7403,
                                34.03119
                            ],
                            [
                                -118.56873,
                                34.04023
                            ],
                            [
                                -118.49219,
                                34.00304
                            ],
                            [
                                -118.39467,
                                33.84392
                            ],
                            [
                                -118.40527,
                                33.74132
                            ],
                            [
                                -118.29153,
                                33.70863
                            ],
                            [
                                -118.2704,
                                33.74195
                            ],
                            [
                                -118.14508,
                                33.75596
                            ],
                            [
                                -118.00579,
                                33.65778
                            ],
                            [
                                -117.78466,
                                33.53878
                            ],
                            [
                                -117.4825,
                                33.30905
                            ],
                            [
                                -117.32651,
                                33.11513
                            ],
                            [
                                -117.27882,
                                33.00317
                            ],
                            [
                                -117.24478,
                                32.78535
                            ],
                            [
                                -117.25608,
                                32.71748
                            ],
                            [
                                -117.17916,
                                32.72241
                            ],
                            [
                                -117.12518,
                                32.6769
                            ],
                            [
                                -117.12358,
                                32.53462
                            ],
                            [
                                -116.25803,
                                32.60013
                            ],
                            [
                                -115.35693,
                                32.66833
                            ],
                            [
                                -114.71719,
                                32.71673
                            ],
                            [
                                -114.73919,
                                32.66575
                            ],
                            [
                                -114.80572,
                                32.61035
                            ],
                            [
                                -114.80514,
                                32.49167
                            ],
                            [
                                -113.99122,
                                32.23883
                            ],
                            [
                                -113.16644,
                                31.98799
                            ],
                            [
                                -112.28707,
                                31.71509
                            ],
                            [
                                -111.66109,
                                31.51658
                            ],
                            [
                                -111.06468,
                                31.32883
                            ],
                            [
                                -110.44012,
                                31.33157
                            ],
                            [
                                -109.9452,
                                31.33218
                            ],
                            [
                                -109.30069,
                                31.33401
                            ],
                            [
                                -108.709,
                                31.33062
                            ],
                            [
                                -108.20823,
                                31.33148
                            ],
                            [
                                -108.20188,
                                31.36112
                            ],
                            [
                                -108.20221,
                                31.78308
                            ],
                            [
                                -107.75588,
                                31.7825
                            ],
                            [
                                -106.52977,
                                31.77816
                            ],
                            [
                                -106.48629,
                                31.74961
                            ],
                            [
                                -106.37955,
                                31.73142
                            ],
                            [
                                -106.27687,
                                31.56535
                            ],
                            [
                                -106.2046,
                                31.47036
                            ],
                            [
                                -106.07293,
                                31.39891
                            ],
                            [
                                -105.95179,
                                31.35983
                            ],
                            [
                                -105.93796,
                                31.3187
                            ],
                            [
                                -105.85232,
                                31.27069
                            ],
                            [
                                -105.76182,
                                31.16847
                            ],
                            [
                                -105.60691,
                                31.08779
                            ],
                            [
                                -105.55414,
                                30.99317
                            ],
                            [
                                -105.40323,
                                30.89154
                            ],
                            [
                                -105.38955,
                                30.85294
                            ],
                            [
                                -105.24684,
                                30.7981
                            ],
                            [
                                -105.20554,
                                30.79935
                            ],
                            [
                                -105.05514,
                                30.684
                            ],
                            [
                                -105.00211,
                                30.67788
                            ],
                            [
                                -104.97349,
                                30.6136
                            ],
                            [
                                -104.92147,
                                30.59686
                            ],
                            [
                                -104.86512,
                                30.48749
                            ],
                            [
                                -104.85281,
                                30.38492
                            ],
                            [
                                -104.70622,
                                30.23454
                            ],
                            [
                                -104.68615,
                                30.1709
                            ],
                            [
                                -104.69915,
                                30.02865
                            ],
                            [
                                -104.67653,
                                29.92526
                            ],
                            [
                                -104.56448,
                                29.77282
                            ],
                            [
                                -104.50772,
                                29.63955
                            ],
                            [
                                -104.3317,
                                29.52118
                            ],
                            [
                                -104.20925,
                                29.47794
                            ],
                            [
                                -104.15912,
                                29.39358
                            ],
                            [
                                -103.97824,
                                29.29592
                            ],
                            [
                                -103.78492,
                                29.25872
                            ],
                            [
                                -103.71776,
                                29.18267
                            ],
                            [
                                -103.55457,
                                29.15112
                            ],
                            [
                                -103.42678,
                                29.04263
                            ],
                            [
                                -103.2443,
                                28.98589
                            ],
                            [
                                -103.11508,
                                28.99105
                            ],
                            [
                                -103.07071,
                                29.08819
                            ],
                            [
                                -102.98673,
                                29.17448
                            ],
                            [
                                -102.8675,
                                29.22001
                            ],
                            [
                                -102.90018,
                                29.25759
                            ],
                            [
                                -102.87834,
                                29.34113
                            ],
                            [
                                -102.81454,
                                29.3977
                            ],
                            [
                                -102.79988,
                                29.51892
                            ],
                            [
                                -102.66993,
                                29.73963
                            ],
                            [
                                -102.54144,
                                29.74612
                            ],
                            [
                                -102.50862,
                                29.77978
                            ],
                            [
                                -102.38579,
                                29.76621
                            ],
                            [
                                -102.3573,
                                29.84469
                            ],
                            [
                                -102.31209,
                                29.87722
                            ],
                            [
                                -102.1758,
                                29.83966
                            ],
                            [
                                -102.06543,
                                29.78589
                            ],
                            [
                                -101.85144,
                                29.80243
                            ],
                            [
                                -101.70635,
                                29.76109
                            ],
                            [
                                -101.45294,
                                29.78209
                            ],
                            [
                                -101.37106,
                                29.69337
                            ],
                            [
                                -101.31225,
                                29.60088
                            ],
                            [
                                -101.24773,
                                29.61688
                            ],
                            [
                                -101.25249,
                                29.52529
                            ],
                            [
                                -101.05666,
                                29.44142
                            ],
                            [
                                -101.00524,
                                29.36212
                            ],
                            [
                                -100.79447,
                                29.24094
                            ],
                            [
                                -100.77061,
                                29.17212
                            ],
                            [
                                -100.66865,
                                29.09216
                            ],
                            [
                                -100.63587,
                                28.94109
                            ],
                            [
                                -100.54394,
                                28.82304
                            ],
                            [
                                -100.50437,
                                28.74033
                            ],
                            [
                                -100.49699,
                                28.66612
                            ],
                            [
                                -100.39661,
                                28.5837
                            ],
                            [
                                -100.40417,
                                28.54742
                            ],
                            [
                                -100.33417,
                                28.43439
                            ],
                            [
                                -100.34177,
                                28.39275
                            ],
                            [
                                -100.28504,
                                28.31267
                            ],
                            [
                                -100.28421,
                                28.27454
                            ],
                            [
                                -100.2002,
                                28.18974
                            ],
                            [
                                -100.08154,
                                28.14271
                            ],
                            [
                                -100.01753,
                                28.06385
                            ],
                            [
                                -99.99297,
                                27.99669
                            ],
                            [
                                -99.93108,
                                27.97441
                            ],
                            [
                                -99.89273,
                                27.8939
                            ],
                            [
                                -99.87317,
                                27.79609
                            ],
                            [
                                -99.76831,
                                27.72507
                            ],
                            [
                                -99.72282,
                                27.66348
                            ],
                            [
                                -99.63955,
                                27.62479
                            ],
                            [
                                -99.59814,
                                27.63414
                            ],
                            [
                                -99.51588,
                                27.56352
                            ],
                            [
                                -99.52631,
                                27.49732
                            ],
                            [
                                -99.4842,
                                27.4815
                            ],
                            [
                                -99.50964,
                                27.33187
                            ],
                            [
                                -99.49734,
                                27.26627
                            ],
                            [
                                -99.44544,
                                27.24528
                            ],
                            [
                                -99.42955,
                                27.16399
                            ],
                            [
                                -99.44981,
                                27.01847
                            ],
                            [
                                -99.38297,
                                26.97678
                            ],
                            [
                                -99.30762,
                                26.86411
                            ],
                            [
                                -99.23562,
                                26.79048
                            ],
                            [
                                -99.19551,
                                26.62759
                            ],
                            [
                                -99.09377,
                                26.47773
                            ],
                            [
                                -99.11108,
                                26.419
                            ],
                            [
                                -99.06117,
                                26.39364
                            ],
                            [
                                -98.92367,
                                26.37574
                            ],
                            [
                                -98.89501,
                                26.35371
                            ],
                            [
                                -98.80548,
                                26.36298
                            ],
                            [
                                -98.75161,
                                26.29153
                            ],
                            [
                                -98.6957,
                                26.28392
                            ],
                            [
                                -98.66365,
                                26.23186
                            ],
                            [
                                -98.59546,
                                26.25463
                            ],
                            [
                                -98.56197,
                                26.2275
                            ],
                            [
                                -98.45215,
                                26.21764
                            ],
                            [
                                -98.3765,
                                26.15133
                            ],
                            [
                                -98.20593,
                                26.05469
                            ],
                            [
                                -98.14074,
                                26.06022
                            ],
                            [
                                -98.04558,
                                26.03558
                            ],
                            [
                                -97.98362,
                                26.0547
                            ],
                            [
                                -97.7998,
                                26.0512
                            ],
                            [
                                -97.73624,
                                26.0215
                            ],
                            [
                                -97.66714,
                                26.02864
                            ],
                            [
                                -97.60687,
                                25.95616
                            ],
                            [
                                -97.42297,
                                25.83814
                            ],
                            [
                                -97.37571,
                                25.90117
                            ],
                            [
                                -97.28521,
                                25.93789
                            ],
                            [
                                -97.14614,
                                25.95613
                            ],
                            [
                                -97.1518,
                                26.05125
                            ],
                            [
                                -97.27126,
                                26.08905
                            ],
                            [
                                -97.30293,
                                26.11781
                            ],
                            [
                                -97.29928,
                                26.19454
                            ],
                            [
                                -97.32937,
                                26.22531
                            ],
                            [
                                -97.38387,
                                26.40376
                            ],
                            [
                                -97.4326,
                                26.40941
                            ],
                            [
                                -97.41966,
                                26.54989
                            ],
                            [
                                -97.43678,
                                26.5731
                            ],
                            [
                                -97.47269,
                                26.7451
                            ],
                            [
                                -97.55707,
                                26.83855
                            ],
                            [
                                -97.55568,
                                26.99209
                            ],
                            [
                                -97.48263,
                                27.00151
                            ],
                            [
                                -97.49651,
                                27.08871
                            ],
                            [
                                -97.46457,
                                27.1015
                            ],
                            [
                                -97.4274,
                                27.25673
                            ],
                            [
                                -97.53856,
                                27.2307
                            ],
                            [
                                -97.62728,
                                27.24543
                            ],
                            [
                                -97.67198,
                                27.2862
                            ],
                            [
                                -97.53568,
                                27.34192
                            ],
                            [
                                -97.40356,
                                27.33457
                            ],
                            [
                                -97.32279,
                                27.5646
                            ],
                            [
                                -97.25745,
                                27.6983
                            ],
                            [
                                -97.37087,
                                27.74544
                            ],
                            [
                                -97.4179,
                                27.82605
                            ],
                            [
                                -97.34089,
                                27.88045
                            ],
                            [
                                -97.17673,
                                27.83315
                            ],
                            [
                                -97.03316,
                                28.04773
                            ],
                            [
                                -97.05257,
                                28.09679
                            ],
                            [
                                -97.13839,
                                28.02524
                            ],
                            [
                                -97.21339,
                                28.07163
                            ],
                            [
                                -97.13138,
                                28.14659
                            ],
                            [
                                -97.03931,
                                28.18651
                            ],
                            [
                                -97.01945,
                                28.14795
                            ],
                            [
                                -96.91353,
                                28.1265
                            ],
                            [
                                -96.79359,
                                28.23403
                            ],
                            [
                                -96.79471,
                                28.35802
                            ],
                            [
                                -96.85566,
                                28.41301
                            ],
                            [
                                -96.71032,
                                28.40164
                            ],
                            [
                                -96.65295,
                                28.32374
                            ],
                            [
                                -96.402,
                                28.44068
                            ],
                            [
                                -96.57477,
                                28.58158
                            ],
                            [
                                -96.65904,
                                28.7124
                            ],
                            [
                                -96.58511,
                                28.71906
                            ],
                            [
                                -96.57278,
                                28.64458
                            ],
                            [
                                -96.2279,
                                28.64284
                            ],
                            [
                                -96.20583,
                                28.58486
                            ],
                            [
                                -96.04334,
                                28.64856
                            ],
                            [
                                -95.99402,
                                28.60261
                            ],
                            [
                                -95.85401,
                                28.64626
                            ],
                            [
                                -95.47759,
                                28.83864
                            ],
                            [
                                -95.39204,
                                28.8687
                            ],
                            [
                                -95.23277,
                                28.99954
                            ],
                            [
                                -95.15573,
                                29.18533
                            ],
                            [
                                -95.09495,
                                29.17944
                            ],
                            [
                                -94.95299,
                                29.29623
                            ],
                            [
                                -94.90458,
                                29.30134
                            ],
                            [
                                -94.89377,
                                29.42789
                            ],
                            [
                                -94.94284,
                                29.4594
                            ],
                            [
                                -95.0141,
                                29.56018
                            ],
                            [
                                -95.00175,
                                29.71435
                            ],
                            [
                                -94.8727,
                                29.67662
                            ],
                            [
                                -94.81623,
                                29.75447
                            ],
                            [
                                -94.73142,
                                29.78377
                            ],
                            [
                                -94.69244,
                                29.68575
                            ],
                            [
                                -94.74158,
                                29.52801
                            ],
                            [
                                -94.5618,
                                29.57163
                            ],
                            [
                                -94.61248,
                                29.46029
                            ],
                            [
                                -94.1535,
                                29.63942
                            ],
                            [
                                -93.97362,
                                29.68156
                            ],
                            [
                                -93.84862,
                                29.6802
                            ],
                            [
                                -93.7781,
                                29.72181
                            ],
                            [
                                -93.64376,
                                29.75087
                            ],
                            [
                                -93.48514,
                                29.76837
                            ],
                            [
                                -93.35412,
                                29.76612
                            ],
                            [
                                -93.34741,
                                29.90045
                            ],
                            [
                                -93.32325,
                                30.00203
                            ],
                            [
                                -93.24255,
                                29.92949
                            ],
                            [
                                -93.24004,
                                29.862
                            ],
                            [
                                -93.34223,
                                29.84015
                            ],
                            [
                                -93.33749,
                                29.76768
                            ],
                            [
                                -93.21162,
                                29.77444
                            ],
                            [
                                -92.9459,
                                29.70732
                            ],
                            [
                                -92.66482,
                                29.59793
                            ],
                            [
                                -92.31615,
                                29.53336
                            ],
                            [
                                -92.2599,
                                29.53963
                            ],
                            [
                                -92.10669,
                                29.61646
                            ],
                            [
                                -92.16621,
                                29.70134
                            ],
                            [
                                -92.10189,
                                29.74908
                            ],
                            [
                                -91.99602,
                                29.79599
                            ],
                            [
                                -91.97212,
                                29.82975
                            ],
                            [
                                -91.835,
                                29.82808
                            ],
                            [
                                -91.85098,
                                29.7123
                            ],
                            [
                                -91.76064,
                                29.74685
                            ],
                            [
                                -91.62069,
                                29.74888
                            ],
                            [
                                -91.63736,
                                29.63741
                            ],
                            [
                                -91.55474,
                                29.63043
                            ],
                            [
                                -91.52999,
                                29.53141
                            ],
                            [
                                -91.43218,
                                29.53491
                            ],
                            [
                                -91.27492,
                                29.47617
                            ],
                            [
                                -91.21816,
                                29.43095
                            ],
                            [
                                -91.19452,
                                29.37505
                            ],
                            [
                                -91.13038,
                                29.33388
                            ],
                            [
                                -91.1254,
                                29.25132
                            ],
                            [
                                -91.1642,
                                29.24013
                            ],
                            [
                                -91.24108,
                                29.36487
                            ],
                            [
                                -91.29453,
                                29.31301
                            ],
                            [
                                -91.27596,
                                29.25005
                            ],
                            [
                                -91.13153,
                                29.22529
                            ],
                            [
                                -90.94505,
                                29.25975
                            ],
                            [
                                -91.00706,
                                29.31164
                            ],
                            [
                                -90.9315,
                                29.33396
                            ],
                            [
                                -90.92804,
                                29.26718
                            ],
                            [
                                -90.78857,
                                29.22163
                            ],
                            [
                                -90.69653,
                                29.21013
                            ],
                            [
                                -90.61876,
                                29.28819
                            ],
                            [
                                -90.61358,
                                29.35006
                            ],
                            [
                                -90.52154,
                                29.45911
                            ],
                            [
                                -90.43509,
                                29.46503
                            ],
                            [
                                -90.34506,
                                29.39872
                            ],
                            [
                                -90.32513,
                                29.33415
                            ],
                            [
                                -90.24374,
                                29.24897
                            ],
                            [
                                -90.20473,
                                29.31704
                            ],
                            [
                                -90.13371,
                                29.32342
                            ],
                            [
                                -90.07389,
                                29.36662
                            ],
                            [
                                -90.05989,
                                29.41762
                            ],
                            [
                                -90.10689,
                                29.45098
                            ],
                            [
                                -90.21056,
                                29.43707
                            ],
                            [
                                -90.22846,
                                29.51065
                            ],
                            [
                                -90.16776,
                                29.57687
                            ],
                            [
                                -90.175,
                                29.68181
                            ],
                            [
                                -90.12011,
                                29.66725
                            ],
                            [
                                -90.12201,
                                29.58456
                            ],
                            [
                                -90.0454,
                                29.50081
                            ],
                            [
                                -89.9972,
                                29.52488
                            ],
                            [
                                -89.88858,
                                29.47252
                            ],
                            [
                                -89.83336,
                                29.42482
                            ],
                            [
                                -89.75998,
                                29.4187
                            ],
                            [
                                -89.70505,
                                29.47009
                            ],
                            [
                                -89.59354,
                                29.36093
                            ],
                            [
                                -89.48489,
                                29.32131
                            ],
                            [
                                -89.39991,
                                29.32179
                            ],
                            [
                                -89.26698,
                                29.19517
                            ],
                            [
                                -89.19466,
                                29.04849
                            ],
                            [
                                -89.06622,
                                29.08402
                            ],
                            [
                                -89.03625,
                                29.13553
                            ],
                            [
                                -89.08405,
                                29.17649
                            ],
                            [
                                -89.14371,
                                29.28481
                            ],
                            [
                                -89.19933,
                                29.33944
                            ],
                            [
                                -89.24732,
                                29.30203
                            ],
                            [
                                -89.29098,
                                29.35357
                            ],
                            [
                                -89.38027,
                                29.33672
                            ],
                            [
                                -89.47974,
                                29.39462
                            ],
                            [
                                -89.56112,
                                29.39487
                            ],
                            [
                                -89.55192,
                                29.45104
                            ],
                            [
                                -89.59354,
                                29.4921
                            ],
                            [
                                -89.68528,
                                29.52192
                            ],
                            [
                                -89.72503,
                                29.59234
                            ],
                            [
                                -89.65502,
                                29.62793
                            ],
                            [
                                -89.65093,
                                29.75934
                            ],
                            [
                                -89.53116,
                                29.74652
                            ],
                            [
                                -89.40671,
                                29.81225
                            ],
                            [
                                -89.34531,
                                29.87585
                            ],
                            [
                                -89.39601,
                                29.95763
                            ],
                            [
                                -89.49636,
                                30.03717
                            ],
                            [
                                -89.57636,
                                29.99152
                            ],
                            [
                                -89.59423,
                                29.88694
                            ],
                            [
                                -89.66018,
                                29.86315
                            ],
                            [
                                -89.84102,
                                29.95203
                            ],
                            [
                                -89.85745,
                                30.00169
                            ],
                            [
                                -89.81383,
                                30.0446
                            ],
                            [
                                -89.71883,
                                30.06674
                            ],
                            [
                                -89.62207,
                                30.15484
                            ],
                            [
                                -89.46829,
                                30.19277
                            ],
                            [
                                -89.41116,
                                30.25791
                            ],
                            [
                                -89.32784,
                                30.30326
                            ],
                            [
                                -89.27422,
                                30.30626
                            ],
                            [
                                -89.00602,
                                30.38564
                            ],
                            [
                                -88.83338,
                                30.403
                            ],
                            [
                                -88.70307,
                                30.34567
                            ],
                            [
                                -88.60272,
                                30.37203
                            ],
                            [
                                -88.4832,
                                30.32206
                            ],
                            [
                                -88.34665,
                                30.40282
                            ],
                            [
                                -88.19328,
                                30.36189
                            ],
                            [
                                -88.10801,
                                30.38121
                            ],
                            [
                                -88.09788,
                                30.51681
                            ],
                            [
                                -88.05492,
                                30.6511
                            ],
                            [
                                -88.00437,
                                30.68132
                            ],
                            [
                                -87.91916,
                                30.63048
                            ],
                            [
                                -87.90376,
                                30.55075
                            ],
                            [
                                -87.93104,
                                30.48503
                            ],
                            [
                                -87.9052,
                                30.4137
                            ],
                            [
                                -87.7691,
                                30.30605
                            ],
                            [
                                -87.77033,
                                30.26422
                            ],
                            [
                                -87.65771,
                                30.25036
                            ],
                            [
                                -87.30691,
                                30.3253
                            ],
                            [
                                -87.17024,
                                30.32584
                            ],
                            [
                                -86.84184,
                                30.38193
                            ],
                            [
                                -86.62104,
                                30.39568
                            ],
                            [
                                -86.41779,
                                30.38038
                            ],
                            [
                                -86.2824,
                                30.3586
                            ],
                            [
                                -86.08814,
                                30.30262
                            ],
                            [
                                -85.95296,
                                30.25075
                            ],
                            [
                                -85.79396,
                                30.16713
                            ],
                            [
                                -85.7011,
                                30.10093
                            ],
                            [
                                -85.56882,
                                30.04318
                            ],
                            [
                                -85.48495,
                                29.96149
                            ],
                            [
                                -85.4047,
                                29.93612
                            ],
                            [
                                -85.31775,
                                29.83411
                            ],
                            [
                                -85.30021,
                                29.68222
                            ],
                            [
                                -85.10803,
                                29.71688
                            ],
                            [
                                -85.02065,
                                29.71114
                            ],
                            [
                                -84.86464,
                                29.74333
                            ],
                            [
                                -84.75742,
                                29.78846
                            ],
                            [
                                -84.52466,
                                29.91226
                            ],
                            [
                                -84.34266,
                                29.94652
                            ],
                            [
                                -84.36631,
                                30.02015
                            ],
                            [
                                -84.33943,
                                30.07348
                            ],
                            [
                                -84.23599,
                                30.09088
                            ],
                            [
                                -84.00221,
                                30.10157
                            ],
                            [
                                -83.98258,
                                30.0764
                            ],
                            [
                                -83.82716,
                                29.98486
                            ],
                            [
                                -83.68299,
                                29.92162
                            ],
                            [
                                -83.58964,
                                29.82072
                            ],
                            [
                                -83.54449,
                                29.73104
                            ],
                            [
                                -83.40537,
                                29.67003
                            ],
                            [
                                -83.39487,
                                29.52014
                            ],
                            [
                                -83.21414,
                                29.4197
                            ],
                            [
                                -83.15097,
                                29.2922
                            ],
                            [
                                -83.09306,
                                29.27368
                            ],
                            [
                                -83.05742,
                                29.18213
                            ],
                            [
                                -83.02354,
                                29.17064
                            ],
                            [
                                -82.80677,
                                29.16363
                            ],
                            [
                                -82.72122,
                                28.95261
                            ],
                            [
                                -82.65338,
                                28.89839
                            ],
                            [
                                -82.7229,
                                28.8476
                            ],
                            [
                                -82.68884,
                                28.81185
                            ],
                            [
                                -82.64365,
                                28.58703
                            ],
                            [
                                -82.68961,
                                28.41966
                            ],
                            [
                                -82.75914,
                                28.22411
                            ],
                            [
                                -82.79264,
                                28.18695
                            ],
                            [
                                -82.77823,
                                28.0737
                            ],
                            [
                                -82.80446,
                                27.96327
                            ],
                            [
                                -82.84969,
                                27.87452
                            ],
                            [
                                -82.77713,
                                27.7756
                            ],
                            [
                                -82.6382,
                                27.71017
                            ],
                            [
                                -82.59959,
                                27.86068
                            ],
                            [
                                -82.71989,
                                27.93982
                            ],
                            [
                                -82.68103,
                                28.00089
                            ],
                            [
                                -82.62078,
                                28.00724
                            ],
                            [
                                -82.53206,
                                27.92475
                            ],
                            [
                                -82.55008,
                                27.85522
                            ],
                            [
                                -82.4898,
                                27.82383
                            ],
                            [
                                -82.48633,
                                27.9175
                            ],
                            [
                                -82.43101,
                                27.91684
                            ],
                            [
                                -82.39222,
                                27.82168
                            ],
                            [
                                -82.47342,
                                27.74374
                            ],
                            [
                                -82.56075,
                                27.63281
                            ],
                            [
                                -82.60146,
                                27.53205
                            ],
                            [
                                -82.64878,
                                27.52092
                            ],
                            [
                                -82.65621,
                                27.44645
                            ],
                            [
                                -82.57332,
                                27.40133
                            ],
                            [
                                -82.54323,
                                27.3265
                            ],
                            [
                                -82.56471,
                                27.27465
                            ],
                            [
                                -82.51871,
                                27.22421
                            ],
                            [
                                -82.4458,
                                27.06398
                            ],
                            [
                                -82.28439,
                                26.84043
                            ],
                            [
                                -82.15151,
                                26.79604
                            ],
                            [
                                -82.18368,
                                26.92997
                            ],
                            [
                                -82.11215,
                                26.9585
                            ],
                            [
                                -82.05699,
                                26.86315
                            ],
                            [
                                -82.05378,
                                26.80219
                            ],
                            [
                                -82.0819,
                                26.68141
                            ],
                            [
                                -82.04714,
                                26.60537
                            ],
                            [
                                -82.05406,
                                26.54794
                            ],
                            [
                                -81.86572,
                                26.37241
                            ],
                            [
                                -81.83185,
                                26.29472
                            ],
                            [
                                -81.7999,
                                26.09135
                            ],
                            [
                                -81.72797,
                                25.96834
                            ],
                            [
                                -81.72617,
                                25.91393
                            ],
                            [
                                -81.56541,
                                25.89344
                            ],
                            [
                                -81.51604,
                                25.84563
                            ],
                            [
                                -81.45078,
                                25.83572
                            ],
                            [
                                -81.36453,
                                25.77055
                            ],
                            [
                                -81.25024,
                                25.63248
                            ],
                            [
                                -81.20668,
                                25.50859
                            ],
                            [
                                -81.16433,
                                25.4728
                            ],
                            [
                                -81.14471,
                                25.32936
                            ],
                            [
                                -81.16877,
                                25.2279
                            ],
                            [
                                -81.08283,
                                25.12139
                            ],
                            [
                                -80.91184,
                                25.14078
                            ],
                            [
                                -80.87276,
                                25.17157
                            ],
                            [
                                -80.79689,
                                25.15737
                            ],
                            [
                                -80.68443,
                                25.16884
                            ],
                            [
                                -80.52119,
                                25.21767
                            ],
                            [
                                -80.44591,
                                25.19189
                            ],
                            [
                                -80.45989,
                                25.153
                            ],
                            [
                                -80.40114,
                                25.10871
                            ],
                            [
                                -80.25975,
                                25.33015
                            ],
                            [
                                -80.35279,
                                25.27783
                            ],
                            [
                                -80.35244,
                                25.20907
                            ],
                            [
                                -80.39447,
                                25.19395
                            ],
                            [
                                -80.42673,
                                25.25788
                            ],
                            [
                                -80.37787,
                                25.29064
                            ],
                            [
                                -80.31053,
                                25.37814
                            ],
                            [
                                -80.33994,
                                25.4898
                            ],
                            [
                                -80.24192,
                                25.72056
                            ],
                            [
                                -80.18899,
                                25.7621
                            ],
                            [
                                -80.16934,
                                25.86614
                            ],
                            [
                                -80.12126,
                                25.90308
                            ],
                            [
                                -80.10962,
                                26.07782
                            ],
                            [
                                -80.04369,
                                26.53914
                            ],
                            [
                                -80.05456,
                                26.81466
                            ],
                            [
                                -80.03903,
                                26.82499
                            ],
                            [
                                -80.09511,
                                27.01997
                            ],
                            [
                                -80.15444,
                                27.15224
                            ],
                            [
                                -80.18707,
                                27.16685
                            ],
                            [
                                -80.31379,
                                27.42428
                            ],
                            [
                                -80.31165,
                                27.52807
                            ],
                            [
                                -80.38499,
                                27.74286
                            ],
                            [
                                -80.5437,
                                28.0413
                            ],
                            [
                                -80.58873,
                                28.17536
                            ],
                            [
                                -80.60668,
                                28.30089
                            ],
                            [
                                -80.6,
                                28.37539
                            ],
                            [
                                -80.527,
                                28.45665
                            ],
                            [
                                -80.57407,
                                28.58154
                            ],
                            [
                                -80.71953,
                                28.77169
                            ],
                            [
                                -80.98421,
                                29.18224
                            ],
                            [
                                -81.16774,
                                29.56451
                            ],
                            [
                                -81.25439,
                                29.78011
                            ],
                            [
                                -81.27428,
                                29.8913
                            ],
                            [
                                -81.31035,
                                29.97566
                            ],
                            [
                                -81.37753,
                                30.24497
                            ],
                            [
                                -81.39633,
                                30.38896
                            ],
                            [
                                -81.53357,
                                30.36062
                            ],
                            [
                                -81.53233,
                                30.42725
                            ],
                            [
                                -81.44909,
                                30.38945
                            ],
                            [
                                -81.49222,
                                30.60658
                            ],
                            [
                                -81.48978,
                                30.64883
                            ],
                            [
                                -81.55826,
                                30.69286
                            ],
                            [
                                -81.50997,
                                30.78031
                            ],
                            [
                                -81.54813,
                                30.84397
                            ],
                            [
                                -81.51958,
                                30.91561
                            ],
                            [
                                -81.56933,
                                31.00973
                            ],
                            [
                                -81.55929,
                                31.14866
                            ],
                            [
                                -81.49311,
                                31.13647
                            ],
                            [
                                -81.43449,
                                31.16759
                            ],
                            [
                                -81.36731,
                                31.14782
                            ],
                            [
                                -81.27483,
                                31.25672
                            ],
                            [
                                -81.28033,
                                31.35606
                            ],
                            [
                                -81.17898,
                                31.51646
                            ],
                            [
                                -81.13229,
                                31.6291
                            ],
                            [
                                -81.13294,
                                31.69228
                            ],
                            [
                                -81.26372,
                                31.75651
                            ],
                            [
                                -81.1986,
                                31.78223
                            ],
                            [
                                -81.15117,
                                31.85215
                            ],
                            [
                                -81.19502,
                                31.94589
                            ],
                            [
                                -81.10838,
                                31.93885
                            ],
                            [
                                -81.01201,
                                32.01676
                            ],
                            [
                                -80.99272,
                                31.98087
                            ],
                            [
                                -80.81604,
                                32.11051
                            ],
                            [
                                -80.73711,
                                32.14776
                            ],
                            [
                                -80.67195,
                                32.2154
                            ],
                            [
                                -80.75917,
                                32.30685
                            ],
                            [
                                -80.54679,
                                32.28151
                            ],
                            [
                                -80.4607,
                                32.32138
                            ],
                            [
                                -80.42993,
                                32.40126
                            ],
                            [
                                -80.48066,
                                32.44665
                            ],
                            [
                                -80.33123,
                                32.4816
                            ],
                            [
                                -80.1923,
                                32.56689
                            ],
                            [
                                -80.0346,
                                32.60887
                            ],
                            [
                                -79.89542,
                                32.67915
                            ],
                            [
                                -79.87975,
                                32.7468
                            ],
                            [
                                -79.73142,
                                32.8055
                            ],
                            [
                                -79.70129,
                                32.85232
                            ],
                            [
                                -79.5855,
                                32.9085
                            ],
                            [
                                -79.61442,
                                32.9554
                            ],
                            [
                                -79.52834,
                                33.03485
                            ],
                            [
                                -79.48607,
                                33.01357
                            ],
                            [
                                -79.36474,
                                33.01498
                            ],
                            [
                                -79.32803,
                                33.08788
                            ],
                            [
                                -79.19324,
                                33.17683
                            ],
                            [
                                -79.13922,
                                33.39494
                            ],
                            [
                                -79.09171,
                                33.47276
                            ],
                            [
                                -78.94702,
                                33.62957
                            ],
                            [
                                -78.83139,
                                33.72924
                            ],
                            [
                                -78.70614,
                                33.80318
                            ],
                            [
                                -78.3819,
                                33.9029
                            ],
                            [
                                -78.24423,
                                33.9162
                            ],
                            [
                                -78.03203,
                                33.88957
                            ],
                            [
                                -77.96204,
                                33.84935
                            ],
                            [
                                -77.86866,
                                34.08645
                            ],
                            [
                                -77.78357,
                                34.22655
                            ],
                            [
                                -77.77455,
                                34.27422
                            ],
                            [
                                -77.67823,
                                34.36602
                            ],
                            [
                                -77.53656,
                                34.45856
                            ],
                            [
                                -77.42109,
                                34.51359
                            ],
                            [
                                -77.42709,
                                34.61658
                            ],
                            [
                                -77.30422,
                                34.55148
                            ],
                            [
                                -77.15231,
                                34.66957
                            ],
                            [
                                -77.02902,
                                34.68545
                            ],
                            [
                                -76.89724,
                                34.72649
                            ],
                            [
                                -76.70173,
                                34.71908
                            ],
                            [
                                -76.68278,
                                34.79834
                            ],
                            [
                                -76.51627,
                                34.75666
                            ],
                            [
                                -76.48931,
                                34.81338
                            ],
                            [
                                -76.35046,
                                34.87458
                            ],
                            [
                                -76.33167,
                                34.9345
                            ],
                            [
                                -76.48626,
                                35.03535
                            ],
                            [
                                -76.53975,
                                35.0077
                            ],
                            [
                                -76.59488,
                                35.07221
                            ],
                            [
                                -76.54011,
                                35.14983
                            ],
                            [
                                -76.53218,
                                35.23128
                            ],
                            [
                                -76.49841,
                                35.28332
                            ],
                            [
                                -76.48096,
                                35.40314
                            ],
                            [
                                -76.39054,
                                35.4254
                            ],
                            [
                                -76.27032,
                                35.34316
                            ],
                            [
                                -76.18058,
                                35.34561
                            ],
                            [
                                -76.08064,
                                35.3918
                            ],
                            [
                                -75.91322,
                                35.5664
                            ],
                            [
                                -75.8555,
                                35.60116
                            ],
                            [
                                -75.80791,
                                35.57548
                            ],
                            [
                                -75.73662,
                                35.631
                            ],
                            [
                                -75.71892,
                                35.69678
                            ],
                            [
                                -75.73054,
                                35.82444
                            ],
                            [
                                -75.78458,
                                35.93293
                            ],
                            [
                                -75.89404,
                                35.93373
                            ],
                            [
                                -75.98158,
                                35.89073
                            ],
                            [
                                -76.00036,
                                35.69556
                            ],
                            [
                                -76.04898,
                                35.74599
                            ],
                            [
                                -76.05821,
                                35.85967
                            ],
                            [
                                -76.01587,
                                35.92172
                            ],
                            [
                                -76.06266,
                                35.98936
                            ],
                            [
                                -76.16304,
                                35.99378
                            ],
                            [
                                -76.37718,
                                35.93345
                            ],
                            [
                                -76.40179,
                                35.97994
                            ],
                            [
                                -76.55016,
                                35.94153
                            ],
                            [
                                -76.66086,
                                35.93298
                            ],
                            [
                                -76.71896,
                                35.96316
                            ],
                            [
                                -76.60744,
                                36.05356
                            ],
                            [
                                -76.57871,
                                36.0134
                            ],
                            [
                                -76.46401,
                                36.0249
                            ],
                            [
                                -76.39515,
                                36.08181
                            ],
                            [
                                -76.23308,
                                36.09954
                            ],
                            [
                                -76.06808,
                                36.14417
                            ],
                            [
                                -76.0056,
                                36.18183
                            ],
                            [
                                -75.91245,
                                36.16217
                            ],
                            [
                                -75.83713,
                                36.0963
                            ],
                            [
                                -75.80205,
                                36.11698
                            ],
                            [
                                -75.92332,
                                36.36027
                            ],
                            [
                                -75.98882,
                                36.40637
                            ],
                            [
                                -76.04854,
                                36.5078
                            ],
                            [
                                -76.0343,
                                36.55156
                            ],
                            [
                                -75.90844,
                                36.49
                            ],
                            [
                                -75.92387,
                                36.56135
                            ],
                            [
                                -75.99093,
                                36.56537
                            ],
                            [
                                -75.99221,
                                36.63804
                            ],
                            [
                                -75.9331,
                                36.70839
                            ],
                            [
                                -75.89185,
                                36.59525
                            ],
                            [
                                -75.86924,
                                36.45489
                            ],
                            [
                                -75.82477,
                                36.34588
                            ],
                            [
                                -75.84503,
                                36.32287
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -140.99226,
                                69.61724
                            ],
                            [
                                -141.19368,
                                69.68204
                            ],
                            [
                                -141.24862,
                                69.63123
                            ],
                            [
                                -141.39889,
                                69.6402
                            ],
                            [
                                -141.48262,
                                69.7042
                            ],
                            [
                                -141.75507,
                                69.78919
                            ],
                            [
                                -141.93446,
                                69.79141
                            ],
                            [
                                -142.10179,
                                69.84469
                            ],
                            [
                                -142.23637,
                                69.8494
                            ],
                            [
                                -142.38273,
                                69.92969
                            ],
                            [
                                -142.7323,
                                70.0378
                            ],
                            [
                                -142.95368,
                                70.05405
                            ],
                            [
                                -143.20999,
                                70.11016
                            ],
                            [
                                -143.6487,
                                70.0736
                            ],
                            [
                                -143.93223,
                                70.06711
                            ],
                            [
                                -144.16854,
                                70.03584
                            ],
                            [
                                -144.4879,
                                70.01613
                            ],
                            [
                                -144.63043,
                                69.96795
                            ],
                            [
                                -144.82625,
                                69.98165
                            ],
                            [
                                -144.95743,
                                69.96048
                            ],
                            [
                                -145.42749,
                                70.03359
                            ],
                            [
                                -145.76853,
                                70.12933
                            ],
                            [
                                -145.89043,
                                70.11808
                            ],
                            [
                                -146.28303,
                                70.1766
                            ],
                            [
                                -146.84665,
                                70.17997
                            ],
                            [
                                -146.9729,
                                70.15182
                            ],
                            [
                                -147.17106,
                                70.15579
                            ],
                            [
                                -147.24298,
                                70.18983
                            ],
                            [
                                -147.68196,
                                70.20133
                            ],
                            [
                                -147.80938,
                                70.24652
                            ],
                            [
                                -148.23593,
                                70.26601
                            ],
                            [
                                -148.48814,
                                70.31765
                            ],
                            [
                                -148.49331,
                                70.3682
                            ],
                            [
                                -148.74662,
                                70.40881
                            ],
                            [
                                -148.88941,
                                70.38847
                            ],
                            [
                                -149.16483,
                                70.48537
                            ],
                            [
                                -149.46407,
                                70.51338
                            ],
                            [
                                -149.76393,
                                70.48938
                            ],
                            [
                                -149.86762,
                                70.5097
                            ],
                            [
                                -150.11621,
                                70.42845
                            ],
                            [
                                -150.39766,
                                70.40568
                            ],
                            [
                                -150.6296,
                                70.41242
                            ],
                            [
                                -150.69414,
                                70.45436
                            ],
                            [
                                -150.9553,
                                70.4569
                            ],
                            [
                                -151.18877,
                                70.40829
                            ],
                            [
                                -151.59898,
                                70.43816
                            ],
                            [
                                -151.89195,
                                70.4336
                            ],
                            [
                                -151.74848,
                                70.53268
                            ],
                            [
                                -151.9774,
                                70.56318
                            ],
                            [
                                -152.25276,
                                70.57185
                            ],
                            [
                                -152.42186,
                                70.60989
                            ],
                            [
                                -152.47708,
                                70.6896
                            ],
                            [
                                -152.38385,
                                70.71593
                            ],
                            [
                                -152.22619,
                                70.82676
                            ],
                            [
                                -152.56696,
                                70.87956
                            ],
                            [
                                -152.92518,
                                70.85213
                            ],
                            [
                                -153.00034,
                                70.88638
                            ],
                            [
                                -153.258,
                                70.91841
                            ],
                            [
                                -153.47341,
                                70.88508
                            ],
                            [
                                -153.89911,
                                70.88226
                            ],
                            [
                                -154.16407,
                                70.77031
                            ],
                            [
                                -154.57194,
                                70.79926
                            ],
                            [
                                -154.77687,
                                70.88606
                            ],
                            [
                                -154.57296,
                                70.98873
                            ],
                            [
                                -154.6292,
                                71.02389
                            ],
                            [
                                -155.02916,
                                71.04459
                            ],
                            [
                                -155.10403,
                                71.12918
                            ],
                            [
                                -155.35967,
                                70.99639
                            ],
                            [
                                -155.5071,
                                70.94142
                            ],
                            [
                                -155.4832,
                                70.86341
                            ],
                            [
                                -155.59712,
                                70.81685
                            ],
                            [
                                -155.87439,
                                70.82816
                            ],
                            [
                                -155.9928,
                                70.87349
                            ],
                            [
                                -155.9879,
                                70.96424
                            ],
                            [
                                -155.7267,
                                70.98551
                            ],
                            [
                                -155.51605,
                                71.07783
                            ],
                            [
                                -155.57083,
                                71.16161
                            ],
                            [
                                -155.79439,
                                71.19356
                            ],
                            [
                                -156.03473,
                                71.20005
                            ],
                            [
                                -156.08564,
                                71.23895
                            ],
                            [
                                -156.39702,
                                71.26582
                            ],
                            [
                                -156.60963,
                                71.34583
                            ],
                            [
                                -156.80737,
                                71.28647
                            ],
                            [
                                -157.24052,
                                71.05336
                            ],
                            [
                                -157.50176,
                                70.94869
                            ],
                            [
                                -157.88596,
                                70.85249
                            ],
                            [
                                -158.13562,
                                70.82133
                            ],
                            [
                                -158.67471,
                                70.78629
                            ],
                            [
                                -158.9574,
                                70.78781
                            ],
                            [
                                -159.11348,
                                70.76
                            ],
                            [
                                -159.40641,
                                70.77349
                            ],
                            [
                                -159.33773,
                                70.84579
                            ],
                            [
                                -159.65373,
                                70.79251
                            ],
                            [
                                -160.51681,
                                70.4443
                            ],
                            [
                                -160.8958,
                                70.33277
                            ],
                            [
                                -161.31211,
                                70.24879
                            ],
                            [
                                -161.61788,
                                70.24294
                            ],
                            [
                                -161.82048,
                                70.1793
                            ],
                            [
                                -161.89472,
                                70.29854
                            ],
                            [
                                -162.15884,
                                70.15282
                            ],
                            [
                                -162.45415,
                                70.04234
                            ],
                            [
                                -162.46756,
                                69.98333
                            ],
                            [
                                -162.94495,
                                69.79086
                            ],
                            [
                                -163.02454,
                                69.72982
                            ],
                            [
                                -163.05988,
                                69.6097
                            ],
                            [
                                -163.02497,
                                69.51205
                            ],
                            [
                                -163.09486,
                                69.37743
                            ],
                            [
                                -163.54581,
                                69.13435
                            ],
                            [
                                -163.91456,
                                68.99966
                            ],
                            [
                                -164.26175,
                                68.92927
                            ],
                            [
                                -165.33428,
                                68.85744
                            ],
                            [
                                -165.62499,
                                68.85215
                            ],
                            [
                                -166.2223,
                                68.87425
                            ],
                            [
                                -166.19102,
                                68.78284
                            ],
                            [
                                -166.24306,
                                68.55573
                            ],
                            [
                                -166.37259,
                                68.40436
                            ],
                            [
                                -166.53942,
                                68.36162
                            ],
                            [
                                -166.473,
                                68.31926
                            ],
                            [
                                -166.21664,
                                68.303
                            ],
                            [
                                -165.88718,
                                68.11394
                            ],
                            [
                                -165.36837,
                                68.03787
                            ],
                            [
                                -164.76832,
                                67.81822
                            ],
                            [
                                -164.42207,
                                67.69671
                            ],
                            [
                                -164.31312,
                                67.69597
                            ],
                            [
                                -164.14899,
                                67.64129
                            ],
                            [
                                -163.86383,
                                67.41027
                            ],
                            [
                                -163.74752,
                                67.21579
                            ],
                            [
                                -163.74239,
                                67.13017
                            ],
                            [
                                -163.64748,
                                67.09809
                            ],
                            [
                                -163.02963,
                                67.03285
                            ],
                            [
                                -162.71349,
                                67.05506
                            ],
                            [
                                -162.48637,
                                66.98773
                            ],
                            [
                                -162.2415,
                                66.99466
                            ],
                            [
                                -161.98119,
                                67.04066
                            ],
                            [
                                -161.81143,
                                67.04615
                            ],
                            [
                                -161.49304,
                                66.96973
                            ],
                            [
                                -161.64167,
                                66.95235
                            ],
                            [
                                -161.78643,
                                66.88841
                            ],
                            [
                                -161.88117,
                                66.71887
                            ],
                            [
                                -161.53516,
                                66.54973
                            ],
                            [
                                -161.25399,
                                66.51693
                            ],
                            [
                                -161.33317,
                                66.47876
                            ],
                            [
                                -161.57667,
                                66.44102
                            ],
                            [
                                -161.90652,
                                66.5454
                            ],
                            [
                                -162.06423,
                                66.64503
                            ],
                            [
                                -162.01507,
                                66.77723
                            ],
                            [
                                -162.11138,
                                66.79592
                            ],
                            [
                                -162.28849,
                                66.9283
                            ],
                            [
                                -162.60255,
                                66.89509
                            ],
                            [
                                -162.61725,
                                66.85196
                            ],
                            [
                                -162.47659,
                                66.73042
                            ],
                            [
                                -162.2482,
                                66.71055
                            ],
                            [
                                -162.09192,
                                66.6069
                            ],
                            [
                                -161.89581,
                                66.52475
                            ],
                            [
                                -161.86902,
                                66.4697
                            ],
                            [
                                -161.91089,
                                66.3493
                            ],
                            [
                                -161.69861,
                                66.39567
                            ],
                            [
                                -161.51246,
                                66.39483
                            ],
                            [
                                -161.10874,
                                66.32494
                            ],
                            [
                                -161.00871,
                                66.242
                            ],
                            [
                                -161.21562,
                                66.2103
                            ],
                            [
                                -161.35146,
                                66.25764
                            ],
                            [
                                -161.54813,
                                66.24135
                            ],
                            [
                                -161.6444,
                                66.14165
                            ],
                            [
                                -161.8238,
                                66.00444
                            ],
                            [
                                -162.03577,
                                66.06875
                            ],
                            [
                                -162.14093,
                                66.07487
                            ],
                            [
                                -162.36626,
                                66.0288
                            ],
                            [
                                -162.45526,
                                66.05835
                            ],
                            [
                                -162.63257,
                                66.0388
                            ],
                            [
                                -162.74801,
                                66.08996
                            ],
                            [
                                -162.95109,
                                66.09118
                            ],
                            [
                                -163.12099,
                                66.05961
                            ],
                            [
                                -163.33438,
                                66.08453
                            ],
                            [
                                -163.62309,
                                66.05855
                            ],
                            [
                                -163.77564,
                                66.08195
                            ],
                            [
                                -163.93241,
                                66.21752
                            ],
                            [
                                -163.83024,
                                66.2698
                            ],
                            [
                                -163.87601,
                                66.32025
                            ],
                            [
                                -163.84621,
                                66.4165
                            ],
                            [
                                -163.76226,
                                66.45666
                            ],
                            [
                                -163.76226,
                                66.53864
                            ],
                            [
                                -163.92411,
                                66.59317
                            ],
                            [
                                -164.43632,
                                66.57727
                            ],
                            [
                                -164.66832,
                                66.54551
                            ],
                            [
                                -164.94415,
                                66.42953
                            ],
                            [
                                -165.13934,
                                66.43294
                            ],
                            [
                                -165.43738,
                                66.40155
                            ],
                            [
                                -165.70197,
                                66.33562
                            ],
                            [
                                -165.86849,
                                66.22349
                            ],
                            [
                                -165.69141,
                                66.20143
                            ],
                            [
                                -165.53641,
                                66.145
                            ],
                            [
                                -165.74104,
                                66.09815
                            ],
                            [
                                -166.04964,
                                66.10806
                            ],
                            [
                                -166.22257,
                                66.17124
                            ],
                            [
                                -166.61144,
                                66.08705
                            ],
                            [
                                -166.78035,
                                66.02593
                            ],
                            [
                                -166.87486,
                                65.92967
                            ],
                            [
                                -167.14289,
                                65.85193
                            ],
                            [
                                -167.28597,
                                65.89654
                            ],
                            [
                                -167.57687,
                                65.79493
                            ],
                            [
                                -167.48767,
                                65.76039
                            ],
                            [
                                -167.58878,
                                65.70808
                            ],
                            [
                                -167.78398,
                                65.70767
                            ],
                            [
                                -168.00416,
                                65.6266
                            ],
                            [
                                -168.05359,
                                65.57234
                            ],
                            [
                                -167.85294,
                                65.54116
                            ],
                            [
                                -167.60221,
                                65.45407
                            ],
                            [
                                -167.39369,
                                65.40212
                            ],
                            [
                                -167.01741,
                                65.38194
                            ],
                            [
                                -166.81685,
                                65.34258
                            ],
                            [
                                -166.51493,
                                65.33455
                            ],
                            [
                                -166.37331,
                                65.2968
                            ],
                            [
                                -166.54497,
                                65.11996
                            ],
                            [
                                -166.85029,
                                65.08935
                            ],
                            [
                                -166.74032,
                                65.05672
                            ],
                            [
                                -166.63978,
                                64.96992
                            ],
                            [
                                -166.42291,
                                64.89254
                            ],
                            [
                                -166.38248,
                                64.81621
                            ],
                            [
                                -166.47371,
                                64.78855
                            ],
                            [
                                -166.47471,
                                64.7323
                            ],
                            [
                                -166.38494,
                                64.6375
                            ],
                            [
                                -166.18979,
                                64.5778
                            ],
                            [
                                -165.65519,
                                64.52664
                            ],
                            [
                                -165.01281,
                                64.43669
                            ],
                            [
                                -164.91517,
                                64.44165
                            ],
                            [
                                -164.75787,
                                64.51163
                            ],
                            [
                                -164.28881,
                                64.56288
                            ],
                            [
                                -163.98663,
                                64.55293
                            ],
                            [
                                -163.86725,
                                64.57303
                            ],
                            [
                                -163.588,
                                64.56144
                            ],
                            [
                                -163.26149,
                                64.47315
                            ],
                            [
                                -163.13831,
                                64.50696
                            ],
                            [
                                -163.35353,
                                64.58674
                            ],
                            [
                                -163.18535,
                                64.64567
                            ],
                            [
                                -162.83709,
                                64.48065
                            ],
                            [
                                -162.80778,
                                64.3498
                            ],
                            [
                                -162.63512,
                                64.38604
                            ],
                            [
                                -162.61228,
                                64.47026
                            ],
                            [
                                -162.54263,
                                64.52961
                            ],
                            [
                                -162.2414,
                                64.61922
                            ],
                            [
                                -162.1773,
                                64.67758
                            ],
                            [
                                -161.92723,
                                64.7013
                            ],
                            [
                                -161.87495,
                                64.74732
                            ],
                            [
                                -161.70344,
                                64.77622
                            ],
                            [
                                -161.42301,
                                64.76191
                            ],
                            [
                                -161.294,
                                64.85199
                            ],
                            [
                                -161.14709,
                                64.90956
                            ],
                            [
                                -160.89662,
                                64.81748
                            ],
                            [
                                -160.78323,
                                64.71406
                            ],
                            [
                                -160.7914,
                                64.62601
                            ],
                            [
                                -160.99848,
                                64.54049
                            ],
                            [
                                -161.02692,
                                64.49987
                            ],
                            [
                                -161.21493,
                                64.49696
                            ],
                            [
                                -161.39329,
                                64.52893
                            ],
                            [
                                -161.47736,
                                64.44474
                            ],
                            [
                                -161.22036,
                                64.36544
                            ],
                            [
                                -160.95541,
                                64.20762
                            ],
                            [
                                -160.94956,
                                64.08242
                            ],
                            [
                                -160.90072,
                                63.99703
                            ],
                            [
                                -160.77641,
                                63.86529
                            ],
                            [
                                -160.76486,
                                63.78626
                            ],
                            [
                                -160.9105,
                                63.65257
                            ],
                            [
                                -161.10537,
                                63.55167
                            ],
                            [
                                -161.13671,
                                63.50818
                            ],
                            [
                                -161.292,
                                63.47327
                            ],
                            [
                                -161.57781,
                                63.44852
                            ],
                            [
                                -161.68075,
                                63.46396
                            ],
                            [
                                -162.10918,
                                63.42942
                            ],
                            [
                                -162.05694,
                                63.48836
                            ],
                            [
                                -162.16828,
                                63.52724
                            ],
                            [
                                -162.37516,
                                63.43997
                            ],
                            [
                                -162.43633,
                                63.37941
                            ],
                            [
                                -162.66647,
                                63.22705
                            ],
                            [
                                -162.82844,
                                63.20207
                            ],
                            [
                                -162.85341,
                                63.15173
                            ],
                            [
                                -163.0438,
                                63.06286
                            ],
                            [
                                -163.31619,
                                63.03621
                            ],
                            [
                                -163.63526,
                                63.14656
                            ],
                            [
                                -163.73098,
                                63.20596
                            ],
                            [
                                -164.041,
                                63.2598
                            ],
                            [
                                -164.3263,
                                63.23897
                            ],
                            [
                                -164.57022,
                                63.13857
                            ],
                            [
                                -164.55918,
                                63.06293
                            ],
                            [
                                -164.71782,
                                63.00265
                            ],
                            [
                                -164.79227,
                                62.93812
                            ],
                            [
                                -164.85879,
                                62.82173
                            ],
                            [
                                -164.8616,
                                62.73974
                            ],
                            [
                                -164.77393,
                                62.59602
                            ],
                            [
                                -164.95998,
                                62.52826
                            ],
                            [
                                -165.03023,
                                62.53978
                            ],
                            [
                                -165.19907,
                                62.47363
                            ],
                            [
                                -165.74429,
                                62.07894
                            ],
                            [
                                -165.75536,
                                61.98854
                            ],
                            [
                                -165.61923,
                                61.84761
                            ],
                            [
                                -166.09768,
                                61.81101
                            ],
                            [
                                -166.0088,
                                61.72268
                            ],
                            [
                                -165.78494,
                                61.67587
                            ],
                            [
                                -166.0844,
                                61.63139
                            ],
                            [
                                -166.18417,
                                61.60135
                            ],
                            [
                                -166.14682,
                                61.51291
                            ],
                            [
                                -165.89775,
                                61.54713
                            ],
                            [
                                -165.7524,
                                61.47626
                            ],
                            [
                                -165.91841,
                                61.38885
                            ],
                            [
                                -165.88167,
                                61.33241
                            ],
                            [
                                -165.65001,
                                61.2917
                            ],
                            [
                                -165.59639,
                                61.11036
                            ],
                            [
                                -165.37254,
                                61.08433
                            ],
                            [
                                -165.32563,
                                61.16767
                            ],
                            [
                                -165.18278,
                                61.14391
                            ],
                            [
                                -165.11714,
                                61.0785
                            ],
                            [
                                -165.00469,
                                61.05747
                            ],
                            [
                                -165.19155,
                                60.97516
                            ],
                            [
                                -165.13769,
                                60.92332
                            ],
                            [
                                -165.03981,
                                60.90912
                            ],
                            [
                                -164.95802,
                                60.94476
                            ],
                            [
                                -164.72057,
                                60.92723
                            ],
                            [
                                -164.58782,
                                60.93482
                            ],
                            [
                                -164.53997,
                                60.84999
                            ],
                            [
                                -164.096,
                                60.87614
                            ],
                            [
                                -164.13828,
                                60.92219
                            ],
                            [
                                -164.00652,
                                61.00686
                            ],
                            [
                                -163.87441,
                                60.92636
                            ],
                            [
                                -163.56714,
                                60.91755
                            ],
                            [
                                -163.5562,
                                60.81605
                            ],
                            [
                                -163.414,
                                60.72569
                            ],
                            [
                                -163.45223,
                                60.67406
                            ],
                            [
                                -163.61302,
                                60.59997
                            ],
                            [
                                -163.7724,
                                60.57625
                            ],
                            [
                                -163.81656,
                                60.62474
                            ],
                            [
                                -163.77426,
                                60.73426
                            ],
                            [
                                -163.91567,
                                60.78576
                            ],
                            [
                                -164.02609,
                                60.76236
                            ],
                            [
                                -164.12234,
                                60.66473
                            ],
                            [
                                -164.19043,
                                60.65761
                            ],
                            [
                                -164.26385,
                                60.73263
                            ],
                            [
                                -164.25557,
                                60.77672
                            ],
                            [
                                -164.43828,
                                60.81978
                            ],
                            [
                                -164.67198,
                                60.81992
                            ],
                            [
                                -164.74816,
                                60.89424
                            ],
                            [
                                -164.866,
                                60.83018
                            ],
                            [
                                -165.03278,
                                60.78475
                            ],
                            [
                                -164.97062,
                                60.72536
                            ],
                            [
                                -165.01522,
                                60.69067
                            ],
                            [
                                -165.37605,
                                60.57802
                            ],
                            [
                                -165.37161,
                                60.50951
                            ],
                            [
                                -165.19187,
                                60.49902
                            ],
                            [
                                -165.05909,
                                60.54364
                            ],
                            [
                                -164.99998,
                                60.4768
                            ],
                            [
                                -165.1297,
                                60.43511
                            ],
                            [
                                -164.89564,
                                60.3157
                            ],
                            [
                                -164.66966,
                                60.3036
                            ],
                            [
                                -164.64114,
                                60.24756
                            ],
                            [
                                -164.44491,
                                60.17047
                            ],
                            [
                                -164.23061,
                                60.17279
                            ],
                            [
                                -164.05169,
                                60.29161
                            ],
                            [
                                -163.88304,
                                60.31398
                            ],
                            [
                                -163.95117,
                                60.37971
                            ],
                            [
                                -163.85354,
                                60.43791
                            ],
                            [
                                -163.75298,
                                60.39029
                            ],
                            [
                                -163.52036,
                                60.35767
                            ],
                            [
                                -163.59443,
                                60.3009
                            ],
                            [
                                -163.60654,
                                60.22013
                            ],
                            [
                                -163.74587,
                                60.15411
                            ],
                            [
                                -163.85337,
                                60.20997
                            ],
                            [
                                -163.7748,
                                60.27267
                            ],
                            [
                                -164.06115,
                                60.2615
                            ],
                            [
                                -164.12084,
                                60.18954
                            ],
                            [
                                -164.24638,
                                60.16168
                            ],
                            [
                                -164.47029,
                                60.14443
                            ],
                            [
                                -164.33924,
                                60.05754
                            ],
                            [
                                -164.12364,
                                59.98545
                            ],
                            [
                                -164.22023,
                                59.94332
                            ],
                            [
                                -164.11146,
                                59.83402
                            ],
                            [
                                -163.86985,
                                59.79878
                            ],
                            [
                                -163.44613,
                                59.80859
                            ],
                            [
                                -163.19825,
                                59.83994
                            ],
                            [
                                -162.77766,
                                59.94572
                            ],
                            [
                                -162.70659,
                                59.98931
                            ],
                            [
                                -162.55993,
                                59.97922
                            ],
                            [
                                -162.48054,
                                60.03387
                            ],
                            [
                                -162.49832,
                                60.12538
                            ],
                            [
                                -162.46532,
                                60.19561
                            ],
                            [
                                -162.57603,
                                60.25341
                            ],
                            [
                                -162.55008,
                                60.31318
                            ],
                            [
                                -162.41174,
                                60.41121
                            ],
                            [
                                -162.25754,
                                60.61304
                            ],
                            [
                                -162.22148,
                                60.51481
                            ],
                            [
                                -162.29512,
                                60.45625
                            ],
                            [
                                -162.32196,
                                60.37374
                            ],
                            [
                                -162.45232,
                                60.29297
                            ],
                            [
                                -162.3337,
                                60.22093
                            ],
                            [
                                -162.37146,
                                60.16755
                            ],
                            [
                                -162.10122,
                                59.94076
                            ],
                            [
                                -162.09109,
                                59.89042
                            ],
                            [
                                -161.97134,
                                59.79967
                            ],
                            [
                                -161.88301,
                                59.70084
                            ],
                            [
                                -161.86187,
                                59.63404
                            ],
                            [
                                -161.70639,
                                59.50152
                            ],
                            [
                                -161.95636,
                                59.36664
                            ],
                            [
                                -161.95214,
                                59.26045
                            ],
                            [
                                -162.03,
                                59.22889
                            ],
                            [
                                -161.89097,
                                59.07769
                            ],
                            [
                                -161.81629,
                                59.11674
                            ],
                            [
                                -161.62859,
                                59.12961
                            ],
                            [
                                -161.59747,
                                59.07341
                            ],
                            [
                                -161.7995,
                                59.01625
                            ],
                            [
                                -161.75464,
                                58.81587
                            ],
                            [
                                -161.91473,
                                58.63304
                            ],
                            [
                                -161.63095,
                                58.59837
                            ],
                            [
                                -161.37817,
                                58.67045
                            ],
                            [
                                -161.26947,
                                58.7837
                            ],
                            [
                                -161.1852,
                                58.78429
                            ],
                            [
                                -160.96096,
                                58.87449
                            ],
                            [
                                -160.77367,
                                58.88988
                            ],
                            [
                                -160.66719,
                                58.9498
                            ],
                            [
                                -160.35897,
                                59.07026
                            ],
                            [
                                -160.25751,
                                58.98886
                            ],
                            [
                                -160.32179,
                                58.95397
                            ],
                            [
                                -160.15471,
                                58.91546
                            ],
                            [
                                -160.1553,
                                58.86418
                            ],
                            [
                                -160.00549,
                                58.87674
                            ],
                            [
                                -159.91598,
                                58.78401
                            ],
                            [
                                -159.80258,
                                58.80182
                            ],
                            [
                                -159.73229,
                                58.91098
                            ],
                            [
                                -159.60825,
                                58.93694
                            ],
                            [
                                -159.54685,
                                58.84442
                            ],
                            [
                                -159.38964,
                                58.75783
                            ],
                            [
                                -159.0592,
                                58.4277
                            ],
                            [
                                -158.92592,
                                58.39808
                            ],
                            [
                                -158.7884,
                                58.42002
                            ],
                            [
                                -158.75481,
                                58.50402
                            ],
                            [
                                -158.8759,
                                58.7107
                            ],
                            [
                                -158.80618,
                                58.73525
                            ],
                            [
                                -158.76576,
                                58.86477
                            ],
                            [
                                -158.61892,
                                58.91286
                            ],
                            [
                                -158.53602,
                                58.99338
                            ],
                            [
                                -158.4786,
                                58.99697
                            ],
                            [
                                -158.53286,
                                58.79113
                            ],
                            [
                                -158.34863,
                                58.72426
                            ],
                            [
                                -158.3314,
                                58.66758
                            ],
                            [
                                -158.21358,
                                58.61694
                            ],
                            [
                                -158.06408,
                                58.62838
                            ],
                            [
                                -157.56113,
                                58.75482
                            ],
                            [
                                -157.32453,
                                58.83323
                            ],
                            [
                                -157.07786,
                                58.87589
                            ],
                            [
                                -156.997,
                                58.81824
                            ],
                            [
                                -157.06173,
                                58.7692
                            ],
                            [
                                -157.05334,
                                58.71442
                            ],
                            [
                                -157.26571,
                                58.61233
                            ],
                            [
                                -157.34096,
                                58.54506
                            ],
                            [
                                -157.46539,
                                58.4919
                            ],
                            [
                                -157.53089,
                                58.39511
                            ],
                            [
                                -157.53649,
                                58.27553
                            ],
                            [
                                -157.4402,
                                58.20963
                            ],
                            [
                                -157.53375,
                                58.16768
                            ],
                            [
                                -157.58611,
                                58.10649
                            ],
                            [
                                -157.65119,
                                57.81129
                            ],
                            [
                                -157.70217,
                                57.71382
                            ],
                            [
                                -157.69114,
                                57.61473
                            ],
                            [
                                -157.59931,
                                57.60126
                            ],
                            [
                                -157.57217,
                                57.52894
                            ],
                            [
                                -157.64627,
                                57.49432
                            ],
                            [
                                -157.70759,
                                57.56197
                            ],
                            [
                                -157.92432,
                                57.47385
                            ],
                            [
                                -158.0606,
                                57.38202
                            ],
                            [
                                -158.03583,
                                57.33849
                            ],
                            [
                                -158.1927,
                                57.332
                            ],
                            [
                                -158.42861,
                                57.2107
                            ],
                            [
                                -158.64001,
                                57.03643
                            ],
                            [
                                -158.68451,
                                56.97714
                            ],
                            [
                                -158.64794,
                                56.7961
                            ],
                            [
                                -158.78077,
                                56.7861
                            ],
                            [
                                -158.9177,
                                56.81781
                            ],
                            [
                                -159.02066,
                                56.81246
                            ],
                            [
                                -159.19329,
                                56.74876
                            ],
                            [
                                -159.32633,
                                56.67096
                            ],
                            [
                                -159.50975,
                                56.63416
                            ],
                            [
                                -159.81616,
                                56.54521
                            ],
                            [
                                -159.9529,
                                56.46729
                            ],
                            [
                                -160.14654,
                                56.39863
                            ],
                            [
                                -160.37486,
                                56.25554
                            ],
                            [
                                -160.49619,
                                56.06655
                            ],
                            [
                                -160.56894,
                                56.00215
                            ],
                            [
                                -160.51366,
                                55.94492
                            ],
                            [
                                -160.3226,
                                55.86352
                            ],
                            [
                                -160.27998,
                                55.76726
                            ],
                            [
                                -160.47125,
                                55.79641
                            ],
                            [
                                -160.49817,
                                55.86105
                            ],
                            [
                                -160.6559,
                                55.85892
                            ],
                            [
                                -160.75872,
                                55.88107
                            ],
                            [
                                -160.75194,
                                55.77989
                            ],
                            [
                                -160.80434,
                                55.7339
                            ],
                            [
                                -160.94895,
                                55.82079
                            ],
                            [
                                -161.0549,
                                55.94591
                            ],
                            [
                                -161.41497,
                                55.96118
                            ],
                            [
                                -161.67253,
                                55.90659
                            ],
                            [
                                -161.79938,
                                55.89292
                            ],
                            [
                                -161.94031,
                                55.81676
                            ],
                            [
                                -162.05768,
                                55.78662
                            ],
                            [
                                -162.27612,
                                55.67909
                            ],
                            [
                                -162.52187,
                                55.48897
                            ],
                            [
                                -162.49839,
                                55.39151
                            ],
                            [
                                -162.55042,
                                55.35272
                            ],
                            [
                                -162.65512,
                                55.37085
                            ],
                            [
                                -162.78716,
                                55.31283
                            ],
                            [
                                -162.88807,
                                55.23845
                            ],
                            [
                                -162.86898,
                                55.18231
                            ],
                            [
                                -162.95565,
                                55.16374
                            ],
                            [
                                -163.10039,
                                55.18323
                            ],
                            [
                                -163.29459,
                                55.11494
                            ],
                            [
                                -163.29232,
                                54.97214
                            ],
                            [
                                -163.34473,
                                54.92986
                            ],
                            [
                                -163.32218,
                                54.87897
                            ],
                            [
                                -163.22517,
                                54.84074
                            ],
                            [
                                -163.03507,
                                54.94533
                            ],
                            [
                                -163.21802,
                                55.03504
                            ],
                            [
                                -163.1989,
                                55.12585
                            ],
                            [
                                -163.10959,
                                55.12353
                            ],
                            [
                                -163.00688,
                                55.07995
                            ],
                            [
                                -162.96365,
                                55.00029
                            ],
                            [
                                -162.87616,
                                54.93329
                            ],
                            [
                                -162.77377,
                                54.93616
                            ],
                            [
                                -162.69602,
                                54.99423
                            ],
                            [
                                -162.57065,
                                55.01835
                            ],
                            [
                                -162.62597,
                                55.1058
                            ],
                            [
                                -162.62904,
                                55.17912
                            ],
                            [
                                -162.72632,
                                55.22219
                            ],
                            [
                                -162.63936,
                                55.30382
                            ],
                            [
                                -162.51814,
                                55.25136
                            ],
                            [
                                -162.46082,
                                55.12267
                            ],
                            [
                                -162.49121,
                                55.06521
                            ],
                            [
                                -162.41317,
                                55.03371
                            ],
                            [
                                -162.22326,
                                55.02711
                            ],
                            [
                                -162.22529,
                                55.10554
                            ],
                            [
                                -162.17218,
                                55.15301
                            ],
                            [
                                -162.05545,
                                55.07499
                            ],
                            [
                                -161.96224,
                                55.10663
                            ],
                            [
                                -161.92022,
                                55.20941
                            ],
                            [
                                -161.68875,
                                55.41176
                            ],
                            [
                                -161.71628,
                                55.51814
                            ],
                            [
                                -161.58814,
                                55.61911
                            ],
                            [
                                -161.45743,
                                55.6334
                            ],
                            [
                                -161.36322,
                                55.58606
                            ],
                            [
                                -161.4754,
                                55.48156
                            ],
                            [
                                -161.51414,
                                55.38121
                            ],
                            [
                                -161.45654,
                                55.35889
                            ],
                            [
                                -161.34199,
                                55.38324
                            ],
                            [
                                -161.23789,
                                55.35841
                            ],
                            [
                                -160.99969,
                                55.43985
                            ],
                            [
                                -160.90477,
                                55.52495
                            ],
                            [
                                -160.76348,
                                55.45919
                            ],
                            [
                                -160.66894,
                                55.46276
                            ],
                            [
                                -160.64986,
                                55.54976
                            ],
                            [
                                -160.5356,
                                55.47696
                            ],
                            [
                                -160.46033,
                                55.51029
                            ],
                            [
                                -160.45292,
                                55.57468
                            ],
                            [
                                -160.29327,
                                55.64026
                            ],
                            [
                                -160.13701,
                                55.66454
                            ],
                            [
                                -160.04514,
                                55.7699
                            ],
                            [
                                -159.85491,
                                55.84255
                            ],
                            [
                                -159.72833,
                                55.84987
                            ],
                            [
                                -159.62985,
                                55.79806
                            ],
                            [
                                -159.67549,
                                55.74128
                            ],
                            [
                                -159.60842,
                                55.64258
                            ],
                            [
                                -159.47165,
                                55.83129
                            ],
                            [
                                -159.26591,
                                55.89463
                            ],
                            [
                                -158.93652,
                                55.93591
                            ],
                            [
                                -158.81241,
                                55.99324
                            ],
                            [
                                -158.5955,
                                56.04944
                            ],
                            [
                                -158.30077,
                                56.18258
                            ],
                            [
                                -158.35964,
                                56.21814
                            ],
                            [
                                -158.20157,
                                56.28576
                            ],
                            [
                                -158.46817,
                                56.34112
                            ],
                            [
                                -158.50322,
                                56.3775
                            ],
                            [
                                -158.33764,
                                56.47944
                            ],
                            [
                                -158.13182,
                                56.46357
                            ],
                            [
                                -158.13418,
                                56.52043
                            ],
                            [
                                -157.86538,
                                56.47466
                            ],
                            [
                                -157.83707,
                                56.56288
                            ],
                            [
                                -157.91387,
                                56.57248
                            ],
                            [
                                -158.12255,
                                56.55356
                            ],
                            [
                                -157.92295,
                                56.64042
                            ],
                            [
                                -157.73811,
                                56.67536
                            ],
                            [
                                -157.67411,
                                56.61129
                            ],
                            [
                                -157.46154,
                                56.62804
                            ],
                            [
                                -157.57844,
                                56.69832
                            ],
                            [
                                -157.4692,
                                56.83495
                            ],
                            [
                                -157.38193,
                                56.86124
                            ],
                            [
                                -157.19782,
                                56.76752
                            ],
                            [
                                -157.1502,
                                56.82635
                            ],
                            [
                                -157.07672,
                                56.82663
                            ],
                            [
                                -157.01324,
                                56.9041
                            ],
                            [
                                -156.88847,
                                56.96298
                            ],
                            [
                                -156.82747,
                                56.8997
                            ],
                            [
                                -156.72035,
                                57.03785
                            ],
                            [
                                -156.63957,
                                56.99503
                            ],
                            [
                                -156.555,
                                57.00972
                            ],
                            [
                                -156.45255,
                                57.08406
                            ],
                            [
                                -156.46071,
                                57.12503
                            ],
                            [
                                -156.33442,
                                57.17623
                            ],
                            [
                                -156.35439,
                                57.32331
                            ],
                            [
                                -156.55018,
                                57.29039
                            ],
                            [
                                -156.32538,
                                57.42309
                            ],
                            [
                                -156.0883,
                                57.43792
                            ],
                            [
                                -156.01228,
                                57.56721
                            ],
                            [
                                -155.93455,
                                57.53535
                            ],
                            [
                                -155.73478,
                                57.63421
                            ],
                            [
                                -155.60023,
                                57.66032
                            ],
                            [
                                -155.63287,
                                57.70793
                            ],
                            [
                                -155.61209,
                                57.78805
                            ],
                            [
                                -155.36514,
                                57.71543
                            ],
                            [
                                -155.30619,
                                57.72721
                            ],
                            [
                                -155.33539,
                                57.82258
                            ],
                            [
                                -155.08152,
                                57.87708
                            ],
                            [
                                -155.11266,
                                57.9413
                            ],
                            [
                                -154.96164,
                                58.02464
                            ],
                            [
                                -154.7773,
                                58.00267
                            ],
                            [
                                -154.71799,
                                58.04968
                            ],
                            [
                                -154.57342,
                                58.02403
                            ],
                            [
                                -154.55599,
                                58.09399
                            ],
                            [
                                -154.3684,
                                58.09838
                            ],
                            [
                                -154.22042,
                                58.14236
                            ],
                            [
                                -154.11048,
                                58.27978
                            ],
                            [
                                -154.15453,
                                58.31483
                            ],
                            [
                                -154.05224,
                                58.35666
                            ],
                            [
                                -154.08325,
                                58.48569
                            ],
                            [
                                -153.92924,
                                58.4985
                            ],
                            [
                                -153.89405,
                                58.60624
                            ],
                            [
                                -153.77048,
                                58.60324
                            ],
                            [
                                -153.59757,
                                58.63604
                            ],
                            [
                                -153.55205,
                                58.68773
                            ],
                            [
                                -153.42763,
                                58.72114
                            ],
                            [
                                -153.38685,
                                58.76263
                            ],
                            [
                                -153.3272,
                                58.91464
                            ],
                            [
                                -153.48412,
                                58.99659
                            ],
                            [
                                -153.60898,
                                59.00362
                            ],
                            [
                                -153.7069,
                                59.07292
                            ],
                            [
                                -153.85334,
                                59.05587
                            ],
                            [
                                -154.00831,
                                59.07444
                            ],
                            [
                                -154.12445,
                                59.03093
                            ],
                            [
                                -154.18995,
                                59.04824
                            ],
                            [
                                -154.18565,
                                59.12294
                            ],
                            [
                                -154.23204,
                                59.16551
                            ],
                            [
                                -154.12754,
                                59.19995
                            ],
                            [
                                -154.12858,
                                59.36165
                            ],
                            [
                                -153.70729,
                                59.46607
                            ],
                            [
                                -153.7869,
                                59.5332
                            ],
                            [
                                -153.58764,
                                59.55552
                            ],
                            [
                                -153.55978,
                                59.62806
                            ],
                            [
                                -153.21254,
                                59.6382
                            ],
                            [
                                -153.05167,
                                59.69682
                            ],
                            [
                                -153.00379,
                                59.82625
                            ],
                            [
                                -153.13988,
                                59.81013
                            ],
                            [
                                -153.19763,
                                59.85684
                            ],
                            [
                                -153.00774,
                                59.88565
                            ],
                            [
                                -152.81586,
                                59.87829
                            ],
                            [
                                -152.6942,
                                59.93326
                            ],
                            [
                                -152.57868,
                                60.04741
                            ],
                            [
                                -152.68201,
                                60.1646
                            ],
                            [
                                -152.81661,
                                60.20323
                            ],
                            [
                                -152.66896,
                                60.2431
                            ],
                            [
                                -152.55814,
                                60.22403
                            ],
                            [
                                -152.39447,
                                60.30371
                            ],
                            [
                                -152.30686,
                                60.41722
                            ],
                            [
                                -152.33207,
                                60.47
                            ],
                            [
                                -152.24206,
                                60.54962
                            ],
                            [
                                -152.10347,
                                60.59376
                            ],
                            [
                                -152.04769,
                                60.65851
                            ],
                            [
                                -151.85409,
                                60.73475
                            ],
                            [
                                -151.70865,
                                60.73566
                            ],
                            [
                                -151.78742,
                                60.8201
                            ],
                            [
                                -151.78081,
                                60.87056
                            ],
                            [
                                -151.49367,
                                61.01022
                            ],
                            [
                                -151.35135,
                                61.01057
                            ],
                            [
                                -151.16749,
                                61.04679
                            ],
                            [
                                -151.00524,
                                61.18608
                            ],
                            [
                                -150.66567,
                                61.27333
                            ],
                            [
                                -150.5397,
                                61.27521
                            ],
                            [
                                -150.43864,
                                61.24442
                            ],
                            [
                                -149.92964,
                                61.26029
                            ],
                            [
                                -149.88172,
                                61.38121
                            ],
                            [
                                -149.64712,
                                61.48541
                            ],
                            [
                                -149.52942,
                                61.49852
                            ],
                            [
                                -149.42927,
                                61.44383
                            ],
                            [
                                -149.71792,
                                61.37151
                            ],
                            [
                                -149.89707,
                                61.22488
                            ],
                            [
                                -150.01936,
                                61.20185
                            ],
                            [
                                -150.06322,
                                61.15121
                            ],
                            [
                                -149.84921,
                                61.08558
                            ],
                            [
                                -149.73539,
                                61.0168
                            ],
                            [
                                -149.50152,
                                60.98402
                            ],
                            [
                                -149.35837,
                                60.92743
                            ],
                            [
                                -149.19092,
                                60.94311
                            ],
                            [
                                -149.11819,
                                60.87713
                            ],
                            [
                                -149.42967,
                                60.90086
                            ],
                            [
                                -149.77118,
                                60.96732
                            ],
                            [
                                -149.85188,
                                60.96692
                            ],
                            [
                                -149.94823,
                                60.89938
                            ],
                            [
                                -150.18972,
                                60.90062
                            ],
                            [
                                -150.3936,
                                61.03763
                            ],
                            [
                                -150.68677,
                                60.95489
                            ],
                            [
                                -151.06743,
                                60.78716
                            ],
                            [
                                -151.21631,
                                60.77952
                            ],
                            [
                                -151.40817,
                                60.72055
                            ],
                            [
                                -151.33007,
                                60.58146
                            ],
                            [
                                -151.26284,
                                60.54721
                            ],
                            [
                                -151.2964,
                                60.39293
                            ],
                            [
                                -151.37666,
                                60.36393
                            ],
                            [
                                -151.42055,
                                60.21489
                            ],
                            [
                                -151.70427,
                                60.029
                            ],
                            [
                                -151.75294,
                                59.92226
                            ],
                            [
                                -151.86871,
                                59.77277
                            ],
                            [
                                -151.79597,
                                59.70567
                            ],
                            [
                                -151.68644,
                                59.66204
                            ],
                            [
                                -151.51521,
                                59.6349
                            ],
                            [
                                -151.32872,
                                59.68653
                            ],
                            [
                                -151.10896,
                                59.77982
                            ],
                            [
                                -150.9812,
                                59.81741
                            ],
                            [
                                -150.91262,
                                59.79317
                            ],
                            [
                                -151.0955,
                                59.70757
                            ],
                            [
                                -151.11253,
                                59.67079
                            ],
                            [
                                -151.27459,
                                59.5916
                            ],
                            [
                                -151.26521,
                                59.5517
                            ],
                            [
                                -151.44369,
                                59.53683
                            ],
                            [
                                -151.47965,
                                59.47387
                            ],
                            [
                                -151.64648,
                                59.48277
                            ],
                            [
                                -151.88324,
                                59.42203
                            ],
                            [
                                -151.85161,
                                59.3692
                            ],
                            [
                                -151.95869,
                                59.34412
                            ],
                            [
                                -151.97049,
                                59.25403
                            ],
                            [
                                -151.79723,
                                59.21205
                            ],
                            [
                                -151.74761,
                                59.1617
                            ],
                            [
                                -151.58804,
                                59.16535
                            ],
                            [
                                -151.57625,
                                59.20257
                            ],
                            [
                                -151.42258,
                                59.25918
                            ],
                            [
                                -151.30707,
                                59.21292
                            ],
                            [
                                -151.18106,
                                59.20486
                            ],
                            [
                                -151.00586,
                                59.2268
                            ],
                            [
                                -150.73189,
                                59.42454
                            ],
                            [
                                -150.60006,
                                59.43068
                            ],
                            [
                                -150.59504,
                                59.54982
                            ],
                            [
                                -150.48845,
                                59.49036
                            ],
                            [
                                -150.32191,
                                59.62726
                            ],
                            [
                                -150.29627,
                                59.57972
                            ],
                            [
                                -150.36318,
                                59.5176
                            ],
                            [
                                -150.25984,
                                59.48906
                            ],
                            [
                                -150.09829,
                                59.5847
                            ],
                            [
                                -150.09062,
                                59.64895
                            ],
                            [
                                -149.95005,
                                59.65858
                            ],
                            [
                                -149.83437,
                                59.71655
                            ],
                            [
                                -149.73477,
                                59.71855
                            ],
                            [
                                -149.83946,
                                59.85139
                            ],
                            [
                                -149.66691,
                                59.9293
                            ],
                            [
                                -149.46342,
                                59.92173
                            ],
                            [
                                -149.3894,
                                59.99369
                            ],
                            [
                                -149.20577,
                                60.00587
                            ],
                            [
                                -149.02714,
                                59.95186
                            ],
                            [
                                -148.92736,
                                59.97188
                            ],
                            [
                                -148.86075,
                                59.92556
                            ],
                            [
                                -148.75576,
                                59.9595
                            ],
                            [
                                -148.61084,
                                59.92393
                            ],
                            [
                                -148.40116,
                                59.98204
                            ],
                            [
                                -148.38579,
                                60.10508
                            ],
                            [
                                -148.23463,
                                60.1182
                            ],
                            [
                                -148.12434,
                                60.16651
                            ],
                            [
                                -148.20882,
                                60.21794
                            ],
                            [
                                -148.21124,
                                60.30141
                            ],
                            [
                                -148.06922,
                                60.39327
                            ],
                            [
                                -147.96365,
                                60.50285
                            ],
                            [
                                -148.06942,
                                60.56537
                            ],
                            [
                                -148.19153,
                                60.55726
                            ],
                            [
                                -148.26893,
                                60.48655
                            ],
                            [
                                -148.46153,
                                60.54154
                            ],
                            [
                                -148.67244,
                                60.44606
                            ],
                            [
                                -148.71,
                                60.46111
                            ],
                            [
                                -148.52355,
                                60.56363
                            ],
                            [
                                -148.43159,
                                60.57012
                            ],
                            [
                                -148.32813,
                                60.52954
                            ],
                            [
                                -148.20539,
                                60.64852
                            ],
                            [
                                -148.299,
                                60.72385
                            ],
                            [
                                -148.51934,
                                60.76458
                            ],
                            [
                                -148.60641,
                                60.82357
                            ],
                            [
                                -148.30867,
                                60.83608
                            ],
                            [
                                -148.16576,
                                61.04151
                            ],
                            [
                                -148.0693,
                                61.01107
                            ],
                            [
                                -147.97184,
                                61.11058
                            ],
                            [
                                -147.82307,
                                61.20374
                            ],
                            [
                                -147.76363,
                                61.18385
                            ],
                            [
                                -147.9077,
                                61.08983
                            ],
                            [
                                -147.99066,
                                60.97025
                            ],
                            [
                                -147.87763,
                                60.82817
                            ],
                            [
                                -147.72707,
                                60.88639
                            ],
                            [
                                -147.60095,
                                60.85467
                            ],
                            [
                                -147.59851,
                                61.03105
                            ],
                            [
                                -147.45125,
                                60.89796
                            ],
                            [
                                -147.35935,
                                60.88552
                            ],
                            [
                                -147.17132,
                                60.93306
                            ],
                            [
                                -147.1085,
                                61.00523
                            ],
                            [
                                -146.99408,
                                60.96749
                            ],
                            [
                                -146.86317,
                                60.97433
                            ],
                            [
                                -146.60965,
                                61.12161
                            ],
                            [
                                -146.29878,
                                61.12844
                            ],
                            [
                                -146.22314,
                                61.08616
                            ],
                            [
                                -146.62141,
                                61.08206
                            ],
                            [
                                -146.73796,
                                60.93301
                            ],
                            [
                                -146.67828,
                                60.86213
                            ],
                            [
                                -146.43643,
                                60.77811
                            ],
                            [
                                -146.58268,
                                60.73835
                            ],
                            [
                                -146.49607,
                                60.67129
                            ],
                            [
                                -146.22181,
                                60.7445
                            ],
                            [
                                -146.18409,
                                60.62752
                            ],
                            [
                                -146.02859,
                                60.66711
                            ],
                            [
                                -145.88462,
                                60.63677
                            ],
                            [
                                -145.67221,
                                60.62934
                            ],
                            [
                                -145.8754,
                                60.44613
                            ],
                            [
                                -145.68946,
                                60.46609
                            ],
                            [
                                -145.55113,
                                60.44012
                            ],
                            [
                                -145.50285,
                                60.39679
                            ],
                            [
                                -145.32874,
                                60.3389
                            ],
                            [
                                -145.23164,
                                60.35864
                            ],
                            [
                                -145.08872,
                                60.44422
                            ],
                            [
                                -144.99725,
                                60.52836
                            ],
                            [
                                -144.86685,
                                60.56403
                            ],
                            [
                                -144.78652,
                                60.49113
                            ],
                            [
                                -144.94176,
                                60.29373
                            ],
                            [
                                -144.76494,
                                60.28194
                            ],
                            [
                                -144.6817,
                                60.20709
                            ],
                            [
                                -144.58722,
                                60.1814
                            ],
                            [
                                -144.37958,
                                60.16837
                            ],
                            [
                                -144.11081,
                                60.09774
                            ],
                            [
                                -144.02365,
                                60.01908
                            ],
                            [
                                -143.89383,
                                59.98738
                            ],
                            [
                                -143.58762,
                                60.04171
                            ],
                            [
                                -143.11092,
                                60.06774
                            ],
                            [
                                -142.83322,
                                60.0939
                            ],
                            [
                                -142.52334,
                                60.08471
                            ],
                            [
                                -142.00557,
                                60.02111
                            ],
                            [
                                -141.72876,
                                59.96235
                            ],
                            [
                                -141.55497,
                                59.96802
                            ],
                            [
                                -141.40003,
                                60.00947
                            ],
                            [
                                -141.26238,
                                59.99699
                            ],
                            [
                                -141.29,
                                59.9362
                            ],
                            [
                                -141.38355,
                                59.86768
                            ],
                            [
                                -140.87464,
                                59.73923
                            ],
                            [
                                -140.70711,
                                59.7166
                            ],
                            [
                                -140.31978,
                                59.69371
                            ],
                            [
                                -140.17029,
                                59.73832
                            ],
                            [
                                -139.78527,
                                59.82651
                            ],
                            [
                                -139.70791,
                                59.92346
                            ],
                            [
                                -139.60659,
                                59.99512
                            ],
                            [
                                -139.41988,
                                59.9895
                            ],
                            [
                                -139.25699,
                                59.8641
                            ],
                            [
                                -139.31658,
                                59.84623
                            ],
                            [
                                -139.45282,
                                59.97935
                            ],
                            [
                                -139.62483,
                                59.90068
                            ],
                            [
                                -139.58148,
                                59.77843
                            ],
                            [
                                -139.47847,
                                59.70209
                            ],
                            [
                                -139.58554,
                                59.60823
                            ],
                            [
                                -139.73948,
                                59.54693
                            ],
                            [
                                -139.83723,
                                59.53132
                            ],
                            [
                                -139.47414,
                                59.40914
                            ],
                            [
                                -139.26727,
                                59.38933
                            ],
                            [
                                -139.24532,
                                59.34368
                            ],
                            [
                                -138.9246,
                                59.24737
                            ],
                            [
                                -138.58668,
                                59.11958
                            ],
                            [
                                -138.48299,
                                59.10698
                            ],
                            [
                                -138.19122,
                                59.01893
                            ],
                            [
                                -137.93863,
                                58.87179
                            ],
                            [
                                -137.92442,
                                58.78184
                            ],
                            [
                                -137.69777,
                                58.67083
                            ],
                            [
                                -137.65996,
                                58.6282
                            ],
                            [
                                -137.09318,
                                58.38443
                            ],
                            [
                                -137.01517,
                                58.40907
                            ],
                            [
                                -136.78871,
                                58.2951
                            ],
                            [
                                -136.66453,
                                58.21258
                            ],
                            [
                                -136.57138,
                                58.28083
                            ],
                            [
                                -136.36054,
                                58.32951
                            ],
                            [
                                -136.28356,
                                58.31665
                            ],
                            [
                                -136.09306,
                                58.35058
                            ],
                            [
                                -136.03692,
                                58.37995
                            ],
                            [
                                -136.07339,
                                58.46508
                            ],
                            [
                                -136.20579,
                                58.61212
                            ],
                            [
                                -136.40227,
                                58.72225
                            ],
                            [
                                -136.53773,
                                58.74429
                            ],
                            [
                                -136.49456,
                                58.79517
                            ],
                            [
                                -136.5648,
                                58.83246
                            ],
                            [
                                -136.7496,
                                58.8762
                            ],
                            [
                                -136.92092,
                                58.898
                            ],
                            [
                                -136.87497,
                                58.96366
                            ],
                            [
                                -136.63236,
                                58.89163
                            ],
                            [
                                -136.53835,
                                58.95415
                            ],
                            [
                                -136.48446,
                                58.83663
                            ],
                            [
                                -136.24824,
                                58.75445
                            ],
                            [
                                -136.08252,
                                58.80886
                            ],
                            [
                                -135.85199,
                                58.59325
                            ],
                            [
                                -135.91511,
                                58.37852
                            ],
                            [
                                -135.67223,
                                58.39705
                            ],
                            [
                                -135.62026,
                                58.42504
                            ],
                            [
                                -135.4592,
                                58.40699
                            ],
                            [
                                -135.31043,
                                58.24381
                            ],
                            [
                                -135.14699,
                                58.20922
                            ],
                            [
                                -135.09304,
                                58.23978
                            ],
                            [
                                -135.05394,
                                58.34661
                            ],
                            [
                                -135.13457,
                                58.51393
                            ],
                            [
                                -135.21814,
                                58.59515
                            ],
                            [
                                -135.14392,
                                58.62219
                            ],
                            [
                                -135.22467,
                                58.71407
                            ],
                            [
                                -135.24579,
                                58.78734
                            ],
                            [
                                -135.3981,
                                58.9705
                            ],
                            [
                                -135.37809,
                                59.08906
                            ],
                            [
                                -135.47127,
                                59.17316
                            ],
                            [
                                -135.39618,
                                59.29956
                            ],
                            [
                                -135.23513,
                                59.12718
                            ],
                            [
                                -135.17831,
                                58.9955
                            ],
                            [
                                -135.14363,
                                58.83999
                            ],
                            [
                                -135.06459,
                                58.76391
                            ],
                            [
                                -134.93571,
                                58.77542
                            ],
                            [
                                -134.98567,
                                58.67442
                            ],
                            [
                                -134.79084,
                                58.49357
                            ],
                            [
                                -134.75862,
                                58.38507
                            ],
                            [
                                -134.65042,
                                58.38239
                            ],
                            [
                                -134.61021,
                                58.32513
                            ],
                            [
                                -134.62863,
                                58.24903
                            ],
                            [
                                -134.35037,
                                58.2006
                            ],
                            [
                                -134.15098,
                                58.20502
                            ],
                            [
                                -134.05009,
                                58.06666
                            ],
                            [
                                -133.85099,
                                57.95013
                            ],
                            [
                                -133.72342,
                                57.80544
                            ],
                            [
                                -133.52567,
                                57.76036
                            ],
                            [
                                -133.33016,
                                57.66492
                            ],
                            [
                                -133.65272,
                                57.70636
                            ],
                            [
                                -133.67151,
                                57.62967
                            ],
                            [
                                -133.51454,
                                57.54248
                            ],
                            [
                                -133.52113,
                                57.47261
                            ],
                            [
                                -133.45821,
                                57.42199
                            ],
                            [
                                -133.44844,
                                57.35462
                            ],
                            [
                                -133.29151,
                                57.33463
                            ],
                            [
                                -133.26669,
                                57.28662
                            ],
                            [
                                -133.47806,
                                57.29391
                            ],
                            [
                                -133.52684,
                                57.25969
                            ],
                            [
                                -133.51433,
                                57.17586
                            ],
                            [
                                -133.31087,
                                57.10769
                            ],
                            [
                                -133.16521,
                                57.14258
                            ],
                            [
                                -133.15943,
                                57.08711
                            ],
                            [
                                -132.78733,
                                57.00236
                            ],
                            [
                                -132.93396,
                                56.99332
                            ],
                            [
                                -132.78417,
                                56.84232
                            ],
                            [
                                -132.53465,
                                56.73194
                            ],
                            [
                                -132.56716,
                                56.63358
                            ],
                            [
                                -132.42488,
                                56.61106
                            ],
                            [
                                -132.28685,
                                56.66394
                            ],
                            [
                                -132.24592,
                                56.68804
                            ],
                            [
                                -132.19184,
                                56.70259
                            ],
                            [
                                -132.05573,
                                56.71906
                            ],
                            [
                                -131.89178,
                                56.65361
                            ],
                            [
                                -131.84734,
                                56.66231
                            ],
                            [
                                -131.89984,
                                56.75591
                            ],
                            [
                                -131.87233,
                                56.80815
                            ],
                            [
                                -132.11996,
                                56.87983
                            ],
                            [
                                -132.04235,
                                57.04641
                            ],
                            [
                                -132.36555,
                                57.09227
                            ],
                            [
                                -132.24163,
                                57.21421
                            ],
                            [
                                -132.37207,
                                57.35324
                            ],
                            [
                                -132.54488,
                                57.49441
                            ],
                            [
                                -132.72821,
                                57.68049
                            ],
                            [
                                -132.88195,
                                57.85623
                            ],
                            [
                                -133.06224,
                                58.00232
                            ],
                            [
                                -133.1722,
                                58.15582
                            ],
                            [
                                -133.38187,
                                58.31154
                            ],
                            [
                                -133.4526,
                                58.38779
                            ],
                            [
                                -133.37492,
                                58.42799
                            ],
                            [
                                -133.70354,
                                58.61739
                            ],
                            [
                                -133.84735,
                                58.73569
                            ],
                            [
                                -134.24132,
                                58.85849
                            ],
                            [
                                -134.40166,
                                58.97965
                            ],
                            [
                                -134.38963,
                                59.05351
                            ],
                            [
                                -134.4801,
                                59.13171
                            ],
                            [
                                -134.56309,
                                59.13425
                            ],
                            [
                                -134.68383,
                                59.19791
                            ],
                            [
                                -134.70116,
                                59.24873
                            ],
                            [
                                -134.96091,
                                59.2849
                            ],
                            [
                                -135.03276,
                                59.35003
                            ],
                            [
                                -134.99147,
                                59.3896
                            ],
                            [
                                -135.09391,
                                59.43223
                            ],
                            [
                                -135.03106,
                                59.4742
                            ],
                            [
                                -135.02939,
                                59.56913
                            ],
                            [
                                -135.21499,
                                59.65864
                            ],
                            [
                                -135.23443,
                                59.6984
                            ],
                            [
                                -135.48326,
                                59.79997
                            ],
                            [
                                -135.93219,
                                59.66839
                            ],
                            [
                                -136.17428,
                                59.64143
                            ],
                            [
                                -136.34472,
                                59.60228
                            ],
                            [
                                -136.23604,
                                59.56298
                            ],
                            [
                                -136.2973,
                                59.47013
                            ],
                            [
                                -136.46377,
                                59.46465
                            ],
                            [
                                -136.45799,
                                59.28249
                            ],
                            [
                                -136.57573,
                                59.17013
                            ],
                            [
                                -136.8235,
                                59.15788
                            ],
                            [
                                -137.25435,
                                59.00752
                            ],
                            [
                                -137.44529,
                                58.91115
                            ],
                            [
                                -137.49311,
                                58.99193
                            ],
                            [
                                -137.5983,
                                59.24161
                            ],
                            [
                                -137.89363,
                                59.40391
                            ],
                            [
                                -138.62366,
                                59.77159
                            ],
                            [
                                -138.70583,
                                59.9111
                            ],
                            [
                                -139.04451,
                                59.99397
                            ],
                            [
                                -139.18606,
                                60.09253
                            ],
                            [
                                -139.05818,
                                60.32722
                            ],
                            [
                                -139.06908,
                                60.35196
                            ],
                            [
                                -139.67449,
                                60.33945
                            ],
                            [
                                -139.9773,
                                60.1847
                            ],
                            [
                                -140.45534,
                                60.31147
                            ],
                            [
                                -140.52194,
                                60.2258
                            ],
                            [
                                -141,
                                60.32135
                            ],
                            [
                                -141,
                                61.12184
                            ],
                            [
                                -141,
                                61.89744
                            ],
                            [
                                -141,
                                62.59005
                            ],
                            [
                                -141,
                                63.21429
                            ],
                            [
                                -141,
                                63.86211
                            ],
                            [
                                -140.99936,
                                64.4708
                            ],
                            [
                                -140.99863,
                                65.0
                            ],
                            [
                                -140.99747,
                                65.83974
                            ],
                            [
                                -140.99644,
                                66.61118
                            ],
                            [
                                -140.9952,
                                67.49797
                            ],
                            [
                                -140.99469,
                                67.85589
                            ],
                            [
                                -140.99383,
                                68.49429
                            ],
                            [
                                -140.99298,
                                69.11124
                            ],
                            [
                                -140.99226,
                                69.61724
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -131.84355,
                                56.64807
                            ],
                            [
                                -131.88371,
                                56.64457
                            ],
                            [
                                -132.0943,
                                56.70775
                            ],
                            [
                                -132.24541,
                                56.68177
                            ],
                            [
                                -132.31843,
                                56.63717
                            ],
                            [
                                -132.36451,
                                56.59206
                            ],
                            [
                                -132.35497,
                                56.52601
                            ],
                            [
                                -132.20932,
                                56.45842
                            ],
                            [
                                -132.119,
                                56.36695
                            ],
                            [
                                -132.05951,
                                56.37465
                            ],
                            [
                                -131.98824,
                                56.34012
                            ],
                            [
                                -131.9319,
                                56.23864
                            ],
                            [
                                -131.7654,
                                56.20326
                            ],
                            [
                                -131.97067,
                                56.17252
                            ],
                            [
                                -131.97532,
                                55.96356
                            ],
                            [
                                -132.04081,
                                55.95769
                            ],
                            [
                                -132.06145,
                                55.82544
                            ],
                            [
                                -132.19052,
                                55.78731
                            ],
                            [
                                -132.22802,
                                55.69879
                            ],
                            [
                                -132.18643,
                                55.58873
                            ],
                            [
                                -131.98545,
                                55.50026
                            ],
                            [
                                -131.96122,
                                55.58879
                            ],
                            [
                                -131.86061,
                                55.63206
                            ],
                            [
                                -131.76611,
                                55.81477
                            ],
                            [
                                -131.89211,
                                55.84421
                            ],
                            [
                                -131.43921,
                                56.00152
                            ],
                            [
                                -131.39066,
                                55.96347
                            ],
                            [
                                -131.21176,
                                55.98241
                            ],
                            [
                                -131.07819,
                                55.88297
                            ],
                            [
                                -130.89128,
                                55.7052
                            ],
                            [
                                -130.86452,
                                55.54193
                            ],
                            [
                                -130.92151,
                                55.43372
                            ],
                            [
                                -130.87053,
                                55.31587
                            ],
                            [
                                -130.94625,
                                55.29171
                            ],
                            [
                                -131.08753,
                                55.19242
                            ],
                            [
                                -131.0718,
                                55.12696
                            ],
                            [
                                -130.99511,
                                55.08389
                            ],
                            [
                                -131.00893,
                                54.99959
                            ],
                            [
                                -130.945,
                                54.82308
                            ],
                            [
                                -130.86112,
                                54.76923
                            ],
                            [
                                -130.65713,
                                54.77852
                            ],
                            [
                                -130.5267,
                                54.88321
                            ],
                            [
                                -130.4826,
                                54.84041
                            ],
                            [
                                -130.29914,
                                54.96425
                            ],
                            [
                                -130.08759,
                                55.22594
                            ],
                            [
                                -129.99854,
                                55.28396
                            ],
                            [
                                -130.05713,
                                55.44358
                            ],
                            [
                                -130.14934,
                                55.59654
                            ],
                            [
                                -130.12694,
                                55.67531
                            ],
                            [
                                -130.17517,
                                55.75931
                            ],
                            [
                                -130.01016,
                                55.91706
                            ],
                            [
                                -130.01074,
                                56.00011
                            ],
                            [
                                -130.10765,
                                56.12399
                            ],
                            [
                                -130.25009,
                                56.09758
                            ],
                            [
                                -130.41732,
                                56.14118
                            ],
                            [
                                -130.46912,
                                56.24501
                            ],
                            [
                                -130.62557,
                                56.27192
                            ],
                            [
                                -130.78407,
                                56.37037
                            ],
                            [
                                -131.07341,
                                56.40677
                            ],
                            [
                                -131.17163,
                                56.45398
                            ],
                            [
                                -131.46911,
                                56.55491
                            ],
                            [
                                -131.58319,
                                56.61447
                            ],
                            [
                                -131.83096,
                                56.60091
                            ],
                            [
                                -131.84355,
                                56.64807
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -153.06831,
                                57.93628
                            ],
                            [
                                -153.20024,
                                57.96941
                            ],
                            [
                                -153.23214,
                                57.89368
                            ],
                            [
                                -153.20486,
                                57.78497
                            ],
                            [
                                -153.47569,
                                57.83997
                            ],
                            [
                                -153.45728,
                                57.79108
                            ],
                            [
                                -153.54309,
                                57.76589
                            ],
                            [
                                -153.62418,
                                57.88141
                            ],
                            [
                                -153.73186,
                                57.89289
                            ],
                            [
                                -153.92981,
                                57.80803
                            ],
                            [
                                -153.90375,
                                57.70302
                            ],
                            [
                                -153.80049,
                                57.69629
                            ],
                            [
                                -153.74213,
                                57.64818
                            ],
                            [
                                -153.87674,
                                57.63249
                            ],
                            [
                                -153.7865,
                                57.56979
                            ],
                            [
                                -153.82089,
                                57.51321
                            ],
                            [
                                -153.81057,
                                57.41584
                            ],
                            [
                                -153.8934,
                                57.42157
                            ],
                            [
                                -153.98186,
                                57.62119
                            ],
                            [
                                -154.03678,
                                57.65223
                            ],
                            [
                                -154.2297,
                                57.66161
                            ],
                            [
                                -154.34311,
                                57.63802
                            ],
                            [
                                -154.44544,
                                57.57686
                            ],
                            [
                                -154.63145,
                                57.50408
                            ],
                            [
                                -154.71116,
                                57.42707
                            ],
                            [
                                -154.7347,
                                57.27626
                            ],
                            [
                                -154.61797,
                                57.26855
                            ],
                            [
                                -154.53873,
                                57.19757
                            ],
                            [
                                -154.50841,
                                56.99024
                            ],
                            [
                                -154.40392,
                                56.96626
                            ],
                            [
                                -154.28922,
                                56.90827
                            ],
                            [
                                -154.21419,
                                56.90802
                            ],
                            [
                                -154.05289,
                                56.98985
                            ],
                            [
                                -153.97135,
                                57.06392
                            ],
                            [
                                -153.95942,
                                56.9082
                            ],
                            [
                                -154.06896,
                                56.84547
                            ],
                            [
                                -154.14379,
                                56.74865
                            ],
                            [
                                -153.96458,
                                56.74742
                            ],
                            [
                                -153.72718,
                                56.89177
                            ],
                            [
                                -153.60377,
                                56.93603
                            ],
                            [
                                -153.54602,
                                56.99707
                            ],
                            [
                                -153.66043,
                                57.08732
                            ],
                            [
                                -153.48743,
                                57.09356
                            ],
                            [
                                -153.26081,
                                57.22509
                            ],
                            [
                                -153.11801,
                                57.21117
                            ],
                            [
                                -152.95138,
                                57.2514
                            ],
                            [
                                -152.90918,
                                57.32005
                            ],
                            [
                                -152.81661,
                                57.26974
                            ],
                            [
                                -152.69199,
                                57.28434
                            ],
                            [
                                -152.60885,
                                57.3591
                            ],
                            [
                                -152.58549,
                                57.44764
                            ],
                            [
                                -152.48862,
                                57.46589
                            ],
                            [
                                -152.34038,
                                57.42311
                            ],
                            [
                                -152.31694,
                                57.48684
                            ],
                            [
                                -152.15782,
                                57.5897
                            ],
                            [
                                -152.33986,
                                57.62962
                            ],
                            [
                                -152.48128,
                                57.722
                            ],
                            [
                                -152.42444,
                                57.81634
                            ],
                            [
                                -152.47061,
                                57.89387
                            ],
                            [
                                -152.7864,
                                57.85539
                            ],
                            [
                                -152.80632,
                                57.91259
                            ],
                            [
                                -152.93844,
                                57.94724
                            ],
                            [
                                -153.06831,
                                57.93628
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -133.6352,
                                56.34647
                            ],
                            [
                                -133.66308,
                                56.31292
                            ],
                            [
                                -133.63863,
                                56.21705
                            ],
                            [
                                -133.57986,
                                56.17998
                            ],
                            [
                                -133.52154,
                                56.07595
                            ],
                            [
                                -133.6643,
                                56.08117
                            ],
                            [
                                -133.81396,
                                55.9401
                            ],
                            [
                                -133.75677,
                                55.9144
                            ],
                            [
                                -133.52264,
                                55.99363
                            ],
                            [
                                -133.39961,
                                56.01953
                            ],
                            [
                                -133.35634,
                                55.96727
                            ],
                            [
                                -133.26617,
                                55.95903
                            ],
                            [
                                -133.24611,
                                55.88861
                            ],
                            [
                                -133.16844,
                                55.85448
                            ],
                            [
                                -133.17272,
                                55.80732
                            ],
                            [
                                -133.41002,
                                55.66494
                            ],
                            [
                                -133.38944,
                                55.62579
                            ],
                            [
                                -133.27251,
                                55.57745
                            ],
                            [
                                -133.07252,
                                55.62141
                            ],
                            [
                                -133.13246,
                                55.50901
                            ],
                            [
                                -133.12362,
                                55.46125
                            ],
                            [
                                -133.01624,
                                55.37892
                            ],
                            [
                                -133.22683,
                                55.38001
                            ],
                            [
                                -133.27735,
                                55.33836
                            ],
                            [
                                -133.22818,
                                55.28415
                            ],
                            [
                                -133.06699,
                                55.2699
                            ],
                            [
                                -132.8878,
                                55.2323
                            ],
                            [
                                -132.72619,
                                55.15419
                            ],
                            [
                                -132.53232,
                                55.10228
                            ],
                            [
                                -132.61273,
                                54.9683
                            ],
                            [
                                -132.49395,
                                54.89737
                            ],
                            [
                                -132.43105,
                                54.91645
                            ],
                            [
                                -132.31178,
                                54.84836
                            ],
                            [
                                -132.36684,
                                54.80751
                            ],
                            [
                                -132.30744,
                                54.72006
                            ],
                            [
                                -132.15601,
                                54.69272
                            ],
                            [
                                -132.02024,
                                54.69553
                            ],
                            [
                                -131.96919,
                                54.84448
                            ],
                            [
                                -131.9919,
                                55.01547
                            ],
                            [
                                -132.09106,
                                55.04129
                            ],
                            [
                                -132.02981,
                                55.14826
                            ],
                            [
                                -131.97922,
                                55.17861
                            ],
                            [
                                -131.9962,
                                55.26095
                            ],
                            [
                                -132.09794,
                                55.26713
                            ],
                            [
                                -132.28474,
                                55.44697
                            ],
                            [
                                -132.49344,
                                55.49746
                            ],
                            [
                                -132.58028,
                                55.56983
                            ],
                            [
                                -132.29752,
                                55.53752
                            ],
                            [
                                -132.47442,
                                55.78435
                            ],
                            [
                                -132.62234,
                                55.91059
                            ],
                            [
                                -132.73725,
                                55.98295
                            ],
                            [
                                -132.86796,
                                56.02892
                            ],
                            [
                                -133.01813,
                                56.05292
                            ],
                            [
                                -133.07345,
                                56.11456
                            ],
                            [
                                -133.03958,
                                56.17549
                            ],
                            [
                                -133.19678,
                                56.33338
                            ],
                            [
                                -133.30557,
                                56.32127
                            ],
                            [
                                -133.61401,
                                56.35652
                            ],
                            [
                                -133.6352,
                                56.34647
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -155.83741,
                                20.26663
                            ],
                            [
                                -155.89828,
                                20.23139
                            ],
                            [
                                -155.89122,
                                20.12571
                            ],
                            [
                                -155.82257,
                                20.02297
                            ],
                            [
                                -155.83199,
                                19.97454
                            ],
                            [
                                -155.88738,
                                19.93128
                            ],
                            [
                                -155.92386,
                                19.85607
                            ],
                            [
                                -155.97193,
                                19.8485
                            ],
                            [
                                -156.04936,
                                19.77217
                            ],
                            [
                                -156.0322,
                                19.65822
                            ],
                            [
                                -155.99114,
                                19.63485
                            ],
                            [
                                -155.94936,
                                19.48658
                            ],
                            [
                                -155.91991,
                                19.476
                            ],
                            [
                                -155.88436,
                                19.33349
                            ],
                            [
                                -155.91844,
                                19.11893
                            ],
                            [
                                -155.87842,
                                19.03371
                            ],
                            [
                                -155.79835,
                                19.00977
                            ],
                            [
                                -155.68687,
                                18.93746
                            ],
                            [
                                -155.63556,
                                18.93837
                            ],
                            [
                                -155.56306,
                                19.03095
                            ],
                            [
                                -155.50404,
                                19.13482
                            ],
                            [
                                -155.44853,
                                19.1506
                            ],
                            [
                                -155.29384,
                                19.26337
                            ],
                            [
                                -155.19272,
                                19.25693
                            ],
                            [
                                -154.97342,
                                19.34896
                            ],
                            [
                                -154.82367,
                                19.47464
                            ],
                            [
                                -154.81308,
                                19.52675
                            ],
                            [
                                -154.92141,
                                19.5825
                            ],
                            [
                                -154.98036,
                                19.63834
                            ],
                            [
                                -155.00181,
                                19.73442
                            ],
                            [
                                -155.08924,
                                19.73178
                            ],
                            [
                                -155.08276,
                                19.84715
                            ],
                            [
                                -155.13901,
                                19.91485
                            ],
                            [
                                -155.27682,
                                20.01696
                            ],
                            [
                                -155.40273,
                                20.07525
                            ],
                            [
                                -155.55356,
                                20.12813
                            ],
                            [
                                -155.59428,
                                20.12093
                            ],
                            [
                                -155.73169,
                                20.21883
                            ],
                            [
                                -155.83741,
                                20.26663
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -171.67211,
                                63.62067
                            ],
                            [
                                -171.56797,
                                63.65826
                            ],
                            [
                                -171.7378,
                                63.78177
                            ],
                            [
                                -171.74002,
                                63.66484
                            ],
                            [
                                -171.8275,
                                63.57733
                            ],
                            [
                                -171.84156,
                                63.48395
                            ],
                            [
                                -171.73421,
                                63.36869
                            ],
                            [
                                -171.45718,
                                63.3105
                            ],
                            [
                                -171.27749,
                                63.38271
                            ],
                            [
                                -171.08208,
                                63.4235
                            ],
                            [
                                -170.90766,
                                63.41898
                            ],
                            [
                                -170.61729,
                                63.3687
                            ],
                            [
                                -170.36388,
                                63.28549
                            ],
                            [
                                -170.28673,
                                63.18979
                            ],
                            [
                                -170.04359,
                                63.16886
                            ],
                            [
                                -169.79185,
                                63.09443
                            ],
                            [
                                -169.71475,
                                63.0157
                            ],
                            [
                                -169.74152,
                                62.95588
                            ],
                            [
                                -169.64754,
                                62.9404
                            ],
                            [
                                -169.53523,
                                62.98088
                            ],
                            [
                                -169.57621,
                                63.02866
                            ],
                            [
                                -169.32363,
                                63.17979
                            ],
                            [
                                -169.1705,
                                63.1982
                            ],
                            [
                                -168.86079,
                                63.14825
                            ],
                            [
                                -168.72602,
                                63.23141
                            ],
                            [
                                -168.70025,
                                63.30001
                            ],
                            [
                                -169.00939,
                                63.34245
                            ],
                            [
                                -169.18383,
                                63.29822
                            ],
                            [
                                -169.28314,
                                63.3478
                            ],
                            [
                                -169.53922,
                                63.37108
                            ],
                            [
                                -169.65169,
                                63.42798
                            ],
                            [
                                -169.85083,
                                63.44139
                            ],
                            [
                                -170.04502,
                                63.47613
                            ],
                            [
                                -170.09922,
                                63.61084
                            ],
                            [
                                -170.29359,
                                63.68592
                            ],
                            [
                                -170.48077,
                                63.69582
                            ],
                            [
                                -170.64389,
                                63.66733
                            ],
                            [
                                -170.89515,
                                63.5726
                            ],
                            [
                                -171.06903,
                                63.57907
                            ],
                            [
                                -171.23826,
                                63.61347
                            ],
                            [
                                -171.48657,
                                63.59684
                            ],
                            [
                                -171.53247,
                                63.65961
                            ],
                            [
                                -171.67211,
                                63.62067
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -135.77113,
                                58.27087
                            ],
                            [
                                -135.82384,
                                58.28105
                            ],
                            [
                                -135.98632,
                                58.19413
                            ],
                            [
                                -136.13787,
                                58.22421
                            ],
                            [
                                -136.23598,
                                58.15736
                            ],
                            [
                                -136.32377,
                                58.15913
                            ],
                            [
                                -136.44515,
                                58.11754
                            ],
                            [
                                -136.34992,
                                58.04641
                            ],
                            [
                                -136.29275,
                                57.99977
                            ],
                            [
                                -136.34532,
                                57.99921
                            ],
                            [
                                -136.37507,
                                57.96502
                            ],
                            [
                                -136.36152,
                                57.92239
                            ],
                            [
                                -136.42811,
                                57.84173
                            ],
                            [
                                -136.30331,
                                57.77577
                            ],
                            [
                                -136.20359,
                                57.76039
                            ],
                            [
                                -136.14371,
                                57.70257
                            ],
                            [
                                -136.15184,
                                57.63924
                            ],
                            [
                                -136.0596,
                                57.59436
                            ],
                            [
                                -135.96706,
                                57.47388
                            ],
                            [
                                -135.84253,
                                57.39119
                            ],
                            [
                                -135.69144,
                                57.37521
                            ],
                            [
                                -135.55621,
                                57.45543
                            ],
                            [
                                -135.57323,
                                57.5965
                            ],
                            [
                                -135.70248,
                                57.65718
                            ],
                            [
                                -135.60957,
                                57.69458
                            ],
                            [
                                -135.47929,
                                57.63151
                            ],
                            [
                                -135.0197,
                                57.45632
                            ],
                            [
                                -134.89846,
                                57.46057
                            ],
                            [
                                -134.83792,
                                57.50052
                            ],
                            [
                                -134.86025,
                                57.60258
                            ],
                            [
                                -134.92092,
                                57.6772
                            ],
                            [
                                -134.93712,
                                57.76095
                            ],
                            [
                                -135.11201,
                                57.75574
                            ],
                            [
                                -135.23169,
                                57.71739
                            ],
                            [
                                -135.37844,
                                57.77504
                            ],
                            [
                                -135.02302,
                                57.77927
                            ],
                            [
                                -134.95703,
                                57.81467
                            ],
                            [
                                -135.07356,
                                57.87738
                            ],
                            [
                                -134.92748,
                                57.9203
                            ],
                            [
                                -134.915,
                                57.97823
                            ],
                            [
                                -134.96576,
                                58.04559
                            ],
                            [
                                -135.11625,
                                58.09061
                            ],
                            [
                                -135.53989,
                                58.10317
                            ],
                            [
                                -135.50013,
                                58.16832
                            ],
                            [
                                -135.77113,
                                58.27087
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -166.16069,
                                60.42785
                            ],
                            [
                                -166.3897,
                                60.3564
                            ],
                            [
                                -166.47438,
                                60.38302
                            ],
                            [
                                -166.73782,
                                60.30932
                            ],
                            [
                                -166.82636,
                                60.26879
                            ],
                            [
                                -166.85339,
                                60.20616
                            ],
                            [
                                -167.10655,
                                60.23161
                            ],
                            [
                                -167.3106,
                                60.23177
                            ],
                            [
                                -167.41467,
                                60.18843
                            ],
                            [
                                -167.32932,
                                60.06991
                            ],
                            [
                                -167.259,
                                60.06657
                            ],
                            [
                                -167.11026,
                                59.99082
                            ],
                            [
                                -166.97325,
                                59.97743
                            ],
                            [
                                -166.6106,
                                59.84838
                            ],
                            [
                                -166.41514,
                                59.85244
                            ],
                            [
                                -166.27166,
                                59.81156
                            ],
                            [
                                -166.19106,
                                59.75146
                            ],
                            [
                                -166.08708,
                                59.77625
                            ],
                            [
                                -166.12291,
                                59.84763
                            ],
                            [
                                -165.8365,
                                59.89153
                            ],
                            [
                                -165.70923,
                                59.8913
                            ],
                            [
                                -165.56714,
                                59.92465
                            ],
                            [
                                -165.7106,
                                60.05963
                            ],
                            [
                                -165.66642,
                                60.0994
                            ],
                            [
                                -165.72779,
                                60.24353
                            ],
                            [
                                -165.68741,
                                60.29249
                            ],
                            [
                                -165.8805,
                                60.34116
                            ],
                            [
                                -165.99921,
                                60.31437
                            ],
                            [
                                -166.12015,
                                60.37449
                            ],
                            [
                                -166.16069,
                                60.42785
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -134.94051,
                                58.40124
                            ],
                            [
                                -134.96747,
                                58.3672
                            ],
                            [
                                -134.89142,
                                58.1902
                            ],
                            [
                                -134.77083,
                                58.08371
                            ],
                            [
                                -134.80858,
                                58.04912
                            ],
                            [
                                -134.70682,
                                57.83071
                            ],
                            [
                                -134.73187,
                                57.7373
                            ],
                            [
                                -134.67377,
                                57.61144
                            ],
                            [
                                -134.61217,
                                57.56251
                            ],
                            [
                                -134.57475,
                                57.47841
                            ],
                            [
                                -134.57385,
                                57.3429
                            ],
                            [
                                -134.65138,
                                57.2153
                            ],
                            [
                                -134.60837,
                                57.15282
                            ],
                            [
                                -134.6118,
                                57.04897
                            ],
                            [
                                -134.49278,
                                57.02815
                            ],
                            [
                                -134.28195,
                                57.15358
                            ],
                            [
                                -134.1584,
                                57.20657
                            ],
                            [
                                -134.09068,
                                57.33142
                            ],
                            [
                                -133.95911,
                                57.3092
                            ],
                            [
                                -133.86529,
                                57.36836
                            ],
                            [
                                -133.88728,
                                57.41171
                            ],
                            [
                                -134.02168,
                                57.46428
                            ],
                            [
                                -133.8856,
                                57.50397
                            ],
                            [
                                -133.93952,
                                57.61419
                            ],
                            [
                                -134.09767,
                                57.71521
                            ],
                            [
                                -134.28186,
                                57.91159
                            ],
                            [
                                -134.32177,
                                57.97317
                            ],
                            [
                                -134.18721,
                                57.97624
                            ],
                            [
                                -134.10299,
                                57.85458
                            ],
                            [
                                -134.03295,
                                57.8151
                            ],
                            [
                                -133.96681,
                                57.6904
                            ],
                            [
                                -133.89118,
                                57.68364
                            ],
                            [
                                -133.90261,
                                57.80662
                            ],
                            [
                                -134.18226,
                                58.07562
                            ],
                            [
                                -134.20889,
                                58.16434
                            ],
                            [
                                -134.32268,
                                58.14478
                            ],
                            [
                                -134.57704,
                                58.17702
                            ],
                            [
                                -134.69992,
                                58.16816
                            ],
                            [
                                -134.71163,
                                58.22601
                            ],
                            [
                                -134.81011,
                                58.3237
                            ],
                            [
                                -134.88766,
                                58.32598
                            ],
                            [
                                -134.94051,
                                58.40124
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -135.48228,
                                57.53601
                            ],
                            [
                                -135.60419,
                                57.37027
                            ],
                            [
                                -135.67186,
                                57.3354
                            ],
                            [
                                -135.60936,
                                57.30165
                            ],
                            [
                                -135.55496,
                                57.23629
                            ],
                            [
                                -135.49997,
                                57.25639
                            ],
                            [
                                -135.34649,
                                57.24667
                            ],
                            [
                                -135.42073,
                                57.16849
                            ],
                            [
                                -135.40078,
                                57.10043
                            ],
                            [
                                -135.30187,
                                56.98017
                            ],
                            [
                                -135.37654,
                                56.95917
                            ],
                            [
                                -135.37233,
                                56.81899
                            ],
                            [
                                -135.27464,
                                56.7819
                            ],
                            [
                                -135.25555,
                                56.73775
                            ],
                            [
                                -135.14776,
                                56.69131
                            ],
                            [
                                -135.13047,
                                56.60943
                            ],
                            [
                                -135.00599,
                                56.63903
                            ],
                            [
                                -135.05731,
                                56.53967
                            ],
                            [
                                -134.94522,
                                56.38388
                            ],
                            [
                                -134.8095,
                                56.3254
                            ],
                            [
                                -134.80274,
                                56.2403
                            ],
                            [
                                -134.68731,
                                56.20343
                            ],
                            [
                                -134.64423,
                                56.26562
                            ],
                            [
                                -134.64131,
                                56.47569
                            ],
                            [
                                -134.61924,
                                56.63534
                            ],
                            [
                                -134.64248,
                                56.73861
                            ],
                            [
                                -134.81564,
                                57.18044
                            ],
                            [
                                -134.98977,
                                57.34334
                            ],
                            [
                                -134.80665,
                                57.3396
                            ],
                            [
                                -134.83784,
                                57.41166
                            ],
                            [
                                -135.00968,
                                57.40321
                            ],
                            [
                                -135.15937,
                                57.44265
                            ],
                            [
                                -135.34914,
                                57.54911
                            ],
                            [
                                -135.48228,
                                57.53601
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -163.7102,
                                55.04186
                            ],
                            [
                                -163.89219,
                                55.03449
                            ],
                            [
                                -164.0433,
                                54.96597
                            ],
                            [
                                -164.16119,
                                54.9565
                            ],
                            [
                                -164.22015,
                                54.89559
                            ],
                            [
                                -164.3506,
                                54.8984
                            ],
                            [
                                -164.4299,
                                54.93002
                            ],
                            [
                                -164.549,
                                54.8867
                            ],
                            [
                                -164.55816,
                                54.84745
                            ],
                            [
                                -164.69485,
                                54.67449
                            ],
                            [
                                -164.92492,
                                54.59895
                            ],
                            [
                                -164.93717,
                                54.53949
                            ],
                            [
                                -164.84015,
                                54.4209
                            ],
                            [
                                -164.64816,
                                54.39122
                            ],
                            [
                                -164.4544,
                                54.42101
                            ],
                            [
                                -164.33686,
                                54.48281
                            ],
                            [
                                -164.32062,
                                54.5472
                            ],
                            [
                                -164.09873,
                                54.62069
                            ],
                            [
                                -163.81374,
                                54.63643
                            ],
                            [
                                -163.58546,
                                54.61506
                            ],
                            [
                                -163.42073,
                                54.65838
                            ],
                            [
                                -163.39454,
                                54.74273
                            ],
                            [
                                -163.19711,
                                54.69842
                            ],
                            [
                                -163.1482,
                                54.76339
                            ],
                            [
                                -163.34229,
                                54.76214
                            ],
                            [
                                -163.41189,
                                54.85829
                            ],
                            [
                                -163.44333,
                                54.97077
                            ],
                            [
                                -163.53632,
                                55.04978
                            ],
                            [
                                -163.7102,
                                55.04186
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -131.35496,
                                55.95158
                            ],
                            [
                                -131.54005,
                                55.90832
                            ],
                            [
                                -131.54749,
                                55.83134
                            ],
                            [
                                -131.70078,
                                55.83714
                            ],
                            [
                                -131.66782,
                                55.76873
                            ],
                            [
                                -131.72229,
                                55.6419
                            ],
                            [
                                -131.63457,
                                55.60035
                            ],
                            [
                                -131.7185,
                                55.51594
                            ],
                            [
                                -131.83026,
                                55.44944
                            ],
                            [
                                -131.69833,
                                55.35569
                            ],
                            [
                                -131.54019,
                                55.29285
                            ],
                            [
                                -131.34936,
                                55.26087
                            ],
                            [
                                -131.20173,
                                55.19109
                            ],
                            [
                                -131.07058,
                                55.25666
                            ],
                            [
                                -131.03234,
                                55.34732
                            ],
                            [
                                -130.97168,
                                55.393
                            ],
                            [
                                -130.98297,
                                55.56181
                            ],
                            [
                                -130.94176,
                                55.61834
                            ],
                            [
                                -130.97396,
                                55.70515
                            ],
                            [
                                -131.07439,
                                55.82965
                            ],
                            [
                                -131.25622,
                                55.96916
                            ],
                            [
                                -131.35496,
                                55.95158
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -133.73021,
                                57.0781
                            ],
                            [
                                -133.87776,
                                57.09796
                            ],
                            [
                                -134.01605,
                                57.06833
                            ],
                            [
                                -134.0442,
                                57.02312
                            ],
                            [
                                -133.85129,
                                56.91771
                            ],
                            [
                                -133.82942,
                                56.84271
                            ],
                            [
                                -133.72836,
                                56.8199
                            ],
                            [
                                -133.69381,
                                56.71945
                            ],
                            [
                                -133.72402,
                                56.68107
                            ],
                            [
                                -133.66008,
                                56.58934
                            ],
                            [
                                -133.65067,
                                56.43907
                            ],
                            [
                                -133.43438,
                                56.45458
                            ],
                            [
                                -133.43338,
                                56.49926
                            ],
                            [
                                -133.21835,
                                56.45253
                            ],
                            [
                                -133.08927,
                                56.52913
                            ],
                            [
                                -133.10507,
                                56.61737
                            ],
                            [
                                -133.21461,
                                56.65062
                            ],
                            [
                                -133.21105,
                                56.73404
                            ],
                            [
                                -133.01431,
                                56.59827
                            ],
                            [
                                -132.93743,
                                56.66444
                            ],
                            [
                                -132.98969,
                                56.79734
                            ],
                            [
                                -132.94089,
                                56.83878
                            ],
                            [
                                -132.99282,
                                56.93636
                            ],
                            [
                                -133.10748,
                                57.00114
                            ],
                            [
                                -133.42771,
                                57.01196
                            ],
                            [
                                -133.73021,
                                57.0781
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -166.70173,
                                54.00207
                            ],
                            [
                                -166.7475,
                                54.01087
                            ],
                            [
                                -167.01413,
                                53.95595
                            ],
                            [
                                -167.08059,
                                53.91765
                            ],
                            [
                                -167.14887,
                                53.83142
                            ],
                            [
                                -167.02541,
                                53.75942
                            ],
                            [
                                -166.95901,
                                53.77482
                            ],
                            [
                                -166.90202,
                                53.71537
                            ],
                            [
                                -167.05188,
                                53.70057
                            ],
                            [
                                -167.09173,
                                53.63128
                            ],
                            [
                                -167.16138,
                                53.6026
                            ],
                            [
                                -167.07679,
                                53.51141
                            ],
                            [
                                -167.26936,
                                53.45738
                            ],
                            [
                                -167.3355,
                                53.40993
                            ],
                            [
                                -167.46913,
                                53.44333
                            ],
                            [
                                -167.68923,
                                53.38528
                            ],
                            [
                                -167.81534,
                                53.31797
                            ],
                            [
                                -167.79356,
                                53.27965
                            ],
                            [
                                -167.62314,
                                53.25705
                            ],
                            [
                                -167.50911,
                                53.26262
                            ],
                            [
                                -167.45313,
                                53.3192
                            ],
                            [
                                -167.28817,
                                53.37119
                            ],
                            [
                                -166.8767,
                                53.47814
                            ],
                            [
                                -166.75521,
                                53.44554
                            ],
                            [
                                -166.66338,
                                53.48903
                            ],
                            [
                                -166.54847,
                                53.62381
                            ],
                            [
                                -166.45288,
                                53.63924
                            ],
                            [
                                -166.26762,
                                53.70638
                            ],
                            [
                                -166.34114,
                                53.78338
                            ],
                            [
                                -166.42512,
                                53.80437
                            ],
                            [
                                -166.35837,
                                53.85897
                            ],
                            [
                                -166.24547,
                                53.88014
                            ],
                            [
                                -166.26542,
                                53.96991
                            ],
                            [
                                -166.36458,
                                53.94587
                            ],
                            [
                                -166.60793,
                                53.8397
                            ],
                            [
                                -166.64481,
                                53.92414
                            ],
                            [
                                -166.59355,
                                53.96417
                            ],
                            [
                                -166.70173,
                                54.00207
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -72.32516,
                                41.14038
                            ],
                            [
                                -72.58427,
                                40.99935
                            ],
                            [
                                -72.77611,
                                40.96682
                            ],
                            [
                                -73.14774,
                                40.96107
                            ],
                            [
                                -73.15435,
                                40.91943
                            ],
                            [
                                -73.31344,
                                40.92707
                            ],
                            [
                                -73.38187,
                                40.90209
                            ],
                            [
                                -73.57271,
                                40.91223
                            ],
                            [
                                -73.68078,
                                40.8558
                            ],
                            [
                                -73.75151,
                                40.78655
                            ],
                            [
                                -73.90755,
                                40.78652
                            ],
                            [
                                -73.95526,
                                40.74801
                            ],
                            [
                                -73.97103,
                                40.7106
                            ],
                            [
                                -74.01128,
                                40.68441
                            ],
                            [
                                -74.03089,
                                40.60822
                            ],
                            [
                                -73.98518,
                                40.57211
                            ],
                            [
                                -73.91226,
                                40.5861
                            ],
                            [
                                -73.82274,
                                40.64694
                            ],
                            [
                                -73.77573,
                                40.60555
                            ],
                            [
                                -73.66107,
                                40.58328
                            ],
                            [
                                -73.61532,
                                40.62546
                            ],
                            [
                                -73.386,
                                40.65863
                            ],
                            [
                                -73.2328,
                                40.71449
                            ],
                            [
                                -73.14056,
                                40.71654
                            ],
                            [
                                -72.84937,
                                40.748
                            ],
                            [
                                -72.72684,
                                40.81023
                            ],
                            [
                                -72.65237,
                                40.79437
                            ],
                            [
                                -72.57026,
                                40.81541
                            ],
                            [
                                -72.4907,
                                40.88029
                            ],
                            [
                                -72.42624,
                                40.86012
                            ],
                            [
                                -71.87622,
                                41.05347
                            ],
                            [
                                -71.94651,
                                41.07386
                            ],
                            [
                                -72.09593,
                                40.99452
                            ],
                            [
                                -72.23283,
                                41.04171
                            ],
                            [
                                -72.25203,
                                41.00644
                            ],
                            [
                                -72.3709,
                                40.9898
                            ],
                            [
                                -72.46395,
                                40.89989
                            ],
                            [
                                -72.57423,
                                40.93753
                            ],
                            [
                                -72.47861,
                                40.9918
                            ],
                            [
                                -72.32516,
                                41.14038
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -134.26997,
                                56.93359
                            ],
                            [
                                -134.4205,
                                56.83231
                            ],
                            [
                                -134.36471,
                                56.67373
                            ],
                            [
                                -134.15251,
                                56.5008
                            ],
                            [
                                -134.05942,
                                56.49734
                            ],
                            [
                                -134.11471,
                                56.40788
                            ],
                            [
                                -134.24652,
                                56.41585
                            ],
                            [
                                -134.23301,
                                56.36348
                            ],
                            [
                                -134.29387,
                                56.28921
                            ],
                            [
                                -134.2144,
                                56.14778
                            ],
                            [
                                -134.23172,
                                56.06904
                            ],
                            [
                                -134.13135,
                                56.00517
                            ],
                            [
                                -134.09337,
                                56.08931
                            ],
                            [
                                -133.96012,
                                56.09678
                            ],
                            [
                                -133.9238,
                                56.2753
                            ],
                            [
                                -133.83517,
                                56.32486
                            ],
                            [
                                -133.92402,
                                56.37646
                            ],
                            [
                                -133.8519,
                                56.44437
                            ],
                            [
                                -133.91519,
                                56.49121
                            ],
                            [
                                -133.80735,
                                56.59868
                            ],
                            [
                                -133.69196,
                                56.59918
                            ],
                            [
                                -133.76718,
                                56.68005
                            ],
                            [
                                -133.73544,
                                56.77451
                            ],
                            [
                                -133.87265,
                                56.80914
                            ],
                            [
                                -133.91519,
                                56.7573
                            ],
                            [
                                -134.02235,
                                56.87814
                            ],
                            [
                                -134.26997,
                                56.93359
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -152.67146,
                                58.46723
                            ],
                            [
                                -152.86206,
                                58.38722
                            ],
                            [
                                -152.77648,
                                58.36499
                            ],
                            [
                                -152.76499,
                                58.27762
                            ],
                            [
                                -152.8931,
                                58.2681
                            ],
                            [
                                -153.03817,
                                58.30333
                            ],
                            [
                                -153.22065,
                                58.16266
                            ],
                            [
                                -153.15058,
                                58.10784
                            ],
                            [
                                -153.07069,
                                58.09425
                            ],
                            [
                                -153.01832,
                                58.04739
                            ],
                            [
                                -152.86033,
                                57.99514
                            ],
                            [
                                -152.7538,
                                58.0575
                            ],
                            [
                                -152.63527,
                                58.07731
                            ],
                            [
                                -152.28957,
                                58.18326
                            ],
                            [
                                -152.10746,
                                58.1516
                            ],
                            [
                                -151.97736,
                                58.2311
                            ],
                            [
                                -152.08134,
                                58.30777
                            ],
                            [
                                -152.2019,
                                58.34524
                            ],
                            [
                                -152.30081,
                                58.42603
                            ],
                            [
                                -152.36537,
                                58.37659
                            ],
                            [
                                -152.47463,
                                58.39929
                            ],
                            [
                                -152.55098,
                                58.45589
                            ],
                            [
                                -152.67146,
                                58.46723
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -168.0769,
                                53.55566
                            ],
                            [
                                -168.2231,
                                53.53138
                            ],
                            [
                                -168.40521,
                                53.42142
                            ],
                            [
                                -168.34445,
                                53.26424
                            ],
                            [
                                -168.5131,
                                53.25213
                            ],
                            [
                                -168.58996,
                                53.27067
                            ],
                            [
                                -168.75122,
                                53.19087
                            ],
                            [
                                -168.80514,
                                53.11005
                            ],
                            [
                                -168.7654,
                                53.07503
                            ],
                            [
                                -168.861,
                                53.01293
                            ],
                            [
                                -168.8603,
                                52.94361
                            ],
                            [
                                -168.64963,
                                52.97818
                            ],
                            [
                                -168.58856,
                                53.026
                            ],
                            [
                                -168.46464,
                                53.05489
                            ],
                            [
                                -168.36828,
                                53.13281
                            ],
                            [
                                -168.32928,
                                53.20637
                            ],
                            [
                                -168.21775,
                                53.25837
                            ],
                            [
                                -168.12,
                                53.27557
                            ],
                            [
                                -167.84612,
                                53.38471
                            ],
                            [
                                -167.89149,
                                53.5203
                            ],
                            [
                                -168.00825,
                                53.56543
                            ],
                            [
                                -168.0769,
                                53.55566
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -156.64074,
                                21.02071
                            ],
                            [
                                -156.69187,
                                20.94746
                            ],
                            [
                                -156.68674,
                                20.88186
                            ],
                            [
                                -156.62215,
                                20.80916
                            ],
                            [
                                -156.536,
                                20.77502
                            ],
                            [
                                -156.46378,
                                20.78178
                            ],
                            [
                                -156.43989,
                                20.60584
                            ],
                            [
                                -156.37354,
                                20.57588
                            ],
                            [
                                -156.29554,
                                20.58463
                            ],
                            [
                                -156.20075,
                                20.62691
                            ],
                            [
                                -156.13584,
                                20.6217
                            ],
                            [
                                -156.04777,
                                20.65228
                            ],
                            [
                                -155.98874,
                                20.70776
                            ],
                            [
                                -156.00187,
                                20.7926
                            ],
                            [
                                -156.11374,
                                20.82572
                            ],
                            [
                                -156.24037,
                                20.93416
                            ],
                            [
                                -156.32163,
                                20.94514
                            ],
                            [
                                -156.47765,
                                20.89511
                            ],
                            [
                                -156.55766,
                                21.01098
                            ],
                            [
                                -156.64074,
                                21.02071
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -157.96889,
                                21.7078
                            ],
                            [
                                -158.03601,
                                21.68133
                            ],
                            [
                                -158.12026,
                                21.58432
                            ],
                            [
                                -158.24675,
                                21.57955
                            ],
                            [
                                -158.22851,
                                21.48281
                            ],
                            [
                                -158.08007,
                                21.29706
                            ],
                            [
                                -157.96593,
                                21.32272
                            ],
                            [
                                -157.78975,
                                21.25732
                            ],
                            [
                                -157.65292,
                                21.30701
                            ],
                            [
                                -157.69525,
                                21.33679
                            ],
                            [
                                -157.74132,
                                21.4239
                            ],
                            [
                                -157.78043,
                                21.41404
                            ],
                            [
                                -157.84001,
                                21.46469
                            ],
                            [
                                -157.83894,
                                21.5335
                            ],
                            [
                                -157.91738,
                                21.62343
                            ],
                            [
                                -157.96889,
                                21.7078
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -147.13503,
                                60.34255
                            ],
                            [
                                -147.1907,
                                60.27266
                            ],
                            [
                                -147.30354,
                                60.21285
                            ],
                            [
                                -147.43624,
                                60.09534
                            ],
                            [
                                -147.69851,
                                59.99391
                            ],
                            [
                                -147.91242,
                                59.83544
                            ],
                            [
                                -147.87733,
                                59.76505
                            ],
                            [
                                -147.68162,
                                59.79968
                            ],
                            [
                                -147.59299,
                                59.85359
                            ],
                            [
                                -147.44056,
                                59.87152
                            ],
                            [
                                -147.49373,
                                59.94029
                            ],
                            [
                                -147.38314,
                                59.97964
                            ],
                            [
                                -147.35784,
                                60.04501
                            ],
                            [
                                -147.19748,
                                60.15087
                            ],
                            [
                                -146.9666,
                                60.24993
                            ],
                            [
                                -147.01951,
                                60.34439
                            ],
                            [
                                -147.13503,
                                60.34255
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -132.46669,
                                56.34363
                            ],
                            [
                                -132.53219,
                                56.3362
                            ],
                            [
                                -132.61295,
                                56.23559
                            ],
                            [
                                -132.71293,
                                56.22165
                            ],
                            [
                                -132.72027,
                                56.14004
                            ],
                            [
                                -132.6654,
                                56.05893
                            ],
                            [
                                -132.45853,
                                56.06262
                            ],
                            [
                                -132.45156,
                                55.97897
                            ],
                            [
                                -132.34852,
                                55.91426
                            ],
                            [
                                -132.13319,
                                55.95976
                            ],
                            [
                                -132.19507,
                                56.08513
                            ],
                            [
                                -132.11149,
                                56.11098
                            ],
                            [
                                -132.24607,
                                56.19165
                            ],
                            [
                                -132.37297,
                                56.22539
                            ],
                            [
                                -132.38029,
                                56.30698
                            ],
                            [
                                -132.46669,
                                56.34363
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -174.23023,
                                52.40085
                            ],
                            [
                                -174.33029,
                                52.37328
                            ],
                            [
                                -174.2992,
                                52.27969
                            ],
                            [
                                -174.23668,
                                52.24589
                            ],
                            [
                                -174.41451,
                                52.18258
                            ],
                            [
                                -174.54717,
                                52.17838
                            ],
                            [
                                -174.63978,
                                52.10532
                            ],
                            [
                                -174.86262,
                                52.10276
                            ],
                            [
                                -175.09064,
                                52.03804
                            ],
                            [
                                -175.02177,
                                52.00892
                            ],
                            [
                                -174.88952,
                                52.04542
                            ],
                            [
                                -174.64492,
                                52.02685
                            ],
                            [
                                -174.46527,
                                52.07665
                            ],
                            [
                                -174.41551,
                                52.04228
                            ],
                            [
                                -174.32468,
                                52.12096
                            ],
                            [
                                -174.23114,
                                52.09459
                            ],
                            [
                                -174.08698,
                                52.13402
                            ],
                            [
                                -174.19062,
                                52.19406
                            ],
                            [
                                -174.05627,
                                52.23057
                            ],
                            [
                                -173.99183,
                                52.29796
                            ],
                            [
                                -174.00868,
                                52.35675
                            ],
                            [
                                -174.14828,
                                52.41744
                            ],
                            [
                                -174.23023,
                                52.40085
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -159.50701,
                                22.2033
                            ],
                            [
                                -159.57966,
                                22.2238
                            ],
                            [
                                -159.7239,
                                22.14823
                            ],
                            [
                                -159.78358,
                                22.06406
                            ],
                            [
                                -159.75868,
                                21.97947
                            ],
                            [
                                -159.66952,
                                21.95351
                            ],
                            [
                                -159.63413,
                                21.91377
                            ],
                            [
                                -159.44448,
                                21.86898
                            ],
                            [
                                -159.33124,
                                21.9598
                            ],
                            [
                                -159.33473,
                                22.04701
                            ],
                            [
                                -159.2963,
                                22.10617
                            ],
                            [
                                -159.31301,
                                22.18296
                            ],
                            [
                                -159.34989,
                                22.21399
                            ],
                            [
                                -159.49725,
                                22.22177
                            ],
                            [
                                -159.50701,
                                22.2033
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                172.74235,
                                53.00793
                            ],
                            [
                                172.63933,
                                53.00226
                            ],
                            [
                                172.47269,
                                52.93582
                            ],
                            [
                                172.51454,
                                52.90479
                            ],
                            [
                                172.76615,
                                52.85833
                            ],
                            [
                                172.7525,
                                52.79439
                            ],
                            [
                                172.8651,
                                52.80021
                            ],
                            [
                                172.90578,
                                52.74623
                            ],
                            [
                                173.00648,
                                52.81651
                            ],
                            [
                                173.11546,
                                52.78485
                            ],
                            [
                                173.30281,
                                52.92437
                            ],
                            [
                                173.1211,
                                52.99014
                            ],
                            [
                                172.74235,
                                53.00793
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -176.55887,
                                51.96165
                            ],
                            [
                                -176.77357,
                                51.96377
                            ],
                            [
                                -176.8073,
                                51.92928
                            ],
                            [
                                -176.72346,
                                51.86356
                            ],
                            [
                                -176.78564,
                                51.8404
                            ],
                            [
                                -176.86746,
                                51.72108
                            ],
                            [
                                -176.86908,
                                51.66607
                            ],
                            [
                                -176.80489,
                                51.61046
                            ],
                            [
                                -176.72449,
                                51.68103
                            ],
                            [
                                -176.55002,
                                51.70893
                            ],
                            [
                                -176.51957,
                                51.75461
                            ],
                            [
                                -176.34978,
                                51.72975
                            ],
                            [
                                -176.27293,
                                51.77371
                            ],
                            [
                                -176.28276,
                                51.85965
                            ],
                            [
                                -176.40026,
                                51.86565
                            ],
                            [
                                -176.58206,
                                51.83841
                            ],
                            [
                                -176.61102,
                                51.90276
                            ],
                            [
                                -176.55887,
                                51.96165
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -133.12691,
                                55.20744
                            ],
                            [
                                -133.2304,
                                55.08162
                            ],
                            [
                                -133.12528,
                                54.9355
                            ],
                            [
                                -132.96786,
                                54.79837
                            ],
                            [
                                -132.73095,
                                54.66676
                            ],
                            [
                                -132.67003,
                                54.675
                            ],
                            [
                                -132.77535,
                                54.83525
                            ],
                            [
                                -132.90165,
                                54.92918
                            ],
                            [
                                -133.02116,
                                55.04566
                            ],
                            [
                                -133.02434,
                                55.13394
                            ],
                            [
                                -133.12691,
                                55.20744
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -132.95672,
                                56.81645
                            ],
                            [
                                -132.90944,
                                56.64109
                            ],
                            [
                                -132.97042,
                                56.60717
                            ],
                            [
                                -132.95059,
                                56.51141
                            ],
                            [
                                -132.73979,
                                56.50695
                            ],
                            [
                                -132.54685,
                                56.58239
                            ],
                            [
                                -132.62366,
                                56.66736
                            ],
                            [
                                -132.73609,
                                56.7121
                            ],
                            [
                                -132.82977,
                                56.79465
                            ],
                            [
                                -132.95672,
                                56.81645
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -132.24051,
                                56.40975
                            ],
                            [
                                -132.3427,
                                56.41236
                            ],
                            [
                                -132.36356,
                                56.28327
                            ],
                            [
                                -132.32997,
                                56.23717
                            ],
                            [
                                -132.09424,
                                56.13245
                            ],
                            [
                                -132.01447,
                                56.1956
                            ],
                            [
                                -131.9234,
                                56.20421
                            ],
                            [
                                -132.02901,
                                56.35104
                            ],
                            [
                                -132.08968,
                                56.37048
                            ],
                            [
                                -132.17311,
                                56.35027
                            ],
                            [
                                -132.24051,
                                56.40975
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -146.65282,
                                60.45554
                            ],
                            [
                                -146.72784,
                                60.38683
                            ],
                            [
                                -146.54015,
                                60.33322
                            ],
                            [
                                -146.69888,
                                60.27839
                            ],
                            [
                                -146.61291,
                                60.23743
                            ],
                            [
                                -146.49189,
                                60.29197
                            ],
                            [
                                -146.30073,
                                60.34665
                            ],
                            [
                                -146.09874,
                                60.3756
                            ],
                            [
                                -146.13005,
                                60.43174
                            ],
                            [
                                -146.36322,
                                60.40936
                            ],
                            [
                                -146.54008,
                                60.48465
                            ],
                            [
                                -146.65282,
                                60.45554
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -135.77782,
                                57.32718
                            ],
                            [
                                -135.85789,
                                57.32856
                            ],
                            [
                                -135.83223,
                                57.17861
                            ],
                            [
                                -135.7346,
                                57.14955
                            ],
                            [
                                -135.84379,
                                57.08728
                            ],
                            [
                                -135.82517,
                                56.99014
                            ],
                            [
                                -135.63458,
                                57.012
                            ],
                            [
                                -135.57071,
                                57.09035
                            ],
                            [
                                -135.62721,
                                57.22966
                            ],
                            [
                                -135.62262,
                                57.29809
                            ],
                            [
                                -135.72743,
                                57.33531
                            ],
                            [
                                -135.77782,
                                57.32718
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -132.91665,
                                56.45689
                            ],
                            [
                                -133.01016,
                                56.41483
                            ],
                            [
                                -133.06511,
                                56.33085
                            ],
                            [
                                -132.95965,
                                56.29436
                            ],
                            [
                                -132.87048,
                                56.23227
                            ],
                            [
                                -132.65973,
                                56.27735
                            ],
                            [
                                -132.68164,
                                56.34613
                            ],
                            [
                                -132.63141,
                                56.41653
                            ],
                            [
                                -132.71501,
                                56.45501
                            ],
                            [
                                -132.91665,
                                56.45689
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -178.15178,
                                51.91357
                            ],
                            [
                                -178.21074,
                                51.85497
                            ],
                            [
                                -177.95234,
                                51.76105
                            ],
                            [
                                -178.00735,
                                51.64861
                            ],
                            [
                                -177.84191,
                                51.68839
                            ],
                            [
                                -177.84153,
                                51.73064
                            ],
                            [
                                -177.75946,
                                51.80862
                            ],
                            [
                                -177.92345,
                                51.85402
                            ],
                            [
                                -177.95231,
                                51.91576
                            ],
                            [
                                -178.15178,
                                51.91357
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -160.82245,
                                55.35942
                            ],
                            [
                                -160.85132,
                                55.20845
                            ],
                            [
                                -160.78565,
                                55.15843
                            ],
                            [
                                -160.69924,
                                55.198
                            ],
                            [
                                -160.61513,
                                55.14964
                            ],
                            [
                                -160.54268,
                                55.15816
                            ],
                            [
                                -160.49454,
                                55.22043
                            ],
                            [
                                -160.56674,
                                55.27433
                            ],
                            [
                                -160.66383,
                                55.39704
                            ],
                            [
                                -160.72991,
                                55.40662
                            ],
                            [
                                -160.82245,
                                55.35942
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -173.60212,
                                52.15241
                            ],
                            [
                                -173.86563,
                                52.10985
                            ],
                            [
                                -173.83638,
                                52.04134
                            ],
                            [
                                -173.68033,
                                52.06653
                            ],
                            [
                                -173.54842,
                                52.0274
                            ],
                            [
                                -173.4497,
                                52.04729
                            ],
                            [
                                -173.15606,
                                52.06036
                            ],
                            [
                                -173.27277,
                                52.10895
                            ],
                            [
                                -173.49448,
                                52.10334
                            ],
                            [
                                -173.60212,
                                52.15241
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -157.25887,
                                21.21585
                            ],
                            [
                                -157.25225,
                                21.17691
                            ],
                            [
                                -157.3096,
                                21.1017
                            ],
                            [
                                -157.24834,
                                21.08559
                            ],
                            [
                                -157.0758,
                                21.10626
                            ],
                            [
                                -156.97726,
                                21.07089
                            ],
                            [
                                -156.83594,
                                21.05455
                            ],
                            [
                                -156.77527,
                                21.08313
                            ],
                            [
                                -156.71281,
                                21.1451
                            ],
                            [
                                -156.74157,
                                21.1732
                            ],
                            [
                                -156.90019,
                                21.16206
                            ],
                            [
                                -156.95948,
                                21.20786
                            ],
                            [
                                -156.99744,
                                21.1796
                            ],
                            [
                                -157.25887,
                                21.21585
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -122.60314,
                                48.41003
                            ],
                            [
                                -122.67001,
                                48.36142
                            ],
                            [
                                -122.75217,
                                48.26043
                            ],
                            [
                                -122.76228,
                                48.21501
                            ],
                            [
                                -122.67857,
                                48.15588
                            ],
                            [
                                -122.61214,
                                48.15404
                            ],
                            [
                                -122.60626,
                                48.03086
                            ],
                            [
                                -122.5211,
                                47.97408
                            ],
                            [
                                -122.34952,
                                47.96055
                            ],
                            [
                                -122.37976,
                                48.03317
                            ],
                            [
                                -122.49193,
                                48.09564
                            ],
                            [
                                -122.65735,
                                48.24524
                            ],
                            [
                                -122.55613,
                                48.28119
                            ],
                            [
                                -122.56303,
                                48.3469
                            ],
                            [
                                -122.60314,
                                48.41003
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -131.56529,
                                55.2832
                            ],
                            [
                                -131.60648,
                                55.24031
                            ],
                            [
                                -131.59126,
                                55.16926
                            ],
                            [
                                -131.63433,
                                55.01014
                            ],
                            [
                                -131.50586,
                                55.0249
                            ],
                            [
                                -131.39064,
                                55.01291
                            ],
                            [
                                -131.35327,
                                55.12446
                            ],
                            [
                                -131.39442,
                                55.20628
                            ],
                            [
                                -131.56529,
                                55.2832
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -172.96519,
                                60.59094
                            ],
                            [
                                -173.04098,
                                60.56157
                            ],
                            [
                                -173.05248,
                                60.49484
                            ],
                            [
                                -172.93339,
                                60.47698
                            ],
                            [
                                -172.73788,
                                60.3655
                            ],
                            [
                                -172.59855,
                                60.31721
                            ],
                            [
                                -172.41103,
                                60.33648
                            ],
                            [
                                -172.50703,
                                60.38047
                            ],
                            [
                                -172.77667,
                                60.45151
                            ],
                            [
                                -172.87826,
                                60.50106
                            ],
                            [
                                -172.96519,
                                60.59094
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -177.19863,
                                51.92318
                            ],
                            [
                                -177.21066,
                                51.81388
                            ],
                            [
                                -177.26978,
                                51.78601
                            ],
                            [
                                -177.46123,
                                51.75518
                            ],
                            [
                                -177.27542,
                                51.67923
                            ],
                            [
                                -177.12502,
                                51.72572
                            ],
                            [
                                -177.11918,
                                51.84051
                            ],
                            [
                                -177.06774,
                                51.86027
                            ],
                            [
                                -177.09486,
                                51.93143
                            ],
                            [
                                -177.19863,
                                51.92318
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -160.71128,
                                58.78207
                            ],
                            [
                                -160.92261,
                                58.74401
                            ],
                            [
                                -161.05449,
                                58.70044
                            ],
                            [
                                -161.06708,
                                58.54965
                            ],
                            [
                                -160.88324,
                                58.58238
                            ],
                            [
                                -160.71128,
                                58.78207
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -147.6827,
                                60.47276
                            ],
                            [
                                -147.78266,
                                60.42904
                            ],
                            [
                                -147.83681,
                                60.31626
                            ],
                            [
                                -147.91569,
                                60.22741
                            ],
                            [
                                -147.75942,
                                60.15979
                            ],
                            [
                                -147.72233,
                                60.26589
                            ],
                            [
                                -147.62498,
                                60.36214
                            ],
                            [
                                -147.6827,
                                60.47276
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -165.98833,
                                54.21138
                            ],
                            [
                                -166.08323,
                                54.17157
                            ],
                            [
                                -166.10708,
                                54.11858
                            ],
                            [
                                -166.0516,
                                54.07668
                            ],
                            [
                                -165.854,
                                54.05567
                            ],
                            [
                                -165.68078,
                                54.09317
                            ],
                            [
                                -165.75512,
                                54.16202
                            ],
                            [
                                -165.98833,
                                54.21138
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -153.28541,
                                57.19985
                            ],
                            [
                                -153.37917,
                                57.11762
                            ],
                            [
                                -153.38696,
                                57.06352
                            ],
                            [
                                -153.23602,
                                57.00611
                            ],
                            [
                                -153.21858,
                                57.06522
                            ],
                            [
                                -153.04194,
                                57.12004
                            ],
                            [
                                -152.87151,
                                57.15004
                            ],
                            [
                                -152.94807,
                                57.1868
                            ],
                            [
                                -153.07138,
                                57.16815
                            ],
                            [
                                -153.28541,
                                57.19985
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                178.64939,
                                51.65746
                            ],
                            [
                                178.63476,
                                51.62423
                            ],
                            [
                                178.76724,
                                51.57579
                            ],
                            [
                                178.94733,
                                51.54176
                            ],
                            [
                                179.21164,
                                51.35994
                            ],
                            [
                                179.33091,
                                51.36424
                            ],
                            [
                                179.2144,
                                51.44006
                            ],
                            [
                                179.08757,
                                51.49158
                            ],
                            [
                                178.8938,
                                51.61632
                            ],
                            [
                                178.64939,
                                51.65746
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                177.58236,
                                52.13363
                            ],
                            [
                                177.48075,
                                51.98261
                            ],
                            [
                                177.36828,
                                51.97559
                            ],
                            [
                                177.20217,
                                51.88101
                            ],
                            [
                                177.32459,
                                51.82923
                            ],
                            [
                                177.34941,
                                51.90596
                            ],
                            [
                                177.53292,
                                51.97067
                            ],
                            [
                                177.6732,
                                52.08837
                            ],
                            [
                                177.58236,
                                52.13363
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -131.82618,
                                55.41854
                            ],
                            [
                                -131.87661,
                                55.37991
                            ],
                            [
                                -131.82553,
                                55.18742
                            ],
                            [
                                -131.76116,
                                55.12924
                            ],
                            [
                                -131.61898,
                                55.29563
                            ],
                            [
                                -131.82618,
                                55.41854
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -159.92419,
                                55.22282
                            ],
                            [
                                -159.99142,
                                55.11969
                            ],
                            [
                                -160.12102,
                                55.13431
                            ],
                            [
                                -160.08306,
                                55.03959
                            ],
                            [
                                -159.86879,
                                55.09684
                            ],
                            [
                                -159.82239,
                                55.14159
                            ],
                            [
                                -159.92419,
                                55.22282
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -136.54229,
                                58.09158
                            ],
                            [
                                -136.56135,
                                57.91191
                            ],
                            [
                                -136.46828,
                                57.88612
                            ],
                            [
                                -136.37752,
                                57.93768
                            ],
                            [
                                -136.37582,
                                57.99419
                            ],
                            [
                                -136.33981,
                                58.01089
                            ],
                            [
                                -136.42651,
                                58.05675
                            ],
                            [
                                -136.47019,
                                58.0977
                            ],
                            [
                                -136.54229,
                                58.09158
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -156.86361,
                                20.75276
                            ],
                            [
                                -156.806,
                                20.80811
                            ],
                            [
                                -156.89234,
                                20.91101
                            ],
                            [
                                -156.98732,
                                20.9288
                            ],
                            [
                                -157.05212,
                                20.91273
                            ],
                            [
                                -157.00614,
                                20.84916
                            ],
                            [
                                -156.96194,
                                20.73228
                            ],
                            [
                                -156.86361,
                                20.75276
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -97.04994,
                                27.83069
                            ],
                            [
                                -97.10354,
                                27.81384
                            ],
                            [
                                -97.19308,
                                27.68797
                            ],
                            [
                                -97.35828,
                                27.3656
                            ],
                            [
                                -97.38964,
                                27.05047
                            ],
                            [
                                -97.38843,
                                26.82978
                            ],
                            [
                                -97.33986,
                                26.76234
                            ],
                            [
                                -97.37714,
                                27.00537
                            ],
                            [
                                -97.36768,
                                27.18228
                            ],
                            [
                                -97.30835,
                                27.39721
                            ],
                            [
                                -97.18458,
                                27.64702
                            ],
                            [
                                -97.04994,
                                27.83069
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -68.33966,
                                44.42364
                            ],
                            [
                                -68.42781,
                                44.31036
                            ],
                            [
                                -68.36354,
                                44.23131
                            ],
                            [
                                -68.29188,
                                44.24971
                            ],
                            [
                                -68.17504,
                                44.3298
                            ],
                            [
                                -68.25037,
                                44.43276
                            ],
                            [
                                -68.33966,
                                44.42364
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -153.25718,
                                58.13933
                            ],
                            [
                                -153.39798,
                                58.07941
                            ],
                            [
                                -153.36366,
                                58.0397
                            ],
                            [
                                -153.22532,
                                58.04948
                            ],
                            [
                                -153.05587,
                                57.98938
                            ],
                            [
                                -153.09261,
                                58.08903
                            ],
                            [
                                -153.16934,
                                58.08937
                            ],
                            [
                                -153.25718,
                                58.13933
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                173.67376,
                                52.50677
                            ],
                            [
                                173.52768,
                                52.44746
                            ],
                            [
                                173.38077,
                                52.43028
                            ],
                            [
                                173.47152,
                                52.38109
                            ],
                            [
                                173.60745,
                                52.37942
                            ],
                            [
                                173.72334,
                                52.35595
                            ],
                            [
                                173.67376,
                                52.50677
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -145.80284,
                                60.58806
                            ],
                            [
                                -145.95229,
                                60.58117
                            ],
                            [
                                -146.03875,
                                60.54991
                            ],
                            [
                                -146.32437,
                                60.50026
                            ],
                            [
                                -146.22727,
                                60.45167
                            ],
                            [
                                -146.10253,
                                60.47458
                            ],
                            [
                                -145.80682,
                                60.56021
                            ],
                            [
                                -145.80284,
                                60.58806
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -96.4318,
                                28.39431
                            ],
                            [
                                -96.44402,
                                28.3422
                            ],
                            [
                                -96.6448,
                                28.25299
                            ],
                            [
                                -96.73008,
                                28.1899
                            ],
                            [
                                -96.81155,
                                28.17566
                            ],
                            [
                                -96.877,
                                28.12678
                            ],
                            [
                                -96.95611,
                                28.03143
                            ],
                            [
                                -96.95375,
                                27.96373
                            ],
                            [
                                -96.83107,
                                28.07887
                            ],
                            [
                                -96.71543,
                                28.16653
                            ],
                            [
                                -96.41039,
                                28.34411
                            ],
                            [
                                -96.4318,
                                28.39431
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                179.61815,
                                52.02415
                            ],
                            [
                                179.48949,
                                51.95928
                            ],
                            [
                                179.47963,
                                51.92335
                            ],
                            [
                                179.6122,
                                51.87217
                            ],
                            [
                                179.73864,
                                51.91197
                            ],
                            [
                                179.7638,
                                51.97418
                            ],
                            [
                                179.61815,
                                52.02415
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -152.34928,
                                58.60747
                            ],
                            [
                                -152.45034,
                                58.62394
                            ],
                            [
                                -152.64366,
                                58.51876
                            ],
                            [
                                -152.47808,
                                58.47123
                            ],
                            [
                                -152.34928,
                                58.60747
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -172.47997,
                                52.37861
                            ],
                            [
                                -172.6178,
                                52.3015
                            ],
                            [
                                -172.60632,
                                52.25357
                            ],
                            [
                                -172.47935,
                                52.26488
                            ],
                            [
                                -172.31754,
                                52.31707
                            ],
                            [
                                -172.30659,
                                52.35373
                            ],
                            [
                                -172.47997,
                                52.37861
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -91.9255,
                                29.63237
                            ],
                            [
                                -92.00305,
                                29.60165
                            ],
                            [
                                -92.01292,
                                29.56026
                            ],
                            [
                                -91.78211,
                                29.48409
                            ],
                            [
                                -91.71805,
                                29.55189
                            ],
                            [
                                -91.84497,
                                29.62592
                            ],
                            [
                                -91.9255,
                                29.63237
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -133.55316,
                                55.83468
                            ],
                            [
                                -133.69914,
                                55.78275
                            ],
                            [
                                -133.64071,
                                55.72808
                            ],
                            [
                                -133.53122,
                                55.69393
                            ],
                            [
                                -133.42135,
                                55.7413
                            ],
                            [
                                -133.55316,
                                55.83468
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -132.79274,
                                55.1706
                            ],
                            [
                                -132.89176,
                                55.16177
                            ],
                            [
                                -132.76638,
                                54.99886
                            ],
                            [
                                -132.68828,
                                55.028
                            ],
                            [
                                -132.69069,
                                55.12422
                            ],
                            [
                                -132.79274,
                                55.1706
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -70.59866,
                                41.45755
                            ],
                            [
                                -70.65759,
                                41.45946
                            ],
                            [
                                -70.77197,
                                41.35241
                            ],
                            [
                                -70.50041,
                                41.35145
                            ],
                            [
                                -70.50628,
                                41.39549
                            ],
                            [
                                -70.59866,
                                41.45755
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -119.92188,
                                34.07001
                            ],
                            [
                                -119.8737,
                                33.98157
                            ],
                            [
                                -119.72059,
                                33.96039
                            ],
                            [
                                -119.63592,
                                34.01379
                            ],
                            [
                                -119.75954,
                                34.05785
                            ],
                            [
                                -119.92188,
                                34.07001
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -154.14905,
                                56.60846
                            ],
                            [
                                -154.29861,
                                56.59225
                            ],
                            [
                                -154.33998,
                                56.5102
                            ],
                            [
                                -154.1547,
                                56.51005
                            ],
                            [
                                -154.07524,
                                56.58792
                            ],
                            [
                                -154.14905,
                                56.60846
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -131.25594,
                                54.97706
                            ],
                            [
                                -131.47908,
                                54.95615
                            ],
                            [
                                -131.47386,
                                54.91208
                            ],
                            [
                                -131.34762,
                                54.85708
                            ],
                            [
                                -131.1915,
                                54.91651
                            ],
                            [
                                -131.25594,
                                54.97706
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -162.43303,
                                63.63444
                            ],
                            [
                                -162.56911,
                                63.63376
                            ],
                            [
                                -162.68474,
                                63.59174
                            ],
                            [
                                -162.60145,
                                63.53916
                            ],
                            [
                                -162.44359,
                                63.54143
                            ],
                            [
                                -162.34693,
                                63.59163
                            ],
                            [
                                -162.43303,
                                63.63444
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -170.65494,
                                52.69769
                            ],
                            [
                                -170.81613,
                                52.63603
                            ],
                            [
                                -170.79517,
                                52.54332
                            ],
                            [
                                -170.68242,
                                52.60307
                            ],
                            [
                                -170.61215,
                                52.60081
                            ],
                            [
                                -170.56322,
                                52.67545
                            ],
                            [
                                -170.65494,
                                52.69769
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -153.2561,
                                57.87588
                            ],
                            [
                                -153.35372,
                                57.93248
                            ],
                            [
                                -153.50228,
                                57.9649
                            ],
                            [
                                -153.53383,
                                57.92958
                            ],
                            [
                                -153.32081,
                                57.83017
                            ],
                            [
                                -153.2561,
                                57.87588
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -154.53568,
                                56.56309
                            ],
                            [
                                -154.68789,
                                56.52659
                            ],
                            [
                                -154.79052,
                                56.43928
                            ],
                            [
                                -154.72865,
                                56.40614
                            ],
                            [
                                -154.59809,
                                56.48482
                            ],
                            [
                                -154.46665,
                                56.51299
                            ],
                            [
                                -154.53568,
                                56.56309
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -169.78444,
                                52.89134
                            ],
                            [
                                -169.88819,
                                52.8496
                            ],
                            [
                                -169.98508,
                                52.85708
                            ],
                            [
                                -169.95875,
                                52.78769
                            ],
                            [
                                -169.87122,
                                52.82576
                            ],
                            [
                                -169.67655,
                                52.82291
                            ],
                            [
                                -169.67216,
                                52.86796
                            ],
                            [
                                -169.78444,
                                52.89134
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -148.07766,
                                60.92087
                            ],
                            [
                                -148.15044,
                                60.81881
                            ],
                            [
                                -148.02924,
                                60.78239
                            ],
                            [
                                -147.9187,
                                60.81069
                            ],
                            [
                                -147.95681,
                                60.89815
                            ],
                            [
                                -148.07766,
                                60.92087
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -165.54688,
                                54.29314
                            ],
                            [
                                -165.67545,
                                54.26466
                            ],
                            [
                                -165.57182,
                                54.10964
                            ],
                            [
                                -165.4775,
                                54.18038
                            ],
                            [
                                -165.57273,
                                54.25089
                            ],
                            [
                                -165.54688,
                                54.29314
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -133.38133,
                                55.33726
                            ],
                            [
                                -133.45706,
                                55.3188
                            ],
                            [
                                -133.43549,
                                55.21018
                            ],
                            [
                                -133.25607,
                                55.22186
                            ],
                            [
                                -133.22716,
                                55.27189
                            ],
                            [
                                -133.38133,
                                55.33726
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -120.09065,
                                34.02004
                            ],
                            [
                                -120.13932,
                                34.0257
                            ],
                            [
                                -120.22369,
                                33.98813
                            ],
                            [
                                -120.17867,
                                33.92472
                            ],
                            [
                                -120.11957,
                                33.89487
                            ],
                            [
                                -119.96897,
                                33.94283
                            ],
                            [
                                -119.97946,
                                33.98271
                            ],
                            [
                                -120.09065,
                                34.02004
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -162.34264,
                                54.97401
                            ],
                            [
                                -162.42317,
                                54.88556
                            ],
                            [
                                -162.3175,
                                54.82875
                            ],
                            [
                                -162.23357,
                                54.88674
                            ],
                            [
                                -162.23487,
                                54.95496
                            ],
                            [
                                -162.34264,
                                54.97401
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -176.15777,
                                52.11258
                            ],
                            [
                                -176.21158,
                                52.06293
                            ],
                            [
                                -176.18799,
                                52.00017
                            ],
                            [
                                -176.02505,
                                51.98154
                            ],
                            [
                                -175.98088,
                                52.02975
                            ],
                            [
                                -176.04475,
                                52.09835
                            ],
                            [
                                -176.15777,
                                52.11258
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -97.32573,
                                26.55938
                            ],
                            [
                                -97.3348,
                                26.51052
                            ],
                            [
                                -97.29913,
                                26.45619
                            ],
                            [
                                -97.26528,
                                26.3467
                            ],
                            [
                                -97.21895,
                                26.39048
                            ],
                            [
                                -97.27029,
                                26.55962
                            ],
                            [
                                -97.32573,
                                26.55938
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -118.60422,
                                33.47732
                            ],
                            [
                                -118.57439,
                                33.44055
                            ],
                            [
                                -118.48852,
                                33.4198
                            ],
                            [
                                -118.45984,
                                33.32352
                            ],
                            [
                                -118.30787,
                                33.33149
                            ],
                            [
                                -118.36761,
                                33.40661
                            ],
                            [
                                -118.60422,
                                33.47732
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -122.93835,
                                48.71087
                            ],
                            [
                                -123.00917,
                                48.65439
                            ],
                            [
                                -122.95271,
                                48.60541
                            ],
                            [
                                -122.82781,
                                48.60281
                            ],
                            [
                                -122.74459,
                                48.66151
                            ],
                            [
                                -122.87793,
                                48.71191
                            ],
                            [
                                -122.93835,
                                48.71087
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -132.76303,
                                54.93203
                            ],
                            [
                                -132.80444,
                                54.86742
                            ],
                            [
                                -132.70459,
                                54.81055
                            ],
                            [
                                -132.6353,
                                54.89262
                            ],
                            [
                                -132.76303,
                                54.93203
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -123.15572,
                                48.61567
                            ],
                            [
                                -123.17555,
                                48.56467
                            ],
                            [
                                -123.13293,
                                48.49949
                            ],
                            [
                                -123.03755,
                                48.45954
                            ],
                            [
                                -123.00688,
                                48.54955
                            ],
                            [
                                -123.10481,
                                48.62042
                            ],
                            [
                                -123.15572,
                                48.61567
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -148.08589,
                                60.12719
                            ],
                            [
                                -148.29022,
                                60.10277
                            ],
                            [
                                -148.29462,
                                60.01982
                            ],
                            [
                                -148.17918,
                                60.02382
                            ],
                            [
                                -148.08589,
                                60.12719
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -162.77976,
                                54.48525
                            ],
                            [
                                -162.77252,
                                54.41129
                            ],
                            [
                                -162.57122,
                                54.38871
                            ],
                            [
                                -162.61677,
                                54.45319
                            ],
                            [
                                -162.77976,
                                54.48525
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -133.59468,
                                55.42628
                            ],
                            [
                                -133.65993,
                                55.38005
                            ],
                            [
                                -133.66617,
                                55.2766
                            ],
                            [
                                -133.46206,
                                55.3795
                            ],
                            [
                                -133.59468,
                                55.42628
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -155.57775,
                                55.77888
                            ],
                            [
                                -155.60847,
                                55.9125
                            ],
                            [
                                -155.75309,
                                55.82097
                            ],
                            [
                                -155.72548,
                                55.7743
                            ],
                            [
                                -155.57775,
                                55.77888
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -144.96904,
                                60.52977
                            ],
                            [
                                -145.04449,
                                60.43853
                            ],
                            [
                                -144.91286,
                                60.43256
                            ],
                            [
                                -144.82579,
                                60.5022
                            ],
                            [
                                -144.96904,
                                60.52977
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -160.1104,
                                21.99308
                            ],
                            [
                                -160.12609,
                                21.9541
                            ],
                            [
                                -160.22715,
                                21.88804
                            ],
                            [
                                -160.24536,
                                21.84544
                            ],
                            [
                                -160.20252,
                                21.78009
                            ],
                            [
                                -160.15848,
                                21.86482
                            ],
                            [
                                -160.07456,
                                21.89633
                            ],
                            [
                                -160.06891,
                                22.00168
                            ],
                            [
                                -160.1104,
                                21.99308
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -161.85092,
                                55.17571
                            ],
                            [
                                -161.75704,
                                55.05722
                            ],
                            [
                                -161.68194,
                                55.07074
                            ],
                            [
                                -161.64303,
                                55.12746
                            ],
                            [
                                -161.85092,
                                55.17571
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -118.60552,
                                33.03207
                            ],
                            [
                                -118.54181,
                                32.91037
                            ],
                            [
                                -118.42532,
                                32.80285
                            ],
                            [
                                -118.35056,
                                32.82012
                            ],
                            [
                                -118.48567,
                                32.92368
                            ],
                            [
                                -118.56359,
                                33.02376
                            ],
                            [
                                -118.60552,
                                33.03207
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -133.75653,
                                55.53569
                            ],
                            [
                                -133.77015,
                                55.49896
                            ],
                            [
                                -133.67009,
                                55.43977
                            ],
                            [
                                -133.59686,
                                55.5442
                            ],
                            [
                                -133.75653,
                                55.53569
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -166.14416,
                                53.84371
                            ],
                            [
                                -166.29929,
                                53.79769
                            ],
                            [
                                -166.24077,
                                53.71244
                            ],
                            [
                                -166.1196,
                                53.77331
                            ],
                            [
                                -166.14416,
                                53.84371
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -153.43505,
                                59.41208
                            ],
                            [
                                -153.51079,
                                59.39213
                            ],
                            [
                                -153.50957,
                                59.32047
                            ],
                            [
                                -153.3638,
                                59.33848
                            ],
                            [
                                -153.43505,
                                59.41208
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -144.24838,
                                60.00103
                            ],
                            [
                                -144.30746,
                                59.98566
                            ],
                            [
                                -144.56504,
                                59.85147
                            ],
                            [
                                -144.56013,
                                59.81156
                            ],
                            [
                                -144.24838,
                                60.00103
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -169.76346,
                                56.61478
                            ],
                            [
                                -169.66778,
                                56.55142
                            ],
                            [
                                -169.57819,
                                56.53198
                            ],
                            [
                                -169.50356,
                                56.60685
                            ],
                            [
                                -169.76346,
                                56.61478
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -148.21697,
                                60.74684
                            ],
                            [
                                -148.23855,
                                60.69667
                            ],
                            [
                                -148.08891,
                                60.67671
                            ],
                            [
                                -148.11563,
                                60.74746
                            ],
                            [
                                -148.21697,
                                60.74684
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -159.51697,
                                55.20739
                            ],
                            [
                                -159.65017,
                                55.12078
                            ],
                            [
                                -159.64879,
                                55.04784
                            ],
                            [
                                -159.57212,
                                55.04681
                            ],
                            [
                                -159.49971,
                                55.137
                            ],
                            [
                                -159.51697,
                                55.20739
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -165.00346,
                                54.13601
                            ],
                            [
                                -165.14482,
                                54.1287
                            ],
                            [
                                -165.04055,
                                54.06566
                            ],
                            [
                                -165.00346,
                                54.13601
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -147.86864,
                                60.07257
                            ],
                            [
                                -148.05493,
                                59.95048
                            ],
                            [
                                -147.90492,
                                59.9733
                            ],
                            [
                                -147.82186,
                                60.0468
                            ],
                            [
                                -147.86864,
                                60.07257
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -133.39443,
                                55.56274
                            ],
                            [
                                -133.4543,
                                55.53159
                            ],
                            [
                                -133.36625,
                                55.45542
                            ],
                            [
                                -133.28906,
                                55.53627
                            ],
                            [
                                -133.39443,
                                55.56274
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -70.03097,
                                41.31528
                            ],
                            [
                                -70.18141,
                                41.29399
                            ],
                            [
                                -70.11322,
                                41.24185
                            ],
                            [
                                -70.00634,
                                41.24009
                            ],
                            [
                                -69.96188,
                                41.27748
                            ],
                            [
                                -70.03097,
                                41.31528
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -157.26626,
                                56.57972
                            ],
                            [
                                -157.30745,
                                56.53164
                            ],
                            [
                                -157.15169,
                                56.52856
                            ],
                            [
                                -157.09009,
                                56.58152
                            ],
                            [
                                -157.26626,
                                56.57972
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -71.23353,
                                41.5145
                            ],
                            [
                                -71.27184,
                                41.62114
                            ],
                            [
                                -71.32466,
                                41.52062
                            ],
                            [
                                -71.23353,
                                41.5145
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -133.49709,
                                55.51694
                            ],
                            [
                                -133.61587,
                                55.45626
                            ],
                            [
                                -133.54916,
                                55.43019
                            ],
                            [
                                -133.43179,
                                55.44987
                            ],
                            [
                                -133.49709,
                                55.51694
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -148.02307,
                                60.37275
                            ],
                            [
                                -148.15487,
                                60.30862
                            ],
                            [
                                -148.02412,
                                60.27902
                            ],
                            [
                                -148.02307,
                                60.37275
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -156.60503,
                                20.59089
                            ],
                            [
                                -156.67549,
                                20.55585
                            ],
                            [
                                -156.66587,
                                20.50162
                            ],
                            [
                                -156.56756,
                                20.51635
                            ],
                            [
                                -156.53925,
                                20.57647
                            ],
                            [
                                -156.60503,
                                20.59089
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -94.79558,
                                29.30974
                            ],
                            [
                                -94.86796,
                                29.29124
                            ],
                            [
                                -95.0632,
                                29.12468
                            ],
                            [
                                -94.80257,
                                29.27984
                            ],
                            [
                                -94.79558,
                                29.30974
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -82.16344,
                                26.70628
                            ],
                            [
                                -82.09495,
                                26.48992
                            ],
                            [
                                -82.06465,
                                26.49501
                            ],
                            [
                                -82.12359,
                                26.69362
                            ],
                            [
                                -82.16344,
                                26.70628
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -178.8301,
                                51.83466
                            ],
                            [
                                -178.87342,
                                51.78208
                            ],
                            [
                                -178.75173,
                                51.7555
                            ],
                            [
                                -178.75058,
                                51.81114
                            ],
                            [
                                -178.8301,
                                51.83466
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -132.40625,
                                56.39387
                            ],
                            [
                                -132.49182,
                                56.43894
                            ],
                            [
                                -132.55495,
                                56.40431
                            ],
                            [
                                -132.50298,
                                56.35249
                            ],
                            [
                                -132.40625,
                                56.39387
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -122.54546,
                                47.69372
                            ],
                            [
                                -122.59107,
                                47.66216
                            ],
                            [
                                -122.57359,
                                47.59558
                            ],
                            [
                                -122.49883,
                                47.59858
                            ],
                            [
                                -122.54546,
                                47.69372
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -159.45271,
                                55.06033
                            ],
                            [
                                -159.45168,
                                54.97048
                            ],
                            [
                                -159.33058,
                                54.97866
                            ],
                            [
                                -159.45271,
                                55.06033
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                178.49425,
                                51.98225
                            ],
                            [
                                178.43839,
                                51.94747
                            ],
                            [
                                178.51676,
                                51.8995
                            ],
                            [
                                178.57084,
                                51.9664
                            ],
                            [
                                178.49425,
                                51.98225
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -68.84937,
                                44.1245
                            ],
                            [
                                -68.9091,
                                44.09763
                            ],
                            [
                                -68.81073,
                                44.03717
                            ],
                            [
                                -68.77666,
                                44.07955
                            ],
                            [
                                -68.84937,
                                44.1245
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "UGA",
                "Country": "Uganda",
                "Total_3GHG": 0.18,
                "Total_3GHG_timeseries": [
                    2.0705e-06,
                    4.117e-06,
                    6.145e-06,
                    8.1584e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029
                ],
                "Fossil_3GHG": 0.07,
                "Fossil_3GHG_timeseries": [
                    9.8815e-08,
                    2.045e-07,
                    3.1719e-07,
                    4.3701e-07,
                    5.641e-07,
                    6.9859e-07,
                    8.406e-07,
                    9.9028e-07,
                    1.1478e-06,
                    1.3132e-06,
                    1.4872e-06,
                    1.6701e-06,
                    1.862e-06,
                    2.063e-06,
                    2.2734e-06,
                    2.4933e-06,
                    2.7228e-06,
                    2.9622e-06,
                    3.2117e-06,
                    3.4714e-06,
                    3.7358e-06,
                    4.0051e-06,
                    4.2795e-06,
                    4.5593e-06,
                    4.8446e-06,
                    5.1355e-06,
                    5.4319e-06,
                    5.734e-06,
                    6.0417e-06,
                    6.3549e-06,
                    6.6731e-06,
                    6.9963e-06,
                    7.3246e-06,
                    7.6581e-06,
                    7.9969e-06,
                    8.3411e-06,
                    8.6907e-06,
                    9.0459e-06,
                    9.4068e-06,
                    9.7742e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Land_3GHG": 0.38,
                "Land_3GHG_timeseries": [
                    1.9717e-06,
                    3.9125e-06,
                    5.8278e-06,
                    7.7213e-06,
                    9.6686e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022
                ],
                "Total_CO2": 0.13,
                "Total_CO2_timeseries": [
                    1.7456e-06,
                    3.459e-06,
                    5.1454e-06,
                    6.8087e-06,
                    8.5245e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014
                ],
                "Fossil_CO2": 0.01,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    4.785e-08,
                    1.1055e-07,
                    1.749e-07,
                    2.6891e-07,
                    3.6783e-07,
                    4.8654e-07,
                    6.0523e-07,
                    7.3047e-07,
                    8.6228e-07,
                    1.0486e-06,
                    1.2382e-06,
                    1.4212e-06,
                    1.6142e-06,
                    1.8088e-06,
                    2.0297e-06,
                    2.3117e-06,
                    2.6414e-06,
                    3.0058e-06,
                    3.4478e-06,
                    3.9771e-06,
                    4.6268e-06,
                    5.2743e-06,
                    5.895e-06,
                    6.4248e-06,
                    6.9606e-06,
                    7.4688e-06,
                    7.9125e-06,
                    8.2737e-06,
                    8.5867e-06,
                    8.8889e-06,
                    9.1708e-06,
                    9.4081e-06,
                    9.6534e-06,
                    9.9297e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001
                ],
                "Land_CO2": 0.39,
                "Land_CO2_timeseries": [
                    1.7456e-06,
                    3.459e-06,
                    5.1454e-06,
                    6.8087e-06,
                    8.5245e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014
                ],
                "Total_CH4": 0.3,
                "Total_CH4_timeseries": [
                    2.2756e-07,
                    4.6175e-07,
                    7.0272e-07,
                    9.5059e-07,
                    1.2055e-06,
                    1.4676e-06,
                    1.7371e-06,
                    2.0141e-06,
                    2.2987e-06,
                    2.5911e-06,
                    2.8945e-06,
                    3.2091e-06,
                    3.535e-06,
                    3.8725e-06,
                    4.2217e-06,
                    4.5827e-06,
                    4.9557e-06,
                    5.341e-06,
                    5.7387e-06,
                    6.1491e-06,
                    6.5664e-06,
                    6.9907e-06,
                    7.4222e-06,
                    7.8608e-06,
                    8.3067e-06,
                    8.76e-06,
                    9.2208e-06,
                    9.689e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013
                ],
                "Fossil_CH4": 0.24,
                "Fossil_CH4_timeseries": [
                    6.8135e-08,
                    1.4277e-07,
                    2.2404e-07,
                    3.1209e-07,
                    4.0705e-07,
                    5.0908e-07,
                    6.1831e-07,
                    7.3491e-07,
                    8.5902e-07,
                    9.908e-07,
                    1.131e-06,
                    1.2798e-06,
                    1.4373e-06,
                    1.6037e-06,
                    1.7792e-06,
                    1.9639e-06,
                    2.1581e-06,
                    2.3619e-06,
                    2.5756e-06,
                    2.7992e-06,
                    3.0272e-06,
                    3.2595e-06,
                    3.4962e-06,
                    3.7375e-06,
                    3.9833e-06,
                    4.2339e-06,
                    4.4892e-06,
                    4.7493e-06,
                    5.0144e-06,
                    5.2845e-06,
                    5.5592e-06,
                    5.8385e-06,
                    6.1227e-06,
                    6.4117e-06,
                    6.7056e-06,
                    7.0046e-06,
                    7.3088e-06,
                    7.6183e-06,
                    7.9331e-06,
                    8.2534e-06,
                    8.5792e-06,
                    8.9108e-06,
                    9.2482e-06,
                    9.5916e-06,
                    9.9409e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006
                ],
                "Land_CH4": 0.4,
                "Land_CH4_timeseries": [
                    1.5942e-07,
                    3.1898e-07,
                    4.7867e-07,
                    6.385e-07,
                    7.9846e-07,
                    9.5855e-07,
                    1.1188e-06,
                    1.2791e-06,
                    1.4396e-06,
                    1.6003e-06,
                    1.7635e-06,
                    1.9293e-06,
                    2.0978e-06,
                    2.2688e-06,
                    2.4425e-06,
                    2.6188e-06,
                    2.7976e-06,
                    2.9791e-06,
                    3.1632e-06,
                    3.3499e-06,
                    3.5392e-06,
                    3.7312e-06,
                    3.926e-06,
                    4.1234e-06,
                    4.3234e-06,
                    4.5262e-06,
                    4.7316e-06,
                    4.9397e-06,
                    5.1505e-06,
                    5.3639e-06,
                    5.5778e-06,
                    5.7922e-06,
                    6.0069e-06,
                    6.2221e-06,
                    6.4378e-06,
                    6.6538e-06,
                    6.8703e-06,
                    7.0873e-06,
                    7.3047e-06,
                    7.5225e-06,
                    7.7407e-06,
                    7.9594e-06,
                    8.1786e-06,
                    8.3982e-06,
                    8.6182e-06,
                    8.8387e-06,
                    9.0596e-06,
                    9.281e-06,
                    9.5028e-06,
                    9.7251e-06,
                    9.9497e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006
                ],
                "Total_N2O": 0.26,
                "Total_N2O_timeseries": [
                    9.728e-08,
                    1.9626e-07,
                    2.9689e-07,
                    3.9907e-07,
                    5.0269e-07,
                    6.0762e-07,
                    7.1369e-07,
                    8.2073e-07,
                    9.2852e-07,
                    1.0368e-06,
                    1.1455e-06,
                    1.2546e-06,
                    1.3639e-06,
                    1.4736e-06,
                    1.5835e-06,
                    1.6937e-06,
                    1.8042e-06,
                    1.915e-06,
                    2.0262e-06,
                    2.1378e-06,
                    2.251e-06,
                    2.368e-06,
                    2.4903e-06,
                    2.6192e-06,
                    2.7552e-06,
                    2.8986e-06,
                    3.049e-06,
                    3.2056e-06,
                    3.367e-06,
                    3.5315e-06,
                    3.6978e-06,
                    3.8656e-06,
                    4.0348e-06,
                    4.2052e-06,
                    4.3767e-06,
                    4.5493e-06,
                    4.7229e-06,
                    4.8976e-06,
                    5.0735e-06,
                    5.2573e-06,
                    5.4429e-06,
                    5.6303e-06,
                    5.8198e-06,
                    6.0112e-06,
                    6.2048e-06,
                    6.4006e-06,
                    6.5987e-06,
                    6.7991e-06,
                    7.0019e-06,
                    7.2071e-06,
                    7.4148e-06,
                    7.625e-06,
                    7.8377e-06,
                    8.053e-06,
                    8.2711e-06,
                    8.4921e-06,
                    8.7162e-06,
                    8.9436e-06,
                    9.1747e-06,
                    9.4098e-06,
                    9.6504e-06,
                    9.8989e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_N2O": 0.12,
                "Fossil_N2O_timeseries": [
                    3.068e-08,
                    6.1732e-08,
                    9.3151e-08,
                    1.2493e-07,
                    1.5705e-07,
                    1.8951e-07,
                    2.2229e-07,
                    2.5538e-07,
                    2.8875e-07,
                    3.2238e-07,
                    3.5626e-07,
                    3.9039e-07,
                    4.2476e-07,
                    4.5938e-07,
                    4.9423e-07,
                    5.2933e-07,
                    5.6467e-07,
                    6.0025e-07,
                    6.3608e-07,
                    6.7217e-07,
                    7.0861e-07,
                    7.4562e-07,
                    7.8334e-07,
                    8.2188e-07,
                    8.6129e-07,
                    9.016e-07,
                    9.4276e-07,
                    9.8471e-07,
                    1.0273e-06,
                    1.0704e-06,
                    1.1139e-06,
                    1.1578e-06,
                    1.2019e-06,
                    1.2465e-06,
                    1.2913e-06,
                    1.3364e-06,
                    1.3819e-06,
                    1.4277e-06,
                    1.4738e-06,
                    1.5209e-06,
                    1.5685e-06,
                    1.6167e-06,
                    1.6654e-06,
                    1.7147e-06,
                    1.7645e-06,
                    1.815e-06,
                    1.8661e-06,
                    1.9178e-06,
                    1.9701e-06,
                    2.0232e-06,
                    2.077e-06,
                    2.1315e-06,
                    2.187e-06,
                    2.2433e-06,
                    2.3006e-06,
                    2.3587e-06,
                    2.4178e-06,
                    2.4777e-06,
                    2.5385e-06,
                    2.5999e-06,
                    2.662e-06,
                    2.7248e-06,
                    2.7881e-06,
                    2.8521e-06,
                    2.9166e-06,
                    2.9817e-06,
                    3.0474e-06,
                    3.1137e-06,
                    3.1805e-06,
                    3.248e-06,
                    3.3161e-06,
                    3.3848e-06,
                    3.4541e-06,
                    3.524e-06,
                    3.5946e-06,
                    3.6658e-06,
                    3.7376e-06,
                    3.8102e-06,
                    3.8834e-06,
                    3.9573e-06,
                    4.0321e-06,
                    4.1077e-06,
                    4.1844e-06,
                    4.2623e-06,
                    4.3413e-06,
                    4.4216e-06,
                    4.5032e-06,
                    4.5862e-06,
                    4.6706e-06,
                    4.7564e-06,
                    4.844e-06,
                    4.9339e-06,
                    5.0264e-06,
                    5.122e-06,
                    5.2209e-06,
                    5.3232e-06,
                    5.4289e-06,
                    5.5379e-06,
                    5.65e-06,
                    5.765e-06,
                    5.8828e-06,
                    6.0035e-06,
                    6.1274e-06,
                    6.2545e-06,
                    6.3848e-06,
                    6.5183e-06,
                    6.6551e-06,
                    6.7948e-06,
                    6.9373e-06,
                    7.0825e-06,
                    7.2301e-06,
                    7.3803e-06,
                    7.5331e-06,
                    7.6888e-06,
                    7.8473e-06,
                    8.009e-06,
                    8.1739e-06,
                    8.3422e-06,
                    8.514e-06,
                    8.6988e-06,
                    8.8865e-06,
                    9.0766e-06,
                    9.2611e-06,
                    9.4426e-06,
                    9.6244e-06,
                    9.817e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.31,
                "Land_N2O_timeseries": [
                    6.66e-08,
                    1.3453e-07,
                    2.0374e-07,
                    2.7414e-07,
                    3.4564e-07,
                    4.1811e-07,
                    4.914e-07,
                    5.6535e-07,
                    6.3978e-07,
                    7.1446e-07,
                    7.8927e-07,
                    8.6418e-07,
                    9.3915e-07,
                    1.0142e-06,
                    1.0893e-06,
                    1.1644e-06,
                    1.2395e-06,
                    1.3148e-06,
                    1.3901e-06,
                    1.4656e-06,
                    1.5424e-06,
                    1.6223e-06,
                    1.707e-06,
                    1.7973e-06,
                    1.894e-06,
                    1.997e-06,
                    2.1063e-06,
                    2.2209e-06,
                    2.3397e-06,
                    2.4611e-06,
                    2.5838e-06,
                    2.7078e-06,
                    2.8329e-06,
                    2.9588e-06,
                    3.0854e-06,
                    3.2129e-06,
                    3.341e-06,
                    3.47e-06,
                    3.5998e-06,
                    3.7364e-06,
                    3.8744e-06,
                    4.0137e-06,
                    4.1544e-06,
                    4.2966e-06,
                    4.4403e-06,
                    4.5857e-06,
                    4.7326e-06,
                    4.8813e-06,
                    5.0317e-06,
                    5.1839e-06,
                    5.3378e-06,
                    5.4935e-06,
                    5.6507e-06,
                    5.8097e-06,
                    5.9705e-06,
                    6.1333e-06,
                    6.2984e-06,
                    6.4659e-06,
                    6.6363e-06,
                    6.8099e-06,
                    6.9884e-06,
                    7.1741e-06,
                    7.3692e-06,
                    7.575e-06,
                    7.7929e-06,
                    8.0234e-06,
                    8.2668e-06,
                    8.5231e-06,
                    8.7917e-06,
                    9.0714e-06,
                    9.3627e-06,
                    9.6668e-06,
                    9.9847e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            29.58951,
                            -1.38662
                        ],
                        [
                            29.67778,
                            -1.38374
                        ],
                        [
                            29.73213,
                            -1.3424
                        ],
                        [
                            29.86314,
                            -1.35834
                        ],
                        [
                            29.90034,
                            -1.46245
                        ],
                        [
                            29.97845,
                            -1.45675
                        ],
                        [
                            30.01582,
                            -1.41286
                        ],
                        [
                            30.16924,
                            -1.33974
                        ],
                        [
                            30.21238,
                            -1.27325
                        ],
                        [
                            30.34323,
                            -1.12653
                        ],
                        [
                            30.35276,
                            -1.06881
                        ],
                        [
                            30.47352,
                            -1.05741
                        ],
                        [
                            30.5394,
                            -1.07485
                        ],
                        [
                            30.66346,
                            -1.05787
                        ],
                        [
                            30.76708,
                            -0.98489
                        ],
                        [
                            30.80464,
                            -0.9999
                        ],
                        [
                            31.37269,
                            -0.9999
                        ],
                        [
                            31.89442,
                            -0.9999
                        ],
                        [
                            32.98994,
                            -0.99989
                        ],
                        [
                            33.93398,
                            -0.99989
                        ],
                        [
                            33.92553,
                            -0.56166
                        ],
                        [
                            33.92939,
                            -0.45994
                        ],
                        [
                            33.98438,
                            -0.13767
                        ],
                        [
                            33.91104,
                            0.09936
                        ],
                        [
                            34.04141,
                            0.28852
                        ],
                        [
                            34.09718,
                            0.34823
                        ],
                        [
                            34.15777,
                            0.59103
                        ],
                        [
                            34.27722,
                            0.64174
                        ],
                        [
                            34.3099,
                            0.75911
                        ],
                        [
                            34.41163,
                            0.8241
                        ],
                        [
                            34.47989,
                            0.93567
                        ],
                        [
                            34.4892,
                            1.01364
                        ],
                        [
                            34.52417,
                            1.10441
                        ],
                        [
                            34.57218,
                            1.09795
                        ],
                        [
                            34.67145,
                            1.20611
                        ],
                        [
                            34.79534,
                            1.21986
                        ],
                        [
                            34.82911,
                            1.30342
                        ],
                        [
                            34.77215,
                            1.41643
                        ],
                        [
                            34.84322,
                            1.46054
                        ],
                        [
                            34.88826,
                            1.55557
                        ],
                        [
                            34.9473,
                            1.58218
                        ],
                        [
                            34.99884,
                            1.68216
                        ],
                        [
                            35.03567,
                            1.9181
                        ],
                        [
                            34.98679,
                            1.99129
                        ],
                        [
                            34.91575,
                            2.39879
                        ],
                        [
                            34.9537,
                            2.45562
                        ],
                        [
                            34.92861,
                            2.51649
                        ],
                        [
                            34.86244,
                            2.57061
                        ],
                        [
                            34.77962,
                            2.68997
                        ],
                        [
                            34.77101,
                            2.81204
                        ],
                        [
                            34.70615,
                            2.87316
                        ],
                        [
                            34.65703,
                            2.86452
                        ],
                        [
                            34.59747,
                            2.91899
                        ],
                        [
                            34.5487,
                            3.1315
                        ],
                        [
                            34.49341,
                            3.14362
                        ],
                        [
                            34.453,
                            3.19128
                        ],
                        [
                            34.45019,
                            3.24311
                        ],
                        [
                            34.40139,
                            3.38219
                        ],
                        [
                            34.44071,
                            3.50517
                        ],
                        [
                            34.45921,
                            3.66899
                        ],
                        [
                            34.35337,
                            3.73696
                        ],
                        [
                            34.29883,
                            3.71651
                        ],
                        [
                            34.25006,
                            3.78158
                        ],
                        [
                            34.17628,
                            3.76617
                        ],
                        [
                            34.15775,
                            3.87003
                        ],
                        [
                            34.11923,
                            3.90126
                        ],
                        [
                            34.12905,
                            3.95228
                        ],
                        [
                            34.05904,
                            4.00901
                        ],
                        [
                            34.09126,
                            4.04936
                        ],
                        [
                            34.05291,
                            4.10872
                        ],
                        [
                            34.06101,
                            4.15082
                        ],
                        [
                            33.99449,
                            4.21443
                        ],
                        [
                            33.50845,
                            3.74941
                        ],
                        [
                            33.17782,
                            3.77409
                        ],
                        [
                            33.02755,
                            3.87295
                        ],
                        [
                            32.9011,
                            3.81537
                        ],
                        [
                            32.72048,
                            3.76542
                        ],
                        [
                            32.4062,
                            3.74694
                        ],
                        [
                            32.17673,
                            3.61226
                        ],
                        [
                            32.21589,
                            3.57567
                        ],
                        [
                            32.20142,
                            3.50558
                        ],
                        [
                            32.08598,
                            3.53351
                        ],
                        [
                            32.0393,
                            3.5865
                        ],
                        [
                            31.95026,
                            3.58753
                        ],
                        [
                            31.91952,
                            3.70926
                        ],
                        [
                            31.85423,
                            3.7895
                        ],
                        [
                            31.8019,
                            3.79999
                        ],
                        [
                            31.70997,
                            3.71755
                        ],
                        [
                            31.58095,
                            3.68224
                        ],
                        [
                            31.53873,
                            3.6549
                        ],
                        [
                            31.28599,
                            3.79133
                        ],
                        [
                            31.17488,
                            3.79295
                        ],
                        [
                            31.00109,
                            3.68854
                        ],
                        [
                            30.97873,
                            3.69692
                        ],
                        [
                            30.91271,
                            3.56858
                        ],
                        [
                            30.85453,
                            3.48747
                        ],
                        [
                            30.92776,
                            3.50454
                        ],
                        [
                            30.93455,
                            3.42822
                        ],
                        [
                            30.91125,
                            3.366
                        ],
                        [
                            30.82477,
                            3.22818
                        ],
                        [
                            30.76411,
                            3.06694
                        ],
                        [
                            30.77281,
                            3.02887
                        ],
                        [
                            30.85351,
                            2.96056
                        ],
                        [
                            30.87881,
                            2.89119
                        ],
                        [
                            30.8532,
                            2.78729
                        ],
                        [
                            30.81665,
                            2.76608
                        ],
                        [
                            30.80423,
                            2.69689
                        ],
                        [
                            30.75536,
                            2.59788
                        ],
                        [
                            30.75523,
                            2.51584
                        ],
                        [
                            30.73069,
                            2.45035
                        ],
                        [
                            30.8245,
                            2.44137
                        ],
                        [
                            30.86795,
                            2.34621
                        ],
                        [
                            30.92419,
                            2.35483
                        ],
                        [
                            30.98697,
                            2.4078
                        ],
                        [
                            31.12086,
                            2.27876
                        ],
                        [
                            31.19543,
                            2.30401
                        ],
                        [
                            31.20398,
                            2.22925
                        ],
                        [
                            31.29685,
                            2.164
                        ],
                        [
                            31.3104,
                            2.11631
                        ],
                        [
                            31.23229,
                            1.99808
                        ],
                        [
                            31.0303,
                            1.75109
                        ],
                        [
                            30.71224,
                            1.50074
                        ],
                        [
                            30.44312,
                            1.2417
                        ],
                        [
                            30.36552,
                            1.20703
                        ],
                        [
                            30.33683,
                            1.15214
                        ],
                        [
                            30.29108,
                            1.1713
                        ],
                        [
                            30.23558,
                            1.12589
                        ],
                        [
                            30.22634,
                            0.98623
                        ],
                        [
                            30.17316,
                            0.91041
                        ],
                        [
                            29.98845,
                            0.84236
                        ],
                        [
                            29.95844,
                            0.65243
                        ],
                        [
                            29.97023,
                            0.55292
                        ],
                        [
                            29.94406,
                            0.52002
                        ],
                        [
                            29.9484,
                            0.44757
                        ],
                        [
                            29.87072,
                            0.37806
                        ],
                        [
                            29.82016,
                            0.16805
                        ],
                        [
                            29.78045,
                            0.16741
                        ],
                        [
                            29.71981,
                            0.06934
                        ],
                        [
                            29.72824,
                            -0.04882
                        ],
                        [
                            29.68087,
                            -0.4967
                        ],
                        [
                            29.65132,
                            -0.59692
                        ],
                        [
                            29.66179,
                            -0.62694
                        ],
                        [
                            29.62628,
                            -0.72041
                        ],
                        [
                            29.63979,
                            -0.82648
                        ],
                        [
                            29.61738,
                            -0.90597
                        ],
                        [
                            29.58628,
                            -0.91205
                        ],
                        [
                            29.58966,
                            -1.04049
                        ],
                        [
                            29.6136,
                            -1.1019
                        ],
                        [
                            29.5746,
                            -1.18584
                        ],
                        [
                            29.64309,
                            -1.26056
                        ],
                        [
                            29.58951,
                            -1.38662
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "UKR",
                "Country": "Ukraine",
                "Total_3GHG": 1.37,
                "Total_3GHG_timeseries": [
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0043,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0045,
                    0.0046,
                    0.0046,
                    0.0046,
                    0.0047,
                    0.0047,
                    0.0048,
                    0.0048,
                    0.0049,
                    0.005,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0055,
                    0.0056,
                    0.0057,
                    0.0058,
                    0.0059,
                    0.006,
                    0.0062,
                    0.0063,
                    0.0065,
                    0.0066,
                    0.0068,
                    0.007,
                    0.0071,
                    0.0073,
                    0.0075,
                    0.0077,
                    0.0079,
                    0.0081,
                    0.0084,
                    0.0086,
                    0.0089,
                    0.0091,
                    0.0094,
                    0.0097,
                    0.01,
                    0.0102,
                    0.0105,
                    0.0108,
                    0.0111,
                    0.0114,
                    0.0117,
                    0.0121,
                    0.0124,
                    0.0128,
                    0.0131,
                    0.0135,
                    0.0138,
                    0.0142,
                    0.0146,
                    0.015,
                    0.0154,
                    0.0158,
                    0.0162,
                    0.0166,
                    0.017,
                    0.0174,
                    0.0178,
                    0.0182,
                    0.0186,
                    0.019,
                    0.0194,
                    0.0197,
                    0.02,
                    0.0202,
                    0.0204,
                    0.0205,
                    0.0207,
                    0.0207,
                    0.0208,
                    0.0209,
                    0.021,
                    0.0211,
                    0.0211,
                    0.0212,
                    0.0213,
                    0.0214,
                    0.0215,
                    0.0215,
                    0.0216,
                    0.0216,
                    0.0217,
                    0.0218,
                    0.0218,
                    0.0219,
                    0.022,
                    0.022,
                    0.0221,
                    0.0222,
                    0.0223,
                    0.0223,
                    0.0224,
                    0.0224
                ],
                "Fossil_3GHG": 1.58,
                "Fossil_3GHG_timeseries": [
                    2.0041e-06,
                    4.114e-06,
                    6.3312e-06,
                    8.6604e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0025,
                    0.0026,
                    0.0028,
                    0.003,
                    0.0031,
                    0.0033,
                    0.0035,
                    0.0037,
                    0.0039,
                    0.0041,
                    0.0043,
                    0.0045,
                    0.0048,
                    0.005,
                    0.0052,
                    0.0055,
                    0.0057,
                    0.006,
                    0.0062,
                    0.0065,
                    0.0068,
                    0.0071,
                    0.0074,
                    0.0077,
                    0.008,
                    0.0083,
                    0.0087,
                    0.009,
                    0.0093,
                    0.0097,
                    0.01,
                    0.0104,
                    0.0107,
                    0.0111,
                    0.0114,
                    0.0118,
                    0.0121,
                    0.0124,
                    0.0127,
                    0.0129,
                    0.0131,
                    0.0132,
                    0.0134,
                    0.0135,
                    0.0137,
                    0.0138,
                    0.0139,
                    0.0141,
                    0.0142,
                    0.0144,
                    0.0145,
                    0.0147,
                    0.0149,
                    0.015,
                    0.0152,
                    0.0153,
                    0.0154,
                    0.0156,
                    0.0157,
                    0.0159,
                    0.016,
                    0.0161,
                    0.0162,
                    0.0163,
                    0.0164,
                    0.0165,
                    0.0166,
                    0.0167
                ],
                "Land_3GHG": 1.0,
                "Land_3GHG_timeseries": [
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.004,
                    0.004,
                    0.004,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0043,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0045,
                    0.0046,
                    0.0046,
                    0.0047,
                    0.0047,
                    0.0048,
                    0.0048,
                    0.0049,
                    0.0049,
                    0.005,
                    0.005,
                    0.0051,
                    0.0051,
                    0.0052,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0054,
                    0.0055,
                    0.0056,
                    0.0056,
                    0.0057,
                    0.0058,
                    0.0058,
                    0.0059,
                    0.006,
                    0.006,
                    0.0061,
                    0.0062,
                    0.0062,
                    0.0063,
                    0.0064,
                    0.0065,
                    0.0065,
                    0.0066,
                    0.0067,
                    0.0067,
                    0.0068,
                    0.0069,
                    0.0069,
                    0.007,
                    0.0071,
                    0.0071,
                    0.0072,
                    0.0072,
                    0.0073,
                    0.0073,
                    0.0073,
                    0.0073,
                    0.0073,
                    0.0073,
                    0.0073,
                    0.0073,
                    0.0072,
                    0.0072,
                    0.0071,
                    0.007,
                    0.007,
                    0.0069,
                    0.0068,
                    0.0067,
                    0.0067,
                    0.0066,
                    0.0065,
                    0.0064,
                    0.0063,
                    0.0062,
                    0.0062,
                    0.0061,
                    0.006,
                    0.006,
                    0.0059,
                    0.0059,
                    0.0059,
                    0.0058,
                    0.0058,
                    0.0058,
                    0.0058
                ],
                "Total_CO2": 1.58,
                "Total_CO2_timeseries": [
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0049,
                    0.005,
                    0.0052,
                    0.0054,
                    0.0055,
                    0.0057,
                    0.0059,
                    0.0061,
                    0.0063,
                    0.0065,
                    0.0067,
                    0.007,
                    0.0072,
                    0.0074,
                    0.0077,
                    0.008,
                    0.0082,
                    0.0085,
                    0.0088,
                    0.0091,
                    0.0094,
                    0.0097,
                    0.01,
                    0.0103,
                    0.0107,
                    0.011,
                    0.0113,
                    0.0117,
                    0.012,
                    0.0123,
                    0.0127,
                    0.013,
                    0.0133,
                    0.0136,
                    0.0139,
                    0.0141,
                    0.0143,
                    0.0145,
                    0.0146,
                    0.0148,
                    0.0149,
                    0.0151,
                    0.0152,
                    0.0153,
                    0.0155,
                    0.0156,
                    0.0157,
                    0.0159,
                    0.016,
                    0.0162,
                    0.0163,
                    0.0165,
                    0.0166,
                    0.0167,
                    0.0169,
                    0.017,
                    0.0171,
                    0.0172,
                    0.0173,
                    0.0174,
                    0.0175,
                    0.0176,
                    0.0177,
                    0.0178,
                    0.0179
                ],
                "Fossil_CO2": 1.8,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    3.0109e-08,
                    3.0109e-08,
                    3.0109e-08,
                    7.2391e-08,
                    1.1724e-07,
                    1.7649e-07,
                    2.5177e-07,
                    3.1967e-07,
                    3.9078e-07,
                    4.7054e-07,
                    5.4678e-07,
                    7.8765e-07,
                    1.0641e-06,
                    1.2941e-06,
                    1.6061e-06,
                    1.9446e-06,
                    2.4017e-06,
                    2.871e-06,
                    3.3114e-06,
                    3.846e-06,
                    4.4613e-06,
                    5.2253e-06,
                    6.0049e-06,
                    7.0239e-06,
                    8.0694e-06,
                    9.2958e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0022,
                    0.0023,
                    0.0025,
                    0.0026,
                    0.0028,
                    0.003,
                    0.0032,
                    0.0034,
                    0.0036,
                    0.0038,
                    0.004,
                    0.0043,
                    0.0045,
                    0.0048,
                    0.0051,
                    0.0053,
                    0.0056,
                    0.0059,
                    0.0062,
                    0.0065,
                    0.0068,
                    0.0071,
                    0.0074,
                    0.0078,
                    0.0081,
                    0.0084,
                    0.0088,
                    0.0091,
                    0.0094,
                    0.0097,
                    0.0099,
                    0.0102,
                    0.0104,
                    0.0105,
                    0.0107,
                    0.0108,
                    0.011,
                    0.0111,
                    0.0113,
                    0.0114,
                    0.0115,
                    0.0117,
                    0.0118,
                    0.0119,
                    0.0121,
                    0.0123,
                    0.0124,
                    0.0125,
                    0.0127,
                    0.0128,
                    0.0129,
                    0.0131,
                    0.0132,
                    0.0133,
                    0.0134,
                    0.0135,
                    0.0136,
                    0.0137,
                    0.0138,
                    0.0139,
                    0.0139
                ],
                "Land_CO2": 1.1,
                "Land_CO2_timeseries": [
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.004,
                    0.004,
                    0.004,
                    0.004
                ],
                "Total_CH4": 0.75,
                "Total_CH4_timeseries": [
                    7.5797e-06,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.004,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0043,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0047,
                    0.0048,
                    0.0048,
                    0.0048,
                    0.0048,
                    0.0047,
                    0.0047,
                    0.0046,
                    0.0046,
                    0.0045,
                    0.0044,
                    0.0044,
                    0.0043,
                    0.0042,
                    0.0041,
                    0.0041,
                    0.004,
                    0.0039,
                    0.0038,
                    0.0037,
                    0.0036,
                    0.0036,
                    0.0035,
                    0.0034,
                    0.0034,
                    0.0033,
                    0.0033,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0031,
                    0.0031
                ],
                "Fossil_CH4": 0.89,
                "Fossil_CH4_timeseries": [
                    1.7218e-06,
                    3.5462e-06,
                    5.475e-06,
                    7.5126e-06,
                    9.6912e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023
                ],
                "Land_CH4": 0.5,
                "Land_CH4_timeseries": [
                    5.8578e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0025,
                    0.0025,
                    0.0024,
                    0.0024,
                    0.0023,
                    0.0022,
                    0.0022,
                    0.0021,
                    0.002,
                    0.0019,
                    0.0018,
                    0.0017,
                    0.0016,
                    0.0016,
                    0.0015,
                    0.0014,
                    0.0013,
                    0.0012,
                    0.0011,
                    0.0011,
                    0.001,
                    0.001,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0008,
                    0.0008
                ],
                "Total_N2O": 1.74,
                "Total_N2O_timeseries": [
                    1.5534e-06,
                    3.1353e-06,
                    4.7447e-06,
                    6.3799e-06,
                    8.0389e-06,
                    9.7195e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014
                ],
                "Fossil_N2O": 1.84,
                "Fossil_N2O_timeseries": [
                    2.8231e-07,
                    5.6772e-07,
                    8.5621e-07,
                    1.1477e-06,
                    1.4423e-06,
                    1.7397e-06,
                    2.0401e-06,
                    2.3432e-06,
                    2.6491e-06,
                    2.9575e-06,
                    3.2685e-06,
                    3.5821e-06,
                    3.8981e-06,
                    4.2167e-06,
                    4.5378e-06,
                    4.8614e-06,
                    5.1875e-06,
                    5.5161e-06,
                    5.8473e-06,
                    6.181e-06,
                    6.5178e-06,
                    6.8586e-06,
                    7.204e-06,
                    7.5546e-06,
                    7.9105e-06,
                    8.272e-06,
                    8.6387e-06,
                    9.0105e-06,
                    9.3866e-06,
                    9.7665e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Land_N2O": 1.71,
                "Land_N2O_timeseries": [
                    1.2711e-06,
                    2.5676e-06,
                    3.8885e-06,
                    5.2321e-06,
                    6.5967e-06,
                    7.9798e-06,
                    9.3786e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            38.23026,
                            47.11935
                        ],
                        [
                            38.23432,
                            47.22966
                        ],
                        [
                            38.32521,
                            47.25817
                        ],
                        [
                            38.33357,
                            47.30433
                        ],
                        [
                            38.22081,
                            47.30587
                        ],
                        [
                            38.30271,
                            47.39285
                        ],
                        [
                            38.28539,
                            47.54323
                        ],
                        [
                            38.35026,
                            47.61699
                        ],
                        [
                            38.45658,
                            47.64408
                        ],
                        [
                            38.60932,
                            47.64422
                        ],
                        [
                            38.66709,
                            47.69816
                        ],
                        [
                            38.77205,
                            47.68625
                        ],
                        [
                            38.78986,
                            47.81423
                        ],
                        [
                            38.88055,
                            47.87585
                        ],
                        [
                            39.07361,
                            47.86941
                        ],
                        [
                            39.14803,
                            47.8423
                        ],
                        [
                            39.24173,
                            47.86687
                        ],
                        [
                            39.47835,
                            47.85922
                        ],
                        [
                            39.52136,
                            47.8271
                        ],
                        [
                            39.737,
                            47.82805
                        ],
                        [
                            39.79463,
                            47.87056
                        ],
                        [
                            39.8145,
                            48.00133
                        ],
                        [
                            39.88311,
                            48.04177
                        ],
                        [
                            39.87164,
                            48.11628
                        ],
                        [
                            39.93684,
                            48.18072
                        ],
                        [
                            39.94207,
                            48.22867
                        ],
                        [
                            39.84898,
                            48.33361
                        ],
                        [
                            39.94253,
                            48.3465
                        ],
                        [
                            39.84626,
                            48.57039
                        ],
                        [
                            39.661,
                            48.60928
                        ],
                        [
                            39.72192,
                            48.68382
                        ],
                        [
                            39.80083,
                            48.84224
                        ],
                        [
                            39.97571,
                            48.79292
                        ],
                        [
                            40.07964,
                            48.87016
                        ],
                        [
                            40.05985,
                            48.9088
                        ],
                        [
                            39.8539,
                            48.89073
                        ],
                        [
                            39.78341,
                            48.91581
                        ],
                        [
                            39.75886,
                            48.97479
                        ],
                        [
                            39.66425,
                            49.00061
                        ],
                        [
                            39.69143,
                            49.04979
                        ],
                        [
                            39.93743,
                            49.05669
                        ],
                        [
                            40.03099,
                            49.17895
                        ],
                        [
                            40.0793,
                            49.18899
                        ],
                        [
                            40.18596,
                            49.2837
                        ],
                        [
                            40.1981,
                            49.34601
                        ],
                        [
                            40.03005,
                            49.45427
                        ],
                        [
                            40.03974,
                            49.52045
                        ],
                        [
                            40.16852,
                            49.56936
                        ],
                        [
                            40.13469,
                            49.61595
                        ],
                        [
                            39.95247,
                            49.59673
                        ],
                        [
                            39.89319,
                            49.55899
                        ],
                        [
                            39.80553,
                            49.55861
                        ],
                        [
                            39.65936,
                            49.61573
                        ],
                        [
                            39.59182,
                            49.71847
                        ],
                        [
                            39.4434,
                            49.75983
                        ],
                        [
                            39.37823,
                            49.73895
                        ],
                        [
                            39.28609,
                            49.75558
                        ],
                        [
                            39.1802,
                            49.88783
                        ],
                        [
                            39.06697,
                            49.81592
                        ],
                        [
                            38.94904,
                            49.79656
                        ],
                        [
                            38.90106,
                            49.86905
                        ],
                        [
                            38.83798,
                            49.86736
                        ],
                        [
                            38.58208,
                            49.977
                        ],
                        [
                            38.48835,
                            49.96403
                        ],
                        [
                            38.35315,
                            50.00555
                        ],
                        [
                            38.32975,
                            50.08346
                        ],
                        [
                            38.17913,
                            50.07931
                        ],
                        [
                            38.22126,
                            49.979
                        ],
                        [
                            38.16976,
                            49.94132
                        ],
                        [
                            38.0577,
                            49.92378
                        ],
                        [
                            37.96461,
                            49.97961
                        ],
                        [
                            37.92513,
                            50.03463
                        ],
                        [
                            37.75507,
                            50.07897
                        ],
                        [
                            37.61507,
                            50.21722
                        ],
                        [
                            37.63534,
                            50.31094
                        ],
                        [
                            37.52098,
                            50.33698
                        ],
                        [
                            37.46576,
                            50.43005
                        ],
                        [
                            37.35143,
                            50.43693
                        ],
                        [
                            37.29281,
                            50.40152
                        ],
                        [
                            37.10409,
                            50.35173
                        ],
                        [
                            36.93745,
                            50.35001
                        ],
                        [
                            36.68966,
                            50.26749
                        ],
                        [
                            36.64902,
                            50.21809
                        ],
                        [
                            36.48617,
                            50.31137
                        ],
                        [
                            36.29682,
                            50.29194
                        ],
                        [
                            36.28216,
                            50.33662
                        ],
                        [
                            36.15774,
                            50.43209
                        ],
                        [
                            36.06426,
                            50.45044
                        ],
                        [
                            35.83028,
                            50.43252
                        ],
                        [
                            35.73897,
                            50.35516
                        ],
                        [
                            35.62561,
                            50.3526
                        ],
                        [
                            35.5855,
                            50.44955
                        ],
                        [
                            35.47669,
                            50.48867
                        ],
                        [
                            35.39382,
                            50.57991
                        ],
                        [
                            35.40211,
                            50.65515
                        ],
                        [
                            35.45958,
                            50.66456
                        ],
                        [
                            35.48664,
                            50.77611
                        ],
                        [
                            35.41368,
                            50.80164
                        ],
                        [
                            35.39112,
                            50.92329
                        ],
                        [
                            35.33275,
                            50.9942
                        ],
                        [
                            35.40579,
                            51.02587
                        ],
                        [
                            35.30545,
                            51.07723
                        ],
                        [
                            35.2098,
                            51.04771
                        ],
                        [
                            35.12452,
                            51.16326
                        ],
                        [
                            35.1476,
                            51.22423
                        ],
                        [
                            34.9533,
                            51.22726
                        ],
                        [
                            34.81734,
                            51.16939
                        ],
                        [
                            34.57948,
                            51.23424
                        ],
                        [
                            34.38148,
                            51.27226
                        ],
                        [
                            34.30815,
                            51.23839
                        ],
                        [
                            34.23902,
                            51.29254
                        ],
                        [
                            34.33754,
                            51.35704
                        ],
                        [
                            34.2232,
                            51.4284
                        ],
                        [
                            34.30569,
                            51.51292
                        ],
                        [
                            34.16705,
                            51.6443
                        ],
                        [
                            34.21544,
                            51.70238
                        ],
                        [
                            34.4209,
                            51.72285
                        ],
                        [
                            34.41257,
                            51.82652
                        ],
                        [
                            34.14359,
                            51.96865
                        ],
                        [
                            34.0805,
                            52.07046
                        ],
                        [
                            34.1149,
                            52.14129
                        ],
                        [
                            34.05226,
                            52.20098
                        ],
                        [
                            33.93788,
                            52.24997
                        ],
                        [
                            33.83558,
                            52.36076
                        ],
                        [
                            33.68151,
                            52.35686
                        ],
                        [
                            33.55921,
                            52.30224
                        ],
                        [
                            33.51905,
                            52.35392
                        ],
                        [
                            33.34957,
                            52.35338
                        ],
                        [
                            33.17045,
                            52.37223
                        ],
                        [
                            33.08189,
                            52.30881
                        ],
                        [
                            32.90248,
                            52.24605
                        ],
                        [
                            32.88298,
                            52.27299
                        ],
                        [
                            32.7023,
                            52.25053
                        ],
                        [
                            32.55034,
                            52.3253
                        ],
                        [
                            32.35347,
                            52.31602
                        ],
                        [
                            32.39956,
                            52.24739
                        ],
                        [
                            32.28931,
                            52.1032
                        ],
                        [
                            32.09493,
                            52.03397
                        ],
                        [
                            31.96408,
                            52.0531
                        ],
                        [
                            31.93054,
                            52.0904
                        ],
                        [
                            31.78688,
                            52.11145
                        ],
                        [
                            31.72321,
                            52.09603
                        ],
                        [
                            31.45088,
                            52.13983
                        ],
                        [
                            31.32454,
                            52.10456
                        ],
                        [
                            31.25527,
                            52.0431
                        ],
                        [
                            31.13831,
                            52.10184
                        ],
                        [
                            30.95033,
                            52.07611
                        ],
                        [
                            30.88809,
                            51.97081
                        ],
                        [
                            30.80777,
                            51.9438
                        ],
                        [
                            30.69261,
                            51.83684
                        ],
                        [
                            30.61202,
                            51.70969
                        ],
                        [
                            30.5105,
                            51.62909
                        ],
                        [
                            30.53131,
                            51.5622
                        ],
                        [
                            30.65286,
                            51.37524
                        ],
                        [
                            30.61374,
                            51.28361
                        ],
                        [
                            30.53988,
                            51.26264
                        ],
                        [
                            30.4007,
                            51.31136
                        ],
                        [
                            30.32479,
                            51.36202
                        ],
                        [
                            30.34412,
                            51.4238
                        ],
                        [
                            30.17996,
                            51.51239
                        ],
                        [
                            30.11708,
                            51.48791
                        ],
                        [
                            30.01587,
                            51.50416
                        ],
                        [
                            29.96832,
                            51.47457
                        ],
                        [
                            29.7922,
                            51.44301
                        ],
                        [
                            29.73533,
                            51.53059
                        ],
                        [
                            29.35172,
                            51.38471
                        ],
                        [
                            29.24588,
                            51.49919
                        ],
                        [
                            29.25182,
                            51.56566
                        ],
                        [
                            29.11614,
                            51.65524
                        ],
                        [
                            28.99963,
                            51.57471
                        ],
                        [
                            28.8854,
                            51.58386
                        ],
                        [
                            28.81785,
                            51.55716
                        ],
                        [
                            28.76249,
                            51.48727
                        ],
                        [
                            28.6827,
                            51.44511
                        ],
                        [
                            28.62949,
                            51.57301
                        ],
                        [
                            28.46896,
                            51.59259
                        ],
                        [
                            28.34243,
                            51.57675
                        ],
                        [
                            28.17222,
                            51.64497
                        ],
                        [
                            28.1128,
                            51.58378
                        ],
                        [
                            27.94094,
                            51.55791
                        ],
                        [
                            27.86053,
                            51.63047
                        ],
                        [
                            27.73787,
                            51.47526
                        ],
                        [
                            27.67836,
                            51.53957
                        ],
                        [
                            27.72189,
                            51.60333
                        ],
                        [
                            27.55029,
                            51.63637
                        ],
                        [
                            27.45597,
                            51.61135
                        ],
                        [
                            27.26941,
                            51.6063
                        ],
                        [
                            27.20853,
                            51.66701
                        ],
                        [
                            27.19897,
                            51.77313
                        ],
                        [
                            26.9975,
                            51.76975
                        ],
                        [
                            26.94854,
                            51.73572
                        ],
                        [
                            26.75156,
                            51.80153
                        ],
                        [
                            26.6164,
                            51.82449
                        ],
                        [
                            26.46913,
                            51.79959
                        ],
                        [
                            26.36871,
                            51.86315
                        ],
                        [
                            26.15761,
                            51.86678
                        ],
                        [
                            26.09242,
                            51.91167
                        ],
                        [
                            25.41327,
                            51.92111
                        ],
                        [
                            25.26211,
                            51.96676
                        ],
                        [
                            25.09602,
                            51.95205
                        ],
                        [
                            24.96463,
                            51.89768
                        ],
                        [
                            24.91939,
                            51.91152
                        ],
                        [
                            24.74118,
                            51.88291
                        ],
                        [
                            24.6107,
                            51.90188
                        ],
                        [
                            24.38959,
                            51.88245
                        ],
                        [
                            24.29454,
                            51.79954
                        ],
                        [
                            24.31751,
                            51.74936
                        ],
                        [
                            24.11891,
                            51.66662
                        ],
                        [
                            23.99517,
                            51.58084
                        ],
                        [
                            23.88033,
                            51.60783
                        ],
                        [
                            23.78099,
                            51.66677
                        ],
                        [
                            23.60566,
                            51.62167
                        ],
                        [
                            23.66269,
                            51.58224
                        ],
                        [
                            23.61744,
                            51.50954
                        ],
                        [
                            23.70018,
                            51.4034
                        ],
                        [
                            23.63788,
                            51.33039
                        ],
                        [
                            23.74287,
                            51.21396
                        ],
                        [
                            23.86184,
                            51.15662
                        ],
                        [
                            23.87287,
                            51.0836
                        ],
                        [
                            23.97014,
                            50.95167
                        ],
                        [
                            24.13209,
                            50.8493
                        ],
                        [
                            24.02177,
                            50.84121
                        ],
                        [
                            23.95854,
                            50.79404
                        ],
                        [
                            24.01872,
                            50.72431
                        ],
                        [
                            24.07433,
                            50.71013
                        ],
                        [
                            24.0911,
                            50.56212
                        ],
                        [
                            23.99708,
                            50.41266
                        ],
                        [
                            23.80338,
                            50.40476
                        ],
                        [
                            23.70343,
                            50.37534
                        ],
                        [
                            23.58121,
                            50.26647
                        ],
                        [
                            23.47043,
                            50.21778
                        ],
                        [
                            23.27859,
                            50.08627
                        ],
                        [
                            23.03327,
                            49.88133
                        ],
                        [
                            22.64151,
                            49.52921
                        ],
                        [
                            22.70006,
                            49.48885
                        ],
                        [
                            22.7443,
                            49.36916
                        ],
                        [
                            22.74112,
                            49.21846
                        ],
                        [
                            22.86811,
                            49.07683
                        ],
                        [
                            22.6825,
                            49.03891
                        ],
                        [
                            22.56684,
                            49.08838
                        ],
                        [
                            22.54477,
                            49.00827
                        ],
                        [
                            22.47959,
                            48.99268
                        ],
                        [
                            22.42826,
                            48.93181
                        ],
                        [
                            22.34594,
                            48.7659
                        ],
                        [
                            22.34082,
                            48.68707
                        ],
                        [
                            22.18958,
                            48.60933
                        ],
                        [
                            22.16099,
                            48.56725
                        ],
                        [
                            22.15531,
                            48.4034
                        ],
                        [
                            22.26562,
                            48.40873
                        ],
                        [
                            22.38398,
                            48.23561
                        ],
                        [
                            22.48811,
                            48.25317
                        ],
                        [
                            22.56947,
                            48.19575
                        ],
                        [
                            22.59113,
                            48.10807
                        ],
                        [
                            22.67421,
                            48.09195
                        ],
                        [
                            22.81951,
                            48.11843
                        ],
                        [
                            22.88098,
                            48.05407
                        ],
                        [
                            22.8379,
                            47.99208
                        ],
                        [
                            22.89627,
                            47.95412
                        ],
                        [
                            22.99423,
                            48.00236
                        ],
                        [
                            23.08969,
                            48.00545
                        ],
                        [
                            23.14647,
                            48.10057
                        ],
                        [
                            23.24602,
                            48.09262
                        ],
                        [
                            23.33963,
                            48.01879
                        ],
                        [
                            23.49361,
                            47.96781
                        ],
                        [
                            23.54213,
                            48.00942
                        ],
                        [
                            23.66833,
                            47.98421
                        ],
                        [
                            23.77079,
                            47.99467
                        ],
                        [
                            23.84459,
                            47.94173
                        ],
                        [
                            24.00891,
                            47.96683
                        ],
                        [
                            24.1097,
                            47.91657
                        ],
                        [
                            24.21928,
                            47.89797
                        ],
                        [
                            24.38029,
                            47.92646
                        ],
                        [
                            24.43414,
                            47.96971
                        ],
                        [
                            24.62275,
                            47.9514
                        ],
                        [
                            24.67089,
                            47.86528
                        ],
                        [
                            24.82719,
                            47.82
                        ],
                        [
                            24.88314,
                            47.72435
                        ],
                        [
                            25.03908,
                            47.72593
                        ],
                        [
                            25.11498,
                            47.75512
                        ],
                        [
                            25.22158,
                            47.85919
                        ],
                        [
                            25.31089,
                            47.91432
                        ],
                        [
                            25.59327,
                            47.93881
                        ],
                        [
                            25.77463,
                            47.93937
                        ],
                        [
                            25.86123,
                            47.9699
                        ],
                        [
                            26.19002,
                            47.99756
                        ],
                        [
                            26.33883,
                            48.18322
                        ],
                        [
                            26.47193,
                            48.21944
                        ],
                        [
                            26.53025,
                            48.21032
                        ],
                        [
                            26.63056,
                            48.25975
                        ],
                        [
                            26.69588,
                            48.32717
                        ],
                        [
                            26.76493,
                            48.35435
                        ],
                        [
                            26.77947,
                            48.41853
                        ],
                        [
                            26.99216,
                            48.36063
                        ],
                        [
                            27.08821,
                            48.41249
                        ],
                        [
                            27.28607,
                            48.37128
                        ],
                        [
                            27.31955,
                            48.44181
                        ],
                        [
                            27.44634,
                            48.40916
                        ],
                        [
                            27.4653,
                            48.44754
                        ],
                        [
                            27.58024,
                            48.48982
                        ],
                        [
                            27.64204,
                            48.44141
                        ],
                        [
                            27.74259,
                            48.45696
                        ],
                        [
                            27.86762,
                            48.4067
                        ],
                        [
                            27.9646,
                            48.32496
                        ],
                        [
                            28.04599,
                            48.32494
                        ],
                        [
                            28.23281,
                            48.21124
                        ],
                        [
                            28.35709,
                            48.2445
                        ],
                        [
                            28.44907,
                            48.08428
                        ],
                        [
                            28.5456,
                            48.16932
                        ],
                        [
                            28.84148,
                            48.12451
                        ],
                        [
                            28.83948,
                            48.03468
                        ],
                        [
                            28.926,
                            47.96069
                        ],
                        [
                            29.03242,
                            47.94324
                        ],
                        [
                            29.17485,
                            47.99286
                        ],
                        [
                            29.20235,
                            47.82859
                        ],
                        [
                            29.2489,
                            47.75227
                        ],
                        [
                            29.21679,
                            47.61245
                        ],
                        [
                            29.11718,
                            47.5544
                        ],
                        [
                            29.23872,
                            47.45709
                        ],
                        [
                            29.31734,
                            47.44841
                        ],
                        [
                            29.33727,
                            47.37027
                        ],
                        [
                            29.39838,
                            47.30037
                        ],
                        [
                            29.4858,
                            47.30574
                        ],
                        [
                            29.48802,
                            47.35548
                        ],
                        [
                            29.57406,
                            47.37054
                        ],
                        [
                            29.59892,
                            47.25745
                        ],
                        [
                            29.5519,
                            47.2515
                        ],
                        [
                            29.57923,
                            47.13587
                        ],
                        [
                            29.61205,
                            47.10033
                        ],
                        [
                            29.59587,
                            46.96364
                        ],
                        [
                            29.64804,
                            46.91979
                        ],
                        [
                            29.73151,
                            46.91783
                        ],
                        [
                            29.74996,
                            46.86109
                        ],
                        [
                            29.88429,
                            46.84971
                        ],
                        [
                            29.97403,
                            46.75221
                        ],
                        [
                            29.94604,
                            46.64834
                        ],
                        [
                            29.96738,
                            46.59716
                        ],
                        [
                            29.92545,
                            46.50259
                        ],
                        [
                            30.00502,
                            46.45435
                        ],
                        [
                            30.16314,
                            46.41337
                        ],
                        [
                            30.02208,
                            46.38343
                        ],
                        [
                            29.93881,
                            46.40096
                        ],
                        [
                            29.88811,
                            46.37207
                        ],
                        [
                            29.80679,
                            46.38521
                        ],
                        [
                            29.77632,
                            46.454
                        ],
                        [
                            29.68719,
                            46.42653
                        ],
                        [
                            29.67865,
                            46.36144
                        ],
                        [
                            29.58034,
                            46.36198
                        ],
                        [
                            29.56555,
                            46.41592
                        ],
                        [
                            29.44916,
                            46.4976
                        ],
                        [
                            29.32319,
                            46.41504
                        ],
                        [
                            29.24516,
                            46.41695
                        ],
                        [
                            29.16361,
                            46.51552
                        ],
                        [
                            29.06293,
                            46.51241
                        ],
                        [
                            29.02473,
                            46.46274
                        ],
                        [
                            28.93081,
                            46.45771
                        ],
                        [
                            28.99685,
                            46.32287
                        ],
                        [
                            28.95187,
                            46.25954
                        ],
                        [
                            29.065,
                            46.19459
                        ],
                        [
                            28.95038,
                            46.09372
                        ],
                        [
                            29.00477,
                            46.0493
                        ],
                        [
                            28.97879,
                            46.00359
                        ],
                        [
                            28.7765,
                            45.97086
                        ],
                        [
                            28.7552,
                            45.92643
                        ],
                        [
                            28.78539,
                            45.83215
                        ],
                        [
                            28.59431,
                            45.73503
                        ],
                        [
                            28.52107,
                            45.73734
                        ],
                        [
                            28.51557,
                            45.66384
                        ],
                        [
                            28.54429,
                            45.57952
                        ],
                        [
                            28.51329,
                            45.49957
                        ],
                        [
                            28.30511,
                            45.54698
                        ],
                        [
                            28.21136,
                            45.46728
                        ],
                        [
                            28.26195,
                            45.45492
                        ],
                        [
                            28.34494,
                            45.32255
                        ],
                        [
                            28.56838,
                            45.24799
                        ],
                        [
                            28.70008,
                            45.2254
                        ],
                        [
                            28.75084,
                            45.28186
                        ],
                        [
                            28.84207,
                            45.31878
                        ],
                        [
                            28.93392,
                            45.28081
                        ],
                        [
                            28.96416,
                            45.32947
                        ],
                        [
                            29.28227,
                            45.42701
                        ],
                        [
                            29.42641,
                            45.442
                        ],
                        [
                            29.55278,
                            45.40695
                        ],
                        [
                            29.6549,
                            45.33589
                        ],
                        [
                            29.67964,
                            45.21184
                        ],
                        [
                            29.74105,
                            45.23087
                        ],
                        [
                            29.76217,
                            45.32496
                        ],
                        [
                            29.7377,
                            45.4841
                        ],
                        [
                            29.64914,
                            45.45274
                        ],
                        [
                            29.60851,
                            45.47723
                        ],
                        [
                            29.68873,
                            45.55943
                        ],
                        [
                            30.23392,
                            45.87119
                        ],
                        [
                            30.35359,
                            45.98325
                        ],
                        [
                            30.46891,
                            46.06958
                        ],
                        [
                            30.55552,
                            46.15671
                        ],
                        [
                            30.68654,
                            46.32998
                        ],
                        [
                            30.74999,
                            46.37784
                        ],
                        [
                            30.76206,
                            46.55058
                        ],
                        [
                            30.83747,
                            46.55202
                        ],
                        [
                            31.17606,
                            46.62719
                        ],
                        [
                            31.34955,
                            46.60158
                        ],
                        [
                            31.47836,
                            46.62596
                        ],
                        [
                            31.54975,
                            46.60027
                        ],
                        [
                            31.65585,
                            46.64837
                        ],
                        [
                            31.79647,
                            46.61008
                        ],
                        [
                            31.88785,
                            46.63735
                        ],
                        [
                            31.92545,
                            46.78853
                        ],
                        [
                            31.98222,
                            46.65653
                        ],
                        [
                            32.08517,
                            46.61583
                        ],
                        [
                            32.13955,
                            46.56127
                        ],
                        [
                            32.24377,
                            46.58968
                        ],
                        [
                            32.30284,
                            46.55792
                        ],
                        [
                            32.25769,
                            46.47727
                        ],
                        [
                            32.09394,
                            46.49852
                        ],
                        [
                            32.02494,
                            46.48772
                        ],
                        [
                            31.75117,
                            46.54558
                        ],
                        [
                            31.55574,
                            46.53527
                        ],
                        [
                            31.68896,
                            46.44912
                        ],
                        [
                            31.73694,
                            46.4876
                        ],
                        [
                            32.0294,
                            46.43713
                        ],
                        [
                            32.0588,
                            46.38963
                        ],
                        [
                            32.00162,
                            46.35837
                        ],
                        [
                            31.82954,
                            46.33215
                        ],
                        [
                            31.78238,
                            46.2724
                        ],
                        [
                            32.07923,
                            46.24545
                        ],
                        [
                            32.12128,
                            46.20759
                        ],
                        [
                            32.23142,
                            46.18563
                        ],
                        [
                            32.23463,
                            46.13227
                        ],
                        [
                            32.54163,
                            46.06623
                        ],
                        [
                            32.64722,
                            46.10598
                        ],
                        [
                            32.76671,
                            46.12192
                        ],
                        [
                            33.01363,
                            46.1092
                        ],
                        [
                            33.03404,
                            46.156
                        ],
                        [
                            33.14172,
                            46.12911
                        ],
                        [
                            33.20874,
                            46.1755
                        ],
                        [
                            33.33179,
                            46.11266
                        ],
                        [
                            33.41792,
                            46.03462
                        ],
                        [
                            33.46139,
                            46.04901
                        ],
                        [
                            33.58303,
                            46.15753
                        ],
                        [
                            33.64186,
                            46.08517
                        ],
                        [
                            33.61396,
                            46.05404
                        ],
                        [
                            33.66047,
                            45.95438
                        ],
                        [
                            33.65528,
                            45.87218
                        ],
                        [
                            33.54899,
                            45.8408
                        ],
                        [
                            33.42671,
                            45.83499
                        ],
                        [
                            33.35251,
                            45.78541
                        ],
                        [
                            33.14305,
                            45.72349
                        ],
                        [
                            32.90725,
                            45.63881
                        ],
                        [
                            32.79003,
                            45.56238
                        ],
                        [
                            32.56284,
                            45.46852
                        ],
                        [
                            32.49895,
                            45.42069
                        ],
                        [
                            32.49617,
                            45.34675
                        ],
                        [
                            32.66729,
                            45.31922
                        ],
                        [
                            32.75096,
                            45.36397
                        ],
                        [
                            32.85584,
                            45.36873
                        ],
                        [
                            32.97003,
                            45.33609
                        ],
                        [
                            33.108,
                            45.23347
                        ],
                        [
                            33.25991,
                            45.14742
                        ],
                        [
                            33.38631,
                            45.19681
                        ],
                        [
                            33.44539,
                            45.17777
                        ],
                        [
                            33.55648,
                            45.09015
                        ],
                        [
                            33.59792,
                            45.01285
                        ],
                        [
                            33.61218,
                            44.92578
                        ],
                        [
                            33.59324,
                            44.84606
                        ],
                        [
                            33.53431,
                            44.79079
                        ],
                        [
                            33.54352,
                            44.66353
                        ],
                        [
                            33.40347,
                            44.55775
                        ],
                        [
                            33.48699,
                            44.49962
                        ],
                        [
                            33.62896,
                            44.47795
                        ],
                        [
                            33.65177,
                            44.42607
                        ],
                        [
                            33.77778,
                            44.38792
                        ],
                        [
                            33.85971,
                            44.40688
                        ],
                        [
                            33.94046,
                            44.39308
                        ],
                        [
                            34.12595,
                            44.42817
                        ],
                        [
                            34.16785,
                            44.49374
                        ],
                        [
                            34.34683,
                            44.54985
                        ],
                        [
                            34.41697,
                            44.67352
                        ],
                        [
                            34.459,
                            44.71116
                        ],
                        [
                            34.73101,
                            44.81271
                        ],
                        [
                            34.89323,
                            44.81776
                        ],
                        [
                            34.96954,
                            44.84196
                        ],
                        [
                            35.0814,
                            44.79406
                        ],
                        [
                            35.16842,
                            44.9025
                        ],
                        [
                            35.23904,
                            44.92002
                        ],
                        [
                            35.27097,
                            44.9694
                        ],
                        [
                            35.34276,
                            44.96673
                        ],
                        [
                            35.43235,
                            45.08886
                        ],
                        [
                            35.55967,
                            45.12969
                        ],
                        [
                            35.68537,
                            45.10902
                        ],
                        [
                            35.77693,
                            45.06681
                        ],
                        [
                            35.8408,
                            44.99852
                        ],
                        [
                            36.07719,
                            45.04824
                        ],
                        [
                            36.22173,
                            45.02875
                        ],
                        [
                            36.43937,
                            45.08545
                        ],
                        [
                            36.4021,
                            45.21375
                        ],
                        [
                            36.43452,
                            45.29575
                        ],
                        [
                            36.50181,
                            45.36262
                        ],
                        [
                            36.60055,
                            45.34765
                        ],
                        [
                            36.64496,
                            45.38244
                        ],
                        [
                            36.59491,
                            45.43837
                        ],
                        [
                            36.39969,
                            45.45055
                        ],
                        [
                            36.28607,
                            45.4809
                        ],
                        [
                            36.0746,
                            45.44306
                        ],
                        [
                            36.04851,
                            45.38462
                        ],
                        [
                            35.92415,
                            45.38495
                        ],
                        [
                            35.85044,
                            45.43802
                        ],
                        [
                            35.74883,
                            45.38857
                        ],
                        [
                            35.71686,
                            45.33349
                        ],
                        [
                            35.52615,
                            45.28354
                        ],
                        [
                            35.34472,
                            45.37661
                        ],
                        [
                            35.04037,
                            45.67159
                        ],
                        [
                            34.93087,
                            45.82899
                        ],
                        [
                            34.85542,
                            45.9921
                        ],
                        [
                            34.82671,
                            46.13612
                        ],
                        [
                            34.84257,
                            46.21056
                        ],
                        [
                            34.89477,
                            46.23835
                        ],
                        [
                            35.05145,
                            46.26784
                        ],
                        [
                            35.21418,
                            46.40304
                        ],
                        [
                            35.31373,
                            46.3144
                        ],
                        [
                            35.46004,
                            46.44222
                        ],
                        [
                            35.59896,
                            46.48887
                        ],
                        [
                            35.7282,
                            46.58656
                        ],
                        [
                            35.91859,
                            46.65796
                        ],
                        [
                            36.19326,
                            46.67198
                        ],
                        [
                            36.28702,
                            46.62832
                        ],
                        [
                            36.3302,
                            46.68321
                        ],
                        [
                            36.41222,
                            46.72397
                        ],
                        [
                            36.6284,
                            46.78037
                        ],
                        [
                            36.73491,
                            46.77651
                        ],
                        [
                            36.815,
                            46.73196
                        ],
                        [
                            37.00323,
                            46.87017
                        ],
                        [
                            37.23661,
                            46.94934
                        ],
                        [
                            37.33695,
                            46.89008
                        ],
                        [
                            37.5383,
                            47.08018
                        ],
                        [
                            37.70378,
                            47.07989
                        ],
                        [
                            37.89097,
                            47.11071
                        ],
                        [
                            37.97409,
                            47.08732
                        ],
                        [
                            38.0665,
                            47.11172
                        ],
                        [
                            38.14401,
                            47.05351
                        ],
                        [
                            38.23026,
                            47.11935
                        ]
                    ],
                    [
                        [
                            34.1508,
                            46.26759
                        ],
                        [
                            34.18732,
                            46.28246
                        ],
                        [
                            34.26121,
                            46.18609
                        ],
                        [
                            34.3787,
                            46.19762
                        ],
                        [
                            34.43384,
                            46.11935
                        ],
                        [
                            34.42428,
                            46.01681
                        ],
                        [
                            34.54758,
                            45.98793
                        ],
                        [
                            34.63998,
                            46.08883
                        ],
                        [
                            34.6061,
                            46.16672
                        ],
                        [
                            34.68149,
                            46.1824
                        ],
                        [
                            34.81518,
                            46.1218
                        ],
                        [
                            34.7101,
                            46.07715
                        ],
                        [
                            34.81004,
                            46.03647
                        ],
                        [
                            34.8421,
                            45.97867
                        ],
                        [
                            34.84007,
                            45.8808
                        ],
                        [
                            34.90771,
                            45.8476
                        ],
                        [
                            35.00544,
                            45.68305
                        ],
                        [
                            35.22512,
                            45.48377
                        ],
                        [
                            35.34606,
                            45.35883
                        ],
                        [
                            35.46897,
                            45.27521
                        ],
                        [
                            35.41316,
                            45.25774
                        ],
                        [
                            35.20383,
                            45.34006
                        ],
                        [
                            35.08227,
                            45.36272
                        ],
                        [
                            34.98141,
                            45.35991
                        ],
                        [
                            35.01925,
                            45.43883
                        ],
                        [
                            35.10824,
                            45.48488
                        ],
                        [
                            35.0198,
                            45.64161
                        ],
                        [
                            34.95481,
                            45.68531
                        ],
                        [
                            34.89441,
                            45.67162
                        ],
                        [
                            34.78853,
                            45.73409
                        ],
                        [
                            34.73496,
                            45.82085
                        ],
                        [
                            34.66132,
                            45.80183
                        ],
                        [
                            34.64952,
                            45.93968
                        ],
                        [
                            34.48702,
                            45.921
                        ],
                        [
                            34.38766,
                            46.00623
                        ],
                        [
                            34.08696,
                            46.06402
                        ],
                        [
                            34.02001,
                            46.0995
                        ],
                        [
                            33.90856,
                            46.04973
                        ],
                        [
                            33.87561,
                            46.08951
                        ],
                        [
                            33.70199,
                            46.198
                        ],
                        [
                            33.77656,
                            46.25398
                        ],
                        [
                            33.83674,
                            46.22483
                        ],
                        [
                            33.9728,
                            46.20952
                        ],
                        [
                            34.03775,
                            46.12596
                        ],
                        [
                            34.20471,
                            46.16629
                        ],
                        [
                            34.1508,
                            46.26759
                        ]
                    ],
                    [
                        [
                            36.56298,
                            45.25692
                        ],
                        [
                            36.55438,
                            45.26496
                        ],
                        [
                            36.53945,
                            45.27783
                        ],
                        [
                            36.57847,
                            45.24825
                        ],
                        [
                            36.56298,
                            45.25692
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "ARE",
                "Country": "United Arab Emirates",
                "Total_3GHG": 0.27,
                "Total_3GHG_timeseries": [
                    2.8344e-08,
                    5.6972e-08,
                    8.5877e-08,
                    1.1504e-07,
                    1.4445e-07,
                    1.7408e-07,
                    2.0393e-07,
                    2.3397e-07,
                    2.6419e-07,
                    2.9455e-07,
                    3.2452e-07,
                    3.541e-07,
                    3.8328e-07,
                    4.1207e-07,
                    4.4046e-07,
                    4.6845e-07,
                    4.9603e-07,
                    5.2323e-07,
                    5.5002e-07,
                    5.764e-07,
                    6.0244e-07,
                    6.283e-07,
                    6.5409e-07,
                    6.7992e-07,
                    7.0581e-07,
                    7.3179e-07,
                    7.5783e-07,
                    7.8386e-07,
                    8.0979e-07,
                    8.3549e-07,
                    8.6134e-07,
                    8.873e-07,
                    9.1337e-07,
                    9.3953e-07,
                    9.6578e-07,
                    9.9211e-07,
                    1.0185e-06,
                    1.045e-06,
                    1.0716e-06,
                    1.0984e-06,
                    1.1253e-06,
                    1.1523e-06,
                    1.1794e-06,
                    1.2066e-06,
                    1.2339e-06,
                    1.2613e-06,
                    1.2889e-06,
                    1.3165e-06,
                    1.3444e-06,
                    1.3723e-06,
                    1.3993e-06,
                    1.4256e-06,
                    1.451e-06,
                    1.4757e-06,
                    1.4996e-06,
                    1.5228e-06,
                    1.5452e-06,
                    1.567e-06,
                    1.588e-06,
                    1.6082e-06,
                    1.6286e-06,
                    1.649e-06,
                    1.6695e-06,
                    1.69e-06,
                    1.7106e-06,
                    1.7312e-06,
                    1.7519e-06,
                    1.7727e-06,
                    1.7935e-06,
                    1.8143e-06,
                    1.8362e-06,
                    1.8593e-06,
                    1.8835e-06,
                    1.909e-06,
                    1.9357e-06,
                    1.9637e-06,
                    1.9929e-06,
                    2.0234e-06,
                    2.055e-06,
                    2.0877e-06,
                    2.1209e-06,
                    2.1544e-06,
                    2.1884e-06,
                    2.2228e-06,
                    2.2576e-06,
                    2.2987e-06,
                    2.3463e-06,
                    2.4005e-06,
                    2.4613e-06,
                    2.53e-06,
                    2.6075e-06,
                    2.6947e-06,
                    2.7923e-06,
                    2.9007e-06,
                    3.0205e-06,
                    3.1519e-06,
                    3.295e-06,
                    3.4496e-06,
                    3.6157e-06,
                    3.7925e-06,
                    3.9727e-06,
                    4.1682e-06,
                    4.3844e-06,
                    4.6227e-06,
                    4.8813e-06,
                    5.1514e-06,
                    5.4312e-06,
                    5.7215e-06,
                    6.0335e-06,
                    6.373e-06,
                    6.6902e-06,
                    7.0121e-06,
                    7.347e-06,
                    7.6922e-06,
                    8.0415e-06,
                    8.3942e-06,
                    9.1428e-06,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0032,
                    0.0033,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0043,
                    0.0044
                ],
                "Fossil_3GHG": 0.41,
                "Fossil_3GHG_timeseries": [
                    1.6766e-08,
                    3.3676e-08,
                    5.0728e-08,
                    6.7916e-08,
                    8.5232e-08,
                    1.0267e-07,
                    1.2022e-07,
                    1.3787e-07,
                    1.5561e-07,
                    1.7342e-07,
                    1.9107e-07,
                    2.0856e-07,
                    2.2589e-07,
                    2.4305e-07,
                    2.6005e-07,
                    2.7688e-07,
                    2.9355e-07,
                    3.1006e-07,
                    3.2642e-07,
                    3.4262e-07,
                    3.5872e-07,
                    3.7484e-07,
                    3.9109e-07,
                    4.0751e-07,
                    4.2416e-07,
                    4.4104e-07,
                    4.5813e-07,
                    4.7539e-07,
                    4.9275e-07,
                    5.1009e-07,
                    5.2754e-07,
                    5.451e-07,
                    5.6275e-07,
                    5.8048e-07,
                    5.9829e-07,
                    6.1617e-07,
                    6.3412e-07,
                    6.5215e-07,
                    6.7025e-07,
                    6.8845e-07,
                    7.0675e-07,
                    7.2514e-07,
                    7.4362e-07,
                    7.622e-07,
                    7.8089e-07,
                    7.9968e-07,
                    8.1858e-07,
                    8.376e-07,
                    8.5674e-07,
                    8.7602e-07,
                    8.9442e-07,
                    9.1198e-07,
                    9.2871e-07,
                    9.4465e-07,
                    9.5981e-07,
                    9.7421e-07,
                    9.8787e-07,
                    1.0008e-06,
                    1.013e-06,
                    1.0244e-06,
                    1.0354e-06,
                    1.0458e-06,
                    1.0559e-06,
                    1.0654e-06,
                    1.0744e-06,
                    1.0829e-06,
                    1.091e-06,
                    1.0985e-06,
                    1.1055e-06,
                    1.1121e-06,
                    1.1191e-06,
                    1.1266e-06,
                    1.1345e-06,
                    1.1429e-06,
                    1.1518e-06,
                    1.1611e-06,
                    1.1708e-06,
                    1.1809e-06,
                    1.1914e-06,
                    1.2023e-06,
                    1.2133e-06,
                    1.2245e-06,
                    1.2357e-06,
                    1.2471e-06,
                    1.2587e-06,
                    1.2704e-06,
                    1.2823e-06,
                    1.2945e-06,
                    1.3069e-06,
                    1.3205e-06,
                    1.3364e-06,
                    1.355e-06,
                    1.3767e-06,
                    1.4018e-06,
                    1.4309e-06,
                    1.4639e-06,
                    1.501e-06,
                    1.5419e-06,
                    1.5864e-06,
                    1.6341e-06,
                    1.684e-06,
                    1.7373e-06,
                    1.7943e-06,
                    1.8554e-06,
                    1.9202e-06,
                    1.9884e-06,
                    2.0599e-06,
                    2.1349e-06,
                    2.2197e-06,
                    2.3094e-06,
                    2.4055e-06,
                    2.5138e-06,
                    2.6342e-06,
                    2.7636e-06,
                    2.9056e-06,
                    3.0599e-06,
                    3.627e-06,
                    4.3561e-06,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0033,
                    0.0034,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0044
                ],
                "Land_3GHG": 0.01,
                "Land_3GHG_timeseries": [
                    1.1579e-08,
                    2.3295e-08,
                    3.5149e-08,
                    4.7126e-08,
                    5.9216e-08,
                    7.141e-08,
                    8.371e-08,
                    9.6104e-08,
                    1.0858e-07,
                    1.2113e-07,
                    1.3345e-07,
                    1.4554e-07,
                    1.574e-07,
                    1.6902e-07,
                    1.8041e-07,
                    1.9157e-07,
                    2.0248e-07,
                    2.1316e-07,
                    2.236e-07,
                    2.3378e-07,
                    2.4372e-07,
                    2.5345e-07,
                    2.6301e-07,
                    2.724e-07,
                    2.8165e-07,
                    2.9075e-07,
                    2.9969e-07,
                    3.0846e-07,
                    3.1704e-07,
                    3.2541e-07,
                    3.338e-07,
                    3.422e-07,
                    3.5062e-07,
                    3.5905e-07,
                    3.6749e-07,
                    3.7594e-07,
                    3.8441e-07,
                    3.9289e-07,
                    4.0139e-07,
                    4.0998e-07,
                    4.1857e-07,
                    4.2717e-07,
                    4.3577e-07,
                    4.4438e-07,
                    4.53e-07,
                    4.6164e-07,
                    4.7028e-07,
                    4.7894e-07,
                    4.8761e-07,
                    4.9627e-07,
                    5.0492e-07,
                    5.1359e-07,
                    5.2232e-07,
                    5.3104e-07,
                    5.3979e-07,
                    5.4857e-07,
                    5.5737e-07,
                    5.6618e-07,
                    5.75e-07,
                    5.8385e-07,
                    5.9325e-07,
                    6.0317e-07,
                    6.1364e-07,
                    6.2464e-07,
                    6.3619e-07,
                    6.4828e-07,
                    6.6094e-07,
                    6.7416e-07,
                    6.8793e-07,
                    7.0223e-07,
                    7.1713e-07,
                    7.3271e-07,
                    7.4903e-07,
                    7.661e-07,
                    7.8397e-07,
                    8.0265e-07,
                    8.2215e-07,
                    8.4245e-07,
                    8.6356e-07,
                    8.854e-07,
                    9.0755e-07,
                    9.2998e-07,
                    9.5269e-07,
                    9.7566e-07,
                    9.9891e-07,
                    1.0283e-06,
                    1.064e-06,
                    1.106e-06,
                    1.1545e-06,
                    1.2094e-06,
                    1.2711e-06,
                    1.3397e-06,
                    1.4156e-06,
                    1.4988e-06,
                    1.5896e-06,
                    1.6879e-06,
                    1.794e-06,
                    1.9078e-06,
                    2.0293e-06,
                    2.1584e-06,
                    2.2887e-06,
                    2.4309e-06,
                    2.5901e-06,
                    2.7674e-06,
                    2.9611e-06,
                    3.163e-06,
                    3.3713e-06,
                    3.5865e-06,
                    3.8138e-06,
                    4.0635e-06,
                    4.2847e-06,
                    4.4983e-06,
                    4.7128e-06,
                    4.9286e-06,
                    5.1359e-06,
                    5.3343e-06,
                    5.5158e-06,
                    5.6891e-06,
                    5.846e-06,
                    5.9854e-06,
                    6.1174e-06,
                    6.2189e-06,
                    6.3106e-06,
                    6.3223e-06,
                    6.2302e-06,
                    5.9807e-06,
                    5.7457e-06,
                    5.5393e-06,
                    5.3093e-06,
                    5.0651e-06,
                    4.8539e-06,
                    4.6463e-06,
                    4.4389e-06,
                    4.2317e-06,
                    4.0343e-06,
                    3.8315e-06,
                    3.6475e-06,
                    3.5319e-06,
                    3.4816e-06,
                    3.5478e-06,
                    3.6513e-06,
                    3.8645e-06,
                    4.0629e-06,
                    4.3723e-06,
                    4.8117e-06,
                    5.4262e-06,
                    6.5417e-06,
                    7.9997e-06,
                    9.6502e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_CO2": 0.22,
                "Total_CO2_timeseries": [
                    -0.0000000001925,
                    -0.0000000003245,
                    -0.000000000396,
                    -0.000000000418,
                    -0.0000000004015,
                    -0.000000000352,
                    -0.000000000264,
                    -0.0000000001485,
                    -0.000000000011,
                    1.375e-10,
                    2.97e-10,
                    4.73e-10,
                    6.6e-10,
                    8.58e-10,
                    1.067e-09,
                    1.2815e-09,
                    1.496e-09,
                    1.7215e-09,
                    1.947e-09,
                    2.156e-09,
                    2.365e-09,
                    2.5685e-09,
                    2.772e-09,
                    2.981e-09,
                    3.19e-09,
                    3.3935e-09,
                    3.597e-09,
                    3.795e-09,
                    3.993e-09,
                    4.1855e-09,
                    4.3725e-09,
                    4.5485e-09,
                    4.7135e-09,
                    4.8675e-09,
                    5.016e-09,
                    5.159e-09,
                    5.2965e-09,
                    5.423e-09,
                    5.5495e-09,
                    5.654e-09,
                    5.7475e-09,
                    5.8355e-09,
                    5.9235e-09,
                    6.0005e-09,
                    6.072e-09,
                    6.138e-09,
                    6.204e-09,
                    6.2645e-09,
                    6.3085e-09,
                    6.336e-09,
                    6.325e-09,
                    6.3195e-09,
                    6.3415e-09,
                    6.336e-09,
                    6.325e-09,
                    6.314e-09,
                    6.2975e-09,
                    6.2535e-09,
                    6.1985e-09,
                    6.138e-09,
                    6.0775e-09,
                    5.9895e-09,
                    5.9015e-09,
                    5.797e-09,
                    5.687e-09,
                    5.577e-09,
                    5.4725e-09,
                    5.3735e-09,
                    5.2635e-09,
                    5.115e-09,
                    4.917e-09,
                    4.686e-09,
                    4.4385e-09,
                    4.158e-09,
                    3.872e-09,
                    3.5695e-09,
                    3.2615e-09,
                    2.9425e-09,
                    2.6235e-09,
                    2.288e-09,
                    1.947e-09,
                    1.6005e-09,
                    1.254e-09,
                    8.91e-10,
                    5.225e-10,
                    1.595e-10,
                    -0.0000000002035,
                    -0.0000000005775,
                    -0.0000000009515,
                    -0.000000001375,
                    -0.0000000018205,
                    -0.0000000022825,
                    -0.0000000027445,
                    -0.000000003223,
                    -0.0000000037015,
                    -0.0000000041965,
                    -0.0000000046915,
                    -0.0000000051755,
                    -0.0000000056595,
                    -0.0000000063635,
                    -0.000000007095,
                    -0.0000000077715,
                    -0.000000008514,
                    -0.000000009427,
                    -0.000000010543,
                    -0.000000011924,
                    -0.000000013629,
                    -0.000000015741,
                    -0.000000013519,
                    -0.000000011044,
                    -0.000000009548,
                    -0.0000000085635,
                    -0.000000006798,
                    -0.0000000097845,
                    -0.000000020663,
                    -0.000000042652,
                    3.2203e-07,
                    8.2157e-07,
                    9.9771e-06,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0025
                ],
                "Fossil_CO2": 0.32,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    4.95e-09,
                    9.9e-09,
                    1.485e-08,
                    2.31e-08,
                    3.3e-08,
                    4.125e-08,
                    5.115e-08,
                    6.27e-08,
                    4.752e-07,
                    1.0345e-06,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0024,
                    0.0025
                ],
                "Land_CO2": -0,
                "Land_CO2_timeseries": [
                    -0.0000000001925,
                    -0.0000000003245,
                    -0.000000000396,
                    -0.000000000418,
                    -0.0000000004015,
                    -0.000000000352,
                    -0.000000000264,
                    -0.0000000001485,
                    -0.000000000011,
                    1.375e-10,
                    2.97e-10,
                    4.73e-10,
                    6.6e-10,
                    8.58e-10,
                    1.067e-09,
                    1.2815e-09,
                    1.496e-09,
                    1.7215e-09,
                    1.947e-09,
                    2.156e-09,
                    2.365e-09,
                    2.5685e-09,
                    2.772e-09,
                    2.981e-09,
                    3.19e-09,
                    3.3935e-09,
                    3.597e-09,
                    3.795e-09,
                    3.993e-09,
                    4.1855e-09,
                    4.3725e-09,
                    4.5485e-09,
                    4.7135e-09,
                    4.8675e-09,
                    5.016e-09,
                    5.159e-09,
                    5.2965e-09,
                    5.423e-09,
                    5.5495e-09,
                    5.654e-09,
                    5.7475e-09,
                    5.8355e-09,
                    5.9235e-09,
                    6.0005e-09,
                    6.072e-09,
                    6.138e-09,
                    6.204e-09,
                    6.2645e-09,
                    6.3085e-09,
                    6.336e-09,
                    6.325e-09,
                    6.3195e-09,
                    6.3415e-09,
                    6.336e-09,
                    6.325e-09,
                    6.314e-09,
                    6.2975e-09,
                    6.2535e-09,
                    6.1985e-09,
                    6.138e-09,
                    6.0775e-09,
                    5.9895e-09,
                    5.9015e-09,
                    5.797e-09,
                    5.687e-09,
                    5.577e-09,
                    5.4725e-09,
                    5.3735e-09,
                    5.2635e-09,
                    5.115e-09,
                    4.917e-09,
                    4.686e-09,
                    4.4385e-09,
                    4.158e-09,
                    3.872e-09,
                    3.5695e-09,
                    3.2615e-09,
                    2.9425e-09,
                    2.6235e-09,
                    2.288e-09,
                    1.947e-09,
                    1.6005e-09,
                    1.254e-09,
                    8.91e-10,
                    5.225e-10,
                    1.595e-10,
                    -0.0000000002035,
                    -0.0000000005775,
                    -0.0000000009515,
                    -0.000000001375,
                    -0.0000000018205,
                    -0.0000000022825,
                    -0.0000000027445,
                    -0.000000003223,
                    -0.0000000037015,
                    -0.0000000041965,
                    -0.0000000046915,
                    -0.0000000051755,
                    -0.0000000056595,
                    -0.0000000063635,
                    -0.000000007095,
                    -0.0000000077715,
                    -0.000000008514,
                    -0.000000009427,
                    -0.000000010543,
                    -0.000000011924,
                    -0.000000013629,
                    -0.000000015741,
                    -0.000000018469,
                    -0.000000020944,
                    -0.000000024398,
                    -0.000000031663,
                    -0.000000039798,
                    -0.000000051034,
                    -0.000000071814,
                    -0.00000010535,
                    -0.00000015317,
                    -0.00000021298,
                    -0.00000029252,
                    -0.00000039298,
                    -0.00000051043,
                    -0.00000064461,
                    -0.00000080503,
                    -0.00000098534,
                    -0.0000011858,
                    -0.0000014112,
                    -0.0000016621,
                    -0.0000019261,
                    -0.0000021997,
                    -0.0000025001,
                    -0.0000028107,
                    -0.0000031424,
                    -0.0000035012,
                    -0.0000038829,
                    -0.0000042841,
                    -0.0000047231,
                    -0.0000051828,
                    -0.0000056062,
                    -0.0000060144,
                    -0.0000063501,
                    -0.000006705,
                    -0.0000070221,
                    -0.0000073885,
                    -0.000007762,
                    -0.0000081375,
                    -0.0000085218,
                    -0.0000084342,
                    -0.0000080468,
                    -0.0000075646,
                    -0.0000070369,
                    -0.0000065123,
                    -0.0000064326,
                    -0.0000064996,
                    -0.0000066489,
                    -0.0000068541,
                    -0.0000070966,
                    -0.0000073408,
                    -0.0000076508,
                    -0.0000079437,
                    -0.0000082283,
                    -0.0000084966,
                    -0.0000087491,
                    -0.0000089868,
                    -0.0000092092,
                    -0.0000093943,
                    -0.0000096338,
                    -0.0000098857,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_CH4": 0.47,
                "Total_CH4_timeseries": [
                    1.711e-08,
                    3.4276e-08,
                    5.1496e-08,
                    6.8771e-08,
                    8.6099e-08,
                    1.0348e-07,
                    1.2092e-07,
                    1.3841e-07,
                    1.5595e-07,
                    1.7355e-07,
                    1.9067e-07,
                    2.0731e-07,
                    2.2349e-07,
                    2.3919e-07,
                    2.5443e-07,
                    2.6919e-07,
                    2.8348e-07,
                    2.973e-07,
                    3.1066e-07,
                    3.2354e-07,
                    3.3593e-07,
                    3.4782e-07,
                    3.5921e-07,
                    3.7011e-07,
                    3.8052e-07,
                    3.9043e-07,
                    3.9984e-07,
                    4.0877e-07,
                    4.172e-07,
                    4.2514e-07,
                    4.3305e-07,
                    4.4093e-07,
                    4.4879e-07,
                    4.5662e-07,
                    4.6442e-07,
                    4.7219e-07,
                    4.7994e-07,
                    4.8765e-07,
                    4.9534e-07,
                    5.03e-07,
                    5.1063e-07,
                    5.1822e-07,
                    5.2578e-07,
                    5.3331e-07,
                    5.4081e-07,
                    5.4828e-07,
                    5.5571e-07,
                    5.6311e-07,
                    5.7048e-07,
                    5.7782e-07,
                    5.8409e-07,
                    5.8931e-07,
                    5.9348e-07,
                    5.9661e-07,
                    5.9872e-07,
                    5.998e-07,
                    5.9987e-07,
                    5.9894e-07,
                    5.9702e-07,
                    5.9412e-07,
                    5.9102e-07,
                    5.8774e-07,
                    5.8426e-07,
                    5.8058e-07,
                    5.7669e-07,
                    5.726e-07,
                    5.6829e-07,
                    5.6376e-07,
                    5.5901e-07,
                    5.5404e-07,
                    5.4988e-07,
                    5.4651e-07,
                    5.4393e-07,
                    5.4211e-07,
                    5.4107e-07,
                    5.4077e-07,
                    5.4122e-07,
                    5.4241e-07,
                    5.4432e-07,
                    5.4695e-07,
                    5.4961e-07,
                    5.5233e-07,
                    5.5509e-07,
                    5.5791e-07,
                    5.6078e-07,
                    5.6962e-07,
                    5.8452e-07,
                    6.0555e-07,
                    6.3284e-07,
                    6.6741e-07,
                    7.1003e-07,
                    7.608e-07,
                    8.1983e-07,
                    8.8722e-07,
                    9.6338e-07,
                    1.0484e-06,
                    1.1425e-06,
                    1.2457e-06,
                    1.3581e-06,
                    1.4799e-06,
                    1.6039e-06,
                    1.7417e-06,
                    1.8994e-06,
                    2.0781e-06,
                    2.276e-06,
                    2.4848e-06,
                    2.7024e-06,
                    2.9298e-06,
                    3.1734e-06,
                    3.4429e-06,
                    3.6865e-06,
                    3.9331e-06,
                    4.1892e-06,
                    4.4571e-06,
                    4.7339e-06,
                    5.0218e-06,
                    5.315e-06,
                    5.6225e-06,
                    5.9492e-06,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019
                ],
                "Fossil_CH4": 0.73,
                "Fossil_CH4_timeseries": [
                    6.499e-09,
                    1.2999e-08,
                    1.95e-08,
                    2.6001e-08,
                    3.2502e-08,
                    3.9003e-08,
                    4.5503e-08,
                    5.2003e-08,
                    5.8501e-08,
                    6.4998e-08,
                    7.1265e-08,
                    7.7303e-08,
                    8.3113e-08,
                    8.8695e-08,
                    9.4051e-08,
                    9.918e-08,
                    1.0408e-07,
                    1.0876e-07,
                    1.1322e-07,
                    1.1745e-07,
                    1.2144e-07,
                    1.2519e-07,
                    1.2871e-07,
                    1.3199e-07,
                    1.3504e-07,
                    1.3786e-07,
                    1.4043e-07,
                    1.4278e-07,
                    1.449e-07,
                    1.4678e-07,
                    1.4863e-07,
                    1.5045e-07,
                    1.5223e-07,
                    1.5398e-07,
                    1.5569e-07,
                    1.5737e-07,
                    1.5901e-07,
                    1.6062e-07,
                    1.622e-07,
                    1.6374e-07,
                    1.6524e-07,
                    1.6671e-07,
                    1.6813e-07,
                    1.6952e-07,
                    1.7087e-07,
                    1.7218e-07,
                    1.7346e-07,
                    1.7469e-07,
                    1.7589e-07,
                    1.7704e-07,
                    1.7713e-07,
                    1.7615e-07,
                    1.7412e-07,
                    1.7105e-07,
                    1.6695e-07,
                    1.6181e-07,
                    1.5566e-07,
                    1.485e-07,
                    1.4034e-07,
                    1.312e-07,
                    1.2133e-07,
                    1.1075e-07,
                    9.9436e-08,
                    8.7394e-08,
                    7.4618e-08,
                    6.1102e-08,
                    4.6843e-08,
                    3.1838e-08,
                    1.6083e-08,
                    -0.0000000004239,
                    -0.000000016701,
                    -0.00000003276,
                    -0.00000004861,
                    -0.000000064262,
                    -0.000000079727,
                    -0.000000095013,
                    -0.00000011013,
                    -0.00000012509,
                    -0.0000001399,
                    -0.00000015456,
                    -0.00000016933,
                    -0.00000018418,
                    -0.00000019912,
                    -0.00000021414,
                    -0.00000022923,
                    -0.00000024439,
                    -0.00000025961,
                    -0.00000027488,
                    -0.00000029021,
                    -0.00000030462,
                    -0.00000031749,
                    -0.0000003288,
                    -0.00000033853,
                    -0.00000034669,
                    -0.00000035295,
                    -0.00000035729,
                    -0.0000003597,
                    -0.00000036015,
                    -0.00000035861,
                    -0.00000035506,
                    -0.00000035035,
                    -0.00000034318,
                    -0.00000033288,
                    -0.00000031932,
                    -0.00000030266,
                    -0.00000028324,
                    -0.00000026127,
                    -0.00000023662,
                    -0.00000020806,
                    -0.00000017573,
                    -0.00000013843,
                    -0.000000094007,
                    -0.000000041381,
                    1.9479e-08,
                    8.8562e-08,
                    1.6545e-07,
                    2.5144e-07,
                    3.4984e-07,
                    4.6571e-07,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019
                ],
                "Land_CH4": 0.03,
                "Land_CH4_timeseries": [
                    1.0611e-08,
                    2.1276e-08,
                    3.1996e-08,
                    4.277e-08,
                    5.3597e-08,
                    6.4479e-08,
                    7.5415e-08,
                    8.6405e-08,
                    9.745e-08,
                    1.0855e-07,
                    1.194e-07,
                    1.3001e-07,
                    1.4038e-07,
                    1.505e-07,
                    1.6038e-07,
                    1.7001e-07,
                    1.794e-07,
                    1.8854e-07,
                    1.9744e-07,
                    2.061e-07,
                    2.1449e-07,
                    2.2263e-07,
                    2.305e-07,
                    2.3812e-07,
                    2.4547e-07,
                    2.5257e-07,
                    2.5941e-07,
                    2.6598e-07,
                    2.723e-07,
                    2.7836e-07,
                    2.8442e-07,
                    2.9049e-07,
                    2.9656e-07,
                    3.0264e-07,
                    3.0873e-07,
                    3.1483e-07,
                    3.2092e-07,
                    3.2703e-07,
                    3.3314e-07,
                    3.3926e-07,
                    3.4538e-07,
                    3.5151e-07,
                    3.5765e-07,
                    3.6379e-07,
                    3.6994e-07,
                    3.761e-07,
                    3.8226e-07,
                    3.8842e-07,
                    3.946e-07,
                    4.0078e-07,
                    4.0696e-07,
                    4.1316e-07,
                    4.1935e-07,
                    4.2556e-07,
                    4.3177e-07,
                    4.3799e-07,
                    4.4421e-07,
                    4.5044e-07,
                    4.5668e-07,
                    4.6292e-07,
                    4.6969e-07,
                    4.7699e-07,
                    4.8482e-07,
                    4.9318e-07,
                    5.0207e-07,
                    5.1149e-07,
                    5.2144e-07,
                    5.3192e-07,
                    5.4293e-07,
                    5.5447e-07,
                    5.6658e-07,
                    5.7927e-07,
                    5.9254e-07,
                    6.0638e-07,
                    6.2079e-07,
                    6.3578e-07,
                    6.5135e-07,
                    6.675e-07,
                    6.8422e-07,
                    7.0151e-07,
                    7.1894e-07,
                    7.3651e-07,
                    7.5421e-07,
                    7.7204e-07,
                    7.9001e-07,
                    8.1401e-07,
                    8.4412e-07,
                    8.8044e-07,
                    9.2305e-07,
                    9.7203e-07,
                    1.0275e-06,
                    1.0896e-06,
                    1.1584e-06,
                    1.2339e-06,
                    1.3163e-06,
                    1.4057e-06,
                    1.5022e-06,
                    1.6058e-06,
                    1.7167e-06,
                    1.8349e-06,
                    1.9542e-06,
                    2.0849e-06,
                    2.2322e-06,
                    2.3974e-06,
                    2.5787e-06,
                    2.7681e-06,
                    2.9637e-06,
                    3.1664e-06,
                    3.3815e-06,
                    3.6186e-06,
                    3.8249e-06,
                    4.0271e-06,
                    4.2305e-06,
                    4.4377e-06,
                    4.6454e-06,
                    4.8564e-06,
                    5.0635e-06,
                    5.2726e-06,
                    5.4835e-06,
                    5.6957e-06,
                    5.9156e-06,
                    6.1195e-06,
                    6.3369e-06,
                    6.4943e-06,
                    6.5737e-06,
                    6.528e-06,
                    6.5194e-06,
                    6.5467e-06,
                    6.5551e-06,
                    6.5716e-06,
                    6.6285e-06,
                    6.7063e-06,
                    6.8068e-06,
                    6.928e-06,
                    7.0735e-06,
                    7.2516e-06,
                    7.4628e-06,
                    7.7025e-06,
                    7.9738e-06,
                    8.2812e-06,
                    8.6277e-06,
                    9.029e-06,
                    9.4571e-06,
                    9.9863e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_N2O": 0.04,
                "Total_N2O_timeseries": [
                    1.1427e-08,
                    2.302e-08,
                    3.4777e-08,
                    4.6689e-08,
                    5.875e-08,
                    7.0949e-08,
                    8.3274e-08,
                    9.5713e-08,
                    1.0825e-07,
                    1.2087e-07,
                    1.3356e-07,
                    1.4631e-07,
                    1.5913e-07,
                    1.7202e-07,
                    1.8497e-07,
                    1.9798e-07,
                    2.1106e-07,
                    2.242e-07,
                    2.3741e-07,
                    2.507e-07,
                    2.6414e-07,
                    2.7791e-07,
                    2.9211e-07,
                    3.0682e-07,
                    3.2211e-07,
                    3.3797e-07,
                    3.5439e-07,
                    3.713e-07,
                    3.886e-07,
                    4.0617e-07,
                    4.2392e-07,
                    4.4182e-07,
                    4.5987e-07,
                    4.7804e-07,
                    4.9634e-07,
                    5.1476e-07,
                    5.333e-07,
                    5.5196e-07,
                    5.7075e-07,
                    5.8978e-07,
                    6.0895e-07,
                    6.2825e-07,
                    6.4769e-07,
                    6.6727e-07,
                    6.8701e-07,
                    7.069e-07,
                    7.2694e-07,
                    7.4716e-07,
                    7.6756e-07,
                    7.8814e-07,
                    8.0892e-07,
                    8.2994e-07,
                    8.5121e-07,
                    8.7274e-07,
                    8.9456e-07,
                    9.1667e-07,
                    9.3907e-07,
                    9.6176e-07,
                    9.8474e-07,
                    1.008e-06,
                    1.0315e-06,
                    1.0553e-06,
                    1.0793e-06,
                    1.1036e-06,
                    1.1282e-06,
                    1.153e-06,
                    1.1782e-06,
                    1.2035e-06,
                    1.2292e-06,
                    1.2551e-06,
                    1.2814e-06,
                    1.3081e-06,
                    1.3352e-06,
                    1.3627e-06,
                    1.3908e-06,
                    1.4194e-06,
                    1.4484e-06,
                    1.478e-06,
                    1.508e-06,
                    1.5385e-06,
                    1.5693e-06,
                    1.6005e-06,
                    1.6321e-06,
                    1.664e-06,
                    1.6963e-06,
                    1.7289e-06,
                    1.762e-06,
                    1.7955e-06,
                    1.8295e-06,
                    1.8639e-06,
                    1.8993e-06,
                    1.9362e-06,
                    1.9752e-06,
                    2.0167e-06,
                    2.0608e-06,
                    2.1076e-06,
                    2.1572e-06,
                    2.2092e-06,
                    2.2633e-06,
                    2.319e-06,
                    2.376e-06,
                    2.4342e-06,
                    2.4936e-06,
                    2.5541e-06,
                    2.6158e-06,
                    2.6785e-06,
                    2.7424e-06,
                    2.8074e-06,
                    2.8737e-06,
                    2.9411e-06,
                    3.0133e-06,
                    3.0876e-06,
                    3.1647e-06,
                    3.2449e-06,
                    3.3282e-06,
                    3.415e-06,
                    3.5058e-06,
                    3.6011e-06,
                    3.7008e-06,
                    3.7776e-06,
                    3.8697e-06,
                    3.9711e-06,
                    4.0962e-06,
                    4.226e-06,
                    4.3593e-06,
                    4.5113e-06,
                    4.6724e-06,
                    4.8572e-06,
                    5.0256e-06,
                    5.2379e-06,
                    5.4599e-06,
                    5.6934e-06,
                    5.9316e-06,
                    6.1985e-06,
                    6.4764e-06,
                    6.7539e-06,
                    7.0497e-06,
                    7.3484e-06,
                    7.6853e-06,
                    8.0388e-06,
                    8.4306e-06,
                    8.8377e-06,
                    9.2698e-06,
                    9.7385e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_N2O": 0.11,
                "Fossil_N2O_timeseries": [
                    1.0267e-08,
                    2.0677e-08,
                    3.1228e-08,
                    4.1915e-08,
                    5.273e-08,
                    6.3667e-08,
                    7.4715e-08,
                    8.5866e-08,
                    9.7106e-08,
                    1.0842e-07,
                    1.1981e-07,
                    1.3126e-07,
                    1.4277e-07,
                    1.5435e-07,
                    1.66e-07,
                    1.777e-07,
                    1.8947e-07,
                    2.013e-07,
                    2.132e-07,
                    2.2517e-07,
                    2.3728e-07,
                    2.4965e-07,
                    2.6237e-07,
                    2.7552e-07,
                    2.8912e-07,
                    3.0319e-07,
                    3.177e-07,
                    3.3261e-07,
                    3.4785e-07,
                    3.6331e-07,
                    3.7891e-07,
                    3.9466e-07,
                    4.1053e-07,
                    4.2651e-07,
                    4.426e-07,
                    4.588e-07,
                    4.7511e-07,
                    4.9152e-07,
                    5.0805e-07,
                    5.2472e-07,
                    5.4151e-07,
                    5.5843e-07,
                    5.7549e-07,
                    5.9268e-07,
                    6.1002e-07,
                    6.2749e-07,
                    6.4512e-07,
                    6.6291e-07,
                    6.8086e-07,
                    6.9898e-07,
                    7.173e-07,
                    7.3583e-07,
                    7.5459e-07,
                    7.736e-07,
                    7.9287e-07,
                    8.124e-07,
                    8.3221e-07,
                    8.5228e-07,
                    8.7261e-07,
                    8.932e-07,
                    9.1403e-07,
                    9.351e-07,
                    9.5642e-07,
                    9.7798e-07,
                    9.9979e-07,
                    1.0218e-06,
                    1.0441e-06,
                    1.0667e-06,
                    1.0895e-06,
                    1.1125e-06,
                    1.1358e-06,
                    1.1593e-06,
                    1.1831e-06,
                    1.2072e-06,
                    1.2315e-06,
                    1.2561e-06,
                    1.2809e-06,
                    1.306e-06,
                    1.3313e-06,
                    1.3569e-06,
                    1.3827e-06,
                    1.4086e-06,
                    1.4348e-06,
                    1.4613e-06,
                    1.4879e-06,
                    1.5148e-06,
                    1.5419e-06,
                    1.5693e-06,
                    1.5971e-06,
                    1.6252e-06,
                    1.6539e-06,
                    1.6838e-06,
                    1.7152e-06,
                    1.7485e-06,
                    1.7838e-06,
                    1.8212e-06,
                    1.8607e-06,
                    1.902e-06,
                    1.945e-06,
                    1.9892e-06,
                    2.0344e-06,
                    2.0804e-06,
                    2.1272e-06,
                    2.1747e-06,
                    2.2228e-06,
                    2.2716e-06,
                    2.3212e-06,
                    2.3716e-06,
                    2.4229e-06,
                    2.4752e-06,
                    2.5291e-06,
                    2.5847e-06,
                    2.6426e-06,
                    2.7029e-06,
                    2.7659e-06,
                    2.8317e-06,
                    2.9003e-06,
                    2.9717e-06,
                    3.0457e-06,
                    3.095e-06,
                    3.1575e-06,
                    3.2271e-06,
                    3.3174e-06,
                    3.4127e-06,
                    3.517e-06,
                    3.6475e-06,
                    3.7841e-06,
                    3.9384e-06,
                    4.0717e-06,
                    4.2443e-06,
                    4.4237e-06,
                    4.6111e-06,
                    4.7983e-06,
                    5.0119e-06,
                    5.2315e-06,
                    5.4509e-06,
                    5.6822e-06,
                    5.9128e-06,
                    6.163e-06,
                    6.4221e-06,
                    6.702e-06,
                    6.98e-06,
                    7.2755e-06,
                    7.5904e-06,
                    7.9268e-06,
                    8.2826e-06,
                    8.6558e-06,
                    9.0379e-06,
                    9.432e-06,
                    9.8007e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.02,
                "Land_N2O_timeseries": [
                    1.16e-09,
                    2.3432e-09,
                    3.5486e-09,
                    4.7749e-09,
                    6.0202e-09,
                    7.2824e-09,
                    8.559e-09,
                    9.8471e-09,
                    1.1143e-08,
                    1.2444e-08,
                    1.3747e-08,
                    1.5052e-08,
                    1.6358e-08,
                    1.7665e-08,
                    1.8972e-08,
                    2.0281e-08,
                    2.159e-08,
                    2.2901e-08,
                    2.4213e-08,
                    2.5528e-08,
                    2.6865e-08,
                    2.8257e-08,
                    2.9731e-08,
                    3.1305e-08,
                    3.2988e-08,
                    3.4784e-08,
                    3.6686e-08,
                    3.8683e-08,
                    4.0752e-08,
                    4.2866e-08,
                    4.5004e-08,
                    4.7164e-08,
                    4.9342e-08,
                    5.1534e-08,
                    5.3741e-08,
                    5.596e-08,
                    5.8192e-08,
                    6.0438e-08,
                    6.27e-08,
                    6.5068e-08,
                    6.7439e-08,
                    6.9816e-08,
                    7.2199e-08,
                    7.4591e-08,
                    7.6991e-08,
                    7.9401e-08,
                    8.1822e-08,
                    8.4255e-08,
                    8.6699e-08,
                    8.9156e-08,
                    9.1627e-08,
                    9.4114e-08,
                    9.662e-08,
                    9.9147e-08,
                    1.017e-07,
                    1.0427e-07,
                    1.0687e-07,
                    1.0949e-07,
                    1.1213e-07,
                    1.148e-07,
                    1.1748e-07,
                    1.2019e-07,
                    1.2292e-07,
                    1.2566e-07,
                    1.2843e-07,
                    1.3121e-07,
                    1.3402e-07,
                    1.3686e-07,
                    1.3973e-07,
                    1.4265e-07,
                    1.4564e-07,
                    1.4876e-07,
                    1.5205e-07,
                    1.5556e-07,
                    1.5931e-07,
                    1.633e-07,
                    1.6754e-07,
                    1.7202e-07,
                    1.7672e-07,
                    1.8161e-07,
                    1.8666e-07,
                    1.9187e-07,
                    1.9723e-07,
                    2.0273e-07,
                    2.0837e-07,
                    2.1416e-07,
                    2.2008e-07,
                    2.2615e-07,
                    2.3238e-07,
                    2.3876e-07,
                    2.454e-07,
                    2.5244e-07,
                    2.5999e-07,
                    2.6815e-07,
                    2.7695e-07,
                    2.864e-07,
                    2.9649e-07,
                    3.0715e-07,
                    3.1829e-07,
                    3.2978e-07,
                    3.4159e-07,
                    3.5378e-07,
                    3.6639e-07,
                    3.7944e-07,
                    3.9295e-07,
                    4.0688e-07,
                    4.2121e-07,
                    4.3587e-07,
                    4.508e-07,
                    4.6588e-07,
                    4.8421e-07,
                    5.0288e-07,
                    5.221e-07,
                    5.4195e-07,
                    5.6231e-07,
                    5.8329e-07,
                    6.0547e-07,
                    6.2939e-07,
                    6.5506e-07,
                    6.8267e-07,
                    7.1219e-07,
                    7.4401e-07,
                    7.7877e-07,
                    8.1329e-07,
                    8.4234e-07,
                    8.6387e-07,
                    8.8839e-07,
                    9.1873e-07,
                    9.5385e-07,
                    9.9356e-07,
                    1.0362e-06,
                    1.0823e-06,
                    1.1332e-06,
                    1.1866e-06,
                    1.2449e-06,
                    1.303e-06,
                    1.3675e-06,
                    1.4356e-06,
                    1.5222e-06,
                    1.6167e-06,
                    1.7287e-06,
                    1.8576e-06,
                    1.9943e-06,
                    2.1481e-06,
                    2.3129e-06,
                    2.4872e-06,
                    2.666e-06,
                    2.8508e-06,
                    3.0465e-06,
                    3.2436e-06,
                    3.446e-06,
                    3.6782e-06,
                    3.9215e-06,
                    4.1648e-06,
                    4.4201e-06,
                    4.6771e-06,
                    4.943e-06,
                    5.2248e-06,
                    5.5138e-06,
                    5.7973e-06,
                    6.0797e-06,
                    6.3488e-06,
                    6.635e-06,
                    6.9281e-06,
                    7.2384e-06,
                    7.5524e-06,
                    7.872e-06,
                    8.1956e-06,
                    8.5174e-06,
                    8.8434e-06,
                    9.1719e-06,
                    9.5023e-06
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                51.59056,
                                24.24297
                            ],
                            [
                                51.59056,
                                24.12333
                            ],
                            [
                                52.06633,
                                23.55332
                            ],
                            [
                                52.58111,
                                22.93583
                            ],
                            [
                                53.4375,
                                22.83279
                            ],
                            [
                                54.06808,
                                22.75687
                            ],
                            [
                                54.50632,
                                22.70409
                            ],
                            [
                                55.13722,
                                22.62806
                            ],
                            [
                                55.20833,
                                22.70833
                            ],
                            [
                                55.22805,
                                22.79153
                            ],
                            [
                                55.21404,
                                22.93465
                            ],
                            [
                                55.23431,
                                23.11355
                            ],
                            [
                                55.2986,
                                23.20622
                            ],
                            [
                                55.39947,
                                23.38802
                            ],
                            [
                                55.57184,
                                23.62937
                            ],
                            [
                                55.57192,
                                23.70225
                            ],
                            [
                                55.53311,
                                23.75904
                            ],
                            [
                                55.5348,
                                23.84048
                            ],
                            [
                                55.48657,
                                23.93879
                            ],
                            [
                                55.63077,
                                24.0188
                            ],
                            [
                                55.73132,
                                24.05696
                            ],
                            [
                                55.83222,
                                24.01528
                            ],
                            [
                                55.90549,
                                24.04707
                            ],
                            [
                                56.01703,
                                24.0689
                            ],
                            [
                                55.95288,
                                24.22225
                            ],
                            [
                                55.83305,
                                24.20206
                            ],
                            [
                                55.77797,
                                24.2338
                            ],
                            [
                                55.83432,
                                24.32956
                            ],
                            [
                                55.83414,
                                24.40739
                            ],
                            [
                                55.76575,
                                24.53417
                            ],
                            [
                                55.83572,
                                24.6741
                            ],
                            [
                                55.81335,
                                24.90584
                            ],
                            [
                                55.85178,
                                24.96358
                            ],
                            [
                                55.96363,
                                25.00414
                            ],
                            [
                                56.0605,
                                24.94473
                            ],
                            [
                                55.98133,
                                24.87612
                            ],
                            [
                                56.11095,
                                24.73901
                            ],
                            [
                                56.19961,
                                24.78456
                            ],
                            [
                                56.20771,
                                24.84958
                            ],
                            [
                                56.32705,
                                24.89668
                            ],
                            [
                                56.37424,
                                24.98035
                            ],
                            [
                                56.35632,
                                25.13691
                            ],
                            [
                                56.37633,
                                25.31771
                            ],
                            [
                                56.35042,
                                25.36493
                            ],
                            [
                                56.37103,
                                25.52599
                            ],
                            [
                                56.35402,
                                25.5948
                            ],
                            [
                                56.26584,
                                25.62472
                            ],
                            [
                                56.17884,
                                25.6236
                            ],
                            [
                                56.14165,
                                25.82377
                            ],
                            [
                                56.19074,
                                25.9717
                            ],
                            [
                                56.15345,
                                26.06864
                            ],
                            [
                                56.086,
                                26.05065
                            ],
                            [
                                56.05235,
                                25.89766
                            ],
                            [
                                55.89499,
                                25.74489
                            ],
                            [
                                55.79561,
                                25.71774
                            ],
                            [
                                55.73635,
                                25.64742
                            ],
                            [
                                55.65112,
                                25.58576
                            ],
                            [
                                55.63767,
                                25.53881
                            ],
                            [
                                55.56591,
                                25.52815
                            ],
                            [
                                55.49512,
                                25.47683
                            ],
                            [
                                55.28868,
                                25.27731
                            ],
                            [
                                55.18183,
                                25.13234
                            ],
                            [
                                55.04692,
                                25.00107
                            ],
                            [
                                54.97447,
                                25.03921
                            ],
                            [
                                54.95983,
                                24.96127
                            ],
                            [
                                54.81159,
                                24.85845
                            ],
                            [
                                54.71015,
                                24.80986
                            ],
                            [
                                54.65892,
                                24.69636
                            ],
                            [
                                54.6175,
                                24.53301
                            ],
                            [
                                54.58366,
                                24.45145
                            ],
                            [
                                54.4913,
                                24.42022
                            ],
                            [
                                54.45511,
                                24.32475
                            ],
                            [
                                54.38426,
                                24.25575
                            ],
                            [
                                54.29554,
                                24.26955
                            ],
                            [
                                54.28191,
                                24.33249
                            ],
                            [
                                54.21615,
                                24.34955
                            ],
                            [
                                54.09507,
                                24.29
                            ],
                            [
                                54.14486,
                                24.20615
                            ],
                            [
                                54.04478,
                                24.11472
                            ],
                            [
                                53.92182,
                                24.07907
                            ],
                            [
                                53.90766,
                                24.13851
                            ],
                            [
                                53.94277,
                                24.2066
                            ],
                            [
                                53.82937,
                                24.24872
                            ],
                            [
                                53.73194,
                                24.23435
                            ],
                            [
                                53.63046,
                                24.17163
                            ],
                            [
                                53.77405,
                                24.124
                            ],
                            [
                                53.85036,
                                24.15278
                            ],
                            [
                                53.90358,
                                24.12507
                            ],
                            [
                                53.91036,
                                24.07733
                            ],
                            [
                                53.80542,
                                24.05084
                            ],
                            [
                                53.70962,
                                24.06329
                            ],
                            [
                                53.60779,
                                24.04373
                            ],
                            [
                                53.4438,
                                24.12284
                            ],
                            [
                                53.28779,
                                24.08611
                            ],
                            [
                                53.19962,
                                24.14507
                            ],
                            [
                                53.05446,
                                24.12055
                            ],
                            [
                                52.98146,
                                24.15178
                            ],
                            [
                                52.93753,
                                24.13346
                            ],
                            [
                                52.83157,
                                24.14272
                            ],
                            [
                                52.77007,
                                24.12759
                            ],
                            [
                                52.66094,
                                24.15244
                            ],
                            [
                                52.59794,
                                24.19614
                            ],
                            [
                                52.56335,
                                24.13379
                            ],
                            [
                                52.4578,
                                24.09274
                            ],
                            [
                                52.44299,
                                24.06622
                            ],
                            [
                                52.31005,
                                23.99703
                            ],
                            [
                                52.21733,
                                23.9676
                            ],
                            [
                                52.0904,
                                23.94878
                            ],
                            [
                                51.94882,
                                23.99786
                            ],
                            [
                                51.90697,
                                23.97483
                            ],
                            [
                                51.83332,
                                23.98858
                            ],
                            [
                                51.78912,
                                24.02855
                            ],
                            [
                                51.76849,
                                24.14675
                            ],
                            [
                                51.77954,
                                24.25891
                            ],
                            [
                                51.74299,
                                24.28022
                            ],
                            [
                                51.69241,
                                24.2179
                            ],
                            [
                                51.59056,
                                24.24297
                            ]
                        ],
                        [
                            [
                                56.22338,
                                25.26201
                            ],
                            [
                                56.27596,
                                25.3373
                            ],
                            [
                                56.35056,
                                25.30419
                            ],
                            [
                                56.28226,
                                25.23678
                            ],
                            [
                                56.22338,
                                25.26201
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                54.30458,
                                24.4562
                            ],
                            [
                                54.46486,
                                24.39839
                            ],
                            [
                                54.37315,
                                24.50902
                            ],
                            [
                                54.30458,
                                24.4562
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "GBR",
                "Country": "United Kingdom",
                "Total_3GHG": 2.43,
                "Total_3GHG_timeseries": [
                    0.0001,
                    0.0002,
                    0.0003,
                    0.0004,
                    0.0005,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0009,
                    0.001,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0016,
                    0.0017,
                    0.0019,
                    0.0021,
                    0.0022,
                    0.0024,
                    0.0026,
                    0.0027,
                    0.0029,
                    0.0031,
                    0.0033,
                    0.0035,
                    0.0037,
                    0.0039,
                    0.0041,
                    0.0043,
                    0.0045,
                    0.0047,
                    0.0049,
                    0.0051,
                    0.0053,
                    0.0055,
                    0.0057,
                    0.006,
                    0.0062,
                    0.0064,
                    0.0066,
                    0.0069,
                    0.0071,
                    0.0073,
                    0.0075,
                    0.0077,
                    0.008,
                    0.0082,
                    0.0085,
                    0.0087,
                    0.009,
                    0.0092,
                    0.0095,
                    0.0098,
                    0.01,
                    0.0103,
                    0.0106,
                    0.0109,
                    0.0112,
                    0.0115,
                    0.0118,
                    0.0121,
                    0.0123,
                    0.0127,
                    0.013,
                    0.0133,
                    0.0136,
                    0.0139,
                    0.0141,
                    0.0144,
                    0.0146,
                    0.0148,
                    0.015,
                    0.0153,
                    0.0155,
                    0.0158,
                    0.0158,
                    0.0161,
                    0.0163,
                    0.0165,
                    0.0168,
                    0.017,
                    0.0172,
                    0.0173,
                    0.0175,
                    0.0177,
                    0.018,
                    0.0182,
                    0.0184,
                    0.0187,
                    0.0189,
                    0.0192,
                    0.0195,
                    0.0198,
                    0.02,
                    0.0202,
                    0.0205,
                    0.0208,
                    0.0211,
                    0.0214,
                    0.0217,
                    0.022,
                    0.0224,
                    0.0227,
                    0.0231,
                    0.0235,
                    0.0239,
                    0.0242,
                    0.0246,
                    0.025,
                    0.0254,
                    0.0257,
                    0.0261,
                    0.0265,
                    0.0269,
                    0.0273,
                    0.0277,
                    0.0281,
                    0.0285,
                    0.0289,
                    0.0293,
                    0.0296,
                    0.03,
                    0.0304,
                    0.0307,
                    0.031,
                    0.0313,
                    0.0316,
                    0.0319,
                    0.0323,
                    0.0325,
                    0.0328,
                    0.0331,
                    0.0334,
                    0.0335,
                    0.0338,
                    0.0341,
                    0.0343,
                    0.0346,
                    0.0348,
                    0.0351,
                    0.0354,
                    0.0356,
                    0.0359,
                    0.0361,
                    0.0364,
                    0.0366,
                    0.0369,
                    0.0371,
                    0.0373,
                    0.0375,
                    0.0377,
                    0.0379,
                    0.0381,
                    0.0383,
                    0.0385,
                    0.0386,
                    0.0387,
                    0.0389,
                    0.039,
                    0.0391,
                    0.0391,
                    0.0392,
                    0.0393,
                    0.0394,
                    0.0394,
                    0.0395,
                    0.0395,
                    0.0396,
                    0.0397,
                    0.0397,
                    0.0398,
                    0.0398
                ],
                "Fossil_3GHG": 3.43,
                "Fossil_3GHG_timeseries": [
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0004,
                    0.0005,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0021,
                    0.0022,
                    0.0024,
                    0.0025,
                    0.0027,
                    0.0029,
                    0.003,
                    0.0032,
                    0.0034,
                    0.0035,
                    0.0037,
                    0.0039,
                    0.0041,
                    0.0043,
                    0.0045,
                    0.0047,
                    0.0048,
                    0.005,
                    0.0052,
                    0.0054,
                    0.0056,
                    0.0058,
                    0.006,
                    0.0062,
                    0.0064,
                    0.0066,
                    0.0068,
                    0.007,
                    0.0072,
                    0.0074,
                    0.0076,
                    0.0079,
                    0.0081,
                    0.0083,
                    0.0086,
                    0.0088,
                    0.0091,
                    0.0093,
                    0.0096,
                    0.0098,
                    0.0101,
                    0.0104,
                    0.0106,
                    0.0109,
                    0.0112,
                    0.0114,
                    0.0117,
                    0.012,
                    0.0123,
                    0.0125,
                    0.0127,
                    0.013,
                    0.0131,
                    0.0133,
                    0.0135,
                    0.0138,
                    0.014,
                    0.0141,
                    0.0143,
                    0.0145,
                    0.0147,
                    0.0149,
                    0.0151,
                    0.0153,
                    0.0154,
                    0.0156,
                    0.0158,
                    0.016,
                    0.0162,
                    0.0164,
                    0.0167,
                    0.0169,
                    0.0172,
                    0.0174,
                    0.0177,
                    0.0179,
                    0.0181,
                    0.0184,
                    0.0186,
                    0.0189,
                    0.0192,
                    0.0194,
                    0.0198,
                    0.0201,
                    0.0204,
                    0.0208,
                    0.0211,
                    0.0215,
                    0.0218,
                    0.0222,
                    0.0225,
                    0.0229,
                    0.0232,
                    0.0236,
                    0.024,
                    0.0243,
                    0.0247,
                    0.0251,
                    0.0255,
                    0.0258,
                    0.0262,
                    0.0265,
                    0.0269,
                    0.0272,
                    0.0275,
                    0.0278,
                    0.0281,
                    0.0284,
                    0.0287,
                    0.029,
                    0.0293,
                    0.0296,
                    0.0298,
                    0.0301,
                    0.0303,
                    0.0305,
                    0.0307,
                    0.0309,
                    0.0312,
                    0.0314,
                    0.0316,
                    0.0319,
                    0.0321,
                    0.0324,
                    0.0326,
                    0.0328,
                    0.0331,
                    0.0333,
                    0.0335,
                    0.0338,
                    0.034,
                    0.0341,
                    0.0343,
                    0.0345,
                    0.0347,
                    0.0349,
                    0.0351,
                    0.0352,
                    0.0353,
                    0.0354,
                    0.0355,
                    0.0356,
                    0.0357,
                    0.0358,
                    0.0359,
                    0.0359,
                    0.036,
                    0.036,
                    0.0361,
                    0.0361,
                    0.0362,
                    0.0362,
                    0.0363,
                    0.0363
                ],
                "Land_3GHG": 0.61,
                "Land_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0033,
                    0.0033,
                    0.0033,
                    0.0033,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0035,
                    0.0035,
                    0.0035,
                    0.0035
                ],
                "Total_CO2": 3.09,
                "Total_CO2_timeseries": [
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0021,
                    0.0022,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0032,
                    0.0033,
                    0.0035,
                    0.0037,
                    0.0038,
                    0.004,
                    0.0041,
                    0.0043,
                    0.0045,
                    0.0046,
                    0.0048,
                    0.005,
                    0.0051,
                    0.0053,
                    0.0055,
                    0.0057,
                    0.0059,
                    0.0061,
                    0.0063,
                    0.0065,
                    0.0067,
                    0.0069,
                    0.0071,
                    0.0073,
                    0.0075,
                    0.0077,
                    0.0079,
                    0.0082,
                    0.0084,
                    0.0086,
                    0.0088,
                    0.0091,
                    0.0093,
                    0.0095,
                    0.0098,
                    0.01,
                    0.0102,
                    0.0105,
                    0.0107,
                    0.0109,
                    0.011,
                    0.0112,
                    0.0115,
                    0.0117,
                    0.0119,
                    0.012,
                    0.0122,
                    0.0124,
                    0.0126,
                    0.0128,
                    0.013,
                    0.0132,
                    0.0134,
                    0.0136,
                    0.0138,
                    0.014,
                    0.0142,
                    0.0144,
                    0.0146,
                    0.0149,
                    0.0151,
                    0.0153,
                    0.0155,
                    0.0157,
                    0.0159,
                    0.0161,
                    0.0163,
                    0.0165,
                    0.0168,
                    0.017,
                    0.0173,
                    0.0175,
                    0.0178,
                    0.018,
                    0.0183,
                    0.0185,
                    0.0188,
                    0.0191,
                    0.0193,
                    0.0196,
                    0.0198,
                    0.0201,
                    0.0204,
                    0.0207,
                    0.021,
                    0.0212,
                    0.0215,
                    0.0218,
                    0.0221,
                    0.0224,
                    0.0227,
                    0.023,
                    0.0233,
                    0.0236,
                    0.0238,
                    0.0241,
                    0.0244,
                    0.0246,
                    0.0249,
                    0.0252,
                    0.0255,
                    0.0257,
                    0.0259,
                    0.0262,
                    0.0264,
                    0.0267,
                    0.027,
                    0.0272,
                    0.0275,
                    0.0278,
                    0.028,
                    0.0283,
                    0.0286,
                    0.0288,
                    0.0291,
                    0.0293,
                    0.0296,
                    0.0298,
                    0.0301,
                    0.0304,
                    0.0306,
                    0.0309,
                    0.0311,
                    0.0314,
                    0.0317,
                    0.0319,
                    0.0322,
                    0.0324,
                    0.0326,
                    0.0329,
                    0.0331,
                    0.0333,
                    0.0335,
                    0.0337,
                    0.0339,
                    0.0341,
                    0.0343,
                    0.0345,
                    0.0346,
                    0.0348,
                    0.035,
                    0.0351
                ],
                "Fossil_CO2": 4.35,
                "Fossil_CO2_timeseries": [
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0029,
                    0.003,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0036,
                    0.0037,
                    0.0039,
                    0.004,
                    0.0042,
                    0.0043,
                    0.0045,
                    0.0047,
                    0.0048,
                    0.005,
                    0.0051,
                    0.0053,
                    0.0055,
                    0.0057,
                    0.0059,
                    0.0061,
                    0.0062,
                    0.0064,
                    0.0066,
                    0.0068,
                    0.007,
                    0.0073,
                    0.0075,
                    0.0077,
                    0.0079,
                    0.0081,
                    0.0083,
                    0.0085,
                    0.0087,
                    0.009,
                    0.0092,
                    0.0094,
                    0.0096,
                    0.0098,
                    0.01,
                    0.0102,
                    0.0104,
                    0.0106,
                    0.0108,
                    0.011,
                    0.0111,
                    0.0113,
                    0.0115,
                    0.0117,
                    0.0119,
                    0.0121,
                    0.0123,
                    0.0125,
                    0.0127,
                    0.0129,
                    0.0131,
                    0.0133,
                    0.0135,
                    0.0137,
                    0.0139,
                    0.0141,
                    0.0143,
                    0.0145,
                    0.0147,
                    0.0149,
                    0.0151,
                    0.0153,
                    0.0155,
                    0.0157,
                    0.016,
                    0.0162,
                    0.0164,
                    0.0167,
                    0.0169,
                    0.0172,
                    0.0175,
                    0.0177,
                    0.018,
                    0.0182,
                    0.0185,
                    0.0187,
                    0.019,
                    0.0193,
                    0.0196,
                    0.0198,
                    0.0201,
                    0.0204,
                    0.0207,
                    0.0209,
                    0.0212,
                    0.0215,
                    0.0218,
                    0.0221,
                    0.0224,
                    0.0227,
                    0.0229,
                    0.0232,
                    0.0235,
                    0.0238,
                    0.024,
                    0.0243,
                    0.0245,
                    0.0248,
                    0.025,
                    0.0253,
                    0.0255,
                    0.0258,
                    0.026,
                    0.0263,
                    0.0266,
                    0.0268,
                    0.0271,
                    0.0274,
                    0.0276,
                    0.0279,
                    0.0281,
                    0.0284,
                    0.0287,
                    0.0289,
                    0.0292,
                    0.0294,
                    0.0297,
                    0.0299,
                    0.0302,
                    0.0305,
                    0.0307,
                    0.031,
                    0.0312,
                    0.0314,
                    0.0317,
                    0.0319,
                    0.0321,
                    0.0323,
                    0.0325,
                    0.0327,
                    0.0329,
                    0.033,
                    0.0332,
                    0.0334,
                    0.0335,
                    0.0337,
                    0.0338
                ],
                "Land_CO2": 0.36,
                "Land_CO2_timeseries": [
                    7.7298e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013
                ],
                "Total_CH4": 0.7,
                "Total_CH4_timeseries": [
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.004,
                    0.004,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0055,
                    0.0056,
                    0.0057,
                    0.0058,
                    0.0059,
                    0.0059,
                    0.006,
                    0.0061,
                    0.0062,
                    0.0062,
                    0.0062,
                    0.0063,
                    0.0063,
                    0.0063,
                    0.0063,
                    0.0063,
                    0.0063,
                    0.0063,
                    0.0063,
                    0.0063,
                    0.0063,
                    0.0063,
                    0.0062,
                    0.0062,
                    0.0062,
                    0.0062,
                    0.0061,
                    0.0061,
                    0.0061,
                    0.006,
                    0.006,
                    0.006,
                    0.0059,
                    0.0059,
                    0.0059,
                    0.0058,
                    0.0058,
                    0.0057,
                    0.0057,
                    0.0056,
                    0.0055,
                    0.0054,
                    0.0053,
                    0.0052,
                    0.0051,
                    0.005,
                    0.0048,
                    0.0047,
                    0.0046,
                    0.0044,
                    0.0042,
                    0.0041,
                    0.0039,
                    0.0038,
                    0.0036,
                    0.0035,
                    0.0034,
                    0.0032,
                    0.0031,
                    0.003,
                    0.0029
                ],
                "Fossil_CH4": 0.64,
                "Fossil_CH4_timeseries": [
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0048,
                    0.0049,
                    0.005,
                    0.005,
                    0.005,
                    0.005,
                    0.005,
                    0.005,
                    0.005,
                    0.005,
                    0.005,
                    0.005,
                    0.005,
                    0.005,
                    0.005,
                    0.005,
                    0.0049,
                    0.0048,
                    0.0048,
                    0.0048,
                    0.0047,
                    0.0047,
                    0.0047,
                    0.0046,
                    0.0046,
                    0.0045,
                    0.0045,
                    0.0045,
                    0.0044,
                    0.0044,
                    0.0044,
                    0.0043,
                    0.0042,
                    0.0041,
                    0.0041,
                    0.004,
                    0.0039,
                    0.0038,
                    0.0037,
                    0.0036,
                    0.0035,
                    0.0033,
                    0.0032,
                    0.0031,
                    0.0029,
                    0.0028,
                    0.0026,
                    0.0025,
                    0.0024,
                    0.0022,
                    0.0021,
                    0.002,
                    0.0019,
                    0.0018,
                    0.0017
                ],
                "Land_CH4": 0.79,
                "Land_CH4_timeseries": [
                    7.5908e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0012
                ],
                "Total_N2O": 2.17,
                "Total_N2O_timeseries": [
                    1.4935e-06,
                    3.0107e-06,
                    4.5509e-06,
                    6.1129e-06,
                    7.6954e-06,
                    9.2969e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018
                ],
                "Fossil_N2O": 3.59,
                "Fossil_N2O_timeseries": [
                    7.7365e-07,
                    1.5566e-06,
                    2.3487e-06,
                    3.1497e-06,
                    3.9595e-06,
                    4.7776e-06,
                    5.6039e-06,
                    6.4377e-06,
                    7.2788e-06,
                    8.1266e-06,
                    8.9808e-06,
                    9.8412e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008
                ],
                "Land_N2O": 1.62,
                "Land_N2O_timeseries": [
                    7.1988e-07,
                    1.4542e-06,
                    2.2022e-06,
                    2.9632e-06,
                    3.736e-06,
                    4.5193e-06,
                    5.3115e-06,
                    6.1109e-06,
                    6.9153e-06,
                    7.7226e-06,
                    8.5312e-06,
                    9.3409e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -3.4075,
                                58.65773
                            ],
                            [
                                -3.37515,
                                58.5952
                            ],
                            [
                                -3.55813,
                                58.62339
                            ],
                            [
                                -3.6612,
                                58.61966
                            ],
                            [
                                -3.75019,
                                58.57944
                            ],
                            [
                                -3.93258,
                                58.57268
                            ],
                            [
                                -4.21215,
                                58.53234
                            ],
                            [
                                -4.42646,
                                58.55076
                            ],
                            [
                                -4.54226,
                                58.58071
                            ],
                            [
                                -4.59479,
                                58.53682
                            ],
                            [
                                -4.79543,
                                58.57622
                            ],
                            [
                                -4.87754,
                                58.6141
                            ],
                            [
                                -5.01405,
                                58.61633
                            ],
                            [
                                -5.12393,
                                58.49104
                            ],
                            [
                                -5.05976,
                                58.46067
                            ],
                            [
                                -5.17935,
                                58.35206
                            ],
                            [
                                -5.13503,
                                58.28007
                            ],
                            [
                                -5.36489,
                                58.21902
                            ],
                            [
                                -5.26883,
                                58.10245
                            ],
                            [
                                -5.30152,
                                58.06781
                            ],
                            [
                                -5.45482,
                                58.07354
                            ],
                            [
                                -5.30827,
                                57.98053
                            ],
                            [
                                -5.45475,
                                57.85445
                            ],
                            [
                                -5.63627,
                                57.91286
                            ],
                            [
                                -5.68841,
                                57.8656
                            ],
                            [
                                -5.81184,
                                57.85726
                            ],
                            [
                                -5.78654,
                                57.69524
                            ],
                            [
                                -5.81726,
                                57.64789
                            ],
                            [
                                -5.72795,
                                57.58687
                            ],
                            [
                                -5.84865,
                                57.56035
                            ],
                            [
                                -5.86053,
                                57.45166
                            ],
                            [
                                -5.82838,
                                57.38753
                            ],
                            [
                                -5.72015,
                                57.31113
                            ],
                            [
                                -5.59011,
                                57.27179
                            ],
                            [
                                -5.71957,
                                57.11812
                            ],
                            [
                                -5.79549,
                                57.06469
                            ],
                            [
                                -5.88769,
                                56.90404
                            ],
                            [
                                -5.78303,
                                56.86747
                            ],
                            [
                                -5.87729,
                                56.80832
                            ],
                            [
                                -6.06397,
                                56.75948
                            ],
                            [
                                -6.17792,
                                56.75501
                            ],
                            [
                                -6.21464,
                                56.70114
                            ],
                            [
                                -5.94106,
                                56.66866
                            ],
                            [
                                -6.00089,
                                56.62133
                            ],
                            [
                                -5.90349,
                                56.55148
                            ],
                            [
                                -5.69806,
                                56.5122
                            ],
                            [
                                -5.56452,
                                56.54292
                            ],
                            [
                                -5.48969,
                                56.61142
                            ],
                            [
                                -5.31964,
                                56.65051
                            ],
                            [
                                -5.43714,
                                56.51836
                            ],
                            [
                                -5.40244,
                                56.4751
                            ],
                            [
                                -5.48364,
                                56.43554
                            ],
                            [
                                -5.57487,
                                56.33481
                            ],
                            [
                                -5.59775,
                                56.25163
                            ],
                            [
                                -5.51965,
                                56.16712
                            ],
                            [
                                -5.7062,
                                55.96431
                            ],
                            [
                                -5.60945,
                                55.91022
                            ],
                            [
                                -5.66908,
                                55.81299
                            ],
                            [
                                -5.5705,
                                55.7658
                            ],
                            [
                                -5.66372,
                                55.66791
                            ],
                            [
                                -5.71568,
                                55.57809
                            ],
                            [
                                -5.72004,
                                55.43464
                            ],
                            [
                                -5.79622,
                                55.39115
                            ],
                            [
                                -5.79879,
                                55.30005
                            ],
                            [
                                -5.60329,
                                55.30796
                            ],
                            [
                                -5.51733,
                                55.36964
                            ],
                            [
                                -5.5584,
                                55.43479
                            ],
                            [
                                -5.51211,
                                55.48771
                            ],
                            [
                                -5.48136,
                                55.64305
                            ],
                            [
                                -5.44631,
                                55.70955
                            ],
                            [
                                -5.31519,
                                55.78573
                            ],
                            [
                                -5.41814,
                                55.89583
                            ],
                            [
                                -5.44986,
                                56.00694
                            ],
                            [
                                -5.33898,
                                55.99556
                            ],
                            [
                                -5.34682,
                                55.89282
                            ],
                            [
                                -5.28238,
                                55.84851
                            ],
                            [
                                -5.18858,
                                55.9465
                            ],
                            [
                                -5.04449,
                                55.87122
                            ],
                            [
                                -4.88811,
                                55.82007
                            ],
                            [
                                -4.85532,
                                55.77383
                            ],
                            [
                                -4.90457,
                                55.6989
                            ],
                            [
                                -4.69861,
                                55.60689
                            ],
                            [
                                -4.62053,
                                55.49979
                            ],
                            [
                                -4.65055,
                                55.44188
                            ],
                            [
                                -4.76911,
                                55.40068
                            ],
                            [
                                -4.84606,
                                55.32337
                            ],
                            [
                                -4.86392,
                                55.22411
                            ],
                            [
                                -4.99158,
                                55.14295
                            ],
                            [
                                -5.05995,
                                55.03074
                            ],
                            [
                                -4.99082,
                                54.92075
                            ],
                            [
                                -5.06037,
                                54.92368
                            ],
                            [
                                -5.10871,
                                55.01796
                            ],
                            [
                                -5.1859,
                                54.97706
                            ],
                            [
                                -5.13856,
                                54.85162
                            ],
                            [
                                -5.00138,
                                54.77245
                            ],
                            [
                                -4.93793,
                                54.8315
                            ],
                            [
                                -4.81561,
                                54.864
                            ],
                            [
                                -4.601,
                                54.77675
                            ],
                            [
                                -4.5712,
                                54.73857
                            ],
                            [
                                -4.40639,
                                54.67823
                            ],
                            [
                                -4.36699,
                                54.69069
                            ],
                            [
                                -4.36257,
                                54.86445
                            ],
                            [
                                -4.21754,
                                54.82593
                            ],
                            [
                                -4.15752,
                                54.78059
                            ],
                            [
                                -3.97047,
                                54.77184
                            ],
                            [
                                -3.72602,
                                54.87983
                            ],
                            [
                                -3.59599,
                                54.87343
                            ],
                            [
                                -3.56019,
                                54.97898
                            ],
                            [
                                -3.32687,
                                54.97813
                            ],
                            [
                                -3.28467,
                                54.94156
                            ],
                            [
                                -3.39833,
                                54.86819
                            ],
                            [
                                -3.43871,
                                54.75676
                            ],
                            [
                                -3.50945,
                                54.71708
                            ],
                            [
                                -3.57552,
                                54.63534
                            ],
                            [
                                -3.61898,
                                54.49103
                            ],
                            [
                                -3.42694,
                                54.34379
                            ],
                            [
                                -3.41982,
                                54.2829
                            ],
                            [
                                -3.33003,
                                54.19639
                            ],
                            [
                                -3.24045,
                                54.20305
                            ],
                            [
                                -3.23856,
                                54.10394
                            ],
                            [
                                -3.17313,
                                54.07928
                            ],
                            [
                                -3.06087,
                                54.16203
                            ],
                            [
                                -2.98421,
                                54.13774
                            ],
                            [
                                -2.90458,
                                54.19474
                            ],
                            [
                                -2.81626,
                                54.12169
                            ],
                            [
                                -2.90611,
                                54.03961
                            ],
                            [
                                -2.85646,
                                53.96602
                            ],
                            [
                                -3.05017,
                                53.9192
                            ],
                            [
                                -3.05512,
                                53.76355
                            ],
                            [
                                -2.92915,
                                53.73154
                            ],
                            [
                                -3.03105,
                                53.64727
                            ],
                            [
                                -3.10546,
                                53.55155
                            ],
                            [
                                -3.03904,
                                53.4408
                            ],
                            [
                                -3.19835,
                                53.3762
                            ],
                            [
                                -3.11981,
                                53.32313
                            ],
                            [
                                -3.12121,
                                53.24882
                            ],
                            [
                                -3.32267,
                                53.35735
                            ],
                            [
                                -3.60114,
                                53.29161
                            ],
                            [
                                -3.83739,
                                53.29564
                            ],
                            [
                                -4.08043,
                                53.22947
                            ],
                            [
                                -4.1937,
                                53.21337
                            ],
                            [
                                -4.21415,
                                53.18218
                            ],
                            [
                                -4.34711,
                                53.10695
                            ],
                            [
                                -4.3535,
                                53.03352
                            ],
                            [
                                -4.52842,
                                52.93764
                            ],
                            [
                                -4.57927,
                                52.93775
                            ],
                            [
                                -4.72493,
                                52.85405
                            ],
                            [
                                -4.75092,
                                52.81584
                            ],
                            [
                                -4.53695,
                                52.79982
                            ],
                            [
                                -4.45706,
                                52.87117
                            ],
                            [
                                -4.21726,
                                52.91864
                            ],
                            [
                                -4.1191,
                                52.84809
                            ],
                            [
                                -4.14422,
                                52.80092
                            ],
                            [
                                -4.04806,
                                52.70518
                            ],
                            [
                                -4.12651,
                                52.60734
                            ],
                            [
                                -4.05208,
                                52.48177
                            ],
                            [
                                -4.14001,
                                52.32342
                            ],
                            [
                                -4.2075,
                                52.26382
                            ],
                            [
                                -4.36566,
                                52.21915
                            ],
                            [
                                -4.51885,
                                52.13527
                            ],
                            [
                                -4.72669,
                                52.11658
                            ],
                            [
                                -4.83926,
                                52.02641
                            ],
                            [
                                -4.988,
                                51.99947
                            ],
                            [
                                -5.29007,
                                51.91358
                            ],
                            [
                                -5.12847,
                                51.8585
                            ],
                            [
                                -5.11781,
                                51.76894
                            ],
                            [
                                -5.18919,
                                51.70781
                            ],
                            [
                                -5.02149,
                                51.70816
                            ],
                            [
                                -5.05841,
                                51.62143
                            ],
                            [
                                -4.94599,
                                51.59844
                            ],
                            [
                                -4.85908,
                                51.64696
                            ],
                            [
                                -4.72085,
                                51.65165
                            ],
                            [
                                -4.66094,
                                51.73163
                            ],
                            [
                                -4.55766,
                                51.74172
                            ],
                            [
                                -4.37497,
                                51.71748
                            ],
                            [
                                -4.24403,
                                51.64713
                            ],
                            [
                                -4.3063,
                                51.61073
                            ],
                            [
                                -4.23867,
                                51.54292
                            ],
                            [
                                -4.13231,
                                51.56911
                            ],
                            [
                                -3.99203,
                                51.56361
                            ],
                            [
                                -3.96142,
                                51.61168
                            ],
                            [
                                -3.85006,
                                51.61891
                            ],
                            [
                                -3.74684,
                                51.50481
                            ],
                            [
                                -3.66665,
                                51.48067
                            ],
                            [
                                -3.55752,
                                51.40124
                            ],
                            [
                                -3.40457,
                                51.38181
                            ],
                            [
                                -3.17152,
                                51.40601
                            ],
                            [
                                -3.12267,
                                51.49044
                            ],
                            [
                                -2.99939,
                                51.53383
                            ],
                            [
                                -2.90577,
                                51.53255
                            ],
                            [
                                -2.75848,
                                51.57801
                            ],
                            [
                                -2.66388,
                                51.57316
                            ],
                            [
                                -2.7202,
                                51.50135
                            ],
                            [
                                -2.8003,
                                51.48497
                            ],
                            [
                                -3.01202,
                                51.31603
                            ],
                            [
                                -3.00384,
                                51.22239
                            ],
                            [
                                -3.27768,
                                51.17955
                            ],
                            [
                                -3.40526,
                                51.18267
                            ],
                            [
                                -3.53698,
                                51.23128
                            ],
                            [
                                -3.769,
                                51.23765
                            ],
                            [
                                -4.08574,
                                51.21688
                            ],
                            [
                                -4.21539,
                                51.18215
                            ],
                            [
                                -4.21618,
                                51.07626
                            ],
                            [
                                -4.30482,
                                50.99683
                            ],
                            [
                                -4.374,
                                50.99017
                            ],
                            [
                                -4.5238,
                                51.0212
                            ],
                            [
                                -4.56104,
                                50.91702
                            ],
                            [
                                -4.57701,
                                50.77214
                            ],
                            [
                                -4.68211,
                                50.69565
                            ],
                            [
                                -4.76336,
                                50.66973
                            ],
                            [
                                -4.79826,
                                50.59813
                            ],
                            [
                                -5.02524,
                                50.55081
                            ],
                            [
                                -5.04046,
                                50.44929
                            ],
                            [
                                -5.13512,
                                50.40815
                            ],
                            [
                                -5.15503,
                                50.34876
                            ],
                            [
                                -5.24545,
                                50.2859
                            ],
                            [
                                -5.43288,
                                50.19386
                            ],
                            [
                                -5.53872,
                                50.21608
                            ],
                            [
                                -5.70905,
                                50.12766
                            ],
                            [
                                -5.68082,
                                50.03577
                            ],
                            [
                                -5.55171,
                                50.06136
                            ],
                            [
                                -5.52405,
                                50.12614
                            ],
                            [
                                -5.33368,
                                50.09071
                            ],
                            [
                                -5.27889,
                                50.05518
                            ],
                            [
                                -5.21445,
                                49.96043
                            ],
                            [
                                -5.05839,
                                50.05285
                            ],
                            [
                                -5.09222,
                                50.12605
                            ],
                            [
                                -4.95557,
                                50.20193
                            ],
                            [
                                -4.79746,
                                50.22991
                            ],
                            [
                                -4.75358,
                                50.33129
                            ],
                            [
                                -4.68373,
                                50.31989
                            ],
                            [
                                -4.47567,
                                50.3337
                            ],
                            [
                                -4.43714,
                                50.36044
                            ],
                            [
                                -4.30761,
                                50.36113
                            ],
                            [
                                -4.22063,
                                50.32596
                            ],
                            [
                                -4.04757,
                                50.2943
                            ],
                            [
                                -3.94747,
                                50.30464
                            ],
                            [
                                -3.86647,
                                50.23952
                            ],
                            [
                                -3.72034,
                                50.20306
                            ],
                            [
                                -3.65826,
                                50.23789
                            ],
                            [
                                -3.61011,
                                50.31894
                            ],
                            [
                                -3.5219,
                                50.34502
                            ],
                            [
                                -3.55501,
                                50.40777
                            ],
                            [
                                -3.49662,
                                50.54225
                            ],
                            [
                                -3.44498,
                                50.59199
                            ],
                            [
                                -3.29471,
                                50.63617
                            ],
                            [
                                -3.26174,
                                50.67177
                            ],
                            [
                                -3.09762,
                                50.68539
                            ],
                            [
                                -2.89445,
                                50.73275
                            ],
                            [
                                -2.77681,
                                50.71408
                            ],
                            [
                                -2.47014,
                                50.58435
                            ],
                            [
                                -2.42523,
                                50.63522
                            ],
                            [
                                -2.10741,
                                50.59688
                            ],
                            [
                                -1.9608,
                                50.59124
                            ],
                            [
                                -1.93336,
                                50.63176
                            ],
                            [
                                -2.02839,
                                50.68081
                            ],
                            [
                                -1.72199,
                                50.73439
                            ],
                            [
                                -1.57762,
                                50.71657
                            ],
                            [
                                -1.52908,
                                50.75456
                            ],
                            [
                                -1.34099,
                                50.78756
                            ],
                            [
                                -1.29732,
                                50.83597
                            ],
                            [
                                -1.14316,
                                50.77423
                            ],
                            [
                                -1.03842,
                                50.78549
                            ],
                            [
                                -1.04406,
                                50.83184
                            ],
                            [
                                -0.93283,
                                50.84315
                            ],
                            [
                                -0.91416,
                                50.7797
                            ],
                            [
                                -0.78577,
                                50.72318
                            ],
                            [
                                -0.72856,
                                50.77129
                            ],
                            [
                                -0.53813,
                                50.80231
                            ],
                            [
                                -0.21601,
                                50.82756
                            ],
                            [
                                0.07681,
                                50.77959
                            ],
                            [
                                0.25773,
                                50.73786
                            ],
                            [
                                0.36343,
                                50.81606
                            ],
                            [
                                0.66958,
                                50.87348
                            ],
                            [
                                0.79603,
                                50.93237
                            ],
                            [
                                0.92987,
                                50.91309
                            ],
                            [
                                0.98356,
                                51.0122
                            ],
                            [
                                1.07562,
                                51.06346
                            ],
                            [
                                1.18841,
                                51.0774
                            ],
                            [
                                1.37734,
                                51.14116
                            ],
                            [
                                1.40497,
                                51.22982
                            ],
                            [
                                1.3647,
                                51.32277
                            ],
                            [
                                1.42512,
                                51.39327
                            ],
                            [
                                1.02555,
                                51.36387
                            ],
                            [
                                0.89826,
                                51.34156
                            ],
                            [
                                0.59153,
                                51.39023
                            ],
                            [
                                0.63247,
                                51.44434
                            ],
                            [
                                0.58761,
                                51.48391
                            ],
                            [
                                0.65233,
                                51.53912
                            ],
                            [
                                0.78888,
                                51.52275
                            ],
                            [
                                0.95317,
                                51.61215
                            ],
                            [
                                0.94985,
                                51.72227
                            ],
                            [
                                0.91304,
                                51.77456
                            ],
                            [
                                1.03339,
                                51.801
                            ],
                            [
                                1.13348,
                                51.77754
                            ],
                            [
                                1.23887,
                                51.8212
                            ],
                            [
                                1.28135,
                                51.93484
                            ],
                            [
                                1.36955,
                                51.96468
                            ],
                            [
                                1.46122,
                                52.04672
                            ],
                            [
                                1.57517,
                                52.08595
                            ],
                            [
                                1.621,
                                52.18467
                            ],
                            [
                                1.63046,
                                52.26845
                            ],
                            [
                                1.72491,
                                52.39324
                            ],
                            [
                                1.76258,
                                52.48141
                            ],
                            [
                                1.74396,
                                52.62939
                            ],
                            [
                                1.69945,
                                52.71919
                            ],
                            [
                                1.61505,
                                52.78424
                            ],
                            [
                                1.41398,
                                52.8907
                            ],
                            [
                                1.3011,
                                52.93277
                            ],
                            [
                                1.04003,
                                52.96803
                            ],
                            [
                                0.87076,
                                52.97876
                            ],
                            [
                                0.54005,
                                52.97532
                            ],
                            [
                                0.49018,
                                52.94791
                            ],
                            [
                                0.44484,
                                52.84505
                            ],
                            [
                                0.36848,
                                52.80155
                            ],
                            [
                                0.22277,
                                52.81765
                            ],
                            [
                                0.17501,
                                52.8728
                            ],
                            [
                                0.04043,
                                52.90308
                            ],
                            [
                                0.17006,
                                53.01968
                            ],
                            [
                                0.34278,
                                53.1036
                            ],
                            [
                                0.33727,
                                53.24036
                            ],
                            [
                                0.17353,
                                53.46939
                            ],
                            [
                                0.03847,
                                53.51443
                            ],
                            [
                                -0.06118,
                                53.58203
                            ],
                            [
                                -0.20392,
                                53.63808
                            ],
                            [
                                -0.29956,
                                53.71433
                            ],
                            [
                                -0.27641,
                                53.74061
                            ],
                            [
                                -0.10216,
                                53.63555
                            ],
                            [
                                0.11139,
                                53.66765
                            ],
                            [
                                -0.1535,
                                53.90077
                            ],
                            [
                                -0.20824,
                                53.99762
                            ],
                            [
                                -0.20928,
                                54.06399
                            ],
                            [
                                -0.09909,
                                54.1298
                            ],
                            [
                                -0.23276,
                                54.16186
                            ],
                            [
                                -0.27209,
                                54.2179
                            ],
                            [
                                -0.36356,
                                54.24531
                            ],
                            [
                                -0.47195,
                                54.3969
                            ],
                            [
                                -0.59324,
                                54.48788
                            ],
                            [
                                -0.7762,
                                54.55677
                            ],
                            [
                                -0.89814,
                                54.57199
                            ],
                            [
                                -1.13933,
                                54.62961
                            ],
                            [
                                -1.30878,
                                54.78119
                            ],
                            [
                                -1.36783,
                                54.93475
                            ],
                            [
                                -1.35391,
                                54.95728
                            ],
                            [
                                -1.4945,
                                55.10247
                            ],
                            [
                                -1.50102,
                                55.18604
                            ],
                            [
                                -1.57085,
                                55.27555
                            ],
                            [
                                -1.54973,
                                55.32152
                            ],
                            [
                                -1.62346,
                                55.5518
                            ],
                            [
                                -1.69315,
                                55.60651
                            ],
                            [
                                -1.8112,
                                55.63405
                            ],
                            [
                                -1.95936,
                                55.73272
                            ],
                            [
                                -2.07795,
                                55.87413
                            ],
                            [
                                -2.21128,
                                55.9313
                            ],
                            [
                                -2.33027,
                                55.93062
                            ],
                            [
                                -2.44642,
                                55.98708
                            ],
                            [
                                -2.54898,
                                55.99911
                            ],
                            [
                                -2.62826,
                                56.05161
                            ],
                            [
                                -2.8146,
                                56.06238
                            ],
                            [
                                -2.89751,
                                55.98407
                            ],
                            [
                                -3.06504,
                                55.94591
                            ],
                            [
                                -3.17795,
                                55.98906
                            ],
                            [
                                -3.29052,
                                55.97939
                            ],
                            [
                                -3.38825,
                                56.01211
                            ],
                            [
                                -3.28341,
                                56.05612
                            ],
                            [
                                -3.17506,
                                56.0631
                            ],
                            [
                                -3.15429,
                                56.11221
                            ],
                            [
                                -2.95495,
                                56.21049
                            ],
                            [
                                -2.81102,
                                56.18435
                            ],
                            [
                                -2.5879,
                                56.27817
                            ],
                            [
                                -2.68847,
                                56.3256
                            ],
                            [
                                -2.8528,
                                56.36946
                            ],
                            [
                                -2.71526,
                                56.49483
                            ],
                            [
                                -2.53951,
                                56.56661
                            ],
                            [
                                -2.48218,
                                56.62255
                            ],
                            [
                                -2.42535,
                                56.75519
                            ],
                            [
                                -2.31646,
                                56.80169
                            ],
                            [
                                -2.19672,
                                56.91031
                            ],
                            [
                                -2.15901,
                                57.01829
                            ],
                            [
                                -2.05078,
                                57.12867
                            ],
                            [
                                -2.07745,
                                57.17698
                            ],
                            [
                                -1.99443,
                                57.3123
                            ],
                            [
                                -1.85983,
                                57.39013
                            ],
                            [
                                -1.77754,
                                57.4748
                            ],
                            [
                                -1.82813,
                                57.6152
                            ],
                            [
                                -1.91899,
                                57.67324
                            ],
                            [
                                -2.07951,
                                57.7003
                            ],
                            [
                                -2.1904,
                                57.67202
                            ],
                            [
                                -2.74124,
                                57.68228
                            ],
                            [
                                -2.84688,
                                57.70496
                            ],
                            [
                                -3.02716,
                                57.6639
                            ],
                            [
                                -3.34527,
                                57.72461
                            ],
                            [
                                -3.48251,
                                57.70254
                            ],
                            [
                                -3.53026,
                                57.66436
                            ],
                            [
                                -3.69155,
                                57.65877
                            ],
                            [
                                -3.82123,
                                57.60245
                            ],
                            [
                                -4.01139,
                                57.60023
                            ],
                            [
                                -4.16852,
                                57.48939
                            ],
                            [
                                -4.17213,
                                57.56513
                            ],
                            [
                                -3.99716,
                                57.67676
                            ],
                            [
                                -3.79538,
                                57.83582
                            ],
                            [
                                -3.89483,
                                57.82434
                            ],
                            [
                                -4.01333,
                                57.86117
                            ],
                            [
                                -3.9813,
                                57.96991
                            ],
                            [
                                -3.89256,
                                57.98846
                            ],
                            [
                                -3.74573,
                                58.06919
                            ],
                            [
                                -3.50879,
                                58.17201
                            ],
                            [
                                -3.36278,
                                58.27633
                            ],
                            [
                                -3.21122,
                                58.31016
                            ],
                            [
                                -3.1109,
                                58.37108
                            ],
                            [
                                -3.05059,
                                58.45192
                            ],
                            [
                                -3.13314,
                                58.50357
                            ],
                            [
                                -3.03588,
                                58.60941
                            ],
                            [
                                -3.15905,
                                58.63824
                            ],
                            [
                                -3.4075,
                                58.65773
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -6.26802,
                                54.10234
                            ],
                            [
                                -6.19306,
                                54.09466
                            ],
                            [
                                -6.06188,
                                54.0241
                            ],
                            [
                                -5.90277,
                                54.10021
                            ],
                            [
                                -5.83217,
                                54.24007
                            ],
                            [
                                -5.61398,
                                54.24778
                            ],
                            [
                                -5.53823,
                                54.31183
                            ],
                            [
                                -5.54998,
                                54.36532
                            ],
                            [
                                -5.64978,
                                54.38977
                            ],
                            [
                                -5.63984,
                                54.44271
                            ],
                            [
                                -5.67965,
                                54.58319
                            ],
                            [
                                -5.56116,
                                54.53248
                            ],
                            [
                                -5.53532,
                                54.43983
                            ],
                            [
                                -5.57889,
                                54.40288
                            ],
                            [
                                -5.50444,
                                54.33184
                            ],
                            [
                                -5.43803,
                                54.45652
                            ],
                            [
                                -5.48952,
                                54.57692
                            ],
                            [
                                -5.57679,
                                54.67476
                            ],
                            [
                                -5.74062,
                                54.67694
                            ],
                            [
                                -5.83974,
                                54.70494
                            ],
                            [
                                -5.68956,
                                54.76721
                            ],
                            [
                                -5.72468,
                                54.84726
                            ],
                            [
                                -5.78902,
                                54.84474
                            ],
                            [
                                -5.91849,
                                54.96206
                            ],
                            [
                                -5.99132,
                                54.98791
                            ],
                            [
                                -6.04206,
                                55.05389
                            ],
                            [
                                -6.02672,
                                55.15937
                            ],
                            [
                                -6.13572,
                                55.22453
                            ],
                            [
                                -6.23812,
                                55.20492
                            ],
                            [
                                -6.2947,
                                55.23086
                            ],
                            [
                                -6.50244,
                                55.2469
                            ],
                            [
                                -6.73038,
                                55.17142
                            ],
                            [
                                -6.91491,
                                55.17544
                            ],
                            [
                                -7.05978,
                                55.04789
                            ],
                            [
                                -7.25607,
                                55.06703
                            ],
                            [
                                -7.344,
                                55.05054
                            ],
                            [
                                -7.44501,
                                54.93701
                            ],
                            [
                                -7.4423,
                                54.87416
                            ],
                            [
                                -7.54889,
                                54.78959
                            ],
                            [
                                -7.74717,
                                54.70452
                            ],
                            [
                                -7.85552,
                                54.72603
                            ],
                            [
                                -7.89245,
                                54.65663
                            ],
                            [
                                -7.7522,
                                54.61868
                            ],
                            [
                                -7.85749,
                                54.53632
                            ],
                            [
                                -8.006,
                                54.54595
                            ],
                            [
                                -8.04336,
                                54.48838
                            ],
                            [
                                -8.15599,
                                54.43795
                            ],
                            [
                                -7.94658,
                                54.30429
                            ],
                            [
                                -7.88697,
                                54.29935
                            ],
                            [
                                -7.85953,
                                54.21745
                            ],
                            [
                                -7.69328,
                                54.20501
                            ],
                            [
                                -7.56591,
                                54.12717
                            ],
                            [
                                -7.44366,
                                54.15276
                            ],
                            [
                                -7.33645,
                                54.11685
                            ],
                            [
                                -7.24898,
                                54.20341
                            ],
                            [
                                -7.14582,
                                54.22494
                            ],
                            [
                                -7.15384,
                                54.33527
                            ],
                            [
                                -7.02864,
                                54.42131
                            ],
                            [
                                -6.87662,
                                54.34616
                            ],
                            [
                                -6.81539,
                                54.22329
                            ],
                            [
                                -6.63175,
                                54.14802
                            ],
                            [
                                -6.66091,
                                54.06293
                            ],
                            [
                                -6.62378,
                                54.03655
                            ],
                            [
                                -6.456,
                                54.07162
                            ],
                            [
                                -6.36625,
                                54.1122
                            ],
                            [
                                -6.26802,
                                54.10234
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -6.21134,
                                58.36273
                            ],
                            [
                                -6.18501,
                                58.46866
                            ],
                            [
                                -6.3013,
                                58.482
                            ],
                            [
                                -6.52046,
                                58.39594
                            ],
                            [
                                -6.54783,
                                58.36624
                            ],
                            [
                                -6.80009,
                                58.30466
                            ],
                            [
                                -6.74622,
                                58.21195
                            ],
                            [
                                -6.86502,
                                58.18482
                            ],
                            [
                                -6.95838,
                                58.23374
                            ],
                            [
                                -7.04942,
                                58.22978
                            ],
                            [
                                -7.13346,
                                58.12684
                            ],
                            [
                                -7.04181,
                                58.02516
                            ],
                            [
                                -7.0783,
                                57.96848
                            ],
                            [
                                -6.91306,
                                57.94302
                            ],
                            [
                                -6.95307,
                                57.87263
                            ],
                            [
                                -7.0848,
                                57.8059
                            ],
                            [
                                -6.97475,
                                57.73134
                            ],
                            [
                                -6.83931,
                                57.81454
                            ],
                            [
                                -6.74343,
                                57.84181
                            ],
                            [
                                -6.68069,
                                57.92876
                            ],
                            [
                                -6.57533,
                                57.91303
                            ],
                            [
                                -6.47165,
                                57.94052
                            ],
                            [
                                -6.45601,
                                57.99106
                            ],
                            [
                                -6.35941,
                                58.03451
                            ],
                            [
                                -6.38046,
                                58.08901
                            ],
                            [
                                -6.34197,
                                58.23778
                            ],
                            [
                                -6.19306,
                                58.33961
                            ],
                            [
                                -6.21134,
                                58.36273
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -6.35029,
                                57.70414
                            ],
                            [
                                -6.42168,
                                57.64331
                            ],
                            [
                                -6.38517,
                                57.51934
                            ],
                            [
                                -6.46231,
                                57.50296
                            ],
                            [
                                -6.56136,
                                57.54881
                            ],
                            [
                                -6.6525,
                                57.55299
                            ],
                            [
                                -6.7829,
                                57.45268
                            ],
                            [
                                -6.71975,
                                57.37405
                            ],
                            [
                                -6.47791,
                                57.29333
                            ],
                            [
                                -6.29721,
                                57.16234
                            ],
                            [
                                -6.11462,
                                57.18745
                            ],
                            [
                                -6.03502,
                                57.05516
                            ],
                            [
                                -5.90402,
                                57.0571
                            ],
                            [
                                -5.7982,
                                57.16089
                            ],
                            [
                                -5.67542,
                                57.20599
                            ],
                            [
                                -5.74413,
                                57.27435
                            ],
                            [
                                -5.9059,
                                57.24307
                            ],
                            [
                                -6.10448,
                                57.32263
                            ],
                            [
                                -6.14098,
                                57.36907
                            ],
                            [
                                -6.13954,
                                57.54423
                            ],
                            [
                                -6.18894,
                                57.63111
                            ],
                            [
                                -6.35029,
                                57.70414
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -1.34617,
                                60.62095
                            ],
                            [
                                -1.55197,
                                60.48699
                            ],
                            [
                                -1.44933,
                                60.46594
                            ],
                            [
                                -1.33544,
                                60.33819
                            ],
                            [
                                -1.46313,
                                60.30071
                            ],
                            [
                                -1.69099,
                                60.29762
                            ],
                            [
                                -1.68527,
                                60.23594
                            ],
                            [
                                -1.56511,
                                60.22267
                            ],
                            [
                                -1.50511,
                                60.1659
                            ],
                            [
                                -1.3042,
                                60.21759
                            ],
                            [
                                -1.27476,
                                60.11048
                            ],
                            [
                                -1.3455,
                                59.99739
                            ],
                            [
                                -1.27196,
                                59.92195
                            ],
                            [
                                -1.22079,
                                60.09977
                            ],
                            [
                                -1.15263,
                                60.18521
                            ],
                            [
                                -1.19323,
                                60.23095
                            ],
                            [
                                -1.08413,
                                60.32304
                            ],
                            [
                                -1.22856,
                                60.49191
                            ],
                            [
                                -1.29869,
                                60.46535
                            ],
                            [
                                -1.34617,
                                60.62095
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -6.11982,
                                56.65305
                            ],
                            [
                                -6.32164,
                                56.60422
                            ],
                            [
                                -6.30745,
                                56.56011
                            ],
                            [
                                -6.15155,
                                56.50074
                            ],
                            [
                                -6.12665,
                                56.44863
                            ],
                            [
                                -6.20276,
                                56.3869
                            ],
                            [
                                -6.18919,
                                56.33328
                            ],
                            [
                                -6.34799,
                                56.34673
                            ],
                            [
                                -6.38284,
                                56.28965
                            ],
                            [
                                -6.04516,
                                56.29334
                            ],
                            [
                                -5.9867,
                                56.32159
                            ],
                            [
                                -5.84252,
                                56.31101
                            ],
                            [
                                -5.66696,
                                56.39209
                            ],
                            [
                                -5.64633,
                                56.44611
                            ],
                            [
                                -5.79881,
                                56.51473
                            ],
                            [
                                -5.95272,
                                56.52123
                            ],
                            [
                                -5.9886,
                                56.57703
                            ],
                            [
                                -6.11982,
                                56.65305
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -4.4673,
                                53.41627
                            ],
                            [
                                -4.55591,
                                53.37403
                            ],
                            [
                                -4.58858,
                                53.30233
                            ],
                            [
                                -4.55354,
                                53.24825
                            ],
                            [
                                -4.40668,
                                53.14512
                            ],
                            [
                                -4.3584,
                                53.13186
                            ],
                            [
                                -4.21933,
                                53.18619
                            ],
                            [
                                -4.20281,
                                53.21423
                            ],
                            [
                                -4.1032,
                                53.25503
                            ],
                            [
                                -4.20263,
                                53.29562
                            ],
                            [
                                -4.296,
                                53.4133
                            ],
                            [
                                -4.4673,
                                53.41627
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -6.10444,
                                55.83125
                            ],
                            [
                                -6.19698,
                                55.92547
                            ],
                            [
                                -6.45418,
                                55.85237
                            ],
                            [
                                -6.48417,
                                55.67268
                            ],
                            [
                                -6.33076,
                                55.74226
                            ],
                            [
                                -6.27041,
                                55.68302
                            ],
                            [
                                -6.3375,
                                55.59136
                            ],
                            [
                                -6.07321,
                                55.64978
                            ],
                            [
                                -6.02263,
                                55.68306
                            ],
                            [
                                -6.10444,
                                55.83125
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -3.19952,
                                59.15303
                            ],
                            [
                                -3.3214,
                                59.13472
                            ],
                            [
                                -3.35397,
                                58.96511
                            ],
                            [
                                -3.23042,
                                58.96635
                            ],
                            [
                                -3.20507,
                                58.91443
                            ],
                            [
                                -2.97195,
                                58.94031
                            ],
                            [
                                -2.93111,
                                58.89247
                            ],
                            [
                                -2.82011,
                                58.8876
                            ],
                            [
                                -2.84736,
                                58.95748
                            ],
                            [
                                -3.03904,
                                59.00949
                            ],
                            [
                                -3.01089,
                                59.07773
                            ],
                            [
                                -3.19952,
                                59.15303
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -5.2848,
                                55.71929
                            ],
                            [
                                -5.36174,
                                55.67976
                            ],
                            [
                                -5.39549,
                                55.61204
                            ],
                            [
                                -5.35479,
                                55.50723
                            ],
                            [
                                -5.24816,
                                55.43893
                            ],
                            [
                                -5.08425,
                                55.45424
                            ],
                            [
                                -5.08303,
                                55.55215
                            ],
                            [
                                -5.16853,
                                55.68374
                            ],
                            [
                                -5.2848,
                                55.71929
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -5.73377,
                                56.14079
                            ],
                            [
                                -5.95058,
                                56.03685
                            ],
                            [
                                -6.0929,
                                55.8906
                            ],
                            [
                                -6.08085,
                                55.82111
                            ],
                            [
                                -5.96625,
                                55.79332
                            ],
                            [
                                -5.9353,
                                55.86723
                            ],
                            [
                                -5.68977,
                                56.11038
                            ],
                            [
                                -5.73377,
                                56.14079
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -1.29006,
                                50.73848
                            ],
                            [
                                -1.52082,
                                50.70717
                            ],
                            [
                                -1.48698,
                                50.66684
                            ],
                            [
                                -1.29482,
                                50.57517
                            ],
                            [
                                -1.18444,
                                50.59786
                            ],
                            [
                                -1.16787,
                                50.64173
                            ],
                            [
                                -1.07026,
                                50.68433
                            ],
                            [
                                -1.10956,
                                50.72149
                            ],
                            [
                                -1.29006,
                                50.73848
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -7.39612,
                                57.39898
                            ],
                            [
                                -7.42374,
                                57.19042
                            ],
                            [
                                -7.39046,
                                57.11457
                            ],
                            [
                                -7.23093,
                                57.09611
                            ],
                            [
                                -7.26191,
                                57.20619
                            ],
                            [
                                -7.20348,
                                57.28267
                            ],
                            [
                                -7.24229,
                                57.35141
                            ],
                            [
                                -7.39612,
                                57.39898
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -7.17968,
                                57.65624
                            ],
                            [
                                -7.48152,
                                57.66115
                            ],
                            [
                                -7.52213,
                                57.6074
                            ],
                            [
                                -7.35198,
                                57.55373
                            ],
                            [
                                -7.32369,
                                57.51243
                            ],
                            [
                                -7.14857,
                                57.51186
                            ],
                            [
                                -7.10224,
                                57.61054
                            ],
                            [
                                -7.17968,
                                57.65624
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -1.07608,
                                60.73073
                            ],
                            [
                                -1.2013,
                                60.60616
                            ],
                            [
                                -1.17085,
                                60.50529
                            ],
                            [
                                -1.03616,
                                60.50194
                            ],
                            [
                                -0.99034,
                                60.65635
                            ],
                            [
                                -1.07608,
                                60.73073
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -3.36773,
                                58.9285
                            ],
                            [
                                -3.41658,
                                58.91075
                            ],
                            [
                                -3.29152,
                                58.77688
                            ],
                            [
                                -3.20277,
                                58.82676
                            ],
                            [
                                -3.21315,
                                58.87813
                            ],
                            [
                                -3.36773,
                                58.9285
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -0.87629,
                                60.8093
                            ],
                            [
                                -0.93457,
                                60.77984
                            ],
                            [
                                -0.98046,
                                60.6857
                            ],
                            [
                                -0.86765,
                                60.70316
                            ],
                            [
                                -0.78264,
                                60.7817
                            ],
                            [
                                -0.87629,
                                60.8093
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -6.3375,
                                57.05933
                            ],
                            [
                                -6.45878,
                                57.00754
                            ],
                            [
                                -6.36905,
                                56.95275
                            ],
                            [
                                -6.25412,
                                56.97028
                            ],
                            [
                                -6.25977,
                                57.03709
                            ],
                            [
                                -6.3375,
                                57.05933
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -7.36545,
                                57.49049
                            ],
                            [
                                -7.38962,
                                57.42444
                            ],
                            [
                                -7.24047,
                                57.4031
                            ],
                            [
                                -7.2337,
                                57.4599
                            ],
                            [
                                -7.36545,
                                57.49049
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -6.76011,
                                56.54785
                            ],
                            [
                                -6.94874,
                                56.52884
                            ],
                            [
                                -6.97166,
                                56.46746
                            ],
                            [
                                -6.81451,
                                56.48919
                            ],
                            [
                                -6.76011,
                                56.54785
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                0.91349,
                                51.40529
                            ],
                            [
                                0.74802,
                                51.43575
                            ],
                            [
                                0.78859,
                                51.37298
                            ],
                            [
                                0.90651,
                                51.35569
                            ],
                            [
                                0.91349,
                                51.40529
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -58.58074,
                                -51.33443
                            ],
                            [
                                -58.73798,
                                -51.32229
                            ],
                            [
                                -58.89693,
                                -51.27781
                            ],
                            [
                                -58.88504,
                                -51.38249
                            ],
                            [
                                -58.99926,
                                -51.3862
                            ],
                            [
                                -59.16296,
                                -51.59376
                            ],
                            [
                                -59.02002,
                                -51.67118
                            ],
                            [
                                -59.23124,
                                -51.72439
                            ],
                            [
                                -59.37477,
                                -51.84327
                            ],
                            [
                                -59.49762,
                                -51.83684
                            ],
                            [
                                -59.60713,
                                -51.91827
                            ],
                            [
                                -59.63484,
                                -52.00664
                            ],
                            [
                                -59.60821,
                                -52.12076
                            ],
                            [
                                -59.67834,
                                -52.12323
                            ],
                            [
                                -59.62846,
                                -52.20835
                            ],
                            [
                                -59.56532,
                                -52.2162
                            ],
                            [
                                -59.38523,
                                -52.31719
                            ],
                            [
                                -59.34539,
                                -52.2409
                            ],
                            [
                                -59.43419,
                                -52.21572
                            ],
                            [
                                -59.46724,
                                -52.16236
                            ],
                            [
                                -59.34784,
                                -52.15774
                            ],
                            [
                                -59.24618,
                                -52.20261
                            ],
                            [
                                -59.0705,
                                -52.23525
                            ],
                            [
                                -59.03012,
                                -52.14642
                            ],
                            [
                                -59.11727,
                                -52.12246
                            ],
                            [
                                -59.19044,
                                -52.0653
                            ],
                            [
                                -59.10081,
                                -52.02657
                            ],
                            [
                                -59.02053,
                                -52.02668
                            ],
                            [
                                -58.9867,
                                -52.08496
                            ],
                            [
                                -58.86793,
                                -52.04629
                            ],
                            [
                                -58.66356,
                                -52.02653
                            ],
                            [
                                -58.63167,
                                -51.96792
                            ],
                            [
                                -58.88967,
                                -51.9009
                            ],
                            [
                                -58.66941,
                                -51.90259
                            ],
                            [
                                -58.51233,
                                -51.88585
                            ],
                            [
                                -58.46461,
                                -51.9016
                            ],
                            [
                                -58.31892,
                                -51.87925
                            ],
                            [
                                -58.18186,
                                -51.7579
                            ],
                            [
                                -57.98148,
                                -51.75519
                            ],
                            [
                                -57.74721,
                                -51.68107
                            ],
                            [
                                -57.7851,
                                -51.61826
                            ],
                            [
                                -58.05039,
                                -51.59117
                            ],
                            [
                                -58.14817,
                                -51.5535
                            ],
                            [
                                -57.99794,
                                -51.50829
                            ],
                            [
                                -57.95406,
                                -51.53836
                            ],
                            [
                                -57.77296,
                                -51.54038
                            ],
                            [
                                -57.85778,
                                -51.41355
                            ],
                            [
                                -57.94547,
                                -51.36502
                            ],
                            [
                                -58.27382,
                                -51.39239
                            ],
                            [
                                -58.38624,
                                -51.53746
                            ],
                            [
                                -58.45669,
                                -51.44947
                            ],
                            [
                                -58.31814,
                                -51.41656
                            ],
                            [
                                -58.41076,
                                -51.31935
                            ],
                            [
                                -58.57212,
                                -51.30031
                            ],
                            [
                                -58.58074,
                                -51.33443
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -59.6793,
                                -51.78326
                            ],
                            [
                                -59.48172,
                                -51.61636
                            ],
                            [
                                -59.3937,
                                -51.60467
                            ],
                            [
                                -59.28666,
                                -51.43326
                            ],
                            [
                                -59.20698,
                                -51.40316
                            ],
                            [
                                -59.38839,
                                -51.33933
                            ],
                            [
                                -59.46275,
                                -51.46157
                            ],
                            [
                                -59.57185,
                                -51.43217
                            ],
                            [
                                -59.79754,
                                -51.45827
                            ],
                            [
                                -59.89244,
                                -51.3969
                            ],
                            [
                                -60.04163,
                                -51.38676
                            ],
                            [
                                -60.13279,
                                -51.50288
                            ],
                            [
                                -60.22656,
                                -51.49627
                            ],
                            [
                                -60.36057,
                                -51.45218
                            ],
                            [
                                -60.53663,
                                -51.37093
                            ],
                            [
                                -60.59606,
                                -51.4389
                            ],
                            [
                                -60.45534,
                                -51.4396
                            ],
                            [
                                -60.50803,
                                -51.5275
                            ],
                            [
                                -60.27202,
                                -51.6087
                            ],
                            [
                                -60.24037,
                                -51.6594
                            ],
                            [
                                -60.50247,
                                -51.7081
                            ],
                            [
                                -60.66015,
                                -51.68445
                            ],
                            [
                                -60.59032,
                                -51.77092
                            ],
                            [
                                -60.45009,
                                -51.77083
                            ],
                            [
                                -60.3639,
                                -51.71392
                            ],
                            [
                                -60.1843,
                                -51.71146
                            ],
                            [
                                -60.21362,
                                -51.78398
                            ],
                            [
                                -60.36234,
                                -51.8126
                            ],
                            [
                                -60.45707,
                                -51.78763
                            ],
                            [
                                -60.45635,
                                -51.88016
                            ],
                            [
                                -60.50314,
                                -51.95124
                            ],
                            [
                                -60.58483,
                                -51.98618
                            ],
                            [
                                -60.83826,
                                -51.95719
                            ],
                            [
                                -60.84947,
                                -52.03957
                            ],
                            [
                                -60.96823,
                                -52.04453
                            ],
                            [
                                -60.93317,
                                -52.1132
                            ],
                            [
                                -60.72301,
                                -52.13264
                            ],
                            [
                                -60.62193,
                                -52.25574
                            ],
                            [
                                -60.49849,
                                -52.17068
                            ],
                            [
                                -60.33632,
                                -52.15212
                            ],
                            [
                                -60.26782,
                                -52.08722
                            ],
                            [
                                -60.28864,
                                -52.00755
                            ],
                            [
                                -60.16749,
                                -52.00536
                            ],
                            [
                                -60.01648,
                                -51.96474
                            ],
                            [
                                -59.99834,
                                -52.00402
                            ],
                            [
                                -59.86089,
                                -51.96236
                            ],
                            [
                                -59.83533,
                                -51.90069
                            ],
                            [
                                -59.74456,
                                -51.81246
                            ],
                            [
                                -59.6793,
                                -51.78326
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -61.16314,
                                -51.84427
                            ],
                            [
                                -61.13142,
                                -51.90202
                            ],
                            [
                                -61.0007,
                                -51.98717
                            ],
                            [
                                -60.88855,
                                -51.92265
                            ],
                            [
                                -60.88097,
                                -51.81407
                            ],
                            [
                                -61.03322,
                                -51.78466
                            ],
                            [
                                -61.05949,
                                -51.82362
                            ],
                            [
                                -61.16314,
                                -51.84427
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -60.32212,
                                -51.26552
                            ],
                            [
                                -60.12196,
                                -51.40162
                            ],
                            [
                                -60.04925,
                                -51.33401
                            ],
                            [
                                -60.08845,
                                -51.30411
                            ],
                            [
                                -60.23052,
                                -51.30722
                            ],
                            [
                                -60.32212,
                                -51.26552
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -59.83373,
                                -51.26457
                            ],
                            [
                                -59.58852,
                                -51.34158
                            ],
                            [
                                -59.48256,
                                -51.3319
                            ],
                            [
                                -59.47771,
                                -51.2835
                            ],
                            [
                                -59.83373,
                                -51.26457
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "URY",
                "Country": "Uruguay",
                "Total_3GHG": 0.14,
                "Total_3GHG_timeseries": [
                    3.164e-06,
                    6.5659e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023
                ],
                "Fossil_3GHG": 0.03,
                "Fossil_3GHG_timeseries": [
                    4.2261e-08,
                    8.8007e-08,
                    1.3729e-07,
                    1.9018e-07,
                    2.4673e-07,
                    3.0701e-07,
                    3.711e-07,
                    4.3906e-07,
                    5.1097e-07,
                    5.8688e-07,
                    6.6655e-07,
                    7.5004e-07,
                    8.3747e-07,
                    9.2892e-07,
                    1.0245e-06,
                    1.1243e-06,
                    1.2285e-06,
                    1.3372e-06,
                    1.4506e-06,
                    1.5686e-06,
                    1.6882e-06,
                    1.8093e-06,
                    1.9322e-06,
                    2.0566e-06,
                    2.1828e-06,
                    2.3107e-06,
                    2.4405e-06,
                    2.572e-06,
                    2.7052e-06,
                    2.8401e-06,
                    2.9805e-06,
                    3.1268e-06,
                    3.2788e-06,
                    3.4367e-06,
                    3.6003e-06,
                    3.7694e-06,
                    3.9441e-06,
                    4.1245e-06,
                    4.3105e-06,
                    4.5024e-06,
                    4.7e-06,
                    4.9037e-06,
                    5.1132e-06,
                    5.3288e-06,
                    5.5503e-06,
                    5.7775e-06,
                    6.0102e-06,
                    6.2488e-06,
                    6.4931e-06,
                    6.743e-06,
                    6.9898e-06,
                    7.2331e-06,
                    7.4729e-06,
                    7.7088e-06,
                    7.9408e-06,
                    8.1691e-06,
                    8.3939e-06,
                    8.6145e-06,
                    8.8312e-06,
                    9.0435e-06,
                    9.258e-06,
                    9.4744e-06,
                    9.6926e-06,
                    9.9143e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004
                ],
                "Land_3GHG": 0.34,
                "Land_3GHG_timeseries": [
                    3.1218e-06,
                    6.4778e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002
                ],
                "Total_CO2": 0.08,
                "Total_CO2_timeseries": [
                    2.236e-06,
                    4.6063e-06,
                    7.0897e-06,
                    9.6765e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009
                ],
                "Fossil_CO2": 0.02,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    3.4369e-08,
                    6.3828e-08,
                    8.6741e-08,
                    1.0965e-07,
                    1.342e-07,
                    1.6694e-07,
                    2.013e-07,
                    2.4058e-07,
                    2.7823e-07,
                    3.175e-07,
                    3.5024e-07,
                    3.797e-07,
                    4.2225e-07,
                    4.7135e-07,
                    5.352e-07,
                    6.0069e-07,
                    6.6617e-07,
                    7.3165e-07,
                    1.8366e-06,
                    3.0175e-06,
                    4.4376e-06,
                    6.0161e-06,
                    7.6985e-06,
                    9.4636e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Land_CO2": 0.2,
                "Land_CO2_timeseries": [
                    2.236e-06,
                    4.6063e-06,
                    7.0897e-06,
                    9.6765e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Total_CH4": 0.29,
                "Total_CH4_timeseries": [
                    8.8429e-07,
                    1.8712e-06,
                    2.9607e-06,
                    4.153e-06,
                    5.4481e-06,
                    6.8461e-06,
                    8.3469e-06,
                    9.9508e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012
                ],
                "Fossil_CH4": 0.07,
                "Fossil_CH4_timeseries": [
                    3.2717e-08,
                    6.8801e-08,
                    1.0831e-07,
                    1.5131e-07,
                    1.9786e-07,
                    2.4804e-07,
                    3.0193e-07,
                    3.596e-07,
                    4.2112e-07,
                    4.8657e-07,
                    5.5569e-07,
                    6.2857e-07,
                    7.053e-07,
                    7.8599e-07,
                    8.7072e-07,
                    9.5964e-07,
                    1.0529e-06,
                    1.1505e-06,
                    1.2527e-06,
                    1.3595e-06,
                    1.4678e-06,
                    1.5774e-06,
                    1.6885e-06,
                    1.8009e-06,
                    1.9148e-06,
                    2.0301e-06,
                    2.1471e-06,
                    2.2655e-06,
                    2.3854e-06,
                    2.5068e-06,
                    2.6337e-06,
                    2.7663e-06,
                    2.9046e-06,
                    3.0485e-06,
                    3.1981e-06,
                    3.3532e-06,
                    3.5137e-06,
                    3.6798e-06,
                    3.8514e-06,
                    4.0287e-06,
                    4.2115e-06,
                    4.4002e-06,
                    4.5946e-06,
                    4.7949e-06,
                    5.0009e-06,
                    5.2124e-06,
                    5.4293e-06,
                    5.6519e-06,
                    5.88e-06,
                    6.1135e-06,
                    6.3437e-06,
                    6.5701e-06,
                    6.7928e-06,
                    7.0114e-06,
                    7.2258e-06,
                    7.4362e-06,
                    7.6428e-06,
                    7.845e-06,
                    8.0429e-06,
                    8.2364e-06,
                    8.4316e-06,
                    8.6286e-06,
                    8.8272e-06,
                    9.0289e-06,
                    9.2302e-06,
                    9.4317e-06,
                    9.6331e-06,
                    9.8342e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002
                ],
                "Land_CH4": 0.67,
                "Land_CH4_timeseries": [
                    8.5157e-07,
                    1.8024e-06,
                    2.8524e-06,
                    4.0017e-06,
                    5.2503e-06,
                    6.598e-06,
                    8.045e-06,
                    9.5913e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001
                ],
                "Total_N2O": 0.28,
                "Total_N2O_timeseries": [
                    4.3798e-08,
                    8.8397e-08,
                    1.3377e-07,
                    1.7986e-07,
                    2.2663e-07,
                    2.74e-07,
                    3.219e-07,
                    3.7023e-07,
                    4.1889e-07,
                    4.6777e-07,
                    5.1679e-07,
                    5.6593e-07,
                    6.1518e-07,
                    6.6454e-07,
                    7.1399e-07,
                    7.6354e-07,
                    8.132e-07,
                    8.6296e-07,
                    9.1286e-07,
                    9.629e-07,
                    1.0137e-06,
                    1.0663e-06,
                    1.1216e-06,
                    1.1801e-06,
                    1.2421e-06,
                    1.3076e-06,
                    1.3767e-06,
                    1.4487e-06,
                    1.5231e-06,
                    1.5989e-06,
                    1.6757e-06,
                    1.7531e-06,
                    1.8312e-06,
                    1.9099e-06,
                    1.989e-06,
                    2.0686e-06,
                    2.1487e-06,
                    2.2293e-06,
                    2.3105e-06,
                    2.4259e-06,
                    2.5429e-06,
                    2.663e-06,
                    2.7878e-06,
                    2.9186e-06,
                    3.0564e-06,
                    3.2022e-06,
                    3.3569e-06,
                    3.5211e-06,
                    3.6953e-06,
                    3.8797e-06,
                    4.0785e-06,
                    4.2982e-06,
                    4.5437e-06,
                    4.818e-06,
                    5.1225e-06,
                    5.4566e-06,
                    5.8183e-06,
                    6.2034e-06,
                    6.6062e-06,
                    7.0193e-06,
                    7.438e-06,
                    7.8621e-06,
                    8.2912e-06,
                    8.7248e-06,
                    9.1626e-06,
                    9.604e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_N2O": 0.04,
                "Fossil_N2O_timeseries": [
                    9.5447e-09,
                    1.9206e-08,
                    2.8982e-08,
                    3.887e-08,
                    4.8866e-08,
                    5.8968e-08,
                    6.9169e-08,
                    7.9465e-08,
                    8.9849e-08,
                    1.0031e-07,
                    1.1086e-07,
                    1.2148e-07,
                    1.3217e-07,
                    1.4294e-07,
                    1.5378e-07,
                    1.647e-07,
                    1.7569e-07,
                    1.8676e-07,
                    1.979e-07,
                    2.0912e-07,
                    2.2046e-07,
                    2.3197e-07,
                    2.4371e-07,
                    2.5571e-07,
                    2.6799e-07,
                    2.8055e-07,
                    2.9338e-07,
                    3.0647e-07,
                    3.1976e-07,
                    3.3322e-07,
                    3.4679e-07,
                    3.6047e-07,
                    3.7426e-07,
                    3.8815e-07,
                    4.0214e-07,
                    4.1623e-07,
                    4.3041e-07,
                    4.447e-07,
                    4.5908e-07,
                    4.7374e-07,
                    4.8856e-07,
                    5.0352e-07,
                    5.1865e-07,
                    5.3394e-07,
                    5.4941e-07,
                    5.6505e-07,
                    5.8087e-07,
                    5.9689e-07,
                    6.1309e-07,
                    6.2949e-07,
                    6.4611e-07,
                    6.6296e-07,
                    6.8006e-07,
                    6.9741e-07,
                    7.1504e-07,
                    7.3293e-07,
                    7.511e-07,
                    7.6953e-07,
                    7.8823e-07,
                    8.0718e-07,
                    8.2637e-07,
                    8.458e-07,
                    8.6546e-07,
                    8.8537e-07,
                    9.0551e-07,
                    9.2588e-07,
                    9.4648e-07,
                    9.6732e-07,
                    9.8839e-07,
                    1.0097e-06,
                    1.0313e-06,
                    1.053e-06,
                    1.0751e-06,
                    1.0973e-06,
                    1.1198e-06,
                    1.1425e-06,
                    1.1655e-06,
                    1.1887e-06,
                    1.2122e-06,
                    1.2359e-06,
                    1.2599e-06,
                    1.2841e-06,
                    1.3085e-06,
                    1.3332e-06,
                    1.3581e-06,
                    1.3833e-06,
                    1.4088e-06,
                    1.4346e-06,
                    1.4607e-06,
                    1.4871e-06,
                    1.514e-06,
                    1.5415e-06,
                    1.5699e-06,
                    1.5992e-06,
                    1.6295e-06,
                    1.6609e-06,
                    1.6933e-06,
                    1.7268e-06,
                    1.7613e-06,
                    1.7967e-06,
                    1.8329e-06,
                    1.8702e-06,
                    1.9087e-06,
                    1.9484e-06,
                    1.9895e-06,
                    2.0321e-06,
                    2.076e-06,
                    2.1214e-06,
                    2.1682e-06,
                    2.2164e-06,
                    2.2659e-06,
                    2.3166e-06,
                    2.3686e-06,
                    2.422e-06,
                    2.4767e-06,
                    2.5329e-06,
                    2.5909e-06,
                    2.6509e-06,
                    2.7131e-06,
                    2.7794e-06,
                    2.8435e-06,
                    2.9096e-06,
                    2.9742e-06,
                    3.0393e-06,
                    3.1076e-06,
                    3.1752e-06,
                    3.2452e-06,
                    3.318e-06,
                    3.393e-06,
                    3.4757e-06,
                    3.5609e-06,
                    3.6408e-06,
                    3.7195e-06,
                    3.7946e-06,
                    3.8702e-06,
                    3.9458e-06,
                    4.024e-06,
                    4.1032e-06,
                    4.1835e-06,
                    4.2626e-06,
                    4.3478e-06,
                    4.4382e-06,
                    4.5302e-06,
                    4.624e-06,
                    4.7195e-06,
                    4.8219e-06,
                    4.9267e-06,
                    5.0366e-06,
                    5.1538e-06,
                    5.2517e-06,
                    5.3456e-06,
                    5.4352e-06,
                    5.5244e-06,
                    5.6188e-06,
                    5.7136e-06,
                    5.8106e-06,
                    5.9084e-06,
                    6.0336e-06,
                    6.1614e-06,
                    6.2939e-06,
                    6.4322e-06,
                    6.5746e-06,
                    6.7151e-06,
                    6.8607e-06,
                    7.0175e-06,
                    7.1791e-06,
                    7.3432e-06,
                    7.5052e-06,
                    7.6698e-06,
                    7.8405e-06,
                    8.0192e-06,
                    8.1996e-06
                ],
                "Land_N2O": 0.38,
                "Land_N2O_timeseries": [
                    3.4253e-08,
                    6.9191e-08,
                    1.0478e-07,
                    1.4099e-07,
                    1.7776e-07,
                    2.1503e-07,
                    2.5273e-07,
                    2.9076e-07,
                    3.2904e-07,
                    3.6745e-07,
                    4.0593e-07,
                    4.4445e-07,
                    4.8301e-07,
                    5.216e-07,
                    5.6021e-07,
                    5.9884e-07,
                    6.3751e-07,
                    6.7621e-07,
                    7.1496e-07,
                    7.5378e-07,
                    7.9325e-07,
                    8.3437e-07,
                    8.779e-07,
                    9.2437e-07,
                    9.7407e-07,
                    1.0271e-06,
                    1.0833e-06,
                    1.1422e-06,
                    1.2033e-06,
                    1.2657e-06,
                    1.3289e-06,
                    1.3927e-06,
                    1.457e-06,
                    1.5217e-06,
                    1.5869e-06,
                    1.6524e-06,
                    1.7183e-06,
                    1.7846e-06,
                    1.8514e-06,
                    1.9521e-06,
                    2.0543e-06,
                    2.1595e-06,
                    2.2692e-06,
                    2.3846e-06,
                    2.507e-06,
                    2.6372e-06,
                    2.776e-06,
                    2.9242e-06,
                    3.0822e-06,
                    3.2502e-06,
                    3.4324e-06,
                    3.6353e-06,
                    3.8636e-06,
                    4.1206e-06,
                    4.4074e-06,
                    4.7237e-06,
                    5.0672e-06,
                    5.4339e-06,
                    5.818e-06,
                    6.2121e-06,
                    6.6116e-06,
                    7.0163e-06,
                    7.4257e-06,
                    7.8395e-06,
                    8.2571e-06,
                    8.6781e-06,
                    9.102e-06,
                    9.5281e-06,
                    9.9559e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -53.37795,
                            -33.7504
                        ],
                        [
                            -53.43648,
                            -33.70067
                        ],
                        [
                            -53.52393,
                            -33.68767
                        ],
                        [
                            -53.50525,
                            -33.35647
                        ],
                        [
                            -53.5186,
                            -33.27321
                        ],
                        [
                            -53.50693,
                            -33.1475
                        ],
                        [
                            -53.43545,
                            -33.05528
                        ],
                        [
                            -53.25462,
                            -32.94594
                        ],
                        [
                            -53.27959,
                            -32.89892
                        ],
                        [
                            -53.18235,
                            -32.85067
                        ],
                        [
                            -53.15644,
                            -32.7991
                        ],
                        [
                            -53.07525,
                            -32.76487
                        ],
                        [
                            -53.08669,
                            -32.72712
                        ],
                        [
                            -53.24361,
                            -32.60606
                        ],
                        [
                            -53.28196,
                            -32.61675
                        ],
                        [
                            -53.41893,
                            -32.56339
                        ],
                        [
                            -53.45957,
                            -32.48003
                        ],
                        [
                            -53.54919,
                            -32.47145
                        ],
                        [
                            -53.6316,
                            -32.38565
                        ],
                        [
                            -53.63512,
                            -32.29614
                        ],
                        [
                            -53.66866,
                            -32.26378
                        ],
                        [
                            -53.74286,
                            -32.08218
                        ],
                        [
                            -53.82634,
                            -32.0577
                        ],
                        [
                            -53.86031,
                            -31.99537
                        ],
                        [
                            -53.94864,
                            -31.95692
                        ],
                        [
                            -53.967,
                            -31.91885
                        ],
                        [
                            -54.05591,
                            -31.89012
                        ],
                        [
                            -54.09506,
                            -31.90537
                        ],
                        [
                            -54.4566,
                            -31.6706
                        ],
                        [
                            -54.42671,
                            -31.63902
                        ],
                        [
                            -54.50516,
                            -31.51677
                        ],
                        [
                            -54.62149,
                            -31.46499
                        ],
                        [
                            -54.71904,
                            -31.4418
                        ],
                        [
                            -54.82826,
                            -31.44768
                        ],
                        [
                            -54.95265,
                            -31.36144
                        ],
                        [
                            -55.01509,
                            -31.28521
                        ],
                        [
                            -55.07395,
                            -31.32555
                        ],
                        [
                            -55.12978,
                            -31.31558
                        ],
                        [
                            -55.25133,
                            -31.24823
                        ],
                        [
                            -55.29218,
                            -31.16501
                        ],
                        [
                            -55.33799,
                            -31.12899
                        ],
                        [
                            -55.38546,
                            -31.02941
                        ],
                        [
                            -55.59756,
                            -30.84762
                        ],
                        [
                            -55.6355,
                            -30.85922
                        ],
                        [
                            -55.65472,
                            -30.9541
                        ],
                        [
                            -55.70117,
                            -30.9608
                        ],
                        [
                            -55.86953,
                            -31.07873
                        ],
                        [
                            -55.94528,
                            -31.08826
                        ],
                        [
                            -56.00583,
                            -31.0629
                        ],
                        [
                            -56.01411,
                            -30.94011
                        ],
                        [
                            -55.98793,
                            -30.85832
                        ],
                        [
                            -56.02225,
                            -30.78558
                        ],
                        [
                            -56.12908,
                            -30.73602
                        ],
                        [
                            -56.17695,
                            -30.61691
                        ],
                        [
                            -56.38376,
                            -30.49426
                        ],
                        [
                            -56.41728,
                            -30.431
                        ],
                        [
                            -56.48685,
                            -30.39381
                        ],
                        [
                            -56.53738,
                            -30.33183
                        ],
                        [
                            -56.7067,
                            -30.17877
                        ],
                        [
                            -56.777,
                            -30.1649
                        ],
                        [
                            -56.83516,
                            -30.09207
                        ],
                        [
                            -57.04026,
                            -30.10094
                        ],
                        [
                            -57.11023,
                            -30.11686
                        ],
                        [
                            -57.20952,
                            -30.28149
                        ],
                        [
                            -57.31344,
                            -30.26086
                        ],
                        [
                            -57.39857,
                            -30.30166
                        ],
                        [
                            -57.42654,
                            -30.276
                        ],
                        [
                            -57.55083,
                            -30.26605
                        ],
                        [
                            -57.55731,
                            -30.21385
                        ],
                        [
                            -57.61898,
                            -30.1759
                        ],
                        [
                            -57.61616,
                            -30.25358
                        ],
                        [
                            -57.64584,
                            -30.34305
                        ],
                        [
                            -57.89335,
                            -30.50968
                        ],
                        [
                            -57.88946,
                            -30.58779
                        ],
                        [
                            -57.80738,
                            -30.69793
                        ],
                        [
                            -57.81339,
                            -30.92478
                        ],
                        [
                            -57.90315,
                            -30.93036
                        ],
                        [
                            -57.86771,
                            -31.00513
                        ],
                        [
                            -57.90648,
                            -31.11078
                        ],
                        [
                            -57.90925,
                            -31.20621
                        ],
                        [
                            -57.98081,
                            -31.32043
                        ],
                        [
                            -57.98361,
                            -31.39124
                        ],
                        [
                            -58.08103,
                            -31.45888
                        ],
                        [
                            -58.00626,
                            -31.52886
                        ],
                        [
                            -57.98111,
                            -31.58305
                        ],
                        [
                            -58.04511,
                            -31.76122
                        ],
                        [
                            -58.07905,
                            -31.82077
                        ],
                        [
                            -58.19907,
                            -31.87125
                        ],
                        [
                            -58.1387,
                            -32.02074
                        ],
                        [
                            -58.18052,
                            -32.16017
                        ],
                        [
                            -58.10383,
                            -32.24523
                        ],
                        [
                            -58.11189,
                            -32.32523
                        ],
                        [
                            -58.18104,
                            -32.37259
                        ],
                        [
                            -58.20379,
                            -32.46778
                        ],
                        [
                            -58.14354,
                            -32.66672
                        ],
                        [
                            -58.1487,
                            -32.72786
                        ],
                        [
                            -58.11375,
                            -32.88603
                        ],
                        [
                            -58.13027,
                            -33.02645
                        ],
                        [
                            -58.13219,
                            -33.09557
                        ],
                        [
                            -58.21422,
                            -33.12306
                        ],
                        [
                            -58.31058,
                            -33.11294
                        ],
                        [
                            -58.36033,
                            -33.1713
                        ],
                        [
                            -58.34719,
                            -33.32255
                        ],
                        [
                            -58.39647,
                            -33.35845
                        ],
                        [
                            -58.39046,
                            -33.47188
                        ],
                        [
                            -58.42891,
                            -33.5141
                        ],
                        [
                            -58.41988,
                            -33.72857
                        ],
                        [
                            -58.43309,
                            -33.81797
                        ],
                        [
                            -58.41489,
                            -33.91018
                        ],
                        [
                            -58.22949,
                            -34.0737
                        ],
                        [
                            -58.2066,
                            -34.16641
                        ],
                        [
                            -58.11023,
                            -34.17431
                        ],
                        [
                            -57.99501,
                            -34.27089
                        ],
                        [
                            -57.90328,
                            -34.38874
                        ],
                        [
                            -57.8551,
                            -34.48397
                        ],
                        [
                            -57.76793,
                            -34.48295
                        ],
                        [
                            -57.60036,
                            -34.43794
                        ],
                        [
                            -57.53334,
                            -34.46489
                        ],
                        [
                            -57.46644,
                            -34.44071
                        ],
                        [
                            -57.12522,
                            -34.46239
                        ],
                        [
                            -57.04743,
                            -34.54436
                        ],
                        [
                            -56.81225,
                            -34.69762
                        ],
                        [
                            -56.64235,
                            -34.72907
                        ],
                        [
                            -56.55124,
                            -34.76971
                        ],
                        [
                            -56.44699,
                            -34.7635
                        ],
                        [
                            -56.37759,
                            -34.78898
                        ],
                        [
                            -56.42436,
                            -34.8441
                        ],
                        [
                            -56.31338,
                            -34.91088
                        ],
                        [
                            -56.14446,
                            -34.91969
                        ],
                        [
                            -56.05992,
                            -34.90063
                        ],
                        [
                            -55.89427,
                            -34.81445
                        ],
                        [
                            -55.68726,
                            -34.77028
                        ],
                        [
                            -55.53398,
                            -34.80192
                        ],
                        [
                            -55.40558,
                            -34.799
                        ],
                        [
                            -55.3233,
                            -34.8225
                        ],
                        [
                            -55.23228,
                            -34.90825
                        ],
                        [
                            -55.17983,
                            -34.88902
                        ],
                        [
                            -55.0539,
                            -34.88868
                        ],
                        [
                            -54.94214,
                            -34.95504
                        ],
                        [
                            -54.80622,
                            -34.90422
                        ],
                        [
                            -54.45512,
                            -34.75054
                        ],
                        [
                            -54.21426,
                            -34.66423
                        ],
                        [
                            -54.11303,
                            -34.57877
                        ],
                        [
                            -53.9124,
                            -34.45536
                        ],
                        [
                            -53.80266,
                            -34.40504
                        ],
                        [
                            -53.76425,
                            -34.35729
                        ],
                        [
                            -53.78927,
                            -34.30341
                        ],
                        [
                            -53.67747,
                            -34.1638
                        ],
                        [
                            -53.53722,
                            -34.04583
                        ],
                        [
                            -53.50288,
                            -33.88715
                        ],
                        [
                            -53.37795,
                            -33.7504
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "UZB",
                "Country": "Uzbekistan",
                "Total_3GHG": 0.4,
                "Total_3GHG_timeseries": [
                    2.7985e-06,
                    5.6092e-06,
                    8.4316e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0048,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0055,
                    0.0056,
                    0.0057,
                    0.0058,
                    0.0059,
                    0.006,
                    0.0062,
                    0.0063,
                    0.0064,
                    0.0065
                ],
                "Fossil_3GHG": 0.46,
                "Fossil_3GHG_timeseries": [
                    1.3811e-07,
                    2.7747e-07,
                    4.1809e-07,
                    5.5996e-07,
                    7.0722e-07,
                    8.5154e-07,
                    9.9706e-07,
                    1.1496e-06,
                    1.3037e-06,
                    1.461e-06,
                    1.6272e-06,
                    1.7993e-06,
                    1.9786e-06,
                    2.1659e-06,
                    2.3596e-06,
                    2.5828e-06,
                    2.8179e-06,
                    3.0535e-06,
                    3.3073e-06,
                    3.5715e-06,
                    3.859e-06,
                    4.1553e-06,
                    4.4555e-06,
                    4.7767e-06,
                    5.1175e-06,
                    5.488e-06,
                    5.87e-06,
                    6.2935e-06,
                    6.7295e-06,
                    7.1986e-06,
                    7.6825e-06,
                    8.1792e-06,
                    8.7053e-06,
                    9.244e-06,
                    9.8102e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0048,
                    0.0049
                ],
                "Land_3GHG": 0.27,
                "Land_3GHG_timeseries": [
                    2.6604e-06,
                    5.3317e-06,
                    8.0135e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016
                ],
                "Total_CO2": 0.3,
                "Total_CO2_timeseries": [
                    2.1442e-06,
                    4.2945e-06,
                    6.4507e-06,
                    8.612e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034
                ],
                "Fossil_CO2": 0.38,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    4.0327e-09,
                    4.0327e-09,
                    4.0327e-09,
                    9.696e-09,
                    1.5702e-08,
                    2.3639e-08,
                    3.3721e-08,
                    4.2817e-08,
                    5.2341e-08,
                    6.3024e-08,
                    7.3235e-08,
                    1.055e-07,
                    1.4252e-07,
                    1.7333e-07,
                    2.1511e-07,
                    2.6046e-07,
                    3.2168e-07,
                    3.8453e-07,
                    4.4352e-07,
                    5.1513e-07,
                    5.9754e-07,
                    6.9987e-07,
                    8.0429e-07,
                    9.4076e-07,
                    1.0808e-06,
                    1.2451e-06,
                    1.4181e-06,
                    1.6003e-06,
                    1.8078e-06,
                    2.0184e-06,
                    2.2478e-06,
                    2.4831e-06,
                    2.732e-06,
                    2.9917e-06,
                    3.2722e-06,
                    3.5898e-06,
                    3.9395e-06,
                    4.3096e-06,
                    4.7435e-06,
                    5.1854e-06,
                    5.6931e-06,
                    6.21e-06,
                    6.8077e-06,
                    7.4779e-06,
                    8.2555e-06,
                    9.1363e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029
                ],
                "Land_CO2": 0.14,
                "Land_CO2_timeseries": [
                    2.1442e-06,
                    4.2945e-06,
                    6.4507e-06,
                    8.612e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Total_CH4": 0.66,
                "Total_CH4_timeseries": [
                    3.8286e-07,
                    7.6677e-07,
                    1.1517e-06,
                    1.5377e-06,
                    1.9249e-06,
                    2.313e-06,
                    2.7022e-06,
                    3.0926e-06,
                    3.4841e-06,
                    3.8767e-06,
                    4.2986e-06,
                    4.7495e-06,
                    5.2296e-06,
                    5.7389e-06,
                    6.2774e-06,
                    6.8456e-06,
                    7.4433e-06,
                    8.0701e-06,
                    8.7264e-06,
                    9.4119e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027
                ],
                "Fossil_CH4": 0.74,
                "Fossil_CH4_timeseries": [
                    8.7463e-08,
                    1.756e-07,
                    2.6441e-07,
                    3.5389e-07,
                    4.4419e-07,
                    5.3504e-07,
                    6.2656e-07,
                    7.1895e-07,
                    8.1204e-07,
                    9.0595e-07,
                    1.0063e-06,
                    1.1129e-06,
                    1.226e-06,
                    1.3455e-06,
                    1.4714e-06,
                    1.6044e-06,
                    1.744e-06,
                    1.89e-06,
                    2.0427e-06,
                    2.2019e-06,
                    2.3678e-06,
                    2.5401e-06,
                    2.7192e-06,
                    2.9056e-06,
                    3.0995e-06,
                    3.302e-06,
                    3.5127e-06,
                    3.7317e-06,
                    3.9588e-06,
                    4.194e-06,
                    4.4346e-06,
                    4.6782e-06,
                    4.9255e-06,
                    5.1817e-06,
                    5.4461e-06,
                    5.7126e-06,
                    5.9887e-06,
                    6.2697e-06,
                    6.5522e-06,
                    6.8461e-06,
                    7.1532e-06,
                    7.4645e-06,
                    7.79e-06,
                    8.1096e-06,
                    8.4562e-06,
                    8.8014e-06,
                    9.1609e-06,
                    9.5349e-06,
                    9.919e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019
                ],
                "Land_CH4": 0.52,
                "Land_CH4_timeseries": [
                    2.954e-07,
                    5.9117e-07,
                    8.8731e-07,
                    1.1838e-06,
                    1.4807e-06,
                    1.778e-06,
                    2.0756e-06,
                    2.3736e-06,
                    2.672e-06,
                    2.9708e-06,
                    3.2923e-06,
                    3.6366e-06,
                    4.0036e-06,
                    4.3934e-06,
                    4.8059e-06,
                    5.2412e-06,
                    5.6993e-06,
                    6.1801e-06,
                    6.6837e-06,
                    7.21e-06,
                    7.7611e-06,
                    8.337e-06,
                    8.9377e-06,
                    9.5631e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008
                ],
                "Total_N2O": 0.39,
                "Total_N2O_timeseries": [
                    2.7146e-07,
                    5.4791e-07,
                    8.2918e-07,
                    1.115e-06,
                    1.405e-06,
                    1.6987e-06,
                    1.9957e-06,
                    2.2954e-06,
                    2.5971e-06,
                    2.9002e-06,
                    3.2041e-06,
                    3.5087e-06,
                    3.814e-06,
                    4.1199e-06,
                    4.4264e-06,
                    4.7334e-06,
                    5.0411e-06,
                    5.3494e-06,
                    5.6585e-06,
                    5.9685e-06,
                    6.2832e-06,
                    6.6094e-06,
                    6.9521e-06,
                    7.3149e-06,
                    7.6998e-06,
                    8.1073e-06,
                    8.5363e-06,
                    8.9843e-06,
                    9.4471e-06,
                    9.9191e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_N2O": 0.24,
                "Fossil_N2O_timeseries": [
                    5.0645e-08,
                    1.0188e-07,
                    1.5368e-07,
                    2.0606e-07,
                    2.59e-07,
                    3.1247e-07,
                    3.6647e-07,
                    4.2097e-07,
                    4.7594e-07,
                    5.3137e-07,
                    5.8723e-07,
                    6.4352e-07,
                    7.0024e-07,
                    7.5739e-07,
                    8.1496e-07,
                    8.7295e-07,
                    9.3137e-07,
                    9.9022e-07,
                    1.0495e-06,
                    1.1092e-06,
                    1.1695e-06,
                    1.2306e-06,
                    1.2927e-06,
                    1.356e-06,
                    1.4205e-06,
                    1.4861e-06,
                    1.553e-06,
                    1.621e-06,
                    1.6899e-06,
                    1.7596e-06,
                    1.8298e-06,
                    1.9006e-06,
                    1.972e-06,
                    2.0439e-06,
                    2.1163e-06,
                    2.1892e-06,
                    2.2627e-06,
                    2.3366e-06,
                    2.4111e-06,
                    2.4868e-06,
                    2.5633e-06,
                    2.6405e-06,
                    2.7184e-06,
                    2.7971e-06,
                    2.8767e-06,
                    2.957e-06,
                    3.0382e-06,
                    3.1203e-06,
                    3.2032e-06,
                    3.287e-06,
                    3.3719e-06,
                    3.4577e-06,
                    3.5447e-06,
                    3.6328e-06,
                    3.7221e-06,
                    3.8126e-06,
                    3.9042e-06,
                    3.997e-06,
                    4.091e-06,
                    4.1859e-06,
                    4.2819e-06,
                    4.3787e-06,
                    4.4765e-06,
                    4.5751e-06,
                    4.6746e-06,
                    4.775e-06,
                    4.8763e-06,
                    4.9785e-06,
                    5.0818e-06,
                    5.1863e-06,
                    5.2922e-06,
                    5.4002e-06,
                    5.5109e-06,
                    5.6247e-06,
                    5.7421e-06,
                    5.8635e-06,
                    5.9892e-06,
                    6.1194e-06,
                    6.2545e-06,
                    6.3945e-06,
                    6.5405e-06,
                    6.6944e-06,
                    6.8574e-06,
                    7.0309e-06,
                    7.2155e-06,
                    7.4117e-06,
                    7.6197e-06,
                    7.8393e-06,
                    8.0701e-06,
                    8.3112e-06,
                    8.5621e-06,
                    8.8229e-06,
                    9.0937e-06,
                    9.3748e-06,
                    9.6665e-06,
                    9.9693e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_N2O": 0.45,
                "Land_N2O_timeseries": [
                    2.2081e-07,
                    4.4604e-07,
                    6.7549e-07,
                    9.0891e-07,
                    1.146e-06,
                    1.3862e-06,
                    1.6292e-06,
                    1.8744e-06,
                    2.1212e-06,
                    2.3688e-06,
                    2.6168e-06,
                    2.8652e-06,
                    3.1138e-06,
                    3.3625e-06,
                    3.6114e-06,
                    3.8605e-06,
                    4.1097e-06,
                    4.3592e-06,
                    4.609e-06,
                    4.8593e-06,
                    5.1137e-06,
                    5.3788e-06,
                    5.6594e-06,
                    5.9589e-06,
                    6.2794e-06,
                    6.6212e-06,
                    6.9833e-06,
                    7.3633e-06,
                    7.7572e-06,
                    8.1596e-06,
                    8.5667e-06,
                    8.9778e-06,
                    9.3923e-06,
                    9.8097e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                67.77866,
                                37.17963
                            ],
                            [
                                67.8207,
                                37.23634
                            ],
                            [
                                67.8285,
                                37.46002
                            ],
                            [
                                67.85399,
                                37.52828
                            ],
                            [
                                67.94247,
                                37.64398
                            ],
                            [
                                68.04083,
                                37.73469
                            ],
                            [
                                68.1274,
                                37.87435
                            ],
                            [
                                68.27085,
                                37.91202
                            ],
                            [
                                68.28794,
                                37.98883
                            ],
                            [
                                68.36928,
                                38.07983
                            ],
                            [
                                68.40198,
                                38.19187
                            ],
                            [
                                68.32162,
                                38.29077
                            ],
                            [
                                68.23627,
                                38.32773
                            ],
                            [
                                68.19592,
                                38.40542
                            ],
                            [
                                68.11472,
                                38.42759
                            ],
                            [
                                68.14027,
                                38.47126
                            ],
                            [
                                68.06945,
                                38.54239
                            ],
                            [
                                68.08531,
                                38.64512
                            ],
                            [
                                68.0601,
                                38.70561
                            ],
                            [
                                68.1254,
                                38.74099
                            ],
                            [
                                68.08496,
                                38.81308
                            ],
                            [
                                68.19405,
                                38.85139
                            ],
                            [
                                68.19789,
                                38.92512
                            ],
                            [
                                68.11459,
                                39.0087
                            ],
                            [
                                67.9682,
                                39.03241
                            ],
                            [
                                67.87079,
                                39.00126
                            ],
                            [
                                67.71554,
                                39.00113
                            ],
                            [
                                67.68506,
                                39.02414
                            ],
                            [
                                67.68012,
                                39.13984
                            ],
                            [
                                67.61689,
                                39.17516
                            ],
                            [
                                67.44876,
                                39.20914
                            ],
                            [
                                67.39462,
                                39.29948
                            ],
                            [
                                67.51775,
                                39.33994
                            ],
                            [
                                67.4278,
                                39.49519
                            ],
                            [
                                67.50305,
                                39.57215
                            ],
                            [
                                67.62472,
                                39.60042
                            ],
                            [
                                67.70931,
                                39.65514
                            ],
                            [
                                67.79954,
                                39.65194
                            ],
                            [
                                67.93448,
                                39.59905
                            ],
                            [
                                68.35971,
                                39.53192
                            ],
                            [
                                68.51728,
                                39.53722
                            ],
                            [
                                68.62637,
                                39.65385
                            ],
                            [
                                68.59513,
                                39.72094
                            ],
                            [
                                68.6507,
                                39.80876
                            ],
                            [
                                68.72189,
                                39.8668
                            ],
                            [
                                68.7768,
                                39.83219
                            ],
                            [
                                68.82307,
                                39.89356
                            ],
                            [
                                68.90055,
                                39.92257
                            ],
                            [
                                68.81411,
                                40.00086
                            ],
                            [
                                68.89321,
                                40.06823
                            ],
                            [
                                69.0006,
                                40.06931
                            ],
                            [
                                68.97239,
                                40.15098
                            ],
                            [
                                68.87045,
                                40.14567
                            ],
                            [
                                68.68114,
                                40.10005
                            ],
                            [
                                68.60451,
                                40.09405
                            ],
                            [
                                68.54013,
                                40.13911
                            ],
                            [
                                68.77039,
                                40.19576
                            ],
                            [
                                69.05213,
                                40.21984
                            ],
                            [
                                69.17224,
                                40.20617
                            ],
                            [
                                69.25436,
                                40.25368
                            ],
                            [
                                69.33832,
                                40.34371
                            ],
                            [
                                69.30907,
                                40.37045
                            ],
                            [
                                69.23651,
                                40.52958
                            ],
                            [
                                69.3317,
                                40.5719
                            ],
                            [
                                69.3614,
                                40.61671
                            ],
                            [
                                69.34929,
                                40.71293
                            ],
                            [
                                69.4036,
                                40.78126
                            ],
                            [
                                69.53321,
                                40.76354
                            ],
                            [
                                69.57277,
                                40.70588
                            ],
                            [
                                69.66801,
                                40.63224
                            ],
                            [
                                69.7373,
                                40.64075
                            ],
                            [
                                69.76658,
                                40.68587
                            ],
                            [
                                69.8769,
                                40.7194
                            ],
                            [
                                69.92341,
                                40.70616
                            ],
                            [
                                70.08074,
                                40.76647
                            ],
                            [
                                70.15559,
                                40.8329
                            ],
                            [
                                70.21723,
                                40.82831
                            ],
                            [
                                70.35921,
                                40.88692
                            ],
                            [
                                70.44664,
                                41.04163
                            ],
                            [
                                70.53767,
                                40.98893
                            ],
                            [
                                70.78823,
                                40.72301
                            ],
                            [
                                70.7341,
                                40.65884
                            ],
                            [
                                70.62902,
                                40.61874
                            ],
                            [
                                70.58716,
                                40.56668
                            ],
                            [
                                70.51504,
                                40.55298
                            ],
                            [
                                70.48731,
                                40.50662
                            ],
                            [
                                70.33339,
                                40.44884
                            ],
                            [
                                70.37908,
                                40.38213
                            ],
                            [
                                70.5479,
                                40.34666
                            ],
                            [
                                70.56998,
                                40.24089
                            ],
                            [
                                70.6503,
                                40.16583
                            ],
                            [
                                70.77911,
                                40.18459
                            ],
                            [
                                70.86928,
                                40.2225
                            ],
                            [
                                70.96761,
                                40.22851
                            ],
                            [
                                70.9698,
                                40.26574
                            ],
                            [
                                71.12112,
                                40.31994
                            ],
                            [
                                71.2728,
                                40.32647
                            ],
                            [
                                71.48671,
                                40.26123
                            ],
                            [
                                71.49506,
                                40.222
                            ],
                            [
                                71.61002,
                                40.19024
                            ],
                            [
                                71.68068,
                                40.22965
                            ],
                            [
                                71.72676,
                                40.15002
                            ],
                            [
                                71.92729,
                                40.22528
                            ],
                            [
                                71.9928,
                                40.27003
                            ],
                            [
                                71.95196,
                                40.3097
                            ],
                            [
                                72.07931,
                                40.38887
                            ],
                            [
                                72.18603,
                                40.49814
                            ],
                            [
                                72.40851,
                                40.40194
                            ],
                            [
                                72.48614,
                                40.55745
                            ],
                            [
                                72.63418,
                                40.52075
                            ],
                            [
                                72.68322,
                                40.59123
                            ],
                            [
                                72.76029,
                                40.57077
                            ],
                            [
                                72.77241,
                                40.67903
                            ],
                            [
                                72.84474,
                                40.6881
                            ],
                            [
                                73.0069,
                                40.7662
                            ],
                            [
                                73.10651,
                                40.79327
                            ],
                            [
                                73.06088,
                                40.85196
                            ],
                            [
                                72.91102,
                                40.81778
                            ],
                            [
                                72.832,
                                40.86874
                            ],
                            [
                                72.67811,
                                40.85694
                            ],
                            [
                                72.57878,
                                40.88921
                            ],
                            [
                                72.50695,
                                40.98087
                            ],
                            [
                                72.49567,
                                41.02988
                            ],
                            [
                                72.35944,
                                41.06315
                            ],
                            [
                                72.2947,
                                41.02942
                            ],
                            [
                                72.2264,
                                41.05128
                            ],
                            [
                                72.19128,
                                41.15437
                            ],
                            [
                                72.07629,
                                41.14095
                            ],
                            [
                                71.9435,
                                41.15883
                            ],
                            [
                                71.86484,
                                41.20731
                            ],
                            [
                                71.93275,
                                41.30984
                            ],
                            [
                                71.8876,
                                41.36975
                            ],
                            [
                                71.74169,
                                41.45335
                            ],
                            [
                                71.73157,
                                41.54485
                            ],
                            [
                                71.62485,
                                41.48954
                            ],
                            [
                                71.67525,
                                41.46171
                            ],
                            [
                                71.67302,
                                41.39537
                            ],
                            [
                                71.59199,
                                41.30647
                            ],
                            [
                                71.48479,
                                41.31421
                            ],
                            [
                                71.4521,
                                41.28821
                            ],
                            [
                                71.47485,
                                41.21904
                            ],
                            [
                                71.43613,
                                41.1271
                            ],
                            [
                                71.39344,
                                41.11307
                            ],
                            [
                                71.26018,
                                41.18362
                            ],
                            [
                                71.12907,
                                41.14801
                            ],
                            [
                                71.02948,
                                41.19241
                            ],
                            [
                                70.95855,
                                41.16475
                            ],
                            [
                                70.87806,
                                41.22883
                            ],
                            [
                                70.78425,
                                41.18843
                            ],
                            [
                                70.77764,
                                41.37826
                            ],
                            [
                                70.71203,
                                41.46207
                            ],
                            [
                                70.58355,
                                41.4417
                            ],
                            [
                                70.48814,
                                41.39972
                            ],
                            [
                                70.35656,
                                41.50003
                            ],
                            [
                                70.18408,
                                41.52365
                            ],
                            [
                                70.19405,
                                41.59602
                            ],
                            [
                                70.34497,
                                41.63691
                            ],
                            [
                                70.48849,
                                41.71703
                            ],
                            [
                                70.52941,
                                41.79431
                            ],
                            [
                                70.59848,
                                41.82678
                            ],
                            [
                                70.6779,
                                41.90732
                            ],
                            [
                                70.82858,
                                41.92583
                            ],
                            [
                                70.86365,
                                42.04184
                            ],
                            [
                                70.96992,
                                42.02808
                            ],
                            [
                                71.14631,
                                42.13259
                            ],
                            [
                                71.21366,
                                42.13645
                            ],
                            [
                                71.25691,
                                42.20152
                            ],
                            [
                                71.13671,
                                42.27187
                            ],
                            [
                                71.05939,
                                42.28758
                            ],
                            [
                                70.94022,
                                42.2592
                            ],
                            [
                                70.83914,
                                42.19401
                            ],
                            [
                                70.80099,
                                42.20983
                            ],
                            [
                                70.69353,
                                42.12676
                            ],
                            [
                                70.62698,
                                42.00088
                            ],
                            [
                                70.55911,
                                42.01883
                            ],
                            [
                                70.54644,
                                42.0695
                            ],
                            [
                                70.43324,
                                42.13009
                            ],
                            [
                                70.32271,
                                42.03444
                            ],
                            [
                                70.33083,
                                41.97559
                            ],
                            [
                                70.24031,
                                41.94113
                            ],
                            [
                                70.15974,
                                41.84434
                            ],
                            [
                                69.98364,
                                41.77901
                            ],
                            [
                                69.95206,
                                41.71917
                            ],
                            [
                                69.83319,
                                41.71886
                            ],
                            [
                                69.62041,
                                41.65719
                            ],
                            [
                                69.51536,
                                41.55938
                            ],
                            [
                                69.40624,
                                41.50029
                            ],
                            [
                                69.41955,
                                41.45554
                            ],
                            [
                                69.23247,
                                41.46151
                            ],
                            [
                                69.03317,
                                41.34133
                            ],
                            [
                                68.94527,
                                41.19475
                            ],
                            [
                                68.86365,
                                41.15012
                            ],
                            [
                                68.76644,
                                41.04332
                            ],
                            [
                                68.74397,
                                40.98738
                            ],
                            [
                                68.59392,
                                40.91763
                            ],
                            [
                                68.56892,
                                40.85818
                            ],
                            [
                                68.58866,
                                40.73537
                            ],
                            [
                                68.65053,
                                40.67185
                            ],
                            [
                                68.60928,
                                40.60081
                            ],
                            [
                                68.53902,
                                40.62445
                            ],
                            [
                                68.48474,
                                40.59288
                            ],
                            [
                                68.23302,
                                40.6918
                            ],
                            [
                                68.0742,
                                40.80121
                            ],
                            [
                                68.13427,
                                40.9367
                            ],
                            [
                                68.14885,
                                41.0305
                            ],
                            [
                                68.10569,
                                41.0651
                            ],
                            [
                                68.03571,
                                41.04229
                            ],
                            [
                                67.93276,
                                41.19543
                            ],
                            [
                                67.84908,
                                41.16104
                            ],
                            [
                                67.77564,
                                41.2021
                            ],
                            [
                                67.30723,
                                41.21169
                            ],
                            [
                                66.60803,
                                41.25202
                            ],
                            [
                                66.53033,
                                41.89447
                            ],
                            [
                                66.0103,
                                41.94583
                            ],
                            [
                                66.01679,
                                42.37472
                            ],
                            [
                                66.10596,
                                42.35262
                            ],
                            [
                                66.09863,
                                42.95982
                            ],
                            [
                                65.82713,
                                42.87014
                            ],
                            [
                                65.68431,
                                43.20593
                            ],
                            [
                                65.6504,
                                43.30308
                            ],
                            [
                                65.29619,
                                43.54401
                            ],
                            [
                                65.16998,
                                43.74273
                            ],
                            [
                                65.11221,
                                43.7755
                            ],
                            [
                                65.00857,
                                43.76612
                            ],
                            [
                                64.53623,
                                43.60346
                            ],
                            [
                                64.25279,
                                43.60986
                            ],
                            [
                                63.91202,
                                43.62808
                            ],
                            [
                                63.38911,
                                43.67283
                            ],
                            [
                                63.20776,
                                43.65245
                            ],
                            [
                                62.02898,
                                43.48656
                            ],
                            [
                                61.9755,
                                43.51241
                            ],
                            [
                                61.41135,
                                44.01838
                            ],
                            [
                                61.12991,
                                44.26063
                            ],
                            [
                                60.59141,
                                44.54405
                            ],
                            [
                                59.48846,
                                45.12475
                            ],
                            [
                                58.59581,
                                45.59043
                            ],
                            [
                                57.91759,
                                45.43673
                            ],
                            [
                                57.00798,
                                45.22994
                            ],
                            [
                                56.00072,
                                45.00006
                            ],
                            [
                                56.00004,
                                43.64984
                            ],
                            [
                                56.00024,
                                42.8196
                            ],
                            [
                                56.00039,
                                42.1923
                            ],
                            [
                                56.0006,
                                41.31805
                            ],
                            [
                                57.04339,
                                41.26443
                            ],
                            [
                                57.09001,
                                41.33461
                            ],
                            [
                                57.02283,
                                41.4963
                            ],
                            [
                                57.01869,
                                41.58779
                            ],
                            [
                                56.97237,
                                41.67255
                            ],
                            [
                                56.96782,
                                41.80532
                            ],
                            [
                                56.98447,
                                41.86821
                            ],
                            [
                                57.03723,
                                41.91757
                            ],
                            [
                                57.16736,
                                41.97511
                            ],
                            [
                                57.23793,
                                42.09387
                            ],
                            [
                                57.41097,
                                42.16947
                            ],
                            [
                                57.52207,
                                42.17402
                            ],
                            [
                                57.67567,
                                42.15218
                            ],
                            [
                                57.76738,
                                42.18087
                            ],
                            [
                                57.83587,
                                42.17301
                            ],
                            [
                                57.84687,
                                42.2456
                            ],
                            [
                                57.92686,
                                42.24378
                            ],
                            [
                                57.93882,
                                42.39071
                            ],
                            [
                                57.91759,
                                42.45743
                            ],
                            [
                                58.04963,
                                42.50453
                            ],
                            [
                                58.13768,
                                42.44356
                            ],
                            [
                                58.20017,
                                42.46689
                            ],
                            [
                                58.32653,
                                42.44673
                            ],
                            [
                                58.36818,
                                42.41997
                            ],
                            [
                                58.40633,
                                42.29228
                            ],
                            [
                                58.51651,
                                42.3224
                            ],
                            [
                                58.4089,
                                42.37042
                            ],
                            [
                                58.30456,
                                42.54993
                            ],
                            [
                                58.14843,
                                42.62329
                            ],
                            [
                                58.27974,
                                42.68892
                            ],
                            [
                                58.47248,
                                42.65056
                            ],
                            [
                                58.59504,
                                42.66595
                            ],
                            [
                                58.59424,
                                42.72868
                            ],
                            [
                                58.63724,
                                42.7874
                            ],
                            [
                                58.93425,
                                42.54403
                            ],
                            [
                                59.04904,
                                42.51074
                            ],
                            [
                                59.17118,
                                42.52734
                            ],
                            [
                                59.277,
                                42.43895
                            ],
                            [
                                59.27173,
                                42.39226
                            ],
                            [
                                59.44203,
                                42.27561
                            ],
                            [
                                59.73751,
                                42.28334
                            ],
                            [
                                59.82865,
                                42.30546
                            ],
                            [
                                59.93797,
                                42.23516
                            ],
                            [
                                60.0301,
                                42.20381
                            ],
                            [
                                59.97404,
                                42.14679
                            ],
                            [
                                60.02932,
                                42.0098
                            ],
                            [
                                59.94952,
                                41.97384
                            ],
                            [
                                60.11349,
                                41.8952
                            ],
                            [
                                60.18258,
                                41.83558
                            ],
                            [
                                60.25959,
                                41.81459
                            ],
                            [
                                60.28906,
                                41.75295
                            ],
                            [
                                60.08365,
                                41.80845
                            ],
                            [
                                60.06857,
                                41.72919
                            ],
                            [
                                60.16373,
                                41.6073
                            ],
                            [
                                60.11339,
                                41.54921
                            ],
                            [
                                60.09425,
                                41.43155
                            ],
                            [
                                60.13093,
                                41.39511
                            ],
                            [
                                60.46915,
                                41.22157
                            ],
                            [
                                61.04415,
                                41.23454
                            ],
                            [
                                61.16936,
                                41.1747
                            ],
                            [
                                61.30148,
                                41.14542
                            ],
                            [
                                61.38016,
                                41.1654
                            ],
                            [
                                61.42024,
                                41.28428
                            ],
                            [
                                61.62687,
                                41.26498
                            ],
                            [
                                61.66062,
                                41.2259
                            ],
                            [
                                61.88035,
                                41.1094
                            ],
                            [
                                61.90081,
                                41.0536
                            ],
                            [
                                61.97089,
                                41.0191
                            ],
                            [
                                62.00015,
                                40.82031
                            ],
                            [
                                62.11315,
                                40.59601
                            ],
                            [
                                62.2089,
                                40.50801
                            ],
                            [
                                62.34943,
                                40.43713
                            ],
                            [
                                62.33439,
                                40.3766
                            ],
                            [
                                62.39142,
                                40.31755
                            ],
                            [
                                62.4137,
                                40.17256
                            ],
                            [
                                62.39679,
                                40.09968
                            ],
                            [
                                62.44355,
                                39.99026
                            ],
                            [
                                62.49027,
                                39.95008
                            ],
                            [
                                62.79819,
                                39.77567
                            ],
                            [
                                63.17045,
                                39.57413
                            ],
                            [
                                63.53743,
                                39.38428
                            ],
                            [
                                63.74497,
                                39.20723
                            ],
                            [
                                64.15689,
                                38.9676
                            ],
                            [
                                64.22945,
                                38.95682
                            ],
                            [
                                64.33141,
                                38.9852
                            ],
                            [
                                64.52451,
                                38.83733
                            ],
                            [
                                64.82733,
                                38.67927
                            ],
                            [
                                65.03388,
                                38.60767
                            ],
                            [
                                65.30102,
                                38.4083
                            ],
                            [
                                65.48183,
                                38.31892
                            ],
                            [
                                65.69495,
                                38.25253
                            ],
                            [
                                65.79576,
                                38.23611
                            ],
                            [
                                65.85312,
                                38.2743
                            ],
                            [
                                66.23834,
                                38.15766
                            ],
                            [
                                66.31191,
                                38.07982
                            ],
                            [
                                66.40064,
                                38.03256
                            ],
                            [
                                66.5499,
                                38.0383
                            ],
                            [
                                66.67653,
                                37.9617
                            ],
                            [
                                66.56473,
                                37.82292
                            ],
                            [
                                66.53921,
                                37.7476
                            ],
                            [
                                66.53958,
                                37.57809
                            ],
                            [
                                66.63635,
                                37.48446
                            ],
                            [
                                66.63774,
                                37.4391
                            ],
                            [
                                66.52947,
                                37.40143
                            ],
                            [
                                66.55373,
                                37.35475
                            ],
                            [
                                66.60406,
                                37.36362
                            ],
                            [
                                66.85115,
                                37.35352
                            ],
                            [
                                66.94659,
                                37.39834
                            ],
                            [
                                67.05904,
                                37.37261
                            ],
                            [
                                67.12529,
                                37.27324
                            ],
                            [
                                67.20854,
                                37.24899
                            ],
                            [
                                67.26022,
                                37.18436
                            ],
                            [
                                67.44898,
                                37.23465
                            ],
                            [
                                67.49915,
                                37.28137
                            ],
                            [
                                67.57109,
                                37.22424
                            ],
                            [
                                67.61277,
                                37.23919
                            ],
                            [
                                67.73687,
                                37.21456
                            ],
                            [
                                67.77866,
                                37.17963
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                70.99603,
                                40.16894
                            ],
                            [
                                71.00768,
                                40.03953
                            ],
                            [
                                71.08546,
                                40.00978
                            ],
                            [
                                71.11277,
                                39.91526
                            ],
                            [
                                71.18046,
                                39.87578
                            ],
                            [
                                71.22936,
                                39.91974
                            ],
                            [
                                71.11976,
                                40.01747
                            ],
                            [
                                71.08144,
                                40.15071
                            ],
                            [
                                70.99603,
                                40.16894
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                71.68945,
                                39.94
                            ],
                            [
                                71.78944,
                                39.9125
                            ],
                            [
                                71.79083,
                                39.99444
                            ],
                            [
                                71.68945,
                                39.94
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "VUT",
                "Country": "Vanuatu",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    4.7377e-08,
                    9.3804e-08,
                    1.4123e-07,
                    1.6988e-07,
                    2.0043e-07,
                    2.51e-07,
                    2.9719e-07,
                    3.5162e-07,
                    3.9661e-07,
                    4.4839e-07,
                    4.9321e-07,
                    5.4587e-07,
                    5.8769e-07,
                    6.3303e-07,
                    6.8768e-07,
                    7.3939e-07,
                    7.95e-07,
                    8.4117e-07,
                    8.9166e-07,
                    9.5819e-07,
                    9.9595e-07,
                    1.0751e-06,
                    1.1285e-06,
                    1.1875e-06,
                    1.2587e-06,
                    1.3298e-06,
                    1.4087e-06,
                    1.4771e-06,
                    1.5506e-06,
                    1.6345e-06,
                    1.7077e-06,
                    1.7811e-06,
                    1.8542e-06,
                    1.9302e-06,
                    2.0276e-06,
                    2.1046e-06,
                    2.1919e-06,
                    2.2789e-06,
                    2.3674e-06,
                    2.4565e-06,
                    2.5413e-06,
                    2.6321e-06,
                    2.702e-06,
                    2.8037e-06,
                    2.8992e-06,
                    3.0015e-06,
                    3.1144e-06,
                    3.2272e-06,
                    3.3539e-06,
                    3.4831e-06,
                    3.6104e-06,
                    3.7338e-06,
                    3.8475e-06,
                    3.9645e-06,
                    4.0655e-06,
                    4.1879e-06,
                    4.3298e-06,
                    4.4557e-06,
                    4.5946e-06,
                    4.7298e-06,
                    4.8723e-06,
                    5.0129e-06,
                    5.1465e-06,
                    5.2961e-06,
                    5.443e-06,
                    5.5826e-06,
                    5.7306e-06,
                    5.8801e-06,
                    6.0452e-06,
                    6.2031e-06,
                    6.365e-06,
                    6.5262e-06,
                    6.6859e-06,
                    6.8463e-06,
                    7.0054e-06,
                    7.1668e-06,
                    7.3226e-06,
                    7.4803e-06,
                    7.6334e-06,
                    7.7998e-06,
                    7.961e-06,
                    8.1415e-06,
                    8.3157e-06,
                    8.4842e-06,
                    8.6548e-06,
                    8.8328e-06,
                    8.9955e-06,
                    9.1537e-06,
                    9.3119e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    2.1355e-09,
                    4.3278e-09,
                    6.5785e-09,
                    8.8895e-09,
                    1.1263e-08,
                    1.37e-08,
                    1.6204e-08,
                    1.8775e-08,
                    2.1417e-08,
                    2.4132e-08,
                    2.6882e-08,
                    2.9669e-08,
                    3.2494e-08,
                    3.5361e-08,
                    3.827e-08,
                    4.1223e-08,
                    4.4223e-08,
                    4.7271e-08,
                    5.037e-08,
                    5.3522e-08,
                    5.6686e-08,
                    5.9863e-08,
                    6.3054e-08,
                    6.6261e-08,
                    6.9484e-08,
                    7.2725e-08,
                    7.5984e-08,
                    7.9261e-08,
                    8.2555e-08,
                    8.5867e-08,
                    8.9082e-08,
                    9.2385e-08,
                    9.5778e-08,
                    9.9267e-08,
                    1.0285e-07,
                    1.0655e-07,
                    1.1035e-07,
                    1.1426e-07,
                    1.1829e-07,
                    1.2245e-07,
                    1.2655e-07,
                    1.306e-07,
                    1.346e-07,
                    1.3853e-07,
                    1.424e-07,
                    1.4624e-07,
                    1.5002e-07,
                    1.5376e-07,
                    1.5745e-07,
                    1.6109e-07,
                    1.648e-07,
                    1.6849e-07,
                    1.7218e-07,
                    1.7584e-07,
                    1.7948e-07,
                    1.831e-07,
                    1.8668e-07,
                    1.9022e-07,
                    1.9371e-07,
                    1.9715e-07,
                    2.0057e-07,
                    2.0397e-07,
                    2.0736e-07,
                    2.1073e-07,
                    2.1408e-07,
                    2.1741e-07,
                    2.207e-07,
                    2.2396e-07,
                    2.272e-07,
                    2.304e-07,
                    2.3359e-07,
                    2.3659e-07,
                    2.3945e-07,
                    2.4216e-07,
                    2.4473e-07,
                    2.4709e-07,
                    2.493e-07,
                    2.5139e-07,
                    2.5326e-07,
                    2.55e-07,
                    2.5679e-07,
                    2.5852e-07,
                    2.6021e-07,
                    2.6187e-07,
                    2.6349e-07,
                    2.6507e-07,
                    2.6663e-07,
                    2.6815e-07,
                    2.6965e-07,
                    2.7112e-07,
                    2.7261e-07,
                    2.7418e-07,
                    2.7581e-07,
                    2.7749e-07,
                    2.7933e-07,
                    2.8147e-07,
                    2.8365e-07,
                    2.8589e-07,
                    2.8828e-07,
                    2.908e-07,
                    2.9409e-07,
                    2.9832e-07,
                    3.0351e-07,
                    3.0971e-07,
                    3.1694e-07,
                    3.2525e-07,
                    3.3467e-07,
                    3.4524e-07,
                    3.5703e-07,
                    3.7009e-07,
                    3.8447e-07,
                    4.1861e-07,
                    4.5091e-07,
                    4.9791e-07,
                    5.3977e-07,
                    5.9622e-07,
                    6.5758e-07,
                    7.1073e-07,
                    7.5724e-07,
                    8.035e-07,
                    8.6039e-07,
                    9.1997e-07,
                    9.7743e-07,
                    1.0396e-06,
                    1.0993e-06,
                    1.1553e-06,
                    1.2158e-06,
                    1.2809e-06,
                    1.3489e-06,
                    1.4181e-06,
                    1.4832e-06,
                    1.5491e-06,
                    1.6179e-06,
                    1.6874e-06,
                    1.7881e-06,
                    1.8617e-06,
                    1.9315e-06,
                    2.0113e-06,
                    2.0905e-06,
                    2.1733e-06,
                    2.2566e-06,
                    2.3408e-06,
                    2.4267e-06,
                    2.515e-06,
                    2.6063e-06,
                    2.7077e-06,
                    2.8126e-06,
                    2.9167e-06,
                    3.0346e-06,
                    3.1554e-06,
                    3.2784e-06,
                    3.3993e-06,
                    3.5224e-06,
                    3.6365e-06,
                    3.7529e-06,
                    3.8682e-06,
                    4.0102e-06,
                    4.1532e-06,
                    4.3108e-06,
                    4.4703e-06,
                    4.6376e-06,
                    4.7987e-06,
                    4.9599e-06,
                    5.1431e-06,
                    5.3162e-06,
                    5.4974e-06,
                    5.6776e-06,
                    5.8773e-06,
                    6.0635e-06,
                    6.266e-06,
                    6.4754e-06,
                    6.686e-06
                ],
                "Land_3GHG": 0.01,
                "Land_3GHG_timeseries": [
                    4.5242e-08,
                    8.9476e-08,
                    1.3465e-07,
                    1.6099e-07,
                    1.8917e-07,
                    2.373e-07,
                    2.8099e-07,
                    3.3285e-07,
                    3.7519e-07,
                    4.2425e-07,
                    4.6633e-07,
                    5.1621e-07,
                    5.552e-07,
                    5.9767e-07,
                    6.4941e-07,
                    6.9816e-07,
                    7.5077e-07,
                    7.939e-07,
                    8.4129e-07,
                    9.0467e-07,
                    9.3926e-07,
                    1.0153e-06,
                    1.0654e-06,
                    1.1212e-06,
                    1.1892e-06,
                    1.2571e-06,
                    1.3327e-06,
                    1.3979e-06,
                    1.468e-06,
                    1.5487e-06,
                    1.6186e-06,
                    1.6887e-06,
                    1.7584e-06,
                    1.8309e-06,
                    1.9247e-06,
                    1.998e-06,
                    2.0815e-06,
                    2.1647e-06,
                    2.2491e-06,
                    2.334e-06,
                    2.4148e-06,
                    2.5015e-06,
                    2.5674e-06,
                    2.6652e-06,
                    2.7568e-06,
                    2.8553e-06,
                    2.9644e-06,
                    3.0735e-06,
                    3.1965e-06,
                    3.322e-06,
                    3.4456e-06,
                    3.5653e-06,
                    3.6753e-06,
                    3.7887e-06,
                    3.886e-06,
                    4.0048e-06,
                    4.1431e-06,
                    4.2655e-06,
                    4.4009e-06,
                    4.5326e-06,
                    4.6717e-06,
                    4.8089e-06,
                    4.9391e-06,
                    5.0854e-06,
                    5.2289e-06,
                    5.3652e-06,
                    5.5099e-06,
                    5.6561e-06,
                    5.818e-06,
                    5.9727e-06,
                    6.1314e-06,
                    6.2896e-06,
                    6.4464e-06,
                    6.6041e-06,
                    6.7606e-06,
                    6.9197e-06,
                    7.0733e-06,
                    7.2289e-06,
                    7.3801e-06,
                    7.5448e-06,
                    7.7042e-06,
                    7.883e-06,
                    8.0555e-06,
                    8.2223e-06,
                    8.3913e-06,
                    8.5677e-06,
                    8.7289e-06,
                    8.8855e-06,
                    9.0422e-06,
                    9.8084e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    2.0532e-08,
                    3.9891e-08,
                    6.0027e-08,
                    6.1171e-08,
                    6.4003e-08,
                    8.6631e-08,
                    1.0466e-07,
                    1.3072e-07,
                    1.4712e-07,
                    1.7012e-07,
                    1.863e-07,
                    2.1047e-07,
                    2.2394e-07,
                    2.4106e-07,
                    2.6765e-07,
                    2.9143e-07,
                    3.1926e-07,
                    3.3778e-07,
                    3.6075e-07,
                    3.9989e-07,
                    4.1041e-07,
                    4.6247e-07,
                    4.8874e-07,
                    5.2073e-07,
                    5.6492e-07,
                    6.0902e-07,
                    6.6088e-07,
                    7.0239e-07,
                    7.4895e-07,
                    8.0615e-07,
                    8.5254e-07,
                    8.9893e-07,
                    9.4492e-07,
                    9.9351e-07,
                    1.0634e-06,
                    1.1127e-06,
                    1.172e-06,
                    1.2309e-06,
                    1.2911e-06,
                    1.3512e-06,
                    1.4072e-06,
                    1.4694e-06,
                    1.5108e-06,
                    1.5841e-06,
                    1.6512e-06,
                    1.7252e-06,
                    1.8098e-06,
                    1.8944e-06,
                    1.9929e-06,
                    2.0937e-06,
                    2.1926e-06,
                    2.2874e-06,
                    2.3724e-06,
                    2.4604e-06,
                    2.5322e-06,
                    2.6252e-06,
                    2.7375e-06,
                    2.8336e-06,
                    2.9425e-06,
                    3.0477e-06,
                    3.1602e-06,
                    3.2709e-06,
                    3.3745e-06,
                    3.4943e-06,
                    3.6114e-06,
                    3.7214e-06,
                    3.8397e-06,
                    3.9597e-06,
                    4.0953e-06,
                    4.2239e-06,
                    4.3565e-06,
                    4.4885e-06,
                    4.6192e-06,
                    4.7508e-06,
                    4.8812e-06,
                    5.0143e-06,
                    5.1418e-06,
                    5.2714e-06,
                    5.3966e-06,
                    5.5354e-06,
                    5.6689e-06,
                    5.8217e-06,
                    5.9682e-06,
                    6.109e-06,
                    6.2519e-06,
                    6.4051e-06,
                    6.5461e-06,
                    6.6854e-06,
                    6.8278e-06,
                    7.5826e-06,
                    8.5633e-06,
                    9.6354e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.815e-08,
                    3.3e-08,
                    6.105e-08,
                    8.25e-08,
                    1.1715e-07,
                    1.551e-07,
                    1.8315e-07,
                    2.0295e-07,
                    2.211e-07,
                    2.475e-07,
                    2.7555e-07,
                    3.003e-07,
                    3.2835e-07,
                    3.531e-07,
                    3.729e-07,
                    3.96e-07,
                    4.224e-07,
                    4.5045e-07,
                    4.785e-07,
                    5.016e-07,
                    5.247e-07,
                    5.4945e-07,
                    5.742e-07,
                    6.2865e-07,
                    6.5505e-07,
                    6.765e-07,
                    7.062e-07,
                    7.3425e-07,
                    7.6395e-07,
                    7.9365e-07,
                    8.2335e-07,
                    8.5305e-07,
                    8.8275e-07,
                    9.1245e-07,
                    9.504e-07,
                    9.9e-07,
                    1.028e-06,
                    1.0676e-06,
                    1.1072e-06,
                    1.1484e-06,
                    1.1864e-06,
                    1.2243e-06,
                    1.2507e-06,
                    1.2771e-06,
                    1.2986e-06,
                    1.3431e-06,
                    1.386e-06,
                    1.4404e-06,
                    1.4949e-06,
                    1.5559e-06,
                    1.6088e-06,
                    1.6582e-06,
                    1.7292e-06,
                    1.7902e-06,
                    1.8579e-06,
                    1.9223e-06,
                    2.0031e-06,
                    2.0774e-06,
                    2.1681e-06,
                    2.2628e-06,
                    2.3564e-06
                ],
                "Land_CO2": 0.02,
                "Land_CO2_timeseries": [
                    2.0532e-08,
                    3.9891e-08,
                    6.0027e-08,
                    6.1171e-08,
                    6.4003e-08,
                    8.6631e-08,
                    1.0466e-07,
                    1.3072e-07,
                    1.4712e-07,
                    1.7012e-07,
                    1.863e-07,
                    2.1047e-07,
                    2.2394e-07,
                    2.4106e-07,
                    2.6765e-07,
                    2.9143e-07,
                    3.1926e-07,
                    3.3778e-07,
                    3.6075e-07,
                    3.9989e-07,
                    4.1041e-07,
                    4.6247e-07,
                    4.8874e-07,
                    5.2073e-07,
                    5.6492e-07,
                    6.0902e-07,
                    6.6088e-07,
                    7.0239e-07,
                    7.4895e-07,
                    8.0615e-07,
                    8.5254e-07,
                    8.9893e-07,
                    9.4492e-07,
                    9.9351e-07,
                    1.0634e-06,
                    1.1127e-06,
                    1.172e-06,
                    1.2309e-06,
                    1.2911e-06,
                    1.3512e-06,
                    1.4072e-06,
                    1.4694e-06,
                    1.5108e-06,
                    1.5841e-06,
                    1.6512e-06,
                    1.7252e-06,
                    1.8098e-06,
                    1.8944e-06,
                    1.9929e-06,
                    2.0937e-06,
                    2.1926e-06,
                    2.2874e-06,
                    2.3724e-06,
                    2.4604e-06,
                    2.5322e-06,
                    2.6252e-06,
                    2.7375e-06,
                    2.8336e-06,
                    2.9425e-06,
                    3.0477e-06,
                    3.1602e-06,
                    3.2709e-06,
                    3.3745e-06,
                    3.4943e-06,
                    3.6114e-06,
                    3.7214e-06,
                    3.8397e-06,
                    3.9597e-06,
                    4.0953e-06,
                    4.2239e-06,
                    4.3565e-06,
                    4.4885e-06,
                    4.6192e-06,
                    4.7508e-06,
                    4.8812e-06,
                    5.0143e-06,
                    5.1418e-06,
                    5.2714e-06,
                    5.3966e-06,
                    5.5354e-06,
                    5.6689e-06,
                    5.8217e-06,
                    5.9682e-06,
                    6.109e-06,
                    6.2519e-06,
                    6.4051e-06,
                    6.5461e-06,
                    6.6854e-06,
                    6.8278e-06,
                    7.5826e-06,
                    8.5633e-06,
                    9.6354e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [
                    2.4806e-08,
                    4.9792e-08,
                    7.4961e-08,
                    1.0031e-07,
                    1.2585e-07,
                    1.5158e-07,
                    1.775e-07,
                    2.0361e-07,
                    2.2992e-07,
                    2.5642e-07,
                    2.8277e-07,
                    3.0897e-07,
                    3.3503e-07,
                    3.6093e-07,
                    3.867e-07,
                    4.1232e-07,
                    4.378e-07,
                    4.6314e-07,
                    4.8835e-07,
                    5.1342e-07,
                    5.3829e-07,
                    5.6297e-07,
                    5.8745e-07,
                    6.1174e-07,
                    6.3582e-07,
                    6.5972e-07,
                    6.8342e-07,
                    7.0692e-07,
                    7.3023e-07,
                    7.5335e-07,
                    7.7644e-07,
                    7.9969e-07,
                    8.2309e-07,
                    8.4665e-07,
                    8.7039e-07,
                    8.9429e-07,
                    9.1837e-07,
                    9.4262e-07,
                    9.6707e-07,
                    9.917e-07,
                    1.0164e-06,
                    1.041e-06,
                    1.0657e-06,
                    1.0904e-06,
                    1.1151e-06,
                    1.1398e-06,
                    1.1645e-06,
                    1.1893e-06,
                    1.2141e-06,
                    1.2389e-06,
                    1.2638e-06,
                    1.2888e-06,
                    1.3139e-06,
                    1.339e-06,
                    1.3641e-06,
                    1.3893e-06,
                    1.4145e-06,
                    1.4398e-06,
                    1.4651e-06,
                    1.4904e-06,
                    1.5155e-06,
                    1.5406e-06,
                    1.5656e-06,
                    1.5905e-06,
                    1.6153e-06,
                    1.6399e-06,
                    1.6645e-06,
                    1.6889e-06,
                    1.7132e-06,
                    1.7374e-06,
                    1.7615e-06,
                    1.7853e-06,
                    1.8089e-06,
                    1.8323e-06,
                    1.8554e-06,
                    1.8782e-06,
                    1.9008e-06,
                    1.9231e-06,
                    1.9452e-06,
                    1.967e-06,
                    1.9889e-06,
                    2.0109e-06,
                    2.0328e-06,
                    2.0547e-06,
                    2.0767e-06,
                    2.0957e-06,
                    2.1118e-06,
                    2.1249e-06,
                    2.135e-06,
                    2.1422e-06,
                    2.1465e-06,
                    2.1478e-06,
                    2.1462e-06,
                    2.1416e-06,
                    2.1341e-06,
                    2.1239e-06,
                    2.1106e-06,
                    2.0943e-06,
                    2.075e-06,
                    2.0528e-06,
                    2.0317e-06,
                    2.0121e-06,
                    1.9943e-06,
                    1.9783e-06,
                    1.9641e-06,
                    1.9544e-06,
                    1.9491e-06,
                    1.9482e-06,
                    1.9518e-06,
                    1.96e-06,
                    1.9844e-06,
                    2.0309e-06,
                    2.1101e-06,
                    2.2061e-06,
                    2.3219e-06,
                    2.4644e-06,
                    2.6263e-06,
                    2.8119e-06,
                    3.0178e-06,
                    3.235e-06,
                    3.4866e-06,
                    3.741e-06,
                    4.0351e-06,
                    4.3482e-06,
                    4.6804e-06,
                    5.0322e-06,
                    5.365e-06,
                    5.6819e-06,
                    5.9864e-06,
                    6.2863e-06,
                    6.5752e-06,
                    6.8592e-06,
                    7.1297e-06,
                    7.3924e-06,
                    7.6599e-06,
                    7.9169e-06,
                    8.1747e-06,
                    8.4094e-06,
                    8.6427e-06,
                    8.9054e-06,
                    9.1568e-06,
                    9.4386e-06,
                    9.7242e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [
                    1.955e-09,
                    3.9645e-09,
                    6.0302e-09,
                    8.1541e-09,
                    1.0338e-08,
                    1.2584e-08,
                    1.4895e-08,
                    1.7271e-08,
                    1.9717e-08,
                    2.2233e-08,
                    2.4783e-08,
                    2.7369e-08,
                    2.9993e-08,
                    3.2656e-08,
                    3.536e-08,
                    3.8107e-08,
                    4.0899e-08,
                    4.3738e-08,
                    4.6626e-08,
                    4.9566e-08,
                    5.2516e-08,
                    5.5475e-08,
                    5.8444e-08,
                    6.1423e-08,
                    6.4413e-08,
                    6.7415e-08,
                    7.043e-08,
                    7.3457e-08,
                    7.6498e-08,
                    7.9553e-08,
                    8.2509e-08,
                    8.5551e-08,
                    8.8681e-08,
                    9.1904e-08,
                    9.5225e-08,
                    9.8648e-08,
                    1.0218e-07,
                    1.0582e-07,
                    1.0958e-07,
                    1.1345e-07,
                    1.1728e-07,
                    1.2104e-07,
                    1.2474e-07,
                    1.2839e-07,
                    1.3197e-07,
                    1.355e-07,
                    1.3899e-07,
                    1.4242e-07,
                    1.4581e-07,
                    1.4913e-07,
                    1.5252e-07,
                    1.559e-07,
                    1.5926e-07,
                    1.6259e-07,
                    1.659e-07,
                    1.6918e-07,
                    1.7241e-07,
                    1.756e-07,
                    1.7874e-07,
                    1.8182e-07,
                    1.8487e-07,
                    1.8791e-07,
                    1.9093e-07,
                    1.9392e-07,
                    1.969e-07,
                    1.9984e-07,
                    2.0275e-07,
                    2.0563e-07,
                    2.0847e-07,
                    2.1128e-07,
                    2.1406e-07,
                    2.1666e-07,
                    2.1912e-07,
                    2.2143e-07,
                    2.2359e-07,
                    2.2554e-07,
                    2.2735e-07,
                    2.2901e-07,
                    2.3047e-07,
                    2.318e-07,
                    2.3317e-07,
                    2.3447e-07,
                    2.3573e-07,
                    2.3694e-07,
                    2.3811e-07,
                    2.3924e-07,
                    2.4033e-07,
                    2.4139e-07,
                    2.424e-07,
                    2.4338e-07,
                    2.4437e-07,
                    2.4542e-07,
                    2.465e-07,
                    2.4762e-07,
                    2.4888e-07,
                    2.5041e-07,
                    2.5196e-07,
                    2.5353e-07,
                    2.5524e-07,
                    2.5707e-07,
                    2.5965e-07,
                    2.6315e-07,
                    2.6761e-07,
                    2.7307e-07,
                    2.7954e-07,
                    2.8708e-07,
                    2.9572e-07,
                    3.055e-07,
                    3.1647e-07,
                    3.2871e-07,
                    3.4224e-07,
                    3.5736e-07,
                    3.739e-07,
                    3.9188e-07,
                    4.1127e-07,
                    4.3202e-07,
                    4.5432e-07,
                    4.7827e-07,
                    5.038e-07,
                    5.3081e-07,
                    5.6018e-07,
                    5.9049e-07,
                    6.2192e-07,
                    6.5462e-07,
                    6.8821e-07,
                    7.2297e-07,
                    7.5872e-07,
                    7.9583e-07,
                    8.341e-07,
                    8.7356e-07,
                    9.1391e-07,
                    9.5507e-07,
                    9.9732e-07,
                    1.0404e-06,
                    1.0847e-06,
                    1.13e-06,
                    1.1766e-06,
                    1.2245e-06,
                    1.2739e-06,
                    1.325e-06,
                    1.3768e-06,
                    1.4296e-06,
                    1.4842e-06,
                    1.541e-06,
                    1.6009e-06,
                    1.6624e-06,
                    1.7257e-06,
                    1.7898e-06,
                    1.8656e-06,
                    1.9441e-06,
                    2.023e-06,
                    2.103e-06,
                    2.1851e-06,
                    2.2698e-06,
                    2.3568e-06,
                    2.4477e-06,
                    2.5416e-06,
                    2.6383e-06,
                    2.7378e-06,
                    2.8391e-06,
                    2.9414e-06,
                    3.046e-06,
                    3.1539e-06,
                    3.2622e-06,
                    3.3703e-06,
                    3.4799e-06,
                    3.5916e-06,
                    3.7061e-06,
                    3.8135e-06,
                    3.9209e-06,
                    4.0311e-06,
                    4.1436e-06
                ],
                "Land_CH4": 0.01,
                "Land_CH4_timeseries": [
                    2.2851e-08,
                    4.5827e-08,
                    6.893e-08,
                    9.216e-08,
                    1.1552e-07,
                    1.39e-07,
                    1.626e-07,
                    1.8634e-07,
                    2.102e-07,
                    2.3419e-07,
                    2.5799e-07,
                    2.816e-07,
                    3.0503e-07,
                    3.2828e-07,
                    3.5134e-07,
                    3.7421e-07,
                    3.969e-07,
                    4.194e-07,
                    4.4172e-07,
                    4.6385e-07,
                    4.8578e-07,
                    5.075e-07,
                    5.2901e-07,
                    5.5031e-07,
                    5.7141e-07,
                    5.923e-07,
                    6.1299e-07,
                    6.3347e-07,
                    6.5374e-07,
                    6.738e-07,
                    6.9393e-07,
                    7.1414e-07,
                    7.3441e-07,
                    7.5475e-07,
                    7.7516e-07,
                    7.9564e-07,
                    8.1619e-07,
                    8.3681e-07,
                    8.5749e-07,
                    8.7825e-07,
                    8.9908e-07,
                    9.1998e-07,
                    9.4095e-07,
                    9.6199e-07,
                    9.831e-07,
                    1.0043e-06,
                    1.0255e-06,
                    1.0469e-06,
                    1.0683e-06,
                    1.0897e-06,
                    1.1113e-06,
                    1.1329e-06,
                    1.1546e-06,
                    1.1764e-06,
                    1.1982e-06,
                    1.2201e-06,
                    1.2421e-06,
                    1.2642e-06,
                    1.2863e-06,
                    1.3085e-06,
                    1.3307e-06,
                    1.3527e-06,
                    1.3747e-06,
                    1.3966e-06,
                    1.4184e-06,
                    1.4401e-06,
                    1.4617e-06,
                    1.4833e-06,
                    1.5048e-06,
                    1.5262e-06,
                    1.5475e-06,
                    1.5687e-06,
                    1.5898e-06,
                    1.6109e-06,
                    1.6318e-06,
                    1.6527e-06,
                    1.6734e-06,
                    1.6941e-06,
                    1.7147e-06,
                    1.7352e-06,
                    1.7558e-06,
                    1.7764e-06,
                    1.7971e-06,
                    1.8178e-06,
                    1.8385e-06,
                    1.8564e-06,
                    1.8714e-06,
                    1.8835e-06,
                    1.8926e-06,
                    1.8988e-06,
                    1.9021e-06,
                    1.9024e-06,
                    1.8997e-06,
                    1.8939e-06,
                    1.8852e-06,
                    1.8734e-06,
                    1.8586e-06,
                    1.8407e-06,
                    1.8198e-06,
                    1.7957e-06,
                    1.772e-06,
                    1.749e-06,
                    1.7267e-06,
                    1.7053e-06,
                    1.6846e-06,
                    1.6673e-06,
                    1.6534e-06,
                    1.6427e-06,
                    1.6354e-06,
                    1.6313e-06,
                    1.6422e-06,
                    1.6735e-06,
                    1.7362e-06,
                    1.8142e-06,
                    1.9106e-06,
                    2.0324e-06,
                    2.172e-06,
                    2.3337e-06,
                    2.514e-06,
                    2.7042e-06,
                    2.9264e-06,
                    3.1506e-06,
                    3.4132e-06,
                    3.6936e-06,
                    3.9922e-06,
                    4.3092e-06,
                    4.6062e-06,
                    4.8861e-06,
                    5.1523e-06,
                    5.4127e-06,
                    5.6612e-06,
                    5.9041e-06,
                    6.1324e-06,
                    6.352e-06,
                    6.5751e-06,
                    6.787e-06,
                    6.9981e-06,
                    7.1848e-06,
                    7.3688e-06,
                    7.5804e-06,
                    7.7801e-06,
                    8.009e-06,
                    8.2401e-06,
                    8.4609e-06,
                    8.6631e-06,
                    8.8479e-06,
                    9.0505e-06,
                    9.2693e-06,
                    9.5022e-06,
                    9.7042e-06,
                    9.872e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [
                    2.0404e-09,
                    4.1203e-09,
                    6.238e-09,
                    8.3912e-09,
                    1.0577e-08,
                    1.2792e-08,
                    1.5032e-08,
                    1.7292e-08,
                    1.9567e-08,
                    2.1851e-08,
                    2.414e-08,
                    2.6432e-08,
                    2.8728e-08,
                    3.1027e-08,
                    3.3329e-08,
                    3.5633e-08,
                    3.794e-08,
                    4.0251e-08,
                    4.2565e-08,
                    4.4885e-08,
                    4.7243e-08,
                    4.9694e-08,
                    5.2279e-08,
                    5.503e-08,
                    5.7962e-08,
                    6.108e-08,
                    6.4374e-08,
                    6.7825e-08,
                    7.1396e-08,
                    7.5042e-08,
                    7.873e-08,
                    8.2454e-08,
                    8.6208e-08,
                    8.9989e-08,
                    9.3794e-08,
                    9.7621e-08,
                    1.0147e-07,
                    1.0534e-07,
                    1.0924e-07,
                    1.1357e-07,
                    1.1771e-07,
                    1.217e-07,
                    1.2555e-07,
                    1.2929e-07,
                    1.3294e-07,
                    1.3652e-07,
                    1.4005e-07,
                    1.4354e-07,
                    1.4701e-07,
                    1.5048e-07,
                    1.5398e-07,
                    1.5756e-07,
                    1.6127e-07,
                    1.6514e-07,
                    1.6917e-07,
                    1.7338e-07,
                    1.7777e-07,
                    1.8231e-07,
                    1.8697e-07,
                    1.9173e-07,
                    1.9654e-07,
                    2.014e-07,
                    2.0631e-07,
                    2.1126e-07,
                    2.1625e-07,
                    2.2128e-07,
                    2.2634e-07,
                    2.3143e-07,
                    2.3657e-07,
                    2.4176e-07,
                    2.4701e-07,
                    2.5232e-07,
                    2.5771e-07,
                    2.6318e-07,
                    2.6873e-07,
                    2.7436e-07,
                    2.8005e-07,
                    2.858e-07,
                    2.9158e-07,
                    2.9737e-07,
                    3.0317e-07,
                    3.0895e-07,
                    3.1473e-07,
                    3.2048e-07,
                    3.2623e-07,
                    3.3195e-07,
                    3.3767e-07,
                    3.4337e-07,
                    3.4907e-07,
                    3.5477e-07,
                    3.6057e-07,
                    3.6662e-07,
                    3.7302e-07,
                    3.7986e-07,
                    3.872e-07,
                    3.9504e-07,
                    4.0337e-07,
                    4.1215e-07,
                    4.2129e-07,
                    4.3066e-07,
                    4.4022e-07,
                    4.4997e-07,
                    4.5992e-07,
                    4.7009e-07,
                    4.8048e-07,
                    4.9109e-07,
                    5.0194e-07,
                    5.1304e-07,
                    5.2437e-07,
                    5.3595e-07,
                    5.4902e-07,
                    5.6355e-07,
                    5.8016e-07,
                    5.9807e-07,
                    6.1724e-07,
                    6.3825e-07,
                    6.6053e-07,
                    6.8435e-07,
                    7.0944e-07,
                    7.3494e-07,
                    7.6316e-07,
                    7.9164e-07,
                    8.2345e-07,
                    8.5689e-07,
                    8.9186e-07,
                    9.2837e-07,
                    9.6365e-07,
                    9.9744e-07,
                    1.0302e-06,
                    1.0626e-06,
                    1.0947e-06,
                    1.1277e-06,
                    1.1618e-06,
                    1.1962e-06,
                    1.2322e-06,
                    1.269e-06,
                    1.3067e-06,
                    1.3448e-06,
                    1.3837e-06,
                    1.4253e-06,
                    1.4683e-06,
                    1.5139e-06,
                    1.5625e-06,
                    1.6116e-06,
                    1.6607e-06,
                    1.71e-06,
                    1.7594e-06,
                    1.8088e-06,
                    1.8588e-06,
                    1.9059e-06,
                    1.9503e-06,
                    1.9949e-06,
                    2.0413e-06,
                    2.0886e-06,
                    2.1368e-06,
                    2.1858e-06,
                    2.2449e-06,
                    2.3048e-06,
                    2.3604e-06,
                    2.4173e-06,
                    2.4762e-06,
                    2.5354e-06,
                    2.595e-06,
                    2.6554e-06,
                    2.709e-06,
                    2.7516e-06,
                    2.7901e-06,
                    2.8345e-06,
                    2.8749e-06,
                    2.9135e-06,
                    2.9512e-06,
                    2.9866e-06
                ],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [
                    1.8054e-10,
                    3.6332e-10,
                    5.4831e-10,
                    7.3546e-10,
                    9.2469e-10,
                    1.1159e-09,
                    1.309e-09,
                    1.504e-09,
                    1.7005e-09,
                    1.8986e-09,
                    2.0981e-09,
                    2.2991e-09,
                    2.5014e-09,
                    2.705e-09,
                    2.9101e-09,
                    3.1165e-09,
                    3.3243e-09,
                    3.5335e-09,
                    3.7441e-09,
                    3.9561e-09,
                    4.1703e-09,
                    4.388e-09,
                    4.6103e-09,
                    4.8378e-09,
                    5.0709e-09,
                    5.3098e-09,
                    5.5542e-09,
                    5.8036e-09,
                    6.0572e-09,
                    6.3139e-09,
                    6.5729e-09,
                    6.834e-09,
                    7.0972e-09,
                    7.3624e-09,
                    7.6294e-09,
                    7.8982e-09,
                    8.1689e-09,
                    8.4414e-09,
                    8.7159e-09,
                    8.9955e-09,
                    9.2778e-09,
                    9.563e-09,
                    9.8511e-09,
                    1.0142e-08,
                    1.0437e-08,
                    1.0734e-08,
                    1.1035e-08,
                    1.1339e-08,
                    1.1647e-08,
                    1.1959e-08,
                    1.2274e-08,
                    1.2594e-08,
                    1.2919e-08,
                    1.3249e-08,
                    1.3583e-08,
                    1.3923e-08,
                    1.4268e-08,
                    1.4617e-08,
                    1.4972e-08,
                    1.533e-08,
                    1.5692e-08,
                    1.6059e-08,
                    1.6429e-08,
                    1.6804e-08,
                    1.7182e-08,
                    1.7564e-08,
                    1.7949e-08,
                    1.8338e-08,
                    1.873e-08,
                    1.9125e-08,
                    1.9523e-08,
                    1.9923e-08,
                    2.0326e-08,
                    2.0731e-08,
                    2.1138e-08,
                    2.1547e-08,
                    2.1958e-08,
                    2.2372e-08,
                    2.2787e-08,
                    2.3206e-08,
                    2.3628e-08,
                    2.4054e-08,
                    2.4487e-08,
                    2.4927e-08,
                    2.5374e-08,
                    2.5829e-08,
                    2.6294e-08,
                    2.6767e-08,
                    2.725e-08,
                    2.7741e-08,
                    2.8244e-08,
                    2.8764e-08,
                    2.9303e-08,
                    2.9865e-08,
                    3.0452e-08,
                    3.1063e-08,
                    3.1699e-08,
                    3.2358e-08,
                    3.3037e-08,
                    3.3732e-08,
                    3.4442e-08,
                    3.5164e-08,
                    3.5898e-08,
                    3.6644e-08,
                    3.7401e-08,
                    3.817e-08,
                    3.8952e-08,
                    3.9746e-08,
                    4.0554e-08,
                    4.1377e-08,
                    4.2222e-08,
                    4.31e-08,
                    4.4019e-08,
                    4.4984e-08,
                    4.5997e-08,
                    4.7059e-08,
                    4.8166e-08,
                    4.9314e-08,
                    5.0494e-08,
                    5.1582e-08,
                    5.2714e-08,
                    5.3931e-08,
                    5.5208e-08,
                    5.6599e-08,
                    5.8015e-08,
                    5.9464e-08,
                    6.1125e-08,
                    6.2681e-08,
                    6.4353e-08,
                    6.6061e-08,
                    6.7698e-08,
                    6.9375e-08,
                    7.1084e-08,
                    7.2786e-08,
                    7.4735e-08,
                    7.6618e-08,
                    7.8475e-08,
                    8.0548e-08,
                    8.2403e-08,
                    8.4358e-08,
                    8.622e-08,
                    8.7827e-08,
                    8.9468e-08,
                    9.1168e-08,
                    9.299e-08,
                    9.491e-08,
                    9.6895e-08,
                    9.8946e-08,
                    1.0144e-07,
                    1.042e-07,
                    1.0707e-07,
                    1.0998e-07,
                    1.1308e-07,
                    1.1601e-07,
                    1.1901e-07,
                    1.2194e-07,
                    1.2542e-07,
                    1.2893e-07,
                    1.3253e-07,
                    1.3624e-07,
                    1.402e-07,
                    1.4396e-07,
                    1.4774e-07,
                    1.5171e-07,
                    1.5562e-07,
                    1.5958e-07,
                    1.6377e-07,
                    1.6816e-07,
                    1.7269e-07,
                    1.7706e-07,
                    1.8152e-07,
                    1.8604e-07
                ],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": [
                    1.8599e-09,
                    3.757e-09,
                    5.6897e-09,
                    7.6557e-09,
                    9.6523e-09,
                    1.1676e-08,
                    1.3723e-08,
                    1.5788e-08,
                    1.7867e-08,
                    1.9952e-08,
                    2.2041e-08,
                    2.4133e-08,
                    2.6227e-08,
                    2.8322e-08,
                    3.0419e-08,
                    3.2516e-08,
                    3.4616e-08,
                    3.6717e-08,
                    3.8821e-08,
                    4.0929e-08,
                    4.3073e-08,
                    4.5306e-08,
                    4.7669e-08,
                    5.0192e-08,
                    5.2891e-08,
                    5.577e-08,
                    5.882e-08,
                    6.2021e-08,
                    6.5339e-08,
                    6.8728e-08,
                    7.2157e-08,
                    7.562e-08,
                    7.9111e-08,
                    8.2627e-08,
                    8.6165e-08,
                    8.9723e-08,
                    9.3302e-08,
                    9.6903e-08,
                    1.0053e-07,
                    1.0457e-07,
                    1.0843e-07,
                    1.1214e-07,
                    1.157e-07,
                    1.1915e-07,
                    1.2251e-07,
                    1.2579e-07,
                    1.2901e-07,
                    1.322e-07,
                    1.3536e-07,
                    1.3852e-07,
                    1.417e-07,
                    1.4497e-07,
                    1.4836e-07,
                    1.5189e-07,
                    1.5559e-07,
                    1.5946e-07,
                    1.635e-07,
                    1.6769e-07,
                    1.72e-07,
                    1.764e-07,
                    1.8085e-07,
                    1.8534e-07,
                    1.8988e-07,
                    1.9446e-07,
                    1.9907e-07,
                    2.0371e-07,
                    2.0839e-07,
                    2.131e-07,
                    2.1784e-07,
                    2.2264e-07,
                    2.2748e-07,
                    2.324e-07,
                    2.3739e-07,
                    2.4245e-07,
                    2.476e-07,
                    2.5281e-07,
                    2.5809e-07,
                    2.6342e-07,
                    2.6879e-07,
                    2.7417e-07,
                    2.7954e-07,
                    2.849e-07,
                    2.9024e-07,
                    2.9556e-07,
                    3.0085e-07,
                    3.0612e-07,
                    3.1137e-07,
                    3.166e-07,
                    3.2182e-07,
                    3.2703e-07,
                    3.3233e-07,
                    3.3785e-07,
                    3.4371e-07,
                    3.5e-07,
                    3.5674e-07,
                    3.6398e-07,
                    3.7168e-07,
                    3.7979e-07,
                    3.8825e-07,
                    3.9693e-07,
                    4.0578e-07,
                    4.1481e-07,
                    4.2403e-07,
                    4.3345e-07,
                    4.4308e-07,
                    4.5292e-07,
                    4.6299e-07,
                    4.7329e-07,
                    4.8382e-07,
                    4.9458e-07,
                    5.068e-07,
                    5.2045e-07,
                    5.3614e-07,
                    5.5308e-07,
                    5.7124e-07,
                    5.9119e-07,
                    6.1236e-07,
                    6.3503e-07,
                    6.5895e-07,
                    6.8336e-07,
                    7.1045e-07,
                    7.3771e-07,
                    7.6824e-07,
                    8.0029e-07,
                    8.3384e-07,
                    8.689e-07,
                    9.0253e-07,
                    9.3476e-07,
                    9.6588e-07,
                    9.965e-07,
                    1.027e-06,
                    1.0583e-06,
                    1.0907e-06,
                    1.1234e-06,
                    1.1575e-06,
                    1.1924e-06,
                    1.2283e-06,
                    1.2643e-06,
                    1.3013e-06,
                    1.3409e-06,
                    1.382e-06,
                    1.4261e-06,
                    1.4731e-06,
                    1.5204e-06,
                    1.5678e-06,
                    1.6151e-06,
                    1.6625e-06,
                    1.7099e-06,
                    1.7573e-06,
                    1.8017e-06,
                    1.8432e-06,
                    1.8849e-06,
                    1.9283e-06,
                    1.9726e-06,
                    2.0177e-06,
                    2.0638e-06,
                    2.1195e-06,
                    2.1758e-06,
                    2.2278e-06,
                    2.2811e-06,
                    2.336e-06,
                    2.3914e-06,
                    2.4473e-06,
                    2.5037e-06,
                    2.5534e-06,
                    2.592e-06,
                    2.6264e-06,
                    2.6664e-06,
                    2.7022e-06,
                    2.7365e-06,
                    2.7697e-06,
                    2.8005e-06
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                166.54368,
                                -14.84647
                            ],
                            [
                                166.60679,
                                -14.99257
                            ],
                            [
                                166.63907,
                                -15.15932
                            ],
                            [
                                166.67296,
                                -15.24315
                            ],
                            [
                                166.64888,
                                -15.39534
                            ],
                            [
                                166.71288,
                                -15.51
                            ],
                            [
                                166.7781,
                                -15.58611
                            ],
                            [
                                166.77567,
                                -15.64904
                            ],
                            [
                                166.97112,
                                -15.58129
                            ],
                            [
                                167.09997,
                                -15.60315
                            ],
                            [
                                167.23366,
                                -15.46187
                            ],
                            [
                                167.18885,
                                -15.38215
                            ],
                            [
                                167.20708,
                                -15.31771
                            ],
                            [
                                167.15883,
                                -15.26926
                            ],
                            [
                                167.17075,
                                -15.20956
                            ],
                            [
                                167.136,
                                -15.12661
                            ],
                            [
                                167.08036,
                                -15.09546
                            ],
                            [
                                167.07571,
                                -15.0181
                            ],
                            [
                                167.0236,
                                -14.93156
                            ],
                            [
                                166.98642,
                                -14.95247
                            ],
                            [
                                166.98761,
                                -15.09441
                            ],
                            [
                                166.95011,
                                -15.15982
                            ],
                            [
                                166.87616,
                                -15.17104
                            ],
                            [
                                166.82353,
                                -15.15331
                            ],
                            [
                                166.78996,
                                -15.01684
                            ],
                            [
                                166.75831,
                                -14.82554
                            ],
                            [
                                166.71589,
                                -14.80172
                            ],
                            [
                                166.61352,
                                -14.64587
                            ],
                            [
                                166.55726,
                                -14.7209
                            ],
                            [
                                166.54368,
                                -14.84647
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                167.78266,
                                -16.38234
                            ],
                            [
                                167.77293,
                                -16.34723
                            ],
                            [
                                167.69512,
                                -16.30802
                            ],
                            [
                                167.60888,
                                -16.22739
                            ],
                            [
                                167.46718,
                                -16.13571
                            ],
                            [
                                167.39214,
                                -16.05876
                            ],
                            [
                                167.40353,
                                -16.01513
                            ],
                            [
                                167.34543,
                                -15.96562
                            ],
                            [
                                167.32845,
                                -15.91631
                            ],
                            [
                                167.21637,
                                -15.88241
                            ],
                            [
                                167.17573,
                                -15.92627
                            ],
                            [
                                167.1874,
                                -15.98121
                            ],
                            [
                                167.15712,
                                -16.08327
                            ],
                            [
                                167.18665,
                                -16.13101
                            ],
                            [
                                167.25128,
                                -16.16228
                            ],
                            [
                                167.3276,
                                -16.11499
                            ],
                            [
                                167.38833,
                                -16.18771
                            ],
                            [
                                167.38001,
                                -16.34672
                            ],
                            [
                                167.43466,
                                -16.45414
                            ],
                            [
                                167.42203,
                                -16.52393
                            ],
                            [
                                167.46309,
                                -16.56589
                            ],
                            [
                                167.53094,
                                -16.57982
                            ],
                            [
                                167.60293,
                                -16.48996
                            ],
                            [
                                167.71676,
                                -16.51462
                            ],
                            [
                                167.73941,
                                -16.54065
                            ],
                            [
                                167.83382,
                                -16.46411
                            ],
                            [
                                167.78266,
                                -16.38234
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                168.16068,
                                -17.70965
                            ],
                            [
                                168.18454,
                                -17.74051
                            ],
                            [
                                168.25103,
                                -17.68717
                            ],
                            [
                                168.3096,
                                -17.77048
                            ],
                            [
                                168.39065,
                                -17.82495
                            ],
                            [
                                168.49249,
                                -17.81672
                            ],
                            [
                                168.55737,
                                -17.78393
                            ],
                            [
                                168.58811,
                                -17.68656
                            ],
                            [
                                168.54658,
                                -17.68077
                            ],
                            [
                                168.44649,
                                -17.53354
                            ],
                            [
                                168.34158,
                                -17.5458
                            ],
                            [
                                168.2862,
                                -17.50576
                            ],
                            [
                                168.23556,
                                -17.61628
                            ],
                            [
                                168.16068,
                                -17.70965
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                169.19743,
                                -18.73906
                            ],
                            [
                                169.14614,
                                -18.63434
                            ],
                            [
                                169.03839,
                                -18.63104
                            ],
                            [
                                169.00878,
                                -18.66031
                            ],
                            [
                                168.98679,
                                -18.76421
                            ],
                            [
                                169.01436,
                                -18.82247
                            ],
                            [
                                168.99215,
                                -18.87382
                            ],
                            [
                                169.09518,
                                -18.93787
                            ],
                            [
                                169.17833,
                                -18.94564
                            ],
                            [
                                169.28729,
                                -18.99517
                            ],
                            [
                                169.34446,
                                -18.94769
                            ],
                            [
                                169.31402,
                                -18.87036
                            ],
                            [
                                169.2182,
                                -18.81325
                            ],
                            [
                                169.28096,
                                -18.76721
                            ],
                            [
                                169.19743,
                                -18.73906
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                167.91294,
                                -16.24088
                            ],
                            [
                                167.98577,
                                -16.31174
                            ],
                            [
                                168.12912,
                                -16.37074
                            ],
                            [
                                168.29981,
                                -16.33936
                            ],
                            [
                                168.30485,
                                -16.29
                            ],
                            [
                                168.22898,
                                -16.2462
                            ],
                            [
                                168.17254,
                                -16.10152
                            ],
                            [
                                168.04842,
                                -16.19659
                            ],
                            [
                                167.98765,
                                -16.19754
                            ],
                            [
                                167.91294,
                                -16.24088
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                169.22067,
                                -19.4547
                            ],
                            [
                                169.28445,
                                -19.57013
                            ],
                            [
                                169.36554,
                                -19.63563
                            ],
                            [
                                169.44007,
                                -19.6556
                            ],
                            [
                                169.46889,
                                -19.6117
                            ],
                            [
                                169.4618,
                                -19.51432
                            ],
                            [
                                169.3716,
                                -19.46565
                            ],
                            [
                                169.34566,
                                -19.38663
                            ],
                            [
                                169.35996,
                                -19.32126
                            ],
                            [
                                169.24759,
                                -19.34839
                            ],
                            [
                                169.22067,
                                -19.4547
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                168.11103,
                                -15.64363
                            ],
                            [
                                168.14178,
                                -15.76442
                            ],
                            [
                                168.1678,
                                -15.79995
                            ],
                            [
                                168.18865,
                                -15.91073
                            ],
                            [
                                168.18413,
                                -15.97967
                            ],
                            [
                                168.21182,
                                -16.01356
                            ],
                            [
                                168.27482,
                                -15.97131
                            ],
                            [
                                168.26733,
                                -15.84674
                            ],
                            [
                                168.18518,
                                -15.59813
                            ],
                            [
                                168.19205,
                                -15.51372
                            ],
                            [
                                168.13755,
                                -15.4943
                            ],
                            [
                                168.11103,
                                -15.64363
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                168.11952,
                                -16.68982
                            ],
                            [
                                168.17826,
                                -16.80244
                            ],
                            [
                                168.26091,
                                -16.82038
                            ],
                            [
                                168.35453,
                                -16.78299
                            ],
                            [
                                168.45452,
                                -16.83585
                            ],
                            [
                                168.46174,
                                -16.7704
                            ],
                            [
                                168.37607,
                                -16.7711
                            ],
                            [
                                168.31983,
                                -16.69242
                            ],
                            [
                                168.23655,
                                -16.66388
                            ],
                            [
                                168.19193,
                                -16.56785
                            ],
                            [
                                168.11952,
                                -16.68982
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                167.78266,
                                -15.34414
                            ],
                            [
                                167.67839,
                                -15.42042
                            ],
                            [
                                167.7084,
                                -15.4687
                            ],
                            [
                                167.85191,
                                -15.46779
                            ],
                            [
                                167.93028,
                                -15.39421
                            ],
                            [
                                167.99201,
                                -15.29316
                            ],
                            [
                                167.95838,
                                -15.27516
                            ],
                            [
                                167.81661,
                                -15.31828
                            ],
                            [
                                167.78266,
                                -15.34414
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                167.38075,
                                -13.83346
                            ],
                            [
                                167.43446,
                                -13.90439
                            ],
                            [
                                167.54523,
                                -13.9012
                            ],
                            [
                                167.54613,
                                -13.80422
                            ],
                            [
                                167.47646,
                                -13.71498
                            ],
                            [
                                167.38596,
                                -13.77808
                            ],
                            [
                                167.38075,
                                -13.83346
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                167.41625,
                                -14.3508
                            ],
                            [
                                167.53996,
                                -14.37184
                            ],
                            [
                                167.57495,
                                -14.35402
                            ],
                            [
                                167.60864,
                                -14.2691
                            ],
                            [
                                167.59284,
                                -14.217
                            ],
                            [
                                167.52064,
                                -14.20071
                            ],
                            [
                                167.43509,
                                -14.22708
                            ],
                            [
                                167.41625,
                                -14.3508
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                168.0392,
                                -14.90414
                            ],
                            [
                                168.08004,
                                -15.10441
                            ],
                            [
                                168.10921,
                                -15.17697
                            ],
                            [
                                168.11917,
                                -15.32996
                            ],
                            [
                                168.18161,
                                -15.35778
                            ],
                            [
                                168.17036,
                                -15.18357
                            ],
                            [
                                168.08145,
                                -14.90433
                            ],
                            [
                                168.0392,
                                -14.90414
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                167.08595,
                                -15.67463
                            ],
                            [
                                167.18975,
                                -15.74679
                            ],
                            [
                                167.2366,
                                -15.74508
                            ],
                            [
                                167.24993,
                                -15.6424
                            ],
                            [
                                167.11758,
                                -15.62862
                            ],
                            [
                                167.08595,
                                -15.67463
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                169.74234,
                                -20.18544
                            ],
                            [
                                169.76954,
                                -20.23238
                            ],
                            [
                                169.87015,
                                -20.24721
                            ],
                            [
                                169.90251,
                                -20.19251
                            ],
                            [
                                169.83939,
                                -20.13636
                            ],
                            [
                                169.75719,
                                -20.14511
                            ],
                            [
                                169.74234,
                                -20.18544
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                167.12563,
                                -15.59813
                            ],
                            [
                                167.21548,
                                -15.60737
                            ],
                            [
                                167.17753,
                                -15.53894
                            ],
                            [
                                167.12563,
                                -15.59813
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "VEN",
                "Country": "Venezuela",
                "Total_3GHG": 0.63,
                "Total_3GHG_timeseries": [
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.002,
                    0.0021,
                    0.0023,
                    0.0024,
                    0.0026,
                    0.0028,
                    0.0029,
                    0.0031,
                    0.0033,
                    0.0034,
                    0.0036,
                    0.0038,
                    0.0039,
                    0.0041,
                    0.0043,
                    0.0045,
                    0.0047,
                    0.0049,
                    0.0051,
                    0.0052,
                    0.0054,
                    0.0056,
                    0.0057,
                    0.0059,
                    0.006,
                    0.0062,
                    0.0065,
                    0.0067,
                    0.0067,
                    0.0069,
                    0.0071,
                    0.0072,
                    0.0072,
                    0.0072,
                    0.0072,
                    0.0072,
                    0.0072,
                    0.0071,
                    0.0071,
                    0.007,
                    0.0069,
                    0.0068,
                    0.0067,
                    0.0066,
                    0.0066,
                    0.0064,
                    0.0062,
                    0.0061,
                    0.0061,
                    0.0059,
                    0.0059,
                    0.0058,
                    0.0058,
                    0.0058,
                    0.0058,
                    0.0058,
                    0.0059,
                    0.0059,
                    0.006,
                    0.0061,
                    0.0062,
                    0.0063,
                    0.0064,
                    0.0065,
                    0.0066,
                    0.0068,
                    0.0069,
                    0.0071,
                    0.0073,
                    0.0074,
                    0.0076,
                    0.0078,
                    0.0079,
                    0.0081,
                    0.0082,
                    0.0084,
                    0.0086,
                    0.0087,
                    0.0089,
                    0.009,
                    0.0092,
                    0.0093,
                    0.0095,
                    0.0097,
                    0.0098,
                    0.0099,
                    0.0101,
                    0.0101,
                    0.0102,
                    0.0102,
                    0.0102,
                    0.0103,
                    0.0103
                ],
                "Fossil_3GHG": 0.55,
                "Fossil_3GHG_timeseries": [
                    3.1491e-07,
                    6.365e-07,
                    9.6492e-07,
                    1.3003e-06,
                    1.6429e-06,
                    1.9927e-06,
                    2.35e-06,
                    2.7149e-06,
                    3.0816e-06,
                    3.4501e-06,
                    3.8148e-06,
                    4.1757e-06,
                    4.5383e-06,
                    4.8971e-06,
                    5.2523e-06,
                    5.6039e-06,
                    5.9519e-06,
                    6.2964e-06,
                    6.6374e-06,
                    6.975e-06,
                    7.3102e-06,
                    7.6437e-06,
                    7.976e-06,
                    8.3073e-06,
                    8.6384e-06,
                    8.9694e-06,
                    9.3003e-06,
                    9.6311e-06,
                    9.9672e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0009,
                    0.001,
                    0.0012,
                    0.0013,
                    0.0015,
                    0.0016,
                    0.0018,
                    0.0019,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0029,
                    0.003,
                    0.0032,
                    0.0034,
                    0.0035,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0044,
                    0.0045,
                    0.0047,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.005,
                    0.0049,
                    0.0049,
                    0.0049,
                    0.0049,
                    0.0048,
                    0.0047,
                    0.0046,
                    0.0045,
                    0.0044,
                    0.0042,
                    0.0041,
                    0.004,
                    0.0039,
                    0.0037,
                    0.0035,
                    0.0033,
                    0.0032,
                    0.0031,
                    0.003,
                    0.0029,
                    0.0029,
                    0.0028,
                    0.0028,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0055,
                    0.0056,
                    0.0057,
                    0.0058,
                    0.0058,
                    0.0058,
                    0.0058,
                    0.0058,
                    0.0058
                ],
                "Land_3GHG": 0.78,
                "Land_3GHG_timeseries": [
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.004,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0045,
                    0.0045
                ],
                "Total_CO2": 0.56,
                "Total_CO2_timeseries": [
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0055,
                    0.0056,
                    0.0057,
                    0.0058,
                    0.0059,
                    0.006,
                    0.0061,
                    0.0061,
                    0.0062,
                    0.0063,
                    0.0063,
                    0.0063,
                    0.0064
                ],
                "Fossil_CO2": 0.44,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    1.65e-09,
                    3.3e-09,
                    3.3e-09,
                    3.3e-09,
                    3.3e-09,
                    3.3e-09,
                    9.9e-09,
                    2.31e-08,
                    4.62e-08,
                    8.25e-08,
                    1.188e-07,
                    2.1615e-07,
                    3.1185e-07,
                    3.795e-07,
                    4.521e-07,
                    5.445e-07,
                    7.4745e-07,
                    9.207e-07,
                    1.2243e-06,
                    1.7061e-06,
                    2.1632e-06,
                    3.0195e-06,
                    3.8973e-06,
                    3.9088e-06,
                    3.9105e-06,
                    5.6249e-06,
                    6.8954e-06,
                    9.2483e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0034
                ],
                "Land_CO2": 0.81,
                "Land_CO2_timeseries": [
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029
                ],
                "Total_CH4": 0.86,
                "Total_CH4_timeseries": [
                    1.5805e-06,
                    3.1962e-06,
                    4.8471e-06,
                    6.5336e-06,
                    8.2556e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0013,
                    0.0014,
                    0.0016,
                    0.0017,
                    0.0019,
                    0.002,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0026,
                    0.0027,
                    0.0029,
                    0.003,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0046,
                    0.0048,
                    0.0048,
                    0.0049,
                    0.0048,
                    0.0048,
                    0.0048,
                    0.0047,
                    0.0046,
                    0.0045,
                    0.0044,
                    0.0043,
                    0.0042,
                    0.004,
                    0.0039,
                    0.0038,
                    0.0036,
                    0.0034,
                    0.0032,
                    0.003,
                    0.0029,
                    0.0027,
                    0.0026,
                    0.0025,
                    0.0025,
                    0.0024,
                    0.0023,
                    0.0023,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0037,
                    0.0036,
                    0.0036
                ],
                "Fossil_CH4": 0.88,
                "Fossil_CH4_timeseries": [
                    2.8132e-07,
                    5.6893e-07,
                    8.6298e-07,
                    1.1636e-06,
                    1.471e-06,
                    1.7854e-06,
                    2.1068e-06,
                    2.4355e-06,
                    2.7657e-06,
                    3.0974e-06,
                    3.4251e-06,
                    3.7487e-06,
                    4.0736e-06,
                    4.3945e-06,
                    4.7115e-06,
                    5.0247e-06,
                    5.334e-06,
                    5.6395e-06,
                    5.9413e-06,
                    6.2393e-06,
                    6.5346e-06,
                    6.8276e-06,
                    7.1186e-06,
                    7.4079e-06,
                    7.696e-06,
                    7.9831e-06,
                    8.2693e-06,
                    8.5546e-06,
                    8.8445e-06,
                    9.1391e-06,
                    9.443e-06,
                    9.7561e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0008,
                    0.0009,
                    0.001,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0016,
                    0.0017,
                    0.0019,
                    0.002,
                    0.0022,
                    0.0023,
                    0.0024,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.003,
                    0.0031,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0044,
                    0.0043,
                    0.0045,
                    0.0045,
                    0.0045,
                    0.0045,
                    0.0044,
                    0.0044,
                    0.0043,
                    0.0042,
                    0.0041,
                    0.004,
                    0.0038,
                    0.0037,
                    0.0035,
                    0.0034,
                    0.0032,
                    0.0031,
                    0.0029,
                    0.0026,
                    0.0024,
                    0.0023,
                    0.0021,
                    0.002,
                    0.0019,
                    0.0018,
                    0.0017,
                    0.0016,
                    0.0015,
                    0.0015,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0023,
                    0.0023
                ],
                "Land_CH4": 0.84,
                "Land_CH4_timeseries": [
                    1.2992e-06,
                    2.6272e-06,
                    3.9841e-06,
                    5.3699e-06,
                    6.7846e-06,
                    8.2281e-06,
                    9.7005e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013
                ],
                "Total_N2O": 0.37,
                "Total_N2O_timeseries": [
                    5.8767e-08,
                    1.1844e-07,
                    1.7898e-07,
                    2.4036e-07,
                    3.0253e-07,
                    3.6543e-07,
                    4.2899e-07,
                    4.9313e-07,
                    5.5777e-07,
                    6.228e-07,
                    6.8815e-07,
                    7.5382e-07,
                    8.1979e-07,
                    8.8605e-07,
                    9.526e-07,
                    1.0194e-06,
                    1.0866e-06,
                    1.154e-06,
                    1.2218e-06,
                    1.2899e-06,
                    1.3588e-06,
                    1.4296e-06,
                    1.5028e-06,
                    1.579e-06,
                    1.6585e-06,
                    1.7414e-06,
                    1.8274e-06,
                    1.9163e-06,
                    2.0074e-06,
                    2.1e-06,
                    2.1935e-06,
                    2.2879e-06,
                    2.3831e-06,
                    2.4789e-06,
                    2.5754e-06,
                    2.6725e-06,
                    2.7702e-06,
                    2.8685e-06,
                    2.9676e-06,
                    3.0926e-06,
                    3.2191e-06,
                    3.3484e-06,
                    3.4816e-06,
                    3.6196e-06,
                    3.7632e-06,
                    3.9132e-06,
                    4.0703e-06,
                    4.2348e-06,
                    4.4071e-06,
                    4.5876e-06,
                    4.7791e-06,
                    4.9867e-06,
                    5.2138e-06,
                    5.4629e-06,
                    5.7348e-06,
                    6.0292e-06,
                    6.3446e-06,
                    6.6779e-06,
                    7.0249e-06,
                    7.38e-06,
                    7.74e-06,
                    8.1046e-06,
                    8.4734e-06,
                    8.8463e-06,
                    9.2227e-06,
                    9.6025e-06,
                    9.9851e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_N2O": 0.19,
                "Fossil_N2O_timeseries": [
                    3.3585e-08,
                    6.7568e-08,
                    1.0194e-07,
                    1.367e-07,
                    1.7184e-07,
                    2.0734e-07,
                    2.4319e-07,
                    2.7937e-07,
                    3.1586e-07,
                    3.5265e-07,
                    3.8972e-07,
                    4.2706e-07,
                    4.6468e-07,
                    5.0258e-07,
                    5.4074e-07,
                    5.7918e-07,
                    6.1789e-07,
                    6.5688e-07,
                    6.9614e-07,
                    7.3569e-07,
                    7.7563e-07,
                    8.1615e-07,
                    8.5739e-07,
                    8.9946e-07,
                    9.4242e-07,
                    9.8627e-07,
                    1.031e-06,
                    1.0765e-06,
                    1.1227e-06,
                    1.1694e-06,
                    1.2166e-06,
                    1.2641e-06,
                    1.3119e-06,
                    1.3602e-06,
                    1.4087e-06,
                    1.4577e-06,
                    1.5069e-06,
                    1.5565e-06,
                    1.6065e-06,
                    1.6574e-06,
                    1.7088e-06,
                    1.7608e-06,
                    1.8133e-06,
                    1.8664e-06,
                    1.9201e-06,
                    1.9744e-06,
                    2.0293e-06,
                    2.0849e-06,
                    2.1411e-06,
                    2.1981e-06,
                    2.2557e-06,
                    2.3141e-06,
                    2.3733e-06,
                    2.4335e-06,
                    2.4945e-06,
                    2.5564e-06,
                    2.6192e-06,
                    2.6829e-06,
                    2.7475e-06,
                    2.813e-06,
                    2.8792e-06,
                    2.9463e-06,
                    3.0141e-06,
                    3.0828e-06,
                    3.1522e-06,
                    3.2224e-06,
                    3.2934e-06,
                    3.3651e-06,
                    3.4377e-06,
                    3.511e-06,
                    3.5852e-06,
                    3.6601e-06,
                    3.7358e-06,
                    3.8123e-06,
                    3.8896e-06,
                    3.9677e-06,
                    4.0466e-06,
                    4.1263e-06,
                    4.2068e-06,
                    4.2881e-06,
                    4.3703e-06,
                    4.4534e-06,
                    4.5374e-06,
                    4.6223e-06,
                    4.7083e-06,
                    4.7953e-06,
                    4.8834e-06,
                    4.9726e-06,
                    5.0631e-06,
                    5.1547e-06,
                    5.248e-06,
                    5.3434e-06,
                    5.4414e-06,
                    5.5422e-06,
                    5.6462e-06,
                    5.7536e-06,
                    5.8643e-06,
                    5.9783e-06,
                    6.0954e-06,
                    6.2156e-06,
                    6.339e-06,
                    6.4668e-06,
                    6.5997e-06,
                    6.7383e-06,
                    6.8831e-06,
                    7.0345e-06,
                    7.1927e-06,
                    7.3575e-06,
                    7.529e-06,
                    7.7067e-06,
                    7.8904e-06,
                    8.0796e-06,
                    8.2744e-06,
                    8.4749e-06,
                    8.6815e-06,
                    8.8947e-06,
                    9.1153e-06,
                    9.3442e-06,
                    9.5825e-06,
                    9.8498e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.44,
                "Land_N2O_timeseries": [
                    2.5182e-08,
                    5.0868e-08,
                    7.7036e-08,
                    1.0366e-07,
                    1.3069e-07,
                    1.5809e-07,
                    1.858e-07,
                    2.1377e-07,
                    2.4191e-07,
                    2.7015e-07,
                    2.9843e-07,
                    3.2676e-07,
                    3.5511e-07,
                    3.8347e-07,
                    4.1186e-07,
                    4.4026e-07,
                    4.6869e-07,
                    4.9714e-07,
                    5.2563e-07,
                    5.5417e-07,
                    5.8319e-07,
                    6.1342e-07,
                    6.4542e-07,
                    6.7958e-07,
                    7.1613e-07,
                    7.5511e-07,
                    7.9641e-07,
                    8.3975e-07,
                    8.8467e-07,
                    9.3055e-07,
                    9.7698e-07,
                    1.0239e-06,
                    1.0711e-06,
                    1.1187e-06,
                    1.1666e-06,
                    1.2148e-06,
                    1.2633e-06,
                    1.312e-06,
                    1.3611e-06,
                    1.4352e-06,
                    1.5103e-06,
                    1.5876e-06,
                    1.6683e-06,
                    1.7531e-06,
                    1.8431e-06,
                    1.9388e-06,
                    2.0409e-06,
                    2.1498e-06,
                    2.266e-06,
                    2.3895e-06,
                    2.5235e-06,
                    2.6726e-06,
                    2.8405e-06,
                    3.0294e-06,
                    3.2403e-06,
                    3.4728e-06,
                    3.7253e-06,
                    3.9949e-06,
                    4.2773e-06,
                    4.5671e-06,
                    4.8608e-06,
                    5.1583e-06,
                    5.4593e-06,
                    5.7635e-06,
                    6.0705e-06,
                    6.3801e-06,
                    6.6917e-06,
                    7.005e-06,
                    7.3195e-06,
                    7.6346e-06,
                    7.9493e-06,
                    8.262e-06,
                    8.5714e-06,
                    8.8769e-06,
                    9.1779e-06,
                    9.4746e-06,
                    9.7672e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -60.73177,
                                5.19614
                            ],
                            [
                                -61.37058,
                                5.91734
                            ],
                            [
                                -61.38373,
                                5.9789
                            ],
                            [
                                -61.25876,
                                6.1224
                            ],
                            [
                                -61.19476,
                                6.1448
                            ],
                            [
                                -61.11674,
                                6.20258
                            ],
                            [
                                -61.12205,
                                6.26456
                            ],
                            [
                                -61.16905,
                                6.32559
                            ],
                            [
                                -61.14484,
                                6.43887
                            ],
                            [
                                -61.21269,
                                6.58537
                            ],
                            [
                                -61.1448,
                                6.7155
                            ],
                            [
                                -61.06436,
                                6.74629
                            ],
                            [
                                -60.94523,
                                6.73838
                            ],
                            [
                                -60.90907,
                                6.76309
                            ],
                            [
                                -60.91508,
                                6.82256
                            ],
                            [
                                -60.83555,
                                6.80181
                            ],
                            [
                                -60.79388,
                                6.81504
                            ],
                            [
                                -60.73241,
                                6.77612
                            ],
                            [
                                -60.63894,
                                6.84922
                            ],
                            [
                                -60.49633,
                                6.89702
                            ],
                            [
                                -60.39909,
                                6.96388
                            ],
                            [
                                -60.30237,
                                7.05706
                            ],
                            [
                                -60.2803,
                                7.11981
                            ],
                            [
                                -60.44702,
                                7.20122
                            ],
                            [
                                -60.52577,
                                7.13536
                            ],
                            [
                                -60.63084,
                                7.23248
                            ],
                            [
                                -60.58672,
                                7.331
                            ],
                            [
                                -60.65137,
                                7.44934
                            ],
                            [
                                -60.69516,
                                7.47359
                            ],
                            [
                                -60.71206,
                                7.5366
                            ],
                            [
                                -60.64651,
                                7.57203
                            ],
                            [
                                -60.57083,
                                7.70902
                            ],
                            [
                                -60.57689,
                                7.73556
                            ],
                            [
                                -60.52286,
                                7.82792
                            ],
                            [
                                -60.35325,
                                7.84074
                            ],
                            [
                                -60.22431,
                                7.96617
                            ],
                            [
                                -60.1122,
                                8.02943
                            ],
                            [
                                -60.04635,
                                8.02583
                            ],
                            [
                                -59.99831,
                                8.06875
                            ],
                            [
                                -59.97984,
                                8.17221
                            ],
                            [
                                -59.9349,
                                8.21698
                            ],
                            [
                                -59.84235,
                                8.23421
                            ],
                            [
                                -59.82444,
                                8.31939
                            ],
                            [
                                -59.99402,
                                8.53343
                            ],
                            [
                                -60.0481,
                                8.57927
                            ],
                            [
                                -60.15546,
                                8.61856
                            ],
                            [
                                -60.39875,
                                8.62828
                            ],
                            [
                                -60.45664,
                                8.52953
                            ],
                            [
                                -60.58743,
                                8.5395
                            ],
                            [
                                -60.72153,
                                8.60429
                            ],
                            [
                                -60.78589,
                                8.58859
                            ],
                            [
                                -60.82989,
                                8.62839
                            ],
                            [
                                -60.78993,
                                8.72342
                            ],
                            [
                                -60.69113,
                                8.78846
                            ],
                            [
                                -60.71049,
                                8.81899
                            ],
                            [
                                -60.81281,
                                8.8636
                            ],
                            [
                                -60.8454,
                                8.90406
                            ],
                            [
                                -60.77397,
                                8.93488
                            ],
                            [
                                -60.78503,
                                9.02169
                            ],
                            [
                                -60.81415,
                                9.08197
                            ],
                            [
                                -60.76111,
                                9.13204
                            ],
                            [
                                -60.77372,
                                9.2297
                            ],
                            [
                                -60.91745,
                                9.18105
                            ],
                            [
                                -60.7893,
                                9.31701
                            ],
                            [
                                -60.79635,
                                9.36766
                            ],
                            [
                                -60.88316,
                                9.47057
                            ],
                            [
                                -61.01214,
                                9.53897
                            ],
                            [
                                -61.21228,
                                9.60033
                            ],
                            [
                                -61.44118,
                                9.81752
                            ],
                            [
                                -61.54987,
                                9.85217
                            ],
                            [
                                -61.62949,
                                9.79819
                            ],
                            [
                                -61.79823,
                                9.81347
                            ],
                            [
                                -61.80828,
                                9.76861
                            ],
                            [
                                -61.97011,
                                9.91065
                            ],
                            [
                                -62.09392,
                                9.98548
                            ],
                            [
                                -62.19217,
                                10.00168
                            ],
                            [
                                -62.19006,
                                9.897
                            ],
                            [
                                -62.30361,
                                9.87376
                            ],
                            [
                                -62.37169,
                                9.88408
                            ],
                            [
                                -62.42897,
                                9.93912
                            ],
                            [
                                -62.42262,
                                9.97637
                            ],
                            [
                                -62.50173,
                                10.17321
                            ],
                            [
                                -62.58801,
                                10.22695
                            ],
                            [
                                -62.6639,
                                10.20546
                            ],
                            [
                                -62.70143,
                                10.35475
                            ],
                            [
                                -62.79117,
                                10.41435
                            ],
                            [
                                -62.83647,
                                10.50498
                            ],
                            [
                                -62.77843,
                                10.55955
                            ],
                            [
                                -62.66041,
                                10.57659
                            ],
                            [
                                -62.43682,
                                10.5368
                            ],
                            [
                                -62.31597,
                                10.54804
                            ],
                            [
                                -62.24683,
                                10.63152
                            ],
                            [
                                -61.96013,
                                10.64511
                            ],
                            [
                                -61.89048,
                                10.68052
                            ],
                            [
                                -61.87518,
                                10.72076
                            ],
                            [
                                -61.99602,
                                10.72122
                            ],
                            [
                                -62.0604,
                                10.70286
                            ],
                            [
                                -62.28351,
                                10.69285
                            ],
                            [
                                -62.34279,
                                10.71046
                            ],
                            [
                                -62.60483,
                                10.74065
                            ],
                            [
                                -62.71264,
                                10.76153
                            ],
                            [
                                -62.90512,
                                10.6944
                            ],
                            [
                                -63.00218,
                                10.71815
                            ],
                            [
                                -63.12095,
                                10.70282
                            ],
                            [
                                -63.15924,
                                10.71492
                            ],
                            [
                                -63.28095,
                                10.66612
                            ],
                            [
                                -63.38797,
                                10.68755
                            ],
                            [
                                -63.41253,
                                10.66436
                            ],
                            [
                                -63.53421,
                                10.6282
                            ],
                            [
                                -63.67834,
                                10.6414
                            ],
                            [
                                -63.78597,
                                10.67329
                            ],
                            [
                                -63.9169,
                                10.62651
                            ],
                            [
                                -64.05522,
                                10.64966
                            ],
                            [
                                -64.13951,
                                10.61792
                            ],
                            [
                                -64.26313,
                                10.6605
                            ],
                            [
                                -64.29368,
                                10.62915
                            ],
                            [
                                -64.23217,
                                10.50857
                            ],
                            [
                                -64.20341,
                                10.55039
                            ],
                            [
                                -64.13282,
                                10.57727
                            ],
                            [
                                -63.95953,
                                10.57932
                            ],
                            [
                                -63.9089,
                                10.55502
                            ],
                            [
                                -63.82179,
                                10.54966
                            ],
                            [
                                -63.7376,
                                10.49664
                            ],
                            [
                                -63.78948,
                                10.44351
                            ],
                            [
                                -63.95619,
                                10.45166
                            ],
                            [
                                -64.02231,
                                10.4385
                            ],
                            [
                                -64.11307,
                                10.47459
                            ],
                            [
                                -64.18244,
                                10.47765
                            ],
                            [
                                -64.22383,
                                10.41827
                            ],
                            [
                                -64.39102,
                                10.37909
                            ],
                            [
                                -64.40231,
                                10.28569
                            ],
                            [
                                -64.4893,
                                10.24321
                            ],
                            [
                                -64.6029,
                                10.25461
                            ],
                            [
                                -64.69657,
                                10.20014
                            ],
                            [
                                -64.71915,
                                10.12935
                            ],
                            [
                                -64.76185,
                                10.10079
                            ],
                            [
                                -64.8582,
                                10.08524
                            ],
                            [
                                -64.9497,
                                10.09549
                            ],
                            [
                                -65.05943,
                                10.06258
                            ],
                            [
                                -65.21853,
                                10.10187
                            ],
                            [
                                -65.45356,
                                10.14618
                            ],
                            [
                                -65.62281,
                                10.19803
                            ],
                            [
                                -65.7742,
                                10.2572
                            ],
                            [
                                -65.91875,
                                10.33505
                            ],
                            [
                                -66.06568,
                                10.44741
                            ],
                            [
                                -66.10688,
                                10.4962
                            ],
                            [
                                -66.0496,
                                10.56933
                            ],
                            [
                                -66.17313,
                                10.61025
                            ],
                            [
                                -66.23841,
                                10.64809
                            ],
                            [
                                -66.34828,
                                10.60799
                            ],
                            [
                                -66.50127,
                                10.63123
                            ],
                            [
                                -66.84877,
                                10.6199
                            ],
                            [
                                -66.94254,
                                10.6005
                            ],
                            [
                                -67.02224,
                                10.61236
                            ],
                            [
                                -67.18523,
                                10.55649
                            ],
                            [
                                -67.39637,
                                10.5327
                            ],
                            [
                                -67.4738,
                                10.53439
                            ],
                            [
                                -67.66249,
                                10.49823
                            ],
                            [
                                -67.70666,
                                10.50129
                            ],
                            [
                                -67.90493,
                                10.46809
                            ],
                            [
                                -67.98858,
                                10.48887
                            ],
                            [
                                -68.10725,
                                10.4837
                            ],
                            [
                                -68.17114,
                                10.50726
                            ],
                            [
                                -68.26859,
                                10.62688
                            ],
                            [
                                -68.32036,
                                10.75641
                            ],
                            [
                                -68.32187,
                                10.81461
                            ],
                            [
                                -68.21929,
                                10.87451
                            ],
                            [
                                -68.3126,
                                10.99429
                            ],
                            [
                                -68.38467,
                                11.14038
                            ],
                            [
                                -68.45051,
                                11.1785
                            ],
                            [
                                -68.52948,
                                11.26186
                            ],
                            [
                                -68.60303,
                                11.2843
                            ],
                            [
                                -68.66491,
                                11.347
                            ],
                            [
                                -68.76618,
                                11.37455
                            ],
                            [
                                -68.82992,
                                11.44014
                            ],
                            [
                                -69.05039,
                                11.44116
                            ],
                            [
                                -69.1046,
                                11.48998
                            ],
                            [
                                -69.28509,
                                11.53064
                            ],
                            [
                                -69.3672,
                                11.48437
                            ],
                            [
                                -69.51704,
                                11.50451
                            ],
                            [
                                -69.57611,
                                11.45872
                            ],
                            [
                                -69.62595,
                                11.47063
                            ],
                            [
                                -69.71482,
                                11.58961
                            ],
                            [
                                -69.78958,
                                11.78292
                            ],
                            [
                                -69.82306,
                                11.99912
                            ],
                            [
                                -69.89886,
                                12.14198
                            ],
                            [
                                -70.0217,
                                12.19519
                            ],
                            [
                                -70.14886,
                                12.10804
                            ],
                            [
                                -70.19788,
                                12.10385
                            ],
                            [
                                -70.2898,
                                11.90588
                            ],
                            [
                                -70.27732,
                                11.821
                            ],
                            [
                                -70.20551,
                                11.72783
                            ],
                            [
                                -70.23484,
                                11.63256
                            ],
                            [
                                -70.18496,
                                11.60562
                            ],
                            [
                                -69.95276,
                                11.66383
                            ],
                            [
                                -69.80483,
                                11.68903
                            ],
                            [
                                -69.72801,
                                11.49238
                            ],
                            [
                                -69.80937,
                                11.42186
                            ],
                            [
                                -69.94943,
                                11.51784
                            ],
                            [
                                -70.04435,
                                11.51043
                            ],
                            [
                                -70.04284,
                                11.44601
                            ],
                            [
                                -70.14847,
                                11.41661
                            ],
                            [
                                -70.1837,
                                11.36708
                            ],
                            [
                                -70.28396,
                                11.35329
                            ],
                            [
                                -70.44291,
                                11.28073
                            ],
                            [
                                -70.48432,
                                11.28857
                            ],
                            [
                                -70.55434,
                                11.23131
                            ],
                            [
                                -70.71151,
                                11.22499
                            ],
                            [
                                -70.84578,
                                11.19312
                            ],
                            [
                                -71.16029,
                                11.01798
                            ],
                            [
                                -71.33426,
                                10.96076
                            ],
                            [
                                -71.43577,
                                10.96702
                            ],
                            [
                                -71.43439,
                                10.82244
                            ],
                            [
                                -71.45386,
                                10.79218
                            ],
                            [
                                -71.58363,
                                10.7945
                            ],
                            [
                                -71.5255,
                                10.72385
                            ],
                            [
                                -71.5372,
                                10.54979
                            ],
                            [
                                -71.46078,
                                10.48646
                            ],
                            [
                                -71.47566,
                                10.39237
                            ],
                            [
                                -71.43065,
                                10.35361
                            ],
                            [
                                -71.34712,
                                10.20267
                            ],
                            [
                                -71.29448,
                                10.16998
                            ],
                            [
                                -71.24131,
                                10.0753
                            ],
                            [
                                -71.20985,
                                9.97727
                            ],
                            [
                                -71.15516,
                                9.95369
                            ],
                            [
                                -71.07781,
                                9.83702
                            ],
                            [
                                -71.08739,
                                9.79713
                            ],
                            [
                                -71.03801,
                                9.74046
                            ],
                            [
                                -71.06155,
                                9.59552
                            ],
                            [
                                -71.08429,
                                9.5445
                            ],
                            [
                                -71.06569,
                                9.45859
                            ],
                            [
                                -71.06028,
                                9.31807
                            ],
                            [
                                -71.20155,
                                9.2178
                            ],
                            [
                                -71.23778,
                                9.14855
                            ],
                            [
                                -71.3401,
                                9.09001
                            ],
                            [
                                -71.53716,
                                9.03779
                            ],
                            [
                                -71.6965,
                                9.06032
                            ],
                            [
                                -71.75574,
                                9.12541
                            ],
                            [
                                -71.74131,
                                9.15467
                            ],
                            [
                                -71.78845,
                                9.23631
                            ],
                            [
                                -71.74502,
                                9.27466
                            ],
                            [
                                -71.71647,
                                9.34437
                            ],
                            [
                                -71.80738,
                                9.37716
                            ],
                            [
                                -71.80825,
                                9.4043
                            ],
                            [
                                -71.92113,
                                9.47346
                            ],
                            [
                                -71.96455,
                                9.52357
                            ],
                            [
                                -71.9718,
                                9.59908
                            ],
                            [
                                -72.09742,
                                9.75843
                            ],
                            [
                                -72.12467,
                                9.82883
                            ],
                            [
                                -72.03769,
                                9.94066
                            ],
                            [
                                -71.97152,
                                10.11196
                            ],
                            [
                                -71.92837,
                                10.11267
                            ],
                            [
                                -71.86953,
                                10.16157
                            ],
                            [
                                -71.78728,
                                10.32843
                            ],
                            [
                                -71.63316,
                                10.44204
                            ],
                            [
                                -71.61317,
                                10.63295
                            ],
                            [
                                -71.59113,
                                10.70653
                            ],
                            [
                                -71.67374,
                                10.79007
                            ],
                            [
                                -71.70606,
                                10.86157
                            ],
                            [
                                -71.73727,
                                11.01658
                            ],
                            [
                                -71.72336,
                                11.05849
                            ],
                            [
                                -71.81265,
                                11.13538
                            ],
                            [
                                -71.87555,
                                11.21894
                            ],
                            [
                                -71.92685,
                                11.31722
                            ],
                            [
                                -71.96028,
                                11.43035
                            ],
                            [
                                -71.9678,
                                11.52734
                            ],
                            [
                                -71.9406,
                                11.6
                            ],
                            [
                                -71.81168,
                                11.64361
                            ],
                            [
                                -71.63473,
                                11.68722
                            ],
                            [
                                -71.44419,
                                11.72066
                            ],
                            [
                                -71.34655,
                                11.79007
                            ],
                            [
                                -71.32407,
                                11.84566
                            ],
                            [
                                -71.38483,
                                11.83033
                            ],
                            [
                                -71.38615,
                                11.81418
                            ],
                            [
                                -71.77776,
                                11.69445
                            ],
                            [
                                -71.966,
                                11.65005
                            ],
                            [
                                -72.23779,
                                11.15236
                            ],
                            [
                                -72.34198,
                                11.15711
                            ],
                            [
                                -72.46744,
                                11.1109
                            ],
                            [
                                -72.5612,
                                10.93656
                            ],
                            [
                                -72.64322,
                                10.88151
                            ],
                            [
                                -72.68082,
                                10.77462
                            ],
                            [
                                -72.75061,
                                10.6426
                            ],
                            [
                                -72.82199,
                                10.57278
                            ],
                            [
                                -72.84373,
                                10.49293
                            ],
                            [
                                -72.88995,
                                10.45389
                            ],
                            [
                                -72.90318,
                                10.34082
                            ],
                            [
                                -72.91455,
                                10.10901
                            ],
                            [
                                -72.9482,
                                10.06161
                            ],
                            [
                                -72.98912,
                                9.93118
                            ],
                            [
                                -72.98912,
                                9.88192
                            ],
                            [
                                -72.94791,
                                9.84188
                            ],
                            [
                                -73.05029,
                                9.68296
                            ],
                            [
                                -73.08116,
                                9.56735
                            ],
                            [
                                -73.14668,
                                9.54363
                            ],
                            [
                                -73.19477,
                                9.44165
                            ],
                            [
                                -73.23332,
                                9.41228
                            ],
                            [
                                -73.31561,
                                9.24006
                            ],
                            [
                                -73.37267,
                                9.18101
                            ],
                            [
                                -73.2527,
                                9.1651
                            ],
                            [
                                -73.17204,
                                9.18478
                            ],
                            [
                                -73.00236,
                                9.29115
                            ],
                            [
                                -72.96372,
                                9.20499
                            ],
                            [
                                -72.96938,
                                9.13874
                            ],
                            [
                                -72.92563,
                                9.0883
                            ],
                            [
                                -72.8777,
                                9.13464
                            ],
                            [
                                -72.77952,
                                9.11531
                            ],
                            [
                                -72.74255,
                                9.01063
                            ],
                            [
                                -72.65191,
                                8.62444
                            ],
                            [
                                -72.58519,
                                8.56849
                            ],
                            [
                                -72.42842,
                                8.39018
                            ],
                            [
                                -72.39442,
                                8.36342
                            ],
                            [
                                -72.39024,
                                8.26134
                            ],
                            [
                                -72.35544,
                                8.1689
                            ],
                            [
                                -72.37271,
                                8.10929
                            ],
                            [
                                -72.34622,
                                8.04967
                            ],
                            [
                                -72.41139,
                                8.03746
                            ],
                            [
                                -72.42096,
                                7.99378
                            ],
                            [
                                -72.48562,
                                7.93522
                            ],
                            [
                                -72.44967,
                                7.83108
                            ],
                            [
                                -72.47045,
                                7.7928
                            ],
                            [
                                -72.47893,
                                7.6276
                            ],
                            [
                                -72.45733,
                                7.56008
                            ],
                            [
                                -72.47947,
                                7.48629
                            ],
                            [
                                -72.43632,
                                7.40054
                            ],
                            [
                                -72.20279,
                                7.37961
                            ],
                            [
                                -72.16652,
                                7.3268
                            ],
                            [
                                -72.1713,
                                7.24865
                            ],
                            [
                                -72.03153,
                                7.02215
                            ],
                            [
                                -72.00805,
                                7.00918
                            ],
                            [
                                -71.83991,
                                7.00829
                            ],
                            [
                                -71.79687,
                                7.05682
                            ],
                            [
                                -71.6524,
                                7.05044
                            ],
                            [
                                -71.46349,
                                7.01251
                            ],
                            [
                                -71.42253,
                                7.03293
                            ],
                            [
                                -71.33265,
                                7.01321
                            ],
                            [
                                -71.13346,
                                7.02465
                            ],
                            [
                                -71.09482,
                                6.98417
                            ],
                            [
                                -70.95356,
                                6.98647
                            ],
                            [
                                -70.88699,
                                7.057
                            ],
                            [
                                -70.69208,
                                7.09078
                            ],
                            [
                                -70.63531,
                                7.06484
                            ],
                            [
                                -70.55951,
                                7.07482
                            ],
                            [
                                -70.49992,
                                7.00671
                            ],
                            [
                                -70.38663,
                                6.98006
                            ],
                            [
                                -70.3181,
                                6.93375
                            ],
                            [
                                -70.22496,
                                6.9706
                            ],
                            [
                                -70.08043,
                                6.99372
                            ],
                            [
                                -69.95808,
                                6.83005
                            ],
                            [
                                -69.4482,
                                6.11797
                            ],
                            [
                                -69.31724,
                                6.1432
                            ],
                            [
                                -69.28082,
                                6.09608
                            ],
                            [
                                -69.21758,
                                6.08906
                            ],
                            [
                                -69.10807,
                                6.1859
                            ],
                            [
                                -69.0484,
                                6.21172
                            ],
                            [
                                -68.92854,
                                6.17604
                            ],
                            [
                                -68.83235,
                                6.1817
                            ],
                            [
                                -68.67125,
                                6.13532
                            ],
                            [
                                -68.45797,
                                6.18948
                            ],
                            [
                                -68.30282,
                                6.17141
                            ],
                            [
                                -68.14504,
                                6.22322
                            ],
                            [
                                -67.97165,
                                6.21147
                            ],
                            [
                                -67.83806,
                                6.30099
                            ],
                            [
                                -67.63372,
                                6.27952
                            ],
                            [
                                -67.55298,
                                6.24951
                            ],
                            [
                                -67.47528,
                                6.19105
                            ],
                            [
                                -67.48334,
                                6.08888
                            ],
                            [
                                -67.42296,
                                6.00468
                            ],
                            [
                                -67.46355,
                                5.94877
                            ],
                            [
                                -67.57765,
                                5.8495
                            ],
                            [
                                -67.64197,
                                5.70686
                            ],
                            [
                                -67.63743,
                                5.59465
                            ],
                            [
                                -67.61455,
                                5.5334
                            ],
                            [
                                -67.65945,
                                5.46447
                            ],
                            [
                                -67.77577,
                                5.39329
                            ],
                            [
                                -67.84903,
                                5.27714
                            ],
                            [
                                -67.79729,
                                5.10139
                            ],
                            [
                                -67.79509,
                                5.04083
                            ],
                            [
                                -67.82881,
                                4.90932
                            ],
                            [
                                -67.82706,
                                4.73292
                            ],
                            [
                                -67.87712,
                                4.53273
                            ],
                            [
                                -67.83348,
                                4.49025
                            ],
                            [
                                -67.78382,
                                4.34118
                            ],
                            [
                                -67.80625,
                                4.22276
                            ],
                            [
                                -67.73494,
                                4.11414
                            ],
                            [
                                -67.67914,
                                3.919
                            ],
                            [
                                -67.62564,
                                3.77768
                            ],
                            [
                                -67.5888,
                                3.73873
                            ],
                            [
                                -67.51628,
                                3.74605
                            ],
                            [
                                -67.44797,
                                3.65857
                            ],
                            [
                                -67.38883,
                                3.4949
                            ],
                            [
                                -67.31079,
                                3.4339
                            ],
                            [
                                -67.30981,
                                3.3796
                            ],
                            [
                                -67.38492,
                                3.28881
                            ],
                            [
                                -67.85192,
                                2.87171
                            ],
                            [
                                -67.82493,
                                2.82598
                            ],
                            [
                                -67.74182,
                                2.8396
                            ],
                            [
                                -67.7135,
                                2.81289
                            ],
                            [
                                -67.61587,
                                2.81121
                            ],
                            [
                                -67.56827,
                                2.72909
                            ],
                            [
                                -67.57115,
                                2.68348
                            ],
                            [
                                -67.49527,
                                2.6708
                            ],
                            [
                                -67.47825,
                                2.62137
                            ],
                            [
                                -67.39246,
                                2.56661
                            ],
                            [
                                -67.27688,
                                2.43706
                            ],
                            [
                                -67.19235,
                                2.38697
                            ],
                            [
                                -67.17378,
                                2.34107
                            ],
                            [
                                -67.21041,
                                2.24794
                            ],
                            [
                                -67.15722,
                                2.12218
                            ],
                            [
                                -67.11346,
                                2.11056
                            ],
                            [
                                -67.11834,
                                1.9751
                            ],
                            [
                                -67.07852,
                                1.9283
                            ],
                            [
                                -66.97757,
                                1.6475
                            ],
                            [
                                -66.97465,
                                1.58725
                            ],
                            [
                                -66.93046,
                                1.48053
                            ],
                            [
                                -66.92564,
                                1.41832
                            ],
                            [
                                -66.88521,
                                1.35961
                            ],
                            [
                                -66.8936,
                                1.27432
                            ],
                            [
                                -66.86983,
                                1.22565
                            ],
                            [
                                -66.8413,
                                1.21941
                            ],
                            [
                                -66.32618,
                                0.75696
                            ],
                            [
                                -66.21861,
                                0.764
                            ],
                            [
                                -66.10022,
                                0.74564
                            ],
                            [
                                -66.06658,
                                0.78636
                            ],
                            [
                                -65.99099,
                                0.79444
                            ],
                            [
                                -65.88293,
                                0.89699
                            ],
                            [
                                -65.8645,
                                0.93573
                            ],
                            [
                                -65.76412,
                                0.97307
                            ],
                            [
                                -65.73219,
                                1.00462
                            ],
                            [
                                -65.60823,
                                1.00898
                            ],
                            [
                                -65.54265,
                                0.97018
                            ],
                            [
                                -65.50213,
                                0.85679
                            ],
                            [
                                -65.58338,
                                0.72099
                            ],
                            [
                                -65.53608,
                                0.65042
                            ],
                            [
                                -65.43398,
                                0.69973
                            ],
                            [
                                -65.3962,
                                0.76599
                            ],
                            [
                                -65.39483,
                                0.83332
                            ],
                            [
                                -65.29471,
                                0.92735
                            ],
                            [
                                -65.18646,
                                0.92725
                            ],
                            [
                                -65.16293,
                                0.98066
                            ],
                            [
                                -65.15451,
                                1.08475
                            ],
                            [
                                -65.12237,
                                1.13551
                            ],
                            [
                                -65.03395,
                                1.13512
                            ],
                            [
                                -64.94793,
                                1.20818
                            ],
                            [
                                -64.88404,
                                1.22018
                            ],
                            [
                                -64.81279,
                                1.28004
                            ],
                            [
                                -64.74419,
                                1.24458
                            ],
                            [
                                -64.59118,
                                1.33323
                            ],
                            [
                                -64.52546,
                                1.44064
                            ],
                            [
                                -64.39252,
                                1.51253
                            ],
                            [
                                -64.322,
                                1.41373
                            ],
                            [
                                -64.19849,
                                1.53141
                            ],
                            [
                                -64.09386,
                                1.61391
                            ],
                            [
                                -64.05166,
                                1.71728
                            ],
                            [
                                -64.05665,
                                1.93075
                            ],
                            [
                                -63.98065,
                                1.98667
                            ],
                            [
                                -63.91276,
                                1.99975
                            ],
                            [
                                -63.78137,
                                1.98971
                            ],
                            [
                                -63.6057,
                                2.11112
                            ],
                            [
                                -63.54393,
                                2.1309
                            ],
                            [
                                -63.40219,
                                2.14668
                            ],
                            [
                                -63.35817,
                                2.26669
                            ],
                            [
                                -63.37376,
                                2.42338
                            ],
                            [
                                -63.62242,
                                2.43518
                            ],
                            [
                                -63.69424,
                                2.45696
                            ],
                            [
                                -63.74833,
                                2.44232
                            ],
                            [
                                -63.84141,
                                2.4927
                            ],
                            [
                                -63.93337,
                                2.45793
                            ],
                            [
                                -64.03928,
                                2.47377
                            ],
                            [
                                -64.04682,
                                2.51428
                            ],
                            [
                                -63.99386,
                                2.63108
                            ],
                            [
                                -63.98799,
                                2.72476
                            ],
                            [
                                -64.01083,
                                2.80335
                            ],
                            [
                                -64.0798,
                                2.92606
                            ],
                            [
                                -64.13924,
                                2.99171
                            ],
                            [
                                -64.14731,
                                3.04158
                            ],
                            [
                                -64.21797,
                                3.12418
                            ],
                            [
                                -64.2057,
                                3.25791
                            ],
                            [
                                -64.23651,
                                3.42872
                            ],
                            [
                                -64.18358,
                                3.53944
                            ],
                            [
                                -64.19595,
                                3.60056
                            ],
                            [
                                -64.33002,
                                3.73724
                            ],
                            [
                                -64.43869,
                                3.78256
                            ],
                            [
                                -64.5349,
                                3.86102
                            ],
                            [
                                -64.56814,
                                3.92167
                            ],
                            [
                                -64.64575,
                                3.99171
                            ],
                            [
                                -64.72009,
                                4.15271
                            ],
                            [
                                -64.79256,
                                4.19226
                            ],
                            [
                                -64.79317,
                                4.2821
                            ],
                            [
                                -64.73495,
                                4.28506
                            ],
                            [
                                -64.65933,
                                4.24681
                            ],
                            [
                                -64.60763,
                                4.14614
                            ],
                            [
                                -64.54091,
                                4.12356
                            ],
                            [
                                -64.38575,
                                4.15243
                            ],
                            [
                                -64.23828,
                                4.14464
                            ],
                            [
                                -64.13018,
                                4.11145
                            ],
                            [
                                -64.09332,
                                4.04472
                            ],
                            [
                                -64.05749,
                                3.92466
                            ],
                            [
                                -64.01467,
                                3.88594
                            ],
                            [
                                -63.9547,
                                3.89269
                            ],
                            [
                                -63.84305,
                                3.9586
                            ],
                            [
                                -63.78833,
                                3.93377
                            ],
                            [
                                -63.6553,
                                3.95378
                            ],
                            [
                                -63.60569,
                                3.94094
                            ],
                            [
                                -63.53887,
                                3.87291
                            ],
                            [
                                -63.45325,
                                3.87416
                            ],
                            [
                                -63.42587,
                                3.96033
                            ],
                            [
                                -63.35552,
                                3.96406
                            ],
                            [
                                -63.22588,
                                3.89827
                            ],
                            [
                                -63.20509,
                                3.81753
                            ],
                            [
                                -63.12005,
                                3.80534
                            ],
                            [
                                -63.07621,
                                3.76935
                            ],
                            [
                                -63.06872,
                                3.68835
                            ],
                            [
                                -62.95714,
                                3.61175
                            ],
                            [
                                -62.83814,
                                3.73384
                            ],
                            [
                                -62.76783,
                                3.68826
                            ],
                            [
                                -62.7286,
                                3.73112
                            ],
                            [
                                -62.77996,
                                3.90446
                            ],
                            [
                                -62.72977,
                                4.03792
                            ],
                            [
                                -62.66888,
                                4.04612
                            ],
                            [
                                -62.55568,
                                4.02051
                            ],
                            [
                                -62.52977,
                                4.12744
                            ],
                            [
                                -62.46317,
                                4.17293
                            ],
                            [
                                -62.39932,
                                4.17938
                            ],
                            [
                                -62.14207,
                                4.08281
                            ],
                            [
                                -62.06292,
                                4.15599
                            ],
                            [
                                -62.00708,
                                4.17257
                            ],
                            [
                                -61.93691,
                                4.13234
                            ],
                            [
                                -61.83839,
                                4.15974
                            ],
                            [
                                -61.79249,
                                4.22679
                            ],
                            [
                                -61.65376,
                                4.26094
                            ],
                            [
                                -61.55658,
                                4.25419
                            ],
                            [
                                -61.50973,
                                4.31437
                            ],
                            [
                                -61.51063,
                                4.40466
                            ],
                            [
                                -61.45437,
                                4.43748
                            ],
                            [
                                -61.34409,
                                4.41896
                            ],
                            [
                                -61.27949,
                                4.46746
                            ],
                            [
                                -61.29245,
                                4.53945
                            ],
                            [
                                -61.18575,
                                4.5178
                            ],
                            [
                                -61.1469,
                                4.48331
                            ],
                            [
                                -61.09242,
                                4.52247
                            ],
                            [
                                -60.99674,
                                4.51749
                            ],
                            [
                                -60.93202,
                                4.58504
                            ],
                            [
                                -60.94587,
                                4.6564
                            ],
                            [
                                -60.89764,
                                4.71709
                            ],
                            [
                                -60.84952,
                                4.70239
                            ],
                            [
                                -60.80116,
                                4.74722
                            ],
                            [
                                -60.74949,
                                4.75291
                            ],
                            [
                                -60.65747,
                                4.84675
                            ],
                            [
                                -60.58258,
                                4.95622
                            ],
                            [
                                -60.63981,
                                5.05507
                            ],
                            [
                                -60.64102,
                                5.11233
                            ],
                            [
                                -60.68474,
                                5.19317
                            ],
                            [
                                -60.73177,
                                5.19614
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -64.16588,
                                10.97472
                            ],
                            [
                                -64.11153,
                                10.91039
                            ],
                            [
                                -64.03884,
                                10.87243
                            ],
                            [
                                -63.83606,
                                10.95788
                            ],
                            [
                                -63.79679,
                                10.99779
                            ],
                            [
                                -63.84406,
                                11.12804
                            ],
                            [
                                -63.88233,
                                11.1755
                            ],
                            [
                                -63.92239,
                                11.12717
                            ],
                            [
                                -63.97671,
                                11.10976
                            ],
                            [
                                -64.04746,
                                10.97755
                            ],
                            [
                                -64.16588,
                                10.97472
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -64.40683,
                                10.97496
                            ],
                            [
                                -64.2092,
                                10.93561
                            ],
                            [
                                -64.17113,
                                10.9799
                            ],
                            [
                                -64.2156,
                                11.08427
                            ],
                            [
                                -64.3816,
                                11.04295
                            ],
                            [
                                -64.40683,
                                10.97496
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -65.42239,
                                10.92404
                            ],
                            [
                                -65.30802,
                                10.89038
                            ],
                            [
                                -65.2098,
                                10.90195
                            ],
                            [
                                -65.23285,
                                10.95015
                            ],
                            [
                                -65.3062,
                                10.98366
                            ],
                            [
                                -65.36641,
                                10.97402
                            ],
                            [
                                -65.42239,
                                10.92404
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -60.82112,
                                8.62479
                            ],
                            [
                                -60.76151,
                                8.63887
                            ],
                            [
                                -60.59695,
                                8.63842
                            ],
                            [
                                -60.68789,
                                8.6971
                            ],
                            [
                                -60.782,
                                8.70048
                            ],
                            [
                                -60.82112,
                                8.62479
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -64.64773,
                                11.84849
                            ],
                            [
                                -64.56726,
                                11.81038
                            ],
                            [
                                -64.56826,
                                11.87105
                            ],
                            [
                                -64.61879,
                                11.89827
                            ],
                            [
                                -64.64773,
                                11.84849
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -63.99795,
                                10.78051
                            ],
                            [
                                -63.91179,
                                10.73676
                            ],
                            [
                                -63.9103,
                                10.79389
                            ],
                            [
                                -63.99795,
                                10.78051
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -62.30972,
                                9.95471
                            ],
                            [
                                -62.22664,
                                10.02704
                            ],
                            [
                                -62.2799,
                                10.05486
                            ],
                            [
                                -62.30972,
                                9.95471
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "VNM",
                "Country": "Vietnam",
                "Total_3GHG": 0.69,
                "Total_3GHG_timeseries": [
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.0049,
                    0.005,
                    0.005,
                    0.0051,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0054,
                    0.0055,
                    0.0056,
                    0.0057,
                    0.0059,
                    0.006,
                    0.0061,
                    0.0063,
                    0.0064,
                    0.0066,
                    0.0067,
                    0.0069,
                    0.0071,
                    0.0073,
                    0.0075,
                    0.0076,
                    0.0078,
                    0.008,
                    0.0083,
                    0.0085,
                    0.0087,
                    0.0089,
                    0.0091,
                    0.0094,
                    0.0096,
                    0.0099,
                    0.0101,
                    0.0104,
                    0.0107,
                    0.011,
                    0.0113
                ],
                "Fossil_3GHG": 0.43,
                "Fossil_3GHG_timeseries": [
                    1.2646e-06,
                    2.5446e-06,
                    3.8403e-06,
                    5.1521e-06,
                    6.4805e-06,
                    7.8256e-06,
                    9.1879e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0018,
                    0.0019,
                    0.002,
                    0.0021,
                    0.0022,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0028,
                    0.0029,
                    0.0031,
                    0.0032,
                    0.0034,
                    0.0035,
                    0.0037,
                    0.0039,
                    0.0041,
                    0.0043,
                    0.0045
                ],
                "Land_3GHG": 1.17,
                "Land_3GHG_timeseries": [
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.0039,
                    0.004,
                    0.004,
                    0.004,
                    0.0041,
                    0.0041,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0045,
                    0.0046,
                    0.0047,
                    0.0048,
                    0.0049,
                    0.005,
                    0.0051,
                    0.0051,
                    0.0052,
                    0.0053,
                    0.0054,
                    0.0054,
                    0.0055,
                    0.0056,
                    0.0057,
                    0.0058,
                    0.0058,
                    0.0059,
                    0.006,
                    0.0061,
                    0.0062,
                    0.0063,
                    0.0064,
                    0.0064,
                    0.0065,
                    0.0066,
                    0.0067,
                    0.0068
                ],
                "Total_CO2": 0.56,
                "Total_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0045,
                    0.0046,
                    0.0048,
                    0.0049,
                    0.0051,
                    0.0053,
                    0.0054,
                    0.0057,
                    0.0059,
                    0.0061,
                    0.0063
                ],
                "Fossil_CO2": 0.29,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    9.57e-08,
                    3.9435e-07,
                    5.313e-07,
                    6.1215e-07,
                    7.755e-07,
                    1.0115e-06,
                    1.3068e-06,
                    1.6368e-06,
                    1.8678e-06,
                    2.0938e-06,
                    2.2737e-06,
                    2.5245e-06,
                    2.8859e-06,
                    3.2423e-06,
                    3.6185e-06,
                    4.0013e-06,
                    4.4154e-06,
                    4.8741e-06,
                    5.4697e-06,
                    5.9912e-06,
                    6.5043e-06,
                    7.1131e-06,
                    7.854e-06,
                    8.6229e-06,
                    9.4413e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0016,
                    0.0018,
                    0.0019,
                    0.0021,
                    0.0023
                ],
                "Land_CO2": 1.13,
                "Land_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035,
                    0.0036,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0038,
                    0.0039,
                    0.0039,
                    0.004,
                    0.0041
                ],
                "Total_CH4": 1.09,
                "Total_CH4_timeseries": [
                    4.059e-06,
                    8.1641e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.0031,
                    0.0032,
                    0.0033,
                    0.0034,
                    0.0035,
                    0.0036,
                    0.0037,
                    0.0038,
                    0.0039,
                    0.004,
                    0.0041,
                    0.0042,
                    0.0042,
                    0.0043,
                    0.0044,
                    0.0044,
                    0.0045,
                    0.0046
                ],
                "Fossil_CH4": 0.85,
                "Fossil_CH4_timeseries": [
                    1.2121e-06,
                    2.4389e-06,
                    3.6809e-06,
                    4.9383e-06,
                    6.2116e-06,
                    7.5012e-06,
                    8.8074e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0022
                ],
                "Land_CH4": 1.5,
                "Land_CH4_timeseries": [
                    2.847e-06,
                    5.7252e-06,
                    8.6347e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024
                ],
                "Total_N2O": 0.51,
                "Total_N2O_timeseries": [
                    1.2404e-07,
                    2.5016e-07,
                    3.783e-07,
                    5.0834e-07,
                    6.4016e-07,
                    7.736e-07,
                    9.0848e-07,
                    1.0446e-06,
                    1.1817e-06,
                    1.3195e-06,
                    1.4579e-06,
                    1.5968e-06,
                    1.7361e-06,
                    1.876e-06,
                    2.0162e-06,
                    2.157e-06,
                    2.2981e-06,
                    2.4398e-06,
                    2.582e-06,
                    2.7247e-06,
                    2.8695e-06,
                    3.0187e-06,
                    3.1742e-06,
                    3.3374e-06,
                    3.509e-06,
                    3.6891e-06,
                    3.8774e-06,
                    4.073e-06,
                    4.2742e-06,
                    4.4791e-06,
                    4.6862e-06,
                    4.8952e-06,
                    5.1059e-06,
                    5.3181e-06,
                    5.5317e-06,
                    5.7466e-06,
                    5.9629e-06,
                    6.1805e-06,
                    6.3997e-06,
                    6.6308e-06,
                    6.8662e-06,
                    7.1061e-06,
                    7.3506e-06,
                    7.5999e-06,
                    7.8542e-06,
                    8.1134e-06,
                    8.3778e-06,
                    8.6475e-06,
                    8.9226e-06,
                    9.2033e-06,
                    9.4896e-06,
                    9.7818e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Fossil_N2O": 0.33,
                "Fossil_N2O_timeseries": [
                    5.2491e-08,
                    1.0563e-07,
                    1.5941e-07,
                    2.1382e-07,
                    2.6883e-07,
                    3.2442e-07,
                    3.8056e-07,
                    4.3722e-07,
                    4.9437e-07,
                    5.5196e-07,
                    6.0996e-07,
                    6.6837e-07,
                    7.2719e-07,
                    7.8641e-07,
                    8.4603e-07,
                    9.0605e-07,
                    9.6647e-07,
                    1.0273e-06,
                    1.0885e-06,
                    1.1502e-06,
                    1.2125e-06,
                    1.2758e-06,
                    1.3404e-06,
                    1.4065e-06,
                    1.4743e-06,
                    1.5436e-06,
                    1.6146e-06,
                    1.687e-06,
                    1.7606e-06,
                    1.8351e-06,
                    1.9103e-06,
                    1.9861e-06,
                    2.0625e-06,
                    2.1395e-06,
                    2.217e-06,
                    2.295e-06,
                    2.3736e-06,
                    2.4527e-06,
                    2.5324e-06,
                    2.6132e-06,
                    2.6948e-06,
                    2.7771e-06,
                    2.8602e-06,
                    2.9442e-06,
                    3.0289e-06,
                    3.1145e-06,
                    3.2009e-06,
                    3.2883e-06,
                    3.3765e-06,
                    3.4657e-06,
                    3.556e-06,
                    3.6474e-06,
                    3.7399e-06,
                    3.8338e-06,
                    3.929e-06,
                    4.0255e-06,
                    4.1233e-06,
                    4.2223e-06,
                    4.3226e-06,
                    4.4241e-06,
                    4.5266e-06,
                    4.6301e-06,
                    4.7348e-06,
                    4.8405e-06,
                    4.9472e-06,
                    5.055e-06,
                    5.1637e-06,
                    5.2735e-06,
                    5.3842e-06,
                    5.4959e-06,
                    5.6085e-06,
                    5.7221e-06,
                    5.8366e-06,
                    5.9521e-06,
                    6.0685e-06,
                    6.1858e-06,
                    6.304e-06,
                    6.4232e-06,
                    6.5433e-06,
                    6.6643e-06,
                    6.7861e-06,
                    6.9089e-06,
                    7.0326e-06,
                    7.1573e-06,
                    7.2831e-06,
                    7.4099e-06,
                    7.5379e-06,
                    7.6672e-06,
                    7.7979e-06,
                    7.9301e-06,
                    8.0646e-06,
                    8.2028e-06,
                    8.3458e-06,
                    8.4943e-06,
                    8.6489e-06,
                    8.8098e-06,
                    8.9772e-06,
                    9.1507e-06,
                    9.3298e-06,
                    9.5137e-06,
                    9.7039e-06,
                    9.9039e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_N2O": 0.57,
                "Land_N2O_timeseries": [
                    7.155e-08,
                    1.4453e-07,
                    2.1888e-07,
                    2.9452e-07,
                    3.7133e-07,
                    4.4918e-07,
                    5.2792e-07,
                    6.0737e-07,
                    6.8733e-07,
                    7.6756e-07,
                    8.4794e-07,
                    9.2841e-07,
                    1.009e-06,
                    1.0896e-06,
                    1.1702e-06,
                    1.2509e-06,
                    1.3317e-06,
                    1.4125e-06,
                    1.4935e-06,
                    1.5746e-06,
                    1.657e-06,
                    1.7429e-06,
                    1.8338e-06,
                    1.9309e-06,
                    2.0347e-06,
                    2.1455e-06,
                    2.2628e-06,
                    2.386e-06,
                    2.5136e-06,
                    2.644e-06,
                    2.7759e-06,
                    2.9091e-06,
                    3.0434e-06,
                    3.1787e-06,
                    3.3148e-06,
                    3.4516e-06,
                    3.5893e-06,
                    3.7279e-06,
                    3.8673e-06,
                    4.0176e-06,
                    4.1714e-06,
                    4.329e-06,
                    4.4904e-06,
                    4.6558e-06,
                    4.8253e-06,
                    4.9989e-06,
                    5.1769e-06,
                    5.3592e-06,
                    5.5461e-06,
                    5.7376e-06,
                    5.9337e-06,
                    6.1344e-06,
                    6.34e-06,
                    6.5504e-06,
                    6.7659e-06,
                    6.9866e-06,
                    7.2128e-06,
                    7.4447e-06,
                    7.6827e-06,
                    7.9272e-06,
                    8.1786e-06,
                    8.4377e-06,
                    8.7051e-06,
                    8.9811e-06,
                    9.2662e-06,
                    9.5607e-06,
                    9.8648e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                104.43861,
                                10.42455
                            ],
                            [
                                104.58134,
                                10.25504
                            ],
                            [
                                104.59116,
                                10.18455
                            ],
                            [
                                104.64523,
                                10.13752
                            ],
                            [
                                104.73174,
                                10.22629
                            ],
                            [
                                104.81279,
                                10.18643
                            ],
                            [
                                104.90319,
                                10.08646
                            ],
                            [
                                104.99347,
                                10.09599
                            ],
                            [
                                105.07476,
                                10.01187
                            ],
                            [
                                105.05258,
                                9.94288
                            ],
                            [
                                104.95528,
                                9.85363
                            ],
                            [
                                104.88738,
                                9.82658
                            ],
                            [
                                104.8582,
                                9.71826
                            ],
                            [
                                104.8345,
                                9.52543
                            ],
                            [
                                104.79855,
                                8.8963
                            ],
                            [
                                104.78145,
                                8.81566
                            ],
                            [
                                104.80384,
                                8.77579
                            ],
                            [
                                104.80694,
                                8.6547
                            ],
                            [
                                104.72495,
                                8.60064
                            ],
                            [
                                104.86048,
                                8.56698
                            ],
                            [
                                105.00478,
                                8.59729
                            ],
                            [
                                105.1098,
                                8.63495
                            ],
                            [
                                105.18318,
                                8.73691
                            ],
                            [
                                105.26766,
                                8.76681
                            ],
                            [
                                105.32937,
                                8.83153
                            ],
                            [
                                105.3976,
                                8.98995
                            ],
                            [
                                105.5345,
                                9.09458
                            ],
                            [
                                105.67337,
                                9.14133
                            ],
                            [
                                105.88918,
                                9.25453
                            ],
                            [
                                106.06317,
                                9.29303
                            ],
                            [
                                106.18728,
                                9.37867
                            ],
                            [
                                106.17012,
                                9.4223
                            ],
                            [
                                106.28302,
                                9.53706
                            ],
                            [
                                106.29561,
                                9.6023
                            ],
                            [
                                106.39103,
                                9.52763
                            ],
                            [
                                106.49671,
                                9.55483
                            ],
                            [
                                106.56862,
                                9.63679
                            ],
                            [
                                106.56817,
                                9.7379
                            ],
                            [
                                106.51875,
                                9.76913
                            ],
                            [
                                106.56456,
                                9.84569
                            ],
                            [
                                106.623,
                                9.80414
                            ],
                            [
                                106.68757,
                                9.87919
                            ],
                            [
                                106.64644,
                                9.9756
                            ],
                            [
                                106.73711,
                                10.04748
                            ],
                            [
                                106.78914,
                                10.10961
                            ],
                            [
                                106.74507,
                                10.20428
                            ],
                            [
                                106.78211,
                                10.29679
                            ],
                            [
                                106.78408,
                                10.39568
                            ],
                            [
                                106.89824,
                                10.37836
                            ],
                            [
                                107.00219,
                                10.49691
                            ],
                            [
                                107.0711,
                                10.43562
                            ],
                            [
                                107.05823,
                                10.38136
                            ],
                            [
                                107.11722,
                                10.3648
                            ],
                            [
                                107.21237,
                                10.40449
                            ],
                            [
                                107.25537,
                                10.38098
                            ],
                            [
                                107.37174,
                                10.46695
                            ],
                            [
                                107.44046,
                                10.46904
                            ],
                            [
                                107.51295,
                                10.50323
                            ],
                            [
                                107.57854,
                                10.572
                            ],
                            [
                                107.77584,
                                10.65397
                            ],
                            [
                                107.88085,
                                10.7182
                            ],
                            [
                                107.99352,
                                10.70392
                            ],
                            [
                                108.03217,
                                10.80921
                            ],
                            [
                                108.08774,
                                10.91325
                            ],
                            [
                                108.22734,
                                10.95332
                            ],
                            [
                                108.33791,
                                10.956
                            ],
                            [
                                108.38225,
                                11.03281
                            ],
                            [
                                108.4708,
                                11.04821
                            ],
                            [
                                108.52537,
                                11.15147
                            ],
                            [
                                108.58688,
                                11.18145
                            ],
                            [
                                108.7297,
                                11.18904
                            ],
                            [
                                108.75597,
                                11.27663
                            ],
                            [
                                108.79022,
                                11.31064
                            ],
                            [
                                108.87877,
                                11.33434
                            ],
                            [
                                108.96712,
                                11.31988
                            ],
                            [
                                109.01648,
                                11.36502
                            ],
                            [
                                109.01243,
                                11.50403
                            ],
                            [
                                109.04211,
                                11.58541
                            ],
                            [
                                109.13019,
                                11.57257
                            ],
                            [
                                109.22495,
                                11.75214
                            ],
                            [
                                109.10888,
                                11.8564
                            ],
                            [
                                109.19575,
                                11.95199
                            ],
                            [
                                109.20827,
                                11.88326
                            ],
                            [
                                109.25106,
                                11.85952
                            ],
                            [
                                109.27931,
                                11.95068
                            ],
                            [
                                109.2091,
                                12.05159
                            ],
                            [
                                109.22075,
                                12.14624
                            ],
                            [
                                109.19958,
                                12.25542
                            ],
                            [
                                109.23573,
                                12.30354
                            ],
                            [
                                109.20333,
                                12.33924
                            ],
                            [
                                109.18676,
                                12.45043
                            ],
                            [
                                109.28624,
                                12.34966
                            ],
                            [
                                109.33158,
                                12.40869
                            ],
                            [
                                109.29032,
                                12.48243
                            ],
                            [
                                109.2392,
                                12.51592
                            ],
                            [
                                109.24173,
                                12.57623
                            ],
                            [
                                109.19435,
                                12.63349
                            ],
                            [
                                109.32988,
                                12.7914
                            ],
                            [
                                109.45467,
                                12.90901
                            ],
                            [
                                109.36894,
                                13.01956
                            ],
                            [
                                109.29899,
                                13.135
                            ],
                            [
                                109.31055,
                                13.27186
                            ],
                            [
                                109.28252,
                                13.36365
                            ],
                            [
                                109.22675,
                                13.39646
                            ],
                            [
                                109.23539,
                                13.48275
                            ],
                            [
                                109.28736,
                                13.45833
                            ],
                            [
                                109.28933,
                                13.56913
                            ],
                            [
                                109.2461,
                                13.60563
                            ],
                            [
                                109.21726,
                                13.73663
                            ],
                            [
                                109.28925,
                                13.76181
                            ],
                            [
                                109.2949,
                                13.87721
                            ],
                            [
                                109.24593,
                                13.94009
                            ],
                            [
                                109.2509,
                                14.01913
                            ],
                            [
                                109.2174,
                                14.07868
                            ],
                            [
                                109.22288,
                                14.13538
                            ],
                            [
                                109.1852,
                                14.20612
                            ],
                            [
                                109.17902,
                                14.28623
                            ],
                            [
                                109.12532,
                                14.36842
                            ],
                            [
                                109.12045,
                                14.44818
                            ],
                            [
                                109.07019,
                                14.55816
                            ],
                            [
                                109.07554,
                                14.69961
                            ],
                            [
                                109.00835,
                                14.81247
                            ],
                            [
                                108.91386,
                                15.03794
                            ],
                            [
                                108.89674,
                                15.18961
                            ],
                            [
                                108.93344,
                                15.21671
                            ],
                            [
                                108.83234,
                                15.37219
                            ],
                            [
                                108.72188,
                                15.41375
                            ],
                            [
                                108.69073,
                                15.47941
                            ],
                            [
                                108.60622,
                                15.52757
                            ],
                            [
                                108.53259,
                                15.62002
                            ],
                            [
                                108.44437,
                                15.75663
                            ],
                            [
                                108.40435,
                                15.86859
                            ],
                            [
                                108.29351,
                                15.96099
                            ],
                            [
                                108.25213,
                                16.04522
                            ],
                            [
                                108.12584,
                                16.1354
                            ],
                            [
                                108.14998,
                                16.21832
                            ],
                            [
                                108.06049,
                                16.22079
                            ],
                            [
                                108.03458,
                                16.33094
                            ],
                            [
                                107.99871,
                                16.31436
                            ],
                            [
                                107.9223,
                                16.35145
                            ],
                            [
                                107.88898,
                                16.27771
                            ],
                            [
                                107.79599,
                                16.31411
                            ],
                            [
                                107.78864,
                                16.38175
                            ],
                            [
                                107.75237,
                                16.45318
                            ],
                            [
                                107.5855,
                                16.57742
                            ],
                            [
                                107.56149,
                                16.57161
                            ],
                            [
                                107.43215,
                                16.63457
                            ],
                            [
                                107.43828,
                                16.66722
                            ],
                            [
                                107.3292,
                                16.78639
                            ],
                            [
                                107.16284,
                                16.93956
                            ],
                            [
                                107.11935,
                                17.00048
                            ],
                            [
                                107.11003,
                                17.0882
                            ],
                            [
                                107.02013,
                                17.14459
                            ],
                            [
                                106.81913,
                                17.29374
                            ],
                            [
                                106.65082,
                                17.45753
                            ],
                            [
                                106.51209,
                                17.66542
                            ],
                            [
                                106.46074,
                                17.76912
                            ],
                            [
                                106.45026,
                                17.86551
                            ],
                            [
                                106.51135,
                                17.94312
                            ],
                            [
                                106.40144,
                                18.10118
                            ],
                            [
                                106.36272,
                                18.10468
                            ],
                            [
                                106.25569,
                                18.2096
                            ],
                            [
                                106.163,
                                18.26419
                            ],
                            [
                                106.12041,
                                18.26485
                            ],
                            [
                                106.0509,
                                18.31987
                            ],
                            [
                                105.94047,
                                18.46373
                            ],
                            [
                                105.86148,
                                18.53753
                            ],
                            [
                                105.79901,
                                18.67034
                            ],
                            [
                                105.7773,
                                18.75449
                            ],
                            [
                                105.71543,
                                18.84646
                            ],
                            [
                                105.64086,
                                18.89706
                            ],
                            [
                                105.61918,
                                18.98137
                            ],
                            [
                                105.63663,
                                19.05817
                            ],
                            [
                                105.73203,
                                19.10509
                            ],
                            [
                                105.73835,
                                19.21524
                            ],
                            [
                                105.82471,
                                19.31127
                            ],
                            [
                                105.78584,
                                19.38872
                            ],
                            [
                                105.81113,
                                19.43413
                            ],
                            [
                                105.80714,
                                19.51356
                            ],
                            [
                                105.85469,
                                19.70261
                            ],
                            [
                                105.92803,
                                19.77411
                            ],
                            [
                                105.95627,
                                19.91853
                            ],
                            [
                                106.0168,
                                19.96177
                            ],
                            [
                                106.05519,
                                19.92876
                            ],
                            [
                                106.16428,
                                19.97265
                            ],
                            [
                                106.37588,
                                20.19431
                            ],
                            [
                                106.49357,
                                20.22124
                            ],
                            [
                                106.57753,
                                20.29541
                            ],
                            [
                                106.59585,
                                20.43571
                            ],
                            [
                                106.58953,
                                20.55513
                            ],
                            [
                                106.6984,
                                20.68757
                            ],
                            [
                                106.79514,
                                20.72153
                            ],
                            [
                                106.75849,
                                20.77364
                            ],
                            [
                                106.88512,
                                20.9065
                            ],
                            [
                                106.89137,
                                20.9706
                            ],
                            [
                                107.18608,
                                20.93787
                            ],
                            [
                                107.23955,
                                20.99366
                            ],
                            [
                                107.34391,
                                21.00603
                            ],
                            [
                                107.58435,
                                21.18029
                            ],
                            [
                                107.54065,
                                21.19514
                            ],
                            [
                                107.45368,
                                21.2944
                            ],
                            [
                                107.60002,
                                21.29089
                            ],
                            [
                                107.66449,
                                21.36917
                            ],
                            [
                                107.79812,
                                21.4792
                            ],
                            [
                                107.89771,
                                21.52907
                            ],
                            [
                                108.01583,
                                21.47423
                            ],
                            [
                                108.02358,
                                21.54887
                            ],
                            [
                                107.95578,
                                21.53702
                            ],
                            [
                                107.86059,
                                21.6528
                            ],
                            [
                                107.8069,
                                21.65775
                            ],
                            [
                                107.64494,
                                21.60458
                            ],
                            [
                                107.57523,
                                21.61659
                            ],
                            [
                                107.49093,
                                21.60064
                            ],
                            [
                                107.46561,
                                21.66278
                            ],
                            [
                                107.36482,
                                21.59985
                            ],
                            [
                                107.35909,
                                21.66192
                            ],
                            [
                                107.30417,
                                21.73872
                            ],
                            [
                                107.24388,
                                21.70779
                            ],
                            [
                                107.11729,
                                21.79219
                            ],
                            [
                                107.03896,
                                21.81654
                            ],
                            [
                                107.01056,
                                21.85185
                            ],
                            [
                                107.06198,
                                21.89728
                            ],
                            [
                                106.99174,
                                21.94886
                            ],
                            [
                                106.91666,
                                21.97299
                            ],
                            [
                                106.81702,
                                21.9766
                            ],
                            [
                                106.74528,
                                22.01237
                            ],
                            [
                                106.67662,
                                22.17839
                            ],
                            [
                                106.69737,
                                22.21467
                            ],
                            [
                                106.65173,
                                22.33747
                            ],
                            [
                                106.57666,
                                22.34278
                            ],
                            [
                                106.56427,
                                22.46313
                            ],
                            [
                                106.6165,
                                22.60389
                            ],
                            [
                                106.71448,
                                22.58205
                            ],
                            [
                                106.72437,
                                22.64192
                            ],
                            [
                                106.82327,
                                22.77997
                            ],
                            [
                                106.67112,
                                22.89166
                            ],
                            [
                                106.52279,
                                22.94743
                            ],
                            [
                                106.49705,
                                22.90893
                            ],
                            [
                                106.34931,
                                22.86083
                            ],
                            [
                                106.25632,
                                22.8844
                            ],
                            [
                                106.23455,
                                22.95248
                            ],
                            [
                                106.1301,
                                22.99415
                            ],
                            [
                                106.00699,
                                22.99167
                            ],
                            [
                                105.99357,
                                22.94474
                            ],
                            [
                                105.87587,
                                22.92183
                            ],
                            [
                                105.82857,
                                22.9841
                            ],
                            [
                                105.7352,
                                23.05862
                            ],
                            [
                                105.57233,
                                23.07825
                            ],
                            [
                                105.55259,
                                23.18296
                            ],
                            [
                                105.50068,
                                23.20347
                            ],
                            [
                                105.43651,
                                23.29967
                            ],
                            [
                                105.37366,
                                23.31869
                            ],
                            [
                                105.32431,
                                23.38979
                            ],
                            [
                                105.26124,
                                23.34322
                            ],
                            [
                                105.22996,
                                23.27547
                            ],
                            [
                                105.17248,
                                23.28834
                            ],
                            [
                                105.07956,
                                23.26571
                            ],
                            [
                                105.02563,
                                23.22057
                            ],
                            [
                                104.88304,
                                23.16694
                            ],
                            [
                                104.81638,
                                23.0868
                            ],
                            [
                                104.86342,
                                22.95388
                            ],
                            [
                                104.77516,
                                22.89683
                            ],
                            [
                                104.72291,
                                22.82095
                            ],
                            [
                                104.60071,
                                22.84328
                            ],
                            [
                                104.53444,
                                22.82272
                            ],
                            [
                                104.39411,
                                22.69273
                            ],
                            [
                                104.27201,
                                22.74249
                            ],
                            [
                                104.24318,
                                22.83786
                            ],
                            [
                                104.11612,
                                22.81006
                            ],
                            [
                                104.04201,
                                22.72531
                            ],
                            [
                                104.01153,
                                22.52273
                            ],
                            [
                                103.96213,
                                22.50739
                            ],
                            [
                                103.82544,
                                22.6174
                            ],
                            [
                                103.76983,
                                22.68762
                            ],
                            [
                                103.64134,
                                22.79601
                            ],
                            [
                                103.56632,
                                22.70786
                            ],
                            [
                                103.57773,
                                22.66754
                            ],
                            [
                                103.52687,
                                22.59591
                            ],
                            [
                                103.43007,
                                22.7044
                            ],
                            [
                                103.44083,
                                22.7558
                            ],
                            [
                                103.32344,
                                22.81114
                            ],
                            [
                                103.28026,
                                22.68335
                            ],
                            [
                                103.19551,
                                22.64898
                            ],
                            [
                                103.15837,
                                22.58926
                            ],
                            [
                                103.17828,
                                22.55664
                            ],
                            [
                                103.06968,
                                22.48935
                            ],
                            [
                                103.0248,
                                22.43957
                            ],
                            [
                                102.98541,
                                22.47884
                            ],
                            [
                                102.92533,
                                22.47722
                            ],
                            [
                                102.85856,
                                22.60421
                            ],
                            [
                                102.79035,
                                22.62636
                            ],
                            [
                                102.69572,
                                22.69911
                            ],
                            [
                                102.6542,
                                22.69378
                            ],
                            [
                                102.54165,
                                22.7648
                            ],
                            [
                                102.47093,
                                22.77643
                            ],
                            [
                                102.40053,
                                22.62891
                            ],
                            [
                                102.25031,
                                22.4682
                            ],
                            [
                                102.15769,
                                22.43962
                            ],
                            [
                                102.14389,
                                22.40069
                            ],
                            [
                                102.17897,
                                22.30535
                            ],
                            [
                                102.23758,
                                22.27072
                            ],
                            [
                                102.28372,
                                22.207
                            ],
                            [
                                102.3819,
                                22.14881
                            ],
                            [
                                102.48387,
                                22.04305
                            ],
                            [
                                102.50555,
                                21.9732
                            ],
                            [
                                102.61054,
                                21.92179
                            ],
                            [
                                102.62106,
                                21.86485
                            ],
                            [
                                102.72822,
                                21.82457
                            ],
                            [
                                102.80626,
                                21.8182
                            ],
                            [
                                102.94165,
                                21.7758
                            ],
                            [
                                102.97987,
                                21.68871
                            ],
                            [
                                102.99623,
                                21.57536
                            ],
                            [
                                102.89682,
                                21.38401
                            ],
                            [
                                102.89181,
                                21.32778
                            ],
                            [
                                102.80843,
                                21.2633
                            ],
                            [
                                102.88418,
                                21.24299
                            ],
                            [
                                102.96029,
                                21.11319
                            ],
                            [
                                102.96135,
                                21.07923
                            ],
                            [
                                103.0406,
                                21.04644
                            ],
                            [
                                103.12,
                                20.88666
                            ],
                            [
                                103.25742,
                                20.8245
                            ],
                            [
                                103.32817,
                                20.81561
                            ],
                            [
                                103.44071,
                                20.84335
                            ],
                            [
                                103.4963,
                                20.77603
                            ],
                            [
                                103.59718,
                                20.80809
                            ],
                            [
                                103.75264,
                                20.77581
                            ],
                            [
                                103.82134,
                                20.7858
                            ],
                            [
                                103.9686,
                                20.87806
                            ],
                            [
                                104.025,
                                20.89547
                            ],
                            [
                                104.05221,
                                20.94891
                            ],
                            [
                                104.10549,
                                20.9766
                            ],
                            [
                                104.18349,
                                20.95676
                            ],
                            [
                                104.32839,
                                20.88819
                            ],
                            [
                                104.33083,
                                20.86058
                            ],
                            [
                                104.47818,
                                20.76598
                            ],
                            [
                                104.53472,
                                20.69025
                            ],
                            [
                                104.59829,
                                20.53589
                            ],
                            [
                                104.49254,
                                20.51719
                            ],
                            [
                                104.44239,
                                20.45813
                            ],
                            [
                                104.4615,
                                20.40309
                            ],
                            [
                                104.62256,
                                20.428
                            ],
                            [
                                104.75492,
                                20.38899
                            ],
                            [
                                104.7794,
                                20.27984
                            ],
                            [
                                104.68008,
                                20.24544
                            ],
                            [
                                104.99035,
                                20.09635
                            ],
                            [
                                104.97592,
                                20.01172
                            ],
                            [
                                104.79883,
                                19.92248
                            ],
                            [
                                104.76955,
                                19.87499
                            ],
                            [
                                104.84155,
                                19.84694
                            ],
                            [
                                104.83383,
                                19.79623
                            ],
                            [
                                104.72321,
                                19.75281
                            ],
                            [
                                104.66507,
                                19.70175
                            ],
                            [
                                104.64158,
                                19.62374
                            ],
                            [
                                104.5214,
                                19.61407
                            ],
                            [
                                104.42492,
                                19.67081
                            ],
                            [
                                104.40361,
                                19.70536
                            ],
                            [
                                104.32304,
                                19.67126
                            ],
                            [
                                104.24153,
                                19.70638
                            ],
                            [
                                104.09273,
                                19.66704
                            ],
                            [
                                104.03561,
                                19.61893
                            ],
                            [
                                104.09964,
                                19.56544
                            ],
                            [
                                104.12045,
                                19.4994
                            ],
                            [
                                104.07828,
                                19.42557
                            ],
                            [
                                103.97793,
                                19.39765
                            ],
                            [
                                103.90016,
                                19.3065
                            ],
                            [
                                104.00055,
                                19.2329
                            ],
                            [
                                104.06702,
                                19.24483
                            ],
                            [
                                104.1863,
                                19.19841
                            ],
                            [
                                104.3162,
                                19.08724
                            ],
                            [
                                104.3979,
                                19.05657
                            ],
                            [
                                104.44865,
                                18.98878
                            ],
                            [
                                104.54144,
                                18.97239
                            ],
                            [
                                104.58203,
                                18.90372
                            ],
                            [
                                104.74622,
                                18.80036
                            ],
                            [
                                104.85539,
                                18.77849
                            ],
                            [
                                104.91482,
                                18.78399
                            ],
                            [
                                104.94473,
                                18.74277
                            ],
                            [
                                105.00953,
                                18.73979
                            ],
                            [
                                105.12609,
                                18.69412
                            ],
                            [
                                105.19019,
                                18.63916
                            ],
                            [
                                105.13786,
                                18.58607
                            ],
                            [
                                105.10321,
                                18.44305
                            ],
                            [
                                105.17813,
                                18.38144
                            ],
                            [
                                105.18746,
                                18.32145
                            ],
                            [
                                105.258,
                                18.2558
                            ],
                            [
                                105.32306,
                                18.22986
                            ],
                            [
                                105.3278,
                                18.1888
                            ],
                            [
                                105.40632,
                                18.14974
                            ],
                            [
                                105.48573,
                                18.19456
                            ],
                            [
                                105.50644,
                                18.12261
                            ],
                            [
                                105.57051,
                                18.07727
                            ],
                            [
                                105.59248,
                                18.00943
                            ],
                            [
                                105.64084,
                                17.98733
                            ],
                            [
                                105.61256,
                                17.88592
                            ],
                            [
                                105.68239,
                                17.83542
                            ],
                            [
                                105.67805,
                                17.79474
                            ],
                            [
                                105.72775,
                                17.74635
                            ],
                            [
                                105.7516,
                                17.67583
                            ],
                            [
                                105.8648,
                                17.61828
                            ],
                            [
                                106.0871,
                                17.35785
                            ],
                            [
                                106.25024,
                                17.24627
                            ],
                            [
                                106.31253,
                                17.21993
                            ],
                            [
                                106.37499,
                                17.11046
                            ],
                            [
                                106.40564,
                                17.08764
                            ],
                            [
                                106.42639,
                                17.00715
                            ],
                            [
                                106.51238,
                                16.97151
                            ],
                            [
                                106.5496,
                                17.00463
                            ],
                            [
                                106.55534,
                                16.69176
                            ],
                            [
                                106.5847,
                                16.60372
                            ],
                            [
                                106.64487,
                                16.59332
                            ],
                            [
                                106.6611,
                                16.47555
                            ],
                            [
                                106.68885,
                                16.44051
                            ],
                            [
                                106.76377,
                                16.42646
                            ],
                            [
                                106.80255,
                                16.465
                            ],
                            [
                                106.83223,
                                16.54484
                            ],
                            [
                                106.88956,
                                16.51245
                            ],
                            [
                                106.87533,
                                16.4389
                            ],
                            [
                                106.96336,
                                16.35333
                            ],
                            [
                                106.96586,
                                16.31276
                            ],
                            [
                                107.09089,
                                16.30928
                            ],
                            [
                                107.15567,
                                16.25784
                            ],
                            [
                                107.15353,
                                16.1782
                            ],
                            [
                                107.18583,
                                16.15064
                            ],
                            [
                                107.35599,
                                16.11237
                            ],
                            [
                                107.43344,
                                16.14546
                            ],
                            [
                                107.47422,
                                16.0665
                            ],
                            [
                                107.42238,
                                15.91883
                            ],
                            [
                                107.22548,
                                15.84254
                            ],
                            [
                                107.21646,
                                15.7603
                            ],
                            [
                                107.28284,
                                15.70961
                            ],
                            [
                                107.26714,
                                15.657
                            ],
                            [
                                107.34869,
                                15.60809
                            ],
                            [
                                107.38448,
                                15.50394
                            ],
                            [
                                107.51039,
                                15.47457
                            ],
                            [
                                107.52717,
                                15.41403
                            ],
                            [
                                107.61103,
                                15.39189
                            ],
                            [
                                107.67225,
                                15.34844
                            ],
                            [
                                107.68317,
                                15.28446
                            ],
                            [
                                107.58866,
                                15.26851
                            ],
                            [
                                107.54837,
                                15.15932
                            ],
                            [
                                107.59424,
                                15.05379
                            ],
                            [
                                107.48011,
                                15.0239
                            ],
                            [
                                107.50424,
                                14.93118
                            ],
                            [
                                107.58864,
                                14.87089
                            ],
                            [
                                107.50706,
                                14.79795
                            ],
                            [
                                107.55613,
                                14.6866
                            ],
                            [
                                107.55226,
                                14.60648
                            ],
                            [
                                107.52427,
                                14.57497
                            ],
                            [
                                107.4859,
                                14.40238
                            ],
                            [
                                107.41068,
                                14.36008
                            ],
                            [
                                107.40639,
                                14.23551
                            ],
                            [
                                107.33961,
                                14.13206
                            ],
                            [
                                107.3822,
                                14.07869
                            ],
                            [
                                107.36549,
                                14.01558
                            ],
                            [
                                107.44632,
                                13.99226
                            ],
                            [
                                107.47224,
                                13.91381
                            ],
                            [
                                107.45171,
                                13.79369
                            ],
                            [
                                107.53157,
                                13.742
                            ],
                            [
                                107.57211,
                                13.66299
                            ],
                            [
                                107.6282,
                                13.48127
                            ],
                            [
                                107.63005,
                                13.36252
                            ],
                            [
                                107.4976,
                                13.03222
                            ],
                            [
                                107.49398,
                                12.89871
                            ],
                            [
                                107.56078,
                                12.79386
                            ],
                            [
                                107.56224,
                                12.7108
                            ],
                            [
                                107.5877,
                                12.55795
                            ],
                            [
                                107.5445,
                                12.3555
                            ],
                            [
                                107.4711,
                                12.31017
                            ],
                            [
                                107.41857,
                                12.2433
                            ],
                            [
                                107.34738,
                                12.3303
                            ],
                            [
                                107.27261,
                                12.3234
                            ],
                            [
                                107.15444,
                                12.27447
                            ],
                            [
                                107.13555,
                                12.23094
                            ],
                            [
                                106.99767,
                                12.09548
                            ],
                            [
                                106.9323,
                                12.06631
                            ],
                            [
                                106.77856,
                                12.07066
                            ],
                            [
                                106.74047,
                                11.9854
                            ],
                            [
                                106.68705,
                                11.96608
                            ],
                            [
                                106.42003,
                                11.97311
                            ],
                            [
                                106.46433,
                                11.8724
                            ],
                            [
                                106.41661,
                                11.76759
                            ],
                            [
                                106.45099,
                                11.6901
                            ],
                            [
                                106.30578,
                                11.67671
                            ],
                            [
                                106.26115,
                                11.72139
                            ],
                            [
                                106.18936,
                                11.74964
                            ],
                            [
                                106.11748,
                                11.74445
                            ],
                            [
                                106.07498,
                                11.77339
                            ],
                            [
                                106.01284,
                                11.72201
                            ],
                            [
                                105.95955,
                                11.64648
                            ],
                            [
                                105.88442,
                                11.67459
                            ],
                            [
                                105.81321,
                                11.61507
                            ],
                            [
                                105.82374,
                                11.57073
                            ],
                            [
                                105.88092,
                                11.54069
                            ],
                            [
                                105.88399,
                                11.35895
                            ],
                            [
                                105.93105,
                                11.216
                            ],
                            [
                                106.01498,
                                11.1854
                            ],
                            [
                                106.02419,
                                11.15027
                            ],
                            [
                                106.09529,
                                11.0971
                            ],
                            [
                                106.16158,
                                11.09578
                            ],
                            [
                                106.20711,
                                10.97786
                            ],
                            [
                                106.1515,
                                10.97765
                            ],
                            [
                                106.14512,
                                10.91655
                            ],
                            [
                                106.19422,
                                10.79681
                            ],
                            [
                                106.08974,
                                10.80618
                            ],
                            [
                                105.97754,
                                10.88741
                            ],
                            [
                                105.90267,
                                10.84211
                            ],
                            [
                                105.85628,
                                10.86099
                            ],
                            [
                                105.84619,
                                10.92721
                            ],
                            [
                                105.7744,
                                11.02947
                            ],
                            [
                                105.5357,
                                10.95267
                            ],
                            [
                                105.42891,
                                10.96978
                            ],
                            [
                                105.33803,
                                10.8633
                            ],
                            [
                                105.0835,
                                10.95529
                            ],
                            [
                                105.03094,
                                10.88905
                            ],
                            [
                                105.09177,
                                10.72078
                            ],
                            [
                                104.94874,
                                10.63334
                            ],
                            [
                                104.86904,
                                10.52394
                            ],
                            [
                                104.76024,
                                10.51805
                            ],
                            [
                                104.69493,
                                10.53737
                            ],
                            [
                                104.58737,
                                10.52663
                            ],
                            [
                                104.55171,
                                10.45786
                            ],
                            [
                                104.43861,
                                10.42455
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                103.83367,
                                10.3631
                            ],
                            [
                                103.85794,
                                10.30711
                            ],
                            [
                                103.91438,
                                10.28822
                            ],
                            [
                                103.96164,
                                10.20322
                            ],
                            [
                                103.99141,
                                10.04903
                            ],
                            [
                                104.0424,
                                10.06907
                            ],
                            [
                                104.03656,
                                10.11957
                            ],
                            [
                                104.08083,
                                10.24761
                            ],
                            [
                                104.07826,
                                10.37154
                            ],
                            [
                                104.00736,
                                10.44643
                            ],
                            [
                                103.9728,
                                10.43742
                            ],
                            [
                                103.91995,
                                10.35973
                            ],
                            [
                                103.83367,
                                10.3631
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                107.09982,
                                20.80735
                            ],
                            [
                                107.0346,
                                20.85991
                            ],
                            [
                                106.90965,
                                20.82506
                            ],
                            [
                                106.99444,
                                20.73732
                            ],
                            [
                                107.09982,
                                20.80735
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                107.62722,
                                16.57033
                            ],
                            [
                                107.7059,
                                16.52131
                            ],
                            [
                                107.84802,
                                16.35664
                            ],
                            [
                                107.89914,
                                16.36775
                            ],
                            [
                                107.68932,
                                16.53921
                            ],
                            [
                                107.62722,
                                16.57033
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "WLF",
                "Country": "Wallis and Futuna",
                "Total_3GHG": 0.0,
                "Total_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    8.25e-09,
                    1.65e-08,
                    2.475e-08,
                    3.3e-08,
                    4.125e-08,
                    4.95e-08,
                    5.94e-08,
                    6.93e-08,
                    7.92e-08,
                    9.075e-08,
                    1.023e-07,
                    1.1385e-07,
                    1.254e-07,
                    1.3695e-07,
                    1.485e-07,
                    1.617e-07,
                    1.749e-07,
                    1.881e-07,
                    1.98e-07,
                    2.112e-07,
                    2.244e-07,
                    2.3595e-07,
                    2.475e-07,
                    2.574e-07,
                    2.673e-07,
                    2.772e-07,
                    2.8875e-07,
                    3.003e-07,
                    3.1185e-07,
                    3.234e-07,
                    3.3495e-07,
                    3.47e-07,
                    3.5892e-07
                ],
                "Fossil_3GHG": 0.0,
                "Fossil_3GHG_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    8.25e-09,
                    1.65e-08,
                    2.475e-08,
                    3.3e-08,
                    4.125e-08,
                    4.95e-08,
                    5.94e-08,
                    6.93e-08,
                    7.92e-08,
                    9.075e-08,
                    1.023e-07,
                    1.1385e-07,
                    1.254e-07,
                    1.3695e-07,
                    1.485e-07,
                    1.617e-07,
                    1.749e-07,
                    1.881e-07,
                    1.98e-07,
                    2.112e-07,
                    2.244e-07,
                    2.3595e-07,
                    2.475e-07,
                    2.574e-07,
                    2.673e-07,
                    2.772e-07,
                    2.8875e-07,
                    3.003e-07,
                    3.1185e-07,
                    3.234e-07,
                    3.3495e-07,
                    3.47e-07,
                    3.5892e-07
                ],
                "Land_3GHG": 0.0,
                "Land_3GHG_timeseries": [],
                "Total_CO2": 0.0,
                "Total_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    8.25e-09,
                    1.65e-08,
                    2.475e-08,
                    3.3e-08,
                    4.125e-08,
                    4.95e-08,
                    5.94e-08,
                    6.93e-08,
                    7.92e-08,
                    9.075e-08,
                    1.023e-07,
                    1.1385e-07,
                    1.254e-07,
                    1.3695e-07,
                    1.485e-07,
                    1.617e-07,
                    1.749e-07,
                    1.881e-07,
                    1.98e-07,
                    2.112e-07,
                    2.244e-07,
                    2.3595e-07,
                    2.475e-07,
                    2.574e-07,
                    2.673e-07,
                    2.772e-07,
                    2.8875e-07,
                    3.003e-07,
                    3.1185e-07,
                    3.234e-07,
                    3.3495e-07,
                    3.47e-07,
                    3.5892e-07
                ],
                "Fossil_CO2": 0.0,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    8.25e-09,
                    1.65e-08,
                    2.475e-08,
                    3.3e-08,
                    4.125e-08,
                    4.95e-08,
                    5.94e-08,
                    6.93e-08,
                    7.92e-08,
                    9.075e-08,
                    1.023e-07,
                    1.1385e-07,
                    1.254e-07,
                    1.3695e-07,
                    1.485e-07,
                    1.617e-07,
                    1.749e-07,
                    1.881e-07,
                    1.98e-07,
                    2.112e-07,
                    2.244e-07,
                    2.3595e-07,
                    2.475e-07,
                    2.574e-07,
                    2.673e-07,
                    2.772e-07,
                    2.8875e-07,
                    3.003e-07,
                    3.1185e-07,
                    3.234e-07,
                    3.3495e-07,
                    3.47e-07,
                    3.5892e-07
                ],
                "Land_CO2": 0.0,
                "Land_CO2_timeseries": [],
                "Total_CH4": 0.0,
                "Total_CH4_timeseries": [],
                "Fossil_CH4": 0.0,
                "Fossil_CH4_timeseries": [],
                "Land_CH4": 0.0,
                "Land_CH4_timeseries": [],
                "Total_N2O": 0.0,
                "Total_N2O_timeseries": [],
                "Fossil_N2O": 0.0,
                "Fossil_N2O_timeseries": [],
                "Land_N2O": 0.0,
                "Land_N2O_timeseries": []
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -176.19254,
                            -13.22225
                        ],
                        [
                            -176.2504,
                            -13.29003
                        ],
                        [
                            -176.20515,
                            -13.35234
                        ],
                        [
                            -176.16184,
                            -13.26524
                        ],
                        [
                            -176.19254,
                            -13.22225
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "YEM",
                "Country": "Yemen",
                "Total_3GHG": 0.07,
                "Total_3GHG_timeseries": [
                    3.3473e-07,
                    6.7306e-07,
                    1.0148e-06,
                    1.3596e-06,
                    1.7073e-06,
                    2.0575e-06,
                    2.4102e-06,
                    2.7649e-06,
                    3.1214e-06,
                    3.4786e-06,
                    3.8367e-06,
                    4.1959e-06,
                    4.5561e-06,
                    4.9174e-06,
                    5.2798e-06,
                    5.6433e-06,
                    6.0079e-06,
                    6.3736e-06,
                    6.7405e-06,
                    7.1157e-06,
                    7.5058e-06,
                    7.911e-06,
                    8.332e-06,
                    8.7693e-06,
                    9.2233e-06,
                    9.694e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012
                ],
                "Fossil_3GHG": 0.08,
                "Fossil_3GHG_timeseries": [
                    2.2202e-07,
                    4.4446e-07,
                    6.6733e-07,
                    8.9061e-07,
                    1.1143e-06,
                    1.3384e-06,
                    1.5629e-06,
                    1.7879e-06,
                    2.0132e-06,
                    2.2389e-06,
                    2.465e-06,
                    2.6915e-06,
                    2.9183e-06,
                    3.1456e-06,
                    3.3732e-06,
                    3.6012e-06,
                    3.8297e-06,
                    4.0584e-06,
                    4.2876e-06,
                    4.5172e-06,
                    4.7524e-06,
                    4.9934e-06,
                    5.2402e-06,
                    5.4928e-06,
                    5.7512e-06,
                    6.0154e-06,
                    6.2855e-06,
                    6.5613e-06,
                    6.8429e-06,
                    7.1302e-06,
                    7.4214e-06,
                    7.7165e-06,
                    8.0154e-06,
                    8.3183e-06,
                    8.625e-06,
                    8.9356e-06,
                    9.25e-06,
                    9.5684e-06,
                    9.8906e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    9.0118e-06,
                    7.8563e-06,
                    6.7537e-06,
                    5.7085e-06,
                    4.7325e-06,
                    3.8305e-06,
                    3.007e-06,
                    2.2667e-06,
                    1.6142e-06,
                    1.0829e-06,
                    6.5122e-07,
                    3.4262e-07,
                    1.5909e-07,
                    2.2371e-06,
                    3.4832e-06,
                    4.7883e-06,
                    6.5355e-06,
                    7.9133e-06,
                    9.7889e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009
                ],
                "Land_3GHG": 0.05,
                "Land_3GHG_timeseries": [
                    1.127e-07,
                    2.2859e-07,
                    3.4744e-07,
                    4.6898e-07,
                    5.9296e-07,
                    7.1912e-07,
                    8.4721e-07,
                    9.77e-07,
                    1.1083e-06,
                    1.2397e-06,
                    1.3717e-06,
                    1.5044e-06,
                    1.6377e-06,
                    1.7718e-06,
                    1.9065e-06,
                    2.042e-06,
                    2.1782e-06,
                    2.3152e-06,
                    2.4529e-06,
                    2.5985e-06,
                    2.7534e-06,
                    2.9176e-06,
                    3.0918e-06,
                    3.2765e-06,
                    3.4721e-06,
                    3.6785e-06,
                    3.8956e-06,
                    4.1227e-06,
                    4.359e-06,
                    4.6013e-06,
                    4.8482e-06,
                    5.0998e-06,
                    5.356e-06,
                    5.6168e-06,
                    5.8823e-06,
                    6.1523e-06,
                    6.427e-06,
                    6.7064e-06,
                    6.9904e-06,
                    7.2806e-06,
                    7.5697e-06,
                    7.858e-06,
                    8.146e-06,
                    8.4337e-06,
                    8.7213e-06,
                    9.009e-06,
                    9.2967e-06,
                    9.5846e-06,
                    9.8726e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Total_CO2": 0.03,
                "Total_CO2_timeseries": [
                    -0.00000012931,
                    -0.00000025681,
                    -0.00000038267,
                    -0.00000050711,
                    -0.00000063031,
                    -0.00000075242,
                    -0.0000008736,
                    -0.00000099397,
                    -0.0000011136,
                    -0.0000012336,
                    -0.0000013536,
                    -0.0000014734,
                    -0.0000015929,
                    -0.0000017122,
                    -0.0000018312,
                    -0.0000019499,
                    -0.0000020684,
                    -0.0000021865,
                    -0.0000023044,
                    -0.0000024148,
                    -0.000002522,
                    -0.0000026271,
                    -0.0000027308,
                    -0.000002833,
                    -0.0000029341,
                    -0.000003034,
                    -0.0000031328,
                    -0.0000032305,
                    -0.0000033272,
                    -0.0000034246,
                    -0.0000035221,
                    -0.0000036192,
                    -0.0000037159,
                    -0.000003812,
                    -0.0000039076,
                    -0.0000040026,
                    -0.000004097,
                    -0.0000041908,
                    -0.0000042839,
                    -0.0000043789,
                    -0.0000044746,
                    -0.0000045704,
                    -0.0000046663,
                    -0.0000047621,
                    -0.0000048576,
                    -0.0000049529,
                    -0.0000050479,
                    -0.0000051426,
                    -0.0000052369,
                    -0.0000053334,
                    -0.0000054311,
                    -0.000005529,
                    -0.0000056275,
                    -0.0000057259,
                    -0.0000058244,
                    -0.0000059225,
                    -0.0000060203,
                    -0.0000061183,
                    -0.0000062159,
                    -0.0000062897,
                    -0.0000063542,
                    -0.0000064128,
                    -0.0000064684,
                    -0.0000065221,
                    -0.0000065736,
                    -0.0000066239,
                    -0.0000066728,
                    -0.0000067201,
                    -0.0000067667,
                    -0.0000068186,
                    -0.0000068719,
                    -0.0000069253,
                    -0.0000069775,
                    -0.0000070273,
                    -0.0000070752,
                    -0.0000071211,
                    -0.0000071648,
                    -0.0000072055,
                    -0.0000072445,
                    -0.0000072887,
                    -0.0000073346,
                    -0.0000073816,
                    -0.0000074275,
                    -0.0000074733,
                    -0.0000075184,
                    -0.0000075624,
                    -0.0000076049,
                    -0.0000076466,
                    -0.0000076873,
                    -0.000007736,
                    -0.0000077887,
                    -0.0000078428,
                    -0.0000078976,
                    -0.000007954,
                    -0.0000080098,
                    -0.0000080673,
                    -0.0000081233,
                    -0.0000081795,
                    -0.0000082349,
                    -0.0000082111,
                    -0.0000081831,
                    -0.0000081457,
                    -0.0000081117,
                    -0.000006113,
                    -0.000005003,
                    -0.0000039691,
                    -0.0000026601,
                    -0.0000018443,
                    -0.00000099359,
                    3.4093e-07,
                    1.3275e-06,
                    2.9457e-06,
                    4.1744e-06,
                    5.775e-06,
                    7.5526e-06,
                    9.1317e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Fossil_CO2": 0.04,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2.64e-08,
                    4.455e-08,
                    7.095e-08,
                    1.023e-07,
                    2.1087e-06,
                    3.2274e-06,
                    4.2768e-06,
                    5.6084e-06,
                    6.4564e-06,
                    7.628e-06,
                    9.2631e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Land_CO2": -0,
                "Land_CO2_timeseries": [
                    -0.00000012931,
                    -0.00000025681,
                    -0.00000038267,
                    -0.00000050711,
                    -0.00000063031,
                    -0.00000075242,
                    -0.0000008736,
                    -0.00000099397,
                    -0.0000011136,
                    -0.0000012336,
                    -0.0000013536,
                    -0.0000014734,
                    -0.0000015929,
                    -0.0000017122,
                    -0.0000018312,
                    -0.0000019499,
                    -0.0000020684,
                    -0.0000021865,
                    -0.0000023044,
                    -0.0000024148,
                    -0.000002522,
                    -0.0000026271,
                    -0.0000027308,
                    -0.000002833,
                    -0.0000029341,
                    -0.000003034,
                    -0.0000031328,
                    -0.0000032305,
                    -0.0000033272,
                    -0.0000034246,
                    -0.0000035221,
                    -0.0000036192,
                    -0.0000037159,
                    -0.000003812,
                    -0.0000039076,
                    -0.0000040026,
                    -0.000004097,
                    -0.0000041908,
                    -0.0000042839,
                    -0.0000043789,
                    -0.0000044746,
                    -0.0000045704,
                    -0.0000046663,
                    -0.0000047621,
                    -0.0000048576,
                    -0.0000049529,
                    -0.0000050479,
                    -0.0000051426,
                    -0.0000052369,
                    -0.0000053334,
                    -0.0000054311,
                    -0.000005529,
                    -0.0000056275,
                    -0.0000057259,
                    -0.0000058244,
                    -0.0000059225,
                    -0.0000060203,
                    -0.0000061183,
                    -0.0000062159,
                    -0.0000062897,
                    -0.0000063542,
                    -0.0000064128,
                    -0.0000064684,
                    -0.0000065221,
                    -0.0000065736,
                    -0.0000066239,
                    -0.0000066728,
                    -0.0000067201,
                    -0.0000067667,
                    -0.0000068186,
                    -0.0000068719,
                    -0.0000069253,
                    -0.0000069775,
                    -0.0000070273,
                    -0.0000070752,
                    -0.0000071211,
                    -0.0000071648,
                    -0.0000072055,
                    -0.0000072445,
                    -0.0000072887,
                    -0.0000073346,
                    -0.0000073816,
                    -0.0000074275,
                    -0.0000074733,
                    -0.0000075184,
                    -0.0000075624,
                    -0.0000076049,
                    -0.0000076466,
                    -0.0000076873,
                    -0.000007736,
                    -0.0000077887,
                    -0.0000078428,
                    -0.0000078976,
                    -0.000007954,
                    -0.0000080098,
                    -0.0000080673,
                    -0.0000081233,
                    -0.0000081795,
                    -0.0000082349,
                    -0.0000082375,
                    -0.0000082276,
                    -0.0000082167,
                    -0.000008214,
                    -0.0000082217,
                    -0.0000082304,
                    -0.0000082459,
                    -0.0000082685,
                    -0.0000083007,
                    -0.0000086215,
                    -0.0000089222,
                    -0.0000091351,
                    -0.0000092659,
                    -0.0000093507,
                    -0.0000093852,
                    -0.0000093764,
                    -0.0000093566,
                    -0.0000093312,
                    -0.0000092714,
                    -0.0000092127,
                    -0.0000091306,
                    -0.0000090141,
                    -0.0000089083,
                    -0.0000087988,
                    -0.0000086491,
                    -0.0000085448,
                    -0.0000084655,
                    -0.0000083958,
                    -0.000008344,
                    -0.0000083076,
                    -0.0000082729,
                    -0.0000082481,
                    -0.0000082261,
                    -0.0000082022,
                    -0.0000081517,
                    -0.0000081031,
                    -0.0000080087,
                    -0.0000079308,
                    -0.0000077718,
                    -0.000006838,
                    -0.0000062955,
                    -0.000006049,
                    -0.000004537,
                    -0.0000036268,
                    -0.0000029404,
                    -0.0000021965,
                    -0.0000017136,
                    -0.0000014082,
                    -0.0000011905,
                    -0.00000089164,
                    -0.00000083761,
                    -0.00000038353,
                    -0.00000041237,
                    1.1128e-07,
                    6.0163e-07,
                    1.252e-06,
                    1.658e-06,
                    1.6429e-06,
                    1.4743e-06,
                    1.9415e-06,
                    1.8702e-06,
                    1.9614e-06,
                    1.9137e-06,
                    1.7467e-06,
                    1.5498e-06,
                    1.285e-06,
                    1.0896e-06,
                    8.4129e-07,
                    5.9726e-07,
                    3.5843e-07,
                    1.2225e-07,
                    -0.00000011579,
                    -0.00000037722
                ],
                "Total_CH4": 0.18,
                "Total_CH4_timeseries": [
                    4.1021e-07,
                    8.2116e-07,
                    1.2329e-06,
                    1.6453e-06,
                    2.0585e-06,
                    2.4724e-06,
                    2.8871e-06,
                    3.3026e-06,
                    3.7188e-06,
                    4.1357e-06,
                    4.5534e-06,
                    4.9718e-06,
                    5.391e-06,
                    5.8109e-06,
                    6.2316e-06,
                    6.6531e-06,
                    7.0752e-06,
                    7.4982e-06,
                    7.9219e-06,
                    8.3463e-06,
                    8.7814e-06,
                    9.2271e-06,
                    9.6835e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Fossil_CH4": 0.21,
                "Fossil_CH4_timeseries": [
                    2.1695e-07,
                    4.3425e-07,
                    6.5191e-07,
                    8.6992e-07,
                    1.0883e-06,
                    1.307e-06,
                    1.5261e-06,
                    1.7455e-06,
                    1.9653e-06,
                    2.1854e-06,
                    2.4059e-06,
                    2.6267e-06,
                    2.8479e-06,
                    3.0694e-06,
                    3.2913e-06,
                    3.5136e-06,
                    3.7361e-06,
                    3.9591e-06,
                    4.1824e-06,
                    4.406e-06,
                    4.6352e-06,
                    4.8701e-06,
                    5.1106e-06,
                    5.3568e-06,
                    5.6085e-06,
                    5.8659e-06,
                    6.1289e-06,
                    6.3975e-06,
                    6.6717e-06,
                    6.9515e-06,
                    7.2351e-06,
                    7.5226e-06,
                    7.8139e-06,
                    8.109e-06,
                    8.408e-06,
                    8.7107e-06,
                    9.0173e-06,
                    9.3277e-06,
                    9.6419e-06,
                    9.9599e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    9.3764e-06,
                    8.1461e-06,
                    6.9622e-06,
                    5.8289e-06,
                    4.7508e-06,
                    3.7397e-06,
                    2.8003e-06,
                    1.9374e-06,
                    1.1558e-06,
                    4.605e-07,
                    -0.00000014088,
                    -0.00000063508,
                    -0.000001015,
                    -0.0000012753,
                    -0.0000012496,
                    -0.0000011684,
                    -0.00000095946,
                    -0.00000059108,
                    -0.00000010917,
                    5.4653e-07,
                    1.256e-06,
                    1.966e-06,
                    2.7313e-06,
                    3.5023e-06,
                    4.3172e-06,
                    5.1606e-06,
                    6.0211e-06,
                    6.903e-06,
                    7.9321e-06,
                    8.8942e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006
                ],
                "Land_CH4": 0.12,
                "Land_CH4_timeseries": [
                    1.9326e-07,
                    3.8691e-07,
                    5.8095e-07,
                    7.7539e-07,
                    9.7022e-07,
                    1.1654e-06,
                    1.3611e-06,
                    1.5571e-06,
                    1.7535e-06,
                    1.9503e-06,
                    2.1475e-06,
                    2.3451e-06,
                    2.5431e-06,
                    2.7415e-06,
                    2.9403e-06,
                    3.1395e-06,
                    3.3391e-06,
                    3.5391e-06,
                    3.7395e-06,
                    3.9403e-06,
                    4.1462e-06,
                    4.357e-06,
                    4.5729e-06,
                    4.7937e-06,
                    5.0196e-06,
                    5.2505e-06,
                    5.4864e-06,
                    5.7273e-06,
                    5.9733e-06,
                    6.2242e-06,
                    6.4786e-06,
                    6.7365e-06,
                    6.9979e-06,
                    7.2627e-06,
                    7.531e-06,
                    7.8028e-06,
                    8.078e-06,
                    8.3567e-06,
                    8.6389e-06,
                    8.9246e-06,
                    9.2096e-06,
                    9.4939e-06,
                    9.7775e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Total_N2O": 0.12,
                "Total_N2O_timeseries": [
                    5.383e-08,
                    1.087e-07,
                    1.6458e-07,
                    2.2139e-07,
                    2.7907e-07,
                    3.3751e-07,
                    3.9662e-07,
                    4.5626e-07,
                    5.1629e-07,
                    5.7654e-07,
                    6.3693e-07,
                    6.9742e-07,
                    7.58e-07,
                    8.1865e-07,
                    8.7936e-07,
                    9.4015e-07,
                    1.001e-06,
                    1.062e-06,
                    1.123e-06,
                    1.1842e-06,
                    1.2464e-06,
                    1.311e-06,
                    1.3793e-06,
                    1.4519e-06,
                    1.5293e-06,
                    1.6116e-06,
                    1.6986e-06,
                    1.7898e-06,
                    1.8841e-06,
                    1.9805e-06,
                    2.0779e-06,
                    2.1763e-06,
                    2.2755e-06,
                    2.3754e-06,
                    2.4759e-06,
                    2.577e-06,
                    2.6788e-06,
                    2.7811e-06,
                    2.8841e-06,
                    2.9917e-06,
                    3.0996e-06,
                    3.2076e-06,
                    3.3161e-06,
                    3.4249e-06,
                    3.5342e-06,
                    3.644e-06,
                    3.7543e-06,
                    3.8651e-06,
                    3.9765e-06,
                    4.0886e-06,
                    4.2013e-06,
                    4.3148e-06,
                    4.4292e-06,
                    4.5446e-06,
                    4.661e-06,
                    4.7786e-06,
                    4.8972e-06,
                    5.017e-06,
                    5.1379e-06,
                    5.2599e-06,
                    5.3829e-06,
                    5.5068e-06,
                    5.6317e-06,
                    5.7574e-06,
                    5.884e-06,
                    6.0116e-06,
                    6.1404e-06,
                    6.2706e-06,
                    6.4022e-06,
                    6.5357e-06,
                    6.6725e-06,
                    6.8149e-06,
                    6.9649e-06,
                    7.1238e-06,
                    7.2928e-06,
                    7.4723e-06,
                    7.6623e-06,
                    7.8626e-06,
                    8.0722e-06,
                    8.2899e-06,
                    8.5148e-06,
                    8.747e-06,
                    8.9865e-06,
                    9.2333e-06,
                    9.4876e-06,
                    9.7494e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Fossil_N2O": 0.12,
                "Fossil_N2O_timeseries": [
                    5.0716e-09,
                    1.0211e-08,
                    1.5418e-08,
                    2.0688e-08,
                    2.6021e-08,
                    3.1412e-08,
                    3.6858e-08,
                    4.2354e-08,
                    4.7895e-08,
                    5.3476e-08,
                    5.9093e-08,
                    6.4745e-08,
                    7.0431e-08,
                    7.6152e-08,
                    8.1906e-08,
                    8.7694e-08,
                    9.3517e-08,
                    9.9374e-08,
                    1.0527e-07,
                    1.1119e-07,
                    1.1719e-07,
                    1.233e-07,
                    1.2957e-07,
                    1.3603e-07,
                    1.4268e-07,
                    1.4954e-07,
                    1.566e-07,
                    1.6383e-07,
                    1.7121e-07,
                    1.7869e-07,
                    1.8623e-07,
                    1.9385e-07,
                    2.0152e-07,
                    2.0925e-07,
                    2.1703e-07,
                    2.2487e-07,
                    2.3275e-07,
                    2.407e-07,
                    2.4869e-07,
                    2.5675e-07,
                    2.6488e-07,
                    2.7307e-07,
                    2.8132e-07,
                    2.8964e-07,
                    2.9803e-07,
                    3.0649e-07,
                    3.1502e-07,
                    3.2362e-07,
                    3.3231e-07,
                    3.4107e-07,
                    3.4992e-07,
                    3.5888e-07,
                    3.6794e-07,
                    3.7711e-07,
                    3.8641e-07,
                    3.9582e-07,
                    4.0536e-07,
                    4.1502e-07,
                    4.248e-07,
                    4.347e-07,
                    4.447e-07,
                    4.5483e-07,
                    4.6506e-07,
                    4.754e-07,
                    4.8586e-07,
                    4.9643e-07,
                    5.0711e-07,
                    5.1791e-07,
                    5.2882e-07,
                    5.3984e-07,
                    5.5097e-07,
                    5.6222e-07,
                    5.7359e-07,
                    5.8508e-07,
                    5.9668e-07,
                    6.0841e-07,
                    6.2024e-07,
                    6.3219e-07,
                    6.4425e-07,
                    6.5642e-07,
                    6.6892e-07,
                    6.8214e-07,
                    6.9641e-07,
                    7.1199e-07,
                    7.2908e-07,
                    7.478e-07,
                    7.682e-07,
                    7.9027e-07,
                    8.1393e-07,
                    8.3902e-07,
                    8.6566e-07,
                    8.9416e-07,
                    9.2478e-07,
                    9.5766e-07,
                    9.9282e-07,
                    1.0302e-06,
                    1.0697e-06,
                    1.1109e-06,
                    1.1537e-06,
                    1.1974e-06,
                    1.2417e-06,
                    1.2867e-06,
                    1.3321e-06,
                    1.378e-06,
                    1.4243e-06,
                    1.471e-06,
                    1.5182e-06,
                    1.566e-06,
                    1.6144e-06,
                    1.6636e-06,
                    1.7152e-06,
                    1.7721e-06,
                    1.8373e-06,
                    1.9136e-06,
                    2.0037e-06,
                    2.1104e-06,
                    2.2364e-06,
                    2.3842e-06,
                    2.5564e-06,
                    2.7101e-06,
                    2.868e-06,
                    3.031e-06,
                    3.2017e-06,
                    3.3752e-06,
                    3.5505e-06,
                    3.7381e-06,
                    3.933e-06,
                    4.137e-06,
                    4.3507e-06,
                    4.5755e-06,
                    4.8094e-06,
                    5.0538e-06,
                    5.3097e-06,
                    5.5715e-06,
                    5.8455e-06,
                    6.1335e-06,
                    6.4332e-06,
                    6.7487e-06,
                    7.076e-06,
                    7.4025e-06,
                    7.7575e-06,
                    8.1305e-06,
                    8.5097e-06,
                    8.9114e-06,
                    9.3574e-06,
                    9.8276e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.12,
                "Land_N2O_timeseries": [
                    4.8759e-08,
                    9.8493e-08,
                    1.4916e-07,
                    2.007e-07,
                    2.5305e-07,
                    3.061e-07,
                    3.5976e-07,
                    4.139e-07,
                    4.6839e-07,
                    5.2307e-07,
                    5.7784e-07,
                    6.3268e-07,
                    6.8757e-07,
                    7.425e-07,
                    7.9746e-07,
                    8.5245e-07,
                    9.0749e-07,
                    9.6258e-07,
                    1.0177e-06,
                    1.073e-06,
                    1.1292e-06,
                    1.1877e-06,
                    1.2497e-06,
                    1.3158e-06,
                    1.3866e-06,
                    1.4621e-06,
                    1.542e-06,
                    1.6259e-06,
                    1.7129e-06,
                    1.8018e-06,
                    1.8917e-06,
                    1.9825e-06,
                    2.074e-06,
                    2.1661e-06,
                    2.2589e-06,
                    2.3522e-06,
                    2.446e-06,
                    2.5404e-06,
                    2.6355e-06,
                    2.735e-06,
                    2.8347e-06,
                    2.9346e-06,
                    3.0348e-06,
                    3.1353e-06,
                    3.2362e-06,
                    3.3375e-06,
                    3.4392e-06,
                    3.5415e-06,
                    3.6442e-06,
                    3.7475e-06,
                    3.8514e-06,
                    3.9559e-06,
                    4.0613e-06,
                    4.1675e-06,
                    4.2746e-06,
                    4.3827e-06,
                    4.4919e-06,
                    4.602e-06,
                    4.7131e-06,
                    4.8252e-06,
                    4.9382e-06,
                    5.052e-06,
                    5.1666e-06,
                    5.282e-06,
                    5.3981e-06,
                    5.5152e-06,
                    5.6333e-06,
                    5.7526e-06,
                    5.8734e-06,
                    5.9959e-06,
                    6.1215e-06,
                    6.2527e-06,
                    6.3913e-06,
                    6.5388e-06,
                    6.6961e-06,
                    6.8638e-06,
                    7.0421e-06,
                    7.2304e-06,
                    7.4279e-06,
                    7.6335e-06,
                    7.8459e-06,
                    8.0649e-06,
                    8.2901e-06,
                    8.5214e-06,
                    8.7585e-06,
                    9.0016e-06,
                    9.2507e-06,
                    9.5059e-06,
                    9.7675e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                42.76391,
                                16.40456
                            ],
                            [
                                42.79107,
                                16.33168
                            ],
                            [
                                42.83382,
                                16.06664
                            ],
                            [
                                42.80672,
                                15.86935
                            ],
                            [
                                42.73373,
                                15.75657
                            ],
                            [
                                42.68763,
                                15.72536
                            ],
                            [
                                42.69793,
                                15.55823
                            ],
                            [
                                42.73851,
                                15.52752
                            ],
                            [
                                42.80451,
                                15.28255
                            ],
                            [
                                42.77545,
                                15.23565
                            ],
                            [
                                42.70543,
                                15.3072
                            ],
                            [
                                42.66785,
                                15.21119
                            ],
                            [
                                42.74135,
                                15.20256
                            ],
                            [
                                42.85009,
                                15.14213
                            ],
                            [
                                42.87166,
                                15.02362
                            ],
                            [
                                42.91618,
                                14.97078
                            ],
                            [
                                42.94642,
                                14.86963
                            ],
                            [
                                42.92978,
                                14.8148
                            ],
                            [
                                42.98186,
                                14.62456
                            ],
                            [
                                43.01232,
                                14.55517
                            ],
                            [
                                42.99405,
                                14.39762
                            ],
                            [
                                43.07168,
                                14.22752
                            ],
                            [
                                43.10543,
                                14.06256
                            ],
                            [
                                43.17481,
                                13.9387
                            ],
                            [
                                43.23116,
                                13.88463
                            ],
                            [
                                43.23735,
                                13.80462
                            ],
                            [
                                43.28864,
                                13.67891
                            ],
                            [
                                43.29211,
                                13.59851
                            ],
                            [
                                43.26634,
                                13.53173
                            ],
                            [
                                43.24074,
                                13.25145
                            ],
                            [
                                43.29022,
                                13.14324
                            ],
                            [
                                43.34686,
                                13.07088
                            ],
                            [
                                43.40942,
                                12.94028
                            ],
                            [
                                43.48773,
                                12.82623
                            ],
                            [
                                43.45986,
                                12.67741
                            ],
                            [
                                43.52743,
                                12.68032
                            ],
                            [
                                43.60254,
                                12.74446
                            ],
                            [
                                43.79895,
                                12.68879
                            ],
                            [
                                43.90385,
                                12.64382
                            ],
                            [
                                43.94789,
                                12.59304
                            ],
                            [
                                44.05487,
                                12.60356
                            ],
                            [
                                44.15214,
                                12.65414
                            ],
                            [
                                44.2891,
                                12.62993
                            ],
                            [
                                44.39988,
                                12.68068
                            ],
                            [
                                44.41986,
                                12.6704
                            ],
                            [
                                44.49837,
                                12.7672
                            ],
                            [
                                44.57891,
                                12.81126
                            ],
                            [
                                44.67693,
                                12.80243
                            ],
                            [
                                44.7278,
                                12.76473
                            ],
                            [
                                44.80664,
                                12.76864
                            ],
                            [
                                44.87529,
                                12.72729
                            ],
                            [
                                44.91901,
                                12.81578
                            ],
                            [
                                44.98801,
                                12.82401
                            ],
                            [
                                45.02047,
                                12.79101
                            ],
                            [
                                45.10421,
                                12.94414
                            ],
                            [
                                45.15029,
                                12.98884
                            ],
                            [
                                45.29803,
                                13.03984
                            ],
                            [
                                45.38394,
                                13.05622
                            ],
                            [
                                45.4614,
                                13.13226
                            ],
                            [
                                45.56861,
                                13.26731
                            ],
                            [
                                45.64753,
                                13.3344
                            ],
                            [
                                45.81189,
                                13.37883
                            ],
                            [
                                46.03789,
                                13.41575
                            ],
                            [
                                46.08017,
                                13.4081
                            ],
                            [
                                46.24793,
                                13.42645
                            ],
                            [
                                46.44224,
                                13.40371
                            ],
                            [
                                46.61461,
                                13.43467
                            ],
                            [
                                46.69123,
                                13.42446
                            ],
                            [
                                46.81311,
                                13.46722
                            ],
                            [
                                46.92848,
                                13.53856
                            ],
                            [
                                47.08034,
                                13.56266
                            ],
                            [
                                47.33069,
                                13.63693
                            ],
                            [
                                47.38505,
                                13.64471
                            ],
                            [
                                47.47286,
                                13.70528
                            ],
                            [
                                47.63972,
                                13.86393
                            ],
                            [
                                47.71146,
                                13.90609
                            ],
                            [
                                47.80414,
                                13.92339
                            ],
                            [
                                47.96945,
                                14.0442
                            ],
                            [
                                48.06769,
                                14.04721
                            ],
                            [
                                48.14365,
                                14.01925
                            ],
                            [
                                48.19171,
                                13.97645
                            ],
                            [
                                48.29658,
                                13.98448
                            ],
                            [
                                48.33944,
                                14.01758
                            ],
                            [
                                48.49494,
                                14.00206
                            ],
                            [
                                48.55567,
                                14.03749
                            ],
                            [
                                48.68613,
                                14.03997
                            ],
                            [
                                48.8378,
                                14.1625
                            ],
                            [
                                48.87877,
                                14.23831
                            ],
                            [
                                48.99753,
                                14.31847
                            ],
                            [
                                49.00747,
                                14.40353
                            ],
                            [
                                49.0801,
                                14.50325
                            ],
                            [
                                49.18088,
                                14.54107
                            ],
                            [
                                49.3103,
                                14.61756
                            ],
                            [
                                49.49442,
                                14.68794
                            ],
                            [
                                49.63437,
                                14.7548
                            ],
                            [
                                49.74741,
                                14.77696
                            ],
                            [
                                49.93706,
                                14.84612
                            ],
                            [
                                50.02762,
                                14.81602
                            ],
                            [
                                50.18836,
                                14.86182
                            ],
                            [
                                50.47234,
                                15.01929
                            ],
                            [
                                50.61694,
                                15.0545
                            ],
                            [
                                50.72062,
                                15.0652
                            ],
                            [
                                50.89252,
                                15.11206
                            ],
                            [
                                51.22416,
                                15.18897
                            ],
                            [
                                51.45567,
                                15.27035
                            ],
                            [
                                51.4808,
                                15.29501
                            ],
                            [
                                51.59226,
                                15.32855
                            ],
                            [
                                51.65044,
                                15.38472
                            ],
                            [
                                51.81942,
                                15.45206
                            ],
                            [
                                51.96755,
                                15.52853
                            ],
                            [
                                52.17432,
                                15.59983
                            ],
                            [
                                52.22624,
                                15.63389
                            ],
                            [
                                52.19062,
                                15.75735
                            ],
                            [
                                52.18804,
                                15.83468
                            ],
                            [
                                52.14776,
                                15.95506
                            ],
                            [
                                52.20508,
                                16.13622
                            ],
                            [
                                52.27751,
                                16.25735
                            ],
                            [
                                52.37397,
                                16.36063
                            ],
                            [
                                52.45294,
                                16.42216
                            ],
                            [
                                52.59896,
                                16.48308
                            ],
                            [
                                52.82103,
                                16.56012
                            ],
                            [
                                52.94786,
                                16.61564
                            ],
                            [
                                53.10703,
                                16.65439
                            ],
                            [
                                52.81289,
                                17.28387
                            ],
                            [
                                52.74876,
                                17.29411
                            ],
                            [
                                52.78077,
                                17.35266
                            ],
                            [
                                52.58793,
                                17.76096
                            ],
                            [
                                52.26345,
                                18.4459
                            ],
                            [
                                52.0,
                                19.0
                            ],
                            [
                                51.1347,
                                18.84992
                            ],
                            [
                                50.7836,
                                18.78898
                            ],
                            [
                                49.91066,
                                18.69998
                            ],
                            [
                                49.11668,
                                18.61642
                            ],
                            [
                                48.49494,
                                18.31687
                            ],
                            [
                                48.18448,
                                18.1671
                            ],
                            [
                                47.60086,
                                17.45094
                            ],
                            [
                                47.46637,
                                17.11701
                            ],
                            [
                                47.18517,
                                16.95114
                            ],
                            [
                                47.0,
                                16.95
                            ],
                            [
                                46.75,
                                17.28333
                            ],
                            [
                                46.36667,
                                17.23333
                            ],
                            [
                                46.1,
                                17.25
                            ],
                            [
                                45.39935,
                                17.33385
                            ],
                            [
                                45.21263,
                                17.43333
                            ],
                            [
                                44.65209,
                                17.43329
                            ],
                            [
                                44.56656,
                                17.40601
                            ],
                            [
                                44.46647,
                                17.43314
                            ],
                            [
                                44.36529,
                                17.43319
                            ],
                            [
                                44.01124,
                                17.40018
                            ],
                            [
                                43.96469,
                                17.33166
                            ],
                            [
                                43.83476,
                                17.33928
                            ],
                            [
                                43.78647,
                                17.37441
                            ],
                            [
                                43.68187,
                                17.36863
                            ],
                            [
                                43.5658,
                                17.48368
                            ],
                            [
                                43.48144,
                                17.546
                            ],
                            [
                                43.42161,
                                17.56503
                            ],
                            [
                                43.35371,
                                17.55445
                            ],
                            [
                                43.24359,
                                17.48105
                            ],
                            [
                                43.23075,
                                17.38435
                            ],
                            [
                                43.32287,
                                17.33002
                            ],
                            [
                                43.20031,
                                17.24285
                            ],
                            [
                                43.1529,
                                17.17146
                            ],
                            [
                                43.16047,
                                17.09006
                            ],
                            [
                                43.22639,
                                17.07421
                            ],
                            [
                                43.14622,
                                16.92537
                            ],
                            [
                                43.14881,
                                16.88127
                            ],
                            [
                                43.26466,
                                16.79613
                            ],
                            [
                                43.22765,
                                16.69934
                            ],
                            [
                                43.16022,
                                16.66617
                            ],
                            [
                                43.11996,
                                16.53065
                            ],
                            [
                                42.99269,
                                16.5208
                            ],
                            [
                                42.95264,
                                16.49813
                            ],
                            [
                                42.93985,
                                16.41095
                            ],
                            [
                                42.83278,
                                16.38002
                            ],
                            [
                                42.76391,
                                16.40456
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                53.30397,
                                12.53731
                            ],
                            [
                                53.46585,
                                12.44137
                            ],
                            [
                                53.5445,
                                12.34178
                            ],
                            [
                                53.7277,
                                12.30103
                            ],
                            [
                                53.89996,
                                12.32758
                            ],
                            [
                                53.99995,
                                12.32804
                            ],
                            [
                                54.03135,
                                12.3496
                            ],
                            [
                                54.13418,
                                12.34944
                            ],
                            [
                                54.26068,
                                12.44109
                            ],
                            [
                                54.40363,
                                12.46641
                            ],
                            [
                                54.46636,
                                12.54461
                            ],
                            [
                                54.35908,
                                12.60582
                            ],
                            [
                                54.30322,
                                12.61093
                            ],
                            [
                                54.11458,
                                12.6978
                            ],
                            [
                                53.95165,
                                12.64063
                            ],
                            [
                                53.8772,
                                12.64581
                            ],
                            [
                                53.84599,
                                12.60467
                            ],
                            [
                                53.7677,
                                12.61759
                            ],
                            [
                                53.64494,
                                12.70372
                            ],
                            [
                                53.54764,
                                12.71413
                            ],
                            [
                                53.39695,
                                12.65576
                            ],
                            [
                                53.382,
                                12.55399
                            ],
                            [
                                53.30397,
                                12.53731
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                52.26345,
                                12.21038
                            ],
                            [
                                52.20117,
                                12.21189
                            ],
                            [
                                52.12928,
                                12.2473
                            ],
                            [
                                52.0995,
                                12.21448
                            ],
                            [
                                52.22176,
                                12.18985
                            ],
                            [
                                52.26345,
                                12.21038
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                42.67684,
                                14.00679
                            ],
                            [
                                42.70835,
                                13.96262
                            ],
                            [
                                42.77246,
                                13.96167
                            ],
                            [
                                42.77908,
                                14.04638
                            ],
                            [
                                42.75349,
                                14.06514
                            ],
                            [
                                42.67684,
                                14.00679
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                42.53255,
                                15.30804
                            ],
                            [
                                42.58566,
                                15.26581
                            ],
                            [
                                42.63365,
                                15.40216
                            ],
                            [
                                42.55475,
                                15.39334
                            ],
                            [
                                42.53255,
                                15.30804
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                52.98037,
                                12.16292
                            ],
                            [
                                53.06477,
                                12.1292
                            ],
                            [
                                53.06776,
                                12.17904
                            ],
                            [
                                52.98037,
                                12.16292
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "ZMB",
                "Country": "Zambia",
                "Total_3GHG": 0.21,
                "Total_3GHG_timeseries": [
                    3.9456e-06,
                    7.9318e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.0031,
                    0.0031,
                    0.0032,
                    0.0032,
                    0.0032,
                    0.0033,
                    0.0033,
                    0.0034,
                    0.0034,
                    0.0035,
                    0.0035
                ],
                "Fossil_3GHG": 0.04,
                "Fossil_3GHG_timeseries": [
                    3.1896e-08,
                    6.3939e-08,
                    9.6126e-08,
                    1.2845e-07,
                    1.6091e-07,
                    1.9351e-07,
                    2.2622e-07,
                    2.5904e-07,
                    2.9197e-07,
                    3.2499e-07,
                    3.5847e-07,
                    3.9242e-07,
                    4.2732e-07,
                    4.6405e-07,
                    5.0265e-07,
                    5.4317e-07,
                    5.8564e-07,
                    6.3011e-07,
                    6.7664e-07,
                    7.2527e-07,
                    7.761e-07,
                    8.2929e-07,
                    8.8496e-07,
                    9.4324e-07,
                    1.0042e-06,
                    1.0679e-06,
                    1.1344e-06,
                    1.2037e-06,
                    1.2758e-06,
                    1.3507e-06,
                    1.428e-06,
                    1.5079e-06,
                    1.5898e-06,
                    1.673e-06,
                    1.7576e-06,
                    1.8436e-06,
                    1.931e-06,
                    2.0199e-06,
                    2.1103e-06,
                    2.2026e-06,
                    2.2966e-06,
                    2.3924e-06,
                    2.49e-06,
                    2.5894e-06,
                    2.6907e-06,
                    2.794e-06,
                    2.8993e-06,
                    3.0067e-06,
                    3.1162e-06,
                    3.2279e-06,
                    3.3471e-06,
                    3.4742e-06,
                    3.6097e-06,
                    3.7539e-06,
                    3.9074e-06,
                    4.0706e-06,
                    4.2439e-06,
                    4.4277e-06,
                    4.6227e-06,
                    4.8291e-06,
                    5.0529e-06,
                    5.2946e-06,
                    5.5547e-06,
                    5.8338e-06,
                    6.1326e-06,
                    6.4517e-06,
                    6.7918e-06,
                    7.1537e-06,
                    7.538e-06,
                    7.9455e-06,
                    8.3734e-06,
                    8.8221e-06,
                    9.2923e-06,
                    9.7845e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005
                ],
                "Land_3GHG": 0.53,
                "Land_3GHG_timeseries": [
                    3.9137e-06,
                    7.8678e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0024,
                    0.0024,
                    0.0024,
                    0.0025,
                    0.0025,
                    0.0026,
                    0.0026,
                    0.0026,
                    0.0027,
                    0.0027,
                    0.0028,
                    0.0028,
                    0.0028,
                    0.0029,
                    0.0029,
                    0.0029,
                    0.003,
                    0.003,
                    0.003,
                    0.0031
                ],
                "Total_CO2": 0.21,
                "Total_CO2_timeseries": [
                    3.6884e-06,
                    7.4139e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022,
                    0.0023,
                    0.0023,
                    0.0023,
                    0.0023
                ],
                "Fossil_CO2": 0.02,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1.0493e-06,
                    2.2064e-06,
                    3.508e-06,
                    4.9267e-06,
                    6.4866e-06,
                    8.3261e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ],
                "Land_CO2": 0.62,
                "Land_CO2_timeseries": [
                    3.6884e-06,
                    7.4139e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.0019,
                    0.002,
                    0.002,
                    0.002,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0021,
                    0.0022,
                    0.0022,
                    0.0022
                ],
                "Total_CH4": 0.19,
                "Total_CH4_timeseries": [
                    8.3223e-08,
                    1.6653e-07,
                    2.4992e-07,
                    3.334e-07,
                    4.1696e-07,
                    5.0061e-07,
                    5.8434e-07,
                    6.6816e-07,
                    7.5206e-07,
                    8.3606e-07,
                    9.2143e-07,
                    1.0082e-06,
                    1.0968e-06,
                    1.1882e-06,
                    1.2824e-06,
                    1.3794e-06,
                    1.4793e-06,
                    1.5821e-06,
                    1.6878e-06,
                    1.7966e-06,
                    1.9085e-06,
                    2.0235e-06,
                    2.1417e-06,
                    2.2632e-06,
                    2.3879e-06,
                    2.516e-06,
                    2.6475e-06,
                    2.7825e-06,
                    2.921e-06,
                    3.0631e-06,
                    3.2076e-06,
                    3.3548e-06,
                    3.504e-06,
                    3.6547e-06,
                    3.8068e-06,
                    3.9604e-06,
                    4.1155e-06,
                    4.2721e-06,
                    4.4304e-06,
                    4.5902e-06,
                    4.7517e-06,
                    4.9149e-06,
                    5.0799e-06,
                    5.2466e-06,
                    5.4152e-06,
                    5.5856e-06,
                    5.758e-06,
                    5.9324e-06,
                    6.1087e-06,
                    6.2872e-06,
                    6.4712e-06,
                    6.6612e-06,
                    6.8576e-06,
                    7.0608e-06,
                    7.2711e-06,
                    7.4891e-06,
                    7.7153e-06,
                    7.95e-06,
                    8.1939e-06,
                    8.4473e-06,
                    8.7314e-06,
                    9.0466e-06,
                    9.3935e-06,
                    9.7728e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008
                ],
                "Fossil_CH4": 0.12,
                "Fossil_CH4_timeseries": [
                    2.4219e-08,
                    4.8472e-08,
                    7.2761e-08,
                    9.7085e-08,
                    1.2144e-07,
                    1.4584e-07,
                    1.7027e-07,
                    1.9474e-07,
                    2.1924e-07,
                    2.4379e-07,
                    2.6875e-07,
                    2.9412e-07,
                    3.2041e-07,
                    3.4848e-07,
                    3.7838e-07,
                    4.1016e-07,
                    4.4384e-07,
                    4.7948e-07,
                    5.1713e-07,
                    5.5684e-07,
                    5.9863e-07,
                    6.4258e-07,
                    6.8871e-07,
                    7.371e-07,
                    7.878e-07,
                    8.4085e-07,
                    8.9632e-07,
                    9.5427e-07,
                    1.0148e-06,
                    1.0778e-06,
                    1.1433e-06,
                    1.211e-06,
                    1.2808e-06,
                    1.3519e-06,
                    1.4242e-06,
                    1.4978e-06,
                    1.5727e-06,
                    1.6491e-06,
                    1.7269e-06,
                    1.8061e-06,
                    1.8868e-06,
                    1.9691e-06,
                    2.0529e-06,
                    2.1384e-06,
                    2.2255e-06,
                    2.3144e-06,
                    2.405e-06,
                    2.4974e-06,
                    2.5917e-06,
                    2.6879e-06,
                    2.7913e-06,
                    2.9022e-06,
                    3.0211e-06,
                    3.1484e-06,
                    3.2845e-06,
                    3.4298e-06,
                    3.5849e-06,
                    3.7502e-06,
                    3.9262e-06,
                    4.1134e-06,
                    4.3176e-06,
                    4.5395e-06,
                    4.7796e-06,
                    5.0384e-06,
                    5.3168e-06,
                    5.6152e-06,
                    5.9344e-06,
                    6.275e-06,
                    6.6379e-06,
                    7.0238e-06,
                    7.4298e-06,
                    7.8564e-06,
                    8.3043e-06,
                    8.7738e-06,
                    9.2658e-06,
                    9.7807e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Land_CH4": 0.32,
                "Land_CH4_timeseries": [
                    5.9004e-08,
                    1.1806e-07,
                    1.7716e-07,
                    2.3631e-07,
                    2.9552e-07,
                    3.5477e-07,
                    4.1407e-07,
                    4.7342e-07,
                    5.3282e-07,
                    5.9227e-07,
                    6.5268e-07,
                    7.1406e-07,
                    7.764e-07,
                    8.3971e-07,
                    9.0398e-07,
                    9.6922e-07,
                    1.0354e-06,
                    1.1026e-06,
                    1.1707e-06,
                    1.2398e-06,
                    1.3099e-06,
                    1.381e-06,
                    1.453e-06,
                    1.5261e-06,
                    1.6001e-06,
                    1.6752e-06,
                    1.7512e-06,
                    1.8282e-06,
                    1.9062e-06,
                    1.9852e-06,
                    2.0644e-06,
                    2.1437e-06,
                    2.2232e-06,
                    2.3029e-06,
                    2.3827e-06,
                    2.4626e-06,
                    2.5428e-06,
                    2.6231e-06,
                    2.7035e-06,
                    2.7841e-06,
                    2.8649e-06,
                    2.9458e-06,
                    3.0269e-06,
                    3.1082e-06,
                    3.1897e-06,
                    3.2713e-06,
                    3.353e-06,
                    3.435e-06,
                    3.5171e-06,
                    3.5993e-06,
                    3.68e-06,
                    3.759e-06,
                    3.8365e-06,
                    3.9124e-06,
                    3.9866e-06,
                    4.0593e-06,
                    4.1303e-06,
                    4.1998e-06,
                    4.2677e-06,
                    4.3339e-06,
                    4.4137e-06,
                    4.5071e-06,
                    4.614e-06,
                    4.7344e-06,
                    4.8683e-06,
                    5.0158e-06,
                    5.1768e-06,
                    5.3513e-06,
                    5.5394e-06,
                    5.7411e-06,
                    5.9612e-06,
                    6.1999e-06,
                    6.4571e-06,
                    6.7328e-06,
                    7.0271e-06,
                    7.3399e-06,
                    7.6713e-06,
                    8.0211e-06,
                    8.3895e-06,
                    8.7765e-06,
                    9.1717e-06,
                    9.5754e-06,
                    9.9874e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005
                ],
                "Total_N2O": 0.44,
                "Total_N2O_timeseries": [
                    1.7396e-07,
                    3.5136e-07,
                    5.3206e-07,
                    7.1584e-07,
                    9.0245e-07,
                    1.0916e-06,
                    1.2829e-06,
                    1.4759e-06,
                    1.6701e-06,
                    1.8651e-06,
                    2.0604e-06,
                    2.256e-06,
                    2.4518e-06,
                    2.6478e-06,
                    2.8439e-06,
                    3.0402e-06,
                    3.2367e-06,
                    3.4334e-06,
                    3.6304e-06,
                    3.8278e-06,
                    4.0284e-06,
                    4.2373e-06,
                    4.4582e-06,
                    4.6936e-06,
                    4.9452e-06,
                    5.2132e-06,
                    5.497e-06,
                    5.7945e-06,
                    6.1028e-06,
                    6.4176e-06,
                    6.7361e-06,
                    7.0577e-06,
                    7.382e-06,
                    7.7085e-06,
                    8.0371e-06,
                    8.3676e-06,
                    8.7e-06,
                    9.0345e-06,
                    9.3713e-06,
                    9.7256e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Fossil_N2O": 0.14,
                "Fossil_N2O_timeseries": [
                    7.677e-09,
                    1.5466e-08,
                    2.3365e-08,
                    3.1368e-08,
                    3.9471e-08,
                    4.7666e-08,
                    5.5947e-08,
                    6.4304e-08,
                    7.2726e-08,
                    8.1203e-08,
                    8.9727e-08,
                    9.8297e-08,
                    1.0691e-07,
                    1.1557e-07,
                    1.2427e-07,
                    1.3301e-07,
                    1.418e-07,
                    1.5063e-07,
                    1.5951e-07,
                    1.6843e-07,
                    1.7746e-07,
                    1.8671e-07,
                    1.9625e-07,
                    2.0614e-07,
                    2.1641e-07,
                    2.2706e-07,
                    2.3809e-07,
                    2.4944e-07,
                    2.6107e-07,
                    2.7287e-07,
                    2.8479e-07,
                    2.9681e-07,
                    3.0893e-07,
                    3.2114e-07,
                    3.3343e-07,
                    3.458e-07,
                    3.5825e-07,
                    3.7079e-07,
                    3.8341e-07,
                    3.9653e-07,
                    4.0983e-07,
                    4.2334e-07,
                    4.3707e-07,
                    4.5102e-07,
                    4.6521e-07,
                    4.7963e-07,
                    4.9432e-07,
                    5.0926e-07,
                    5.2448e-07,
                    5.3999e-07,
                    5.5581e-07,
                    5.7198e-07,
                    5.8855e-07,
                    6.0552e-07,
                    6.2291e-07,
                    6.4072e-07,
                    6.5894e-07,
                    6.7754e-07,
                    6.965e-07,
                    7.1575e-07,
                    7.3528e-07,
                    7.5506e-07,
                    7.7509e-07,
                    7.9535e-07,
                    8.1583e-07,
                    8.3654e-07,
                    8.5747e-07,
                    8.7863e-07,
                    9.0003e-07,
                    9.2166e-07,
                    9.4355e-07,
                    9.6567e-07,
                    9.8804e-07,
                    1.0107e-06,
                    1.0335e-06,
                    1.0566e-06,
                    1.08e-06,
                    1.1037e-06,
                    1.1276e-06,
                    1.1519e-06,
                    1.1782e-06,
                    1.2096e-06,
                    1.2485e-06,
                    1.2971e-06,
                    1.3567e-06,
                    1.4283e-06,
                    1.5122e-06,
                    1.6083e-06,
                    1.716e-06,
                    1.834e-06,
                    1.9622e-06,
                    2.1018e-06,
                    2.2535e-06,
                    2.4176e-06,
                    2.5939e-06,
                    2.782e-06,
                    2.9809e-06,
                    3.1891e-06,
                    3.4049e-06,
                    3.6261e-06,
                    3.8512e-06,
                    4.0796e-06,
                    4.3111e-06,
                    4.5455e-06,
                    4.7825e-06,
                    5.0223e-06,
                    5.2651e-06,
                    5.5109e-06,
                    5.7604e-06,
                    6.0138e-06,
                    6.2743e-06,
                    6.5473e-06,
                    6.8382e-06,
                    7.1528e-06,
                    7.4965e-06,
                    7.8752e-06,
                    8.2947e-06,
                    8.7609e-06,
                    9.2797e-06,
                    9.6753e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.56,
                "Land_N2O_timeseries": [
                    1.6629e-07,
                    3.359e-07,
                    5.0869e-07,
                    6.8447e-07,
                    8.6298e-07,
                    1.0439e-06,
                    1.2269e-06,
                    1.4116e-06,
                    1.5974e-06,
                    1.7839e-06,
                    1.9706e-06,
                    2.1577e-06,
                    2.3449e-06,
                    2.5322e-06,
                    2.7196e-06,
                    2.9072e-06,
                    3.0949e-06,
                    3.2827e-06,
                    3.4709e-06,
                    3.6593e-06,
                    3.851e-06,
                    4.0506e-06,
                    4.2619e-06,
                    4.4875e-06,
                    4.7288e-06,
                    4.9862e-06,
                    5.2589e-06,
                    5.5451e-06,
                    5.8417e-06,
                    6.1447e-06,
                    6.4513e-06,
                    6.7609e-06,
                    7.073e-06,
                    7.3874e-06,
                    7.7037e-06,
                    8.0218e-06,
                    8.3418e-06,
                    8.6637e-06,
                    8.9879e-06,
                    9.329e-06,
                    9.6734e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            23.42989,
                            -17.63446
                        ],
                        [
                            24.24673,
                            -17.47317
                        ],
                        [
                            24.32856,
                            -17.49169
                        ],
                        [
                            24.38833,
                            -17.46932
                        ],
                        [
                            24.47304,
                            -17.48584
                        ],
                        [
                            24.56285,
                            -17.53856
                        ],
                        [
                            24.70381,
                            -17.49735
                        ],
                        [
                            24.79931,
                            -17.53664
                        ],
                        [
                            24.87927,
                            -17.52722
                        ],
                        [
                            25.04638,
                            -17.59007
                        ],
                        [
                            25.18809,
                            -17.7664
                        ],
                        [
                            25.2628,
                            -17.79139
                        ],
                        [
                            25.27033,
                            -17.79891
                        ],
                        [
                            25.38203,
                            -17.85443
                        ],
                        [
                            25.55414,
                            -17.84288
                        ],
                        [
                            25.59592,
                            -17.85206
                        ],
                        [
                            25.69931,
                            -17.81649
                        ],
                        [
                            25.84106,
                            -17.89458
                        ],
                        [
                            25.86697,
                            -17.97532
                        ],
                        [
                            25.97299,
                            -18.0052
                        ],
                        [
                            26.01393,
                            -17.97912
                        ],
                        [
                            26.09016,
                            -17.98305
                        ],
                        [
                            26.10193,
                            -17.93299
                        ],
                        [
                            26.20797,
                            -17.89333
                        ],
                        [
                            26.30988,
                            -17.93689
                        ],
                        [
                            26.40773,
                            -17.94027
                        ],
                        [
                            26.56206,
                            -17.99143
                        ],
                        [
                            26.60501,
                            -18.05352
                        ],
                        [
                            26.68864,
                            -18.07824
                        ],
                        [
                            26.73128,
                            -18.03775
                        ],
                        [
                            27.00956,
                            -17.95481
                        ],
                        [
                            27.03875,
                            -17.96241
                        ],
                        [
                            27.14747,
                            -17.84977
                        ],
                        [
                            27.14837,
                            -17.80077
                        ],
                        [
                            27.31149,
                            -17.59955
                        ],
                        [
                            27.54456,
                            -17.42315
                        ],
                        [
                            27.61755,
                            -17.33607
                        ],
                        [
                            27.63431,
                            -17.24065
                        ],
                        [
                            27.83059,
                            -16.96274
                        ],
                        [
                            28.13453,
                            -16.82465
                        ],
                        [
                            28.27218,
                            -16.71695
                        ],
                        [
                            28.63942,
                            -16.57236
                        ],
                        [
                            28.7322,
                            -16.55511
                        ],
                        [
                            28.8032,
                            -16.50168
                        ],
                        [
                            28.84781,
                            -16.37807
                        ],
                        [
                            28.82253,
                            -16.31983
                        ],
                        [
                            28.8533,
                            -16.26337
                        ],
                        [
                            28.83548,
                            -16.22324
                        ],
                        [
                            28.86199,
                            -16.12263
                        ],
                        [
                            28.84529,
                            -16.05468
                        ],
                        [
                            28.91432,
                            -15.94629
                        ],
                        [
                            29.01323,
                            -15.94115
                        ],
                        [
                            29.06558,
                            -15.87994
                        ],
                        [
                            29.19189,
                            -15.79337
                        ],
                        [
                            29.35956,
                            -15.71116
                        ],
                        [
                            29.50214,
                            -15.684
                        ],
                        [
                            29.54261,
                            -15.6481
                        ],
                        [
                            29.63071,
                            -15.66102
                        ],
                        [
                            29.82355,
                            -15.60901
                        ],
                        [
                            29.96827,
                            -15.64182
                        ],
                        [
                            30.16352,
                            -15.62046
                        ],
                        [
                            30.21415,
                            -15.6606
                        ],
                        [
                            30.26027,
                            -15.62725
                        ],
                        [
                            30.35734,
                            -15.6498
                        ],
                        [
                            30.41826,
                            -15.61757
                        ],
                        [
                            30.36583,
                            -15.5532
                        ],
                        [
                            30.40132,
                            -15.47285
                        ],
                        [
                            30.37569,
                            -15.34252
                        ],
                        [
                            30.27967,
                            -15.25114
                        ],
                        [
                            30.23038,
                            -15.13849
                        ],
                        [
                            30.21821,
                            -14.99832
                        ],
                        [
                            30.36618,
                            -14.95912
                        ],
                        [
                            30.51718,
                            -14.88835
                        ],
                        [
                            30.79877,
                            -14.78385
                        ],
                        [
                            31.08057,
                            -14.7167
                        ],
                        [
                            31.26428,
                            -14.65951
                        ],
                        [
                            31.47334,
                            -14.61945
                        ],
                        [
                            31.68165,
                            -14.50752
                        ],
                        [
                            31.81475,
                            -14.47679
                        ],
                        [
                            31.94781,
                            -14.41297
                        ],
                        [
                            32.05615,
                            -14.38843
                        ],
                        [
                            32.24352,
                            -14.32286
                        ],
                        [
                            32.45068,
                            -14.28265
                        ],
                        [
                            32.61303,
                            -14.2137
                        ],
                        [
                            33.20672,
                            -14.00444
                        ],
                        [
                            33.24222,
                            -13.99852
                        ],
                        [
                            33.19765,
                            -13.99114
                        ],
                        [
                            33.15557,
                            -13.93726
                        ],
                        [
                            33.06979,
                            -13.99115
                        ],
                        [
                            33.02871,
                            -14.045
                        ],
                        [
                            32.99197,
                            -14.01249
                        ],
                        [
                            32.99999,
                            -13.94966
                        ],
                        [
                            32.9441,
                            -13.92535
                        ],
                        [
                            32.9376,
                            -13.87602
                        ],
                        [
                            32.8597,
                            -13.79235
                        ],
                        [
                            32.77279,
                            -13.77349
                        ],
                        [
                            32.84265,
                            -13.71319
                        ],
                        [
                            32.77406,
                            -13.63626
                        ],
                        [
                            32.67547,
                            -13.60985
                        ],
                        [
                            32.70539,
                            -13.56549
                        ],
                        [
                            32.84638,
                            -13.50657
                        ],
                        [
                            32.91375,
                            -13.40996
                        ],
                        [
                            32.94584,
                            -13.27352
                        ],
                        [
                            33.01531,
                            -13.21083
                        ],
                        [
                            32.98082,
                            -13.15616
                        ],
                        [
                            32.98758,
                            -13.02777
                        ],
                        [
                            33.02593,
                            -12.91077
                        ],
                        [
                            32.95734,
                            -12.84254
                        ],
                        [
                            32.96041,
                            -12.75613
                        ],
                        [
                            33.01532,
                            -12.65784
                        ],
                        [
                            33.08663,
                            -12.59471
                        ],
                        [
                            33.17736,
                            -12.61073
                        ],
                        [
                            33.23272,
                            -12.59172
                        ],
                        [
                            33.26833,
                            -12.53848
                        ],
                        [
                            33.36096,
                            -12.55274
                        ],
                        [
                            33.40978,
                            -12.52089
                        ],
                        [
                            33.47247,
                            -12.42157
                        ],
                        [
                            33.54387,
                            -12.37139
                        ],
                        [
                            33.45712,
                            -12.32265
                        ],
                        [
                            33.36696,
                            -12.34768
                        ],
                        [
                            33.31009,
                            -12.24595
                        ],
                        [
                            33.30849,
                            -12.16568
                        ],
                        [
                            33.26109,
                            -12.11773
                        ],
                        [
                            33.3085,
                            -12.00052
                        ],
                        [
                            33.32303,
                            -11.89957
                        ],
                        [
                            33.30532,
                            -11.86205
                        ],
                        [
                            33.33356,
                            -11.80138
                        ],
                        [
                            33.31523,
                            -11.72233
                        ],
                        [
                            33.31107,
                            -11.59618
                        ],
                        [
                            33.24819,
                            -11.52857
                        ],
                        [
                            33.2411,
                            -11.4018
                        ],
                        [
                            33.29047,
                            -11.36855
                        ],
                        [
                            33.38105,
                            -11.23177
                        ],
                        [
                            33.4058,
                            -11.15866
                        ],
                        [
                            33.33267,
                            -11.06806
                        ],
                        [
                            33.30815,
                            -10.99268
                        ],
                        [
                            33.31072,
                            -10.86921
                        ],
                        [
                            33.33528,
                            -10.82906
                        ],
                        [
                            33.46031,
                            -10.81603
                        ],
                        [
                            33.53198,
                            -10.76307
                        ],
                        [
                            33.59811,
                            -10.6603
                        ],
                        [
                            33.68348,
                            -10.60704
                        ],
                        [
                            33.66905,
                            -10.53168
                        ],
                        [
                            33.61952,
                            -10.45056
                        ],
                        [
                            33.57751,
                            -10.42887
                        ],
                        [
                            33.53552,
                            -10.32891
                        ],
                        [
                            33.55909,
                            -10.22679
                        ],
                        [
                            33.45882,
                            -10.17053
                        ],
                        [
                            33.41944,
                            -10.12585
                        ],
                        [
                            33.33914,
                            -10.08803
                        ],
                        [
                            33.31898,
                            -10.045
                        ],
                        [
                            33.34817,
                            -9.94656
                        ],
                        [
                            33.3809,
                            -9.90571
                        ],
                        [
                            33.33805,
                            -9.82326
                        ],
                        [
                            33.28969,
                            -9.80957
                        ],
                        [
                            33.22716,
                            -9.71818
                        ],
                        [
                            33.22688,
                            -9.65503
                        ],
                        [
                            33.19425,
                            -9.60567
                        ],
                        [
                            33.06037,
                            -9.63384
                        ],
                        [
                            33.0031,
                            -9.61516
                        ],
                        [
                            33.0279,
                            -9.52581
                        ],
                        [
                            32.94786,
                            -9.48507
                        ],
                        [
                            32.95351,
                            -9.40145
                        ],
                        [
                            32.8657,
                            -9.37318
                        ],
                        [
                            32.76919,
                            -9.31743
                        ],
                        [
                            32.7457,
                            -9.28149
                        ],
                        [
                            32.54157,
                            -9.25393
                        ],
                        [
                            32.43142,
                            -9.11893
                        ],
                        [
                            32.266,
                            -9.13312
                        ],
                        [
                            32.16053,
                            -9.06223
                        ],
                        [
                            32.06195,
                            -9.05145
                        ],
                        [
                            31.99837,
                            -9.0751
                        ],
                        [
                            31.96256,
                            -9.05332
                        ],
                        [
                            31.93221,
                            -8.98083
                        ],
                        [
                            31.94435,
                            -8.93609
                        ],
                        [
                            31.81729,
                            -8.89046
                        ],
                        [
                            31.73645,
                            -8.92061
                        ],
                        [
                            31.68044,
                            -8.90986
                        ],
                        [
                            31.58671,
                            -8.83926
                        ],
                        [
                            31.56281,
                            -8.70175
                        ],
                        [
                            31.4897,
                            -8.68198
                        ],
                        [
                            31.45709,
                            -8.64098
                        ],
                        [
                            31.35033,
                            -8.61459
                        ],
                        [
                            31.29124,
                            -8.62953
                        ],
                        [
                            31.2121,
                            -8.58827
                        ],
                        [
                            31.15068,
                            -8.63016
                        ],
                        [
                            31.10272,
                            -8.62977
                        ],
                        [
                            31.00379,
                            -8.56807
                        ],
                        [
                            30.81151,
                            -8.31612
                        ],
                        [
                            30.77124,
                            -8.19225
                        ],
                        [
                            30.58084,
                            -8.27435
                        ],
                        [
                            30.54407,
                            -8.2555
                        ],
                        [
                            30.12231,
                            -8.31243
                        ],
                        [
                            29.99963,
                            -8.31677
                        ],
                        [
                            29.74052,
                            -8.35556
                        ],
                        [
                            29.63785,
                            -8.4004
                        ],
                        [
                            29.59474,
                            -8.37651
                        ],
                        [
                            29.00335,
                            -8.45973
                        ],
                        [
                            28.96019,
                            -8.57402
                        ],
                        [
                            28.9413,
                            -8.71432
                        ],
                        [
                            28.8642,
                            -8.84235
                        ],
                        [
                            28.69557,
                            -9.03421
                        ],
                        [
                            28.48228,
                            -9.17152
                        ],
                        [
                            28.38453,
                            -9.25852
                        ],
                        [
                            28.49664,
                            -9.32697
                        ],
                        [
                            28.53365,
                            -9.38233
                        ],
                        [
                            28.5152,
                            -9.43333
                        ],
                        [
                            28.56945,
                            -9.49089
                        ],
                        [
                            28.57404,
                            -9.54654
                        ],
                        [
                            28.61528,
                            -9.60372
                        ],
                        [
                            28.6241,
                            -9.72931
                        ],
                        [
                            28.66856,
                            -9.75739
                        ],
                        [
                            28.67215,
                            -9.81995
                        ],
                        [
                            28.6257,
                            -9.95562
                        ],
                        [
                            28.63586,
                            -10.02158
                        ],
                        [
                            28.62153,
                            -10.15639
                        ],
                        [
                            28.57762,
                            -10.23005
                        ],
                        [
                            28.63639,
                            -10.31667
                        ],
                        [
                            28.6219,
                            -10.37531
                        ],
                        [
                            28.64268,
                            -10.45034
                        ],
                        [
                            28.63436,
                            -10.51902
                        ],
                        [
                            28.6724,
                            -10.56907
                        ],
                        [
                            28.68955,
                            -10.6788
                        ],
                        [
                            28.55382,
                            -10.83233
                        ],
                        [
                            28.53835,
                            -10.94061
                        ],
                        [
                            28.47662,
                            -11.10496
                        ],
                        [
                            28.49521,
                            -11.14816
                        ],
                        [
                            28.48649,
                            -11.24382
                        ],
                        [
                            28.44911,
                            -11.32481
                        ],
                        [
                            28.41842,
                            -11.44577
                        ],
                        [
                            28.39517,
                            -11.47441
                        ],
                        [
                            28.38131,
                            -11.57566
                        ],
                        [
                            28.42406,
                            -11.63445
                        ],
                        [
                            28.41824,
                            -11.73191
                        ],
                        [
                            28.44375,
                            -11.83097
                        ],
                        [
                            28.50703,
                            -11.88057
                        ],
                        [
                            28.61293,
                            -11.91267
                        ],
                        [
                            28.63885,
                            -11.95043
                        ],
                        [
                            28.7639,
                            -11.99786
                        ],
                        [
                            28.77897,
                            -12.05499
                        ],
                        [
                            28.85689,
                            -12.13895
                        ],
                        [
                            28.94729,
                            -12.21266
                        ],
                        [
                            29.03511,
                            -12.3731
                        ],
                        [
                            29.1293,
                            -12.39456
                        ],
                        [
                            29.26687,
                            -12.36535
                        ],
                        [
                            29.30253,
                            -12.41259
                        ],
                        [
                            29.36751,
                            -12.41373
                        ],
                        [
                            29.47251,
                            -12.46982
                        ],
                        [
                            29.53507,
                            -12.42952
                        ],
                        [
                            29.45673,
                            -12.33288
                        ],
                        [
                            29.4889,
                            -12.23973
                        ],
                        [
                            29.57635,
                            -12.19333
                        ],
                        [
                            29.66785,
                            -12.20669
                        ],
                        [
                            29.76164,
                            -12.16136
                        ],
                        [
                            29.81016,
                            -12.19379
                        ],
                        [
                            29.8089,
                            -12.9964
                        ],
                        [
                            29.80814,
                            -13.45247
                        ],
                        [
                            29.71091,
                            -13.45461
                        ],
                        [
                            29.61234,
                            -13.40941
                        ],
                        [
                            29.6785,
                            -13.26967
                        ],
                        [
                            29.67652,
                            -13.23542
                        ],
                        [
                            29.58505,
                            -13.21395
                        ],
                        [
                            29.52567,
                            -13.22993
                        ],
                        [
                            29.44142,
                            -13.31331
                        ],
                        [
                            29.36639,
                            -13.32716
                        ],
                        [
                            29.18694,
                            -13.44098
                        ],
                        [
                            29.1081,
                            -13.37024
                        ],
                        [
                            29.02092,
                            -13.41652
                        ],
                        [
                            28.94693,
                            -13.30691
                        ],
                        [
                            28.90399,
                            -13.1642
                        ],
                        [
                            28.84851,
                            -13.14623
                        ],
                        [
                            28.83375,
                            -13.02865
                        ],
                        [
                            28.73291,
                            -12.88764
                        ],
                        [
                            28.65422,
                            -12.82013
                        ],
                        [
                            28.58729,
                            -12.88477
                        ],
                        [
                            28.45582,
                            -12.71063
                        ],
                        [
                            28.52194,
                            -12.63427
                        ],
                        [
                            28.32603,
                            -12.42548
                        ],
                        [
                            28.19059,
                            -12.40076
                        ],
                        [
                            28.1167,
                            -12.42716
                        ],
                        [
                            28.08872,
                            -12.36319
                        ],
                        [
                            27.96342,
                            -12.35182
                        ],
                        [
                            27.91803,
                            -12.24153
                        ],
                        [
                            27.86434,
                            -12.24352
                        ],
                        [
                            27.7586,
                            -12.28808
                        ],
                        [
                            27.65473,
                            -12.28619
                        ],
                        [
                            27.56582,
                            -12.21014
                        ],
                        [
                            27.50929,
                            -12.13912
                        ],
                        [
                            27.46484,
                            -12.01276
                        ],
                        [
                            27.46181,
                            -11.92671
                        ],
                        [
                            27.22794,
                            -11.77221
                        ],
                        [
                            27.21048,
                            -11.57844
                        ],
                        [
                            27.15779,
                            -11.59902
                        ],
                        [
                            27.04487,
                            -11.60346
                        ],
                        [
                            27.0253,
                            -11.65066
                        ],
                        [
                            27.04784,
                            -11.70274
                        ],
                        [
                            27.00878,
                            -11.76622
                        ],
                        [
                            27.00185,
                            -11.8528
                        ],
                        [
                            26.88324,
                            -11.98368
                        ],
                        [
                            26.79695,
                            -11.96716
                        ],
                        [
                            26.72004,
                            -12.00664
                        ],
                        [
                            26.6022,
                            -11.97245
                        ],
                        [
                            26.56223,
                            -11.97986
                        ],
                        [
                            26.46686,
                            -11.92002
                        ],
                        [
                            26.40781,
                            -11.92082
                        ],
                        [
                            26.32773,
                            -11.96559
                        ],
                        [
                            26.2112,
                            -11.9282
                        ],
                        [
                            26.18639,
                            -11.9389
                        ],
                        [
                            25.98967,
                            -11.94002
                        ],
                        [
                            25.98507,
                            -11.89647
                        ],
                        [
                            25.91752,
                            -11.87246
                        ],
                        [
                            25.88894,
                            -11.81074
                        ],
                        [
                            25.82228,
                            -11.82764
                        ],
                        [
                            25.71912,
                            -11.81466
                        ],
                        [
                            25.65666,
                            -11.73736
                        ],
                        [
                            25.59793,
                            -11.73572
                        ],
                        [
                            25.50733,
                            -11.78461
                        ],
                        [
                            25.49247,
                            -11.70951
                        ],
                        [
                            25.33799,
                            -11.62677
                        ],
                        [
                            25.2967,
                            -11.51058
                        ],
                        [
                            25.3005,
                            -11.4138
                        ],
                        [
                            25.27979,
                            -11.36839
                        ],
                        [
                            25.34834,
                            -11.19715
                        ],
                        [
                            25.30125,
                            -11.19267
                        ],
                        [
                            25.22481,
                            -11.22723
                        ],
                        [
                            25.10063,
                            -11.25074
                        ],
                        [
                            24.8734,
                            -11.26335
                        ],
                        [
                            24.85125,
                            -11.29252
                        ],
                        [
                            24.73827,
                            -11.30697
                        ],
                        [
                            24.66603,
                            -11.35902
                        ],
                        [
                            24.57575,
                            -11.45532
                        ],
                        [
                            24.47412,
                            -11.4607
                        ],
                        [
                            24.38185,
                            -11.40938
                        ],
                        [
                            24.35031,
                            -11.36476
                        ],
                        [
                            24.39816,
                            -11.26368
                        ],
                        [
                            24.38233,
                            -11.09227
                        ],
                        [
                            24.32276,
                            -11.05421
                        ],
                        [
                            24.13213,
                            -11.02326
                        ],
                        [
                            24.14211,
                            -10.96744
                        ],
                        [
                            24.11586,
                            -10.90519
                        ],
                        [
                            23.99953,
                            -10.88725
                        ],
                        [
                            24.01842,
                            -10.94207
                        ],
                        [
                            24.0071,
                            -11.02103
                        ],
                        [
                            24.03555,
                            -11.13938
                        ],
                        [
                            24.03355,
                            -11.26478
                        ],
                        [
                            24.08506,
                            -11.4039
                        ],
                        [
                            24.02348,
                            -11.4481
                        ],
                        [
                            24.03822,
                            -11.52534
                        ],
                        [
                            23.98046,
                            -11.64278
                        ],
                        [
                            24.01269,
                            -11.81187
                        ],
                        [
                            23.98357,
                            -11.9069
                        ],
                        [
                            23.98419,
                            -12.17063
                        ],
                        [
                            24.05955,
                            -12.26441
                        ],
                        [
                            24.07574,
                            -12.3596
                        ],
                        [
                            24.03338,
                            -12.44003
                        ],
                        [
                            23.94663,
                            -12.55667
                        ],
                        [
                            23.95956,
                            -12.59326
                        ],
                        [
                            23.89941,
                            -12.76354
                        ],
                        [
                            23.89393,
                            -12.84073
                        ],
                        [
                            24.02649,
                            -12.94391
                        ],
                        [
                            24.04521,
                            -12.9964
                        ],
                        [
                            23.92582,
                            -12.9967
                        ],
                        [
                            22.01,
                            -13.00148
                        ],
                        [
                            22.00417,
                            -13.00401
                        ],
                        [
                            22.00028,
                            -13.4738
                        ],
                        [
                            21.9999,
                            -16.18406
                        ],
                        [
                            22.11935,
                            -16.35013
                        ],
                        [
                            22.12823,
                            -16.44848
                        ],
                        [
                            22.17954,
                            -16.53277
                        ],
                        [
                            22.32574,
                            -16.64507
                        ],
                        [
                            22.48765,
                            -16.84674
                        ],
                        [
                            22.60924,
                            -16.93977
                        ],
                        [
                            22.78472,
                            -17.11608
                        ],
                        [
                            22.80069,
                            -17.16191
                        ],
                        [
                            22.91894,
                            -17.26606
                        ],
                        [
                            22.99276,
                            -17.2705
                        ],
                        [
                            23.067,
                            -17.35536
                        ],
                        [
                            23.07048,
                            -17.38756
                        ],
                        [
                            23.14178,
                            -17.46746
                        ],
                        [
                            23.22621,
                            -17.52588
                        ],
                        [
                            23.3625,
                            -17.55246
                        ],
                        [
                            23.42989,
                            -17.63446
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "ZWE",
                "Country": "Zimbabwe",
                "Total_3GHG": 0.11,
                "Total_3GHG_timeseries": [
                    5.9629e-07,
                    1.1997e-06,
                    1.8178e-06,
                    2.4403e-06,
                    3.0705e-06,
                    3.7095e-06,
                    4.3565e-06,
                    5.0116e-06,
                    5.6772e-06,
                    6.3587e-06,
                    7.057e-06,
                    7.7707e-06,
                    8.4944e-06,
                    9.2252e-06,
                    9.9582e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0012,
                    0.0013,
                    0.0013,
                    0.0013,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0014,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0015,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0016,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0017,
                    0.0018,
                    0.0018,
                    0.0018,
                    0.0018
                ],
                "Fossil_3GHG": 0.06,
                "Fossil_3GHG_timeseries": [
                    6.3276e-08,
                    1.2776e-07,
                    1.9346e-07,
                    2.6039e-07,
                    3.2855e-07,
                    3.9796e-07,
                    4.6861e-07,
                    5.4053e-07,
                    6.1369e-07,
                    6.8812e-07,
                    7.6388e-07,
                    8.4098e-07,
                    9.195e-07,
                    9.9941e-07,
                    1.0807e-06,
                    1.1635e-06,
                    1.2477e-06,
                    1.3334e-06,
                    1.4205e-06,
                    1.5093e-06,
                    1.5995e-06,
                    1.6915e-06,
                    1.7854e-06,
                    1.8811e-06,
                    1.9789e-06,
                    2.0788e-06,
                    2.1806e-06,
                    2.2844e-06,
                    2.3902e-06,
                    2.4976e-06,
                    2.607e-06,
                    2.7181e-06,
                    2.8311e-06,
                    2.9459e-06,
                    3.0625e-06,
                    3.1811e-06,
                    3.3015e-06,
                    3.4238e-06,
                    3.548e-06,
                    3.6752e-06,
                    3.8048e-06,
                    3.9368e-06,
                    4.0714e-06,
                    4.2084e-06,
                    4.3481e-06,
                    4.4904e-06,
                    4.6353e-06,
                    4.783e-06,
                    4.9334e-06,
                    5.0867e-06,
                    5.243e-06,
                    5.4027e-06,
                    5.645e-06,
                    5.9113e-06,
                    6.2449e-06,
                    6.5949e-06,
                    6.9662e-06,
                    7.4229e-06,
                    7.8933e-06,
                    8.3823e-06,
                    8.9312e-06,
                    9.4888e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006
                ],
                "Land_3GHG": 0.2,
                "Land_3GHG_timeseries": [
                    5.3302e-07,
                    1.072e-06,
                    1.6243e-06,
                    2.1799e-06,
                    2.7419e-06,
                    3.3115e-06,
                    3.8879e-06,
                    4.4711e-06,
                    5.0635e-06,
                    5.6705e-06,
                    6.2931e-06,
                    6.9297e-06,
                    7.5749e-06,
                    8.2257e-06,
                    8.8775e-06,
                    9.5317e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011,
                    0.0011
                ],
                "Total_CO2": 0.09,
                "Total_CO2_timeseries": [
                    1.5338e-07,
                    3.0577e-07,
                    4.6468e-07,
                    6.2003e-07,
                    7.7508e-07,
                    9.311e-07,
                    1.0874e-06,
                    1.2442e-06,
                    1.4039e-06,
                    1.5724e-06,
                    1.7493e-06,
                    1.9333e-06,
                    2.1191e-06,
                    2.3036e-06,
                    2.482e-06,
                    2.6561e-06,
                    2.8279e-06,
                    2.9981e-06,
                    3.1679e-06,
                    3.3483e-06,
                    3.5372e-06,
                    3.7341e-06,
                    3.9324e-06,
                    4.1275e-06,
                    4.3176e-06,
                    4.5109e-06,
                    4.7099e-06,
                    4.9048e-06,
                    5.1078e-06,
                    5.3165e-06,
                    5.5335e-06,
                    5.7592e-06,
                    5.988e-06,
                    6.2255e-06,
                    6.4637e-06,
                    6.7065e-06,
                    6.9499e-06,
                    7.1999e-06,
                    7.4507e-06,
                    7.7142e-06,
                    7.9929e-06,
                    8.2843e-06,
                    8.5817e-06,
                    8.885e-06,
                    9.1941e-06,
                    9.5093e-06,
                    9.8282e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0008,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.0009,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001,
                    0.001
                ],
                "Fossil_CO2": 0.05,
                "Fossil_CO2_timeseries": [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    5.115e-08,
                    1.155e-07,
                    2.211e-07,
                    3.3495e-07,
                    4.6035e-07,
                    6.3855e-07,
                    8.2335e-07,
                    1.018e-06,
                    1.249e-06,
                    1.4833e-06,
                    1.7457e-06,
                    2.1252e-06,
                    2.569e-06,
                    3.102e-06,
                    3.6977e-06,
                    4.229e-06,
                    4.7817e-06,
                    5.4071e-06,
                    6.0307e-06,
                    6.5901e-06,
                    7.2583e-06,
                    7.9645e-06,
                    8.7879e-06,
                    9.834e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004
                ],
                "Land_CO2": 0.19,
                "Land_CO2_timeseries": [
                    1.5338e-07,
                    3.0577e-07,
                    4.6468e-07,
                    6.2003e-07,
                    7.7508e-07,
                    9.311e-07,
                    1.0874e-06,
                    1.2442e-06,
                    1.4039e-06,
                    1.5724e-06,
                    1.7493e-06,
                    1.9333e-06,
                    2.1191e-06,
                    2.3036e-06,
                    2.482e-06,
                    2.6561e-06,
                    2.8279e-06,
                    2.9981e-06,
                    3.1679e-06,
                    3.3483e-06,
                    3.5372e-06,
                    3.7341e-06,
                    3.9324e-06,
                    4.1275e-06,
                    4.3176e-06,
                    4.5109e-06,
                    4.7099e-06,
                    4.9048e-06,
                    5.1078e-06,
                    5.3165e-06,
                    5.5335e-06,
                    5.7592e-06,
                    5.988e-06,
                    6.2255e-06,
                    6.4637e-06,
                    6.7065e-06,
                    6.9499e-06,
                    7.1999e-06,
                    7.4507e-06,
                    7.7142e-06,
                    7.9929e-06,
                    8.2843e-06,
                    8.5817e-06,
                    8.885e-06,
                    9.1941e-06,
                    9.5093e-06,
                    9.8282e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007,
                    0.0007
                ],
                "Total_CH4": 0.14,
                "Total_CH4_timeseries": [
                    3.6307e-07,
                    7.3285e-07,
                    1.1094e-06,
                    1.4926e-06,
                    1.8826e-06,
                    2.2794e-06,
                    2.683e-06,
                    3.0934e-06,
                    3.5107e-06,
                    3.9348e-06,
                    4.3669e-06,
                    4.807e-06,
                    5.2553e-06,
                    5.7116e-06,
                    6.176e-06,
                    6.6485e-06,
                    7.1291e-06,
                    7.6179e-06,
                    8.1148e-06,
                    8.62e-06,
                    9.1346e-06,
                    9.6586e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0004,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0005,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006,
                    0.0006
                ],
                "Fossil_CH4": 0.1,
                "Fossil_CH4_timeseries": [
                    3.9976e-08,
                    8.0873e-08,
                    1.227e-07,
                    1.6549e-07,
                    2.0924e-07,
                    2.5399e-07,
                    2.9973e-07,
                    3.465e-07,
                    3.9431e-07,
                    4.4319e-07,
                    4.932e-07,
                    5.4438e-07,
                    5.968e-07,
                    6.5042e-07,
                    7.0527e-07,
                    7.6137e-07,
                    8.1875e-07,
                    8.7742e-07,
                    9.3742e-07,
                    9.9876e-07,
                    1.0614e-06,
                    1.1252e-06,
                    1.1904e-06,
                    1.2569e-06,
                    1.3247e-06,
                    1.3938e-06,
                    1.4642e-06,
                    1.536e-06,
                    1.6091e-06,
                    1.6837e-06,
                    1.7598e-06,
                    1.8374e-06,
                    1.9166e-06,
                    1.9974e-06,
                    2.0798e-06,
                    2.1638e-06,
                    2.2494e-06,
                    2.3367e-06,
                    2.4257e-06,
                    2.5165e-06,
                    2.6091e-06,
                    2.7036e-06,
                    2.8001e-06,
                    2.8985e-06,
                    2.9989e-06,
                    3.1014e-06,
                    3.2058e-06,
                    3.3123e-06,
                    3.4209e-06,
                    3.5316e-06,
                    3.6448e-06,
                    3.7603e-06,
                    3.9065e-06,
                    4.0624e-06,
                    4.2435e-06,
                    4.4317e-06,
                    4.6289e-06,
                    4.8577e-06,
                    5.0928e-06,
                    5.336e-06,
                    5.6022e-06,
                    5.8732e-06,
                    6.1626e-06,
                    6.5195e-06,
                    6.9149e-06,
                    7.3624e-06,
                    7.8475e-06,
                    8.3006e-06,
                    8.7687e-06,
                    9.28e-06,
                    9.7974e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Land_CH4": 0.21,
                "Land_CH4_timeseries": [
                    3.2309e-07,
                    6.5197e-07,
                    9.8665e-07,
                    1.3271e-06,
                    1.6734e-06,
                    2.0254e-06,
                    2.3833e-06,
                    2.7469e-06,
                    3.1164e-06,
                    3.4916e-06,
                    3.8737e-06,
                    4.2627e-06,
                    4.6585e-06,
                    5.0612e-06,
                    5.4707e-06,
                    5.8871e-06,
                    6.3103e-06,
                    6.7405e-06,
                    7.1774e-06,
                    7.6213e-06,
                    8.0732e-06,
                    8.5333e-06,
                    9.0015e-06,
                    9.4779e-06,
                    9.9623e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003,
                    0.0003
                ],
                "Total_N2O": 0.21,
                "Total_N2O_timeseries": [
                    7.9842e-08,
                    1.611e-07,
                    2.4373e-07,
                    3.2764e-07,
                    4.1275e-07,
                    4.9894e-07,
                    5.8608e-07,
                    6.74e-07,
                    7.6255e-07,
                    8.5151e-07,
                    9.4076e-07,
                    1.0303e-06,
                    1.12e-06,
                    1.21e-06,
                    1.3002e-06,
                    1.3906e-06,
                    1.4813e-06,
                    1.5722e-06,
                    1.6633e-06,
                    1.7548e-06,
                    1.8476e-06,
                    1.9436e-06,
                    2.0441e-06,
                    2.1502e-06,
                    2.2622e-06,
                    2.3805e-06,
                    2.5046e-06,
                    2.634e-06,
                    2.7674e-06,
                    2.9034e-06,
                    3.0409e-06,
                    3.1797e-06,
                    3.3196e-06,
                    3.4605e-06,
                    3.6023e-06,
                    3.745e-06,
                    3.8885e-06,
                    4.033e-06,
                    4.1784e-06,
                    4.3309e-06,
                    4.485e-06,
                    4.6408e-06,
                    4.7984e-06,
                    4.9577e-06,
                    5.119e-06,
                    5.2822e-06,
                    5.4475e-06,
                    5.6149e-06,
                    5.7844e-06,
                    5.9561e-06,
                    6.1301e-06,
                    6.3063e-06,
                    6.4849e-06,
                    6.6658e-06,
                    6.8493e-06,
                    7.0354e-06,
                    7.2243e-06,
                    7.4162e-06,
                    7.6113e-06,
                    7.8098e-06,
                    8.0131e-06,
                    8.2231e-06,
                    8.4415e-06,
                    8.6696e-06,
                    8.9084e-06,
                    9.1584e-06,
                    9.42e-06,
                    9.6928e-06,
                    9.9766e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002,
                    0.0002
                ],
                "Fossil_N2O": 0.12,
                "Fossil_N2O_timeseries": [
                    2.3299e-08,
                    4.6885e-08,
                    7.0753e-08,
                    9.4896e-08,
                    1.1931e-07,
                    1.4397e-07,
                    1.6888e-07,
                    1.9402e-07,
                    2.1938e-07,
                    2.4493e-07,
                    2.7067e-07,
                    2.966e-07,
                    3.227e-07,
                    3.4899e-07,
                    3.7546e-07,
                    4.021e-07,
                    4.2893e-07,
                    4.5594e-07,
                    4.8313e-07,
                    5.1051e-07,
                    5.3817e-07,
                    5.6627e-07,
                    5.9494e-07,
                    6.2426e-07,
                    6.5427e-07,
                    6.85e-07,
                    7.1641e-07,
                    7.4845e-07,
                    7.8101e-07,
                    8.1395e-07,
                    8.472e-07,
                    8.8071e-07,
                    9.1449e-07,
                    9.4852e-07,
                    9.8279e-07,
                    1.0173e-06,
                    1.052e-06,
                    1.087e-06,
                    1.1223e-06,
                    1.1587e-06,
                    1.1957e-06,
                    1.2332e-06,
                    1.2713e-06,
                    1.3099e-06,
                    1.3492e-06,
                    1.389e-06,
                    1.4295e-06,
                    1.4707e-06,
                    1.5125e-06,
                    1.555e-06,
                    1.5983e-06,
                    1.6424e-06,
                    1.6874e-06,
                    1.7334e-06,
                    1.7803e-06,
                    1.8282e-06,
                    1.877e-06,
                    1.9267e-06,
                    1.9771e-06,
                    2.0283e-06,
                    2.08e-06,
                    2.1323e-06,
                    2.1852e-06,
                    2.2385e-06,
                    2.2923e-06,
                    2.3467e-06,
                    2.4015e-06,
                    2.4568e-06,
                    2.5126e-06,
                    2.5689e-06,
                    2.6258e-06,
                    2.6832e-06,
                    2.7411e-06,
                    2.7995e-06,
                    2.8585e-06,
                    2.918e-06,
                    2.9781e-06,
                    3.0388e-06,
                    3.1002e-06,
                    3.1623e-06,
                    3.2254e-06,
                    3.2899e-06,
                    3.3562e-06,
                    3.4245e-06,
                    3.4953e-06,
                    3.5685e-06,
                    3.6443e-06,
                    3.7227e-06,
                    3.8037e-06,
                    3.8872e-06,
                    3.9732e-06,
                    4.0622e-06,
                    4.1543e-06,
                    4.2498e-06,
                    4.3487e-06,
                    4.4512e-06,
                    4.5573e-06,
                    4.6668e-06,
                    4.7796e-06,
                    4.8955e-06,
                    5.0146e-06,
                    5.1372e-06,
                    5.2636e-06,
                    5.3941e-06,
                    5.5286e-06,
                    5.6671e-06,
                    5.8095e-06,
                    5.9556e-06,
                    6.1049e-06,
                    6.2571e-06,
                    6.4119e-06,
                    6.5696e-06,
                    6.7303e-06,
                    6.8946e-06,
                    7.0629e-06,
                    7.2359e-06,
                    7.4143e-06,
                    7.5991e-06,
                    7.7911e-06,
                    7.9982e-06,
                    8.215e-06,
                    8.4399e-06,
                    8.6665e-06,
                    8.8863e-06,
                    9.1245e-06,
                    9.3656e-06,
                    9.61e-06,
                    9.8474e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "Land_N2O": 0.24,
                "Land_N2O_timeseries": [
                    5.6543e-08,
                    1.1422e-07,
                    1.7297e-07,
                    2.3274e-07,
                    2.9344e-07,
                    3.5497e-07,
                    4.172e-07,
                    4.7998e-07,
                    5.4317e-07,
                    6.0657e-07,
                    6.7009e-07,
                    7.3368e-07,
                    7.9734e-07,
                    8.6103e-07,
                    9.2477e-07,
                    9.8854e-07,
                    1.0524e-06,
                    1.1163e-06,
                    1.1802e-06,
                    1.2443e-06,
                    1.3095e-06,
                    1.3773e-06,
                    1.4492e-06,
                    1.5259e-06,
                    1.608e-06,
                    1.6955e-06,
                    1.7882e-06,
                    1.8855e-06,
                    1.9864e-06,
                    2.0894e-06,
                    2.1937e-06,
                    2.2989e-06,
                    2.4051e-06,
                    2.512e-06,
                    2.6195e-06,
                    2.7277e-06,
                    2.8365e-06,
                    2.946e-06,
                    3.0562e-06,
                    3.1722e-06,
                    3.2893e-06,
                    3.4076e-06,
                    3.527e-06,
                    3.6478e-06,
                    3.7698e-06,
                    3.8932e-06,
                    4.018e-06,
                    4.1442e-06,
                    4.2719e-06,
                    4.4011e-06,
                    4.5318e-06,
                    4.6639e-06,
                    4.7974e-06,
                    4.9324e-06,
                    5.069e-06,
                    5.2072e-06,
                    5.3473e-06,
                    5.4895e-06,
                    5.6342e-06,
                    5.7816e-06,
                    5.9331e-06,
                    6.0908e-06,
                    6.2564e-06,
                    6.4312e-06,
                    6.6161e-06,
                    6.8118e-06,
                    7.0185e-06,
                    7.2361e-06,
                    7.4641e-06,
                    7.7016e-06,
                    7.9488e-06,
                    8.2071e-06,
                    8.477e-06,
                    8.7587e-06,
                    9.0519e-06,
                    9.3557e-06,
                    9.6687e-06,
                    9.989e-06,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001,
                    0.0001
                ]
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            30.41826,
                            -15.61757
                        ],
                        [
                            30.35734,
                            -15.6498
                        ],
                        [
                            30.26027,
                            -15.62725
                        ],
                        [
                            30.21415,
                            -15.6606
                        ],
                        [
                            30.16352,
                            -15.62046
                        ],
                        [
                            29.96827,
                            -15.64182
                        ],
                        [
                            29.82355,
                            -15.60901
                        ],
                        [
                            29.63071,
                            -15.66102
                        ],
                        [
                            29.54261,
                            -15.6481
                        ],
                        [
                            29.50214,
                            -15.684
                        ],
                        [
                            29.35956,
                            -15.71116
                        ],
                        [
                            29.19189,
                            -15.79337
                        ],
                        [
                            29.06558,
                            -15.87994
                        ],
                        [
                            29.01323,
                            -15.94115
                        ],
                        [
                            28.91432,
                            -15.94629
                        ],
                        [
                            28.84529,
                            -16.05468
                        ],
                        [
                            28.86199,
                            -16.12263
                        ],
                        [
                            28.83548,
                            -16.22324
                        ],
                        [
                            28.8533,
                            -16.26337
                        ],
                        [
                            28.82253,
                            -16.31983
                        ],
                        [
                            28.84781,
                            -16.37807
                        ],
                        [
                            28.8032,
                            -16.50168
                        ],
                        [
                            28.7322,
                            -16.55511
                        ],
                        [
                            28.63942,
                            -16.57236
                        ],
                        [
                            28.27218,
                            -16.71695
                        ],
                        [
                            28.13453,
                            -16.82465
                        ],
                        [
                            27.83059,
                            -16.96274
                        ],
                        [
                            27.63431,
                            -17.24065
                        ],
                        [
                            27.61755,
                            -17.33607
                        ],
                        [
                            27.54456,
                            -17.42315
                        ],
                        [
                            27.31149,
                            -17.59955
                        ],
                        [
                            27.14837,
                            -17.80077
                        ],
                        [
                            27.14747,
                            -17.84977
                        ],
                        [
                            27.03875,
                            -17.96241
                        ],
                        [
                            27.00956,
                            -17.95481
                        ],
                        [
                            26.73128,
                            -18.03775
                        ],
                        [
                            26.68864,
                            -18.07824
                        ],
                        [
                            26.60501,
                            -18.05352
                        ],
                        [
                            26.56206,
                            -17.99143
                        ],
                        [
                            26.40773,
                            -17.94027
                        ],
                        [
                            26.30988,
                            -17.93689
                        ],
                        [
                            26.20797,
                            -17.89333
                        ],
                        [
                            26.10193,
                            -17.93299
                        ],
                        [
                            26.09016,
                            -17.98305
                        ],
                        [
                            26.01393,
                            -17.97912
                        ],
                        [
                            25.97299,
                            -18.0052
                        ],
                        [
                            25.86697,
                            -17.97532
                        ],
                        [
                            25.84106,
                            -17.89458
                        ],
                        [
                            25.69931,
                            -17.81649
                        ],
                        [
                            25.59592,
                            -17.85206
                        ],
                        [
                            25.55414,
                            -17.84288
                        ],
                        [
                            25.38203,
                            -17.85443
                        ],
                        [
                            25.27033,
                            -17.79891
                        ],
                        [
                            25.23725,
                            -17.91588
                        ],
                        [
                            25.32315,
                            -18.07829
                        ],
                        [
                            25.41942,
                            -18.15725
                        ],
                        [
                            25.49164,
                            -18.29937
                        ],
                        [
                            25.52268,
                            -18.38577
                        ],
                        [
                            25.60798,
                            -18.48643
                        ],
                        [
                            25.64414,
                            -18.5008
                        ],
                        [
                            25.71244,
                            -18.59845
                        ],
                        [
                            25.78338,
                            -18.63459
                        ],
                        [
                            25.79051,
                            -18.75792
                        ],
                        [
                            25.82056,
                            -18.84341
                        ],
                        [
                            25.94099,
                            -18.91113
                        ],
                        [
                            25.99336,
                            -19.03081
                        ],
                        [
                            25.9584,
                            -19.09135
                        ],
                        [
                            26.04247,
                            -19.21909
                        ],
                        [
                            26.13664,
                            -19.44231
                        ],
                        [
                            26.1657,
                            -19.54534
                        ],
                        [
                            26.24299,
                            -19.5888
                        ],
                        [
                            26.3075,
                            -19.58292
                        ],
                        [
                            26.44079,
                            -19.75523
                        ],
                        [
                            26.49112,
                            -19.76118
                        ],
                        [
                            26.57526,
                            -19.80956
                        ],
                        [
                            26.61586,
                            -19.88647
                        ],
                        [
                            26.69418,
                            -19.89472
                        ],
                        [
                            26.71751,
                            -19.94314
                        ],
                        [
                            26.79184,
                            -19.94842
                        ],
                        [
                            26.80737,
                            -19.98143
                        ],
                        [
                            26.96904,
                            -20.0201
                        ],
                        [
                            27.05707,
                            -20.02334
                        ],
                        [
                            27.11623,
                            -20.08598
                        ],
                        [
                            27.19077,
                            -20.08393
                        ],
                        [
                            27.24444,
                            -20.14582
                        ],
                        [
                            27.29764,
                            -20.29987
                        ],
                        [
                            27.28586,
                            -20.49816
                        ],
                        [
                            27.35865,
                            -20.47397
                        ],
                        [
                            27.47455,
                            -20.4737
                        ],
                        [
                            27.57274,
                            -20.49514
                        ],
                        [
                            27.68312,
                            -20.49109
                        ],
                        [
                            27.72963,
                            -20.54647
                        ],
                        [
                            27.70519,
                            -20.60599
                        ],
                        [
                            27.7301,
                            -20.71105
                        ],
                        [
                            27.73026,
                            -20.79412
                        ],
                        [
                            27.69063,
                            -20.881
                        ],
                        [
                            27.71101,
                            -20.96759
                        ],
                        [
                            27.68685,
                            -21.06624
                        ],
                        [
                            27.74964,
                            -21.15216
                        ],
                        [
                            27.81175,
                            -21.1835
                        ],
                        [
                            27.90003,
                            -21.30293
                        ],
                        [
                            28.03183,
                            -21.58131
                        ],
                        [
                            28.20097,
                            -21.61026
                        ],
                        [
                            28.27503,
                            -21.59812
                        ],
                        [
                            28.36696,
                            -21.60872
                        ],
                        [
                            28.49627,
                            -21.66755
                        ],
                        [
                            28.56973,
                            -21.63207
                        ],
                        [
                            28.79497,
                            -21.73455
                        ],
                        [
                            28.94222,
                            -21.77554
                        ],
                        [
                            29.00181,
                            -21.77477
                        ],
                        [
                            29.07468,
                            -21.81888
                        ],
                        [
                            29.04015,
                            -21.86195
                        ],
                        [
                            29.02373,
                            -21.95725
                        ],
                        [
                            29.05548,
                            -22.02286
                        ],
                        [
                            29.10486,
                            -22.06105
                        ],
                        [
                            29.18635,
                            -22.07932
                        ],
                        [
                            29.25189,
                            -22.06163
                        ],
                        [
                            29.36078,
                            -22.19663
                        ],
                        [
                            29.45962,
                            -22.1677
                        ],
                        [
                            29.51818,
                            -22.17569
                        ],
                        [
                            29.64762,
                            -22.12718
                        ],
                        [
                            29.7641,
                            -22.14138
                        ],
                        [
                            29.87581,
                            -22.19025
                        ],
                        [
                            30.0092,
                            -22.23001
                        ],
                        [
                            30.12474,
                            -22.30825
                        ],
                        [
                            30.22395,
                            -22.2944
                        ],
                        [
                            30.27428,
                            -22.34446
                        ],
                        [
                            30.40579,
                            -22.33998
                        ],
                        [
                            30.48442,
                            -22.31449
                        ],
                        [
                            30.70896,
                            -22.31501
                        ],
                        [
                            30.81017,
                            -22.29274
                        ],
                        [
                            30.93035,
                            -22.30031
                        ],
                        [
                            31.07723,
                            -22.34382
                        ],
                        [
                            31.1449,
                            -22.32709
                        ],
                        [
                            31.25068,
                            -22.35796
                        ],
                        [
                            31.31127,
                            -22.41774
                        ],
                        [
                            31.38151,
                            -22.37176
                        ],
                        [
                            31.90382,
                            -21.83988
                        ],
                        [
                            32.39848,
                            -21.32898
                        ],
                        [
                            32.47519,
                            -21.31009
                        ],
                        [
                            32.39909,
                            -21.20525
                        ],
                        [
                            32.36752,
                            -21.13652
                        ],
                        [
                            32.49293,
                            -20.96849
                        ],
                        [
                            32.51802,
                            -20.88629
                        ],
                        [
                            32.49787,
                            -20.80704
                        ],
                        [
                            32.49137,
                            -20.62048
                        ],
                        [
                            32.56746,
                            -20.56168
                        ],
                        [
                            32.65589,
                            -20.56113
                        ],
                        [
                            32.73431,
                            -20.44843
                        ],
                        [
                            32.86159,
                            -20.28893
                        ],
                        [
                            32.86752,
                            -20.11496
                        ],
                        [
                            32.91653,
                            -20.11611
                        ],
                        [
                            32.92902,
                            -20.04378
                        ],
                        [
                            33.01082,
                            -20.01728
                        ],
                        [
                            33.05199,
                            -19.781
                        ],
                        [
                            32.95881,
                            -19.72177
                        ],
                        [
                            32.96859,
                            -19.65607
                        ],
                        [
                            32.85038,
                            -19.68414
                        ],
                        [
                            32.84447,
                            -19.48007
                        ],
                        [
                            32.77983,
                            -19.46194
                        ],
                        [
                            32.7797,
                            -19.35871
                        ],
                        [
                            32.84992,
                            -19.29134
                        ],
                        [
                            32.8769,
                            -19.11315
                        ],
                        [
                            32.84592,
                            -19.02843
                        ],
                        [
                            32.71884,
                            -19.02099
                        ],
                        [
                            32.70113,
                            -18.94278
                        ],
                        [
                            32.72991,
                            -18.92509
                        ],
                        [
                            32.71519,
                            -18.83149
                        ],
                        [
                            32.81776,
                            -18.7803
                        ],
                        [
                            32.87511,
                            -18.79577
                        ],
                        [
                            32.92678,
                            -18.76697
                        ],
                        [
                            32.95407,
                            -18.69327
                        ],
                        [
                            32.88791,
                            -18.58037
                        ],
                        [
                            32.89113,
                            -18.50857
                        ],
                        [
                            33.01475,
                            -18.47267
                        ],
                        [
                            33.02336,
                            -18.39417
                        ],
                        [
                            33.05403,
                            -18.36214
                        ],
                        [
                            33.00189,
                            -18.30203
                        ],
                        [
                            33.00839,
                            -18.2339
                        ],
                        [
                            32.94246,
                            -17.98577
                        ],
                        [
                            32.96095,
                            -17.81769
                        ],
                        [
                            33.00862,
                            -17.80066
                        ],
                        [
                            33.00396,
                            -17.74048
                        ],
                        [
                            33.04251,
                            -17.60695
                        ],
                        [
                            32.98095,
                            -17.5607
                        ],
                        [
                            32.95981,
                            -17.49275
                        ],
                        [
                            33.04325,
                            -17.34674
                        ],
                        [
                            32.99837,
                            -17.30914
                        ],
                        [
                            32.9865,
                            -17.1806
                        ],
                        [
                            32.93931,
                            -17.0717
                        ],
                        [
                            32.84866,
                            -16.94669
                        ],
                        [
                            32.91223,
                            -16.89277
                        ],
                        [
                            32.96673,
                            -16.77175
                        ],
                        [
                            32.97645,
                            -16.70767
                        ],
                        [
                            32.89076,
                            -16.7193
                        ],
                        [
                            32.76654,
                            -16.70788
                        ],
                        [
                            32.7038,
                            -16.67706
                        ],
                        [
                            32.70849,
                            -16.60026
                        ],
                        [
                            32.41156,
                            -16.46957
                        ],
                        [
                            32.27757,
                            -16.43467
                        ],
                        [
                            32.03821,
                            -16.44193
                        ],
                        [
                            31.91841,
                            -16.41389
                        ],
                        [
                            31.89442,
                            -16.33817
                        ],
                        [
                            31.83336,
                            -16.31035
                        ],
                        [
                            31.77082,
                            -16.23751
                        ],
                        [
                            31.69154,
                            -16.20191
                        ],
                        [
                            31.54729,
                            -16.18457
                        ],
                        [
                            31.43106,
                            -16.1556
                        ],
                        [
                            31.30676,
                            -16.02725
                        ],
                        [
                            31.13821,
                            -15.98318
                        ],
                        [
                            31.03131,
                            -16.01927
                        ],
                        [
                            30.98351,
                            -16.05862
                        ],
                        [
                            30.92071,
                            -16.0001
                        ],
                        [
                            30.42584,
                            -15.99957
                        ],
                        [
                            30.42519,
                            -15.63229
                        ],
                        [
                            30.41826,
                            -15.61757
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "ASM",
                "Country": "American Samoa",
                "Total_3GHG": null,
                "Total_3GHG_timeseries": {},
                "Fossil_3GHG": null,
                "Fossil_3GHG_timeseries": {},
                "Land_3GHG": null,
                "Land_3GHG_timeseries": {},
                "Total_CO2": null,
                "Total_CO2_timeseries": {},
                "Fossil_CO2": null,
                "Fossil_CO2_timeseries": {},
                "Land_CO2": null,
                "Land_CO2_timeseries": {},
                "Total_CH4": null,
                "Total_CH4_timeseries": {},
                "Fossil_CH4": null,
                "Fossil_CH4_timeseries": {},
                "Land_CH4": null,
                "Land_CH4_timeseries": {},
                "Total_N2O": null,
                "Total_N2O_timeseries": {},
                "Fossil_N2O": null,
                "Fossil_N2O_timeseries": {},
                "Land_N2O": null,
                "Land_N2O_timeseries": {}
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -170.84145,
                                -14.32213
                            ],
                            [
                                -170.74062,
                                -14.36413
                            ],
                            [
                                -170.67643,
                                -14.28486
                            ],
                            [
                                -170.79856,
                                -14.2906
                            ],
                            [
                                -170.84145,
                                -14.32213
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -169.51862,
                                -14.22145
                            ],
                            [
                                -169.49672,
                                -14.26566
                            ],
                            [
                                -169.42303,
                                -14.25573
                            ],
                            [
                                -169.428,
                                -14.21157
                            ],
                            [
                                -169.51862,
                                -14.22145
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "BLM",
                "Country": "Saint Barth\xe9lemy",
                "Total_3GHG": null,
                "Total_3GHG_timeseries": {},
                "Fossil_3GHG": null,
                "Fossil_3GHG_timeseries": {},
                "Land_3GHG": null,
                "Land_3GHG_timeseries": {},
                "Total_CO2": null,
                "Total_CO2_timeseries": {},
                "Fossil_CO2": null,
                "Fossil_CO2_timeseries": {},
                "Land_CO2": null,
                "Land_CO2_timeseries": {},
                "Total_CH4": null,
                "Total_CH4_timeseries": {},
                "Fossil_CH4": null,
                "Fossil_CH4_timeseries": {},
                "Land_CH4": null,
                "Land_CH4_timeseries": {},
                "Total_N2O": null,
                "Total_N2O_timeseries": {},
                "Fossil_N2O": null,
                "Fossil_N2O_timeseries": {},
                "Land_N2O": null,
                "Land_N2O_timeseries": {}
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -62.87255,
                            17.92677
                        ],
                        [
                            -62.84013,
                            17.87958
                        ],
                        [
                            -62.7957,
                            17.89739
                        ],
                        [
                            -62.80985,
                            17.91168
                        ],
                        [
                            -62.84048,
                            17.90466
                        ],
                        [
                            -62.87255,
                            17.92677
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "BVT",
                "Country": "Bouvet Island",
                "Total_3GHG": null,
                "Total_3GHG_timeseries": {},
                "Fossil_3GHG": null,
                "Fossil_3GHG_timeseries": {},
                "Land_3GHG": null,
                "Land_3GHG_timeseries": {},
                "Total_CO2": null,
                "Total_CO2_timeseries": {},
                "Fossil_CO2": null,
                "Fossil_CO2_timeseries": {},
                "Land_CO2": null,
                "Land_CO2_timeseries": {},
                "Total_CH4": null,
                "Total_CH4_timeseries": {},
                "Fossil_CH4": null,
                "Fossil_CH4_timeseries": {},
                "Land_CH4": null,
                "Land_CH4_timeseries": {},
                "Total_N2O": null,
                "Total_N2O_timeseries": {},
                "Fossil_N2O": null,
                "Fossil_N2O_timeseries": {},
                "Land_N2O": null,
                "Land_N2O_timeseries": {}
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            3.29714,
                            -54.41718
                        ],
                        [
                            3.32975,
                            -54.45064
                        ],
                        [
                            3.41282,
                            -54.44449
                        ],
                        [
                            3.37332,
                            -54.39123
                        ],
                        [
                            3.29714,
                            -54.41718
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "CCK",
                "Country": "Cocos (Keeling) Islands",
                "Total_3GHG": null,
                "Total_3GHG_timeseries": {},
                "Fossil_3GHG": null,
                "Fossil_3GHG_timeseries": {},
                "Land_3GHG": null,
                "Land_3GHG_timeseries": {},
                "Total_CO2": null,
                "Total_CO2_timeseries": {},
                "Fossil_CO2": null,
                "Fossil_CO2_timeseries": {},
                "Land_CO2": null,
                "Land_CO2_timeseries": {},
                "Total_CH4": null,
                "Total_CH4_timeseries": {},
                "Fossil_CH4": null,
                "Fossil_CH4_timeseries": {},
                "Land_CH4": null,
                "Land_CH4_timeseries": {},
                "Total_N2O": null,
                "Total_N2O_timeseries": {},
                "Fossil_N2O": null,
                "Fossil_N2O_timeseries": {},
                "Land_N2O": null,
                "Land_N2O_timeseries": {}
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            96.81946,
                            -12.18138
                        ],
                        [
                            96.82689,
                            -12.18714
                        ],
                        [
                            96.83405,
                            -12.18609
                        ],
                        [
                            96.82635,
                            -12.1779
                        ],
                        [
                            96.81946,
                            -12.18138
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "CPT",
                "Country": "Clipperton Island",
                "Total_3GHG": null,
                "Total_3GHG_timeseries": {},
                "Fossil_3GHG": null,
                "Fossil_3GHG_timeseries": {},
                "Land_3GHG": null,
                "Land_3GHG_timeseries": {},
                "Total_CO2": null,
                "Total_CO2_timeseries": {},
                "Fossil_CO2": null,
                "Fossil_CO2_timeseries": {},
                "Land_CO2": null,
                "Land_CO2_timeseries": {},
                "Total_CH4": null,
                "Total_CH4_timeseries": {},
                "Fossil_CH4": null,
                "Fossil_CH4_timeseries": {},
                "Land_CH4": null,
                "Land_CH4_timeseries": {},
                "Total_N2O": null,
                "Total_N2O_timeseries": {},
                "Fossil_N2O": null,
                "Fossil_N2O_timeseries": {},
                "Land_N2O": null,
                "Land_N2O_timeseries": {}
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -109.23472,
                            10.30915
                        ],
                        [
                            -109.21867,
                            10.28849
                        ],
                        [
                            -109.20133,
                            10.30864
                        ],
                        [
                            -109.22726,
                            10.31934
                        ],
                        [
                            -109.23472,
                            10.30915
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "GGY",
                "Country": "Guernsey",
                "Total_3GHG": null,
                "Total_3GHG_timeseries": {},
                "Fossil_3GHG": null,
                "Fossil_3GHG_timeseries": {},
                "Land_3GHG": null,
                "Land_3GHG_timeseries": {},
                "Total_CO2": null,
                "Total_CO2_timeseries": {},
                "Fossil_CO2": null,
                "Fossil_CO2_timeseries": {},
                "Land_CO2": null,
                "Land_CO2_timeseries": {},
                "Total_CH4": null,
                "Total_CH4_timeseries": {},
                "Fossil_CH4": null,
                "Fossil_CH4_timeseries": {},
                "Land_CH4": null,
                "Land_CH4_timeseries": {},
                "Total_N2O": null,
                "Total_N2O_timeseries": {},
                "Fossil_N2O": null,
                "Fossil_N2O_timeseries": {},
                "Land_N2O": null,
                "Land_N2O_timeseries": {}
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -2.57555,
                            49.42341
                        ],
                        [
                            -2.51812,
                            49.50722
                        ],
                        [
                            -2.65581,
                            49.45719
                        ],
                        [
                            -2.57555,
                            49.42341
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "GIB",
                "Country": "Gibraltar",
                "Total_3GHG": null,
                "Total_3GHG_timeseries": {},
                "Fossil_3GHG": null,
                "Fossil_3GHG_timeseries": {},
                "Land_3GHG": null,
                "Land_3GHG_timeseries": {},
                "Total_CO2": null,
                "Total_CO2_timeseries": {},
                "Fossil_CO2": null,
                "Fossil_CO2_timeseries": {},
                "Land_CO2": null,
                "Land_CO2_timeseries": {},
                "Total_CH4": null,
                "Total_CH4_timeseries": {},
                "Fossil_CH4": null,
                "Fossil_CH4_timeseries": {},
                "Land_CH4": null,
                "Land_CH4_timeseries": {},
                "Total_N2O": null,
                "Total_N2O_timeseries": {},
                "Fossil_N2O": null,
                "Fossil_N2O_timeseries": {},
                "Land_N2O": null,
                "Land_N2O_timeseries": {}
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -5.35152,
                            36.15257
                        ],
                        [
                            -5.35591,
                            36.12522
                        ],
                        [
                            -5.34126,
                            36.12467
                        ],
                        [
                            -5.33922,
                            36.15203
                        ],
                        [
                            -5.35152,
                            36.15257
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "HMD",
                "Country": "Heard Island and Mcdonald Islands",
                "Total_3GHG": null,
                "Total_3GHG_timeseries": {},
                "Fossil_3GHG": null,
                "Fossil_3GHG_timeseries": {},
                "Land_3GHG": null,
                "Land_3GHG_timeseries": {},
                "Total_CO2": null,
                "Total_CO2_timeseries": {},
                "Fossil_CO2": null,
                "Fossil_CO2_timeseries": {},
                "Land_CO2": null,
                "Land_CO2_timeseries": {},
                "Total_CH4": null,
                "Total_CH4_timeseries": {},
                "Fossil_CH4": null,
                "Fossil_CH4_timeseries": {},
                "Land_CH4": null,
                "Land_CH4_timeseries": {},
                "Total_N2O": null,
                "Total_N2O_timeseries": {},
                "Fossil_N2O": null,
                "Fossil_N2O_timeseries": {},
                "Land_N2O": null,
                "Land_N2O_timeseries": {}
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            73.25251,
                            -52.98916
                        ],
                        [
                            73.36249,
                            -53.02223
                        ],
                        [
                            73.39747,
                            -53.18815
                        ],
                        [
                            73.49235,
                            -53.21812
                        ],
                        [
                            73.72054,
                            -53.13856
                        ],
                        [
                            73.65045,
                            -53.04794
                        ],
                        [
                            73.57331,
                            -53.0203
                        ],
                        [
                            73.37067,
                            -53.01984
                        ],
                        [
                            73.25251,
                            -52.98916
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "SGS",
                "Country": "South Georgia and The South Sandwich Islands",
                "Total_3GHG": null,
                "Total_3GHG_timeseries": {},
                "Fossil_3GHG": null,
                "Fossil_3GHG_timeseries": {},
                "Land_3GHG": null,
                "Land_3GHG_timeseries": {},
                "Total_CO2": null,
                "Total_CO2_timeseries": {},
                "Fossil_CO2": null,
                "Fossil_CO2_timeseries": {},
                "Land_CO2": null,
                "Land_CO2_timeseries": {},
                "Total_CH4": null,
                "Total_CH4_timeseries": {},
                "Fossil_CH4": null,
                "Fossil_CH4_timeseries": {},
                "Land_CH4": null,
                "Land_CH4_timeseries": {},
                "Total_N2O": null,
                "Total_N2O_timeseries": {},
                "Fossil_N2O": null,
                "Fossil_N2O_timeseries": {},
                "Land_N2O": null,
                "Land_N2O_timeseries": {}
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -38.01606,
                                -54.05948
                            ],
                            [
                                -37.67746,
                                -54.03457
                            ],
                            [
                                -37.61201,
                                -54.05519
                            ],
                            [
                                -37.67882,
                                -54.17569
                            ],
                            [
                                -37.40964,
                                -54.15103
                            ],
                            [
                                -37.32534,
                                -54.22945
                            ],
                            [
                                -37.09324,
                                -54.28676
                            ],
                            [
                                -37.0157,
                                -54.35329
                            ],
                            [
                                -36.92839,
                                -54.34383
                            ],
                            [
                                -36.83455,
                                -54.40615
                            ],
                            [
                                -36.81078,
                                -54.45838
                            ],
                            [
                                -36.65684,
                                -54.50332
                            ],
                            [
                                -36.53197,
                                -54.50015
                            ],
                            [
                                -36.47721,
                                -54.57672
                            ],
                            [
                                -36.36008,
                                -54.64993
                            ],
                            [
                                -36.26123,
                                -54.79378
                            ],
                            [
                                -36.08689,
                                -54.88524
                            ],
                            [
                                -35.98667,
                                -54.87316
                            ],
                            [
                                -35.83322,
                                -54.7595
                            ],
                            [
                                -35.91338,
                                -54.69255
                            ],
                            [
                                -35.93604,
                                -54.61949
                            ],
                            [
                                -36.07381,
                                -54.56516
                            ],
                            [
                                -36.05238,
                                -54.46764
                            ],
                            [
                                -36.14199,
                                -54.46182
                            ],
                            [
                                -36.24093,
                                -54.34777
                            ],
                            [
                                -36.25802,
                                -54.29723
                            ],
                            [
                                -36.39166,
                                -54.27799
                            ],
                            [
                                -36.61741,
                                -54.28311
                            ],
                            [
                                -36.67502,
                                -54.25448
                            ],
                            [
                                -36.68181,
                                -54.13936
                            ],
                            [
                                -36.90112,
                                -54.08028
                            ],
                            [
                                -37.0855,
                                -54.08767
                            ],
                            [
                                -37.3508,
                                -54.05197
                            ],
                            [
                                -37.4196,
                                -54.06574
                            ],
                            [
                                -37.5067,
                                -54.02308
                            ],
                            [
                                -37.71101,
                                -53.98831
                            ],
                            [
                                -37.78565,
                                -54.01595
                            ],
                            [
                                -37.94542,
                                -54.00602
                            ],
                            [
                                -38.01606,
                                -54.05948
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -26.45122,
                                -58.43628
                            ],
                            [
                                -26.28992,
                                -58.48308
                            ],
                            [
                                -26.26781,
                                -58.39348
                            ],
                            [
                                -26.4314,
                                -58.39577
                            ],
                            [
                                -26.45122,
                                -58.43628
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "GUM",
                "Country": "Guam",
                "Total_3GHG": null,
                "Total_3GHG_timeseries": {},
                "Fossil_3GHG": null,
                "Fossil_3GHG_timeseries": {},
                "Land_3GHG": null,
                "Land_3GHG_timeseries": {},
                "Total_CO2": null,
                "Total_CO2_timeseries": {},
                "Fossil_CO2": null,
                "Fossil_CO2_timeseries": {},
                "Land_CO2": null,
                "Land_CO2_timeseries": {},
                "Total_CH4": null,
                "Total_CH4_timeseries": {},
                "Fossil_CH4": null,
                "Fossil_CH4_timeseries": {},
                "Land_CH4": null,
                "Land_CH4_timeseries": {},
                "Total_N2O": null,
                "Total_N2O_timeseries": {},
                "Fossil_N2O": null,
                "Fossil_N2O_timeseries": {},
                "Land_N2O": null,
                "Land_N2O_timeseries": {}
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            144.61862,
                            13.44686
                        ],
                        [
                            144.66228,
                            13.397
                        ],
                        [
                            144.64701,
                            13.33456
                        ],
                        [
                            144.66325,
                            13.27014
                        ],
                        [
                            144.7271,
                            13.24811
                        ],
                        [
                            144.76916,
                            13.29591
                        ],
                        [
                            144.7734,
                            13.39323
                        ],
                        [
                            144.92554,
                            13.52247
                        ],
                        [
                            144.95491,
                            13.59784
                        ],
                        [
                            144.85117,
                            13.64664
                        ],
                        [
                            144.83586,
                            13.59063
                        ],
                        [
                            144.76345,
                            13.47924
                        ],
                        [
                            144.66204,
                            13.44247
                        ],
                        [
                            144.61862,
                            13.44686
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "IMN",
                "Country": "Isle of Man",
                "Total_3GHG": null,
                "Total_3GHG_timeseries": {},
                "Fossil_3GHG": null,
                "Fossil_3GHG_timeseries": {},
                "Land_3GHG": null,
                "Land_3GHG_timeseries": {},
                "Total_CO2": null,
                "Total_CO2_timeseries": {},
                "Fossil_CO2": null,
                "Fossil_CO2_timeseries": {},
                "Land_CO2": null,
                "Land_CO2_timeseries": {},
                "Total_CH4": null,
                "Total_CH4_timeseries": {},
                "Fossil_CH4": null,
                "Fossil_CH4_timeseries": {},
                "Land_CH4": null,
                "Land_CH4_timeseries": {},
                "Total_N2O": null,
                "Total_N2O_timeseries": {},
                "Fossil_N2O": null,
                "Fossil_N2O_timeseries": {},
                "Land_N2O": null,
                "Land_N2O_timeseries": {}
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -4.79305,
                            54.06376
                        ],
                        [
                            -4.66997,
                            54.06257
                        ],
                        [
                            -4.46723,
                            54.14242
                        ],
                        [
                            -4.30978,
                            54.29847
                        ],
                        [
                            -4.3694,
                            54.31353
                        ],
                        [
                            -4.38033,
                            54.41502
                        ],
                        [
                            -4.53327,
                            54.36884
                        ],
                        [
                            -4.61162,
                            54.26959
                        ],
                        [
                            -4.71764,
                            54.2121
                        ],
                        [
                            -4.73123,
                            54.14083
                        ],
                        [
                            -4.79305,
                            54.06376
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "IOT",
                "Country": "British Indian Ocean Territory",
                "Total_3GHG": null,
                "Total_3GHG_timeseries": {},
                "Fossil_3GHG": null,
                "Fossil_3GHG_timeseries": {},
                "Land_3GHG": null,
                "Land_3GHG_timeseries": {},
                "Total_CO2": null,
                "Total_CO2_timeseries": {},
                "Fossil_CO2": null,
                "Fossil_CO2_timeseries": {},
                "Land_CO2": null,
                "Land_CO2_timeseries": {},
                "Total_CH4": null,
                "Total_CH4_timeseries": {},
                "Fossil_CH4": null,
                "Fossil_CH4_timeseries": {},
                "Land_CH4": null,
                "Land_CH4_timeseries": {},
                "Total_N2O": null,
                "Total_N2O_timeseries": {},
                "Fossil_N2O": null,
                "Fossil_N2O_timeseries": {},
                "Land_N2O": null,
                "Land_N2O_timeseries": {}
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            72.43369,
                            -7.43164
                        ],
                        [
                            72.49292,
                            -7.3814
                        ],
                        [
                            72.4883,
                            -7.37256
                        ],
                        [
                            72.45403,
                            -7.40235
                        ],
                        [
                            72.43369,
                            -7.43164
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "JEY",
                "Country": "Jersey",
                "Total_3GHG": null,
                "Total_3GHG_timeseries": {},
                "Fossil_3GHG": null,
                "Fossil_3GHG_timeseries": {},
                "Land_3GHG": null,
                "Land_3GHG_timeseries": {},
                "Total_CO2": null,
                "Total_CO2_timeseries": {},
                "Fossil_CO2": null,
                "Fossil_CO2_timeseries": {},
                "Land_CO2": null,
                "Land_CO2_timeseries": {},
                "Total_CH4": null,
                "Total_CH4_timeseries": {},
                "Fossil_CH4": null,
                "Fossil_CH4_timeseries": {},
                "Land_CH4": null,
                "Land_CH4_timeseries": {},
                "Total_N2O": null,
                "Total_N2O_timeseries": {},
                "Fossil_N2O": null,
                "Fossil_N2O_timeseries": {},
                "Land_N2O": null,
                "Land_N2O_timeseries": {}
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -2.25401,
                            49.25201
                        ],
                        [
                            -2.22407,
                            49.17479
                        ],
                        [
                            -2.12777,
                            49.19331
                        ],
                        [
                            -2.02806,
                            49.16676
                        ],
                        [
                            -2.0242,
                            49.23218
                        ],
                        [
                            -2.15168,
                            49.26126
                        ],
                        [
                            -2.25401,
                            49.25201
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "CYM",
                "Country": "Cayman Islands",
                "Total_3GHG": null,
                "Total_3GHG_timeseries": {},
                "Fossil_3GHG": null,
                "Fossil_3GHG_timeseries": {},
                "Land_3GHG": null,
                "Land_3GHG_timeseries": {},
                "Total_CO2": null,
                "Total_CO2_timeseries": {},
                "Fossil_CO2": null,
                "Fossil_CO2_timeseries": {},
                "Land_CO2": null,
                "Land_CO2_timeseries": {},
                "Total_CH4": null,
                "Total_CH4_timeseries": {},
                "Fossil_CH4": null,
                "Fossil_CH4_timeseries": {},
                "Land_CH4": null,
                "Land_CH4_timeseries": {},
                "Total_N2O": null,
                "Total_N2O_timeseries": {},
                "Fossil_N2O": null,
                "Fossil_N2O_timeseries": {},
                "Land_N2O": null,
                "Land_N2O_timeseries": {}
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -81.41973,
                            19.37489
                        ],
                        [
                            -81.38363,
                            19.3476
                        ],
                        [
                            -81.39269,
                            19.28121
                        ],
                        [
                            -81.28106,
                            19.26311
                        ],
                        [
                            -81.21398,
                            19.2956
                        ],
                        [
                            -81.11432,
                            19.29427
                        ],
                        [
                            -81.09894,
                            19.3533
                        ],
                        [
                            -81.26531,
                            19.35773
                        ],
                        [
                            -81.31987,
                            19.29518
                        ],
                        [
                            -81.36637,
                            19.31381
                        ],
                        [
                            -81.38859,
                            19.39639
                        ],
                        [
                            -81.41973,
                            19.37489
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "MNP",
                "Country": "Northern Mariana Islands",
                "Total_3GHG": null,
                "Total_3GHG_timeseries": {},
                "Fossil_3GHG": null,
                "Fossil_3GHG_timeseries": {},
                "Land_3GHG": null,
                "Land_3GHG_timeseries": {},
                "Total_CO2": null,
                "Total_CO2_timeseries": {},
                "Fossil_CO2": null,
                "Fossil_CO2_timeseries": {},
                "Land_CO2": null,
                "Land_CO2_timeseries": {},
                "Total_CH4": null,
                "Total_CH4_timeseries": {},
                "Fossil_CH4": null,
                "Fossil_CH4_timeseries": {},
                "Land_CH4": null,
                "Land_CH4_timeseries": {},
                "Total_N2O": null,
                "Total_N2O_timeseries": {},
                "Fossil_N2O": null,
                "Fossil_N2O_timeseries": {},
                "Land_N2O": null,
                "Land_N2O_timeseries": {}
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                145.69102,
                                15.11996
                            ],
                            [
                                145.75024,
                                15.15882
                            ],
                            [
                                145.82988,
                                15.27257
                            ],
                            [
                                145.81119,
                                15.28965
                            ],
                            [
                                145.72886,
                                15.21894
                            ],
                            [
                                145.69102,
                                15.11996
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                145.58226,
                                15.01791
                            ],
                            [
                                145.64576,
                                14.92605
                            ],
                            [
                                145.67412,
                                15.0048
                            ],
                            [
                                145.6023,
                                15.05748
                            ],
                            [
                                145.58226,
                                15.01791
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                145.12172,
                                14.12161
                            ],
                            [
                                145.21359,
                                14.11638
                            ],
                            [
                                145.23726,
                                14.19946
                            ],
                            [
                                145.16022,
                                14.16843
                            ],
                            [
                                145.12172,
                                14.12161
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "NFK",
                "Country": "Norfolk Island",
                "Total_3GHG": null,
                "Total_3GHG_timeseries": {},
                "Fossil_3GHG": null,
                "Fossil_3GHG_timeseries": {},
                "Land_3GHG": null,
                "Land_3GHG_timeseries": {},
                "Total_CO2": null,
                "Total_CO2_timeseries": {},
                "Fossil_CO2": null,
                "Fossil_CO2_timeseries": {},
                "Land_CO2": null,
                "Land_CO2_timeseries": {},
                "Total_CH4": null,
                "Total_CH4_timeseries": {},
                "Fossil_CH4": null,
                "Fossil_CH4_timeseries": {},
                "Land_CH4": null,
                "Land_CH4_timeseries": {},
                "Total_N2O": null,
                "Total_N2O_timeseries": {},
                "Fossil_N2O": null,
                "Fossil_N2O_timeseries": {},
                "Land_N2O": null,
                "Land_N2O_timeseries": {}
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            167.91781,
                            -29.00786
                        ],
                        [
                            167.91994,
                            -29.05166
                        ],
                        [
                            167.96788,
                            -29.06125
                        ],
                        [
                            167.95454,
                            -29.00551
                        ],
                        [
                            167.91781,
                            -29.00786
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "PCN",
                "Country": "Pitcairn Islands",
                "Total_3GHG": null,
                "Total_3GHG_timeseries": {},
                "Fossil_3GHG": null,
                "Fossil_3GHG_timeseries": {},
                "Land_3GHG": null,
                "Land_3GHG_timeseries": {},
                "Total_CO2": null,
                "Total_CO2_timeseries": {},
                "Fossil_CO2": null,
                "Fossil_CO2_timeseries": {},
                "Land_CO2": null,
                "Land_CO2_timeseries": {},
                "Total_CH4": null,
                "Total_CH4_timeseries": {},
                "Fossil_CH4": null,
                "Fossil_CH4_timeseries": {},
                "Land_CH4": null,
                "Land_CH4_timeseries": {},
                "Total_N2O": null,
                "Total_N2O_timeseries": {},
                "Fossil_N2O": null,
                "Fossil_N2O_timeseries": {},
                "Land_N2O": null,
                "Land_N2O_timeseries": {}
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -128.35707,
                            -24.36846
                        ],
                        [
                            -128.33697,
                            -24.40719
                        ],
                        [
                            -128.29188,
                            -24.41749
                        ],
                        [
                            -128.30655,
                            -24.34928
                        ],
                        [
                            -128.35707,
                            -24.36846
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "PRI",
                "Country": "Puerto Rico",
                "Total_3GHG": null,
                "Total_3GHG_timeseries": {},
                "Fossil_3GHG": null,
                "Fossil_3GHG_timeseries": {},
                "Land_3GHG": null,
                "Land_3GHG_timeseries": {},
                "Total_CO2": null,
                "Total_CO2_timeseries": {},
                "Fossil_CO2": null,
                "Fossil_CO2_timeseries": {},
                "Land_CO2": null,
                "Land_CO2_timeseries": {},
                "Total_CH4": null,
                "Total_CH4_timeseries": {},
                "Fossil_CH4": null,
                "Fossil_CH4_timeseries": {},
                "Land_CH4": null,
                "Land_CH4_timeseries": {},
                "Total_N2O": null,
                "Total_N2O_timeseries": {},
                "Fossil_N2O": null,
                "Fossil_N2O_timeseries": {},
                "Land_N2O": null,
                "Land_N2O_timeseries": {}
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -65.72865,
                                18.18277
                            ],
                            [
                                -65.63762,
                                18.2236
                            ],
                            [
                                -65.62631,
                                18.30743
                            ],
                            [
                                -65.64441,
                                18.37583
                            ],
                            [
                                -65.69584,
                                18.36803
                            ],
                            [
                                -65.77347,
                                18.4118
                            ],
                            [
                                -65.90162,
                                18.45202
                            ],
                            [
                                -66.04339,
                                18.45405
                            ],
                            [
                                -66.10745,
                                18.43021
                            ],
                            [
                                -66.14173,
                                18.46151
                            ],
                            [
                                -66.39979,
                                18.49092
                            ],
                            [
                                -66.46662,
                                18.46944
                            ],
                            [
                                -66.62637,
                                18.49357
                            ],
                            [
                                -66.71197,
                                18.47314
                            ],
                            [
                                -66.79048,
                                18.49189
                            ],
                            [
                                -66.91282,
                                18.48482
                            ],
                            [
                                -67.01512,
                                18.50921
                            ],
                            [
                                -67.14212,
                                18.50418
                            ],
                            [
                                -67.15963,
                                18.4172
                            ],
                            [
                                -67.27032,
                                18.36212
                            ],
                            [
                                -67.19488,
                                18.28726
                            ],
                            [
                                -67.15727,
                                18.19385
                            ],
                            [
                                -67.18232,
                                18.16591
                            ],
                            [
                                -67.20558,
                                18.03833
                            ],
                            [
                                -67.17774,
                                17.96325
                            ],
                            [
                                -67.10673,
                                17.94621
                            ],
                            [
                                -67.05832,
                                17.97313
                            ],
                            [
                                -66.98603,
                                17.96913
                            ],
                            [
                                -66.95472,
                                17.93218
                            ],
                            [
                                -66.83468,
                                17.95138
                            ],
                            [
                                -66.76699,
                                18.00424
                            ],
                            [
                                -66.67201,
                                17.96817
                            ],
                            [
                                -66.58001,
                                17.96314
                            ],
                            [
                                -66.46471,
                                17.98974
                            ],
                            [
                                -66.38649,
                                17.94126
                            ],
                            [
                                -66.32435,
                                17.97779
                            ],
                            [
                                -66.23644,
                                17.93009
                            ],
                            [
                                -66.15387,
                                17.93201
                            ],
                            [
                                -66.01525,
                                17.97904
                            ],
                            [
                                -65.92002,
                                17.9763
                            ],
                            [
                                -65.8356,
                                18.01611
                            ],
                            [
                                -65.76875,
                                18.14423
                            ],
                            [
                                -65.72865,
                                18.18277
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -65.57681,
                                18.10322
                            ],
                            [
                                -65.53271,
                                18.08042
                            ],
                            [
                                -65.42365,
                                18.0967
                            ],
                            [
                                -65.39472,
                                18.16229
                            ],
                            [
                                -65.57681,
                                18.10322
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "TKL",
                "Country": "Tokelau",
                "Total_3GHG": null,
                "Total_3GHG_timeseries": {},
                "Fossil_3GHG": null,
                "Fossil_3GHG_timeseries": {},
                "Land_3GHG": null,
                "Land_3GHG_timeseries": {},
                "Total_CO2": null,
                "Total_CO2_timeseries": {},
                "Fossil_CO2": null,
                "Fossil_CO2_timeseries": {},
                "Land_CO2": null,
                "Land_CO2_timeseries": {},
                "Total_CH4": null,
                "Total_CH4_timeseries": {},
                "Fossil_CH4": null,
                "Fossil_CH4_timeseries": {},
                "Land_CH4": null,
                "Land_CH4_timeseries": {},
                "Total_N2O": null,
                "Total_N2O_timeseries": {},
                "Fossil_N2O": null,
                "Fossil_N2O_timeseries": {},
                "Land_N2O": null,
                "Land_N2O_timeseries": {}
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -172.50283,
                            -8.58274
                        ],
                        [
                            -172.47902,
                            -8.57604
                        ],
                        [
                            -172.4654,
                            -8.57564
                        ],
                        [
                            -172.46663,
                            -8.56597
                        ],
                        [
                            -172.46544,
                            -8.55803
                        ],
                        [
                            -172.47818,
                            -8.54957
                        ],
                        [
                            -172.48162,
                            -8.5513
                        ],
                        [
                            -172.46759,
                            -8.55958
                        ],
                        [
                            -172.46978,
                            -8.57345
                        ],
                        [
                            -172.47535,
                            -8.57023
                        ],
                        [
                            -172.48659,
                            -8.57593
                        ],
                        [
                            -172.49737,
                            -8.57729
                        ],
                        [
                            -172.50283,
                            -8.58274
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "ATF",
                "Country": "French Southern and Antarctic Lands",
                "Total_3GHG": null,
                "Total_3GHG_timeseries": {},
                "Fossil_3GHG": null,
                "Fossil_3GHG_timeseries": {},
                "Land_3GHG": null,
                "Land_3GHG_timeseries": {},
                "Total_CO2": null,
                "Total_CO2_timeseries": {},
                "Fossil_CO2": null,
                "Fossil_CO2_timeseries": {},
                "Land_CO2": null,
                "Land_CO2_timeseries": {},
                "Total_CH4": null,
                "Total_CH4_timeseries": {},
                "Fossil_CH4": null,
                "Fossil_CH4_timeseries": {},
                "Land_CH4": null,
                "Land_CH4_timeseries": {},
                "Total_N2O": null,
                "Total_N2O_timeseries": {},
                "Fossil_N2O": null,
                "Fossil_N2O_timeseries": {},
                "Land_N2O": null,
                "Land_N2O_timeseries": {}
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                69.9203,
                                -49.69497
                            ],
                            [
                                70.04181,
                                -49.71436
                            ],
                            [
                                70.24745,
                                -49.66685
                            ],
                            [
                                70.31656,
                                -49.57386
                            ],
                            [
                                70.13317,
                                -49.51054
                            ],
                            [
                                70.01302,
                                -49.54236
                            ],
                            [
                                69.94553,
                                -49.59548
                            ],
                            [
                                69.79908,
                                -49.54816
                            ],
                            [
                                69.77988,
                                -49.4786
                            ],
                            [
                                69.87024,
                                -49.35336
                            ],
                            [
                                69.98618,
                                -49.37313
                            ],
                            [
                                70.10996,
                                -49.34506
                            ],
                            [
                                70.3205,
                                -49.35133
                            ],
                            [
                                70.44179,
                                -49.37941
                            ],
                            [
                                70.53173,
                                -49.30336
                            ],
                            [
                                70.54981,
                                -49.19431
                            ],
                            [
                                70.51765,
                                -49.09646
                            ],
                            [
                                70.39272,
                                -49.05661
                            ],
                            [
                                70.24709,
                                -49.08388
                            ],
                            [
                                70.22002,
                                -49.15341
                            ],
                            [
                                70.08638,
                                -49.11734
                            ],
                            [
                                69.98968,
                                -49.14212
                            ],
                            [
                                69.85516,
                                -49.21455
                            ],
                            [
                                69.8348,
                                -49.26282
                            ],
                            [
                                69.71202,
                                -49.25322
                            ],
                            [
                                69.59802,
                                -49.27578
                            ],
                            [
                                69.46541,
                                -49.24594
                            ],
                            [
                                69.42157,
                                -49.1925
                            ],
                            [
                                69.49021,
                                -49.13145
                            ],
                            [
                                69.56748,
                                -49.13337
                            ],
                            [
                                69.65923,
                                -49.06604
                            ],
                            [
                                69.53539,
                                -48.96314
                            ],
                            [
                                69.49121,
                                -49.0383
                            ],
                            [
                                69.40224,
                                -49.03796
                            ],
                            [
                                69.33611,
                                -49.09679
                            ],
                            [
                                69.21488,
                                -49.12966
                            ],
                            [
                                69.18614,
                                -49.06337
                            ],
                            [
                                69.0972,
                                -48.99449
                            ],
                            [
                                69.08148,
                                -48.90195
                            ],
                            [
                                69.14495,
                                -48.85103
                            ],
                            [
                                69.04463,
                                -48.77209
                            ],
                            [
                                69.05728,
                                -48.69806
                            ],
                            [
                                68.95739,
                                -48.69579
                            ],
                            [
                                68.94334,
                                -48.7532
                            ],
                            [
                                68.87101,
                                -48.82172
                            ],
                            [
                                68.78848,
                                -48.84666
                            ],
                            [
                                68.85834,
                                -48.9347
                            ],
                            [
                                68.7846,
                                -48.98057
                            ],
                            [
                                68.79497,
                                -49.02769
                            ],
                            [
                                68.73119,
                                -49.07898
                            ],
                            [
                                68.82123,
                                -49.15265
                            ],
                            [
                                68.76357,
                                -49.20415
                            ],
                            [
                                68.84931,
                                -49.32782
                            ],
                            [
                                68.80398,
                                -49.3726
                            ],
                            [
                                68.89343,
                                -49.4531
                            ],
                            [
                                68.81924,
                                -49.48553
                            ],
                            [
                                68.83631,
                                -49.52982
                            ],
                            [
                                68.73543,
                                -49.64117
                            ],
                            [
                                68.78016,
                                -49.7266
                            ],
                            [
                                68.99834,
                                -49.71749
                            ],
                            [
                                69.08429,
                                -49.68653
                            ],
                            [
                                69.17548,
                                -49.58864
                            ],
                            [
                                69.36781,
                                -49.5793
                            ],
                            [
                                69.42028,
                                -49.63463
                            ],
                            [
                                69.69722,
                                -49.63198
                            ],
                            [
                                69.69188,
                                -49.54236
                            ],
                            [
                                69.87271,
                                -49.7067
                            ],
                            [
                                69.9203,
                                -49.69497
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                69.19235,
                                -48.99494
                            ],
                            [
                                69.21505,
                                -49.07144
                            ],
                            [
                                69.3118,
                                -49.09314
                            ],
                            [
                                69.40429,
                                -48.93068
                            ],
                            [
                                69.34898,
                                -48.88513
                            ],
                            [
                                69.19235,
                                -48.99494
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                51.64228,
                                -46.39178
                            ],
                            [
                                51.70168,
                                -46.45057
                            ],
                            [
                                51.83096,
                                -46.46386
                            ],
                            [
                                51.84556,
                                -46.39442
                            ],
                            [
                                51.73442,
                                -46.34205
                            ],
                            [
                                51.64228,
                                -46.39178
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                52.091,
                                -46.41973
                            ],
                            [
                                52.19818,
                                -46.47674
                            ],
                            [
                                52.30447,
                                -46.46198
                            ],
                            [
                                52.31761,
                                -46.4198
                            ],
                            [
                                52.18947,
                                -46.38162
                            ],
                            [
                                52.091,
                                -46.41973
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                50.16562,
                                -46.08896
                            ],
                            [
                                50.25594,
                                -46.14461
                            ],
                            [
                                50.26742,
                                -46.05916
                            ],
                            [
                                50.16562,
                                -46.08896
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "UMI",
                "Country": "United States Minor Outlying Islands",
                "Total_3GHG": null,
                "Total_3GHG_timeseries": {},
                "Fossil_3GHG": null,
                "Fossil_3GHG_timeseries": {},
                "Land_3GHG": null,
                "Land_3GHG_timeseries": {},
                "Total_CO2": null,
                "Total_CO2_timeseries": {},
                "Fossil_CO2": null,
                "Fossil_CO2_timeseries": {},
                "Land_CO2": null,
                "Land_CO2_timeseries": {},
                "Total_CH4": null,
                "Total_CH4_timeseries": {},
                "Fossil_CH4": null,
                "Fossil_CH4_timeseries": {},
                "Land_CH4": null,
                "Land_CH4_timeseries": {},
                "Total_N2O": null,
                "Total_N2O_timeseries": {},
                "Fossil_N2O": null,
                "Fossil_N2O_timeseries": {},
                "Land_N2O": null,
                "Land_N2O_timeseries": {}
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -162.7878,
                            6.6008
                        ],
                        [
                            -162.66714,
                            6.50865
                        ],
                        [
                            -162.57326,
                            6.47325
                        ],
                        [
                            -162.45775,
                            6.39155
                        ],
                        [
                            -162.39457,
                            6.38922
                        ],
                        [
                            -162.58288,
                            6.50849
                        ],
                        [
                            -162.7878,
                            6.6008
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "VIR",
                "Country": "Us Virgin Islands",
                "Total_3GHG": null,
                "Total_3GHG_timeseries": {},
                "Fossil_3GHG": null,
                "Fossil_3GHG_timeseries": {},
                "Land_3GHG": null,
                "Land_3GHG_timeseries": {},
                "Total_CO2": null,
                "Total_CO2_timeseries": {},
                "Fossil_CO2": null,
                "Fossil_CO2_timeseries": {},
                "Land_CO2": null,
                "Land_CO2_timeseries": {},
                "Total_CH4": null,
                "Total_CH4_timeseries": {},
                "Fossil_CH4": null,
                "Fossil_CH4_timeseries": {},
                "Land_CH4": null,
                "Land_CH4_timeseries": {},
                "Total_N2O": null,
                "Total_N2O_timeseries": {},
                "Fossil_N2O": null,
                "Fossil_N2O_timeseries": {},
                "Land_N2O": null,
                "Land_N2O_timeseries": {}
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                -64.90345,
                                17.67909
                            ],
                            [
                                -64.7173,
                                17.69911
                            ],
                            [
                                -64.70684,
                                17.74749
                            ],
                            [
                                -64.74864,
                                17.78171
                            ],
                            [
                                -64.87608,
                                17.76947
                            ],
                            [
                                -64.90345,
                                17.67909
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -65.04541,
                                18.3527
                            ],
                            [
                                -64.9055,
                                18.31173
                            ],
                            [
                                -64.89226,
                                18.36192
                            ],
                            [
                                -64.98955,
                                18.37124
                            ],
                            [
                                -65.04541,
                                18.3527
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "VAT",
                "Country": "Vatican City",
                "Total_3GHG": null,
                "Total_3GHG_timeseries": {},
                "Fossil_3GHG": null,
                "Fossil_3GHG_timeseries": {},
                "Land_3GHG": null,
                "Land_3GHG_timeseries": {},
                "Total_CO2": null,
                "Total_CO2_timeseries": {},
                "Fossil_CO2": null,
                "Fossil_CO2_timeseries": {},
                "Land_CO2": null,
                "Land_CO2_timeseries": {},
                "Total_CH4": null,
                "Total_CH4_timeseries": {},
                "Fossil_CH4": null,
                "Fossil_CH4_timeseries": {},
                "Land_CH4": null,
                "Land_CH4_timeseries": {},
                "Total_N2O": null,
                "Total_N2O_timeseries": {},
                "Fossil_N2O": null,
                "Fossil_N2O_timeseries": {},
                "Land_N2O": null,
                "Land_N2O_timeseries": {}
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            12.44806,
                            41.90082
                        ],
                        [
                            12.45784,
                            41.90155
                        ],
                        [
                            12.45125,
                            41.90628
                        ],
                        [
                            12.44806,
                            41.90082
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "ISO3": "XO",
                "Country": "Bassas Da India",
                "Total_3GHG": null,
                "Total_3GHG_timeseries": {},
                "Fossil_3GHG": null,
                "Fossil_3GHG_timeseries": {},
                "Land_3GHG": null,
                "Land_3GHG_timeseries": {},
                "Total_CO2": null,
                "Total_CO2_timeseries": {},
                "Fossil_CO2": null,
                "Fossil_CO2_timeseries": {},
                "Land_CO2": null,
                "Land_CO2_timeseries": {},
                "Total_CH4": null,
                "Total_CH4_timeseries": {},
                "Fossil_CH4": null,
                "Fossil_CH4_timeseries": {},
                "Land_CH4": null,
                "Land_CH4_timeseries": {},
                "Total_N2O": null,
                "Total_N2O_timeseries": {},
                "Fossil_N2O": null,
                "Fossil_N2O_timeseries": {},
                "Land_N2O": null,
                "Land_N2O_timeseries": {}
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            40.36403,
                            -22.36659
                        ],
                        [
                            40.36542,
                            -22.33941
                        ],
                        [
                            40.33308,
                            -22.34641
                        ],
                        [
                            40.33148,
                            -22.37545
                        ],
                        [
                            40.36403,
                            -22.36659
                        ]
                    ]
                ]
            }
        }
    ]
};


var $2a9498df2b5d3cfc$exports = {};


(function(factory) {
    var L, proj4;
    if (typeof define === 'function' && define.amd) // AMD
    define([
        'leaflet',
        'proj4'
    ], factory);
    else if (typeof $2a9498df2b5d3cfc$exports === "object") {
        // Node/CommonJS
        L = (parcelRequire("8JYDX"));
        proj4 = (parcelRequire("ebcW3"));
        $2a9498df2b5d3cfc$exports = factory(L, proj4);
    } else {
        // Browser globals
        if (typeof window.L === 'undefined' || typeof window.proj4 === 'undefined') throw 'Leaflet and proj4 must be loaded first';
        factory(window.L, window.proj4);
    }
})(function(L, proj4) {
    if (proj4.__esModule && proj4.default) // If proj4 was bundled as an ES6 module, unwrap it to get
    // to the actual main proj4 object.
    // See discussion in https://github.com/kartena/Proj4Leaflet/pull/147
    proj4 = proj4.default;
    L.Proj = {};
    L.Proj._isProj4Obj = function(a) {
        return typeof a.inverse !== 'undefined' && typeof a.forward !== 'undefined';
    };
    L.Proj.Projection = L.Class.extend({
        initialize: function(code, def, bounds) {
            var isP4 = L.Proj._isProj4Obj(code);
            this._proj = isP4 ? code : this._projFromCodeDef(code, def);
            this.bounds = isP4 ? def : bounds;
        },
        project: function(latlng) {
            var point = this._proj.forward([
                latlng.lng,
                latlng.lat
            ]);
            return new L.Point(point[0], point[1]);
        },
        unproject: function(point, unbounded) {
            var point2 = this._proj.inverse([
                point.x,
                point.y
            ]);
            return new L.LatLng(point2[1], point2[0], unbounded);
        },
        _projFromCodeDef: function(code, def) {
            if (def) proj4.defs(code, def);
            else if (proj4.defs[code] === undefined) {
                var urn = code.split(':');
                if (urn.length > 3) code = urn[urn.length - 3] + ':' + urn[urn.length - 1];
                if (proj4.defs[code] === undefined) throw 'No projection definition for code ' + code;
            }
            return proj4(code);
        }
    });
    L.Proj.CRS = L.Class.extend({
        includes: L.CRS,
        options: {
            transformation: new L.Transformation(1, 0, -1, 0)
        },
        initialize: function(a, b, c) {
            var code, proj, def, options;
            if (L.Proj._isProj4Obj(a)) {
                proj = a;
                code = proj.srsCode;
                options = b || {};
                this.projection = new L.Proj.Projection(proj, options.bounds);
            } else {
                code = a;
                def = b;
                options = c || {};
                this.projection = new L.Proj.Projection(code, def, options.bounds);
            }
            L.Util.setOptions(this, options);
            this.code = code;
            this.transformation = this.options.transformation;
            if (this.options.origin) this.transformation = new L.Transformation(1, -this.options.origin[0], -1, this.options.origin[1]);
            if (this.options.scales) this._scales = this.options.scales;
            else if (this.options.resolutions) {
                this._scales = [];
                for(var i = this.options.resolutions.length - 1; i >= 0; i--)if (this.options.resolutions[i]) this._scales[i] = 1 / this.options.resolutions[i];
            }
            this.infinite = !this.options.bounds;
        },
        scale: function(zoom) {
            var iZoom = Math.floor(zoom), baseScale, nextScale, scaleDiff, zDiff;
            if (zoom === iZoom) return this._scales[zoom];
            else {
                // Non-integer zoom, interpolate
                baseScale = this._scales[iZoom];
                nextScale = this._scales[iZoom + 1];
                scaleDiff = nextScale - baseScale;
                zDiff = zoom - iZoom;
                return baseScale + scaleDiff * zDiff;
            }
        },
        zoom: function(scale) {
            // Find closest number in this._scales, down
            var downScale = this._closestElement(this._scales, scale), downZoom = this._scales.indexOf(downScale), nextScale, nextZoom, scaleDiff;
            // Check if scale is downScale => return array index
            if (scale === downScale) return downZoom;
            if (downScale === undefined) return -Infinity;
            // Interpolate
            nextZoom = downZoom + 1;
            nextScale = this._scales[nextZoom];
            if (nextScale === undefined) return Infinity;
            scaleDiff = nextScale - downScale;
            return (scale - downScale) / scaleDiff + downZoom;
        },
        distance: L.CRS.Earth.distance,
        R: L.CRS.Earth.R,
        /* Get the closest lowest element in an array */ _closestElement: function(array, element) {
            var low;
            for(var i = array.length; i--;)if (array[i] <= element && (low === undefined || low < array[i])) low = array[i];
            return low;
        }
    });
    L.Proj.GeoJSON = L.GeoJSON.extend({
        initialize: function(geojson, options) {
            this._callLevel = 0;
            L.GeoJSON.prototype.initialize.call(this, geojson, options);
        },
        addData: function(geojson) {
            var crs;
            if (geojson) {
                if (geojson.crs && geojson.crs.type === 'name') crs = new L.Proj.CRS(geojson.crs.properties.name);
                else if (geojson.crs && geojson.crs.type) crs = new L.Proj.CRS(geojson.crs.type + ':' + geojson.crs.properties.code);
                if (crs !== undefined) this.options.coordsToLatLng = function(coords) {
                    var point = L.point(coords[0], coords[1]);
                    return crs.projection.unproject(point);
                };
            }
            // Base class' addData might call us recursively, but
            // CRS shouldn't be cleared in that case, since CRS applies
            // to the whole GeoJSON, inluding sub-features.
            this._callLevel++;
            try {
                L.GeoJSON.prototype.addData.call(this, geojson);
            } finally{
                this._callLevel--;
                if (this._callLevel === 0) delete this.options.coordsToLatLng;
            }
        }
    });
    L.Proj.geoJson = function(geojson, options) {
        return new L.Proj.GeoJSON(geojson, options);
    };
    L.Proj.ImageOverlay = L.ImageOverlay.extend({
        initialize: function(url, bounds, options) {
            L.ImageOverlay.prototype.initialize.call(this, url, null, options);
            this._projectedBounds = bounds;
        },
        // Danger ahead: Overriding internal methods in Leaflet.
        // Decided to do this rather than making a copy of L.ImageOverlay
        // and doing very tiny modifications to it.
        // Future will tell if this was wise or not.
        _animateZoom: function(event) {
            var scale = this._map.getZoomScale(event.zoom);
            var northWest = L.point(this._projectedBounds.min.x, this._projectedBounds.max.y);
            var offset = this._projectedToNewLayerPoint(northWest, event.zoom, event.center);
            L.DomUtil.setTransform(this._image, offset, scale);
        },
        _reset: function() {
            var zoom = this._map.getZoom();
            var pixelOrigin = this._map.getPixelOrigin();
            var bounds = L.bounds(this._transform(this._projectedBounds.min, zoom)._subtract(pixelOrigin), this._transform(this._projectedBounds.max, zoom)._subtract(pixelOrigin));
            var size = bounds.getSize();
            L.DomUtil.setPosition(this._image, bounds.min);
            this._image.style.width = size.x + 'px';
            this._image.style.height = size.y + 'px';
        },
        _projectedToNewLayerPoint: function(point, zoom, center) {
            var viewHalf = this._map.getSize()._divideBy(2);
            var newTopLeft = this._map.project(center, zoom)._subtract(viewHalf)._round();
            var topLeft = newTopLeft.add(this._map._getMapPanePos());
            return this._transform(point, zoom)._subtract(topLeft);
        },
        _transform: function(point, zoom) {
            var crs = this._map.options.crs;
            var transformation = crs.transformation;
            var scale = crs.scale(zoom);
            return transformation.transform(point, scale);
        }
    });
    L.Proj.imageOverlay = function(url, bounds, options) {
        return new L.Proj.ImageOverlay(url, bounds, options);
    };
    return L.Proj;
});


// Function to colour polygons
const $24badfeb4d36b999$export$13746b04065d45d9 = function(val, scale, colPalette) {
    // Define the color for "Insufficient Data"
    const noDataColor = "#808080";
    // Check if val is null or undefined
    if (val === null || val === undefined) return noDataColor;
    // Return colour based on value
    return val >= scale[0] ? colPalette[0] : val >= scale[1] ? colPalette[1] : val >= scale[2] ? colPalette[2] : val >= scale[3] ? colPalette[3] : val >= scale[4] ? colPalette[4] : val >= scale[5] ? colPalette[5] : val >= scale[6] ? colPalette[6] : val >= scale[7] ? colPalette[7] : val >= scale[8] ? colPalette[8] : val >= scale[9] ? colPalette[9] : colPalette[10]; // negative values
};
const $24badfeb4d36b999$export$ebcd05299db66cf5 = function(properties, gas, source, chartId) {
    const html = `
    <div>
      <p class="text-start fw-bold" style="margin: 0;">${properties.Country}</p>
      <p class="text-start" style="margin-top: 5px; margin-bottom: 7.5px;">
        <span style="color: grey;">Source:</span>&nbsp;${source}<br>
        <span style="color: grey;">Gas:</span>&nbsp;${gas}<br>
      </p>
    </div>
    <div id="${chartId}" style="width: 100%; height: 150px;"></div>
  `;
    return html;
};
const $24badfeb4d36b999$export$ef5a49dd25f32dd3 = function(value) {
    // console.log(value)
    // 1 decimal place for values >= 10
    if (value >= 10) return value.toFixed(1);
    // 1 decimal place for values between 1 and 10
    if (value >= 1 && value < 10) return value.toFixed(1);
    // 2 decimal places for values between 0.001 and 1
    if (value > 0.001 && value < 1) return value.toFixed(2);
    // 1 significant figure between zero and 0.001
    if (value <= 0.001 && value >= 0) return value.toPrecision(1);
    // 2 significant figure if negative
    if (value < 0) return value.toPrecision(2);
};


// Import JS libraries
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $73ff38dc46896811$var$extendStatics = function(d, b) {
    $73ff38dc46896811$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $73ff38dc46896811$var$extendStatics(d, b);
};
function $73ff38dc46896811$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $73ff38dc46896811$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $73ff38dc46896811$export$18ce0697a983be9b = function() {
    $73ff38dc46896811$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $73ff38dc46896811$export$18ce0697a983be9b.apply(this, arguments);
};
function $73ff38dc46896811$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $73ff38dc46896811$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $73ff38dc46896811$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $73ff38dc46896811$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $73ff38dc46896811$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $73ff38dc46896811$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $73ff38dc46896811$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $73ff38dc46896811$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $73ff38dc46896811$export$45d3717a4c69092e(o, m, p);
}
function $73ff38dc46896811$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $73ff38dc46896811$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $73ff38dc46896811$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($73ff38dc46896811$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $73ff38dc46896811$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $73ff38dc46896811$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || from);
}
function $73ff38dc46896811$export$10c90e4f7922046c(v) {
    return this instanceof $73ff38dc46896811$export$10c90e4f7922046c ? (this.v = v, this) : new $73ff38dc46896811$export$10c90e4f7922046c(v);
}
function $73ff38dc46896811$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $73ff38dc46896811$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $73ff38dc46896811$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $73ff38dc46896811$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $73ff38dc46896811$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $73ff38dc46896811$export$19a8beecd37a4c45 === "function" ? $73ff38dc46896811$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $73ff38dc46896811$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $73ff38dc46896811$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $73ff38dc46896811$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $73ff38dc46896811$export$45d3717a4c69092e(result, mod, k);
    }
    $73ff38dc46896811$var$__setModuleDefault(result, mod);
    return result;
}
function $73ff38dc46896811$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $73ff38dc46896811$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $73ff38dc46896811$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}


/*!
* ZRender, a high performance 2d drawing library.
*
* Copyright (c) 2013, Baidu Inc.
* All rights reserved.
*
* LICENSE
* https://github.com/ecomfe/zrender/blob/master/LICENSE.txt
*/ var $ce6dd58693a21851$var$Browser = function() {
    function Browser() {
        this.firefox = false;
        this.ie = false;
        this.edge = false;
        this.newEdge = false;
        this.weChat = false;
    }
    return Browser;
}();
var $ce6dd58693a21851$var$Env = function() {
    function Env() {
        this.browser = new $ce6dd58693a21851$var$Browser();
        this.node = false;
        this.wxa = false;
        this.worker = false;
        this.svgSupported = false;
        this.touchEventsSupported = false;
        this.pointerEventsSupported = false;
        this.domSupported = false;
        this.transformSupported = false;
        this.transform3dSupported = false;
        this.hasGlobalWindow = typeof window !== 'undefined';
    }
    return Env;
}();
var $ce6dd58693a21851$var$env = new $ce6dd58693a21851$var$Env();
if (typeof wx === 'object' && typeof wx.getSystemInfoSync === 'function') {
    $ce6dd58693a21851$var$env.wxa = true;
    $ce6dd58693a21851$var$env.touchEventsSupported = true;
} else if (typeof document === 'undefined' && typeof self !== 'undefined') $ce6dd58693a21851$var$env.worker = true;
else if (!$ce6dd58693a21851$var$env.hasGlobalWindow || 'Deno' in window) {
    $ce6dd58693a21851$var$env.node = true;
    $ce6dd58693a21851$var$env.svgSupported = true;
} else $ce6dd58693a21851$var$detect(navigator.userAgent, $ce6dd58693a21851$var$env);
function $ce6dd58693a21851$var$detect(ua, env) {
    var browser = env.browser;
    var firefox = ua.match(/Firefox\/([\d.]+)/);
    var ie = ua.match(/MSIE\s([\d.]+)/) || ua.match(/Trident\/.+?rv:(([\d.]+))/);
    var edge = ua.match(/Edge?\/([\d.]+)/);
    var weChat = /micromessenger/i.test(ua);
    if (firefox) {
        browser.firefox = true;
        browser.version = firefox[1];
    }
    if (ie) {
        browser.ie = true;
        browser.version = ie[1];
    }
    if (edge) {
        browser.edge = true;
        browser.version = edge[1];
        browser.newEdge = +edge[1].split('.')[0] > 18;
    }
    if (weChat) browser.weChat = true;
    env.svgSupported = typeof SVGRect !== 'undefined';
    env.touchEventsSupported = 'ontouchstart' in window && !browser.ie && !browser.edge;
    env.pointerEventsSupported = 'onpointerdown' in window && (browser.edge || browser.ie && +browser.version >= 11);
    env.domSupported = typeof document !== 'undefined';
    var style = document.documentElement.style;
    env.transform3dSupported = (browser.ie && 'transition' in style || browser.edge || 'WebKitCSSMatrix' in window && 'm11' in new WebKitCSSMatrix() || 'MozPerspective' in style) && !('OTransition' in style);
    env.transformSupported = env.transform3dSupported || browser.ie && +browser.version >= 9;
}
var $ce6dd58693a21851$export$2e2bcd8739ae039 = $ce6dd58693a21851$var$env;


var $c6341dcc9d86826e$export$b1461457ea2c1179 = 12;
var $c6341dcc9d86826e$export$2653e0d5dd45b294 = 'sans-serif';
var $c6341dcc9d86826e$export$7d7a232b6d2cc80c = $c6341dcc9d86826e$export$b1461457ea2c1179 + "px " + $c6341dcc9d86826e$export$2653e0d5dd45b294;
var $c6341dcc9d86826e$var$OFFSET = 20;
var $c6341dcc9d86826e$var$SCALE = 100;
var $c6341dcc9d86826e$var$defaultWidthMapStr = "007LLmW'55;N0500LLLLLLLLLL00NNNLzWW\\\\WQb\\0FWLg\\bWb\\WQ\\WrWWQ000CL5LLFLL0LL**F*gLLLL5F0LF\\FFF5.5N";
function $c6341dcc9d86826e$var$getTextWidthMap(mapStr) {
    var map = {};
    if (typeof JSON === 'undefined') return map;
    for(var i = 0; i < mapStr.length; i++){
        var char = String.fromCharCode(i + 32);
        var size = (mapStr.charCodeAt(i) - $c6341dcc9d86826e$var$OFFSET) / $c6341dcc9d86826e$var$SCALE;
        map[char] = size;
    }
    return map;
}
var $c6341dcc9d86826e$export$69462fcc6bf851a4 = $c6341dcc9d86826e$var$getTextWidthMap($c6341dcc9d86826e$var$defaultWidthMapStr);
var $c6341dcc9d86826e$export$ef5e599365494451 = {
    createCanvas: function() {
        return typeof document !== 'undefined' && document.createElement('canvas');
    },
    measureText: function() {
        var _ctx;
        var _cachedFont;
        return function(text, font) {
            if (!_ctx) {
                var canvas = $c6341dcc9d86826e$export$ef5e599365494451.createCanvas();
                _ctx = canvas && canvas.getContext('2d');
            }
            if (_ctx) {
                if (_cachedFont !== font) _cachedFont = _ctx.font = font || $c6341dcc9d86826e$export$7d7a232b6d2cc80c;
                return _ctx.measureText(text);
            } else {
                text = text || '';
                font = font || $c6341dcc9d86826e$export$7d7a232b6d2cc80c;
                var res = /((?:\d+)?\.?\d*)px/.exec(font);
                var fontSize = res && +res[1] || $c6341dcc9d86826e$export$b1461457ea2c1179;
                var width = 0;
                if (font.indexOf('mono') >= 0) width = fontSize * text.length;
                else for(var i = 0; i < text.length; i++){
                    var preCalcWidth = $c6341dcc9d86826e$export$69462fcc6bf851a4[text[i]];
                    width += preCalcWidth == null ? fontSize : preCalcWidth * fontSize;
                }
                return {
                    width: width
                };
            }
        };
    }(),
    loadImage: function(src, onload, onerror) {
        var image = new Image();
        image.onload = onload;
        image.onerror = onerror;
        image.src = src;
        return image;
    }
};
function $c6341dcc9d86826e$export$61bcfd79465c1b7c(newPlatformApis) {
    for(var key in $c6341dcc9d86826e$export$ef5e599365494451)if (newPlatformApis[key]) $c6341dcc9d86826e$export$ef5e599365494451[key] = newPlatformApis[key];
}


var $7a1bd9c2710fea0d$var$BUILTIN_OBJECT = $7a1bd9c2710fea0d$export$533b26079ad0b4b([
    'Function',
    'RegExp',
    'Date',
    'Error',
    'CanvasGradient',
    'CanvasPattern',
    'Image',
    'Canvas'
], function(obj, val) {
    obj['[object ' + val + ']'] = true;
    return obj;
}, {});
var $7a1bd9c2710fea0d$var$TYPED_ARRAY = $7a1bd9c2710fea0d$export$533b26079ad0b4b([
    'Int8',
    'Uint8',
    'Uint8Clamped',
    'Int16',
    'Uint16',
    'Int32',
    'Uint32',
    'Float32',
    'Float64'
], function(obj, val) {
    obj['[object ' + val + 'Array]'] = true;
    return obj;
}, {});
var $7a1bd9c2710fea0d$var$objToString = Object.prototype.toString;
var $7a1bd9c2710fea0d$var$arrayProto = Array.prototype;
var $7a1bd9c2710fea0d$var$nativeForEach = $7a1bd9c2710fea0d$var$arrayProto.forEach;
var $7a1bd9c2710fea0d$var$nativeFilter = $7a1bd9c2710fea0d$var$arrayProto.filter;
var $7a1bd9c2710fea0d$var$nativeSlice = $7a1bd9c2710fea0d$var$arrayProto.slice;
var $7a1bd9c2710fea0d$var$nativeMap = $7a1bd9c2710fea0d$var$arrayProto.map;
var $7a1bd9c2710fea0d$var$ctorFunction = (function() {}).constructor;
var $7a1bd9c2710fea0d$var$protoFunction = $7a1bd9c2710fea0d$var$ctorFunction ? $7a1bd9c2710fea0d$var$ctorFunction.prototype : null;
var $7a1bd9c2710fea0d$var$protoKey = '__proto__';
var $7a1bd9c2710fea0d$var$idStart = 0x0907;
function $7a1bd9c2710fea0d$export$46e8f25c7328f77e() {
    return $7a1bd9c2710fea0d$var$idStart++;
}
function $7a1bd9c2710fea0d$export$58da9968c3170cb1() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (typeof console !== 'undefined') console.error.apply(console, args);
}
function $7a1bd9c2710fea0d$export$9cd59f9826255e47(source) {
    if (source == null || typeof source !== 'object') return source;
    var result = source;
    var typeStr = $7a1bd9c2710fea0d$var$objToString.call(source);
    if (typeStr === '[object Array]') {
        if (!$7a1bd9c2710fea0d$export$c3825b437cbdea5c(source)) {
            result = [];
            for(var i = 0, len = source.length; i < len; i++)result[i] = $7a1bd9c2710fea0d$export$9cd59f9826255e47(source[i]);
        }
    } else if ($7a1bd9c2710fea0d$var$TYPED_ARRAY[typeStr]) {
        if (!$7a1bd9c2710fea0d$export$c3825b437cbdea5c(source)) {
            var Ctor = source.constructor;
            if (Ctor.from) result = Ctor.from(source);
            else {
                result = new Ctor(source.length);
                for(var i = 0, len = source.length; i < len; i++)result[i] = source[i];
            }
        }
    } else if (!$7a1bd9c2710fea0d$var$BUILTIN_OBJECT[typeStr] && !$7a1bd9c2710fea0d$export$c3825b437cbdea5c(source) && !$7a1bd9c2710fea0d$export$9f57505b7bd8dae(source)) {
        result = {};
        for(var key in source)if (source.hasOwnProperty(key) && key !== $7a1bd9c2710fea0d$var$protoKey) result[key] = $7a1bd9c2710fea0d$export$9cd59f9826255e47(source[key]);
    }
    return result;
}
function $7a1bd9c2710fea0d$export$4950aa0f605343fb(target, source, overwrite) {
    if (!$7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(source) || !$7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(target)) return overwrite ? $7a1bd9c2710fea0d$export$9cd59f9826255e47(source) : target;
    for(var key in source)if (source.hasOwnProperty(key) && key !== $7a1bd9c2710fea0d$var$protoKey) {
        var targetProp = target[key];
        var sourceProp = source[key];
        if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(sourceProp) && $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(targetProp) && !$7a1bd9c2710fea0d$export$43bee75e5e14138e(sourceProp) && !$7a1bd9c2710fea0d$export$43bee75e5e14138e(targetProp) && !$7a1bd9c2710fea0d$export$9f57505b7bd8dae(sourceProp) && !$7a1bd9c2710fea0d$export$9f57505b7bd8dae(targetProp) && !$7a1bd9c2710fea0d$export$fa523b2c4941fd4f(sourceProp) && !$7a1bd9c2710fea0d$export$fa523b2c4941fd4f(targetProp) && !$7a1bd9c2710fea0d$export$c3825b437cbdea5c(sourceProp) && !$7a1bd9c2710fea0d$export$c3825b437cbdea5c(targetProp)) $7a1bd9c2710fea0d$export$4950aa0f605343fb(targetProp, sourceProp, overwrite);
        else if (overwrite || !(key in target)) target[key] = $7a1bd9c2710fea0d$export$9cd59f9826255e47(source[key]);
    }
    return target;
}
function $7a1bd9c2710fea0d$export$18aef43295bbe906(targetAndSources, overwrite) {
    var result = targetAndSources[0];
    for(var i = 1, len = targetAndSources.length; i < len; i++)result = $7a1bd9c2710fea0d$export$4950aa0f605343fb(result, targetAndSources[i], overwrite);
    return result;
}
function $7a1bd9c2710fea0d$export$8b58be045bf06082(target, source) {
    if (Object.assign) Object.assign(target, source);
    else {
        for(var key in source)if (source.hasOwnProperty(key) && key !== $7a1bd9c2710fea0d$var$protoKey) target[key] = source[key];
    }
    return target;
}
function $7a1bd9c2710fea0d$export$ebe90cb607ad99e(target, source, overlay) {
    var keysArr = $7a1bd9c2710fea0d$export$ed97f33186d4b816(source);
    for(var i = 0, len = keysArr.length; i < len; i++){
        var key = keysArr[i];
        if (overlay ? source[key] != null : target[key] == null) target[key] = source[key];
    }
    return target;
}
var $7a1bd9c2710fea0d$export$cd3d1f114b139967 = (0, $c6341dcc9d86826e$export$ef5e599365494451).createCanvas;
function $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(array, value) {
    if (array) {
        if (array.indexOf) return array.indexOf(value);
        for(var i = 0, len = array.length; i < len; i++){
            if (array[i] === value) return i;
        }
    }
    return -1;
}
function $7a1bd9c2710fea0d$export$69f1b2dcda23c5f8(clazz, baseClazz) {
    var clazzPrototype = clazz.prototype;
    function F() {}
    F.prototype = baseClazz.prototype;
    clazz.prototype = new F();
    for(var prop in clazzPrototype)if (clazzPrototype.hasOwnProperty(prop)) clazz.prototype[prop] = clazzPrototype[prop];
    clazz.prototype.constructor = clazz;
    clazz.superClass = baseClazz;
}
function $7a1bd9c2710fea0d$export$e36fc9d62a853069(target, source, override) {
    target = 'prototype' in target ? target.prototype : target;
    source = 'prototype' in source ? source.prototype : source;
    if (Object.getOwnPropertyNames) {
        var keyList = Object.getOwnPropertyNames(source);
        for(var i = 0; i < keyList.length; i++){
            var key = keyList[i];
            if (key !== 'constructor') {
                if (override ? source[key] != null : target[key] == null) target[key] = source[key];
            }
        }
    } else $7a1bd9c2710fea0d$export$ebe90cb607ad99e(target, source, override);
}
function $7a1bd9c2710fea0d$export$1e2f57719e155213(data) {
    if (!data) return false;
    if (typeof data === 'string') return false;
    return typeof data.length === 'number';
}
function $7a1bd9c2710fea0d$export$79b2f7037acddd43(arr, cb, context) {
    if (!(arr && cb)) return;
    if (arr.forEach && arr.forEach === $7a1bd9c2710fea0d$var$nativeForEach) arr.forEach(cb, context);
    else if (arr.length === +arr.length) for(var i = 0, len = arr.length; i < len; i++)cb.call(context, arr[i], i, arr);
    else {
        for(var key in arr)if (arr.hasOwnProperty(key)) cb.call(context, arr[key], key, arr);
    }
}
function $7a1bd9c2710fea0d$export$871de8747c9eaa88(arr, cb, context) {
    if (!arr) return [];
    if (!cb) return $7a1bd9c2710fea0d$export$58adb3bec8346d0f(arr);
    if (arr.map && arr.map === $7a1bd9c2710fea0d$var$nativeMap) return arr.map(cb, context);
    else {
        var result = [];
        for(var i = 0, len = arr.length; i < len; i++)result.push(cb.call(context, arr[i], i, arr));
        return result;
    }
}
function $7a1bd9c2710fea0d$export$533b26079ad0b4b(arr, cb, memo, context) {
    if (!(arr && cb)) return;
    for(var i = 0, len = arr.length; i < len; i++)memo = cb.call(context, memo, arr[i], i, arr);
    return memo;
}
function $7a1bd9c2710fea0d$export$3dea766d36a8935f(arr, cb, context) {
    if (!arr) return [];
    if (!cb) return $7a1bd9c2710fea0d$export$58adb3bec8346d0f(arr);
    if (arr.filter && arr.filter === $7a1bd9c2710fea0d$var$nativeFilter) return arr.filter(cb, context);
    else {
        var result = [];
        for(var i = 0, len = arr.length; i < len; i++)if (cb.call(context, arr[i], i, arr)) result.push(arr[i]);
        return result;
    }
}
function $7a1bd9c2710fea0d$export$71aa6c912b956294(arr, cb, context) {
    if (!(arr && cb)) return;
    for(var i = 0, len = arr.length; i < len; i++){
        if (cb.call(context, arr[i], i, arr)) return arr[i];
    }
}
function $7a1bd9c2710fea0d$export$ed97f33186d4b816(obj) {
    if (!obj) return [];
    if (Object.keys) return Object.keys(obj);
    var keyList = [];
    for(var key in obj)if (obj.hasOwnProperty(key)) keyList.push(key);
    return keyList;
}
function $7a1bd9c2710fea0d$var$bindPolyfill(func, context) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    return function() {
        return func.apply(context, args.concat($7a1bd9c2710fea0d$var$nativeSlice.call(arguments)));
    };
}
var $7a1bd9c2710fea0d$export$2385a24977818dd0 = $7a1bd9c2710fea0d$var$protoFunction && $7a1bd9c2710fea0d$export$f6e2535fb5126e54($7a1bd9c2710fea0d$var$protoFunction.bind) ? $7a1bd9c2710fea0d$var$protoFunction.call.bind($7a1bd9c2710fea0d$var$protoFunction.bind) : $7a1bd9c2710fea0d$var$bindPolyfill;
function $7a1bd9c2710fea0d$export$c3095a23b368d1f2(func) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    return function() {
        return func.apply(this, args.concat($7a1bd9c2710fea0d$var$nativeSlice.call(arguments)));
    };
}
function $7a1bd9c2710fea0d$export$43bee75e5e14138e(value) {
    if (Array.isArray) return Array.isArray(value);
    return $7a1bd9c2710fea0d$var$objToString.call(value) === '[object Array]';
}
function $7a1bd9c2710fea0d$export$f6e2535fb5126e54(value) {
    return typeof value === 'function';
}
function $7a1bd9c2710fea0d$export$844ec244b1367d54(value) {
    return typeof value === 'string';
}
function $7a1bd9c2710fea0d$export$29d0bb2a4e07b252(value) {
    return $7a1bd9c2710fea0d$var$objToString.call(value) === '[object String]';
}
function $7a1bd9c2710fea0d$export$7e4aa119212bc614(value) {
    return typeof value === 'number';
}
function $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(value) {
    var type = typeof value;
    return type === 'function' || !!value && type === 'object';
}
function $7a1bd9c2710fea0d$export$fa523b2c4941fd4f(value) {
    return !!$7a1bd9c2710fea0d$var$BUILTIN_OBJECT[$7a1bd9c2710fea0d$var$objToString.call(value)];
}
function $7a1bd9c2710fea0d$export$b119cc7e1840e59c(value) {
    return !!$7a1bd9c2710fea0d$var$TYPED_ARRAY[$7a1bd9c2710fea0d$var$objToString.call(value)];
}
function $7a1bd9c2710fea0d$export$9f57505b7bd8dae(value) {
    return typeof value === 'object' && typeof value.nodeType === 'number' && typeof value.ownerDocument === 'object';
}
function $7a1bd9c2710fea0d$export$fa2c283003ed971c(value) {
    return value.colorStops != null;
}
function $7a1bd9c2710fea0d$export$a49bbf3a55dcef7b(value) {
    return value.image != null;
}
function $7a1bd9c2710fea0d$export$49841c62b9eff15(value) {
    return $7a1bd9c2710fea0d$var$objToString.call(value) === '[object RegExp]';
}
function $7a1bd9c2710fea0d$export$7d667b9a0c48c975(value) {
    return value !== value;
}
function $7a1bd9c2710fea0d$export$8a4d17b6e8486e66() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    for(var i = 0, len = args.length; i < len; i++){
        if (args[i] != null) return args[i];
    }
}
function $7a1bd9c2710fea0d$export$995e01f2f5c9d030(value0, value1) {
    return value0 != null ? value0 : value1;
}
function $7a1bd9c2710fea0d$export$2e94551289abb95b(value0, value1, value2) {
    return value0 != null ? value0 : value1 != null ? value1 : value2;
}
function $7a1bd9c2710fea0d$export$58adb3bec8346d0f(arr) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    return $7a1bd9c2710fea0d$var$nativeSlice.apply(arr, args);
}
function $7a1bd9c2710fea0d$export$f3a38102c49f4268(val) {
    if (typeof val === 'number') return [
        val,
        val,
        val,
        val
    ];
    var len = val.length;
    if (len === 2) return [
        val[0],
        val[1],
        val[0],
        val[1]
    ];
    else if (len === 3) return [
        val[0],
        val[1],
        val[2],
        val[1]
    ];
    return val;
}
function $7a1bd9c2710fea0d$export$a7a9523472993e97(condition, message) {
    if (!condition) throw new Error(message);
}
function $7a1bd9c2710fea0d$export$87c2784dc9fc4ab(str) {
    if (str == null) return null;
    else if (typeof str.trim === 'function') return str.trim();
    else return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
}
var $7a1bd9c2710fea0d$var$primitiveKey = '__ec_primitive__';
function $7a1bd9c2710fea0d$export$112e66431016387b(obj) {
    obj[$7a1bd9c2710fea0d$var$primitiveKey] = true;
}
function $7a1bd9c2710fea0d$export$c3825b437cbdea5c(obj) {
    return obj[$7a1bd9c2710fea0d$var$primitiveKey];
}
var $7a1bd9c2710fea0d$var$MapPolyfill = function() {
    function MapPolyfill() {
        this.data = {};
    }
    MapPolyfill.prototype["delete"] = function(key) {
        var existed = this.has(key);
        if (existed) delete this.data[key];
        return existed;
    };
    MapPolyfill.prototype.has = function(key) {
        return this.data.hasOwnProperty(key);
    };
    MapPolyfill.prototype.get = function(key) {
        return this.data[key];
    };
    MapPolyfill.prototype.set = function(key, value) {
        this.data[key] = value;
        return this;
    };
    MapPolyfill.prototype.keys = function() {
        return $7a1bd9c2710fea0d$export$ed97f33186d4b816(this.data);
    };
    MapPolyfill.prototype.forEach = function(callback) {
        var data = this.data;
        for(var key in data)if (data.hasOwnProperty(key)) callback(data[key], key);
    };
    return MapPolyfill;
}();
var $7a1bd9c2710fea0d$var$isNativeMapSupported = typeof Map === 'function';
function $7a1bd9c2710fea0d$var$maybeNativeMap() {
    return $7a1bd9c2710fea0d$var$isNativeMapSupported ? new Map() : new $7a1bd9c2710fea0d$var$MapPolyfill();
}
var $7a1bd9c2710fea0d$export$60ef0b43d585640a = function() {
    function HashMap(obj) {
        var isArr = $7a1bd9c2710fea0d$export$43bee75e5e14138e(obj);
        this.data = $7a1bd9c2710fea0d$var$maybeNativeMap();
        var thisMap = this;
        obj instanceof HashMap ? obj.each(visit) : obj && $7a1bd9c2710fea0d$export$79b2f7037acddd43(obj, visit);
        function visit(value, key) {
            isArr ? thisMap.set(value, key) : thisMap.set(key, value);
        }
    }
    HashMap.prototype.hasKey = function(key) {
        return this.data.has(key);
    };
    HashMap.prototype.get = function(key) {
        return this.data.get(key);
    };
    HashMap.prototype.set = function(key, value) {
        this.data.set(key, value);
        return value;
    };
    HashMap.prototype.each = function(cb, context) {
        this.data.forEach(function(value, key) {
            cb.call(context, value, key);
        });
    };
    HashMap.prototype.keys = function() {
        var keys = this.data.keys();
        return $7a1bd9c2710fea0d$var$isNativeMapSupported ? Array.from(keys) : keys;
    };
    HashMap.prototype.removeKey = function(key) {
        this.data["delete"](key);
    };
    return HashMap;
}();
function $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4(obj) {
    return new $7a1bd9c2710fea0d$export$60ef0b43d585640a(obj);
}
function $7a1bd9c2710fea0d$export$4fd8af2c48c43416(a, b) {
    var newArray = new a.constructor(a.length + b.length);
    for(var i = 0; i < a.length; i++)newArray[i] = a[i];
    var offset = a.length;
    for(var i = 0; i < b.length; i++)newArray[i + offset] = b[i];
    return newArray;
}
function $7a1bd9c2710fea0d$export$79c7e160a7743efd(proto, properties) {
    var obj;
    if (Object.create) obj = Object.create(proto);
    else {
        var StyleCtor = function() {};
        StyleCtor.prototype = proto;
        obj = new StyleCtor();
    }
    if (properties) $7a1bd9c2710fea0d$export$8b58be045bf06082(obj, properties);
    return obj;
}
function $7a1bd9c2710fea0d$export$23a5d775868fdd2c(dom) {
    var domStyle = dom.style;
    domStyle.webkitUserSelect = 'none';
    domStyle.userSelect = 'none';
    domStyle.webkitTapHighlightColor = 'rgba(0,0,0,0)';
    domStyle['-webkit-touch-callout'] = 'none';
}
function $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3(own, prop) {
    return own.hasOwnProperty(prop);
}
function $7a1bd9c2710fea0d$export$8793edee2d425525() {}
var $7a1bd9c2710fea0d$export$bce8e055322a0ce6 = 180 / Math.PI;


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $995fbf2af591395d$var$extendStatics = function(d, b) {
    $995fbf2af591395d$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $995fbf2af591395d$var$extendStatics(d, b);
};
function $995fbf2af591395d$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $995fbf2af591395d$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $995fbf2af591395d$export$18ce0697a983be9b = function() {
    $995fbf2af591395d$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $995fbf2af591395d$export$18ce0697a983be9b.apply(this, arguments);
};
function $995fbf2af591395d$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $995fbf2af591395d$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $995fbf2af591395d$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $995fbf2af591395d$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $995fbf2af591395d$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $995fbf2af591395d$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $995fbf2af591395d$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $995fbf2af591395d$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $995fbf2af591395d$export$45d3717a4c69092e(o, m, p);
}
function $995fbf2af591395d$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $995fbf2af591395d$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $995fbf2af591395d$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($995fbf2af591395d$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $995fbf2af591395d$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $995fbf2af591395d$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || from);
}
function $995fbf2af591395d$export$10c90e4f7922046c(v) {
    return this instanceof $995fbf2af591395d$export$10c90e4f7922046c ? (this.v = v, this) : new $995fbf2af591395d$export$10c90e4f7922046c(v);
}
function $995fbf2af591395d$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $995fbf2af591395d$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $995fbf2af591395d$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $995fbf2af591395d$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $995fbf2af591395d$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $995fbf2af591395d$export$19a8beecd37a4c45 === "function" ? $995fbf2af591395d$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $995fbf2af591395d$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $995fbf2af591395d$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $995fbf2af591395d$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $995fbf2af591395d$export$45d3717a4c69092e(result, mod, k);
    }
    $995fbf2af591395d$var$__setModuleDefault(result, mod);
    return result;
}
function $995fbf2af591395d$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $995fbf2af591395d$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $995fbf2af591395d$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}



function $6de594cf8ac295ff$export$185802fd694ee1f5(x, y) {
    if (x == null) x = 0;
    if (y == null) y = 0;
    return [
        x,
        y
    ];
}
function $6de594cf8ac295ff$export$784d13d8ee351f07(out, v) {
    out[0] = v[0];
    out[1] = v[1];
    return out;
}
function $6de594cf8ac295ff$export$9cd59f9826255e47(v) {
    return [
        v[0],
        v[1]
    ];
}
function $6de594cf8ac295ff$export$adaa4cf7ef1b65be(out, a, b) {
    out[0] = a;
    out[1] = b;
    return out;
}
function $6de594cf8ac295ff$export$e16d8520af44a096(out, v1, v2) {
    out[0] = v1[0] + v2[0];
    out[1] = v1[1] + v2[1];
    return out;
}
function $6de594cf8ac295ff$export$19cedf1da84ba854(out, v1, v2, a) {
    out[0] = v1[0] + v2[0] * a;
    out[1] = v1[1] + v2[1] * a;
    return out;
}
function $6de594cf8ac295ff$export$f93b5905241a7cca(out, v1, v2) {
    out[0] = v1[0] - v2[0];
    out[1] = v1[1] - v2[1];
    return out;
}
function $6de594cf8ac295ff$export$fc1400facf92c78(v) {
    return Math.sqrt($6de594cf8ac295ff$export$48e33bc611e4c25a(v));
}
var $6de594cf8ac295ff$export$f24224f1c91d8156 = $6de594cf8ac295ff$export$fc1400facf92c78;
function $6de594cf8ac295ff$export$48e33bc611e4c25a(v) {
    return v[0] * v[0] + v[1] * v[1];
}
var $6de594cf8ac295ff$export$2f106540dd9a5136 = $6de594cf8ac295ff$export$48e33bc611e4c25a;
function $6de594cf8ac295ff$export$6e3a27864ab166fe(out, v1, v2) {
    out[0] = v1[0] * v2[0];
    out[1] = v1[1] * v2[1];
    return out;
}
function $6de594cf8ac295ff$export$159d9494db57879b(out, v1, v2) {
    out[0] = v1[0] / v2[0];
    out[1] = v1[1] / v2[1];
    return out;
}
function $6de594cf8ac295ff$export$94132a0e348806d4(v1, v2) {
    return v1[0] * v2[0] + v1[1] * v2[1];
}
function $6de594cf8ac295ff$export$dcdf75081b88279d(out, v, s) {
    out[0] = v[0] * s;
    out[1] = v[1] * s;
    return out;
}
function $6de594cf8ac295ff$export$a3295358bff77e(out, v) {
    var d = $6de594cf8ac295ff$export$fc1400facf92c78(v);
    if (d === 0) {
        out[0] = 0;
        out[1] = 0;
    } else {
        out[0] = v[0] / d;
        out[1] = v[1] / d;
    }
    return out;
}
function $6de594cf8ac295ff$export$9f17032d917177de(v1, v2) {
    return Math.sqrt((v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]));
}
var $6de594cf8ac295ff$export$6c4a311cc157c764 = $6de594cf8ac295ff$export$9f17032d917177de;
function $6de594cf8ac295ff$export$137c0a69d1ff4a79(v1, v2) {
    return (v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]);
}
var $6de594cf8ac295ff$export$c68db45a034c13b0 = $6de594cf8ac295ff$export$137c0a69d1ff4a79;
function $6de594cf8ac295ff$export$aef51622e549b8b0(out, v) {
    out[0] = -v[0];
    out[1] = -v[1];
    return out;
}
function $6de594cf8ac295ff$export$3a89f8d6f6bf6c9f(out, v1, v2, t) {
    out[0] = v1[0] + t * (v2[0] - v1[0]);
    out[1] = v1[1] + t * (v2[1] - v1[1]);
    return out;
}
function $6de594cf8ac295ff$export$9f9dcb98c894b623(out, v, m) {
    var x = v[0];
    var y = v[1];
    out[0] = m[0] * x + m[2] * y + m[4];
    out[1] = m[1] * x + m[3] * y + m[5];
    return out;
}
function $6de594cf8ac295ff$export$96ec731ed4dcb222(out, v1, v2) {
    out[0] = Math.min(v1[0], v2[0]);
    out[1] = Math.min(v1[1], v2[1]);
    return out;
}
function $6de594cf8ac295ff$export$8960430cfd85939f(out, v1, v2) {
    out[0] = Math.max(v1[0], v2[0]);
    out[1] = Math.max(v1[1], v2[1]);
    return out;
}


var $4e8ea7ab4b22b6b2$var$Param = function() {
    function Param(target, e) {
        this.target = target;
        this.topTarget = e && e.topTarget;
    }
    return Param;
}();
var $4e8ea7ab4b22b6b2$var$Draggable = function() {
    function Draggable(handler) {
        this.handler = handler;
        handler.on('mousedown', this._dragStart, this);
        handler.on('mousemove', this._drag, this);
        handler.on('mouseup', this._dragEnd, this);
    }
    Draggable.prototype._dragStart = function(e) {
        var draggingTarget = e.target;
        while(draggingTarget && !draggingTarget.draggable)draggingTarget = draggingTarget.parent || draggingTarget.__hostTarget;
        if (draggingTarget) {
            this._draggingTarget = draggingTarget;
            draggingTarget.dragging = true;
            this._x = e.offsetX;
            this._y = e.offsetY;
            this.handler.dispatchToElement(new $4e8ea7ab4b22b6b2$var$Param(draggingTarget, e), 'dragstart', e.event);
        }
    };
    Draggable.prototype._drag = function(e) {
        var draggingTarget = this._draggingTarget;
        if (draggingTarget) {
            var x = e.offsetX;
            var y = e.offsetY;
            var dx = x - this._x;
            var dy = y - this._y;
            this._x = x;
            this._y = y;
            draggingTarget.drift(dx, dy, e);
            this.handler.dispatchToElement(new $4e8ea7ab4b22b6b2$var$Param(draggingTarget, e), 'drag', e.event);
            var dropTarget = this.handler.findHover(x, y, draggingTarget).target;
            var lastDropTarget = this._dropTarget;
            this._dropTarget = dropTarget;
            if (draggingTarget !== dropTarget) {
                if (lastDropTarget && dropTarget !== lastDropTarget) this.handler.dispatchToElement(new $4e8ea7ab4b22b6b2$var$Param(lastDropTarget, e), 'dragleave', e.event);
                if (dropTarget && dropTarget !== lastDropTarget) this.handler.dispatchToElement(new $4e8ea7ab4b22b6b2$var$Param(dropTarget, e), 'dragenter', e.event);
            }
        }
    };
    Draggable.prototype._dragEnd = function(e) {
        var draggingTarget = this._draggingTarget;
        if (draggingTarget) draggingTarget.dragging = false;
        this.handler.dispatchToElement(new $4e8ea7ab4b22b6b2$var$Param(draggingTarget, e), 'dragend', e.event);
        if (this._dropTarget) this.handler.dispatchToElement(new $4e8ea7ab4b22b6b2$var$Param(this._dropTarget, e), 'drop', e.event);
        this._draggingTarget = null;
        this._dropTarget = null;
    };
    return Draggable;
}();
var $4e8ea7ab4b22b6b2$export$2e2bcd8739ae039 = $4e8ea7ab4b22b6b2$var$Draggable;


var $63441a86293f101f$var$Eventful = function() {
    function Eventful(eventProcessors) {
        if (eventProcessors) this._$eventProcessor = eventProcessors;
    }
    Eventful.prototype.on = function(event, query, handler, context) {
        if (!this._$handlers) this._$handlers = {};
        var _h = this._$handlers;
        if (typeof query === 'function') {
            context = handler;
            handler = query;
            query = null;
        }
        if (!handler || !event) return this;
        var eventProcessor = this._$eventProcessor;
        if (query != null && eventProcessor && eventProcessor.normalizeQuery) query = eventProcessor.normalizeQuery(query);
        if (!_h[event]) _h[event] = [];
        for(var i = 0; i < _h[event].length; i++){
            if (_h[event][i].h === handler) return this;
        }
        var wrap = {
            h: handler,
            query: query,
            ctx: context || this,
            callAtLast: handler.zrEventfulCallAtLast
        };
        var lastIndex = _h[event].length - 1;
        var lastWrap = _h[event][lastIndex];
        lastWrap && lastWrap.callAtLast ? _h[event].splice(lastIndex, 0, wrap) : _h[event].push(wrap);
        return this;
    };
    Eventful.prototype.isSilent = function(eventName) {
        var _h = this._$handlers;
        return !_h || !_h[eventName] || !_h[eventName].length;
    };
    Eventful.prototype.off = function(eventType, handler) {
        var _h = this._$handlers;
        if (!_h) return this;
        if (!eventType) {
            this._$handlers = {};
            return this;
        }
        if (handler) {
            if (_h[eventType]) {
                var newList = [];
                for(var i = 0, l = _h[eventType].length; i < l; i++)if (_h[eventType][i].h !== handler) newList.push(_h[eventType][i]);
                _h[eventType] = newList;
            }
            if (_h[eventType] && _h[eventType].length === 0) delete _h[eventType];
        } else delete _h[eventType];
        return this;
    };
    Eventful.prototype.trigger = function(eventType) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (!this._$handlers) return this;
        var _h = this._$handlers[eventType];
        var eventProcessor = this._$eventProcessor;
        if (_h) {
            var argLen = args.length;
            var len = _h.length;
            for(var i = 0; i < len; i++){
                var hItem = _h[i];
                if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(eventType, hItem.query)) continue;
                switch(argLen){
                    case 0:
                        hItem.h.call(hItem.ctx);
                        break;
                    case 1:
                        hItem.h.call(hItem.ctx, args[0]);
                        break;
                    case 2:
                        hItem.h.call(hItem.ctx, args[0], args[1]);
                        break;
                    default:
                        hItem.h.apply(hItem.ctx, args);
                        break;
                }
            }
        }
        eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(eventType);
        return this;
    };
    Eventful.prototype.triggerWithContext = function(type) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (!this._$handlers) return this;
        var _h = this._$handlers[type];
        var eventProcessor = this._$eventProcessor;
        if (_h) {
            var argLen = args.length;
            var ctx = args[argLen - 1];
            var len = _h.length;
            for(var i = 0; i < len; i++){
                var hItem = _h[i];
                if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(type, hItem.query)) continue;
                switch(argLen){
                    case 0:
                        hItem.h.call(ctx);
                        break;
                    case 1:
                        hItem.h.call(ctx, args[0]);
                        break;
                    case 2:
                        hItem.h.call(ctx, args[0], args[1]);
                        break;
                    default:
                        hItem.h.apply(ctx, args.slice(1, argLen - 1));
                        break;
                }
            }
        }
        eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(type);
        return this;
    };
    return Eventful;
}();
var $63441a86293f101f$export$2e2bcd8739ae039 = $63441a86293f101f$var$Eventful;





var $a9b673cb651a68dc$var$LN2 = Math.log(2);
function $a9b673cb651a68dc$var$determinant(rows, rank, rowStart, rowMask, colMask, detCache) {
    var cacheKey = rowMask + '-' + colMask;
    var fullRank = rows.length;
    if (detCache.hasOwnProperty(cacheKey)) return detCache[cacheKey];
    if (rank === 1) {
        var colStart = Math.round(Math.log((1 << fullRank) - 1 & ~colMask) / $a9b673cb651a68dc$var$LN2);
        return rows[rowStart][colStart];
    }
    var subRowMask = rowMask | 1 << rowStart;
    var subRowStart = rowStart + 1;
    while(rowMask & 1 << subRowStart)subRowStart++;
    var sum = 0;
    for(var j = 0, colLocalIdx = 0; j < fullRank; j++){
        var colTag = 1 << j;
        if (!(colTag & colMask)) {
            sum += (colLocalIdx % 2 ? -1 : 1) * rows[rowStart][j] * $a9b673cb651a68dc$var$determinant(rows, rank - 1, subRowStart, subRowMask, colMask | colTag, detCache);
            colLocalIdx++;
        }
    }
    detCache[cacheKey] = sum;
    return sum;
}
function $a9b673cb651a68dc$export$fbdb2748a8171a7e(src, dest) {
    var mA = [
        [
            src[0],
            src[1],
            1,
            0,
            0,
            0,
            -dest[0] * src[0],
            -dest[0] * src[1]
        ],
        [
            0,
            0,
            0,
            src[0],
            src[1],
            1,
            -dest[1] * src[0],
            -dest[1] * src[1]
        ],
        [
            src[2],
            src[3],
            1,
            0,
            0,
            0,
            -dest[2] * src[2],
            -dest[2] * src[3]
        ],
        [
            0,
            0,
            0,
            src[2],
            src[3],
            1,
            -dest[3] * src[2],
            -dest[3] * src[3]
        ],
        [
            src[4],
            src[5],
            1,
            0,
            0,
            0,
            -dest[4] * src[4],
            -dest[4] * src[5]
        ],
        [
            0,
            0,
            0,
            src[4],
            src[5],
            1,
            -dest[5] * src[4],
            -dest[5] * src[5]
        ],
        [
            src[6],
            src[7],
            1,
            0,
            0,
            0,
            -dest[6] * src[6],
            -dest[6] * src[7]
        ],
        [
            0,
            0,
            0,
            src[6],
            src[7],
            1,
            -dest[7] * src[6],
            -dest[7] * src[7]
        ]
    ];
    var detCache = {};
    var det = $a9b673cb651a68dc$var$determinant(mA, 8, 0, 0, 0, detCache);
    if (det === 0) return;
    var vh = [];
    for(var i = 0; i < 8; i++)for(var j = 0; j < 8; j++){
        vh[j] == null && (vh[j] = 0);
        vh[j] += ((i + j) % 2 ? -1 : 1) * $a9b673cb651a68dc$var$determinant(mA, 7, i === 0 ? 1 : 0, 1 << i, 1 << j, detCache) / det * dest[i];
    }
    return function(out, srcPointX, srcPointY) {
        var pk = srcPointX * vh[6] + srcPointY * vh[7] + 1;
        out[0] = (srcPointX * vh[0] + srcPointY * vh[1] + vh[2]) / pk;
        out[1] = (srcPointX * vh[3] + srcPointY * vh[4] + vh[5]) / pk;
    };
}


var $664e052f390bd76e$var$EVENT_SAVED_PROP = '___zrEVENTSAVED';
var $664e052f390bd76e$var$_calcOut = [];
function $664e052f390bd76e$export$8c5c02e118307e20(out, elFrom, elTarget, inX, inY) {
    return $664e052f390bd76e$export$1219648acc517df4($664e052f390bd76e$var$_calcOut, elFrom, inX, inY, true) && $664e052f390bd76e$export$1219648acc517df4(out, elTarget, $664e052f390bd76e$var$_calcOut[0], $664e052f390bd76e$var$_calcOut[1]);
}
function $664e052f390bd76e$export$1219648acc517df4(out, el, inX, inY, inverse) {
    if (el.getBoundingClientRect && (0, $ce6dd58693a21851$export$2e2bcd8739ae039).domSupported && !$664e052f390bd76e$export$1b92e4fe606eff6d(el)) {
        var saved = el[$664e052f390bd76e$var$EVENT_SAVED_PROP] || (el[$664e052f390bd76e$var$EVENT_SAVED_PROP] = {});
        var markers = $664e052f390bd76e$var$prepareCoordMarkers(el, saved);
        var transformer = $664e052f390bd76e$var$preparePointerTransformer(markers, saved, inverse);
        if (transformer) {
            transformer(out, inX, inY);
            return true;
        }
    }
    return false;
}
function $664e052f390bd76e$var$prepareCoordMarkers(el, saved) {
    var markers = saved.markers;
    if (markers) return markers;
    markers = saved.markers = [];
    var propLR = [
        'left',
        'right'
    ];
    var propTB = [
        'top',
        'bottom'
    ];
    for(var i = 0; i < 4; i++){
        var marker = document.createElement('div');
        var stl = marker.style;
        var idxLR = i % 2;
        var idxTB = (i >> 1) % 2;
        stl.cssText = [
            'position: absolute',
            'visibility: hidden',
            'padding: 0',
            'margin: 0',
            'border-width: 0',
            'user-select: none',
            'width:0',
            'height:0',
            propLR[idxLR] + ':0',
            propTB[idxTB] + ':0',
            propLR[1 - idxLR] + ':auto',
            propTB[1 - idxTB] + ':auto',
            ''
        ].join('!important;');
        el.appendChild(marker);
        markers.push(marker);
    }
    return markers;
}
function $664e052f390bd76e$var$preparePointerTransformer(markers, saved, inverse) {
    var transformerName = inverse ? 'invTrans' : 'trans';
    var transformer = saved[transformerName];
    var oldSrcCoords = saved.srcCoords;
    var srcCoords = [];
    var destCoords = [];
    var oldCoordTheSame = true;
    for(var i = 0; i < 4; i++){
        var rect = markers[i].getBoundingClientRect();
        var ii = 2 * i;
        var x = rect.left;
        var y = rect.top;
        srcCoords.push(x, y);
        oldCoordTheSame = oldCoordTheSame && oldSrcCoords && x === oldSrcCoords[ii] && y === oldSrcCoords[ii + 1];
        destCoords.push(markers[i].offsetLeft, markers[i].offsetTop);
    }
    return oldCoordTheSame && transformer ? transformer : (saved.srcCoords = srcCoords, saved[transformerName] = inverse ? (0, $a9b673cb651a68dc$export$fbdb2748a8171a7e)(destCoords, srcCoords) : (0, $a9b673cb651a68dc$export$fbdb2748a8171a7e)(srcCoords, destCoords));
}
function $664e052f390bd76e$export$1b92e4fe606eff6d(el) {
    return el.nodeName.toUpperCase() === 'CANVAS';
}
var $664e052f390bd76e$var$replaceReg = /([&<>"'])/g;
var $664e052f390bd76e$var$replaceMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    '\'': '&#39;'
};
function $664e052f390bd76e$export$f9d6449b9af28dc1(source) {
    return source == null ? '' : (source + '').replace($664e052f390bd76e$var$replaceReg, function(str, c) {
        return $664e052f390bd76e$var$replaceMap[c];
    });
}


var $b3864a78637ff9ed$var$MOUSE_EVENT_REG = /^(?:mouse|pointer|contextmenu|drag|drop)|click/;
var $b3864a78637ff9ed$var$_calcOut = [];
var $b3864a78637ff9ed$var$firefoxNotSupportOffsetXY = (0, $ce6dd58693a21851$export$2e2bcd8739ae039).browser.firefox && +(0, $ce6dd58693a21851$export$2e2bcd8739ae039).browser.version.split('.')[0] < 39;
function $b3864a78637ff9ed$export$7d5fecde839eee88(el, e, out, calculate) {
    out = out || {};
    if (calculate) $b3864a78637ff9ed$var$calculateZrXY(el, e, out);
    else if ($b3864a78637ff9ed$var$firefoxNotSupportOffsetXY && e.layerX != null && e.layerX !== e.offsetX) {
        out.zrX = e.layerX;
        out.zrY = e.layerY;
    } else if (e.offsetX != null) {
        out.zrX = e.offsetX;
        out.zrY = e.offsetY;
    } else $b3864a78637ff9ed$var$calculateZrXY(el, e, out);
    return out;
}
function $b3864a78637ff9ed$var$calculateZrXY(el, e, out) {
    if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).domSupported && el.getBoundingClientRect) {
        var ex = e.clientX;
        var ey = e.clientY;
        if ((0, $664e052f390bd76e$export$1b92e4fe606eff6d)(el)) {
            var box = el.getBoundingClientRect();
            out.zrX = ex - box.left;
            out.zrY = ey - box.top;
            return;
        } else if ((0, $664e052f390bd76e$export$1219648acc517df4)($b3864a78637ff9ed$var$_calcOut, el, ex, ey)) {
            out.zrX = $b3864a78637ff9ed$var$_calcOut[0];
            out.zrY = $b3864a78637ff9ed$var$_calcOut[1];
            return;
        }
    }
    out.zrX = out.zrY = 0;
}
function $b3864a78637ff9ed$export$4abe0e945399ac1d(e) {
    return e || window.event;
}
function $b3864a78637ff9ed$export$40fadb093aebad71(el, e, calculate) {
    e = $b3864a78637ff9ed$export$4abe0e945399ac1d(e);
    if (e.zrX != null) return e;
    var eventType = e.type;
    var isTouch = eventType && eventType.indexOf('touch') >= 0;
    if (!isTouch) {
        $b3864a78637ff9ed$export$7d5fecde839eee88(el, e, e, calculate);
        var wheelDelta = $b3864a78637ff9ed$var$getWheelDeltaMayPolyfill(e);
        e.zrDelta = wheelDelta ? wheelDelta / 120 : -(e.detail || 0) / 3;
    } else {
        var touch = eventType !== 'touchend' ? e.targetTouches[0] : e.changedTouches[0];
        touch && $b3864a78637ff9ed$export$7d5fecde839eee88(el, touch, e, calculate);
    }
    var button = e.button;
    if (e.which == null && button !== undefined && $b3864a78637ff9ed$var$MOUSE_EVENT_REG.test(e.type)) e.which = button & 1 ? 1 : button & 2 ? 3 : button & 4 ? 2 : 0;
    return e;
}
function $b3864a78637ff9ed$var$getWheelDeltaMayPolyfill(e) {
    var rawWheelDelta = e.wheelDelta;
    if (rawWheelDelta) return rawWheelDelta;
    var deltaX = e.deltaX;
    var deltaY = e.deltaY;
    if (deltaX == null || deltaY == null) return rawWheelDelta;
    var delta = deltaY !== 0 ? Math.abs(deltaY) : Math.abs(deltaX);
    var sign = deltaY > 0 ? -1 : deltaY < 0 ? 1 : deltaX > 0 ? -1 : 1;
    return 3 * delta * sign;
}
function $b3864a78637ff9ed$export$3f65cefe8380dbea(el, name, handler, opt) {
    el.addEventListener(name, handler, opt);
}
function $b3864a78637ff9ed$export$8ff9f68337b520c0(el, name, handler, opt) {
    el.removeEventListener(name, handler, opt);
}
var $b3864a78637ff9ed$export$fa6813432f753b0d = function(e) {
    e.preventDefault();
    e.stopPropagation();
    e.cancelBubble = true;
};
function $b3864a78637ff9ed$export$b7ae4cded3e71bd2(e) {
    return e.which === 2 || e.which === 3;
}



var $225ab5cf635fc62d$export$f7557d6f27e9503 = function() {
    function GestureMgr() {
        this._track = [];
    }
    GestureMgr.prototype.recognize = function(event, target, root) {
        this._doTrack(event, target, root);
        return this._recognize(event);
    };
    GestureMgr.prototype.clear = function() {
        this._track.length = 0;
        return this;
    };
    GestureMgr.prototype._doTrack = function(event, target, root) {
        var touches = event.touches;
        if (!touches) return;
        var trackItem = {
            points: [],
            touches: [],
            target: target,
            event: event
        };
        for(var i = 0, len = touches.length; i < len; i++){
            var touch = touches[i];
            var pos = $b3864a78637ff9ed$export$7d5fecde839eee88(root, touch, {});
            trackItem.points.push([
                pos.zrX,
                pos.zrY
            ]);
            trackItem.touches.push(touch);
        }
        this._track.push(trackItem);
    };
    GestureMgr.prototype._recognize = function(event) {
        for(var eventName in $225ab5cf635fc62d$var$recognizers)if ($225ab5cf635fc62d$var$recognizers.hasOwnProperty(eventName)) {
            var gestureInfo = $225ab5cf635fc62d$var$recognizers[eventName](this._track, event);
            if (gestureInfo) return gestureInfo;
        }
    };
    return GestureMgr;
}();
function $225ab5cf635fc62d$var$dist(pointPair) {
    var dx = pointPair[1][0] - pointPair[0][0];
    var dy = pointPair[1][1] - pointPair[0][1];
    return Math.sqrt(dx * dx + dy * dy);
}
function $225ab5cf635fc62d$var$center(pointPair) {
    return [
        (pointPair[0][0] + pointPair[1][0]) / 2,
        (pointPair[0][1] + pointPair[1][1]) / 2
    ];
}
var $225ab5cf635fc62d$var$recognizers = {
    pinch: function(tracks, event) {
        var trackLen = tracks.length;
        if (!trackLen) return;
        var pinchEnd = (tracks[trackLen - 1] || {}).points;
        var pinchPre = (tracks[trackLen - 2] || {}).points || pinchEnd;
        if (pinchPre && pinchPre.length > 1 && pinchEnd && pinchEnd.length > 1) {
            var pinchScale = $225ab5cf635fc62d$var$dist(pinchEnd) / $225ab5cf635fc62d$var$dist(pinchPre);
            !isFinite(pinchScale) && (pinchScale = 1);
            event.pinchScale = pinchScale;
            var pinchCenter = $225ab5cf635fc62d$var$center(pinchEnd);
            event.pinchX = pinchCenter[0];
            event.pinchY = pinchCenter[1];
            return {
                type: 'pinch',
                target: tracks[0].target,
                event: event
            };
        }
    }
};


function $f41ebb9dd60b55b4$export$185802fd694ee1f5() {
    return [
        1,
        0,
        0,
        1,
        0,
        0
    ];
}
function $f41ebb9dd60b55b4$export$f0954fd7d5368655(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    out[4] = 0;
    out[5] = 0;
    return out;
}
function $f41ebb9dd60b55b4$export$784d13d8ee351f07(out, m) {
    out[0] = m[0];
    out[1] = m[1];
    out[2] = m[2];
    out[3] = m[3];
    out[4] = m[4];
    out[5] = m[5];
    return out;
}
function $f41ebb9dd60b55b4$export$6e3a27864ab166fe(out, m1, m2) {
    var out0 = m1[0] * m2[0] + m1[2] * m2[1];
    var out1 = m1[1] * m2[0] + m1[3] * m2[1];
    var out2 = m1[0] * m2[2] + m1[2] * m2[3];
    var out3 = m1[1] * m2[2] + m1[3] * m2[3];
    var out4 = m1[0] * m2[4] + m1[2] * m2[5] + m1[4];
    var out5 = m1[1] * m2[4] + m1[3] * m2[5] + m1[5];
    out[0] = out0;
    out[1] = out1;
    out[2] = out2;
    out[3] = out3;
    out[4] = out4;
    out[5] = out5;
    return out;
}
function $f41ebb9dd60b55b4$export$d73ee8ef04f5226a(out, a, v) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4] + v[0];
    out[5] = a[5] + v[1];
    return out;
}
function $f41ebb9dd60b55b4$export$bb628a54ab399bc9(out, a, rad, pivot) {
    if (pivot === void 0) pivot = [
        0,
        0
    ];
    var aa = a[0];
    var ac = a[2];
    var atx = a[4];
    var ab = a[1];
    var ad = a[3];
    var aty = a[5];
    var st = Math.sin(rad);
    var ct = Math.cos(rad);
    out[0] = aa * ct + ab * st;
    out[1] = -aa * st + ab * ct;
    out[2] = ac * ct + ad * st;
    out[3] = -ac * st + ct * ad;
    out[4] = ct * (atx - pivot[0]) + st * (aty - pivot[1]) + pivot[0];
    out[5] = ct * (aty - pivot[1]) - st * (atx - pivot[0]) + pivot[1];
    return out;
}
function $f41ebb9dd60b55b4$export$dcdf75081b88279d(out, a, v) {
    var vx = v[0];
    var vy = v[1];
    out[0] = a[0] * vx;
    out[1] = a[1] * vy;
    out[2] = a[2] * vx;
    out[3] = a[3] * vy;
    out[4] = a[4] * vx;
    out[5] = a[5] * vy;
    return out;
}
function $f41ebb9dd60b55b4$export$6897c284b6f9f4dc(out, a) {
    var aa = a[0];
    var ac = a[2];
    var atx = a[4];
    var ab = a[1];
    var ad = a[3];
    var aty = a[5];
    var det = aa * ad - ab * ac;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = ad * det;
    out[1] = -ab * det;
    out[2] = -ac * det;
    out[3] = aa * det;
    out[4] = (ac * aty - ad * atx) * det;
    out[5] = (ab * atx - aa * aty) * det;
    return out;
}
function $f41ebb9dd60b55b4$export$9cd59f9826255e47(a) {
    var b = $f41ebb9dd60b55b4$export$185802fd694ee1f5();
    $f41ebb9dd60b55b4$export$784d13d8ee351f07(b, a);
    return b;
}


var $b887f038f104fe7e$var$Point = function() {
    function Point(x, y) {
        this.x = x || 0;
        this.y = y || 0;
    }
    Point.prototype.copy = function(other) {
        this.x = other.x;
        this.y = other.y;
        return this;
    };
    Point.prototype.clone = function() {
        return new Point(this.x, this.y);
    };
    Point.prototype.set = function(x, y) {
        this.x = x;
        this.y = y;
        return this;
    };
    Point.prototype.equal = function(other) {
        return other.x === this.x && other.y === this.y;
    };
    Point.prototype.add = function(other) {
        this.x += other.x;
        this.y += other.y;
        return this;
    };
    Point.prototype.scale = function(scalar) {
        this.x *= scalar;
        this.y *= scalar;
    };
    Point.prototype.scaleAndAdd = function(other, scalar) {
        this.x += other.x * scalar;
        this.y += other.y * scalar;
    };
    Point.prototype.sub = function(other) {
        this.x -= other.x;
        this.y -= other.y;
        return this;
    };
    Point.prototype.dot = function(other) {
        return this.x * other.x + this.y * other.y;
    };
    Point.prototype.len = function() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    };
    Point.prototype.lenSquare = function() {
        return this.x * this.x + this.y * this.y;
    };
    Point.prototype.normalize = function() {
        var len = this.len();
        this.x /= len;
        this.y /= len;
        return this;
    };
    Point.prototype.distance = function(other) {
        var dx = this.x - other.x;
        var dy = this.y - other.y;
        return Math.sqrt(dx * dx + dy * dy);
    };
    Point.prototype.distanceSquare = function(other) {
        var dx = this.x - other.x;
        var dy = this.y - other.y;
        return dx * dx + dy * dy;
    };
    Point.prototype.negate = function() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    };
    Point.prototype.transform = function(m) {
        if (!m) return;
        var x = this.x;
        var y = this.y;
        this.x = m[0] * x + m[2] * y + m[4];
        this.y = m[1] * x + m[3] * y + m[5];
        return this;
    };
    Point.prototype.toArray = function(out) {
        out[0] = this.x;
        out[1] = this.y;
        return out;
    };
    Point.prototype.fromArray = function(input) {
        this.x = input[0];
        this.y = input[1];
    };
    Point.set = function(p, x, y) {
        p.x = x;
        p.y = y;
    };
    Point.copy = function(p, p2) {
        p.x = p2.x;
        p.y = p2.y;
    };
    Point.len = function(p) {
        return Math.sqrt(p.x * p.x + p.y * p.y);
    };
    Point.lenSquare = function(p) {
        return p.x * p.x + p.y * p.y;
    };
    Point.dot = function(p0, p1) {
        return p0.x * p1.x + p0.y * p1.y;
    };
    Point.add = function(out, p0, p1) {
        out.x = p0.x + p1.x;
        out.y = p0.y + p1.y;
    };
    Point.sub = function(out, p0, p1) {
        out.x = p0.x - p1.x;
        out.y = p0.y - p1.y;
    };
    Point.scale = function(out, p0, scalar) {
        out.x = p0.x * scalar;
        out.y = p0.y * scalar;
    };
    Point.scaleAndAdd = function(out, p0, p1, scalar) {
        out.x = p0.x + p1.x * scalar;
        out.y = p0.y + p1.y * scalar;
    };
    Point.lerp = function(out, p0, p1, t) {
        var onet = 1 - t;
        out.x = onet * p0.x + t * p1.x;
        out.y = onet * p0.y + t * p1.y;
    };
    return Point;
}();
var $b887f038f104fe7e$export$2e2bcd8739ae039 = $b887f038f104fe7e$var$Point;


var $1bebe7106c895823$var$mathMin = Math.min;
var $1bebe7106c895823$var$mathMax = Math.max;
var $1bebe7106c895823$var$lt = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
var $1bebe7106c895823$var$rb = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
var $1bebe7106c895823$var$lb = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
var $1bebe7106c895823$var$rt = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
var $1bebe7106c895823$var$minTv = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
var $1bebe7106c895823$var$maxTv = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
var $1bebe7106c895823$var$BoundingRect = function() {
    function BoundingRect(x, y, width, height) {
        if (width < 0) {
            x = x + width;
            width = -width;
        }
        if (height < 0) {
            y = y + height;
            height = -height;
        }
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }
    BoundingRect.prototype.union = function(other) {
        var x = $1bebe7106c895823$var$mathMin(other.x, this.x);
        var y = $1bebe7106c895823$var$mathMin(other.y, this.y);
        if (isFinite(this.x) && isFinite(this.width)) this.width = $1bebe7106c895823$var$mathMax(other.x + other.width, this.x + this.width) - x;
        else this.width = other.width;
        if (isFinite(this.y) && isFinite(this.height)) this.height = $1bebe7106c895823$var$mathMax(other.y + other.height, this.y + this.height) - y;
        else this.height = other.height;
        this.x = x;
        this.y = y;
    };
    BoundingRect.prototype.applyTransform = function(m) {
        BoundingRect.applyTransform(this, this, m);
    };
    BoundingRect.prototype.calculateTransform = function(b) {
        var a = this;
        var sx = b.width / a.width;
        var sy = b.height / a.height;
        var m = $f41ebb9dd60b55b4$export$185802fd694ee1f5();
        $f41ebb9dd60b55b4$export$d73ee8ef04f5226a(m, m, [
            -a.x,
            -a.y
        ]);
        $f41ebb9dd60b55b4$export$dcdf75081b88279d(m, m, [
            sx,
            sy
        ]);
        $f41ebb9dd60b55b4$export$d73ee8ef04f5226a(m, m, [
            b.x,
            b.y
        ]);
        return m;
    };
    BoundingRect.prototype.intersect = function(b, mtv) {
        if (!b) return false;
        if (!(b instanceof BoundingRect)) b = BoundingRect.create(b);
        var a = this;
        var ax0 = a.x;
        var ax1 = a.x + a.width;
        var ay0 = a.y;
        var ay1 = a.y + a.height;
        var bx0 = b.x;
        var bx1 = b.x + b.width;
        var by0 = b.y;
        var by1 = b.y + b.height;
        var overlap = !(ax1 < bx0 || bx1 < ax0 || ay1 < by0 || by1 < ay0);
        if (mtv) {
            var dMin = Infinity;
            var dMax = 0;
            var d0 = Math.abs(ax1 - bx0);
            var d1 = Math.abs(bx1 - ax0);
            var d2 = Math.abs(ay1 - by0);
            var d3 = Math.abs(by1 - ay0);
            var dx = Math.min(d0, d1);
            var dy = Math.min(d2, d3);
            if (ax1 < bx0 || bx1 < ax0) {
                if (dx > dMax) {
                    dMax = dx;
                    if (d0 < d1) (0, $b887f038f104fe7e$export$2e2bcd8739ae039).set($1bebe7106c895823$var$maxTv, -d0, 0);
                    else (0, $b887f038f104fe7e$export$2e2bcd8739ae039).set($1bebe7106c895823$var$maxTv, d1, 0);
                }
            } else if (dx < dMin) {
                dMin = dx;
                if (d0 < d1) (0, $b887f038f104fe7e$export$2e2bcd8739ae039).set($1bebe7106c895823$var$minTv, d0, 0);
                else (0, $b887f038f104fe7e$export$2e2bcd8739ae039).set($1bebe7106c895823$var$minTv, -d1, 0);
            }
            if (ay1 < by0 || by1 < ay0) {
                if (dy > dMax) {
                    dMax = dy;
                    if (d2 < d3) (0, $b887f038f104fe7e$export$2e2bcd8739ae039).set($1bebe7106c895823$var$maxTv, 0, -d2);
                    else (0, $b887f038f104fe7e$export$2e2bcd8739ae039).set($1bebe7106c895823$var$maxTv, 0, d3);
                }
            } else if (dx < dMin) {
                dMin = dx;
                if (d2 < d3) (0, $b887f038f104fe7e$export$2e2bcd8739ae039).set($1bebe7106c895823$var$minTv, 0, d2);
                else (0, $b887f038f104fe7e$export$2e2bcd8739ae039).set($1bebe7106c895823$var$minTv, 0, -d3);
            }
        }
        if (mtv) (0, $b887f038f104fe7e$export$2e2bcd8739ae039).copy(mtv, overlap ? $1bebe7106c895823$var$minTv : $1bebe7106c895823$var$maxTv);
        return overlap;
    };
    BoundingRect.prototype.contain = function(x, y) {
        var rect = this;
        return x >= rect.x && x <= rect.x + rect.width && y >= rect.y && y <= rect.y + rect.height;
    };
    BoundingRect.prototype.clone = function() {
        return new BoundingRect(this.x, this.y, this.width, this.height);
    };
    BoundingRect.prototype.copy = function(other) {
        BoundingRect.copy(this, other);
    };
    BoundingRect.prototype.plain = function() {
        return {
            x: this.x,
            y: this.y,
            width: this.width,
            height: this.height
        };
    };
    BoundingRect.prototype.isFinite = function() {
        return isFinite(this.x) && isFinite(this.y) && isFinite(this.width) && isFinite(this.height);
    };
    BoundingRect.prototype.isZero = function() {
        return this.width === 0 || this.height === 0;
    };
    BoundingRect.create = function(rect) {
        return new BoundingRect(rect.x, rect.y, rect.width, rect.height);
    };
    BoundingRect.copy = function(target, source) {
        target.x = source.x;
        target.y = source.y;
        target.width = source.width;
        target.height = source.height;
    };
    BoundingRect.applyTransform = function(target, source, m) {
        if (!m) {
            if (target !== source) BoundingRect.copy(target, source);
            return;
        }
        if (m[1] < 1e-5 && m[1] > -0.00001 && m[2] < 1e-5 && m[2] > -0.00001) {
            var sx = m[0];
            var sy = m[3];
            var tx = m[4];
            var ty = m[5];
            target.x = source.x * sx + tx;
            target.y = source.y * sy + ty;
            target.width = source.width * sx;
            target.height = source.height * sy;
            if (target.width < 0) {
                target.x += target.width;
                target.width = -target.width;
            }
            if (target.height < 0) {
                target.y += target.height;
                target.height = -target.height;
            }
            return;
        }
        $1bebe7106c895823$var$lt.x = $1bebe7106c895823$var$lb.x = source.x;
        $1bebe7106c895823$var$lt.y = $1bebe7106c895823$var$rt.y = source.y;
        $1bebe7106c895823$var$rb.x = $1bebe7106c895823$var$rt.x = source.x + source.width;
        $1bebe7106c895823$var$rb.y = $1bebe7106c895823$var$lb.y = source.y + source.height;
        $1bebe7106c895823$var$lt.transform(m);
        $1bebe7106c895823$var$rt.transform(m);
        $1bebe7106c895823$var$rb.transform(m);
        $1bebe7106c895823$var$lb.transform(m);
        target.x = $1bebe7106c895823$var$mathMin($1bebe7106c895823$var$lt.x, $1bebe7106c895823$var$rb.x, $1bebe7106c895823$var$lb.x, $1bebe7106c895823$var$rt.x);
        target.y = $1bebe7106c895823$var$mathMin($1bebe7106c895823$var$lt.y, $1bebe7106c895823$var$rb.y, $1bebe7106c895823$var$lb.y, $1bebe7106c895823$var$rt.y);
        var maxX = $1bebe7106c895823$var$mathMax($1bebe7106c895823$var$lt.x, $1bebe7106c895823$var$rb.x, $1bebe7106c895823$var$lb.x, $1bebe7106c895823$var$rt.x);
        var maxY = $1bebe7106c895823$var$mathMax($1bebe7106c895823$var$lt.y, $1bebe7106c895823$var$rb.y, $1bebe7106c895823$var$lb.y, $1bebe7106c895823$var$rt.y);
        target.width = maxX - target.x;
        target.height = maxY - target.y;
    };
    return BoundingRect;
}();
var $1bebe7106c895823$export$2e2bcd8739ae039 = $1bebe7106c895823$var$BoundingRect;


var $b30f5d021af2ec5a$var$SILENT = 'silent';
function $b30f5d021af2ec5a$var$makeEventPacket(eveType, targetInfo, event) {
    return {
        type: eveType,
        event: event,
        target: targetInfo.target,
        topTarget: targetInfo.topTarget,
        cancelBubble: false,
        offsetX: event.zrX,
        offsetY: event.zrY,
        gestureEvent: event.gestureEvent,
        pinchX: event.pinchX,
        pinchY: event.pinchY,
        pinchScale: event.pinchScale,
        wheelDelta: event.zrDelta,
        zrByTouch: event.zrByTouch,
        which: event.which,
        stop: $b30f5d021af2ec5a$var$stopEvent
    };
}
function $b30f5d021af2ec5a$var$stopEvent() {
    $b3864a78637ff9ed$export$fa6813432f753b0d(this.event);
}
var $b30f5d021af2ec5a$var$EmptyProxy = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(EmptyProxy, _super);
    function EmptyProxy() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handler = null;
        return _this;
    }
    EmptyProxy.prototype.dispose = function() {};
    EmptyProxy.prototype.setCursor = function() {};
    return EmptyProxy;
}((0, $63441a86293f101f$export$2e2bcd8739ae039));
var $b30f5d021af2ec5a$var$HoveredResult = function() {
    function HoveredResult(x, y) {
        this.x = x;
        this.y = y;
    }
    return HoveredResult;
}();
var $b30f5d021af2ec5a$var$handlerNames = [
    'click',
    'dblclick',
    'mousewheel',
    'mouseout',
    'mouseup',
    'mousedown',
    'mousemove',
    'contextmenu'
];
var $b30f5d021af2ec5a$var$tmpRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
var $b30f5d021af2ec5a$var$Handler = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Handler, _super);
    function Handler(storage, painter, proxy, painterRoot, pointerSize) {
        var _this = _super.call(this) || this;
        _this._hovered = new $b30f5d021af2ec5a$var$HoveredResult(0, 0);
        _this.storage = storage;
        _this.painter = painter;
        _this.painterRoot = painterRoot;
        _this._pointerSize = pointerSize;
        proxy = proxy || new $b30f5d021af2ec5a$var$EmptyProxy();
        _this.proxy = null;
        _this.setHandlerProxy(proxy);
        _this._draggingMgr = new (0, $4e8ea7ab4b22b6b2$export$2e2bcd8739ae039)(_this);
        return _this;
    }
    Handler.prototype.setHandlerProxy = function(proxy) {
        if (this.proxy) this.proxy.dispose();
        if (proxy) {
            $7a1bd9c2710fea0d$export$79b2f7037acddd43($b30f5d021af2ec5a$var$handlerNames, function(name) {
                proxy.on && proxy.on(name, this[name], this);
            }, this);
            proxy.handler = this;
        }
        this.proxy = proxy;
    };
    Handler.prototype.mousemove = function(event) {
        var x = event.zrX;
        var y = event.zrY;
        var isOutside = $b30f5d021af2ec5a$var$isOutsideBoundary(this, x, y);
        var lastHovered = this._hovered;
        var lastHoveredTarget = lastHovered.target;
        if (lastHoveredTarget && !lastHoveredTarget.__zr) {
            lastHovered = this.findHover(lastHovered.x, lastHovered.y);
            lastHoveredTarget = lastHovered.target;
        }
        var hovered = this._hovered = isOutside ? new $b30f5d021af2ec5a$var$HoveredResult(x, y) : this.findHover(x, y);
        var hoveredTarget = hovered.target;
        var proxy = this.proxy;
        proxy.setCursor && proxy.setCursor(hoveredTarget ? hoveredTarget.cursor : 'default');
        if (lastHoveredTarget && hoveredTarget !== lastHoveredTarget) this.dispatchToElement(lastHovered, 'mouseout', event);
        this.dispatchToElement(hovered, 'mousemove', event);
        if (hoveredTarget && hoveredTarget !== lastHoveredTarget) this.dispatchToElement(hovered, 'mouseover', event);
    };
    Handler.prototype.mouseout = function(event) {
        var eventControl = event.zrEventControl;
        if (eventControl !== 'only_globalout') this.dispatchToElement(this._hovered, 'mouseout', event);
        if (eventControl !== 'no_globalout') this.trigger('globalout', {
            type: 'globalout',
            event: event
        });
    };
    Handler.prototype.resize = function() {
        this._hovered = new $b30f5d021af2ec5a$var$HoveredResult(0, 0);
    };
    Handler.prototype.dispatch = function(eventName, eventArgs) {
        var handler = this[eventName];
        handler && handler.call(this, eventArgs);
    };
    Handler.prototype.dispose = function() {
        this.proxy.dispose();
        this.storage = null;
        this.proxy = null;
        this.painter = null;
    };
    Handler.prototype.setCursorStyle = function(cursorStyle) {
        var proxy = this.proxy;
        proxy.setCursor && proxy.setCursor(cursorStyle);
    };
    Handler.prototype.dispatchToElement = function(targetInfo, eventName, event) {
        targetInfo = targetInfo || {};
        var el = targetInfo.target;
        if (el && el.silent) return;
        var eventKey = 'on' + eventName;
        var eventPacket = $b30f5d021af2ec5a$var$makeEventPacket(eventName, targetInfo, event);
        while(el){
            el[eventKey] && (eventPacket.cancelBubble = !!el[eventKey].call(el, eventPacket));
            el.trigger(eventName, eventPacket);
            el = el.__hostTarget ? el.__hostTarget : el.parent;
            if (eventPacket.cancelBubble) break;
        }
        if (!eventPacket.cancelBubble) {
            this.trigger(eventName, eventPacket);
            if (this.painter && this.painter.eachOtherLayer) this.painter.eachOtherLayer(function(layer) {
                if (typeof layer[eventKey] === 'function') layer[eventKey].call(layer, eventPacket);
                if (layer.trigger) layer.trigger(eventName, eventPacket);
            });
        }
    };
    Handler.prototype.findHover = function(x, y, exclude) {
        var list = this.storage.getDisplayList();
        var out = new $b30f5d021af2ec5a$var$HoveredResult(x, y);
        $b30f5d021af2ec5a$var$setHoverTarget(list, out, x, y, exclude);
        if (this._pointerSize && !out.target) {
            var candidates = [];
            var pointerSize = this._pointerSize;
            var targetSizeHalf = pointerSize / 2;
            var pointerRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(x - targetSizeHalf, y - targetSizeHalf, pointerSize, pointerSize);
            for(var i = list.length - 1; i >= 0; i--){
                var el = list[i];
                if (el !== exclude && !el.ignore && !el.ignoreCoarsePointer && (!el.parent || !el.parent.ignoreCoarsePointer)) {
                    $b30f5d021af2ec5a$var$tmpRect.copy(el.getBoundingRect());
                    if (el.transform) $b30f5d021af2ec5a$var$tmpRect.applyTransform(el.transform);
                    if ($b30f5d021af2ec5a$var$tmpRect.intersect(pointerRect)) candidates.push(el);
                }
            }
            if (candidates.length) {
                var rStep = 4;
                var thetaStep = Math.PI / 12;
                var PI2 = Math.PI * 2;
                for(var r = 0; r < targetSizeHalf; r += rStep)for(var theta = 0; theta < PI2; theta += thetaStep){
                    var x1 = x + r * Math.cos(theta);
                    var y1 = y + r * Math.sin(theta);
                    $b30f5d021af2ec5a$var$setHoverTarget(candidates, out, x1, y1, exclude);
                    if (out.target) return out;
                }
            }
        }
        return out;
    };
    Handler.prototype.processGesture = function(event, stage) {
        if (!this._gestureMgr) this._gestureMgr = new (0, $225ab5cf635fc62d$export$f7557d6f27e9503)();
        var gestureMgr = this._gestureMgr;
        stage === 'start' && gestureMgr.clear();
        var gestureInfo = gestureMgr.recognize(event, this.findHover(event.zrX, event.zrY, null).target, this.proxy.dom);
        stage === 'end' && gestureMgr.clear();
        if (gestureInfo) {
            var type = gestureInfo.type;
            event.gestureEvent = type;
            var res = new $b30f5d021af2ec5a$var$HoveredResult();
            res.target = gestureInfo.target;
            this.dispatchToElement(res, type, gestureInfo.event);
        }
    };
    return Handler;
}((0, $63441a86293f101f$export$2e2bcd8739ae039));
$7a1bd9c2710fea0d$export$79b2f7037acddd43([
    'click',
    'mousedown',
    'mouseup',
    'mousewheel',
    'dblclick',
    'contextmenu'
], function(name) {
    $b30f5d021af2ec5a$var$Handler.prototype[name] = function(event) {
        var x = event.zrX;
        var y = event.zrY;
        var isOutside = $b30f5d021af2ec5a$var$isOutsideBoundary(this, x, y);
        var hovered;
        var hoveredTarget;
        if (name !== 'mouseup' || !isOutside) {
            hovered = this.findHover(x, y);
            hoveredTarget = hovered.target;
        }
        if (name === 'mousedown') {
            this._downEl = hoveredTarget;
            this._downPoint = [
                event.zrX,
                event.zrY
            ];
            this._upEl = hoveredTarget;
        } else if (name === 'mouseup') this._upEl = hoveredTarget;
        else if (name === 'click') {
            if (this._downEl !== this._upEl || !this._downPoint || $6de594cf8ac295ff$export$6c4a311cc157c764(this._downPoint, [
                event.zrX,
                event.zrY
            ]) > 4) return;
            this._downPoint = null;
        }
        this.dispatchToElement(hovered, name, event);
    };
});
function $b30f5d021af2ec5a$var$isHover(displayable, x, y) {
    if (displayable[displayable.rectHover ? 'rectContain' : 'contain'](x, y)) {
        var el = displayable;
        var isSilent = void 0;
        var ignoreClip = false;
        while(el){
            if (el.ignoreClip) ignoreClip = true;
            if (!ignoreClip) {
                var clipPath = el.getClipPath();
                if (clipPath && !clipPath.contain(x, y)) return false;
            }
            if (el.silent) isSilent = true;
            var hostEl = el.__hostTarget;
            el = hostEl ? hostEl : el.parent;
        }
        return isSilent ? $b30f5d021af2ec5a$var$SILENT : true;
    }
    return false;
}
function $b30f5d021af2ec5a$var$setHoverTarget(list, out, x, y, exclude) {
    for(var i = list.length - 1; i >= 0; i--){
        var el = list[i];
        var hoverCheckResult = void 0;
        if (el !== exclude && !el.ignore && (hoverCheckResult = $b30f5d021af2ec5a$var$isHover(el, x, y))) {
            !out.topTarget && (out.topTarget = el);
            if (hoverCheckResult !== $b30f5d021af2ec5a$var$SILENT) {
                out.target = el;
                break;
            }
        }
    }
}
function $b30f5d021af2ec5a$var$isOutsideBoundary(handlerInstance, x, y) {
    var painter = handlerInstance.painter;
    return x < 0 || x > painter.getWidth() || y < 0 || y > painter.getHeight();
}
var $b30f5d021af2ec5a$export$2e2bcd8739ae039 = $b30f5d021af2ec5a$var$Handler;



var $97579a54749e4b24$var$DEFAULT_MIN_MERGE = 32;
var $97579a54749e4b24$var$DEFAULT_MIN_GALLOPING = 7;
function $97579a54749e4b24$var$minRunLength(n) {
    var r = 0;
    while(n >= $97579a54749e4b24$var$DEFAULT_MIN_MERGE){
        r |= n & 1;
        n >>= 1;
    }
    return n + r;
}
function $97579a54749e4b24$var$makeAscendingRun(array, lo, hi, compare) {
    var runHi = lo + 1;
    if (runHi === hi) return 1;
    if (compare(array[runHi++], array[lo]) < 0) {
        while(runHi < hi && compare(array[runHi], array[runHi - 1]) < 0)runHi++;
        $97579a54749e4b24$var$reverseRun(array, lo, runHi);
    } else while(runHi < hi && compare(array[runHi], array[runHi - 1]) >= 0)runHi++;
    return runHi - lo;
}
function $97579a54749e4b24$var$reverseRun(array, lo, hi) {
    hi--;
    while(lo < hi){
        var t = array[lo];
        array[lo++] = array[hi];
        array[hi--] = t;
    }
}
function $97579a54749e4b24$var$binaryInsertionSort(array, lo, hi, start, compare) {
    if (start === lo) start++;
    for(; start < hi; start++){
        var pivot = array[start];
        var left = lo;
        var right = start;
        var mid;
        while(left < right){
            mid = left + right >>> 1;
            if (compare(pivot, array[mid]) < 0) right = mid;
            else left = mid + 1;
        }
        var n = start - left;
        switch(n){
            case 3:
                array[left + 3] = array[left + 2];
            case 2:
                array[left + 2] = array[left + 1];
            case 1:
                array[left + 1] = array[left];
                break;
            default:
                while(n > 0){
                    array[left + n] = array[left + n - 1];
                    n--;
                }
        }
        array[left] = pivot;
    }
}
function $97579a54749e4b24$var$gallopLeft(value, array, start, length, hint, compare) {
    var lastOffset = 0;
    var maxOffset = 0;
    var offset = 1;
    if (compare(value, array[start + hint]) > 0) {
        maxOffset = length - hint;
        while(offset < maxOffset && compare(value, array[start + hint + offset]) > 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        lastOffset += hint;
        offset += hint;
    } else {
        maxOffset = hint + 1;
        while(offset < maxOffset && compare(value, array[start + hint - offset]) <= 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        var tmp = lastOffset;
        lastOffset = hint - offset;
        offset = hint - tmp;
    }
    lastOffset++;
    while(lastOffset < offset){
        var m = lastOffset + (offset - lastOffset >>> 1);
        if (compare(value, array[start + m]) > 0) lastOffset = m + 1;
        else offset = m;
    }
    return offset;
}
function $97579a54749e4b24$var$gallopRight(value, array, start, length, hint, compare) {
    var lastOffset = 0;
    var maxOffset = 0;
    var offset = 1;
    if (compare(value, array[start + hint]) < 0) {
        maxOffset = hint + 1;
        while(offset < maxOffset && compare(value, array[start + hint - offset]) < 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        var tmp = lastOffset;
        lastOffset = hint - offset;
        offset = hint - tmp;
    } else {
        maxOffset = length - hint;
        while(offset < maxOffset && compare(value, array[start + hint + offset]) >= 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        lastOffset += hint;
        offset += hint;
    }
    lastOffset++;
    while(lastOffset < offset){
        var m = lastOffset + (offset - lastOffset >>> 1);
        if (compare(value, array[start + m]) < 0) offset = m;
        else lastOffset = m + 1;
    }
    return offset;
}
function $97579a54749e4b24$var$TimSort(array, compare) {
    var minGallop = $97579a54749e4b24$var$DEFAULT_MIN_GALLOPING;
    var runStart;
    var runLength;
    var stackSize = 0;
    var tmp = [];
    runStart = [];
    runLength = [];
    function pushRun(_runStart, _runLength) {
        runStart[stackSize] = _runStart;
        runLength[stackSize] = _runLength;
        stackSize += 1;
    }
    function mergeRuns() {
        while(stackSize > 1){
            var n = stackSize - 2;
            if (n >= 1 && runLength[n - 1] <= runLength[n] + runLength[n + 1] || n >= 2 && runLength[n - 2] <= runLength[n] + runLength[n - 1]) {
                if (runLength[n - 1] < runLength[n + 1]) n--;
            } else if (runLength[n] > runLength[n + 1]) break;
            mergeAt(n);
        }
    }
    function forceMergeRuns() {
        while(stackSize > 1){
            var n = stackSize - 2;
            if (n > 0 && runLength[n - 1] < runLength[n + 1]) n--;
            mergeAt(n);
        }
    }
    function mergeAt(i) {
        var start1 = runStart[i];
        var length1 = runLength[i];
        var start2 = runStart[i + 1];
        var length2 = runLength[i + 1];
        runLength[i] = length1 + length2;
        if (i === stackSize - 3) {
            runStart[i + 1] = runStart[i + 2];
            runLength[i + 1] = runLength[i + 2];
        }
        stackSize--;
        var k = $97579a54749e4b24$var$gallopRight(array[start2], array, start1, length1, 0, compare);
        start1 += k;
        length1 -= k;
        if (length1 === 0) return;
        length2 = $97579a54749e4b24$var$gallopLeft(array[start1 + length1 - 1], array, start2, length2, length2 - 1, compare);
        if (length2 === 0) return;
        if (length1 <= length2) mergeLow(start1, length1, start2, length2);
        else mergeHigh(start1, length1, start2, length2);
    }
    function mergeLow(start1, length1, start2, length2) {
        var i = 0;
        for(i = 0; i < length1; i++)tmp[i] = array[start1 + i];
        var cursor1 = 0;
        var cursor2 = start2;
        var dest = start1;
        array[dest++] = array[cursor2++];
        if (--length2 === 0) {
            for(i = 0; i < length1; i++)array[dest + i] = tmp[cursor1 + i];
            return;
        }
        if (length1 === 1) {
            for(i = 0; i < length2; i++)array[dest + i] = array[cursor2 + i];
            array[dest + length2] = tmp[cursor1];
            return;
        }
        var _minGallop = minGallop;
        var count1;
        var count2;
        var exit;
        while(true){
            count1 = 0;
            count2 = 0;
            exit = false;
            do if (compare(array[cursor2], tmp[cursor1]) < 0) {
                array[dest++] = array[cursor2++];
                count2++;
                count1 = 0;
                if (--length2 === 0) {
                    exit = true;
                    break;
                }
            } else {
                array[dest++] = tmp[cursor1++];
                count1++;
                count2 = 0;
                if (--length1 === 1) {
                    exit = true;
                    break;
                }
            }
            while ((count1 | count2) < _minGallop);
            if (exit) break;
            do {
                count1 = $97579a54749e4b24$var$gallopRight(array[cursor2], tmp, cursor1, length1, 0, compare);
                if (count1 !== 0) {
                    for(i = 0; i < count1; i++)array[dest + i] = tmp[cursor1 + i];
                    dest += count1;
                    cursor1 += count1;
                    length1 -= count1;
                    if (length1 <= 1) {
                        exit = true;
                        break;
                    }
                }
                array[dest++] = array[cursor2++];
                if (--length2 === 0) {
                    exit = true;
                    break;
                }
                count2 = $97579a54749e4b24$var$gallopLeft(tmp[cursor1], array, cursor2, length2, 0, compare);
                if (count2 !== 0) {
                    for(i = 0; i < count2; i++)array[dest + i] = array[cursor2 + i];
                    dest += count2;
                    cursor2 += count2;
                    length2 -= count2;
                    if (length2 === 0) {
                        exit = true;
                        break;
                    }
                }
                array[dest++] = tmp[cursor1++];
                if (--length1 === 1) {
                    exit = true;
                    break;
                }
                _minGallop--;
            }while (count1 >= $97579a54749e4b24$var$DEFAULT_MIN_GALLOPING || count2 >= $97579a54749e4b24$var$DEFAULT_MIN_GALLOPING);
            if (exit) break;
            if (_minGallop < 0) _minGallop = 0;
            _minGallop += 2;
        }
        minGallop = _minGallop;
        minGallop < 1 && (minGallop = 1);
        if (length1 === 1) {
            for(i = 0; i < length2; i++)array[dest + i] = array[cursor2 + i];
            array[dest + length2] = tmp[cursor1];
        } else if (length1 === 0) throw new Error();
        else for(i = 0; i < length1; i++)array[dest + i] = tmp[cursor1 + i];
    }
    function mergeHigh(start1, length1, start2, length2) {
        var i = 0;
        for(i = 0; i < length2; i++)tmp[i] = array[start2 + i];
        var cursor1 = start1 + length1 - 1;
        var cursor2 = length2 - 1;
        var dest = start2 + length2 - 1;
        var customCursor = 0;
        var customDest = 0;
        array[dest--] = array[cursor1--];
        if (--length1 === 0) {
            customCursor = dest - (length2 - 1);
            for(i = 0; i < length2; i++)array[customCursor + i] = tmp[i];
            return;
        }
        if (length2 === 1) {
            dest -= length1;
            cursor1 -= length1;
            customDest = dest + 1;
            customCursor = cursor1 + 1;
            for(i = length1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
            array[dest] = tmp[cursor2];
            return;
        }
        var _minGallop = minGallop;
        while(true){
            var count1 = 0;
            var count2 = 0;
            var exit = false;
            do if (compare(tmp[cursor2], array[cursor1]) < 0) {
                array[dest--] = array[cursor1--];
                count1++;
                count2 = 0;
                if (--length1 === 0) {
                    exit = true;
                    break;
                }
            } else {
                array[dest--] = tmp[cursor2--];
                count2++;
                count1 = 0;
                if (--length2 === 1) {
                    exit = true;
                    break;
                }
            }
            while ((count1 | count2) < _minGallop);
            if (exit) break;
            do {
                count1 = length1 - $97579a54749e4b24$var$gallopRight(tmp[cursor2], array, start1, length1, length1 - 1, compare);
                if (count1 !== 0) {
                    dest -= count1;
                    cursor1 -= count1;
                    length1 -= count1;
                    customDest = dest + 1;
                    customCursor = cursor1 + 1;
                    for(i = count1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
                    if (length1 === 0) {
                        exit = true;
                        break;
                    }
                }
                array[dest--] = tmp[cursor2--];
                if (--length2 === 1) {
                    exit = true;
                    break;
                }
                count2 = length2 - $97579a54749e4b24$var$gallopLeft(array[cursor1], tmp, 0, length2, length2 - 1, compare);
                if (count2 !== 0) {
                    dest -= count2;
                    cursor2 -= count2;
                    length2 -= count2;
                    customDest = dest + 1;
                    customCursor = cursor2 + 1;
                    for(i = 0; i < count2; i++)array[customDest + i] = tmp[customCursor + i];
                    if (length2 <= 1) {
                        exit = true;
                        break;
                    }
                }
                array[dest--] = array[cursor1--];
                if (--length1 === 0) {
                    exit = true;
                    break;
                }
                _minGallop--;
            }while (count1 >= $97579a54749e4b24$var$DEFAULT_MIN_GALLOPING || count2 >= $97579a54749e4b24$var$DEFAULT_MIN_GALLOPING);
            if (exit) break;
            if (_minGallop < 0) _minGallop = 0;
            _minGallop += 2;
        }
        minGallop = _minGallop;
        if (minGallop < 1) minGallop = 1;
        if (length2 === 1) {
            dest -= length1;
            cursor1 -= length1;
            customDest = dest + 1;
            customCursor = cursor1 + 1;
            for(i = length1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
            array[dest] = tmp[cursor2];
        } else if (length2 === 0) throw new Error();
        else {
            customCursor = dest - (length2 - 1);
            for(i = 0; i < length2; i++)array[customCursor + i] = tmp[i];
        }
    }
    return {
        mergeRuns: mergeRuns,
        forceMergeRuns: forceMergeRuns,
        pushRun: pushRun
    };
}
function $97579a54749e4b24$export$2e2bcd8739ae039(array, compare, lo, hi) {
    if (!lo) lo = 0;
    if (!hi) hi = array.length;
    var remaining = hi - lo;
    if (remaining < 2) return;
    var runLength = 0;
    if (remaining < $97579a54749e4b24$var$DEFAULT_MIN_MERGE) {
        runLength = $97579a54749e4b24$var$makeAscendingRun(array, lo, hi, compare);
        $97579a54749e4b24$var$binaryInsertionSort(array, lo, hi, lo + runLength, compare);
        return;
    }
    var ts = $97579a54749e4b24$var$TimSort(array, compare);
    var minRun = $97579a54749e4b24$var$minRunLength(remaining);
    do {
        runLength = $97579a54749e4b24$var$makeAscendingRun(array, lo, hi, compare);
        if (runLength < minRun) {
            var force = remaining;
            if (force > minRun) force = minRun;
            $97579a54749e4b24$var$binaryInsertionSort(array, lo, lo + force, lo + runLength, compare);
            runLength = force;
        }
        ts.pushRun(lo, runLength);
        ts.mergeRuns();
        remaining -= runLength;
        lo += runLength;
    }while (remaining !== 0);
    ts.forceMergeRuns();
}


var $ddf76b16f1246ba9$export$a7b6db622c6c7dbd = 1;
var $ddf76b16f1246ba9$export$ada8b2beb3d76671 = 2;
var $ddf76b16f1246ba9$export$f75fe89a33ebe115 = 4;


var $319574df0bc66e80$var$invalidZErrorLogged = false;
function $319574df0bc66e80$var$logInvalidZError() {
    if ($319574df0bc66e80$var$invalidZErrorLogged) return;
    $319574df0bc66e80$var$invalidZErrorLogged = true;
    console.warn('z / z2 / zlevel of displayable is invalid, which may cause unexpected errors');
}
function $319574df0bc66e80$var$shapeCompareFunc(a, b) {
    if (a.zlevel === b.zlevel) {
        if (a.z === b.z) return a.z2 - b.z2;
        return a.z - b.z;
    }
    return a.zlevel - b.zlevel;
}
var $319574df0bc66e80$var$Storage = function() {
    function Storage() {
        this._roots = [];
        this._displayList = [];
        this._displayListLen = 0;
        this.displayableSortFunc = $319574df0bc66e80$var$shapeCompareFunc;
    }
    Storage.prototype.traverse = function(cb, context) {
        for(var i = 0; i < this._roots.length; i++)this._roots[i].traverse(cb, context);
    };
    Storage.prototype.getDisplayList = function(update, includeIgnore) {
        includeIgnore = includeIgnore || false;
        var displayList = this._displayList;
        if (update || !displayList.length) this.updateDisplayList(includeIgnore);
        return displayList;
    };
    Storage.prototype.updateDisplayList = function(includeIgnore) {
        this._displayListLen = 0;
        var roots = this._roots;
        var displayList = this._displayList;
        for(var i = 0, len = roots.length; i < len; i++)this._updateAndAddDisplayable(roots[i], null, includeIgnore);
        displayList.length = this._displayListLen;
        (0, $97579a54749e4b24$export$2e2bcd8739ae039)(displayList, $319574df0bc66e80$var$shapeCompareFunc);
    };
    Storage.prototype._updateAndAddDisplayable = function(el, clipPaths, includeIgnore) {
        if (el.ignore && !includeIgnore) return;
        el.beforeUpdate();
        el.update();
        el.afterUpdate();
        var userSetClipPath = el.getClipPath();
        if (el.ignoreClip) clipPaths = null;
        else if (userSetClipPath) {
            if (clipPaths) clipPaths = clipPaths.slice();
            else clipPaths = [];
            var currentClipPath = userSetClipPath;
            var parentClipPath = el;
            while(currentClipPath){
                currentClipPath.parent = parentClipPath;
                currentClipPath.updateTransform();
                clipPaths.push(currentClipPath);
                parentClipPath = currentClipPath;
                currentClipPath = currentClipPath.getClipPath();
            }
        }
        if (el.childrenRef) {
            var children = el.childrenRef();
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                if (el.__dirty) child.__dirty |= (0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd);
                this._updateAndAddDisplayable(child, clipPaths, includeIgnore);
            }
            el.__dirty = 0;
        } else {
            var disp = el;
            if (clipPaths && clipPaths.length) disp.__clipPaths = clipPaths;
            else if (disp.__clipPaths && disp.__clipPaths.length > 0) disp.__clipPaths = [];
            if (isNaN(disp.z)) {
                $319574df0bc66e80$var$logInvalidZError();
                disp.z = 0;
            }
            if (isNaN(disp.z2)) {
                $319574df0bc66e80$var$logInvalidZError();
                disp.z2 = 0;
            }
            if (isNaN(disp.zlevel)) {
                $319574df0bc66e80$var$logInvalidZError();
                disp.zlevel = 0;
            }
            this._displayList[this._displayListLen++] = disp;
        }
        var decalEl = el.getDecalElement && el.getDecalElement();
        if (decalEl) this._updateAndAddDisplayable(decalEl, clipPaths, includeIgnore);
        var textGuide = el.getTextGuideLine();
        if (textGuide) this._updateAndAddDisplayable(textGuide, clipPaths, includeIgnore);
        var textEl = el.getTextContent();
        if (textEl) this._updateAndAddDisplayable(textEl, clipPaths, includeIgnore);
    };
    Storage.prototype.addRoot = function(el) {
        if (el.__zr && el.__zr.storage === this) return;
        this._roots.push(el);
    };
    Storage.prototype.delRoot = function(el) {
        if (el instanceof Array) {
            for(var i = 0, l = el.length; i < l; i++)this.delRoot(el[i]);
            return;
        }
        var idx = $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(this._roots, el);
        if (idx >= 0) this._roots.splice(idx, 1);
    };
    Storage.prototype.delAllRoots = function() {
        this._roots = [];
        this._displayList = [];
        this._displayListLen = 0;
        return;
    };
    Storage.prototype.getRoots = function() {
        return this._roots;
    };
    Storage.prototype.dispose = function() {
        this._displayList = null;
        this._roots = null;
    };
    return Storage;
}();
var $319574df0bc66e80$export$2e2bcd8739ae039 = $319574df0bc66e80$var$Storage;





var $731d42ad1858cd4c$var$requestAnimationFrame;
$731d42ad1858cd4c$var$requestAnimationFrame = (0, $ce6dd58693a21851$export$2e2bcd8739ae039).hasGlobalWindow && (window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.msRequestAnimationFrame && window.msRequestAnimationFrame.bind(window) || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame) || function(func) {
    return setTimeout(func, 16);
};
var $731d42ad1858cd4c$export$2e2bcd8739ae039 = $731d42ad1858cd4c$var$requestAnimationFrame;


var $9668111025b0b56f$var$easingFuncs = {
    linear: function(k) {
        return k;
    },
    quadraticIn: function(k) {
        return k * k;
    },
    quadraticOut: function(k) {
        return k * (2 - k);
    },
    quadraticInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k;
        return -0.5 * (--k * (k - 2) - 1);
    },
    cubicIn: function(k) {
        return k * k * k;
    },
    cubicOut: function(k) {
        return --k * k * k + 1;
    },
    cubicInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k;
        return 0.5 * ((k -= 2) * k * k + 2);
    },
    quarticIn: function(k) {
        return k * k * k * k;
    },
    quarticOut: function(k) {
        return 1 - --k * k * k * k;
    },
    quarticInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k * k;
        return -0.5 * ((k -= 2) * k * k * k - 2);
    },
    quinticIn: function(k) {
        return k * k * k * k * k;
    },
    quinticOut: function(k) {
        return --k * k * k * k * k + 1;
    },
    quinticInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k * k * k;
        return 0.5 * ((k -= 2) * k * k * k * k + 2);
    },
    sinusoidalIn: function(k) {
        return 1 - Math.cos(k * Math.PI / 2);
    },
    sinusoidalOut: function(k) {
        return Math.sin(k * Math.PI / 2);
    },
    sinusoidalInOut: function(k) {
        return 0.5 * (1 - Math.cos(Math.PI * k));
    },
    exponentialIn: function(k) {
        return k === 0 ? 0 : Math.pow(1024, k - 1);
    },
    exponentialOut: function(k) {
        return k === 1 ? 1 : 1 - Math.pow(2, -10 * k);
    },
    exponentialInOut: function(k) {
        if (k === 0) return 0;
        if (k === 1) return 1;
        if ((k *= 2) < 1) return 0.5 * Math.pow(1024, k - 1);
        return 0.5 * (-Math.pow(2, -10 * (k - 1)) + 2);
    },
    circularIn: function(k) {
        return 1 - Math.sqrt(1 - k * k);
    },
    circularOut: function(k) {
        return Math.sqrt(1 - --k * k);
    },
    circularInOut: function(k) {
        if ((k *= 2) < 1) return -0.5 * (Math.sqrt(1 - k * k) - 1);
        return 0.5 * (Math.sqrt(1 - (k -= 2) * k) + 1);
    },
    elasticIn: function(k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) return 0;
        if (k === 1) return 1;
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        } else s = p * Math.asin(1 / a) / (2 * Math.PI);
        return -(a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
    },
    elasticOut: function(k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) return 0;
        if (k === 1) return 1;
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        } else s = p * Math.asin(1 / a) / (2 * Math.PI);
        return a * Math.pow(2, -10 * k) * Math.sin((k - s) * (2 * Math.PI) / p) + 1;
    },
    elasticInOut: function(k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) return 0;
        if (k === 1) return 1;
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        } else s = p * Math.asin(1 / a) / (2 * Math.PI);
        if ((k *= 2) < 1) return -0.5 * (a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
        return a * Math.pow(2, -10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p) * 0.5 + 1;
    },
    backIn: function(k) {
        var s = 1.70158;
        return k * k * ((s + 1) * k - s);
    },
    backOut: function(k) {
        var s = 1.70158;
        return --k * k * ((s + 1) * k + s) + 1;
    },
    backInOut: function(k) {
        var s = 2.5949095;
        if ((k *= 2) < 1) return 0.5 * (k * k * ((s + 1) * k - s));
        return 0.5 * ((k -= 2) * k * ((s + 1) * k + s) + 2);
    },
    bounceIn: function(k) {
        return 1 - $9668111025b0b56f$var$easingFuncs.bounceOut(1 - k);
    },
    bounceOut: function(k) {
        if (k < 1 / 2.75) return 7.5625 * k * k;
        else if (k < 2 / 2.75) return 7.5625 * (k -= 1.5 / 2.75) * k + 0.75;
        else if (k < 2.5 / 2.75) return 7.5625 * (k -= 2.25 / 2.75) * k + 0.9375;
        else return 7.5625 * (k -= 2.625 / 2.75) * k + 0.984375;
    },
    bounceInOut: function(k) {
        if (k < 0.5) return $9668111025b0b56f$var$easingFuncs.bounceIn(k * 2) * 0.5;
        return $9668111025b0b56f$var$easingFuncs.bounceOut(k * 2 - 1) * 0.5 + 0.5;
    }
};
var $9668111025b0b56f$export$2e2bcd8739ae039 = $9668111025b0b56f$var$easingFuncs;




var $747cfc5611b57cea$var$mathPow = Math.pow;
var $747cfc5611b57cea$var$mathSqrt = Math.sqrt;
var $747cfc5611b57cea$var$EPSILON = 1e-8;
var $747cfc5611b57cea$var$EPSILON_NUMERIC = 1e-4;
var $747cfc5611b57cea$var$THREE_SQRT = $747cfc5611b57cea$var$mathSqrt(3);
var $747cfc5611b57cea$var$ONE_THIRD = 1 / 3;
var $747cfc5611b57cea$var$_v0 = (0, $6de594cf8ac295ff$export$185802fd694ee1f5)();
var $747cfc5611b57cea$var$_v1 = (0, $6de594cf8ac295ff$export$185802fd694ee1f5)();
var $747cfc5611b57cea$var$_v2 = (0, $6de594cf8ac295ff$export$185802fd694ee1f5)();
function $747cfc5611b57cea$var$isAroundZero(val) {
    return val > -$747cfc5611b57cea$var$EPSILON && val < $747cfc5611b57cea$var$EPSILON;
}
function $747cfc5611b57cea$var$isNotAroundZero(val) {
    return val > $747cfc5611b57cea$var$EPSILON || val < -$747cfc5611b57cea$var$EPSILON;
}
function $747cfc5611b57cea$export$547c21de482bbcb2(p0, p1, p2, p3, t) {
    var onet = 1 - t;
    return onet * onet * (onet * p0 + 3 * t * p1) + t * t * (t * p3 + 3 * onet * p2);
}
function $747cfc5611b57cea$export$55fce925c60b6271(p0, p1, p2, p3, t) {
    var onet = 1 - t;
    return 3 * (((p1 - p0) * onet + 2 * (p2 - p1) * t) * onet + (p3 - p2) * t * t);
}
function $747cfc5611b57cea$export$ca5d13faa10b167e(p0, p1, p2, p3, val, roots) {
    var a = p3 + 3 * (p1 - p2) - p0;
    var b = 3 * (p2 - p1 * 2 + p0);
    var c = 3 * (p1 - p0);
    var d = p0 - val;
    var A = b * b - 3 * a * c;
    var B = b * c - 9 * a * d;
    var C = c * c - 3 * b * d;
    var n = 0;
    if ($747cfc5611b57cea$var$isAroundZero(A) && $747cfc5611b57cea$var$isAroundZero(B)) {
        if ($747cfc5611b57cea$var$isAroundZero(b)) roots[0] = 0;
        else {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        }
    } else {
        var disc = B * B - 4 * A * C;
        if ($747cfc5611b57cea$var$isAroundZero(disc)) {
            var K = B / A;
            var t1 = -b / a + K;
            var t2 = -K / 2;
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
        } else if (disc > 0) {
            var discSqrt = $747cfc5611b57cea$var$mathSqrt(disc);
            var Y1 = A * b + 1.5 * a * (-B + discSqrt);
            var Y2 = A * b + 1.5 * a * (-B - discSqrt);
            if (Y1 < 0) Y1 = -$747cfc5611b57cea$var$mathPow(-Y1, $747cfc5611b57cea$var$ONE_THIRD);
            else Y1 = $747cfc5611b57cea$var$mathPow(Y1, $747cfc5611b57cea$var$ONE_THIRD);
            if (Y2 < 0) Y2 = -$747cfc5611b57cea$var$mathPow(-Y2, $747cfc5611b57cea$var$ONE_THIRD);
            else Y2 = $747cfc5611b57cea$var$mathPow(Y2, $747cfc5611b57cea$var$ONE_THIRD);
            var t1 = (-b - (Y1 + Y2)) / (3 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        } else {
            var T = (2 * A * b - 3 * a * B) / (2 * $747cfc5611b57cea$var$mathSqrt(A * A * A));
            var theta = Math.acos(T) / 3;
            var ASqrt = $747cfc5611b57cea$var$mathSqrt(A);
            var tmp = Math.cos(theta);
            var t1 = (-b - 2 * ASqrt * tmp) / (3 * a);
            var t2 = (-b + ASqrt * (tmp + $747cfc5611b57cea$var$THREE_SQRT * Math.sin(theta))) / (3 * a);
            var t3 = (-b + ASqrt * (tmp - $747cfc5611b57cea$var$THREE_SQRT * Math.sin(theta))) / (3 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
            if (t3 >= 0 && t3 <= 1) roots[n++] = t3;
        }
    }
    return n;
}
function $747cfc5611b57cea$export$df1a172f100d0457(p0, p1, p2, p3, extrema) {
    var b = 6 * p2 - 12 * p1 + 6 * p0;
    var a = 9 * p1 + 3 * p3 - 3 * p0 - 9 * p2;
    var c = 3 * p1 - 3 * p0;
    var n = 0;
    if ($747cfc5611b57cea$var$isAroundZero(a)) {
        if ($747cfc5611b57cea$var$isNotAroundZero(b)) {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) extrema[n++] = t1;
        }
    } else {
        var disc = b * b - 4 * a * c;
        if ($747cfc5611b57cea$var$isAroundZero(disc)) extrema[0] = -b / (2 * a);
        else if (disc > 0) {
            var discSqrt = $747cfc5611b57cea$var$mathSqrt(disc);
            var t1 = (-b + discSqrt) / (2 * a);
            var t2 = (-b - discSqrt) / (2 * a);
            if (t1 >= 0 && t1 <= 1) extrema[n++] = t1;
            if (t2 >= 0 && t2 <= 1) extrema[n++] = t2;
        }
    }
    return n;
}
function $747cfc5611b57cea$export$a2ee23a0567039da(p0, p1, p2, p3, t, out) {
    var p01 = (p1 - p0) * t + p0;
    var p12 = (p2 - p1) * t + p1;
    var p23 = (p3 - p2) * t + p2;
    var p012 = (p12 - p01) * t + p01;
    var p123 = (p23 - p12) * t + p12;
    var p0123 = (p123 - p012) * t + p012;
    out[0] = p0;
    out[1] = p01;
    out[2] = p012;
    out[3] = p0123;
    out[4] = p0123;
    out[5] = p123;
    out[6] = p23;
    out[7] = p3;
}
function $747cfc5611b57cea$export$dbaa3801d1284367(x0, y0, x1, y1, x2, y2, x3, y3, x, y, out) {
    var t;
    var interval = 0.005;
    var d = Infinity;
    var prev;
    var next;
    var d1;
    var d2;
    $747cfc5611b57cea$var$_v0[0] = x;
    $747cfc5611b57cea$var$_v0[1] = y;
    for(var _t = 0; _t < 1; _t += 0.05){
        $747cfc5611b57cea$var$_v1[0] = $747cfc5611b57cea$export$547c21de482bbcb2(x0, x1, x2, x3, _t);
        $747cfc5611b57cea$var$_v1[1] = $747cfc5611b57cea$export$547c21de482bbcb2(y0, y1, y2, y3, _t);
        d1 = (0, $6de594cf8ac295ff$export$c68db45a034c13b0)($747cfc5611b57cea$var$_v0, $747cfc5611b57cea$var$_v1);
        if (d1 < d) {
            t = _t;
            d = d1;
        }
    }
    d = Infinity;
    for(var i = 0; i < 32; i++){
        if (interval < $747cfc5611b57cea$var$EPSILON_NUMERIC) break;
        prev = t - interval;
        next = t + interval;
        $747cfc5611b57cea$var$_v1[0] = $747cfc5611b57cea$export$547c21de482bbcb2(x0, x1, x2, x3, prev);
        $747cfc5611b57cea$var$_v1[1] = $747cfc5611b57cea$export$547c21de482bbcb2(y0, y1, y2, y3, prev);
        d1 = (0, $6de594cf8ac295ff$export$c68db45a034c13b0)($747cfc5611b57cea$var$_v1, $747cfc5611b57cea$var$_v0);
        if (prev >= 0 && d1 < d) {
            t = prev;
            d = d1;
        } else {
            $747cfc5611b57cea$var$_v2[0] = $747cfc5611b57cea$export$547c21de482bbcb2(x0, x1, x2, x3, next);
            $747cfc5611b57cea$var$_v2[1] = $747cfc5611b57cea$export$547c21de482bbcb2(y0, y1, y2, y3, next);
            d2 = (0, $6de594cf8ac295ff$export$c68db45a034c13b0)($747cfc5611b57cea$var$_v2, $747cfc5611b57cea$var$_v0);
            if (next <= 1 && d2 < d) {
                t = next;
                d = d2;
            } else interval *= 0.5;
        }
    }
    if (out) {
        out[0] = $747cfc5611b57cea$export$547c21de482bbcb2(x0, x1, x2, x3, t);
        out[1] = $747cfc5611b57cea$export$547c21de482bbcb2(y0, y1, y2, y3, t);
    }
    return $747cfc5611b57cea$var$mathSqrt(d);
}
function $747cfc5611b57cea$export$af1875d576f60d7c(x0, y0, x1, y1, x2, y2, x3, y3, iteration) {
    var px = x0;
    var py = y0;
    var d = 0;
    var step = 1 / iteration;
    for(var i = 1; i <= iteration; i++){
        var t = i * step;
        var x = $747cfc5611b57cea$export$547c21de482bbcb2(x0, x1, x2, x3, t);
        var y = $747cfc5611b57cea$export$547c21de482bbcb2(y0, y1, y2, y3, t);
        var dx = x - px;
        var dy = y - py;
        d += Math.sqrt(dx * dx + dy * dy);
        px = x;
        py = y;
    }
    return d;
}
function $747cfc5611b57cea$export$af17094a950f5073(p0, p1, p2, t) {
    var onet = 1 - t;
    return onet * (onet * p0 + 2 * t * p1) + t * t * p2;
}
function $747cfc5611b57cea$export$7e161e77e6fff8cb(p0, p1, p2, t) {
    return 2 * ((1 - t) * (p1 - p0) + t * (p2 - p1));
}
function $747cfc5611b57cea$export$fd895ac7ee764967(p0, p1, p2, val, roots) {
    var a = p0 - 2 * p1 + p2;
    var b = 2 * (p1 - p0);
    var c = p0 - val;
    var n = 0;
    if ($747cfc5611b57cea$var$isAroundZero(a)) {
        if ($747cfc5611b57cea$var$isNotAroundZero(b)) {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        }
    } else {
        var disc = b * b - 4 * a * c;
        if ($747cfc5611b57cea$var$isAroundZero(disc)) {
            var t1 = -b / (2 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        } else if (disc > 0) {
            var discSqrt = $747cfc5611b57cea$var$mathSqrt(disc);
            var t1 = (-b + discSqrt) / (2 * a);
            var t2 = (-b - discSqrt) / (2 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
        }
    }
    return n;
}
function $747cfc5611b57cea$export$752e1f8c6e7f7e11(p0, p1, p2) {
    var divider = p0 + p2 - 2 * p1;
    if (divider === 0) return 0.5;
    else return (p0 - p1) / divider;
}
function $747cfc5611b57cea$export$117c659e21a7a060(p0, p1, p2, t, out) {
    var p01 = (p1 - p0) * t + p0;
    var p12 = (p2 - p1) * t + p1;
    var p012 = (p12 - p01) * t + p01;
    out[0] = p0;
    out[1] = p01;
    out[2] = p012;
    out[3] = p012;
    out[4] = p12;
    out[5] = p2;
}
function $747cfc5611b57cea$export$81915a594fe10dee(x0, y0, x1, y1, x2, y2, x, y, out) {
    var t;
    var interval = 0.005;
    var d = Infinity;
    $747cfc5611b57cea$var$_v0[0] = x;
    $747cfc5611b57cea$var$_v0[1] = y;
    for(var _t = 0; _t < 1; _t += 0.05){
        $747cfc5611b57cea$var$_v1[0] = $747cfc5611b57cea$export$af17094a950f5073(x0, x1, x2, _t);
        $747cfc5611b57cea$var$_v1[1] = $747cfc5611b57cea$export$af17094a950f5073(y0, y1, y2, _t);
        var d1 = (0, $6de594cf8ac295ff$export$c68db45a034c13b0)($747cfc5611b57cea$var$_v0, $747cfc5611b57cea$var$_v1);
        if (d1 < d) {
            t = _t;
            d = d1;
        }
    }
    d = Infinity;
    for(var i = 0; i < 32; i++){
        if (interval < $747cfc5611b57cea$var$EPSILON_NUMERIC) break;
        var prev = t - interval;
        var next = t + interval;
        $747cfc5611b57cea$var$_v1[0] = $747cfc5611b57cea$export$af17094a950f5073(x0, x1, x2, prev);
        $747cfc5611b57cea$var$_v1[1] = $747cfc5611b57cea$export$af17094a950f5073(y0, y1, y2, prev);
        var d1 = (0, $6de594cf8ac295ff$export$c68db45a034c13b0)($747cfc5611b57cea$var$_v1, $747cfc5611b57cea$var$_v0);
        if (prev >= 0 && d1 < d) {
            t = prev;
            d = d1;
        } else {
            $747cfc5611b57cea$var$_v2[0] = $747cfc5611b57cea$export$af17094a950f5073(x0, x1, x2, next);
            $747cfc5611b57cea$var$_v2[1] = $747cfc5611b57cea$export$af17094a950f5073(y0, y1, y2, next);
            var d2 = (0, $6de594cf8ac295ff$export$c68db45a034c13b0)($747cfc5611b57cea$var$_v2, $747cfc5611b57cea$var$_v0);
            if (next <= 1 && d2 < d) {
                t = next;
                d = d2;
            } else interval *= 0.5;
        }
    }
    if (out) {
        out[0] = $747cfc5611b57cea$export$af17094a950f5073(x0, x1, x2, t);
        out[1] = $747cfc5611b57cea$export$af17094a950f5073(y0, y1, y2, t);
    }
    return $747cfc5611b57cea$var$mathSqrt(d);
}
function $747cfc5611b57cea$export$8a68adee46f3cf55(x0, y0, x1, y1, x2, y2, iteration) {
    var px = x0;
    var py = y0;
    var d = 0;
    var step = 1 / iteration;
    for(var i = 1; i <= iteration; i++){
        var t = i * step;
        var x = $747cfc5611b57cea$export$af17094a950f5073(x0, x1, x2, t);
        var y = $747cfc5611b57cea$export$af17094a950f5073(y0, y1, y2, t);
        var dx = x - px;
        var dy = y - py;
        d += Math.sqrt(dx * dx + dy * dy);
        px = x;
        py = y;
    }
    return d;
}



var $0aea98bda0b4be1f$var$regexp = /cubic-bezier\(([0-9,\.e ]+)\)/;
function $0aea98bda0b4be1f$export$ec0863d806fd857e(cubicEasingStr) {
    var cubic = cubicEasingStr && $0aea98bda0b4be1f$var$regexp.exec(cubicEasingStr);
    if (cubic) {
        var points = cubic[1].split(',');
        var a_1 = +(0, $7a1bd9c2710fea0d$export$87c2784dc9fc4ab)(points[0]);
        var b_1 = +(0, $7a1bd9c2710fea0d$export$87c2784dc9fc4ab)(points[1]);
        var c_1 = +(0, $7a1bd9c2710fea0d$export$87c2784dc9fc4ab)(points[2]);
        var d_1 = +(0, $7a1bd9c2710fea0d$export$87c2784dc9fc4ab)(points[3]);
        if (isNaN(a_1 + b_1 + c_1 + d_1)) return;
        var roots_1 = [];
        return function(p) {
            return p <= 0 ? 0 : p >= 1 ? 1 : (0, $747cfc5611b57cea$export$ca5d13faa10b167e)(0, a_1, c_1, 1, p, roots_1) && (0, $747cfc5611b57cea$export$547c21de482bbcb2)(0, b_1, d_1, 1, roots_1[0]);
        };
    }
}


var $00f1e1cb3568b9c5$var$Clip = function() {
    function Clip(opts) {
        this._inited = false;
        this._startTime = 0;
        this._pausedTime = 0;
        this._paused = false;
        this._life = opts.life || 1000;
        this._delay = opts.delay || 0;
        this.loop = opts.loop || false;
        this.onframe = opts.onframe || (0, $7a1bd9c2710fea0d$export$8793edee2d425525);
        this.ondestroy = opts.ondestroy || (0, $7a1bd9c2710fea0d$export$8793edee2d425525);
        this.onrestart = opts.onrestart || (0, $7a1bd9c2710fea0d$export$8793edee2d425525);
        opts.easing && this.setEasing(opts.easing);
    }
    Clip.prototype.step = function(globalTime, deltaTime) {
        if (!this._inited) {
            this._startTime = globalTime + this._delay;
            this._inited = true;
        }
        if (this._paused) {
            this._pausedTime += deltaTime;
            return;
        }
        var life = this._life;
        var elapsedTime = globalTime - this._startTime - this._pausedTime;
        var percent = elapsedTime / life;
        if (percent < 0) percent = 0;
        percent = Math.min(percent, 1);
        var easingFunc = this.easingFunc;
        var schedule = easingFunc ? easingFunc(percent) : percent;
        this.onframe(schedule);
        if (percent === 1) {
            if (this.loop) {
                var remainder = elapsedTime % life;
                this._startTime = globalTime - remainder;
                this._pausedTime = 0;
                this.onrestart();
            } else return true;
        }
        return false;
    };
    Clip.prototype.pause = function() {
        this._paused = true;
    };
    Clip.prototype.resume = function() {
        this._paused = false;
    };
    Clip.prototype.setEasing = function(easing) {
        this.easing = easing;
        this.easingFunc = (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(easing) ? easing : (0, $9668111025b0b56f$export$2e2bcd8739ae039)[easing] || (0, $0aea98bda0b4be1f$export$ec0863d806fd857e)(easing);
    };
    return Clip;
}();
var $00f1e1cb3568b9c5$export$2e2bcd8739ae039 = $00f1e1cb3568b9c5$var$Clip;


var $d91b0b6fc564d9c7$export$3bb977b3ba9d3b59 = function() {
    function Entry(val) {
        this.value = val;
    }
    return Entry;
}();
var $d91b0b6fc564d9c7$export$f0ef28713f767754 = function() {
    function LinkedList() {
        this._len = 0;
    }
    LinkedList.prototype.insert = function(val) {
        var entry = new $d91b0b6fc564d9c7$export$3bb977b3ba9d3b59(val);
        this.insertEntry(entry);
        return entry;
    };
    LinkedList.prototype.insertEntry = function(entry) {
        if (!this.head) this.head = this.tail = entry;
        else {
            this.tail.next = entry;
            entry.prev = this.tail;
            entry.next = null;
            this.tail = entry;
        }
        this._len++;
    };
    LinkedList.prototype.remove = function(entry) {
        var prev = entry.prev;
        var next = entry.next;
        if (prev) prev.next = next;
        else this.head = next;
        if (next) next.prev = prev;
        else this.tail = prev;
        entry.next = entry.prev = null;
        this._len--;
    };
    LinkedList.prototype.len = function() {
        return this._len;
    };
    LinkedList.prototype.clear = function() {
        this.head = this.tail = null;
        this._len = 0;
    };
    return LinkedList;
}();
var $d91b0b6fc564d9c7$var$LRU = function() {
    function LRU(maxSize) {
        this._list = new $d91b0b6fc564d9c7$export$f0ef28713f767754();
        this._maxSize = 10;
        this._map = {};
        this._maxSize = maxSize;
    }
    LRU.prototype.put = function(key, value) {
        var list = this._list;
        var map = this._map;
        var removed = null;
        if (map[key] == null) {
            var len = list.len();
            var entry = this._lastRemovedEntry;
            if (len >= this._maxSize && len > 0) {
                var leastUsedEntry = list.head;
                list.remove(leastUsedEntry);
                delete map[leastUsedEntry.key];
                removed = leastUsedEntry.value;
                this._lastRemovedEntry = leastUsedEntry;
            }
            if (entry) entry.value = value;
            else entry = new $d91b0b6fc564d9c7$export$3bb977b3ba9d3b59(value);
            entry.key = key;
            list.insertEntry(entry);
            map[key] = entry;
        }
        return removed;
    };
    LRU.prototype.get = function(key) {
        var entry = this._map[key];
        var list = this._list;
        if (entry != null) {
            if (entry !== list.tail) {
                list.remove(entry);
                list.insertEntry(entry);
            }
            return entry.value;
        }
    };
    LRU.prototype.clear = function() {
        this._list.clear();
        this._map = {};
    };
    LRU.prototype.len = function() {
        return this._list.len();
    };
    return LRU;
}();
var $d91b0b6fc564d9c7$export$2e2bcd8739ae039 = $d91b0b6fc564d9c7$var$LRU;



var $2c037f5bda6341ca$var$kCSSColorTable = {
    'transparent': [
        0,
        0,
        0,
        0
    ],
    'aliceblue': [
        240,
        248,
        255,
        1
    ],
    'antiquewhite': [
        250,
        235,
        215,
        1
    ],
    'aqua': [
        0,
        255,
        255,
        1
    ],
    'aquamarine': [
        127,
        255,
        212,
        1
    ],
    'azure': [
        240,
        255,
        255,
        1
    ],
    'beige': [
        245,
        245,
        220,
        1
    ],
    'bisque': [
        255,
        228,
        196,
        1
    ],
    'black': [
        0,
        0,
        0,
        1
    ],
    'blanchedalmond': [
        255,
        235,
        205,
        1
    ],
    'blue': [
        0,
        0,
        255,
        1
    ],
    'blueviolet': [
        138,
        43,
        226,
        1
    ],
    'brown': [
        165,
        42,
        42,
        1
    ],
    'burlywood': [
        222,
        184,
        135,
        1
    ],
    'cadetblue': [
        95,
        158,
        160,
        1
    ],
    'chartreuse': [
        127,
        255,
        0,
        1
    ],
    'chocolate': [
        210,
        105,
        30,
        1
    ],
    'coral': [
        255,
        127,
        80,
        1
    ],
    'cornflowerblue': [
        100,
        149,
        237,
        1
    ],
    'cornsilk': [
        255,
        248,
        220,
        1
    ],
    'crimson': [
        220,
        20,
        60,
        1
    ],
    'cyan': [
        0,
        255,
        255,
        1
    ],
    'darkblue': [
        0,
        0,
        139,
        1
    ],
    'darkcyan': [
        0,
        139,
        139,
        1
    ],
    'darkgoldenrod': [
        184,
        134,
        11,
        1
    ],
    'darkgray': [
        169,
        169,
        169,
        1
    ],
    'darkgreen': [
        0,
        100,
        0,
        1
    ],
    'darkgrey': [
        169,
        169,
        169,
        1
    ],
    'darkkhaki': [
        189,
        183,
        107,
        1
    ],
    'darkmagenta': [
        139,
        0,
        139,
        1
    ],
    'darkolivegreen': [
        85,
        107,
        47,
        1
    ],
    'darkorange': [
        255,
        140,
        0,
        1
    ],
    'darkorchid': [
        153,
        50,
        204,
        1
    ],
    'darkred': [
        139,
        0,
        0,
        1
    ],
    'darksalmon': [
        233,
        150,
        122,
        1
    ],
    'darkseagreen': [
        143,
        188,
        143,
        1
    ],
    'darkslateblue': [
        72,
        61,
        139,
        1
    ],
    'darkslategray': [
        47,
        79,
        79,
        1
    ],
    'darkslategrey': [
        47,
        79,
        79,
        1
    ],
    'darkturquoise': [
        0,
        206,
        209,
        1
    ],
    'darkviolet': [
        148,
        0,
        211,
        1
    ],
    'deeppink': [
        255,
        20,
        147,
        1
    ],
    'deepskyblue': [
        0,
        191,
        255,
        1
    ],
    'dimgray': [
        105,
        105,
        105,
        1
    ],
    'dimgrey': [
        105,
        105,
        105,
        1
    ],
    'dodgerblue': [
        30,
        144,
        255,
        1
    ],
    'firebrick': [
        178,
        34,
        34,
        1
    ],
    'floralwhite': [
        255,
        250,
        240,
        1
    ],
    'forestgreen': [
        34,
        139,
        34,
        1
    ],
    'fuchsia': [
        255,
        0,
        255,
        1
    ],
    'gainsboro': [
        220,
        220,
        220,
        1
    ],
    'ghostwhite': [
        248,
        248,
        255,
        1
    ],
    'gold': [
        255,
        215,
        0,
        1
    ],
    'goldenrod': [
        218,
        165,
        32,
        1
    ],
    'gray': [
        128,
        128,
        128,
        1
    ],
    'green': [
        0,
        128,
        0,
        1
    ],
    'greenyellow': [
        173,
        255,
        47,
        1
    ],
    'grey': [
        128,
        128,
        128,
        1
    ],
    'honeydew': [
        240,
        255,
        240,
        1
    ],
    'hotpink': [
        255,
        105,
        180,
        1
    ],
    'indianred': [
        205,
        92,
        92,
        1
    ],
    'indigo': [
        75,
        0,
        130,
        1
    ],
    'ivory': [
        255,
        255,
        240,
        1
    ],
    'khaki': [
        240,
        230,
        140,
        1
    ],
    'lavender': [
        230,
        230,
        250,
        1
    ],
    'lavenderblush': [
        255,
        240,
        245,
        1
    ],
    'lawngreen': [
        124,
        252,
        0,
        1
    ],
    'lemonchiffon': [
        255,
        250,
        205,
        1
    ],
    'lightblue': [
        173,
        216,
        230,
        1
    ],
    'lightcoral': [
        240,
        128,
        128,
        1
    ],
    'lightcyan': [
        224,
        255,
        255,
        1
    ],
    'lightgoldenrodyellow': [
        250,
        250,
        210,
        1
    ],
    'lightgray': [
        211,
        211,
        211,
        1
    ],
    'lightgreen': [
        144,
        238,
        144,
        1
    ],
    'lightgrey': [
        211,
        211,
        211,
        1
    ],
    'lightpink': [
        255,
        182,
        193,
        1
    ],
    'lightsalmon': [
        255,
        160,
        122,
        1
    ],
    'lightseagreen': [
        32,
        178,
        170,
        1
    ],
    'lightskyblue': [
        135,
        206,
        250,
        1
    ],
    'lightslategray': [
        119,
        136,
        153,
        1
    ],
    'lightslategrey': [
        119,
        136,
        153,
        1
    ],
    'lightsteelblue': [
        176,
        196,
        222,
        1
    ],
    'lightyellow': [
        255,
        255,
        224,
        1
    ],
    'lime': [
        0,
        255,
        0,
        1
    ],
    'limegreen': [
        50,
        205,
        50,
        1
    ],
    'linen': [
        250,
        240,
        230,
        1
    ],
    'magenta': [
        255,
        0,
        255,
        1
    ],
    'maroon': [
        128,
        0,
        0,
        1
    ],
    'mediumaquamarine': [
        102,
        205,
        170,
        1
    ],
    'mediumblue': [
        0,
        0,
        205,
        1
    ],
    'mediumorchid': [
        186,
        85,
        211,
        1
    ],
    'mediumpurple': [
        147,
        112,
        219,
        1
    ],
    'mediumseagreen': [
        60,
        179,
        113,
        1
    ],
    'mediumslateblue': [
        123,
        104,
        238,
        1
    ],
    'mediumspringgreen': [
        0,
        250,
        154,
        1
    ],
    'mediumturquoise': [
        72,
        209,
        204,
        1
    ],
    'mediumvioletred': [
        199,
        21,
        133,
        1
    ],
    'midnightblue': [
        25,
        25,
        112,
        1
    ],
    'mintcream': [
        245,
        255,
        250,
        1
    ],
    'mistyrose': [
        255,
        228,
        225,
        1
    ],
    'moccasin': [
        255,
        228,
        181,
        1
    ],
    'navajowhite': [
        255,
        222,
        173,
        1
    ],
    'navy': [
        0,
        0,
        128,
        1
    ],
    'oldlace': [
        253,
        245,
        230,
        1
    ],
    'olive': [
        128,
        128,
        0,
        1
    ],
    'olivedrab': [
        107,
        142,
        35,
        1
    ],
    'orange': [
        255,
        165,
        0,
        1
    ],
    'orangered': [
        255,
        69,
        0,
        1
    ],
    'orchid': [
        218,
        112,
        214,
        1
    ],
    'palegoldenrod': [
        238,
        232,
        170,
        1
    ],
    'palegreen': [
        152,
        251,
        152,
        1
    ],
    'paleturquoise': [
        175,
        238,
        238,
        1
    ],
    'palevioletred': [
        219,
        112,
        147,
        1
    ],
    'papayawhip': [
        255,
        239,
        213,
        1
    ],
    'peachpuff': [
        255,
        218,
        185,
        1
    ],
    'peru': [
        205,
        133,
        63,
        1
    ],
    'pink': [
        255,
        192,
        203,
        1
    ],
    'plum': [
        221,
        160,
        221,
        1
    ],
    'powderblue': [
        176,
        224,
        230,
        1
    ],
    'purple': [
        128,
        0,
        128,
        1
    ],
    'red': [
        255,
        0,
        0,
        1
    ],
    'rosybrown': [
        188,
        143,
        143,
        1
    ],
    'royalblue': [
        65,
        105,
        225,
        1
    ],
    'saddlebrown': [
        139,
        69,
        19,
        1
    ],
    'salmon': [
        250,
        128,
        114,
        1
    ],
    'sandybrown': [
        244,
        164,
        96,
        1
    ],
    'seagreen': [
        46,
        139,
        87,
        1
    ],
    'seashell': [
        255,
        245,
        238,
        1
    ],
    'sienna': [
        160,
        82,
        45,
        1
    ],
    'silver': [
        192,
        192,
        192,
        1
    ],
    'skyblue': [
        135,
        206,
        235,
        1
    ],
    'slateblue': [
        106,
        90,
        205,
        1
    ],
    'slategray': [
        112,
        128,
        144,
        1
    ],
    'slategrey': [
        112,
        128,
        144,
        1
    ],
    'snow': [
        255,
        250,
        250,
        1
    ],
    'springgreen': [
        0,
        255,
        127,
        1
    ],
    'steelblue': [
        70,
        130,
        180,
        1
    ],
    'tan': [
        210,
        180,
        140,
        1
    ],
    'teal': [
        0,
        128,
        128,
        1
    ],
    'thistle': [
        216,
        191,
        216,
        1
    ],
    'tomato': [
        255,
        99,
        71,
        1
    ],
    'turquoise': [
        64,
        224,
        208,
        1
    ],
    'violet': [
        238,
        130,
        238,
        1
    ],
    'wheat': [
        245,
        222,
        179,
        1
    ],
    'white': [
        255,
        255,
        255,
        1
    ],
    'whitesmoke': [
        245,
        245,
        245,
        1
    ],
    'yellow': [
        255,
        255,
        0,
        1
    ],
    'yellowgreen': [
        154,
        205,
        50,
        1
    ]
};
function $2c037f5bda6341ca$var$clampCssByte(i) {
    i = Math.round(i);
    return i < 0 ? 0 : i > 255 ? 255 : i;
}
function $2c037f5bda6341ca$var$clampCssAngle(i) {
    i = Math.round(i);
    return i < 0 ? 0 : i > 360 ? 360 : i;
}
function $2c037f5bda6341ca$var$clampCssFloat(f) {
    return f < 0 ? 0 : f > 1 ? 1 : f;
}
function $2c037f5bda6341ca$var$parseCssInt(val) {
    var str = val;
    if (str.length && str.charAt(str.length - 1) === '%') return $2c037f5bda6341ca$var$clampCssByte(parseFloat(str) / 100 * 255);
    return $2c037f5bda6341ca$var$clampCssByte(parseInt(str, 10));
}
function $2c037f5bda6341ca$var$parseCssFloat(val) {
    var str = val;
    if (str.length && str.charAt(str.length - 1) === '%') return $2c037f5bda6341ca$var$clampCssFloat(parseFloat(str) / 100);
    return $2c037f5bda6341ca$var$clampCssFloat(parseFloat(str));
}
function $2c037f5bda6341ca$var$cssHueToRgb(m1, m2, h) {
    if (h < 0) h += 1;
    else if (h > 1) h -= 1;
    if (h * 6 < 1) return m1 + (m2 - m1) * h * 6;
    if (h * 2 < 1) return m2;
    if (h * 3 < 2) return m1 + (m2 - m1) * (2 / 3 - h) * 6;
    return m1;
}
function $2c037f5bda6341ca$var$lerpNumber(a, b, p) {
    return a + (b - a) * p;
}
function $2c037f5bda6341ca$var$setRgba(out, r, g, b, a) {
    out[0] = r;
    out[1] = g;
    out[2] = b;
    out[3] = a;
    return out;
}
function $2c037f5bda6341ca$var$copyRgba(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
var $2c037f5bda6341ca$var$colorCache = new (0, $d91b0b6fc564d9c7$export$2e2bcd8739ae039)(20);
var $2c037f5bda6341ca$var$lastRemovedArr = null;
function $2c037f5bda6341ca$var$putToCache(colorStr, rgbaArr) {
    if ($2c037f5bda6341ca$var$lastRemovedArr) $2c037f5bda6341ca$var$copyRgba($2c037f5bda6341ca$var$lastRemovedArr, rgbaArr);
    $2c037f5bda6341ca$var$lastRemovedArr = $2c037f5bda6341ca$var$colorCache.put(colorStr, $2c037f5bda6341ca$var$lastRemovedArr || rgbaArr.slice());
}
function $2c037f5bda6341ca$export$98e6a39c04603d36(colorStr, rgbaArr) {
    if (!colorStr) return;
    rgbaArr = rgbaArr || [];
    var cached = $2c037f5bda6341ca$var$colorCache.get(colorStr);
    if (cached) return $2c037f5bda6341ca$var$copyRgba(rgbaArr, cached);
    colorStr = colorStr + '';
    var str = colorStr.replace(/ /g, '').toLowerCase();
    if (str in $2c037f5bda6341ca$var$kCSSColorTable) {
        $2c037f5bda6341ca$var$copyRgba(rgbaArr, $2c037f5bda6341ca$var$kCSSColorTable[str]);
        $2c037f5bda6341ca$var$putToCache(colorStr, rgbaArr);
        return rgbaArr;
    }
    var strLen = str.length;
    if (str.charAt(0) === '#') {
        if (strLen === 4 || strLen === 5) {
            var iv = parseInt(str.slice(1, 4), 16);
            if (!(iv >= 0 && iv <= 0xfff)) {
                $2c037f5bda6341ca$var$setRgba(rgbaArr, 0, 0, 0, 1);
                return;
            }
            $2c037f5bda6341ca$var$setRgba(rgbaArr, (iv & 0xf00) >> 4 | (iv & 0xf00) >> 8, iv & 0xf0 | (iv & 0xf0) >> 4, iv & 0xf | (iv & 0xf) << 4, strLen === 5 ? parseInt(str.slice(4), 16) / 0xf : 1);
            $2c037f5bda6341ca$var$putToCache(colorStr, rgbaArr);
            return rgbaArr;
        } else if (strLen === 7 || strLen === 9) {
            var iv = parseInt(str.slice(1, 7), 16);
            if (!(iv >= 0 && iv <= 0xffffff)) {
                $2c037f5bda6341ca$var$setRgba(rgbaArr, 0, 0, 0, 1);
                return;
            }
            $2c037f5bda6341ca$var$setRgba(rgbaArr, (iv & 0xff0000) >> 16, (iv & 0xff00) >> 8, iv & 0xff, strLen === 9 ? parseInt(str.slice(7), 16) / 0xff : 1);
            $2c037f5bda6341ca$var$putToCache(colorStr, rgbaArr);
            return rgbaArr;
        }
        return;
    }
    var op = str.indexOf('(');
    var ep = str.indexOf(')');
    if (op !== -1 && ep + 1 === strLen) {
        var fname = str.substr(0, op);
        var params = str.substr(op + 1, ep - (op + 1)).split(',');
        var alpha = 1;
        switch(fname){
            case 'rgba':
                if (params.length !== 4) return params.length === 3 ? $2c037f5bda6341ca$var$setRgba(rgbaArr, +params[0], +params[1], +params[2], 1) : $2c037f5bda6341ca$var$setRgba(rgbaArr, 0, 0, 0, 1);
                alpha = $2c037f5bda6341ca$var$parseCssFloat(params.pop());
            case 'rgb':
                if (params.length >= 3) {
                    $2c037f5bda6341ca$var$setRgba(rgbaArr, $2c037f5bda6341ca$var$parseCssInt(params[0]), $2c037f5bda6341ca$var$parseCssInt(params[1]), $2c037f5bda6341ca$var$parseCssInt(params[2]), params.length === 3 ? alpha : $2c037f5bda6341ca$var$parseCssFloat(params[3]));
                    $2c037f5bda6341ca$var$putToCache(colorStr, rgbaArr);
                    return rgbaArr;
                } else {
                    $2c037f5bda6341ca$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
            case 'hsla':
                if (params.length !== 4) {
                    $2c037f5bda6341ca$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                params[3] = $2c037f5bda6341ca$var$parseCssFloat(params[3]);
                $2c037f5bda6341ca$var$hsla2rgba(params, rgbaArr);
                $2c037f5bda6341ca$var$putToCache(colorStr, rgbaArr);
                return rgbaArr;
            case 'hsl':
                if (params.length !== 3) {
                    $2c037f5bda6341ca$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                $2c037f5bda6341ca$var$hsla2rgba(params, rgbaArr);
                $2c037f5bda6341ca$var$putToCache(colorStr, rgbaArr);
                return rgbaArr;
            default:
                return;
        }
    }
    $2c037f5bda6341ca$var$setRgba(rgbaArr, 0, 0, 0, 1);
    return;
}
function $2c037f5bda6341ca$var$hsla2rgba(hsla, rgba) {
    var h = (parseFloat(hsla[0]) % 360 + 360) % 360 / 360;
    var s = $2c037f5bda6341ca$var$parseCssFloat(hsla[1]);
    var l = $2c037f5bda6341ca$var$parseCssFloat(hsla[2]);
    var m2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
    var m1 = l * 2 - m2;
    rgba = rgba || [];
    $2c037f5bda6341ca$var$setRgba(rgba, $2c037f5bda6341ca$var$clampCssByte($2c037f5bda6341ca$var$cssHueToRgb(m1, m2, h + 1 / 3) * 255), $2c037f5bda6341ca$var$clampCssByte($2c037f5bda6341ca$var$cssHueToRgb(m1, m2, h) * 255), $2c037f5bda6341ca$var$clampCssByte($2c037f5bda6341ca$var$cssHueToRgb(m1, m2, h - 1 / 3) * 255), 1);
    if (hsla.length === 4) rgba[3] = hsla[3];
    return rgba;
}
function $2c037f5bda6341ca$var$rgba2hsla(rgba) {
    if (!rgba) return;
    var R = rgba[0] / 255;
    var G = rgba[1] / 255;
    var B = rgba[2] / 255;
    var vMin = Math.min(R, G, B);
    var vMax = Math.max(R, G, B);
    var delta = vMax - vMin;
    var L = (vMax + vMin) / 2;
    var H;
    var S;
    if (delta === 0) {
        H = 0;
        S = 0;
    } else {
        if (L < 0.5) S = delta / (vMax + vMin);
        else S = delta / (2 - vMax - vMin);
        var deltaR = ((vMax - R) / 6 + delta / 2) / delta;
        var deltaG = ((vMax - G) / 6 + delta / 2) / delta;
        var deltaB = ((vMax - B) / 6 + delta / 2) / delta;
        if (R === vMax) H = deltaB - deltaG;
        else if (G === vMax) H = 1 / 3 + deltaR - deltaB;
        else if (B === vMax) H = 2 / 3 + deltaG - deltaR;
        if (H < 0) H += 1;
        if (H > 1) H -= 1;
    }
    var hsla = [
        H * 360,
        S,
        L
    ];
    if (rgba[3] != null) hsla.push(rgba[3]);
    return hsla;
}
function $2c037f5bda6341ca$export$590e8b2c435046d9(color, level) {
    var colorArr = $2c037f5bda6341ca$export$98e6a39c04603d36(color);
    if (colorArr) {
        for(var i = 0; i < 3; i++){
            if (level < 0) colorArr[i] = colorArr[i] * (1 - level) | 0;
            else colorArr[i] = (255 - colorArr[i]) * level + colorArr[i] | 0;
            if (colorArr[i] > 255) colorArr[i] = 255;
            else if (colorArr[i] < 0) colorArr[i] = 0;
        }
        return $2c037f5bda6341ca$export$fac44ee5b035f737(colorArr, colorArr.length === 4 ? 'rgba' : 'rgb');
    }
}
function $2c037f5bda6341ca$export$7ea66e3774a60b67(color) {
    var colorArr = $2c037f5bda6341ca$export$98e6a39c04603d36(color);
    if (colorArr) return (16777216 + (colorArr[0] << 16) + (colorArr[1] << 8) + +colorArr[2]).toString(16).slice(1);
}
function $2c037f5bda6341ca$export$66cb3c0e9efc61c8(normalizedValue, colors, out) {
    if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) return;
    out = out || [];
    var value = normalizedValue * (colors.length - 1);
    var leftIndex = Math.floor(value);
    var rightIndex = Math.ceil(value);
    var leftColor = colors[leftIndex];
    var rightColor = colors[rightIndex];
    var dv = value - leftIndex;
    out[0] = $2c037f5bda6341ca$var$clampCssByte($2c037f5bda6341ca$var$lerpNumber(leftColor[0], rightColor[0], dv));
    out[1] = $2c037f5bda6341ca$var$clampCssByte($2c037f5bda6341ca$var$lerpNumber(leftColor[1], rightColor[1], dv));
    out[2] = $2c037f5bda6341ca$var$clampCssByte($2c037f5bda6341ca$var$lerpNumber(leftColor[2], rightColor[2], dv));
    out[3] = $2c037f5bda6341ca$var$clampCssFloat($2c037f5bda6341ca$var$lerpNumber(leftColor[3], rightColor[3], dv));
    return out;
}
var $2c037f5bda6341ca$export$daa5a65daad5df58 = $2c037f5bda6341ca$export$66cb3c0e9efc61c8;
function $2c037f5bda6341ca$export$3a89f8d6f6bf6c9f(normalizedValue, colors, fullOutput) {
    if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) return;
    var value = normalizedValue * (colors.length - 1);
    var leftIndex = Math.floor(value);
    var rightIndex = Math.ceil(value);
    var leftColor = $2c037f5bda6341ca$export$98e6a39c04603d36(colors[leftIndex]);
    var rightColor = $2c037f5bda6341ca$export$98e6a39c04603d36(colors[rightIndex]);
    var dv = value - leftIndex;
    var color = $2c037f5bda6341ca$export$fac44ee5b035f737([
        $2c037f5bda6341ca$var$clampCssByte($2c037f5bda6341ca$var$lerpNumber(leftColor[0], rightColor[0], dv)),
        $2c037f5bda6341ca$var$clampCssByte($2c037f5bda6341ca$var$lerpNumber(leftColor[1], rightColor[1], dv)),
        $2c037f5bda6341ca$var$clampCssByte($2c037f5bda6341ca$var$lerpNumber(leftColor[2], rightColor[2], dv)),
        $2c037f5bda6341ca$var$clampCssFloat($2c037f5bda6341ca$var$lerpNumber(leftColor[3], rightColor[3], dv))
    ], 'rgba');
    return fullOutput ? {
        color: color,
        leftIndex: leftIndex,
        rightIndex: rightIndex,
        value: value
    } : color;
}
var $2c037f5bda6341ca$export$296e08242b78a3ec = $2c037f5bda6341ca$export$3a89f8d6f6bf6c9f;
function $2c037f5bda6341ca$export$d898ae866e27bf18(color, h, s, l) {
    var colorArr = $2c037f5bda6341ca$export$98e6a39c04603d36(color);
    if (color) {
        colorArr = $2c037f5bda6341ca$var$rgba2hsla(colorArr);
        h != null && (colorArr[0] = $2c037f5bda6341ca$var$clampCssAngle(h));
        s != null && (colorArr[1] = $2c037f5bda6341ca$var$parseCssFloat(s));
        l != null && (colorArr[2] = $2c037f5bda6341ca$var$parseCssFloat(l));
        return $2c037f5bda6341ca$export$fac44ee5b035f737($2c037f5bda6341ca$var$hsla2rgba(colorArr), 'rgba');
    }
}
function $2c037f5bda6341ca$export$ab4754bf42583a26(color, alpha) {
    var colorArr = $2c037f5bda6341ca$export$98e6a39c04603d36(color);
    if (colorArr && alpha != null) {
        colorArr[3] = $2c037f5bda6341ca$var$clampCssFloat(alpha);
        return $2c037f5bda6341ca$export$fac44ee5b035f737(colorArr, 'rgba');
    }
}
function $2c037f5bda6341ca$export$fac44ee5b035f737(arrColor, type) {
    if (!arrColor || !arrColor.length) return;
    var colorStr = arrColor[0] + ',' + arrColor[1] + ',' + arrColor[2];
    if (type === 'rgba' || type === 'hsva' || type === 'hsla') colorStr += ',' + arrColor[3];
    return type + '(' + colorStr + ')';
}
function $2c037f5bda6341ca$export$16c0ec21a6f9ef95(color, backgroundLum) {
    var arr = $2c037f5bda6341ca$export$98e6a39c04603d36(color);
    return arr ? (0.299 * arr[0] + 0.587 * arr[1] + 0.114 * arr[2]) * arr[3] / 255 + (1 - arr[3]) * backgroundLum : 0;
}
function $2c037f5bda6341ca$export$4385e60b38654f68() {
    return $2c037f5bda6341ca$export$fac44ee5b035f737([
        Math.round(Math.random() * 255),
        Math.round(Math.random() * 255),
        Math.round(Math.random() * 255)
    ], 'rgb');
}
var $2c037f5bda6341ca$var$liftedColorCache = new (0, $d91b0b6fc564d9c7$export$2e2bcd8739ae039)(100);
function $2c037f5bda6341ca$export$2b47e247dfb87a73(color) {
    if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(color)) {
        var liftedColor = $2c037f5bda6341ca$var$liftedColorCache.get(color);
        if (!liftedColor) {
            liftedColor = $2c037f5bda6341ca$export$590e8b2c435046d9(color, -0.1);
            $2c037f5bda6341ca$var$liftedColorCache.put(color, liftedColor);
        }
        return liftedColor;
    } else if ((0, $7a1bd9c2710fea0d$export$fa2c283003ed971c)(color)) {
        var ret = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, color);
        ret.colorStops = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(color.colorStops, function(stop) {
            return {
                offset: stop.offset,
                color: $2c037f5bda6341ca$export$590e8b2c435046d9(stop.color, -0.1)
            };
        });
        return ret;
    }
    return color;
}








/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


var $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
var $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        var len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        var buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $51861dfc7ca9d588$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eeb0961446aae8e3$export$6100ba28696e12de(buf);
    else return $eeb0961446aae8e3$export$6100ba28696e12de(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $eeb0961446aae8e3$export$d622b2ad8d90c771($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();


var $999d81abec723db8$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
var $999d81abec723db8$var$mathRound = Math.round;
function $999d81abec723db8$export$4cde5df63f53f473(color) {
    var opacity;
    if (!color || color === 'transparent') color = 'none';
    else if (typeof color === 'string' && color.indexOf('rgba') > -1) {
        var arr = (0, $2c037f5bda6341ca$export$98e6a39c04603d36)(color);
        if (arr) {
            color = 'rgb(' + arr[0] + ',' + arr[1] + ',' + arr[2] + ')';
            opacity = arr[3];
        }
    }
    return {
        color: color,
        opacity: opacity == null ? 1 : opacity
    };
}
var $999d81abec723db8$var$EPSILON = 1e-4;
function $999d81abec723db8$export$4701367f5b4de464(transform) {
    return transform < $999d81abec723db8$var$EPSILON && transform > -$999d81abec723db8$var$EPSILON;
}
function $999d81abec723db8$export$4b9074ac37ee5a23(transform) {
    return $999d81abec723db8$var$mathRound(transform * 1e3) / 1e3;
}
function $999d81abec723db8$export$52bfc6d3e2ff0fc2(transform) {
    return $999d81abec723db8$var$mathRound(transform * 1e4) / 1e4;
}
function $999d81abec723db8$export$19676ab5cb1de150(transform) {
    return $999d81abec723db8$var$mathRound(transform * 10) / 10;
}
function $999d81abec723db8$export$f29a4456cf56ff21(m) {
    return 'matrix(' + $999d81abec723db8$export$4b9074ac37ee5a23(m[0]) + ',' + $999d81abec723db8$export$4b9074ac37ee5a23(m[1]) + ',' + $999d81abec723db8$export$4b9074ac37ee5a23(m[2]) + ',' + $999d81abec723db8$export$4b9074ac37ee5a23(m[3]) + ',' + $999d81abec723db8$export$52bfc6d3e2ff0fc2(m[4]) + ',' + $999d81abec723db8$export$52bfc6d3e2ff0fc2(m[5]) + ')';
}
var $999d81abec723db8$export$4062150f0600d971 = {
    left: 'start',
    right: 'end',
    center: 'middle',
    middle: 'middle'
};
function $999d81abec723db8$export$bf7d6802d2badd9(y, lineHeight, textBaseline) {
    if (textBaseline === 'top') y += lineHeight / 2;
    else if (textBaseline === 'bottom') y -= lineHeight / 2;
    return y;
}
function $999d81abec723db8$export$c62076b3a966c94b(style) {
    return style && (style.shadowBlur || style.shadowOffsetX || style.shadowOffsetY);
}
function $999d81abec723db8$export$9e4c657be710688a(displayable) {
    var style = displayable.style;
    var globalScale = displayable.getGlobalScale();
    return [
        style.shadowColor,
        (style.shadowBlur || 0).toFixed(2),
        (style.shadowOffsetX || 0).toFixed(2),
        (style.shadowOffsetY || 0).toFixed(2),
        globalScale[0],
        globalScale[1]
    ].join(',');
}
function $999d81abec723db8$export$8abc07640cab0527(clipPaths) {
    var key = [];
    if (clipPaths) for(var i = 0; i < clipPaths.length; i++){
        var clipPath = clipPaths[i];
        key.push(clipPath.id);
    }
    return key.join(',');
}
function $999d81abec723db8$export$2ade673ac4f85dfe(val) {
    return val && !!val.image;
}
function $999d81abec723db8$export$30352f47600a13cd(val) {
    return val && !!val.svgElement;
}
function $999d81abec723db8$export$41a28f5a000a9d0f(val) {
    return $999d81abec723db8$export$2ade673ac4f85dfe(val) || $999d81abec723db8$export$30352f47600a13cd(val);
}
function $999d81abec723db8$export$7d961bca9d3b47d0(val) {
    return val.type === 'linear';
}
function $999d81abec723db8$export$2a9cca6692a0ce3a(val) {
    return val.type === 'radial';
}
function $999d81abec723db8$export$545e02bbd5f8fe95(val) {
    return val && (val.type === 'linear' || val.type === 'radial');
}
function $999d81abec723db8$export$bb094196179998a5(id) {
    return "url(#" + id + ")";
}
function $999d81abec723db8$export$93fa1ae8a509371c(el) {
    var scale = el.getGlobalScale();
    var size = Math.max(scale[0], scale[1]);
    return Math.max(Math.ceil(Math.log(size) / Math.log(10)), 1);
}
function $999d81abec723db8$export$3fe07c0888ff6164(transform) {
    var x = transform.x || 0;
    var y = transform.y || 0;
    var rotation = (transform.rotation || 0) * (0, $7a1bd9c2710fea0d$export$bce8e055322a0ce6);
    var scaleX = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(transform.scaleX, 1);
    var scaleY = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(transform.scaleY, 1);
    var skewX = transform.skewX || 0;
    var skewY = transform.skewY || 0;
    var res = [];
    if (x || y) res.push("translate(" + x + "px," + y + "px)");
    if (rotation) res.push("rotate(" + rotation + ")");
    if (scaleX !== 1 || scaleY !== 1) res.push("scale(" + scaleX + "," + scaleY + ")");
    if (skewX || skewY) res.push("skew(" + $999d81abec723db8$var$mathRound(skewX * (0, $7a1bd9c2710fea0d$export$bce8e055322a0ce6)) + "deg, " + $999d81abec723db8$var$mathRound(skewY * (0, $7a1bd9c2710fea0d$export$bce8e055322a0ce6)) + "deg)");
    return res.join(' ');
}
var $999d81abec723db8$export$8fb536984ec8b4d7 = function() {
    if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).hasGlobalWindow && (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(window.btoa)) return function(str) {
        return window.btoa(unescape(encodeURIComponent(str)));
    };
    if (typeof $999d81abec723db8$require$Buffer !== 'undefined') return function(str) {
        return $999d81abec723db8$require$Buffer.from(str).toString('base64');
    };
    return function(str) {
        return null;
    };
}();


var $76d8a142a20276fc$var$arraySlice = Array.prototype.slice;
function $76d8a142a20276fc$var$interpolateNumber(p0, p1, percent) {
    return (p1 - p0) * percent + p0;
}
function $76d8a142a20276fc$var$interpolate1DArray(out, p0, p1, percent) {
    var len = p0.length;
    for(var i = 0; i < len; i++)out[i] = $76d8a142a20276fc$var$interpolateNumber(p0[i], p1[i], percent);
    return out;
}
function $76d8a142a20276fc$var$interpolate2DArray(out, p0, p1, percent) {
    var len = p0.length;
    var len2 = len && p0[0].length;
    for(var i = 0; i < len; i++){
        if (!out[i]) out[i] = [];
        for(var j = 0; j < len2; j++)out[i][j] = $76d8a142a20276fc$var$interpolateNumber(p0[i][j], p1[i][j], percent);
    }
    return out;
}
function $76d8a142a20276fc$var$add1DArray(out, p0, p1, sign) {
    var len = p0.length;
    for(var i = 0; i < len; i++)out[i] = p0[i] + p1[i] * sign;
    return out;
}
function $76d8a142a20276fc$var$add2DArray(out, p0, p1, sign) {
    var len = p0.length;
    var len2 = len && p0[0].length;
    for(var i = 0; i < len; i++){
        if (!out[i]) out[i] = [];
        for(var j = 0; j < len2; j++)out[i][j] = p0[i][j] + p1[i][j] * sign;
    }
    return out;
}
function $76d8a142a20276fc$var$fillColorStops(val0, val1) {
    var len0 = val0.length;
    var len1 = val1.length;
    var shorterArr = len0 > len1 ? val1 : val0;
    var shorterLen = Math.min(len0, len1);
    var last = shorterArr[shorterLen - 1] || {
        color: [
            0,
            0,
            0,
            0
        ],
        offset: 0
    };
    for(var i = shorterLen; i < Math.max(len0, len1); i++)shorterArr.push({
        offset: last.offset,
        color: last.color.slice()
    });
}
function $76d8a142a20276fc$var$fillArray(val0, val1, arrDim) {
    var arr0 = val0;
    var arr1 = val1;
    if (!arr0.push || !arr1.push) return;
    var arr0Len = arr0.length;
    var arr1Len = arr1.length;
    if (arr0Len !== arr1Len) {
        var isPreviousLarger = arr0Len > arr1Len;
        if (isPreviousLarger) arr0.length = arr1Len;
        else for(var i = arr0Len; i < arr1Len; i++)arr0.push(arrDim === 1 ? arr1[i] : $76d8a142a20276fc$var$arraySlice.call(arr1[i]));
    }
    var len2 = arr0[0] && arr0[0].length;
    for(var i = 0; i < arr0.length; i++){
        if (arrDim === 1) {
            if (isNaN(arr0[i])) arr0[i] = arr1[i];
        } else {
            for(var j = 0; j < len2; j++)if (isNaN(arr0[i][j])) arr0[i][j] = arr1[i][j];
        }
    }
}
function $76d8a142a20276fc$export$c5e92b7f105af84e(value) {
    if ((0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(value)) {
        var len = value.length;
        if ((0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(value[0])) {
            var ret = [];
            for(var i = 0; i < len; i++)ret.push($76d8a142a20276fc$var$arraySlice.call(value[i]));
            return ret;
        }
        return $76d8a142a20276fc$var$arraySlice.call(value);
    }
    return value;
}
function $76d8a142a20276fc$var$rgba2String(rgba) {
    rgba[0] = Math.floor(rgba[0]) || 0;
    rgba[1] = Math.floor(rgba[1]) || 0;
    rgba[2] = Math.floor(rgba[2]) || 0;
    rgba[3] = rgba[3] == null ? 1 : rgba[3];
    return 'rgba(' + rgba.join(',') + ')';
}
function $76d8a142a20276fc$var$guessArrayDim(value) {
    return (0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(value && value[0]) ? 2 : 1;
}
var $76d8a142a20276fc$var$VALUE_TYPE_NUMBER = 0;
var $76d8a142a20276fc$var$VALUE_TYPE_1D_ARRAY = 1;
var $76d8a142a20276fc$var$VALUE_TYPE_2D_ARRAY = 2;
var $76d8a142a20276fc$var$VALUE_TYPE_COLOR = 3;
var $76d8a142a20276fc$var$VALUE_TYPE_LINEAR_GRADIENT = 4;
var $76d8a142a20276fc$var$VALUE_TYPE_RADIAL_GRADIENT = 5;
var $76d8a142a20276fc$var$VALUE_TYPE_UNKOWN = 6;
function $76d8a142a20276fc$var$isGradientValueType(valType) {
    return valType === $76d8a142a20276fc$var$VALUE_TYPE_LINEAR_GRADIENT || valType === $76d8a142a20276fc$var$VALUE_TYPE_RADIAL_GRADIENT;
}
function $76d8a142a20276fc$var$isArrayValueType(valType) {
    return valType === $76d8a142a20276fc$var$VALUE_TYPE_1D_ARRAY || valType === $76d8a142a20276fc$var$VALUE_TYPE_2D_ARRAY;
}
var $76d8a142a20276fc$var$tmpRgba = [
    0,
    0,
    0,
    0
];
var $76d8a142a20276fc$var$Track = function() {
    function Track(propName) {
        this.keyframes = [];
        this.discrete = false;
        this._invalid = false;
        this._needsSort = false;
        this._lastFr = 0;
        this._lastFrP = 0;
        this.propName = propName;
    }
    Track.prototype.isFinished = function() {
        return this._finished;
    };
    Track.prototype.setFinished = function() {
        this._finished = true;
        if (this._additiveTrack) this._additiveTrack.setFinished();
    };
    Track.prototype.needsAnimate = function() {
        return this.keyframes.length >= 1;
    };
    Track.prototype.getAdditiveTrack = function() {
        return this._additiveTrack;
    };
    Track.prototype.addKeyframe = function(time, rawValue, easing) {
        this._needsSort = true;
        var keyframes = this.keyframes;
        var len = keyframes.length;
        var discrete = false;
        var valType = $76d8a142a20276fc$var$VALUE_TYPE_UNKOWN;
        var value = rawValue;
        if ((0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(rawValue)) {
            var arrayDim = $76d8a142a20276fc$var$guessArrayDim(rawValue);
            valType = arrayDim;
            if (arrayDim === 1 && !(0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(rawValue[0]) || arrayDim === 2 && !(0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(rawValue[0][0])) discrete = true;
        } else {
            if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(rawValue) && !(0, $7a1bd9c2710fea0d$export$7d667b9a0c48c975)(rawValue)) valType = $76d8a142a20276fc$var$VALUE_TYPE_NUMBER;
            else if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(rawValue)) {
                if (!isNaN(+rawValue)) valType = $76d8a142a20276fc$var$VALUE_TYPE_NUMBER;
                else {
                    var colorArray = $2c037f5bda6341ca$export$98e6a39c04603d36(rawValue);
                    if (colorArray) {
                        value = colorArray;
                        valType = $76d8a142a20276fc$var$VALUE_TYPE_COLOR;
                    }
                }
            } else if ((0, $7a1bd9c2710fea0d$export$fa2c283003ed971c)(rawValue)) {
                var parsedGradient = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, value);
                parsedGradient.colorStops = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(rawValue.colorStops, function(colorStop) {
                    return {
                        offset: colorStop.offset,
                        color: $2c037f5bda6341ca$export$98e6a39c04603d36(colorStop.color)
                    };
                });
                if ((0, $999d81abec723db8$export$7d961bca9d3b47d0)(rawValue)) valType = $76d8a142a20276fc$var$VALUE_TYPE_LINEAR_GRADIENT;
                else if ((0, $999d81abec723db8$export$2a9cca6692a0ce3a)(rawValue)) valType = $76d8a142a20276fc$var$VALUE_TYPE_RADIAL_GRADIENT;
                value = parsedGradient;
            }
        }
        if (len === 0) this.valType = valType;
        else if (valType !== this.valType || valType === $76d8a142a20276fc$var$VALUE_TYPE_UNKOWN) discrete = true;
        this.discrete = this.discrete || discrete;
        var kf = {
            time: time,
            value: value,
            rawValue: rawValue,
            percent: 0
        };
        if (easing) {
            kf.easing = easing;
            kf.easingFunc = (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(easing) ? easing : (0, $9668111025b0b56f$export$2e2bcd8739ae039)[easing] || (0, $0aea98bda0b4be1f$export$ec0863d806fd857e)(easing);
        }
        keyframes.push(kf);
        return kf;
    };
    Track.prototype.prepare = function(maxTime, additiveTrack) {
        var kfs = this.keyframes;
        if (this._needsSort) kfs.sort(function(a, b) {
            return a.time - b.time;
        });
        var valType = this.valType;
        var kfsLen = kfs.length;
        var lastKf = kfs[kfsLen - 1];
        var isDiscrete = this.discrete;
        var isArr = $76d8a142a20276fc$var$isArrayValueType(valType);
        var isGradient = $76d8a142a20276fc$var$isGradientValueType(valType);
        for(var i = 0; i < kfsLen; i++){
            var kf = kfs[i];
            var value = kf.value;
            var lastValue = lastKf.value;
            kf.percent = kf.time / maxTime;
            if (!isDiscrete) {
                if (isArr && i !== kfsLen - 1) $76d8a142a20276fc$var$fillArray(value, lastValue, valType);
                else if (isGradient) $76d8a142a20276fc$var$fillColorStops(value.colorStops, lastValue.colorStops);
            }
        }
        if (!isDiscrete && valType !== $76d8a142a20276fc$var$VALUE_TYPE_RADIAL_GRADIENT && additiveTrack && this.needsAnimate() && additiveTrack.needsAnimate() && valType === additiveTrack.valType && !additiveTrack._finished) {
            this._additiveTrack = additiveTrack;
            var startValue = kfs[0].value;
            for(var i = 0; i < kfsLen; i++){
                if (valType === $76d8a142a20276fc$var$VALUE_TYPE_NUMBER) kfs[i].additiveValue = kfs[i].value - startValue;
                else if (valType === $76d8a142a20276fc$var$VALUE_TYPE_COLOR) kfs[i].additiveValue = $76d8a142a20276fc$var$add1DArray([], kfs[i].value, startValue, -1);
                else if ($76d8a142a20276fc$var$isArrayValueType(valType)) kfs[i].additiveValue = valType === $76d8a142a20276fc$var$VALUE_TYPE_1D_ARRAY ? $76d8a142a20276fc$var$add1DArray([], kfs[i].value, startValue, -1) : $76d8a142a20276fc$var$add2DArray([], kfs[i].value, startValue, -1);
            }
        }
    };
    Track.prototype.step = function(target, percent) {
        if (this._finished) return;
        if (this._additiveTrack && this._additiveTrack._finished) this._additiveTrack = null;
        var isAdditive = this._additiveTrack != null;
        var valueKey = isAdditive ? 'additiveValue' : 'value';
        var valType = this.valType;
        var keyframes = this.keyframes;
        var kfsNum = keyframes.length;
        var propName = this.propName;
        var isValueColor = valType === $76d8a142a20276fc$var$VALUE_TYPE_COLOR;
        var frameIdx;
        var lastFrame = this._lastFr;
        var mathMin = Math.min;
        var frame;
        var nextFrame;
        if (kfsNum === 1) frame = nextFrame = keyframes[0];
        else {
            if (percent < 0) frameIdx = 0;
            else if (percent < this._lastFrP) {
                var start = mathMin(lastFrame + 1, kfsNum - 1);
                for(frameIdx = start; frameIdx >= 0; frameIdx--){
                    if (keyframes[frameIdx].percent <= percent) break;
                }
                frameIdx = mathMin(frameIdx, kfsNum - 2);
            } else {
                for(frameIdx = lastFrame; frameIdx < kfsNum; frameIdx++){
                    if (keyframes[frameIdx].percent > percent) break;
                }
                frameIdx = mathMin(frameIdx - 1, kfsNum - 2);
            }
            nextFrame = keyframes[frameIdx + 1];
            frame = keyframes[frameIdx];
        }
        if (!(frame && nextFrame)) return;
        this._lastFr = frameIdx;
        this._lastFrP = percent;
        var interval = nextFrame.percent - frame.percent;
        var w = interval === 0 ? 1 : mathMin((percent - frame.percent) / interval, 1);
        if (nextFrame.easingFunc) w = nextFrame.easingFunc(w);
        var targetArr = isAdditive ? this._additiveValue : isValueColor ? $76d8a142a20276fc$var$tmpRgba : target[propName];
        if (($76d8a142a20276fc$var$isArrayValueType(valType) || isValueColor) && !targetArr) targetArr = this._additiveValue = [];
        if (this.discrete) target[propName] = w < 1 ? frame.rawValue : nextFrame.rawValue;
        else if ($76d8a142a20276fc$var$isArrayValueType(valType)) valType === $76d8a142a20276fc$var$VALUE_TYPE_1D_ARRAY ? $76d8a142a20276fc$var$interpolate1DArray(targetArr, frame[valueKey], nextFrame[valueKey], w) : $76d8a142a20276fc$var$interpolate2DArray(targetArr, frame[valueKey], nextFrame[valueKey], w);
        else if ($76d8a142a20276fc$var$isGradientValueType(valType)) {
            var val = frame[valueKey];
            var nextVal_1 = nextFrame[valueKey];
            var isLinearGradient_1 = valType === $76d8a142a20276fc$var$VALUE_TYPE_LINEAR_GRADIENT;
            target[propName] = {
                type: isLinearGradient_1 ? 'linear' : 'radial',
                x: $76d8a142a20276fc$var$interpolateNumber(val.x, nextVal_1.x, w),
                y: $76d8a142a20276fc$var$interpolateNumber(val.y, nextVal_1.y, w),
                colorStops: (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(val.colorStops, function(colorStop, idx) {
                    var nextColorStop = nextVal_1.colorStops[idx];
                    return {
                        offset: $76d8a142a20276fc$var$interpolateNumber(colorStop.offset, nextColorStop.offset, w),
                        color: $76d8a142a20276fc$var$rgba2String($76d8a142a20276fc$var$interpolate1DArray([], colorStop.color, nextColorStop.color, w))
                    };
                }),
                global: nextVal_1.global
            };
            if (isLinearGradient_1) {
                target[propName].x2 = $76d8a142a20276fc$var$interpolateNumber(val.x2, nextVal_1.x2, w);
                target[propName].y2 = $76d8a142a20276fc$var$interpolateNumber(val.y2, nextVal_1.y2, w);
            } else target[propName].r = $76d8a142a20276fc$var$interpolateNumber(val.r, nextVal_1.r, w);
        } else if (isValueColor) {
            $76d8a142a20276fc$var$interpolate1DArray(targetArr, frame[valueKey], nextFrame[valueKey], w);
            if (!isAdditive) target[propName] = $76d8a142a20276fc$var$rgba2String(targetArr);
        } else {
            var value = $76d8a142a20276fc$var$interpolateNumber(frame[valueKey], nextFrame[valueKey], w);
            if (isAdditive) this._additiveValue = value;
            else target[propName] = value;
        }
        if (isAdditive) this._addToTarget(target);
    };
    Track.prototype._addToTarget = function(target) {
        var valType = this.valType;
        var propName = this.propName;
        var additiveValue = this._additiveValue;
        if (valType === $76d8a142a20276fc$var$VALUE_TYPE_NUMBER) target[propName] = target[propName] + additiveValue;
        else if (valType === $76d8a142a20276fc$var$VALUE_TYPE_COLOR) {
            $2c037f5bda6341ca$export$98e6a39c04603d36(target[propName], $76d8a142a20276fc$var$tmpRgba);
            $76d8a142a20276fc$var$add1DArray($76d8a142a20276fc$var$tmpRgba, $76d8a142a20276fc$var$tmpRgba, additiveValue, 1);
            target[propName] = $76d8a142a20276fc$var$rgba2String($76d8a142a20276fc$var$tmpRgba);
        } else if (valType === $76d8a142a20276fc$var$VALUE_TYPE_1D_ARRAY) $76d8a142a20276fc$var$add1DArray(target[propName], target[propName], additiveValue, 1);
        else if (valType === $76d8a142a20276fc$var$VALUE_TYPE_2D_ARRAY) $76d8a142a20276fc$var$add2DArray(target[propName], target[propName], additiveValue, 1);
    };
    return Track;
}();
var $76d8a142a20276fc$var$Animator = function() {
    function Animator(target, loop, allowDiscreteAnimation, additiveTo) {
        this._tracks = {};
        this._trackKeys = [];
        this._maxTime = 0;
        this._started = 0;
        this._clip = null;
        this._target = target;
        this._loop = loop;
        if (loop && additiveTo) {
            (0, $7a1bd9c2710fea0d$export$58da9968c3170cb1)('Can\' use additive animation on looped animation.');
            return;
        }
        this._additiveAnimators = additiveTo;
        this._allowDiscrete = allowDiscreteAnimation;
    }
    Animator.prototype.getMaxTime = function() {
        return this._maxTime;
    };
    Animator.prototype.getDelay = function() {
        return this._delay;
    };
    Animator.prototype.getLoop = function() {
        return this._loop;
    };
    Animator.prototype.getTarget = function() {
        return this._target;
    };
    Animator.prototype.changeTarget = function(target) {
        this._target = target;
    };
    Animator.prototype.when = function(time, props, easing) {
        return this.whenWithKeys(time, props, (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(props), easing);
    };
    Animator.prototype.whenWithKeys = function(time, props, propNames, easing) {
        var tracks = this._tracks;
        for(var i = 0; i < propNames.length; i++){
            var propName = propNames[i];
            var track = tracks[propName];
            if (!track) {
                track = tracks[propName] = new $76d8a142a20276fc$var$Track(propName);
                var initialValue = void 0;
                var additiveTrack = this._getAdditiveTrack(propName);
                if (additiveTrack) {
                    var addtiveTrackKfs = additiveTrack.keyframes;
                    var lastFinalKf = addtiveTrackKfs[addtiveTrackKfs.length - 1];
                    initialValue = lastFinalKf && lastFinalKf.value;
                    if (additiveTrack.valType === $76d8a142a20276fc$var$VALUE_TYPE_COLOR && initialValue) initialValue = $76d8a142a20276fc$var$rgba2String(initialValue);
                } else initialValue = this._target[propName];
                if (initialValue == null) continue;
                if (time > 0) track.addKeyframe(0, $76d8a142a20276fc$export$c5e92b7f105af84e(initialValue), easing);
                this._trackKeys.push(propName);
            }
            track.addKeyframe(time, $76d8a142a20276fc$export$c5e92b7f105af84e(props[propName]), easing);
        }
        this._maxTime = Math.max(this._maxTime, time);
        return this;
    };
    Animator.prototype.pause = function() {
        this._clip.pause();
        this._paused = true;
    };
    Animator.prototype.resume = function() {
        this._clip.resume();
        this._paused = false;
    };
    Animator.prototype.isPaused = function() {
        return !!this._paused;
    };
    Animator.prototype.duration = function(duration) {
        this._maxTime = duration;
        this._force = true;
        return this;
    };
    Animator.prototype._doneCallback = function() {
        this._setTracksFinished();
        this._clip = null;
        var doneList = this._doneCbs;
        if (doneList) {
            var len = doneList.length;
            for(var i = 0; i < len; i++)doneList[i].call(this);
        }
    };
    Animator.prototype._abortedCallback = function() {
        this._setTracksFinished();
        var animation = this.animation;
        var abortedList = this._abortedCbs;
        if (animation) animation.removeClip(this._clip);
        this._clip = null;
        if (abortedList) for(var i = 0; i < abortedList.length; i++)abortedList[i].call(this);
    };
    Animator.prototype._setTracksFinished = function() {
        var tracks = this._tracks;
        var tracksKeys = this._trackKeys;
        for(var i = 0; i < tracksKeys.length; i++)tracks[tracksKeys[i]].setFinished();
    };
    Animator.prototype._getAdditiveTrack = function(trackName) {
        var additiveTrack;
        var additiveAnimators = this._additiveAnimators;
        if (additiveAnimators) for(var i = 0; i < additiveAnimators.length; i++){
            var track = additiveAnimators[i].getTrack(trackName);
            if (track) additiveTrack = track;
        }
        return additiveTrack;
    };
    Animator.prototype.start = function(easing) {
        if (this._started > 0) return;
        this._started = 1;
        var self = this;
        var tracks = [];
        var maxTime = this._maxTime || 0;
        for(var i = 0; i < this._trackKeys.length; i++){
            var propName = this._trackKeys[i];
            var track = this._tracks[propName];
            var additiveTrack = this._getAdditiveTrack(propName);
            var kfs = track.keyframes;
            var kfsNum = kfs.length;
            track.prepare(maxTime, additiveTrack);
            if (track.needsAnimate()) {
                if (!this._allowDiscrete && track.discrete) {
                    var lastKf = kfs[kfsNum - 1];
                    if (lastKf) self._target[track.propName] = lastKf.rawValue;
                    track.setFinished();
                } else tracks.push(track);
            }
        }
        if (tracks.length || this._force) {
            var clip = new (0, $00f1e1cb3568b9c5$export$2e2bcd8739ae039)({
                life: maxTime,
                loop: this._loop,
                delay: this._delay || 0,
                onframe: function(percent) {
                    self._started = 2;
                    var additiveAnimators = self._additiveAnimators;
                    if (additiveAnimators) {
                        var stillHasAdditiveAnimator = false;
                        for(var i = 0; i < additiveAnimators.length; i++)if (additiveAnimators[i]._clip) {
                            stillHasAdditiveAnimator = true;
                            break;
                        }
                        if (!stillHasAdditiveAnimator) self._additiveAnimators = null;
                    }
                    for(var i = 0; i < tracks.length; i++)tracks[i].step(self._target, percent);
                    var onframeList = self._onframeCbs;
                    if (onframeList) for(var i = 0; i < onframeList.length; i++)onframeList[i](self._target, percent);
                },
                ondestroy: function() {
                    self._doneCallback();
                }
            });
            this._clip = clip;
            if (this.animation) this.animation.addClip(clip);
            if (easing) clip.setEasing(easing);
        } else this._doneCallback();
        return this;
    };
    Animator.prototype.stop = function(forwardToLast) {
        if (!this._clip) return;
        var clip = this._clip;
        if (forwardToLast) clip.onframe(1);
        this._abortedCallback();
    };
    Animator.prototype.delay = function(time) {
        this._delay = time;
        return this;
    };
    Animator.prototype.during = function(cb) {
        if (cb) {
            if (!this._onframeCbs) this._onframeCbs = [];
            this._onframeCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.done = function(cb) {
        if (cb) {
            if (!this._doneCbs) this._doneCbs = [];
            this._doneCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.aborted = function(cb) {
        if (cb) {
            if (!this._abortedCbs) this._abortedCbs = [];
            this._abortedCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.getClip = function() {
        return this._clip;
    };
    Animator.prototype.getTrack = function(propName) {
        return this._tracks[propName];
    };
    Animator.prototype.getTracks = function() {
        var _this = this;
        return (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(this._trackKeys, function(key) {
            return _this._tracks[key];
        });
    };
    Animator.prototype.stopTracks = function(propNames, forwardToLast) {
        if (!propNames.length || !this._clip) return true;
        var tracks = this._tracks;
        var tracksKeys = this._trackKeys;
        for(var i = 0; i < propNames.length; i++){
            var track = tracks[propNames[i]];
            if (track && !track.isFinished()) {
                if (forwardToLast) track.step(this._target, 1);
                else if (this._started === 1) track.step(this._target, 0);
                track.setFinished();
            }
        }
        var allAborted = true;
        for(var i = 0; i < tracksKeys.length; i++)if (!tracks[tracksKeys[i]].isFinished()) {
            allAborted = false;
            break;
        }
        if (allAborted) this._abortedCallback();
        return allAborted;
    };
    Animator.prototype.saveTo = function(target, trackKeys, firstOrLast) {
        if (!target) return;
        trackKeys = trackKeys || this._trackKeys;
        for(var i = 0; i < trackKeys.length; i++){
            var propName = trackKeys[i];
            var track = this._tracks[propName];
            if (!track || track.isFinished()) continue;
            var kfs = track.keyframes;
            var kf = kfs[firstOrLast ? 0 : kfs.length - 1];
            if (kf) target[propName] = $76d8a142a20276fc$export$c5e92b7f105af84e(kf.rawValue);
        }
    };
    Animator.prototype.__changeFinalValue = function(finalProps, trackKeys) {
        trackKeys = trackKeys || (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(finalProps);
        for(var i = 0; i < trackKeys.length; i++){
            var propName = trackKeys[i];
            var track = this._tracks[propName];
            if (!track) continue;
            var kfs = track.keyframes;
            if (kfs.length > 1) {
                var lastKf = kfs.pop();
                track.addKeyframe(lastKf.time, finalProps[propName]);
                track.prepare(this._maxTime, track.getAdditiveTrack());
            }
        }
    };
    return Animator;
}();
var $76d8a142a20276fc$export$2e2bcd8739ae039 = $76d8a142a20276fc$var$Animator;


function $fad434a4044c956a$export$1428f42a7de81803() {
    return new Date().getTime();
}
var $fad434a4044c956a$var$Animation = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Animation, _super);
    function Animation(opts) {
        var _this = _super.call(this) || this;
        _this._running = false;
        _this._time = 0;
        _this._pausedTime = 0;
        _this._pauseStart = 0;
        _this._paused = false;
        opts = opts || {};
        _this.stage = opts.stage || {};
        return _this;
    }
    Animation.prototype.addClip = function(clip) {
        if (clip.animation) this.removeClip(clip);
        if (!this._head) this._head = this._tail = clip;
        else {
            this._tail.next = clip;
            clip.prev = this._tail;
            clip.next = null;
            this._tail = clip;
        }
        clip.animation = this;
    };
    Animation.prototype.addAnimator = function(animator) {
        animator.animation = this;
        var clip = animator.getClip();
        if (clip) this.addClip(clip);
    };
    Animation.prototype.removeClip = function(clip) {
        if (!clip.animation) return;
        var prev = clip.prev;
        var next = clip.next;
        if (prev) prev.next = next;
        else this._head = next;
        if (next) next.prev = prev;
        else this._tail = prev;
        clip.next = clip.prev = clip.animation = null;
    };
    Animation.prototype.removeAnimator = function(animator) {
        var clip = animator.getClip();
        if (clip) this.removeClip(clip);
        animator.animation = null;
    };
    Animation.prototype.update = function(notTriggerFrameAndStageUpdate) {
        var time = $fad434a4044c956a$export$1428f42a7de81803() - this._pausedTime;
        var delta = time - this._time;
        var clip = this._head;
        while(clip){
            var nextClip = clip.next;
            var finished = clip.step(time, delta);
            if (finished) {
                clip.ondestroy();
                this.removeClip(clip);
                clip = nextClip;
            } else clip = nextClip;
        }
        this._time = time;
        if (!notTriggerFrameAndStageUpdate) {
            this.trigger('frame', delta);
            this.stage.update && this.stage.update();
        }
    };
    Animation.prototype._startLoop = function() {
        var self = this;
        this._running = true;
        function step() {
            if (self._running) {
                (0, $731d42ad1858cd4c$export$2e2bcd8739ae039)(step);
                !self._paused && self.update();
            }
        }
        (0, $731d42ad1858cd4c$export$2e2bcd8739ae039)(step);
    };
    Animation.prototype.start = function() {
        if (this._running) return;
        this._time = $fad434a4044c956a$export$1428f42a7de81803();
        this._pausedTime = 0;
        this._startLoop();
    };
    Animation.prototype.stop = function() {
        this._running = false;
    };
    Animation.prototype.pause = function() {
        if (!this._paused) {
            this._pauseStart = $fad434a4044c956a$export$1428f42a7de81803();
            this._paused = true;
        }
    };
    Animation.prototype.resume = function() {
        if (this._paused) {
            this._pausedTime += $fad434a4044c956a$export$1428f42a7de81803() - this._pauseStart;
            this._paused = false;
        }
    };
    Animation.prototype.clear = function() {
        var clip = this._head;
        while(clip){
            var nextClip = clip.next;
            clip.prev = clip.next = clip.animation = null;
            clip = nextClip;
        }
        this._head = this._tail = null;
    };
    Animation.prototype.isFinished = function() {
        return this._head == null;
    };
    Animation.prototype.animate = function(target, options) {
        options = options || {};
        this.start();
        var animator = new (0, $76d8a142a20276fc$export$2e2bcd8739ae039)(target, options.loop);
        this.addAnimator(animator);
        return animator;
    };
    return Animation;
}((0, $63441a86293f101f$export$2e2bcd8739ae039));
var $fad434a4044c956a$export$2e2bcd8739ae039 = $fad434a4044c956a$var$Animation;







var $c0dbbc6989260eee$var$TOUCH_CLICK_DELAY = 300;
var $c0dbbc6989260eee$var$globalEventSupported = (0, $ce6dd58693a21851$export$2e2bcd8739ae039).domSupported;
var $c0dbbc6989260eee$var$localNativeListenerNames = function() {
    var mouseHandlerNames = [
        'click',
        'dblclick',
        'mousewheel',
        'wheel',
        'mouseout',
        'mouseup',
        'mousedown',
        'mousemove',
        'contextmenu'
    ];
    var touchHandlerNames = [
        'touchstart',
        'touchend',
        'touchmove'
    ];
    var pointerEventNameMap = {
        pointerdown: 1,
        pointerup: 1,
        pointermove: 1,
        pointerout: 1
    };
    var pointerHandlerNames = $7a1bd9c2710fea0d$export$871de8747c9eaa88(mouseHandlerNames, function(name) {
        var nm = name.replace('mouse', 'pointer');
        return pointerEventNameMap.hasOwnProperty(nm) ? nm : name;
    });
    return {
        mouse: mouseHandlerNames,
        touch: touchHandlerNames,
        pointer: pointerHandlerNames
    };
}();
var $c0dbbc6989260eee$var$globalNativeListenerNames = {
    mouse: [
        'mousemove',
        'mouseup'
    ],
    pointer: [
        'pointermove',
        'pointerup'
    ]
};
var $c0dbbc6989260eee$var$wheelEventSupported = false;
function $c0dbbc6989260eee$var$isPointerFromTouch(event) {
    var pointerType = event.pointerType;
    return pointerType === 'pen' || pointerType === 'touch';
}
function $c0dbbc6989260eee$var$setTouchTimer(scope) {
    scope.touching = true;
    if (scope.touchTimer != null) {
        clearTimeout(scope.touchTimer);
        scope.touchTimer = null;
    }
    scope.touchTimer = setTimeout(function() {
        scope.touching = false;
        scope.touchTimer = null;
    }, 700);
}
function $c0dbbc6989260eee$var$markTouch(event) {
    event && (event.zrByTouch = true);
}
function $c0dbbc6989260eee$var$normalizeGlobalEvent(instance, event) {
    return (0, $b3864a78637ff9ed$export$40fadb093aebad71)(instance.dom, new $c0dbbc6989260eee$var$FakeGlobalEvent(instance, event), true);
}
function $c0dbbc6989260eee$var$isLocalEl(instance, el) {
    var elTmp = el;
    var isLocal = false;
    while(elTmp && elTmp.nodeType !== 9 && !(isLocal = elTmp.domBelongToZr || elTmp !== el && elTmp === instance.painterRoot))elTmp = elTmp.parentNode;
    return isLocal;
}
var $c0dbbc6989260eee$var$FakeGlobalEvent = function() {
    function FakeGlobalEvent(instance, event) {
        this.stopPropagation = $7a1bd9c2710fea0d$export$8793edee2d425525;
        this.stopImmediatePropagation = $7a1bd9c2710fea0d$export$8793edee2d425525;
        this.preventDefault = $7a1bd9c2710fea0d$export$8793edee2d425525;
        this.type = event.type;
        this.target = this.currentTarget = instance.dom;
        this.pointerType = event.pointerType;
        this.clientX = event.clientX;
        this.clientY = event.clientY;
    }
    return FakeGlobalEvent;
}();
var $c0dbbc6989260eee$var$localDOMHandlers = {
    mousedown: function(event) {
        event = (0, $b3864a78637ff9ed$export$40fadb093aebad71)(this.dom, event);
        this.__mayPointerCapture = [
            event.zrX,
            event.zrY
        ];
        this.trigger('mousedown', event);
    },
    mousemove: function(event) {
        event = (0, $b3864a78637ff9ed$export$40fadb093aebad71)(this.dom, event);
        var downPoint = this.__mayPointerCapture;
        if (downPoint && (event.zrX !== downPoint[0] || event.zrY !== downPoint[1])) this.__togglePointerCapture(true);
        this.trigger('mousemove', event);
    },
    mouseup: function(event) {
        event = (0, $b3864a78637ff9ed$export$40fadb093aebad71)(this.dom, event);
        this.__togglePointerCapture(false);
        this.trigger('mouseup', event);
    },
    mouseout: function(event) {
        event = (0, $b3864a78637ff9ed$export$40fadb093aebad71)(this.dom, event);
        var element = event.toElement || event.relatedTarget;
        if (!$c0dbbc6989260eee$var$isLocalEl(this, element)) {
            if (this.__pointerCapturing) event.zrEventControl = 'no_globalout';
            this.trigger('mouseout', event);
        }
    },
    wheel: function(event) {
        $c0dbbc6989260eee$var$wheelEventSupported = true;
        event = (0, $b3864a78637ff9ed$export$40fadb093aebad71)(this.dom, event);
        this.trigger('mousewheel', event);
    },
    mousewheel: function(event) {
        if ($c0dbbc6989260eee$var$wheelEventSupported) return;
        event = (0, $b3864a78637ff9ed$export$40fadb093aebad71)(this.dom, event);
        this.trigger('mousewheel', event);
    },
    touchstart: function(event) {
        event = (0, $b3864a78637ff9ed$export$40fadb093aebad71)(this.dom, event);
        $c0dbbc6989260eee$var$markTouch(event);
        this.__lastTouchMoment = new Date();
        this.handler.processGesture(event, 'start');
        $c0dbbc6989260eee$var$localDOMHandlers.mousemove.call(this, event);
        $c0dbbc6989260eee$var$localDOMHandlers.mousedown.call(this, event);
    },
    touchmove: function(event) {
        event = (0, $b3864a78637ff9ed$export$40fadb093aebad71)(this.dom, event);
        $c0dbbc6989260eee$var$markTouch(event);
        this.handler.processGesture(event, 'change');
        $c0dbbc6989260eee$var$localDOMHandlers.mousemove.call(this, event);
    },
    touchend: function(event) {
        event = (0, $b3864a78637ff9ed$export$40fadb093aebad71)(this.dom, event);
        $c0dbbc6989260eee$var$markTouch(event);
        this.handler.processGesture(event, 'end');
        $c0dbbc6989260eee$var$localDOMHandlers.mouseup.call(this, event);
        if (+new Date() - +this.__lastTouchMoment < $c0dbbc6989260eee$var$TOUCH_CLICK_DELAY) $c0dbbc6989260eee$var$localDOMHandlers.click.call(this, event);
    },
    pointerdown: function(event) {
        $c0dbbc6989260eee$var$localDOMHandlers.mousedown.call(this, event);
    },
    pointermove: function(event) {
        if (!$c0dbbc6989260eee$var$isPointerFromTouch(event)) $c0dbbc6989260eee$var$localDOMHandlers.mousemove.call(this, event);
    },
    pointerup: function(event) {
        $c0dbbc6989260eee$var$localDOMHandlers.mouseup.call(this, event);
    },
    pointerout: function(event) {
        if (!$c0dbbc6989260eee$var$isPointerFromTouch(event)) $c0dbbc6989260eee$var$localDOMHandlers.mouseout.call(this, event);
    }
};
$7a1bd9c2710fea0d$export$79b2f7037acddd43([
    'click',
    'dblclick',
    'contextmenu'
], function(name) {
    $c0dbbc6989260eee$var$localDOMHandlers[name] = function(event) {
        event = (0, $b3864a78637ff9ed$export$40fadb093aebad71)(this.dom, event);
        this.trigger(name, event);
    };
});
var $c0dbbc6989260eee$var$globalDOMHandlers = {
    pointermove: function(event) {
        if (!$c0dbbc6989260eee$var$isPointerFromTouch(event)) $c0dbbc6989260eee$var$globalDOMHandlers.mousemove.call(this, event);
    },
    pointerup: function(event) {
        $c0dbbc6989260eee$var$globalDOMHandlers.mouseup.call(this, event);
    },
    mousemove: function(event) {
        this.trigger('mousemove', event);
    },
    mouseup: function(event) {
        var pointerCaptureReleasing = this.__pointerCapturing;
        this.__togglePointerCapture(false);
        this.trigger('mouseup', event);
        if (pointerCaptureReleasing) {
            event.zrEventControl = 'only_globalout';
            this.trigger('mouseout', event);
        }
    }
};
function $c0dbbc6989260eee$var$mountLocalDOMEventListeners(instance, scope) {
    var domHandlers = scope.domHandlers;
    if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).pointerEventsSupported) $7a1bd9c2710fea0d$export$79b2f7037acddd43($c0dbbc6989260eee$var$localNativeListenerNames.pointer, function(nativeEventName) {
        $c0dbbc6989260eee$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
            domHandlers[nativeEventName].call(instance, event);
        });
    });
    else {
        if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).touchEventsSupported) $7a1bd9c2710fea0d$export$79b2f7037acddd43($c0dbbc6989260eee$var$localNativeListenerNames.touch, function(nativeEventName) {
            $c0dbbc6989260eee$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
                domHandlers[nativeEventName].call(instance, event);
                $c0dbbc6989260eee$var$setTouchTimer(scope);
            });
        });
        $7a1bd9c2710fea0d$export$79b2f7037acddd43($c0dbbc6989260eee$var$localNativeListenerNames.mouse, function(nativeEventName) {
            $c0dbbc6989260eee$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
                event = (0, $b3864a78637ff9ed$export$4abe0e945399ac1d)(event);
                if (!scope.touching) domHandlers[nativeEventName].call(instance, event);
            });
        });
    }
}
function $c0dbbc6989260eee$var$mountGlobalDOMEventListeners(instance, scope) {
    if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).pointerEventsSupported) $7a1bd9c2710fea0d$export$79b2f7037acddd43($c0dbbc6989260eee$var$globalNativeListenerNames.pointer, mount);
    else if (!(0, $ce6dd58693a21851$export$2e2bcd8739ae039).touchEventsSupported) $7a1bd9c2710fea0d$export$79b2f7037acddd43($c0dbbc6989260eee$var$globalNativeListenerNames.mouse, mount);
    function mount(nativeEventName) {
        function nativeEventListener(event) {
            event = (0, $b3864a78637ff9ed$export$4abe0e945399ac1d)(event);
            if (!$c0dbbc6989260eee$var$isLocalEl(instance, event.target)) {
                event = $c0dbbc6989260eee$var$normalizeGlobalEvent(instance, event);
                scope.domHandlers[nativeEventName].call(instance, event);
            }
        }
        $c0dbbc6989260eee$var$mountSingleDOMEventListener(scope, nativeEventName, nativeEventListener, {
            capture: true
        });
    }
}
function $c0dbbc6989260eee$var$mountSingleDOMEventListener(scope, nativeEventName, listener, opt) {
    scope.mounted[nativeEventName] = listener;
    scope.listenerOpts[nativeEventName] = opt;
    (0, $b3864a78637ff9ed$export$3f65cefe8380dbea)(scope.domTarget, nativeEventName, listener, opt);
}
function $c0dbbc6989260eee$var$unmountDOMEventListeners(scope) {
    var mounted = scope.mounted;
    for(var nativeEventName in mounted)if (mounted.hasOwnProperty(nativeEventName)) (0, $b3864a78637ff9ed$export$8ff9f68337b520c0)(scope.domTarget, nativeEventName, mounted[nativeEventName], scope.listenerOpts[nativeEventName]);
    scope.mounted = {};
}
var $c0dbbc6989260eee$var$DOMHandlerScope = function() {
    function DOMHandlerScope(domTarget, domHandlers) {
        this.mounted = {};
        this.listenerOpts = {};
        this.touching = false;
        this.domTarget = domTarget;
        this.domHandlers = domHandlers;
    }
    return DOMHandlerScope;
}();
var $c0dbbc6989260eee$var$HandlerDomProxy = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(HandlerDomProxy, _super);
    function HandlerDomProxy(dom, painterRoot) {
        var _this = _super.call(this) || this;
        _this.__pointerCapturing = false;
        _this.dom = dom;
        _this.painterRoot = painterRoot;
        _this._localHandlerScope = new $c0dbbc6989260eee$var$DOMHandlerScope(dom, $c0dbbc6989260eee$var$localDOMHandlers);
        if ($c0dbbc6989260eee$var$globalEventSupported) _this._globalHandlerScope = new $c0dbbc6989260eee$var$DOMHandlerScope(document, $c0dbbc6989260eee$var$globalDOMHandlers);
        $c0dbbc6989260eee$var$mountLocalDOMEventListeners(_this, _this._localHandlerScope);
        return _this;
    }
    HandlerDomProxy.prototype.dispose = function() {
        $c0dbbc6989260eee$var$unmountDOMEventListeners(this._localHandlerScope);
        if ($c0dbbc6989260eee$var$globalEventSupported) $c0dbbc6989260eee$var$unmountDOMEventListeners(this._globalHandlerScope);
    };
    HandlerDomProxy.prototype.setCursor = function(cursorStyle) {
        this.dom.style && (this.dom.style.cursor = cursorStyle || 'default');
    };
    HandlerDomProxy.prototype.__togglePointerCapture = function(isPointerCapturing) {
        this.__mayPointerCapture = null;
        if ($c0dbbc6989260eee$var$globalEventSupported && +this.__pointerCapturing ^ +isPointerCapturing) {
            this.__pointerCapturing = isPointerCapturing;
            var globalHandlerScope = this._globalHandlerScope;
            isPointerCapturing ? $c0dbbc6989260eee$var$mountGlobalDOMEventListeners(this, globalHandlerScope) : $c0dbbc6989260eee$var$unmountDOMEventListeners(globalHandlerScope);
        }
    };
    return HandlerDomProxy;
}((0, $63441a86293f101f$export$2e2bcd8739ae039));
var $c0dbbc6989260eee$export$2e2bcd8739ae039 = $c0dbbc6989260eee$var$HandlerDomProxy;




var $4b0cedd85979c776$var$dpr = 1;
if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).hasGlobalWindow) $4b0cedd85979c776$var$dpr = Math.max(window.devicePixelRatio || window.screen && window.screen.deviceXDPI / window.screen.logicalXDPI || 1, 1);
var $4b0cedd85979c776$export$7cdcde344c85339c = 0;
var $4b0cedd85979c776$export$508f096bfcdaac40 = $4b0cedd85979c776$var$dpr;
var $4b0cedd85979c776$export$fd81e7ebc7dae256 = 0.4;
var $4b0cedd85979c776$export$f8ce94761f39398d = '#333';
var $4b0cedd85979c776$export$3c6e95f318c8369b = '#ccc';
var $4b0cedd85979c776$export$27682248795c3c6b = '#eee';






var $becf2d727f9cf450$var$mIdentity = $f41ebb9dd60b55b4$export$f0954fd7d5368655;
var $becf2d727f9cf450$var$EPSILON = 5e-5;
function $becf2d727f9cf450$var$isNotAroundZero(val) {
    return val > $becf2d727f9cf450$var$EPSILON || val < -$becf2d727f9cf450$var$EPSILON;
}
var $becf2d727f9cf450$var$scaleTmp = [];
var $becf2d727f9cf450$var$tmpTransform = [];
var $becf2d727f9cf450$var$originTransform = $f41ebb9dd60b55b4$export$185802fd694ee1f5();
var $becf2d727f9cf450$var$abs = Math.abs;
var $becf2d727f9cf450$var$Transformable = function() {
    function Transformable() {}
    Transformable.prototype.getLocalTransform = function(m) {
        return Transformable.getLocalTransform(this, m);
    };
    Transformable.prototype.setPosition = function(arr) {
        this.x = arr[0];
        this.y = arr[1];
    };
    Transformable.prototype.setScale = function(arr) {
        this.scaleX = arr[0];
        this.scaleY = arr[1];
    };
    Transformable.prototype.setSkew = function(arr) {
        this.skewX = arr[0];
        this.skewY = arr[1];
    };
    Transformable.prototype.setOrigin = function(arr) {
        this.originX = arr[0];
        this.originY = arr[1];
    };
    Transformable.prototype.needLocalTransform = function() {
        return $becf2d727f9cf450$var$isNotAroundZero(this.rotation) || $becf2d727f9cf450$var$isNotAroundZero(this.x) || $becf2d727f9cf450$var$isNotAroundZero(this.y) || $becf2d727f9cf450$var$isNotAroundZero(this.scaleX - 1) || $becf2d727f9cf450$var$isNotAroundZero(this.scaleY - 1) || $becf2d727f9cf450$var$isNotAroundZero(this.skewX) || $becf2d727f9cf450$var$isNotAroundZero(this.skewY);
    };
    Transformable.prototype.updateTransform = function() {
        var parentTransform = this.parent && this.parent.transform;
        var needLocalTransform = this.needLocalTransform();
        var m = this.transform;
        if (!(needLocalTransform || parentTransform)) {
            if (m) {
                $becf2d727f9cf450$var$mIdentity(m);
                this.invTransform = null;
            }
            return;
        }
        m = m || $f41ebb9dd60b55b4$export$185802fd694ee1f5();
        if (needLocalTransform) this.getLocalTransform(m);
        else $becf2d727f9cf450$var$mIdentity(m);
        if (parentTransform) {
            if (needLocalTransform) $f41ebb9dd60b55b4$export$6e3a27864ab166fe(m, parentTransform, m);
            else $f41ebb9dd60b55b4$export$784d13d8ee351f07(m, parentTransform);
        }
        this.transform = m;
        this._resolveGlobalScaleRatio(m);
    };
    Transformable.prototype._resolveGlobalScaleRatio = function(m) {
        var globalScaleRatio = this.globalScaleRatio;
        if (globalScaleRatio != null && globalScaleRatio !== 1) {
            this.getGlobalScale($becf2d727f9cf450$var$scaleTmp);
            var relX = $becf2d727f9cf450$var$scaleTmp[0] < 0 ? -1 : 1;
            var relY = $becf2d727f9cf450$var$scaleTmp[1] < 0 ? -1 : 1;
            var sx = (($becf2d727f9cf450$var$scaleTmp[0] - relX) * globalScaleRatio + relX) / $becf2d727f9cf450$var$scaleTmp[0] || 0;
            var sy = (($becf2d727f9cf450$var$scaleTmp[1] - relY) * globalScaleRatio + relY) / $becf2d727f9cf450$var$scaleTmp[1] || 0;
            m[0] *= sx;
            m[1] *= sx;
            m[2] *= sy;
            m[3] *= sy;
        }
        this.invTransform = this.invTransform || $f41ebb9dd60b55b4$export$185802fd694ee1f5();
        $f41ebb9dd60b55b4$export$6897c284b6f9f4dc(this.invTransform, m);
    };
    Transformable.prototype.getComputedTransform = function() {
        var transformNode = this;
        var ancestors = [];
        while(transformNode){
            ancestors.push(transformNode);
            transformNode = transformNode.parent;
        }
        while(transformNode = ancestors.pop())transformNode.updateTransform();
        return this.transform;
    };
    Transformable.prototype.setLocalTransform = function(m) {
        if (!m) return;
        var sx = m[0] * m[0] + m[1] * m[1];
        var sy = m[2] * m[2] + m[3] * m[3];
        var rotation = Math.atan2(m[1], m[0]);
        var shearX = Math.PI / 2 + rotation - Math.atan2(m[3], m[2]);
        sy = Math.sqrt(sy) * Math.cos(shearX);
        sx = Math.sqrt(sx);
        this.skewX = shearX;
        this.skewY = 0;
        this.rotation = -rotation;
        this.x = +m[4];
        this.y = +m[5];
        this.scaleX = sx;
        this.scaleY = sy;
        this.originX = 0;
        this.originY = 0;
    };
    Transformable.prototype.decomposeTransform = function() {
        if (!this.transform) return;
        var parent = this.parent;
        var m = this.transform;
        if (parent && parent.transform) {
            parent.invTransform = parent.invTransform || $f41ebb9dd60b55b4$export$185802fd694ee1f5();
            $f41ebb9dd60b55b4$export$6e3a27864ab166fe($becf2d727f9cf450$var$tmpTransform, parent.invTransform, m);
            m = $becf2d727f9cf450$var$tmpTransform;
        }
        var ox = this.originX;
        var oy = this.originY;
        if (ox || oy) {
            $becf2d727f9cf450$var$originTransform[4] = ox;
            $becf2d727f9cf450$var$originTransform[5] = oy;
            $f41ebb9dd60b55b4$export$6e3a27864ab166fe($becf2d727f9cf450$var$tmpTransform, m, $becf2d727f9cf450$var$originTransform);
            $becf2d727f9cf450$var$tmpTransform[4] -= ox;
            $becf2d727f9cf450$var$tmpTransform[5] -= oy;
            m = $becf2d727f9cf450$var$tmpTransform;
        }
        this.setLocalTransform(m);
    };
    Transformable.prototype.getGlobalScale = function(out) {
        var m = this.transform;
        out = out || [];
        if (!m) {
            out[0] = 1;
            out[1] = 1;
            return out;
        }
        out[0] = Math.sqrt(m[0] * m[0] + m[1] * m[1]);
        out[1] = Math.sqrt(m[2] * m[2] + m[3] * m[3]);
        if (m[0] < 0) out[0] = -out[0];
        if (m[3] < 0) out[1] = -out[1];
        return out;
    };
    Transformable.prototype.transformCoordToLocal = function(x, y) {
        var v2 = [
            x,
            y
        ];
        var invTransform = this.invTransform;
        if (invTransform) $6de594cf8ac295ff$export$9f9dcb98c894b623(v2, v2, invTransform);
        return v2;
    };
    Transformable.prototype.transformCoordToGlobal = function(x, y) {
        var v2 = [
            x,
            y
        ];
        var transform = this.transform;
        if (transform) $6de594cf8ac295ff$export$9f9dcb98c894b623(v2, v2, transform);
        return v2;
    };
    Transformable.prototype.getLineScale = function() {
        var m = this.transform;
        return m && $becf2d727f9cf450$var$abs(m[0] - 1) > 1e-10 && $becf2d727f9cf450$var$abs(m[3] - 1) > 1e-10 ? Math.sqrt($becf2d727f9cf450$var$abs(m[0] * m[3] - m[2] * m[1])) : 1;
    };
    Transformable.prototype.copyTransform = function(source) {
        $becf2d727f9cf450$export$234b1c16dfa57d6a(this, source);
    };
    Transformable.getLocalTransform = function(target, m) {
        m = m || [];
        var ox = target.originX || 0;
        var oy = target.originY || 0;
        var sx = target.scaleX;
        var sy = target.scaleY;
        var ax = target.anchorX;
        var ay = target.anchorY;
        var rotation = target.rotation || 0;
        var x = target.x;
        var y = target.y;
        var skewX = target.skewX ? Math.tan(target.skewX) : 0;
        var skewY = target.skewY ? Math.tan(-target.skewY) : 0;
        if (ox || oy || ax || ay) {
            var dx = ox + ax;
            var dy = oy + ay;
            m[4] = -dx * sx - skewX * dy * sy;
            m[5] = -dy * sy - skewY * dx * sx;
        } else m[4] = m[5] = 0;
        m[0] = sx;
        m[3] = sy;
        m[1] = skewY * sx;
        m[2] = skewX * sy;
        rotation && $f41ebb9dd60b55b4$export$bb628a54ab399bc9(m, m, rotation);
        m[4] += ox + x;
        m[5] += oy + y;
        return m;
    };
    Transformable.initDefaultProps = function() {
        var proto = Transformable.prototype;
        proto.scaleX = proto.scaleY = proto.globalScaleRatio = 1;
        proto.x = proto.y = proto.originX = proto.originY = proto.skewX = proto.skewY = proto.rotation = proto.anchorX = proto.anchorY = 0;
    }();
    return Transformable;
}();
var $becf2d727f9cf450$export$98ab6203ec3396e2 = [
    'x',
    'y',
    'originX',
    'originY',
    'anchorX',
    'anchorY',
    'rotation',
    'scaleX',
    'scaleY',
    'skewX',
    'skewY'
];
function $becf2d727f9cf450$export$234b1c16dfa57d6a(target, source) {
    for(var i = 0; i < $becf2d727f9cf450$export$98ab6203ec3396e2.length; i++){
        var propName = $becf2d727f9cf450$export$98ab6203ec3396e2[i];
        target[propName] = source[propName];
    }
}
var $becf2d727f9cf450$export$2e2bcd8739ae039 = $becf2d727f9cf450$var$Transformable;








var $6c308355c7107803$var$textWidthCache = {};
function $6c308355c7107803$export$3c49c185de0c2bfc(text, font) {
    font = font || (0, $c6341dcc9d86826e$export$7d7a232b6d2cc80c);
    var cacheOfFont = $6c308355c7107803$var$textWidthCache[font];
    if (!cacheOfFont) cacheOfFont = $6c308355c7107803$var$textWidthCache[font] = new (0, $d91b0b6fc564d9c7$export$2e2bcd8739ae039)(500);
    var width = cacheOfFont.get(text);
    if (width == null) {
        width = (0, $c6341dcc9d86826e$export$ef5e599365494451).measureText(text, font).width;
        cacheOfFont.put(text, width);
    }
    return width;
}
function $6c308355c7107803$export$85aabf24202fbe9b(text, font, textAlign, textBaseline) {
    var width = $6c308355c7107803$export$3c49c185de0c2bfc(text, font);
    var height = $6c308355c7107803$export$56204a27a2958a55(font);
    var x = $6c308355c7107803$export$eb5a525ef00ef9a4(0, width, textAlign);
    var y = $6c308355c7107803$export$bf7d6802d2badd9(0, height, textBaseline);
    var rect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(x, y, width, height);
    return rect;
}
function $6c308355c7107803$export$c381147bfed79d9f(text, font, textAlign, textBaseline) {
    var textLines = ((text || '') + '').split('\n');
    var len = textLines.length;
    if (len === 1) return $6c308355c7107803$export$85aabf24202fbe9b(textLines[0], font, textAlign, textBaseline);
    else {
        var uniondRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
        for(var i = 0; i < textLines.length; i++){
            var rect = $6c308355c7107803$export$85aabf24202fbe9b(textLines[i], font, textAlign, textBaseline);
            i === 0 ? uniondRect.copy(rect) : uniondRect.union(rect);
        }
        return uniondRect;
    }
}
function $6c308355c7107803$export$eb5a525ef00ef9a4(x, width, textAlign) {
    if (textAlign === 'right') x -= width;
    else if (textAlign === 'center') x -= width / 2;
    return x;
}
function $6c308355c7107803$export$bf7d6802d2badd9(y, height, verticalAlign) {
    if (verticalAlign === 'middle') y -= height / 2;
    else if (verticalAlign === 'bottom') y -= height;
    return y;
}
function $6c308355c7107803$export$56204a27a2958a55(font) {
    return $6c308355c7107803$export$3c49c185de0c2bfc("\u56FD", font);
}
function $6c308355c7107803$export$866cc30a33805630(text, font) {
    return (0, $c6341dcc9d86826e$export$ef5e599365494451).measureText(text, font);
}
function $6c308355c7107803$export$e8514cb5a5e2b40f(value, maxValue) {
    if (typeof value === 'string') {
        if (value.lastIndexOf('%') >= 0) return parseFloat(value) / 100 * maxValue;
        return parseFloat(value);
    }
    return value;
}
function $6c308355c7107803$export$eee3603b512feab7(out, opts, rect) {
    var textPosition = opts.position || 'inside';
    var distance = opts.distance != null ? opts.distance : 5;
    var height = rect.height;
    var width = rect.width;
    var halfHeight = height / 2;
    var x = rect.x;
    var y = rect.y;
    var textAlign = 'left';
    var textVerticalAlign = 'top';
    if (textPosition instanceof Array) {
        x += $6c308355c7107803$export$e8514cb5a5e2b40f(textPosition[0], rect.width);
        y += $6c308355c7107803$export$e8514cb5a5e2b40f(textPosition[1], rect.height);
        textAlign = null;
        textVerticalAlign = null;
    } else switch(textPosition){
        case 'left':
            x -= distance;
            y += halfHeight;
            textAlign = 'right';
            textVerticalAlign = 'middle';
            break;
        case 'right':
            x += distance + width;
            y += halfHeight;
            textVerticalAlign = 'middle';
            break;
        case 'top':
            x += width / 2;
            y -= distance;
            textAlign = 'center';
            textVerticalAlign = 'bottom';
            break;
        case 'bottom':
            x += width / 2;
            y += height + distance;
            textAlign = 'center';
            break;
        case 'inside':
            x += width / 2;
            y += halfHeight;
            textAlign = 'center';
            textVerticalAlign = 'middle';
            break;
        case 'insideLeft':
            x += distance;
            y += halfHeight;
            textVerticalAlign = 'middle';
            break;
        case 'insideRight':
            x += width - distance;
            y += halfHeight;
            textAlign = 'right';
            textVerticalAlign = 'middle';
            break;
        case 'insideTop':
            x += width / 2;
            y += distance;
            textAlign = 'center';
            break;
        case 'insideBottom':
            x += width / 2;
            y += height - distance;
            textAlign = 'center';
            textVerticalAlign = 'bottom';
            break;
        case 'insideTopLeft':
            x += distance;
            y += distance;
            break;
        case 'insideTopRight':
            x += width - distance;
            y += distance;
            textAlign = 'right';
            break;
        case 'insideBottomLeft':
            x += distance;
            y += height - distance;
            textVerticalAlign = 'bottom';
            break;
        case 'insideBottomRight':
            x += width - distance;
            y += height - distance;
            textAlign = 'right';
            textVerticalAlign = 'bottom';
            break;
    }
    out = out || {};
    out.x = x;
    out.y = y;
    out.align = textAlign;
    out.verticalAlign = textVerticalAlign;
    return out;
}






var $4bb0f26b847654d5$export$97b5e845c7286801 = '__zr_normal__';
var $4bb0f26b847654d5$var$PRIMARY_STATES_KEYS = (0, $becf2d727f9cf450$export$98ab6203ec3396e2).concat([
    'ignore'
]);
var $4bb0f26b847654d5$var$DEFAULT_ANIMATABLE_MAP = (0, $7a1bd9c2710fea0d$export$533b26079ad0b4b)((0, $becf2d727f9cf450$export$98ab6203ec3396e2), function(obj, key) {
    obj[key] = true;
    return obj;
}, {
    ignore: false
});
var $4bb0f26b847654d5$var$tmpTextPosCalcRes = {};
var $4bb0f26b847654d5$var$tmpBoundingRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
var $4bb0f26b847654d5$var$Element = function() {
    function Element(props) {
        this.id = (0, $7a1bd9c2710fea0d$export$46e8f25c7328f77e)();
        this.animators = [];
        this.currentStates = [];
        this.states = {};
        this._init(props);
    }
    Element.prototype._init = function(props) {
        this.attr(props);
    };
    Element.prototype.drift = function(dx, dy, e) {
        switch(this.draggable){
            case 'horizontal':
                dy = 0;
                break;
            case 'vertical':
                dx = 0;
                break;
        }
        var m = this.transform;
        if (!m) m = this.transform = [
            1,
            0,
            0,
            1,
            0,
            0
        ];
        m[4] += dx;
        m[5] += dy;
        this.decomposeTransform();
        this.markRedraw();
    };
    Element.prototype.beforeUpdate = function() {};
    Element.prototype.afterUpdate = function() {};
    Element.prototype.update = function() {
        this.updateTransform();
        if (this.__dirty) this.updateInnerText();
    };
    Element.prototype.updateInnerText = function(forceUpdate) {
        var textEl = this._textContent;
        if (textEl && (!textEl.ignore || forceUpdate)) {
            if (!this.textConfig) this.textConfig = {};
            var textConfig = this.textConfig;
            var isLocal = textConfig.local;
            var innerTransformable = textEl.innerTransformable;
            var textAlign = void 0;
            var textVerticalAlign = void 0;
            var textStyleChanged = false;
            innerTransformable.parent = isLocal ? this : null;
            var innerOrigin = false;
            innerTransformable.copyTransform(textEl);
            if (textConfig.position != null) {
                var layoutRect = $4bb0f26b847654d5$var$tmpBoundingRect;
                if (textConfig.layoutRect) layoutRect.copy(textConfig.layoutRect);
                else layoutRect.copy(this.getBoundingRect());
                if (!isLocal) layoutRect.applyTransform(this.transform);
                if (this.calculateTextPosition) this.calculateTextPosition($4bb0f26b847654d5$var$tmpTextPosCalcRes, textConfig, layoutRect);
                else (0, $6c308355c7107803$export$eee3603b512feab7)($4bb0f26b847654d5$var$tmpTextPosCalcRes, textConfig, layoutRect);
                innerTransformable.x = $4bb0f26b847654d5$var$tmpTextPosCalcRes.x;
                innerTransformable.y = $4bb0f26b847654d5$var$tmpTextPosCalcRes.y;
                textAlign = $4bb0f26b847654d5$var$tmpTextPosCalcRes.align;
                textVerticalAlign = $4bb0f26b847654d5$var$tmpTextPosCalcRes.verticalAlign;
                var textOrigin = textConfig.origin;
                if (textOrigin && textConfig.rotation != null) {
                    var relOriginX = void 0;
                    var relOriginY = void 0;
                    if (textOrigin === 'center') {
                        relOriginX = layoutRect.width * 0.5;
                        relOriginY = layoutRect.height * 0.5;
                    } else {
                        relOriginX = (0, $6c308355c7107803$export$e8514cb5a5e2b40f)(textOrigin[0], layoutRect.width);
                        relOriginY = (0, $6c308355c7107803$export$e8514cb5a5e2b40f)(textOrigin[1], layoutRect.height);
                    }
                    innerOrigin = true;
                    innerTransformable.originX = -innerTransformable.x + relOriginX + (isLocal ? 0 : layoutRect.x);
                    innerTransformable.originY = -innerTransformable.y + relOriginY + (isLocal ? 0 : layoutRect.y);
                }
            }
            if (textConfig.rotation != null) innerTransformable.rotation = textConfig.rotation;
            var textOffset = textConfig.offset;
            if (textOffset) {
                innerTransformable.x += textOffset[0];
                innerTransformable.y += textOffset[1];
                if (!innerOrigin) {
                    innerTransformable.originX = -textOffset[0];
                    innerTransformable.originY = -textOffset[1];
                }
            }
            var isInside = textConfig.inside == null ? typeof textConfig.position === 'string' && textConfig.position.indexOf('inside') >= 0 : textConfig.inside;
            var innerTextDefaultStyle = this._innerTextDefaultStyle || (this._innerTextDefaultStyle = {});
            var textFill = void 0;
            var textStroke = void 0;
            var autoStroke = void 0;
            if (isInside && this.canBeInsideText()) {
                textFill = textConfig.insideFill;
                textStroke = textConfig.insideStroke;
                if (textFill == null || textFill === 'auto') textFill = this.getInsideTextFill();
                if (textStroke == null || textStroke === 'auto') {
                    textStroke = this.getInsideTextStroke(textFill);
                    autoStroke = true;
                }
            } else {
                textFill = textConfig.outsideFill;
                textStroke = textConfig.outsideStroke;
                if (textFill == null || textFill === 'auto') textFill = this.getOutsideFill();
                if (textStroke == null || textStroke === 'auto') {
                    textStroke = this.getOutsideStroke(textFill);
                    autoStroke = true;
                }
            }
            textFill = textFill || '#000';
            if (textFill !== innerTextDefaultStyle.fill || textStroke !== innerTextDefaultStyle.stroke || autoStroke !== innerTextDefaultStyle.autoStroke || textAlign !== innerTextDefaultStyle.align || textVerticalAlign !== innerTextDefaultStyle.verticalAlign) {
                textStyleChanged = true;
                innerTextDefaultStyle.fill = textFill;
                innerTextDefaultStyle.stroke = textStroke;
                innerTextDefaultStyle.autoStroke = autoStroke;
                innerTextDefaultStyle.align = textAlign;
                innerTextDefaultStyle.verticalAlign = textVerticalAlign;
                textEl.setDefaultTextStyle(innerTextDefaultStyle);
            }
            textEl.__dirty |= (0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd);
            if (textStyleChanged) textEl.dirtyStyle(true);
        }
    };
    Element.prototype.canBeInsideText = function() {
        return true;
    };
    Element.prototype.getInsideTextFill = function() {
        return '#fff';
    };
    Element.prototype.getInsideTextStroke = function(textFill) {
        return '#000';
    };
    Element.prototype.getOutsideFill = function() {
        return this.__zr && this.__zr.isDarkMode() ? (0, $4b0cedd85979c776$export$3c6e95f318c8369b) : (0, $4b0cedd85979c776$export$f8ce94761f39398d);
    };
    Element.prototype.getOutsideStroke = function(textFill) {
        var backgroundColor = this.__zr && this.__zr.getBackgroundColor();
        var colorArr = typeof backgroundColor === 'string' && (0, $2c037f5bda6341ca$export$98e6a39c04603d36)(backgroundColor);
        if (!colorArr) colorArr = [
            255,
            255,
            255,
            1
        ];
        var alpha = colorArr[3];
        var isDark = this.__zr.isDarkMode();
        for(var i = 0; i < 3; i++)colorArr[i] = colorArr[i] * alpha + (isDark ? 0 : 255) * (1 - alpha);
        colorArr[3] = 1;
        return (0, $2c037f5bda6341ca$export$fac44ee5b035f737)(colorArr, 'rgba');
    };
    Element.prototype.traverse = function(cb, context) {};
    Element.prototype.attrKV = function(key, value) {
        if (key === 'textConfig') this.setTextConfig(value);
        else if (key === 'textContent') this.setTextContent(value);
        else if (key === 'clipPath') this.setClipPath(value);
        else if (key === 'extra') {
            this.extra = this.extra || {};
            (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(this.extra, value);
        } else this[key] = value;
    };
    Element.prototype.hide = function() {
        this.ignore = true;
        this.markRedraw();
    };
    Element.prototype.show = function() {
        this.ignore = false;
        this.markRedraw();
    };
    Element.prototype.attr = function(keyOrObj, value) {
        if (typeof keyOrObj === 'string') this.attrKV(keyOrObj, value);
        else if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(keyOrObj)) {
            var obj = keyOrObj;
            var keysArr = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(obj);
            for(var i = 0; i < keysArr.length; i++){
                var key = keysArr[i];
                this.attrKV(key, keyOrObj[key]);
            }
        }
        this.markRedraw();
        return this;
    };
    Element.prototype.saveCurrentToNormalState = function(toState) {
        this._innerSaveToNormal(toState);
        var normalState = this._normalState;
        for(var i = 0; i < this.animators.length; i++){
            var animator = this.animators[i];
            var fromStateTransition = animator.__fromStateTransition;
            if (animator.getLoop() || fromStateTransition && fromStateTransition !== $4bb0f26b847654d5$export$97b5e845c7286801) continue;
            var targetName = animator.targetName;
            var target = targetName ? normalState[targetName] : normalState;
            animator.saveTo(target);
        }
    };
    Element.prototype._innerSaveToNormal = function(toState) {
        var normalState = this._normalState;
        if (!normalState) normalState = this._normalState = {};
        if (toState.textConfig && !normalState.textConfig) normalState.textConfig = this.textConfig;
        this._savePrimaryToNormal(toState, normalState, $4bb0f26b847654d5$var$PRIMARY_STATES_KEYS);
    };
    Element.prototype._savePrimaryToNormal = function(toState, normalState, primaryKeys) {
        for(var i = 0; i < primaryKeys.length; i++){
            var key = primaryKeys[i];
            if (toState[key] != null && !(key in normalState)) normalState[key] = this[key];
        }
    };
    Element.prototype.hasState = function() {
        return this.currentStates.length > 0;
    };
    Element.prototype.getState = function(name) {
        return this.states[name];
    };
    Element.prototype.ensureState = function(name) {
        var states = this.states;
        if (!states[name]) states[name] = {};
        return states[name];
    };
    Element.prototype.clearStates = function(noAnimation) {
        this.useState($4bb0f26b847654d5$export$97b5e845c7286801, false, noAnimation);
    };
    Element.prototype.useState = function(stateName, keepCurrentStates, noAnimation, forceUseHoverLayer) {
        var toNormalState = stateName === $4bb0f26b847654d5$export$97b5e845c7286801;
        var hasStates = this.hasState();
        if (!hasStates && toNormalState) return;
        var currentStates = this.currentStates;
        var animationCfg = this.stateTransition;
        if ((0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(currentStates, stateName) >= 0 && (keepCurrentStates || currentStates.length === 1)) return;
        var state;
        if (this.stateProxy && !toNormalState) state = this.stateProxy(stateName);
        if (!state) state = this.states && this.states[stateName];
        if (!state && !toNormalState) {
            (0, $7a1bd9c2710fea0d$export$58da9968c3170cb1)("State " + stateName + " not exists.");
            return;
        }
        if (!toNormalState) this.saveCurrentToNormalState(state);
        var useHoverLayer = !!(state && state.hoverLayer || forceUseHoverLayer);
        if (useHoverLayer) this._toggleHoverLayerFlag(true);
        this._applyStateObj(stateName, state, this._normalState, keepCurrentStates, !noAnimation && !this.__inHover && animationCfg && animationCfg.duration > 0, animationCfg);
        var textContent = this._textContent;
        var textGuide = this._textGuide;
        if (textContent) textContent.useState(stateName, keepCurrentStates, noAnimation, useHoverLayer);
        if (textGuide) textGuide.useState(stateName, keepCurrentStates, noAnimation, useHoverLayer);
        if (toNormalState) {
            this.currentStates = [];
            this._normalState = {};
        } else if (!keepCurrentStates) this.currentStates = [
            stateName
        ];
        else this.currentStates.push(stateName);
        this._updateAnimationTargets();
        this.markRedraw();
        if (!useHoverLayer && this.__inHover) {
            this._toggleHoverLayerFlag(false);
            this.__dirty &= ~(0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd);
        }
        return state;
    };
    Element.prototype.useStates = function(states, noAnimation, forceUseHoverLayer) {
        if (!states.length) this.clearStates();
        else {
            var stateObjects = [];
            var currentStates = this.currentStates;
            var len = states.length;
            var notChange = len === currentStates.length;
            if (notChange) {
                for(var i = 0; i < len; i++)if (states[i] !== currentStates[i]) {
                    notChange = false;
                    break;
                }
            }
            if (notChange) return;
            for(var i = 0; i < len; i++){
                var stateName = states[i];
                var stateObj = void 0;
                if (this.stateProxy) stateObj = this.stateProxy(stateName, states);
                if (!stateObj) stateObj = this.states[stateName];
                if (stateObj) stateObjects.push(stateObj);
            }
            var lastStateObj = stateObjects[len - 1];
            var useHoverLayer = !!(lastStateObj && lastStateObj.hoverLayer || forceUseHoverLayer);
            if (useHoverLayer) this._toggleHoverLayerFlag(true);
            var mergedState = this._mergeStates(stateObjects);
            var animationCfg = this.stateTransition;
            this.saveCurrentToNormalState(mergedState);
            this._applyStateObj(states.join(','), mergedState, this._normalState, false, !noAnimation && !this.__inHover && animationCfg && animationCfg.duration > 0, animationCfg);
            var textContent = this._textContent;
            var textGuide = this._textGuide;
            if (textContent) textContent.useStates(states, noAnimation, useHoverLayer);
            if (textGuide) textGuide.useStates(states, noAnimation, useHoverLayer);
            this._updateAnimationTargets();
            this.currentStates = states.slice();
            this.markRedraw();
            if (!useHoverLayer && this.__inHover) {
                this._toggleHoverLayerFlag(false);
                this.__dirty &= ~(0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd);
            }
        }
    };
    Element.prototype.isSilent = function() {
        var isSilent = this.silent;
        var ancestor = this.parent;
        while(!isSilent && ancestor){
            if (ancestor.silent) {
                isSilent = true;
                break;
            }
            ancestor = ancestor.parent;
        }
        return isSilent;
    };
    Element.prototype._updateAnimationTargets = function() {
        for(var i = 0; i < this.animators.length; i++){
            var animator = this.animators[i];
            if (animator.targetName) animator.changeTarget(this[animator.targetName]);
        }
    };
    Element.prototype.removeState = function(state) {
        var idx = (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(this.currentStates, state);
        if (idx >= 0) {
            var currentStates = this.currentStates.slice();
            currentStates.splice(idx, 1);
            this.useStates(currentStates);
        }
    };
    Element.prototype.replaceState = function(oldState, newState, forceAdd) {
        var currentStates = this.currentStates.slice();
        var idx = (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(currentStates, oldState);
        var newStateExists = (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(currentStates, newState) >= 0;
        if (idx >= 0) {
            if (!newStateExists) currentStates[idx] = newState;
            else currentStates.splice(idx, 1);
        } else if (forceAdd && !newStateExists) currentStates.push(newState);
        this.useStates(currentStates);
    };
    Element.prototype.toggleState = function(state, enable) {
        if (enable) this.useState(state, true);
        else this.removeState(state);
    };
    Element.prototype._mergeStates = function(states) {
        var mergedState = {};
        var mergedTextConfig;
        for(var i = 0; i < states.length; i++){
            var state = states[i];
            (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(mergedState, state);
            if (state.textConfig) {
                mergedTextConfig = mergedTextConfig || {};
                (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(mergedTextConfig, state.textConfig);
            }
        }
        if (mergedTextConfig) mergedState.textConfig = mergedTextConfig;
        return mergedState;
    };
    Element.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        var needsRestoreToNormal = !(state && keepCurrentStates);
        if (state && state.textConfig) {
            this.textConfig = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, keepCurrentStates ? this.textConfig : normalState.textConfig);
            (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(this.textConfig, state.textConfig);
        } else if (needsRestoreToNormal) {
            if (normalState.textConfig) this.textConfig = normalState.textConfig;
        }
        var transitionTarget = {};
        var hasTransition = false;
        for(var i = 0; i < $4bb0f26b847654d5$var$PRIMARY_STATES_KEYS.length; i++){
            var key = $4bb0f26b847654d5$var$PRIMARY_STATES_KEYS[i];
            var propNeedsTransition = transition && $4bb0f26b847654d5$var$DEFAULT_ANIMATABLE_MAP[key];
            if (state && state[key] != null) {
                if (propNeedsTransition) {
                    hasTransition = true;
                    transitionTarget[key] = state[key];
                } else this[key] = state[key];
            } else if (needsRestoreToNormal) {
                if (normalState[key] != null) {
                    if (propNeedsTransition) {
                        hasTransition = true;
                        transitionTarget[key] = normalState[key];
                    } else this[key] = normalState[key];
                }
            }
        }
        if (!transition) for(var i = 0; i < this.animators.length; i++){
            var animator = this.animators[i];
            var targetName = animator.targetName;
            if (!animator.getLoop()) animator.__changeFinalValue(targetName ? (state || normalState)[targetName] : state || normalState);
        }
        if (hasTransition) this._transitionState(stateName, transitionTarget, animationCfg);
    };
    Element.prototype._attachComponent = function(componentEl) {
        if (componentEl.__zr && !componentEl.__hostTarget) return;
        if (componentEl === this) return;
        var zr = this.__zr;
        if (zr) componentEl.addSelfToZr(zr);
        componentEl.__zr = zr;
        componentEl.__hostTarget = this;
    };
    Element.prototype._detachComponent = function(componentEl) {
        if (componentEl.__zr) componentEl.removeSelfFromZr(componentEl.__zr);
        componentEl.__zr = null;
        componentEl.__hostTarget = null;
    };
    Element.prototype.getClipPath = function() {
        return this._clipPath;
    };
    Element.prototype.setClipPath = function(clipPath) {
        if (this._clipPath && this._clipPath !== clipPath) this.removeClipPath();
        this._attachComponent(clipPath);
        this._clipPath = clipPath;
        this.markRedraw();
    };
    Element.prototype.removeClipPath = function() {
        var clipPath = this._clipPath;
        if (clipPath) {
            this._detachComponent(clipPath);
            this._clipPath = null;
            this.markRedraw();
        }
    };
    Element.prototype.getTextContent = function() {
        return this._textContent;
    };
    Element.prototype.setTextContent = function(textEl) {
        var previousTextContent = this._textContent;
        if (previousTextContent === textEl) return;
        if (previousTextContent && previousTextContent !== textEl) this.removeTextContent();
        textEl.innerTransformable = new (0, $becf2d727f9cf450$export$2e2bcd8739ae039)();
        this._attachComponent(textEl);
        this._textContent = textEl;
        this.markRedraw();
    };
    Element.prototype.setTextConfig = function(cfg) {
        if (!this.textConfig) this.textConfig = {};
        (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(this.textConfig, cfg);
        this.markRedraw();
    };
    Element.prototype.removeTextConfig = function() {
        this.textConfig = null;
        this.markRedraw();
    };
    Element.prototype.removeTextContent = function() {
        var textEl = this._textContent;
        if (textEl) {
            textEl.innerTransformable = null;
            this._detachComponent(textEl);
            this._textContent = null;
            this._innerTextDefaultStyle = null;
            this.markRedraw();
        }
    };
    Element.prototype.getTextGuideLine = function() {
        return this._textGuide;
    };
    Element.prototype.setTextGuideLine = function(guideLine) {
        if (this._textGuide && this._textGuide !== guideLine) this.removeTextGuideLine();
        this._attachComponent(guideLine);
        this._textGuide = guideLine;
        this.markRedraw();
    };
    Element.prototype.removeTextGuideLine = function() {
        var textGuide = this._textGuide;
        if (textGuide) {
            this._detachComponent(textGuide);
            this._textGuide = null;
            this.markRedraw();
        }
    };
    Element.prototype.markRedraw = function() {
        this.__dirty |= (0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd);
        var zr = this.__zr;
        if (zr) {
            if (this.__inHover) zr.refreshHover();
            else zr.refresh();
        }
        if (this.__hostTarget) this.__hostTarget.markRedraw();
    };
    Element.prototype.dirty = function() {
        this.markRedraw();
    };
    Element.prototype._toggleHoverLayerFlag = function(inHover) {
        this.__inHover = inHover;
        var textContent = this._textContent;
        var textGuide = this._textGuide;
        if (textContent) textContent.__inHover = inHover;
        if (textGuide) textGuide.__inHover = inHover;
    };
    Element.prototype.addSelfToZr = function(zr) {
        if (this.__zr === zr) return;
        this.__zr = zr;
        var animators = this.animators;
        if (animators) for(var i = 0; i < animators.length; i++)zr.animation.addAnimator(animators[i]);
        if (this._clipPath) this._clipPath.addSelfToZr(zr);
        if (this._textContent) this._textContent.addSelfToZr(zr);
        if (this._textGuide) this._textGuide.addSelfToZr(zr);
    };
    Element.prototype.removeSelfFromZr = function(zr) {
        if (!this.__zr) return;
        this.__zr = null;
        var animators = this.animators;
        if (animators) for(var i = 0; i < animators.length; i++)zr.animation.removeAnimator(animators[i]);
        if (this._clipPath) this._clipPath.removeSelfFromZr(zr);
        if (this._textContent) this._textContent.removeSelfFromZr(zr);
        if (this._textGuide) this._textGuide.removeSelfFromZr(zr);
    };
    Element.prototype.animate = function(key, loop, allowDiscreteAnimation) {
        var target = key ? this[key] : this;
        var animator = new (0, $76d8a142a20276fc$export$2e2bcd8739ae039)(target, loop, allowDiscreteAnimation);
        key && (animator.targetName = key);
        this.addAnimator(animator, key);
        return animator;
    };
    Element.prototype.addAnimator = function(animator, key) {
        var zr = this.__zr;
        var el = this;
        animator.during(function() {
            el.updateDuringAnimation(key);
        }).done(function() {
            var animators = el.animators;
            var idx = (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(animators, animator);
            if (idx >= 0) animators.splice(idx, 1);
        });
        this.animators.push(animator);
        if (zr) zr.animation.addAnimator(animator);
        zr && zr.wakeUp();
    };
    Element.prototype.updateDuringAnimation = function(key) {
        this.markRedraw();
    };
    Element.prototype.stopAnimation = function(scope, forwardToLast) {
        var animators = this.animators;
        var len = animators.length;
        var leftAnimators = [];
        for(var i = 0; i < len; i++){
            var animator = animators[i];
            if (!scope || scope === animator.scope) animator.stop(forwardToLast);
            else leftAnimators.push(animator);
        }
        this.animators = leftAnimators;
        return this;
    };
    Element.prototype.animateTo = function(target, cfg, animationProps) {
        $4bb0f26b847654d5$var$animateTo(this, target, cfg, animationProps);
    };
    Element.prototype.animateFrom = function(target, cfg, animationProps) {
        $4bb0f26b847654d5$var$animateTo(this, target, cfg, animationProps, true);
    };
    Element.prototype._transitionState = function(stateName, target, cfg, animationProps) {
        var animators = $4bb0f26b847654d5$var$animateTo(this, target, cfg, animationProps);
        for(var i = 0; i < animators.length; i++)animators[i].__fromStateTransition = stateName;
    };
    Element.prototype.getBoundingRect = function() {
        return null;
    };
    Element.prototype.getPaintRect = function() {
        return null;
    };
    Element.initDefaultProps = function() {
        var elProto = Element.prototype;
        elProto.type = 'element';
        elProto.name = '';
        elProto.ignore = elProto.silent = elProto.isGroup = elProto.draggable = elProto.dragging = elProto.ignoreClip = elProto.__inHover = false;
        elProto.__dirty = (0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd);
        var logs = {};
        function logDeprecatedError(key, xKey, yKey) {
            if (!logs[key + xKey + yKey]) {
                console.warn("DEPRECATED: '" + key + "' has been deprecated. use '" + xKey + "', '" + yKey + "' instead");
                logs[key + xKey + yKey] = true;
            }
        }
        function createLegacyProperty(key, privateKey, xKey, yKey) {
            Object.defineProperty(elProto, key, {
                get: function() {
                    if (!this[privateKey]) {
                        var pos = this[privateKey] = [];
                        enhanceArray(this, pos);
                    }
                    return this[privateKey];
                },
                set: function(pos) {
                    this[xKey] = pos[0];
                    this[yKey] = pos[1];
                    this[privateKey] = pos;
                    enhanceArray(this, pos);
                }
            });
            function enhanceArray(self, pos) {
                Object.defineProperty(pos, 0, {
                    get: function() {
                        return self[xKey];
                    },
                    set: function(val) {
                        self[xKey] = val;
                    }
                });
                Object.defineProperty(pos, 1, {
                    get: function() {
                        return self[yKey];
                    },
                    set: function(val) {
                        self[yKey] = val;
                    }
                });
            }
        }
        if (Object.defineProperty) {
            createLegacyProperty('position', '_legacyPos', 'x', 'y');
            createLegacyProperty('scale', '_legacyScale', 'scaleX', 'scaleY');
            createLegacyProperty('origin', '_legacyOrigin', 'originX', 'originY');
        }
    }();
    return Element;
}();
(0, $7a1bd9c2710fea0d$export$e36fc9d62a853069)($4bb0f26b847654d5$var$Element, (0, $63441a86293f101f$export$2e2bcd8739ae039));
(0, $7a1bd9c2710fea0d$export$e36fc9d62a853069)($4bb0f26b847654d5$var$Element, (0, $becf2d727f9cf450$export$2e2bcd8739ae039));
function $4bb0f26b847654d5$var$animateTo(animatable, target, cfg, animationProps, reverse) {
    cfg = cfg || {};
    var animators = [];
    $4bb0f26b847654d5$var$animateToShallow(animatable, '', animatable, target, cfg, animationProps, animators, reverse);
    var finishCount = animators.length;
    var doneHappened = false;
    var cfgDone = cfg.done;
    var cfgAborted = cfg.aborted;
    var doneCb = function() {
        doneHappened = true;
        finishCount--;
        if (finishCount <= 0) doneHappened ? cfgDone && cfgDone() : cfgAborted && cfgAborted();
    };
    var abortedCb = function() {
        finishCount--;
        if (finishCount <= 0) doneHappened ? cfgDone && cfgDone() : cfgAborted && cfgAborted();
    };
    if (!finishCount) cfgDone && cfgDone();
    if (animators.length > 0 && cfg.during) animators[0].during(function(target, percent) {
        cfg.during(percent);
    });
    for(var i = 0; i < animators.length; i++){
        var animator = animators[i];
        if (doneCb) animator.done(doneCb);
        if (abortedCb) animator.aborted(abortedCb);
        if (cfg.force) animator.duration(cfg.duration);
        animator.start(cfg.easing);
    }
    return animators;
}
function $4bb0f26b847654d5$var$copyArrShallow(source, target, len) {
    for(var i = 0; i < len; i++)source[i] = target[i];
}
function $4bb0f26b847654d5$var$is2DArray(value) {
    return (0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(value[0]);
}
function $4bb0f26b847654d5$var$copyValue(target, source, key) {
    if ((0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(source[key])) {
        if (!(0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(target[key])) target[key] = [];
        if ((0, $7a1bd9c2710fea0d$export$b119cc7e1840e59c)(source[key])) {
            var len = source[key].length;
            if (target[key].length !== len) {
                target[key] = new source[key].constructor(len);
                $4bb0f26b847654d5$var$copyArrShallow(target[key], source[key], len);
            }
        } else {
            var sourceArr = source[key];
            var targetArr = target[key];
            var len0 = sourceArr.length;
            if ($4bb0f26b847654d5$var$is2DArray(sourceArr)) {
                var len1 = sourceArr[0].length;
                for(var i = 0; i < len0; i++)if (!targetArr[i]) targetArr[i] = Array.prototype.slice.call(sourceArr[i]);
                else $4bb0f26b847654d5$var$copyArrShallow(targetArr[i], sourceArr[i], len1);
            } else $4bb0f26b847654d5$var$copyArrShallow(targetArr, sourceArr, len0);
            targetArr.length = sourceArr.length;
        }
    } else target[key] = source[key];
}
function $4bb0f26b847654d5$var$isValueSame(val1, val2) {
    return val1 === val2 || (0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(val1) && (0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(val2) && $4bb0f26b847654d5$var$is1DArraySame(val1, val2);
}
function $4bb0f26b847654d5$var$is1DArraySame(arr0, arr1) {
    var len = arr0.length;
    if (len !== arr1.length) return false;
    for(var i = 0; i < len; i++){
        if (arr0[i] !== arr1[i]) return false;
    }
    return true;
}
function $4bb0f26b847654d5$var$animateToShallow(animatable, topKey, animateObj, target, cfg, animationProps, animators, reverse) {
    var targetKeys = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(target);
    var duration = cfg.duration;
    var delay = cfg.delay;
    var additive = cfg.additive;
    var setToFinal = cfg.setToFinal;
    var animateAll = !(0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(animationProps);
    var existsAnimators = animatable.animators;
    var animationKeys = [];
    for(var k = 0; k < targetKeys.length; k++){
        var innerKey = targetKeys[k];
        var targetVal = target[innerKey];
        if (targetVal != null && animateObj[innerKey] != null && (animateAll || animationProps[innerKey])) {
            if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(targetVal) && !(0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(targetVal) && !(0, $7a1bd9c2710fea0d$export$fa2c283003ed971c)(targetVal)) {
                if (topKey) {
                    if (!reverse) {
                        animateObj[innerKey] = targetVal;
                        animatable.updateDuringAnimation(topKey);
                    }
                    continue;
                }
                $4bb0f26b847654d5$var$animateToShallow(animatable, innerKey, animateObj[innerKey], targetVal, cfg, animationProps && animationProps[innerKey], animators, reverse);
            } else animationKeys.push(innerKey);
        } else if (!reverse) {
            animateObj[innerKey] = targetVal;
            animatable.updateDuringAnimation(topKey);
            animationKeys.push(innerKey);
        }
    }
    var keyLen = animationKeys.length;
    if (!additive && keyLen) for(var i = 0; i < existsAnimators.length; i++){
        var animator = existsAnimators[i];
        if (animator.targetName === topKey) {
            var allAborted = animator.stopTracks(animationKeys);
            if (allAborted) {
                var idx = (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(existsAnimators, animator);
                existsAnimators.splice(idx, 1);
            }
        }
    }
    if (!cfg.force) {
        animationKeys = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(animationKeys, function(key) {
            return !$4bb0f26b847654d5$var$isValueSame(target[key], animateObj[key]);
        });
        keyLen = animationKeys.length;
    }
    if (keyLen > 0 || cfg.force && !animators.length) {
        var revertedSource = void 0;
        var reversedTarget = void 0;
        var sourceClone = void 0;
        if (reverse) {
            reversedTarget = {};
            if (setToFinal) revertedSource = {};
            for(var i = 0; i < keyLen; i++){
                var innerKey = animationKeys[i];
                reversedTarget[innerKey] = animateObj[innerKey];
                if (setToFinal) revertedSource[innerKey] = target[innerKey];
                else animateObj[innerKey] = target[innerKey];
            }
        } else if (setToFinal) {
            sourceClone = {};
            for(var i = 0; i < keyLen; i++){
                var innerKey = animationKeys[i];
                sourceClone[innerKey] = (0, $76d8a142a20276fc$export$c5e92b7f105af84e)(animateObj[innerKey]);
                $4bb0f26b847654d5$var$copyValue(animateObj, target, innerKey);
            }
        }
        var animator = new (0, $76d8a142a20276fc$export$2e2bcd8739ae039)(animateObj, false, false, additive ? (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(existsAnimators, function(animator) {
            return animator.targetName === topKey;
        }) : null);
        animator.targetName = topKey;
        if (cfg.scope) animator.scope = cfg.scope;
        if (setToFinal && revertedSource) animator.whenWithKeys(0, revertedSource, animationKeys);
        if (sourceClone) animator.whenWithKeys(0, sourceClone, animationKeys);
        animator.whenWithKeys(duration == null ? 500 : duration, reverse ? reversedTarget : target, animationKeys).delay(delay || 0);
        animatable.addAnimator(animator, topKey);
        animators.push(animator);
    }
}
var $4bb0f26b847654d5$export$2e2bcd8739ae039 = $4bb0f26b847654d5$var$Element;



var $7ef7583d8302ffce$var$Group = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Group, _super);
    function Group(opts) {
        var _this = _super.call(this) || this;
        _this.isGroup = true;
        _this._children = [];
        _this.attr(opts);
        return _this;
    }
    Group.prototype.childrenRef = function() {
        return this._children;
    };
    Group.prototype.children = function() {
        return this._children.slice();
    };
    Group.prototype.childAt = function(idx) {
        return this._children[idx];
    };
    Group.prototype.childOfName = function(name) {
        var children = this._children;
        for(var i = 0; i < children.length; i++){
            if (children[i].name === name) return children[i];
        }
    };
    Group.prototype.childCount = function() {
        return this._children.length;
    };
    Group.prototype.add = function(child) {
        if (child) {
            if (child !== this && child.parent !== this) {
                this._children.push(child);
                this._doAdd(child);
            }
        }
        return this;
    };
    Group.prototype.addBefore = function(child, nextSibling) {
        if (child && child !== this && child.parent !== this && nextSibling && nextSibling.parent === this) {
            var children = this._children;
            var idx = children.indexOf(nextSibling);
            if (idx >= 0) {
                children.splice(idx, 0, child);
                this._doAdd(child);
            }
        }
        return this;
    };
    Group.prototype.replace = function(oldChild, newChild) {
        var idx = $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(this._children, oldChild);
        if (idx >= 0) this.replaceAt(newChild, idx);
        return this;
    };
    Group.prototype.replaceAt = function(child, index) {
        var children = this._children;
        var old = children[index];
        if (child && child !== this && child.parent !== this && child !== old) {
            children[index] = child;
            old.parent = null;
            var zr = this.__zr;
            if (zr) old.removeSelfFromZr(zr);
            this._doAdd(child);
        }
        return this;
    };
    Group.prototype._doAdd = function(child) {
        if (child.parent) child.parent.remove(child);
        child.parent = this;
        var zr = this.__zr;
        if (zr && zr !== child.__zr) child.addSelfToZr(zr);
        zr && zr.refresh();
    };
    Group.prototype.remove = function(child) {
        var zr = this.__zr;
        var children = this._children;
        var idx = $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(children, child);
        if (idx < 0) return this;
        children.splice(idx, 1);
        child.parent = null;
        if (zr) child.removeSelfFromZr(zr);
        zr && zr.refresh();
        return this;
    };
    Group.prototype.removeAll = function() {
        var children = this._children;
        var zr = this.__zr;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            if (zr) child.removeSelfFromZr(zr);
            child.parent = null;
        }
        children.length = 0;
        return this;
    };
    Group.prototype.eachChild = function(cb, context) {
        var children = this._children;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            cb.call(context, child, i);
        }
        return this;
    };
    Group.prototype.traverse = function(cb, context) {
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            var stopped = cb.call(context, child);
            if (child.isGroup && !stopped) child.traverse(cb, context);
        }
        return this;
    };
    Group.prototype.addSelfToZr = function(zr) {
        _super.prototype.addSelfToZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            child.addSelfToZr(zr);
        }
    };
    Group.prototype.removeSelfFromZr = function(zr) {
        _super.prototype.removeSelfFromZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            child.removeSelfFromZr(zr);
        }
    };
    Group.prototype.getBoundingRect = function(includeChildren) {
        var tmpRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
        var children = includeChildren || this._children;
        var tmpMat = [];
        var rect = null;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            if (child.ignore || child.invisible) continue;
            var childRect = child.getBoundingRect();
            var transform = child.getLocalTransform(tmpMat);
            if (transform) {
                (0, $1bebe7106c895823$export$2e2bcd8739ae039).applyTransform(tmpRect, childRect, transform);
                rect = rect || tmpRect.clone();
                rect.union(tmpRect);
            } else {
                rect = rect || childRect.clone();
                rect.union(childRect);
            }
        }
        return rect || tmpRect;
    };
    return Group;
}((0, $4bb0f26b847654d5$export$2e2bcd8739ae039));
$7ef7583d8302ffce$var$Group.prototype.type = 'group';
var $7ef7583d8302ffce$export$2e2bcd8739ae039 = $7ef7583d8302ffce$var$Group;


var $6eba88f9eebe6af9$var$painterCtors = {};
var $6eba88f9eebe6af9$var$instances = {};
function $6eba88f9eebe6af9$var$delInstance(id) {
    delete $6eba88f9eebe6af9$var$instances[id];
}
function $6eba88f9eebe6af9$var$isDarkMode(backgroundColor) {
    if (!backgroundColor) return false;
    if (typeof backgroundColor === 'string') return (0, $2c037f5bda6341ca$export$16c0ec21a6f9ef95)(backgroundColor, 1) < (0, $4b0cedd85979c776$export$fd81e7ebc7dae256);
    else if (backgroundColor.colorStops) {
        var colorStops = backgroundColor.colorStops;
        var totalLum = 0;
        var len = colorStops.length;
        for(var i = 0; i < len; i++)totalLum += (0, $2c037f5bda6341ca$export$16c0ec21a6f9ef95)(colorStops[i].color, 1);
        totalLum /= len;
        return totalLum < (0, $4b0cedd85979c776$export$fd81e7ebc7dae256);
    }
    return false;
}
var $6eba88f9eebe6af9$var$ZRender = function() {
    function ZRender(id, dom, opts) {
        var _this = this;
        this._sleepAfterStill = 10;
        this._stillFrameAccum = 0;
        this._needsRefresh = true;
        this._needsRefreshHover = true;
        this._darkMode = false;
        opts = opts || {};
        this.dom = dom;
        this.id = id;
        var storage = new (0, $319574df0bc66e80$export$2e2bcd8739ae039)();
        var rendererType = opts.renderer || 'canvas';
        if (!$6eba88f9eebe6af9$var$painterCtors[rendererType]) rendererType = $7a1bd9c2710fea0d$export$ed97f33186d4b816($6eba88f9eebe6af9$var$painterCtors)[0];
        opts.useDirtyRect = opts.useDirtyRect == null ? false : opts.useDirtyRect;
        var painter = new $6eba88f9eebe6af9$var$painterCtors[rendererType](dom, storage, opts, id);
        var ssrMode = opts.ssr || painter.ssrOnly;
        this.storage = storage;
        this.painter = painter;
        var handlerProxy = !(0, $ce6dd58693a21851$export$2e2bcd8739ae039).node && !(0, $ce6dd58693a21851$export$2e2bcd8739ae039).worker && !ssrMode ? new (0, $c0dbbc6989260eee$export$2e2bcd8739ae039)(painter.getViewportRoot(), painter.root) : null;
        var useCoarsePointer = opts.useCoarsePointer;
        var usePointerSize = useCoarsePointer == null || useCoarsePointer === 'auto' ? (0, $ce6dd58693a21851$export$2e2bcd8739ae039).touchEventsSupported : !!useCoarsePointer;
        var defaultPointerSize = 44;
        var pointerSize;
        if (usePointerSize) pointerSize = $7a1bd9c2710fea0d$export$995e01f2f5c9d030(opts.pointerSize, defaultPointerSize);
        this.handler = new (0, $b30f5d021af2ec5a$export$2e2bcd8739ae039)(storage, painter, handlerProxy, painter.root, pointerSize);
        this.animation = new (0, $fad434a4044c956a$export$2e2bcd8739ae039)({
            stage: {
                update: ssrMode ? null : function() {
                    return _this._flush(true);
                }
            }
        });
        if (!ssrMode) this.animation.start();
    }
    ZRender.prototype.add = function(el) {
        if (this._disposed || !el) return;
        this.storage.addRoot(el);
        el.addSelfToZr(this);
        this.refresh();
    };
    ZRender.prototype.remove = function(el) {
        if (this._disposed || !el) return;
        this.storage.delRoot(el);
        el.removeSelfFromZr(this);
        this.refresh();
    };
    ZRender.prototype.configLayer = function(zLevel, config) {
        if (this._disposed) return;
        if (this.painter.configLayer) this.painter.configLayer(zLevel, config);
        this.refresh();
    };
    ZRender.prototype.setBackgroundColor = function(backgroundColor) {
        if (this._disposed) return;
        if (this.painter.setBackgroundColor) this.painter.setBackgroundColor(backgroundColor);
        this.refresh();
        this._backgroundColor = backgroundColor;
        this._darkMode = $6eba88f9eebe6af9$var$isDarkMode(backgroundColor);
    };
    ZRender.prototype.getBackgroundColor = function() {
        return this._backgroundColor;
    };
    ZRender.prototype.setDarkMode = function(darkMode) {
        this._darkMode = darkMode;
    };
    ZRender.prototype.isDarkMode = function() {
        return this._darkMode;
    };
    ZRender.prototype.refreshImmediately = function(fromInside) {
        if (this._disposed) return;
        if (!fromInside) this.animation.update(true);
        this._needsRefresh = false;
        this.painter.refresh();
        this._needsRefresh = false;
    };
    ZRender.prototype.refresh = function() {
        if (this._disposed) return;
        this._needsRefresh = true;
        this.animation.start();
    };
    ZRender.prototype.flush = function() {
        if (this._disposed) return;
        this._flush(false);
    };
    ZRender.prototype._flush = function(fromInside) {
        var triggerRendered;
        var start = (0, $fad434a4044c956a$export$1428f42a7de81803)();
        if (this._needsRefresh) {
            triggerRendered = true;
            this.refreshImmediately(fromInside);
        }
        if (this._needsRefreshHover) {
            triggerRendered = true;
            this.refreshHoverImmediately();
        }
        var end = (0, $fad434a4044c956a$export$1428f42a7de81803)();
        if (triggerRendered) {
            this._stillFrameAccum = 0;
            this.trigger('rendered', {
                elapsedTime: end - start
            });
        } else if (this._sleepAfterStill > 0) {
            this._stillFrameAccum++;
            if (this._stillFrameAccum > this._sleepAfterStill) this.animation.stop();
        }
    };
    ZRender.prototype.setSleepAfterStill = function(stillFramesCount) {
        this._sleepAfterStill = stillFramesCount;
    };
    ZRender.prototype.wakeUp = function() {
        if (this._disposed) return;
        this.animation.start();
        this._stillFrameAccum = 0;
    };
    ZRender.prototype.refreshHover = function() {
        this._needsRefreshHover = true;
    };
    ZRender.prototype.refreshHoverImmediately = function() {
        if (this._disposed) return;
        this._needsRefreshHover = false;
        if (this.painter.refreshHover && this.painter.getType() === 'canvas') this.painter.refreshHover();
    };
    ZRender.prototype.resize = function(opts) {
        if (this._disposed) return;
        opts = opts || {};
        this.painter.resize(opts.width, opts.height);
        this.handler.resize();
    };
    ZRender.prototype.clearAnimation = function() {
        if (this._disposed) return;
        this.animation.clear();
    };
    ZRender.prototype.getWidth = function() {
        if (this._disposed) return;
        return this.painter.getWidth();
    };
    ZRender.prototype.getHeight = function() {
        if (this._disposed) return;
        return this.painter.getHeight();
    };
    ZRender.prototype.setCursorStyle = function(cursorStyle) {
        if (this._disposed) return;
        this.handler.setCursorStyle(cursorStyle);
    };
    ZRender.prototype.findHover = function(x, y) {
        if (this._disposed) return;
        return this.handler.findHover(x, y);
    };
    ZRender.prototype.on = function(eventName, eventHandler, context) {
        if (!this._disposed) this.handler.on(eventName, eventHandler, context);
        return this;
    };
    ZRender.prototype.off = function(eventName, eventHandler) {
        if (this._disposed) return;
        this.handler.off(eventName, eventHandler);
    };
    ZRender.prototype.trigger = function(eventName, event) {
        if (this._disposed) return;
        this.handler.trigger(eventName, event);
    };
    ZRender.prototype.clear = function() {
        if (this._disposed) return;
        var roots = this.storage.getRoots();
        for(var i = 0; i < roots.length; i++)if (roots[i] instanceof (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)) roots[i].removeSelfFromZr(this);
        this.storage.delAllRoots();
        this.painter.clear();
    };
    ZRender.prototype.dispose = function() {
        if (this._disposed) return;
        this.animation.stop();
        this.clear();
        this.storage.dispose();
        this.painter.dispose();
        this.handler.dispose();
        this.animation = this.storage = this.painter = this.handler = null;
        this._disposed = true;
        $6eba88f9eebe6af9$var$delInstance(this.id);
    };
    return ZRender;
}();
function $6eba88f9eebe6af9$export$2cd8252107eb640b(dom, opts) {
    var zr = new $6eba88f9eebe6af9$var$ZRender($7a1bd9c2710fea0d$export$46e8f25c7328f77e(), dom, opts);
    $6eba88f9eebe6af9$var$instances[zr.id] = zr;
    return zr;
}
function $6eba88f9eebe6af9$export$fcfbbcec2cb820d5(zr) {
    zr.dispose();
}
function $6eba88f9eebe6af9$export$825f692fb04800ef() {
    for(var key in $6eba88f9eebe6af9$var$instances)if ($6eba88f9eebe6af9$var$instances.hasOwnProperty(key)) $6eba88f9eebe6af9$var$instances[key].dispose();
    $6eba88f9eebe6af9$var$instances = {};
}
function $6eba88f9eebe6af9$export$8bedcca5bbd73999(id) {
    return $6eba88f9eebe6af9$var$instances[id];
}
function $6eba88f9eebe6af9$export$a3e793ccb11823a5(name, Ctor) {
    $6eba88f9eebe6af9$var$painterCtors[name] = Ctor;
}
var $6eba88f9eebe6af9$var$ssrDataGetter;
function $6eba88f9eebe6af9$export$dd7015a5412ca583(el) {
    if (typeof $6eba88f9eebe6af9$var$ssrDataGetter === 'function') return $6eba88f9eebe6af9$var$ssrDataGetter(el);
}
function $6eba88f9eebe6af9$export$e7a09d7fe68a4f7(getter) {
    $6eba88f9eebe6af9$var$ssrDataGetter = getter;
}
var $6eba88f9eebe6af9$export$83d89fbfd8236492 = '5.6.1';






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* A third-party license is embedded for some of the code in this file:
* The method "quantile" was copied from "d3.js".
* (See more details in the comment of the method below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the license of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/ 
var $cfc1f3b422a3185f$var$RADIAN_EPSILON = 1e-4;
// Although chrome already enlarge this number to 100 for `toFixed`, but
// we sill follow the spec for compatibility.
var $cfc1f3b422a3185f$var$ROUND_SUPPORTED_PRECISION_MAX = 20;
function $cfc1f3b422a3185f$var$_trim(str) {
    return str.replace(/^\s+|\s+$/g, '');
}
function $cfc1f3b422a3185f$export$d3f68fbaa670562(val, domain, range, clamp) {
    var d0 = domain[0];
    var d1 = domain[1];
    var r0 = range[0];
    var r1 = range[1];
    var subDomain = d1 - d0;
    var subRange = r1 - r0;
    if (subDomain === 0) return subRange === 0 ? r0 : (r0 + r1) / 2;
    // Avoid accuracy problem in edge, such as
    // 146.39 - 62.83 === 83.55999999999999.
    // See echarts/test/ut/spec/util/number.js#linearMap#accuracyError
    // It is a little verbose for efficiency considering this method
    // is a hotspot.
    if (clamp) {
        if (subDomain > 0) {
            if (val <= d0) return r0;
            else if (val >= d1) return r1;
        } else {
            if (val >= d0) return r0;
            else if (val <= d1) return r1;
        }
    } else {
        if (val === d0) return r0;
        if (val === d1) return r1;
    }
    return (val - d0) / subDomain * subRange + r0;
}
function $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(percent, all) {
    switch(percent){
        case 'center':
        case 'middle':
            percent = '50%';
            break;
        case 'left':
        case 'top':
            percent = '0%';
            break;
        case 'right':
        case 'bottom':
            percent = '100%';
            break;
    }
    if ($7a1bd9c2710fea0d$export$844ec244b1367d54(percent)) {
        if ($cfc1f3b422a3185f$var$_trim(percent).match(/%$/)) return parseFloat(percent) / 100 * all;
        return parseFloat(percent);
    }
    return percent == null ? NaN : +percent;
}
function $cfc1f3b422a3185f$export$2077e0241d6afd3c(x, precision, returnStr) {
    if (precision == null) precision = 10;
    // Avoid range error
    precision = Math.min(Math.max(0, precision), $cfc1f3b422a3185f$var$ROUND_SUPPORTED_PRECISION_MAX);
    // PENDING: 1.005.toFixed(2) is '1.00' rather than '1.01'
    x = (+x).toFixed(precision);
    return returnStr ? x : +x;
}
function $cfc1f3b422a3185f$export$debe6e778e0a6d32(arr) {
    arr.sort(function(a, b) {
        return a - b;
    });
    return arr;
}
function $cfc1f3b422a3185f$export$e0c74b50bbd10f68(val) {
    val = +val;
    if (isNaN(val)) return 0;
    // It is much faster than methods converting number to string as follows
    //      let tmp = val.toString();
    //      return tmp.length - 1 - tmp.indexOf('.');
    // especially when precision is low
    // Notice:
    // (1) If the loop count is over about 20, it is slower than `getPrecisionSafe`.
    //     (see https://jsbench.me/2vkpcekkvw/1)
    // (2) If the val is less than for example 1e-15, the result may be incorrect.
    //     (see test/ut/spec/util/number.test.ts `getPrecision_equal_random`)
    if (val > 1e-14) {
        var e = 1;
        for(var i = 0; i < 15; i++, e *= 10){
            if (Math.round(val * e) / e === val) return i;
        }
    }
    return $cfc1f3b422a3185f$export$6d86ba4ca4984d31(val);
}
function $cfc1f3b422a3185f$export$6d86ba4ca4984d31(val) {
    // toLowerCase for: '3.4E-12'
    var str = val.toString().toLowerCase();
    // Consider scientific notation: '3.4e-12' '3.4e+12'
    var eIndex = str.indexOf('e');
    var exp = eIndex > 0 ? +str.slice(eIndex + 1) : 0;
    var significandPartLen = eIndex > 0 ? eIndex : str.length;
    var dotIndex = str.indexOf('.');
    var decimalPartLen = dotIndex < 0 ? 0 : significandPartLen - 1 - dotIndex;
    return Math.max(0, decimalPartLen - exp);
}
function $cfc1f3b422a3185f$export$666260d9a2dda8a7(dataExtent, pixelExtent) {
    var log = Math.log;
    var LN10 = Math.LN10;
    var dataQuantity = Math.floor(log(dataExtent[1] - dataExtent[0]) / LN10);
    var sizeQuantity = Math.round(log(Math.abs(pixelExtent[1] - pixelExtent[0])) / LN10);
    // toFixed() digits argument must be between 0 and 20.
    var precision = Math.min(Math.max(-dataQuantity + sizeQuantity, 0), 20);
    return !isFinite(precision) ? 20 : precision;
}
function $cfc1f3b422a3185f$export$70cc11b075afeb90(valueList, idx, precision) {
    if (!valueList[idx]) return 0;
    var seats = $cfc1f3b422a3185f$export$222dabb13d5320df(valueList, precision);
    return seats[idx] || 0;
}
function $cfc1f3b422a3185f$export$222dabb13d5320df(valueList, precision) {
    var sum = $7a1bd9c2710fea0d$export$533b26079ad0b4b(valueList, function(acc, val) {
        return acc + (isNaN(val) ? 0 : val);
    }, 0);
    if (sum === 0) return [];
    var digits = Math.pow(10, precision);
    var votesPerQuota = $7a1bd9c2710fea0d$export$871de8747c9eaa88(valueList, function(val) {
        return (isNaN(val) ? 0 : val) / sum * digits * 100;
    });
    var targetSeats = digits * 100;
    var seats = $7a1bd9c2710fea0d$export$871de8747c9eaa88(votesPerQuota, function(votes) {
        // Assign automatic seats.
        return Math.floor(votes);
    });
    var currentSum = $7a1bd9c2710fea0d$export$533b26079ad0b4b(seats, function(acc, val) {
        return acc + val;
    }, 0);
    var remainder = $7a1bd9c2710fea0d$export$871de8747c9eaa88(votesPerQuota, function(votes, idx) {
        return votes - seats[idx];
    });
    // Has remainding votes.
    while(currentSum < targetSeats){
        // Find next largest remainder.
        var max = Number.NEGATIVE_INFINITY;
        var maxId = null;
        for(var i = 0, len = remainder.length; i < len; ++i)if (remainder[i] > max) {
            max = remainder[i];
            maxId = i;
        }
        // Add a vote to max remainder.
        ++seats[maxId];
        remainder[maxId] = 0;
        ++currentSum;
    }
    return $7a1bd9c2710fea0d$export$871de8747c9eaa88(seats, function(seat) {
        return seat / digits;
    });
}
function $cfc1f3b422a3185f$export$d3389a301c3a5706(val0, val1) {
    var maxPrecision = Math.max($cfc1f3b422a3185f$export$e0c74b50bbd10f68(val0), $cfc1f3b422a3185f$export$e0c74b50bbd10f68(val1));
    // const multiplier = Math.pow(10, maxPrecision);
    // return (Math.round(val0 * multiplier) + Math.round(val1 * multiplier)) / multiplier;
    var sum = val0 + val1;
    // // PENDING: support more?
    return maxPrecision > $cfc1f3b422a3185f$var$ROUND_SUPPORTED_PRECISION_MAX ? sum : $cfc1f3b422a3185f$export$2077e0241d6afd3c(sum, maxPrecision);
}
var $cfc1f3b422a3185f$export$18510406f204a1b9 = 9007199254740991;
function $cfc1f3b422a3185f$export$2ca6dd70a288b1c3(radian) {
    var pi2 = Math.PI * 2;
    return (radian % pi2 + pi2) % pi2;
}
function $cfc1f3b422a3185f$export$d1df570aea2868f(val) {
    return val > -$cfc1f3b422a3185f$var$RADIAN_EPSILON && val < $cfc1f3b422a3185f$var$RADIAN_EPSILON;
}
// eslint-disable-next-line
var $cfc1f3b422a3185f$var$TIME_REG = /^(?:(\d{4})(?:[-\/](\d{1,2})(?:[-\/](\d{1,2})(?:[T ](\d{1,2})(?::(\d{1,2})(?::(\d{1,2})(?:[.,](\d+))?)?)?(Z|[\+\-]\d\d:?\d\d)?)?)?)?)?$/; // jshint ignore:line
function $cfc1f3b422a3185f$export$6b862160d295c8e(value) {
    if (value instanceof Date) return value;
    else if ($7a1bd9c2710fea0d$export$844ec244b1367d54(value)) {
        // Different browsers parse date in different way, so we parse it manually.
        // Some other issues:
        // new Date('1970-01-01') is UTC,
        // new Date('1970/01/01') and new Date('1970-1-01') is local.
        // See issue #3623
        var match = $cfc1f3b422a3185f$var$TIME_REG.exec(value);
        if (!match) // return Invalid Date.
        return new Date(NaN);
        // Use local time when no timezone offset is specified.
        if (!match[8]) // match[n] can only be string or undefined.
        // But take care of '12' + 1 => '121'.
        return new Date(+match[1], +(match[2] || 1) - 1, +match[3] || 1, +match[4] || 0, +(match[5] || 0), +match[6] || 0, match[7] ? +match[7].substring(0, 3) : 0);
        else {
            var hour = +match[4] || 0;
            if (match[8].toUpperCase() !== 'Z') hour -= +match[8].slice(0, 3);
            return new Date(Date.UTC(+match[1], +(match[2] || 1) - 1, +match[3] || 1, hour, +(match[5] || 0), +match[6] || 0, match[7] ? +match[7].substring(0, 3) : 0));
        }
    } else if (value == null) return new Date(NaN);
    return new Date(Math.round(value));
}
function $cfc1f3b422a3185f$export$82dd68b83a44b253(val) {
    return Math.pow(10, $cfc1f3b422a3185f$export$97256a17b20a0c24(val));
}
function $cfc1f3b422a3185f$export$97256a17b20a0c24(val) {
    if (val === 0) return 0;
    var exp = Math.floor(Math.log(val) / Math.LN10);
    /**
   * exp is expected to be the rounded-down result of the base-10 log of val.
   * But due to the precision loss with Math.log(val), we need to restore it
   * using 10^exp to make sure we can get val back from exp. #11249
   */ if (val / Math.pow(10, exp) >= 10) exp++;
    return exp;
}
function $cfc1f3b422a3185f$export$7a695fe44258210b(val, round) {
    var exponent = $cfc1f3b422a3185f$export$97256a17b20a0c24(val);
    var exp10 = Math.pow(10, exponent);
    var f = val / exp10; // 1 <= f < 10
    var nf;
    if (round) {
        if (f < 1.5) nf = 1;
        else if (f < 2.5) nf = 2;
        else if (f < 4) nf = 3;
        else if (f < 7) nf = 5;
        else nf = 10;
    } else {
        if (f < 1) nf = 1;
        else if (f < 2) nf = 2;
        else if (f < 3) nf = 3;
        else if (f < 5) nf = 5;
        else nf = 10;
    }
    val = nf * exp10;
    // Fix 3 * 0.1 === 0.30000000000000004 issue (see IEEE 754).
    // 20 is the uppper bound of toFixed.
    return exponent >= -20 ? +val.toFixed(exponent < 0 ? -exponent : 0) : val;
}
function $cfc1f3b422a3185f$export$651fb4afdb6caa4b(ascArr, p) {
    var H = (ascArr.length - 1) * p + 1;
    var h = Math.floor(H);
    var v = +ascArr[h - 1];
    var e = H - h;
    return e ? v + e * (ascArr[h] - v) : v;
}
function $cfc1f3b422a3185f$export$12f7386070bc380a(list) {
    list.sort(function(a, b) {
        return littleThan(a, b, 0) ? -1 : 1;
    });
    var curr = -Infinity;
    var currClose = 1;
    for(var i = 0; i < list.length;){
        var interval = list[i].interval;
        var close_1 = list[i].close;
        for(var lg = 0; lg < 2; lg++){
            if (interval[lg] <= curr) {
                interval[lg] = curr;
                close_1[lg] = !lg ? 1 - currClose : 1;
            }
            curr = interval[lg];
            currClose = close_1[lg];
        }
        if (interval[0] === interval[1] && close_1[0] * close_1[1] !== 1) list.splice(i, 1);
        else i++;
    }
    return list;
    function littleThan(a, b, lg) {
        return a.interval[lg] < b.interval[lg] || a.interval[lg] === b.interval[lg] && (a.close[lg] - b.close[lg] === (!lg ? 1 : -1) || !lg && littleThan(a, b, 1));
    }
}
function $cfc1f3b422a3185f$export$8b4007b942b45a96(val) {
    var valFloat = parseFloat(val);
    return valFloat == val // eslint-disable-line eqeqeq
     && (valFloat !== 0 || !$7a1bd9c2710fea0d$export$844ec244b1367d54(val) || val.indexOf('x') <= 0 // For case ' 0x0 '.
    ) ? valFloat : NaN;
}
function $cfc1f3b422a3185f$export$e90fb89750dba83f(val) {
    return !isNaN($cfc1f3b422a3185f$export$8b4007b942b45a96(val));
}
function $cfc1f3b422a3185f$export$474d2ec9aa44a22() {
    return Math.round(Math.random() * 9);
}
function $cfc1f3b422a3185f$export$a368fd580c0d0fe4(a, b) {
    if (b === 0) return a;
    return $cfc1f3b422a3185f$export$a368fd580c0d0fe4(b, a % b);
}
function $cfc1f3b422a3185f$export$680a45b749323f49(a, b) {
    if (a == null) return b;
    if (b == null) return a;
    return a * b / $cfc1f3b422a3185f$export$a368fd580c0d0fe4(a, b);
}



function $76d619f648247e6d$var$interpolateNumber(p0, p1, percent) {
    return (p1 - p0) * percent + p0;
}
/**
 * Make the name displayable. But we should
 * make sure it is not duplicated with user
 * specified name, so use '\0';
 */ var $76d619f648247e6d$var$DUMMY_COMPONENT_NAME_PREFIX = 'series\0';
var $76d619f648247e6d$var$INTERNAL_COMPONENT_ID_PREFIX = '\0_ec_\0';
function $76d619f648247e6d$export$4f07b212a02c8051(value) {
    return value instanceof Array ? value : value == null ? [] : [
        value
    ];
}
function $76d619f648247e6d$export$abdcc6a26372f94b(opt, key, subOpts) {
    // Caution: performance sensitive.
    if (opt) {
        opt[key] = opt[key] || {};
        opt.emphasis = opt.emphasis || {};
        opt.emphasis[key] = opt.emphasis[key] || {};
        // Default emphasis option from normal
        for(var i = 0, len = subOpts.length; i < len; i++){
            var subOptName = subOpts[i];
            if (!opt.emphasis[key].hasOwnProperty(subOptName) && opt[key].hasOwnProperty(subOptName)) opt.emphasis[key][subOptName] = opt[key][subOptName];
        }
    }
}
var $76d619f648247e6d$export$df45610347a602ad = [
    'fontStyle',
    'fontWeight',
    'fontSize',
    'fontFamily',
    'rich',
    'tag',
    'color',
    'textBorderColor',
    'textBorderWidth',
    'width',
    'height',
    'lineHeight',
    'align',
    'verticalAlign',
    'baseline',
    'shadowColor',
    'shadowBlur',
    'shadowOffsetX',
    'shadowOffsetY',
    'textShadowColor',
    'textShadowBlur',
    'textShadowOffsetX',
    'textShadowOffsetY',
    'backgroundColor',
    'borderColor',
    'borderWidth',
    'borderRadius',
    'padding'
];
function $76d619f648247e6d$export$2c944e12edb48d4b(dataItem) {
    return (0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(dataItem) && !(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(dataItem) && !(dataItem instanceof Date) ? dataItem.value : dataItem;
}
function $76d619f648247e6d$export$3e1a543f33ef6883(dataItem) {
    return (0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(dataItem) && !(dataItem instanceof Array);
// // markLine data can be array
// && !(dataItem[0] && isObject(dataItem[0]) && !(dataItem[0] instanceof Array));
}
function $76d619f648247e6d$export$574f818966e4da87(existings, newCmptOptions, mode) {
    var isNormalMergeMode = mode === 'normalMerge';
    var isReplaceMergeMode = mode === 'replaceMerge';
    var isReplaceAllMode = mode === 'replaceAll';
    existings = existings || [];
    newCmptOptions = (newCmptOptions || []).slice();
    var existingIdIdxMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    // Validate id and name on user input option.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(newCmptOptions, function(cmptOption, index) {
        if (!(0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(cmptOption)) {
            newCmptOptions[index] = null;
            return;
        }
    });
    var result = $76d619f648247e6d$var$prepareResult(existings, existingIdIdxMap, mode);
    if (isNormalMergeMode || isReplaceMergeMode) $76d619f648247e6d$var$mappingById(result, existings, existingIdIdxMap, newCmptOptions);
    if (isNormalMergeMode) $76d619f648247e6d$var$mappingByName(result, newCmptOptions);
    if (isNormalMergeMode || isReplaceMergeMode) $76d619f648247e6d$var$mappingByIndex(result, newCmptOptions, isReplaceMergeMode);
    else if (isReplaceAllMode) $76d619f648247e6d$var$mappingInReplaceAllMode(result, newCmptOptions);
    $76d619f648247e6d$var$makeIdAndName(result);
    // The array `result` MUST NOT contain elided items, otherwise the
    // forEach will omit those items and result in incorrect result.
    return result;
}
function $76d619f648247e6d$var$prepareResult(existings, existingIdIdxMap, mode) {
    var result = [];
    if (mode === 'replaceAll') return result;
    // Do not use native `map` to in case that the array `existings`
    // contains elided items, which will be omitted.
    for(var index = 0; index < existings.length; index++){
        var existing = existings[index];
        // Because of replaceMerge, `existing` may be null/undefined.
        if (existing && existing.id != null) existingIdIdxMap.set(existing.id, index);
        // For non-internal-componnets:
        //     Mode "normalMerge": all existings kept.
        //     Mode "replaceMerge": all existing removed unless mapped by id.
        // For internal-components:
        //     go with "replaceMerge" approach in both mode.
        result.push({
            existing: mode === 'replaceMerge' || $76d619f648247e6d$export$feece3e7d52a102b(existing) ? null : existing,
            newOption: null,
            keyInfo: null,
            brandNew: null
        });
    }
    return result;
}
function $76d619f648247e6d$var$mappingById(result, existings, existingIdIdxMap, newCmptOptions) {
    // Mapping by id if specified.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(newCmptOptions, function(cmptOption, index) {
        if (!cmptOption || cmptOption.id == null) return;
        var optionId = $76d619f648247e6d$var$makeComparableKey(cmptOption.id);
        var existingIdx = existingIdIdxMap.get(optionId);
        if (existingIdx != null) {
            var resultItem = result[existingIdx];
            (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)(!resultItem.newOption, 'Duplicated option on id "' + optionId + '".');
            resultItem.newOption = cmptOption;
            // In both mode, if id matched, new option will be merged to
            // the existings rather than creating new component model.
            resultItem.existing = existings[existingIdx];
            newCmptOptions[index] = null;
        }
    });
}
function $76d619f648247e6d$var$mappingByName(result, newCmptOptions) {
    // Mapping by name if specified.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(newCmptOptions, function(cmptOption, index) {
        if (!cmptOption || cmptOption.name == null) return;
        for(var i = 0; i < result.length; i++){
            var existing = result[i].existing;
            if (!result[i].newOption // Consider name: two map to one.
             && existing && (existing.id == null || cmptOption.id == null) && !$76d619f648247e6d$export$feece3e7d52a102b(cmptOption) && !$76d619f648247e6d$export$feece3e7d52a102b(existing) && $76d619f648247e6d$var$keyExistAndEqual('name', existing, cmptOption)) {
                result[i].newOption = cmptOption;
                newCmptOptions[index] = null;
                return;
            }
        }
    });
}
function $76d619f648247e6d$var$mappingByIndex(result, newCmptOptions, brandNew) {
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(newCmptOptions, function(cmptOption) {
        if (!cmptOption) return;
        // Find the first place that not mapped by id and not internal component (consider the "hole").
        var resultItem;
        var nextIdx = 0;
        while(// Be `!resultItem` only when `nextIdx >= result.length`.
        (resultItem = result[nextIdx]) && (resultItem.newOption || $76d619f648247e6d$export$feece3e7d52a102b(resultItem.existing) || // In mode "replaceMerge", here no not-mapped-non-internal-existing.
        resultItem.existing && cmptOption.id != null && !$76d619f648247e6d$var$keyExistAndEqual('id', cmptOption, resultItem.existing)))nextIdx++;
        if (resultItem) {
            resultItem.newOption = cmptOption;
            resultItem.brandNew = brandNew;
        } else result.push({
            newOption: cmptOption,
            brandNew: brandNew,
            existing: null,
            keyInfo: null
        });
        nextIdx++;
    });
}
function $76d619f648247e6d$var$mappingInReplaceAllMode(result, newCmptOptions) {
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(newCmptOptions, function(cmptOption) {
        // The feature "reproduce" requires "hole" will also reproduced
        // in case that component index referring are broken.
        result.push({
            newOption: cmptOption,
            brandNew: true,
            existing: null,
            keyInfo: null
        });
    });
}
/**
 * Make id and name for mapping result (result of mappingToExists)
 * into `keyInfo` field.
 */ function $76d619f648247e6d$var$makeIdAndName(mapResult) {
    // We use this id to hash component models and view instances
    // in echarts. id can be specified by user, or auto generated.
    // The id generation rule ensures new view instance are able
    // to mapped to old instance when setOption are called in
    // no-merge mode. So we generate model id by name and plus
    // type in view id.
    // name can be duplicated among components, which is convenient
    // to specify multi components (like series) by one name.
    // Ensure that each id is distinct.
    var idMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(mapResult, function(item) {
        var existing = item.existing;
        existing && idMap.set(existing.id, item);
    });
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(mapResult, function(item) {
        var opt = item.newOption;
        // Force ensure id not duplicated.
        (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)(!opt || opt.id == null || !idMap.get(opt.id) || idMap.get(opt.id) === item, 'id duplicates: ' + (opt && opt.id));
        opt && opt.id != null && idMap.set(opt.id, item);
        !item.keyInfo && (item.keyInfo = {});
    });
    // Make name and id.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(mapResult, function(item, index) {
        var existing = item.existing;
        var opt = item.newOption;
        var keyInfo = item.keyInfo;
        if (!(0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(opt)) return;
        // Name can be overwritten. Consider case: axis.name = '20km'.
        // But id generated by name will not be changed, which affect
        // only in that case: setOption with 'not merge mode' and view
        // instance will be recreated, which can be accepted.
        keyInfo.name = opt.name != null ? $76d619f648247e6d$var$makeComparableKey(opt.name) : existing ? existing.name : $76d619f648247e6d$var$DUMMY_COMPONENT_NAME_PREFIX + index;
        if (existing) keyInfo.id = $76d619f648247e6d$var$makeComparableKey(existing.id);
        else if (opt.id != null) keyInfo.id = $76d619f648247e6d$var$makeComparableKey(opt.id);
        else {
            // Consider this situatoin:
            //  optionA: [{name: 'a'}, {name: 'a'}, {..}]
            //  optionB [{..}, {name: 'a'}, {name: 'a'}]
            // Series with the same name between optionA and optionB
            // should be mapped.
            var idNum = 0;
            do keyInfo.id = '\0' + keyInfo.name + '\0' + idNum++;
            while (idMap.get(keyInfo.id));
        }
        idMap.set(keyInfo.id, item);
    });
}
function $76d619f648247e6d$var$keyExistAndEqual(attr, obj1, obj2) {
    var key1 = $76d619f648247e6d$export$fb1a222ba5dd6e51(obj1[attr], null);
    var key2 = $76d619f648247e6d$export$fb1a222ba5dd6e51(obj2[attr], null);
    // See `MappingExistingItem`. `id` and `name` trade string equals to number.
    return key1 != null && key2 != null && key1 === key2;
}
/**
 * @return return null if not exist.
 */ function $76d619f648247e6d$var$makeComparableKey(val) {
    return $76d619f648247e6d$export$fb1a222ba5dd6e51(val, '');
}
function $76d619f648247e6d$export$fb1a222ba5dd6e51(idOrName, defaultValue) {
    if (idOrName == null) return defaultValue;
    return (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(idOrName) ? idOrName : (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(idOrName) || (0, $7a1bd9c2710fea0d$export$29d0bb2a4e07b252)(idOrName) ? idOrName + '' : defaultValue;
}
function $76d619f648247e6d$var$warnInvalidateIdOrName(idOrName) {}
function $76d619f648247e6d$var$isValidIdOrName(idOrName) {
    return (0, $7a1bd9c2710fea0d$export$29d0bb2a4e07b252)(idOrName) || (0, $cfc1f3b422a3185f$export$e90fb89750dba83f)(idOrName);
}
function $76d619f648247e6d$export$beae19a2652b3368(componentModel) {
    var name = componentModel.name;
    // Is specified when `indexOf` get -1 or > 0.
    return !!(name && name.indexOf($76d619f648247e6d$var$DUMMY_COMPONENT_NAME_PREFIX));
}
function $76d619f648247e6d$export$feece3e7d52a102b(cmptOption) {
    return cmptOption && cmptOption.id != null && $76d619f648247e6d$var$makeComparableKey(cmptOption.id).indexOf($76d619f648247e6d$var$INTERNAL_COMPONENT_ID_PREFIX) === 0;
}
function $76d619f648247e6d$export$1753133c42e665e8(idSuffix) {
    return $76d619f648247e6d$var$INTERNAL_COMPONENT_ID_PREFIX + idSuffix;
}
function $76d619f648247e6d$export$5ac61aca2ba0282d(mappingResult, mainType, componentModelCtor) {
    // Set mainType and complete subType.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(mappingResult, function(item) {
        var newOption = item.newOption;
        if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(newOption)) {
            item.keyInfo.mainType = mainType;
            item.keyInfo.subType = $76d619f648247e6d$var$determineSubType(mainType, newOption, item.existing, componentModelCtor);
        }
    });
}
function $76d619f648247e6d$var$determineSubType(mainType, newCmptOption, existComponent, componentModelCtor) {
    var subType = newCmptOption.type ? newCmptOption.type : existComponent ? existComponent.subType : componentModelCtor.determineSubType(mainType, newCmptOption);
    // tooltip, markline, markpoint may always has no subType
    return subType;
}
function $76d619f648247e6d$export$6d12cabb0c9bf8e3(batchA, batchB) {
    var mapA = {};
    var mapB = {};
    makeMap(batchA || [], mapA);
    makeMap(batchB || [], mapB, mapA);
    return [
        mapToArray(mapA),
        mapToArray(mapB)
    ];
    function makeMap(sourceBatch, map, otherMap) {
        for(var i = 0, len = sourceBatch.length; i < len; i++){
            var seriesId = $76d619f648247e6d$export$fb1a222ba5dd6e51(sourceBatch[i].seriesId, null);
            if (seriesId == null) return;
            var dataIndices = $76d619f648247e6d$export$4f07b212a02c8051(sourceBatch[i].dataIndex);
            var otherDataIndices = otherMap && otherMap[seriesId];
            for(var j = 0, lenj = dataIndices.length; j < lenj; j++){
                var dataIndex = dataIndices[j];
                if (otherDataIndices && otherDataIndices[dataIndex]) otherDataIndices[dataIndex] = null;
                else (map[seriesId] || (map[seriesId] = {}))[dataIndex] = 1;
            }
        }
    }
    function mapToArray(map, isData) {
        var result = [];
        for(var i in map)if (map.hasOwnProperty(i) && map[i] != null) {
            if (isData) result.push(+i);
            else {
                var dataIndices = mapToArray(map[i], true);
                dataIndices.length && result.push({
                    seriesId: i,
                    dataIndex: dataIndices
                });
            }
        }
        return result;
    }
}
function $76d619f648247e6d$export$42b26cae8b8d10(data, payload) {
    if (payload.dataIndexInside != null) return payload.dataIndexInside;
    else if (payload.dataIndex != null) return (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(payload.dataIndex) ? (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(payload.dataIndex, function(value) {
        return data.indexOfRawIndex(value);
    }) : data.indexOfRawIndex(payload.dataIndex);
    else if (payload.name != null) return (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(payload.name) ? (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(payload.name, function(value) {
        return data.indexOfName(value);
    }) : data.indexOfName(payload.name);
}
function $76d619f648247e6d$export$64df9f8d92ae083f() {
    var key = '__ec_inner_' + $76d619f648247e6d$var$innerUniqueIndex++;
    return function(hostObj) {
        return hostObj[key] || (hostObj[key] = {});
    };
}
var $76d619f648247e6d$var$innerUniqueIndex = (0, $cfc1f3b422a3185f$export$474d2ec9aa44a22)();
function $76d619f648247e6d$export$95de80076abac814(ecModel, finderInput, opt) {
    var _a = $76d619f648247e6d$export$fe600815775d9400(finderInput, opt), mainTypeSpecified = _a.mainTypeSpecified, queryOptionMap = _a.queryOptionMap, others = _a.others;
    var result = others;
    var defaultMainType = opt ? opt.defaultMainType : null;
    if (!mainTypeSpecified && defaultMainType) queryOptionMap.set(defaultMainType, {});
    queryOptionMap.each(function(queryOption, mainType) {
        var queryResult = $76d619f648247e6d$export$dc741340f7e5f186(ecModel, mainType, queryOption, {
            useDefault: defaultMainType === mainType,
            enableAll: opt && opt.enableAll != null ? opt.enableAll : true,
            enableNone: opt && opt.enableNone != null ? opt.enableNone : true
        });
        result[mainType + 'Models'] = queryResult.models;
        result[mainType + 'Model'] = queryResult.models[0];
    });
    return result;
}
function $76d619f648247e6d$export$fe600815775d9400(finderInput, opt) {
    var finder;
    if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(finderInput)) {
        var obj = {};
        obj[finderInput + 'Index'] = 0;
        finder = obj;
    } else finder = finderInput;
    var queryOptionMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    var others = {};
    var mainTypeSpecified = false;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(finder, function(value, key) {
        // Exclude 'dataIndex' and other illgal keys.
        if (key === 'dataIndex' || key === 'dataIndexInside') {
            others[key] = value;
            return;
        }
        var parsedKey = key.match(/^(\w+)(Index|Id|Name)$/) || [];
        var mainType = parsedKey[1];
        var queryType = (parsedKey[2] || '').toLowerCase();
        if (!mainType || !queryType || opt && opt.includeMainTypes && (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(opt.includeMainTypes, mainType) < 0) return;
        mainTypeSpecified = mainTypeSpecified || !!mainType;
        var queryOption = queryOptionMap.get(mainType) || queryOptionMap.set(mainType, {});
        queryOption[queryType] = value;
    });
    return {
        mainTypeSpecified: mainTypeSpecified,
        queryOptionMap: queryOptionMap,
        others: others
    };
}
var $76d619f648247e6d$export$f076738ec84e693c = {
    useDefault: true,
    enableAll: false,
    enableNone: false
};
var $76d619f648247e6d$export$48d598924ce4892c = {
    useDefault: false,
    enableAll: true,
    enableNone: true
};
function $76d619f648247e6d$export$dc741340f7e5f186(ecModel, mainType, userOption, opt) {
    opt = opt || $76d619f648247e6d$export$f076738ec84e693c;
    var indexOption = userOption.index;
    var idOption = userOption.id;
    var nameOption = userOption.name;
    var result = {
        models: null,
        specified: indexOption != null || idOption != null || nameOption != null
    };
    if (!result.specified) {
        // Use the first as default if `useDefault`.
        var firstCmpt = void 0;
        result.models = opt.useDefault && (firstCmpt = ecModel.getComponent(mainType)) ? [
            firstCmpt
        ] : [];
        return result;
    }
    if (indexOption === 'none' || indexOption === false) {
        (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)(opt.enableNone, '`"none"` or `false` is not a valid value on index option.');
        result.models = [];
        return result;
    }
    // `queryComponents` will return all components if
    // both all of index/id/name are null/undefined.
    if (indexOption === 'all') {
        (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)(opt.enableAll, '`"all"` is not a valid value on index option.');
        indexOption = idOption = nameOption = null;
    }
    result.models = ecModel.queryComponents({
        mainType: mainType,
        index: indexOption,
        id: idOption,
        name: nameOption
    });
    return result;
}
function $76d619f648247e6d$export$9fec4d97f1922e0b(dom, key, value) {
    dom.setAttribute ? dom.setAttribute(key, value) : dom[key] = value;
}
function $76d619f648247e6d$export$735ee1799fd02602(dom, key) {
    return dom.getAttribute ? dom.getAttribute(key) : dom[key];
}
function $76d619f648247e6d$export$cc0a17a5d27b4e17(renderModeOption) {
    if (renderModeOption === 'auto') // Using html when `document` exists, use richText otherwise
    return (0, $ce6dd58693a21851$export$2e2bcd8739ae039).domSupported ? 'html' : 'richText';
    else return renderModeOption || 'html';
}
function $76d619f648247e6d$export$7ab5bda43e13168f(array, getKey // return key
) {
    var buckets = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    var keys = [];
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(array, function(item) {
        var key = getKey(item);
        (buckets.get(key) || (keys.push(key), buckets.set(key, []))).push(item);
    });
    return {
        keys: keys,
        buckets: buckets
    };
}
function $76d619f648247e6d$export$bd0439821a1869f3(data, precision, sourceValue, targetValue, percent) {
    var isAutoPrecision = precision == null || precision === 'auto';
    if (targetValue == null) return targetValue;
    if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(targetValue)) {
        var value = $76d619f648247e6d$var$interpolateNumber(sourceValue || 0, targetValue, percent);
        return (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(value, isAutoPrecision ? Math.max((0, $cfc1f3b422a3185f$export$e0c74b50bbd10f68)(sourceValue || 0), (0, $cfc1f3b422a3185f$export$e0c74b50bbd10f68)(targetValue)) : precision);
    } else if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(targetValue)) return percent < 1 ? sourceValue : targetValue;
    else {
        var interpolated = [];
        var leftArr = sourceValue;
        var rightArr = targetValue;
        var length_1 = Math.max(leftArr ? leftArr.length : 0, rightArr.length);
        for(var i = 0; i < length_1; ++i){
            var info = data.getDimensionInfo(i);
            // Don't interpolate ordinal dims
            if (info && info.type === 'ordinal') // In init, there is no `sourceValue`, but should better not to get undefined result.
            interpolated[i] = (percent < 1 && leftArr ? leftArr : rightArr)[i];
            else {
                var leftVal = leftArr && leftArr[i] ? leftArr[i] : 0;
                var rightVal = rightArr[i];
                var value = $76d619f648247e6d$var$interpolateNumber(leftVal, rightVal, percent);
                interpolated[i] = (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(value, isAutoPrecision ? Math.max((0, $cfc1f3b422a3185f$export$e0c74b50bbd10f68)(leftVal), (0, $cfc1f3b422a3185f$export$e0c74b50bbd10f68)(rightVal)) : precision);
            }
        }
        return interpolated;
    }
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $cd5f95cf03b4e3e7$var$TYPE_DELIMITER = '.';
var $cd5f95cf03b4e3e7$var$IS_CONTAINER = '___EC__COMPONENT__CONTAINER___';
var $cd5f95cf03b4e3e7$var$IS_EXTENDED_CLASS = '___EC__EXTENDED_CLASS___';
function $cd5f95cf03b4e3e7$export$fbe18865d303bf01(componentType) {
    var ret = {
        main: '',
        sub: ''
    };
    if (componentType) {
        var typeArr = componentType.split($cd5f95cf03b4e3e7$var$TYPE_DELIMITER);
        ret.main = typeArr[0] || '';
        ret.sub = typeArr[1] || '';
    }
    return ret;
}
/**
 * @public
 */ function $cd5f95cf03b4e3e7$var$checkClassType(componentType) {
    $7a1bd9c2710fea0d$export$a7a9523472993e97(/^[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)?$/.test(componentType), 'componentType "' + componentType + '" illegal');
}
function $cd5f95cf03b4e3e7$export$4f3b818f3dd2d182(clz) {
    return !!(clz && clz[$cd5f95cf03b4e3e7$var$IS_EXTENDED_CLASS]);
}
function $cd5f95cf03b4e3e7$export$cd4c3a4dca301c70(rootClz, mandatoryMethods) {
    rootClz.$constructor = rootClz; // FIXME: not necessary?
    rootClz.extend = function(proto) {
        var superClass = this;
        var ExtendedClass;
        if ($cd5f95cf03b4e3e7$var$isESClass(superClass)) ExtendedClass = /** @class */ function(_super) {
            (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(class_1, _super);
            function class_1() {
                return _super.apply(this, arguments) || this;
            }
            return class_1;
        }(superClass);
        else {
            // For backward compat, we both support ts class inheritance and this
            // "extend" approach.
            // The constructor should keep the same behavior as ts class inheritance:
            // If this constructor/$constructor is not declared, auto invoke the super
            // constructor.
            // If this constructor/$constructor is declared, it is responsible for
            // calling the super constructor.
            ExtendedClass = function() {
                (proto.$constructor || superClass).apply(this, arguments);
            };
            $7a1bd9c2710fea0d$export$69f1b2dcda23c5f8(ExtendedClass, this);
        }
        $7a1bd9c2710fea0d$export$8b58be045bf06082(ExtendedClass.prototype, proto);
        ExtendedClass[$cd5f95cf03b4e3e7$var$IS_EXTENDED_CLASS] = true;
        ExtendedClass.extend = this.extend;
        ExtendedClass.superCall = $cd5f95cf03b4e3e7$var$superCall;
        ExtendedClass.superApply = $cd5f95cf03b4e3e7$var$superApply;
        ExtendedClass.superClass = superClass;
        return ExtendedClass;
    };
}
function $cd5f95cf03b4e3e7$var$isESClass(fn) {
    return $7a1bd9c2710fea0d$export$f6e2535fb5126e54(fn) && /^class\s/.test(Function.prototype.toString.call(fn));
}
function $cd5f95cf03b4e3e7$export$c9c2d87774f1275d(SubClz, SupperClz) {
    SubClz.extend = SupperClz.extend;
}
// A random offset.
var $cd5f95cf03b4e3e7$var$classBase = Math.round(Math.random() * 10);
function $cd5f95cf03b4e3e7$export$e1aac4552ae82081(target) {
    var classAttr = [
        '__\0is_clz',
        $cd5f95cf03b4e3e7$var$classBase++
    ].join('_');
    target.prototype[classAttr] = true;
    target.isInstance = function(obj) {
        return !!(obj && obj[classAttr]);
    };
}
// superCall should have class info, which can not be fetched from 'this'.
// Consider this case:
// class A has method f,
// class B inherits class A, overrides method f, f call superApply('f'),
// class C inherits class B, does not override method f,
// then when method of class C is called, dead loop occurred.
function $cd5f95cf03b4e3e7$var$superCall(context, methodName) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    return this.superClass.prototype[methodName].apply(context, args);
}
function $cd5f95cf03b4e3e7$var$superApply(context, methodName, args) {
    return this.superClass.prototype[methodName].apply(context, args);
}
function $cd5f95cf03b4e3e7$export$241315e45585454d(target) {
    /**
   * Component model classes
   * key: componentType,
   * value:
   *     componentClass, when componentType is 'a'
   *     or Object.<subKey, componentClass>, when componentType is 'a.b'
   */ var storage = {};
    target.registerClass = function(clz) {
        // `type` should not be a "instance member".
        // If using TS class, should better declared as `static type = 'series.pie'`.
        // otherwise users have to mount `type` on prototype manually.
        // For backward compat and enable instance visit type via `this.type`,
        // we still support fetch `type` from prototype.
        var componentFullType = clz.type || clz.prototype.type;
        if (componentFullType) {
            $cd5f95cf03b4e3e7$var$checkClassType(componentFullType);
            // If only static type declared, we assign it to prototype mandatorily.
            clz.prototype.type = componentFullType;
            var componentTypeInfo = $cd5f95cf03b4e3e7$export$fbe18865d303bf01(componentFullType);
            if (!componentTypeInfo.sub) storage[componentTypeInfo.main] = clz;
            else if (componentTypeInfo.sub !== $cd5f95cf03b4e3e7$var$IS_CONTAINER) {
                var container = makeContainer(componentTypeInfo);
                container[componentTypeInfo.sub] = clz;
            }
        }
        return clz;
    };
    target.getClass = function(mainType, subType, throwWhenNotFound) {
        var clz = storage[mainType];
        if (clz && clz[$cd5f95cf03b4e3e7$var$IS_CONTAINER]) clz = subType ? clz[subType] : null;
        if (throwWhenNotFound && !clz) throw new Error(!subType ? mainType + '.' + 'type should be specified.' : 'Component ' + mainType + '.' + (subType || '') + ' is used but not imported.');
        return clz;
    };
    target.getClassesByMainType = function(componentType) {
        var componentTypeInfo = $cd5f95cf03b4e3e7$export$fbe18865d303bf01(componentType);
        var result = [];
        var obj = storage[componentTypeInfo.main];
        if (obj && obj[$cd5f95cf03b4e3e7$var$IS_CONTAINER]) $7a1bd9c2710fea0d$export$79b2f7037acddd43(obj, function(o, type) {
            type !== $cd5f95cf03b4e3e7$var$IS_CONTAINER && result.push(o);
        });
        else result.push(obj);
        return result;
    };
    target.hasClass = function(componentType) {
        // Just consider componentType.main.
        var componentTypeInfo = $cd5f95cf03b4e3e7$export$fbe18865d303bf01(componentType);
        return !!storage[componentTypeInfo.main];
    };
    /**
   * @return Like ['aa', 'bb'], but can not be ['aa.xx']
   */ target.getAllClassMainTypes = function() {
        var types = [];
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(storage, function(obj, type) {
            types.push(type);
        });
        return types;
    };
    /**
   * If a main type is container and has sub types
   */ target.hasSubTypes = function(componentType) {
        var componentTypeInfo = $cd5f95cf03b4e3e7$export$fbe18865d303bf01(componentType);
        var obj = storage[componentTypeInfo.main];
        return obj && obj[$cd5f95cf03b4e3e7$var$IS_CONTAINER];
    };
    function makeContainer(componentTypeInfo) {
        var container = storage[componentTypeInfo.main];
        if (!container || !container[$cd5f95cf03b4e3e7$var$IS_CONTAINER]) {
            container = storage[componentTypeInfo.main] = {};
            container[$cd5f95cf03b4e3e7$var$IS_CONTAINER] = true;
        }
        return container;
    }
} // /**
 //  * @param {string|Array.<string>} properties
 //  */
 // export function setReadOnly(obj, properties) {
 // FIXME It seems broken in IE8 simulation of IE11
 // if (!zrUtil.isArray(properties)) {
 //     properties = properties != null ? [properties] : [];
 // }
 // zrUtil.each(properties, function (prop) {
 //     let value = obj[prop];
 //     Object.defineProperty
 //         && Object.defineProperty(obj, prop, {
 //             value: value, writable: false
 //         });
 //     zrUtil.isArray(obj[prop])
 //         && Object.freeze
 //         && Object.freeze(obj[prop]);
 // });
 // }


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // TODO Parse shadow style
// TODO Only shallow path support

function $06542048a26d4d91$export$2e2bcd8739ae039(properties, ignoreParent) {
    // Normalize
    for(var i = 0; i < properties.length; i++)if (!properties[i][1]) properties[i][1] = properties[i][0];
    ignoreParent = ignoreParent || false;
    return function(model, excludes, includes) {
        var style = {};
        for(var i = 0; i < properties.length; i++){
            var propName = properties[i][1];
            if (excludes && $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(excludes, propName) >= 0 || includes && $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(includes, propName) < 0) continue;
            var val = model.getShallow(propName, ignoreParent);
            if (val != null) style[properties[i][0]] = val;
        }
        // TODO Text or image?
        return style;
    };
}


var $cb2a96727da5284d$export$52de6e304d934d85 = [
    [
        'fill',
        'color'
    ],
    [
        'shadowBlur'
    ],
    [
        'shadowOffsetX'
    ],
    [
        'shadowOffsetY'
    ],
    [
        'opacity'
    ],
    [
        'shadowColor'
    ]
];
var $cb2a96727da5284d$var$getAreaStyle = (0, $06542048a26d4d91$export$2e2bcd8739ae039)($cb2a96727da5284d$export$52de6e304d934d85);
var $cb2a96727da5284d$export$a3a0ed7e2dd84c9e = /** @class */ function() {
    function AreaStyleMixin() {}
    AreaStyleMixin.prototype.getAreaStyle = function(excludes, includes) {
        return $cb2a96727da5284d$var$getAreaStyle(this, excludes, includes);
    };
    return AreaStyleMixin;
}();


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $a53bd598adfb7ebe$var$globalImageCache = new (0, $d91b0b6fc564d9c7$export$2e2bcd8739ae039)(50);
function $a53bd598adfb7ebe$export$1b614f30ac2c8867(newImageOrSrc) {
    if (typeof newImageOrSrc === 'string') {
        var cachedImgObj = $a53bd598adfb7ebe$var$globalImageCache.get(newImageOrSrc);
        return cachedImgObj && cachedImgObj.image;
    } else return newImageOrSrc;
}
function $a53bd598adfb7ebe$export$46c791b69ff9a0f(newImageOrSrc, image, hostEl, onload, cbPayload) {
    if (!newImageOrSrc) return image;
    else if (typeof newImageOrSrc === 'string') {
        if (image && image.__zrImageSrc === newImageOrSrc || !hostEl) return image;
        var cachedImgObj = $a53bd598adfb7ebe$var$globalImageCache.get(newImageOrSrc);
        var pendingWrap = {
            hostEl: hostEl,
            cb: onload,
            cbPayload: cbPayload
        };
        if (cachedImgObj) {
            image = cachedImgObj.image;
            !$a53bd598adfb7ebe$export$37ca7dd901d0236d(image) && cachedImgObj.pending.push(pendingWrap);
        } else {
            image = (0, $c6341dcc9d86826e$export$ef5e599365494451).loadImage(newImageOrSrc, $a53bd598adfb7ebe$var$imageOnLoad, $a53bd598adfb7ebe$var$imageOnLoad);
            image.__zrImageSrc = newImageOrSrc;
            $a53bd598adfb7ebe$var$globalImageCache.put(newImageOrSrc, image.__cachedImgObj = {
                image: image,
                pending: [
                    pendingWrap
                ]
            });
        }
        return image;
    } else return newImageOrSrc;
}
function $a53bd598adfb7ebe$var$imageOnLoad() {
    var cachedImgObj = this.__cachedImgObj;
    this.onload = this.onerror = this.__cachedImgObj = null;
    for(var i = 0; i < cachedImgObj.pending.length; i++){
        var pendingWrap = cachedImgObj.pending[i];
        var cb = pendingWrap.cb;
        cb && cb(this, pendingWrap.cbPayload);
        pendingWrap.hostEl.dirty();
    }
    cachedImgObj.pending.length = 0;
}
function $a53bd598adfb7ebe$export$37ca7dd901d0236d(image) {
    return image && image.width && image.height;
}




var $64fa9b3825ba2dec$var$STYLE_REG = /\{([a-zA-Z0-9_]+)\|([^}]*)\}/g;
function $64fa9b3825ba2dec$export$59a943b34a82e690(text, containerWidth, font, ellipsis, options) {
    var out = {};
    $64fa9b3825ba2dec$var$truncateText2(out, text, containerWidth, font, ellipsis, options);
    return out.text;
}
function $64fa9b3825ba2dec$var$truncateText2(out, text, containerWidth, font, ellipsis, options) {
    if (!containerWidth) {
        out.text = '';
        out.isTruncated = false;
        return;
    }
    var textLines = (text + '').split('\n');
    options = $64fa9b3825ba2dec$var$prepareTruncateOptions(containerWidth, font, ellipsis, options);
    var isTruncated = false;
    var truncateOut = {};
    for(var i = 0, len = textLines.length; i < len; i++){
        $64fa9b3825ba2dec$var$truncateSingleLine(truncateOut, textLines[i], options);
        textLines[i] = truncateOut.textLine;
        isTruncated = isTruncated || truncateOut.isTruncated;
    }
    out.text = textLines.join('\n');
    out.isTruncated = isTruncated;
}
function $64fa9b3825ba2dec$var$prepareTruncateOptions(containerWidth, font, ellipsis, options) {
    options = options || {};
    var preparedOpts = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, options);
    preparedOpts.font = font;
    ellipsis = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(ellipsis, '...');
    preparedOpts.maxIterations = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(options.maxIterations, 2);
    var minChar = preparedOpts.minChar = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(options.minChar, 0);
    preparedOpts.cnCharWidth = (0, $6c308355c7107803$export$3c49c185de0c2bfc)("\u56FD", font);
    var ascCharWidth = preparedOpts.ascCharWidth = (0, $6c308355c7107803$export$3c49c185de0c2bfc)('a', font);
    preparedOpts.placeholder = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(options.placeholder, '');
    var contentWidth = containerWidth = Math.max(0, containerWidth - 1);
    for(var i = 0; i < minChar && contentWidth >= ascCharWidth; i++)contentWidth -= ascCharWidth;
    var ellipsisWidth = (0, $6c308355c7107803$export$3c49c185de0c2bfc)(ellipsis, font);
    if (ellipsisWidth > contentWidth) {
        ellipsis = '';
        ellipsisWidth = 0;
    }
    contentWidth = containerWidth - ellipsisWidth;
    preparedOpts.ellipsis = ellipsis;
    preparedOpts.ellipsisWidth = ellipsisWidth;
    preparedOpts.contentWidth = contentWidth;
    preparedOpts.containerWidth = containerWidth;
    return preparedOpts;
}
function $64fa9b3825ba2dec$var$truncateSingleLine(out, textLine, options) {
    var containerWidth = options.containerWidth;
    var font = options.font;
    var contentWidth = options.contentWidth;
    if (!containerWidth) {
        out.textLine = '';
        out.isTruncated = false;
        return;
    }
    var lineWidth = (0, $6c308355c7107803$export$3c49c185de0c2bfc)(textLine, font);
    if (lineWidth <= containerWidth) {
        out.textLine = textLine;
        out.isTruncated = false;
        return;
    }
    for(var j = 0;; j++){
        if (lineWidth <= contentWidth || j >= options.maxIterations) {
            textLine += options.ellipsis;
            break;
        }
        var subLength = j === 0 ? $64fa9b3825ba2dec$var$estimateLength(textLine, contentWidth, options.ascCharWidth, options.cnCharWidth) : lineWidth > 0 ? Math.floor(textLine.length * contentWidth / lineWidth) : 0;
        textLine = textLine.substr(0, subLength);
        lineWidth = (0, $6c308355c7107803$export$3c49c185de0c2bfc)(textLine, font);
    }
    if (textLine === '') textLine = options.placeholder;
    out.textLine = textLine;
    out.isTruncated = true;
}
function $64fa9b3825ba2dec$var$estimateLength(text, contentWidth, ascCharWidth, cnCharWidth) {
    var width = 0;
    var i = 0;
    for(var len = text.length; i < len && width < contentWidth; i++){
        var charCode = text.charCodeAt(i);
        width += 0 <= charCode && charCode <= 127 ? ascCharWidth : cnCharWidth;
    }
    return i;
}
function $64fa9b3825ba2dec$export$5772575e34ef80f9(text, style) {
    text != null && (text += '');
    var overflow = style.overflow;
    var padding = style.padding;
    var font = style.font;
    var truncate = overflow === 'truncate';
    var calculatedLineHeight = (0, $6c308355c7107803$export$56204a27a2958a55)(font);
    var lineHeight = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(style.lineHeight, calculatedLineHeight);
    var bgColorDrawn = !!style.backgroundColor;
    var truncateLineOverflow = style.lineOverflow === 'truncate';
    var isTruncated = false;
    var width = style.width;
    var lines;
    if (width != null && (overflow === 'break' || overflow === 'breakAll')) lines = text ? $64fa9b3825ba2dec$var$wrapText(text, style.font, width, overflow === 'breakAll', 0).lines : [];
    else lines = text ? text.split('\n') : [];
    var contentHeight = lines.length * lineHeight;
    var height = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(style.height, contentHeight);
    if (contentHeight > height && truncateLineOverflow) {
        var lineCount = Math.floor(height / lineHeight);
        isTruncated = isTruncated || lines.length > lineCount;
        lines = lines.slice(0, lineCount);
    }
    if (text && truncate && width != null) {
        var options = $64fa9b3825ba2dec$var$prepareTruncateOptions(width, font, style.ellipsis, {
            minChar: style.truncateMinChar,
            placeholder: style.placeholder
        });
        var singleOut = {};
        for(var i = 0; i < lines.length; i++){
            $64fa9b3825ba2dec$var$truncateSingleLine(singleOut, lines[i], options);
            lines[i] = singleOut.textLine;
            isTruncated = isTruncated || singleOut.isTruncated;
        }
    }
    var outerHeight = height;
    var contentWidth = 0;
    for(var i = 0; i < lines.length; i++)contentWidth = Math.max((0, $6c308355c7107803$export$3c49c185de0c2bfc)(lines[i], font), contentWidth);
    if (width == null) width = contentWidth;
    var outerWidth = contentWidth;
    if (padding) {
        outerHeight += padding[0] + padding[2];
        outerWidth += padding[1] + padding[3];
        width += padding[1] + padding[3];
    }
    if (bgColorDrawn) outerWidth = width;
    return {
        lines: lines,
        height: height,
        outerWidth: outerWidth,
        outerHeight: outerHeight,
        lineHeight: lineHeight,
        calculatedLineHeight: calculatedLineHeight,
        contentWidth: contentWidth,
        contentHeight: contentHeight,
        width: width,
        isTruncated: isTruncated
    };
}
var $64fa9b3825ba2dec$var$RichTextToken = function() {
    function RichTextToken() {}
    return RichTextToken;
}();
var $64fa9b3825ba2dec$var$RichTextLine = function() {
    function RichTextLine(tokens) {
        this.tokens = [];
        if (tokens) this.tokens = tokens;
    }
    return RichTextLine;
}();
var $64fa9b3825ba2dec$export$ca607d3c98caaf7e = function() {
    function RichTextContentBlock() {
        this.width = 0;
        this.height = 0;
        this.contentWidth = 0;
        this.contentHeight = 0;
        this.outerWidth = 0;
        this.outerHeight = 0;
        this.lines = [];
        this.isTruncated = false;
    }
    return RichTextContentBlock;
}();
function $64fa9b3825ba2dec$export$15ec9472ff2d721(text, style) {
    var contentBlock = new $64fa9b3825ba2dec$export$ca607d3c98caaf7e();
    text != null && (text += '');
    if (!text) return contentBlock;
    var topWidth = style.width;
    var topHeight = style.height;
    var overflow = style.overflow;
    var wrapInfo = (overflow === 'break' || overflow === 'breakAll') && topWidth != null ? {
        width: topWidth,
        accumWidth: 0,
        breakAll: overflow === 'breakAll'
    } : null;
    var lastIndex = $64fa9b3825ba2dec$var$STYLE_REG.lastIndex = 0;
    var result;
    while((result = $64fa9b3825ba2dec$var$STYLE_REG.exec(text)) != null){
        var matchedIndex = result.index;
        if (matchedIndex > lastIndex) $64fa9b3825ba2dec$var$pushTokens(contentBlock, text.substring(lastIndex, matchedIndex), style, wrapInfo);
        $64fa9b3825ba2dec$var$pushTokens(contentBlock, result[2], style, wrapInfo, result[1]);
        lastIndex = $64fa9b3825ba2dec$var$STYLE_REG.lastIndex;
    }
    if (lastIndex < text.length) $64fa9b3825ba2dec$var$pushTokens(contentBlock, text.substring(lastIndex, text.length), style, wrapInfo);
    var pendingList = [];
    var calculatedHeight = 0;
    var calculatedWidth = 0;
    var stlPadding = style.padding;
    var truncate = overflow === 'truncate';
    var truncateLine = style.lineOverflow === 'truncate';
    var tmpTruncateOut = {};
    function finishLine(line, lineWidth, lineHeight) {
        line.width = lineWidth;
        line.lineHeight = lineHeight;
        calculatedHeight += lineHeight;
        calculatedWidth = Math.max(calculatedWidth, lineWidth);
    }
    outer: for(var i = 0; i < contentBlock.lines.length; i++){
        var line = contentBlock.lines[i];
        var lineHeight = 0;
        var lineWidth = 0;
        for(var j = 0; j < line.tokens.length; j++){
            var token = line.tokens[j];
            var tokenStyle = token.styleName && style.rich[token.styleName] || {};
            var textPadding = token.textPadding = tokenStyle.padding;
            var paddingH = textPadding ? textPadding[1] + textPadding[3] : 0;
            var font = token.font = tokenStyle.font || style.font;
            token.contentHeight = (0, $6c308355c7107803$export$56204a27a2958a55)(font);
            var tokenHeight = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(tokenStyle.height, token.contentHeight);
            token.innerHeight = tokenHeight;
            textPadding && (tokenHeight += textPadding[0] + textPadding[2]);
            token.height = tokenHeight;
            token.lineHeight = (0, $7a1bd9c2710fea0d$export$2e94551289abb95b)(tokenStyle.lineHeight, style.lineHeight, tokenHeight);
            token.align = tokenStyle && tokenStyle.align || style.align;
            token.verticalAlign = tokenStyle && tokenStyle.verticalAlign || 'middle';
            if (truncateLine && topHeight != null && calculatedHeight + token.lineHeight > topHeight) {
                var originalLength = contentBlock.lines.length;
                if (j > 0) {
                    line.tokens = line.tokens.slice(0, j);
                    finishLine(line, lineWidth, lineHeight);
                    contentBlock.lines = contentBlock.lines.slice(0, i + 1);
                } else contentBlock.lines = contentBlock.lines.slice(0, i);
                contentBlock.isTruncated = contentBlock.isTruncated || contentBlock.lines.length < originalLength;
                break outer;
            }
            var styleTokenWidth = tokenStyle.width;
            var tokenWidthNotSpecified = styleTokenWidth == null || styleTokenWidth === 'auto';
            if (typeof styleTokenWidth === 'string' && styleTokenWidth.charAt(styleTokenWidth.length - 1) === '%') {
                token.percentWidth = styleTokenWidth;
                pendingList.push(token);
                token.contentWidth = (0, $6c308355c7107803$export$3c49c185de0c2bfc)(token.text, font);
            } else {
                if (tokenWidthNotSpecified) {
                    var textBackgroundColor = tokenStyle.backgroundColor;
                    var bgImg = textBackgroundColor && textBackgroundColor.image;
                    if (bgImg) {
                        bgImg = $a53bd598adfb7ebe$export$1b614f30ac2c8867(bgImg);
                        if ($a53bd598adfb7ebe$export$37ca7dd901d0236d(bgImg)) token.width = Math.max(token.width, bgImg.width * tokenHeight / bgImg.height);
                    }
                }
                var remainTruncWidth = truncate && topWidth != null ? topWidth - lineWidth : null;
                if (remainTruncWidth != null && remainTruncWidth < token.width) {
                    if (!tokenWidthNotSpecified || remainTruncWidth < paddingH) {
                        token.text = '';
                        token.width = token.contentWidth = 0;
                    } else {
                        $64fa9b3825ba2dec$var$truncateText2(tmpTruncateOut, token.text, remainTruncWidth - paddingH, font, style.ellipsis, {
                            minChar: style.truncateMinChar
                        });
                        token.text = tmpTruncateOut.text;
                        contentBlock.isTruncated = contentBlock.isTruncated || tmpTruncateOut.isTruncated;
                        token.width = token.contentWidth = (0, $6c308355c7107803$export$3c49c185de0c2bfc)(token.text, font);
                    }
                } else token.contentWidth = (0, $6c308355c7107803$export$3c49c185de0c2bfc)(token.text, font);
            }
            token.width += paddingH;
            lineWidth += token.width;
            tokenStyle && (lineHeight = Math.max(lineHeight, token.lineHeight));
        }
        finishLine(line, lineWidth, lineHeight);
    }
    contentBlock.outerWidth = contentBlock.width = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(topWidth, calculatedWidth);
    contentBlock.outerHeight = contentBlock.height = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(topHeight, calculatedHeight);
    contentBlock.contentHeight = calculatedHeight;
    contentBlock.contentWidth = calculatedWidth;
    if (stlPadding) {
        contentBlock.outerWidth += stlPadding[1] + stlPadding[3];
        contentBlock.outerHeight += stlPadding[0] + stlPadding[2];
    }
    for(var i = 0; i < pendingList.length; i++){
        var token = pendingList[i];
        var percentWidth = token.percentWidth;
        token.width = parseInt(percentWidth, 10) / 100 * contentBlock.width;
    }
    return contentBlock;
}
function $64fa9b3825ba2dec$var$pushTokens(block, str, style, wrapInfo, styleName) {
    var isEmptyStr = str === '';
    var tokenStyle = styleName && style.rich[styleName] || {};
    var lines = block.lines;
    var font = tokenStyle.font || style.font;
    var newLine = false;
    var strLines;
    var linesWidths;
    if (wrapInfo) {
        var tokenPadding = tokenStyle.padding;
        var tokenPaddingH = tokenPadding ? tokenPadding[1] + tokenPadding[3] : 0;
        if (tokenStyle.width != null && tokenStyle.width !== 'auto') {
            var outerWidth_1 = (0, $6c308355c7107803$export$e8514cb5a5e2b40f)(tokenStyle.width, wrapInfo.width) + tokenPaddingH;
            if (lines.length > 0) {
                if (outerWidth_1 + wrapInfo.accumWidth > wrapInfo.width) {
                    strLines = str.split('\n');
                    newLine = true;
                }
            }
            wrapInfo.accumWidth = outerWidth_1;
        } else {
            var res = $64fa9b3825ba2dec$var$wrapText(str, font, wrapInfo.width, wrapInfo.breakAll, wrapInfo.accumWidth);
            wrapInfo.accumWidth = res.accumWidth + tokenPaddingH;
            linesWidths = res.linesWidths;
            strLines = res.lines;
        }
    } else strLines = str.split('\n');
    for(var i = 0; i < strLines.length; i++){
        var text = strLines[i];
        var token = new $64fa9b3825ba2dec$var$RichTextToken();
        token.styleName = styleName;
        token.text = text;
        token.isLineHolder = !text && !isEmptyStr;
        if (typeof tokenStyle.width === 'number') token.width = tokenStyle.width;
        else token.width = linesWidths ? linesWidths[i] : (0, $6c308355c7107803$export$3c49c185de0c2bfc)(text, font);
        if (!i && !newLine) {
            var tokens = (lines[lines.length - 1] || (lines[0] = new $64fa9b3825ba2dec$var$RichTextLine())).tokens;
            var tokensLen = tokens.length;
            tokensLen === 1 && tokens[0].isLineHolder ? tokens[0] = token : (text || !tokensLen || isEmptyStr) && tokens.push(token);
        } else lines.push(new $64fa9b3825ba2dec$var$RichTextLine([
            token
        ]));
    }
}
function $64fa9b3825ba2dec$var$isAlphabeticLetter(ch) {
    var code = ch.charCodeAt(0);
    return code >= 0x20 && code <= 0x24F || code >= 0x370 && code <= 0x10FF || code >= 0x1200 && code <= 0x13FF || code >= 0x1E00 && code <= 0x206F;
}
var $64fa9b3825ba2dec$var$breakCharMap = (0, $7a1bd9c2710fea0d$export$533b26079ad0b4b)(',&?/;] '.split(''), function(obj, ch) {
    obj[ch] = true;
    return obj;
}, {});
function $64fa9b3825ba2dec$var$isWordBreakChar(ch) {
    if ($64fa9b3825ba2dec$var$isAlphabeticLetter(ch)) {
        if ($64fa9b3825ba2dec$var$breakCharMap[ch]) return true;
        return false;
    }
    return true;
}
function $64fa9b3825ba2dec$var$wrapText(text, font, lineWidth, isBreakAll, lastAccumWidth) {
    var lines = [];
    var linesWidths = [];
    var line = '';
    var currentWord = '';
    var currentWordWidth = 0;
    var accumWidth = 0;
    for(var i = 0; i < text.length; i++){
        var ch = text.charAt(i);
        if (ch === '\n') {
            if (currentWord) {
                line += currentWord;
                accumWidth += currentWordWidth;
            }
            lines.push(line);
            linesWidths.push(accumWidth);
            line = '';
            currentWord = '';
            currentWordWidth = 0;
            accumWidth = 0;
            continue;
        }
        var chWidth = (0, $6c308355c7107803$export$3c49c185de0c2bfc)(ch, font);
        var inWord = isBreakAll ? false : !$64fa9b3825ba2dec$var$isWordBreakChar(ch);
        if (!lines.length ? lastAccumWidth + accumWidth + chWidth > lineWidth : accumWidth + chWidth > lineWidth) {
            if (!accumWidth) {
                if (inWord) {
                    lines.push(currentWord);
                    linesWidths.push(currentWordWidth);
                    currentWord = ch;
                    currentWordWidth = chWidth;
                } else {
                    lines.push(ch);
                    linesWidths.push(chWidth);
                }
            } else if (line || currentWord) {
                if (inWord) {
                    if (!line) {
                        line = currentWord;
                        currentWord = '';
                        currentWordWidth = 0;
                        accumWidth = currentWordWidth;
                    }
                    lines.push(line);
                    linesWidths.push(accumWidth - currentWordWidth);
                    currentWord += ch;
                    currentWordWidth += chWidth;
                    line = '';
                    accumWidth = currentWordWidth;
                } else {
                    if (currentWord) {
                        line += currentWord;
                        currentWord = '';
                        currentWordWidth = 0;
                    }
                    lines.push(line);
                    linesWidths.push(accumWidth);
                    line = ch;
                    accumWidth = chWidth;
                }
            }
            continue;
        }
        accumWidth += chWidth;
        if (inWord) {
            currentWord += ch;
            currentWordWidth += chWidth;
        } else {
            if (currentWord) {
                line += currentWord;
                currentWord = '';
                currentWordWidth = 0;
            }
            line += ch;
        }
    }
    if (!lines.length && !line) {
        line = text;
        currentWord = '';
        currentWordWidth = 0;
    }
    if (currentWord) line += currentWord;
    if (line) {
        lines.push(line);
        linesWidths.push(accumWidth);
    }
    if (lines.length === 1) accumWidth += lastAccumWidth;
    return {
        accumWidth: accumWidth,
        lines: lines,
        linesWidths: linesWidths
    };
}








var $56206a6cb4666931$var$STYLE_MAGIC_KEY = '__zr_style_' + Math.round(Math.random() * 10);
var $56206a6cb4666931$export$737672163db00fe3 = {
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    shadowColor: '#000',
    opacity: 1,
    blend: 'source-over'
};
var $56206a6cb4666931$export$9908943fb57fbe51 = {
    style: {
        shadowBlur: true,
        shadowOffsetX: true,
        shadowOffsetY: true,
        shadowColor: true,
        opacity: true
    }
};
$56206a6cb4666931$export$737672163db00fe3[$56206a6cb4666931$var$STYLE_MAGIC_KEY] = true;
var $56206a6cb4666931$var$PRIMARY_STATES_KEYS = [
    'z',
    'z2',
    'invisible'
];
var $56206a6cb4666931$var$PRIMARY_STATES_KEYS_IN_HOVER_LAYER = [
    'invisible'
];
var $56206a6cb4666931$var$Displayable = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Displayable, _super);
    function Displayable(props) {
        return _super.call(this, props) || this;
    }
    Displayable.prototype._init = function(props) {
        var keysArr = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(props);
        for(var i = 0; i < keysArr.length; i++){
            var key = keysArr[i];
            if (key === 'style') this.useStyle(props[key]);
            else _super.prototype.attrKV.call(this, key, props[key]);
        }
        if (!this.style) this.useStyle({});
    };
    Displayable.prototype.beforeBrush = function() {};
    Displayable.prototype.afterBrush = function() {};
    Displayable.prototype.innerBeforeBrush = function() {};
    Displayable.prototype.innerAfterBrush = function() {};
    Displayable.prototype.shouldBePainted = function(viewWidth, viewHeight, considerClipPath, considerAncestors) {
        var m = this.transform;
        if (this.ignore || this.invisible || this.style.opacity === 0 || this.culling && $56206a6cb4666931$var$isDisplayableCulled(this, viewWidth, viewHeight) || m && !m[0] && !m[3]) return false;
        if (considerClipPath && this.__clipPaths) for(var i = 0; i < this.__clipPaths.length; ++i){
            if (this.__clipPaths[i].isZeroArea()) return false;
        }
        if (considerAncestors && this.parent) {
            var parent_1 = this.parent;
            while(parent_1){
                if (parent_1.ignore) return false;
                parent_1 = parent_1.parent;
            }
        }
        return true;
    };
    Displayable.prototype.contain = function(x, y) {
        return this.rectContain(x, y);
    };
    Displayable.prototype.traverse = function(cb, context) {
        cb.call(context, this);
    };
    Displayable.prototype.rectContain = function(x, y) {
        var coord = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        return rect.contain(coord[0], coord[1]);
    };
    Displayable.prototype.getPaintRect = function() {
        var rect = this._paintRect;
        if (!this._paintRect || this.__dirty) {
            var transform = this.transform;
            var elRect = this.getBoundingRect();
            var style = this.style;
            var shadowSize = style.shadowBlur || 0;
            var shadowOffsetX = style.shadowOffsetX || 0;
            var shadowOffsetY = style.shadowOffsetY || 0;
            rect = this._paintRect || (this._paintRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0));
            if (transform) (0, $1bebe7106c895823$export$2e2bcd8739ae039).applyTransform(rect, elRect, transform);
            else rect.copy(elRect);
            if (shadowSize || shadowOffsetX || shadowOffsetY) {
                rect.width += shadowSize * 2 + Math.abs(shadowOffsetX);
                rect.height += shadowSize * 2 + Math.abs(shadowOffsetY);
                rect.x = Math.min(rect.x, rect.x + shadowOffsetX - shadowSize);
                rect.y = Math.min(rect.y, rect.y + shadowOffsetY - shadowSize);
            }
            var tolerance = this.dirtyRectTolerance;
            if (!rect.isZero()) {
                rect.x = Math.floor(rect.x - tolerance);
                rect.y = Math.floor(rect.y - tolerance);
                rect.width = Math.ceil(rect.width + 1 + tolerance * 2);
                rect.height = Math.ceil(rect.height + 1 + tolerance * 2);
            }
        }
        return rect;
    };
    Displayable.prototype.setPrevPaintRect = function(paintRect) {
        if (paintRect) {
            this._prevPaintRect = this._prevPaintRect || new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
            this._prevPaintRect.copy(paintRect);
        } else this._prevPaintRect = null;
    };
    Displayable.prototype.getPrevPaintRect = function() {
        return this._prevPaintRect;
    };
    Displayable.prototype.animateStyle = function(loop) {
        return this.animate('style', loop);
    };
    Displayable.prototype.updateDuringAnimation = function(targetKey) {
        if (targetKey === 'style') this.dirtyStyle();
        else this.markRedraw();
    };
    Displayable.prototype.attrKV = function(key, value) {
        if (key !== 'style') _super.prototype.attrKV.call(this, key, value);
        else if (!this.style) this.useStyle(value);
        else this.setStyle(value);
    };
    Displayable.prototype.setStyle = function(keyOrObj, value) {
        if (typeof keyOrObj === 'string') this.style[keyOrObj] = value;
        else (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(this.style, keyOrObj);
        this.dirtyStyle();
        return this;
    };
    Displayable.prototype.dirtyStyle = function(notRedraw) {
        if (!notRedraw) this.markRedraw();
        this.__dirty |= (0, $ddf76b16f1246ba9$export$ada8b2beb3d76671);
        if (this._rect) this._rect = null;
    };
    Displayable.prototype.dirty = function() {
        this.dirtyStyle();
    };
    Displayable.prototype.styleChanged = function() {
        return !!(this.__dirty & (0, $ddf76b16f1246ba9$export$ada8b2beb3d76671));
    };
    Displayable.prototype.styleUpdated = function() {
        this.__dirty &= ~(0, $ddf76b16f1246ba9$export$ada8b2beb3d76671);
    };
    Displayable.prototype.createStyle = function(obj) {
        return (0, $7a1bd9c2710fea0d$export$79c7e160a7743efd)($56206a6cb4666931$export$737672163db00fe3, obj);
    };
    Displayable.prototype.useStyle = function(obj) {
        if (!obj[$56206a6cb4666931$var$STYLE_MAGIC_KEY]) obj = this.createStyle(obj);
        if (this.__inHover) this.__hoverStyle = obj;
        else this.style = obj;
        this.dirtyStyle();
    };
    Displayable.prototype.isStyleObject = function(obj) {
        return obj[$56206a6cb4666931$var$STYLE_MAGIC_KEY];
    };
    Displayable.prototype._innerSaveToNormal = function(toState) {
        _super.prototype._innerSaveToNormal.call(this, toState);
        var normalState = this._normalState;
        if (toState.style && !normalState.style) normalState.style = this._mergeStyle(this.createStyle(), this.style);
        this._savePrimaryToNormal(toState, normalState, $56206a6cb4666931$var$PRIMARY_STATES_KEYS);
    };
    Displayable.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        _super.prototype._applyStateObj.call(this, stateName, state, normalState, keepCurrentStates, transition, animationCfg);
        var needsRestoreToNormal = !(state && keepCurrentStates);
        var targetStyle;
        if (state && state.style) {
            if (transition) {
                if (keepCurrentStates) targetStyle = state.style;
                else {
                    targetStyle = this._mergeStyle(this.createStyle(), normalState.style);
                    this._mergeStyle(targetStyle, state.style);
                }
            } else {
                targetStyle = this._mergeStyle(this.createStyle(), keepCurrentStates ? this.style : normalState.style);
                this._mergeStyle(targetStyle, state.style);
            }
        } else if (needsRestoreToNormal) targetStyle = normalState.style;
        if (targetStyle) {
            if (transition) {
                var sourceStyle = this.style;
                this.style = this.createStyle(needsRestoreToNormal ? {} : sourceStyle);
                if (needsRestoreToNormal) {
                    var changedKeys = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(sourceStyle);
                    for(var i = 0; i < changedKeys.length; i++){
                        var key = changedKeys[i];
                        if (key in targetStyle) {
                            targetStyle[key] = targetStyle[key];
                            this.style[key] = sourceStyle[key];
                        }
                    }
                }
                var targetKeys = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(targetStyle);
                for(var i = 0; i < targetKeys.length; i++){
                    var key = targetKeys[i];
                    this.style[key] = this.style[key];
                }
                this._transitionState(stateName, {
                    style: targetStyle
                }, animationCfg, this.getAnimationStyleProps());
            } else this.useStyle(targetStyle);
        }
        var statesKeys = this.__inHover ? $56206a6cb4666931$var$PRIMARY_STATES_KEYS_IN_HOVER_LAYER : $56206a6cb4666931$var$PRIMARY_STATES_KEYS;
        for(var i = 0; i < statesKeys.length; i++){
            var key = statesKeys[i];
            if (state && state[key] != null) this[key] = state[key];
            else if (needsRestoreToNormal) {
                if (normalState[key] != null) this[key] = normalState[key];
            }
        }
    };
    Displayable.prototype._mergeStates = function(states) {
        var mergedState = _super.prototype._mergeStates.call(this, states);
        var mergedStyle;
        for(var i = 0; i < states.length; i++){
            var state = states[i];
            if (state.style) {
                mergedStyle = mergedStyle || {};
                this._mergeStyle(mergedStyle, state.style);
            }
        }
        if (mergedStyle) mergedState.style = mergedStyle;
        return mergedState;
    };
    Displayable.prototype._mergeStyle = function(targetStyle, sourceStyle) {
        (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(targetStyle, sourceStyle);
        return targetStyle;
    };
    Displayable.prototype.getAnimationStyleProps = function() {
        return $56206a6cb4666931$export$9908943fb57fbe51;
    };
    Displayable.initDefaultProps = function() {
        var dispProto = Displayable.prototype;
        dispProto.type = 'displayable';
        dispProto.invisible = false;
        dispProto.z = 0;
        dispProto.z2 = 0;
        dispProto.zlevel = 0;
        dispProto.culling = false;
        dispProto.cursor = 'pointer';
        dispProto.rectHover = false;
        dispProto.incremental = false;
        dispProto._rect = null;
        dispProto.dirtyRectTolerance = 0;
        dispProto.__dirty = (0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd) | (0, $ddf76b16f1246ba9$export$ada8b2beb3d76671);
    }();
    return Displayable;
}((0, $4bb0f26b847654d5$export$2e2bcd8739ae039));
var $56206a6cb4666931$var$tmpRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
var $56206a6cb4666931$var$viewRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
function $56206a6cb4666931$var$isDisplayableCulled(el, width, height) {
    $56206a6cb4666931$var$tmpRect.copy(el.getBoundingRect());
    if (el.transform) $56206a6cb4666931$var$tmpRect.applyTransform(el.transform);
    $56206a6cb4666931$var$viewRect.width = width;
    $56206a6cb4666931$var$viewRect.height = height;
    return !$56206a6cb4666931$var$tmpRect.intersect($56206a6cb4666931$var$viewRect);
}
var $56206a6cb4666931$export$2e2bcd8739ae039 = $56206a6cb4666931$var$Displayable;










var $af3aab2435198f82$var$mathMin = Math.min;
var $af3aab2435198f82$var$mathMax = Math.max;
var $af3aab2435198f82$var$mathSin = Math.sin;
var $af3aab2435198f82$var$mathCos = Math.cos;
var $af3aab2435198f82$var$PI2 = Math.PI * 2;
var $af3aab2435198f82$var$start = $6de594cf8ac295ff$export$185802fd694ee1f5();
var $af3aab2435198f82$var$end = $6de594cf8ac295ff$export$185802fd694ee1f5();
var $af3aab2435198f82$var$extremity = $6de594cf8ac295ff$export$185802fd694ee1f5();
function $af3aab2435198f82$export$188c3cd07b4129dd(points, min, max) {
    if (points.length === 0) return;
    var p = points[0];
    var left = p[0];
    var right = p[0];
    var top = p[1];
    var bottom = p[1];
    for(var i = 1; i < points.length; i++){
        p = points[i];
        left = $af3aab2435198f82$var$mathMin(left, p[0]);
        right = $af3aab2435198f82$var$mathMax(right, p[0]);
        top = $af3aab2435198f82$var$mathMin(top, p[1]);
        bottom = $af3aab2435198f82$var$mathMax(bottom, p[1]);
    }
    min[0] = left;
    min[1] = top;
    max[0] = right;
    max[1] = bottom;
}
function $af3aab2435198f82$export$d2b1491e4450bf2c(x0, y0, x1, y1, min, max) {
    min[0] = $af3aab2435198f82$var$mathMin(x0, x1);
    min[1] = $af3aab2435198f82$var$mathMin(y0, y1);
    max[0] = $af3aab2435198f82$var$mathMax(x0, x1);
    max[1] = $af3aab2435198f82$var$mathMax(y0, y1);
}
var $af3aab2435198f82$var$xDim = [];
var $af3aab2435198f82$var$yDim = [];
function $af3aab2435198f82$export$c1bc6be456bb6609(x0, y0, x1, y1, x2, y2, x3, y3, min, max) {
    var cubicExtrema = $747cfc5611b57cea$export$df1a172f100d0457;
    var cubicAt = $747cfc5611b57cea$export$547c21de482bbcb2;
    var n = cubicExtrema(x0, x1, x2, x3, $af3aab2435198f82$var$xDim);
    min[0] = Infinity;
    min[1] = Infinity;
    max[0] = -Infinity;
    max[1] = -Infinity;
    for(var i = 0; i < n; i++){
        var x = cubicAt(x0, x1, x2, x3, $af3aab2435198f82$var$xDim[i]);
        min[0] = $af3aab2435198f82$var$mathMin(x, min[0]);
        max[0] = $af3aab2435198f82$var$mathMax(x, max[0]);
    }
    n = cubicExtrema(y0, y1, y2, y3, $af3aab2435198f82$var$yDim);
    for(var i = 0; i < n; i++){
        var y = cubicAt(y0, y1, y2, y3, $af3aab2435198f82$var$yDim[i]);
        min[1] = $af3aab2435198f82$var$mathMin(y, min[1]);
        max[1] = $af3aab2435198f82$var$mathMax(y, max[1]);
    }
    min[0] = $af3aab2435198f82$var$mathMin(x0, min[0]);
    max[0] = $af3aab2435198f82$var$mathMax(x0, max[0]);
    min[0] = $af3aab2435198f82$var$mathMin(x3, min[0]);
    max[0] = $af3aab2435198f82$var$mathMax(x3, max[0]);
    min[1] = $af3aab2435198f82$var$mathMin(y0, min[1]);
    max[1] = $af3aab2435198f82$var$mathMax(y0, max[1]);
    min[1] = $af3aab2435198f82$var$mathMin(y3, min[1]);
    max[1] = $af3aab2435198f82$var$mathMax(y3, max[1]);
}
function $af3aab2435198f82$export$16fbe795323a1f4c(x0, y0, x1, y1, x2, y2, min, max) {
    var quadraticExtremum = $747cfc5611b57cea$export$752e1f8c6e7f7e11;
    var quadraticAt = $747cfc5611b57cea$export$af17094a950f5073;
    var tx = $af3aab2435198f82$var$mathMax($af3aab2435198f82$var$mathMin(quadraticExtremum(x0, x1, x2), 1), 0);
    var ty = $af3aab2435198f82$var$mathMax($af3aab2435198f82$var$mathMin(quadraticExtremum(y0, y1, y2), 1), 0);
    var x = quadraticAt(x0, x1, x2, tx);
    var y = quadraticAt(y0, y1, y2, ty);
    min[0] = $af3aab2435198f82$var$mathMin(x0, x2, x);
    min[1] = $af3aab2435198f82$var$mathMin(y0, y2, y);
    max[0] = $af3aab2435198f82$var$mathMax(x0, x2, x);
    max[1] = $af3aab2435198f82$var$mathMax(y0, y2, y);
}
function $af3aab2435198f82$export$161c8bb0e1d9ef49(x, y, rx, ry, startAngle, endAngle, anticlockwise, min, max) {
    var vec2Min = $6de594cf8ac295ff$export$96ec731ed4dcb222;
    var vec2Max = $6de594cf8ac295ff$export$8960430cfd85939f;
    var diff = Math.abs(startAngle - endAngle);
    if (diff % $af3aab2435198f82$var$PI2 < 1e-4 && diff > 1e-4) {
        min[0] = x - rx;
        min[1] = y - ry;
        max[0] = x + rx;
        max[1] = y + ry;
        return;
    }
    $af3aab2435198f82$var$start[0] = $af3aab2435198f82$var$mathCos(startAngle) * rx + x;
    $af3aab2435198f82$var$start[1] = $af3aab2435198f82$var$mathSin(startAngle) * ry + y;
    $af3aab2435198f82$var$end[0] = $af3aab2435198f82$var$mathCos(endAngle) * rx + x;
    $af3aab2435198f82$var$end[1] = $af3aab2435198f82$var$mathSin(endAngle) * ry + y;
    vec2Min(min, $af3aab2435198f82$var$start, $af3aab2435198f82$var$end);
    vec2Max(max, $af3aab2435198f82$var$start, $af3aab2435198f82$var$end);
    startAngle = startAngle % $af3aab2435198f82$var$PI2;
    if (startAngle < 0) startAngle = startAngle + $af3aab2435198f82$var$PI2;
    endAngle = endAngle % $af3aab2435198f82$var$PI2;
    if (endAngle < 0) endAngle = endAngle + $af3aab2435198f82$var$PI2;
    if (startAngle > endAngle && !anticlockwise) endAngle += $af3aab2435198f82$var$PI2;
    else if (startAngle < endAngle && anticlockwise) startAngle += $af3aab2435198f82$var$PI2;
    if (anticlockwise) {
        var tmp = endAngle;
        endAngle = startAngle;
        startAngle = tmp;
    }
    for(var angle = 0; angle < endAngle; angle += Math.PI / 2)if (angle > startAngle) {
        $af3aab2435198f82$var$extremity[0] = $af3aab2435198f82$var$mathCos(angle) * rx + x;
        $af3aab2435198f82$var$extremity[1] = $af3aab2435198f82$var$mathSin(angle) * ry + y;
        vec2Min(min, $af3aab2435198f82$var$extremity, min);
        vec2Max(max, $af3aab2435198f82$var$extremity, max);
    }
}



var $20ebe2448f123f2e$var$CMD = {
    M: 1,
    L: 2,
    C: 3,
    Q: 4,
    A: 5,
    Z: 6,
    R: 7
};
var $20ebe2448f123f2e$var$tmpOutX = [];
var $20ebe2448f123f2e$var$tmpOutY = [];
var $20ebe2448f123f2e$var$min = [];
var $20ebe2448f123f2e$var$max = [];
var $20ebe2448f123f2e$var$min2 = [];
var $20ebe2448f123f2e$var$max2 = [];
var $20ebe2448f123f2e$var$mathMin = Math.min;
var $20ebe2448f123f2e$var$mathMax = Math.max;
var $20ebe2448f123f2e$var$mathCos = Math.cos;
var $20ebe2448f123f2e$var$mathSin = Math.sin;
var $20ebe2448f123f2e$var$mathAbs = Math.abs;
var $20ebe2448f123f2e$var$PI = Math.PI;
var $20ebe2448f123f2e$var$PI2 = $20ebe2448f123f2e$var$PI * 2;
var $20ebe2448f123f2e$var$hasTypedArray = typeof Float32Array !== 'undefined';
var $20ebe2448f123f2e$var$tmpAngles = [];
function $20ebe2448f123f2e$var$modPI2(radian) {
    var n = Math.round(radian / $20ebe2448f123f2e$var$PI * 1e8) / 1e8;
    return n % 2 * $20ebe2448f123f2e$var$PI;
}
function $20ebe2448f123f2e$export$bc668021e937022a(angles, anticlockwise) {
    var newStartAngle = $20ebe2448f123f2e$var$modPI2(angles[0]);
    if (newStartAngle < 0) newStartAngle += $20ebe2448f123f2e$var$PI2;
    var delta = newStartAngle - angles[0];
    var newEndAngle = angles[1];
    newEndAngle += delta;
    if (!anticlockwise && newEndAngle - newStartAngle >= $20ebe2448f123f2e$var$PI2) newEndAngle = newStartAngle + $20ebe2448f123f2e$var$PI2;
    else if (anticlockwise && newStartAngle - newEndAngle >= $20ebe2448f123f2e$var$PI2) newEndAngle = newStartAngle - $20ebe2448f123f2e$var$PI2;
    else if (!anticlockwise && newStartAngle > newEndAngle) newEndAngle = newStartAngle + ($20ebe2448f123f2e$var$PI2 - $20ebe2448f123f2e$var$modPI2(newStartAngle - newEndAngle));
    else if (anticlockwise && newStartAngle < newEndAngle) newEndAngle = newStartAngle - ($20ebe2448f123f2e$var$PI2 - $20ebe2448f123f2e$var$modPI2(newEndAngle - newStartAngle));
    angles[0] = newStartAngle;
    angles[1] = newEndAngle;
}
var $20ebe2448f123f2e$var$PathProxy = function() {
    function PathProxy(notSaveData) {
        this.dpr = 1;
        this._xi = 0;
        this._yi = 0;
        this._x0 = 0;
        this._y0 = 0;
        this._len = 0;
        if (notSaveData) this._saveData = false;
        if (this._saveData) this.data = [];
    }
    PathProxy.prototype.increaseVersion = function() {
        this._version++;
    };
    PathProxy.prototype.getVersion = function() {
        return this._version;
    };
    PathProxy.prototype.setScale = function(sx, sy, segmentIgnoreThreshold) {
        segmentIgnoreThreshold = segmentIgnoreThreshold || 0;
        if (segmentIgnoreThreshold > 0) {
            this._ux = $20ebe2448f123f2e$var$mathAbs(segmentIgnoreThreshold / (0, $4b0cedd85979c776$export$508f096bfcdaac40) / sx) || 0;
            this._uy = $20ebe2448f123f2e$var$mathAbs(segmentIgnoreThreshold / (0, $4b0cedd85979c776$export$508f096bfcdaac40) / sy) || 0;
        }
    };
    PathProxy.prototype.setDPR = function(dpr) {
        this.dpr = dpr;
    };
    PathProxy.prototype.setContext = function(ctx) {
        this._ctx = ctx;
    };
    PathProxy.prototype.getContext = function() {
        return this._ctx;
    };
    PathProxy.prototype.beginPath = function() {
        this._ctx && this._ctx.beginPath();
        this.reset();
        return this;
    };
    PathProxy.prototype.reset = function() {
        if (this._saveData) this._len = 0;
        if (this._pathSegLen) {
            this._pathSegLen = null;
            this._pathLen = 0;
        }
        this._version++;
    };
    PathProxy.prototype.moveTo = function(x, y) {
        this._drawPendingPt();
        this.addData($20ebe2448f123f2e$var$CMD.M, x, y);
        this._ctx && this._ctx.moveTo(x, y);
        this._x0 = x;
        this._y0 = y;
        this._xi = x;
        this._yi = y;
        return this;
    };
    PathProxy.prototype.lineTo = function(x, y) {
        var dx = $20ebe2448f123f2e$var$mathAbs(x - this._xi);
        var dy = $20ebe2448f123f2e$var$mathAbs(y - this._yi);
        var exceedUnit = dx > this._ux || dy > this._uy;
        this.addData($20ebe2448f123f2e$var$CMD.L, x, y);
        if (this._ctx && exceedUnit) this._ctx.lineTo(x, y);
        if (exceedUnit) {
            this._xi = x;
            this._yi = y;
            this._pendingPtDist = 0;
        } else {
            var d2 = dx * dx + dy * dy;
            if (d2 > this._pendingPtDist) {
                this._pendingPtX = x;
                this._pendingPtY = y;
                this._pendingPtDist = d2;
            }
        }
        return this;
    };
    PathProxy.prototype.bezierCurveTo = function(x1, y1, x2, y2, x3, y3) {
        this._drawPendingPt();
        this.addData($20ebe2448f123f2e$var$CMD.C, x1, y1, x2, y2, x3, y3);
        if (this._ctx) this._ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
        this._xi = x3;
        this._yi = y3;
        return this;
    };
    PathProxy.prototype.quadraticCurveTo = function(x1, y1, x2, y2) {
        this._drawPendingPt();
        this.addData($20ebe2448f123f2e$var$CMD.Q, x1, y1, x2, y2);
        if (this._ctx) this._ctx.quadraticCurveTo(x1, y1, x2, y2);
        this._xi = x2;
        this._yi = y2;
        return this;
    };
    PathProxy.prototype.arc = function(cx, cy, r, startAngle, endAngle, anticlockwise) {
        this._drawPendingPt();
        $20ebe2448f123f2e$var$tmpAngles[0] = startAngle;
        $20ebe2448f123f2e$var$tmpAngles[1] = endAngle;
        $20ebe2448f123f2e$export$bc668021e937022a($20ebe2448f123f2e$var$tmpAngles, anticlockwise);
        startAngle = $20ebe2448f123f2e$var$tmpAngles[0];
        endAngle = $20ebe2448f123f2e$var$tmpAngles[1];
        var delta = endAngle - startAngle;
        this.addData($20ebe2448f123f2e$var$CMD.A, cx, cy, r, r, startAngle, delta, 0, anticlockwise ? 0 : 1);
        this._ctx && this._ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
        this._xi = $20ebe2448f123f2e$var$mathCos(endAngle) * r + cx;
        this._yi = $20ebe2448f123f2e$var$mathSin(endAngle) * r + cy;
        return this;
    };
    PathProxy.prototype.arcTo = function(x1, y1, x2, y2, radius) {
        this._drawPendingPt();
        if (this._ctx) this._ctx.arcTo(x1, y1, x2, y2, radius);
        return this;
    };
    PathProxy.prototype.rect = function(x, y, w, h) {
        this._drawPendingPt();
        this._ctx && this._ctx.rect(x, y, w, h);
        this.addData($20ebe2448f123f2e$var$CMD.R, x, y, w, h);
        return this;
    };
    PathProxy.prototype.closePath = function() {
        this._drawPendingPt();
        this.addData($20ebe2448f123f2e$var$CMD.Z);
        var ctx = this._ctx;
        var x0 = this._x0;
        var y0 = this._y0;
        if (ctx) ctx.closePath();
        this._xi = x0;
        this._yi = y0;
        return this;
    };
    PathProxy.prototype.fill = function(ctx) {
        ctx && ctx.fill();
        this.toStatic();
    };
    PathProxy.prototype.stroke = function(ctx) {
        ctx && ctx.stroke();
        this.toStatic();
    };
    PathProxy.prototype.len = function() {
        return this._len;
    };
    PathProxy.prototype.setData = function(data) {
        var len = data.length;
        if (!(this.data && this.data.length === len) && $20ebe2448f123f2e$var$hasTypedArray) this.data = new Float32Array(len);
        for(var i = 0; i < len; i++)this.data[i] = data[i];
        this._len = len;
    };
    PathProxy.prototype.appendPath = function(path) {
        if (!(path instanceof Array)) path = [
            path
        ];
        var len = path.length;
        var appendSize = 0;
        var offset = this._len;
        for(var i = 0; i < len; i++)appendSize += path[i].len();
        if ($20ebe2448f123f2e$var$hasTypedArray && this.data instanceof Float32Array) this.data = new Float32Array(offset + appendSize);
        for(var i = 0; i < len; i++){
            var appendPathData = path[i].data;
            for(var k = 0; k < appendPathData.length; k++)this.data[offset++] = appendPathData[k];
        }
        this._len = offset;
    };
    PathProxy.prototype.addData = function(cmd, a, b, c, d, e, f, g, h) {
        if (!this._saveData) return;
        var data = this.data;
        if (this._len + arguments.length > data.length) {
            this._expandData();
            data = this.data;
        }
        for(var i = 0; i < arguments.length; i++)data[this._len++] = arguments[i];
    };
    PathProxy.prototype._drawPendingPt = function() {
        if (this._pendingPtDist > 0) {
            this._ctx && this._ctx.lineTo(this._pendingPtX, this._pendingPtY);
            this._pendingPtDist = 0;
        }
    };
    PathProxy.prototype._expandData = function() {
        if (!(this.data instanceof Array)) {
            var newData = [];
            for(var i = 0; i < this._len; i++)newData[i] = this.data[i];
            this.data = newData;
        }
    };
    PathProxy.prototype.toStatic = function() {
        if (!this._saveData) return;
        this._drawPendingPt();
        var data = this.data;
        if (data instanceof Array) {
            data.length = this._len;
            if ($20ebe2448f123f2e$var$hasTypedArray && this._len > 11) this.data = new Float32Array(data);
        }
    };
    PathProxy.prototype.getBoundingRect = function() {
        $20ebe2448f123f2e$var$min[0] = $20ebe2448f123f2e$var$min[1] = $20ebe2448f123f2e$var$min2[0] = $20ebe2448f123f2e$var$min2[1] = Number.MAX_VALUE;
        $20ebe2448f123f2e$var$max[0] = $20ebe2448f123f2e$var$max[1] = $20ebe2448f123f2e$var$max2[0] = $20ebe2448f123f2e$var$max2[1] = -Number.MAX_VALUE;
        var data = this.data;
        var xi = 0;
        var yi = 0;
        var x0 = 0;
        var y0 = 0;
        var i;
        for(i = 0; i < this._len;){
            var cmd = data[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = data[i];
                yi = data[i + 1];
                x0 = xi;
                y0 = yi;
            }
            switch(cmd){
                case $20ebe2448f123f2e$var$CMD.M:
                    xi = x0 = data[i++];
                    yi = y0 = data[i++];
                    $20ebe2448f123f2e$var$min2[0] = x0;
                    $20ebe2448f123f2e$var$min2[1] = y0;
                    $20ebe2448f123f2e$var$max2[0] = x0;
                    $20ebe2448f123f2e$var$max2[1] = y0;
                    break;
                case $20ebe2448f123f2e$var$CMD.L:
                    (0, $af3aab2435198f82$export$d2b1491e4450bf2c)(xi, yi, data[i], data[i + 1], $20ebe2448f123f2e$var$min2, $20ebe2448f123f2e$var$max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $20ebe2448f123f2e$var$CMD.C:
                    (0, $af3aab2435198f82$export$c1bc6be456bb6609)(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], $20ebe2448f123f2e$var$min2, $20ebe2448f123f2e$var$max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $20ebe2448f123f2e$var$CMD.Q:
                    (0, $af3aab2435198f82$export$16fbe795323a1f4c)(xi, yi, data[i++], data[i++], data[i], data[i + 1], $20ebe2448f123f2e$var$min2, $20ebe2448f123f2e$var$max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $20ebe2448f123f2e$var$CMD.A:
                    var cx = data[i++];
                    var cy = data[i++];
                    var rx = data[i++];
                    var ry = data[i++];
                    var startAngle = data[i++];
                    var endAngle = data[i++] + startAngle;
                    i += 1;
                    var anticlockwise = !data[i++];
                    if (isFirst) {
                        x0 = $20ebe2448f123f2e$var$mathCos(startAngle) * rx + cx;
                        y0 = $20ebe2448f123f2e$var$mathSin(startAngle) * ry + cy;
                    }
                    (0, $af3aab2435198f82$export$161c8bb0e1d9ef49)(cx, cy, rx, ry, startAngle, endAngle, anticlockwise, $20ebe2448f123f2e$var$min2, $20ebe2448f123f2e$var$max2);
                    xi = $20ebe2448f123f2e$var$mathCos(endAngle) * rx + cx;
                    yi = $20ebe2448f123f2e$var$mathSin(endAngle) * ry + cy;
                    break;
                case $20ebe2448f123f2e$var$CMD.R:
                    x0 = xi = data[i++];
                    y0 = yi = data[i++];
                    var width = data[i++];
                    var height = data[i++];
                    (0, $af3aab2435198f82$export$d2b1491e4450bf2c)(x0, y0, x0 + width, y0 + height, $20ebe2448f123f2e$var$min2, $20ebe2448f123f2e$var$max2);
                    break;
                case $20ebe2448f123f2e$var$CMD.Z:
                    xi = x0;
                    yi = y0;
                    break;
            }
            $6de594cf8ac295ff$export$96ec731ed4dcb222($20ebe2448f123f2e$var$min, $20ebe2448f123f2e$var$min, $20ebe2448f123f2e$var$min2);
            $6de594cf8ac295ff$export$8960430cfd85939f($20ebe2448f123f2e$var$max, $20ebe2448f123f2e$var$max, $20ebe2448f123f2e$var$max2);
        }
        if (i === 0) $20ebe2448f123f2e$var$min[0] = $20ebe2448f123f2e$var$min[1] = $20ebe2448f123f2e$var$max[0] = $20ebe2448f123f2e$var$max[1] = 0;
        return new (0, $1bebe7106c895823$export$2e2bcd8739ae039)($20ebe2448f123f2e$var$min[0], $20ebe2448f123f2e$var$min[1], $20ebe2448f123f2e$var$max[0] - $20ebe2448f123f2e$var$min[0], $20ebe2448f123f2e$var$max[1] - $20ebe2448f123f2e$var$min[1]);
    };
    PathProxy.prototype._calculateLength = function() {
        var data = this.data;
        var len = this._len;
        var ux = this._ux;
        var uy = this._uy;
        var xi = 0;
        var yi = 0;
        var x0 = 0;
        var y0 = 0;
        if (!this._pathSegLen) this._pathSegLen = [];
        var pathSegLen = this._pathSegLen;
        var pathTotalLen = 0;
        var segCount = 0;
        for(var i = 0; i < len;){
            var cmd = data[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = data[i];
                yi = data[i + 1];
                x0 = xi;
                y0 = yi;
            }
            var l = -1;
            switch(cmd){
                case $20ebe2448f123f2e$var$CMD.M:
                    xi = x0 = data[i++];
                    yi = y0 = data[i++];
                    break;
                case $20ebe2448f123f2e$var$CMD.L:
                    var x2 = data[i++];
                    var y2 = data[i++];
                    var dx = x2 - xi;
                    var dy = y2 - yi;
                    if ($20ebe2448f123f2e$var$mathAbs(dx) > ux || $20ebe2448f123f2e$var$mathAbs(dy) > uy || i === len - 1) {
                        l = Math.sqrt(dx * dx + dy * dy);
                        xi = x2;
                        yi = y2;
                    }
                    break;
                case $20ebe2448f123f2e$var$CMD.C:
                    var x1 = data[i++];
                    var y1 = data[i++];
                    var x2 = data[i++];
                    var y2 = data[i++];
                    var x3 = data[i++];
                    var y3 = data[i++];
                    l = (0, $747cfc5611b57cea$export$af1875d576f60d7c)(xi, yi, x1, y1, x2, y2, x3, y3, 10);
                    xi = x3;
                    yi = y3;
                    break;
                case $20ebe2448f123f2e$var$CMD.Q:
                    var x1 = data[i++];
                    var y1 = data[i++];
                    var x2 = data[i++];
                    var y2 = data[i++];
                    l = (0, $747cfc5611b57cea$export$8a68adee46f3cf55)(xi, yi, x1, y1, x2, y2, 10);
                    xi = x2;
                    yi = y2;
                    break;
                case $20ebe2448f123f2e$var$CMD.A:
                    var cx = data[i++];
                    var cy = data[i++];
                    var rx = data[i++];
                    var ry = data[i++];
                    var startAngle = data[i++];
                    var delta = data[i++];
                    var endAngle = delta + startAngle;
                    i += 1;
                    if (isFirst) {
                        x0 = $20ebe2448f123f2e$var$mathCos(startAngle) * rx + cx;
                        y0 = $20ebe2448f123f2e$var$mathSin(startAngle) * ry + cy;
                    }
                    l = $20ebe2448f123f2e$var$mathMax(rx, ry) * $20ebe2448f123f2e$var$mathMin($20ebe2448f123f2e$var$PI2, Math.abs(delta));
                    xi = $20ebe2448f123f2e$var$mathCos(endAngle) * rx + cx;
                    yi = $20ebe2448f123f2e$var$mathSin(endAngle) * ry + cy;
                    break;
                case $20ebe2448f123f2e$var$CMD.R:
                    x0 = xi = data[i++];
                    y0 = yi = data[i++];
                    var width = data[i++];
                    var height = data[i++];
                    l = width * 2 + height * 2;
                    break;
                case $20ebe2448f123f2e$var$CMD.Z:
                    var dx = x0 - xi;
                    var dy = y0 - yi;
                    l = Math.sqrt(dx * dx + dy * dy);
                    xi = x0;
                    yi = y0;
                    break;
            }
            if (l >= 0) {
                pathSegLen[segCount++] = l;
                pathTotalLen += l;
            }
        }
        this._pathLen = pathTotalLen;
        return pathTotalLen;
    };
    PathProxy.prototype.rebuildPath = function(ctx, percent) {
        var d = this.data;
        var ux = this._ux;
        var uy = this._uy;
        var len = this._len;
        var x0;
        var y0;
        var xi;
        var yi;
        var x;
        var y;
        var drawPart = percent < 1;
        var pathSegLen;
        var pathTotalLen;
        var accumLength = 0;
        var segCount = 0;
        var displayedLength;
        var pendingPtDist = 0;
        var pendingPtX;
        var pendingPtY;
        if (drawPart) {
            if (!this._pathSegLen) this._calculateLength();
            pathSegLen = this._pathSegLen;
            pathTotalLen = this._pathLen;
            displayedLength = percent * pathTotalLen;
            if (!displayedLength) return;
        }
        lo: for(var i = 0; i < len;){
            var cmd = d[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = d[i];
                yi = d[i + 1];
                x0 = xi;
                y0 = yi;
            }
            if (cmd !== $20ebe2448f123f2e$var$CMD.L && pendingPtDist > 0) {
                ctx.lineTo(pendingPtX, pendingPtY);
                pendingPtDist = 0;
            }
            switch(cmd){
                case $20ebe2448f123f2e$var$CMD.M:
                    x0 = xi = d[i++];
                    y0 = yi = d[i++];
                    ctx.moveTo(xi, yi);
                    break;
                case $20ebe2448f123f2e$var$CMD.L:
                    x = d[i++];
                    y = d[i++];
                    var dx = $20ebe2448f123f2e$var$mathAbs(x - xi);
                    var dy = $20ebe2448f123f2e$var$mathAbs(y - yi);
                    if (dx > ux || dy > uy) {
                        if (drawPart) {
                            var l = pathSegLen[segCount++];
                            if (accumLength + l > displayedLength) {
                                var t = (displayedLength - accumLength) / l;
                                ctx.lineTo(xi * (1 - t) + x * t, yi * (1 - t) + y * t);
                                break lo;
                            }
                            accumLength += l;
                        }
                        ctx.lineTo(x, y);
                        xi = x;
                        yi = y;
                        pendingPtDist = 0;
                    } else {
                        var d2 = dx * dx + dy * dy;
                        if (d2 > pendingPtDist) {
                            pendingPtX = x;
                            pendingPtY = y;
                            pendingPtDist = d2;
                        }
                    }
                    break;
                case $20ebe2448f123f2e$var$CMD.C:
                    var x1 = d[i++];
                    var y1 = d[i++];
                    var x2 = d[i++];
                    var y2 = d[i++];
                    var x3 = d[i++];
                    var y3 = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            (0, $747cfc5611b57cea$export$a2ee23a0567039da)(xi, x1, x2, x3, t, $20ebe2448f123f2e$var$tmpOutX);
                            (0, $747cfc5611b57cea$export$a2ee23a0567039da)(yi, y1, y2, y3, t, $20ebe2448f123f2e$var$tmpOutY);
                            ctx.bezierCurveTo($20ebe2448f123f2e$var$tmpOutX[1], $20ebe2448f123f2e$var$tmpOutY[1], $20ebe2448f123f2e$var$tmpOutX[2], $20ebe2448f123f2e$var$tmpOutY[2], $20ebe2448f123f2e$var$tmpOutX[3], $20ebe2448f123f2e$var$tmpOutY[3]);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
                    xi = x3;
                    yi = y3;
                    break;
                case $20ebe2448f123f2e$var$CMD.Q:
                    var x1 = d[i++];
                    var y1 = d[i++];
                    var x2 = d[i++];
                    var y2 = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            (0, $747cfc5611b57cea$export$117c659e21a7a060)(xi, x1, x2, t, $20ebe2448f123f2e$var$tmpOutX);
                            (0, $747cfc5611b57cea$export$117c659e21a7a060)(yi, y1, y2, t, $20ebe2448f123f2e$var$tmpOutY);
                            ctx.quadraticCurveTo($20ebe2448f123f2e$var$tmpOutX[1], $20ebe2448f123f2e$var$tmpOutY[1], $20ebe2448f123f2e$var$tmpOutX[2], $20ebe2448f123f2e$var$tmpOutY[2]);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.quadraticCurveTo(x1, y1, x2, y2);
                    xi = x2;
                    yi = y2;
                    break;
                case $20ebe2448f123f2e$var$CMD.A:
                    var cx = d[i++];
                    var cy = d[i++];
                    var rx = d[i++];
                    var ry = d[i++];
                    var startAngle = d[i++];
                    var delta = d[i++];
                    var psi = d[i++];
                    var anticlockwise = !d[i++];
                    var r = rx > ry ? rx : ry;
                    var isEllipse = $20ebe2448f123f2e$var$mathAbs(rx - ry) > 1e-3;
                    var endAngle = startAngle + delta;
                    var breakBuild = false;
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            endAngle = startAngle + delta * (displayedLength - accumLength) / l;
                            breakBuild = true;
                        }
                        accumLength += l;
                    }
                    if (isEllipse && ctx.ellipse) ctx.ellipse(cx, cy, rx, ry, psi, startAngle, endAngle, anticlockwise);
                    else ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
                    if (breakBuild) break lo;
                    if (isFirst) {
                        x0 = $20ebe2448f123f2e$var$mathCos(startAngle) * rx + cx;
                        y0 = $20ebe2448f123f2e$var$mathSin(startAngle) * ry + cy;
                    }
                    xi = $20ebe2448f123f2e$var$mathCos(endAngle) * rx + cx;
                    yi = $20ebe2448f123f2e$var$mathSin(endAngle) * ry + cy;
                    break;
                case $20ebe2448f123f2e$var$CMD.R:
                    x0 = xi = d[i];
                    y0 = yi = d[i + 1];
                    x = d[i++];
                    y = d[i++];
                    var width = d[i++];
                    var height = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var d_1 = displayedLength - accumLength;
                            ctx.moveTo(x, y);
                            ctx.lineTo(x + $20ebe2448f123f2e$var$mathMin(d_1, width), y);
                            d_1 -= width;
                            if (d_1 > 0) ctx.lineTo(x + width, y + $20ebe2448f123f2e$var$mathMin(d_1, height));
                            d_1 -= height;
                            if (d_1 > 0) ctx.lineTo(x + $20ebe2448f123f2e$var$mathMax(width - d_1, 0), y + height);
                            d_1 -= width;
                            if (d_1 > 0) ctx.lineTo(x, y + $20ebe2448f123f2e$var$mathMax(height - d_1, 0));
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.rect(x, y, width, height);
                    break;
                case $20ebe2448f123f2e$var$CMD.Z:
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            ctx.lineTo(xi * (1 - t) + x0 * t, yi * (1 - t) + y0 * t);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.closePath();
                    xi = x0;
                    yi = y0;
            }
        }
    };
    PathProxy.prototype.clone = function() {
        var newProxy = new PathProxy();
        var data = this.data;
        newProxy.data = data.slice ? data.slice() : Array.prototype.slice.call(data);
        newProxy._len = this._len;
        return newProxy;
    };
    PathProxy.CMD = $20ebe2448f123f2e$var$CMD;
    PathProxy.initDefaultProps = function() {
        var proto = PathProxy.prototype;
        proto._saveData = true;
        proto._ux = 0;
        proto._uy = 0;
        proto._pendingPtDist = 0;
        proto._version = 0;
    }();
    return PathProxy;
}();
var $20ebe2448f123f2e$export$2e2bcd8739ae039 = $20ebe2448f123f2e$var$PathProxy;



function $beafddd7270f4bea$export$8d36b1b5d19157c5(x0, y0, x1, y1, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    var _a = 0;
    var _b = x0;
    if (y > y0 + _l && y > y1 + _l || y < y0 - _l && y < y1 - _l || x > x0 + _l && x > x1 + _l || x < x0 - _l && x < x1 - _l) return false;
    if (x0 !== x1) {
        _a = (y0 - y1) / (x0 - x1);
        _b = (x0 * y1 - x1 * y0) / (x0 - x1);
    } else return Math.abs(x - x0) <= _l / 2;
    var tmp = _a * x - y + _b;
    var _s = tmp * tmp / (_a * _a + 1);
    return _s <= _l / 2 * _l / 2;
}



function $e22e0fd22a005e8a$export$8d36b1b5d19157c5(x0, y0, x1, y1, x2, y2, x3, y3, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    if (y > y0 + _l && y > y1 + _l && y > y2 + _l && y > y3 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l && y < y3 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l && x > x3 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l && x < x3 - _l) return false;
    var d = $747cfc5611b57cea$export$dbaa3801d1284367(x0, y0, x1, y1, x2, y2, x3, y3, x, y, null);
    return d <= _l / 2;
}



function $a1d80a5bf05b597b$export$8d36b1b5d19157c5(x0, y0, x1, y1, x2, y2, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    if (y > y0 + _l && y > y1 + _l && y > y2 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l) return false;
    var d = (0, $747cfc5611b57cea$export$81915a594fe10dee)(x0, y0, x1, y1, x2, y2, x, y, null);
    return d <= _l / 2;
}


var $b44a8536c7214e4f$var$PI2 = Math.PI * 2;
function $b44a8536c7214e4f$export$d44861331f213635(angle) {
    angle %= $b44a8536c7214e4f$var$PI2;
    if (angle < 0) angle += $b44a8536c7214e4f$var$PI2;
    return angle;
}


var $6e9b0f2fe4e39376$var$PI2 = Math.PI * 2;
function $6e9b0f2fe4e39376$export$8d36b1b5d19157c5(cx, cy, r, startAngle, endAngle, anticlockwise, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    x -= cx;
    y -= cy;
    var d = Math.sqrt(x * x + y * y);
    if (d - _l > r || d + _l < r) return false;
    if (Math.abs(startAngle - endAngle) % $6e9b0f2fe4e39376$var$PI2 < 1e-4) return true;
    if (anticlockwise) {
        var tmp = startAngle;
        startAngle = (0, $b44a8536c7214e4f$export$d44861331f213635)(endAngle);
        endAngle = (0, $b44a8536c7214e4f$export$d44861331f213635)(tmp);
    } else {
        startAngle = (0, $b44a8536c7214e4f$export$d44861331f213635)(startAngle);
        endAngle = (0, $b44a8536c7214e4f$export$d44861331f213635)(endAngle);
    }
    if (startAngle > endAngle) endAngle += $6e9b0f2fe4e39376$var$PI2;
    var angle = Math.atan2(y, x);
    if (angle < 0) angle += $6e9b0f2fe4e39376$var$PI2;
    return angle >= startAngle && angle <= endAngle || angle + $6e9b0f2fe4e39376$var$PI2 >= startAngle && angle + $6e9b0f2fe4e39376$var$PI2 <= endAngle;
}



function $e1acc0b10546155f$export$2e2bcd8739ae039(x0, y0, x1, y1, x, y) {
    if (y > y0 && y > y1 || y < y0 && y < y1) return 0;
    if (y1 === y0) return 0;
    var t = (y - y0) / (y1 - y0);
    var dir = y1 < y0 ? 1 : -1;
    if (t === 1 || t === 0) dir = y1 < y0 ? 0.5 : -0.5;
    var x_ = t * (x1 - x0) + x0;
    return x_ === x ? Infinity : x_ > x ? dir : 0;
}


var $347a114fcc5254ff$var$CMD = (0, $20ebe2448f123f2e$export$2e2bcd8739ae039).CMD;
var $347a114fcc5254ff$var$PI2 = Math.PI * 2;
var $347a114fcc5254ff$var$EPSILON = 1e-4;
function $347a114fcc5254ff$var$isAroundEqual(a, b) {
    return Math.abs(a - b) < $347a114fcc5254ff$var$EPSILON;
}
var $347a114fcc5254ff$var$roots = [
    -1,
    -1,
    -1
];
var $347a114fcc5254ff$var$extrema = [
    -1,
    -1
];
function $347a114fcc5254ff$var$swapExtrema() {
    var tmp = $347a114fcc5254ff$var$extrema[0];
    $347a114fcc5254ff$var$extrema[0] = $347a114fcc5254ff$var$extrema[1];
    $347a114fcc5254ff$var$extrema[1] = tmp;
}
function $347a114fcc5254ff$var$windingCubic(x0, y0, x1, y1, x2, y2, x3, y3, x, y) {
    if (y > y0 && y > y1 && y > y2 && y > y3 || y < y0 && y < y1 && y < y2 && y < y3) return 0;
    var nRoots = $747cfc5611b57cea$export$ca5d13faa10b167e(y0, y1, y2, y3, y, $347a114fcc5254ff$var$roots);
    if (nRoots === 0) return 0;
    else {
        var w = 0;
        var nExtrema = -1;
        var y0_ = void 0;
        var y1_ = void 0;
        for(var i = 0; i < nRoots; i++){
            var t = $347a114fcc5254ff$var$roots[i];
            var unit = t === 0 || t === 1 ? 0.5 : 1;
            var x_ = $747cfc5611b57cea$export$547c21de482bbcb2(x0, x1, x2, x3, t);
            if (x_ < x) continue;
            if (nExtrema < 0) {
                nExtrema = $747cfc5611b57cea$export$df1a172f100d0457(y0, y1, y2, y3, $347a114fcc5254ff$var$extrema);
                if ($347a114fcc5254ff$var$extrema[1] < $347a114fcc5254ff$var$extrema[0] && nExtrema > 1) $347a114fcc5254ff$var$swapExtrema();
                y0_ = $747cfc5611b57cea$export$547c21de482bbcb2(y0, y1, y2, y3, $347a114fcc5254ff$var$extrema[0]);
                if (nExtrema > 1) y1_ = $747cfc5611b57cea$export$547c21de482bbcb2(y0, y1, y2, y3, $347a114fcc5254ff$var$extrema[1]);
            }
            if (nExtrema === 2) {
                if (t < $347a114fcc5254ff$var$extrema[0]) w += y0_ < y0 ? unit : -unit;
                else if (t < $347a114fcc5254ff$var$extrema[1]) w += y1_ < y0_ ? unit : -unit;
                else w += y3 < y1_ ? unit : -unit;
            } else if (t < $347a114fcc5254ff$var$extrema[0]) w += y0_ < y0 ? unit : -unit;
            else w += y3 < y0_ ? unit : -unit;
        }
        return w;
    }
}
function $347a114fcc5254ff$var$windingQuadratic(x0, y0, x1, y1, x2, y2, x, y) {
    if (y > y0 && y > y1 && y > y2 || y < y0 && y < y1 && y < y2) return 0;
    var nRoots = $747cfc5611b57cea$export$fd895ac7ee764967(y0, y1, y2, y, $347a114fcc5254ff$var$roots);
    if (nRoots === 0) return 0;
    else {
        var t = $747cfc5611b57cea$export$752e1f8c6e7f7e11(y0, y1, y2);
        if (t >= 0 && t <= 1) {
            var w = 0;
            var y_ = $747cfc5611b57cea$export$af17094a950f5073(y0, y1, y2, t);
            for(var i = 0; i < nRoots; i++){
                var unit = $347a114fcc5254ff$var$roots[i] === 0 || $347a114fcc5254ff$var$roots[i] === 1 ? 0.5 : 1;
                var x_ = $747cfc5611b57cea$export$af17094a950f5073(x0, x1, x2, $347a114fcc5254ff$var$roots[i]);
                if (x_ < x) continue;
                if ($347a114fcc5254ff$var$roots[i] < t) w += y_ < y0 ? unit : -unit;
                else w += y2 < y_ ? unit : -unit;
            }
            return w;
        } else {
            var unit = $347a114fcc5254ff$var$roots[0] === 0 || $347a114fcc5254ff$var$roots[0] === 1 ? 0.5 : 1;
            var x_ = $747cfc5611b57cea$export$af17094a950f5073(x0, x1, x2, $347a114fcc5254ff$var$roots[0]);
            if (x_ < x) return 0;
            return y2 < y0 ? unit : -unit;
        }
    }
}
function $347a114fcc5254ff$var$windingArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y) {
    y -= cy;
    if (y > r || y < -r) return 0;
    var tmp = Math.sqrt(r * r - y * y);
    $347a114fcc5254ff$var$roots[0] = -tmp;
    $347a114fcc5254ff$var$roots[1] = tmp;
    var dTheta = Math.abs(startAngle - endAngle);
    if (dTheta < 1e-4) return 0;
    if (dTheta >= $347a114fcc5254ff$var$PI2 - 1e-4) {
        startAngle = 0;
        endAngle = $347a114fcc5254ff$var$PI2;
        var dir = anticlockwise ? 1 : -1;
        if (x >= $347a114fcc5254ff$var$roots[0] + cx && x <= $347a114fcc5254ff$var$roots[1] + cx) return dir;
        else return 0;
    }
    if (startAngle > endAngle) {
        var tmp_1 = startAngle;
        startAngle = endAngle;
        endAngle = tmp_1;
    }
    if (startAngle < 0) {
        startAngle += $347a114fcc5254ff$var$PI2;
        endAngle += $347a114fcc5254ff$var$PI2;
    }
    var w = 0;
    for(var i = 0; i < 2; i++){
        var x_ = $347a114fcc5254ff$var$roots[i];
        if (x_ + cx > x) {
            var angle = Math.atan2(y, x_);
            var dir = anticlockwise ? 1 : -1;
            if (angle < 0) angle = $347a114fcc5254ff$var$PI2 + angle;
            if (angle >= startAngle && angle <= endAngle || angle + $347a114fcc5254ff$var$PI2 >= startAngle && angle + $347a114fcc5254ff$var$PI2 <= endAngle) {
                if (angle > Math.PI / 2 && angle < Math.PI * 1.5) dir = -dir;
                w += dir;
            }
        }
    }
    return w;
}
function $347a114fcc5254ff$var$containPath(path, lineWidth, isStroke, x, y) {
    var data = path.data;
    var len = path.len();
    var w = 0;
    var xi = 0;
    var yi = 0;
    var x0 = 0;
    var y0 = 0;
    var x1;
    var y1;
    for(var i = 0; i < len;){
        var cmd = data[i++];
        var isFirst = i === 1;
        if (cmd === $347a114fcc5254ff$var$CMD.M && i > 1) {
            if (!isStroke) w += (0, $e1acc0b10546155f$export$2e2bcd8739ae039)(xi, yi, x0, y0, x, y);
        }
        if (isFirst) {
            xi = data[i];
            yi = data[i + 1];
            x0 = xi;
            y0 = yi;
        }
        switch(cmd){
            case $347a114fcc5254ff$var$CMD.M:
                x0 = data[i++];
                y0 = data[i++];
                xi = x0;
                yi = y0;
                break;
            case $347a114fcc5254ff$var$CMD.L:
                if (isStroke) {
                    if ($beafddd7270f4bea$export$8d36b1b5d19157c5(xi, yi, data[i], data[i + 1], lineWidth, x, y)) return true;
                } else w += (0, $e1acc0b10546155f$export$2e2bcd8739ae039)(xi, yi, data[i], data[i + 1], x, y) || 0;
                xi = data[i++];
                yi = data[i++];
                break;
            case $347a114fcc5254ff$var$CMD.C:
                if (isStroke) {
                    if ($e22e0fd22a005e8a$export$8d36b1b5d19157c5(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) return true;
                } else w += $347a114fcc5254ff$var$windingCubic(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
                xi = data[i++];
                yi = data[i++];
                break;
            case $347a114fcc5254ff$var$CMD.Q:
                if (isStroke) {
                    if ($a1d80a5bf05b597b$export$8d36b1b5d19157c5(xi, yi, data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) return true;
                } else w += $347a114fcc5254ff$var$windingQuadratic(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
                xi = data[i++];
                yi = data[i++];
                break;
            case $347a114fcc5254ff$var$CMD.A:
                var cx = data[i++];
                var cy = data[i++];
                var rx = data[i++];
                var ry = data[i++];
                var theta = data[i++];
                var dTheta = data[i++];
                i += 1;
                var anticlockwise = !!(1 - data[i++]);
                x1 = Math.cos(theta) * rx + cx;
                y1 = Math.sin(theta) * ry + cy;
                if (!isFirst) w += (0, $e1acc0b10546155f$export$2e2bcd8739ae039)(xi, yi, x1, y1, x, y);
                else {
                    x0 = x1;
                    y0 = y1;
                }
                var _x = (x - cx) * ry / rx + cx;
                if (isStroke) {
                    if ($6e9b0f2fe4e39376$export$8d36b1b5d19157c5(cx, cy, ry, theta, theta + dTheta, anticlockwise, lineWidth, _x, y)) return true;
                } else w += $347a114fcc5254ff$var$windingArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y);
                xi = Math.cos(theta + dTheta) * rx + cx;
                yi = Math.sin(theta + dTheta) * ry + cy;
                break;
            case $347a114fcc5254ff$var$CMD.R:
                x0 = xi = data[i++];
                y0 = yi = data[i++];
                var width = data[i++];
                var height = data[i++];
                x1 = x0 + width;
                y1 = y0 + height;
                if (isStroke) {
                    if ($beafddd7270f4bea$export$8d36b1b5d19157c5(x0, y0, x1, y0, lineWidth, x, y) || $beafddd7270f4bea$export$8d36b1b5d19157c5(x1, y0, x1, y1, lineWidth, x, y) || $beafddd7270f4bea$export$8d36b1b5d19157c5(x1, y1, x0, y1, lineWidth, x, y) || $beafddd7270f4bea$export$8d36b1b5d19157c5(x0, y1, x0, y0, lineWidth, x, y)) return true;
                } else {
                    w += (0, $e1acc0b10546155f$export$2e2bcd8739ae039)(x1, y0, x1, y1, x, y);
                    w += (0, $e1acc0b10546155f$export$2e2bcd8739ae039)(x0, y1, x0, y0, x, y);
                }
                break;
            case $347a114fcc5254ff$var$CMD.Z:
                if (isStroke) {
                    if ($beafddd7270f4bea$export$8d36b1b5d19157c5(xi, yi, x0, y0, lineWidth, x, y)) return true;
                } else w += (0, $e1acc0b10546155f$export$2e2bcd8739ae039)(xi, yi, x0, y0, x, y);
                xi = x0;
                yi = y0;
                break;
        }
    }
    if (!isStroke && !$347a114fcc5254ff$var$isAroundEqual(yi, y0)) w += (0, $e1acc0b10546155f$export$2e2bcd8739ae039)(xi, yi, x0, y0, x, y) || 0;
    return w !== 0;
}
function $347a114fcc5254ff$export$8893e2b90ba10d92(pathProxy, x, y) {
    return $347a114fcc5254ff$var$containPath(pathProxy, 0, false, x, y);
}
function $347a114fcc5254ff$export$8d36b1b5d19157c5(pathProxy, lineWidth, x, y) {
    return $347a114fcc5254ff$var$containPath(pathProxy, lineWidth, true, x, y);
}







var $b02ffe7acd508c08$export$deade517576e293a = (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
    fill: '#000',
    stroke: null,
    strokePercent: 1,
    fillOpacity: 1,
    strokeOpacity: 1,
    lineDashOffset: 0,
    lineWidth: 1,
    lineCap: 'butt',
    miterLimit: 10,
    strokeNoScale: false,
    strokeFirst: false
}, (0, $56206a6cb4666931$export$737672163db00fe3));
var $b02ffe7acd508c08$export$71bb6c3c6862c6a5 = {
    style: (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
        fill: true,
        stroke: true,
        strokePercent: true,
        fillOpacity: true,
        strokeOpacity: true,
        lineDashOffset: true,
        lineWidth: true,
        miterLimit: true
    }, (0, $56206a6cb4666931$export$9908943fb57fbe51).style)
};
var $b02ffe7acd508c08$var$pathCopyParams = (0, $becf2d727f9cf450$export$98ab6203ec3396e2).concat([
    'invisible',
    'culling',
    'z',
    'z2',
    'zlevel',
    'parent'
]);
var $b02ffe7acd508c08$var$Path = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Path, _super);
    function Path(opts) {
        return _super.call(this, opts) || this;
    }
    Path.prototype.update = function() {
        var _this = this;
        _super.prototype.update.call(this);
        var style = this.style;
        if (style.decal) {
            var decalEl = this._decalEl = this._decalEl || new Path();
            if (decalEl.buildPath === Path.prototype.buildPath) decalEl.buildPath = function(ctx) {
                _this.buildPath(ctx, _this.shape);
            };
            decalEl.silent = true;
            var decalElStyle = decalEl.style;
            for(var key in style)if (decalElStyle[key] !== style[key]) decalElStyle[key] = style[key];
            decalElStyle.fill = style.fill ? style.decal : null;
            decalElStyle.decal = null;
            decalElStyle.shadowColor = null;
            style.strokeFirst && (decalElStyle.stroke = null);
            for(var i = 0; i < $b02ffe7acd508c08$var$pathCopyParams.length; ++i)decalEl[$b02ffe7acd508c08$var$pathCopyParams[i]] = this[$b02ffe7acd508c08$var$pathCopyParams[i]];
            decalEl.__dirty |= (0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd);
        } else if (this._decalEl) this._decalEl = null;
    };
    Path.prototype.getDecalElement = function() {
        return this._decalEl;
    };
    Path.prototype._init = function(props) {
        var keysArr = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(props);
        this.shape = this.getDefaultShape();
        var defaultStyle = this.getDefaultStyle();
        if (defaultStyle) this.useStyle(defaultStyle);
        for(var i = 0; i < keysArr.length; i++){
            var key = keysArr[i];
            var value = props[key];
            if (key === 'style') {
                if (!this.style) this.useStyle(value);
                else (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(this.style, value);
            } else if (key === 'shape') (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(this.shape, value);
            else _super.prototype.attrKV.call(this, key, value);
        }
        if (!this.style) this.useStyle({});
    };
    Path.prototype.getDefaultStyle = function() {
        return null;
    };
    Path.prototype.getDefaultShape = function() {
        return {};
    };
    Path.prototype.canBeInsideText = function() {
        return this.hasFill();
    };
    Path.prototype.getInsideTextFill = function() {
        var pathFill = this.style.fill;
        if (pathFill !== 'none') {
            if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(pathFill)) {
                var fillLum = (0, $2c037f5bda6341ca$export$16c0ec21a6f9ef95)(pathFill, 0);
                if (fillLum > 0.5) return 0, $4b0cedd85979c776$export$f8ce94761f39398d;
                else if (fillLum > 0.2) return 0, $4b0cedd85979c776$export$27682248795c3c6b;
                return 0, $4b0cedd85979c776$export$3c6e95f318c8369b;
            } else if (pathFill) return 0, $4b0cedd85979c776$export$3c6e95f318c8369b;
        }
        return 0, $4b0cedd85979c776$export$f8ce94761f39398d;
    };
    Path.prototype.getInsideTextStroke = function(textFill) {
        var pathFill = this.style.fill;
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(pathFill)) {
            var zr = this.__zr;
            var isDarkMode = !!(zr && zr.isDarkMode());
            var isDarkLabel = (0, $2c037f5bda6341ca$export$16c0ec21a6f9ef95)(textFill, 0) < (0, $4b0cedd85979c776$export$fd81e7ebc7dae256);
            if (isDarkMode === isDarkLabel) return pathFill;
        }
    };
    Path.prototype.buildPath = function(ctx, shapeCfg, inBatch) {};
    Path.prototype.pathUpdated = function() {
        this.__dirty &= ~(0, $ddf76b16f1246ba9$export$f75fe89a33ebe115);
    };
    Path.prototype.getUpdatedPathProxy = function(inBatch) {
        !this.path && this.createPathProxy();
        this.path.beginPath();
        this.buildPath(this.path, this.shape, inBatch);
        return this.path;
    };
    Path.prototype.createPathProxy = function() {
        this.path = new (0, $20ebe2448f123f2e$export$2e2bcd8739ae039)(false);
    };
    Path.prototype.hasStroke = function() {
        var style = this.style;
        var stroke = style.stroke;
        return !(stroke == null || stroke === 'none' || !(style.lineWidth > 0));
    };
    Path.prototype.hasFill = function() {
        var style = this.style;
        var fill = style.fill;
        return fill != null && fill !== 'none';
    };
    Path.prototype.getBoundingRect = function() {
        var rect = this._rect;
        var style = this.style;
        var needsUpdateRect = !rect;
        if (needsUpdateRect) {
            var firstInvoke = false;
            if (!this.path) {
                firstInvoke = true;
                this.createPathProxy();
            }
            var path = this.path;
            if (firstInvoke || this.__dirty & (0, $ddf76b16f1246ba9$export$f75fe89a33ebe115)) {
                path.beginPath();
                this.buildPath(path, this.shape, false);
                this.pathUpdated();
            }
            rect = path.getBoundingRect();
        }
        this._rect = rect;
        if (this.hasStroke() && this.path && this.path.len() > 0) {
            var rectStroke = this._rectStroke || (this._rectStroke = rect.clone());
            if (this.__dirty || needsUpdateRect) {
                rectStroke.copy(rect);
                var lineScale = style.strokeNoScale ? this.getLineScale() : 1;
                var w = style.lineWidth;
                if (!this.hasFill()) {
                    var strokeContainThreshold = this.strokeContainThreshold;
                    w = Math.max(w, strokeContainThreshold == null ? 4 : strokeContainThreshold);
                }
                if (lineScale > 1e-10) {
                    rectStroke.width += w / lineScale;
                    rectStroke.height += w / lineScale;
                    rectStroke.x -= w / lineScale / 2;
                    rectStroke.y -= w / lineScale / 2;
                }
            }
            return rectStroke;
        }
        return rect;
    };
    Path.prototype.contain = function(x, y) {
        var localPos = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        var style = this.style;
        x = localPos[0];
        y = localPos[1];
        if (rect.contain(x, y)) {
            var pathProxy = this.path;
            if (this.hasStroke()) {
                var lineWidth = style.lineWidth;
                var lineScale = style.strokeNoScale ? this.getLineScale() : 1;
                if (lineScale > 1e-10) {
                    if (!this.hasFill()) lineWidth = Math.max(lineWidth, this.strokeContainThreshold);
                    if ($347a114fcc5254ff$export$8d36b1b5d19157c5(pathProxy, lineWidth / lineScale, x, y)) return true;
                }
            }
            if (this.hasFill()) return $347a114fcc5254ff$export$8893e2b90ba10d92(pathProxy, x, y);
        }
        return false;
    };
    Path.prototype.dirtyShape = function() {
        this.__dirty |= (0, $ddf76b16f1246ba9$export$f75fe89a33ebe115);
        if (this._rect) this._rect = null;
        if (this._decalEl) this._decalEl.dirtyShape();
        this.markRedraw();
    };
    Path.prototype.dirty = function() {
        this.dirtyStyle();
        this.dirtyShape();
    };
    Path.prototype.animateShape = function(loop) {
        return this.animate('shape', loop);
    };
    Path.prototype.updateDuringAnimation = function(targetKey) {
        if (targetKey === 'style') this.dirtyStyle();
        else if (targetKey === 'shape') this.dirtyShape();
        else this.markRedraw();
    };
    Path.prototype.attrKV = function(key, value) {
        if (key === 'shape') this.setShape(value);
        else _super.prototype.attrKV.call(this, key, value);
    };
    Path.prototype.setShape = function(keyOrObj, value) {
        var shape = this.shape;
        if (!shape) shape = this.shape = {};
        if (typeof keyOrObj === 'string') shape[keyOrObj] = value;
        else (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(shape, keyOrObj);
        this.dirtyShape();
        return this;
    };
    Path.prototype.shapeChanged = function() {
        return !!(this.__dirty & (0, $ddf76b16f1246ba9$export$f75fe89a33ebe115));
    };
    Path.prototype.createStyle = function(obj) {
        return (0, $7a1bd9c2710fea0d$export$79c7e160a7743efd)($b02ffe7acd508c08$export$deade517576e293a, obj);
    };
    Path.prototype._innerSaveToNormal = function(toState) {
        _super.prototype._innerSaveToNormal.call(this, toState);
        var normalState = this._normalState;
        if (toState.shape && !normalState.shape) normalState.shape = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, this.shape);
    };
    Path.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        _super.prototype._applyStateObj.call(this, stateName, state, normalState, keepCurrentStates, transition, animationCfg);
        var needsRestoreToNormal = !(state && keepCurrentStates);
        var targetShape;
        if (state && state.shape) {
            if (transition) {
                if (keepCurrentStates) targetShape = state.shape;
                else {
                    targetShape = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, normalState.shape);
                    (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(targetShape, state.shape);
                }
            } else {
                targetShape = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, keepCurrentStates ? this.shape : normalState.shape);
                (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(targetShape, state.shape);
            }
        } else if (needsRestoreToNormal) targetShape = normalState.shape;
        if (targetShape) {
            if (transition) {
                this.shape = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, this.shape);
                var targetShapePrimaryProps = {};
                var shapeKeys = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(targetShape);
                for(var i = 0; i < shapeKeys.length; i++){
                    var key = shapeKeys[i];
                    if (typeof targetShape[key] === 'object') this.shape[key] = targetShape[key];
                    else targetShapePrimaryProps[key] = targetShape[key];
                }
                this._transitionState(stateName, {
                    shape: targetShapePrimaryProps
                }, animationCfg);
            } else {
                this.shape = targetShape;
                this.dirtyShape();
            }
        }
    };
    Path.prototype._mergeStates = function(states) {
        var mergedState = _super.prototype._mergeStates.call(this, states);
        var mergedShape;
        for(var i = 0; i < states.length; i++){
            var state = states[i];
            if (state.shape) {
                mergedShape = mergedShape || {};
                this._mergeStyle(mergedShape, state.shape);
            }
        }
        if (mergedShape) mergedState.shape = mergedShape;
        return mergedState;
    };
    Path.prototype.getAnimationStyleProps = function() {
        return $b02ffe7acd508c08$export$71bb6c3c6862c6a5;
    };
    Path.prototype.isZeroArea = function() {
        return false;
    };
    Path.extend = function(defaultProps) {
        var Sub = function(_super) {
            (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Sub, _super);
            function Sub(opts) {
                var _this = _super.call(this, opts) || this;
                defaultProps.init && defaultProps.init.call(_this, opts);
                return _this;
            }
            Sub.prototype.getDefaultStyle = function() {
                return (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(defaultProps.style);
            };
            Sub.prototype.getDefaultShape = function() {
                return (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(defaultProps.shape);
            };
            return Sub;
        }(Path);
        for(var key in defaultProps)if (typeof defaultProps[key] === 'function') Sub.prototype[key] = defaultProps[key];
        return Sub;
    };
    Path.initDefaultProps = function() {
        var pathProto = Path.prototype;
        pathProto.type = 'path';
        pathProto.strokeContainThreshold = 5;
        pathProto.segmentIgnoreThreshold = 0;
        pathProto.subPixelOptimize = false;
        pathProto.autoBatch = false;
        pathProto.__dirty = (0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd) | (0, $ddf76b16f1246ba9$export$ada8b2beb3d76671) | (0, $ddf76b16f1246ba9$export$f75fe89a33ebe115);
    }();
    return Path;
}((0, $56206a6cb4666931$export$2e2bcd8739ae039));
var $b02ffe7acd508c08$export$2e2bcd8739ae039 = $b02ffe7acd508c08$var$Path;




var $c9d5c769fe2f591f$export$5fbb6d98091bcb56 = (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
    strokeFirst: true,
    font: (0, $c6341dcc9d86826e$export$7d7a232b6d2cc80c),
    x: 0,
    y: 0,
    textAlign: 'left',
    textBaseline: 'top',
    miterLimit: 2
}, (0, $b02ffe7acd508c08$export$deade517576e293a));
var $c9d5c769fe2f591f$var$TSpan = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(TSpan, _super);
    function TSpan() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TSpan.prototype.hasStroke = function() {
        var style = this.style;
        var stroke = style.stroke;
        return stroke != null && stroke !== 'none' && style.lineWidth > 0;
    };
    TSpan.prototype.hasFill = function() {
        var style = this.style;
        var fill = style.fill;
        return fill != null && fill !== 'none';
    };
    TSpan.prototype.createStyle = function(obj) {
        return (0, $7a1bd9c2710fea0d$export$79c7e160a7743efd)($c9d5c769fe2f591f$export$5fbb6d98091bcb56, obj);
    };
    TSpan.prototype.setBoundingRect = function(rect) {
        this._rect = rect;
    };
    TSpan.prototype.getBoundingRect = function() {
        var style = this.style;
        if (!this._rect) {
            var text = style.text;
            text != null ? text += '' : text = '';
            var rect = (0, $6c308355c7107803$export$c381147bfed79d9f)(text, style.font, style.textAlign, style.textBaseline);
            rect.x += style.x || 0;
            rect.y += style.y || 0;
            if (this.hasStroke()) {
                var w = style.lineWidth;
                rect.x -= w / 2;
                rect.y -= w / 2;
                rect.width += w;
                rect.height += w;
            }
            this._rect = rect;
        }
        return this._rect;
    };
    TSpan.initDefaultProps = function() {
        var tspanProto = TSpan.prototype;
        tspanProto.dirtyRectTolerance = 10;
    }();
    return TSpan;
}((0, $56206a6cb4666931$export$2e2bcd8739ae039));
$c9d5c769fe2f591f$var$TSpan.prototype.type = 'tspan';
var $c9d5c769fe2f591f$export$2e2bcd8739ae039 = $c9d5c769fe2f591f$var$TSpan;








var $86adec94217b86c6$export$8993f922aeeac642 = (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
    x: 0,
    y: 0
}, (0, $56206a6cb4666931$export$737672163db00fe3));
var $86adec94217b86c6$export$4aba8ad70847a488 = {
    style: (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
        x: true,
        y: true,
        width: true,
        height: true,
        sx: true,
        sy: true,
        sWidth: true,
        sHeight: true
    }, (0, $56206a6cb4666931$export$9908943fb57fbe51).style)
};
function $86adec94217b86c6$var$isImageLike(source) {
    return !!(source && typeof source !== 'string' && source.width && source.height);
}
var $86adec94217b86c6$var$ZRImage = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(ZRImage, _super);
    function ZRImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ZRImage.prototype.createStyle = function(obj) {
        return (0, $7a1bd9c2710fea0d$export$79c7e160a7743efd)($86adec94217b86c6$export$8993f922aeeac642, obj);
    };
    ZRImage.prototype._getSize = function(dim) {
        var style = this.style;
        var size = style[dim];
        if (size != null) return size;
        var imageSource = $86adec94217b86c6$var$isImageLike(style.image) ? style.image : this.__image;
        if (!imageSource) return 0;
        var otherDim = dim === 'width' ? 'height' : 'width';
        var otherDimSize = style[otherDim];
        if (otherDimSize == null) return imageSource[dim];
        else return imageSource[dim] / imageSource[otherDim] * otherDimSize;
    };
    ZRImage.prototype.getWidth = function() {
        return this._getSize('width');
    };
    ZRImage.prototype.getHeight = function() {
        return this._getSize('height');
    };
    ZRImage.prototype.getAnimationStyleProps = function() {
        return $86adec94217b86c6$export$4aba8ad70847a488;
    };
    ZRImage.prototype.getBoundingRect = function() {
        var style = this.style;
        if (!this._rect) this._rect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(style.x || 0, style.y || 0, this.getWidth(), this.getHeight());
        return this._rect;
    };
    return ZRImage;
}((0, $56206a6cb4666931$export$2e2bcd8739ae039));
$86adec94217b86c6$var$ZRImage.prototype.type = 'image';
var $86adec94217b86c6$export$2e2bcd8739ae039 = $86adec94217b86c6$var$ZRImage;




function $a351e275fffc3a77$export$5cc7f731b5937e99(ctx, shape) {
    var x = shape.x;
    var y = shape.y;
    var width = shape.width;
    var height = shape.height;
    var r = shape.r;
    var r1;
    var r2;
    var r3;
    var r4;
    if (width < 0) {
        x = x + width;
        width = -width;
    }
    if (height < 0) {
        y = y + height;
        height = -height;
    }
    if (typeof r === 'number') r1 = r2 = r3 = r4 = r;
    else if (r instanceof Array) {
        if (r.length === 1) r1 = r2 = r3 = r4 = r[0];
        else if (r.length === 2) {
            r1 = r3 = r[0];
            r2 = r4 = r[1];
        } else if (r.length === 3) {
            r1 = r[0];
            r2 = r4 = r[1];
            r3 = r[2];
        } else {
            r1 = r[0];
            r2 = r[1];
            r3 = r[2];
            r4 = r[3];
        }
    } else r1 = r2 = r3 = r4 = 0;
    var total;
    if (r1 + r2 > width) {
        total = r1 + r2;
        r1 *= width / total;
        r2 *= width / total;
    }
    if (r3 + r4 > width) {
        total = r3 + r4;
        r3 *= width / total;
        r4 *= width / total;
    }
    if (r2 + r3 > height) {
        total = r2 + r3;
        r2 *= height / total;
        r3 *= height / total;
    }
    if (r1 + r4 > height) {
        total = r1 + r4;
        r1 *= height / total;
        r4 *= height / total;
    }
    ctx.moveTo(x + r1, y);
    ctx.lineTo(x + width - r2, y);
    r2 !== 0 && ctx.arc(x + width - r2, y + r2, r2, -Math.PI / 2, 0);
    ctx.lineTo(x + width, y + height - r3);
    r3 !== 0 && ctx.arc(x + width - r3, y + height - r3, r3, 0, Math.PI / 2);
    ctx.lineTo(x + r4, y + height);
    r4 !== 0 && ctx.arc(x + r4, y + height - r4, r4, Math.PI / 2, Math.PI);
    ctx.lineTo(x, y + r1);
    r1 !== 0 && ctx.arc(x + r1, y + r1, r1, Math.PI, Math.PI * 1.5);
}


var $4d5544821af8d796$var$round = Math.round;
function $4d5544821af8d796$export$8b4b620d7f4aad1b(outputShape, inputShape, style) {
    if (!inputShape) return;
    var x1 = inputShape.x1;
    var x2 = inputShape.x2;
    var y1 = inputShape.y1;
    var y2 = inputShape.y2;
    outputShape.x1 = x1;
    outputShape.x2 = x2;
    outputShape.y1 = y1;
    outputShape.y2 = y2;
    var lineWidth = style && style.lineWidth;
    if (!lineWidth) return outputShape;
    if ($4d5544821af8d796$var$round(x1 * 2) === $4d5544821af8d796$var$round(x2 * 2)) outputShape.x1 = outputShape.x2 = $4d5544821af8d796$export$72c4fd4c1b8fcb10(x1, lineWidth, true);
    if ($4d5544821af8d796$var$round(y1 * 2) === $4d5544821af8d796$var$round(y2 * 2)) outputShape.y1 = outputShape.y2 = $4d5544821af8d796$export$72c4fd4c1b8fcb10(y1, lineWidth, true);
    return outputShape;
}
function $4d5544821af8d796$export$60e2aa74957d0b9d(outputShape, inputShape, style) {
    if (!inputShape) return;
    var originX = inputShape.x;
    var originY = inputShape.y;
    var originWidth = inputShape.width;
    var originHeight = inputShape.height;
    outputShape.x = originX;
    outputShape.y = originY;
    outputShape.width = originWidth;
    outputShape.height = originHeight;
    var lineWidth = style && style.lineWidth;
    if (!lineWidth) return outputShape;
    outputShape.x = $4d5544821af8d796$export$72c4fd4c1b8fcb10(originX, lineWidth, true);
    outputShape.y = $4d5544821af8d796$export$72c4fd4c1b8fcb10(originY, lineWidth, true);
    outputShape.width = Math.max($4d5544821af8d796$export$72c4fd4c1b8fcb10(originX + originWidth, lineWidth, false) - outputShape.x, originWidth === 0 ? 0 : 1);
    outputShape.height = Math.max($4d5544821af8d796$export$72c4fd4c1b8fcb10(originY + originHeight, lineWidth, false) - outputShape.y, originHeight === 0 ? 0 : 1);
    return outputShape;
}
function $4d5544821af8d796$export$72c4fd4c1b8fcb10(position, lineWidth, positiveOrNegative) {
    if (!lineWidth) return position;
    var doubledPosition = $4d5544821af8d796$var$round(position * 2);
    return (doubledPosition + $4d5544821af8d796$var$round(lineWidth)) % 2 === 0 ? doubledPosition / 2 : (doubledPosition + (positiveOrNegative ? 1 : -1)) / 2;
}


var $419e5ff2f303755e$export$51140d6b71bb4ed5 = function() {
    function RectShape() {
        this.x = 0;
        this.y = 0;
        this.width = 0;
        this.height = 0;
    }
    return RectShape;
}();
var $419e5ff2f303755e$var$subPixelOptimizeOutputShape = {};
var $419e5ff2f303755e$var$Rect = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Rect, _super);
    function Rect(opts) {
        return _super.call(this, opts) || this;
    }
    Rect.prototype.getDefaultShape = function() {
        return new $419e5ff2f303755e$export$51140d6b71bb4ed5();
    };
    Rect.prototype.buildPath = function(ctx, shape) {
        var x;
        var y;
        var width;
        var height;
        if (this.subPixelOptimize) {
            var optimizedShape = (0, $4d5544821af8d796$export$60e2aa74957d0b9d)($419e5ff2f303755e$var$subPixelOptimizeOutputShape, shape, this.style);
            x = optimizedShape.x;
            y = optimizedShape.y;
            width = optimizedShape.width;
            height = optimizedShape.height;
            optimizedShape.r = shape.r;
            shape = optimizedShape;
        } else {
            x = shape.x;
            y = shape.y;
            width = shape.width;
            height = shape.height;
        }
        if (!shape.r) ctx.rect(x, y, width, height);
        else $a351e275fffc3a77$export$5cc7f731b5937e99(ctx, shape);
    };
    Rect.prototype.isZeroArea = function() {
        return !this.shape.width || !this.shape.height;
    };
    return Rect;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
$419e5ff2f303755e$var$Rect.prototype.type = 'rect';
var $419e5ff2f303755e$export$2e2bcd8739ae039 = $419e5ff2f303755e$var$Rect;





var $fe885cc21795562b$var$DEFAULT_RICH_TEXT_COLOR = {
    fill: '#000'
};
var $fe885cc21795562b$var$DEFAULT_STROKE_LINE_WIDTH = 2;
var $fe885cc21795562b$export$21aaaa0607ee0e2b = {
    style: (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
        fill: true,
        stroke: true,
        fillOpacity: true,
        strokeOpacity: true,
        lineWidth: true,
        fontSize: true,
        lineHeight: true,
        width: true,
        height: true,
        textShadowColor: true,
        textShadowBlur: true,
        textShadowOffsetX: true,
        textShadowOffsetY: true,
        backgroundColor: true,
        padding: true,
        borderColor: true,
        borderWidth: true,
        borderRadius: true
    }, (0, $56206a6cb4666931$export$9908943fb57fbe51).style)
};
var $fe885cc21795562b$var$ZRText = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(ZRText, _super);
    function ZRText(opts) {
        var _this = _super.call(this) || this;
        _this.type = 'text';
        _this._children = [];
        _this._defaultStyle = $fe885cc21795562b$var$DEFAULT_RICH_TEXT_COLOR;
        _this.attr(opts);
        return _this;
    }
    ZRText.prototype.childrenRef = function() {
        return this._children;
    };
    ZRText.prototype.update = function() {
        _super.prototype.update.call(this);
        if (this.styleChanged()) this._updateSubTexts();
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            child.zlevel = this.zlevel;
            child.z = this.z;
            child.z2 = this.z2;
            child.culling = this.culling;
            child.cursor = this.cursor;
            child.invisible = this.invisible;
        }
    };
    ZRText.prototype.updateTransform = function() {
        var innerTransformable = this.innerTransformable;
        if (innerTransformable) {
            innerTransformable.updateTransform();
            if (innerTransformable.transform) this.transform = innerTransformable.transform;
        } else _super.prototype.updateTransform.call(this);
    };
    ZRText.prototype.getLocalTransform = function(m) {
        var innerTransformable = this.innerTransformable;
        return innerTransformable ? innerTransformable.getLocalTransform(m) : _super.prototype.getLocalTransform.call(this, m);
    };
    ZRText.prototype.getComputedTransform = function() {
        if (this.__hostTarget) {
            this.__hostTarget.getComputedTransform();
            this.__hostTarget.updateInnerText(true);
        }
        return _super.prototype.getComputedTransform.call(this);
    };
    ZRText.prototype._updateSubTexts = function() {
        this._childCursor = 0;
        $fe885cc21795562b$export$176336068cc5371f(this.style);
        this.style.rich ? this._updateRichTexts() : this._updatePlainTexts();
        this._children.length = this._childCursor;
        this.styleUpdated();
    };
    ZRText.prototype.addSelfToZr = function(zr) {
        _super.prototype.addSelfToZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++)this._children[i].__zr = zr;
    };
    ZRText.prototype.removeSelfFromZr = function(zr) {
        _super.prototype.removeSelfFromZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++)this._children[i].__zr = null;
    };
    ZRText.prototype.getBoundingRect = function() {
        if (this.styleChanged()) this._updateSubTexts();
        if (!this._rect) {
            var tmpRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
            var children = this._children;
            var tmpMat = [];
            var rect = null;
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                var childRect = child.getBoundingRect();
                var transform = child.getLocalTransform(tmpMat);
                if (transform) {
                    tmpRect.copy(childRect);
                    tmpRect.applyTransform(transform);
                    rect = rect || tmpRect.clone();
                    rect.union(tmpRect);
                } else {
                    rect = rect || childRect.clone();
                    rect.union(childRect);
                }
            }
            this._rect = rect || tmpRect;
        }
        return this._rect;
    };
    ZRText.prototype.setDefaultTextStyle = function(defaultTextStyle) {
        this._defaultStyle = defaultTextStyle || $fe885cc21795562b$var$DEFAULT_RICH_TEXT_COLOR;
    };
    ZRText.prototype.setTextContent = function(textContent) {};
    ZRText.prototype._mergeStyle = function(targetStyle, sourceStyle) {
        if (!sourceStyle) return targetStyle;
        var sourceRich = sourceStyle.rich;
        var targetRich = targetStyle.rich || sourceRich && {};
        (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(targetStyle, sourceStyle);
        if (sourceRich && targetRich) {
            this._mergeRich(targetRich, sourceRich);
            targetStyle.rich = targetRich;
        } else if (targetRich) targetStyle.rich = targetRich;
        return targetStyle;
    };
    ZRText.prototype._mergeRich = function(targetRich, sourceRich) {
        var richNames = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(sourceRich);
        for(var i = 0; i < richNames.length; i++){
            var richName = richNames[i];
            targetRich[richName] = targetRich[richName] || {};
            (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(targetRich[richName], sourceRich[richName]);
        }
    };
    ZRText.prototype.getAnimationStyleProps = function() {
        return $fe885cc21795562b$export$21aaaa0607ee0e2b;
    };
    ZRText.prototype._getOrCreateChild = function(Ctor) {
        var child = this._children[this._childCursor];
        if (!child || !(child instanceof Ctor)) child = new Ctor();
        this._children[this._childCursor++] = child;
        child.__zr = this.__zr;
        child.parent = this;
        return child;
    };
    ZRText.prototype._updatePlainTexts = function() {
        var style = this.style;
        var textFont = style.font || (0, $c6341dcc9d86826e$export$7d7a232b6d2cc80c);
        var textPadding = style.padding;
        var text = $fe885cc21795562b$var$getStyleText(style);
        var contentBlock = (0, $64fa9b3825ba2dec$export$5772575e34ef80f9)(text, style);
        var needDrawBg = $fe885cc21795562b$var$needDrawBackground(style);
        var bgColorDrawn = !!style.backgroundColor;
        var outerHeight = contentBlock.outerHeight;
        var outerWidth = contentBlock.outerWidth;
        var contentWidth = contentBlock.contentWidth;
        var textLines = contentBlock.lines;
        var lineHeight = contentBlock.lineHeight;
        var defaultStyle = this._defaultStyle;
        this.isTruncated = !!contentBlock.isTruncated;
        var baseX = style.x || 0;
        var baseY = style.y || 0;
        var textAlign = style.align || defaultStyle.align || 'left';
        var verticalAlign = style.verticalAlign || defaultStyle.verticalAlign || 'top';
        var textX = baseX;
        var textY = (0, $6c308355c7107803$export$bf7d6802d2badd9)(baseY, contentBlock.contentHeight, verticalAlign);
        if (needDrawBg || textPadding) {
            var boxX = (0, $6c308355c7107803$export$eb5a525ef00ef9a4)(baseX, outerWidth, textAlign);
            var boxY = (0, $6c308355c7107803$export$bf7d6802d2badd9)(baseY, outerHeight, verticalAlign);
            needDrawBg && this._renderBackground(style, style, boxX, boxY, outerWidth, outerHeight);
        }
        textY += lineHeight / 2;
        if (textPadding) {
            textX = $fe885cc21795562b$var$getTextXForPadding(baseX, textAlign, textPadding);
            if (verticalAlign === 'top') textY += textPadding[0];
            else if (verticalAlign === 'bottom') textY -= textPadding[2];
        }
        var defaultLineWidth = 0;
        var useDefaultFill = false;
        var textFill = $fe885cc21795562b$var$getFill('fill' in style ? style.fill : (useDefaultFill = true, defaultStyle.fill));
        var textStroke = $fe885cc21795562b$var$getStroke('stroke' in style ? style.stroke : !bgColorDrawn && (!defaultStyle.autoStroke || useDefaultFill) ? (defaultLineWidth = $fe885cc21795562b$var$DEFAULT_STROKE_LINE_WIDTH, defaultStyle.stroke) : null);
        var hasShadow = style.textShadowBlur > 0;
        var fixedBoundingRect = style.width != null && (style.overflow === 'truncate' || style.overflow === 'break' || style.overflow === 'breakAll');
        var calculatedLineHeight = contentBlock.calculatedLineHeight;
        for(var i = 0; i < textLines.length; i++){
            var el = this._getOrCreateChild((0, $c9d5c769fe2f591f$export$2e2bcd8739ae039));
            var subElStyle = el.createStyle();
            el.useStyle(subElStyle);
            subElStyle.text = textLines[i];
            subElStyle.x = textX;
            subElStyle.y = textY;
            if (textAlign) subElStyle.textAlign = textAlign;
            subElStyle.textBaseline = 'middle';
            subElStyle.opacity = style.opacity;
            subElStyle.strokeFirst = true;
            if (hasShadow) {
                subElStyle.shadowBlur = style.textShadowBlur || 0;
                subElStyle.shadowColor = style.textShadowColor || 'transparent';
                subElStyle.shadowOffsetX = style.textShadowOffsetX || 0;
                subElStyle.shadowOffsetY = style.textShadowOffsetY || 0;
            }
            subElStyle.stroke = textStroke;
            subElStyle.fill = textFill;
            if (textStroke) {
                subElStyle.lineWidth = style.lineWidth || defaultLineWidth;
                subElStyle.lineDash = style.lineDash;
                subElStyle.lineDashOffset = style.lineDashOffset || 0;
            }
            subElStyle.font = textFont;
            $fe885cc21795562b$var$setSeparateFont(subElStyle, style);
            textY += lineHeight;
            if (fixedBoundingRect) el.setBoundingRect(new (0, $1bebe7106c895823$export$2e2bcd8739ae039)((0, $6c308355c7107803$export$eb5a525ef00ef9a4)(subElStyle.x, contentWidth, subElStyle.textAlign), (0, $6c308355c7107803$export$bf7d6802d2badd9)(subElStyle.y, calculatedLineHeight, subElStyle.textBaseline), contentWidth, calculatedLineHeight));
        }
    };
    ZRText.prototype._updateRichTexts = function() {
        var style = this.style;
        var text = $fe885cc21795562b$var$getStyleText(style);
        var contentBlock = (0, $64fa9b3825ba2dec$export$15ec9472ff2d721)(text, style);
        var contentWidth = contentBlock.width;
        var outerWidth = contentBlock.outerWidth;
        var outerHeight = contentBlock.outerHeight;
        var textPadding = style.padding;
        var baseX = style.x || 0;
        var baseY = style.y || 0;
        var defaultStyle = this._defaultStyle;
        var textAlign = style.align || defaultStyle.align;
        var verticalAlign = style.verticalAlign || defaultStyle.verticalAlign;
        this.isTruncated = !!contentBlock.isTruncated;
        var boxX = (0, $6c308355c7107803$export$eb5a525ef00ef9a4)(baseX, outerWidth, textAlign);
        var boxY = (0, $6c308355c7107803$export$bf7d6802d2badd9)(baseY, outerHeight, verticalAlign);
        var xLeft = boxX;
        var lineTop = boxY;
        if (textPadding) {
            xLeft += textPadding[3];
            lineTop += textPadding[0];
        }
        var xRight = xLeft + contentWidth;
        if ($fe885cc21795562b$var$needDrawBackground(style)) this._renderBackground(style, style, boxX, boxY, outerWidth, outerHeight);
        var bgColorDrawn = !!style.backgroundColor;
        for(var i = 0; i < contentBlock.lines.length; i++){
            var line = contentBlock.lines[i];
            var tokens = line.tokens;
            var tokenCount = tokens.length;
            var lineHeight = line.lineHeight;
            var remainedWidth = line.width;
            var leftIndex = 0;
            var lineXLeft = xLeft;
            var lineXRight = xRight;
            var rightIndex = tokenCount - 1;
            var token = void 0;
            while(leftIndex < tokenCount && (token = tokens[leftIndex], !token.align || token.align === 'left')){
                this._placeToken(token, style, lineHeight, lineTop, lineXLeft, 'left', bgColorDrawn);
                remainedWidth -= token.width;
                lineXLeft += token.width;
                leftIndex++;
            }
            while(rightIndex >= 0 && (token = tokens[rightIndex], token.align === 'right')){
                this._placeToken(token, style, lineHeight, lineTop, lineXRight, 'right', bgColorDrawn);
                remainedWidth -= token.width;
                lineXRight -= token.width;
                rightIndex--;
            }
            lineXLeft += (contentWidth - (lineXLeft - xLeft) - (xRight - lineXRight) - remainedWidth) / 2;
            while(leftIndex <= rightIndex){
                token = tokens[leftIndex];
                this._placeToken(token, style, lineHeight, lineTop, lineXLeft + token.width / 2, 'center', bgColorDrawn);
                lineXLeft += token.width;
                leftIndex++;
            }
            lineTop += lineHeight;
        }
    };
    ZRText.prototype._placeToken = function(token, style, lineHeight, lineTop, x, textAlign, parentBgColorDrawn) {
        var tokenStyle = style.rich[token.styleName] || {};
        tokenStyle.text = token.text;
        var verticalAlign = token.verticalAlign;
        var y = lineTop + lineHeight / 2;
        if (verticalAlign === 'top') y = lineTop + token.height / 2;
        else if (verticalAlign === 'bottom') y = lineTop + lineHeight - token.height / 2;
        var needDrawBg = !token.isLineHolder && $fe885cc21795562b$var$needDrawBackground(tokenStyle);
        needDrawBg && this._renderBackground(tokenStyle, style, textAlign === 'right' ? x - token.width : textAlign === 'center' ? x - token.width / 2 : x, y - token.height / 2, token.width, token.height);
        var bgColorDrawn = !!tokenStyle.backgroundColor;
        var textPadding = token.textPadding;
        if (textPadding) {
            x = $fe885cc21795562b$var$getTextXForPadding(x, textAlign, textPadding);
            y -= token.height / 2 - textPadding[0] - token.innerHeight / 2;
        }
        var el = this._getOrCreateChild((0, $c9d5c769fe2f591f$export$2e2bcd8739ae039));
        var subElStyle = el.createStyle();
        el.useStyle(subElStyle);
        var defaultStyle = this._defaultStyle;
        var useDefaultFill = false;
        var defaultLineWidth = 0;
        var textFill = $fe885cc21795562b$var$getFill('fill' in tokenStyle ? tokenStyle.fill : 'fill' in style ? style.fill : (useDefaultFill = true, defaultStyle.fill));
        var textStroke = $fe885cc21795562b$var$getStroke('stroke' in tokenStyle ? tokenStyle.stroke : 'stroke' in style ? style.stroke : !bgColorDrawn && !parentBgColorDrawn && (!defaultStyle.autoStroke || useDefaultFill) ? (defaultLineWidth = $fe885cc21795562b$var$DEFAULT_STROKE_LINE_WIDTH, defaultStyle.stroke) : null);
        var hasShadow = tokenStyle.textShadowBlur > 0 || style.textShadowBlur > 0;
        subElStyle.text = token.text;
        subElStyle.x = x;
        subElStyle.y = y;
        if (hasShadow) {
            subElStyle.shadowBlur = tokenStyle.textShadowBlur || style.textShadowBlur || 0;
            subElStyle.shadowColor = tokenStyle.textShadowColor || style.textShadowColor || 'transparent';
            subElStyle.shadowOffsetX = tokenStyle.textShadowOffsetX || style.textShadowOffsetX || 0;
            subElStyle.shadowOffsetY = tokenStyle.textShadowOffsetY || style.textShadowOffsetY || 0;
        }
        subElStyle.textAlign = textAlign;
        subElStyle.textBaseline = 'middle';
        subElStyle.font = token.font || (0, $c6341dcc9d86826e$export$7d7a232b6d2cc80c);
        subElStyle.opacity = (0, $7a1bd9c2710fea0d$export$2e94551289abb95b)(tokenStyle.opacity, style.opacity, 1);
        $fe885cc21795562b$var$setSeparateFont(subElStyle, tokenStyle);
        if (textStroke) {
            subElStyle.lineWidth = (0, $7a1bd9c2710fea0d$export$2e94551289abb95b)(tokenStyle.lineWidth, style.lineWidth, defaultLineWidth);
            subElStyle.lineDash = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(tokenStyle.lineDash, style.lineDash);
            subElStyle.lineDashOffset = style.lineDashOffset || 0;
            subElStyle.stroke = textStroke;
        }
        if (textFill) subElStyle.fill = textFill;
        var textWidth = token.contentWidth;
        var textHeight = token.contentHeight;
        el.setBoundingRect(new (0, $1bebe7106c895823$export$2e2bcd8739ae039)((0, $6c308355c7107803$export$eb5a525ef00ef9a4)(subElStyle.x, textWidth, subElStyle.textAlign), (0, $6c308355c7107803$export$bf7d6802d2badd9)(subElStyle.y, textHeight, subElStyle.textBaseline), textWidth, textHeight));
    };
    ZRText.prototype._renderBackground = function(style, topStyle, x, y, width, height) {
        var textBackgroundColor = style.backgroundColor;
        var textBorderWidth = style.borderWidth;
        var textBorderColor = style.borderColor;
        var isImageBg = textBackgroundColor && textBackgroundColor.image;
        var isPlainOrGradientBg = textBackgroundColor && !isImageBg;
        var textBorderRadius = style.borderRadius;
        var self = this;
        var rectEl;
        var imgEl;
        if (isPlainOrGradientBg || style.lineHeight || textBorderWidth && textBorderColor) {
            rectEl = this._getOrCreateChild((0, $419e5ff2f303755e$export$2e2bcd8739ae039));
            rectEl.useStyle(rectEl.createStyle());
            rectEl.style.fill = null;
            var rectShape = rectEl.shape;
            rectShape.x = x;
            rectShape.y = y;
            rectShape.width = width;
            rectShape.height = height;
            rectShape.r = textBorderRadius;
            rectEl.dirtyShape();
        }
        if (isPlainOrGradientBg) {
            var rectStyle = rectEl.style;
            rectStyle.fill = textBackgroundColor || null;
            rectStyle.fillOpacity = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(style.fillOpacity, 1);
        } else if (isImageBg) {
            imgEl = this._getOrCreateChild((0, $86adec94217b86c6$export$2e2bcd8739ae039));
            imgEl.onload = function() {
                self.dirtyStyle();
            };
            var imgStyle = imgEl.style;
            imgStyle.image = textBackgroundColor.image;
            imgStyle.x = x;
            imgStyle.y = y;
            imgStyle.width = width;
            imgStyle.height = height;
        }
        if (textBorderWidth && textBorderColor) {
            var rectStyle = rectEl.style;
            rectStyle.lineWidth = textBorderWidth;
            rectStyle.stroke = textBorderColor;
            rectStyle.strokeOpacity = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(style.strokeOpacity, 1);
            rectStyle.lineDash = style.borderDash;
            rectStyle.lineDashOffset = style.borderDashOffset || 0;
            rectEl.strokeContainThreshold = 0;
            if (rectEl.hasFill() && rectEl.hasStroke()) {
                rectStyle.strokeFirst = true;
                rectStyle.lineWidth *= 2;
            }
        }
        var commonStyle = (rectEl || imgEl).style;
        commonStyle.shadowBlur = style.shadowBlur || 0;
        commonStyle.shadowColor = style.shadowColor || 'transparent';
        commonStyle.shadowOffsetX = style.shadowOffsetX || 0;
        commonStyle.shadowOffsetY = style.shadowOffsetY || 0;
        commonStyle.opacity = (0, $7a1bd9c2710fea0d$export$2e94551289abb95b)(style.opacity, topStyle.opacity, 1);
    };
    ZRText.makeFont = function(style) {
        var font = '';
        if ($fe885cc21795562b$export$4685c95d5118e76a(style)) font = [
            style.fontStyle,
            style.fontWeight,
            $fe885cc21795562b$export$51b066d9cfc2578e(style.fontSize),
            style.fontFamily || 'sans-serif'
        ].join(' ');
        return font && (0, $7a1bd9c2710fea0d$export$87c2784dc9fc4ab)(font) || style.textFont || style.font;
    };
    return ZRText;
}((0, $56206a6cb4666931$export$2e2bcd8739ae039));
var $fe885cc21795562b$var$VALID_TEXT_ALIGN = {
    left: true,
    right: 1,
    center: 1
};
var $fe885cc21795562b$var$VALID_TEXT_VERTICAL_ALIGN = {
    top: 1,
    bottom: 1,
    middle: 1
};
var $fe885cc21795562b$var$FONT_PARTS = [
    'fontStyle',
    'fontWeight',
    'fontSize',
    'fontFamily'
];
function $fe885cc21795562b$export$51b066d9cfc2578e(fontSize) {
    if (typeof fontSize === 'string' && (fontSize.indexOf('px') !== -1 || fontSize.indexOf('rem') !== -1 || fontSize.indexOf('em') !== -1)) return fontSize;
    else if (!isNaN(+fontSize)) return fontSize + 'px';
    else return (0, $c6341dcc9d86826e$export$b1461457ea2c1179) + 'px';
}
function $fe885cc21795562b$var$setSeparateFont(targetStyle, sourceStyle) {
    for(var i = 0; i < $fe885cc21795562b$var$FONT_PARTS.length; i++){
        var fontProp = $fe885cc21795562b$var$FONT_PARTS[i];
        var val = sourceStyle[fontProp];
        if (val != null) targetStyle[fontProp] = val;
    }
}
function $fe885cc21795562b$export$4685c95d5118e76a(style) {
    return style.fontSize != null || style.fontFamily || style.fontWeight;
}
function $fe885cc21795562b$export$176336068cc5371f(style) {
    $fe885cc21795562b$var$normalizeStyle(style);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(style.rich, $fe885cc21795562b$var$normalizeStyle);
    return style;
}
function $fe885cc21795562b$var$normalizeStyle(style) {
    if (style) {
        style.font = $fe885cc21795562b$var$ZRText.makeFont(style);
        var textAlign = style.align;
        textAlign === 'middle' && (textAlign = 'center');
        style.align = textAlign == null || $fe885cc21795562b$var$VALID_TEXT_ALIGN[textAlign] ? textAlign : 'left';
        var verticalAlign = style.verticalAlign;
        verticalAlign === 'center' && (verticalAlign = 'middle');
        style.verticalAlign = verticalAlign == null || $fe885cc21795562b$var$VALID_TEXT_VERTICAL_ALIGN[verticalAlign] ? verticalAlign : 'top';
        var textPadding = style.padding;
        if (textPadding) style.padding = (0, $7a1bd9c2710fea0d$export$f3a38102c49f4268)(style.padding);
    }
}
function $fe885cc21795562b$var$getStroke(stroke, lineWidth) {
    return stroke == null || lineWidth <= 0 || stroke === 'transparent' || stroke === 'none' ? null : stroke.image || stroke.colorStops ? '#000' : stroke;
}
function $fe885cc21795562b$var$getFill(fill) {
    return fill == null || fill === 'none' ? null : fill.image || fill.colorStops ? '#000' : fill;
}
function $fe885cc21795562b$var$getTextXForPadding(x, textAlign, textPadding) {
    return textAlign === 'right' ? x - textPadding[1] : textAlign === 'center' ? x + textPadding[3] / 2 - textPadding[1] / 2 : x + textPadding[3];
}
function $fe885cc21795562b$var$getStyleText(style) {
    var text = style.text;
    text != null && (text += '');
    return text;
}
function $fe885cc21795562b$var$needDrawBackground(style) {
    return !!(style.backgroundColor || style.lineHeight || style.borderWidth && style.borderColor);
}
var $fe885cc21795562b$export$2e2bcd8739ae039 = $fe885cc21795562b$var$ZRText;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $b1983a2fffd47d56$export$b1c39b2bacd1ddc2 = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $b1983a2fffd47d56$export$30d6736ebb8e18d5 = function(seriesIndex, dataType, dataIdx, el) {
    if (el) {
        var ecData = $b1983a2fffd47d56$export$b1c39b2bacd1ddc2(el);
        // Add data index and series index for indexing the data by element
        // Useful in tooltip
        ecData.dataIndex = dataIdx;
        ecData.dataType = dataType;
        ecData.seriesIndex = seriesIndex;
        ecData.ssrType = 'chart';
        // TODO: not store dataIndex on children.
        if (el.type === 'group') el.traverse(function(child) {
            var childECData = $b1983a2fffd47d56$export$b1c39b2bacd1ddc2(child);
            childECData.seriesIndex = seriesIndex;
            childECData.dataIndex = dataIdx;
            childECData.dataType = dataType;
            childECData.ssrType = 'chart';
        });
    }
};






// Reserve 0 as default.
var $2bf82c0980125b62$var$_highlightNextDigit = 1;
var $2bf82c0980125b62$var$_highlightKeyMap = {};
var $2bf82c0980125b62$var$getSavedStates = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $2bf82c0980125b62$var$getComponentStates = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $2bf82c0980125b62$export$5542daa30722333e = 0;
var $2bf82c0980125b62$export$1307d6a87d56baa = 1;
var $2bf82c0980125b62$export$f0f2bee145debb31 = 2;
var $2bf82c0980125b62$export$151308dceb52d5b = [
    'emphasis',
    'blur',
    'select'
];
var $2bf82c0980125b62$export$57ee5306b85ad7d5 = [
    'normal',
    'emphasis',
    'blur',
    'select'
];
var $2bf82c0980125b62$export$1cb9fc6ed5b9836c = 10;
var $2bf82c0980125b62$export$3a2f97d39514bbc = 9;
var $2bf82c0980125b62$export$df035d873a9de64f = 'highlight';
var $2bf82c0980125b62$export$f8a2f7807cc185ea = 'downplay';
var $2bf82c0980125b62$export$89616263e7d38fe9 = 'select';
var $2bf82c0980125b62$export$7636ad95c0f68a79 = 'unselect';
var $2bf82c0980125b62$export$1e90ed8a25542516 = 'toggleSelect';
function $2bf82c0980125b62$var$hasFillOrStroke(fillOrStroke) {
    return fillOrStroke != null && fillOrStroke !== 'none';
}
function $2bf82c0980125b62$var$doChangeHoverState(el, stateName, hoverStateEnum) {
    if (el.onHoverStateChange && (el.hoverState || 0) !== hoverStateEnum) el.onHoverStateChange(stateName);
    el.hoverState = hoverStateEnum;
}
function $2bf82c0980125b62$var$singleEnterEmphasis(el) {
    // Only mark the flag.
    // States will be applied in the echarts.ts in next frame.
    $2bf82c0980125b62$var$doChangeHoverState(el, 'emphasis', $2bf82c0980125b62$export$f0f2bee145debb31);
}
function $2bf82c0980125b62$var$singleLeaveEmphasis(el) {
    // Only mark the flag.
    // States will be applied in the echarts.ts in next frame.
    if (el.hoverState === $2bf82c0980125b62$export$f0f2bee145debb31) $2bf82c0980125b62$var$doChangeHoverState(el, 'normal', $2bf82c0980125b62$export$5542daa30722333e);
}
function $2bf82c0980125b62$var$singleEnterBlur(el) {
    $2bf82c0980125b62$var$doChangeHoverState(el, 'blur', $2bf82c0980125b62$export$1307d6a87d56baa);
}
function $2bf82c0980125b62$var$singleLeaveBlur(el) {
    if (el.hoverState === $2bf82c0980125b62$export$1307d6a87d56baa) $2bf82c0980125b62$var$doChangeHoverState(el, 'normal', $2bf82c0980125b62$export$5542daa30722333e);
}
function $2bf82c0980125b62$var$singleEnterSelect(el) {
    el.selected = true;
}
function $2bf82c0980125b62$var$singleLeaveSelect(el) {
    el.selected = false;
}
function $2bf82c0980125b62$var$updateElementState(el, updater, commonParam) {
    updater(el, commonParam);
}
function $2bf82c0980125b62$var$traverseUpdateState(el, updater, commonParam) {
    $2bf82c0980125b62$var$updateElementState(el, updater, commonParam);
    el.isGroup && el.traverse(function(child) {
        $2bf82c0980125b62$var$updateElementState(child, updater, commonParam);
    });
}
function $2bf82c0980125b62$export$868ba38adffa9e39(el, stateName) {
    switch(stateName){
        case 'emphasis':
            el.hoverState = $2bf82c0980125b62$export$f0f2bee145debb31;
            break;
        case 'normal':
            el.hoverState = $2bf82c0980125b62$export$5542daa30722333e;
            break;
        case 'blur':
            el.hoverState = $2bf82c0980125b62$export$1307d6a87d56baa;
            break;
        case 'select':
            el.selected = true;
    }
}
function $2bf82c0980125b62$export$35330f949342a669(el) {
    if (el.isGroup) el.traverse(function(child) {
        child.clearStates();
    });
    else el.clearStates();
}
function $2bf82c0980125b62$var$getFromStateStyle(el, props, toStateName, defaultValue) {
    var style = el.style;
    var fromState = {};
    for(var i = 0; i < props.length; i++){
        var propName = props[i];
        var val = style[propName];
        fromState[propName] = val == null ? defaultValue && defaultValue[propName] : val;
    }
    for(var i = 0; i < el.animators.length; i++){
        var animator = el.animators[i];
        if (animator.__fromStateTransition && animator.__fromStateTransition.indexOf(toStateName) < 0 && animator.targetName === 'style') animator.saveTo(fromState, props);
    }
    return fromState;
}
function $2bf82c0980125b62$var$createEmphasisDefaultState(el, stateName, targetStates, state) {
    var hasSelect = targetStates && (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(targetStates, 'select') >= 0;
    var cloned = false;
    if (el instanceof (0, $b02ffe7acd508c08$export$2e2bcd8739ae039)) {
        var store = $2bf82c0980125b62$var$getSavedStates(el);
        var fromFill = hasSelect ? store.selectFill || store.normalFill : store.normalFill;
        var fromStroke = hasSelect ? store.selectStroke || store.normalStroke : store.normalStroke;
        if ($2bf82c0980125b62$var$hasFillOrStroke(fromFill) || $2bf82c0980125b62$var$hasFillOrStroke(fromStroke)) {
            state = state || {};
            var emphasisStyle = state.style || {};
            // inherit case
            if (emphasisStyle.fill === 'inherit') {
                cloned = true;
                state = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, state);
                emphasisStyle = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, emphasisStyle);
                emphasisStyle.fill = fromFill;
            } else if (!$2bf82c0980125b62$var$hasFillOrStroke(emphasisStyle.fill) && $2bf82c0980125b62$var$hasFillOrStroke(fromFill)) {
                cloned = true;
                // Not modify the original value.
                state = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, state);
                emphasisStyle = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, emphasisStyle);
                // Already being applied 'emphasis'. DON'T lift color multiple times.
                emphasisStyle.fill = (0, $2c037f5bda6341ca$export$2b47e247dfb87a73)(fromFill);
            } else if (!$2bf82c0980125b62$var$hasFillOrStroke(emphasisStyle.stroke) && $2bf82c0980125b62$var$hasFillOrStroke(fromStroke)) {
                if (!cloned) {
                    state = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, state);
                    emphasisStyle = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, emphasisStyle);
                }
                emphasisStyle.stroke = (0, $2c037f5bda6341ca$export$2b47e247dfb87a73)(fromStroke);
            }
            state.style = emphasisStyle;
        }
    }
    if (state) // TODO Share with textContent?
    {
        if (state.z2 == null) {
            if (!cloned) state = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, state);
            var z2EmphasisLift = el.z2EmphasisLift;
            state.z2 = el.z2 + (z2EmphasisLift != null ? z2EmphasisLift : $2bf82c0980125b62$export$1cb9fc6ed5b9836c);
        }
    }
    return state;
}
function $2bf82c0980125b62$var$createSelectDefaultState(el, stateName, state) {
    // const hasSelect = indexOf(el.currentStates, stateName) >= 0;
    if (state) // TODO Share with textContent?
    {
        if (state.z2 == null) {
            state = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, state);
            var z2SelectLift = el.z2SelectLift;
            state.z2 = el.z2 + (z2SelectLift != null ? z2SelectLift : $2bf82c0980125b62$export$3a2f97d39514bbc);
        }
    }
    return state;
}
function $2bf82c0980125b62$var$createBlurDefaultState(el, stateName, state) {
    var hasBlur = (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(el.currentStates, stateName) >= 0;
    var currentOpacity = el.style.opacity;
    var fromState = !hasBlur ? $2bf82c0980125b62$var$getFromStateStyle(el, [
        'opacity'
    ], stateName, {
        opacity: 1
    }) : null;
    state = state || {};
    var blurStyle = state.style || {};
    if (blurStyle.opacity == null) {
        // clone state
        state = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, state);
        blurStyle = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
            // Already being applied 'emphasis'. DON'T mul opacity multiple times.
            opacity: hasBlur ? currentOpacity : fromState.opacity * 0.1
        }, blurStyle);
        state.style = blurStyle;
    }
    return state;
}
function $2bf82c0980125b62$var$elementStateProxy(stateName, targetStates) {
    var state = this.states[stateName];
    if (this.style) {
        if (stateName === 'emphasis') return $2bf82c0980125b62$var$createEmphasisDefaultState(this, stateName, targetStates, state);
        else if (stateName === 'blur') return $2bf82c0980125b62$var$createBlurDefaultState(this, stateName, state);
        else if (stateName === 'select') return $2bf82c0980125b62$var$createSelectDefaultState(this, stateName, state);
    }
    return state;
}
function $2bf82c0980125b62$export$20f39bbe322fb9ab(el) {
    el.stateProxy = $2bf82c0980125b62$var$elementStateProxy;
    var textContent = el.getTextContent();
    var textGuide = el.getTextGuideLine();
    if (textContent) textContent.stateProxy = $2bf82c0980125b62$var$elementStateProxy;
    if (textGuide) textGuide.stateProxy = $2bf82c0980125b62$var$elementStateProxy;
}
function $2bf82c0980125b62$export$d899507e2598e4ae(el, e) {
    !$2bf82c0980125b62$var$shouldSilent(el, e) && !el.__highByOuter && $2bf82c0980125b62$var$traverseUpdateState(el, $2bf82c0980125b62$var$singleEnterEmphasis);
}
function $2bf82c0980125b62$export$784cba1f7fe58cca(el, e) {
    !$2bf82c0980125b62$var$shouldSilent(el, e) && !el.__highByOuter && $2bf82c0980125b62$var$traverseUpdateState(el, $2bf82c0980125b62$var$singleLeaveEmphasis);
}
function $2bf82c0980125b62$export$b2d02638cc34c042(el, highlightDigit) {
    el.__highByOuter |= 1 << (highlightDigit || 0);
    $2bf82c0980125b62$var$traverseUpdateState(el, $2bf82c0980125b62$var$singleEnterEmphasis);
}
function $2bf82c0980125b62$export$11be6f716239ac55(el, highlightDigit) {
    !(el.__highByOuter &= ~(1 << (highlightDigit || 0))) && $2bf82c0980125b62$var$traverseUpdateState(el, $2bf82c0980125b62$var$singleLeaveEmphasis);
}
function $2bf82c0980125b62$export$207f9cb3e1099375(el) {
    $2bf82c0980125b62$var$traverseUpdateState(el, $2bf82c0980125b62$var$singleEnterBlur);
}
function $2bf82c0980125b62$export$fd4a9ec75456d3c1(el) {
    $2bf82c0980125b62$var$traverseUpdateState(el, $2bf82c0980125b62$var$singleLeaveBlur);
}
function $2bf82c0980125b62$export$252d028dda8ef765(el) {
    $2bf82c0980125b62$var$traverseUpdateState(el, $2bf82c0980125b62$var$singleEnterSelect);
}
function $2bf82c0980125b62$export$ea9a904bd6e32bd3(el) {
    $2bf82c0980125b62$var$traverseUpdateState(el, $2bf82c0980125b62$var$singleLeaveSelect);
}
function $2bf82c0980125b62$var$shouldSilent(el, e) {
    return el.__highDownSilentOnTouch && e.zrByTouch;
}
function $2bf82c0980125b62$export$b2a593c7b5243584(api) {
    var model = api.getModel();
    var leaveBlurredSeries = [];
    var allComponentViews = [];
    model.eachComponent(function(componentType, componentModel) {
        var componentStates = $2bf82c0980125b62$var$getComponentStates(componentModel);
        var isSeries = componentType === 'series';
        var view = isSeries ? api.getViewOfSeriesModel(componentModel) : api.getViewOfComponentModel(componentModel);
        !isSeries && allComponentViews.push(view);
        if (componentStates.isBlured) {
            // Leave blur anyway
            view.group.traverse(function(child) {
                $2bf82c0980125b62$var$singleLeaveBlur(child);
            });
            isSeries && leaveBlurredSeries.push(componentModel);
        }
        componentStates.isBlured = false;
    });
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(allComponentViews, function(view) {
        if (view && view.toggleBlurSeries) view.toggleBlurSeries(leaveBlurredSeries, false, model);
    });
}
function $2bf82c0980125b62$export$7d399e067d6552e3(targetSeriesIndex, focus, blurScope, api) {
    var ecModel = api.getModel();
    blurScope = blurScope || 'coordinateSystem';
    function leaveBlurOfIndices(data, dataIndices) {
        for(var i = 0; i < dataIndices.length; i++){
            var itemEl = data.getItemGraphicEl(dataIndices[i]);
            itemEl && $2bf82c0980125b62$export$fd4a9ec75456d3c1(itemEl);
        }
    }
    if (targetSeriesIndex == null) return;
    if (!focus || focus === 'none') return;
    var targetSeriesModel = ecModel.getSeriesByIndex(targetSeriesIndex);
    var targetCoordSys = targetSeriesModel.coordinateSystem;
    if (targetCoordSys && targetCoordSys.master) targetCoordSys = targetCoordSys.master;
    var blurredSeries = [];
    ecModel.eachSeries(function(seriesModel) {
        var sameSeries = targetSeriesModel === seriesModel;
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys && coordSys.master) coordSys = coordSys.master;
        var sameCoordSys = coordSys && targetCoordSys ? coordSys === targetCoordSys : sameSeries; // If there is no coordinate system. use sameSeries instead.
        if (!// Not blur other series if blurScope series
        (blurScope === 'series' && !sameSeries || blurScope === 'coordinateSystem' && !sameCoordSys || focus === 'series' && sameSeries)) {
            var view = api.getViewOfSeriesModel(seriesModel);
            view.group.traverse(function(child) {
                // For the elements that have been triggered by other components,
                // and are still required to be highlighted,
                // because the current is directly forced to blur the element,
                // it will cause the focus self to be unable to highlight, so skip the blur of this element.
                if (child.__highByOuter && sameSeries && focus === 'self') return;
                $2bf82c0980125b62$var$singleEnterBlur(child);
            });
            if ((0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(focus)) leaveBlurOfIndices(seriesModel.getData(), focus);
            else if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(focus)) {
                var dataTypes = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(focus);
                for(var d = 0; d < dataTypes.length; d++)leaveBlurOfIndices(seriesModel.getData(dataTypes[d]), focus[dataTypes[d]]);
            }
            blurredSeries.push(seriesModel);
            $2bf82c0980125b62$var$getComponentStates(seriesModel).isBlured = true;
        }
    });
    ecModel.eachComponent(function(componentType, componentModel) {
        if (componentType === 'series') return;
        var view = api.getViewOfComponentModel(componentModel);
        if (view && view.toggleBlurSeries) view.toggleBlurSeries(blurredSeries, true, ecModel);
    });
}
function $2bf82c0980125b62$export$569da03256c8a55f(componentMainType, componentIndex, api) {
    if (componentMainType == null || componentIndex == null) return;
    var componentModel = api.getModel().getComponent(componentMainType, componentIndex);
    if (!componentModel) return;
    $2bf82c0980125b62$var$getComponentStates(componentModel).isBlured = true;
    var view = api.getViewOfComponentModel(componentModel);
    if (!view || !view.focusBlurEnabled) return;
    view.group.traverse(function(child) {
        $2bf82c0980125b62$var$singleEnterBlur(child);
    });
}
function $2bf82c0980125b62$export$64f1fd4daefef21b(seriesModel, payload, api) {
    var seriesIndex = seriesModel.seriesIndex;
    var data = seriesModel.getData(payload.dataType);
    if (!data) return;
    var dataIndex = (0, $76d619f648247e6d$export$42b26cae8b8d10)(data, payload);
    // Pick the first one if there is multiple/none exists.
    dataIndex = ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(dataIndex) ? dataIndex[0] : dataIndex) || 0;
    var el = data.getItemGraphicEl(dataIndex);
    if (!el) {
        var count = data.count();
        var current = 0;
        // If data on dataIndex is NaN.
        while(!el && current < count)el = data.getItemGraphicEl(current++);
    }
    if (el) {
        var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el);
        $2bf82c0980125b62$export$7d399e067d6552e3(seriesIndex, ecData.focus, ecData.blurScope, api);
    } else {
        // If there is no element put on the data. Try getting it from raw option
        // TODO Should put it on seriesModel?
        var focus_1 = seriesModel.get([
            'emphasis',
            'focus'
        ]);
        var blurScope = seriesModel.get([
            'emphasis',
            'blurScope'
        ]);
        if (focus_1 != null) $2bf82c0980125b62$export$7d399e067d6552e3(seriesIndex, focus_1, blurScope, api);
    }
}
function $2bf82c0980125b62$export$f31a644ccca0ef23(componentMainType, componentIndex, name, api) {
    var ret = {
        focusSelf: false,
        dispatchers: null
    };
    if (componentMainType == null || componentMainType === 'series' || componentIndex == null || name == null) return ret;
    var componentModel = api.getModel().getComponent(componentMainType, componentIndex);
    if (!componentModel) return ret;
    var view = api.getViewOfComponentModel(componentModel);
    if (!view || !view.findHighDownDispatchers) return ret;
    var dispatchers = view.findHighDownDispatchers(name);
    // At presnet, the component (like Geo) only blur inside itself.
    // So we do not use `blurScope` in component.
    var focusSelf;
    for(var i = 0; i < dispatchers.length; i++)if ((0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(dispatchers[i]).focus === 'self') {
        focusSelf = true;
        break;
    }
    return {
        focusSelf: focusSelf,
        dispatchers: dispatchers
    };
}
function $2bf82c0980125b62$export$416765b6198234ff(dispatcher, e, api) {
    var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(dispatcher);
    var _a = $2bf82c0980125b62$export$f31a644ccca0ef23(ecData.componentMainType, ecData.componentIndex, ecData.componentHighDownName, api), dispatchers = _a.dispatchers, focusSelf = _a.focusSelf;
    // If `findHighDownDispatchers` is supported on the component,
    // highlight/downplay elements with the same name.
    if (dispatchers) {
        if (focusSelf) $2bf82c0980125b62$export$569da03256c8a55f(ecData.componentMainType, ecData.componentIndex, api);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dispatchers, function(dispatcher) {
            return $2bf82c0980125b62$export$d899507e2598e4ae(dispatcher, e);
        });
    } else {
        // Try blur all in the related series. Then emphasis the hoverred.
        // TODO. progressive mode.
        $2bf82c0980125b62$export$7d399e067d6552e3(ecData.seriesIndex, ecData.focus, ecData.blurScope, api);
        if (ecData.focus === 'self') $2bf82c0980125b62$export$569da03256c8a55f(ecData.componentMainType, ecData.componentIndex, api);
        // Other than series, component that not support `findHighDownDispatcher` will
        // also use it. But in this case, highlight/downplay are only supported in
        // mouse hover but not in dispatchAction.
        $2bf82c0980125b62$export$d899507e2598e4ae(dispatcher, e);
    }
}
function $2bf82c0980125b62$export$bb1c7b62436282a(dispatcher, e, api) {
    $2bf82c0980125b62$export$b2a593c7b5243584(api);
    var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(dispatcher);
    var dispatchers = $2bf82c0980125b62$export$f31a644ccca0ef23(ecData.componentMainType, ecData.componentIndex, ecData.componentHighDownName, api).dispatchers;
    if (dispatchers) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dispatchers, function(dispatcher) {
        return $2bf82c0980125b62$export$784cba1f7fe58cca(dispatcher, e);
    });
    else $2bf82c0980125b62$export$784cba1f7fe58cca(dispatcher, e);
}
function $2bf82c0980125b62$export$1c7d489f62372d73(seriesModel, payload, api) {
    if (!$2bf82c0980125b62$export$72aea10e60e45351(payload)) return;
    var dataType = payload.dataType;
    var data = seriesModel.getData(dataType);
    var dataIndex = (0, $76d619f648247e6d$export$42b26cae8b8d10)(data, payload);
    if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(dataIndex)) dataIndex = [
        dataIndex
    ];
    seriesModel[payload.type === $2bf82c0980125b62$export$1e90ed8a25542516 ? 'toggleSelect' : payload.type === $2bf82c0980125b62$export$89616263e7d38fe9 ? 'select' : 'unselect'](dataIndex, dataType);
}
function $2bf82c0980125b62$export$e4ea08ef52e0a73(seriesModel) {
    var allData = seriesModel.getAllData();
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(allData, function(_a) {
        var data = _a.data, type = _a.type;
        data.eachItemGraphicEl(function(el, idx) {
            seriesModel.isSelected(idx, type) ? $2bf82c0980125b62$export$252d028dda8ef765(el) : $2bf82c0980125b62$export$ea9a904bd6e32bd3(el);
        });
    });
}
function $2bf82c0980125b62$export$c529643b619af6b3(ecModel) {
    var ret = [];
    ecModel.eachSeries(function(seriesModel) {
        var allData = seriesModel.getAllData();
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(allData, function(_a) {
            var data = _a.data, type = _a.type;
            var dataIndices = seriesModel.getSelectedDataIndices();
            if (dataIndices.length > 0) {
                var item = {
                    dataIndex: dataIndices,
                    seriesIndex: seriesModel.seriesIndex
                };
                if (type != null) item.dataType = type;
                ret.push(item);
            }
        });
    });
    return ret;
}
function $2bf82c0980125b62$export$5f393df0b5aee2e7(el, focus, blurScope) {
    $2bf82c0980125b62$export$9ba15aea1e048d48(el, true);
    $2bf82c0980125b62$var$traverseUpdateState(el, $2bf82c0980125b62$export$20f39bbe322fb9ab);
    $2bf82c0980125b62$export$24972466b2b62ac2(el, focus, blurScope);
}
function $2bf82c0980125b62$export$912cae7b47c8e437(el) {
    $2bf82c0980125b62$export$9ba15aea1e048d48(el, false);
}
function $2bf82c0980125b62$export$e51187539ff11209(el, focus, blurScope, isDisabled) {
    isDisabled ? $2bf82c0980125b62$export$912cae7b47c8e437(el) : $2bf82c0980125b62$export$5f393df0b5aee2e7(el, focus, blurScope);
}
function $2bf82c0980125b62$export$24972466b2b62ac2(el, focus, blurScope) {
    var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el);
    if (focus != null) {
        // TODO dataIndex may be set after this function. This check is not useful.
        // if (ecData.dataIndex == null) {
        //     if (__DEV__) {
        //         console.warn('focus can only been set on element with dataIndex');
        //     }
        // }
        // else {
        ecData.focus = focus;
        ecData.blurScope = blurScope;
    // }
    } else if (ecData.focus) ecData.focus = null;
}
var $2bf82c0980125b62$var$OTHER_STATES = [
    'emphasis',
    'blur',
    'select'
];
var $2bf82c0980125b62$var$defaultStyleGetterMap = {
    itemStyle: 'getItemStyle',
    lineStyle: 'getLineStyle',
    areaStyle: 'getAreaStyle'
};
function $2bf82c0980125b62$export$48b68047d330bbc9(el, itemModel, styleType, // default itemStyle
getter) {
    styleType = styleType || 'itemStyle';
    for(var i = 0; i < $2bf82c0980125b62$var$OTHER_STATES.length; i++){
        var stateName = $2bf82c0980125b62$var$OTHER_STATES[i];
        var model = itemModel.getModel([
            stateName,
            styleType
        ]);
        var state = el.ensureState(stateName);
        // Let it throw error if getterType is not found.
        state.style = getter ? getter(model) : model[$2bf82c0980125b62$var$defaultStyleGetterMap[styleType]]();
    }
}
function $2bf82c0980125b62$export$9ba15aea1e048d48(el, asDispatcher) {
    var disable = asDispatcher === false;
    var extendedEl = el;
    // Make `highDownSilentOnTouch` and `onStateChange` only work after
    // `setAsHighDownDispatcher` called. Avoid it is modified by user unexpectedly.
    if (el.highDownSilentOnTouch) extendedEl.__highDownSilentOnTouch = el.highDownSilentOnTouch;
    // Simple optimize, since this method might be
    // called for each elements of a group in some cases.
    if (!disable || extendedEl.__highDownDispatcher) {
        // Emphasis, normal can be triggered manually by API or other components like hover link.
        // el[method]('emphasis', onElementEmphasisEvent)[method]('normal', onElementNormalEvent);
        // Also keep previous record.
        extendedEl.__highByOuter = extendedEl.__highByOuter || 0;
        extendedEl.__highDownDispatcher = !disable;
    }
}
function $2bf82c0980125b62$export$77d1445f699c58b5(el) {
    return !!(el && el.__highDownDispatcher);
}
function $2bf82c0980125b62$export$4da05a9639f01954(el, componentModel, componentHighDownName) {
    var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el);
    ecData.componentMainType = componentModel.mainType;
    ecData.componentIndex = componentModel.componentIndex;
    ecData.componentHighDownName = componentHighDownName;
}
function $2bf82c0980125b62$export$824af40eb714530d(highlightKey) {
    var highlightDigit = $2bf82c0980125b62$var$_highlightKeyMap[highlightKey];
    if (highlightDigit == null && $2bf82c0980125b62$var$_highlightNextDigit <= 32) highlightDigit = $2bf82c0980125b62$var$_highlightKeyMap[highlightKey] = $2bf82c0980125b62$var$_highlightNextDigit++;
    return highlightDigit;
}
function $2bf82c0980125b62$export$72aea10e60e45351(payload) {
    var payloadType = payload.type;
    return payloadType === $2bf82c0980125b62$export$89616263e7d38fe9 || payloadType === $2bf82c0980125b62$export$7636ad95c0f68a79 || payloadType === $2bf82c0980125b62$export$1e90ed8a25542516;
}
function $2bf82c0980125b62$export$aebe71265c1b77bf(payload) {
    var payloadType = payload.type;
    return payloadType === $2bf82c0980125b62$export$df035d873a9de64f || payloadType === $2bf82c0980125b62$export$f8a2f7807cc185ea;
}
function $2bf82c0980125b62$export$9fe78019e6f395b6(el) {
    var store = $2bf82c0980125b62$var$getSavedStates(el);
    store.normalFill = el.style.fill;
    store.normalStroke = el.style.stroke;
    var selectState = el.states.select || {};
    store.selectFill = selectState.style && selectState.style.fill || null;
    store.selectStroke = selectState.style && selectState.style.stroke || null;
}




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $8b353638fbedfefa$export$ae7433df314f6ec3 = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $8b353638fbedfefa$export$5cc7add7ab591d0a(animationType, animatableModel, dataIndex, // Extra opts can override the option in animatable model.
extraOpts, // TODO It's only for pictorial bar now.
extraDelayParams) {
    var animationPayload;
    // Check if there is global animation configuration from dataZoom/resize can override the config in option.
    // If animation is enabled. Will use this animation config in payload.
    // If animation is disabled. Just ignore it.
    if (animatableModel && animatableModel.ecModel) {
        var updatePayload = animatableModel.ecModel.getUpdatePayload();
        animationPayload = updatePayload && updatePayload.animation;
    }
    var animationEnabled = animatableModel && animatableModel.isAnimationEnabled();
    var isUpdate = animationType === 'update';
    if (animationEnabled) {
        var duration = void 0;
        var easing = void 0;
        var delay = void 0;
        if (extraOpts) {
            duration = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(extraOpts.duration, 200);
            easing = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(extraOpts.easing, 'cubicOut');
            delay = 0;
        } else {
            duration = animatableModel.getShallow(isUpdate ? 'animationDurationUpdate' : 'animationDuration');
            easing = animatableModel.getShallow(isUpdate ? 'animationEasingUpdate' : 'animationEasing');
            delay = animatableModel.getShallow(isUpdate ? 'animationDelayUpdate' : 'animationDelay');
        }
        // animation from payload has highest priority.
        if (animationPayload) {
            animationPayload.duration != null && (duration = animationPayload.duration);
            animationPayload.easing != null && (easing = animationPayload.easing);
            animationPayload.delay != null && (delay = animationPayload.delay);
        }
        if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(delay)) delay = delay(dataIndex, extraDelayParams);
        if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(duration)) duration = duration(dataIndex);
        var config = {
            duration: duration || 0,
            delay: delay,
            easing: easing
        };
        return config;
    } else return null;
}
function $8b353638fbedfefa$var$animateOrSetProps(animationType, el, props, animatableModel, dataIndex, cb, during) {
    var isFrom = false;
    var removeOpt;
    if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(dataIndex)) {
        during = cb;
        cb = dataIndex;
        dataIndex = null;
    } else if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(dataIndex)) {
        cb = dataIndex.cb;
        during = dataIndex.during;
        isFrom = dataIndex.isFrom;
        removeOpt = dataIndex.removeOpt;
        dataIndex = dataIndex.dataIndex;
    }
    var isRemove = animationType === 'leave';
    if (!isRemove) // Must stop the remove animation.
    el.stopAnimation('leave');
    var animationConfig = $8b353638fbedfefa$export$5cc7add7ab591d0a(animationType, animatableModel, dataIndex, isRemove ? removeOpt || {} : null, animatableModel && animatableModel.getAnimationDelayParams ? animatableModel.getAnimationDelayParams(el, dataIndex) : null);
    if (animationConfig && animationConfig.duration > 0) {
        var duration = animationConfig.duration;
        var animationDelay = animationConfig.delay;
        var animationEasing = animationConfig.easing;
        var animateConfig = {
            duration: duration,
            delay: animationDelay || 0,
            easing: animationEasing,
            done: cb,
            force: !!cb || !!during,
            // Set to final state in update/init animation.
            // So the post processing based on the path shape can be done correctly.
            setToFinal: !isRemove,
            scope: animationType,
            during: during
        };
        isFrom ? el.animateFrom(props, animateConfig) : el.animateTo(props, animateConfig);
    } else {
        el.stopAnimation();
        // If `isFrom`, the props is the "from" props.
        !isFrom && el.attr(props);
        // Call during at least once.
        during && during(1);
        cb && cb();
    }
}
/**
 * Update graphic element properties with or without animation according to the
 * configuration in series.
 *
 * Caution: this method will stop previous animation.
 * So do not use this method to one element twice before
 * animation starts, unless you know what you are doing.
 * @example
 *     graphic.updateProps(el, {
 *         position: [100, 100]
 *     }, seriesModel, dataIndex, function () { console.log('Animation done!'); });
 *     // Or
 *     graphic.updateProps(el, {
 *         position: [100, 100]
 *     }, seriesModel, function () { console.log('Animation done!'); });
 */ function $8b353638fbedfefa$export$c8dce3c08436e91e(el, props, // TODO: TYPE AnimatableModel
animatableModel, dataIndex, cb, during) {
    $8b353638fbedfefa$var$animateOrSetProps('update', el, props, animatableModel, dataIndex, cb, during);
}
function $8b353638fbedfefa$export$a121566aadcfe021(el, props, animatableModel, dataIndex, cb, during) {
    $8b353638fbedfefa$var$animateOrSetProps('enter', el, props, animatableModel, dataIndex, cb, during);
}
function $8b353638fbedfefa$export$5b89d4b643713034(el) {
    if (!el.__zr) return true;
    for(var i = 0; i < el.animators.length; i++){
        var animator = el.animators[i];
        if (animator.scope === 'leave') return true;
    }
    return false;
}
function $8b353638fbedfefa$export$f883456a56996078(el, props, animatableModel, dataIndex, cb, during) {
    // Don't do remove animation twice.
    if ($8b353638fbedfefa$export$5b89d4b643713034(el)) return;
    $8b353638fbedfefa$var$animateOrSetProps('leave', el, props, animatableModel, dataIndex, cb, during);
}
function $8b353638fbedfefa$var$fadeOutDisplayable(el, animatableModel, dataIndex, done) {
    el.removeTextContent();
    el.removeTextGuideLine();
    $8b353638fbedfefa$export$f883456a56996078(el, {
        style: {
            opacity: 0
        }
    }, animatableModel, dataIndex, done);
}
function $8b353638fbedfefa$export$6d0fd725cb4aee8a(el, animatableModel, dataIndex) {
    function doRemove() {
        el.parent && el.parent.remove(el);
    }
    // Hide label and labelLine first
    // TODO Also use fade out animation?
    if (!el.isGroup) $8b353638fbedfefa$var$fadeOutDisplayable(el, animatableModel, dataIndex, doRemove);
    else el.traverse(function(disp) {
        if (!disp.isGroup) // Can invoke doRemove multiple times.
        $8b353638fbedfefa$var$fadeOutDisplayable(disp, animatableModel, dataIndex, doRemove);
    });
}
function $8b353638fbedfefa$export$bca7290a9faf0ec9(el) {
    $8b353638fbedfefa$export$ae7433df314f6ec3(el).oldStyle = el.style;
}
function $8b353638fbedfefa$export$ccb1f1e4d2fa86ac(el) {
    return $8b353638fbedfefa$export$ae7433df314f6ec3(el).oldStyle;
}

var $5b455ae6f843ac47$exports = {};

$parcel$export($5b455ae6f843ac47$exports, "extendShape", () => $5b455ae6f843ac47$export$d0d5398c9d612037);
$parcel$export($5b455ae6f843ac47$exports, "extendPath", () => $5b455ae6f843ac47$export$53b54a3137026af0);
$parcel$export($5b455ae6f843ac47$exports, "registerShape", () => $5b455ae6f843ac47$export$2b95b62e3aaf6fdd);
$parcel$export($5b455ae6f843ac47$exports, "getShapeClass", () => $5b455ae6f843ac47$export$51df4b5565a58189);
$parcel$export($5b455ae6f843ac47$exports, "makePath", () => $5b455ae6f843ac47$export$aa9bab72412f5613);
$parcel$export($5b455ae6f843ac47$exports, "resizePath", () => $5b455ae6f843ac47$export$566dbf1c62b04fc7);
$parcel$export($5b455ae6f843ac47$exports, "makeImage", () => $5b455ae6f843ac47$export$7a2bdede98851ac5);
$parcel$export($5b455ae6f843ac47$exports, "mergePath", () => $5b455ae6f843ac47$export$7b1dd269fbc4e903);
$parcel$export($5b455ae6f843ac47$exports, "subPixelOptimizeLine", () => $5b455ae6f843ac47$export$8b4b620d7f4aad1b);
$parcel$export($5b455ae6f843ac47$exports, "subPixelOptimizeRect", () => $5b455ae6f843ac47$export$60e2aa74957d0b9d);
$parcel$export($5b455ae6f843ac47$exports, "subPixelOptimize", () => $5b455ae6f843ac47$export$72c4fd4c1b8fcb10);
$parcel$export($5b455ae6f843ac47$exports, "getTransform", () => $5b455ae6f843ac47$export$fce0c6cfca85ed96);
$parcel$export($5b455ae6f843ac47$exports, "applyTransform", () => $5b455ae6f843ac47$export$9f9dcb98c894b623);
$parcel$export($5b455ae6f843ac47$exports, "transformDirection", () => $5b455ae6f843ac47$export$fff94e9792354cfa);
$parcel$export($5b455ae6f843ac47$exports, "groupTransition", () => $5b455ae6f843ac47$export$64fcab7860c216ae);
$parcel$export($5b455ae6f843ac47$exports, "clipPointsByRect", () => $5b455ae6f843ac47$export$e2f409471bbbc1dc);
$parcel$export($5b455ae6f843ac47$exports, "clipRectByRect", () => $5b455ae6f843ac47$export$d0d3709202b8b2a);
$parcel$export($5b455ae6f843ac47$exports, "createIcon", () => $5b455ae6f843ac47$export$274edc73af1ae9c8);
$parcel$export($5b455ae6f843ac47$exports, "linePolygonIntersect", () => $5b455ae6f843ac47$export$4f47c855a5e9ae9);
$parcel$export($5b455ae6f843ac47$exports, "lineLineIntersect", () => $5b455ae6f843ac47$export$6c0a70ea1d8d158b);
$parcel$export($5b455ae6f843ac47$exports, "setTooltipConfig", () => $5b455ae6f843ac47$export$fc6410d97fab306c);
$parcel$export($5b455ae6f843ac47$exports, "traverseElements", () => $5b455ae6f843ac47$export$3e564442729bf048);
$parcel$export($5b455ae6f843ac47$exports, "updateProps", () => $8b353638fbedfefa$export$c8dce3c08436e91e);
$parcel$export($5b455ae6f843ac47$exports, "initProps", () => $8b353638fbedfefa$export$a121566aadcfe021);
$parcel$export($5b455ae6f843ac47$exports, "removeElement", () => $8b353638fbedfefa$export$f883456a56996078);
$parcel$export($5b455ae6f843ac47$exports, "removeElementWithFadeOut", () => $8b353638fbedfefa$export$6d0fd725cb4aee8a);
$parcel$export($5b455ae6f843ac47$exports, "isElementRemoved", () => $8b353638fbedfefa$export$5b89d4b643713034);
$parcel$export($5b455ae6f843ac47$exports, "Group", () => $7ef7583d8302ffce$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Image", () => $86adec94217b86c6$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Text", () => $fe885cc21795562b$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Circle", () => $1e68d8727773abb7$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Ellipse", () => $4a809f055a7e524c$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Sector", () => $a3e1dec0a3875b49$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Ring", () => $9da0cbfd3f86fdc1$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Polygon", () => $51acf033123e1a30$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Polyline", () => $d28119f30e6bb670$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Rect", () => $419e5ff2f303755e$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Line", () => $7a316ae5ceff7b27$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "BezierCurve", () => $6c7800c49630e431$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Arc", () => $2b5c23eb3597b84a$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "IncrementalDisplayable", () => $ee829f116f003981$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "CompoundPath", () => $e152f3dbf8fba6e2$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "LinearGradient", () => $cf44c01491b58e53$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "RadialGradient", () => $cd2ee2ba32bb26c3$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "BoundingRect", () => $1bebe7106c895823$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "OrientedBoundingRect", () => $f9793b4d8aade116$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Point", () => $b887f038f104fe7e$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Path", () => $b02ffe7acd508c08$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $07911aacc70e67cc$var$CMD = (0, $20ebe2448f123f2e$export$2e2bcd8739ae039).CMD;
var $07911aacc70e67cc$var$points = [
    [],
    [],
    []
];
var $07911aacc70e67cc$var$mathSqrt = Math.sqrt;
var $07911aacc70e67cc$var$mathAtan2 = Math.atan2;
function $07911aacc70e67cc$export$2e2bcd8739ae039(path, m) {
    if (!m) return;
    var data = path.data;
    var len = path.len();
    var cmd;
    var nPoint;
    var i;
    var j;
    var k;
    var p;
    var M = $07911aacc70e67cc$var$CMD.M;
    var C = $07911aacc70e67cc$var$CMD.C;
    var L = $07911aacc70e67cc$var$CMD.L;
    var R = $07911aacc70e67cc$var$CMD.R;
    var A = $07911aacc70e67cc$var$CMD.A;
    var Q = $07911aacc70e67cc$var$CMD.Q;
    for(i = 0, j = 0; i < len;){
        cmd = data[i++];
        j = i;
        nPoint = 0;
        switch(cmd){
            case M:
                nPoint = 1;
                break;
            case L:
                nPoint = 1;
                break;
            case C:
                nPoint = 3;
                break;
            case Q:
                nPoint = 2;
                break;
            case A:
                var x = m[4];
                var y = m[5];
                var sx = $07911aacc70e67cc$var$mathSqrt(m[0] * m[0] + m[1] * m[1]);
                var sy = $07911aacc70e67cc$var$mathSqrt(m[2] * m[2] + m[3] * m[3]);
                var angle = $07911aacc70e67cc$var$mathAtan2(-m[1] / sy, m[0] / sx);
                data[i] *= sx;
                data[i++] += x;
                data[i] *= sy;
                data[i++] += y;
                data[i++] *= sx;
                data[i++] *= sy;
                data[i++] += angle;
                data[i++] += angle;
                i += 2;
                j = i;
                break;
            case R:
                p[0] = data[i++];
                p[1] = data[i++];
                (0, $6de594cf8ac295ff$export$9f9dcb98c894b623)(p, p, m);
                data[j++] = p[0];
                data[j++] = p[1];
                p[0] += data[i++];
                p[1] += data[i++];
                (0, $6de594cf8ac295ff$export$9f9dcb98c894b623)(p, p, m);
                data[j++] = p[0];
                data[j++] = p[1];
        }
        for(k = 0; k < nPoint; k++){
            var p_1 = $07911aacc70e67cc$var$points[k];
            p_1[0] = data[i++];
            p_1[1] = data[i++];
            (0, $6de594cf8ac295ff$export$9f9dcb98c894b623)(p_1, p_1, m);
            data[j++] = p_1[0];
            data[j++] = p_1[1];
        }
    }
    path.increaseVersion();
}



var $15b38920672b9006$var$mathSqrt = Math.sqrt;
var $15b38920672b9006$var$mathSin = Math.sin;
var $15b38920672b9006$var$mathCos = Math.cos;
var $15b38920672b9006$var$PI = Math.PI;
function $15b38920672b9006$var$vMag(v) {
    return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
}
function $15b38920672b9006$var$vRatio(u, v) {
    return (u[0] * v[0] + u[1] * v[1]) / ($15b38920672b9006$var$vMag(u) * $15b38920672b9006$var$vMag(v));
}
function $15b38920672b9006$var$vAngle(u, v) {
    return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos($15b38920672b9006$var$vRatio(u, v));
}
function $15b38920672b9006$var$processArc(x1, y1, x2, y2, fa, fs, rx, ry, psiDeg, cmd, path) {
    var psi = psiDeg * ($15b38920672b9006$var$PI / 180.0);
    var xp = $15b38920672b9006$var$mathCos(psi) * (x1 - x2) / 2.0 + $15b38920672b9006$var$mathSin(psi) * (y1 - y2) / 2.0;
    var yp = -1 * $15b38920672b9006$var$mathSin(psi) * (x1 - x2) / 2.0 + $15b38920672b9006$var$mathCos(psi) * (y1 - y2) / 2.0;
    var lambda = xp * xp / (rx * rx) + yp * yp / (ry * ry);
    if (lambda > 1) {
        rx *= $15b38920672b9006$var$mathSqrt(lambda);
        ry *= $15b38920672b9006$var$mathSqrt(lambda);
    }
    var f = (fa === fs ? -1 : 1) * $15b38920672b9006$var$mathSqrt((rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) / (rx * rx * (yp * yp) + ry * ry * (xp * xp))) || 0;
    var cxp = f * rx * yp / ry;
    var cyp = f * -ry * xp / rx;
    var cx = (x1 + x2) / 2.0 + $15b38920672b9006$var$mathCos(psi) * cxp - $15b38920672b9006$var$mathSin(psi) * cyp;
    var cy = (y1 + y2) / 2.0 + $15b38920672b9006$var$mathSin(psi) * cxp + $15b38920672b9006$var$mathCos(psi) * cyp;
    var theta = $15b38920672b9006$var$vAngle([
        1,
        0
    ], [
        (xp - cxp) / rx,
        (yp - cyp) / ry
    ]);
    var u = [
        (xp - cxp) / rx,
        (yp - cyp) / ry
    ];
    var v = [
        (-1 * xp - cxp) / rx,
        (-1 * yp - cyp) / ry
    ];
    var dTheta = $15b38920672b9006$var$vAngle(u, v);
    if ($15b38920672b9006$var$vRatio(u, v) <= -1) dTheta = $15b38920672b9006$var$PI;
    if ($15b38920672b9006$var$vRatio(u, v) >= 1) dTheta = 0;
    if (dTheta < 0) {
        var n = Math.round(dTheta / $15b38920672b9006$var$PI * 1e6) / 1e6;
        dTheta = $15b38920672b9006$var$PI * 2 + n % 2 * $15b38920672b9006$var$PI;
    }
    path.addData(cmd, cx, cy, rx, ry, theta, dTheta, psi, fs);
}
var $15b38920672b9006$var$commandReg = /([mlvhzcqtsa])([^mlvhzcqtsa]*)/ig;
var $15b38920672b9006$var$numberReg = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g;
function $15b38920672b9006$var$createPathProxyFromString(data) {
    var path = new (0, $20ebe2448f123f2e$export$2e2bcd8739ae039)();
    if (!data) return path;
    var cpx = 0;
    var cpy = 0;
    var subpathX = cpx;
    var subpathY = cpy;
    var prevCmd;
    var CMD = (0, $20ebe2448f123f2e$export$2e2bcd8739ae039).CMD;
    var cmdList = data.match($15b38920672b9006$var$commandReg);
    if (!cmdList) return path;
    for(var l = 0; l < cmdList.length; l++){
        var cmdText = cmdList[l];
        var cmdStr = cmdText.charAt(0);
        var cmd = void 0;
        var p = cmdText.match($15b38920672b9006$var$numberReg) || [];
        var pLen = p.length;
        for(var i = 0; i < pLen; i++)p[i] = parseFloat(p[i]);
        var off = 0;
        while(off < pLen){
            var ctlPtx = void 0;
            var ctlPty = void 0;
            var rx = void 0;
            var ry = void 0;
            var psi = void 0;
            var fa = void 0;
            var fs = void 0;
            var x1 = cpx;
            var y1 = cpy;
            var len = void 0;
            var pathData = void 0;
            switch(cmdStr){
                case 'l':
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'L':
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'm':
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.M;
                    path.addData(cmd, cpx, cpy);
                    subpathX = cpx;
                    subpathY = cpy;
                    cmdStr = 'l';
                    break;
                case 'M':
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.M;
                    path.addData(cmd, cpx, cpy);
                    subpathX = cpx;
                    subpathY = cpy;
                    cmdStr = 'L';
                    break;
                case 'h':
                    cpx += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'H':
                    cpx = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'v':
                    cpy += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'V':
                    cpy = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'C':
                    cmd = CMD.C;
                    path.addData(cmd, p[off++], p[off++], p[off++], p[off++], p[off++], p[off++]);
                    cpx = p[off - 2];
                    cpy = p[off - 1];
                    break;
                case 'c':
                    cmd = CMD.C;
                    path.addData(cmd, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy);
                    cpx += p[off - 2];
                    cpy += p[off - 1];
                    break;
                case 'S':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.C) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cmd = CMD.C;
                    x1 = p[off++];
                    y1 = p[off++];
                    cpx = p[off++];
                    cpy = p[off++];
                    path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
                    break;
                case 's':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.C) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cmd = CMD.C;
                    x1 = cpx + p[off++];
                    y1 = cpy + p[off++];
                    cpx += p[off++];
                    cpy += p[off++];
                    path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
                    break;
                case 'Q':
                    x1 = p[off++];
                    y1 = p[off++];
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, x1, y1, cpx, cpy);
                    break;
                case 'q':
                    x1 = p[off++] + cpx;
                    y1 = p[off++] + cpy;
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, x1, y1, cpx, cpy);
                    break;
                case 'T':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.Q) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
                    break;
                case 't':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.Q) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
                    break;
                case 'A':
                    rx = p[off++];
                    ry = p[off++];
                    psi = p[off++];
                    fa = p[off++];
                    fs = p[off++];
                    x1 = cpx, y1 = cpy;
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.A;
                    $15b38920672b9006$var$processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
                    break;
                case 'a':
                    rx = p[off++];
                    ry = p[off++];
                    psi = p[off++];
                    fa = p[off++];
                    fs = p[off++];
                    x1 = cpx, y1 = cpy;
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.A;
                    $15b38920672b9006$var$processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
                    break;
            }
        }
        if (cmdStr === 'z' || cmdStr === 'Z') {
            cmd = CMD.Z;
            path.addData(cmd);
            cpx = subpathX;
            cpy = subpathY;
        }
        prevCmd = cmd;
    }
    path.toStatic();
    return path;
}
var $15b38920672b9006$var$SVGPath = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(SVGPath, _super);
    function SVGPath() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SVGPath.prototype.applyTransform = function(m) {};
    return SVGPath;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
function $15b38920672b9006$var$isPathProxy(path) {
    return path.setData != null;
}
function $15b38920672b9006$var$createPathOptions(str, opts) {
    var pathProxy = $15b38920672b9006$var$createPathProxyFromString(str);
    var innerOpts = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, opts);
    innerOpts.buildPath = function(path) {
        if ($15b38920672b9006$var$isPathProxy(path)) {
            path.setData(pathProxy.data);
            var ctx = path.getContext();
            if (ctx) path.rebuildPath(ctx, 1);
        } else {
            var ctx = path;
            pathProxy.rebuildPath(ctx, 1);
        }
    };
    innerOpts.applyTransform = function(m) {
        (0, $07911aacc70e67cc$export$2e2bcd8739ae039)(pathProxy, m);
        this.dirtyShape();
    };
    return innerOpts;
}
function $15b38920672b9006$export$ae5b259626f00aeb(str, opts) {
    return new $15b38920672b9006$var$SVGPath($15b38920672b9006$var$createPathOptions(str, opts));
}
function $15b38920672b9006$export$68e3a51ba2ed417c(str, defaultOpts) {
    var innerOpts = $15b38920672b9006$var$createPathOptions(str, defaultOpts);
    var Sub = function(_super) {
        (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Sub, _super);
        function Sub(opts) {
            var _this = _super.call(this, opts) || this;
            _this.applyTransform = innerOpts.applyTransform;
            _this.buildPath = innerOpts.buildPath;
            return _this;
        }
        return Sub;
    }($15b38920672b9006$var$SVGPath);
    return Sub;
}
function $15b38920672b9006$export$7b1dd269fbc4e903(pathEls, opts) {
    var pathList = [];
    var len = pathEls.length;
    for(var i = 0; i < len; i++){
        var pathEl = pathEls[i];
        pathList.push(pathEl.getUpdatedPathProxy(true));
    }
    var pathBundle = new (0, $b02ffe7acd508c08$export$2e2bcd8739ae039)(opts);
    pathBundle.createPathProxy();
    pathBundle.buildPath = function(path) {
        if ($15b38920672b9006$var$isPathProxy(path)) {
            path.appendPath(pathList);
            var ctx = path.getContext();
            if (ctx) path.rebuildPath(ctx, 1);
        }
    };
    return pathBundle;
}
function $15b38920672b9006$export$18711d956bf1c3eb(sourcePath, opts) {
    opts = opts || {};
    var path = new (0, $b02ffe7acd508c08$export$2e2bcd8739ae039)();
    if (sourcePath.shape) path.setShape(sourcePath.shape);
    path.setStyle(sourcePath.style);
    if (opts.bakeTransform) (0, $07911aacc70e67cc$export$2e2bcd8739ae039)(path.path, sourcePath.getComputedTransform());
    else if (opts.toLocal) path.setLocalTransform(sourcePath.getComputedTransform());
    else path.copyTransform(sourcePath);
    path.buildPath = sourcePath.buildPath;
    path.applyTransform = path.applyTransform;
    path.z = sourcePath.z;
    path.z2 = sourcePath.z2;
    path.zlevel = sourcePath.zlevel;
    return path;
}











var $1e68d8727773abb7$export$2c0b65c9c7b57845 = function() {
    function CircleShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
    }
    return CircleShape;
}();
var $1e68d8727773abb7$var$Circle = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Circle, _super);
    function Circle(opts) {
        return _super.call(this, opts) || this;
    }
    Circle.prototype.getDefaultShape = function() {
        return new $1e68d8727773abb7$export$2c0b65c9c7b57845();
    };
    Circle.prototype.buildPath = function(ctx, shape) {
        ctx.moveTo(shape.cx + shape.r, shape.cy);
        ctx.arc(shape.cx, shape.cy, shape.r, 0, Math.PI * 2);
    };
    return Circle;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
$1e68d8727773abb7$var$Circle.prototype.type = 'circle';
var $1e68d8727773abb7$export$2e2bcd8739ae039 = $1e68d8727773abb7$var$Circle;




var $4a809f055a7e524c$export$817919dfe2806d31 = function() {
    function EllipseShape() {
        this.cx = 0;
        this.cy = 0;
        this.rx = 0;
        this.ry = 0;
    }
    return EllipseShape;
}();
var $4a809f055a7e524c$var$Ellipse = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Ellipse, _super);
    function Ellipse(opts) {
        return _super.call(this, opts) || this;
    }
    Ellipse.prototype.getDefaultShape = function() {
        return new $4a809f055a7e524c$export$817919dfe2806d31();
    };
    Ellipse.prototype.buildPath = function(ctx, shape) {
        var k = 0.5522848;
        var x = shape.cx;
        var y = shape.cy;
        var a = shape.rx;
        var b = shape.ry;
        var ox = a * k;
        var oy = b * k;
        ctx.moveTo(x - a, y);
        ctx.bezierCurveTo(x - a, y - oy, x - ox, y - b, x, y - b);
        ctx.bezierCurveTo(x + ox, y - b, x + a, y - oy, x + a, y);
        ctx.bezierCurveTo(x + a, y + oy, x + ox, y + b, x, y + b);
        ctx.bezierCurveTo(x - ox, y + b, x - a, y + oy, x - a, y);
        ctx.closePath();
    };
    return Ellipse;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
$4a809f055a7e524c$var$Ellipse.prototype.type = 'ellipse';
var $4a809f055a7e524c$export$2e2bcd8739ae039 = $4a809f055a7e524c$var$Ellipse;





var $a2aa1e91473aa9ab$var$PI = Math.PI;
var $a2aa1e91473aa9ab$var$PI2 = $a2aa1e91473aa9ab$var$PI * 2;
var $a2aa1e91473aa9ab$var$mathSin = Math.sin;
var $a2aa1e91473aa9ab$var$mathCos = Math.cos;
var $a2aa1e91473aa9ab$var$mathACos = Math.acos;
var $a2aa1e91473aa9ab$var$mathATan2 = Math.atan2;
var $a2aa1e91473aa9ab$var$mathAbs = Math.abs;
var $a2aa1e91473aa9ab$var$mathSqrt = Math.sqrt;
var $a2aa1e91473aa9ab$var$mathMax = Math.max;
var $a2aa1e91473aa9ab$var$mathMin = Math.min;
var $a2aa1e91473aa9ab$var$e = 1e-4;
function $a2aa1e91473aa9ab$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var dx10 = x1 - x0;
    var dy10 = y1 - y0;
    var dx32 = x3 - x2;
    var dy32 = y3 - y2;
    var t = dy32 * dx10 - dx32 * dy10;
    if (t * t < $a2aa1e91473aa9ab$var$e) return;
    t = (dx32 * (y0 - y2) - dy32 * (x0 - x2)) / t;
    return [
        x0 + t * dx10,
        y0 + t * dy10
    ];
}
function $a2aa1e91473aa9ab$var$computeCornerTangents(x0, y0, x1, y1, radius, cr, clockwise) {
    var x01 = x0 - x1;
    var y01 = y0 - y1;
    var lo = (clockwise ? cr : -cr) / $a2aa1e91473aa9ab$var$mathSqrt(x01 * x01 + y01 * y01);
    var ox = lo * y01;
    var oy = -lo * x01;
    var x11 = x0 + ox;
    var y11 = y0 + oy;
    var x10 = x1 + ox;
    var y10 = y1 + oy;
    var x00 = (x11 + x10) / 2;
    var y00 = (y11 + y10) / 2;
    var dx = x10 - x11;
    var dy = y10 - y11;
    var d2 = dx * dx + dy * dy;
    var r = radius - cr;
    var s = x11 * y10 - x10 * y11;
    var d = (dy < 0 ? -1 : 1) * $a2aa1e91473aa9ab$var$mathSqrt($a2aa1e91473aa9ab$var$mathMax(0, r * r * d2 - s * s));
    var cx0 = (s * dy - dx * d) / d2;
    var cy0 = (-s * dx - dy * d) / d2;
    var cx1 = (s * dy + dx * d) / d2;
    var cy1 = (-s * dx + dy * d) / d2;
    var dx0 = cx0 - x00;
    var dy0 = cy0 - y00;
    var dx1 = cx1 - x00;
    var dy1 = cy1 - y00;
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) {
        cx0 = cx1;
        cy0 = cy1;
    }
    return {
        cx: cx0,
        cy: cy0,
        x0: -ox,
        y0: -oy,
        x1: cx0 * (radius / r - 1),
        y1: cy0 * (radius / r - 1)
    };
}
function $a2aa1e91473aa9ab$var$normalizeCornerRadius(cr) {
    var arr;
    if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(cr)) {
        var len = cr.length;
        if (!len) return cr;
        if (len === 1) arr = [
            cr[0],
            cr[0],
            0,
            0
        ];
        else if (len === 2) arr = [
            cr[0],
            cr[0],
            cr[1],
            cr[1]
        ];
        else if (len === 3) arr = cr.concat(cr[2]);
        else arr = cr;
    } else arr = [
        cr,
        cr,
        cr,
        cr
    ];
    return arr;
}
function $a2aa1e91473aa9ab$export$5cc7f731b5937e99(ctx, shape) {
    var _a;
    var radius = $a2aa1e91473aa9ab$var$mathMax(shape.r, 0);
    var innerRadius = $a2aa1e91473aa9ab$var$mathMax(shape.r0 || 0, 0);
    var hasRadius = radius > 0;
    var hasInnerRadius = innerRadius > 0;
    if (!hasRadius && !hasInnerRadius) return;
    if (!hasRadius) {
        radius = innerRadius;
        innerRadius = 0;
    }
    if (innerRadius > radius) {
        var tmp = radius;
        radius = innerRadius;
        innerRadius = tmp;
    }
    var startAngle = shape.startAngle, endAngle = shape.endAngle;
    if (isNaN(startAngle) || isNaN(endAngle)) return;
    var cx = shape.cx, cy = shape.cy;
    var clockwise = !!shape.clockwise;
    var arc = $a2aa1e91473aa9ab$var$mathAbs(endAngle - startAngle);
    var mod = arc > $a2aa1e91473aa9ab$var$PI2 && arc % $a2aa1e91473aa9ab$var$PI2;
    mod > $a2aa1e91473aa9ab$var$e && (arc = mod);
    if (!(radius > $a2aa1e91473aa9ab$var$e)) ctx.moveTo(cx, cy);
    else if (arc > $a2aa1e91473aa9ab$var$PI2 - $a2aa1e91473aa9ab$var$e) {
        ctx.moveTo(cx + radius * $a2aa1e91473aa9ab$var$mathCos(startAngle), cy + radius * $a2aa1e91473aa9ab$var$mathSin(startAngle));
        ctx.arc(cx, cy, radius, startAngle, endAngle, !clockwise);
        if (innerRadius > $a2aa1e91473aa9ab$var$e) {
            ctx.moveTo(cx + innerRadius * $a2aa1e91473aa9ab$var$mathCos(endAngle), cy + innerRadius * $a2aa1e91473aa9ab$var$mathSin(endAngle));
            ctx.arc(cx, cy, innerRadius, endAngle, startAngle, clockwise);
        }
    } else {
        var icrStart = void 0;
        var icrEnd = void 0;
        var ocrStart = void 0;
        var ocrEnd = void 0;
        var ocrs = void 0;
        var ocre = void 0;
        var icrs = void 0;
        var icre = void 0;
        var ocrMax = void 0;
        var icrMax = void 0;
        var limitedOcrMax = void 0;
        var limitedIcrMax = void 0;
        var xre = void 0;
        var yre = void 0;
        var xirs = void 0;
        var yirs = void 0;
        var xrs = radius * $a2aa1e91473aa9ab$var$mathCos(startAngle);
        var yrs = radius * $a2aa1e91473aa9ab$var$mathSin(startAngle);
        var xire = innerRadius * $a2aa1e91473aa9ab$var$mathCos(endAngle);
        var yire = innerRadius * $a2aa1e91473aa9ab$var$mathSin(endAngle);
        var hasArc = arc > $a2aa1e91473aa9ab$var$e;
        if (hasArc) {
            var cornerRadius = shape.cornerRadius;
            if (cornerRadius) _a = $a2aa1e91473aa9ab$var$normalizeCornerRadius(cornerRadius), icrStart = _a[0], icrEnd = _a[1], ocrStart = _a[2], ocrEnd = _a[3];
            var halfRd = $a2aa1e91473aa9ab$var$mathAbs(radius - innerRadius) / 2;
            ocrs = $a2aa1e91473aa9ab$var$mathMin(halfRd, ocrStart);
            ocre = $a2aa1e91473aa9ab$var$mathMin(halfRd, ocrEnd);
            icrs = $a2aa1e91473aa9ab$var$mathMin(halfRd, icrStart);
            icre = $a2aa1e91473aa9ab$var$mathMin(halfRd, icrEnd);
            limitedOcrMax = ocrMax = $a2aa1e91473aa9ab$var$mathMax(ocrs, ocre);
            limitedIcrMax = icrMax = $a2aa1e91473aa9ab$var$mathMax(icrs, icre);
            if (ocrMax > $a2aa1e91473aa9ab$var$e || icrMax > $a2aa1e91473aa9ab$var$e) {
                xre = radius * $a2aa1e91473aa9ab$var$mathCos(endAngle);
                yre = radius * $a2aa1e91473aa9ab$var$mathSin(endAngle);
                xirs = innerRadius * $a2aa1e91473aa9ab$var$mathCos(startAngle);
                yirs = innerRadius * $a2aa1e91473aa9ab$var$mathSin(startAngle);
                if (arc < $a2aa1e91473aa9ab$var$PI) {
                    var it_1 = $a2aa1e91473aa9ab$var$intersect(xrs, yrs, xirs, yirs, xre, yre, xire, yire);
                    if (it_1) {
                        var x0 = xrs - it_1[0];
                        var y0 = yrs - it_1[1];
                        var x1 = xre - it_1[0];
                        var y1 = yre - it_1[1];
                        var a = 1 / $a2aa1e91473aa9ab$var$mathSin($a2aa1e91473aa9ab$var$mathACos((x0 * x1 + y0 * y1) / ($a2aa1e91473aa9ab$var$mathSqrt(x0 * x0 + y0 * y0) * $a2aa1e91473aa9ab$var$mathSqrt(x1 * x1 + y1 * y1))) / 2);
                        var b = $a2aa1e91473aa9ab$var$mathSqrt(it_1[0] * it_1[0] + it_1[1] * it_1[1]);
                        limitedOcrMax = $a2aa1e91473aa9ab$var$mathMin(ocrMax, (radius - b) / (a + 1));
                        limitedIcrMax = $a2aa1e91473aa9ab$var$mathMin(icrMax, (innerRadius - b) / (a - 1));
                    }
                }
            }
        }
        if (!hasArc) ctx.moveTo(cx + xrs, cy + yrs);
        else if (limitedOcrMax > $a2aa1e91473aa9ab$var$e) {
            var crStart = $a2aa1e91473aa9ab$var$mathMin(ocrStart, limitedOcrMax);
            var crEnd = $a2aa1e91473aa9ab$var$mathMin(ocrEnd, limitedOcrMax);
            var ct0 = $a2aa1e91473aa9ab$var$computeCornerTangents(xirs, yirs, xrs, yrs, radius, crStart, clockwise);
            var ct1 = $a2aa1e91473aa9ab$var$computeCornerTangents(xre, yre, xire, yire, radius, crEnd, clockwise);
            ctx.moveTo(cx + ct0.cx + ct0.x0, cy + ct0.cy + ct0.y0);
            if (limitedOcrMax < ocrMax && crStart === crEnd) ctx.arc(cx + ct0.cx, cy + ct0.cy, limitedOcrMax, $a2aa1e91473aa9ab$var$mathATan2(ct0.y0, ct0.x0), $a2aa1e91473aa9ab$var$mathATan2(ct1.y0, ct1.x0), !clockwise);
            else {
                crStart > 0 && ctx.arc(cx + ct0.cx, cy + ct0.cy, crStart, $a2aa1e91473aa9ab$var$mathATan2(ct0.y0, ct0.x0), $a2aa1e91473aa9ab$var$mathATan2(ct0.y1, ct0.x1), !clockwise);
                ctx.arc(cx, cy, radius, $a2aa1e91473aa9ab$var$mathATan2(ct0.cy + ct0.y1, ct0.cx + ct0.x1), $a2aa1e91473aa9ab$var$mathATan2(ct1.cy + ct1.y1, ct1.cx + ct1.x1), !clockwise);
                crEnd > 0 && ctx.arc(cx + ct1.cx, cy + ct1.cy, crEnd, $a2aa1e91473aa9ab$var$mathATan2(ct1.y1, ct1.x1), $a2aa1e91473aa9ab$var$mathATan2(ct1.y0, ct1.x0), !clockwise);
            }
        } else {
            ctx.moveTo(cx + xrs, cy + yrs);
            ctx.arc(cx, cy, radius, startAngle, endAngle, !clockwise);
        }
        if (!(innerRadius > $a2aa1e91473aa9ab$var$e) || !hasArc) ctx.lineTo(cx + xire, cy + yire);
        else if (limitedIcrMax > $a2aa1e91473aa9ab$var$e) {
            var crStart = $a2aa1e91473aa9ab$var$mathMin(icrStart, limitedIcrMax);
            var crEnd = $a2aa1e91473aa9ab$var$mathMin(icrEnd, limitedIcrMax);
            var ct0 = $a2aa1e91473aa9ab$var$computeCornerTangents(xire, yire, xre, yre, innerRadius, -crEnd, clockwise);
            var ct1 = $a2aa1e91473aa9ab$var$computeCornerTangents(xrs, yrs, xirs, yirs, innerRadius, -crStart, clockwise);
            ctx.lineTo(cx + ct0.cx + ct0.x0, cy + ct0.cy + ct0.y0);
            if (limitedIcrMax < icrMax && crStart === crEnd) ctx.arc(cx + ct0.cx, cy + ct0.cy, limitedIcrMax, $a2aa1e91473aa9ab$var$mathATan2(ct0.y0, ct0.x0), $a2aa1e91473aa9ab$var$mathATan2(ct1.y0, ct1.x0), !clockwise);
            else {
                crEnd > 0 && ctx.arc(cx + ct0.cx, cy + ct0.cy, crEnd, $a2aa1e91473aa9ab$var$mathATan2(ct0.y0, ct0.x0), $a2aa1e91473aa9ab$var$mathATan2(ct0.y1, ct0.x1), !clockwise);
                ctx.arc(cx, cy, innerRadius, $a2aa1e91473aa9ab$var$mathATan2(ct0.cy + ct0.y1, ct0.cx + ct0.x1), $a2aa1e91473aa9ab$var$mathATan2(ct1.cy + ct1.y1, ct1.cx + ct1.x1), clockwise);
                crStart > 0 && ctx.arc(cx + ct1.cx, cy + ct1.cy, crStart, $a2aa1e91473aa9ab$var$mathATan2(ct1.y1, ct1.x1), $a2aa1e91473aa9ab$var$mathATan2(ct1.y0, ct1.x0), !clockwise);
            }
        } else {
            ctx.lineTo(cx + xire, cy + yire);
            ctx.arc(cx, cy, innerRadius, endAngle, startAngle, clockwise);
        }
    }
    ctx.closePath();
}


var $a3e1dec0a3875b49$export$98af62de8a972c99 = function() {
    function SectorShape() {
        this.cx = 0;
        this.cy = 0;
        this.r0 = 0;
        this.r = 0;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.clockwise = true;
        this.cornerRadius = 0;
    }
    return SectorShape;
}();
var $a3e1dec0a3875b49$var$Sector = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Sector, _super);
    function Sector(opts) {
        return _super.call(this, opts) || this;
    }
    Sector.prototype.getDefaultShape = function() {
        return new $a3e1dec0a3875b49$export$98af62de8a972c99();
    };
    Sector.prototype.buildPath = function(ctx, shape) {
        $a2aa1e91473aa9ab$export$5cc7f731b5937e99(ctx, shape);
    };
    Sector.prototype.isZeroArea = function() {
        return this.shape.startAngle === this.shape.endAngle || this.shape.r === this.shape.r0;
    };
    return Sector;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
$a3e1dec0a3875b49$var$Sector.prototype.type = 'sector';
var $a3e1dec0a3875b49$export$2e2bcd8739ae039 = $a3e1dec0a3875b49$var$Sector;




var $9da0cbfd3f86fdc1$export$4a506b3cd4ea73db = function() {
    function RingShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
        this.r0 = 0;
    }
    return RingShape;
}();
var $9da0cbfd3f86fdc1$var$Ring = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Ring, _super);
    function Ring(opts) {
        return _super.call(this, opts) || this;
    }
    Ring.prototype.getDefaultShape = function() {
        return new $9da0cbfd3f86fdc1$export$4a506b3cd4ea73db();
    };
    Ring.prototype.buildPath = function(ctx, shape) {
        var x = shape.cx;
        var y = shape.cy;
        var PI2 = Math.PI * 2;
        ctx.moveTo(x + shape.r, y);
        ctx.arc(x, y, shape.r, 0, PI2, false);
        ctx.moveTo(x + shape.r0, y);
        ctx.arc(x, y, shape.r0, 0, PI2, true);
    };
    return Ring;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
$9da0cbfd3f86fdc1$var$Ring.prototype.type = 'ring';
var $9da0cbfd3f86fdc1$export$2e2bcd8739ae039 = $9da0cbfd3f86fdc1$var$Ring;





function $de6f6db626660fc1$export$2e2bcd8739ae039(points, smooth, isLoop, constraint) {
    var cps = [];
    var v = [];
    var v1 = [];
    var v2 = [];
    var prevPoint;
    var nextPoint;
    var min;
    var max;
    if (constraint) {
        min = [
            Infinity,
            Infinity
        ];
        max = [
            -Infinity,
            -Infinity
        ];
        for(var i = 0, len = points.length; i < len; i++){
            (0, $6de594cf8ac295ff$export$96ec731ed4dcb222)(min, min, points[i]);
            (0, $6de594cf8ac295ff$export$8960430cfd85939f)(max, max, points[i]);
        }
        (0, $6de594cf8ac295ff$export$96ec731ed4dcb222)(min, min, constraint[0]);
        (0, $6de594cf8ac295ff$export$8960430cfd85939f)(max, max, constraint[1]);
    }
    for(var i = 0, len = points.length; i < len; i++){
        var point = points[i];
        if (isLoop) {
            prevPoint = points[i ? i - 1 : len - 1];
            nextPoint = points[(i + 1) % len];
        } else if (i === 0 || i === len - 1) {
            cps.push((0, $6de594cf8ac295ff$export$9cd59f9826255e47)(points[i]));
            continue;
        } else {
            prevPoint = points[i - 1];
            nextPoint = points[i + 1];
        }
        (0, $6de594cf8ac295ff$export$f93b5905241a7cca)(v, nextPoint, prevPoint);
        (0, $6de594cf8ac295ff$export$dcdf75081b88279d)(v, v, smooth);
        var d0 = (0, $6de594cf8ac295ff$export$9f17032d917177de)(point, prevPoint);
        var d1 = (0, $6de594cf8ac295ff$export$9f17032d917177de)(point, nextPoint);
        var sum = d0 + d1;
        if (sum !== 0) {
            d0 /= sum;
            d1 /= sum;
        }
        (0, $6de594cf8ac295ff$export$dcdf75081b88279d)(v1, v, -d0);
        (0, $6de594cf8ac295ff$export$dcdf75081b88279d)(v2, v, d1);
        var cp0 = (0, $6de594cf8ac295ff$export$e16d8520af44a096)([], point, v1);
        var cp1 = (0, $6de594cf8ac295ff$export$e16d8520af44a096)([], point, v2);
        if (constraint) {
            (0, $6de594cf8ac295ff$export$8960430cfd85939f)(cp0, cp0, min);
            (0, $6de594cf8ac295ff$export$96ec731ed4dcb222)(cp0, cp0, max);
            (0, $6de594cf8ac295ff$export$8960430cfd85939f)(cp1, cp1, min);
            (0, $6de594cf8ac295ff$export$96ec731ed4dcb222)(cp1, cp1, max);
        }
        cps.push(cp0);
        cps.push(cp1);
    }
    if (isLoop) cps.push(cps.shift());
    return cps;
}


function $68ae9e1c9ba70ac1$export$5cc7f731b5937e99(ctx, shape, closePath) {
    var smooth = shape.smooth;
    var points = shape.points;
    if (points && points.length >= 2) {
        if (smooth) {
            var controlPoints = (0, $de6f6db626660fc1$export$2e2bcd8739ae039)(points, smooth, closePath, shape.smoothConstraint);
            ctx.moveTo(points[0][0], points[0][1]);
            var len = points.length;
            for(var i = 0; i < (closePath ? len : len - 1); i++){
                var cp1 = controlPoints[i * 2];
                var cp2 = controlPoints[i * 2 + 1];
                var p = points[(i + 1) % len];
                ctx.bezierCurveTo(cp1[0], cp1[1], cp2[0], cp2[1], p[0], p[1]);
            }
        } else {
            ctx.moveTo(points[0][0], points[0][1]);
            for(var i = 1, l = points.length; i < l; i++)ctx.lineTo(points[i][0], points[i][1]);
        }
        closePath && ctx.closePath();
    }
}


var $51acf033123e1a30$export$a34d87b9aaeedd46 = function() {
    function PolygonShape() {
        this.points = null;
        this.smooth = 0;
        this.smoothConstraint = null;
    }
    return PolygonShape;
}();
var $51acf033123e1a30$var$Polygon = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Polygon, _super);
    function Polygon(opts) {
        return _super.call(this, opts) || this;
    }
    Polygon.prototype.getDefaultShape = function() {
        return new $51acf033123e1a30$export$a34d87b9aaeedd46();
    };
    Polygon.prototype.buildPath = function(ctx, shape) {
        $68ae9e1c9ba70ac1$export$5cc7f731b5937e99(ctx, shape, true);
    };
    return Polygon;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
$51acf033123e1a30$var$Polygon.prototype.type = 'polygon';
var $51acf033123e1a30$export$2e2bcd8739ae039 = $51acf033123e1a30$var$Polygon;





var $d28119f30e6bb670$export$e9e5cc3985e19d11 = function() {
    function PolylineShape() {
        this.points = null;
        this.percent = 1;
        this.smooth = 0;
        this.smoothConstraint = null;
    }
    return PolylineShape;
}();
var $d28119f30e6bb670$var$Polyline = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Polyline, _super);
    function Polyline(opts) {
        return _super.call(this, opts) || this;
    }
    Polyline.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    Polyline.prototype.getDefaultShape = function() {
        return new $d28119f30e6bb670$export$e9e5cc3985e19d11();
    };
    Polyline.prototype.buildPath = function(ctx, shape) {
        $68ae9e1c9ba70ac1$export$5cc7f731b5937e99(ctx, shape, false);
    };
    return Polyline;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
$d28119f30e6bb670$var$Polyline.prototype.type = 'polyline';
var $d28119f30e6bb670$export$2e2bcd8739ae039 = $d28119f30e6bb670$var$Polyline;






var $7a316ae5ceff7b27$var$subPixelOptimizeOutputShape = {};
var $7a316ae5ceff7b27$export$64b674d0815308 = function() {
    function LineShape() {
        this.x1 = 0;
        this.y1 = 0;
        this.x2 = 0;
        this.y2 = 0;
        this.percent = 1;
    }
    return LineShape;
}();
var $7a316ae5ceff7b27$var$Line = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Line, _super);
    function Line(opts) {
        return _super.call(this, opts) || this;
    }
    Line.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    Line.prototype.getDefaultShape = function() {
        return new $7a316ae5ceff7b27$export$64b674d0815308();
    };
    Line.prototype.buildPath = function(ctx, shape) {
        var x1;
        var y1;
        var x2;
        var y2;
        if (this.subPixelOptimize) {
            var optimizedShape = (0, $4d5544821af8d796$export$8b4b620d7f4aad1b)($7a316ae5ceff7b27$var$subPixelOptimizeOutputShape, shape, this.style);
            x1 = optimizedShape.x1;
            y1 = optimizedShape.y1;
            x2 = optimizedShape.x2;
            y2 = optimizedShape.y2;
        } else {
            x1 = shape.x1;
            y1 = shape.y1;
            x2 = shape.x2;
            y2 = shape.y2;
        }
        var percent = shape.percent;
        if (percent === 0) return;
        ctx.moveTo(x1, y1);
        if (percent < 1) {
            x2 = x1 * (1 - percent) + x2 * percent;
            y2 = y1 * (1 - percent) + y2 * percent;
        }
        ctx.lineTo(x2, y2);
    };
    Line.prototype.pointAt = function(p) {
        var shape = this.shape;
        return [
            shape.x1 * (1 - p) + shape.x2 * p,
            shape.y1 * (1 - p) + shape.y2 * p
        ];
    };
    return Line;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
$7a316ae5ceff7b27$var$Line.prototype.type = 'line';
var $7a316ae5ceff7b27$export$2e2bcd8739ae039 = $7a316ae5ceff7b27$var$Line;






var $6c7800c49630e431$var$out = [];
var $6c7800c49630e431$export$e10089729fef29aa = function() {
    function BezierCurveShape() {
        this.x1 = 0;
        this.y1 = 0;
        this.x2 = 0;
        this.y2 = 0;
        this.cpx1 = 0;
        this.cpy1 = 0;
        this.percent = 1;
    }
    return BezierCurveShape;
}();
function $6c7800c49630e431$var$someVectorAt(shape, t, isTangent) {
    var cpx2 = shape.cpx2;
    var cpy2 = shape.cpy2;
    if (cpx2 != null || cpy2 != null) return [
        (isTangent ? (0, $747cfc5611b57cea$export$55fce925c60b6271) : (0, $747cfc5611b57cea$export$547c21de482bbcb2))(shape.x1, shape.cpx1, shape.cpx2, shape.x2, t),
        (isTangent ? (0, $747cfc5611b57cea$export$55fce925c60b6271) : (0, $747cfc5611b57cea$export$547c21de482bbcb2))(shape.y1, shape.cpy1, shape.cpy2, shape.y2, t)
    ];
    else return [
        (isTangent ? (0, $747cfc5611b57cea$export$7e161e77e6fff8cb) : (0, $747cfc5611b57cea$export$af17094a950f5073))(shape.x1, shape.cpx1, shape.x2, t),
        (isTangent ? (0, $747cfc5611b57cea$export$7e161e77e6fff8cb) : (0, $747cfc5611b57cea$export$af17094a950f5073))(shape.y1, shape.cpy1, shape.y2, t)
    ];
}
var $6c7800c49630e431$var$BezierCurve = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(BezierCurve, _super);
    function BezierCurve(opts) {
        return _super.call(this, opts) || this;
    }
    BezierCurve.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    BezierCurve.prototype.getDefaultShape = function() {
        return new $6c7800c49630e431$export$e10089729fef29aa();
    };
    BezierCurve.prototype.buildPath = function(ctx, shape) {
        var x1 = shape.x1;
        var y1 = shape.y1;
        var x2 = shape.x2;
        var y2 = shape.y2;
        var cpx1 = shape.cpx1;
        var cpy1 = shape.cpy1;
        var cpx2 = shape.cpx2;
        var cpy2 = shape.cpy2;
        var percent = shape.percent;
        if (percent === 0) return;
        ctx.moveTo(x1, y1);
        if (cpx2 == null || cpy2 == null) {
            if (percent < 1) {
                (0, $747cfc5611b57cea$export$117c659e21a7a060)(x1, cpx1, x2, percent, $6c7800c49630e431$var$out);
                cpx1 = $6c7800c49630e431$var$out[1];
                x2 = $6c7800c49630e431$var$out[2];
                (0, $747cfc5611b57cea$export$117c659e21a7a060)(y1, cpy1, y2, percent, $6c7800c49630e431$var$out);
                cpy1 = $6c7800c49630e431$var$out[1];
                y2 = $6c7800c49630e431$var$out[2];
            }
            ctx.quadraticCurveTo(cpx1, cpy1, x2, y2);
        } else {
            if (percent < 1) {
                (0, $747cfc5611b57cea$export$a2ee23a0567039da)(x1, cpx1, cpx2, x2, percent, $6c7800c49630e431$var$out);
                cpx1 = $6c7800c49630e431$var$out[1];
                cpx2 = $6c7800c49630e431$var$out[2];
                x2 = $6c7800c49630e431$var$out[3];
                (0, $747cfc5611b57cea$export$a2ee23a0567039da)(y1, cpy1, cpy2, y2, percent, $6c7800c49630e431$var$out);
                cpy1 = $6c7800c49630e431$var$out[1];
                cpy2 = $6c7800c49630e431$var$out[2];
                y2 = $6c7800c49630e431$var$out[3];
            }
            ctx.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, x2, y2);
        }
    };
    BezierCurve.prototype.pointAt = function(t) {
        return $6c7800c49630e431$var$someVectorAt(this.shape, t, false);
    };
    BezierCurve.prototype.tangentAt = function(t) {
        var p = $6c7800c49630e431$var$someVectorAt(this.shape, t, true);
        return $6de594cf8ac295ff$export$a3295358bff77e(p, p);
    };
    return BezierCurve;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
$6c7800c49630e431$var$BezierCurve.prototype.type = 'bezier-curve';
var $6c7800c49630e431$export$2e2bcd8739ae039 = $6c7800c49630e431$var$BezierCurve;




var $2b5c23eb3597b84a$export$a259dbdc51948277 = function() {
    function ArcShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.clockwise = true;
    }
    return ArcShape;
}();
var $2b5c23eb3597b84a$var$Arc = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Arc, _super);
    function Arc(opts) {
        return _super.call(this, opts) || this;
    }
    Arc.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    Arc.prototype.getDefaultShape = function() {
        return new $2b5c23eb3597b84a$export$a259dbdc51948277();
    };
    Arc.prototype.buildPath = function(ctx, shape) {
        var x = shape.cx;
        var y = shape.cy;
        var r = Math.max(shape.r, 0);
        var startAngle = shape.startAngle;
        var endAngle = shape.endAngle;
        var clockwise = shape.clockwise;
        var unitX = Math.cos(startAngle);
        var unitY = Math.sin(startAngle);
        ctx.moveTo(unitX * r + x, unitY * r + y);
        ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
    };
    return Arc;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
$2b5c23eb3597b84a$var$Arc.prototype.type = 'arc';
var $2b5c23eb3597b84a$export$2e2bcd8739ae039 = $2b5c23eb3597b84a$var$Arc;




var $e152f3dbf8fba6e2$var$CompoundPath = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(CompoundPath, _super);
    function CompoundPath() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'compound';
        return _this;
    }
    CompoundPath.prototype._updatePathDirty = function() {
        var paths = this.shape.paths;
        var dirtyPath = this.shapeChanged();
        for(var i = 0; i < paths.length; i++)dirtyPath = dirtyPath || paths[i].shapeChanged();
        if (dirtyPath) this.dirtyShape();
    };
    CompoundPath.prototype.beforeBrush = function() {
        this._updatePathDirty();
        var paths = this.shape.paths || [];
        var scale = this.getGlobalScale();
        for(var i = 0; i < paths.length; i++){
            if (!paths[i].path) paths[i].createPathProxy();
            paths[i].path.setScale(scale[0], scale[1], paths[i].segmentIgnoreThreshold);
        }
    };
    CompoundPath.prototype.buildPath = function(ctx, shape) {
        var paths = shape.paths || [];
        for(var i = 0; i < paths.length; i++)paths[i].buildPath(ctx, paths[i].shape, true);
    };
    CompoundPath.prototype.afterBrush = function() {
        var paths = this.shape.paths || [];
        for(var i = 0; i < paths.length; i++)paths[i].pathUpdated();
    };
    CompoundPath.prototype.getBoundingRect = function() {
        this._updatePathDirty.call(this);
        return (0, $b02ffe7acd508c08$export$2e2bcd8739ae039).prototype.getBoundingRect.call(this);
    };
    return CompoundPath;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
var $e152f3dbf8fba6e2$export$2e2bcd8739ae039 = $e152f3dbf8fba6e2$var$CompoundPath;



var $8273248bf9338d40$var$Gradient = function() {
    function Gradient(colorStops) {
        this.colorStops = colorStops || [];
    }
    Gradient.prototype.addColorStop = function(offset, color) {
        this.colorStops.push({
            offset: offset,
            color: color
        });
    };
    return Gradient;
}();
var $8273248bf9338d40$export$2e2bcd8739ae039 = $8273248bf9338d40$var$Gradient;


var $cf44c01491b58e53$var$LinearGradient = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(LinearGradient, _super);
    function LinearGradient(x, y, x2, y2, colorStops, globalCoord) {
        var _this = _super.call(this, colorStops) || this;
        _this.x = x == null ? 0 : x;
        _this.y = y == null ? 0 : y;
        _this.x2 = x2 == null ? 1 : x2;
        _this.y2 = y2 == null ? 0 : y2;
        _this.type = 'linear';
        _this.global = globalCoord || false;
        return _this;
    }
    return LinearGradient;
}((0, $8273248bf9338d40$export$2e2bcd8739ae039));
var $cf44c01491b58e53$export$2e2bcd8739ae039 = $cf44c01491b58e53$var$LinearGradient;




var $cd2ee2ba32bb26c3$var$RadialGradient = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(RadialGradient, _super);
    function RadialGradient(x, y, r, colorStops, globalCoord) {
        var _this = _super.call(this, colorStops) || this;
        _this.x = x == null ? 0.5 : x;
        _this.y = y == null ? 0.5 : y;
        _this.r = r == null ? 0.5 : r;
        _this.type = 'radial';
        _this.global = globalCoord || false;
        return _this;
    }
    return RadialGradient;
}((0, $8273248bf9338d40$export$2e2bcd8739ae039));
var $cd2ee2ba32bb26c3$export$2e2bcd8739ae039 = $cd2ee2ba32bb26c3$var$RadialGradient;




var $f9793b4d8aade116$var$extent = [
    0,
    0
];
var $f9793b4d8aade116$var$extent2 = [
    0,
    0
];
var $f9793b4d8aade116$var$minTv = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
var $f9793b4d8aade116$var$maxTv = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
var $f9793b4d8aade116$var$OrientedBoundingRect = function() {
    function OrientedBoundingRect(rect, transform) {
        this._corners = [];
        this._axes = [];
        this._origin = [
            0,
            0
        ];
        for(var i = 0; i < 4; i++)this._corners[i] = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
        for(var i = 0; i < 2; i++)this._axes[i] = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
        if (rect) this.fromBoundingRect(rect, transform);
    }
    OrientedBoundingRect.prototype.fromBoundingRect = function(rect, transform) {
        var corners = this._corners;
        var axes = this._axes;
        var x = rect.x;
        var y = rect.y;
        var x2 = x + rect.width;
        var y2 = y + rect.height;
        corners[0].set(x, y);
        corners[1].set(x2, y);
        corners[2].set(x2, y2);
        corners[3].set(x, y2);
        if (transform) for(var i = 0; i < 4; i++)corners[i].transform(transform);
        (0, $b887f038f104fe7e$export$2e2bcd8739ae039).sub(axes[0], corners[1], corners[0]);
        (0, $b887f038f104fe7e$export$2e2bcd8739ae039).sub(axes[1], corners[3], corners[0]);
        axes[0].normalize();
        axes[1].normalize();
        for(var i = 0; i < 2; i++)this._origin[i] = axes[i].dot(corners[0]);
    };
    OrientedBoundingRect.prototype.intersect = function(other, mtv) {
        var overlapped = true;
        var noMtv = !mtv;
        $f9793b4d8aade116$var$minTv.set(Infinity, Infinity);
        $f9793b4d8aade116$var$maxTv.set(0, 0);
        if (!this._intersectCheckOneSide(this, other, $f9793b4d8aade116$var$minTv, $f9793b4d8aade116$var$maxTv, noMtv, 1)) {
            overlapped = false;
            if (noMtv) return overlapped;
        }
        if (!this._intersectCheckOneSide(other, this, $f9793b4d8aade116$var$minTv, $f9793b4d8aade116$var$maxTv, noMtv, -1)) {
            overlapped = false;
            if (noMtv) return overlapped;
        }
        if (!noMtv) (0, $b887f038f104fe7e$export$2e2bcd8739ae039).copy(mtv, overlapped ? $f9793b4d8aade116$var$minTv : $f9793b4d8aade116$var$maxTv);
        return overlapped;
    };
    OrientedBoundingRect.prototype._intersectCheckOneSide = function(self, other, minTv, maxTv, noMtv, inverse) {
        var overlapped = true;
        for(var i = 0; i < 2; i++){
            var axis = this._axes[i];
            this._getProjMinMaxOnAxis(i, self._corners, $f9793b4d8aade116$var$extent);
            this._getProjMinMaxOnAxis(i, other._corners, $f9793b4d8aade116$var$extent2);
            if ($f9793b4d8aade116$var$extent[1] < $f9793b4d8aade116$var$extent2[0] || $f9793b4d8aade116$var$extent[0] > $f9793b4d8aade116$var$extent2[1]) {
                overlapped = false;
                if (noMtv) return overlapped;
                var dist0 = Math.abs($f9793b4d8aade116$var$extent2[0] - $f9793b4d8aade116$var$extent[1]);
                var dist1 = Math.abs($f9793b4d8aade116$var$extent[0] - $f9793b4d8aade116$var$extent2[1]);
                if (Math.min(dist0, dist1) > maxTv.len()) {
                    if (dist0 < dist1) (0, $b887f038f104fe7e$export$2e2bcd8739ae039).scale(maxTv, axis, -dist0 * inverse);
                    else (0, $b887f038f104fe7e$export$2e2bcd8739ae039).scale(maxTv, axis, dist1 * inverse);
                }
            } else if (minTv) {
                var dist0 = Math.abs($f9793b4d8aade116$var$extent2[0] - $f9793b4d8aade116$var$extent[1]);
                var dist1 = Math.abs($f9793b4d8aade116$var$extent[0] - $f9793b4d8aade116$var$extent2[1]);
                if (Math.min(dist0, dist1) < minTv.len()) {
                    if (dist0 < dist1) (0, $b887f038f104fe7e$export$2e2bcd8739ae039).scale(minTv, axis, dist0 * inverse);
                    else (0, $b887f038f104fe7e$export$2e2bcd8739ae039).scale(minTv, axis, -dist1 * inverse);
                }
            }
        }
        return overlapped;
    };
    OrientedBoundingRect.prototype._getProjMinMaxOnAxis = function(dim, corners, out) {
        var axis = this._axes[dim];
        var origin = this._origin;
        var proj = corners[0].dot(axis) + origin[dim];
        var min = proj;
        var max = proj;
        for(var i = 1; i < corners.length; i++){
            var proj_1 = corners[i].dot(axis) + origin[dim];
            min = Math.min(proj_1, min);
            max = Math.max(proj_1, max);
        }
        out[0] = min;
        out[1] = max;
    };
    return OrientedBoundingRect;
}();
var $f9793b4d8aade116$export$2e2bcd8739ae039 = $f9793b4d8aade116$var$OrientedBoundingRect;






var $ee829f116f003981$var$m = [];
var $ee829f116f003981$var$IncrementalDisplayable = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(IncrementalDisplayable, _super);
    function IncrementalDisplayable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.notClear = true;
        _this.incremental = true;
        _this._displayables = [];
        _this._temporaryDisplayables = [];
        _this._cursor = 0;
        return _this;
    }
    IncrementalDisplayable.prototype.traverse = function(cb, context) {
        cb.call(context, this);
    };
    IncrementalDisplayable.prototype.useStyle = function() {
        this.style = {};
    };
    IncrementalDisplayable.prototype.getCursor = function() {
        return this._cursor;
    };
    IncrementalDisplayable.prototype.innerAfterBrush = function() {
        this._cursor = this._displayables.length;
    };
    IncrementalDisplayable.prototype.clearDisplaybles = function() {
        this._displayables = [];
        this._temporaryDisplayables = [];
        this._cursor = 0;
        this.markRedraw();
        this.notClear = false;
    };
    IncrementalDisplayable.prototype.clearTemporalDisplayables = function() {
        this._temporaryDisplayables = [];
    };
    IncrementalDisplayable.prototype.addDisplayable = function(displayable, notPersistent) {
        if (notPersistent) this._temporaryDisplayables.push(displayable);
        else this._displayables.push(displayable);
        this.markRedraw();
    };
    IncrementalDisplayable.prototype.addDisplayables = function(displayables, notPersistent) {
        notPersistent = notPersistent || false;
        for(var i = 0; i < displayables.length; i++)this.addDisplayable(displayables[i], notPersistent);
    };
    IncrementalDisplayable.prototype.getDisplayables = function() {
        return this._displayables;
    };
    IncrementalDisplayable.prototype.getTemporalDisplayables = function() {
        return this._temporaryDisplayables;
    };
    IncrementalDisplayable.prototype.eachPendingDisplayable = function(cb) {
        for(var i = this._cursor; i < this._displayables.length; i++)cb && cb(this._displayables[i]);
        for(var i = 0; i < this._temporaryDisplayables.length; i++)cb && cb(this._temporaryDisplayables[i]);
    };
    IncrementalDisplayable.prototype.update = function() {
        this.updateTransform();
        for(var i = this._cursor; i < this._displayables.length; i++){
            var displayable = this._displayables[i];
            displayable.parent = this;
            displayable.update();
            displayable.parent = null;
        }
        for(var i = 0; i < this._temporaryDisplayables.length; i++){
            var displayable = this._temporaryDisplayables[i];
            displayable.parent = this;
            displayable.update();
            displayable.parent = null;
        }
    };
    IncrementalDisplayable.prototype.getBoundingRect = function() {
        if (!this._rect) {
            var rect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(Infinity, Infinity, -Infinity, -Infinity);
            for(var i = 0; i < this._displayables.length; i++){
                var displayable = this._displayables[i];
                var childRect = displayable.getBoundingRect().clone();
                if (displayable.needLocalTransform()) childRect.applyTransform(displayable.getLocalTransform($ee829f116f003981$var$m));
                rect.union(childRect);
            }
            this._rect = rect;
        }
        return this._rect;
    };
    IncrementalDisplayable.prototype.contain = function(x, y) {
        var localPos = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        if (rect.contain(localPos[0], localPos[1])) for(var i = 0; i < this._displayables.length; i++){
            var displayable = this._displayables[i];
            if (displayable.contain(x, y)) return true;
        }
        return false;
    };
    return IncrementalDisplayable;
}((0, $56206a6cb4666931$export$2e2bcd8739ae039));
var $ee829f116f003981$export$2e2bcd8739ae039 = $ee829f116f003981$var$IncrementalDisplayable;






var $5b455ae6f843ac47$var$mathMax = Math.max;
var $5b455ae6f843ac47$var$mathMin = Math.min;
var $5b455ae6f843ac47$var$_customShapeMap = {};
function $5b455ae6f843ac47$export$d0d5398c9d612037(opts) {
    return (0, $b02ffe7acd508c08$export$2e2bcd8739ae039).extend(opts);
}
var $5b455ae6f843ac47$var$extendPathFromString = $15b38920672b9006$export$68e3a51ba2ed417c;
function $5b455ae6f843ac47$export$53b54a3137026af0(pathData, opts) {
    return $5b455ae6f843ac47$var$extendPathFromString(pathData, opts);
}
function $5b455ae6f843ac47$export$2b95b62e3aaf6fdd(name, ShapeClass) {
    $5b455ae6f843ac47$var$_customShapeMap[name] = ShapeClass;
}
function $5b455ae6f843ac47$export$51df4b5565a58189(name) {
    if ($5b455ae6f843ac47$var$_customShapeMap.hasOwnProperty(name)) return $5b455ae6f843ac47$var$_customShapeMap[name];
}
function $5b455ae6f843ac47$export$aa9bab72412f5613(pathData, opts, rect, layout) {
    var path = $15b38920672b9006$export$ae5b259626f00aeb(pathData, opts);
    if (rect) {
        if (layout === 'center') rect = $5b455ae6f843ac47$var$centerGraphic(rect, path.getBoundingRect());
        $5b455ae6f843ac47$export$566dbf1c62b04fc7(path, rect);
    }
    return path;
}
function $5b455ae6f843ac47$export$7a2bdede98851ac5(imageUrl, rect, layout) {
    var zrImg = new (0, $86adec94217b86c6$export$2e2bcd8739ae039)({
        style: {
            image: imageUrl,
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height
        },
        onload: function(img) {
            if (layout === 'center') {
                var boundingRect = {
                    width: img.width,
                    height: img.height
                };
                zrImg.setStyle($5b455ae6f843ac47$var$centerGraphic(rect, boundingRect));
            }
        }
    });
    return zrImg;
}
/**
 * Get position of centered element in bounding box.
 *
 * @param  rect         element local bounding box
 * @param  boundingRect constraint bounding box
 * @return element position containing x, y, width, and height
 */ function $5b455ae6f843ac47$var$centerGraphic(rect, boundingRect) {
    // Set rect to center, keep width / height ratio.
    var aspect = boundingRect.width / boundingRect.height;
    var width = rect.height * aspect;
    var height;
    if (width <= rect.width) height = rect.height;
    else {
        width = rect.width;
        height = width / aspect;
    }
    var cx = rect.x + rect.width / 2;
    var cy = rect.y + rect.height / 2;
    return {
        x: cx - width / 2,
        y: cy - height / 2,
        width: width,
        height: height
    };
}
var $5b455ae6f843ac47$export$7b1dd269fbc4e903 = $15b38920672b9006$export$7b1dd269fbc4e903;
function $5b455ae6f843ac47$export$566dbf1c62b04fc7(path, rect) {
    if (!path.applyTransform) return;
    var pathRect = path.getBoundingRect();
    var m = pathRect.calculateTransform(rect);
    path.applyTransform(m);
}
function $5b455ae6f843ac47$export$8b4b620d7f4aad1b(shape, lineWidth) {
    $4d5544821af8d796$export$8b4b620d7f4aad1b(shape, shape, {
        lineWidth: lineWidth
    });
    return shape;
}
function $5b455ae6f843ac47$export$60e2aa74957d0b9d(param) {
    $4d5544821af8d796$export$60e2aa74957d0b9d(param.shape, param.shape, param.style);
    return param;
}
var $5b455ae6f843ac47$export$72c4fd4c1b8fcb10 = $4d5544821af8d796$export$72c4fd4c1b8fcb10;
function $5b455ae6f843ac47$export$fce0c6cfca85ed96(target, ancestor) {
    var mat = $f41ebb9dd60b55b4$export$f0954fd7d5368655([]);
    while(target && target !== ancestor){
        $f41ebb9dd60b55b4$export$6e3a27864ab166fe(mat, target.getLocalTransform(), mat);
        target = target.parent;
    }
    return mat;
}
function $5b455ae6f843ac47$export$9f9dcb98c894b623(target, transform, invert) {
    if (transform && !(0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(transform)) transform = (0, $becf2d727f9cf450$export$2e2bcd8739ae039).getLocalTransform(transform);
    if (invert) transform = $f41ebb9dd60b55b4$export$6897c284b6f9f4dc([], transform);
    return $6de594cf8ac295ff$export$9f9dcb98c894b623([], target, transform);
}
function $5b455ae6f843ac47$export$fff94e9792354cfa(direction, transform, invert) {
    // Pick a base, ensure that transform result will not be (0, 0).
    var hBase = transform[4] === 0 || transform[5] === 0 || transform[0] === 0 ? 1 : Math.abs(2 * transform[4] / transform[0]);
    var vBase = transform[4] === 0 || transform[5] === 0 || transform[2] === 0 ? 1 : Math.abs(2 * transform[4] / transform[2]);
    var vertex = [
        direction === 'left' ? -hBase : direction === 'right' ? hBase : 0,
        direction === 'top' ? -vBase : direction === 'bottom' ? vBase : 0
    ];
    vertex = $5b455ae6f843ac47$export$9f9dcb98c894b623(vertex, transform, invert);
    return Math.abs(vertex[0]) > Math.abs(vertex[1]) ? vertex[0] > 0 ? 'right' : 'left' : vertex[1] > 0 ? 'bottom' : 'top';
}
function $5b455ae6f843ac47$var$isNotGroup(el) {
    return !el.isGroup;
}
function $5b455ae6f843ac47$var$isPath(el) {
    return el.shape != null;
}
function $5b455ae6f843ac47$export$64fcab7860c216ae(g1, g2, animatableModel) {
    if (!g1 || !g2) return;
    function getElMap(g) {
        var elMap = {};
        g.traverse(function(el) {
            if ($5b455ae6f843ac47$var$isNotGroup(el) && el.anid) elMap[el.anid] = el;
        });
        return elMap;
    }
    function getAnimatableProps(el) {
        var obj = {
            x: el.x,
            y: el.y,
            rotation: el.rotation
        };
        if ($5b455ae6f843ac47$var$isPath(el)) obj.shape = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, el.shape);
        return obj;
    }
    var elMap1 = getElMap(g1);
    g2.traverse(function(el) {
        if ($5b455ae6f843ac47$var$isNotGroup(el) && el.anid) {
            var oldEl = elMap1[el.anid];
            if (oldEl) {
                var newProp = getAnimatableProps(el);
                el.attr(getAnimatableProps(oldEl));
                (0, $8b353638fbedfefa$export$c8dce3c08436e91e)(el, newProp, animatableModel, (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).dataIndex);
            }
        }
    });
}
function $5b455ae6f843ac47$export$e2f409471bbbc1dc(points, rect) {
    // FIXME: This way might be incorrect when graphic clipped by a corner
    // and when element has a border.
    return (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(points, function(point) {
        var x = point[0];
        x = $5b455ae6f843ac47$var$mathMax(x, rect.x);
        x = $5b455ae6f843ac47$var$mathMin(x, rect.x + rect.width);
        var y = point[1];
        y = $5b455ae6f843ac47$var$mathMax(y, rect.y);
        y = $5b455ae6f843ac47$var$mathMin(y, rect.y + rect.height);
        return [
            x,
            y
        ];
    });
}
function $5b455ae6f843ac47$export$d0d3709202b8b2a(targetRect, rect) {
    var x = $5b455ae6f843ac47$var$mathMax(targetRect.x, rect.x);
    var x2 = $5b455ae6f843ac47$var$mathMin(targetRect.x + targetRect.width, rect.x + rect.width);
    var y = $5b455ae6f843ac47$var$mathMax(targetRect.y, rect.y);
    var y2 = $5b455ae6f843ac47$var$mathMin(targetRect.y + targetRect.height, rect.y + rect.height);
    // If the total rect is cliped, nothing, including the border,
    // should be painted. So return undefined.
    if (x2 >= x && y2 >= y) return {
        x: x,
        y: y,
        width: x2 - x,
        height: y2 - y
    };
}
function $5b455ae6f843ac47$export$274edc73af1ae9c8(iconStr, // Support 'image://' or 'path://' or direct svg path.
opt, rect) {
    var innerOpts = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
        rectHover: true
    }, opt);
    var style = innerOpts.style = {
        strokeNoScale: true
    };
    rect = rect || {
        x: -1,
        y: -1,
        width: 2,
        height: 2
    };
    if (iconStr) return iconStr.indexOf('image://') === 0 ? (style.image = iconStr.slice(8), (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(style, rect), new (0, $86adec94217b86c6$export$2e2bcd8739ae039)(innerOpts)) : $5b455ae6f843ac47$export$aa9bab72412f5613(iconStr.replace('path://', ''), innerOpts, rect, 'center');
}
function $5b455ae6f843ac47$export$4f47c855a5e9ae9(a1x, a1y, a2x, a2y, points) {
    for(var i = 0, p2 = points[points.length - 1]; i < points.length; i++){
        var p = points[i];
        if ($5b455ae6f843ac47$export$6c0a70ea1d8d158b(a1x, a1y, a2x, a2y, p[0], p[1], p2[0], p2[1])) return true;
        p2 = p;
    }
}
function $5b455ae6f843ac47$export$6c0a70ea1d8d158b(a1x, a1y, a2x, a2y, b1x, b1y, b2x, b2y) {
    // let `vec_m` to be `vec_a2 - vec_a1` and `vec_n` to be `vec_b2 - vec_b1`.
    var mx = a2x - a1x;
    var my = a2y - a1y;
    var nx = b2x - b1x;
    var ny = b2y - b1y;
    // `vec_m` and `vec_n` are parallel iff
    //     existing `k` such that `vec_m = k · vec_n`, equivalent to `vec_m X vec_n = 0`.
    var nmCrossProduct = $5b455ae6f843ac47$var$crossProduct2d(nx, ny, mx, my);
    if ($5b455ae6f843ac47$var$nearZero(nmCrossProduct)) return false;
    // `vec_m` and `vec_n` are intersect iff
    //     existing `p` and `q` in [0, 1] such that `vec_a1 + p * vec_m = vec_b1 + q * vec_n`,
    //     such that `q = ((vec_a1 - vec_b1) X vec_m) / (vec_n X vec_m)`
    //           and `p = ((vec_a1 - vec_b1) X vec_n) / (vec_n X vec_m)`.
    var b1a1x = a1x - b1x;
    var b1a1y = a1y - b1y;
    var q = $5b455ae6f843ac47$var$crossProduct2d(b1a1x, b1a1y, mx, my) / nmCrossProduct;
    if (q < 0 || q > 1) return false;
    var p = $5b455ae6f843ac47$var$crossProduct2d(b1a1x, b1a1y, nx, ny) / nmCrossProduct;
    if (p < 0 || p > 1) return false;
    return true;
}
/**
 * Cross product of 2-dimension vector.
 */ function $5b455ae6f843ac47$var$crossProduct2d(x1, y1, x2, y2) {
    return x1 * y2 - x2 * y1;
}
function $5b455ae6f843ac47$var$nearZero(val) {
    return val <= 1e-6 && val >= -0.000001;
}
function $5b455ae6f843ac47$export$fc6410d97fab306c(opt) {
    var itemTooltipOption = opt.itemTooltipOption;
    var componentModel = opt.componentModel;
    var itemName = opt.itemName;
    var itemTooltipOptionObj = (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(itemTooltipOption) ? {
        formatter: itemTooltipOption
    } : itemTooltipOption;
    var mainType = componentModel.mainType;
    var componentIndex = componentModel.componentIndex;
    var formatterParams = {
        componentType: mainType,
        name: itemName,
        $vars: [
            'name'
        ]
    };
    formatterParams[mainType + 'Index'] = componentIndex;
    var formatterParamsExtra = opt.formatterParamsExtra;
    if (formatterParamsExtra) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(formatterParamsExtra), function(key) {
        if (!(0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(formatterParams, key)) {
            formatterParams[key] = formatterParamsExtra[key];
            formatterParams.$vars.push(key);
        }
    });
    var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(opt.el);
    ecData.componentMainType = mainType;
    ecData.componentIndex = componentIndex;
    ecData.tooltipConfig = {
        name: itemName,
        option: (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
            content: itemName,
            encodeHTMLContent: true,
            formatterParams: formatterParams
        }, itemTooltipOptionObj)
    };
}
function $5b455ae6f843ac47$var$traverseElement(el, cb) {
    var stopped;
    // TODO
    // Polyfill for fixing zrender group traverse don't visit it's root issue.
    if (el.isGroup) stopped = cb(el);
    if (!stopped) el.traverse(cb);
}
function $5b455ae6f843ac47$export$3e564442729bf048(els, cb) {
    if (els) {
        if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(els)) for(var i = 0; i < els.length; i++)$5b455ae6f843ac47$var$traverseElement(els[i], cb);
        else $5b455ae6f843ac47$var$traverseElement(els, cb);
    }
}
// Register built-in shapes. These shapes might be overwritten
// by users, although we do not recommend that.
$5b455ae6f843ac47$export$2b95b62e3aaf6fdd('circle', (0, $1e68d8727773abb7$export$2e2bcd8739ae039));
$5b455ae6f843ac47$export$2b95b62e3aaf6fdd('ellipse', (0, $4a809f055a7e524c$export$2e2bcd8739ae039));
$5b455ae6f843ac47$export$2b95b62e3aaf6fdd('sector', (0, $a3e1dec0a3875b49$export$2e2bcd8739ae039));
$5b455ae6f843ac47$export$2b95b62e3aaf6fdd('ring', (0, $9da0cbfd3f86fdc1$export$2e2bcd8739ae039));
$5b455ae6f843ac47$export$2b95b62e3aaf6fdd('polygon', (0, $51acf033123e1a30$export$2e2bcd8739ae039));
$5b455ae6f843ac47$export$2b95b62e3aaf6fdd('polyline', (0, $d28119f30e6bb670$export$2e2bcd8739ae039));
$5b455ae6f843ac47$export$2b95b62e3aaf6fdd('rect', (0, $419e5ff2f303755e$export$2e2bcd8739ae039));
$5b455ae6f843ac47$export$2b95b62e3aaf6fdd('line', (0, $7a316ae5ceff7b27$export$2e2bcd8739ae039));
$5b455ae6f843ac47$export$2b95b62e3aaf6fdd('bezierCurve', (0, $6c7800c49630e431$export$2e2bcd8739ae039));
$5b455ae6f843ac47$export$2b95b62e3aaf6fdd('arc', (0, $2b5c23eb3597b84a$export$2e2bcd8739ae039));


var $6800dfcb6e1e2a44$var$EMPTY_OBJ = {};
function $6800dfcb6e1e2a44$export$b533918394a58529(label, labelTexts) {
    for(var i = 0; i < (0, $2bf82c0980125b62$export$151308dceb52d5b).length; i++){
        var stateName = (0, $2bf82c0980125b62$export$151308dceb52d5b)[i];
        var text = labelTexts[stateName];
        var state = label.ensureState(stateName);
        state.style = state.style || {};
        state.style.text = text;
    }
    var oldStates = label.currentStates.slice();
    label.clearStates(true);
    label.setStyle({
        text: labelTexts.normal
    });
    label.useStates(oldStates, true);
}
function $6800dfcb6e1e2a44$var$getLabelText(opt, stateModels, interpolatedValue) {
    var labelFetcher = opt.labelFetcher;
    var labelDataIndex = opt.labelDataIndex;
    var labelDimIndex = opt.labelDimIndex;
    var normalModel = stateModels.normal;
    var baseText;
    if (labelFetcher) baseText = labelFetcher.getFormattedLabel(labelDataIndex, 'normal', null, labelDimIndex, normalModel && normalModel.get('formatter'), interpolatedValue != null ? {
        interpolatedValue: interpolatedValue
    } : null);
    if (baseText == null) baseText = (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(opt.defaultText) ? opt.defaultText(labelDataIndex, opt, interpolatedValue) : opt.defaultText;
    var statesText = {
        normal: baseText
    };
    for(var i = 0; i < (0, $2bf82c0980125b62$export$151308dceb52d5b).length; i++){
        var stateName = (0, $2bf82c0980125b62$export$151308dceb52d5b)[i];
        var stateModel = stateModels[stateName];
        statesText[stateName] = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(labelFetcher ? labelFetcher.getFormattedLabel(labelDataIndex, stateName, null, labelDimIndex, stateModel && stateModel.get('formatter')) : null, baseText);
    }
    return statesText;
}
function $6800dfcb6e1e2a44$export$9a13992917966657(targetEl, labelStatesModels, opt, stateSpecified) {
    opt = opt || $6800dfcb6e1e2a44$var$EMPTY_OBJ;
    var isSetOnText = targetEl instanceof (0, $fe885cc21795562b$export$2e2bcd8739ae039);
    var needsCreateText = false;
    for(var i = 0; i < (0, $2bf82c0980125b62$export$57ee5306b85ad7d5).length; i++){
        var stateModel = labelStatesModels[(0, $2bf82c0980125b62$export$57ee5306b85ad7d5)[i]];
        if (stateModel && stateModel.getShallow('show')) {
            needsCreateText = true;
            break;
        }
    }
    var textContent = isSetOnText ? targetEl : targetEl.getTextContent();
    if (needsCreateText) {
        if (!isSetOnText) {
            // Reuse the previous
            if (!textContent) {
                textContent = new (0, $fe885cc21795562b$export$2e2bcd8739ae039)();
                targetEl.setTextContent(textContent);
            }
            // Use same state proxy
            if (targetEl.stateProxy) textContent.stateProxy = targetEl.stateProxy;
        }
        var labelStatesTexts = $6800dfcb6e1e2a44$var$getLabelText(opt, labelStatesModels);
        var normalModel = labelStatesModels.normal;
        var showNormal = !!normalModel.getShallow('show');
        var normalStyle = $6800dfcb6e1e2a44$export$f8998c3d0a13de59(normalModel, stateSpecified && stateSpecified.normal, opt, false, !isSetOnText);
        normalStyle.text = labelStatesTexts.normal;
        if (!isSetOnText) // Always create new
        targetEl.setTextConfig($6800dfcb6e1e2a44$export$e149afab8df6e053(normalModel, opt, false));
        for(var i = 0; i < (0, $2bf82c0980125b62$export$151308dceb52d5b).length; i++){
            var stateName = (0, $2bf82c0980125b62$export$151308dceb52d5b)[i];
            var stateModel = labelStatesModels[stateName];
            if (stateModel) {
                var stateObj = textContent.ensureState(stateName);
                var stateShow = !!(0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(stateModel.getShallow('show'), showNormal);
                if (stateShow !== showNormal) stateObj.ignore = !stateShow;
                stateObj.style = $6800dfcb6e1e2a44$export$f8998c3d0a13de59(stateModel, stateSpecified && stateSpecified[stateName], opt, true, !isSetOnText);
                stateObj.style.text = labelStatesTexts[stateName];
                if (!isSetOnText) {
                    var targetElEmphasisState = targetEl.ensureState(stateName);
                    targetElEmphasisState.textConfig = $6800dfcb6e1e2a44$export$e149afab8df6e053(stateModel, opt, true);
                }
            }
        }
        // PENDING: if there is many requirements that emphasis position
        // need to be different from normal position, we might consider
        // auto silent is those cases.
        textContent.silent = !!normalModel.getShallow('silent');
        // Keep x and y
        if (textContent.style.x != null) normalStyle.x = textContent.style.x;
        if (textContent.style.y != null) normalStyle.y = textContent.style.y;
        textContent.ignore = !showNormal;
        // Always create new style.
        textContent.useStyle(normalStyle);
        textContent.dirty();
        if (opt.enableTextSetter) $6800dfcb6e1e2a44$export$f62786d3261ab0f4(textContent).setLabelText = function(interpolatedValue) {
            var labelStatesTexts = $6800dfcb6e1e2a44$var$getLabelText(opt, labelStatesModels, interpolatedValue);
            $6800dfcb6e1e2a44$export$b533918394a58529(textContent, labelStatesTexts);
        };
    } else if (textContent) // Not display rich text.
    textContent.ignore = true;
    targetEl.dirty();
}
function $6800dfcb6e1e2a44$export$9739a32674be5893(itemModel, labelName) {
    labelName = labelName || 'label';
    var statesModels = {
        normal: itemModel.getModel(labelName)
    };
    for(var i = 0; i < (0, $2bf82c0980125b62$export$151308dceb52d5b).length; i++){
        var stateName = (0, $2bf82c0980125b62$export$151308dceb52d5b)[i];
        statesModels[stateName] = itemModel.getModel([
            stateName,
            labelName
        ]);
    }
    return statesModels;
}
function $6800dfcb6e1e2a44$export$f8998c3d0a13de59(textStyleModel, specifiedTextStyle, // Fixed style in the code. Can't be set by model.
opt, isNotNormal, isAttached // If text is attached on an element. If so, auto color will handling in zrender.
) {
    var textStyle = {};
    $6800dfcb6e1e2a44$var$setTextStyleCommon(textStyle, textStyleModel, opt, isNotNormal, isAttached);
    specifiedTextStyle && (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(textStyle, specifiedTextStyle);
    // textStyle.host && textStyle.host.dirty && textStyle.host.dirty(false);
    return textStyle;
}
function $6800dfcb6e1e2a44$export$e149afab8df6e053(textStyleModel, opt, isNotNormal) {
    opt = opt || {};
    var textConfig = {};
    var labelPosition;
    var labelRotate = textStyleModel.getShallow('rotate');
    var labelDistance = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(textStyleModel.getShallow('distance'), isNotNormal ? null : 5);
    var labelOffset = textStyleModel.getShallow('offset');
    labelPosition = textStyleModel.getShallow('position') || (isNotNormal ? null : 'inside');
    // 'outside' is not a valid zr textPostion value, but used
    // in bar series, and magric type should be considered.
    labelPosition === 'outside' && (labelPosition = opt.defaultOutsidePosition || 'top');
    if (labelPosition != null) textConfig.position = labelPosition;
    if (labelOffset != null) textConfig.offset = labelOffset;
    if (labelRotate != null) {
        labelRotate *= Math.PI / 180;
        textConfig.rotation = labelRotate;
    }
    if (labelDistance != null) textConfig.distance = labelDistance;
    // fill and auto is determined by the color of path fill if it's not specified by developers.
    textConfig.outsideFill = textStyleModel.get('color') === 'inherit' ? opt.inheritColor || null : 'auto';
    return textConfig;
}
/**
 * The uniform entry of set text style, that is, retrieve style definitions
 * from `model` and set to `textStyle` object.
 *
 * Never in merge mode, but in overwrite mode, that is, all of the text style
 * properties will be set. (Consider the states of normal and emphasis and
 * default value can be adopted, merge would make the logic too complicated
 * to manage.)
 */ function $6800dfcb6e1e2a44$var$setTextStyleCommon(textStyle, textStyleModel, opt, isNotNormal, isAttached) {
    // Consider there will be abnormal when merge hover style to normal style if given default value.
    opt = opt || $6800dfcb6e1e2a44$var$EMPTY_OBJ;
    var ecModel = textStyleModel.ecModel;
    var globalTextStyle = ecModel && ecModel.option.textStyle;
    // Consider case:
    // {
    //     data: [{
    //         value: 12,
    //         label: {
    //             rich: {
    //                 // no 'a' here but using parent 'a'.
    //             }
    //         }
    //     }],
    //     rich: {
    //         a: { ... }
    //     }
    // }
    var richItemNames = $6800dfcb6e1e2a44$var$getRichItemNames(textStyleModel);
    var richResult;
    if (richItemNames) {
        richResult = {};
        for(var name_1 in richItemNames)if (richItemNames.hasOwnProperty(name_1)) {
            // Cascade is supported in rich.
            var richTextStyle = textStyleModel.getModel([
                'rich',
                name_1
            ]);
            // In rich, never `disableBox`.
            // FIXME: consider `label: {formatter: '{a|xx}', color: 'blue', rich: {a: {}}}`,
            // the default color `'blue'` will not be adopted if no color declared in `rich`.
            // That might confuses users. So probably we should put `textStyleModel` as the
            // root ancestor of the `richTextStyle`. But that would be a break change.
            $6800dfcb6e1e2a44$var$setTokenTextStyle(richResult[name_1] = {}, richTextStyle, globalTextStyle, opt, isNotNormal, isAttached, false, true);
        }
    }
    if (richResult) textStyle.rich = richResult;
    var overflow = textStyleModel.get('overflow');
    if (overflow) textStyle.overflow = overflow;
    var margin = textStyleModel.get('minMargin');
    if (margin != null) textStyle.margin = margin;
    $6800dfcb6e1e2a44$var$setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isNotNormal, isAttached, true, false);
}
// Consider case:
// {
//     data: [{
//         value: 12,
//         label: {
//             rich: {
//                 // no 'a' here but using parent 'a'.
//             }
//         }
//     }],
//     rich: {
//         a: { ... }
//     }
// }
// TODO TextStyleModel
function $6800dfcb6e1e2a44$var$getRichItemNames(textStyleModel) {
    // Use object to remove duplicated names.
    var richItemNameMap;
    while(textStyleModel && textStyleModel !== textStyleModel.ecModel){
        var rich = (textStyleModel.option || $6800dfcb6e1e2a44$var$EMPTY_OBJ).rich;
        if (rich) {
            richItemNameMap = richItemNameMap || {};
            var richKeys = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(rich);
            for(var i = 0; i < richKeys.length; i++){
                var richKey = richKeys[i];
                richItemNameMap[richKey] = 1;
            }
        }
        textStyleModel = textStyleModel.parentModel;
    }
    return richItemNameMap;
}
var $6800dfcb6e1e2a44$var$TEXT_PROPS_WITH_GLOBAL = [
    'fontStyle',
    'fontWeight',
    'fontSize',
    'fontFamily',
    'textShadowColor',
    'textShadowBlur',
    'textShadowOffsetX',
    'textShadowOffsetY'
];
var $6800dfcb6e1e2a44$var$TEXT_PROPS_SELF = [
    'align',
    'lineHeight',
    'width',
    'height',
    'tag',
    'verticalAlign',
    'ellipsis'
];
var $6800dfcb6e1e2a44$var$TEXT_PROPS_BOX = [
    'padding',
    'borderWidth',
    'borderRadius',
    'borderDashOffset',
    'backgroundColor',
    'borderColor',
    'shadowColor',
    'shadowBlur',
    'shadowOffsetX',
    'shadowOffsetY'
];
function $6800dfcb6e1e2a44$var$setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isNotNormal, isAttached, isBlock, inRich) {
    // In merge mode, default value should not be given.
    globalTextStyle = !isNotNormal && globalTextStyle || $6800dfcb6e1e2a44$var$EMPTY_OBJ;
    var inheritColor = opt && opt.inheritColor;
    var fillColor = textStyleModel.getShallow('color');
    var strokeColor = textStyleModel.getShallow('textBorderColor');
    var opacity = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(textStyleModel.getShallow('opacity'), globalTextStyle.opacity);
    if (fillColor === 'inherit' || fillColor === 'auto') {
        if (inheritColor) fillColor = inheritColor;
        else fillColor = null;
    }
    if (strokeColor === 'inherit' || strokeColor === 'auto') {
        if (inheritColor) strokeColor = inheritColor;
        else strokeColor = null;
    }
    if (!isAttached) {
        // Only use default global textStyle.color if text is individual.
        // Otherwise it will use the strategy of attached text color because text may be on a path.
        fillColor = fillColor || globalTextStyle.color;
        strokeColor = strokeColor || globalTextStyle.textBorderColor;
    }
    if (fillColor != null) textStyle.fill = fillColor;
    if (strokeColor != null) textStyle.stroke = strokeColor;
    var textBorderWidth = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(textStyleModel.getShallow('textBorderWidth'), globalTextStyle.textBorderWidth);
    if (textBorderWidth != null) textStyle.lineWidth = textBorderWidth;
    var textBorderType = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(textStyleModel.getShallow('textBorderType'), globalTextStyle.textBorderType);
    if (textBorderType != null) textStyle.lineDash = textBorderType;
    var textBorderDashOffset = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(textStyleModel.getShallow('textBorderDashOffset'), globalTextStyle.textBorderDashOffset);
    if (textBorderDashOffset != null) textStyle.lineDashOffset = textBorderDashOffset;
    if (!isNotNormal && opacity == null && !inRich) opacity = opt && opt.defaultOpacity;
    if (opacity != null) textStyle.opacity = opacity;
    // TODO
    if (!isNotNormal && !isAttached) // Set default finally.
    {
        if (textStyle.fill == null && opt.inheritColor) textStyle.fill = opt.inheritColor;
    }
    // Do not use `getFont` here, because merge should be supported, where
    // part of these properties may be changed in emphasis style, and the
    // others should remain their original value got from normal style.
    for(var i = 0; i < $6800dfcb6e1e2a44$var$TEXT_PROPS_WITH_GLOBAL.length; i++){
        var key = $6800dfcb6e1e2a44$var$TEXT_PROPS_WITH_GLOBAL[i];
        var val = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(textStyleModel.getShallow(key), globalTextStyle[key]);
        if (val != null) textStyle[key] = val;
    }
    for(var i = 0; i < $6800dfcb6e1e2a44$var$TEXT_PROPS_SELF.length; i++){
        var key = $6800dfcb6e1e2a44$var$TEXT_PROPS_SELF[i];
        var val = textStyleModel.getShallow(key);
        if (val != null) textStyle[key] = val;
    }
    if (textStyle.verticalAlign == null) {
        var baseline = textStyleModel.getShallow('baseline');
        if (baseline != null) textStyle.verticalAlign = baseline;
    }
    if (!isBlock || !opt.disableBox) {
        for(var i = 0; i < $6800dfcb6e1e2a44$var$TEXT_PROPS_BOX.length; i++){
            var key = $6800dfcb6e1e2a44$var$TEXT_PROPS_BOX[i];
            var val = textStyleModel.getShallow(key);
            if (val != null) textStyle[key] = val;
        }
        var borderType = textStyleModel.getShallow('borderType');
        if (borderType != null) textStyle.borderDash = borderType;
        if ((textStyle.backgroundColor === 'auto' || textStyle.backgroundColor === 'inherit') && inheritColor) textStyle.backgroundColor = inheritColor;
        if ((textStyle.borderColor === 'auto' || textStyle.borderColor === 'inherit') && inheritColor) textStyle.borderColor = inheritColor;
    }
}
function $6800dfcb6e1e2a44$export$155316a870a9d61e(opt, ecModel) {
    var gTextStyleModel = ecModel && ecModel.getModel('textStyle');
    return (0, $7a1bd9c2710fea0d$export$87c2784dc9fc4ab)([
        // FIXME in node-canvas fontWeight is before fontStyle
        opt.fontStyle || gTextStyleModel && gTextStyleModel.getShallow('fontStyle') || '',
        opt.fontWeight || gTextStyleModel && gTextStyleModel.getShallow('fontWeight') || '',
        (opt.fontSize || gTextStyleModel && gTextStyleModel.getShallow('fontSize') || 12) + 'px',
        opt.fontFamily || gTextStyleModel && gTextStyleModel.getShallow('fontFamily') || 'sans-serif'
    ].join(' '));
}
var $6800dfcb6e1e2a44$export$f62786d3261ab0f4 = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $6800dfcb6e1e2a44$export$7bdbceaf9ab378f2(label, labelStatesModels, value, getDefaultText) {
    if (!label) return;
    var obj = $6800dfcb6e1e2a44$export$f62786d3261ab0f4(label);
    obj.prevValue = obj.value;
    obj.value = value;
    var normalLabelModel = labelStatesModels.normal;
    obj.valueAnimation = normalLabelModel.get('valueAnimation');
    if (obj.valueAnimation) {
        obj.precision = normalLabelModel.get('precision');
        obj.defaultInterpolatedText = getDefaultText;
        obj.statesModels = labelStatesModels;
    }
}
function $6800dfcb6e1e2a44$export$dd6101605f5c186(textEl, dataIndex, data, animatableModel, labelFetcher) {
    var labelInnerStore = $6800dfcb6e1e2a44$export$f62786d3261ab0f4(textEl);
    if (!labelInnerStore.valueAnimation || labelInnerStore.prevValue === labelInnerStore.value) // Value not changed, no new label animation
    return;
    var defaultInterpolatedText = labelInnerStore.defaultInterpolatedText;
    // Consider the case that being animating, do not use the `obj.value`,
    // Otherwise it will jump to the `obj.value` when this new animation started.
    var currValue = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(labelInnerStore.interpolatedValue, labelInnerStore.prevValue);
    var targetValue = labelInnerStore.value;
    function during(percent) {
        var interpolated = (0, $76d619f648247e6d$export$bd0439821a1869f3)(data, labelInnerStore.precision, currValue, targetValue, percent);
        labelInnerStore.interpolatedValue = percent === 1 ? null : interpolated;
        var labelText = $6800dfcb6e1e2a44$var$getLabelText({
            labelDataIndex: dataIndex,
            labelFetcher: labelFetcher,
            defaultText: defaultInterpolatedText ? defaultInterpolatedText(interpolated) : interpolated + ''
        }, labelInnerStore.statesModels, interpolated);
        $6800dfcb6e1e2a44$export$b533918394a58529(textEl, labelText);
    }
    textEl.percent = 0;
    (labelInnerStore.prevValue == null ? (0, $8b353638fbedfefa$export$a121566aadcfe021) : (0, $8b353638fbedfefa$export$c8dce3c08436e91e))(textEl, {
        // percent is used to prevent animation from being aborted #15916
        percent: 1
    }, animatableModel, dataIndex, null, during);
}



var $a8b74de3c15b55c3$var$PATH_COLOR = [
    'textStyle',
    'color'
];
var $a8b74de3c15b55c3$var$textStyleParams = [
    'fontStyle',
    'fontWeight',
    'fontSize',
    'fontFamily',
    'padding',
    'lineHeight',
    'rich',
    'width',
    'height',
    'overflow'
];
// TODO Performance improvement?
var $a8b74de3c15b55c3$var$tmpText = new (0, $fe885cc21795562b$export$2e2bcd8739ae039)();
var $a8b74de3c15b55c3$var$TextStyleMixin = /** @class */ function() {
    function TextStyleMixin() {}
    /**
   * Get color property or get color from option.textStyle.color
   */ // TODO Callback
    TextStyleMixin.prototype.getTextColor = function(isEmphasis) {
        var ecModel = this.ecModel;
        return this.getShallow('color') || (!isEmphasis && ecModel ? ecModel.get($a8b74de3c15b55c3$var$PATH_COLOR) : null);
    };
    /**
   * Create font string from fontStyle, fontWeight, fontSize, fontFamily
   * @return {string}
   */ TextStyleMixin.prototype.getFont = function() {
        return (0, $6800dfcb6e1e2a44$export$155316a870a9d61e)({
            fontStyle: this.getShallow('fontStyle'),
            fontWeight: this.getShallow('fontWeight'),
            fontSize: this.getShallow('fontSize'),
            fontFamily: this.getShallow('fontFamily')
        }, this.ecModel);
    };
    TextStyleMixin.prototype.getTextRect = function(text) {
        var style = {
            text: text,
            verticalAlign: this.getShallow('verticalAlign') || this.getShallow('baseline')
        };
        for(var i = 0; i < $a8b74de3c15b55c3$var$textStyleParams.length; i++)style[$a8b74de3c15b55c3$var$textStyleParams[i]] = this.getShallow($a8b74de3c15b55c3$var$textStyleParams[i]);
        $a8b74de3c15b55c3$var$tmpText.useStyle(style);
        $a8b74de3c15b55c3$var$tmpText.update();
        return $a8b74de3c15b55c3$var$tmpText.getBoundingRect();
    };
    return TextStyleMixin;
}();
var $a8b74de3c15b55c3$export$2e2bcd8739ae039 = $a8b74de3c15b55c3$var$TextStyleMixin;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9c5206e1bd69e88f$export$9f34de5b59222949 = [
    [
        'lineWidth',
        'width'
    ],
    [
        'stroke',
        'color'
    ],
    [
        'opacity'
    ],
    [
        'shadowBlur'
    ],
    [
        'shadowOffsetX'
    ],
    [
        'shadowOffsetY'
    ],
    [
        'shadowColor'
    ],
    [
        'lineDash',
        'type'
    ],
    [
        'lineDashOffset',
        'dashOffset'
    ],
    [
        'lineCap',
        'cap'
    ],
    [
        'lineJoin',
        'join'
    ],
    [
        'miterLimit'
    ]
];
var $9c5206e1bd69e88f$var$getLineStyle = (0, $06542048a26d4d91$export$2e2bcd8739ae039)($9c5206e1bd69e88f$export$9f34de5b59222949);
var $9c5206e1bd69e88f$export$91eeeeed4a69a7e7 = /** @class */ function() {
    function LineStyleMixin() {}
    LineStyleMixin.prototype.getLineStyle = function(excludes) {
        return $9c5206e1bd69e88f$var$getLineStyle(this, excludes);
    };
    return LineStyleMixin;
}();


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $c42afdfd2f0ddc96$export$ffb0bba5dde0130b = [
    [
        'fill',
        'color'
    ],
    [
        'stroke',
        'borderColor'
    ],
    [
        'lineWidth',
        'borderWidth'
    ],
    [
        'opacity'
    ],
    [
        'shadowBlur'
    ],
    [
        'shadowOffsetX'
    ],
    [
        'shadowOffsetY'
    ],
    [
        'shadowColor'
    ],
    [
        'lineDash',
        'borderType'
    ],
    [
        'lineDashOffset',
        'borderDashOffset'
    ],
    [
        'lineCap',
        'borderCap'
    ],
    [
        'lineJoin',
        'borderJoin'
    ],
    [
        'miterLimit',
        'borderMiterLimit'
    ]
];
var $c42afdfd2f0ddc96$var$getItemStyle = (0, $06542048a26d4d91$export$2e2bcd8739ae039)($c42afdfd2f0ddc96$export$ffb0bba5dde0130b);
var $c42afdfd2f0ddc96$export$e4f01e48d6fda412 = /** @class */ function() {
    function ItemStyleMixin() {}
    ItemStyleMixin.prototype.getItemStyle = function(excludes, includes) {
        return $c42afdfd2f0ddc96$var$getItemStyle(this, excludes, includes);
    };
    return ItemStyleMixin;
}();



var $6818646a97528290$var$Model = /** @class */ function() {
    function Model(option, parentModel, ecModel) {
        this.parentModel = parentModel;
        this.ecModel = ecModel;
        this.option = option;
    // Simple optimization
    // if (this.init) {
    //     if (arguments.length <= 4) {
    //         this.init(option, parentModel, ecModel, extraOpt);
    //     }
    //     else {
    //         this.init.apply(this, arguments);
    //     }
    // }
    }
    Model.prototype.init = function(option, parentModel, ecModel) {
        var rest = [];
        for(var _i = 3; _i < arguments.length; _i++)rest[_i - 3] = arguments[_i];
    };
    /**
   * Merge the input option to me.
   */ Model.prototype.mergeOption = function(option, ecModel) {
        (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)(this.option, option, true);
    };
    // `path` can be 'a.b.c', so the return value type have to be `ModelOption`
    // TODO: TYPE strict key check?
    // get(path: string | string[], ignoreParent?: boolean): ModelOption;
    Model.prototype.get = function(path, ignoreParent) {
        if (path == null) return this.option;
        return this._doGet(this.parsePath(path), !ignoreParent && this.parentModel);
    };
    Model.prototype.getShallow = function(key, ignoreParent) {
        var option = this.option;
        var val = option == null ? option : option[key];
        if (val == null && !ignoreParent) {
            var parentModel = this.parentModel;
            if (parentModel) // FIXME:TS do not know how to make it works
            val = parentModel.getShallow(key);
        }
        return val;
    };
    // `path` can be 'a.b.c', so the return value type have to be `Model<ModelOption>`
    // getModel(path: string | string[], parentModel?: Model): Model;
    // TODO 'a.b.c' is deprecated
    Model.prototype.getModel = function(path, parentModel) {
        var hasPath = path != null;
        var pathFinal = hasPath ? this.parsePath(path) : null;
        var obj = hasPath ? this._doGet(pathFinal) : this.option;
        parentModel = parentModel || this.parentModel && this.parentModel.getModel(this.resolveParentPath(pathFinal));
        return new Model(obj, parentModel, this.ecModel);
    };
    /**
   * If model has option
   */ Model.prototype.isEmpty = function() {
        return this.option == null;
    };
    Model.prototype.restoreData = function() {};
    // Pending
    Model.prototype.clone = function() {
        var Ctor = this.constructor;
        return new Ctor((0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(this.option));
    };
    // setReadOnly(properties): void {
    // clazzUtil.setReadOnly(this, properties);
    // }
    // If path is null/undefined, return null/undefined.
    Model.prototype.parsePath = function(path) {
        if (typeof path === 'string') return path.split('.');
        return path;
    };
    // Resolve path for parent. Perhaps useful when parent use a different property.
    // Default to be a identity resolver.
    // Can be modified to a different resolver.
    Model.prototype.resolveParentPath = function(path) {
        return path;
    };
    // FIXME:TS check whether put this method here
    Model.prototype.isAnimationEnabled = function() {
        if (!(0, $ce6dd58693a21851$export$2e2bcd8739ae039).node && this.option) {
            if (this.option.animation != null) return !!this.option.animation;
            else if (this.parentModel) return this.parentModel.isAnimationEnabled();
        }
    };
    Model.prototype._doGet = function(pathArr, parentModel) {
        var obj = this.option;
        if (!pathArr) return obj;
        for(var i = 0; i < pathArr.length; i++){
            // Ignore empty
            if (!pathArr[i]) continue;
            // obj could be number/string/... (like 0)
            obj = obj && typeof obj === 'object' ? obj[pathArr[i]] : null;
            if (obj == null) break;
        }
        if (obj == null && parentModel) obj = parentModel._doGet(this.resolveParentPath(pathArr), parentModel.parentModel);
        return obj;
    };
    return Model;
}();
// Enable Model.extend.
(0, $cd5f95cf03b4e3e7$export$cd4c3a4dca301c70)($6818646a97528290$var$Model);
(0, $cd5f95cf03b4e3e7$export$e1aac4552ae82081)($6818646a97528290$var$Model);
(0, $7a1bd9c2710fea0d$export$e36fc9d62a853069)($6818646a97528290$var$Model, (0, $9c5206e1bd69e88f$export$91eeeeed4a69a7e7));
(0, $7a1bd9c2710fea0d$export$e36fc9d62a853069)($6818646a97528290$var$Model, (0, $c42afdfd2f0ddc96$export$e4f01e48d6fda412));
(0, $7a1bd9c2710fea0d$export$e36fc9d62a853069)($6818646a97528290$var$Model, (0, $cb2a96727da5284d$export$a3a0ed7e2dd84c9e));
(0, $7a1bd9c2710fea0d$export$e36fc9d62a853069)($6818646a97528290$var$Model, (0, $a8b74de3c15b55c3$export$2e2bcd8739ae039));
var $6818646a97528290$export$2e2bcd8739ae039 = $6818646a97528290$var$Model;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


// A random offset
var $5370df662b2caf37$var$base = Math.round(Math.random() * 10);
function $5370df662b2caf37$export$6d2b3473b0986646(type) {
    // Considering the case of crossing js context,
    // use Math.random to make id as unique as possible.
    return [
        type || '',
        $5370df662b2caf37$var$base++
    ].join('_');
}
function $5370df662b2caf37$export$b9faf30b7d655a6f(target) {
    var subTypeDefaulters = {};
    target.registerSubTypeDefaulter = function(componentType, defaulter) {
        var componentTypeInfo = (0, $cd5f95cf03b4e3e7$export$fbe18865d303bf01)(componentType);
        subTypeDefaulters[componentTypeInfo.main] = defaulter;
    };
    target.determineSubType = function(componentType, option) {
        var type = option.type;
        if (!type) {
            var componentTypeMain = (0, $cd5f95cf03b4e3e7$export$fbe18865d303bf01)(componentType).main;
            if (target.hasSubTypes(componentType) && subTypeDefaulters[componentTypeMain]) type = subTypeDefaulters[componentTypeMain](option);
        }
        return type;
    };
}
function $5370df662b2caf37$export$ce592d345a3ec040(entity, dependencyGetter) {
    /**
   * @param targetNameList Target Component type list.
   *                       Can be ['aa', 'bb', 'aa.xx']
   * @param fullNameList By which we can build dependency graph.
   * @param callback Params: componentType, dependencies.
   * @param context Scope of callback.
   */ entity.topologicalTravel = function(targetNameList, fullNameList, callback, context) {
        if (!targetNameList.length) return;
        var result = makeDepndencyGraph(fullNameList);
        var graph = result.graph;
        var noEntryList = result.noEntryList;
        var targetNameSet = {};
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(targetNameList, function(name) {
            targetNameSet[name] = true;
        });
        while(noEntryList.length){
            var currComponentType = noEntryList.pop();
            var currVertex = graph[currComponentType];
            var isInTargetNameSet = !!targetNameSet[currComponentType];
            if (isInTargetNameSet) {
                callback.call(context, currComponentType, currVertex.originalDeps.slice());
                delete targetNameSet[currComponentType];
            }
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(currVertex.successor, isInTargetNameSet ? removeEdgeAndAdd : removeEdge);
        }
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(targetNameSet, function() {
            var errMsg = '';
            throw new Error(errMsg);
        });
        function removeEdge(succComponentType) {
            graph[succComponentType].entryCount--;
            if (graph[succComponentType].entryCount === 0) noEntryList.push(succComponentType);
        }
        // Consider this case: legend depends on series, and we call
        // chart.setOption({series: [...]}), where only series is in option.
        // If we do not have 'removeEdgeAndAdd', legendModel.mergeOption will
        // not be called, but only sereis.mergeOption is called. Thus legend
        // have no chance to update its local record about series (like which
        // name of series is available in legend).
        function removeEdgeAndAdd(succComponentType) {
            targetNameSet[succComponentType] = true;
            removeEdge(succComponentType);
        }
    };
    function makeDepndencyGraph(fullNameList) {
        var graph = {};
        var noEntryList = [];
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(fullNameList, function(name) {
            var thisItem = createDependencyGraphItem(graph, name);
            var originalDeps = thisItem.originalDeps = dependencyGetter(name);
            var availableDeps = getAvailableDependencies(originalDeps, fullNameList);
            thisItem.entryCount = availableDeps.length;
            if (thisItem.entryCount === 0) noEntryList.push(name);
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(availableDeps, function(dependentName) {
                if ($7a1bd9c2710fea0d$export$305f7d4e9d4624f2(thisItem.predecessor, dependentName) < 0) thisItem.predecessor.push(dependentName);
                var thatItem = createDependencyGraphItem(graph, dependentName);
                if ($7a1bd9c2710fea0d$export$305f7d4e9d4624f2(thatItem.successor, dependentName) < 0) thatItem.successor.push(name);
            });
        });
        return {
            graph: graph,
            noEntryList: noEntryList
        };
    }
    function createDependencyGraphItem(graph, name) {
        if (!graph[name]) graph[name] = {
            predecessor: [],
            successor: []
        };
        return graph[name];
    }
    function getAvailableDependencies(originalDeps, fullNameList) {
        var availableDeps = [];
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(originalDeps, function(dep) {
            $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(fullNameList, dep) >= 0 && availableDeps.push(dep);
        });
        return availableDeps;
    }
}
function $5370df662b2caf37$export$68acc510e46fef2(superOption, subOption) {
    // See also `model/Component.ts#getDefaultOption`
    return $7a1bd9c2710fea0d$export$4950aa0f605343fb($7a1bd9c2710fea0d$export$4950aa0f605343fb({}, superOption, true), subOption, true);
}




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Layout helpers for each component positioning



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */ /**
 * Language: English.
 */ var $af0c4f5df0270dd8$export$2e2bcd8739ae039 = {
    time: {
        month: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ],
        monthAbbr: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
        ],
        dayOfWeek: [
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday'
        ],
        dayOfWeekAbbr: [
            'Sun',
            'Mon',
            'Tue',
            'Wed',
            'Thu',
            'Fri',
            'Sat'
        ]
    },
    legend: {
        selector: {
            all: 'All',
            inverse: 'Inv'
        }
    },
    toolbox: {
        brush: {
            title: {
                rect: 'Box Select',
                polygon: 'Lasso Select',
                lineX: 'Horizontally Select',
                lineY: 'Vertically Select',
                keep: 'Keep Selections',
                clear: 'Clear Selections'
            }
        },
        dataView: {
            title: 'Data View',
            lang: [
                'Data View',
                'Close',
                'Refresh'
            ]
        },
        dataZoom: {
            title: {
                zoom: 'Zoom',
                back: 'Zoom Reset'
            }
        },
        magicType: {
            title: {
                line: 'Switch to Line Chart',
                bar: 'Switch to Bar Chart',
                stack: 'Stack',
                tiled: 'Tile'
            }
        },
        restore: {
            title: 'Restore'
        },
        saveAsImage: {
            title: 'Save as Image',
            lang: [
                'Right Click to Save Image'
            ]
        }
    },
    series: {
        typeNames: {
            pie: 'Pie chart',
            bar: 'Bar chart',
            line: 'Line chart',
            scatter: 'Scatter plot',
            effectScatter: 'Ripple scatter plot',
            radar: 'Radar chart',
            tree: 'Tree',
            treemap: 'Treemap',
            boxplot: 'Boxplot',
            candlestick: 'Candlestick',
            k: 'K line chart',
            heatmap: 'Heat map',
            map: 'Map',
            parallel: 'Parallel coordinate map',
            lines: 'Line graph',
            graph: 'Relationship graph',
            sankey: 'Sankey diagram',
            funnel: 'Funnel chart',
            gauge: 'Gauge',
            pictorialBar: 'Pictorial bar',
            themeRiver: 'Theme River Map',
            sunburst: 'Sunburst',
            custom: 'Custom chart',
            chart: 'Chart'
        }
    },
    aria: {
        general: {
            withTitle: 'This is a chart about "{title}"',
            withoutTitle: 'This is a chart'
        },
        series: {
            single: {
                prefix: '',
                withName: ' with type {seriesType} named {seriesName}.',
                withoutName: ' with type {seriesType}.'
            },
            multiple: {
                prefix: '. It consists of {seriesCount} series count.',
                withName: ' The {seriesId} series is a {seriesType} representing {seriesName}.',
                withoutName: ' The {seriesId} series is a {seriesType}.',
                separator: {
                    middle: '',
                    end: ''
                }
            }
        },
        data: {
            allData: 'The data is as follows: ',
            partialData: 'The first {displayCnt} items are: ',
            withName: 'the data for {name} is {value}',
            withoutName: '{value}',
            separator: {
                middle: ', ',
                end: '. '
            }
        }
    }
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */ var $b3a62bfb11b19829$export$2e2bcd8739ae039 = {
    time: {
        month: [
            "\u4E00\u6708",
            "\u4E8C\u6708",
            "\u4E09\u6708",
            "\u56DB\u6708",
            "\u4E94\u6708",
            "\u516D\u6708",
            "\u4E03\u6708",
            "\u516B\u6708",
            "\u4E5D\u6708",
            "\u5341\u6708",
            "\u5341\u4E00\u6708",
            "\u5341\u4E8C\u6708"
        ],
        monthAbbr: [
            "1\u6708",
            "2\u6708",
            "3\u6708",
            "4\u6708",
            "5\u6708",
            "6\u6708",
            "7\u6708",
            "8\u6708",
            "9\u6708",
            "10\u6708",
            "11\u6708",
            "12\u6708"
        ],
        dayOfWeek: [
            "\u661F\u671F\u65E5",
            "\u661F\u671F\u4E00",
            "\u661F\u671F\u4E8C",
            "\u661F\u671F\u4E09",
            "\u661F\u671F\u56DB",
            "\u661F\u671F\u4E94",
            "\u661F\u671F\u516D"
        ],
        dayOfWeekAbbr: [
            "\u65E5",
            "\u4E00",
            "\u4E8C",
            "\u4E09",
            "\u56DB",
            "\u4E94",
            "\u516D"
        ]
    },
    legend: {
        selector: {
            all: "\u5168\u9009",
            inverse: "\u53CD\u9009"
        }
    },
    toolbox: {
        brush: {
            title: {
                rect: "\u77E9\u5F62\u9009\u62E9",
                polygon: "\u5708\u9009",
                lineX: "\u6A2A\u5411\u9009\u62E9",
                lineY: "\u7EB5\u5411\u9009\u62E9",
                keep: "\u4FDD\u6301\u9009\u62E9",
                clear: "\u6E05\u9664\u9009\u62E9"
            }
        },
        dataView: {
            title: "\u6570\u636E\u89C6\u56FE",
            lang: [
                "\u6570\u636E\u89C6\u56FE",
                "\u5173\u95ED",
                "\u5237\u65B0"
            ]
        },
        dataZoom: {
            title: {
                zoom: "\u533A\u57DF\u7F29\u653E",
                back: "\u533A\u57DF\u7F29\u653E\u8FD8\u539F"
            }
        },
        magicType: {
            title: {
                line: "\u5207\u6362\u4E3A\u6298\u7EBF\u56FE",
                bar: "\u5207\u6362\u4E3A\u67F1\u72B6\u56FE",
                stack: "\u5207\u6362\u4E3A\u5806\u53E0",
                tiled: "\u5207\u6362\u4E3A\u5E73\u94FA"
            }
        },
        restore: {
            title: "\u8FD8\u539F"
        },
        saveAsImage: {
            title: "\u4FDD\u5B58\u4E3A\u56FE\u7247",
            lang: [
                "\u53F3\u952E\u53E6\u5B58\u4E3A\u56FE\u7247"
            ]
        }
    },
    series: {
        typeNames: {
            pie: "\u997C\u56FE",
            bar: "\u67F1\u72B6\u56FE",
            line: "\u6298\u7EBF\u56FE",
            scatter: "\u6563\u70B9\u56FE",
            effectScatter: "\u6D9F\u6F2A\u6563\u70B9\u56FE",
            radar: "\u96F7\u8FBE\u56FE",
            tree: "\u6811\u56FE",
            treemap: "\u77E9\u5F62\u6811\u56FE",
            boxplot: "\u7BB1\u578B\u56FE",
            candlestick: "K\u7EBF\u56FE",
            k: "K\u7EBF\u56FE",
            heatmap: "\u70ED\u529B\u56FE",
            map: "\u5730\u56FE",
            parallel: "\u5E73\u884C\u5750\u6807\u56FE",
            lines: "\u7EBF\u56FE",
            graph: "\u5173\u7CFB\u56FE",
            sankey: "\u6851\u57FA\u56FE",
            funnel: "\u6F0F\u6597\u56FE",
            gauge: "\u4EEA\u8868\u76D8\u56FE",
            pictorialBar: "\u8C61\u5F62\u67F1\u56FE",
            themeRiver: "\u4E3B\u9898\u6CB3\u6D41\u56FE",
            sunburst: "\u65ED\u65E5\u56FE",
            custom: "\u81EA\u5B9A\u4E49\u56FE\u8868",
            chart: "\u56FE\u8868"
        }
    },
    aria: {
        general: {
            withTitle: "\u8FD9\u662F\u4E00\u4E2A\u5173\u4E8E\u201C{title}\u201D\u7684\u56FE\u8868\u3002",
            withoutTitle: "\u8FD9\u662F\u4E00\u4E2A\u56FE\u8868\uFF0C"
        },
        series: {
            single: {
                prefix: '',
                withName: "\u56FE\u8868\u7C7B\u578B\u662F{seriesType}\uFF0C\u8868\u793A{seriesName}\u3002",
                withoutName: "\u56FE\u8868\u7C7B\u578B\u662F{seriesType}\u3002"
            },
            multiple: {
                prefix: "\u5B83\u7531{seriesCount}\u4E2A\u56FE\u8868\u7CFB\u5217\u7EC4\u6210\u3002",
                withName: "\u7B2C{seriesId}\u4E2A\u7CFB\u5217\u662F\u4E00\u4E2A\u8868\u793A{seriesName}\u7684{seriesType}\uFF0C",
                withoutName: "\u7B2C{seriesId}\u4E2A\u7CFB\u5217\u662F\u4E00\u4E2A{seriesType}\uFF0C",
                separator: {
                    middle: "\uFF1B",
                    end: "\u3002"
                }
            }
        },
        data: {
            allData: "\u5176\u6570\u636E\u662F\u2014\u2014",
            partialData: "\u5176\u4E2D\uFF0C\u524D{displayCnt}\u9879\u662F\u2014\u2014",
            withName: "{name}\u7684\u6570\u636E\u662F{value}",
            withoutName: '{value}',
            separator: {
                middle: "\uFF0C",
                end: ''
            }
        }
    }
};



var $9b0a1ef4bcc91e7d$var$LOCALE_ZH = 'ZH';
var $9b0a1ef4bcc91e7d$var$LOCALE_EN = 'EN';
var $9b0a1ef4bcc91e7d$var$DEFAULT_LOCALE = $9b0a1ef4bcc91e7d$var$LOCALE_EN;
var $9b0a1ef4bcc91e7d$var$localeStorage = {};
var $9b0a1ef4bcc91e7d$var$localeModels = {};
var $9b0a1ef4bcc91e7d$export$9a2147b3808d4c6b = !(0, $ce6dd58693a21851$export$2e2bcd8739ae039).domSupported ? $9b0a1ef4bcc91e7d$var$DEFAULT_LOCALE : function() {
    var langStr = /* eslint-disable-next-line */ (document.documentElement.lang || navigator.language || navigator.browserLanguage || $9b0a1ef4bcc91e7d$var$DEFAULT_LOCALE).toUpperCase();
    return langStr.indexOf($9b0a1ef4bcc91e7d$var$LOCALE_ZH) > -1 ? $9b0a1ef4bcc91e7d$var$LOCALE_ZH : $9b0a1ef4bcc91e7d$var$DEFAULT_LOCALE;
}();
function $9b0a1ef4bcc91e7d$export$bab6a7822cc1e2cd(locale, localeObj) {
    locale = locale.toUpperCase();
    $9b0a1ef4bcc91e7d$var$localeModels[locale] = new (0, $6818646a97528290$export$2e2bcd8739ae039)(localeObj);
    $9b0a1ef4bcc91e7d$var$localeStorage[locale] = localeObj;
}
function $9b0a1ef4bcc91e7d$export$ddc371781a6af754(locale) {
    if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(locale)) {
        var localeObj = $9b0a1ef4bcc91e7d$var$localeStorage[locale.toUpperCase()] || {};
        if (locale === $9b0a1ef4bcc91e7d$var$LOCALE_ZH || locale === $9b0a1ef4bcc91e7d$var$LOCALE_EN) return (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(localeObj);
        else return (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)((0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(localeObj), (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)($9b0a1ef4bcc91e7d$var$localeStorage[$9b0a1ef4bcc91e7d$var$DEFAULT_LOCALE]), false);
    } else return (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)((0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(locale), (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)($9b0a1ef4bcc91e7d$var$localeStorage[$9b0a1ef4bcc91e7d$var$DEFAULT_LOCALE]), false);
}
function $9b0a1ef4bcc91e7d$export$37cc638e0e11865f(lang) {
    return $9b0a1ef4bcc91e7d$var$localeModels[lang];
}
function $9b0a1ef4bcc91e7d$export$1188f179b2597821() {
    return $9b0a1ef4bcc91e7d$var$localeModels[$9b0a1ef4bcc91e7d$var$DEFAULT_LOCALE];
}
// Default locale
$9b0a1ef4bcc91e7d$export$bab6a7822cc1e2cd($9b0a1ef4bcc91e7d$var$LOCALE_EN, (0, $af0c4f5df0270dd8$export$2e2bcd8739ae039));
$9b0a1ef4bcc91e7d$export$bab6a7822cc1e2cd($9b0a1ef4bcc91e7d$var$LOCALE_ZH, (0, $b3a62bfb11b19829$export$2e2bcd8739ae039));



var $0ae0381fb3fd176f$export$32c0454ceff7f92d = 1000;
var $0ae0381fb3fd176f$export$35acaebf644db34e = $0ae0381fb3fd176f$export$32c0454ceff7f92d * 60;
var $0ae0381fb3fd176f$export$82541edf19e5e3b0 = $0ae0381fb3fd176f$export$35acaebf644db34e * 60;
var $0ae0381fb3fd176f$export$a97a1358cbb650ab = $0ae0381fb3fd176f$export$82541edf19e5e3b0 * 24;
var $0ae0381fb3fd176f$export$99cafda57477293d = $0ae0381fb3fd176f$export$a97a1358cbb650ab * 365;
var $0ae0381fb3fd176f$export$f7854271ddbda64e = {
    year: '{yyyy}',
    month: '{MMM}',
    day: '{d}',
    hour: '{HH}:{mm}',
    minute: '{HH}:{mm}',
    second: '{HH}:{mm}:{ss}',
    millisecond: '{HH}:{mm}:{ss} {SSS}',
    none: '{yyyy}-{MM}-{dd} {HH}:{mm}:{ss} {SSS}'
};
var $0ae0381fb3fd176f$var$fullDayFormatter = '{yyyy}-{MM}-{dd}';
var $0ae0381fb3fd176f$export$445bdbd8d2334e40 = {
    year: '{yyyy}',
    month: '{yyyy}-{MM}',
    day: $0ae0381fb3fd176f$var$fullDayFormatter,
    hour: $0ae0381fb3fd176f$var$fullDayFormatter + ' ' + $0ae0381fb3fd176f$export$f7854271ddbda64e.hour,
    minute: $0ae0381fb3fd176f$var$fullDayFormatter + ' ' + $0ae0381fb3fd176f$export$f7854271ddbda64e.minute,
    second: $0ae0381fb3fd176f$var$fullDayFormatter + ' ' + $0ae0381fb3fd176f$export$f7854271ddbda64e.second,
    millisecond: $0ae0381fb3fd176f$export$f7854271ddbda64e.none
};
var $0ae0381fb3fd176f$export$87100da04d711986 = [
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'millisecond'
];
var $0ae0381fb3fd176f$export$833c398a55654bb7 = [
    'year',
    'half-year',
    'quarter',
    'month',
    'week',
    'half-week',
    'day',
    'half-day',
    'quarter-day',
    'hour',
    'minute',
    'second',
    'millisecond'
];
function $0ae0381fb3fd176f$export$5d04458e2a6c373e(str, len) {
    str += '';
    return '0000'.substr(0, len - str.length) + str;
}
function $0ae0381fb3fd176f$export$1da4b91a25d7e1c8(timeUnit) {
    switch(timeUnit){
        case 'half-year':
        case 'quarter':
            return 'month';
        case 'week':
        case 'half-week':
            return 'day';
        case 'half-day':
        case 'quarter-day':
            return 'hour';
        default:
            // year, minutes, second, milliseconds
            return timeUnit;
    }
}
function $0ae0381fb3fd176f$export$beb5920b69c13da(timeUnit) {
    return timeUnit === $0ae0381fb3fd176f$export$1da4b91a25d7e1c8(timeUnit);
}
function $0ae0381fb3fd176f$export$124c820721c4f66b(timeUnit) {
    switch(timeUnit){
        case 'year':
        case 'month':
            return 'day';
        case 'millisecond':
            return 'millisecond';
        default:
            // Also for day, hour, minute, second
            return 'second';
    }
}
function $0ae0381fb3fd176f$export$d9468344d3651243(// Note: The result based on `isUTC` are totally different, which can not be just simply
// substituted by the result without `isUTC`. So we make the param `isUTC` mandatory.
time, template, isUTC, lang) {
    var date = $cfc1f3b422a3185f$export$6b862160d295c8e(time);
    var y = date[$0ae0381fb3fd176f$export$8d046fefed9a548e(isUTC)]();
    var M = date[$0ae0381fb3fd176f$export$5c242a801a23eec7(isUTC)]() + 1;
    var q = Math.floor((M - 1) / 3) + 1;
    var d = date[$0ae0381fb3fd176f$export$4189e6cbc9753260(isUTC)]();
    var e = date['get' + (isUTC ? 'UTC' : '') + 'Day']();
    var H = date[$0ae0381fb3fd176f$export$8b40b55b3c06cbe2(isUTC)]();
    var h = (H - 1) % 12 + 1;
    var m = date[$0ae0381fb3fd176f$export$8807847c5c71eded(isUTC)]();
    var s = date[$0ae0381fb3fd176f$export$8f49e73e2eebd168(isUTC)]();
    var S = date[$0ae0381fb3fd176f$export$312207a92d041116(isUTC)]();
    var a = H >= 12 ? 'pm' : 'am';
    var A = a.toUpperCase();
    var localeModel = lang instanceof (0, $6818646a97528290$export$2e2bcd8739ae039) ? lang : (0, $9b0a1ef4bcc91e7d$export$37cc638e0e11865f)(lang || (0, $9b0a1ef4bcc91e7d$export$9a2147b3808d4c6b)) || (0, $9b0a1ef4bcc91e7d$export$1188f179b2597821)();
    var timeModel = localeModel.getModel('time');
    var month = timeModel.get('month');
    var monthAbbr = timeModel.get('monthAbbr');
    var dayOfWeek = timeModel.get('dayOfWeek');
    var dayOfWeekAbbr = timeModel.get('dayOfWeekAbbr');
    return (template || '').replace(/{a}/g, a + '').replace(/{A}/g, A + '').replace(/{yyyy}/g, y + '').replace(/{yy}/g, $0ae0381fb3fd176f$export$5d04458e2a6c373e(y % 100 + '', 2)).replace(/{Q}/g, q + '').replace(/{MMMM}/g, month[M - 1]).replace(/{MMM}/g, monthAbbr[M - 1]).replace(/{MM}/g, $0ae0381fb3fd176f$export$5d04458e2a6c373e(M, 2)).replace(/{M}/g, M + '').replace(/{dd}/g, $0ae0381fb3fd176f$export$5d04458e2a6c373e(d, 2)).replace(/{d}/g, d + '').replace(/{eeee}/g, dayOfWeek[e]).replace(/{ee}/g, dayOfWeekAbbr[e]).replace(/{e}/g, e + '').replace(/{HH}/g, $0ae0381fb3fd176f$export$5d04458e2a6c373e(H, 2)).replace(/{H}/g, H + '').replace(/{hh}/g, $0ae0381fb3fd176f$export$5d04458e2a6c373e(h + '', 2)).replace(/{h}/g, h + '').replace(/{mm}/g, $0ae0381fb3fd176f$export$5d04458e2a6c373e(m, 2)).replace(/{m}/g, m + '').replace(/{ss}/g, $0ae0381fb3fd176f$export$5d04458e2a6c373e(s, 2)).replace(/{s}/g, s + '').replace(/{SSS}/g, $0ae0381fb3fd176f$export$5d04458e2a6c373e(S, 3)).replace(/{S}/g, S + '');
}
function $0ae0381fb3fd176f$export$fe777b6293828b5d(tick, idx, formatter, lang, isUTC) {
    var template = null;
    if ($7a1bd9c2710fea0d$export$844ec244b1367d54(formatter)) // Single formatter for all units at all levels
    template = formatter;
    else if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(formatter)) // Callback formatter
    template = formatter(tick.value, idx, {
        level: tick.level
    });
    else {
        var defaults = $7a1bd9c2710fea0d$export$8b58be045bf06082({}, $0ae0381fb3fd176f$export$f7854271ddbda64e);
        if (tick.level > 0) for(var i = 0; i < $0ae0381fb3fd176f$export$87100da04d711986.length; ++i)defaults[$0ae0381fb3fd176f$export$87100da04d711986[i]] = "{primary|" + defaults[$0ae0381fb3fd176f$export$87100da04d711986[i]] + "}";
        var mergedFormatter = formatter ? formatter.inherit === false ? formatter // Use formatter with bigger units
         : $7a1bd9c2710fea0d$export$ebe90cb607ad99e(formatter, defaults) : defaults;
        var unit = $0ae0381fb3fd176f$export$4dfb0417ad6555b7(tick.value, isUTC);
        if (mergedFormatter[unit]) template = mergedFormatter[unit];
        else if (mergedFormatter.inherit) {
            // Unit formatter is not defined and should inherit from bigger units
            var targetId = $0ae0381fb3fd176f$export$833c398a55654bb7.indexOf(unit);
            for(var i = targetId - 1; i >= 0; --i)if (mergedFormatter[unit]) {
                template = mergedFormatter[unit];
                break;
            }
            template = template || defaults.none;
        }
        if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(template)) {
            var levelId = tick.level == null ? 0 : tick.level >= 0 ? tick.level : template.length + tick.level;
            levelId = Math.min(levelId, template.length - 1);
            template = template[levelId];
        }
    }
    return $0ae0381fb3fd176f$export$d9468344d3651243(new Date(tick.value), template, isUTC, lang);
}
function $0ae0381fb3fd176f$export$4dfb0417ad6555b7(value, isUTC) {
    var date = $cfc1f3b422a3185f$export$6b862160d295c8e(value);
    var M = date[$0ae0381fb3fd176f$export$5c242a801a23eec7(isUTC)]() + 1;
    var d = date[$0ae0381fb3fd176f$export$4189e6cbc9753260(isUTC)]();
    var h = date[$0ae0381fb3fd176f$export$8b40b55b3c06cbe2(isUTC)]();
    var m = date[$0ae0381fb3fd176f$export$8807847c5c71eded(isUTC)]();
    var s = date[$0ae0381fb3fd176f$export$8f49e73e2eebd168(isUTC)]();
    var S = date[$0ae0381fb3fd176f$export$312207a92d041116(isUTC)]();
    var isSecond = S === 0;
    var isMinute = isSecond && s === 0;
    var isHour = isMinute && m === 0;
    var isDay = isHour && h === 0;
    var isMonth = isDay && d === 1;
    var isYear = isMonth && M === 1;
    if (isYear) return 'year';
    else if (isMonth) return 'month';
    else if (isDay) return 'day';
    else if (isHour) return 'hour';
    else if (isMinute) return 'minute';
    else if (isSecond) return 'second';
    else return 'millisecond';
}
function $0ae0381fb3fd176f$export$e04e41a1e24ffd3f(value, unit, isUTC) {
    var date = $7a1bd9c2710fea0d$export$7e4aa119212bc614(value) ? $cfc1f3b422a3185f$export$6b862160d295c8e(value) : value;
    unit = unit || $0ae0381fb3fd176f$export$4dfb0417ad6555b7(value, isUTC);
    switch(unit){
        case 'year':
            return date[$0ae0381fb3fd176f$export$8d046fefed9a548e(isUTC)]();
        case 'half-year':
            return date[$0ae0381fb3fd176f$export$5c242a801a23eec7(isUTC)]() >= 6 ? 1 : 0;
        case 'quarter':
            return Math.floor((date[$0ae0381fb3fd176f$export$5c242a801a23eec7(isUTC)]() + 1) / 4);
        case 'month':
            return date[$0ae0381fb3fd176f$export$5c242a801a23eec7(isUTC)]();
        case 'day':
            return date[$0ae0381fb3fd176f$export$4189e6cbc9753260(isUTC)]();
        case 'half-day':
            return date[$0ae0381fb3fd176f$export$8b40b55b3c06cbe2(isUTC)]() / 24;
        case 'hour':
            return date[$0ae0381fb3fd176f$export$8b40b55b3c06cbe2(isUTC)]();
        case 'minute':
            return date[$0ae0381fb3fd176f$export$8807847c5c71eded(isUTC)]();
        case 'second':
            return date[$0ae0381fb3fd176f$export$8f49e73e2eebd168(isUTC)]();
        case 'millisecond':
            return date[$0ae0381fb3fd176f$export$312207a92d041116(isUTC)]();
    }
}
function $0ae0381fb3fd176f$export$8d046fefed9a548e(isUTC) {
    return isUTC ? 'getUTCFullYear' : 'getFullYear';
}
function $0ae0381fb3fd176f$export$5c242a801a23eec7(isUTC) {
    return isUTC ? 'getUTCMonth' : 'getMonth';
}
function $0ae0381fb3fd176f$export$4189e6cbc9753260(isUTC) {
    return isUTC ? 'getUTCDate' : 'getDate';
}
function $0ae0381fb3fd176f$export$8b40b55b3c06cbe2(isUTC) {
    return isUTC ? 'getUTCHours' : 'getHours';
}
function $0ae0381fb3fd176f$export$8807847c5c71eded(isUTC) {
    return isUTC ? 'getUTCMinutes' : 'getMinutes';
}
function $0ae0381fb3fd176f$export$8f49e73e2eebd168(isUTC) {
    return isUTC ? 'getUTCSeconds' : 'getSeconds';
}
function $0ae0381fb3fd176f$export$312207a92d041116(isUTC) {
    return isUTC ? 'getUTCMilliseconds' : 'getMilliseconds';
}
function $0ae0381fb3fd176f$export$43fbeac90913b151(isUTC) {
    return isUTC ? 'setUTCFullYear' : 'setFullYear';
}
function $0ae0381fb3fd176f$export$233f59998ed71c09(isUTC) {
    return isUTC ? 'setUTCMonth' : 'setMonth';
}
function $0ae0381fb3fd176f$export$82fd379a67f37fa0(isUTC) {
    return isUTC ? 'setUTCDate' : 'setDate';
}
function $0ae0381fb3fd176f$export$b6f943e8d23c15bb(isUTC) {
    return isUTC ? 'setUTCHours' : 'setHours';
}
function $0ae0381fb3fd176f$export$50303078793fc7d(isUTC) {
    return isUTC ? 'setUTCMinutes' : 'setMinutes';
}
function $0ae0381fb3fd176f$export$a4a908acda9c3118(isUTC) {
    return isUTC ? 'setUTCSeconds' : 'setSeconds';
}
function $0ae0381fb3fd176f$export$c047afab75f6d84(isUTC) {
    return isUTC ? 'setUTCMilliseconds' : 'setMilliseconds';
}





function $c84c9521536c601a$export$b6fe44657ce35c42(x) {
    if (!(0, $cfc1f3b422a3185f$export$e90fb89750dba83f)(x)) return $7a1bd9c2710fea0d$export$844ec244b1367d54(x) ? x : '-';
    var parts = (x + '').split('.');
    return parts[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, '$1,') + (parts.length > 1 ? '.' + parts[1] : '');
}
function $c84c9521536c601a$export$86f54f62aa7a7514(str, upperCaseFirst) {
    str = (str || '').toLowerCase().replace(/-(.)/g, function(match, group1) {
        return group1.toUpperCase();
    });
    if (upperCaseFirst && str) str = str.charAt(0).toUpperCase() + str.slice(1);
    return str;
}
var $c84c9521536c601a$export$f3a38102c49f4268 = $7a1bd9c2710fea0d$export$f3a38102c49f4268;
function $c84c9521536c601a$export$3cd8db88714decfc(value, valueType, useUTC) {
    var USER_READABLE_DEFUALT_TIME_PATTERN = '{yyyy}-{MM}-{dd} {HH}:{mm}:{ss}';
    function stringToUserReadable(str) {
        return str && $7a1bd9c2710fea0d$export$87c2784dc9fc4ab(str) ? str : '-';
    }
    function isNumberUserReadable(num) {
        return !!(num != null && !isNaN(num) && isFinite(num));
    }
    var isTypeTime = valueType === 'time';
    var isValueDate = value instanceof Date;
    if (isTypeTime || isValueDate) {
        var date = isTypeTime ? (0, $cfc1f3b422a3185f$export$6b862160d295c8e)(value) : value;
        if (!isNaN(+date)) return (0, $0ae0381fb3fd176f$export$d9468344d3651243)(date, USER_READABLE_DEFUALT_TIME_PATTERN, useUTC);
        else if (isValueDate) return '-';
    // In other cases, continue to try to display the value in the following code.
    }
    if (valueType === 'ordinal') return $7a1bd9c2710fea0d$export$29d0bb2a4e07b252(value) ? stringToUserReadable(value) : $7a1bd9c2710fea0d$export$7e4aa119212bc614(value) ? isNumberUserReadable(value) ? value + '' : '-' : '-';
    // By default.
    var numericResult = (0, $cfc1f3b422a3185f$export$8b4007b942b45a96)(value);
    return isNumberUserReadable(numericResult) ? $c84c9521536c601a$export$b6fe44657ce35c42(numericResult) : $7a1bd9c2710fea0d$export$29d0bb2a4e07b252(value) ? stringToUserReadable(value) : typeof value === 'boolean' ? value + '' : '-';
}
var $c84c9521536c601a$var$TPL_VAR_ALIAS = [
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g'
];
var $c84c9521536c601a$var$wrapVar = function(varName, seriesIdx) {
    return '{' + varName + (seriesIdx == null ? '' : seriesIdx) + '}';
};
function $c84c9521536c601a$export$2028496a35766e41(tpl, paramsList, encode) {
    if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(paramsList)) paramsList = [
        paramsList
    ];
    var seriesLen = paramsList.length;
    if (!seriesLen) return '';
    var $vars = paramsList[0].$vars || [];
    for(var i = 0; i < $vars.length; i++){
        var alias = $c84c9521536c601a$var$TPL_VAR_ALIAS[i];
        tpl = tpl.replace($c84c9521536c601a$var$wrapVar(alias), $c84c9521536c601a$var$wrapVar(alias, 0));
    }
    for(var seriesIdx = 0; seriesIdx < seriesLen; seriesIdx++)for(var k = 0; k < $vars.length; k++){
        var val = paramsList[seriesIdx][$vars[k]];
        tpl = tpl.replace($c84c9521536c601a$var$wrapVar($c84c9521536c601a$var$TPL_VAR_ALIAS[k], seriesIdx), encode ? (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(val) : val);
    }
    return tpl;
}
function $c84c9521536c601a$export$2fa08233ee42f8e1(tpl, param, encode) {
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(param, function(value, key) {
        tpl = tpl.replace('{' + key + '}', encode ? (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(value) : value);
    });
    return tpl;
}
function $c84c9521536c601a$export$1987a3dbdf3c45ca(inOpt, extraCssText) {
    var opt = $7a1bd9c2710fea0d$export$844ec244b1367d54(inOpt) ? {
        color: inOpt,
        extraCssText: extraCssText
    } : inOpt || {};
    var color = opt.color;
    var type = opt.type;
    extraCssText = opt.extraCssText;
    var renderMode = opt.renderMode || 'html';
    if (!color) return '';
    if (renderMode === 'html') return type === 'subItem' ? '<span style="display:inline-block;vertical-align:middle;margin-right:8px;margin-left:3px;border-radius:4px;width:4px;height:4px;background-color:' + (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(color) + ';' + (extraCssText || '') + '"></span>' : '<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:' + (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(color) + ';' + (extraCssText || '') + '"></span>';
    else {
        // Should better not to auto generate style name by auto-increment number here.
        // Because this util is usually called in tooltip formatter, which is probably
        // called repeatedly when mouse move and the auto-increment number increases fast.
        // Users can make their own style name by theirselves, make it unique and readable.
        var markerId = opt.markerId || 'markerX';
        return {
            renderMode: renderMode,
            content: '{' + markerId + '|}  ',
            style: type === 'subItem' ? {
                width: 4,
                height: 4,
                borderRadius: 2,
                backgroundColor: color
            } : {
                width: 10,
                height: 10,
                borderRadius: 5,
                backgroundColor: color
            }
        };
    }
}
function $c84c9521536c601a$export$3203edd9e5edd663(tpl, value, isUTC) {
    if (tpl === 'week' || tpl === 'month' || tpl === 'quarter' || tpl === 'half-year' || tpl === 'year') tpl = 'MM-dd\nyyyy';
    var date = (0, $cfc1f3b422a3185f$export$6b862160d295c8e)(value);
    var getUTC = isUTC ? 'getUTC' : 'get';
    var y = date[getUTC + 'FullYear']();
    var M = date[getUTC + 'Month']() + 1;
    var d = date[getUTC + 'Date']();
    var h = date[getUTC + 'Hours']();
    var m = date[getUTC + 'Minutes']();
    var s = date[getUTC + 'Seconds']();
    var S = date[getUTC + 'Milliseconds']();
    tpl = tpl.replace('MM', (0, $0ae0381fb3fd176f$export$5d04458e2a6c373e)(M, 2)).replace('M', M).replace('yyyy', y).replace('yy', (0, $0ae0381fb3fd176f$export$5d04458e2a6c373e)(y % 100 + '', 2)).replace('dd', (0, $0ae0381fb3fd176f$export$5d04458e2a6c373e)(d, 2)).replace('d', d).replace('hh', (0, $0ae0381fb3fd176f$export$5d04458e2a6c373e)(h, 2)).replace('h', h).replace('mm', (0, $0ae0381fb3fd176f$export$5d04458e2a6c373e)(m, 2)).replace('m', m).replace('ss', (0, $0ae0381fb3fd176f$export$5d04458e2a6c373e)(s, 2)).replace('s', s).replace('SSS', (0, $0ae0381fb3fd176f$export$5d04458e2a6c373e)(S, 3));
    return tpl;
}
function $c84c9521536c601a$export$38a1e7552f497c0e(str) {
    return str ? str.charAt(0).toUpperCase() + str.substr(1) : str;
}
function $c84c9521536c601a$export$cda04d03233e5555(color, defaultColor) {
    defaultColor = defaultColor || 'transparent';
    return $7a1bd9c2710fea0d$export$844ec244b1367d54(color) ? color : $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(color) ? color.colorStops && (color.colorStops[0] || {}).color || defaultColor : defaultColor;
}
function $c84c9521536c601a$export$13e13f9b96dbe8fa(link, target) {
    /* global window */ if (target === '_blank' || target === 'blank') {
        var blank = window.open();
        blank.opener = null;
        blank.location.href = link;
    } else window.open(link, target);
}


var $93b9bc7f22ac7369$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
var $93b9bc7f22ac7369$export$a9aa2cc018afbed = [
    'left',
    'right',
    'top',
    'bottom',
    'width',
    'height'
];
var $93b9bc7f22ac7369$export$d7fd4338c7b20804 = [
    [
        'width',
        'left',
        'right'
    ],
    [
        'height',
        'top',
        'bottom'
    ]
];
function $93b9bc7f22ac7369$var$boxLayout(orient, group, gap, maxWidth, maxHeight) {
    var x = 0;
    var y = 0;
    if (maxWidth == null) maxWidth = Infinity;
    if (maxHeight == null) maxHeight = Infinity;
    var currentLineMaxSize = 0;
    group.eachChild(function(child, idx) {
        var rect = child.getBoundingRect();
        var nextChild = group.childAt(idx + 1);
        var nextChildRect = nextChild && nextChild.getBoundingRect();
        var nextX;
        var nextY;
        if (orient === 'horizontal') {
            var moveX = rect.width + (nextChildRect ? -nextChildRect.x + rect.x : 0);
            nextX = x + moveX;
            // Wrap when width exceeds maxWidth or meet a `newline` group
            // FIXME compare before adding gap?
            if (nextX > maxWidth || child.newline) {
                x = 0;
                nextX = moveX;
                y += currentLineMaxSize + gap;
                currentLineMaxSize = rect.height;
            } else // FIXME: consider rect.y is not `0`?
            currentLineMaxSize = Math.max(currentLineMaxSize, rect.height);
        } else {
            var moveY = rect.height + (nextChildRect ? -nextChildRect.y + rect.y : 0);
            nextY = y + moveY;
            // Wrap when width exceeds maxHeight or meet a `newline` group
            if (nextY > maxHeight || child.newline) {
                x += currentLineMaxSize + gap;
                y = 0;
                nextY = moveY;
                currentLineMaxSize = rect.width;
            } else currentLineMaxSize = Math.max(currentLineMaxSize, rect.width);
        }
        if (child.newline) return;
        child.x = x;
        child.y = y;
        child.markRedraw();
        orient === 'horizontal' ? x = nextX + gap : y = nextY + gap;
    });
}
var $93b9bc7f22ac7369$export$827f4ee28efc37 = $93b9bc7f22ac7369$var$boxLayout;
var $93b9bc7f22ac7369$export$be20d9158c17374c = $7a1bd9c2710fea0d$export$c3095a23b368d1f2($93b9bc7f22ac7369$var$boxLayout, 'vertical');
var $93b9bc7f22ac7369$export$ae65a483d943e7a7 = $7a1bd9c2710fea0d$export$c3095a23b368d1f2($93b9bc7f22ac7369$var$boxLayout, 'horizontal');
function $93b9bc7f22ac7369$export$145a8938a85a22b1(positionInfo, containerRect, margin) {
    var containerWidth = containerRect.width;
    var containerHeight = containerRect.height;
    var x = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(positionInfo.left, containerWidth);
    var y = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(positionInfo.top, containerHeight);
    var x2 = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(positionInfo.right, containerWidth);
    var y2 = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(positionInfo.bottom, containerHeight);
    (isNaN(x) || isNaN(parseFloat(positionInfo.left))) && (x = 0);
    (isNaN(x2) || isNaN(parseFloat(positionInfo.right))) && (x2 = containerWidth);
    (isNaN(y) || isNaN(parseFloat(positionInfo.top))) && (y = 0);
    (isNaN(y2) || isNaN(parseFloat(positionInfo.bottom))) && (y2 = containerHeight);
    margin = $c84c9521536c601a$export$f3a38102c49f4268(margin || 0);
    return {
        width: Math.max(x2 - x - margin[1] - margin[3], 0),
        height: Math.max(y2 - y - margin[0] - margin[2], 0)
    };
}
function $93b9bc7f22ac7369$export$4517a5ca639a7293(positionInfo, containerRect, margin) {
    margin = $c84c9521536c601a$export$f3a38102c49f4268(margin || 0);
    var containerWidth = containerRect.width;
    var containerHeight = containerRect.height;
    var left = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(positionInfo.left, containerWidth);
    var top = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(positionInfo.top, containerHeight);
    var right = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(positionInfo.right, containerWidth);
    var bottom = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(positionInfo.bottom, containerHeight);
    var width = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(positionInfo.width, containerWidth);
    var height = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(positionInfo.height, containerHeight);
    var verticalMargin = margin[2] + margin[0];
    var horizontalMargin = margin[1] + margin[3];
    var aspect = positionInfo.aspect;
    // If width is not specified, calculate width from left and right
    if (isNaN(width)) width = containerWidth - right - horizontalMargin - left;
    if (isNaN(height)) height = containerHeight - bottom - verticalMargin - top;
    if (aspect != null) {
        // If width and height are not given
        // 1. Graph should not exceeds the container
        // 2. Aspect must be keeped
        // 3. Graph should take the space as more as possible
        // FIXME
        // Margin is not considered, because there is no case that both
        // using margin and aspect so far.
        if (isNaN(width) && isNaN(height)) {
            if (aspect > containerWidth / containerHeight) width = containerWidth * 0.8;
            else height = containerHeight * 0.8;
        }
        // Calculate width or height with given aspect
        if (isNaN(width)) width = aspect * height;
        if (isNaN(height)) height = width / aspect;
    }
    // If left is not specified, calculate left from right and width
    if (isNaN(left)) left = containerWidth - right - width - horizontalMargin;
    if (isNaN(top)) top = containerHeight - bottom - height - verticalMargin;
    // Align left and top
    switch(positionInfo.left || positionInfo.right){
        case 'center':
            left = containerWidth / 2 - width / 2 - margin[3];
            break;
        case 'right':
            left = containerWidth - width - horizontalMargin;
            break;
    }
    switch(positionInfo.top || positionInfo.bottom){
        case 'middle':
        case 'center':
            top = containerHeight / 2 - height / 2 - margin[0];
            break;
        case 'bottom':
            top = containerHeight - height - verticalMargin;
            break;
    }
    // If something is wrong and left, top, width, height are calculated as NaN
    left = left || 0;
    top = top || 0;
    if (isNaN(width)) // Width may be NaN if only one value is given except width
    width = containerWidth - horizontalMargin - left - (right || 0);
    if (isNaN(height)) // Height may be NaN if only one value is given except height
    height = containerHeight - verticalMargin - top - (bottom || 0);
    var rect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(left + margin[3], top + margin[0], width, height);
    rect.margin = margin;
    return rect;
}
function $93b9bc7f22ac7369$export$74054bd96b5eeef1(el, positionInfo, containerRect, margin, opt, out) {
    var h = !opt || !opt.hv || opt.hv[0];
    var v = !opt || !opt.hv || opt.hv[1];
    var boundingMode = opt && opt.boundingMode || 'all';
    out = out || el;
    out.x = el.x;
    out.y = el.y;
    if (!h && !v) return false;
    var rect;
    if (boundingMode === 'raw') rect = el.type === 'group' ? new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, +positionInfo.width || 0, +positionInfo.height || 0) : el.getBoundingRect();
    else {
        rect = el.getBoundingRect();
        if (el.needLocalTransform()) {
            var transform = el.getLocalTransform();
            // Notice: raw rect may be inner object of el,
            // which should not be modified.
            rect = rect.clone();
            rect.applyTransform(transform);
        }
    }
    // The real width and height can not be specified but calculated by the given el.
    var layoutRect = $93b9bc7f22ac7369$export$4517a5ca639a7293($7a1bd9c2710fea0d$export$ebe90cb607ad99e({
        width: rect.width,
        height: rect.height
    }, positionInfo), containerRect, margin);
    // Because 'tranlate' is the last step in transform
    // (see zrender/core/Transformable#getLocalTransform),
    // we can just only modify el.position to get final result.
    var dx = h ? layoutRect.x - rect.x : 0;
    var dy = v ? layoutRect.y - rect.y : 0;
    if (boundingMode === 'raw') {
        out.x = dx;
        out.y = dy;
    } else {
        out.x += dx;
        out.y += dy;
    }
    if (out === el) el.markRedraw();
    return true;
}
function $93b9bc7f22ac7369$export$7ede609e8ebc9650(option, hvIdx) {
    return option[$93b9bc7f22ac7369$export$d7fd4338c7b20804[hvIdx][0]] != null || option[$93b9bc7f22ac7369$export$d7fd4338c7b20804[hvIdx][1]] != null && option[$93b9bc7f22ac7369$export$d7fd4338c7b20804[hvIdx][2]] != null;
}
function $93b9bc7f22ac7369$export$3968a28a7cbd6063(ins) {
    var layoutMode = ins.layoutMode || ins.constructor.layoutMode;
    return $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(layoutMode) ? layoutMode : layoutMode ? {
        type: layoutMode
    } : null;
}
function $93b9bc7f22ac7369$export$1754cb91f16ca028(targetOption, newOption, opt) {
    var ignoreSize = opt && opt.ignoreSize;
    !$7a1bd9c2710fea0d$export$43bee75e5e14138e(ignoreSize) && (ignoreSize = [
        ignoreSize,
        ignoreSize
    ]);
    var hResult = merge($93b9bc7f22ac7369$export$d7fd4338c7b20804[0], 0);
    var vResult = merge($93b9bc7f22ac7369$export$d7fd4338c7b20804[1], 1);
    copy($93b9bc7f22ac7369$export$d7fd4338c7b20804[0], targetOption, hResult);
    copy($93b9bc7f22ac7369$export$d7fd4338c7b20804[1], targetOption, vResult);
    function merge(names, hvIdx) {
        var newParams = {};
        var newValueCount = 0;
        var merged = {};
        var mergedValueCount = 0;
        var enoughParamNumber = 2;
        $93b9bc7f22ac7369$var$each(names, function(name) {
            merged[name] = targetOption[name];
        });
        $93b9bc7f22ac7369$var$each(names, function(name) {
            // Consider case: newOption.width is null, which is
            // set by user for removing width setting.
            hasProp(newOption, name) && (newParams[name] = merged[name] = newOption[name]);
            hasValue(newParams, name) && newValueCount++;
            hasValue(merged, name) && mergedValueCount++;
        });
        if (ignoreSize[hvIdx]) {
            // Only one of left/right is premitted to exist.
            if (hasValue(newOption, names[1])) merged[names[2]] = null;
            else if (hasValue(newOption, names[2])) merged[names[1]] = null;
            return merged;
        }
        // Case: newOption: {width: ..., right: ...},
        // or targetOption: {right: ...} and newOption: {width: ...},
        // There is no conflict when merged only has params count
        // little than enoughParamNumber.
        if (mergedValueCount === enoughParamNumber || !newValueCount) return merged;
        else if (newValueCount >= enoughParamNumber) return newParams;
        else {
            // Chose another param from targetOption by priority.
            for(var i = 0; i < names.length; i++){
                var name_1 = names[i];
                if (!hasProp(newParams, name_1) && hasProp(targetOption, name_1)) {
                    newParams[name_1] = targetOption[name_1];
                    break;
                }
            }
            return newParams;
        }
    }
    function hasProp(obj, name) {
        return obj.hasOwnProperty(name);
    }
    function hasValue(obj, name) {
        return obj[name] != null && obj[name] !== 'auto';
    }
    function copy(names, target, source) {
        $93b9bc7f22ac7369$var$each(names, function(name) {
            target[name] = source[name];
        });
    }
}
function $93b9bc7f22ac7369$export$4b0d20af19c9875e(source) {
    return $93b9bc7f22ac7369$export$7438999faea9b6cc({}, source);
}
function $93b9bc7f22ac7369$export$7438999faea9b6cc(target, source) {
    source && target && $93b9bc7f22ac7369$var$each($93b9bc7f22ac7369$export$a9aa2cc018afbed, function(name) {
        source.hasOwnProperty(name) && (target[name] = source[name]);
    });
    return target;
}


var $116d65051f61bdfe$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $116d65051f61bdfe$var$ComponentModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ComponentModel, _super);
    function ComponentModel(option, parentModel, ecModel) {
        var _this = _super.call(this, option, parentModel, ecModel) || this;
        _this.uid = $5370df662b2caf37$export$6d2b3473b0986646('ec_cpt_model');
        return _this;
    }
    ComponentModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
    };
    ComponentModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
        var layoutMode = $93b9bc7f22ac7369$export$3968a28a7cbd6063(this);
        var inputPositionParams = layoutMode ? $93b9bc7f22ac7369$export$4b0d20af19c9875e(option) : {};
        var themeModel = ecModel.getTheme();
        $7a1bd9c2710fea0d$export$4950aa0f605343fb(option, themeModel.get(this.mainType));
        $7a1bd9c2710fea0d$export$4950aa0f605343fb(option, this.getDefaultOption());
        if (layoutMode) $93b9bc7f22ac7369$export$1754cb91f16ca028(option, inputPositionParams, layoutMode);
    };
    ComponentModel.prototype.mergeOption = function(option, ecModel) {
        $7a1bd9c2710fea0d$export$4950aa0f605343fb(this.option, option, true);
        var layoutMode = $93b9bc7f22ac7369$export$3968a28a7cbd6063(this);
        if (layoutMode) $93b9bc7f22ac7369$export$1754cb91f16ca028(this.option, option, layoutMode);
    };
    /**
   * Called immediately after `init` or `mergeOption` of this instance called.
   */ ComponentModel.prototype.optionUpdated = function(newCptOption, isInit) {};
    /**
   * [How to declare defaultOption]:
   *
   * (A) If using class declaration in typescript (since echarts 5):
   * ```ts
   * import {ComponentOption} from '../model/option.js';
   * export interface XxxOption extends ComponentOption {
   *     aaa: number
   * }
   * export class XxxModel extends Component {
   *     static type = 'xxx';
   *     static defaultOption: XxxOption = {
   *         aaa: 123
   *     }
   * }
   * Component.registerClass(XxxModel);
   * ```
   * ```ts
   * import {inheritDefaultOption} from '../util/component.js';
   * import {XxxModel, XxxOption} from './XxxModel.js';
   * export interface XxxSubOption extends XxxOption {
   *     bbb: number
   * }
   * class XxxSubModel extends XxxModel {
   *     static defaultOption: XxxSubOption = inheritDefaultOption(XxxModel.defaultOption, {
   *         bbb: 456
   *     })
   *     fn() {
   *         let opt = this.getDefaultOption();
   *         // opt is {aaa: 123, bbb: 456}
   *     }
   * }
   * ```
   *
   * (B) If using class extend (previous approach in echarts 3 & 4):
   * ```js
   * let XxxComponent = Component.extend({
   *     defaultOption: {
   *         xx: 123
   *     }
   * })
   * ```
   * ```js
   * let XxxSubComponent = XxxComponent.extend({
   *     defaultOption: {
   *         yy: 456
   *     },
   *     fn: function () {
   *         let opt = this.getDefaultOption();
   *         // opt is {xx: 123, yy: 456}
   *     }
   * })
   * ```
   */ ComponentModel.prototype.getDefaultOption = function() {
        var ctor = this.constructor;
        // If using class declaration, it is different to travel super class
        // in legacy env and auto merge defaultOption. So if using class
        // declaration, defaultOption should be merged manually.
        if (!(0, $cd5f95cf03b4e3e7$export$4f3b818f3dd2d182)(ctor)) // When using ts class, defaultOption must be declared as static.
        return ctor.defaultOption;
        // FIXME: remove this approach?
        var fields = $116d65051f61bdfe$var$inner(this);
        if (!fields.defaultOption) {
            var optList = [];
            var clz = ctor;
            while(clz){
                var opt = clz.prototype.defaultOption;
                opt && optList.push(opt);
                clz = clz.superClass;
            }
            var defaultOption = {};
            for(var i = optList.length - 1; i >= 0; i--)defaultOption = $7a1bd9c2710fea0d$export$4950aa0f605343fb(defaultOption, optList[i], true);
            fields.defaultOption = defaultOption;
        }
        return fields.defaultOption;
    };
    /**
   * Notice: always force to input param `useDefault` in case that forget to consider it.
   * The same behavior as `modelUtil.parseFinder`.
   *
   * @param useDefault In many cases like series refer axis and axis refer grid,
   *        If axis index / axis id not specified, use the first target as default.
   *        In other cases like dataZoom refer axis, if not specified, measn no refer.
   */ ComponentModel.prototype.getReferringComponents = function(mainType, opt) {
        var indexKey = mainType + 'Index';
        var idKey = mainType + 'Id';
        return (0, $76d619f648247e6d$export$dc741340f7e5f186)(this.ecModel, mainType, {
            index: this.get(indexKey, true),
            id: this.get(idKey, true)
        }, opt);
    };
    ComponentModel.prototype.getBoxLayoutParams = function() {
        // Consider itself having box layout configs.
        var boxLayoutModel = this;
        return {
            left: boxLayoutModel.get('left'),
            top: boxLayoutModel.get('top'),
            right: boxLayoutModel.get('right'),
            bottom: boxLayoutModel.get('bottom'),
            width: boxLayoutModel.get('width'),
            height: boxLayoutModel.get('height')
        };
    };
    /**
   * Get key for zlevel.
   * If developers don't configure zlevel. We will assign zlevel to series based on the key.
   * For example, lines with trail effect and progressive series will in an individual zlevel.
   */ ComponentModel.prototype.getZLevelKey = function() {
        return '';
    };
    ComponentModel.prototype.setZLevel = function(zlevel) {
        this.option.zlevel = zlevel;
    };
    ComponentModel.protoInitialize = function() {
        var proto = ComponentModel.prototype;
        proto.type = 'component';
        proto.id = '';
        proto.name = '';
        proto.mainType = '';
        proto.subType = '';
        proto.componentIndex = 0;
    }();
    return ComponentModel;
}((0, $6818646a97528290$export$2e2bcd8739ae039));
(0, $cd5f95cf03b4e3e7$export$c9c2d87774f1275d)($116d65051f61bdfe$var$ComponentModel, (0, $6818646a97528290$export$2e2bcd8739ae039));
(0, $cd5f95cf03b4e3e7$export$241315e45585454d)($116d65051f61bdfe$var$ComponentModel);
$5370df662b2caf37$export$b9faf30b7d655a6f($116d65051f61bdfe$var$ComponentModel);
$5370df662b2caf37$export$ce592d345a3ec040($116d65051f61bdfe$var$ComponentModel, $116d65051f61bdfe$var$getDependencies);
function $116d65051f61bdfe$var$getDependencies(componentType) {
    var deps = [];
    $7a1bd9c2710fea0d$export$79b2f7037acddd43($116d65051f61bdfe$var$ComponentModel.getClassesByMainType(componentType), function(clz) {
        deps = deps.concat(clz.dependencies || clz.prototype.dependencies || []);
    });
    // Ensure main type.
    deps = $7a1bd9c2710fea0d$export$871de8747c9eaa88(deps, function(type) {
        return (0, $cd5f95cf03b4e3e7$export$fbe18865d303bf01)(type).main;
    });
    // Hack dataset for convenience.
    if (componentType !== 'dataset' && $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(deps, 'dataset') <= 0) deps.unshift('dataset');
    return deps;
}
var $116d65051f61bdfe$export$2e2bcd8739ae039 = $116d65051f61bdfe$var$ComponentModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $2d7ac35b3b3d57e3$var$platform = '';
// Navigator not exists in node
if (typeof navigator !== 'undefined') /* global navigator */ $2d7ac35b3b3d57e3$var$platform = navigator.platform || '';
var $2d7ac35b3b3d57e3$var$decalColor = 'rgba(0, 0, 0, 0.2)';
var $2d7ac35b3b3d57e3$export$2e2bcd8739ae039 = {
    darkMode: 'auto',
    // backgroundColor: 'rgba(0,0,0,0)',
    colorBy: 'series',
    color: [
        '#5470c6',
        '#91cc75',
        '#fac858',
        '#ee6666',
        '#73c0de',
        '#3ba272',
        '#fc8452',
        '#9a60b4',
        '#ea7ccc'
    ],
    gradientColor: [
        '#f6efa6',
        '#d88273',
        '#bf444c'
    ],
    aria: {
        decal: {
            decals: [
                {
                    color: $2d7ac35b3b3d57e3$var$decalColor,
                    dashArrayX: [
                        1,
                        0
                    ],
                    dashArrayY: [
                        2,
                        5
                    ],
                    symbolSize: 1,
                    rotation: Math.PI / 6
                },
                {
                    color: $2d7ac35b3b3d57e3$var$decalColor,
                    symbol: 'circle',
                    dashArrayX: [
                        [
                            8,
                            8
                        ],
                        [
                            0,
                            8,
                            8,
                            0
                        ]
                    ],
                    dashArrayY: [
                        6,
                        0
                    ],
                    symbolSize: 0.8
                },
                {
                    color: $2d7ac35b3b3d57e3$var$decalColor,
                    dashArrayX: [
                        1,
                        0
                    ],
                    dashArrayY: [
                        4,
                        3
                    ],
                    rotation: -Math.PI / 4
                },
                {
                    color: $2d7ac35b3b3d57e3$var$decalColor,
                    dashArrayX: [
                        [
                            6,
                            6
                        ],
                        [
                            0,
                            6,
                            6,
                            0
                        ]
                    ],
                    dashArrayY: [
                        6,
                        0
                    ]
                },
                {
                    color: $2d7ac35b3b3d57e3$var$decalColor,
                    dashArrayX: [
                        [
                            1,
                            0
                        ],
                        [
                            1,
                            6
                        ]
                    ],
                    dashArrayY: [
                        1,
                        0,
                        6,
                        0
                    ],
                    rotation: Math.PI / 4
                },
                {
                    color: $2d7ac35b3b3d57e3$var$decalColor,
                    symbol: 'triangle',
                    dashArrayX: [
                        [
                            9,
                            9
                        ],
                        [
                            0,
                            9,
                            9,
                            0
                        ]
                    ],
                    dashArrayY: [
                        7,
                        2
                    ],
                    symbolSize: 0.75
                }
            ]
        }
    },
    // If xAxis and yAxis declared, grid is created by default.
    // grid: {},
    textStyle: {
        // color: '#000',
        // decoration: 'none',
        // PENDING
        fontFamily: $2d7ac35b3b3d57e3$var$platform.match(/^Win/) ? 'Microsoft YaHei' : 'sans-serif',
        // fontFamily: 'Arial, Verdana, sans-serif',
        fontSize: 12,
        fontStyle: 'normal',
        fontWeight: 'normal'
    },
    // http://blogs.adobe.com/webplatform/2014/02/24/using-blend-modes-in-html-canvas/
    // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
    // Default is source-over
    blendMode: null,
    stateAnimation: {
        duration: 300,
        easing: 'cubicOut'
    },
    animation: 'auto',
    animationDuration: 1000,
    animationDurationUpdate: 500,
    animationEasing: 'cubicInOut',
    animationEasingUpdate: 'cubicInOut',
    animationThreshold: 2000,
    // Configuration for progressive/incremental rendering
    progressiveThreshold: 3000,
    progressive: 400,
    // Threshold of if use single hover layer to optimize.
    // It is recommended that `hoverLayerThreshold` is equivalent to or less than
    // `progressiveThreshold`, otherwise hover will cause restart of progressive,
    // which is unexpected.
    // see example <echarts/test/heatmap-large.html>.
    hoverLayerThreshold: 3000,
    // See: module:echarts/scale/Time
    useUTC: false
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $cab29724515ce2b8$export$cd51b5ca77f6f0e4 = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)([
    'tooltip',
    'label',
    'itemName',
    'itemId',
    'itemGroupId',
    'itemChildGroupId',
    'seriesName'
]);
var $cab29724515ce2b8$export$2823037fb9d8f0c6 = 'original';
var $cab29724515ce2b8$export$fcd62ebf51387903 = 'arrayRows';
var $cab29724515ce2b8$export$703ae8a2d83f441 = 'objectRows';
var $cab29724515ce2b8$export$6a32b42c754a3cb8 = 'keyedColumns';
var $cab29724515ce2b8$export$a918cb016a382d45 = 'typedArray';
var $cab29724515ce2b8$export$c78f1330778d30d = 'unknown';
var $cab29724515ce2b8$export$7b3f3c6551b4949b = 'column';
var $cab29724515ce2b8$export$d55da1467cdf7804 = 'row';


var $7dc6cdfd7450ef29$export$328749e9c5b40760 = {
    Must: 1,
    Might: 2,
    Not: 3 // Other cases
};
var $7dc6cdfd7450ef29$var$innerGlobalModel = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $7dc6cdfd7450ef29$export$b30cdea50aa00e6(ecModel) {
    // `datasetMap` is used to make default encode.
    $7dc6cdfd7450ef29$var$innerGlobalModel(ecModel).datasetMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
}
function $7dc6cdfd7450ef29$export$37682b8fdd2e83d(coordDimensions, seriesModel, source) {
    var encode = {};
    var datasetModel = $7dc6cdfd7450ef29$export$8da66f73a1eda454(seriesModel);
    // Currently only make default when using dataset, util more reqirements occur.
    if (!datasetModel || !coordDimensions) return encode;
    var encodeItemName = [];
    var encodeSeriesName = [];
    var ecModel = seriesModel.ecModel;
    var datasetMap = $7dc6cdfd7450ef29$var$innerGlobalModel(ecModel).datasetMap;
    var key = datasetModel.uid + '_' + source.seriesLayoutBy;
    var baseCategoryDimIndex;
    var categoryWayValueDimStart;
    coordDimensions = coordDimensions.slice();
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(coordDimensions, function(coordDimInfoLoose, coordDimIdx) {
        var coordDimInfo = (0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(coordDimInfoLoose) ? coordDimInfoLoose : coordDimensions[coordDimIdx] = {
            name: coordDimInfoLoose
        };
        if (coordDimInfo.type === 'ordinal' && baseCategoryDimIndex == null) {
            baseCategoryDimIndex = coordDimIdx;
            categoryWayValueDimStart = getDataDimCountOnCoordDim(coordDimInfo);
        }
        encode[coordDimInfo.name] = [];
    });
    var datasetRecord = datasetMap.get(key) || datasetMap.set(key, {
        categoryWayDim: categoryWayValueDimStart,
        valueWayDim: 0
    });
    // TODO
    // Auto detect first time axis and do arrangement.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(coordDimensions, function(coordDimInfo, coordDimIdx) {
        var coordDimName = coordDimInfo.name;
        var count = getDataDimCountOnCoordDim(coordDimInfo);
        // In value way.
        if (baseCategoryDimIndex == null) {
            var start = datasetRecord.valueWayDim;
            pushDim(encode[coordDimName], start, count);
            pushDim(encodeSeriesName, start, count);
            datasetRecord.valueWayDim += count;
        // ??? TODO give a better default series name rule?
        // especially when encode x y specified.
        // consider: when multiple series share one dimension
        // category axis, series name should better use
        // the other dimension name. On the other hand, use
        // both dimensions name.
        } else if (baseCategoryDimIndex === coordDimIdx) {
            pushDim(encode[coordDimName], 0, count);
            pushDim(encodeItemName, 0, count);
        } else {
            var start = datasetRecord.categoryWayDim;
            pushDim(encode[coordDimName], start, count);
            pushDim(encodeSeriesName, start, count);
            datasetRecord.categoryWayDim += count;
        }
    });
    function pushDim(dimIdxArr, idxFrom, idxCount) {
        for(var i = 0; i < idxCount; i++)dimIdxArr.push(idxFrom + i);
    }
    function getDataDimCountOnCoordDim(coordDimInfo) {
        var dimsDef = coordDimInfo.dimsDef;
        return dimsDef ? dimsDef.length : 1;
    }
    encodeItemName.length && (encode.itemName = encodeItemName);
    encodeSeriesName.length && (encode.seriesName = encodeSeriesName);
    return encode;
}
function $7dc6cdfd7450ef29$export$60b8a57d1f2fed26(seriesModel, source, dimCount) {
    var encode = {};
    var datasetModel = $7dc6cdfd7450ef29$export$8da66f73a1eda454(seriesModel);
    // Currently only make default when using dataset, util more reqirements occur.
    if (!datasetModel) return encode;
    var sourceFormat = source.sourceFormat;
    var dimensionsDefine = source.dimensionsDefine;
    var potentialNameDimIndex;
    if (sourceFormat === (0, $cab29724515ce2b8$export$703ae8a2d83f441) || sourceFormat === (0, $cab29724515ce2b8$export$6a32b42c754a3cb8)) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dimensionsDefine, function(dim, idx) {
        if (((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(dim) ? dim.name : dim) === 'name') potentialNameDimIndex = idx;
    });
    var idxResult = function() {
        var idxRes0 = {};
        var idxRes1 = {};
        var guessRecords = [];
        // 5 is an experience value.
        for(var i = 0, len = Math.min(5, dimCount); i < len; i++){
            var guessResult = $7dc6cdfd7450ef29$var$doGuessOrdinal(source.data, sourceFormat, source.seriesLayoutBy, dimensionsDefine, source.startIndex, i);
            guessRecords.push(guessResult);
            var isPureNumber = guessResult === $7dc6cdfd7450ef29$export$328749e9c5b40760.Not;
            // [Strategy of idxRes0]: find the first BE_ORDINAL.Not as the value dim,
            // and then find a name dim with the priority:
            // "BE_ORDINAL.Might|BE_ORDINAL.Must" > "other dim" > "the value dim itself".
            if (isPureNumber && idxRes0.v == null && i !== potentialNameDimIndex) idxRes0.v = i;
            if (idxRes0.n == null || idxRes0.n === idxRes0.v || !isPureNumber && guessRecords[idxRes0.n] === $7dc6cdfd7450ef29$export$328749e9c5b40760.Not) idxRes0.n = i;
            if (fulfilled(idxRes0) && guessRecords[idxRes0.n] !== $7dc6cdfd7450ef29$export$328749e9c5b40760.Not) return idxRes0;
            // [Strategy of idxRes1]: if idxRes0 not satisfied (that is, no BE_ORDINAL.Not),
            // find the first BE_ORDINAL.Might as the value dim,
            // and then find a name dim with the priority:
            // "other dim" > "the value dim itself".
            // That is for backward compat: number-like (e.g., `'3'`, `'55'`) can be
            // treated as number.
            if (!isPureNumber) {
                if (guessResult === $7dc6cdfd7450ef29$export$328749e9c5b40760.Might && idxRes1.v == null && i !== potentialNameDimIndex) idxRes1.v = i;
                if (idxRes1.n == null || idxRes1.n === idxRes1.v) idxRes1.n = i;
            }
        }
        function fulfilled(idxResult) {
            return idxResult.v != null && idxResult.n != null;
        }
        return fulfilled(idxRes0) ? idxRes0 : fulfilled(idxRes1) ? idxRes1 : null;
    }();
    if (idxResult) {
        encode.value = [
            idxResult.v
        ];
        // `potentialNameDimIndex` has highest priority.
        var nameDimIndex = potentialNameDimIndex != null ? potentialNameDimIndex : idxResult.n;
        // By default, label uses itemName in charts.
        // So we don't set encodeLabel here.
        encode.itemName = [
            nameDimIndex
        ];
        encode.seriesName = [
            nameDimIndex
        ];
    }
    return encode;
}
function $7dc6cdfd7450ef29$export$8da66f73a1eda454(seriesModel) {
    // Caution: consider the scenario:
    // A dataset is declared and a series is not expected to use the dataset,
    // and at the beginning `setOption({series: { noData })` (just prepare other
    // option but no data), then `setOption({series: {data: [...]}); In this case,
    // the user should set an empty array to avoid that dataset is used by default.
    var thisData = seriesModel.get('data', true);
    if (!thisData) return (0, $76d619f648247e6d$export$dc741340f7e5f186)(seriesModel.ecModel, 'dataset', {
        index: seriesModel.get('datasetIndex', true),
        id: seriesModel.get('datasetId', true)
    }, (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
}
function $7dc6cdfd7450ef29$export$397ba553479711e7(datasetModel) {
    // Only these attributes declared, we by default reference to `datasetIndex: 0`.
    // Otherwise, no reference.
    if (!datasetModel.get('transform', true) && !datasetModel.get('fromTransformResult', true)) return [];
    return (0, $76d619f648247e6d$export$dc741340f7e5f186)(datasetModel.ecModel, 'dataset', {
        index: datasetModel.get('fromDatasetIndex', true),
        id: datasetModel.get('fromDatasetId', true)
    }, (0, $76d619f648247e6d$export$f076738ec84e693c)).models;
}
function $7dc6cdfd7450ef29$export$c51adf1a2be01b9c(source, dimIndex) {
    return $7dc6cdfd7450ef29$var$doGuessOrdinal(source.data, source.sourceFormat, source.seriesLayoutBy, source.dimensionsDefine, source.startIndex, dimIndex);
}
// dimIndex may be overflow source data.
// return {BE_ORDINAL}
function $7dc6cdfd7450ef29$var$doGuessOrdinal(data, sourceFormat, seriesLayoutBy, dimensionsDefine, startIndex, dimIndex) {
    var result;
    // Experience value.
    var maxLoop = 5;
    if ((0, $7a1bd9c2710fea0d$export$b119cc7e1840e59c)(data)) return $7dc6cdfd7450ef29$export$328749e9c5b40760.Not;
    // When sourceType is 'objectRows' or 'keyedColumns', dimensionsDefine
    // always exists in source.
    var dimName;
    var dimType;
    if (dimensionsDefine) {
        var dimDefItem = dimensionsDefine[dimIndex];
        if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(dimDefItem)) {
            dimName = dimDefItem.name;
            dimType = dimDefItem.type;
        } else if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(dimDefItem)) dimName = dimDefItem;
    }
    if (dimType != null) return dimType === 'ordinal' ? $7dc6cdfd7450ef29$export$328749e9c5b40760.Must : $7dc6cdfd7450ef29$export$328749e9c5b40760.Not;
    if (sourceFormat === (0, $cab29724515ce2b8$export$fcd62ebf51387903)) {
        var dataArrayRows = data;
        if (seriesLayoutBy === (0, $cab29724515ce2b8$export$d55da1467cdf7804)) {
            var sample = dataArrayRows[dimIndex];
            for(var i = 0; i < (sample || []).length && i < maxLoop; i++){
                if ((result = detectValue(sample[startIndex + i])) != null) return result;
            }
        } else for(var i = 0; i < dataArrayRows.length && i < maxLoop; i++){
            var row = dataArrayRows[startIndex + i];
            if (row && (result = detectValue(row[dimIndex])) != null) return result;
        }
    } else if (sourceFormat === (0, $cab29724515ce2b8$export$703ae8a2d83f441)) {
        var dataObjectRows = data;
        if (!dimName) return $7dc6cdfd7450ef29$export$328749e9c5b40760.Not;
        for(var i = 0; i < dataObjectRows.length && i < maxLoop; i++){
            var item = dataObjectRows[i];
            if (item && (result = detectValue(item[dimName])) != null) return result;
        }
    } else if (sourceFormat === (0, $cab29724515ce2b8$export$6a32b42c754a3cb8)) {
        var dataKeyedColumns = data;
        if (!dimName) return $7dc6cdfd7450ef29$export$328749e9c5b40760.Not;
        var sample = dataKeyedColumns[dimName];
        if (!sample || (0, $7a1bd9c2710fea0d$export$b119cc7e1840e59c)(sample)) return $7dc6cdfd7450ef29$export$328749e9c5b40760.Not;
        for(var i = 0; i < sample.length && i < maxLoop; i++){
            if ((result = detectValue(sample[i])) != null) return result;
        }
    } else if (sourceFormat === (0, $cab29724515ce2b8$export$2823037fb9d8f0c6)) {
        var dataOriginal = data;
        for(var i = 0; i < dataOriginal.length && i < maxLoop; i++){
            var item = dataOriginal[i];
            var val = (0, $76d619f648247e6d$export$2c944e12edb48d4b)(item);
            if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(val)) return $7dc6cdfd7450ef29$export$328749e9c5b40760.Not;
            if ((result = detectValue(val[dimIndex])) != null) return result;
        }
    }
    function detectValue(val) {
        var beStr = (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(val);
        // Consider usage convenience, '1', '2' will be treated as "number".
        // `Number('')` (or any whitespace) is `0`.
        if (val != null && Number.isFinite(Number(val)) && val !== '') return beStr ? $7dc6cdfd7450ef29$export$328749e9c5b40760.Might : $7dc6cdfd7450ef29$export$328749e9c5b40760.Not;
        else if (beStr && val !== '-') return $7dc6cdfd7450ef29$export$328749e9c5b40760.Must;
    }
    return $7dc6cdfd7450ef29$export$328749e9c5b40760.Not;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $a625fe571efb4064$var$internalOptionCreatorMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
function $a625fe571efb4064$export$5a90be4668898d38(mainType, creator) {
    (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)($a625fe571efb4064$var$internalOptionCreatorMap.get(mainType) == null && creator);
    $a625fe571efb4064$var$internalOptionCreatorMap.set(mainType, creator);
}
function $a625fe571efb4064$export$c713a6a3b43f401d(ecModel, mainType, newCmptOptionList) {
    var internalOptionCreator = $a625fe571efb4064$var$internalOptionCreatorMap.get(mainType);
    if (!internalOptionCreator) return newCmptOptionList;
    var internalOptions = internalOptionCreator(ecModel);
    if (!internalOptions) return newCmptOptionList;
    var i;
    return newCmptOptionList.concat(internalOptions);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $e7fbd47751ca3c28$var$innerColor = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $e7fbd47751ca3c28$var$innerDecal = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $e7fbd47751ca3c28$export$55a3c39e852b90f4 = /** @class */ function() {
    function PaletteMixin() {}
    PaletteMixin.prototype.getColorFromPalette = function(name, scope, requestNum) {
        var defaultPalette = (0, $76d619f648247e6d$export$4f07b212a02c8051)(this.get('color', true));
        var layeredPalette = this.get('colorLayer', true);
        return $e7fbd47751ca3c28$var$getFromPalette(this, $e7fbd47751ca3c28$var$innerColor, defaultPalette, layeredPalette, name, scope, requestNum);
    };
    PaletteMixin.prototype.clearColorPalette = function() {
        $e7fbd47751ca3c28$var$clearPalette(this, $e7fbd47751ca3c28$var$innerColor);
    };
    return PaletteMixin;
}();
function $e7fbd47751ca3c28$export$e4d892222945a227(ecModel, name, scope, requestNum) {
    var defaultDecals = (0, $76d619f648247e6d$export$4f07b212a02c8051)(ecModel.get([
        'aria',
        'decal',
        'decals'
    ]));
    return $e7fbd47751ca3c28$var$getFromPalette(ecModel, $e7fbd47751ca3c28$var$innerDecal, defaultDecals, null, name, scope, requestNum);
}
function $e7fbd47751ca3c28$var$getNearestPalette(palettes, requestColorNum) {
    var paletteNum = palettes.length;
    // TODO palettes must be in order
    for(var i = 0; i < paletteNum; i++){
        if (palettes[i].length > requestColorNum) return palettes[i];
    }
    return palettes[paletteNum - 1];
}
/**
 * @param name MUST NOT be null/undefined. Otherwise call this function
 *             twise with the same parameters will get different result.
 * @param scope default this.
 * @return Can be null/undefined
 */ function $e7fbd47751ca3c28$var$getFromPalette(that, inner, defaultPalette, layeredPalette, name, scope, requestNum) {
    scope = scope || that;
    var scopeFields = inner(scope);
    var paletteIdx = scopeFields.paletteIdx || 0;
    var paletteNameMap = scopeFields.paletteNameMap = scopeFields.paletteNameMap || {};
    // Use `hasOwnProperty` to avoid conflict with Object.prototype.
    if (paletteNameMap.hasOwnProperty(name)) return paletteNameMap[name];
    var palette = requestNum == null || !layeredPalette ? defaultPalette : $e7fbd47751ca3c28$var$getNearestPalette(layeredPalette, requestNum);
    // In case can't find in layered color palette.
    palette = palette || defaultPalette;
    if (!palette || !palette.length) return;
    var pickedPaletteItem = palette[paletteIdx];
    if (name) paletteNameMap[name] = pickedPaletteItem;
    scopeFields.paletteIdx = (paletteIdx + 1) % palette.length;
    return pickedPaletteItem;
}
function $e7fbd47751ca3c28$var$clearPalette(that, inner) {
    inner(that).paletteIdx = 0;
    inner(that).paletteNameMap = {};
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $84bc7667c27ccedc$var$ECHARTS_PREFIX = '[ECharts] ';
var $84bc7667c27ccedc$var$storedLogs = {};
var $84bc7667c27ccedc$var$hasConsole = typeof console !== 'undefined' && console.warn && console.log;
function $84bc7667c27ccedc$var$outputLog(type, str, onlyOnce) {
    if ($84bc7667c27ccedc$var$hasConsole) {
        if (onlyOnce) {
            if ($84bc7667c27ccedc$var$storedLogs[str]) return;
            $84bc7667c27ccedc$var$storedLogs[str] = true;
        }
        // eslint-disable-next-line
        console[type]($84bc7667c27ccedc$var$ECHARTS_PREFIX + str);
    }
}
function $84bc7667c27ccedc$export$bef1f36f5486a6a3(str, onlyOnce) {
    $84bc7667c27ccedc$var$outputLog('log', str, onlyOnce);
}
function $84bc7667c27ccedc$export$c106dd0671a0fc2d(str, onlyOnce) {
    $84bc7667c27ccedc$var$outputLog('warn', str, onlyOnce);
}
function $84bc7667c27ccedc$export$a3bc9b8ed74fc(str, onlyOnce) {
    $84bc7667c27ccedc$var$outputLog('error', str, onlyOnce);
}
function $84bc7667c27ccedc$export$4a9c0b74eb885aa1(str) {}
function $84bc7667c27ccedc$export$bbd91d66002c4ea6(oldOpt, newOpt, scope) {}
function $84bc7667c27ccedc$export$a68bb8b222a6bd43() {
    var hintInfo = [];
    for(var _i = 0; _i < arguments.length; _i++)hintInfo[_i] = arguments[_i];
    var msg = '';
    var makePrintableStringIfPossible_1;
    return msg;
}
function $84bc7667c27ccedc$export$8bf7aba4a9e09055(msg) {
    throw new Error(msg);
}


// -----------------------
// Internal method names:
// -----------------------
var $51f6ef0dd9546916$var$reCreateSeriesIndices;
var $51f6ef0dd9546916$var$assertSeriesInitialized;
var $51f6ef0dd9546916$var$initBase;
var $51f6ef0dd9546916$var$OPTION_INNER_KEY = '\0_ec_inner';
var $51f6ef0dd9546916$var$OPTION_INNER_VALUE = 1;
var $51f6ef0dd9546916$var$BUITIN_COMPONENTS_MAP = {
    grid: 'GridComponent',
    polar: 'PolarComponent',
    geo: 'GeoComponent',
    singleAxis: 'SingleAxisComponent',
    parallel: 'ParallelComponent',
    calendar: 'CalendarComponent',
    graphic: 'GraphicComponent',
    toolbox: 'ToolboxComponent',
    tooltip: 'TooltipComponent',
    axisPointer: 'AxisPointerComponent',
    brush: 'BrushComponent',
    title: 'TitleComponent',
    timeline: 'TimelineComponent',
    markPoint: 'MarkPointComponent',
    markLine: 'MarkLineComponent',
    markArea: 'MarkAreaComponent',
    legend: 'LegendComponent',
    dataZoom: 'DataZoomComponent',
    visualMap: 'VisualMapComponent',
    // aria: 'AriaComponent',
    // dataset: 'DatasetComponent',
    // Dependencies
    xAxis: 'GridComponent',
    yAxis: 'GridComponent',
    angleAxis: 'PolarComponent',
    radiusAxis: 'PolarComponent'
};
var $51f6ef0dd9546916$var$BUILTIN_CHARTS_MAP = {
    line: 'LineChart',
    bar: 'BarChart',
    pie: 'PieChart',
    scatter: 'ScatterChart',
    radar: 'RadarChart',
    map: 'MapChart',
    tree: 'TreeChart',
    treemap: 'TreemapChart',
    graph: 'GraphChart',
    gauge: 'GaugeChart',
    funnel: 'FunnelChart',
    parallel: 'ParallelChart',
    sankey: 'SankeyChart',
    boxplot: 'BoxplotChart',
    candlestick: 'CandlestickChart',
    effectScatter: 'EffectScatterChart',
    lines: 'LinesChart',
    heatmap: 'HeatmapChart',
    pictorialBar: 'PictorialBarChart',
    themeRiver: 'ThemeRiverChart',
    sunburst: 'SunburstChart',
    custom: 'CustomChart'
};
var $51f6ef0dd9546916$var$componetsMissingLogPrinted = {};
function $51f6ef0dd9546916$var$checkMissingComponents(option) {
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(option, function(componentOption, mainType) {
        if (!(0, $116d65051f61bdfe$export$2e2bcd8739ae039).hasClass(mainType)) {
            var componentImportName = $51f6ef0dd9546916$var$BUITIN_COMPONENTS_MAP[mainType];
            if (componentImportName && !$51f6ef0dd9546916$var$componetsMissingLogPrinted[componentImportName]) {
                (0, $84bc7667c27ccedc$export$a3bc9b8ed74fc)("Component " + mainType + " is used but not imported.\nimport { " + componentImportName + " } from 'echarts/components';\necharts.use([" + componentImportName + "]);");
                $51f6ef0dd9546916$var$componetsMissingLogPrinted[componentImportName] = true;
            }
        }
    });
}
var $51f6ef0dd9546916$var$GlobalModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(GlobalModel, _super);
    function GlobalModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GlobalModel.prototype.init = function(option, parentModel, ecModel, theme, locale, optionManager) {
        theme = theme || {};
        this.option = null; // Mark as not initialized.
        this._theme = new (0, $6818646a97528290$export$2e2bcd8739ae039)(theme);
        this._locale = new (0, $6818646a97528290$export$2e2bcd8739ae039)(locale);
        this._optionManager = optionManager;
    };
    GlobalModel.prototype.setOption = function(option, opts, optionPreprocessorFuncs) {
        var innerOpt = $51f6ef0dd9546916$var$normalizeSetOptionInput(opts);
        this._optionManager.setOption(option, optionPreprocessorFuncs, innerOpt);
        this._resetOption(null, innerOpt);
    };
    /**
   * @param type null/undefined: reset all.
   *        'recreate': force recreate all.
   *        'timeline': only reset timeline option
   *        'media': only reset media query option
   * @return Whether option changed.
   */ GlobalModel.prototype.resetOption = function(type, opt) {
        return this._resetOption(type, $51f6ef0dd9546916$var$normalizeSetOptionInput(opt));
    };
    GlobalModel.prototype._resetOption = function(type, opt) {
        var optionChanged = false;
        var optionManager = this._optionManager;
        if (!type || type === 'recreate') {
            var baseOption = optionManager.mountOption(type === 'recreate');
            if (!this.option || type === 'recreate') $51f6ef0dd9546916$var$initBase(this, baseOption);
            else {
                this.restoreData();
                this._mergeOption(baseOption, opt);
            }
            optionChanged = true;
        }
        if (type === 'timeline' || type === 'media') this.restoreData();
        // By design, if `setOption(option2)` at the second time, and `option2` is a `ECUnitOption`,
        // it should better not have the same props with `MediaUnit['option']`.
        // Because either `option2` or `MediaUnit['option']` will be always merged to "current option"
        // rather than original "baseOption". If they both override a prop, the result might be
        // unexpected when media state changed after `setOption` called.
        // If we really need to modify a props in each `MediaUnit['option']`, use the full version
        // (`{baseOption, media}`) in `setOption`.
        // For `timeline`, the case is the same.
        if (!type || type === 'recreate' || type === 'timeline') {
            var timelineOption = optionManager.getTimelineOption(this);
            if (timelineOption) {
                optionChanged = true;
                this._mergeOption(timelineOption, opt);
            }
        }
        if (!type || type === 'recreate' || type === 'media') {
            var mediaOptions = optionManager.getMediaOption(this);
            if (mediaOptions.length) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(mediaOptions, function(mediaOption) {
                optionChanged = true;
                this._mergeOption(mediaOption, opt);
            }, this);
        }
        return optionChanged;
    };
    GlobalModel.prototype.mergeOption = function(option) {
        this._mergeOption(option, null);
    };
    GlobalModel.prototype._mergeOption = function(newOption, opt) {
        var option = this.option;
        var componentsMap = this._componentsMap;
        var componentsCount = this._componentsCount;
        var newCmptTypes = [];
        var newCmptTypeMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        var replaceMergeMainTypeMap = opt && opt.replaceMergeMainTypeMap;
        (0, $7dc6cdfd7450ef29$export$b30cdea50aa00e6)(this);
        // If no component class, merge directly.
        // For example: color, animaiton options, etc.
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(newOption, function(componentOption, mainType) {
            if (componentOption == null) return;
            if (!(0, $116d65051f61bdfe$export$2e2bcd8739ae039).hasClass(mainType)) // globalSettingTask.dirty();
            option[mainType] = option[mainType] == null ? (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(componentOption) : (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)(option[mainType], componentOption, true);
            else if (mainType) {
                newCmptTypes.push(mainType);
                newCmptTypeMap.set(mainType, true);
            }
        });
        if (replaceMergeMainTypeMap) // If there is a mainType `xxx` in `replaceMerge` but not declared in option,
        // we trade it as it is declared in option as `{xxx: []}`. Because:
        // (1) for normal merge, `{xxx: null/undefined}` are the same meaning as `{xxx: []}`.
        // (2) some preprocessor may convert some of `{xxx: null/undefined}` to `{xxx: []}`.
        replaceMergeMainTypeMap.each(function(val, mainTypeInReplaceMerge) {
            if ((0, $116d65051f61bdfe$export$2e2bcd8739ae039).hasClass(mainTypeInReplaceMerge) && !newCmptTypeMap.get(mainTypeInReplaceMerge)) {
                newCmptTypes.push(mainTypeInReplaceMerge);
                newCmptTypeMap.set(mainTypeInReplaceMerge, true);
            }
        });
        (0, $116d65051f61bdfe$export$2e2bcd8739ae039).topologicalTravel(newCmptTypes, (0, $116d65051f61bdfe$export$2e2bcd8739ae039).getAllClassMainTypes(), visitComponent, this);
        function visitComponent(mainType) {
            var newCmptOptionList = (0, $a625fe571efb4064$export$c713a6a3b43f401d)(this, mainType, $76d619f648247e6d$export$4f07b212a02c8051(newOption[mainType]));
            var oldCmptList = componentsMap.get(mainType);
            var mergeMode = // `!oldCmptList` means init. See the comment in `mappingToExists`
            !oldCmptList ? 'replaceAll' : replaceMergeMainTypeMap && replaceMergeMainTypeMap.get(mainType) ? 'replaceMerge' : 'normalMerge';
            var mappingResult = $76d619f648247e6d$export$574f818966e4da87(oldCmptList, newCmptOptionList, mergeMode);
            // Set mainType and complete subType.
            $76d619f648247e6d$export$5ac61aca2ba0282d(mappingResult, mainType, (0, $116d65051f61bdfe$export$2e2bcd8739ae039));
            // Empty it before the travel, in order to prevent `this._componentsMap`
            // from being used in the `init`/`mergeOption`/`optionUpdated` of some
            // components, which is probably incorrect logic.
            option[mainType] = null;
            componentsMap.set(mainType, null);
            componentsCount.set(mainType, 0);
            var optionsByMainType = [];
            var cmptsByMainType = [];
            var cmptsCountByMainType = 0;
            var tooltipExists;
            var tooltipWarningLogged;
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(mappingResult, function(resultItem, index) {
                var componentModel = resultItem.existing;
                var newCmptOption = resultItem.newOption;
                if (!newCmptOption) {
                    if (componentModel) {
                        // Consider where is no new option and should be merged using {},
                        // see removeEdgeAndAdd in topologicalTravel and
                        // ComponentModel.getAllClassMainTypes.
                        componentModel.mergeOption({}, this);
                        componentModel.optionUpdated({}, false);
                    }
                } else {
                    var isSeriesType = mainType === 'series';
                    var ComponentModelClass = (0, $116d65051f61bdfe$export$2e2bcd8739ae039).getClass(mainType, resultItem.keyInfo.subType, !isSeriesType // Give a more detailed warn later if series don't exists
                    );
                    if (!ComponentModelClass) {
                        var subType, seriesImportName;
                        return;
                    }
                    // TODO Before multiple tooltips get supported, we do this check to avoid unexpected exception.
                    if (mainType === 'tooltip') {
                        if (tooltipExists) return;
                        tooltipExists = true;
                    }
                    if (componentModel && componentModel.constructor === ComponentModelClass) {
                        componentModel.name = resultItem.keyInfo.name;
                        // componentModel.settingTask && componentModel.settingTask.dirty();
                        componentModel.mergeOption(newCmptOption, this);
                        componentModel.optionUpdated(newCmptOption, false);
                    } else {
                        // PENDING Global as parent ?
                        var extraOpt = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
                            componentIndex: index
                        }, resultItem.keyInfo);
                        componentModel = new ComponentModelClass(newCmptOption, this, this, extraOpt);
                        // Assign `keyInfo`
                        (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(componentModel, extraOpt);
                        if (resultItem.brandNew) componentModel.__requireNewView = true;
                        componentModel.init(newCmptOption, this, this);
                        // Call optionUpdated after init.
                        // newCmptOption has been used as componentModel.option
                        // and may be merged with theme and default, so pass null
                        // to avoid confusion.
                        componentModel.optionUpdated(null, true);
                    }
                }
                if (componentModel) {
                    optionsByMainType.push(componentModel.option);
                    cmptsByMainType.push(componentModel);
                    cmptsCountByMainType++;
                } else {
                    // Always do assign to avoid elided item in array.
                    optionsByMainType.push(void 0);
                    cmptsByMainType.push(void 0);
                }
            }, this);
            option[mainType] = optionsByMainType;
            componentsMap.set(mainType, cmptsByMainType);
            componentsCount.set(mainType, cmptsCountByMainType);
            // Backup series for filtering.
            if (mainType === 'series') $51f6ef0dd9546916$var$reCreateSeriesIndices(this);
        }
        // If no series declared, ensure `_seriesIndices` initialized.
        if (!this._seriesIndices) $51f6ef0dd9546916$var$reCreateSeriesIndices(this);
    };
    /**
   * Get option for output (cloned option and inner info removed)
   */ GlobalModel.prototype.getOption = function() {
        var option = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(this.option);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(option, function(optInMainType, mainType) {
            if ((0, $116d65051f61bdfe$export$2e2bcd8739ae039).hasClass(mainType)) {
                var opts = $76d619f648247e6d$export$4f07b212a02c8051(optInMainType);
                // Inner cmpts need to be removed.
                // Inner cmpts might not be at last since ec5.0, but still
                // compatible for users: if inner cmpt at last, splice the returned array.
                var realLen = opts.length;
                var metNonInner = false;
                for(var i = realLen - 1; i >= 0; i--)// Remove options with inner id.
                if (opts[i] && !$76d619f648247e6d$export$feece3e7d52a102b(opts[i])) metNonInner = true;
                else {
                    opts[i] = null;
                    !metNonInner && realLen--;
                }
                opts.length = realLen;
                option[mainType] = opts;
            }
        });
        delete option[$51f6ef0dd9546916$var$OPTION_INNER_KEY];
        return option;
    };
    GlobalModel.prototype.getTheme = function() {
        return this._theme;
    };
    GlobalModel.prototype.getLocaleModel = function() {
        return this._locale;
    };
    GlobalModel.prototype.setUpdatePayload = function(payload) {
        this._payload = payload;
    };
    GlobalModel.prototype.getUpdatePayload = function() {
        return this._payload;
    };
    /**
   * @param idx If not specified, return the first one.
   */ GlobalModel.prototype.getComponent = function(mainType, idx) {
        var list = this._componentsMap.get(mainType);
        if (list) {
            var cmpt = list[idx || 0];
            if (cmpt) return cmpt;
            else if (idx == null) for(var i = 0; i < list.length; i++){
                if (list[i]) return list[i];
            }
        }
    };
    /**
   * @return Never be null/undefined.
   */ GlobalModel.prototype.queryComponents = function(condition) {
        var mainType = condition.mainType;
        if (!mainType) return [];
        var index = condition.index;
        var id = condition.id;
        var name = condition.name;
        var cmpts = this._componentsMap.get(mainType);
        if (!cmpts || !cmpts.length) return [];
        var result;
        if (index != null) {
            result = [];
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($76d619f648247e6d$export$4f07b212a02c8051(index), function(idx) {
                cmpts[idx] && result.push(cmpts[idx]);
            });
        } else if (id != null) result = $51f6ef0dd9546916$var$queryByIdOrName('id', id, cmpts);
        else if (name != null) result = $51f6ef0dd9546916$var$queryByIdOrName('name', name, cmpts);
        else // Return all non-empty components in that mainType
        result = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(cmpts, function(cmpt) {
            return !!cmpt;
        });
        return $51f6ef0dd9546916$var$filterBySubType(result, condition);
    };
    /**
   * The interface is different from queryComponents,
   * which is convenient for inner usage.
   *
   * @usage
   * let result = findComponents(
   *     {mainType: 'dataZoom', query: {dataZoomId: 'abc'}}
   * );
   * let result = findComponents(
   *     {mainType: 'series', subType: 'pie', query: {seriesName: 'uio'}}
   * );
   * let result = findComponents(
   *     {mainType: 'series',
   *     filter: function (model, index) {...}}
   * );
   * // result like [component0, componnet1, ...]
   */ GlobalModel.prototype.findComponents = function(condition) {
        var query = condition.query;
        var mainType = condition.mainType;
        var queryCond = getQueryCond(query);
        var result = queryCond ? this.queryComponents(queryCond) : (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(this._componentsMap.get(mainType), function(cmpt) {
            return !!cmpt;
        });
        return doFilter($51f6ef0dd9546916$var$filterBySubType(result, condition));
        function getQueryCond(q) {
            var indexAttr = mainType + 'Index';
            var idAttr = mainType + 'Id';
            var nameAttr = mainType + 'Name';
            return q && (q[indexAttr] != null || q[idAttr] != null || q[nameAttr] != null) ? {
                mainType: mainType,
                // subType will be filtered finally.
                index: q[indexAttr],
                id: q[idAttr],
                name: q[nameAttr]
            } : null;
        }
        function doFilter(res) {
            return condition.filter ? (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(res, condition.filter) : res;
        }
    };
    GlobalModel.prototype.eachComponent = function(mainType, cb, context) {
        var componentsMap = this._componentsMap;
        if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(mainType)) {
            var ctxForAll_1 = cb;
            var cbForAll_1 = mainType;
            componentsMap.each(function(cmpts, componentType) {
                for(var i = 0; cmpts && i < cmpts.length; i++){
                    var cmpt = cmpts[i];
                    cmpt && cbForAll_1.call(ctxForAll_1, componentType, cmpt, cmpt.componentIndex);
                }
            });
        } else {
            var cmpts = (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(mainType) ? componentsMap.get(mainType) : (0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(mainType) ? this.findComponents(mainType) : null;
            for(var i = 0; cmpts && i < cmpts.length; i++){
                var cmpt = cmpts[i];
                cmpt && cb.call(context, cmpt, cmpt.componentIndex);
            }
        }
    };
    /**
   * Get series list before filtered by name.
   */ GlobalModel.prototype.getSeriesByName = function(name) {
        var nameStr = $76d619f648247e6d$export$fb1a222ba5dd6e51(name, null);
        return (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(this._componentsMap.get('series'), function(oneSeries) {
            return !!oneSeries && nameStr != null && oneSeries.name === nameStr;
        });
    };
    /**
   * Get series list before filtered by index.
   */ GlobalModel.prototype.getSeriesByIndex = function(seriesIndex) {
        return this._componentsMap.get('series')[seriesIndex];
    };
    /**
   * Get series list before filtered by type.
   * FIXME: rename to getRawSeriesByType?
   */ GlobalModel.prototype.getSeriesByType = function(subType) {
        return (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(this._componentsMap.get('series'), function(oneSeries) {
            return !!oneSeries && oneSeries.subType === subType;
        });
    };
    /**
   * Get all series before filtered.
   */ GlobalModel.prototype.getSeries = function() {
        return (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(this._componentsMap.get('series'), function(oneSeries) {
            return !!oneSeries;
        });
    };
    /**
   * Count series before filtered.
   */ GlobalModel.prototype.getSeriesCount = function() {
        return this._componentsCount.get('series');
    };
    /**
   * After filtering, series may be different
   * from raw series.
   */ GlobalModel.prototype.eachSeries = function(cb, context) {
        $51f6ef0dd9546916$var$assertSeriesInitialized(this);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._seriesIndices, function(rawSeriesIndex) {
            var series = this._componentsMap.get('series')[rawSeriesIndex];
            cb.call(context, series, rawSeriesIndex);
        }, this);
    };
    /**
   * Iterate raw series before filtered.
   *
   * @param {Function} cb
   * @param {*} context
   */ GlobalModel.prototype.eachRawSeries = function(cb, context) {
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._componentsMap.get('series'), function(series) {
            series && cb.call(context, series, series.componentIndex);
        });
    };
    /**
   * After filtering, series may be different.
   * from raw series.
   */ GlobalModel.prototype.eachSeriesByType = function(subType, cb, context) {
        $51f6ef0dd9546916$var$assertSeriesInitialized(this);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._seriesIndices, function(rawSeriesIndex) {
            var series = this._componentsMap.get('series')[rawSeriesIndex];
            if (series.subType === subType) cb.call(context, series, rawSeriesIndex);
        }, this);
    };
    /**
   * Iterate raw series before filtered of given type.
   */ GlobalModel.prototype.eachRawSeriesByType = function(subType, cb, context) {
        return (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this.getSeriesByType(subType), cb, context);
    };
    GlobalModel.prototype.isSeriesFiltered = function(seriesModel) {
        $51f6ef0dd9546916$var$assertSeriesInitialized(this);
        return this._seriesIndicesMap.get(seriesModel.componentIndex) == null;
    };
    GlobalModel.prototype.getCurrentSeriesIndices = function() {
        return (this._seriesIndices || []).slice();
    };
    GlobalModel.prototype.filterSeries = function(cb, context) {
        $51f6ef0dd9546916$var$assertSeriesInitialized(this);
        var newSeriesIndices = [];
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._seriesIndices, function(seriesRawIdx) {
            var series = this._componentsMap.get('series')[seriesRawIdx];
            cb.call(context, series, seriesRawIdx) && newSeriesIndices.push(seriesRawIdx);
        }, this);
        this._seriesIndices = newSeriesIndices;
        this._seriesIndicesMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)(newSeriesIndices);
    };
    GlobalModel.prototype.restoreData = function(payload) {
        $51f6ef0dd9546916$var$reCreateSeriesIndices(this);
        var componentsMap = this._componentsMap;
        var componentTypes = [];
        componentsMap.each(function(components, componentType) {
            if ((0, $116d65051f61bdfe$export$2e2bcd8739ae039).hasClass(componentType)) componentTypes.push(componentType);
        });
        (0, $116d65051f61bdfe$export$2e2bcd8739ae039).topologicalTravel(componentTypes, (0, $116d65051f61bdfe$export$2e2bcd8739ae039).getAllClassMainTypes(), function(componentType) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(componentsMap.get(componentType), function(component) {
                if (component && (componentType !== 'series' || !$51f6ef0dd9546916$var$isNotTargetSeries(component, payload))) component.restoreData();
            });
        });
    };
    GlobalModel.internalField = function() {
        $51f6ef0dd9546916$var$reCreateSeriesIndices = function(ecModel) {
            var seriesIndices = ecModel._seriesIndices = [];
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(ecModel._componentsMap.get('series'), function(series) {
                // series may have been removed by `replaceMerge`.
                series && seriesIndices.push(series.componentIndex);
            });
            ecModel._seriesIndicesMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)(seriesIndices);
        };
        $51f6ef0dd9546916$var$assertSeriesInitialized = function(ecModel) {};
        $51f6ef0dd9546916$var$initBase = function(ecModel, baseOption) {
            // Using OPTION_INNER_KEY to mark that this option cannot be used outside,
            // i.e. `chart.setOption(chart.getModel().option);` is forbidden.
            ecModel.option = {};
            ecModel.option[$51f6ef0dd9546916$var$OPTION_INNER_KEY] = $51f6ef0dd9546916$var$OPTION_INNER_VALUE;
            // Init with series: [], in case of calling findSeries method
            // before series initialized.
            ecModel._componentsMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)({
                series: []
            });
            ecModel._componentsCount = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
            // If user spefied `option.aria`, aria will be enable. This detection should be
            // performed before theme and globalDefault merge.
            var airaOption = baseOption.aria;
            if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(airaOption) && airaOption.enabled == null) airaOption.enabled = true;
            $51f6ef0dd9546916$var$mergeTheme(baseOption, ecModel._theme.option);
            // TODO Needs clone when merging to the unexisted property
            (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)(baseOption, (0, $2d7ac35b3b3d57e3$export$2e2bcd8739ae039), false);
            ecModel._mergeOption(baseOption, null);
        };
    }();
    return GlobalModel;
}((0, $6818646a97528290$export$2e2bcd8739ae039));
function $51f6ef0dd9546916$var$isNotTargetSeries(seriesModel, payload) {
    if (payload) {
        var index = payload.seriesIndex;
        var id = payload.seriesId;
        var name_1 = payload.seriesName;
        return index != null && seriesModel.componentIndex !== index || id != null && seriesModel.id !== id || name_1 != null && seriesModel.name !== name_1;
    }
}
function $51f6ef0dd9546916$var$mergeTheme(option, theme) {
    // PENDING
    // NOT use `colorLayer` in theme if option has `color`
    var notMergeColorLayer = option.color && !option.colorLayer;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(theme, function(themeItem, name) {
        if (name === 'colorLayer' && notMergeColorLayer) return;
        // If it is component model mainType, the model handles that merge later.
        // otherwise, merge them here.
        if (!(0, $116d65051f61bdfe$export$2e2bcd8739ae039).hasClass(name)) {
            if (typeof themeItem === 'object') option[name] = !option[name] ? (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(themeItem) : (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)(option[name], themeItem, false);
            else if (option[name] == null) option[name] = themeItem;
        }
    });
}
function $51f6ef0dd9546916$var$queryByIdOrName(attr, idOrName, cmpts) {
    // Here is a break from echarts4: string and number are
    // treated as equal.
    if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(idOrName)) {
        var keyMap_1 = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(idOrName, function(idOrNameItem) {
            if (idOrNameItem != null) {
                var idName = $76d619f648247e6d$export$fb1a222ba5dd6e51(idOrNameItem, null);
                idName != null && keyMap_1.set(idOrNameItem, true);
            }
        });
        return (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(cmpts, function(cmpt) {
            return cmpt && keyMap_1.get(cmpt[attr]);
        });
    } else {
        var idName_1 = $76d619f648247e6d$export$fb1a222ba5dd6e51(idOrName, null);
        return (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(cmpts, function(cmpt) {
            return cmpt && idName_1 != null && cmpt[attr] === idName_1;
        });
    }
}
function $51f6ef0dd9546916$var$filterBySubType(components, condition) {
    // Using hasOwnProperty for restrict. Consider
    // subType is undefined in user payload.
    return condition.hasOwnProperty('subType') ? (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(components, function(cmpt) {
        return cmpt && cmpt.subType === condition.subType;
    }) : components;
}
function $51f6ef0dd9546916$var$normalizeSetOptionInput(opts) {
    var replaceMergeMainTypeMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    opts && (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($76d619f648247e6d$export$4f07b212a02c8051(opts.replaceMerge), function(mainType) {
        replaceMergeMainTypeMap.set(mainType, true);
    });
    return {
        replaceMergeMainTypeMap: replaceMergeMainTypeMap
    };
}
(0, $7a1bd9c2710fea0d$export$e36fc9d62a853069)($51f6ef0dd9546916$var$GlobalModel, (0, $e7fbd47751ca3c28$export$55a3c39e852b90f4));
var $51f6ef0dd9546916$export$2e2bcd8739ae039 = $51f6ef0dd9546916$var$GlobalModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $a6d7e6163195660e$var$availableMethods = [
    'getDom',
    'getZr',
    'getWidth',
    'getHeight',
    'getDevicePixelRatio',
    'dispatchAction',
    'isSSR',
    'isDisposed',
    'on',
    'off',
    'getDataURL',
    'getConnectedDataURL',
    // 'getModel',
    'getOption',
    // 'getViewOfComponentModel',
    // 'getViewOfSeriesModel',
    'getId',
    'updateLabelLayout'
];
var $a6d7e6163195660e$var$ExtensionAPI = /** @class */ function() {
    function ExtensionAPI(ecInstance) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43($a6d7e6163195660e$var$availableMethods, function(methodName) {
            this[methodName] = $7a1bd9c2710fea0d$export$2385a24977818dd0(ecInstance[methodName], ecInstance);
        }, this);
    }
    return ExtensionAPI;
}();
var $a6d7e6163195660e$export$2e2bcd8739ae039 = $a6d7e6163195660e$var$ExtensionAPI;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $70c3ede7d3b64757$var$coordinateSystemCreators = {};
var $70c3ede7d3b64757$var$CoordinateSystemManager = /** @class */ function() {
    function CoordinateSystemManager() {
        this._coordinateSystems = [];
    }
    CoordinateSystemManager.prototype.create = function(ecModel, api) {
        var coordinateSystems = [];
        $7a1bd9c2710fea0d$export$79b2f7037acddd43($70c3ede7d3b64757$var$coordinateSystemCreators, function(creator, type) {
            var list = creator.create(ecModel, api);
            coordinateSystems = coordinateSystems.concat(list || []);
        });
        this._coordinateSystems = coordinateSystems;
    };
    CoordinateSystemManager.prototype.update = function(ecModel, api) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(this._coordinateSystems, function(coordSys) {
            coordSys.update && coordSys.update(ecModel, api);
        });
    };
    CoordinateSystemManager.prototype.getCoordinateSystems = function() {
        return this._coordinateSystems.slice();
    };
    CoordinateSystemManager.register = function(type, creator) {
        $70c3ede7d3b64757$var$coordinateSystemCreators[type] = creator;
    };
    CoordinateSystemManager.get = function(type) {
        return $70c3ede7d3b64757$var$coordinateSystemCreators[type];
    };
    return CoordinateSystemManager;
}();
var $70c3ede7d3b64757$export$2e2bcd8739ae039 = $70c3ede7d3b64757$var$CoordinateSystemManager;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $bf4c0a9077b4e970$var$QUERY_REG = /^(min|max)?(.+)$/;
// Key: mainType
// type FakeComponentsMap = HashMap<(MappingExistingItem & { subType: string })[]>;
/**
 * TERM EXPLANATIONS:
 * See `ECOption` and `ECUnitOption` in `src/util/types.ts`.
 */ var $bf4c0a9077b4e970$var$OptionManager = /** @class */ function() {
    // timeline.notMerge is not supported in ec3. Firstly there is rearly
    // case that notMerge is needed. Secondly supporting 'notMerge' requires
    // rawOption cloned and backuped when timeline changed, which does no
    // good to performance. What's more, that both timeline and setOption
    // method supply 'notMerge' brings complex and some problems.
    // Consider this case:
    // (step1) chart.setOption({timeline: {notMerge: false}, ...}, false);
    // (step2) chart.setOption({timeline: {notMerge: true}, ...}, false);
    function OptionManager(api) {
        this._timelineOptions = [];
        this._mediaList = [];
        /**
     * -1, means default.
     * empty means no media.
     */ this._currentMediaIndices = [];
        this._api = api;
    }
    OptionManager.prototype.setOption = function(rawOption, optionPreprocessorFuncs, opt) {
        if (rawOption) {
            // That set dat primitive is dangerous if user reuse the data when setOption again.
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $76d619f648247e6d$export$4f07b212a02c8051)(rawOption.series), function(series) {
                series && series.data && (0, $7a1bd9c2710fea0d$export$b119cc7e1840e59c)(series.data) && (0, $7a1bd9c2710fea0d$export$112e66431016387b)(series.data);
            });
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $76d619f648247e6d$export$4f07b212a02c8051)(rawOption.dataset), function(dataset) {
                dataset && dataset.source && (0, $7a1bd9c2710fea0d$export$b119cc7e1840e59c)(dataset.source) && (0, $7a1bd9c2710fea0d$export$112e66431016387b)(dataset.source);
            });
        }
        // Caution: some series modify option data, if do not clone,
        // it should ensure that the repeat modify correctly
        // (create a new object when modify itself).
        rawOption = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(rawOption);
        // FIXME
        // If some property is set in timeline options or media option but
        // not set in baseOption, a warning should be given.
        var optionBackup = this._optionBackup;
        var newParsedOption = $bf4c0a9077b4e970$var$parseRawOption(rawOption, optionPreprocessorFuncs, !optionBackup);
        this._newBaseOption = newParsedOption.baseOption;
        // For setOption at second time (using merge mode);
        if (optionBackup) {
            // FIXME
            // the restore merge solution is essentially incorrect.
            // the mapping can not be 100% consistent with ecModel, which probably brings
            // potential bug!
            // The first merge is delayed, because in most cases, users do not call `setOption` twice.
            // let fakeCmptsMap = this._fakeCmptsMap;
            // if (!fakeCmptsMap) {
            //     fakeCmptsMap = this._fakeCmptsMap = createHashMap();
            //     mergeToBackupOption(fakeCmptsMap, null, optionBackup.baseOption, null);
            // }
            // mergeToBackupOption(
            //     fakeCmptsMap, optionBackup.baseOption, newParsedOption.baseOption, opt
            // );
            // For simplicity, timeline options and media options do not support merge,
            // that is, if you `setOption` twice and both has timeline options, the latter
            // timeline options will not be merged to the former, but just substitute them.
            if (newParsedOption.timelineOptions.length) optionBackup.timelineOptions = newParsedOption.timelineOptions;
            if (newParsedOption.mediaList.length) optionBackup.mediaList = newParsedOption.mediaList;
            if (newParsedOption.mediaDefault) optionBackup.mediaDefault = newParsedOption.mediaDefault;
        } else this._optionBackup = newParsedOption;
    };
    OptionManager.prototype.mountOption = function(isRecreate) {
        var optionBackup = this._optionBackup;
        this._timelineOptions = optionBackup.timelineOptions;
        this._mediaList = optionBackup.mediaList;
        this._mediaDefault = optionBackup.mediaDefault;
        this._currentMediaIndices = [];
        return (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(isRecreate ? optionBackup.baseOption : this._newBaseOption);
    };
    OptionManager.prototype.getTimelineOption = function(ecModel) {
        var option;
        var timelineOptions = this._timelineOptions;
        if (timelineOptions.length) {
            // getTimelineOption can only be called after ecModel inited,
            // so we can get currentIndex from timelineModel.
            var timelineModel = ecModel.getComponent('timeline');
            if (timelineModel) option = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(// FIXME:TS as TimelineModel or quivlant interface
            timelineOptions[timelineModel.getCurrentIndex()]);
        }
        return option;
    };
    OptionManager.prototype.getMediaOption = function(ecModel) {
        var ecWidth = this._api.getWidth();
        var ecHeight = this._api.getHeight();
        var mediaList = this._mediaList;
        var mediaDefault = this._mediaDefault;
        var indices = [];
        var result = [];
        // No media defined.
        if (!mediaList.length && !mediaDefault) return result;
        // Multi media may be applied, the latter defined media has higher priority.
        for(var i = 0, len = mediaList.length; i < len; i++)if ($bf4c0a9077b4e970$var$applyMediaQuery(mediaList[i].query, ecWidth, ecHeight)) indices.push(i);
        // FIXME
        // Whether mediaDefault should force users to provide? Otherwise
        // the change by media query can not be recorvered.
        if (!indices.length && mediaDefault) indices = [
            -1
        ];
        if (indices.length && !$bf4c0a9077b4e970$var$indicesEquals(indices, this._currentMediaIndices)) result = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(indices, function(index) {
            return (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(index === -1 ? mediaDefault.option : mediaList[index].option);
        });
        // Otherwise return nothing.
        this._currentMediaIndices = indices;
        return result;
    };
    return OptionManager;
}();
/**
 * [RAW_OPTION_PATTERNS]
 * (Note: "series: []" represents all other props in `ECUnitOption`)
 *
 * (1) No prop "baseOption" declared:
 * Root option is used as "baseOption" (except prop "options" and "media").
 * ```js
 * option = {
 *     series: [],
 *     timeline: {},
 *     options: [],
 * };
 * option = {
 *     series: [],
 *     media: {},
 * };
 * option = {
 *     series: [],
 *     timeline: {},
 *     options: [],
 *     media: {},
 * }
 * ```
 *
 * (2) Prop "baseOption" declared:
 * If "baseOption" declared, `ECUnitOption` props can only be declared
 * inside "baseOption" except prop "timeline" (compat ec2).
 * ```js
 * option = {
 *     baseOption: {
 *         timeline: {},
 *         series: [],
 *     },
 *     options: []
 * };
 * option = {
 *     baseOption: {
 *         series: [],
 *     },
 *     media: []
 * };
 * option = {
 *     baseOption: {
 *         timeline: {},
 *         series: [],
 *     },
 *     options: []
 *     media: []
 * };
 * option = {
 *     // ec3 compat ec2: allow (only) `timeline` declared
 *     // outside baseOption. Keep this setting for compat.
 *     timeline: {},
 *     baseOption: {
 *         series: [],
 *     },
 *     options: [],
 *     media: []
 * };
 * ```
 */ function $bf4c0a9077b4e970$var$parseRawOption(// `rawOption` May be modified
rawOption, optionPreprocessorFuncs, isNew) {
    var mediaList = [];
    var mediaDefault;
    var baseOption;
    var declaredBaseOption = rawOption.baseOption;
    // Compatible with ec2, [RAW_OPTION_PATTERNS] above.
    var timelineOnRoot = rawOption.timeline;
    var timelineOptionsOnRoot = rawOption.options;
    var mediaOnRoot = rawOption.media;
    var hasMedia = !!rawOption.media;
    var hasTimeline = !!(timelineOptionsOnRoot || timelineOnRoot || declaredBaseOption && declaredBaseOption.timeline);
    if (declaredBaseOption) {
        baseOption = declaredBaseOption;
        // For merge option.
        if (!baseOption.timeline) baseOption.timeline = timelineOnRoot;
    } else {
        if (hasTimeline || hasMedia) rawOption.options = rawOption.media = null;
        baseOption = rawOption;
    }
    if (hasMedia) {
        if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(mediaOnRoot)) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(mediaOnRoot, function(singleMedia) {
            if (singleMedia && singleMedia.option) {
                if (singleMedia.query) mediaList.push(singleMedia);
                else if (!mediaDefault) // Use the first media default.
                mediaDefault = singleMedia;
            }
        });
    }
    doPreprocess(baseOption);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(timelineOptionsOnRoot, function(option) {
        return doPreprocess(option);
    });
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(mediaList, function(media) {
        return doPreprocess(media.option);
    });
    function doPreprocess(option) {
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(optionPreprocessorFuncs, function(preProcess) {
            preProcess(option, isNew);
        });
    }
    return {
        baseOption: baseOption,
        timelineOptions: timelineOptionsOnRoot || [],
        mediaDefault: mediaDefault,
        mediaList: mediaList
    };
}
/**
 * @see <http://www.w3.org/TR/css3-mediaqueries/#media1>
 * Support: width, height, aspectRatio
 * Can use max or min as prefix.
 */ function $bf4c0a9077b4e970$var$applyMediaQuery(query, ecWidth, ecHeight) {
    var realMap = {
        width: ecWidth,
        height: ecHeight,
        aspectratio: ecWidth / ecHeight // lower case for convenience.
    };
    var applicable = true;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(query, function(value, attr) {
        var matched = attr.match($bf4c0a9077b4e970$var$QUERY_REG);
        if (!matched || !matched[1] || !matched[2]) return;
        var operator = matched[1];
        var realAttr = matched[2].toLowerCase();
        if (!$bf4c0a9077b4e970$var$compare(realMap[realAttr], value, operator)) applicable = false;
    });
    return applicable;
}
function $bf4c0a9077b4e970$var$compare(real, expect, operator) {
    if (operator === 'min') return real >= expect;
    else if (operator === 'max') return real <= expect;
    else // Equals
    return real === expect;
}
function $bf4c0a9077b4e970$var$indicesEquals(indices1, indices2) {
    // indices is always order by asc and has only finite number.
    return indices1.join(',') === indices2.join(',');
}
var /**
 * Consider case:
 * `chart.setOption(opt1);`
 * Then user do some interaction like dataZoom, dataView changing.
 * `chart.setOption(opt2);`
 * Then user press 'reset button' in toolbox.
 *
 * After doing that all of the interaction effects should be reset, the
 * chart should be the same as the result of invoke
 * `chart.setOption(opt1); chart.setOption(opt2);`.
 *
 * Although it is not able ensure that
 * `chart.setOption(opt1); chart.setOption(opt2);` is equivalents to
 * `chart.setOption(merge(opt1, opt2));` exactly,
 * this might be the only simple way to implement that feature.
 *
 * MEMO: We've considered some other approaches:
 * 1. Each model handles its self restoration but not uniform treatment.
 *     (Too complex in logic and error-prone)
 * 2. Use a shadow ecModel. (Performance expensive)
 *
 * FIXME: A possible solution:
 * Add a extra level of model for each component model. The inheritance chain would be:
 * ecModel <- componentModel <- componentActionModel <- dataItemModel
 * And all of the actions can only modify the `componentActionModel` rather than
 * `componentModel`. `setOption` will only modify the `ecModel` and `componentModel`.
 * When "resotre" action triggered, model from `componentActionModel` will be discarded
 * instead of recreating the "ecModel" from the "_optionBackup".
 */ // function mergeToBackupOption(
//     fakeCmptsMap: FakeComponentsMap,
//     // `tarOption` Can be null/undefined, means init
//     tarOption: ECUnitOption,
//     newOption: ECUnitOption,
//     // Can be null/undefined
//     opt: InnerSetOptionOpts
// ): void {
//     newOption = newOption || {} as ECUnitOption;
//     const notInit = !!tarOption;
//     each(newOption, function (newOptsInMainType, mainType) {
//         if (newOptsInMainType == null) {
//             return;
//         }
//         if (!ComponentModel.hasClass(mainType)) {
//             if (tarOption) {
//                 tarOption[mainType] = merge(tarOption[mainType], newOptsInMainType, true);
//             }
//         }
//         else {
//             const oldTarOptsInMainType = notInit ? normalizeToArray(tarOption[mainType]) : null;
//             const oldFakeCmptsInMainType = fakeCmptsMap.get(mainType) || [];
//             const resultTarOptsInMainType = notInit ? (tarOption[mainType] = [] as ComponentOption[]) : null;
//             const resultFakeCmptsInMainType = fakeCmptsMap.set(mainType, []);
//             const mappingResult = mappingToExists(
//                 oldFakeCmptsInMainType,
//                 normalizeToArray(newOptsInMainType),
//                 (opt && opt.replaceMergeMainTypeMap.get(mainType)) ? 'replaceMerge' : 'normalMerge'
//             );
//             setComponentTypeToKeyInfo(mappingResult, mainType, ComponentModel as ComponentModelConstructor);
//             each(mappingResult, function (resultItem, index) {
//                 // The same logic as `Global.ts#_mergeOption`.
//                 let fakeCmpt = resultItem.existing;
//                 const newOption = resultItem.newOption;
//                 const keyInfo = resultItem.keyInfo;
//                 let fakeCmptOpt;
//                 if (!newOption) {
//                     fakeCmptOpt = oldTarOptsInMainType[index];
//                 }
//                 else {
//                     if (fakeCmpt && fakeCmpt.subType === keyInfo.subType) {
//                         fakeCmpt.name = keyInfo.name;
//                         if (notInit) {
//                             fakeCmptOpt = merge(oldTarOptsInMainType[index], newOption, true);
//                         }
//                     }
//                     else {
//                         fakeCmpt = extend({}, keyInfo);
//                         if (notInit) {
//                             fakeCmptOpt = clone(newOption);
//                         }
//                     }
//                 }
//                 if (fakeCmpt) {
//                     notInit && resultTarOptsInMainType.push(fakeCmptOpt);
//                     resultFakeCmptsInMainType.push(fakeCmpt);
//                 }
//                 else {
//                     notInit && resultTarOptsInMainType.push(void 0);
//                     resultFakeCmptsInMainType.push(void 0);
//                 }
//             });
//         }
//     });
// }
$bf4c0a9077b4e970$export$2e2bcd8739ae039 = $bf4c0a9077b4e970$var$OptionManager;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $621cc5e1b758ea39$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
var $621cc5e1b758ea39$var$isObject = $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a;
var $621cc5e1b758ea39$var$POSSIBLE_STYLES = [
    'areaStyle',
    'lineStyle',
    'nodeStyle',
    'linkStyle',
    'chordStyle',
    'label',
    'labelLine'
];
function $621cc5e1b758ea39$var$compatEC2ItemStyle(opt) {
    var itemStyleOpt = opt && opt.itemStyle;
    if (!itemStyleOpt) return;
    for(var i = 0, len = $621cc5e1b758ea39$var$POSSIBLE_STYLES.length; i < len; i++){
        var styleName = $621cc5e1b758ea39$var$POSSIBLE_STYLES[i];
        var normalItemStyleOpt = itemStyleOpt.normal;
        var emphasisItemStyleOpt = itemStyleOpt.emphasis;
        if (normalItemStyleOpt && normalItemStyleOpt[styleName]) {
            opt[styleName] = opt[styleName] || {};
            if (!opt[styleName].normal) opt[styleName].normal = normalItemStyleOpt[styleName];
            else $7a1bd9c2710fea0d$export$4950aa0f605343fb(opt[styleName].normal, normalItemStyleOpt[styleName]);
            normalItemStyleOpt[styleName] = null;
        }
        if (emphasisItemStyleOpt && emphasisItemStyleOpt[styleName]) {
            opt[styleName] = opt[styleName] || {};
            if (!opt[styleName].emphasis) opt[styleName].emphasis = emphasisItemStyleOpt[styleName];
            else $7a1bd9c2710fea0d$export$4950aa0f605343fb(opt[styleName].emphasis, emphasisItemStyleOpt[styleName]);
            emphasisItemStyleOpt[styleName] = null;
        }
    }
}
function $621cc5e1b758ea39$var$convertNormalEmphasis(opt, optType, useExtend) {
    if (opt && opt[optType] && (opt[optType].normal || opt[optType].emphasis)) {
        var normalOpt = opt[optType].normal;
        var emphasisOpt = opt[optType].emphasis;
        if (normalOpt) {
            // Timeline controlStyle has other properties besides normal and emphasis
            if (useExtend) {
                opt[optType].normal = opt[optType].emphasis = null;
                $7a1bd9c2710fea0d$export$ebe90cb607ad99e(opt[optType], normalOpt);
            } else opt[optType] = normalOpt;
        }
        if (emphasisOpt) {
            opt.emphasis = opt.emphasis || {};
            opt.emphasis[optType] = emphasisOpt;
            // Also compat the case user mix the style and focus together in ec3 style
            // for example: { itemStyle: { normal: {}, emphasis: {focus, shadowBlur} } }
            if (emphasisOpt.focus) opt.emphasis.focus = emphasisOpt.focus;
            if (emphasisOpt.blurScope) opt.emphasis.blurScope = emphasisOpt.blurScope;
        }
    }
}
function $621cc5e1b758ea39$var$removeEC3NormalStatus(opt) {
    $621cc5e1b758ea39$var$convertNormalEmphasis(opt, 'itemStyle');
    $621cc5e1b758ea39$var$convertNormalEmphasis(opt, 'lineStyle');
    $621cc5e1b758ea39$var$convertNormalEmphasis(opt, 'areaStyle');
    $621cc5e1b758ea39$var$convertNormalEmphasis(opt, 'label');
    $621cc5e1b758ea39$var$convertNormalEmphasis(opt, 'labelLine');
    // treemap
    $621cc5e1b758ea39$var$convertNormalEmphasis(opt, 'upperLabel');
    // graph
    $621cc5e1b758ea39$var$convertNormalEmphasis(opt, 'edgeLabel');
}
function $621cc5e1b758ea39$var$compatTextStyle(opt, propName) {
    // Check whether is not object (string\null\undefined ...)
    var labelOptSingle = $621cc5e1b758ea39$var$isObject(opt) && opt[propName];
    var textStyle = $621cc5e1b758ea39$var$isObject(labelOptSingle) && labelOptSingle.textStyle;
    if (textStyle) for(var i = 0, len = $76d619f648247e6d$export$df45610347a602ad.length; i < len; i++){
        var textPropName = $76d619f648247e6d$export$df45610347a602ad[i];
        if (textStyle.hasOwnProperty(textPropName)) labelOptSingle[textPropName] = textStyle[textPropName];
    }
}
function $621cc5e1b758ea39$var$compatEC3CommonStyles(opt) {
    if (opt) {
        $621cc5e1b758ea39$var$removeEC3NormalStatus(opt);
        $621cc5e1b758ea39$var$compatTextStyle(opt, 'label');
        opt.emphasis && $621cc5e1b758ea39$var$compatTextStyle(opt.emphasis, 'label');
    }
}
function $621cc5e1b758ea39$var$processSeries(seriesOpt) {
    if (!$621cc5e1b758ea39$var$isObject(seriesOpt)) return;
    $621cc5e1b758ea39$var$compatEC2ItemStyle(seriesOpt);
    $621cc5e1b758ea39$var$removeEC3NormalStatus(seriesOpt);
    $621cc5e1b758ea39$var$compatTextStyle(seriesOpt, 'label');
    // treemap
    $621cc5e1b758ea39$var$compatTextStyle(seriesOpt, 'upperLabel');
    // graph
    $621cc5e1b758ea39$var$compatTextStyle(seriesOpt, 'edgeLabel');
    if (seriesOpt.emphasis) {
        $621cc5e1b758ea39$var$compatTextStyle(seriesOpt.emphasis, 'label');
        // treemap
        $621cc5e1b758ea39$var$compatTextStyle(seriesOpt.emphasis, 'upperLabel');
        // graph
        $621cc5e1b758ea39$var$compatTextStyle(seriesOpt.emphasis, 'edgeLabel');
    }
    var markPoint = seriesOpt.markPoint;
    if (markPoint) {
        $621cc5e1b758ea39$var$compatEC2ItemStyle(markPoint);
        $621cc5e1b758ea39$var$compatEC3CommonStyles(markPoint);
    }
    var markLine = seriesOpt.markLine;
    if (markLine) {
        $621cc5e1b758ea39$var$compatEC2ItemStyle(markLine);
        $621cc5e1b758ea39$var$compatEC3CommonStyles(markLine);
    }
    var markArea = seriesOpt.markArea;
    if (markArea) $621cc5e1b758ea39$var$compatEC3CommonStyles(markArea);
    var data = seriesOpt.data;
    // Break with ec3: if `setOption` again, there may be no `type` in option,
    // then the backward compat based on option type will not be performed.
    if (seriesOpt.type === 'graph') {
        data = data || seriesOpt.nodes;
        var edgeData = seriesOpt.links || seriesOpt.edges;
        if (edgeData && !$7a1bd9c2710fea0d$export$b119cc7e1840e59c(edgeData)) for(var i = 0; i < edgeData.length; i++)$621cc5e1b758ea39$var$compatEC3CommonStyles(edgeData[i]);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(seriesOpt.categories, function(opt) {
            $621cc5e1b758ea39$var$removeEC3NormalStatus(opt);
        });
    }
    if (data && !$7a1bd9c2710fea0d$export$b119cc7e1840e59c(data)) for(var i = 0; i < data.length; i++)$621cc5e1b758ea39$var$compatEC3CommonStyles(data[i]);
    // mark point data
    markPoint = seriesOpt.markPoint;
    if (markPoint && markPoint.data) {
        var mpData = markPoint.data;
        for(var i = 0; i < mpData.length; i++)$621cc5e1b758ea39$var$compatEC3CommonStyles(mpData[i]);
    }
    // mark line data
    markLine = seriesOpt.markLine;
    if (markLine && markLine.data) {
        var mlData = markLine.data;
        for(var i = 0; i < mlData.length; i++)if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(mlData[i])) {
            $621cc5e1b758ea39$var$compatEC3CommonStyles(mlData[i][0]);
            $621cc5e1b758ea39$var$compatEC3CommonStyles(mlData[i][1]);
        } else $621cc5e1b758ea39$var$compatEC3CommonStyles(mlData[i]);
    }
    // Series
    if (seriesOpt.type === 'gauge') {
        $621cc5e1b758ea39$var$compatTextStyle(seriesOpt, 'axisLabel');
        $621cc5e1b758ea39$var$compatTextStyle(seriesOpt, 'title');
        $621cc5e1b758ea39$var$compatTextStyle(seriesOpt, 'detail');
    } else if (seriesOpt.type === 'treemap') {
        $621cc5e1b758ea39$var$convertNormalEmphasis(seriesOpt.breadcrumb, 'itemStyle');
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(seriesOpt.levels, function(opt) {
            $621cc5e1b758ea39$var$removeEC3NormalStatus(opt);
        });
    } else if (seriesOpt.type === 'tree') $621cc5e1b758ea39$var$removeEC3NormalStatus(seriesOpt.leaves);
// sunburst starts from ec4, so it does not need to compat levels.
}
function $621cc5e1b758ea39$var$toArr(o) {
    return $7a1bd9c2710fea0d$export$43bee75e5e14138e(o) ? o : o ? [
        o
    ] : [];
}
function $621cc5e1b758ea39$var$toObj(o) {
    return ($7a1bd9c2710fea0d$export$43bee75e5e14138e(o) ? o[0] : o) || {};
}
function $621cc5e1b758ea39$export$2e2bcd8739ae039(option, isTheme) {
    $621cc5e1b758ea39$var$each($621cc5e1b758ea39$var$toArr(option.series), function(seriesOpt) {
        $621cc5e1b758ea39$var$isObject(seriesOpt) && $621cc5e1b758ea39$var$processSeries(seriesOpt);
    });
    var axes = [
        'xAxis',
        'yAxis',
        'radiusAxis',
        'angleAxis',
        'singleAxis',
        'parallelAxis',
        'radar'
    ];
    isTheme && axes.push('valueAxis', 'categoryAxis', 'logAxis', 'timeAxis');
    $621cc5e1b758ea39$var$each(axes, function(axisName) {
        $621cc5e1b758ea39$var$each($621cc5e1b758ea39$var$toArr(option[axisName]), function(axisOpt) {
            if (axisOpt) {
                $621cc5e1b758ea39$var$compatTextStyle(axisOpt, 'axisLabel');
                $621cc5e1b758ea39$var$compatTextStyle(axisOpt.axisPointer, 'label');
            }
        });
    });
    $621cc5e1b758ea39$var$each($621cc5e1b758ea39$var$toArr(option.parallel), function(parallelOpt) {
        var parallelAxisDefault = parallelOpt && parallelOpt.parallelAxisDefault;
        $621cc5e1b758ea39$var$compatTextStyle(parallelAxisDefault, 'axisLabel');
        $621cc5e1b758ea39$var$compatTextStyle(parallelAxisDefault && parallelAxisDefault.axisPointer, 'label');
    });
    $621cc5e1b758ea39$var$each($621cc5e1b758ea39$var$toArr(option.calendar), function(calendarOpt) {
        $621cc5e1b758ea39$var$convertNormalEmphasis(calendarOpt, 'itemStyle');
        $621cc5e1b758ea39$var$compatTextStyle(calendarOpt, 'dayLabel');
        $621cc5e1b758ea39$var$compatTextStyle(calendarOpt, 'monthLabel');
        $621cc5e1b758ea39$var$compatTextStyle(calendarOpt, 'yearLabel');
    });
    // radar.name.textStyle
    $621cc5e1b758ea39$var$each($621cc5e1b758ea39$var$toArr(option.radar), function(radarOpt) {
        $621cc5e1b758ea39$var$compatTextStyle(radarOpt, 'name');
        // Use axisName instead of name because component has name property
        if (radarOpt.name && radarOpt.axisName == null) {
            radarOpt.axisName = radarOpt.name;
            delete radarOpt.name;
        }
        if (radarOpt.nameGap != null && radarOpt.axisNameGap == null) {
            radarOpt.axisNameGap = radarOpt.nameGap;
            delete radarOpt.nameGap;
        }
    });
    $621cc5e1b758ea39$var$each($621cc5e1b758ea39$var$toArr(option.geo), function(geoOpt) {
        if ($621cc5e1b758ea39$var$isObject(geoOpt)) {
            $621cc5e1b758ea39$var$compatEC3CommonStyles(geoOpt);
            $621cc5e1b758ea39$var$each($621cc5e1b758ea39$var$toArr(geoOpt.regions), function(regionObj) {
                $621cc5e1b758ea39$var$compatEC3CommonStyles(regionObj);
            });
        }
    });
    $621cc5e1b758ea39$var$each($621cc5e1b758ea39$var$toArr(option.timeline), function(timelineOpt) {
        $621cc5e1b758ea39$var$compatEC3CommonStyles(timelineOpt);
        $621cc5e1b758ea39$var$convertNormalEmphasis(timelineOpt, 'label');
        $621cc5e1b758ea39$var$convertNormalEmphasis(timelineOpt, 'itemStyle');
        $621cc5e1b758ea39$var$convertNormalEmphasis(timelineOpt, 'controlStyle', true);
        var data = timelineOpt.data;
        $7a1bd9c2710fea0d$export$43bee75e5e14138e(data) && $7a1bd9c2710fea0d$export$79b2f7037acddd43(data, function(item) {
            if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(item)) {
                $621cc5e1b758ea39$var$convertNormalEmphasis(item, 'label');
                $621cc5e1b758ea39$var$convertNormalEmphasis(item, 'itemStyle');
            }
        });
    });
    $621cc5e1b758ea39$var$each($621cc5e1b758ea39$var$toArr(option.toolbox), function(toolboxOpt) {
        $621cc5e1b758ea39$var$convertNormalEmphasis(toolboxOpt, 'iconStyle');
        $621cc5e1b758ea39$var$each(toolboxOpt.feature, function(featureOpt) {
            $621cc5e1b758ea39$var$convertNormalEmphasis(featureOpt, 'iconStyle');
        });
    });
    $621cc5e1b758ea39$var$compatTextStyle($621cc5e1b758ea39$var$toObj(option.axisPointer), 'label');
    $621cc5e1b758ea39$var$compatTextStyle($621cc5e1b758ea39$var$toObj(option.tooltip).axisPointer, 'label');
// Clean logs
// storedLogs = {};
}




function $c4489ebdf95633b6$var$get(opt, path) {
    var pathArr = path.split(',');
    var obj = opt;
    for(var i = 0; i < pathArr.length; i++){
        obj = obj && obj[pathArr[i]];
        if (obj == null) break;
    }
    return obj;
}
function $c4489ebdf95633b6$var$set(opt, path, val, overwrite) {
    var pathArr = path.split(',');
    var obj = opt;
    var key;
    var i = 0;
    for(; i < pathArr.length - 1; i++){
        key = pathArr[i];
        if (obj[key] == null) obj[key] = {};
        obj = obj[key];
    }
    if (overwrite || obj[pathArr[i]] == null) obj[pathArr[i]] = val;
}
function $c4489ebdf95633b6$var$compatLayoutProperties(option) {
    option && (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($c4489ebdf95633b6$var$LAYOUT_PROPERTIES, function(prop) {
        if (prop[0] in option && !(prop[1] in option)) option[prop[1]] = option[prop[0]];
    });
}
var $c4489ebdf95633b6$var$LAYOUT_PROPERTIES = [
    [
        'x',
        'left'
    ],
    [
        'y',
        'top'
    ],
    [
        'x2',
        'right'
    ],
    [
        'y2',
        'bottom'
    ]
];
var $c4489ebdf95633b6$var$COMPATITABLE_COMPONENTS = [
    'grid',
    'geo',
    'parallel',
    'legend',
    'toolbox',
    'title',
    'visualMap',
    'dataZoom',
    'timeline'
];
var $c4489ebdf95633b6$var$BAR_ITEM_STYLE_MAP = [
    [
        'borderRadius',
        'barBorderRadius'
    ],
    [
        'borderColor',
        'barBorderColor'
    ],
    [
        'borderWidth',
        'barBorderWidth'
    ]
];
function $c4489ebdf95633b6$var$compatBarItemStyle(option) {
    var itemStyle = option && option.itemStyle;
    if (itemStyle) for(var i = 0; i < $c4489ebdf95633b6$var$BAR_ITEM_STYLE_MAP.length; i++){
        var oldName = $c4489ebdf95633b6$var$BAR_ITEM_STYLE_MAP[i][1];
        var newName = $c4489ebdf95633b6$var$BAR_ITEM_STYLE_MAP[i][0];
        if (itemStyle[oldName] != null) itemStyle[newName] = itemStyle[oldName];
    }
}
function $c4489ebdf95633b6$var$compatPieLabel(option) {
    if (!option) return;
    if (option.alignTo === 'edge' && option.margin != null && option.edgeDistance == null) option.edgeDistance = option.margin;
}
function $c4489ebdf95633b6$var$compatSunburstState(option) {
    if (!option) return;
    if (option.downplay && !option.blur) option.blur = option.downplay;
}
function $c4489ebdf95633b6$var$compatGraphFocus(option) {
    if (!option) return;
    if (option.focusNodeAdjacency != null) {
        option.emphasis = option.emphasis || {};
        if (option.emphasis.focus == null) option.emphasis.focus = 'adjacency';
    }
}
function $c4489ebdf95633b6$var$traverseTree(data, cb) {
    if (data) for(var i = 0; i < data.length; i++){
        cb(data[i]);
        data[i] && $c4489ebdf95633b6$var$traverseTree(data[i].children, cb);
    }
}
function $c4489ebdf95633b6$export$2e2bcd8739ae039(option, isTheme) {
    (0, $621cc5e1b758ea39$export$2e2bcd8739ae039)(option, isTheme);
    // Make sure series array for model initialization.
    option.series = (0, $76d619f648247e6d$export$4f07b212a02c8051)(option.series);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(option.series, function(seriesOpt) {
        if (!(0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(seriesOpt)) return;
        var seriesType = seriesOpt.type;
        if (seriesType === 'line') {
            if (seriesOpt.clipOverflow != null) seriesOpt.clip = seriesOpt.clipOverflow;
        } else if (seriesType === 'pie' || seriesType === 'gauge') {
            if (seriesOpt.clockWise != null) seriesOpt.clockwise = seriesOpt.clockWise;
            $c4489ebdf95633b6$var$compatPieLabel(seriesOpt.label);
            var data = seriesOpt.data;
            if (data && !(0, $7a1bd9c2710fea0d$export$b119cc7e1840e59c)(data)) for(var i = 0; i < data.length; i++)$c4489ebdf95633b6$var$compatPieLabel(data[i]);
            if (seriesOpt.hoverOffset != null) {
                seriesOpt.emphasis = seriesOpt.emphasis || {};
                seriesOpt.emphasis.scaleSize = null;
            }
        } else if (seriesType === 'gauge') {
            var pointerColor = $c4489ebdf95633b6$var$get(seriesOpt, 'pointer.color');
            pointerColor != null && $c4489ebdf95633b6$var$set(seriesOpt, 'itemStyle.color', pointerColor);
        } else if (seriesType === 'bar') {
            $c4489ebdf95633b6$var$compatBarItemStyle(seriesOpt);
            $c4489ebdf95633b6$var$compatBarItemStyle(seriesOpt.backgroundStyle);
            $c4489ebdf95633b6$var$compatBarItemStyle(seriesOpt.emphasis);
            var data = seriesOpt.data;
            if (data && !(0, $7a1bd9c2710fea0d$export$b119cc7e1840e59c)(data)) {
                for(var i = 0; i < data.length; i++)if (typeof data[i] === 'object') {
                    $c4489ebdf95633b6$var$compatBarItemStyle(data[i]);
                    $c4489ebdf95633b6$var$compatBarItemStyle(data[i] && data[i].emphasis);
                }
            }
        } else if (seriesType === 'sunburst') {
            var highlightPolicy = seriesOpt.highlightPolicy;
            if (highlightPolicy) {
                seriesOpt.emphasis = seriesOpt.emphasis || {};
                if (!seriesOpt.emphasis.focus) seriesOpt.emphasis.focus = highlightPolicy;
            }
            $c4489ebdf95633b6$var$compatSunburstState(seriesOpt);
            $c4489ebdf95633b6$var$traverseTree(seriesOpt.data, $c4489ebdf95633b6$var$compatSunburstState);
        } else if (seriesType === 'graph' || seriesType === 'sankey') $c4489ebdf95633b6$var$compatGraphFocus(seriesOpt);
        else if (seriesType === 'map') {
            if (seriesOpt.mapType && !seriesOpt.map) seriesOpt.map = seriesOpt.mapType;
            if (seriesOpt.mapLocation) (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(seriesOpt, seriesOpt.mapLocation);
        }
        if (seriesOpt.hoverAnimation != null) {
            seriesOpt.emphasis = seriesOpt.emphasis || {};
            if (seriesOpt.emphasis && seriesOpt.emphasis.scale == null) seriesOpt.emphasis.scale = seriesOpt.hoverAnimation;
        }
        $c4489ebdf95633b6$var$compatLayoutProperties(seriesOpt);
    });
    // dataRange has changed to visualMap
    if (option.dataRange) option.visualMap = option.dataRange;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($c4489ebdf95633b6$var$COMPATITABLE_COMPONENTS, function(componentName) {
        var options = option[componentName];
        if (options) {
            if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(options)) options = [
                options
            ];
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(options, function(option) {
                $c4489ebdf95633b6$var$compatLayoutProperties(option);
            });
        }
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $92eb0b43a1e7607a$export$2e2bcd8739ae039(ecModel) {
    var stackInfoMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    ecModel.eachSeries(function(seriesModel) {
        var stack = seriesModel.get('stack');
        // Compatible: when `stack` is set as '', do not stack.
        if (stack) {
            var stackInfoList = stackInfoMap.get(stack) || stackInfoMap.set(stack, []);
            var data = seriesModel.getData();
            var stackInfo = {
                // Used for calculate axis extent automatically.
                // TODO: Type getCalculationInfo return more specific type?
                stackResultDimension: data.getCalculationInfo('stackResultDimension'),
                stackedOverDimension: data.getCalculationInfo('stackedOverDimension'),
                stackedDimension: data.getCalculationInfo('stackedDimension'),
                stackedByDimension: data.getCalculationInfo('stackedByDimension'),
                isStackedByIndex: data.getCalculationInfo('isStackedByIndex'),
                data: data,
                seriesModel: seriesModel
            };
            // If stacked on axis that do not support data stack.
            if (!stackInfo.stackedDimension || !(stackInfo.isStackedByIndex || stackInfo.stackedByDimension)) return;
            stackInfoList.length && data.setCalculationInfo('stackedOnSeries', stackInfoList[stackInfoList.length - 1].seriesModel);
            stackInfoList.push(stackInfo);
        }
    });
    stackInfoMap.each($92eb0b43a1e7607a$var$calculateStack);
}
function $92eb0b43a1e7607a$var$calculateStack(stackInfoList) {
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(stackInfoList, function(targetStackInfo, idxInStack) {
        var resultVal = [];
        var resultNaN = [
            NaN,
            NaN
        ];
        var dims = [
            targetStackInfo.stackResultDimension,
            targetStackInfo.stackedOverDimension
        ];
        var targetData = targetStackInfo.data;
        var isStackedByIndex = targetStackInfo.isStackedByIndex;
        var stackStrategy = targetStackInfo.seriesModel.get('stackStrategy') || 'samesign';
        // Should not write on raw data, because stack series model list changes
        // depending on legend selection.
        targetData.modify(dims, function(v0, v1, dataIndex) {
            var sum = targetData.get(targetStackInfo.stackedDimension, dataIndex);
            // Consider `connectNulls` of line area, if value is NaN, stackedOver
            // should also be NaN, to draw a appropriate belt area.
            if (isNaN(sum)) return resultNaN;
            var byValue;
            var stackedDataRawIndex;
            if (isStackedByIndex) stackedDataRawIndex = targetData.getRawIndex(dataIndex);
            else byValue = targetData.get(targetStackInfo.stackedByDimension, dataIndex);
            // If stackOver is NaN, chart view will render point on value start.
            var stackedOver = NaN;
            for(var j = idxInStack - 1; j >= 0; j--){
                var stackInfo = stackInfoList[j];
                // Has been optimized by inverted indices on `stackedByDimension`.
                if (!isStackedByIndex) stackedDataRawIndex = stackInfo.data.rawIndexOf(stackInfo.stackedByDimension, byValue);
                if (stackedDataRawIndex >= 0) {
                    var val = stackInfo.data.getByRawIndex(stackInfo.stackResultDimension, stackedDataRawIndex);
                    // Considering positive stack, negative stack and empty data
                    if (stackStrategy === 'all' // single stack group
                     || stackStrategy === 'positive' && val > 0 || stackStrategy === 'negative' && val < 0 || stackStrategy === 'samesign' && sum >= 0 && val > 0 // All positive stack
                     || stackStrategy === 'samesign' && sum <= 0 && val < 0 // All negative stack
                    ) {
                        // The sum has to be very small to be affected by the
                        // floating arithmetic problem. An incorrect result will probably
                        // cause axis min/max to be filtered incorrectly.
                        sum = (0, $cfc1f3b422a3185f$export$d3389a301c3a5706)(sum, val);
                        stackedOver = val;
                        break;
                    }
                }
            }
            resultVal[0] = sum;
            resultVal[1] = stackedOver;
            return resultVal;
        });
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



// @inner
var $99e22f5c2aa5094b$var$SourceImpl = /** @class */ function() {
    function SourceImpl(fields) {
        this.data = fields.data || (fields.sourceFormat === (0, $cab29724515ce2b8$export$6a32b42c754a3cb8) ? {} : []);
        this.sourceFormat = fields.sourceFormat || (0, $cab29724515ce2b8$export$c78f1330778d30d);
        // Visit config
        this.seriesLayoutBy = fields.seriesLayoutBy || (0, $cab29724515ce2b8$export$7b3f3c6551b4949b);
        this.startIndex = fields.startIndex || 0;
        this.dimensionsDetectedCount = fields.dimensionsDetectedCount;
        this.metaRawOption = fields.metaRawOption;
        var dimensionsDefine = this.dimensionsDefine = fields.dimensionsDefine;
        if (dimensionsDefine) for(var i = 0; i < dimensionsDefine.length; i++){
            var dim = dimensionsDefine[i];
            if (dim.type == null) {
                if ((0, $7dc6cdfd7450ef29$export$c51adf1a2be01b9c)(this, i) === (0, $7dc6cdfd7450ef29$export$328749e9c5b40760).Must) dim.type = 'ordinal';
            }
        }
    }
    return SourceImpl;
}();
function $99e22f5c2aa5094b$export$22b808bc02a60488(val) {
    return val instanceof $99e22f5c2aa5094b$var$SourceImpl;
}
function $99e22f5c2aa5094b$export$1921362e86c73c88(sourceData, thisMetaRawOption, // can be null. If not provided, auto detect it from `sourceData`.
sourceFormat) {
    sourceFormat = sourceFormat || $99e22f5c2aa5094b$export$52a469afa4653e57(sourceData);
    var seriesLayoutBy = thisMetaRawOption.seriesLayoutBy;
    var determined = $99e22f5c2aa5094b$var$determineSourceDimensions(sourceData, sourceFormat, seriesLayoutBy, thisMetaRawOption.sourceHeader, thisMetaRawOption.dimensions);
    var source = new $99e22f5c2aa5094b$var$SourceImpl({
        data: sourceData,
        sourceFormat: sourceFormat,
        seriesLayoutBy: seriesLayoutBy,
        dimensionsDefine: determined.dimensionsDefine,
        startIndex: determined.startIndex,
        dimensionsDetectedCount: determined.dimensionsDetectedCount,
        metaRawOption: (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(thisMetaRawOption)
    });
    return source;
}
function $99e22f5c2aa5094b$export$75aef3f97c0a5edf(data) {
    return new $99e22f5c2aa5094b$var$SourceImpl({
        data: data,
        sourceFormat: (0, $7a1bd9c2710fea0d$export$b119cc7e1840e59c)(data) ? (0, $cab29724515ce2b8$export$a918cb016a382d45) : (0, $cab29724515ce2b8$export$2823037fb9d8f0c6)
    });
}
function $99e22f5c2aa5094b$export$e0365e7e3555ddd4(source) {
    return new $99e22f5c2aa5094b$var$SourceImpl({
        data: source.data,
        sourceFormat: source.sourceFormat,
        seriesLayoutBy: source.seriesLayoutBy,
        dimensionsDefine: (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(source.dimensionsDefine),
        startIndex: source.startIndex,
        dimensionsDetectedCount: source.dimensionsDetectedCount
    });
}
function $99e22f5c2aa5094b$export$52a469afa4653e57(data) {
    var sourceFormat = (0, $cab29724515ce2b8$export$c78f1330778d30d);
    if ((0, $7a1bd9c2710fea0d$export$b119cc7e1840e59c)(data)) sourceFormat = (0, $cab29724515ce2b8$export$a918cb016a382d45);
    else if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(data)) {
        // FIXME Whether tolerate null in top level array?
        if (data.length === 0) sourceFormat = (0, $cab29724515ce2b8$export$fcd62ebf51387903);
        for(var i = 0, len = data.length; i < len; i++){
            var item = data[i];
            if (item == null) continue;
            else if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(item) || (0, $7a1bd9c2710fea0d$export$b119cc7e1840e59c)(item)) {
                sourceFormat = (0, $cab29724515ce2b8$export$fcd62ebf51387903);
                break;
            } else if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(item)) {
                sourceFormat = (0, $cab29724515ce2b8$export$703ae8a2d83f441);
                break;
            }
        }
    } else if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(data)) {
        for(var key in data)if ((0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(data, key) && (0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(data[key])) {
            sourceFormat = (0, $cab29724515ce2b8$export$6a32b42c754a3cb8);
            break;
        }
    }
    return sourceFormat;
}
/**
 * Determine the source definitions from data standalone dimensions definitions
 * are not specified.
 */ function $99e22f5c2aa5094b$var$determineSourceDimensions(data, sourceFormat, seriesLayoutBy, sourceHeader, // standalone raw dimensions definition, like:
// {
//     dimensions: ['aa', 'bb', { name: 'cc', type: 'time' }]
// }
// in `dataset` or `series`
dimensionsDefine) {
    var dimensionsDetectedCount;
    var startIndex;
    // PENDING: Could data be null/undefined here?
    // currently, if `dataset.source` not specified, error thrown.
    // if `series.data` not specified, nothing rendered without error thrown.
    // Should test these cases.
    if (!data) return {
        dimensionsDefine: $99e22f5c2aa5094b$var$normalizeDimensionsOption(dimensionsDefine),
        startIndex: startIndex,
        dimensionsDetectedCount: dimensionsDetectedCount
    };
    if (sourceFormat === (0, $cab29724515ce2b8$export$fcd62ebf51387903)) {
        var dataArrayRows = data;
        // Rule: Most of the first line are string: it is header.
        // Caution: consider a line with 5 string and 1 number,
        // it still can not be sure it is a head, because the
        // 5 string may be 5 values of category columns.
        if (sourceHeader === 'auto' || sourceHeader == null) $99e22f5c2aa5094b$var$arrayRowsTravelFirst(function(val) {
            // '-' is regarded as null/undefined.
            if (val != null && val !== '-') {
                if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(val)) startIndex == null && (startIndex = 1);
                else startIndex = 0;
            }
        // 10 is an experience number, avoid long loop.
        }, seriesLayoutBy, dataArrayRows, 10);
        else startIndex = (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(sourceHeader) ? sourceHeader : sourceHeader ? 1 : 0;
        if (!dimensionsDefine && startIndex === 1) {
            dimensionsDefine = [];
            $99e22f5c2aa5094b$var$arrayRowsTravelFirst(function(val, index) {
                dimensionsDefine[index] = val != null ? val + '' : '';
            }, seriesLayoutBy, dataArrayRows, Infinity);
        }
        dimensionsDetectedCount = dimensionsDefine ? dimensionsDefine.length : seriesLayoutBy === (0, $cab29724515ce2b8$export$d55da1467cdf7804) ? dataArrayRows.length : dataArrayRows[0] ? dataArrayRows[0].length : null;
    } else if (sourceFormat === (0, $cab29724515ce2b8$export$703ae8a2d83f441)) {
        if (!dimensionsDefine) dimensionsDefine = $99e22f5c2aa5094b$var$objectRowsCollectDimensions(data);
    } else if (sourceFormat === (0, $cab29724515ce2b8$export$6a32b42c754a3cb8)) {
        if (!dimensionsDefine) {
            dimensionsDefine = [];
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(data, function(colArr, key) {
                dimensionsDefine.push(key);
            });
        }
    } else if (sourceFormat === (0, $cab29724515ce2b8$export$2823037fb9d8f0c6)) {
        var value0 = (0, $76d619f648247e6d$export$2c944e12edb48d4b)(data[0]);
        dimensionsDetectedCount = (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(value0) && value0.length || 1;
    }
    return {
        startIndex: startIndex,
        dimensionsDefine: $99e22f5c2aa5094b$var$normalizeDimensionsOption(dimensionsDefine),
        dimensionsDetectedCount: dimensionsDetectedCount
    };
}
function $99e22f5c2aa5094b$var$objectRowsCollectDimensions(data) {
    var firstIndex = 0;
    var obj;
    while(firstIndex < data.length && !(obj = data[firstIndex++])); // jshint ignore: line
    if (obj) return (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(obj);
}
// Consider dimensions defined like ['A', 'price', 'B', 'price', 'C', 'price'],
// which is reasonable. But dimension name is duplicated.
// Returns undefined or an array contains only object without null/undefined or string.
function $99e22f5c2aa5094b$var$normalizeDimensionsOption(dimensionsDefine) {
    if (!dimensionsDefine) // The meaning of null/undefined is different from empty array.
    return;
    var nameMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    return (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(dimensionsDefine, function(rawItem, index) {
        rawItem = (0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(rawItem) ? rawItem : {
            name: rawItem
        };
        // Other fields will be discarded.
        var item = {
            name: rawItem.name,
            displayName: rawItem.displayName,
            type: rawItem.type
        };
        // User can set null in dimensions.
        // We don't auto specify name, otherwise a given name may
        // cause it to be referred unexpectedly.
        if (item.name == null) return item;
        // Also consider number form like 2012.
        item.name += '';
        // User may also specify displayName.
        // displayName will always exists except user not
        // specified or dim name is not specified or detected.
        // (A auto generated dim name will not be used as
        // displayName).
        if (item.displayName == null) item.displayName = item.name;
        var exist = nameMap.get(item.name);
        if (!exist) nameMap.set(item.name, {
            count: 1
        });
        else item.name += '-' + exist.count++;
        return item;
    });
}
function $99e22f5c2aa5094b$var$arrayRowsTravelFirst(cb, seriesLayoutBy, data, maxLoop) {
    if (seriesLayoutBy === (0, $cab29724515ce2b8$export$d55da1467cdf7804)) for(var i = 0; i < data.length && i < maxLoop; i++)cb(data[i] ? data[i][0] : null, i);
    else {
        var value0 = data[0] || [];
        for(var i = 0; i < value0.length && i < maxLoop; i++)cb(value0[i], i);
    }
}
function $99e22f5c2aa5094b$export$8911336b527f8517(source) {
    var sourceFormat = source.sourceFormat;
    return sourceFormat === (0, $cab29724515ce2b8$export$703ae8a2d83f441) || sourceFormat === (0, $cab29724515ce2b8$export$6a32b42c754a3cb8);
}



var $8ffb0d67e9446edb$var$_a, $8ffb0d67e9446edb$var$_b, $8ffb0d67e9446edb$var$_c;
var $8ffb0d67e9446edb$var$providerMethods;
var $8ffb0d67e9446edb$var$mountMethods;
/**
 * If normal array used, mutable chunk size is supported.
 * If typed array used, chunk size must be fixed.
 */ var $8ffb0d67e9446edb$export$b900d7c4c3952a40 = /** @class */ function() {
    function DefaultDataProvider(sourceParam, dimSize) {
        // let source: Source;
        var source = !(0, $99e22f5c2aa5094b$export$22b808bc02a60488)(sourceParam) ? (0, $99e22f5c2aa5094b$export$75aef3f97c0a5edf)(sourceParam) : sourceParam;
        // declare source is Source;
        this._source = source;
        var data = this._data = source.data;
        // Typed array. TODO IE10+?
        if (source.sourceFormat === (0, $cab29724515ce2b8$export$a918cb016a382d45)) {
            this._offset = 0;
            this._dimSize = dimSize;
            this._data = data;
        }
        $8ffb0d67e9446edb$var$mountMethods(this, data, source);
    }
    DefaultDataProvider.prototype.getSource = function() {
        return this._source;
    };
    DefaultDataProvider.prototype.count = function() {
        return 0;
    };
    DefaultDataProvider.prototype.getItem = function(idx, out) {
        return;
    };
    DefaultDataProvider.prototype.appendData = function(newData) {};
    DefaultDataProvider.prototype.clean = function() {};
    DefaultDataProvider.protoInitialize = function() {
        // PENDING: To avoid potential incompat (e.g., prototype
        // is visited somewhere), still init them on prototype.
        var proto = DefaultDataProvider.prototype;
        proto.pure = false;
        proto.persistent = true;
    }();
    DefaultDataProvider.internalField = function() {
        var _a;
        $8ffb0d67e9446edb$var$mountMethods = function(provider, data, source) {
            var sourceFormat = source.sourceFormat;
            var seriesLayoutBy = source.seriesLayoutBy;
            var startIndex = source.startIndex;
            var dimsDef = source.dimensionsDefine;
            var methods = $8ffb0d67e9446edb$var$providerMethods[$8ffb0d67e9446edb$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
            (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(provider, methods);
            if (sourceFormat === (0, $cab29724515ce2b8$export$a918cb016a382d45)) {
                provider.getItem = getItemForTypedArray;
                provider.count = countForTypedArray;
                provider.fillStorage = fillStorageForTypedArray;
            } else {
                var rawItemGetter = $8ffb0d67e9446edb$export$92c8ea8642b3957d(sourceFormat, seriesLayoutBy);
                provider.getItem = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(rawItemGetter, null, data, startIndex, dimsDef);
                var rawCounter = $8ffb0d67e9446edb$export$803742e832f4b52c(sourceFormat, seriesLayoutBy);
                provider.count = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(rawCounter, null, data, startIndex, dimsDef);
            }
        };
        var getItemForTypedArray = function(idx, out) {
            idx = idx - this._offset;
            out = out || [];
            var data = this._data;
            var dimSize = this._dimSize;
            var offset = dimSize * idx;
            for(var i = 0; i < dimSize; i++)out[i] = data[offset + i];
            return out;
        };
        var fillStorageForTypedArray = function(start, end, storage, extent) {
            var data = this._data;
            var dimSize = this._dimSize;
            for(var dim = 0; dim < dimSize; dim++){
                var dimExtent = extent[dim];
                var min = dimExtent[0] == null ? Infinity : dimExtent[0];
                var max = dimExtent[1] == null ? -Infinity : dimExtent[1];
                var count = end - start;
                var arr = storage[dim];
                for(var i = 0; i < count; i++){
                    // appendData with TypedArray will always do replace in provider.
                    var val = data[i * dimSize + dim];
                    arr[start + i] = val;
                    val < min && (min = val);
                    val > max && (max = val);
                }
                dimExtent[0] = min;
                dimExtent[1] = max;
            }
        };
        var countForTypedArray = function() {
            return this._data ? this._data.length / this._dimSize : 0;
        };
        $8ffb0d67e9446edb$var$providerMethods = (_a = {}, _a[(0, $cab29724515ce2b8$export$fcd62ebf51387903) + '_' + (0, $cab29724515ce2b8$export$7b3f3c6551b4949b)] = {
            pure: true,
            appendData: appendDataSimply
        }, _a[(0, $cab29724515ce2b8$export$fcd62ebf51387903) + '_' + (0, $cab29724515ce2b8$export$d55da1467cdf7804)] = {
            pure: true,
            appendData: function() {
                throw new Error('Do not support appendData when set seriesLayoutBy: "row".');
            }
        }, _a[0, $cab29724515ce2b8$export$703ae8a2d83f441] = {
            pure: true,
            appendData: appendDataSimply
        }, _a[0, $cab29724515ce2b8$export$6a32b42c754a3cb8] = {
            pure: true,
            appendData: function(newData) {
                var data = this._data;
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(newData, function(newCol, key) {
                    var oldCol = data[key] || (data[key] = []);
                    for(var i = 0; i < (newCol || []).length; i++)oldCol.push(newCol[i]);
                });
            }
        }, _a[0, $cab29724515ce2b8$export$2823037fb9d8f0c6] = {
            appendData: appendDataSimply
        }, _a[0, $cab29724515ce2b8$export$a918cb016a382d45] = {
            persistent: false,
            pure: true,
            appendData: function(newData) {
                this._data = newData;
            },
            // Clean self if data is already used.
            clean: function() {
                // PENDING
                this._offset += this.count();
                this._data = null;
            }
        }, _a);
        function appendDataSimply(newData) {
            for(var i = 0; i < newData.length; i++)this._data.push(newData[i]);
        }
    }();
    return DefaultDataProvider;
}();
var $8ffb0d67e9446edb$var$getItemSimply = function(rawData, startIndex, dimsDef, idx) {
    return rawData[idx];
};
var $8ffb0d67e9446edb$var$rawSourceItemGetterMap = ($8ffb0d67e9446edb$var$_a = {}, $8ffb0d67e9446edb$var$_a[(0, $cab29724515ce2b8$export$fcd62ebf51387903) + '_' + (0, $cab29724515ce2b8$export$7b3f3c6551b4949b)] = function(rawData, startIndex, dimsDef, idx) {
    return rawData[idx + startIndex];
}, $8ffb0d67e9446edb$var$_a[(0, $cab29724515ce2b8$export$fcd62ebf51387903) + '_' + (0, $cab29724515ce2b8$export$d55da1467cdf7804)] = function(rawData, startIndex, dimsDef, idx, out) {
    idx += startIndex;
    var item = out || [];
    var data = rawData;
    for(var i = 0; i < data.length; i++){
        var row = data[i];
        item[i] = row ? row[idx] : null;
    }
    return item;
}, $8ffb0d67e9446edb$var$_a[0, $cab29724515ce2b8$export$703ae8a2d83f441] = $8ffb0d67e9446edb$var$getItemSimply, $8ffb0d67e9446edb$var$_a[0, $cab29724515ce2b8$export$6a32b42c754a3cb8] = function(rawData, startIndex, dimsDef, idx, out) {
    var item = out || [];
    for(var i = 0; i < dimsDef.length; i++){
        var dimName = dimsDef[i].name;
        var col = rawData[dimName];
        item[i] = col ? col[idx] : null;
    }
    return item;
}, $8ffb0d67e9446edb$var$_a[0, $cab29724515ce2b8$export$2823037fb9d8f0c6] = $8ffb0d67e9446edb$var$getItemSimply, $8ffb0d67e9446edb$var$_a);
function $8ffb0d67e9446edb$export$92c8ea8642b3957d(sourceFormat, seriesLayoutBy) {
    var method = $8ffb0d67e9446edb$var$rawSourceItemGetterMap[$8ffb0d67e9446edb$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
    return method;
}
var $8ffb0d67e9446edb$var$countSimply = function(rawData, startIndex, dimsDef) {
    return rawData.length;
};
var $8ffb0d67e9446edb$var$rawSourceDataCounterMap = ($8ffb0d67e9446edb$var$_b = {}, $8ffb0d67e9446edb$var$_b[(0, $cab29724515ce2b8$export$fcd62ebf51387903) + '_' + (0, $cab29724515ce2b8$export$7b3f3c6551b4949b)] = function(rawData, startIndex, dimsDef) {
    return Math.max(0, rawData.length - startIndex);
}, $8ffb0d67e9446edb$var$_b[(0, $cab29724515ce2b8$export$fcd62ebf51387903) + '_' + (0, $cab29724515ce2b8$export$d55da1467cdf7804)] = function(rawData, startIndex, dimsDef) {
    var row = rawData[0];
    return row ? Math.max(0, row.length - startIndex) : 0;
}, $8ffb0d67e9446edb$var$_b[0, $cab29724515ce2b8$export$703ae8a2d83f441] = $8ffb0d67e9446edb$var$countSimply, $8ffb0d67e9446edb$var$_b[0, $cab29724515ce2b8$export$6a32b42c754a3cb8] = function(rawData, startIndex, dimsDef) {
    var dimName = dimsDef[0].name;
    var col = rawData[dimName];
    return col ? col.length : 0;
}, $8ffb0d67e9446edb$var$_b[0, $cab29724515ce2b8$export$2823037fb9d8f0c6] = $8ffb0d67e9446edb$var$countSimply, $8ffb0d67e9446edb$var$_b);
function $8ffb0d67e9446edb$export$803742e832f4b52c(sourceFormat, seriesLayoutBy) {
    var method = $8ffb0d67e9446edb$var$rawSourceDataCounterMap[$8ffb0d67e9446edb$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
    return method;
}
var $8ffb0d67e9446edb$var$getRawValueSimply = function(dataItem, dimIndex, property) {
    return dataItem[dimIndex];
};
var $8ffb0d67e9446edb$var$rawSourceValueGetterMap = ($8ffb0d67e9446edb$var$_c = {}, $8ffb0d67e9446edb$var$_c[0, $cab29724515ce2b8$export$fcd62ebf51387903] = $8ffb0d67e9446edb$var$getRawValueSimply, $8ffb0d67e9446edb$var$_c[0, $cab29724515ce2b8$export$703ae8a2d83f441] = function(dataItem, dimIndex, property) {
    return dataItem[property];
}, $8ffb0d67e9446edb$var$_c[0, $cab29724515ce2b8$export$6a32b42c754a3cb8] = $8ffb0d67e9446edb$var$getRawValueSimply, $8ffb0d67e9446edb$var$_c[0, $cab29724515ce2b8$export$2823037fb9d8f0c6] = function(dataItem, dimIndex, property) {
    // FIXME: In some case (markpoint in geo (geo-map.html)),
    // dataItem is {coord: [...]}
    var value = (0, $76d619f648247e6d$export$2c944e12edb48d4b)(dataItem);
    return !(value instanceof Array) ? value : value[dimIndex];
}, $8ffb0d67e9446edb$var$_c[0, $cab29724515ce2b8$export$a918cb016a382d45] = $8ffb0d67e9446edb$var$getRawValueSimply, $8ffb0d67e9446edb$var$_c);
function $8ffb0d67e9446edb$export$1752de8084789a14(sourceFormat) {
    var method = $8ffb0d67e9446edb$var$rawSourceValueGetterMap[sourceFormat];
    return method;
}
function $8ffb0d67e9446edb$var$getMethodMapKey(sourceFormat, seriesLayoutBy) {
    return sourceFormat === (0, $cab29724515ce2b8$export$fcd62ebf51387903) ? sourceFormat + '_' + seriesLayoutBy : sourceFormat;
}
function $8ffb0d67e9446edb$export$cde9373da9aad801(data, dataIndex, // If dimIndex is null/undefined, return OptionDataItem.
// Otherwise, return OptionDataValue.
dim) {
    if (!data) return;
    // Consider data may be not persistent.
    var dataItem = data.getRawDataItem(dataIndex);
    if (dataItem == null) return;
    var store = data.getStore();
    var sourceFormat = store.getSource().sourceFormat;
    if (dim != null) {
        var dimIndex = data.getDimensionIndex(dim);
        var property = store.getDimensionProperty(dimIndex);
        return $8ffb0d67e9446edb$export$1752de8084789a14(sourceFormat)(dataItem, dimIndex, property);
    } else {
        var result = dataItem;
        if (sourceFormat === (0, $cab29724515ce2b8$export$2823037fb9d8f0c6)) result = (0, $76d619f648247e6d$export$2c944e12edb48d4b)(dataItem);
        return result;
    }
}
function $8ffb0d67e9446edb$export$c8ae9e77e0ddc42a(data, dataIndex, attr) {
    if (!data) return;
    var sourceFormat = data.getStore().getSource().sourceFormat;
    if (sourceFormat !== (0, $cab29724515ce2b8$export$2823037fb9d8f0c6) && sourceFormat !== (0, $cab29724515ce2b8$export$703ae8a2d83f441)) return;
    var dataItem = data.getRawDataItem(dataIndex);
    if (sourceFormat === (0, $cab29724515ce2b8$export$2823037fb9d8f0c6) && !(0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(dataItem)) dataItem = null;
    if (dataItem) return dataItem[attr];
}




var $655dd6075cc63601$var$DIMENSION_LABEL_REG = /\{@(.+?)\}/g;
var $655dd6075cc63601$export$f23396ae04ea95a7 = /** @class */ function() {
    function DataFormatMixin() {}
    /**
   * Get params for formatter
   */ DataFormatMixin.prototype.getDataParams = function(dataIndex, dataType) {
        var data = this.getData(dataType);
        var rawValue = this.getRawValue(dataIndex, dataType);
        var rawDataIndex = data.getRawIndex(dataIndex);
        var name = data.getName(dataIndex);
        var itemOpt = data.getRawDataItem(dataIndex);
        var style = data.getItemVisual(dataIndex, 'style');
        var color = style && style[data.getItemVisual(dataIndex, 'drawType') || 'fill'];
        var borderColor = style && style.stroke;
        var mainType = this.mainType;
        var isSeries = mainType === 'series';
        var userOutput = data.userOutput && data.userOutput.get();
        return {
            componentType: mainType,
            componentSubType: this.subType,
            componentIndex: this.componentIndex,
            seriesType: isSeries ? this.subType : null,
            seriesIndex: this.seriesIndex,
            seriesId: isSeries ? this.id : null,
            seriesName: isSeries ? this.name : null,
            name: name,
            dataIndex: rawDataIndex,
            data: itemOpt,
            dataType: dataType,
            value: rawValue,
            color: color,
            borderColor: borderColor,
            dimensionNames: userOutput ? userOutput.fullDimensions : null,
            encode: userOutput ? userOutput.encode : null,
            // Param name list for mapping `a`, `b`, `c`, `d`, `e`
            $vars: [
                'seriesName',
                'name',
                'value'
            ]
        };
    };
    /**
   * Format label
   * @param dataIndex
   * @param status 'normal' by default
   * @param dataType
   * @param labelDimIndex Only used in some chart that
   *        use formatter in different dimensions, like radar.
   * @param formatter Formatter given outside.
   * @return return null/undefined if no formatter
   */ DataFormatMixin.prototype.getFormattedLabel = function(dataIndex, status, dataType, labelDimIndex, formatter, extendParams) {
        status = status || 'normal';
        var data = this.getData(dataType);
        var params = this.getDataParams(dataIndex, dataType);
        if (extendParams) params.value = extendParams.interpolatedValue;
        if (labelDimIndex != null && $7a1bd9c2710fea0d$export$43bee75e5e14138e(params.value)) params.value = params.value[labelDimIndex];
        if (!formatter) {
            var itemModel = data.getItemModel(dataIndex);
            // @ts-ignore
            formatter = itemModel.get(status === 'normal' ? [
                'label',
                'formatter'
            ] : [
                status,
                'label',
                'formatter'
            ]);
        }
        if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(formatter)) {
            params.status = status;
            params.dimensionIndex = labelDimIndex;
            return formatter(params);
        } else if ($7a1bd9c2710fea0d$export$844ec244b1367d54(formatter)) {
            var str = (0, $c84c9521536c601a$export$2028496a35766e41)(formatter, params);
            // Support 'aaa{@[3]}bbb{@product}ccc'.
            // Do not support '}' in dim name util have to.
            return str.replace($655dd6075cc63601$var$DIMENSION_LABEL_REG, function(origin, dimStr) {
                var len = dimStr.length;
                var dimLoose = dimStr;
                if (dimLoose.charAt(0) === '[' && dimLoose.charAt(len - 1) === ']') dimLoose = +dimLoose.slice(1, len - 1); // Also support: '[]' => 0
                var val = (0, $8ffb0d67e9446edb$export$cde9373da9aad801)(data, dataIndex, dimLoose);
                if (extendParams && $7a1bd9c2710fea0d$export$43bee75e5e14138e(extendParams.interpolatedValue)) {
                    var dimIndex = data.getDimensionIndex(dimLoose);
                    if (dimIndex >= 0) val = extendParams.interpolatedValue[dimIndex];
                }
                return val != null ? val + '' : '';
            });
        }
    };
    /**
   * Get raw value in option
   */ DataFormatMixin.prototype.getRawValue = function(idx, dataType) {
        return (0, $8ffb0d67e9446edb$export$cde9373da9aad801)(this.getData(dataType), idx);
    };
    /**
   * Should be implemented.
   * @param {number} dataIndex
   * @param {boolean} [multipleSeries=false]
   * @param {string} [dataType]
   */ DataFormatMixin.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        // Empty function
        return;
    };
    return DataFormatMixin;
}();
function $655dd6075cc63601$export$2d16fa82a50c4741(result) {
    var markupText;
    // let markers: Dictionary<ColorString>;
    var markupFragment;
    if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(result)) {
        if (result.type) markupFragment = result;
    } else markupText = result;
    return {
        text: markupText,
        // markers: markers || markersExisting,
        frag: markupFragment
    };
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $4d16404c851dcec6$export$f7292ab7796be73c(define) {
    return new $4d16404c851dcec6$export$2dea7024bcdd7731(define);
}
var $4d16404c851dcec6$export$2dea7024bcdd7731 = /** @class */ function() {
    function Task(define) {
        define = define || {};
        this._reset = define.reset;
        this._plan = define.plan;
        this._count = define.count;
        this._onDirty = define.onDirty;
        this._dirty = true;
    }
    /**
   * @param step Specified step.
   * @param skip Skip customer perform call.
   * @param modBy Sampling window size.
   * @param modDataCount Sampling count.
   * @return whether unfinished.
   */ Task.prototype.perform = function(performArgs) {
        var upTask = this._upstream;
        var skip = performArgs && performArgs.skip;
        // TODO some refactor.
        // Pull data. Must pull data each time, because context.data
        // may be updated by Series.setData.
        if (this._dirty && upTask) {
            var context = this.context;
            context.data = context.outputData = upTask.context.outputData;
        }
        if (this.__pipeline) this.__pipeline.currentTask = this;
        var planResult;
        if (this._plan && !skip) planResult = this._plan(this.context);
        // Support sharding by mod, which changes the render sequence and makes the rendered graphic
        // elements uniformed distributed when progress, especially when moving or zooming.
        var lastModBy = normalizeModBy(this._modBy);
        var lastModDataCount = this._modDataCount || 0;
        var modBy = normalizeModBy(performArgs && performArgs.modBy);
        var modDataCount = performArgs && performArgs.modDataCount || 0;
        if (lastModBy !== modBy || lastModDataCount !== modDataCount) planResult = 'reset';
        function normalizeModBy(val) {
            !(val >= 1) && (val = 1); // jshint ignore:line
            return val;
        }
        var forceFirstProgress;
        if (this._dirty || planResult === 'reset') {
            this._dirty = false;
            forceFirstProgress = this._doReset(skip);
        }
        this._modBy = modBy;
        this._modDataCount = modDataCount;
        var step = performArgs && performArgs.step;
        if (upTask) this._dueEnd = upTask._outputDueEnd;
        else this._dueEnd = this._count ? this._count(this.context) : Infinity;
        // Note: Stubs, that its host overall task let it has progress, has progress.
        // If no progress, pass index from upstream to downstream each time plan called.
        if (this._progress) {
            var start = this._dueIndex;
            var end = Math.min(step != null ? this._dueIndex + step : Infinity, this._dueEnd);
            if (!skip && (forceFirstProgress || start < end)) {
                var progress = this._progress;
                if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(progress)) for(var i = 0; i < progress.length; i++)this._doProgress(progress[i], start, end, modBy, modDataCount);
                else this._doProgress(progress, start, end, modBy, modDataCount);
            }
            this._dueIndex = end;
            // If no `outputDueEnd`, assume that output data and
            // input data is the same, so use `dueIndex` as `outputDueEnd`.
            var outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : end;
            this._outputDueEnd = outputDueEnd;
        } else // (1) Some overall task has no progress.
        // (2) Stubs, that its host overall task do not let it has progress, has no progress.
        // This should always be performed so it can be passed to downstream.
        this._dueIndex = this._outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : this._dueEnd;
        return this.unfinished();
    };
    Task.prototype.dirty = function() {
        this._dirty = true;
        this._onDirty && this._onDirty(this.context);
    };
    Task.prototype._doProgress = function(progress, start, end, modBy, modDataCount) {
        $4d16404c851dcec6$var$iterator.reset(start, end, modBy, modDataCount);
        this._callingProgress = progress;
        this._callingProgress({
            start: start,
            end: end,
            count: end - start,
            next: $4d16404c851dcec6$var$iterator.next
        }, this.context);
    };
    Task.prototype._doReset = function(skip) {
        this._dueIndex = this._outputDueEnd = this._dueEnd = 0;
        this._settedOutputEnd = null;
        var progress;
        var forceFirstProgress;
        if (!skip && this._reset) {
            progress = this._reset(this.context);
            if (progress && progress.progress) {
                forceFirstProgress = progress.forceFirstProgress;
                progress = progress.progress;
            }
            // To simplify no progress checking, array must has item.
            if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(progress) && !progress.length) progress = null;
        }
        this._progress = progress;
        this._modBy = this._modDataCount = null;
        var downstream = this._downstream;
        downstream && downstream.dirty();
        return forceFirstProgress;
    };
    Task.prototype.unfinished = function() {
        return this._progress && this._dueIndex < this._dueEnd;
    };
    /**
   * @param downTask The downstream task.
   * @return The downstream task.
   */ Task.prototype.pipe = function(downTask) {
        // If already downstream, do not dirty downTask.
        if (this._downstream !== downTask || this._dirty) {
            this._downstream = downTask;
            downTask._upstream = this;
            downTask.dirty();
        }
    };
    Task.prototype.dispose = function() {
        if (this._disposed) return;
        this._upstream && (this._upstream._downstream = null);
        this._downstream && (this._downstream._upstream = null);
        this._dirty = false;
        this._disposed = true;
    };
    Task.prototype.getUpstream = function() {
        return this._upstream;
    };
    Task.prototype.getDownstream = function() {
        return this._downstream;
    };
    Task.prototype.setOutputEnd = function(end) {
        // This only happens in dataTask, dataZoom, map, currently.
        // where dataZoom do not set end each time, but only set
        // when reset. So we should record the set end, in case
        // that the stub of dataZoom perform again and earse the
        // set end by upstream.
        this._outputDueEnd = this._settedOutputEnd = end;
    };
    return Task;
}();
var $4d16404c851dcec6$var$iterator = function() {
    var end;
    var current;
    var modBy;
    var modDataCount;
    var winCount;
    var it = {
        reset: function(s, e, sStep, sCount) {
            current = s;
            end = e;
            modBy = sStep;
            modDataCount = sCount;
            winCount = Math.ceil(modDataCount / modBy);
            it.next = modBy > 1 && modDataCount > 0 ? modNext : sequentialNext;
        }
    };
    return it;
    function sequentialNext() {
        return current < end ? current++ : null;
    }
    function modNext() {
        var dataIndex = current % winCount * modBy + Math.ceil(current / winCount);
        var result = current >= end ? null : dataIndex < modDataCount ? dataIndex : current;
        current++;
        return result;
    }
}(); // -----------------------------------------------------------------------------
 // For stream debug (Should be commented out after used!)
 // @usage: printTask(this, 'begin');
 // @usage: printTask(this, null, {someExtraProp});
 // @usage: Use `__idxInPipeline` as conditional breakpiont.
 //
 // window.printTask = function (task: any, prefix: string, extra: { [key: string]: unknown }): void {
 //     window.ecTaskUID == null && (window.ecTaskUID = 0);
 //     task.uidDebug == null && (task.uidDebug = `task_${window.ecTaskUID++}`);
 //     task.agent && task.agent.uidDebug == null && (task.agent.uidDebug = `task_${window.ecTaskUID++}`);
 //     let props = [];
 //     if (task.__pipeline) {
 //         let val = `${task.__idxInPipeline}/${task.__pipeline.tail.__idxInPipeline} ${task.agent ? '(stub)' : ''}`;
 //         props.push({text: '__idxInPipeline/total', value: val});
 //     } else {
 //         let stubCount = 0;
 //         task.agentStubMap.each(() => stubCount++);
 //         props.push({text: 'idx', value: `overall (stubs: ${stubCount})`});
 //     }
 //     props.push({text: 'uid', value: task.uidDebug});
 //     if (task.__pipeline) {
 //         props.push({text: 'pipelineId', value: task.__pipeline.id});
 //         task.agent && props.push(
 //             {text: 'stubFor', value: task.agent.uidDebug}
 //         );
 //     }
 //     props.push(
 //         {text: 'dirty', value: task._dirty},
 //         {text: 'dueIndex', value: task._dueIndex},
 //         {text: 'dueEnd', value: task._dueEnd},
 //         {text: 'outputDueEnd', value: task._outputDueEnd}
 //     );
 //     if (extra) {
 //         Object.keys(extra).forEach(key => {
 //             props.push({text: key, value: extra[key]});
 //         });
 //     }
 //     let args = ['color: blue'];
 //     let msg = `%c[${prefix || 'T'}] %c` + props.map(item => (
 //         args.push('color: green', 'color: red'),
 //         `${item.text}: %c${item.value}`
 //     )).join('%c, ');
 //     console.log.apply(console, [msg].concat(args));
 //     // console.log(this);
 // };
 // window.printPipeline = function (task: any, prefix: string) {
 //     const pipeline = task.__pipeline;
 //     let currTask = pipeline.head;
 //     while (currTask) {
 //         window.printTask(currTask, prefix);
 //         currTask = currTask._downstream;
 //     }
 // };
 // window.showChain = function (chainHeadTask) {
 //     var chain = [];
 //     var task = chainHeadTask;
 //     while (task) {
 //         chain.push({
 //             task: task,
 //             up: task._upstream,
 //             down: task._downstream,
 //             idxInPipeline: task.__idxInPipeline
 //         });
 //         task = task._downstream;
 //     }
 //     return chain;
 // };
 // window.findTaskInChain = function (task, chainHeadTask) {
 //     let chain = window.showChain(chainHeadTask);
 //     let result = [];
 //     for (let i = 0; i < chain.length; i++) {
 //         let chainItem = chain[i];
 //         if (chainItem.task === task) {
 //             result.push(i);
 //         }
 //     }
 //     return result;
 // };
 // window.printChainAEachInChainB = function (chainHeadTaskA, chainHeadTaskB) {
 //     let chainA = window.showChain(chainHeadTaskA);
 //     for (let i = 0; i < chainA.length; i++) {
 //         console.log('chainAIdx:', i, 'inChainB:', window.findTaskInChain(chainA[i].task, chainHeadTaskB));
 //     }
 // };



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $40ab59f44b7d2db6$export$cc7175145baad076(value, // For high performance, do not omit the second param.
opt) {
    // Performance sensitive.
    var dimType = opt && opt.type;
    if (dimType === 'ordinal') // If given value is a category string
    return value;
    if (dimType === 'time' && !(0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(value) && value != null && value !== '-') value = +(0, $cfc1f3b422a3185f$export$6b862160d295c8e)(value);
    // dimType defaults 'number'.
    // If dimType is not ordinal and value is null or undefined or NaN or '-',
    // parse to NaN.
    // number-like string (like ' 123 ') can be converted to a number.
    // where null/undefined or other string will be converted to NaN.
    return value == null || value === '' ? NaN : Number(value);
}
var $40ab59f44b7d2db6$var$valueParserMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)({
    'number': function(val) {
        // Do not use `numericToNumber` here. We have `numericToNumber` by default.
        // Here the number parser can have loose rule:
        // enable to cut suffix: "120px" => 120, "14%" => 14.
        return parseFloat(val);
    },
    'time': function(val) {
        // return timestamp.
        return +(0, $cfc1f3b422a3185f$export$6b862160d295c8e)(val);
    },
    'trim': function(val) {
        return (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(val) ? (0, $7a1bd9c2710fea0d$export$87c2784dc9fc4ab)(val) : val;
    }
});
function $40ab59f44b7d2db6$export$c88237b7c265b36b(type) {
    return $40ab59f44b7d2db6$var$valueParserMap.get(type);
}
var $40ab59f44b7d2db6$var$ORDER_COMPARISON_OP_MAP = {
    lt: function(lval, rval) {
        return lval < rval;
    },
    lte: function(lval, rval) {
        return lval <= rval;
    },
    gt: function(lval, rval) {
        return lval > rval;
    },
    gte: function(lval, rval) {
        return lval >= rval;
    }
};
var $40ab59f44b7d2db6$var$FilterOrderComparator = /** @class */ function() {
    function FilterOrderComparator(op, rval) {
        if (!(0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(rval)) {
            var errMsg = '';
            (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
        }
        this._opFn = $40ab59f44b7d2db6$var$ORDER_COMPARISON_OP_MAP[op];
        this._rvalFloat = (0, $cfc1f3b422a3185f$export$8b4007b942b45a96)(rval);
    }
    // Performance sensitive.
    FilterOrderComparator.prototype.evaluate = function(lval) {
        // Most cases is 'number', and typeof maybe 10 times faseter than parseFloat.
        return (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(lval) ? this._opFn(lval, this._rvalFloat) : this._opFn((0, $cfc1f3b422a3185f$export$8b4007b942b45a96)(lval), this._rvalFloat);
    };
    return FilterOrderComparator;
}();
var $40ab59f44b7d2db6$export$ed75a5d7b0144167 = /** @class */ function() {
    /**
   * @param order by default: 'asc'
   * @param incomparable by default: Always on the tail.
   *        That is, if 'asc' => 'max', if 'desc' => 'min'
   *        See the definition of "incomparable" in [SORT_COMPARISON_RULE].
   */ function SortOrderComparator(order, incomparable) {
        var isDesc = order === 'desc';
        this._resultLT = isDesc ? 1 : -1;
        if (incomparable == null) incomparable = isDesc ? 'min' : 'max';
        this._incomparable = incomparable === 'min' ? -Infinity : Infinity;
    }
    // See [SORT_COMPARISON_RULE].
    // Performance sensitive.
    SortOrderComparator.prototype.evaluate = function(lval, rval) {
        // Most cases is 'number', and typeof maybe 10 times faseter than parseFloat.
        var lvalFloat = (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(lval) ? lval : (0, $cfc1f3b422a3185f$export$8b4007b942b45a96)(lval);
        var rvalFloat = (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(rval) ? rval : (0, $cfc1f3b422a3185f$export$8b4007b942b45a96)(rval);
        var lvalNotNumeric = isNaN(lvalFloat);
        var rvalNotNumeric = isNaN(rvalFloat);
        if (lvalNotNumeric) lvalFloat = this._incomparable;
        if (rvalNotNumeric) rvalFloat = this._incomparable;
        if (lvalNotNumeric && rvalNotNumeric) {
            var lvalIsStr = (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(lval);
            var rvalIsStr = (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(rval);
            if (lvalIsStr) lvalFloat = rvalIsStr ? lval : 0;
            if (rvalIsStr) rvalFloat = lvalIsStr ? rval : 0;
        }
        return lvalFloat < rvalFloat ? this._resultLT : lvalFloat > rvalFloat ? -this._resultLT : 0;
    };
    return SortOrderComparator;
}();
var $40ab59f44b7d2db6$var$FilterEqualityComparator = /** @class */ function() {
    function FilterEqualityComparator(isEq, rval) {
        this._rval = rval;
        this._isEQ = isEq;
        this._rvalTypeof = typeof rval;
        this._rvalFloat = (0, $cfc1f3b422a3185f$export$8b4007b942b45a96)(rval);
    }
    // Performance sensitive.
    FilterEqualityComparator.prototype.evaluate = function(lval) {
        var eqResult = lval === this._rval;
        if (!eqResult) {
            var lvalTypeof = typeof lval;
            if (lvalTypeof !== this._rvalTypeof && (lvalTypeof === 'number' || this._rvalTypeof === 'number')) eqResult = (0, $cfc1f3b422a3185f$export$8b4007b942b45a96)(lval) === this._rvalFloat;
        }
        return this._isEQ ? eqResult : !eqResult;
    };
    return FilterEqualityComparator;
}();
function $40ab59f44b7d2db6$export$f2644c3485f94c4e(op, rval) {
    return op === 'eq' || op === 'ne' ? new $40ab59f44b7d2db6$var$FilterEqualityComparator(op === 'eq', rval) : (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)($40ab59f44b7d2db6$var$ORDER_COMPARISON_OP_MAP, op) ? new $40ab59f44b7d2db6$var$FilterOrderComparator(op, rval) : null;
}




/**
 * TODO: disable writable.
 * This structure will be exposed to users.
 */ var $523dedd0a2328c06$export$ffc19e40a21f08eb = /** @class */ function() {
    function ExternalSource() {}
    ExternalSource.prototype.getRawData = function() {
        // Only built-in transform available.
        throw new Error('not supported');
    };
    ExternalSource.prototype.getRawDataItem = function(dataIndex) {
        // Only built-in transform available.
        throw new Error('not supported');
    };
    ExternalSource.prototype.cloneRawData = function() {
        return;
    };
    /**
   * @return If dimension not found, return null/undefined.
   */ ExternalSource.prototype.getDimensionInfo = function(dim) {
        return;
    };
    /**
   * dimensions defined if and only if either:
   * (a) dataset.dimensions are declared.
   * (b) dataset data include dimensions definitions in data (detected or via specified `sourceHeader`).
   * If dimensions are defined, `dimensionInfoAll` is corresponding to
   * the defined dimensions.
   * Otherwise, `dimensionInfoAll` is determined by data columns.
   * @return Always return an array (even empty array).
   */ ExternalSource.prototype.cloneAllDimensionInfo = function() {
        return;
    };
    ExternalSource.prototype.count = function() {
        return;
    };
    /**
   * Only support by dimension index.
   * No need to support by dimension name in transform function,
   * because transform function is not case-specific, no need to use name literally.
   */ ExternalSource.prototype.retrieveValue = function(dataIndex, dimIndex) {
        return;
    };
    ExternalSource.prototype.retrieveValueFromItem = function(dataItem, dimIndex) {
        return;
    };
    ExternalSource.prototype.convertValue = function(rawVal, dimInfo) {
        return (0, $40ab59f44b7d2db6$export$cc7175145baad076)(rawVal, dimInfo);
    };
    return ExternalSource;
}();
function $523dedd0a2328c06$var$createExternalSource(internalSource, externalTransform) {
    var extSource = new $523dedd0a2328c06$export$ffc19e40a21f08eb();
    var data = internalSource.data;
    var sourceFormat = extSource.sourceFormat = internalSource.sourceFormat;
    var sourceHeaderCount = internalSource.startIndex;
    var errMsg = '';
    if (internalSource.seriesLayoutBy !== (0, $cab29724515ce2b8$export$7b3f3c6551b4949b)) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    // [MEMO]
    // Create a new dimensions structure for exposing.
    // Do not expose all dimension info to users directly.
    // Because the dimension is probably auto detected from data and not might reliable.
    // Should not lead the transformers to think that is reliable and return it.
    // See [DIMENSION_INHERIT_RULE] in `sourceManager.ts`.
    var dimensions = [];
    var dimsByName = {};
    var dimsDef = internalSource.dimensionsDefine;
    if (dimsDef) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dimsDef, function(dimDef, idx) {
        var name = dimDef.name;
        var dimDefExt = {
            index: idx,
            name: name,
            displayName: dimDef.displayName
        };
        dimensions.push(dimDefExt);
        // Users probably do not specify dimension name. For simplicity, data transform
        // does not generate dimension name.
        if (name != null) {
            // Dimension name should not be duplicated.
            // For simplicity, data transform forbids name duplication, do not generate
            // new name like module `completeDimensions.ts` did, but just tell users.
            var errMsg_1 = '';
            if ((0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(dimsByName, name)) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg_1);
            dimsByName[name] = dimDefExt;
        }
    });
    else for(var i = 0; i < internalSource.dimensionsDetectedCount || 0; i++)// Do not generete name or anything others. The consequence process in
    // `transform` or `series` probably have there own name generation strategry.
    dimensions.push({
        index: i
    });
    // Implement public methods:
    var rawItemGetter = (0, $8ffb0d67e9446edb$export$92c8ea8642b3957d)(sourceFormat, (0, $cab29724515ce2b8$export$7b3f3c6551b4949b));
    if (externalTransform.__isBuiltIn) {
        extSource.getRawDataItem = function(dataIndex) {
            return rawItemGetter(data, sourceHeaderCount, dimensions, dataIndex);
        };
        extSource.getRawData = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)($523dedd0a2328c06$var$getRawData, null, internalSource);
    }
    extSource.cloneRawData = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)($523dedd0a2328c06$var$cloneRawData, null, internalSource);
    var rawCounter = (0, $8ffb0d67e9446edb$export$803742e832f4b52c)(sourceFormat, (0, $cab29724515ce2b8$export$7b3f3c6551b4949b));
    extSource.count = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(rawCounter, null, data, sourceHeaderCount, dimensions);
    var rawValueGetter = (0, $8ffb0d67e9446edb$export$1752de8084789a14)(sourceFormat);
    extSource.retrieveValue = function(dataIndex, dimIndex) {
        var rawItem = rawItemGetter(data, sourceHeaderCount, dimensions, dataIndex);
        return retrieveValueFromItem(rawItem, dimIndex);
    };
    var retrieveValueFromItem = extSource.retrieveValueFromItem = function(dataItem, dimIndex) {
        if (dataItem == null) return;
        var dimDef = dimensions[dimIndex];
        // When `dimIndex` is `null`, `rawValueGetter` return the whole item.
        if (dimDef) return rawValueGetter(dataItem, dimIndex, dimDef.name);
    };
    extSource.getDimensionInfo = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)($523dedd0a2328c06$var$getDimensionInfo, null, dimensions, dimsByName);
    extSource.cloneAllDimensionInfo = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)($523dedd0a2328c06$var$cloneAllDimensionInfo, null, dimensions);
    return extSource;
}
function $523dedd0a2328c06$var$getRawData(upstream) {
    var sourceFormat = upstream.sourceFormat;
    if (!$523dedd0a2328c06$var$isSupportedSourceFormat(sourceFormat)) {
        var errMsg = '';
        (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    }
    return upstream.data;
}
function $523dedd0a2328c06$var$cloneRawData(upstream) {
    var sourceFormat = upstream.sourceFormat;
    var data = upstream.data;
    if (!$523dedd0a2328c06$var$isSupportedSourceFormat(sourceFormat)) {
        var errMsg = '';
        (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    }
    if (sourceFormat === (0, $cab29724515ce2b8$export$fcd62ebf51387903)) {
        var result = [];
        for(var i = 0, len = data.length; i < len; i++)// Not strictly clone for performance
        result.push(data[i].slice());
        return result;
    } else if (sourceFormat === (0, $cab29724515ce2b8$export$703ae8a2d83f441)) {
        var result = [];
        for(var i = 0, len = data.length; i < len; i++)// Not strictly clone for performance
        result.push((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, data[i]));
        return result;
    }
}
function $523dedd0a2328c06$var$getDimensionInfo(dimensions, dimsByName, dim) {
    if (dim == null) return;
    // Keep the same logic as `List::getDimension` did.
    if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(dim) || !isNaN(dim) && !(0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(dimsByName, dim)) return dimensions[dim];
    else if ((0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(dimsByName, dim)) return dimsByName[dim];
}
function $523dedd0a2328c06$var$cloneAllDimensionInfo(dimensions) {
    return (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(dimensions);
}
var $523dedd0a2328c06$var$externalTransformMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
function $523dedd0a2328c06$export$92c96c6d8b255b7d(externalTransform) {
    externalTransform = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(externalTransform);
    var type = externalTransform.type;
    var errMsg = '';
    if (!type) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    var typeParsed = type.split(':');
    if (typeParsed.length !== 2) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    // Namespace 'echarts:xxx' is official namespace, where the transforms should
    // be called directly via 'xxx' rather than 'echarts:xxx'.
    var isBuiltIn = false;
    if (typeParsed[0] === 'echarts') {
        type = typeParsed[1];
        isBuiltIn = true;
    }
    externalTransform.__isBuiltIn = isBuiltIn;
    $523dedd0a2328c06$var$externalTransformMap.set(type, externalTransform);
}
function $523dedd0a2328c06$export$42a68f09db16803f(rawTransOption, sourceList, infoForPrint) {
    var pipedTransOption = (0, $76d619f648247e6d$export$4f07b212a02c8051)(rawTransOption);
    var pipeLen = pipedTransOption.length;
    var errMsg = '';
    if (!pipeLen) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    for(var i = 0, len = pipeLen; i < len; i++){
        var transOption = pipedTransOption[i];
        sourceList = $523dedd0a2328c06$var$applySingleDataTransform(transOption, sourceList, infoForPrint, pipeLen === 1 ? null : i);
        // piped transform only support single input, except the fist one.
        // piped transform only support single output, except the last one.
        if (i !== len - 1) sourceList.length = Math.max(sourceList.length, 1);
    }
    return sourceList;
}
function $523dedd0a2328c06$var$applySingleDataTransform(transOption, upSourceList, infoForPrint, // If `pipeIndex` is null/undefined, no piped transform.
pipeIndex) {
    var errMsg = '';
    if (!upSourceList.length) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    if (!(0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(transOption)) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    var transType = transOption.type;
    var externalTransform = $523dedd0a2328c06$var$externalTransformMap.get(transType);
    if (!externalTransform) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    // Prepare source
    var extUpSourceList = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(upSourceList, function(upSource) {
        return $523dedd0a2328c06$var$createExternalSource(upSource, externalTransform);
    });
    var resultList = (0, $76d619f648247e6d$export$4f07b212a02c8051)(externalTransform.transform({
        upstream: extUpSourceList[0],
        upstreamList: extUpSourceList,
        config: (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(transOption.config)
    }));
    var printStrArr;
    return (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(resultList, function(result, resultIndex) {
        var errMsg = '';
        if (!(0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(result)) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
        if (!result.data) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
        var sourceFormat = (0, $99e22f5c2aa5094b$export$52a469afa4653e57)(result.data);
        if (!$523dedd0a2328c06$var$isSupportedSourceFormat(sourceFormat)) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
        var resultMetaRawOption;
        var firstUpSource = upSourceList[0];
        /**
     * Intuitively, the end users known the content of the original `dataset.source`,
     * calucating the transform result in mind.
     * Suppose the original `dataset.source` is:
     * ```js
     * [
     *     ['product', '2012', '2013', '2014', '2015'],
     *     ['AAA', 41.1, 30.4, 65.1, 53.3],
     *     ['BBB', 86.5, 92.1, 85.7, 83.1],
     *     ['CCC', 24.1, 67.2, 79.5, 86.4]
     * ]
     * ```
     * The dimension info have to be detected from the source data.
     * Some of the transformers (like filter, sort) will follow the dimension info
     * of upstream, while others use new dimensions (like aggregate).
     * Transformer can output a field `dimensions` to define the its own output dimensions.
     * We also allow transformers to ignore the output `dimensions` field, and
     * inherit the upstream dimensions definition. It can reduce the burden of handling
     * dimensions in transformers.
     *
     * See also [DIMENSION_INHERIT_RULE] in `sourceManager.ts`.
     */ if (firstUpSource && resultIndex === 0 && !result.dimensions) {
            var startIndex = firstUpSource.startIndex;
            // We copy the header of upstream to the result, because:
            // (1) The returned data always does not contain header line and can not be used
            // as dimension-detection. In this case we can not use "detected dimensions" of
            // upstream directly, because it might be detected based on different `seriesLayoutBy`.
            // (2) We should support that the series read the upstream source in `seriesLayoutBy: 'row'`.
            // So the original detected header should be add to the result, otherwise they can not be read.
            if (startIndex) result.data = firstUpSource.data.slice(0, startIndex).concat(result.data);
            resultMetaRawOption = {
                seriesLayoutBy: (0, $cab29724515ce2b8$export$7b3f3c6551b4949b),
                sourceHeader: startIndex,
                dimensions: firstUpSource.metaRawOption.dimensions
            };
        } else resultMetaRawOption = {
            seriesLayoutBy: (0, $cab29724515ce2b8$export$7b3f3c6551b4949b),
            sourceHeader: 0,
            dimensions: result.dimensions
        };
        return (0, $99e22f5c2aa5094b$export$1921362e86c73c88)(result.data, resultMetaRawOption, null);
    });
}
function $523dedd0a2328c06$var$isSupportedSourceFormat(sourceFormat) {
    return sourceFormat === (0, $cab29724515ce2b8$export$fcd62ebf51387903) || sourceFormat === (0, $cab29724515ce2b8$export$703ae8a2d83f441);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $370e5aa482d8420b$var$UNDEFINED = 'undefined';
var $370e5aa482d8420b$export$859a1fa4f1106aa0 = typeof Uint32Array === $370e5aa482d8420b$var$UNDEFINED ? Array : Uint32Array;
var $370e5aa482d8420b$export$78cf73566f32c185 = typeof Uint16Array === $370e5aa482d8420b$var$UNDEFINED ? Array : Uint16Array;
var $370e5aa482d8420b$export$b60d945128546f53 = typeof Int32Array === $370e5aa482d8420b$var$UNDEFINED ? Array : Int32Array;
var $370e5aa482d8420b$export$365b104db51a490a = typeof Float64Array === $370e5aa482d8420b$var$UNDEFINED ? Array : Float64Array;
/**
 * Multi dimensional data store
 */ var $370e5aa482d8420b$var$dataCtors = {
    'float': $370e5aa482d8420b$export$365b104db51a490a,
    'int': $370e5aa482d8420b$export$b60d945128546f53,
    // Ordinal data type can be string or int
    'ordinal': Array,
    'number': Array,
    'time': $370e5aa482d8420b$export$365b104db51a490a
};
var $370e5aa482d8420b$var$defaultDimValueGetters;
function $370e5aa482d8420b$var$getIndicesCtor(rawCount) {
    // The possible max value in this._indicies is always this._rawCount despite of filtering.
    return rawCount > 65535 ? $370e5aa482d8420b$export$859a1fa4f1106aa0 : $370e5aa482d8420b$export$78cf73566f32c185;
}
function $370e5aa482d8420b$var$getInitialExtent() {
    return [
        Infinity,
        -Infinity
    ];
}
function $370e5aa482d8420b$var$cloneChunk(originalChunk) {
    var Ctor = originalChunk.constructor;
    // Only shallow clone is enough when Array.
    return Ctor === Array ? originalChunk.slice() : new Ctor(originalChunk);
}
function $370e5aa482d8420b$var$prepareStore(store, dimIdx, dimType, end, append) {
    var DataCtor = $370e5aa482d8420b$var$dataCtors[dimType || 'float'];
    if (append) {
        var oldStore = store[dimIdx];
        var oldLen = oldStore && oldStore.length;
        if (!(oldLen === end)) {
            var newStore = new DataCtor(end);
            // The cost of the copy is probably inconsiderable
            // within the initial chunkSize.
            for(var j = 0; j < oldLen; j++)newStore[j] = oldStore[j];
            store[dimIdx] = newStore;
        }
    } else store[dimIdx] = new DataCtor(end);
}
/**
 * Basically, DataStore API keep immutable.
 */ var $370e5aa482d8420b$var$DataStore = /** @class */ function() {
    function DataStore() {
        this._chunks = [];
        // It will not be calculated until needed.
        this._rawExtent = [];
        this._extent = [];
        this._count = 0;
        this._rawCount = 0;
        this._calcDimNameToIdx = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    }
    /**
   * Initialize from data
   */ DataStore.prototype.initData = function(provider, inputDimensions, dimValueGetter) {
        this._provider = provider;
        // Clear
        this._chunks = [];
        this._indices = null;
        this.getRawIndex = this._getRawIdxIdentity;
        var source = provider.getSource();
        var defaultGetter = this.defaultDimValueGetter = $370e5aa482d8420b$var$defaultDimValueGetters[source.sourceFormat];
        // Default dim value getter
        this._dimValueGetter = dimValueGetter || defaultGetter;
        // Reset raw extent.
        this._rawExtent = [];
        var willRetrieveDataByName = (0, $99e22f5c2aa5094b$export$8911336b527f8517)(source);
        this._dimensions = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(inputDimensions, function(dim) {
            return {
                // Only pick these two props. Not leak other properties like orderMeta.
                type: dim.type,
                property: dim.property
            };
        });
        this._initDataFromProvider(0, provider.count());
    };
    DataStore.prototype.getProvider = function() {
        return this._provider;
    };
    /**
   * Caution: even when a `source` instance owned by a series, the created data store
   * may still be shared by different sereis (the source hash does not use all `source`
   * props, see `sourceManager`). In this case, the `source` props that are not used in
   * hash (like `source.dimensionDefine`) probably only belongs to a certain series and
   * thus should not be fetch here.
   */ DataStore.prototype.getSource = function() {
        return this._provider.getSource();
    };
    /**
   * @caution Only used in dataStack.
   */ DataStore.prototype.ensureCalculationDimension = function(dimName, type) {
        var calcDimNameToIdx = this._calcDimNameToIdx;
        var dimensions = this._dimensions;
        var calcDimIdx = calcDimNameToIdx.get(dimName);
        if (calcDimIdx != null) {
            if (dimensions[calcDimIdx].type === type) return calcDimIdx;
        } else calcDimIdx = dimensions.length;
        dimensions[calcDimIdx] = {
            type: type
        };
        calcDimNameToIdx.set(dimName, calcDimIdx);
        this._chunks[calcDimIdx] = new $370e5aa482d8420b$var$dataCtors[type || 'float'](this._rawCount);
        this._rawExtent[calcDimIdx] = $370e5aa482d8420b$var$getInitialExtent();
        return calcDimIdx;
    };
    DataStore.prototype.collectOrdinalMeta = function(dimIdx, ordinalMeta) {
        var chunk = this._chunks[dimIdx];
        var dim = this._dimensions[dimIdx];
        var rawExtents = this._rawExtent;
        var offset = dim.ordinalOffset || 0;
        var len = chunk.length;
        if (offset === 0) // We need to reset the rawExtent if collect is from start.
        // Because this dimension may be guessed as number and calcuating a wrong extent.
        rawExtents[dimIdx] = $370e5aa482d8420b$var$getInitialExtent();
        var dimRawExtent = rawExtents[dimIdx];
        // Parse from previous data offset. len may be changed after appendData
        for(var i = offset; i < len; i++){
            var val = chunk[i] = ordinalMeta.parseAndCollect(chunk[i]);
            if (!isNaN(val)) {
                dimRawExtent[0] = Math.min(val, dimRawExtent[0]);
                dimRawExtent[1] = Math.max(val, dimRawExtent[1]);
            }
        }
        dim.ordinalMeta = ordinalMeta;
        dim.ordinalOffset = len;
        dim.type = 'ordinal'; // Force to be ordinal
    };
    DataStore.prototype.getOrdinalMeta = function(dimIdx) {
        var dimInfo = this._dimensions[dimIdx];
        var ordinalMeta = dimInfo.ordinalMeta;
        return ordinalMeta;
    };
    DataStore.prototype.getDimensionProperty = function(dimIndex) {
        var item = this._dimensions[dimIndex];
        return item && item.property;
    };
    /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   */ DataStore.prototype.appendData = function(data) {
        var provider = this._provider;
        var start = this.count();
        provider.appendData(data);
        var end = provider.count();
        if (!provider.persistent) end += start;
        if (start < end) this._initDataFromProvider(start, end, true);
        return [
            start,
            end
        ];
    };
    DataStore.prototype.appendValues = function(values, minFillLen) {
        var chunks = this._chunks;
        var dimensions = this._dimensions;
        var dimLen = dimensions.length;
        var rawExtent = this._rawExtent;
        var start = this.count();
        var end = start + Math.max(values.length, minFillLen || 0);
        for(var i = 0; i < dimLen; i++){
            var dim = dimensions[i];
            $370e5aa482d8420b$var$prepareStore(chunks, i, dim.type, end, true);
        }
        var emptyDataItem = [];
        for(var idx = start; idx < end; idx++){
            var sourceIdx = idx - start;
            // Store the data by dimensions
            for(var dimIdx = 0; dimIdx < dimLen; dimIdx++){
                var dim = dimensions[dimIdx];
                var val = $370e5aa482d8420b$var$defaultDimValueGetters.arrayRows.call(this, values[sourceIdx] || emptyDataItem, dim.property, sourceIdx, dimIdx);
                chunks[dimIdx][idx] = val;
                var dimRawExtent = rawExtent[dimIdx];
                val < dimRawExtent[0] && (dimRawExtent[0] = val);
                val > dimRawExtent[1] && (dimRawExtent[1] = val);
            }
        }
        this._rawCount = this._count = end;
        return {
            start: start,
            end: end
        };
    };
    DataStore.prototype._initDataFromProvider = function(start, end, append) {
        var provider = this._provider;
        var chunks = this._chunks;
        var dimensions = this._dimensions;
        var dimLen = dimensions.length;
        var rawExtent = this._rawExtent;
        var dimNames = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(dimensions, function(dim) {
            return dim.property;
        });
        for(var i = 0; i < dimLen; i++){
            var dim = dimensions[i];
            if (!rawExtent[i]) rawExtent[i] = $370e5aa482d8420b$var$getInitialExtent();
            $370e5aa482d8420b$var$prepareStore(chunks, i, dim.type, end, append);
        }
        if (provider.fillStorage) provider.fillStorage(start, end, chunks, rawExtent);
        else {
            var dataItem = [];
            for(var idx = start; idx < end; idx++){
                // NOTICE: Try not to write things into dataItem
                dataItem = provider.getItem(idx, dataItem);
                // Each data item is value
                // [1, 2]
                // 2
                // Bar chart, line chart which uses category axis
                // only gives the 'y' value. 'x' value is the indices of category
                // Use a tempValue to normalize the value to be a (x, y) value
                // Store the data by dimensions
                for(var dimIdx = 0; dimIdx < dimLen; dimIdx++){
                    var dimStorage = chunks[dimIdx];
                    // PENDING NULL is empty or zero
                    var val = this._dimValueGetter(dataItem, dimNames[dimIdx], idx, dimIdx);
                    dimStorage[idx] = val;
                    var dimRawExtent = rawExtent[dimIdx];
                    val < dimRawExtent[0] && (dimRawExtent[0] = val);
                    val > dimRawExtent[1] && (dimRawExtent[1] = val);
                }
            }
        }
        if (!provider.persistent && provider.clean) // Clean unused data if data source is typed array.
        provider.clean();
        this._rawCount = this._count = end;
        // Reset data extent
        this._extent = [];
    };
    DataStore.prototype.count = function() {
        return this._count;
    };
    /**
   * Get value. Return NaN if idx is out of range.
   */ DataStore.prototype.get = function(dim, idx) {
        if (!(idx >= 0 && idx < this._count)) return NaN;
        var dimStore = this._chunks[dim];
        return dimStore ? dimStore[this.getRawIndex(idx)] : NaN;
    };
    DataStore.prototype.getValues = function(dimensions, idx) {
        var values = [];
        var dimArr = [];
        if (idx == null) {
            idx = dimensions;
            // TODO get all from store?
            dimensions = [];
            // All dimensions
            for(var i = 0; i < this._dimensions.length; i++)dimArr.push(i);
        } else dimArr = dimensions;
        for(var i = 0, len = dimArr.length; i < len; i++)values.push(this.get(dimArr[i], idx));
        return values;
    };
    /**
   * @param dim concrete dim
   */ DataStore.prototype.getByRawIndex = function(dim, rawIdx) {
        if (!(rawIdx >= 0 && rawIdx < this._rawCount)) return NaN;
        var dimStore = this._chunks[dim];
        return dimStore ? dimStore[rawIdx] : NaN;
    };
    /**
   * Get sum of data in one dimension
   */ DataStore.prototype.getSum = function(dim) {
        var dimData = this._chunks[dim];
        var sum = 0;
        if (dimData) for(var i = 0, len = this.count(); i < len; i++){
            var value = this.get(dim, i);
            if (!isNaN(value)) sum += value;
        }
        return sum;
    };
    /**
   * Get median of data in one dimension
   */ DataStore.prototype.getMedian = function(dim) {
        var dimDataArray = [];
        // map all data of one dimension
        this.each([
            dim
        ], function(val) {
            if (!isNaN(val)) dimDataArray.push(val);
        });
        // TODO
        // Use quick select?
        var sortedDimDataArray = dimDataArray.sort(function(a, b) {
            return a - b;
        });
        var len = this.count();
        // calculate median
        return len === 0 ? 0 : len % 2 === 1 ? sortedDimDataArray[(len - 1) / 2] : (sortedDimDataArray[len / 2] + sortedDimDataArray[len / 2 - 1]) / 2;
    };
    /**
   * Retrieve the index with given raw data index.
   */ DataStore.prototype.indexOfRawIndex = function(rawIndex) {
        if (rawIndex >= this._rawCount || rawIndex < 0) return -1;
        if (!this._indices) return rawIndex;
        // Indices are ascending
        var indices = this._indices;
        // If rawIndex === dataIndex
        var rawDataIndex = indices[rawIndex];
        if (rawDataIndex != null && rawDataIndex < this._count && rawDataIndex === rawIndex) return rawIndex;
        var left = 0;
        var right = this._count - 1;
        while(left <= right){
            var mid = (left + right) / 2 | 0;
            if (indices[mid] < rawIndex) left = mid + 1;
            else if (indices[mid] > rawIndex) right = mid - 1;
            else return mid;
        }
        return -1;
    };
    /**
   * Retrieve the index of nearest value.
   * @param dim
   * @param value
   * @param [maxDistance=Infinity]
   * @return If and only if multiple indices have
   *         the same value, they are put to the result.
   */ DataStore.prototype.indicesOfNearest = function(dim, value, maxDistance) {
        var chunks = this._chunks;
        var dimData = chunks[dim];
        var nearestIndices = [];
        if (!dimData) return nearestIndices;
        if (maxDistance == null) maxDistance = Infinity;
        var minDist = Infinity;
        var minDiff = -1;
        var nearestIndicesLen = 0;
        // Check the test case of `test/ut/spec/data/SeriesData.js`.
        for(var i = 0, len = this.count(); i < len; i++){
            var dataIndex = this.getRawIndex(i);
            var diff = value - dimData[dataIndex];
            var dist = Math.abs(diff);
            if (dist <= maxDistance) {
                // When the `value` is at the middle of `this.get(dim, i)` and `this.get(dim, i+1)`,
                // we'd better not push both of them to `nearestIndices`, otherwise it is easy to
                // get more than one item in `nearestIndices` (more specifically, in `tooltip`).
                // So we choose the one that `diff >= 0` in this case.
                // But if `this.get(dim, i)` and `this.get(dim, j)` get the same value, both of them
                // should be push to `nearestIndices`.
                if (dist < minDist || dist === minDist && diff >= 0 && minDiff < 0) {
                    minDist = dist;
                    minDiff = diff;
                    nearestIndicesLen = 0;
                }
                if (diff === minDiff) nearestIndices[nearestIndicesLen++] = i;
            }
        }
        nearestIndices.length = nearestIndicesLen;
        return nearestIndices;
    };
    DataStore.prototype.getIndices = function() {
        var newIndices;
        var indices = this._indices;
        if (indices) {
            var Ctor = indices.constructor;
            var thisCount = this._count;
            // `new Array(a, b, c)` is different from `new Uint32Array(a, b, c)`.
            if (Ctor === Array) {
                newIndices = new Ctor(thisCount);
                for(var i = 0; i < thisCount; i++)newIndices[i] = indices[i];
            } else newIndices = new Ctor(indices.buffer, 0, thisCount);
        } else {
            var Ctor = $370e5aa482d8420b$var$getIndicesCtor(this._rawCount);
            newIndices = new Ctor(this.count());
            for(var i = 0; i < newIndices.length; i++)newIndices[i] = i;
        }
        return newIndices;
    };
    /**
   * Data filter.
   */ DataStore.prototype.filter = function(dims, cb) {
        if (!this._count) return this;
        var newStore = this.clone();
        var count = newStore.count();
        var Ctor = $370e5aa482d8420b$var$getIndicesCtor(newStore._rawCount);
        var newIndices = new Ctor(count);
        var value = [];
        var dimSize = dims.length;
        var offset = 0;
        var dim0 = dims[0];
        var chunks = newStore._chunks;
        for(var i = 0; i < count; i++){
            var keep = void 0;
            var rawIdx = newStore.getRawIndex(i);
            // Simple optimization
            if (dimSize === 0) keep = cb(i);
            else if (dimSize === 1) {
                var val = chunks[dim0][rawIdx];
                keep = cb(val, i);
            } else {
                var k = 0;
                for(; k < dimSize; k++)value[k] = chunks[dims[k]][rawIdx];
                value[k] = i;
                keep = cb.apply(null, value);
            }
            if (keep) newIndices[offset++] = rawIdx;
        }
        // Set indices after filtered.
        if (offset < count) newStore._indices = newIndices;
        newStore._count = offset;
        // Reset data extent
        newStore._extent = [];
        newStore._updateGetRawIdx();
        return newStore;
    };
    /**
   * Select data in range. (For optimization of filter)
   * (Manually inline code, support 5 million data filtering in data zoom.)
   */ DataStore.prototype.selectRange = function(range) {
        var newStore = this.clone();
        var len = newStore._count;
        if (!len) return this;
        var dims = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(range);
        var dimSize = dims.length;
        if (!dimSize) return this;
        var originalCount = newStore.count();
        var Ctor = $370e5aa482d8420b$var$getIndicesCtor(newStore._rawCount);
        var newIndices = new Ctor(originalCount);
        var offset = 0;
        var dim0 = dims[0];
        var min = range[dim0][0];
        var max = range[dim0][1];
        var storeArr = newStore._chunks;
        var quickFinished = false;
        if (!newStore._indices) {
            // Extreme optimization for common case. About 2x faster in chrome.
            var idx = 0;
            if (dimSize === 1) {
                var dimStorage = storeArr[dims[0]];
                for(var i = 0; i < len; i++){
                    var val = dimStorage[i];
                    // NaN will not be filtered. Consider the case, in line chart, empty
                    // value indicates the line should be broken. But for the case like
                    // scatter plot, a data item with empty value will not be rendered,
                    // but the axis extent may be effected if some other dim of the data
                    // item has value. Fortunately it is not a significant negative effect.
                    if (val >= min && val <= max || isNaN(val)) newIndices[offset++] = idx;
                    idx++;
                }
                quickFinished = true;
            } else if (dimSize === 2) {
                var dimStorage = storeArr[dims[0]];
                var dimStorage2 = storeArr[dims[1]];
                var min2 = range[dims[1]][0];
                var max2 = range[dims[1]][1];
                for(var i = 0; i < len; i++){
                    var val = dimStorage[i];
                    var val2 = dimStorage2[i];
                    // Do not filter NaN, see comment above.
                    if ((val >= min && val <= max || isNaN(val)) && (val2 >= min2 && val2 <= max2 || isNaN(val2))) newIndices[offset++] = idx;
                    idx++;
                }
                quickFinished = true;
            }
        }
        if (!quickFinished) {
            if (dimSize === 1) for(var i = 0; i < originalCount; i++){
                var rawIndex = newStore.getRawIndex(i);
                var val = storeArr[dims[0]][rawIndex];
                // Do not filter NaN, see comment above.
                if (val >= min && val <= max || isNaN(val)) newIndices[offset++] = rawIndex;
            }
            else for(var i = 0; i < originalCount; i++){
                var keep = true;
                var rawIndex = newStore.getRawIndex(i);
                for(var k = 0; k < dimSize; k++){
                    var dimk = dims[k];
                    var val = storeArr[dimk][rawIndex];
                    // Do not filter NaN, see comment above.
                    if (val < range[dimk][0] || val > range[dimk][1]) keep = false;
                }
                if (keep) newIndices[offset++] = newStore.getRawIndex(i);
            }
        }
        // Set indices after filtered.
        if (offset < originalCount) newStore._indices = newIndices;
        newStore._count = offset;
        // Reset data extent
        newStore._extent = [];
        newStore._updateGetRawIdx();
        return newStore;
    };
    // /**
    //  * Data mapping to a plain array
    //  */
    // mapArray(dims: DimensionIndex[], cb: MapArrayCb): any[] {
    //     const result: any[] = [];
    //     this.each(dims, function () {
    //         result.push(cb && (cb as MapArrayCb).apply(null, arguments));
    //     });
    //     return result;
    // }
    /**
   * Data mapping to a new List with given dimensions
   */ DataStore.prototype.map = function(dims, cb) {
        // TODO only clone picked chunks.
        var target = this.clone(dims);
        this._updateDims(target, dims, cb);
        return target;
    };
    /**
   * @caution Danger!! Only used in dataStack.
   */ DataStore.prototype.modify = function(dims, cb) {
        this._updateDims(this, dims, cb);
    };
    DataStore.prototype._updateDims = function(target, dims, cb) {
        var targetChunks = target._chunks;
        var tmpRetValue = [];
        var dimSize = dims.length;
        var dataCount = target.count();
        var values = [];
        var rawExtent = target._rawExtent;
        for(var i = 0; i < dims.length; i++)rawExtent[dims[i]] = $370e5aa482d8420b$var$getInitialExtent();
        for(var dataIndex = 0; dataIndex < dataCount; dataIndex++){
            var rawIndex = target.getRawIndex(dataIndex);
            for(var k = 0; k < dimSize; k++)values[k] = targetChunks[dims[k]][rawIndex];
            values[dimSize] = dataIndex;
            var retValue = cb && cb.apply(null, values);
            if (retValue != null) {
                // a number or string (in oridinal dimension)?
                if (typeof retValue !== 'object') {
                    tmpRetValue[0] = retValue;
                    retValue = tmpRetValue;
                }
                for(var i = 0; i < retValue.length; i++){
                    var dim = dims[i];
                    var val = retValue[i];
                    var rawExtentOnDim = rawExtent[dim];
                    var dimStore = targetChunks[dim];
                    if (dimStore) dimStore[rawIndex] = val;
                    if (val < rawExtentOnDim[0]) rawExtentOnDim[0] = val;
                    if (val > rawExtentOnDim[1]) rawExtentOnDim[1] = val;
                }
            }
        }
    };
    /**
   * Large data down sampling using largest-triangle-three-buckets
   * @param {string} valueDimension
   * @param {number} targetCount
   */ DataStore.prototype.lttbDownSample = function(valueDimension, rate) {
        var target = this.clone([
            valueDimension
        ], true);
        var targetStorage = target._chunks;
        var dimStore = targetStorage[valueDimension];
        var len = this.count();
        var sampledIndex = 0;
        var frameSize = Math.floor(1 / rate);
        var currentRawIndex = this.getRawIndex(0);
        var maxArea;
        var area;
        var nextRawIndex;
        var newIndices = new ($370e5aa482d8420b$var$getIndicesCtor(this._rawCount))(Math.min((Math.ceil(len / frameSize) + 2) * 2, len));
        // First frame use the first data.
        newIndices[sampledIndex++] = currentRawIndex;
        for(var i = 1; i < len - 1; i += frameSize){
            var nextFrameStart = Math.min(i + frameSize, len - 1);
            var nextFrameEnd = Math.min(i + frameSize * 2, len);
            var avgX = (nextFrameEnd + nextFrameStart) / 2;
            var avgY = 0;
            for(var idx = nextFrameStart; idx < nextFrameEnd; idx++){
                var rawIndex = this.getRawIndex(idx);
                var y = dimStore[rawIndex];
                if (isNaN(y)) continue;
                avgY += y;
            }
            avgY /= nextFrameEnd - nextFrameStart;
            var frameStart = i;
            var frameEnd = Math.min(i + frameSize, len);
            var pointAX = i - 1;
            var pointAY = dimStore[currentRawIndex];
            maxArea = -1;
            nextRawIndex = frameStart;
            var firstNaNIndex = -1;
            var countNaN = 0;
            // Find a point from current frame that construct a triangle with largest area with previous selected point
            // And the average of next frame.
            for(var idx = frameStart; idx < frameEnd; idx++){
                var rawIndex = this.getRawIndex(idx);
                var y = dimStore[rawIndex];
                if (isNaN(y)) {
                    countNaN++;
                    if (firstNaNIndex < 0) firstNaNIndex = rawIndex;
                    continue;
                }
                // Calculate triangle area over three buckets
                area = Math.abs((pointAX - avgX) * (y - pointAY) - (pointAX - idx) * (avgY - pointAY));
                if (area > maxArea) {
                    maxArea = area;
                    nextRawIndex = rawIndex; // Next a is this b
                }
            }
            if (countNaN > 0 && countNaN < frameEnd - frameStart) {
                // Append first NaN point in every bucket.
                // It is necessary to ensure the correct order of indices.
                newIndices[sampledIndex++] = Math.min(firstNaNIndex, nextRawIndex);
                nextRawIndex = Math.max(firstNaNIndex, nextRawIndex);
            }
            newIndices[sampledIndex++] = nextRawIndex;
            currentRawIndex = nextRawIndex; // This a is the next a (chosen b)
        }
        // First frame use the last data.
        newIndices[sampledIndex++] = this.getRawIndex(len - 1);
        target._count = sampledIndex;
        target._indices = newIndices;
        target.getRawIndex = this._getRawIdx;
        return target;
    };
    /**
   * Large data down sampling using min-max
   * @param {string} valueDimension
   * @param {number} rate
   */ DataStore.prototype.minmaxDownSample = function(valueDimension, rate) {
        var target = this.clone([
            valueDimension
        ], true);
        var targetStorage = target._chunks;
        var frameSize = Math.floor(1 / rate);
        var dimStore = targetStorage[valueDimension];
        var len = this.count();
        // Each frame results in 2 data points, one for min and one for max
        var newIndices = new ($370e5aa482d8420b$var$getIndicesCtor(this._rawCount))(Math.ceil(len / frameSize) * 2);
        var offset = 0;
        for(var i = 0; i < len; i += frameSize){
            var minIndex = i;
            var minValue = dimStore[this.getRawIndex(minIndex)];
            var maxIndex = i;
            var maxValue = dimStore[this.getRawIndex(maxIndex)];
            var thisFrameSize = frameSize;
            // Handle final smaller frame
            if (i + frameSize > len) thisFrameSize = len - i;
            // Determine min and max within the current frame
            for(var k = 0; k < thisFrameSize; k++){
                var rawIndex = this.getRawIndex(i + k);
                var value = dimStore[rawIndex];
                if (value < minValue) {
                    minValue = value;
                    minIndex = i + k;
                }
                if (value > maxValue) {
                    maxValue = value;
                    maxIndex = i + k;
                }
            }
            var rawMinIndex = this.getRawIndex(minIndex);
            var rawMaxIndex = this.getRawIndex(maxIndex);
            // Set the order of the min and max values, based on their ordering in the frame
            if (minIndex < maxIndex) {
                newIndices[offset++] = rawMinIndex;
                newIndices[offset++] = rawMaxIndex;
            } else {
                newIndices[offset++] = rawMaxIndex;
                newIndices[offset++] = rawMinIndex;
            }
        }
        target._count = offset;
        target._indices = newIndices;
        target._updateGetRawIdx();
        return target;
    };
    /**
   * Large data down sampling on given dimension
   * @param sampleIndex Sample index for name and id
   */ DataStore.prototype.downSample = function(dimension, rate, sampleValue, sampleIndex) {
        var target = this.clone([
            dimension
        ], true);
        var targetStorage = target._chunks;
        var frameValues = [];
        var frameSize = Math.floor(1 / rate);
        var dimStore = targetStorage[dimension];
        var len = this.count();
        var rawExtentOnDim = target._rawExtent[dimension] = $370e5aa482d8420b$var$getInitialExtent();
        var newIndices = new ($370e5aa482d8420b$var$getIndicesCtor(this._rawCount))(Math.ceil(len / frameSize));
        var offset = 0;
        for(var i = 0; i < len; i += frameSize){
            // Last frame
            if (frameSize > len - i) {
                frameSize = len - i;
                frameValues.length = frameSize;
            }
            for(var k = 0; k < frameSize; k++){
                var dataIdx = this.getRawIndex(i + k);
                frameValues[k] = dimStore[dataIdx];
            }
            var value = sampleValue(frameValues);
            var sampleFrameIdx = this.getRawIndex(Math.min(i + sampleIndex(frameValues, value) || 0, len - 1));
            // Only write value on the filtered data
            dimStore[sampleFrameIdx] = value;
            if (value < rawExtentOnDim[0]) rawExtentOnDim[0] = value;
            if (value > rawExtentOnDim[1]) rawExtentOnDim[1] = value;
            newIndices[offset++] = sampleFrameIdx;
        }
        target._count = offset;
        target._indices = newIndices;
        target._updateGetRawIdx();
        return target;
    };
    /**
   * Data iteration
   * @param ctx default this
   * @example
   *  list.each('x', function (x, idx) {});
   *  list.each(['x', 'y'], function (x, y, idx) {});
   *  list.each(function (idx) {})
   */ DataStore.prototype.each = function(dims, cb) {
        if (!this._count) return;
        var dimSize = dims.length;
        var chunks = this._chunks;
        for(var i = 0, len = this.count(); i < len; i++){
            var rawIdx = this.getRawIndex(i);
            // Simple optimization
            switch(dimSize){
                case 0:
                    cb(i);
                    break;
                case 1:
                    cb(chunks[dims[0]][rawIdx], i);
                    break;
                case 2:
                    cb(chunks[dims[0]][rawIdx], chunks[dims[1]][rawIdx], i);
                    break;
                default:
                    var k = 0;
                    var value = [];
                    for(; k < dimSize; k++)value[k] = chunks[dims[k]][rawIdx];
                    // Index
                    value[k] = i;
                    cb.apply(null, value);
            }
        }
    };
    /**
   * Get extent of data in one dimension
   */ DataStore.prototype.getDataExtent = function(dim) {
        // Make sure use concrete dim as cache name.
        var dimData = this._chunks[dim];
        var initialExtent = $370e5aa482d8420b$var$getInitialExtent();
        if (!dimData) return initialExtent;
        // Make more strict checkings to ensure hitting cache.
        var currEnd = this.count();
        // Consider the most cases when using data zoom, `getDataExtent`
        // happened before filtering. We cache raw extent, which is not
        // necessary to be cleared and recalculated when restore data.
        var useRaw = !this._indices;
        var dimExtent;
        if (useRaw) return this._rawExtent[dim].slice();
        dimExtent = this._extent[dim];
        if (dimExtent) return dimExtent.slice();
        dimExtent = initialExtent;
        var min = dimExtent[0];
        var max = dimExtent[1];
        for(var i = 0; i < currEnd; i++){
            var rawIdx = this.getRawIndex(i);
            var value = dimData[rawIdx];
            value < min && (min = value);
            value > max && (max = value);
        }
        dimExtent = [
            min,
            max
        ];
        this._extent[dim] = dimExtent;
        return dimExtent;
    };
    /**
   * Get raw data item
   */ DataStore.prototype.getRawDataItem = function(idx) {
        var rawIdx = this.getRawIndex(idx);
        if (!this._provider.persistent) {
            var val = [];
            var chunks = this._chunks;
            for(var i = 0; i < chunks.length; i++)val.push(chunks[i][rawIdx]);
            return val;
        } else return this._provider.getItem(rawIdx);
    };
    /**
   * Clone shallow.
   *
   * @param clonedDims Determine which dims to clone. Will share the data if not specified.
   */ DataStore.prototype.clone = function(clonedDims, ignoreIndices) {
        var target = new DataStore();
        var chunks = this._chunks;
        var clonedDimsMap = clonedDims && (0, $7a1bd9c2710fea0d$export$533b26079ad0b4b)(clonedDims, function(obj, dimIdx) {
            obj[dimIdx] = true;
            return obj;
        }, {});
        if (clonedDimsMap) for(var i = 0; i < chunks.length; i++)// Not clone if dim is not picked.
        target._chunks[i] = !clonedDimsMap[i] ? chunks[i] : $370e5aa482d8420b$var$cloneChunk(chunks[i]);
        else target._chunks = chunks;
        this._copyCommonProps(target);
        if (!ignoreIndices) target._indices = this._cloneIndices();
        target._updateGetRawIdx();
        return target;
    };
    DataStore.prototype._copyCommonProps = function(target) {
        target._count = this._count;
        target._rawCount = this._rawCount;
        target._provider = this._provider;
        target._dimensions = this._dimensions;
        target._extent = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(this._extent);
        target._rawExtent = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(this._rawExtent);
    };
    DataStore.prototype._cloneIndices = function() {
        if (this._indices) {
            var Ctor = this._indices.constructor;
            var indices = void 0;
            if (Ctor === Array) {
                var thisCount = this._indices.length;
                indices = new Ctor(thisCount);
                for(var i = 0; i < thisCount; i++)indices[i] = this._indices[i];
            } else indices = new Ctor(this._indices);
            return indices;
        }
        return null;
    };
    DataStore.prototype._getRawIdxIdentity = function(idx) {
        return idx;
    };
    DataStore.prototype._getRawIdx = function(idx) {
        if (idx < this._count && idx >= 0) return this._indices[idx];
        return -1;
    };
    DataStore.prototype._updateGetRawIdx = function() {
        this.getRawIndex = this._indices ? this._getRawIdx : this._getRawIdxIdentity;
    };
    DataStore.internalField = function() {
        function getDimValueSimply(dataItem, property, dataIndex, dimIndex) {
            return (0, $40ab59f44b7d2db6$export$cc7175145baad076)(dataItem[dimIndex], this._dimensions[dimIndex]);
        }
        $370e5aa482d8420b$var$defaultDimValueGetters = {
            arrayRows: getDimValueSimply,
            objectRows: function(dataItem, property, dataIndex, dimIndex) {
                return (0, $40ab59f44b7d2db6$export$cc7175145baad076)(dataItem[property], this._dimensions[dimIndex]);
            },
            keyedColumns: getDimValueSimply,
            original: function(dataItem, property, dataIndex, dimIndex) {
                // Performance sensitive, do not use modelUtil.getDataItemValue.
                // If dataItem is an plain object with no value field, the let `value`
                // will be assigned with the object, but it will be tread correctly
                // in the `convertValue`.
                var value = dataItem && (dataItem.value == null ? dataItem : dataItem.value);
                return (0, $40ab59f44b7d2db6$export$cc7175145baad076)(value instanceof Array ? value[dimIndex] : value, this._dimensions[dimIndex]);
            },
            typedArray: function(dataItem, property, dataIndex, dimIndex) {
                return dataItem[dimIndex];
            }
        };
    }();
    return DataStore;
}();
var $370e5aa482d8420b$export$2e2bcd8739ae039 = $370e5aa482d8420b$var$DataStore;



/**
 * [REQUIREMENT_MEMO]:
 * (0) `metaRawOption` means `dimensions`/`sourceHeader`/`seriesLayoutBy` in raw option.
 * (1) Keep support the feature: `metaRawOption` can be specified both on `series` and
 * `root-dataset`. Them on `series` has higher priority.
 * (2) Do not support to set `metaRawOption` on a `non-root-dataset`, because it might
 * confuse users: whether those props indicate how to visit the upstream source or visit
 * the transform result source, and some transforms has nothing to do with these props,
 * and some transforms might have multiple upstream.
 * (3) Transforms should specify `metaRawOption` in each output, just like they can be
 * declared in `root-dataset`.
 * (4) At present only support visit source in `SERIES_LAYOUT_BY_COLUMN` in transforms.
 * That is for reducing complexity in transforms.
 * PENDING: Whether to provide transposition transform?
 *
 * [IMPLEMENTAION_MEMO]:
 * "sourceVisitConfig" are calculated from `metaRawOption` and `data`.
 * They will not be calculated until `source` is about to be visited (to prevent from
 * duplicate calcuation). `source` is visited only in series and input to transforms.
 *
 * [DIMENSION_INHERIT_RULE]:
 * By default the dimensions are inherited from ancestors, unless a transform return
 * a new dimensions definition.
 * Consider the case:
 * ```js
 * dataset: [{
 *     source: [ ['Product', 'Sales', 'Prise'], ['Cookies', 321, 44.21], ...]
 * }, {
 *     transform: { type: 'filter', ... }
 * }]
 * dataset: [{
 *     dimension: ['Product', 'Sales', 'Prise'],
 *     source: [ ['Cookies', 321, 44.21], ...]
 * }, {
 *     transform: { type: 'filter', ... }
 * }]
 * ```
 * The two types of option should have the same behavior after transform.
 *
 *
 * [SCENARIO]:
 * (1) Provide source data directly:
 * ```js
 * series: {
 *     encode: {...},
 *     dimensions: [...]
 *     seriesLayoutBy: 'row',
 *     data: [[...]]
 * }
 * ```
 * (2) Series refer to dataset.
 * ```js
 * series: [{
 *     encode: {...}
 *     // Ignore datasetIndex means `datasetIndex: 0`
 *     // and the dimensions defination in dataset is used
 * }, {
 *     encode: {...},
 *     seriesLayoutBy: 'column',
 *     datasetIndex: 1
 * }]
 * ```
 * (3) dataset transform
 * ```js
 * dataset: [{
 *     source: [...]
 * }, {
 *     source: [...]
 * }, {
 *     // By default from 0.
 *     transform: { type: 'filter', config: {...} }
 * }, {
 *     // Piped.
 *     transform: [
 *         { type: 'filter', config: {...} },
 *         { type: 'sort', config: {...} }
 *     ]
 * }, {
 *     id: 'regressionData',
 *     fromDatasetIndex: 1,
 *     // Third-party transform
 *     transform: { type: 'ecStat:regression', config: {...} }
 * }, {
 *     // retrieve the extra result.
 *     id: 'regressionFormula',
 *     fromDatasetId: 'regressionData',
 *     fromTransformResult: 1
 * }]
 * ```
 */ var $1c87d176de397e7e$export$af4db9ec7e200ea2 = /** @class */ function() {
    function SourceManager(sourceHost) {
        // Cached source. Do not repeat calculating if not dirty.
        this._sourceList = [];
        this._storeList = [];
        // version sign of each upstream source manager.
        this._upstreamSignList = [];
        this._versionSignBase = 0;
        this._dirty = true;
        this._sourceHost = sourceHost;
    }
    /**
   * Mark dirty.
   */ SourceManager.prototype.dirty = function() {
        this._setLocalSource([], []);
        this._storeList = [];
        this._dirty = true;
    };
    SourceManager.prototype._setLocalSource = function(sourceList, upstreamSignList) {
        this._sourceList = sourceList;
        this._upstreamSignList = upstreamSignList;
        this._versionSignBase++;
        if (this._versionSignBase > 9e10) this._versionSignBase = 0;
    };
    /**
   * For detecting whether the upstream source is dirty, so that
   * the local cached source (in `_sourceList`) should be discarded.
   */ SourceManager.prototype._getVersionSign = function() {
        return this._sourceHost.uid + '_' + this._versionSignBase;
    };
    /**
   * Always return a source instance. Otherwise throw error.
   */ SourceManager.prototype.prepareSource = function() {
        // For the case that call `setOption` multiple time but no data changed,
        // cache the result source to prevent from repeating transform.
        if (this._isDirty()) {
            this._createSource();
            this._dirty = false;
        }
    };
    SourceManager.prototype._createSource = function() {
        this._setLocalSource([], []);
        var sourceHost = this._sourceHost;
        var upSourceMgrList = this._getUpstreamSourceManagers();
        var hasUpstream = !!upSourceMgrList.length;
        var resultSourceList;
        var upstreamSignList;
        if ($1c87d176de397e7e$var$isSeries(sourceHost)) {
            var seriesModel = sourceHost;
            var data = void 0;
            var sourceFormat = void 0;
            var upSource = void 0;
            // Has upstream dataset
            if (hasUpstream) {
                var upSourceMgr = upSourceMgrList[0];
                upSourceMgr.prepareSource();
                upSource = upSourceMgr.getSource();
                data = upSource.data;
                sourceFormat = upSource.sourceFormat;
                upstreamSignList = [
                    upSourceMgr._getVersionSign()
                ];
            } else {
                data = seriesModel.get('data', true);
                sourceFormat = (0, $7a1bd9c2710fea0d$export$b119cc7e1840e59c)(data) ? (0, $cab29724515ce2b8$export$a918cb016a382d45) : (0, $cab29724515ce2b8$export$2823037fb9d8f0c6);
                upstreamSignList = [];
            }
            // See [REQUIREMENT_MEMO], merge settings on series and parent dataset if it is root.
            var newMetaRawOption = this._getSourceMetaRawOption() || {};
            var upMetaRawOption = upSource && upSource.metaRawOption || {};
            var seriesLayoutBy = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(newMetaRawOption.seriesLayoutBy, upMetaRawOption.seriesLayoutBy) || null;
            var sourceHeader = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(newMetaRawOption.sourceHeader, upMetaRawOption.sourceHeader);
            // Note here we should not use `upSource.dimensionsDefine`. Consider the case:
            // `upSource.dimensionsDefine` is detected by `seriesLayoutBy: 'column'`,
            // but series need `seriesLayoutBy: 'row'`.
            var dimensions = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(newMetaRawOption.dimensions, upMetaRawOption.dimensions);
            // We share source with dataset as much as possible
            // to avoid extra memory cost of high dimensional data.
            var needsCreateSource = seriesLayoutBy !== upMetaRawOption.seriesLayoutBy || !!sourceHeader !== !!upMetaRawOption.sourceHeader || dimensions;
            resultSourceList = needsCreateSource ? [
                (0, $99e22f5c2aa5094b$export$1921362e86c73c88)(data, {
                    seriesLayoutBy: seriesLayoutBy,
                    sourceHeader: sourceHeader,
                    dimensions: dimensions
                }, sourceFormat)
            ] : [];
        } else {
            var datasetModel = sourceHost;
            // Has upstream dataset.
            if (hasUpstream) {
                var result = this._applyTransform(upSourceMgrList);
                resultSourceList = result.sourceList;
                upstreamSignList = result.upstreamSignList;
            } else {
                var sourceData = datasetModel.get('source', true);
                resultSourceList = [
                    (0, $99e22f5c2aa5094b$export$1921362e86c73c88)(sourceData, this._getSourceMetaRawOption(), null)
                ];
                upstreamSignList = [];
            }
        }
        this._setLocalSource(resultSourceList, upstreamSignList);
    };
    SourceManager.prototype._applyTransform = function(upMgrList) {
        var datasetModel = this._sourceHost;
        var transformOption = datasetModel.get('transform', true);
        var fromTransformResult = datasetModel.get('fromTransformResult', true);
        if (fromTransformResult != null) {
            var errMsg = '';
            if (upMgrList.length !== 1) $1c87d176de397e7e$var$doThrow(errMsg);
        }
        var sourceList;
        var upSourceList = [];
        var upstreamSignList = [];
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(upMgrList, function(upMgr) {
            upMgr.prepareSource();
            var upSource = upMgr.getSource(fromTransformResult || 0);
            var errMsg = '';
            if (fromTransformResult != null && !upSource) $1c87d176de397e7e$var$doThrow(errMsg);
            upSourceList.push(upSource);
            upstreamSignList.push(upMgr._getVersionSign());
        });
        if (transformOption) sourceList = (0, $523dedd0a2328c06$export$42a68f09db16803f)(transformOption, upSourceList, {
            datasetIndex: datasetModel.componentIndex
        });
        else if (fromTransformResult != null) sourceList = [
            (0, $99e22f5c2aa5094b$export$e0365e7e3555ddd4)(upSourceList[0])
        ];
        return {
            sourceList: sourceList,
            upstreamSignList: upstreamSignList
        };
    };
    SourceManager.prototype._isDirty = function() {
        if (this._dirty) return true;
        // All sourceList is from the some upstream.
        var upSourceMgrList = this._getUpstreamSourceManagers();
        for(var i = 0; i < upSourceMgrList.length; i++){
            var upSrcMgr = upSourceMgrList[i];
            if (// Consider the case that there is ancestor diry, call it recursively.
            // The performance is probably not an issue because usually the chain is not long.
            upSrcMgr._isDirty() || this._upstreamSignList[i] !== upSrcMgr._getVersionSign()) return true;
        }
    };
    /**
   * @param sourceIndex By default 0, means "main source".
   *                    In most cases there is only one source.
   */ SourceManager.prototype.getSource = function(sourceIndex) {
        sourceIndex = sourceIndex || 0;
        var source = this._sourceList[sourceIndex];
        if (!source) {
            // Series may share source instance with dataset.
            var upSourceMgrList = this._getUpstreamSourceManagers();
            return upSourceMgrList[0] && upSourceMgrList[0].getSource(sourceIndex);
        }
        return source;
    };
    /**
   *
   * Get a data store which can be shared across series.
   * Only available for series.
   *
   * @param seriesDimRequest Dimensions that are generated in series.
   *        Should have been sorted by `storeDimIndex` asc.
   */ SourceManager.prototype.getSharedDataStore = function(seriesDimRequest) {
        var schema = seriesDimRequest.makeStoreSchema();
        return this._innerGetDataStore(schema.dimensions, seriesDimRequest.source, schema.hash);
    };
    SourceManager.prototype._innerGetDataStore = function(storeDims, seriesSource, sourceReadKey) {
        // TODO Can use other sourceIndex?
        var sourceIndex = 0;
        var storeList = this._storeList;
        var cachedStoreMap = storeList[sourceIndex];
        if (!cachedStoreMap) cachedStoreMap = storeList[sourceIndex] = {};
        var cachedStore = cachedStoreMap[sourceReadKey];
        if (!cachedStore) {
            var upSourceMgr = this._getUpstreamSourceManagers()[0];
            if ($1c87d176de397e7e$var$isSeries(this._sourceHost) && upSourceMgr) cachedStore = upSourceMgr._innerGetDataStore(storeDims, seriesSource, sourceReadKey);
            else {
                cachedStore = new (0, $370e5aa482d8420b$export$2e2bcd8739ae039)();
                // Always create store from source of series.
                cachedStore.initData(new (0, $8ffb0d67e9446edb$export$b900d7c4c3952a40)(seriesSource, storeDims.length), storeDims);
            }
            cachedStoreMap[sourceReadKey] = cachedStore;
        }
        return cachedStore;
    };
    /**
   * PENDING: Is it fast enough?
   * If no upstream, return empty array.
   */ SourceManager.prototype._getUpstreamSourceManagers = function() {
        // Always get the relationship from the raw option.
        // Do not cache the link of the dependency graph, so that
        // there is no need to update them when change happens.
        var sourceHost = this._sourceHost;
        if ($1c87d176de397e7e$var$isSeries(sourceHost)) {
            var datasetModel = (0, $7dc6cdfd7450ef29$export$8da66f73a1eda454)(sourceHost);
            return !datasetModel ? [] : [
                datasetModel.getSourceManager()
            ];
        } else return (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)((0, $7dc6cdfd7450ef29$export$397ba553479711e7)(sourceHost), function(datasetModel) {
            return datasetModel.getSourceManager();
        });
    };
    SourceManager.prototype._getSourceMetaRawOption = function() {
        var sourceHost = this._sourceHost;
        var seriesLayoutBy;
        var sourceHeader;
        var dimensions;
        if ($1c87d176de397e7e$var$isSeries(sourceHost)) {
            seriesLayoutBy = sourceHost.get('seriesLayoutBy', true);
            sourceHeader = sourceHost.get('sourceHeader', true);
            dimensions = sourceHost.get('dimensions', true);
        } else if (!this._getUpstreamSourceManagers().length) {
            var model = sourceHost;
            seriesLayoutBy = model.get('seriesLayoutBy', true);
            sourceHeader = model.get('sourceHeader', true);
            dimensions = model.get('dimensions', true);
        }
        return {
            seriesLayoutBy: seriesLayoutBy,
            sourceHeader: sourceHeader,
            dimensions: dimensions
        };
    };
    return SourceManager;
}();
function $1c87d176de397e7e$export$9451f4e9047441ec(datasetModel) {
    var transformOption = datasetModel.option.transform;
    transformOption && (0, $7a1bd9c2710fea0d$export$112e66431016387b)(datasetModel.option.transform);
}
function $1c87d176de397e7e$var$isSeries(sourceHost) {
    // Avoid circular dependency with Series.ts
    return sourceHost.mainType === 'series';
}
function $1c87d176de397e7e$var$doThrow(errMsg) {
    throw new Error(errMsg);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $d5ab84c08d6657ec$var$TOOLTIP_LINE_HEIGHT_CSS = 'line-height:1';
function $d5ab84c08d6657ec$var$getTooltipLineHeight(textStyle) {
    var lineHeight = textStyle.lineHeight;
    if (lineHeight == null) return $d5ab84c08d6657ec$var$TOOLTIP_LINE_HEIGHT_CSS;
    else return "line-height:" + (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(lineHeight + '') + "px";
}
// TODO: more textStyle option
function $d5ab84c08d6657ec$var$getTooltipTextStyle(textStyle, renderMode) {
    var nameFontColor = textStyle.color || '#6e7079';
    var nameFontSize = textStyle.fontSize || 12;
    var nameFontWeight = textStyle.fontWeight || '400';
    var valueFontColor = textStyle.color || '#464646';
    var valueFontSize = textStyle.fontSize || 14;
    var valueFontWeight = textStyle.fontWeight || '900';
    if (renderMode === 'html') // `textStyle` is probably from user input, should be encoded to reduce security risk.
    return {
        // eslint-disable-next-line max-len
        nameStyle: "font-size:" + (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(nameFontSize + '') + "px;color:" + (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(nameFontColor) + ";font-weight:" + (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(nameFontWeight + ''),
        // eslint-disable-next-line max-len
        valueStyle: "font-size:" + (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(valueFontSize + '') + "px;color:" + (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(valueFontColor) + ";font-weight:" + (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(valueFontWeight + '')
    };
    else return {
        nameStyle: {
            fontSize: nameFontSize,
            fill: nameFontColor,
            fontWeight: nameFontWeight
        },
        valueStyle: {
            fontSize: valueFontSize,
            fill: valueFontColor,
            fontWeight: valueFontWeight
        }
    };
}
// See `TooltipMarkupLayoutIntent['innerGapLevel']`.
// (value from UI design)
var $d5ab84c08d6657ec$var$HTML_GAPS = [
    0,
    10,
    20,
    30
];
var $d5ab84c08d6657ec$var$RICH_TEXT_GAPS = [
    '',
    '\n',
    '\n\n',
    '\n\n\n'
];
function $d5ab84c08d6657ec$export$cf63b23ce77d1921(type, option) {
    option.type = type;
    return option;
}
function $d5ab84c08d6657ec$var$isSectionFragment(frag) {
    return frag.type === 'section';
}
function $d5ab84c08d6657ec$var$getBuilder(frag) {
    return $d5ab84c08d6657ec$var$isSectionFragment(frag) ? $d5ab84c08d6657ec$var$buildSection : $d5ab84c08d6657ec$var$buildNameValue;
}
function $d5ab84c08d6657ec$var$getBlockGapLevel(frag) {
    if ($d5ab84c08d6657ec$var$isSectionFragment(frag)) {
        var gapLevel_1 = 0;
        var subBlockLen = frag.blocks.length;
        var hasInnerGap_1 = subBlockLen > 1 || subBlockLen > 0 && !frag.noHeader;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(frag.blocks, function(subBlock) {
            var subGapLevel = $d5ab84c08d6657ec$var$getBlockGapLevel(subBlock);
            // If the some of the sub-blocks have some gaps (like 10px) inside, this block
            // should use a larger gap (like 20px) to distinguish those sub-blocks.
            if (subGapLevel >= gapLevel_1) gapLevel_1 = subGapLevel + +(hasInnerGap_1 && // 0 always can not be readable gap level.
            (!subGapLevel || $d5ab84c08d6657ec$var$isSectionFragment(subBlock) && !subBlock.noHeader));
        });
        return gapLevel_1;
    }
    return 0;
}
function $d5ab84c08d6657ec$var$buildSection(ctx, fragment, topMarginForOuterGap, toolTipTextStyle) {
    var noHeader = fragment.noHeader;
    var gaps = $d5ab84c08d6657ec$var$getGap($d5ab84c08d6657ec$var$getBlockGapLevel(fragment));
    var subMarkupTextList = [];
    var subBlocks = fragment.blocks || [];
    (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)(!subBlocks || (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(subBlocks));
    subBlocks = subBlocks || [];
    var orderMode = ctx.orderMode;
    if (fragment.sortBlocks && orderMode) {
        subBlocks = subBlocks.slice();
        var orderMap = {
            valueAsc: 'asc',
            valueDesc: 'desc'
        };
        if ((0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(orderMap, orderMode)) {
            var comparator_1 = new (0, $40ab59f44b7d2db6$export$ed75a5d7b0144167)(orderMap[orderMode], null);
            subBlocks.sort(function(a, b) {
                return comparator_1.evaluate(a.sortParam, b.sortParam);
            });
        } else if (orderMode === 'seriesDesc') subBlocks.reverse();
    }
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(subBlocks, function(subBlock, idx) {
        var valueFormatter = fragment.valueFormatter;
        var subMarkupText = $d5ab84c08d6657ec$var$getBuilder(subBlock)(// Inherit valueFormatter
        valueFormatter ? (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, ctx), {
            valueFormatter: valueFormatter
        }) : ctx, subBlock, idx > 0 ? gaps.html : 0, toolTipTextStyle);
        subMarkupText != null && subMarkupTextList.push(subMarkupText);
    });
    var subMarkupText = ctx.renderMode === 'richText' ? subMarkupTextList.join(gaps.richText) : $d5ab84c08d6657ec$var$wrapBlockHTML(toolTipTextStyle, subMarkupTextList.join(''), noHeader ? topMarginForOuterGap : gaps.html);
    if (noHeader) return subMarkupText;
    var displayableHeader = (0, $c84c9521536c601a$export$3cd8db88714decfc)(fragment.header, 'ordinal', ctx.useUTC);
    var nameStyle = $d5ab84c08d6657ec$var$getTooltipTextStyle(toolTipTextStyle, ctx.renderMode).nameStyle;
    var tooltipLineHeight = $d5ab84c08d6657ec$var$getTooltipLineHeight(toolTipTextStyle);
    if (ctx.renderMode === 'richText') return $d5ab84c08d6657ec$var$wrapInlineNameRichText(ctx, displayableHeader, nameStyle) + gaps.richText + subMarkupText;
    else return $d5ab84c08d6657ec$var$wrapBlockHTML(toolTipTextStyle, "<div style=\"" + nameStyle + ";" + tooltipLineHeight + ";\">" + (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(displayableHeader) + '</div>' + subMarkupText, topMarginForOuterGap);
}
function $d5ab84c08d6657ec$var$buildNameValue(ctx, fragment, topMarginForOuterGap, toolTipTextStyle) {
    var renderMode = ctx.renderMode;
    var noName = fragment.noName;
    var noValue = fragment.noValue;
    var noMarker = !fragment.markerType;
    var name = fragment.name;
    var useUTC = ctx.useUTC;
    var valueFormatter = fragment.valueFormatter || ctx.valueFormatter || function(value) {
        value = (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(value) ? value : [
            value
        ];
        return (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(value, function(val, idx) {
            return (0, $c84c9521536c601a$export$3cd8db88714decfc)(val, (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(valueTypeOption) ? valueTypeOption[idx] : valueTypeOption, useUTC);
        });
    };
    if (noName && noValue) return;
    var markerStr = noMarker ? '' : ctx.markupStyleCreator.makeTooltipMarker(fragment.markerType, fragment.markerColor || '#333', renderMode);
    var readableName = noName ? '' : (0, $c84c9521536c601a$export$3cd8db88714decfc)(name, 'ordinal', useUTC);
    var valueTypeOption = fragment.valueType;
    var readableValueList = noValue ? [] : valueFormatter(fragment.value, fragment.dataIndex);
    var valueAlignRight = !noMarker || !noName;
    // It little weird if only value next to marker but far from marker.
    var valueCloseToMarker = !noMarker && noName;
    var _a = $d5ab84c08d6657ec$var$getTooltipTextStyle(toolTipTextStyle, renderMode), nameStyle = _a.nameStyle, valueStyle = _a.valueStyle;
    return renderMode === 'richText' ? (noMarker ? '' : markerStr) + (noName ? '' : $d5ab84c08d6657ec$var$wrapInlineNameRichText(ctx, readableName, nameStyle)) + (noValue ? '' : $d5ab84c08d6657ec$var$wrapInlineValueRichText(ctx, readableValueList, valueAlignRight, valueCloseToMarker, valueStyle)) : $d5ab84c08d6657ec$var$wrapBlockHTML(toolTipTextStyle, (noMarker ? '' : markerStr) + (noName ? '' : $d5ab84c08d6657ec$var$wrapInlineNameHTML(readableName, !noMarker, nameStyle)) + (noValue ? '' : $d5ab84c08d6657ec$var$wrapInlineValueHTML(readableValueList, valueAlignRight, valueCloseToMarker, valueStyle)), topMarginForOuterGap);
}
function $d5ab84c08d6657ec$export$6969ffb02c1cb49a(fragment, markupStyleCreator, renderMode, orderMode, useUTC, toolTipTextStyle) {
    if (!fragment) return;
    var builder = $d5ab84c08d6657ec$var$getBuilder(fragment);
    var ctx = {
        useUTC: useUTC,
        renderMode: renderMode,
        orderMode: orderMode,
        markupStyleCreator: markupStyleCreator,
        valueFormatter: fragment.valueFormatter
    };
    return builder(ctx, fragment, 0, toolTipTextStyle);
}
function $d5ab84c08d6657ec$var$getGap(gapLevel) {
    return {
        html: $d5ab84c08d6657ec$var$HTML_GAPS[gapLevel],
        richText: $d5ab84c08d6657ec$var$RICH_TEXT_GAPS[gapLevel]
    };
}
function $d5ab84c08d6657ec$var$wrapBlockHTML(textStyle, encodedContent, topGap) {
    var clearfix = '<div style="clear:both"></div>';
    var marginCSS = "margin: " + topGap + "px 0 0";
    var tooltipLineHeight = $d5ab84c08d6657ec$var$getTooltipLineHeight(textStyle);
    return "<div style=\"" + marginCSS + ";" + tooltipLineHeight + ";\">" + encodedContent + clearfix + '</div>';
}
function $d5ab84c08d6657ec$var$wrapInlineNameHTML(name, leftHasMarker, style) {
    var marginCss = leftHasMarker ? 'margin-left:2px' : '';
    return "<span style=\"" + style + ";" + marginCss + "\">" + (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(name) + '</span>';
}
function $d5ab84c08d6657ec$var$wrapInlineValueHTML(valueList, alignRight, valueCloseToMarker, style) {
    // Do not too close to marker, considering there are multiple values separated by spaces.
    var paddingStr = valueCloseToMarker ? '10px' : '20px';
    var alignCSS = alignRight ? "float:right;margin-left:" + paddingStr : '';
    valueList = (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(valueList) ? valueList : [
        valueList
    ];
    return "<span style=\"" + alignCSS + ";" + style + "\">" + (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(valueList, function(value) {
        return (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(value);
    }).join('&nbsp;&nbsp;') + '</span>';
}
function $d5ab84c08d6657ec$var$wrapInlineNameRichText(ctx, name, style) {
    return ctx.markupStyleCreator.wrapRichTextStyle(name, style);
}
function $d5ab84c08d6657ec$var$wrapInlineValueRichText(ctx, values, alignRight, valueCloseToMarker, style) {
    var styles = [
        style
    ];
    var paddingLeft = valueCloseToMarker ? 10 : 20;
    alignRight && styles.push({
        padding: [
            0,
            0,
            0,
            paddingLeft
        ],
        align: 'right'
    });
    // Value has commas inside, so use '  ' as delimiter for multiple values.
    return ctx.markupStyleCreator.wrapRichTextStyle((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(values) ? values.join('  ') : values, styles);
}
function $d5ab84c08d6657ec$export$ea15628039c0fa93(series, dataIndex) {
    var style = series.getData().getItemVisual(dataIndex, 'style');
    var color = style[series.visualDrawType];
    return (0, $c84c9521536c601a$export$cda04d03233e5555)(color);
}
function $d5ab84c08d6657ec$export$3048212c802df496(model, renderMode) {
    var padding = model.get('padding');
    return padding != null ? padding : renderMode === 'richText' ? [
        8,
        10
    ] : 10;
}
/**
 * The major feature is generate styles for `renderMode: 'richText'`.
 * But it also serves `renderMode: 'html'` to provide
 * "renderMode-independent" API.
 */ var $d5ab84c08d6657ec$export$2fba3afbcdcf3e18 = /** @class */ function() {
    function TooltipMarkupStyleCreator() {
        this.richTextStyles = {};
        // Notice that "generate a style name" usually happens repeatedly when mouse is moving and
        // a tooltip is displayed. So we put the `_nextStyleNameId` as a member of each creator
        // rather than static shared by all creators (which will cause it increase to fast).
        this._nextStyleNameId = (0, $cfc1f3b422a3185f$export$474d2ec9aa44a22)();
    }
    TooltipMarkupStyleCreator.prototype._generateStyleName = function() {
        return '__EC_aUTo_' + this._nextStyleNameId++;
    };
    TooltipMarkupStyleCreator.prototype.makeTooltipMarker = function(markerType, colorStr, renderMode) {
        var markerId = renderMode === 'richText' ? this._generateStyleName() : null;
        var marker = (0, $c84c9521536c601a$export$1987a3dbdf3c45ca)({
            color: colorStr,
            type: markerType,
            renderMode: renderMode,
            markerId: markerId
        });
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(marker)) return marker;
        else {
            this.richTextStyles[markerId] = marker.style;
            return marker.content;
        }
    };
    /**
   * @usage
   * ```ts
   * const styledText = markupStyleCreator.wrapRichTextStyle([
   *     // The styles will be auto merged.
   *     {
   *         fontSize: 12,
   *         color: 'blue'
   *     },
   *     {
   *         padding: 20
   *     }
   * ]);
   * ```
   */ TooltipMarkupStyleCreator.prototype.wrapRichTextStyle = function(text, styles) {
        var finalStl = {};
        if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(styles)) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(styles, function(stl) {
            return (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(finalStl, stl);
        });
        else (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(finalStl, styles);
        var styleName = this._generateStyleName();
        this.richTextStyles[styleName] = finalStl;
        return "{" + styleName + "|" + text + "}";
    };
    return TooltipMarkupStyleCreator;
}();




function $b0d4c63a14430ca1$export$3a110b9fb5c88b34(opt) {
    var series = opt.series;
    var dataIndex = opt.dataIndex;
    var multipleSeries = opt.multipleSeries;
    var data = series.getData();
    var tooltipDims = data.mapDimensionsAll('defaultedTooltip');
    var tooltipDimLen = tooltipDims.length;
    var value = series.getRawValue(dataIndex);
    var isValueArr = (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(value);
    var markerColor = (0, $d5ab84c08d6657ec$export$ea15628039c0fa93)(series, dataIndex);
    // Complicated rule for pretty tooltip.
    var inlineValue;
    var inlineValueType;
    var subBlocks;
    var sortParam;
    if (tooltipDimLen > 1 || isValueArr && !tooltipDimLen) {
        var formatArrResult = $b0d4c63a14430ca1$var$formatTooltipArrayValue(value, series, dataIndex, tooltipDims, markerColor);
        inlineValue = formatArrResult.inlineValues;
        inlineValueType = formatArrResult.inlineValueTypes;
        subBlocks = formatArrResult.blocks;
        // Only support tooltip sort by the first inline value. It's enough in most cases.
        sortParam = formatArrResult.inlineValues[0];
    } else if (tooltipDimLen) {
        var dimInfo = data.getDimensionInfo(tooltipDims[0]);
        sortParam = inlineValue = (0, $8ffb0d67e9446edb$export$cde9373da9aad801)(data, dataIndex, tooltipDims[0]);
        inlineValueType = dimInfo.type;
    } else sortParam = inlineValue = isValueArr ? value[0] : value;
    // Do not show generated series name. It might not be readable.
    var seriesNameSpecified = (0, $76d619f648247e6d$export$beae19a2652b3368)(series);
    var seriesName = seriesNameSpecified && series.name || '';
    var itemName = data.getName(dataIndex);
    var inlineName = multipleSeries ? seriesName : itemName;
    return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)('section', {
        header: seriesName,
        // When series name is not specified, do not show a header line with only '-'.
        // This case always happens in tooltip.trigger: 'item'.
        noHeader: multipleSeries || !seriesNameSpecified,
        sortParam: sortParam,
        blocks: [
            (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)('nameValue', {
                markerType: 'item',
                markerColor: markerColor,
                // Do not mix display seriesName and itemName in one tooltip,
                // which might confuses users.
                name: inlineName,
                // name dimension might be auto assigned, where the name might
                // be not readable. So we check trim here.
                noName: !(0, $7a1bd9c2710fea0d$export$87c2784dc9fc4ab)(inlineName),
                value: inlineValue,
                valueType: inlineValueType,
                dataIndex: dataIndex
            })
        ].concat(subBlocks || [])
    });
}
function $b0d4c63a14430ca1$var$formatTooltipArrayValue(value, series, dataIndex, tooltipDims, colorStr) {
    // check: category-no-encode-has-axis-data in dataset.html
    var data = series.getData();
    var isValueMultipleLine = (0, $7a1bd9c2710fea0d$export$533b26079ad0b4b)(value, function(isValueMultipleLine, val, idx) {
        var dimItem = data.getDimensionInfo(idx);
        return isValueMultipleLine = isValueMultipleLine || dimItem && dimItem.tooltip !== false && dimItem.displayName != null;
    }, false);
    var inlineValues = [];
    var inlineValueTypes = [];
    var blocks = [];
    tooltipDims.length ? (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(tooltipDims, function(dim) {
        setEachItem((0, $8ffb0d67e9446edb$export$cde9373da9aad801)(data, dataIndex, dim), dim);
    }) : (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(value, setEachItem);
    function setEachItem(val, dim) {
        var dimInfo = data.getDimensionInfo(dim);
        // If `dimInfo.tooltip` is not set, show tooltip.
        if (!dimInfo || dimInfo.otherDims.tooltip === false) return;
        if (isValueMultipleLine) blocks.push((0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)('nameValue', {
            markerType: 'subItem',
            markerColor: colorStr,
            name: dimInfo.displayName,
            value: val,
            valueType: dimInfo.type
        }));
        else {
            inlineValues.push(val);
            inlineValueTypes.push(dimInfo.type);
        }
    }
    return {
        inlineValues: inlineValues,
        inlineValueTypes: inlineValueTypes,
        blocks: blocks
    };
}


var $7c10febb2cdef0d8$var$inner = $76d619f648247e6d$export$64df9f8d92ae083f();
function $7c10febb2cdef0d8$var$getSelectionKey(data, dataIndex) {
    return data.getName(dataIndex) || data.getId(dataIndex);
}
var $7c10febb2cdef0d8$export$e960441116ae2799 = '__universalTransitionEnabled';
var $7c10febb2cdef0d8$var$SeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SeriesModel, _super);
    function SeriesModel() {
        // [Caution]: Because this class or desecendants can be used as `XXX.extend(subProto)`,
        // the class members must not be initialized in constructor or declaration place.
        // Otherwise there is bad case:
        //   class A {xxx = 1;}
        //   enableClassExtend(A);
        //   class B extends A {}
        //   var C = B.extend({xxx: 5});
        //   var c = new C();
        //   console.log(c.xxx); // expect 5 but always 1.
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // ---------------------------------------
        // Props about data selection
        // ---------------------------------------
        _this._selectedDataIndicesMap = {};
        return _this;
    }
    SeriesModel.prototype.init = function(option, parentModel, ecModel) {
        this.seriesIndex = this.componentIndex;
        this.dataTask = (0, $4d16404c851dcec6$export$f7292ab7796be73c)({
            count: $7c10febb2cdef0d8$var$dataTaskCount,
            reset: $7c10febb2cdef0d8$var$dataTaskReset
        });
        this.dataTask.context = {
            model: this
        };
        this.mergeDefaultAndTheme(option, ecModel);
        var sourceManager = $7c10febb2cdef0d8$var$inner(this).sourceManager = new (0, $1c87d176de397e7e$export$af4db9ec7e200ea2)(this);
        sourceManager.prepareSource();
        var data = this.getInitialData(option, ecModel);
        $7c10febb2cdef0d8$var$wrapData(data, this);
        this.dataTask.context.data = data;
        $7c10febb2cdef0d8$var$inner(this).dataBeforeProcessed = data;
        // If we reverse the order (make data firstly, and then make
        // dataBeforeProcessed by cloneShallow), cloneShallow will
        // cause data.graph.data !== data when using
        // module:echarts/data/Graph or module:echarts/data/Tree.
        // See module:echarts/data/helper/linkSeriesData
        // Theoretically, it is unreasonable to call `seriesModel.getData()` in the model
        // init or merge stage, because the data can be restored. So we do not `restoreData`
        // and `setData` here, which forbids calling `seriesModel.getData()` in this stage.
        // Call `seriesModel.getRawData()` instead.
        // this.restoreData();
        $7c10febb2cdef0d8$var$autoSeriesName(this);
        this._initSelectedMapFromData(data);
    };
    /**
   * Util for merge default and theme to option
   */ SeriesModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
        var layoutMode = (0, $93b9bc7f22ac7369$export$3968a28a7cbd6063)(this);
        var inputPositionParams = layoutMode ? (0, $93b9bc7f22ac7369$export$4b0d20af19c9875e)(option) : {};
        // Backward compat: using subType on theme.
        // But if name duplicate between series subType
        // (for example: parallel) add component mainType,
        // add suffix 'Series'.
        var themeSubType = this.subType;
        if ((0, $116d65051f61bdfe$export$2e2bcd8739ae039).hasClass(themeSubType)) themeSubType += 'Series';
        $7a1bd9c2710fea0d$export$4950aa0f605343fb(option, ecModel.getTheme().get(this.subType));
        $7a1bd9c2710fea0d$export$4950aa0f605343fb(option, this.getDefaultOption());
        // Default label emphasis `show`
        $76d619f648247e6d$export$abdcc6a26372f94b(option, 'label', [
            'show'
        ]);
        this.fillDataTextStyle(option.data);
        if (layoutMode) (0, $93b9bc7f22ac7369$export$1754cb91f16ca028)(option, inputPositionParams, layoutMode);
    };
    SeriesModel.prototype.mergeOption = function(newSeriesOption, ecModel) {
        // this.settingTask.dirty();
        newSeriesOption = $7a1bd9c2710fea0d$export$4950aa0f605343fb(this.option, newSeriesOption, true);
        this.fillDataTextStyle(newSeriesOption.data);
        var layoutMode = (0, $93b9bc7f22ac7369$export$3968a28a7cbd6063)(this);
        if (layoutMode) (0, $93b9bc7f22ac7369$export$1754cb91f16ca028)(this.option, newSeriesOption, layoutMode);
        var sourceManager = $7c10febb2cdef0d8$var$inner(this).sourceManager;
        sourceManager.dirty();
        sourceManager.prepareSource();
        var data = this.getInitialData(newSeriesOption, ecModel);
        $7c10febb2cdef0d8$var$wrapData(data, this);
        this.dataTask.dirty();
        this.dataTask.context.data = data;
        $7c10febb2cdef0d8$var$inner(this).dataBeforeProcessed = data;
        $7c10febb2cdef0d8$var$autoSeriesName(this);
        this._initSelectedMapFromData(data);
    };
    SeriesModel.prototype.fillDataTextStyle = function(data) {
        // Default data label emphasis `show`
        // FIXME Tree structure data ?
        // FIXME Performance ?
        if (data && !$7a1bd9c2710fea0d$export$b119cc7e1840e59c(data)) {
            var props = [
                'show'
            ];
            for(var i = 0; i < data.length; i++)if (data[i] && data[i].label) $76d619f648247e6d$export$abdcc6a26372f94b(data[i], 'label', props);
        }
    };
    /**
   * Init a data structure from data related option in series
   * Must be overridden.
   */ SeriesModel.prototype.getInitialData = function(option, ecModel) {
        return;
    };
    /**
   * Append data to list
   */ SeriesModel.prototype.appendData = function(params) {
        // FIXME ???
        // (1) If data from dataset, forbidden append.
        // (2) support append data of dataset.
        var data = this.getRawData();
        data.appendData(params.data);
    };
    /**
   * Consider some method like `filter`, `map` need make new data,
   * We should make sure that `seriesModel.getData()` get correct
   * data in the stream procedure. So we fetch data from upstream
   * each time `task.perform` called.
   */ SeriesModel.prototype.getData = function(dataType) {
        var task = $7c10febb2cdef0d8$var$getCurrentTask(this);
        if (task) {
            var data = task.context.data;
            return dataType == null || !data.getLinkedData ? data : data.getLinkedData(dataType);
        } else // When series is not alive (that may happen when click toolbox
        // restore or setOption with not merge mode), series data may
        // be still need to judge animation or something when graphic
        // elements want to know whether fade out.
        return $7c10febb2cdef0d8$var$inner(this).data;
    };
    SeriesModel.prototype.getAllData = function() {
        var mainData = this.getData();
        return mainData && mainData.getLinkedDataAll ? mainData.getLinkedDataAll() : [
            {
                data: mainData
            }
        ];
    };
    SeriesModel.prototype.setData = function(data) {
        var task = $7c10febb2cdef0d8$var$getCurrentTask(this);
        if (task) {
            var context = task.context;
            // Consider case: filter, data sample.
            // FIXME:TS never used, so comment it
            // if (context.data !== data && task.modifyOutputEnd) {
            //     task.setOutputEnd(data.count());
            // }
            context.outputData = data;
            // Caution: setData should update context.data,
            // Because getData may be called multiply in a
            // single stage and expect to get the data just
            // set. (For example, AxisProxy, x y both call
            // getData and setDate sequentially).
            // So the context.data should be fetched from
            // upstream each time when a stage starts to be
            // performed.
            if (task !== this.dataTask) context.data = data;
        }
        $7c10febb2cdef0d8$var$inner(this).data = data;
    };
    SeriesModel.prototype.getEncode = function() {
        var encode = this.get('encode', true);
        if (encode) return $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4(encode);
    };
    SeriesModel.prototype.getSourceManager = function() {
        return $7c10febb2cdef0d8$var$inner(this).sourceManager;
    };
    SeriesModel.prototype.getSource = function() {
        return this.getSourceManager().getSource();
    };
    /**
   * Get data before processed
   */ SeriesModel.prototype.getRawData = function() {
        return $7c10febb2cdef0d8$var$inner(this).dataBeforeProcessed;
    };
    SeriesModel.prototype.getColorBy = function() {
        var colorBy = this.get('colorBy');
        return colorBy || 'series';
    };
    SeriesModel.prototype.isColorBySeries = function() {
        return this.getColorBy() === 'series';
    };
    /**
   * Get base axis if has coordinate system and has axis.
   * By default use coordSys.getBaseAxis();
   * Can be overridden for some chart.
   * @return {type} description
   */ SeriesModel.prototype.getBaseAxis = function() {
        var coordSys = this.coordinateSystem;
        // @ts-ignore
        return coordSys && coordSys.getBaseAxis && coordSys.getBaseAxis();
    };
    /**
   * Default tooltip formatter
   *
   * @param dataIndex
   * @param multipleSeries
   * @param dataType
   * @param renderMode valid values: 'html'(by default) and 'richText'.
   *        'html' is used for rendering tooltip in extra DOM form, and the result
   *        string is used as DOM HTML content.
   *        'richText' is used for rendering tooltip in rich text form, for those where
   *        DOM operation is not supported.
   * @return formatted tooltip with `html` and `markers`
   *        Notice: The override method can also return string
   */ SeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        return (0, $b0d4c63a14430ca1$export$3a110b9fb5c88b34)({
            series: this,
            dataIndex: dataIndex,
            multipleSeries: multipleSeries
        });
    };
    SeriesModel.prototype.isAnimationEnabled = function() {
        var ecModel = this.ecModel;
        // Disable animation if using echarts in node but not give ssr flag.
        // In ssr mode, renderToString will generate svg with css animation.
        if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).node && !(ecModel && ecModel.ssr)) return false;
        var animationEnabled = this.getShallow('animation');
        if (animationEnabled) {
            if (this.getData().count() > this.getShallow('animationThreshold')) animationEnabled = false;
        }
        return !!animationEnabled;
    };
    SeriesModel.prototype.restoreData = function() {
        this.dataTask.dirty();
    };
    SeriesModel.prototype.getColorFromPalette = function(name, scope, requestColorNum) {
        var ecModel = this.ecModel;
        // PENDING
        var color = (0, $e7fbd47751ca3c28$export$55a3c39e852b90f4).prototype.getColorFromPalette.call(this, name, scope, requestColorNum);
        if (!color) color = ecModel.getColorFromPalette(name, scope, requestColorNum);
        return color;
    };
    /**
   * Use `data.mapDimensionsAll(coordDim)` instead.
   * @deprecated
   */ SeriesModel.prototype.coordDimToDataDim = function(coordDim) {
        return this.getRawData().mapDimensionsAll(coordDim);
    };
    /**
   * Get progressive rendering count each step
   */ SeriesModel.prototype.getProgressive = function() {
        return this.get('progressive');
    };
    /**
   * Get progressive rendering count each step
   */ SeriesModel.prototype.getProgressiveThreshold = function() {
        return this.get('progressiveThreshold');
    };
    // PENGING If selectedMode is null ?
    SeriesModel.prototype.select = function(innerDataIndices, dataType) {
        this._innerSelect(this.getData(dataType), innerDataIndices);
    };
    SeriesModel.prototype.unselect = function(innerDataIndices, dataType) {
        var selectedMap = this.option.selectedMap;
        if (!selectedMap) return;
        var selectedMode = this.option.selectedMode;
        var data = this.getData(dataType);
        if (selectedMode === 'series' || selectedMap === 'all') {
            this.option.selectedMap = {};
            this._selectedDataIndicesMap = {};
            return;
        }
        for(var i = 0; i < innerDataIndices.length; i++){
            var dataIndex = innerDataIndices[i];
            var nameOrId = $7c10febb2cdef0d8$var$getSelectionKey(data, dataIndex);
            selectedMap[nameOrId] = false;
            this._selectedDataIndicesMap[nameOrId] = -1;
        }
    };
    SeriesModel.prototype.toggleSelect = function(innerDataIndices, dataType) {
        var tmpArr = [];
        for(var i = 0; i < innerDataIndices.length; i++){
            tmpArr[0] = innerDataIndices[i];
            this.isSelected(innerDataIndices[i], dataType) ? this.unselect(tmpArr, dataType) : this.select(tmpArr, dataType);
        }
    };
    SeriesModel.prototype.getSelectedDataIndices = function() {
        if (this.option.selectedMap === 'all') return [].slice.call(this.getData().getIndices());
        var selectedDataIndicesMap = this._selectedDataIndicesMap;
        var nameOrIds = $7a1bd9c2710fea0d$export$ed97f33186d4b816(selectedDataIndicesMap);
        var dataIndices = [];
        for(var i = 0; i < nameOrIds.length; i++){
            var dataIndex = selectedDataIndicesMap[nameOrIds[i]];
            if (dataIndex >= 0) dataIndices.push(dataIndex);
        }
        return dataIndices;
    };
    SeriesModel.prototype.isSelected = function(dataIndex, dataType) {
        var selectedMap = this.option.selectedMap;
        if (!selectedMap) return false;
        var data = this.getData(dataType);
        return (selectedMap === 'all' || selectedMap[$7c10febb2cdef0d8$var$getSelectionKey(data, dataIndex)]) && !data.getItemModel(dataIndex).get([
            'select',
            'disabled'
        ]);
    };
    SeriesModel.prototype.isUniversalTransitionEnabled = function() {
        if (this[$7c10febb2cdef0d8$export$e960441116ae2799]) return true;
        var universalTransitionOpt = this.option.universalTransition;
        // Quick reject
        if (!universalTransitionOpt) return false;
        if (universalTransitionOpt === true) return true;
        // Can be simply 'universalTransition: true'
        return universalTransitionOpt && universalTransitionOpt.enabled;
    };
    SeriesModel.prototype._innerSelect = function(data, innerDataIndices) {
        var _a, _b;
        var option = this.option;
        var selectedMode = option.selectedMode;
        var len = innerDataIndices.length;
        if (!selectedMode || !len) return;
        if (selectedMode === 'series') option.selectedMap = 'all';
        else if (selectedMode === 'multiple') {
            if (!$7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(option.selectedMap)) option.selectedMap = {};
            var selectedMap = option.selectedMap;
            for(var i = 0; i < len; i++){
                var dataIndex = innerDataIndices[i];
                // TODO different types of data share same object.
                var nameOrId = $7c10febb2cdef0d8$var$getSelectionKey(data, dataIndex);
                selectedMap[nameOrId] = true;
                this._selectedDataIndicesMap[nameOrId] = data.getRawIndex(dataIndex);
            }
        } else if (selectedMode === 'single' || selectedMode === true) {
            var lastDataIndex = innerDataIndices[len - 1];
            var nameOrId = $7c10febb2cdef0d8$var$getSelectionKey(data, lastDataIndex);
            option.selectedMap = (_a = {}, _a[nameOrId] = true, _a);
            this._selectedDataIndicesMap = (_b = {}, _b[nameOrId] = data.getRawIndex(lastDataIndex), _b);
        }
    };
    SeriesModel.prototype._initSelectedMapFromData = function(data) {
        // Ignore select info in data if selectedMap exists.
        // NOTE It's only for legacy usage. edge data is not supported.
        if (this.option.selectedMap) return;
        var dataIndices = [];
        if (data.hasItemOption) data.each(function(idx) {
            var rawItem = data.getRawDataItem(idx);
            if (rawItem && rawItem.selected) dataIndices.push(idx);
        });
        if (dataIndices.length > 0) this._innerSelect(data, dataIndices);
    };
    // /**
    //  * @see {module:echarts/stream/Scheduler}
    //  */
    // abstract pipeTask: null
    SeriesModel.registerClass = function(clz) {
        return (0, $116d65051f61bdfe$export$2e2bcd8739ae039).registerClass(clz);
    };
    SeriesModel.protoInitialize = function() {
        var proto = SeriesModel.prototype;
        proto.type = 'series.__base__';
        proto.seriesIndex = 0;
        proto.ignoreStyleOnData = false;
        proto.hasSymbolVisual = false;
        proto.defaultSymbol = 'circle';
        // Make sure the values can be accessed!
        proto.visualStyleAccessPath = 'itemStyle';
        proto.visualDrawType = 'fill';
    }();
    return SeriesModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
$7a1bd9c2710fea0d$export$e36fc9d62a853069($7c10febb2cdef0d8$var$SeriesModel, (0, $655dd6075cc63601$export$f23396ae04ea95a7));
$7a1bd9c2710fea0d$export$e36fc9d62a853069($7c10febb2cdef0d8$var$SeriesModel, (0, $e7fbd47751ca3c28$export$55a3c39e852b90f4));
(0, $cd5f95cf03b4e3e7$export$c9c2d87774f1275d)($7c10febb2cdef0d8$var$SeriesModel, (0, $116d65051f61bdfe$export$2e2bcd8739ae039));
/**
 * MUST be called after `prepareSource` called
 * Here we need to make auto series, especially for auto legend. But we
 * do not modify series.name in option to avoid side effects.
 */ function $7c10febb2cdef0d8$var$autoSeriesName(seriesModel) {
    // User specified name has higher priority, otherwise it may cause
    // series can not be queried unexpectedly.
    var name = seriesModel.name;
    if (!$76d619f648247e6d$export$beae19a2652b3368(seriesModel)) seriesModel.name = $7c10febb2cdef0d8$var$getSeriesAutoName(seriesModel) || name;
}
function $7c10febb2cdef0d8$var$getSeriesAutoName(seriesModel) {
    var data = seriesModel.getRawData();
    var dataDims = data.mapDimensionsAll('seriesName');
    var nameArr = [];
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(dataDims, function(dataDim) {
        var dimInfo = data.getDimensionInfo(dataDim);
        dimInfo.displayName && nameArr.push(dimInfo.displayName);
    });
    return nameArr.join(' ');
}
function $7c10febb2cdef0d8$var$dataTaskCount(context) {
    return context.model.getRawData().count();
}
function $7c10febb2cdef0d8$var$dataTaskReset(context) {
    var seriesModel = context.model;
    seriesModel.setData(seriesModel.getRawData().cloneShallow());
    return $7c10febb2cdef0d8$var$dataTaskProgress;
}
function $7c10febb2cdef0d8$var$dataTaskProgress(param, context) {
    // Avoid repeat cloneShallow when data just created in reset.
    if (context.outputData && param.end > context.outputData.count()) context.model.getRawData().cloneShallow(context.outputData);
}
// TODO refactor
function $7c10febb2cdef0d8$var$wrapData(data, seriesModel) {
    $7a1bd9c2710fea0d$export$79b2f7037acddd43($7a1bd9c2710fea0d$export$4fd8af2c48c43416(data.CHANGABLE_METHODS, data.DOWNSAMPLE_METHODS), function(methodName) {
        data.wrapMethod(methodName, $7a1bd9c2710fea0d$export$c3095a23b368d1f2($7c10febb2cdef0d8$var$onDataChange, seriesModel));
    });
}
function $7c10febb2cdef0d8$var$onDataChange(seriesModel, newList) {
    var task = $7c10febb2cdef0d8$var$getCurrentTask(seriesModel);
    if (task) // Consider case: filter, selectRange
    task.setOutputEnd((newList || this).count());
    return newList;
}
function $7c10febb2cdef0d8$var$getCurrentTask(seriesModel) {
    var scheduler = (seriesModel.ecModel || {}).scheduler;
    var pipeline = scheduler && scheduler.getPipeline(seriesModel.uid);
    if (pipeline) {
        // When pipline finished, the currrentTask keep the last
        // task (renderTask).
        var task = pipeline.currentTask;
        if (task) {
            var agentStubMap = task.agentStubMap;
            if (agentStubMap) task = agentStubMap.get(seriesModel.uid);
        }
        return task;
    }
}
var $7c10febb2cdef0d8$export$2e2bcd8739ae039 = $7c10febb2cdef0d8$var$SeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $737c88aa0711f65a$var$ComponentView = /** @class */ function() {
    function ComponentView() {
        this.group = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)();
        this.uid = $5370df662b2caf37$export$6d2b3473b0986646('viewComponent');
    }
    ComponentView.prototype.init = function(ecModel, api) {};
    ComponentView.prototype.render = function(model, ecModel, api, payload) {};
    ComponentView.prototype.dispose = function(ecModel, api) {};
    ComponentView.prototype.updateView = function(model, ecModel, api, payload) {
    // Do nothing;
    };
    ComponentView.prototype.updateLayout = function(model, ecModel, api, payload) {
    // Do nothing;
    };
    ComponentView.prototype.updateVisual = function(model, ecModel, api, payload) {
    // Do nothing;
    };
    /**
   * Hook for toggle blur target series.
   * Can be used in marker for blur or leave blur the markers
   */ ComponentView.prototype.toggleBlurSeries = function(seriesModels, isBlur, ecModel) {
    // Do nothing;
    };
    /**
   * Traverse the new rendered elements.
   *
   * It will traverse the new added element in progressive rendering.
   * And traverse all in normal rendering.
   */ ComponentView.prototype.eachRendered = function(cb) {
        var group = this.group;
        if (group) group.traverse(cb);
    };
    return ComponentView;
}();
$cd5f95cf03b4e3e7$export$cd4c3a4dca301c70($737c88aa0711f65a$var$ComponentView);
$cd5f95cf03b4e3e7$export$241315e45585454d($737c88aa0711f65a$var$ComponentView);
var $737c88aa0711f65a$export$2e2bcd8739ae039 = $737c88aa0711f65a$var$ComponentView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $cd70075c57b35175$export$2e2bcd8739ae039() {
    var inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
    return function(seriesModel) {
        var fields = inner(seriesModel);
        var pipelineContext = seriesModel.pipelineContext;
        var originalLarge = !!fields.large;
        var originalProgressive = !!fields.progressiveRender;
        // FIXME: if the planner works on a filtered series, `pipelineContext` does not
        // exists. See #11611 . Probably we need to modify this structure, see the comment
        // on `performRawSeries` in `Schedular.js`.
        var large = fields.large = !!(pipelineContext && pipelineContext.large);
        var progressive = fields.progressiveRender = !!(pipelineContext && pipelineContext.progressiveRender);
        return !!(originalLarge !== large || originalProgressive !== progressive) && 'reset';
    };
}




var $0dc5061053e23cd3$var$inner = $76d619f648247e6d$export$64df9f8d92ae083f();
var $0dc5061053e23cd3$var$renderPlanner = (0, $cd70075c57b35175$export$2e2bcd8739ae039)();
var $0dc5061053e23cd3$var$ChartView = /** @class */ function() {
    function ChartView() {
        this.group = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)();
        this.uid = $5370df662b2caf37$export$6d2b3473b0986646('viewChart');
        this.renderTask = (0, $4d16404c851dcec6$export$f7292ab7796be73c)({
            plan: $0dc5061053e23cd3$var$renderTaskPlan,
            reset: $0dc5061053e23cd3$var$renderTaskReset
        });
        this.renderTask.context = {
            view: this
        };
    }
    ChartView.prototype.init = function(ecModel, api) {};
    ChartView.prototype.render = function(seriesModel, ecModel, api, payload) {};
    /**
   * Highlight series or specified data item.
   */ ChartView.prototype.highlight = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData(payload && payload.dataType);
        if (!data) return;
        $0dc5061053e23cd3$var$toggleHighlight(data, payload, 'emphasis');
    };
    /**
   * Downplay series or specified data item.
   */ ChartView.prototype.downplay = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData(payload && payload.dataType);
        if (!data) return;
        $0dc5061053e23cd3$var$toggleHighlight(data, payload, 'normal');
    };
    /**
   * Remove self.
   */ ChartView.prototype.remove = function(ecModel, api) {
        this.group.removeAll();
    };
    /**
   * Dispose self.
   */ ChartView.prototype.dispose = function(ecModel, api) {};
    ChartView.prototype.updateView = function(seriesModel, ecModel, api, payload) {
        this.render(seriesModel, ecModel, api, payload);
    };
    // FIXME never used?
    ChartView.prototype.updateLayout = function(seriesModel, ecModel, api, payload) {
        this.render(seriesModel, ecModel, api, payload);
    };
    // FIXME never used?
    ChartView.prototype.updateVisual = function(seriesModel, ecModel, api, payload) {
        this.render(seriesModel, ecModel, api, payload);
    };
    /**
   * Traverse the new rendered elements.
   *
   * It will traverse the new added element in progressive rendering.
   * And traverse all in normal rendering.
   */ ChartView.prototype.eachRendered = function(cb) {
        (0, $5b455ae6f843ac47$export$3e564442729bf048)(this.group, cb);
    };
    ChartView.markUpdateMethod = function(payload, methodName) {
        $0dc5061053e23cd3$var$inner(payload).updateMethod = methodName;
    };
    ChartView.protoInitialize = function() {
        var proto = ChartView.prototype;
        proto.type = 'chart';
    }();
    return ChartView;
}();
/**
 * Set state of single element
 */ function $0dc5061053e23cd3$var$elSetState(el, state, highlightDigit) {
    if (el && (0, $2bf82c0980125b62$export$77d1445f699c58b5)(el)) (state === 'emphasis' ? (0, $2bf82c0980125b62$export$b2d02638cc34c042) : (0, $2bf82c0980125b62$export$11be6f716239ac55))(el, highlightDigit);
}
function $0dc5061053e23cd3$var$toggleHighlight(data, payload, state) {
    var dataIndex = $76d619f648247e6d$export$42b26cae8b8d10(data, payload);
    var highlightDigit = payload && payload.highlightKey != null ? (0, $2bf82c0980125b62$export$824af40eb714530d)(payload.highlightKey) : null;
    if (dataIndex != null) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($76d619f648247e6d$export$4f07b212a02c8051(dataIndex), function(dataIdx) {
        $0dc5061053e23cd3$var$elSetState(data.getItemGraphicEl(dataIdx), state, highlightDigit);
    });
    else data.eachItemGraphicEl(function(el) {
        $0dc5061053e23cd3$var$elSetState(el, state, highlightDigit);
    });
}
$cd5f95cf03b4e3e7$export$cd4c3a4dca301c70($0dc5061053e23cd3$var$ChartView, [
    'dispose'
]);
$cd5f95cf03b4e3e7$export$241315e45585454d($0dc5061053e23cd3$var$ChartView);
function $0dc5061053e23cd3$var$renderTaskPlan(context) {
    return $0dc5061053e23cd3$var$renderPlanner(context.model);
}
function $0dc5061053e23cd3$var$renderTaskReset(context) {
    var seriesModel = context.model;
    var ecModel = context.ecModel;
    var api = context.api;
    var payload = context.payload;
    // FIXME: remove updateView updateVisual
    var progressiveRender = seriesModel.pipelineContext.progressiveRender;
    var view = context.view;
    var updateMethod = payload && $0dc5061053e23cd3$var$inner(payload).updateMethod;
    var methodName = progressiveRender ? 'incrementalPrepareRender' : updateMethod && view[updateMethod] ? updateMethod : 'render';
    if (methodName !== 'render') view[methodName](seriesModel, ecModel, api, payload);
    return $0dc5061053e23cd3$var$progressMethodMap[methodName];
}
var $0dc5061053e23cd3$var$progressMethodMap = {
    incrementalPrepareRender: {
        progress: function(params, context) {
            context.view.incrementalRender(params, context.model, context.ecModel, context.api, context.payload);
        }
    },
    render: {
        // Put view.render in `progress` to support appendData. But in this case
        // view.render should not be called in reset, otherwise it will be called
        // twise. Use `forceFirstProgress` to make sure that view.render is called
        // in any cases.
        forceFirstProgress: true,
        progress: function(params, context) {
            context.view.render(context.model, context.ecModel, context.api, context.payload);
        }
    }
};
var $0dc5061053e23cd3$export$2e2bcd8739ae039 = $0dc5061053e23cd3$var$ChartView;






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $c98659a9437a3d2e$var$ORIGIN_METHOD = '\0__throttleOriginMethod';
var $c98659a9437a3d2e$var$RATE = '\0__throttleRate';
var $c98659a9437a3d2e$var$THROTTLE_TYPE = '\0__throttleType';
function $c98659a9437a3d2e$export$de363e709c412c8a(fn, delay, debounce) {
    var currCall;
    var lastCall = 0;
    var lastExec = 0;
    var timer = null;
    var diff;
    var scope;
    var args;
    var debounceNextCall;
    delay = delay || 0;
    function exec() {
        lastExec = new Date().getTime();
        timer = null;
        fn.apply(scope, args || []);
    }
    var cb = function() {
        var cbArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)cbArgs[_i] = arguments[_i];
        currCall = new Date().getTime();
        scope = this;
        args = cbArgs;
        var thisDelay = debounceNextCall || delay;
        var thisDebounce = debounceNextCall || debounce;
        debounceNextCall = null;
        diff = currCall - (thisDebounce ? lastCall : lastExec) - thisDelay;
        clearTimeout(timer);
        // Here we should make sure that: the `exec` SHOULD NOT be called later
        // than a new call of `cb`, that is, preserving the command order. Consider
        // calculating "scale rate" when roaming as an example. When a call of `cb`
        // happens, either the `exec` is called dierectly, or the call is delayed.
        // But the delayed call should never be later than next call of `cb`. Under
        // this assurance, we can simply update view state each time `dispatchAction`
        // triggered by user roaming, but not need to add extra code to avoid the
        // state being "rolled-back".
        if (thisDebounce) timer = setTimeout(exec, thisDelay);
        else if (diff >= 0) exec();
        else timer = setTimeout(exec, -diff);
        lastCall = currCall;
    };
    /**
   * Clear throttle.
   * @public
   */ cb.clear = function() {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    };
    /**
   * Enable debounce once.
   */ cb.debounceNextCall = function(debounceDelay) {
        debounceNextCall = debounceDelay;
    };
    return cb;
}
function $c98659a9437a3d2e$export$958e3e1a02eac4b6(obj, fnAttr, rate, throttleType) {
    var fn = obj[fnAttr];
    if (!fn) return;
    var originFn = fn[$c98659a9437a3d2e$var$ORIGIN_METHOD] || fn;
    var lastThrottleType = fn[$c98659a9437a3d2e$var$THROTTLE_TYPE];
    var lastRate = fn[$c98659a9437a3d2e$var$RATE];
    if (lastRate !== rate || lastThrottleType !== throttleType) {
        if (rate == null || !throttleType) return obj[fnAttr] = originFn;
        fn = obj[fnAttr] = $c98659a9437a3d2e$export$de363e709c412c8a(originFn, rate, throttleType === 'debounce');
        fn[$c98659a9437a3d2e$var$ORIGIN_METHOD] = originFn;
        fn[$c98659a9437a3d2e$var$THROTTLE_TYPE] = throttleType;
        fn[$c98659a9437a3d2e$var$RATE] = rate;
    }
    return fn;
}
function $c98659a9437a3d2e$export$42ffd38884aecdac(obj, fnAttr) {
    var fn = obj[fnAttr];
    if (fn && fn[$c98659a9437a3d2e$var$ORIGIN_METHOD]) {
        // Clear throttle
        fn.clear && fn.clear();
        obj[fnAttr] = fn[$c98659a9437a3d2e$var$ORIGIN_METHOD];
    }
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $a617f62dd17b10f1$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $a617f62dd17b10f1$var$defaultStyleMappers = {
    itemStyle: (0, $06542048a26d4d91$export$2e2bcd8739ae039)((0, $c42afdfd2f0ddc96$export$ffb0bba5dde0130b), true),
    lineStyle: (0, $06542048a26d4d91$export$2e2bcd8739ae039)((0, $9c5206e1bd69e88f$export$9f34de5b59222949), true)
};
var $a617f62dd17b10f1$var$defaultColorKey = {
    lineStyle: 'stroke',
    itemStyle: 'fill'
};
function $a617f62dd17b10f1$var$getStyleMapper(seriesModel, stylePath) {
    var styleMapper = seriesModel.visualStyleMapper || $a617f62dd17b10f1$var$defaultStyleMappers[stylePath];
    if (!styleMapper) {
        console.warn("Unknown style type '" + stylePath + "'.");
        return $a617f62dd17b10f1$var$defaultStyleMappers.itemStyle;
    }
    return styleMapper;
}
function $a617f62dd17b10f1$var$getDefaultColorKey(seriesModel, stylePath) {
    // return defaultColorKey[stylePath] ||
    var colorKey = seriesModel.visualDrawType || $a617f62dd17b10f1$var$defaultColorKey[stylePath];
    if (!colorKey) {
        console.warn("Unknown style type '" + stylePath + "'.");
        return 'fill';
    }
    return colorKey;
}
var $a617f62dd17b10f1$export$7ce4d65f9b69240 = {
    createOnAllSeries: true,
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        var data = seriesModel.getData();
        var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle';
        // Set in itemStyle
        var styleModel = seriesModel.getModel(stylePath);
        var getStyle = $a617f62dd17b10f1$var$getStyleMapper(seriesModel, stylePath);
        var globalStyle = getStyle(styleModel);
        var decalOption = styleModel.getShallow('decal');
        if (decalOption) {
            data.setVisual('decal', decalOption);
            decalOption.dirty = true;
        }
        // TODO
        var colorKey = $a617f62dd17b10f1$var$getDefaultColorKey(seriesModel, stylePath);
        var color = globalStyle[colorKey];
        // TODO style callback
        var colorCallback = (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(color) ? color : null;
        var hasAutoColor = globalStyle.fill === 'auto' || globalStyle.stroke === 'auto';
        // Get from color palette by default.
        if (!globalStyle[colorKey] || colorCallback || hasAutoColor) {
            // Note: If some series has color specified (e.g., by itemStyle.color), we DO NOT
            // make it effect palette. Because some scenarios users need to make some series
            // transparent or as background, which should better not effect the palette.
            var colorPalette = seriesModel.getColorFromPalette(// TODO series count changed.
            seriesModel.name, null, ecModel.getSeriesCount());
            if (!globalStyle[colorKey]) {
                globalStyle[colorKey] = colorPalette;
                data.setVisual('colorFromPalette', true);
            }
            globalStyle.fill = globalStyle.fill === 'auto' || (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(globalStyle.fill) ? colorPalette : globalStyle.fill;
            globalStyle.stroke = globalStyle.stroke === 'auto' || (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(globalStyle.stroke) ? colorPalette : globalStyle.stroke;
        }
        data.setVisual('style', globalStyle);
        data.setVisual('drawType', colorKey);
        // Only visible series has each data be visual encoded
        if (!ecModel.isSeriesFiltered(seriesModel) && colorCallback) {
            data.setVisual('colorFromPalette', false);
            return {
                dataEach: function(data, idx) {
                    var dataParams = seriesModel.getDataParams(idx);
                    var itemStyle = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, globalStyle);
                    itemStyle[colorKey] = colorCallback(dataParams);
                    data.setItemVisual(idx, 'style', itemStyle);
                }
            };
        }
    }
};
var $a617f62dd17b10f1$var$sharedModel = new (0, $6818646a97528290$export$2e2bcd8739ae039)();
var $a617f62dd17b10f1$export$f7dcb66a065003d1 = {
    createOnAllSeries: true,
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        if (seriesModel.ignoreStyleOnData || ecModel.isSeriesFiltered(seriesModel)) return;
        var data = seriesModel.getData();
        var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle';
        // Set in itemStyle
        var getStyle = $a617f62dd17b10f1$var$getStyleMapper(seriesModel, stylePath);
        var colorKey = data.getVisual('drawType');
        return {
            dataEach: data.hasItemOption ? function(data, idx) {
                // Not use getItemModel for performance considuration
                var rawItem = data.getRawDataItem(idx);
                if (rawItem && rawItem[stylePath]) {
                    $a617f62dd17b10f1$var$sharedModel.option = rawItem[stylePath];
                    var style = getStyle($a617f62dd17b10f1$var$sharedModel);
                    var existsStyle = data.ensureUniqueItemVisual(idx, 'style');
                    (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(existsStyle, style);
                    if ($a617f62dd17b10f1$var$sharedModel.option.decal) {
                        data.setItemVisual(idx, 'decal', $a617f62dd17b10f1$var$sharedModel.option.decal);
                        $a617f62dd17b10f1$var$sharedModel.option.decal.dirty = true;
                    }
                    if (colorKey in style) data.setItemVisual(idx, 'colorFromPalette', false);
                }
            } : null
        };
    }
};
// Pick color from palette for the data which has not been set with color yet.
// Note: do not support stream rendering. No such cases yet.
var $a617f62dd17b10f1$export$cf9758b0d6dc0aa9 = {
    performRawSeries: true,
    overallReset: function(ecModel) {
        // Each type of series uses one scope.
        // Pie and funnel are using different scopes.
        var paletteScopeGroupByType = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        ecModel.eachSeries(function(seriesModel) {
            var colorBy = seriesModel.getColorBy();
            if (seriesModel.isColorBySeries()) return;
            var key = seriesModel.type + '-' + colorBy;
            var colorScope = paletteScopeGroupByType.get(key);
            if (!colorScope) {
                colorScope = {};
                paletteScopeGroupByType.set(key, colorScope);
            }
            $a617f62dd17b10f1$var$inner(seriesModel).scope = colorScope;
        });
        ecModel.eachSeries(function(seriesModel) {
            if (seriesModel.isColorBySeries() || ecModel.isSeriesFiltered(seriesModel)) return;
            var dataAll = seriesModel.getRawData();
            var idxMap = {};
            var data = seriesModel.getData();
            var colorScope = $a617f62dd17b10f1$var$inner(seriesModel).scope;
            var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle';
            var colorKey = $a617f62dd17b10f1$var$getDefaultColorKey(seriesModel, stylePath);
            data.each(function(idx) {
                var rawIdx = data.getRawIndex(idx);
                idxMap[rawIdx] = idx;
            });
            // Iterate on data before filtered. To make sure color from palette can be
            // Consistent when toggling legend.
            dataAll.each(function(rawIdx) {
                var idx = idxMap[rawIdx];
                var fromPalette = data.getItemVisual(idx, 'colorFromPalette');
                // Get color from palette for each data only when the color is inherited from series color, which is
                // also picked from color palette. So following situation is not in the case:
                // 1. series.itemStyle.color is set
                // 2. color is encoded by visualMap
                if (fromPalette) {
                    var itemStyle = data.ensureUniqueItemVisual(idx, 'style');
                    var name_1 = dataAll.getName(rawIdx) || rawIdx + '';
                    var dataCount = dataAll.count();
                    itemStyle[colorKey] = seriesModel.getColorFromPalette(name_1, colorScope, dataCount);
                }
            });
        });
    }
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $f23f99c31dceac8f$var$PI = Math.PI;
function $f23f99c31dceac8f$export$2e2bcd8739ae039(api, opts) {
    opts = opts || {};
    $7a1bd9c2710fea0d$export$ebe90cb607ad99e(opts, {
        text: 'loading',
        textColor: '#000',
        fontSize: 12,
        fontWeight: 'normal',
        fontStyle: 'normal',
        fontFamily: 'sans-serif',
        maskColor: 'rgba(255, 255, 255, 0.8)',
        showSpinner: true,
        color: '#5470c6',
        spinnerRadius: 10,
        lineWidth: 5,
        zlevel: 0
    });
    var group = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
    var mask = new $419e5ff2f303755e$export$2e2bcd8739ae039({
        style: {
            fill: opts.maskColor
        },
        zlevel: opts.zlevel,
        z: 10000
    });
    group.add(mask);
    var textContent = new $fe885cc21795562b$export$2e2bcd8739ae039({
        style: {
            text: opts.text,
            fill: opts.textColor,
            fontSize: opts.fontSize,
            fontWeight: opts.fontWeight,
            fontStyle: opts.fontStyle,
            fontFamily: opts.fontFamily
        },
        zlevel: opts.zlevel,
        z: 10001
    });
    var labelRect = new $419e5ff2f303755e$export$2e2bcd8739ae039({
        style: {
            fill: 'none'
        },
        textContent: textContent,
        textConfig: {
            position: 'right',
            distance: 10
        },
        zlevel: opts.zlevel,
        z: 10001
    });
    group.add(labelRect);
    var arc;
    if (opts.showSpinner) {
        arc = new $2b5c23eb3597b84a$export$2e2bcd8739ae039({
            shape: {
                startAngle: -$f23f99c31dceac8f$var$PI / 2,
                endAngle: -$f23f99c31dceac8f$var$PI / 2 + 0.1,
                r: opts.spinnerRadius
            },
            style: {
                stroke: opts.color,
                lineCap: 'round',
                lineWidth: opts.lineWidth
            },
            zlevel: opts.zlevel,
            z: 10001
        });
        arc.animateShape(true).when(1000, {
            endAngle: $f23f99c31dceac8f$var$PI * 3 / 2
        }).start('circularInOut');
        arc.animateShape(true).when(1000, {
            startAngle: $f23f99c31dceac8f$var$PI * 3 / 2
        }).delay(300).start('circularInOut');
        group.add(arc);
    }
    // Inject resize
    group.resize = function() {
        var textWidth = textContent.getBoundingRect().width;
        var r = opts.showSpinner ? opts.spinnerRadius : 0;
        // cx = (containerWidth - arcDiameter - textDistance - textWidth) / 2
        // textDistance needs to be calculated when both animation and text exist
        var cx = (api.getWidth() - r * 2 - (opts.showSpinner && textWidth ? 10 : 0) - textWidth) / 2 - (opts.showSpinner && textWidth ? 0 : 5 + textWidth / 2) + (opts.showSpinner ? 0 : textWidth / 2) + (textWidth ? 0 : r);
        var cy = api.getHeight() / 2;
        opts.showSpinner && arc.setShape({
            cx: cx,
            cy: cy
        });
        labelRect.setShape({
            x: cx - r,
            y: cy - r,
            width: r * 2,
            height: r * 2
        });
        mask.setShape({
            x: 0,
            y: 0,
            width: api.getWidth(),
            height: api.getHeight()
        });
    };
    group.resize();
    return group;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $94ae4e8744638a8a$var$Scheduler = /** @class */ function() {
    function Scheduler(ecInstance, api, dataProcessorHandlers, visualHandlers) {
        // key: handlerUID
        this._stageTaskMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        this.ecInstance = ecInstance;
        this.api = api;
        // Fix current processors in case that in some rear cases that
        // processors might be registered after echarts instance created.
        // Register processors incrementally for a echarts instance is
        // not supported by this stream architecture.
        dataProcessorHandlers = this._dataProcessorHandlers = dataProcessorHandlers.slice();
        visualHandlers = this._visualHandlers = visualHandlers.slice();
        this._allHandlers = dataProcessorHandlers.concat(visualHandlers);
    }
    Scheduler.prototype.restoreData = function(ecModel, payload) {
        // TODO: Only restore needed series and components, but not all components.
        // Currently `restoreData` of all of the series and component will be called.
        // But some independent components like `title`, `legend`, `graphic`, `toolbox`,
        // `tooltip`, `axisPointer`, etc, do not need series refresh when `setOption`,
        // and some components like coordinate system, axes, dataZoom, visualMap only
        // need their target series refresh.
        // (1) If we are implementing this feature some day, we should consider these cases:
        // if a data processor depends on a component (e.g., dataZoomProcessor depends
        // on the settings of `dataZoom`), it should be re-performed if the component
        // is modified by `setOption`.
        // (2) If a processor depends on sevral series, speicified by its `getTargetSeries`,
        // it should be re-performed when the result array of `getTargetSeries` changed.
        // We use `dependencies` to cover these issues.
        // (3) How to update target series when coordinate system related components modified.
        // TODO: simply the dirty mechanism? Check whether only the case here can set tasks dirty,
        // and this case all of the tasks will be set as dirty.
        ecModel.restoreData(payload);
        // Theoretically an overall task not only depends on each of its target series, but also
        // depends on all of the series.
        // The overall task is not in pipeline, and `ecModel.restoreData` only set pipeline tasks
        // dirty. If `getTargetSeries` of an overall task returns nothing, we should also ensure
        // that the overall task is set as dirty and to be performed, otherwise it probably cause
        // state chaos. So we have to set dirty of all of the overall tasks manually, otherwise it
        // probably cause state chaos (consider `dataZoomProcessor`).
        this._stageTaskMap.each(function(taskRecord) {
            var overallTask = taskRecord.overallTask;
            overallTask && overallTask.dirty();
        });
    };
    // If seriesModel provided, incremental threshold is check by series data.
    Scheduler.prototype.getPerformArgs = function(task, isBlock) {
        // For overall task
        if (!task.__pipeline) return;
        var pipeline = this._pipelineMap.get(task.__pipeline.id);
        var pCtx = pipeline.context;
        var incremental = !isBlock && pipeline.progressiveEnabled && (!pCtx || pCtx.progressiveRender) && task.__idxInPipeline > pipeline.blockIndex;
        var step = incremental ? pipeline.step : null;
        var modDataCount = pCtx && pCtx.modDataCount;
        var modBy = modDataCount != null ? Math.ceil(modDataCount / step) : null;
        return {
            step: step,
            modBy: modBy,
            modDataCount: modDataCount
        };
    };
    Scheduler.prototype.getPipeline = function(pipelineId) {
        return this._pipelineMap.get(pipelineId);
    };
    /**
   * Current, progressive rendering starts from visual and layout.
   * Always detect render mode in the same stage, avoiding that incorrect
   * detection caused by data filtering.
   * Caution:
   * `updateStreamModes` use `seriesModel.getData()`.
   */ Scheduler.prototype.updateStreamModes = function(seriesModel, view) {
        var pipeline = this._pipelineMap.get(seriesModel.uid);
        var data = seriesModel.getData();
        var dataLen = data.count();
        // `progressiveRender` means that can render progressively in each
        // animation frame. Note that some types of series do not provide
        // `view.incrementalPrepareRender` but support `chart.appendData`. We
        // use the term `incremental` but not `progressive` to describe the
        // case that `chart.appendData`.
        var progressiveRender = pipeline.progressiveEnabled && view.incrementalPrepareRender && dataLen >= pipeline.threshold;
        var large = seriesModel.get('large') && dataLen >= seriesModel.get('largeThreshold');
        // TODO: modDataCount should not updated if `appendData`, otherwise cause whole repaint.
        // see `test/candlestick-large3.html`
        var modDataCount = seriesModel.get('progressiveChunkMode') === 'mod' ? dataLen : null;
        seriesModel.pipelineContext = pipeline.context = {
            progressiveRender: progressiveRender,
            modDataCount: modDataCount,
            large: large
        };
    };
    Scheduler.prototype.restorePipelines = function(ecModel) {
        var scheduler = this;
        var pipelineMap = scheduler._pipelineMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        ecModel.eachSeries(function(seriesModel) {
            var progressive = seriesModel.getProgressive();
            var pipelineId = seriesModel.uid;
            pipelineMap.set(pipelineId, {
                id: pipelineId,
                head: null,
                tail: null,
                threshold: seriesModel.getProgressiveThreshold(),
                progressiveEnabled: progressive && !(seriesModel.preventIncremental && seriesModel.preventIncremental()),
                blockIndex: -1,
                step: Math.round(progressive || 700),
                count: 0
            });
            scheduler._pipe(seriesModel, seriesModel.dataTask);
        });
    };
    Scheduler.prototype.prepareStageTasks = function() {
        var stageTaskMap = this._stageTaskMap;
        var ecModel = this.api.getModel();
        var api = this.api;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._allHandlers, function(handler) {
            var record = stageTaskMap.get(handler.uid) || stageTaskMap.set(handler.uid, {});
            var errMsg = '';
            (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)(!(handler.reset && handler.overallReset), errMsg);
            handler.reset && this._createSeriesStageTask(handler, record, ecModel, api);
            handler.overallReset && this._createOverallStageTask(handler, record, ecModel, api);
        }, this);
    };
    Scheduler.prototype.prepareView = function(view, model, ecModel, api) {
        var renderTask = view.renderTask;
        var context = renderTask.context;
        context.model = model;
        context.ecModel = ecModel;
        context.api = api;
        renderTask.__block = !view.incrementalPrepareRender;
        this._pipe(model, renderTask);
    };
    Scheduler.prototype.performDataProcessorTasks = function(ecModel, payload) {
        // If we do not use `block` here, it should be considered when to update modes.
        this._performStageTasks(this._dataProcessorHandlers, ecModel, payload, {
            block: true
        });
    };
    Scheduler.prototype.performVisualTasks = function(ecModel, payload, opt) {
        this._performStageTasks(this._visualHandlers, ecModel, payload, opt);
    };
    Scheduler.prototype._performStageTasks = function(stageHandlers, ecModel, payload, opt) {
        opt = opt || {};
        var unfinished = false;
        var scheduler = this;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(stageHandlers, function(stageHandler, idx) {
            if (opt.visualType && opt.visualType !== stageHandler.visualType) return;
            var stageHandlerRecord = scheduler._stageTaskMap.get(stageHandler.uid);
            var seriesTaskMap = stageHandlerRecord.seriesTaskMap;
            var overallTask = stageHandlerRecord.overallTask;
            if (overallTask) {
                var overallNeedDirty_1;
                var agentStubMap = overallTask.agentStubMap;
                agentStubMap.each(function(stub) {
                    if (needSetDirty(opt, stub)) {
                        stub.dirty();
                        overallNeedDirty_1 = true;
                    }
                });
                overallNeedDirty_1 && overallTask.dirty();
                scheduler.updatePayload(overallTask, payload);
                var performArgs_1 = scheduler.getPerformArgs(overallTask, opt.block);
                // Execute stubs firstly, which may set the overall task dirty,
                // then execute the overall task. And stub will call seriesModel.setData,
                // which ensures that in the overallTask seriesModel.getData() will not
                // return incorrect data.
                agentStubMap.each(function(stub) {
                    stub.perform(performArgs_1);
                });
                if (overallTask.perform(performArgs_1)) unfinished = true;
            } else if (seriesTaskMap) seriesTaskMap.each(function(task, pipelineId) {
                if (needSetDirty(opt, task)) task.dirty();
                var performArgs = scheduler.getPerformArgs(task, opt.block);
                // FIXME
                // if intending to declare `performRawSeries` in handlers, only
                // stream-independent (specifically, data item independent) operations can be
                // performed. Because if a series is filtered, most of the tasks will not
                // be performed. A stream-dependent operation probably cause wrong biz logic.
                // Perhaps we should not provide a separate callback for this case instead
                // of providing the config `performRawSeries`. The stream-dependent operations
                // and stream-independent operations should better not be mixed.
                performArgs.skip = !stageHandler.performRawSeries && ecModel.isSeriesFiltered(task.context.model);
                scheduler.updatePayload(task, payload);
                if (task.perform(performArgs)) unfinished = true;
            });
        });
        function needSetDirty(opt, task) {
            return opt.setDirty && (!opt.dirtyMap || opt.dirtyMap.get(task.__pipeline.id));
        }
        this.unfinished = unfinished || this.unfinished;
    };
    Scheduler.prototype.performSeriesTasks = function(ecModel) {
        var unfinished;
        ecModel.eachSeries(function(seriesModel) {
            // Progress to the end for dataInit and dataRestore.
            unfinished = seriesModel.dataTask.perform() || unfinished;
        });
        this.unfinished = unfinished || this.unfinished;
    };
    Scheduler.prototype.plan = function() {
        // Travel pipelines, check block.
        this._pipelineMap.each(function(pipeline) {
            var task = pipeline.tail;
            do {
                if (task.__block) {
                    pipeline.blockIndex = task.__idxInPipeline;
                    break;
                }
                task = task.getUpstream();
            }while (task);
        });
    };
    Scheduler.prototype.updatePayload = function(task, payload) {
        payload !== 'remain' && (task.context.payload = payload);
    };
    Scheduler.prototype._createSeriesStageTask = function(stageHandler, stageHandlerRecord, ecModel, api) {
        var scheduler = this;
        var oldSeriesTaskMap = stageHandlerRecord.seriesTaskMap;
        // The count of stages are totally about only several dozen, so
        // do not need to reuse the map.
        var newSeriesTaskMap = stageHandlerRecord.seriesTaskMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        var seriesType = stageHandler.seriesType;
        var getTargetSeries = stageHandler.getTargetSeries;
        // If a stageHandler should cover all series, `createOnAllSeries` should be declared mandatorily,
        // to avoid some typo or abuse. Otherwise if an extension do not specify a `seriesType`,
        // it works but it may cause other irrelevant charts blocked.
        if (stageHandler.createOnAllSeries) ecModel.eachRawSeries(create);
        else if (seriesType) ecModel.eachRawSeriesByType(seriesType, create);
        else if (getTargetSeries) getTargetSeries(ecModel, api).each(create);
        function create(seriesModel) {
            var pipelineId = seriesModel.uid;
            // Init tasks for each seriesModel only once.
            // Reuse original task instance.
            var task = newSeriesTaskMap.set(pipelineId, oldSeriesTaskMap && oldSeriesTaskMap.get(pipelineId) || (0, $4d16404c851dcec6$export$f7292ab7796be73c)({
                plan: $94ae4e8744638a8a$var$seriesTaskPlan,
                reset: $94ae4e8744638a8a$var$seriesTaskReset,
                count: $94ae4e8744638a8a$var$seriesTaskCount
            }));
            task.context = {
                model: seriesModel,
                ecModel: ecModel,
                api: api,
                // PENDING: `useClearVisual` not used?
                useClearVisual: stageHandler.isVisual && !stageHandler.isLayout,
                plan: stageHandler.plan,
                reset: stageHandler.reset,
                scheduler: scheduler
            };
            scheduler._pipe(seriesModel, task);
        }
    };
    Scheduler.prototype._createOverallStageTask = function(stageHandler, stageHandlerRecord, ecModel, api) {
        var scheduler = this;
        var overallTask = stageHandlerRecord.overallTask = stageHandlerRecord.overallTask || (0, $4d16404c851dcec6$export$f7292ab7796be73c)({
            reset: $94ae4e8744638a8a$var$overallTaskReset
        });
        overallTask.context = {
            ecModel: ecModel,
            api: api,
            overallReset: stageHandler.overallReset,
            scheduler: scheduler
        };
        var oldAgentStubMap = overallTask.agentStubMap;
        // The count of stages are totally about only several dozen, so
        // do not need to reuse the map.
        var newAgentStubMap = overallTask.agentStubMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        var seriesType = stageHandler.seriesType;
        var getTargetSeries = stageHandler.getTargetSeries;
        var overallProgress = true;
        var shouldOverallTaskDirty = false;
        // FIXME:TS never used, so comment it
        // let modifyOutputEnd = stageHandler.modifyOutputEnd;
        // An overall task with seriesType detected or has `getTargetSeries`, we add
        // stub in each pipelines, it will set the overall task dirty when the pipeline
        // progress. Moreover, to avoid call the overall task each frame (too frequent),
        // we set the pipeline block.
        var errMsg = '';
        (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)(!stageHandler.createOnAllSeries, errMsg);
        if (seriesType) ecModel.eachRawSeriesByType(seriesType, createStub);
        else if (getTargetSeries) getTargetSeries(ecModel, api).each(createStub);
        else {
            overallProgress = false;
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(ecModel.getSeries(), createStub);
        }
        function createStub(seriesModel) {
            var pipelineId = seriesModel.uid;
            var stub = newAgentStubMap.set(pipelineId, oldAgentStubMap && oldAgentStubMap.get(pipelineId) || // When the result of `getTargetSeries` changed, the overallTask
            // should be set as dirty and re-performed.
            (shouldOverallTaskDirty = true, (0, $4d16404c851dcec6$export$f7292ab7796be73c)({
                reset: $94ae4e8744638a8a$var$stubReset,
                onDirty: $94ae4e8744638a8a$var$stubOnDirty
            })));
            stub.context = {
                model: seriesModel,
                overallProgress: overallProgress
            };
            stub.agent = overallTask;
            stub.__block = overallProgress;
            scheduler._pipe(seriesModel, stub);
        }
        if (shouldOverallTaskDirty) overallTask.dirty();
    };
    Scheduler.prototype._pipe = function(seriesModel, task) {
        var pipelineId = seriesModel.uid;
        var pipeline = this._pipelineMap.get(pipelineId);
        !pipeline.head && (pipeline.head = task);
        pipeline.tail && pipeline.tail.pipe(task);
        pipeline.tail = task;
        task.__idxInPipeline = pipeline.count++;
        task.__pipeline = pipeline;
    };
    Scheduler.wrapStageHandler = function(stageHandler, visualType) {
        if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(stageHandler)) stageHandler = {
            overallReset: stageHandler,
            seriesType: $94ae4e8744638a8a$var$detectSeriseType(stageHandler)
        };
        stageHandler.uid = (0, $5370df662b2caf37$export$6d2b3473b0986646)('stageHandler');
        visualType && (stageHandler.visualType = visualType);
        return stageHandler;
    };
    return Scheduler;
}();
function $94ae4e8744638a8a$var$overallTaskReset(context) {
    context.overallReset(context.ecModel, context.api, context.payload);
}
function $94ae4e8744638a8a$var$stubReset(context) {
    return context.overallProgress && $94ae4e8744638a8a$var$stubProgress;
}
function $94ae4e8744638a8a$var$stubProgress() {
    this.agent.dirty();
    this.getDownstream().dirty();
}
function $94ae4e8744638a8a$var$stubOnDirty() {
    this.agent && this.agent.dirty();
}
function $94ae4e8744638a8a$var$seriesTaskPlan(context) {
    return context.plan ? context.plan(context.model, context.ecModel, context.api, context.payload) : null;
}
function $94ae4e8744638a8a$var$seriesTaskReset(context) {
    if (context.useClearVisual) context.data.clearAllVisual();
    var resetDefines = context.resetDefines = (0, $76d619f648247e6d$export$4f07b212a02c8051)(context.reset(context.model, context.ecModel, context.api, context.payload));
    return resetDefines.length > 1 ? (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(resetDefines, function(v, idx) {
        return $94ae4e8744638a8a$var$makeSeriesTaskProgress(idx);
    }) : $94ae4e8744638a8a$var$singleSeriesTaskProgress;
}
var $94ae4e8744638a8a$var$singleSeriesTaskProgress = $94ae4e8744638a8a$var$makeSeriesTaskProgress(0);
function $94ae4e8744638a8a$var$makeSeriesTaskProgress(resetDefineIdx) {
    return function(params, context) {
        var data = context.data;
        var resetDefine = context.resetDefines[resetDefineIdx];
        if (resetDefine && resetDefine.dataEach) for(var i = params.start; i < params.end; i++)resetDefine.dataEach(data, i);
        else if (resetDefine && resetDefine.progress) resetDefine.progress(params, data);
    };
}
function $94ae4e8744638a8a$var$seriesTaskCount(context) {
    return context.data.count();
}
/**
 * Only some legacy stage handlers (usually in echarts extensions) are pure function.
 * To ensure that they can work normally, they should work in block mode, that is,
 * they should not be started util the previous tasks finished. So they cause the
 * progressive rendering disabled. We try to detect the series type, to narrow down
 * the block range to only the series type they concern, but not all series.
 */ function $94ae4e8744638a8a$var$detectSeriseType(legacyFunc) {
    $94ae4e8744638a8a$var$seriesType = null;
    try {
        // Assume there is no async when calling `eachSeriesByType`.
        legacyFunc($94ae4e8744638a8a$var$ecModelMock, $94ae4e8744638a8a$var$apiMock);
    } catch (e) {}
    return $94ae4e8744638a8a$var$seriesType;
}
var $94ae4e8744638a8a$var$ecModelMock = {};
var $94ae4e8744638a8a$var$apiMock = {};
var $94ae4e8744638a8a$var$seriesType;
$94ae4e8744638a8a$var$mockMethods($94ae4e8744638a8a$var$ecModelMock, (0, $51f6ef0dd9546916$export$2e2bcd8739ae039));
$94ae4e8744638a8a$var$mockMethods($94ae4e8744638a8a$var$apiMock, (0, $a6d7e6163195660e$export$2e2bcd8739ae039));
$94ae4e8744638a8a$var$ecModelMock.eachSeriesByType = $94ae4e8744638a8a$var$ecModelMock.eachRawSeriesByType = function(type) {
    $94ae4e8744638a8a$var$seriesType = type;
};
$94ae4e8744638a8a$var$ecModelMock.eachComponent = function(cond) {
    if (cond.mainType === 'series' && cond.subType) $94ae4e8744638a8a$var$seriesType = cond.subType;
};
function $94ae4e8744638a8a$var$mockMethods(target, Clz) {
    /* eslint-disable */ for(var name_1 in Clz.prototype)// Do not use hasOwnProperty
    target[name_1] = (0, $7a1bd9c2710fea0d$export$8793edee2d425525);
/* eslint-enable */ }
var $94ae4e8744638a8a$export$2e2bcd8739ae039 = $94ae4e8744638a8a$var$Scheduler;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $0e5dbddd76825050$var$colorAll = [
    '#37A2DA',
    '#32C5E9',
    '#67E0E3',
    '#9FE6B8',
    '#FFDB5C',
    '#ff9f7f',
    '#fb7293',
    '#E062AE',
    '#E690D1',
    '#e7bcf3',
    '#9d96f5',
    '#8378EA',
    '#96BFFF'
];
var $0e5dbddd76825050$export$2e2bcd8739ae039 = {
    color: $0e5dbddd76825050$var$colorAll,
    colorLayer: [
        [
            '#37A2DA',
            '#ffd85c',
            '#fd7b5f'
        ],
        [
            '#37A2DA',
            '#67E0E3',
            '#FFDB5C',
            '#ff9f7f',
            '#E062AE',
            '#9d96f5'
        ],
        [
            '#37A2DA',
            '#32C5E9',
            '#9FE6B8',
            '#FFDB5C',
            '#ff9f7f',
            '#fb7293',
            '#e7bcf3',
            '#8378EA',
            '#96BFFF'
        ],
        $0e5dbddd76825050$var$colorAll
    ]
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $985c98ffd51c6ff6$var$contrastColor = '#B9B8CE';
var $985c98ffd51c6ff6$var$backgroundColor = '#100C2A';
var $985c98ffd51c6ff6$var$axisCommon = function() {
    return {
        axisLine: {
            lineStyle: {
                color: $985c98ffd51c6ff6$var$contrastColor
            }
        },
        splitLine: {
            lineStyle: {
                color: '#484753'
            }
        },
        splitArea: {
            areaStyle: {
                color: [
                    'rgba(255,255,255,0.02)',
                    'rgba(255,255,255,0.05)'
                ]
            }
        },
        minorSplitLine: {
            lineStyle: {
                color: '#20203B'
            }
        }
    };
};
var $985c98ffd51c6ff6$var$colorPalette = [
    '#4992ff',
    '#7cffb2',
    '#fddd60',
    '#ff6e76',
    '#58d9f9',
    '#05c091',
    '#ff8a45',
    '#8d48e3',
    '#dd79ff'
];
var $985c98ffd51c6ff6$var$theme = {
    darkMode: true,
    color: $985c98ffd51c6ff6$var$colorPalette,
    backgroundColor: $985c98ffd51c6ff6$var$backgroundColor,
    axisPointer: {
        lineStyle: {
            color: '#817f91'
        },
        crossStyle: {
            color: '#817f91'
        },
        label: {
            // TODO Contrast of label backgorundColor
            color: '#fff'
        }
    },
    legend: {
        textStyle: {
            color: $985c98ffd51c6ff6$var$contrastColor
        },
        pageTextStyle: {
            color: $985c98ffd51c6ff6$var$contrastColor
        }
    },
    textStyle: {
        color: $985c98ffd51c6ff6$var$contrastColor
    },
    title: {
        textStyle: {
            color: '#EEF1FA'
        },
        subtextStyle: {
            color: '#B9B8CE'
        }
    },
    toolbox: {
        iconStyle: {
            borderColor: $985c98ffd51c6ff6$var$contrastColor
        }
    },
    dataZoom: {
        borderColor: '#71708A',
        textStyle: {
            color: $985c98ffd51c6ff6$var$contrastColor
        },
        brushStyle: {
            color: 'rgba(135,163,206,0.3)'
        },
        handleStyle: {
            color: '#353450',
            borderColor: '#C5CBE3'
        },
        moveHandleStyle: {
            color: '#B0B6C3',
            opacity: 0.3
        },
        fillerColor: 'rgba(135,163,206,0.2)',
        emphasis: {
            handleStyle: {
                borderColor: '#91B7F2',
                color: '#4D587D'
            },
            moveHandleStyle: {
                color: '#636D9A',
                opacity: 0.7
            }
        },
        dataBackground: {
            lineStyle: {
                color: '#71708A',
                width: 1
            },
            areaStyle: {
                color: '#71708A'
            }
        },
        selectedDataBackground: {
            lineStyle: {
                color: '#87A3CE'
            },
            areaStyle: {
                color: '#87A3CE'
            }
        }
    },
    visualMap: {
        textStyle: {
            color: $985c98ffd51c6ff6$var$contrastColor
        }
    },
    timeline: {
        lineStyle: {
            color: $985c98ffd51c6ff6$var$contrastColor
        },
        label: {
            color: $985c98ffd51c6ff6$var$contrastColor
        },
        controlStyle: {
            color: $985c98ffd51c6ff6$var$contrastColor,
            borderColor: $985c98ffd51c6ff6$var$contrastColor
        }
    },
    calendar: {
        itemStyle: {
            color: $985c98ffd51c6ff6$var$backgroundColor
        },
        dayLabel: {
            color: $985c98ffd51c6ff6$var$contrastColor
        },
        monthLabel: {
            color: $985c98ffd51c6ff6$var$contrastColor
        },
        yearLabel: {
            color: $985c98ffd51c6ff6$var$contrastColor
        }
    },
    timeAxis: $985c98ffd51c6ff6$var$axisCommon(),
    logAxis: $985c98ffd51c6ff6$var$axisCommon(),
    valueAxis: $985c98ffd51c6ff6$var$axisCommon(),
    categoryAxis: $985c98ffd51c6ff6$var$axisCommon(),
    line: {
        symbol: 'circle'
    },
    graph: {
        color: $985c98ffd51c6ff6$var$colorPalette
    },
    gauge: {
        title: {
            color: $985c98ffd51c6ff6$var$contrastColor
        },
        axisLine: {
            lineStyle: {
                color: [
                    [
                        1,
                        'rgba(207,212,219,0.2)'
                    ]
                ]
            }
        },
        axisLabel: {
            color: $985c98ffd51c6ff6$var$contrastColor
        },
        detail: {
            color: '#EEF1FA'
        }
    },
    candlestick: {
        itemStyle: {
            color: '#f64e56',
            color0: '#54ea92',
            borderColor: '#f64e56',
            borderColor0: '#54ea92'
        }
    }
};
$985c98ffd51c6ff6$var$theme.categoryAxis.splitLine.show = false;
var $985c98ffd51c6ff6$export$2e2bcd8739ae039 = $985c98ffd51c6ff6$var$theme;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/**
 * Usage of query:
 * `chart.on('click', query, handler);`
 * The `query` can be:
 * + The component type query string, only `mainType` or `mainType.subType`,
 *   like: 'xAxis', 'series', 'xAxis.category' or 'series.line'.
 * + The component query object, like:
 *   `{seriesIndex: 2}`, `{seriesName: 'xx'}`, `{seriesId: 'some'}`,
 *   `{xAxisIndex: 2}`, `{xAxisName: 'xx'}`, `{xAxisId: 'some'}`.
 * + The data query object, like:
 *   `{dataIndex: 123}`, `{dataType: 'link'}`, `{name: 'some'}`.
 * + The other query object (cmponent customized query), like:
 *   `{element: 'some'}` (only available in custom series).
 *
 * Caveat: If a prop in the `query` object is `null/undefined`, it is the
 * same as there is no such prop in the `query` object.
 */ var $82d62ed69f6abce3$export$d0fd09f950257b52 = /** @class */ function() {
    function ECEventProcessor() {}
    ECEventProcessor.prototype.normalizeQuery = function(query) {
        var cptQuery = {};
        var dataQuery = {};
        var otherQuery = {};
        // `query` is `mainType` or `mainType.subType` of component.
        if ($7a1bd9c2710fea0d$export$844ec244b1367d54(query)) {
            var condCptType = (0, $cd5f95cf03b4e3e7$export$fbe18865d303bf01)(query);
            // `.main` and `.sub` may be ''.
            cptQuery.mainType = condCptType.main || null;
            cptQuery.subType = condCptType.sub || null;
        } else {
            // `xxxIndex`, `xxxName`, `xxxId`, `name`, `dataIndex`, `dataType` is reserved,
            // can not be used in `compomentModel.filterForExposedEvent`.
            var suffixes_1 = [
                'Index',
                'Name',
                'Id'
            ];
            var dataKeys_1 = {
                name: 1,
                dataIndex: 1,
                dataType: 1
            };
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(query, function(val, key) {
                var reserved = false;
                for(var i = 0; i < suffixes_1.length; i++){
                    var propSuffix = suffixes_1[i];
                    var suffixPos = key.lastIndexOf(propSuffix);
                    if (suffixPos > 0 && suffixPos === key.length - propSuffix.length) {
                        var mainType = key.slice(0, suffixPos);
                        // Consider `dataIndex`.
                        if (mainType !== 'data') {
                            cptQuery.mainType = mainType;
                            cptQuery[propSuffix.toLowerCase()] = val;
                            reserved = true;
                        }
                    }
                }
                if (dataKeys_1.hasOwnProperty(key)) {
                    dataQuery[key] = val;
                    reserved = true;
                }
                if (!reserved) otherQuery[key] = val;
            });
        }
        return {
            cptQuery: cptQuery,
            dataQuery: dataQuery,
            otherQuery: otherQuery
        };
    };
    ECEventProcessor.prototype.filter = function(eventType, query) {
        // They should be assigned before each trigger call.
        var eventInfo = this.eventInfo;
        if (!eventInfo) return true;
        var targetEl = eventInfo.targetEl;
        var packedEvent = eventInfo.packedEvent;
        var model = eventInfo.model;
        var view = eventInfo.view;
        // For event like 'globalout'.
        if (!model || !view) return true;
        var cptQuery = query.cptQuery;
        var dataQuery = query.dataQuery;
        return check(cptQuery, model, 'mainType') && check(cptQuery, model, 'subType') && check(cptQuery, model, 'index', 'componentIndex') && check(cptQuery, model, 'name') && check(cptQuery, model, 'id') && check(dataQuery, packedEvent, 'name') && check(dataQuery, packedEvent, 'dataIndex') && check(dataQuery, packedEvent, 'dataType') && (!view.filterForExposedEvent || view.filterForExposedEvent(eventType, query.otherQuery, targetEl, packedEvent));
        function check(query, host, prop, propOnHost) {
            return query[prop] == null || host[propOnHost || prop] === query[prop];
        }
    };
    ECEventProcessor.prototype.afterTrigger = function() {
        // Make sure the eventInfo won't be used in next trigger.
        this.eventInfo = null;
    };
    return ECEventProcessor;
}();


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $f8e1f1a448782588$var$SYMBOL_PROPS_WITH_CB = [
    'symbol',
    'symbolSize',
    'symbolRotate',
    'symbolOffset'
];
var $f8e1f1a448782588$var$SYMBOL_PROPS = $f8e1f1a448782588$var$SYMBOL_PROPS_WITH_CB.concat([
    'symbolKeepAspect'
]);
// Encoding visual for all series include which is filtered for legend drawing
var $f8e1f1a448782588$export$144ac3beded415d9 = {
    createOnAllSeries: true,
    // For legend.
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        var data = seriesModel.getData();
        if (seriesModel.legendIcon) data.setVisual('legendIcon', seriesModel.legendIcon);
        if (!seriesModel.hasSymbolVisual) return;
        var symbolOptions = {};
        var symbolOptionsCb = {};
        var hasCallback = false;
        for(var i = 0; i < $f8e1f1a448782588$var$SYMBOL_PROPS_WITH_CB.length; i++){
            var symbolPropName = $f8e1f1a448782588$var$SYMBOL_PROPS_WITH_CB[i];
            var val = seriesModel.get(symbolPropName);
            if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(val)) {
                hasCallback = true;
                symbolOptionsCb[symbolPropName] = val;
            } else symbolOptions[symbolPropName] = val;
        }
        symbolOptions.symbol = symbolOptions.symbol || seriesModel.defaultSymbol;
        data.setVisual((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
            legendIcon: seriesModel.legendIcon || symbolOptions.symbol,
            symbolKeepAspect: seriesModel.get('symbolKeepAspect')
        }, symbolOptions));
        // Only visible series has each data be visual encoded
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        var symbolPropsCb = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(symbolOptionsCb);
        function dataEach(data, idx) {
            var rawValue = seriesModel.getRawValue(idx);
            var params = seriesModel.getDataParams(idx);
            for(var i = 0; i < symbolPropsCb.length; i++){
                var symbolPropName = symbolPropsCb[i];
                data.setItemVisual(idx, symbolPropName, symbolOptionsCb[symbolPropName](rawValue, params));
            }
        }
        return {
            dataEach: hasCallback ? dataEach : null
        };
    }
};
var $f8e1f1a448782588$export$435b956f7f1071fb = {
    createOnAllSeries: true,
    // For legend.
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        if (!seriesModel.hasSymbolVisual) return;
        // Only visible series has each data be visual encoded
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        var data = seriesModel.getData();
        function dataEach(data, idx) {
            var itemModel = data.getItemModel(idx);
            for(var i = 0; i < $f8e1f1a448782588$var$SYMBOL_PROPS.length; i++){
                var symbolPropName = $f8e1f1a448782588$var$SYMBOL_PROPS[i];
                var val = itemModel.getShallow(symbolPropName, true);
                if (val != null) data.setItemVisual(idx, symbolPropName, val);
            }
        }
        return {
            dataEach: data.hasItemOption ? dataEach : null
        };
    }
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $ea13f1ab2169d82d$export$91d919a86b2df624(data, dataIndex, key) {
    switch(key){
        case 'color':
            var style = data.getItemVisual(dataIndex, 'style');
            return style[data.getVisual('drawType')];
        case 'opacity':
            return data.getItemVisual(dataIndex, 'style').opacity;
        case 'symbol':
        case 'symbolSize':
        case 'liftZ':
            return data.getItemVisual(dataIndex, key);
        default:
    }
}
function $ea13f1ab2169d82d$export$d76e333a86ea1a2(data, key) {
    switch(key){
        case 'color':
            var style = data.getVisual('style');
            return style[data.getVisual('drawType')];
        case 'opacity':
            return data.getVisual('style').opacity;
        case 'symbol':
        case 'symbolSize':
        case 'liftZ':
            return data.getVisual(key);
        default:
    }
}
function $ea13f1ab2169d82d$export$3aab879e9d0e7c75(data, dataIndex, key, value) {
    switch(key){
        case 'color':
            // Make sure not sharing style object.
            var style = data.ensureUniqueItemVisual(dataIndex, 'style');
            style[data.getVisual('drawType')] = value;
            // Mark the color has been changed, not from palette anymore
            data.setItemVisual(dataIndex, 'colorFromPalette', false);
            break;
        case 'opacity':
            data.ensureUniqueItemVisual(dataIndex, 'style').opacity = value;
            break;
        case 'symbol':
        case 'symbolSize':
        case 'liftZ':
            data.setItemVisual(dataIndex, key, value);
            break;
        default:
    }
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $e855ccf7eff48bce$export$62942ba95693dbfc(seriesType, ecRegisterAction) {
    function getSeriesIndices(ecModel, payload) {
        var seriesIndices = [];
        ecModel.eachComponent({
            mainType: 'series',
            subType: seriesType,
            query: payload
        }, function(seriesModel) {
            seriesIndices.push(seriesModel.seriesIndex);
        });
        return seriesIndices;
    }
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
        [
            seriesType + 'ToggleSelect',
            'toggleSelect'
        ],
        [
            seriesType + 'Select',
            'select'
        ],
        [
            seriesType + 'UnSelect',
            'unselect'
        ]
    ], function(eventsMap) {
        ecRegisterAction(eventsMap[0], function(payload, ecModel, api) {
            payload = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, payload);
            api.dispatchAction((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(payload, {
                type: eventsMap[1],
                seriesIndex: getSeriesIndices(ecModel, payload)
            }));
        });
    });
}
function $e855ccf7eff48bce$var$handleSeriesLegacySelectEvents(type, eventPostfix, ecIns, ecModel, payload) {
    var legacyEventName = type + eventPostfix;
    if (!ecIns.isSilent(legacyEventName)) ecModel.eachComponent({
        mainType: 'series',
        subType: 'pie'
    }, function(seriesModel) {
        var seriesIndex = seriesModel.seriesIndex;
        var selectedMap = seriesModel.option.selectedMap;
        var selected = payload.selected;
        for(var i = 0; i < selected.length; i++)if (selected[i].seriesIndex === seriesIndex) {
            var data = seriesModel.getData();
            var dataIndex = (0, $76d619f648247e6d$export$42b26cae8b8d10)(data, payload.fromActionPayload);
            ecIns.trigger(legacyEventName, {
                type: legacyEventName,
                seriesId: seriesModel.id,
                name: (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(dataIndex) ? data.getName(dataIndex[0]) : data.getName(dataIndex),
                selected: (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(selectedMap) ? selectedMap : (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, selectedMap)
            });
        }
    });
}
function $e855ccf7eff48bce$export$2575c83262e49d0c(messageCenter, ecIns, api) {
    messageCenter.on('selectchanged', function(params) {
        var ecModel = api.getModel();
        if (params.isFromClick) {
            $e855ccf7eff48bce$var$handleSeriesLegacySelectEvents('map', 'selectchanged', ecIns, ecModel, params);
            $e855ccf7eff48bce$var$handleSeriesLegacySelectEvents('pie', 'selectchanged', ecIns, ecModel, params);
        } else if (params.fromAction === 'select') {
            $e855ccf7eff48bce$var$handleSeriesLegacySelectEvents('map', 'selected', ecIns, ecModel, params);
            $e855ccf7eff48bce$var$handleSeriesLegacySelectEvents('pie', 'selected', ecIns, ecModel, params);
        } else if (params.fromAction === 'unselect') {
            $e855ccf7eff48bce$var$handleSeriesLegacySelectEvents('map', 'unselected', ecIns, ecModel, params);
            $e855ccf7eff48bce$var$handleSeriesLegacySelectEvents('pie', 'unselected', ecIns, ecModel, params);
        }
    });
}




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $808c5a2823518f68$export$8a4fca9e04eb4df6(target, det, returnFirstMatch) {
    var found;
    while(target){
        if (det(target)) {
            found = target;
            if (returnFirstMatch) break;
        }
        target = target.__hostTarget || target.parent;
    }
    return found;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $56aadf5b08ec1b47$var$wmUniqueIndex = Math.round(Math.random() * 9);
var $56aadf5b08ec1b47$var$supportDefineProperty = typeof Object.defineProperty === 'function';
var $56aadf5b08ec1b47$var$WeakMap = function() {
    function WeakMap() {
        this._id = '__ec_inner_' + $56aadf5b08ec1b47$var$wmUniqueIndex++;
    }
    WeakMap.prototype.get = function(key) {
        return this._guard(key)[this._id];
    };
    WeakMap.prototype.set = function(key, value) {
        var target = this._guard(key);
        if ($56aadf5b08ec1b47$var$supportDefineProperty) Object.defineProperty(target, this._id, {
            value: value,
            enumerable: false,
            configurable: true
        });
        else target[this._id] = value;
        return this;
    };
    WeakMap.prototype["delete"] = function(key) {
        if (this.has(key)) {
            delete this._guard(key)[this._id];
            return true;
        }
        return false;
    };
    WeakMap.prototype.has = function(key) {
        return !!this._guard(key)[this._id];
    };
    WeakMap.prototype._guard = function(key) {
        if (key !== Object(key)) throw TypeError('Value of WeakMap is not a non-null object.');
        return key;
    };
    return WeakMap;
}();
var $56aadf5b08ec1b47$export$2e2bcd8739ae039 = $56aadf5b08ec1b47$var$WeakMap;





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Symbol factory





/**
 * Triangle shape
 * @inner
 */ var $5370466dadc978d7$var$Triangle = $b02ffe7acd508c08$export$2e2bcd8739ae039.extend({
    type: 'triangle',
    shape: {
        cx: 0,
        cy: 0,
        width: 0,
        height: 0
    },
    buildPath: function(path, shape) {
        var cx = shape.cx;
        var cy = shape.cy;
        var width = shape.width / 2;
        var height = shape.height / 2;
        path.moveTo(cx, cy - height);
        path.lineTo(cx + width, cy + height);
        path.lineTo(cx - width, cy + height);
        path.closePath();
    }
});
/**
 * Diamond shape
 * @inner
 */ var $5370466dadc978d7$var$Diamond = $b02ffe7acd508c08$export$2e2bcd8739ae039.extend({
    type: 'diamond',
    shape: {
        cx: 0,
        cy: 0,
        width: 0,
        height: 0
    },
    buildPath: function(path, shape) {
        var cx = shape.cx;
        var cy = shape.cy;
        var width = shape.width / 2;
        var height = shape.height / 2;
        path.moveTo(cx, cy - height);
        path.lineTo(cx + width, cy);
        path.lineTo(cx, cy + height);
        path.lineTo(cx - width, cy);
        path.closePath();
    }
});
/**
 * Pin shape
 * @inner
 */ var $5370466dadc978d7$var$Pin = $b02ffe7acd508c08$export$2e2bcd8739ae039.extend({
    type: 'pin',
    shape: {
        // x, y on the cusp
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    buildPath: function(path, shape) {
        var x = shape.x;
        var y = shape.y;
        var w = shape.width / 5 * 3;
        // Height must be larger than width
        var h = Math.max(w, shape.height);
        var r = w / 2;
        // Dist on y with tangent point and circle center
        var dy = r * r / (h - r);
        var cy = y - h + r + dy;
        var angle = Math.asin(dy / r);
        // Dist on x with tangent point and circle center
        var dx = Math.cos(angle) * r;
        var tanX = Math.sin(angle);
        var tanY = Math.cos(angle);
        var cpLen = r * 0.6;
        var cpLen2 = r * 0.7;
        path.moveTo(x - dx, cy + dy);
        path.arc(x, cy, r, Math.PI - angle, Math.PI * 2 + angle);
        path.bezierCurveTo(x + dx - tanX * cpLen, cy + dy + tanY * cpLen, x, y - cpLen2, x, y);
        path.bezierCurveTo(x, y - cpLen2, x - dx + tanX * cpLen, cy + dy + tanY * cpLen, x - dx, cy + dy);
        path.closePath();
    }
});
/**
 * Arrow shape
 * @inner
 */ var $5370466dadc978d7$var$Arrow = $b02ffe7acd508c08$export$2e2bcd8739ae039.extend({
    type: 'arrow',
    shape: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    buildPath: function(ctx, shape) {
        var height = shape.height;
        var width = shape.width;
        var x = shape.x;
        var y = shape.y;
        var dx = width / 3 * 2;
        ctx.moveTo(x, y);
        ctx.lineTo(x + dx, y + height);
        ctx.lineTo(x, y + height / 4 * 3);
        ctx.lineTo(x - dx, y + height);
        ctx.lineTo(x, y);
        ctx.closePath();
    }
});
/**
 * Map of path constructors
 */ // TODO Use function to build symbol path.
var $5370466dadc978d7$var$symbolCtors = {
    line: $7a316ae5ceff7b27$export$2e2bcd8739ae039,
    rect: $419e5ff2f303755e$export$2e2bcd8739ae039,
    roundRect: $419e5ff2f303755e$export$2e2bcd8739ae039,
    square: $419e5ff2f303755e$export$2e2bcd8739ae039,
    circle: $1e68d8727773abb7$export$2e2bcd8739ae039,
    diamond: $5370466dadc978d7$var$Diamond,
    pin: $5370466dadc978d7$var$Pin,
    arrow: $5370466dadc978d7$var$Arrow,
    triangle: $5370466dadc978d7$var$Triangle
};
var $5370466dadc978d7$var$symbolShapeMakers = {
    line: function(x, y, w, h, shape) {
        shape.x1 = x;
        shape.y1 = y + h / 2;
        shape.x2 = x + w;
        shape.y2 = y + h / 2;
    },
    rect: function(x, y, w, h, shape) {
        shape.x = x;
        shape.y = y;
        shape.width = w;
        shape.height = h;
    },
    roundRect: function(x, y, w, h, shape) {
        shape.x = x;
        shape.y = y;
        shape.width = w;
        shape.height = h;
        shape.r = Math.min(w, h) / 4;
    },
    square: function(x, y, w, h, shape) {
        var size = Math.min(w, h);
        shape.x = x;
        shape.y = y;
        shape.width = size;
        shape.height = size;
    },
    circle: function(x, y, w, h, shape) {
        // Put circle in the center of square
        shape.cx = x + w / 2;
        shape.cy = y + h / 2;
        shape.r = Math.min(w, h) / 2;
    },
    diamond: function(x, y, w, h, shape) {
        shape.cx = x + w / 2;
        shape.cy = y + h / 2;
        shape.width = w;
        shape.height = h;
    },
    pin: function(x, y, w, h, shape) {
        shape.x = x + w / 2;
        shape.y = y + h / 2;
        shape.width = w;
        shape.height = h;
    },
    arrow: function(x, y, w, h, shape) {
        shape.x = x + w / 2;
        shape.y = y + h / 2;
        shape.width = w;
        shape.height = h;
    },
    triangle: function(x, y, w, h, shape) {
        shape.cx = x + w / 2;
        shape.cy = y + h / 2;
        shape.width = w;
        shape.height = h;
    }
};
var $5370466dadc978d7$export$33fc3b478d332725 = {};
(0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($5370466dadc978d7$var$symbolCtors, function(Ctor, name) {
    $5370466dadc978d7$export$33fc3b478d332725[name] = new Ctor();
});
var $5370466dadc978d7$var$SymbolClz = $b02ffe7acd508c08$export$2e2bcd8739ae039.extend({
    type: 'symbol',
    shape: {
        symbolType: '',
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    calculateTextPosition: function(out, config, rect) {
        var res = (0, $6c308355c7107803$export$eee3603b512feab7)(out, config, rect);
        var shape = this.shape;
        if (shape && shape.symbolType === 'pin' && config.position === 'inside') res.y = rect.y + rect.height * 0.4;
        return res;
    },
    buildPath: function(ctx, shape, inBundle) {
        var symbolType = shape.symbolType;
        if (symbolType !== 'none') {
            var proxySymbol = $5370466dadc978d7$export$33fc3b478d332725[symbolType];
            if (!proxySymbol) {
                // Default rect
                symbolType = 'rect';
                proxySymbol = $5370466dadc978d7$export$33fc3b478d332725[symbolType];
            }
            $5370466dadc978d7$var$symbolShapeMakers[symbolType](shape.x, shape.y, shape.width, shape.height, proxySymbol.shape);
            proxySymbol.buildPath(ctx, proxySymbol.shape, inBundle);
        }
    }
});
// Provide setColor helper method to avoid determine if set the fill or stroke outside
function $5370466dadc978d7$var$symbolPathSetColor(color, innerColor) {
    if (this.type !== 'image') {
        var symbolStyle = this.style;
        if (this.__isEmptyBrush) {
            symbolStyle.stroke = color;
            symbolStyle.fill = innerColor || '#fff';
            // TODO Same width with lineStyle in LineView
            symbolStyle.lineWidth = 2;
        } else if (this.shape.symbolType === 'line') symbolStyle.stroke = color;
        else symbolStyle.fill = color;
        this.markRedraw();
    }
}
function $5370466dadc978d7$export$af050e04da3a02e8(symbolType, x, y, w, h, color, // whether to keep the ratio of w/h,
keepAspect) {
    // TODO Support image object, DynamicImage.
    var isEmpty = symbolType.indexOf('empty') === 0;
    if (isEmpty) symbolType = symbolType.substr(5, 1).toLowerCase() + symbolType.substr(6);
    var symbolPath;
    if (symbolType.indexOf('image://') === 0) symbolPath = $5b455ae6f843ac47$export$7a2bdede98851ac5(symbolType.slice(8), new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(x, y, w, h), keepAspect ? 'center' : 'cover');
    else if (symbolType.indexOf('path://') === 0) symbolPath = $5b455ae6f843ac47$export$aa9bab72412f5613(symbolType.slice(7), {}, new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(x, y, w, h), keepAspect ? 'center' : 'cover');
    else symbolPath = new $5370466dadc978d7$var$SymbolClz({
        shape: {
            symbolType: symbolType,
            x: x,
            y: y,
            width: w,
            height: h
        }
    });
    symbolPath.__isEmptyBrush = isEmpty;
    // TODO Should deprecate setColor
    symbolPath.setColor = $5370466dadc978d7$var$symbolPathSetColor;
    if (color) symbolPath.setColor(color);
    return symbolPath;
}
function $5370466dadc978d7$export$a84524f03e8e8dfb(symbolSize) {
    if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(symbolSize)) symbolSize = [
        +symbolSize,
        +symbolSize
    ];
    return [
        symbolSize[0] || 0,
        symbolSize[1] || 0
    ];
}
function $5370466dadc978d7$export$e3e292895c033f6d(symbolOffset, symbolSize) {
    if (symbolOffset == null) return;
    if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(symbolOffset)) symbolOffset = [
        symbolOffset,
        symbolOffset
    ];
    return [
        (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(symbolOffset[0], symbolSize[0]) || 0,
        (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)((0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(symbolOffset[1], symbolOffset[0]), symbolSize[1]) || 0
    ];
}





function $d76b6507633b3c44$var$isSafeNum(num) {
    return isFinite(num);
}
function $d76b6507633b3c44$export$235c7ac50fe1db0a(ctx, obj, rect) {
    var x = obj.x == null ? 0 : obj.x;
    var x2 = obj.x2 == null ? 1 : obj.x2;
    var y = obj.y == null ? 0 : obj.y;
    var y2 = obj.y2 == null ? 0 : obj.y2;
    if (!obj.global) {
        x = x * rect.width + rect.x;
        x2 = x2 * rect.width + rect.x;
        y = y * rect.height + rect.y;
        y2 = y2 * rect.height + rect.y;
    }
    x = $d76b6507633b3c44$var$isSafeNum(x) ? x : 0;
    x2 = $d76b6507633b3c44$var$isSafeNum(x2) ? x2 : 1;
    y = $d76b6507633b3c44$var$isSafeNum(y) ? y : 0;
    y2 = $d76b6507633b3c44$var$isSafeNum(y2) ? y2 : 0;
    var canvasGradient = ctx.createLinearGradient(x, y, x2, y2);
    return canvasGradient;
}
function $d76b6507633b3c44$export$57f098206d57a443(ctx, obj, rect) {
    var width = rect.width;
    var height = rect.height;
    var min = Math.min(width, height);
    var x = obj.x == null ? 0.5 : obj.x;
    var y = obj.y == null ? 0.5 : obj.y;
    var r = obj.r == null ? 0.5 : obj.r;
    if (!obj.global) {
        x = x * width + rect.x;
        y = y * height + rect.y;
        r = r * min;
    }
    x = $d76b6507633b3c44$var$isSafeNum(x) ? x : 0.5;
    y = $d76b6507633b3c44$var$isSafeNum(y) ? y : 0.5;
    r = r >= 0 && $d76b6507633b3c44$var$isSafeNum(r) ? r : 0.5;
    var canvasGradient = ctx.createRadialGradient(x, y, 0, x, y, r);
    return canvasGradient;
}
function $d76b6507633b3c44$export$3dab6afd018d48c7(ctx, obj, rect) {
    var canvasGradient = obj.type === 'radial' ? $d76b6507633b3c44$export$57f098206d57a443(ctx, obj, rect) : $d76b6507633b3c44$export$235c7ac50fe1db0a(ctx, obj, rect);
    var colorStops = obj.colorStops;
    for(var i = 0; i < colorStops.length; i++)canvasGradient.addColorStop(colorStops[i].offset, colorStops[i].color);
    return canvasGradient;
}
function $d76b6507633b3c44$export$beeddc5150cb2e83(clipPaths, prevClipPaths) {
    if (clipPaths === prevClipPaths || !clipPaths && !prevClipPaths) return false;
    if (!clipPaths || !prevClipPaths || clipPaths.length !== prevClipPaths.length) return true;
    for(var i = 0; i < clipPaths.length; i++){
        if (clipPaths[i] !== prevClipPaths[i]) return true;
    }
    return false;
}
function $d76b6507633b3c44$var$parseInt10(val) {
    return parseInt(val, 10);
}
function $d76b6507633b3c44$export$31b21d0167753bb4(root, whIdx, opts) {
    var wh = [
        'width',
        'height'
    ][whIdx];
    var cwh = [
        'clientWidth',
        'clientHeight'
    ][whIdx];
    var plt = [
        'paddingLeft',
        'paddingTop'
    ][whIdx];
    var prb = [
        'paddingRight',
        'paddingBottom'
    ][whIdx];
    if (opts[wh] != null && opts[wh] !== 'auto') return parseFloat(opts[wh]);
    var stl = document.defaultView.getComputedStyle(root);
    return (root[cwh] || $d76b6507633b3c44$var$parseInt10(stl[wh]) || $d76b6507633b3c44$var$parseInt10(root.style[wh])) - ($d76b6507633b3c44$var$parseInt10(stl[plt]) || 0) - ($d76b6507633b3c44$var$parseInt10(stl[prb]) || 0) | 0;
}







function $21ab8baf7c1f083c$export$9efb2ae8a603855d(lineType, lineWidth) {
    if (!lineType || lineType === 'solid' || !(lineWidth > 0)) return null;
    return lineType === 'dashed' ? [
        4 * lineWidth,
        2 * lineWidth
    ] : lineType === 'dotted' ? [
        lineWidth
    ] : (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(lineType) ? [
        lineType
    ] : (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(lineType) ? lineType : null;
}
function $21ab8baf7c1f083c$export$9d315911f153b3b2(el) {
    var style = el.style;
    var lineDash = style.lineDash && style.lineWidth > 0 && $21ab8baf7c1f083c$export$9efb2ae8a603855d(style.lineDash, style.lineWidth);
    var lineDashOffset = style.lineDashOffset;
    if (lineDash) {
        var lineScale_1 = style.strokeNoScale && el.getLineScale ? el.getLineScale() : 1;
        if (lineScale_1 && lineScale_1 !== 1) {
            lineDash = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(lineDash, function(rawVal) {
                return rawVal / lineScale_1;
            });
            lineDashOffset /= lineScale_1;
        }
    }
    return [
        lineDash,
        lineDashOffset
    ];
}




var $4f71e35e4552e3dd$var$pathProxyForDraw = new (0, $20ebe2448f123f2e$export$2e2bcd8739ae039)(true);
function $4f71e35e4552e3dd$var$styleHasStroke(style) {
    var stroke = style.stroke;
    return !(stroke == null || stroke === 'none' || !(style.lineWidth > 0));
}
function $4f71e35e4552e3dd$var$isValidStrokeFillStyle(strokeOrFill) {
    return typeof strokeOrFill === 'string' && strokeOrFill !== 'none';
}
function $4f71e35e4552e3dd$var$styleHasFill(style) {
    var fill = style.fill;
    return fill != null && fill !== 'none';
}
function $4f71e35e4552e3dd$var$doFillPath(ctx, style) {
    if (style.fillOpacity != null && style.fillOpacity !== 1) {
        var originalGlobalAlpha = ctx.globalAlpha;
        ctx.globalAlpha = style.fillOpacity * style.opacity;
        ctx.fill();
        ctx.globalAlpha = originalGlobalAlpha;
    } else ctx.fill();
}
function $4f71e35e4552e3dd$var$doStrokePath(ctx, style) {
    if (style.strokeOpacity != null && style.strokeOpacity !== 1) {
        var originalGlobalAlpha = ctx.globalAlpha;
        ctx.globalAlpha = style.strokeOpacity * style.opacity;
        ctx.stroke();
        ctx.globalAlpha = originalGlobalAlpha;
    } else ctx.stroke();
}
function $4f71e35e4552e3dd$export$8eb5db6b7bc27903(ctx, pattern, el) {
    var image = (0, $a53bd598adfb7ebe$export$46c791b69ff9a0f)(pattern.image, pattern.__image, el);
    if ((0, $a53bd598adfb7ebe$export$37ca7dd901d0236d)(image)) {
        var canvasPattern = ctx.createPattern(image, pattern.repeat || 'repeat');
        if (typeof DOMMatrix === 'function' && canvasPattern && canvasPattern.setTransform) {
            var matrix = new DOMMatrix();
            matrix.translateSelf(pattern.x || 0, pattern.y || 0);
            matrix.rotateSelf(0, 0, (pattern.rotation || 0) * (0, $7a1bd9c2710fea0d$export$bce8e055322a0ce6));
            matrix.scaleSelf(pattern.scaleX || 1, pattern.scaleY || 1);
            canvasPattern.setTransform(matrix);
        }
        return canvasPattern;
    }
}
function $4f71e35e4552e3dd$var$brushPath(ctx, el, style, inBatch) {
    var _a;
    var hasStroke = $4f71e35e4552e3dd$var$styleHasStroke(style);
    var hasFill = $4f71e35e4552e3dd$var$styleHasFill(style);
    var strokePercent = style.strokePercent;
    var strokePart = strokePercent < 1;
    var firstDraw = !el.path;
    if ((!el.silent || strokePart) && firstDraw) el.createPathProxy();
    var path = el.path || $4f71e35e4552e3dd$var$pathProxyForDraw;
    var dirtyFlag = el.__dirty;
    if (!inBatch) {
        var fill = style.fill;
        var stroke = style.stroke;
        var hasFillGradient = hasFill && !!fill.colorStops;
        var hasStrokeGradient = hasStroke && !!stroke.colorStops;
        var hasFillPattern = hasFill && !!fill.image;
        var hasStrokePattern = hasStroke && !!stroke.image;
        var fillGradient = void 0;
        var strokeGradient = void 0;
        var fillPattern = void 0;
        var strokePattern = void 0;
        var rect = void 0;
        if (hasFillGradient || hasStrokeGradient) rect = el.getBoundingRect();
        if (hasFillGradient) {
            fillGradient = dirtyFlag ? (0, $d76b6507633b3c44$export$3dab6afd018d48c7)(ctx, fill, rect) : el.__canvasFillGradient;
            el.__canvasFillGradient = fillGradient;
        }
        if (hasStrokeGradient) {
            strokeGradient = dirtyFlag ? (0, $d76b6507633b3c44$export$3dab6afd018d48c7)(ctx, stroke, rect) : el.__canvasStrokeGradient;
            el.__canvasStrokeGradient = strokeGradient;
        }
        if (hasFillPattern) {
            fillPattern = dirtyFlag || !el.__canvasFillPattern ? $4f71e35e4552e3dd$export$8eb5db6b7bc27903(ctx, fill, el) : el.__canvasFillPattern;
            el.__canvasFillPattern = fillPattern;
        }
        if (hasStrokePattern) {
            strokePattern = dirtyFlag || !el.__canvasStrokePattern ? $4f71e35e4552e3dd$export$8eb5db6b7bc27903(ctx, stroke, el) : el.__canvasStrokePattern;
            el.__canvasStrokePattern = fillPattern;
        }
        if (hasFillGradient) ctx.fillStyle = fillGradient;
        else if (hasFillPattern) {
            if (fillPattern) ctx.fillStyle = fillPattern;
            else hasFill = false;
        }
        if (hasStrokeGradient) ctx.strokeStyle = strokeGradient;
        else if (hasStrokePattern) {
            if (strokePattern) ctx.strokeStyle = strokePattern;
            else hasStroke = false;
        }
    }
    var scale = el.getGlobalScale();
    path.setScale(scale[0], scale[1], el.segmentIgnoreThreshold);
    var lineDash;
    var lineDashOffset;
    if (ctx.setLineDash && style.lineDash) _a = (0, $21ab8baf7c1f083c$export$9d315911f153b3b2)(el), lineDash = _a[0], lineDashOffset = _a[1];
    var needsRebuild = true;
    if (firstDraw || dirtyFlag & (0, $ddf76b16f1246ba9$export$f75fe89a33ebe115)) {
        path.setDPR(ctx.dpr);
        if (strokePart) path.setContext(null);
        else {
            path.setContext(ctx);
            needsRebuild = false;
        }
        path.reset();
        el.buildPath(path, el.shape, inBatch);
        path.toStatic();
        el.pathUpdated();
    }
    if (needsRebuild) path.rebuildPath(ctx, strokePart ? strokePercent : 1);
    if (lineDash) {
        ctx.setLineDash(lineDash);
        ctx.lineDashOffset = lineDashOffset;
    }
    if (!inBatch) {
        if (style.strokeFirst) {
            if (hasStroke) $4f71e35e4552e3dd$var$doStrokePath(ctx, style);
            if (hasFill) $4f71e35e4552e3dd$var$doFillPath(ctx, style);
        } else {
            if (hasFill) $4f71e35e4552e3dd$var$doFillPath(ctx, style);
            if (hasStroke) $4f71e35e4552e3dd$var$doStrokePath(ctx, style);
        }
    }
    if (lineDash) ctx.setLineDash([]);
}
function $4f71e35e4552e3dd$var$brushImage(ctx, el, style) {
    var image = el.__image = (0, $a53bd598adfb7ebe$export$46c791b69ff9a0f)(style.image, el.__image, el, el.onload);
    if (!image || !(0, $a53bd598adfb7ebe$export$37ca7dd901d0236d)(image)) return;
    var x = style.x || 0;
    var y = style.y || 0;
    var width = el.getWidth();
    var height = el.getHeight();
    var aspect = image.width / image.height;
    if (width == null && height != null) width = height * aspect;
    else if (height == null && width != null) height = width / aspect;
    else if (width == null && height == null) {
        width = image.width;
        height = image.height;
    }
    if (style.sWidth && style.sHeight) {
        var sx = style.sx || 0;
        var sy = style.sy || 0;
        ctx.drawImage(image, sx, sy, style.sWidth, style.sHeight, x, y, width, height);
    } else if (style.sx && style.sy) {
        var sx = style.sx;
        var sy = style.sy;
        var sWidth = width - sx;
        var sHeight = height - sy;
        ctx.drawImage(image, sx, sy, sWidth, sHeight, x, y, width, height);
    } else ctx.drawImage(image, x, y, width, height);
}
function $4f71e35e4552e3dd$var$brushText(ctx, el, style) {
    var _a;
    var text = style.text;
    text != null && (text += '');
    if (text) {
        ctx.font = style.font || (0, $c6341dcc9d86826e$export$7d7a232b6d2cc80c);
        ctx.textAlign = style.textAlign;
        ctx.textBaseline = style.textBaseline;
        var lineDash = void 0;
        var lineDashOffset = void 0;
        if (ctx.setLineDash && style.lineDash) _a = (0, $21ab8baf7c1f083c$export$9d315911f153b3b2)(el), lineDash = _a[0], lineDashOffset = _a[1];
        if (lineDash) {
            ctx.setLineDash(lineDash);
            ctx.lineDashOffset = lineDashOffset;
        }
        if (style.strokeFirst) {
            if ($4f71e35e4552e3dd$var$styleHasStroke(style)) ctx.strokeText(text, style.x, style.y);
            if ($4f71e35e4552e3dd$var$styleHasFill(style)) ctx.fillText(text, style.x, style.y);
        } else {
            if ($4f71e35e4552e3dd$var$styleHasFill(style)) ctx.fillText(text, style.x, style.y);
            if ($4f71e35e4552e3dd$var$styleHasStroke(style)) ctx.strokeText(text, style.x, style.y);
        }
        if (lineDash) ctx.setLineDash([]);
    }
}
var $4f71e35e4552e3dd$var$SHADOW_NUMBER_PROPS = [
    'shadowBlur',
    'shadowOffsetX',
    'shadowOffsetY'
];
var $4f71e35e4552e3dd$var$STROKE_PROPS = [
    [
        'lineCap',
        'butt'
    ],
    [
        'lineJoin',
        'miter'
    ],
    [
        'miterLimit',
        10
    ]
];
function $4f71e35e4552e3dd$var$bindCommonProps(ctx, style, prevStyle, forceSetAll, scope) {
    var styleChanged = false;
    if (!forceSetAll) {
        prevStyle = prevStyle || {};
        if (style === prevStyle) return false;
    }
    if (forceSetAll || style.opacity !== prevStyle.opacity) {
        $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
        styleChanged = true;
        var opacity = Math.max(Math.min(style.opacity, 1), 0);
        ctx.globalAlpha = isNaN(opacity) ? (0, $56206a6cb4666931$export$737672163db00fe3).opacity : opacity;
    }
    if (forceSetAll || style.blend !== prevStyle.blend) {
        if (!styleChanged) {
            $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.globalCompositeOperation = style.blend || (0, $56206a6cb4666931$export$737672163db00fe3).blend;
    }
    for(var i = 0; i < $4f71e35e4552e3dd$var$SHADOW_NUMBER_PROPS.length; i++){
        var propName = $4f71e35e4552e3dd$var$SHADOW_NUMBER_PROPS[i];
        if (forceSetAll || style[propName] !== prevStyle[propName]) {
            if (!styleChanged) {
                $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx[propName] = ctx.dpr * (style[propName] || 0);
        }
    }
    if (forceSetAll || style.shadowColor !== prevStyle.shadowColor) {
        if (!styleChanged) {
            $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.shadowColor = style.shadowColor || (0, $56206a6cb4666931$export$737672163db00fe3).shadowColor;
    }
    return styleChanged;
}
function $4f71e35e4552e3dd$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetAll, scope) {
    var style = $4f71e35e4552e3dd$var$getStyle(el, scope.inHover);
    var prevStyle = forceSetAll ? null : prevEl && $4f71e35e4552e3dd$var$getStyle(prevEl, scope.inHover) || {};
    if (style === prevStyle) return false;
    var styleChanged = $4f71e35e4552e3dd$var$bindCommonProps(ctx, style, prevStyle, forceSetAll, scope);
    if (forceSetAll || style.fill !== prevStyle.fill) {
        if (!styleChanged) {
            $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        $4f71e35e4552e3dd$var$isValidStrokeFillStyle(style.fill) && (ctx.fillStyle = style.fill);
    }
    if (forceSetAll || style.stroke !== prevStyle.stroke) {
        if (!styleChanged) {
            $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        $4f71e35e4552e3dd$var$isValidStrokeFillStyle(style.stroke) && (ctx.strokeStyle = style.stroke);
    }
    if (forceSetAll || style.opacity !== prevStyle.opacity) {
        if (!styleChanged) {
            $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.globalAlpha = style.opacity == null ? 1 : style.opacity;
    }
    if (el.hasStroke()) {
        var lineWidth = style.lineWidth;
        var newLineWidth = lineWidth / (style.strokeNoScale && el.getLineScale ? el.getLineScale() : 1);
        if (ctx.lineWidth !== newLineWidth) {
            if (!styleChanged) {
                $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx.lineWidth = newLineWidth;
        }
    }
    for(var i = 0; i < $4f71e35e4552e3dd$var$STROKE_PROPS.length; i++){
        var prop = $4f71e35e4552e3dd$var$STROKE_PROPS[i];
        var propName = prop[0];
        if (forceSetAll || style[propName] !== prevStyle[propName]) {
            if (!styleChanged) {
                $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx[propName] = style[propName] || prop[1];
        }
    }
    return styleChanged;
}
function $4f71e35e4552e3dd$var$bindImageStyle(ctx, el, prevEl, forceSetAll, scope) {
    return $4f71e35e4552e3dd$var$bindCommonProps(ctx, $4f71e35e4552e3dd$var$getStyle(el, scope.inHover), prevEl && $4f71e35e4552e3dd$var$getStyle(prevEl, scope.inHover), forceSetAll, scope);
}
function $4f71e35e4552e3dd$var$setContextTransform(ctx, el) {
    var m = el.transform;
    var dpr = ctx.dpr || 1;
    if (m) ctx.setTransform(dpr * m[0], dpr * m[1], dpr * m[2], dpr * m[3], dpr * m[4], dpr * m[5]);
    else ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
}
function $4f71e35e4552e3dd$var$updateClipStatus(clipPaths, ctx, scope) {
    var allClipped = false;
    for(var i = 0; i < clipPaths.length; i++){
        var clipPath = clipPaths[i];
        allClipped = allClipped || clipPath.isZeroArea();
        $4f71e35e4552e3dd$var$setContextTransform(ctx, clipPath);
        ctx.beginPath();
        clipPath.buildPath(ctx, clipPath.shape);
        ctx.clip();
    }
    scope.allClipped = allClipped;
}
function $4f71e35e4552e3dd$var$isTransformChanged(m0, m1) {
    if (m0 && m1) return m0[0] !== m1[0] || m0[1] !== m1[1] || m0[2] !== m1[2] || m0[3] !== m1[3] || m0[4] !== m1[4] || m0[5] !== m1[5];
    else if (!m0 && !m1) return false;
    return true;
}
var $4f71e35e4552e3dd$var$DRAW_TYPE_PATH = 1;
var $4f71e35e4552e3dd$var$DRAW_TYPE_IMAGE = 2;
var $4f71e35e4552e3dd$var$DRAW_TYPE_TEXT = 3;
var $4f71e35e4552e3dd$var$DRAW_TYPE_INCREMENTAL = 4;
function $4f71e35e4552e3dd$var$canPathBatch(style) {
    var hasFill = $4f71e35e4552e3dd$var$styleHasFill(style);
    var hasStroke = $4f71e35e4552e3dd$var$styleHasStroke(style);
    return !(style.lineDash || !(+hasFill ^ +hasStroke) || hasFill && typeof style.fill !== 'string' || hasStroke && typeof style.stroke !== 'string' || style.strokePercent < 1 || style.strokeOpacity < 1 || style.fillOpacity < 1);
}
function $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope) {
    scope.batchFill && ctx.fill();
    scope.batchStroke && ctx.stroke();
    scope.batchFill = '';
    scope.batchStroke = '';
}
function $4f71e35e4552e3dd$var$getStyle(el, inHover) {
    return inHover ? el.__hoverStyle || el.style : el.style;
}
function $4f71e35e4552e3dd$export$567881adfc3eb7f3(ctx, el) {
    $4f71e35e4552e3dd$export$da5d6544e8c27bc1(ctx, el, {
        inHover: false,
        viewWidth: 0,
        viewHeight: 0
    }, true);
}
function $4f71e35e4552e3dd$export$da5d6544e8c27bc1(ctx, el, scope, isLast) {
    var m = el.transform;
    if (!el.shouldBePainted(scope.viewWidth, scope.viewHeight, false, false)) {
        el.__dirty &= ~(0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd);
        el.__isRendered = false;
        return;
    }
    var clipPaths = el.__clipPaths;
    var prevElClipPaths = scope.prevElClipPaths;
    var forceSetTransform = false;
    var forceSetStyle = false;
    if (!prevElClipPaths || (0, $d76b6507633b3c44$export$beeddc5150cb2e83)(clipPaths, prevElClipPaths)) {
        if (prevElClipPaths && prevElClipPaths.length) {
            $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
            ctx.restore();
            forceSetStyle = forceSetTransform = true;
            scope.prevElClipPaths = null;
            scope.allClipped = false;
            scope.prevEl = null;
        }
        if (clipPaths && clipPaths.length) {
            $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
            ctx.save();
            $4f71e35e4552e3dd$var$updateClipStatus(clipPaths, ctx, scope);
            forceSetTransform = true;
        }
        scope.prevElClipPaths = clipPaths;
    }
    if (scope.allClipped) {
        el.__isRendered = false;
        return;
    }
    el.beforeBrush && el.beforeBrush();
    el.innerBeforeBrush();
    var prevEl = scope.prevEl;
    if (!prevEl) forceSetStyle = forceSetTransform = true;
    var canBatchPath = el instanceof (0, $b02ffe7acd508c08$export$2e2bcd8739ae039) && el.autoBatch && $4f71e35e4552e3dd$var$canPathBatch(el.style);
    if (forceSetTransform || $4f71e35e4552e3dd$var$isTransformChanged(m, prevEl.transform)) {
        $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
        $4f71e35e4552e3dd$var$setContextTransform(ctx, el);
    } else if (!canBatchPath) $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
    var style = $4f71e35e4552e3dd$var$getStyle(el, scope.inHover);
    if (el instanceof (0, $b02ffe7acd508c08$export$2e2bcd8739ae039)) {
        if (scope.lastDrawType !== $4f71e35e4552e3dd$var$DRAW_TYPE_PATH) {
            forceSetStyle = true;
            scope.lastDrawType = $4f71e35e4552e3dd$var$DRAW_TYPE_PATH;
        }
        $4f71e35e4552e3dd$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetStyle, scope);
        if (!canBatchPath || !scope.batchFill && !scope.batchStroke) ctx.beginPath();
        $4f71e35e4552e3dd$var$brushPath(ctx, el, style, canBatchPath);
        if (canBatchPath) {
            scope.batchFill = style.fill || '';
            scope.batchStroke = style.stroke || '';
        }
    } else {
        if (el instanceof (0, $c9d5c769fe2f591f$export$2e2bcd8739ae039)) {
            if (scope.lastDrawType !== $4f71e35e4552e3dd$var$DRAW_TYPE_TEXT) {
                forceSetStyle = true;
                scope.lastDrawType = $4f71e35e4552e3dd$var$DRAW_TYPE_TEXT;
            }
            $4f71e35e4552e3dd$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetStyle, scope);
            $4f71e35e4552e3dd$var$brushText(ctx, el, style);
        } else if (el instanceof (0, $86adec94217b86c6$export$2e2bcd8739ae039)) {
            if (scope.lastDrawType !== $4f71e35e4552e3dd$var$DRAW_TYPE_IMAGE) {
                forceSetStyle = true;
                scope.lastDrawType = $4f71e35e4552e3dd$var$DRAW_TYPE_IMAGE;
            }
            $4f71e35e4552e3dd$var$bindImageStyle(ctx, el, prevEl, forceSetStyle, scope);
            $4f71e35e4552e3dd$var$brushImage(ctx, el, style);
        } else if (el.getTemporalDisplayables) {
            if (scope.lastDrawType !== $4f71e35e4552e3dd$var$DRAW_TYPE_INCREMENTAL) {
                forceSetStyle = true;
                scope.lastDrawType = $4f71e35e4552e3dd$var$DRAW_TYPE_INCREMENTAL;
            }
            $4f71e35e4552e3dd$var$brushIncremental(ctx, el, scope);
        }
    }
    if (canBatchPath && isLast) $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
    el.innerAfterBrush();
    el.afterBrush && el.afterBrush();
    scope.prevEl = el;
    el.__dirty = 0;
    el.__isRendered = true;
}
function $4f71e35e4552e3dd$var$brushIncremental(ctx, el, scope) {
    var displayables = el.getDisplayables();
    var temporalDisplayables = el.getTemporalDisplayables();
    ctx.save();
    var innerScope = {
        prevElClipPaths: null,
        prevEl: null,
        allClipped: false,
        viewWidth: scope.viewWidth,
        viewHeight: scope.viewHeight,
        inHover: scope.inHover
    };
    var i;
    var len;
    for(i = el.getCursor(), len = displayables.length; i < len; i++){
        var displayable = displayables[i];
        displayable.beforeBrush && displayable.beforeBrush();
        displayable.innerBeforeBrush();
        $4f71e35e4552e3dd$export$da5d6544e8c27bc1(ctx, displayable, innerScope, i === len - 1);
        displayable.innerAfterBrush();
        displayable.afterBrush && displayable.afterBrush();
        innerScope.prevEl = displayable;
    }
    for(var i_1 = 0, len_1 = temporalDisplayables.length; i_1 < len_1; i_1++){
        var displayable = temporalDisplayables[i_1];
        displayable.beforeBrush && displayable.beforeBrush();
        displayable.innerBeforeBrush();
        $4f71e35e4552e3dd$export$da5d6544e8c27bc1(ctx, displayable, innerScope, i_1 === len_1 - 1);
        displayable.innerAfterBrush();
        displayable.afterBrush && displayable.afterBrush();
        innerScope.prevEl = displayable;
    }
    el.clearTemporalDisplayables();
    el.notClear = true;
    ctx.restore();
}



var $c6d646aacd243427$var$decalMap = new (0, $56aadf5b08ec1b47$export$2e2bcd8739ae039)();
var $c6d646aacd243427$var$decalCache = new (0, $d91b0b6fc564d9c7$export$2e2bcd8739ae039)(100);
var $c6d646aacd243427$var$decalKeys = [
    'symbol',
    'symbolSize',
    'symbolKeepAspect',
    'color',
    'backgroundColor',
    'dashArrayX',
    'dashArrayY',
    'maxTileWidth',
    'maxTileHeight'
];
function $c6d646aacd243427$export$a3ba048e1a648972(decalObject, api) {
    if (decalObject === 'none') return null;
    var dpr = api.getDevicePixelRatio();
    var zr = api.getZr();
    var isSVG = zr.painter.type === 'svg';
    if (decalObject.dirty) $c6d646aacd243427$var$decalMap["delete"](decalObject);
    var oldPattern = $c6d646aacd243427$var$decalMap.get(decalObject);
    if (oldPattern) return oldPattern;
    var decalOpt = (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(decalObject, {
        symbol: 'rect',
        symbolSize: 1,
        symbolKeepAspect: true,
        color: 'rgba(0, 0, 0, 0.2)',
        backgroundColor: null,
        dashArrayX: 5,
        dashArrayY: 5,
        rotation: 0,
        maxTileWidth: 512,
        maxTileHeight: 512
    });
    if (decalOpt.backgroundColor === 'none') decalOpt.backgroundColor = null;
    var pattern = {
        repeat: 'repeat'
    };
    setPatternnSource(pattern);
    pattern.rotation = decalOpt.rotation;
    pattern.scaleX = pattern.scaleY = isSVG ? 1 : 1 / dpr;
    $c6d646aacd243427$var$decalMap.set(decalObject, pattern);
    decalObject.dirty = false;
    return pattern;
    function setPatternnSource(pattern) {
        var keys = [
            dpr
        ];
        var isValidKey = true;
        for(var i = 0; i < $c6d646aacd243427$var$decalKeys.length; ++i){
            var value = decalOpt[$c6d646aacd243427$var$decalKeys[i]];
            if (value != null && !(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(value) && !(0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(value) && !(0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(value) && typeof value !== 'boolean') {
                isValidKey = false;
                break;
            }
            keys.push(value);
        }
        var cacheKey;
        if (isValidKey) {
            cacheKey = keys.join(',') + (isSVG ? '-svg' : '');
            var cache = $c6d646aacd243427$var$decalCache.get(cacheKey);
            if (cache) isSVG ? pattern.svgElement = cache : pattern.image = cache;
        }
        var dashArrayX = $c6d646aacd243427$var$normalizeDashArrayX(decalOpt.dashArrayX);
        var dashArrayY = $c6d646aacd243427$var$normalizeDashArrayY(decalOpt.dashArrayY);
        var symbolArray = $c6d646aacd243427$var$normalizeSymbolArray(decalOpt.symbol);
        var lineBlockLengthsX = $c6d646aacd243427$var$getLineBlockLengthX(dashArrayX);
        var lineBlockLengthY = $c6d646aacd243427$var$getLineBlockLengthY(dashArrayY);
        var canvas = !isSVG && (0, $c6341dcc9d86826e$export$ef5e599365494451).createCanvas();
        var svgRoot = isSVG && {
            tag: 'g',
            attrs: {},
            key: 'dcl',
            children: []
        };
        var pSize = getPatternSize();
        var ctx;
        if (canvas) {
            canvas.width = pSize.width * dpr;
            canvas.height = pSize.height * dpr;
            ctx = canvas.getContext('2d');
        }
        brushDecal();
        if (isValidKey) $c6d646aacd243427$var$decalCache.put(cacheKey, canvas || svgRoot);
        pattern.image = canvas;
        pattern.svgElement = svgRoot;
        pattern.svgWidth = pSize.width;
        pattern.svgHeight = pSize.height;
        /**
     * Get minimum length that can make a repeatable pattern.
     *
     * @return {Object} pattern width and height
     */ function getPatternSize() {
            /**
       * For example, if dash is [[3, 2], [2, 1]] for X, it looks like
       * |---  ---  ---  ---  --- ...
       * |-- -- -- -- -- -- -- -- ...
       * |---  ---  ---  ---  --- ...
       * |-- -- -- -- -- -- -- -- ...
       * So the minimum length of X is 15,
       * which is the least common multiple of `3 + 2` and `2 + 1`
       * |---  ---  ---  |---  --- ...
       * |-- -- -- -- -- |-- -- -- ...
       */ var width = 1;
            for(var i = 0, xlen = lineBlockLengthsX.length; i < xlen; ++i)width = (0, $cfc1f3b422a3185f$export$680a45b749323f49)(width, lineBlockLengthsX[i]);
            var symbolRepeats = 1;
            for(var i = 0, xlen = symbolArray.length; i < xlen; ++i)symbolRepeats = (0, $cfc1f3b422a3185f$export$680a45b749323f49)(symbolRepeats, symbolArray[i].length);
            width *= symbolRepeats;
            var height = lineBlockLengthY * lineBlockLengthsX.length * symbolArray.length;
            var warn;
            return {
                width: Math.max(1, Math.min(width, decalOpt.maxTileWidth)),
                height: Math.max(1, Math.min(height, decalOpt.maxTileHeight))
            };
        }
        function brushDecal() {
            if (ctx) {
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                if (decalOpt.backgroundColor) {
                    ctx.fillStyle = decalOpt.backgroundColor;
                    ctx.fillRect(0, 0, canvas.width, canvas.height);
                }
            }
            var ySum = 0;
            for(var i = 0; i < dashArrayY.length; ++i)ySum += dashArrayY[i];
            if (ySum <= 0) // dashArrayY is 0, draw nothing
            return;
            var y = -lineBlockLengthY;
            var yId = 0;
            var yIdTotal = 0;
            var xId0 = 0;
            while(y < pSize.height){
                if (yId % 2 === 0) {
                    var symbolYId = yIdTotal / 2 % symbolArray.length;
                    var x = 0;
                    var xId1 = 0;
                    var xId1Total = 0;
                    while(x < pSize.width * 2){
                        var xSum = 0;
                        for(var i = 0; i < dashArrayX[xId0].length; ++i)xSum += dashArrayX[xId0][i];
                        if (xSum <= 0) break;
                        // E.g., [15, 5, 20, 5] draws only for 15 and 20
                        if (xId1 % 2 === 0) {
                            var size = (1 - decalOpt.symbolSize) * 0.5;
                            var left = x + dashArrayX[xId0][xId1] * size;
                            var top_1 = y + dashArrayY[yId] * size;
                            var width = dashArrayX[xId0][xId1] * decalOpt.symbolSize;
                            var height = dashArrayY[yId] * decalOpt.symbolSize;
                            var symbolXId = xId1Total / 2 % symbolArray[symbolYId].length;
                            brushSymbol(left, top_1, width, height, symbolArray[symbolYId][symbolXId]);
                        }
                        x += dashArrayX[xId0][xId1];
                        ++xId1Total;
                        ++xId1;
                        if (xId1 === dashArrayX[xId0].length) xId1 = 0;
                    }
                    ++xId0;
                    if (xId0 === dashArrayX.length) xId0 = 0;
                }
                y += dashArrayY[yId];
                ++yIdTotal;
                ++yId;
                if (yId === dashArrayY.length) yId = 0;
            }
            function brushSymbol(x, y, width, height, symbolType) {
                var scale = isSVG ? 1 : dpr;
                var symbol = (0, $5370466dadc978d7$export$af050e04da3a02e8)(symbolType, x * scale, y * scale, width * scale, height * scale, decalOpt.color, decalOpt.symbolKeepAspect);
                if (isSVG) {
                    var symbolVNode = zr.painter.renderOneToVNode(symbol);
                    if (symbolVNode) svgRoot.children.push(symbolVNode);
                } else // Paint to canvas for all other renderers.
                (0, $4f71e35e4552e3dd$export$567881adfc3eb7f3)(ctx, symbol);
            }
        }
    }
}
/**
 * Convert symbol array into normalized array
 *
 * @param {string | (string | string[])[]} symbol symbol input
 * @return {string[][]} normolized symbol array
 */ function $c6d646aacd243427$var$normalizeSymbolArray(symbol) {
    if (!symbol || symbol.length === 0) return [
        [
            'rect'
        ]
    ];
    if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(symbol)) return [
        [
            symbol
        ]
    ];
    var isAllString = true;
    for(var i = 0; i < symbol.length; ++i)if (!(0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(symbol[i])) {
        isAllString = false;
        break;
    }
    if (isAllString) return $c6d646aacd243427$var$normalizeSymbolArray([
        symbol
    ]);
    var result = [];
    for(var i = 0; i < symbol.length; ++i)if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(symbol[i])) result.push([
        symbol[i]
    ]);
    else result.push(symbol[i]);
    return result;
}
/**
 * Convert dash input into dashArray
 *
 * @param {DecalDashArrayX} dash dash input
 * @return {number[][]} normolized dash array
 */ function $c6d646aacd243427$var$normalizeDashArrayX(dash) {
    if (!dash || dash.length === 0) return [
        [
            0,
            0
        ]
    ];
    if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(dash)) {
        var dashValue = Math.ceil(dash);
        return [
            [
                dashValue,
                dashValue
            ]
        ];
    }
    /**
   * [20, 5] should be normalized into [[20, 5]],
   * while [20, [5, 10]] should be normalized into [[20, 20], [5, 10]]
   */ var isAllNumber = true;
    for(var i = 0; i < dash.length; ++i)if (!(0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(dash[i])) {
        isAllNumber = false;
        break;
    }
    if (isAllNumber) return $c6d646aacd243427$var$normalizeDashArrayX([
        dash
    ]);
    var result = [];
    for(var i = 0; i < dash.length; ++i)if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(dash[i])) {
        var dashValue = Math.ceil(dash[i]);
        result.push([
            dashValue,
            dashValue
        ]);
    } else {
        var dashValue = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(dash[i], function(n) {
            return Math.ceil(n);
        });
        if (dashValue.length % 2 === 1) // [4, 2, 1] means |----  -    -- |----  -    -- |
        // so normalize it to be [4, 2, 1, 4, 2, 1]
        result.push(dashValue.concat(dashValue));
        else result.push(dashValue);
    }
    return result;
}
/**
 * Convert dash input into dashArray
 *
 * @param {DecalDashArrayY} dash dash input
 * @return {number[]} normolized dash array
 */ function $c6d646aacd243427$var$normalizeDashArrayY(dash) {
    if (!dash || typeof dash === 'object' && dash.length === 0) return [
        0,
        0
    ];
    if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(dash)) {
        var dashValue_1 = Math.ceil(dash);
        return [
            dashValue_1,
            dashValue_1
        ];
    }
    var dashValue = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(dash, function(n) {
        return Math.ceil(n);
    });
    return dash.length % 2 ? dashValue.concat(dashValue) : dashValue;
}
/**
 * Get block length of each line. A block is the length of dash line and space.
 * For example, a line with [4, 1] has a dash line of 4 and a space of 1 after
 * that, so the block length of this line is 5.
 *
 * @param {number[][]} dash dash array of X or Y
 * @return {number[]} block length of each line
 */ function $c6d646aacd243427$var$getLineBlockLengthX(dash) {
    return (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(dash, function(line) {
        return $c6d646aacd243427$var$getLineBlockLengthY(line);
    });
}
function $c6d646aacd243427$var$getLineBlockLengthY(dash) {
    var blockLength = 0;
    for(var i = 0; i < dash.length; ++i)blockLength += dash[i];
    if (dash.length % 2 === 1) // [4, 2, 1] means |----  -    -- |----  -    -- |
    // So total length is (4 + 2 + 1) * 2
    return blockLength * 2;
    return blockLength;
}


function $d82adaf1a5a5cfeb$export$2e2bcd8739ae039(ecModel, api) {
    ecModel.eachRawSeries(function(seriesModel) {
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        var data = seriesModel.getData();
        if (data.hasItemVisual()) data.each(function(idx) {
            var decal = data.getItemVisual(idx, 'decal');
            if (decal) {
                var itemStyle = data.ensureUniqueItemVisual(idx, 'style');
                itemStyle.decal = (0, $c6d646aacd243427$export$a3ba048e1a648972)(decal, api);
            }
        });
        var decal = data.getVisual('decal');
        if (decal) {
            var style = data.getVisual('style');
            style.decal = (0, $c6d646aacd243427$export$a3ba048e1a648972)(decal, api);
        }
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $8022924a3c5c0bb5$var$lifecycle = new (0, $63441a86293f101f$export$2e2bcd8739ae039)();
var $8022924a3c5c0bb5$export$2e2bcd8739ae039 = $8022924a3c5c0bb5$var$lifecycle;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
// Implementation of exported APIs. For example registerMap, getMap.
// The implementations will be registered when installing the component.
// Avoid these code being bundled to the core module.
var $f773aa0508c1d920$var$implsStore = {};
function $f773aa0508c1d920$export$9b808fd12256ddd3(name, impl) {
    $f773aa0508c1d920$var$implsStore[name] = impl;
}
function $f773aa0508c1d920$export$73333eb8a09d5f61(name) {
    return $f773aa0508c1d920$var$implsStore[name];
}


var $4d59907f44a2d0ad$export$83d89fbfd8236492 = '5.6.0';
var $4d59907f44a2d0ad$export$b74ff737e0e298b5 = {
    zrender: '5.6.1'
};
var $4d59907f44a2d0ad$var$TEST_FRAME_REMAIN_TIME = 1;
var $4d59907f44a2d0ad$var$PRIORITY_PROCESSOR_SERIES_FILTER = 800;
// Some data processors depends on the stack result dimension (to calculate data extent).
// So data stack stage should be in front of data processing stage.
var $4d59907f44a2d0ad$var$PRIORITY_PROCESSOR_DATASTACK = 900;
// "Data filter" will block the stream, so it should be
// put at the beginning of data processing.
var $4d59907f44a2d0ad$var$PRIORITY_PROCESSOR_FILTER = 1000;
var $4d59907f44a2d0ad$var$PRIORITY_PROCESSOR_DEFAULT = 2000;
var $4d59907f44a2d0ad$var$PRIORITY_PROCESSOR_STATISTIC = 5000;
var $4d59907f44a2d0ad$var$PRIORITY_VISUAL_LAYOUT = 1000;
var $4d59907f44a2d0ad$var$PRIORITY_VISUAL_PROGRESSIVE_LAYOUT = 1100;
var $4d59907f44a2d0ad$var$PRIORITY_VISUAL_GLOBAL = 2000;
var $4d59907f44a2d0ad$var$PRIORITY_VISUAL_CHART = 3000;
var $4d59907f44a2d0ad$var$PRIORITY_VISUAL_COMPONENT = 4000;
// Visual property in data. Greater than `PRIORITY_VISUAL_COMPONENT` to enable to
// overwrite the viusal result of component (like `visualMap`)
// using data item specific setting (like itemStyle.xxx on data item)
var $4d59907f44a2d0ad$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM = 4500;
// Greater than `PRIORITY_VISUAL_CHART_DATA_CUSTOM` to enable to layout based on
// visual result like `symbolSize`.
var $4d59907f44a2d0ad$var$PRIORITY_VISUAL_POST_CHART_LAYOUT = 4600;
var $4d59907f44a2d0ad$var$PRIORITY_VISUAL_BRUSH = 5000;
var $4d59907f44a2d0ad$var$PRIORITY_VISUAL_ARIA = 6000;
var $4d59907f44a2d0ad$var$PRIORITY_VISUAL_DECAL = 7000;
var $4d59907f44a2d0ad$export$bb34f3538ba26c7e = {
    PROCESSOR: {
        FILTER: $4d59907f44a2d0ad$var$PRIORITY_PROCESSOR_FILTER,
        SERIES_FILTER: $4d59907f44a2d0ad$var$PRIORITY_PROCESSOR_SERIES_FILTER,
        STATISTIC: $4d59907f44a2d0ad$var$PRIORITY_PROCESSOR_STATISTIC
    },
    VISUAL: {
        LAYOUT: $4d59907f44a2d0ad$var$PRIORITY_VISUAL_LAYOUT,
        PROGRESSIVE_LAYOUT: $4d59907f44a2d0ad$var$PRIORITY_VISUAL_PROGRESSIVE_LAYOUT,
        GLOBAL: $4d59907f44a2d0ad$var$PRIORITY_VISUAL_GLOBAL,
        CHART: $4d59907f44a2d0ad$var$PRIORITY_VISUAL_CHART,
        POST_CHART_LAYOUT: $4d59907f44a2d0ad$var$PRIORITY_VISUAL_POST_CHART_LAYOUT,
        COMPONENT: $4d59907f44a2d0ad$var$PRIORITY_VISUAL_COMPONENT,
        BRUSH: $4d59907f44a2d0ad$var$PRIORITY_VISUAL_BRUSH,
        CHART_ITEM: $4d59907f44a2d0ad$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM,
        ARIA: $4d59907f44a2d0ad$var$PRIORITY_VISUAL_ARIA,
        DECAL: $4d59907f44a2d0ad$var$PRIORITY_VISUAL_DECAL
    }
};
// Main process have three entries: `setOption`, `dispatchAction` and `resize`,
// where they must not be invoked nestedly, except the only case: invoke
// dispatchAction with updateMethod "none" in main process.
// This flag is used to carry out this rule.
// All events will be triggered out side main process (i.e. when !this[IN_MAIN_PROCESS]).
var $4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY = '__flagInMainProcess';
var $4d59907f44a2d0ad$var$PENDING_UPDATE = '__pendingUpdate';
var $4d59907f44a2d0ad$var$STATUS_NEEDS_UPDATE_KEY = '__needsUpdateStatus';
var $4d59907f44a2d0ad$var$ACTION_REG = /^[a-zA-Z0-9_]+$/;
var $4d59907f44a2d0ad$var$CONNECT_STATUS_KEY = '__connectUpdateStatus';
var $4d59907f44a2d0ad$var$CONNECT_STATUS_PENDING = 0;
var $4d59907f44a2d0ad$var$CONNECT_STATUS_UPDATING = 1;
var $4d59907f44a2d0ad$var$CONNECT_STATUS_UPDATED = 2;
function $4d59907f44a2d0ad$var$createRegisterEventWithLowercaseECharts(method) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (this.isDisposed()) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        return $4d59907f44a2d0ad$var$toLowercaseNameAndCallEventful(this, method, args);
    };
}
function $4d59907f44a2d0ad$var$createRegisterEventWithLowercaseMessageCenter(method) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $4d59907f44a2d0ad$var$toLowercaseNameAndCallEventful(this, method, args);
    };
}
function $4d59907f44a2d0ad$var$toLowercaseNameAndCallEventful(host, method, args) {
    // `args[0]` is event name. Event name is all lowercase.
    args[0] = args[0] && args[0].toLowerCase();
    return (0, $63441a86293f101f$export$2e2bcd8739ae039).prototype[method].apply(host, args);
}
var $4d59907f44a2d0ad$var$MessageCenter = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(MessageCenter, _super);
    function MessageCenter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MessageCenter;
}((0, $63441a86293f101f$export$2e2bcd8739ae039));
var $4d59907f44a2d0ad$var$messageCenterProto = $4d59907f44a2d0ad$var$MessageCenter.prototype;
$4d59907f44a2d0ad$var$messageCenterProto.on = $4d59907f44a2d0ad$var$createRegisterEventWithLowercaseMessageCenter('on');
$4d59907f44a2d0ad$var$messageCenterProto.off = $4d59907f44a2d0ad$var$createRegisterEventWithLowercaseMessageCenter('off');
// ---------------------------------------
// Internal method names for class ECharts
// ---------------------------------------
var $4d59907f44a2d0ad$var$prepare;
var $4d59907f44a2d0ad$var$prepareView;
var $4d59907f44a2d0ad$var$updateDirectly;
var $4d59907f44a2d0ad$var$updateMethods;
var $4d59907f44a2d0ad$var$doConvertPixel;
var $4d59907f44a2d0ad$var$updateStreamModes;
var $4d59907f44a2d0ad$var$doDispatchAction;
var $4d59907f44a2d0ad$var$flushPendingActions;
var $4d59907f44a2d0ad$var$triggerUpdatedEvent;
var $4d59907f44a2d0ad$var$bindRenderedEvent;
var $4d59907f44a2d0ad$var$bindMouseEvent;
var $4d59907f44a2d0ad$var$render;
var $4d59907f44a2d0ad$var$renderComponents;
var $4d59907f44a2d0ad$var$renderSeries;
var $4d59907f44a2d0ad$var$createExtensionAPI;
var $4d59907f44a2d0ad$var$enableConnect;
var $4d59907f44a2d0ad$var$markStatusToUpdate;
var $4d59907f44a2d0ad$var$applyChangedStates;
var $4d59907f44a2d0ad$var$ECharts = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ECharts, _super);
    function ECharts(dom, // Theme name or themeOption.
    theme, opts) {
        var _this = _super.call(this, new (0, $82d62ed69f6abce3$export$d0fd09f950257b52)()) || this;
        _this._chartsViews = [];
        _this._chartsMap = {};
        _this._componentsViews = [];
        _this._componentsMap = {};
        // Can't dispatch action during rendering procedure
        _this._pendingActions = [];
        opts = opts || {};
        // Get theme by name
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(theme)) theme = $4d59907f44a2d0ad$var$themeStorage[theme];
        _this._dom = dom;
        var defaultRenderer = 'canvas';
        var defaultCoarsePointer = 'auto';
        var defaultUseDirtyRect = false;
        var root;
        if (opts.ssr) $6eba88f9eebe6af9$export$e7a09d7fe68a4f7(function(el) {
            var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el);
            var dataIndex = ecData.dataIndex;
            if (dataIndex == null) return;
            var hashMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
            hashMap.set('series_index', ecData.seriesIndex);
            hashMap.set('data_index', dataIndex);
            ecData.ssrType && hashMap.set('ssr_type', ecData.ssrType);
            return hashMap;
        });
        var zr = _this._zr = $6eba88f9eebe6af9$export$2cd8252107eb640b(dom, {
            renderer: opts.renderer || defaultRenderer,
            devicePixelRatio: opts.devicePixelRatio,
            width: opts.width,
            height: opts.height,
            ssr: opts.ssr,
            useDirtyRect: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(opts.useDirtyRect, defaultUseDirtyRect),
            useCoarsePointer: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(opts.useCoarsePointer, defaultCoarsePointer),
            pointerSize: opts.pointerSize
        });
        _this._ssr = opts.ssr;
        // Expect 60 fps.
        _this._throttledZrFlush = (0, $c98659a9437a3d2e$export$de363e709c412c8a)((0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(zr.flush, zr), 17);
        theme = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(theme);
        theme && (0, $c4489ebdf95633b6$export$2e2bcd8739ae039)(theme, true);
        _this._theme = theme;
        _this._locale = (0, $9b0a1ef4bcc91e7d$export$ddc371781a6af754)(opts.locale || (0, $9b0a1ef4bcc91e7d$export$9a2147b3808d4c6b));
        _this._coordSysMgr = new (0, $70c3ede7d3b64757$export$2e2bcd8739ae039)();
        var api = _this._api = $4d59907f44a2d0ad$var$createExtensionAPI(_this);
        // Sort on demand
        function prioritySortFunc(a, b) {
            return a.__prio - b.__prio;
        }
        (0, $97579a54749e4b24$export$2e2bcd8739ae039)($4d59907f44a2d0ad$var$visualFuncs, prioritySortFunc);
        (0, $97579a54749e4b24$export$2e2bcd8739ae039)($4d59907f44a2d0ad$var$dataProcessorFuncs, prioritySortFunc);
        _this._scheduler = new (0, $94ae4e8744638a8a$export$2e2bcd8739ae039)(_this, api, $4d59907f44a2d0ad$var$dataProcessorFuncs, $4d59907f44a2d0ad$var$visualFuncs);
        _this._messageCenter = new $4d59907f44a2d0ad$var$MessageCenter();
        // Init mouse events
        _this._initEvents();
        // In case some people write `window.onresize = chart.resize`
        _this.resize = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(_this.resize, _this);
        zr.animation.on('frame', _this._onframe, _this);
        $4d59907f44a2d0ad$var$bindRenderedEvent(zr, _this);
        $4d59907f44a2d0ad$var$bindMouseEvent(zr, _this);
        // ECharts instance can be used as value.
        (0, $7a1bd9c2710fea0d$export$112e66431016387b)(_this);
        return _this;
    }
    ECharts.prototype._onframe = function() {
        if (this._disposed) return;
        $4d59907f44a2d0ad$var$applyChangedStates(this);
        var scheduler = this._scheduler;
        // Lazy update
        if (this[$4d59907f44a2d0ad$var$PENDING_UPDATE]) {
            var silent = this[$4d59907f44a2d0ad$var$PENDING_UPDATE].silent;
            this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = true;
            try {
                $4d59907f44a2d0ad$var$prepare(this);
                $4d59907f44a2d0ad$var$updateMethods.update.call(this, null, this[$4d59907f44a2d0ad$var$PENDING_UPDATE].updateParams);
            } catch (e) {
                this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = false;
                this[$4d59907f44a2d0ad$var$PENDING_UPDATE] = null;
                throw e;
            }
            // At present, in each frame, zrender performs:
            //   (1) animation step forward.
            //   (2) trigger('frame') (where this `_onframe` is called)
            //   (3) zrender flush (render).
            // If we do nothing here, since we use `setToFinal: true`, the step (3) above
            // will render the final state of the elements before the real animation started.
            this._zr.flush();
            this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = false;
            this[$4d59907f44a2d0ad$var$PENDING_UPDATE] = null;
            $4d59907f44a2d0ad$var$flushPendingActions.call(this, silent);
            $4d59907f44a2d0ad$var$triggerUpdatedEvent.call(this, silent);
        } else if (scheduler.unfinished) {
            // Stream progress.
            var remainTime = $4d59907f44a2d0ad$var$TEST_FRAME_REMAIN_TIME;
            var ecModel = this._model;
            var api = this._api;
            scheduler.unfinished = false;
            do {
                var startTime = +new Date();
                scheduler.performSeriesTasks(ecModel);
                // Currently dataProcessorFuncs do not check threshold.
                scheduler.performDataProcessorTasks(ecModel);
                $4d59907f44a2d0ad$var$updateStreamModes(this, ecModel);
                // Do not update coordinate system here. Because that coord system update in
                // each frame is not a good user experience. So we follow the rule that
                // the extent of the coordinate system is determined in the first frame (the
                // frame is executed immediately after task reset.
                // this._coordSysMgr.update(ecModel, api);
                // console.log('--- ec frame visual ---', remainTime);
                scheduler.performVisualTasks(ecModel);
                $4d59907f44a2d0ad$var$renderSeries(this, this._model, api, 'remain', {});
                remainTime -= +new Date() - startTime;
            }while (remainTime > 0 && scheduler.unfinished);
            // Call flush explicitly for trigger finished event.
            if (!scheduler.unfinished) this._zr.flush();
        // Else, zr flushing be ensue within the same frame,
        // because zr flushing is after onframe event.
        }
    };
    ECharts.prototype.getDom = function() {
        return this._dom;
    };
    ECharts.prototype.getId = function() {
        return this.id;
    };
    ECharts.prototype.getZr = function() {
        return this._zr;
    };
    ECharts.prototype.isSSR = function() {
        return this._ssr;
    };
    /* eslint-disable-next-line */ ECharts.prototype.setOption = function(option, notMerge, lazyUpdate) {
        if (this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY]) return;
        if (this._disposed) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        var silent;
        var replaceMerge;
        var transitionOpt;
        if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(notMerge)) {
            lazyUpdate = notMerge.lazyUpdate;
            silent = notMerge.silent;
            replaceMerge = notMerge.replaceMerge;
            transitionOpt = notMerge.transition;
            notMerge = notMerge.notMerge;
        }
        this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = true;
        if (!this._model || notMerge) {
            var optionManager = new (0, $bf4c0a9077b4e970$export$2e2bcd8739ae039)(this._api);
            var theme = this._theme;
            var ecModel = this._model = new (0, $51f6ef0dd9546916$export$2e2bcd8739ae039)();
            ecModel.scheduler = this._scheduler;
            ecModel.ssr = this._ssr;
            ecModel.init(null, null, null, theme, this._locale, optionManager);
        }
        this._model.setOption(option, {
            replaceMerge: replaceMerge
        }, $4d59907f44a2d0ad$var$optionPreprocessorFuncs);
        var updateParams = {
            seriesTransition: transitionOpt,
            optionChanged: true
        };
        if (lazyUpdate) {
            this[$4d59907f44a2d0ad$var$PENDING_UPDATE] = {
                silent: silent,
                updateParams: updateParams
            };
            this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = false;
            // `setOption(option, {lazyMode: true})` may be called when zrender has been slept.
            // It should wake it up to make sure zrender start to render at the next frame.
            this.getZr().wakeUp();
        } else {
            try {
                $4d59907f44a2d0ad$var$prepare(this);
                $4d59907f44a2d0ad$var$updateMethods.update.call(this, null, updateParams);
            } catch (e) {
                this[$4d59907f44a2d0ad$var$PENDING_UPDATE] = null;
                this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = false;
                throw e;
            }
            // Ensure zr refresh sychronously, and then pixel in canvas can be
            // fetched after `setOption`.
            if (!this._ssr) // not use flush when using ssr mode.
            this._zr.flush();
            this[$4d59907f44a2d0ad$var$PENDING_UPDATE] = null;
            this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = false;
            $4d59907f44a2d0ad$var$flushPendingActions.call(this, silent);
            $4d59907f44a2d0ad$var$triggerUpdatedEvent.call(this, silent);
        }
    };
    /**
   * @deprecated
   */ ECharts.prototype.setTheme = function() {
        (0, $84bc7667c27ccedc$export$4a9c0b74eb885aa1)('ECharts#setTheme() is DEPRECATED in ECharts 3.0');
    };
    // We don't want developers to use getModel directly.
    ECharts.prototype.getModel = function() {
        return this._model;
    };
    ECharts.prototype.getOption = function() {
        return this._model && this._model.getOption();
    };
    ECharts.prototype.getWidth = function() {
        return this._zr.getWidth();
    };
    ECharts.prototype.getHeight = function() {
        return this._zr.getHeight();
    };
    ECharts.prototype.getDevicePixelRatio = function() {
        return this._zr.painter.dpr || (0, $ce6dd58693a21851$export$2e2bcd8739ae039).hasGlobalWindow && window.devicePixelRatio || 1;
    };
    /**
   * Get canvas which has all thing rendered
   * @deprecated Use renderToCanvas instead.
   */ ECharts.prototype.getRenderedCanvas = function(opts) {
        return this.renderToCanvas(opts);
    };
    ECharts.prototype.renderToCanvas = function(opts) {
        opts = opts || {};
        var painter = this._zr.painter;
        return painter.getRenderedCanvas({
            backgroundColor: opts.backgroundColor || this._model.get('backgroundColor'),
            pixelRatio: opts.pixelRatio || this.getDevicePixelRatio()
        });
    };
    ECharts.prototype.renderToSVGString = function(opts) {
        opts = opts || {};
        var painter = this._zr.painter;
        return painter.renderToString({
            useViewBox: opts.useViewBox
        });
    };
    /**
   * Get svg data url
   */ ECharts.prototype.getSvgDataURL = function() {
        if (!(0, $ce6dd58693a21851$export$2e2bcd8739ae039).svgSupported) return;
        var zr = this._zr;
        var list = zr.storage.getDisplayList();
        // Stop animations
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(list, function(el) {
            el.stopAnimation(null, true);
        });
        return zr.painter.toDataURL();
    };
    ECharts.prototype.getDataURL = function(opts) {
        if (this._disposed) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        opts = opts || {};
        var excludeComponents = opts.excludeComponents;
        var ecModel = this._model;
        var excludesComponentViews = [];
        var self = this;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(excludeComponents, function(componentType) {
            ecModel.eachComponent({
                mainType: componentType
            }, function(component) {
                var view = self._componentsMap[component.__viewId];
                if (!view.group.ignore) {
                    excludesComponentViews.push(view);
                    view.group.ignore = true;
                }
            });
        });
        var url = this._zr.painter.getType() === 'svg' ? this.getSvgDataURL() : this.renderToCanvas(opts).toDataURL('image/' + (opts && opts.type || 'png'));
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(excludesComponentViews, function(view) {
            view.group.ignore = false;
        });
        return url;
    };
    ECharts.prototype.getConnectedDataURL = function(opts) {
        if (this._disposed) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        var isSvg = opts.type === 'svg';
        var groupId = this.group;
        var mathMin = Math.min;
        var mathMax = Math.max;
        var MAX_NUMBER = Infinity;
        if ($4d59907f44a2d0ad$var$connectedGroups[groupId]) {
            var left_1 = MAX_NUMBER;
            var top_1 = MAX_NUMBER;
            var right_1 = -MAX_NUMBER;
            var bottom_1 = -MAX_NUMBER;
            var canvasList_1 = [];
            var dpr_1 = opts && opts.pixelRatio || this.getDevicePixelRatio();
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($4d59907f44a2d0ad$var$instances, function(chart, id) {
                if (chart.group === groupId) {
                    var canvas = isSvg ? chart.getZr().painter.getSvgDom().innerHTML : chart.renderToCanvas((0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(opts));
                    var boundingRect = chart.getDom().getBoundingClientRect();
                    left_1 = mathMin(boundingRect.left, left_1);
                    top_1 = mathMin(boundingRect.top, top_1);
                    right_1 = mathMax(boundingRect.right, right_1);
                    bottom_1 = mathMax(boundingRect.bottom, bottom_1);
                    canvasList_1.push({
                        dom: canvas,
                        left: boundingRect.left,
                        top: boundingRect.top
                    });
                }
            });
            left_1 *= dpr_1;
            top_1 *= dpr_1;
            right_1 *= dpr_1;
            bottom_1 *= dpr_1;
            var width = right_1 - left_1;
            var height = bottom_1 - top_1;
            var targetCanvas = (0, $c6341dcc9d86826e$export$ef5e599365494451).createCanvas();
            var zr_1 = $6eba88f9eebe6af9$export$2cd8252107eb640b(targetCanvas, {
                renderer: isSvg ? 'svg' : 'canvas'
            });
            zr_1.resize({
                width: width,
                height: height
            });
            if (isSvg) {
                var content_1 = '';
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(canvasList_1, function(item) {
                    var x = item.left - left_1;
                    var y = item.top - top_1;
                    content_1 += '<g transform="translate(' + x + ',' + y + ')">' + item.dom + '</g>';
                });
                zr_1.painter.getSvgRoot().innerHTML = content_1;
                if (opts.connectedBackgroundColor) zr_1.painter.setBackgroundColor(opts.connectedBackgroundColor);
                zr_1.refreshImmediately();
                return zr_1.painter.toDataURL();
            } else {
                // Background between the charts
                if (opts.connectedBackgroundColor) zr_1.add(new $419e5ff2f303755e$export$2e2bcd8739ae039({
                    shape: {
                        x: 0,
                        y: 0,
                        width: width,
                        height: height
                    },
                    style: {
                        fill: opts.connectedBackgroundColor
                    }
                }));
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(canvasList_1, function(item) {
                    var img = new $86adec94217b86c6$export$2e2bcd8739ae039({
                        style: {
                            x: item.left * dpr_1 - left_1,
                            y: item.top * dpr_1 - top_1,
                            image: item.dom
                        }
                    });
                    zr_1.add(img);
                });
                zr_1.refreshImmediately();
                return targetCanvas.toDataURL('image/' + (opts && opts.type || 'png'));
            }
        } else return this.getDataURL(opts);
    };
    ECharts.prototype.convertToPixel = function(finder, value) {
        return $4d59907f44a2d0ad$var$doConvertPixel(this, 'convertToPixel', finder, value);
    };
    ECharts.prototype.convertFromPixel = function(finder, value) {
        return $4d59907f44a2d0ad$var$doConvertPixel(this, 'convertFromPixel', finder, value);
    };
    /**
   * Is the specified coordinate systems or components contain the given pixel point.
   * @param {Array|number} value
   * @return {boolean} result
   */ ECharts.prototype.containPixel = function(finder, value) {
        if (this._disposed) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        var ecModel = this._model;
        var result;
        var findResult = $76d619f648247e6d$export$95de80076abac814(ecModel, finder);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(findResult, function(models, key) {
            key.indexOf('Models') >= 0 && (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(models, function(model) {
                var coordSys = model.coordinateSystem;
                if (coordSys && coordSys.containPoint) result = result || !!coordSys.containPoint(value);
                else if (key === 'seriesModels') {
                    var view = this._chartsMap[model.__viewId];
                    if (view && view.containPoint) result = result || view.containPoint(value, model);
                }
            }, this);
        }, this);
        return !!result;
    };
    /**
   * Get visual from series or data.
   * @param finder
   *        If string, e.g., 'series', means {seriesIndex: 0}.
   *        If Object, could contain some of these properties below:
   *        {
   *            seriesIndex / seriesId / seriesName,
   *            dataIndex / dataIndexInside
   *        }
   *        If dataIndex is not specified, series visual will be fetched,
   *        but not data item visual.
   *        If all of seriesIndex, seriesId, seriesName are not specified,
   *        visual will be fetched from first series.
   * @param visualType 'color', 'symbol', 'symbolSize'
   */ ECharts.prototype.getVisual = function(finder, visualType) {
        var ecModel = this._model;
        var parsedFinder = $76d619f648247e6d$export$95de80076abac814(ecModel, finder, {
            defaultMainType: 'series'
        });
        var seriesModel = parsedFinder.seriesModel;
        var data = seriesModel.getData();
        var dataIndexInside = parsedFinder.hasOwnProperty('dataIndexInside') ? parsedFinder.dataIndexInside : parsedFinder.hasOwnProperty('dataIndex') ? data.indexOfRawIndex(parsedFinder.dataIndex) : null;
        return dataIndexInside != null ? (0, $ea13f1ab2169d82d$export$91d919a86b2df624)(data, dataIndexInside, visualType) : (0, $ea13f1ab2169d82d$export$d76e333a86ea1a2)(data, visualType);
    };
    /**
   * Get view of corresponding component model
   */ ECharts.prototype.getViewOfComponentModel = function(componentModel) {
        return this._componentsMap[componentModel.__viewId];
    };
    /**
   * Get view of corresponding series model
   */ ECharts.prototype.getViewOfSeriesModel = function(seriesModel) {
        return this._chartsMap[seriesModel.__viewId];
    };
    ECharts.prototype._initEvents = function() {
        var _this = this;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($4d59907f44a2d0ad$var$MOUSE_EVENT_NAMES, function(eveName) {
            var handler = function(e) {
                var ecModel = _this.getModel();
                var el = e.target;
                var params;
                var isGlobalOut = eveName === 'globalout';
                // no e.target when 'globalout'.
                if (isGlobalOut) params = {};
                else el && (0, $808c5a2823518f68$export$8a4fca9e04eb4df6)(el, function(parent) {
                    var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(parent);
                    if (ecData && ecData.dataIndex != null) {
                        var dataModel = ecData.dataModel || ecModel.getSeriesByIndex(ecData.seriesIndex);
                        params = dataModel && dataModel.getDataParams(ecData.dataIndex, ecData.dataType, el) || {};
                        return true;
                    } else if (ecData.eventData) {
                        params = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, ecData.eventData);
                        return true;
                    }
                }, true);
                // Contract: if params prepared in mouse event,
                // these properties must be specified:
                // {
                //    componentType: string (component main type)
                //    componentIndex: number
                // }
                // Otherwise event query can not work.
                if (params) {
                    var componentType = params.componentType;
                    var componentIndex = params.componentIndex;
                    // Special handling for historic reason: when trigger by
                    // markLine/markPoint/markArea, the componentType is
                    // 'markLine'/'markPoint'/'markArea', but we should better
                    // enable them to be queried by seriesIndex, since their
                    // option is set in each series.
                    if (componentType === 'markLine' || componentType === 'markPoint' || componentType === 'markArea') {
                        componentType = 'series';
                        componentIndex = params.seriesIndex;
                    }
                    var model = componentType && componentIndex != null && ecModel.getComponent(componentType, componentIndex);
                    var view = model && _this[model.mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId];
                    params.event = e;
                    params.type = eveName;
                    _this._$eventProcessor.eventInfo = {
                        targetEl: el,
                        packedEvent: params,
                        model: model,
                        view: view
                    };
                    _this.trigger(eveName, params);
                }
            };
            // Consider that some component (like tooltip, brush, ...)
            // register zr event handler, but user event handler might
            // do anything, such as call `setOption` or `dispatchAction`,
            // which probably update any of the content and probably
            // cause problem if it is called previous other inner handlers.
            handler.zrEventfulCallAtLast = true;
            _this._zr.on(eveName, handler, _this);
        });
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($4d59907f44a2d0ad$var$eventActionMap, function(actionType, eventType) {
            _this._messageCenter.on(eventType, function(event) {
                this.trigger(eventType, event);
            }, _this);
        });
        // Extra events
        // TODO register?
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
            'selectchanged'
        ], function(eventType) {
            _this._messageCenter.on(eventType, function(event) {
                this.trigger(eventType, event);
            }, _this);
        });
        (0, $e855ccf7eff48bce$export$2575c83262e49d0c)(this._messageCenter, this, this._api);
    };
    ECharts.prototype.isDisposed = function() {
        return this._disposed;
    };
    ECharts.prototype.clear = function() {
        if (this._disposed) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        this.setOption({
            series: []
        }, true);
    };
    ECharts.prototype.dispose = function() {
        if (this._disposed) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        this._disposed = true;
        var dom = this.getDom();
        if (dom) $76d619f648247e6d$export$9fec4d97f1922e0b(this.getDom(), $4d59907f44a2d0ad$var$DOM_ATTRIBUTE_KEY, '');
        var chart = this;
        var api = chart._api;
        var ecModel = chart._model;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(chart._componentsViews, function(component) {
            component.dispose(ecModel, api);
        });
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(chart._chartsViews, function(chart) {
            chart.dispose(ecModel, api);
        });
        // Dispose after all views disposed
        chart._zr.dispose();
        // Set properties to null.
        // To reduce the memory cost in case the top code still holds this instance unexpectedly.
        chart._dom = chart._model = chart._chartsMap = chart._componentsMap = chart._chartsViews = chart._componentsViews = chart._scheduler = chart._api = chart._zr = chart._throttledZrFlush = chart._theme = chart._coordSysMgr = chart._messageCenter = null;
        delete $4d59907f44a2d0ad$var$instances[chart.id];
    };
    /**
   * Resize the chart
   */ ECharts.prototype.resize = function(opts) {
        if (this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY]) return;
        if (this._disposed) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        this._zr.resize(opts);
        var ecModel = this._model;
        // Resize loading effect
        this._loadingFX && this._loadingFX.resize();
        if (!ecModel) return;
        var needPrepare = ecModel.resetOption('media');
        var silent = opts && opts.silent;
        // There is some real cases that:
        // chart.setOption(option, { lazyUpdate: true });
        // chart.resize();
        if (this[$4d59907f44a2d0ad$var$PENDING_UPDATE]) {
            if (silent == null) silent = this[$4d59907f44a2d0ad$var$PENDING_UPDATE].silent;
            needPrepare = true;
            this[$4d59907f44a2d0ad$var$PENDING_UPDATE] = null;
        }
        this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = true;
        try {
            needPrepare && $4d59907f44a2d0ad$var$prepare(this);
            $4d59907f44a2d0ad$var$updateMethods.update.call(this, {
                type: 'resize',
                animation: (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
                    // Disable animation
                    duration: 0
                }, opts && opts.animation)
            });
        } catch (e) {
            this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = false;
            throw e;
        }
        this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = false;
        $4d59907f44a2d0ad$var$flushPendingActions.call(this, silent);
        $4d59907f44a2d0ad$var$triggerUpdatedEvent.call(this, silent);
    };
    ECharts.prototype.showLoading = function(name, cfg) {
        if (this._disposed) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(name)) {
            cfg = name;
            name = '';
        }
        name = name || 'default';
        this.hideLoading();
        if (!$4d59907f44a2d0ad$var$loadingEffects[name]) return;
        var el = $4d59907f44a2d0ad$var$loadingEffects[name](this._api, cfg);
        var zr = this._zr;
        this._loadingFX = el;
        zr.add(el);
    };
    /**
   * Hide loading effect
   */ ECharts.prototype.hideLoading = function() {
        if (this._disposed) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        this._loadingFX && this._zr.remove(this._loadingFX);
        this._loadingFX = null;
    };
    ECharts.prototype.makeActionFromEvent = function(eventObj) {
        var payload = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, eventObj);
        payload.type = $4d59907f44a2d0ad$var$eventActionMap[eventObj.type];
        return payload;
    };
    /**
   * @param opt If pass boolean, means opt.silent
   * @param opt.silent Default `false`. Whether trigger events.
   * @param opt.flush Default `undefined`.
   *        true: Flush immediately, and then pixel in canvas can be fetched
   *            immediately. Caution: it might affect performance.
   *        false: Not flush.
   *        undefined: Auto decide whether perform flush.
   */ ECharts.prototype.dispatchAction = function(payload, opt) {
        if (this._disposed) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        if (!(0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(opt)) opt = {
            silent: !!opt
        };
        if (!$4d59907f44a2d0ad$var$actions[payload.type]) return;
        // Avoid dispatch action before setOption. Especially in `connect`.
        if (!this._model) return;
        // May dispatchAction in rendering procedure
        if (this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY]) {
            this._pendingActions.push(payload);
            return;
        }
        var silent = opt.silent;
        $4d59907f44a2d0ad$var$doDispatchAction.call(this, payload, silent);
        var flush = opt.flush;
        if (flush) this._zr.flush();
        else if (flush !== false && (0, $ce6dd58693a21851$export$2e2bcd8739ae039).browser.weChat) // In WeChat embedded browser, `requestAnimationFrame` and `setInterval`
        // hang when sliding page (on touch event), which cause that zr does not
        // refresh until user interaction finished, which is not expected.
        // But `dispatchAction` may be called too frequently when pan on touch
        // screen, which impacts performance if do not throttle them.
        this._throttledZrFlush();
        $4d59907f44a2d0ad$var$flushPendingActions.call(this, silent);
        $4d59907f44a2d0ad$var$triggerUpdatedEvent.call(this, silent);
    };
    ECharts.prototype.updateLabelLayout = function() {
        (0, $8022924a3c5c0bb5$export$2e2bcd8739ae039).trigger('series:layoutlabels', this._model, this._api, {
            // Not adding series labels.
            // TODO
            updatedSeries: []
        });
    };
    ECharts.prototype.appendData = function(params) {
        if (this._disposed) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        var seriesIndex = params.seriesIndex;
        var ecModel = this.getModel();
        var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
        seriesModel.appendData(params);
        // Note: `appendData` does not support that update extent of coordinate
        // system, util some scenario require that. In the expected usage of
        // `appendData`, the initial extent of coordinate system should better
        // be fixed by axis `min`/`max` setting or initial data, otherwise if
        // the extent changed while `appendData`, the location of the painted
        // graphic elements have to be changed, which make the usage of
        // `appendData` meaningless.
        this._scheduler.unfinished = true;
        this.getZr().wakeUp();
    };
    // A work around for no `internal` modifier in ts yet but
    // need to strictly hide private methods to JS users.
    ECharts.internalField = function() {
        $4d59907f44a2d0ad$var$prepare = function(ecIns) {
            var scheduler = ecIns._scheduler;
            scheduler.restorePipelines(ecIns._model);
            scheduler.prepareStageTasks();
            $4d59907f44a2d0ad$var$prepareView(ecIns, true);
            $4d59907f44a2d0ad$var$prepareView(ecIns, false);
            scheduler.plan();
        };
        /**
     * Prepare view instances of charts and components
     */ $4d59907f44a2d0ad$var$prepareView = function(ecIns, isComponent) {
            var ecModel = ecIns._model;
            var scheduler = ecIns._scheduler;
            var viewList = isComponent ? ecIns._componentsViews : ecIns._chartsViews;
            var viewMap = isComponent ? ecIns._componentsMap : ecIns._chartsMap;
            var zr = ecIns._zr;
            var api = ecIns._api;
            for(var i = 0; i < viewList.length; i++)viewList[i].__alive = false;
            isComponent ? ecModel.eachComponent(function(componentType, model) {
                componentType !== 'series' && doPrepare(model);
            }) : ecModel.eachSeries(doPrepare);
            function doPrepare(model) {
                // By default view will be reused if possible for the case that `setOption` with "notMerge"
                // mode and need to enable transition animation. (Usually, when they have the same id, or
                // especially no id but have the same type & name & index. See the `model.id` generation
                // rule in `makeIdAndName` and `viewId` generation rule here).
                // But in `replaceMerge` mode, this feature should be able to disabled when it is clear that
                // the new model has nothing to do with the old model.
                var requireNewView = model.__requireNewView;
                // This command should not work twice.
                model.__requireNewView = false;
                // Consider: id same and type changed.
                var viewId = '_ec_' + model.id + '_' + model.type;
                var view = !requireNewView && viewMap[viewId];
                if (!view) {
                    var classType = (0, $cd5f95cf03b4e3e7$export$fbe18865d303bf01)(model.type);
                    var Clazz = isComponent ? (0, $737c88aa0711f65a$export$2e2bcd8739ae039).getClass(classType.main, classType.sub) : // FIXME:TS
                    // (ChartView as ChartViewConstructor).getClass('series', classType.sub)
                    // For backward compat, still support a chart type declared as only subType
                    // like "liquidfill", but recommend "series.liquidfill"
                    // But need a base class to make a type series.
                    (0, $0dc5061053e23cd3$export$2e2bcd8739ae039).getClass(classType.sub);
                    view = new Clazz();
                    view.init(ecModel, api);
                    viewMap[viewId] = view;
                    viewList.push(view);
                    zr.add(view.group);
                }
                model.__viewId = view.__id = viewId;
                view.__alive = true;
                view.__model = model;
                view.group.__ecComponentInfo = {
                    mainType: model.mainType,
                    index: model.componentIndex
                };
                !isComponent && scheduler.prepareView(view, model, ecModel, api);
            }
            for(var i = 0; i < viewList.length;){
                var view = viewList[i];
                if (!view.__alive) {
                    !isComponent && view.renderTask.dispose();
                    zr.remove(view.group);
                    view.dispose(ecModel, api);
                    viewList.splice(i, 1);
                    if (viewMap[view.__id] === view) delete viewMap[view.__id];
                    view.__id = view.group.__ecComponentInfo = null;
                } else i++;
            }
        };
        $4d59907f44a2d0ad$var$updateDirectly = function(ecIns, method, payload, mainType, subType) {
            var ecModel = ecIns._model;
            ecModel.setUpdatePayload(payload);
            // broadcast
            if (!mainType) {
                // FIXME
                // Chart will not be update directly here, except set dirty.
                // But there is no such scenario now.
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([].concat(ecIns._componentsViews).concat(ecIns._chartsViews), callView);
                return;
            }
            var query = {};
            query[mainType + 'Id'] = payload[mainType + 'Id'];
            query[mainType + 'Index'] = payload[mainType + 'Index'];
            query[mainType + 'Name'] = payload[mainType + 'Name'];
            var condition = {
                mainType: mainType,
                query: query
            };
            subType && (condition.subType = subType); // subType may be '' by parseClassType;
            var excludeSeriesId = payload.excludeSeriesId;
            var excludeSeriesIdMap;
            if (excludeSeriesId != null) {
                excludeSeriesIdMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($76d619f648247e6d$export$4f07b212a02c8051(excludeSeriesId), function(id) {
                    var modelId = $76d619f648247e6d$export$fb1a222ba5dd6e51(id, null);
                    if (modelId != null) excludeSeriesIdMap.set(modelId, true);
                });
            }
            // If dispatchAction before setOption, do nothing.
            ecModel && ecModel.eachComponent(condition, function(model) {
                var isExcluded = excludeSeriesIdMap && excludeSeriesIdMap.get(model.id) != null;
                if (isExcluded) return;
                if ((0, $2bf82c0980125b62$export$aebe71265c1b77bf)(payload)) {
                    if (model instanceof (0, $7c10febb2cdef0d8$export$2e2bcd8739ae039)) {
                        if (payload.type === (0, $2bf82c0980125b62$export$df035d873a9de64f) && !payload.notBlur && !model.get([
                            'emphasis',
                            'disabled'
                        ])) (0, $2bf82c0980125b62$export$64f1fd4daefef21b)(model, payload, ecIns._api);
                    } else {
                        var _a = (0, $2bf82c0980125b62$export$f31a644ccca0ef23)(model.mainType, model.componentIndex, payload.name, ecIns._api), focusSelf = _a.focusSelf, dispatchers = _a.dispatchers;
                        if (payload.type === (0, $2bf82c0980125b62$export$df035d873a9de64f) && focusSelf && !payload.notBlur) (0, $2bf82c0980125b62$export$569da03256c8a55f)(model.mainType, model.componentIndex, ecIns._api);
                        // PENDING:
                        // Whether to put this "enter emphasis" code in `ComponentView`,
                        // which will be the same as `ChartView` but might be not necessary
                        // and will be far from this logic.
                        if (dispatchers) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dispatchers, function(dispatcher) {
                            payload.type === (0, $2bf82c0980125b62$export$df035d873a9de64f) ? (0, $2bf82c0980125b62$export$b2d02638cc34c042)(dispatcher) : (0, $2bf82c0980125b62$export$11be6f716239ac55)(dispatcher);
                        });
                    }
                } else if ((0, $2bf82c0980125b62$export$72aea10e60e45351)(payload)) // TODO geo
                {
                    if (model instanceof (0, $7c10febb2cdef0d8$export$2e2bcd8739ae039)) {
                        (0, $2bf82c0980125b62$export$1c7d489f62372d73)(model, payload, ecIns._api);
                        (0, $2bf82c0980125b62$export$e4ea08ef52e0a73)(model);
                        $4d59907f44a2d0ad$var$markStatusToUpdate(ecIns);
                    }
                }
            }, ecIns);
            ecModel && ecModel.eachComponent(condition, function(model) {
                var isExcluded = excludeSeriesIdMap && excludeSeriesIdMap.get(model.id) != null;
                if (isExcluded) return;
                callView(ecIns[mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId]);
            }, ecIns);
            function callView(view) {
                view && view.__alive && view[method] && view[method](view.__model, ecModel, ecIns._api, payload);
            }
        };
        $4d59907f44a2d0ad$var$updateMethods = {
            prepareAndUpdate: function(payload) {
                $4d59907f44a2d0ad$var$prepare(this);
                $4d59907f44a2d0ad$var$updateMethods.update.call(this, payload, {
                    // Needs to mark option changed if newOption is given.
                    // It's from MagicType.
                    // TODO If use a separate flag optionChanged in payload?
                    optionChanged: payload.newOption != null
                });
            },
            update: function(payload, updateParams) {
                var ecModel = this._model;
                var api = this._api;
                var zr = this._zr;
                var coordSysMgr = this._coordSysMgr;
                var scheduler = this._scheduler;
                // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload);
                scheduler.restoreData(ecModel, payload);
                scheduler.performSeriesTasks(ecModel);
                // TODO
                // Save total ecModel here for undo/redo (after restoring data and before processing data).
                // Undo (restoration of total ecModel) can be carried out in 'action' or outside API call.
                // Create new coordinate system each update
                // In LineView may save the old coordinate system and use it to get the original point.
                coordSysMgr.create(ecModel, api);
                scheduler.performDataProcessorTasks(ecModel, payload);
                // Current stream render is not supported in data process. So we can update
                // stream modes after data processing, where the filtered data is used to
                // determine whether to use progressive rendering.
                $4d59907f44a2d0ad$var$updateStreamModes(this, ecModel);
                // We update stream modes before coordinate system updated, then the modes info
                // can be fetched when coord sys updating (consider the barGrid extent fix). But
                // the drawback is the full coord info can not be fetched. Fortunately this full
                // coord is not required in stream mode updater currently.
                coordSysMgr.update(ecModel, api);
                clearColorPalette(ecModel);
                scheduler.performVisualTasks(ecModel, payload);
                $4d59907f44a2d0ad$var$render(this, ecModel, api, payload, updateParams);
                // Set background
                var backgroundColor = ecModel.get('backgroundColor') || 'transparent';
                var darkMode = ecModel.get('darkMode');
                zr.setBackgroundColor(backgroundColor);
                // Force set dark mode.
                if (darkMode != null && darkMode !== 'auto') zr.setDarkMode(darkMode);
                (0, $8022924a3c5c0bb5$export$2e2bcd8739ae039).trigger('afterupdate', ecModel, api);
            },
            updateTransform: function(payload) {
                var _this = this;
                var ecModel = this._model;
                var api = this._api;
                // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload);
                // ChartView.markUpdateMethod(payload, 'updateTransform');
                var componentDirtyList = [];
                ecModel.eachComponent(function(componentType, componentModel) {
                    if (componentType === 'series') return;
                    var componentView = _this.getViewOfComponentModel(componentModel);
                    if (componentView && componentView.__alive) {
                        if (componentView.updateTransform) {
                            var result = componentView.updateTransform(componentModel, ecModel, api, payload);
                            result && result.update && componentDirtyList.push(componentView);
                        } else componentDirtyList.push(componentView);
                    }
                });
                var seriesDirtyMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
                ecModel.eachSeries(function(seriesModel) {
                    var chartView = _this._chartsMap[seriesModel.__viewId];
                    if (chartView.updateTransform) {
                        var result = chartView.updateTransform(seriesModel, ecModel, api, payload);
                        result && result.update && seriesDirtyMap.set(seriesModel.uid, 1);
                    } else seriesDirtyMap.set(seriesModel.uid, 1);
                });
                clearColorPalette(ecModel);
                // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
                // this._scheduler.performVisualTasks(ecModel, payload, 'layout', true);
                this._scheduler.performVisualTasks(ecModel, payload, {
                    setDirty: true,
                    dirtyMap: seriesDirtyMap
                });
                // Currently, not call render of components. Geo render cost a lot.
                // renderComponents(ecIns, ecModel, api, payload, componentDirtyList);
                $4d59907f44a2d0ad$var$renderSeries(this, ecModel, api, payload, {}, seriesDirtyMap);
                (0, $8022924a3c5c0bb5$export$2e2bcd8739ae039).trigger('afterupdate', ecModel, api);
            },
            updateView: function(payload) {
                var ecModel = this._model;
                // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload);
                (0, $0dc5061053e23cd3$export$2e2bcd8739ae039).markUpdateMethod(payload, 'updateView');
                clearColorPalette(ecModel);
                // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
                this._scheduler.performVisualTasks(ecModel, payload, {
                    setDirty: true
                });
                $4d59907f44a2d0ad$var$render(this, ecModel, this._api, payload, {});
                (0, $8022924a3c5c0bb5$export$2e2bcd8739ae039).trigger('afterupdate', ecModel, this._api);
            },
            updateVisual: function(payload) {
                // updateMethods.update.call(this, payload);
                var _this = this;
                var ecModel = this._model;
                // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload);
                // clear all visual
                ecModel.eachSeries(function(seriesModel) {
                    seriesModel.getData().clearAllVisual();
                });
                // Perform visual
                (0, $0dc5061053e23cd3$export$2e2bcd8739ae039).markUpdateMethod(payload, 'updateVisual');
                clearColorPalette(ecModel);
                // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
                this._scheduler.performVisualTasks(ecModel, payload, {
                    visualType: 'visual',
                    setDirty: true
                });
                ecModel.eachComponent(function(componentType, componentModel) {
                    if (componentType !== 'series') {
                        var componentView = _this.getViewOfComponentModel(componentModel);
                        componentView && componentView.__alive && componentView.updateVisual(componentModel, ecModel, _this._api, payload);
                    }
                });
                ecModel.eachSeries(function(seriesModel) {
                    var chartView = _this._chartsMap[seriesModel.__viewId];
                    chartView.updateVisual(seriesModel, ecModel, _this._api, payload);
                });
                (0, $8022924a3c5c0bb5$export$2e2bcd8739ae039).trigger('afterupdate', ecModel, this._api);
            },
            updateLayout: function(payload) {
                $4d59907f44a2d0ad$var$updateMethods.update.call(this, payload);
            }
        };
        $4d59907f44a2d0ad$var$doConvertPixel = function(ecIns, methodName, finder, value) {
            if (ecIns._disposed) {
                $4d59907f44a2d0ad$var$disposedWarning(ecIns.id);
                return;
            }
            var ecModel = ecIns._model;
            var coordSysList = ecIns._coordSysMgr.getCoordinateSystems();
            var result;
            var parsedFinder = $76d619f648247e6d$export$95de80076abac814(ecModel, finder);
            for(var i = 0; i < coordSysList.length; i++){
                var coordSys = coordSysList[i];
                if (coordSys[methodName] && (result = coordSys[methodName](ecModel, parsedFinder, value)) != null) return result;
            }
        };
        $4d59907f44a2d0ad$var$updateStreamModes = function(ecIns, ecModel) {
            var chartsMap = ecIns._chartsMap;
            var scheduler = ecIns._scheduler;
            ecModel.eachSeries(function(seriesModel) {
                scheduler.updateStreamModes(seriesModel, chartsMap[seriesModel.__viewId]);
            });
        };
        $4d59907f44a2d0ad$var$doDispatchAction = function(payload, silent) {
            var _this = this;
            var ecModel = this.getModel();
            var payloadType = payload.type;
            var escapeConnect = payload.escapeConnect;
            var actionWrap = $4d59907f44a2d0ad$var$actions[payloadType];
            var actionInfo = actionWrap.actionInfo;
            var cptTypeTmp = (actionInfo.update || 'update').split(':');
            var updateMethod = cptTypeTmp.pop();
            var cptType = cptTypeTmp[0] != null && (0, $cd5f95cf03b4e3e7$export$fbe18865d303bf01)(cptTypeTmp[0]);
            this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = true;
            var payloads = [
                payload
            ];
            var batched = false;
            // Batch action
            if (payload.batch) {
                batched = true;
                payloads = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(payload.batch, function(item) {
                    item = (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, item), payload);
                    item.batch = null;
                    return item;
                });
            }
            var eventObjBatch = [];
            var eventObj;
            var isSelectChange = (0, $2bf82c0980125b62$export$72aea10e60e45351)(payload);
            var isHighDown = (0, $2bf82c0980125b62$export$aebe71265c1b77bf)(payload);
            // Only leave blur once if there are multiple batches.
            if (isHighDown) (0, $2bf82c0980125b62$export$b2a593c7b5243584)(this._api);
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(payloads, function(batchItem) {
                // Action can specify the event by return it.
                eventObj = actionWrap.action(batchItem, _this._model, _this._api);
                // Emit event outside
                eventObj = eventObj || (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, batchItem);
                // Convert type to eventType
                eventObj.type = actionInfo.event || eventObj.type;
                eventObjBatch.push(eventObj);
                // light update does not perform data process, layout and visual.
                if (isHighDown) {
                    var _a = $76d619f648247e6d$export$fe600815775d9400(payload), queryOptionMap = _a.queryOptionMap, mainTypeSpecified = _a.mainTypeSpecified;
                    var componentMainType = mainTypeSpecified ? queryOptionMap.keys()[0] : 'series';
                    $4d59907f44a2d0ad$var$updateDirectly(_this, updateMethod, batchItem, componentMainType);
                    $4d59907f44a2d0ad$var$markStatusToUpdate(_this);
                } else if (isSelectChange) {
                    // At present `dispatchAction({ type: 'select', ... })` is not supported on components.
                    // geo still use 'geoselect'.
                    $4d59907f44a2d0ad$var$updateDirectly(_this, updateMethod, batchItem, 'series');
                    $4d59907f44a2d0ad$var$markStatusToUpdate(_this);
                } else if (cptType) $4d59907f44a2d0ad$var$updateDirectly(_this, updateMethod, batchItem, cptType.main, cptType.sub);
            });
            if (updateMethod !== 'none' && !isHighDown && !isSelectChange && !cptType) try {
                // Still dirty
                if (this[$4d59907f44a2d0ad$var$PENDING_UPDATE]) {
                    $4d59907f44a2d0ad$var$prepare(this);
                    $4d59907f44a2d0ad$var$updateMethods.update.call(this, payload);
                    this[$4d59907f44a2d0ad$var$PENDING_UPDATE] = null;
                } else $4d59907f44a2d0ad$var$updateMethods[updateMethod].call(this, payload);
            } catch (e) {
                this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = false;
                throw e;
            }
            // Follow the rule of action batch
            if (batched) eventObj = {
                type: actionInfo.event || payloadType,
                escapeConnect: escapeConnect,
                batch: eventObjBatch
            };
            else eventObj = eventObjBatch[0];
            this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = false;
            if (!silent) {
                var messageCenter = this._messageCenter;
                messageCenter.trigger(eventObj.type, eventObj);
                // Extra triggered 'selectchanged' event
                if (isSelectChange) {
                    var newObj = {
                        type: 'selectchanged',
                        escapeConnect: escapeConnect,
                        selected: (0, $2bf82c0980125b62$export$c529643b619af6b3)(ecModel),
                        isFromClick: payload.isFromClick || false,
                        fromAction: payload.type,
                        fromActionPayload: payload
                    };
                    messageCenter.trigger(newObj.type, newObj);
                }
            }
        };
        $4d59907f44a2d0ad$var$flushPendingActions = function(silent) {
            var pendingActions = this._pendingActions;
            while(pendingActions.length){
                var payload = pendingActions.shift();
                $4d59907f44a2d0ad$var$doDispatchAction.call(this, payload, silent);
            }
        };
        $4d59907f44a2d0ad$var$triggerUpdatedEvent = function(silent) {
            !silent && this.trigger('updated');
        };
        /**
     * Event `rendered` is triggered when zr
     * rendered. It is useful for realtime
     * snapshot (reflect animation).
     *
     * Event `finished` is triggered when:
     * (1) zrender rendering finished.
     * (2) initial animation finished.
     * (3) progressive rendering finished.
     * (4) no pending action.
     * (5) no delayed setOption needs to be processed.
     */ $4d59907f44a2d0ad$var$bindRenderedEvent = function(zr, ecIns) {
            zr.on('rendered', function(params) {
                ecIns.trigger('rendered', params);
                // The `finished` event should not be triggered repeatedly,
                // so it should only be triggered when rendering indeed happens
                // in zrender. (Consider the case that dipatchAction is keep
                // triggering when mouse move).
                if (// Although zr is dirty if initial animation is not finished
                // and this checking is called on frame, we also check
                // animation finished for robustness.
                zr.animation.isFinished() && !ecIns[$4d59907f44a2d0ad$var$PENDING_UPDATE] && !ecIns._scheduler.unfinished && !ecIns._pendingActions.length) ecIns.trigger('finished');
            });
        };
        $4d59907f44a2d0ad$var$bindMouseEvent = function(zr, ecIns) {
            zr.on('mouseover', function(e) {
                var el = e.target;
                var dispatcher = (0, $808c5a2823518f68$export$8a4fca9e04eb4df6)(el, (0, $2bf82c0980125b62$export$77d1445f699c58b5));
                if (dispatcher) {
                    (0, $2bf82c0980125b62$export$416765b6198234ff)(dispatcher, e, ecIns._api);
                    $4d59907f44a2d0ad$var$markStatusToUpdate(ecIns);
                }
            }).on('mouseout', function(e) {
                var el = e.target;
                var dispatcher = (0, $808c5a2823518f68$export$8a4fca9e04eb4df6)(el, (0, $2bf82c0980125b62$export$77d1445f699c58b5));
                if (dispatcher) {
                    (0, $2bf82c0980125b62$export$bb1c7b62436282a)(dispatcher, e, ecIns._api);
                    $4d59907f44a2d0ad$var$markStatusToUpdate(ecIns);
                }
            }).on('click', function(e) {
                var el = e.target;
                var dispatcher = (0, $808c5a2823518f68$export$8a4fca9e04eb4df6)(el, function(target) {
                    return (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(target).dataIndex != null;
                }, true);
                if (dispatcher) {
                    var actionType = dispatcher.selected ? 'unselect' : 'select';
                    var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(dispatcher);
                    ecIns._api.dispatchAction({
                        type: actionType,
                        dataType: ecData.dataType,
                        dataIndexInside: ecData.dataIndex,
                        seriesIndex: ecData.seriesIndex,
                        isFromClick: true
                    });
                }
            });
        };
        function clearColorPalette(ecModel) {
            ecModel.clearColorPalette();
            ecModel.eachSeries(function(seriesModel) {
                seriesModel.clearColorPalette();
            });
        }
        // Allocate zlevels for series and components
        function allocateZlevels(ecModel) {
            var componentZLevels = [];
            var seriesZLevels = [];
            var hasSeparateZLevel = false;
            ecModel.eachComponent(function(componentType, componentModel) {
                var zlevel = componentModel.get('zlevel') || 0;
                var z = componentModel.get('z') || 0;
                var zlevelKey = componentModel.getZLevelKey();
                hasSeparateZLevel = hasSeparateZLevel || !!zlevelKey;
                (componentType === 'series' ? seriesZLevels : componentZLevels).push({
                    zlevel: zlevel,
                    z: z,
                    idx: componentModel.componentIndex,
                    type: componentType,
                    key: zlevelKey
                });
            });
            if (hasSeparateZLevel) {
                // Series after component
                var zLevels = componentZLevels.concat(seriesZLevels);
                var lastSeriesZLevel_1;
                var lastSeriesKey_1;
                (0, $97579a54749e4b24$export$2e2bcd8739ae039)(zLevels, function(a, b) {
                    if (a.zlevel === b.zlevel) return a.z - b.z;
                    return a.zlevel - b.zlevel;
                });
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(zLevels, function(item) {
                    var componentModel = ecModel.getComponent(item.type, item.idx);
                    var zlevel = item.zlevel;
                    var key = item.key;
                    if (lastSeriesZLevel_1 != null) zlevel = Math.max(lastSeriesZLevel_1, zlevel);
                    if (key) {
                        if (zlevel === lastSeriesZLevel_1 && key !== lastSeriesKey_1) zlevel++;
                        lastSeriesKey_1 = key;
                    } else if (lastSeriesKey_1) {
                        if (zlevel === lastSeriesZLevel_1) zlevel++;
                        lastSeriesKey_1 = '';
                    }
                    lastSeriesZLevel_1 = zlevel;
                    componentModel.setZLevel(zlevel);
                });
            }
        }
        $4d59907f44a2d0ad$var$render = function(ecIns, ecModel, api, payload, updateParams) {
            allocateZlevels(ecModel);
            $4d59907f44a2d0ad$var$renderComponents(ecIns, ecModel, api, payload, updateParams);
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(ecIns._chartsViews, function(chart) {
                chart.__alive = false;
            });
            $4d59907f44a2d0ad$var$renderSeries(ecIns, ecModel, api, payload, updateParams);
            // Remove groups of unrendered charts
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(ecIns._chartsViews, function(chart) {
                if (!chart.__alive) chart.remove(ecModel, api);
            });
        };
        $4d59907f44a2d0ad$var$renderComponents = function(ecIns, ecModel, api, payload, updateParams, dirtyList) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dirtyList || ecIns._componentsViews, function(componentView) {
                var componentModel = componentView.__model;
                clearStates(componentModel, componentView);
                componentView.render(componentModel, ecModel, api, payload);
                updateZ(componentModel, componentView);
                updateStates(componentModel, componentView);
            });
        };
        /**
     * Render each chart and component
     */ $4d59907f44a2d0ad$var$renderSeries = function(ecIns, ecModel, api, payload, updateParams, dirtyMap) {
            // Render all charts
            var scheduler = ecIns._scheduler;
            updateParams = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(updateParams || {}, {
                updatedSeries: ecModel.getSeries()
            });
            // TODO progressive?
            (0, $8022924a3c5c0bb5$export$2e2bcd8739ae039).trigger('series:beforeupdate', ecModel, api, updateParams);
            var unfinished = false;
            ecModel.eachSeries(function(seriesModel) {
                var chartView = ecIns._chartsMap[seriesModel.__viewId];
                chartView.__alive = true;
                var renderTask = chartView.renderTask;
                scheduler.updatePayload(renderTask, payload);
                // TODO states on marker.
                clearStates(seriesModel, chartView);
                if (dirtyMap && dirtyMap.get(seriesModel.uid)) renderTask.dirty();
                if (renderTask.perform(scheduler.getPerformArgs(renderTask))) unfinished = true;
                chartView.group.silent = !!seriesModel.get('silent');
                // Should not call markRedraw on group, because it will disable zrender
                // incremental render (always render from the __startIndex each frame)
                // chartView.group.markRedraw();
                updateBlend(seriesModel, chartView);
                (0, $2bf82c0980125b62$export$e4ea08ef52e0a73)(seriesModel);
            });
            scheduler.unfinished = unfinished || scheduler.unfinished;
            (0, $8022924a3c5c0bb5$export$2e2bcd8739ae039).trigger('series:layoutlabels', ecModel, api, updateParams);
            // transition after label is layouted.
            (0, $8022924a3c5c0bb5$export$2e2bcd8739ae039).trigger('series:transition', ecModel, api, updateParams);
            ecModel.eachSeries(function(seriesModel) {
                var chartView = ecIns._chartsMap[seriesModel.__viewId];
                // Update Z after labels updated. Before applying states.
                updateZ(seriesModel, chartView);
                // NOTE: Update states after label is updated.
                // label should be in normal status when layouting.
                updateStates(seriesModel, chartView);
            });
            // If use hover layer
            updateHoverLayerStatus(ecIns, ecModel);
            (0, $8022924a3c5c0bb5$export$2e2bcd8739ae039).trigger('series:afterupdate', ecModel, api, updateParams);
        };
        $4d59907f44a2d0ad$var$markStatusToUpdate = function(ecIns) {
            ecIns[$4d59907f44a2d0ad$var$STATUS_NEEDS_UPDATE_KEY] = true;
            // Wake up zrender if it's sleep. Let it update states in the next frame.
            ecIns.getZr().wakeUp();
        };
        $4d59907f44a2d0ad$var$applyChangedStates = function(ecIns) {
            if (!ecIns[$4d59907f44a2d0ad$var$STATUS_NEEDS_UPDATE_KEY]) return;
            ecIns.getZr().storage.traverse(function(el) {
                // Not applied on removed elements, it may still in fading.
                if ($8b353638fbedfefa$export$5b89d4b643713034(el)) return;
                applyElementStates(el);
            });
            ecIns[$4d59907f44a2d0ad$var$STATUS_NEEDS_UPDATE_KEY] = false;
        };
        function applyElementStates(el) {
            var newStates = [];
            var oldStates = el.currentStates;
            // Keep other states.
            for(var i = 0; i < oldStates.length; i++){
                var stateName = oldStates[i];
                if (!(stateName === 'emphasis' || stateName === 'blur' || stateName === 'select')) newStates.push(stateName);
            }
            // Only use states when it's exists.
            if (el.selected && el.states.select) newStates.push('select');
            if (el.hoverState === (0, $2bf82c0980125b62$export$f0f2bee145debb31) && el.states.emphasis) newStates.push('emphasis');
            else if (el.hoverState === (0, $2bf82c0980125b62$export$1307d6a87d56baa) && el.states.blur) newStates.push('blur');
            el.useStates(newStates);
        }
        function updateHoverLayerStatus(ecIns, ecModel) {
            var zr = ecIns._zr;
            var storage = zr.storage;
            var elCount = 0;
            storage.traverse(function(el) {
                if (!el.isGroup) elCount++;
            });
            if (elCount > ecModel.get('hoverLayerThreshold') && !(0, $ce6dd58693a21851$export$2e2bcd8739ae039).node && !(0, $ce6dd58693a21851$export$2e2bcd8739ae039).worker) ecModel.eachSeries(function(seriesModel) {
                if (seriesModel.preventUsingHoverLayer) return;
                var chartView = ecIns._chartsMap[seriesModel.__viewId];
                if (chartView.__alive) chartView.eachRendered(function(el) {
                    if (el.states.emphasis) el.states.emphasis.hoverLayer = true;
                });
            });
        }
        /**
     * Update chart and blend.
     */ function updateBlend(seriesModel, chartView) {
            var blendMode = seriesModel.get('blendMode') || null;
            chartView.eachRendered(function(el) {
                // FIXME marker and other components
                if (!el.isGroup) // DON'T mark the element dirty. In case element is incremental and don't want to rerender.
                el.style.blend = blendMode;
            });
        }
        function updateZ(model, view) {
            if (model.preventAutoZ) return;
            var z = model.get('z') || 0;
            var zlevel = model.get('zlevel') || 0;
            // Set z and zlevel
            view.eachRendered(function(el) {
                doUpdateZ(el, z, zlevel, -Infinity);
                // Don't traverse the children because it has been traversed in _updateZ.
                return true;
            });
        }
        function doUpdateZ(el, z, zlevel, maxZ2) {
            // Group may also have textContent
            var label = el.getTextContent();
            var labelLine = el.getTextGuideLine();
            var isGroup = el.isGroup;
            if (isGroup) {
                // set z & zlevel of children elements of Group
                var children = el.childrenRef();
                for(var i = 0; i < children.length; i++)maxZ2 = Math.max(doUpdateZ(children[i], z, zlevel, maxZ2), maxZ2);
            } else {
                // not Group
                el.z = z;
                el.zlevel = zlevel;
                maxZ2 = Math.max(el.z2, maxZ2);
            }
            // always set z and zlevel if label/labelLine exists
            if (label) {
                label.z = z;
                label.zlevel = zlevel;
                // lift z2 of text content
                // TODO if el.emphasis.z2 is spcefied, what about textContent.
                isFinite(maxZ2) && (label.z2 = maxZ2 + 2);
            }
            if (labelLine) {
                var textGuideLineConfig = el.textGuideLineConfig;
                labelLine.z = z;
                labelLine.zlevel = zlevel;
                isFinite(maxZ2) && (labelLine.z2 = maxZ2 + (textGuideLineConfig && textGuideLineConfig.showAbove ? 1 : -1));
            }
            return maxZ2;
        }
        // Clear states without animation.
        // TODO States on component.
        function clearStates(model, view) {
            view.eachRendered(function(el) {
                // Not applied on removed elements, it may still in fading.
                if ($8b353638fbedfefa$export$5b89d4b643713034(el)) return;
                var textContent = el.getTextContent();
                var textGuide = el.getTextGuideLine();
                if (el.stateTransition) el.stateTransition = null;
                if (textContent && textContent.stateTransition) textContent.stateTransition = null;
                if (textGuide && textGuide.stateTransition) textGuide.stateTransition = null;
                // TODO If el is incremental.
                if (el.hasState()) {
                    el.prevStates = el.currentStates;
                    el.clearStates();
                } else if (el.prevStates) el.prevStates = null;
            });
        }
        function updateStates(model, view) {
            var stateAnimationModel = model.getModel('stateAnimation');
            var enableAnimation = model.isAnimationEnabled();
            var duration = stateAnimationModel.get('duration');
            var stateTransition = duration > 0 ? {
                duration: duration,
                delay: stateAnimationModel.get('delay'),
                easing: stateAnimationModel.get('easing')
            } : null;
            view.eachRendered(function(el) {
                if (el.states && el.states.emphasis) {
                    // Not applied on removed elements, it may still in fading.
                    if ($8b353638fbedfefa$export$5b89d4b643713034(el)) return;
                    if (el instanceof $b02ffe7acd508c08$export$2e2bcd8739ae039) (0, $2bf82c0980125b62$export$9fe78019e6f395b6)(el);
                    // Only updated on changed element. In case element is incremental and don't want to rerender.
                    // TODO, a more proper way?
                    if (el.__dirty) {
                        var prevStates = el.prevStates;
                        // Restore states without animation
                        if (prevStates) el.useStates(prevStates);
                    }
                    // Update state transition and enable animation again.
                    if (enableAnimation) {
                        el.stateTransition = stateTransition;
                        var textContent = el.getTextContent();
                        var textGuide = el.getTextGuideLine();
                        // TODO Is it necessary to animate label?
                        if (textContent) textContent.stateTransition = stateTransition;
                        if (textGuide) textGuide.stateTransition = stateTransition;
                    }
                    // Use highlighted and selected flag to toggle states.
                    if (el.__dirty) applyElementStates(el);
                }
            });
        }
        $4d59907f44a2d0ad$var$createExtensionAPI = function(ecIns) {
            return new /** @class */ (function(_super) {
                (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(class_1, _super);
                function class_1() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                class_1.prototype.getCoordinateSystems = function() {
                    return ecIns._coordSysMgr.getCoordinateSystems();
                };
                class_1.prototype.getComponentByElement = function(el) {
                    while(el){
                        var modelInfo = el.__ecComponentInfo;
                        if (modelInfo != null) return ecIns._model.getComponent(modelInfo.mainType, modelInfo.index);
                        el = el.parent;
                    }
                };
                class_1.prototype.enterEmphasis = function(el, highlightDigit) {
                    (0, $2bf82c0980125b62$export$b2d02638cc34c042)(el, highlightDigit);
                    $4d59907f44a2d0ad$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.leaveEmphasis = function(el, highlightDigit) {
                    (0, $2bf82c0980125b62$export$11be6f716239ac55)(el, highlightDigit);
                    $4d59907f44a2d0ad$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.enterBlur = function(el) {
                    (0, $2bf82c0980125b62$export$207f9cb3e1099375)(el);
                    $4d59907f44a2d0ad$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.leaveBlur = function(el) {
                    (0, $2bf82c0980125b62$export$fd4a9ec75456d3c1)(el);
                    $4d59907f44a2d0ad$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.enterSelect = function(el) {
                    (0, $2bf82c0980125b62$export$252d028dda8ef765)(el);
                    $4d59907f44a2d0ad$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.leaveSelect = function(el) {
                    (0, $2bf82c0980125b62$export$ea9a904bd6e32bd3)(el);
                    $4d59907f44a2d0ad$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.getModel = function() {
                    return ecIns.getModel();
                };
                class_1.prototype.getViewOfComponentModel = function(componentModel) {
                    return ecIns.getViewOfComponentModel(componentModel);
                };
                class_1.prototype.getViewOfSeriesModel = function(seriesModel) {
                    return ecIns.getViewOfSeriesModel(seriesModel);
                };
                return class_1;
            }((0, $a6d7e6163195660e$export$2e2bcd8739ae039)))(ecIns);
        };
        $4d59907f44a2d0ad$var$enableConnect = function(chart) {
            function updateConnectedChartsStatus(charts, status) {
                for(var i = 0; i < charts.length; i++){
                    var otherChart = charts[i];
                    otherChart[$4d59907f44a2d0ad$var$CONNECT_STATUS_KEY] = status;
                }
            }
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($4d59907f44a2d0ad$var$eventActionMap, function(actionType, eventType) {
                chart._messageCenter.on(eventType, function(event) {
                    if ($4d59907f44a2d0ad$var$connectedGroups[chart.group] && chart[$4d59907f44a2d0ad$var$CONNECT_STATUS_KEY] !== $4d59907f44a2d0ad$var$CONNECT_STATUS_PENDING) {
                        if (event && event.escapeConnect) return;
                        var action_1 = chart.makeActionFromEvent(event);
                        var otherCharts_1 = [];
                        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($4d59907f44a2d0ad$var$instances, function(otherChart) {
                            if (otherChart !== chart && otherChart.group === chart.group) otherCharts_1.push(otherChart);
                        });
                        updateConnectedChartsStatus(otherCharts_1, $4d59907f44a2d0ad$var$CONNECT_STATUS_PENDING);
                        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(otherCharts_1, function(otherChart) {
                            if (otherChart[$4d59907f44a2d0ad$var$CONNECT_STATUS_KEY] !== $4d59907f44a2d0ad$var$CONNECT_STATUS_UPDATING) otherChart.dispatchAction(action_1);
                        });
                        updateConnectedChartsStatus(otherCharts_1, $4d59907f44a2d0ad$var$CONNECT_STATUS_UPDATED);
                    }
                });
            });
        };
    }();
    return ECharts;
}((0, $63441a86293f101f$export$2e2bcd8739ae039));
var $4d59907f44a2d0ad$var$echartsProto = $4d59907f44a2d0ad$var$ECharts.prototype;
$4d59907f44a2d0ad$var$echartsProto.on = $4d59907f44a2d0ad$var$createRegisterEventWithLowercaseECharts('on');
$4d59907f44a2d0ad$var$echartsProto.off = $4d59907f44a2d0ad$var$createRegisterEventWithLowercaseECharts('off');
/**
 * @deprecated
 */ // @ts-ignore
$4d59907f44a2d0ad$var$echartsProto.one = function(eventName, cb, ctx) {
    var self = this;
    (0, $84bc7667c27ccedc$export$4a9c0b74eb885aa1)('ECharts#one is deprecated.');
    function wrapped() {
        var args2 = [];
        for(var _i = 0; _i < arguments.length; _i++)args2[_i] = arguments[_i];
        cb && cb.apply && cb.apply(this, args2);
        // @ts-ignore
        self.off(eventName, wrapped);
    }
    // @ts-ignore
    this.on.call(this, eventName, wrapped, ctx);
};
var $4d59907f44a2d0ad$var$MOUSE_EVENT_NAMES = [
    'click',
    'dblclick',
    'mouseover',
    'mouseout',
    'mousemove',
    'mousedown',
    'mouseup',
    'globalout',
    'contextmenu'
];
function $4d59907f44a2d0ad$var$disposedWarning(id) {}
var $4d59907f44a2d0ad$var$actions = {};
/**
 * Map eventType to actionType
 */ var $4d59907f44a2d0ad$var$eventActionMap = {};
var $4d59907f44a2d0ad$var$dataProcessorFuncs = [];
var $4d59907f44a2d0ad$var$optionPreprocessorFuncs = [];
var $4d59907f44a2d0ad$var$visualFuncs = [];
var $4d59907f44a2d0ad$var$themeStorage = {};
var $4d59907f44a2d0ad$var$loadingEffects = {};
var $4d59907f44a2d0ad$var$instances = {};
var $4d59907f44a2d0ad$var$connectedGroups = {};
var $4d59907f44a2d0ad$var$idBase = +new Date() - 0;
var $4d59907f44a2d0ad$var$groupIdBase = +new Date() - 0;
var $4d59907f44a2d0ad$var$DOM_ATTRIBUTE_KEY = '_echarts_instance_';
function $4d59907f44a2d0ad$export$2cd8252107eb640b(dom, theme, opts) {
    var isClient = !(opts && opts.ssr);
    if (isClient) {
        var existInstance = $4d59907f44a2d0ad$export$33b6fbccd4f643f8(dom);
        if (existInstance) return existInstance;
    }
    var chart = new $4d59907f44a2d0ad$var$ECharts(dom, theme, opts);
    chart.id = 'ec_' + $4d59907f44a2d0ad$var$idBase++;
    $4d59907f44a2d0ad$var$instances[chart.id] = chart;
    isClient && $76d619f648247e6d$export$9fec4d97f1922e0b(dom, $4d59907f44a2d0ad$var$DOM_ATTRIBUTE_KEY, chart.id);
    $4d59907f44a2d0ad$var$enableConnect(chart);
    (0, $8022924a3c5c0bb5$export$2e2bcd8739ae039).trigger('afterinit', chart);
    return chart;
}
function $4d59907f44a2d0ad$export$64605811ab45167f(groupId) {
    // Is array of charts
    if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(groupId)) {
        var charts = groupId;
        groupId = null;
        // If any chart has group
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(charts, function(chart) {
            if (chart.group != null) groupId = chart.group;
        });
        groupId = groupId || 'g_' + $4d59907f44a2d0ad$var$groupIdBase++;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(charts, function(chart) {
            chart.group = groupId;
        });
    }
    $4d59907f44a2d0ad$var$connectedGroups[groupId] = true;
    return groupId;
}
function $4d59907f44a2d0ad$export$37dfea93db2e14ed(groupId) {
    $4d59907f44a2d0ad$var$connectedGroups[groupId] = false;
}
var $4d59907f44a2d0ad$export$87cd6834112ecb52 = $4d59907f44a2d0ad$export$37dfea93db2e14ed;
function $4d59907f44a2d0ad$export$fcfbbcec2cb820d5(chart) {
    if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(chart)) chart = $4d59907f44a2d0ad$var$instances[chart];
    else if (!(chart instanceof $4d59907f44a2d0ad$var$ECharts)) // Try to treat as dom
    chart = $4d59907f44a2d0ad$export$33b6fbccd4f643f8(chart);
    if (chart instanceof $4d59907f44a2d0ad$var$ECharts && !chart.isDisposed()) chart.dispose();
}
function $4d59907f44a2d0ad$export$33b6fbccd4f643f8(dom) {
    return $4d59907f44a2d0ad$var$instances[$76d619f648247e6d$export$735ee1799fd02602(dom, $4d59907f44a2d0ad$var$DOM_ATTRIBUTE_KEY)];
}
function $4d59907f44a2d0ad$export$89b4be35062c4a3f(key) {
    return $4d59907f44a2d0ad$var$instances[key];
}
function $4d59907f44a2d0ad$export$f9c59eed5de5ff80(name, theme) {
    $4d59907f44a2d0ad$var$themeStorage[name] = theme;
}
function $4d59907f44a2d0ad$export$77095792a057b768(preprocessorFunc) {
    if ((0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)($4d59907f44a2d0ad$var$optionPreprocessorFuncs, preprocessorFunc) < 0) $4d59907f44a2d0ad$var$optionPreprocessorFuncs.push(preprocessorFunc);
}
function $4d59907f44a2d0ad$export$d575e6557ac1729f(priority, processor) {
    $4d59907f44a2d0ad$var$normalizeRegister($4d59907f44a2d0ad$var$dataProcessorFuncs, priority, processor, $4d59907f44a2d0ad$var$PRIORITY_PROCESSOR_DEFAULT);
}
function $4d59907f44a2d0ad$export$c8c249911ee8c1ed(postInitFunc) {
    $4d59907f44a2d0ad$export$c9ec4b5faef04865('afterinit', postInitFunc);
}
function $4d59907f44a2d0ad$export$99560909c18c76bb(postUpdateFunc) {
    $4d59907f44a2d0ad$export$c9ec4b5faef04865('afterupdate', postUpdateFunc);
}
function $4d59907f44a2d0ad$export$c9ec4b5faef04865(name, cb) {
    (0, $8022924a3c5c0bb5$export$2e2bcd8739ae039).on(name, cb);
}
function $4d59907f44a2d0ad$export$408c24786cd729c6(actionInfo, eventName, action) {
    if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(eventName)) {
        action = eventName;
        eventName = '';
    }
    var actionType = (0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(actionInfo) ? actionInfo.type : [
        actionInfo,
        actionInfo = {
            event: eventName
        }
    ][0];
    // Event name is all lowercase
    actionInfo.event = (actionInfo.event || actionType).toLowerCase();
    eventName = actionInfo.event;
    if ($4d59907f44a2d0ad$var$eventActionMap[eventName]) // Already registered.
    return;
    // Validate action type and event name.
    (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)($4d59907f44a2d0ad$var$ACTION_REG.test(actionType) && $4d59907f44a2d0ad$var$ACTION_REG.test(eventName));
    if (!$4d59907f44a2d0ad$var$actions[actionType]) $4d59907f44a2d0ad$var$actions[actionType] = {
        action: action,
        actionInfo: actionInfo
    };
    $4d59907f44a2d0ad$var$eventActionMap[eventName] = actionType;
}
function $4d59907f44a2d0ad$export$1dd5e025a8a37dd(type, coordSysCreator) {
    (0, $70c3ede7d3b64757$export$2e2bcd8739ae039).register(type, coordSysCreator);
}
function $4d59907f44a2d0ad$export$fc2638719e4159b9(type) {
    var coordSysCreator = (0, $70c3ede7d3b64757$export$2e2bcd8739ae039).get(type);
    if (coordSysCreator) return coordSysCreator.getDimensionsInfo ? coordSysCreator.getDimensionsInfo() : coordSysCreator.dimensions.slice();
}
function $4d59907f44a2d0ad$export$d768f97700ca6bea(priority, layoutTask) {
    $4d59907f44a2d0ad$var$normalizeRegister($4d59907f44a2d0ad$var$visualFuncs, priority, layoutTask, $4d59907f44a2d0ad$var$PRIORITY_VISUAL_LAYOUT, 'layout');
}
function $4d59907f44a2d0ad$export$5f32c1eb94c381bb(priority, visualTask) {
    $4d59907f44a2d0ad$var$normalizeRegister($4d59907f44a2d0ad$var$visualFuncs, priority, visualTask, $4d59907f44a2d0ad$var$PRIORITY_VISUAL_CHART, 'visual');
}
var $4d59907f44a2d0ad$var$registeredTasks = [];
function $4d59907f44a2d0ad$var$normalizeRegister(targetList, priority, fn, defaultPriority, visualType) {
    if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(priority) || (0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(priority)) {
        fn = priority;
        priority = defaultPriority;
    }
    // Already registered
    if ((0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)($4d59907f44a2d0ad$var$registeredTasks, fn) >= 0) return;
    $4d59907f44a2d0ad$var$registeredTasks.push(fn);
    var stageHandler = (0, $94ae4e8744638a8a$export$2e2bcd8739ae039).wrapStageHandler(fn, visualType);
    stageHandler.__prio = priority;
    stageHandler.__raw = fn;
    targetList.push(stageHandler);
}
function $4d59907f44a2d0ad$export$e06b68a82007c015(name, loadingFx) {
    $4d59907f44a2d0ad$var$loadingEffects[name] = loadingFx;
}
function $4d59907f44a2d0ad$export$10425ea7a243b114(creator) {
    (0, $c6341dcc9d86826e$export$61bcfd79465c1b7c)({
        createCanvas: creator
    });
}
function $4d59907f44a2d0ad$export$d456de060be2dba1(mapName, geoJson, specialAreas) {
    var registerMap = (0, $f773aa0508c1d920$export$73333eb8a09d5f61)('registerMap');
    registerMap && registerMap(mapName, geoJson, specialAreas);
}
function $4d59907f44a2d0ad$export$b8586192aead8a7e(mapName) {
    var getMap = (0, $f773aa0508c1d920$export$73333eb8a09d5f61)('getMap');
    return getMap && getMap(mapName);
}
var $4d59907f44a2d0ad$export$f01d71dd0389d7e4 = (0, $523dedd0a2328c06$export$92c96c6d8b255b7d);
/**
 * Globa dispatchAction to a specified chart instance.
 */ // export function dispatchAction(payload: { chartId: string } & Payload, opt?: Parameters<ECharts['dispatchAction']>[1]) {
//     if (!payload || !payload.chartId) {
//         // Must have chartId to find chart
//         return;
//     }
//     const chart = instances[payload.chartId];
//     if (chart) {
//         chart.dispatchAction(payload, opt);
//     }
// }
// Builtin global visual
$4d59907f44a2d0ad$export$5f32c1eb94c381bb($4d59907f44a2d0ad$var$PRIORITY_VISUAL_GLOBAL, (0, $a617f62dd17b10f1$export$7ce4d65f9b69240));
$4d59907f44a2d0ad$export$5f32c1eb94c381bb($4d59907f44a2d0ad$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, $a617f62dd17b10f1$export$f7dcb66a065003d1));
$4d59907f44a2d0ad$export$5f32c1eb94c381bb($4d59907f44a2d0ad$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, $a617f62dd17b10f1$export$cf9758b0d6dc0aa9));
$4d59907f44a2d0ad$export$5f32c1eb94c381bb($4d59907f44a2d0ad$var$PRIORITY_VISUAL_GLOBAL, (0, $f8e1f1a448782588$export$144ac3beded415d9));
$4d59907f44a2d0ad$export$5f32c1eb94c381bb($4d59907f44a2d0ad$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, $f8e1f1a448782588$export$435b956f7f1071fb));
$4d59907f44a2d0ad$export$5f32c1eb94c381bb($4d59907f44a2d0ad$var$PRIORITY_VISUAL_DECAL, (0, $d82adaf1a5a5cfeb$export$2e2bcd8739ae039));
$4d59907f44a2d0ad$export$77095792a057b768((0, $c4489ebdf95633b6$export$2e2bcd8739ae039));
$4d59907f44a2d0ad$export$d575e6557ac1729f($4d59907f44a2d0ad$var$PRIORITY_PROCESSOR_DATASTACK, (0, $92eb0b43a1e7607a$export$2e2bcd8739ae039));
$4d59907f44a2d0ad$export$e06b68a82007c015('default', (0, $f23f99c31dceac8f$export$2e2bcd8739ae039));
// Default actions
$4d59907f44a2d0ad$export$408c24786cd729c6({
    type: (0, $2bf82c0980125b62$export$df035d873a9de64f),
    event: (0, $2bf82c0980125b62$export$df035d873a9de64f),
    update: (0, $2bf82c0980125b62$export$df035d873a9de64f)
}, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));
$4d59907f44a2d0ad$export$408c24786cd729c6({
    type: (0, $2bf82c0980125b62$export$f8a2f7807cc185ea),
    event: (0, $2bf82c0980125b62$export$f8a2f7807cc185ea),
    update: (0, $2bf82c0980125b62$export$f8a2f7807cc185ea)
}, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));
$4d59907f44a2d0ad$export$408c24786cd729c6({
    type: (0, $2bf82c0980125b62$export$89616263e7d38fe9),
    event: (0, $2bf82c0980125b62$export$89616263e7d38fe9),
    update: (0, $2bf82c0980125b62$export$89616263e7d38fe9)
}, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));
$4d59907f44a2d0ad$export$408c24786cd729c6({
    type: (0, $2bf82c0980125b62$export$7636ad95c0f68a79),
    event: (0, $2bf82c0980125b62$export$7636ad95c0f68a79),
    update: (0, $2bf82c0980125b62$export$7636ad95c0f68a79)
}, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));
$4d59907f44a2d0ad$export$408c24786cd729c6({
    type: (0, $2bf82c0980125b62$export$1e90ed8a25542516),
    event: (0, $2bf82c0980125b62$export$1e90ed8a25542516),
    update: (0, $2bf82c0980125b62$export$1e90ed8a25542516)
}, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));
// Default theme
$4d59907f44a2d0ad$export$f9c59eed5de5ff80('light', (0, $0e5dbddd76825050$export$2e2bcd8739ae039));
$4d59907f44a2d0ad$export$f9c59eed5de5ff80('dark', (0, $985c98ffd51c6ff6$export$2e2bcd8739ae039));
var $4d59907f44a2d0ad$export$73cae5e090579589 = {};









var $d657479d857c7ab3$var$extensions = [];
var $d657479d857c7ab3$var$extensionRegisters = {
    registerPreprocessor: (0, $4d59907f44a2d0ad$export$77095792a057b768),
    registerProcessor: (0, $4d59907f44a2d0ad$export$d575e6557ac1729f),
    registerPostInit: (0, $4d59907f44a2d0ad$export$c8c249911ee8c1ed),
    registerPostUpdate: (0, $4d59907f44a2d0ad$export$99560909c18c76bb),
    registerUpdateLifecycle: (0, $4d59907f44a2d0ad$export$c9ec4b5faef04865),
    registerAction: (0, $4d59907f44a2d0ad$export$408c24786cd729c6),
    registerCoordinateSystem: (0, $4d59907f44a2d0ad$export$1dd5e025a8a37dd),
    registerLayout: (0, $4d59907f44a2d0ad$export$d768f97700ca6bea),
    registerVisual: (0, $4d59907f44a2d0ad$export$5f32c1eb94c381bb),
    registerTransform: (0, $4d59907f44a2d0ad$export$f01d71dd0389d7e4),
    registerLoading: (0, $4d59907f44a2d0ad$export$e06b68a82007c015),
    registerMap: (0, $4d59907f44a2d0ad$export$d456de060be2dba1),
    registerImpl: (0, $f773aa0508c1d920$export$9b808fd12256ddd3),
    PRIORITY: (0, $4d59907f44a2d0ad$export$bb34f3538ba26c7e),
    ComponentModel: (0, $116d65051f61bdfe$export$2e2bcd8739ae039),
    ComponentView: (0, $737c88aa0711f65a$export$2e2bcd8739ae039),
    SeriesModel: (0, $7c10febb2cdef0d8$export$2e2bcd8739ae039),
    ChartView: (0, $0dc5061053e23cd3$export$2e2bcd8739ae039),
    // TODO Use ComponentModel and SeriesModel instead of Constructor
    registerComponentModel: function(ComponentModelClass) {
        (0, $116d65051f61bdfe$export$2e2bcd8739ae039).registerClass(ComponentModelClass);
    },
    registerComponentView: function(ComponentViewClass) {
        (0, $737c88aa0711f65a$export$2e2bcd8739ae039).registerClass(ComponentViewClass);
    },
    registerSeriesModel: function(SeriesModelClass) {
        (0, $7c10febb2cdef0d8$export$2e2bcd8739ae039).registerClass(SeriesModelClass);
    },
    registerChartView: function(ChartViewClass) {
        (0, $0dc5061053e23cd3$export$2e2bcd8739ae039).registerClass(ChartViewClass);
    },
    registerSubTypeDefaulter: function(componentType, defaulter) {
        (0, $116d65051f61bdfe$export$2e2bcd8739ae039).registerSubTypeDefaulter(componentType, defaulter);
    },
    registerPainter: function(painterType, PainterCtor) {
        (0, $6eba88f9eebe6af9$export$a3e793ccb11823a5)(painterType, PainterCtor);
    }
};
function $d657479d857c7ab3$export$1f96ae73734a86cc(ext) {
    if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(ext)) {
        // use([ChartLine, ChartBar]);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(ext, function(singleExt) {
            $d657479d857c7ab3$export$1f96ae73734a86cc(singleExt);
        });
        return;
    }
    if ((0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)($d657479d857c7ab3$var$extensions, ext) >= 0) return;
    $d657479d857c7ab3$var$extensions.push(ext);
    if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(ext)) ext = {
        install: ext
    };
    ext.install($d657479d857c7ab3$var$extensionRegisters);
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 










function $f88637d76300101e$var$createDom(id, painter, dpr) {
    var newDom = (0, $c6341dcc9d86826e$export$ef5e599365494451).createCanvas();
    var width = painter.getWidth();
    var height = painter.getHeight();
    var newDomStyle = newDom.style;
    if (newDomStyle) {
        newDomStyle.position = 'absolute';
        newDomStyle.left = '0';
        newDomStyle.top = '0';
        newDomStyle.width = width + 'px';
        newDomStyle.height = height + 'px';
        newDom.setAttribute('data-zr-dom-id', id);
    }
    newDom.width = width * dpr;
    newDom.height = height * dpr;
    return newDom;
}
var $f88637d76300101e$var$Layer = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Layer, _super);
    function Layer(id, painter, dpr) {
        var _this = _super.call(this) || this;
        _this.motionBlur = false;
        _this.lastFrameAlpha = 0.7;
        _this.dpr = 1;
        _this.virtual = false;
        _this.config = {};
        _this.incremental = false;
        _this.zlevel = 0;
        _this.maxRepaintRectCount = 5;
        _this.__dirty = true;
        _this.__firstTimePaint = true;
        _this.__used = false;
        _this.__drawIndex = 0;
        _this.__startIndex = 0;
        _this.__endIndex = 0;
        _this.__prevStartIndex = null;
        _this.__prevEndIndex = null;
        var dom;
        dpr = dpr || (0, $4b0cedd85979c776$export$508f096bfcdaac40);
        if (typeof id === 'string') dom = $f88637d76300101e$var$createDom(id, painter, dpr);
        else if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(id)) {
            dom = id;
            id = dom.id;
        }
        _this.id = id;
        _this.dom = dom;
        var domStyle = dom.style;
        if (domStyle) {
            $7a1bd9c2710fea0d$export$23a5d775868fdd2c(dom);
            dom.onselectstart = function() {
                return false;
            };
            domStyle.padding = '0';
            domStyle.margin = '0';
            domStyle.borderWidth = '0';
        }
        _this.painter = painter;
        _this.dpr = dpr;
        return _this;
    }
    Layer.prototype.getElementCount = function() {
        return this.__endIndex - this.__startIndex;
    };
    Layer.prototype.afterBrush = function() {
        this.__prevStartIndex = this.__startIndex;
        this.__prevEndIndex = this.__endIndex;
    };
    Layer.prototype.initContext = function() {
        this.ctx = this.dom.getContext('2d');
        this.ctx.dpr = this.dpr;
    };
    Layer.prototype.setUnpainted = function() {
        this.__firstTimePaint = true;
    };
    Layer.prototype.createBackBuffer = function() {
        var dpr = this.dpr;
        this.domBack = $f88637d76300101e$var$createDom('back-' + this.id, this.painter, dpr);
        this.ctxBack = this.domBack.getContext('2d');
        if (dpr !== 1) this.ctxBack.scale(dpr, dpr);
    };
    Layer.prototype.createRepaintRects = function(displayList, prevList, viewWidth, viewHeight) {
        if (this.__firstTimePaint) {
            this.__firstTimePaint = false;
            return null;
        }
        var mergedRepaintRects = [];
        var maxRepaintRectCount = this.maxRepaintRectCount;
        var full = false;
        var pendingRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
        function addRectToMergePool(rect) {
            if (!rect.isFinite() || rect.isZero()) return;
            if (mergedRepaintRects.length === 0) {
                var boundingRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
                boundingRect.copy(rect);
                mergedRepaintRects.push(boundingRect);
            } else {
                var isMerged = false;
                var minDeltaArea = Infinity;
                var bestRectToMergeIdx = 0;
                for(var i = 0; i < mergedRepaintRects.length; ++i){
                    var mergedRect = mergedRepaintRects[i];
                    if (mergedRect.intersect(rect)) {
                        var pendingRect_1 = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
                        pendingRect_1.copy(mergedRect);
                        pendingRect_1.union(rect);
                        mergedRepaintRects[i] = pendingRect_1;
                        isMerged = true;
                        break;
                    } else if (full) {
                        pendingRect.copy(rect);
                        pendingRect.union(mergedRect);
                        var aArea = rect.width * rect.height;
                        var bArea = mergedRect.width * mergedRect.height;
                        var pendingArea = pendingRect.width * pendingRect.height;
                        var deltaArea = pendingArea - aArea - bArea;
                        if (deltaArea < minDeltaArea) {
                            minDeltaArea = deltaArea;
                            bestRectToMergeIdx = i;
                        }
                    }
                }
                if (full) {
                    mergedRepaintRects[bestRectToMergeIdx].union(rect);
                    isMerged = true;
                }
                if (!isMerged) {
                    var boundingRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
                    boundingRect.copy(rect);
                    mergedRepaintRects.push(boundingRect);
                }
                if (!full) full = mergedRepaintRects.length >= maxRepaintRectCount;
            }
        }
        for(var i = this.__startIndex; i < this.__endIndex; ++i){
            var el = displayList[i];
            if (el) {
                var shouldPaint = el.shouldBePainted(viewWidth, viewHeight, true, true);
                var prevRect = el.__isRendered && (el.__dirty & (0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd) || !shouldPaint) ? el.getPrevPaintRect() : null;
                if (prevRect) addRectToMergePool(prevRect);
                var curRect = shouldPaint && (el.__dirty & (0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd) || !el.__isRendered) ? el.getPaintRect() : null;
                if (curRect) addRectToMergePool(curRect);
            }
        }
        for(var i = this.__prevStartIndex; i < this.__prevEndIndex; ++i){
            var el = prevList[i];
            var shouldPaint = el && el.shouldBePainted(viewWidth, viewHeight, true, true);
            if (el && (!shouldPaint || !el.__zr) && el.__isRendered) {
                var prevRect = el.getPrevPaintRect();
                if (prevRect) addRectToMergePool(prevRect);
            }
        }
        var hasIntersections;
        do {
            hasIntersections = false;
            for(var i = 0; i < mergedRepaintRects.length;){
                if (mergedRepaintRects[i].isZero()) {
                    mergedRepaintRects.splice(i, 1);
                    continue;
                }
                for(var j = i + 1; j < mergedRepaintRects.length;)if (mergedRepaintRects[i].intersect(mergedRepaintRects[j])) {
                    hasIntersections = true;
                    mergedRepaintRects[i].union(mergedRepaintRects[j]);
                    mergedRepaintRects.splice(j, 1);
                } else j++;
                i++;
            }
        }while (hasIntersections);
        this._paintRects = mergedRepaintRects;
        return mergedRepaintRects;
    };
    Layer.prototype.debugGetPaintRects = function() {
        return (this._paintRects || []).slice();
    };
    Layer.prototype.resize = function(width, height) {
        var dpr = this.dpr;
        var dom = this.dom;
        var domStyle = dom.style;
        var domBack = this.domBack;
        if (domStyle) {
            domStyle.width = width + 'px';
            domStyle.height = height + 'px';
        }
        dom.width = width * dpr;
        dom.height = height * dpr;
        if (domBack) {
            domBack.width = width * dpr;
            domBack.height = height * dpr;
            if (dpr !== 1) this.ctxBack.scale(dpr, dpr);
        }
    };
    Layer.prototype.clear = function(clearAll, clearColor, repaintRects) {
        var dom = this.dom;
        var ctx = this.ctx;
        var width = dom.width;
        var height = dom.height;
        clearColor = clearColor || this.clearColor;
        var haveMotionBLur = this.motionBlur && !clearAll;
        var lastFrameAlpha = this.lastFrameAlpha;
        var dpr = this.dpr;
        var self = this;
        if (haveMotionBLur) {
            if (!this.domBack) this.createBackBuffer();
            this.ctxBack.globalCompositeOperation = 'copy';
            this.ctxBack.drawImage(dom, 0, 0, width / dpr, height / dpr);
        }
        var domBack = this.domBack;
        function doClear(x, y, width, height) {
            ctx.clearRect(x, y, width, height);
            if (clearColor && clearColor !== 'transparent') {
                var clearColorGradientOrPattern = void 0;
                if ($7a1bd9c2710fea0d$export$fa2c283003ed971c(clearColor)) {
                    var shouldCache = clearColor.global || clearColor.__width === width && clearColor.__height === height;
                    clearColorGradientOrPattern = shouldCache && clearColor.__canvasGradient || (0, $d76b6507633b3c44$export$3dab6afd018d48c7)(ctx, clearColor, {
                        x: 0,
                        y: 0,
                        width: width,
                        height: height
                    });
                    clearColor.__canvasGradient = clearColorGradientOrPattern;
                    clearColor.__width = width;
                    clearColor.__height = height;
                } else if ($7a1bd9c2710fea0d$export$a49bbf3a55dcef7b(clearColor)) {
                    clearColor.scaleX = clearColor.scaleX || dpr;
                    clearColor.scaleY = clearColor.scaleY || dpr;
                    clearColorGradientOrPattern = (0, $4f71e35e4552e3dd$export$8eb5db6b7bc27903)(ctx, clearColor, {
                        dirty: function() {
                            self.setUnpainted();
                            self.painter.refresh();
                        }
                    });
                }
                ctx.save();
                ctx.fillStyle = clearColorGradientOrPattern || clearColor;
                ctx.fillRect(x, y, width, height);
                ctx.restore();
            }
            if (haveMotionBLur) {
                ctx.save();
                ctx.globalAlpha = lastFrameAlpha;
                ctx.drawImage(domBack, x, y, width, height);
                ctx.restore();
            }
        }
        if (!repaintRects || haveMotionBLur) doClear(0, 0, width, height);
        else if (repaintRects.length) $7a1bd9c2710fea0d$export$79b2f7037acddd43(repaintRects, function(rect) {
            doClear(rect.x * dpr, rect.y * dpr, rect.width * dpr, rect.height * dpr);
        });
    };
    return Layer;
}((0, $63441a86293f101f$export$2e2bcd8739ae039));
var $f88637d76300101e$export$2e2bcd8739ae039 = $f88637d76300101e$var$Layer;







var $19d742a3d88cea2b$var$HOVER_LAYER_ZLEVEL = 1e5;
var $19d742a3d88cea2b$var$CANVAS_ZLEVEL = 314159;
var $19d742a3d88cea2b$var$EL_AFTER_INCREMENTAL_INC = 0.01;
var $19d742a3d88cea2b$var$INCREMENTAL_INC = 0.001;
function $19d742a3d88cea2b$var$isLayerValid(layer) {
    if (!layer) return false;
    if (layer.__builtin__) return true;
    if (typeof layer.resize !== 'function' || typeof layer.refresh !== 'function') return false;
    return true;
}
function $19d742a3d88cea2b$var$createRoot(width, height) {
    var domRoot = document.createElement('div');
    domRoot.style.cssText = [
        'position:relative',
        'width:' + width + 'px',
        'height:' + height + 'px',
        'padding:0',
        'margin:0',
        'border-width:0'
    ].join(';') + ';';
    return domRoot;
}
var $19d742a3d88cea2b$var$CanvasPainter = function() {
    function CanvasPainter(root, storage, opts, id) {
        this.type = 'canvas';
        this._zlevelList = [];
        this._prevDisplayList = [];
        this._layers = {};
        this._layerConfig = {};
        this._needsManuallyCompositing = false;
        this.type = 'canvas';
        var singleCanvas = !root.nodeName || root.nodeName.toUpperCase() === 'CANVAS';
        this._opts = opts = $7a1bd9c2710fea0d$export$8b58be045bf06082({}, opts || {});
        this.dpr = opts.devicePixelRatio || (0, $4b0cedd85979c776$export$508f096bfcdaac40);
        this._singleCanvas = singleCanvas;
        this.root = root;
        var rootStyle = root.style;
        if (rootStyle) {
            $7a1bd9c2710fea0d$export$23a5d775868fdd2c(root);
            root.innerHTML = '';
        }
        this.storage = storage;
        var zlevelList = this._zlevelList;
        this._prevDisplayList = [];
        var layers = this._layers;
        if (!singleCanvas) {
            this._width = (0, $d76b6507633b3c44$export$31b21d0167753bb4)(root, 0, opts);
            this._height = (0, $d76b6507633b3c44$export$31b21d0167753bb4)(root, 1, opts);
            var domRoot = this._domRoot = $19d742a3d88cea2b$var$createRoot(this._width, this._height);
            root.appendChild(domRoot);
        } else {
            var rootCanvas = root;
            var width = rootCanvas.width;
            var height = rootCanvas.height;
            if (opts.width != null) width = opts.width;
            if (opts.height != null) height = opts.height;
            this.dpr = opts.devicePixelRatio || 1;
            rootCanvas.width = width * this.dpr;
            rootCanvas.height = height * this.dpr;
            this._width = width;
            this._height = height;
            var mainLayer = new (0, $f88637d76300101e$export$2e2bcd8739ae039)(rootCanvas, this, this.dpr);
            mainLayer.__builtin__ = true;
            mainLayer.initContext();
            layers[$19d742a3d88cea2b$var$CANVAS_ZLEVEL] = mainLayer;
            mainLayer.zlevel = $19d742a3d88cea2b$var$CANVAS_ZLEVEL;
            zlevelList.push($19d742a3d88cea2b$var$CANVAS_ZLEVEL);
            this._domRoot = root;
        }
    }
    CanvasPainter.prototype.getType = function() {
        return 'canvas';
    };
    CanvasPainter.prototype.isSingleCanvas = function() {
        return this._singleCanvas;
    };
    CanvasPainter.prototype.getViewportRoot = function() {
        return this._domRoot;
    };
    CanvasPainter.prototype.getViewportRootOffset = function() {
        var viewportRoot = this.getViewportRoot();
        if (viewportRoot) return {
            offsetLeft: viewportRoot.offsetLeft || 0,
            offsetTop: viewportRoot.offsetTop || 0
        };
    };
    CanvasPainter.prototype.refresh = function(paintAll) {
        var list = this.storage.getDisplayList(true);
        var prevList = this._prevDisplayList;
        var zlevelList = this._zlevelList;
        this._redrawId = Math.random();
        this._paintList(list, prevList, paintAll, this._redrawId);
        for(var i = 0; i < zlevelList.length; i++){
            var z = zlevelList[i];
            var layer = this._layers[z];
            if (!layer.__builtin__ && layer.refresh) {
                var clearColor = i === 0 ? this._backgroundColor : null;
                layer.refresh(clearColor);
            }
        }
        if (this._opts.useDirtyRect) this._prevDisplayList = list.slice();
        return this;
    };
    CanvasPainter.prototype.refreshHover = function() {
        this._paintHoverList(this.storage.getDisplayList(false));
    };
    CanvasPainter.prototype._paintHoverList = function(list) {
        var len = list.length;
        var hoverLayer = this._hoverlayer;
        hoverLayer && hoverLayer.clear();
        if (!len) return;
        var scope = {
            inHover: true,
            viewWidth: this._width,
            viewHeight: this._height
        };
        var ctx;
        for(var i = 0; i < len; i++){
            var el = list[i];
            if (el.__inHover) {
                if (!hoverLayer) hoverLayer = this._hoverlayer = this.getLayer($19d742a3d88cea2b$var$HOVER_LAYER_ZLEVEL);
                if (!ctx) {
                    ctx = hoverLayer.ctx;
                    ctx.save();
                }
                (0, $4f71e35e4552e3dd$export$da5d6544e8c27bc1)(ctx, el, scope, i === len - 1);
            }
        }
        if (ctx) ctx.restore();
    };
    CanvasPainter.prototype.getHoverLayer = function() {
        return this.getLayer($19d742a3d88cea2b$var$HOVER_LAYER_ZLEVEL);
    };
    CanvasPainter.prototype.paintOne = function(ctx, el) {
        (0, $4f71e35e4552e3dd$export$567881adfc3eb7f3)(ctx, el);
    };
    CanvasPainter.prototype._paintList = function(list, prevList, paintAll, redrawId) {
        if (this._redrawId !== redrawId) return;
        paintAll = paintAll || false;
        this._updateLayerStatus(list);
        var _a = this._doPaintList(list, prevList, paintAll), finished = _a.finished, needsRefreshHover = _a.needsRefreshHover;
        if (this._needsManuallyCompositing) this._compositeManually();
        if (needsRefreshHover) this._paintHoverList(list);
        if (!finished) {
            var self_1 = this;
            (0, $731d42ad1858cd4c$export$2e2bcd8739ae039)(function() {
                self_1._paintList(list, prevList, paintAll, redrawId);
            });
        } else this.eachLayer(function(layer) {
            layer.afterBrush && layer.afterBrush();
        });
    };
    CanvasPainter.prototype._compositeManually = function() {
        var ctx = this.getLayer($19d742a3d88cea2b$var$CANVAS_ZLEVEL).ctx;
        var width = this._domRoot.width;
        var height = this._domRoot.height;
        ctx.clearRect(0, 0, width, height);
        this.eachBuiltinLayer(function(layer) {
            if (layer.virtual) ctx.drawImage(layer.dom, 0, 0, width, height);
        });
    };
    CanvasPainter.prototype._doPaintList = function(list, prevList, paintAll) {
        var _this = this;
        var layerList = [];
        var useDirtyRect = this._opts.useDirtyRect;
        for(var zi = 0; zi < this._zlevelList.length; zi++){
            var zlevel = this._zlevelList[zi];
            var layer = this._layers[zlevel];
            if (layer.__builtin__ && layer !== this._hoverlayer && (layer.__dirty || paintAll)) layerList.push(layer);
        }
        var finished = true;
        var needsRefreshHover = false;
        var _loop_1 = function(k) {
            var layer = layerList[k];
            var ctx = layer.ctx;
            var repaintRects = useDirtyRect && layer.createRepaintRects(list, prevList, this_1._width, this_1._height);
            var start = paintAll ? layer.__startIndex : layer.__drawIndex;
            var useTimer = !paintAll && layer.incremental && Date.now;
            var startTime = useTimer && Date.now();
            var clearColor = layer.zlevel === this_1._zlevelList[0] ? this_1._backgroundColor : null;
            if (layer.__startIndex === layer.__endIndex) layer.clear(false, clearColor, repaintRects);
            else if (start === layer.__startIndex) {
                var firstEl = list[start];
                if (!firstEl.incremental || !firstEl.notClear || paintAll) layer.clear(false, clearColor, repaintRects);
            }
            if (start === -1) {
                console.error('For some unknown reason. drawIndex is -1');
                start = layer.__startIndex;
            }
            var i;
            var repaint = function(repaintRect) {
                var scope = {
                    inHover: false,
                    allClipped: false,
                    prevEl: null,
                    viewWidth: _this._width,
                    viewHeight: _this._height
                };
                for(i = start; i < layer.__endIndex; i++){
                    var el = list[i];
                    if (el.__inHover) needsRefreshHover = true;
                    _this._doPaintEl(el, layer, useDirtyRect, repaintRect, scope, i === layer.__endIndex - 1);
                    if (useTimer) {
                        var dTime = Date.now() - startTime;
                        if (dTime > 15) break;
                    }
                }
                if (scope.prevElClipPaths) ctx.restore();
            };
            if (repaintRects) {
                if (repaintRects.length === 0) i = layer.__endIndex;
                else {
                    var dpr = this_1.dpr;
                    for(var r = 0; r < repaintRects.length; ++r){
                        var rect = repaintRects[r];
                        ctx.save();
                        ctx.beginPath();
                        ctx.rect(rect.x * dpr, rect.y * dpr, rect.width * dpr, rect.height * dpr);
                        ctx.clip();
                        repaint(rect);
                        ctx.restore();
                    }
                }
            } else {
                ctx.save();
                repaint();
                ctx.restore();
            }
            layer.__drawIndex = i;
            if (layer.__drawIndex < layer.__endIndex) finished = false;
        };
        var this_1 = this;
        for(var k = 0; k < layerList.length; k++)_loop_1(k);
        if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).wxa) $7a1bd9c2710fea0d$export$79b2f7037acddd43(this._layers, function(layer) {
            if (layer && layer.ctx && layer.ctx.draw) layer.ctx.draw();
        });
        return {
            finished: finished,
            needsRefreshHover: needsRefreshHover
        };
    };
    CanvasPainter.prototype._doPaintEl = function(el, currentLayer, useDirtyRect, repaintRect, scope, isLast) {
        var ctx = currentLayer.ctx;
        if (useDirtyRect) {
            var paintRect = el.getPaintRect();
            if (!repaintRect || paintRect && paintRect.intersect(repaintRect)) {
                (0, $4f71e35e4552e3dd$export$da5d6544e8c27bc1)(ctx, el, scope, isLast);
                el.setPrevPaintRect(paintRect);
            }
        } else (0, $4f71e35e4552e3dd$export$da5d6544e8c27bc1)(ctx, el, scope, isLast);
    };
    CanvasPainter.prototype.getLayer = function(zlevel, virtual) {
        if (this._singleCanvas && !this._needsManuallyCompositing) zlevel = $19d742a3d88cea2b$var$CANVAS_ZLEVEL;
        var layer = this._layers[zlevel];
        if (!layer) {
            layer = new (0, $f88637d76300101e$export$2e2bcd8739ae039)('zr_' + zlevel, this, this.dpr);
            layer.zlevel = zlevel;
            layer.__builtin__ = true;
            if (this._layerConfig[zlevel]) $7a1bd9c2710fea0d$export$4950aa0f605343fb(layer, this._layerConfig[zlevel], true);
            else if (this._layerConfig[zlevel - $19d742a3d88cea2b$var$EL_AFTER_INCREMENTAL_INC]) $7a1bd9c2710fea0d$export$4950aa0f605343fb(layer, this._layerConfig[zlevel - $19d742a3d88cea2b$var$EL_AFTER_INCREMENTAL_INC], true);
            if (virtual) layer.virtual = virtual;
            this.insertLayer(zlevel, layer);
            layer.initContext();
        }
        return layer;
    };
    CanvasPainter.prototype.insertLayer = function(zlevel, layer) {
        var layersMap = this._layers;
        var zlevelList = this._zlevelList;
        var len = zlevelList.length;
        var domRoot = this._domRoot;
        var prevLayer = null;
        var i = -1;
        if (layersMap[zlevel]) return;
        if (!$19d742a3d88cea2b$var$isLayerValid(layer)) return;
        if (len > 0 && zlevel > zlevelList[0]) {
            for(i = 0; i < len - 1; i++){
                if (zlevelList[i] < zlevel && zlevelList[i + 1] > zlevel) break;
            }
            prevLayer = layersMap[zlevelList[i]];
        }
        zlevelList.splice(i + 1, 0, zlevel);
        layersMap[zlevel] = layer;
        if (!layer.virtual) {
            if (prevLayer) {
                var prevDom = prevLayer.dom;
                if (prevDom.nextSibling) domRoot.insertBefore(layer.dom, prevDom.nextSibling);
                else domRoot.appendChild(layer.dom);
            } else if (domRoot.firstChild) domRoot.insertBefore(layer.dom, domRoot.firstChild);
            else domRoot.appendChild(layer.dom);
        }
        layer.painter || (layer.painter = this);
    };
    CanvasPainter.prototype.eachLayer = function(cb, context) {
        var zlevelList = this._zlevelList;
        for(var i = 0; i < zlevelList.length; i++){
            var z = zlevelList[i];
            cb.call(context, this._layers[z], z);
        }
    };
    CanvasPainter.prototype.eachBuiltinLayer = function(cb, context) {
        var zlevelList = this._zlevelList;
        for(var i = 0; i < zlevelList.length; i++){
            var z = zlevelList[i];
            var layer = this._layers[z];
            if (layer.__builtin__) cb.call(context, layer, z);
        }
    };
    CanvasPainter.prototype.eachOtherLayer = function(cb, context) {
        var zlevelList = this._zlevelList;
        for(var i = 0; i < zlevelList.length; i++){
            var z = zlevelList[i];
            var layer = this._layers[z];
            if (!layer.__builtin__) cb.call(context, layer, z);
        }
    };
    CanvasPainter.prototype.getLayers = function() {
        return this._layers;
    };
    CanvasPainter.prototype._updateLayerStatus = function(list) {
        this.eachBuiltinLayer(function(layer, z) {
            layer.__dirty = layer.__used = false;
        });
        function updatePrevLayer(idx) {
            if (prevLayer) {
                if (prevLayer.__endIndex !== idx) prevLayer.__dirty = true;
                prevLayer.__endIndex = idx;
            }
        }
        if (this._singleCanvas) for(var i_1 = 1; i_1 < list.length; i_1++){
            var el = list[i_1];
            if (el.zlevel !== list[i_1 - 1].zlevel || el.incremental) {
                this._needsManuallyCompositing = true;
                break;
            }
        }
        var prevLayer = null;
        var incrementalLayerCount = 0;
        var prevZlevel;
        var i;
        for(i = 0; i < list.length; i++){
            var el = list[i];
            var zlevel = el.zlevel;
            var layer = void 0;
            if (prevZlevel !== zlevel) {
                prevZlevel = zlevel;
                incrementalLayerCount = 0;
            }
            if (el.incremental) {
                layer = this.getLayer(zlevel + $19d742a3d88cea2b$var$INCREMENTAL_INC, this._needsManuallyCompositing);
                layer.incremental = true;
                incrementalLayerCount = 1;
            } else layer = this.getLayer(zlevel + (incrementalLayerCount > 0 ? $19d742a3d88cea2b$var$EL_AFTER_INCREMENTAL_INC : 0), this._needsManuallyCompositing);
            if (!layer.__builtin__) $7a1bd9c2710fea0d$export$58da9968c3170cb1('ZLevel ' + zlevel + ' has been used by unkown layer ' + layer.id);
            if (layer !== prevLayer) {
                layer.__used = true;
                if (layer.__startIndex !== i) layer.__dirty = true;
                layer.__startIndex = i;
                if (!layer.incremental) layer.__drawIndex = i;
                else layer.__drawIndex = -1;
                updatePrevLayer(i);
                prevLayer = layer;
            }
            if (el.__dirty & (0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd) && !el.__inHover) {
                layer.__dirty = true;
                if (layer.incremental && layer.__drawIndex < 0) layer.__drawIndex = i;
            }
        }
        updatePrevLayer(i);
        this.eachBuiltinLayer(function(layer, z) {
            if (!layer.__used && layer.getElementCount() > 0) {
                layer.__dirty = true;
                layer.__startIndex = layer.__endIndex = layer.__drawIndex = 0;
            }
            if (layer.__dirty && layer.__drawIndex < 0) layer.__drawIndex = layer.__startIndex;
        });
    };
    CanvasPainter.prototype.clear = function() {
        this.eachBuiltinLayer(this._clearLayer);
        return this;
    };
    CanvasPainter.prototype._clearLayer = function(layer) {
        layer.clear();
    };
    CanvasPainter.prototype.setBackgroundColor = function(backgroundColor) {
        this._backgroundColor = backgroundColor;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(this._layers, function(layer) {
            layer.setUnpainted();
        });
    };
    CanvasPainter.prototype.configLayer = function(zlevel, config) {
        if (config) {
            var layerConfig = this._layerConfig;
            if (!layerConfig[zlevel]) layerConfig[zlevel] = config;
            else $7a1bd9c2710fea0d$export$4950aa0f605343fb(layerConfig[zlevel], config, true);
            for(var i = 0; i < this._zlevelList.length; i++){
                var _zlevel = this._zlevelList[i];
                if (_zlevel === zlevel || _zlevel === zlevel + $19d742a3d88cea2b$var$EL_AFTER_INCREMENTAL_INC) {
                    var layer = this._layers[_zlevel];
                    $7a1bd9c2710fea0d$export$4950aa0f605343fb(layer, layerConfig[zlevel], true);
                }
            }
        }
    };
    CanvasPainter.prototype.delLayer = function(zlevel) {
        var layers = this._layers;
        var zlevelList = this._zlevelList;
        var layer = layers[zlevel];
        if (!layer) return;
        layer.dom.parentNode.removeChild(layer.dom);
        delete layers[zlevel];
        zlevelList.splice($7a1bd9c2710fea0d$export$305f7d4e9d4624f2(zlevelList, zlevel), 1);
    };
    CanvasPainter.prototype.resize = function(width, height) {
        if (!this._domRoot.style) {
            if (width == null || height == null) return;
            this._width = width;
            this._height = height;
            this.getLayer($19d742a3d88cea2b$var$CANVAS_ZLEVEL).resize(width, height);
        } else {
            var domRoot = this._domRoot;
            domRoot.style.display = 'none';
            var opts = this._opts;
            var root = this.root;
            width != null && (opts.width = width);
            height != null && (opts.height = height);
            width = (0, $d76b6507633b3c44$export$31b21d0167753bb4)(root, 0, opts);
            height = (0, $d76b6507633b3c44$export$31b21d0167753bb4)(root, 1, opts);
            domRoot.style.display = '';
            if (this._width !== width || height !== this._height) {
                domRoot.style.width = width + 'px';
                domRoot.style.height = height + 'px';
                for(var id in this._layers)if (this._layers.hasOwnProperty(id)) this._layers[id].resize(width, height);
                this.refresh(true);
            }
            this._width = width;
            this._height = height;
        }
        return this;
    };
    CanvasPainter.prototype.clearLayer = function(zlevel) {
        var layer = this._layers[zlevel];
        if (layer) layer.clear();
    };
    CanvasPainter.prototype.dispose = function() {
        this.root.innerHTML = '';
        this.root = this.storage = this._domRoot = this._layers = null;
    };
    CanvasPainter.prototype.getRenderedCanvas = function(opts) {
        opts = opts || {};
        if (this._singleCanvas && !this._compositeManually) return this._layers[$19d742a3d88cea2b$var$CANVAS_ZLEVEL].dom;
        var imageLayer = new (0, $f88637d76300101e$export$2e2bcd8739ae039)('image', this, opts.pixelRatio || this.dpr);
        imageLayer.initContext();
        imageLayer.clear(false, opts.backgroundColor || this._backgroundColor);
        var ctx = imageLayer.ctx;
        if (opts.pixelRatio <= this.dpr) {
            this.refresh();
            var width_1 = imageLayer.dom.width;
            var height_1 = imageLayer.dom.height;
            this.eachLayer(function(layer) {
                if (layer.__builtin__) ctx.drawImage(layer.dom, 0, 0, width_1, height_1);
                else if (layer.renderToCanvas) {
                    ctx.save();
                    layer.renderToCanvas(ctx);
                    ctx.restore();
                }
            });
        } else {
            var scope = {
                inHover: false,
                viewWidth: this._width,
                viewHeight: this._height
            };
            var displayList = this.storage.getDisplayList(true);
            for(var i = 0, len = displayList.length; i < len; i++){
                var el = displayList[i];
                (0, $4f71e35e4552e3dd$export$da5d6544e8c27bc1)(ctx, el, scope, i === len - 1);
            }
        }
        return imageLayer.dom;
    };
    CanvasPainter.prototype.getWidth = function() {
        return this._width;
    };
    CanvasPainter.prototype.getHeight = function() {
        return this._height;
    };
    return CanvasPainter;
}();
var $19d742a3d88cea2b$export$2e2bcd8739ae039 = $19d742a3d88cea2b$var$CanvasPainter;


function $e792bf2f67d76098$export$4b3e715f166fdd78(registers) {
    registers.registerPainter('canvas', (0, $19d742a3d88cea2b$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $c8b2ce72d2349eb5$var$mathSin = Math.sin;
var $c8b2ce72d2349eb5$var$mathCos = Math.cos;
var $c8b2ce72d2349eb5$var$PI = Math.PI;
var $c8b2ce72d2349eb5$var$PI2 = Math.PI * 2;
var $c8b2ce72d2349eb5$var$degree = 180 / $c8b2ce72d2349eb5$var$PI;
var $c8b2ce72d2349eb5$var$SVGPathRebuilder = function() {
    function SVGPathRebuilder() {}
    SVGPathRebuilder.prototype.reset = function(precision) {
        this._start = true;
        this._d = [];
        this._str = '';
        this._p = Math.pow(10, precision || 4);
    };
    SVGPathRebuilder.prototype.moveTo = function(x, y) {
        this._add('M', x, y);
    };
    SVGPathRebuilder.prototype.lineTo = function(x, y) {
        this._add('L', x, y);
    };
    SVGPathRebuilder.prototype.bezierCurveTo = function(x, y, x2, y2, x3, y3) {
        this._add('C', x, y, x2, y2, x3, y3);
    };
    SVGPathRebuilder.prototype.quadraticCurveTo = function(x, y, x2, y2) {
        this._add('Q', x, y, x2, y2);
    };
    SVGPathRebuilder.prototype.arc = function(cx, cy, r, startAngle, endAngle, anticlockwise) {
        this.ellipse(cx, cy, r, r, 0, startAngle, endAngle, anticlockwise);
    };
    SVGPathRebuilder.prototype.ellipse = function(cx, cy, rx, ry, psi, startAngle, endAngle, anticlockwise) {
        var dTheta = endAngle - startAngle;
        var clockwise = !anticlockwise;
        var dThetaPositive = Math.abs(dTheta);
        var isCircle = (0, $999d81abec723db8$export$4701367f5b4de464)(dThetaPositive - $c8b2ce72d2349eb5$var$PI2) || (clockwise ? dTheta >= $c8b2ce72d2349eb5$var$PI2 : -dTheta >= $c8b2ce72d2349eb5$var$PI2);
        var unifiedTheta = dTheta > 0 ? dTheta % $c8b2ce72d2349eb5$var$PI2 : dTheta % $c8b2ce72d2349eb5$var$PI2 + $c8b2ce72d2349eb5$var$PI2;
        var large = false;
        if (isCircle) large = true;
        else if ((0, $999d81abec723db8$export$4701367f5b4de464)(dThetaPositive)) large = false;
        else large = unifiedTheta >= $c8b2ce72d2349eb5$var$PI === !!clockwise;
        var x0 = cx + rx * $c8b2ce72d2349eb5$var$mathCos(startAngle);
        var y0 = cy + ry * $c8b2ce72d2349eb5$var$mathSin(startAngle);
        if (this._start) this._add('M', x0, y0);
        var xRot = Math.round(psi * $c8b2ce72d2349eb5$var$degree);
        if (isCircle) {
            var p = 1 / this._p;
            var dTheta_1 = (clockwise ? 1 : -1) * ($c8b2ce72d2349eb5$var$PI2 - p);
            this._add('A', rx, ry, xRot, 1, +clockwise, cx + rx * $c8b2ce72d2349eb5$var$mathCos(startAngle + dTheta_1), cy + ry * $c8b2ce72d2349eb5$var$mathSin(startAngle + dTheta_1));
            if (p > 1e-2) this._add('A', rx, ry, xRot, 0, +clockwise, x0, y0);
        } else {
            var x = cx + rx * $c8b2ce72d2349eb5$var$mathCos(endAngle);
            var y = cy + ry * $c8b2ce72d2349eb5$var$mathSin(endAngle);
            this._add('A', rx, ry, xRot, +large, +clockwise, x, y);
        }
    };
    SVGPathRebuilder.prototype.rect = function(x, y, w, h) {
        this._add('M', x, y);
        this._add('l', w, 0);
        this._add('l', 0, h);
        this._add('l', -w, 0);
        this._add('Z');
    };
    SVGPathRebuilder.prototype.closePath = function() {
        if (this._d.length > 0) this._add('Z');
    };
    SVGPathRebuilder.prototype._add = function(cmd, a, b, c, d, e, f, g, h) {
        var vals = [];
        var p = this._p;
        for(var i = 1; i < arguments.length; i++){
            var val = arguments[i];
            if (isNaN(val)) {
                this._invalid = true;
                return;
            }
            vals.push(Math.round(val * p) / p);
        }
        this._d.push(cmd + vals.join(' '));
        this._start = cmd === 'Z';
    };
    SVGPathRebuilder.prototype.generateStr = function() {
        this._str = this._invalid ? '' : this._d.join('');
        this._d = [];
    };
    SVGPathRebuilder.prototype.getStr = function() {
        return this._str;
    };
    return SVGPathRebuilder;
}();
var $c8b2ce72d2349eb5$export$2e2bcd8739ae039 = $c8b2ce72d2349eb5$var$SVGPathRebuilder;







var $6f6b3090476bfa7b$var$NONE = 'none';
var $6f6b3090476bfa7b$var$mathRound = Math.round;
function $6f6b3090476bfa7b$var$pathHasFill(style) {
    var fill = style.fill;
    return fill != null && fill !== $6f6b3090476bfa7b$var$NONE;
}
function $6f6b3090476bfa7b$var$pathHasStroke(style) {
    var stroke = style.stroke;
    return stroke != null && stroke !== $6f6b3090476bfa7b$var$NONE;
}
var $6f6b3090476bfa7b$var$strokeProps = [
    'lineCap',
    'miterLimit',
    'lineJoin'
];
var $6f6b3090476bfa7b$var$svgStrokeProps = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)($6f6b3090476bfa7b$var$strokeProps, function(prop) {
    return "stroke-" + prop.toLowerCase();
});
function $6f6b3090476bfa7b$export$2e2bcd8739ae039(updateAttr, style, el, forceUpdate) {
    var opacity = style.opacity == null ? 1 : style.opacity;
    if (el instanceof (0, $86adec94217b86c6$export$2e2bcd8739ae039)) {
        updateAttr('opacity', opacity);
        return;
    }
    if ($6f6b3090476bfa7b$var$pathHasFill(style)) {
        var fill = (0, $999d81abec723db8$export$4cde5df63f53f473)(style.fill);
        updateAttr('fill', fill.color);
        var fillOpacity = style.fillOpacity != null ? style.fillOpacity * fill.opacity * opacity : fill.opacity * opacity;
        if (forceUpdate || fillOpacity < 1) updateAttr('fill-opacity', fillOpacity);
    } else updateAttr('fill', $6f6b3090476bfa7b$var$NONE);
    if ($6f6b3090476bfa7b$var$pathHasStroke(style)) {
        var stroke = (0, $999d81abec723db8$export$4cde5df63f53f473)(style.stroke);
        updateAttr('stroke', stroke.color);
        var strokeScale = style.strokeNoScale ? el.getLineScale() : 1;
        var strokeWidth = strokeScale ? (style.lineWidth || 0) / strokeScale : 0;
        var strokeOpacity = style.strokeOpacity != null ? style.strokeOpacity * stroke.opacity * opacity : stroke.opacity * opacity;
        var strokeFirst = style.strokeFirst;
        if (forceUpdate || strokeWidth !== 1) updateAttr('stroke-width', strokeWidth);
        if (forceUpdate || strokeFirst) updateAttr('paint-order', strokeFirst ? 'stroke' : 'fill');
        if (forceUpdate || strokeOpacity < 1) updateAttr('stroke-opacity', strokeOpacity);
        if (style.lineDash) {
            var _a = (0, $21ab8baf7c1f083c$export$9d315911f153b3b2)(el), lineDash = _a[0], lineDashOffset = _a[1];
            if (lineDash) {
                lineDashOffset = $6f6b3090476bfa7b$var$mathRound(lineDashOffset || 0);
                updateAttr('stroke-dasharray', lineDash.join(','));
                if (lineDashOffset || forceUpdate) updateAttr('stroke-dashoffset', lineDashOffset);
            }
        } else if (forceUpdate) updateAttr('stroke-dasharray', $6f6b3090476bfa7b$var$NONE);
        for(var i = 0; i < $6f6b3090476bfa7b$var$strokeProps.length; i++){
            var propName = $6f6b3090476bfa7b$var$strokeProps[i];
            if (forceUpdate || style[propName] !== (0, $b02ffe7acd508c08$export$deade517576e293a)[propName]) {
                var val = style[propName] || (0, $b02ffe7acd508c08$export$deade517576e293a)[propName];
                val && updateAttr($6f6b3090476bfa7b$var$svgStrokeProps[i], val);
            }
        }
    } else if (forceUpdate) updateAttr('stroke', $6f6b3090476bfa7b$var$NONE);
}




var $f6ad3c9e333d7ffc$export$a690ad4c9a38f86e = 'http://www.w3.org/2000/svg';
var $f6ad3c9e333d7ffc$export$b22c6da1792ecec8 = 'http://www.w3.org/1999/xlink';
var $f6ad3c9e333d7ffc$export$fac09d762d15fa3b = 'http://www.w3.org/2000/xmlns/';
var $f6ad3c9e333d7ffc$export$ad4c4fdecd3b4156 = 'http://www.w3.org/XML/1998/namespace';
var $f6ad3c9e333d7ffc$export$d3f79611f155197c = 'ecmeta_';
function $f6ad3c9e333d7ffc$export$c8a8987d4410bf2d(name) {
    return document.createElementNS($f6ad3c9e333d7ffc$export$a690ad4c9a38f86e, name);
}
function $f6ad3c9e333d7ffc$export$bf5c4cf060303d58(tag, key, attrs, children, text) {
    return {
        tag: tag,
        attrs: attrs || {},
        children: children,
        text: text,
        key: key
    };
}
function $f6ad3c9e333d7ffc$var$createElementOpen(name, attrs) {
    var attrsStr = [];
    if (attrs) for(var key in attrs){
        var val = attrs[key];
        var part = key;
        if (val === false) continue;
        else if (val !== true && val != null) part += "=\"" + val + "\"";
        attrsStr.push(part);
    }
    return "<" + name + " " + attrsStr.join(' ') + ">";
}
function $f6ad3c9e333d7ffc$var$createElementClose(name) {
    return "</" + name + ">";
}
function $f6ad3c9e333d7ffc$export$f5c4a9a0e027f2b(el, opts) {
    opts = opts || {};
    var S = opts.newline ? '\n' : '';
    function convertElToString(el) {
        var children = el.children, tag = el.tag, attrs = el.attrs, text = el.text;
        return $f6ad3c9e333d7ffc$var$createElementOpen(tag, attrs) + (tag !== 'style' ? (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(text) : text || '') + (children ? "" + S + (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(children, function(child) {
            return convertElToString(child);
        }).join(S) + S : '') + $f6ad3c9e333d7ffc$var$createElementClose(tag);
    }
    return convertElToString(el);
}
function $f6ad3c9e333d7ffc$export$e2b4f3597c7a7dcb(selectorNodes, animationNodes, opts) {
    opts = opts || {};
    var S = opts.newline ? '\n' : '';
    var bracketBegin = " {" + S;
    var bracketEnd = S + "}";
    var selectors = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)((0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(selectorNodes), function(className) {
        return className + bracketBegin + (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)((0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(selectorNodes[className]), function(attrName) {
            return attrName + ":" + selectorNodes[className][attrName] + ";";
        }).join(S) + bracketEnd;
    }).join(S);
    var animations = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)((0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(animationNodes), function(animationName) {
        return "@keyframes " + animationName + bracketBegin + (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)((0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(animationNodes[animationName]), function(percent) {
            return percent + bracketBegin + (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)((0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(animationNodes[animationName][percent]), function(attrName) {
                var val = animationNodes[animationName][percent][attrName];
                if (attrName === 'd') val = "path(\"" + val + "\")";
                return attrName + ":" + val + ";";
            }).join(S) + bracketEnd;
        }).join(S) + bracketEnd;
    }).join(S);
    if (!selectors && !animations) return '';
    return [
        '<![CDATA[',
        selectors,
        animations,
        ']]>'
    ].join(S);
}
function $f6ad3c9e333d7ffc$export$96fee5f38ed01741(zrId) {
    return {
        zrId: zrId,
        shadowCache: {},
        patternCache: {},
        gradientCache: {},
        clipPathCache: {},
        defs: {},
        cssNodes: {},
        cssAnims: {},
        cssStyleCache: {},
        cssAnimIdx: 0,
        shadowIdx: 0,
        gradientIdx: 0,
        patternIdx: 0,
        clipPathIdx: 0
    };
}
function $f6ad3c9e333d7ffc$export$5529a6aad332ee75(width, height, children, useViewBox) {
    return $f6ad3c9e333d7ffc$export$bf5c4cf060303d58('svg', 'root', {
        'width': width,
        'height': height,
        'xmlns': $f6ad3c9e333d7ffc$export$a690ad4c9a38f86e,
        'xmlns:xlink': $f6ad3c9e333d7ffc$export$b22c6da1792ecec8,
        'version': '1.1',
        'baseProfile': 'full',
        'viewBox': useViewBox ? "0 0 " + width + " " + height : false
    }, children);
}












var $849cb89161be4359$var$cssClassIdx = 0;
function $849cb89161be4359$export$9c80c36b7367fb56() {
    return $849cb89161be4359$var$cssClassIdx++;
}


var $a85a6a2869494a29$export$54ee1847795bcf37 = {
    cubicIn: '0.32,0,0.67,0',
    cubicOut: '0.33,1,0.68,1',
    cubicInOut: '0.65,0,0.35,1',
    quadraticIn: '0.11,0,0.5,0',
    quadraticOut: '0.5,1,0.89,1',
    quadraticInOut: '0.45,0,0.55,1',
    quarticIn: '0.5,0,0.75,0',
    quarticOut: '0.25,1,0.5,1',
    quarticInOut: '0.76,0,0.24,1',
    quinticIn: '0.64,0,0.78,0',
    quinticOut: '0.22,1,0.36,1',
    quinticInOut: '0.83,0,0.17,1',
    sinusoidalIn: '0.12,0,0.39,0',
    sinusoidalOut: '0.61,1,0.88,1',
    sinusoidalInOut: '0.37,0,0.63,1',
    exponentialIn: '0.7,0,0.84,0',
    exponentialOut: '0.16,1,0.3,1',
    exponentialInOut: '0.87,0,0.13,1',
    circularIn: '0.55,0,1,0.45',
    circularOut: '0,0.55,0.45,1',
    circularInOut: '0.85,0,0.15,1'
};
var $a85a6a2869494a29$var$transformOriginKey = 'transform-origin';
function $a85a6a2869494a29$var$buildPathString(el, kfShape, path) {
    var shape = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, el.shape);
    (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(shape, kfShape);
    el.buildPath(path, shape);
    var svgPathBuilder = new (0, $c8b2ce72d2349eb5$export$2e2bcd8739ae039)();
    svgPathBuilder.reset((0, $999d81abec723db8$export$93fa1ae8a509371c)(el));
    path.rebuildPath(svgPathBuilder, 1);
    svgPathBuilder.generateStr();
    return svgPathBuilder.getStr();
}
function $a85a6a2869494a29$var$setTransformOrigin(target, transform) {
    var originX = transform.originX, originY = transform.originY;
    if (originX || originY) target[$a85a6a2869494a29$var$transformOriginKey] = originX + "px " + originY + "px";
}
var $a85a6a2869494a29$export$f0dede2064ee89d7 = {
    fill: 'fill',
    opacity: 'opacity',
    lineWidth: 'stroke-width',
    lineDashOffset: 'stroke-dashoffset'
};
function $a85a6a2869494a29$var$addAnimation(cssAnim, scope) {
    var animationName = scope.zrId + '-ani-' + scope.cssAnimIdx++;
    scope.cssAnims[animationName] = cssAnim;
    return animationName;
}
function $a85a6a2869494a29$var$createCompoundPathCSSAnimation(el, attrs, scope) {
    var paths = el.shape.paths;
    var composedAnim = {};
    var cssAnimationCfg;
    var cssAnimationName;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(paths, function(path) {
        var subScope = (0, $f6ad3c9e333d7ffc$export$96fee5f38ed01741)(scope.zrId);
        subScope.animation = true;
        $a85a6a2869494a29$export$dc9722e37397d426(path, {}, subScope, true);
        var cssAnims = subScope.cssAnims;
        var cssNodes = subScope.cssNodes;
        var animNames = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(cssAnims);
        var len = animNames.length;
        if (!len) return;
        cssAnimationName = animNames[len - 1];
        var lastAnim = cssAnims[cssAnimationName];
        for(var percent in lastAnim){
            var kf = lastAnim[percent];
            composedAnim[percent] = composedAnim[percent] || {
                d: ''
            };
            composedAnim[percent].d += kf.d || '';
        }
        for(var className in cssNodes){
            var val = cssNodes[className].animation;
            if (val.indexOf(cssAnimationName) >= 0) cssAnimationCfg = val;
        }
    });
    if (!cssAnimationCfg) return;
    attrs.d = false;
    var animationName = $a85a6a2869494a29$var$addAnimation(composedAnim, scope);
    return cssAnimationCfg.replace(cssAnimationName, animationName);
}
function $a85a6a2869494a29$var$getEasingFunc(easing) {
    return (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(easing) ? $a85a6a2869494a29$export$54ee1847795bcf37[easing] ? "cubic-bezier(" + $a85a6a2869494a29$export$54ee1847795bcf37[easing] + ")" : (0, $0aea98bda0b4be1f$export$ec0863d806fd857e)(easing) ? easing : '' : '';
}
function $a85a6a2869494a29$export$dc9722e37397d426(el, attrs, scope, onlyShape) {
    var animators = el.animators;
    var len = animators.length;
    var cssAnimations = [];
    if (el instanceof (0, $e152f3dbf8fba6e2$export$2e2bcd8739ae039)) {
        var animationCfg = $a85a6a2869494a29$var$createCompoundPathCSSAnimation(el, attrs, scope);
        if (animationCfg) cssAnimations.push(animationCfg);
        else if (!len) return;
    } else if (!len) return;
    var groupAnimators = {};
    for(var i = 0; i < len; i++){
        var animator = animators[i];
        var cfgArr = [
            animator.getMaxTime() / 1000 + 's'
        ];
        var easing = $a85a6a2869494a29$var$getEasingFunc(animator.getClip().easing);
        var delay = animator.getDelay();
        if (easing) cfgArr.push(easing);
        else cfgArr.push('linear');
        if (delay) cfgArr.push(delay / 1000 + 's');
        if (animator.getLoop()) cfgArr.push('infinite');
        var cfg = cfgArr.join(' ');
        groupAnimators[cfg] = groupAnimators[cfg] || [
            cfg,
            []
        ];
        groupAnimators[cfg][1].push(animator);
    }
    function createSingleCSSAnimation(groupAnimator) {
        var animators = groupAnimator[1];
        var len = animators.length;
        var transformKfs = {};
        var shapeKfs = {};
        var finalKfs = {};
        var animationTimingFunctionAttrName = 'animation-timing-function';
        function saveAnimatorTrackToCssKfs(animator, cssKfs, toCssAttrName) {
            var tracks = animator.getTracks();
            var maxTime = animator.getMaxTime();
            for(var k = 0; k < tracks.length; k++){
                var track = tracks[k];
                if (track.needsAnimate()) {
                    var kfs = track.keyframes;
                    var attrName = track.propName;
                    toCssAttrName && (attrName = toCssAttrName(attrName));
                    if (attrName) for(var i = 0; i < kfs.length; i++){
                        var kf = kfs[i];
                        var percent = Math.round(kf.time / maxTime * 100) + '%';
                        var kfEasing = $a85a6a2869494a29$var$getEasingFunc(kf.easing);
                        var rawValue = kf.rawValue;
                        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(rawValue) || (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(rawValue)) {
                            cssKfs[percent] = cssKfs[percent] || {};
                            cssKfs[percent][attrName] = kf.rawValue;
                            if (kfEasing) cssKfs[percent][animationTimingFunctionAttrName] = kfEasing;
                        }
                    }
                }
            }
        }
        for(var i = 0; i < len; i++){
            var animator = animators[i];
            var targetProp = animator.targetName;
            if (!targetProp) !onlyShape && saveAnimatorTrackToCssKfs(animator, transformKfs);
            else if (targetProp === 'shape') saveAnimatorTrackToCssKfs(animator, shapeKfs);
        }
        for(var percent in transformKfs){
            var transform = {};
            (0, $becf2d727f9cf450$export$234b1c16dfa57d6a)(transform, el);
            (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(transform, transformKfs[percent]);
            var str = (0, $999d81abec723db8$export$3fe07c0888ff6164)(transform);
            var timingFunction = transformKfs[percent][animationTimingFunctionAttrName];
            finalKfs[percent] = str ? {
                transform: str
            } : {};
            $a85a6a2869494a29$var$setTransformOrigin(finalKfs[percent], transform);
            if (timingFunction) finalKfs[percent][animationTimingFunctionAttrName] = timingFunction;
        }
        var path;
        var canAnimateShape = true;
        for(var percent in shapeKfs){
            finalKfs[percent] = finalKfs[percent] || {};
            var isFirst = !path;
            var timingFunction = shapeKfs[percent][animationTimingFunctionAttrName];
            if (isFirst) path = new (0, $20ebe2448f123f2e$export$2e2bcd8739ae039)();
            var len_1 = path.len();
            path.reset();
            finalKfs[percent].d = $a85a6a2869494a29$var$buildPathString(el, shapeKfs[percent], path);
            var newLen = path.len();
            if (!isFirst && len_1 !== newLen) {
                canAnimateShape = false;
                break;
            }
            if (timingFunction) finalKfs[percent][animationTimingFunctionAttrName] = timingFunction;
        }
        if (!canAnimateShape) for(var percent in finalKfs)delete finalKfs[percent].d;
        if (!onlyShape) for(var i = 0; i < len; i++){
            var animator = animators[i];
            var targetProp = animator.targetName;
            if (targetProp === 'style') saveAnimatorTrackToCssKfs(animator, finalKfs, function(propName) {
                return $a85a6a2869494a29$export$f0dede2064ee89d7[propName];
            });
        }
        var percents = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(finalKfs);
        var allTransformOriginSame = true;
        var transformOrigin;
        for(var i = 1; i < percents.length; i++){
            var p0 = percents[i - 1];
            var p1 = percents[i];
            if (finalKfs[p0][$a85a6a2869494a29$var$transformOriginKey] !== finalKfs[p1][$a85a6a2869494a29$var$transformOriginKey]) {
                allTransformOriginSame = false;
                break;
            }
            transformOrigin = finalKfs[p0][$a85a6a2869494a29$var$transformOriginKey];
        }
        if (allTransformOriginSame && transformOrigin) {
            for(var percent in finalKfs)if (finalKfs[percent][$a85a6a2869494a29$var$transformOriginKey]) delete finalKfs[percent][$a85a6a2869494a29$var$transformOriginKey];
            attrs[$a85a6a2869494a29$var$transformOriginKey] = transformOrigin;
        }
        if ((0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(percents, function(percent) {
            return (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(finalKfs[percent]).length > 0;
        }).length) {
            var animationName = $a85a6a2869494a29$var$addAnimation(finalKfs, scope);
            return animationName + " " + groupAnimator[0] + " both";
        }
    }
    for(var key in groupAnimators){
        var animationCfg = createSingleCSSAnimation(groupAnimators[key]);
        if (animationCfg) cssAnimations.push(animationCfg);
    }
    if (cssAnimations.length) {
        var className = scope.zrId + '-cls-' + (0, $849cb89161be4359$export$9c80c36b7367fb56)();
        scope.cssNodes['.' + className] = {
            animation: cssAnimations.join(',')
        };
        attrs["class"] = className;
    }
}






function $05e38a5f94c3c427$export$b4c8f742d3cb22ba(el, attrs, scope) {
    if (!el.ignore) {
        if (el.isSilent()) {
            var style = {
                'pointer-events': 'none'
            };
            $05e38a5f94c3c427$var$setClassAttribute(style, attrs, scope, true);
        } else {
            var emphasisStyle = el.states.emphasis && el.states.emphasis.style ? el.states.emphasis.style : {};
            var fill = emphasisStyle.fill;
            if (!fill) {
                var normalFill = el.style && el.style.fill;
                var selectFill = el.states.select && el.states.select.style && el.states.select.style.fill;
                var fromFill = el.currentStates.indexOf('select') >= 0 ? selectFill || normalFill : normalFill;
                if (fromFill) fill = (0, $2c037f5bda6341ca$export$2b47e247dfb87a73)(fromFill);
            }
            var lineWidth = emphasisStyle.lineWidth;
            if (lineWidth) {
                var scaleX = !emphasisStyle.strokeNoScale && el.transform ? el.transform[0] : 1;
                lineWidth = lineWidth / scaleX;
            }
            var style = {
                cursor: 'pointer'
            };
            if (fill) style.fill = fill;
            if (emphasisStyle.stroke) style.stroke = emphasisStyle.stroke;
            if (lineWidth) style['stroke-width'] = lineWidth;
            $05e38a5f94c3c427$var$setClassAttribute(style, attrs, scope, true);
        }
    }
}
function $05e38a5f94c3c427$var$setClassAttribute(style, attrs, scope, withHover) {
    var styleKey = JSON.stringify(style);
    var className = scope.cssStyleCache[styleKey];
    if (!className) {
        className = scope.zrId + '-cls-' + (0, $849cb89161be4359$export$9c80c36b7367fb56)();
        scope.cssStyleCache[styleKey] = className;
        scope.cssNodes['.' + className + (withHover ? ':hover' : '')] = style;
    }
    attrs["class"] = attrs["class"] ? attrs["class"] + ' ' + className : className;
}



var $5a7f1b53a6723dcf$var$round = Math.round;
function $5a7f1b53a6723dcf$var$isImageLike(val) {
    return val && (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(val.src);
}
function $5a7f1b53a6723dcf$var$isCanvasLike(val) {
    return val && (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(val.toDataURL);
}
function $5a7f1b53a6723dcf$var$setStyleAttrs(attrs, style, el, scope) {
    (0, $6f6b3090476bfa7b$export$2e2bcd8739ae039)(function(key, val) {
        var isFillStroke = key === 'fill' || key === 'stroke';
        if (isFillStroke && (0, $999d81abec723db8$export$545e02bbd5f8fe95)(val)) $5a7f1b53a6723dcf$export$afaa8352c6a43a44(style, attrs, key, scope);
        else if (isFillStroke && (0, $999d81abec723db8$export$41a28f5a000a9d0f)(val)) $5a7f1b53a6723dcf$export$faed90dbedc3b6d5(el, attrs, key, scope);
        else attrs[key] = val;
        if (isFillStroke && scope.ssr && val === 'none') attrs['pointer-events'] = 'visible';
    }, style, el, false);
    $5a7f1b53a6723dcf$var$setShadow(el, attrs, scope);
}
function $5a7f1b53a6723dcf$var$setMetaData(attrs, el) {
    var metaData = (0, $6eba88f9eebe6af9$export$dd7015a5412ca583)(el);
    if (metaData) {
        metaData.each(function(val, key) {
            val != null && (attrs[((0, $f6ad3c9e333d7ffc$export$d3f79611f155197c) + key).toLowerCase()] = val + '');
        });
        if (el.isSilent()) attrs[(0, $f6ad3c9e333d7ffc$export$d3f79611f155197c) + 'silent'] = 'true';
    }
}
function $5a7f1b53a6723dcf$var$noRotateScale(m) {
    return (0, $999d81abec723db8$export$4701367f5b4de464)(m[0] - 1) && (0, $999d81abec723db8$export$4701367f5b4de464)(m[1]) && (0, $999d81abec723db8$export$4701367f5b4de464)(m[2]) && (0, $999d81abec723db8$export$4701367f5b4de464)(m[3] - 1);
}
function $5a7f1b53a6723dcf$var$noTranslate(m) {
    return (0, $999d81abec723db8$export$4701367f5b4de464)(m[4]) && (0, $999d81abec723db8$export$4701367f5b4de464)(m[5]);
}
function $5a7f1b53a6723dcf$var$setTransform(attrs, m, compress) {
    if (m && !($5a7f1b53a6723dcf$var$noTranslate(m) && $5a7f1b53a6723dcf$var$noRotateScale(m))) {
        var mul = compress ? 10 : 1e4;
        attrs.transform = $5a7f1b53a6723dcf$var$noRotateScale(m) ? "translate(" + $5a7f1b53a6723dcf$var$round(m[4] * mul) / mul + " " + $5a7f1b53a6723dcf$var$round(m[5] * mul) / mul + ")" : (0, $999d81abec723db8$export$f29a4456cf56ff21)(m);
    }
}
function $5a7f1b53a6723dcf$var$convertPolyShape(shape, attrs, mul) {
    var points = shape.points;
    var strArr = [];
    for(var i = 0; i < points.length; i++){
        strArr.push($5a7f1b53a6723dcf$var$round(points[i][0] * mul) / mul);
        strArr.push($5a7f1b53a6723dcf$var$round(points[i][1] * mul) / mul);
    }
    attrs.points = strArr.join(' ');
}
function $5a7f1b53a6723dcf$var$validatePolyShape(shape) {
    return !shape.smooth;
}
function $5a7f1b53a6723dcf$var$createAttrsConvert(desc) {
    var normalizedDesc = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(desc, function(item) {
        return typeof item === 'string' ? [
            item,
            item
        ] : item;
    });
    return function(shape, attrs, mul) {
        for(var i = 0; i < normalizedDesc.length; i++){
            var item = normalizedDesc[i];
            var val = shape[item[0]];
            if (val != null) attrs[item[1]] = $5a7f1b53a6723dcf$var$round(val * mul) / mul;
        }
    };
}
var $5a7f1b53a6723dcf$var$builtinShapesDef = {
    circle: [
        $5a7f1b53a6723dcf$var$createAttrsConvert([
            'cx',
            'cy',
            'r'
        ])
    ],
    polyline: [
        $5a7f1b53a6723dcf$var$convertPolyShape,
        $5a7f1b53a6723dcf$var$validatePolyShape
    ],
    polygon: [
        $5a7f1b53a6723dcf$var$convertPolyShape,
        $5a7f1b53a6723dcf$var$validatePolyShape
    ]
};
function $5a7f1b53a6723dcf$var$hasShapeAnimation(el) {
    var animators = el.animators;
    for(var i = 0; i < animators.length; i++){
        if (animators[i].targetName === 'shape') return true;
    }
    return false;
}
function $5a7f1b53a6723dcf$export$1dc017d31b76c55b(el, scope) {
    var style = el.style;
    var shape = el.shape;
    var builtinShpDef = $5a7f1b53a6723dcf$var$builtinShapesDef[el.type];
    var attrs = {};
    var needsAnimate = scope.animation;
    var svgElType = 'path';
    var strokePercent = el.style.strokePercent;
    var precision = scope.compress && (0, $999d81abec723db8$export$93fa1ae8a509371c)(el) || 4;
    if (builtinShpDef && !scope.willUpdate && !(builtinShpDef[1] && !builtinShpDef[1](shape)) && !(needsAnimate && $5a7f1b53a6723dcf$var$hasShapeAnimation(el)) && !(strokePercent < 1)) {
        svgElType = el.type;
        var mul = Math.pow(10, precision);
        builtinShpDef[0](shape, attrs, mul);
    } else {
        var needBuildPath = !el.path || el.shapeChanged();
        if (!el.path) el.createPathProxy();
        var path = el.path;
        if (needBuildPath) {
            path.beginPath();
            el.buildPath(path, el.shape);
            el.pathUpdated();
        }
        var pathVersion = path.getVersion();
        var elExt = el;
        var svgPathBuilder = elExt.__svgPathBuilder;
        if (elExt.__svgPathVersion !== pathVersion || !svgPathBuilder || strokePercent !== elExt.__svgPathStrokePercent) {
            if (!svgPathBuilder) svgPathBuilder = elExt.__svgPathBuilder = new (0, $c8b2ce72d2349eb5$export$2e2bcd8739ae039)();
            svgPathBuilder.reset(precision);
            path.rebuildPath(svgPathBuilder, strokePercent);
            svgPathBuilder.generateStr();
            elExt.__svgPathVersion = pathVersion;
            elExt.__svgPathStrokePercent = strokePercent;
        }
        attrs.d = svgPathBuilder.getStr();
    }
    $5a7f1b53a6723dcf$var$setTransform(attrs, el.transform);
    $5a7f1b53a6723dcf$var$setStyleAttrs(attrs, style, el, scope);
    $5a7f1b53a6723dcf$var$setMetaData(attrs, el);
    scope.animation && (0, $a85a6a2869494a29$export$dc9722e37397d426)(el, attrs, scope);
    scope.emphasis && (0, $05e38a5f94c3c427$export$b4c8f742d3cb22ba)(el, attrs, scope);
    return (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)(svgElType, el.id + '', attrs);
}
function $5a7f1b53a6723dcf$export$a35ef46dc8240635(el, scope) {
    var style = el.style;
    var image = style.image;
    if (image && !(0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(image)) {
        if ($5a7f1b53a6723dcf$var$isImageLike(image)) image = image.src;
        else if ($5a7f1b53a6723dcf$var$isCanvasLike(image)) image = image.toDataURL();
    }
    if (!image) return;
    var x = style.x || 0;
    var y = style.y || 0;
    var dw = style.width;
    var dh = style.height;
    var attrs = {
        href: image,
        width: dw,
        height: dh
    };
    if (x) attrs.x = x;
    if (y) attrs.y = y;
    $5a7f1b53a6723dcf$var$setTransform(attrs, el.transform);
    $5a7f1b53a6723dcf$var$setStyleAttrs(attrs, style, el, scope);
    $5a7f1b53a6723dcf$var$setMetaData(attrs, el);
    scope.animation && (0, $a85a6a2869494a29$export$dc9722e37397d426)(el, attrs, scope);
    return (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)('image', el.id + '', attrs);
}
function $5a7f1b53a6723dcf$export$d506f5385e62a84a(el, scope) {
    var style = el.style;
    var text = style.text;
    text != null && (text += '');
    if (!text || isNaN(style.x) || isNaN(style.y)) return;
    var font = style.font || (0, $c6341dcc9d86826e$export$7d7a232b6d2cc80c);
    var x = style.x || 0;
    var y = (0, $999d81abec723db8$export$bf7d6802d2badd9)(style.y || 0, (0, $6c308355c7107803$export$56204a27a2958a55)(font), style.textBaseline);
    var textAlign = (0, $999d81abec723db8$export$4062150f0600d971)[style.textAlign] || style.textAlign;
    var attrs = {
        'dominant-baseline': 'central',
        'text-anchor': textAlign
    };
    if ((0, $fe885cc21795562b$export$4685c95d5118e76a)(style)) {
        var separatedFontStr = '';
        var fontStyle = style.fontStyle;
        var fontSize = (0, $fe885cc21795562b$export$51b066d9cfc2578e)(style.fontSize);
        if (!parseFloat(fontSize)) return;
        var fontFamily = style.fontFamily || (0, $c6341dcc9d86826e$export$2653e0d5dd45b294);
        var fontWeight = style.fontWeight;
        separatedFontStr += "font-size:" + fontSize + ";font-family:" + fontFamily + ";";
        if (fontStyle && fontStyle !== 'normal') separatedFontStr += "font-style:" + fontStyle + ";";
        if (fontWeight && fontWeight !== 'normal') separatedFontStr += "font-weight:" + fontWeight + ";";
        attrs.style = separatedFontStr;
    } else attrs.style = "font: " + font;
    if (text.match(/\s/)) attrs['xml:space'] = 'preserve';
    if (x) attrs.x = x;
    if (y) attrs.y = y;
    $5a7f1b53a6723dcf$var$setTransform(attrs, el.transform);
    $5a7f1b53a6723dcf$var$setStyleAttrs(attrs, style, el, scope);
    $5a7f1b53a6723dcf$var$setMetaData(attrs, el);
    scope.animation && (0, $a85a6a2869494a29$export$dc9722e37397d426)(el, attrs, scope);
    return (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)('text', el.id + '', attrs, undefined, text);
}
function $5a7f1b53a6723dcf$export$da5d6544e8c27bc1(el, scope) {
    if (el instanceof (0, $b02ffe7acd508c08$export$2e2bcd8739ae039)) return $5a7f1b53a6723dcf$export$1dc017d31b76c55b(el, scope);
    else if (el instanceof (0, $86adec94217b86c6$export$2e2bcd8739ae039)) return $5a7f1b53a6723dcf$export$a35ef46dc8240635(el, scope);
    else if (el instanceof (0, $c9d5c769fe2f591f$export$2e2bcd8739ae039)) return $5a7f1b53a6723dcf$export$d506f5385e62a84a(el, scope);
}
function $5a7f1b53a6723dcf$var$setShadow(el, attrs, scope) {
    var style = el.style;
    if ((0, $999d81abec723db8$export$c62076b3a966c94b)(style)) {
        var shadowKey = (0, $999d81abec723db8$export$9e4c657be710688a)(el);
        var shadowCache = scope.shadowCache;
        var shadowId = shadowCache[shadowKey];
        if (!shadowId) {
            var globalScale = el.getGlobalScale();
            var scaleX = globalScale[0];
            var scaleY = globalScale[1];
            if (!scaleX || !scaleY) return;
            var offsetX = style.shadowOffsetX || 0;
            var offsetY = style.shadowOffsetY || 0;
            var blur_1 = style.shadowBlur;
            var _a = (0, $999d81abec723db8$export$4cde5df63f53f473)(style.shadowColor), opacity = _a.opacity, color = _a.color;
            var stdDx = blur_1 / 2 / scaleX;
            var stdDy = blur_1 / 2 / scaleY;
            var stdDeviation = stdDx + ' ' + stdDy;
            shadowId = scope.zrId + '-s' + scope.shadowIdx++;
            scope.defs[shadowId] = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)('filter', shadowId, {
                'id': shadowId,
                'x': '-100%',
                'y': '-100%',
                'width': '300%',
                'height': '300%'
            }, [
                (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)('feDropShadow', '', {
                    'dx': offsetX / scaleX,
                    'dy': offsetY / scaleY,
                    'stdDeviation': stdDeviation,
                    'flood-color': color,
                    'flood-opacity': opacity
                })
            ]);
            shadowCache[shadowKey] = shadowId;
        }
        attrs.filter = (0, $999d81abec723db8$export$bb094196179998a5)(shadowId);
    }
}
function $5a7f1b53a6723dcf$export$afaa8352c6a43a44(style, attrs, target, scope) {
    var val = style[target];
    var gradientTag;
    var gradientAttrs = {
        'gradientUnits': val.global ? 'userSpaceOnUse' : 'objectBoundingBox'
    };
    if ((0, $999d81abec723db8$export$7d961bca9d3b47d0)(val)) {
        gradientTag = 'linearGradient';
        gradientAttrs.x1 = val.x;
        gradientAttrs.y1 = val.y;
        gradientAttrs.x2 = val.x2;
        gradientAttrs.y2 = val.y2;
    } else if ((0, $999d81abec723db8$export$2a9cca6692a0ce3a)(val)) {
        gradientTag = 'radialGradient';
        gradientAttrs.cx = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(val.x, 0.5);
        gradientAttrs.cy = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(val.y, 0.5);
        gradientAttrs.r = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(val.r, 0.5);
    } else return;
    var colors = val.colorStops;
    var colorStops = [];
    for(var i = 0, len = colors.length; i < len; ++i){
        var offset = (0, $999d81abec723db8$export$52bfc6d3e2ff0fc2)(colors[i].offset) * 100 + '%';
        var stopColor = colors[i].color;
        var _a = (0, $999d81abec723db8$export$4cde5df63f53f473)(stopColor), color = _a.color, opacity = _a.opacity;
        var stopsAttrs = {
            'offset': offset
        };
        stopsAttrs['stop-color'] = color;
        if (opacity < 1) stopsAttrs['stop-opacity'] = opacity;
        colorStops.push((0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)('stop', i + '', stopsAttrs));
    }
    var gradientVNode = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)(gradientTag, '', gradientAttrs, colorStops);
    var gradientKey = (0, $f6ad3c9e333d7ffc$export$f5c4a9a0e027f2b)(gradientVNode);
    var gradientCache = scope.gradientCache;
    var gradientId = gradientCache[gradientKey];
    if (!gradientId) {
        gradientId = scope.zrId + '-g' + scope.gradientIdx++;
        gradientCache[gradientKey] = gradientId;
        gradientAttrs.id = gradientId;
        scope.defs[gradientId] = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)(gradientTag, gradientId, gradientAttrs, colorStops);
    }
    attrs[target] = (0, $999d81abec723db8$export$bb094196179998a5)(gradientId);
}
function $5a7f1b53a6723dcf$export$faed90dbedc3b6d5(el, attrs, target, scope) {
    var val = el.style[target];
    var boundingRect = el.getBoundingRect();
    var patternAttrs = {};
    var repeat = val.repeat;
    var noRepeat = repeat === 'no-repeat';
    var repeatX = repeat === 'repeat-x';
    var repeatY = repeat === 'repeat-y';
    var child;
    if ((0, $999d81abec723db8$export$2ade673ac4f85dfe)(val)) {
        var imageWidth_1 = val.imageWidth;
        var imageHeight_1 = val.imageHeight;
        var imageSrc = void 0;
        var patternImage = val.image;
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(patternImage)) imageSrc = patternImage;
        else if ($5a7f1b53a6723dcf$var$isImageLike(patternImage)) imageSrc = patternImage.src;
        else if ($5a7f1b53a6723dcf$var$isCanvasLike(patternImage)) imageSrc = patternImage.toDataURL();
        if (typeof Image === 'undefined') {
            var errMsg = 'Image width/height must been given explictly in svg-ssr renderer.';
            (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)(imageWidth_1, errMsg);
            (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)(imageHeight_1, errMsg);
        } else if (imageWidth_1 == null || imageHeight_1 == null) {
            var setSizeToVNode_1 = function(vNode, img) {
                if (vNode) {
                    var svgEl = vNode.elm;
                    var width = imageWidth_1 || img.width;
                    var height = imageHeight_1 || img.height;
                    if (vNode.tag === 'pattern') {
                        if (repeatX) {
                            height = 1;
                            width /= boundingRect.width;
                        } else if (repeatY) {
                            width = 1;
                            height /= boundingRect.height;
                        }
                    }
                    vNode.attrs.width = width;
                    vNode.attrs.height = height;
                    if (svgEl) {
                        svgEl.setAttribute('width', width);
                        svgEl.setAttribute('height', height);
                    }
                }
            };
            var createdImage = (0, $a53bd598adfb7ebe$export$46c791b69ff9a0f)(imageSrc, null, el, function(img) {
                noRepeat || setSizeToVNode_1(patternVNode, img);
                setSizeToVNode_1(child, img);
            });
            if (createdImage && createdImage.width && createdImage.height) {
                imageWidth_1 = imageWidth_1 || createdImage.width;
                imageHeight_1 = imageHeight_1 || createdImage.height;
            }
        }
        child = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)('image', 'img', {
            href: imageSrc,
            width: imageWidth_1,
            height: imageHeight_1
        });
        patternAttrs.width = imageWidth_1;
        patternAttrs.height = imageHeight_1;
    } else if (val.svgElement) {
        child = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(val.svgElement);
        patternAttrs.width = val.svgWidth;
        patternAttrs.height = val.svgHeight;
    }
    if (!child) return;
    var patternWidth;
    var patternHeight;
    if (noRepeat) patternWidth = patternHeight = 1;
    else if (repeatX) {
        patternHeight = 1;
        patternWidth = patternAttrs.width / boundingRect.width;
    } else if (repeatY) {
        patternWidth = 1;
        patternHeight = patternAttrs.height / boundingRect.height;
    } else patternAttrs.patternUnits = 'userSpaceOnUse';
    if (patternWidth != null && !isNaN(patternWidth)) patternAttrs.width = patternWidth;
    if (patternHeight != null && !isNaN(patternHeight)) patternAttrs.height = patternHeight;
    var patternTransform = (0, $999d81abec723db8$export$3fe07c0888ff6164)(val);
    patternTransform && (patternAttrs.patternTransform = patternTransform);
    var patternVNode = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)('pattern', '', patternAttrs, [
        child
    ]);
    var patternKey = (0, $f6ad3c9e333d7ffc$export$f5c4a9a0e027f2b)(patternVNode);
    var patternCache = scope.patternCache;
    var patternId = patternCache[patternKey];
    if (!patternId) {
        patternId = scope.zrId + '-p' + scope.patternIdx++;
        patternCache[patternKey] = patternId;
        patternAttrs.id = patternId;
        patternVNode = scope.defs[patternId] = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)('pattern', patternId, patternAttrs, [
            child
        ]);
    }
    attrs[target] = (0, $999d81abec723db8$export$bb094196179998a5)(patternId);
}
function $5a7f1b53a6723dcf$export$8f1d80b445d4fc(clipPath, attrs, scope) {
    var clipPathCache = scope.clipPathCache, defs = scope.defs;
    var clipPathId = clipPathCache[clipPath.id];
    if (!clipPathId) {
        clipPathId = scope.zrId + '-c' + scope.clipPathIdx++;
        var clipPathAttrs = {
            id: clipPathId
        };
        clipPathCache[clipPath.id] = clipPathId;
        defs[clipPathId] = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)('clipPath', clipPathId, clipPathAttrs, [
            $5a7f1b53a6723dcf$export$1dc017d31b76c55b(clipPath, scope)
        ]);
    }
    attrs['clip-path'] = (0, $999d81abec723db8$export$bb094196179998a5)(clipPathId);
}







function $a4f5b07c584c2741$export$b2ce9ad90858ed7a(text) {
    return document.createTextNode(text);
}
function $a4f5b07c584c2741$export$2a15b079e3f46654(text) {
    return document.createComment(text);
}
function $a4f5b07c584c2741$export$86b68c7dbeb53c22(parentNode, newNode, referenceNode) {
    parentNode.insertBefore(newNode, referenceNode);
}
function $a4f5b07c584c2741$export$7ae609f7af59e4f7(node, child) {
    node.removeChild(child);
}
function $a4f5b07c584c2741$export$1b8e57c9ea42f1d2(node, child) {
    node.appendChild(child);
}
function $a4f5b07c584c2741$export$b54be7ce267a037b(node) {
    return node.parentNode;
}
function $a4f5b07c584c2741$export$335219007e689d29(node) {
    return node.nextSibling;
}
function $a4f5b07c584c2741$export$45e0b80f1e500bd4(elm) {
    return elm.tagName;
}
function $a4f5b07c584c2741$export$94b0296cab6203e(node, text) {
    node.textContent = text;
}
function $a4f5b07c584c2741$export$132e79e4118a78e0(node) {
    return node.textContent;
}
function $a4f5b07c584c2741$export$45a5e7f76e0caa8d(node) {
    return node.nodeType === 1;
}
function $a4f5b07c584c2741$export$1879817ac5c922b7(node) {
    return node.nodeType === 3;
}
function $a4f5b07c584c2741$export$3ab01370f5e64ac8(node) {
    return node.nodeType === 8;
}


var $57ac702d7860318b$var$colonChar = 58;
var $57ac702d7860318b$var$xChar = 120;
var $57ac702d7860318b$var$emptyNode = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)('', '');
function $57ac702d7860318b$var$isUndef(s) {
    return s === undefined;
}
function $57ac702d7860318b$var$isDef(s) {
    return s !== undefined;
}
function $57ac702d7860318b$var$createKeyToOldIdx(children, beginIdx, endIdx) {
    var map = {};
    for(var i = beginIdx; i <= endIdx; ++i){
        var key = children[i].key;
        if (key !== undefined) map[key] = i;
    }
    return map;
}
function $57ac702d7860318b$var$sameVnode(vnode1, vnode2) {
    var isSameKey = vnode1.key === vnode2.key;
    var isSameTag = vnode1.tag === vnode2.tag;
    return isSameTag && isSameKey;
}
function $57ac702d7860318b$var$createElm(vnode) {
    var i;
    var children = vnode.children;
    var tag = vnode.tag;
    if ($57ac702d7860318b$var$isDef(tag)) {
        var elm = vnode.elm = (0, $f6ad3c9e333d7ffc$export$c8a8987d4410bf2d)(tag);
        $57ac702d7860318b$export$277dcc6f06048f24($57ac702d7860318b$var$emptyNode, vnode);
        if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(children)) for(i = 0; i < children.length; ++i){
            var ch = children[i];
            if (ch != null) $a4f5b07c584c2741$export$1b8e57c9ea42f1d2(elm, $57ac702d7860318b$var$createElm(ch));
        }
        else if ($57ac702d7860318b$var$isDef(vnode.text) && !(0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(vnode.text)) $a4f5b07c584c2741$export$1b8e57c9ea42f1d2(elm, $a4f5b07c584c2741$export$b2ce9ad90858ed7a(vnode.text));
    } else vnode.elm = $a4f5b07c584c2741$export$b2ce9ad90858ed7a(vnode.text);
    return vnode.elm;
}
function $57ac702d7860318b$var$addVnodes(parentElm, before, vnodes, startIdx, endIdx) {
    for(; startIdx <= endIdx; ++startIdx){
        var ch = vnodes[startIdx];
        if (ch != null) $a4f5b07c584c2741$export$86b68c7dbeb53c22(parentElm, $57ac702d7860318b$var$createElm(ch), before);
    }
}
function $57ac702d7860318b$var$removeVnodes(parentElm, vnodes, startIdx, endIdx) {
    for(; startIdx <= endIdx; ++startIdx){
        var ch = vnodes[startIdx];
        if (ch != null) {
            if ($57ac702d7860318b$var$isDef(ch.tag)) {
                var parent_1 = $a4f5b07c584c2741$export$b54be7ce267a037b(ch.elm);
                $a4f5b07c584c2741$export$7ae609f7af59e4f7(parent_1, ch.elm);
            } else $a4f5b07c584c2741$export$7ae609f7af59e4f7(parentElm, ch.elm);
        }
    }
}
function $57ac702d7860318b$export$277dcc6f06048f24(oldVnode, vnode) {
    var key;
    var elm = vnode.elm;
    var oldAttrs = oldVnode && oldVnode.attrs || {};
    var attrs = vnode.attrs || {};
    if (oldAttrs === attrs) return;
    for(key in attrs){
        var cur = attrs[key];
        var old = oldAttrs[key];
        if (old !== cur) {
            if (cur === true) elm.setAttribute(key, '');
            else if (cur === false) elm.removeAttribute(key);
            else {
                if (key === 'style') elm.style.cssText = cur;
                else if (key.charCodeAt(0) !== $57ac702d7860318b$var$xChar) elm.setAttribute(key, cur);
                else if (key === 'xmlns:xlink' || key === 'xmlns') elm.setAttributeNS((0, $f6ad3c9e333d7ffc$export$fac09d762d15fa3b), key, cur);
                else if (key.charCodeAt(3) === $57ac702d7860318b$var$colonChar) elm.setAttributeNS((0, $f6ad3c9e333d7ffc$export$ad4c4fdecd3b4156), key, cur);
                else if (key.charCodeAt(5) === $57ac702d7860318b$var$colonChar) elm.setAttributeNS((0, $f6ad3c9e333d7ffc$export$b22c6da1792ecec8), key, cur);
                else elm.setAttribute(key, cur);
            }
        }
    }
    for(key in oldAttrs)if (!(key in attrs)) elm.removeAttribute(key);
}
function $57ac702d7860318b$var$updateChildren(parentElm, oldCh, newCh) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx;
    var idxInOld;
    var elmToMove;
    var before;
    while(oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx){
        if (oldStartVnode == null) oldStartVnode = oldCh[++oldStartIdx];
        else if (oldEndVnode == null) oldEndVnode = oldCh[--oldEndIdx];
        else if (newStartVnode == null) newStartVnode = newCh[++newStartIdx];
        else if (newEndVnode == null) newEndVnode = newCh[--newEndIdx];
        else if ($57ac702d7860318b$var$sameVnode(oldStartVnode, newStartVnode)) {
            $57ac702d7860318b$var$patchVnode(oldStartVnode, newStartVnode);
            oldStartVnode = oldCh[++oldStartIdx];
            newStartVnode = newCh[++newStartIdx];
        } else if ($57ac702d7860318b$var$sameVnode(oldEndVnode, newEndVnode)) {
            $57ac702d7860318b$var$patchVnode(oldEndVnode, newEndVnode);
            oldEndVnode = oldCh[--oldEndIdx];
            newEndVnode = newCh[--newEndIdx];
        } else if ($57ac702d7860318b$var$sameVnode(oldStartVnode, newEndVnode)) {
            $57ac702d7860318b$var$patchVnode(oldStartVnode, newEndVnode);
            $a4f5b07c584c2741$export$86b68c7dbeb53c22(parentElm, oldStartVnode.elm, $a4f5b07c584c2741$export$335219007e689d29(oldEndVnode.elm));
            oldStartVnode = oldCh[++oldStartIdx];
            newEndVnode = newCh[--newEndIdx];
        } else if ($57ac702d7860318b$var$sameVnode(oldEndVnode, newStartVnode)) {
            $57ac702d7860318b$var$patchVnode(oldEndVnode, newStartVnode);
            $a4f5b07c584c2741$export$86b68c7dbeb53c22(parentElm, oldEndVnode.elm, oldStartVnode.elm);
            oldEndVnode = oldCh[--oldEndIdx];
            newStartVnode = newCh[++newStartIdx];
        } else {
            if ($57ac702d7860318b$var$isUndef(oldKeyToIdx)) oldKeyToIdx = $57ac702d7860318b$var$createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
            idxInOld = oldKeyToIdx[newStartVnode.key];
            if ($57ac702d7860318b$var$isUndef(idxInOld)) $a4f5b07c584c2741$export$86b68c7dbeb53c22(parentElm, $57ac702d7860318b$var$createElm(newStartVnode), oldStartVnode.elm);
            else {
                elmToMove = oldCh[idxInOld];
                if (elmToMove.tag !== newStartVnode.tag) $a4f5b07c584c2741$export$86b68c7dbeb53c22(parentElm, $57ac702d7860318b$var$createElm(newStartVnode), oldStartVnode.elm);
                else {
                    $57ac702d7860318b$var$patchVnode(elmToMove, newStartVnode);
                    oldCh[idxInOld] = undefined;
                    $a4f5b07c584c2741$export$86b68c7dbeb53c22(parentElm, elmToMove.elm, oldStartVnode.elm);
                }
            }
            newStartVnode = newCh[++newStartIdx];
        }
    }
    if (oldStartIdx <= oldEndIdx || newStartIdx <= newEndIdx) {
        if (oldStartIdx > oldEndIdx) {
            before = newCh[newEndIdx + 1] == null ? null : newCh[newEndIdx + 1].elm;
            $57ac702d7860318b$var$addVnodes(parentElm, before, newCh, newStartIdx, newEndIdx);
        } else $57ac702d7860318b$var$removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
}
function $57ac702d7860318b$var$patchVnode(oldVnode, vnode) {
    var elm = vnode.elm = oldVnode.elm;
    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (oldVnode === vnode) return;
    $57ac702d7860318b$export$277dcc6f06048f24(oldVnode, vnode);
    if ($57ac702d7860318b$var$isUndef(vnode.text)) {
        if ($57ac702d7860318b$var$isDef(oldCh) && $57ac702d7860318b$var$isDef(ch)) {
            if (oldCh !== ch) $57ac702d7860318b$var$updateChildren(elm, oldCh, ch);
        } else if ($57ac702d7860318b$var$isDef(ch)) {
            if ($57ac702d7860318b$var$isDef(oldVnode.text)) $a4f5b07c584c2741$export$94b0296cab6203e(elm, '');
            $57ac702d7860318b$var$addVnodes(elm, null, ch, 0, ch.length - 1);
        } else if ($57ac702d7860318b$var$isDef(oldCh)) $57ac702d7860318b$var$removeVnodes(elm, oldCh, 0, oldCh.length - 1);
        else if ($57ac702d7860318b$var$isDef(oldVnode.text)) $a4f5b07c584c2741$export$94b0296cab6203e(elm, '');
    } else if (oldVnode.text !== vnode.text) {
        if ($57ac702d7860318b$var$isDef(oldCh)) $57ac702d7860318b$var$removeVnodes(elm, oldCh, 0, oldCh.length - 1);
        $a4f5b07c584c2741$export$94b0296cab6203e(elm, vnode.text);
    }
}
function $57ac702d7860318b$export$2e2bcd8739ae039(oldVnode, vnode) {
    if ($57ac702d7860318b$var$sameVnode(oldVnode, vnode)) $57ac702d7860318b$var$patchVnode(oldVnode, vnode);
    else {
        var elm = oldVnode.elm;
        var parent_2 = $a4f5b07c584c2741$export$b54be7ce267a037b(elm);
        $57ac702d7860318b$var$createElm(vnode);
        if (parent_2 !== null) {
            $a4f5b07c584c2741$export$86b68c7dbeb53c22(parent_2, vnode.elm, $a4f5b07c584c2741$export$335219007e689d29(elm));
            $57ac702d7860318b$var$removeVnodes(parent_2, [
                oldVnode
            ], 0, 0);
        }
    }
    return vnode;
}



var $c7b90ea532fd792a$var$svgId = 0;
var $c7b90ea532fd792a$var$SVGPainter = function() {
    function SVGPainter(root, storage, opts) {
        this.type = 'svg';
        this.refreshHover = $c7b90ea532fd792a$var$createMethodNotSupport('refreshHover');
        this.configLayer = $c7b90ea532fd792a$var$createMethodNotSupport('configLayer');
        this.storage = storage;
        this._opts = opts = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, opts);
        this.root = root;
        this._id = 'zr' + $c7b90ea532fd792a$var$svgId++;
        this._oldVNode = (0, $f6ad3c9e333d7ffc$export$5529a6aad332ee75)(opts.width, opts.height);
        if (root && !opts.ssr) {
            var viewport = this._viewport = document.createElement('div');
            viewport.style.cssText = 'position:relative;overflow:hidden';
            var svgDom = this._svgDom = this._oldVNode.elm = (0, $f6ad3c9e333d7ffc$export$c8a8987d4410bf2d)('svg');
            (0, $57ac702d7860318b$export$277dcc6f06048f24)(null, this._oldVNode);
            viewport.appendChild(svgDom);
            root.appendChild(viewport);
        }
        this.resize(opts.width, opts.height);
    }
    SVGPainter.prototype.getType = function() {
        return this.type;
    };
    SVGPainter.prototype.getViewportRoot = function() {
        return this._viewport;
    };
    SVGPainter.prototype.getViewportRootOffset = function() {
        var viewportRoot = this.getViewportRoot();
        if (viewportRoot) return {
            offsetLeft: viewportRoot.offsetLeft || 0,
            offsetTop: viewportRoot.offsetTop || 0
        };
    };
    SVGPainter.prototype.getSvgDom = function() {
        return this._svgDom;
    };
    SVGPainter.prototype.refresh = function() {
        if (this.root) {
            var vnode = this.renderToVNode({
                willUpdate: true
            });
            vnode.attrs.style = 'position:absolute;left:0;top:0;user-select:none';
            (0, $57ac702d7860318b$export$2e2bcd8739ae039)(this._oldVNode, vnode);
            this._oldVNode = vnode;
        }
    };
    SVGPainter.prototype.renderOneToVNode = function(el) {
        return (0, $5a7f1b53a6723dcf$export$da5d6544e8c27bc1)(el, (0, $f6ad3c9e333d7ffc$export$96fee5f38ed01741)(this._id));
    };
    SVGPainter.prototype.renderToVNode = function(opts) {
        opts = opts || {};
        var list = this.storage.getDisplayList(true);
        var width = this._width;
        var height = this._height;
        var scope = (0, $f6ad3c9e333d7ffc$export$96fee5f38ed01741)(this._id);
        scope.animation = opts.animation;
        scope.willUpdate = opts.willUpdate;
        scope.compress = opts.compress;
        scope.emphasis = opts.emphasis;
        scope.ssr = this._opts.ssr;
        var children = [];
        var bgVNode = this._bgVNode = $c7b90ea532fd792a$var$createBackgroundVNode(width, height, this._backgroundColor, scope);
        bgVNode && children.push(bgVNode);
        var mainVNode = !opts.compress ? this._mainVNode = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)('g', 'main', {}, []) : null;
        this._paintList(list, scope, mainVNode ? mainVNode.children : children);
        mainVNode && children.push(mainVNode);
        var defs = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)((0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(scope.defs), function(id) {
            return scope.defs[id];
        });
        if (defs.length) children.push((0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)('defs', 'defs', {}, defs));
        if (opts.animation) {
            var animationCssStr = (0, $f6ad3c9e333d7ffc$export$e2b4f3597c7a7dcb)(scope.cssNodes, scope.cssAnims, {
                newline: true
            });
            if (animationCssStr) {
                var styleNode = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)('style', 'stl', {}, [], animationCssStr);
                children.push(styleNode);
            }
        }
        return (0, $f6ad3c9e333d7ffc$export$5529a6aad332ee75)(width, height, children, opts.useViewBox);
    };
    SVGPainter.prototype.renderToString = function(opts) {
        opts = opts || {};
        return (0, $f6ad3c9e333d7ffc$export$f5c4a9a0e027f2b)(this.renderToVNode({
            animation: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(opts.cssAnimation, true),
            emphasis: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(opts.cssEmphasis, true),
            willUpdate: false,
            compress: true,
            useViewBox: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(opts.useViewBox, true)
        }), {
            newline: true
        });
    };
    SVGPainter.prototype.setBackgroundColor = function(backgroundColor) {
        this._backgroundColor = backgroundColor;
    };
    SVGPainter.prototype.getSvgRoot = function() {
        return this._mainVNode && this._mainVNode.elm;
    };
    SVGPainter.prototype._paintList = function(list, scope, out) {
        var listLen = list.length;
        var clipPathsGroupsStack = [];
        var clipPathsGroupsStackDepth = 0;
        var currentClipPathGroup;
        var prevClipPaths;
        var clipGroupNodeIdx = 0;
        for(var i = 0; i < listLen; i++){
            var displayable = list[i];
            if (!displayable.invisible) {
                var clipPaths = displayable.__clipPaths;
                var len = clipPaths && clipPaths.length || 0;
                var prevLen = prevClipPaths && prevClipPaths.length || 0;
                var lca = void 0;
                for(lca = Math.max(len - 1, prevLen - 1); lca >= 0; lca--){
                    if (clipPaths && prevClipPaths && clipPaths[lca] === prevClipPaths[lca]) break;
                }
                for(var i_1 = prevLen - 1; i_1 > lca; i_1--){
                    clipPathsGroupsStackDepth--;
                    currentClipPathGroup = clipPathsGroupsStack[clipPathsGroupsStackDepth - 1];
                }
                for(var i_2 = lca + 1; i_2 < len; i_2++){
                    var groupAttrs = {};
                    (0, $5a7f1b53a6723dcf$export$8f1d80b445d4fc)(clipPaths[i_2], groupAttrs, scope);
                    var g = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)('g', 'clip-g-' + clipGroupNodeIdx++, groupAttrs, []);
                    (currentClipPathGroup ? currentClipPathGroup.children : out).push(g);
                    clipPathsGroupsStack[clipPathsGroupsStackDepth++] = g;
                    currentClipPathGroup = g;
                }
                prevClipPaths = clipPaths;
                var ret = (0, $5a7f1b53a6723dcf$export$da5d6544e8c27bc1)(displayable, scope);
                if (ret) (currentClipPathGroup ? currentClipPathGroup.children : out).push(ret);
            }
        }
    };
    SVGPainter.prototype.resize = function(width, height) {
        var opts = this._opts;
        var root = this.root;
        var viewport = this._viewport;
        width != null && (opts.width = width);
        height != null && (opts.height = height);
        if (root && viewport) {
            viewport.style.display = 'none';
            width = (0, $d76b6507633b3c44$export$31b21d0167753bb4)(root, 0, opts);
            height = (0, $d76b6507633b3c44$export$31b21d0167753bb4)(root, 1, opts);
            viewport.style.display = '';
        }
        if (this._width !== width || this._height !== height) {
            this._width = width;
            this._height = height;
            if (viewport) {
                var viewportStyle = viewport.style;
                viewportStyle.width = width + 'px';
                viewportStyle.height = height + 'px';
            }
            if (!(0, $999d81abec723db8$export$41a28f5a000a9d0f)(this._backgroundColor)) {
                var svgDom = this._svgDom;
                if (svgDom) {
                    svgDom.setAttribute('width', width);
                    svgDom.setAttribute('height', height);
                }
                var bgEl = this._bgVNode && this._bgVNode.elm;
                if (bgEl) {
                    bgEl.setAttribute('width', width);
                    bgEl.setAttribute('height', height);
                }
            } else this.refresh();
        }
    };
    SVGPainter.prototype.getWidth = function() {
        return this._width;
    };
    SVGPainter.prototype.getHeight = function() {
        return this._height;
    };
    SVGPainter.prototype.dispose = function() {
        if (this.root) this.root.innerHTML = '';
        this._svgDom = this._viewport = this.storage = this._oldVNode = this._bgVNode = this._mainVNode = null;
    };
    SVGPainter.prototype.clear = function() {
        if (this._svgDom) this._svgDom.innerHTML = null;
        this._oldVNode = null;
    };
    SVGPainter.prototype.toDataURL = function(base64) {
        var str = this.renderToString();
        var prefix = 'data:image/svg+xml;';
        if (base64) {
            str = (0, $999d81abec723db8$export$8fb536984ec8b4d7)(str);
            return str && prefix + 'base64,' + str;
        }
        return prefix + 'charset=UTF-8,' + encodeURIComponent(str);
    };
    return SVGPainter;
}();
function $c7b90ea532fd792a$var$createMethodNotSupport(method) {
    return function() {};
}
function $c7b90ea532fd792a$var$createBackgroundVNode(width, height, backgroundColor, scope) {
    var bgVNode;
    if (backgroundColor && backgroundColor !== 'none') {
        bgVNode = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)('rect', 'bg', {
            width: width,
            height: height,
            x: '0',
            y: '0'
        });
        if ((0, $999d81abec723db8$export$545e02bbd5f8fe95)(backgroundColor)) (0, $5a7f1b53a6723dcf$export$afaa8352c6a43a44)({
            fill: backgroundColor
        }, bgVNode.attrs, 'fill', scope);
        else if ((0, $999d81abec723db8$export$41a28f5a000a9d0f)(backgroundColor)) (0, $5a7f1b53a6723dcf$export$faed90dbedc3b6d5)({
            style: {
                fill: backgroundColor
            },
            dirty: (0, $7a1bd9c2710fea0d$export$8793edee2d425525),
            getBoundingRect: function() {
                return {
                    width: width,
                    height: height
                };
            }
        }, bgVNode.attrs, 'fill', scope);
        else {
            var _a = (0, $999d81abec723db8$export$4cde5df63f53f473)(backgroundColor), color = _a.color, opacity = _a.opacity;
            bgVNode.attrs.fill = color;
            opacity < 1 && (bgVNode.attrs['fill-opacity'] = opacity);
        }
    }
    return bgVNode;
}
var $c7b90ea532fd792a$export$2e2bcd8739ae039 = $c7b90ea532fd792a$var$SVGPainter;


function $8d8c6eb926bbdd0e$export$4b3e715f166fdd78(registers) {
    registers.registerPainter('svg', (0, $c7b90ea532fd792a$export$2e2bcd8739ae039));
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $85b723b311a86ffc$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $85b723b311a86ffc$var$dimTypeShort = {
    float: 'f',
    int: 'i',
    ordinal: 'o',
    number: 'n',
    time: 't'
};
/**
 * Represents the dimension requirement of a series.
 *
 * NOTICE:
 * When there are too many dimensions in dataset and many series, only the used dimensions
 * (i.e., used by coord sys and declared in `series.encode`) are add to `dimensionDefineList`.
 * But users may query data by other unused dimension names.
 * In this case, users can only query data if and only if they have defined dimension names
 * via ec option, so we provide `getDimensionIndexFromSource`, which only query them from
 * `source` dimensions.
 */ var $85b723b311a86ffc$export$a1ef064685775f3e = /** @class */ function() {
    function SeriesDataSchema(opt) {
        this.dimensions = opt.dimensions;
        this._dimOmitted = opt.dimensionOmitted;
        this.source = opt.source;
        this._fullDimCount = opt.fullDimensionCount;
        this._updateDimOmitted(opt.dimensionOmitted);
    }
    SeriesDataSchema.prototype.isDimensionOmitted = function() {
        return this._dimOmitted;
    };
    SeriesDataSchema.prototype._updateDimOmitted = function(dimensionOmitted) {
        this._dimOmitted = dimensionOmitted;
        if (!dimensionOmitted) return;
        if (!this._dimNameMap) this._dimNameMap = $85b723b311a86ffc$export$be39ae17310c33f7(this.source);
    };
    /**
   * @caution Can only be used when `dimensionOmitted: true`.
   *
   * Get index by user defined dimension name (i.e., not internal generate name).
   * That is, get index from `dimensionsDefine`.
   * If no `dimensionsDefine`, or no name get, return -1.
   */ SeriesDataSchema.prototype.getSourceDimensionIndex = function(dimName) {
        return (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(this._dimNameMap.get(dimName), -1);
    };
    /**
   * @caution Can only be used when `dimensionOmitted: true`.
   *
   * Notice: may return `null`/`undefined` if user not specify dimension names.
   */ SeriesDataSchema.prototype.getSourceDimension = function(dimIndex) {
        var dimensionsDefine = this.source.dimensionsDefine;
        if (dimensionsDefine) return dimensionsDefine[dimIndex];
    };
    SeriesDataSchema.prototype.makeStoreSchema = function() {
        var dimCount = this._fullDimCount;
        var willRetrieveDataByName = (0, $99e22f5c2aa5094b$export$8911336b527f8517)(this.source);
        var makeHashStrict = !$85b723b311a86ffc$export$238b87930d825d87(dimCount);
        // If source don't have dimensions or series don't omit unsed dimensions.
        // Generate from seriesDimList directly
        var dimHash = '';
        var dims = [];
        for(var fullDimIdx = 0, seriesDimIdx = 0; fullDimIdx < dimCount; fullDimIdx++){
            var property = void 0;
            var type = void 0;
            var ordinalMeta = void 0;
            var seriesDimDef = this.dimensions[seriesDimIdx];
            // The list has been sorted by `storeDimIndex` asc.
            if (seriesDimDef && seriesDimDef.storeDimIndex === fullDimIdx) {
                property = willRetrieveDataByName ? seriesDimDef.name : null;
                type = seriesDimDef.type;
                ordinalMeta = seriesDimDef.ordinalMeta;
                seriesDimIdx++;
            } else {
                var sourceDimDef = this.getSourceDimension(fullDimIdx);
                if (sourceDimDef) {
                    property = willRetrieveDataByName ? sourceDimDef.name : null;
                    type = sourceDimDef.type;
                }
            }
            dims.push({
                property: property,
                type: type,
                ordinalMeta: ordinalMeta
            });
            // If retrieving data by index,
            //   use <index, type, ordinalMeta> to determine whether data can be shared.
            //   (Because in this case there might be no dimension name defined in dataset, but indices always exists).
            //   (Indices are always 0, 1, 2, ..., so we can ignore them to shorten the hash).
            // Otherwise if retrieving data by property name (like `data: [{aa: 123, bb: 765}, ...]`),
            //   use <property, type, ordinalMeta> in hash.
            if (willRetrieveDataByName && property != null && (!seriesDimDef || !seriesDimDef.isCalculationCoord)) dimHash += makeHashStrict ? property.replace(/\`/g, '`1').replace(/\$/g, '`2') : property;
            dimHash += '$';
            dimHash += $85b723b311a86ffc$var$dimTypeShort[type] || 'f';
            if (ordinalMeta) dimHash += ordinalMeta.uid;
            dimHash += '$';
        }
        // Source from endpoint(usually series) will be read differently
        // when seriesLayoutBy or startIndex(which is affected by sourceHeader) are different.
        // So we use this three props as key.
        var source = this.source;
        var hash = [
            source.seriesLayoutBy,
            source.startIndex,
            dimHash
        ].join('$$');
        return {
            dimensions: dims,
            hash: hash
        };
    };
    SeriesDataSchema.prototype.makeOutputDimensionNames = function() {
        var result = [];
        for(var fullDimIdx = 0, seriesDimIdx = 0; fullDimIdx < this._fullDimCount; fullDimIdx++){
            var name_1 = void 0;
            var seriesDimDef = this.dimensions[seriesDimIdx];
            // The list has been sorted by `storeDimIndex` asc.
            if (seriesDimDef && seriesDimDef.storeDimIndex === fullDimIdx) {
                if (!seriesDimDef.isCalculationCoord) name_1 = seriesDimDef.name;
                seriesDimIdx++;
            } else {
                var sourceDimDef = this.getSourceDimension(fullDimIdx);
                if (sourceDimDef) name_1 = sourceDimDef.name;
            }
            result.push(name_1);
        }
        return result;
    };
    SeriesDataSchema.prototype.appendCalculationDimension = function(dimDef) {
        this.dimensions.push(dimDef);
        dimDef.isCalculationCoord = true;
        this._fullDimCount++;
        // If append dimension on a data store, consider the store
        // might be shared by different series, series dimensions not
        // really map to store dimensions.
        this._updateDimOmitted(true);
    };
    return SeriesDataSchema;
}();
function $85b723b311a86ffc$export$fafbc856132a3a0e(schema) {
    return schema instanceof $85b723b311a86ffc$export$a1ef064685775f3e;
}
function $85b723b311a86ffc$export$a477f5bebfd07944(dimsDef) {
    var dataDimNameMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    for(var i = 0; i < (dimsDef || []).length; i++){
        var dimDefItemRaw = dimsDef[i];
        var userDimName = (0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(dimDefItemRaw) ? dimDefItemRaw.name : dimDefItemRaw;
        if (userDimName != null && dataDimNameMap.get(userDimName) == null) dataDimNameMap.set(userDimName, i);
    }
    return dataDimNameMap;
}
function $85b723b311a86ffc$export$be39ae17310c33f7(source) {
    var innerSource = $85b723b311a86ffc$var$inner(source);
    return innerSource.dimNameMap || (innerSource.dimNameMap = $85b723b311a86ffc$export$a477f5bebfd07944(source.dimensionsDefine));
}
function $85b723b311a86ffc$export$238b87930d825d87(dimCount) {
    return dimCount > 30;
}


function $efdd976e4917927c$export$f2165f9e8499b278(seriesModel, dimensionsInput, opt) {
    opt = opt || {};
    var byIndex = opt.byIndex;
    var stackedCoordDimension = opt.stackedCoordDimension;
    var dimensionDefineList;
    var schema;
    var store;
    if ($efdd976e4917927c$var$isLegacyDimensionsInput(dimensionsInput)) dimensionDefineList = dimensionsInput;
    else {
        schema = dimensionsInput.schema;
        dimensionDefineList = schema.dimensions;
        store = dimensionsInput.store;
    }
    // Compatibal: when `stack` is set as '', do not stack.
    var mayStack = !!(seriesModel && seriesModel.get('stack'));
    var stackedByDimInfo;
    var stackedDimInfo;
    var stackResultDimension;
    var stackedOverDimension;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dimensionDefineList, function(dimensionInfo, index) {
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(dimensionInfo)) dimensionDefineList[index] = dimensionInfo = {
            name: dimensionInfo
        };
        if (mayStack && !dimensionInfo.isExtraCoord) {
            // Find the first ordinal dimension as the stackedByDimInfo.
            if (!byIndex && !stackedByDimInfo && dimensionInfo.ordinalMeta) stackedByDimInfo = dimensionInfo;
            // Find the first stackable dimension as the stackedDimInfo.
            if (!stackedDimInfo && dimensionInfo.type !== 'ordinal' && dimensionInfo.type !== 'time' && (!stackedCoordDimension || stackedCoordDimension === dimensionInfo.coordDim)) stackedDimInfo = dimensionInfo;
        }
    });
    if (stackedDimInfo && !byIndex && !stackedByDimInfo) // Compatible with previous design, value axis (time axis) only stack by index.
    // It may make sense if the user provides elaborately constructed data.
    byIndex = true;
    // Add stack dimension, they can be both calculated by coordinate system in `unionExtent`.
    // That put stack logic in List is for using conveniently in echarts extensions, but it
    // might not be a good way.
    if (stackedDimInfo) {
        // Use a weird name that not duplicated with other names.
        // Also need to use seriesModel.id as postfix because different
        // series may share same data store. The stack dimension needs to be distinguished.
        stackResultDimension = '__\0ecstackresult_' + seriesModel.id;
        stackedOverDimension = '__\0ecstackedover_' + seriesModel.id;
        // Create inverted index to fast query index by value.
        if (stackedByDimInfo) stackedByDimInfo.createInvertedIndices = true;
        var stackedDimCoordDim_1 = stackedDimInfo.coordDim;
        var stackedDimType = stackedDimInfo.type;
        var stackedDimCoordIndex_1 = 0;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dimensionDefineList, function(dimensionInfo) {
            if (dimensionInfo.coordDim === stackedDimCoordDim_1) stackedDimCoordIndex_1++;
        });
        var stackedOverDimensionDefine = {
            name: stackResultDimension,
            coordDim: stackedDimCoordDim_1,
            coordDimIndex: stackedDimCoordIndex_1,
            type: stackedDimType,
            isExtraCoord: true,
            isCalculationCoord: true,
            storeDimIndex: dimensionDefineList.length
        };
        var stackResultDimensionDefine = {
            name: stackedOverDimension,
            // This dimension contains stack base (generally, 0), so do not set it as
            // `stackedDimCoordDim` to avoid extent calculation, consider log scale.
            coordDim: stackedOverDimension,
            coordDimIndex: stackedDimCoordIndex_1 + 1,
            type: stackedDimType,
            isExtraCoord: true,
            isCalculationCoord: true,
            storeDimIndex: dimensionDefineList.length + 1
        };
        if (schema) {
            if (store) {
                stackedOverDimensionDefine.storeDimIndex = store.ensureCalculationDimension(stackedOverDimension, stackedDimType);
                stackResultDimensionDefine.storeDimIndex = store.ensureCalculationDimension(stackResultDimension, stackedDimType);
            }
            schema.appendCalculationDimension(stackedOverDimensionDefine);
            schema.appendCalculationDimension(stackResultDimensionDefine);
        } else {
            dimensionDefineList.push(stackedOverDimensionDefine);
            dimensionDefineList.push(stackResultDimensionDefine);
        }
    }
    return {
        stackedDimension: stackedDimInfo && stackedDimInfo.name,
        stackedByDimension: stackedByDimInfo && stackedByDimInfo.name,
        isStackedByIndex: byIndex,
        stackedOverDimension: stackedOverDimension,
        stackResultDimension: stackResultDimension
    };
}
function $efdd976e4917927c$var$isLegacyDimensionsInput(dimensionsInput) {
    return !(0, $85b723b311a86ffc$export$fafbc856132a3a0e)(dimensionsInput.schema);
}
function $efdd976e4917927c$export$1dedc39359ae35c(data, stackedDim) {
    // Each single series only maps to one pair of axis. So we do not need to
    // check stackByDim, whatever stacked by a dimension or stacked by index.
    return !!stackedDim && stackedDim === data.getCalculationInfo('stackedDimension');
}
function $efdd976e4917927c$export$909db2be4938fbdf(data, targetDim) {
    return $efdd976e4917927c$export$1dedc39359ae35c(data, targetDim) ? data.getCalculationInfo('stackResultDimension') : targetDim;
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/* global Float32Array */ var $5cd50afac93e9148$var$supportFloat32Array = typeof Float32Array !== 'undefined';
var $5cd50afac93e9148$var$Float32ArrayCtor = !$5cd50afac93e9148$var$supportFloat32Array ? Array : Float32Array;
function $5cd50afac93e9148$export$21d2298f3f56bbaf(arg) {
    if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(arg)) // Return self directly if don't support TypedArray.
    return $5cd50afac93e9148$var$supportFloat32Array ? new Float32Array(arg) : arg;
    // Else is number
    return new $5cd50afac93e9148$var$Float32ArrayCtor(arg);
}


var $361c48dd900de28f$var$STACK_PREFIX = '__ec_stack_';
function $361c48dd900de28f$var$getSeriesStackId(seriesModel) {
    return seriesModel.get('stack') || $361c48dd900de28f$var$STACK_PREFIX + seriesModel.seriesIndex;
}
function $361c48dd900de28f$var$getAxisKey(axis) {
    return axis.dim + axis.index;
}
function $361c48dd900de28f$export$658df087977b9e84(opt) {
    var params = [];
    var baseAxis = opt.axis;
    var axisKey = 'axis0';
    if (baseAxis.type !== 'category') return;
    var bandWidth = baseAxis.getBandWidth();
    for(var i = 0; i < opt.count || 0; i++)params.push((0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
        bandWidth: bandWidth,
        axisKey: axisKey,
        stackId: $361c48dd900de28f$var$STACK_PREFIX + i
    }, opt));
    var widthAndOffsets = $361c48dd900de28f$var$doCalBarWidthAndOffset(params);
    var result = [];
    for(var i = 0; i < opt.count; i++){
        var item = widthAndOffsets[axisKey][$361c48dd900de28f$var$STACK_PREFIX + i];
        item.offsetCenter = item.offset + item.width / 2;
        result.push(item);
    }
    return result;
}
function $361c48dd900de28f$export$efbd0c3f5ab0d5e4(seriesType, ecModel) {
    var seriesModels = [];
    ecModel.eachSeriesByType(seriesType, function(seriesModel) {
        // Check series coordinate, do layout for cartesian2d only
        if ($361c48dd900de28f$var$isOnCartesian(seriesModel)) seriesModels.push(seriesModel);
    });
    return seriesModels;
}
/**
 * Map from (baseAxis.dim + '_' + baseAxis.index) to min gap of two adjacent
 * values.
 * This works for time axes, value axes, and log axes.
 * For a single time axis, return value is in the form like
 * {'x_0': [1000000]}.
 * The value of 1000000 is in milliseconds.
 */ function $361c48dd900de28f$var$getValueAxesMinGaps(barSeries) {
    /**
   * Map from axis.index to values.
   * For a single time axis, axisValues is in the form like
   * {'x_0': [1495555200000, 1495641600000, 1495728000000]}.
   * Items in axisValues[x], e.g. 1495555200000, are time values of all
   * series.
   */ var axisValues = {};
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(barSeries, function(seriesModel) {
        var cartesian = seriesModel.coordinateSystem;
        var baseAxis = cartesian.getBaseAxis();
        if (baseAxis.type !== 'time' && baseAxis.type !== 'value') return;
        var data = seriesModel.getData();
        var key = baseAxis.dim + '_' + baseAxis.index;
        var dimIdx = data.getDimensionIndex(data.mapDimension(baseAxis.dim));
        var store = data.getStore();
        for(var i = 0, cnt = store.count(); i < cnt; ++i){
            var value = store.get(dimIdx, i);
            if (!axisValues[key]) // No previous data for the axis
            axisValues[key] = [
                value
            ];
            else // No value in previous series
            axisValues[key].push(value);
        // Ignore duplicated time values in the same axis
        }
    });
    var axisMinGaps = {};
    for(var key in axisValues)if (axisValues.hasOwnProperty(key)) {
        var valuesInAxis = axisValues[key];
        if (valuesInAxis) {
            // Sort axis values into ascending order to calculate gaps
            valuesInAxis.sort(function(a, b) {
                return a - b;
            });
            var min = null;
            for(var j = 1; j < valuesInAxis.length; ++j){
                var delta = valuesInAxis[j] - valuesInAxis[j - 1];
                if (delta > 0) // Ignore 0 delta because they are of the same axis value
                min = min === null ? delta : Math.min(min, delta);
            }
            // Set to null if only have one data
            axisMinGaps[key] = min;
        }
    }
    return axisMinGaps;
}
function $361c48dd900de28f$export$20769dafc84e0299(barSeries) {
    var axisMinGaps = $361c48dd900de28f$var$getValueAxesMinGaps(barSeries);
    var seriesInfoList = [];
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(barSeries, function(seriesModel) {
        var cartesian = seriesModel.coordinateSystem;
        var baseAxis = cartesian.getBaseAxis();
        var axisExtent = baseAxis.getExtent();
        var bandWidth;
        if (baseAxis.type === 'category') bandWidth = baseAxis.getBandWidth();
        else if (baseAxis.type === 'value' || baseAxis.type === 'time') {
            var key = baseAxis.dim + '_' + baseAxis.index;
            var minGap = axisMinGaps[key];
            var extentSpan = Math.abs(axisExtent[1] - axisExtent[0]);
            var scale = baseAxis.scale.getExtent();
            var scaleSpan = Math.abs(scale[1] - scale[0]);
            bandWidth = minGap ? extentSpan / scaleSpan * minGap : extentSpan; // When there is only one data value
        } else {
            var data = seriesModel.getData();
            bandWidth = Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
        }
        var barWidth = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(seriesModel.get('barWidth'), bandWidth);
        var barMaxWidth = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(seriesModel.get('barMaxWidth'), bandWidth);
        var barMinWidth = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(// barMinWidth by default is 0.5 / 1 in cartesian. Because in value axis,
        // the auto-calculated bar width might be less than 0.5 / 1.
        seriesModel.get('barMinWidth') || ($361c48dd900de28f$var$isInLargeMode(seriesModel) ? 0.5 : 1), bandWidth);
        var barGap = seriesModel.get('barGap');
        var barCategoryGap = seriesModel.get('barCategoryGap');
        seriesInfoList.push({
            bandWidth: bandWidth,
            barWidth: barWidth,
            barMaxWidth: barMaxWidth,
            barMinWidth: barMinWidth,
            barGap: barGap,
            barCategoryGap: barCategoryGap,
            axisKey: $361c48dd900de28f$var$getAxisKey(baseAxis),
            stackId: $361c48dd900de28f$var$getSeriesStackId(seriesModel)
        });
    });
    return $361c48dd900de28f$var$doCalBarWidthAndOffset(seriesInfoList);
}
function $361c48dd900de28f$var$doCalBarWidthAndOffset(seriesInfoList) {
    // Columns info on each category axis. Key is cartesian name
    var columnsMap = {};
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(seriesInfoList, function(seriesInfo, idx) {
        var axisKey = seriesInfo.axisKey;
        var bandWidth = seriesInfo.bandWidth;
        var columnsOnAxis = columnsMap[axisKey] || {
            bandWidth: bandWidth,
            remainedWidth: bandWidth,
            autoWidthCount: 0,
            categoryGap: null,
            gap: '20%',
            stacks: {}
        };
        var stacks = columnsOnAxis.stacks;
        columnsMap[axisKey] = columnsOnAxis;
        var stackId = seriesInfo.stackId;
        if (!stacks[stackId]) columnsOnAxis.autoWidthCount++;
        stacks[stackId] = stacks[stackId] || {
            width: 0,
            maxWidth: 0
        };
        // Caution: In a single coordinate system, these barGrid attributes
        // will be shared by series. Consider that they have default values,
        // only the attributes set on the last series will work.
        // Do not change this fact unless there will be a break change.
        var barWidth = seriesInfo.barWidth;
        if (barWidth && !stacks[stackId].width) {
            // See #6312, do not restrict width.
            stacks[stackId].width = barWidth;
            barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
            columnsOnAxis.remainedWidth -= barWidth;
        }
        var barMaxWidth = seriesInfo.barMaxWidth;
        barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
        var barMinWidth = seriesInfo.barMinWidth;
        barMinWidth && (stacks[stackId].minWidth = barMinWidth);
        var barGap = seriesInfo.barGap;
        barGap != null && (columnsOnAxis.gap = barGap);
        var barCategoryGap = seriesInfo.barCategoryGap;
        barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
    });
    var result = {};
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(columnsMap, function(columnsOnAxis, coordSysName) {
        result[coordSysName] = {};
        var stacks = columnsOnAxis.stacks;
        var bandWidth = columnsOnAxis.bandWidth;
        var categoryGapPercent = columnsOnAxis.categoryGap;
        if (categoryGapPercent == null) {
            var columnCount = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(stacks).length;
            // More columns in one group
            // the spaces between group is smaller. Or the column will be too thin.
            categoryGapPercent = Math.max(35 - columnCount * 4, 15) + '%';
        }
        var categoryGap = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(categoryGapPercent, bandWidth);
        var barGapPercent = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(columnsOnAxis.gap, 1);
        var remainedWidth = columnsOnAxis.remainedWidth;
        var autoWidthCount = columnsOnAxis.autoWidthCount;
        var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
        autoWidth = Math.max(autoWidth, 0);
        // Find if any auto calculated bar exceeded maxBarWidth
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(stacks, function(column) {
            var maxWidth = column.maxWidth;
            var minWidth = column.minWidth;
            if (!column.width) {
                var finalWidth = autoWidth;
                if (maxWidth && maxWidth < finalWidth) finalWidth = Math.min(maxWidth, remainedWidth);
                // `minWidth` has higher priority. `minWidth` decide that whether the
                // bar is able to be visible. So `minWidth` should not be restricted
                // by `maxWidth` or `remainedWidth` (which is from `bandWidth`). In
                // the extreme cases for `value` axis, bars are allowed to overlap
                // with each other if `minWidth` specified.
                if (minWidth && minWidth > finalWidth) finalWidth = minWidth;
                if (finalWidth !== autoWidth) {
                    column.width = finalWidth;
                    remainedWidth -= finalWidth + barGapPercent * finalWidth;
                    autoWidthCount--;
                }
            } else {
                // `barMinWidth/barMaxWidth` has higher priority than `barWidth`, as
                // CSS does. Because barWidth can be a percent value, where
                // `barMaxWidth` can be used to restrict the final width.
                var finalWidth = column.width;
                if (maxWidth) finalWidth = Math.min(finalWidth, maxWidth);
                // `minWidth` has higher priority, as described above
                if (minWidth) finalWidth = Math.max(finalWidth, minWidth);
                column.width = finalWidth;
                remainedWidth -= finalWidth + barGapPercent * finalWidth;
                autoWidthCount--;
            }
        });
        // Recalculate width again
        autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
        autoWidth = Math.max(autoWidth, 0);
        var widthSum = 0;
        var lastColumn;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(stacks, function(column, idx) {
            if (!column.width) column.width = autoWidth;
            lastColumn = column;
            widthSum += column.width * (1 + barGapPercent);
        });
        if (lastColumn) widthSum -= lastColumn.width * barGapPercent;
        var offset = -widthSum / 2;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(stacks, function(column, stackId) {
            result[coordSysName][stackId] = result[coordSysName][stackId] || {
                bandWidth: bandWidth,
                offset: offset,
                width: column.width
            };
            offset += column.width * (1 + barGapPercent);
        });
    });
    return result;
}
function $361c48dd900de28f$export$35920bb6556da1c2(barWidthAndOffset, axis, seriesModel) {
    if (barWidthAndOffset && axis) {
        var result = barWidthAndOffset[$361c48dd900de28f$var$getAxisKey(axis)];
        if (result != null && seriesModel != null) return result[$361c48dd900de28f$var$getSeriesStackId(seriesModel)];
        return result;
    }
}
function $361c48dd900de28f$export$b3219800bda33a1f(seriesType, ecModel) {
    var seriesModels = $361c48dd900de28f$export$efbd0c3f5ab0d5e4(seriesType, ecModel);
    var barWidthAndOffset = $361c48dd900de28f$export$20769dafc84e0299(seriesModels);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(seriesModels, function(seriesModel) {
        var data = seriesModel.getData();
        var cartesian = seriesModel.coordinateSystem;
        var baseAxis = cartesian.getBaseAxis();
        var stackId = $361c48dd900de28f$var$getSeriesStackId(seriesModel);
        var columnLayoutInfo = barWidthAndOffset[$361c48dd900de28f$var$getAxisKey(baseAxis)][stackId];
        var columnOffset = columnLayoutInfo.offset;
        var columnWidth = columnLayoutInfo.width;
        data.setLayout({
            bandWidth: columnLayoutInfo.bandWidth,
            offset: columnOffset,
            size: columnWidth
        });
    });
}
function $361c48dd900de28f$export$16e8685758531cb6(seriesType) {
    return {
        seriesType: seriesType,
        plan: (0, $cd70075c57b35175$export$2e2bcd8739ae039)(),
        reset: function(seriesModel) {
            if (!$361c48dd900de28f$var$isOnCartesian(seriesModel)) return;
            var data = seriesModel.getData();
            var cartesian = seriesModel.coordinateSystem;
            var baseAxis = cartesian.getBaseAxis();
            var valueAxis = cartesian.getOtherAxis(baseAxis);
            var valueDimIdx = data.getDimensionIndex(data.mapDimension(valueAxis.dim));
            var baseDimIdx = data.getDimensionIndex(data.mapDimension(baseAxis.dim));
            var drawBackground = seriesModel.get('showBackground', true);
            var valueDim = data.mapDimension(valueAxis.dim);
            var stackResultDim = data.getCalculationInfo('stackResultDimension');
            var stacked = (0, $efdd976e4917927c$export$1dedc39359ae35c)(data, valueDim) && !!data.getCalculationInfo('stackedOnSeries');
            var isValueAxisH = valueAxis.isHorizontal();
            var valueAxisStart = $361c48dd900de28f$var$getValueAxisStart(baseAxis, valueAxis);
            var isLarge = $361c48dd900de28f$var$isInLargeMode(seriesModel);
            var barMinHeight = seriesModel.get('barMinHeight') || 0;
            var stackedDimIdx = stackResultDim && data.getDimensionIndex(stackResultDim);
            // Layout info.
            var columnWidth = data.getLayout('size');
            var columnOffset = data.getLayout('offset');
            return {
                progress: function(params, data) {
                    var count = params.count;
                    var largePoints = isLarge && (0, $5cd50afac93e9148$export$21d2298f3f56bbaf)(count * 3);
                    var largeBackgroundPoints = isLarge && drawBackground && (0, $5cd50afac93e9148$export$21d2298f3f56bbaf)(count * 3);
                    var largeDataIndices = isLarge && (0, $5cd50afac93e9148$export$21d2298f3f56bbaf)(count);
                    var coordLayout = cartesian.master.getRect();
                    var bgSize = isValueAxisH ? coordLayout.width : coordLayout.height;
                    var dataIndex;
                    var store = data.getStore();
                    var idxOffset = 0;
                    while((dataIndex = params.next()) != null){
                        var value = store.get(stacked ? stackedDimIdx : valueDimIdx, dataIndex);
                        var baseValue = store.get(baseDimIdx, dataIndex);
                        var baseCoord = valueAxisStart;
                        var stackStartValue = void 0;
                        // Because of the barMinHeight, we can not use the value in
                        // stackResultDimension directly.
                        if (stacked) stackStartValue = +value - store.get(valueDimIdx, dataIndex);
                        var x = void 0;
                        var y = void 0;
                        var width = void 0;
                        var height = void 0;
                        if (isValueAxisH) {
                            var coord = cartesian.dataToPoint([
                                value,
                                baseValue
                            ]);
                            if (stacked) {
                                var startCoord = cartesian.dataToPoint([
                                    stackStartValue,
                                    baseValue
                                ]);
                                baseCoord = startCoord[0];
                            }
                            x = baseCoord;
                            y = coord[1] + columnOffset;
                            width = coord[0] - baseCoord;
                            height = columnWidth;
                            if (Math.abs(width) < barMinHeight) width = (width < 0 ? -1 : 1) * barMinHeight;
                        } else {
                            var coord = cartesian.dataToPoint([
                                baseValue,
                                value
                            ]);
                            if (stacked) {
                                var startCoord = cartesian.dataToPoint([
                                    baseValue,
                                    stackStartValue
                                ]);
                                baseCoord = startCoord[1];
                            }
                            x = coord[0] + columnOffset;
                            y = baseCoord;
                            width = columnWidth;
                            height = coord[1] - baseCoord;
                            if (Math.abs(height) < barMinHeight) // Include zero to has a positive bar
                            height = (height <= 0 ? -1 : 1) * barMinHeight;
                        }
                        if (!isLarge) data.setItemLayout(dataIndex, {
                            x: x,
                            y: y,
                            width: width,
                            height: height
                        });
                        else {
                            largePoints[idxOffset] = x;
                            largePoints[idxOffset + 1] = y;
                            largePoints[idxOffset + 2] = isValueAxisH ? width : height;
                            if (largeBackgroundPoints) {
                                largeBackgroundPoints[idxOffset] = isValueAxisH ? coordLayout.x : x;
                                largeBackgroundPoints[idxOffset + 1] = isValueAxisH ? y : coordLayout.y;
                                largeBackgroundPoints[idxOffset + 2] = bgSize;
                            }
                            largeDataIndices[dataIndex] = dataIndex;
                        }
                        idxOffset += 3;
                    }
                    if (isLarge) data.setLayout({
                        largePoints: largePoints,
                        largeDataIndices: largeDataIndices,
                        largeBackgroundPoints: largeBackgroundPoints,
                        valueAxisHorizontal: isValueAxisH
                    });
                }
            };
        }
    };
}
function $361c48dd900de28f$var$isOnCartesian(seriesModel) {
    return seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === 'cartesian2d';
}
function $361c48dd900de28f$var$isInLargeMode(seriesModel) {
    return seriesModel.pipelineContext && seriesModel.pipelineContext.large;
}
// See cases in `test/bar-start.html` and `#7412`, `#8747`.
function $361c48dd900de28f$var$getValueAxisStart(baseAxis, valueAxis) {
    var startValue = valueAxis.model.get('startValue');
    if (!startValue) startValue = 0;
    return valueAxis.toGlobalCoord(valueAxis.dataToCoord(valueAxis.type === 'log' ? startValue > 0 ? startValue : 1 : startValue));
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3a37e5b80322a871$var$samplers = {
    average: function(frame) {
        var sum = 0;
        var count = 0;
        for(var i = 0; i < frame.length; i++)if (!isNaN(frame[i])) {
            sum += frame[i];
            count++;
        }
        // Return NaN if count is 0
        return count === 0 ? NaN : sum / count;
    },
    sum: function(frame) {
        var sum = 0;
        for(var i = 0; i < frame.length; i++)// Ignore NaN
        sum += frame[i] || 0;
        return sum;
    },
    max: function(frame) {
        var max = -Infinity;
        for(var i = 0; i < frame.length; i++)frame[i] > max && (max = frame[i]);
        // NaN will cause illegal axis extent.
        return isFinite(max) ? max : NaN;
    },
    min: function(frame) {
        var min = Infinity;
        for(var i = 0; i < frame.length; i++)frame[i] < min && (min = frame[i]);
        // NaN will cause illegal axis extent.
        return isFinite(min) ? min : NaN;
    },
    // TODO
    // Median
    nearest: function(frame) {
        return frame[0];
    }
};
var $3a37e5b80322a871$var$indexSampler = function(frame) {
    return Math.round(frame.length / 2);
};
function $3a37e5b80322a871$export$2e2bcd8739ae039(seriesType) {
    return {
        seriesType: seriesType,
        // FIXME:TS never used, so comment it
        // modifyOutputEnd: true,
        reset: function(seriesModel, ecModel, api) {
            var data = seriesModel.getData();
            var sampling = seriesModel.get('sampling');
            var coordSys = seriesModel.coordinateSystem;
            var count = data.count();
            // Only cartesian2d support down sampling. Disable it when there is few data.
            if (count > 10 && coordSys.type === 'cartesian2d' && sampling) {
                var baseAxis = coordSys.getBaseAxis();
                var valueAxis = coordSys.getOtherAxis(baseAxis);
                var extent = baseAxis.getExtent();
                var dpr = api.getDevicePixelRatio();
                // Coordinste system has been resized
                var size = Math.abs(extent[1] - extent[0]) * (dpr || 1);
                var rate = Math.round(count / size);
                if (isFinite(rate) && rate > 1) {
                    if (sampling === 'lttb') seriesModel.setData(data.lttbDownSample(data.mapDimension(valueAxis.dim), 1 / rate));
                    else if (sampling === 'minmax') seriesModel.setData(data.minmaxDownSample(data.mapDimension(valueAxis.dim), 1 / rate));
                    var sampler = void 0;
                    if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(sampling)) sampler = $3a37e5b80322a871$var$samplers[sampling];
                    else if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(sampling)) sampler = sampling;
                    if (sampler) // Only support sample the first dim mapped from value axis.
                    seriesModel.setData(data.downSample(data.mapDimension(valueAxis.dim), 1 / rate, sampler, $3a37e5b80322a871$var$indexSampler));
                }
            }
        }
    };
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /* global Int32Array */ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $306d1c87baff8a10$var$dataIndexMapValueLength(valNumOrArrLengthMoreThan2) {
    return valNumOrArrLengthMoreThan2 == null ? 0 : valNumOrArrLengthMoreThan2.length || 1;
}
function $306d1c87baff8a10$var$defaultKeyGetter(item) {
    return item;
}
var $306d1c87baff8a10$var$DataDiffer = /** @class */ function() {
    /**
   * @param context Can be visited by this.context in callback.
   */ function DataDiffer(oldArr, newArr, oldKeyGetter, newKeyGetter, context, // By default: 'oneToOne'.
    diffMode) {
        this._old = oldArr;
        this._new = newArr;
        this._oldKeyGetter = oldKeyGetter || $306d1c87baff8a10$var$defaultKeyGetter;
        this._newKeyGetter = newKeyGetter || $306d1c87baff8a10$var$defaultKeyGetter;
        // Visible in callback via `this.context`;
        this.context = context;
        this._diffModeMultiple = diffMode === 'multiple';
    }
    /**
   * Callback function when add a data
   */ DataDiffer.prototype.add = function(func) {
        this._add = func;
        return this;
    };
    /**
   * Callback function when update a data
   */ DataDiffer.prototype.update = function(func) {
        this._update = func;
        return this;
    };
    /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */ DataDiffer.prototype.updateManyToOne = function(func) {
        this._updateManyToOne = func;
        return this;
    };
    /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */ DataDiffer.prototype.updateOneToMany = function(func) {
        this._updateOneToMany = func;
        return this;
    };
    /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */ DataDiffer.prototype.updateManyToMany = function(func) {
        this._updateManyToMany = func;
        return this;
    };
    /**
   * Callback function when remove a data
   */ DataDiffer.prototype.remove = function(func) {
        this._remove = func;
        return this;
    };
    DataDiffer.prototype.execute = function() {
        this[this._diffModeMultiple ? '_executeMultiple' : '_executeOneToOne']();
    };
    DataDiffer.prototype._executeOneToOne = function() {
        var oldArr = this._old;
        var newArr = this._new;
        var newDataIndexMap = {};
        var oldDataKeyArr = new Array(oldArr.length);
        var newDataKeyArr = new Array(newArr.length);
        this._initIndexMap(oldArr, null, oldDataKeyArr, '_oldKeyGetter');
        this._initIndexMap(newArr, newDataIndexMap, newDataKeyArr, '_newKeyGetter');
        for(var i = 0; i < oldArr.length; i++){
            var oldKey = oldDataKeyArr[i];
            var newIdxMapVal = newDataIndexMap[oldKey];
            var newIdxMapValLen = $306d1c87baff8a10$var$dataIndexMapValueLength(newIdxMapVal);
            // idx can never be empty array here. see 'set null' logic below.
            if (newIdxMapValLen > 1) {
                // Consider there is duplicate key (for example, use dataItem.name as key).
                // We should make sure every item in newArr and oldArr can be visited.
                var newIdx = newIdxMapVal.shift();
                if (newIdxMapVal.length === 1) newDataIndexMap[oldKey] = newIdxMapVal[0];
                this._update && this._update(newIdx, i);
            } else if (newIdxMapValLen === 1) {
                newDataIndexMap[oldKey] = null;
                this._update && this._update(newIdxMapVal, i);
            } else this._remove && this._remove(i);
        }
        this._performRestAdd(newDataKeyArr, newDataIndexMap);
    };
    /**
   * For example, consider the case:
   * oldData: [o0, o1, o2, o3, o4, o5, o6, o7],
   * newData: [n0, n1, n2, n3, n4, n5, n6, n7, n8],
   * Where:
   *     o0, o1, n0 has key 'a' (many to one)
   *     o5, n4, n5, n6 has key 'b' (one to many)
   *     o2, n1 has key 'c' (one to one)
   *     n2, n3 has key 'd' (add)
   *     o3, o4 has key 'e' (remove)
   *     o6, o7, n7, n8 has key 'f' (many to many, treated as add and remove)
   * Then:
   *     (The order of the following directives are not ensured.)
   *     this._updateManyToOne(n0, [o0, o1]);
   *     this._updateOneToMany([n4, n5, n6], o5);
   *     this._update(n1, o2);
   *     this._remove(o3);
   *     this._remove(o4);
   *     this._remove(o6);
   *     this._remove(o7);
   *     this._add(n2);
   *     this._add(n3);
   *     this._add(n7);
   *     this._add(n8);
   */ DataDiffer.prototype._executeMultiple = function() {
        var oldArr = this._old;
        var newArr = this._new;
        var oldDataIndexMap = {};
        var newDataIndexMap = {};
        var oldDataKeyArr = [];
        var newDataKeyArr = [];
        this._initIndexMap(oldArr, oldDataIndexMap, oldDataKeyArr, '_oldKeyGetter');
        this._initIndexMap(newArr, newDataIndexMap, newDataKeyArr, '_newKeyGetter');
        for(var i = 0; i < oldDataKeyArr.length; i++){
            var oldKey = oldDataKeyArr[i];
            var oldIdxMapVal = oldDataIndexMap[oldKey];
            var newIdxMapVal = newDataIndexMap[oldKey];
            var oldIdxMapValLen = $306d1c87baff8a10$var$dataIndexMapValueLength(oldIdxMapVal);
            var newIdxMapValLen = $306d1c87baff8a10$var$dataIndexMapValueLength(newIdxMapVal);
            if (oldIdxMapValLen > 1 && newIdxMapValLen === 1) {
                this._updateManyToOne && this._updateManyToOne(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen === 1 && newIdxMapValLen > 1) {
                this._updateOneToMany && this._updateOneToMany(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen === 1 && newIdxMapValLen === 1) {
                this._update && this._update(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen > 1 && newIdxMapValLen > 1) {
                this._updateManyToMany && this._updateManyToMany(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen > 1) for(var i_1 = 0; i_1 < oldIdxMapValLen; i_1++)this._remove && this._remove(oldIdxMapVal[i_1]);
            else this._remove && this._remove(oldIdxMapVal);
        }
        this._performRestAdd(newDataKeyArr, newDataIndexMap);
    };
    DataDiffer.prototype._performRestAdd = function(newDataKeyArr, newDataIndexMap) {
        for(var i = 0; i < newDataKeyArr.length; i++){
            var newKey = newDataKeyArr[i];
            var newIdxMapVal = newDataIndexMap[newKey];
            var idxMapValLen = $306d1c87baff8a10$var$dataIndexMapValueLength(newIdxMapVal);
            if (idxMapValLen > 1) for(var j = 0; j < idxMapValLen; j++)this._add && this._add(newIdxMapVal[j]);
            else if (idxMapValLen === 1) this._add && this._add(newIdxMapVal);
            // Support both `newDataKeyArr` are duplication removed or not removed.
            newDataIndexMap[newKey] = null;
        }
    };
    DataDiffer.prototype._initIndexMap = function(arr, // Can be null.
    map, // In 'byKey', the output `keyArr` is duplication removed.
    // In 'byIndex', the output `keyArr` is not duplication removed and
    //     its indices are accurately corresponding to `arr`.
    keyArr, keyGetterName) {
        var cbModeMultiple = this._diffModeMultiple;
        for(var i = 0; i < arr.length; i++){
            // Add prefix to avoid conflict with Object.prototype.
            var key = '_ec_' + this[keyGetterName](arr[i], i);
            if (!cbModeMultiple) keyArr[i] = key;
            if (!map) continue;
            var idxMapVal = map[key];
            var idxMapValLen = $306d1c87baff8a10$var$dataIndexMapValueLength(idxMapVal);
            if (idxMapValLen === 0) {
                // Simple optimize: in most cases, one index has one key,
                // do not need array.
                map[key] = i;
                if (cbModeMultiple) keyArr.push(key);
            } else if (idxMapValLen === 1) map[key] = [
                idxMapVal,
                i
            ];
            else idxMapVal.push(i);
        }
    };
    return DataDiffer;
}();
var $306d1c87baff8a10$export$2e2bcd8739ae039 = $306d1c87baff8a10$var$DataDiffer;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $18085de91ae59d03$var$DimensionUserOuput = /** @class */ function() {
    function DimensionUserOuput(encode, dimRequest) {
        this._encode = encode;
        this._schema = dimRequest;
    }
    DimensionUserOuput.prototype.get = function() {
        return {
            // Do not generate full dimension name until fist used.
            fullDimensions: this._getFullDimensionNames(),
            encode: this._encode
        };
    };
    /**
   * Get all data store dimension names.
   * Theoretically a series data store is defined both by series and used dataset (if any).
   * If some dimensions are omitted for performance reason in `this.dimensions`,
   * the dimension name may not be auto-generated if user does not specify a dimension name.
   * In this case, the dimension name is `null`/`undefined`.
   */ DimensionUserOuput.prototype._getFullDimensionNames = function() {
        if (!this._cachedDimNames) this._cachedDimNames = this._schema ? this._schema.makeOutputDimensionNames() : [];
        return this._cachedDimNames;
    };
    return DimensionUserOuput;
}();
function $18085de91ae59d03$export$505a22c3734846f1(data, schema) {
    var summary = {};
    var encode = summary.encode = {};
    var notExtraCoordDimMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    var defaultedLabel = [];
    var defaultedTooltip = [];
    var userOutputEncode = {};
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(data.dimensions, function(dimName) {
        var dimItem = data.getDimensionInfo(dimName);
        var coordDim = dimItem.coordDim;
        if (coordDim) {
            var coordDimIndex = dimItem.coordDimIndex;
            $18085de91ae59d03$var$getOrCreateEncodeArr(encode, coordDim)[coordDimIndex] = dimName;
            if (!dimItem.isExtraCoord) {
                notExtraCoordDimMap.set(coordDim, 1);
                // Use the last coord dim (and label friendly) as default label,
                // because when dataset is used, it is hard to guess which dimension
                // can be value dimension. If both show x, y on label is not look good,
                // and conventionally y axis is focused more.
                if ($18085de91ae59d03$var$mayLabelDimType(dimItem.type)) defaultedLabel[0] = dimName;
                // User output encode do not contain generated coords.
                // And it only has index. User can use index to retrieve value from the raw item array.
                $18085de91ae59d03$var$getOrCreateEncodeArr(userOutputEncode, coordDim)[coordDimIndex] = data.getDimensionIndex(dimItem.name);
            }
            if (dimItem.defaultTooltip) defaultedTooltip.push(dimName);
        }
        (0, $cab29724515ce2b8$export$cd51b5ca77f6f0e4).each(function(v, otherDim) {
            var encodeArr = $18085de91ae59d03$var$getOrCreateEncodeArr(encode, otherDim);
            var dimIndex = dimItem.otherDims[otherDim];
            if (dimIndex != null && dimIndex !== false) encodeArr[dimIndex] = dimItem.name;
        });
    });
    var dataDimsOnCoord = [];
    var encodeFirstDimNotExtra = {};
    notExtraCoordDimMap.each(function(v, coordDim) {
        var dimArr = encode[coordDim];
        encodeFirstDimNotExtra[coordDim] = dimArr[0];
        // Not necessary to remove duplicate, because a data
        // dim canot on more than one coordDim.
        dataDimsOnCoord = dataDimsOnCoord.concat(dimArr);
    });
    summary.dataDimsOnCoord = dataDimsOnCoord;
    summary.dataDimIndicesOnCoord = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(dataDimsOnCoord, function(dimName) {
        return data.getDimensionInfo(dimName).storeDimIndex;
    });
    summary.encodeFirstDimNotExtra = encodeFirstDimNotExtra;
    var encodeLabel = encode.label;
    // FIXME `encode.label` is not recommended, because formatter cannot be set
    // in this way. Use label.formatter instead. Maybe remove this approach someday.
    if (encodeLabel && encodeLabel.length) defaultedLabel = encodeLabel.slice();
    var encodeTooltip = encode.tooltip;
    if (encodeTooltip && encodeTooltip.length) defaultedTooltip = encodeTooltip.slice();
    else if (!defaultedTooltip.length) defaultedTooltip = defaultedLabel.slice();
    encode.defaultedLabel = defaultedLabel;
    encode.defaultedTooltip = defaultedTooltip;
    summary.userOutput = new $18085de91ae59d03$var$DimensionUserOuput(userOutputEncode, schema);
    return summary;
}
function $18085de91ae59d03$var$getOrCreateEncodeArr(encode, dim) {
    if (!encode.hasOwnProperty(dim)) encode[dim] = [];
    return encode[dim];
}
function $18085de91ae59d03$export$af1622903e71278e(axisType) {
    return axisType === 'category' ? 'ordinal' : axisType === 'time' ? 'time' : 'float';
}
function $18085de91ae59d03$var$mayLabelDimType(dimType) {
    // In most cases, ordinal and time do not suitable for label.
    // Ordinal info can be displayed on axis. Time is too long.
    return !(dimType === 'ordinal' || dimType === 'time');
} // function findTheLastDimMayLabel(data) {
 //     // Get last value dim
 //     let dimensions = data.dimensions.slice();
 //     let valueType;
 //     let valueDim;
 //     while (dimensions.length && (
 //         valueDim = dimensions.pop(),
 //         valueType = data.getDimensionInfo(valueDim).type,
 //         valueType === 'ordinal' || valueType === 'time'
 //     )) {} // jshint ignore:line
 //     return valueDim;
 // }


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $5e233867ea3713e7$var$SeriesDimensionDefine = /** @class */ function() {
    /**
   * @param opt All of the fields will be shallow copied.
   */ function SeriesDimensionDefine(opt) {
        /**
     * The format of `otherDims` is:
     * ```js
     * {
     *     tooltip?: number
     *     label?: number
     *     itemName?: number
     *     seriesName?: number
     * }
     * ```
     *
     * A `series.encode` can specified these fields:
     * ```js
     * encode: {
     *     // "3, 1, 5" is the index of data dimension.
     *     tooltip: [3, 1, 5],
     *     label: [0, 3],
     *     ...
     * }
     * ```
     * `otherDims` is the parse result of the `series.encode` above, like:
     * ```js
     * // Suppose the index of this data dimension is `3`.
     * this.otherDims = {
     *     // `3` is at the index `0` of the `encode.tooltip`
     *     tooltip: 0,
     *     // `3` is at the index `1` of the `encode.label`
     *     label: 1
     * };
     * ```
     *
     * This prop should never be `null`/`undefined` after initialized.
     */ this.otherDims = {};
        if (opt != null) $7a1bd9c2710fea0d$export$8b58be045bf06082(this, opt);
    }
    return SeriesDimensionDefine;
}();
var $5e233867ea3713e7$export$2e2bcd8739ae039 = $5e233867ea3713e7$var$SeriesDimensionDefine;








var $0ab0556b819346fd$var$isObject = $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a;
var $0ab0556b819346fd$var$map = $7a1bd9c2710fea0d$export$871de8747c9eaa88;
var $0ab0556b819346fd$var$CtorInt32Array = typeof Int32Array === 'undefined' ? Array : Int32Array;
// Use prefix to avoid index to be the same as otherIdList[idx],
// which will cause weird update animation.
var $0ab0556b819346fd$var$ID_PREFIX = 'e\0\0';
var $0ab0556b819346fd$var$INDEX_NOT_FOUND = -1;
// type SeriesDimensionIndex = DimensionIndex;
var $0ab0556b819346fd$var$TRANSFERABLE_PROPERTIES = [
    'hasItemOption',
    '_nameList',
    '_idList',
    '_invertedIndicesMap',
    '_dimSummary',
    'userOutput',
    '_rawData',
    '_dimValueGetter',
    '_nameDimIdx',
    '_idDimIdx',
    '_nameRepeatCount'
];
var $0ab0556b819346fd$var$CLONE_PROPERTIES = [
    '_approximateExtent'
];
// -----------------------------
// Internal method declarations:
// -----------------------------
var $0ab0556b819346fd$var$prepareInvertedIndex;
var $0ab0556b819346fd$var$getId;
var $0ab0556b819346fd$var$getIdNameFromStore;
var $0ab0556b819346fd$var$normalizeDimensions;
var $0ab0556b819346fd$var$transferProperties;
var $0ab0556b819346fd$var$cloneListForMapAndSample;
var $0ab0556b819346fd$var$makeIdFromName;
var $0ab0556b819346fd$var$SeriesData = /** @class */ function() {
    /**
   * @param dimensionsInput.dimensions
   *        For example, ['someDimName', {name: 'someDimName', type: 'someDimType'}, ...].
   *        Dimensions should be concrete names like x, y, z, lng, lat, angle, radius
   */ function SeriesData(dimensionsInput, hostModel) {
        this.type = 'list';
        this._dimOmitted = false;
        this._nameList = [];
        this._idList = [];
        // Models of data option is stored sparse for optimizing memory cost
        // Never used yet (not used yet).
        // private _optionModels: Model[] = [];
        // Global visual properties after visual coding
        this._visual = {};
        // Global layout properties.
        this._layout = {};
        // Item visual properties after visual coding
        this._itemVisuals = [];
        // Item layout properties after layout
        this._itemLayouts = [];
        // Graphic elements
        this._graphicEls = [];
        // key: dim, value: extent
        this._approximateExtent = {};
        this._calculationInfo = {};
        // Having detected that there is data item is non primitive type
        // (in type `OptionDataItemObject`).
        // Like `data: [ { value: xx, itemStyle: {...} }, ...]`
        // At present it only happen in `SOURCE_FORMAT_ORIGINAL`.
        this.hasItemOption = false;
        // Methods that create a new list based on this list should be listed here.
        // Notice that those method should `RETURN` the new list.
        this.TRANSFERABLE_METHODS = [
            'cloneShallow',
            'downSample',
            'minmaxDownSample',
            'lttbDownSample',
            'map'
        ];
        // Methods that change indices of this list should be listed here.
        this.CHANGABLE_METHODS = [
            'filterSelf',
            'selectRange'
        ];
        this.DOWNSAMPLE_METHODS = [
            'downSample',
            'minmaxDownSample',
            'lttbDownSample'
        ];
        var dimensions;
        var assignStoreDimIdx = false;
        if ((0, $85b723b311a86ffc$export$fafbc856132a3a0e)(dimensionsInput)) {
            dimensions = dimensionsInput.dimensions;
            this._dimOmitted = dimensionsInput.isDimensionOmitted();
            this._schema = dimensionsInput;
        } else {
            assignStoreDimIdx = true;
            dimensions = dimensionsInput;
        }
        dimensions = dimensions || [
            'x',
            'y'
        ];
        var dimensionInfos = {};
        var dimensionNames = [];
        var invertedIndicesMap = {};
        var needsHasOwn = false;
        var emptyObj = {};
        for(var i = 0; i < dimensions.length; i++){
            // Use the original dimensions[i], where other flag props may exists.
            var dimInfoInput = dimensions[i];
            var dimensionInfo = $7a1bd9c2710fea0d$export$844ec244b1367d54(dimInfoInput) ? new (0, $5e233867ea3713e7$export$2e2bcd8739ae039)({
                name: dimInfoInput
            }) : !(dimInfoInput instanceof (0, $5e233867ea3713e7$export$2e2bcd8739ae039)) ? new (0, $5e233867ea3713e7$export$2e2bcd8739ae039)(dimInfoInput) : dimInfoInput;
            var dimensionName = dimensionInfo.name;
            dimensionInfo.type = dimensionInfo.type || 'float';
            if (!dimensionInfo.coordDim) {
                dimensionInfo.coordDim = dimensionName;
                dimensionInfo.coordDimIndex = 0;
            }
            var otherDims = dimensionInfo.otherDims = dimensionInfo.otherDims || {};
            dimensionNames.push(dimensionName);
            dimensionInfos[dimensionName] = dimensionInfo;
            if (emptyObj[dimensionName] != null) needsHasOwn = true;
            if (dimensionInfo.createInvertedIndices) invertedIndicesMap[dimensionName] = [];
            if (otherDims.itemName === 0) this._nameDimIdx = i;
            if (otherDims.itemId === 0) this._idDimIdx = i;
            if (assignStoreDimIdx) dimensionInfo.storeDimIndex = i;
        }
        this.dimensions = dimensionNames;
        this._dimInfos = dimensionInfos;
        this._initGetDimensionInfo(needsHasOwn);
        this.hostModel = hostModel;
        this._invertedIndicesMap = invertedIndicesMap;
        if (this._dimOmitted) {
            var dimIdxToName_1 = this._dimIdxToName = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(dimensionNames, function(dimName) {
                dimIdxToName_1.set(dimensionInfos[dimName].storeDimIndex, dimName);
            });
        }
    }
    /**
   *
   * Get concrete dimension name by dimension name or dimension index.
   * If input a dimension name, do not validate whether the dimension name exits.
   *
   * @caution
   * @param dim Must make sure the dimension is `SeriesDimensionLoose`.
   * Because only those dimensions will have auto-generated dimension names if not
   * have a user-specified name, and other dimensions will get a return of null/undefined.
   *
   * @notice Because of this reason, should better use `getDimensionIndex` instead, for examples:
   * ```js
   * const val = data.getStore().get(data.getDimensionIndex(dim), dataIdx);
   * ```
   *
   * @return Concrete dim name.
   */ SeriesData.prototype.getDimension = function(dim) {
        var dimIdx = this._recognizeDimIndex(dim);
        if (dimIdx == null) return dim;
        dimIdx = dim;
        if (!this._dimOmitted) return this.dimensions[dimIdx];
        // Retrieve from series dimension definition because it probably contains
        // generated dimension name (like 'x', 'y').
        var dimName = this._dimIdxToName.get(dimIdx);
        if (dimName != null) return dimName;
        var sourceDimDef = this._schema.getSourceDimension(dimIdx);
        if (sourceDimDef) return sourceDimDef.name;
    };
    /**
   * Get dimension index in data store. Return -1 if not found.
   * Can be used to index value from getRawValue.
   */ SeriesData.prototype.getDimensionIndex = function(dim) {
        var dimIdx = this._recognizeDimIndex(dim);
        if (dimIdx != null) return dimIdx;
        if (dim == null) return -1;
        var dimInfo = this._getDimInfo(dim);
        return dimInfo ? dimInfo.storeDimIndex : this._dimOmitted ? this._schema.getSourceDimensionIndex(dim) : -1;
    };
    /**
   * The meanings of the input parameter `dim`:
   *
   * + If dim is a number (e.g., `1`), it means the index of the dimension.
   *   For example, `getDimension(0)` will return 'x' or 'lng' or 'radius'.
   * + If dim is a number-like string (e.g., `"1"`):
   *     + If there is the same concrete dim name defined in `series.dimensions` or `dataset.dimensions`,
   *        it means that concrete name.
   *     + If not, it will be converted to a number, which means the index of the dimension.
   *        (why? because of the backward compatibility. We have been tolerating number-like string in
   *        dimension setting, although now it seems that it is not a good idea.)
   *     For example, `visualMap[i].dimension: "1"` is the same meaning as `visualMap[i].dimension: 1`,
   *     if no dimension name is defined as `"1"`.
   * + If dim is a not-number-like string, it means the concrete dim name.
   *   For example, it can be be default name `"x"`, `"y"`, `"z"`, `"lng"`, `"lat"`, `"angle"`, `"radius"`,
   *   or customized in `dimensions` property of option like `"age"`.
   *
   * @return recognized `DimensionIndex`. Otherwise return null/undefined (means that dim is `DimensionName`).
   */ SeriesData.prototype._recognizeDimIndex = function(dim) {
        if ($7a1bd9c2710fea0d$export$7e4aa119212bc614(dim) || dim != null && !isNaN(dim) && !this._getDimInfo(dim) && (!this._dimOmitted || this._schema.getSourceDimensionIndex(dim) < 0)) return +dim;
    };
    SeriesData.prototype._getStoreDimIndex = function(dim) {
        var dimIdx = this.getDimensionIndex(dim);
        return dimIdx;
    };
    /**
   * Get type and calculation info of particular dimension
   * @param dim
   *        Dimension can be concrete names like x, y, z, lng, lat, angle, radius
   *        Or a ordinal number. For example getDimensionInfo(0) will return 'x' or 'lng' or 'radius'
   */ SeriesData.prototype.getDimensionInfo = function(dim) {
        // Do not clone, because there may be categories in dimInfo.
        return this._getDimInfo(this.getDimension(dim));
    };
    SeriesData.prototype._initGetDimensionInfo = function(needsHasOwn) {
        var dimensionInfos = this._dimInfos;
        this._getDimInfo = needsHasOwn ? function(dimName) {
            return dimensionInfos.hasOwnProperty(dimName) ? dimensionInfos[dimName] : undefined;
        } : function(dimName) {
            return dimensionInfos[dimName];
        };
    };
    /**
   * concrete dimension name list on coord.
   */ SeriesData.prototype.getDimensionsOnCoord = function() {
        return this._dimSummary.dataDimsOnCoord.slice();
    };
    SeriesData.prototype.mapDimension = function(coordDim, idx) {
        var dimensionsSummary = this._dimSummary;
        if (idx == null) return dimensionsSummary.encodeFirstDimNotExtra[coordDim];
        var dims = dimensionsSummary.encode[coordDim];
        return dims ? dims[idx] : null;
    };
    SeriesData.prototype.mapDimensionsAll = function(coordDim) {
        var dimensionsSummary = this._dimSummary;
        var dims = dimensionsSummary.encode[coordDim];
        return (dims || []).slice();
    };
    SeriesData.prototype.getStore = function() {
        return this._store;
    };
    /**
   * Initialize from data
   * @param data source or data or data store.
   * @param nameList The name of a datum is used on data diff and
   *        default label/tooltip.
   *        A name can be specified in encode.itemName,
   *        or dataItem.name (only for series option data),
   *        or provided in nameList from outside.
   */ SeriesData.prototype.initData = function(data, nameList, dimValueGetter) {
        var _this = this;
        var store;
        if (data instanceof (0, $370e5aa482d8420b$export$2e2bcd8739ae039)) store = data;
        if (!store) {
            var dimensions = this.dimensions;
            var provider = (0, $99e22f5c2aa5094b$export$22b808bc02a60488)(data) || $7a1bd9c2710fea0d$export$1e2f57719e155213(data) ? new (0, $8ffb0d67e9446edb$export$b900d7c4c3952a40)(data, dimensions.length) : data;
            store = new (0, $370e5aa482d8420b$export$2e2bcd8739ae039)();
            var dimensionInfos = $0ab0556b819346fd$var$map(dimensions, function(dimName) {
                return {
                    type: _this._dimInfos[dimName].type,
                    property: dimName
                };
            });
            store.initData(provider, dimensionInfos, dimValueGetter);
        }
        this._store = store;
        // Reset
        this._nameList = (nameList || []).slice();
        this._idList = [];
        this._nameRepeatCount = {};
        this._doInit(0, store.count());
        // Cache summary info for fast visit. See "dimensionHelper".
        // Needs to be initialized after store is prepared.
        this._dimSummary = (0, $18085de91ae59d03$export$505a22c3734846f1)(this, this._schema);
        this.userOutput = this._dimSummary.userOutput;
    };
    /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   */ SeriesData.prototype.appendData = function(data) {
        var range = this._store.appendData(data);
        this._doInit(range[0], range[1]);
    };
    /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   * This method does not modify `rawData` (`dataProvider`), but only
   * add values to store.
   *
   * The final count will be increased by `Math.max(values.length, names.length)`.
   *
   * @param values That is the SourceType: 'arrayRows', like
   *        [
   *            [12, 33, 44],
   *            [NaN, 43, 1],
   *            ['-', 'asdf', 0]
   *        ]
   *        Each item is exactly corresponding to a dimension.
   */ SeriesData.prototype.appendValues = function(values, names) {
        var _a = this._store.appendValues(values, names && names.length), start = _a.start, end = _a.end;
        var shouldMakeIdFromName = this._shouldMakeIdFromName();
        this._updateOrdinalMeta();
        if (names) for(var idx = start; idx < end; idx++){
            var sourceIdx = idx - start;
            this._nameList[idx] = names[sourceIdx];
            if (shouldMakeIdFromName) $0ab0556b819346fd$var$makeIdFromName(this, idx);
        }
    };
    SeriesData.prototype._updateOrdinalMeta = function() {
        var store = this._store;
        var dimensions = this.dimensions;
        for(var i = 0; i < dimensions.length; i++){
            var dimInfo = this._dimInfos[dimensions[i]];
            if (dimInfo.ordinalMeta) store.collectOrdinalMeta(dimInfo.storeDimIndex, dimInfo.ordinalMeta);
        }
    };
    SeriesData.prototype._shouldMakeIdFromName = function() {
        var provider = this._store.getProvider();
        return this._idDimIdx == null && provider.getSource().sourceFormat !== (0, $cab29724515ce2b8$export$a918cb016a382d45) && !provider.fillStorage;
    };
    SeriesData.prototype._doInit = function(start, end) {
        if (start >= end) return;
        var store = this._store;
        var provider = store.getProvider();
        this._updateOrdinalMeta();
        var nameList = this._nameList;
        var idList = this._idList;
        var sourceFormat = provider.getSource().sourceFormat;
        var isFormatOriginal = sourceFormat === (0, $cab29724515ce2b8$export$2823037fb9d8f0c6);
        // Each data item is value
        // [1, 2]
        // 2
        // Bar chart, line chart which uses category axis
        // only gives the 'y' value. 'x' value is the indices of category
        // Use a tempValue to normalize the value to be a (x, y) value
        // If dataItem is {name: ...} or {id: ...}, it has highest priority.
        // This kind of ids and names are always stored `_nameList` and `_idList`.
        if (isFormatOriginal && !provider.pure) {
            var sharedDataItem = [];
            for(var idx = start; idx < end; idx++){
                // NOTICE: Try not to write things into dataItem
                var dataItem = provider.getItem(idx, sharedDataItem);
                if (!this.hasItemOption && (0, $76d619f648247e6d$export$3e1a543f33ef6883)(dataItem)) this.hasItemOption = true;
                if (dataItem) {
                    var itemName = dataItem.name;
                    if (nameList[idx] == null && itemName != null) nameList[idx] = (0, $76d619f648247e6d$export$fb1a222ba5dd6e51)(itemName, null);
                    var itemId = dataItem.id;
                    if (idList[idx] == null && itemId != null) idList[idx] = (0, $76d619f648247e6d$export$fb1a222ba5dd6e51)(itemId, null);
                }
            }
        }
        if (this._shouldMakeIdFromName()) for(var idx = start; idx < end; idx++)$0ab0556b819346fd$var$makeIdFromName(this, idx);
        $0ab0556b819346fd$var$prepareInvertedIndex(this);
    };
    /**
   * PENDING: In fact currently this function is only used to short-circuit
   * the calling of `scale.unionExtentFromData` when data have been filtered by modules
   * like "dataZoom". `scale.unionExtentFromData` is used to calculate data extent for series on
   * an axis, but if a "axis related data filter module" is used, the extent of the axis have
   * been fixed and no need to calling `scale.unionExtentFromData` actually.
   * But if we add "custom data filter" in future, which is not "axis related", this method may
   * be still needed.
   *
   * Optimize for the scenario that data is filtered by a given extent.
   * Consider that if data amount is more than hundreds of thousand,
   * extent calculation will cost more than 10ms and the cache will
   * be erased because of the filtering.
   */ SeriesData.prototype.getApproximateExtent = function(dim) {
        return this._approximateExtent[dim] || this._store.getDataExtent(this._getStoreDimIndex(dim));
    };
    /**
   * Calculate extent on a filtered data might be time consuming.
   * Approximate extent is only used for: calculate extent of filtered data outside.
   */ SeriesData.prototype.setApproximateExtent = function(extent, dim) {
        dim = this.getDimension(dim);
        this._approximateExtent[dim] = extent.slice();
    };
    SeriesData.prototype.getCalculationInfo = function(key) {
        return this._calculationInfo[key];
    };
    SeriesData.prototype.setCalculationInfo = function(key, value) {
        $0ab0556b819346fd$var$isObject(key) ? $7a1bd9c2710fea0d$export$8b58be045bf06082(this._calculationInfo, key) : this._calculationInfo[key] = value;
    };
    /**
   * @return Never be null/undefined. `number` will be converted to string. Because:
   * In most cases, name is used in display, where returning a string is more convenient.
   * In other cases, name is used in query (see `indexOfName`), where we can keep the
   * rule that name `2` equals to name `'2'`.
   */ SeriesData.prototype.getName = function(idx) {
        var rawIndex = this.getRawIndex(idx);
        var name = this._nameList[rawIndex];
        if (name == null && this._nameDimIdx != null) name = $0ab0556b819346fd$var$getIdNameFromStore(this, this._nameDimIdx, rawIndex);
        if (name == null) name = '';
        return name;
    };
    SeriesData.prototype._getCategory = function(dimIdx, idx) {
        var ordinal = this._store.get(dimIdx, idx);
        var ordinalMeta = this._store.getOrdinalMeta(dimIdx);
        if (ordinalMeta) return ordinalMeta.categories[ordinal];
        return ordinal;
    };
    /**
   * @return Never null/undefined. `number` will be converted to string. Because:
   * In all cases having encountered at present, id is used in making diff comparison, which
   * are usually based on hash map. We can keep the rule that the internal id are always string
   * (treat `2` is the same as `'2'`) to make the related logic simple.
   */ SeriesData.prototype.getId = function(idx) {
        return $0ab0556b819346fd$var$getId(this, this.getRawIndex(idx));
    };
    SeriesData.prototype.count = function() {
        return this._store.count();
    };
    /**
   * Get value. Return NaN if idx is out of range.
   *
   * @notice Should better to use `data.getStore().get(dimIndex, dataIdx)` instead.
   */ SeriesData.prototype.get = function(dim, idx) {
        var store = this._store;
        var dimInfo = this._dimInfos[dim];
        if (dimInfo) return store.get(dimInfo.storeDimIndex, idx);
    };
    /**
   * @notice Should better to use `data.getStore().getByRawIndex(dimIndex, dataIdx)` instead.
   */ SeriesData.prototype.getByRawIndex = function(dim, rawIdx) {
        var store = this._store;
        var dimInfo = this._dimInfos[dim];
        if (dimInfo) return store.getByRawIndex(dimInfo.storeDimIndex, rawIdx);
    };
    SeriesData.prototype.getIndices = function() {
        return this._store.getIndices();
    };
    SeriesData.prototype.getDataExtent = function(dim) {
        return this._store.getDataExtent(this._getStoreDimIndex(dim));
    };
    SeriesData.prototype.getSum = function(dim) {
        return this._store.getSum(this._getStoreDimIndex(dim));
    };
    SeriesData.prototype.getMedian = function(dim) {
        return this._store.getMedian(this._getStoreDimIndex(dim));
    };
    SeriesData.prototype.getValues = function(dimensions, idx) {
        var _this = this;
        var store = this._store;
        return $7a1bd9c2710fea0d$export$43bee75e5e14138e(dimensions) ? store.getValues($0ab0556b819346fd$var$map(dimensions, function(dim) {
            return _this._getStoreDimIndex(dim);
        }), idx) : store.getValues(dimensions);
    };
    /**
   * If value is NaN. Including '-'
   * Only check the coord dimensions.
   */ SeriesData.prototype.hasValue = function(idx) {
        var dataDimIndicesOnCoord = this._dimSummary.dataDimIndicesOnCoord;
        for(var i = 0, len = dataDimIndicesOnCoord.length; i < len; i++){
            // Ordinal type originally can be string or number.
            // But when an ordinal type is used on coord, it can
            // not be string but only number. So we can also use isNaN.
            if (isNaN(this._store.get(dataDimIndicesOnCoord[i], idx))) return false;
        }
        return true;
    };
    /**
   * Retrieve the index with given name
   */ SeriesData.prototype.indexOfName = function(name) {
        for(var i = 0, len = this._store.count(); i < len; i++){
            if (this.getName(i) === name) return i;
        }
        return -1;
    };
    SeriesData.prototype.getRawIndex = function(idx) {
        return this._store.getRawIndex(idx);
    };
    SeriesData.prototype.indexOfRawIndex = function(rawIndex) {
        return this._store.indexOfRawIndex(rawIndex);
    };
    /**
   * Only support the dimension which inverted index created.
   * Do not support other cases until required.
   * @param dim concrete dim
   * @param value ordinal index
   * @return rawIndex
   */ SeriesData.prototype.rawIndexOf = function(dim, value) {
        var invertedIndices = dim && this._invertedIndicesMap[dim];
        var rawIndex = invertedIndices && invertedIndices[value];
        if (rawIndex == null || isNaN(rawIndex)) return $0ab0556b819346fd$var$INDEX_NOT_FOUND;
        return rawIndex;
    };
    /**
   * Retrieve the index of nearest value
   * @param dim
   * @param value
   * @param [maxDistance=Infinity]
   * @return If and only if multiple indices has
   *         the same value, they are put to the result.
   */ SeriesData.prototype.indicesOfNearest = function(dim, value, maxDistance) {
        return this._store.indicesOfNearest(this._getStoreDimIndex(dim), value, maxDistance);
    };
    SeriesData.prototype.each = function(dims, cb, ctx) {
        'use strict';
        if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(dims)) {
            ctx = cb;
            cb = dims;
            dims = [];
        }
        // ctxCompat just for compat echarts3
        var fCtx = ctx || this;
        var dimIndices = $0ab0556b819346fd$var$map($0ab0556b819346fd$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        this._store.each(dimIndices, fCtx ? $7a1bd9c2710fea0d$export$2385a24977818dd0(cb, fCtx) : cb);
    };
    SeriesData.prototype.filterSelf = function(dims, cb, ctx) {
        'use strict';
        if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(dims)) {
            ctx = cb;
            cb = dims;
            dims = [];
        }
        // ctxCompat just for compat echarts3
        var fCtx = ctx || this;
        var dimIndices = $0ab0556b819346fd$var$map($0ab0556b819346fd$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        this._store = this._store.filter(dimIndices, fCtx ? $7a1bd9c2710fea0d$export$2385a24977818dd0(cb, fCtx) : cb);
        return this;
    };
    /**
   * Select data in range. (For optimization of filter)
   * (Manually inline code, support 5 million data filtering in data zoom.)
   */ SeriesData.prototype.selectRange = function(range) {
        'use strict';
        var _this = this;
        var innerRange = {};
        var dims = $7a1bd9c2710fea0d$export$ed97f33186d4b816(range);
        var dimIndices = [];
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(dims, function(dim) {
            var dimIdx = _this._getStoreDimIndex(dim);
            innerRange[dimIdx] = range[dim];
            dimIndices.push(dimIdx);
        });
        this._store = this._store.selectRange(innerRange);
        return this;
    };
    /* eslint-enable max-len */ SeriesData.prototype.mapArray = function(dims, cb, ctx) {
        'use strict';
        if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(dims)) {
            ctx = cb;
            cb = dims;
            dims = [];
        }
        // ctxCompat just for compat echarts3
        ctx = ctx || this;
        var result = [];
        this.each(dims, function() {
            result.push(cb && cb.apply(this, arguments));
        }, ctx);
        return result;
    };
    SeriesData.prototype.map = function(dims, cb, ctx, ctxCompat) {
        'use strict';
        // ctxCompat just for compat echarts3
        var fCtx = ctx || ctxCompat || this;
        var dimIndices = $0ab0556b819346fd$var$map($0ab0556b819346fd$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        var list = $0ab0556b819346fd$var$cloneListForMapAndSample(this);
        list._store = this._store.map(dimIndices, fCtx ? $7a1bd9c2710fea0d$export$2385a24977818dd0(cb, fCtx) : cb);
        return list;
    };
    SeriesData.prototype.modify = function(dims, cb, ctx, ctxCompat) {
        var _this = this;
        // ctxCompat just for compat echarts3
        var fCtx = ctx || ctxCompat || this;
        var dimIndices = $0ab0556b819346fd$var$map($0ab0556b819346fd$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        // If do shallow clone here, if there are too many stacked series,
        // it still cost lots of memory, because `_store.dimensions` are not shared.
        // We should consider there probably be shallow clone happen in each series
        // in consequent filter/map.
        this._store.modify(dimIndices, fCtx ? $7a1bd9c2710fea0d$export$2385a24977818dd0(cb, fCtx) : cb);
    };
    /**
   * Large data down sampling on given dimension
   * @param sampleIndex Sample index for name and id
   */ SeriesData.prototype.downSample = function(dimension, rate, sampleValue, sampleIndex) {
        var list = $0ab0556b819346fd$var$cloneListForMapAndSample(this);
        list._store = this._store.downSample(this._getStoreDimIndex(dimension), rate, sampleValue, sampleIndex);
        return list;
    };
    /**
   * Large data down sampling using min-max
   * @param {string} valueDimension
   * @param {number} rate
   */ SeriesData.prototype.minmaxDownSample = function(valueDimension, rate) {
        var list = $0ab0556b819346fd$var$cloneListForMapAndSample(this);
        list._store = this._store.minmaxDownSample(this._getStoreDimIndex(valueDimension), rate);
        return list;
    };
    /**
   * Large data down sampling using largest-triangle-three-buckets
   * @param {string} valueDimension
   * @param {number} targetCount
   */ SeriesData.prototype.lttbDownSample = function(valueDimension, rate) {
        var list = $0ab0556b819346fd$var$cloneListForMapAndSample(this);
        list._store = this._store.lttbDownSample(this._getStoreDimIndex(valueDimension), rate);
        return list;
    };
    SeriesData.prototype.getRawDataItem = function(idx) {
        return this._store.getRawDataItem(idx);
    };
    /**
   * Get model of one data item.
   */ // TODO: Type of data item
    SeriesData.prototype.getItemModel = function(idx) {
        var hostModel = this.hostModel;
        var dataItem = this.getRawDataItem(idx);
        return new (0, $6818646a97528290$export$2e2bcd8739ae039)(dataItem, hostModel, hostModel && hostModel.ecModel);
    };
    /**
   * Create a data differ
   */ SeriesData.prototype.diff = function(otherList) {
        var thisList = this;
        return new (0, $306d1c87baff8a10$export$2e2bcd8739ae039)(otherList ? otherList.getStore().getIndices() : [], this.getStore().getIndices(), function(idx) {
            return $0ab0556b819346fd$var$getId(otherList, idx);
        }, function(idx) {
            return $0ab0556b819346fd$var$getId(thisList, idx);
        });
    };
    /**
   * Get visual property.
   */ SeriesData.prototype.getVisual = function(key) {
        var visual = this._visual;
        return visual && visual[key];
    };
    SeriesData.prototype.setVisual = function(kvObj, val) {
        this._visual = this._visual || {};
        if ($0ab0556b819346fd$var$isObject(kvObj)) $7a1bd9c2710fea0d$export$8b58be045bf06082(this._visual, kvObj);
        else this._visual[kvObj] = val;
    };
    /**
   * Get visual property of single data item
   */ // eslint-disable-next-line
    SeriesData.prototype.getItemVisual = function(idx, key) {
        var itemVisual = this._itemVisuals[idx];
        var val = itemVisual && itemVisual[key];
        if (val == null) // Use global visual property
        return this.getVisual(key);
        return val;
    };
    /**
   * If exists visual property of single data item
   */ SeriesData.prototype.hasItemVisual = function() {
        return this._itemVisuals.length > 0;
    };
    /**
   * Make sure itemVisual property is unique
   */ // TODO: use key to save visual to reduce memory.
    SeriesData.prototype.ensureUniqueItemVisual = function(idx, key) {
        var itemVisuals = this._itemVisuals;
        var itemVisual = itemVisuals[idx];
        if (!itemVisual) itemVisual = itemVisuals[idx] = {};
        var val = itemVisual[key];
        if (val == null) {
            val = this.getVisual(key);
            // TODO Performance?
            if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(val)) val = val.slice();
            else if ($0ab0556b819346fd$var$isObject(val)) val = $7a1bd9c2710fea0d$export$8b58be045bf06082({}, val);
            itemVisual[key] = val;
        }
        return val;
    };
    // eslint-disable-next-line
    SeriesData.prototype.setItemVisual = function(idx, key, value) {
        var itemVisual = this._itemVisuals[idx] || {};
        this._itemVisuals[idx] = itemVisual;
        if ($0ab0556b819346fd$var$isObject(key)) $7a1bd9c2710fea0d$export$8b58be045bf06082(itemVisual, key);
        else itemVisual[key] = value;
    };
    /**
   * Clear itemVisuals and list visual.
   */ SeriesData.prototype.clearAllVisual = function() {
        this._visual = {};
        this._itemVisuals = [];
    };
    SeriesData.prototype.setLayout = function(key, val) {
        $0ab0556b819346fd$var$isObject(key) ? $7a1bd9c2710fea0d$export$8b58be045bf06082(this._layout, key) : this._layout[key] = val;
    };
    /**
   * Get layout property.
   */ SeriesData.prototype.getLayout = function(key) {
        return this._layout[key];
    };
    /**
   * Get layout of single data item
   */ SeriesData.prototype.getItemLayout = function(idx) {
        return this._itemLayouts[idx];
    };
    /**
   * Set layout of single data item
   */ SeriesData.prototype.setItemLayout = function(idx, layout, merge) {
        this._itemLayouts[idx] = merge ? $7a1bd9c2710fea0d$export$8b58be045bf06082(this._itemLayouts[idx] || {}, layout) : layout;
    };
    /**
   * Clear all layout of single data item
   */ SeriesData.prototype.clearItemLayouts = function() {
        this._itemLayouts.length = 0;
    };
    /**
   * Set graphic element relative to data. It can be set as null
   */ SeriesData.prototype.setItemGraphicEl = function(idx, el) {
        var seriesIndex = this.hostModel && this.hostModel.seriesIndex;
        (0, $b1983a2fffd47d56$export$30d6736ebb8e18d5)(seriesIndex, this.dataType, idx, el);
        this._graphicEls[idx] = el;
    };
    SeriesData.prototype.getItemGraphicEl = function(idx) {
        return this._graphicEls[idx];
    };
    SeriesData.prototype.eachItemGraphicEl = function(cb, context) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(this._graphicEls, function(el, idx) {
            if (el) cb && cb.call(context, el, idx);
        });
    };
    /**
   * Shallow clone a new list except visual and layout properties, and graph elements.
   * New list only change the indices.
   */ SeriesData.prototype.cloneShallow = function(list) {
        if (!list) list = new SeriesData(this._schema ? this._schema : $0ab0556b819346fd$var$map(this.dimensions, this._getDimInfo, this), this.hostModel);
        $0ab0556b819346fd$var$transferProperties(list, this);
        list._store = this._store;
        return list;
    };
    /**
   * Wrap some method to add more feature
   */ SeriesData.prototype.wrapMethod = function(methodName, injectFunction) {
        var originalMethod = this[methodName];
        if (!$7a1bd9c2710fea0d$export$f6e2535fb5126e54(originalMethod)) return;
        this.__wrappedMethods = this.__wrappedMethods || [];
        this.__wrappedMethods.push(methodName);
        this[methodName] = function() {
            var res = originalMethod.apply(this, arguments);
            return injectFunction.apply(this, [
                res
            ].concat($7a1bd9c2710fea0d$export$58adb3bec8346d0f(arguments)));
        };
    };
    // ----------------------------------------------------------
    // A work around for internal method visiting private member.
    // ----------------------------------------------------------
    SeriesData.internalField = function() {
        $0ab0556b819346fd$var$prepareInvertedIndex = function(data) {
            var invertedIndicesMap = data._invertedIndicesMap;
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(invertedIndicesMap, function(invertedIndices, dim) {
                var dimInfo = data._dimInfos[dim];
                // Currently, only dimensions that has ordinalMeta can create inverted indices.
                var ordinalMeta = dimInfo.ordinalMeta;
                var store = data._store;
                if (ordinalMeta) {
                    invertedIndices = invertedIndicesMap[dim] = new $0ab0556b819346fd$var$CtorInt32Array(ordinalMeta.categories.length);
                    // The default value of TypedArray is 0. To avoid miss
                    // mapping to 0, we should set it as INDEX_NOT_FOUND.
                    for(var i = 0; i < invertedIndices.length; i++)invertedIndices[i] = $0ab0556b819346fd$var$INDEX_NOT_FOUND;
                    for(var i = 0; i < store.count(); i++)// Only support the case that all values are distinct.
                    invertedIndices[store.get(dimInfo.storeDimIndex, i)] = i;
                }
            });
        };
        $0ab0556b819346fd$var$getIdNameFromStore = function(data, dimIdx, idx) {
            return (0, $76d619f648247e6d$export$fb1a222ba5dd6e51)(data._getCategory(dimIdx, idx), null);
        };
        /**
     * @see the comment of `List['getId']`.
     */ $0ab0556b819346fd$var$getId = function(data, rawIndex) {
            var id = data._idList[rawIndex];
            if (id == null && data._idDimIdx != null) id = $0ab0556b819346fd$var$getIdNameFromStore(data, data._idDimIdx, rawIndex);
            if (id == null) id = $0ab0556b819346fd$var$ID_PREFIX + rawIndex;
            return id;
        };
        $0ab0556b819346fd$var$normalizeDimensions = function(dimensions) {
            if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(dimensions)) dimensions = dimensions != null ? [
                dimensions
            ] : [];
            return dimensions;
        };
        /**
     * Data in excludeDimensions is copied, otherwise transferred.
     */ $0ab0556b819346fd$var$cloneListForMapAndSample = function(original) {
            var list = new SeriesData(original._schema ? original._schema : $0ab0556b819346fd$var$map(original.dimensions, original._getDimInfo, original), original.hostModel);
            // FIXME If needs stackedOn, value may already been stacked
            $0ab0556b819346fd$var$transferProperties(list, original);
            return list;
        };
        $0ab0556b819346fd$var$transferProperties = function(target, source) {
            $7a1bd9c2710fea0d$export$79b2f7037acddd43($0ab0556b819346fd$var$TRANSFERABLE_PROPERTIES.concat(source.__wrappedMethods || []), function(propName) {
                if (source.hasOwnProperty(propName)) target[propName] = source[propName];
            });
            target.__wrappedMethods = source.__wrappedMethods;
            $7a1bd9c2710fea0d$export$79b2f7037acddd43($0ab0556b819346fd$var$CLONE_PROPERTIES, function(propName) {
                target[propName] = $7a1bd9c2710fea0d$export$9cd59f9826255e47(source[propName]);
            });
            target._calculationInfo = $7a1bd9c2710fea0d$export$8b58be045bf06082({}, source._calculationInfo);
        };
        $0ab0556b819346fd$var$makeIdFromName = function(data, idx) {
            var nameList = data._nameList;
            var idList = data._idList;
            var nameDimIdx = data._nameDimIdx;
            var idDimIdx = data._idDimIdx;
            var name = nameList[idx];
            var id = idList[idx];
            if (name == null && nameDimIdx != null) nameList[idx] = name = $0ab0556b819346fd$var$getIdNameFromStore(data, nameDimIdx, idx);
            if (id == null && idDimIdx != null) idList[idx] = id = $0ab0556b819346fd$var$getIdNameFromStore(data, idDimIdx, idx);
            if (id == null && name != null) {
                var nameRepeatCount = data._nameRepeatCount;
                var nmCnt = nameRepeatCount[name] = (nameRepeatCount[name] || 0) + 1;
                id = name;
                if (nmCnt > 1) id += '__ec__' + nmCnt;
                idList[idx] = id;
            }
        };
    }();
    return SeriesData;
}();
var $0ab0556b819346fd$export$2e2bcd8739ae039 = $0ab0556b819346fd$var$SeriesData;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







function $a27631012b7b377c$export$8066c1b52b2e9504(source, opt) {
    return $a27631012b7b377c$export$2e2bcd8739ae039(source, opt).dimensions;
}
function $a27631012b7b377c$export$2e2bcd8739ae039(// TODO: TYPE completeDimensions type
source, opt) {
    if (!(0, $99e22f5c2aa5094b$export$22b808bc02a60488)(source)) source = (0, $99e22f5c2aa5094b$export$75aef3f97c0a5edf)(source);
    opt = opt || {};
    var sysDims = opt.coordDimensions || [];
    var dimsDef = opt.dimensionsDefine || source.dimensionsDefine || [];
    var coordDimNameMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    var resultList = [];
    var dimCount = $a27631012b7b377c$var$getDimCount(source, sysDims, dimsDef, opt.dimensionsCount);
    // Try to ignore unused dimensions if sharing a high dimension datastore
    // 30 is an experience value.
    var omitUnusedDimensions = opt.canOmitUnusedDimensions && (0, $85b723b311a86ffc$export$238b87930d825d87)(dimCount);
    var isUsingSourceDimensionsDef = dimsDef === source.dimensionsDefine;
    var dataDimNameMap = isUsingSourceDimensionsDef ? (0, $85b723b311a86ffc$export$be39ae17310c33f7)(source) : (0, $85b723b311a86ffc$export$a477f5bebfd07944)(dimsDef);
    var encodeDef = opt.encodeDefine;
    if (!encodeDef && opt.encodeDefaulter) encodeDef = opt.encodeDefaulter(source, dimCount);
    var encodeDefMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)(encodeDef);
    var indicesMap = new (0, $370e5aa482d8420b$export$b60d945128546f53)(dimCount);
    for(var i = 0; i < indicesMap.length; i++)indicesMap[i] = -1;
    function getResultItem(dimIdx) {
        var idx = indicesMap[dimIdx];
        if (idx < 0) {
            var dimDefItemRaw = dimsDef[dimIdx];
            var dimDefItem = (0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(dimDefItemRaw) ? dimDefItemRaw : {
                name: dimDefItemRaw
            };
            var resultItem = new (0, $5e233867ea3713e7$export$2e2bcd8739ae039)();
            var userDimName = dimDefItem.name;
            if (userDimName != null && dataDimNameMap.get(userDimName) != null) // Only if `series.dimensions` is defined in option
            // displayName, will be set, and dimension will be displayed vertically in
            // tooltip by default.
            resultItem.name = resultItem.displayName = userDimName;
            dimDefItem.type != null && (resultItem.type = dimDefItem.type);
            dimDefItem.displayName != null && (resultItem.displayName = dimDefItem.displayName);
            var newIdx = resultList.length;
            indicesMap[dimIdx] = newIdx;
            resultItem.storeDimIndex = dimIdx;
            resultList.push(resultItem);
            return resultItem;
        }
        return resultList[idx];
    }
    if (!omitUnusedDimensions) for(var i = 0; i < dimCount; i++)getResultItem(i);
    // Set `coordDim` and `coordDimIndex` by `encodeDefMap` and normalize `encodeDefMap`.
    encodeDefMap.each(function(dataDimsRaw, coordDim) {
        var dataDims = (0, $76d619f648247e6d$export$4f07b212a02c8051)(dataDimsRaw).slice();
        // Note: It is allowed that `dataDims.length` is `0`, e.g., options is
        // `{encode: {x: -1, y: 1}}`. Should not filter anything in
        // this case.
        if (dataDims.length === 1 && !(0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(dataDims[0]) && dataDims[0] < 0) {
            encodeDefMap.set(coordDim, false);
            return;
        }
        var validDataDims = encodeDefMap.set(coordDim, []);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dataDims, function(resultDimIdxOrName, idx) {
            // The input resultDimIdx can be dim name or index.
            var resultDimIdx = (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(resultDimIdxOrName) ? dataDimNameMap.get(resultDimIdxOrName) : resultDimIdxOrName;
            if (resultDimIdx != null && resultDimIdx < dimCount) {
                validDataDims[idx] = resultDimIdx;
                applyDim(getResultItem(resultDimIdx), coordDim, idx);
            }
        });
    });
    // Apply templates and default order from `sysDims`.
    var availDimIdx = 0;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(sysDims, function(sysDimItemRaw) {
        var coordDim;
        var sysDimItemDimsDef;
        var sysDimItemOtherDims;
        var sysDimItem;
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(sysDimItemRaw)) {
            coordDim = sysDimItemRaw;
            sysDimItem = {};
        } else {
            sysDimItem = sysDimItemRaw;
            coordDim = sysDimItem.name;
            var ordinalMeta = sysDimItem.ordinalMeta;
            sysDimItem.ordinalMeta = null;
            sysDimItem = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, sysDimItem);
            sysDimItem.ordinalMeta = ordinalMeta;
            // `coordDimIndex` should not be set directly.
            sysDimItemDimsDef = sysDimItem.dimsDef;
            sysDimItemOtherDims = sysDimItem.otherDims;
            sysDimItem.name = sysDimItem.coordDim = sysDimItem.coordDimIndex = sysDimItem.dimsDef = sysDimItem.otherDims = null;
        }
        var dataDims = encodeDefMap.get(coordDim);
        // negative resultDimIdx means no need to mapping.
        if (dataDims === false) return;
        dataDims = (0, $76d619f648247e6d$export$4f07b212a02c8051)(dataDims);
        // dimensions provides default dim sequences.
        if (!dataDims.length) for(var i = 0; i < (sysDimItemDimsDef && sysDimItemDimsDef.length || 1); i++){
            while(availDimIdx < dimCount && getResultItem(availDimIdx).coordDim != null)availDimIdx++;
            availDimIdx < dimCount && dataDims.push(availDimIdx++);
        }
        // Apply templates.
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dataDims, function(resultDimIdx, coordDimIndex) {
            var resultItem = getResultItem(resultDimIdx);
            // Coordinate system has a higher priority on dim type than source.
            if (isUsingSourceDimensionsDef && sysDimItem.type != null) resultItem.type = sysDimItem.type;
            applyDim((0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(resultItem, sysDimItem), coordDim, coordDimIndex);
            if (resultItem.name == null && sysDimItemDimsDef) {
                var sysDimItemDimsDefItem = sysDimItemDimsDef[coordDimIndex];
                !(0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(sysDimItemDimsDefItem) && (sysDimItemDimsDefItem = {
                    name: sysDimItemDimsDefItem
                });
                resultItem.name = resultItem.displayName = sysDimItemDimsDefItem.name;
                resultItem.defaultTooltip = sysDimItemDimsDefItem.defaultTooltip;
            }
            // FIXME refactor, currently only used in case: {otherDims: {tooltip: false}}
            sysDimItemOtherDims && (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(resultItem.otherDims, sysDimItemOtherDims);
        });
    });
    function applyDim(resultItem, coordDim, coordDimIndex) {
        if ((0, $cab29724515ce2b8$export$cd51b5ca77f6f0e4).get(coordDim) != null) resultItem.otherDims[coordDim] = coordDimIndex;
        else {
            resultItem.coordDim = coordDim;
            resultItem.coordDimIndex = coordDimIndex;
            coordDimNameMap.set(coordDim, true);
        }
    }
    // Make sure the first extra dim is 'value'.
    var generateCoord = opt.generateCoord;
    var generateCoordCount = opt.generateCoordCount;
    var fromZero = generateCoordCount != null;
    generateCoordCount = generateCoord ? generateCoordCount || 1 : 0;
    var extra = generateCoord || 'value';
    function ifNoNameFillWithCoordName(resultItem) {
        if (resultItem.name == null) // Duplication will be removed in the next step.
        resultItem.name = resultItem.coordDim;
    }
    // Set dim `name` and other `coordDim` and other props.
    if (!omitUnusedDimensions) for(var resultDimIdx = 0; resultDimIdx < dimCount; resultDimIdx++){
        var resultItem = getResultItem(resultDimIdx);
        var coordDim = resultItem.coordDim;
        if (coordDim == null) {
            // TODO no need to generate coordDim for isExtraCoord?
            resultItem.coordDim = $a27631012b7b377c$var$genCoordDimName(extra, coordDimNameMap, fromZero);
            resultItem.coordDimIndex = 0;
            // Series specified generateCoord is using out.
            if (!generateCoord || generateCoordCount <= 0) resultItem.isExtraCoord = true;
            generateCoordCount--;
        }
        ifNoNameFillWithCoordName(resultItem);
        if (resultItem.type == null && ((0, $7dc6cdfd7450ef29$export$c51adf1a2be01b9c)(source, resultDimIdx) === (0, $7dc6cdfd7450ef29$export$328749e9c5b40760).Must || resultItem.isExtraCoord && (resultItem.otherDims.itemName != null || resultItem.otherDims.seriesName != null))) resultItem.type = 'ordinal';
    }
    else {
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(resultList, function(resultItem) {
            // PENDING: guessOrdinal or let user specify type: 'ordinal' manually?
            ifNoNameFillWithCoordName(resultItem);
        });
        // Sort dimensions: there are some rule that use the last dim as label,
        // and for some latter travel process easier.
        resultList.sort(function(item0, item1) {
            return item0.storeDimIndex - item1.storeDimIndex;
        });
    }
    $a27631012b7b377c$var$removeDuplication(resultList);
    return new (0, $85b723b311a86ffc$export$a1ef064685775f3e)({
        source: source,
        dimensions: resultList,
        fullDimensionCount: dimCount,
        dimensionOmitted: omitUnusedDimensions
    });
}
function $a27631012b7b377c$var$removeDuplication(result) {
    var duplicationMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    for(var i = 0; i < result.length; i++){
        var dim = result[i];
        var dimOriginalName = dim.name;
        var count = duplicationMap.get(dimOriginalName) || 0;
        if (count > 0) // Starts from 0.
        dim.name = dimOriginalName + (count - 1);
        count++;
        duplicationMap.set(dimOriginalName, count);
    }
}
// ??? TODO
// Originally detect dimCount by data[0]. Should we
// optimize it to only by sysDims and dimensions and encode.
// So only necessary dims will be initialized.
// But
// (1) custom series should be considered. where other dims
// may be visited.
// (2) sometimes user need to calculate bubble size or use visualMap
// on other dimensions besides coordSys needed.
// So, dims that is not used by system, should be shared in data store?
function $a27631012b7b377c$var$getDimCount(source, sysDims, dimsDef, optDimCount) {
    // Note that the result dimCount should not small than columns count
    // of data, otherwise `dataDimNameMap` checking will be incorrect.
    var dimCount = Math.max(source.dimensionsDetectedCount || 1, sysDims.length, dimsDef.length, optDimCount || 0);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(sysDims, function(sysDimItem) {
        var sysDimItemDimsDef;
        if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(sysDimItem) && (sysDimItemDimsDef = sysDimItem.dimsDef)) dimCount = Math.max(dimCount, sysDimItemDimsDef.length);
    });
    return dimCount;
}
function $a27631012b7b377c$var$genCoordDimName(name, map, fromZero) {
    if (fromZero || map.hasKey(name)) {
        var i = 0;
        while(map.hasKey(name + i))i++;
        name += i;
    }
    map.set(name, true);
    return name;
}





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Helper for model references.
 * There are many manners to refer axis/coordSys.
 */ // TODO
// merge relevant logic to this file?
// check: "modelHelper" of tooltip and "BrushTargetManager".


/**
 * @class
 * For example:
 * {
 *     coordSysName: 'cartesian2d',
 *     coordSysDims: ['x', 'y', ...],
 *     axisMap: HashMap({
 *         x: xAxisModel,
 *         y: yAxisModel
 *     }),
 *     categoryAxisMap: HashMap({
 *         x: xAxisModel,
 *         y: undefined
 *     }),
 *     // The index of the first category axis in `coordSysDims`.
 *     // `null/undefined` means no category axis exists.
 *     firstCategoryDimIndex: 1,
 *     // To replace user specified encode.
 * }
 */ var $a97e3a3e4c0c9c28$var$CoordSysInfo = /** @class */ function() {
    function CoordSysInfo(coordSysName) {
        this.coordSysDims = [];
        this.axisMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        this.categoryAxisMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        this.coordSysName = coordSysName;
    }
    return CoordSysInfo;
}();
function $a97e3a3e4c0c9c28$export$f2befeb2f4933656(seriesModel) {
    var coordSysName = seriesModel.get('coordinateSystem');
    var result = new $a97e3a3e4c0c9c28$var$CoordSysInfo(coordSysName);
    var fetch = $a97e3a3e4c0c9c28$var$fetchers[coordSysName];
    if (fetch) {
        fetch(seriesModel, result, result.axisMap, result.categoryAxisMap);
        return result;
    }
}
var $a97e3a3e4c0c9c28$var$fetchers = {
    cartesian2d: function(seriesModel, result, axisMap, categoryAxisMap) {
        var xAxisModel = seriesModel.getReferringComponents('xAxis', (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
        var yAxisModel = seriesModel.getReferringComponents('yAxis', (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
        result.coordSysDims = [
            'x',
            'y'
        ];
        axisMap.set('x', xAxisModel);
        axisMap.set('y', yAxisModel);
        if ($a97e3a3e4c0c9c28$var$isCategory(xAxisModel)) {
            categoryAxisMap.set('x', xAxisModel);
            result.firstCategoryDimIndex = 0;
        }
        if ($a97e3a3e4c0c9c28$var$isCategory(yAxisModel)) {
            categoryAxisMap.set('y', yAxisModel);
            result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
        }
    },
    singleAxis: function(seriesModel, result, axisMap, categoryAxisMap) {
        var singleAxisModel = seriesModel.getReferringComponents('singleAxis', (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
        result.coordSysDims = [
            'single'
        ];
        axisMap.set('single', singleAxisModel);
        if ($a97e3a3e4c0c9c28$var$isCategory(singleAxisModel)) {
            categoryAxisMap.set('single', singleAxisModel);
            result.firstCategoryDimIndex = 0;
        }
    },
    polar: function(seriesModel, result, axisMap, categoryAxisMap) {
        var polarModel = seriesModel.getReferringComponents('polar', (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
        var radiusAxisModel = polarModel.findAxisModel('radiusAxis');
        var angleAxisModel = polarModel.findAxisModel('angleAxis');
        result.coordSysDims = [
            'radius',
            'angle'
        ];
        axisMap.set('radius', radiusAxisModel);
        axisMap.set('angle', angleAxisModel);
        if ($a97e3a3e4c0c9c28$var$isCategory(radiusAxisModel)) {
            categoryAxisMap.set('radius', radiusAxisModel);
            result.firstCategoryDimIndex = 0;
        }
        if ($a97e3a3e4c0c9c28$var$isCategory(angleAxisModel)) {
            categoryAxisMap.set('angle', angleAxisModel);
            result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
        }
    },
    geo: function(seriesModel, result, axisMap, categoryAxisMap) {
        result.coordSysDims = [
            'lng',
            'lat'
        ];
    },
    parallel: function(seriesModel, result, axisMap, categoryAxisMap) {
        var ecModel = seriesModel.ecModel;
        var parallelModel = ecModel.getComponent('parallel', seriesModel.get('parallelIndex'));
        var coordSysDims = result.coordSysDims = parallelModel.dimensions.slice();
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(parallelModel.parallelAxisIndex, function(axisIndex, index) {
            var axisModel = ecModel.getComponent('parallelAxis', axisIndex);
            var axisDim = coordSysDims[index];
            axisMap.set(axisDim, axisModel);
            if ($a97e3a3e4c0c9c28$var$isCategory(axisModel)) {
                categoryAxisMap.set(axisDim, axisModel);
                if (result.firstCategoryDimIndex == null) result.firstCategoryDimIndex = index;
            }
        });
    }
};
function $a97e3a3e4c0c9c28$var$isCategory(axisModel) {
    return axisModel.get('type') === 'category';
}






function $8afdec5f59c90781$var$getCoordSysDimDefs(seriesModel, coordSysInfo) {
    var coordSysName = seriesModel.get('coordinateSystem');
    var registeredCoordSys = (0, $70c3ede7d3b64757$export$2e2bcd8739ae039).get(coordSysName);
    var coordSysDimDefs;
    if (coordSysInfo && coordSysInfo.coordSysDims) coordSysDimDefs = $7a1bd9c2710fea0d$export$871de8747c9eaa88(coordSysInfo.coordSysDims, function(dim) {
        var dimInfo = {
            name: dim
        };
        var axisModel = coordSysInfo.axisMap.get(dim);
        if (axisModel) {
            var axisType = axisModel.get('type');
            dimInfo.type = (0, $18085de91ae59d03$export$af1622903e71278e)(axisType);
        }
        return dimInfo;
    });
    if (!coordSysDimDefs) // Get dimensions from registered coordinate system
    coordSysDimDefs = registeredCoordSys && (registeredCoordSys.getDimensionsInfo ? registeredCoordSys.getDimensionsInfo() : registeredCoordSys.dimensions.slice()) || [
        'x',
        'y'
    ];
    return coordSysDimDefs;
}
function $8afdec5f59c90781$var$injectOrdinalMeta(dimInfoList, createInvertedIndices, coordSysInfo) {
    var firstCategoryDimIndex;
    var hasNameEncode;
    coordSysInfo && $7a1bd9c2710fea0d$export$79b2f7037acddd43(dimInfoList, function(dimInfo, dimIndex) {
        var coordDim = dimInfo.coordDim;
        var categoryAxisModel = coordSysInfo.categoryAxisMap.get(coordDim);
        if (categoryAxisModel) {
            if (firstCategoryDimIndex == null) firstCategoryDimIndex = dimIndex;
            dimInfo.ordinalMeta = categoryAxisModel.getOrdinalMeta();
            if (createInvertedIndices) dimInfo.createInvertedIndices = true;
        }
        if (dimInfo.otherDims.itemName != null) hasNameEncode = true;
    });
    if (!hasNameEncode && firstCategoryDimIndex != null) dimInfoList[firstCategoryDimIndex].otherDims.itemName = 0;
    return firstCategoryDimIndex;
}
/**
 * Caution: there are side effects to `sourceManager` in this method.
 * Should better only be called in `Series['getInitialData']`.
 */ function $8afdec5f59c90781$var$createSeriesData(sourceRaw, seriesModel, opt) {
    opt = opt || {};
    var sourceManager = seriesModel.getSourceManager();
    var source;
    var isOriginalSource = false;
    if (sourceRaw) {
        isOriginalSource = true;
        source = (0, $99e22f5c2aa5094b$export$75aef3f97c0a5edf)(sourceRaw);
    } else {
        source = sourceManager.getSource();
        // Is series.data. not dataset.
        isOriginalSource = source.sourceFormat === (0, $cab29724515ce2b8$export$2823037fb9d8f0c6);
    }
    var coordSysInfo = (0, $a97e3a3e4c0c9c28$export$f2befeb2f4933656)(seriesModel);
    var coordSysDimDefs = $8afdec5f59c90781$var$getCoordSysDimDefs(seriesModel, coordSysInfo);
    var useEncodeDefaulter = opt.useEncodeDefaulter;
    var encodeDefaulter = $7a1bd9c2710fea0d$export$f6e2535fb5126e54(useEncodeDefaulter) ? useEncodeDefaulter : useEncodeDefaulter ? $7a1bd9c2710fea0d$export$c3095a23b368d1f2((0, $7dc6cdfd7450ef29$export$37682b8fdd2e83d), coordSysDimDefs, seriesModel) : null;
    var createDimensionOptions = {
        coordDimensions: coordSysDimDefs,
        generateCoord: opt.generateCoord,
        encodeDefine: seriesModel.getEncode(),
        encodeDefaulter: encodeDefaulter,
        canOmitUnusedDimensions: !isOriginalSource
    };
    var schema = (0, $a27631012b7b377c$export$2e2bcd8739ae039)(source, createDimensionOptions);
    var firstCategoryDimIndex = $8afdec5f59c90781$var$injectOrdinalMeta(schema.dimensions, opt.createInvertedIndices, coordSysInfo);
    var store = !isOriginalSource ? sourceManager.getSharedDataStore(schema) : null;
    var stackCalculationInfo = (0, $efdd976e4917927c$export$f2165f9e8499b278)(seriesModel, {
        schema: schema,
        store: store
    });
    var data = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)(schema, seriesModel);
    data.setCalculationInfo(stackCalculationInfo);
    var dimValueGetter = firstCategoryDimIndex != null && $8afdec5f59c90781$var$isNeedCompleteOrdinalData(source) ? function(itemOpt, dimName, dataIndex, dimIndex) {
        // Use dataIndex as ordinal value in categoryAxis
        return dimIndex === firstCategoryDimIndex ? dataIndex : this.defaultDimValueGetter(itemOpt, dimName, dataIndex, dimIndex);
    } : null;
    data.hasItemOption = false;
    data.initData(// Try to reuse the data store in sourceManager if using dataset.
    isOriginalSource ? source : store, null, dimValueGetter);
    return data;
}
function $8afdec5f59c90781$var$isNeedCompleteOrdinalData(source) {
    if (source.sourceFormat === (0, $cab29724515ce2b8$export$2823037fb9d8f0c6)) {
        var sampleItem = $8afdec5f59c90781$var$firstDataNotNull(source.data || []);
        return !$7a1bd9c2710fea0d$export$43bee75e5e14138e((0, $76d619f648247e6d$export$2c944e12edb48d4b)(sampleItem));
    }
}
function $8afdec5f59c90781$var$firstDataNotNull(arr) {
    var i = 0;
    while(i < arr.length && arr[i] == null)i++;
    return arr[i];
}
var $8afdec5f59c90781$export$2e2bcd8739ae039 = $8afdec5f59c90781$var$createSeriesData;



var $b508252f98157abf$var$BaseBarSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(BaseBarSeriesModel, _super);
    function BaseBarSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BaseBarSeriesModel.type;
        return _this;
    }
    BaseBarSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $8afdec5f59c90781$export$2e2bcd8739ae039)(null, this, {
            useEncodeDefaulter: true
        });
    };
    BaseBarSeriesModel.prototype.getMarkerPosition = function(value, dims, startingAtTick) {
        var coordSys = this.coordinateSystem;
        if (coordSys && coordSys.clampData) {
            // PENDING if clamp ?
            var clampData_1 = coordSys.clampData(value);
            var pt_1 = coordSys.dataToPoint(clampData_1);
            if (startingAtTick) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(coordSys.getAxes(), function(axis, idx) {
                // If axis type is category, use tick coords instead
                if (axis.type === 'category' && dims != null) {
                    var tickCoords = axis.getTicksCoords();
                    var alignTicksWithLabel = axis.getTickModel().get('alignWithLabel');
                    var targetTickId = clampData_1[idx];
                    // The index of rightmost tick of markArea is 1 larger than x1/y1 index
                    var isEnd = dims[idx] === 'x1' || dims[idx] === 'y1';
                    if (isEnd && !alignTicksWithLabel) targetTickId += 1;
                    // The only contains one tick, tickCoords is
                    // like [{coord: 0, tickValue: 0}, {coord: 0}]
                    // to the length should always be larger than 1
                    if (tickCoords.length < 2) return;
                    else if (tickCoords.length === 2) {
                        // The left value and right value of the axis are
                        // the same. coord is 0 in both items. Use the max
                        // value of the axis as the coord
                        pt_1[idx] = axis.toGlobalCoord(axis.getExtent()[isEnd ? 1 : 0]);
                        return;
                    }
                    var leftCoord = void 0;
                    var coord = void 0;
                    var stepTickValue = 1;
                    for(var i = 0; i < tickCoords.length; i++){
                        var tickCoord = tickCoords[i].coord;
                        // The last item of tickCoords doesn't contain
                        // tickValue
                        var tickValue = i === tickCoords.length - 1 ? tickCoords[i - 1].tickValue + stepTickValue : tickCoords[i].tickValue;
                        if (tickValue === targetTickId) {
                            coord = tickCoord;
                            break;
                        } else if (tickValue < targetTickId) leftCoord = tickCoord;
                        else if (leftCoord != null && tickValue > targetTickId) {
                            coord = (tickCoord + leftCoord) / 2;
                            break;
                        }
                        if (i === 1) // Here we assume the step of category axes is
                        // the same
                        stepTickValue = tickValue - tickCoords[0].tickValue;
                    }
                    if (coord == null) {
                        if (!leftCoord) // targetTickId is smaller than all tick ids in the
                        // visible area, use the leftmost tick coord
                        coord = tickCoords[0].coord;
                        else if (leftCoord) // targetTickId is larger than all tick ids in the
                        // visible area, use the rightmost tick coord
                        coord = tickCoords[tickCoords.length - 1].coord;
                    }
                    pt_1[idx] = axis.toGlobalCoord(coord);
                }
            });
            else {
                var data = this.getData();
                var offset = data.getLayout('offset');
                var size = data.getLayout('size');
                var offsetIndex = coordSys.getBaseAxis().isHorizontal() ? 0 : 1;
                pt_1[offsetIndex] += offset + size / 2;
            }
            return pt_1;
        }
        return [
            NaN,
            NaN
        ];
    };
    BaseBarSeriesModel.type = 'series.__base_bar__';
    BaseBarSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        coordinateSystem: 'cartesian2d',
        legendHoverLink: true,
        // stack: null
        // Cartesian coordinate system
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        barMinHeight: 0,
        barMinAngle: 0,
        // cursor: null,
        large: false,
        largeThreshold: 400,
        progressive: 3e3,
        progressiveChunkMode: 'mod'
    };
    return BaseBarSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
(0, $7c10febb2cdef0d8$export$2e2bcd8739ae039).registerClass($b508252f98157abf$var$BaseBarSeriesModel);
var $b508252f98157abf$export$2e2bcd8739ae039 = $b508252f98157abf$var$BaseBarSeriesModel;




var $1db8e2e676cae702$var$BarSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(BarSeriesModel, _super);
    function BarSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BarSeriesModel.type;
        return _this;
    }
    BarSeriesModel.prototype.getInitialData = function() {
        return (0, $8afdec5f59c90781$export$2e2bcd8739ae039)(null, this, {
            useEncodeDefaulter: true,
            createInvertedIndices: !!this.get('realtimeSort', true) || null
        });
    };
    /**
   * @override
   */ BarSeriesModel.prototype.getProgressive = function() {
        // Do not support progressive in normal mode.
        return this.get('large') ? this.get('progressive') : false;
    };
    /**
   * @override
   */ BarSeriesModel.prototype.getProgressiveThreshold = function() {
        // Do not support progressive in normal mode.
        var progressiveThreshold = this.get('progressiveThreshold');
        var largeThreshold = this.get('largeThreshold');
        if (largeThreshold > progressiveThreshold) progressiveThreshold = largeThreshold;
        return progressiveThreshold;
    };
    BarSeriesModel.prototype.brushSelector = function(dataIndex, data, selectors) {
        return selectors.rect(data.getItemLayout(dataIndex));
    };
    BarSeriesModel.type = 'series.bar';
    BarSeriesModel.dependencies = [
        'grid',
        'polar'
    ];
    BarSeriesModel.defaultOption = (0, $5370df662b2caf37$export$68acc510e46fef2)((0, $b508252f98157abf$export$2e2bcd8739ae039).defaultOption, {
        // If clipped
        // Only available on cartesian2d
        clip: true,
        roundCap: false,
        showBackground: false,
        backgroundStyle: {
            color: 'rgba(180, 180, 180, 0.2)',
            borderColor: null,
            borderWidth: 0,
            borderType: 'solid',
            borderRadius: 0,
            shadowBlur: 0,
            shadowColor: null,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            opacity: 1
        },
        select: {
            itemStyle: {
                borderColor: '#212121'
            }
        },
        realtimeSort: false
    });
    return BarSeriesModel;
}((0, $b508252f98157abf$export$2e2bcd8739ae039));
var $1db8e2e676cae702$export$2e2bcd8739ae039 = $1db8e2e676cae702$var$BarSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 








/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $0e2cc04b3aaad400$export$83958787eb658d14(cartesian, hasAnimation, seriesModel, done, during) {
    var rect = cartesian.getArea();
    var x = rect.x;
    var y = rect.y;
    var width = rect.width;
    var height = rect.height;
    var lineWidth = seriesModel.get([
        'lineStyle',
        'width'
    ]) || 0;
    // Expand the clip path a bit to avoid the border is clipped and looks thinner
    x -= lineWidth / 2;
    y -= lineWidth / 2;
    width += lineWidth;
    height += lineWidth;
    // fix: https://github.com/apache/incubator-echarts/issues/11369
    width = Math.ceil(width);
    if (x !== Math.floor(x)) {
        x = Math.floor(x);
        // if no extra 1px on `width`, it will still be clipped since `x` is floored
        width++;
    }
    var clipPath = new $419e5ff2f303755e$export$2e2bcd8739ae039({
        shape: {
            x: x,
            y: y,
            width: width,
            height: height
        }
    });
    if (hasAnimation) {
        var baseAxis = cartesian.getBaseAxis();
        var isHorizontal = baseAxis.isHorizontal();
        var isAxisInversed = baseAxis.inverse;
        if (isHorizontal) {
            if (isAxisInversed) clipPath.shape.x += width;
            clipPath.shape.width = 0;
        } else {
            if (!isAxisInversed) clipPath.shape.y += height;
            clipPath.shape.height = 0;
        }
        var duringCb = (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(during) ? function(percent) {
            during(percent, clipPath);
        } : null;
        $8b353638fbedfefa$export$a121566aadcfe021(clipPath, {
            shape: {
                width: width,
                height: height,
                x: x,
                y: y
            }
        }, seriesModel, null, done, duringCb);
    }
    return clipPath;
}
function $0e2cc04b3aaad400$export$13dc2b2230df3cb5(polar, hasAnimation, seriesModel) {
    var sectorArea = polar.getArea();
    // Avoid float number rounding error for symbol on the edge of axis extent.
    var r0 = (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(sectorArea.r0, 1);
    var r = (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(sectorArea.r, 1);
    var clipPath = new $a3e1dec0a3875b49$export$2e2bcd8739ae039({
        shape: {
            cx: (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(polar.cx, 1),
            cy: (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(polar.cy, 1),
            r0: r0,
            r: r,
            startAngle: sectorArea.startAngle,
            endAngle: sectorArea.endAngle,
            clockwise: sectorArea.clockwise
        }
    });
    if (hasAnimation) {
        var isRadial = polar.getBaseAxis().dim === 'angle';
        if (isRadial) clipPath.shape.endAngle = sectorArea.startAngle;
        else clipPath.shape.r = r0;
        $8b353638fbedfefa$export$a121566aadcfe021(clipPath, {
            shape: {
                endAngle: sectorArea.endAngle,
                r: r
            }
        }, seriesModel);
    }
    return clipPath;
}
function $0e2cc04b3aaad400$export$e0fe5081209d01c9(coordSys, hasAnimation, seriesModel, done, during) {
    if (!coordSys) return null;
    else if (coordSys.type === 'polar') return $0e2cc04b3aaad400$export$13dc2b2230df3cb5(coordSys, hasAnimation, seriesModel);
    else if (coordSys.type === 'cartesian2d') return $0e2cc04b3aaad400$export$83958787eb658d14(coordSys, hasAnimation, seriesModel, done, during);
    return null;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/**
 * Sausage: similar to sector, but have half circle on both sides
 */ var $9674946a7a7df213$var$SausageShape = /** @class */ function() {
    function SausageShape() {
        this.cx = 0;
        this.cy = 0;
        this.r0 = 0;
        this.r = 0;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.clockwise = true;
    }
    return SausageShape;
}();
var $9674946a7a7df213$var$SausagePath = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SausagePath, _super);
    function SausagePath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'sausage';
        return _this;
    }
    SausagePath.prototype.getDefaultShape = function() {
        return new $9674946a7a7df213$var$SausageShape();
    };
    SausagePath.prototype.buildPath = function(ctx, shape) {
        var cx = shape.cx;
        var cy = shape.cy;
        var r0 = Math.max(shape.r0 || 0, 0);
        var r = Math.max(shape.r, 0);
        var dr = (r - r0) * 0.5;
        var rCenter = r0 + dr;
        var startAngle = shape.startAngle;
        var endAngle = shape.endAngle;
        var clockwise = shape.clockwise;
        var PI2 = Math.PI * 2;
        var lessThanCircle = clockwise ? endAngle - startAngle < PI2 : startAngle - endAngle < PI2;
        if (!lessThanCircle) // Normalize angles
        startAngle = endAngle - (clockwise ? PI2 : -PI2);
        var unitStartX = Math.cos(startAngle);
        var unitStartY = Math.sin(startAngle);
        var unitEndX = Math.cos(endAngle);
        var unitEndY = Math.sin(endAngle);
        if (lessThanCircle) {
            ctx.moveTo(unitStartX * r0 + cx, unitStartY * r0 + cy);
            ctx.arc(unitStartX * rCenter + cx, unitStartY * rCenter + cy, dr, -Math.PI + startAngle, startAngle, !clockwise);
        } else ctx.moveTo(unitStartX * r + cx, unitStartY * r + cy);
        ctx.arc(cx, cy, r, startAngle, endAngle, !clockwise);
        ctx.arc(unitEndX * rCenter + cx, unitEndY * rCenter + cy, dr, endAngle - Math.PI * 2, endAngle - Math.PI, !clockwise);
        if (r0 !== 0) ctx.arc(cx, cy, r0, endAngle, startAngle, clockwise);
    // ctx.closePath();
    };
    return SausagePath;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
var $9674946a7a7df213$export$2e2bcd8739ae039 = $9674946a7a7df213$var$SausagePath;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $3fea949f0512eb55$export$8567506e6336616(coordSys, type) {
    return coordSys.type === type;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $b2475f850d3c0bc2$export$5ff20667590927ed(data, dataIndex) {
    var labelDims = data.mapDimensionsAll('defaultedLabel');
    var len = labelDims.length;
    // Simple optimization (in lots of cases, label dims length is 1)
    if (len === 1) {
        var rawVal = (0, $8ffb0d67e9446edb$export$cde9373da9aad801)(data, dataIndex, labelDims[0]);
        return rawVal != null ? rawVal + '' : null;
    } else if (len) {
        var vals = [];
        for(var i = 0; i < labelDims.length; i++)vals.push((0, $8ffb0d67e9446edb$export$cde9373da9aad801)(data, dataIndex, labelDims[i]));
        return vals.join(' ');
    }
}
function $b2475f850d3c0bc2$export$5f84815e91ca6775(data, interpolatedValue) {
    var labelDims = data.mapDimensionsAll('defaultedLabel');
    if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(interpolatedValue)) return interpolatedValue + '';
    var vals = [];
    for(var i = 0; i < labelDims.length; i++){
        var dimIndex = data.getDimensionIndex(labelDims[i]);
        if (dimIndex >= 0) vals.push(interpolatedValue[dimIndex]);
    }
    return vals.join(' ');
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $5e4aaa173c31cda6$export$359a1e2d210ed734(positionMapping, opts) {
    opts = opts || {};
    var isRoundCap = opts.isRoundCap;
    return function(out, opts, boundingRect) {
        var textPosition = opts.position;
        if (!textPosition || textPosition instanceof Array) return (0, $6c308355c7107803$export$eee3603b512feab7)(out, opts, boundingRect);
        var mappedSectorPosition = positionMapping(textPosition);
        var distance = opts.distance != null ? opts.distance : 5;
        var sector = this.shape;
        var cx = sector.cx;
        var cy = sector.cy;
        var r = sector.r;
        var r0 = sector.r0;
        var middleR = (r + r0) / 2;
        var startAngle = sector.startAngle;
        var endAngle = sector.endAngle;
        var middleAngle = (startAngle + endAngle) / 2;
        var extraDist = isRoundCap ? Math.abs(r - r0) / 2 : 0;
        var mathCos = Math.cos;
        var mathSin = Math.sin;
        // base position: top-left
        var x = cx + r * mathCos(startAngle);
        var y = cy + r * mathSin(startAngle);
        var textAlign = 'left';
        var textVerticalAlign = 'top';
        switch(mappedSectorPosition){
            case 'startArc':
                x = cx + (r0 - distance) * mathCos(middleAngle);
                y = cy + (r0 - distance) * mathSin(middleAngle);
                textAlign = 'center';
                textVerticalAlign = 'top';
                break;
            case 'insideStartArc':
                x = cx + (r0 + distance) * mathCos(middleAngle);
                y = cy + (r0 + distance) * mathSin(middleAngle);
                textAlign = 'center';
                textVerticalAlign = 'bottom';
                break;
            case 'startAngle':
                x = cx + middleR * mathCos(startAngle) + $5e4aaa173c31cda6$var$adjustAngleDistanceX(startAngle, distance + extraDist, false);
                y = cy + middleR * mathSin(startAngle) + $5e4aaa173c31cda6$var$adjustAngleDistanceY(startAngle, distance + extraDist, false);
                textAlign = 'right';
                textVerticalAlign = 'middle';
                break;
            case 'insideStartAngle':
                x = cx + middleR * mathCos(startAngle) + $5e4aaa173c31cda6$var$adjustAngleDistanceX(startAngle, -distance + extraDist, false);
                y = cy + middleR * mathSin(startAngle) + $5e4aaa173c31cda6$var$adjustAngleDistanceY(startAngle, -distance + extraDist, false);
                textAlign = 'left';
                textVerticalAlign = 'middle';
                break;
            case 'middle':
                x = cx + middleR * mathCos(middleAngle);
                y = cy + middleR * mathSin(middleAngle);
                textAlign = 'center';
                textVerticalAlign = 'middle';
                break;
            case 'endArc':
                x = cx + (r + distance) * mathCos(middleAngle);
                y = cy + (r + distance) * mathSin(middleAngle);
                textAlign = 'center';
                textVerticalAlign = 'bottom';
                break;
            case 'insideEndArc':
                x = cx + (r - distance) * mathCos(middleAngle);
                y = cy + (r - distance) * mathSin(middleAngle);
                textAlign = 'center';
                textVerticalAlign = 'top';
                break;
            case 'endAngle':
                x = cx + middleR * mathCos(endAngle) + $5e4aaa173c31cda6$var$adjustAngleDistanceX(endAngle, distance + extraDist, true);
                y = cy + middleR * mathSin(endAngle) + $5e4aaa173c31cda6$var$adjustAngleDistanceY(endAngle, distance + extraDist, true);
                textAlign = 'left';
                textVerticalAlign = 'middle';
                break;
            case 'insideEndAngle':
                x = cx + middleR * mathCos(endAngle) + $5e4aaa173c31cda6$var$adjustAngleDistanceX(endAngle, -distance + extraDist, true);
                y = cy + middleR * mathSin(endAngle) + $5e4aaa173c31cda6$var$adjustAngleDistanceY(endAngle, -distance + extraDist, true);
                textAlign = 'right';
                textVerticalAlign = 'middle';
                break;
            default:
                return (0, $6c308355c7107803$export$eee3603b512feab7)(out, opts, boundingRect);
        }
        out = out || {};
        out.x = x;
        out.y = y;
        out.align = textAlign;
        out.verticalAlign = textVerticalAlign;
        return out;
    };
}
function $5e4aaa173c31cda6$export$672ce504c0db395a(sector, textPosition, positionMapping, rotateType) {
    if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(rotateType)) {
        // user-set rotation
        sector.setTextConfig({
            rotation: rotateType
        });
        return;
    } else if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(textPosition)) {
        // user-set position, use 0 as auto rotation
        sector.setTextConfig({
            rotation: 0
        });
        return;
    }
    var shape = sector.shape;
    var startAngle = shape.clockwise ? shape.startAngle : shape.endAngle;
    var endAngle = shape.clockwise ? shape.endAngle : shape.startAngle;
    var middleAngle = (startAngle + endAngle) / 2;
    var anchorAngle;
    var mappedSectorPosition = positionMapping(textPosition);
    switch(mappedSectorPosition){
        case 'startArc':
        case 'insideStartArc':
        case 'middle':
        case 'insideEndArc':
        case 'endArc':
            anchorAngle = middleAngle;
            break;
        case 'startAngle':
        case 'insideStartAngle':
            anchorAngle = startAngle;
            break;
        case 'endAngle':
        case 'insideEndAngle':
            anchorAngle = endAngle;
            break;
        default:
            sector.setTextConfig({
                rotation: 0
            });
            return;
    }
    var rotate = Math.PI * 1.5 - anchorAngle;
    /**
   * TODO: labels with rotate > Math.PI / 2 should be rotate another
   * half round flipped to increase readability. However, only middle
   * position supports this for now, because in other positions, the
   * anchor point is not at the center of the text, so the positions
   * after rotating is not as expected.
   */ if (mappedSectorPosition === 'middle' && rotate > Math.PI / 2 && rotate < Math.PI * 1.5) rotate -= Math.PI;
    sector.setTextConfig({
        rotation: rotate
    });
}
function $5e4aaa173c31cda6$var$adjustAngleDistanceX(angle, distance, isEnd) {
    return distance * Math.sin(angle) * (isEnd ? -1 : 1);
}
function $5e4aaa173c31cda6$var$adjustAngleDistanceY(angle, distance, isEnd) {
    return distance * Math.cos(angle) * (isEnd ? 1 : -1);
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $9491a9b96e203579$export$b395eeeb2ad7cce5(model, shape, zeroIfNull) {
    var cornerRadius = model.get('borderRadius');
    if (cornerRadius == null) return zeroIfNull ? {
        cornerRadius: 0
    } : null;
    if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(cornerRadius)) cornerRadius = [
        cornerRadius,
        cornerRadius,
        cornerRadius,
        cornerRadius
    ];
    var dr = Math.abs(shape.r || 0 - shape.r0 || 0);
    return {
        cornerRadius: (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(cornerRadius, function(cr) {
            return (0, $6c308355c7107803$export$e8514cb5a5e2b40f)(cr, dr);
        })
    };
}


var $0b120d76f26c920d$var$mathMax = Math.max;
var $0b120d76f26c920d$var$mathMin = Math.min;
function $0b120d76f26c920d$var$getClipArea(coord, data) {
    var coordSysClipArea = coord.getArea && coord.getArea();
    if ((0, $3fea949f0512eb55$export$8567506e6336616)(coord, 'cartesian2d')) {
        var baseAxis = coord.getBaseAxis();
        // When boundaryGap is false or using time axis. bar may exceed the grid.
        // We should not clip this part.
        // See test/bar2.html
        if (baseAxis.type !== 'category' || !baseAxis.onBand) {
            var expandWidth = data.getLayout('bandWidth');
            if (baseAxis.isHorizontal()) {
                coordSysClipArea.x -= expandWidth;
                coordSysClipArea.width += expandWidth * 2;
            } else {
                coordSysClipArea.y -= expandWidth;
                coordSysClipArea.height += expandWidth * 2;
            }
        }
    }
    return coordSysClipArea;
}
var $0b120d76f26c920d$var$BarView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(BarView, _super);
    function BarView() {
        var _this = _super.call(this) || this;
        _this.type = BarView.type;
        _this._isFirstFrame = true;
        return _this;
    }
    BarView.prototype.render = function(seriesModel, ecModel, api, payload) {
        this._model = seriesModel;
        this._removeOnRenderedListener(api);
        this._updateDrawMode(seriesModel);
        var coordinateSystemType = seriesModel.get('coordinateSystem');
        if (coordinateSystemType === 'cartesian2d' || coordinateSystemType === 'polar') {
            // Clear previously rendered progressive elements.
            this._progressiveEls = null;
            this._isLargeDraw ? this._renderLarge(seriesModel, ecModel, api) : this._renderNormal(seriesModel, ecModel, api, payload);
        }
    };
    BarView.prototype.incrementalPrepareRender = function(seriesModel) {
        this._clear();
        this._updateDrawMode(seriesModel);
        // incremental also need to clip, otherwise might be overlow.
        // But must not set clip in each frame, otherwise all of the children will be marked redraw.
        this._updateLargeClip(seriesModel);
    };
    BarView.prototype.incrementalRender = function(params, seriesModel) {
        // Reset
        this._progressiveEls = [];
        // Do not support progressive in normal mode.
        this._incrementalRenderLarge(params, seriesModel);
    };
    BarView.prototype.eachRendered = function(cb) {
        (0, $5b455ae6f843ac47$export$3e564442729bf048)(this._progressiveEls || this.group, cb);
    };
    BarView.prototype._updateDrawMode = function(seriesModel) {
        var isLargeDraw = seriesModel.pipelineContext.large;
        if (this._isLargeDraw == null || isLargeDraw !== this._isLargeDraw) {
            this._isLargeDraw = isLargeDraw;
            this._clear();
        }
    };
    BarView.prototype._renderNormal = function(seriesModel, ecModel, api, payload) {
        var group = this.group;
        var data = seriesModel.getData();
        var oldData = this._data;
        var coord = seriesModel.coordinateSystem;
        var baseAxis = coord.getBaseAxis();
        var isHorizontalOrRadial;
        if (coord.type === 'cartesian2d') isHorizontalOrRadial = baseAxis.isHorizontal();
        else if (coord.type === 'polar') isHorizontalOrRadial = baseAxis.dim === 'angle';
        var animationModel = seriesModel.isAnimationEnabled() ? seriesModel : null;
        var realtimeSortCfg = $0b120d76f26c920d$var$shouldRealtimeSort(seriesModel, coord);
        if (realtimeSortCfg) this._enableRealtimeSort(realtimeSortCfg, data, api);
        var needsClip = seriesModel.get('clip', true) || realtimeSortCfg;
        var coordSysClipArea = $0b120d76f26c920d$var$getClipArea(coord, data);
        // If there is clipPath created in large mode. Remove it.
        group.removeClipPath();
        // We don't use clipPath in normal mode because we needs a perfect animation
        // And don't want the label are clipped.
        var roundCap = seriesModel.get('roundCap', true);
        var drawBackground = seriesModel.get('showBackground', true);
        var backgroundModel = seriesModel.getModel('backgroundStyle');
        var barBorderRadius = backgroundModel.get('borderRadius') || 0;
        var bgEls = [];
        var oldBgEls = this._backgroundEls;
        var isInitSort = payload && payload.isInitSort;
        var isChangeOrder = payload && payload.type === 'changeAxisOrder';
        function createBackground(dataIndex) {
            var bgLayout = $0b120d76f26c920d$var$getLayout[coord.type](data, dataIndex);
            var bgEl = $0b120d76f26c920d$var$createBackgroundEl(coord, isHorizontalOrRadial, bgLayout);
            bgEl.useStyle(backgroundModel.getItemStyle());
            // Only cartesian2d support borderRadius.
            if (coord.type === 'cartesian2d') bgEl.setShape('r', barBorderRadius);
            else bgEl.setShape('cornerRadius', barBorderRadius);
            bgEls[dataIndex] = bgEl;
            return bgEl;
        }
        data.diff(oldData).add(function(dataIndex) {
            var itemModel = data.getItemModel(dataIndex);
            var layout = $0b120d76f26c920d$var$getLayout[coord.type](data, dataIndex, itemModel);
            if (drawBackground) createBackground(dataIndex);
            // If dataZoom in filteMode: 'empty', the baseValue can be set as NaN in "axisProxy".
            if (!data.hasValue(dataIndex) || !$0b120d76f26c920d$var$isValidLayout[coord.type](layout)) return;
            var isClipped = false;
            if (needsClip) // Clip will modify the layout params.
            // And return a boolean to determine if the shape are fully clipped.
            isClipped = $0b120d76f26c920d$var$clip[coord.type](coordSysClipArea, layout);
            var el = $0b120d76f26c920d$var$elementCreator[coord.type](seriesModel, data, dataIndex, layout, isHorizontalOrRadial, animationModel, baseAxis.model, false, roundCap);
            if (realtimeSortCfg) /**
         * Force label animation because even if the element is
         * ignored because it's clipped, it may not be clipped after
         * changing order. Then, if not using forceLabelAnimation,
         * the label animation was never started, in which case,
         * the label will be the final value and doesn't have label
         * animation.
         */ el.forceLabelAnimation = true;
            $0b120d76f26c920d$var$updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === 'polar');
            if (isInitSort) el.attr({
                shape: layout
            });
            else if (realtimeSortCfg) $0b120d76f26c920d$var$updateRealtimeAnimation(realtimeSortCfg, animationModel, el, layout, dataIndex, isHorizontalOrRadial, false, false);
            else (0, $8b353638fbedfefa$export$a121566aadcfe021)(el, {
                shape: layout
            }, seriesModel, dataIndex);
            data.setItemGraphicEl(dataIndex, el);
            group.add(el);
            el.ignore = isClipped;
        }).update(function(newIndex, oldIndex) {
            var itemModel = data.getItemModel(newIndex);
            var layout = $0b120d76f26c920d$var$getLayout[coord.type](data, newIndex, itemModel);
            if (drawBackground) {
                var bgEl = void 0;
                if (oldBgEls.length === 0) bgEl = createBackground(oldIndex);
                else {
                    bgEl = oldBgEls[oldIndex];
                    bgEl.useStyle(backgroundModel.getItemStyle());
                    // Only cartesian2d support borderRadius.
                    if (coord.type === 'cartesian2d') bgEl.setShape('r', barBorderRadius);
                    else bgEl.setShape('cornerRadius', barBorderRadius);
                    bgEls[newIndex] = bgEl;
                }
                var bgLayout = $0b120d76f26c920d$var$getLayout[coord.type](data, newIndex);
                var shape = $0b120d76f26c920d$var$createBackgroundShape(isHorizontalOrRadial, bgLayout, coord);
                (0, $8b353638fbedfefa$export$c8dce3c08436e91e)(bgEl, {
                    shape: shape
                }, animationModel, newIndex);
            }
            var el = oldData.getItemGraphicEl(oldIndex);
            if (!data.hasValue(newIndex) || !$0b120d76f26c920d$var$isValidLayout[coord.type](layout)) {
                group.remove(el);
                return;
            }
            var isClipped = false;
            if (needsClip) {
                isClipped = $0b120d76f26c920d$var$clip[coord.type](coordSysClipArea, layout);
                if (isClipped) group.remove(el);
            }
            if (!el) el = $0b120d76f26c920d$var$elementCreator[coord.type](seriesModel, data, newIndex, layout, isHorizontalOrRadial, animationModel, baseAxis.model, !!el, roundCap);
            else (0, $8b353638fbedfefa$export$bca7290a9faf0ec9)(el);
            if (realtimeSortCfg) el.forceLabelAnimation = true;
            if (isChangeOrder) {
                var textEl = el.getTextContent();
                if (textEl) {
                    var labelInnerStore = (0, $6800dfcb6e1e2a44$export$f62786d3261ab0f4)(textEl);
                    if (labelInnerStore.prevValue != null) /**
             * Set preValue to be value so that no new label
             * should be started, otherwise, it will take a full
             * `animationDurationUpdate` time to finish the
             * animation, which is not expected.
             */ labelInnerStore.prevValue = labelInnerStore.value;
                }
            } else $0b120d76f26c920d$var$updateStyle(el, data, newIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === 'polar');
            if (isInitSort) el.attr({
                shape: layout
            });
            else if (realtimeSortCfg) $0b120d76f26c920d$var$updateRealtimeAnimation(realtimeSortCfg, animationModel, el, layout, newIndex, isHorizontalOrRadial, true, isChangeOrder);
            else (0, $8b353638fbedfefa$export$c8dce3c08436e91e)(el, {
                shape: layout
            }, seriesModel, newIndex, null);
            data.setItemGraphicEl(newIndex, el);
            el.ignore = isClipped;
            group.add(el);
        }).remove(function(dataIndex) {
            var el = oldData.getItemGraphicEl(dataIndex);
            el && (0, $8b353638fbedfefa$export$6d0fd725cb4aee8a)(el, seriesModel, dataIndex);
        }).execute();
        var bgGroup = this._backgroundGroup || (this._backgroundGroup = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)());
        bgGroup.removeAll();
        for(var i = 0; i < bgEls.length; ++i)bgGroup.add(bgEls[i]);
        group.add(bgGroup);
        this._backgroundEls = bgEls;
        this._data = data;
    };
    BarView.prototype._renderLarge = function(seriesModel, ecModel, api) {
        this._clear();
        $0b120d76f26c920d$var$createLarge(seriesModel, this.group);
        this._updateLargeClip(seriesModel);
    };
    BarView.prototype._incrementalRenderLarge = function(params, seriesModel) {
        this._removeBackground();
        $0b120d76f26c920d$var$createLarge(seriesModel, this.group, this._progressiveEls, true);
    };
    BarView.prototype._updateLargeClip = function(seriesModel) {
        // Use clipPath in large mode.
        var clipPath = seriesModel.get('clip', true) && (0, $0e2cc04b3aaad400$export$e0fe5081209d01c9)(seriesModel.coordinateSystem, false, seriesModel);
        var group = this.group;
        if (clipPath) group.setClipPath(clipPath);
        else group.removeClipPath();
    };
    BarView.prototype._enableRealtimeSort = function(realtimeSortCfg, data, api) {
        var _this = this;
        // If no data in the first frame, wait for data to initSort
        if (!data.count()) return;
        var baseAxis = realtimeSortCfg.baseAxis;
        if (this._isFirstFrame) {
            this._dispatchInitSort(data, realtimeSortCfg, api);
            this._isFirstFrame = false;
        } else {
            var orderMapping_1 = function(idx) {
                var el = data.getItemGraphicEl(idx);
                var shape = el && el.shape;
                return shape && // The result should be consistent with the initial sort by data value.
                // Do not support the case that both positive and negative exist.
                Math.abs(baseAxis.isHorizontal() ? shape.height : shape.width) || 0;
            };
            this._onRendered = function() {
                _this._updateSortWithinSameData(data, orderMapping_1, baseAxis, api);
            };
            api.getZr().on('rendered', this._onRendered);
        }
    };
    BarView.prototype._dataSort = function(data, baseAxis, orderMapping) {
        var info = [];
        data.each(data.mapDimension(baseAxis.dim), function(ordinalNumber, dataIdx) {
            var mappedValue = orderMapping(dataIdx);
            mappedValue = mappedValue == null ? NaN : mappedValue;
            info.push({
                dataIndex: dataIdx,
                mappedValue: mappedValue,
                ordinalNumber: ordinalNumber
            });
        });
        info.sort(function(a, b) {
            // If NaN, it will be treated as min val.
            return b.mappedValue - a.mappedValue;
        });
        return {
            ordinalNumbers: (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(info, function(item) {
                return item.ordinalNumber;
            })
        };
    };
    BarView.prototype._isOrderChangedWithinSameData = function(data, orderMapping, baseAxis) {
        var scale = baseAxis.scale;
        var ordinalDataDim = data.mapDimension(baseAxis.dim);
        var lastValue = Number.MAX_VALUE;
        for(var tickNum = 0, len = scale.getOrdinalMeta().categories.length; tickNum < len; ++tickNum){
            var rawIdx = data.rawIndexOf(ordinalDataDim, scale.getRawOrdinalNumber(tickNum));
            var value = rawIdx < 0 ? Number.MIN_VALUE : orderMapping(data.indexOfRawIndex(rawIdx));
            if (value > lastValue) return true;
            lastValue = value;
        }
        return false;
    };
    /*
   * Consider the case when A and B changed order, whose representing
   * bars are both out of sight, we don't wish to trigger reorder action
   * as long as the order in the view doesn't change.
   */ BarView.prototype._isOrderDifferentInView = function(orderInfo, baseAxis) {
        var scale = baseAxis.scale;
        var extent = scale.getExtent();
        var tickNum = Math.max(0, extent[0]);
        var tickMax = Math.min(extent[1], scale.getOrdinalMeta().categories.length - 1);
        for(; tickNum <= tickMax; ++tickNum){
            if (orderInfo.ordinalNumbers[tickNum] !== scale.getRawOrdinalNumber(tickNum)) return true;
        }
    };
    BarView.prototype._updateSortWithinSameData = function(data, orderMapping, baseAxis, api) {
        if (!this._isOrderChangedWithinSameData(data, orderMapping, baseAxis)) return;
        var sortInfo = this._dataSort(data, baseAxis, orderMapping);
        if (this._isOrderDifferentInView(sortInfo, baseAxis)) {
            this._removeOnRenderedListener(api);
            api.dispatchAction({
                type: 'changeAxisOrder',
                componentType: baseAxis.dim + 'Axis',
                axisId: baseAxis.index,
                sortInfo: sortInfo
            });
        }
    };
    BarView.prototype._dispatchInitSort = function(data, realtimeSortCfg, api) {
        var baseAxis = realtimeSortCfg.baseAxis;
        var sortResult = this._dataSort(data, baseAxis, function(dataIdx) {
            return data.get(data.mapDimension(realtimeSortCfg.otherAxis.dim), dataIdx);
        });
        api.dispatchAction({
            type: 'changeAxisOrder',
            componentType: baseAxis.dim + 'Axis',
            isInitSort: true,
            axisId: baseAxis.index,
            sortInfo: sortResult
        });
    };
    BarView.prototype.remove = function(ecModel, api) {
        this._clear(this._model);
        this._removeOnRenderedListener(api);
    };
    BarView.prototype.dispose = function(ecModel, api) {
        this._removeOnRenderedListener(api);
    };
    BarView.prototype._removeOnRenderedListener = function(api) {
        if (this._onRendered) {
            api.getZr().off('rendered', this._onRendered);
            this._onRendered = null;
        }
    };
    BarView.prototype._clear = function(model) {
        var group = this.group;
        var data = this._data;
        if (model && model.isAnimationEnabled() && data && !this._isLargeDraw) {
            this._removeBackground();
            this._backgroundEls = [];
            data.eachItemGraphicEl(function(el) {
                (0, $8b353638fbedfefa$export$6d0fd725cb4aee8a)(el, model, (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).dataIndex);
            });
        } else group.removeAll();
        this._data = null;
        this._isFirstFrame = true;
    };
    BarView.prototype._removeBackground = function() {
        this.group.remove(this._backgroundGroup);
        this._backgroundGroup = null;
    };
    BarView.type = 'bar';
    return BarView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $0b120d76f26c920d$var$clip = {
    cartesian2d: function(coordSysBoundingRect, layout) {
        var signWidth = layout.width < 0 ? -1 : 1;
        var signHeight = layout.height < 0 ? -1 : 1;
        // Needs positive width and height
        if (signWidth < 0) {
            layout.x += layout.width;
            layout.width = -layout.width;
        }
        if (signHeight < 0) {
            layout.y += layout.height;
            layout.height = -layout.height;
        }
        var coordSysX2 = coordSysBoundingRect.x + coordSysBoundingRect.width;
        var coordSysY2 = coordSysBoundingRect.y + coordSysBoundingRect.height;
        var x = $0b120d76f26c920d$var$mathMax(layout.x, coordSysBoundingRect.x);
        var x2 = $0b120d76f26c920d$var$mathMin(layout.x + layout.width, coordSysX2);
        var y = $0b120d76f26c920d$var$mathMax(layout.y, coordSysBoundingRect.y);
        var y2 = $0b120d76f26c920d$var$mathMin(layout.y + layout.height, coordSysY2);
        var xClipped = x2 < x;
        var yClipped = y2 < y;
        // When xClipped or yClipped, the element will be marked as `ignore`.
        // But we should also place the element at the edge of the coord sys bounding rect.
        // Because if data changed and the bar shows again, its transition animation
        // will begin at this place.
        layout.x = xClipped && x > coordSysX2 ? x2 : x;
        layout.y = yClipped && y > coordSysY2 ? y2 : y;
        layout.width = xClipped ? 0 : x2 - x;
        layout.height = yClipped ? 0 : y2 - y;
        // Reverse back
        if (signWidth < 0) {
            layout.x += layout.width;
            layout.width = -layout.width;
        }
        if (signHeight < 0) {
            layout.y += layout.height;
            layout.height = -layout.height;
        }
        return xClipped || yClipped;
    },
    polar: function(coordSysClipArea, layout) {
        var signR = layout.r0 <= layout.r ? 1 : -1;
        // Make sure r is larger than r0
        if (signR < 0) {
            var tmp = layout.r;
            layout.r = layout.r0;
            layout.r0 = tmp;
        }
        var r = $0b120d76f26c920d$var$mathMin(layout.r, coordSysClipArea.r);
        var r0 = $0b120d76f26c920d$var$mathMax(layout.r0, coordSysClipArea.r0);
        layout.r = r;
        layout.r0 = r0;
        var clipped = r - r0 < 0;
        // Reverse back
        if (signR < 0) {
            var tmp = layout.r;
            layout.r = layout.r0;
            layout.r0 = tmp;
        }
        return clipped;
    }
};
var $0b120d76f26c920d$var$elementCreator = {
    cartesian2d: function(seriesModel, data, newIndex, layout, isHorizontal, animationModel, axisModel, isUpdate, roundCap) {
        var rect = new (0, $419e5ff2f303755e$export$2e2bcd8739ae039)({
            shape: (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, layout),
            z2: 1
        });
        rect.__dataIndex = newIndex;
        rect.name = 'item';
        if (animationModel) {
            var rectShape = rect.shape;
            var animateProperty = isHorizontal ? 'height' : 'width';
            rectShape[animateProperty] = 0;
        }
        return rect;
    },
    polar: function(seriesModel, data, newIndex, layout, isRadial, animationModel, axisModel, isUpdate, roundCap) {
        var ShapeClass = !isRadial && roundCap ? (0, $9674946a7a7df213$export$2e2bcd8739ae039) : (0, $a3e1dec0a3875b49$export$2e2bcd8739ae039);
        var sector = new ShapeClass({
            shape: layout,
            z2: 1
        });
        sector.name = 'item';
        var positionMap = $0b120d76f26c920d$var$createPolarPositionMapping(isRadial);
        sector.calculateTextPosition = (0, $5e4aaa173c31cda6$export$359a1e2d210ed734)(positionMap, {
            isRoundCap: ShapeClass === (0, $9674946a7a7df213$export$2e2bcd8739ae039)
        });
        // Animation
        if (animationModel) {
            var sectorShape = sector.shape;
            var animateProperty = isRadial ? 'r' : 'endAngle';
            var animateTarget = {};
            sectorShape[animateProperty] = isRadial ? layout.r0 : layout.startAngle;
            animateTarget[animateProperty] = layout[animateProperty];
            (isUpdate ? (0, $8b353638fbedfefa$export$c8dce3c08436e91e) : (0, $8b353638fbedfefa$export$a121566aadcfe021))(sector, {
                shape: animateTarget
            }, animationModel);
        }
        return sector;
    }
};
function $0b120d76f26c920d$var$shouldRealtimeSort(seriesModel, coordSys) {
    var realtimeSortOption = seriesModel.get('realtimeSort', true);
    var baseAxis = coordSys.getBaseAxis();
    if (realtimeSortOption && baseAxis.type === 'category' && coordSys.type === 'cartesian2d') return {
        baseAxis: baseAxis,
        otherAxis: coordSys.getOtherAxis(baseAxis)
    };
}
function $0b120d76f26c920d$var$updateRealtimeAnimation(realtimeSortCfg, seriesAnimationModel, el, layout, newIndex, isHorizontal, isUpdate, isChangeOrder) {
    var seriesTarget;
    var axisTarget;
    if (isHorizontal) {
        axisTarget = {
            x: layout.x,
            width: layout.width
        };
        seriesTarget = {
            y: layout.y,
            height: layout.height
        };
    } else {
        axisTarget = {
            y: layout.y,
            height: layout.height
        };
        seriesTarget = {
            x: layout.x,
            width: layout.width
        };
    }
    if (!isChangeOrder) // Keep the original growth animation if only axis order changed.
    // Not start a new animation.
    (isUpdate ? (0, $8b353638fbedfefa$export$c8dce3c08436e91e) : (0, $8b353638fbedfefa$export$a121566aadcfe021))(el, {
        shape: seriesTarget
    }, seriesAnimationModel, newIndex, null);
    var axisAnimationModel = seriesAnimationModel ? realtimeSortCfg.baseAxis.model : null;
    (isUpdate ? (0, $8b353638fbedfefa$export$c8dce3c08436e91e) : (0, $8b353638fbedfefa$export$a121566aadcfe021))(el, {
        shape: axisTarget
    }, axisAnimationModel, newIndex);
}
function $0b120d76f26c920d$var$checkPropertiesNotValid(obj, props) {
    for(var i = 0; i < props.length; i++){
        if (!isFinite(obj[props[i]])) return true;
    }
    return false;
}
var $0b120d76f26c920d$var$rectPropties = [
    'x',
    'y',
    'width',
    'height'
];
var $0b120d76f26c920d$var$polarPropties = [
    'cx',
    'cy',
    'r',
    'startAngle',
    'endAngle'
];
var $0b120d76f26c920d$var$isValidLayout = {
    cartesian2d: function(layout) {
        return !$0b120d76f26c920d$var$checkPropertiesNotValid(layout, $0b120d76f26c920d$var$rectPropties);
    },
    polar: function(layout) {
        return !$0b120d76f26c920d$var$checkPropertiesNotValid(layout, $0b120d76f26c920d$var$polarPropties);
    }
};
var $0b120d76f26c920d$var$getLayout = {
    // itemModel is only used to get borderWidth, which is not needed
    // when calculating bar background layout.
    cartesian2d: function(data, dataIndex, itemModel) {
        var layout = data.getItemLayout(dataIndex);
        var fixedLineWidth = itemModel ? $0b120d76f26c920d$var$getLineWidth(itemModel, layout) : 0;
        // fix layout with lineWidth
        var signX = layout.width > 0 ? 1 : -1;
        var signY = layout.height > 0 ? 1 : -1;
        return {
            x: layout.x + signX * fixedLineWidth / 2,
            y: layout.y + signY * fixedLineWidth / 2,
            width: layout.width - signX * fixedLineWidth,
            height: layout.height - signY * fixedLineWidth
        };
    },
    polar: function(data, dataIndex, itemModel) {
        var layout = data.getItemLayout(dataIndex);
        return {
            cx: layout.cx,
            cy: layout.cy,
            r0: layout.r0,
            r: layout.r,
            startAngle: layout.startAngle,
            endAngle: layout.endAngle,
            clockwise: layout.clockwise
        };
    }
};
function $0b120d76f26c920d$var$isZeroOnPolar(layout) {
    return layout.startAngle != null && layout.endAngle != null && layout.startAngle === layout.endAngle;
}
function $0b120d76f26c920d$var$createPolarPositionMapping(isRadial) {
    return function(isRadial) {
        var arcOrAngle = isRadial ? 'Arc' : 'Angle';
        return function(position) {
            switch(position){
                case 'start':
                case 'insideStart':
                case 'end':
                case 'insideEnd':
                    return position + arcOrAngle;
                default:
                    return position;
            }
        };
    }(isRadial);
}
function $0b120d76f26c920d$var$updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, isPolar) {
    var style = data.getItemVisual(dataIndex, 'style');
    if (!isPolar) {
        var borderRadius = itemModel.get([
            'itemStyle',
            'borderRadius'
        ]) || 0;
        el.setShape('r', borderRadius);
    } else if (!seriesModel.get('roundCap')) {
        var sectorShape = el.shape;
        var cornerRadius = (0, $9491a9b96e203579$export$b395eeeb2ad7cce5)(itemModel.getModel('itemStyle'), sectorShape, true);
        (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(sectorShape, cornerRadius);
        el.setShape(sectorShape);
    }
    el.useStyle(style);
    var cursorStyle = itemModel.getShallow('cursor');
    cursorStyle && el.attr('cursor', cursorStyle);
    var labelPositionOutside = isPolar ? isHorizontalOrRadial ? layout.r >= layout.r0 ? 'endArc' : 'startArc' : layout.endAngle >= layout.startAngle ? 'endAngle' : 'startAngle' : isHorizontalOrRadial ? layout.height >= 0 ? 'bottom' : 'top' : layout.width >= 0 ? 'right' : 'left';
    var labelStatesModels = (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(itemModel);
    (0, $6800dfcb6e1e2a44$export$9a13992917966657)(el, labelStatesModels, {
        labelFetcher: seriesModel,
        labelDataIndex: dataIndex,
        defaultText: (0, $b2475f850d3c0bc2$export$5ff20667590927ed)(seriesModel.getData(), dataIndex),
        inheritColor: style.fill,
        defaultOpacity: style.opacity,
        defaultOutsidePosition: labelPositionOutside
    });
    var label = el.getTextContent();
    if (isPolar && label) {
        var position = itemModel.get([
            'label',
            'position'
        ]);
        el.textConfig.inside = position === 'middle' ? true : null;
        (0, $5e4aaa173c31cda6$export$672ce504c0db395a)(el, position === 'outside' ? labelPositionOutside : position, $0b120d76f26c920d$var$createPolarPositionMapping(isHorizontalOrRadial), itemModel.get([
            'label',
            'rotate'
        ]));
    }
    (0, $6800dfcb6e1e2a44$export$7bdbceaf9ab378f2)(label, labelStatesModels, seriesModel.getRawValue(dataIndex), function(value) {
        return (0, $b2475f850d3c0bc2$export$5f84815e91ca6775)(data, value);
    });
    var emphasisModel = itemModel.getModel([
        'emphasis'
    ]);
    (0, $2bf82c0980125b62$export$e51187539ff11209)(el, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
    (0, $2bf82c0980125b62$export$48b68047d330bbc9)(el, itemModel);
    if ($0b120d76f26c920d$var$isZeroOnPolar(layout)) {
        el.style.fill = 'none';
        el.style.stroke = 'none';
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(el.states, function(state) {
            if (state.style) state.style.fill = state.style.stroke = 'none';
        });
    }
}
// In case width or height are too small.
function $0b120d76f26c920d$var$getLineWidth(itemModel, rawLayout) {
    // Has no border.
    var borderColor = itemModel.get([
        'itemStyle',
        'borderColor'
    ]);
    if (!borderColor || borderColor === 'none') return 0;
    var lineWidth = itemModel.get([
        'itemStyle',
        'borderWidth'
    ]) || 0;
    // width or height may be NaN for empty data
    var width = isNaN(rawLayout.width) ? Number.MAX_VALUE : Math.abs(rawLayout.width);
    var height = isNaN(rawLayout.height) ? Number.MAX_VALUE : Math.abs(rawLayout.height);
    return Math.min(lineWidth, width, height);
}
var $0b120d76f26c920d$var$LagePathShape = /** @class */ function() {
    function LagePathShape() {}
    return LagePathShape;
}();
var $0b120d76f26c920d$var$LargePath = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(LargePath, _super);
    function LargePath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'largeBar';
        return _this;
    }
    LargePath.prototype.getDefaultShape = function() {
        return new $0b120d76f26c920d$var$LagePathShape();
    };
    LargePath.prototype.buildPath = function(ctx, shape) {
        // Drawing lines is more efficient than drawing
        // a whole line or drawing rects.
        var points = shape.points;
        var baseDimIdx = this.baseDimIdx;
        var valueDimIdx = 1 - this.baseDimIdx;
        var startPoint = [];
        var size = [];
        var barWidth = this.barWidth;
        for(var i = 0; i < points.length; i += 3){
            size[baseDimIdx] = barWidth;
            size[valueDimIdx] = points[i + 2];
            startPoint[baseDimIdx] = points[i + baseDimIdx];
            startPoint[valueDimIdx] = points[i + valueDimIdx];
            ctx.rect(startPoint[0], startPoint[1], size[0], size[1]);
        }
    };
    return LargePath;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
function $0b120d76f26c920d$var$createLarge(seriesModel, group, progressiveEls, incremental) {
    // TODO support polar
    var data = seriesModel.getData();
    var baseDimIdx = data.getLayout('valueAxisHorizontal') ? 1 : 0;
    var largeDataIndices = data.getLayout('largeDataIndices');
    var barWidth = data.getLayout('size');
    var backgroundModel = seriesModel.getModel('backgroundStyle');
    var bgPoints = data.getLayout('largeBackgroundPoints');
    if (bgPoints) {
        var bgEl = new $0b120d76f26c920d$var$LargePath({
            shape: {
                points: bgPoints
            },
            incremental: !!incremental,
            silent: true,
            z2: 0
        });
        bgEl.baseDimIdx = baseDimIdx;
        bgEl.largeDataIndices = largeDataIndices;
        bgEl.barWidth = barWidth;
        bgEl.useStyle(backgroundModel.getItemStyle());
        group.add(bgEl);
        progressiveEls && progressiveEls.push(bgEl);
    }
    var el = new $0b120d76f26c920d$var$LargePath({
        shape: {
            points: data.getLayout('largePoints')
        },
        incremental: !!incremental,
        ignoreCoarsePointer: true,
        z2: 1
    });
    el.baseDimIdx = baseDimIdx;
    el.largeDataIndices = largeDataIndices;
    el.barWidth = barWidth;
    group.add(el);
    el.useStyle(data.getVisual('style'));
    // Stroke is rendered first to avoid overlapping with fill
    el.style.stroke = null;
    // Enable tooltip and user mouse/touch event handlers.
    (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).seriesIndex = seriesModel.seriesIndex;
    if (!seriesModel.get('silent')) {
        el.on('mousedown', $0b120d76f26c920d$var$largePathUpdateDataIndex);
        el.on('mousemove', $0b120d76f26c920d$var$largePathUpdateDataIndex);
    }
    progressiveEls && progressiveEls.push(el);
}
// Use throttle to avoid frequently traverse to find dataIndex.
var $0b120d76f26c920d$var$largePathUpdateDataIndex = (0, $c98659a9437a3d2e$export$de363e709c412c8a)(function(event) {
    var largePath = this;
    var dataIndex = $0b120d76f26c920d$var$largePathFindDataIndex(largePath, event.offsetX, event.offsetY);
    (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(largePath).dataIndex = dataIndex >= 0 ? dataIndex : null;
}, 30, false);
function $0b120d76f26c920d$var$largePathFindDataIndex(largePath, x, y) {
    var baseDimIdx = largePath.baseDimIdx;
    var valueDimIdx = 1 - baseDimIdx;
    var points = largePath.shape.points;
    var largeDataIndices = largePath.largeDataIndices;
    var startPoint = [];
    var size = [];
    var barWidth = largePath.barWidth;
    for(var i = 0, len = points.length / 3; i < len; i++){
        var ii = i * 3;
        size[baseDimIdx] = barWidth;
        size[valueDimIdx] = points[ii + 2];
        startPoint[baseDimIdx] = points[ii + baseDimIdx];
        startPoint[valueDimIdx] = points[ii + valueDimIdx];
        if (size[valueDimIdx] < 0) {
            startPoint[valueDimIdx] += size[valueDimIdx];
            size[valueDimIdx] = -size[valueDimIdx];
        }
        if (x >= startPoint[0] && x <= startPoint[0] + size[0] && y >= startPoint[1] && y <= startPoint[1] + size[1]) return largeDataIndices[i];
    }
    return -1;
}
function $0b120d76f26c920d$var$createBackgroundShape(isHorizontalOrRadial, layout, coord) {
    if ((0, $3fea949f0512eb55$export$8567506e6336616)(coord, 'cartesian2d')) {
        var rectShape = layout;
        var coordLayout = coord.getArea();
        return {
            x: isHorizontalOrRadial ? rectShape.x : coordLayout.x,
            y: isHorizontalOrRadial ? coordLayout.y : rectShape.y,
            width: isHorizontalOrRadial ? rectShape.width : coordLayout.width,
            height: isHorizontalOrRadial ? coordLayout.height : rectShape.height
        };
    } else {
        var coordLayout = coord.getArea();
        var sectorShape = layout;
        return {
            cx: coordLayout.cx,
            cy: coordLayout.cy,
            r0: isHorizontalOrRadial ? coordLayout.r0 : sectorShape.r0,
            r: isHorizontalOrRadial ? coordLayout.r : sectorShape.r,
            startAngle: isHorizontalOrRadial ? sectorShape.startAngle : 0,
            endAngle: isHorizontalOrRadial ? sectorShape.endAngle : Math.PI * 2
        };
    }
}
function $0b120d76f26c920d$var$createBackgroundEl(coord, isHorizontalOrRadial, layout) {
    var ElementClz = coord.type === 'polar' ? (0, $a3e1dec0a3875b49$export$2e2bcd8739ae039) : (0, $419e5ff2f303755e$export$2e2bcd8739ae039);
    return new ElementClz({
        shape: $0b120d76f26c920d$var$createBackgroundShape(isHorizontalOrRadial, layout, coord),
        silent: true,
        z2: 0
    });
}
var $0b120d76f26c920d$export$2e2bcd8739ae039 = $0b120d76f26c920d$var$BarView;


function $4bb56d1f08552ff4$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $0b120d76f26c920d$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $1db8e2e676cae702$export$2e2bcd8739ae039));
    registers.registerLayout(registers.PRIORITY.VISUAL.LAYOUT, $7a1bd9c2710fea0d$export$c3095a23b368d1f2((0, $361c48dd900de28f$export$b3219800bda33a1f), 'bar'));
    // Do layout after other overall layout, which can prepare some information.
    registers.registerLayout(registers.PRIORITY.VISUAL.PROGRESSIVE_LAYOUT, (0, $361c48dd900de28f$export$16e8685758531cb6)('bar'));
    // Down sample after filter
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, (0, $3a37e5b80322a871$export$2e2bcd8739ae039)('bar'));
    /**
   * @payload
   * @property {string} [componentType=series]
   * @property {number} [dx]
   * @property {number} [dy]
   * @property {number} [zoom]
   * @property {number} [originX]
   * @property {number} [originY]
   */ registers.registerAction({
        type: 'changeAxisOrder',
        event: 'changeAxisOrder',
        update: 'update'
    }, function(payload, ecModel) {
        var componentType = payload.componentType || 'series';
        ecModel.eachComponent({
            mainType: componentType,
            query: payload
        }, function(componentModel) {
            if (payload.sortInfo) componentModel.axis.setCategorySortInfo(payload.sortInfo);
        });
    });
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $7e5c3511527c9907$export$2e2bcd8739ae039(seriesModel, opt, nameList) {
    opt = (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(opt) && {
        coordDimensions: opt
    } || (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
        encodeDefine: seriesModel.getEncode()
    }, opt);
    var source = seriesModel.getSource();
    var dimensions = (0, $a27631012b7b377c$export$2e2bcd8739ae039)(source, opt).dimensions;
    var list = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)(dimensions, seriesModel);
    list.initData(source, nameList);
    return list;
}





var $29bc1fc21a5243a6$export$ccfed902f8630510 = /** @class */ function() {
    function WhiskerBoxCommonMixin() {}
    /**
   * @private
   */ WhiskerBoxCommonMixin.prototype._hasEncodeRule = function(key) {
        var encodeRules = this.getEncode();
        return encodeRules && encodeRules.get(key) != null;
    };
    /**
   * @override
   */ WhiskerBoxCommonMixin.prototype.getInitialData = function(option, ecModel) {
        // When both types of xAxis and yAxis are 'value', layout is
        // needed to be specified by user. Otherwise, layout can be
        // judged by which axis is category.
        var ordinalMeta;
        var xAxisModel = ecModel.getComponent('xAxis', this.get('xAxisIndex'));
        var yAxisModel = ecModel.getComponent('yAxis', this.get('yAxisIndex'));
        var xAxisType = xAxisModel.get('type');
        var yAxisType = yAxisModel.get('type');
        var addOrdinal;
        // FIXME
        // Consider time axis.
        if (xAxisType === 'category') {
            option.layout = 'horizontal';
            ordinalMeta = xAxisModel.getOrdinalMeta();
            addOrdinal = !this._hasEncodeRule('x');
        } else if (yAxisType === 'category') {
            option.layout = 'vertical';
            ordinalMeta = yAxisModel.getOrdinalMeta();
            addOrdinal = !this._hasEncodeRule('y');
        } else option.layout = option.layout || 'horizontal';
        var coordDims = [
            'x',
            'y'
        ];
        var baseAxisDimIndex = option.layout === 'horizontal' ? 0 : 1;
        var baseAxisDim = this._baseAxisDim = coordDims[baseAxisDimIndex];
        var otherAxisDim = coordDims[1 - baseAxisDimIndex];
        var axisModels = [
            xAxisModel,
            yAxisModel
        ];
        var baseAxisType = axisModels[baseAxisDimIndex].get('type');
        var otherAxisType = axisModels[1 - baseAxisDimIndex].get('type');
        var data = option.data;
        // Clone a new data for next setOption({}) usage.
        // Avoid modifying current data will affect further update.
        if (data && addOrdinal) {
            var newOptionData_1 = [];
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(data, function(item, index) {
                var newItem;
                if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(item)) {
                    newItem = item.slice();
                    // Modify current using data.
                    item.unshift(index);
                } else if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(item.value)) {
                    newItem = $7a1bd9c2710fea0d$export$8b58be045bf06082({}, item);
                    newItem.value = newItem.value.slice();
                    // Modify current using data.
                    item.value.unshift(index);
                } else newItem = item;
                newOptionData_1.push(newItem);
            });
            option.data = newOptionData_1;
        }
        var defaultValueDimensions = this.defaultValueDimensions;
        var coordDimensions = [
            {
                name: baseAxisDim,
                type: (0, $18085de91ae59d03$export$af1622903e71278e)(baseAxisType),
                ordinalMeta: ordinalMeta,
                otherDims: {
                    tooltip: false,
                    itemName: 0
                },
                dimsDef: [
                    'base'
                ]
            },
            {
                name: otherAxisDim,
                type: (0, $18085de91ae59d03$export$af1622903e71278e)(otherAxisType),
                dimsDef: defaultValueDimensions.slice()
            }
        ];
        return (0, $7e5c3511527c9907$export$2e2bcd8739ae039)(this, {
            coordDimensions: coordDimensions,
            dimensionsCount: defaultValueDimensions.length + 1,
            encodeDefaulter: $7a1bd9c2710fea0d$export$c3095a23b368d1f2((0, $7dc6cdfd7450ef29$export$37682b8fdd2e83d), coordDimensions, this)
        });
    };
    /**
   * If horizontal, base axis is x, otherwise y.
   * @override
   */ WhiskerBoxCommonMixin.prototype.getBaseAxis = function() {
        var dim = this._baseAxisDim;
        return this.ecModel.getComponent(dim + 'Axis', this.get(dim + 'AxisIndex')).axis;
    };
    return WhiskerBoxCommonMixin;
}();



var $de6da9192b0ee4cb$var$BoxplotSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(BoxplotSeriesModel, _super);
    function BoxplotSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BoxplotSeriesModel.type;
        // TODO
        // box width represents group size, so dimension should have 'size'.
        /**
     * @see <https://en.wikipedia.org/wiki/Box_plot>
     * The meanings of 'min' and 'max' depend on user,
     * and echarts do not need to know it.
     * @readOnly
     */ _this.defaultValueDimensions = [
            {
                name: 'min',
                defaultTooltip: true
            },
            {
                name: 'Q1',
                defaultTooltip: true
            },
            {
                name: 'median',
                defaultTooltip: true
            },
            {
                name: 'Q3',
                defaultTooltip: true
            },
            {
                name: 'max',
                defaultTooltip: true
            }
        ];
        _this.visualDrawType = 'stroke';
        return _this;
    }
    BoxplotSeriesModel.type = 'series.boxplot';
    BoxplotSeriesModel.dependencies = [
        'xAxis',
        'yAxis',
        'grid'
    ];
    BoxplotSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        coordinateSystem: 'cartesian2d',
        legendHoverLink: true,
        layout: null,
        boxWidth: [
            7,
            50
        ],
        itemStyle: {
            color: '#fff',
            borderWidth: 1
        },
        emphasis: {
            scale: true,
            itemStyle: {
                borderWidth: 2,
                shadowBlur: 5,
                shadowOffsetX: 1,
                shadowOffsetY: 1,
                shadowColor: 'rgba(0,0,0,0.2)'
            }
        },
        animationDuration: 800
    };
    return BoxplotSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
(0, $7a1bd9c2710fea0d$export$e36fc9d62a853069)($de6da9192b0ee4cb$var$BoxplotSeriesModel, (0, $29bc1fc21a5243a6$export$ccfed902f8630510), true);
var $de6da9192b0ee4cb$export$2e2bcd8739ae039 = $de6da9192b0ee4cb$var$BoxplotSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $4f6c4593265afb0c$var$BoxplotView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(BoxplotView, _super);
    function BoxplotView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BoxplotView.type;
        return _this;
    }
    BoxplotView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var group = this.group;
        var oldData = this._data;
        // There is no old data only when first rendering or switching from
        // stream mode to normal mode, where previous elements should be removed.
        if (!this._data) group.removeAll();
        var constDim = seriesModel.get('layout') === 'horizontal' ? 1 : 0;
        data.diff(oldData).add(function(newIdx) {
            if (data.hasValue(newIdx)) {
                var itemLayout = data.getItemLayout(newIdx);
                var symbolEl = $4f6c4593265afb0c$var$createNormalBox(itemLayout, data, newIdx, constDim, true);
                data.setItemGraphicEl(newIdx, symbolEl);
                group.add(symbolEl);
            }
        }).update(function(newIdx, oldIdx) {
            var symbolEl = oldData.getItemGraphicEl(oldIdx);
            // Empty data
            if (!data.hasValue(newIdx)) {
                group.remove(symbolEl);
                return;
            }
            var itemLayout = data.getItemLayout(newIdx);
            if (!symbolEl) symbolEl = $4f6c4593265afb0c$var$createNormalBox(itemLayout, data, newIdx, constDim);
            else {
                (0, $8b353638fbedfefa$export$bca7290a9faf0ec9)(symbolEl);
                $4f6c4593265afb0c$var$updateNormalBoxData(itemLayout, symbolEl, data, newIdx);
            }
            group.add(symbolEl);
            data.setItemGraphicEl(newIdx, symbolEl);
        }).remove(function(oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            el && group.remove(el);
        }).execute();
        this._data = data;
    };
    BoxplotView.prototype.remove = function(ecModel) {
        var group = this.group;
        var data = this._data;
        this._data = null;
        data && data.eachItemGraphicEl(function(el) {
            el && group.remove(el);
        });
    };
    BoxplotView.type = 'boxplot';
    return BoxplotView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $4f6c4593265afb0c$var$BoxPathShape = /** @class */ function() {
    function BoxPathShape() {}
    return BoxPathShape;
}();
var $4f6c4593265afb0c$var$BoxPath = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(BoxPath, _super);
    function BoxPath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'boxplotBoxPath';
        return _this;
    }
    BoxPath.prototype.getDefaultShape = function() {
        return new $4f6c4593265afb0c$var$BoxPathShape();
    };
    BoxPath.prototype.buildPath = function(ctx, shape) {
        var ends = shape.points;
        var i = 0;
        ctx.moveTo(ends[i][0], ends[i][1]);
        i++;
        for(; i < 4; i++)ctx.lineTo(ends[i][0], ends[i][1]);
        ctx.closePath();
        for(; i < ends.length; i++){
            ctx.moveTo(ends[i][0], ends[i][1]);
            i++;
            ctx.lineTo(ends[i][0], ends[i][1]);
        }
    };
    return BoxPath;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
function $4f6c4593265afb0c$var$createNormalBox(itemLayout, data, dataIndex, constDim, isInit) {
    var ends = itemLayout.ends;
    var el = new $4f6c4593265afb0c$var$BoxPath({
        shape: {
            points: isInit ? $4f6c4593265afb0c$var$transInit(ends, constDim, itemLayout) : ends
        }
    });
    $4f6c4593265afb0c$var$updateNormalBoxData(itemLayout, el, data, dataIndex, isInit);
    return el;
}
function $4f6c4593265afb0c$var$updateNormalBoxData(itemLayout, el, data, dataIndex, isInit) {
    var seriesModel = data.hostModel;
    var updateMethod = $5b455ae6f843ac47$exports[isInit ? 'initProps' : 'updateProps'];
    updateMethod(el, {
        shape: {
            points: itemLayout.ends
        }
    }, seriesModel, dataIndex);
    el.useStyle(data.getItemVisual(dataIndex, 'style'));
    el.style.strokeNoScale = true;
    el.z2 = 100;
    var itemModel = data.getItemModel(dataIndex);
    var emphasisModel = itemModel.getModel('emphasis');
    (0, $2bf82c0980125b62$export$48b68047d330bbc9)(el, itemModel);
    (0, $2bf82c0980125b62$export$e51187539ff11209)(el, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
}
function $4f6c4593265afb0c$var$transInit(points, dim, itemLayout) {
    return $7a1bd9c2710fea0d$export$871de8747c9eaa88(points, function(point) {
        point = point.slice();
        point[dim] = itemLayout.initBaseline;
        return point;
    });
}
var $4f6c4593265afb0c$export$2e2bcd8739ae039 = $4f6c4593265afb0c$var$BoxplotView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $aa15a3e67343392c$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
function $aa15a3e67343392c$export$2e2bcd8739ae039(ecModel) {
    var groupResult = $aa15a3e67343392c$var$groupSeriesByAxis(ecModel);
    $aa15a3e67343392c$var$each(groupResult, function(groupItem) {
        var seriesModels = groupItem.seriesModels;
        if (!seriesModels.length) return;
        $aa15a3e67343392c$var$calculateBase(groupItem);
        $aa15a3e67343392c$var$each(seriesModels, function(seriesModel, idx) {
            $aa15a3e67343392c$var$layoutSingleSeries(seriesModel, groupItem.boxOffsetList[idx], groupItem.boxWidthList[idx]);
        });
    });
}
/**
 * Group series by axis.
 */ function $aa15a3e67343392c$var$groupSeriesByAxis(ecModel) {
    var result = [];
    var axisList = [];
    ecModel.eachSeriesByType('boxplot', function(seriesModel) {
        var baseAxis = seriesModel.getBaseAxis();
        var idx = $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(axisList, baseAxis);
        if (idx < 0) {
            idx = axisList.length;
            axisList[idx] = baseAxis;
            result[idx] = {
                axis: baseAxis,
                seriesModels: []
            };
        }
        result[idx].seriesModels.push(seriesModel);
    });
    return result;
}
/**
 * Calculate offset and box width for each series.
 */ function $aa15a3e67343392c$var$calculateBase(groupItem) {
    var baseAxis = groupItem.axis;
    var seriesModels = groupItem.seriesModels;
    var seriesCount = seriesModels.length;
    var boxWidthList = groupItem.boxWidthList = [];
    var boxOffsetList = groupItem.boxOffsetList = [];
    var boundList = [];
    var bandWidth;
    if (baseAxis.type === 'category') bandWidth = baseAxis.getBandWidth();
    else {
        var maxDataCount_1 = 0;
        $aa15a3e67343392c$var$each(seriesModels, function(seriesModel) {
            maxDataCount_1 = Math.max(maxDataCount_1, seriesModel.getData().count());
        });
        var extent = baseAxis.getExtent();
        bandWidth = Math.abs(extent[1] - extent[0]) / maxDataCount_1;
    }
    $aa15a3e67343392c$var$each(seriesModels, function(seriesModel) {
        var boxWidthBound = seriesModel.get('boxWidth');
        if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(boxWidthBound)) boxWidthBound = [
            boxWidthBound,
            boxWidthBound
        ];
        boundList.push([
            (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(boxWidthBound[0], bandWidth) || 0,
            (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(boxWidthBound[1], bandWidth) || 0
        ]);
    });
    var availableWidth = bandWidth * 0.8 - 2;
    var boxGap = availableWidth / seriesCount * 0.3;
    var boxWidth = (availableWidth - boxGap * (seriesCount - 1)) / seriesCount;
    var base = boxWidth / 2 - availableWidth / 2;
    $aa15a3e67343392c$var$each(seriesModels, function(seriesModel, idx) {
        boxOffsetList.push(base);
        base += boxGap + boxWidth;
        boxWidthList.push(Math.min(Math.max(boxWidth, boundList[idx][0]), boundList[idx][1]));
    });
}
/**
 * Calculate points location for each series.
 */ function $aa15a3e67343392c$var$layoutSingleSeries(seriesModel, offset, boxWidth) {
    var coordSys = seriesModel.coordinateSystem;
    var data = seriesModel.getData();
    var halfWidth = boxWidth / 2;
    var cDimIdx = seriesModel.get('layout') === 'horizontal' ? 0 : 1;
    var vDimIdx = 1 - cDimIdx;
    var coordDims = [
        'x',
        'y'
    ];
    var cDim = data.mapDimension(coordDims[cDimIdx]);
    var vDims = data.mapDimensionsAll(coordDims[vDimIdx]);
    if (cDim == null || vDims.length < 5) return;
    for(var dataIndex = 0; dataIndex < data.count(); dataIndex++){
        var axisDimVal = data.get(cDim, dataIndex);
        var median = getPoint(axisDimVal, vDims[2], dataIndex);
        var end1 = getPoint(axisDimVal, vDims[0], dataIndex);
        var end2 = getPoint(axisDimVal, vDims[1], dataIndex);
        var end4 = getPoint(axisDimVal, vDims[3], dataIndex);
        var end5 = getPoint(axisDimVal, vDims[4], dataIndex);
        var ends = [];
        addBodyEnd(ends, end2, false);
        addBodyEnd(ends, end4, true);
        ends.push(end1, end2, end5, end4);
        layEndLine(ends, end1);
        layEndLine(ends, end5);
        layEndLine(ends, median);
        data.setItemLayout(dataIndex, {
            initBaseline: median[vDimIdx],
            ends: ends
        });
    }
    function getPoint(axisDimVal, dim, dataIndex) {
        var val = data.get(dim, dataIndex);
        var p = [];
        p[cDimIdx] = axisDimVal;
        p[vDimIdx] = val;
        var point;
        if (isNaN(axisDimVal) || isNaN(val)) point = [
            NaN,
            NaN
        ];
        else {
            point = coordSys.dataToPoint(p);
            point[cDimIdx] += offset;
        }
        return point;
    }
    function addBodyEnd(ends, point, start) {
        var point1 = point.slice();
        var point2 = point.slice();
        point1[cDimIdx] += halfWidth;
        point2[cDimIdx] -= halfWidth;
        start ? ends.push(point1, point2) : ends.push(point2, point1);
    }
    function layEndLine(ends, endCenter) {
        var from = endCenter.slice();
        var to = endCenter.slice();
        from[cDimIdx] -= halfWidth;
        to[cDimIdx] += halfWidth;
        ends.push(from, to);
    }
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $a9247e275753b379$export$2e2bcd8739ae039(rawData, opt) {
    opt = opt || {};
    var boxData = [];
    var outliers = [];
    var boundIQR = opt.boundIQR;
    var useExtreme = boundIQR === 'none' || boundIQR === 0;
    for(var i = 0; i < rawData.length; i++){
        var ascList = (0, $cfc1f3b422a3185f$export$debe6e778e0a6d32)(rawData[i].slice());
        var Q1 = (0, $cfc1f3b422a3185f$export$651fb4afdb6caa4b)(ascList, 0.25);
        var Q2 = (0, $cfc1f3b422a3185f$export$651fb4afdb6caa4b)(ascList, 0.5);
        var Q3 = (0, $cfc1f3b422a3185f$export$651fb4afdb6caa4b)(ascList, 0.75);
        var min = ascList[0];
        var max = ascList[ascList.length - 1];
        var bound = (boundIQR == null ? 1.5 : boundIQR) * (Q3 - Q1);
        var low = useExtreme ? min : Math.max(min, Q1 - bound);
        var high = useExtreme ? max : Math.min(max, Q3 + bound);
        var itemNameFormatter = opt.itemNameFormatter;
        var itemName = (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(itemNameFormatter) ? itemNameFormatter({
            value: i
        }) : (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(itemNameFormatter) ? itemNameFormatter.replace('{value}', i + '') : i + '';
        boxData.push([
            itemName,
            low,
            Q1,
            Q2,
            Q3,
            high
        ]);
        for(var j = 0; j < ascList.length; j++){
            var dataItem = ascList[j];
            if (dataItem < low || dataItem > high) {
                var outlier = [
                    itemName,
                    dataItem
                ];
                outliers.push(outlier);
            }
        }
    }
    return {
        boxData: boxData,
        outliers: outliers
    };
}




var $9203fc6e2b112614$export$e0915fae26dedefc = {
    type: 'echarts:boxplot',
    transform: function transform(params) {
        var upstream = params.upstream;
        if (upstream.sourceFormat !== (0, $cab29724515ce2b8$export$fcd62ebf51387903)) {
            var errMsg = '';
            (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
        }
        var result = (0, $a9247e275753b379$export$2e2bcd8739ae039)(upstream.getRawData(), params.config);
        return [
            {
                dimensions: [
                    'ItemName',
                    'Low',
                    'Q1',
                    'Q2',
                    'Q3',
                    'High'
                ],
                data: result.boxData
            },
            {
                data: result.outliers
            }
        ];
    }
};


function $0fd6296850ce3099$export$4b3e715f166fdd78(registers) {
    registers.registerSeriesModel((0, $de6da9192b0ee4cb$export$2e2bcd8739ae039));
    registers.registerChartView((0, $4f6c4593265afb0c$export$2e2bcd8739ae039));
    registers.registerLayout((0, $aa15a3e67343392c$export$2e2bcd8739ae039));
    registers.registerTransform((0, $9203fc6e2b112614$export$e0915fae26dedefc));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $f31d4ab399bcabcc$var$positiveBorderColorQuery = [
    'itemStyle',
    'borderColor'
];
var $f31d4ab399bcabcc$var$negativeBorderColorQuery = [
    'itemStyle',
    'borderColor0'
];
var $f31d4ab399bcabcc$var$dojiBorderColorQuery = [
    'itemStyle',
    'borderColorDoji'
];
var $f31d4ab399bcabcc$var$positiveColorQuery = [
    'itemStyle',
    'color'
];
var $f31d4ab399bcabcc$var$negativeColorQuery = [
    'itemStyle',
    'color0'
];
function $f31d4ab399bcabcc$export$5551a2d24ff40153(sign, model) {
    return model.get(sign > 0 ? $f31d4ab399bcabcc$var$positiveColorQuery : $f31d4ab399bcabcc$var$negativeColorQuery);
}
function $f31d4ab399bcabcc$export$dbc6cfecd630bcea(sign, model) {
    return model.get(sign === 0 ? $f31d4ab399bcabcc$var$dojiBorderColorQuery : sign > 0 ? $f31d4ab399bcabcc$var$positiveBorderColorQuery : $f31d4ab399bcabcc$var$negativeBorderColorQuery);
}
var $f31d4ab399bcabcc$var$candlestickVisual = {
    seriesType: 'candlestick',
    plan: (0, $cd70075c57b35175$export$2e2bcd8739ae039)(),
    // For legend.
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        // Only visible series has each data be visual encoded
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        var isLargeRender = seriesModel.pipelineContext.large;
        return !isLargeRender && {
            progress: function(params, data) {
                var dataIndex;
                while((dataIndex = params.next()) != null){
                    var itemModel = data.getItemModel(dataIndex);
                    var sign = data.getItemLayout(dataIndex).sign;
                    var style = itemModel.getItemStyle();
                    style.fill = $f31d4ab399bcabcc$export$5551a2d24ff40153(sign, itemModel);
                    style.stroke = $f31d4ab399bcabcc$export$dbc6cfecd630bcea(sign, itemModel) || style.fill;
                    var existsStyle = data.ensureUniqueItemVisual(dataIndex, 'style');
                    (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(existsStyle, style);
                }
            }
        };
    }
};
var $f31d4ab399bcabcc$export$2e2bcd8739ae039 = $f31d4ab399bcabcc$var$candlestickVisual;


var $74dcd5b9be05016d$var$SKIP_PROPS = [
    'color',
    'borderColor'
];
var $74dcd5b9be05016d$var$CandlestickView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(CandlestickView, _super);
    function CandlestickView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CandlestickView.type;
        return _this;
    }
    CandlestickView.prototype.render = function(seriesModel, ecModel, api) {
        // If there is clipPath created in large mode. Remove it.
        this.group.removeClipPath();
        // Clear previously rendered progressive elements.
        this._progressiveEls = null;
        this._updateDrawMode(seriesModel);
        this._isLargeDraw ? this._renderLarge(seriesModel) : this._renderNormal(seriesModel);
    };
    CandlestickView.prototype.incrementalPrepareRender = function(seriesModel, ecModel, api) {
        this._clear();
        this._updateDrawMode(seriesModel);
    };
    CandlestickView.prototype.incrementalRender = function(params, seriesModel, ecModel, api) {
        this._progressiveEls = [];
        this._isLargeDraw ? this._incrementalRenderLarge(params, seriesModel) : this._incrementalRenderNormal(params, seriesModel);
    };
    CandlestickView.prototype.eachRendered = function(cb) {
        $5b455ae6f843ac47$export$3e564442729bf048(this._progressiveEls || this.group, cb);
    };
    CandlestickView.prototype._updateDrawMode = function(seriesModel) {
        var isLargeDraw = seriesModel.pipelineContext.large;
        if (this._isLargeDraw == null || isLargeDraw !== this._isLargeDraw) {
            this._isLargeDraw = isLargeDraw;
            this._clear();
        }
    };
    CandlestickView.prototype._renderNormal = function(seriesModel) {
        var data = seriesModel.getData();
        var oldData = this._data;
        var group = this.group;
        var isSimpleBox = data.getLayout('isSimpleBox');
        var needsClip = seriesModel.get('clip', true);
        var coord = seriesModel.coordinateSystem;
        var clipArea = coord.getArea && coord.getArea();
        // There is no old data only when first rendering or switching from
        // stream mode to normal mode, where previous elements should be removed.
        if (!this._data) group.removeAll();
        data.diff(oldData).add(function(newIdx) {
            if (data.hasValue(newIdx)) {
                var itemLayout = data.getItemLayout(newIdx);
                if (needsClip && $74dcd5b9be05016d$var$isNormalBoxClipped(clipArea, itemLayout)) return;
                var el = $74dcd5b9be05016d$var$createNormalBox(itemLayout, newIdx, true);
                $8b353638fbedfefa$export$a121566aadcfe021(el, {
                    shape: {
                        points: itemLayout.ends
                    }
                }, seriesModel, newIdx);
                $74dcd5b9be05016d$var$setBoxCommon(el, data, newIdx, isSimpleBox);
                group.add(el);
                data.setItemGraphicEl(newIdx, el);
            }
        }).update(function(newIdx, oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            // Empty data
            if (!data.hasValue(newIdx)) {
                group.remove(el);
                return;
            }
            var itemLayout = data.getItemLayout(newIdx);
            if (needsClip && $74dcd5b9be05016d$var$isNormalBoxClipped(clipArea, itemLayout)) {
                group.remove(el);
                return;
            }
            if (!el) el = $74dcd5b9be05016d$var$createNormalBox(itemLayout, newIdx);
            else {
                $8b353638fbedfefa$export$c8dce3c08436e91e(el, {
                    shape: {
                        points: itemLayout.ends
                    }
                }, seriesModel, newIdx);
                (0, $8b353638fbedfefa$export$bca7290a9faf0ec9)(el);
            }
            $74dcd5b9be05016d$var$setBoxCommon(el, data, newIdx, isSimpleBox);
            group.add(el);
            data.setItemGraphicEl(newIdx, el);
        }).remove(function(oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            el && group.remove(el);
        }).execute();
        this._data = data;
    };
    CandlestickView.prototype._renderLarge = function(seriesModel) {
        this._clear();
        $74dcd5b9be05016d$var$createLarge(seriesModel, this.group);
        var clipPath = seriesModel.get('clip', true) ? (0, $0e2cc04b3aaad400$export$e0fe5081209d01c9)(seriesModel.coordinateSystem, false, seriesModel) : null;
        if (clipPath) this.group.setClipPath(clipPath);
        else this.group.removeClipPath();
    };
    CandlestickView.prototype._incrementalRenderNormal = function(params, seriesModel) {
        var data = seriesModel.getData();
        var isSimpleBox = data.getLayout('isSimpleBox');
        var dataIndex;
        while((dataIndex = params.next()) != null){
            var itemLayout = data.getItemLayout(dataIndex);
            var el = $74dcd5b9be05016d$var$createNormalBox(itemLayout, dataIndex);
            $74dcd5b9be05016d$var$setBoxCommon(el, data, dataIndex, isSimpleBox);
            el.incremental = true;
            this.group.add(el);
            this._progressiveEls.push(el);
        }
    };
    CandlestickView.prototype._incrementalRenderLarge = function(params, seriesModel) {
        $74dcd5b9be05016d$var$createLarge(seriesModel, this.group, this._progressiveEls, true);
    };
    CandlestickView.prototype.remove = function(ecModel) {
        this._clear();
    };
    CandlestickView.prototype._clear = function() {
        this.group.removeAll();
        this._data = null;
    };
    CandlestickView.type = 'candlestick';
    return CandlestickView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $74dcd5b9be05016d$var$NormalBoxPathShape = /** @class */ function() {
    function NormalBoxPathShape() {}
    return NormalBoxPathShape;
}();
var $74dcd5b9be05016d$var$NormalBoxPath = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(NormalBoxPath, _super);
    function NormalBoxPath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'normalCandlestickBox';
        return _this;
    }
    NormalBoxPath.prototype.getDefaultShape = function() {
        return new $74dcd5b9be05016d$var$NormalBoxPathShape();
    };
    NormalBoxPath.prototype.buildPath = function(ctx, shape) {
        var ends = shape.points;
        if (this.__simpleBox) {
            ctx.moveTo(ends[4][0], ends[4][1]);
            ctx.lineTo(ends[6][0], ends[6][1]);
        } else {
            ctx.moveTo(ends[0][0], ends[0][1]);
            ctx.lineTo(ends[1][0], ends[1][1]);
            ctx.lineTo(ends[2][0], ends[2][1]);
            ctx.lineTo(ends[3][0], ends[3][1]);
            ctx.closePath();
            ctx.moveTo(ends[4][0], ends[4][1]);
            ctx.lineTo(ends[5][0], ends[5][1]);
            ctx.moveTo(ends[6][0], ends[6][1]);
            ctx.lineTo(ends[7][0], ends[7][1]);
        }
    };
    return NormalBoxPath;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
function $74dcd5b9be05016d$var$createNormalBox(itemLayout, dataIndex, isInit) {
    var ends = itemLayout.ends;
    return new $74dcd5b9be05016d$var$NormalBoxPath({
        shape: {
            points: isInit ? $74dcd5b9be05016d$var$transInit(ends, itemLayout) : ends
        },
        z2: 100
    });
}
function $74dcd5b9be05016d$var$isNormalBoxClipped(clipArea, itemLayout) {
    var clipped = true;
    for(var i = 0; i < itemLayout.ends.length; i++)// If any point are in the region.
    if (clipArea.contain(itemLayout.ends[i][0], itemLayout.ends[i][1])) {
        clipped = false;
        break;
    }
    return clipped;
}
function $74dcd5b9be05016d$var$setBoxCommon(el, data, dataIndex, isSimpleBox) {
    var itemModel = data.getItemModel(dataIndex);
    el.useStyle(data.getItemVisual(dataIndex, 'style'));
    el.style.strokeNoScale = true;
    el.__simpleBox = isSimpleBox;
    (0, $2bf82c0980125b62$export$48b68047d330bbc9)(el, itemModel);
    var sign = data.getItemLayout(dataIndex).sign;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(el.states, function(state, stateName) {
        var stateModel = itemModel.getModel(stateName);
        var color = (0, $f31d4ab399bcabcc$export$5551a2d24ff40153)(sign, stateModel);
        var borderColor = (0, $f31d4ab399bcabcc$export$dbc6cfecd630bcea)(sign, stateModel) || color;
        var stateStyle = state.style || (state.style = {});
        color && (stateStyle.fill = color);
        borderColor && (stateStyle.stroke = borderColor);
    });
    var emphasisModel = itemModel.getModel('emphasis');
    (0, $2bf82c0980125b62$export$e51187539ff11209)(el, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
}
function $74dcd5b9be05016d$var$transInit(points, itemLayout) {
    return $7a1bd9c2710fea0d$export$871de8747c9eaa88(points, function(point) {
        point = point.slice();
        point[1] = itemLayout.initBaseline;
        return point;
    });
}
var $74dcd5b9be05016d$var$LargeBoxPathShape = /** @class */ function() {
    function LargeBoxPathShape() {}
    return LargeBoxPathShape;
}();
var $74dcd5b9be05016d$var$LargeBoxPath = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(LargeBoxPath, _super);
    function LargeBoxPath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'largeCandlestickBox';
        return _this;
    }
    LargeBoxPath.prototype.getDefaultShape = function() {
        return new $74dcd5b9be05016d$var$LargeBoxPathShape();
    };
    LargeBoxPath.prototype.buildPath = function(ctx, shape) {
        // Drawing lines is more efficient than drawing
        // a whole line or drawing rects.
        var points = shape.points;
        for(var i = 0; i < points.length;)if (this.__sign === points[i++]) {
            var x = points[i++];
            ctx.moveTo(x, points[i++]);
            ctx.lineTo(x, points[i++]);
        } else i += 3;
    };
    return LargeBoxPath;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
function $74dcd5b9be05016d$var$createLarge(seriesModel, group, progressiveEls, incremental) {
    var data = seriesModel.getData();
    var largePoints = data.getLayout('largePoints');
    var elP = new $74dcd5b9be05016d$var$LargeBoxPath({
        shape: {
            points: largePoints
        },
        __sign: 1,
        ignoreCoarsePointer: true
    });
    group.add(elP);
    var elN = new $74dcd5b9be05016d$var$LargeBoxPath({
        shape: {
            points: largePoints
        },
        __sign: -1,
        ignoreCoarsePointer: true
    });
    group.add(elN);
    var elDoji = new $74dcd5b9be05016d$var$LargeBoxPath({
        shape: {
            points: largePoints
        },
        __sign: 0,
        ignoreCoarsePointer: true
    });
    group.add(elDoji);
    $74dcd5b9be05016d$var$setLargeStyle(1, elP, seriesModel, data);
    $74dcd5b9be05016d$var$setLargeStyle(-1, elN, seriesModel, data);
    $74dcd5b9be05016d$var$setLargeStyle(0, elDoji, seriesModel, data);
    if (incremental) {
        elP.incremental = true;
        elN.incremental = true;
    }
    if (progressiveEls) progressiveEls.push(elP, elN);
}
function $74dcd5b9be05016d$var$setLargeStyle(sign, el, seriesModel, data) {
    // TODO put in visual?
    var borderColor = (0, $f31d4ab399bcabcc$export$dbc6cfecd630bcea)(sign, seriesModel) || (0, $f31d4ab399bcabcc$export$5551a2d24ff40153)(sign, seriesModel);
    // Color must be excluded.
    // Because symbol provide setColor individually to set fill and stroke
    var itemStyle = seriesModel.getModel('itemStyle').getItemStyle($74dcd5b9be05016d$var$SKIP_PROPS);
    el.useStyle(itemStyle);
    el.style.fill = null;
    el.style.stroke = borderColor;
}
var $74dcd5b9be05016d$export$2e2bcd8739ae039 = $74dcd5b9be05016d$var$CandlestickView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $b79b80243e209954$var$CandlestickSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(CandlestickSeriesModel, _super);
    function CandlestickSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CandlestickSeriesModel.type;
        _this.defaultValueDimensions = [
            {
                name: 'open',
                defaultTooltip: true
            },
            {
                name: 'close',
                defaultTooltip: true
            },
            {
                name: 'lowest',
                defaultTooltip: true
            },
            {
                name: 'highest',
                defaultTooltip: true
            }
        ];
        return _this;
    }
    /**
   * Get dimension for shadow in dataZoom
   * @return dimension name
   */ CandlestickSeriesModel.prototype.getShadowDim = function() {
        return 'open';
    };
    CandlestickSeriesModel.prototype.brushSelector = function(dataIndex, data, selectors) {
        var itemLayout = data.getItemLayout(dataIndex);
        return itemLayout && selectors.rect(itemLayout.brushRect);
    };
    CandlestickSeriesModel.type = 'series.candlestick';
    CandlestickSeriesModel.dependencies = [
        'xAxis',
        'yAxis',
        'grid'
    ];
    CandlestickSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        coordinateSystem: 'cartesian2d',
        legendHoverLink: true,
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        layout: null,
        clip: true,
        itemStyle: {
            color: '#eb5454',
            color0: '#47b262',
            borderColor: '#eb5454',
            borderColor0: '#47b262',
            borderColorDoji: null,
            // borderColor: '#d24040',
            // borderColor0: '#398f4f',
            borderWidth: 1
        },
        emphasis: {
            itemStyle: {
                borderWidth: 2
            }
        },
        barMaxWidth: null,
        barMinWidth: null,
        barWidth: null,
        large: true,
        largeThreshold: 600,
        progressive: 3e3,
        progressiveThreshold: 1e4,
        progressiveChunkMode: 'mod',
        animationEasing: 'linear',
        animationDuration: 300
    };
    return CandlestickSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
(0, $7a1bd9c2710fea0d$export$e36fc9d62a853069)($b79b80243e209954$var$CandlestickSeriesModel, (0, $29bc1fc21a5243a6$export$ccfed902f8630510), true);
var $b79b80243e209954$export$2e2bcd8739ae039 = $b79b80243e209954$var$CandlestickSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $55263b38adc138a7$export$2e2bcd8739ae039(option) {
    if (!option || !$7a1bd9c2710fea0d$export$43bee75e5e14138e(option.series)) return;
    // Translate 'k' to 'candlestick'.
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(option.series, function(seriesItem) {
        if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(seriesItem) && seriesItem.type === 'k') seriesItem.type = 'candlestick';
    });
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $a4e49046f9f1fd8b$var$candlestickLayout = {
    seriesType: 'candlestick',
    plan: (0, $cd70075c57b35175$export$2e2bcd8739ae039)(),
    reset: function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        var data = seriesModel.getData();
        var candleWidth = $a4e49046f9f1fd8b$var$calculateCandleWidth(seriesModel, data);
        var cDimIdx = 0;
        var vDimIdx = 1;
        var coordDims = [
            'x',
            'y'
        ];
        var cDimI = data.getDimensionIndex(data.mapDimension(coordDims[cDimIdx]));
        var vDimsI = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(data.mapDimensionsAll(coordDims[vDimIdx]), data.getDimensionIndex, data);
        var openDimI = vDimsI[0];
        var closeDimI = vDimsI[1];
        var lowestDimI = vDimsI[2];
        var highestDimI = vDimsI[3];
        data.setLayout({
            candleWidth: candleWidth,
            // The value is experimented visually.
            isSimpleBox: candleWidth <= 1.3
        });
        if (cDimI < 0 || vDimsI.length < 4) return;
        return {
            progress: seriesModel.pipelineContext.large ? largeProgress : normalProgress
        };
        function normalProgress(params, data) {
            var dataIndex;
            var store = data.getStore();
            while((dataIndex = params.next()) != null){
                var axisDimVal = store.get(cDimI, dataIndex);
                var openVal = store.get(openDimI, dataIndex);
                var closeVal = store.get(closeDimI, dataIndex);
                var lowestVal = store.get(lowestDimI, dataIndex);
                var highestVal = store.get(highestDimI, dataIndex);
                var ocLow = Math.min(openVal, closeVal);
                var ocHigh = Math.max(openVal, closeVal);
                var ocLowPoint = getPoint(ocLow, axisDimVal);
                var ocHighPoint = getPoint(ocHigh, axisDimVal);
                var lowestPoint = getPoint(lowestVal, axisDimVal);
                var highestPoint = getPoint(highestVal, axisDimVal);
                var ends = [];
                addBodyEnd(ends, ocHighPoint, 0);
                addBodyEnd(ends, ocLowPoint, 1);
                ends.push(subPixelOptimizePoint(highestPoint), subPixelOptimizePoint(ocHighPoint), subPixelOptimizePoint(lowestPoint), subPixelOptimizePoint(ocLowPoint));
                var itemModel = data.getItemModel(dataIndex);
                var hasDojiColor = !!itemModel.get([
                    'itemStyle',
                    'borderColorDoji'
                ]);
                data.setItemLayout(dataIndex, {
                    sign: $a4e49046f9f1fd8b$var$getSign(store, dataIndex, openVal, closeVal, closeDimI, hasDojiColor),
                    initBaseline: openVal > closeVal ? ocHighPoint[vDimIdx] : ocLowPoint[vDimIdx],
                    ends: ends,
                    brushRect: makeBrushRect(lowestVal, highestVal, axisDimVal)
                });
            }
            function getPoint(val, axisDimVal) {
                var p = [];
                p[cDimIdx] = axisDimVal;
                p[vDimIdx] = val;
                return isNaN(axisDimVal) || isNaN(val) ? [
                    NaN,
                    NaN
                ] : coordSys.dataToPoint(p);
            }
            function addBodyEnd(ends, point, start) {
                var point1 = point.slice();
                var point2 = point.slice();
                point1[cDimIdx] = (0, $5b455ae6f843ac47$export$72c4fd4c1b8fcb10)(point1[cDimIdx] + candleWidth / 2, 1, false);
                point2[cDimIdx] = (0, $5b455ae6f843ac47$export$72c4fd4c1b8fcb10)(point2[cDimIdx] - candleWidth / 2, 1, true);
                start ? ends.push(point1, point2) : ends.push(point2, point1);
            }
            function makeBrushRect(lowestVal, highestVal, axisDimVal) {
                var pmin = getPoint(lowestVal, axisDimVal);
                var pmax = getPoint(highestVal, axisDimVal);
                pmin[cDimIdx] -= candleWidth / 2;
                pmax[cDimIdx] -= candleWidth / 2;
                return {
                    x: pmin[0],
                    y: pmin[1],
                    width: vDimIdx ? candleWidth : pmax[0] - pmin[0],
                    height: vDimIdx ? pmax[1] - pmin[1] : candleWidth
                };
            }
            function subPixelOptimizePoint(point) {
                point[cDimIdx] = (0, $5b455ae6f843ac47$export$72c4fd4c1b8fcb10)(point[cDimIdx], 1);
                return point;
            }
        }
        function largeProgress(params, data) {
            // Structure: [sign, x, yhigh, ylow, sign, x, yhigh, ylow, ...]
            var points = (0, $5cd50afac93e9148$export$21d2298f3f56bbaf)(params.count * 4);
            var offset = 0;
            var point;
            var tmpIn = [];
            var tmpOut = [];
            var dataIndex;
            var store = data.getStore();
            var hasDojiColor = !!seriesModel.get([
                'itemStyle',
                'borderColorDoji'
            ]);
            while((dataIndex = params.next()) != null){
                var axisDimVal = store.get(cDimI, dataIndex);
                var openVal = store.get(openDimI, dataIndex);
                var closeVal = store.get(closeDimI, dataIndex);
                var lowestVal = store.get(lowestDimI, dataIndex);
                var highestVal = store.get(highestDimI, dataIndex);
                if (isNaN(axisDimVal) || isNaN(lowestVal) || isNaN(highestVal)) {
                    points[offset++] = NaN;
                    offset += 3;
                    continue;
                }
                points[offset++] = $a4e49046f9f1fd8b$var$getSign(store, dataIndex, openVal, closeVal, closeDimI, hasDojiColor);
                tmpIn[cDimIdx] = axisDimVal;
                tmpIn[vDimIdx] = lowestVal;
                point = coordSys.dataToPoint(tmpIn, null, tmpOut);
                points[offset++] = point ? point[0] : NaN;
                points[offset++] = point ? point[1] : NaN;
                tmpIn[vDimIdx] = highestVal;
                point = coordSys.dataToPoint(tmpIn, null, tmpOut);
                points[offset++] = point ? point[1] : NaN;
            }
            data.setLayout('largePoints', points);
        }
    }
};
/**
 * Get the sign of a single data.
 *
 * @returns 0 for doji with hasDojiColor: true,
 *          1 for positive,
 *          -1 for negative.
 */ function $a4e49046f9f1fd8b$var$getSign(store, dataIndex, openVal, closeVal, closeDimI, hasDojiColor) {
    var sign;
    if (openVal > closeVal) sign = -1;
    else if (openVal < closeVal) sign = 1;
    else sign = hasDojiColor ? 0 : dataIndex > 0 ? store.get(closeDimI, dataIndex - 1) <= closeVal ? 1 : -1 : 1;
    return sign;
}
function $a4e49046f9f1fd8b$var$calculateCandleWidth(seriesModel, data) {
    var baseAxis = seriesModel.getBaseAxis();
    var extent;
    var bandWidth = baseAxis.type === 'category' ? baseAxis.getBandWidth() : (extent = baseAxis.getExtent(), Math.abs(extent[1] - extent[0]) / data.count());
    var barMaxWidth = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)((0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(seriesModel.get('barMaxWidth'), bandWidth), bandWidth);
    var barMinWidth = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)((0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(seriesModel.get('barMinWidth'), 1), bandWidth);
    var barWidth = seriesModel.get('barWidth');
    return barWidth != null ? (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(barWidth, bandWidth) : Math.max(Math.min(bandWidth / 2, barMaxWidth), barMinWidth);
}
var $a4e49046f9f1fd8b$export$2e2bcd8739ae039 = $a4e49046f9f1fd8b$var$candlestickLayout;


function $21999577dfdc5807$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $74dcd5b9be05016d$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $b79b80243e209954$export$2e2bcd8739ae039));
    registers.registerPreprocessor((0, $55263b38adc138a7$export$2e2bcd8739ae039));
    registers.registerVisual((0, $f31d4ab399bcabcc$export$2e2bcd8739ae039));
    registers.registerLayout((0, $a4e49046f9f1fd8b$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $fef28dd8967d3f1b$export$84369c8e2229fa7f = {
    color: 'fill',
    borderColor: 'stroke'
};
var $fef28dd8967d3f1b$export$734d775a14929701 = {
    symbol: 1,
    symbolSize: 1,
    symbolKeepAspect: 1,
    legendIcon: 1,
    visualMeta: 1,
    liftZ: 1,
    decal: 1
};
var $fef28dd8967d3f1b$export$dd5c3cc86073562f = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $fef28dd8967d3f1b$var$CustomSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(CustomSeriesModel, _super);
    function CustomSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CustomSeriesModel.type;
        return _this;
    }
    CustomSeriesModel.prototype.optionUpdated = function() {
        this.currentZLevel = this.get('zlevel', true);
        this.currentZ = this.get('z', true);
    };
    CustomSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $8afdec5f59c90781$export$2e2bcd8739ae039)(null, this);
    };
    CustomSeriesModel.prototype.getDataParams = function(dataIndex, dataType, el) {
        var params = _super.prototype.getDataParams.call(this, dataIndex, dataType);
        el && (params.info = $fef28dd8967d3f1b$export$dd5c3cc86073562f(el).info);
        return params;
    };
    CustomSeriesModel.type = 'series.custom';
    CustomSeriesModel.dependencies = [
        'grid',
        'polar',
        'geo',
        'singleAxis',
        'calendar'
    ];
    CustomSeriesModel.defaultOption = {
        coordinateSystem: 'cartesian2d',
        // zlevel: 0,
        z: 2,
        legendHoverLink: true,
        // Custom series will not clip by default.
        // Some case will use custom series to draw label
        // For example https://echarts.apache.org/examples/en/editor.html?c=custom-gantt-flight
        clip: false
    };
    return CustomSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $fef28dd8967d3f1b$export$2e2bcd8739ae039 = $fef28dd8967d3f1b$var$CustomSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 









/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $eb5b87553d7c5e15$var$dataToCoordSize(dataSize, dataItem) {
    // dataItem is necessary in log axis.
    dataItem = dataItem || [
        0,
        0
    ];
    return $7a1bd9c2710fea0d$export$871de8747c9eaa88([
        'x',
        'y'
    ], function(dim, dimIdx) {
        var axis = this.getAxis(dim);
        var val = dataItem[dimIdx];
        var halfSize = dataSize[dimIdx] / 2;
        return axis.type === 'category' ? axis.getBandWidth() : Math.abs(axis.dataToCoord(val - halfSize) - axis.dataToCoord(val + halfSize));
    }, this);
}
function $eb5b87553d7c5e15$export$2e2bcd8739ae039(coordSys) {
    var rect = coordSys.master.getRect();
    return {
        coordSys: {
            // The name exposed to user is always 'cartesian2d' but not 'grid'.
            type: 'cartesian2d',
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height
        },
        api: {
            coord: function(data) {
                // do not provide "out" param
                return coordSys.dataToPoint(data);
            },
            size: $7a1bd9c2710fea0d$export$2385a24977818dd0($eb5b87553d7c5e15$var$dataToCoordSize, coordSys)
        }
    };
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $db94904ae7a63a7b$var$dataToCoordSize(dataSize, dataItem) {
    dataItem = dataItem || [
        0,
        0
    ];
    return $7a1bd9c2710fea0d$export$871de8747c9eaa88([
        0,
        1
    ], function(dimIdx) {
        var val = dataItem[dimIdx];
        var halfSize = dataSize[dimIdx] / 2;
        var p1 = [];
        var p2 = [];
        p1[dimIdx] = val - halfSize;
        p2[dimIdx] = val + halfSize;
        p1[1 - dimIdx] = p2[1 - dimIdx] = dataItem[1 - dimIdx];
        return Math.abs(this.dataToPoint(p1)[dimIdx] - this.dataToPoint(p2)[dimIdx]);
    }, this);
}
function $db94904ae7a63a7b$export$2e2bcd8739ae039(coordSys) {
    var rect = coordSys.getBoundingRect();
    return {
        coordSys: {
            type: 'geo',
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height,
            zoom: coordSys.getZoom()
        },
        api: {
            coord: function(data) {
                // do not provide "out" and noRoam param,
                // Compatible with this usage:
                // echarts.util.map(item.points, api.coord)
                return coordSys.dataToPoint(data);
            },
            size: $7a1bd9c2710fea0d$export$2385a24977818dd0($db94904ae7a63a7b$var$dataToCoordSize, coordSys)
        }
    };
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $4af7f8b40c63338e$var$dataToCoordSize(dataSize, dataItem) {
    // dataItem is necessary in log axis.
    var axis = this.getAxis();
    var val = dataItem instanceof Array ? dataItem[0] : dataItem;
    var halfSize = (dataSize instanceof Array ? dataSize[0] : dataSize) / 2;
    return axis.type === 'category' ? axis.getBandWidth() : Math.abs(axis.dataToCoord(val - halfSize) - axis.dataToCoord(val + halfSize));
}
function $4af7f8b40c63338e$export$2e2bcd8739ae039(coordSys) {
    var rect = coordSys.getRect();
    return {
        coordSys: {
            type: 'singleAxis',
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height
        },
        api: {
            coord: function(val) {
                // do not provide "out" param
                return coordSys.dataToPoint(val);
            },
            size: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)($4af7f8b40c63338e$var$dataToCoordSize, coordSys)
        }
    };
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
// import AngleAxis from './AngleAxis.js';
function $5542da7477183ee1$var$dataToCoordSize(dataSize, dataItem) {
    // dataItem is necessary in log axis.
    dataItem = dataItem || [
        0,
        0
    ];
    return $7a1bd9c2710fea0d$export$871de8747c9eaa88([
        'Radius',
        'Angle'
    ], function(dim, dimIdx) {
        var getterName = 'get' + dim + 'Axis';
        // TODO: TYPE Check Angle Axis
        var axis = this[getterName]();
        var val = dataItem[dimIdx];
        var halfSize = dataSize[dimIdx] / 2;
        var result = axis.type === 'category' ? axis.getBandWidth() : Math.abs(axis.dataToCoord(val - halfSize) - axis.dataToCoord(val + halfSize));
        if (dim === 'Angle') result = result * Math.PI / 180;
        return result;
    }, this);
}
function $5542da7477183ee1$export$2e2bcd8739ae039(coordSys) {
    var radiusAxis = coordSys.getRadiusAxis();
    var angleAxis = coordSys.getAngleAxis();
    var radius = radiusAxis.getExtent();
    radius[0] > radius[1] && radius.reverse();
    return {
        coordSys: {
            type: 'polar',
            cx: coordSys.cx,
            cy: coordSys.cy,
            r: radius[1],
            r0: radius[0]
        },
        api: {
            coord: function(data) {
                var radius = radiusAxis.dataToRadius(data[0]);
                var angle = angleAxis.dataToAngle(data[1]);
                var coord = coordSys.coordToPoint([
                    radius,
                    angle
                ]);
                coord.push(radius, angle * Math.PI / 180);
                return coord;
            },
            size: $7a1bd9c2710fea0d$export$2385a24977818dd0($5542da7477183ee1$var$dataToCoordSize, coordSys)
        }
    };
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $07a38220d20058fb$export$2e2bcd8739ae039(coordSys) {
    var rect = coordSys.getRect();
    var rangeInfo = coordSys.getRangeInfo();
    return {
        coordSys: {
            type: 'calendar',
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height,
            cellWidth: coordSys.getCellWidth(),
            cellHeight: coordSys.getCellHeight(),
            rangeInfo: {
                start: rangeInfo.start,
                end: rangeInfo.end,
                weeks: rangeInfo.weeks,
                dayCount: rangeInfo.allDay
            }
        },
        api: {
            coord: function(data, clamp) {
                return coordSys.dataToPoint(data, clamp);
            }
        }
    };
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $daa53642c3afcc30$var$deprecatedLogs = {};
function $daa53642c3afcc30$export$3b868abde5eae7d1(style, elType, hasOwnTextContentOption, hasOwnTextConfig) {
    // Since echarts5, `RectText` is separated from its host element and style.text
    // does not exist any more. The compat work brings some extra burden on performance.
    // So we provide:
    // `legacy: true` force make compat.
    // `legacy: false`, force do not compat.
    // `legacy` not set: auto detect whether legacy.
    //     But in this case we do not compat (difficult to detect and rare case):
    //     Becuse custom series and graphic component support "merge", users may firstly
    //     only set `textStrokeWidth` style or secondly only set `text`.
    return style && (style.legacy || style.legacy !== false && !hasOwnTextContentOption && !hasOwnTextConfig && elType !== 'tspan' && (elType === 'text' || (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(style, 'text')));
}
function $daa53642c3afcc30$export$7748133eaaa8aecc(hostStyle, elType, isNormal) {
    var srcStyle = hostStyle;
    var textConfig;
    var textContent;
    var textContentStyle;
    if (elType === 'text') textContentStyle = srcStyle;
    else {
        textContentStyle = {};
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, 'text') && (textContentStyle.text = srcStyle.text);
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, 'rich') && (textContentStyle.rich = srcStyle.rich);
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, 'textFill') && (textContentStyle.fill = srcStyle.textFill);
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, 'textStroke') && (textContentStyle.stroke = srcStyle.textStroke);
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, 'fontFamily') && (textContentStyle.fontFamily = srcStyle.fontFamily);
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, 'fontSize') && (textContentStyle.fontSize = srcStyle.fontSize);
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, 'fontStyle') && (textContentStyle.fontStyle = srcStyle.fontStyle);
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, 'fontWeight') && (textContentStyle.fontWeight = srcStyle.fontWeight);
        textContent = {
            type: 'text',
            style: textContentStyle,
            // ec4 does not support rectText trigger.
            // And when text position is different in normal and emphasis
            // => hover text trigger emphasis;
            // => text position changed, leave mouse pointer immediately;
            // That might cause incorrect state.
            silent: true
        };
        textConfig = {};
        var hasOwnPos = (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, 'textPosition');
        if (isNormal) textConfig.position = hasOwnPos ? srcStyle.textPosition : 'inside';
        else hasOwnPos && (textConfig.position = srcStyle.textPosition);
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, 'textPosition') && (textConfig.position = srcStyle.textPosition);
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, 'textOffset') && (textConfig.offset = srcStyle.textOffset);
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, 'textRotation') && (textConfig.rotation = srcStyle.textRotation);
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, 'textDistance') && (textConfig.distance = srcStyle.textDistance);
    }
    $daa53642c3afcc30$var$convertEC4CompatibleRichItem(textContentStyle, hostStyle);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(textContentStyle.rich, function(richItem) {
        $daa53642c3afcc30$var$convertEC4CompatibleRichItem(richItem, richItem);
    });
    return {
        textConfig: textConfig,
        textContent: textContent
    };
}
/**
 * The result will be set to `out`.
 */ function $daa53642c3afcc30$var$convertEC4CompatibleRichItem(out, richItem) {
    if (!richItem) return;
    // (1) For simplicity, make textXXX properties (deprecated since ec5) has
    // higher priority. For example, consider in ec4 `borderColor: 5, textBorderColor: 10`
    // on a rect means `borderColor: 4` on the rect and `borderColor: 10` on an attached
    // richText in ec5.
    // (2) `out === richItem` if and only if `out` is text el or rich item.
    // So we can overwrite existing props in `out` since textXXX has higher priority.
    richItem.font = richItem.textFont || richItem.font;
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, 'textStrokeWidth') && (out.lineWidth = richItem.textStrokeWidth);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, 'textAlign') && (out.align = richItem.textAlign);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, 'textVerticalAlign') && (out.verticalAlign = richItem.textVerticalAlign);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, 'textLineHeight') && (out.lineHeight = richItem.textLineHeight);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, 'textWidth') && (out.width = richItem.textWidth);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, 'textHeight') && (out.height = richItem.textHeight);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, 'textBackgroundColor') && (out.backgroundColor = richItem.textBackgroundColor);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, 'textPadding') && (out.padding = richItem.textPadding);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, 'textBorderColor') && (out.borderColor = richItem.textBorderColor);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, 'textBorderWidth') && (out.borderWidth = richItem.textBorderWidth);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, 'textBorderRadius') && (out.borderRadius = richItem.textBorderRadius);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, 'textBoxShadowColor') && (out.shadowColor = richItem.textBoxShadowColor);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, 'textBoxShadowBlur') && (out.shadowBlur = richItem.textBoxShadowBlur);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, 'textBoxShadowOffsetX') && (out.shadowOffsetX = richItem.textBoxShadowOffsetX);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, 'textBoxShadowOffsetY') && (out.shadowOffsetY = richItem.textBoxShadowOffsetY);
}
function $daa53642c3afcc30$export$b8ddb75bd1b9b791(itemStl, txStl, txCfg) {
    var out = itemStl;
    // See `custom.ts`, a trick to set extra `textPosition` firstly.
    out.textPosition = out.textPosition || txCfg.position || 'inside';
    txCfg.offset != null && (out.textOffset = txCfg.offset);
    txCfg.rotation != null && (out.textRotation = txCfg.rotation);
    txCfg.distance != null && (out.textDistance = txCfg.distance);
    var isInside = out.textPosition.indexOf('inside') >= 0;
    var hostFill = itemStl.fill || '#000';
    $daa53642c3afcc30$var$convertToEC4RichItem(out, txStl);
    var textFillNotSet = out.textFill == null;
    if (isInside) {
        if (textFillNotSet) {
            out.textFill = txCfg.insideFill || '#fff';
            !out.textStroke && txCfg.insideStroke && (out.textStroke = txCfg.insideStroke);
            !out.textStroke && (out.textStroke = hostFill);
            out.textStrokeWidth == null && (out.textStrokeWidth = 2);
        }
    } else {
        if (textFillNotSet) out.textFill = itemStl.fill || txCfg.outsideFill || '#000';
        !out.textStroke && txCfg.outsideStroke && (out.textStroke = txCfg.outsideStroke);
    }
    out.text = txStl.text;
    out.rich = txStl.rich;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(txStl.rich, function(richItem) {
        $daa53642c3afcc30$var$convertToEC4RichItem(richItem, richItem);
    });
    return out;
}
function $daa53642c3afcc30$var$convertToEC4RichItem(out, richItem) {
    if (!richItem) return;
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, 'fill') && (out.textFill = richItem.fill);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, 'stroke') && (out.textStroke = richItem.fill);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, 'lineWidth') && (out.textStrokeWidth = richItem.lineWidth);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, 'font') && (out.font = richItem.font);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, 'fontStyle') && (out.fontStyle = richItem.fontStyle);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, 'fontWeight') && (out.fontWeight = richItem.fontWeight);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, 'fontSize') && (out.fontSize = richItem.fontSize);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, 'fontFamily') && (out.fontFamily = richItem.fontFamily);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, 'align') && (out.textAlign = richItem.align);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, 'verticalAlign') && (out.textVerticalAlign = richItem.verticalAlign);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, 'lineHeight') && (out.textLineHeight = richItem.lineHeight);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, 'width') && (out.textWidth = richItem.width);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, 'height') && (out.textHeight = richItem.height);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, 'backgroundColor') && (out.textBackgroundColor = richItem.backgroundColor);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, 'padding') && (out.textPadding = richItem.padding);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, 'borderColor') && (out.textBorderColor = richItem.borderColor);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, 'borderWidth') && (out.textBorderWidth = richItem.borderWidth);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, 'borderRadius') && (out.textBorderRadius = richItem.borderRadius);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, 'shadowColor') && (out.textBoxShadowColor = richItem.shadowColor);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, 'shadowBlur') && (out.textBoxShadowBlur = richItem.shadowBlur);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, 'shadowOffsetX') && (out.textBoxShadowOffsetX = richItem.shadowOffsetX);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, 'shadowOffsetY') && (out.textBoxShadowOffsetY = richItem.shadowOffsetY);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, 'textShadowColor') && (out.textShadowColor = richItem.textShadowColor);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, 'textShadowBlur') && (out.textShadowBlur = richItem.textShadowBlur);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, 'textShadowOffsetX') && (out.textShadowOffsetX = richItem.textShadowOffsetX);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, 'textShadowOffsetY') && (out.textShadowOffsetY = richItem.textShadowOffsetY);
}
function $daa53642c3afcc30$export$606a5c06d13e04b6(deprecated, insteadApproach) {
    var key;
}





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







var $7c104376a000308e$var$LEGACY_TRANSFORM_PROPS_MAP = {
    position: [
        'x',
        'y'
    ],
    scale: [
        'scaleX',
        'scaleY'
    ],
    origin: [
        'originX',
        'originY'
    ]
};
var $7c104376a000308e$var$LEGACY_TRANSFORM_PROPS = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)($7c104376a000308e$var$LEGACY_TRANSFORM_PROPS_MAP);
var $7c104376a000308e$var$TRANSFORM_PROPS_MAP = (0, $7a1bd9c2710fea0d$export$533b26079ad0b4b)((0, $becf2d727f9cf450$export$98ab6203ec3396e2), function(obj, key) {
    obj[key] = 1;
    return obj;
}, {});
var $7c104376a000308e$var$transformPropNamesStr = (0, $becf2d727f9cf450$export$98ab6203ec3396e2).join(', ');
var $7c104376a000308e$export$9a911ad86e905b13 = [
    '',
    'style',
    'shape',
    'extra'
];
var $7c104376a000308e$var$transitionInnerStore = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $7c104376a000308e$var$getElementAnimationConfig(animationType, el, elOption, parentModel, dataIndex) {
    var animationProp = animationType + "Animation";
    var config = (0, $8b353638fbedfefa$export$5cc7add7ab591d0a)(animationType, parentModel, dataIndex) || {};
    var userDuring = $7c104376a000308e$var$transitionInnerStore(el).userDuring;
    // Only set when duration is > 0 and it's need to be animated.
    if (config.duration > 0) {
        // For simplicity, if during not specified, the previous during will not work any more.
        config.during = userDuring ? (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)($7c104376a000308e$var$duringCall, {
            el: el,
            userDuring: userDuring
        }) : null;
        config.setToFinal = true;
        config.scope = animationType;
    }
    (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(config, elOption[animationProp]);
    return config;
}
function $7c104376a000308e$export$4342b281b9b5d77e(el, elOption, animatableModel, opts) {
    opts = opts || {};
    var dataIndex = opts.dataIndex, isInit = opts.isInit, clearStyle = opts.clearStyle;
    var hasAnimation = animatableModel.isAnimationEnabled();
    // Save the meta info for further morphing. Like apply on the sub morphing elements.
    var store = $7c104376a000308e$var$transitionInnerStore(el);
    var styleOpt = elOption.style;
    store.userDuring = elOption.during;
    var transFromProps = {};
    var propsToSet = {};
    $7c104376a000308e$var$prepareTransformAllPropsFinal(el, elOption, propsToSet);
    $7c104376a000308e$var$prepareShapeOrExtraAllPropsFinal('shape', elOption, propsToSet);
    $7c104376a000308e$var$prepareShapeOrExtraAllPropsFinal('extra', elOption, propsToSet);
    if (!isInit && hasAnimation) {
        $7c104376a000308e$var$prepareTransformTransitionFrom(el, elOption, transFromProps);
        $7c104376a000308e$var$prepareShapeOrExtraTransitionFrom('shape', el, elOption, transFromProps);
        $7c104376a000308e$var$prepareShapeOrExtraTransitionFrom('extra', el, elOption, transFromProps);
        $7c104376a000308e$var$prepareStyleTransitionFrom(el, elOption, styleOpt, transFromProps);
    }
    propsToSet.style = styleOpt;
    $7c104376a000308e$var$applyPropsDirectly(el, propsToSet, clearStyle);
    $7c104376a000308e$var$applyMiscProps(el, elOption);
    if (hasAnimation) {
        if (isInit) {
            var enterFromProps_1 = {};
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($7c104376a000308e$export$9a911ad86e905b13, function(propName) {
                var prop = propName ? elOption[propName] : elOption;
                if (prop && prop.enterFrom) {
                    if (propName) enterFromProps_1[propName] = enterFromProps_1[propName] || {};
                    (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(propName ? enterFromProps_1[propName] : enterFromProps_1, prop.enterFrom);
                }
            });
            var config = $7c104376a000308e$var$getElementAnimationConfig('enter', el, elOption, animatableModel, dataIndex);
            if (config.duration > 0) el.animateFrom(enterFromProps_1, config);
        } else $7c104376a000308e$var$applyPropsTransition(el, elOption, dataIndex || 0, animatableModel, transFromProps);
    }
    // Store leave to be used in leave transition.
    $7c104376a000308e$export$a6f11bb1cb100e2a(el, elOption);
    styleOpt ? el.dirty() : el.markRedraw();
}
function $7c104376a000308e$export$a6f11bb1cb100e2a(el, elOption) {
    // Try merge to previous set leaveTo
    var leaveToProps = $7c104376a000308e$var$transitionInnerStore(el).leaveToProps;
    for(var i = 0; i < $7c104376a000308e$export$9a911ad86e905b13.length; i++){
        var propName = $7c104376a000308e$export$9a911ad86e905b13[i];
        var prop = propName ? elOption[propName] : elOption;
        if (prop && prop.leaveTo) {
            if (!leaveToProps) leaveToProps = $7c104376a000308e$var$transitionInnerStore(el).leaveToProps = {};
            if (propName) leaveToProps[propName] = leaveToProps[propName] || {};
            (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(propName ? leaveToProps[propName] : leaveToProps, prop.leaveTo);
        }
    }
}
function $7c104376a000308e$export$15575b6d82d35bb3(el, elOption, animatableModel, onRemove) {
    if (el) {
        var parent_1 = el.parent;
        var leaveToProps = $7c104376a000308e$var$transitionInnerStore(el).leaveToProps;
        if (leaveToProps) {
            // TODO TODO use leave after leaveAnimation in series is introduced
            // TODO Data index?
            var config = $7c104376a000308e$var$getElementAnimationConfig('update', el, elOption, animatableModel, 0);
            config.done = function() {
                parent_1.remove(el);
                onRemove && onRemove();
            };
            el.animateTo(leaveToProps, config);
        } else {
            parent_1.remove(el);
            onRemove && onRemove();
        }
    }
}
function $7c104376a000308e$export$6f3361b4b8d7a8ba(transition) {
    return transition === 'all';
}
function $7c104376a000308e$var$applyPropsDirectly(el, // Can be null/undefined
allPropsFinal, clearStyle) {
    var styleOpt = allPropsFinal.style;
    if (!el.isGroup && styleOpt) {
        if (clearStyle) {
            el.useStyle({});
            // When style object changed, how to trade the existing animation?
            // It is probably complicated and not needed to cover all the cases.
            // But still need consider the case:
            // (1) When using init animation on `style.opacity`, and before the animation
            //     ended users triggers an update by mousewhel. At that time the init
            //     animation should better be continued rather than terminated.
            //     So after `useStyle` called, we should change the animation target manually
            //     to continue the effect of the init animation.
            // (2) PENDING: If the previous animation targeted at a `val1`, and currently we need
            //     to update the value to `val2` and no animation declared, should be terminate
            //     the previous animation or just modify the target of the animation?
            //     Therotically That will happen not only on `style` but also on `shape` and
            //     `transfrom` props. But we haven't handle this case at present yet.
            // (3) PENDING: Is it proper to visit `animators` and `targetName`?
            var animators = el.animators;
            for(var i = 0; i < animators.length; i++){
                var animator = animators[i];
                // targetName is the "topKey".
                if (animator.targetName === 'style') animator.changeTarget(el.style);
            }
        }
        el.setStyle(styleOpt);
    }
    if (allPropsFinal) {
        // Not set style here.
        allPropsFinal.style = null;
        // Set el to the final state firstly.
        allPropsFinal && el.attr(allPropsFinal);
        allPropsFinal.style = styleOpt;
    }
}
function $7c104376a000308e$var$applyPropsTransition(el, elOption, dataIndex, model, // Can be null/undefined
transFromProps) {
    if (transFromProps) {
        var config = $7c104376a000308e$var$getElementAnimationConfig('update', el, elOption, model, dataIndex);
        if (config.duration > 0) el.animateFrom(transFromProps, config);
    }
}
function $7c104376a000308e$var$applyMiscProps(el, elOption) {
    // Merge by default.
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(elOption, 'silent') && (el.silent = elOption.silent);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(elOption, 'ignore') && (el.ignore = elOption.ignore);
    if (el instanceof (0, $56206a6cb4666931$export$2e2bcd8739ae039)) (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(elOption, 'invisible') && (el.invisible = elOption.invisible);
    if (el instanceof (0, $b02ffe7acd508c08$export$2e2bcd8739ae039)) (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(elOption, 'autoBatch') && (el.autoBatch = elOption.autoBatch);
}
// Use it to avoid it be exposed to user.
var $7c104376a000308e$var$tmpDuringScope = {};
var $7c104376a000308e$var$transitionDuringAPI = {
    // Usually other props do not need to be changed in animation during.
    setTransform: function(key, val) {
        $7c104376a000308e$var$tmpDuringScope.el[key] = val;
        return this;
    },
    getTransform: function(key) {
        return $7c104376a000308e$var$tmpDuringScope.el[key];
    },
    setShape: function(key, val) {
        var el = $7c104376a000308e$var$tmpDuringScope.el;
        var shape = el.shape || (el.shape = {});
        shape[key] = val;
        el.dirtyShape && el.dirtyShape();
        return this;
    },
    getShape: function(key) {
        var shape = $7c104376a000308e$var$tmpDuringScope.el.shape;
        if (shape) return shape[key];
    },
    setStyle: function(key, val) {
        var el = $7c104376a000308e$var$tmpDuringScope.el;
        var style = el.style;
        if (style) {
            style[key] = val;
            el.dirtyStyle && el.dirtyStyle();
        }
        return this;
    },
    getStyle: function(key) {
        var style = $7c104376a000308e$var$tmpDuringScope.el.style;
        if (style) return style[key];
    },
    setExtra: function(key, val) {
        var extra = $7c104376a000308e$var$tmpDuringScope.el.extra || ($7c104376a000308e$var$tmpDuringScope.el.extra = {});
        extra[key] = val;
        return this;
    },
    getExtra: function(key) {
        var extra = $7c104376a000308e$var$tmpDuringScope.el.extra;
        if (extra) return extra[key];
    }
};
function $7c104376a000308e$var$assertNotReserved(key) {}
function $7c104376a000308e$var$duringCall() {
    // Do not provide "percent" until some requirements come.
    // Because consider thies case:
    // enterFrom: {x: 100, y: 30}, transition: 'x'.
    // And enter duration is different from update duration.
    // Thus it might be confused about the meaning of "percent" in during callback.
    var scope = this;
    var el = scope.el;
    if (!el) return;
    // If el is remove from zr by reason like legend, during still need to called,
    // because el will be added back to zr and the prop value should not be incorrect.
    var latestUserDuring = $7c104376a000308e$var$transitionInnerStore(el).userDuring;
    var scopeUserDuring = scope.userDuring;
    // Ensured a during is only called once in each animation frame.
    // If a during is called multiple times in one frame, maybe some users' calculation logic
    // might be wrong (not sure whether this usage exists).
    // The case of a during might be called twice can be: by default there is a animator for
    // 'x', 'y' when init. Before the init animation finished, call `setOption` to start
    // another animators for 'style'/'shape'/'extra'.
    if (latestUserDuring !== scopeUserDuring) {
        // release
        scope.el = scope.userDuring = null;
        return;
    }
    $7c104376a000308e$var$tmpDuringScope.el = el;
    // Give no `this` to user in "during" calling.
    scopeUserDuring($7c104376a000308e$var$transitionDuringAPI);
// FIXME: if in future meet the case that some prop will be both modified in `during` and `state`,
// consider the issue that the prop might be incorrect when return to "normal" state.
}
function $7c104376a000308e$var$prepareShapeOrExtraTransitionFrom(mainAttr, fromEl, elOption, transFromProps) {
    var attrOpt = elOption[mainAttr];
    if (!attrOpt) return;
    var elPropsInAttr = fromEl[mainAttr];
    var transFromPropsInAttr;
    if (elPropsInAttr) {
        var transition = elOption.transition;
        var attrTransition = attrOpt.transition;
        if (attrTransition) {
            !transFromPropsInAttr && (transFromPropsInAttr = transFromProps[mainAttr] = {});
            if ($7c104376a000308e$export$6f3361b4b8d7a8ba(attrTransition)) (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(transFromPropsInAttr, elPropsInAttr);
            else {
                var transitionKeys = (0, $76d619f648247e6d$export$4f07b212a02c8051)(attrTransition);
                for(var i = 0; i < transitionKeys.length; i++){
                    var key = transitionKeys[i];
                    var elVal = elPropsInAttr[key];
                    transFromPropsInAttr[key] = elVal;
                }
            }
        } else if ($7c104376a000308e$export$6f3361b4b8d7a8ba(transition) || (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(transition, mainAttr) >= 0) {
            !transFromPropsInAttr && (transFromPropsInAttr = transFromProps[mainAttr] = {});
            var elPropsInAttrKeys = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(elPropsInAttr);
            for(var i = 0; i < elPropsInAttrKeys.length; i++){
                var key = elPropsInAttrKeys[i];
                var elVal = elPropsInAttr[key];
                if ($7c104376a000308e$var$isNonStyleTransitionEnabled(attrOpt[key], elVal)) transFromPropsInAttr[key] = elVal;
            }
        }
    }
}
function $7c104376a000308e$var$prepareShapeOrExtraAllPropsFinal(mainAttr, elOption, allProps) {
    var attrOpt = elOption[mainAttr];
    if (!attrOpt) return;
    var allPropsInAttr = allProps[mainAttr] = {};
    var keysInAttr = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(attrOpt);
    for(var i = 0; i < keysInAttr.length; i++){
        var key = keysInAttr[i];
        // To avoid share one object with different element, and
        // to avoid user modify the object inexpectedly, have to clone.
        allPropsInAttr[key] = (0, $76d8a142a20276fc$export$c5e92b7f105af84e)(attrOpt[key]);
    }
}
function $7c104376a000308e$var$prepareTransformTransitionFrom(el, elOption, transFromProps) {
    var transition = elOption.transition;
    var transitionKeys = $7c104376a000308e$export$6f3361b4b8d7a8ba(transition) ? (0, $becf2d727f9cf450$export$98ab6203ec3396e2) : (0, $76d619f648247e6d$export$4f07b212a02c8051)(transition || []);
    for(var i = 0; i < transitionKeys.length; i++){
        var key = transitionKeys[i];
        if (key === 'style' || key === 'shape' || key === 'extra') continue;
        var elVal = el[key];
        // Do not clone, animator will perform that clone.
        transFromProps[key] = elVal;
    }
}
function $7c104376a000308e$var$prepareTransformAllPropsFinal(el, elOption, allProps) {
    for(var i = 0; i < $7c104376a000308e$var$LEGACY_TRANSFORM_PROPS.length; i++){
        var legacyName = $7c104376a000308e$var$LEGACY_TRANSFORM_PROPS[i];
        var xyName = $7c104376a000308e$var$LEGACY_TRANSFORM_PROPS_MAP[legacyName];
        var legacyArr = elOption[legacyName];
        if (legacyArr) {
            allProps[xyName[0]] = legacyArr[0];
            allProps[xyName[1]] = legacyArr[1];
        }
    }
    for(var i = 0; i < (0, $becf2d727f9cf450$export$98ab6203ec3396e2).length; i++){
        var key = (0, $becf2d727f9cf450$export$98ab6203ec3396e2)[i];
        if (elOption[key] != null) allProps[key] = elOption[key];
    }
}
function $7c104376a000308e$var$prepareStyleTransitionFrom(fromEl, elOption, styleOpt, transFromProps) {
    if (!styleOpt) return;
    var fromElStyle = fromEl.style;
    var transFromStyleProps;
    if (fromElStyle) {
        var styleTransition = styleOpt.transition;
        var elTransition = elOption.transition;
        if (styleTransition && !$7c104376a000308e$export$6f3361b4b8d7a8ba(styleTransition)) {
            var transitionKeys = (0, $76d619f648247e6d$export$4f07b212a02c8051)(styleTransition);
            !transFromStyleProps && (transFromStyleProps = transFromProps.style = {});
            for(var i = 0; i < transitionKeys.length; i++){
                var key = transitionKeys[i];
                var elVal = fromElStyle[key];
                // Do not clone, see `checkNonStyleTansitionRefer`.
                transFromStyleProps[key] = elVal;
            }
        } else if (fromEl.getAnimationStyleProps && ($7c104376a000308e$export$6f3361b4b8d7a8ba(elTransition) || $7c104376a000308e$export$6f3361b4b8d7a8ba(styleTransition) || (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(elTransition, 'style') >= 0)) {
            var animationProps = fromEl.getAnimationStyleProps();
            var animationStyleProps = animationProps ? animationProps.style : null;
            if (animationStyleProps) {
                !transFromStyleProps && (transFromStyleProps = transFromProps.style = {});
                var styleKeys = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(styleOpt);
                for(var i = 0; i < styleKeys.length; i++){
                    var key = styleKeys[i];
                    if (animationStyleProps[key]) {
                        var elVal = fromElStyle[key];
                        transFromStyleProps[key] = elVal;
                    }
                }
            }
        }
    }
}
function $7c104376a000308e$var$isNonStyleTransitionEnabled(optVal, elVal) {
    // The same as `checkNonStyleTansitionRefer`.
    return !(0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(optVal) ? optVal != null && isFinite(optVal) : optVal !== elVal;
}
var $7c104376a000308e$var$checkTransformPropRefer;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $ab8d73690f09fb6d$var$getStateToRestore = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $ab8d73690f09fb6d$var$KEYFRAME_EXCLUDE_KEYS = [
    'percent',
    'easing',
    'shape',
    'style',
    'extra'
];
function $ab8d73690f09fb6d$export$9e5c70edf1ec0cb4(el) {
    // Stop previous keyframe animation.
    el.stopAnimation('keyframe');
    // Restore
    el.attr($ab8d73690f09fb6d$var$getStateToRestore(el));
}
function $ab8d73690f09fb6d$export$b0aa6a5f01693fa4(el, animationOpts, animatableModel) {
    if (!animatableModel.isAnimationEnabled() || !animationOpts) return;
    if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(animationOpts)) {
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(animationOpts, function(singleAnimationOpts) {
            $ab8d73690f09fb6d$export$b0aa6a5f01693fa4(el, singleAnimationOpts, animatableModel);
        });
        return;
    }
    var keyframes = animationOpts.keyframes;
    var duration = animationOpts.duration;
    if (animatableModel && duration == null) {
        // Default to use duration of config.
        // NOTE: animation config from payload will be ignored because they are mainly for transitions.
        var config = (0, $8b353638fbedfefa$export$5cc7add7ab591d0a)('enter', animatableModel, 0);
        duration = config && config.duration;
    }
    if (!keyframes || !duration) return;
    var stateToRestore = $ab8d73690f09fb6d$var$getStateToRestore(el);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $7c104376a000308e$export$9a911ad86e905b13), function(targetPropName) {
        if (targetPropName && !el[targetPropName]) return;
        var animator;
        var endFrameIsSet = false;
        // Sort keyframes by percent.
        keyframes.sort(function(a, b) {
            return a.percent - b.percent;
        });
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(keyframes, function(kf) {
            // Stop current animation.
            var animators = el.animators;
            var kfValues = targetPropName ? kf[targetPropName] : kf;
            if (!kfValues) return;
            var propKeys = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(kfValues);
            if (!targetPropName) // PENDING performance?
            propKeys = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(propKeys, function(key) {
                return (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)($ab8d73690f09fb6d$var$KEYFRAME_EXCLUDE_KEYS, key) < 0;
            });
            if (!propKeys.length) return;
            if (!animator) {
                animator = el.animate(targetPropName, animationOpts.loop, true);
                animator.scope = 'keyframe';
            }
            for(var i = 0; i < animators.length; i++)// Stop all other animation that is not keyframe.
            if (animators[i] !== animator && animators[i].targetName === animator.targetName) animators[i].stopTracks(propKeys);
            targetPropName && (stateToRestore[targetPropName] = stateToRestore[targetPropName] || {});
            var savedTarget = targetPropName ? stateToRestore[targetPropName] : stateToRestore;
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(propKeys, function(key) {
                // Save original value.
                savedTarget[key] = ((targetPropName ? el[targetPropName] : el) || {})[key];
            });
            animator.whenWithKeys(duration * kf.percent, kfValues, propKeys, kf.easing);
        });
        if (!animator) return;
        animator.delay(animationOpts.delay || 0).duration(duration).start(animationOpts.easing);
    });
}


var $590d5f44e94a6803$var$EMPHASIS = 'emphasis';
var $590d5f44e94a6803$var$NORMAL = 'normal';
var $590d5f44e94a6803$var$BLUR = 'blur';
var $590d5f44e94a6803$var$SELECT = 'select';
var $590d5f44e94a6803$var$STATES = [
    $590d5f44e94a6803$var$NORMAL,
    $590d5f44e94a6803$var$EMPHASIS,
    $590d5f44e94a6803$var$BLUR,
    $590d5f44e94a6803$var$SELECT
];
var $590d5f44e94a6803$var$PATH_ITEM_STYLE = {
    normal: [
        'itemStyle'
    ],
    emphasis: [
        $590d5f44e94a6803$var$EMPHASIS,
        'itemStyle'
    ],
    blur: [
        $590d5f44e94a6803$var$BLUR,
        'itemStyle'
    ],
    select: [
        $590d5f44e94a6803$var$SELECT,
        'itemStyle'
    ]
};
var $590d5f44e94a6803$var$PATH_LABEL = {
    normal: [
        'label'
    ],
    emphasis: [
        $590d5f44e94a6803$var$EMPHASIS,
        'label'
    ],
    blur: [
        $590d5f44e94a6803$var$BLUR,
        'label'
    ],
    select: [
        $590d5f44e94a6803$var$SELECT,
        'label'
    ]
};
var $590d5f44e94a6803$var$DEFAULT_TRANSITION = [
    'x',
    'y'
];
// Use prefix to avoid index to be the same as el.name,
// which will cause weird update animation.
var $590d5f44e94a6803$var$GROUP_DIFF_PREFIX = 'e\0\0';
var $590d5f44e94a6803$var$attachedTxInfoTmp = {
    normal: {},
    emphasis: {},
    blur: {},
    select: {}
};
/**
 * To reduce total package size of each coordinate systems, the modules `prepareCustom`
 * of each coordinate systems are not required by each coordinate systems directly, but
 * required by the module `custom`.
 *
 * prepareInfoForCustomSeries {Function}: optional
 *     @return {Object} {coordSys: {...}, api: {
 *         coord: function (data, clamp) {}, // return point in global.
 *         size: function (dataSize, dataItem) {} // return size of each axis in coordSys.
 *     }}
 */ var $590d5f44e94a6803$var$prepareCustoms = {
    cartesian2d: (0, $eb5b87553d7c5e15$export$2e2bcd8739ae039),
    geo: (0, $db94904ae7a63a7b$export$2e2bcd8739ae039),
    single: (0, $4af7f8b40c63338e$export$2e2bcd8739ae039),
    polar: (0, $5542da7477183ee1$export$2e2bcd8739ae039),
    calendar: (0, $07a38220d20058fb$export$2e2bcd8739ae039)
};
function $590d5f44e94a6803$var$isPath(el) {
    return el instanceof $b02ffe7acd508c08$export$2e2bcd8739ae039;
}
function $590d5f44e94a6803$var$isDisplayable(el) {
    return el instanceof (0, $56206a6cb4666931$export$2e2bcd8739ae039);
}
function $590d5f44e94a6803$var$copyElement(sourceEl, targetEl) {
    targetEl.copyTransform(sourceEl);
    if ($590d5f44e94a6803$var$isDisplayable(targetEl) && $590d5f44e94a6803$var$isDisplayable(sourceEl)) {
        targetEl.setStyle(sourceEl.style);
        targetEl.z = sourceEl.z;
        targetEl.z2 = sourceEl.z2;
        targetEl.zlevel = sourceEl.zlevel;
        targetEl.invisible = sourceEl.invisible;
        targetEl.ignore = sourceEl.ignore;
        if ($590d5f44e94a6803$var$isPath(targetEl) && $590d5f44e94a6803$var$isPath(sourceEl)) targetEl.setShape(sourceEl.shape);
    }
}
var $590d5f44e94a6803$var$CustomChartView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(CustomChartView, _super);
    function CustomChartView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CustomChartView.type;
        return _this;
    }
    CustomChartView.prototype.render = function(customSeries, ecModel, api, payload) {
        // Clear previously rendered progressive elements.
        this._progressiveEls = null;
        var oldData = this._data;
        var data = customSeries.getData();
        var group = this.group;
        var renderItem = $590d5f44e94a6803$var$makeRenderItem(customSeries, data, ecModel, api);
        if (!oldData) // Previous render is incremental render or first render.
        // Needs remove the incremental rendered elements.
        group.removeAll();
        data.diff(oldData).add(function(newIdx) {
            $590d5f44e94a6803$var$createOrUpdateItem(api, null, newIdx, renderItem(newIdx, payload), customSeries, group, data);
        }).remove(function(oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            el && (0, $7c104376a000308e$export$15575b6d82d35bb3)(el, (0, $fef28dd8967d3f1b$export$dd5c3cc86073562f)(el).option, customSeries);
        }).update(function(newIdx, oldIdx) {
            var oldEl = oldData.getItemGraphicEl(oldIdx);
            $590d5f44e94a6803$var$createOrUpdateItem(api, oldEl, newIdx, renderItem(newIdx, payload), customSeries, group, data);
        }).execute();
        // Do clipping
        var clipPath = customSeries.get('clip', true) ? (0, $0e2cc04b3aaad400$export$e0fe5081209d01c9)(customSeries.coordinateSystem, false, customSeries) : null;
        if (clipPath) group.setClipPath(clipPath);
        else group.removeClipPath();
        this._data = data;
    };
    CustomChartView.prototype.incrementalPrepareRender = function(customSeries, ecModel, api) {
        this.group.removeAll();
        this._data = null;
    };
    CustomChartView.prototype.incrementalRender = function(params, customSeries, ecModel, api, payload) {
        var data = customSeries.getData();
        var renderItem = $590d5f44e94a6803$var$makeRenderItem(customSeries, data, ecModel, api);
        var progressiveEls = this._progressiveEls = [];
        function setIncrementalAndHoverLayer(el) {
            if (!el.isGroup) {
                el.incremental = true;
                el.ensureState('emphasis').hoverLayer = true;
            }
        }
        for(var idx = params.start; idx < params.end; idx++){
            var el = $590d5f44e94a6803$var$createOrUpdateItem(null, null, idx, renderItem(idx, payload), customSeries, this.group, data);
            if (el) {
                el.traverse(setIncrementalAndHoverLayer);
                progressiveEls.push(el);
            }
        }
    };
    CustomChartView.prototype.eachRendered = function(cb) {
        $5b455ae6f843ac47$export$3e564442729bf048(this._progressiveEls || this.group, cb);
    };
    CustomChartView.prototype.filterForExposedEvent = function(eventType, query, targetEl, packedEvent) {
        var elementName = query.element;
        if (elementName == null || targetEl.name === elementName) return true;
        // Enable to give a name on a group made by `renderItem`, and listen
        // events that are triggered by its descendents.
        while((targetEl = targetEl.__hostTarget || targetEl.parent) && targetEl !== this.group){
            if (targetEl.name === elementName) return true;
        }
        return false;
    };
    CustomChartView.type = 'custom';
    return CustomChartView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $590d5f44e94a6803$export$2e2bcd8739ae039 = $590d5f44e94a6803$var$CustomChartView;
function $590d5f44e94a6803$var$createEl(elOption) {
    var graphicType = elOption.type;
    var el;
    // Those graphic elements are not shapes. They should not be
    // overwritten by users, so do them first.
    if (graphicType === 'path') {
        var shape = elOption.shape;
        // Using pathRect brings convenience to users sacle svg path.
        var pathRect = shape.width != null && shape.height != null ? {
            x: shape.x || 0,
            y: shape.y || 0,
            width: shape.width,
            height: shape.height
        } : null;
        var pathData = $590d5f44e94a6803$var$getPathData(shape);
        // Path is also used for icon, so layout 'center' by default.
        el = $5b455ae6f843ac47$export$aa9bab72412f5613(pathData, null, pathRect, shape.layout || 'center');
        (0, $fef28dd8967d3f1b$export$dd5c3cc86073562f)(el).customPathData = pathData;
    } else if (graphicType === 'image') {
        el = new $86adec94217b86c6$export$2e2bcd8739ae039({});
        (0, $fef28dd8967d3f1b$export$dd5c3cc86073562f)(el).customImagePath = elOption.style.image;
    } else if (graphicType === 'text') el = new $fe885cc21795562b$export$2e2bcd8739ae039({});
    else if (graphicType === 'group') el = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
    else if (graphicType === 'compoundPath') throw new Error('"compoundPath" is not supported yet.');
    else {
        var Clz = $5b455ae6f843ac47$export$51df4b5565a58189(graphicType);
        if (!Clz) {
            var errMsg = '';
            (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
        }
        el = new Clz();
    }
    (0, $fef28dd8967d3f1b$export$dd5c3cc86073562f)(el).customGraphicType = graphicType;
    el.name = elOption.name;
    // Compat ec4: the default z2 lift is 1. If changing the number,
    // some cases probably be broken: hierarchy layout along z, like circle packing,
    // where emphasis only intending to modify color/border rather than lift z2.
    el.z2EmphasisLift = 1;
    el.z2SelectLift = 1;
    return el;
}
function $590d5f44e94a6803$var$updateElNormal(// Can be null/undefined
api, el, dataIndex, elOption, attachedTxInfo, seriesModel, isInit) {
    // Stop and restore before update any other attributes.
    (0, $ab8d73690f09fb6d$export$9e5c70edf1ec0cb4)(el);
    var txCfgOpt = attachedTxInfo && attachedTxInfo.normal.cfg;
    if (txCfgOpt) // PENDING: whether use user object directly rather than clone?
    // TODO:5.0 textConfig transition animation?
    el.setTextConfig(txCfgOpt);
    // Default transition ['x', 'y']
    if (elOption && elOption.transition == null) elOption.transition = $590d5f44e94a6803$var$DEFAULT_TRANSITION;
    // Do some normalization on style.
    var styleOpt = elOption && elOption.style;
    if (styleOpt) {
        if (el.type === 'text') {
            var textOptionStyle = styleOpt;
            // Compatible with ec4: if `textFill` or `textStroke` exists use them.
            (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(textOptionStyle, 'textFill') && (textOptionStyle.fill = textOptionStyle.textFill);
            (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(textOptionStyle, 'textStroke') && (textOptionStyle.stroke = textOptionStyle.textStroke);
        }
        var decalPattern = void 0;
        var decalObj = $590d5f44e94a6803$var$isPath(el) ? styleOpt.decal : null;
        if (api && decalObj) {
            decalObj.dirty = true;
            decalPattern = (0, $c6d646aacd243427$export$a3ba048e1a648972)(decalObj, api);
        }
        // Always overwrite in case user specify this prop.
        styleOpt.__decalPattern = decalPattern;
    }
    if ($590d5f44e94a6803$var$isDisplayable(el)) {
        if (styleOpt) {
            var decalPattern = styleOpt.__decalPattern;
            if (decalPattern) styleOpt.decal = decalPattern;
        }
    }
    (0, $7c104376a000308e$export$4342b281b9b5d77e)(el, elOption, seriesModel, {
        dataIndex: dataIndex,
        isInit: isInit,
        clearStyle: true
    });
    (0, $ab8d73690f09fb6d$export$b0aa6a5f01693fa4)(el, elOption.keyframeAnimation, seriesModel);
}
function $590d5f44e94a6803$var$updateElOnState(state, el, elStateOpt, styleOpt, attachedTxInfo) {
    var elDisplayable = el.isGroup ? null : el;
    var txCfgOpt = attachedTxInfo && attachedTxInfo[state].cfg;
    // PENDING:5.0 support customize scale change and transition animation?
    if (elDisplayable) {
        // By default support auto lift color when hover whether `emphasis` specified.
        var stateObj = elDisplayable.ensureState(state);
        if (styleOpt === false) {
            var existingEmphasisState = elDisplayable.getState(state);
            if (existingEmphasisState) existingEmphasisState.style = null;
        } else // style is needed to enable default emphasis.
        stateObj.style = styleOpt || null;
        // If `elOption.styleEmphasis` or `elOption.emphasis.style` is `false`,
        // remove hover style.
        // If `elOption.textConfig` or `elOption.emphasis.textConfig` is null/undefined, it does not
        // make sense. So for simplicity, we do not ditinguish `hasOwnProperty` and null/undefined.
        if (txCfgOpt) stateObj.textConfig = txCfgOpt;
        (0, $2bf82c0980125b62$export$20f39bbe322fb9ab)(elDisplayable);
    }
}
function $590d5f44e94a6803$var$updateZ(el, elOption, seriesModel) {
    // Group not support textContent and not support z yet.
    if (el.isGroup) return;
    var elDisplayable = el;
    var currentZ = seriesModel.currentZ;
    var currentZLevel = seriesModel.currentZLevel;
    // Always erase.
    elDisplayable.z = currentZ;
    elDisplayable.zlevel = currentZLevel;
    // z2 must not be null/undefined, otherwise sort error may occur.
    var optZ2 = elOption.z2;
    optZ2 != null && (elDisplayable.z2 = optZ2 || 0);
    for(var i = 0; i < $590d5f44e94a6803$var$STATES.length; i++)$590d5f44e94a6803$var$updateZForEachState(elDisplayable, elOption, $590d5f44e94a6803$var$STATES[i]);
}
function $590d5f44e94a6803$var$updateZForEachState(elDisplayable, elOption, state) {
    var isNormal = state === $590d5f44e94a6803$var$NORMAL;
    var elStateOpt = isNormal ? elOption : $590d5f44e94a6803$var$retrieveStateOption(elOption, state);
    var optZ2 = elStateOpt ? elStateOpt.z2 : null;
    var stateObj;
    if (optZ2 != null) {
        // Do not `ensureState` until required.
        stateObj = isNormal ? elDisplayable : elDisplayable.ensureState(state);
        stateObj.z2 = optZ2 || 0;
    }
}
function $590d5f44e94a6803$var$makeRenderItem(customSeries, data, ecModel, api) {
    var renderItem = customSeries.get('renderItem');
    var coordSys = customSeries.coordinateSystem;
    var prepareResult = {};
    if (coordSys) // `coordSys.prepareCustoms` is used for external coord sys like bmap.
    prepareResult = coordSys.prepareCustoms ? coordSys.prepareCustoms(coordSys) : $590d5f44e94a6803$var$prepareCustoms[coordSys.type](coordSys);
    var userAPI = (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
        getWidth: api.getWidth,
        getHeight: api.getHeight,
        getZr: api.getZr,
        getDevicePixelRatio: api.getDevicePixelRatio,
        value: value,
        style: style,
        ordinalRawValue: ordinalRawValue,
        styleEmphasis: styleEmphasis,
        visual: visual,
        barLayout: barLayout,
        currentSeriesIndices: currentSeriesIndices,
        font: font
    }, prepareResult.api || {});
    var userParams = {
        // The life cycle of context: current round of rendering.
        // The global life cycle is probably not necessary, because
        // user can store global status by themselves.
        context: {},
        seriesId: customSeries.id,
        seriesName: customSeries.name,
        seriesIndex: customSeries.seriesIndex,
        coordSys: prepareResult.coordSys,
        dataInsideLength: data.count(),
        encode: $590d5f44e94a6803$var$wrapEncodeDef(customSeries.getData())
    };
    // If someday intending to refactor them to a class, should consider do not
    // break change: currently these attribute member are encapsulated in a closure
    // so that do not need to force user to call these method with a scope.
    // Do not support call `api` asynchronously without dataIndexInside input.
    var currDataIndexInside;
    var currItemModel;
    var currItemStyleModels = {};
    var currLabelModels = {};
    var seriesItemStyleModels = {};
    var seriesLabelModels = {};
    for(var i = 0; i < $590d5f44e94a6803$var$STATES.length; i++){
        var stateName = $590d5f44e94a6803$var$STATES[i];
        seriesItemStyleModels[stateName] = customSeries.getModel($590d5f44e94a6803$var$PATH_ITEM_STYLE[stateName]);
        seriesLabelModels[stateName] = customSeries.getModel($590d5f44e94a6803$var$PATH_LABEL[stateName]);
    }
    function getItemModel(dataIndexInside) {
        return dataIndexInside === currDataIndexInside ? currItemModel || (currItemModel = data.getItemModel(dataIndexInside)) : data.getItemModel(dataIndexInside);
    }
    function getItemStyleModel(dataIndexInside, state) {
        return !data.hasItemOption ? seriesItemStyleModels[state] : dataIndexInside === currDataIndexInside ? currItemStyleModels[state] || (currItemStyleModels[state] = getItemModel(dataIndexInside).getModel($590d5f44e94a6803$var$PATH_ITEM_STYLE[state])) : getItemModel(dataIndexInside).getModel($590d5f44e94a6803$var$PATH_ITEM_STYLE[state]);
    }
    function getLabelModel(dataIndexInside, state) {
        return !data.hasItemOption ? seriesLabelModels[state] : dataIndexInside === currDataIndexInside ? currLabelModels[state] || (currLabelModels[state] = getItemModel(dataIndexInside).getModel($590d5f44e94a6803$var$PATH_LABEL[state])) : getItemModel(dataIndexInside).getModel($590d5f44e94a6803$var$PATH_LABEL[state]);
    }
    return function(dataIndexInside, payload) {
        currDataIndexInside = dataIndexInside;
        currItemModel = null;
        currItemStyleModels = {};
        currLabelModels = {};
        return renderItem && renderItem((0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
            dataIndexInside: dataIndexInside,
            dataIndex: data.getRawIndex(dataIndexInside),
            // Can be used for optimization when zoom or roam.
            actionType: payload ? payload.type : null
        }, userParams), userAPI);
    };
    /**
   * @public
   * @param dim by default 0.
   * @param dataIndexInside by default `currDataIndexInside`.
   */ function value(dim, dataIndexInside) {
        dataIndexInside == null && (dataIndexInside = currDataIndexInside);
        return data.getStore().get(data.getDimensionIndex(dim || 0), dataIndexInside);
    }
    /**
   * @public
   * @param dim by default 0.
   * @param dataIndexInside by default `currDataIndexInside`.
   */ function ordinalRawValue(dim, dataIndexInside) {
        dataIndexInside == null && (dataIndexInside = currDataIndexInside);
        dim = dim || 0;
        var dimInfo = data.getDimensionInfo(dim);
        if (!dimInfo) {
            var dimIndex = data.getDimensionIndex(dim);
            return dimIndex >= 0 ? data.getStore().get(dimIndex, dataIndexInside) : undefined;
        }
        var val = data.get(dimInfo.name, dataIndexInside);
        var ordinalMeta = dimInfo && dimInfo.ordinalMeta;
        return ordinalMeta ? ordinalMeta.categories[val] : val;
    }
    /**
   * @deprecated The original intention of `api.style` is enable to set itemStyle
   * like other series. But it is not necessary and not easy to give a strict definition
   * of what it returns. And since echarts5 it needs to be make compat work. So
   * deprecates it since echarts5.
   *
   * By default, `visual` is applied to style (to support visualMap).
   * `visual.color` is applied at `fill`. If user want apply visual.color on `stroke`,
   * it can be implemented as:
   * `api.style({stroke: api.visual('color'), fill: null})`;
   *
   * [Compat]: since ec5, RectText has been separated from its hosts el.
   * so `api.style()` will only return the style from `itemStyle` but not handle `label`
   * any more. But `series.label` config is never published in doc.
   * We still compat it in `api.style()`. But not encourage to use it and will still not
   * to pulish it to doc.
   * @public
   * @param dataIndexInside by default `currDataIndexInside`.
   */ function style(userProps, dataIndexInside) {
        dataIndexInside == null && (dataIndexInside = currDataIndexInside);
        var style = data.getItemVisual(dataIndexInside, 'style');
        var visualColor = style && style.fill;
        var opacity = style && style.opacity;
        var itemStyle = getItemStyleModel(dataIndexInside, $590d5f44e94a6803$var$NORMAL).getItemStyle();
        visualColor != null && (itemStyle.fill = visualColor);
        opacity != null && (itemStyle.opacity = opacity);
        var opt = {
            inheritColor: (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(visualColor) ? visualColor : '#000'
        };
        var labelModel = getLabelModel(dataIndexInside, $590d5f44e94a6803$var$NORMAL);
        // Now that the feature of "auto adjust text fill/stroke" has been migrated to zrender
        // since ec5, we should set `isAttached` as `false` here and make compat in
        // `convertToEC4StyleForCustomSerise`.
        var textStyle = $6800dfcb6e1e2a44$export$f8998c3d0a13de59(labelModel, null, opt, false, true);
        textStyle.text = labelModel.getShallow('show') ? (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(customSeries.getFormattedLabel(dataIndexInside, $590d5f44e94a6803$var$NORMAL), (0, $b2475f850d3c0bc2$export$5ff20667590927ed)(data, dataIndexInside)) : null;
        var textConfig = $6800dfcb6e1e2a44$export$e149afab8df6e053(labelModel, opt, false);
        preFetchFromExtra(userProps, itemStyle);
        itemStyle = (0, $daa53642c3afcc30$export$b8ddb75bd1b9b791)(itemStyle, textStyle, textConfig);
        userProps && applyUserPropsAfter(itemStyle, userProps);
        itemStyle.legacy = true;
        return itemStyle;
    }
    /**
   * @deprecated The reason see `api.style()`
   * @public
   * @param dataIndexInside by default `currDataIndexInside`.
   */ function styleEmphasis(userProps, dataIndexInside) {
        dataIndexInside == null && (dataIndexInside = currDataIndexInside);
        var itemStyle = getItemStyleModel(dataIndexInside, $590d5f44e94a6803$var$EMPHASIS).getItemStyle();
        var labelModel = getLabelModel(dataIndexInside, $590d5f44e94a6803$var$EMPHASIS);
        var textStyle = $6800dfcb6e1e2a44$export$f8998c3d0a13de59(labelModel, null, null, true, true);
        textStyle.text = labelModel.getShallow('show') ? (0, $7a1bd9c2710fea0d$export$2e94551289abb95b)(customSeries.getFormattedLabel(dataIndexInside, $590d5f44e94a6803$var$EMPHASIS), customSeries.getFormattedLabel(dataIndexInside, $590d5f44e94a6803$var$NORMAL), (0, $b2475f850d3c0bc2$export$5ff20667590927ed)(data, dataIndexInside)) : null;
        var textConfig = $6800dfcb6e1e2a44$export$e149afab8df6e053(labelModel, null, true);
        preFetchFromExtra(userProps, itemStyle);
        itemStyle = (0, $daa53642c3afcc30$export$b8ddb75bd1b9b791)(itemStyle, textStyle, textConfig);
        userProps && applyUserPropsAfter(itemStyle, userProps);
        itemStyle.legacy = true;
        return itemStyle;
    }
    function applyUserPropsAfter(itemStyle, extra) {
        for(var key in extra)if ((0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(extra, key)) itemStyle[key] = extra[key];
    }
    function preFetchFromExtra(extra, itemStyle) {
        // A trick to retrieve those props firstly, which are used to
        // apply auto inside fill/stroke in `convertToEC4StyleForCustomSerise`.
        // (It's not reasonable but only for a degree of compat)
        if (extra) {
            extra.textFill && (itemStyle.textFill = extra.textFill);
            extra.textPosition && (itemStyle.textPosition = extra.textPosition);
        }
    }
    /**
   * @public
   * @param dataIndexInside by default `currDataIndexInside`.
   */ function visual(visualType, dataIndexInside) {
        dataIndexInside == null && (dataIndexInside = currDataIndexInside);
        if ((0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)((0, $fef28dd8967d3f1b$export$84369c8e2229fa7f), visualType)) {
            var style_1 = data.getItemVisual(dataIndexInside, 'style');
            return style_1 ? style_1[(0, $fef28dd8967d3f1b$export$84369c8e2229fa7f)[visualType]] : null;
        }
        // Only support these visuals. Other visual might be inner tricky
        // for performance (like `style`), do not expose to users.
        if ((0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)((0, $fef28dd8967d3f1b$export$734d775a14929701), visualType)) return data.getItemVisual(dataIndexInside, visualType);
    }
    /**
   * @public
   * @return If not support, return undefined.
   */ function barLayout(opt) {
        if (coordSys.type === 'cartesian2d') {
            var baseAxis = coordSys.getBaseAxis();
            return (0, $361c48dd900de28f$export$658df087977b9e84)((0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
                axis: baseAxis
            }, opt));
        }
    }
    /**
   * @public
   */ function currentSeriesIndices() {
        return ecModel.getCurrentSeriesIndices();
    }
    /**
   * @public
   * @return font string
   */ function font(opt) {
        return $6800dfcb6e1e2a44$export$155316a870a9d61e(opt, ecModel);
    }
}
function $590d5f44e94a6803$var$wrapEncodeDef(data) {
    var encodeDef = {};
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(data.dimensions, function(dimName) {
        var dimInfo = data.getDimensionInfo(dimName);
        if (!dimInfo.isExtraCoord) {
            var coordDim = dimInfo.coordDim;
            var dataDims = encodeDef[coordDim] = encodeDef[coordDim] || [];
            dataDims[dimInfo.coordDimIndex] = data.getDimensionIndex(dimName);
        }
    });
    return encodeDef;
}
function $590d5f44e94a6803$var$createOrUpdateItem(api, existsEl, dataIndex, elOption, seriesModel, group, data) {
    // [Rule]
    // If `renderItem` returns `null`/`undefined`/`false`, remove the previous el if existing.
    //     (It seems that violate the "merge" principle, but most of users probably intuitively
    //     regard "return;" as "show nothing element whatever", so make a exception to meet the
    //     most cases.)
    // The rule or "merge" see [STRATEGY_MERGE].
    // If `elOption` is `null`/`undefined`/`false` (when `renderItem` returns nothing).
    if (!elOption) {
        group.remove(existsEl);
        return;
    }
    var el = $590d5f44e94a6803$var$doCreateOrUpdateEl(api, existsEl, dataIndex, elOption, seriesModel, group);
    el && data.setItemGraphicEl(dataIndex, el);
    el && (0, $2bf82c0980125b62$export$e51187539ff11209)(el, elOption.focus, elOption.blurScope, elOption.emphasisDisabled);
    return el;
}
function $590d5f44e94a6803$var$doCreateOrUpdateEl(api, existsEl, dataIndex, elOption, seriesModel, group) {
    var toBeReplacedIdx = -1;
    var oldEl = existsEl;
    if (existsEl && $590d5f44e94a6803$var$doesElNeedRecreate(existsEl, elOption, seriesModel)) {
        // Should keep at the original index, otherwise "merge by index" will be incorrect.
        toBeReplacedIdx = (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(group.childrenRef(), existsEl);
        existsEl = null;
    }
    var isInit = !existsEl;
    var el = existsEl;
    if (!el) {
        el = $590d5f44e94a6803$var$createEl(elOption);
        if (oldEl) $590d5f44e94a6803$var$copyElement(oldEl, el);
    } else // FIMXE:NEXT unified clearState?
    // If in some case the performance issue arised, consider
    // do not clearState but update cached normal state directly.
    el.clearStates();
    // Need to set morph: false explictly to disable automatically morphing.
    if (elOption.morph === false) el.disableMorphing = true;
    else if (el.disableMorphing) el.disableMorphing = false;
    $590d5f44e94a6803$var$attachedTxInfoTmp.normal.cfg = $590d5f44e94a6803$var$attachedTxInfoTmp.normal.conOpt = $590d5f44e94a6803$var$attachedTxInfoTmp.emphasis.cfg = $590d5f44e94a6803$var$attachedTxInfoTmp.emphasis.conOpt = $590d5f44e94a6803$var$attachedTxInfoTmp.blur.cfg = $590d5f44e94a6803$var$attachedTxInfoTmp.blur.conOpt = $590d5f44e94a6803$var$attachedTxInfoTmp.select.cfg = $590d5f44e94a6803$var$attachedTxInfoTmp.select.conOpt = null;
    $590d5f44e94a6803$var$attachedTxInfoTmp.isLegacy = false;
    $590d5f44e94a6803$var$doCreateOrUpdateAttachedTx(el, dataIndex, elOption, seriesModel, isInit, $590d5f44e94a6803$var$attachedTxInfoTmp);
    $590d5f44e94a6803$var$doCreateOrUpdateClipPath(el, dataIndex, elOption, seriesModel, isInit);
    $590d5f44e94a6803$var$updateElNormal(api, el, dataIndex, elOption, $590d5f44e94a6803$var$attachedTxInfoTmp, seriesModel, isInit);
    // `elOption.info` enables user to mount some info on
    // elements and use them in event handlers.
    // Update them only when user specified, otherwise, remain.
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(elOption, 'info') && ((0, $fef28dd8967d3f1b$export$dd5c3cc86073562f)(el).info = elOption.info);
    for(var i = 0; i < $590d5f44e94a6803$var$STATES.length; i++){
        var stateName = $590d5f44e94a6803$var$STATES[i];
        if (stateName !== $590d5f44e94a6803$var$NORMAL) {
            var otherStateOpt = $590d5f44e94a6803$var$retrieveStateOption(elOption, stateName);
            var otherStyleOpt = $590d5f44e94a6803$var$retrieveStyleOptionOnState(elOption, otherStateOpt, stateName);
            $590d5f44e94a6803$var$updateElOnState(stateName, el, otherStateOpt, otherStyleOpt, $590d5f44e94a6803$var$attachedTxInfoTmp);
        }
    }
    $590d5f44e94a6803$var$updateZ(el, elOption, seriesModel);
    if (elOption.type === 'group') $590d5f44e94a6803$var$mergeChildren(api, el, dataIndex, elOption, seriesModel);
    if (toBeReplacedIdx >= 0) group.replaceAt(el, toBeReplacedIdx);
    else group.add(el);
    return el;
}
// `el` must not be null/undefined.
function $590d5f44e94a6803$var$doesElNeedRecreate(el, elOption, seriesModel) {
    var elInner = (0, $fef28dd8967d3f1b$export$dd5c3cc86073562f)(el);
    var elOptionType = elOption.type;
    var elOptionShape = elOption.shape;
    var elOptionStyle = elOption.style;
    return(// Always create new if universal transition is enabled.
    // Because we do transition after render. It needs to know what old element is. Replacement will loose it.
    seriesModel.isUniversalTransitionEnabled() || elOptionType != null && elOptionType !== elInner.customGraphicType || elOptionType === 'path' && $590d5f44e94a6803$var$hasOwnPathData(elOptionShape) && $590d5f44e94a6803$var$getPathData(elOptionShape) !== elInner.customPathData || elOptionType === 'image' && (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(elOptionStyle, 'image') && elOptionStyle.image !== elInner.customImagePath);
}
function $590d5f44e94a6803$var$doCreateOrUpdateClipPath(el, dataIndex, elOption, seriesModel, isInit) {
    // Based on the "merge" principle, if no clipPath provided,
    // do nothing. The exists clip will be totally removed only if
    // `el.clipPath` is `false`. Otherwise it will be merged/replaced.
    var clipPathOpt = elOption.clipPath;
    if (clipPathOpt === false) {
        if (el && el.getClipPath()) el.removeClipPath();
    } else if (clipPathOpt) {
        var clipPath = el.getClipPath();
        if (clipPath && $590d5f44e94a6803$var$doesElNeedRecreate(clipPath, clipPathOpt, seriesModel)) clipPath = null;
        if (!clipPath) {
            clipPath = $590d5f44e94a6803$var$createEl(clipPathOpt);
            el.setClipPath(clipPath);
        }
        $590d5f44e94a6803$var$updateElNormal(null, clipPath, dataIndex, clipPathOpt, null, seriesModel, isInit);
    }
// If not define `clipPath` in option, do nothing unnecessary.
}
function $590d5f44e94a6803$var$doCreateOrUpdateAttachedTx(el, dataIndex, elOption, seriesModel, isInit, attachedTxInfo) {
    // Group does not support textContent temporarily until necessary.
    if (el.isGroup) return;
    // Normal must be called before emphasis, for `isLegacy` detection.
    $590d5f44e94a6803$var$processTxInfo(elOption, null, attachedTxInfo);
    $590d5f44e94a6803$var$processTxInfo(elOption, $590d5f44e94a6803$var$EMPHASIS, attachedTxInfo);
    // If `elOption.textConfig` or `elOption.textContent` is null/undefined, it does not make sense.
    // So for simplicity, if "elOption hasOwnProperty of them but be null/undefined", we do not
    // trade them as set to null to el.
    // Especially:
    // `elOption.textContent: false` means remove textContent.
    // `elOption.textContent.emphasis.style: false` means remove the style from emphasis state.
    var txConOptNormal = attachedTxInfo.normal.conOpt;
    var txConOptEmphasis = attachedTxInfo.emphasis.conOpt;
    var txConOptBlur = attachedTxInfo.blur.conOpt;
    var txConOptSelect = attachedTxInfo.select.conOpt;
    if (txConOptNormal != null || txConOptEmphasis != null || txConOptSelect != null || txConOptBlur != null) {
        var textContent = el.getTextContent();
        if (txConOptNormal === false) textContent && el.removeTextContent();
        else {
            txConOptNormal = attachedTxInfo.normal.conOpt = txConOptNormal || {
                type: 'text'
            };
            if (!textContent) {
                textContent = $590d5f44e94a6803$var$createEl(txConOptNormal);
                el.setTextContent(textContent);
            } else // If in some case the performance issue arised, consider
            // do not clearState but update cached normal state directly.
            textContent.clearStates();
            $590d5f44e94a6803$var$updateElNormal(null, textContent, dataIndex, txConOptNormal, null, seriesModel, isInit);
            var txConStlOptNormal = txConOptNormal && txConOptNormal.style;
            for(var i = 0; i < $590d5f44e94a6803$var$STATES.length; i++){
                var stateName = $590d5f44e94a6803$var$STATES[i];
                if (stateName !== $590d5f44e94a6803$var$NORMAL) {
                    var txConOptOtherState = attachedTxInfo[stateName].conOpt;
                    $590d5f44e94a6803$var$updateElOnState(stateName, textContent, txConOptOtherState, $590d5f44e94a6803$var$retrieveStyleOptionOnState(txConOptNormal, txConOptOtherState, stateName), null);
                }
            }
            txConStlOptNormal ? textContent.dirty() : textContent.markRedraw();
        }
    }
}
function $590d5f44e94a6803$var$processTxInfo(elOption, state, attachedTxInfo) {
    var stateOpt = !state ? elOption : $590d5f44e94a6803$var$retrieveStateOption(elOption, state);
    var styleOpt = !state ? elOption.style : $590d5f44e94a6803$var$retrieveStyleOptionOnState(elOption, stateOpt, $590d5f44e94a6803$var$EMPHASIS);
    var elType = elOption.type;
    var txCfg = stateOpt ? stateOpt.textConfig : null;
    var txConOptNormal = elOption.textContent;
    var txConOpt = !txConOptNormal ? null : !state ? txConOptNormal : $590d5f44e94a6803$var$retrieveStateOption(txConOptNormal, state);
    if (styleOpt && // Because emphasis style has little info to detect legacy,
    // if normal is legacy, emphasis is trade as legacy.
    (attachedTxInfo.isLegacy || (0, $daa53642c3afcc30$export$3b868abde5eae7d1)(styleOpt, elType, !!txCfg, !!txConOpt))) {
        attachedTxInfo.isLegacy = true;
        var convertResult = (0, $daa53642c3afcc30$export$7748133eaaa8aecc)(styleOpt, elType, !state);
        // Explicitly specified `textConfig` and `textContent` has higher priority than
        // the ones generated by legacy style. Otherwise if users use them and `api.style`
        // at the same time, they not both work and hardly to known why.
        if (!txCfg && convertResult.textConfig) txCfg = convertResult.textConfig;
        if (!txConOpt && convertResult.textContent) txConOpt = convertResult.textContent;
    }
    if (!state && txConOpt) {
        var txConOptNormal_1 = txConOpt;
        // `textContent: {type: 'text'}`, the "type" is easy to be missing. So we tolerate it.
        !txConOptNormal_1.type && (txConOptNormal_1.type = 'text');
    }
    var info = !state ? attachedTxInfo.normal : attachedTxInfo[state];
    info.cfg = txCfg;
    info.conOpt = txConOpt;
}
function $590d5f44e94a6803$var$retrieveStateOption(elOption, state) {
    return !state ? elOption : elOption ? elOption[state] : null;
}
function $590d5f44e94a6803$var$retrieveStyleOptionOnState(stateOptionNormal, stateOption, state) {
    var style = stateOption && stateOption.style;
    if (style == null && state === $590d5f44e94a6803$var$EMPHASIS && stateOptionNormal) style = stateOptionNormal.styleEmphasis;
    return style;
}
// Usage:
// (1) By default, `elOption.$mergeChildren` is `'byIndex'`, which indicates
//     that the existing children will not be removed, and enables the feature
//     that update some of the props of some of the children simply by construct
//     the returned children of `renderItem` like:
//     `var children = group.children = []; children[3] = {opacity: 0.5};`
// (2) If `elOption.$mergeChildren` is `'byName'`, add/update/remove children
//     by child.name. But that might be lower performance.
// (3) If `elOption.$mergeChildren` is `false`, the existing children will be
//     replaced totally.
// (4) If `!elOption.children`, following the "merge" principle, nothing will
//     happen.
// (5) If `elOption.$mergeChildren` is not `false` neither `'byName'` and the
//     `el` is a group, and if any of the new child is null, it means to remove
//     the element at the same index, if exists. On the other hand, if the new
//     child is and empty object `{}`, it means to keep the element not changed.
//
// For implementation simpleness, do not provide a direct way to remove single
// child (otherwise the total indices of the children array have to be modified).
// User can remove a single child by setting its `ignore` to `true`.
function $590d5f44e94a6803$var$mergeChildren(api, el, dataIndex, elOption, seriesModel) {
    var newChildren = elOption.children;
    var newLen = newChildren ? newChildren.length : 0;
    var mergeChildren = elOption.$mergeChildren;
    // `diffChildrenByName` has been deprecated.
    var byName = mergeChildren === 'byName' || elOption.diffChildrenByName;
    var notMerge = mergeChildren === false;
    // For better performance on roam update, only enter if necessary.
    if (!newLen && !byName && !notMerge) return;
    if (byName) {
        $590d5f44e94a6803$var$diffGroupChildren({
            api: api,
            oldChildren: el.children() || [],
            newChildren: newChildren || [],
            dataIndex: dataIndex,
            seriesModel: seriesModel,
            group: el
        });
        return;
    }
    notMerge && el.removeAll();
    // Mapping children of a group simply by index, which
    // might be better performance.
    var index = 0;
    for(; index < newLen; index++){
        var newChild = newChildren[index];
        var oldChild = el.childAt(index);
        if (newChild) {
            if (newChild.ignore == null) // The old child is set to be ignored if null (see comments
            // below). So we need to set ignore to be false back.
            newChild.ignore = false;
            $590d5f44e94a6803$var$doCreateOrUpdateEl(api, oldChild, dataIndex, newChild, seriesModel, el);
        } else // If the new element option is null, it means to remove the old
        // element. But we cannot really remove the element from the group
        // directly, because the element order may not be stable when this
        // element is added back. So we set the element to be ignored.
        oldChild.ignore = true;
    }
    for(var i = el.childCount() - 1; i >= index; i--){
        var child = el.childAt(i);
        $590d5f44e94a6803$var$removeChildFromGroup(el, child, seriesModel);
    }
}
function $590d5f44e94a6803$var$removeChildFromGroup(group, child, seriesModel) {
    // Do not support leave elements that are not mentioned in the latest
    // `renderItem` return. Otherwise users may not have a clear and simple
    // concept that how to control all of the elements.
    child && (0, $7c104376a000308e$export$15575b6d82d35bb3)(child, (0, $fef28dd8967d3f1b$export$dd5c3cc86073562f)(group).option, seriesModel);
}
function $590d5f44e94a6803$var$diffGroupChildren(context) {
    new (0, $306d1c87baff8a10$export$2e2bcd8739ae039)(context.oldChildren, context.newChildren, $590d5f44e94a6803$var$getKey, $590d5f44e94a6803$var$getKey, context).add($590d5f44e94a6803$var$processAddUpdate).update($590d5f44e94a6803$var$processAddUpdate).remove($590d5f44e94a6803$var$processRemove).execute();
}
function $590d5f44e94a6803$var$getKey(item, idx) {
    var name = item && item.name;
    return name != null ? name : $590d5f44e94a6803$var$GROUP_DIFF_PREFIX + idx;
}
function $590d5f44e94a6803$var$processAddUpdate(newIndex, oldIndex) {
    var context = this.context;
    var childOption = newIndex != null ? context.newChildren[newIndex] : null;
    var child = oldIndex != null ? context.oldChildren[oldIndex] : null;
    $590d5f44e94a6803$var$doCreateOrUpdateEl(context.api, child, context.dataIndex, childOption, context.seriesModel, context.group);
}
function $590d5f44e94a6803$var$processRemove(oldIndex) {
    var context = this.context;
    var child = context.oldChildren[oldIndex];
    child && (0, $7c104376a000308e$export$15575b6d82d35bb3)(child, (0, $fef28dd8967d3f1b$export$dd5c3cc86073562f)(child).option, context.seriesModel);
}
/**
 * @return SVG Path data.
 */ function $590d5f44e94a6803$var$getPathData(shape) {
    // "d" follows the SVG convention.
    return shape && (shape.pathData || shape.d);
}
function $590d5f44e94a6803$var$hasOwnPathData(shape) {
    return shape && ((0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(shape, 'pathData') || (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(shape, 'd'));
}


function $3fd02cf8c6a1578a$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $590d5f44e94a6803$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $fef28dd8967d3f1b$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 









var $b1d9c3e17ccace80$var$Symbol = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(Symbol, _super);
    function Symbol(data, idx, seriesScope, opts) {
        var _this = _super.call(this) || this;
        _this.updateData(data, idx, seriesScope, opts);
        return _this;
    }
    Symbol.prototype._createSymbol = function(symbolType, data, idx, symbolSize, keepAspect) {
        // Remove paths created before
        this.removeAll();
        // let symbolPath = createSymbol(
        //     symbolType, -0.5, -0.5, 1, 1, color
        // );
        // If width/height are set too small (e.g., set to 1) on ios10
        // and macOS Sierra, a circle stroke become a rect, no matter what
        // the scale is set. So we set width/height as 2. See #4150.
        var symbolPath = (0, $5370466dadc978d7$export$af050e04da3a02e8)(symbolType, -1, -1, 2, 2, null, keepAspect);
        symbolPath.attr({
            z2: 100,
            culling: true,
            scaleX: symbolSize[0] / 2,
            scaleY: symbolSize[1] / 2
        });
        // Rewrite drift method
        symbolPath.drift = $b1d9c3e17ccace80$var$driftSymbol;
        this._symbolType = symbolType;
        this.add(symbolPath);
    };
    /**
   * Stop animation
   * @param {boolean} toLastFrame
   */ Symbol.prototype.stopSymbolAnimation = function(toLastFrame) {
        this.childAt(0).stopAnimation(null, toLastFrame);
    };
    Symbol.prototype.getSymbolType = function() {
        return this._symbolType;
    };
    /**
   * FIXME:
   * Caution: This method breaks the encapsulation of this module,
   * but it indeed brings convenience. So do not use the method
   * unless you detailedly know all the implements of `Symbol`,
   * especially animation.
   *
   * Get symbol path element.
   */ Symbol.prototype.getSymbolPath = function() {
        return this.childAt(0);
    };
    /**
   * Highlight symbol
   */ Symbol.prototype.highlight = function() {
        (0, $2bf82c0980125b62$export$b2d02638cc34c042)(this.childAt(0));
    };
    /**
   * Downplay symbol
   */ Symbol.prototype.downplay = function() {
        (0, $2bf82c0980125b62$export$11be6f716239ac55)(this.childAt(0));
    };
    /**
   * @param {number} zlevel
   * @param {number} z
   */ Symbol.prototype.setZ = function(zlevel, z) {
        var symbolPath = this.childAt(0);
        symbolPath.zlevel = zlevel;
        symbolPath.z = z;
    };
    Symbol.prototype.setDraggable = function(draggable, hasCursorOption) {
        var symbolPath = this.childAt(0);
        symbolPath.draggable = draggable;
        symbolPath.cursor = !hasCursorOption && draggable ? 'move' : symbolPath.cursor;
    };
    /**
   * Update symbol properties
   */ Symbol.prototype.updateData = function(data, idx, seriesScope, opts) {
        this.silent = false;
        var symbolType = data.getItemVisual(idx, 'symbol') || 'circle';
        var seriesModel = data.hostModel;
        var symbolSize = Symbol.getSymbolSize(data, idx);
        var isInit = symbolType !== this._symbolType;
        var disableAnimation = opts && opts.disableAnimation;
        if (isInit) {
            var keepAspect = data.getItemVisual(idx, 'symbolKeepAspect');
            this._createSymbol(symbolType, data, idx, symbolSize, keepAspect);
        } else {
            var symbolPath = this.childAt(0);
            symbolPath.silent = false;
            var target = {
                scaleX: symbolSize[0] / 2,
                scaleY: symbolSize[1] / 2
            };
            disableAnimation ? symbolPath.attr(target) : $8b353638fbedfefa$export$c8dce3c08436e91e(symbolPath, target, seriesModel, idx);
            (0, $8b353638fbedfefa$export$bca7290a9faf0ec9)(symbolPath);
        }
        this._updateCommon(data, idx, symbolSize, seriesScope, opts);
        if (isInit) {
            var symbolPath = this.childAt(0);
            if (!disableAnimation) {
                var target = {
                    scaleX: this._sizeX,
                    scaleY: this._sizeY,
                    style: {
                        // Always fadeIn. Because it has fadeOut animation when symbol is removed..
                        opacity: symbolPath.style.opacity
                    }
                };
                symbolPath.scaleX = symbolPath.scaleY = 0;
                symbolPath.style.opacity = 0;
                $8b353638fbedfefa$export$a121566aadcfe021(symbolPath, target, seriesModel, idx);
            }
        }
        if (disableAnimation) // Must stop leave transition manually if don't call initProps or updateProps.
        this.childAt(0).stopAnimation('leave');
    };
    Symbol.prototype._updateCommon = function(data, idx, symbolSize, seriesScope, opts) {
        var symbolPath = this.childAt(0);
        var seriesModel = data.hostModel;
        var emphasisItemStyle;
        var blurItemStyle;
        var selectItemStyle;
        var focus;
        var blurScope;
        var emphasisDisabled;
        var labelStatesModels;
        var hoverScale;
        var cursorStyle;
        if (seriesScope) {
            emphasisItemStyle = seriesScope.emphasisItemStyle;
            blurItemStyle = seriesScope.blurItemStyle;
            selectItemStyle = seriesScope.selectItemStyle;
            focus = seriesScope.focus;
            blurScope = seriesScope.blurScope;
            labelStatesModels = seriesScope.labelStatesModels;
            hoverScale = seriesScope.hoverScale;
            cursorStyle = seriesScope.cursorStyle;
            emphasisDisabled = seriesScope.emphasisDisabled;
        }
        if (!seriesScope || data.hasItemOption) {
            var itemModel = seriesScope && seriesScope.itemModel ? seriesScope.itemModel : data.getItemModel(idx);
            var emphasisModel = itemModel.getModel('emphasis');
            emphasisItemStyle = emphasisModel.getModel('itemStyle').getItemStyle();
            selectItemStyle = itemModel.getModel([
                'select',
                'itemStyle'
            ]).getItemStyle();
            blurItemStyle = itemModel.getModel([
                'blur',
                'itemStyle'
            ]).getItemStyle();
            focus = emphasisModel.get('focus');
            blurScope = emphasisModel.get('blurScope');
            emphasisDisabled = emphasisModel.get('disabled');
            labelStatesModels = (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(itemModel);
            hoverScale = emphasisModel.getShallow('scale');
            cursorStyle = itemModel.getShallow('cursor');
        }
        var symbolRotate = data.getItemVisual(idx, 'symbolRotate');
        symbolPath.attr('rotation', (symbolRotate || 0) * Math.PI / 180 || 0);
        var symbolOffset = (0, $5370466dadc978d7$export$e3e292895c033f6d)(data.getItemVisual(idx, 'symbolOffset'), symbolSize);
        if (symbolOffset) {
            symbolPath.x = symbolOffset[0];
            symbolPath.y = symbolOffset[1];
        }
        cursorStyle && symbolPath.attr('cursor', cursorStyle);
        var symbolStyle = data.getItemVisual(idx, 'style');
        var visualColor = symbolStyle.fill;
        if (symbolPath instanceof (0, $86adec94217b86c6$export$2e2bcd8739ae039)) {
            var pathStyle = symbolPath.style;
            symbolPath.useStyle((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
                // TODO other properties like x, y ?
                image: pathStyle.image,
                x: pathStyle.x,
                y: pathStyle.y,
                width: pathStyle.width,
                height: pathStyle.height
            }, symbolStyle));
        } else {
            if (symbolPath.__isEmptyBrush) // fill and stroke will be swapped if it's empty.
            // So we cloned a new style to avoid it affecting the original style in visual storage.
            // TODO Better implementation. No empty logic!
            symbolPath.useStyle((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, symbolStyle));
            else symbolPath.useStyle(symbolStyle);
            // Disable decal because symbol scale will been applied on the decal.
            symbolPath.style.decal = null;
            symbolPath.setColor(visualColor, opts && opts.symbolInnerColor);
            symbolPath.style.strokeNoScale = true;
        }
        var liftZ = data.getItemVisual(idx, 'liftZ');
        var z2Origin = this._z2;
        if (liftZ != null) {
            if (z2Origin == null) {
                this._z2 = symbolPath.z2;
                symbolPath.z2 += liftZ;
            }
        } else if (z2Origin != null) {
            symbolPath.z2 = z2Origin;
            this._z2 = null;
        }
        var useNameLabel = opts && opts.useNameLabel;
        (0, $6800dfcb6e1e2a44$export$9a13992917966657)(symbolPath, labelStatesModels, {
            labelFetcher: seriesModel,
            labelDataIndex: idx,
            defaultText: getLabelDefaultText,
            inheritColor: visualColor,
            defaultOpacity: symbolStyle.opacity
        });
        // Do not execute util needed.
        function getLabelDefaultText(idx) {
            return useNameLabel ? data.getName(idx) : (0, $b2475f850d3c0bc2$export$5ff20667590927ed)(data, idx);
        }
        this._sizeX = symbolSize[0] / 2;
        this._sizeY = symbolSize[1] / 2;
        var emphasisState = symbolPath.ensureState('emphasis');
        emphasisState.style = emphasisItemStyle;
        symbolPath.ensureState('select').style = selectItemStyle;
        symbolPath.ensureState('blur').style = blurItemStyle;
        // null / undefined / true means to use default strategy.
        // 0 / false / negative number / NaN / Infinity means no scale.
        var scaleRatio = hoverScale == null || hoverScale === true ? Math.max(1.1, 3 / this._sizeY) : isFinite(hoverScale) && hoverScale > 0 ? +hoverScale : 1;
        // always set scale to allow resetting
        emphasisState.scaleX = this._sizeX * scaleRatio;
        emphasisState.scaleY = this._sizeY * scaleRatio;
        this.setSymbolScale(1);
        (0, $2bf82c0980125b62$export$e51187539ff11209)(this, focus, blurScope, emphasisDisabled);
    };
    Symbol.prototype.setSymbolScale = function(scale) {
        this.scaleX = this.scaleY = scale;
    };
    Symbol.prototype.fadeOut = function(cb, seriesModel, opt) {
        var symbolPath = this.childAt(0);
        var dataIndex = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(this).dataIndex;
        var animationOpt = opt && opt.animation;
        // Avoid mistaken hover when fading out
        this.silent = symbolPath.silent = true;
        // Not show text when animating
        if (opt && opt.fadeLabel) {
            var textContent = symbolPath.getTextContent();
            if (textContent) $8b353638fbedfefa$export$f883456a56996078(textContent, {
                style: {
                    opacity: 0
                }
            }, seriesModel, {
                dataIndex: dataIndex,
                removeOpt: animationOpt,
                cb: function() {
                    symbolPath.removeTextContent();
                }
            });
        } else symbolPath.removeTextContent();
        $8b353638fbedfefa$export$f883456a56996078(symbolPath, {
            style: {
                opacity: 0
            },
            scaleX: 0,
            scaleY: 0
        }, seriesModel, {
            dataIndex: dataIndex,
            cb: cb,
            removeOpt: animationOpt
        });
    };
    Symbol.getSymbolSize = function(data, idx) {
        return (0, $5370466dadc978d7$export$a84524f03e8e8dfb)(data.getItemVisual(idx, 'symbolSize'));
    };
    return Symbol;
}($7ef7583d8302ffce$export$2e2bcd8739ae039);
function $b1d9c3e17ccace80$var$driftSymbol(dx, dy) {
    this.parent.drift(dx, dy);
}
var $b1d9c3e17ccace80$export$2e2bcd8739ae039 = $b1d9c3e17ccace80$var$Symbol;




function $fedf62268297fcbb$var$symbolNeedsDraw(data, point, idx, opt) {
    return point && !isNaN(point[0]) && !isNaN(point[1]) && !(opt.isIgnore && opt.isIgnore(idx)) && !(opt.clipShape && !opt.clipShape.contain(point[0], point[1])) && data.getItemVisual(idx, 'symbol') !== 'none';
}
function $fedf62268297fcbb$var$normalizeUpdateOpt(opt) {
    if (opt != null && !(0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(opt)) opt = {
        isIgnore: opt
    };
    return opt || {};
}
function $fedf62268297fcbb$var$makeSeriesScope(data) {
    var seriesModel = data.hostModel;
    var emphasisModel = seriesModel.getModel('emphasis');
    return {
        emphasisItemStyle: emphasisModel.getModel('itemStyle').getItemStyle(),
        blurItemStyle: seriesModel.getModel([
            'blur',
            'itemStyle'
        ]).getItemStyle(),
        selectItemStyle: seriesModel.getModel([
            'select',
            'itemStyle'
        ]).getItemStyle(),
        focus: emphasisModel.get('focus'),
        blurScope: emphasisModel.get('blurScope'),
        emphasisDisabled: emphasisModel.get('disabled'),
        hoverScale: emphasisModel.get('scale'),
        labelStatesModels: (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(seriesModel),
        cursorStyle: seriesModel.get('cursor')
    };
}
var $fedf62268297fcbb$var$SymbolDraw = /** @class */ function() {
    function SymbolDraw(SymbolCtor) {
        this.group = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        this._SymbolCtor = SymbolCtor || (0, $b1d9c3e17ccace80$export$2e2bcd8739ae039);
    }
    /**
   * Update symbols draw by new data
   */ SymbolDraw.prototype.updateData = function(data, opt) {
        // Remove progressive els.
        this._progressiveEls = null;
        opt = $fedf62268297fcbb$var$normalizeUpdateOpt(opt);
        var group = this.group;
        var seriesModel = data.hostModel;
        var oldData = this._data;
        var SymbolCtor = this._SymbolCtor;
        var disableAnimation = opt.disableAnimation;
        var seriesScope = $fedf62268297fcbb$var$makeSeriesScope(data);
        var symbolUpdateOpt = {
            disableAnimation: disableAnimation
        };
        var getSymbolPoint = opt.getSymbolPoint || function(idx) {
            return data.getItemLayout(idx);
        };
        // There is no oldLineData only when first rendering or switching from
        // stream mode to normal mode, where previous elements should be removed.
        if (!oldData) group.removeAll();
        data.diff(oldData).add(function(newIdx) {
            var point = getSymbolPoint(newIdx);
            if ($fedf62268297fcbb$var$symbolNeedsDraw(data, point, newIdx, opt)) {
                var symbolEl = new SymbolCtor(data, newIdx, seriesScope, symbolUpdateOpt);
                symbolEl.setPosition(point);
                data.setItemGraphicEl(newIdx, symbolEl);
                group.add(symbolEl);
            }
        }).update(function(newIdx, oldIdx) {
            var symbolEl = oldData.getItemGraphicEl(oldIdx);
            var point = getSymbolPoint(newIdx);
            if (!$fedf62268297fcbb$var$symbolNeedsDraw(data, point, newIdx, opt)) {
                group.remove(symbolEl);
                return;
            }
            var newSymbolType = data.getItemVisual(newIdx, 'symbol') || 'circle';
            var oldSymbolType = symbolEl && symbolEl.getSymbolType && symbolEl.getSymbolType();
            if (!symbolEl || oldSymbolType && oldSymbolType !== newSymbolType) {
                group.remove(symbolEl);
                symbolEl = new SymbolCtor(data, newIdx, seriesScope, symbolUpdateOpt);
                symbolEl.setPosition(point);
            } else {
                symbolEl.updateData(data, newIdx, seriesScope, symbolUpdateOpt);
                var target = {
                    x: point[0],
                    y: point[1]
                };
                disableAnimation ? symbolEl.attr(target) : $8b353638fbedfefa$export$c8dce3c08436e91e(symbolEl, target, seriesModel);
            }
            // Add back
            group.add(symbolEl);
            data.setItemGraphicEl(newIdx, symbolEl);
        }).remove(function(oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            el && el.fadeOut(function() {
                group.remove(el);
            }, seriesModel);
        }).execute();
        this._getSymbolPoint = getSymbolPoint;
        this._data = data;
    };
    SymbolDraw.prototype.updateLayout = function() {
        var _this = this;
        var data = this._data;
        if (data) // Not use animation
        data.eachItemGraphicEl(function(el, idx) {
            var point = _this._getSymbolPoint(idx);
            el.setPosition(point);
            el.markRedraw();
        });
    };
    SymbolDraw.prototype.incrementalPrepareUpdate = function(data) {
        this._seriesScope = $fedf62268297fcbb$var$makeSeriesScope(data);
        this._data = null;
        this.group.removeAll();
    };
    /**
   * Update symbols draw by new data
   */ SymbolDraw.prototype.incrementalUpdate = function(taskParams, data, opt) {
        // Clear
        this._progressiveEls = [];
        opt = $fedf62268297fcbb$var$normalizeUpdateOpt(opt);
        function updateIncrementalAndHover(el) {
            if (!el.isGroup) {
                el.incremental = true;
                el.ensureState('emphasis').hoverLayer = true;
            }
        }
        for(var idx = taskParams.start; idx < taskParams.end; idx++){
            var point = data.getItemLayout(idx);
            if ($fedf62268297fcbb$var$symbolNeedsDraw(data, point, idx, opt)) {
                var el = new this._SymbolCtor(data, idx, this._seriesScope);
                el.traverse(updateIncrementalAndHover);
                el.setPosition(point);
                this.group.add(el);
                data.setItemGraphicEl(idx, el);
                this._progressiveEls.push(el);
            }
        }
    };
    SymbolDraw.prototype.eachRendered = function(cb) {
        $5b455ae6f843ac47$export$3e564442729bf048(this._progressiveEls || this.group, cb);
    };
    SymbolDraw.prototype.remove = function(enableAnimation) {
        var group = this.group;
        var data = this._data;
        // Incremental model do not have this._data.
        if (data && enableAnimation) data.eachItemGraphicEl(function(el) {
            el.fadeOut(function() {
                group.remove(el);
            }, data.hostModel);
        });
        else group.removeAll();
    };
    return SymbolDraw;
}();
var $fedf62268297fcbb$export$2e2bcd8739ae039 = $fedf62268297fcbb$var$SymbolDraw;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




function $fa583301cd9a2f5a$var$updateRipplePath(rippleGroup, effectCfg) {
    var color = effectCfg.rippleEffectColor || effectCfg.color;
    rippleGroup.eachChild(function(ripplePath) {
        ripplePath.attr({
            z: effectCfg.z,
            zlevel: effectCfg.zlevel,
            style: {
                stroke: effectCfg.brushType === 'stroke' ? color : null,
                fill: effectCfg.brushType === 'fill' ? color : null
            }
        });
    });
}
var $fa583301cd9a2f5a$var$EffectSymbol = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(EffectSymbol, _super);
    function EffectSymbol(data, idx) {
        var _this = _super.call(this) || this;
        var symbol = new (0, $b1d9c3e17ccace80$export$2e2bcd8739ae039)(data, idx);
        var rippleGroup = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)();
        _this.add(symbol);
        _this.add(rippleGroup);
        _this.updateData(data, idx);
        return _this;
    }
    EffectSymbol.prototype.stopEffectAnimation = function() {
        this.childAt(1).removeAll();
    };
    EffectSymbol.prototype.startEffectAnimation = function(effectCfg) {
        var symbolType = effectCfg.symbolType;
        var color = effectCfg.color;
        var rippleNumber = effectCfg.rippleNumber;
        var rippleGroup = this.childAt(1);
        for(var i = 0; i < rippleNumber; i++){
            // If width/height are set too small (e.g., set to 1) on ios10
            // and macOS Sierra, a circle stroke become a rect, no matter what
            // the scale is set. So we set width/height as 2. See #4136.
            var ripplePath = (0, $5370466dadc978d7$export$af050e04da3a02e8)(symbolType, -1, -1, 2, 2, color);
            ripplePath.attr({
                style: {
                    strokeNoScale: true
                },
                z2: 99,
                silent: true,
                scaleX: 0.5,
                scaleY: 0.5
            });
            var delay = -i / rippleNumber * effectCfg.period + effectCfg.effectOffset;
            ripplePath.animate('', true).when(effectCfg.period, {
                scaleX: effectCfg.rippleScale / 2,
                scaleY: effectCfg.rippleScale / 2
            }).delay(delay).start();
            ripplePath.animateStyle(true).when(effectCfg.period, {
                opacity: 0
            }).delay(delay).start();
            rippleGroup.add(ripplePath);
        }
        $fa583301cd9a2f5a$var$updateRipplePath(rippleGroup, effectCfg);
    };
    /**
   * Update effect symbol
   */ EffectSymbol.prototype.updateEffectAnimation = function(effectCfg) {
        var oldEffectCfg = this._effectCfg;
        var rippleGroup = this.childAt(1);
        // Must reinitialize effect if following configuration changed
        var DIFFICULT_PROPS = [
            'symbolType',
            'period',
            'rippleScale',
            'rippleNumber'
        ];
        for(var i = 0; i < DIFFICULT_PROPS.length; i++){
            var propName = DIFFICULT_PROPS[i];
            if (oldEffectCfg[propName] !== effectCfg[propName]) {
                this.stopEffectAnimation();
                this.startEffectAnimation(effectCfg);
                return;
            }
        }
        $fa583301cd9a2f5a$var$updateRipplePath(rippleGroup, effectCfg);
    };
    /**
   * Highlight symbol
   */ EffectSymbol.prototype.highlight = function() {
        (0, $2bf82c0980125b62$export$b2d02638cc34c042)(this);
    };
    /**
   * Downplay symbol
   */ EffectSymbol.prototype.downplay = function() {
        (0, $2bf82c0980125b62$export$11be6f716239ac55)(this);
    };
    EffectSymbol.prototype.getSymbolType = function() {
        var symbol = this.childAt(0);
        return symbol && symbol.getSymbolType();
    };
    /**
   * Update symbol properties
   */ EffectSymbol.prototype.updateData = function(data, idx) {
        var _this = this;
        var seriesModel = data.hostModel;
        this.childAt(0).updateData(data, idx);
        var rippleGroup = this.childAt(1);
        var itemModel = data.getItemModel(idx);
        var symbolType = data.getItemVisual(idx, 'symbol');
        var symbolSize = (0, $5370466dadc978d7$export$a84524f03e8e8dfb)(data.getItemVisual(idx, 'symbolSize'));
        var symbolStyle = data.getItemVisual(idx, 'style');
        var color = symbolStyle && symbolStyle.fill;
        var emphasisModel = itemModel.getModel('emphasis');
        rippleGroup.setScale(symbolSize);
        rippleGroup.traverse(function(ripplePath) {
            ripplePath.setStyle('fill', color);
        });
        var symbolOffset = (0, $5370466dadc978d7$export$e3e292895c033f6d)(data.getItemVisual(idx, 'symbolOffset'), symbolSize);
        if (symbolOffset) {
            rippleGroup.x = symbolOffset[0];
            rippleGroup.y = symbolOffset[1];
        }
        var symbolRotate = data.getItemVisual(idx, 'symbolRotate');
        rippleGroup.rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
        var effectCfg = {};
        effectCfg.showEffectOn = seriesModel.get('showEffectOn');
        effectCfg.rippleScale = itemModel.get([
            'rippleEffect',
            'scale'
        ]);
        effectCfg.brushType = itemModel.get([
            'rippleEffect',
            'brushType'
        ]);
        effectCfg.period = itemModel.get([
            'rippleEffect',
            'period'
        ]) * 1000;
        effectCfg.effectOffset = idx / data.count();
        effectCfg.z = seriesModel.getShallow('z') || 0;
        effectCfg.zlevel = seriesModel.getShallow('zlevel') || 0;
        effectCfg.symbolType = symbolType;
        effectCfg.color = color;
        effectCfg.rippleEffectColor = itemModel.get([
            'rippleEffect',
            'color'
        ]);
        effectCfg.rippleNumber = itemModel.get([
            'rippleEffect',
            'number'
        ]);
        if (effectCfg.showEffectOn === 'render') {
            this._effectCfg ? this.updateEffectAnimation(effectCfg) : this.startEffectAnimation(effectCfg);
            this._effectCfg = effectCfg;
        } else {
            // Not keep old effect config
            this._effectCfg = null;
            this.stopEffectAnimation();
            this.onHoverStateChange = function(toState) {
                if (toState === 'emphasis') {
                    if (effectCfg.showEffectOn !== 'render') _this.startEffectAnimation(effectCfg);
                } else if (toState === 'normal') {
                    if (effectCfg.showEffectOn !== 'render') _this.stopEffectAnimation();
                }
            };
        }
        this._effectCfg = effectCfg;
        (0, $2bf82c0980125b62$export$e51187539ff11209)(this, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
    };
    EffectSymbol.prototype.fadeOut = function(cb) {
        cb && cb();
    };
    return EffectSymbol;
}((0, $7ef7583d8302ffce$export$2e2bcd8739ae039));
var $fa583301cd9a2f5a$export$2e2bcd8739ae039 = $fa583301cd9a2f5a$var$EffectSymbol;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



function $73b014aa594ea652$export$2e2bcd8739ae039(seriesType, forceStoreInTypedArray) {
    return {
        seriesType: seriesType,
        plan: (0, $cd70075c57b35175$export$2e2bcd8739ae039)(),
        reset: function(seriesModel) {
            var data = seriesModel.getData();
            var coordSys = seriesModel.coordinateSystem;
            var pipelineContext = seriesModel.pipelineContext;
            var useTypedArray = forceStoreInTypedArray || pipelineContext.large;
            if (!coordSys) return;
            var dims = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(coordSys.dimensions, function(dim) {
                return data.mapDimension(dim);
            }).slice(0, 2);
            var dimLen = dims.length;
            var stackResultDim = data.getCalculationInfo('stackResultDimension');
            if ((0, $efdd976e4917927c$export$1dedc39359ae35c)(data, dims[0])) dims[0] = stackResultDim;
            if ((0, $efdd976e4917927c$export$1dedc39359ae35c)(data, dims[1])) dims[1] = stackResultDim;
            var store = data.getStore();
            var dimIdx0 = data.getDimensionIndex(dims[0]);
            var dimIdx1 = data.getDimensionIndex(dims[1]);
            return dimLen && {
                progress: function(params, data) {
                    var segCount = params.end - params.start;
                    var points = useTypedArray && (0, $5cd50afac93e9148$export$21d2298f3f56bbaf)(segCount * dimLen);
                    var tmpIn = [];
                    var tmpOut = [];
                    for(var i = params.start, offset = 0; i < params.end; i++){
                        var point = void 0;
                        if (dimLen === 1) {
                            var x = store.get(dimIdx0, i);
                            // NOTE: Make sure the second parameter is null to use default strategy.
                            point = coordSys.dataToPoint(x, null, tmpOut);
                        } else {
                            tmpIn[0] = store.get(dimIdx0, i);
                            tmpIn[1] = store.get(dimIdx1, i);
                            // Let coordinate system to handle the NaN data.
                            point = coordSys.dataToPoint(tmpIn, null, tmpOut);
                        }
                        if (useTypedArray) {
                            points[offset++] = point[0];
                            points[offset++] = point[1];
                        } else data.setItemLayout(i, point.slice());
                    }
                    useTypedArray && data.setLayout('points', points);
                }
            };
        }
    };
}



var $41934e1dad128ad0$var$EffectScatterView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(EffectScatterView, _super);
    function EffectScatterView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = EffectScatterView.type;
        return _this;
    }
    EffectScatterView.prototype.init = function() {
        this._symbolDraw = new (0, $fedf62268297fcbb$export$2e2bcd8739ae039)((0, $fa583301cd9a2f5a$export$2e2bcd8739ae039));
    };
    EffectScatterView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var effectSymbolDraw = this._symbolDraw;
        effectSymbolDraw.updateData(data, {
            clipShape: this._getClipShape(seriesModel)
        });
        this.group.add(effectSymbolDraw.group);
    };
    EffectScatterView.prototype._getClipShape = function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        var clipArea = coordSys && coordSys.getArea && coordSys.getArea();
        return seriesModel.get('clip', true) ? clipArea : null;
    };
    EffectScatterView.prototype.updateTransform = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        this.group.dirty();
        var res = (0, $73b014aa594ea652$export$2e2bcd8739ae039)('').reset(seriesModel, ecModel, api);
        if (res.progress) res.progress({
            start: 0,
            end: data.count(),
            count: data.count()
        }, data);
        this._symbolDraw.updateLayout();
    };
    EffectScatterView.prototype._updateGroupTransform = function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys && coordSys.getRoamTransform) {
            this.group.transform = $f41ebb9dd60b55b4$export$9cd59f9826255e47(coordSys.getRoamTransform());
            this.group.decomposeTransform();
        }
    };
    EffectScatterView.prototype.remove = function(ecModel, api) {
        this._symbolDraw && this._symbolDraw.remove(true);
    };
    EffectScatterView.type = 'effectScatter';
    return EffectScatterView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $41934e1dad128ad0$export$2e2bcd8739ae039 = $41934e1dad128ad0$var$EffectScatterView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $719c2a408bc8b7bb$var$EffectScatterSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(EffectScatterSeriesModel, _super);
    function EffectScatterSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = EffectScatterSeriesModel.type;
        _this.hasSymbolVisual = true;
        return _this;
    }
    EffectScatterSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $8afdec5f59c90781$export$2e2bcd8739ae039)(null, this, {
            useEncodeDefaulter: true
        });
    };
    EffectScatterSeriesModel.prototype.brushSelector = function(dataIndex, data, selectors) {
        return selectors.point(data.getItemLayout(dataIndex));
    };
    EffectScatterSeriesModel.type = 'series.effectScatter';
    EffectScatterSeriesModel.dependencies = [
        'grid',
        'polar'
    ];
    EffectScatterSeriesModel.defaultOption = {
        coordinateSystem: 'cartesian2d',
        // zlevel: 0,
        z: 2,
        legendHoverLink: true,
        effectType: 'ripple',
        progressive: 0,
        // When to show the effect, option: 'render'|'emphasis'
        showEffectOn: 'render',
        clip: true,
        // Ripple effect config
        rippleEffect: {
            period: 4,
            // Scale of ripple
            scale: 2.5,
            // Brush type can be fill or stroke
            brushType: 'fill',
            // Ripple number
            number: 3
        },
        universalTransition: {
            divideShape: 'clone'
        },
        // Cartesian coordinate system
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        // Polar coordinate system
        // polarIndex: 0,
        // Geo coordinate system
        // geoIndex: 0,
        // symbol: null,        // 图形类型
        symbolSize: 10 // 图形大小，半宽（半径）参数，当图形为方向或菱形则总宽度为symbolSize * 2
    };
    return EffectScatterSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $719c2a408bc8b7bb$export$2e2bcd8739ae039 = $719c2a408bc8b7bb$var$EffectScatterSeriesModel;



function $a0fd335cdafe9e6e$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $41934e1dad128ad0$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $719c2a408bc8b7bb$export$2e2bcd8739ae039));
    registers.registerLayout((0, $73b014aa594ea652$export$2e2bcd8739ae039)('effectScatter'));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







var $f4eb87a228be297f$var$PI2 = Math.PI * 2;
var $f4eb87a228be297f$var$CMD = (0, $20ebe2448f123f2e$export$2e2bcd8739ae039).CMD;
var $f4eb87a228be297f$var$DEFAULT_SEARCH_SPACE = [
    'top',
    'right',
    'bottom',
    'left'
];
function $f4eb87a228be297f$var$getCandidateAnchor(pos, distance, rect, outPt, outDir) {
    var width = rect.width;
    var height = rect.height;
    switch(pos){
        case 'top':
            outPt.set(rect.x + width / 2, rect.y - distance);
            outDir.set(0, -1);
            break;
        case 'bottom':
            outPt.set(rect.x + width / 2, rect.y + height + distance);
            outDir.set(0, 1);
            break;
        case 'left':
            outPt.set(rect.x - distance, rect.y + height / 2);
            outDir.set(-1, 0);
            break;
        case 'right':
            outPt.set(rect.x + width + distance, rect.y + height / 2);
            outDir.set(1, 0);
            break;
    }
}
function $f4eb87a228be297f$var$projectPointToArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y, out) {
    x -= cx;
    y -= cy;
    var d = Math.sqrt(x * x + y * y);
    x /= d;
    y /= d;
    // Intersect point.
    var ox = x * r + cx;
    var oy = y * r + cy;
    if (Math.abs(startAngle - endAngle) % $f4eb87a228be297f$var$PI2 < 1e-4) {
        // Is a circle
        out[0] = ox;
        out[1] = oy;
        return d - r;
    }
    if (anticlockwise) {
        var tmp = startAngle;
        startAngle = (0, $b44a8536c7214e4f$export$d44861331f213635)(endAngle);
        endAngle = (0, $b44a8536c7214e4f$export$d44861331f213635)(tmp);
    } else {
        startAngle = (0, $b44a8536c7214e4f$export$d44861331f213635)(startAngle);
        endAngle = (0, $b44a8536c7214e4f$export$d44861331f213635)(endAngle);
    }
    if (startAngle > endAngle) endAngle += $f4eb87a228be297f$var$PI2;
    var angle = Math.atan2(y, x);
    if (angle < 0) angle += $f4eb87a228be297f$var$PI2;
    if (angle >= startAngle && angle <= endAngle || angle + $f4eb87a228be297f$var$PI2 >= startAngle && angle + $f4eb87a228be297f$var$PI2 <= endAngle) {
        // Project point is on the arc.
        out[0] = ox;
        out[1] = oy;
        return d - r;
    }
    var x1 = r * Math.cos(startAngle) + cx;
    var y1 = r * Math.sin(startAngle) + cy;
    var x2 = r * Math.cos(endAngle) + cx;
    var y2 = r * Math.sin(endAngle) + cy;
    var d1 = (x1 - x) * (x1 - x) + (y1 - y) * (y1 - y);
    var d2 = (x2 - x) * (x2 - x) + (y2 - y) * (y2 - y);
    if (d1 < d2) {
        out[0] = x1;
        out[1] = y1;
        return Math.sqrt(d1);
    } else {
        out[0] = x2;
        out[1] = y2;
        return Math.sqrt(d2);
    }
}
function $f4eb87a228be297f$var$projectPointToLine(x1, y1, x2, y2, x, y, out, limitToEnds) {
    var dx = x - x1;
    var dy = y - y1;
    var dx1 = x2 - x1;
    var dy1 = y2 - y1;
    var lineLen = Math.sqrt(dx1 * dx1 + dy1 * dy1);
    dx1 /= lineLen;
    dy1 /= lineLen;
    // dot product
    var projectedLen = dx * dx1 + dy * dy1;
    var t = projectedLen / lineLen;
    if (limitToEnds) t = Math.min(Math.max(t, 0), 1);
    t *= lineLen;
    var ox = out[0] = x1 + t * dx1;
    var oy = out[1] = y1 + t * dy1;
    return Math.sqrt((ox - x) * (ox - x) + (oy - y) * (oy - y));
}
function $f4eb87a228be297f$var$projectPointToRect(x1, y1, width, height, x, y, out) {
    if (width < 0) {
        x1 = x1 + width;
        width = -width;
    }
    if (height < 0) {
        y1 = y1 + height;
        height = -height;
    }
    var x2 = x1 + width;
    var y2 = y1 + height;
    var ox = out[0] = Math.min(Math.max(x, x1), x2);
    var oy = out[1] = Math.min(Math.max(y, y1), y2);
    return Math.sqrt((ox - x) * (ox - x) + (oy - y) * (oy - y));
}
var $f4eb87a228be297f$var$tmpPt = [];
function $f4eb87a228be297f$var$nearestPointOnRect(pt, rect, out) {
    var dist = $f4eb87a228be297f$var$projectPointToRect(rect.x, rect.y, rect.width, rect.height, pt.x, pt.y, $f4eb87a228be297f$var$tmpPt);
    out.set($f4eb87a228be297f$var$tmpPt[0], $f4eb87a228be297f$var$tmpPt[1]);
    return dist;
}
/**
 * Calculate min distance corresponding point.
 * This method won't evaluate if point is in the path.
 */ function $f4eb87a228be297f$var$nearestPointOnPath(pt, path, out) {
    var xi = 0;
    var yi = 0;
    var x0 = 0;
    var y0 = 0;
    var x1;
    var y1;
    var minDist = Infinity;
    var data = path.data;
    var x = pt.x;
    var y = pt.y;
    for(var i = 0; i < data.length;){
        var cmd = data[i++];
        if (i === 1) {
            xi = data[i];
            yi = data[i + 1];
            x0 = xi;
            y0 = yi;
        }
        var d = minDist;
        switch(cmd){
            case $f4eb87a228be297f$var$CMD.M:
                // moveTo 命令重新创建一个新的 subpath, 并且更新新的起点
                // 在 closePath 的时候使用
                x0 = data[i++];
                y0 = data[i++];
                xi = x0;
                yi = y0;
                break;
            case $f4eb87a228be297f$var$CMD.L:
                d = $f4eb87a228be297f$var$projectPointToLine(xi, yi, data[i], data[i + 1], x, y, $f4eb87a228be297f$var$tmpPt, true);
                xi = data[i++];
                yi = data[i++];
                break;
            case $f4eb87a228be297f$var$CMD.C:
                d = (0, $747cfc5611b57cea$export$dbaa3801d1284367)(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y, $f4eb87a228be297f$var$tmpPt);
                xi = data[i++];
                yi = data[i++];
                break;
            case $f4eb87a228be297f$var$CMD.Q:
                d = (0, $747cfc5611b57cea$export$81915a594fe10dee)(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y, $f4eb87a228be297f$var$tmpPt);
                xi = data[i++];
                yi = data[i++];
                break;
            case $f4eb87a228be297f$var$CMD.A:
                // TODO Arc 判断的开销比较大
                var cx = data[i++];
                var cy = data[i++];
                var rx = data[i++];
                var ry = data[i++];
                var theta = data[i++];
                var dTheta = data[i++];
                // TODO Arc 旋转
                i += 1;
                var anticlockwise = !!(1 - data[i++]);
                x1 = Math.cos(theta) * rx + cx;
                y1 = Math.sin(theta) * ry + cy;
                // 不是直接使用 arc 命令
                if (i <= 1) {
                    // 第一个命令起点还未定义
                    x0 = x1;
                    y0 = y1;
                }
                // zr 使用scale来模拟椭圆, 这里也对x做一定的缩放
                var _x = (x - cx) * ry / rx + cx;
                d = $f4eb87a228be297f$var$projectPointToArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y, $f4eb87a228be297f$var$tmpPt);
                xi = Math.cos(theta + dTheta) * rx + cx;
                yi = Math.sin(theta + dTheta) * ry + cy;
                break;
            case $f4eb87a228be297f$var$CMD.R:
                x0 = xi = data[i++];
                y0 = yi = data[i++];
                var width = data[i++];
                var height = data[i++];
                d = $f4eb87a228be297f$var$projectPointToRect(x0, y0, width, height, x, y, $f4eb87a228be297f$var$tmpPt);
                break;
            case $f4eb87a228be297f$var$CMD.Z:
                d = $f4eb87a228be297f$var$projectPointToLine(xi, yi, x0, y0, x, y, $f4eb87a228be297f$var$tmpPt, true);
                xi = x0;
                yi = y0;
                break;
        }
        if (d < minDist) {
            minDist = d;
            out.set($f4eb87a228be297f$var$tmpPt[0], $f4eb87a228be297f$var$tmpPt[1]);
        }
    }
    return minDist;
}
// Temporal variable for intermediate usage.
var $f4eb87a228be297f$var$pt0 = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
var $f4eb87a228be297f$var$pt1 = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
var $f4eb87a228be297f$var$pt2 = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
var $f4eb87a228be297f$var$dir = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
var $f4eb87a228be297f$var$dir2 = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
function $f4eb87a228be297f$export$cc93ba643cd97d83(target, labelLineModel) {
    if (!target) return;
    var labelLine = target.getTextGuideLine();
    var label = target.getTextContent();
    // Needs to create text guide in each charts.
    if (!(label && labelLine)) return;
    var labelGuideConfig = target.textGuideLineConfig || {};
    var points = [
        [
            0,
            0
        ],
        [
            0,
            0
        ],
        [
            0,
            0
        ]
    ];
    var searchSpace = labelGuideConfig.candidates || $f4eb87a228be297f$var$DEFAULT_SEARCH_SPACE;
    var labelRect = label.getBoundingRect().clone();
    labelRect.applyTransform(label.getComputedTransform());
    var minDist = Infinity;
    var anchorPoint = labelGuideConfig.anchor;
    var targetTransform = target.getComputedTransform();
    var targetInversedTransform = targetTransform && (0, $f41ebb9dd60b55b4$export$6897c284b6f9f4dc)([], targetTransform);
    var len = labelLineModel.get('length2') || 0;
    if (anchorPoint) $f4eb87a228be297f$var$pt2.copy(anchorPoint);
    for(var i = 0; i < searchSpace.length; i++){
        var candidate = searchSpace[i];
        $f4eb87a228be297f$var$getCandidateAnchor(candidate, 0, labelRect, $f4eb87a228be297f$var$pt0, $f4eb87a228be297f$var$dir);
        (0, $b887f038f104fe7e$export$2e2bcd8739ae039).scaleAndAdd($f4eb87a228be297f$var$pt1, $f4eb87a228be297f$var$pt0, $f4eb87a228be297f$var$dir, len);
        // Transform to target coord space.
        $f4eb87a228be297f$var$pt1.transform(targetInversedTransform);
        // Note: getBoundingRect will ensure the `path` being created.
        var boundingRect = target.getBoundingRect();
        var dist = anchorPoint ? anchorPoint.distance($f4eb87a228be297f$var$pt1) : target instanceof (0, $b02ffe7acd508c08$export$2e2bcd8739ae039) ? $f4eb87a228be297f$var$nearestPointOnPath($f4eb87a228be297f$var$pt1, target.path, $f4eb87a228be297f$var$pt2) : $f4eb87a228be297f$var$nearestPointOnRect($f4eb87a228be297f$var$pt1, boundingRect, $f4eb87a228be297f$var$pt2);
        // TODO pt2 is in the path
        if (dist < minDist) {
            minDist = dist;
            // Transform back to global space.
            $f4eb87a228be297f$var$pt1.transform(targetTransform);
            $f4eb87a228be297f$var$pt2.transform(targetTransform);
            $f4eb87a228be297f$var$pt2.toArray(points[0]);
            $f4eb87a228be297f$var$pt1.toArray(points[1]);
            $f4eb87a228be297f$var$pt0.toArray(points[2]);
        }
    }
    $f4eb87a228be297f$export$ac52062003fbe6a(points, labelLineModel.get('minTurnAngle'));
    labelLine.setShape({
        points: points
    });
}
// Temporal variable for the limitTurnAngle function
var $f4eb87a228be297f$var$tmpArr = [];
var $f4eb87a228be297f$var$tmpProjPoint = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
function $f4eb87a228be297f$export$ac52062003fbe6a(linePoints, minTurnAngle) {
    if (!(minTurnAngle <= 180 && minTurnAngle > 0)) return;
    minTurnAngle = minTurnAngle / 180 * Math.PI;
    // The line points can be
    //      /pt1----pt2 (label)
    //     /
    // pt0/
    $f4eb87a228be297f$var$pt0.fromArray(linePoints[0]);
    $f4eb87a228be297f$var$pt1.fromArray(linePoints[1]);
    $f4eb87a228be297f$var$pt2.fromArray(linePoints[2]);
    (0, $b887f038f104fe7e$export$2e2bcd8739ae039).sub($f4eb87a228be297f$var$dir, $f4eb87a228be297f$var$pt0, $f4eb87a228be297f$var$pt1);
    (0, $b887f038f104fe7e$export$2e2bcd8739ae039).sub($f4eb87a228be297f$var$dir2, $f4eb87a228be297f$var$pt2, $f4eb87a228be297f$var$pt1);
    var len1 = $f4eb87a228be297f$var$dir.len();
    var len2 = $f4eb87a228be297f$var$dir2.len();
    if (len1 < 1e-3 || len2 < 1e-3) return;
    $f4eb87a228be297f$var$dir.scale(1 / len1);
    $f4eb87a228be297f$var$dir2.scale(1 / len2);
    var angleCos = $f4eb87a228be297f$var$dir.dot($f4eb87a228be297f$var$dir2);
    var minTurnAngleCos = Math.cos(minTurnAngle);
    if (minTurnAngleCos < angleCos) {
        // Smaller than minTurnAngle
        // Calculate project point of pt0 on pt1-pt2
        var d = $f4eb87a228be297f$var$projectPointToLine($f4eb87a228be297f$var$pt1.x, $f4eb87a228be297f$var$pt1.y, $f4eb87a228be297f$var$pt2.x, $f4eb87a228be297f$var$pt2.y, $f4eb87a228be297f$var$pt0.x, $f4eb87a228be297f$var$pt0.y, $f4eb87a228be297f$var$tmpArr, false);
        $f4eb87a228be297f$var$tmpProjPoint.fromArray($f4eb87a228be297f$var$tmpArr);
        // Calculate new projected length with limited minTurnAngle and get the new connect point
        $f4eb87a228be297f$var$tmpProjPoint.scaleAndAdd($f4eb87a228be297f$var$dir2, d / Math.tan(Math.PI - minTurnAngle));
        // Limit the new calculated connect point between pt1 and pt2.
        var t = $f4eb87a228be297f$var$pt2.x !== $f4eb87a228be297f$var$pt1.x ? ($f4eb87a228be297f$var$tmpProjPoint.x - $f4eb87a228be297f$var$pt1.x) / ($f4eb87a228be297f$var$pt2.x - $f4eb87a228be297f$var$pt1.x) : ($f4eb87a228be297f$var$tmpProjPoint.y - $f4eb87a228be297f$var$pt1.y) / ($f4eb87a228be297f$var$pt2.y - $f4eb87a228be297f$var$pt1.y);
        if (isNaN(t)) return;
        if (t < 0) (0, $b887f038f104fe7e$export$2e2bcd8739ae039).copy($f4eb87a228be297f$var$tmpProjPoint, $f4eb87a228be297f$var$pt1);
        else if (t > 1) (0, $b887f038f104fe7e$export$2e2bcd8739ae039).copy($f4eb87a228be297f$var$tmpProjPoint, $f4eb87a228be297f$var$pt2);
        $f4eb87a228be297f$var$tmpProjPoint.toArray(linePoints[1]);
    }
}
function $f4eb87a228be297f$export$973e1fdb2708f71b(linePoints, surfaceNormal, maxSurfaceAngle) {
    if (!(maxSurfaceAngle <= 180 && maxSurfaceAngle > 0)) return;
    maxSurfaceAngle = maxSurfaceAngle / 180 * Math.PI;
    $f4eb87a228be297f$var$pt0.fromArray(linePoints[0]);
    $f4eb87a228be297f$var$pt1.fromArray(linePoints[1]);
    $f4eb87a228be297f$var$pt2.fromArray(linePoints[2]);
    (0, $b887f038f104fe7e$export$2e2bcd8739ae039).sub($f4eb87a228be297f$var$dir, $f4eb87a228be297f$var$pt1, $f4eb87a228be297f$var$pt0);
    (0, $b887f038f104fe7e$export$2e2bcd8739ae039).sub($f4eb87a228be297f$var$dir2, $f4eb87a228be297f$var$pt2, $f4eb87a228be297f$var$pt1);
    var len1 = $f4eb87a228be297f$var$dir.len();
    var len2 = $f4eb87a228be297f$var$dir2.len();
    if (len1 < 1e-3 || len2 < 1e-3) return;
    $f4eb87a228be297f$var$dir.scale(1 / len1);
    $f4eb87a228be297f$var$dir2.scale(1 / len2);
    var angleCos = $f4eb87a228be297f$var$dir.dot(surfaceNormal);
    var maxSurfaceAngleCos = Math.cos(maxSurfaceAngle);
    if (angleCos < maxSurfaceAngleCos) {
        // Calculate project point of pt0 on pt1-pt2
        var d = $f4eb87a228be297f$var$projectPointToLine($f4eb87a228be297f$var$pt1.x, $f4eb87a228be297f$var$pt1.y, $f4eb87a228be297f$var$pt2.x, $f4eb87a228be297f$var$pt2.y, $f4eb87a228be297f$var$pt0.x, $f4eb87a228be297f$var$pt0.y, $f4eb87a228be297f$var$tmpArr, false);
        $f4eb87a228be297f$var$tmpProjPoint.fromArray($f4eb87a228be297f$var$tmpArr);
        var HALF_PI = Math.PI / 2;
        var angle2 = Math.acos($f4eb87a228be297f$var$dir2.dot(surfaceNormal));
        var newAngle = HALF_PI + angle2 - maxSurfaceAngle;
        if (newAngle >= HALF_PI) // parallel
        (0, $b887f038f104fe7e$export$2e2bcd8739ae039).copy($f4eb87a228be297f$var$tmpProjPoint, $f4eb87a228be297f$var$pt2);
        else {
            // Calculate new projected length with limited minTurnAngle and get the new connect point
            $f4eb87a228be297f$var$tmpProjPoint.scaleAndAdd($f4eb87a228be297f$var$dir2, d / Math.tan(Math.PI / 2 - newAngle));
            // Limit the new calculated connect point between pt1 and pt2.
            var t = $f4eb87a228be297f$var$pt2.x !== $f4eb87a228be297f$var$pt1.x ? ($f4eb87a228be297f$var$tmpProjPoint.x - $f4eb87a228be297f$var$pt1.x) / ($f4eb87a228be297f$var$pt2.x - $f4eb87a228be297f$var$pt1.x) : ($f4eb87a228be297f$var$tmpProjPoint.y - $f4eb87a228be297f$var$pt1.y) / ($f4eb87a228be297f$var$pt2.y - $f4eb87a228be297f$var$pt1.y);
            if (isNaN(t)) return;
            if (t < 0) (0, $b887f038f104fe7e$export$2e2bcd8739ae039).copy($f4eb87a228be297f$var$tmpProjPoint, $f4eb87a228be297f$var$pt1);
            else if (t > 1) (0, $b887f038f104fe7e$export$2e2bcd8739ae039).copy($f4eb87a228be297f$var$tmpProjPoint, $f4eb87a228be297f$var$pt2);
        }
        $f4eb87a228be297f$var$tmpProjPoint.toArray(linePoints[1]);
    }
}
function $f4eb87a228be297f$var$setLabelLineState(labelLine, ignore, stateName, stateModel) {
    var isNormal = stateName === 'normal';
    var stateObj = isNormal ? labelLine : labelLine.ensureState(stateName);
    // Make sure display.
    stateObj.ignore = ignore;
    // Set smooth
    var smooth = stateModel.get('smooth');
    if (smooth && smooth === true) smooth = 0.3;
    stateObj.shape = stateObj.shape || {};
    if (smooth > 0) stateObj.shape.smooth = smooth;
    var styleObj = stateModel.getModel('lineStyle').getLineStyle();
    isNormal ? labelLine.useStyle(styleObj) : stateObj.style = styleObj;
}
function $f4eb87a228be297f$var$buildLabelLinePath(path, shape) {
    var smooth = shape.smooth;
    var points = shape.points;
    if (!points) return;
    path.moveTo(points[0][0], points[0][1]);
    if (smooth > 0 && points.length >= 3) {
        var len1 = $6de594cf8ac295ff$export$6c4a311cc157c764(points[0], points[1]);
        var len2 = $6de594cf8ac295ff$export$6c4a311cc157c764(points[1], points[2]);
        if (!len1 || !len2) {
            path.lineTo(points[1][0], points[1][1]);
            path.lineTo(points[2][0], points[2][1]);
            return;
        }
        var moveLen = Math.min(len1, len2) * smooth;
        var midPoint0 = $6de594cf8ac295ff$export$3a89f8d6f6bf6c9f([], points[1], points[0], moveLen / len1);
        var midPoint2 = $6de594cf8ac295ff$export$3a89f8d6f6bf6c9f([], points[1], points[2], moveLen / len2);
        var midPoint1 = $6de594cf8ac295ff$export$3a89f8d6f6bf6c9f([], midPoint0, midPoint2, 0.5);
        path.bezierCurveTo(midPoint0[0], midPoint0[1], midPoint0[0], midPoint0[1], midPoint1[0], midPoint1[1]);
        path.bezierCurveTo(midPoint2[0], midPoint2[1], midPoint2[0], midPoint2[1], points[2][0], points[2][1]);
    } else for(var i = 1; i < points.length; i++)path.lineTo(points[i][0], points[i][1]);
}
function $f4eb87a228be297f$export$c09e0b0574bdd2dc(targetEl, statesModels, defaultStyle) {
    var labelLine = targetEl.getTextGuideLine();
    var label = targetEl.getTextContent();
    if (!label) {
        // Not show label line if there is no label.
        if (labelLine) targetEl.removeTextGuideLine();
        return;
    }
    var normalModel = statesModels.normal;
    var showNormal = normalModel.get('show');
    var labelIgnoreNormal = label.ignore;
    for(var i = 0; i < (0, $2bf82c0980125b62$export$57ee5306b85ad7d5).length; i++){
        var stateName = (0, $2bf82c0980125b62$export$57ee5306b85ad7d5)[i];
        var stateModel = statesModels[stateName];
        var isNormal = stateName === 'normal';
        if (stateModel) {
            var stateShow = stateModel.get('show');
            var isLabelIgnored = isNormal ? labelIgnoreNormal : (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(label.states[stateName] && label.states[stateName].ignore, labelIgnoreNormal);
            if (isLabelIgnored // Not show when label is not shown in this state.
             || !(0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(stateShow, showNormal) // Use normal state by default if not set.
            ) {
                var stateObj = isNormal ? labelLine : labelLine && labelLine.states[stateName];
                if (stateObj) stateObj.ignore = true;
                if (!!labelLine) $f4eb87a228be297f$var$setLabelLineState(labelLine, true, stateName, stateModel);
                continue;
            }
            // Create labelLine if not exists
            if (!labelLine) {
                labelLine = new (0, $d28119f30e6bb670$export$2e2bcd8739ae039)();
                targetEl.setTextGuideLine(labelLine);
                // Reset state of normal because it's new created.
                // NOTE: NORMAL should always been the first!
                if (!isNormal && (labelIgnoreNormal || !showNormal)) $f4eb87a228be297f$var$setLabelLineState(labelLine, true, 'normal', statesModels.normal);
                // Use same state proxy.
                if (targetEl.stateProxy) labelLine.stateProxy = targetEl.stateProxy;
            }
            $f4eb87a228be297f$var$setLabelLineState(labelLine, false, stateName, stateModel);
        }
    }
    if (labelLine) {
        (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(labelLine.style, defaultStyle);
        // Not fill.
        labelLine.style.fill = null;
        var showAbove = normalModel.get('showAbove');
        var labelLineConfig = targetEl.textGuideLineConfig = targetEl.textGuideLineConfig || {};
        labelLineConfig.showAbove = showAbove || false;
        // Custom the buildPath.
        labelLine.buildPath = $f4eb87a228be297f$var$buildLabelLinePath;
    }
}
function $f4eb87a228be297f$export$2979fdbf5ebce521(itemModel, labelLineName) {
    labelLineName = labelLineName || 'labelLine';
    var statesModels = {
        normal: itemModel.getModel(labelLineName)
    };
    for(var i = 0; i < (0, $2bf82c0980125b62$export$151308dceb52d5b).length; i++){
        var stateName = (0, $2bf82c0980125b62$export$151308dceb52d5b)[i];
        statesModels[stateName] = itemModel.getModel([
            stateName,
            labelLineName
        ]);
    }
    return statesModels;
}




var $a34a81cc5e14c818$var$opacityAccessPath = [
    'itemStyle',
    'opacity'
];
/**
 * Piece of pie including Sector, Label, LabelLine
 */ var $a34a81cc5e14c818$var$FunnelPiece = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(FunnelPiece, _super);
    function FunnelPiece(data, idx) {
        var _this = _super.call(this) || this;
        var polygon = _this;
        var labelLine = new $d28119f30e6bb670$export$2e2bcd8739ae039();
        var text = new $fe885cc21795562b$export$2e2bcd8739ae039();
        polygon.setTextContent(text);
        _this.setTextGuideLine(labelLine);
        _this.updateData(data, idx, true);
        return _this;
    }
    FunnelPiece.prototype.updateData = function(data, idx, firstCreate) {
        var polygon = this;
        var seriesModel = data.hostModel;
        var itemModel = data.getItemModel(idx);
        var layout = data.getItemLayout(idx);
        var emphasisModel = itemModel.getModel('emphasis');
        var opacity = itemModel.get($a34a81cc5e14c818$var$opacityAccessPath);
        opacity = opacity == null ? 1 : opacity;
        if (!firstCreate) (0, $8b353638fbedfefa$export$bca7290a9faf0ec9)(polygon);
        // Update common style
        polygon.useStyle(data.getItemVisual(idx, 'style'));
        polygon.style.lineJoin = 'round';
        if (firstCreate) {
            polygon.setShape({
                points: layout.points
            });
            polygon.style.opacity = 0;
            $8b353638fbedfefa$export$a121566aadcfe021(polygon, {
                style: {
                    opacity: opacity
                }
            }, seriesModel, idx);
        } else $8b353638fbedfefa$export$c8dce3c08436e91e(polygon, {
            style: {
                opacity: opacity
            },
            shape: {
                points: layout.points
            }
        }, seriesModel, idx);
        (0, $2bf82c0980125b62$export$48b68047d330bbc9)(polygon, itemModel);
        this._updateLabel(data, idx);
        (0, $2bf82c0980125b62$export$e51187539ff11209)(this, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
    };
    FunnelPiece.prototype._updateLabel = function(data, idx) {
        var polygon = this;
        var labelLine = this.getTextGuideLine();
        var labelText = polygon.getTextContent();
        var seriesModel = data.hostModel;
        var itemModel = data.getItemModel(idx);
        var layout = data.getItemLayout(idx);
        var labelLayout = layout.label;
        var style = data.getItemVisual(idx, 'style');
        var visualColor = style.fill;
        (0, $6800dfcb6e1e2a44$export$9a13992917966657)(// position will not be used in setLabelStyle
        labelText, (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(itemModel), {
            labelFetcher: data.hostModel,
            labelDataIndex: idx,
            defaultOpacity: style.opacity,
            defaultText: data.getName(idx)
        }, {
            normal: {
                align: labelLayout.textAlign,
                verticalAlign: labelLayout.verticalAlign
            }
        });
        polygon.setTextConfig({
            local: true,
            inside: !!labelLayout.inside,
            insideStroke: visualColor,
            // insideFill: 'auto',
            outsideFill: visualColor
        });
        var linePoints = labelLayout.linePoints;
        labelLine.setShape({
            points: linePoints
        });
        polygon.textGuideLineConfig = {
            anchor: linePoints ? new $b887f038f104fe7e$export$2e2bcd8739ae039(linePoints[0][0], linePoints[0][1]) : null
        };
        // Make sure update style on labelText after setLabelStyle.
        // Because setLabelStyle will replace a new style on it.
        $8b353638fbedfefa$export$c8dce3c08436e91e(labelText, {
            style: {
                x: labelLayout.x,
                y: labelLayout.y
            }
        }, seriesModel, idx);
        labelText.attr({
            rotation: labelLayout.rotation,
            originX: labelLayout.x,
            originY: labelLayout.y,
            z2: 10
        });
        (0, $f4eb87a228be297f$export$c09e0b0574bdd2dc)(polygon, (0, $f4eb87a228be297f$export$2979fdbf5ebce521)(itemModel), {
            // Default use item visual color
            stroke: visualColor
        });
    };
    return FunnelPiece;
}($51acf033123e1a30$export$2e2bcd8739ae039);
var $a34a81cc5e14c818$var$FunnelView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(FunnelView, _super);
    function FunnelView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = FunnelView.type;
        _this.ignoreLabelLineUpdate = true;
        return _this;
    }
    FunnelView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var oldData = this._data;
        var group = this.group;
        data.diff(oldData).add(function(idx) {
            var funnelPiece = new $a34a81cc5e14c818$var$FunnelPiece(data, idx);
            data.setItemGraphicEl(idx, funnelPiece);
            group.add(funnelPiece);
        }).update(function(newIdx, oldIdx) {
            var piece = oldData.getItemGraphicEl(oldIdx);
            piece.updateData(data, newIdx);
            group.add(piece);
            data.setItemGraphicEl(newIdx, piece);
        }).remove(function(idx) {
            var piece = oldData.getItemGraphicEl(idx);
            $8b353638fbedfefa$export$6d0fd725cb4aee8a(piece, seriesModel, idx);
        }).execute();
        this._data = data;
    };
    FunnelView.prototype.remove = function() {
        this.group.removeAll();
        this._data = null;
    };
    FunnelView.prototype.dispose = function() {};
    FunnelView.type = 'funnel';
    return FunnelView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $a34a81cc5e14c818$export$2e2bcd8739ae039 = $a34a81cc5e14c818$var$FunnelView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * LegendVisualProvider is an bridge that pick encoded color from data and
 * provide to the legend component.
 */ var $cf24728fc17c4ab6$var$LegendVisualProvider = /** @class */ function() {
    function LegendVisualProvider(// Function to get data after filtered. It stores all the encoding info
    getDataWithEncodedVisual, // Function to get raw data before filtered.
    getRawData) {
        this._getDataWithEncodedVisual = getDataWithEncodedVisual;
        this._getRawData = getRawData;
    }
    LegendVisualProvider.prototype.getAllNames = function() {
        var rawData = this._getRawData();
        // We find the name from the raw data. In case it's filtered by the legend component.
        // Normally, the name can be found in rawData, but can't be found in filtered data will display as gray.
        return rawData.mapArray(rawData.getName);
    };
    LegendVisualProvider.prototype.containName = function(name) {
        var rawData = this._getRawData();
        return rawData.indexOfName(name) >= 0;
    };
    LegendVisualProvider.prototype.indexOfName = function(name) {
        // Only get data when necessary.
        // Because LegendVisualProvider constructor may be new in the stage that data is not prepared yet.
        // Invoking Series#getData immediately will throw an error.
        var dataWithEncodedVisual = this._getDataWithEncodedVisual();
        return dataWithEncodedVisual.indexOfName(name);
    };
    LegendVisualProvider.prototype.getItemVisual = function(dataIndex, key) {
        // Get encoded visual properties from final filtered data.
        var dataWithEncodedVisual = this._getDataWithEncodedVisual();
        return dataWithEncodedVisual.getItemVisual(dataIndex, key);
    };
    return LegendVisualProvider;
}();
var $cf24728fc17c4ab6$export$2e2bcd8739ae039 = $cf24728fc17c4ab6$var$LegendVisualProvider;



var $3ac6efc4b95638aa$var$FunnelSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(FunnelSeriesModel, _super);
    function FunnelSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = FunnelSeriesModel.type;
        return _this;
    }
    FunnelSeriesModel.prototype.init = function(option) {
        _super.prototype.init.apply(this, arguments);
        // Enable legend selection for each data item
        // Use a function instead of direct access because data reference may changed
        this.legendVisualProvider = new (0, $cf24728fc17c4ab6$export$2e2bcd8739ae039)($7a1bd9c2710fea0d$export$2385a24977818dd0(this.getData, this), $7a1bd9c2710fea0d$export$2385a24977818dd0(this.getRawData, this));
        // Extend labelLine emphasis
        this._defaultLabelLine(option);
    };
    FunnelSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $7e5c3511527c9907$export$2e2bcd8739ae039)(this, {
            coordDimensions: [
                'value'
            ],
            encodeDefaulter: $7a1bd9c2710fea0d$export$c3095a23b368d1f2((0, $7dc6cdfd7450ef29$export$60b8a57d1f2fed26), this)
        });
    };
    FunnelSeriesModel.prototype._defaultLabelLine = function(option) {
        // Extend labelLine emphasis
        (0, $76d619f648247e6d$export$abdcc6a26372f94b)(option, 'labelLine', [
            'show'
        ]);
        var labelLineNormalOpt = option.labelLine;
        var labelLineEmphasisOpt = option.emphasis.labelLine;
        // Not show label line if `label.normal.show = false`
        labelLineNormalOpt.show = labelLineNormalOpt.show && option.label.show;
        labelLineEmphasisOpt.show = labelLineEmphasisOpt.show && option.emphasis.label.show;
    };
    // Overwrite
    FunnelSeriesModel.prototype.getDataParams = function(dataIndex) {
        var data = this.getData();
        var params = _super.prototype.getDataParams.call(this, dataIndex);
        var valueDim = data.mapDimension('value');
        var sum = data.getSum(valueDim);
        // Percent is 0 if sum is 0
        params.percent = !sum ? 0 : +(data.get(valueDim, dataIndex) / sum * 100).toFixed(2);
        params.$vars.push('percent');
        return params;
    };
    FunnelSeriesModel.type = 'series.funnel';
    FunnelSeriesModel.defaultOption = {
        // zlevel: 0,                  // 一级层叠
        z: 2,
        legendHoverLink: true,
        colorBy: 'data',
        left: 80,
        top: 60,
        right: 80,
        bottom: 60,
        // width: {totalWidth} - left - right,
        // height: {totalHeight} - top - bottom,
        // 默认取数据最小最大值
        // min: 0,
        // max: 100,
        minSize: '0%',
        maxSize: '100%',
        sort: 'descending',
        orient: 'vertical',
        gap: 0,
        funnelAlign: 'center',
        label: {
            show: true,
            position: 'outer'
        },
        labelLine: {
            show: true,
            length: 20,
            lineStyle: {
                // color: 各异,
                width: 1
            }
        },
        itemStyle: {
            // color: 各异,
            borderColor: '#fff',
            borderWidth: 1
        },
        emphasis: {
            label: {
                show: true
            }
        },
        select: {
            itemStyle: {
                borderColor: '#212121'
            }
        }
    };
    return FunnelSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $3ac6efc4b95638aa$export$2e2bcd8739ae039 = $3ac6efc4b95638aa$var$FunnelSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $4e9f9ac9332ed124$var$getViewRect(seriesModel, api) {
    return $93b9bc7f22ac7369$export$4517a5ca639a7293(seriesModel.getBoxLayoutParams(), {
        width: api.getWidth(),
        height: api.getHeight()
    });
}
function $4e9f9ac9332ed124$var$getSortedIndices(data, sort) {
    var valueDim = data.mapDimension('value');
    var valueArr = data.mapArray(valueDim, function(val) {
        return val;
    });
    var indices = [];
    var isAscending = sort === 'ascending';
    for(var i = 0, len = data.count(); i < len; i++)indices[i] = i;
    // Add custom sortable function & none sortable opetion by "options.sort"
    if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(sort)) indices.sort(sort);
    else if (sort !== 'none') indices.sort(function(a, b) {
        return isAscending ? valueArr[a] - valueArr[b] : valueArr[b] - valueArr[a];
    });
    return indices;
}
function $4e9f9ac9332ed124$var$labelLayout(data) {
    var seriesModel = data.hostModel;
    var orient = seriesModel.get('orient');
    data.each(function(idx) {
        var itemModel = data.getItemModel(idx);
        var labelModel = itemModel.getModel('label');
        var labelPosition = labelModel.get('position');
        var labelLineModel = itemModel.getModel('labelLine');
        var layout = data.getItemLayout(idx);
        var points = layout.points;
        var isLabelInside = labelPosition === 'inner' || labelPosition === 'inside' || labelPosition === 'center' || labelPosition === 'insideLeft' || labelPosition === 'insideRight';
        var textAlign;
        var textX;
        var textY;
        var linePoints;
        if (isLabelInside) {
            if (labelPosition === 'insideLeft') {
                textX = (points[0][0] + points[3][0]) / 2 + 5;
                textY = (points[0][1] + points[3][1]) / 2;
                textAlign = 'left';
            } else if (labelPosition === 'insideRight') {
                textX = (points[1][0] + points[2][0]) / 2 - 5;
                textY = (points[1][1] + points[2][1]) / 2;
                textAlign = 'right';
            } else {
                textX = (points[0][0] + points[1][0] + points[2][0] + points[3][0]) / 4;
                textY = (points[0][1] + points[1][1] + points[2][1] + points[3][1]) / 4;
                textAlign = 'center';
            }
            linePoints = [
                [
                    textX,
                    textY
                ],
                [
                    textX,
                    textY
                ]
            ];
        } else {
            var x1 = void 0;
            var y1 = void 0;
            var x2 = void 0;
            var y2 = void 0;
            var labelLineLen = labelLineModel.get('length');
            if (labelPosition === 'left') {
                // Left side
                x1 = (points[3][0] + points[0][0]) / 2;
                y1 = (points[3][1] + points[0][1]) / 2;
                x2 = x1 - labelLineLen;
                textX = x2 - 5;
                textAlign = 'right';
            } else if (labelPosition === 'right') {
                // Right side
                x1 = (points[1][0] + points[2][0]) / 2;
                y1 = (points[1][1] + points[2][1]) / 2;
                x2 = x1 + labelLineLen;
                textX = x2 + 5;
                textAlign = 'left';
            } else if (labelPosition === 'top') {
                // Top side
                x1 = (points[3][0] + points[0][0]) / 2;
                y1 = (points[3][1] + points[0][1]) / 2;
                y2 = y1 - labelLineLen;
                textY = y2 - 5;
                textAlign = 'center';
            } else if (labelPosition === 'bottom') {
                // Bottom side
                x1 = (points[1][0] + points[2][0]) / 2;
                y1 = (points[1][1] + points[2][1]) / 2;
                y2 = y1 + labelLineLen;
                textY = y2 + 5;
                textAlign = 'center';
            } else if (labelPosition === 'rightTop') {
                // RightTop side
                x1 = orient === 'horizontal' ? points[3][0] : points[1][0];
                y1 = orient === 'horizontal' ? points[3][1] : points[1][1];
                if (orient === 'horizontal') {
                    y2 = y1 - labelLineLen;
                    textY = y2 - 5;
                    textAlign = 'center';
                } else {
                    x2 = x1 + labelLineLen;
                    textX = x2 + 5;
                    textAlign = 'top';
                }
            } else if (labelPosition === 'rightBottom') {
                // RightBottom side
                x1 = points[2][0];
                y1 = points[2][1];
                if (orient === 'horizontal') {
                    y2 = y1 + labelLineLen;
                    textY = y2 + 5;
                    textAlign = 'center';
                } else {
                    x2 = x1 + labelLineLen;
                    textX = x2 + 5;
                    textAlign = 'bottom';
                }
            } else if (labelPosition === 'leftTop') {
                // LeftTop side
                x1 = points[0][0];
                y1 = orient === 'horizontal' ? points[0][1] : points[1][1];
                if (orient === 'horizontal') {
                    y2 = y1 - labelLineLen;
                    textY = y2 - 5;
                    textAlign = 'center';
                } else {
                    x2 = x1 - labelLineLen;
                    textX = x2 - 5;
                    textAlign = 'right';
                }
            } else if (labelPosition === 'leftBottom') {
                // LeftBottom side
                x1 = orient === 'horizontal' ? points[1][0] : points[3][0];
                y1 = orient === 'horizontal' ? points[1][1] : points[2][1];
                if (orient === 'horizontal') {
                    y2 = y1 + labelLineLen;
                    textY = y2 + 5;
                    textAlign = 'center';
                } else {
                    x2 = x1 - labelLineLen;
                    textX = x2 - 5;
                    textAlign = 'right';
                }
            } else {
                // Right side or Bottom side
                x1 = (points[1][0] + points[2][0]) / 2;
                y1 = (points[1][1] + points[2][1]) / 2;
                if (orient === 'horizontal') {
                    y2 = y1 + labelLineLen;
                    textY = y2 + 5;
                    textAlign = 'center';
                } else {
                    x2 = x1 + labelLineLen;
                    textX = x2 + 5;
                    textAlign = 'left';
                }
            }
            if (orient === 'horizontal') {
                x2 = x1;
                textX = x2;
            } else {
                y2 = y1;
                textY = y2;
            }
            linePoints = [
                [
                    x1,
                    y1
                ],
                [
                    x2,
                    y2
                ]
            ];
        }
        layout.label = {
            linePoints: linePoints,
            x: textX,
            y: textY,
            verticalAlign: 'middle',
            textAlign: textAlign,
            inside: isLabelInside
        };
    });
}
function $4e9f9ac9332ed124$export$2e2bcd8739ae039(ecModel, api) {
    ecModel.eachSeriesByType('funnel', function(seriesModel) {
        var data = seriesModel.getData();
        var valueDim = data.mapDimension('value');
        var sort = seriesModel.get('sort');
        var viewRect = $4e9f9ac9332ed124$var$getViewRect(seriesModel, api);
        var orient = seriesModel.get('orient');
        var viewWidth = viewRect.width;
        var viewHeight = viewRect.height;
        var indices = $4e9f9ac9332ed124$var$getSortedIndices(data, sort);
        var x = viewRect.x;
        var y = viewRect.y;
        var sizeExtent = orient === 'horizontal' ? [
            (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(seriesModel.get('minSize'), viewHeight),
            (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(seriesModel.get('maxSize'), viewHeight)
        ] : [
            (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(seriesModel.get('minSize'), viewWidth),
            (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(seriesModel.get('maxSize'), viewWidth)
        ];
        var dataExtent = data.getDataExtent(valueDim);
        var min = seriesModel.get('min');
        var max = seriesModel.get('max');
        if (min == null) min = Math.min(dataExtent[0], 0);
        if (max == null) max = dataExtent[1];
        var funnelAlign = seriesModel.get('funnelAlign');
        var gap = seriesModel.get('gap');
        var viewSize = orient === 'horizontal' ? viewWidth : viewHeight;
        var itemSize = (viewSize - gap * (data.count() - 1)) / data.count();
        var getLinePoints = function(idx, offset) {
            // End point index is data.count() and we assign it 0
            if (orient === 'horizontal') {
                var val_1 = data.get(valueDim, idx) || 0;
                var itemHeight = (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(val_1, [
                    min,
                    max
                ], sizeExtent, true);
                var y0 = void 0;
                switch(funnelAlign){
                    case 'top':
                        y0 = y;
                        break;
                    case 'center':
                        y0 = y + (viewHeight - itemHeight) / 2;
                        break;
                    case 'bottom':
                        y0 = y + (viewHeight - itemHeight);
                        break;
                }
                return [
                    [
                        offset,
                        y0
                    ],
                    [
                        offset,
                        y0 + itemHeight
                    ]
                ];
            }
            var val = data.get(valueDim, idx) || 0;
            var itemWidth = (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(val, [
                min,
                max
            ], sizeExtent, true);
            var x0;
            switch(funnelAlign){
                case 'left':
                    x0 = x;
                    break;
                case 'center':
                    x0 = x + (viewWidth - itemWidth) / 2;
                    break;
                case 'right':
                    x0 = x + viewWidth - itemWidth;
                    break;
            }
            return [
                [
                    x0,
                    offset
                ],
                [
                    x0 + itemWidth,
                    offset
                ]
            ];
        };
        if (sort === 'ascending') {
            // From bottom to top
            itemSize = -itemSize;
            gap = -gap;
            if (orient === 'horizontal') x += viewWidth;
            else y += viewHeight;
            indices = indices.reverse();
        }
        for(var i = 0; i < indices.length; i++){
            var idx = indices[i];
            var nextIdx = indices[i + 1];
            var itemModel = data.getItemModel(idx);
            if (orient === 'horizontal') {
                var width = itemModel.get([
                    'itemStyle',
                    'width'
                ]);
                if (width == null) width = itemSize;
                else {
                    width = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(width, viewWidth);
                    if (sort === 'ascending') width = -width;
                }
                var start = getLinePoints(idx, x);
                var end = getLinePoints(nextIdx, x + width);
                x += width + gap;
                data.setItemLayout(idx, {
                    points: start.concat(end.slice().reverse())
                });
            } else {
                var height = itemModel.get([
                    'itemStyle',
                    'height'
                ]);
                if (height == null) height = itemSize;
                else {
                    height = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(height, viewHeight);
                    if (sort === 'ascending') height = -height;
                }
                var start = getLinePoints(idx, y);
                var end = getLinePoints(nextIdx, y + height);
                y += height + gap;
                data.setItemLayout(idx, {
                    points: start.concat(end.slice().reverse())
                });
            }
        }
        $4e9f9ac9332ed124$var$labelLayout(data);
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $e11a533bf70b759c$export$2e2bcd8739ae039(seriesType) {
    return {
        seriesType: seriesType,
        reset: function(seriesModel, ecModel) {
            var legendModels = ecModel.findComponents({
                mainType: 'legend'
            });
            if (!legendModels || !legendModels.length) return;
            var data = seriesModel.getData();
            data.filterSelf(function(idx) {
                var name = data.getName(idx);
                // If in any legend component the status is not selected.
                for(var i = 0; i < legendModels.length; i++){
                    // @ts-ignore FIXME: LegendModel
                    if (!legendModels[i].isSelected(name)) return false;
                }
                return true;
            });
        }
    };
}


function $2bdc3734cdc2f6c8$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $a34a81cc5e14c818$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $3ac6efc4b95638aa$export$2e2bcd8739ae039));
    registers.registerLayout((0, $4e9f9ac9332ed124$export$2e2bcd8739ae039));
    registers.registerProcessor((0, $e11a533bf70b759c$export$2e2bcd8739ae039)('funnel'));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $ea4af8acc4ea1022$var$PointerShape = /** @class */ function() {
    function PointerShape() {
        this.angle = 0;
        this.width = 10;
        this.r = 10;
        this.x = 0;
        this.y = 0;
    }
    return PointerShape;
}();
var $ea4af8acc4ea1022$var$PointerPath = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(PointerPath, _super);
    function PointerPath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'pointer';
        return _this;
    }
    PointerPath.prototype.getDefaultShape = function() {
        return new $ea4af8acc4ea1022$var$PointerShape();
    };
    PointerPath.prototype.buildPath = function(ctx, shape) {
        var mathCos = Math.cos;
        var mathSin = Math.sin;
        var r = shape.r;
        var width = shape.width;
        var angle = shape.angle;
        var x = shape.x - mathCos(angle) * width * (width >= r / 3 ? 1 : 2);
        var y = shape.y - mathSin(angle) * width * (width >= r / 3 ? 1 : 2);
        angle = shape.angle - Math.PI / 2;
        ctx.moveTo(x, y);
        ctx.lineTo(shape.x + mathCos(angle) * width, shape.y + mathSin(angle) * width);
        ctx.lineTo(shape.x + mathCos(shape.angle) * r, shape.y + mathSin(shape.angle) * r);
        ctx.lineTo(shape.x - mathCos(angle) * width, shape.y - mathSin(angle) * width);
        ctx.lineTo(x, y);
    };
    return PointerPath;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
var $ea4af8acc4ea1022$export$2e2bcd8739ae039 = $ea4af8acc4ea1022$var$PointerPath;













function $f677de6b1db15bcf$var$parsePosition(seriesModel, api) {
    var center = seriesModel.get('center');
    var width = api.getWidth();
    var height = api.getHeight();
    var size = Math.min(width, height);
    var cx = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(center[0], api.getWidth());
    var cy = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(center[1], api.getHeight());
    var r = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(seriesModel.get('radius'), size / 2);
    return {
        cx: cx,
        cy: cy,
        r: r
    };
}
function $f677de6b1db15bcf$var$formatLabel(value, labelFormatter) {
    var label = value == null ? '' : value + '';
    if (labelFormatter) {
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(labelFormatter)) label = labelFormatter.replace('{value}', label);
        else if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(labelFormatter)) label = labelFormatter(value);
    }
    return label;
}
var $f677de6b1db15bcf$var$GaugeView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(GaugeView, _super);
    function GaugeView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GaugeView.type;
        return _this;
    }
    GaugeView.prototype.render = function(seriesModel, ecModel, api) {
        this.group.removeAll();
        var colorList = seriesModel.get([
            'axisLine',
            'lineStyle',
            'color'
        ]);
        var posInfo = $f677de6b1db15bcf$var$parsePosition(seriesModel, api);
        this._renderMain(seriesModel, ecModel, api, colorList, posInfo);
        this._data = seriesModel.getData();
    };
    GaugeView.prototype.dispose = function() {};
    GaugeView.prototype._renderMain = function(seriesModel, ecModel, api, colorList, posInfo) {
        var group = this.group;
        var clockwise = seriesModel.get('clockwise');
        var startAngle = -seriesModel.get('startAngle') / 180 * Math.PI;
        var endAngle = -seriesModel.get('endAngle') / 180 * Math.PI;
        var axisLineModel = seriesModel.getModel('axisLine');
        var roundCap = axisLineModel.get('roundCap');
        var MainPath = roundCap ? (0, $9674946a7a7df213$export$2e2bcd8739ae039) : $a3e1dec0a3875b49$export$2e2bcd8739ae039;
        var showAxis = axisLineModel.get('show');
        var lineStyleModel = axisLineModel.getModel('lineStyle');
        var axisLineWidth = lineStyleModel.get('width');
        var angles = [
            startAngle,
            endAngle
        ];
        (0, $20ebe2448f123f2e$export$bc668021e937022a)(angles, !clockwise);
        startAngle = angles[0];
        endAngle = angles[1];
        var angleRangeSpan = endAngle - startAngle;
        var prevEndAngle = startAngle;
        var sectors = [];
        for(var i = 0; showAxis && i < colorList.length; i++){
            // Clamp
            var percent = Math.min(Math.max(colorList[i][0], 0), 1);
            endAngle = startAngle + angleRangeSpan * percent;
            var sector = new MainPath({
                shape: {
                    startAngle: prevEndAngle,
                    endAngle: endAngle,
                    cx: posInfo.cx,
                    cy: posInfo.cy,
                    clockwise: clockwise,
                    r0: posInfo.r - axisLineWidth,
                    r: posInfo.r
                },
                silent: true
            });
            sector.setStyle({
                fill: colorList[i][1]
            });
            sector.setStyle(lineStyleModel.getLineStyle(// Because we use sector to simulate arc
            // so the properties for stroking are useless
            [
                'color',
                'width'
            ]));
            sectors.push(sector);
            prevEndAngle = endAngle;
        }
        sectors.reverse();
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(sectors, function(sector) {
            return group.add(sector);
        });
        var getColor = function(percent) {
            // Less than 0
            if (percent <= 0) return colorList[0][1];
            var i;
            for(i = 0; i < colorList.length; i++){
                if (colorList[i][0] >= percent && (i === 0 ? 0 : colorList[i - 1][0]) < percent) return colorList[i][1];
            }
            // More than 1
            return colorList[i - 1][1];
        };
        this._renderTicks(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise, axisLineWidth);
        this._renderTitleAndDetail(seriesModel, ecModel, api, getColor, posInfo);
        this._renderAnchor(seriesModel, posInfo);
        this._renderPointer(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise, axisLineWidth);
    };
    GaugeView.prototype._renderTicks = function(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise, axisLineWidth) {
        var group = this.group;
        var cx = posInfo.cx;
        var cy = posInfo.cy;
        var r = posInfo.r;
        var minVal = +seriesModel.get('min');
        var maxVal = +seriesModel.get('max');
        var splitLineModel = seriesModel.getModel('splitLine');
        var tickModel = seriesModel.getModel('axisTick');
        var labelModel = seriesModel.getModel('axisLabel');
        var splitNumber = seriesModel.get('splitNumber');
        var subSplitNumber = tickModel.get('splitNumber');
        var splitLineLen = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(splitLineModel.get('length'), r);
        var tickLen = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(tickModel.get('length'), r);
        var angle = startAngle;
        var step = (endAngle - startAngle) / splitNumber;
        var subStep = step / subSplitNumber;
        var splitLineStyle = splitLineModel.getModel('lineStyle').getLineStyle();
        var tickLineStyle = tickModel.getModel('lineStyle').getLineStyle();
        var splitLineDistance = splitLineModel.get('distance');
        var unitX;
        var unitY;
        for(var i = 0; i <= splitNumber; i++){
            unitX = Math.cos(angle);
            unitY = Math.sin(angle);
            // Split line
            if (splitLineModel.get('show')) {
                var distance = splitLineDistance ? splitLineDistance + axisLineWidth : axisLineWidth;
                var splitLine = new $7a316ae5ceff7b27$export$2e2bcd8739ae039({
                    shape: {
                        x1: unitX * (r - distance) + cx,
                        y1: unitY * (r - distance) + cy,
                        x2: unitX * (r - splitLineLen - distance) + cx,
                        y2: unitY * (r - splitLineLen - distance) + cy
                    },
                    style: splitLineStyle,
                    silent: true
                });
                if (splitLineStyle.stroke === 'auto') splitLine.setStyle({
                    stroke: getColor(i / splitNumber)
                });
                group.add(splitLine);
            }
            // Label
            if (labelModel.get('show')) {
                var distance = labelModel.get('distance') + splitLineDistance;
                var label = $f677de6b1db15bcf$var$formatLabel((0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(i / splitNumber * (maxVal - minVal) + minVal), labelModel.get('formatter'));
                var autoColor = getColor(i / splitNumber);
                var textStyleX = unitX * (r - splitLineLen - distance) + cx;
                var textStyleY = unitY * (r - splitLineLen - distance) + cy;
                var rotateType = labelModel.get('rotate');
                var rotate = 0;
                if (rotateType === 'radial') {
                    rotate = -angle + 2 * Math.PI;
                    if (rotate > Math.PI / 2) rotate += Math.PI;
                } else if (rotateType === 'tangential') rotate = -angle - Math.PI / 2;
                else if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(rotateType)) rotate = rotateType * Math.PI / 180;
                if (rotate === 0) group.add(new $fe885cc21795562b$export$2e2bcd8739ae039({
                    style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(labelModel, {
                        text: label,
                        x: textStyleX,
                        y: textStyleY,
                        verticalAlign: unitY < -0.8 ? 'top' : unitY > 0.8 ? 'bottom' : 'middle',
                        align: unitX < -0.4 ? 'left' : unitX > 0.4 ? 'right' : 'center'
                    }, {
                        inheritColor: autoColor
                    }),
                    silent: true
                }));
                else group.add(new $fe885cc21795562b$export$2e2bcd8739ae039({
                    style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(labelModel, {
                        text: label,
                        x: textStyleX,
                        y: textStyleY,
                        verticalAlign: 'middle',
                        align: 'center'
                    }, {
                        inheritColor: autoColor
                    }),
                    silent: true,
                    originX: textStyleX,
                    originY: textStyleY,
                    rotation: rotate
                }));
            }
            // Axis tick
            if (tickModel.get('show') && i !== splitNumber) {
                var distance = tickModel.get('distance');
                distance = distance ? distance + axisLineWidth : axisLineWidth;
                for(var j = 0; j <= subSplitNumber; j++){
                    unitX = Math.cos(angle);
                    unitY = Math.sin(angle);
                    var tickLine = new $7a316ae5ceff7b27$export$2e2bcd8739ae039({
                        shape: {
                            x1: unitX * (r - distance) + cx,
                            y1: unitY * (r - distance) + cy,
                            x2: unitX * (r - tickLen - distance) + cx,
                            y2: unitY * (r - tickLen - distance) + cy
                        },
                        silent: true,
                        style: tickLineStyle
                    });
                    if (tickLineStyle.stroke === 'auto') tickLine.setStyle({
                        stroke: getColor((i + j / subSplitNumber) / splitNumber)
                    });
                    group.add(tickLine);
                    angle += subStep;
                }
                angle -= subStep;
            } else angle += step;
        }
    };
    GaugeView.prototype._renderPointer = function(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise, axisLineWidth) {
        var group = this.group;
        var oldData = this._data;
        var oldProgressData = this._progressEls;
        var progressList = [];
        var showPointer = seriesModel.get([
            'pointer',
            'show'
        ]);
        var progressModel = seriesModel.getModel('progress');
        var showProgress = progressModel.get('show');
        var data = seriesModel.getData();
        var valueDim = data.mapDimension('value');
        var minVal = +seriesModel.get('min');
        var maxVal = +seriesModel.get('max');
        var valueExtent = [
            minVal,
            maxVal
        ];
        var angleExtent = [
            startAngle,
            endAngle
        ];
        function createPointer(idx, angle) {
            var itemModel = data.getItemModel(idx);
            var pointerModel = itemModel.getModel('pointer');
            var pointerWidth = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(pointerModel.get('width'), posInfo.r);
            var pointerLength = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(pointerModel.get('length'), posInfo.r);
            var pointerStr = seriesModel.get([
                'pointer',
                'icon'
            ]);
            var pointerOffset = pointerModel.get('offsetCenter');
            var pointerOffsetX = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(pointerOffset[0], posInfo.r);
            var pointerOffsetY = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(pointerOffset[1], posInfo.r);
            var pointerKeepAspect = pointerModel.get('keepAspect');
            var pointer;
            // not exist icon type will be set 'rect'
            if (pointerStr) pointer = (0, $5370466dadc978d7$export$af050e04da3a02e8)(pointerStr, pointerOffsetX - pointerWidth / 2, pointerOffsetY - pointerLength, pointerWidth, pointerLength, null, pointerKeepAspect);
            else pointer = new (0, $ea4af8acc4ea1022$export$2e2bcd8739ae039)({
                shape: {
                    angle: -Math.PI / 2,
                    width: pointerWidth,
                    r: pointerLength,
                    x: pointerOffsetX,
                    y: pointerOffsetY
                }
            });
            pointer.rotation = -(angle + Math.PI / 2);
            pointer.x = posInfo.cx;
            pointer.y = posInfo.cy;
            return pointer;
        }
        function createProgress(idx, endAngle) {
            var roundCap = progressModel.get('roundCap');
            var ProgressPath = roundCap ? (0, $9674946a7a7df213$export$2e2bcd8739ae039) : $a3e1dec0a3875b49$export$2e2bcd8739ae039;
            var isOverlap = progressModel.get('overlap');
            var progressWidth = isOverlap ? progressModel.get('width') : axisLineWidth / data.count();
            var r0 = isOverlap ? posInfo.r - progressWidth : posInfo.r - (idx + 1) * progressWidth;
            var r = isOverlap ? posInfo.r : posInfo.r - idx * progressWidth;
            var progress = new ProgressPath({
                shape: {
                    startAngle: startAngle,
                    endAngle: endAngle,
                    cx: posInfo.cx,
                    cy: posInfo.cy,
                    clockwise: clockwise,
                    r0: r0,
                    r: r
                }
            });
            isOverlap && (progress.z2 = (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(data.get(valueDim, idx), [
                minVal,
                maxVal
            ], [
                100,
                0
            ], true));
            return progress;
        }
        if (showProgress || showPointer) {
            data.diff(oldData).add(function(idx) {
                var val = data.get(valueDim, idx);
                if (showPointer) {
                    var pointer = createPointer(idx, startAngle);
                    // TODO hide pointer on NaN value?
                    $8b353638fbedfefa$export$a121566aadcfe021(pointer, {
                        rotation: -((isNaN(+val) ? angleExtent[0] : (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(val, valueExtent, angleExtent, true)) + Math.PI / 2)
                    }, seriesModel);
                    group.add(pointer);
                    data.setItemGraphicEl(idx, pointer);
                }
                if (showProgress) {
                    var progress = createProgress(idx, startAngle);
                    var isClip = progressModel.get('clip');
                    $8b353638fbedfefa$export$a121566aadcfe021(progress, {
                        shape: {
                            endAngle: (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(val, valueExtent, angleExtent, isClip)
                        }
                    }, seriesModel);
                    group.add(progress);
                    // Add data index and series index for indexing the data by element
                    // Useful in tooltip
                    (0, $b1983a2fffd47d56$export$30d6736ebb8e18d5)(seriesModel.seriesIndex, data.dataType, idx, progress);
                    progressList[idx] = progress;
                }
            }).update(function(newIdx, oldIdx) {
                var val = data.get(valueDim, newIdx);
                if (showPointer) {
                    var previousPointer = oldData.getItemGraphicEl(oldIdx);
                    var previousRotate = previousPointer ? previousPointer.rotation : startAngle;
                    var pointer = createPointer(newIdx, previousRotate);
                    pointer.rotation = previousRotate;
                    $8b353638fbedfefa$export$c8dce3c08436e91e(pointer, {
                        rotation: -((isNaN(+val) ? angleExtent[0] : (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(val, valueExtent, angleExtent, true)) + Math.PI / 2)
                    }, seriesModel);
                    group.add(pointer);
                    data.setItemGraphicEl(newIdx, pointer);
                }
                if (showProgress) {
                    var previousProgress = oldProgressData[oldIdx];
                    var previousEndAngle = previousProgress ? previousProgress.shape.endAngle : startAngle;
                    var progress = createProgress(newIdx, previousEndAngle);
                    var isClip = progressModel.get('clip');
                    $8b353638fbedfefa$export$c8dce3c08436e91e(progress, {
                        shape: {
                            endAngle: (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(val, valueExtent, angleExtent, isClip)
                        }
                    }, seriesModel);
                    group.add(progress);
                    // Add data index and series index for indexing the data by element
                    // Useful in tooltip
                    (0, $b1983a2fffd47d56$export$30d6736ebb8e18d5)(seriesModel.seriesIndex, data.dataType, newIdx, progress);
                    progressList[newIdx] = progress;
                }
            }).execute();
            data.each(function(idx) {
                var itemModel = data.getItemModel(idx);
                var emphasisModel = itemModel.getModel('emphasis');
                var focus = emphasisModel.get('focus');
                var blurScope = emphasisModel.get('blurScope');
                var emphasisDisabled = emphasisModel.get('disabled');
                if (showPointer) {
                    var pointer = data.getItemGraphicEl(idx);
                    var symbolStyle = data.getItemVisual(idx, 'style');
                    var visualColor = symbolStyle.fill;
                    if (pointer instanceof (0, $86adec94217b86c6$export$2e2bcd8739ae039)) {
                        var pathStyle = pointer.style;
                        pointer.useStyle((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
                            image: pathStyle.image,
                            x: pathStyle.x,
                            y: pathStyle.y,
                            width: pathStyle.width,
                            height: pathStyle.height
                        }, symbolStyle));
                    } else {
                        pointer.useStyle(symbolStyle);
                        pointer.type !== 'pointer' && pointer.setColor(visualColor);
                    }
                    pointer.setStyle(itemModel.getModel([
                        'pointer',
                        'itemStyle'
                    ]).getItemStyle());
                    if (pointer.style.fill === 'auto') pointer.setStyle('fill', getColor((0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(data.get(valueDim, idx), valueExtent, [
                        0,
                        1
                    ], true)));
                    pointer.z2EmphasisLift = 0;
                    (0, $2bf82c0980125b62$export$48b68047d330bbc9)(pointer, itemModel);
                    (0, $2bf82c0980125b62$export$e51187539ff11209)(pointer, focus, blurScope, emphasisDisabled);
                }
                if (showProgress) {
                    var progress = progressList[idx];
                    progress.useStyle(data.getItemVisual(idx, 'style'));
                    progress.setStyle(itemModel.getModel([
                        'progress',
                        'itemStyle'
                    ]).getItemStyle());
                    progress.z2EmphasisLift = 0;
                    (0, $2bf82c0980125b62$export$48b68047d330bbc9)(progress, itemModel);
                    (0, $2bf82c0980125b62$export$e51187539ff11209)(progress, focus, blurScope, emphasisDisabled);
                }
            });
            this._progressEls = progressList;
        }
    };
    GaugeView.prototype._renderAnchor = function(seriesModel, posInfo) {
        var anchorModel = seriesModel.getModel('anchor');
        var showAnchor = anchorModel.get('show');
        if (showAnchor) {
            var anchorSize = anchorModel.get('size');
            var anchorType = anchorModel.get('icon');
            var offsetCenter = anchorModel.get('offsetCenter');
            var anchorKeepAspect = anchorModel.get('keepAspect');
            var anchor = (0, $5370466dadc978d7$export$af050e04da3a02e8)(anchorType, posInfo.cx - anchorSize / 2 + (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(offsetCenter[0], posInfo.r), posInfo.cy - anchorSize / 2 + (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(offsetCenter[1], posInfo.r), anchorSize, anchorSize, null, anchorKeepAspect);
            anchor.z2 = anchorModel.get('showAbove') ? 1 : 0;
            anchor.setStyle(anchorModel.getModel('itemStyle').getItemStyle());
            this.group.add(anchor);
        }
    };
    GaugeView.prototype._renderTitleAndDetail = function(seriesModel, ecModel, api, getColor, posInfo) {
        var _this = this;
        var data = seriesModel.getData();
        var valueDim = data.mapDimension('value');
        var minVal = +seriesModel.get('min');
        var maxVal = +seriesModel.get('max');
        var contentGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        var newTitleEls = [];
        var newDetailEls = [];
        var hasAnimation = seriesModel.isAnimationEnabled();
        var showPointerAbove = seriesModel.get([
            'pointer',
            'showAbove'
        ]);
        data.diff(this._data).add(function(idx) {
            newTitleEls[idx] = new $fe885cc21795562b$export$2e2bcd8739ae039({
                silent: true
            });
            newDetailEls[idx] = new $fe885cc21795562b$export$2e2bcd8739ae039({
                silent: true
            });
        }).update(function(idx, oldIdx) {
            newTitleEls[idx] = _this._titleEls[oldIdx];
            newDetailEls[idx] = _this._detailEls[oldIdx];
        }).execute();
        data.each(function(idx) {
            var itemModel = data.getItemModel(idx);
            var value = data.get(valueDim, idx);
            var itemGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
            var autoColor = getColor((0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(value, [
                minVal,
                maxVal
            ], [
                0,
                1
            ], true));
            var itemTitleModel = itemModel.getModel('title');
            if (itemTitleModel.get('show')) {
                var titleOffsetCenter = itemTitleModel.get('offsetCenter');
                var titleX = posInfo.cx + (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(titleOffsetCenter[0], posInfo.r);
                var titleY = posInfo.cy + (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(titleOffsetCenter[1], posInfo.r);
                var labelEl = newTitleEls[idx];
                labelEl.attr({
                    z2: showPointerAbove ? 0 : 2,
                    style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(itemTitleModel, {
                        x: titleX,
                        y: titleY,
                        text: data.getName(idx),
                        align: 'center',
                        verticalAlign: 'middle'
                    }, {
                        inheritColor: autoColor
                    })
                });
                itemGroup.add(labelEl);
            }
            var itemDetailModel = itemModel.getModel('detail');
            if (itemDetailModel.get('show')) {
                var detailOffsetCenter = itemDetailModel.get('offsetCenter');
                var detailX = posInfo.cx + (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(detailOffsetCenter[0], posInfo.r);
                var detailY = posInfo.cy + (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(detailOffsetCenter[1], posInfo.r);
                var width = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(itemDetailModel.get('width'), posInfo.r);
                var height = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(itemDetailModel.get('height'), posInfo.r);
                var detailColor = seriesModel.get([
                    'progress',
                    'show'
                ]) ? data.getItemVisual(idx, 'style').fill : autoColor;
                var labelEl = newDetailEls[idx];
                var formatter_1 = itemDetailModel.get('formatter');
                labelEl.attr({
                    z2: showPointerAbove ? 0 : 2,
                    style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(itemDetailModel, {
                        x: detailX,
                        y: detailY,
                        text: $f677de6b1db15bcf$var$formatLabel(value, formatter_1),
                        width: isNaN(width) ? null : width,
                        height: isNaN(height) ? null : height,
                        align: 'center',
                        verticalAlign: 'middle'
                    }, {
                        inheritColor: detailColor
                    })
                });
                (0, $6800dfcb6e1e2a44$export$7bdbceaf9ab378f2)(labelEl, {
                    normal: itemDetailModel
                }, value, function(value) {
                    return $f677de6b1db15bcf$var$formatLabel(value, formatter_1);
                });
                hasAnimation && (0, $6800dfcb6e1e2a44$export$dd6101605f5c186)(labelEl, idx, data, seriesModel, {
                    getFormattedLabel: function(labelDataIndex, status, dataType, labelDimIndex, fmt, extendParams) {
                        return $f677de6b1db15bcf$var$formatLabel(extendParams ? extendParams.interpolatedValue : value, formatter_1);
                    }
                });
                itemGroup.add(labelEl);
            }
            contentGroup.add(itemGroup);
        });
        this.group.add(contentGroup);
        this._titleEls = newTitleEls;
        this._detailEls = newDetailEls;
    };
    GaugeView.type = 'gauge';
    return GaugeView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $f677de6b1db15bcf$export$2e2bcd8739ae039 = $f677de6b1db15bcf$var$GaugeView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $059503c83684127e$var$GaugeSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(GaugeSeriesModel, _super);
    function GaugeSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GaugeSeriesModel.type;
        _this.visualStyleAccessPath = 'itemStyle';
        return _this;
    }
    GaugeSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $7e5c3511527c9907$export$2e2bcd8739ae039)(this, [
            'value'
        ]);
    };
    GaugeSeriesModel.type = 'series.gauge';
    GaugeSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        colorBy: 'data',
        // 默认全局居中
        center: [
            '50%',
            '50%'
        ],
        legendHoverLink: true,
        radius: '75%',
        startAngle: 225,
        endAngle: -45,
        clockwise: true,
        // 最小值
        min: 0,
        // 最大值
        max: 100,
        // 分割段数，默认为10
        splitNumber: 10,
        // 坐标轴线
        axisLine: {
            // 默认显示，属性show控制显示与否
            show: true,
            roundCap: false,
            lineStyle: {
                color: [
                    [
                        1,
                        '#E6EBF8'
                    ]
                ],
                width: 10
            }
        },
        // 坐标轴线
        progress: {
            // 默认显示，属性show控制显示与否
            show: false,
            overlap: true,
            width: 10,
            roundCap: false,
            clip: true
        },
        // 分隔线
        splitLine: {
            // 默认显示，属性show控制显示与否
            show: true,
            // 属性length控制线长
            length: 10,
            distance: 10,
            // 属性lineStyle（详见lineStyle）控制线条样式
            lineStyle: {
                color: '#63677A',
                width: 3,
                type: 'solid'
            }
        },
        // 坐标轴小标记
        axisTick: {
            // 属性show控制显示与否，默认不显示
            show: true,
            // 每份split细分多少段
            splitNumber: 5,
            // 属性length控制线长
            length: 6,
            distance: 10,
            // 属性lineStyle控制线条样式
            lineStyle: {
                color: '#63677A',
                width: 1,
                type: 'solid'
            }
        },
        axisLabel: {
            show: true,
            distance: 15,
            // formatter: null,
            color: '#464646',
            fontSize: 12,
            rotate: 0
        },
        pointer: {
            icon: null,
            offsetCenter: [
                0,
                0
            ],
            show: true,
            showAbove: true,
            length: '60%',
            width: 6,
            keepAspect: false
        },
        anchor: {
            show: false,
            showAbove: false,
            size: 6,
            icon: 'circle',
            offsetCenter: [
                0,
                0
            ],
            keepAspect: false,
            itemStyle: {
                color: '#fff',
                borderWidth: 0,
                borderColor: '#5470c6'
            }
        },
        title: {
            show: true,
            // x, y，单位px
            offsetCenter: [
                0,
                '20%'
            ],
            // 其余属性默认使用全局文本样式，详见TEXTSTYLE
            color: '#464646',
            fontSize: 16,
            valueAnimation: false
        },
        detail: {
            show: true,
            backgroundColor: 'rgba(0,0,0,0)',
            borderWidth: 0,
            borderColor: '#ccc',
            width: 100,
            height: null,
            padding: [
                5,
                10
            ],
            // x, y，单位px
            offsetCenter: [
                0,
                '40%'
            ],
            // formatter: null,
            // 其余属性默认使用全局文本样式，详见TEXTSTYLE
            color: '#464646',
            fontSize: 30,
            fontWeight: 'bold',
            lineHeight: 30,
            valueAnimation: false
        }
    };
    return GaugeSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $059503c83684127e$export$2e2bcd8739ae039 = $059503c83684127e$var$GaugeSeriesModel;


function $bf7cb565bb1d2308$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $f677de6b1db15bcf$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $059503c83684127e$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $23b43ea6be789dc3$export$2e2bcd8739ae039(ecModel) {
    var legendModels = ecModel.findComponents({
        mainType: 'legend'
    });
    if (!legendModels || !legendModels.length) return;
    ecModel.eachSeriesByType('graph', function(graphSeries) {
        var categoriesData = graphSeries.getCategoriesData();
        var graph = graphSeries.getGraph();
        var data = graph.data;
        var categoryNames = categoriesData.mapArray(categoriesData.getName);
        data.filterSelf(function(idx) {
            var model = data.getItemModel(idx);
            var category = model.getShallow('category');
            if (category != null) {
                if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(category)) category = categoryNames[category];
                // If in any legend component the status is not selected.
                for(var i = 0; i < legendModels.length; i++){
                    if (!legendModels[i].isSelected(category)) return false;
                }
            }
            return true;
        });
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $2c7d64c9b3613d6b$export$2e2bcd8739ae039(ecModel) {
    var paletteScope = {};
    ecModel.eachSeriesByType('graph', function(seriesModel) {
        var categoriesData = seriesModel.getCategoriesData();
        var data = seriesModel.getData();
        var categoryNameIdxMap = {};
        categoriesData.each(function(idx) {
            var name = categoriesData.getName(idx);
            // Add prefix to avoid conflict with Object.prototype.
            categoryNameIdxMap['ec-' + name] = idx;
            var itemModel = categoriesData.getItemModel(idx);
            var style = itemModel.getModel('itemStyle').getItemStyle();
            if (!style.fill) // Get color from palette.
            style.fill = seriesModel.getColorFromPalette(name, paletteScope);
            categoriesData.setItemVisual(idx, 'style', style);
            var symbolVisualList = [
                'symbol',
                'symbolSize',
                'symbolKeepAspect'
            ];
            for(var i = 0; i < symbolVisualList.length; i++){
                var symbolVisual = itemModel.getShallow(symbolVisualList[i], true);
                if (symbolVisual != null) categoriesData.setItemVisual(idx, symbolVisualList[i], symbolVisual);
            }
        });
        // Assign category color to visual
        if (categoriesData.count()) data.each(function(idx) {
            var model = data.getItemModel(idx);
            var categoryIdx = model.getShallow('category');
            if (categoryIdx != null) {
                if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(categoryIdx)) categoryIdx = categoryNameIdxMap['ec-' + categoryIdx];
                var categoryStyle = categoriesData.getItemVisual(categoryIdx, 'style');
                var style = data.ensureUniqueItemVisual(idx, 'style');
                (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(style, categoryStyle);
                var visualList = [
                    'symbol',
                    'symbolSize',
                    'symbolKeepAspect'
                ];
                for(var i = 0; i < visualList.length; i++)data.setItemVisual(idx, visualList[i], categoriesData.getItemVisual(categoryIdx, visualList[i]));
            }
        });
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $11ee0a103a25747c$var$normalize(a) {
    if (!(a instanceof Array)) a = [
        a,
        a
    ];
    return a;
}
function $11ee0a103a25747c$export$2e2bcd8739ae039(ecModel) {
    ecModel.eachSeriesByType('graph', function(seriesModel) {
        var graph = seriesModel.getGraph();
        var edgeData = seriesModel.getEdgeData();
        var symbolType = $11ee0a103a25747c$var$normalize(seriesModel.get('edgeSymbol'));
        var symbolSize = $11ee0a103a25747c$var$normalize(seriesModel.get('edgeSymbolSize'));
        // const colorQuery = ['lineStyle', 'color'] as const;
        // const opacityQuery = ['lineStyle', 'opacity'] as const;
        edgeData.setVisual('fromSymbol', symbolType && symbolType[0]);
        edgeData.setVisual('toSymbol', symbolType && symbolType[1]);
        edgeData.setVisual('fromSymbolSize', symbolSize && symbolSize[0]);
        edgeData.setVisual('toSymbolSize', symbolSize && symbolSize[1]);
        edgeData.setVisual('style', seriesModel.getModel('lineStyle').getLineStyle());
        edgeData.each(function(idx) {
            var itemModel = edgeData.getItemModel(idx);
            var edge = graph.getEdgeByIndex(idx);
            var symbolType = $11ee0a103a25747c$var$normalize(itemModel.getShallow('symbol', true));
            var symbolSize = $11ee0a103a25747c$var$normalize(itemModel.getShallow('symbolSize', true));
            // Edge visual must after node visual
            var style = itemModel.getModel('lineStyle').getLineStyle();
            var existsStyle = edgeData.ensureUniqueItemVisual(idx, 'style');
            (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(existsStyle, style);
            switch(existsStyle.stroke){
                case 'source':
                    var nodeStyle = edge.node1.getVisual('style');
                    existsStyle.stroke = nodeStyle && nodeStyle.fill;
                    break;
                case 'target':
                    var nodeStyle = edge.node2.getVisual('style');
                    existsStyle.stroke = nodeStyle && nodeStyle.fill;
                    break;
            }
            symbolType[0] && edge.setVisual('fromSymbol', symbolType[0]);
            symbolType[1] && edge.setVisual('toSymbol', symbolType[1]);
            symbolSize[0] && edge.setVisual('fromSymbolSize', symbolSize[0]);
            symbolSize[1] && edge.setVisual('toSymbolSize', symbolSize[1]);
        });
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // @ts-nocheck

var $0425a00d02ade69a$var$KEY_DELIMITER = '-->';
/**
 * params handler
 * @param {module:echarts/model/SeriesModel} seriesModel
 * @returns {*}
 */ var $0425a00d02ade69a$var$getAutoCurvenessParams = function(seriesModel) {
    return seriesModel.get('autoCurveness') || null;
};
/**
 * Generate a list of edge curvatures, 20 is the default
 * @param {module:echarts/model/SeriesModel} seriesModel
 * @param {number} appendLength
 * @return  20 => [0, -0.2, 0.2, -0.4, 0.4, -0.6, 0.6, -0.8, 0.8, -1, 1, -1.2, 1.2, -1.4, 1.4, -1.6, 1.6, -1.8, 1.8, -2]
 */ var $0425a00d02ade69a$var$createCurveness = function(seriesModel, appendLength) {
    var autoCurvenessParmas = $0425a00d02ade69a$var$getAutoCurvenessParams(seriesModel);
    var length = 20;
    var curvenessList = [];
    // handler the function set
    if ($7a1bd9c2710fea0d$export$7e4aa119212bc614(autoCurvenessParmas)) length = autoCurvenessParmas;
    else if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(autoCurvenessParmas)) {
        seriesModel.__curvenessList = autoCurvenessParmas;
        return;
    }
    // append length
    if (appendLength > length) length = appendLength;
    // make sure the length is even
    var len = length % 2 ? length + 2 : length + 3;
    curvenessList = [];
    for(var i = 0; i < len; i++)curvenessList.push((i % 2 ? i + 1 : i) / 10 * (i % 2 ? -1 : 1));
    seriesModel.__curvenessList = curvenessList;
};
/**
 * Create different cache key data in the positive and negative directions, in order to set the curvature later
 * @param {number|string|module:echarts/data/Graph.Node} n1
 * @param {number|string|module:echarts/data/Graph.Node} n2
 * @param {module:echarts/model/SeriesModel} seriesModel
 * @returns {string} key
 */ var $0425a00d02ade69a$var$getKeyOfEdges = function(n1, n2, seriesModel) {
    var source = [
        n1.id,
        n1.dataIndex
    ].join('.');
    var target = [
        n2.id,
        n2.dataIndex
    ].join('.');
    return [
        seriesModel.uid,
        source,
        target
    ].join($0425a00d02ade69a$var$KEY_DELIMITER);
};
/**
 * get opposite key
 * @param {string} key
 * @returns {string}
 */ var $0425a00d02ade69a$var$getOppositeKey = function(key) {
    var keys = key.split($0425a00d02ade69a$var$KEY_DELIMITER);
    return [
        keys[0],
        keys[2],
        keys[1]
    ].join($0425a00d02ade69a$var$KEY_DELIMITER);
};
/**
 * get edgeMap with key
 * @param edge
 * @param {module:echarts/model/SeriesModel} seriesModel
 */ var $0425a00d02ade69a$var$getEdgeFromMap = function(edge, seriesModel) {
    var key = $0425a00d02ade69a$var$getKeyOfEdges(edge.node1, edge.node2, seriesModel);
    return seriesModel.__edgeMap[key];
};
/**
 * calculate all cases total length
 * @param edge
 * @param seriesModel
 * @returns {number}
 */ var $0425a00d02ade69a$var$getTotalLengthBetweenNodes = function(edge, seriesModel) {
    var len = $0425a00d02ade69a$var$getEdgeMapLengthWithKey($0425a00d02ade69a$var$getKeyOfEdges(edge.node1, edge.node2, seriesModel), seriesModel);
    var lenV = $0425a00d02ade69a$var$getEdgeMapLengthWithKey($0425a00d02ade69a$var$getKeyOfEdges(edge.node2, edge.node1, seriesModel), seriesModel);
    return len + lenV;
};
/**
 *
 * @param key
 */ var $0425a00d02ade69a$var$getEdgeMapLengthWithKey = function(key, seriesModel) {
    var edgeMap = seriesModel.__edgeMap;
    return edgeMap[key] ? edgeMap[key].length : 0;
};
function $0425a00d02ade69a$export$4f05389c1f2934b8(seriesModel) {
    if (!$0425a00d02ade69a$var$getAutoCurvenessParams(seriesModel)) return;
    seriesModel.__curvenessList = [];
    seriesModel.__edgeMap = {};
    // calc the array of curveness List
    $0425a00d02ade69a$var$createCurveness(seriesModel);
}
function $0425a00d02ade69a$export$c47b549eed9a7311(n1, n2, seriesModel, index) {
    if (!$0425a00d02ade69a$var$getAutoCurvenessParams(seriesModel)) return;
    var key = $0425a00d02ade69a$var$getKeyOfEdges(n1, n2, seriesModel);
    var edgeMap = seriesModel.__edgeMap;
    var oppositeEdges = edgeMap[$0425a00d02ade69a$var$getOppositeKey(key)];
    // set direction
    if (edgeMap[key] && !oppositeEdges) edgeMap[key].isForward = true;
    else if (oppositeEdges && edgeMap[key]) {
        oppositeEdges.isForward = true;
        edgeMap[key].isForward = false;
    }
    edgeMap[key] = edgeMap[key] || [];
    edgeMap[key].push(index);
}
function $0425a00d02ade69a$export$7e88123f7f1f62da(edge, seriesModel, index, needReverse) {
    var autoCurvenessParams = $0425a00d02ade69a$var$getAutoCurvenessParams(seriesModel);
    var isArrayParam = $7a1bd9c2710fea0d$export$43bee75e5e14138e(autoCurvenessParams);
    if (!autoCurvenessParams) return null;
    var edgeArray = $0425a00d02ade69a$var$getEdgeFromMap(edge, seriesModel);
    if (!edgeArray) return null;
    var edgeIndex = -1;
    for(var i = 0; i < edgeArray.length; i++)if (edgeArray[i] === index) {
        edgeIndex = i;
        break;
    }
    // if totalLen is Longer createCurveness
    var totalLen = $0425a00d02ade69a$var$getTotalLengthBetweenNodes(edge, seriesModel);
    $0425a00d02ade69a$var$createCurveness(seriesModel, totalLen);
    edge.lineStyle = edge.lineStyle || {};
    // if is opposite edge, must set curvenss to opposite number
    var curKey = $0425a00d02ade69a$var$getKeyOfEdges(edge.node1, edge.node2, seriesModel);
    var curvenessList = seriesModel.__curvenessList;
    // if pass array no need parity
    var parityCorrection = isArrayParam ? 0 : totalLen % 2 ? 0 : 1;
    if (!edgeArray.isForward) {
        // the opposite edge show outside
        var oppositeKey = $0425a00d02ade69a$var$getOppositeKey(curKey);
        var len = $0425a00d02ade69a$var$getEdgeMapLengthWithKey(oppositeKey, seriesModel);
        var resValue = curvenessList[edgeIndex + len + parityCorrection];
        // isNeedReverse, simple, force type need reverse the curveness in the junction of the forword and the opposite
        if (needReverse) {
            // set as array may make the parity handle with the len of opposite
            if (isArrayParam) {
                if (autoCurvenessParams && autoCurvenessParams[0] === 0) return (len + parityCorrection) % 2 ? resValue : -resValue;
                else return ((len % 2 ? 0 : 1) + parityCorrection) % 2 ? resValue : -resValue;
            } else return (len + parityCorrection) % 2 ? resValue : -resValue;
        } else return curvenessList[edgeIndex + len + parityCorrection];
    } else return curvenessList[parityCorrection + edgeIndex];
}


function $159cad03c3625d06$export$6d7efb25f4dcb4db(seriesModel) {
    var coordSys = seriesModel.coordinateSystem;
    if (coordSys && coordSys.type !== 'view') return;
    var graph = seriesModel.getGraph();
    graph.eachNode(function(node) {
        var model = node.getModel();
        node.setLayout([
            +model.get('x'),
            +model.get('y')
        ]);
    });
    $159cad03c3625d06$export$a25b52345bee32aa(graph, seriesModel);
}
function $159cad03c3625d06$export$a25b52345bee32aa(graph, seriesModel) {
    graph.eachEdge(function(edge, index) {
        var curveness = $7a1bd9c2710fea0d$export$2e94551289abb95b(edge.getModel().get([
            'lineStyle',
            'curveness'
        ]), -(0, $0425a00d02ade69a$export$7e88123f7f1f62da)(edge, seriesModel, index, true), 0);
        var p1 = $6de594cf8ac295ff$export$9cd59f9826255e47(edge.node1.getLayout());
        var p2 = $6de594cf8ac295ff$export$9cd59f9826255e47(edge.node2.getLayout());
        var points = [
            p1,
            p2
        ];
        if (+curveness) points.push([
            (p1[0] + p2[0]) / 2 - (p1[1] - p2[1]) * curveness,
            (p1[1] + p2[1]) / 2 - (p2[0] - p1[0]) * curveness
        ]);
        edge.setLayout(points);
    });
}


function $35717df2daa24f5d$export$2e2bcd8739ae039(ecModel, api) {
    ecModel.eachSeriesByType('graph', function(seriesModel) {
        var layout = seriesModel.get('layout');
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys && coordSys.type !== 'view') {
            var data_1 = seriesModel.getData();
            var dimensions_1 = [];
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(coordSys.dimensions, function(coordDim) {
                dimensions_1 = dimensions_1.concat(data_1.mapDimensionsAll(coordDim));
            });
            for(var dataIndex = 0; dataIndex < data_1.count(); dataIndex++){
                var value = [];
                var hasValue = false;
                for(var i = 0; i < dimensions_1.length; i++){
                    var val = data_1.get(dimensions_1[i], dataIndex);
                    if (!isNaN(val)) hasValue = true;
                    value.push(val);
                }
                if (hasValue) data_1.setItemLayout(dataIndex, coordSys.dataToPoint(value));
                else // Also {Array.<number>}, not undefined to avoid if...else... statement
                data_1.setItemLayout(dataIndex, [
                    NaN,
                    NaN
                ]);
            }
            (0, $159cad03c3625d06$export$a25b52345bee32aa)(data_1.graph, seriesModel);
        } else if (!layout || layout === 'none') (0, $159cad03c3625d06$export$6d7efb25f4dcb4db)(seriesModel);
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $ad8b4f94f577d55a$export$e2aa0fb9ed198ba7(seriesModel) {
    var coordSys = seriesModel.coordinateSystem;
    if (coordSys.type !== 'view') return 1;
    var nodeScaleRatio = seriesModel.option.nodeScaleRatio;
    var groupZoom = coordSys.scaleX;
    // Scale node when zoom changes
    var roamZoom = coordSys.getZoom();
    var nodeScale = (roamZoom - 1) * nodeScaleRatio + 1;
    return nodeScale / groupZoom;
}
function $ad8b4f94f577d55a$export$8d4a06d3facd414b(node) {
    var symbolSize = node.getVisual('symbolSize');
    if (symbolSize instanceof Array) symbolSize = (symbolSize[0] + symbolSize[1]) / 2;
    return +symbolSize;
}




var $484ee97adf82b508$var$PI = Math.PI;
var $484ee97adf82b508$var$_symbolRadiansHalf = [];
function $484ee97adf82b508$export$cbfed6ae5cab3dae(seriesModel, basedOn, draggingNode, pointer) {
    var coordSys = seriesModel.coordinateSystem;
    if (coordSys && coordSys.type !== 'view') return;
    var rect = coordSys.getBoundingRect();
    var nodeData = seriesModel.getData();
    var graph = nodeData.graph;
    var cx = rect.width / 2 + rect.x;
    var cy = rect.height / 2 + rect.y;
    var r = Math.min(rect.width, rect.height) / 2;
    var count = nodeData.count();
    nodeData.setLayout({
        cx: cx,
        cy: cy
    });
    if (!count) return;
    if (draggingNode) {
        var _a = coordSys.pointToData(pointer), tempX = _a[0], tempY = _a[1];
        var v = [
            tempX - cx,
            tempY - cy
        ];
        $6de594cf8ac295ff$export$a3295358bff77e(v, v);
        $6de594cf8ac295ff$export$dcdf75081b88279d(v, v, r);
        draggingNode.setLayout([
            cx + v[0],
            cy + v[1]
        ], true);
        var circularRotateLabel = seriesModel.get([
            'circular',
            'rotateLabel'
        ]);
        $484ee97adf82b508$export$c768377a6a0a9ab8(draggingNode, circularRotateLabel, cx, cy);
    }
    $484ee97adf82b508$var$_layoutNodesBasedOn[basedOn](seriesModel, graph, nodeData, r, cx, cy, count);
    graph.eachEdge(function(edge, index) {
        var curveness = $7a1bd9c2710fea0d$export$2e94551289abb95b(edge.getModel().get([
            'lineStyle',
            'curveness'
        ]), (0, $0425a00d02ade69a$export$7e88123f7f1f62da)(edge, seriesModel, index), 0);
        var p1 = $6de594cf8ac295ff$export$9cd59f9826255e47(edge.node1.getLayout());
        var p2 = $6de594cf8ac295ff$export$9cd59f9826255e47(edge.node2.getLayout());
        var cp1;
        var x12 = (p1[0] + p2[0]) / 2;
        var y12 = (p1[1] + p2[1]) / 2;
        if (+curveness) {
            curveness *= 3;
            cp1 = [
                cx * curveness + x12 * (1 - curveness),
                cy * curveness + y12 * (1 - curveness)
            ];
        }
        edge.setLayout([
            p1,
            p2,
            cp1
        ]);
    });
}
var $484ee97adf82b508$var$_layoutNodesBasedOn = {
    value: function(seriesModel, graph, nodeData, r, cx, cy, count) {
        var angle = 0;
        var sum = nodeData.getSum('value');
        var unitAngle = Math.PI * 2 / (sum || count);
        graph.eachNode(function(node) {
            var value = node.getValue('value');
            var radianHalf = unitAngle * (sum ? value : 1) / 2;
            angle += radianHalf;
            node.setLayout([
                r * Math.cos(angle) + cx,
                r * Math.sin(angle) + cy
            ]);
            angle += radianHalf;
        });
    },
    symbolSize: function(seriesModel, graph, nodeData, r, cx, cy, count) {
        var sumRadian = 0;
        $484ee97adf82b508$var$_symbolRadiansHalf.length = count;
        var nodeScale = (0, $ad8b4f94f577d55a$export$e2aa0fb9ed198ba7)(seriesModel);
        graph.eachNode(function(node) {
            var symbolSize = (0, $ad8b4f94f577d55a$export$8d4a06d3facd414b)(node);
            // Normally this case will not happen, but we still add
            // some the defensive code (2px is an arbitrary value).
            isNaN(symbolSize) && (symbolSize = 2);
            symbolSize < 0 && (symbolSize = 0);
            symbolSize *= nodeScale;
            var symbolRadianHalf = Math.asin(symbolSize / 2 / r);
            // when `symbolSize / 2` is bigger than `r`.
            isNaN(symbolRadianHalf) && (symbolRadianHalf = $484ee97adf82b508$var$PI / 2);
            $484ee97adf82b508$var$_symbolRadiansHalf[node.dataIndex] = symbolRadianHalf;
            sumRadian += symbolRadianHalf * 2;
        });
        var halfRemainRadian = (2 * $484ee97adf82b508$var$PI - sumRadian) / count / 2;
        var angle = 0;
        graph.eachNode(function(node) {
            var radianHalf = halfRemainRadian + $484ee97adf82b508$var$_symbolRadiansHalf[node.dataIndex];
            angle += radianHalf;
            // init circular layout for
            // 1. layout undefined node
            // 2. not fixed node
            (!node.getLayout() || !node.getLayout().fixed) && node.setLayout([
                r * Math.cos(angle) + cx,
                r * Math.sin(angle) + cy
            ]);
            angle += radianHalf;
        });
    }
};
function $484ee97adf82b508$export$c768377a6a0a9ab8(node, circularRotateLabel, cx, cy) {
    var el = node.getGraphicEl();
    // need to check if el exists. '-' value may not create node element.
    if (!el) return;
    var nodeModel = node.getModel();
    var labelRotate = nodeModel.get([
        'label',
        'rotate'
    ]) || 0;
    var symbolPath = el.getSymbolPath();
    if (circularRotateLabel) {
        var pos = node.getLayout();
        var rad = Math.atan2(pos[1] - cy, pos[0] - cx);
        if (rad < 0) rad = Math.PI * 2 + rad;
        var isLeft = pos[0] < cx;
        if (isLeft) rad = rad - Math.PI;
        var textPosition = isLeft ? 'left' : 'right';
        symbolPath.setTextConfig({
            rotation: -rad,
            position: textPosition,
            origin: 'center'
        });
        var emphasisState = symbolPath.ensureState('emphasis');
        $7a1bd9c2710fea0d$export$8b58be045bf06082(emphasisState.textConfig || (emphasisState.textConfig = {}), {
            position: textPosition
        });
    } else symbolPath.setTextConfig({
        rotation: labelRotate *= Math.PI / 180
    });
}


function $3c017b875f1b19fb$export$2e2bcd8739ae039(ecModel) {
    ecModel.eachSeriesByType('graph', function(seriesModel) {
        if (seriesModel.get('layout') === 'circular') (0, $484ee97adf82b508$export$cbfed6ae5cab3dae)(seriesModel, 'symbolSize');
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* A third-party license is embedded for some of the code in this file:
* Some formulas were originally copied from "d3.js" with some
* modifications made for this project.
* (See more details in the comment of the method "step" below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the license of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/ 
var $b2cd6170c8983d43$var$scaleAndAdd = $6de594cf8ac295ff$export$19cedf1da84ba854;
function $b2cd6170c8983d43$export$100e93b4853dcbde(inNodes, inEdges, opts) {
    var nodes = inNodes;
    var edges = inEdges;
    var rect = opts.rect;
    var width = rect.width;
    var height = rect.height;
    var center = [
        rect.x + width / 2,
        rect.y + height / 2
    ];
    // let scale = opts.scale || 1;
    var gravity = opts.gravity == null ? 0.1 : opts.gravity;
    // for (let i = 0; i < edges.length; i++) {
    //     let e = edges[i];
    //     let n1 = e.n1;
    //     let n2 = e.n2;
    //     n1.edges = n1.edges || [];
    //     n2.edges = n2.edges || [];
    //     n1.edges.push(e);
    //     n2.edges.push(e);
    // }
    // Init position
    for(var i = 0; i < nodes.length; i++){
        var n = nodes[i];
        if (!n.p) n.p = $6de594cf8ac295ff$export$185802fd694ee1f5(width * (Math.random() - 0.5) + center[0], height * (Math.random() - 0.5) + center[1]);
        n.pp = $6de594cf8ac295ff$export$9cd59f9826255e47(n.p);
        n.edges = null;
    }
    // Formula in 'Graph Drawing by Force-directed Placement'
    // let k = scale * Math.sqrt(width * height / nodes.length);
    // let k2 = k * k;
    var initialFriction = opts.friction == null ? 0.6 : opts.friction;
    var friction = initialFriction;
    var beforeStepCallback;
    var afterStepCallback;
    return {
        warmUp: function() {
            friction = initialFriction * 0.8;
        },
        setFixed: function(idx) {
            nodes[idx].fixed = true;
        },
        setUnfixed: function(idx) {
            nodes[idx].fixed = false;
        },
        /**
     * Before step hook
     */ beforeStep: function(cb) {
            beforeStepCallback = cb;
        },
        /**
     * After step hook
     */ afterStep: function(cb) {
            afterStepCallback = cb;
        },
        /**
     * Some formulas were originally copied from "d3.js"
     * https://github.com/d3/d3/blob/b516d77fb8566b576088e73410437494717ada26/src/layout/force.js
     * with some modifications made for this project.
     * See the license statement at the head of this file.
     */ step: function(cb) {
            beforeStepCallback && beforeStepCallback(nodes, edges);
            var v12 = [];
            var nLen = nodes.length;
            for(var i = 0; i < edges.length; i++){
                var e = edges[i];
                if (e.ignoreForceLayout) continue;
                var n1 = e.n1;
                var n2 = e.n2;
                $6de594cf8ac295ff$export$f93b5905241a7cca(v12, n2.p, n1.p);
                var d = $6de594cf8ac295ff$export$fc1400facf92c78(v12) - e.d;
                var w = n2.w / (n1.w + n2.w);
                if (isNaN(w)) w = 0;
                $6de594cf8ac295ff$export$a3295358bff77e(v12, v12);
                !n1.fixed && $b2cd6170c8983d43$var$scaleAndAdd(n1.p, n1.p, v12, w * d * friction);
                !n2.fixed && $b2cd6170c8983d43$var$scaleAndAdd(n2.p, n2.p, v12, -(1 - w) * d * friction);
            }
            // Gravity
            for(var i = 0; i < nLen; i++){
                var n = nodes[i];
                if (!n.fixed) {
                    $6de594cf8ac295ff$export$f93b5905241a7cca(v12, center, n.p);
                    // let d = vec2.len(v12);
                    // vec2.scale(v12, v12, 1 / d);
                    // let gravityFactor = gravity;
                    $b2cd6170c8983d43$var$scaleAndAdd(n.p, n.p, v12, gravity * friction);
                }
            }
            // Repulsive
            // PENDING
            for(var i = 0; i < nLen; i++){
                var n1 = nodes[i];
                for(var j = i + 1; j < nLen; j++){
                    var n2 = nodes[j];
                    $6de594cf8ac295ff$export$f93b5905241a7cca(v12, n2.p, n1.p);
                    var d = $6de594cf8ac295ff$export$fc1400facf92c78(v12);
                    if (d === 0) {
                        // Random repulse
                        $6de594cf8ac295ff$export$adaa4cf7ef1b65be(v12, Math.random() - 0.5, Math.random() - 0.5);
                        d = 1;
                    }
                    var repFact = (n1.rep + n2.rep) / d / d;
                    !n1.fixed && $b2cd6170c8983d43$var$scaleAndAdd(n1.pp, n1.pp, v12, repFact);
                    !n2.fixed && $b2cd6170c8983d43$var$scaleAndAdd(n2.pp, n2.pp, v12, -repFact);
                }
            }
            var v = [];
            for(var i = 0; i < nLen; i++){
                var n = nodes[i];
                if (!n.fixed) {
                    $6de594cf8ac295ff$export$f93b5905241a7cca(v, n.p, n.pp);
                    $b2cd6170c8983d43$var$scaleAndAdd(n.p, n.p, v, friction);
                    $6de594cf8ac295ff$export$784d13d8ee351f07(n.pp, n.p);
                }
            }
            friction = friction * 0.992;
            var finished = friction < 0.01;
            afterStepCallback && afterStepCallback(nodes, edges, finished);
            cb && cb(finished);
        }
    };
}








function $cd6209901c0041df$export$2e2bcd8739ae039(ecModel) {
    ecModel.eachSeriesByType('graph', function(graphSeries) {
        var coordSys = graphSeries.coordinateSystem;
        if (coordSys && coordSys.type !== 'view') return;
        if (graphSeries.get('layout') === 'force') {
            var preservedPoints_1 = graphSeries.preservedPoints || {};
            var graph_1 = graphSeries.getGraph();
            var nodeData_1 = graph_1.data;
            var edgeData = graph_1.edgeData;
            var forceModel = graphSeries.getModel('force');
            var initLayout = forceModel.get('initLayout');
            if (graphSeries.preservedPoints) nodeData_1.each(function(idx) {
                var id = nodeData_1.getId(idx);
                nodeData_1.setItemLayout(idx, preservedPoints_1[id] || [
                    NaN,
                    NaN
                ]);
            });
            else if (!initLayout || initLayout === 'none') (0, $159cad03c3625d06$export$6d7efb25f4dcb4db)(graphSeries);
            else if (initLayout === 'circular') (0, $484ee97adf82b508$export$cbfed6ae5cab3dae)(graphSeries, 'value');
            var nodeDataExtent_1 = nodeData_1.getDataExtent('value');
            var edgeDataExtent_1 = edgeData.getDataExtent('value');
            // let edgeDataExtent = edgeData.getDataExtent('value');
            var repulsion = forceModel.get('repulsion');
            var edgeLength = forceModel.get('edgeLength');
            var repulsionArr_1 = $7a1bd9c2710fea0d$export$43bee75e5e14138e(repulsion) ? repulsion : [
                repulsion,
                repulsion
            ];
            var edgeLengthArr_1 = $7a1bd9c2710fea0d$export$43bee75e5e14138e(edgeLength) ? edgeLength : [
                edgeLength,
                edgeLength
            ];
            // Larger value has smaller length
            edgeLengthArr_1 = [
                edgeLengthArr_1[1],
                edgeLengthArr_1[0]
            ];
            var nodes_1 = nodeData_1.mapArray('value', function(value, idx) {
                var point = nodeData_1.getItemLayout(idx);
                var rep = (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(value, nodeDataExtent_1, repulsionArr_1);
                if (isNaN(rep)) rep = (repulsionArr_1[0] + repulsionArr_1[1]) / 2;
                return {
                    w: rep,
                    rep: rep,
                    fixed: nodeData_1.getItemModel(idx).get('fixed'),
                    p: !point || isNaN(point[0]) || isNaN(point[1]) ? null : point
                };
            });
            var edges = edgeData.mapArray('value', function(value, idx) {
                var edge = graph_1.getEdgeByIndex(idx);
                var d = (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(value, edgeDataExtent_1, edgeLengthArr_1);
                if (isNaN(d)) d = (edgeLengthArr_1[0] + edgeLengthArr_1[1]) / 2;
                var edgeModel = edge.getModel();
                var curveness = $7a1bd9c2710fea0d$export$2e94551289abb95b(edge.getModel().get([
                    'lineStyle',
                    'curveness'
                ]), -(0, $0425a00d02ade69a$export$7e88123f7f1f62da)(edge, graphSeries, idx, true), 0);
                return {
                    n1: nodes_1[edge.node1.dataIndex],
                    n2: nodes_1[edge.node2.dataIndex],
                    d: d,
                    curveness: curveness,
                    ignoreForceLayout: edgeModel.get('ignoreForceLayout')
                };
            });
            // let coordSys = graphSeries.coordinateSystem;
            var rect = coordSys.getBoundingRect();
            var forceInstance = (0, $b2cd6170c8983d43$export$100e93b4853dcbde)(nodes_1, edges, {
                rect: rect,
                gravity: forceModel.get('gravity'),
                friction: forceModel.get('friction')
            });
            forceInstance.beforeStep(function(nodes, edges) {
                for(var i = 0, l = nodes.length; i < l; i++)if (nodes[i].fixed) // Write back to layout instance
                $6de594cf8ac295ff$export$784d13d8ee351f07(nodes[i].p, graph_1.getNodeByIndex(i).getLayout());
            });
            forceInstance.afterStep(function(nodes, edges, stopped) {
                for(var i = 0, l = nodes.length; i < l; i++){
                    if (!nodes[i].fixed) graph_1.getNodeByIndex(i).setLayout(nodes[i].p);
                    preservedPoints_1[nodeData_1.getId(i)] = nodes[i].p;
                }
                for(var i = 0, l = edges.length; i < l; i++){
                    var e = edges[i];
                    var edge = graph_1.getEdgeByIndex(i);
                    var p1 = e.n1.p;
                    var p2 = e.n2.p;
                    var points = edge.getLayout();
                    points = points ? points.slice() : [];
                    points[0] = points[0] || [];
                    points[1] = points[1] || [];
                    $6de594cf8ac295ff$export$784d13d8ee351f07(points[0], p1);
                    $6de594cf8ac295ff$export$784d13d8ee351f07(points[1], p2);
                    if (+e.curveness) points[2] = [
                        (p1[0] + p2[0]) / 2 - (p1[1] - p2[1]) * e.curveness,
                        (p1[1] + p2[1]) / 2 - (p2[0] - p1[0]) * e.curveness
                    ];
                    edge.setLayout(points);
                }
            });
            graphSeries.forceLayout = forceInstance;
            graphSeries.preservedPoints = preservedPoints_1;
            // Step to get the layout
            forceInstance.step();
        } else // Remove prev injected forceLayout instance
        graphSeries.forceLayout = null;
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // FIXME Where to create the simple view coordinate system
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $4a92e7570d47c1fe$var$v2ApplyTransform = $6de594cf8ac295ff$export$9f9dcb98c894b623;
var $4a92e7570d47c1fe$var$View = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(View, _super);
    function View(name) {
        var _this = _super.call(this) || this;
        _this.type = 'view';
        _this.dimensions = [
            'x',
            'y'
        ];
        /**
     * Represents the transform brought by roam/zoom.
     * If `View['_viewRect']` applies roam transform,
     * we can get the final displayed rect.
     */ _this._roamTransformable = new (0, $becf2d727f9cf450$export$2e2bcd8739ae039)();
        /**
     * Represents the transform from `View['_rect']` to `View['_viewRect']`.
     */ _this._rawTransformable = new (0, $becf2d727f9cf450$export$2e2bcd8739ae039)();
        _this.name = name;
        return _this;
    }
    View.prototype.setBoundingRect = function(x, y, width, height) {
        this._rect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(x, y, width, height);
        return this._rect;
    };
    /**
   * @return {module:zrender/core/BoundingRect}
   */ View.prototype.getBoundingRect = function() {
        return this._rect;
    };
    View.prototype.setViewRect = function(x, y, width, height) {
        this._transformTo(x, y, width, height);
        this._viewRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(x, y, width, height);
    };
    /**
   * Transformed to particular position and size
   */ View.prototype._transformTo = function(x, y, width, height) {
        var rect = this.getBoundingRect();
        var rawTransform = this._rawTransformable;
        rawTransform.transform = rect.calculateTransform(new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(x, y, width, height));
        var rawParent = rawTransform.parent;
        rawTransform.parent = null;
        rawTransform.decomposeTransform();
        rawTransform.parent = rawParent;
        this._updateTransform();
    };
    /**
   * Set center of view
   */ View.prototype.setCenter = function(centerCoord, api) {
        if (!centerCoord) return;
        this._center = [
            (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(centerCoord[0], api.getWidth()),
            (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(centerCoord[1], api.getHeight())
        ];
        this._updateCenterAndZoom();
    };
    View.prototype.setZoom = function(zoom) {
        zoom = zoom || 1;
        var zoomLimit = this.zoomLimit;
        if (zoomLimit) {
            if (zoomLimit.max != null) zoom = Math.min(zoomLimit.max, zoom);
            if (zoomLimit.min != null) zoom = Math.max(zoomLimit.min, zoom);
        }
        this._zoom = zoom;
        this._updateCenterAndZoom();
    };
    /**
   * Get default center without roam
   */ View.prototype.getDefaultCenter = function() {
        // Rect before any transform
        var rawRect = this.getBoundingRect();
        var cx = rawRect.x + rawRect.width / 2;
        var cy = rawRect.y + rawRect.height / 2;
        return [
            cx,
            cy
        ];
    };
    View.prototype.getCenter = function() {
        return this._center || this.getDefaultCenter();
    };
    View.prototype.getZoom = function() {
        return this._zoom || 1;
    };
    View.prototype.getRoamTransform = function() {
        return this._roamTransformable.getLocalTransform();
    };
    /**
   * Remove roam
   */ View.prototype._updateCenterAndZoom = function() {
        // Must update after view transform updated
        var rawTransformMatrix = this._rawTransformable.getLocalTransform();
        var roamTransform = this._roamTransformable;
        var defaultCenter = this.getDefaultCenter();
        var center = this.getCenter();
        var zoom = this.getZoom();
        center = $6de594cf8ac295ff$export$9f9dcb98c894b623([], center, rawTransformMatrix);
        defaultCenter = $6de594cf8ac295ff$export$9f9dcb98c894b623([], defaultCenter, rawTransformMatrix);
        roamTransform.originX = center[0];
        roamTransform.originY = center[1];
        roamTransform.x = defaultCenter[0] - center[0];
        roamTransform.y = defaultCenter[1] - center[1];
        roamTransform.scaleX = roamTransform.scaleY = zoom;
        this._updateTransform();
    };
    /**
   * Update transform props on `this` based on the current
   * `this._roamTransformable` and `this._rawTransformable`.
   */ View.prototype._updateTransform = function() {
        var roamTransformable = this._roamTransformable;
        var rawTransformable = this._rawTransformable;
        rawTransformable.parent = roamTransformable;
        roamTransformable.updateTransform();
        rawTransformable.updateTransform();
        $f41ebb9dd60b55b4$export$784d13d8ee351f07(this.transform || (this.transform = []), rawTransformable.transform || $f41ebb9dd60b55b4$export$185802fd694ee1f5());
        this._rawTransform = rawTransformable.getLocalTransform();
        this.invTransform = this.invTransform || [];
        $f41ebb9dd60b55b4$export$6897c284b6f9f4dc(this.invTransform, this.transform);
        this.decomposeTransform();
    };
    View.prototype.getTransformInfo = function() {
        var rawTransformable = this._rawTransformable;
        var roamTransformable = this._roamTransformable;
        // Because roamTransformabel has `originX/originY` modified,
        // but the caller of `getTransformInfo` can not handle `originX/originY`,
        // so need to recalculate them.
        var dummyTransformable = new (0, $becf2d727f9cf450$export$2e2bcd8739ae039)();
        dummyTransformable.transform = roamTransformable.transform;
        dummyTransformable.decomposeTransform();
        return {
            roam: {
                x: dummyTransformable.x,
                y: dummyTransformable.y,
                scaleX: dummyTransformable.scaleX,
                scaleY: dummyTransformable.scaleY
            },
            raw: {
                x: rawTransformable.x,
                y: rawTransformable.y,
                scaleX: rawTransformable.scaleX,
                scaleY: rawTransformable.scaleY
            }
        };
    };
    View.prototype.getViewRect = function() {
        return this._viewRect;
    };
    /**
   * Get view rect after roam transform
   */ View.prototype.getViewRectAfterRoam = function() {
        var rect = this.getBoundingRect().clone();
        rect.applyTransform(this.transform);
        return rect;
    };
    /**
   * Convert a single (lon, lat) data item to (x, y) point.
   */ View.prototype.dataToPoint = function(data, noRoam, out) {
        var transform = noRoam ? this._rawTransform : this.transform;
        out = out || [];
        return transform ? $4a92e7570d47c1fe$var$v2ApplyTransform(out, data, transform) : $6de594cf8ac295ff$export$784d13d8ee351f07(out, data);
    };
    /**
   * Convert a (x, y) point to (lon, lat) data
   */ View.prototype.pointToData = function(point) {
        var invTransform = this.invTransform;
        return invTransform ? $4a92e7570d47c1fe$var$v2ApplyTransform([], point, invTransform) : [
            point[0],
            point[1]
        ];
    };
    View.prototype.convertToPixel = function(ecModel, finder, value) {
        var coordSys = $4a92e7570d47c1fe$var$getCoordSys(finder);
        return coordSys === this ? coordSys.dataToPoint(value) : null;
    };
    View.prototype.convertFromPixel = function(ecModel, finder, pixel) {
        var coordSys = $4a92e7570d47c1fe$var$getCoordSys(finder);
        return coordSys === this ? coordSys.pointToData(pixel) : null;
    };
    /**
   * @implements
   */ View.prototype.containPoint = function(point) {
        return this.getViewRectAfterRoam().contain(point[0], point[1]);
    };
    View.dimensions = [
        'x',
        'y'
    ];
    return View;
}((0, $becf2d727f9cf450$export$2e2bcd8739ae039));
function $4a92e7570d47c1fe$var$getCoordSys(finder) {
    var seriesModel = finder.seriesModel;
    return seriesModel ? seriesModel.coordinateSystem : null; // e.g., graph.
}
var $4a92e7570d47c1fe$export$2e2bcd8739ae039 = $4a92e7570d47c1fe$var$View;





function $8491beaca48712b9$var$getViewRect(seriesModel, api, aspect) {
    var option = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(seriesModel.getBoxLayoutParams(), {
        aspect: aspect
    });
    return (0, $93b9bc7f22ac7369$export$4517a5ca639a7293)(option, {
        width: api.getWidth(),
        height: api.getHeight()
    });
}
function $8491beaca48712b9$export$2e2bcd8739ae039(ecModel, api) {
    var viewList = [];
    ecModel.eachSeriesByType('graph', function(seriesModel) {
        var coordSysType = seriesModel.get('coordinateSystem');
        if (!coordSysType || coordSysType === 'view') {
            var data_1 = seriesModel.getData();
            var positions = data_1.mapArray(function(idx) {
                var itemModel = data_1.getItemModel(idx);
                return [
                    +itemModel.get('x'),
                    +itemModel.get('y')
                ];
            });
            var min = [];
            var max = [];
            $af3aab2435198f82$export$188c3cd07b4129dd(positions, min, max);
            // If width or height is 0
            if (max[0] - min[0] === 0) {
                max[0] += 1;
                min[0] -= 1;
            }
            if (max[1] - min[1] === 0) {
                max[1] += 1;
                min[1] -= 1;
            }
            var aspect = (max[0] - min[0]) / (max[1] - min[1]);
            // FIXME If get view rect after data processed?
            var viewRect = $8491beaca48712b9$var$getViewRect(seriesModel, api, aspect);
            // Position may be NaN, use view rect instead
            if (isNaN(aspect)) {
                min = [
                    viewRect.x,
                    viewRect.y
                ];
                max = [
                    viewRect.x + viewRect.width,
                    viewRect.y + viewRect.height
                ];
            }
            var bbWidth = max[0] - min[0];
            var bbHeight = max[1] - min[1];
            var viewWidth = viewRect.width;
            var viewHeight = viewRect.height;
            var viewCoordSys = seriesModel.coordinateSystem = new (0, $4a92e7570d47c1fe$export$2e2bcd8739ae039)();
            viewCoordSys.zoomLimit = seriesModel.get('scaleLimit');
            viewCoordSys.setBoundingRect(min[0], min[1], bbWidth, bbHeight);
            viewCoordSys.setViewRect(viewRect.x, viewRect.y, viewWidth, viewHeight);
            // Update roam info
            viewCoordSys.setCenter(seriesModel.get('center'), api);
            viewCoordSys.setZoom(seriesModel.get('zoom'));
            viewList.push(viewCoordSys);
        }
    });
    return viewList;
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $ab7bf64951ce094b$var$straightLineProto = $7a316ae5ceff7b27$export$2e2bcd8739ae039.prototype;
var $ab7bf64951ce094b$var$bezierCurveProto = $6c7800c49630e431$export$2e2bcd8739ae039.prototype;
var $ab7bf64951ce094b$var$StraightLineShape = /** @class */ function() {
    function StraightLineShape() {
        // Start point
        this.x1 = 0;
        this.y1 = 0;
        // End point
        this.x2 = 0;
        this.y2 = 0;
        this.percent = 1;
    }
    return StraightLineShape;
}();
var $ab7bf64951ce094b$var$CurveShape = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(CurveShape, _super);
    function CurveShape() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CurveShape;
}($ab7bf64951ce094b$var$StraightLineShape);
function $ab7bf64951ce094b$var$isStraightLine(shape) {
    return isNaN(+shape.cpx1) || isNaN(+shape.cpy1);
}
var $ab7bf64951ce094b$var$ECLinePath = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ECLinePath, _super);
    function ECLinePath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'ec-line';
        return _this;
    }
    ECLinePath.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    ECLinePath.prototype.getDefaultShape = function() {
        return new $ab7bf64951ce094b$var$StraightLineShape();
    };
    ECLinePath.prototype.buildPath = function(ctx, shape) {
        if ($ab7bf64951ce094b$var$isStraightLine(shape)) $ab7bf64951ce094b$var$straightLineProto.buildPath.call(this, ctx, shape);
        else $ab7bf64951ce094b$var$bezierCurveProto.buildPath.call(this, ctx, shape);
    };
    ECLinePath.prototype.pointAt = function(t) {
        if ($ab7bf64951ce094b$var$isStraightLine(this.shape)) return $ab7bf64951ce094b$var$straightLineProto.pointAt.call(this, t);
        else return $ab7bf64951ce094b$var$bezierCurveProto.pointAt.call(this, t);
    };
    ECLinePath.prototype.tangentAt = function(t) {
        var shape = this.shape;
        var p = $ab7bf64951ce094b$var$isStraightLine(shape) ? [
            shape.x2 - shape.x1,
            shape.y2 - shape.y1
        ] : $ab7bf64951ce094b$var$bezierCurveProto.tangentAt.call(this, t);
        return $6de594cf8ac295ff$export$a3295358bff77e(p, p);
    };
    return ECLinePath;
}($b02ffe7acd508c08$export$2e2bcd8739ae039);
var $ab7bf64951ce094b$export$2e2bcd8739ae039 = $ab7bf64951ce094b$var$ECLinePath;






var $9e0b5f801ab5090c$var$SYMBOL_CATEGORIES = [
    'fromSymbol',
    'toSymbol'
];
function $9e0b5f801ab5090c$var$makeSymbolTypeKey(symbolCategory) {
    return '_' + symbolCategory + 'Type';
}
function $9e0b5f801ab5090c$var$makeSymbolTypeValue(name, lineData, idx) {
    var symbolType = lineData.getItemVisual(idx, name);
    if (!symbolType || symbolType === 'none') return symbolType;
    var symbolSize = lineData.getItemVisual(idx, name + 'Size');
    var symbolRotate = lineData.getItemVisual(idx, name + 'Rotate');
    var symbolOffset = lineData.getItemVisual(idx, name + 'Offset');
    var symbolKeepAspect = lineData.getItemVisual(idx, name + 'KeepAspect');
    var symbolSizeArr = $5370466dadc978d7$export$a84524f03e8e8dfb(symbolSize);
    var symbolOffsetArr = $5370466dadc978d7$export$e3e292895c033f6d(symbolOffset || 0, symbolSizeArr);
    return symbolType + symbolSizeArr + symbolOffsetArr + (symbolRotate || '') + (symbolKeepAspect || '');
}
/**
 * @inner
 */ function $9e0b5f801ab5090c$var$createSymbol(name, lineData, idx) {
    var symbolType = lineData.getItemVisual(idx, name);
    if (!symbolType || symbolType === 'none') return;
    var symbolSize = lineData.getItemVisual(idx, name + 'Size');
    var symbolRotate = lineData.getItemVisual(idx, name + 'Rotate');
    var symbolOffset = lineData.getItemVisual(idx, name + 'Offset');
    var symbolKeepAspect = lineData.getItemVisual(idx, name + 'KeepAspect');
    var symbolSizeArr = $5370466dadc978d7$export$a84524f03e8e8dfb(symbolSize);
    var symbolOffsetArr = $5370466dadc978d7$export$e3e292895c033f6d(symbolOffset || 0, symbolSizeArr);
    var symbolPath = $5370466dadc978d7$export$af050e04da3a02e8(symbolType, -symbolSizeArr[0] / 2 + symbolOffsetArr[0], -symbolSizeArr[1] / 2 + symbolOffsetArr[1], symbolSizeArr[0], symbolSizeArr[1], null, symbolKeepAspect);
    symbolPath.__specifiedRotation = symbolRotate == null || isNaN(symbolRotate) ? void 0 : +symbolRotate * Math.PI / 180 || 0;
    symbolPath.name = name;
    return symbolPath;
}
function $9e0b5f801ab5090c$var$createLine(points) {
    var line = new (0, $ab7bf64951ce094b$export$2e2bcd8739ae039)({
        name: 'line',
        subPixelOptimize: true
    });
    $9e0b5f801ab5090c$var$setLinePoints(line.shape, points);
    return line;
}
function $9e0b5f801ab5090c$var$setLinePoints(targetShape, points) {
    targetShape.x1 = points[0][0];
    targetShape.y1 = points[0][1];
    targetShape.x2 = points[1][0];
    targetShape.y2 = points[1][1];
    targetShape.percent = 1;
    var cp1 = points[2];
    if (cp1) {
        targetShape.cpx1 = cp1[0];
        targetShape.cpy1 = cp1[1];
    } else {
        targetShape.cpx1 = NaN;
        targetShape.cpy1 = NaN;
    }
}
var $9e0b5f801ab5090c$var$Line = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(Line, _super);
    function Line(lineData, idx, seriesScope) {
        var _this = _super.call(this) || this;
        _this._createLine(lineData, idx, seriesScope);
        return _this;
    }
    Line.prototype._createLine = function(lineData, idx, seriesScope) {
        var seriesModel = lineData.hostModel;
        var linePoints = lineData.getItemLayout(idx);
        var line = $9e0b5f801ab5090c$var$createLine(linePoints);
        line.shape.percent = 0;
        $8b353638fbedfefa$export$a121566aadcfe021(line, {
            shape: {
                percent: 1
            }
        }, seriesModel, idx);
        this.add(line);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($9e0b5f801ab5090c$var$SYMBOL_CATEGORIES, function(symbolCategory) {
            var symbol = $9e0b5f801ab5090c$var$createSymbol(symbolCategory, lineData, idx);
            // symbols must added after line to make sure
            // it will be updated after line#update.
            // Or symbol position and rotation update in line#beforeUpdate will be one frame slow
            this.add(symbol);
            this[$9e0b5f801ab5090c$var$makeSymbolTypeKey(symbolCategory)] = $9e0b5f801ab5090c$var$makeSymbolTypeValue(symbolCategory, lineData, idx);
        }, this);
        this._updateCommonStl(lineData, idx, seriesScope);
    };
    // TODO More strict on the List type in parameters?
    Line.prototype.updateData = function(lineData, idx, seriesScope) {
        var seriesModel = lineData.hostModel;
        var line = this.childOfName('line');
        var linePoints = lineData.getItemLayout(idx);
        var target = {
            shape: {}
        };
        $9e0b5f801ab5090c$var$setLinePoints(target.shape, linePoints);
        $8b353638fbedfefa$export$c8dce3c08436e91e(line, target, seriesModel, idx);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($9e0b5f801ab5090c$var$SYMBOL_CATEGORIES, function(symbolCategory) {
            var symbolType = $9e0b5f801ab5090c$var$makeSymbolTypeValue(symbolCategory, lineData, idx);
            var key = $9e0b5f801ab5090c$var$makeSymbolTypeKey(symbolCategory);
            // Symbol changed
            if (this[key] !== symbolType) {
                this.remove(this.childOfName(symbolCategory));
                var symbol = $9e0b5f801ab5090c$var$createSymbol(symbolCategory, lineData, idx);
                this.add(symbol);
            }
            this[key] = symbolType;
        }, this);
        this._updateCommonStl(lineData, idx, seriesScope);
    };
    Line.prototype.getLinePath = function() {
        return this.childAt(0);
    };
    Line.prototype._updateCommonStl = function(lineData, idx, seriesScope) {
        var seriesModel = lineData.hostModel;
        var line = this.childOfName('line');
        var emphasisLineStyle = seriesScope && seriesScope.emphasisLineStyle;
        var blurLineStyle = seriesScope && seriesScope.blurLineStyle;
        var selectLineStyle = seriesScope && seriesScope.selectLineStyle;
        var labelStatesModels = seriesScope && seriesScope.labelStatesModels;
        var emphasisDisabled = seriesScope && seriesScope.emphasisDisabled;
        var focus = seriesScope && seriesScope.focus;
        var blurScope = seriesScope && seriesScope.blurScope;
        // Optimization for large dataset
        if (!seriesScope || lineData.hasItemOption) {
            var itemModel = lineData.getItemModel(idx);
            var emphasisModel = itemModel.getModel('emphasis');
            emphasisLineStyle = emphasisModel.getModel('lineStyle').getLineStyle();
            blurLineStyle = itemModel.getModel([
                'blur',
                'lineStyle'
            ]).getLineStyle();
            selectLineStyle = itemModel.getModel([
                'select',
                'lineStyle'
            ]).getLineStyle();
            emphasisDisabled = emphasisModel.get('disabled');
            focus = emphasisModel.get('focus');
            blurScope = emphasisModel.get('blurScope');
            labelStatesModels = (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(itemModel);
        }
        var lineStyle = lineData.getItemVisual(idx, 'style');
        var visualColor = lineStyle.stroke;
        line.useStyle(lineStyle);
        line.style.fill = null;
        line.style.strokeNoScale = true;
        line.ensureState('emphasis').style = emphasisLineStyle;
        line.ensureState('blur').style = blurLineStyle;
        line.ensureState('select').style = selectLineStyle;
        // Update symbol
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($9e0b5f801ab5090c$var$SYMBOL_CATEGORIES, function(symbolCategory) {
            var symbol = this.childOfName(symbolCategory);
            if (symbol) {
                // Share opacity and color with line.
                symbol.setColor(visualColor);
                symbol.style.opacity = lineStyle.opacity;
                for(var i = 0; i < (0, $2bf82c0980125b62$export$151308dceb52d5b).length; i++){
                    var stateName = (0, $2bf82c0980125b62$export$151308dceb52d5b)[i];
                    var lineState = line.getState(stateName);
                    if (lineState) {
                        var lineStateStyle = lineState.style || {};
                        var state = symbol.ensureState(stateName);
                        var stateStyle = state.style || (state.style = {});
                        if (lineStateStyle.stroke != null) stateStyle[symbol.__isEmptyBrush ? 'stroke' : 'fill'] = lineStateStyle.stroke;
                        if (lineStateStyle.opacity != null) stateStyle.opacity = lineStateStyle.opacity;
                    }
                }
                symbol.markRedraw();
            }
        }, this);
        var rawVal = seriesModel.getRawValue(idx);
        (0, $6800dfcb6e1e2a44$export$9a13992917966657)(this, labelStatesModels, {
            labelDataIndex: idx,
            labelFetcher: {
                getFormattedLabel: function(dataIndex, stateName) {
                    return seriesModel.getFormattedLabel(dataIndex, stateName, lineData.dataType);
                }
            },
            inheritColor: visualColor || '#000',
            defaultOpacity: lineStyle.opacity,
            defaultText: (rawVal == null ? lineData.getName(idx) : isFinite(rawVal) ? (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(rawVal) : rawVal) + ''
        });
        var label = this.getTextContent();
        // Always set `textStyle` even if `normalStyle.text` is null, because default
        // values have to be set on `normalStyle`.
        if (label) {
            var labelNormalModel = labelStatesModels.normal;
            label.__align = label.style.align;
            label.__verticalAlign = label.style.verticalAlign;
            // 'start', 'middle', 'end'
            label.__position = labelNormalModel.get('position') || 'middle';
            var distance = labelNormalModel.get('distance');
            if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(distance)) distance = [
                distance,
                distance
            ];
            label.__labelDistance = distance;
        }
        this.setTextConfig({
            position: null,
            local: true,
            inside: false // Can't be inside for stroke element.
        });
        (0, $2bf82c0980125b62$export$e51187539ff11209)(this, focus, blurScope, emphasisDisabled);
    };
    Line.prototype.highlight = function() {
        (0, $2bf82c0980125b62$export$b2d02638cc34c042)(this);
    };
    Line.prototype.downplay = function() {
        (0, $2bf82c0980125b62$export$11be6f716239ac55)(this);
    };
    Line.prototype.updateLayout = function(lineData, idx) {
        this.setLinePoints(lineData.getItemLayout(idx));
    };
    Line.prototype.setLinePoints = function(points) {
        var linePath = this.childOfName('line');
        $9e0b5f801ab5090c$var$setLinePoints(linePath.shape, points);
        linePath.dirty();
    };
    Line.prototype.beforeUpdate = function() {
        var lineGroup = this;
        var symbolFrom = lineGroup.childOfName('fromSymbol');
        var symbolTo = lineGroup.childOfName('toSymbol');
        var label = lineGroup.getTextContent();
        // Quick reject
        if (!symbolFrom && !symbolTo && (!label || label.ignore)) return;
        var invScale = 1;
        var parentNode = this.parent;
        while(parentNode){
            if (parentNode.scaleX) invScale /= parentNode.scaleX;
            parentNode = parentNode.parent;
        }
        var line = lineGroup.childOfName('line');
        // If line not changed
        // FIXME Parent scale changed
        if (!this.__dirty && !line.__dirty) return;
        var percent = line.shape.percent;
        var fromPos = line.pointAt(0);
        var toPos = line.pointAt(percent);
        var d = $6de594cf8ac295ff$export$f93b5905241a7cca([], toPos, fromPos);
        $6de594cf8ac295ff$export$a3295358bff77e(d, d);
        function setSymbolRotation(symbol, percent) {
            // Fix #12388
            // when symbol is set to be 'arrow' in markLine,
            // symbolRotate value will be ignored, and compulsively use tangent angle.
            // rotate by default if symbol rotation is not specified
            var specifiedRotation = symbol.__specifiedRotation;
            if (specifiedRotation == null) {
                var tangent = line.tangentAt(percent);
                symbol.attr('rotation', (percent === 1 ? -1 : 1) * Math.PI / 2 - Math.atan2(tangent[1], tangent[0]));
            } else symbol.attr('rotation', specifiedRotation);
        }
        if (symbolFrom) {
            symbolFrom.setPosition(fromPos);
            setSymbolRotation(symbolFrom, 0);
            symbolFrom.scaleX = symbolFrom.scaleY = invScale * percent;
            symbolFrom.markRedraw();
        }
        if (symbolTo) {
            symbolTo.setPosition(toPos);
            setSymbolRotation(symbolTo, 1);
            symbolTo.scaleX = symbolTo.scaleY = invScale * percent;
            symbolTo.markRedraw();
        }
        if (label && !label.ignore) {
            label.x = label.y = 0;
            label.originX = label.originY = 0;
            var textAlign = void 0;
            var textVerticalAlign = void 0;
            var distance = label.__labelDistance;
            var distanceX = distance[0] * invScale;
            var distanceY = distance[1] * invScale;
            var halfPercent = percent / 2;
            var tangent = line.tangentAt(halfPercent);
            var n = [
                tangent[1],
                -tangent[0]
            ];
            var cp = line.pointAt(halfPercent);
            if (n[1] > 0) {
                n[0] = -n[0];
                n[1] = -n[1];
            }
            var dir = tangent[0] < 0 ? -1 : 1;
            if (label.__position !== 'start' && label.__position !== 'end') {
                var rotation = -Math.atan2(tangent[1], tangent[0]);
                if (toPos[0] < fromPos[0]) rotation = Math.PI + rotation;
                label.rotation = rotation;
            }
            var dy = void 0;
            switch(label.__position){
                case 'insideStartTop':
                case 'insideMiddleTop':
                case 'insideEndTop':
                case 'middle':
                    dy = -distanceY;
                    textVerticalAlign = 'bottom';
                    break;
                case 'insideStartBottom':
                case 'insideMiddleBottom':
                case 'insideEndBottom':
                    dy = distanceY;
                    textVerticalAlign = 'top';
                    break;
                default:
                    dy = 0;
                    textVerticalAlign = 'middle';
            }
            switch(label.__position){
                case 'end':
                    label.x = d[0] * distanceX + toPos[0];
                    label.y = d[1] * distanceY + toPos[1];
                    textAlign = d[0] > 0.8 ? 'left' : d[0] < -0.8 ? 'right' : 'center';
                    textVerticalAlign = d[1] > 0.8 ? 'top' : d[1] < -0.8 ? 'bottom' : 'middle';
                    break;
                case 'start':
                    label.x = -d[0] * distanceX + fromPos[0];
                    label.y = -d[1] * distanceY + fromPos[1];
                    textAlign = d[0] > 0.8 ? 'right' : d[0] < -0.8 ? 'left' : 'center';
                    textVerticalAlign = d[1] > 0.8 ? 'bottom' : d[1] < -0.8 ? 'top' : 'middle';
                    break;
                case 'insideStartTop':
                case 'insideStart':
                case 'insideStartBottom':
                    label.x = distanceX * dir + fromPos[0];
                    label.y = fromPos[1] + dy;
                    textAlign = tangent[0] < 0 ? 'right' : 'left';
                    label.originX = -distanceX * dir;
                    label.originY = -dy;
                    break;
                case 'insideMiddleTop':
                case 'insideMiddle':
                case 'insideMiddleBottom':
                case 'middle':
                    label.x = cp[0];
                    label.y = cp[1] + dy;
                    textAlign = 'center';
                    label.originY = -dy;
                    break;
                case 'insideEndTop':
                case 'insideEnd':
                case 'insideEndBottom':
                    label.x = -distanceX * dir + toPos[0];
                    label.y = toPos[1] + dy;
                    textAlign = tangent[0] >= 0 ? 'right' : 'left';
                    label.originX = distanceX * dir;
                    label.originY = -dy;
                    break;
            }
            label.scaleX = label.scaleY = invScale;
            label.setStyle({
                // Use the user specified text align and baseline first
                verticalAlign: label.__verticalAlign || textVerticalAlign,
                align: label.__align || textAlign
            });
        }
    };
    return Line;
}($7ef7583d8302ffce$export$2e2bcd8739ae039);
var $9e0b5f801ab5090c$export$2e2bcd8739ae039 = $9e0b5f801ab5090c$var$Line;



var $a2fd63a0fc11274a$var$LineDraw = /** @class */ function() {
    function LineDraw(LineCtor) {
        this.group = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        this._LineCtor = LineCtor || (0, $9e0b5f801ab5090c$export$2e2bcd8739ae039);
    }
    LineDraw.prototype.updateData = function(lineData) {
        var _this = this;
        // Remove progressive els.
        this._progressiveEls = null;
        var lineDraw = this;
        var group = lineDraw.group;
        var oldLineData = lineDraw._lineData;
        lineDraw._lineData = lineData;
        // There is no oldLineData only when first rendering or switching from
        // stream mode to normal mode, where previous elements should be removed.
        if (!oldLineData) group.removeAll();
        var seriesScope = $a2fd63a0fc11274a$var$makeSeriesScope(lineData);
        lineData.diff(oldLineData).add(function(idx) {
            _this._doAdd(lineData, idx, seriesScope);
        }).update(function(newIdx, oldIdx) {
            _this._doUpdate(oldLineData, lineData, oldIdx, newIdx, seriesScope);
        }).remove(function(idx) {
            group.remove(oldLineData.getItemGraphicEl(idx));
        }).execute();
    };
    LineDraw.prototype.updateLayout = function() {
        var lineData = this._lineData;
        // Do not support update layout in incremental mode.
        if (!lineData) return;
        lineData.eachItemGraphicEl(function(el, idx) {
            el.updateLayout(lineData, idx);
        }, this);
    };
    LineDraw.prototype.incrementalPrepareUpdate = function(lineData) {
        this._seriesScope = $a2fd63a0fc11274a$var$makeSeriesScope(lineData);
        this._lineData = null;
        this.group.removeAll();
    };
    LineDraw.prototype.incrementalUpdate = function(taskParams, lineData) {
        this._progressiveEls = [];
        function updateIncrementalAndHover(el) {
            if (!el.isGroup && !$a2fd63a0fc11274a$var$isEffectObject(el)) {
                el.incremental = true;
                el.ensureState('emphasis').hoverLayer = true;
            }
        }
        for(var idx = taskParams.start; idx < taskParams.end; idx++){
            var itemLayout = lineData.getItemLayout(idx);
            if ($a2fd63a0fc11274a$var$lineNeedsDraw(itemLayout)) {
                var el = new this._LineCtor(lineData, idx, this._seriesScope);
                el.traverse(updateIncrementalAndHover);
                this.group.add(el);
                lineData.setItemGraphicEl(idx, el);
                this._progressiveEls.push(el);
            }
        }
    };
    LineDraw.prototype.remove = function() {
        this.group.removeAll();
    };
    LineDraw.prototype.eachRendered = function(cb) {
        $5b455ae6f843ac47$export$3e564442729bf048(this._progressiveEls || this.group, cb);
    };
    LineDraw.prototype._doAdd = function(lineData, idx, seriesScope) {
        var itemLayout = lineData.getItemLayout(idx);
        if (!$a2fd63a0fc11274a$var$lineNeedsDraw(itemLayout)) return;
        var el = new this._LineCtor(lineData, idx, seriesScope);
        lineData.setItemGraphicEl(idx, el);
        this.group.add(el);
    };
    LineDraw.prototype._doUpdate = function(oldLineData, newLineData, oldIdx, newIdx, seriesScope) {
        var itemEl = oldLineData.getItemGraphicEl(oldIdx);
        if (!$a2fd63a0fc11274a$var$lineNeedsDraw(newLineData.getItemLayout(newIdx))) {
            this.group.remove(itemEl);
            return;
        }
        if (!itemEl) itemEl = new this._LineCtor(newLineData, newIdx, seriesScope);
        else itemEl.updateData(newLineData, newIdx, seriesScope);
        newLineData.setItemGraphicEl(newIdx, itemEl);
        this.group.add(itemEl);
    };
    return LineDraw;
}();
function $a2fd63a0fc11274a$var$isEffectObject(el) {
    return el.animators && el.animators.length > 0;
}
function $a2fd63a0fc11274a$var$makeSeriesScope(lineData) {
    var hostModel = lineData.hostModel;
    var emphasisModel = hostModel.getModel('emphasis');
    return {
        lineStyle: hostModel.getModel('lineStyle').getLineStyle(),
        emphasisLineStyle: emphasisModel.getModel([
            'lineStyle'
        ]).getLineStyle(),
        blurLineStyle: hostModel.getModel([
            'blur',
            'lineStyle'
        ]).getLineStyle(),
        selectLineStyle: hostModel.getModel([
            'select',
            'lineStyle'
        ]).getLineStyle(),
        emphasisDisabled: emphasisModel.get('disabled'),
        blurScope: emphasisModel.get('blurScope'),
        focus: emphasisModel.get('focus'),
        labelStatesModels: (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(hostModel)
    };
}
function $a2fd63a0fc11274a$var$isPointNaN(pt) {
    return isNaN(pt[0]) || isNaN(pt[1]);
}
function $a2fd63a0fc11274a$var$lineNeedsDraw(pts) {
    return pts && !$a2fd63a0fc11274a$var$isPointNaN(pts[0]) && !$a2fd63a0fc11274a$var$isPointNaN(pts[1]);
}
var $a2fd63a0fc11274a$export$2e2bcd8739ae039 = $a2fd63a0fc11274a$var$LineDraw;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // @ts-nocheck


var $befd6a34b30d3f54$var$ATTR = '\0_ec_interaction_mutex';
function $befd6a34b30d3f54$export$b7df5d561049483a(zr, resourceKey, userKey) {
    var store = $befd6a34b30d3f54$var$getStore(zr);
    store[resourceKey] = userKey;
}
function $befd6a34b30d3f54$export$23d3fad09dc44362(zr, resourceKey, userKey) {
    var store = $befd6a34b30d3f54$var$getStore(zr);
    var uKey = store[resourceKey];
    if (uKey === userKey) store[resourceKey] = null;
}
function $befd6a34b30d3f54$export$5623cba512bc9470(zr, resourceKey) {
    return !!$befd6a34b30d3f54$var$getStore(zr)[resourceKey];
}
function $befd6a34b30d3f54$var$getStore(zr) {
    return zr[$befd6a34b30d3f54$var$ATTR] || (zr[$befd6a34b30d3f54$var$ATTR] = {});
}
/**
 * payload: {
 *     type: 'takeGlobalCursor',
 *     key: 'dataZoomSelect', or 'brush', or ...,
 *         If no userKey, release global cursor.
 * }
 */ // TODO: SELF REGISTERED.
$4d59907f44a2d0ad$export$408c24786cd729c6({
    type: 'takeGlobalCursor',
    event: 'globalCursorTaken',
    update: 'update'
}, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));



var $15927f329deeab51$var$RoamController = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(RoamController, _super);
    function RoamController(zr) {
        var _this = _super.call(this) || this;
        _this._zr = zr;
        // Avoid two roamController bind the same handler
        var mousedownHandler = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(_this._mousedownHandler, _this);
        var mousemoveHandler = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(_this._mousemoveHandler, _this);
        var mouseupHandler = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(_this._mouseupHandler, _this);
        var mousewheelHandler = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(_this._mousewheelHandler, _this);
        var pinchHandler = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(_this._pinchHandler, _this);
        /**
     * Notice: only enable needed types. For example, if 'zoom'
     * is not needed, 'zoom' should not be enabled, otherwise
     * default mousewheel behaviour (scroll page) will be disabled.
     */ _this.enable = function(controlType, opt) {
            // Disable previous first
            this.disable();
            this._opt = (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)((0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(opt) || {}, {
                zoomOnMouseWheel: true,
                moveOnMouseMove: true,
                // By default, wheel do not trigger move.
                moveOnMouseWheel: false,
                preventDefaultMouseMove: true
            });
            if (controlType == null) controlType = true;
            if (controlType === true || controlType === 'move' || controlType === 'pan') {
                zr.on('mousedown', mousedownHandler);
                zr.on('mousemove', mousemoveHandler);
                zr.on('mouseup', mouseupHandler);
            }
            if (controlType === true || controlType === 'scale' || controlType === 'zoom') {
                zr.on('mousewheel', mousewheelHandler);
                zr.on('pinch', pinchHandler);
            }
        };
        _this.disable = function() {
            zr.off('mousedown', mousedownHandler);
            zr.off('mousemove', mousemoveHandler);
            zr.off('mouseup', mouseupHandler);
            zr.off('mousewheel', mousewheelHandler);
            zr.off('pinch', pinchHandler);
        };
        return _this;
    }
    RoamController.prototype.isDragging = function() {
        return this._dragging;
    };
    RoamController.prototype.isPinching = function() {
        return this._pinching;
    };
    RoamController.prototype.setPointerChecker = function(pointerChecker) {
        this.pointerChecker = pointerChecker;
    };
    RoamController.prototype.dispose = function() {
        this.disable();
    };
    RoamController.prototype._mousedownHandler = function(e) {
        if ($b3864a78637ff9ed$export$b7ae4cded3e71bd2(e)) return;
        var el = e.target;
        while(el){
            if (el.draggable) return;
            // check if host is draggable
            el = el.__hostTarget || el.parent;
        }
        var x = e.offsetX;
        var y = e.offsetY;
        // Only check on mosedown, but not mousemove.
        // Mouse can be out of target when mouse moving.
        if (this.pointerChecker && this.pointerChecker(e, x, y)) {
            this._x = x;
            this._y = y;
            this._dragging = true;
        }
    };
    RoamController.prototype._mousemoveHandler = function(e) {
        if (!this._dragging || !$15927f329deeab51$var$isAvailableBehavior('moveOnMouseMove', e, this._opt) || e.gestureEvent === 'pinch' || $befd6a34b30d3f54$export$5623cba512bc9470(this._zr, 'globalPan')) return;
        var x = e.offsetX;
        var y = e.offsetY;
        var oldX = this._x;
        var oldY = this._y;
        var dx = x - oldX;
        var dy = y - oldY;
        this._x = x;
        this._y = y;
        this._opt.preventDefaultMouseMove && $b3864a78637ff9ed$export$fa6813432f753b0d(e.event);
        $15927f329deeab51$var$trigger(this, 'pan', 'moveOnMouseMove', e, {
            dx: dx,
            dy: dy,
            oldX: oldX,
            oldY: oldY,
            newX: x,
            newY: y,
            isAvailableBehavior: null
        });
    };
    RoamController.prototype._mouseupHandler = function(e) {
        if (!$b3864a78637ff9ed$export$b7ae4cded3e71bd2(e)) this._dragging = false;
    };
    RoamController.prototype._mousewheelHandler = function(e) {
        var shouldZoom = $15927f329deeab51$var$isAvailableBehavior('zoomOnMouseWheel', e, this._opt);
        var shouldMove = $15927f329deeab51$var$isAvailableBehavior('moveOnMouseWheel', e, this._opt);
        var wheelDelta = e.wheelDelta;
        var absWheelDeltaDelta = Math.abs(wheelDelta);
        var originX = e.offsetX;
        var originY = e.offsetY;
        // wheelDelta maybe -0 in chrome mac.
        if (wheelDelta === 0 || !shouldZoom && !shouldMove) return;
        // If both `shouldZoom` and `shouldMove` is true, trigger
        // their event both, and the final behavior is determined
        // by event listener themselves.
        if (shouldZoom) {
            // Convenience:
            // Mac and VM Windows on Mac: scroll up: zoom out.
            // Windows: scroll up: zoom in.
            // FIXME: Should do more test in different environment.
            // wheelDelta is too complicated in difference nvironment
            // (https://developer.mozilla.org/en-US/docs/Web/Events/mousewheel),
            // although it has been normallized by zrender.
            // wheelDelta of mouse wheel is bigger than touch pad.
            var factor = absWheelDeltaDelta > 3 ? 1.4 : absWheelDeltaDelta > 1 ? 1.2 : 1.1;
            var scale = wheelDelta > 0 ? factor : 1 / factor;
            $15927f329deeab51$var$checkPointerAndTrigger(this, 'zoom', 'zoomOnMouseWheel', e, {
                scale: scale,
                originX: originX,
                originY: originY,
                isAvailableBehavior: null
            });
        }
        if (shouldMove) {
            // FIXME: Should do more test in different environment.
            var absDelta = Math.abs(wheelDelta);
            // wheelDelta of mouse wheel is bigger than touch pad.
            var scrollDelta = (wheelDelta > 0 ? 1 : -1) * (absDelta > 3 ? 0.4 : absDelta > 1 ? 0.15 : 0.05);
            $15927f329deeab51$var$checkPointerAndTrigger(this, 'scrollMove', 'moveOnMouseWheel', e, {
                scrollDelta: scrollDelta,
                originX: originX,
                originY: originY,
                isAvailableBehavior: null
            });
        }
    };
    RoamController.prototype._pinchHandler = function(e) {
        if ($befd6a34b30d3f54$export$5623cba512bc9470(this._zr, 'globalPan')) return;
        var scale = e.pinchScale > 1 ? 1.1 : 1 / 1.1;
        $15927f329deeab51$var$checkPointerAndTrigger(this, 'zoom', null, e, {
            scale: scale,
            originX: e.pinchX,
            originY: e.pinchY,
            isAvailableBehavior: null
        });
    };
    return RoamController;
}((0, $63441a86293f101f$export$2e2bcd8739ae039));
function $15927f329deeab51$var$checkPointerAndTrigger(controller, eventName, behaviorToCheck, e, contollerEvent) {
    if (controller.pointerChecker && controller.pointerChecker(e, contollerEvent.originX, contollerEvent.originY)) {
        // When mouse is out of roamController rect,
        // default befavoius should not be be disabled, otherwise
        // page sliding is disabled, contrary to expectation.
        $b3864a78637ff9ed$export$fa6813432f753b0d(e.event);
        $15927f329deeab51$var$trigger(controller, eventName, behaviorToCheck, e, contollerEvent);
    }
}
function $15927f329deeab51$var$trigger(controller, eventName, behaviorToCheck, e, contollerEvent) {
    // Also provide behavior checker for event listener, for some case that
    // multiple components share one listener.
    contollerEvent.isAvailableBehavior = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)($15927f329deeab51$var$isAvailableBehavior, null, behaviorToCheck, e);
    // TODO should not have type issue.
    controller.trigger(eventName, contollerEvent);
}
// settings: {
//     zoomOnMouseWheel
//     moveOnMouseMove
//     moveOnMouseWheel
// }
// The value can be: true / false / 'shift' / 'ctrl' / 'alt'.
function $15927f329deeab51$var$isAvailableBehavior(behaviorToCheck, e, settings) {
    var setting = settings[behaviorToCheck];
    return !behaviorToCheck || setting && (!(0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(setting) || e.event[setting + 'Key']);
}
var $15927f329deeab51$export$2e2bcd8739ae039 = $15927f329deeab51$var$RoamController;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * For geo and graph.
 */ function $35fd859fd545c4be$export$1e6abcd98caba733(controllerHost, dx, dy) {
    var target = controllerHost.target;
    target.x += dx;
    target.y += dy;
    target.dirty();
}
function $35fd859fd545c4be$export$29b3c66d30a4866(controllerHost, zoomDelta, zoomX, zoomY) {
    var target = controllerHost.target;
    var zoomLimit = controllerHost.zoomLimit;
    var newZoom = controllerHost.zoom = controllerHost.zoom || 1;
    newZoom *= zoomDelta;
    if (zoomLimit) {
        var zoomMin = zoomLimit.min || 0;
        var zoomMax = zoomLimit.max || Infinity;
        newZoom = Math.max(Math.min(zoomMax, newZoom), zoomMin);
    }
    var zoomScale = newZoom / controllerHost.zoom;
    controllerHost.zoom = newZoom;
    // Keep the mouse center when scaling
    target.x -= (zoomX - target.x) * (zoomScale - 1);
    target.y -= (zoomY - target.y) * (zoomScale - 1);
    target.scaleX *= zoomScale;
    target.scaleY *= zoomScale;
    target.dirty();
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $bee256db41541054$var$IRRELEVANT_EXCLUDES = {
    'axisPointer': 1,
    'tooltip': 1,
    'brush': 1
};
function $bee256db41541054$export$8a33eacb690eac07(e, api, targetCoordSysModel) {
    var model = api.getComponentByElement(e.topTarget);
    // If model is axisModel, it works only if it is injected with coordinateSystem.
    var coordSys = model && model.coordinateSystem;
    return model && model !== targetCoordSysModel && !$bee256db41541054$var$IRRELEVANT_EXCLUDES.hasOwnProperty(model.mainType) && coordSys && coordSys.model !== targetCoordSysModel;
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $197126bedfb0a68b$var$v1 = [];
var $197126bedfb0a68b$var$v2 = [];
var $197126bedfb0a68b$var$v3 = [];
var $197126bedfb0a68b$var$quadraticAt = $747cfc5611b57cea$export$af17094a950f5073;
var $197126bedfb0a68b$var$v2DistSquare = $6de594cf8ac295ff$export$c68db45a034c13b0;
var $197126bedfb0a68b$var$mathAbs = Math.abs;
function $197126bedfb0a68b$var$intersectCurveCircle(curvePoints, center, radius) {
    var p0 = curvePoints[0];
    var p1 = curvePoints[1];
    var p2 = curvePoints[2];
    var d = Infinity;
    var t;
    var radiusSquare = radius * radius;
    var interval = 0.1;
    for(var _t = 0.1; _t <= 0.9; _t += 0.1){
        $197126bedfb0a68b$var$v1[0] = $197126bedfb0a68b$var$quadraticAt(p0[0], p1[0], p2[0], _t);
        $197126bedfb0a68b$var$v1[1] = $197126bedfb0a68b$var$quadraticAt(p0[1], p1[1], p2[1], _t);
        var diff = $197126bedfb0a68b$var$mathAbs($197126bedfb0a68b$var$v2DistSquare($197126bedfb0a68b$var$v1, center) - radiusSquare);
        if (diff < d) {
            d = diff;
            t = _t;
        }
    }
    // Assume the segment is monotone，Find root through Bisection method
    // At most 32 iteration
    for(var i = 0; i < 32; i++){
        // let prev = t - interval;
        var next = t + interval;
        // v1[0] = quadraticAt(p0[0], p1[0], p2[0], prev);
        // v1[1] = quadraticAt(p0[1], p1[1], p2[1], prev);
        $197126bedfb0a68b$var$v2[0] = $197126bedfb0a68b$var$quadraticAt(p0[0], p1[0], p2[0], t);
        $197126bedfb0a68b$var$v2[1] = $197126bedfb0a68b$var$quadraticAt(p0[1], p1[1], p2[1], t);
        $197126bedfb0a68b$var$v3[0] = $197126bedfb0a68b$var$quadraticAt(p0[0], p1[0], p2[0], next);
        $197126bedfb0a68b$var$v3[1] = $197126bedfb0a68b$var$quadraticAt(p0[1], p1[1], p2[1], next);
        var diff = $197126bedfb0a68b$var$v2DistSquare($197126bedfb0a68b$var$v2, center) - radiusSquare;
        if ($197126bedfb0a68b$var$mathAbs(diff) < 1e-2) break;
        // let prevDiff = v2DistSquare(v1, center) - radiusSquare;
        var nextDiff = $197126bedfb0a68b$var$v2DistSquare($197126bedfb0a68b$var$v3, center) - radiusSquare;
        interval /= 2;
        if (diff < 0) {
            if (nextDiff >= 0) t = t + interval;
            else t = t - interval;
        } else if (nextDiff >= 0) t = t - interval;
        else t = t + interval;
    }
    return t;
}
function $197126bedfb0a68b$export$2e2bcd8739ae039(graph, scale) {
    var tmp0 = [];
    var quadraticSubdivide = $747cfc5611b57cea$export$117c659e21a7a060;
    var pts = [
        [],
        [],
        []
    ];
    var pts2 = [
        [],
        []
    ];
    var v = [];
    scale /= 2;
    graph.eachEdge(function(edge, idx) {
        var linePoints = edge.getLayout();
        var fromSymbol = edge.getVisual('fromSymbol');
        var toSymbol = edge.getVisual('toSymbol');
        if (!linePoints.__original) {
            linePoints.__original = [
                $6de594cf8ac295ff$export$9cd59f9826255e47(linePoints[0]),
                $6de594cf8ac295ff$export$9cd59f9826255e47(linePoints[1])
            ];
            if (linePoints[2]) linePoints.__original.push($6de594cf8ac295ff$export$9cd59f9826255e47(linePoints[2]));
        }
        var originalPoints = linePoints.__original;
        // Quadratic curve
        if (linePoints[2] != null) {
            $6de594cf8ac295ff$export$784d13d8ee351f07(pts[0], originalPoints[0]);
            $6de594cf8ac295ff$export$784d13d8ee351f07(pts[1], originalPoints[2]);
            $6de594cf8ac295ff$export$784d13d8ee351f07(pts[2], originalPoints[1]);
            if (fromSymbol && fromSymbol !== 'none') {
                var symbolSize = (0, $ad8b4f94f577d55a$export$8d4a06d3facd414b)(edge.node1);
                var t = $197126bedfb0a68b$var$intersectCurveCircle(pts, originalPoints[0], symbolSize * scale);
                // Subdivide and get the second
                quadraticSubdivide(pts[0][0], pts[1][0], pts[2][0], t, tmp0);
                pts[0][0] = tmp0[3];
                pts[1][0] = tmp0[4];
                quadraticSubdivide(pts[0][1], pts[1][1], pts[2][1], t, tmp0);
                pts[0][1] = tmp0[3];
                pts[1][1] = tmp0[4];
            }
            if (toSymbol && toSymbol !== 'none') {
                var symbolSize = (0, $ad8b4f94f577d55a$export$8d4a06d3facd414b)(edge.node2);
                var t = $197126bedfb0a68b$var$intersectCurveCircle(pts, originalPoints[1], symbolSize * scale);
                // Subdivide and get the first
                quadraticSubdivide(pts[0][0], pts[1][0], pts[2][0], t, tmp0);
                pts[1][0] = tmp0[1];
                pts[2][0] = tmp0[2];
                quadraticSubdivide(pts[0][1], pts[1][1], pts[2][1], t, tmp0);
                pts[1][1] = tmp0[1];
                pts[2][1] = tmp0[2];
            }
            // Copy back to layout
            $6de594cf8ac295ff$export$784d13d8ee351f07(linePoints[0], pts[0]);
            $6de594cf8ac295ff$export$784d13d8ee351f07(linePoints[1], pts[2]);
            $6de594cf8ac295ff$export$784d13d8ee351f07(linePoints[2], pts[1]);
        } else {
            $6de594cf8ac295ff$export$784d13d8ee351f07(pts2[0], originalPoints[0]);
            $6de594cf8ac295ff$export$784d13d8ee351f07(pts2[1], originalPoints[1]);
            $6de594cf8ac295ff$export$f93b5905241a7cca(v, pts2[1], pts2[0]);
            $6de594cf8ac295ff$export$a3295358bff77e(v, v);
            if (fromSymbol && fromSymbol !== 'none') {
                var symbolSize = (0, $ad8b4f94f577d55a$export$8d4a06d3facd414b)(edge.node1);
                $6de594cf8ac295ff$export$19cedf1da84ba854(pts2[0], pts2[0], v, symbolSize * scale);
            }
            if (toSymbol && toSymbol !== 'none') {
                var symbolSize = (0, $ad8b4f94f577d55a$export$8d4a06d3facd414b)(edge.node2);
                $6de594cf8ac295ff$export$19cedf1da84ba854(pts2[1], pts2[1], v, -symbolSize * scale);
            }
            $6de594cf8ac295ff$export$784d13d8ee351f07(linePoints[0], pts2[0]);
            $6de594cf8ac295ff$export$784d13d8ee351f07(linePoints[1], pts2[1]);
        }
    });
}







function $65490d05ca8b2521$var$isViewCoordSys(coordSys) {
    return coordSys.type === 'view';
}
var $65490d05ca8b2521$var$GraphView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(GraphView, _super);
    function GraphView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GraphView.type;
        return _this;
    }
    GraphView.prototype.init = function(ecModel, api) {
        var symbolDraw = new (0, $fedf62268297fcbb$export$2e2bcd8739ae039)();
        var lineDraw = new (0, $a2fd63a0fc11274a$export$2e2bcd8739ae039)();
        var group = this.group;
        this._controller = new (0, $15927f329deeab51$export$2e2bcd8739ae039)(api.getZr());
        this._controllerHost = {
            target: group
        };
        group.add(symbolDraw.group);
        group.add(lineDraw.group);
        this._symbolDraw = symbolDraw;
        this._lineDraw = lineDraw;
        this._firstRender = true;
    };
    GraphView.prototype.render = function(seriesModel, ecModel, api) {
        var _this = this;
        var coordSys = seriesModel.coordinateSystem;
        this._model = seriesModel;
        var symbolDraw = this._symbolDraw;
        var lineDraw = this._lineDraw;
        var group = this.group;
        if ($65490d05ca8b2521$var$isViewCoordSys(coordSys)) {
            var groupNewProp = {
                x: coordSys.x,
                y: coordSys.y,
                scaleX: coordSys.scaleX,
                scaleY: coordSys.scaleY
            };
            if (this._firstRender) group.attr(groupNewProp);
            else $8b353638fbedfefa$export$c8dce3c08436e91e(group, groupNewProp, seriesModel);
        }
        // Fix edge contact point with node
        (0, $197126bedfb0a68b$export$2e2bcd8739ae039)(seriesModel.getGraph(), (0, $ad8b4f94f577d55a$export$e2aa0fb9ed198ba7)(seriesModel));
        var data = seriesModel.getData();
        symbolDraw.updateData(data);
        var edgeData = seriesModel.getEdgeData();
        // TODO: TYPE
        lineDraw.updateData(edgeData);
        this._updateNodeAndLinkScale();
        this._updateController(seriesModel, ecModel, api);
        clearTimeout(this._layoutTimeout);
        var forceLayout = seriesModel.forceLayout;
        var layoutAnimation = seriesModel.get([
            'force',
            'layoutAnimation'
        ]);
        if (forceLayout) this._startForceLayoutIteration(forceLayout, layoutAnimation);
        var layout = seriesModel.get('layout');
        data.graph.eachNode(function(node) {
            var idx = node.dataIndex;
            var el = node.getGraphicEl();
            var itemModel = node.getModel();
            if (!el) return;
            // Update draggable
            el.off('drag').off('dragend');
            var draggable = itemModel.get('draggable');
            if (draggable) el.on('drag', function(e) {
                switch(layout){
                    case 'force':
                        forceLayout.warmUp();
                        !_this._layouting && _this._startForceLayoutIteration(forceLayout, layoutAnimation);
                        forceLayout.setFixed(idx);
                        // Write position back to layout
                        data.setItemLayout(idx, [
                            el.x,
                            el.y
                        ]);
                        break;
                    case 'circular':
                        data.setItemLayout(idx, [
                            el.x,
                            el.y
                        ]);
                        // mark node fixed
                        node.setLayout({
                            fixed: true
                        }, true);
                        // recalculate circular layout
                        (0, $484ee97adf82b508$export$cbfed6ae5cab3dae)(seriesModel, 'symbolSize', node, [
                            e.offsetX,
                            e.offsetY
                        ]);
                        _this.updateLayout(seriesModel);
                        break;
                    case 'none':
                    default:
                        data.setItemLayout(idx, [
                            el.x,
                            el.y
                        ]);
                        // update edge
                        (0, $159cad03c3625d06$export$a25b52345bee32aa)(seriesModel.getGraph(), seriesModel);
                        _this.updateLayout(seriesModel);
                        break;
                }
            }).on('dragend', function() {
                if (forceLayout) forceLayout.setUnfixed(idx);
            });
            el.setDraggable(draggable, !!itemModel.get('cursor'));
            var focus = itemModel.get([
                'emphasis',
                'focus'
            ]);
            if (focus === 'adjacency') (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).focus = node.getAdjacentDataIndices();
        });
        data.graph.eachEdge(function(edge) {
            var el = edge.getGraphicEl();
            var focus = edge.getModel().get([
                'emphasis',
                'focus'
            ]);
            if (!el) return;
            if (focus === 'adjacency') (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).focus = {
                edge: [
                    edge.dataIndex
                ],
                node: [
                    edge.node1.dataIndex,
                    edge.node2.dataIndex
                ]
            };
        });
        var circularRotateLabel = seriesModel.get('layout') === 'circular' && seriesModel.get([
            'circular',
            'rotateLabel'
        ]);
        var cx = data.getLayout('cx');
        var cy = data.getLayout('cy');
        data.graph.eachNode(function(node) {
            (0, $484ee97adf82b508$export$c768377a6a0a9ab8)(node, circularRotateLabel, cx, cy);
        });
        this._firstRender = false;
    };
    GraphView.prototype.dispose = function() {
        this.remove();
        this._controller && this._controller.dispose();
        this._controllerHost = null;
    };
    GraphView.prototype._startForceLayoutIteration = function(forceLayout, layoutAnimation) {
        var self = this;
        (function step() {
            forceLayout.step(function(stopped) {
                self.updateLayout(self._model);
                (self._layouting = !stopped) && (layoutAnimation ? self._layoutTimeout = setTimeout(step, 16) : step());
            });
        })();
    };
    GraphView.prototype._updateController = function(seriesModel, ecModel, api) {
        var _this = this;
        var controller = this._controller;
        var controllerHost = this._controllerHost;
        var group = this.group;
        controller.setPointerChecker(function(e, x, y) {
            var rect = group.getBoundingRect();
            rect.applyTransform(group.transform);
            return rect.contain(x, y) && !(0, $bee256db41541054$export$8a33eacb690eac07)(e, api, seriesModel);
        });
        if (!$65490d05ca8b2521$var$isViewCoordSys(seriesModel.coordinateSystem)) {
            controller.disable();
            return;
        }
        controller.enable(seriesModel.get('roam'));
        controllerHost.zoomLimit = seriesModel.get('scaleLimit');
        controllerHost.zoom = seriesModel.coordinateSystem.getZoom();
        controller.off('pan').off('zoom').on('pan', function(e) {
            $35fd859fd545c4be$export$1e6abcd98caba733(controllerHost, e.dx, e.dy);
            api.dispatchAction({
                seriesId: seriesModel.id,
                type: 'graphRoam',
                dx: e.dx,
                dy: e.dy
            });
        }).on('zoom', function(e) {
            $35fd859fd545c4be$export$29b3c66d30a4866(controllerHost, e.scale, e.originX, e.originY);
            api.dispatchAction({
                seriesId: seriesModel.id,
                type: 'graphRoam',
                zoom: e.scale,
                originX: e.originX,
                originY: e.originY
            });
            _this._updateNodeAndLinkScale();
            (0, $197126bedfb0a68b$export$2e2bcd8739ae039)(seriesModel.getGraph(), (0, $ad8b4f94f577d55a$export$e2aa0fb9ed198ba7)(seriesModel));
            _this._lineDraw.updateLayout();
            // Only update label layout on zoom
            api.updateLabelLayout();
        });
    };
    GraphView.prototype._updateNodeAndLinkScale = function() {
        var seriesModel = this._model;
        var data = seriesModel.getData();
        var nodeScale = (0, $ad8b4f94f577d55a$export$e2aa0fb9ed198ba7)(seriesModel);
        data.eachItemGraphicEl(function(el, idx) {
            el && el.setSymbolScale(nodeScale);
        });
    };
    GraphView.prototype.updateLayout = function(seriesModel) {
        (0, $197126bedfb0a68b$export$2e2bcd8739ae039)(seriesModel.getGraph(), (0, $ad8b4f94f577d55a$export$e2aa0fb9ed198ba7)(seriesModel));
        this._symbolDraw.updateLayout();
        this._lineDraw.updateLayout();
    };
    GraphView.prototype.remove = function() {
        clearTimeout(this._layoutTimeout);
        this._layouting = false;
        this._layoutTimeout = null;
        this._symbolDraw && this._symbolDraw.remove();
        this._lineDraw && this._lineDraw.remove();
    };
    GraphView.type = 'graph';
    return GraphView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $65490d05ca8b2521$export$2e2bcd8739ae039 = $65490d05ca8b2521$var$GraphView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
// id may be function name of Object, add a prefix to avoid this problem.
function $7e67f74238c90217$var$generateNodeKey(id) {
    return '_EC_' + id;
}
var $7e67f74238c90217$var$Graph = /** @class */ function() {
    function Graph(directed) {
        this.type = 'graph';
        this.nodes = [];
        this.edges = [];
        this._nodesMap = {};
        /**
     * @type {Object.<string, module:echarts/data/Graph.Edge>}
     * @private
     */ this._edgesMap = {};
        this._directed = directed || false;
    }
    /**
   * If is directed graph
   */ Graph.prototype.isDirected = function() {
        return this._directed;
    };
    /**
   * Add a new node
   */ Graph.prototype.addNode = function(id, dataIndex) {
        id = id == null ? '' + dataIndex : '' + id;
        var nodesMap = this._nodesMap;
        if (nodesMap[$7e67f74238c90217$var$generateNodeKey(id)]) return;
        var node = new $7e67f74238c90217$export$32866653dfc29d0d(id, dataIndex);
        node.hostGraph = this;
        this.nodes.push(node);
        nodesMap[$7e67f74238c90217$var$generateNodeKey(id)] = node;
        return node;
    };
    /**
   * Get node by data index
   */ Graph.prototype.getNodeByIndex = function(dataIndex) {
        var rawIdx = this.data.getRawIndex(dataIndex);
        return this.nodes[rawIdx];
    };
    /**
   * Get node by id
   */ Graph.prototype.getNodeById = function(id) {
        return this._nodesMap[$7e67f74238c90217$var$generateNodeKey(id)];
    };
    /**
   * Add a new edge
   */ Graph.prototype.addEdge = function(n1, n2, dataIndex) {
        var nodesMap = this._nodesMap;
        var edgesMap = this._edgesMap;
        // PENDING
        if ($7a1bd9c2710fea0d$export$7e4aa119212bc614(n1)) n1 = this.nodes[n1];
        if ($7a1bd9c2710fea0d$export$7e4aa119212bc614(n2)) n2 = this.nodes[n2];
        if (!(n1 instanceof $7e67f74238c90217$export$32866653dfc29d0d)) n1 = nodesMap[$7e67f74238c90217$var$generateNodeKey(n1)];
        if (!(n2 instanceof $7e67f74238c90217$export$32866653dfc29d0d)) n2 = nodesMap[$7e67f74238c90217$var$generateNodeKey(n2)];
        if (!n1 || !n2) return;
        var key = n1.id + '-' + n2.id;
        var edge = new $7e67f74238c90217$export$87f150720cc8d165(n1, n2, dataIndex);
        edge.hostGraph = this;
        if (this._directed) {
            n1.outEdges.push(edge);
            n2.inEdges.push(edge);
        }
        n1.edges.push(edge);
        if (n1 !== n2) n2.edges.push(edge);
        this.edges.push(edge);
        edgesMap[key] = edge;
        return edge;
    };
    /**
   * Get edge by data index
   */ Graph.prototype.getEdgeByIndex = function(dataIndex) {
        var rawIdx = this.edgeData.getRawIndex(dataIndex);
        return this.edges[rawIdx];
    };
    /**
   * Get edge by two linked nodes
   */ Graph.prototype.getEdge = function(n1, n2) {
        if (n1 instanceof $7e67f74238c90217$export$32866653dfc29d0d) n1 = n1.id;
        if (n2 instanceof $7e67f74238c90217$export$32866653dfc29d0d) n2 = n2.id;
        var edgesMap = this._edgesMap;
        if (this._directed) return edgesMap[n1 + '-' + n2];
        else return edgesMap[n1 + '-' + n2] || edgesMap[n2 + '-' + n1];
    };
    /**
   * Iterate all nodes
   */ Graph.prototype.eachNode = function(cb, context) {
        var nodes = this.nodes;
        var len = nodes.length;
        for(var i = 0; i < len; i++)if (nodes[i].dataIndex >= 0) cb.call(context, nodes[i], i);
    };
    /**
   * Iterate all edges
   */ Graph.prototype.eachEdge = function(cb, context) {
        var edges = this.edges;
        var len = edges.length;
        for(var i = 0; i < len; i++)if (edges[i].dataIndex >= 0 && edges[i].node1.dataIndex >= 0 && edges[i].node2.dataIndex >= 0) cb.call(context, edges[i], i);
    };
    /**
   * Breadth first traverse
   * Return true to stop traversing
   */ Graph.prototype.breadthFirstTraverse = function(cb, startNode, direction, context) {
        if (!(startNode instanceof $7e67f74238c90217$export$32866653dfc29d0d)) startNode = this._nodesMap[$7e67f74238c90217$var$generateNodeKey(startNode)];
        if (!startNode) return;
        var edgeType = direction === 'out' ? 'outEdges' : direction === 'in' ? 'inEdges' : 'edges';
        for(var i = 0; i < this.nodes.length; i++)this.nodes[i].__visited = false;
        if (cb.call(context, startNode, null)) return;
        var queue = [
            startNode
        ];
        while(queue.length){
            var currentNode = queue.shift();
            var edges = currentNode[edgeType];
            for(var i = 0; i < edges.length; i++){
                var e = edges[i];
                var otherNode = e.node1 === currentNode ? e.node2 : e.node1;
                if (!otherNode.__visited) {
                    if (cb.call(context, otherNode, currentNode)) // Stop traversing
                    return;
                    queue.push(otherNode);
                    otherNode.__visited = true;
                }
            }
        }
    };
    // TODO
    // depthFirstTraverse(
    //     cb, startNode, direction, context
    // ) {
    // };
    // Filter update
    Graph.prototype.update = function() {
        var data = this.data;
        var edgeData = this.edgeData;
        var nodes = this.nodes;
        var edges = this.edges;
        for(var i = 0, len = nodes.length; i < len; i++)nodes[i].dataIndex = -1;
        for(var i = 0, len = data.count(); i < len; i++)nodes[data.getRawIndex(i)].dataIndex = i;
        edgeData.filterSelf(function(idx) {
            var edge = edges[edgeData.getRawIndex(idx)];
            return edge.node1.dataIndex >= 0 && edge.node2.dataIndex >= 0;
        });
        // Update edge
        for(var i = 0, len = edges.length; i < len; i++)edges[i].dataIndex = -1;
        for(var i = 0, len = edgeData.count(); i < len; i++)edges[edgeData.getRawIndex(i)].dataIndex = i;
    };
    /**
   * @return {module:echarts/data/Graph}
   */ Graph.prototype.clone = function() {
        var graph = new Graph(this._directed);
        var nodes = this.nodes;
        var edges = this.edges;
        for(var i = 0; i < nodes.length; i++)graph.addNode(nodes[i].id, nodes[i].dataIndex);
        for(var i = 0; i < edges.length; i++){
            var e = edges[i];
            graph.addEdge(e.node1.id, e.node2.id, e.dataIndex);
        }
        return graph;
    };
    return Graph;
}();
var $7e67f74238c90217$export$32866653dfc29d0d = /** @class */ function() {
    function GraphNode(id, dataIndex) {
        this.inEdges = [];
        this.outEdges = [];
        this.edges = [];
        this.dataIndex = -1;
        this.id = id == null ? '' : id;
        this.dataIndex = dataIndex == null ? -1 : dataIndex;
    }
    /**
   * @return {number}
   */ GraphNode.prototype.degree = function() {
        return this.edges.length;
    };
    /**
   * @return {number}
   */ GraphNode.prototype.inDegree = function() {
        return this.inEdges.length;
    };
    /**
  * @return {number}
  */ GraphNode.prototype.outDegree = function() {
        return this.outEdges.length;
    };
    GraphNode.prototype.getModel = function(path) {
        if (this.dataIndex < 0) return;
        var graph = this.hostGraph;
        var itemModel = graph.data.getItemModel(this.dataIndex);
        return itemModel.getModel(path);
    };
    GraphNode.prototype.getAdjacentDataIndices = function() {
        var dataIndices = {
            edge: [],
            node: []
        };
        for(var i = 0; i < this.edges.length; i++){
            var adjacentEdge = this.edges[i];
            if (adjacentEdge.dataIndex < 0) continue;
            dataIndices.edge.push(adjacentEdge.dataIndex);
            dataIndices.node.push(adjacentEdge.node1.dataIndex, adjacentEdge.node2.dataIndex);
        }
        return dataIndices;
    };
    GraphNode.prototype.getTrajectoryDataIndices = function() {
        var connectedEdgesMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        var connectedNodesMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        for(var i = 0; i < this.edges.length; i++){
            var adjacentEdge = this.edges[i];
            if (adjacentEdge.dataIndex < 0) continue;
            connectedEdgesMap.set(adjacentEdge.dataIndex, true);
            var sourceNodesQueue = [
                adjacentEdge.node1
            ];
            var targetNodesQueue = [
                adjacentEdge.node2
            ];
            var nodeIteratorIndex = 0;
            while(nodeIteratorIndex < sourceNodesQueue.length){
                var sourceNode = sourceNodesQueue[nodeIteratorIndex];
                nodeIteratorIndex++;
                connectedNodesMap.set(sourceNode.dataIndex, true);
                for(var j = 0; j < sourceNode.inEdges.length; j++){
                    connectedEdgesMap.set(sourceNode.inEdges[j].dataIndex, true);
                    sourceNodesQueue.push(sourceNode.inEdges[j].node1);
                }
            }
            nodeIteratorIndex = 0;
            while(nodeIteratorIndex < targetNodesQueue.length){
                var targetNode = targetNodesQueue[nodeIteratorIndex];
                nodeIteratorIndex++;
                connectedNodesMap.set(targetNode.dataIndex, true);
                for(var j = 0; j < targetNode.outEdges.length; j++){
                    connectedEdgesMap.set(targetNode.outEdges[j].dataIndex, true);
                    targetNodesQueue.push(targetNode.outEdges[j].node2);
                }
            }
        }
        return {
            edge: connectedEdgesMap.keys(),
            node: connectedNodesMap.keys()
        };
    };
    return GraphNode;
}();
var $7e67f74238c90217$export$87f150720cc8d165 = /** @class */ function() {
    function GraphEdge(n1, n2, dataIndex) {
        this.dataIndex = -1;
        this.node1 = n1;
        this.node2 = n2;
        this.dataIndex = dataIndex == null ? -1 : dataIndex;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    GraphEdge.prototype.getModel = function(path) {
        if (this.dataIndex < 0) return;
        var graph = this.hostGraph;
        var itemModel = graph.edgeData.getItemModel(this.dataIndex);
        return itemModel.getModel(path);
    };
    GraphEdge.prototype.getAdjacentDataIndices = function() {
        return {
            edge: [
                this.dataIndex
            ],
            node: [
                this.node1.dataIndex,
                this.node2.dataIndex
            ]
        };
    };
    GraphEdge.prototype.getTrajectoryDataIndices = function() {
        var connectedEdgesMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        var connectedNodesMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        connectedEdgesMap.set(this.dataIndex, true);
        var sourceNodes = [
            this.node1
        ];
        var targetNodes = [
            this.node2
        ];
        var nodeIteratorIndex = 0;
        while(nodeIteratorIndex < sourceNodes.length){
            var sourceNode = sourceNodes[nodeIteratorIndex];
            nodeIteratorIndex++;
            connectedNodesMap.set(sourceNode.dataIndex, true);
            for(var j = 0; j < sourceNode.inEdges.length; j++){
                connectedEdgesMap.set(sourceNode.inEdges[j].dataIndex, true);
                sourceNodes.push(sourceNode.inEdges[j].node1);
            }
        }
        nodeIteratorIndex = 0;
        while(nodeIteratorIndex < targetNodes.length){
            var targetNode = targetNodes[nodeIteratorIndex];
            nodeIteratorIndex++;
            connectedNodesMap.set(targetNode.dataIndex, true);
            for(var j = 0; j < targetNode.outEdges.length; j++){
                connectedEdgesMap.set(targetNode.outEdges[j].dataIndex, true);
                targetNodes.push(targetNode.outEdges[j].node2);
            }
        }
        return {
            edge: connectedEdgesMap.keys(),
            node: connectedNodesMap.keys()
        };
    };
    return GraphEdge;
}();
function $7e67f74238c90217$var$createGraphDataProxyMixin(hostName, dataName) {
    return {
        /**
     * @param Default 'value'. can be 'a', 'b', 'c', 'd', 'e'.
     */ getValue: function(dimension) {
            var data = this[hostName][dataName];
            return data.getStore().get(data.getDimensionIndex(dimension || 'value'), this.dataIndex);
        },
        // TODO: TYPE stricter type.
        setVisual: function(key, value) {
            this.dataIndex >= 0 && this[hostName][dataName].setItemVisual(this.dataIndex, key, value);
        },
        getVisual: function(key) {
            return this[hostName][dataName].getItemVisual(this.dataIndex, key);
        },
        setLayout: function(layout, merge) {
            this.dataIndex >= 0 && this[hostName][dataName].setItemLayout(this.dataIndex, layout, merge);
        },
        getLayout: function() {
            return this[hostName][dataName].getItemLayout(this.dataIndex);
        },
        getGraphicEl: function() {
            return this[hostName][dataName].getItemGraphicEl(this.dataIndex);
        },
        getRawIndex: function() {
            return this[hostName][dataName].getRawIndex(this.dataIndex);
        }
    };
}
$7a1bd9c2710fea0d$export$e36fc9d62a853069($7e67f74238c90217$export$32866653dfc29d0d, $7e67f74238c90217$var$createGraphDataProxyMixin('hostGraph', 'data'));
$7a1bd9c2710fea0d$export$e36fc9d62a853069($7e67f74238c90217$export$87f150720cc8d165, $7e67f74238c90217$var$createGraphDataProxyMixin('hostGraph', 'edgeData'));
var $7e67f74238c90217$export$2e2bcd8739ae039 = $7e67f74238c90217$var$Graph;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Link lists and struct (graph or tree)
 */ 

var $4a8451eb7786c849$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $4a8451eb7786c849$var$linkSeriesData(opt) {
    var mainData = opt.mainData;
    var datas = opt.datas;
    if (!datas) {
        datas = {
            main: mainData
        };
        opt.datasAttr = {
            main: 'data'
        };
    }
    opt.datas = opt.mainData = null;
    $4a8451eb7786c849$var$linkAll(mainData, datas, opt);
    // Porxy data original methods.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(datas, function(data) {
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(mainData.TRANSFERABLE_METHODS, function(methodName) {
            data.wrapMethod(methodName, (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($4a8451eb7786c849$var$transferInjection, opt));
        });
    });
    // Beyond transfer, additional features should be added to `cloneShallow`.
    mainData.wrapMethod('cloneShallow', (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($4a8451eb7786c849$var$cloneShallowInjection, opt));
    // Only mainData trigger change, because struct.update may trigger
    // another changable methods, which may bring about dead lock.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(mainData.CHANGABLE_METHODS, function(methodName) {
        mainData.wrapMethod(methodName, (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($4a8451eb7786c849$var$changeInjection, opt));
    });
    // Make sure datas contains mainData.
    (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)(datas[mainData.dataType] === mainData);
}
function $4a8451eb7786c849$var$transferInjection(opt, res) {
    if ($4a8451eb7786c849$var$isMainData(this)) {
        // Transfer datas to new main data.
        var datas = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, $4a8451eb7786c849$var$inner(this).datas);
        datas[this.dataType] = res;
        $4a8451eb7786c849$var$linkAll(res, datas, opt);
    } else // Modify the reference in main data to point newData.
    $4a8451eb7786c849$var$linkSingle(res, this.dataType, $4a8451eb7786c849$var$inner(this).mainData, opt);
    return res;
}
function $4a8451eb7786c849$var$changeInjection(opt, res) {
    opt.struct && opt.struct.update();
    return res;
}
function $4a8451eb7786c849$var$cloneShallowInjection(opt, res) {
    // cloneShallow, which brings about some fragilities, may be inappropriate
    // to be exposed as an API. So for implementation simplicity we can make
    // the restriction that cloneShallow of not-mainData should not be invoked
    // outside, but only be invoked here.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($4a8451eb7786c849$var$inner(res).datas, function(data, dataType) {
        data !== res && $4a8451eb7786c849$var$linkSingle(data.cloneShallow(), dataType, res, opt);
    });
    return res;
}
/**
 * Supplement method to List.
 *
 * @public
 * @param [dataType] If not specified, return mainData.
 */ function $4a8451eb7786c849$var$getLinkedData(dataType) {
    var mainData = $4a8451eb7786c849$var$inner(this).mainData;
    return dataType == null || mainData == null ? mainData : $4a8451eb7786c849$var$inner(mainData).datas[dataType];
}
/**
 * Get list of all linked data
 */ function $4a8451eb7786c849$var$getLinkedDataAll() {
    var mainData = $4a8451eb7786c849$var$inner(this).mainData;
    return mainData == null ? [
        {
            data: mainData
        }
    ] : (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)((0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)($4a8451eb7786c849$var$inner(mainData).datas), function(type) {
        return {
            type: type,
            data: $4a8451eb7786c849$var$inner(mainData).datas[type]
        };
    });
}
function $4a8451eb7786c849$var$isMainData(data) {
    return $4a8451eb7786c849$var$inner(data).mainData === data;
}
function $4a8451eb7786c849$var$linkAll(mainData, datas, opt) {
    $4a8451eb7786c849$var$inner(mainData).datas = {};
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(datas, function(data, dataType) {
        $4a8451eb7786c849$var$linkSingle(data, dataType, mainData, opt);
    });
}
function $4a8451eb7786c849$var$linkSingle(data, dataType, mainData, opt) {
    $4a8451eb7786c849$var$inner(mainData).datas[dataType] = data;
    $4a8451eb7786c849$var$inner(data).mainData = mainData;
    data.dataType = dataType;
    if (opt.struct) {
        data[opt.structAttr] = opt.struct;
        opt.struct[opt.datasAttr[dataType]] = data;
    }
    // Supplement method.
    data.getLinkedData = $4a8451eb7786c849$var$getLinkedData;
    data.getLinkedDataAll = $4a8451eb7786c849$var$getLinkedDataAll;
}
var $4a8451eb7786c849$export$2e2bcd8739ae039 = $4a8451eb7786c849$var$linkSeriesData;






function $09eb5d193a1ecbce$export$2e2bcd8739ae039(nodes, edges, seriesModel, directed, beforeLink) {
    // ??? TODO
    // support dataset?
    var graph = new (0, $7e67f74238c90217$export$2e2bcd8739ae039)(directed);
    for(var i = 0; i < nodes.length; i++)graph.addNode($7a1bd9c2710fea0d$export$8a4d17b6e8486e66(// Id, name, dataIndex
    nodes[i].id, nodes[i].name, i), i);
    var linkNameList = [];
    var validEdges = [];
    var linkCount = 0;
    for(var i = 0; i < edges.length; i++){
        var link = edges[i];
        var source = link.source;
        var target = link.target;
        // addEdge may fail when source or target not exists
        if (graph.addEdge(source, target, linkCount)) {
            validEdges.push(link);
            linkNameList.push($7a1bd9c2710fea0d$export$8a4d17b6e8486e66((0, $76d619f648247e6d$export$fb1a222ba5dd6e51)(link.id, null), source + ' > ' + target));
            linkCount++;
        }
    }
    var coordSys = seriesModel.get('coordinateSystem');
    var nodeData;
    if (coordSys === 'cartesian2d' || coordSys === 'polar') nodeData = (0, $8afdec5f59c90781$export$2e2bcd8739ae039)(nodes, seriesModel);
    else {
        var coordSysCtor = (0, $70c3ede7d3b64757$export$2e2bcd8739ae039).get(coordSys);
        var coordDimensions = coordSysCtor ? coordSysCtor.dimensions || [] : [];
        // FIXME: Some geo do not need `value` dimenson, whereas `calendar` needs
        // `value` dimension, but graph need `value` dimension. It's better to
        // uniform this behavior.
        if ($7a1bd9c2710fea0d$export$305f7d4e9d4624f2(coordDimensions, 'value') < 0) coordDimensions.concat([
            'value'
        ]);
        var dimensions = (0, $a27631012b7b377c$export$2e2bcd8739ae039)(nodes, {
            coordDimensions: coordDimensions,
            encodeDefine: seriesModel.getEncode()
        }).dimensions;
        nodeData = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)(dimensions, seriesModel);
        nodeData.initData(nodes);
    }
    var edgeData = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)([
        'value'
    ], seriesModel);
    edgeData.initData(validEdges, linkNameList);
    beforeLink && beforeLink(nodeData, edgeData);
    (0, $4a8451eb7786c849$export$2e2bcd8739ae039)({
        mainData: nodeData,
        struct: graph,
        structAttr: 'graph',
        datas: {
            node: nodeData,
            edge: edgeData
        },
        datasAttr: {
            node: 'data',
            edge: 'edgeData'
        }
    });
    // Update dataIndex of nodes and edges because invalid edge may be removed
    graph.update();
    return graph;
}







var $6c5e3b756b0e9560$var$GraphSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(GraphSeriesModel, _super);
    function GraphSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GraphSeriesModel.type;
        _this.hasSymbolVisual = true;
        return _this;
    }
    GraphSeriesModel.prototype.init = function(option) {
        _super.prototype.init.apply(this, arguments);
        var self = this;
        function getCategoriesData() {
            return self._categoriesData;
        }
        // Provide data for legend select
        this.legendVisualProvider = new (0, $cf24728fc17c4ab6$export$2e2bcd8739ae039)(getCategoriesData, getCategoriesData);
        this.fillDataTextStyle(option.edges || option.links);
        this._updateCategoriesData();
    };
    GraphSeriesModel.prototype.mergeOption = function(option) {
        _super.prototype.mergeOption.apply(this, arguments);
        this.fillDataTextStyle(option.edges || option.links);
        this._updateCategoriesData();
    };
    GraphSeriesModel.prototype.mergeDefaultAndTheme = function(option) {
        _super.prototype.mergeDefaultAndTheme.apply(this, arguments);
        (0, $76d619f648247e6d$export$abdcc6a26372f94b)(option, 'edgeLabel', [
            'show'
        ]);
    };
    GraphSeriesModel.prototype.getInitialData = function(option, ecModel) {
        var edges = option.edges || option.links || [];
        var nodes = option.data || option.nodes || [];
        var self = this;
        if (nodes && edges) {
            // auto curveness
            (0, $0425a00d02ade69a$export$4f05389c1f2934b8)(this);
            var graph = (0, $09eb5d193a1ecbce$export$2e2bcd8739ae039)(nodes, edges, this, true, beforeLink);
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(graph.edges, function(edge) {
                (0, $0425a00d02ade69a$export$c47b549eed9a7311)(edge.node1, edge.node2, this, edge.dataIndex);
            }, this);
            return graph.data;
        }
        function beforeLink(nodeData, edgeData) {
            // Overwrite nodeData.getItemModel to
            nodeData.wrapMethod('getItemModel', function(model) {
                var categoriesModels = self._categoriesModels;
                var categoryIdx = model.getShallow('category');
                var categoryModel = categoriesModels[categoryIdx];
                if (categoryModel) {
                    categoryModel.parentModel = model.parentModel;
                    model.parentModel = categoryModel;
                }
                return model;
            });
            // TODO Inherit resolveParentPath by default in Model#getModel?
            var oldGetModel = (0, $6818646a97528290$export$2e2bcd8739ae039).prototype.getModel;
            function newGetModel(path, parentModel) {
                var model = oldGetModel.call(this, path, parentModel);
                model.resolveParentPath = resolveParentPath;
                return model;
            }
            edgeData.wrapMethod('getItemModel', function(model) {
                model.resolveParentPath = resolveParentPath;
                model.getModel = newGetModel;
                return model;
            });
            function resolveParentPath(pathArr) {
                if (pathArr && (pathArr[0] === 'label' || pathArr[1] === 'label')) {
                    var newPathArr = pathArr.slice();
                    if (pathArr[0] === 'label') newPathArr[0] = 'edgeLabel';
                    else if (pathArr[1] === 'label') newPathArr[1] = 'edgeLabel';
                    return newPathArr;
                }
                return pathArr;
            }
        }
    };
    GraphSeriesModel.prototype.getGraph = function() {
        return this.getData().graph;
    };
    GraphSeriesModel.prototype.getEdgeData = function() {
        return this.getGraph().edgeData;
    };
    GraphSeriesModel.prototype.getCategoriesData = function() {
        return this._categoriesData;
    };
    GraphSeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        if (dataType === 'edge') {
            var nodeData = this.getData();
            var params = this.getDataParams(dataIndex, dataType);
            var edge = nodeData.graph.getEdgeByIndex(dataIndex);
            var sourceName = nodeData.getName(edge.node1.dataIndex);
            var targetName = nodeData.getName(edge.node2.dataIndex);
            var nameArr = [];
            sourceName != null && nameArr.push(sourceName);
            targetName != null && nameArr.push(targetName);
            return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)('nameValue', {
                name: nameArr.join(' > '),
                value: params.value,
                noValue: params.value == null
            });
        }
        // dataType === 'node' or empty
        var nodeMarkup = (0, $b0d4c63a14430ca1$export$3a110b9fb5c88b34)({
            series: this,
            dataIndex: dataIndex,
            multipleSeries: multipleSeries
        });
        return nodeMarkup;
    };
    GraphSeriesModel.prototype._updateCategoriesData = function() {
        var categories = $7a1bd9c2710fea0d$export$871de8747c9eaa88(this.option.categories || [], function(category) {
            // Data must has value
            return category.value != null ? category : $7a1bd9c2710fea0d$export$8b58be045bf06082({
                value: 0
            }, category);
        });
        var categoriesData = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)([
            'value'
        ], this);
        categoriesData.initData(categories);
        this._categoriesData = categoriesData;
        this._categoriesModels = categoriesData.mapArray(function(idx) {
            return categoriesData.getItemModel(idx);
        });
    };
    GraphSeriesModel.prototype.setZoom = function(zoom) {
        this.option.zoom = zoom;
    };
    GraphSeriesModel.prototype.setCenter = function(center) {
        this.option.center = center;
    };
    GraphSeriesModel.prototype.isAnimationEnabled = function() {
        return _super.prototype.isAnimationEnabled.call(this) && !(this.get('layout') === 'force' && this.get([
            'force',
            'layoutAnimation'
        ]));
    };
    GraphSeriesModel.type = 'series.graph';
    GraphSeriesModel.dependencies = [
        'grid',
        'polar',
        'geo',
        'singleAxis',
        'calendar'
    ];
    GraphSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        coordinateSystem: 'view',
        // Default option for all coordinate systems
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        // polarIndex: 0,
        // geoIndex: 0,
        legendHoverLink: true,
        layout: null,
        // Configuration of circular layout
        circular: {
            rotateLabel: false
        },
        // Configuration of force directed layout
        force: {
            initLayout: null,
            // Node repulsion. Can be an array to represent range.
            repulsion: [
                0,
                50
            ],
            gravity: 0.1,
            // Initial friction
            friction: 0.6,
            // Edge length. Can be an array to represent range.
            edgeLength: 30,
            layoutAnimation: true
        },
        left: 'center',
        top: 'center',
        // right: null,
        // bottom: null,
        // width: '80%',
        // height: '80%',
        symbol: 'circle',
        symbolSize: 10,
        edgeSymbol: [
            'none',
            'none'
        ],
        edgeSymbolSize: 10,
        edgeLabel: {
            position: 'middle',
            distance: 5
        },
        draggable: false,
        roam: false,
        // Default on center of graph
        center: null,
        zoom: 1,
        // Symbol size scale ratio in roam
        nodeScaleRatio: 0.6,
        // cursor: null,
        // categories: [],
        // data: []
        // Or
        // nodes: []
        //
        // links: []
        // Or
        // edges: []
        label: {
            show: false,
            formatter: '{b}'
        },
        itemStyle: {},
        lineStyle: {
            color: '#aaa',
            width: 1,
            opacity: 0.5
        },
        emphasis: {
            scale: true,
            label: {
                show: true
            }
        },
        select: {
            itemStyle: {
                borderColor: '#212121'
            }
        }
    };
    return GraphSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $6c5e3b756b0e9560$export$2e2bcd8739ae039 = $6c5e3b756b0e9560$var$GraphSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $799fe5cfb5042219$var$getCenterCoord(view, point) {
    // Use projected coord as center because it's linear.
    return view.pointToProjected ? view.pointToProjected(point) : view.pointToData(point);
}
function $799fe5cfb5042219$export$797ecc50d262ebd8(view, payload, zoomLimit, api) {
    var previousZoom = view.getZoom();
    var center = view.getCenter();
    var zoom = payload.zoom;
    var point = view.projectedToPoint ? view.projectedToPoint(center) : view.dataToPoint(center);
    if (payload.dx != null && payload.dy != null) {
        point[0] -= payload.dx;
        point[1] -= payload.dy;
        view.setCenter($799fe5cfb5042219$var$getCenterCoord(view, point), api);
    }
    if (zoom != null) {
        if (zoomLimit) {
            var zoomMin = zoomLimit.min || 0;
            var zoomMax = zoomLimit.max || Infinity;
            zoom = Math.max(Math.min(previousZoom * zoom, zoomMax), zoomMin) / previousZoom;
        }
        // Zoom on given point(originX, originY)
        view.scaleX *= zoom;
        view.scaleY *= zoom;
        var fixX = (payload.originX - view.x) * (zoom - 1);
        var fixY = (payload.originY - view.y) * (zoom - 1);
        view.x -= fixX;
        view.y -= fixY;
        view.updateTransform();
        // Get the new center
        view.setCenter($799fe5cfb5042219$var$getCenterCoord(view, point), api);
        view.setZoom(zoom * previousZoom);
    }
    return {
        center: view.getCenter(),
        zoom: view.getZoom()
    };
}



var $b48bd73bf5d69641$var$actionInfo = {
    type: 'graphRoam',
    event: 'graphRoam',
    update: 'none'
};
function $b48bd73bf5d69641$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $65490d05ca8b2521$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $6c5e3b756b0e9560$export$2e2bcd8739ae039));
    registers.registerProcessor((0, $23b43ea6be789dc3$export$2e2bcd8739ae039));
    registers.registerVisual((0, $2c7d64c9b3613d6b$export$2e2bcd8739ae039));
    registers.registerVisual((0, $11ee0a103a25747c$export$2e2bcd8739ae039));
    registers.registerLayout((0, $35717df2daa24f5d$export$2e2bcd8739ae039));
    registers.registerLayout(registers.PRIORITY.VISUAL.POST_CHART_LAYOUT, (0, $3c017b875f1b19fb$export$2e2bcd8739ae039));
    registers.registerLayout((0, $cd6209901c0041df$export$2e2bcd8739ae039));
    registers.registerCoordinateSystem('graphView', {
        dimensions: (0, $4a92e7570d47c1fe$export$2e2bcd8739ae039).dimensions,
        create: (0, $8491beaca48712b9$export$2e2bcd8739ae039)
    });
    // Register legacy focus actions
    registers.registerAction({
        type: 'focusNodeAdjacency',
        event: 'focusNodeAdjacency',
        update: 'series:focusNodeAdjacency'
    }, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));
    registers.registerAction({
        type: 'unfocusNodeAdjacency',
        event: 'unfocusNodeAdjacency',
        update: 'series:unfocusNodeAdjacency'
    }, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));
    // Register roam action.
    registers.registerAction($b48bd73bf5d69641$var$actionInfo, function(payload, ecModel, api) {
        ecModel.eachComponent({
            mainType: 'series',
            query: payload
        }, function(seriesModel) {
            var coordSys = seriesModel.coordinateSystem;
            var res = (0, $799fe5cfb5042219$export$797ecc50d262ebd8)(coordSys, payload, undefined, api);
            seriesModel.setCenter && seriesModel.setCenter(res.center);
            seriesModel.setZoom && seriesModel.setZoom(res.zoom);
        });
    });
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /* global Uint8ClampedArray */ 
var $e72df59f80933534$var$GRADIENT_LEVELS = 256;
var $e72df59f80933534$var$HeatmapLayer = /** @class */ function() {
    function HeatmapLayer() {
        this.blurSize = 30;
        this.pointSize = 20;
        this.maxOpacity = 1;
        this.minOpacity = 0;
        this._gradientPixels = {
            inRange: null,
            outOfRange: null
        };
        var canvas = (0, $c6341dcc9d86826e$export$ef5e599365494451).createCanvas();
        this.canvas = canvas;
    }
    /**
   * Renders Heatmap and returns the rendered canvas
   * @param data array of data, each has x, y, value
   * @param width canvas width
   * @param height canvas height
   */ HeatmapLayer.prototype.update = function(data, width, height, normalize, colorFunc, isInRange) {
        var brush = this._getBrush();
        var gradientInRange = this._getGradient(colorFunc, 'inRange');
        var gradientOutOfRange = this._getGradient(colorFunc, 'outOfRange');
        var r = this.pointSize + this.blurSize;
        var canvas = this.canvas;
        var ctx = canvas.getContext('2d');
        var len = data.length;
        canvas.width = width;
        canvas.height = height;
        for(var i = 0; i < len; ++i){
            var p = data[i];
            var x = p[0];
            var y = p[1];
            var value = p[2];
            // calculate alpha using value
            var alpha = normalize(value);
            // draw with the circle brush with alpha
            ctx.globalAlpha = alpha;
            ctx.drawImage(brush, x - r, y - r);
        }
        if (!canvas.width || !canvas.height) // Avoid "Uncaught DOMException: Failed to execute 'getImageData' on
        // 'CanvasRenderingContext2D': The source height is 0."
        return canvas;
        // colorize the canvas using alpha value and set with gradient
        var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        var pixels = imageData.data;
        var offset = 0;
        var pixelLen = pixels.length;
        var minOpacity = this.minOpacity;
        var maxOpacity = this.maxOpacity;
        var diffOpacity = maxOpacity - minOpacity;
        while(offset < pixelLen){
            var alpha = pixels[offset + 3] / 256;
            var gradientOffset = Math.floor(alpha * ($e72df59f80933534$var$GRADIENT_LEVELS - 1)) * 4;
            // Simple optimize to ignore the empty data
            if (alpha > 0) {
                var gradient = isInRange(alpha) ? gradientInRange : gradientOutOfRange;
                // Any alpha > 0 will be mapped to [minOpacity, maxOpacity]
                alpha > 0 && (alpha = alpha * diffOpacity + minOpacity);
                pixels[offset++] = gradient[gradientOffset];
                pixels[offset++] = gradient[gradientOffset + 1];
                pixels[offset++] = gradient[gradientOffset + 2];
                pixels[offset++] = gradient[gradientOffset + 3] * alpha * 256;
            } else offset += 4;
        }
        ctx.putImageData(imageData, 0, 0);
        return canvas;
    };
    /**
   * get canvas of a black circle brush used for canvas to draw later
   */ HeatmapLayer.prototype._getBrush = function() {
        var brushCanvas = this._brushCanvas || (this._brushCanvas = (0, $c6341dcc9d86826e$export$ef5e599365494451).createCanvas());
        // set brush size
        var r = this.pointSize + this.blurSize;
        var d = r * 2;
        brushCanvas.width = d;
        brushCanvas.height = d;
        var ctx = brushCanvas.getContext('2d');
        ctx.clearRect(0, 0, d, d);
        // in order to render shadow without the distinct circle,
        // draw the distinct circle in an invisible place,
        // and use shadowOffset to draw shadow in the center of the canvas
        ctx.shadowOffsetX = d;
        ctx.shadowBlur = this.blurSize;
        // draw the shadow in black, and use alpha and shadow blur to generate
        // color in color map
        ctx.shadowColor = '#000';
        // draw circle in the left to the canvas
        ctx.beginPath();
        ctx.arc(-r, r, this.pointSize, 0, Math.PI * 2, true);
        ctx.closePath();
        ctx.fill();
        return brushCanvas;
    };
    /**
   * get gradient color map
   * @private
   */ HeatmapLayer.prototype._getGradient = function(colorFunc, state) {
        var gradientPixels = this._gradientPixels;
        var pixelsSingleState = gradientPixels[state] || (gradientPixels[state] = new Uint8ClampedArray(1024));
        var color = [
            0,
            0,
            0,
            0
        ];
        var off = 0;
        for(var i = 0; i < 256; i++){
            colorFunc[state](i / 255, true, color);
            pixelsSingleState[off++] = color[0];
            pixelsSingleState[off++] = color[1];
            pixelsSingleState[off++] = color[2];
            pixelsSingleState[off++] = color[3];
        }
        return pixelsSingleState;
    };
    return HeatmapLayer;
}();
var $e72df59f80933534$export$2e2bcd8739ae039 = $e72df59f80933534$var$HeatmapLayer;






function $62f45dd0b06f949c$var$getIsInPiecewiseRange(dataExtent, pieceList, selected) {
    var dataSpan = dataExtent[1] - dataExtent[0];
    pieceList = $7a1bd9c2710fea0d$export$871de8747c9eaa88(pieceList, function(piece) {
        return {
            interval: [
                (piece.interval[0] - dataExtent[0]) / dataSpan,
                (piece.interval[1] - dataExtent[0]) / dataSpan
            ]
        };
    });
    var len = pieceList.length;
    var lastIndex = 0;
    return function(val) {
        var i;
        // Try to find in the location of the last found
        for(i = lastIndex; i < len; i++){
            var interval = pieceList[i].interval;
            if (interval[0] <= val && val <= interval[1]) {
                lastIndex = i;
                break;
            }
        }
        if (i === len) // Not found, back interation
        for(i = lastIndex - 1; i >= 0; i--){
            var interval = pieceList[i].interval;
            if (interval[0] <= val && val <= interval[1]) {
                lastIndex = i;
                break;
            }
        }
        return i >= 0 && i < len && selected[i];
    };
}
function $62f45dd0b06f949c$var$getIsInContinuousRange(dataExtent, range) {
    var dataSpan = dataExtent[1] - dataExtent[0];
    range = [
        (range[0] - dataExtent[0]) / dataSpan,
        (range[1] - dataExtent[0]) / dataSpan
    ];
    return function(val) {
        return val >= range[0] && val <= range[1];
    };
}
function $62f45dd0b06f949c$var$isGeoCoordSys(coordSys) {
    var dimensions = coordSys.dimensions;
    // Not use coordSys.type === 'geo' because coordSys maybe extended
    return dimensions[0] === 'lng' && dimensions[1] === 'lat';
}
var $62f45dd0b06f949c$var$HeatmapView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(HeatmapView, _super);
    function HeatmapView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = HeatmapView.type;
        return _this;
    }
    HeatmapView.prototype.render = function(seriesModel, ecModel, api) {
        var visualMapOfThisSeries;
        ecModel.eachComponent('visualMap', function(visualMap) {
            visualMap.eachTargetSeries(function(targetSeries) {
                if (targetSeries === seriesModel) visualMapOfThisSeries = visualMap;
            });
        });
        // Clear previously rendered progressive elements.
        this._progressiveEls = null;
        this.group.removeAll();
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys.type === 'cartesian2d' || coordSys.type === 'calendar') this._renderOnCartesianAndCalendar(seriesModel, api, 0, seriesModel.getData().count());
        else if ($62f45dd0b06f949c$var$isGeoCoordSys(coordSys)) this._renderOnGeo(coordSys, seriesModel, visualMapOfThisSeries, api);
    };
    HeatmapView.prototype.incrementalPrepareRender = function(seriesModel, ecModel, api) {
        this.group.removeAll();
    };
    HeatmapView.prototype.incrementalRender = function(params, seriesModel, ecModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys) {
            // geo does not support incremental rendering?
            if ($62f45dd0b06f949c$var$isGeoCoordSys(coordSys)) this.render(seriesModel, ecModel, api);
            else {
                this._progressiveEls = [];
                this._renderOnCartesianAndCalendar(seriesModel, api, params.start, params.end, true);
            }
        }
    };
    HeatmapView.prototype.eachRendered = function(cb) {
        $5b455ae6f843ac47$export$3e564442729bf048(this._progressiveEls || this.group, cb);
    };
    HeatmapView.prototype._renderOnCartesianAndCalendar = function(seriesModel, api, start, end, incremental) {
        var coordSys = seriesModel.coordinateSystem;
        var isCartesian2d = (0, $3fea949f0512eb55$export$8567506e6336616)(coordSys, 'cartesian2d');
        var width;
        var height;
        var xAxisExtent;
        var yAxisExtent;
        if (isCartesian2d) {
            var xAxis = coordSys.getAxis('x');
            var yAxis = coordSys.getAxis('y');
            // add 0.5px to avoid the gaps
            width = xAxis.getBandWidth() + .5;
            height = yAxis.getBandWidth() + .5;
            xAxisExtent = xAxis.scale.getExtent();
            yAxisExtent = yAxis.scale.getExtent();
        }
        var group = this.group;
        var data = seriesModel.getData();
        var emphasisStyle = seriesModel.getModel([
            'emphasis',
            'itemStyle'
        ]).getItemStyle();
        var blurStyle = seriesModel.getModel([
            'blur',
            'itemStyle'
        ]).getItemStyle();
        var selectStyle = seriesModel.getModel([
            'select',
            'itemStyle'
        ]).getItemStyle();
        var borderRadius = seriesModel.get([
            'itemStyle',
            'borderRadius'
        ]);
        var labelStatesModels = (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(seriesModel);
        var emphasisModel = seriesModel.getModel('emphasis');
        var focus = emphasisModel.get('focus');
        var blurScope = emphasisModel.get('blurScope');
        var emphasisDisabled = emphasisModel.get('disabled');
        var dataDims = isCartesian2d ? [
            data.mapDimension('x'),
            data.mapDimension('y'),
            data.mapDimension('value')
        ] : [
            data.mapDimension('time'),
            data.mapDimension('value')
        ];
        for(var idx = start; idx < end; idx++){
            var rect = void 0;
            var style = data.getItemVisual(idx, 'style');
            if (isCartesian2d) {
                var dataDimX = data.get(dataDims[0], idx);
                var dataDimY = data.get(dataDims[1], idx);
                // Ignore empty data and out of extent data
                if (isNaN(data.get(dataDims[2], idx)) || isNaN(dataDimX) || isNaN(dataDimY) || dataDimX < xAxisExtent[0] || dataDimX > xAxisExtent[1] || dataDimY < yAxisExtent[0] || dataDimY > yAxisExtent[1]) continue;
                var point = coordSys.dataToPoint([
                    dataDimX,
                    dataDimY
                ]);
                rect = new $419e5ff2f303755e$export$2e2bcd8739ae039({
                    shape: {
                        x: point[0] - width / 2,
                        y: point[1] - height / 2,
                        width: width,
                        height: height
                    },
                    style: style
                });
            } else {
                // Ignore empty data
                if (isNaN(data.get(dataDims[1], idx))) continue;
                rect = new $419e5ff2f303755e$export$2e2bcd8739ae039({
                    z2: 1,
                    shape: coordSys.dataToRect([
                        data.get(dataDims[0], idx)
                    ]).contentShape,
                    style: style
                });
            }
            // Optimization for large dataset
            if (data.hasItemOption) {
                var itemModel = data.getItemModel(idx);
                var emphasisModel_1 = itemModel.getModel('emphasis');
                emphasisStyle = emphasisModel_1.getModel('itemStyle').getItemStyle();
                blurStyle = itemModel.getModel([
                    'blur',
                    'itemStyle'
                ]).getItemStyle();
                selectStyle = itemModel.getModel([
                    'select',
                    'itemStyle'
                ]).getItemStyle();
                // Each item value struct in the data would be firstly
                // {
                //     itemStyle: { borderRadius: [30, 30] },
                //     value: [2022, 02, 22]
                // }
                borderRadius = itemModel.get([
                    'itemStyle',
                    'borderRadius'
                ]);
                focus = emphasisModel_1.get('focus');
                blurScope = emphasisModel_1.get('blurScope');
                emphasisDisabled = emphasisModel_1.get('disabled');
                labelStatesModels = (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(itemModel);
            }
            rect.shape.r = borderRadius;
            var rawValue = seriesModel.getRawValue(idx);
            var defaultText = '-';
            if (rawValue && rawValue[2] != null) defaultText = rawValue[2] + '';
            (0, $6800dfcb6e1e2a44$export$9a13992917966657)(rect, labelStatesModels, {
                labelFetcher: seriesModel,
                labelDataIndex: idx,
                defaultOpacity: style.opacity,
                defaultText: defaultText
            });
            rect.ensureState('emphasis').style = emphasisStyle;
            rect.ensureState('blur').style = blurStyle;
            rect.ensureState('select').style = selectStyle;
            (0, $2bf82c0980125b62$export$e51187539ff11209)(rect, focus, blurScope, emphasisDisabled);
            rect.incremental = incremental;
            // PENDING
            if (incremental) // Rect must use hover layer if it's incremental.
            rect.states.emphasis.hoverLayer = true;
            group.add(rect);
            data.setItemGraphicEl(idx, rect);
            if (this._progressiveEls) this._progressiveEls.push(rect);
        }
    };
    HeatmapView.prototype._renderOnGeo = function(geo, seriesModel, visualMapModel, api) {
        var inRangeVisuals = visualMapModel.targetVisuals.inRange;
        var outOfRangeVisuals = visualMapModel.targetVisuals.outOfRange;
        // if (!visualMapping) {
        //     throw new Error('Data range must have color visuals');
        // }
        var data = seriesModel.getData();
        var hmLayer = this._hmLayer || this._hmLayer || new (0, $e72df59f80933534$export$2e2bcd8739ae039)();
        hmLayer.blurSize = seriesModel.get('blurSize');
        hmLayer.pointSize = seriesModel.get('pointSize');
        hmLayer.minOpacity = seriesModel.get('minOpacity');
        hmLayer.maxOpacity = seriesModel.get('maxOpacity');
        var rect = geo.getViewRect().clone();
        var roamTransform = geo.getRoamTransform();
        rect.applyTransform(roamTransform);
        // Clamp on viewport
        var x = Math.max(rect.x, 0);
        var y = Math.max(rect.y, 0);
        var x2 = Math.min(rect.width + rect.x, api.getWidth());
        var y2 = Math.min(rect.height + rect.y, api.getHeight());
        var width = x2 - x;
        var height = y2 - y;
        var dims = [
            data.mapDimension('lng'),
            data.mapDimension('lat'),
            data.mapDimension('value')
        ];
        var points = data.mapArray(dims, function(lng, lat, value) {
            var pt = geo.dataToPoint([
                lng,
                lat
            ]);
            pt[0] -= x;
            pt[1] -= y;
            pt.push(value);
            return pt;
        });
        var dataExtent = visualMapModel.getExtent();
        var isInRange = visualMapModel.type === 'visualMap.continuous' ? $62f45dd0b06f949c$var$getIsInContinuousRange(dataExtent, visualMapModel.option.range) : $62f45dd0b06f949c$var$getIsInPiecewiseRange(dataExtent, visualMapModel.getPieceList(), visualMapModel.option.selected);
        hmLayer.update(points, width, height, inRangeVisuals.color.getNormalizer(), {
            inRange: inRangeVisuals.color.getColorMapper(),
            outOfRange: outOfRangeVisuals.color.getColorMapper()
        }, isInRange);
        var img = new $86adec94217b86c6$export$2e2bcd8739ae039({
            style: {
                width: width,
                height: height,
                x: x,
                y: y,
                image: hmLayer.canvas
            },
            silent: true
        });
        this.group.add(img);
    };
    HeatmapView.type = 'heatmap';
    return HeatmapView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $62f45dd0b06f949c$export$2e2bcd8739ae039 = $62f45dd0b06f949c$var$HeatmapView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $4b84759fb7a8174c$var$HeatmapSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(HeatmapSeriesModel, _super);
    function HeatmapSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = HeatmapSeriesModel.type;
        return _this;
    }
    HeatmapSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $8afdec5f59c90781$export$2e2bcd8739ae039)(null, this, {
            generateCoord: 'value'
        });
    };
    HeatmapSeriesModel.prototype.preventIncremental = function() {
        var coordSysCreator = (0, $70c3ede7d3b64757$export$2e2bcd8739ae039).get(this.get('coordinateSystem'));
        if (coordSysCreator && coordSysCreator.dimensions) return coordSysCreator.dimensions[0] === 'lng' && coordSysCreator.dimensions[1] === 'lat';
    };
    HeatmapSeriesModel.type = 'series.heatmap';
    HeatmapSeriesModel.dependencies = [
        'grid',
        'geo',
        'calendar'
    ];
    HeatmapSeriesModel.defaultOption = {
        coordinateSystem: 'cartesian2d',
        // zlevel: 0,
        z: 2,
        // Cartesian coordinate system
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        // Geo coordinate system
        geoIndex: 0,
        blurSize: 30,
        pointSize: 20,
        maxOpacity: 1,
        minOpacity: 0,
        select: {
            itemStyle: {
                borderColor: '#212121'
            }
        }
    };
    return HeatmapSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $4b84759fb7a8174c$export$2e2bcd8739ae039 = $4b84759fb7a8174c$var$HeatmapSeriesModel;


function $c53e84d38e53ec61$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $62f45dd0b06f949c$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $4b84759fb7a8174c$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $04f9db15b0fa1cf8$var$LineSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(LineSeriesModel, _super);
    function LineSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = LineSeriesModel.type;
        _this.hasSymbolVisual = true;
        return _this;
    }
    LineSeriesModel.prototype.getInitialData = function(option) {
        var coordSys;
        return (0, $8afdec5f59c90781$export$2e2bcd8739ae039)(null, this, {
            useEncodeDefaulter: true
        });
    };
    LineSeriesModel.prototype.getLegendIcon = function(opt) {
        var group = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)();
        var line = (0, $5370466dadc978d7$export$af050e04da3a02e8)('line', 0, opt.itemHeight / 2, opt.itemWidth, 0, opt.lineStyle.stroke, false);
        group.add(line);
        line.setStyle(opt.lineStyle);
        var visualType = this.getData().getVisual('symbol');
        var visualRotate = this.getData().getVisual('symbolRotate');
        var symbolType = visualType === 'none' ? 'circle' : visualType;
        // Symbol size is 80% when there is a line
        var size = opt.itemHeight * 0.8;
        var symbol = (0, $5370466dadc978d7$export$af050e04da3a02e8)(symbolType, (opt.itemWidth - size) / 2, (opt.itemHeight - size) / 2, size, size, opt.itemStyle.fill);
        group.add(symbol);
        symbol.setStyle(opt.itemStyle);
        var symbolRotate = opt.iconRotate === 'inherit' ? visualRotate : opt.iconRotate || 0;
        symbol.rotation = symbolRotate * Math.PI / 180;
        symbol.setOrigin([
            opt.itemWidth / 2,
            opt.itemHeight / 2
        ]);
        if (symbolType.indexOf('empty') > -1) {
            symbol.style.stroke = symbol.style.fill;
            symbol.style.fill = '#fff';
            symbol.style.lineWidth = 2;
        }
        return group;
    };
    LineSeriesModel.type = 'series.line';
    LineSeriesModel.dependencies = [
        'grid',
        'polar'
    ];
    LineSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 3,
        coordinateSystem: 'cartesian2d',
        legendHoverLink: true,
        clip: true,
        label: {
            position: 'top'
        },
        // itemStyle: {
        // },
        endLabel: {
            show: false,
            valueAnimation: true,
            distance: 8
        },
        lineStyle: {
            width: 2,
            type: 'solid'
        },
        emphasis: {
            scale: true
        },
        // areaStyle: {
        // origin of areaStyle. Valid values:
        // `'auto'/null/undefined`: from axisLine to data
        // `'start'`: from min to data
        // `'end'`: from data to max
        // origin: 'auto'
        // },
        // false, 'start', 'end', 'middle'
        step: false,
        // Disabled if step is true
        smooth: false,
        smoothMonotone: null,
        symbol: 'emptyCircle',
        symbolSize: 4,
        symbolRotate: null,
        showSymbol: true,
        // `false`: follow the label interval strategy.
        // `true`: show all symbols.
        // `'auto'`: If possible, show all symbols, otherwise
        //           follow the label interval strategy.
        showAllSymbol: 'auto',
        // Whether to connect break point.
        connectNulls: false,
        // Sampling for large data. Can be: 'average', 'max', 'min', 'sum', 'lttb'.
        sampling: 'none',
        animationEasing: 'linear',
        // Disable progressive
        progressive: 0,
        hoverLayerThreshold: Infinity,
        universalTransition: {
            divideShape: 'clone'
        },
        triggerLineEvent: false
    };
    return LineSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $04f9db15b0fa1cf8$export$2e2bcd8739ae039 = $04f9db15b0fa1cf8$var$LineSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $af63fd8cd32fb271$export$b488a529581b37e(coordSys, data, valueOrigin) {
    var baseAxis = coordSys.getBaseAxis();
    var valueAxis = coordSys.getOtherAxis(baseAxis);
    var valueStart = $af63fd8cd32fb271$var$getValueStart(valueAxis, valueOrigin);
    var baseAxisDim = baseAxis.dim;
    var valueAxisDim = valueAxis.dim;
    var valueDim = data.mapDimension(valueAxisDim);
    var baseDim = data.mapDimension(baseAxisDim);
    var baseDataOffset = valueAxisDim === 'x' || valueAxisDim === 'radius' ? 1 : 0;
    var dims = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(coordSys.dimensions, function(coordDim) {
        return data.mapDimension(coordDim);
    });
    var stacked = false;
    var stackResultDim = data.getCalculationInfo('stackResultDimension');
    if ((0, $efdd976e4917927c$export$1dedc39359ae35c)(data, dims[0])) {
        // jshint ignore:line
        stacked = true;
        dims[0] = stackResultDim;
    }
    if ((0, $efdd976e4917927c$export$1dedc39359ae35c)(data, dims[1])) {
        // jshint ignore:line
        stacked = true;
        dims[1] = stackResultDim;
    }
    return {
        dataDimsForPoint: dims,
        valueStart: valueStart,
        valueAxisDim: valueAxisDim,
        baseAxisDim: baseAxisDim,
        stacked: !!stacked,
        valueDim: valueDim,
        baseDim: baseDim,
        baseDataOffset: baseDataOffset,
        stackedOverDimension: data.getCalculationInfo('stackedOverDimension')
    };
}
function $af63fd8cd32fb271$var$getValueStart(valueAxis, valueOrigin) {
    var valueStart = 0;
    var extent = valueAxis.scale.getExtent();
    if (valueOrigin === 'start') valueStart = extent[0];
    else if (valueOrigin === 'end') valueStart = extent[1];
    else if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(valueOrigin) && !isNaN(valueOrigin)) valueStart = valueOrigin;
    else {
        // Both positive
        if (extent[0] > 0) valueStart = extent[0];
        else if (extent[1] < 0) valueStart = extent[1];
    // If is one positive, and one negative, onZero shall be true
    }
    return valueStart;
}
function $af63fd8cd32fb271$export$c1601aa630e7b5f8(dataCoordInfo, coordSys, data, idx) {
    var value = NaN;
    if (dataCoordInfo.stacked) value = data.get(data.getCalculationInfo('stackedOverDimension'), idx);
    if (isNaN(value)) value = dataCoordInfo.valueStart;
    var baseDataOffset = dataCoordInfo.baseDataOffset;
    var stackedData = [];
    stackedData[baseDataOffset] = data.get(dataCoordInfo.baseDim, idx);
    stackedData[1 - baseDataOffset] = value;
    return coordSys.dataToPoint(stackedData);
}



function $b022c65e2d67ded9$var$diffData(oldData, newData) {
    var diffResult = [];
    newData.diff(oldData).add(function(idx) {
        diffResult.push({
            cmd: '+',
            idx: idx
        });
    }).update(function(newIdx, oldIdx) {
        diffResult.push({
            cmd: '=',
            idx: oldIdx,
            idx1: newIdx
        });
    }).remove(function(idx) {
        diffResult.push({
            cmd: '-',
            idx: idx
        });
    }).execute();
    return diffResult;
}
function $b022c65e2d67ded9$export$2e2bcd8739ae039(oldData, newData, oldStackedOnPoints, newStackedOnPoints, oldCoordSys, newCoordSys, oldValueOrigin, newValueOrigin) {
    var diff = $b022c65e2d67ded9$var$diffData(oldData, newData);
    // let newIdList = newData.mapArray(newData.getId);
    // let oldIdList = oldData.mapArray(oldData.getId);
    // convertToIntId(newIdList, oldIdList);
    // // FIXME One data ?
    // diff = arrayDiff(oldIdList, newIdList);
    var currPoints = [];
    var nextPoints = [];
    // Points for stacking base line
    var currStackedPoints = [];
    var nextStackedPoints = [];
    var status = [];
    var sortedIndices = [];
    var rawIndices = [];
    var newDataOldCoordInfo = (0, $af63fd8cd32fb271$export$b488a529581b37e)(oldCoordSys, newData, oldValueOrigin);
    // const oldDataNewCoordInfo = prepareDataCoordInfo(newCoordSys, oldData, newValueOrigin);
    var oldPoints = oldData.getLayout('points') || [];
    var newPoints = newData.getLayout('points') || [];
    for(var i = 0; i < diff.length; i++){
        var diffItem = diff[i];
        var pointAdded = true;
        var oldIdx2 = void 0;
        var newIdx2 = void 0;
        // FIXME, animation is not so perfect when dataZoom window moves fast
        // Which is in case remvoing or add more than one data in the tail or head
        switch(diffItem.cmd){
            case '=':
                oldIdx2 = diffItem.idx * 2;
                newIdx2 = diffItem.idx1 * 2;
                var currentX = oldPoints[oldIdx2];
                var currentY = oldPoints[oldIdx2 + 1];
                var nextX = newPoints[newIdx2];
                var nextY = newPoints[newIdx2 + 1];
                // If previous data is NaN, use next point directly
                if (isNaN(currentX) || isNaN(currentY)) {
                    currentX = nextX;
                    currentY = nextY;
                }
                currPoints.push(currentX, currentY);
                nextPoints.push(nextX, nextY);
                currStackedPoints.push(oldStackedOnPoints[oldIdx2], oldStackedOnPoints[oldIdx2 + 1]);
                nextStackedPoints.push(newStackedOnPoints[newIdx2], newStackedOnPoints[newIdx2 + 1]);
                rawIndices.push(newData.getRawIndex(diffItem.idx1));
                break;
            case '+':
                var newIdx = diffItem.idx;
                var newDataDimsForPoint = newDataOldCoordInfo.dataDimsForPoint;
                var oldPt = oldCoordSys.dataToPoint([
                    newData.get(newDataDimsForPoint[0], newIdx),
                    newData.get(newDataDimsForPoint[1], newIdx)
                ]);
                newIdx2 = newIdx * 2;
                currPoints.push(oldPt[0], oldPt[1]);
                nextPoints.push(newPoints[newIdx2], newPoints[newIdx2 + 1]);
                var stackedOnPoint = (0, $af63fd8cd32fb271$export$c1601aa630e7b5f8)(newDataOldCoordInfo, oldCoordSys, newData, newIdx);
                currStackedPoints.push(stackedOnPoint[0], stackedOnPoint[1]);
                nextStackedPoints.push(newStackedOnPoints[newIdx2], newStackedOnPoints[newIdx2 + 1]);
                rawIndices.push(newData.getRawIndex(newIdx));
                break;
            case '-':
                pointAdded = false;
        }
        // Original indices
        if (pointAdded) {
            status.push(diffItem);
            sortedIndices.push(sortedIndices.length);
        }
    }
    // Diff result may be crossed if all items are changed
    // Sort by data index
    sortedIndices.sort(function(a, b) {
        return rawIndices[a] - rawIndices[b];
    });
    var len = currPoints.length;
    var sortedCurrPoints = (0, $5cd50afac93e9148$export$21d2298f3f56bbaf)(len);
    var sortedNextPoints = (0, $5cd50afac93e9148$export$21d2298f3f56bbaf)(len);
    var sortedCurrStackedPoints = (0, $5cd50afac93e9148$export$21d2298f3f56bbaf)(len);
    var sortedNextStackedPoints = (0, $5cd50afac93e9148$export$21d2298f3f56bbaf)(len);
    var sortedStatus = [];
    for(var i = 0; i < sortedIndices.length; i++){
        var idx = sortedIndices[i];
        var i2 = i * 2;
        var idx2 = idx * 2;
        sortedCurrPoints[i2] = currPoints[idx2];
        sortedCurrPoints[i2 + 1] = currPoints[idx2 + 1];
        sortedNextPoints[i2] = nextPoints[idx2];
        sortedNextPoints[i2 + 1] = nextPoints[idx2 + 1];
        sortedCurrStackedPoints[i2] = currStackedPoints[idx2];
        sortedCurrStackedPoints[i2 + 1] = currStackedPoints[idx2 + 1];
        sortedNextStackedPoints[i2] = nextStackedPoints[idx2];
        sortedNextStackedPoints[i2 + 1] = nextStackedPoints[idx2 + 1];
        sortedStatus[i] = status[idx];
    }
    return {
        current: sortedCurrPoints,
        next: sortedNextPoints,
        stackedOnCurrent: sortedCurrStackedPoints,
        stackedOnNext: sortedNextStackedPoints,
        status: sortedStatus
    };
}




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $5c417e1ed90142c5$var$mathMin = Math.min;
var $5c417e1ed90142c5$var$mathMax = Math.max;
function $5c417e1ed90142c5$var$isPointNull(x, y) {
    return isNaN(x) || isNaN(y);
}
/**
 * Draw smoothed line in non-monotone, in may cause undesired curve in extreme
 * situations. This should be used when points are non-monotone neither in x or
 * y dimension.
 */ function $5c417e1ed90142c5$var$drawSegment(ctx, points, start, segLen, allLen, dir, smooth, smoothMonotone, connectNulls) {
    var prevX;
    var prevY;
    var cpx0;
    var cpy0;
    var cpx1;
    var cpy1;
    var idx = start;
    var k = 0;
    for(; k < segLen; k++){
        var x = points[idx * 2];
        var y = points[idx * 2 + 1];
        if (idx >= allLen || idx < 0) break;
        if ($5c417e1ed90142c5$var$isPointNull(x, y)) {
            if (connectNulls) {
                idx += dir;
                continue;
            }
            break;
        }
        if (idx === start) {
            ctx[dir > 0 ? 'moveTo' : 'lineTo'](x, y);
            cpx0 = x;
            cpy0 = y;
        } else {
            var dx = x - prevX;
            var dy = y - prevY;
            // Ignore tiny segment.
            if (dx * dx + dy * dy < 0.5) {
                idx += dir;
                continue;
            }
            if (smooth > 0) {
                var nextIdx = idx + dir;
                var nextX = points[nextIdx * 2];
                var nextY = points[nextIdx * 2 + 1];
                // Ignore duplicate point
                while(nextX === x && nextY === y && k < segLen){
                    k++;
                    nextIdx += dir;
                    idx += dir;
                    nextX = points[nextIdx * 2];
                    nextY = points[nextIdx * 2 + 1];
                    x = points[idx * 2];
                    y = points[idx * 2 + 1];
                    dx = x - prevX;
                    dy = y - prevY;
                }
                var tmpK = k + 1;
                if (connectNulls) // Find next point not null
                while($5c417e1ed90142c5$var$isPointNull(nextX, nextY) && tmpK < segLen){
                    tmpK++;
                    nextIdx += dir;
                    nextX = points[nextIdx * 2];
                    nextY = points[nextIdx * 2 + 1];
                }
                var ratioNextSeg = 0.5;
                var vx = 0;
                var vy = 0;
                var nextCpx0 = void 0;
                var nextCpy0 = void 0;
                // Is last point
                if (tmpK >= segLen || $5c417e1ed90142c5$var$isPointNull(nextX, nextY)) {
                    cpx1 = x;
                    cpy1 = y;
                } else {
                    vx = nextX - prevX;
                    vy = nextY - prevY;
                    var dx0 = x - prevX;
                    var dx1 = nextX - x;
                    var dy0 = y - prevY;
                    var dy1 = nextY - y;
                    var lenPrevSeg = void 0;
                    var lenNextSeg = void 0;
                    if (smoothMonotone === 'x') {
                        lenPrevSeg = Math.abs(dx0);
                        lenNextSeg = Math.abs(dx1);
                        var dir_1 = vx > 0 ? 1 : -1;
                        cpx1 = x - dir_1 * lenPrevSeg * smooth;
                        cpy1 = y;
                        nextCpx0 = x + dir_1 * lenNextSeg * smooth;
                        nextCpy0 = y;
                    } else if (smoothMonotone === 'y') {
                        lenPrevSeg = Math.abs(dy0);
                        lenNextSeg = Math.abs(dy1);
                        var dir_2 = vy > 0 ? 1 : -1;
                        cpx1 = x;
                        cpy1 = y - dir_2 * lenPrevSeg * smooth;
                        nextCpx0 = x;
                        nextCpy0 = y + dir_2 * lenNextSeg * smooth;
                    } else {
                        lenPrevSeg = Math.sqrt(dx0 * dx0 + dy0 * dy0);
                        lenNextSeg = Math.sqrt(dx1 * dx1 + dy1 * dy1);
                        // Use ratio of seg length
                        ratioNextSeg = lenNextSeg / (lenNextSeg + lenPrevSeg);
                        cpx1 = x - vx * smooth * (1 - ratioNextSeg);
                        cpy1 = y - vy * smooth * (1 - ratioNextSeg);
                        // cp0 of next segment
                        nextCpx0 = x + vx * smooth * ratioNextSeg;
                        nextCpy0 = y + vy * smooth * ratioNextSeg;
                        // Smooth constraint between point and next point.
                        // Avoid exceeding extreme after smoothing.
                        nextCpx0 = $5c417e1ed90142c5$var$mathMin(nextCpx0, $5c417e1ed90142c5$var$mathMax(nextX, x));
                        nextCpy0 = $5c417e1ed90142c5$var$mathMin(nextCpy0, $5c417e1ed90142c5$var$mathMax(nextY, y));
                        nextCpx0 = $5c417e1ed90142c5$var$mathMax(nextCpx0, $5c417e1ed90142c5$var$mathMin(nextX, x));
                        nextCpy0 = $5c417e1ed90142c5$var$mathMax(nextCpy0, $5c417e1ed90142c5$var$mathMin(nextY, y));
                        // Reclaculate cp1 based on the adjusted cp0 of next seg.
                        vx = nextCpx0 - x;
                        vy = nextCpy0 - y;
                        cpx1 = x - vx * lenPrevSeg / lenNextSeg;
                        cpy1 = y - vy * lenPrevSeg / lenNextSeg;
                        // Smooth constraint between point and prev point.
                        // Avoid exceeding extreme after smoothing.
                        cpx1 = $5c417e1ed90142c5$var$mathMin(cpx1, $5c417e1ed90142c5$var$mathMax(prevX, x));
                        cpy1 = $5c417e1ed90142c5$var$mathMin(cpy1, $5c417e1ed90142c5$var$mathMax(prevY, y));
                        cpx1 = $5c417e1ed90142c5$var$mathMax(cpx1, $5c417e1ed90142c5$var$mathMin(prevX, x));
                        cpy1 = $5c417e1ed90142c5$var$mathMax(cpy1, $5c417e1ed90142c5$var$mathMin(prevY, y));
                        // Adjust next cp0 again.
                        vx = x - cpx1;
                        vy = y - cpy1;
                        nextCpx0 = x + vx * lenNextSeg / lenPrevSeg;
                        nextCpy0 = y + vy * lenNextSeg / lenPrevSeg;
                    }
                }
                ctx.bezierCurveTo(cpx0, cpy0, cpx1, cpy1, x, y);
                cpx0 = nextCpx0;
                cpy0 = nextCpy0;
            } else ctx.lineTo(x, y);
        }
        prevX = x;
        prevY = y;
        idx += dir;
    }
    return k;
}
var $5c417e1ed90142c5$var$ECPolylineShape = /** @class */ function() {
    function ECPolylineShape() {
        this.smooth = 0;
        this.smoothConstraint = true;
    }
    return ECPolylineShape;
}();
var $5c417e1ed90142c5$export$bf7c0585b8f7d00f = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ECPolyline, _super);
    function ECPolyline(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'ec-polyline';
        return _this;
    }
    ECPolyline.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    ECPolyline.prototype.getDefaultShape = function() {
        return new $5c417e1ed90142c5$var$ECPolylineShape();
    };
    ECPolyline.prototype.buildPath = function(ctx, shape) {
        var points = shape.points;
        var i = 0;
        var len = points.length / 2;
        // const result = getBoundingBox(points, shape.smoothConstraint);
        if (shape.connectNulls) {
            // Must remove first and last null values avoid draw error in polygon
            for(; len > 0; len--){
                if (!$5c417e1ed90142c5$var$isPointNull(points[len * 2 - 2], points[len * 2 - 1])) break;
            }
            for(; i < len; i++){
                if (!$5c417e1ed90142c5$var$isPointNull(points[i * 2], points[i * 2 + 1])) break;
            }
        }
        while(i < len)i += $5c417e1ed90142c5$var$drawSegment(ctx, points, i, len, len, 1, shape.smooth, shape.smoothMonotone, shape.connectNulls) + 1;
    };
    ECPolyline.prototype.getPointOn = function(xOrY, dim) {
        if (!this.path) {
            this.createPathProxy();
            this.buildPath(this.path, this.shape);
        }
        var path = this.path;
        var data = path.data;
        var CMD = (0, $20ebe2448f123f2e$export$2e2bcd8739ae039).CMD;
        var x0;
        var y0;
        var isDimX = dim === 'x';
        var roots = [];
        for(var i = 0; i < data.length;){
            var cmd = data[i++];
            var x = void 0;
            var y = void 0;
            var x2 = void 0;
            var y2 = void 0;
            var x3 = void 0;
            var y3 = void 0;
            var t = void 0;
            switch(cmd){
                case CMD.M:
                    x0 = data[i++];
                    y0 = data[i++];
                    break;
                case CMD.L:
                    x = data[i++];
                    y = data[i++];
                    t = isDimX ? (xOrY - x0) / (x - x0) : (xOrY - y0) / (y - y0);
                    if (t <= 1 && t >= 0) {
                        var val = isDimX ? (y - y0) * t + y0 : (x - x0) * t + x0;
                        return isDimX ? [
                            xOrY,
                            val
                        ] : [
                            val,
                            xOrY
                        ];
                    }
                    x0 = x;
                    y0 = y;
                    break;
                case CMD.C:
                    x = data[i++];
                    y = data[i++];
                    x2 = data[i++];
                    y2 = data[i++];
                    x3 = data[i++];
                    y3 = data[i++];
                    var nRoot = isDimX ? (0, $747cfc5611b57cea$export$ca5d13faa10b167e)(x0, x, x2, x3, xOrY, roots) : (0, $747cfc5611b57cea$export$ca5d13faa10b167e)(y0, y, y2, y3, xOrY, roots);
                    if (nRoot > 0) for(var i_1 = 0; i_1 < nRoot; i_1++){
                        var t_1 = roots[i_1];
                        if (t_1 <= 1 && t_1 >= 0) {
                            var val = isDimX ? (0, $747cfc5611b57cea$export$547c21de482bbcb2)(y0, y, y2, y3, t_1) : (0, $747cfc5611b57cea$export$547c21de482bbcb2)(x0, x, x2, x3, t_1);
                            return isDimX ? [
                                xOrY,
                                val
                            ] : [
                                val,
                                xOrY
                            ];
                        }
                    }
                    x0 = x3;
                    y0 = y3;
                    break;
            }
        }
    };
    return ECPolyline;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
var $5c417e1ed90142c5$var$ECPolygonShape = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ECPolygonShape, _super);
    function ECPolygonShape() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ECPolygonShape;
}($5c417e1ed90142c5$var$ECPolylineShape);
var $5c417e1ed90142c5$export$6042a400d113f2bd = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ECPolygon, _super);
    function ECPolygon(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'ec-polygon';
        return _this;
    }
    ECPolygon.prototype.getDefaultShape = function() {
        return new $5c417e1ed90142c5$var$ECPolygonShape();
    };
    ECPolygon.prototype.buildPath = function(ctx, shape) {
        var points = shape.points;
        var stackedOnPoints = shape.stackedOnPoints;
        var i = 0;
        var len = points.length / 2;
        var smoothMonotone = shape.smoothMonotone;
        if (shape.connectNulls) {
            // Must remove first and last null values avoid draw error in polygon
            for(; len > 0; len--){
                if (!$5c417e1ed90142c5$var$isPointNull(points[len * 2 - 2], points[len * 2 - 1])) break;
            }
            for(; i < len; i++){
                if (!$5c417e1ed90142c5$var$isPointNull(points[i * 2], points[i * 2 + 1])) break;
            }
        }
        while(i < len){
            var k = $5c417e1ed90142c5$var$drawSegment(ctx, points, i, len, len, 1, shape.smooth, smoothMonotone, shape.connectNulls);
            $5c417e1ed90142c5$var$drawSegment(ctx, stackedOnPoints, i + k - 1, k, len, -1, shape.stackedOnSmooth, smoothMonotone, shape.connectNulls);
            i += k + 1;
            ctx.closePath();
        }
    };
    return ECPolygon;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));













function $ada57dad04d4bbf5$var$isPointsSame(points1, points2) {
    if (points1.length !== points2.length) return;
    for(var i = 0; i < points1.length; i++){
        if (points1[i] !== points2[i]) return;
    }
    return true;
}
function $ada57dad04d4bbf5$var$bboxFromPoints(points) {
    var minX = Infinity;
    var minY = Infinity;
    var maxX = -Infinity;
    var maxY = -Infinity;
    for(var i = 0; i < points.length;){
        var x = points[i++];
        var y = points[i++];
        if (!isNaN(x)) {
            minX = Math.min(x, minX);
            maxX = Math.max(x, maxX);
        }
        if (!isNaN(y)) {
            minY = Math.min(y, minY);
            maxY = Math.max(y, maxY);
        }
    }
    return [
        [
            minX,
            minY
        ],
        [
            maxX,
            maxY
        ]
    ];
}
function $ada57dad04d4bbf5$var$getBoundingDiff(points1, points2) {
    var _a = $ada57dad04d4bbf5$var$bboxFromPoints(points1), min1 = _a[0], max1 = _a[1];
    var _b = $ada57dad04d4bbf5$var$bboxFromPoints(points2), min2 = _b[0], max2 = _b[1];
    // Get a max value from each corner of two boundings.
    return Math.max(Math.abs(min1[0] - min2[0]), Math.abs(min1[1] - min2[1]), Math.abs(max1[0] - max2[0]), Math.abs(max1[1] - max2[1]));
}
function $ada57dad04d4bbf5$var$getSmooth(smooth) {
    return $7a1bd9c2710fea0d$export$7e4aa119212bc614(smooth) ? smooth : smooth ? 0.5 : 0;
}
function $ada57dad04d4bbf5$var$getStackedOnPoints(coordSys, data, dataCoordInfo) {
    if (!dataCoordInfo.valueDim) return [];
    var len = data.count();
    var points = (0, $5cd50afac93e9148$export$21d2298f3f56bbaf)(len * 2);
    for(var idx = 0; idx < len; idx++){
        var pt = (0, $af63fd8cd32fb271$export$c1601aa630e7b5f8)(dataCoordInfo, coordSys, data, idx);
        points[idx * 2] = pt[0];
        points[idx * 2 + 1] = pt[1];
    }
    return points;
}
/**
 * Filter the null data and extend data for step considering `stepTurnAt`
 *
 * @param points data to convert, that may containing null
 * @param basePoints base data to reference, used only for areaStyle points
 * @param coordSys coordinate system
 * @param stepTurnAt 'start' | 'end' | 'middle' | true
 * @param connectNulls whether to connect nulls
 * @returns converted point positions
 */ function $ada57dad04d4bbf5$var$turnPointsIntoStep(points, basePoints, coordSys, stepTurnAt, connectNulls) {
    var baseAxis = coordSys.getBaseAxis();
    var baseIndex = baseAxis.dim === 'x' || baseAxis.dim === 'radius' ? 0 : 1;
    var stepPoints = [];
    var i = 0;
    var stepPt = [];
    var pt = [];
    var nextPt = [];
    var filteredPoints = [];
    if (connectNulls) {
        for(i = 0; i < points.length; i += 2){
            /**
       * For areaStyle of stepped lines, `stackedOnPoints` should be
       * filtered the same as `points` so that the base axis values
       * should stay the same as the lines above. See #20021
       */ var reference = basePoints || points;
            if (!isNaN(reference[i]) && !isNaN(reference[i + 1])) filteredPoints.push(points[i], points[i + 1]);
        }
        points = filteredPoints;
    }
    for(i = 0; i < points.length - 2; i += 2){
        nextPt[0] = points[i + 2];
        nextPt[1] = points[i + 3];
        pt[0] = points[i];
        pt[1] = points[i + 1];
        stepPoints.push(pt[0], pt[1]);
        switch(stepTurnAt){
            case 'end':
                stepPt[baseIndex] = nextPt[baseIndex];
                stepPt[1 - baseIndex] = pt[1 - baseIndex];
                stepPoints.push(stepPt[0], stepPt[1]);
                break;
            case 'middle':
                var middle = (pt[baseIndex] + nextPt[baseIndex]) / 2;
                var stepPt2 = [];
                stepPt[baseIndex] = stepPt2[baseIndex] = middle;
                stepPt[1 - baseIndex] = pt[1 - baseIndex];
                stepPt2[1 - baseIndex] = nextPt[1 - baseIndex];
                stepPoints.push(stepPt[0], stepPt[1]);
                stepPoints.push(stepPt2[0], stepPt2[1]);
                break;
            default:
                // default is start
                stepPt[baseIndex] = pt[baseIndex];
                stepPt[1 - baseIndex] = nextPt[1 - baseIndex];
                stepPoints.push(stepPt[0], stepPt[1]);
        }
    }
    // Last points
    stepPoints.push(points[i++], points[i++]);
    return stepPoints;
}
/**
 * Clip color stops to edge. Avoid creating too large gradients.
 * Which may lead to blurry when GPU acceleration is enabled. See #15680
 *
 * The stops has been sorted from small to large.
 */ function $ada57dad04d4bbf5$var$clipColorStops(colorStops, maxSize) {
    var newColorStops = [];
    var len = colorStops.length;
    // coord will always < 0 in prevOutOfRangeColorStop.
    var prevOutOfRangeColorStop;
    var prevInRangeColorStop;
    function lerpStop(stop0, stop1, clippedCoord) {
        var coord0 = stop0.coord;
        var p = (clippedCoord - coord0) / (stop1.coord - coord0);
        var color = (0, $2c037f5bda6341ca$export$3a89f8d6f6bf6c9f)(p, [
            stop0.color,
            stop1.color
        ]);
        return {
            coord: clippedCoord,
            color: color
        };
    }
    for(var i = 0; i < len; i++){
        var stop_1 = colorStops[i];
        var coord = stop_1.coord;
        if (coord < 0) prevOutOfRangeColorStop = stop_1;
        else if (coord > maxSize) {
            if (prevInRangeColorStop) newColorStops.push(lerpStop(prevInRangeColorStop, stop_1, maxSize));
            else if (prevOutOfRangeColorStop) // If there are two stops and coord range is between these two stops
            newColorStops.push(lerpStop(prevOutOfRangeColorStop, stop_1, 0), lerpStop(prevOutOfRangeColorStop, stop_1, maxSize));
            break;
        } else {
            if (prevOutOfRangeColorStop) {
                newColorStops.push(lerpStop(prevOutOfRangeColorStop, stop_1, 0));
                // Reset
                prevOutOfRangeColorStop = null;
            }
            newColorStops.push(stop_1);
            prevInRangeColorStop = stop_1;
        }
    }
    return newColorStops;
}
function $ada57dad04d4bbf5$var$getVisualGradient(data, coordSys, api) {
    var visualMetaList = data.getVisual('visualMeta');
    if (!visualMetaList || !visualMetaList.length || !data.count()) // When data.count() is 0, gradient range can not be calculated.
    return;
    if (coordSys.type !== 'cartesian2d') return;
    var coordDim;
    var visualMeta;
    for(var i = visualMetaList.length - 1; i >= 0; i--){
        var dimInfo = data.getDimensionInfo(visualMetaList[i].dimension);
        coordDim = dimInfo && dimInfo.coordDim;
        // Can only be x or y
        if (coordDim === 'x' || coordDim === 'y') {
            visualMeta = visualMetaList[i];
            break;
        }
    }
    if (!visualMeta) return;
    // If the area to be rendered is bigger than area defined by LinearGradient,
    // the canvas spec prescribes that the color of the first stop and the last
    // stop should be used. But if two stops are added at offset 0, in effect
    // browsers use the color of the second stop to render area outside
    // LinearGradient. So we can only infinitesimally extend area defined in
    // LinearGradient to render `outerColors`.
    var axis = coordSys.getAxis(coordDim);
    // dataToCoord mapping may not be linear, but must be monotonic.
    var colorStops = $7a1bd9c2710fea0d$export$871de8747c9eaa88(visualMeta.stops, function(stop) {
        // offset will be calculated later.
        return {
            coord: axis.toGlobalCoord(axis.dataToCoord(stop.value)),
            color: stop.color
        };
    });
    var stopLen = colorStops.length;
    var outerColors = visualMeta.outerColors.slice();
    if (stopLen && colorStops[0].coord > colorStops[stopLen - 1].coord) {
        colorStops.reverse();
        outerColors.reverse();
    }
    var colorStopsInRange = $ada57dad04d4bbf5$var$clipColorStops(colorStops, coordDim === 'x' ? api.getWidth() : api.getHeight());
    var inRangeStopLen = colorStopsInRange.length;
    if (!inRangeStopLen && stopLen) // All stops are out of range. All will be the same color.
    return colorStops[0].coord < 0 ? outerColors[1] ? outerColors[1] : colorStops[stopLen - 1].color : outerColors[0] ? outerColors[0] : colorStops[0].color;
    var tinyExtent = 10; // Arbitrary value: 10px
    var minCoord = colorStopsInRange[0].coord - tinyExtent;
    var maxCoord = colorStopsInRange[inRangeStopLen - 1].coord + tinyExtent;
    var coordSpan = maxCoord - minCoord;
    if (coordSpan < 1e-3) return 'transparent';
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(colorStopsInRange, function(stop) {
        stop.offset = (stop.coord - minCoord) / coordSpan;
    });
    colorStopsInRange.push({
        // NOTE: inRangeStopLen may still be 0 if stoplen is zero.
        offset: inRangeStopLen ? colorStopsInRange[inRangeStopLen - 1].offset : 0.5,
        color: outerColors[1] || 'transparent'
    });
    colorStopsInRange.unshift({
        offset: inRangeStopLen ? colorStopsInRange[0].offset : 0.5,
        color: outerColors[0] || 'transparent'
    });
    var gradient = new $cf44c01491b58e53$export$2e2bcd8739ae039(0, 0, 0, 0, colorStopsInRange, true);
    gradient[coordDim] = minCoord;
    gradient[coordDim + '2'] = maxCoord;
    return gradient;
}
function $ada57dad04d4bbf5$var$getIsIgnoreFunc(seriesModel, data, coordSys) {
    var showAllSymbol = seriesModel.get('showAllSymbol');
    var isAuto = showAllSymbol === 'auto';
    if (showAllSymbol && !isAuto) return;
    var categoryAxis = coordSys.getAxesByScale('ordinal')[0];
    if (!categoryAxis) return;
    // Note that category label interval strategy might bring some weird effect
    // in some scenario: users may wonder why some of the symbols are not
    // displayed. So we show all symbols as possible as we can.
    if (isAuto && $ada57dad04d4bbf5$var$canShowAllSymbolForCategory(categoryAxis, data)) return;
    // Otherwise follow the label interval strategy on category axis.
    var categoryDataDim = data.mapDimension(categoryAxis.dim);
    var labelMap = {};
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(categoryAxis.getViewLabels(), function(labelItem) {
        var ordinalNumber = categoryAxis.scale.getRawOrdinalNumber(labelItem.tickValue);
        labelMap[ordinalNumber] = 1;
    });
    return function(dataIndex) {
        return !labelMap.hasOwnProperty(data.get(categoryDataDim, dataIndex));
    };
}
function $ada57dad04d4bbf5$var$canShowAllSymbolForCategory(categoryAxis, data) {
    // In most cases, line is monotonous on category axis, and the label size
    // is close with each other. So we check the symbol size and some of the
    // label size alone with the category axis to estimate whether all symbol
    // can be shown without overlap.
    var axisExtent = categoryAxis.getExtent();
    var availSize = Math.abs(axisExtent[1] - axisExtent[0]) / categoryAxis.scale.count();
    isNaN(availSize) && (availSize = 0); // 0/0 is NaN.
    // Sampling some points, max 5.
    var dataLen = data.count();
    var step = Math.max(1, Math.round(dataLen / 5));
    for(var dataIndex = 0; dataIndex < dataLen; dataIndex += step){
        if ((0, $b1d9c3e17ccace80$export$2e2bcd8739ae039).getSymbolSize(data, dataIndex)[categoryAxis.isHorizontal() ? 1 : 0] * 1.5 > availSize) return false;
    }
    return true;
}
function $ada57dad04d4bbf5$var$isPointNull(x, y) {
    return isNaN(x) || isNaN(y);
}
function $ada57dad04d4bbf5$var$getLastIndexNotNull(points) {
    var len = points.length / 2;
    for(; len > 0; len--){
        if (!$ada57dad04d4bbf5$var$isPointNull(points[len * 2 - 2], points[len * 2 - 1])) break;
    }
    return len - 1;
}
function $ada57dad04d4bbf5$var$getPointAtIndex(points, idx) {
    return [
        points[idx * 2],
        points[idx * 2 + 1]
    ];
}
function $ada57dad04d4bbf5$var$getIndexRange(points, xOrY, dim) {
    var len = points.length / 2;
    var dimIdx = dim === 'x' ? 0 : 1;
    var a;
    var b;
    var prevIndex = 0;
    var nextIndex = -1;
    for(var i = 0; i < len; i++){
        b = points[i * 2 + dimIdx];
        if (isNaN(b) || isNaN(points[i * 2 + 1 - dimIdx])) continue;
        if (i === 0) {
            a = b;
            continue;
        }
        if (a <= xOrY && b >= xOrY || a >= xOrY && b <= xOrY) {
            nextIndex = i;
            break;
        }
        prevIndex = i;
        a = b;
    }
    return {
        range: [
            prevIndex,
            nextIndex
        ],
        t: (xOrY - a) / (b - a)
    };
}
function $ada57dad04d4bbf5$var$anyStateShowEndLabel(seriesModel) {
    if (seriesModel.get([
        'endLabel',
        'show'
    ])) return true;
    for(var i = 0; i < (0, $2bf82c0980125b62$export$151308dceb52d5b).length; i++){
        if (seriesModel.get([
            (0, $2bf82c0980125b62$export$151308dceb52d5b)[i],
            'endLabel',
            'show'
        ])) return true;
    }
    return false;
}
function $ada57dad04d4bbf5$var$createLineClipPath(lineView, coordSys, hasAnimation, seriesModel) {
    if ((0, $3fea949f0512eb55$export$8567506e6336616)(coordSys, 'cartesian2d')) {
        var endLabelModel_1 = seriesModel.getModel('endLabel');
        var valueAnimation_1 = endLabelModel_1.get('valueAnimation');
        var data_1 = seriesModel.getData();
        var labelAnimationRecord_1 = {
            lastFrameIndex: 0
        };
        var during = $ada57dad04d4bbf5$var$anyStateShowEndLabel(seriesModel) ? function(percent, clipRect) {
            lineView._endLabelOnDuring(percent, clipRect, data_1, labelAnimationRecord_1, valueAnimation_1, endLabelModel_1, coordSys);
        } : null;
        var isHorizontal = coordSys.getBaseAxis().isHorizontal();
        var clipPath = (0, $0e2cc04b3aaad400$export$83958787eb658d14)(coordSys, hasAnimation, seriesModel, function() {
            var endLabel = lineView._endLabel;
            if (endLabel && hasAnimation) {
                if (labelAnimationRecord_1.originalX != null) endLabel.attr({
                    x: labelAnimationRecord_1.originalX,
                    y: labelAnimationRecord_1.originalY
                });
            }
        }, during);
        // Expand clip shape to avoid clipping when line value exceeds axis
        if (!seriesModel.get('clip', true)) {
            var rectShape = clipPath.shape;
            var expandSize = Math.max(rectShape.width, rectShape.height);
            if (isHorizontal) {
                rectShape.y -= expandSize;
                rectShape.height += expandSize * 2;
            } else {
                rectShape.x -= expandSize;
                rectShape.width += expandSize * 2;
            }
        }
        // Set to the final frame. To make sure label layout is right.
        if (during) during(1, clipPath);
        return clipPath;
    } else return (0, $0e2cc04b3aaad400$export$13dc2b2230df3cb5)(coordSys, hasAnimation, seriesModel);
}
function $ada57dad04d4bbf5$var$getEndLabelStateSpecified(endLabelModel, coordSys) {
    var baseAxis = coordSys.getBaseAxis();
    var isHorizontal = baseAxis.isHorizontal();
    var isBaseInversed = baseAxis.inverse;
    var align = isHorizontal ? isBaseInversed ? 'right' : 'left' : 'center';
    var verticalAlign = isHorizontal ? 'middle' : isBaseInversed ? 'top' : 'bottom';
    return {
        normal: {
            align: endLabelModel.get('align') || align,
            verticalAlign: endLabelModel.get('verticalAlign') || verticalAlign
        }
    };
}
var $ada57dad04d4bbf5$var$LineView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(LineView, _super);
    function LineView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LineView.prototype.init = function() {
        var lineGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        var symbolDraw = new (0, $fedf62268297fcbb$export$2e2bcd8739ae039)();
        this.group.add(symbolDraw.group);
        this._symbolDraw = symbolDraw;
        this._lineGroup = lineGroup;
        this._changePolyState = $7a1bd9c2710fea0d$export$2385a24977818dd0(this._changePolyState, this);
    };
    LineView.prototype.render = function(seriesModel, ecModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        var group = this.group;
        var data = seriesModel.getData();
        var lineStyleModel = seriesModel.getModel('lineStyle');
        var areaStyleModel = seriesModel.getModel('areaStyle');
        var points = data.getLayout('points') || [];
        var isCoordSysPolar = coordSys.type === 'polar';
        var prevCoordSys = this._coordSys;
        var symbolDraw = this._symbolDraw;
        var polyline = this._polyline;
        var polygon = this._polygon;
        var lineGroup = this._lineGroup;
        var hasAnimation = !ecModel.ssr && seriesModel.get('animation');
        var isAreaChart = !areaStyleModel.isEmpty();
        var valueOrigin = areaStyleModel.get('origin');
        var dataCoordInfo = (0, $af63fd8cd32fb271$export$b488a529581b37e)(coordSys, data, valueOrigin);
        var stackedOnPoints = isAreaChart && $ada57dad04d4bbf5$var$getStackedOnPoints(coordSys, data, dataCoordInfo);
        var showSymbol = seriesModel.get('showSymbol');
        var connectNulls = seriesModel.get('connectNulls');
        var isIgnoreFunc = showSymbol && !isCoordSysPolar && $ada57dad04d4bbf5$var$getIsIgnoreFunc(seriesModel, data, coordSys);
        // Remove temporary symbols
        var oldData = this._data;
        oldData && oldData.eachItemGraphicEl(function(el, idx) {
            if (el.__temp) {
                group.remove(el);
                oldData.setItemGraphicEl(idx, null);
            }
        });
        // Remove previous created symbols if showSymbol changed to false
        if (!showSymbol) symbolDraw.remove();
        group.add(lineGroup);
        // FIXME step not support polar
        var step = !isCoordSysPolar ? seriesModel.get('step') : false;
        var clipShapeForSymbol;
        if (coordSys && coordSys.getArea && seriesModel.get('clip', true)) {
            clipShapeForSymbol = coordSys.getArea();
            // Avoid float number rounding error for symbol on the edge of axis extent.
            // See #7913 and `test/dataZoom-clip.html`.
            if (clipShapeForSymbol.width != null) {
                clipShapeForSymbol.x -= 0.1;
                clipShapeForSymbol.y -= 0.1;
                clipShapeForSymbol.width += 0.2;
                clipShapeForSymbol.height += 0.2;
            } else if (clipShapeForSymbol.r0) {
                clipShapeForSymbol.r0 -= 0.5;
                clipShapeForSymbol.r += 0.5;
            }
        }
        this._clipShapeForSymbol = clipShapeForSymbol;
        var visualColor = $ada57dad04d4bbf5$var$getVisualGradient(data, coordSys, api) || data.getVisual('style')[data.getVisual('drawType')];
        // Initialization animation or coordinate system changed
        if (!(polyline && prevCoordSys.type === coordSys.type && step === this._step)) {
            showSymbol && symbolDraw.updateData(data, {
                isIgnore: isIgnoreFunc,
                clipShape: clipShapeForSymbol,
                disableAnimation: true,
                getSymbolPoint: function(idx) {
                    return [
                        points[idx * 2],
                        points[idx * 2 + 1]
                    ];
                }
            });
            hasAnimation && this._initSymbolLabelAnimation(data, coordSys, clipShapeForSymbol);
            if (step) {
                if (stackedOnPoints) stackedOnPoints = $ada57dad04d4bbf5$var$turnPointsIntoStep(stackedOnPoints, points, coordSys, step, connectNulls);
                // TODO If stacked series is not step
                points = $ada57dad04d4bbf5$var$turnPointsIntoStep(points, null, coordSys, step, connectNulls);
            }
            polyline = this._newPolyline(points);
            if (isAreaChart) polygon = this._newPolygon(points, stackedOnPoints);
            else if (polygon) {
                lineGroup.remove(polygon);
                polygon = this._polygon = null;
            }
            // NOTE: Must update _endLabel before setClipPath.
            if (!isCoordSysPolar) this._initOrUpdateEndLabel(seriesModel, coordSys, (0, $c84c9521536c601a$export$cda04d03233e5555)(visualColor));
            lineGroup.setClipPath($ada57dad04d4bbf5$var$createLineClipPath(this, coordSys, true, seriesModel));
        } else {
            if (isAreaChart && !polygon) // If areaStyle is added
            polygon = this._newPolygon(points, stackedOnPoints);
            else if (polygon && !isAreaChart) {
                // If areaStyle is removed
                lineGroup.remove(polygon);
                polygon = this._polygon = null;
            }
            // NOTE: Must update _endLabel before setClipPath.
            if (!isCoordSysPolar) this._initOrUpdateEndLabel(seriesModel, coordSys, (0, $c84c9521536c601a$export$cda04d03233e5555)(visualColor));
            // Update clipPath
            var oldClipPath = lineGroup.getClipPath();
            if (oldClipPath) {
                var newClipPath = $ada57dad04d4bbf5$var$createLineClipPath(this, coordSys, false, seriesModel);
                $8b353638fbedfefa$export$a121566aadcfe021(oldClipPath, {
                    shape: newClipPath.shape
                }, seriesModel);
            } else lineGroup.setClipPath($ada57dad04d4bbf5$var$createLineClipPath(this, coordSys, true, seriesModel));
            // Always update, or it is wrong in the case turning on legend
            // because points are not changed.
            showSymbol && symbolDraw.updateData(data, {
                isIgnore: isIgnoreFunc,
                clipShape: clipShapeForSymbol,
                disableAnimation: true,
                getSymbolPoint: function(idx) {
                    return [
                        points[idx * 2],
                        points[idx * 2 + 1]
                    ];
                }
            });
            // In the case data zoom triggered refreshing frequently
            // Data may not change if line has a category axis. So it should animate nothing.
            if (!$ada57dad04d4bbf5$var$isPointsSame(this._stackedOnPoints, stackedOnPoints) || !$ada57dad04d4bbf5$var$isPointsSame(this._points, points)) {
                if (hasAnimation) this._doUpdateAnimation(data, stackedOnPoints, coordSys, api, step, valueOrigin, connectNulls);
                else {
                    // Not do it in update with animation
                    if (step) {
                        if (stackedOnPoints) stackedOnPoints = $ada57dad04d4bbf5$var$turnPointsIntoStep(stackedOnPoints, points, coordSys, step, connectNulls);
                        // TODO If stacked series is not step
                        points = $ada57dad04d4bbf5$var$turnPointsIntoStep(points, null, coordSys, step, connectNulls);
                    }
                    polyline.setShape({
                        points: points
                    });
                    polygon && polygon.setShape({
                        points: points,
                        stackedOnPoints: stackedOnPoints
                    });
                }
            }
        }
        var emphasisModel = seriesModel.getModel('emphasis');
        var focus = emphasisModel.get('focus');
        var blurScope = emphasisModel.get('blurScope');
        var emphasisDisabled = emphasisModel.get('disabled');
        polyline.useStyle($7a1bd9c2710fea0d$export$ebe90cb607ad99e(// Use color in lineStyle first
        lineStyleModel.getLineStyle(), {
            fill: 'none',
            stroke: visualColor,
            lineJoin: 'bevel'
        }));
        (0, $2bf82c0980125b62$export$48b68047d330bbc9)(polyline, seriesModel, 'lineStyle');
        if (polyline.style.lineWidth > 0 && seriesModel.get([
            'emphasis',
            'lineStyle',
            'width'
        ]) === 'bolder') {
            var emphasisLineStyle = polyline.getState('emphasis').style;
            emphasisLineStyle.lineWidth = +polyline.style.lineWidth + 1;
        }
        // Needs seriesIndex for focus
        (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(polyline).seriesIndex = seriesModel.seriesIndex;
        (0, $2bf82c0980125b62$export$e51187539ff11209)(polyline, focus, blurScope, emphasisDisabled);
        var smooth = $ada57dad04d4bbf5$var$getSmooth(seriesModel.get('smooth'));
        var smoothMonotone = seriesModel.get('smoothMonotone');
        polyline.setShape({
            smooth: smooth,
            smoothMonotone: smoothMonotone,
            connectNulls: connectNulls
        });
        if (polygon) {
            var stackedOnSeries = data.getCalculationInfo('stackedOnSeries');
            var stackedOnSmooth = 0;
            polygon.useStyle($7a1bd9c2710fea0d$export$ebe90cb607ad99e(areaStyleModel.getAreaStyle(), {
                fill: visualColor,
                opacity: 0.7,
                lineJoin: 'bevel',
                decal: data.getVisual('style').decal
            }));
            if (stackedOnSeries) stackedOnSmooth = $ada57dad04d4bbf5$var$getSmooth(stackedOnSeries.get('smooth'));
            polygon.setShape({
                smooth: smooth,
                stackedOnSmooth: stackedOnSmooth,
                smoothMonotone: smoothMonotone,
                connectNulls: connectNulls
            });
            (0, $2bf82c0980125b62$export$48b68047d330bbc9)(polygon, seriesModel, 'areaStyle');
            // Needs seriesIndex for focus
            (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(polygon).seriesIndex = seriesModel.seriesIndex;
            (0, $2bf82c0980125b62$export$e51187539ff11209)(polygon, focus, blurScope, emphasisDisabled);
        }
        var changePolyState = this._changePolyState;
        data.eachItemGraphicEl(function(el) {
            // Switch polyline / polygon state if element changed its state.
            el && (el.onHoverStateChange = changePolyState);
        });
        this._polyline.onHoverStateChange = changePolyState;
        this._data = data;
        // Save the coordinate system for transition animation when data changed
        this._coordSys = coordSys;
        this._stackedOnPoints = stackedOnPoints;
        this._points = points;
        this._step = step;
        this._valueOrigin = valueOrigin;
        if (seriesModel.get('triggerLineEvent')) {
            this.packEventData(seriesModel, polyline);
            polygon && this.packEventData(seriesModel, polygon);
        }
    };
    LineView.prototype.packEventData = function(seriesModel, el) {
        (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).eventData = {
            componentType: 'series',
            componentSubType: 'line',
            componentIndex: seriesModel.componentIndex,
            seriesIndex: seriesModel.seriesIndex,
            seriesName: seriesModel.name,
            seriesType: 'line'
        };
    };
    LineView.prototype.highlight = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData();
        var dataIndex = $76d619f648247e6d$export$42b26cae8b8d10(data, payload);
        this._changePolyState('emphasis');
        if (!(dataIndex instanceof Array) && dataIndex != null && dataIndex >= 0) {
            var points = data.getLayout('points');
            var symbol = data.getItemGraphicEl(dataIndex);
            if (!symbol) {
                // Create a temporary symbol if it is not exists
                var x = points[dataIndex * 2];
                var y = points[dataIndex * 2 + 1];
                if (isNaN(x) || isNaN(y)) // Null data
                return;
                // fix #11360: shouldn't draw symbol outside clipShapeForSymbol
                if (this._clipShapeForSymbol && !this._clipShapeForSymbol.contain(x, y)) return;
                var zlevel = seriesModel.get('zlevel') || 0;
                var z = seriesModel.get('z') || 0;
                symbol = new (0, $b1d9c3e17ccace80$export$2e2bcd8739ae039)(data, dataIndex);
                symbol.x = x;
                symbol.y = y;
                symbol.setZ(zlevel, z);
                // ensure label text of the temporary symbol is in front of line and area polygon
                var symbolLabel = symbol.getSymbolPath().getTextContent();
                if (symbolLabel) {
                    symbolLabel.zlevel = zlevel;
                    symbolLabel.z = z;
                    symbolLabel.z2 = this._polyline.z2 + 1;
                }
                symbol.__temp = true;
                data.setItemGraphicEl(dataIndex, symbol);
                // Stop scale animation
                symbol.stopSymbolAnimation(true);
                this.group.add(symbol);
            }
            symbol.highlight();
        } else // Highlight whole series
        (0, $0dc5061053e23cd3$export$2e2bcd8739ae039).prototype.highlight.call(this, seriesModel, ecModel, api, payload);
    };
    LineView.prototype.downplay = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData();
        var dataIndex = $76d619f648247e6d$export$42b26cae8b8d10(data, payload);
        this._changePolyState('normal');
        if (dataIndex != null && dataIndex >= 0) {
            var symbol = data.getItemGraphicEl(dataIndex);
            if (symbol) {
                if (symbol.__temp) {
                    data.setItemGraphicEl(dataIndex, null);
                    this.group.remove(symbol);
                } else symbol.downplay();
            }
        } else // FIXME
        // can not downplay completely.
        // Downplay whole series
        (0, $0dc5061053e23cd3$export$2e2bcd8739ae039).prototype.downplay.call(this, seriesModel, ecModel, api, payload);
    };
    LineView.prototype._changePolyState = function(toState) {
        var polygon = this._polygon;
        (0, $2bf82c0980125b62$export$868ba38adffa9e39)(this._polyline, toState);
        polygon && (0, $2bf82c0980125b62$export$868ba38adffa9e39)(polygon, toState);
    };
    LineView.prototype._newPolyline = function(points) {
        var polyline = this._polyline;
        // Remove previous created polyline
        if (polyline) this._lineGroup.remove(polyline);
        polyline = new (0, $5c417e1ed90142c5$export$bf7c0585b8f7d00f)({
            shape: {
                points: points
            },
            segmentIgnoreThreshold: 2,
            z2: 10
        });
        this._lineGroup.add(polyline);
        this._polyline = polyline;
        return polyline;
    };
    LineView.prototype._newPolygon = function(points, stackedOnPoints) {
        var polygon = this._polygon;
        // Remove previous created polygon
        if (polygon) this._lineGroup.remove(polygon);
        polygon = new (0, $5c417e1ed90142c5$export$6042a400d113f2bd)({
            shape: {
                points: points,
                stackedOnPoints: stackedOnPoints
            },
            segmentIgnoreThreshold: 2
        });
        this._lineGroup.add(polygon);
        this._polygon = polygon;
        return polygon;
    };
    LineView.prototype._initSymbolLabelAnimation = function(data, coordSys, clipShape) {
        var isHorizontalOrRadial;
        var isCoordSysPolar;
        var baseAxis = coordSys.getBaseAxis();
        var isAxisInverse = baseAxis.inverse;
        if (coordSys.type === 'cartesian2d') {
            isHorizontalOrRadial = baseAxis.isHorizontal();
            isCoordSysPolar = false;
        } else if (coordSys.type === 'polar') {
            isHorizontalOrRadial = baseAxis.dim === 'angle';
            isCoordSysPolar = true;
        }
        var seriesModel = data.hostModel;
        var seriesDuration = seriesModel.get('animationDuration');
        if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(seriesDuration)) seriesDuration = seriesDuration(null);
        var seriesDelay = seriesModel.get('animationDelay') || 0;
        var seriesDelayValue = $7a1bd9c2710fea0d$export$f6e2535fb5126e54(seriesDelay) ? seriesDelay(null) : seriesDelay;
        data.eachItemGraphicEl(function(symbol, idx) {
            var el = symbol;
            if (el) {
                var point = [
                    symbol.x,
                    symbol.y
                ];
                var start = void 0;
                var end = void 0;
                var current = void 0;
                if (clipShape) {
                    if (isCoordSysPolar) {
                        var polarClip = clipShape;
                        var coord = coordSys.pointToCoord(point);
                        if (isHorizontalOrRadial) {
                            start = polarClip.startAngle;
                            end = polarClip.endAngle;
                            current = -coord[1] / 180 * Math.PI;
                        } else {
                            start = polarClip.r0;
                            end = polarClip.r;
                            current = coord[0];
                        }
                    } else {
                        var gridClip = clipShape;
                        if (isHorizontalOrRadial) {
                            start = gridClip.x;
                            end = gridClip.x + gridClip.width;
                            current = symbol.x;
                        } else {
                            start = gridClip.y + gridClip.height;
                            end = gridClip.y;
                            current = symbol.y;
                        }
                    }
                }
                var ratio = end === start ? 0 : (current - start) / (end - start);
                if (isAxisInverse) ratio = 1 - ratio;
                var delay = $7a1bd9c2710fea0d$export$f6e2535fb5126e54(seriesDelay) ? seriesDelay(idx) : seriesDuration * ratio + seriesDelayValue;
                var symbolPath = el.getSymbolPath();
                var text = symbolPath.getTextContent();
                el.attr({
                    scaleX: 0,
                    scaleY: 0
                });
                el.animateTo({
                    scaleX: 1,
                    scaleY: 1
                }, {
                    duration: 200,
                    setToFinal: true,
                    delay: delay
                });
                if (text) text.animateFrom({
                    style: {
                        opacity: 0
                    }
                }, {
                    duration: 300,
                    delay: delay
                });
                symbolPath.disableLabelAnimation = true;
            }
        });
    };
    LineView.prototype._initOrUpdateEndLabel = function(seriesModel, coordSys, inheritColor) {
        var endLabelModel = seriesModel.getModel('endLabel');
        if ($ada57dad04d4bbf5$var$anyStateShowEndLabel(seriesModel)) {
            var data_2 = seriesModel.getData();
            var polyline = this._polyline;
            // series may be filtered.
            var points = data_2.getLayout('points');
            if (!points) {
                polyline.removeTextContent();
                this._endLabel = null;
                return;
            }
            var endLabel = this._endLabel;
            if (!endLabel) {
                endLabel = this._endLabel = new $fe885cc21795562b$export$2e2bcd8739ae039({
                    z2: 200 // should be higher than item symbol
                });
                endLabel.ignoreClip = true;
                polyline.setTextContent(this._endLabel);
                polyline.disableLabelAnimation = true;
            }
            // Find last non-NaN data to display data
            var dataIndex = $ada57dad04d4bbf5$var$getLastIndexNotNull(points);
            if (dataIndex >= 0) {
                (0, $6800dfcb6e1e2a44$export$9a13992917966657)(polyline, (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(seriesModel, 'endLabel'), {
                    inheritColor: inheritColor,
                    labelFetcher: seriesModel,
                    labelDataIndex: dataIndex,
                    defaultText: function(dataIndex, opt, interpolatedValue) {
                        return interpolatedValue != null ? (0, $b2475f850d3c0bc2$export$5f84815e91ca6775)(data_2, interpolatedValue) : (0, $b2475f850d3c0bc2$export$5ff20667590927ed)(data_2, dataIndex);
                    },
                    enableTextSetter: true
                }, $ada57dad04d4bbf5$var$getEndLabelStateSpecified(endLabelModel, coordSys));
                polyline.textConfig.position = null;
            }
        } else if (this._endLabel) {
            this._polyline.removeTextContent();
            this._endLabel = null;
        }
    };
    LineView.prototype._endLabelOnDuring = function(percent, clipRect, data, animationRecord, valueAnimation, endLabelModel, coordSys) {
        var endLabel = this._endLabel;
        var polyline = this._polyline;
        if (endLabel) {
            // NOTE: Don't remove percent < 1. percent === 1 means the first frame during render.
            // The label is not prepared at this time.
            if (percent < 1 && animationRecord.originalX == null) {
                animationRecord.originalX = endLabel.x;
                animationRecord.originalY = endLabel.y;
            }
            var points = data.getLayout('points');
            var seriesModel = data.hostModel;
            var connectNulls = seriesModel.get('connectNulls');
            var precision = endLabelModel.get('precision');
            var distance = endLabelModel.get('distance') || 0;
            var baseAxis = coordSys.getBaseAxis();
            var isHorizontal = baseAxis.isHorizontal();
            var isBaseInversed = baseAxis.inverse;
            var clipShape = clipRect.shape;
            var xOrY = isBaseInversed ? isHorizontal ? clipShape.x : clipShape.y + clipShape.height : isHorizontal ? clipShape.x + clipShape.width : clipShape.y;
            var distanceX = (isHorizontal ? distance : 0) * (isBaseInversed ? -1 : 1);
            var distanceY = (isHorizontal ? 0 : -distance) * (isBaseInversed ? -1 : 1);
            var dim = isHorizontal ? 'x' : 'y';
            var dataIndexRange = $ada57dad04d4bbf5$var$getIndexRange(points, xOrY, dim);
            var indices = dataIndexRange.range;
            var diff = indices[1] - indices[0];
            var value = void 0;
            if (diff >= 1) {
                // diff > 1 && connectNulls, which is on the null data.
                if (diff > 1 && !connectNulls) {
                    var pt = $ada57dad04d4bbf5$var$getPointAtIndex(points, indices[0]);
                    endLabel.attr({
                        x: pt[0] + distanceX,
                        y: pt[1] + distanceY
                    });
                    valueAnimation && (value = seriesModel.getRawValue(indices[0]));
                } else {
                    var pt = polyline.getPointOn(xOrY, dim);
                    pt && endLabel.attr({
                        x: pt[0] + distanceX,
                        y: pt[1] + distanceY
                    });
                    var startValue = seriesModel.getRawValue(indices[0]);
                    var endValue = seriesModel.getRawValue(indices[1]);
                    valueAnimation && (value = $76d619f648247e6d$export$bd0439821a1869f3(data, precision, startValue, endValue, dataIndexRange.t));
                }
                animationRecord.lastFrameIndex = indices[0];
            } else {
                // If diff <= 0, which is the range is not found(Include NaN)
                // Choose the first point or last point.
                var idx = percent === 1 || animationRecord.lastFrameIndex > 0 ? indices[0] : 0;
                var pt = $ada57dad04d4bbf5$var$getPointAtIndex(points, idx);
                valueAnimation && (value = seriesModel.getRawValue(idx));
                endLabel.attr({
                    x: pt[0] + distanceX,
                    y: pt[1] + distanceY
                });
            }
            if (valueAnimation) {
                var inner = (0, $6800dfcb6e1e2a44$export$f62786d3261ab0f4)(endLabel);
                if (typeof inner.setLabelText === 'function') inner.setLabelText(value);
            }
        }
    };
    /**
   * @private
   */ // FIXME Two value axis
    LineView.prototype._doUpdateAnimation = function(data, stackedOnPoints, coordSys, api, step, valueOrigin, connectNulls) {
        var polyline = this._polyline;
        var polygon = this._polygon;
        var seriesModel = data.hostModel;
        var diff = (0, $b022c65e2d67ded9$export$2e2bcd8739ae039)(this._data, data, this._stackedOnPoints, stackedOnPoints, this._coordSys, coordSys, this._valueOrigin, valueOrigin);
        var current = diff.current;
        var stackedOnCurrent = diff.stackedOnCurrent;
        var next = diff.next;
        var stackedOnNext = diff.stackedOnNext;
        if (step) {
            // TODO If stacked series is not step
            stackedOnCurrent = $ada57dad04d4bbf5$var$turnPointsIntoStep(diff.stackedOnCurrent, diff.current, coordSys, step, connectNulls);
            current = $ada57dad04d4bbf5$var$turnPointsIntoStep(diff.current, null, coordSys, step, connectNulls);
            stackedOnNext = $ada57dad04d4bbf5$var$turnPointsIntoStep(diff.stackedOnNext, diff.next, coordSys, step, connectNulls);
            next = $ada57dad04d4bbf5$var$turnPointsIntoStep(diff.next, null, coordSys, step, connectNulls);
        }
        // Don't apply animation if diff is large.
        // For better result and avoid memory explosion problems like
        // https://github.com/apache/incubator-echarts/issues/12229
        if ($ada57dad04d4bbf5$var$getBoundingDiff(current, next) > 3000 || polygon && $ada57dad04d4bbf5$var$getBoundingDiff(stackedOnCurrent, stackedOnNext) > 3000) {
            polyline.stopAnimation();
            polyline.setShape({
                points: next
            });
            if (polygon) {
                polygon.stopAnimation();
                polygon.setShape({
                    points: next,
                    stackedOnPoints: stackedOnNext
                });
            }
            return;
        }
        polyline.shape.__points = diff.current;
        polyline.shape.points = current;
        var target = {
            shape: {
                points: next
            }
        };
        // Also animate the original points.
        // If points reference is changed when turning into step line.
        if (diff.current !== current) target.shape.__points = diff.next;
        // Stop previous animation.
        polyline.stopAnimation();
        $8b353638fbedfefa$export$c8dce3c08436e91e(polyline, target, seriesModel);
        if (polygon) {
            polygon.setShape({
                // Reuse the points with polyline.
                points: current,
                stackedOnPoints: stackedOnCurrent
            });
            polygon.stopAnimation();
            $8b353638fbedfefa$export$c8dce3c08436e91e(polygon, {
                shape: {
                    stackedOnPoints: stackedOnNext
                }
            }, seriesModel);
            // If use attr directly in updateProps.
            if (polyline.shape.points !== polygon.shape.points) polygon.shape.points = polyline.shape.points;
        }
        var updatedDataInfo = [];
        var diffStatus = diff.status;
        for(var i = 0; i < diffStatus.length; i++){
            var cmd = diffStatus[i].cmd;
            if (cmd === '=') {
                var el = data.getItemGraphicEl(diffStatus[i].idx1);
                if (el) updatedDataInfo.push({
                    el: el,
                    ptIdx: i // Index of points
                });
            }
        }
        if (polyline.animators && polyline.animators.length) polyline.animators[0].during(function() {
            polygon && polygon.dirtyShape();
            var points = polyline.shape.__points;
            for(var i = 0; i < updatedDataInfo.length; i++){
                var el = updatedDataInfo[i].el;
                var offset = updatedDataInfo[i].ptIdx * 2;
                el.x = points[offset];
                el.y = points[offset + 1];
                el.markRedraw();
            }
        });
    };
    LineView.prototype.remove = function(ecModel) {
        var group = this.group;
        var oldData = this._data;
        this._lineGroup.removeAll();
        this._symbolDraw.remove(true);
        // Remove temporary created elements when highlighting
        oldData && oldData.eachItemGraphicEl(function(el, idx) {
            if (el.__temp) {
                group.remove(el);
                oldData.setItemGraphicEl(idx, null);
            }
        });
        this._polyline = this._polygon = this._coordSys = this._points = this._stackedOnPoints = this._endLabel = this._data = null;
    };
    LineView.type = 'line';
    return LineView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $ada57dad04d4bbf5$export$2e2bcd8739ae039 = $ada57dad04d4bbf5$var$LineView;




function $9c1bfdc9a4f78f2d$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $ada57dad04d4bbf5$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $04f9db15b0fa1cf8$export$2e2bcd8739ae039));
    registers.registerLayout((0, $73b014aa594ea652$export$2e2bcd8739ae039)('line', true));
    registers.registerVisual({
        seriesType: 'line',
        reset: function(seriesModel) {
            var data = seriesModel.getData();
            // Visual coding for legend
            var lineStyle = seriesModel.getModel('lineStyle').getLineStyle();
            if (lineStyle && !lineStyle.stroke) // Fill in visual should be palette color if
            // has color callback
            lineStyle.stroke = data.getVisual('style').fill;
            data.setVisual('legendLineStyle', lineStyle);
        }
    });
    // Down sample after filter
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, (0, $3a37e5b80322a871$export$2e2bcd8739ae039)('line'));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $ac4f44aacfb7dba9$var$EffectLine = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(EffectLine, _super);
    function EffectLine(lineData, idx, seriesScope) {
        var _this = _super.call(this) || this;
        _this.add(_this.createLine(lineData, idx, seriesScope));
        _this._updateEffectSymbol(lineData, idx);
        return _this;
    }
    EffectLine.prototype.createLine = function(lineData, idx, seriesScope) {
        return new (0, $9e0b5f801ab5090c$export$2e2bcd8739ae039)(lineData, idx, seriesScope);
    };
    EffectLine.prototype._updateEffectSymbol = function(lineData, idx) {
        var itemModel = lineData.getItemModel(idx);
        var effectModel = itemModel.getModel('effect');
        var size = effectModel.get('symbolSize');
        var symbolType = effectModel.get('symbol');
        if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(size)) size = [
            size,
            size
        ];
        var lineStyle = lineData.getItemVisual(idx, 'style');
        var color = effectModel.get('color') || lineStyle && lineStyle.stroke;
        var symbol = this.childAt(1);
        if (this._symbolType !== symbolType) {
            // Remove previous
            this.remove(symbol);
            symbol = (0, $5370466dadc978d7$export$af050e04da3a02e8)(symbolType, -0.5, -0.5, 1, 1, color);
            symbol.z2 = 100;
            symbol.culling = true;
            this.add(symbol);
        }
        // Symbol may be removed if loop is false
        if (!symbol) return;
        // Shadow color is same with color in default
        symbol.setStyle('shadowColor', color);
        symbol.setStyle(effectModel.getItemStyle([
            'color'
        ]));
        symbol.scaleX = size[0];
        symbol.scaleY = size[1];
        symbol.setColor(color);
        this._symbolType = symbolType;
        this._symbolScale = size;
        this._updateEffectAnimation(lineData, effectModel, idx);
    };
    EffectLine.prototype._updateEffectAnimation = function(lineData, effectModel, idx) {
        var symbol = this.childAt(1);
        if (!symbol) return;
        var points = lineData.getItemLayout(idx);
        var period = effectModel.get('period') * 1000;
        var loop = effectModel.get('loop');
        var roundTrip = effectModel.get('roundTrip');
        var constantSpeed = effectModel.get('constantSpeed');
        var delayExpr = $7a1bd9c2710fea0d$export$8a4d17b6e8486e66(effectModel.get('delay'), function(idx) {
            return idx / lineData.count() * period / 3;
        });
        // Ignore when updating
        symbol.ignore = true;
        this._updateAnimationPoints(symbol, points);
        if (constantSpeed > 0) period = this._getLineLength(symbol) / constantSpeed * 1000;
        if (period !== this._period || loop !== this._loop || roundTrip !== this._roundTrip) {
            symbol.stopAnimation();
            var delayNum = void 0;
            if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(delayExpr)) delayNum = delayExpr(idx);
            else delayNum = delayExpr;
            if (symbol.__t > 0) delayNum = -period * symbol.__t;
            this._animateSymbol(symbol, period, delayNum, loop, roundTrip);
        }
        this._period = period;
        this._loop = loop;
        this._roundTrip = roundTrip;
    };
    EffectLine.prototype._animateSymbol = function(symbol, period, delayNum, loop, roundTrip) {
        if (period > 0) {
            symbol.__t = 0;
            var self_1 = this;
            var animator = symbol.animate('', loop).when(roundTrip ? period * 2 : period, {
                __t: roundTrip ? 2 : 1
            }).delay(delayNum).during(function() {
                self_1._updateSymbolPosition(symbol);
            });
            if (!loop) animator.done(function() {
                self_1.remove(symbol);
            });
            animator.start();
        }
    };
    EffectLine.prototype._getLineLength = function(symbol) {
        // Not so accurate
        return $6de594cf8ac295ff$export$6c4a311cc157c764(symbol.__p1, symbol.__cp1) + $6de594cf8ac295ff$export$6c4a311cc157c764(symbol.__cp1, symbol.__p2);
    };
    EffectLine.prototype._updateAnimationPoints = function(symbol, points) {
        symbol.__p1 = points[0];
        symbol.__p2 = points[1];
        symbol.__cp1 = points[2] || [
            (points[0][0] + points[1][0]) / 2,
            (points[0][1] + points[1][1]) / 2
        ];
    };
    EffectLine.prototype.updateData = function(lineData, idx, seriesScope) {
        this.childAt(0).updateData(lineData, idx, seriesScope);
        this._updateEffectSymbol(lineData, idx);
    };
    EffectLine.prototype._updateSymbolPosition = function(symbol) {
        var p1 = symbol.__p1;
        var p2 = symbol.__p2;
        var cp1 = symbol.__cp1;
        var t = symbol.__t < 1 ? symbol.__t : 2 - symbol.__t;
        var pos = [
            symbol.x,
            symbol.y
        ];
        var lastPos = pos.slice();
        var quadraticAt = $747cfc5611b57cea$export$af17094a950f5073;
        var quadraticDerivativeAt = $747cfc5611b57cea$export$7e161e77e6fff8cb;
        pos[0] = quadraticAt(p1[0], cp1[0], p2[0], t);
        pos[1] = quadraticAt(p1[1], cp1[1], p2[1], t);
        // Tangent
        var tx = symbol.__t < 1 ? quadraticDerivativeAt(p1[0], cp1[0], p2[0], t) : quadraticDerivativeAt(p2[0], cp1[0], p1[0], 1 - t);
        var ty = symbol.__t < 1 ? quadraticDerivativeAt(p1[1], cp1[1], p2[1], t) : quadraticDerivativeAt(p2[1], cp1[1], p1[1], 1 - t);
        symbol.rotation = -Math.atan2(ty, tx) - Math.PI / 2;
        // enable continuity trail for 'line', 'rect', 'roundRect' symbolType
        if (this._symbolType === 'line' || this._symbolType === 'rect' || this._symbolType === 'roundRect') {
            if (symbol.__lastT !== undefined && symbol.__lastT < symbol.__t) {
                symbol.scaleY = $6de594cf8ac295ff$export$6c4a311cc157c764(lastPos, pos) * 1.05;
                // make sure the last segment render within endPoint
                if (t === 1) {
                    pos[0] = lastPos[0] + (pos[0] - lastPos[0]) / 2;
                    pos[1] = lastPos[1] + (pos[1] - lastPos[1]) / 2;
                }
            } else if (symbol.__lastT === 1) // After first loop, symbol.__t does NOT start with 0, so connect p1 to pos directly.
            symbol.scaleY = 2 * $6de594cf8ac295ff$export$6c4a311cc157c764(p1, pos);
            else symbol.scaleY = this._symbolScale[1];
        }
        symbol.__lastT = symbol.__t;
        symbol.ignore = false;
        symbol.x = pos[0];
        symbol.y = pos[1];
    };
    EffectLine.prototype.updateLayout = function(lineData, idx) {
        this.childAt(0).updateLayout(lineData, idx);
        var effectModel = lineData.getItemModel(idx).getModel('effect');
        this._updateEffectAnimation(lineData, effectModel, idx);
    };
    return EffectLine;
}($7ef7583d8302ffce$export$2e2bcd8739ae039);
var $ac4f44aacfb7dba9$export$2e2bcd8739ae039 = $ac4f44aacfb7dba9$var$EffectLine;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $bdfe7b18bcde1955$var$Polyline = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(Polyline, _super);
    function Polyline(lineData, idx, seriesScope) {
        var _this = _super.call(this) || this;
        _this._createPolyline(lineData, idx, seriesScope);
        return _this;
    }
    Polyline.prototype._createPolyline = function(lineData, idx, seriesScope) {
        // let seriesModel = lineData.hostModel;
        var points = lineData.getItemLayout(idx);
        var line = new $d28119f30e6bb670$export$2e2bcd8739ae039({
            shape: {
                points: points
            }
        });
        this.add(line);
        this._updateCommonStl(lineData, idx, seriesScope);
    };
    Polyline.prototype.updateData = function(lineData, idx, seriesScope) {
        var seriesModel = lineData.hostModel;
        var line = this.childAt(0);
        var target = {
            shape: {
                points: lineData.getItemLayout(idx)
            }
        };
        $8b353638fbedfefa$export$c8dce3c08436e91e(line, target, seriesModel, idx);
        this._updateCommonStl(lineData, idx, seriesScope);
    };
    Polyline.prototype._updateCommonStl = function(lineData, idx, seriesScope) {
        var line = this.childAt(0);
        var itemModel = lineData.getItemModel(idx);
        var emphasisLineStyle = seriesScope && seriesScope.emphasisLineStyle;
        var focus = seriesScope && seriesScope.focus;
        var blurScope = seriesScope && seriesScope.blurScope;
        var emphasisDisabled = seriesScope && seriesScope.emphasisDisabled;
        if (!seriesScope || lineData.hasItemOption) {
            var emphasisModel = itemModel.getModel('emphasis');
            emphasisLineStyle = emphasisModel.getModel('lineStyle').getLineStyle();
            emphasisDisabled = emphasisModel.get('disabled');
            focus = emphasisModel.get('focus');
            blurScope = emphasisModel.get('blurScope');
        }
        line.useStyle(lineData.getItemVisual(idx, 'style'));
        line.style.fill = null;
        line.style.strokeNoScale = true;
        var lineEmphasisState = line.ensureState('emphasis');
        lineEmphasisState.style = emphasisLineStyle;
        (0, $2bf82c0980125b62$export$e51187539ff11209)(this, focus, blurScope, emphasisDisabled);
    };
    Polyline.prototype.updateLayout = function(lineData, idx) {
        var polyline = this.childAt(0);
        polyline.setShape('points', lineData.getItemLayout(idx));
    };
    return Polyline;
}($7ef7583d8302ffce$export$2e2bcd8739ae039);
var $bdfe7b18bcde1955$export$2e2bcd8739ae039 = $bdfe7b18bcde1955$var$Polyline;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $a16373b7bc6b0508$var$EffectPolyline = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(EffectPolyline, _super);
    function EffectPolyline() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._lastFrame = 0;
        _this._lastFramePercent = 0;
        return _this;
    }
    // Override
    EffectPolyline.prototype.createLine = function(lineData, idx, seriesScope) {
        return new (0, $bdfe7b18bcde1955$export$2e2bcd8739ae039)(lineData, idx, seriesScope);
    };
    // Override
    EffectPolyline.prototype._updateAnimationPoints = function(symbol, points) {
        this._points = points;
        var accLenArr = [
            0
        ];
        var len = 0;
        for(var i = 1; i < points.length; i++){
            var p1 = points[i - 1];
            var p2 = points[i];
            len += $6de594cf8ac295ff$export$6c4a311cc157c764(p1, p2);
            accLenArr.push(len);
        }
        if (len === 0) {
            this._length = 0;
            return;
        }
        for(var i = 0; i < accLenArr.length; i++)accLenArr[i] /= len;
        this._offsets = accLenArr;
        this._length = len;
    };
    // Override
    EffectPolyline.prototype._getLineLength = function() {
        return this._length;
    };
    // Override
    EffectPolyline.prototype._updateSymbolPosition = function(symbol) {
        var t = symbol.__t < 1 ? symbol.__t : 2 - symbol.__t;
        var points = this._points;
        var offsets = this._offsets;
        var len = points.length;
        if (!offsets) // Has length 0
        return;
        var lastFrame = this._lastFrame;
        var frame;
        if (t < this._lastFramePercent) {
            // Start from the next frame
            // PENDING start from lastFrame ?
            var start = Math.min(lastFrame + 1, len - 1);
            for(frame = start; frame >= 0; frame--){
                if (offsets[frame] <= t) break;
            }
            // PENDING really need to do this ?
            frame = Math.min(frame, len - 2);
        } else {
            for(frame = lastFrame; frame < len; frame++){
                if (offsets[frame] > t) break;
            }
            frame = Math.min(frame - 1, len - 2);
        }
        var p = (t - offsets[frame]) / (offsets[frame + 1] - offsets[frame]);
        var p0 = points[frame];
        var p1 = points[frame + 1];
        symbol.x = p0[0] * (1 - p) + p * p1[0];
        symbol.y = p0[1] * (1 - p) + p * p1[1];
        var tx = symbol.__t < 1 ? p1[0] - p0[0] : p0[0] - p1[0];
        var ty = symbol.__t < 1 ? p1[1] - p0[1] : p0[1] - p1[1];
        symbol.rotation = -Math.atan2(ty, tx) - Math.PI / 2;
        this._lastFrame = frame;
        this._lastFramePercent = t;
        symbol.ignore = false;
    };
    return EffectPolyline;
}((0, $ac4f44aacfb7dba9$export$2e2bcd8739ae039));
var $a16373b7bc6b0508$export$2e2bcd8739ae039 = $a16373b7bc6b0508$var$EffectPolyline;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $2f5f63360e8576db$var$LargeLinesPathShape = /** @class */ function() {
    function LargeLinesPathShape() {
        this.polyline = false;
        this.curveness = 0;
        this.segs = [];
    }
    return LargeLinesPathShape;
}();
var $2f5f63360e8576db$var$LargeLinesPath = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(LargeLinesPath, _super);
    function LargeLinesPath(opts) {
        var _this = _super.call(this, opts) || this;
        _this._off = 0;
        _this.hoverDataIdx = -1;
        return _this;
    }
    LargeLinesPath.prototype.reset = function() {
        this.notClear = false;
        this._off = 0;
    };
    LargeLinesPath.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    LargeLinesPath.prototype.getDefaultShape = function() {
        return new $2f5f63360e8576db$var$LargeLinesPathShape();
    };
    LargeLinesPath.prototype.buildPath = function(ctx, shape) {
        var segs = shape.segs;
        var curveness = shape.curveness;
        var i;
        if (shape.polyline) for(i = this._off; i < segs.length;){
            var count = segs[i++];
            if (count > 0) {
                ctx.moveTo(segs[i++], segs[i++]);
                for(var k = 1; k < count; k++)ctx.lineTo(segs[i++], segs[i++]);
            }
        }
        else for(i = this._off; i < segs.length;){
            var x0 = segs[i++];
            var y0 = segs[i++];
            var x1 = segs[i++];
            var y1 = segs[i++];
            ctx.moveTo(x0, y0);
            if (curveness > 0) {
                var x2 = (x0 + x1) / 2 - (y0 - y1) * curveness;
                var y2 = (y0 + y1) / 2 - (x1 - x0) * curveness;
                ctx.quadraticCurveTo(x2, y2, x1, y1);
            } else ctx.lineTo(x1, y1);
        }
        if (this.incremental) {
            this._off = i;
            this.notClear = true;
        }
    };
    LargeLinesPath.prototype.findDataIndex = function(x, y) {
        var shape = this.shape;
        var segs = shape.segs;
        var curveness = shape.curveness;
        var lineWidth = this.style.lineWidth;
        if (shape.polyline) {
            var dataIndex = 0;
            for(var i = 0; i < segs.length;){
                var count = segs[i++];
                if (count > 0) {
                    var x0 = segs[i++];
                    var y0 = segs[i++];
                    for(var k = 1; k < count; k++){
                        var x1 = segs[i++];
                        var y1 = segs[i++];
                        if ($beafddd7270f4bea$export$8d36b1b5d19157c5(x0, y0, x1, y1, lineWidth, x, y)) return dataIndex;
                    }
                }
                dataIndex++;
            }
        } else {
            var dataIndex = 0;
            for(var i = 0; i < segs.length;){
                var x0 = segs[i++];
                var y0 = segs[i++];
                var x1 = segs[i++];
                var y1 = segs[i++];
                if (curveness > 0) {
                    var x2 = (x0 + x1) / 2 - (y0 - y1) * curveness;
                    var y2 = (y0 + y1) / 2 - (x1 - x0) * curveness;
                    if ($a1d80a5bf05b597b$export$8d36b1b5d19157c5(x0, y0, x2, y2, x1, y1, lineWidth, x, y)) return dataIndex;
                } else {
                    if ($beafddd7270f4bea$export$8d36b1b5d19157c5(x0, y0, x1, y1, lineWidth, x, y)) return dataIndex;
                }
                dataIndex++;
            }
        }
        return -1;
    };
    LargeLinesPath.prototype.contain = function(x, y) {
        var localPos = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        x = localPos[0];
        y = localPos[1];
        if (rect.contain(x, y)) {
            // Cache found data index.
            var dataIdx = this.hoverDataIdx = this.findDataIndex(x, y);
            return dataIdx >= 0;
        }
        this.hoverDataIdx = -1;
        return false;
    };
    LargeLinesPath.prototype.getBoundingRect = function() {
        // Ignore stroke for large symbol draw.
        var rect = this._rect;
        if (!rect) {
            var shape = this.shape;
            var points = shape.segs;
            var minX = Infinity;
            var minY = Infinity;
            var maxX = -Infinity;
            var maxY = -Infinity;
            for(var i = 0; i < points.length;){
                var x = points[i++];
                var y = points[i++];
                minX = Math.min(x, minX);
                maxX = Math.max(x, maxX);
                minY = Math.min(y, minY);
                maxY = Math.max(y, maxY);
            }
            rect = this._rect = new $1bebe7106c895823$export$2e2bcd8739ae039(minX, minY, maxX, maxY);
        }
        return rect;
    };
    return LargeLinesPath;
}($b02ffe7acd508c08$export$2e2bcd8739ae039);
var $2f5f63360e8576db$var$LargeLineDraw = /** @class */ function() {
    function LargeLineDraw() {
        this.group = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
    }
    /**
   * Update symbols draw by new data
   */ LargeLineDraw.prototype.updateData = function(data) {
        this._clear();
        var lineEl = this._create();
        lineEl.setShape({
            segs: data.getLayout('linesPoints')
        });
        this._setCommon(lineEl, data);
    };
    /**
   * @override
   */ LargeLineDraw.prototype.incrementalPrepareUpdate = function(data) {
        this.group.removeAll();
        this._clear();
    };
    /**
   * @override
   */ LargeLineDraw.prototype.incrementalUpdate = function(taskParams, data) {
        var lastAdded = this._newAdded[0];
        var linePoints = data.getLayout('linesPoints');
        var oldSegs = lastAdded && lastAdded.shape.segs;
        // Merging the exists. Each element has 1e4 points.
        // Consider the performance balance between too much elements and too much points in one shape(may affect hover optimization)
        if (oldSegs && oldSegs.length < 2e4) {
            var oldLen = oldSegs.length;
            var newSegs = new Float32Array(oldLen + linePoints.length);
            // Concat two array
            newSegs.set(oldSegs);
            newSegs.set(linePoints, oldLen);
            lastAdded.setShape({
                segs: newSegs
            });
        } else {
            // Clear
            this._newAdded = [];
            var lineEl = this._create();
            lineEl.incremental = true;
            lineEl.setShape({
                segs: linePoints
            });
            this._setCommon(lineEl, data);
            lineEl.__startIndex = taskParams.start;
        }
    };
    /**
   * @override
   */ LargeLineDraw.prototype.remove = function() {
        this._clear();
    };
    LargeLineDraw.prototype.eachRendered = function(cb) {
        this._newAdded[0] && cb(this._newAdded[0]);
    };
    LargeLineDraw.prototype._create = function() {
        var lineEl = new $2f5f63360e8576db$var$LargeLinesPath({
            cursor: 'default',
            ignoreCoarsePointer: true
        });
        this._newAdded.push(lineEl);
        this.group.add(lineEl);
        return lineEl;
    };
    LargeLineDraw.prototype._setCommon = function(lineEl, data, isIncremental) {
        var hostModel = data.hostModel;
        lineEl.setShape({
            polyline: hostModel.get('polyline'),
            curveness: hostModel.get([
                'lineStyle',
                'curveness'
            ])
        });
        lineEl.useStyle(hostModel.getModel('lineStyle').getLineStyle());
        lineEl.style.strokeNoScale = true;
        var style = data.getVisual('style');
        if (style && style.stroke) lineEl.setStyle('stroke', style.stroke);
        lineEl.setStyle('fill', null);
        var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(lineEl);
        // Enable tooltip
        // PENDING May have performance issue when path is extremely large
        ecData.seriesIndex = hostModel.seriesIndex;
        lineEl.on('mousemove', function(e) {
            ecData.dataIndex = null;
            var dataIndex = lineEl.hoverDataIdx;
            if (dataIndex > 0) // Provide dataIndex for tooltip
            ecData.dataIndex = dataIndex + lineEl.__startIndex;
        });
    };
    LargeLineDraw.prototype._clear = function() {
        this._newAdded = [];
        this.group.removeAll();
    };
    return LargeLineDraw;
}();
var $2f5f63360e8576db$export$2e2bcd8739ae039 = $2f5f63360e8576db$var$LargeLineDraw;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /* global Float32Array */ 

var $e702d3171e9448b0$var$linesLayout = {
    seriesType: 'lines',
    plan: (0, $cd70075c57b35175$export$2e2bcd8739ae039)(),
    reset: function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        if (!coordSys) return;
        var isPolyline = seriesModel.get('polyline');
        var isLarge = seriesModel.pipelineContext.large;
        return {
            progress: function(params, lineData) {
                var lineCoords = [];
                if (isLarge) {
                    var points = void 0;
                    var segCount = params.end - params.start;
                    if (isPolyline) {
                        var totalCoordsCount = 0;
                        for(var i = params.start; i < params.end; i++)totalCoordsCount += seriesModel.getLineCoordsCount(i);
                        points = new Float32Array(segCount + totalCoordsCount * 2);
                    } else points = new Float32Array(segCount * 4);
                    var offset = 0;
                    var pt = [];
                    for(var i = params.start; i < params.end; i++){
                        var len = seriesModel.getLineCoords(i, lineCoords);
                        if (isPolyline) points[offset++] = len;
                        for(var k = 0; k < len; k++){
                            pt = coordSys.dataToPoint(lineCoords[k], false, pt);
                            points[offset++] = pt[0];
                            points[offset++] = pt[1];
                        }
                    }
                    lineData.setLayout('linesPoints', points);
                } else for(var i = params.start; i < params.end; i++){
                    var itemModel = lineData.getItemModel(i);
                    var len = seriesModel.getLineCoords(i, lineCoords);
                    var pts = [];
                    if (isPolyline) for(var j = 0; j < len; j++)pts.push(coordSys.dataToPoint(lineCoords[j]));
                    else {
                        pts[0] = coordSys.dataToPoint(lineCoords[0]);
                        pts[1] = coordSys.dataToPoint(lineCoords[1]);
                        var curveness = itemModel.get([
                            'lineStyle',
                            'curveness'
                        ]);
                        if (+curveness) pts[2] = [
                            (pts[0][0] + pts[1][0]) / 2 - (pts[0][1] - pts[1][1]) * curveness,
                            (pts[0][1] + pts[1][1]) / 2 - (pts[1][0] - pts[0][0]) * curveness
                        ];
                    }
                    lineData.setItemLayout(i, pts);
                }
            }
        };
    }
};
var $e702d3171e9448b0$export$2e2bcd8739ae039 = $e702d3171e9448b0$var$linesLayout;




var $cefff1aea7415b28$var$LinesView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(LinesView, _super);
    function LinesView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = LinesView.type;
        return _this;
    }
    LinesView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var lineDraw = this._updateLineDraw(data, seriesModel);
        var zlevel = seriesModel.get('zlevel');
        var trailLength = seriesModel.get([
            'effect',
            'trailLength'
        ]);
        var zr = api.getZr();
        // Avoid the drag cause ghost shadow
        // FIXME Better way ?
        // SVG doesn't support
        var isSvg = zr.painter.getType() === 'svg';
        if (!isSvg) zr.painter.getLayer(zlevel).clear(true);
        // Config layer with motion blur
        if (this._lastZlevel != null && !isSvg) zr.configLayer(this._lastZlevel, {
            motionBlur: false
        });
        if (this._showEffect(seriesModel) && trailLength > 0) {
            if (!isSvg) zr.configLayer(zlevel, {
                motionBlur: true,
                lastFrameAlpha: Math.max(Math.min(trailLength / 10 + 0.9, 1), 0)
            });
        }
        lineDraw.updateData(data);
        var clipPath = seriesModel.get('clip', true) && (0, $0e2cc04b3aaad400$export$e0fe5081209d01c9)(seriesModel.coordinateSystem, false, seriesModel);
        if (clipPath) this.group.setClipPath(clipPath);
        else this.group.removeClipPath();
        this._lastZlevel = zlevel;
        this._finished = true;
    };
    LinesView.prototype.incrementalPrepareRender = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var lineDraw = this._updateLineDraw(data, seriesModel);
        lineDraw.incrementalPrepareUpdate(data);
        this._clearLayer(api);
        this._finished = false;
    };
    LinesView.prototype.incrementalRender = function(taskParams, seriesModel, ecModel) {
        this._lineDraw.incrementalUpdate(taskParams, seriesModel.getData());
        this._finished = taskParams.end === seriesModel.getData().count();
    };
    LinesView.prototype.eachRendered = function(cb) {
        this._lineDraw && this._lineDraw.eachRendered(cb);
    };
    LinesView.prototype.updateTransform = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var pipelineContext = seriesModel.pipelineContext;
        if (!this._finished || pipelineContext.large || pipelineContext.progressiveRender) // TODO Don't have to do update in large mode. Only do it when there are millions of data.
        return {
            update: true
        };
        else {
            // TODO Use same logic with ScatterView.
            // Manually update layout
            var res = (0, $e702d3171e9448b0$export$2e2bcd8739ae039).reset(seriesModel, ecModel, api);
            if (res.progress) res.progress({
                start: 0,
                end: data.count(),
                count: data.count()
            }, data);
            // Not in large mode
            this._lineDraw.updateLayout();
            this._clearLayer(api);
        }
    };
    LinesView.prototype._updateLineDraw = function(data, seriesModel) {
        var lineDraw = this._lineDraw;
        var hasEffect = this._showEffect(seriesModel);
        var isPolyline = !!seriesModel.get('polyline');
        var pipelineContext = seriesModel.pipelineContext;
        var isLargeDraw = pipelineContext.large;
        if (!lineDraw || hasEffect !== this._hasEffet || isPolyline !== this._isPolyline || isLargeDraw !== this._isLargeDraw) {
            if (lineDraw) lineDraw.remove();
            lineDraw = this._lineDraw = isLargeDraw ? new (0, $2f5f63360e8576db$export$2e2bcd8739ae039)() : new (0, $a2fd63a0fc11274a$export$2e2bcd8739ae039)(isPolyline ? hasEffect ? (0, $a16373b7bc6b0508$export$2e2bcd8739ae039) : (0, $bdfe7b18bcde1955$export$2e2bcd8739ae039) : hasEffect ? (0, $ac4f44aacfb7dba9$export$2e2bcd8739ae039) : (0, $9e0b5f801ab5090c$export$2e2bcd8739ae039));
            this._hasEffet = hasEffect;
            this._isPolyline = isPolyline;
            this._isLargeDraw = isLargeDraw;
        }
        this.group.add(lineDraw.group);
        return lineDraw;
    };
    LinesView.prototype._showEffect = function(seriesModel) {
        return !!seriesModel.get([
            'effect',
            'show'
        ]);
    };
    LinesView.prototype._clearLayer = function(api) {
        // Not use motion when dragging or zooming
        var zr = api.getZr();
        var isSvg = zr.painter.getType() === 'svg';
        if (!isSvg && this._lastZlevel != null) zr.painter.getLayer(this._lastZlevel).clear(true);
    };
    LinesView.prototype.remove = function(ecModel, api) {
        this._lineDraw && this._lineDraw.remove();
        this._lineDraw = null;
        // Clear motion when lineDraw is removed
        this._clearLayer(api);
    };
    LinesView.prototype.dispose = function(ecModel, api) {
        this.remove(ecModel, api);
    };
    LinesView.type = 'lines';
    return LinesView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $cefff1aea7415b28$export$2e2bcd8739ae039 = $cefff1aea7415b28$var$LinesView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $7abeccdc5e740e42$var$Uint32Arr = typeof Uint32Array === 'undefined' ? Array : Uint32Array;
var $7abeccdc5e740e42$var$Float64Arr = typeof Float64Array === 'undefined' ? Array : Float64Array;
function $7abeccdc5e740e42$var$compatEc2(seriesOpt) {
    var data = seriesOpt.data;
    if (data && data[0] && data[0][0] && data[0][0].coord) seriesOpt.data = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(data, function(itemOpt) {
        var coords = [
            itemOpt[0].coord,
            itemOpt[1].coord
        ];
        var target = {
            coords: coords
        };
        if (itemOpt[0].name) target.fromName = itemOpt[0].name;
        if (itemOpt[1].name) target.toName = itemOpt[1].name;
        return (0, $7a1bd9c2710fea0d$export$18aef43295bbe906)([
            target,
            itemOpt[0],
            itemOpt[1]
        ]);
    });
}
var $7abeccdc5e740e42$var$LinesSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(LinesSeriesModel, _super);
    function LinesSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = LinesSeriesModel.type;
        _this.visualStyleAccessPath = 'lineStyle';
        _this.visualDrawType = 'stroke';
        return _this;
    }
    LinesSeriesModel.prototype.init = function(option) {
        // The input data may be null/undefined.
        option.data = option.data || [];
        // Not using preprocessor because mergeOption may not have series.type
        $7abeccdc5e740e42$var$compatEc2(option);
        var result = this._processFlatCoordsArray(option.data);
        this._flatCoords = result.flatCoords;
        this._flatCoordsOffset = result.flatCoordsOffset;
        if (result.flatCoords) option.data = new Float32Array(result.count);
        _super.prototype.init.apply(this, arguments);
    };
    LinesSeriesModel.prototype.mergeOption = function(option) {
        $7abeccdc5e740e42$var$compatEc2(option);
        if (option.data) {
            // Only update when have option data to merge.
            var result = this._processFlatCoordsArray(option.data);
            this._flatCoords = result.flatCoords;
            this._flatCoordsOffset = result.flatCoordsOffset;
            if (result.flatCoords) option.data = new Float32Array(result.count);
        }
        _super.prototype.mergeOption.apply(this, arguments);
    };
    LinesSeriesModel.prototype.appendData = function(params) {
        var result = this._processFlatCoordsArray(params.data);
        if (result.flatCoords) {
            if (!this._flatCoords) {
                this._flatCoords = result.flatCoords;
                this._flatCoordsOffset = result.flatCoordsOffset;
            } else {
                this._flatCoords = (0, $7a1bd9c2710fea0d$export$4fd8af2c48c43416)(this._flatCoords, result.flatCoords);
                this._flatCoordsOffset = (0, $7a1bd9c2710fea0d$export$4fd8af2c48c43416)(this._flatCoordsOffset, result.flatCoordsOffset);
            }
            params.data = new Float32Array(result.count);
        }
        this.getRawData().appendData(params.data);
    };
    LinesSeriesModel.prototype._getCoordsFromItemModel = function(idx) {
        var itemModel = this.getData().getItemModel(idx);
        var coords = itemModel.option instanceof Array ? itemModel.option : itemModel.getShallow('coords');
        return coords;
    };
    LinesSeriesModel.prototype.getLineCoordsCount = function(idx) {
        if (this._flatCoordsOffset) return this._flatCoordsOffset[idx * 2 + 1];
        else return this._getCoordsFromItemModel(idx).length;
    };
    LinesSeriesModel.prototype.getLineCoords = function(idx, out) {
        if (this._flatCoordsOffset) {
            var offset = this._flatCoordsOffset[idx * 2];
            var len = this._flatCoordsOffset[idx * 2 + 1];
            for(var i = 0; i < len; i++){
                out[i] = out[i] || [];
                out[i][0] = this._flatCoords[offset + i * 2];
                out[i][1] = this._flatCoords[offset + i * 2 + 1];
            }
            return len;
        } else {
            var coords = this._getCoordsFromItemModel(idx);
            for(var i = 0; i < coords.length; i++){
                out[i] = out[i] || [];
                out[i][0] = coords[i][0];
                out[i][1] = coords[i][1];
            }
            return coords.length;
        }
    };
    LinesSeriesModel.prototype._processFlatCoordsArray = function(data) {
        var startOffset = 0;
        if (this._flatCoords) startOffset = this._flatCoords.length;
        // Stored as a typed array. In format
        // Points Count(2) | x | y | x | y | Points Count(3) | x |  y | x | y | x | y |
        if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(data[0])) {
            var len = data.length;
            // Store offset and len of each segment
            var coordsOffsetAndLenStorage = new $7abeccdc5e740e42$var$Uint32Arr(len);
            var coordsStorage = new $7abeccdc5e740e42$var$Float64Arr(len);
            var coordsCursor = 0;
            var offsetCursor = 0;
            var dataCount = 0;
            for(var i = 0; i < len;){
                dataCount++;
                var count = data[i++];
                // Offset
                coordsOffsetAndLenStorage[offsetCursor++] = coordsCursor + startOffset;
                // Len
                coordsOffsetAndLenStorage[offsetCursor++] = count;
                for(var k = 0; k < count; k++){
                    var x = data[i++];
                    var y = data[i++];
                    coordsStorage[coordsCursor++] = x;
                    coordsStorage[coordsCursor++] = y;
                }
            }
            return {
                flatCoordsOffset: new Uint32Array(coordsOffsetAndLenStorage.buffer, 0, offsetCursor),
                flatCoords: coordsStorage,
                count: dataCount
            };
        }
        return {
            flatCoordsOffset: null,
            flatCoords: null,
            count: data.length
        };
    };
    LinesSeriesModel.prototype.getInitialData = function(option, ecModel) {
        var CoordSys;
        var lineData = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)([
            'value'
        ], this);
        lineData.hasItemOption = false;
        lineData.initData(option.data, [], function(dataItem, dimName, dataIndex, dimIndex) {
            // dataItem is simply coords
            if (dataItem instanceof Array) return NaN;
            else {
                lineData.hasItemOption = true;
                var value = dataItem.value;
                if (value != null) return value instanceof Array ? value[dimIndex] : value;
            }
        });
        return lineData;
    };
    LinesSeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        var data = this.getData();
        var itemModel = data.getItemModel(dataIndex);
        var name = itemModel.get('name');
        if (name) return name;
        var fromName = itemModel.get('fromName');
        var toName = itemModel.get('toName');
        var nameArr = [];
        fromName != null && nameArr.push(fromName);
        toName != null && nameArr.push(toName);
        return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)('nameValue', {
            name: nameArr.join(' > ')
        });
    };
    LinesSeriesModel.prototype.preventIncremental = function() {
        return !!this.get([
            'effect',
            'show'
        ]);
    };
    LinesSeriesModel.prototype.getProgressive = function() {
        var progressive = this.option.progressive;
        if (progressive == null) return this.option.large ? 1e4 : this.get('progressive');
        return progressive;
    };
    LinesSeriesModel.prototype.getProgressiveThreshold = function() {
        var progressiveThreshold = this.option.progressiveThreshold;
        if (progressiveThreshold == null) return this.option.large ? 2e4 : this.get('progressiveThreshold');
        return progressiveThreshold;
    };
    LinesSeriesModel.prototype.getZLevelKey = function() {
        var effectModel = this.getModel('effect');
        var trailLength = effectModel.get('trailLength');
        return this.getData().count() > this.getProgressiveThreshold() ? this.id : effectModel.get('show') && trailLength > 0 ? trailLength + '' : '';
    };
    LinesSeriesModel.type = 'series.lines';
    LinesSeriesModel.dependencies = [
        'grid',
        'polar',
        'geo',
        'calendar'
    ];
    LinesSeriesModel.defaultOption = {
        coordinateSystem: 'geo',
        // zlevel: 0,
        z: 2,
        legendHoverLink: true,
        // Cartesian coordinate system
        xAxisIndex: 0,
        yAxisIndex: 0,
        symbol: [
            'none',
            'none'
        ],
        symbolSize: [
            10,
            10
        ],
        // Geo coordinate system
        geoIndex: 0,
        effect: {
            show: false,
            period: 4,
            constantSpeed: 0,
            symbol: 'circle',
            symbolSize: 3,
            loop: true,
            trailLength: 0.2
        },
        large: false,
        // Available when large is true
        largeThreshold: 2000,
        polyline: false,
        clip: true,
        label: {
            show: false,
            position: 'end'
        },
        lineStyle: {
            opacity: 0.5
        }
    };
    return LinesSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $7abeccdc5e740e42$export$2e2bcd8739ae039 = $7abeccdc5e740e42$var$LinesSeriesModel;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $111ea02a392b95a6$var$normalize(a) {
    if (!(a instanceof Array)) a = [
        a,
        a
    ];
    return a;
}
var $111ea02a392b95a6$var$linesVisual = {
    seriesType: 'lines',
    reset: function(seriesModel) {
        var symbolType = $111ea02a392b95a6$var$normalize(seriesModel.get('symbol'));
        var symbolSize = $111ea02a392b95a6$var$normalize(seriesModel.get('symbolSize'));
        var data = seriesModel.getData();
        data.setVisual('fromSymbol', symbolType && symbolType[0]);
        data.setVisual('toSymbol', symbolType && symbolType[1]);
        data.setVisual('fromSymbolSize', symbolSize && symbolSize[0]);
        data.setVisual('toSymbolSize', symbolSize && symbolSize[1]);
        function dataEach(data, idx) {
            var itemModel = data.getItemModel(idx);
            var symbolType = $111ea02a392b95a6$var$normalize(itemModel.getShallow('symbol', true));
            var symbolSize = $111ea02a392b95a6$var$normalize(itemModel.getShallow('symbolSize', true));
            symbolType[0] && data.setItemVisual(idx, 'fromSymbol', symbolType[0]);
            symbolType[1] && data.setItemVisual(idx, 'toSymbol', symbolType[1]);
            symbolSize[0] && data.setItemVisual(idx, 'fromSymbolSize', symbolSize[0]);
            symbolSize[1] && data.setItemVisual(idx, 'toSymbolSize', symbolSize[1]);
        }
        return {
            dataEach: data.hasItemOption ? dataEach : null
        };
    }
};
var $111ea02a392b95a6$export$2e2bcd8739ae039 = $111ea02a392b95a6$var$linesVisual;


function $52dd2448928cc7d8$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $cefff1aea7415b28$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $7abeccdc5e740e42$export$2e2bcd8739ae039));
    registers.registerLayout((0, $e702d3171e9448b0$export$2e2bcd8739ae039));
    registers.registerVisual((0, $111ea02a392b95a6$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 














function $6d3db85dae3a1192$export$eacefc55fad2867e(svg) {
    if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(svg)) {
        var parser = new DOMParser();
        svg = parser.parseFromString(svg, 'text/xml');
    }
    var svgNode = svg;
    if (svgNode.nodeType === 9) svgNode = svgNode.firstChild;
    while(svgNode.nodeName.toLowerCase() !== 'svg' || svgNode.nodeType !== 1)svgNode = svgNode.nextSibling;
    return svgNode;
}


var $ccaaa4a85c480645$var$nodeParsers;
var $ccaaa4a85c480645$var$INHERITABLE_STYLE_ATTRIBUTES_MAP = {
    'fill': 'fill',
    'stroke': 'stroke',
    'stroke-width': 'lineWidth',
    'opacity': 'opacity',
    'fill-opacity': 'fillOpacity',
    'stroke-opacity': 'strokeOpacity',
    'stroke-dasharray': 'lineDash',
    'stroke-dashoffset': 'lineDashOffset',
    'stroke-linecap': 'lineCap',
    'stroke-linejoin': 'lineJoin',
    'stroke-miterlimit': 'miterLimit',
    'font-family': 'fontFamily',
    'font-size': 'fontSize',
    'font-style': 'fontStyle',
    'font-weight': 'fontWeight',
    'text-anchor': 'textAlign',
    'visibility': 'visibility',
    'display': 'display'
};
var $ccaaa4a85c480645$var$INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)($ccaaa4a85c480645$var$INHERITABLE_STYLE_ATTRIBUTES_MAP);
var $ccaaa4a85c480645$var$SELF_STYLE_ATTRIBUTES_MAP = {
    'alignment-baseline': 'textBaseline',
    'stop-color': 'stopColor'
};
var $ccaaa4a85c480645$var$SELF_STYLE_ATTRIBUTES_MAP_KEYS = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)($ccaaa4a85c480645$var$SELF_STYLE_ATTRIBUTES_MAP);
var $ccaaa4a85c480645$var$SVGParser = function() {
    function SVGParser() {
        this._defs = {};
        this._root = null;
    }
    SVGParser.prototype.parse = function(xml, opt) {
        opt = opt || {};
        var svg = (0, $6d3db85dae3a1192$export$eacefc55fad2867e)(xml);
        this._defsUsePending = [];
        var root = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)();
        this._root = root;
        var named = [];
        var viewBox = svg.getAttribute('viewBox') || '';
        var width = parseFloat(svg.getAttribute('width') || opt.width);
        var height = parseFloat(svg.getAttribute('height') || opt.height);
        isNaN(width) && (width = null);
        isNaN(height) && (height = null);
        $ccaaa4a85c480645$var$parseAttributes(svg, root, null, true, false);
        var child = svg.firstChild;
        while(child){
            this._parseNode(child, root, named, null, false, false);
            child = child.nextSibling;
        }
        $ccaaa4a85c480645$var$applyDefs(this._defs, this._defsUsePending);
        this._defsUsePending = [];
        var viewBoxRect;
        var viewBoxTransform;
        if (viewBox) {
            var viewBoxArr = $ccaaa4a85c480645$var$splitNumberSequence(viewBox);
            if (viewBoxArr.length >= 4) viewBoxRect = {
                x: parseFloat(viewBoxArr[0] || 0),
                y: parseFloat(viewBoxArr[1] || 0),
                width: parseFloat(viewBoxArr[2]),
                height: parseFloat(viewBoxArr[3])
            };
        }
        if (viewBoxRect && width != null && height != null) {
            viewBoxTransform = $ccaaa4a85c480645$export$3e2db4420f14f50f(viewBoxRect, {
                x: 0,
                y: 0,
                width: width,
                height: height
            });
            if (!opt.ignoreViewBox) {
                var elRoot = root;
                root = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)();
                root.add(elRoot);
                elRoot.scaleX = elRoot.scaleY = viewBoxTransform.scale;
                elRoot.x = viewBoxTransform.x;
                elRoot.y = viewBoxTransform.y;
            }
        }
        if (!opt.ignoreRootClip && width != null && height != null) root.setClipPath(new (0, $419e5ff2f303755e$export$2e2bcd8739ae039)({
            shape: {
                x: 0,
                y: 0,
                width: width,
                height: height
            }
        }));
        return {
            root: root,
            width: width,
            height: height,
            viewBoxRect: viewBoxRect,
            viewBoxTransform: viewBoxTransform,
            named: named
        };
    };
    SVGParser.prototype._parseNode = function(xmlNode, parentGroup, named, namedFrom, isInDefs, isInText) {
        var nodeName = xmlNode.nodeName.toLowerCase();
        var el;
        var namedFromForSub = namedFrom;
        if (nodeName === 'defs') isInDefs = true;
        if (nodeName === 'text') isInText = true;
        if (nodeName === 'defs' || nodeName === 'switch') el = parentGroup;
        else {
            if (!isInDefs) {
                var parser_1 = $ccaaa4a85c480645$var$nodeParsers[nodeName];
                if (parser_1 && (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)($ccaaa4a85c480645$var$nodeParsers, nodeName)) {
                    el = parser_1.call(this, xmlNode, parentGroup);
                    var nameAttr = xmlNode.getAttribute('name');
                    if (nameAttr) {
                        var newNamed = {
                            name: nameAttr,
                            namedFrom: null,
                            svgNodeTagLower: nodeName,
                            el: el
                        };
                        named.push(newNamed);
                        if (nodeName === 'g') namedFromForSub = newNamed;
                    } else if (namedFrom) named.push({
                        name: namedFrom.name,
                        namedFrom: namedFrom,
                        svgNodeTagLower: nodeName,
                        el: el
                    });
                    parentGroup.add(el);
                }
            }
            var parser = $ccaaa4a85c480645$var$paintServerParsers[nodeName];
            if (parser && (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)($ccaaa4a85c480645$var$paintServerParsers, nodeName)) {
                var def = parser.call(this, xmlNode);
                var id = xmlNode.getAttribute('id');
                if (id) this._defs[id] = def;
            }
        }
        if (el && el.isGroup) {
            var child = xmlNode.firstChild;
            while(child){
                if (child.nodeType === 1) this._parseNode(child, el, named, namedFromForSub, isInDefs, isInText);
                else if (child.nodeType === 3 && isInText) this._parseText(child, el);
                child = child.nextSibling;
            }
        }
    };
    SVGParser.prototype._parseText = function(xmlNode, parentGroup) {
        var text = new (0, $c9d5c769fe2f591f$export$2e2bcd8739ae039)({
            style: {
                text: xmlNode.textContent
            },
            silent: true,
            x: this._textX || 0,
            y: this._textY || 0
        });
        $ccaaa4a85c480645$var$inheritStyle(parentGroup, text);
        $ccaaa4a85c480645$var$parseAttributes(xmlNode, text, this._defsUsePending, false, false);
        $ccaaa4a85c480645$var$applyTextAlignment(text, parentGroup);
        var textStyle = text.style;
        var fontSize = textStyle.fontSize;
        if (fontSize && fontSize < 9) {
            textStyle.fontSize = 9;
            text.scaleX *= fontSize / 9;
            text.scaleY *= fontSize / 9;
        }
        var font = (textStyle.fontSize || textStyle.fontFamily) && [
            textStyle.fontStyle,
            textStyle.fontWeight,
            (textStyle.fontSize || 12) + 'px',
            textStyle.fontFamily || 'sans-serif'
        ].join(' ');
        textStyle.font = font;
        var rect = text.getBoundingRect();
        this._textX += rect.width;
        parentGroup.add(text);
        return text;
    };
    SVGParser.internalField = function() {
        $ccaaa4a85c480645$var$nodeParsers = {
            'g': function(xmlNode, parentGroup) {
                var g = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)();
                $ccaaa4a85c480645$var$inheritStyle(parentGroup, g);
                $ccaaa4a85c480645$var$parseAttributes(xmlNode, g, this._defsUsePending, false, false);
                return g;
            },
            'rect': function(xmlNode, parentGroup) {
                var rect = new (0, $419e5ff2f303755e$export$2e2bcd8739ae039)();
                $ccaaa4a85c480645$var$inheritStyle(parentGroup, rect);
                $ccaaa4a85c480645$var$parseAttributes(xmlNode, rect, this._defsUsePending, false, false);
                rect.setShape({
                    x: parseFloat(xmlNode.getAttribute('x') || '0'),
                    y: parseFloat(xmlNode.getAttribute('y') || '0'),
                    width: parseFloat(xmlNode.getAttribute('width') || '0'),
                    height: parseFloat(xmlNode.getAttribute('height') || '0')
                });
                rect.silent = true;
                return rect;
            },
            'circle': function(xmlNode, parentGroup) {
                var circle = new (0, $1e68d8727773abb7$export$2e2bcd8739ae039)();
                $ccaaa4a85c480645$var$inheritStyle(parentGroup, circle);
                $ccaaa4a85c480645$var$parseAttributes(xmlNode, circle, this._defsUsePending, false, false);
                circle.setShape({
                    cx: parseFloat(xmlNode.getAttribute('cx') || '0'),
                    cy: parseFloat(xmlNode.getAttribute('cy') || '0'),
                    r: parseFloat(xmlNode.getAttribute('r') || '0')
                });
                circle.silent = true;
                return circle;
            },
            'line': function(xmlNode, parentGroup) {
                var line = new (0, $7a316ae5ceff7b27$export$2e2bcd8739ae039)();
                $ccaaa4a85c480645$var$inheritStyle(parentGroup, line);
                $ccaaa4a85c480645$var$parseAttributes(xmlNode, line, this._defsUsePending, false, false);
                line.setShape({
                    x1: parseFloat(xmlNode.getAttribute('x1') || '0'),
                    y1: parseFloat(xmlNode.getAttribute('y1') || '0'),
                    x2: parseFloat(xmlNode.getAttribute('x2') || '0'),
                    y2: parseFloat(xmlNode.getAttribute('y2') || '0')
                });
                line.silent = true;
                return line;
            },
            'ellipse': function(xmlNode, parentGroup) {
                var ellipse = new (0, $4a809f055a7e524c$export$2e2bcd8739ae039)();
                $ccaaa4a85c480645$var$inheritStyle(parentGroup, ellipse);
                $ccaaa4a85c480645$var$parseAttributes(xmlNode, ellipse, this._defsUsePending, false, false);
                ellipse.setShape({
                    cx: parseFloat(xmlNode.getAttribute('cx') || '0'),
                    cy: parseFloat(xmlNode.getAttribute('cy') || '0'),
                    rx: parseFloat(xmlNode.getAttribute('rx') || '0'),
                    ry: parseFloat(xmlNode.getAttribute('ry') || '0')
                });
                ellipse.silent = true;
                return ellipse;
            },
            'polygon': function(xmlNode, parentGroup) {
                var pointsStr = xmlNode.getAttribute('points');
                var pointsArr;
                if (pointsStr) pointsArr = $ccaaa4a85c480645$var$parsePoints(pointsStr);
                var polygon = new (0, $51acf033123e1a30$export$2e2bcd8739ae039)({
                    shape: {
                        points: pointsArr || []
                    },
                    silent: true
                });
                $ccaaa4a85c480645$var$inheritStyle(parentGroup, polygon);
                $ccaaa4a85c480645$var$parseAttributes(xmlNode, polygon, this._defsUsePending, false, false);
                return polygon;
            },
            'polyline': function(xmlNode, parentGroup) {
                var pointsStr = xmlNode.getAttribute('points');
                var pointsArr;
                if (pointsStr) pointsArr = $ccaaa4a85c480645$var$parsePoints(pointsStr);
                var polyline = new (0, $d28119f30e6bb670$export$2e2bcd8739ae039)({
                    shape: {
                        points: pointsArr || []
                    },
                    silent: true
                });
                $ccaaa4a85c480645$var$inheritStyle(parentGroup, polyline);
                $ccaaa4a85c480645$var$parseAttributes(xmlNode, polyline, this._defsUsePending, false, false);
                return polyline;
            },
            'image': function(xmlNode, parentGroup) {
                var img = new (0, $86adec94217b86c6$export$2e2bcd8739ae039)();
                $ccaaa4a85c480645$var$inheritStyle(parentGroup, img);
                $ccaaa4a85c480645$var$parseAttributes(xmlNode, img, this._defsUsePending, false, false);
                img.setStyle({
                    image: xmlNode.getAttribute('xlink:href') || xmlNode.getAttribute('href'),
                    x: +xmlNode.getAttribute('x'),
                    y: +xmlNode.getAttribute('y'),
                    width: +xmlNode.getAttribute('width'),
                    height: +xmlNode.getAttribute('height')
                });
                img.silent = true;
                return img;
            },
            'text': function(xmlNode, parentGroup) {
                var x = xmlNode.getAttribute('x') || '0';
                var y = xmlNode.getAttribute('y') || '0';
                var dx = xmlNode.getAttribute('dx') || '0';
                var dy = xmlNode.getAttribute('dy') || '0';
                this._textX = parseFloat(x) + parseFloat(dx);
                this._textY = parseFloat(y) + parseFloat(dy);
                var g = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)();
                $ccaaa4a85c480645$var$inheritStyle(parentGroup, g);
                $ccaaa4a85c480645$var$parseAttributes(xmlNode, g, this._defsUsePending, false, true);
                return g;
            },
            'tspan': function(xmlNode, parentGroup) {
                var x = xmlNode.getAttribute('x');
                var y = xmlNode.getAttribute('y');
                if (x != null) this._textX = parseFloat(x);
                if (y != null) this._textY = parseFloat(y);
                var dx = xmlNode.getAttribute('dx') || '0';
                var dy = xmlNode.getAttribute('dy') || '0';
                var g = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)();
                $ccaaa4a85c480645$var$inheritStyle(parentGroup, g);
                $ccaaa4a85c480645$var$parseAttributes(xmlNode, g, this._defsUsePending, false, true);
                this._textX += parseFloat(dx);
                this._textY += parseFloat(dy);
                return g;
            },
            'path': function(xmlNode, parentGroup) {
                var d = xmlNode.getAttribute('d') || '';
                var path = (0, $15b38920672b9006$export$ae5b259626f00aeb)(d);
                $ccaaa4a85c480645$var$inheritStyle(parentGroup, path);
                $ccaaa4a85c480645$var$parseAttributes(xmlNode, path, this._defsUsePending, false, false);
                path.silent = true;
                return path;
            }
        };
    }();
    return SVGParser;
}();
var $ccaaa4a85c480645$var$paintServerParsers = {
    'lineargradient': function(xmlNode) {
        var x1 = parseInt(xmlNode.getAttribute('x1') || '0', 10);
        var y1 = parseInt(xmlNode.getAttribute('y1') || '0', 10);
        var x2 = parseInt(xmlNode.getAttribute('x2') || '10', 10);
        var y2 = parseInt(xmlNode.getAttribute('y2') || '0', 10);
        var gradient = new (0, $cf44c01491b58e53$export$2e2bcd8739ae039)(x1, y1, x2, y2);
        $ccaaa4a85c480645$var$parsePaintServerUnit(xmlNode, gradient);
        $ccaaa4a85c480645$var$parseGradientColorStops(xmlNode, gradient);
        return gradient;
    },
    'radialgradient': function(xmlNode) {
        var cx = parseInt(xmlNode.getAttribute('cx') || '0', 10);
        var cy = parseInt(xmlNode.getAttribute('cy') || '0', 10);
        var r = parseInt(xmlNode.getAttribute('r') || '0', 10);
        var gradient = new (0, $cd2ee2ba32bb26c3$export$2e2bcd8739ae039)(cx, cy, r);
        $ccaaa4a85c480645$var$parsePaintServerUnit(xmlNode, gradient);
        $ccaaa4a85c480645$var$parseGradientColorStops(xmlNode, gradient);
        return gradient;
    }
};
function $ccaaa4a85c480645$var$parsePaintServerUnit(xmlNode, gradient) {
    var gradientUnits = xmlNode.getAttribute('gradientUnits');
    if (gradientUnits === 'userSpaceOnUse') gradient.global = true;
}
function $ccaaa4a85c480645$var$parseGradientColorStops(xmlNode, gradient) {
    var stop = xmlNode.firstChild;
    while(stop){
        if (stop.nodeType === 1 && stop.nodeName.toLocaleLowerCase() === 'stop') {
            var offsetStr = stop.getAttribute('offset');
            var offset = void 0;
            if (offsetStr && offsetStr.indexOf('%') > 0) offset = parseInt(offsetStr, 10) / 100;
            else if (offsetStr) offset = parseFloat(offsetStr);
            else offset = 0;
            var styleVals = {};
            $ccaaa4a85c480645$var$parseInlineStyle(stop, styleVals, styleVals);
            var stopColor = styleVals.stopColor || stop.getAttribute('stop-color') || '#000000';
            gradient.colorStops.push({
                offset: offset,
                color: stopColor
            });
        }
        stop = stop.nextSibling;
    }
}
function $ccaaa4a85c480645$var$inheritStyle(parent, child) {
    if (parent && parent.__inheritedStyle) {
        if (!child.__inheritedStyle) child.__inheritedStyle = {};
        (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(child.__inheritedStyle, parent.__inheritedStyle);
    }
}
function $ccaaa4a85c480645$var$parsePoints(pointsString) {
    var list = $ccaaa4a85c480645$var$splitNumberSequence(pointsString);
    var points = [];
    for(var i = 0; i < list.length; i += 2){
        var x = parseFloat(list[i]);
        var y = parseFloat(list[i + 1]);
        points.push([
            x,
            y
        ]);
    }
    return points;
}
function $ccaaa4a85c480645$var$parseAttributes(xmlNode, el, defsUsePending, onlyInlineStyle, isTextGroup) {
    var disp = el;
    var inheritedStyle = disp.__inheritedStyle = disp.__inheritedStyle || {};
    var selfStyle = {};
    if (xmlNode.nodeType === 1) {
        $ccaaa4a85c480645$var$parseTransformAttribute(xmlNode, el);
        $ccaaa4a85c480645$var$parseInlineStyle(xmlNode, inheritedStyle, selfStyle);
        if (!onlyInlineStyle) $ccaaa4a85c480645$var$parseAttributeStyle(xmlNode, inheritedStyle, selfStyle);
    }
    disp.style = disp.style || {};
    if (inheritedStyle.fill != null) disp.style.fill = $ccaaa4a85c480645$var$getFillStrokeStyle(disp, 'fill', inheritedStyle.fill, defsUsePending);
    if (inheritedStyle.stroke != null) disp.style.stroke = $ccaaa4a85c480645$var$getFillStrokeStyle(disp, 'stroke', inheritedStyle.stroke, defsUsePending);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
        'lineWidth',
        'opacity',
        'fillOpacity',
        'strokeOpacity',
        'miterLimit',
        'fontSize'
    ], function(propName) {
        if (inheritedStyle[propName] != null) disp.style[propName] = parseFloat(inheritedStyle[propName]);
    });
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
        'lineDashOffset',
        'lineCap',
        'lineJoin',
        'fontWeight',
        'fontFamily',
        'fontStyle',
        'textAlign'
    ], function(propName) {
        if (inheritedStyle[propName] != null) disp.style[propName] = inheritedStyle[propName];
    });
    if (isTextGroup) disp.__selfStyle = selfStyle;
    if (inheritedStyle.lineDash) disp.style.lineDash = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)($ccaaa4a85c480645$var$splitNumberSequence(inheritedStyle.lineDash), function(str) {
        return parseFloat(str);
    });
    if (inheritedStyle.visibility === 'hidden' || inheritedStyle.visibility === 'collapse') disp.invisible = true;
    if (inheritedStyle.display === 'none') disp.ignore = true;
}
function $ccaaa4a85c480645$var$applyTextAlignment(text, parentGroup) {
    var parentSelfStyle = parentGroup.__selfStyle;
    if (parentSelfStyle) {
        var textBaseline = parentSelfStyle.textBaseline;
        var zrTextBaseline = textBaseline;
        if (!textBaseline || textBaseline === 'auto') zrTextBaseline = 'alphabetic';
        else if (textBaseline === 'baseline') zrTextBaseline = 'alphabetic';
        else if (textBaseline === 'before-edge' || textBaseline === 'text-before-edge') zrTextBaseline = 'top';
        else if (textBaseline === 'after-edge' || textBaseline === 'text-after-edge') zrTextBaseline = 'bottom';
        else if (textBaseline === 'central' || textBaseline === 'mathematical') zrTextBaseline = 'middle';
        text.style.textBaseline = zrTextBaseline;
    }
    var parentInheritedStyle = parentGroup.__inheritedStyle;
    if (parentInheritedStyle) {
        var textAlign = parentInheritedStyle.textAlign;
        var zrTextAlign = textAlign;
        if (textAlign) {
            if (textAlign === 'middle') zrTextAlign = 'center';
            text.style.textAlign = zrTextAlign;
        }
    }
}
var $ccaaa4a85c480645$var$urlRegex = /^url\(\s*#(.*?)\)/;
function $ccaaa4a85c480645$var$getFillStrokeStyle(el, method, str, defsUsePending) {
    var urlMatch = str && str.match($ccaaa4a85c480645$var$urlRegex);
    if (urlMatch) {
        var url = (0, $7a1bd9c2710fea0d$export$87c2784dc9fc4ab)(urlMatch[1]);
        defsUsePending.push([
            el,
            method,
            url
        ]);
        return;
    }
    if (str === 'none') str = null;
    return str;
}
function $ccaaa4a85c480645$var$applyDefs(defs, defsUsePending) {
    for(var i = 0; i < defsUsePending.length; i++){
        var item = defsUsePending[i];
        item[0].style[item[1]] = defs[item[2]];
    }
}
var $ccaaa4a85c480645$var$numberReg = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g;
function $ccaaa4a85c480645$var$splitNumberSequence(rawStr) {
    return rawStr.match($ccaaa4a85c480645$var$numberReg) || [];
}
var $ccaaa4a85c480645$var$transformRegex = /(translate|scale|rotate|skewX|skewY|matrix)\(([\-\s0-9\.eE,]*)\)/g;
var $ccaaa4a85c480645$var$DEGREE_TO_ANGLE = Math.PI / 180;
function $ccaaa4a85c480645$var$parseTransformAttribute(xmlNode, node) {
    var transform = xmlNode.getAttribute('transform');
    if (transform) {
        transform = transform.replace(/,/g, ' ');
        var transformOps_1 = [];
        var mt = null;
        transform.replace($ccaaa4a85c480645$var$transformRegex, function(str, type, value) {
            transformOps_1.push(type, value);
            return '';
        });
        for(var i = transformOps_1.length - 1; i > 0; i -= 2){
            var value = transformOps_1[i];
            var type = transformOps_1[i - 1];
            var valueArr = $ccaaa4a85c480645$var$splitNumberSequence(value);
            mt = mt || $f41ebb9dd60b55b4$export$185802fd694ee1f5();
            switch(type){
                case 'translate':
                    $f41ebb9dd60b55b4$export$d73ee8ef04f5226a(mt, mt, [
                        parseFloat(valueArr[0]),
                        parseFloat(valueArr[1] || '0')
                    ]);
                    break;
                case 'scale':
                    $f41ebb9dd60b55b4$export$dcdf75081b88279d(mt, mt, [
                        parseFloat(valueArr[0]),
                        parseFloat(valueArr[1] || valueArr[0])
                    ]);
                    break;
                case 'rotate':
                    $f41ebb9dd60b55b4$export$bb628a54ab399bc9(mt, mt, -parseFloat(valueArr[0]) * $ccaaa4a85c480645$var$DEGREE_TO_ANGLE, [
                        parseFloat(valueArr[1] || '0'),
                        parseFloat(valueArr[2] || '0')
                    ]);
                    break;
                case 'skewX':
                    var sx = Math.tan(parseFloat(valueArr[0]) * $ccaaa4a85c480645$var$DEGREE_TO_ANGLE);
                    $f41ebb9dd60b55b4$export$6e3a27864ab166fe(mt, [
                        1,
                        0,
                        sx,
                        1,
                        0,
                        0
                    ], mt);
                    break;
                case 'skewY':
                    var sy = Math.tan(parseFloat(valueArr[0]) * $ccaaa4a85c480645$var$DEGREE_TO_ANGLE);
                    $f41ebb9dd60b55b4$export$6e3a27864ab166fe(mt, [
                        1,
                        sy,
                        0,
                        1,
                        0,
                        0
                    ], mt);
                    break;
                case 'matrix':
                    mt[0] = parseFloat(valueArr[0]);
                    mt[1] = parseFloat(valueArr[1]);
                    mt[2] = parseFloat(valueArr[2]);
                    mt[3] = parseFloat(valueArr[3]);
                    mt[4] = parseFloat(valueArr[4]);
                    mt[5] = parseFloat(valueArr[5]);
                    break;
            }
        }
        node.setLocalTransform(mt);
    }
}
var $ccaaa4a85c480645$var$styleRegex = /([^\s:;]+)\s*:\s*([^:;]+)/g;
function $ccaaa4a85c480645$var$parseInlineStyle(xmlNode, inheritableStyleResult, selfStyleResult) {
    var style = xmlNode.getAttribute('style');
    if (!style) return;
    $ccaaa4a85c480645$var$styleRegex.lastIndex = 0;
    var styleRegResult;
    while((styleRegResult = $ccaaa4a85c480645$var$styleRegex.exec(style)) != null){
        var svgStlAttr = styleRegResult[1];
        var zrInheritableStlAttr = (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)($ccaaa4a85c480645$var$INHERITABLE_STYLE_ATTRIBUTES_MAP, svgStlAttr) ? $ccaaa4a85c480645$var$INHERITABLE_STYLE_ATTRIBUTES_MAP[svgStlAttr] : null;
        if (zrInheritableStlAttr) inheritableStyleResult[zrInheritableStlAttr] = styleRegResult[2];
        var zrSelfStlAttr = (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)($ccaaa4a85c480645$var$SELF_STYLE_ATTRIBUTES_MAP, svgStlAttr) ? $ccaaa4a85c480645$var$SELF_STYLE_ATTRIBUTES_MAP[svgStlAttr] : null;
        if (zrSelfStlAttr) selfStyleResult[zrSelfStlAttr] = styleRegResult[2];
    }
}
function $ccaaa4a85c480645$var$parseAttributeStyle(xmlNode, inheritableStyleResult, selfStyleResult) {
    for(var i = 0; i < $ccaaa4a85c480645$var$INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS.length; i++){
        var svgAttrName = $ccaaa4a85c480645$var$INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS[i];
        var attrValue = xmlNode.getAttribute(svgAttrName);
        if (attrValue != null) inheritableStyleResult[$ccaaa4a85c480645$var$INHERITABLE_STYLE_ATTRIBUTES_MAP[svgAttrName]] = attrValue;
    }
    for(var i = 0; i < $ccaaa4a85c480645$var$SELF_STYLE_ATTRIBUTES_MAP_KEYS.length; i++){
        var svgAttrName = $ccaaa4a85c480645$var$SELF_STYLE_ATTRIBUTES_MAP_KEYS[i];
        var attrValue = xmlNode.getAttribute(svgAttrName);
        if (attrValue != null) selfStyleResult[$ccaaa4a85c480645$var$SELF_STYLE_ATTRIBUTES_MAP[svgAttrName]] = attrValue;
    }
}
function $ccaaa4a85c480645$export$3e2db4420f14f50f(viewBoxRect, boundingRect) {
    var scaleX = boundingRect.width / viewBoxRect.width;
    var scaleY = boundingRect.height / viewBoxRect.height;
    var scale = Math.min(scaleX, scaleY);
    return {
        scale: scale,
        x: -(viewBoxRect.x + viewBoxRect.width / 2) * scale + (boundingRect.x + boundingRect.width / 2),
        y: -(viewBoxRect.y + viewBoxRect.height / 2) * scale + (boundingRect.y + boundingRect.height / 2)
    };
}
function $ccaaa4a85c480645$export$1919f5101c220601(xml, opt) {
    var parser = new $ccaaa4a85c480645$var$SVGParser();
    return parser.parse(xml, opt);
}







/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $b4726ec5f917394d$var$EPSILON = 1e-8;
function $b4726ec5f917394d$var$isAroundEqual(a, b) {
    return Math.abs(a - b) < $b4726ec5f917394d$var$EPSILON;
}
function $b4726ec5f917394d$export$8893e2b90ba10d92(points, x, y) {
    var w = 0;
    var p = points[0];
    if (!p) return false;
    for(var i = 1; i < points.length; i++){
        var p2 = points[i];
        w += (0, $e1acc0b10546155f$export$2e2bcd8739ae039)(p[0], p[1], p2[0], p2[1], x, y);
        p = p2;
    }
    var p0 = points[0];
    if (!$b4726ec5f917394d$var$isAroundEqual(p[0], p0[0]) || !$b4726ec5f917394d$var$isAroundEqual(p[1], p0[1])) w += (0, $e1acc0b10546155f$export$2e2bcd8739ae039)(p[0], p[1], p0[0], p0[1], x, y);
    return w !== 0;
}




var $00e94d08c93517b6$var$TMP_TRANSFORM = [];
function $00e94d08c93517b6$var$transformPoints(points, transform) {
    for(var p = 0; p < points.length; p++)$6de594cf8ac295ff$export$9f9dcb98c894b623(points[p], points[p], transform);
}
function $00e94d08c93517b6$var$updateBBoxFromPoints(points, min, max, projection) {
    for(var i = 0; i < points.length; i++){
        var p = points[i];
        if (projection) // projection may return null point.
        p = projection.project(p);
        if (p && isFinite(p[0]) && isFinite(p[1])) {
            $6de594cf8ac295ff$export$96ec731ed4dcb222(min, min, p);
            $6de594cf8ac295ff$export$8960430cfd85939f(max, max, p);
        }
    }
}
function $00e94d08c93517b6$var$centroid(points) {
    var signedArea = 0;
    var cx = 0;
    var cy = 0;
    var len = points.length;
    var x0 = points[len - 1][0];
    var y0 = points[len - 1][1];
    // Polygon should been closed.
    for(var i = 0; i < len; i++){
        var x1 = points[i][0];
        var y1 = points[i][1];
        var a = x0 * y1 - x1 * y0;
        signedArea += a;
        cx += (x0 + x1) * a;
        cy += (y0 + y1) * a;
        x0 = x1;
        y0 = y1;
    }
    return signedArea ? [
        cx / signedArea / 3,
        cy / signedArea / 3,
        signedArea
    ] : [
        points[0][0] || 0,
        points[0][1] || 0
    ];
}
var $00e94d08c93517b6$export$b1f97c3099fc6872 = /** @class */ function() {
    function Region(name) {
        this.name = name;
    }
    Region.prototype.setCenter = function(center) {
        this._center = center;
    };
    /**
   * Get center point in data unit. That is,
   * for GeoJSONRegion, the unit is lat/lng,
   * for GeoSVGRegion, the unit is SVG local coord.
   */ Region.prototype.getCenter = function() {
        var center = this._center;
        if (!center) // In most cases there are no need to calculate this center.
        // So calculate only when called.
        center = this._center = this.calcCenter();
        return center;
    };
    return Region;
}();
var $00e94d08c93517b6$export$91e20b0f72443753 = /** @class */ function() {
    function GeoJSONPolygonGeometry(exterior, interiors) {
        this.type = 'polygon';
        this.exterior = exterior;
        this.interiors = interiors;
    }
    return GeoJSONPolygonGeometry;
}();
var $00e94d08c93517b6$export$335807c9e785d92c = /** @class */ function() {
    function GeoJSONLineStringGeometry(points) {
        this.type = 'linestring';
        this.points = points;
    }
    return GeoJSONLineStringGeometry;
}();
var $00e94d08c93517b6$export$ee84fcb463f24b3d = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(GeoJSONRegion, _super);
    function GeoJSONRegion(name, geometries, cp) {
        var _this = _super.call(this, name) || this;
        _this.type = 'geoJSON';
        _this.geometries = geometries;
        _this._center = cp && [
            cp[0],
            cp[1]
        ];
        return _this;
    }
    GeoJSONRegion.prototype.calcCenter = function() {
        var geometries = this.geometries;
        var largestGeo;
        var largestGeoSize = 0;
        for(var i = 0; i < geometries.length; i++){
            var geo = geometries[i];
            var exterior = geo.exterior;
            // Simple trick to use points count instead of polygon area as region size.
            // Ignore linestring
            var size = exterior && exterior.length;
            if (size > largestGeoSize) {
                largestGeo = geo;
                largestGeoSize = size;
            }
        }
        if (largestGeo) return $00e94d08c93517b6$var$centroid(largestGeo.exterior);
        // from bounding rect by default.
        var rect = this.getBoundingRect();
        return [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
    };
    GeoJSONRegion.prototype.getBoundingRect = function(projection) {
        var rect = this._rect;
        // Always recalculate if using projection.
        if (rect && !projection) return rect;
        var min = [
            Infinity,
            Infinity
        ];
        var max = [
            -Infinity,
            -Infinity
        ];
        var geometries = this.geometries;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(geometries, function(geo) {
            if (geo.type === 'polygon') // Doesn't consider hole
            $00e94d08c93517b6$var$updateBBoxFromPoints(geo.exterior, min, max, projection);
            else (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(geo.points, function(points) {
                $00e94d08c93517b6$var$updateBBoxFromPoints(points, min, max, projection);
            });
        });
        // Normalie invalid bounding.
        if (!(isFinite(min[0]) && isFinite(min[1]) && isFinite(max[0]) && isFinite(max[1]))) min[0] = min[1] = max[0] = max[1] = 0;
        rect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(min[0], min[1], max[0] - min[0], max[1] - min[1]);
        if (!projection) this._rect = rect;
        return rect;
    };
    GeoJSONRegion.prototype.contain = function(coord) {
        var rect = this.getBoundingRect();
        var geometries = this.geometries;
        if (!rect.contain(coord[0], coord[1])) return false;
        loopGeo: for(var i = 0, len = geometries.length; i < len; i++){
            var geo = geometries[i];
            // Only support polygon.
            if (geo.type !== 'polygon') continue;
            var exterior = geo.exterior;
            var interiors = geo.interiors;
            if ($b4726ec5f917394d$export$8893e2b90ba10d92(exterior, coord[0], coord[1])) {
                // Not in the region if point is in the hole.
                for(var k = 0; k < (interiors ? interiors.length : 0); k++){
                    if ($b4726ec5f917394d$export$8893e2b90ba10d92(interiors[k], coord[0], coord[1])) continue loopGeo;
                }
                return true;
            }
        }
        return false;
    };
    /**
   * Transform the raw coords to target bounding.
   * @param x
   * @param y
   * @param width
   * @param height
   */ GeoJSONRegion.prototype.transformTo = function(x, y, width, height) {
        var rect = this.getBoundingRect();
        var aspect = rect.width / rect.height;
        if (!width) width = aspect * height;
        else if (!height) height = width / aspect;
        var target = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(x, y, width, height);
        var transform = rect.calculateTransform(target);
        var geometries = this.geometries;
        for(var i = 0; i < geometries.length; i++){
            var geo = geometries[i];
            if (geo.type === 'polygon') {
                $00e94d08c93517b6$var$transformPoints(geo.exterior, transform);
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(geo.interiors, function(interior) {
                    $00e94d08c93517b6$var$transformPoints(interior, transform);
                });
            } else (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(geo.points, function(points) {
                $00e94d08c93517b6$var$transformPoints(points, transform);
            });
        }
        rect = this._rect;
        rect.copy(target);
        // Update center
        this._center = [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
    };
    GeoJSONRegion.prototype.cloneShallow = function(name) {
        name == null && (name = this.name);
        var newRegion = new GeoJSONRegion(name, this.geometries, this._center);
        newRegion._rect = this._rect;
        newRegion.transformTo = null; // Simply avoid to be called.
        return newRegion;
    };
    return GeoJSONRegion;
}($00e94d08c93517b6$export$b1f97c3099fc6872);
var $00e94d08c93517b6$export$5f3d89e7254f3e69 = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(GeoSVGRegion, _super);
    function GeoSVGRegion(name, elOnlyForCalculate) {
        var _this = _super.call(this, name) || this;
        _this.type = 'geoSVG';
        _this._elOnlyForCalculate = elOnlyForCalculate;
        return _this;
    }
    GeoSVGRegion.prototype.calcCenter = function() {
        var el = this._elOnlyForCalculate;
        var rect = el.getBoundingRect();
        var center = [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
        var mat = $f41ebb9dd60b55b4$export$f0954fd7d5368655($00e94d08c93517b6$var$TMP_TRANSFORM);
        var target = el;
        while(target && !target.isGeoSVGGraphicRoot){
            $f41ebb9dd60b55b4$export$6e3a27864ab166fe(mat, target.getLocalTransform(), mat);
            target = target.parent;
        }
        $f41ebb9dd60b55b4$export$6897c284b6f9f4dc(mat, mat);
        $6de594cf8ac295ff$export$9f9dcb98c894b623(center, center, mat);
        return center;
    };
    return GeoSVGRegion;
}($00e94d08c93517b6$export$b1f97c3099fc6872);


/**
 * "region available" means that: enable users to set attribute `name="xxx"` on those tags
 * to make it be a region.
 * 1. region styles and its label styles can be defined in echarts opton:
 * ```js
 * geo: {
 *     regions: [{
 *         name: 'xxx',
 *         itemStyle: { ... },
 *         label: { ... }
 *     }, {
 *         ...
 *     },
 *     ...]
 * };
 * ```
 * 2. name can be duplicated in different SVG tag. All of the tags with the same name share
 * a region option. For exampel if there are two <path> representing two lung lobes. They have
 * no common parents but both of them need to display label "lung" inside.
 */ var $decc9bf1380d61c0$var$REGION_AVAILABLE_SVG_TAG_MAP = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)([
    'rect',
    'circle',
    'line',
    'ellipse',
    'polygon',
    'polyline',
    'path',
    // <text> <tspan> are also enabled because some SVG might paint text itself,
    // but still need to trigger events or tooltip.
    'text',
    'tspan',
    // <g> is also enabled because this case: if multiple tags share one name
    // and need label displayed, every tags will display the name, which is not
    // expected. So we can put them into a <g name="xxx">. Thereby only one label
    // displayed and located based on the bounding rect of the <g>.
    'g'
]);
var $decc9bf1380d61c0$export$be52c950efae1f84 = /** @class */ function() {
    function GeoSVGResource(mapName, svg) {
        this.type = 'geoSVG';
        // All used graphics. key: hostKey, value: root
        this._usedGraphicMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        // All unused graphics.
        this._freedGraphics = [];
        this._mapName = mapName;
        // Only perform parse to XML object here, which might be time
        // consiming for large SVG.
        // Although convert XML to zrender element is also time consiming,
        // if we do it here, the clone of zrender elements has to be
        // required. So we do it once for each geo instance, util real
        // performance issues call for optimizing it.
        this._parsedXML = (0, $6d3db85dae3a1192$export$eacefc55fad2867e)(svg);
    }
    GeoSVGResource.prototype.load = function() {
        // In the "load" stage, graphic need to be built to
        // get boundingRect for geo coordinate system.
        var firstGraphic = this._firstGraphic;
        // Create the return data structure only when first graphic created.
        // Because they will be used in geo coordinate system update stage,
        // and `regions` will be mounted at `geo` coordinate system,
        // in which there is no "view" info, so that it should better not to
        // make references to graphic elements.
        if (!firstGraphic) {
            firstGraphic = this._firstGraphic = this._buildGraphic(this._parsedXML);
            this._freedGraphics.push(firstGraphic);
            this._boundingRect = this._firstGraphic.boundingRect.clone();
            // PENDING: `nameMap` will not be supported until some real requirement come.
            // if (nameMap) {
            //     named = applyNameMap(named, nameMap);
            // }
            var _a = $decc9bf1380d61c0$var$createRegions(firstGraphic.named), regions = _a.regions, regionsMap = _a.regionsMap;
            this._regions = regions;
            this._regionsMap = regionsMap;
        }
        return {
            boundingRect: this._boundingRect,
            regions: this._regions,
            regionsMap: this._regionsMap
        };
    };
    GeoSVGResource.prototype._buildGraphic = function(svgXML) {
        var result;
        var rootFromParse;
        try {
            result = svgXML && (0, $ccaaa4a85c480645$export$1919f5101c220601)(svgXML, {
                ignoreViewBox: true,
                ignoreRootClip: true
            }) || {};
            rootFromParse = result.root;
            (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)(rootFromParse != null);
        } catch (e) {
            throw new Error('Invalid svg format\n' + e.message);
        }
        // Note: we keep the covenant that the root has no transform. So always add an extra root.
        var root = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)();
        root.add(rootFromParse);
        root.isGeoSVGGraphicRoot = true;
        // [THE_RULE_OF_VIEWPORT_AND_VIEWBOX]
        //
        // Consider: `<svg width="..." height="..." viewBox="...">`
        // - the `width/height` we call it `svgWidth/svgHeight` for short.
        // - `(0, 0, svgWidth, svgHeight)` defines the viewport of the SVG, or say,
        //   "viewport boundingRect", or `boundingRect` for short.
        // - `viewBox` defines the transform from the real content ot the viewport.
        //   `viewBox` has the same unit as the content of SVG.
        //   If `viewBox` exists, a transform is defined, so the unit of `svgWidth/svgHeight` become
        //   different from the content of SVG. Otherwise, they are the same.
        //
        // If both `svgWidth/svgHeight/viewBox` are specified in a SVG file, the transform rule will be:
        // 0. `boundingRect` is `(0, 0, svgWidth, svgHeight)`. Set it to Geo['_rect'] (View['_rect']).
        // 1. Make a transform from `viewBox` to `boundingRect`.
        //    Note: only support `preserveAspectRatio 'xMidYMid'` here. That is, this transform will preserve
        //    the aspect ratio.
        // 2. Make a transform from boundingRect to Geo['_viewRect'] (View['_viewRect'])
        //    (`Geo`/`View` will do this job).
        //    Note: this transform might not preserve aspect radio, which depending on how users specify
        //    viewRect in echarts option (e.g., `geo.left/top/width/height` will not preserve aspect ratio,
        //    but `geo.layoutCenter/layoutSize` will preserve aspect ratio).
        //
        // If `svgWidth/svgHeight` not specified, we use `viewBox` as the `boundingRect` to make the SVG
        // layout look good.
        //
        // If neither `svgWidth/svgHeight` nor `viewBox` are not specified, we calculate the boundingRect
        // of the SVG content and use them to make SVG layout look good.
        var svgWidth = result.width;
        var svgHeight = result.height;
        var viewBoxRect = result.viewBoxRect;
        var boundingRect = this._boundingRect;
        if (!boundingRect) {
            var bRectX = void 0;
            var bRectY = void 0;
            var bRectWidth = void 0;
            var bRectHeight = void 0;
            if (svgWidth != null) {
                bRectX = 0;
                bRectWidth = svgWidth;
            } else if (viewBoxRect) {
                bRectX = viewBoxRect.x;
                bRectWidth = viewBoxRect.width;
            }
            if (svgHeight != null) {
                bRectY = 0;
                bRectHeight = svgHeight;
            } else if (viewBoxRect) {
                bRectY = viewBoxRect.y;
                bRectHeight = viewBoxRect.height;
            }
            // If both viewBox and svgWidth/svgHeight not specified,
            // we have to determine how to layout those element to make them look good.
            if (bRectX == null || bRectY == null) {
                var calculatedBoundingRect = rootFromParse.getBoundingRect();
                if (bRectX == null) {
                    bRectX = calculatedBoundingRect.x;
                    bRectWidth = calculatedBoundingRect.width;
                }
                if (bRectY == null) {
                    bRectY = calculatedBoundingRect.y;
                    bRectHeight = calculatedBoundingRect.height;
                }
            }
            boundingRect = this._boundingRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(bRectX, bRectY, bRectWidth, bRectHeight);
        }
        if (viewBoxRect) {
            var viewBoxTransform = (0, $ccaaa4a85c480645$export$3e2db4420f14f50f)(viewBoxRect, boundingRect);
            // Only support `preserveAspectRatio 'xMidYMid'`
            rootFromParse.scaleX = rootFromParse.scaleY = viewBoxTransform.scale;
            rootFromParse.x = viewBoxTransform.x;
            rootFromParse.y = viewBoxTransform.y;
        }
        // SVG needs to clip based on `viewBox`. And some SVG files really rely on this feature.
        // They do not strictly confine all of the content inside a display rect, but deliberately
        // use a `viewBox` to define a displayable rect.
        // PENDING:
        // The drawback of the `setClipPath` here is: the region label (genereted by echarts) near the
        // edge might also be clipped, because region labels are put as `textContent` of the SVG path.
        root.setClipPath(new (0, $419e5ff2f303755e$export$2e2bcd8739ae039)({
            shape: boundingRect.plain()
        }));
        var named = [];
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(result.named, function(namedItem) {
            if ($decc9bf1380d61c0$var$REGION_AVAILABLE_SVG_TAG_MAP.get(namedItem.svgNodeTagLower) != null) {
                named.push(namedItem);
                $decc9bf1380d61c0$var$setSilent(namedItem.el);
            }
        });
        return {
            root: root,
            boundingRect: boundingRect,
            named: named
        };
    };
    /**
   * Consider:
   * (1) One graphic element can not be shared by different `geoView` running simultaneously.
   *     Notice, also need to consider multiple echarts instances share a `mapRecord`.
   * (2) Converting SVG to graphic elements is time consuming.
   * (3) In the current architecture, `load` should be called frequently to get boundingRect,
   *     and it is called without view info.
   * So we maintain graphic elements in this module, and enables `view` to use/return these
   * graphics from/to the pool with it's uid.
   */ GeoSVGResource.prototype.useGraphic = function(hostKey /* , nameMap: NameMap */ ) {
        var usedRootMap = this._usedGraphicMap;
        var svgGraphic = usedRootMap.get(hostKey);
        if (svgGraphic) return svgGraphic;
        svgGraphic = this._freedGraphics.pop() || this._buildGraphic(this._parsedXML);
        usedRootMap.set(hostKey, svgGraphic);
        // PENDING: `nameMap` will not be supported until some real requirement come.
        // `nameMap` can only be obtained from echarts option.
        // The original `named` must not be modified.
        // if (nameMap) {
        //     svgGraphic = extend({}, svgGraphic);
        //     svgGraphic.named = applyNameMap(svgGraphic.named, nameMap);
        // }
        return svgGraphic;
    };
    GeoSVGResource.prototype.freeGraphic = function(hostKey) {
        var usedRootMap = this._usedGraphicMap;
        var svgGraphic = usedRootMap.get(hostKey);
        if (svgGraphic) {
            usedRootMap.removeKey(hostKey);
            this._freedGraphics.push(svgGraphic);
        }
    };
    return GeoSVGResource;
}();
function $decc9bf1380d61c0$var$setSilent(el) {
    // Only named element has silent: false, other elements should
    // act as background and has no user interaction.
    el.silent = false;
    // text|tspan will be converted to group.
    if (el.isGroup) el.traverse(function(child) {
        child.silent = false;
    });
}
function $decc9bf1380d61c0$var$createRegions(named) {
    var regions = [];
    var regionsMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    // Create resions only for the first graphic.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(named, function(namedItem) {
        // Region has feature to calculate center for tooltip or other features.
        // If there is a <g name="xxx">, the center should be the center of the
        // bounding rect of the g.
        if (namedItem.namedFrom != null) return;
        var region = new (0, $00e94d08c93517b6$export$5f3d89e7254f3e69)(namedItem.name, namedItem.el);
        // PENDING: if `nameMap` supported, this region can not be mounted on
        // `this`, but can only be created each time `load()` called.
        regions.push(region);
        // PENDING: if multiple tag named with the same name, only one will be
        // found by `_regionsMap`. `_regionsMap` is used to find a coordinate
        // by name. We use `region.getCenter()` as the coordinate.
        regionsMap.set(namedItem.name, region);
    });
    return {
        regions: regions,
        regionsMap: regionsMap
    };
} // PENDING: `nameMap` will not be supported until some real requirement come.
 // /**
 //  * Use the alias in geoNameMap.
 //  * The input `named` must not be modified.
 //  */
 // function applyNameMap(
 //     named: GeoSVGGraphicRecord['named'],
 //     nameMap: NameMap
 // ): GeoSVGGraphicRecord['named'] {
 //     const result = [] as GeoSVGGraphicRecord['named'];
 //     for (let i = 0; i < named.length; i++) {
 //         let regionGraphic = named[i];
 //         const name = regionGraphic.name;
 //         if (nameMap && nameMap.hasOwnProperty(name)) {
 //             regionGraphic = extend({}, regionGraphic);
 //             regionGraphic.name = name;
 //         }
 //         result.push(regionGraphic);
 //     }
 //     return result;
 // }


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Parse and decode geo json
 */ 

function $1a1de70a2b6a5dc5$var$decode(json) {
    if (!json.UTF8Encoding) return json;
    var jsonCompressed = json;
    var encodeScale = jsonCompressed.UTF8Scale;
    if (encodeScale == null) encodeScale = 1024;
    var features = jsonCompressed.features;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(features, function(feature) {
        var geometry = feature.geometry;
        var encodeOffsets = geometry.encodeOffsets;
        var coordinates = geometry.coordinates;
        // Geometry may be appeded manually in the script after json loaded.
        // In this case this geometry is usually not encoded.
        if (!encodeOffsets) return;
        switch(geometry.type){
            case 'LineString':
                geometry.coordinates = $1a1de70a2b6a5dc5$var$decodeRing(coordinates, encodeOffsets, encodeScale);
                break;
            case 'Polygon':
                $1a1de70a2b6a5dc5$var$decodeRings(coordinates, encodeOffsets, encodeScale);
                break;
            case 'MultiLineString':
                $1a1de70a2b6a5dc5$var$decodeRings(coordinates, encodeOffsets, encodeScale);
                break;
            case 'MultiPolygon':
                $7a1bd9c2710fea0d$export$79b2f7037acddd43(coordinates, function(rings, idx) {
                    return $1a1de70a2b6a5dc5$var$decodeRings(rings, encodeOffsets[idx], encodeScale);
                });
        }
    });
    // Has been decoded
    jsonCompressed.UTF8Encoding = false;
    return jsonCompressed;
}
function $1a1de70a2b6a5dc5$var$decodeRings(rings, encodeOffsets, encodeScale) {
    for(var c = 0; c < rings.length; c++)rings[c] = $1a1de70a2b6a5dc5$var$decodeRing(rings[c], encodeOffsets[c], encodeScale);
}
function $1a1de70a2b6a5dc5$var$decodeRing(coordinate, encodeOffsets, encodeScale) {
    var result = [];
    var prevX = encodeOffsets[0];
    var prevY = encodeOffsets[1];
    for(var i = 0; i < coordinate.length; i += 2){
        var x = coordinate.charCodeAt(i) - 64;
        var y = coordinate.charCodeAt(i + 1) - 64;
        // ZigZag decoding
        x = x >> 1 ^ -(x & 1);
        y = y >> 1 ^ -(y & 1);
        // Delta deocding
        x += prevX;
        y += prevY;
        prevX = x;
        prevY = y;
        // Dequantize
        result.push([
            x / encodeScale,
            y / encodeScale
        ]);
    }
    return result;
}
function $1a1de70a2b6a5dc5$export$2e2bcd8739ae039(geoJson, nameProperty) {
    geoJson = $1a1de70a2b6a5dc5$var$decode(geoJson);
    return $7a1bd9c2710fea0d$export$871de8747c9eaa88($7a1bd9c2710fea0d$export$3dea766d36a8935f(geoJson.features, function(featureObj) {
        // Output of mapshaper may have geometry null
        return featureObj.geometry && featureObj.properties && featureObj.geometry.coordinates.length > 0;
    }), function(featureObj) {
        var properties = featureObj.properties;
        var geo = featureObj.geometry;
        var geometries = [];
        switch(geo.type){
            case 'Polygon':
                var coordinates = geo.coordinates;
                // According to the GeoJSON specification.
                // First must be exterior, and the rest are all interior(holes).
                geometries.push(new (0, $00e94d08c93517b6$export$91e20b0f72443753)(coordinates[0], coordinates.slice(1)));
                break;
            case 'MultiPolygon':
                $7a1bd9c2710fea0d$export$79b2f7037acddd43(geo.coordinates, function(item) {
                    if (item[0]) geometries.push(new (0, $00e94d08c93517b6$export$91e20b0f72443753)(item[0], item.slice(1)));
                });
                break;
            case 'LineString':
                geometries.push(new (0, $00e94d08c93517b6$export$335807c9e785d92c)([
                    geo.coordinates
                ]));
                break;
            case 'MultiLineString':
                geometries.push(new (0, $00e94d08c93517b6$export$335807c9e785d92c)(geo.coordinates));
        }
        var region = new (0, $00e94d08c93517b6$export$ee84fcb463f24b3d)(properties[nameProperty || 'name'], geometries, properties.cp);
        region.properties = properties;
        return region;
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Fix for 南海诸岛


var $616ae7a19aad52f4$var$geoCoord = [
    126,
    25
];
var $616ae7a19aad52f4$var$nanhaiName = "\u5357\u6D77\u8BF8\u5C9B";
var $616ae7a19aad52f4$var$points = [
    [
        [
            0,
            3.5
        ],
        [
            7,
            11.2
        ],
        [
            15,
            11.9
        ],
        [
            30,
            7
        ],
        [
            42,
            0.7
        ],
        [
            52,
            0.7
        ],
        [
            56,
            7.7
        ],
        [
            59,
            0.7
        ],
        [
            64,
            0.7
        ],
        [
            64,
            0
        ],
        [
            5,
            0
        ],
        [
            0,
            3.5
        ]
    ],
    [
        [
            13,
            16.1
        ],
        [
            19,
            14.7
        ],
        [
            16,
            21.7
        ],
        [
            11,
            23.1
        ],
        [
            13,
            16.1
        ]
    ],
    [
        [
            12,
            32.2
        ],
        [
            14,
            38.5
        ],
        [
            15,
            38.5
        ],
        [
            13,
            32.2
        ],
        [
            12,
            32.2
        ]
    ],
    [
        [
            16,
            47.6
        ],
        [
            12,
            53.2
        ],
        [
            13,
            53.2
        ],
        [
            18,
            47.6
        ],
        [
            16,
            47.6
        ]
    ],
    [
        [
            6,
            64.4
        ],
        [
            8,
            70
        ],
        [
            9,
            70
        ],
        [
            8,
            64.4
        ],
        [
            6,
            64.4
        ]
    ],
    [
        [
            23,
            82.6
        ],
        [
            29,
            79.8
        ],
        [
            30,
            79.8
        ],
        [
            25,
            82.6
        ],
        [
            23,
            82.6
        ]
    ],
    [
        [
            37,
            70.7
        ],
        [
            43,
            62.3
        ],
        [
            44,
            62.3
        ],
        [
            39,
            70.7
        ],
        [
            37,
            70.7
        ]
    ],
    [
        [
            48,
            51.1
        ],
        [
            51,
            45.5
        ],
        [
            53,
            45.5
        ],
        [
            50,
            51.1
        ],
        [
            48,
            51.1
        ]
    ],
    [
        [
            51,
            35
        ],
        [
            51,
            28.7
        ],
        [
            53,
            28.7
        ],
        [
            53,
            35
        ],
        [
            51,
            35
        ]
    ],
    [
        [
            52,
            22.4
        ],
        [
            55,
            17.5
        ],
        [
            56,
            17.5
        ],
        [
            53,
            22.4
        ],
        [
            52,
            22.4
        ]
    ],
    [
        [
            58,
            12.6
        ],
        [
            62,
            7
        ],
        [
            63,
            7
        ],
        [
            60,
            12.6
        ],
        [
            58,
            12.6
        ]
    ],
    [
        [
            0,
            3.5
        ],
        [
            0,
            93.1
        ],
        [
            64,
            93.1
        ],
        [
            64,
            0
        ],
        [
            63,
            0
        ],
        [
            63,
            92.4
        ],
        [
            1,
            92.4
        ],
        [
            1,
            3.5
        ],
        [
            0,
            3.5
        ]
    ]
];
for(var $616ae7a19aad52f4$var$i = 0; $616ae7a19aad52f4$var$i < $616ae7a19aad52f4$var$points.length; $616ae7a19aad52f4$var$i++)for(var $616ae7a19aad52f4$var$k = 0; $616ae7a19aad52f4$var$k < $616ae7a19aad52f4$var$points[$616ae7a19aad52f4$var$i].length; $616ae7a19aad52f4$var$k++){
    $616ae7a19aad52f4$var$points[$616ae7a19aad52f4$var$i][$616ae7a19aad52f4$var$k][0] /= 10.5;
    $616ae7a19aad52f4$var$points[$616ae7a19aad52f4$var$i][$616ae7a19aad52f4$var$k][1] /= -14;
    $616ae7a19aad52f4$var$points[$616ae7a19aad52f4$var$i][$616ae7a19aad52f4$var$k][0] += $616ae7a19aad52f4$var$geoCoord[0];
    $616ae7a19aad52f4$var$points[$616ae7a19aad52f4$var$i][$616ae7a19aad52f4$var$k][1] += $616ae7a19aad52f4$var$geoCoord[1];
}
function $616ae7a19aad52f4$export$2e2bcd8739ae039(mapType, regions) {
    if (mapType === 'china') {
        for(var i = 0; i < regions.length; i++){
            // Already exists.
            if (regions[i].name === $616ae7a19aad52f4$var$nanhaiName) return;
        }
        regions.push(new (0, $00e94d08c93517b6$export$ee84fcb463f24b3d)($616ae7a19aad52f4$var$nanhaiName, $7a1bd9c2710fea0d$export$871de8747c9eaa88($616ae7a19aad52f4$var$points, function(exterior) {
            return {
                type: 'polygon',
                exterior: exterior
            };
        }), $616ae7a19aad52f4$var$geoCoord));
    }
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $280c32529827bd03$var$coordsOffsetMap = {
    "\u5357\u6D77\u8BF8\u5C9B": [
        32,
        80
    ],
    // 全国
    "\u5E7F\u4E1C": [
        0,
        -10
    ],
    "\u9999\u6E2F": [
        10,
        5
    ],
    "\u6FB3\u95E8": [
        -10,
        10
    ],
    // '北京': [-10, 0],
    "\u5929\u6D25": [
        5,
        5
    ]
};
function $280c32529827bd03$export$2e2bcd8739ae039(mapType, region) {
    if (mapType === 'china') {
        var coordFix = $280c32529827bd03$var$coordsOffsetMap[region.name];
        if (coordFix) {
            var cp = region.getCenter();
            cp[0] += coordFix[0] / 10.5;
            cp[1] += -coordFix[1] / 14;
            region.setCenter(cp);
        }
    }
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Fix for 钓鱼岛
// let Region = require('../Region');
// let zrUtil = require('zrender/lib/core/util');
// let geoCoord = [126, 25];
var $5b04f3878acd754e$var$points = [
    [
        [
            123.45165252685547,
            25.73527164402261
        ],
        [
            123.49731445312499,
            25.73527164402261
        ],
        [
            123.49731445312499,
            25.750734064600884
        ],
        [
            123.45165252685547,
            25.750734064600884
        ],
        [
            123.45165252685547,
            25.73527164402261
        ]
    ]
];
function $5b04f3878acd754e$export$2e2bcd8739ae039(mapType, region) {
    if (mapType === 'china' && region.name === "\u53F0\u6E7E") region.geometries.push({
        type: 'polygon',
        exterior: $5b04f3878acd754e$var$points[0]
    });
}



var $ca9a35044b20ba4d$var$DEFAULT_NAME_PROPERTY = 'name';
var $ca9a35044b20ba4d$export$859cf85c67f2df51 = /** @class */ function() {
    function GeoJSONResource(mapName, geoJSON, specialAreas) {
        this.type = 'geoJSON';
        this._parsedMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        this._mapName = mapName;
        this._specialAreas = specialAreas;
        // PENDING: delay the parse to the first usage to rapid up the FMP?
        this._geoJSON = $ca9a35044b20ba4d$var$parseInput(geoJSON);
    }
    /**
   * @param nameMap can be null/undefined
   * @param nameProperty can be null/undefined
   */ GeoJSONResource.prototype.load = function(nameMap, nameProperty) {
        nameProperty = nameProperty || $ca9a35044b20ba4d$var$DEFAULT_NAME_PROPERTY;
        var parsed = this._parsedMap.get(nameProperty);
        if (!parsed) {
            var rawRegions = this._parseToRegions(nameProperty);
            parsed = this._parsedMap.set(nameProperty, {
                regions: rawRegions,
                boundingRect: $ca9a35044b20ba4d$var$calculateBoundingRect(rawRegions)
            });
        }
        var regionsMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        var finalRegions = [];
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(parsed.regions, function(region) {
            var regionName = region.name;
            // Try use the alias in geoNameMap
            if (nameMap && (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(nameMap, regionName)) region = region.cloneShallow(regionName = nameMap[regionName]);
            finalRegions.push(region);
            regionsMap.set(regionName, region);
        });
        return {
            regions: finalRegions,
            boundingRect: parsed.boundingRect || new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0),
            regionsMap: regionsMap
        };
    };
    GeoJSONResource.prototype._parseToRegions = function(nameProperty) {
        var mapName = this._mapName;
        var geoJSON = this._geoJSON;
        var rawRegions;
        // https://jsperf.com/try-catch-performance-overhead
        try {
            rawRegions = geoJSON ? (0, $1a1de70a2b6a5dc5$export$2e2bcd8739ae039)(geoJSON, nameProperty) : [];
        } catch (e) {
            throw new Error('Invalid geoJson format\n' + e.message);
        }
        (0, $616ae7a19aad52f4$export$2e2bcd8739ae039)(mapName, rawRegions);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(rawRegions, function(region) {
            var regionName = region.name;
            (0, $280c32529827bd03$export$2e2bcd8739ae039)(mapName, region);
            (0, $5b04f3878acd754e$export$2e2bcd8739ae039)(mapName, region);
            // Some area like Alaska in USA map needs to be tansformed
            // to look better
            var specialArea = this._specialAreas && this._specialAreas[regionName];
            if (specialArea) region.transformTo(specialArea.left, specialArea.top, specialArea.width, specialArea.height);
        }, this);
        return rawRegions;
    };
    /**
   * Only for exporting to users.
   * **MUST NOT** used internally.
   */ GeoJSONResource.prototype.getMapForUser = function() {
        return {
            // For backward compatibility, use geoJson
            // PENDING: it has been returning them without clone.
            // do we need to avoid outsite modification?
            geoJson: this._geoJSON,
            geoJSON: this._geoJSON,
            specialAreas: this._specialAreas
        };
    };
    return GeoJSONResource;
}();
function $ca9a35044b20ba4d$var$calculateBoundingRect(regions) {
    var rect;
    for(var i = 0; i < regions.length; i++){
        var regionRect = regions[i].getBoundingRect();
        rect = rect || regionRect.clone();
        rect.union(regionRect);
    }
    return rect;
}
function $ca9a35044b20ba4d$var$parseInput(source) {
    return !(0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(source) ? source : typeof JSON !== 'undefined' && JSON.parse ? JSON.parse(source) : new Function('return (' + source + ');')();
}


var $09550a1229dcb4ad$var$storage = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
var $09550a1229dcb4ad$export$2e2bcd8739ae039 = {
    /**
   * Compatible with previous `echarts.registerMap`.
   *
   * @usage
   * ```js
   *
   * echarts.registerMap('USA', geoJson, specialAreas);
   *
   * echarts.registerMap('USA', {
   *     geoJson: geoJson,
   *     specialAreas: {...}
   * });
   * echarts.registerMap('USA', {
   *     geoJSON: geoJson,
   *     specialAreas: {...}
   * });
   *
   * echarts.registerMap('airport', {
   *     svg: svg
   * }
   * ```
   *
   * Note:
   * Do not support that register multiple geoJSON or SVG
   * one map name. Because different geoJSON and SVG have
   * different unit. It's not easy to make sure how those
   * units are mapping/normalize.
   * If intending to use multiple geoJSON or SVG, we can
   * use multiple geo coordinate system.
   */ registerMap: function(mapName, rawDef, rawSpecialAreas) {
        if (rawDef.svg) {
            var resource = new (0, $decc9bf1380d61c0$export$be52c950efae1f84)(mapName, rawDef.svg);
            $09550a1229dcb4ad$var$storage.set(mapName, resource);
        } else {
            // Recommend:
            //     echarts.registerMap('eu', { geoJSON: xxx, specialAreas: xxx });
            // Backward compatibility:
            //     echarts.registerMap('eu', geoJSON, specialAreas);
            //     echarts.registerMap('eu', { geoJson: xxx, specialAreas: xxx });
            var geoJSON = rawDef.geoJson || rawDef.geoJSON;
            if (geoJSON && !rawDef.features) rawSpecialAreas = rawDef.specialAreas;
            else geoJSON = rawDef;
            var resource = new (0, $ca9a35044b20ba4d$export$859cf85c67f2df51)(mapName, geoJSON, rawSpecialAreas);
            $09550a1229dcb4ad$var$storage.set(mapName, resource);
        }
    },
    getGeoResource: function(mapName) {
        return $09550a1229dcb4ad$var$storage.get(mapName);
    },
    /**
   * Only for exporting to users.
   * **MUST NOT** used internally.
   */ getMapForUser: function(mapName) {
        var resource = $09550a1229dcb4ad$var$storage.get(mapName);
        // Do not support return SVG until some real requirement come.
        return resource && resource.type === 'geoJSON' && resource.getMapForUser();
    },
    load: function(mapName, nameMap, nameProperty) {
        var resource = $09550a1229dcb4ad$var$storage.get(mapName);
        if (!resource) return;
        return resource.load(nameMap, nameProperty);
    }
};








/**
 * Only these tags enable use `itemStyle` if they are named in SVG.
 * Other tags like <text> <tspan> <image> might not suitable for `itemStyle`.
 * They will not be considered to be styled until some requirements come.
 */ var $ad029c27e0f2a7ab$var$OPTION_STYLE_ENABLED_TAGS = [
    'rect',
    'circle',
    'line',
    'ellipse',
    'polygon',
    'polyline',
    'path'
];
var $ad029c27e0f2a7ab$var$OPTION_STYLE_ENABLED_TAG_MAP = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4($ad029c27e0f2a7ab$var$OPTION_STYLE_ENABLED_TAGS);
var $ad029c27e0f2a7ab$var$STATE_TRIGGER_TAG_MAP = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4($ad029c27e0f2a7ab$var$OPTION_STYLE_ENABLED_TAGS.concat([
    'g'
]));
var $ad029c27e0f2a7ab$var$LABEL_HOST_MAP = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4($ad029c27e0f2a7ab$var$OPTION_STYLE_ENABLED_TAGS.concat([
    'g'
]));
var $ad029c27e0f2a7ab$var$mapLabelRaw = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $ad029c27e0f2a7ab$var$getFixedItemStyle(model) {
    var itemStyle = model.getItemStyle();
    var areaColor = model.get('areaColor');
    // If user want the color not to be changed when hover,
    // they should both set areaColor and color to be null.
    if (areaColor != null) itemStyle.fill = areaColor;
    return itemStyle;
}
// Only stroke can be used for line.
// Using fill in style if stroke not exits.
// TODO Not sure yet. Perhaps a separate `lineStyle`?
function $ad029c27e0f2a7ab$var$fixLineStyle(styleHost) {
    var style = styleHost.style;
    if (style) {
        style.stroke = style.stroke || style.fill;
        style.fill = null;
    }
}
var $ad029c27e0f2a7ab$var$MapDraw = /** @class */ function() {
    function MapDraw(api) {
        var group = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        this.uid = (0, $5370df662b2caf37$export$6d2b3473b0986646)('ec_map_draw');
        this._controller = new (0, $15927f329deeab51$export$2e2bcd8739ae039)(api.getZr());
        this._controllerHost = {
            target: group
        };
        this.group = group;
        group.add(this._regionsGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039());
        group.add(this._svgGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039());
    }
    MapDraw.prototype.draw = function(mapOrGeoModel, ecModel, api, fromView, payload) {
        var isGeo = mapOrGeoModel.mainType === 'geo';
        // Map series has data. GEO model that controlled by map series
        // will be assigned with map data. Other GEO model has no data.
        var data = mapOrGeoModel.getData && mapOrGeoModel.getData();
        isGeo && ecModel.eachComponent({
            mainType: 'series',
            subType: 'map'
        }, function(mapSeries) {
            if (!data && mapSeries.getHostGeoModel() === mapOrGeoModel) data = mapSeries.getData();
        });
        var geo = mapOrGeoModel.coordinateSystem;
        var regionsGroup = this._regionsGroup;
        var group = this.group;
        var transformInfo = geo.getTransformInfo();
        var transformInfoRaw = transformInfo.raw;
        var transformInfoRoam = transformInfo.roam;
        // No animation when first draw or in action
        var isFirstDraw = !regionsGroup.childAt(0) || payload;
        if (isFirstDraw) {
            group.x = transformInfoRoam.x;
            group.y = transformInfoRoam.y;
            group.scaleX = transformInfoRoam.scaleX;
            group.scaleY = transformInfoRoam.scaleY;
            group.dirty();
        } else $8b353638fbedfefa$export$c8dce3c08436e91e(group, transformInfoRoam, mapOrGeoModel);
        var isVisualEncodedByVisualMap = data && data.getVisual('visualMeta') && data.getVisual('visualMeta').length > 0;
        var viewBuildCtx = {
            api: api,
            geo: geo,
            mapOrGeoModel: mapOrGeoModel,
            data: data,
            isVisualEncodedByVisualMap: isVisualEncodedByVisualMap,
            isGeo: isGeo,
            transformInfoRaw: transformInfoRaw
        };
        if (geo.resourceType === 'geoJSON') this._buildGeoJSON(viewBuildCtx);
        else if (geo.resourceType === 'geoSVG') this._buildSVG(viewBuildCtx);
        this._updateController(mapOrGeoModel, ecModel, api);
        this._updateMapSelectHandler(mapOrGeoModel, regionsGroup, api, fromView);
    };
    MapDraw.prototype._buildGeoJSON = function(viewBuildCtx) {
        var regionsGroupByName = this._regionsGroupByName = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        var regionsInfoByName = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        var regionsGroup = this._regionsGroup;
        var transformInfoRaw = viewBuildCtx.transformInfoRaw;
        var mapOrGeoModel = viewBuildCtx.mapOrGeoModel;
        var data = viewBuildCtx.data;
        var projection = viewBuildCtx.geo.projection;
        var projectionStream = projection && projection.stream;
        function transformPoint(point, project) {
            if (project) // projection may return null point.
            point = project(point);
            return point && [
                point[0] * transformInfoRaw.scaleX + transformInfoRaw.x,
                point[1] * transformInfoRaw.scaleY + transformInfoRaw.y
            ];
        }
        function transformPolygonPoints(inPoints) {
            var outPoints = [];
            // If projectionStream is provided. Use it instead of single point project.
            var project = !projectionStream && projection && projection.project;
            for(var i = 0; i < inPoints.length; ++i){
                var newPt = transformPoint(inPoints[i], project);
                newPt && outPoints.push(newPt);
            }
            return outPoints;
        }
        function getPolyShape(points) {
            return {
                shape: {
                    points: transformPolygonPoints(points)
                }
            };
        }
        regionsGroup.removeAll();
        // Only when the resource is GeoJSON, there is `geo.regions`.
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(viewBuildCtx.geo.regions, function(region) {
            var regionName = region.name;
            // Consider in GeoJson properties.name may be duplicated, for example,
            // there is multiple region named "United Kindom" or "France" (so many
            // colonies). And it is not appropriate to merge them in geo, which
            // will make them share the same label and bring trouble in label
            // location calculation.
            var regionGroup = regionsGroupByName.get(regionName);
            var _a = regionsInfoByName.get(regionName) || {}, dataIdx = _a.dataIdx, regionModel = _a.regionModel;
            if (!regionGroup) {
                regionGroup = regionsGroupByName.set(regionName, new $7ef7583d8302ffce$export$2e2bcd8739ae039());
                regionsGroup.add(regionGroup);
                dataIdx = data ? data.indexOfName(regionName) : null;
                regionModel = viewBuildCtx.isGeo ? mapOrGeoModel.getRegionModel(regionName) : data ? data.getItemModel(dataIdx) : null;
                var silent = regionModel.get('silent', true);
                silent != null && (regionGroup.silent = silent);
                regionsInfoByName.set(regionName, {
                    dataIdx: dataIdx,
                    regionModel: regionModel
                });
            }
            var polygonSubpaths = [];
            var polylineSubpaths = [];
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(region.geometries, function(geometry) {
                // Polygon and MultiPolygon
                if (geometry.type === 'polygon') {
                    var polys = [
                        geometry.exterior
                    ].concat(geometry.interiors || []);
                    if (projectionStream) polys = $ad029c27e0f2a7ab$var$projectPolys(polys, projectionStream);
                    $7a1bd9c2710fea0d$export$79b2f7037acddd43(polys, function(poly) {
                        polygonSubpaths.push(new $51acf033123e1a30$export$2e2bcd8739ae039(getPolyShape(poly)));
                    });
                } else {
                    var points = geometry.points;
                    if (projectionStream) points = $ad029c27e0f2a7ab$var$projectPolys(points, projectionStream, true);
                    $7a1bd9c2710fea0d$export$79b2f7037acddd43(points, function(points) {
                        polylineSubpaths.push(new $d28119f30e6bb670$export$2e2bcd8739ae039(getPolyShape(points)));
                    });
                }
            });
            var centerPt = transformPoint(region.getCenter(), projection && projection.project);
            function createCompoundPath(subpaths, isLine) {
                if (!subpaths.length) return;
                var compoundPath = new $e152f3dbf8fba6e2$export$2e2bcd8739ae039({
                    culling: true,
                    segmentIgnoreThreshold: 1,
                    shape: {
                        paths: subpaths
                    }
                });
                regionGroup.add(compoundPath);
                $ad029c27e0f2a7ab$var$applyOptionStyleForRegion(viewBuildCtx, compoundPath, dataIdx, regionModel);
                $ad029c27e0f2a7ab$var$resetLabelForRegion(viewBuildCtx, compoundPath, regionName, regionModel, mapOrGeoModel, dataIdx, centerPt);
                if (isLine) {
                    $ad029c27e0f2a7ab$var$fixLineStyle(compoundPath);
                    $7a1bd9c2710fea0d$export$79b2f7037acddd43(compoundPath.states, $ad029c27e0f2a7ab$var$fixLineStyle);
                }
            }
            createCompoundPath(polygonSubpaths);
            createCompoundPath(polylineSubpaths, true);
        });
        // Ensure children have been added to `regionGroup` before calling them.
        regionsGroupByName.each(function(regionGroup, regionName) {
            var _a = regionsInfoByName.get(regionName), dataIdx = _a.dataIdx, regionModel = _a.regionModel;
            $ad029c27e0f2a7ab$var$resetEventTriggerForRegion(viewBuildCtx, regionGroup, regionName, regionModel, mapOrGeoModel, dataIdx);
            $ad029c27e0f2a7ab$var$resetTooltipForRegion(viewBuildCtx, regionGroup, regionName, regionModel, mapOrGeoModel);
            $ad029c27e0f2a7ab$var$resetStateTriggerForRegion(viewBuildCtx, regionGroup, regionName, regionModel, mapOrGeoModel);
        }, this);
    };
    MapDraw.prototype._buildSVG = function(viewBuildCtx) {
        var mapName = viewBuildCtx.geo.map;
        var transformInfoRaw = viewBuildCtx.transformInfoRaw;
        this._svgGroup.x = transformInfoRaw.x;
        this._svgGroup.y = transformInfoRaw.y;
        this._svgGroup.scaleX = transformInfoRaw.scaleX;
        this._svgGroup.scaleY = transformInfoRaw.scaleY;
        if (this._svgResourceChanged(mapName)) {
            this._freeSVG();
            this._useSVG(mapName);
        }
        var svgDispatcherMap = this._svgDispatcherMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        var focusSelf = false;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(this._svgGraphicRecord.named, function(namedItem) {
            // Note that we also allow different elements have the same name.
            // For example, a glyph of a city and the label of the city have
            // the same name and their tooltip info can be defined in a single
            // region option.
            var regionName = namedItem.name;
            var mapOrGeoModel = viewBuildCtx.mapOrGeoModel;
            var data = viewBuildCtx.data;
            var svgNodeTagLower = namedItem.svgNodeTagLower;
            var el = namedItem.el;
            var dataIdx = data ? data.indexOfName(regionName) : null;
            var regionModel = mapOrGeoModel.getRegionModel(regionName);
            if ($ad029c27e0f2a7ab$var$OPTION_STYLE_ENABLED_TAG_MAP.get(svgNodeTagLower) != null && el instanceof (0, $56206a6cb4666931$export$2e2bcd8739ae039)) $ad029c27e0f2a7ab$var$applyOptionStyleForRegion(viewBuildCtx, el, dataIdx, regionModel);
            if (el instanceof (0, $56206a6cb4666931$export$2e2bcd8739ae039)) el.culling = true;
            var silent = regionModel.get('silent', true);
            silent != null && (el.silent = silent);
            // We do not know how the SVG like so we'd better not to change z2.
            // Otherwise it might bring some unexpected result. For example,
            // an area hovered that make some inner city can not be clicked.
            el.z2EmphasisLift = 0;
            // If self named:
            if (!namedItem.namedFrom) {
                // label should batter to be displayed based on the center of <g>
                // if it is named rather than displayed on each child.
                if ($ad029c27e0f2a7ab$var$LABEL_HOST_MAP.get(svgNodeTagLower) != null) $ad029c27e0f2a7ab$var$resetLabelForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel, dataIdx, null);
                $ad029c27e0f2a7ab$var$resetEventTriggerForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel, dataIdx);
                $ad029c27e0f2a7ab$var$resetTooltipForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel);
                if ($ad029c27e0f2a7ab$var$STATE_TRIGGER_TAG_MAP.get(svgNodeTagLower) != null) {
                    var focus_1 = $ad029c27e0f2a7ab$var$resetStateTriggerForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel);
                    if (focus_1 === 'self') focusSelf = true;
                    var els = svgDispatcherMap.get(regionName) || svgDispatcherMap.set(regionName, []);
                    els.push(el);
                }
            }
        }, this);
        this._enableBlurEntireSVG(focusSelf, viewBuildCtx);
    };
    MapDraw.prototype._enableBlurEntireSVG = function(focusSelf, viewBuildCtx) {
        // It's a little complicated to support blurring the entire geoSVG in series-map.
        // So do not support it until some requirements come.
        // At present, in series-map, only regions can be blurred.
        if (focusSelf && viewBuildCtx.isGeo) {
            var blurStyle = viewBuildCtx.mapOrGeoModel.getModel([
                'blur',
                'itemStyle'
            ]).getItemStyle();
            // Only support `opacity` here. Because not sure that other props are suitable for
            // all of the elements generated by SVG (especially for Text/TSpan/Image/... ).
            var opacity_1 = blurStyle.opacity;
            this._svgGraphicRecord.root.traverse(function(el) {
                if (!el.isGroup) {
                    // PENDING: clear those settings to SVG elements when `_freeSVG`.
                    // (Currently it happen not to be needed.)
                    (0, $2bf82c0980125b62$export$20f39bbe322fb9ab)(el);
                    var style = el.ensureState('blur').style || {};
                    // Do not overwrite the region style that already set from region option.
                    if (style.opacity == null && opacity_1 != null) style.opacity = opacity_1;
                    // If `ensureState('blur').style = {}`, there will be default opacity.
                    // Enable `stateTransition` (animation).
                    el.ensureState('emphasis');
                }
            });
        }
    };
    MapDraw.prototype.remove = function() {
        this._regionsGroup.removeAll();
        this._regionsGroupByName = null;
        this._svgGroup.removeAll();
        this._freeSVG();
        this._controller.dispose();
        this._controllerHost = null;
    };
    MapDraw.prototype.findHighDownDispatchers = function(name, geoModel) {
        if (name == null) return [];
        var geo = geoModel.coordinateSystem;
        if (geo.resourceType === 'geoJSON') {
            var regionsGroupByName = this._regionsGroupByName;
            if (regionsGroupByName) {
                var regionGroup = regionsGroupByName.get(name);
                return regionGroup ? [
                    regionGroup
                ] : [];
            }
        } else if (geo.resourceType === 'geoSVG') return this._svgDispatcherMap && this._svgDispatcherMap.get(name) || [];
    };
    MapDraw.prototype._svgResourceChanged = function(mapName) {
        return this._svgMapName !== mapName;
    };
    MapDraw.prototype._useSVG = function(mapName) {
        var resource = (0, $09550a1229dcb4ad$export$2e2bcd8739ae039).getGeoResource(mapName);
        if (resource && resource.type === 'geoSVG') {
            var svgGraphic = resource.useGraphic(this.uid);
            this._svgGroup.add(svgGraphic.root);
            this._svgGraphicRecord = svgGraphic;
            this._svgMapName = mapName;
        }
    };
    MapDraw.prototype._freeSVG = function() {
        var mapName = this._svgMapName;
        if (mapName == null) return;
        var resource = (0, $09550a1229dcb4ad$export$2e2bcd8739ae039).getGeoResource(mapName);
        if (resource && resource.type === 'geoSVG') resource.freeGraphic(this.uid);
        this._svgGraphicRecord = null;
        this._svgDispatcherMap = null;
        this._svgGroup.removeAll();
        this._svgMapName = null;
    };
    MapDraw.prototype._updateController = function(mapOrGeoModel, ecModel, api) {
        var geo = mapOrGeoModel.coordinateSystem;
        var controller = this._controller;
        var controllerHost = this._controllerHost;
        // @ts-ignore FIXME:TS
        controllerHost.zoomLimit = mapOrGeoModel.get('scaleLimit');
        controllerHost.zoom = geo.getZoom();
        // roamType is will be set default true if it is null
        // @ts-ignore FIXME:TS
        controller.enable(mapOrGeoModel.get('roam') || false);
        var mainType = mapOrGeoModel.mainType;
        function makeActionBase() {
            var action = {
                type: 'geoRoam',
                componentType: mainType
            };
            action[mainType + 'Id'] = mapOrGeoModel.id;
            return action;
        }
        controller.off('pan').on('pan', function(e) {
            this._mouseDownFlag = false;
            $35fd859fd545c4be$export$1e6abcd98caba733(controllerHost, e.dx, e.dy);
            api.dispatchAction($7a1bd9c2710fea0d$export$8b58be045bf06082(makeActionBase(), {
                dx: e.dx,
                dy: e.dy,
                animation: {
                    duration: 0
                }
            }));
        }, this);
        controller.off('zoom').on('zoom', function(e) {
            this._mouseDownFlag = false;
            $35fd859fd545c4be$export$29b3c66d30a4866(controllerHost, e.scale, e.originX, e.originY);
            api.dispatchAction($7a1bd9c2710fea0d$export$8b58be045bf06082(makeActionBase(), {
                totalZoom: controllerHost.zoom,
                zoom: e.scale,
                originX: e.originX,
                originY: e.originY,
                animation: {
                    duration: 0
                }
            }));
        }, this);
        controller.setPointerChecker(function(e, x, y) {
            return geo.containPoint([
                x,
                y
            ]) && !(0, $bee256db41541054$export$8a33eacb690eac07)(e, api, mapOrGeoModel);
        });
    };
    /**
   * FIXME: this is a temporarily workaround.
   * When `geoRoam` the elements need to be reset in `MapView['render']`, because the props like
   * `ignore` might have been modified by `LabelManager`, and `LabelManager#addLabelsOfSeries`
   * will subsequently cache `defaultAttr` like `ignore`. If do not do this reset, the modified
   * props will have no chance to be restored.
   * Note: This reset should be after `clearStates` in `renderSeries` because `useStates` in
   * `renderSeries` will cache the modified `ignore` to `el._normalState`.
   * TODO:
   * Use clone/immutable in `LabelManager`?
   */ MapDraw.prototype.resetForLabelLayout = function() {
        this.group.traverse(function(el) {
            var label = el.getTextContent();
            if (label) label.ignore = $ad029c27e0f2a7ab$var$mapLabelRaw(label).ignore;
        });
    };
    MapDraw.prototype._updateMapSelectHandler = function(mapOrGeoModel, regionsGroup, api, fromView) {
        var mapDraw = this;
        regionsGroup.off('mousedown');
        regionsGroup.off('click');
        // @ts-ignore FIXME:TS resolve type conflict
        if (mapOrGeoModel.get('selectedMode')) {
            regionsGroup.on('mousedown', function() {
                mapDraw._mouseDownFlag = true;
            });
            regionsGroup.on('click', function(e) {
                if (!mapDraw._mouseDownFlag) return;
                mapDraw._mouseDownFlag = false;
            });
        }
    };
    return MapDraw;
}();
function $ad029c27e0f2a7ab$var$applyOptionStyleForRegion(viewBuildCtx, el, dataIndex, regionModel) {
    // All of the path are using `itemStyle`, because
    // (1) Some SVG also use fill on polyline (The different between
    // polyline and polygon is "open" or "close" but not fill or not).
    // (2) For the common props like opacity, if some use itemStyle
    // and some use `lineStyle`, it might confuse users.
    // (3) Most SVG use <path>, where can not detect whether to draw a "line"
    // or a filled shape, so use `itemStyle` for <path>.
    var normalStyleModel = regionModel.getModel('itemStyle');
    var emphasisStyleModel = regionModel.getModel([
        'emphasis',
        'itemStyle'
    ]);
    var blurStyleModel = regionModel.getModel([
        'blur',
        'itemStyle'
    ]);
    var selectStyleModel = regionModel.getModel([
        'select',
        'itemStyle'
    ]);
    // NOTE: DON'T use 'style' in visual when drawing map.
    // This component is used for drawing underlying map for both geo component and map series.
    var normalStyle = $ad029c27e0f2a7ab$var$getFixedItemStyle(normalStyleModel);
    var emphasisStyle = $ad029c27e0f2a7ab$var$getFixedItemStyle(emphasisStyleModel);
    var selectStyle = $ad029c27e0f2a7ab$var$getFixedItemStyle(selectStyleModel);
    var blurStyle = $ad029c27e0f2a7ab$var$getFixedItemStyle(blurStyleModel);
    // Update the itemStyle if has data visual
    var data = viewBuildCtx.data;
    if (data) {
        // Only visual color of each item will be used. It can be encoded by visualMap
        // But visual color of series is used in symbol drawing
        // Visual color for each series is for the symbol draw
        var style = data.getItemVisual(dataIndex, 'style');
        var decal = data.getItemVisual(dataIndex, 'decal');
        if (viewBuildCtx.isVisualEncodedByVisualMap && style.fill) normalStyle.fill = style.fill;
        if (decal) normalStyle.decal = (0, $c6d646aacd243427$export$a3ba048e1a648972)(decal, viewBuildCtx.api);
    }
    // SVG text, tspan and image can be named but not supporeted
    // to be styled by region option yet.
    el.setStyle(normalStyle);
    el.style.strokeNoScale = true;
    el.ensureState('emphasis').style = emphasisStyle;
    el.ensureState('select').style = selectStyle;
    el.ensureState('blur').style = blurStyle;
    // Enable blur
    (0, $2bf82c0980125b62$export$20f39bbe322fb9ab)(el);
}
function $ad029c27e0f2a7ab$var$resetLabelForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel, // Exist only if `viewBuildCtx.data` exists.
dataIdx, // If labelXY not provided, use `textConfig.position: 'inside'`
labelXY) {
    var data = viewBuildCtx.data;
    var isGeo = viewBuildCtx.isGeo;
    var isDataNaN = data && isNaN(data.get(data.mapDimension('value'), dataIdx));
    var itemLayout = data && data.getItemLayout(dataIdx);
    // In the following cases label will be drawn
    // 1. In map series and data value is NaN
    // 2. In geo component
    // 3. Region has no series legendIcon, which will be add a showLabel flag in mapSymbolLayout
    if (isGeo || isDataNaN || itemLayout && itemLayout.showLabel) {
        var query = !isGeo ? dataIdx : regionName;
        var labelFetcher = void 0;
        // Consider dataIdx not found.
        if (!data || dataIdx >= 0) labelFetcher = mapOrGeoModel;
        var specifiedTextOpt = labelXY ? {
            normal: {
                align: 'center',
                verticalAlign: 'middle'
            }
        } : null;
        // Caveat: must be called after `setDefaultStateProxy(el);` called.
        // because textContent will be assign with `el.stateProxy` inside.
        (0, $6800dfcb6e1e2a44$export$9a13992917966657)(el, (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(regionModel), {
            labelFetcher: labelFetcher,
            labelDataIndex: query,
            defaultText: regionName
        }, specifiedTextOpt);
        var textEl = el.getTextContent();
        if (textEl) {
            $ad029c27e0f2a7ab$var$mapLabelRaw(textEl).ignore = textEl.ignore;
            if (el.textConfig && labelXY) {
                // Compute a relative offset based on the el bounding rect.
                var rect = el.getBoundingRect().clone();
                // Need to make sure the percent position base on the same rect in normal and
                // emphasis state. Otherwise if using boundingRect of el, but the emphasis state
                // has borderWidth (even 0.5px), the text position will be changed obviously
                // if the position is very big like ['1234%', '1345%'].
                el.textConfig.layoutRect = rect;
                el.textConfig.position = [
                    (labelXY[0] - rect.x) / rect.width * 100 + '%',
                    (labelXY[1] - rect.y) / rect.height * 100 + '%'
                ];
            }
        }
        // PENDING:
        // If labelLayout is enabled (test/label-layout.html), el.dataIndex should be specified.
        // But el.dataIndex is also used to determine whether user event should be triggered,
        // where el.seriesIndex or el.dataModel must be specified. At present for a single el
        // there is not case that "only label layout enabled but user event disabled", so here
        // we depends `resetEventTriggerForRegion` to do the job of setting `el.dataIndex`.
        el.disableLabelAnimation = true;
    } else {
        el.removeTextContent();
        el.removeTextConfig();
        el.disableLabelAnimation = null;
    }
}
function $ad029c27e0f2a7ab$var$resetEventTriggerForRegion(viewBuildCtx, eventTrigger, regionName, regionModel, mapOrGeoModel, // Exist only if `viewBuildCtx.data` exists.
dataIdx) {
    // setItemGraphicEl, setHoverStyle after all polygons and labels
    // are added to the regionGroup
    if (viewBuildCtx.data) // FIXME: when series-map use a SVG map, and there are duplicated name specified
    // on different SVG elements, after `data.setItemGraphicEl(...)`:
    // (1) all of them will be mounted with `dataIndex`, `seriesIndex`, so that tooltip
    // can be triggered only mouse hover. That's correct.
    // (2) only the last element will be kept in `data`, so that if trigger tooltip
    // by `dispatchAction`, only the last one can be found and triggered. That might be
    // not correct. We will fix it in future if anyone demanding that.
    viewBuildCtx.data.setItemGraphicEl(dataIdx, eventTrigger);
    else // Package custom mouse event for geo component
    (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(eventTrigger).eventData = {
        componentType: 'geo',
        componentIndex: mapOrGeoModel.componentIndex,
        geoIndex: mapOrGeoModel.componentIndex,
        name: regionName,
        region: regionModel && regionModel.option || {}
    };
}
function $ad029c27e0f2a7ab$var$resetTooltipForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel) {
    if (!viewBuildCtx.data) $5b455ae6f843ac47$export$fc6410d97fab306c({
        el: el,
        componentModel: mapOrGeoModel,
        itemName: regionName,
        // @ts-ignore FIXME:TS fix the "compatible with each other"?
        itemTooltipOption: regionModel.get('tooltip')
    });
}
function $ad029c27e0f2a7ab$var$resetStateTriggerForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel) {
    // @ts-ignore FIXME:TS fix the "compatible with each other"?
    el.highDownSilentOnTouch = !!mapOrGeoModel.get('selectedMode');
    // @ts-ignore FIXME:TS fix the "compatible with each other"?
    var emphasisModel = regionModel.getModel('emphasis');
    var focus = emphasisModel.get('focus');
    (0, $2bf82c0980125b62$export$e51187539ff11209)(el, focus, emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
    if (viewBuildCtx.isGeo) (0, $2bf82c0980125b62$export$4da05a9639f01954)(el, mapOrGeoModel, regionName);
    return focus;
}
function $ad029c27e0f2a7ab$var$projectPolys(rings, // Polygons include exterior and interiors. Or polylines.
createStream, isLine) {
    var polygons = [];
    var curPoly;
    function startPolygon() {
        curPoly = [];
    }
    function endPolygon() {
        if (curPoly.length) {
            polygons.push(curPoly);
            curPoly = [];
        }
    }
    var stream = createStream({
        polygonStart: startPolygon,
        polygonEnd: endPolygon,
        lineStart: startPolygon,
        lineEnd: endPolygon,
        point: function(x, y) {
            // May have NaN values from stream.
            if (isFinite(x) && isFinite(y)) curPoly.push([
                x,
                y
            ]);
        },
        sphere: function() {}
    });
    !isLine && stream.polygonStart();
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(rings, function(ring) {
        stream.lineStart();
        for(var i = 0; i < ring.length; i++)stream.point(ring[i][0], ring[i][1]);
        stream.lineEnd();
    });
    !isLine && stream.polygonEnd();
    return polygons;
}
var $ad029c27e0f2a7ab$export$2e2bcd8739ae039 // @ts-ignore FIXME:TS fix the "compatible with each other"?
 = $ad029c27e0f2a7ab$var$MapDraw;





var $1c3add93106395a4$var$MapView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(MapView, _super);
    function MapView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MapView.type;
        return _this;
    }
    MapView.prototype.render = function(mapModel, ecModel, api, payload) {
        // Not render if it is an toggleSelect action from self
        if (payload && payload.type === 'mapToggleSelect' && payload.from === this.uid) return;
        var group = this.group;
        group.removeAll();
        if (mapModel.getHostGeoModel()) return;
        if (this._mapDraw && payload && payload.type === 'geoRoam') this._mapDraw.resetForLabelLayout();
        // Not update map if it is an roam action from self
        if (!(payload && payload.type === 'geoRoam' && payload.componentType === 'series' && payload.seriesId === mapModel.id)) {
            if (mapModel.needsDrawMap) {
                var mapDraw = this._mapDraw || new (0, $ad029c27e0f2a7ab$export$2e2bcd8739ae039)(api);
                group.add(mapDraw.group);
                mapDraw.draw(mapModel, ecModel, api, this, payload);
                this._mapDraw = mapDraw;
            } else {
                // Remove drawn map
                this._mapDraw && this._mapDraw.remove();
                this._mapDraw = null;
            }
        } else {
            var mapDraw = this._mapDraw;
            mapDraw && group.add(mapDraw.group);
        }
        mapModel.get('showLegendSymbol') && ecModel.getComponent('legend') && this._renderSymbols(mapModel, ecModel, api);
    };
    MapView.prototype.remove = function() {
        this._mapDraw && this._mapDraw.remove();
        this._mapDraw = null;
        this.group.removeAll();
    };
    MapView.prototype.dispose = function() {
        this._mapDraw && this._mapDraw.remove();
        this._mapDraw = null;
    };
    MapView.prototype._renderSymbols = function(mapModel, ecModel, api) {
        var originalData = mapModel.originalData;
        var group = this.group;
        originalData.each(originalData.mapDimension('value'), function(value, originalDataIndex) {
            if (isNaN(value)) return;
            var layout = originalData.getItemLayout(originalDataIndex);
            if (!layout || !layout.point) // Not exists in map
            return;
            var point = layout.point;
            var offset = layout.offset;
            var circle = new $1e68d8727773abb7$export$2e2bcd8739ae039({
                style: {
                    // Because the special of map draw.
                    // Which needs statistic of multiple series and draw on one map.
                    // And each series also need a symbol with legend color
                    //
                    // Layout and visual are put one the different data
                    // TODO
                    fill: mapModel.getData().getVisual('style').fill
                },
                shape: {
                    cx: point[0] + offset * 9,
                    cy: point[1],
                    r: 3
                },
                silent: true,
                // Do not overlap the first series, on which labels are displayed.
                z2: 8 + (!offset ? (0, $2bf82c0980125b62$export$1cb9fc6ed5b9836c) + 1 : 0)
            });
            // Only the series that has the first value on the same region is in charge of rendering the label.
            // But consider the case:
            // series: [
            //     {id: 'X', type: 'map', map: 'm', {data: [{name: 'A', value: 11}, {name: 'B', {value: 22}]},
            //     {id: 'Y', type: 'map', map: 'm', {data: [{name: 'A', value: 21}, {name: 'C', {value: 33}]}
            // ]
            // The offset `0` of item `A` is at series `X`, but of item `C` is at series `Y`.
            // For backward compatibility, we follow the rule that render label `A` by the
            // settings on series `X` but render label `C` by the settings on series `Y`.
            if (!offset) {
                var fullData = mapModel.mainSeries.getData();
                var name_1 = originalData.getName(originalDataIndex);
                var fullIndex_1 = fullData.indexOfName(name_1);
                var itemModel = originalData.getItemModel(originalDataIndex);
                var labelModel = itemModel.getModel('label');
                var regionGroup = fullData.getItemGraphicEl(fullIndex_1);
                // `getFormattedLabel` needs to use `getData` inside. Here
                // `mapModel.getData()` is shallow cloned from `mainSeries.getData()`.
                // FIXME
                // If this is not the `mainSeries`, the item model (like label formatter)
                // set on original data item will never get. But it has been working
                // like that from the beginning, and this scenario is rarely encountered.
                // So it won't be fixed until we have to.
                (0, $6800dfcb6e1e2a44$export$9a13992917966657)(circle, (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(itemModel), {
                    labelFetcher: {
                        getFormattedLabel: function(idx, state) {
                            return mapModel.getFormattedLabel(fullIndex_1, state);
                        }
                    },
                    defaultText: name_1
                });
                circle.disableLabelAnimation = true;
                if (!labelModel.get('position')) circle.setTextConfig({
                    position: 'bottom'
                });
                regionGroup.onHoverStateChange = function(toState) {
                    (0, $2bf82c0980125b62$export$868ba38adffa9e39)(circle, toState);
                };
            }
            group.add(circle);
        });
    };
    MapView.type = 'map';
    return MapView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $1c3add93106395a4$export$2e2bcd8739ae039 = $1c3add93106395a4$var$MapView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







var $f2f4aa5429e1d3d3$var$MapSeries = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(MapSeries, _super);
    function MapSeries() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MapSeries.type;
        // Only first map series of same mapType will drawMap.
        _this.needsDrawMap = false;
        // Group of all map series with same mapType
        _this.seriesGroup = [];
        _this.getTooltipPosition = function(dataIndex) {
            if (dataIndex != null) {
                var name_1 = this.getData().getName(dataIndex);
                var geo = this.coordinateSystem;
                var region = geo.getRegion(name_1);
                return region && geo.dataToPoint(region.getCenter());
            }
        };
        return _this;
    }
    MapSeries.prototype.getInitialData = function(option) {
        var data = (0, $7e5c3511527c9907$export$2e2bcd8739ae039)(this, {
            coordDimensions: [
                'value'
            ],
            encodeDefaulter: $7a1bd9c2710fea0d$export$c3095a23b368d1f2((0, $7dc6cdfd7450ef29$export$60b8a57d1f2fed26), this)
        });
        var dataNameIndexMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        var toAppendItems = [];
        for(var i = 0, len = data.count(); i < len; i++){
            var name_2 = data.getName(i);
            dataNameIndexMap.set(name_2, i);
        }
        var geoSource = (0, $09550a1229dcb4ad$export$2e2bcd8739ae039).load(this.getMapType(), this.option.nameMap, this.option.nameProperty);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(geoSource.regions, function(region) {
            var name = region.name;
            var dataNameIdx = dataNameIndexMap.get(name);
            // apply specified echarts style in GeoJSON data
            var specifiedGeoJSONRegionStyle = region.properties && region.properties.echartsStyle;
            var dataItem;
            if (dataNameIdx == null) {
                dataItem = {
                    name: name
                };
                toAppendItems.push(dataItem);
            } else dataItem = data.getRawDataItem(dataNameIdx);
            specifiedGeoJSONRegionStyle && $7a1bd9c2710fea0d$export$4950aa0f605343fb(dataItem, specifiedGeoJSONRegionStyle);
        });
        // Complete data with missing regions. The consequent processes (like visual
        // map and render) can not be performed without a "full data". For example,
        // find `dataIndex` by name.
        data.appendData(toAppendItems);
        return data;
    };
    /**
   * If no host geo model, return null, which means using a
   * inner exclusive geo model.
   */ MapSeries.prototype.getHostGeoModel = function() {
        var geoIndex = this.option.geoIndex;
        return geoIndex != null ? this.ecModel.getComponent('geo', geoIndex) : null;
    };
    MapSeries.prototype.getMapType = function() {
        return (this.getHostGeoModel() || this).option.map;
    };
    // _fillOption(option, mapName) {
    // Shallow clone
    // option = zrUtil.extend({}, option);
    // option.data = geoCreator.getFilledRegions(option.data, mapName, option.nameMap);
    // return option;
    // }
    MapSeries.prototype.getRawValue = function(dataIndex) {
        // Use value stored in data instead because it is calculated from multiple series
        // FIXME Provide all value of multiple series ?
        var data = this.getData();
        return data.get(data.mapDimension('value'), dataIndex);
    };
    /**
   * Get model of region
   */ MapSeries.prototype.getRegionModel = function(regionName) {
        var data = this.getData();
        return data.getItemModel(data.indexOfName(regionName));
    };
    /**
   * Map tooltip formatter
   */ MapSeries.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        // FIXME orignalData and data is a bit confusing
        var data = this.getData();
        var value = this.getRawValue(dataIndex);
        var name = data.getName(dataIndex);
        var seriesGroup = this.seriesGroup;
        var seriesNames = [];
        for(var i = 0; i < seriesGroup.length; i++){
            var otherIndex = seriesGroup[i].originalData.indexOfName(name);
            var valueDim = data.mapDimension('value');
            if (!isNaN(seriesGroup[i].originalData.get(valueDim, otherIndex))) seriesNames.push(seriesGroup[i].name);
        }
        return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)('section', {
            header: seriesNames.join(', '),
            noHeader: !seriesNames.length,
            blocks: [
                (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)('nameValue', {
                    name: name,
                    value: value
                })
            ]
        });
    };
    MapSeries.prototype.setZoom = function(zoom) {
        this.option.zoom = zoom;
    };
    MapSeries.prototype.setCenter = function(center) {
        this.option.center = center;
    };
    MapSeries.prototype.getLegendIcon = function(opt) {
        var iconType = opt.icon || 'roundRect';
        var icon = (0, $5370466dadc978d7$export$af050e04da3a02e8)(iconType, 0, 0, opt.itemWidth, opt.itemHeight, opt.itemStyle.fill);
        icon.setStyle(opt.itemStyle);
        // Map do not use itemStyle.borderWidth as border width
        icon.style.stroke = 'none';
        // No rotation because no series visual symbol for map
        if (iconType.indexOf('empty') > -1) {
            icon.style.stroke = icon.style.fill;
            icon.style.fill = '#fff';
            icon.style.lineWidth = 2;
        }
        return icon;
    };
    MapSeries.type = 'series.map';
    MapSeries.dependencies = [
        'geo'
    ];
    MapSeries.layoutMode = 'box';
    MapSeries.defaultOption = {
        // 一级层叠
        // zlevel: 0,
        // 二级层叠
        z: 2,
        coordinateSystem: 'geo',
        // map should be explicitly specified since ec3.
        map: '',
        // If `geoIndex` is not specified, a exclusive geo will be
        // created. Otherwise use the specified geo component, and
        // `map` and `mapType` are ignored.
        // geoIndex: 0,
        // 'center' | 'left' | 'right' | 'x%' | {number}
        left: 'center',
        // 'center' | 'top' | 'bottom' | 'x%' | {number}
        top: 'center',
        // right
        // bottom
        // width:
        // height
        // Aspect is width / height. Inited to be geoJson bbox aspect
        // This parameter is used for scale this aspect
        // Default value:
        // for geoSVG source: 1,
        // for geoJSON source: 0.75.
        aspectScale: null,
        // Layout with center and size
        // If you want to put map in a fixed size box with right aspect ratio
        // This two properties may be more convenient.
        // layoutCenter: [50%, 50%]
        // layoutSize: 100
        showLegendSymbol: true,
        // Define left-top, right-bottom coords to control view
        // For example, [ [180, 90], [-180, -90] ],
        // higher priority than center and zoom
        boundingCoords: null,
        // Default on center of map
        center: null,
        zoom: 1,
        scaleLimit: null,
        selectedMode: true,
        label: {
            show: false,
            color: '#000'
        },
        // scaleLimit: null,
        itemStyle: {
            borderWidth: 0.5,
            borderColor: '#444',
            areaColor: '#eee'
        },
        emphasis: {
            label: {
                show: true,
                color: 'rgb(100,0,0)'
            },
            itemStyle: {
                areaColor: 'rgba(255,215,0,0.8)'
            }
        },
        select: {
            label: {
                show: true,
                color: 'rgb(100,0,0)'
            },
            itemStyle: {
                color: 'rgba(255,215,0,0.8)'
            }
        },
        nameProperty: 'name'
    };
    return MapSeries;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $f2f4aa5429e1d3d3$export$2e2bcd8739ae039 = $f2f4aa5429e1d3d3$var$MapSeries;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
// FIXME 公用？
function $5e3d42588445ae72$var$dataStatistics(datas, statisticType) {
    var dataNameMap = {};
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(datas, function(data) {
        data.each(data.mapDimension('value'), function(value, idx) {
            // Add prefix to avoid conflict with Object.prototype.
            var mapKey = 'ec-' + data.getName(idx);
            dataNameMap[mapKey] = dataNameMap[mapKey] || [];
            if (!isNaN(value)) dataNameMap[mapKey].push(value);
        });
    });
    return datas[0].map(datas[0].mapDimension('value'), function(value, idx) {
        var mapKey = 'ec-' + datas[0].getName(idx);
        var sum = 0;
        var min = Infinity;
        var max = -Infinity;
        var len = dataNameMap[mapKey].length;
        for(var i = 0; i < len; i++){
            min = Math.min(min, dataNameMap[mapKey][i]);
            max = Math.max(max, dataNameMap[mapKey][i]);
            sum += dataNameMap[mapKey][i];
        }
        var result;
        if (statisticType === 'min') result = min;
        else if (statisticType === 'max') result = max;
        else if (statisticType === 'average') result = sum / len;
        else result = sum;
        return len === 0 ? NaN : result;
    });
}
function $5e3d42588445ae72$export$2e2bcd8739ae039(ecModel) {
    var seriesGroups = {};
    ecModel.eachSeriesByType('map', function(seriesModel) {
        var hostGeoModel = seriesModel.getHostGeoModel();
        var key = hostGeoModel ? 'o' + hostGeoModel.id : 'i' + seriesModel.getMapType();
        (seriesGroups[key] = seriesGroups[key] || []).push(seriesModel);
    });
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(seriesGroups, function(seriesList, key) {
        var data = $5e3d42588445ae72$var$dataStatistics($7a1bd9c2710fea0d$export$871de8747c9eaa88(seriesList, function(seriesModel) {
            return seriesModel.getData();
        }), seriesList[0].get('mapValueCalculation'));
        for(var i = 0; i < seriesList.length; i++)seriesList[i].originalData = seriesList[i].getData();
        // FIXME Put where?
        for(var i = 0; i < seriesList.length; i++){
            seriesList[i].seriesGroup = seriesList;
            seriesList[i].needsDrawMap = i === 0 && !seriesList[i].getHostGeoModel();
            seriesList[i].setData(data.cloneShallow());
            seriesList[i].mainSeries = seriesList[0];
        }
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $53e61890435fb2d8$export$2e2bcd8739ae039(ecModel) {
    var processedMapType = {};
    ecModel.eachSeriesByType('map', function(mapSeries) {
        var mapType = mapSeries.getMapType();
        if (mapSeries.getHostGeoModel() || processedMapType[mapType]) return;
        var mapSymbolOffsets = {};
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(mapSeries.seriesGroup, function(subMapSeries) {
            var geo = subMapSeries.coordinateSystem;
            var data = subMapSeries.originalData;
            if (subMapSeries.get('showLegendSymbol') && ecModel.getComponent('legend')) data.each(data.mapDimension('value'), function(value, idx) {
                var name = data.getName(idx);
                var region = geo.getRegion(name);
                // If input series.data is [11, 22, '-'/null/undefined, 44],
                // it will be filled with NaN: [11, 22, NaN, 44] and NaN will
                // not be drawn. So here must validate if value is NaN.
                if (!region || isNaN(value)) return;
                var offset = mapSymbolOffsets[name] || 0;
                var point = geo.dataToPoint(region.getCenter());
                mapSymbolOffsets[name] = offset + 1;
                data.setItemLayout(idx, {
                    point: point,
                    offset: offset
                });
            });
        });
        // Show label of those region not has legendIcon (which is offset 0)
        var data = mapSeries.getData();
        data.each(function(idx) {
            var name = data.getName(idx);
            var layout = data.getItemLayout(idx) || {};
            layout.showLabel = !mapSymbolOffsets[name];
            data.setItemLayout(idx, layout);
        });
        processedMapType[mapType] = true;
    });
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $e67116e61e57a131$var$GEO_DEFAULT_PARAMS = {
    'geoJSON': {
        aspectScale: 0.75,
        invertLongitute: true
    },
    'geoSVG': {
        aspectScale: 1,
        invertLongitute: false
    }
};
var $e67116e61e57a131$export$10dbc57975912e0f = [
    'lng',
    'lat'
];
var $e67116e61e57a131$var$Geo = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(Geo, _super);
    function Geo(name, map, opt) {
        var _this = _super.call(this, name) || this;
        _this.dimensions = $e67116e61e57a131$export$10dbc57975912e0f;
        _this.type = 'geo';
        // Only store specified name coord via `addGeoCoord`.
        _this._nameCoordMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        _this.map = map;
        var projection = opt.projection;
        var source = (0, $09550a1229dcb4ad$export$2e2bcd8739ae039).load(map, opt.nameMap, opt.nameProperty);
        var resource = (0, $09550a1229dcb4ad$export$2e2bcd8739ae039).getGeoResource(map);
        var resourceType = _this.resourceType = resource ? resource.type : null;
        var regions = _this.regions = source.regions;
        var defaultParams = $e67116e61e57a131$var$GEO_DEFAULT_PARAMS[resource.type];
        _this._regionsMap = source.regionsMap;
        _this.regions = source.regions;
        _this.projection = projection;
        var boundingRect;
        if (projection) // Can't reuse the raw bounding rect
        for(var i = 0; i < regions.length; i++){
            var regionRect = regions[i].getBoundingRect(projection);
            boundingRect = boundingRect || regionRect.clone();
            boundingRect.union(regionRect);
        }
        else boundingRect = source.boundingRect;
        _this.setBoundingRect(boundingRect.x, boundingRect.y, boundingRect.width, boundingRect.height);
        // aspectScale and invertLongitute actually is the parameters default raw projection.
        // So we ignore them if projection is given.
        // Ignore default aspect scale if projection exits.
        _this.aspectScale = projection ? 1 : $7a1bd9c2710fea0d$export$995e01f2f5c9d030(opt.aspectScale, defaultParams.aspectScale);
        // Not invert longitude if projection exits.
        _this._invertLongitute = projection ? false : defaultParams.invertLongitute;
        return _this;
    }
    Geo.prototype._transformTo = function(x, y, width, height) {
        var rect = this.getBoundingRect();
        var invertLongitute = this._invertLongitute;
        rect = rect.clone();
        if (invertLongitute) // Longitude is inverted.
        rect.y = -rect.y - rect.height;
        var rawTransformable = this._rawTransformable;
        rawTransformable.transform = rect.calculateTransform(new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(x, y, width, height));
        var rawParent = rawTransformable.parent;
        rawTransformable.parent = null;
        rawTransformable.decomposeTransform();
        rawTransformable.parent = rawParent;
        if (invertLongitute) rawTransformable.scaleY = -rawTransformable.scaleY;
        this._updateTransform();
    };
    Geo.prototype.getRegion = function(name) {
        return this._regionsMap.get(name);
    };
    Geo.prototype.getRegionByCoord = function(coord) {
        var regions = this.regions;
        for(var i = 0; i < regions.length; i++){
            var region = regions[i];
            if (region.type === 'geoJSON' && region.contain(coord)) return regions[i];
        }
    };
    /**
   * Add geoCoord for indexing by name
   */ Geo.prototype.addGeoCoord = function(name, geoCoord) {
        this._nameCoordMap.set(name, geoCoord);
    };
    /**
   * Get geoCoord by name
   */ Geo.prototype.getGeoCoord = function(name) {
        var region = this._regionsMap.get(name);
        // Calculate center only on demand.
        return this._nameCoordMap.get(name) || region && region.getCenter();
    };
    Geo.prototype.dataToPoint = function(data, noRoam, out) {
        if ($7a1bd9c2710fea0d$export$844ec244b1367d54(data)) // Map area name to geoCoord
        data = this.getGeoCoord(data);
        if (data) {
            var projection = this.projection;
            if (projection) // projection may return null point.
            data = projection.project(data);
            return data && this.projectedToPoint(data, noRoam, out);
        }
    };
    Geo.prototype.pointToData = function(point) {
        var projection = this.projection;
        if (projection) // projection may return null point.
        point = projection.unproject(point);
        return point && this.pointToProjected(point);
    };
    /**
   * Point to projected data. Same with pointToData when projection is used.
   */ Geo.prototype.pointToProjected = function(point) {
        return _super.prototype.pointToData.call(this, point);
    };
    Geo.prototype.projectedToPoint = function(projected, noRoam, out) {
        return _super.prototype.dataToPoint.call(this, projected, noRoam, out);
    };
    Geo.prototype.convertToPixel = function(ecModel, finder, value) {
        var coordSys = $e67116e61e57a131$var$getCoordSys(finder);
        return coordSys === this ? coordSys.dataToPoint(value) : null;
    };
    Geo.prototype.convertFromPixel = function(ecModel, finder, pixel) {
        var coordSys = $e67116e61e57a131$var$getCoordSys(finder);
        return coordSys === this ? coordSys.pointToData(pixel) : null;
    };
    return Geo;
}((0, $4a92e7570d47c1fe$export$2e2bcd8739ae039));
$7a1bd9c2710fea0d$export$e36fc9d62a853069($e67116e61e57a131$var$Geo, (0, $4a92e7570d47c1fe$export$2e2bcd8739ae039));
function $e67116e61e57a131$var$getCoordSys(finder) {
    var geoModel = finder.geoModel;
    var seriesModel = finder.seriesModel;
    return geoModel ? geoModel.coordinateSystem : seriesModel ? seriesModel.coordinateSystem // For map series.
     || (seriesModel.getReferringComponents('geo', (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0] || {}).coordinateSystem : null;
}
var $e67116e61e57a131$export$2e2bcd8739ae039 = $e67116e61e57a131$var$Geo;






/**
 * Resize method bound to the geo
 */ function $303164fe3ecc2dc5$var$resizeGeo(geoModel, api) {
    var boundingCoords = geoModel.get('boundingCoords');
    if (boundingCoords != null) {
        var leftTop_1 = boundingCoords[0];
        var rightBottom_1 = boundingCoords[1];
        if (!(isFinite(leftTop_1[0]) && isFinite(leftTop_1[1]) && isFinite(rightBottom_1[0]) && isFinite(rightBottom_1[1]))) ;
        else {
            // Sample around the lng/lat rect and use projection to calculate actual bounding rect.
            var projection_1 = this.projection;
            if (projection_1) {
                var xMin = leftTop_1[0];
                var yMin = leftTop_1[1];
                var xMax = rightBottom_1[0];
                var yMax = rightBottom_1[1];
                leftTop_1 = [
                    Infinity,
                    Infinity
                ];
                rightBottom_1 = [
                    -Infinity,
                    -Infinity
                ];
                // TODO better way?
                var sampleLine = function(x0, y0, x1, y1) {
                    var dx = x1 - x0;
                    var dy = y1 - y0;
                    for(var i = 0; i <= 100; i++){
                        var p = i / 100;
                        var pt = projection_1.project([
                            x0 + dx * p,
                            y0 + dy * p
                        ]);
                        $6de594cf8ac295ff$export$96ec731ed4dcb222(leftTop_1, leftTop_1, pt);
                        $6de594cf8ac295ff$export$8960430cfd85939f(rightBottom_1, rightBottom_1, pt);
                    }
                };
                // Top
                sampleLine(xMin, yMin, xMax, yMin);
                // Right
                sampleLine(xMax, yMin, xMax, yMax);
                // Bottom
                sampleLine(xMax, yMax, xMin, yMax);
                // Left
                sampleLine(xMin, yMax, xMax, yMin);
            }
            this.setBoundingRect(leftTop_1[0], leftTop_1[1], rightBottom_1[0] - leftTop_1[0], rightBottom_1[1] - leftTop_1[1]);
        }
    }
    var rect = this.getBoundingRect();
    var centerOption = geoModel.get('layoutCenter');
    var sizeOption = geoModel.get('layoutSize');
    var viewWidth = api.getWidth();
    var viewHeight = api.getHeight();
    var aspect = rect.width / rect.height * this.aspectScale;
    var useCenterAndSize = false;
    var center;
    var size;
    if (centerOption && sizeOption) {
        center = [
            $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(centerOption[0], viewWidth),
            $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(centerOption[1], viewHeight)
        ];
        size = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(sizeOption, Math.min(viewWidth, viewHeight));
        if (!isNaN(center[0]) && !isNaN(center[1]) && !isNaN(size)) useCenterAndSize = true;
    }
    var viewRect;
    if (useCenterAndSize) {
        viewRect = {};
        if (aspect > 1) {
            // Width is same with size
            viewRect.width = size;
            viewRect.height = size / aspect;
        } else {
            viewRect.height = size;
            viewRect.width = size * aspect;
        }
        viewRect.y = center[1] - viewRect.height / 2;
        viewRect.x = center[0] - viewRect.width / 2;
    } else {
        // Use left/top/width/height
        var boxLayoutOption = geoModel.getBoxLayoutParams();
        boxLayoutOption.aspect = aspect;
        viewRect = $93b9bc7f22ac7369$export$4517a5ca639a7293(boxLayoutOption, {
            width: viewWidth,
            height: viewHeight
        });
    }
    this.setViewRect(viewRect.x, viewRect.y, viewRect.width, viewRect.height);
    this.setCenter(geoModel.get('center'), api);
    this.setZoom(geoModel.get('zoom'));
}
// Back compat for ECharts2, where the coord map is set on map series:
// {type: 'map', geoCoord: {'cityA': [116.46,39.92], 'cityA': [119.12,24.61]}},
function $303164fe3ecc2dc5$var$setGeoCoords(geo, model) {
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(model.get('geoCoord'), function(geoCoord, name) {
        geo.addGeoCoord(name, geoCoord);
    });
}
var $303164fe3ecc2dc5$var$GeoCreator = /** @class */ function() {
    function GeoCreator() {
        // For deciding which dimensions to use when creating list data
        this.dimensions = (0, $e67116e61e57a131$export$10dbc57975912e0f);
    }
    GeoCreator.prototype.create = function(ecModel, api) {
        var geoList = [];
        function getCommonGeoProperties(model) {
            return {
                nameProperty: model.get('nameProperty'),
                aspectScale: model.get('aspectScale'),
                projection: model.get('projection')
            };
        }
        // FIXME Create each time may be slow
        ecModel.eachComponent('geo', function(geoModel, idx) {
            var mapName = geoModel.get('map');
            var geo = new (0, $e67116e61e57a131$export$2e2bcd8739ae039)(mapName + idx, mapName, $7a1bd9c2710fea0d$export$8b58be045bf06082({
                nameMap: geoModel.get('nameMap')
            }, getCommonGeoProperties(geoModel)));
            geo.zoomLimit = geoModel.get('scaleLimit');
            geoList.push(geo);
            // setGeoCoords(geo, geoModel);
            geoModel.coordinateSystem = geo;
            geo.model = geoModel;
            // Inject resize method
            geo.resize = $303164fe3ecc2dc5$var$resizeGeo;
            geo.resize(geoModel, api);
        });
        ecModel.eachSeries(function(seriesModel) {
            var coordSys = seriesModel.get('coordinateSystem');
            if (coordSys === 'geo') {
                var geoIndex = seriesModel.get('geoIndex') || 0;
                seriesModel.coordinateSystem = geoList[geoIndex];
            }
        });
        // If has map series
        var mapModelGroupBySeries = {};
        ecModel.eachSeriesByType('map', function(seriesModel) {
            if (!seriesModel.getHostGeoModel()) {
                var mapType = seriesModel.getMapType();
                mapModelGroupBySeries[mapType] = mapModelGroupBySeries[mapType] || [];
                mapModelGroupBySeries[mapType].push(seriesModel);
            }
        });
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(mapModelGroupBySeries, function(mapSeries, mapType) {
            var nameMapList = $7a1bd9c2710fea0d$export$871de8747c9eaa88(mapSeries, function(singleMapSeries) {
                return singleMapSeries.get('nameMap');
            });
            var geo = new (0, $e67116e61e57a131$export$2e2bcd8739ae039)(mapType, mapType, $7a1bd9c2710fea0d$export$8b58be045bf06082({
                nameMap: $7a1bd9c2710fea0d$export$18aef43295bbe906(nameMapList)
            }, getCommonGeoProperties(mapSeries[0])));
            geo.zoomLimit = $7a1bd9c2710fea0d$export$8a4d17b6e8486e66.apply(null, $7a1bd9c2710fea0d$export$871de8747c9eaa88(mapSeries, function(singleMapSeries) {
                return singleMapSeries.get('scaleLimit');
            }));
            geoList.push(geo);
            // Inject resize method
            geo.resize = $303164fe3ecc2dc5$var$resizeGeo;
            geo.resize(mapSeries[0], api);
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(mapSeries, function(singleMapSeries) {
                singleMapSeries.coordinateSystem = geo;
                $303164fe3ecc2dc5$var$setGeoCoords(geo, singleMapSeries);
            });
        });
        return geoList;
    };
    /**
   * Fill given regions array
   */ GeoCreator.prototype.getFilledRegions = function(originRegionArr, mapName, nameMap, nameProperty) {
        // Not use the original
        var regionsArr = (originRegionArr || []).slice();
        var dataNameMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        for(var i = 0; i < regionsArr.length; i++)dataNameMap.set(regionsArr[i].name, regionsArr[i]);
        var source = (0, $09550a1229dcb4ad$export$2e2bcd8739ae039).load(mapName, nameMap, nameProperty);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(source.regions, function(region) {
            var name = region.name;
            var regionOption = dataNameMap.get(name);
            // apply specified echarts style in GeoJSON data
            var specifiedGeoJSONRegionStyle = region.properties && region.properties.echartsStyle;
            if (!regionOption) {
                regionOption = {
                    name: name
                };
                regionsArr.push(regionOption);
            }
            specifiedGeoJSONRegionStyle && $7a1bd9c2710fea0d$export$4950aa0f605343fb(regionOption, specifiedGeoJSONRegionStyle);
        });
        return regionsArr;
    };
    return GeoCreator;
}();
var $303164fe3ecc2dc5$var$geoCreator = new $303164fe3ecc2dc5$var$GeoCreator();
var $303164fe3ecc2dc5$export$2e2bcd8739ae039 = $303164fe3ecc2dc5$var$geoCreator;



var $4ff027656cc71ef0$var$GeoModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(GeoModel, _super);
    function GeoModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GeoModel.type;
        return _this;
    }
    GeoModel.prototype.init = function(option, parentModel, ecModel) {
        var source = (0, $09550a1229dcb4ad$export$2e2bcd8739ae039).getGeoResource(option.map);
        if (source && source.type === 'geoJSON') {
            var itemStyle = option.itemStyle = option.itemStyle || {};
            if (!('color' in itemStyle)) itemStyle.color = '#eee';
        }
        this.mergeDefaultAndTheme(option, ecModel);
        // Default label emphasis `show`
        $76d619f648247e6d$export$abdcc6a26372f94b(option, 'label', [
            'show'
        ]);
    };
    GeoModel.prototype.optionUpdated = function() {
        var _this = this;
        var option = this.option;
        option.regions = (0, $303164fe3ecc2dc5$export$2e2bcd8739ae039).getFilledRegions(option.regions, option.map, option.nameMap, option.nameProperty);
        var selectedMap = {};
        this._optionModelMap = $7a1bd9c2710fea0d$export$533b26079ad0b4b(option.regions || [], function(optionModelMap, regionOpt) {
            var regionName = regionOpt.name;
            if (regionName) {
                optionModelMap.set(regionName, new (0, $6818646a97528290$export$2e2bcd8739ae039)(regionOpt, _this, _this.ecModel));
                if (regionOpt.selected) selectedMap[regionName] = true;
            }
            return optionModelMap;
        }, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4());
        if (!option.selectedMap) option.selectedMap = selectedMap;
    };
    /**
   * Get model of region.
   */ GeoModel.prototype.getRegionModel = function(name) {
        return this._optionModelMap.get(name) || new (0, $6818646a97528290$export$2e2bcd8739ae039)(null, this, this.ecModel);
    };
    /**
   * Format label
   * @param name Region name
   */ GeoModel.prototype.getFormattedLabel = function(name, status) {
        var regionModel = this.getRegionModel(name);
        var formatter = status === 'normal' ? regionModel.get([
            'label',
            'formatter'
        ]) : regionModel.get([
            'emphasis',
            'label',
            'formatter'
        ]);
        var params = {
            name: name
        };
        if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(formatter)) {
            params.status = status;
            return formatter(params);
        } else if ($7a1bd9c2710fea0d$export$844ec244b1367d54(formatter)) return formatter.replace('{a}', name != null ? name : '');
    };
    GeoModel.prototype.setZoom = function(zoom) {
        this.option.zoom = zoom;
    };
    GeoModel.prototype.setCenter = function(center) {
        this.option.center = center;
    };
    // PENGING If selectedMode is null ?
    GeoModel.prototype.select = function(name) {
        var option = this.option;
        var selectedMode = option.selectedMode;
        if (!selectedMode) return;
        if (selectedMode !== 'multiple') option.selectedMap = null;
        var selectedMap = option.selectedMap || (option.selectedMap = {});
        selectedMap[name] = true;
    };
    GeoModel.prototype.unSelect = function(name) {
        var selectedMap = this.option.selectedMap;
        if (selectedMap) selectedMap[name] = false;
    };
    GeoModel.prototype.toggleSelected = function(name) {
        this[this.isSelected(name) ? 'unSelect' : 'select'](name);
    };
    GeoModel.prototype.isSelected = function(name) {
        var selectedMap = this.option.selectedMap;
        return !!(selectedMap && selectedMap[name]);
    };
    GeoModel.type = 'geo';
    GeoModel.layoutMode = 'box';
    GeoModel.defaultOption = {
        // zlevel: 0,
        z: 0,
        show: true,
        left: 'center',
        top: 'center',
        // Default value:
        // for geoSVG source: 1,
        // for geoJSON source: 0.75.
        aspectScale: null,
        // /// Layout with center and size
        // If you want to put map in a fixed size box with right aspect ratio
        // This two properties may be more convenient
        // layoutCenter: [50%, 50%]
        // layoutSize: 100
        silent: false,
        // Map type
        map: '',
        // Define left-top, right-bottom coords to control view
        // For example, [ [180, 90], [-180, -90] ]
        boundingCoords: null,
        // Default on center of map
        center: null,
        zoom: 1,
        scaleLimit: null,
        // selectedMode: false
        label: {
            show: false,
            color: '#000'
        },
        itemStyle: {
            borderWidth: 0.5,
            borderColor: '#444'
        },
        emphasis: {
            label: {
                show: true,
                color: 'rgb(100,0,0)'
            },
            itemStyle: {
                color: 'rgba(255,215,0,0.8)'
            }
        },
        select: {
            label: {
                show: true,
                color: 'rgb(100,0,0)'
            },
            itemStyle: {
                color: 'rgba(255,215,0,0.8)'
            }
        },
        regions: []
    };
    return GeoModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $4ff027656cc71ef0$export$2e2bcd8739ae039 = $4ff027656cc71ef0$var$GeoModel;





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $26ced9bb0cf549b8$var$GeoView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(GeoView, _super);
    function GeoView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GeoView.type;
        _this.focusBlurEnabled = true;
        return _this;
    }
    GeoView.prototype.init = function(ecModel, api) {
        this._api = api;
    };
    GeoView.prototype.render = function(geoModel, ecModel, api, payload) {
        this._model = geoModel;
        if (!geoModel.get('show')) {
            this._mapDraw && this._mapDraw.remove();
            this._mapDraw = null;
            return;
        }
        if (!this._mapDraw) this._mapDraw = new (0, $ad029c27e0f2a7ab$export$2e2bcd8739ae039)(api);
        var mapDraw = this._mapDraw;
        mapDraw.draw(geoModel, ecModel, api, this, payload);
        mapDraw.group.on('click', this._handleRegionClick, this);
        mapDraw.group.silent = geoModel.get('silent');
        this.group.add(mapDraw.group);
        this.updateSelectStatus(geoModel, ecModel, api);
    };
    GeoView.prototype._handleRegionClick = function(e) {
        var eventData;
        (0, $808c5a2823518f68$export$8a4fca9e04eb4df6)(e.target, function(current) {
            return (eventData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(current).eventData) != null;
        }, true);
        if (eventData) this._api.dispatchAction({
            type: 'geoToggleSelect',
            geoId: this._model.id,
            name: eventData.name
        });
    };
    GeoView.prototype.updateSelectStatus = function(model, ecModel, api) {
        var _this = this;
        this._mapDraw.group.traverse(function(node) {
            var eventData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(node).eventData;
            if (eventData) {
                _this._model.isSelected(eventData.name) ? api.enterSelect(node) : api.leaveSelect(node);
                // No need to traverse children.
                return true;
            }
        });
    };
    GeoView.prototype.findHighDownDispatchers = function(name) {
        return this._mapDraw && this._mapDraw.findHighDownDispatchers(name, this._model);
    };
    GeoView.prototype.dispose = function() {
        this._mapDraw && this._mapDraw.remove();
    };
    GeoView.type = 'geo';
    return GeoView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $26ced9bb0cf549b8$export$2e2bcd8739ae039 = $26ced9bb0cf549b8$var$GeoView;



function $8082b8b129488d44$var$registerMap(mapName, geoJson, specialAreas) {
    (0, $09550a1229dcb4ad$export$2e2bcd8739ae039).registerMap(mapName, geoJson, specialAreas);
}
function $8082b8b129488d44$export$4b3e715f166fdd78(registers) {
    registers.registerCoordinateSystem('geo', (0, $303164fe3ecc2dc5$export$2e2bcd8739ae039));
    registers.registerComponentModel((0, $4ff027656cc71ef0$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $26ced9bb0cf549b8$export$2e2bcd8739ae039));
    registers.registerImpl('registerMap', $8082b8b129488d44$var$registerMap);
    registers.registerImpl('getMap', function(mapName) {
        return (0, $09550a1229dcb4ad$export$2e2bcd8739ae039).getMapForUser(mapName);
    });
    function makeAction(method, actionInfo) {
        actionInfo.update = 'geo:updateSelectStatus';
        registers.registerAction(actionInfo, function(payload, ecModel) {
            var selected = {};
            var allSelected = [];
            ecModel.eachComponent({
                mainType: 'geo',
                query: payload
            }, function(geoModel) {
                geoModel[method](payload.name);
                var geo = geoModel.coordinateSystem;
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(geo.regions, function(region) {
                    selected[region.name] = geoModel.isSelected(region.name) || false;
                });
                // Notice: there might be duplicated name in different regions.
                var names = [];
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(selected, function(v, name) {
                    selected[name] && names.push(name);
                });
                allSelected.push({
                    geoIndex: geoModel.componentIndex,
                    // Use singular, the same naming convention as the event `selectchanged`.
                    name: names
                });
            });
            return {
                selected: selected,
                allSelected: allSelected,
                name: payload.name
            };
        });
    }
    makeAction('toggleSelected', {
        type: 'geoToggleSelect',
        event: 'geoselectchanged'
    });
    makeAction('select', {
        type: 'geoSelect',
        event: 'geoselected'
    });
    makeAction('unSelect', {
        type: 'geoUnSelect',
        event: 'geounselected'
    });
    /**
   * @payload
   * @property {string} [componentType=series]
   * @property {number} [dx]
   * @property {number} [dy]
   * @property {number} [zoom]
   * @property {number} [originX]
   * @property {number} [originY]
   */ registers.registerAction({
        type: 'geoRoam',
        event: 'geoRoam',
        update: 'updateTransform'
    }, function(payload, ecModel, api) {
        var componentType = payload.componentType || 'series';
        ecModel.eachComponent({
            mainType: componentType,
            query: payload
        }, function(componentModel) {
            var geo = componentModel.coordinateSystem;
            if (geo.type !== 'geo') return;
            var res = (0, $799fe5cfb5042219$export$797ecc50d262ebd8)(geo, payload, componentModel.get('scaleLimit'), api);
            componentModel.setCenter && componentModel.setCenter(res.center);
            componentModel.setZoom && componentModel.setZoom(res.zoom);
            // All map series with same `map` use the same geo coordinate system
            // So the center and zoom must be in sync. Include the series not selected by legend
            if (componentType === 'series') (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(componentModel.seriesGroup, function(seriesModel) {
                seriesModel.setCenter(res.center);
                seriesModel.setZoom(res.zoom);
            });
        });
    });
}


function $6c94070aa7d5e098$export$4b3e715f166fdd78(registers) {
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $8082b8b129488d44$export$4b3e715f166fdd78));
    registers.registerChartView((0, $1c3add93106395a4$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $f2f4aa5429e1d3d3$export$2e2bcd8739ae039));
    registers.registerLayout((0, $53e61890435fb2d8$export$2e2bcd8739ae039));
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, (0, $5e3d42588445ae72$export$2e2bcd8739ae039));
    (0, $e855ccf7eff48bce$export$62942ba95693dbfc)('map', registers.registerAction);
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $9e57680b9c04f083$var$DEFAULT_SMOOTH = 0.3;
var $9e57680b9c04f083$var$ParallelView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ParallelView, _super);
    function ParallelView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ParallelView.type;
        _this._dataGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        _this._initialized = false;
        return _this;
    }
    ParallelView.prototype.init = function() {
        this.group.add(this._dataGroup);
    };
    /**
   * @override
   */ ParallelView.prototype.render = function(seriesModel, ecModel, api, payload) {
        // Clear previously rendered progressive elements.
        this._progressiveEls = null;
        var dataGroup = this._dataGroup;
        var data = seriesModel.getData();
        var oldData = this._data;
        var coordSys = seriesModel.coordinateSystem;
        var dimensions = coordSys.dimensions;
        var seriesScope = $9e57680b9c04f083$var$makeSeriesScope(seriesModel);
        data.diff(oldData).add(add).update(update).remove(remove).execute();
        function add(newDataIndex) {
            var line = $9e57680b9c04f083$var$addEl(data, dataGroup, newDataIndex, dimensions, coordSys);
            $9e57680b9c04f083$var$updateElCommon(line, data, newDataIndex, seriesScope);
        }
        function update(newDataIndex, oldDataIndex) {
            var line = oldData.getItemGraphicEl(oldDataIndex);
            var points = $9e57680b9c04f083$var$createLinePoints(data, newDataIndex, dimensions, coordSys);
            data.setItemGraphicEl(newDataIndex, line);
            $8b353638fbedfefa$export$c8dce3c08436e91e(line, {
                shape: {
                    points: points
                }
            }, seriesModel, newDataIndex);
            (0, $8b353638fbedfefa$export$bca7290a9faf0ec9)(line);
            $9e57680b9c04f083$var$updateElCommon(line, data, newDataIndex, seriesScope);
        }
        function remove(oldDataIndex) {
            var line = oldData.getItemGraphicEl(oldDataIndex);
            dataGroup.remove(line);
        }
        // First create
        if (!this._initialized) {
            this._initialized = true;
            var clipPath = $9e57680b9c04f083$var$createGridClipShape(coordSys, seriesModel, function() {
                // Callback will be invoked immediately if there is no animation
                setTimeout(function() {
                    dataGroup.removeClipPath();
                });
            });
            dataGroup.setClipPath(clipPath);
        }
        this._data = data;
    };
    ParallelView.prototype.incrementalPrepareRender = function(seriesModel, ecModel, api) {
        this._initialized = true;
        this._data = null;
        this._dataGroup.removeAll();
    };
    ParallelView.prototype.incrementalRender = function(taskParams, seriesModel, ecModel) {
        var data = seriesModel.getData();
        var coordSys = seriesModel.coordinateSystem;
        var dimensions = coordSys.dimensions;
        var seriesScope = $9e57680b9c04f083$var$makeSeriesScope(seriesModel);
        var progressiveEls = this._progressiveEls = [];
        for(var dataIndex = taskParams.start; dataIndex < taskParams.end; dataIndex++){
            var line = $9e57680b9c04f083$var$addEl(data, this._dataGroup, dataIndex, dimensions, coordSys);
            line.incremental = true;
            $9e57680b9c04f083$var$updateElCommon(line, data, dataIndex, seriesScope);
            progressiveEls.push(line);
        }
    };
    ParallelView.prototype.remove = function() {
        this._dataGroup && this._dataGroup.removeAll();
        this._data = null;
    };
    ParallelView.type = 'parallel';
    return ParallelView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
function $9e57680b9c04f083$var$createGridClipShape(coordSys, seriesModel, cb) {
    var parallelModel = coordSys.model;
    var rect = coordSys.getRect();
    var rectEl = new $419e5ff2f303755e$export$2e2bcd8739ae039({
        shape: {
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height
        }
    });
    var dim = parallelModel.get('layout') === 'horizontal' ? 'width' : 'height';
    rectEl.setShape(dim, 0);
    $8b353638fbedfefa$export$a121566aadcfe021(rectEl, {
        shape: {
            width: rect.width,
            height: rect.height
        }
    }, seriesModel, cb);
    return rectEl;
}
function $9e57680b9c04f083$var$createLinePoints(data, dataIndex, dimensions, coordSys) {
    var points = [];
    for(var i = 0; i < dimensions.length; i++){
        var dimName = dimensions[i];
        var value = data.get(data.mapDimension(dimName), dataIndex);
        if (!$9e57680b9c04f083$var$isEmptyValue(value, coordSys.getAxis(dimName).type)) points.push(coordSys.dataToPoint(value, dimName));
    }
    return points;
}
function $9e57680b9c04f083$var$addEl(data, dataGroup, dataIndex, dimensions, coordSys) {
    var points = $9e57680b9c04f083$var$createLinePoints(data, dataIndex, dimensions, coordSys);
    var line = new $d28119f30e6bb670$export$2e2bcd8739ae039({
        shape: {
            points: points
        },
        // silent: true,
        z2: 10
    });
    dataGroup.add(line);
    data.setItemGraphicEl(dataIndex, line);
    return line;
}
function $9e57680b9c04f083$var$makeSeriesScope(seriesModel) {
    var smooth = seriesModel.get('smooth', true);
    smooth === true && (smooth = $9e57680b9c04f083$var$DEFAULT_SMOOTH);
    smooth = (0, $cfc1f3b422a3185f$export$8b4007b942b45a96)(smooth);
    (0, $7a1bd9c2710fea0d$export$7d667b9a0c48c975)(smooth) && (smooth = 0);
    return {
        smooth: smooth
    };
}
function $9e57680b9c04f083$var$updateElCommon(el, data, dataIndex, seriesScope) {
    el.useStyle(data.getItemVisual(dataIndex, 'style'));
    el.style.fill = null;
    el.setShape('smooth', seriesScope.smooth);
    var itemModel = data.getItemModel(dataIndex);
    var emphasisModel = itemModel.getModel('emphasis');
    (0, $2bf82c0980125b62$export$48b68047d330bbc9)(el, itemModel, 'lineStyle');
    (0, $2bf82c0980125b62$export$e51187539ff11209)(el, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
}
// function simpleDiff(oldData, newData, dimensions) {
//     let oldLen;
//     if (!oldData
//         || !oldData.__plProgressive
//         || (oldLen = oldData.count()) !== newData.count()
//     ) {
//         return true;
//     }
//     let dimLen = dimensions.length;
//     for (let i = 0; i < oldLen; i++) {
//         for (let j = 0; j < dimLen; j++) {
//             if (oldData.get(dimensions[j], i) !== newData.get(dimensions[j], i)) {
//                 return true;
//             }
//         }
//     }
//     return false;
// }
// FIXME put in common util?
function $9e57680b9c04f083$var$isEmptyValue(val, axisType) {
    return axisType === 'category' ? val == null : val == null || isNaN(val); // axisType === 'value'
}
var $9e57680b9c04f083$export$2e2bcd8739ae039 = $9e57680b9c04f083$var$ParallelView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $5d63691998e05817$var$ParallelSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ParallelSeriesModel, _super);
    function ParallelSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ParallelSeriesModel.type;
        _this.visualStyleAccessPath = 'lineStyle';
        _this.visualDrawType = 'stroke';
        return _this;
    }
    ParallelSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $8afdec5f59c90781$export$2e2bcd8739ae039)(null, this, {
            useEncodeDefaulter: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)($5d63691998e05817$var$makeDefaultEncode, null, this)
        });
    };
    /**
   * User can get data raw indices on 'axisAreaSelected' event received.
   *
   * @return Raw indices
   */ ParallelSeriesModel.prototype.getRawIndicesByActiveState = function(activeState) {
        var coordSys = this.coordinateSystem;
        var data = this.getData();
        var indices = [];
        coordSys.eachActiveState(data, function(theActiveState, dataIndex) {
            if (activeState === theActiveState) indices.push(data.getRawIndex(dataIndex));
        });
        return indices;
    };
    ParallelSeriesModel.type = 'series.parallel';
    ParallelSeriesModel.dependencies = [
        'parallel'
    ];
    ParallelSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        coordinateSystem: 'parallel',
        parallelIndex: 0,
        label: {
            show: false
        },
        inactiveOpacity: 0.05,
        activeOpacity: 1,
        lineStyle: {
            width: 1,
            opacity: 0.45,
            type: 'solid'
        },
        emphasis: {
            label: {
                show: false
            }
        },
        progressive: 500,
        smooth: false,
        animationEasing: 'linear'
    };
    return ParallelSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
function $5d63691998e05817$var$makeDefaultEncode(seriesModel) {
    // The mapping of parallelAxis dimension to data dimension can
    // be specified in parallelAxis.option.dim. For example, if
    // parallelAxis.option.dim is 'dim3', it mapping to the third
    // dimension of data. But `data.encode` has higher priority.
    // Moreover, parallelModel.dimension should not be regarded as data
    // dimensions. Consider dimensions = ['dim4', 'dim2', 'dim6'];
    var parallelModel = seriesModel.ecModel.getComponent('parallel', seriesModel.get('parallelIndex'));
    if (!parallelModel) return;
    var encodeDefine = {};
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(parallelModel.dimensions, function(axisDim) {
        var dataDimIndex = $5d63691998e05817$var$convertDimNameToNumber(axisDim);
        encodeDefine[axisDim] = dataDimIndex;
    });
    return encodeDefine;
}
function $5d63691998e05817$var$convertDimNameToNumber(dimName) {
    return +dimName.replace('dim', '');
}
var $5d63691998e05817$export$2e2bcd8739ae039 = $5d63691998e05817$var$ParallelSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $8148e21d655f67c8$var$opacityAccessPath = [
    'lineStyle',
    'opacity'
];
var $8148e21d655f67c8$var$parallelVisual = {
    seriesType: 'parallel',
    reset: function(seriesModel, ecModel) {
        var coordSys = seriesModel.coordinateSystem;
        var opacityMap = {
            normal: seriesModel.get([
                'lineStyle',
                'opacity'
            ]),
            active: seriesModel.get('activeOpacity'),
            inactive: seriesModel.get('inactiveOpacity')
        };
        return {
            progress: function(params, data) {
                coordSys.eachActiveState(data, function(activeState, dataIndex) {
                    var opacity = opacityMap[activeState];
                    if (activeState === 'normal' && data.hasItemOption) {
                        var itemOpacity = data.getItemModel(dataIndex).get($8148e21d655f67c8$var$opacityAccessPath, true);
                        itemOpacity != null && (opacity = itemOpacity);
                    }
                    var existsStyle = data.ensureUniqueItemVisual(dataIndex, 'style');
                    existsStyle.opacity = opacity;
                }, params.start, params.end);
            }
        };
    }
};
var $8148e21d655f67c8$export$2e2bcd8739ae039 = $8148e21d655f67c8$var$parallelVisual;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $30173db3404062fa$export$2e2bcd8739ae039(option) {
    $30173db3404062fa$var$createParallelIfNeeded(option);
    $30173db3404062fa$var$mergeAxisOptionFromParallel(option);
}
/**
 * Create a parallel coordinate if not exists.
 * @inner
 */ function $30173db3404062fa$var$createParallelIfNeeded(option) {
    if (option.parallel) return;
    var hasParallelSeries = false;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(option.series, function(seriesOpt) {
        if (seriesOpt && seriesOpt.type === 'parallel') hasParallelSeries = true;
    });
    if (hasParallelSeries) option.parallel = [
        {}
    ];
}
/**
 * Merge aixs definition from parallel option (if exists) to axis option.
 * @inner
 */ function $30173db3404062fa$var$mergeAxisOptionFromParallel(option) {
    var axes = $76d619f648247e6d$export$4f07b212a02c8051(option.parallelAxis);
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(axes, function(axisOption) {
        if (!$7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(axisOption)) return;
        var parallelIndex = axisOption.parallelIndex || 0;
        var parallelOption = $76d619f648247e6d$export$4f07b212a02c8051(option.parallel)[parallelIndex];
        if (parallelOption && parallelOption.parallelAxisDefault) $7a1bd9c2710fea0d$export$4950aa0f605343fb(axisOption, parallelOption.parallelAxisDefault, false);
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $ccce4513d4baec6a$var$CLICK_THRESHOLD = 5; // > 4
var $ccce4513d4baec6a$var$ParallelView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ParallelView, _super);
    function ParallelView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ParallelView.type;
        return _this;
    }
    ParallelView.prototype.render = function(parallelModel, ecModel, api) {
        this._model = parallelModel;
        this._api = api;
        if (!this._handlers) {
            this._handlers = {};
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($ccce4513d4baec6a$var$handlers, function(handler, eventName) {
                api.getZr().on(eventName, this._handlers[eventName] = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(handler, this));
            }, this);
        }
        (0, $c98659a9437a3d2e$export$958e3e1a02eac4b6)(this, '_throttledDispatchExpand', parallelModel.get('axisExpandRate'), 'fixRate');
    };
    ParallelView.prototype.dispose = function(ecModel, api) {
        (0, $c98659a9437a3d2e$export$42ffd38884aecdac)(this, '_throttledDispatchExpand');
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._handlers, function(handler, eventName) {
            api.getZr().off(eventName, handler);
        });
        this._handlers = null;
    };
    /**
   * @internal
   * @param {Object} [opt] If null, cancel the last action triggering for debounce.
   */ ParallelView.prototype._throttledDispatchExpand = function(opt) {
        this._dispatchExpand(opt);
    };
    /**
   * @internal
   */ ParallelView.prototype._dispatchExpand = function(opt) {
        opt && this._api.dispatchAction((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
            type: 'parallelAxisExpand'
        }, opt));
    };
    ParallelView.type = 'parallel';
    return ParallelView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $ccce4513d4baec6a$var$handlers = {
    mousedown: function(e) {
        if ($ccce4513d4baec6a$var$checkTrigger(this, 'click')) this._mouseDownPoint = [
            e.offsetX,
            e.offsetY
        ];
    },
    mouseup: function(e) {
        var mouseDownPoint = this._mouseDownPoint;
        if ($ccce4513d4baec6a$var$checkTrigger(this, 'click') && mouseDownPoint) {
            var point = [
                e.offsetX,
                e.offsetY
            ];
            var dist = Math.pow(mouseDownPoint[0] - point[0], 2) + Math.pow(mouseDownPoint[1] - point[1], 2);
            if (dist > $ccce4513d4baec6a$var$CLICK_THRESHOLD) return;
            var result = this._model.coordinateSystem.getSlidedAxisExpandWindow([
                e.offsetX,
                e.offsetY
            ]);
            result.behavior !== 'none' && this._dispatchExpand({
                axisExpandWindow: result.axisExpandWindow
            });
        }
        this._mouseDownPoint = null;
    },
    mousemove: function(e) {
        // Should do nothing when brushing.
        if (this._mouseDownPoint || !$ccce4513d4baec6a$var$checkTrigger(this, 'mousemove')) return;
        var model = this._model;
        var result = model.coordinateSystem.getSlidedAxisExpandWindow([
            e.offsetX,
            e.offsetY
        ]);
        var behavior = result.behavior;
        behavior === 'jump' && this._throttledDispatchExpand.debounceNextCall(model.get('axisExpandDebounce'));
        this._throttledDispatchExpand(behavior === 'none' ? null // Cancel the last trigger, in case that mouse slide out of the area quickly.
         : {
            axisExpandWindow: result.axisExpandWindow,
            // Jumping uses animation, and sliding suppresses animation.
            animation: behavior === 'jump' ? null : {
                duration: 0 // Disable animation.
            }
        });
    }
};
function $ccce4513d4baec6a$var$checkTrigger(view, triggerOn) {
    var model = view._model;
    return model.get('axisExpandable') && model.get('axisExpandTriggerOn') === triggerOn;
}
var $ccce4513d4baec6a$export$2e2bcd8739ae039 = $ccce4513d4baec6a$var$ParallelView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $a14d8e1511adaa1e$var$ParallelModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ParallelModel, _super);
    function ParallelModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ParallelModel.type;
        return _this;
    }
    ParallelModel.prototype.init = function() {
        _super.prototype.init.apply(this, arguments);
        this.mergeOption({});
    };
    ParallelModel.prototype.mergeOption = function(newOption) {
        var thisOption = this.option;
        newOption && $7a1bd9c2710fea0d$export$4950aa0f605343fb(thisOption, newOption, true);
        this._initDimensions();
    };
    /**
   * Whether series or axis is in this coordinate system.
   */ ParallelModel.prototype.contains = function(model, ecModel) {
        var parallelIndex = model.get('parallelIndex');
        return parallelIndex != null && ecModel.getComponent('parallel', parallelIndex) === this;
    };
    ParallelModel.prototype.setAxisExpand = function(opt) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43([
            'axisExpandable',
            'axisExpandCenter',
            'axisExpandCount',
            'axisExpandWidth',
            'axisExpandWindow'
        ], function(name) {
            if (opt.hasOwnProperty(name)) // @ts-ignore FIXME: why "never" inferred in this.option[name]?
            this.option[name] = opt[name];
        }, this);
    };
    ParallelModel.prototype._initDimensions = function() {
        var dimensions = this.dimensions = [];
        var parallelAxisIndex = this.parallelAxisIndex = [];
        var axisModels = $7a1bd9c2710fea0d$export$3dea766d36a8935f(this.ecModel.queryComponents({
            mainType: 'parallelAxis'
        }), function(axisModel) {
            // Can not use this.contains here, because
            // initialization has not been completed yet.
            return (axisModel.get('parallelIndex') || 0) === this.componentIndex;
        }, this);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(axisModels, function(axisModel) {
            dimensions.push('dim' + axisModel.get('dim'));
            parallelAxisIndex.push(axisModel.componentIndex);
        });
    };
    ParallelModel.type = 'parallel';
    ParallelModel.dependencies = [
        'parallelAxis'
    ];
    ParallelModel.layoutMode = 'box';
    ParallelModel.defaultOption = {
        // zlevel: 0,
        z: 0,
        left: 80,
        top: 60,
        right: 80,
        bottom: 60,
        // width: {totalWidth} - left - right,
        // height: {totalHeight} - top - bottom,
        layout: 'horizontal',
        // FIXME
        // naming?
        axisExpandable: false,
        axisExpandCenter: null,
        axisExpandCount: 0,
        axisExpandWidth: 50,
        axisExpandRate: 17,
        axisExpandDebounce: 50,
        // [out, in, jumpTarget]. In percentage. If use [null, 0.05], null means full.
        // Do not doc to user until necessary.
        axisExpandSlideTriggerArea: [
            -0.15,
            0.05,
            0.4
        ],
        axisExpandTriggerOn: 'click',
        parallelAxisDefault: null
    };
    return ParallelModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $a14d8e1511adaa1e$export$2e2bcd8739ae039 = $a14d8e1511adaa1e$var$ParallelModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Parallel coordinate system creater.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Parallel Coordinates
 * <https://en.wikipedia.org/wiki/Parallel_coordinates>
 */ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $1754de95b9b9c398$var$Scale = /** @class */ function() {
    function Scale(setting) {
        this._setting = setting || {};
        this._extent = [
            Infinity,
            -Infinity
        ];
    }
    Scale.prototype.getSetting = function(name) {
        return this._setting[name];
    };
    /**
   * Set extent from data
   */ Scale.prototype.unionExtent = function(other) {
        var extent = this._extent;
        other[0] < extent[0] && (extent[0] = other[0]);
        other[1] > extent[1] && (extent[1] = other[1]);
    // not setExtent because in log axis it may transformed to power
    // this.setExtent(extent[0], extent[1]);
    };
    /**
   * Set extent from data
   */ Scale.prototype.unionExtentFromData = function(data, dim) {
        this.unionExtent(data.getApproximateExtent(dim));
    };
    /**
   * Get extent
   *
   * Extent is always in increase order.
   */ Scale.prototype.getExtent = function() {
        return this._extent.slice();
    };
    /**
   * Set extent
   */ Scale.prototype.setExtent = function(start, end) {
        var thisExtent = this._extent;
        if (!isNaN(start)) thisExtent[0] = start;
        if (!isNaN(end)) thisExtent[1] = end;
    };
    /**
   * If value is in extent range
   */ Scale.prototype.isInExtentRange = function(value) {
        return this._extent[0] <= value && this._extent[1] >= value;
    };
    /**
   * When axis extent depends on data and no data exists,
   * axis ticks should not be drawn, which is named 'blank'.
   */ Scale.prototype.isBlank = function() {
        return this._isBlank;
    };
    /**
   * When axis extent depends on data and no data exists,
   * axis ticks should not be drawn, which is named 'blank'.
   */ Scale.prototype.setBlank = function(isBlank) {
        this._isBlank = isBlank;
    };
    return Scale;
}();
$cd5f95cf03b4e3e7$export$241315e45585454d($1754de95b9b9c398$var$Scale);
var $1754de95b9b9c398$export$2e2bcd8739ae039 = $1754de95b9b9c398$var$Scale;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $57fe7cbbaae9fab0$var$uidBase = 0;
var $57fe7cbbaae9fab0$var$OrdinalMeta = /** @class */ function() {
    function OrdinalMeta(opt) {
        this.categories = opt.categories || [];
        this._needCollect = opt.needCollect;
        this._deduplication = opt.deduplication;
        this.uid = ++$57fe7cbbaae9fab0$var$uidBase;
    }
    OrdinalMeta.createByAxisModel = function(axisModel) {
        var option = axisModel.option;
        var data = option.data;
        var categories = data && (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(data, $57fe7cbbaae9fab0$var$getName);
        return new OrdinalMeta({
            categories: categories,
            needCollect: !categories,
            // deduplication is default in axis.
            deduplication: option.dedplication !== false
        });
    };
    OrdinalMeta.prototype.getOrdinal = function(category) {
        // @ts-ignore
        return this._getOrCreateMap().get(category);
    };
    /**
   * @return The ordinal. If not found, return NaN.
   */ OrdinalMeta.prototype.parseAndCollect = function(category) {
        var index;
        var needCollect = this._needCollect;
        // The value of category dim can be the index of the given category set.
        // This feature is only supported when !needCollect, because we should
        // consider a common case: a value is 2017, which is a number but is
        // expected to be tread as a category. This case usually happen in dataset,
        // where it happent to be no need of the index feature.
        if (!(0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(category) && !needCollect) return category;
        // Optimize for the scenario:
        // category is ['2012-01-01', '2012-01-02', ...], where the input
        // data has been ensured not duplicate and is large data.
        // Notice, if a dataset dimension provide categroies, usually echarts
        // should remove duplication except user tell echarts dont do that
        // (set axis.deduplication = false), because echarts do not know whether
        // the values in the category dimension has duplication (consider the
        // parallel-aqi example)
        if (needCollect && !this._deduplication) {
            index = this.categories.length;
            this.categories[index] = category;
            return index;
        }
        var map = this._getOrCreateMap();
        // @ts-ignore
        index = map.get(category);
        if (index == null) {
            if (needCollect) {
                index = this.categories.length;
                this.categories[index] = category;
                // @ts-ignore
                map.set(category, index);
            } else index = NaN;
        }
        return index;
    };
    // Consider big data, do not create map until needed.
    OrdinalMeta.prototype._getOrCreateMap = function() {
        return this._map || (this._map = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)(this.categories));
    };
    return OrdinalMeta;
}();
function $57fe7cbbaae9fab0$var$getName(obj) {
    if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(obj) && obj.value != null) return obj.value;
    else return obj + '';
}
var $57fe7cbbaae9fab0$export$2e2bcd8739ae039 = $57fe7cbbaae9fab0$var$OrdinalMeta;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $60f7f1f3e3996637$export$a8a5b03ea14764df(val) {
    var exp10 = Math.pow(10, (0, $cfc1f3b422a3185f$export$97256a17b20a0c24)(Math.abs(val)));
    var f = Math.abs(val / exp10);
    return f === 0 || f === 1 || f === 2 || f === 3 || f === 5;
}
function $60f7f1f3e3996637$export$dfc8cd28ed7b22a0(scale) {
    return scale.type === 'interval' || scale.type === 'log';
}
function $60f7f1f3e3996637$export$eeea879a611eb991(extent, splitNumber, minInterval, maxInterval) {
    var result = {};
    var span = extent[1] - extent[0];
    var interval = result.interval = (0, $cfc1f3b422a3185f$export$7a695fe44258210b)(span / splitNumber, true);
    if (minInterval != null && interval < minInterval) interval = result.interval = minInterval;
    if (maxInterval != null && interval > maxInterval) interval = result.interval = maxInterval;
    // Tow more digital for tick.
    var precision = result.intervalPrecision = $60f7f1f3e3996637$export$86a060b060d3d31a(interval);
    // Niced extent inside original extent
    var niceTickExtent = result.niceTickExtent = [
        (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(Math.ceil(extent[0] / interval) * interval, precision),
        (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(Math.floor(extent[1] / interval) * interval, precision)
    ];
    $60f7f1f3e3996637$export$624b8c8c438031ad(niceTickExtent, extent);
    return result;
}
function $60f7f1f3e3996637$export$f39031e8422f329d(interval) {
    var exp10 = Math.pow(10, (0, $cfc1f3b422a3185f$export$97256a17b20a0c24)(interval));
    // Increase interval
    var f = interval / exp10;
    if (!f) f = 1;
    else if (f === 2) f = 3;
    else if (f === 3) f = 5;
    else // f is 1 or 5
    f *= 2;
    return (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(f * exp10);
}
function $60f7f1f3e3996637$export$86a060b060d3d31a(interval) {
    // Tow more digital for tick.
    return (0, $cfc1f3b422a3185f$export$e0c74b50bbd10f68)(interval) + 2;
}
function $60f7f1f3e3996637$var$clamp(niceTickExtent, idx, extent) {
    niceTickExtent[idx] = Math.max(Math.min(niceTickExtent[idx], extent[1]), extent[0]);
}
function $60f7f1f3e3996637$export$624b8c8c438031ad(niceTickExtent, extent) {
    !isFinite(niceTickExtent[0]) && (niceTickExtent[0] = extent[0]);
    !isFinite(niceTickExtent[1]) && (niceTickExtent[1] = extent[1]);
    $60f7f1f3e3996637$var$clamp(niceTickExtent, 0, extent);
    $60f7f1f3e3996637$var$clamp(niceTickExtent, 1, extent);
    if (niceTickExtent[0] > niceTickExtent[1]) niceTickExtent[0] = niceTickExtent[1];
}
function $60f7f1f3e3996637$export$8893e2b90ba10d92(val, extent) {
    return val >= extent[0] && val <= extent[1];
}
function $60f7f1f3e3996637$export$a3295358bff77e(val, extent) {
    if (extent[1] === extent[0]) return 0.5;
    return (val - extent[0]) / (extent[1] - extent[0]);
}
function $60f7f1f3e3996637$export$dcdf75081b88279d(val, extent) {
    return val * (extent[1] - extent[0]) + extent[0];
}



var $6e82606ec775d365$var$OrdinalScale = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(OrdinalScale, _super);
    function OrdinalScale(setting) {
        var _this = _super.call(this, setting) || this;
        _this.type = 'ordinal';
        var ordinalMeta = _this.getSetting('ordinalMeta');
        // Caution: Should not use instanceof, consider ec-extensions using
        // import approach to get OrdinalMeta class.
        if (!ordinalMeta) ordinalMeta = new (0, $57fe7cbbaae9fab0$export$2e2bcd8739ae039)({});
        if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(ordinalMeta)) ordinalMeta = new (0, $57fe7cbbaae9fab0$export$2e2bcd8739ae039)({
            categories: (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(ordinalMeta, function(item) {
                return (0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(item) ? item.value : item;
            })
        });
        _this._ordinalMeta = ordinalMeta;
        _this._extent = _this.getSetting('extent') || [
            0,
            ordinalMeta.categories.length - 1
        ];
        return _this;
    }
    OrdinalScale.prototype.parse = function(val) {
        // Caution: Math.round(null) will return `0` rather than `NaN`
        if (val == null) return NaN;
        return (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(val) ? this._ordinalMeta.getOrdinal(val) : Math.round(val);
    };
    OrdinalScale.prototype.contain = function(rank) {
        rank = this.parse(rank);
        return $60f7f1f3e3996637$export$8893e2b90ba10d92(rank, this._extent) && this._ordinalMeta.categories[rank] != null;
    };
    /**
   * Normalize given rank or name to linear [0, 1]
   * @param val raw ordinal number.
   * @return normalized value in [0, 1].
   */ OrdinalScale.prototype.normalize = function(val) {
        val = this._getTickNumber(this.parse(val));
        return $60f7f1f3e3996637$export$a3295358bff77e(val, this._extent);
    };
    /**
   * @param val normalized value in [0, 1].
   * @return raw ordinal number.
   */ OrdinalScale.prototype.scale = function(val) {
        val = Math.round($60f7f1f3e3996637$export$dcdf75081b88279d(val, this._extent));
        return this.getRawOrdinalNumber(val);
    };
    OrdinalScale.prototype.getTicks = function() {
        var ticks = [];
        var extent = this._extent;
        var rank = extent[0];
        while(rank <= extent[1]){
            ticks.push({
                value: rank
            });
            rank++;
        }
        return ticks;
    };
    OrdinalScale.prototype.getMinorTicks = function(splitNumber) {
        // Not support.
        return;
    };
    /**
   * @see `Ordinal['_ordinalNumbersByTick']`
   */ OrdinalScale.prototype.setSortInfo = function(info) {
        if (info == null) {
            this._ordinalNumbersByTick = this._ticksByOrdinalNumber = null;
            return;
        }
        var infoOrdinalNumbers = info.ordinalNumbers;
        var ordinalsByTick = this._ordinalNumbersByTick = [];
        var ticksByOrdinal = this._ticksByOrdinalNumber = [];
        // Unnecessary support negative tick in `realtimeSort`.
        var tickNum = 0;
        var allCategoryLen = this._ordinalMeta.categories.length;
        for(var len = Math.min(allCategoryLen, infoOrdinalNumbers.length); tickNum < len; ++tickNum){
            var ordinalNumber = infoOrdinalNumbers[tickNum];
            ordinalsByTick[tickNum] = ordinalNumber;
            ticksByOrdinal[ordinalNumber] = tickNum;
        }
        // Handle that `series.data` only covers part of the `axis.category.data`.
        var unusedOrdinal = 0;
        for(; tickNum < allCategoryLen; ++tickNum){
            while(ticksByOrdinal[unusedOrdinal] != null)unusedOrdinal++;
            ordinalsByTick.push(unusedOrdinal);
            ticksByOrdinal[unusedOrdinal] = tickNum;
        }
    };
    OrdinalScale.prototype._getTickNumber = function(ordinal) {
        var ticksByOrdinalNumber = this._ticksByOrdinalNumber;
        // also support ordinal out of range of `ordinalMeta.categories.length`,
        // where ordinal numbers are used as tick value directly.
        return ticksByOrdinalNumber && ordinal >= 0 && ordinal < ticksByOrdinalNumber.length ? ticksByOrdinalNumber[ordinal] : ordinal;
    };
    /**
   * @usage
   * ```js
   * const ordinalNumber = ordinalScale.getRawOrdinalNumber(tickVal);
   *
   * // case0
   * const rawOrdinalValue = axisModel.getCategories()[ordinalNumber];
   * // case1
   * const rawOrdinalValue = this._ordinalMeta.categories[ordinalNumber];
   * // case2
   * const coord = axis.dataToCoord(ordinalNumber);
   * ```
   *
   * @param {OrdinalNumber} tickNumber index of display
   */ OrdinalScale.prototype.getRawOrdinalNumber = function(tickNumber) {
        var ordinalNumbersByTick = this._ordinalNumbersByTick;
        // tickNumber may be out of range, e.g., when axis max is larger than `ordinalMeta.categories.length`.,
        // where ordinal numbers are used as tick value directly.
        return ordinalNumbersByTick && tickNumber >= 0 && tickNumber < ordinalNumbersByTick.length ? ordinalNumbersByTick[tickNumber] : tickNumber;
    };
    /**
   * Get item on tick
   */ OrdinalScale.prototype.getLabel = function(tick) {
        if (!this.isBlank()) {
            var ordinalNumber = this.getRawOrdinalNumber(tick.value);
            var cateogry = this._ordinalMeta.categories[ordinalNumber];
            // Note that if no data, ordinalMeta.categories is an empty array.
            // Return empty if it's not exist.
            return cateogry == null ? '' : cateogry + '';
        }
    };
    OrdinalScale.prototype.count = function() {
        return this._extent[1] - this._extent[0] + 1;
    };
    OrdinalScale.prototype.unionExtentFromData = function(data, dim) {
        this.unionExtent(data.getApproximateExtent(dim));
    };
    /**
   * @override
   * If value is in extent range
   */ OrdinalScale.prototype.isInExtentRange = function(value) {
        value = this._getTickNumber(value);
        return this._extent[0] <= value && this._extent[1] >= value;
    };
    OrdinalScale.prototype.getOrdinalMeta = function() {
        return this._ordinalMeta;
    };
    OrdinalScale.prototype.calcNiceTicks = function() {};
    OrdinalScale.prototype.calcNiceExtent = function() {};
    OrdinalScale.type = 'ordinal';
    return OrdinalScale;
}((0, $1754de95b9b9c398$export$2e2bcd8739ae039));
(0, $1754de95b9b9c398$export$2e2bcd8739ae039).registerClass($6e82606ec775d365$var$OrdinalScale);
var $6e82606ec775d365$export$2e2bcd8739ae039 = $6e82606ec775d365$var$OrdinalScale;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $dddb89ade16db3d5$var$roundNumber = $cfc1f3b422a3185f$export$2077e0241d6afd3c;
var $dddb89ade16db3d5$var$IntervalScale = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(IntervalScale, _super);
    function IntervalScale() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'interval';
        // Step is calculated in adjustExtent.
        _this._interval = 0;
        _this._intervalPrecision = 2;
        return _this;
    }
    IntervalScale.prototype.parse = function(val) {
        return val;
    };
    IntervalScale.prototype.contain = function(val) {
        return $60f7f1f3e3996637$export$8893e2b90ba10d92(val, this._extent);
    };
    IntervalScale.prototype.normalize = function(val) {
        return $60f7f1f3e3996637$export$a3295358bff77e(val, this._extent);
    };
    IntervalScale.prototype.scale = function(val) {
        return $60f7f1f3e3996637$export$dcdf75081b88279d(val, this._extent);
    };
    IntervalScale.prototype.setExtent = function(start, end) {
        var thisExtent = this._extent;
        // start,end may be a Number like '25',so...
        if (!isNaN(start)) thisExtent[0] = parseFloat(start);
        if (!isNaN(end)) thisExtent[1] = parseFloat(end);
    };
    IntervalScale.prototype.unionExtent = function(other) {
        var extent = this._extent;
        other[0] < extent[0] && (extent[0] = other[0]);
        other[1] > extent[1] && (extent[1] = other[1]);
        // unionExtent may called by it's sub classes
        this.setExtent(extent[0], extent[1]);
    };
    IntervalScale.prototype.getInterval = function() {
        return this._interval;
    };
    IntervalScale.prototype.setInterval = function(interval) {
        this._interval = interval;
        // Dropped auto calculated niceExtent and use user-set extent.
        // We assume user wants to set both interval, min, max to get a better result.
        this._niceExtent = this._extent.slice();
        this._intervalPrecision = $60f7f1f3e3996637$export$86a060b060d3d31a(interval);
    };
    /**
   * @param expandToNicedExtent Whether expand the ticks to niced extent.
   */ IntervalScale.prototype.getTicks = function(expandToNicedExtent) {
        var interval = this._interval;
        var extent = this._extent;
        var niceTickExtent = this._niceExtent;
        var intervalPrecision = this._intervalPrecision;
        var ticks = [];
        // If interval is 0, return [];
        if (!interval) return ticks;
        // Consider this case: using dataZoom toolbox, zoom and zoom.
        var safeLimit = 10000;
        if (extent[0] < niceTickExtent[0]) {
            if (expandToNicedExtent) ticks.push({
                value: $dddb89ade16db3d5$var$roundNumber(niceTickExtent[0] - interval, intervalPrecision)
            });
            else ticks.push({
                value: extent[0]
            });
        }
        var tick = niceTickExtent[0];
        while(tick <= niceTickExtent[1]){
            ticks.push({
                value: tick
            });
            // Avoid rounding error
            tick = $dddb89ade16db3d5$var$roundNumber(tick + interval, intervalPrecision);
            if (tick === ticks[ticks.length - 1].value) break;
            if (ticks.length > safeLimit) return [];
        }
        // Consider this case: the last item of ticks is smaller
        // than niceTickExtent[1] and niceTickExtent[1] === extent[1].
        var lastNiceTick = ticks.length ? ticks[ticks.length - 1].value : niceTickExtent[1];
        if (extent[1] > lastNiceTick) {
            if (expandToNicedExtent) ticks.push({
                value: $dddb89ade16db3d5$var$roundNumber(lastNiceTick + interval, intervalPrecision)
            });
            else ticks.push({
                value: extent[1]
            });
        }
        return ticks;
    };
    IntervalScale.prototype.getMinorTicks = function(splitNumber) {
        var ticks = this.getTicks(true);
        var minorTicks = [];
        var extent = this.getExtent();
        for(var i = 1; i < ticks.length; i++){
            var nextTick = ticks[i];
            var prevTick = ticks[i - 1];
            var count = 0;
            var minorTicksGroup = [];
            var interval = nextTick.value - prevTick.value;
            var minorInterval = interval / splitNumber;
            while(count < splitNumber - 1){
                var minorTick = $dddb89ade16db3d5$var$roundNumber(prevTick.value + (count + 1) * minorInterval);
                // For the first and last interval. The count may be less than splitNumber.
                if (minorTick > extent[0] && minorTick < extent[1]) minorTicksGroup.push(minorTick);
                count++;
            }
            minorTicks.push(minorTicksGroup);
        }
        return minorTicks;
    };
    /**
   * @param opt.precision If 'auto', use nice presision.
   * @param opt.pad returns 1.50 but not 1.5 if precision is 2.
   */ IntervalScale.prototype.getLabel = function(data, opt) {
        if (data == null) return '';
        var precision = opt && opt.precision;
        if (precision == null) precision = $cfc1f3b422a3185f$export$e0c74b50bbd10f68(data.value) || 0;
        else if (precision === 'auto') // Should be more precise then tick.
        precision = this._intervalPrecision;
        // (1) If `precision` is set, 12.005 should be display as '12.00500'.
        // (2) Use roundNumber (toFixed) to avoid scientific notation like '3.5e-7'.
        var dataNum = $dddb89ade16db3d5$var$roundNumber(data.value, precision, true);
        return $c84c9521536c601a$export$b6fe44657ce35c42(dataNum);
    };
    /**
   * @param splitNumber By default `5`.
   */ IntervalScale.prototype.calcNiceTicks = function(splitNumber, minInterval, maxInterval) {
        splitNumber = splitNumber || 5;
        var extent = this._extent;
        var span = extent[1] - extent[0];
        if (!isFinite(span)) return;
        // User may set axis min 0 and data are all negative
        // FIXME If it needs to reverse ?
        if (span < 0) {
            span = -span;
            extent.reverse();
        }
        var result = $60f7f1f3e3996637$export$eeea879a611eb991(extent, splitNumber, minInterval, maxInterval);
        this._intervalPrecision = result.intervalPrecision;
        this._interval = result.interval;
        this._niceExtent = result.niceTickExtent;
    };
    IntervalScale.prototype.calcNiceExtent = function(opt) {
        var extent = this._extent;
        // If extent start and end are same, expand them
        if (extent[0] === extent[1]) {
            if (extent[0] !== 0) {
                // Expand extent
                // Note that extents can be both negative. See #13154
                var expandSize = Math.abs(extent[0]);
                // In the fowllowing case
                //      Axis has been fixed max 100
                //      Plus data are all 100 and axis extent are [100, 100].
                // Extend to the both side will cause expanded max is larger than fixed max.
                // So only expand to the smaller side.
                if (!opt.fixMax) {
                    extent[1] += expandSize / 2;
                    extent[0] -= expandSize / 2;
                } else extent[0] -= expandSize / 2;
            } else extent[1] = 1;
        }
        var span = extent[1] - extent[0];
        // If there are no data and extent are [Infinity, -Infinity]
        if (!isFinite(span)) {
            extent[0] = 0;
            extent[1] = 1;
        }
        this.calcNiceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval);
        // let extent = this._extent;
        var interval = this._interval;
        if (!opt.fixMin) extent[0] = $dddb89ade16db3d5$var$roundNumber(Math.floor(extent[0] / interval) * interval);
        if (!opt.fixMax) extent[1] = $dddb89ade16db3d5$var$roundNumber(Math.ceil(extent[1] / interval) * interval);
    };
    IntervalScale.prototype.setNiceExtent = function(min, max) {
        this._niceExtent = [
            min,
            max
        ];
    };
    IntervalScale.type = 'interval';
    return IntervalScale;
}((0, $1754de95b9b9c398$export$2e2bcd8739ae039));
(0, $1754de95b9b9c398$export$2e2bcd8739ae039).registerClass($dddb89ade16db3d5$var$IntervalScale);
var $dddb89ade16db3d5$export$2e2bcd8739ae039 = $dddb89ade16db3d5$var$IntervalScale;





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







// FIXME 公用？
var $7729d7ac367e621c$var$bisect = function(a, x, lo, hi) {
    while(lo < hi){
        var mid = lo + hi >>> 1;
        if (a[mid][1] < x) lo = mid + 1;
        else hi = mid;
    }
    return lo;
};
var $7729d7ac367e621c$var$TimeScale = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(TimeScale, _super);
    function TimeScale(settings) {
        var _this = _super.call(this, settings) || this;
        _this.type = 'time';
        return _this;
    }
    /**
   * Get label is mainly for other components like dataZoom, tooltip.
   */ TimeScale.prototype.getLabel = function(tick) {
        var useUTC = this.getSetting('useUTC');
        return (0, $0ae0381fb3fd176f$export$d9468344d3651243)(tick.value, (0, $0ae0381fb3fd176f$export$445bdbd8d2334e40)[(0, $0ae0381fb3fd176f$export$124c820721c4f66b)((0, $0ae0381fb3fd176f$export$1da4b91a25d7e1c8)(this._minLevelUnit))] || (0, $0ae0381fb3fd176f$export$445bdbd8d2334e40).second, useUTC, this.getSetting('locale'));
    };
    TimeScale.prototype.getFormattedLabel = function(tick, idx, labelFormatter) {
        var isUTC = this.getSetting('useUTC');
        var lang = this.getSetting('locale');
        return (0, $0ae0381fb3fd176f$export$fe777b6293828b5d)(tick, idx, labelFormatter, lang, isUTC);
    };
    /**
   * @override
   */ TimeScale.prototype.getTicks = function() {
        var interval = this._interval;
        var extent = this._extent;
        var ticks = [];
        // If interval is 0, return [];
        if (!interval) return ticks;
        ticks.push({
            value: extent[0],
            level: 0
        });
        var useUTC = this.getSetting('useUTC');
        var innerTicks = $7729d7ac367e621c$var$getIntervalTicks(this._minLevelUnit, this._approxInterval, useUTC, extent);
        ticks = ticks.concat(innerTicks);
        ticks.push({
            value: extent[1],
            level: 0
        });
        return ticks;
    };
    TimeScale.prototype.calcNiceExtent = function(opt) {
        var extent = this._extent;
        // If extent start and end are same, expand them
        if (extent[0] === extent[1]) {
            // Expand extent
            extent[0] -= (0, $0ae0381fb3fd176f$export$a97a1358cbb650ab);
            extent[1] += (0, $0ae0381fb3fd176f$export$a97a1358cbb650ab);
        }
        // If there are no data and extent are [Infinity, -Infinity]
        if (extent[1] === -Infinity && extent[0] === Infinity) {
            var d = new Date();
            extent[1] = +new Date(d.getFullYear(), d.getMonth(), d.getDate());
            extent[0] = extent[1] - (0, $0ae0381fb3fd176f$export$a97a1358cbb650ab);
        }
        this.calcNiceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval);
    };
    TimeScale.prototype.calcNiceTicks = function(approxTickNum, minInterval, maxInterval) {
        approxTickNum = approxTickNum || 10;
        var extent = this._extent;
        var span = extent[1] - extent[0];
        this._approxInterval = span / approxTickNum;
        if (minInterval != null && this._approxInterval < minInterval) this._approxInterval = minInterval;
        if (maxInterval != null && this._approxInterval > maxInterval) this._approxInterval = maxInterval;
        var scaleIntervalsLen = $7729d7ac367e621c$var$scaleIntervals.length;
        var idx = Math.min($7729d7ac367e621c$var$bisect($7729d7ac367e621c$var$scaleIntervals, this._approxInterval, 0, scaleIntervalsLen), scaleIntervalsLen - 1);
        // Interval that can be used to calculate ticks
        this._interval = $7729d7ac367e621c$var$scaleIntervals[idx][1];
        // Min level used when picking ticks from top down.
        // We check one more level to avoid the ticks are to sparse in some case.
        this._minLevelUnit = $7729d7ac367e621c$var$scaleIntervals[Math.max(idx - 1, 0)][0];
    };
    TimeScale.prototype.parse = function(val) {
        // val might be float.
        return (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(val) ? val : +$cfc1f3b422a3185f$export$6b862160d295c8e(val);
    };
    TimeScale.prototype.contain = function(val) {
        return $60f7f1f3e3996637$export$8893e2b90ba10d92(this.parse(val), this._extent);
    };
    TimeScale.prototype.normalize = function(val) {
        return $60f7f1f3e3996637$export$a3295358bff77e(this.parse(val), this._extent);
    };
    TimeScale.prototype.scale = function(val) {
        return $60f7f1f3e3996637$export$dcdf75081b88279d(val, this._extent);
    };
    TimeScale.type = 'time';
    return TimeScale;
}((0, $dddb89ade16db3d5$export$2e2bcd8739ae039));
/**
 * This implementation was originally copied from "d3.js"
 * <https://github.com/d3/d3/blob/b516d77fb8566b576088e73410437494717ada26/src/time/scale.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 */ var $7729d7ac367e621c$var$scaleIntervals = [
    // Format                           interval
    [
        'second',
        (0, $0ae0381fb3fd176f$export$32c0454ceff7f92d)
    ],
    [
        'minute',
        (0, $0ae0381fb3fd176f$export$35acaebf644db34e)
    ],
    [
        'hour',
        (0, $0ae0381fb3fd176f$export$82541edf19e5e3b0)
    ],
    [
        'quarter-day',
        (0, $0ae0381fb3fd176f$export$82541edf19e5e3b0) * 6
    ],
    [
        'half-day',
        (0, $0ae0381fb3fd176f$export$82541edf19e5e3b0) * 12
    ],
    [
        'day',
        (0, $0ae0381fb3fd176f$export$a97a1358cbb650ab) * 1.2
    ],
    [
        'half-week',
        (0, $0ae0381fb3fd176f$export$a97a1358cbb650ab) * 3.5
    ],
    [
        'week',
        (0, $0ae0381fb3fd176f$export$a97a1358cbb650ab) * 7
    ],
    [
        'month',
        (0, $0ae0381fb3fd176f$export$a97a1358cbb650ab) * 31
    ],
    [
        'quarter',
        (0, $0ae0381fb3fd176f$export$a97a1358cbb650ab) * 95
    ],
    [
        'half-year',
        (0, $0ae0381fb3fd176f$export$99cafda57477293d) / 2
    ],
    [
        'year',
        (0, $0ae0381fb3fd176f$export$99cafda57477293d)
    ] // 1Y
];
function $7729d7ac367e621c$var$isUnitValueSame(unit, valueA, valueB, isUTC) {
    var dateA = $cfc1f3b422a3185f$export$6b862160d295c8e(valueA);
    var dateB = $cfc1f3b422a3185f$export$6b862160d295c8e(valueB);
    var isSame = function(unit) {
        return (0, $0ae0381fb3fd176f$export$e04e41a1e24ffd3f)(dateA, unit, isUTC) === (0, $0ae0381fb3fd176f$export$e04e41a1e24ffd3f)(dateB, unit, isUTC);
    };
    var isSameYear = function() {
        return isSame('year');
    };
    // const isSameHalfYear = () => isSameYear() && isSame('half-year');
    // const isSameQuater = () => isSameYear() && isSame('quarter');
    var isSameMonth = function() {
        return isSameYear() && isSame('month');
    };
    var isSameDay = function() {
        return isSameMonth() && isSame('day');
    };
    // const isSameHalfDay = () => isSameDay() && isSame('half-day');
    var isSameHour = function() {
        return isSameDay() && isSame('hour');
    };
    var isSameMinute = function() {
        return isSameHour() && isSame('minute');
    };
    var isSameSecond = function() {
        return isSameMinute() && isSame('second');
    };
    var isSameMilliSecond = function() {
        return isSameSecond() && isSame('millisecond');
    };
    switch(unit){
        case 'year':
            return isSameYear();
        case 'month':
            return isSameMonth();
        case 'day':
            return isSameDay();
        case 'hour':
            return isSameHour();
        case 'minute':
            return isSameMinute();
        case 'second':
            return isSameSecond();
        case 'millisecond':
            return isSameMilliSecond();
    }
}
// const primaryUnitGetters = {
//     year: fullYearGetterName(),
//     month: monthGetterName(),
//     day: dateGetterName(),
//     hour: hoursGetterName(),
//     minute: minutesGetterName(),
//     second: secondsGetterName(),
//     millisecond: millisecondsGetterName()
// };
// const primaryUnitUTCGetters = {
//     year: fullYearGetterName(true),
//     month: monthGetterName(true),
//     day: dateGetterName(true),
//     hour: hoursGetterName(true),
//     minute: minutesGetterName(true),
//     second: secondsGetterName(true),
//     millisecond: millisecondsGetterName(true)
// };
// function moveTick(date: Date, unitName: TimeUnit, step: number, isUTC: boolean) {
//     step = step || 1;
//     switch (getPrimaryTimeUnit(unitName)) {
//         case 'year':
//             date[fullYearSetterName(isUTC)](date[fullYearGetterName(isUTC)]() + step);
//             break;
//         case 'month':
//             date[monthSetterName(isUTC)](date[monthGetterName(isUTC)]() + step);
//             break;
//         case 'day':
//             date[dateSetterName(isUTC)](date[dateGetterName(isUTC)]() + step);
//             break;
//         case 'hour':
//             date[hoursSetterName(isUTC)](date[hoursGetterName(isUTC)]() + step);
//             break;
//         case 'minute':
//             date[minutesSetterName(isUTC)](date[minutesGetterName(isUTC)]() + step);
//             break;
//         case 'second':
//             date[secondsSetterName(isUTC)](date[secondsGetterName(isUTC)]() + step);
//             break;
//         case 'millisecond':
//             date[millisecondsSetterName(isUTC)](date[millisecondsGetterName(isUTC)]() + step);
//             break;
//     }
//     return date.getTime();
// }
// const DATE_INTERVALS = [[8, 7.5], [4, 3.5], [2, 1.5]];
// const MONTH_INTERVALS = [[6, 5.5], [3, 2.5], [2, 1.5]];
// const MINUTES_SECONDS_INTERVALS = [[30, 30], [20, 20], [15, 15], [10, 10], [5, 5], [2, 2]];
function $7729d7ac367e621c$var$getDateInterval(approxInterval, daysInMonth) {
    approxInterval /= (0, $0ae0381fb3fd176f$export$a97a1358cbb650ab);
    return approxInterval > 16 ? 16 : approxInterval > 7.5 ? 7 // TODO week 7 or day 8?
     : approxInterval > 3.5 ? 4 : approxInterval > 1.5 ? 2 : 1;
}
function $7729d7ac367e621c$var$getMonthInterval(approxInterval) {
    var APPROX_ONE_MONTH = 30 * (0, $0ae0381fb3fd176f$export$a97a1358cbb650ab);
    approxInterval /= APPROX_ONE_MONTH;
    return approxInterval > 6 ? 6 : approxInterval > 3 ? 3 : approxInterval > 2 ? 2 : 1;
}
function $7729d7ac367e621c$var$getHourInterval(approxInterval) {
    approxInterval /= (0, $0ae0381fb3fd176f$export$82541edf19e5e3b0);
    return approxInterval > 12 ? 12 : approxInterval > 6 ? 6 : approxInterval > 3.5 ? 4 : approxInterval > 2 ? 2 : 1;
}
function $7729d7ac367e621c$var$getMinutesAndSecondsInterval(approxInterval, isMinutes) {
    approxInterval /= isMinutes ? (0, $0ae0381fb3fd176f$export$35acaebf644db34e) : (0, $0ae0381fb3fd176f$export$32c0454ceff7f92d);
    return approxInterval > 30 ? 30 : approxInterval > 20 ? 20 : approxInterval > 15 ? 15 : approxInterval > 10 ? 10 : approxInterval > 5 ? 5 : approxInterval > 2 ? 2 : 1;
}
function $7729d7ac367e621c$var$getMillisecondsInterval(approxInterval) {
    return $cfc1f3b422a3185f$export$7a695fe44258210b(approxInterval, true);
}
function $7729d7ac367e621c$var$getFirstTimestampOfUnit(date, unitName, isUTC) {
    var outDate = new Date(date);
    switch((0, $0ae0381fb3fd176f$export$1da4b91a25d7e1c8)(unitName)){
        case 'year':
        case 'month':
            outDate[(0, $0ae0381fb3fd176f$export$233f59998ed71c09)(isUTC)](0);
        case 'day':
            outDate[(0, $0ae0381fb3fd176f$export$82fd379a67f37fa0)(isUTC)](1);
        case 'hour':
            outDate[(0, $0ae0381fb3fd176f$export$b6f943e8d23c15bb)(isUTC)](0);
        case 'minute':
            outDate[(0, $0ae0381fb3fd176f$export$50303078793fc7d)(isUTC)](0);
        case 'second':
            outDate[(0, $0ae0381fb3fd176f$export$a4a908acda9c3118)(isUTC)](0);
            outDate[(0, $0ae0381fb3fd176f$export$c047afab75f6d84)(isUTC)](0);
    }
    return outDate.getTime();
}
function $7729d7ac367e621c$var$getIntervalTicks(bottomUnitName, approxInterval, isUTC, extent) {
    var safeLimit = 10000;
    var unitNames = (0, $0ae0381fb3fd176f$export$833c398a55654bb7);
    var iter = 0;
    function addTicksInSpan(interval, minTimestamp, maxTimestamp, getMethodName, setMethodName, isDate, out) {
        var date = new Date(minTimestamp);
        var dateTime = minTimestamp;
        var d = date[getMethodName]();
        // if (isDate) {
        //     d -= 1; // Starts with 0;   PENDING
        // }
        while(dateTime < maxTimestamp && dateTime <= extent[1]){
            out.push({
                value: dateTime
            });
            d += interval;
            date[setMethodName](d);
            dateTime = date.getTime();
        }
        // This extra tick is for calcuating ticks of next level. Will not been added to the final result
        out.push({
            value: dateTime,
            notAdd: true
        });
    }
    function addLevelTicks(unitName, lastLevelTicks, levelTicks) {
        var newAddedTicks = [];
        var isFirstLevel = !lastLevelTicks.length;
        if ($7729d7ac367e621c$var$isUnitValueSame((0, $0ae0381fb3fd176f$export$1da4b91a25d7e1c8)(unitName), extent[0], extent[1], isUTC)) return;
        if (isFirstLevel) lastLevelTicks = [
            {
                // TODO Optimize. Not include so may ticks.
                value: $7729d7ac367e621c$var$getFirstTimestampOfUnit(new Date(extent[0]), unitName, isUTC)
            },
            {
                value: extent[1]
            }
        ];
        for(var i = 0; i < lastLevelTicks.length - 1; i++){
            var startTick = lastLevelTicks[i].value;
            var endTick = lastLevelTicks[i + 1].value;
            if (startTick === endTick) continue;
            var interval = void 0;
            var getterName = void 0;
            var setterName = void 0;
            var isDate = false;
            switch(unitName){
                case 'year':
                    interval = Math.max(1, Math.round(approxInterval / (0, $0ae0381fb3fd176f$export$a97a1358cbb650ab) / 365));
                    getterName = (0, $0ae0381fb3fd176f$export$8d046fefed9a548e)(isUTC);
                    setterName = (0, $0ae0381fb3fd176f$export$43fbeac90913b151)(isUTC);
                    break;
                case 'half-year':
                case 'quarter':
                case 'month':
                    interval = $7729d7ac367e621c$var$getMonthInterval(approxInterval);
                    getterName = (0, $0ae0381fb3fd176f$export$5c242a801a23eec7)(isUTC);
                    setterName = (0, $0ae0381fb3fd176f$export$233f59998ed71c09)(isUTC);
                    break;
                case 'week':
                case 'half-week':
                case 'day':
                    interval = $7729d7ac367e621c$var$getDateInterval(approxInterval, 31); // Use 32 days and let interval been 16
                    getterName = (0, $0ae0381fb3fd176f$export$4189e6cbc9753260)(isUTC);
                    setterName = (0, $0ae0381fb3fd176f$export$82fd379a67f37fa0)(isUTC);
                    isDate = true;
                    break;
                case 'half-day':
                case 'quarter-day':
                case 'hour':
                    interval = $7729d7ac367e621c$var$getHourInterval(approxInterval);
                    getterName = (0, $0ae0381fb3fd176f$export$8b40b55b3c06cbe2)(isUTC);
                    setterName = (0, $0ae0381fb3fd176f$export$b6f943e8d23c15bb)(isUTC);
                    break;
                case 'minute':
                    interval = $7729d7ac367e621c$var$getMinutesAndSecondsInterval(approxInterval, true);
                    getterName = (0, $0ae0381fb3fd176f$export$8807847c5c71eded)(isUTC);
                    setterName = (0, $0ae0381fb3fd176f$export$50303078793fc7d)(isUTC);
                    break;
                case 'second':
                    interval = $7729d7ac367e621c$var$getMinutesAndSecondsInterval(approxInterval, false);
                    getterName = (0, $0ae0381fb3fd176f$export$8f49e73e2eebd168)(isUTC);
                    setterName = (0, $0ae0381fb3fd176f$export$a4a908acda9c3118)(isUTC);
                    break;
                case 'millisecond':
                    interval = $7729d7ac367e621c$var$getMillisecondsInterval(approxInterval);
                    getterName = (0, $0ae0381fb3fd176f$export$312207a92d041116)(isUTC);
                    setterName = (0, $0ae0381fb3fd176f$export$c047afab75f6d84)(isUTC);
                    break;
            }
            addTicksInSpan(interval, startTick, endTick, getterName, setterName, isDate, newAddedTicks);
            if (unitName === 'year' && levelTicks.length > 1 && i === 0) // Add nearest years to the left extent.
            levelTicks.unshift({
                value: levelTicks[0].value - interval
            });
        }
        for(var i = 0; i < newAddedTicks.length; i++)levelTicks.push(newAddedTicks[i]);
        // newAddedTicks.length && console.log(unitName, newAddedTicks);
        return newAddedTicks;
    }
    var levelsTicks = [];
    var currentLevelTicks = [];
    var tickCount = 0;
    var lastLevelTickCount = 0;
    for(var i = 0; i < unitNames.length && iter++ < safeLimit; ++i){
        var primaryTimeUnit = (0, $0ae0381fb3fd176f$export$1da4b91a25d7e1c8)(unitNames[i]);
        if (!(0, $0ae0381fb3fd176f$export$beb5920b69c13da)(unitNames[i])) continue;
        addLevelTicks(unitNames[i], levelsTicks[levelsTicks.length - 1] || [], currentLevelTicks);
        var nextPrimaryTimeUnit = unitNames[i + 1] ? (0, $0ae0381fb3fd176f$export$1da4b91a25d7e1c8)(unitNames[i + 1]) : null;
        if (primaryTimeUnit !== nextPrimaryTimeUnit) {
            if (currentLevelTicks.length) {
                lastLevelTickCount = tickCount;
                // Remove the duplicate so the tick count can be precisely.
                currentLevelTicks.sort(function(a, b) {
                    return a.value - b.value;
                });
                var levelTicksRemoveDuplicated = [];
                for(var i_1 = 0; i_1 < currentLevelTicks.length; ++i_1){
                    var tickValue = currentLevelTicks[i_1].value;
                    if (i_1 === 0 || currentLevelTicks[i_1 - 1].value !== tickValue) {
                        levelTicksRemoveDuplicated.push(currentLevelTicks[i_1]);
                        if (tickValue >= extent[0] && tickValue <= extent[1]) tickCount++;
                    }
                }
                var targetTickNum = (extent[1] - extent[0]) / approxInterval;
                // Added too much in this level and not too less in last level
                if (tickCount > targetTickNum * 1.5 && lastLevelTickCount > targetTickNum / 1.5) break;
                // Only treat primary time unit as one level.
                levelsTicks.push(levelTicksRemoveDuplicated);
                if (tickCount > targetTickNum || bottomUnitName === unitNames[i]) break;
            }
            // Reset if next unitName is primary
            currentLevelTicks = [];
        }
    }
    var levelsTicksInExtent = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)((0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(levelsTicks, function(levelTicks) {
        return (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(levelTicks, function(tick) {
            return tick.value >= extent[0] && tick.value <= extent[1] && !tick.notAdd;
        });
    }), function(levelTicks) {
        return levelTicks.length > 0;
    });
    var ticks = [];
    var maxLevel = levelsTicksInExtent.length - 1;
    for(var i = 0; i < levelsTicksInExtent.length; ++i){
        var levelTicks = levelsTicksInExtent[i];
        for(var k = 0; k < levelTicks.length; ++k)ticks.push({
            value: levelTicks[k].value,
            level: maxLevel - i
        });
    }
    ticks.sort(function(a, b) {
        return a.value - b.value;
    });
    // Remove duplicates
    var result = [];
    for(var i = 0; i < ticks.length; ++i)if (i === 0 || ticks[i].value !== ticks[i - 1].value) result.push(ticks[i]);
    return result;
}
(0, $1754de95b9b9c398$export$2e2bcd8739ae039).registerClass($7729d7ac367e621c$var$TimeScale);
var $7729d7ac367e621c$export$2e2bcd8739ae039 = $7729d7ac367e621c$var$TimeScale;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $ae24d1f3a7f905fc$var$scaleProto = (0, $1754de95b9b9c398$export$2e2bcd8739ae039).prototype;
// FIXME:TS refactor: not good to call it directly with `this`?
var $ae24d1f3a7f905fc$var$intervalScaleProto = (0, $dddb89ade16db3d5$export$2e2bcd8739ae039).prototype;
var $ae24d1f3a7f905fc$var$roundingErrorFix = $cfc1f3b422a3185f$export$2077e0241d6afd3c;
var $ae24d1f3a7f905fc$var$mathFloor = Math.floor;
var $ae24d1f3a7f905fc$var$mathCeil = Math.ceil;
var $ae24d1f3a7f905fc$var$mathPow = Math.pow;
var $ae24d1f3a7f905fc$var$mathLog = Math.log;
var $ae24d1f3a7f905fc$var$LogScale = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(LogScale, _super);
    function LogScale() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'log';
        _this.base = 10;
        _this._originalScale = new (0, $dddb89ade16db3d5$export$2e2bcd8739ae039)();
        // FIXME:TS actually used by `IntervalScale`
        _this._interval = 0;
        return _this;
    }
    /**
   * @param Whether expand the ticks to niced extent.
   */ LogScale.prototype.getTicks = function(expandToNicedExtent) {
        var originalScale = this._originalScale;
        var extent = this._extent;
        var originalExtent = originalScale.getExtent();
        var ticks = $ae24d1f3a7f905fc$var$intervalScaleProto.getTicks.call(this, expandToNicedExtent);
        return $7a1bd9c2710fea0d$export$871de8747c9eaa88(ticks, function(tick) {
            var val = tick.value;
            var powVal = $cfc1f3b422a3185f$export$2077e0241d6afd3c($ae24d1f3a7f905fc$var$mathPow(this.base, val));
            // Fix #4158
            powVal = val === extent[0] && this._fixMin ? $ae24d1f3a7f905fc$var$fixRoundingError(powVal, originalExtent[0]) : powVal;
            powVal = val === extent[1] && this._fixMax ? $ae24d1f3a7f905fc$var$fixRoundingError(powVal, originalExtent[1]) : powVal;
            return {
                value: powVal
            };
        }, this);
    };
    LogScale.prototype.setExtent = function(start, end) {
        var base = $ae24d1f3a7f905fc$var$mathLog(this.base);
        // log(-Infinity) is NaN, so safe guard here
        start = $ae24d1f3a7f905fc$var$mathLog(Math.max(0, start)) / base;
        end = $ae24d1f3a7f905fc$var$mathLog(Math.max(0, end)) / base;
        $ae24d1f3a7f905fc$var$intervalScaleProto.setExtent.call(this, start, end);
    };
    /**
   * @return {number} end
   */ LogScale.prototype.getExtent = function() {
        var base = this.base;
        var extent = $ae24d1f3a7f905fc$var$scaleProto.getExtent.call(this);
        extent[0] = $ae24d1f3a7f905fc$var$mathPow(base, extent[0]);
        extent[1] = $ae24d1f3a7f905fc$var$mathPow(base, extent[1]);
        // Fix #4158
        var originalScale = this._originalScale;
        var originalExtent = originalScale.getExtent();
        this._fixMin && (extent[0] = $ae24d1f3a7f905fc$var$fixRoundingError(extent[0], originalExtent[0]));
        this._fixMax && (extent[1] = $ae24d1f3a7f905fc$var$fixRoundingError(extent[1], originalExtent[1]));
        return extent;
    };
    LogScale.prototype.unionExtent = function(extent) {
        this._originalScale.unionExtent(extent);
        var base = this.base;
        extent[0] = $ae24d1f3a7f905fc$var$mathLog(extent[0]) / $ae24d1f3a7f905fc$var$mathLog(base);
        extent[1] = $ae24d1f3a7f905fc$var$mathLog(extent[1]) / $ae24d1f3a7f905fc$var$mathLog(base);
        $ae24d1f3a7f905fc$var$scaleProto.unionExtent.call(this, extent);
    };
    LogScale.prototype.unionExtentFromData = function(data, dim) {
        // TODO
        // filter value that <= 0
        this.unionExtent(data.getApproximateExtent(dim));
    };
    /**
   * Update interval and extent of intervals for nice ticks
   * @param approxTickNum default 10 Given approx tick number
   */ LogScale.prototype.calcNiceTicks = function(approxTickNum) {
        approxTickNum = approxTickNum || 10;
        var extent = this._extent;
        var span = extent[1] - extent[0];
        if (span === Infinity || span <= 0) return;
        var interval = $cfc1f3b422a3185f$export$82dd68b83a44b253(span);
        var err = approxTickNum / span * interval;
        // Filter ticks to get closer to the desired count.
        if (err <= 0.5) interval *= 10;
        // Interval should be integer
        while(!isNaN(interval) && Math.abs(interval) < 1 && Math.abs(interval) > 0)interval *= 10;
        var niceExtent = [
            $cfc1f3b422a3185f$export$2077e0241d6afd3c($ae24d1f3a7f905fc$var$mathCeil(extent[0] / interval) * interval),
            $cfc1f3b422a3185f$export$2077e0241d6afd3c($ae24d1f3a7f905fc$var$mathFloor(extent[1] / interval) * interval)
        ];
        this._interval = interval;
        this._niceExtent = niceExtent;
    };
    LogScale.prototype.calcNiceExtent = function(opt) {
        $ae24d1f3a7f905fc$var$intervalScaleProto.calcNiceExtent.call(this, opt);
        this._fixMin = opt.fixMin;
        this._fixMax = opt.fixMax;
    };
    LogScale.prototype.parse = function(val) {
        return val;
    };
    LogScale.prototype.contain = function(val) {
        val = $ae24d1f3a7f905fc$var$mathLog(val) / $ae24d1f3a7f905fc$var$mathLog(this.base);
        return $60f7f1f3e3996637$export$8893e2b90ba10d92(val, this._extent);
    };
    LogScale.prototype.normalize = function(val) {
        val = $ae24d1f3a7f905fc$var$mathLog(val) / $ae24d1f3a7f905fc$var$mathLog(this.base);
        return $60f7f1f3e3996637$export$a3295358bff77e(val, this._extent);
    };
    LogScale.prototype.scale = function(val) {
        val = $60f7f1f3e3996637$export$dcdf75081b88279d(val, this._extent);
        return $ae24d1f3a7f905fc$var$mathPow(this.base, val);
    };
    LogScale.type = 'log';
    return LogScale;
}((0, $1754de95b9b9c398$export$2e2bcd8739ae039));
var $ae24d1f3a7f905fc$var$proto = $ae24d1f3a7f905fc$var$LogScale.prototype;
$ae24d1f3a7f905fc$var$proto.getMinorTicks = $ae24d1f3a7f905fc$var$intervalScaleProto.getMinorTicks;
$ae24d1f3a7f905fc$var$proto.getLabel = $ae24d1f3a7f905fc$var$intervalScaleProto.getLabel;
function $ae24d1f3a7f905fc$var$fixRoundingError(val, originalVal) {
    return $ae24d1f3a7f905fc$var$roundingErrorFix(val, $cfc1f3b422a3185f$export$e0c74b50bbd10f68(originalVal));
}
(0, $1754de95b9b9c398$export$2e2bcd8739ae039).registerClass($ae24d1f3a7f905fc$var$LogScale);
var $ae24d1f3a7f905fc$export$2e2bcd8739ae039 = $ae24d1f3a7f905fc$var$LogScale;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $483be9695e74220c$export$c35454f678e99c82 = /** @class */ function() {
    function ScaleRawExtentInfo(scale, model, // Usually: data extent from all series on this axis.
    originalExtent) {
        this._prepareParams(scale, model, originalExtent);
    }
    /**
   * Parameters depending on outside (like model, user callback)
   * are prepared and fixed here.
   */ ScaleRawExtentInfo.prototype._prepareParams = function(scale, model, // Usually: data extent from all series on this axis.
    dataExtent) {
        if (dataExtent[1] < dataExtent[0]) dataExtent = [
            NaN,
            NaN
        ];
        this._dataMin = dataExtent[0];
        this._dataMax = dataExtent[1];
        var isOrdinal = this._isOrdinal = scale.type === 'ordinal';
        this._needCrossZero = scale.type === 'interval' && model.getNeedCrossZero && model.getNeedCrossZero();
        var axisMinValue = model.get('min', true);
        if (axisMinValue == null) axisMinValue = model.get('startValue', true);
        var modelMinRaw = this._modelMinRaw = axisMinValue;
        if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(modelMinRaw)) // This callback always provides users the full data extent (before data is filtered).
        this._modelMinNum = $483be9695e74220c$export$d02f2e65dfc3c2b(scale, modelMinRaw({
            min: dataExtent[0],
            max: dataExtent[1]
        }));
        else if (modelMinRaw !== 'dataMin') this._modelMinNum = $483be9695e74220c$export$d02f2e65dfc3c2b(scale, modelMinRaw);
        var modelMaxRaw = this._modelMaxRaw = model.get('max', true);
        if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(modelMaxRaw)) // This callback always provides users the full data extent (before data is filtered).
        this._modelMaxNum = $483be9695e74220c$export$d02f2e65dfc3c2b(scale, modelMaxRaw({
            min: dataExtent[0],
            max: dataExtent[1]
        }));
        else if (modelMaxRaw !== 'dataMax') this._modelMaxNum = $483be9695e74220c$export$d02f2e65dfc3c2b(scale, modelMaxRaw);
        if (isOrdinal) // FIXME: there is a flaw here: if there is no "block" data processor like `dataZoom`,
        // and progressive rendering is using, here the category result might just only contain
        // the processed chunk rather than the entire result.
        this._axisDataLen = model.getCategories().length;
        else {
            var boundaryGap = model.get('boundaryGap');
            var boundaryGapArr = (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(boundaryGap) ? boundaryGap : [
                boundaryGap || 0,
                boundaryGap || 0
            ];
            if (typeof boundaryGapArr[0] === 'boolean' || typeof boundaryGapArr[1] === 'boolean') this._boundaryGapInner = [
                0,
                0
            ];
            else this._boundaryGapInner = [
                (0, $6c308355c7107803$export$e8514cb5a5e2b40f)(boundaryGapArr[0], 1),
                (0, $6c308355c7107803$export$e8514cb5a5e2b40f)(boundaryGapArr[1], 1)
            ];
        }
    };
    /**
   * Calculate extent by prepared parameters.
   * This method has no external dependency and can be called duplicatedly,
   * getting the same result.
   * If parameters changed, should call this method to recalcuate.
   */ ScaleRawExtentInfo.prototype.calculate = function() {
        // Notice: When min/max is not set (that is, when there are null/undefined,
        // which is the most common case), these cases should be ensured:
        // (1) For 'ordinal', show all axis.data.
        // (2) For others:
        //      + `boundaryGap` is applied (if min/max set, boundaryGap is
        //      disabled).
        //      + If `needCrossZero`, min/max should be zero, otherwise, min/max should
        //      be the result that originalExtent enlarged by boundaryGap.
        // (3) If no data, it should be ensured that `scale.setBlank` is set.
        var isOrdinal = this._isOrdinal;
        var dataMin = this._dataMin;
        var dataMax = this._dataMax;
        var axisDataLen = this._axisDataLen;
        var boundaryGapInner = this._boundaryGapInner;
        var span = !isOrdinal ? dataMax - dataMin || Math.abs(dataMin) : null;
        // Currently if a `'value'` axis model min is specified as 'dataMin'/'dataMax',
        // `boundaryGap` will not be used. It's the different from specifying as `null`/`undefined`.
        var min = this._modelMinRaw === 'dataMin' ? dataMin : this._modelMinNum;
        var max = this._modelMaxRaw === 'dataMax' ? dataMax : this._modelMaxNum;
        // If `_modelMinNum`/`_modelMaxNum` is `null`/`undefined`, should not be fixed.
        var minFixed = min != null;
        var maxFixed = max != null;
        if (min == null) min = isOrdinal ? axisDataLen ? 0 : NaN : dataMin - boundaryGapInner[0] * span;
        if (max == null) max = isOrdinal ? axisDataLen ? axisDataLen - 1 : NaN : dataMax + boundaryGapInner[1] * span;
        (min == null || !isFinite(min)) && (min = NaN);
        (max == null || !isFinite(max)) && (max = NaN);
        var isBlank = (0, $7a1bd9c2710fea0d$export$7d667b9a0c48c975)(min) || (0, $7a1bd9c2710fea0d$export$7d667b9a0c48c975)(max) || isOrdinal && !axisDataLen;
        // If data extent modified, need to recalculated to ensure cross zero.
        if (this._needCrossZero) {
            // Axis is over zero and min is not set
            if (min > 0 && max > 0 && !minFixed) min = 0;
            // Axis is under zero and max is not set
            if (min < 0 && max < 0 && !maxFixed) max = 0;
        // PENDING:
        // When `needCrossZero` and all data is positive/negative, should it be ensured
        // that the results processed by boundaryGap are positive/negative?
        // If so, here `minFixed`/`maxFixed` need to be set.
        }
        var determinedMin = this._determinedMin;
        var determinedMax = this._determinedMax;
        if (determinedMin != null) {
            min = determinedMin;
            minFixed = true;
        }
        if (determinedMax != null) {
            max = determinedMax;
            maxFixed = true;
        }
        // Ensure min/max be finite number or NaN here. (not to be null/undefined)
        // `NaN` means min/max axis is blank.
        return {
            min: min,
            max: max,
            minFixed: minFixed,
            maxFixed: maxFixed,
            isBlank: isBlank
        };
    };
    ScaleRawExtentInfo.prototype.modifyDataMinMax = function(minMaxName, val) {
        this[$483be9695e74220c$var$DATA_MIN_MAX_ATTR[minMaxName]] = val;
    };
    ScaleRawExtentInfo.prototype.setDeterminedMinMax = function(minMaxName, val) {
        var attr = $483be9695e74220c$var$DETERMINED_MIN_MAX_ATTR[minMaxName];
        this[attr] = val;
    };
    ScaleRawExtentInfo.prototype.freeze = function() {
        // @ts-ignore
        this.frozen = true;
    };
    return ScaleRawExtentInfo;
}();
var $483be9695e74220c$var$DETERMINED_MIN_MAX_ATTR = {
    min: '_determinedMin',
    max: '_determinedMax'
};
var $483be9695e74220c$var$DATA_MIN_MAX_ATTR = {
    min: '_dataMin',
    max: '_dataMax'
};
function $483be9695e74220c$export$5c3dbcbeb9ce7f5a(scale, model, // Usually: data extent from all series on this axis.
originalExtent) {
    // Do not permit to recreate.
    var rawExtentInfo = scale.rawExtentInfo;
    if (rawExtentInfo) return rawExtentInfo;
    rawExtentInfo = new $483be9695e74220c$export$c35454f678e99c82(scale, model, originalExtent);
    // @ts-ignore
    scale.rawExtentInfo = rawExtentInfo;
    return rawExtentInfo;
}
function $483be9695e74220c$export$d02f2e65dfc3c2b(scale, minMax) {
    return minMax == null ? null : (0, $7a1bd9c2710fea0d$export$7d667b9a0c48c975)(minMax) ? NaN : scale.parse(minMax);
}


function $2d646e51cc34f840$export$9c0ba8df7eb7b328(scale, model) {
    var scaleType = scale.type;
    var rawExtentResult = (0, $483be9695e74220c$export$5c3dbcbeb9ce7f5a)(scale, model, scale.getExtent()).calculate();
    scale.setBlank(rawExtentResult.isBlank);
    var min = rawExtentResult.min;
    var max = rawExtentResult.max;
    // If bars are placed on a base axis of type time or interval account for axis boundary overflow and current axis
    // is base axis
    // FIXME
    // (1) Consider support value axis, where below zero and axis `onZero` should be handled properly.
    // (2) Refactor the logic with `barGrid`. Is it not need to `makeBarWidthAndOffsetInfo` twice with different extent?
    //     Should not depend on series type `bar`?
    // (3) Fix that might overlap when using dataZoom.
    // (4) Consider other chart types using `barGrid`?
    // See #6728, #4862, `test/bar-overflow-time-plot.html`
    var ecModel = model.ecModel;
    if (ecModel && scaleType === 'time' /* || scaleType === 'interval' */ ) {
        var barSeriesModels = (0, $361c48dd900de28f$export$efbd0c3f5ab0d5e4)('bar', ecModel);
        var isBaseAxisAndHasBarSeries_1 = false;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(barSeriesModels, function(seriesModel) {
            isBaseAxisAndHasBarSeries_1 = isBaseAxisAndHasBarSeries_1 || seriesModel.getBaseAxis() === model.axis;
        });
        if (isBaseAxisAndHasBarSeries_1) {
            // Calculate placement of bars on axis. TODO should be decoupled
            // with barLayout
            var barWidthAndOffset = (0, $361c48dd900de28f$export$20769dafc84e0299)(barSeriesModels);
            // Adjust axis min and max to account for overflow
            var adjustedScale = $2d646e51cc34f840$var$adjustScaleForOverflow(min, max, model, barWidthAndOffset);
            min = adjustedScale.min;
            max = adjustedScale.max;
        }
    }
    return {
        extent: [
            min,
            max
        ],
        // "fix" means "fixed", the value should not be
        // changed in the subsequent steps.
        fixMin: rawExtentResult.minFixed,
        fixMax: rawExtentResult.maxFixed
    };
}
function $2d646e51cc34f840$var$adjustScaleForOverflow(min, max, model, // Only support cartesian coord yet.
barWidthAndOffset) {
    // Get Axis Length
    var axisExtent = model.axis.getExtent();
    var axisLength = Math.abs(axisExtent[1] - axisExtent[0]);
    // Get bars on current base axis and calculate min and max overflow
    var barsOnCurrentAxis = (0, $361c48dd900de28f$export$35920bb6556da1c2)(barWidthAndOffset, model.axis);
    if (barsOnCurrentAxis === undefined) return {
        min: min,
        max: max
    };
    var minOverflow = Infinity;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(barsOnCurrentAxis, function(item) {
        minOverflow = Math.min(item.offset, minOverflow);
    });
    var maxOverflow = -Infinity;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(barsOnCurrentAxis, function(item) {
        maxOverflow = Math.max(item.offset + item.width, maxOverflow);
    });
    minOverflow = Math.abs(minOverflow);
    maxOverflow = Math.abs(maxOverflow);
    var totalOverFlow = minOverflow + maxOverflow;
    // Calculate required buffer based on old range and overflow
    var oldRange = max - min;
    var oldRangePercentOfNew = 1 - (minOverflow + maxOverflow) / axisLength;
    var overflowBuffer = oldRange / oldRangePercentOfNew - oldRange;
    max += overflowBuffer * (maxOverflow / totalOverFlow);
    min -= overflowBuffer * (minOverflow / totalOverFlow);
    return {
        min: min,
        max: max
    };
}
function $2d646e51cc34f840$export$51f3e70a54405d5a(scale, inModel) {
    var model = inModel;
    var extentInfo = $2d646e51cc34f840$export$9c0ba8df7eb7b328(scale, model);
    var extent = extentInfo.extent;
    var splitNumber = model.get('splitNumber');
    if (scale instanceof (0, $ae24d1f3a7f905fc$export$2e2bcd8739ae039)) scale.base = model.get('logBase');
    var scaleType = scale.type;
    var interval = model.get('interval');
    var isIntervalOrTime = scaleType === 'interval' || scaleType === 'time';
    scale.setExtent(extent[0], extent[1]);
    scale.calcNiceExtent({
        splitNumber: splitNumber,
        fixMin: extentInfo.fixMin,
        fixMax: extentInfo.fixMax,
        minInterval: isIntervalOrTime ? model.get('minInterval') : null,
        maxInterval: isIntervalOrTime ? model.get('maxInterval') : null
    });
    // If some one specified the min, max. And the default calculated interval
    // is not good enough. He can specify the interval. It is often appeared
    // in angle axis with angle 0 - 360. Interval calculated in interval scale is hard
    // to be 60.
    // FIXME
    if (interval != null) scale.setInterval && scale.setInterval(interval);
}
function $2d646e51cc34f840$export$8941c4cacdc8f5a5(model, axisType) {
    axisType = axisType || model.get('type');
    if (axisType) switch(axisType){
        // Buildin scale
        case 'category':
            return new (0, $6e82606ec775d365$export$2e2bcd8739ae039)({
                ordinalMeta: model.getOrdinalMeta ? model.getOrdinalMeta() : model.getCategories(),
                extent: [
                    Infinity,
                    -Infinity
                ]
            });
        case 'time':
            return new (0, $7729d7ac367e621c$export$2e2bcd8739ae039)({
                locale: model.ecModel.getLocaleModel(),
                useUTC: model.ecModel.get('useUTC')
            });
        default:
            // case 'value'/'interval', 'log', or others.
            return new ((0, $1754de95b9b9c398$export$2e2bcd8739ae039).getClass(axisType) || (0, $dddb89ade16db3d5$export$2e2bcd8739ae039))();
    }
}
function $2d646e51cc34f840$export$3eac36a69f37d52(axis) {
    var dataExtent = axis.scale.getExtent();
    var min = dataExtent[0];
    var max = dataExtent[1];
    return !(min > 0 && max > 0 || min < 0 && max < 0);
}
function $2d646e51cc34f840$export$742f19a75415b2ae(axis) {
    var labelFormatter = axis.getLabelModel().get('formatter');
    var categoryTickStart = axis.type === 'category' ? axis.scale.getExtent()[0] : null;
    if (axis.scale.type === 'time') return function(tpl) {
        return function(tick, idx) {
            return axis.scale.getFormattedLabel(tick, idx, tpl);
        };
    }(labelFormatter);
    else if ($7a1bd9c2710fea0d$export$844ec244b1367d54(labelFormatter)) return function(tpl) {
        return function(tick) {
            // For category axis, get raw value; for numeric axis,
            // get formatted label like '1,333,444'.
            var label = axis.scale.getLabel(tick);
            var text = tpl.replace('{value}', label != null ? label : '');
            return text;
        };
    }(labelFormatter);
    else if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(labelFormatter)) return function(cb) {
        return function(tick, idx) {
            // The original intention of `idx` is "the index of the tick in all ticks".
            // But the previous implementation of category axis do not consider the
            // `axisLabel.interval`, which cause that, for example, the `interval` is
            // `1`, then the ticks "name5", "name7", "name9" are displayed, where the
            // corresponding `idx` are `0`, `2`, `4`, but not `0`, `1`, `2`. So we keep
            // the definition here for back compatibility.
            if (categoryTickStart != null) idx = tick.value - categoryTickStart;
            return cb($2d646e51cc34f840$export$a5a32f324c1fa457(axis, tick), idx, tick.level != null ? {
                level: tick.level
            } : null);
        };
    }(labelFormatter);
    else return function(tick) {
        return axis.scale.getLabel(tick);
    };
}
function $2d646e51cc34f840$export$a5a32f324c1fa457(axis, tick) {
    // In category axis with data zoom, tick is not the original
    // index of axis.data. So tick should not be exposed to user
    // in category axis.
    return axis.type === 'category' ? axis.scale.getLabel(tick) : tick.value;
}
function $2d646e51cc34f840$export$fef1c7f0af0b48d(axis) {
    var axisModel = axis.model;
    var scale = axis.scale;
    if (!axisModel.get([
        'axisLabel',
        'show'
    ]) || scale.isBlank()) return;
    var realNumberScaleTicks;
    var tickCount;
    var categoryScaleExtent = scale.getExtent();
    // Optimize for large category data, avoid call `getTicks()`.
    if (scale instanceof (0, $6e82606ec775d365$export$2e2bcd8739ae039)) tickCount = scale.count();
    else {
        realNumberScaleTicks = scale.getTicks();
        tickCount = realNumberScaleTicks.length;
    }
    var axisLabelModel = axis.getLabelModel();
    var labelFormatter = $2d646e51cc34f840$export$742f19a75415b2ae(axis);
    var rect;
    var step = 1;
    // Simple optimization for large amount of labels
    if (tickCount > 40) step = Math.ceil(tickCount / 40);
    for(var i = 0; i < tickCount; i += step){
        var tick = realNumberScaleTicks ? realNumberScaleTicks[i] : {
            value: categoryScaleExtent[0] + i
        };
        var label = labelFormatter(tick, i);
        var unrotatedSingleRect = axisLabelModel.getTextRect(label);
        var singleRect = $2d646e51cc34f840$var$rotateTextRect(unrotatedSingleRect, axisLabelModel.get('rotate') || 0);
        rect ? rect.union(singleRect) : rect = singleRect;
    }
    return rect;
}
function $2d646e51cc34f840$var$rotateTextRect(textRect, rotate) {
    var rotateRadians = rotate * Math.PI / 180;
    var beforeWidth = textRect.width;
    var beforeHeight = textRect.height;
    var afterWidth = beforeWidth * Math.abs(Math.cos(rotateRadians)) + Math.abs(beforeHeight * Math.sin(rotateRadians));
    var afterHeight = beforeWidth * Math.abs(Math.sin(rotateRadians)) + Math.abs(beforeHeight * Math.cos(rotateRadians));
    var rotatedRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(textRect.x, textRect.y, afterWidth, afterHeight);
    return rotatedRect;
}
function $2d646e51cc34f840$export$6d0bc2429155c088(model) {
    var interval = model.get('interval');
    return interval == null ? 'auto' : interval;
}
function $2d646e51cc34f840$export$c2911c025243d6a6(axis) {
    return axis.type === 'category' && $2d646e51cc34f840$export$6d0bc2429155c088(axis.getLabelModel()) === 0;
}
function $2d646e51cc34f840$export$e4cf30b1e74cd69d(data, axisDim) {
    // Remove duplicated dat dimensions caused by `getStackedDimension`.
    var dataDimMap = {};
    // Currently `mapDimensionsAll` will contain stack result dimension ('__\0ecstackresult').
    // PENDING: is it reasonable? Do we need to remove the original dim from "coord dim" since
    // there has been stacked result dim?
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(data.mapDimensionsAll(axisDim), function(dataDim) {
        // For example, the extent of the original dimension
        // is [0.1, 0.5], the extent of the `stackResultDimension`
        // is [7, 9], the final extent should NOT include [0.1, 0.5],
        // because there is no graphic corresponding to [0.1, 0.5].
        // See the case in `test/area-stack.html` `main1`, where area line
        // stack needs `yAxis` not start from 0.
        dataDimMap[(0, $efdd976e4917927c$export$909db2be4938fbdf)(data, dataDim)] = true;
    });
    return $7a1bd9c2710fea0d$export$ed97f33186d4b816(dataDimMap);
}
function $2d646e51cc34f840$export$635fe7f20d0f4c70(dataExtent, data, axisDim) {
    if (data) $7a1bd9c2710fea0d$export$79b2f7037acddd43($2d646e51cc34f840$export$e4cf30b1e74cd69d(data, axisDim), function(dim) {
        var seriesExtent = data.getApproximateExtent(dim);
        seriesExtent[0] < dataExtent[0] && (dataExtent[0] = seriesExtent[0]);
        seriesExtent[1] > dataExtent[1] && (dataExtent[1] = seriesExtent[1]);
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $6a439e51dccdc432$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $6a439e51dccdc432$var$tickValuesToNumbers(axis, values) {
    var nums = $7a1bd9c2710fea0d$export$871de8747c9eaa88(values, function(val) {
        return axis.scale.parse(val);
    });
    if (axis.type === 'time' && nums.length > 0) {
        // Time axis needs duplicate first/last tick (see TimeScale.getTicks())
        // The first and last tick/label don't get drawn
        nums.sort();
        nums.unshift(nums[0]);
        nums.push(nums[nums.length - 1]);
    }
    return nums;
}
function $6a439e51dccdc432$export$10216ebd3e3e485e(axis) {
    var custom = axis.getLabelModel().get('customValues');
    if (custom) {
        var labelFormatter_1 = (0, $2d646e51cc34f840$export$742f19a75415b2ae)(axis);
        var extent_1 = axis.scale.getExtent();
        var tickNumbers = $6a439e51dccdc432$var$tickValuesToNumbers(axis, custom);
        var ticks = $7a1bd9c2710fea0d$export$3dea766d36a8935f(tickNumbers, function(val) {
            return val >= extent_1[0] && val <= extent_1[1];
        });
        return {
            labels: $7a1bd9c2710fea0d$export$871de8747c9eaa88(ticks, function(numval) {
                var tick = {
                    value: numval
                };
                return {
                    formattedLabel: labelFormatter_1(tick),
                    rawLabel: axis.scale.getLabel(tick),
                    tickValue: numval
                };
            })
        };
    }
    // Only ordinal scale support tick interval
    return axis.type === 'category' ? $6a439e51dccdc432$var$makeCategoryLabels(axis) : $6a439e51dccdc432$var$makeRealNumberLabels(axis);
}
function $6a439e51dccdc432$export$7cccf6836ae8323c(axis, tickModel) {
    var custom = axis.getTickModel().get('customValues');
    if (custom) {
        var extent_2 = axis.scale.getExtent();
        var tickNumbers = $6a439e51dccdc432$var$tickValuesToNumbers(axis, custom);
        return {
            ticks: $7a1bd9c2710fea0d$export$3dea766d36a8935f(tickNumbers, function(val) {
                return val >= extent_2[0] && val <= extent_2[1];
            })
        };
    }
    // Only ordinal scale support tick interval
    return axis.type === 'category' ? $6a439e51dccdc432$var$makeCategoryTicks(axis, tickModel) : {
        ticks: $7a1bd9c2710fea0d$export$871de8747c9eaa88(axis.scale.getTicks(), function(tick) {
            return tick.value;
        })
    };
}
function $6a439e51dccdc432$var$makeCategoryLabels(axis) {
    var labelModel = axis.getLabelModel();
    var result = $6a439e51dccdc432$var$makeCategoryLabelsActually(axis, labelModel);
    return !labelModel.get('show') || axis.scale.isBlank() ? {
        labels: [],
        labelCategoryInterval: result.labelCategoryInterval
    } : result;
}
function $6a439e51dccdc432$var$makeCategoryLabelsActually(axis, labelModel) {
    var labelsCache = $6a439e51dccdc432$var$getListCache(axis, 'labels');
    var optionLabelInterval = (0, $2d646e51cc34f840$export$6d0bc2429155c088)(labelModel);
    var result = $6a439e51dccdc432$var$listCacheGet(labelsCache, optionLabelInterval);
    if (result) return result;
    var labels;
    var numericLabelInterval;
    if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(optionLabelInterval)) labels = $6a439e51dccdc432$var$makeLabelsByCustomizedCategoryInterval(axis, optionLabelInterval);
    else {
        numericLabelInterval = optionLabelInterval === 'auto' ? $6a439e51dccdc432$var$makeAutoCategoryInterval(axis) : optionLabelInterval;
        labels = $6a439e51dccdc432$var$makeLabelsByNumericCategoryInterval(axis, numericLabelInterval);
    }
    // Cache to avoid calling interval function repeatedly.
    return $6a439e51dccdc432$var$listCacheSet(labelsCache, optionLabelInterval, {
        labels: labels,
        labelCategoryInterval: numericLabelInterval
    });
}
function $6a439e51dccdc432$var$makeCategoryTicks(axis, tickModel) {
    var ticksCache = $6a439e51dccdc432$var$getListCache(axis, 'ticks');
    var optionTickInterval = (0, $2d646e51cc34f840$export$6d0bc2429155c088)(tickModel);
    var result = $6a439e51dccdc432$var$listCacheGet(ticksCache, optionTickInterval);
    if (result) return result;
    var ticks;
    var tickCategoryInterval;
    // Optimize for the case that large category data and no label displayed,
    // we should not return all ticks.
    if (!tickModel.get('show') || axis.scale.isBlank()) ticks = [];
    if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(optionTickInterval)) ticks = $6a439e51dccdc432$var$makeLabelsByCustomizedCategoryInterval(axis, optionTickInterval, true);
    else if (optionTickInterval === 'auto') {
        var labelsResult = $6a439e51dccdc432$var$makeCategoryLabelsActually(axis, axis.getLabelModel());
        tickCategoryInterval = labelsResult.labelCategoryInterval;
        ticks = $7a1bd9c2710fea0d$export$871de8747c9eaa88(labelsResult.labels, function(labelItem) {
            return labelItem.tickValue;
        });
    } else {
        tickCategoryInterval = optionTickInterval;
        ticks = $6a439e51dccdc432$var$makeLabelsByNumericCategoryInterval(axis, tickCategoryInterval, true);
    }
    // Cache to avoid calling interval function repeatedly.
    return $6a439e51dccdc432$var$listCacheSet(ticksCache, optionTickInterval, {
        ticks: ticks,
        tickCategoryInterval: tickCategoryInterval
    });
}
function $6a439e51dccdc432$var$makeRealNumberLabels(axis) {
    var ticks = axis.scale.getTicks();
    var labelFormatter = (0, $2d646e51cc34f840$export$742f19a75415b2ae)(axis);
    return {
        labels: $7a1bd9c2710fea0d$export$871de8747c9eaa88(ticks, function(tick, idx) {
            return {
                level: tick.level,
                formattedLabel: labelFormatter(tick, idx),
                rawLabel: axis.scale.getLabel(tick),
                tickValue: tick.value
            };
        })
    };
}
function $6a439e51dccdc432$var$getListCache(axis, prop) {
    // Because key can be a function, and cache size always is small, we use array cache.
    return $6a439e51dccdc432$var$inner(axis)[prop] || ($6a439e51dccdc432$var$inner(axis)[prop] = []);
}
function $6a439e51dccdc432$var$listCacheGet(cache, key) {
    for(var i = 0; i < cache.length; i++){
        if (cache[i].key === key) return cache[i].value;
    }
}
function $6a439e51dccdc432$var$listCacheSet(cache, key, value) {
    cache.push({
        key: key,
        value: value
    });
    return value;
}
function $6a439e51dccdc432$var$makeAutoCategoryInterval(axis) {
    var result = $6a439e51dccdc432$var$inner(axis).autoInterval;
    return result != null ? result : $6a439e51dccdc432$var$inner(axis).autoInterval = axis.calculateCategoryInterval();
}
function $6a439e51dccdc432$export$9ea1d3f146a5a65f(axis) {
    var params = $6a439e51dccdc432$var$fetchAutoCategoryIntervalCalculationParams(axis);
    var labelFormatter = (0, $2d646e51cc34f840$export$742f19a75415b2ae)(axis);
    var rotation = (params.axisRotate - params.labelRotate) / 180 * Math.PI;
    var ordinalScale = axis.scale;
    var ordinalExtent = ordinalScale.getExtent();
    // Providing this method is for optimization:
    // avoid generating a long array by `getTicks`
    // in large category data case.
    var tickCount = ordinalScale.count();
    if (ordinalExtent[1] - ordinalExtent[0] < 1) return 0;
    var step = 1;
    // Simple optimization. Empirical value: tick count should less than 40.
    if (tickCount > 40) step = Math.max(1, Math.floor(tickCount / 40));
    var tickValue = ordinalExtent[0];
    var unitSpan = axis.dataToCoord(tickValue + 1) - axis.dataToCoord(tickValue);
    var unitW = Math.abs(unitSpan * Math.cos(rotation));
    var unitH = Math.abs(unitSpan * Math.sin(rotation));
    var maxW = 0;
    var maxH = 0;
    // Caution: Performance sensitive for large category data.
    // Consider dataZoom, we should make appropriate step to avoid O(n) loop.
    for(; tickValue <= ordinalExtent[1]; tickValue += step){
        var width = 0;
        var height = 0;
        // Not precise, do not consider align and vertical align
        // and each distance from axis line yet.
        var rect = $6c308355c7107803$export$c381147bfed79d9f(labelFormatter({
            value: tickValue
        }), params.font, 'center', 'top');
        // Magic number
        width = rect.width * 1.3;
        height = rect.height * 1.3;
        // Min size, void long loop.
        maxW = Math.max(maxW, width, 7);
        maxH = Math.max(maxH, height, 7);
    }
    var dw = maxW / unitW;
    var dh = maxH / unitH;
    // 0/0 is NaN, 1/0 is Infinity.
    isNaN(dw) && (dw = Infinity);
    isNaN(dh) && (dh = Infinity);
    var interval = Math.max(0, Math.floor(Math.min(dw, dh)));
    var cache = $6a439e51dccdc432$var$inner(axis.model);
    var axisExtent = axis.getExtent();
    var lastAutoInterval = cache.lastAutoInterval;
    var lastTickCount = cache.lastTickCount;
    // Use cache to keep interval stable while moving zoom window,
    // otherwise the calculated interval might jitter when the zoom
    // window size is close to the interval-changing size.
    // For example, if all of the axis labels are `a, b, c, d, e, f, g`.
    // The jitter will cause that sometimes the displayed labels are
    // `a, d, g` (interval: 2) sometimes `a, c, e`(interval: 1).
    if (lastAutoInterval != null && lastTickCount != null && Math.abs(lastAutoInterval - interval) <= 1 && Math.abs(lastTickCount - tickCount) <= 1 && lastAutoInterval > interval && cache.axisExtent0 === axisExtent[0] && cache.axisExtent1 === axisExtent[1]) interval = lastAutoInterval;
    else {
        cache.lastTickCount = tickCount;
        cache.lastAutoInterval = interval;
        cache.axisExtent0 = axisExtent[0];
        cache.axisExtent1 = axisExtent[1];
    }
    return interval;
}
function $6a439e51dccdc432$var$fetchAutoCategoryIntervalCalculationParams(axis) {
    var labelModel = axis.getLabelModel();
    return {
        axisRotate: axis.getRotate ? axis.getRotate() : axis.isHorizontal && !axis.isHorizontal() ? 90 : 0,
        labelRotate: labelModel.get('rotate') || 0,
        font: labelModel.getFont()
    };
}
function $6a439e51dccdc432$var$makeLabelsByNumericCategoryInterval(axis, categoryInterval, onlyTick) {
    var labelFormatter = (0, $2d646e51cc34f840$export$742f19a75415b2ae)(axis);
    var ordinalScale = axis.scale;
    var ordinalExtent = ordinalScale.getExtent();
    var labelModel = axis.getLabelModel();
    var result = [];
    // TODO: axisType: ordinalTime, pick the tick from each month/day/year/...
    var step = Math.max((categoryInterval || 0) + 1, 1);
    var startTick = ordinalExtent[0];
    var tickCount = ordinalScale.count();
    // Calculate start tick based on zero if possible to keep label consistent
    // while zooming and moving while interval > 0. Otherwise the selection
    // of displayable ticks and symbols probably keep changing.
    // 3 is empirical value.
    if (startTick !== 0 && step > 1 && tickCount / step > 2) startTick = Math.round(Math.ceil(startTick / step) * step);
    // (1) Only add min max label here but leave overlap checking
    // to render stage, which also ensure the returned list
    // suitable for splitLine and splitArea rendering.
    // (2) Scales except category always contain min max label so
    // do not need to perform this process.
    var showAllLabel = (0, $2d646e51cc34f840$export$c2911c025243d6a6)(axis);
    var includeMinLabel = labelModel.get('showMinLabel') || showAllLabel;
    var includeMaxLabel = labelModel.get('showMaxLabel') || showAllLabel;
    if (includeMinLabel && startTick !== ordinalExtent[0]) addItem(ordinalExtent[0]);
    // Optimize: avoid generating large array by `ordinalScale.getTicks()`.
    var tickValue = startTick;
    for(; tickValue <= ordinalExtent[1]; tickValue += step)addItem(tickValue);
    if (includeMaxLabel && tickValue - step !== ordinalExtent[1]) addItem(ordinalExtent[1]);
    function addItem(tickValue) {
        var tickObj = {
            value: tickValue
        };
        result.push(onlyTick ? tickValue : {
            formattedLabel: labelFormatter(tickObj),
            rawLabel: ordinalScale.getLabel(tickObj),
            tickValue: tickValue
        });
    }
    return result;
}
function $6a439e51dccdc432$var$makeLabelsByCustomizedCategoryInterval(axis, categoryInterval, onlyTick) {
    var ordinalScale = axis.scale;
    var labelFormatter = (0, $2d646e51cc34f840$export$742f19a75415b2ae)(axis);
    var result = [];
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(ordinalScale.getTicks(), function(tick) {
        var rawLabel = ordinalScale.getLabel(tick);
        var tickValue = tick.value;
        if (categoryInterval(tick.value, rawLabel)) result.push(onlyTick ? tickValue : {
            formattedLabel: labelFormatter(tick),
            rawLabel: rawLabel,
            tickValue: tickValue
        });
    });
    return result;
}


var $c2b1efffe5ae3f42$var$NORMALIZED_EXTENT = [
    0,
    1
];
/**
 * Base class of Axis.
 */ var $c2b1efffe5ae3f42$var$Axis = /** @class */ function() {
    function Axis(dim, scale, extent) {
        this.onBand = false;
        this.inverse = false;
        this.dim = dim;
        this.scale = scale;
        this._extent = extent || [
            0,
            0
        ];
    }
    /**
   * If axis extent contain given coord
   */ Axis.prototype.contain = function(coord) {
        var extent = this._extent;
        var min = Math.min(extent[0], extent[1]);
        var max = Math.max(extent[0], extent[1]);
        return coord >= min && coord <= max;
    };
    /**
   * If axis extent contain given data
   */ Axis.prototype.containData = function(data) {
        return this.scale.contain(data);
    };
    /**
   * Get coord extent.
   */ Axis.prototype.getExtent = function() {
        return this._extent.slice();
    };
    /**
   * Get precision used for formatting
   */ Axis.prototype.getPixelPrecision = function(dataExtent) {
        return (0, $cfc1f3b422a3185f$export$666260d9a2dda8a7)(dataExtent || this.scale.getExtent(), this._extent);
    };
    /**
   * Set coord extent
   */ Axis.prototype.setExtent = function(start, end) {
        var extent = this._extent;
        extent[0] = start;
        extent[1] = end;
    };
    /**
   * Convert data to coord. Data is the rank if it has an ordinal scale
   */ Axis.prototype.dataToCoord = function(data, clamp) {
        var extent = this._extent;
        var scale = this.scale;
        data = scale.normalize(data);
        if (this.onBand && scale.type === 'ordinal') {
            extent = extent.slice();
            $c2b1efffe5ae3f42$var$fixExtentWithBands(extent, scale.count());
        }
        return (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(data, $c2b1efffe5ae3f42$var$NORMALIZED_EXTENT, extent, clamp);
    };
    /**
   * Convert coord to data. Data is the rank if it has an ordinal scale
   */ Axis.prototype.coordToData = function(coord, clamp) {
        var extent = this._extent;
        var scale = this.scale;
        if (this.onBand && scale.type === 'ordinal') {
            extent = extent.slice();
            $c2b1efffe5ae3f42$var$fixExtentWithBands(extent, scale.count());
        }
        var t = (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(coord, extent, $c2b1efffe5ae3f42$var$NORMALIZED_EXTENT, clamp);
        return this.scale.scale(t);
    };
    /**
   * Convert pixel point to data in axis
   */ Axis.prototype.pointToData = function(point, clamp) {
        // Should be implemented in derived class if necessary.
        return;
    };
    /**
   * Different from `zrUtil.map(axis.getTicks(), axis.dataToCoord, axis)`,
   * `axis.getTicksCoords` considers `onBand`, which is used by
   * `boundaryGap:true` of category axis and splitLine and splitArea.
   * @param opt.tickModel default: axis.model.getModel('axisTick')
   * @param opt.clamp If `true`, the first and the last
   *        tick must be at the axis end points. Otherwise, clip ticks
   *        that outside the axis extent.
   */ Axis.prototype.getTicksCoords = function(opt) {
        opt = opt || {};
        var tickModel = opt.tickModel || this.getTickModel();
        var result = (0, $6a439e51dccdc432$export$7cccf6836ae8323c)(this, tickModel);
        var ticks = result.ticks;
        var ticksCoords = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(ticks, function(tickVal) {
            return {
                coord: this.dataToCoord(this.scale.type === 'ordinal' ? this.scale.getRawOrdinalNumber(tickVal) : tickVal),
                tickValue: tickVal
            };
        }, this);
        var alignWithLabel = tickModel.get('alignWithLabel');
        $c2b1efffe5ae3f42$var$fixOnBandTicksCoords(this, ticksCoords, alignWithLabel, opt.clamp);
        return ticksCoords;
    };
    Axis.prototype.getMinorTicksCoords = function() {
        if (this.scale.type === 'ordinal') // Category axis doesn't support minor ticks
        return [];
        var minorTickModel = this.model.getModel('minorTick');
        var splitNumber = minorTickModel.get('splitNumber');
        // Protection.
        if (!(splitNumber > 0 && splitNumber < 100)) splitNumber = 5;
        var minorTicks = this.scale.getMinorTicks(splitNumber);
        var minorTicksCoords = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(minorTicks, function(minorTicksGroup) {
            return (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(minorTicksGroup, function(minorTick) {
                return {
                    coord: this.dataToCoord(minorTick),
                    tickValue: minorTick
                };
            }, this);
        }, this);
        return minorTicksCoords;
    };
    Axis.prototype.getViewLabels = function() {
        return (0, $6a439e51dccdc432$export$10216ebd3e3e485e)(this).labels;
    };
    Axis.prototype.getLabelModel = function() {
        return this.model.getModel('axisLabel');
    };
    /**
   * Notice here we only get the default tick model. For splitLine
   * or splitArea, we should pass the splitLineModel or splitAreaModel
   * manually when calling `getTicksCoords`.
   * In GL, this method may be overridden to:
   * `axisModel.getModel('axisTick', grid3DModel.getModel('axisTick'));`
   */ Axis.prototype.getTickModel = function() {
        return this.model.getModel('axisTick');
    };
    /**
   * Get width of band
   */ Axis.prototype.getBandWidth = function() {
        var axisExtent = this._extent;
        var dataExtent = this.scale.getExtent();
        var len = dataExtent[1] - dataExtent[0] + (this.onBand ? 1 : 0);
        // Fix #2728, avoid NaN when only one data.
        len === 0 && (len = 1);
        var size = Math.abs(axisExtent[1] - axisExtent[0]);
        return Math.abs(size) / len;
    };
    /**
   * Only be called in category axis.
   * Can be overridden, consider other axes like in 3D.
   * @return Auto interval for cateogry axis tick and label
   */ Axis.prototype.calculateCategoryInterval = function() {
        return (0, $6a439e51dccdc432$export$9ea1d3f146a5a65f)(this);
    };
    return Axis;
}();
function $c2b1efffe5ae3f42$var$fixExtentWithBands(extent, nTick) {
    var size = extent[1] - extent[0];
    var len = nTick;
    var margin = size / len / 2;
    extent[0] += margin;
    extent[1] -= margin;
}
// If axis has labels [1, 2, 3, 4]. Bands on the axis are
// |---1---|---2---|---3---|---4---|.
// So the displayed ticks and splitLine/splitArea should between
// each data item, otherwise cause misleading (e.g., split tow bars
// of a single data item when there are two bar series).
// Also consider if tickCategoryInterval > 0 and onBand, ticks and
// splitLine/spliteArea should layout appropriately corresponding
// to displayed labels. (So we should not use `getBandWidth` in this
// case).
function $c2b1efffe5ae3f42$var$fixOnBandTicksCoords(axis, ticksCoords, alignWithLabel, clamp) {
    var ticksLen = ticksCoords.length;
    if (!axis.onBand || alignWithLabel || !ticksLen) return;
    var axisExtent = axis.getExtent();
    var last;
    var diffSize;
    if (ticksLen === 1) {
        ticksCoords[0].coord = axisExtent[0];
        last = ticksCoords[1] = {
            coord: axisExtent[1],
            tickValue: ticksCoords[0].tickValue
        };
    } else {
        var crossLen = ticksCoords[ticksLen - 1].tickValue - ticksCoords[0].tickValue;
        var shift_1 = (ticksCoords[ticksLen - 1].coord - ticksCoords[0].coord) / crossLen;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(ticksCoords, function(ticksItem) {
            ticksItem.coord -= shift_1 / 2;
        });
        var dataExtent = axis.scale.getExtent();
        diffSize = 1 + dataExtent[1] - ticksCoords[ticksLen - 1].tickValue;
        last = {
            coord: ticksCoords[ticksLen - 1].coord + shift_1 * diffSize,
            tickValue: dataExtent[1] + 1
        };
        ticksCoords.push(last);
    }
    var inverse = axisExtent[0] > axisExtent[1];
    // Handling clamp.
    if (littleThan(ticksCoords[0].coord, axisExtent[0])) clamp ? ticksCoords[0].coord = axisExtent[0] : ticksCoords.shift();
    if (clamp && littleThan(axisExtent[0], ticksCoords[0].coord)) ticksCoords.unshift({
        coord: axisExtent[0]
    });
    if (littleThan(axisExtent[1], last.coord)) clamp ? last.coord = axisExtent[1] : ticksCoords.pop();
    if (clamp && littleThan(last.coord, axisExtent[1])) ticksCoords.push({
        coord: axisExtent[1]
    });
    function littleThan(a, b) {
        // Avoid rounding error cause calculated tick coord different with extent.
        // It may cause an extra unnecessary tick added.
        a = (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(a);
        b = (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(b);
        return inverse ? a > b : a < b;
    }
}
var $c2b1efffe5ae3f42$export$2e2bcd8739ae039 = $c2b1efffe5ae3f42$var$Axis;


var $ec1c8727611588c2$var$ParallelAxis = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ParallelAxis, _super);
    function ParallelAxis(dim, scale, coordExtent, axisType, axisIndex) {
        var _this = _super.call(this, dim, scale, coordExtent) || this;
        _this.type = axisType || 'value';
        _this.axisIndex = axisIndex;
        return _this;
    }
    ParallelAxis.prototype.isHorizontal = function() {
        return this.coordinateSystem.getModel().get('layout') !== 'horizontal';
    };
    return ParallelAxis;
}((0, $c2b1efffe5ae3f42$export$2e2bcd8739ae039));
var $ec1c8727611588c2$export$2e2bcd8739ae039 = $ec1c8727611588c2$var$ParallelAxis;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Calculate slider move result.
 * Usage:
 * (1) If both handle0 and handle1 are needed to be moved, set minSpan the same as
 * maxSpan and the same as `Math.abs(handleEnd[1] - handleEnds[0])`.
 * (2) If handle0 is forbidden to cross handle1, set minSpan as `0`.
 *
 * @param delta Move length.
 * @param handleEnds handleEnds[0] can be bigger then handleEnds[1].
 *              handleEnds will be modified in this method.
 * @param extent handleEnds is restricted by extent.
 *              extent[0] should less or equals than extent[1].
 * @param handleIndex Can be 'all', means that both move the two handleEnds.
 * @param minSpan The range of dataZoom can not be smaller than that.
 *              If not set, handle0 and cross handle1. If set as a non-negative
 *              number (including `0`), handles will push each other when reaching
 *              the minSpan.
 * @param maxSpan The range of dataZoom can not be larger than that.
 * @return The input handleEnds.
 */ function $00a8003b34293330$export$2e2bcd8739ae039(delta, handleEnds, extent, handleIndex, minSpan, maxSpan) {
    delta = delta || 0;
    var extentSpan = extent[1] - extent[0];
    // Notice maxSpan and minSpan can be null/undefined.
    if (minSpan != null) minSpan = $00a8003b34293330$var$restrict(minSpan, [
        0,
        extentSpan
    ]);
    if (maxSpan != null) maxSpan = Math.max(maxSpan, minSpan != null ? minSpan : 0);
    if (handleIndex === 'all') {
        var handleSpan = Math.abs(handleEnds[1] - handleEnds[0]);
        handleSpan = $00a8003b34293330$var$restrict(handleSpan, [
            0,
            extentSpan
        ]);
        minSpan = maxSpan = $00a8003b34293330$var$restrict(handleSpan, [
            minSpan,
            maxSpan
        ]);
        handleIndex = 0;
    }
    handleEnds[0] = $00a8003b34293330$var$restrict(handleEnds[0], extent);
    handleEnds[1] = $00a8003b34293330$var$restrict(handleEnds[1], extent);
    var originalDistSign = $00a8003b34293330$var$getSpanSign(handleEnds, handleIndex);
    handleEnds[handleIndex] += delta;
    // Restrict in extent.
    var extentMinSpan = minSpan || 0;
    var realExtent = extent.slice();
    originalDistSign.sign < 0 ? realExtent[0] += extentMinSpan : realExtent[1] -= extentMinSpan;
    handleEnds[handleIndex] = $00a8003b34293330$var$restrict(handleEnds[handleIndex], realExtent);
    // Expand span.
    var currDistSign;
    currDistSign = $00a8003b34293330$var$getSpanSign(handleEnds, handleIndex);
    if (minSpan != null && (currDistSign.sign !== originalDistSign.sign || currDistSign.span < minSpan)) // If minSpan exists, 'cross' is forbidden.
    handleEnds[1 - handleIndex] = handleEnds[handleIndex] + originalDistSign.sign * minSpan;
    // Shrink span.
    currDistSign = $00a8003b34293330$var$getSpanSign(handleEnds, handleIndex);
    if (maxSpan != null && currDistSign.span > maxSpan) handleEnds[1 - handleIndex] = handleEnds[handleIndex] + currDistSign.sign * maxSpan;
    return handleEnds;
}
function $00a8003b34293330$var$getSpanSign(handleEnds, handleIndex) {
    var dist = handleEnds[handleIndex] - handleEnds[1 - handleIndex];
    // If `handleEnds[0] === handleEnds[1]`, always believe that handleEnd[0]
    // is at left of handleEnds[1] for non-cross case.
    return {
        span: Math.abs(dist),
        sign: dist > 0 ? -1 : dist < 0 ? 1 : handleIndex ? -1 : 1
    };
}
function $00a8003b34293330$var$restrict(value, extend) {
    return Math.min(extend[1] != null ? extend[1] : Infinity, Math.max(extend[0] != null ? extend[0] : -Infinity, value));
}


var $a26a2212b9c3ac89$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
var $a26a2212b9c3ac89$var$mathMin = Math.min;
var $a26a2212b9c3ac89$var$mathMax = Math.max;
var $a26a2212b9c3ac89$var$mathFloor = Math.floor;
var $a26a2212b9c3ac89$var$mathCeil = Math.ceil;
var $a26a2212b9c3ac89$var$round = $cfc1f3b422a3185f$export$2077e0241d6afd3c;
var $a26a2212b9c3ac89$var$PI = Math.PI;
var $a26a2212b9c3ac89$var$Parallel = /** @class */ function() {
    function Parallel(parallelModel, ecModel, api) {
        this.type = 'parallel';
        /**
     * key: dimension
     */ this._axesMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        /**
     * key: dimension
     * value: {position: [], rotation, }
     */ this._axesLayout = {};
        this.dimensions = parallelModel.dimensions;
        this._model = parallelModel;
        this._init(parallelModel, ecModel, api);
    }
    Parallel.prototype._init = function(parallelModel, ecModel, api) {
        var dimensions = parallelModel.dimensions;
        var parallelAxisIndex = parallelModel.parallelAxisIndex;
        $a26a2212b9c3ac89$var$each(dimensions, function(dim, idx) {
            var axisIndex = parallelAxisIndex[idx];
            var axisModel = ecModel.getComponent('parallelAxis', axisIndex);
            var axis = this._axesMap.set(dim, new (0, $ec1c8727611588c2$export$2e2bcd8739ae039)(dim, $2d646e51cc34f840$export$8941c4cacdc8f5a5(axisModel), [
                0,
                0
            ], axisModel.get('type'), axisIndex));
            var isCategory = axis.type === 'category';
            axis.onBand = isCategory && axisModel.get('boundaryGap');
            axis.inverse = axisModel.get('inverse');
            // Injection
            axisModel.axis = axis;
            axis.model = axisModel;
            axis.coordinateSystem = axisModel.coordinateSystem = this;
        }, this);
    };
    /**
   * Update axis scale after data processed
   */ Parallel.prototype.update = function(ecModel, api) {
        this._updateAxesFromSeries(this._model, ecModel);
    };
    Parallel.prototype.containPoint = function(point) {
        var layoutInfo = this._makeLayoutInfo();
        var axisBase = layoutInfo.axisBase;
        var layoutBase = layoutInfo.layoutBase;
        var pixelDimIndex = layoutInfo.pixelDimIndex;
        var pAxis = point[1 - pixelDimIndex];
        var pLayout = point[pixelDimIndex];
        return pAxis >= axisBase && pAxis <= axisBase + layoutInfo.axisLength && pLayout >= layoutBase && pLayout <= layoutBase + layoutInfo.layoutLength;
    };
    Parallel.prototype.getModel = function() {
        return this._model;
    };
    /**
   * Update properties from series
   */ Parallel.prototype._updateAxesFromSeries = function(parallelModel, ecModel) {
        ecModel.eachSeries(function(seriesModel) {
            if (!parallelModel.contains(seriesModel, ecModel)) return;
            var data = seriesModel.getData();
            $a26a2212b9c3ac89$var$each(this.dimensions, function(dim) {
                var axis = this._axesMap.get(dim);
                axis.scale.unionExtentFromData(data, data.mapDimension(dim));
                $2d646e51cc34f840$export$51f3e70a54405d5a(axis.scale, axis.model);
            }, this);
        }, this);
    };
    /**
   * Resize the parallel coordinate system.
   */ Parallel.prototype.resize = function(parallelModel, api) {
        this._rect = $93b9bc7f22ac7369$export$4517a5ca639a7293(parallelModel.getBoxLayoutParams(), {
            width: api.getWidth(),
            height: api.getHeight()
        });
        this._layoutAxes();
    };
    Parallel.prototype.getRect = function() {
        return this._rect;
    };
    Parallel.prototype._makeLayoutInfo = function() {
        var parallelModel = this._model;
        var rect = this._rect;
        var xy = [
            'x',
            'y'
        ];
        var wh = [
            'width',
            'height'
        ];
        var layout = parallelModel.get('layout');
        var pixelDimIndex = layout === 'horizontal' ? 0 : 1;
        var layoutLength = rect[wh[pixelDimIndex]];
        var layoutExtent = [
            0,
            layoutLength
        ];
        var axisCount = this.dimensions.length;
        var axisExpandWidth = $a26a2212b9c3ac89$var$restrict(parallelModel.get('axisExpandWidth'), layoutExtent);
        var axisExpandCount = $a26a2212b9c3ac89$var$restrict(parallelModel.get('axisExpandCount') || 0, [
            0,
            axisCount
        ]);
        var axisExpandable = parallelModel.get('axisExpandable') && axisCount > 3 && axisCount > axisExpandCount && axisExpandCount > 1 && axisExpandWidth > 0 && layoutLength > 0;
        // `axisExpandWindow` is According to the coordinates of [0, axisExpandLength],
        // for sake of consider the case that axisCollapseWidth is 0 (when screen is narrow),
        // where collapsed axes should be overlapped.
        var axisExpandWindow = parallelModel.get('axisExpandWindow');
        var winSize;
        if (!axisExpandWindow) {
            winSize = $a26a2212b9c3ac89$var$restrict(axisExpandWidth * (axisExpandCount - 1), layoutExtent);
            var axisExpandCenter = parallelModel.get('axisExpandCenter') || $a26a2212b9c3ac89$var$mathFloor(axisCount / 2);
            axisExpandWindow = [
                axisExpandWidth * axisExpandCenter - winSize / 2
            ];
            axisExpandWindow[1] = axisExpandWindow[0] + winSize;
        } else {
            winSize = $a26a2212b9c3ac89$var$restrict(axisExpandWindow[1] - axisExpandWindow[0], layoutExtent);
            axisExpandWindow[1] = axisExpandWindow[0] + winSize;
        }
        var axisCollapseWidth = (layoutLength - winSize) / (axisCount - axisExpandCount);
        // Avoid axisCollapseWidth is too small.
        axisCollapseWidth < 3 && (axisCollapseWidth = 0);
        // Find the first and last indices > ewin[0] and < ewin[1].
        var winInnerIndices = [
            $a26a2212b9c3ac89$var$mathFloor($a26a2212b9c3ac89$var$round(axisExpandWindow[0] / axisExpandWidth, 1)) + 1,
            $a26a2212b9c3ac89$var$mathCeil($a26a2212b9c3ac89$var$round(axisExpandWindow[1] / axisExpandWidth, 1)) - 1
        ];
        // Pos in ec coordinates.
        var axisExpandWindow0Pos = axisCollapseWidth / axisExpandWidth * axisExpandWindow[0];
        return {
            layout: layout,
            pixelDimIndex: pixelDimIndex,
            layoutBase: rect[xy[pixelDimIndex]],
            layoutLength: layoutLength,
            axisBase: rect[xy[1 - pixelDimIndex]],
            axisLength: rect[wh[1 - pixelDimIndex]],
            axisExpandable: axisExpandable,
            axisExpandWidth: axisExpandWidth,
            axisCollapseWidth: axisCollapseWidth,
            axisExpandWindow: axisExpandWindow,
            axisCount: axisCount,
            winInnerIndices: winInnerIndices,
            axisExpandWindow0Pos: axisExpandWindow0Pos
        };
    };
    Parallel.prototype._layoutAxes = function() {
        var rect = this._rect;
        var axes = this._axesMap;
        var dimensions = this.dimensions;
        var layoutInfo = this._makeLayoutInfo();
        var layout = layoutInfo.layout;
        axes.each(function(axis) {
            var axisExtent = [
                0,
                layoutInfo.axisLength
            ];
            var idx = axis.inverse ? 1 : 0;
            axis.setExtent(axisExtent[idx], axisExtent[1 - idx]);
        });
        $a26a2212b9c3ac89$var$each(dimensions, function(dim, idx) {
            var posInfo = (layoutInfo.axisExpandable ? $a26a2212b9c3ac89$var$layoutAxisWithExpand : $a26a2212b9c3ac89$var$layoutAxisWithoutExpand)(idx, layoutInfo);
            var positionTable = {
                horizontal: {
                    x: posInfo.position,
                    y: layoutInfo.axisLength
                },
                vertical: {
                    x: 0,
                    y: posInfo.position
                }
            };
            var rotationTable = {
                horizontal: $a26a2212b9c3ac89$var$PI / 2,
                vertical: 0
            };
            var position = [
                positionTable[layout].x + rect.x,
                positionTable[layout].y + rect.y
            ];
            var rotation = rotationTable[layout];
            var transform = $f41ebb9dd60b55b4$export$185802fd694ee1f5();
            $f41ebb9dd60b55b4$export$bb628a54ab399bc9(transform, transform, rotation);
            $f41ebb9dd60b55b4$export$d73ee8ef04f5226a(transform, transform, position);
            // TODO
            // tick layout info
            // TODO
            // update dimensions info based on axis order.
            this._axesLayout[dim] = {
                position: position,
                rotation: rotation,
                transform: transform,
                axisNameAvailableWidth: posInfo.axisNameAvailableWidth,
                axisLabelShow: posInfo.axisLabelShow,
                nameTruncateMaxWidth: posInfo.nameTruncateMaxWidth,
                tickDirection: 1,
                labelDirection: 1
            };
        }, this);
    };
    /**
   * Get axis by dim.
   */ Parallel.prototype.getAxis = function(dim) {
        return this._axesMap.get(dim);
    };
    /**
   * Convert a dim value of a single item of series data to Point.
   */ Parallel.prototype.dataToPoint = function(value, dim) {
        return this.axisCoordToPoint(this._axesMap.get(dim).dataToCoord(value), dim);
    };
    /**
   * Travel data for one time, get activeState of each data item.
   * @param start the start dataIndex that travel from.
   * @param end the next dataIndex of the last dataIndex will be travel.
   */ Parallel.prototype.eachActiveState = function(data, callback, start, end) {
        start == null && (start = 0);
        end == null && (end = data.count());
        var axesMap = this._axesMap;
        var dimensions = this.dimensions;
        var dataDimensions = [];
        var axisModels = [];
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(dimensions, function(axisDim) {
            dataDimensions.push(data.mapDimension(axisDim));
            axisModels.push(axesMap.get(axisDim).model);
        });
        var hasActiveSet = this.hasAxisBrushed();
        for(var dataIndex = start; dataIndex < end; dataIndex++){
            var activeState = void 0;
            if (!hasActiveSet) activeState = 'normal';
            else {
                activeState = 'active';
                var values = data.getValues(dataDimensions, dataIndex);
                for(var j = 0, lenj = dimensions.length; j < lenj; j++){
                    var state = axisModels[j].getActiveState(values[j]);
                    if (state === 'inactive') {
                        activeState = 'inactive';
                        break;
                    }
                }
            }
            callback(activeState, dataIndex);
        }
    };
    /**
   * Whether has any activeSet.
   */ Parallel.prototype.hasAxisBrushed = function() {
        var dimensions = this.dimensions;
        var axesMap = this._axesMap;
        var hasActiveSet = false;
        for(var j = 0, lenj = dimensions.length; j < lenj; j++)if (axesMap.get(dimensions[j]).model.getActiveState() !== 'normal') hasActiveSet = true;
        return hasActiveSet;
    };
    /**
   * Convert coords of each axis to Point.
   *  Return point. For example: [10, 20]
   */ Parallel.prototype.axisCoordToPoint = function(coord, dim) {
        var axisLayout = this._axesLayout[dim];
        return $5b455ae6f843ac47$export$9f9dcb98c894b623([
            coord,
            0
        ], axisLayout.transform);
    };
    /**
   * Get axis layout.
   */ Parallel.prototype.getAxisLayout = function(dim) {
        return $7a1bd9c2710fea0d$export$9cd59f9826255e47(this._axesLayout[dim]);
    };
    /**
   * @return {Object} {axisExpandWindow, delta, behavior: 'jump' | 'slide' | 'none'}.
   */ Parallel.prototype.getSlidedAxisExpandWindow = function(point) {
        var layoutInfo = this._makeLayoutInfo();
        var pixelDimIndex = layoutInfo.pixelDimIndex;
        var axisExpandWindow = layoutInfo.axisExpandWindow.slice();
        var winSize = axisExpandWindow[1] - axisExpandWindow[0];
        var extent = [
            0,
            layoutInfo.axisExpandWidth * (layoutInfo.axisCount - 1)
        ];
        // Out of the area of coordinate system.
        if (!this.containPoint(point)) return {
            behavior: 'none',
            axisExpandWindow: axisExpandWindow
        };
        // Convert the point from global to expand coordinates.
        var pointCoord = point[pixelDimIndex] - layoutInfo.layoutBase - layoutInfo.axisExpandWindow0Pos;
        // For dragging operation convenience, the window should not be
        // slided when mouse is the center area of the window.
        var delta;
        var behavior = 'slide';
        var axisCollapseWidth = layoutInfo.axisCollapseWidth;
        var triggerArea = this._model.get('axisExpandSlideTriggerArea');
        // But consider touch device, jump is necessary.
        var useJump = triggerArea[0] != null;
        if (axisCollapseWidth) {
            if (useJump && axisCollapseWidth && pointCoord < winSize * triggerArea[0]) {
                behavior = 'jump';
                delta = pointCoord - winSize * triggerArea[2];
            } else if (useJump && axisCollapseWidth && pointCoord > winSize * (1 - triggerArea[0])) {
                behavior = 'jump';
                delta = pointCoord - winSize * (1 - triggerArea[2]);
            } else (delta = pointCoord - winSize * triggerArea[1]) >= 0 && (delta = pointCoord - winSize * (1 - triggerArea[1])) <= 0 && (delta = 0);
            delta *= layoutInfo.axisExpandWidth / axisCollapseWidth;
            delta ? (0, $00a8003b34293330$export$2e2bcd8739ae039)(delta, axisExpandWindow, extent, 'all') : behavior = 'none';
        } else {
            var winSize2 = axisExpandWindow[1] - axisExpandWindow[0];
            var pos = extent[1] * pointCoord / winSize2;
            axisExpandWindow = [
                $a26a2212b9c3ac89$var$mathMax(0, pos - winSize2 / 2)
            ];
            axisExpandWindow[1] = $a26a2212b9c3ac89$var$mathMin(extent[1], axisExpandWindow[0] + winSize2);
            axisExpandWindow[0] = axisExpandWindow[1] - winSize2;
        }
        return {
            axisExpandWindow: axisExpandWindow,
            behavior: behavior
        };
    };
    return Parallel;
}();
function $a26a2212b9c3ac89$var$restrict(len, extent) {
    return $a26a2212b9c3ac89$var$mathMin($a26a2212b9c3ac89$var$mathMax(len, extent[0]), extent[1]);
}
function $a26a2212b9c3ac89$var$layoutAxisWithoutExpand(axisIndex, layoutInfo) {
    var step = layoutInfo.layoutLength / (layoutInfo.axisCount - 1);
    return {
        position: step * axisIndex,
        axisNameAvailableWidth: step,
        axisLabelShow: true
    };
}
function $a26a2212b9c3ac89$var$layoutAxisWithExpand(axisIndex, layoutInfo) {
    var layoutLength = layoutInfo.layoutLength;
    var axisExpandWidth = layoutInfo.axisExpandWidth;
    var axisCount = layoutInfo.axisCount;
    var axisCollapseWidth = layoutInfo.axisCollapseWidth;
    var winInnerIndices = layoutInfo.winInnerIndices;
    var position;
    var axisNameAvailableWidth = axisCollapseWidth;
    var axisLabelShow = false;
    var nameTruncateMaxWidth;
    if (axisIndex < winInnerIndices[0]) {
        position = axisIndex * axisCollapseWidth;
        nameTruncateMaxWidth = axisCollapseWidth;
    } else if (axisIndex <= winInnerIndices[1]) {
        position = layoutInfo.axisExpandWindow0Pos + axisIndex * axisExpandWidth - layoutInfo.axisExpandWindow[0];
        axisNameAvailableWidth = axisExpandWidth;
        axisLabelShow = true;
    } else {
        position = layoutLength - (axisCount - 1 - axisIndex) * axisCollapseWidth;
        nameTruncateMaxWidth = axisCollapseWidth;
    }
    return {
        position: position,
        axisNameAvailableWidth: axisNameAvailableWidth,
        axisLabelShow: axisLabelShow,
        nameTruncateMaxWidth: nameTruncateMaxWidth
    };
}
var $a26a2212b9c3ac89$export$2e2bcd8739ae039 = $a26a2212b9c3ac89$var$Parallel;



function $88531590cdbcfc26$var$createParallelCoordSys(ecModel, api) {
    var coordSysList = [];
    ecModel.eachComponent('parallel', function(parallelModel, idx) {
        var coordSys = new (0, $a26a2212b9c3ac89$export$2e2bcd8739ae039)(parallelModel, ecModel, api);
        coordSys.name = 'parallel_' + idx;
        coordSys.resize(parallelModel, api);
        parallelModel.coordinateSystem = coordSys;
        coordSys.model = parallelModel;
        coordSysList.push(coordSys);
    });
    // Inject the coordinateSystems into seriesModel
    ecModel.eachSeries(function(seriesModel) {
        if (seriesModel.get('coordinateSystem') === 'parallel') {
            var parallelModel = seriesModel.getReferringComponents('parallel', (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
            seriesModel.coordinateSystem = parallelModel.coordinateSystem;
        }
    });
    return coordSysList;
}
var $88531590cdbcfc26$var$parallelCoordSysCreator = {
    create: $88531590cdbcfc26$var$createParallelCoordSys
};
var $88531590cdbcfc26$export$2e2bcd8739ae039 = $88531590cdbcfc26$var$parallelCoordSysCreator;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $ad861b9162f24222$var$defaultOption = {
    show: true,
    // zlevel: 0,
    z: 0,
    // Inverse the axis.
    inverse: false,
    // Axis name displayed.
    name: '',
    // 'start' | 'middle' | 'end'
    nameLocation: 'end',
    // By degree. By default auto rotate by nameLocation.
    nameRotate: null,
    nameTruncate: {
        maxWidth: null,
        ellipsis: '...',
        placeholder: '.'
    },
    // Use global text style by default.
    nameTextStyle: {},
    // The gap between axisName and axisLine.
    nameGap: 15,
    // Default `false` to support tooltip.
    silent: false,
    // Default `false` to avoid legacy user event listener fail.
    triggerEvent: false,
    tooltip: {
        show: false
    },
    axisPointer: {},
    axisLine: {
        show: true,
        onZero: true,
        onZeroAxisIndex: null,
        lineStyle: {
            color: '#6E7079',
            width: 1,
            type: 'solid'
        },
        // The arrow at both ends the the axis.
        symbol: [
            'none',
            'none'
        ],
        symbolSize: [
            10,
            15
        ]
    },
    axisTick: {
        show: true,
        // Whether axisTick is inside the grid or outside the grid.
        inside: false,
        // The length of axisTick.
        length: 5,
        lineStyle: {
            width: 1
        }
    },
    axisLabel: {
        show: true,
        // Whether axisLabel is inside the grid or outside the grid.
        inside: false,
        rotate: 0,
        // true | false | null/undefined (auto)
        showMinLabel: null,
        // true | false | null/undefined (auto)
        showMaxLabel: null,
        margin: 8,
        // formatter: null,
        fontSize: 12
    },
    splitLine: {
        show: true,
        showMinLine: true,
        showMaxLine: true,
        lineStyle: {
            color: [
                '#E0E6F1'
            ],
            width: 1,
            type: 'solid'
        }
    },
    splitArea: {
        show: false,
        areaStyle: {
            color: [
                'rgba(250,250,250,0.2)',
                'rgba(210,219,238,0.2)'
            ]
        }
    }
};
var $ad861b9162f24222$var$categoryAxis = $7a1bd9c2710fea0d$export$4950aa0f605343fb({
    // The gap at both ends of the axis. For categoryAxis, boolean.
    boundaryGap: true,
    // Set false to faster category collection.
    deduplication: null,
    // splitArea: {
    // show: false
    // },
    splitLine: {
        show: false
    },
    axisTick: {
        // If tick is align with label when boundaryGap is true
        alignWithLabel: false,
        interval: 'auto'
    },
    axisLabel: {
        interval: 'auto'
    }
}, $ad861b9162f24222$var$defaultOption);
var $ad861b9162f24222$var$valueAxis = $7a1bd9c2710fea0d$export$4950aa0f605343fb({
    boundaryGap: [
        0,
        0
    ],
    axisLine: {
        // Not shown when other axis is categoryAxis in cartesian
        show: 'auto'
    },
    axisTick: {
        // Not shown when other axis is categoryAxis in cartesian
        show: 'auto'
    },
    // TODO
    // min/max: [30, datamin, 60] or [20, datamin] or [datamin, 60]
    splitNumber: 5,
    minorTick: {
        // Minor tick, not available for cateogry axis.
        show: false,
        // Split number of minor ticks. The value should be in range of (0, 100)
        splitNumber: 5,
        // Length of minor tick
        length: 3,
        // Line style
        lineStyle: {
        }
    },
    minorSplitLine: {
        show: false,
        lineStyle: {
            color: '#F4F7FD',
            width: 1
        }
    }
}, $ad861b9162f24222$var$defaultOption);
var $ad861b9162f24222$var$timeAxis = $7a1bd9c2710fea0d$export$4950aa0f605343fb({
    splitNumber: 6,
    axisLabel: {
        // To eliminate labels that are not nice
        showMinLabel: false,
        showMaxLabel: false,
        rich: {
            primary: {
                fontWeight: 'bold'
            }
        }
    },
    splitLine: {
        show: false
    }
}, $ad861b9162f24222$var$valueAxis);
var $ad861b9162f24222$var$logAxis = $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
    logBase: 10
}, $ad861b9162f24222$var$valueAxis);
var $ad861b9162f24222$export$2e2bcd8739ae039 = {
    category: $ad861b9162f24222$var$categoryAxis,
    value: $ad861b9162f24222$var$valueAxis,
    time: $ad861b9162f24222$var$timeAxis,
    log: $ad861b9162f24222$var$logAxis
};




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $5dc621cc2f35ccb4$export$2e0057d176d6f690 = {
    value: 1,
    category: 1,
    time: 1,
    log: 1
};



function $c5c4c85259d60abe$export$2e2bcd8739ae039(registers, axisName, BaseAxisModelClass, extraDefaultOption) {
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $5dc621cc2f35ccb4$export$2e0057d176d6f690), function(v, axisType) {
        var defaultOption = (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)((0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)({}, (0, $ad861b9162f24222$export$2e2bcd8739ae039)[axisType], true), extraDefaultOption, true);
        var AxisModel = /** @class */ function(_super) {
            (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(AxisModel, _super);
            function AxisModel() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.type = axisName + 'Axis.' + axisType;
                return _this;
            }
            AxisModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
                var layoutMode = (0, $93b9bc7f22ac7369$export$3968a28a7cbd6063)(this);
                var inputPositionParams = layoutMode ? (0, $93b9bc7f22ac7369$export$4b0d20af19c9875e)(option) : {};
                var themeModel = ecModel.getTheme();
                (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)(option, themeModel.get(axisType + 'Axis'));
                (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)(option, this.getDefaultOption());
                option.type = $c5c4c85259d60abe$var$getAxisType(option);
                if (layoutMode) (0, $93b9bc7f22ac7369$export$1754cb91f16ca028)(option, inputPositionParams, layoutMode);
            };
            AxisModel.prototype.optionUpdated = function() {
                var thisOption = this.option;
                if (thisOption.type === 'category') this.__ordinalMeta = (0, $57fe7cbbaae9fab0$export$2e2bcd8739ae039).createByAxisModel(this);
            };
            /**
       * Should not be called before all of 'getInitailData' finished.
       * Because categories are collected during initializing data.
       */ AxisModel.prototype.getCategories = function(rawData) {
                var option = this.option;
                // FIXME
                // warning if called before all of 'getInitailData' finished.
                if (option.type === 'category') {
                    if (rawData) return option.data;
                    return this.__ordinalMeta.categories;
                }
            };
            AxisModel.prototype.getOrdinalMeta = function() {
                return this.__ordinalMeta;
            };
            AxisModel.type = axisName + 'Axis.' + axisType;
            AxisModel.defaultOption = defaultOption;
            return AxisModel;
        }(BaseAxisModelClass);
        registers.registerComponentModel(AxisModel);
    });
    registers.registerSubTypeDefaulter(axisName + 'Axis', $c5c4c85259d60abe$var$getAxisType);
}
function $c5c4c85259d60abe$var$getAxisType(option) {
    // Default axis with data is category axis
    return option.type || (option.data ? 'category' : 'value');
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // eslint-disable-next-line @typescript-eslint/no-unused-vars
var $3449fd4c0590d99e$export$5c54b224726edb5a = /** @class */ function() {
    function AxisModelCommonMixin() {}
    AxisModelCommonMixin.prototype.getNeedCrossZero = function() {
        var option = this.option;
        return !option.scale;
    };
    /**
   * Should be implemented by each axis model if necessary.
   * @return coordinate system model
   */ AxisModelCommonMixin.prototype.getCoordSysModel = function() {
        return;
    };
    return AxisModelCommonMixin;
}();


var $839a50fcb1c6f44b$var$ParallelAxisModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ParallelAxisModel, _super);
    function ParallelAxisModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ParallelAxisModel.type;
        /**
     * @readOnly
     */ _this.activeIntervals = [];
        return _this;
    }
    ParallelAxisModel.prototype.getAreaSelectStyle = function() {
        return (0, $06542048a26d4d91$export$2e2bcd8739ae039)([
            [
                'fill',
                'color'
            ],
            [
                'lineWidth',
                'borderWidth'
            ],
            [
                'stroke',
                'borderColor'
            ],
            [
                'width',
                'width'
            ],
            [
                'opacity',
                'opacity'
            ]
        ])(this.getModel('areaSelectStyle'));
    };
    /**
   * The code of this feature is put on AxisModel but not ParallelAxis,
   * because axisModel can be alive after echarts updating but instance of
   * ParallelAxis having been disposed. this._activeInterval should be kept
   * when action dispatched (i.e. legend click).
   *
   * @param intervals `interval.length === 0` means set all active.
   */ ParallelAxisModel.prototype.setActiveIntervals = function(intervals) {
        var activeIntervals = this.activeIntervals = $7a1bd9c2710fea0d$export$9cd59f9826255e47(intervals);
        // Normalize
        if (activeIntervals) for(var i = activeIntervals.length - 1; i >= 0; i--)$cfc1f3b422a3185f$export$debe6e778e0a6d32(activeIntervals[i]);
    };
    /**
   * @param value When only attempting detect whether 'no activeIntervals set',
   *        `value` is not needed to be input.
   */ ParallelAxisModel.prototype.getActiveState = function(value) {
        var activeIntervals = this.activeIntervals;
        if (!activeIntervals.length) return 'normal';
        if (value == null || isNaN(+value)) return 'inactive';
        // Simple optimization
        if (activeIntervals.length === 1) {
            var interval = activeIntervals[0];
            if (interval[0] <= value && value <= interval[1]) return 'active';
        } else for(var i = 0, len = activeIntervals.length; i < len; i++){
            if (activeIntervals[i][0] <= value && value <= activeIntervals[i][1]) return 'active';
        }
        return 'inactive';
    };
    return ParallelAxisModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
$7a1bd9c2710fea0d$export$e36fc9d62a853069($839a50fcb1c6f44b$var$ParallelAxisModel, (0, $3449fd4c0590d99e$export$5c54b224726edb5a));
var $839a50fcb1c6f44b$export$2e2bcd8739ae039 = $839a50fcb1c6f44b$var$ParallelAxisModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 









/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $11dac7a73f36cc2c$export$6c403cad1ae3e239(input) {
    var list = [];
    for(var i = 0; i < input.length; i++){
        var rawItem = input[i];
        if (rawItem.defaultAttr.ignore) continue;
        var label = rawItem.label;
        var transform = label.getComputedTransform();
        // NOTE: Get bounding rect after getComputedTransform, or label may not been updated by the host el.
        var localRect = label.getBoundingRect();
        var isAxisAligned = !transform || transform[1] < 1e-5 && transform[2] < 1e-5;
        var minMargin = label.style.margin || 0;
        var globalRect = localRect.clone();
        globalRect.applyTransform(transform);
        globalRect.x -= minMargin / 2;
        globalRect.y -= minMargin / 2;
        globalRect.width += minMargin;
        globalRect.height += minMargin;
        var obb = isAxisAligned ? new (0, $f9793b4d8aade116$export$2e2bcd8739ae039)(localRect, transform) : null;
        list.push({
            label: label,
            labelLine: rawItem.labelLine,
            rect: globalRect,
            localRect: localRect,
            obb: obb,
            priority: rawItem.priority,
            defaultAttr: rawItem.defaultAttr,
            layoutOption: rawItem.computedLayoutOption,
            axisAligned: isAxisAligned,
            transform: transform
        });
    }
    return list;
}
function $11dac7a73f36cc2c$var$shiftLayout(list, xyDim, sizeDim, minBound, maxBound, balanceShift) {
    var len = list.length;
    if (len < 2) return;
    list.sort(function(a, b) {
        return a.rect[xyDim] - b.rect[xyDim];
    });
    var lastPos = 0;
    var delta;
    var adjusted = false;
    var shifts = [];
    var totalShifts = 0;
    for(var i = 0; i < len; i++){
        var item = list[i];
        var rect = item.rect;
        delta = rect[xyDim] - lastPos;
        if (delta < 0) {
            // shiftForward(i, len, -delta);
            rect[xyDim] -= delta;
            item.label[xyDim] -= delta;
            adjusted = true;
        }
        var shift = Math.max(-delta, 0);
        shifts.push(shift);
        totalShifts += shift;
        lastPos = rect[xyDim] + rect[sizeDim];
    }
    if (totalShifts > 0 && balanceShift) // Shift back to make the distribution more equally.
    shiftList(-totalShifts / len, 0, len);
    // TODO bleedMargin?
    var first = list[0];
    var last = list[len - 1];
    var minGap;
    var maxGap;
    updateMinMaxGap();
    // If ends exceed two bounds, squeeze at most 80%, then take the gap of two bounds.
    minGap < 0 && squeezeGaps(-minGap, 0.8);
    maxGap < 0 && squeezeGaps(maxGap, 0.8);
    updateMinMaxGap();
    takeBoundsGap(minGap, maxGap, 1);
    takeBoundsGap(maxGap, minGap, -1);
    // Handle bailout when there is not enough space.
    updateMinMaxGap();
    if (minGap < 0) squeezeWhenBailout(-minGap);
    if (maxGap < 0) squeezeWhenBailout(maxGap);
    function updateMinMaxGap() {
        minGap = first.rect[xyDim] - minBound;
        maxGap = maxBound - last.rect[xyDim] - last.rect[sizeDim];
    }
    function takeBoundsGap(gapThisBound, gapOtherBound, moveDir) {
        if (gapThisBound < 0) {
            // Move from other gap if can.
            var moveFromMaxGap = Math.min(gapOtherBound, -gapThisBound);
            if (moveFromMaxGap > 0) {
                shiftList(moveFromMaxGap * moveDir, 0, len);
                var remained = moveFromMaxGap + gapThisBound;
                if (remained < 0) squeezeGaps(-remained * moveDir, 1);
            } else squeezeGaps(-gapThisBound * moveDir, 1);
        }
    }
    function shiftList(delta, start, end) {
        if (delta !== 0) adjusted = true;
        for(var i = start; i < end; i++){
            var item = list[i];
            var rect = item.rect;
            rect[xyDim] += delta;
            item.label[xyDim] += delta;
        }
    }
    // Squeeze gaps if the labels exceed margin.
    function squeezeGaps(delta, maxSqeezePercent) {
        var gaps = [];
        var totalGaps = 0;
        for(var i = 1; i < len; i++){
            var prevItemRect = list[i - 1].rect;
            var gap = Math.max(list[i].rect[xyDim] - prevItemRect[xyDim] - prevItemRect[sizeDim], 0);
            gaps.push(gap);
            totalGaps += gap;
        }
        if (!totalGaps) return;
        var squeezePercent = Math.min(Math.abs(delta) / totalGaps, maxSqeezePercent);
        if (delta > 0) for(var i = 0; i < len - 1; i++){
            // Distribute the shift delta to all gaps.
            var movement = gaps[i] * squeezePercent;
            // Forward
            shiftList(movement, 0, i + 1);
        }
        else // Backward
        for(var i = len - 1; i > 0; i--){
            // Distribute the shift delta to all gaps.
            var movement = gaps[i - 1] * squeezePercent;
            shiftList(-movement, i, len);
        }
    }
    /**
   * Squeeze to allow overlap if there is no more space available.
   * Let other overlapping strategy like hideOverlap do the job instead of keep exceeding the bounds.
   */ function squeezeWhenBailout(delta) {
        var dir = delta < 0 ? -1 : 1;
        delta = Math.abs(delta);
        var moveForEachLabel = Math.ceil(delta / (len - 1));
        for(var i = 0; i < len - 1; i++){
            if (dir > 0) // Forward
            shiftList(moveForEachLabel, 0, i + 1);
            else // Backward
            shiftList(-moveForEachLabel, len - i - 1, len);
            delta -= moveForEachLabel;
            if (delta <= 0) return;
        }
    }
    return adjusted;
}
function $11dac7a73f36cc2c$export$b6b2b07f8ed32bd6(list, leftBound, rightBound, // If average the shifts on all labels and add them to 0
// TODO: Not sure if should enable it.
// Pros: The angle of lines will distribute more equally
// Cons: In some layout. It may not what user wanted. like in pie. the label of last sector is usually changed unexpectedly.
balanceShift) {
    return $11dac7a73f36cc2c$var$shiftLayout(list, 'x', 'width', leftBound, rightBound, balanceShift);
}
function $11dac7a73f36cc2c$export$118c25e0932528e4(list, topBound, bottomBound, // If average the shifts on all labels and add them to 0
balanceShift) {
    return $11dac7a73f36cc2c$var$shiftLayout(list, 'y', 'height', topBound, bottomBound, balanceShift);
}
function $11dac7a73f36cc2c$export$8ce774e164a49410(labelList) {
    var displayedLabels = [];
    // TODO, render overflow visible first, put in the displayedLabels.
    labelList.sort(function(a, b) {
        return b.priority - a.priority;
    });
    var globalRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
    function hideEl(el) {
        if (!el.ignore) {
            // Show on emphasis.
            var emphasisState = el.ensureState('emphasis');
            if (emphasisState.ignore == null) emphasisState.ignore = false;
        }
        el.ignore = true;
    }
    for(var i = 0; i < labelList.length; i++){
        var labelItem = labelList[i];
        var isAxisAligned = labelItem.axisAligned;
        var localRect = labelItem.localRect;
        var transform = labelItem.transform;
        var label = labelItem.label;
        var labelLine = labelItem.labelLine;
        globalRect.copy(labelItem.rect);
        // Add a threshold because layout may be aligned precisely.
        globalRect.width -= 0.1;
        globalRect.height -= 0.1;
        globalRect.x += 0.05;
        globalRect.y += 0.05;
        var obb = labelItem.obb;
        var overlapped = false;
        for(var j = 0; j < displayedLabels.length; j++){
            var existsTextCfg = displayedLabels[j];
            // Fast rejection.
            if (!globalRect.intersect(existsTextCfg.rect)) continue;
            if (isAxisAligned && existsTextCfg.axisAligned) {
                // Is overlapped
                overlapped = true;
                break;
            }
            if (!existsTextCfg.obb) // If self is not axis aligned. But other is.
            existsTextCfg.obb = new (0, $f9793b4d8aade116$export$2e2bcd8739ae039)(existsTextCfg.localRect, existsTextCfg.transform);
            if (!obb) // If self is axis aligned. But other is not.
            obb = new (0, $f9793b4d8aade116$export$2e2bcd8739ae039)(localRect, transform);
            if (obb.intersect(existsTextCfg.obb)) {
                overlapped = true;
                break;
            }
        }
        // TODO Callback to determine if this overlap should be handled?
        if (overlapped) {
            hideEl(label);
            labelLine && hideEl(labelLine);
        } else {
            label.attr('ignore', labelItem.defaultAttr.ignore);
            labelLine && labelLine.attr('ignore', labelItem.defaultAttr.labelGuideIgnore);
            displayedLabels.push(labelItem);
        }
    }
}


var $dfe15f745e1c3c2b$var$PI = Math.PI;
/**
 * A final axis is translated and rotated from a "standard axis".
 * So opt.position and opt.rotation is required.
 *
 * A standard axis is and axis from [0, 0] to [0, axisExtent[1]],
 * for example: (0, 0) ------------> (0, 50)
 *
 * nameDirection or tickDirection or labelDirection is 1 means tick
 * or label is below the standard axis, whereas is -1 means above
 * the standard axis. labelOffset means offset between label and axis,
 * which is useful when 'onZero', where axisLabel is in the grid and
 * label in outside grid.
 *
 * Tips: like always,
 * positive rotation represents anticlockwise, and negative rotation
 * represents clockwise.
 * The direction of position coordinate is the same as the direction
 * of screen coordinate.
 *
 * Do not need to consider axis 'inverse', which is auto processed by
 * axis extent.
 */ var $dfe15f745e1c3c2b$var$AxisBuilder = /** @class */ function() {
    function AxisBuilder(axisModel, opt) {
        this.group = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        this.opt = opt;
        this.axisModel = axisModel;
        // Default value
        (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(opt, {
            labelOffset: 0,
            nameDirection: 1,
            tickDirection: 1,
            labelDirection: 1,
            silent: true,
            handleAutoShown: function() {
                return true;
            }
        });
        // FIXME Not use a separate text group?
        var transformGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039({
            x: opt.position[0],
            y: opt.position[1],
            rotation: opt.rotation
        });
        // this.group.add(transformGroup);
        // this._transformGroup = transformGroup;
        transformGroup.updateTransform();
        this._transformGroup = transformGroup;
    }
    AxisBuilder.prototype.hasBuilder = function(name) {
        return !!$dfe15f745e1c3c2b$var$builders[name];
    };
    AxisBuilder.prototype.add = function(name) {
        $dfe15f745e1c3c2b$var$builders[name](this.opt, this.axisModel, this.group, this._transformGroup);
    };
    AxisBuilder.prototype.getGroup = function() {
        return this.group;
    };
    AxisBuilder.innerTextLayout = function(axisRotation, textRotation, direction) {
        var rotationDiff = (0, $cfc1f3b422a3185f$export$2ca6dd70a288b1c3)(textRotation - axisRotation);
        var textAlign;
        var textVerticalAlign;
        if ((0, $cfc1f3b422a3185f$export$d1df570aea2868f)(rotationDiff)) {
            // Label is parallel with axis line.
            textVerticalAlign = direction > 0 ? 'top' : 'bottom';
            textAlign = 'center';
        } else if ((0, $cfc1f3b422a3185f$export$d1df570aea2868f)(rotationDiff - $dfe15f745e1c3c2b$var$PI)) {
            // Label is inverse parallel with axis line.
            textVerticalAlign = direction > 0 ? 'bottom' : 'top';
            textAlign = 'center';
        } else {
            textVerticalAlign = 'middle';
            if (rotationDiff > 0 && rotationDiff < $dfe15f745e1c3c2b$var$PI) textAlign = direction > 0 ? 'right' : 'left';
            else textAlign = direction > 0 ? 'left' : 'right';
        }
        return {
            rotation: rotationDiff,
            textAlign: textAlign,
            textVerticalAlign: textVerticalAlign
        };
    };
    AxisBuilder.makeAxisEventDataBase = function(axisModel) {
        var eventData = {
            componentType: axisModel.mainType,
            componentIndex: axisModel.componentIndex
        };
        eventData[axisModel.mainType + 'Index'] = axisModel.componentIndex;
        return eventData;
    };
    AxisBuilder.isLabelSilent = function(axisModel) {
        var tooltipOpt = axisModel.get('tooltip');
        return axisModel.get('silent') || !(axisModel.get('triggerEvent') || tooltipOpt && tooltipOpt.show);
    };
    return AxisBuilder;
}();
var $dfe15f745e1c3c2b$var$builders = {
    axisLine: function(opt, axisModel, group, transformGroup) {
        var shown = axisModel.get([
            'axisLine',
            'show'
        ]);
        if (shown === 'auto' && opt.handleAutoShown) shown = opt.handleAutoShown('axisLine');
        if (!shown) return;
        var extent = axisModel.axis.getExtent();
        var matrix = transformGroup.transform;
        var pt1 = [
            extent[0],
            0
        ];
        var pt2 = [
            extent[1],
            0
        ];
        var inverse = pt1[0] > pt2[0];
        if (matrix) {
            (0, $6de594cf8ac295ff$export$9f9dcb98c894b623)(pt1, pt1, matrix);
            (0, $6de594cf8ac295ff$export$9f9dcb98c894b623)(pt2, pt2, matrix);
        }
        var lineStyle = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
            lineCap: 'round'
        }, axisModel.getModel([
            'axisLine',
            'lineStyle'
        ]).getLineStyle());
        var line = new $7a316ae5ceff7b27$export$2e2bcd8739ae039({
            shape: {
                x1: pt1[0],
                y1: pt1[1],
                x2: pt2[0],
                y2: pt2[1]
            },
            style: lineStyle,
            strokeContainThreshold: opt.strokeContainThreshold || 5,
            silent: true,
            z2: 1
        });
        $5b455ae6f843ac47$export$8b4b620d7f4aad1b(line.shape, line.style.lineWidth);
        line.anid = 'line';
        group.add(line);
        var arrows = axisModel.get([
            'axisLine',
            'symbol'
        ]);
        if (arrows != null) {
            var arrowSize = axisModel.get([
                'axisLine',
                'symbolSize'
            ]);
            if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(arrows)) // Use the same arrow for start and end point
            arrows = [
                arrows,
                arrows
            ];
            if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(arrowSize) || (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(arrowSize)) // Use the same size for width and height
            arrowSize = [
                arrowSize,
                arrowSize
            ];
            var arrowOffset = (0, $5370466dadc978d7$export$e3e292895c033f6d)(axisModel.get([
                'axisLine',
                'symbolOffset'
            ]) || 0, arrowSize);
            var symbolWidth_1 = arrowSize[0];
            var symbolHeight_1 = arrowSize[1];
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
                {
                    rotate: opt.rotation + Math.PI / 2,
                    offset: arrowOffset[0],
                    r: 0
                },
                {
                    rotate: opt.rotation - Math.PI / 2,
                    offset: arrowOffset[1],
                    r: Math.sqrt((pt1[0] - pt2[0]) * (pt1[0] - pt2[0]) + (pt1[1] - pt2[1]) * (pt1[1] - pt2[1]))
                }
            ], function(point, index) {
                if (arrows[index] !== 'none' && arrows[index] != null) {
                    var symbol = (0, $5370466dadc978d7$export$af050e04da3a02e8)(arrows[index], -symbolWidth_1 / 2, -symbolHeight_1 / 2, symbolWidth_1, symbolHeight_1, lineStyle.stroke, true);
                    // Calculate arrow position with offset
                    var r = point.r + point.offset;
                    var pt = inverse ? pt2 : pt1;
                    symbol.attr({
                        rotation: point.rotate,
                        x: pt[0] + r * Math.cos(opt.rotation),
                        y: pt[1] - r * Math.sin(opt.rotation),
                        silent: true,
                        z2: 11
                    });
                    group.add(symbol);
                }
            });
        }
    },
    axisTickLabel: function(opt, axisModel, group, transformGroup) {
        var ticksEls = $dfe15f745e1c3c2b$var$buildAxisMajorTicks(group, transformGroup, axisModel, opt);
        var labelEls = $dfe15f745e1c3c2b$var$buildAxisLabel(group, transformGroup, axisModel, opt);
        $dfe15f745e1c3c2b$var$fixMinMaxLabelShow(axisModel, labelEls, ticksEls);
        $dfe15f745e1c3c2b$var$buildAxisMinorTicks(group, transformGroup, axisModel, opt.tickDirection);
        // This bit fixes the label overlap issue for the time chart.
        // See https://github.com/apache/echarts/issues/14266 for more.
        if (axisModel.get([
            'axisLabel',
            'hideOverlap'
        ])) {
            var labelList = (0, $11dac7a73f36cc2c$export$6c403cad1ae3e239)((0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(labelEls, function(label) {
                return {
                    label: label,
                    priority: label.z2,
                    defaultAttr: {
                        ignore: label.ignore
                    }
                };
            }));
            (0, $11dac7a73f36cc2c$export$8ce774e164a49410)(labelList);
        }
    },
    axisName: function(opt, axisModel, group, transformGroup) {
        var name = (0, $7a1bd9c2710fea0d$export$8a4d17b6e8486e66)(opt.axisName, axisModel.get('name'));
        if (!name) return;
        var nameLocation = axisModel.get('nameLocation');
        var nameDirection = opt.nameDirection;
        var textStyleModel = axisModel.getModel('nameTextStyle');
        var gap = axisModel.get('nameGap') || 0;
        var extent = axisModel.axis.getExtent();
        var gapSignal = extent[0] > extent[1] ? -1 : 1;
        var pos = [
            nameLocation === 'start' ? extent[0] - gapSignal * gap : nameLocation === 'end' ? extent[1] + gapSignal * gap : (extent[0] + extent[1]) / 2,
            // Reuse labelOffset.
            $dfe15f745e1c3c2b$var$isNameLocationCenter(nameLocation) ? opt.labelOffset + nameDirection * gap : 0
        ];
        var labelLayout;
        var nameRotation = axisModel.get('nameRotate');
        if (nameRotation != null) nameRotation = nameRotation * $dfe15f745e1c3c2b$var$PI / 180; // To radian.
        var axisNameAvailableWidth;
        if ($dfe15f745e1c3c2b$var$isNameLocationCenter(nameLocation)) labelLayout = $dfe15f745e1c3c2b$var$AxisBuilder.innerTextLayout(opt.rotation, nameRotation != null ? nameRotation : opt.rotation, // Adapt to axis.
        nameDirection);
        else {
            labelLayout = $dfe15f745e1c3c2b$var$endTextLayout(opt.rotation, nameLocation, nameRotation || 0, extent);
            axisNameAvailableWidth = opt.axisNameAvailableWidth;
            if (axisNameAvailableWidth != null) {
                axisNameAvailableWidth = Math.abs(axisNameAvailableWidth / Math.sin(labelLayout.rotation));
                !isFinite(axisNameAvailableWidth) && (axisNameAvailableWidth = null);
            }
        }
        var textFont = textStyleModel.getFont();
        var truncateOpt = axisModel.get('nameTruncate', true) || {};
        var ellipsis = truncateOpt.ellipsis;
        var maxWidth = (0, $7a1bd9c2710fea0d$export$8a4d17b6e8486e66)(opt.nameTruncateMaxWidth, truncateOpt.maxWidth, axisNameAvailableWidth);
        var textEl = new $fe885cc21795562b$export$2e2bcd8739ae039({
            x: pos[0],
            y: pos[1],
            rotation: labelLayout.rotation,
            silent: $dfe15f745e1c3c2b$var$AxisBuilder.isLabelSilent(axisModel),
            style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(textStyleModel, {
                text: name,
                font: textFont,
                overflow: 'truncate',
                width: maxWidth,
                ellipsis: ellipsis,
                fill: textStyleModel.getTextColor() || axisModel.get([
                    'axisLine',
                    'lineStyle',
                    'color'
                ]),
                align: textStyleModel.get('align') || labelLayout.textAlign,
                verticalAlign: textStyleModel.get('verticalAlign') || labelLayout.textVerticalAlign
            }),
            z2: 1
        });
        $5b455ae6f843ac47$export$fc6410d97fab306c({
            el: textEl,
            componentModel: axisModel,
            itemName: name
        });
        textEl.__fullText = name;
        // Id for animation
        textEl.anid = 'name';
        if (axisModel.get('triggerEvent')) {
            var eventData = $dfe15f745e1c3c2b$var$AxisBuilder.makeAxisEventDataBase(axisModel);
            eventData.targetType = 'axisName';
            eventData.name = name;
            (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(textEl).eventData = eventData;
        }
        // FIXME
        transformGroup.add(textEl);
        textEl.updateTransform();
        group.add(textEl);
        textEl.decomposeTransform();
    }
};
function $dfe15f745e1c3c2b$var$endTextLayout(rotation, textPosition, textRotate, extent) {
    var rotationDiff = (0, $cfc1f3b422a3185f$export$2ca6dd70a288b1c3)(textRotate - rotation);
    var textAlign;
    var textVerticalAlign;
    var inverse = extent[0] > extent[1];
    var onLeft = textPosition === 'start' && !inverse || textPosition !== 'start' && inverse;
    if ((0, $cfc1f3b422a3185f$export$d1df570aea2868f)(rotationDiff - $dfe15f745e1c3c2b$var$PI / 2)) {
        textVerticalAlign = onLeft ? 'bottom' : 'top';
        textAlign = 'center';
    } else if ((0, $cfc1f3b422a3185f$export$d1df570aea2868f)(rotationDiff - $dfe15f745e1c3c2b$var$PI * 1.5)) {
        textVerticalAlign = onLeft ? 'top' : 'bottom';
        textAlign = 'center';
    } else {
        textVerticalAlign = 'middle';
        if (rotationDiff < $dfe15f745e1c3c2b$var$PI * 1.5 && rotationDiff > $dfe15f745e1c3c2b$var$PI / 2) textAlign = onLeft ? 'left' : 'right';
        else textAlign = onLeft ? 'right' : 'left';
    }
    return {
        rotation: rotationDiff,
        textAlign: textAlign,
        textVerticalAlign: textVerticalAlign
    };
}
function $dfe15f745e1c3c2b$var$fixMinMaxLabelShow(axisModel, labelEls, tickEls) {
    if ((0, $2d646e51cc34f840$export$c2911c025243d6a6)(axisModel.axis)) return;
    // If min or max are user set, we need to check
    // If the tick on min(max) are overlap on their neighbour tick
    // If they are overlapped, we need to hide the min(max) tick label
    var showMinLabel = axisModel.get([
        'axisLabel',
        'showMinLabel'
    ]);
    var showMaxLabel = axisModel.get([
        'axisLabel',
        'showMaxLabel'
    ]);
    // FIXME
    // Have not consider onBand yet, where tick els is more than label els.
    labelEls = labelEls || [];
    tickEls = tickEls || [];
    var firstLabel = labelEls[0];
    var nextLabel = labelEls[1];
    var lastLabel = labelEls[labelEls.length - 1];
    var prevLabel = labelEls[labelEls.length - 2];
    var firstTick = tickEls[0];
    var nextTick = tickEls[1];
    var lastTick = tickEls[tickEls.length - 1];
    var prevTick = tickEls[tickEls.length - 2];
    if (showMinLabel === false) {
        $dfe15f745e1c3c2b$var$ignoreEl(firstLabel);
        $dfe15f745e1c3c2b$var$ignoreEl(firstTick);
    } else if ($dfe15f745e1c3c2b$var$isTwoLabelOverlapped(firstLabel, nextLabel)) {
        if (showMinLabel) {
            $dfe15f745e1c3c2b$var$ignoreEl(nextLabel);
            $dfe15f745e1c3c2b$var$ignoreEl(nextTick);
        } else {
            $dfe15f745e1c3c2b$var$ignoreEl(firstLabel);
            $dfe15f745e1c3c2b$var$ignoreEl(firstTick);
        }
    }
    if (showMaxLabel === false) {
        $dfe15f745e1c3c2b$var$ignoreEl(lastLabel);
        $dfe15f745e1c3c2b$var$ignoreEl(lastTick);
    } else if ($dfe15f745e1c3c2b$var$isTwoLabelOverlapped(prevLabel, lastLabel)) {
        if (showMaxLabel) {
            $dfe15f745e1c3c2b$var$ignoreEl(prevLabel);
            $dfe15f745e1c3c2b$var$ignoreEl(prevTick);
        } else {
            $dfe15f745e1c3c2b$var$ignoreEl(lastLabel);
            $dfe15f745e1c3c2b$var$ignoreEl(lastTick);
        }
    }
}
function $dfe15f745e1c3c2b$var$ignoreEl(el) {
    el && (el.ignore = true);
}
function $dfe15f745e1c3c2b$var$isTwoLabelOverlapped(current, next) {
    // current and next has the same rotation.
    var firstRect = current && current.getBoundingRect().clone();
    var nextRect = next && next.getBoundingRect().clone();
    if (!firstRect || !nextRect) return;
    // When checking intersect of two rotated labels, we use mRotationBack
    // to avoid that boundingRect is enlarge when using `boundingRect.applyTransform`.
    var mRotationBack = $f41ebb9dd60b55b4$export$f0954fd7d5368655([]);
    $f41ebb9dd60b55b4$export$bb628a54ab399bc9(mRotationBack, mRotationBack, -current.rotation);
    firstRect.applyTransform($f41ebb9dd60b55b4$export$6e3a27864ab166fe([], mRotationBack, current.getLocalTransform()));
    nextRect.applyTransform($f41ebb9dd60b55b4$export$6e3a27864ab166fe([], mRotationBack, next.getLocalTransform()));
    return firstRect.intersect(nextRect);
}
function $dfe15f745e1c3c2b$var$isNameLocationCenter(nameLocation) {
    return nameLocation === 'middle' || nameLocation === 'center';
}
function $dfe15f745e1c3c2b$var$createTicks(ticksCoords, tickTransform, tickEndCoord, tickLineStyle, anidPrefix) {
    var tickEls = [];
    var pt1 = [];
    var pt2 = [];
    for(var i = 0; i < ticksCoords.length; i++){
        var tickCoord = ticksCoords[i].coord;
        pt1[0] = tickCoord;
        pt1[1] = 0;
        pt2[0] = tickCoord;
        pt2[1] = tickEndCoord;
        if (tickTransform) {
            (0, $6de594cf8ac295ff$export$9f9dcb98c894b623)(pt1, pt1, tickTransform);
            (0, $6de594cf8ac295ff$export$9f9dcb98c894b623)(pt2, pt2, tickTransform);
        }
        // Tick line, Not use group transform to have better line draw
        var tickEl = new $7a316ae5ceff7b27$export$2e2bcd8739ae039({
            shape: {
                x1: pt1[0],
                y1: pt1[1],
                x2: pt2[0],
                y2: pt2[1]
            },
            style: tickLineStyle,
            z2: 2,
            autoBatch: true,
            silent: true
        });
        $5b455ae6f843ac47$export$8b4b620d7f4aad1b(tickEl.shape, tickEl.style.lineWidth);
        tickEl.anid = anidPrefix + '_' + ticksCoords[i].tickValue;
        tickEls.push(tickEl);
    }
    return tickEls;
}
function $dfe15f745e1c3c2b$var$buildAxisMajorTicks(group, transformGroup, axisModel, opt) {
    var axis = axisModel.axis;
    var tickModel = axisModel.getModel('axisTick');
    var shown = tickModel.get('show');
    if (shown === 'auto' && opt.handleAutoShown) shown = opt.handleAutoShown('axisTick');
    if (!shown || axis.scale.isBlank()) return;
    var lineStyleModel = tickModel.getModel('lineStyle');
    var tickEndCoord = opt.tickDirection * tickModel.get('length');
    var ticksCoords = axis.getTicksCoords();
    var ticksEls = $dfe15f745e1c3c2b$var$createTicks(ticksCoords, transformGroup.transform, tickEndCoord, (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(lineStyleModel.getLineStyle(), {
        stroke: axisModel.get([
            'axisLine',
            'lineStyle',
            'color'
        ])
    }), 'ticks');
    for(var i = 0; i < ticksEls.length; i++)group.add(ticksEls[i]);
    return ticksEls;
}
function $dfe15f745e1c3c2b$var$buildAxisMinorTicks(group, transformGroup, axisModel, tickDirection) {
    var axis = axisModel.axis;
    var minorTickModel = axisModel.getModel('minorTick');
    if (!minorTickModel.get('show') || axis.scale.isBlank()) return;
    var minorTicksCoords = axis.getMinorTicksCoords();
    if (!minorTicksCoords.length) return;
    var lineStyleModel = minorTickModel.getModel('lineStyle');
    var tickEndCoord = tickDirection * minorTickModel.get('length');
    var minorTickLineStyle = (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(lineStyleModel.getLineStyle(), (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(axisModel.getModel('axisTick').getLineStyle(), {
        stroke: axisModel.get([
            'axisLine',
            'lineStyle',
            'color'
        ])
    }));
    for(var i = 0; i < minorTicksCoords.length; i++){
        var minorTicksEls = $dfe15f745e1c3c2b$var$createTicks(minorTicksCoords[i], transformGroup.transform, tickEndCoord, minorTickLineStyle, 'minorticks_' + i);
        for(var k = 0; k < minorTicksEls.length; k++)group.add(minorTicksEls[k]);
    }
}
function $dfe15f745e1c3c2b$var$buildAxisLabel(group, transformGroup, axisModel, opt) {
    var axis = axisModel.axis;
    var show = (0, $7a1bd9c2710fea0d$export$8a4d17b6e8486e66)(opt.axisLabelShow, axisModel.get([
        'axisLabel',
        'show'
    ]));
    if (!show || axis.scale.isBlank()) return;
    var labelModel = axisModel.getModel('axisLabel');
    var labelMargin = labelModel.get('margin');
    var labels = axis.getViewLabels();
    // Special label rotate.
    var labelRotation = ((0, $7a1bd9c2710fea0d$export$8a4d17b6e8486e66)(opt.labelRotate, labelModel.get('rotate')) || 0) * $dfe15f745e1c3c2b$var$PI / 180;
    var labelLayout = $dfe15f745e1c3c2b$var$AxisBuilder.innerTextLayout(opt.rotation, labelRotation, opt.labelDirection);
    var rawCategoryData = axisModel.getCategories && axisModel.getCategories(true);
    var labelEls = [];
    var silent = $dfe15f745e1c3c2b$var$AxisBuilder.isLabelSilent(axisModel);
    var triggerEvent = axisModel.get('triggerEvent');
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(labels, function(labelItem, index) {
        var tickValue = axis.scale.type === 'ordinal' ? axis.scale.getRawOrdinalNumber(labelItem.tickValue) : labelItem.tickValue;
        var formattedLabel = labelItem.formattedLabel;
        var rawLabel = labelItem.rawLabel;
        var itemLabelModel = labelModel;
        if (rawCategoryData && rawCategoryData[tickValue]) {
            var rawCategoryItem = rawCategoryData[tickValue];
            if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(rawCategoryItem) && rawCategoryItem.textStyle) itemLabelModel = new (0, $6818646a97528290$export$2e2bcd8739ae039)(rawCategoryItem.textStyle, labelModel, axisModel.ecModel);
        }
        var textColor = itemLabelModel.getTextColor() || axisModel.get([
            'axisLine',
            'lineStyle',
            'color'
        ]);
        var tickCoord = axis.dataToCoord(tickValue);
        var align = itemLabelModel.getShallow('align', true) || labelLayout.textAlign;
        var alignMin = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(itemLabelModel.getShallow('alignMinLabel', true), align);
        var alignMax = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(itemLabelModel.getShallow('alignMaxLabel', true), align);
        var verticalAlign = itemLabelModel.getShallow('verticalAlign', true) || itemLabelModel.getShallow('baseline', true) || labelLayout.textVerticalAlign;
        var verticalAlignMin = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(itemLabelModel.getShallow('verticalAlignMinLabel', true), verticalAlign);
        var verticalAlignMax = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(itemLabelModel.getShallow('verticalAlignMaxLabel', true), verticalAlign);
        var textEl = new $fe885cc21795562b$export$2e2bcd8739ae039({
            x: tickCoord,
            y: opt.labelOffset + opt.labelDirection * labelMargin,
            rotation: labelLayout.rotation,
            silent: silent,
            z2: 10 + (labelItem.level || 0),
            style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(itemLabelModel, {
                text: formattedLabel,
                align: index === 0 ? alignMin : index === labels.length - 1 ? alignMax : align,
                verticalAlign: index === 0 ? verticalAlignMin : index === labels.length - 1 ? verticalAlignMax : verticalAlign,
                fill: (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(textColor) ? textColor(// (1) In category axis with data zoom, tick is not the original
                // index of axis.data. So tick should not be exposed to user
                // in category axis.
                // (2) Compatible with previous version, which always use formatted label as
                // input. But in interval scale the formatted label is like '223,445', which
                // maked user replace ','. So we modify it to return original val but remain
                // it as 'string' to avoid error in replacing.
                axis.type === 'category' ? rawLabel : axis.type === 'value' ? tickValue + '' : tickValue, index) : textColor
            })
        });
        textEl.anid = 'label_' + tickValue;
        $5b455ae6f843ac47$export$fc6410d97fab306c({
            el: textEl,
            componentModel: axisModel,
            itemName: formattedLabel,
            formatterParamsExtra: {
                isTruncated: function() {
                    return textEl.isTruncated;
                },
                value: rawLabel,
                tickIndex: index
            }
        });
        // Pack data for mouse event
        if (triggerEvent) {
            var eventData = $dfe15f745e1c3c2b$var$AxisBuilder.makeAxisEventDataBase(axisModel);
            eventData.targetType = 'axisLabel';
            eventData.value = rawLabel;
            eventData.tickIndex = index;
            if (axis.type === 'category') eventData.dataIndex = tickValue;
            (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(textEl).eventData = eventData;
        }
        // FIXME
        transformGroup.add(textEl);
        textEl.updateTransform();
        labelEls.push(textEl);
        group.add(textEl);
        textEl.decomposeTransform();
    });
    return labelEls;
}
var $dfe15f745e1c3c2b$export$2e2bcd8739ae039 = $dfe15f745e1c3c2b$var$AxisBuilder;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $91342d1cfa622c5a$var$BRUSH_PANEL_GLOBAL = true;
var $91342d1cfa622c5a$var$mathMin = Math.min;
var $91342d1cfa622c5a$var$mathMax = Math.max;
var $91342d1cfa622c5a$var$mathPow = Math.pow;
var $91342d1cfa622c5a$var$COVER_Z = 10000;
var $91342d1cfa622c5a$var$UNSELECT_THRESHOLD = 6;
var $91342d1cfa622c5a$var$MIN_RESIZE_LINE_WIDTH = 6;
var $91342d1cfa622c5a$var$MUTEX_RESOURCE_KEY = 'globalPan';
var $91342d1cfa622c5a$var$DIRECTION_MAP = {
    w: [
        0,
        0
    ],
    e: [
        0,
        1
    ],
    n: [
        1,
        0
    ],
    s: [
        1,
        1
    ]
};
var $91342d1cfa622c5a$var$CURSOR_MAP = {
    w: 'ew',
    e: 'ew',
    n: 'ns',
    s: 'ns',
    ne: 'nesw',
    sw: 'nesw',
    nw: 'nwse',
    se: 'nwse'
};
var $91342d1cfa622c5a$var$DEFAULT_BRUSH_OPT = {
    brushStyle: {
        lineWidth: 2,
        stroke: 'rgba(210,219,238,0.3)',
        fill: '#D2DBEE'
    },
    transformable: true,
    brushMode: 'single',
    removeOnClick: false
};
var $91342d1cfa622c5a$var$baseUID = 0;
/**
 * params:
 *     areas: Array.<Array>, coord relates to container group,
 *                             If no container specified, to global.
 *     opt {
 *         isEnd: boolean,
 *         removeOnClick: boolean
 *     }
 */ var $91342d1cfa622c5a$var$BrushController = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(BrushController, _super);
    function BrushController(zr) {
        var _this = _super.call(this) || this;
        /**
     * @internal
     */ _this._track = [];
        /**
     * @internal
     */ _this._covers = [];
        _this._handlers = {};
        _this._zr = zr;
        _this.group = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        _this._uid = 'brushController_' + $91342d1cfa622c5a$var$baseUID++;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($91342d1cfa622c5a$var$pointerHandlers, function(handler, eventName) {
            this._handlers[eventName] = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(handler, this);
        }, _this);
        return _this;
    }
    /**
   * If set to `false`, select disabled.
   */ BrushController.prototype.enableBrush = function(brushOption) {
        this._brushType && this._doDisableBrush();
        brushOption.brushType && this._doEnableBrush(brushOption);
        return this;
    };
    BrushController.prototype._doEnableBrush = function(brushOption) {
        var zr = this._zr;
        // Consider roam, which takes globalPan too.
        if (!this._enableGlobalPan) $befd6a34b30d3f54$export$b7df5d561049483a(zr, $91342d1cfa622c5a$var$MUTEX_RESOURCE_KEY, this._uid);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._handlers, function(handler, eventName) {
            zr.on(eventName, handler);
        });
        this._brushType = brushOption.brushType;
        this._brushOption = (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)((0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)($91342d1cfa622c5a$var$DEFAULT_BRUSH_OPT), brushOption, true);
    };
    BrushController.prototype._doDisableBrush = function() {
        var zr = this._zr;
        $befd6a34b30d3f54$export$23d3fad09dc44362(zr, $91342d1cfa622c5a$var$MUTEX_RESOURCE_KEY, this._uid);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._handlers, function(handler, eventName) {
            zr.off(eventName, handler);
        });
        this._brushType = this._brushOption = null;
    };
    /**
   * @param panelOpts If not pass, it is global brush.
   */ BrushController.prototype.setPanels = function(panelOpts) {
        if (panelOpts && panelOpts.length) {
            var panels_1 = this._panels = {};
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(panelOpts, function(panelOpts) {
                panels_1[panelOpts.panelId] = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(panelOpts);
            });
        } else this._panels = null;
        return this;
    };
    BrushController.prototype.mount = function(opt) {
        opt = opt || {};
        this._enableGlobalPan = opt.enableGlobalPan;
        var thisGroup = this.group;
        this._zr.add(thisGroup);
        thisGroup.attr({
            x: opt.x || 0,
            y: opt.y || 0,
            rotation: opt.rotation || 0,
            scaleX: opt.scaleX || 1,
            scaleY: opt.scaleY || 1
        });
        this._transform = thisGroup.getLocalTransform();
        return this;
    };
    // eachCover(cb, context): void {
    //     each(this._covers, cb, context);
    // }
    /**
   * Update covers.
   * @param coverConfigList
   *        If coverConfigList is null/undefined, all covers removed.
   */ BrushController.prototype.updateCovers = function(coverConfigList) {
        coverConfigList = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(coverConfigList, function(coverConfig) {
            return (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)((0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)($91342d1cfa622c5a$var$DEFAULT_BRUSH_OPT), coverConfig, true);
        });
        var tmpIdPrefix = '\0-brush-index-';
        var oldCovers = this._covers;
        var newCovers = this._covers = [];
        var controller = this;
        var creatingCover = this._creatingCover;
        new (0, $306d1c87baff8a10$export$2e2bcd8739ae039)(oldCovers, coverConfigList, oldGetKey, getKey).add(addOrUpdate).update(addOrUpdate).remove(remove).execute();
        return this;
        function getKey(brushOption, index) {
            return (brushOption.id != null ? brushOption.id : tmpIdPrefix + index) + '-' + brushOption.brushType;
        }
        function oldGetKey(cover, index) {
            return getKey(cover.__brushOption, index);
        }
        function addOrUpdate(newIndex, oldIndex) {
            var newBrushInternal = coverConfigList[newIndex];
            // Consider setOption in event listener of brushSelect,
            // where updating cover when creating should be forbidden.
            if (oldIndex != null && oldCovers[oldIndex] === creatingCover) newCovers[newIndex] = oldCovers[oldIndex];
            else {
                var cover = newCovers[newIndex] = oldIndex != null ? (oldCovers[oldIndex].__brushOption = newBrushInternal, oldCovers[oldIndex]) : $91342d1cfa622c5a$var$endCreating(controller, $91342d1cfa622c5a$var$createCover(controller, newBrushInternal));
                $91342d1cfa622c5a$var$updateCoverAfterCreation(controller, cover);
            }
        }
        function remove(oldIndex) {
            if (oldCovers[oldIndex] !== creatingCover) controller.group.remove(oldCovers[oldIndex]);
        }
    };
    BrushController.prototype.unmount = function() {
        this.enableBrush(false);
        // container may 'removeAll' outside.
        $91342d1cfa622c5a$var$clearCovers(this);
        this._zr.remove(this.group);
        return this;
    };
    BrushController.prototype.dispose = function() {
        this.unmount();
        this.off();
    };
    return BrushController;
}((0, $63441a86293f101f$export$2e2bcd8739ae039));
function $91342d1cfa622c5a$var$createCover(controller, brushOption) {
    var cover = $91342d1cfa622c5a$var$coverRenderers[brushOption.brushType].createCover(controller, brushOption);
    cover.__brushOption = brushOption;
    $91342d1cfa622c5a$var$updateZ(cover, brushOption);
    controller.group.add(cover);
    return cover;
}
function $91342d1cfa622c5a$var$endCreating(controller, creatingCover) {
    var coverRenderer = $91342d1cfa622c5a$var$getCoverRenderer(creatingCover);
    if (coverRenderer.endCreating) {
        coverRenderer.endCreating(controller, creatingCover);
        $91342d1cfa622c5a$var$updateZ(creatingCover, creatingCover.__brushOption);
    }
    return creatingCover;
}
function $91342d1cfa622c5a$var$updateCoverShape(controller, cover) {
    var brushOption = cover.__brushOption;
    $91342d1cfa622c5a$var$getCoverRenderer(cover).updateCoverShape(controller, cover, brushOption.range, brushOption);
}
function $91342d1cfa622c5a$var$updateZ(cover, brushOption) {
    var z = brushOption.z;
    z == null && (z = $91342d1cfa622c5a$var$COVER_Z);
    cover.traverse(function(el) {
        el.z = z;
        el.z2 = z; // Consider in given container.
    });
}
function $91342d1cfa622c5a$var$updateCoverAfterCreation(controller, cover) {
    $91342d1cfa622c5a$var$getCoverRenderer(cover).updateCommon(controller, cover);
    $91342d1cfa622c5a$var$updateCoverShape(controller, cover);
}
function $91342d1cfa622c5a$var$getCoverRenderer(cover) {
    return $91342d1cfa622c5a$var$coverRenderers[cover.__brushOption.brushType];
}
// return target panel or `true` (means global panel)
function $91342d1cfa622c5a$var$getPanelByPoint(controller, e, localCursorPoint) {
    var panels = controller._panels;
    if (!panels) return $91342d1cfa622c5a$var$BRUSH_PANEL_GLOBAL; // Global panel
    var panel;
    var transform = controller._transform;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(panels, function(pn) {
        pn.isTargetByCursor(e, localCursorPoint, transform) && (panel = pn);
    });
    return panel;
}
// Return a panel or true
function $91342d1cfa622c5a$var$getPanelByCover(controller, cover) {
    var panels = controller._panels;
    if (!panels) return $91342d1cfa622c5a$var$BRUSH_PANEL_GLOBAL; // Global panel
    var panelId = cover.__brushOption.panelId;
    // User may give cover without coord sys info,
    // which is then treated as global panel.
    return panelId != null ? panels[panelId] : $91342d1cfa622c5a$var$BRUSH_PANEL_GLOBAL;
}
function $91342d1cfa622c5a$var$clearCovers(controller) {
    var covers = controller._covers;
    var originalLength = covers.length;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(covers, function(cover) {
        controller.group.remove(cover);
    }, controller);
    covers.length = 0;
    return !!originalLength;
}
function $91342d1cfa622c5a$var$trigger(controller, opt) {
    var areas = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(controller._covers, function(cover) {
        var brushOption = cover.__brushOption;
        var range = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(brushOption.range);
        return {
            brushType: brushOption.brushType,
            panelId: brushOption.panelId,
            range: range
        };
    });
    controller.trigger('brush', {
        areas: areas,
        isEnd: !!opt.isEnd,
        removeOnClick: !!opt.removeOnClick
    });
}
function $91342d1cfa622c5a$var$shouldShowCover(controller) {
    var track = controller._track;
    if (!track.length) return false;
    var p2 = track[track.length - 1];
    var p1 = track[0];
    var dx = p2[0] - p1[0];
    var dy = p2[1] - p1[1];
    var dist = $91342d1cfa622c5a$var$mathPow(dx * dx + dy * dy, 0.5);
    return dist > $91342d1cfa622c5a$var$UNSELECT_THRESHOLD;
}
function $91342d1cfa622c5a$var$getTrackEnds(track) {
    var tail = track.length - 1;
    tail < 0 && (tail = 0);
    return [
        track[0],
        track[tail]
    ];
}
function $91342d1cfa622c5a$var$createBaseRectCover(rectRangeConverter, controller, brushOption, edgeNameSequences) {
    var cover = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
    cover.add(new $419e5ff2f303755e$export$2e2bcd8739ae039({
        name: 'main',
        style: $91342d1cfa622c5a$var$makeStyle(brushOption),
        silent: true,
        draggable: true,
        cursor: 'move',
        drift: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($91342d1cfa622c5a$var$driftRect, rectRangeConverter, controller, cover, [
            'n',
            's',
            'w',
            'e'
        ]),
        ondragend: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($91342d1cfa622c5a$var$trigger, controller, {
            isEnd: true
        })
    }));
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(edgeNameSequences, function(nameSequence) {
        cover.add(new $419e5ff2f303755e$export$2e2bcd8739ae039({
            name: nameSequence.join(''),
            style: {
                opacity: 0
            },
            draggable: true,
            silent: true,
            invisible: true,
            drift: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($91342d1cfa622c5a$var$driftRect, rectRangeConverter, controller, cover, nameSequence),
            ondragend: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($91342d1cfa622c5a$var$trigger, controller, {
                isEnd: true
            })
        }));
    });
    return cover;
}
function $91342d1cfa622c5a$var$updateBaseRect(controller, cover, localRange, brushOption) {
    var lineWidth = brushOption.brushStyle.lineWidth || 0;
    var handleSize = $91342d1cfa622c5a$var$mathMax(lineWidth, $91342d1cfa622c5a$var$MIN_RESIZE_LINE_WIDTH);
    var x = localRange[0][0];
    var y = localRange[1][0];
    var xa = x - lineWidth / 2;
    var ya = y - lineWidth / 2;
    var x2 = localRange[0][1];
    var y2 = localRange[1][1];
    var x2a = x2 - handleSize + lineWidth / 2;
    var y2a = y2 - handleSize + lineWidth / 2;
    var width = x2 - x;
    var height = y2 - y;
    var widtha = width + lineWidth;
    var heighta = height + lineWidth;
    $91342d1cfa622c5a$var$updateRectShape(controller, cover, 'main', x, y, width, height);
    if (brushOption.transformable) {
        $91342d1cfa622c5a$var$updateRectShape(controller, cover, 'w', xa, ya, handleSize, heighta);
        $91342d1cfa622c5a$var$updateRectShape(controller, cover, 'e', x2a, ya, handleSize, heighta);
        $91342d1cfa622c5a$var$updateRectShape(controller, cover, 'n', xa, ya, widtha, handleSize);
        $91342d1cfa622c5a$var$updateRectShape(controller, cover, 's', xa, y2a, widtha, handleSize);
        $91342d1cfa622c5a$var$updateRectShape(controller, cover, 'nw', xa, ya, handleSize, handleSize);
        $91342d1cfa622c5a$var$updateRectShape(controller, cover, 'ne', x2a, ya, handleSize, handleSize);
        $91342d1cfa622c5a$var$updateRectShape(controller, cover, 'sw', xa, y2a, handleSize, handleSize);
        $91342d1cfa622c5a$var$updateRectShape(controller, cover, 'se', x2a, y2a, handleSize, handleSize);
    }
}
function $91342d1cfa622c5a$var$updateCommon(controller, cover) {
    var brushOption = cover.__brushOption;
    var transformable = brushOption.transformable;
    var mainEl = cover.childAt(0);
    mainEl.useStyle($91342d1cfa622c5a$var$makeStyle(brushOption));
    mainEl.attr({
        silent: !transformable,
        cursor: transformable ? 'move' : 'default'
    });
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
        [
            'w'
        ],
        [
            'e'
        ],
        [
            'n'
        ],
        [
            's'
        ],
        [
            's',
            'e'
        ],
        [
            's',
            'w'
        ],
        [
            'n',
            'e'
        ],
        [
            'n',
            'w'
        ]
    ], function(nameSequence) {
        var el = cover.childOfName(nameSequence.join(''));
        var globalDir = nameSequence.length === 1 ? $91342d1cfa622c5a$var$getGlobalDirection1(controller, nameSequence[0]) : $91342d1cfa622c5a$var$getGlobalDirection2(controller, nameSequence);
        el && el.attr({
            silent: !transformable,
            invisible: !transformable,
            cursor: transformable ? $91342d1cfa622c5a$var$CURSOR_MAP[globalDir] + '-resize' : null
        });
    });
}
function $91342d1cfa622c5a$var$updateRectShape(controller, cover, name, x, y, w, h) {
    var el = cover.childOfName(name);
    el && el.setShape($91342d1cfa622c5a$var$pointsToRect($91342d1cfa622c5a$var$clipByPanel(controller, cover, [
        [
            x,
            y
        ],
        [
            x + w,
            y + h
        ]
    ])));
}
function $91342d1cfa622c5a$var$makeStyle(brushOption) {
    return (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
        strokeNoScale: true
    }, brushOption.brushStyle);
}
function $91342d1cfa622c5a$var$formatRectRange(x, y, x2, y2) {
    var min = [
        $91342d1cfa622c5a$var$mathMin(x, x2),
        $91342d1cfa622c5a$var$mathMin(y, y2)
    ];
    var max = [
        $91342d1cfa622c5a$var$mathMax(x, x2),
        $91342d1cfa622c5a$var$mathMax(y, y2)
    ];
    return [
        [
            min[0],
            max[0]
        ],
        [
            min[1],
            max[1]
        ] // y range
    ];
}
function $91342d1cfa622c5a$var$getTransform(controller) {
    return $5b455ae6f843ac47$export$fce0c6cfca85ed96(controller.group);
}
function $91342d1cfa622c5a$var$getGlobalDirection1(controller, localDirName) {
    var map = {
        w: 'left',
        e: 'right',
        n: 'top',
        s: 'bottom'
    };
    var inverseMap = {
        left: 'w',
        right: 'e',
        top: 'n',
        bottom: 's'
    };
    var dir = $5b455ae6f843ac47$export$fff94e9792354cfa(map[localDirName], $91342d1cfa622c5a$var$getTransform(controller));
    return inverseMap[dir];
}
function $91342d1cfa622c5a$var$getGlobalDirection2(controller, localDirNameSeq) {
    var globalDir = [
        $91342d1cfa622c5a$var$getGlobalDirection1(controller, localDirNameSeq[0]),
        $91342d1cfa622c5a$var$getGlobalDirection1(controller, localDirNameSeq[1])
    ];
    (globalDir[0] === 'e' || globalDir[0] === 'w') && globalDir.reverse();
    return globalDir.join('');
}
function $91342d1cfa622c5a$var$driftRect(rectRangeConverter, controller, cover, dirNameSequence, dx, dy) {
    var brushOption = cover.__brushOption;
    var rectRange = rectRangeConverter.toRectRange(brushOption.range);
    var localDelta = $91342d1cfa622c5a$var$toLocalDelta(controller, dx, dy);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dirNameSequence, function(dirName) {
        var ind = $91342d1cfa622c5a$var$DIRECTION_MAP[dirName];
        rectRange[ind[0]][ind[1]] += localDelta[ind[0]];
    });
    brushOption.range = rectRangeConverter.fromRectRange($91342d1cfa622c5a$var$formatRectRange(rectRange[0][0], rectRange[1][0], rectRange[0][1], rectRange[1][1]));
    $91342d1cfa622c5a$var$updateCoverAfterCreation(controller, cover);
    $91342d1cfa622c5a$var$trigger(controller, {
        isEnd: false
    });
}
function $91342d1cfa622c5a$var$driftPolygon(controller, cover, dx, dy) {
    var range = cover.__brushOption.range;
    var localDelta = $91342d1cfa622c5a$var$toLocalDelta(controller, dx, dy);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(range, function(point) {
        point[0] += localDelta[0];
        point[1] += localDelta[1];
    });
    $91342d1cfa622c5a$var$updateCoverAfterCreation(controller, cover);
    $91342d1cfa622c5a$var$trigger(controller, {
        isEnd: false
    });
}
function $91342d1cfa622c5a$var$toLocalDelta(controller, dx, dy) {
    var thisGroup = controller.group;
    var localD = thisGroup.transformCoordToLocal(dx, dy);
    var localZero = thisGroup.transformCoordToLocal(0, 0);
    return [
        localD[0] - localZero[0],
        localD[1] - localZero[1]
    ];
}
function $91342d1cfa622c5a$var$clipByPanel(controller, cover, data) {
    var panel = $91342d1cfa622c5a$var$getPanelByCover(controller, cover);
    return panel && panel !== $91342d1cfa622c5a$var$BRUSH_PANEL_GLOBAL ? panel.clipPath(data, controller._transform) : (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(data);
}
function $91342d1cfa622c5a$var$pointsToRect(points) {
    var xmin = $91342d1cfa622c5a$var$mathMin(points[0][0], points[1][0]);
    var ymin = $91342d1cfa622c5a$var$mathMin(points[0][1], points[1][1]);
    var xmax = $91342d1cfa622c5a$var$mathMax(points[0][0], points[1][0]);
    var ymax = $91342d1cfa622c5a$var$mathMax(points[0][1], points[1][1]);
    return {
        x: xmin,
        y: ymin,
        width: xmax - xmin,
        height: ymax - ymin
    };
}
function $91342d1cfa622c5a$var$resetCursor(controller, e, localCursorPoint) {
    if (// Check active
    !controller._brushType || $91342d1cfa622c5a$var$isOutsideZrArea(controller, e.offsetX, e.offsetY)) return;
    var zr = controller._zr;
    var covers = controller._covers;
    var currPanel = $91342d1cfa622c5a$var$getPanelByPoint(controller, e, localCursorPoint);
    // Check whether in covers.
    if (!controller._dragging) for(var i = 0; i < covers.length; i++){
        var brushOption = covers[i].__brushOption;
        if (currPanel && (currPanel === $91342d1cfa622c5a$var$BRUSH_PANEL_GLOBAL || brushOption.panelId === currPanel.panelId) && $91342d1cfa622c5a$var$coverRenderers[brushOption.brushType].contain(covers[i], localCursorPoint[0], localCursorPoint[1])) // Use cursor style set on cover.
        return;
    }
    currPanel && zr.setCursorStyle('crosshair');
}
function $91342d1cfa622c5a$var$preventDefault(e) {
    var rawE = e.event;
    rawE.preventDefault && rawE.preventDefault();
}
function $91342d1cfa622c5a$var$mainShapeContain(cover, x, y) {
    return cover.childOfName('main').contain(x, y);
}
function $91342d1cfa622c5a$var$updateCoverByMouse(controller, e, localCursorPoint, isEnd) {
    var creatingCover = controller._creatingCover;
    var panel = controller._creatingPanel;
    var thisBrushOption = controller._brushOption;
    var eventParams;
    controller._track.push(localCursorPoint.slice());
    if ($91342d1cfa622c5a$var$shouldShowCover(controller) || creatingCover) {
        if (panel && !creatingCover) {
            thisBrushOption.brushMode === 'single' && $91342d1cfa622c5a$var$clearCovers(controller);
            var brushOption = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(thisBrushOption);
            brushOption.brushType = $91342d1cfa622c5a$var$determineBrushType(brushOption.brushType, panel);
            brushOption.panelId = panel === $91342d1cfa622c5a$var$BRUSH_PANEL_GLOBAL ? null : panel.panelId;
            creatingCover = controller._creatingCover = $91342d1cfa622c5a$var$createCover(controller, brushOption);
            controller._covers.push(creatingCover);
        }
        if (creatingCover) {
            var coverRenderer = $91342d1cfa622c5a$var$coverRenderers[$91342d1cfa622c5a$var$determineBrushType(controller._brushType, panel)];
            var coverBrushOption = creatingCover.__brushOption;
            coverBrushOption.range = coverRenderer.getCreatingRange($91342d1cfa622c5a$var$clipByPanel(controller, creatingCover, controller._track));
            if (isEnd) {
                $91342d1cfa622c5a$var$endCreating(controller, creatingCover);
                coverRenderer.updateCommon(controller, creatingCover);
            }
            $91342d1cfa622c5a$var$updateCoverShape(controller, creatingCover);
            eventParams = {
                isEnd: isEnd
            };
        }
    } else if (isEnd && thisBrushOption.brushMode === 'single' && thisBrushOption.removeOnClick) // Help user to remove covers easily, only by a tiny drag, in 'single' mode.
    // But a single click do not clear covers, because user may have casual
    // clicks (for example, click on other component and do not expect covers
    // disappear).
    // Only some cover removed, trigger action, but not every click trigger action.
    {
        if ($91342d1cfa622c5a$var$getPanelByPoint(controller, e, localCursorPoint) && $91342d1cfa622c5a$var$clearCovers(controller)) eventParams = {
            isEnd: isEnd,
            removeOnClick: true
        };
    }
    return eventParams;
}
function $91342d1cfa622c5a$var$determineBrushType(brushType, panel) {
    if (brushType === 'auto') return panel.defaultBrushType;
    return brushType;
}
var $91342d1cfa622c5a$var$pointerHandlers = {
    mousedown: function(e) {
        if (this._dragging) // In case some browser do not support globalOut,
        // and release mouse out side the browser.
        $91342d1cfa622c5a$var$handleDragEnd(this, e);
        else if (!e.target || !e.target.draggable) {
            $91342d1cfa622c5a$var$preventDefault(e);
            var localCursorPoint = this.group.transformCoordToLocal(e.offsetX, e.offsetY);
            this._creatingCover = null;
            var panel = this._creatingPanel = $91342d1cfa622c5a$var$getPanelByPoint(this, e, localCursorPoint);
            if (panel) {
                this._dragging = true;
                this._track = [
                    localCursorPoint.slice()
                ];
            }
        }
    },
    mousemove: function(e) {
        var x = e.offsetX;
        var y = e.offsetY;
        var localCursorPoint = this.group.transformCoordToLocal(x, y);
        $91342d1cfa622c5a$var$resetCursor(this, e, localCursorPoint);
        if (this._dragging) {
            $91342d1cfa622c5a$var$preventDefault(e);
            var eventParams = $91342d1cfa622c5a$var$updateCoverByMouse(this, e, localCursorPoint, false);
            eventParams && $91342d1cfa622c5a$var$trigger(this, eventParams);
        }
    },
    mouseup: function(e) {
        $91342d1cfa622c5a$var$handleDragEnd(this, e);
    }
};
function $91342d1cfa622c5a$var$handleDragEnd(controller, e) {
    if (controller._dragging) {
        $91342d1cfa622c5a$var$preventDefault(e);
        var x = e.offsetX;
        var y = e.offsetY;
        var localCursorPoint = controller.group.transformCoordToLocal(x, y);
        var eventParams = $91342d1cfa622c5a$var$updateCoverByMouse(controller, e, localCursorPoint, true);
        controller._dragging = false;
        controller._track = [];
        controller._creatingCover = null;
        // trigger event should be at final, after procedure will be nested.
        eventParams && $91342d1cfa622c5a$var$trigger(controller, eventParams);
    }
}
function $91342d1cfa622c5a$var$isOutsideZrArea(controller, x, y) {
    var zr = controller._zr;
    return x < 0 || x > zr.getWidth() || y < 0 || y > zr.getHeight();
}
/**
 * key: brushType
 */ var $91342d1cfa622c5a$var$coverRenderers = {
    lineX: $91342d1cfa622c5a$var$getLineRenderer(0),
    lineY: $91342d1cfa622c5a$var$getLineRenderer(1),
    rect: {
        createCover: function(controller, brushOption) {
            function returnInput(range) {
                return range;
            }
            return $91342d1cfa622c5a$var$createBaseRectCover({
                toRectRange: returnInput,
                fromRectRange: returnInput
            }, controller, brushOption, [
                [
                    'w'
                ],
                [
                    'e'
                ],
                [
                    'n'
                ],
                [
                    's'
                ],
                [
                    's',
                    'e'
                ],
                [
                    's',
                    'w'
                ],
                [
                    'n',
                    'e'
                ],
                [
                    'n',
                    'w'
                ]
            ]);
        },
        getCreatingRange: function(localTrack) {
            var ends = $91342d1cfa622c5a$var$getTrackEnds(localTrack);
            return $91342d1cfa622c5a$var$formatRectRange(ends[1][0], ends[1][1], ends[0][0], ends[0][1]);
        },
        updateCoverShape: function(controller, cover, localRange, brushOption) {
            $91342d1cfa622c5a$var$updateBaseRect(controller, cover, localRange, brushOption);
        },
        updateCommon: $91342d1cfa622c5a$var$updateCommon,
        contain: $91342d1cfa622c5a$var$mainShapeContain
    },
    polygon: {
        createCover: function(controller, brushOption) {
            var cover = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
            // Do not use graphic.Polygon because graphic.Polyline do not close the
            // border of the shape when drawing, which is a better experience for user.
            cover.add(new $d28119f30e6bb670$export$2e2bcd8739ae039({
                name: 'main',
                style: $91342d1cfa622c5a$var$makeStyle(brushOption),
                silent: true
            }));
            return cover;
        },
        getCreatingRange: function(localTrack) {
            return localTrack;
        },
        endCreating: function(controller, cover) {
            cover.remove(cover.childAt(0));
            // Use graphic.Polygon close the shape.
            cover.add(new $51acf033123e1a30$export$2e2bcd8739ae039({
                name: 'main',
                draggable: true,
                drift: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($91342d1cfa622c5a$var$driftPolygon, controller, cover),
                ondragend: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($91342d1cfa622c5a$var$trigger, controller, {
                    isEnd: true
                })
            }));
        },
        updateCoverShape: function(controller, cover, localRange, brushOption) {
            cover.childAt(0).setShape({
                points: $91342d1cfa622c5a$var$clipByPanel(controller, cover, localRange)
            });
        },
        updateCommon: $91342d1cfa622c5a$var$updateCommon,
        contain: $91342d1cfa622c5a$var$mainShapeContain
    }
};
function $91342d1cfa622c5a$var$getLineRenderer(xyIndex) {
    return {
        createCover: function(controller, brushOption) {
            return $91342d1cfa622c5a$var$createBaseRectCover({
                toRectRange: function(range) {
                    var rectRange = [
                        range,
                        [
                            0,
                            100
                        ]
                    ];
                    xyIndex && rectRange.reverse();
                    return rectRange;
                },
                fromRectRange: function(rectRange) {
                    return rectRange[xyIndex];
                }
            }, controller, brushOption, [
                [
                    [
                        'w'
                    ],
                    [
                        'e'
                    ]
                ],
                [
                    [
                        'n'
                    ],
                    [
                        's'
                    ]
                ]
            ][xyIndex]);
        },
        getCreatingRange: function(localTrack) {
            var ends = $91342d1cfa622c5a$var$getTrackEnds(localTrack);
            var min = $91342d1cfa622c5a$var$mathMin(ends[0][xyIndex], ends[1][xyIndex]);
            var max = $91342d1cfa622c5a$var$mathMax(ends[0][xyIndex], ends[1][xyIndex]);
            return [
                min,
                max
            ];
        },
        updateCoverShape: function(controller, cover, localRange, brushOption) {
            var otherExtent;
            // If brushWidth not specified, fit the panel.
            var panel = $91342d1cfa622c5a$var$getPanelByCover(controller, cover);
            if (panel !== $91342d1cfa622c5a$var$BRUSH_PANEL_GLOBAL && panel.getLinearBrushOtherExtent) otherExtent = panel.getLinearBrushOtherExtent(xyIndex);
            else {
                var zr = controller._zr;
                otherExtent = [
                    0,
                    [
                        zr.getWidth(),
                        zr.getHeight()
                    ][1 - xyIndex]
                ];
            }
            var rectRange = [
                localRange,
                otherExtent
            ];
            xyIndex && rectRange.reverse();
            $91342d1cfa622c5a$var$updateBaseRect(controller, cover, rectRange, brushOption);
        },
        updateCommon: $91342d1cfa622c5a$var$updateCommon,
        contain: $91342d1cfa622c5a$var$mainShapeContain
    };
}
var $91342d1cfa622c5a$export$2e2bcd8739ae039 = $91342d1cfa622c5a$var$BrushController;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $d9c171f7dfe1f12f$export$fee17964a62a87a7(rect) {
    rect = $d9c171f7dfe1f12f$var$normalizeRect(rect);
    return function(localPoints) {
        return $5b455ae6f843ac47$export$e2f409471bbbc1dc(localPoints, rect);
    };
}
function $d9c171f7dfe1f12f$export$7280070e90fad7a0(rect, specifiedXYIndex) {
    rect = $d9c171f7dfe1f12f$var$normalizeRect(rect);
    return function(xyIndex) {
        var idx = specifiedXYIndex != null ? specifiedXYIndex : xyIndex;
        var brushWidth = idx ? rect.width : rect.height;
        var base = idx ? rect.x : rect.y;
        return [
            base,
            base + (brushWidth || 0)
        ];
    };
}
function $d9c171f7dfe1f12f$export$e63e66b3b18aa99f(rect, api, targetModel) {
    var boundingRect = $d9c171f7dfe1f12f$var$normalizeRect(rect);
    return function(e, localCursorPoint) {
        return boundingRect.contain(localCursorPoint[0], localCursorPoint[1]) && !(0, $bee256db41541054$export$8a33eacb690eac07)(e, api, targetModel);
    };
}
// Consider width/height is negative.
function $d9c171f7dfe1f12f$var$normalizeRect(rect) {
    return (0, $1bebe7106c895823$export$2e2bcd8739ae039).create(rect);
}




var $90a4a8a0234865c7$var$elementList = [
    'axisLine',
    'axisTickLabel',
    'axisName'
];
var $90a4a8a0234865c7$var$ParallelAxisView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ParallelAxisView, _super);
    function ParallelAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ParallelAxisView.type;
        return _this;
    }
    ParallelAxisView.prototype.init = function(ecModel, api) {
        _super.prototype.init.apply(this, arguments);
        (this._brushController = new (0, $91342d1cfa622c5a$export$2e2bcd8739ae039)(api.getZr())).on('brush', $7a1bd9c2710fea0d$export$2385a24977818dd0(this._onBrush, this));
    };
    ParallelAxisView.prototype.render = function(axisModel, ecModel, api, payload) {
        if ($90a4a8a0234865c7$var$fromAxisAreaSelect(axisModel, ecModel, payload)) return;
        this.axisModel = axisModel;
        this.api = api;
        this.group.removeAll();
        var oldAxisGroup = this._axisGroup;
        this._axisGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        this.group.add(this._axisGroup);
        if (!axisModel.get('show')) return;
        var coordSysModel = $90a4a8a0234865c7$var$getCoordSysModel(axisModel, ecModel);
        var coordSys = coordSysModel.coordinateSystem;
        var areaSelectStyle = axisModel.getAreaSelectStyle();
        var areaWidth = areaSelectStyle.width;
        var dim = axisModel.axis.dim;
        var axisLayout = coordSys.getAxisLayout(dim);
        var builderOpt = $7a1bd9c2710fea0d$export$8b58be045bf06082({
            strokeContainThreshold: areaWidth
        }, axisLayout);
        var axisBuilder = new (0, $dfe15f745e1c3c2b$export$2e2bcd8739ae039)(axisModel, builderOpt);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43($90a4a8a0234865c7$var$elementList, axisBuilder.add, axisBuilder);
        this._axisGroup.add(axisBuilder.getGroup());
        this._refreshBrushController(builderOpt, areaSelectStyle, axisModel, coordSysModel, areaWidth, api);
        $5b455ae6f843ac47$export$64fcab7860c216ae(oldAxisGroup, this._axisGroup, axisModel);
    };
    // /**
    //  * @override
    //  */
    // updateVisual(axisModel, ecModel, api, payload) {
    //     this._brushController && this._brushController
    //         .updateCovers(getCoverInfoList(axisModel));
    // }
    ParallelAxisView.prototype._refreshBrushController = function(builderOpt, areaSelectStyle, axisModel, coordSysModel, areaWidth, api) {
        // After filtering, axis may change, select area needs to be update.
        var extent = axisModel.axis.getExtent();
        var extentLen = extent[1] - extent[0];
        var extra = Math.min(30, Math.abs(extentLen) * 0.1); // Arbitrary value.
        // width/height might be negative, which will be
        // normalized in BoundingRect.
        var rect = $1bebe7106c895823$export$2e2bcd8739ae039.create({
            x: extent[0],
            y: -areaWidth / 2,
            width: extentLen,
            height: areaWidth
        });
        rect.x -= extra;
        rect.width += 2 * extra;
        this._brushController.mount({
            enableGlobalPan: true,
            rotation: builderOpt.rotation,
            x: builderOpt.position[0],
            y: builderOpt.position[1]
        }).setPanels([
            {
                panelId: 'pl',
                clipPath: $d9c171f7dfe1f12f$export$fee17964a62a87a7(rect),
                isTargetByCursor: $d9c171f7dfe1f12f$export$e63e66b3b18aa99f(rect, api, coordSysModel),
                getLinearBrushOtherExtent: $d9c171f7dfe1f12f$export$7280070e90fad7a0(rect, 0)
            }
        ]).enableBrush({
            brushType: 'lineX',
            brushStyle: areaSelectStyle,
            removeOnClick: true
        }).updateCovers($90a4a8a0234865c7$var$getCoverInfoList(axisModel));
    };
    ParallelAxisView.prototype._onBrush = function(eventParam) {
        var coverInfoList = eventParam.areas;
        // Do not cache these object, because the mey be changed.
        var axisModel = this.axisModel;
        var axis = axisModel.axis;
        var intervals = $7a1bd9c2710fea0d$export$871de8747c9eaa88(coverInfoList, function(coverInfo) {
            return [
                axis.coordToData(coverInfo.range[0], true),
                axis.coordToData(coverInfo.range[1], true)
            ];
        });
        // If realtime is true, action is not dispatched on drag end, because
        // the drag end emits the same params with the last drag move event,
        // and may have some delay when using touch pad.
        if (!axisModel.option.realtime === eventParam.isEnd || eventParam.removeOnClick) // jshint ignore:line
        this.api.dispatchAction({
            type: 'axisAreaSelect',
            parallelAxisId: axisModel.id,
            intervals: intervals
        });
    };
    ParallelAxisView.prototype.dispose = function() {
        this._brushController.dispose();
    };
    ParallelAxisView.type = 'parallelAxis';
    return ParallelAxisView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
function $90a4a8a0234865c7$var$fromAxisAreaSelect(axisModel, ecModel, payload) {
    return payload && payload.type === 'axisAreaSelect' && ecModel.findComponents({
        mainType: 'parallelAxis',
        query: payload
    })[0] === axisModel;
}
function $90a4a8a0234865c7$var$getCoverInfoList(axisModel) {
    var axis = axisModel.axis;
    return $7a1bd9c2710fea0d$export$871de8747c9eaa88(axisModel.activeIntervals, function(interval) {
        return {
            brushType: 'lineX',
            panelId: 'pl',
            range: [
                axis.dataToCoord(interval[0], true),
                axis.dataToCoord(interval[1], true)
            ]
        };
    });
}
function $90a4a8a0234865c7$var$getCoordSysModel(axisModel, ecModel) {
    return ecModel.getComponent('parallel', axisModel.get('parallelIndex'));
}
var $90a4a8a0234865c7$export$2e2bcd8739ae039 = $90a4a8a0234865c7$var$ParallelAxisView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $1c10e648a7cc8028$var$actionInfo = {
    type: 'axisAreaSelect',
    event: 'axisAreaSelected'
};
function $1c10e648a7cc8028$export$a97c1e0aa84f4f71(registers) {
    registers.registerAction($1c10e648a7cc8028$var$actionInfo, function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: 'parallelAxis',
            query: payload
        }, function(parallelAxisModel) {
            parallelAxisModel.axis.model.setActiveIntervals(payload.intervals);
        });
    });
    /**
   * @payload
   */ registers.registerAction('parallelAxisExpand', function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: 'parallel',
            query: payload
        }, function(parallelModel) {
            parallelModel.setAxisExpand(payload);
        });
    });
}


var $462857bad733a944$var$defaultAxisOption = {
    type: 'value',
    areaSelectStyle: {
        width: 20,
        borderWidth: 1,
        borderColor: 'rgba(160,197,232)',
        color: 'rgba(160,197,232)',
        opacity: 0.3
    },
    realtime: true,
    z: 10
};
function $462857bad733a944$export$4b3e715f166fdd78(registers) {
    registers.registerComponentView((0, $ccce4513d4baec6a$export$2e2bcd8739ae039));
    registers.registerComponentModel((0, $a14d8e1511adaa1e$export$2e2bcd8739ae039));
    registers.registerCoordinateSystem('parallel', (0, $88531590cdbcfc26$export$2e2bcd8739ae039));
    registers.registerPreprocessor((0, $30173db3404062fa$export$2e2bcd8739ae039));
    registers.registerComponentModel((0, $839a50fcb1c6f44b$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $90a4a8a0234865c7$export$2e2bcd8739ae039));
    (0, $c5c4c85259d60abe$export$2e2bcd8739ae039)(registers, 'parallel', (0, $839a50fcb1c6f44b$export$2e2bcd8739ae039), $462857bad733a944$var$defaultAxisOption);
    (0, $1c10e648a7cc8028$export$a97c1e0aa84f4f71)(registers);
}


function $4d1dc874f9d8653d$export$4b3e715f166fdd78(registers) {
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $462857bad733a944$export$4b3e715f166fdd78));
    registers.registerChartView((0, $9e57680b9c04f083$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $5d63691998e05817$export$2e2bcd8739ae039));
    registers.registerVisual(registers.PRIORITY.VISUAL.BRUSH, (0, $8148e21d655f67c8$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 











var $55a0f29f32f7b1c4$var$BAR_BORDER_WIDTH_QUERY = [
    'itemStyle',
    'borderWidth'
];
// index: +isHorizontal
var $55a0f29f32f7b1c4$var$LAYOUT_ATTRS = [
    {
        xy: 'x',
        wh: 'width',
        index: 0,
        posDesc: [
            'left',
            'right'
        ]
    },
    {
        xy: 'y',
        wh: 'height',
        index: 1,
        posDesc: [
            'top',
            'bottom'
        ]
    }
];
var $55a0f29f32f7b1c4$var$pathForLineWidth = new $5b455ae6f843ac47$exports.Circle();
var $55a0f29f32f7b1c4$var$PictorialBarView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(PictorialBarView, _super);
    function PictorialBarView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = PictorialBarView.type;
        return _this;
    }
    PictorialBarView.prototype.render = function(seriesModel, ecModel, api) {
        var group = this.group;
        var data = seriesModel.getData();
        var oldData = this._data;
        var cartesian = seriesModel.coordinateSystem;
        var baseAxis = cartesian.getBaseAxis();
        var isHorizontal = baseAxis.isHorizontal();
        var coordSysRect = cartesian.master.getRect();
        var opt = {
            ecSize: {
                width: api.getWidth(),
                height: api.getHeight()
            },
            seriesModel: seriesModel,
            coordSys: cartesian,
            coordSysExtent: [
                [
                    coordSysRect.x,
                    coordSysRect.x + coordSysRect.width
                ],
                [
                    coordSysRect.y,
                    coordSysRect.y + coordSysRect.height
                ]
            ],
            isHorizontal: isHorizontal,
            valueDim: $55a0f29f32f7b1c4$var$LAYOUT_ATTRS[+isHorizontal],
            categoryDim: $55a0f29f32f7b1c4$var$LAYOUT_ATTRS[1 - +isHorizontal]
        };
        data.diff(oldData).add(function(dataIndex) {
            if (!data.hasValue(dataIndex)) return;
            var itemModel = $55a0f29f32f7b1c4$var$getItemModel(data, dataIndex);
            var symbolMeta = $55a0f29f32f7b1c4$var$getSymbolMeta(data, dataIndex, itemModel, opt);
            var bar = $55a0f29f32f7b1c4$var$createBar(data, opt, symbolMeta);
            data.setItemGraphicEl(dataIndex, bar);
            group.add(bar);
            $55a0f29f32f7b1c4$var$updateCommon(bar, opt, symbolMeta);
        }).update(function(newIndex, oldIndex) {
            var bar = oldData.getItemGraphicEl(oldIndex);
            if (!data.hasValue(newIndex)) {
                group.remove(bar);
                return;
            }
            var itemModel = $55a0f29f32f7b1c4$var$getItemModel(data, newIndex);
            var symbolMeta = $55a0f29f32f7b1c4$var$getSymbolMeta(data, newIndex, itemModel, opt);
            var pictorialShapeStr = $55a0f29f32f7b1c4$var$getShapeStr(data, symbolMeta);
            if (bar && pictorialShapeStr !== bar.__pictorialShapeStr) {
                group.remove(bar);
                data.setItemGraphicEl(newIndex, null);
                bar = null;
            }
            if (bar) $55a0f29f32f7b1c4$var$updateBar(bar, opt, symbolMeta);
            else bar = $55a0f29f32f7b1c4$var$createBar(data, opt, symbolMeta, true);
            data.setItemGraphicEl(newIndex, bar);
            bar.__pictorialSymbolMeta = symbolMeta;
            // Add back
            group.add(bar);
            $55a0f29f32f7b1c4$var$updateCommon(bar, opt, symbolMeta);
        }).remove(function(dataIndex) {
            var bar = oldData.getItemGraphicEl(dataIndex);
            bar && $55a0f29f32f7b1c4$var$removeBar(oldData, dataIndex, bar.__pictorialSymbolMeta.animationModel, bar);
        }).execute();
        // Do clipping
        var clipPath = seriesModel.get('clip', true) ? (0, $0e2cc04b3aaad400$export$e0fe5081209d01c9)(seriesModel.coordinateSystem, false, seriesModel) : null;
        if (clipPath) group.setClipPath(clipPath);
        else group.removeClipPath();
        this._data = data;
        return this.group;
    };
    PictorialBarView.prototype.remove = function(ecModel, api) {
        var group = this.group;
        var data = this._data;
        if (ecModel.get('animation')) {
            if (data) data.eachItemGraphicEl(function(bar) {
                $55a0f29f32f7b1c4$var$removeBar(data, (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(bar).dataIndex, ecModel, bar);
            });
        } else group.removeAll();
    };
    PictorialBarView.type = 'pictorialBar';
    return PictorialBarView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
// Set or calculate default value about symbol, and calculate layout info.
function $55a0f29f32f7b1c4$var$getSymbolMeta(data, dataIndex, itemModel, opt) {
    var layout = data.getItemLayout(dataIndex);
    var symbolRepeat = itemModel.get('symbolRepeat');
    var symbolClip = itemModel.get('symbolClip');
    var symbolPosition = itemModel.get('symbolPosition') || 'start';
    var symbolRotate = itemModel.get('symbolRotate');
    var rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
    var symbolPatternSize = itemModel.get('symbolPatternSize') || 2;
    var isAnimationEnabled = itemModel.isAnimationEnabled();
    var symbolMeta = {
        dataIndex: dataIndex,
        layout: layout,
        itemModel: itemModel,
        symbolType: data.getItemVisual(dataIndex, 'symbol') || 'circle',
        style: data.getItemVisual(dataIndex, 'style'),
        symbolClip: symbolClip,
        symbolRepeat: symbolRepeat,
        symbolRepeatDirection: itemModel.get('symbolRepeatDirection'),
        symbolPatternSize: symbolPatternSize,
        rotation: rotation,
        animationModel: isAnimationEnabled ? itemModel : null,
        hoverScale: isAnimationEnabled && itemModel.get([
            'emphasis',
            'scale'
        ]),
        z2: itemModel.getShallow('z', true) || 0
    };
    $55a0f29f32f7b1c4$var$prepareBarLength(itemModel, symbolRepeat, layout, opt, symbolMeta);
    $55a0f29f32f7b1c4$var$prepareSymbolSize(data, dataIndex, layout, symbolRepeat, symbolClip, symbolMeta.boundingLength, symbolMeta.pxSign, symbolPatternSize, opt, symbolMeta);
    $55a0f29f32f7b1c4$var$prepareLineWidth(itemModel, symbolMeta.symbolScale, rotation, opt, symbolMeta);
    var symbolSize = symbolMeta.symbolSize;
    var symbolOffset = (0, $5370466dadc978d7$export$e3e292895c033f6d)(itemModel.get('symbolOffset'), symbolSize);
    $55a0f29f32f7b1c4$var$prepareLayoutInfo(itemModel, symbolSize, layout, symbolRepeat, symbolClip, symbolOffset, symbolPosition, symbolMeta.valueLineWidth, symbolMeta.boundingLength, symbolMeta.repeatCutLength, opt, symbolMeta);
    return symbolMeta;
}
// bar length can be negative.
function $55a0f29f32f7b1c4$var$prepareBarLength(itemModel, symbolRepeat, layout, opt, outputSymbolMeta) {
    var valueDim = opt.valueDim;
    var symbolBoundingData = itemModel.get('symbolBoundingData');
    var valueAxis = opt.coordSys.getOtherAxis(opt.coordSys.getBaseAxis());
    var zeroPx = valueAxis.toGlobalCoord(valueAxis.dataToCoord(0));
    var pxSignIdx = 1 - +(layout[valueDim.wh] <= 0);
    var boundingLength;
    if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(symbolBoundingData)) {
        var symbolBoundingExtent = [
            $55a0f29f32f7b1c4$var$convertToCoordOnAxis(valueAxis, symbolBoundingData[0]) - zeroPx,
            $55a0f29f32f7b1c4$var$convertToCoordOnAxis(valueAxis, symbolBoundingData[1]) - zeroPx
        ];
        symbolBoundingExtent[1] < symbolBoundingExtent[0] && symbolBoundingExtent.reverse();
        boundingLength = symbolBoundingExtent[pxSignIdx];
    } else if (symbolBoundingData != null) boundingLength = $55a0f29f32f7b1c4$var$convertToCoordOnAxis(valueAxis, symbolBoundingData) - zeroPx;
    else if (symbolRepeat) boundingLength = opt.coordSysExtent[valueDim.index][pxSignIdx] - zeroPx;
    else boundingLength = layout[valueDim.wh];
    outputSymbolMeta.boundingLength = boundingLength;
    if (symbolRepeat) outputSymbolMeta.repeatCutLength = layout[valueDim.wh];
    // if 'pxSign' means sign of pixel,  it can't be zero, or symbolScale will be zero
    // and when borderWidth be settled, the actual linewidth will be NaN
    var isXAxis = valueDim.xy === 'x';
    var isInverse = valueAxis.inverse;
    outputSymbolMeta.pxSign = isXAxis && !isInverse || !isXAxis && isInverse ? boundingLength >= 0 ? 1 : -1 : boundingLength > 0 ? 1 : -1;
}
function $55a0f29f32f7b1c4$var$convertToCoordOnAxis(axis, value) {
    return axis.toGlobalCoord(axis.dataToCoord(axis.scale.parse(value)));
}
// Support ['100%', '100%']
function $55a0f29f32f7b1c4$var$prepareSymbolSize(data, dataIndex, layout, symbolRepeat, symbolClip, boundingLength, pxSign, symbolPatternSize, opt, outputSymbolMeta) {
    var valueDim = opt.valueDim;
    var categoryDim = opt.categoryDim;
    var categorySize = Math.abs(layout[categoryDim.wh]);
    var symbolSize = data.getItemVisual(dataIndex, 'symbolSize');
    var parsedSymbolSize;
    if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(symbolSize)) parsedSymbolSize = symbolSize.slice();
    else if (symbolSize == null) // will parse to number below
    parsedSymbolSize = [
        '100%',
        '100%'
    ];
    else parsedSymbolSize = [
        symbolSize,
        symbolSize
    ];
    // Note: percentage symbolSize (like '100%') do not consider lineWidth, because it is
    // to complicated to calculate real percent value if considering scaled lineWidth.
    // So the actual size will bigger than layout size if lineWidth is bigger than zero,
    // which can be tolerated in pictorial chart.
    parsedSymbolSize[categoryDim.index] = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(parsedSymbolSize[categoryDim.index], categorySize);
    parsedSymbolSize[valueDim.index] = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(parsedSymbolSize[valueDim.index], symbolRepeat ? categorySize : Math.abs(boundingLength));
    outputSymbolMeta.symbolSize = parsedSymbolSize;
    // If x or y is less than zero, show reversed shape.
    var symbolScale = outputSymbolMeta.symbolScale = [
        parsedSymbolSize[0] / symbolPatternSize,
        parsedSymbolSize[1] / symbolPatternSize
    ];
    // Follow convention, 'right' and 'top' is the normal scale.
    symbolScale[valueDim.index] *= (opt.isHorizontal ? -1 : 1) * pxSign;
}
function $55a0f29f32f7b1c4$var$prepareLineWidth(itemModel, symbolScale, rotation, opt, outputSymbolMeta) {
    // In symbols are drawn with scale, so do not need to care about the case that width
    // or height are too small. But symbol use strokeNoScale, where acture lineWidth should
    // be calculated.
    var valueLineWidth = itemModel.get($55a0f29f32f7b1c4$var$BAR_BORDER_WIDTH_QUERY) || 0;
    if (valueLineWidth) {
        $55a0f29f32f7b1c4$var$pathForLineWidth.attr({
            scaleX: symbolScale[0],
            scaleY: symbolScale[1],
            rotation: rotation
        });
        $55a0f29f32f7b1c4$var$pathForLineWidth.updateTransform();
        valueLineWidth /= $55a0f29f32f7b1c4$var$pathForLineWidth.getLineScale();
        valueLineWidth *= symbolScale[opt.valueDim.index];
    }
    outputSymbolMeta.valueLineWidth = valueLineWidth || 0;
}
function $55a0f29f32f7b1c4$var$prepareLayoutInfo(itemModel, symbolSize, layout, symbolRepeat, symbolClip, symbolOffset, symbolPosition, valueLineWidth, boundingLength, repeatCutLength, opt, outputSymbolMeta) {
    var categoryDim = opt.categoryDim;
    var valueDim = opt.valueDim;
    var pxSign = outputSymbolMeta.pxSign;
    var unitLength = Math.max(symbolSize[valueDim.index] + valueLineWidth, 0);
    var pathLen = unitLength;
    // Note: rotation will not effect the layout of symbols, because user may
    // want symbols to rotate on its center, which should not be translated
    // when rotating.
    if (symbolRepeat) {
        var absBoundingLength = Math.abs(boundingLength);
        var symbolMargin = $7a1bd9c2710fea0d$export$8a4d17b6e8486e66(itemModel.get('symbolMargin'), '15%') + '';
        var hasEndGap = false;
        if (symbolMargin.lastIndexOf('!') === symbolMargin.length - 1) {
            hasEndGap = true;
            symbolMargin = symbolMargin.slice(0, symbolMargin.length - 1);
        }
        var symbolMarginNumeric = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(symbolMargin, symbolSize[valueDim.index]);
        var uLenWithMargin = Math.max(unitLength + symbolMarginNumeric * 2, 0);
        // When symbol margin is less than 0, margin at both ends will be subtracted
        // to ensure that all of the symbols will not be overflow the given area.
        var endFix = hasEndGap ? 0 : symbolMarginNumeric * 2;
        // Both final repeatTimes and final symbolMarginNumeric area calculated based on
        // boundingLength.
        var repeatSpecified = (0, $cfc1f3b422a3185f$export$e90fb89750dba83f)(symbolRepeat);
        var repeatTimes = repeatSpecified ? symbolRepeat : $55a0f29f32f7b1c4$var$toIntTimes((absBoundingLength + endFix) / uLenWithMargin);
        // Adjust calculate margin, to ensure each symbol is displayed
        // entirely in the given layout area.
        var mDiff = absBoundingLength - repeatTimes * unitLength;
        symbolMarginNumeric = mDiff / 2 / (hasEndGap ? repeatTimes : Math.max(repeatTimes - 1, 1));
        uLenWithMargin = unitLength + symbolMarginNumeric * 2;
        endFix = hasEndGap ? 0 : symbolMarginNumeric * 2;
        // Update repeatTimes when not all symbol will be shown.
        if (!repeatSpecified && symbolRepeat !== 'fixed') repeatTimes = repeatCutLength ? $55a0f29f32f7b1c4$var$toIntTimes((Math.abs(repeatCutLength) + endFix) / uLenWithMargin) : 0;
        pathLen = repeatTimes * uLenWithMargin - endFix;
        outputSymbolMeta.repeatTimes = repeatTimes;
        outputSymbolMeta.symbolMargin = symbolMarginNumeric;
    }
    var sizeFix = pxSign * (pathLen / 2);
    var pathPosition = outputSymbolMeta.pathPosition = [];
    pathPosition[categoryDim.index] = layout[categoryDim.wh] / 2;
    pathPosition[valueDim.index] = symbolPosition === 'start' ? sizeFix : symbolPosition === 'end' ? boundingLength - sizeFix : boundingLength / 2; // 'center'
    if (symbolOffset) {
        pathPosition[0] += symbolOffset[0];
        pathPosition[1] += symbolOffset[1];
    }
    var bundlePosition = outputSymbolMeta.bundlePosition = [];
    bundlePosition[categoryDim.index] = layout[categoryDim.xy];
    bundlePosition[valueDim.index] = layout[valueDim.xy];
    var barRectShape = outputSymbolMeta.barRectShape = $7a1bd9c2710fea0d$export$8b58be045bf06082({}, layout);
    barRectShape[valueDim.wh] = pxSign * Math.max(Math.abs(layout[valueDim.wh]), Math.abs(pathPosition[valueDim.index] + sizeFix));
    barRectShape[categoryDim.wh] = layout[categoryDim.wh];
    var clipShape = outputSymbolMeta.clipShape = {};
    // Consider that symbol may be overflow layout rect.
    clipShape[categoryDim.xy] = -layout[categoryDim.xy];
    clipShape[categoryDim.wh] = opt.ecSize[categoryDim.wh];
    clipShape[valueDim.xy] = 0;
    clipShape[valueDim.wh] = layout[valueDim.wh];
}
function $55a0f29f32f7b1c4$var$createPath(symbolMeta) {
    var symbolPatternSize = symbolMeta.symbolPatternSize;
    var path = (0, $5370466dadc978d7$export$af050e04da3a02e8)(// Consider texture img, make a big size.
    symbolMeta.symbolType, -symbolPatternSize / 2, -symbolPatternSize / 2, symbolPatternSize, symbolPatternSize);
    path.attr({
        culling: true
    });
    path.type !== 'image' && path.setStyle({
        strokeNoScale: true
    });
    return path;
}
function $55a0f29f32f7b1c4$var$createOrUpdateRepeatSymbols(bar, opt, symbolMeta, isUpdate) {
    var bundle = bar.__pictorialBundle;
    var symbolSize = symbolMeta.symbolSize;
    var valueLineWidth = symbolMeta.valueLineWidth;
    var pathPosition = symbolMeta.pathPosition;
    var valueDim = opt.valueDim;
    var repeatTimes = symbolMeta.repeatTimes || 0;
    var index = 0;
    var unit = symbolSize[opt.valueDim.index] + valueLineWidth + symbolMeta.symbolMargin * 2;
    $55a0f29f32f7b1c4$var$eachPath(bar, function(path) {
        path.__pictorialAnimationIndex = index;
        path.__pictorialRepeatTimes = repeatTimes;
        if (index < repeatTimes) $55a0f29f32f7b1c4$var$updateAttr(path, null, makeTarget(index), symbolMeta, isUpdate);
        else $55a0f29f32f7b1c4$var$updateAttr(path, null, {
            scaleX: 0,
            scaleY: 0
        }, symbolMeta, isUpdate, function() {
            bundle.remove(path);
        });
        // updateHoverAnimation(path, symbolMeta);
        index++;
    });
    for(; index < repeatTimes; index++){
        var path = $55a0f29f32f7b1c4$var$createPath(symbolMeta);
        path.__pictorialAnimationIndex = index;
        path.__pictorialRepeatTimes = repeatTimes;
        bundle.add(path);
        var target = makeTarget(index);
        $55a0f29f32f7b1c4$var$updateAttr(path, {
            x: target.x,
            y: target.y,
            scaleX: 0,
            scaleY: 0
        }, {
            scaleX: target.scaleX,
            scaleY: target.scaleY,
            rotation: target.rotation
        }, symbolMeta, isUpdate);
    }
    function makeTarget(index) {
        var position = pathPosition.slice();
        // (start && pxSign > 0) || (end && pxSign < 0): i = repeatTimes - index
        // Otherwise: i = index;
        var pxSign = symbolMeta.pxSign;
        var i = index;
        if (symbolMeta.symbolRepeatDirection === 'start' ? pxSign > 0 : pxSign < 0) i = repeatTimes - 1 - index;
        position[valueDim.index] = unit * (i - repeatTimes / 2 + 0.5) + pathPosition[valueDim.index];
        return {
            x: position[0],
            y: position[1],
            scaleX: symbolMeta.symbolScale[0],
            scaleY: symbolMeta.symbolScale[1],
            rotation: symbolMeta.rotation
        };
    }
}
function $55a0f29f32f7b1c4$var$createOrUpdateSingleSymbol(bar, opt, symbolMeta, isUpdate) {
    var bundle = bar.__pictorialBundle;
    var mainPath = bar.__pictorialMainPath;
    if (!mainPath) {
        mainPath = bar.__pictorialMainPath = $55a0f29f32f7b1c4$var$createPath(symbolMeta);
        bundle.add(mainPath);
        $55a0f29f32f7b1c4$var$updateAttr(mainPath, {
            x: symbolMeta.pathPosition[0],
            y: symbolMeta.pathPosition[1],
            scaleX: 0,
            scaleY: 0,
            rotation: symbolMeta.rotation
        }, {
            scaleX: symbolMeta.symbolScale[0],
            scaleY: symbolMeta.symbolScale[1]
        }, symbolMeta, isUpdate);
    } else $55a0f29f32f7b1c4$var$updateAttr(mainPath, null, {
        x: symbolMeta.pathPosition[0],
        y: symbolMeta.pathPosition[1],
        scaleX: symbolMeta.symbolScale[0],
        scaleY: symbolMeta.symbolScale[1],
        rotation: symbolMeta.rotation
    }, symbolMeta, isUpdate);
}
// bar rect is used for label.
function $55a0f29f32f7b1c4$var$createOrUpdateBarRect(bar, symbolMeta, isUpdate) {
    var rectShape = $7a1bd9c2710fea0d$export$8b58be045bf06082({}, symbolMeta.barRectShape);
    var barRect = bar.__pictorialBarRect;
    if (!barRect) {
        barRect = bar.__pictorialBarRect = new $5b455ae6f843ac47$exports.Rect({
            z2: 2,
            shape: rectShape,
            silent: true,
            style: {
                stroke: 'transparent',
                fill: 'transparent',
                lineWidth: 0
            }
        });
        barRect.disableMorphing = true;
        bar.add(barRect);
    } else $55a0f29f32f7b1c4$var$updateAttr(barRect, null, {
        shape: rectShape
    }, symbolMeta, isUpdate);
}
function $55a0f29f32f7b1c4$var$createOrUpdateClip(bar, opt, symbolMeta, isUpdate) {
    // If not clip, symbol will be remove and rebuilt.
    if (symbolMeta.symbolClip) {
        var clipPath = bar.__pictorialClipPath;
        var clipShape = $7a1bd9c2710fea0d$export$8b58be045bf06082({}, symbolMeta.clipShape);
        var valueDim = opt.valueDim;
        var animationModel = symbolMeta.animationModel;
        var dataIndex = symbolMeta.dataIndex;
        if (clipPath) $5b455ae6f843ac47$exports.updateProps(clipPath, {
            shape: clipShape
        }, animationModel, dataIndex);
        else {
            clipShape[valueDim.wh] = 0;
            clipPath = new $5b455ae6f843ac47$exports.Rect({
                shape: clipShape
            });
            bar.__pictorialBundle.setClipPath(clipPath);
            bar.__pictorialClipPath = clipPath;
            var target = {};
            target[valueDim.wh] = symbolMeta.clipShape[valueDim.wh];
            $5b455ae6f843ac47$exports[isUpdate ? 'updateProps' : 'initProps'](clipPath, {
                shape: target
            }, animationModel, dataIndex);
        }
    }
}
function $55a0f29f32f7b1c4$var$getItemModel(data, dataIndex) {
    var itemModel = data.getItemModel(dataIndex);
    itemModel.getAnimationDelayParams = $55a0f29f32f7b1c4$var$getAnimationDelayParams;
    itemModel.isAnimationEnabled = $55a0f29f32f7b1c4$var$isAnimationEnabled;
    return itemModel;
}
function $55a0f29f32f7b1c4$var$getAnimationDelayParams(path) {
    // The order is the same as the z-order, see `symbolRepeatDiretion`.
    return {
        index: path.__pictorialAnimationIndex,
        count: path.__pictorialRepeatTimes
    };
}
function $55a0f29f32f7b1c4$var$isAnimationEnabled() {
    // `animation` prop can be set on itemModel in pictorial bar chart.
    return this.parentModel.isAnimationEnabled() && !!this.getShallow('animation');
}
function $55a0f29f32f7b1c4$var$createBar(data, opt, symbolMeta, isUpdate) {
    // bar is the main element for each data.
    var bar = new $5b455ae6f843ac47$exports.Group();
    // bundle is used for location and clip.
    var bundle = new $5b455ae6f843ac47$exports.Group();
    bar.add(bundle);
    bar.__pictorialBundle = bundle;
    bundle.x = symbolMeta.bundlePosition[0];
    bundle.y = symbolMeta.bundlePosition[1];
    if (symbolMeta.symbolRepeat) $55a0f29f32f7b1c4$var$createOrUpdateRepeatSymbols(bar, opt, symbolMeta);
    else $55a0f29f32f7b1c4$var$createOrUpdateSingleSymbol(bar, opt, symbolMeta);
    $55a0f29f32f7b1c4$var$createOrUpdateBarRect(bar, symbolMeta, isUpdate);
    $55a0f29f32f7b1c4$var$createOrUpdateClip(bar, opt, symbolMeta, isUpdate);
    bar.__pictorialShapeStr = $55a0f29f32f7b1c4$var$getShapeStr(data, symbolMeta);
    bar.__pictorialSymbolMeta = symbolMeta;
    return bar;
}
function $55a0f29f32f7b1c4$var$updateBar(bar, opt, symbolMeta) {
    var animationModel = symbolMeta.animationModel;
    var dataIndex = symbolMeta.dataIndex;
    var bundle = bar.__pictorialBundle;
    $5b455ae6f843ac47$exports.updateProps(bundle, {
        x: symbolMeta.bundlePosition[0],
        y: symbolMeta.bundlePosition[1]
    }, animationModel, dataIndex);
    if (symbolMeta.symbolRepeat) $55a0f29f32f7b1c4$var$createOrUpdateRepeatSymbols(bar, opt, symbolMeta, true);
    else $55a0f29f32f7b1c4$var$createOrUpdateSingleSymbol(bar, opt, symbolMeta, true);
    $55a0f29f32f7b1c4$var$createOrUpdateBarRect(bar, symbolMeta, true);
    $55a0f29f32f7b1c4$var$createOrUpdateClip(bar, opt, symbolMeta, true);
}
function $55a0f29f32f7b1c4$var$removeBar(data, dataIndex, animationModel, bar) {
    // Not show text when animating
    var labelRect = bar.__pictorialBarRect;
    labelRect && labelRect.removeTextContent();
    var paths = [];
    $55a0f29f32f7b1c4$var$eachPath(bar, function(path) {
        paths.push(path);
    });
    bar.__pictorialMainPath && paths.push(bar.__pictorialMainPath);
    // I do not find proper remove animation for clip yet.
    bar.__pictorialClipPath && (animationModel = null);
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(paths, function(path) {
        $5b455ae6f843ac47$exports.removeElement(path, {
            scaleX: 0,
            scaleY: 0
        }, animationModel, dataIndex, function() {
            bar.parent && bar.parent.remove(bar);
        });
    });
    data.setItemGraphicEl(dataIndex, null);
}
function $55a0f29f32f7b1c4$var$getShapeStr(data, symbolMeta) {
    return [
        data.getItemVisual(symbolMeta.dataIndex, 'symbol') || 'none',
        !!symbolMeta.symbolRepeat,
        !!symbolMeta.symbolClip
    ].join(':');
}
function $55a0f29f32f7b1c4$var$eachPath(bar, cb, context) {
    // Do not use Group#eachChild, because it do not support remove.
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(bar.__pictorialBundle.children(), function(el) {
        el !== bar.__pictorialBarRect && cb.call(context, el);
    });
}
function $55a0f29f32f7b1c4$var$updateAttr(el, immediateAttrs, animationAttrs, symbolMeta, isUpdate, cb) {
    immediateAttrs && el.attr(immediateAttrs);
    // when symbolCip used, only clip path has init animation, otherwise it would be weird effect.
    if (symbolMeta.symbolClip && !isUpdate) animationAttrs && el.attr(animationAttrs);
    else animationAttrs && $5b455ae6f843ac47$exports[isUpdate ? 'updateProps' : 'initProps'](el, animationAttrs, symbolMeta.animationModel, symbolMeta.dataIndex, cb);
}
function $55a0f29f32f7b1c4$var$updateCommon(bar, opt, symbolMeta) {
    var dataIndex = symbolMeta.dataIndex;
    var itemModel = symbolMeta.itemModel;
    // Color must be excluded.
    // Because symbol provide setColor individually to set fill and stroke
    var emphasisModel = itemModel.getModel('emphasis');
    var emphasisStyle = emphasisModel.getModel('itemStyle').getItemStyle();
    var blurStyle = itemModel.getModel([
        'blur',
        'itemStyle'
    ]).getItemStyle();
    var selectStyle = itemModel.getModel([
        'select',
        'itemStyle'
    ]).getItemStyle();
    var cursorStyle = itemModel.getShallow('cursor');
    var focus = emphasisModel.get('focus');
    var blurScope = emphasisModel.get('blurScope');
    var hoverScale = emphasisModel.get('scale');
    $55a0f29f32f7b1c4$var$eachPath(bar, function(path) {
        if (path instanceof (0, $86adec94217b86c6$export$2e2bcd8739ae039)) {
            var pathStyle = path.style;
            path.useStyle($7a1bd9c2710fea0d$export$8b58be045bf06082({
                // TODO other properties like dx, dy ?
                image: pathStyle.image,
                x: pathStyle.x,
                y: pathStyle.y,
                width: pathStyle.width,
                height: pathStyle.height
            }, symbolMeta.style));
        } else path.useStyle(symbolMeta.style);
        var emphasisState = path.ensureState('emphasis');
        emphasisState.style = emphasisStyle;
        if (hoverScale) {
            // NOTE: Must after scale is set after updateAttr
            emphasisState.scaleX = path.scaleX * 1.1;
            emphasisState.scaleY = path.scaleY * 1.1;
        }
        path.ensureState('blur').style = blurStyle;
        path.ensureState('select').style = selectStyle;
        cursorStyle && (path.cursor = cursorStyle);
        path.z2 = symbolMeta.z2;
    });
    var barPositionOutside = opt.valueDim.posDesc[+(symbolMeta.boundingLength > 0)];
    var barRect = bar.__pictorialBarRect;
    barRect.ignoreClip = true;
    (0, $6800dfcb6e1e2a44$export$9a13992917966657)(barRect, (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(itemModel), {
        labelFetcher: opt.seriesModel,
        labelDataIndex: dataIndex,
        defaultText: (0, $b2475f850d3c0bc2$export$5ff20667590927ed)(opt.seriesModel.getData(), dataIndex),
        inheritColor: symbolMeta.style.fill,
        defaultOpacity: symbolMeta.style.opacity,
        defaultOutsidePosition: barPositionOutside
    });
    (0, $2bf82c0980125b62$export$e51187539ff11209)(bar, focus, blurScope, emphasisModel.get('disabled'));
}
function $55a0f29f32f7b1c4$var$toIntTimes(times) {
    var roundedTimes = Math.round(times);
    // Escapse accurate error
    return Math.abs(times - roundedTimes) < 1e-4 ? roundedTimes : Math.ceil(times);
}
var $55a0f29f32f7b1c4$export$2e2bcd8739ae039 = $55a0f29f32f7b1c4$var$PictorialBarView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $eb46f662d47de4a6$var$PictorialBarSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(PictorialBarSeriesModel, _super);
    function PictorialBarSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = PictorialBarSeriesModel.type;
        _this.hasSymbolVisual = true;
        _this.defaultSymbol = 'roundRect';
        return _this;
    }
    PictorialBarSeriesModel.prototype.getInitialData = function(option) {
        // Disable stack.
        option.stack = null;
        return _super.prototype.getInitialData.apply(this, arguments);
    };
    PictorialBarSeriesModel.type = 'series.pictorialBar';
    PictorialBarSeriesModel.dependencies = [
        'grid'
    ];
    PictorialBarSeriesModel.defaultOption = (0, $5370df662b2caf37$export$68acc510e46fef2)((0, $b508252f98157abf$export$2e2bcd8739ae039).defaultOption, {
        symbol: 'circle',
        symbolSize: null,
        symbolRotate: null,
        symbolPosition: null,
        symbolOffset: null,
        symbolMargin: null,
        symbolRepeat: false,
        symbolRepeatDirection: 'end',
        symbolClip: false,
        symbolBoundingData: null,
        symbolPatternSize: 400,
        barGap: '-100%',
        // Pictorial bar do not clip by default because in many cases
        // xAxis and yAxis are not displayed and it's expected not to clip
        clip: false,
        // z can be set in data item, which is z2 actually.
        // Disable progressive
        progressive: 0,
        emphasis: {
            // By default pictorialBar do not hover scale. Hover scale is not suitable
            // for the case that both has foreground and background.
            scale: false
        },
        select: {
            itemStyle: {
                borderColor: '#212121'
            }
        }
    });
    return PictorialBarSeriesModel;
}((0, $b508252f98157abf$export$2e2bcd8739ae039));
var $eb46f662d47de4a6$export$2e2bcd8739ae039 = $eb46f662d47de4a6$var$PictorialBarSeriesModel;




function $7e25595b74be81a3$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $55a0f29f32f7b1c4$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $eb46f662d47de4a6$export$2e2bcd8739ae039));
    registers.registerLayout(registers.PRIORITY.VISUAL.LAYOUT, (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)((0, $361c48dd900de28f$export$b3219800bda33a1f), 'pictorialBar'));
    // Do layout after other overall layout, which can prepare some information.
    registers.registerLayout(registers.PRIORITY.VISUAL.PROGRESSIVE_LAYOUT, (0, $361c48dd900de28f$export$16e8685758531cb6)('pictorialBar'));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $21576fcf4c669316$var$PI2 = Math.PI * 2;
var $21576fcf4c669316$var$RADIAN = Math.PI / 180;
function $21576fcf4c669316$var$getViewRect(seriesModel, api) {
    return $93b9bc7f22ac7369$export$4517a5ca639a7293(seriesModel.getBoxLayoutParams(), {
        width: api.getWidth(),
        height: api.getHeight()
    });
}
function $21576fcf4c669316$export$2a0d4d5b12383eb9(seriesModel, api) {
    var viewRect = $21576fcf4c669316$var$getViewRect(seriesModel, api);
    // center can be string or number when coordinateSystem is specified
    var center = seriesModel.get('center');
    var radius = seriesModel.get('radius');
    if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(radius)) radius = [
        0,
        radius
    ];
    var width = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(viewRect.width, api.getWidth());
    var height = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(viewRect.height, api.getHeight());
    var size = Math.min(width, height);
    var r0 = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(radius[0], size / 2);
    var r = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(radius[1], size / 2);
    var cx;
    var cy;
    var coordSys = seriesModel.coordinateSystem;
    if (coordSys) {
        // percentage is not allowed when coordinate system is specified
        var point = coordSys.dataToPoint(center);
        cx = point[0] || 0;
        cy = point[1] || 0;
    } else {
        if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(center)) center = [
            center,
            center
        ];
        cx = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(center[0], width) + viewRect.x;
        cy = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(center[1], height) + viewRect.y;
    }
    return {
        cx: cx,
        cy: cy,
        r0: r0,
        r: r
    };
}
function $21576fcf4c669316$export$2e2bcd8739ae039(seriesType, ecModel, api) {
    ecModel.eachSeriesByType(seriesType, function(seriesModel) {
        var data = seriesModel.getData();
        var valueDim = data.mapDimension('value');
        var viewRect = $21576fcf4c669316$var$getViewRect(seriesModel, api);
        var _a = $21576fcf4c669316$export$2a0d4d5b12383eb9(seriesModel, api), cx = _a.cx, cy = _a.cy, r = _a.r, r0 = _a.r0;
        var startAngle = -seriesModel.get('startAngle') * $21576fcf4c669316$var$RADIAN;
        var endAngle = seriesModel.get('endAngle');
        var padAngle = seriesModel.get('padAngle') * $21576fcf4c669316$var$RADIAN;
        endAngle = endAngle === 'auto' ? startAngle - $21576fcf4c669316$var$PI2 : -endAngle * $21576fcf4c669316$var$RADIAN;
        var minAngle = seriesModel.get('minAngle') * $21576fcf4c669316$var$RADIAN;
        var minAndPadAngle = minAngle + padAngle;
        var validDataCount = 0;
        data.each(valueDim, function(value) {
            !isNaN(value) && validDataCount++;
        });
        var sum = data.getSum(valueDim);
        // Sum may be 0
        var unitRadian = Math.PI / (sum || validDataCount) * 2;
        var clockwise = seriesModel.get('clockwise');
        var roseType = seriesModel.get('roseType');
        var stillShowZeroSum = seriesModel.get('stillShowZeroSum');
        // [0...max]
        var extent = data.getDataExtent(valueDim);
        extent[0] = 0;
        var dir = clockwise ? 1 : -1;
        var angles = [
            startAngle,
            endAngle
        ];
        var halfPadAngle = dir * padAngle / 2;
        (0, $20ebe2448f123f2e$export$bc668021e937022a)(angles, !clockwise);
        startAngle = angles[0], endAngle = angles[1];
        var layoutData = $21576fcf4c669316$export$4e43b88a06b9f223(seriesModel);
        layoutData.startAngle = startAngle;
        layoutData.endAngle = endAngle;
        layoutData.clockwise = clockwise;
        var angleRange = Math.abs(endAngle - startAngle);
        // In the case some sector angle is smaller than minAngle
        var restAngle = angleRange;
        var valueSumLargerThanMinAngle = 0;
        var currentAngle = startAngle;
        data.setLayout({
            viewRect: viewRect,
            r: r
        });
        data.each(valueDim, function(value, idx) {
            var angle;
            if (isNaN(value)) {
                data.setItemLayout(idx, {
                    angle: NaN,
                    startAngle: NaN,
                    endAngle: NaN,
                    clockwise: clockwise,
                    cx: cx,
                    cy: cy,
                    r0: r0,
                    r: roseType ? NaN : r
                });
                return;
            }
            // FIXME 兼容 2.0 但是 roseType 是 area 的时候才是这样？
            if (roseType !== 'area') angle = sum === 0 && stillShowZeroSum ? unitRadian : value * unitRadian;
            else angle = angleRange / validDataCount;
            if (angle < minAndPadAngle) {
                angle = minAndPadAngle;
                restAngle -= minAndPadAngle;
            } else valueSumLargerThanMinAngle += value;
            var endAngle = currentAngle + dir * angle;
            // calculate display angle
            var actualStartAngle = 0;
            var actualEndAngle = 0;
            if (padAngle > angle) {
                actualStartAngle = currentAngle + dir * angle / 2;
                actualEndAngle = actualStartAngle;
            } else {
                actualStartAngle = currentAngle + halfPadAngle;
                actualEndAngle = endAngle - halfPadAngle;
            }
            data.setItemLayout(idx, {
                angle: angle,
                startAngle: actualStartAngle,
                endAngle: actualEndAngle,
                clockwise: clockwise,
                cx: cx,
                cy: cy,
                r0: r0,
                r: roseType ? (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(value, extent, [
                    r0,
                    r
                ]) : r
            });
            currentAngle = endAngle;
        });
        // Some sector is constrained by minAngle and padAngle
        // Rest sectors needs recalculate angle
        if (restAngle < $21576fcf4c669316$var$PI2 && validDataCount) {
            // Average the angle if rest angle is not enough after all angles is
            // Constrained by minAngle and padAngle
            if (restAngle <= 1e-3) {
                var angle_1 = angleRange / validDataCount;
                data.each(valueDim, function(value, idx) {
                    if (!isNaN(value)) {
                        var layout_1 = data.getItemLayout(idx);
                        layout_1.angle = angle_1;
                        var actualStartAngle = 0;
                        var actualEndAngle = 0;
                        if (angle_1 < padAngle) {
                            actualStartAngle = startAngle + dir * (idx + 0.5) * angle_1;
                            actualEndAngle = actualStartAngle;
                        } else {
                            actualStartAngle = startAngle + dir * idx * angle_1 + halfPadAngle;
                            actualEndAngle = startAngle + dir * (idx + 1) * angle_1 - halfPadAngle;
                        }
                        layout_1.startAngle = actualStartAngle;
                        layout_1.endAngle = actualEndAngle;
                    }
                });
            } else {
                unitRadian = restAngle / valueSumLargerThanMinAngle;
                currentAngle = startAngle;
                data.each(valueDim, function(value, idx) {
                    if (!isNaN(value)) {
                        var layout_2 = data.getItemLayout(idx);
                        var angle = layout_2.angle === minAndPadAngle ? minAndPadAngle : value * unitRadian;
                        var actualStartAngle = 0;
                        var actualEndAngle = 0;
                        if (angle < padAngle) {
                            actualStartAngle = currentAngle + dir * angle / 2;
                            actualEndAngle = actualStartAngle;
                        } else {
                            actualStartAngle = currentAngle + halfPadAngle;
                            actualEndAngle = currentAngle + dir * angle - halfPadAngle;
                        }
                        layout_2.startAngle = actualStartAngle;
                        layout_2.endAngle = actualEndAngle;
                        currentAngle += dir * angle;
                    }
                });
            }
        }
    });
}
var $21576fcf4c669316$export$4e43b88a06b9f223 = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // FIXME emphasis label position is not same with normal label position





var $4b109d23b790ee9a$var$RADIAN = Math.PI / 180;
function $4b109d23b790ee9a$var$adjustSingleSide(list, cx, cy, r, dir, viewWidth, viewHeight, viewLeft, viewTop, farthestX) {
    if (list.length < 2) return;
    function recalculateXOnSemiToAlignOnEllipseCurve(semi) {
        var rB = semi.rB;
        var rB2 = rB * rB;
        for(var i = 0; i < semi.list.length; i++){
            var item = semi.list[i];
            var dy = Math.abs(item.label.y - cy);
            // horizontal r is always same with original r because x is not changed.
            var rA = r + item.len;
            var rA2 = rA * rA;
            // Use ellipse implicit function to calculate x
            var dx = Math.sqrt(Math.abs((1 - dy * dy / rB2) * rA2));
            var newX = cx + (dx + item.len2) * dir;
            var deltaX = newX - item.label.x;
            var newTargetWidth = item.targetTextWidth - deltaX * dir;
            // text x is changed, so need to recalculate width.
            $4b109d23b790ee9a$var$constrainTextWidth(item, newTargetWidth, true);
            item.label.x = newX;
        }
    }
    // Adjust X based on the shifted y. Make tight labels aligned on an ellipse curve.
    function recalculateX(items) {
        // Extremes of
        var topSemi = {
            list: [],
            maxY: 0
        };
        var bottomSemi = {
            list: [],
            maxY: 0
        };
        for(var i = 0; i < items.length; i++){
            if (items[i].labelAlignTo !== 'none') continue;
            var item = items[i];
            var semi = item.label.y > cy ? bottomSemi : topSemi;
            var dy = Math.abs(item.label.y - cy);
            if (dy >= semi.maxY) {
                var dx = item.label.x - cx - item.len2 * dir;
                // horizontal r is always same with original r because x is not changed.
                var rA = r + item.len;
                // Canculate rB based on the topest / bottemest label.
                var rB = Math.abs(dx) < rA ? Math.sqrt(dy * dy / (1 - dx * dx / rA / rA)) : rA;
                semi.rB = rB;
                semi.maxY = dy;
            }
            semi.list.push(item);
        }
        recalculateXOnSemiToAlignOnEllipseCurve(topSemi);
        recalculateXOnSemiToAlignOnEllipseCurve(bottomSemi);
    }
    var len = list.length;
    for(var i = 0; i < len; i++)if (list[i].position === 'outer' && list[i].labelAlignTo === 'labelLine') {
        var dx = list[i].label.x - farthestX;
        list[i].linePoints[1][0] += dx;
        list[i].label.x = farthestX;
    }
    if ((0, $11dac7a73f36cc2c$export$118c25e0932528e4)(list, viewTop, viewTop + viewHeight)) recalculateX(list);
}
function $4b109d23b790ee9a$var$avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight, viewLeft, viewTop) {
    var leftList = [];
    var rightList = [];
    var leftmostX = Number.MAX_VALUE;
    var rightmostX = -Number.MAX_VALUE;
    for(var i = 0; i < labelLayoutList.length; i++){
        var label = labelLayoutList[i].label;
        if ($4b109d23b790ee9a$var$isPositionCenter(labelLayoutList[i])) continue;
        if (label.x < cx) {
            leftmostX = Math.min(leftmostX, label.x);
            leftList.push(labelLayoutList[i]);
        } else {
            rightmostX = Math.max(rightmostX, label.x);
            rightList.push(labelLayoutList[i]);
        }
    }
    for(var i = 0; i < labelLayoutList.length; i++){
        var layout = labelLayoutList[i];
        if (!$4b109d23b790ee9a$var$isPositionCenter(layout) && layout.linePoints) {
            if (layout.labelStyleWidth != null) continue;
            var label = layout.label;
            var linePoints = layout.linePoints;
            var targetTextWidth = void 0;
            if (layout.labelAlignTo === 'edge') {
                if (label.x < cx) targetTextWidth = linePoints[2][0] - layout.labelDistance - viewLeft - layout.edgeDistance;
                else targetTextWidth = viewLeft + viewWidth - layout.edgeDistance - linePoints[2][0] - layout.labelDistance;
            } else if (layout.labelAlignTo === 'labelLine') {
                if (label.x < cx) targetTextWidth = leftmostX - viewLeft - layout.bleedMargin;
                else targetTextWidth = viewLeft + viewWidth - rightmostX - layout.bleedMargin;
            } else if (label.x < cx) targetTextWidth = label.x - viewLeft - layout.bleedMargin;
            else targetTextWidth = viewLeft + viewWidth - label.x - layout.bleedMargin;
            layout.targetTextWidth = targetTextWidth;
            $4b109d23b790ee9a$var$constrainTextWidth(layout, targetTextWidth);
        }
    }
    $4b109d23b790ee9a$var$adjustSingleSide(rightList, cx, cy, r, 1, viewWidth, viewHeight, viewLeft, viewTop, rightmostX);
    $4b109d23b790ee9a$var$adjustSingleSide(leftList, cx, cy, r, -1, viewWidth, viewHeight, viewLeft, viewTop, leftmostX);
    for(var i = 0; i < labelLayoutList.length; i++){
        var layout = labelLayoutList[i];
        if (!$4b109d23b790ee9a$var$isPositionCenter(layout) && layout.linePoints) {
            var label = layout.label;
            var linePoints = layout.linePoints;
            var isAlignToEdge = layout.labelAlignTo === 'edge';
            var padding = label.style.padding;
            var paddingH = padding ? padding[1] + padding[3] : 0;
            // textRect.width already contains paddingH if bgColor is set
            var extraPaddingH = label.style.backgroundColor ? 0 : paddingH;
            var realTextWidth = layout.rect.width + extraPaddingH;
            var dist = linePoints[1][0] - linePoints[2][0];
            if (isAlignToEdge) {
                if (label.x < cx) linePoints[2][0] = viewLeft + layout.edgeDistance + realTextWidth + layout.labelDistance;
                else linePoints[2][0] = viewLeft + viewWidth - layout.edgeDistance - realTextWidth - layout.labelDistance;
            } else {
                if (label.x < cx) linePoints[2][0] = label.x + layout.labelDistance;
                else linePoints[2][0] = label.x - layout.labelDistance;
                linePoints[1][0] = linePoints[2][0] + dist;
            }
            linePoints[1][1] = linePoints[2][1] = label.y;
        }
    }
}
/**
 * Set max width of each label, and then wrap each label to the max width.
 *
 * @param layout label layout
 * @param availableWidth max width for the label to display
 * @param forceRecalculate recaculate the text layout even if the current width
 * is smaller than `availableWidth`. This is useful when the text was previously
 * wrapped by calling `constrainTextWidth` but now `availableWidth` changed, in
 * which case, previous wrapping should be redo.
 */ function $4b109d23b790ee9a$var$constrainTextWidth(layout, availableWidth, forceRecalculate) {
    if (forceRecalculate === void 0) forceRecalculate = false;
    if (layout.labelStyleWidth != null) // User-defined style.width has the highest priority.
    return;
    var label = layout.label;
    var style = label.style;
    var textRect = layout.rect;
    var bgColor = style.backgroundColor;
    var padding = style.padding;
    var paddingH = padding ? padding[1] + padding[3] : 0;
    var overflow = style.overflow;
    // textRect.width already contains paddingH if bgColor is set
    var oldOuterWidth = textRect.width + (bgColor ? 0 : paddingH);
    if (availableWidth < oldOuterWidth || forceRecalculate) {
        var oldHeight = textRect.height;
        if (overflow && overflow.match('break')) {
            // Temporarily set background to be null to calculate
            // the bounding box without background.
            label.setStyle('backgroundColor', null);
            // Set constraining width
            label.setStyle('width', availableWidth - paddingH);
            // This is the real bounding box of the text without padding.
            var innerRect = label.getBoundingRect();
            label.setStyle('width', Math.ceil(innerRect.width));
            label.setStyle('backgroundColor', bgColor);
        } else {
            var availableInnerWidth = availableWidth - paddingH;
            var newWidth = availableWidth < oldOuterWidth ? availableInnerWidth : // Current available width is enough, but the text may have
            // already been wrapped with a smaller available width.
            forceRecalculate ? availableInnerWidth > layout.unconstrainedWidth ? null : availableInnerWidth : null;
            label.setStyle('width', newWidth);
        }
        var newRect = label.getBoundingRect();
        textRect.width = newRect.width;
        var margin = (label.style.margin || 0) + 2.1;
        textRect.height = newRect.height + margin;
        textRect.y -= (textRect.height - oldHeight) / 2;
    }
}
function $4b109d23b790ee9a$var$isPositionCenter(sectorShape) {
    // Not change x for center label
    return sectorShape.position === 'center';
}
function $4b109d23b790ee9a$export$2e2bcd8739ae039(seriesModel) {
    var data = seriesModel.getData();
    var labelLayoutList = [];
    var cx;
    var cy;
    var hasLabelRotate = false;
    var minShowLabelRadian = (seriesModel.get('minShowLabelAngle') || 0) * $4b109d23b790ee9a$var$RADIAN;
    var viewRect = data.getLayout('viewRect');
    var r = data.getLayout('r');
    var viewWidth = viewRect.width;
    var viewLeft = viewRect.x;
    var viewTop = viewRect.y;
    var viewHeight = viewRect.height;
    function setNotShow(el) {
        el.ignore = true;
    }
    function isLabelShown(label) {
        if (!label.ignore) return true;
        for(var key in label.states){
            if (label.states[key].ignore === false) return true;
        }
        return false;
    }
    data.each(function(idx) {
        var sector = data.getItemGraphicEl(idx);
        var sectorShape = sector.shape;
        var label = sector.getTextContent();
        var labelLine = sector.getTextGuideLine();
        var itemModel = data.getItemModel(idx);
        var labelModel = itemModel.getModel('label');
        // Use position in normal or emphasis
        var labelPosition = labelModel.get('position') || itemModel.get([
            'emphasis',
            'label',
            'position'
        ]);
        var labelDistance = labelModel.get('distanceToLabelLine');
        var labelAlignTo = labelModel.get('alignTo');
        var edgeDistance = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(labelModel.get('edgeDistance'), viewWidth);
        var bleedMargin = labelModel.get('bleedMargin');
        var labelLineModel = itemModel.getModel('labelLine');
        var labelLineLen = labelLineModel.get('length');
        labelLineLen = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(labelLineLen, viewWidth);
        var labelLineLen2 = labelLineModel.get('length2');
        labelLineLen2 = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(labelLineLen2, viewWidth);
        if (Math.abs(sectorShape.endAngle - sectorShape.startAngle) < minShowLabelRadian) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(label.states, setNotShow);
            label.ignore = true;
            if (labelLine) {
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(labelLine.states, setNotShow);
                labelLine.ignore = true;
            }
            return;
        }
        if (!isLabelShown(label)) return;
        var midAngle = (sectorShape.startAngle + sectorShape.endAngle) / 2;
        var nx = Math.cos(midAngle);
        var ny = Math.sin(midAngle);
        var textX;
        var textY;
        var linePoints;
        var textAlign;
        cx = sectorShape.cx;
        cy = sectorShape.cy;
        var isLabelInside = labelPosition === 'inside' || labelPosition === 'inner';
        if (labelPosition === 'center') {
            textX = sectorShape.cx;
            textY = sectorShape.cy;
            textAlign = 'center';
        } else {
            var x1 = (isLabelInside ? (sectorShape.r + sectorShape.r0) / 2 * nx : sectorShape.r * nx) + cx;
            var y1 = (isLabelInside ? (sectorShape.r + sectorShape.r0) / 2 * ny : sectorShape.r * ny) + cy;
            textX = x1 + nx * 3;
            textY = y1 + ny * 3;
            if (!isLabelInside) {
                // For roseType
                var x2 = x1 + nx * (labelLineLen + r - sectorShape.r);
                var y2 = y1 + ny * (labelLineLen + r - sectorShape.r);
                var x3 = x2 + (nx < 0 ? -1 : 1) * labelLineLen2;
                var y3 = y2;
                if (labelAlignTo === 'edge') // Adjust textX because text align of edge is opposite
                textX = nx < 0 ? viewLeft + edgeDistance : viewLeft + viewWidth - edgeDistance;
                else textX = x3 + (nx < 0 ? -labelDistance : labelDistance);
                textY = y3;
                linePoints = [
                    [
                        x1,
                        y1
                    ],
                    [
                        x2,
                        y2
                    ],
                    [
                        x3,
                        y3
                    ]
                ];
            }
            textAlign = isLabelInside ? 'center' : labelAlignTo === 'edge' ? nx > 0 ? 'right' : 'left' : nx > 0 ? 'left' : 'right';
        }
        var PI = Math.PI;
        var labelRotate = 0;
        var rotate = labelModel.get('rotate');
        if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(rotate)) labelRotate = rotate * (PI / 180);
        else if (labelPosition === 'center') labelRotate = 0;
        else if (rotate === 'radial' || rotate === true) {
            var radialAngle = nx < 0 ? -midAngle + PI : -midAngle;
            labelRotate = radialAngle;
        } else if (rotate === 'tangential' && labelPosition !== 'outside' && labelPosition !== 'outer') {
            var rad = Math.atan2(nx, ny);
            if (rad < 0) rad = PI * 2 + rad;
            var isDown = ny > 0;
            if (isDown) rad = PI + rad;
            labelRotate = rad - PI;
        }
        hasLabelRotate = !!labelRotate;
        label.x = textX;
        label.y = textY;
        label.rotation = labelRotate;
        label.setStyle({
            verticalAlign: 'middle'
        });
        // Not sectorShape the inside label
        if (!isLabelInside) {
            var textRect = label.getBoundingRect().clone();
            textRect.applyTransform(label.getComputedTransform());
            // Text has a default 1px stroke. Exclude this.
            var margin = (label.style.margin || 0) + 2.1;
            textRect.y -= margin / 2;
            textRect.height += margin;
            labelLayoutList.push({
                label: label,
                labelLine: labelLine,
                position: labelPosition,
                len: labelLineLen,
                len2: labelLineLen2,
                minTurnAngle: labelLineModel.get('minTurnAngle'),
                maxSurfaceAngle: labelLineModel.get('maxSurfaceAngle'),
                surfaceNormal: new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)(nx, ny),
                linePoints: linePoints,
                textAlign: textAlign,
                labelDistance: labelDistance,
                labelAlignTo: labelAlignTo,
                edgeDistance: edgeDistance,
                bleedMargin: bleedMargin,
                rect: textRect,
                unconstrainedWidth: textRect.width,
                labelStyleWidth: label.style.width
            });
        } else {
            label.setStyle({
                align: textAlign
            });
            var selectState = label.states.select;
            if (selectState) {
                selectState.x += label.x;
                selectState.y += label.y;
            }
        }
        sector.setTextConfig({
            inside: isLabelInside
        });
    });
    if (!hasLabelRotate && seriesModel.get('avoidLabelOverlap')) $4b109d23b790ee9a$var$avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight, viewLeft, viewTop);
    for(var i = 0; i < labelLayoutList.length; i++){
        var layout = labelLayoutList[i];
        var label = layout.label;
        var labelLine = layout.labelLine;
        var notShowLabel = isNaN(label.x) || isNaN(label.y);
        if (label) {
            label.setStyle({
                align: layout.textAlign
            });
            if (notShowLabel) {
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(label.states, setNotShow);
                label.ignore = true;
            }
            var selectState = label.states.select;
            if (selectState) {
                selectState.x += label.x;
                selectState.y += label.y;
            }
        }
        if (labelLine) {
            var linePoints = layout.linePoints;
            if (notShowLabel || !linePoints) {
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(labelLine.states, setNotShow);
                labelLine.ignore = true;
            } else {
                (0, $f4eb87a228be297f$export$ac52062003fbe6a)(linePoints, layout.minTurnAngle);
                (0, $f4eb87a228be297f$export$973e1fdb2708f71b)(linePoints, layout.surfaceNormal, layout.maxSurfaceAngle);
                labelLine.setShape({
                    points: linePoints
                });
                // Set the anchor to the midpoint of sector
                label.__hostTarget.textGuideLineConfig = {
                    anchor: new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)(linePoints[0][0], linePoints[0][1])
                };
            }
        }
    }
}







/**
 * Piece of pie including Sector, Label, LabelLine
 */ var $773d25f97e67400e$var$PiePiece = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(PiePiece, _super);
    function PiePiece(data, idx, startAngle) {
        var _this = _super.call(this) || this;
        _this.z2 = 2;
        var text = new $fe885cc21795562b$export$2e2bcd8739ae039();
        _this.setTextContent(text);
        _this.updateData(data, idx, startAngle, true);
        return _this;
    }
    PiePiece.prototype.updateData = function(data, idx, startAngle, firstCreate) {
        var sector = this;
        var seriesModel = data.hostModel;
        var itemModel = data.getItemModel(idx);
        var emphasisModel = itemModel.getModel('emphasis');
        var layout = data.getItemLayout(idx);
        // cornerRadius & innerCornerRadius doesn't exist in the item layout. Use `0` if null value is specified.
        // see `setItemLayout` in `pieLayout.ts`.
        var sectorShape = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)((0, $9491a9b96e203579$export$b395eeeb2ad7cce5)(itemModel.getModel('itemStyle'), layout, true), layout);
        // Ignore NaN data.
        if (isNaN(sectorShape.startAngle)) {
            // Use NaN shape to avoid drawing shape.
            sector.setShape(sectorShape);
            return;
        }
        if (firstCreate) {
            sector.setShape(sectorShape);
            var animationType = seriesModel.getShallow('animationType');
            if (seriesModel.ecModel.ssr) {
                // Use scale animation in SSR mode(opacity?)
                // Because CSS SVG animation doesn't support very customized shape animation.
                $8b353638fbedfefa$export$a121566aadcfe021(sector, {
                    scaleX: 0,
                    scaleY: 0
                }, seriesModel, {
                    dataIndex: idx,
                    isFrom: true
                });
                sector.originX = sectorShape.cx;
                sector.originY = sectorShape.cy;
            } else if (animationType === 'scale') {
                sector.shape.r = layout.r0;
                $8b353638fbedfefa$export$a121566aadcfe021(sector, {
                    shape: {
                        r: layout.r
                    }
                }, seriesModel, idx);
            } else if (startAngle != null) {
                sector.setShape({
                    startAngle: startAngle,
                    endAngle: startAngle
                });
                $8b353638fbedfefa$export$a121566aadcfe021(sector, {
                    shape: {
                        startAngle: layout.startAngle,
                        endAngle: layout.endAngle
                    }
                }, seriesModel, idx);
            } else {
                sector.shape.endAngle = layout.startAngle;
                $8b353638fbedfefa$export$c8dce3c08436e91e(sector, {
                    shape: {
                        endAngle: layout.endAngle
                    }
                }, seriesModel, idx);
            }
        } else {
            (0, $8b353638fbedfefa$export$bca7290a9faf0ec9)(sector);
            // Transition animation from the old shape
            $8b353638fbedfefa$export$c8dce3c08436e91e(sector, {
                shape: sectorShape
            }, seriesModel, idx);
        }
        sector.useStyle(data.getItemVisual(idx, 'style'));
        (0, $2bf82c0980125b62$export$48b68047d330bbc9)(sector, itemModel);
        var midAngle = (layout.startAngle + layout.endAngle) / 2;
        var offset = seriesModel.get('selectedOffset');
        var dx = Math.cos(midAngle) * offset;
        var dy = Math.sin(midAngle) * offset;
        var cursorStyle = itemModel.getShallow('cursor');
        cursorStyle && sector.attr('cursor', cursorStyle);
        this._updateLabel(seriesModel, data, idx);
        sector.ensureState('emphasis').shape = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
            r: layout.r + (emphasisModel.get('scale') ? emphasisModel.get('scaleSize') || 0 : 0)
        }, (0, $9491a9b96e203579$export$b395eeeb2ad7cce5)(emphasisModel.getModel('itemStyle'), layout));
        (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(sector.ensureState('select'), {
            x: dx,
            y: dy,
            shape: (0, $9491a9b96e203579$export$b395eeeb2ad7cce5)(itemModel.getModel([
                'select',
                'itemStyle'
            ]), layout)
        });
        (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(sector.ensureState('blur'), {
            shape: (0, $9491a9b96e203579$export$b395eeeb2ad7cce5)(itemModel.getModel([
                'blur',
                'itemStyle'
            ]), layout)
        });
        var labelLine = sector.getTextGuideLine();
        var labelText = sector.getTextContent();
        labelLine && (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(labelLine.ensureState('select'), {
            x: dx,
            y: dy
        });
        // TODO: needs dx, dy in zrender?
        (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(labelText.ensureState('select'), {
            x: dx,
            y: dy
        });
        (0, $2bf82c0980125b62$export$e51187539ff11209)(this, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
    };
    PiePiece.prototype._updateLabel = function(seriesModel, data, idx) {
        var sector = this;
        var itemModel = data.getItemModel(idx);
        var labelLineModel = itemModel.getModel('labelLine');
        var style = data.getItemVisual(idx, 'style');
        var visualColor = style && style.fill;
        var visualOpacity = style && style.opacity;
        (0, $6800dfcb6e1e2a44$export$9a13992917966657)(sector, (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(itemModel), {
            labelFetcher: data.hostModel,
            labelDataIndex: idx,
            inheritColor: visualColor,
            defaultOpacity: visualOpacity,
            defaultText: seriesModel.getFormattedLabel(idx, 'normal') || data.getName(idx)
        });
        var labelText = sector.getTextContent();
        // Set textConfig on sector.
        sector.setTextConfig({
            // reset position, rotation
            position: null,
            rotation: null
        });
        // Make sure update style on labelText after setLabelStyle.
        // Because setLabelStyle will replace a new style on it.
        labelText.attr({
            z2: 10
        });
        var labelPosition = seriesModel.get([
            'label',
            'position'
        ]);
        if (labelPosition !== 'outside' && labelPosition !== 'outer') sector.removeTextGuideLine();
        else {
            var polyline = this.getTextGuideLine();
            if (!polyline) {
                polyline = new $d28119f30e6bb670$export$2e2bcd8739ae039();
                this.setTextGuideLine(polyline);
            }
            // Default use item visual color
            (0, $f4eb87a228be297f$export$c09e0b0574bdd2dc)(this, (0, $f4eb87a228be297f$export$2979fdbf5ebce521)(itemModel), {
                stroke: visualColor,
                opacity: (0, $7a1bd9c2710fea0d$export$2e94551289abb95b)(labelLineModel.get([
                    'lineStyle',
                    'opacity'
                ]), visualOpacity, 1)
            });
        }
    };
    return PiePiece;
}($a3e1dec0a3875b49$export$2e2bcd8739ae039);
// Pie view
var $773d25f97e67400e$var$PieView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(PieView, _super);
    function PieView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ignoreLabelLineUpdate = true;
        return _this;
    }
    PieView.prototype.render = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData();
        var oldData = this._data;
        var group = this.group;
        var startAngle;
        // First render
        if (!oldData && data.count() > 0) {
            var shape = data.getItemLayout(0);
            for(var s = 1; isNaN(shape && shape.startAngle) && s < data.count(); ++s)shape = data.getItemLayout(s);
            if (shape) startAngle = shape.startAngle;
        }
        // remove empty-circle if it exists
        if (this._emptyCircleSector) group.remove(this._emptyCircleSector);
        // when all data are filtered, show lightgray empty circle
        if (data.count() === 0 && seriesModel.get('showEmptyCircle')) {
            var layoutData = (0, $21576fcf4c669316$export$4e43b88a06b9f223)(seriesModel);
            var sector = new $a3e1dec0a3875b49$export$2e2bcd8739ae039({
                shape: (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)((0, $21576fcf4c669316$export$2a0d4d5b12383eb9)(seriesModel, api), layoutData)
            });
            sector.useStyle(seriesModel.getModel('emptyCircleStyle').getItemStyle());
            this._emptyCircleSector = sector;
            group.add(sector);
        }
        data.diff(oldData).add(function(idx) {
            var piePiece = new $773d25f97e67400e$var$PiePiece(data, idx, startAngle);
            data.setItemGraphicEl(idx, piePiece);
            group.add(piePiece);
        }).update(function(newIdx, oldIdx) {
            var piePiece = oldData.getItemGraphicEl(oldIdx);
            piePiece.updateData(data, newIdx, startAngle);
            piePiece.off('click');
            group.add(piePiece);
            data.setItemGraphicEl(newIdx, piePiece);
        }).remove(function(idx) {
            var piePiece = oldData.getItemGraphicEl(idx);
            $8b353638fbedfefa$export$6d0fd725cb4aee8a(piePiece, seriesModel, idx);
        }).execute();
        (0, $4b109d23b790ee9a$export$2e2bcd8739ae039)(seriesModel);
        // Always use initial animation.
        if (seriesModel.get('animationTypeUpdate') !== 'expansion') this._data = data;
    };
    PieView.prototype.dispose = function() {};
    PieView.prototype.containPoint = function(point, seriesModel) {
        var data = seriesModel.getData();
        var itemLayout = data.getItemLayout(0);
        if (itemLayout) {
            var dx = point[0] - itemLayout.cx;
            var dy = point[1] - itemLayout.cy;
            var radius = Math.sqrt(dx * dx + dy * dy);
            return radius <= itemLayout.r && radius >= itemLayout.r0;
        }
    };
    PieView.type = 'pie';
    return PieView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $773d25f97e67400e$export$2e2bcd8739ae039 = $773d25f97e67400e$var$PieView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







var $9de67b16c98ecc62$var$innerData = $76d619f648247e6d$export$64df9f8d92ae083f();
var $9de67b16c98ecc62$var$PieSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(PieSeriesModel, _super);
    function PieSeriesModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
   * @overwrite
   */ PieSeriesModel.prototype.init = function(option) {
        _super.prototype.init.apply(this, arguments);
        // Enable legend selection for each data item
        // Use a function instead of direct access because data reference may changed
        this.legendVisualProvider = new (0, $cf24728fc17c4ab6$export$2e2bcd8739ae039)($7a1bd9c2710fea0d$export$2385a24977818dd0(this.getData, this), $7a1bd9c2710fea0d$export$2385a24977818dd0(this.getRawData, this));
        this._defaultLabelLine(option);
    };
    /**
   * @overwrite
   */ PieSeriesModel.prototype.mergeOption = function() {
        _super.prototype.mergeOption.apply(this, arguments);
    };
    /**
   * @overwrite
   */ PieSeriesModel.prototype.getInitialData = function() {
        return (0, $7e5c3511527c9907$export$2e2bcd8739ae039)(this, {
            coordDimensions: [
                'value'
            ],
            encodeDefaulter: $7a1bd9c2710fea0d$export$c3095a23b368d1f2((0, $7dc6cdfd7450ef29$export$60b8a57d1f2fed26), this)
        });
    };
    /**
   * @overwrite
   */ PieSeriesModel.prototype.getDataParams = function(dataIndex) {
        var data = this.getData();
        // update seats when data is changed
        var dataInner = $9de67b16c98ecc62$var$innerData(data);
        var seats = dataInner.seats;
        if (!seats) {
            var valueList_1 = [];
            data.each(data.mapDimension('value'), function(value) {
                valueList_1.push(value);
            });
            seats = dataInner.seats = (0, $cfc1f3b422a3185f$export$222dabb13d5320df)(valueList_1, data.hostModel.get('percentPrecision'));
        }
        var params = _super.prototype.getDataParams.call(this, dataIndex);
        // seats may be empty when sum is 0
        params.percent = seats[dataIndex] || 0;
        params.$vars.push('percent');
        return params;
    };
    PieSeriesModel.prototype._defaultLabelLine = function(option) {
        // Extend labelLine emphasis
        $76d619f648247e6d$export$abdcc6a26372f94b(option, 'labelLine', [
            'show'
        ]);
        var labelLineNormalOpt = option.labelLine;
        var labelLineEmphasisOpt = option.emphasis.labelLine;
        // Not show label line if `label.normal.show = false`
        labelLineNormalOpt.show = labelLineNormalOpt.show && option.label.show;
        labelLineEmphasisOpt.show = labelLineEmphasisOpt.show && option.emphasis.label.show;
    };
    PieSeriesModel.type = 'series.pie';
    PieSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        legendHoverLink: true,
        colorBy: 'data',
        // 默认全局居中
        center: [
            '50%',
            '50%'
        ],
        radius: [
            0,
            '75%'
        ],
        // 默认顺时针
        clockwise: true,
        startAngle: 90,
        endAngle: 'auto',
        padAngle: 0,
        // 最小角度改为0
        minAngle: 0,
        // If the angle of a sector less than `minShowLabelAngle`,
        // the label will not be displayed.
        minShowLabelAngle: 0,
        // 选中时扇区偏移量
        selectedOffset: 10,
        // 选择模式，默认关闭，可选single，multiple
        // selectedMode: false,
        // 南丁格尔玫瑰图模式，'radius'（半径） | 'area'（面积）
        // roseType: null,
        percentPrecision: 2,
        // If still show when all data zero.
        stillShowZeroSum: true,
        // cursor: null,
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        width: null,
        height: null,
        label: {
            // color: 'inherit',
            // If rotate around circle
            rotate: 0,
            show: true,
            overflow: 'truncate',
            // 'outer', 'inside', 'center'
            position: 'outer',
            // 'none', 'labelLine', 'edge'. Works only when position is 'outer'
            alignTo: 'none',
            // Closest distance between label and chart edge.
            // Works only position is 'outer' and alignTo is 'edge'.
            edgeDistance: '25%',
            // Works only position is 'outer' and alignTo is not 'edge'.
            bleedMargin: 10,
            // Distance between text and label line.
            distanceToLabelLine: 5
        },
        // Enabled when label.normal.position is 'outer'
        labelLine: {
            show: true,
            // 引导线两段中的第一段长度
            length: 15,
            // 引导线两段中的第二段长度
            length2: 15,
            smooth: false,
            minTurnAngle: 90,
            maxSurfaceAngle: 90,
            lineStyle: {
                // color: 各异,
                width: 1,
                type: 'solid'
            }
        },
        itemStyle: {
            borderWidth: 1,
            borderJoin: 'round'
        },
        showEmptyCircle: true,
        emptyCircleStyle: {
            color: 'lightgray',
            opacity: 1
        },
        labelLayout: {
            // Hide the overlapped label.
            hideOverlap: true
        },
        emphasis: {
            scale: true,
            scaleSize: 5
        },
        // If use strategy to avoid label overlapping
        avoidLabelOverlap: true,
        // Animation type. Valid values: expansion, scale
        animationType: 'expansion',
        animationDuration: 1000,
        // Animation type when update. Valid values: transition, expansion
        animationTypeUpdate: 'transition',
        animationEasingUpdate: 'cubicInOut',
        animationDurationUpdate: 500,
        animationEasing: 'cubicInOut'
    };
    return PieSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $9de67b16c98ecc62$export$2e2bcd8739ae039 = $9de67b16c98ecc62$var$PieSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $10dfc09d63e54240$export$2e2bcd8739ae039(seriesType) {
    return {
        seriesType: seriesType,
        reset: function(seriesModel, ecModel) {
            var data = seriesModel.getData();
            data.filterSelf(function(idx) {
                // handle negative value condition
                var valueDim = data.mapDimension('value');
                var curValue = data.get(valueDim, idx);
                if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(curValue) && !isNaN(curValue) && curValue < 0) return false;
                return true;
            });
        }
    };
}


function $6b7ead9b40180cba$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $773d25f97e67400e$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $9de67b16c98ecc62$export$2e2bcd8739ae039));
    (0, $e855ccf7eff48bce$export$62942ba95693dbfc)('pie', registers.registerAction);
    registers.registerLayout((0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)((0, $21576fcf4c669316$export$2e2bcd8739ae039), 'pie'));
    registers.registerProcessor((0, $e11a533bf70b759c$export$2e2bcd8739ae039)('pie'));
    registers.registerProcessor((0, $10dfc09d63e54240$export$2e2bcd8739ae039)('pie'));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $bec68b02ebcf9063$export$2e2bcd8739ae039(ecModel) {
    ecModel.eachSeriesByType('radar', function(seriesModel) {
        var data = seriesModel.getData();
        var points = [];
        var coordSys = seriesModel.coordinateSystem;
        if (!coordSys) return;
        var axes = coordSys.getIndicatorAxes();
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(axes, function(axis, axisIndex) {
            data.each(data.mapDimension(axes[axisIndex].dim), function(val, dataIndex) {
                points[dataIndex] = points[dataIndex] || [];
                var point = coordSys.dataToPoint(val, axisIndex);
                points[dataIndex][axisIndex] = $bec68b02ebcf9063$var$isValidPoint(point) ? point : $bec68b02ebcf9063$var$getValueMissingPoint(coordSys);
            });
        });
        // Close polygon
        data.each(function(idx) {
            // TODO
            // Is it appropriate to connect to the next data when some data is missing?
            // Or, should trade it like `connectNull` in line chart?
            var firstPoint = $7a1bd9c2710fea0d$export$71aa6c912b956294(points[idx], function(point) {
                return $bec68b02ebcf9063$var$isValidPoint(point);
            }) || $bec68b02ebcf9063$var$getValueMissingPoint(coordSys);
            // Copy the first actual point to the end of the array
            points[idx].push(firstPoint.slice());
            data.setItemLayout(idx, points[idx]);
        });
    });
}
function $bec68b02ebcf9063$var$isValidPoint(point) {
    return !isNaN(point[0]) && !isNaN(point[1]);
}
function $bec68b02ebcf9063$var$getValueMissingPoint(coordSys) {
    // It is error-prone to input [NaN, NaN] into polygon, polygon.
    // (probably cause problem when refreshing or animating)
    return [
        coordSys.cx,
        coordSys.cy
    ];
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // @ts-nocheck
// Backward compat for radar chart in 2

function $506480c8f28f74be$export$2e2bcd8739ae039(option) {
    var polarOptArr = option.polar;
    if (polarOptArr) {
        if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(polarOptArr)) polarOptArr = [
            polarOptArr
        ];
        var polarNotRadar_1 = [];
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(polarOptArr, function(polarOpt, idx) {
            if (polarOpt.indicator) {
                if (polarOpt.type && !polarOpt.shape) polarOpt.shape = polarOpt.type;
                option.radar = option.radar || [];
                if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(option.radar)) option.radar = [
                    option.radar
                ];
                option.radar.push(polarOpt);
            } else polarNotRadar_1.push(polarOpt);
        });
        option.polar = polarNotRadar_1;
    }
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(option.series, function(seriesOpt) {
        if (seriesOpt && seriesOpt.type === 'radar' && seriesOpt.polarIndex) seriesOpt.radarIndex = seriesOpt.polarIndex;
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 








var $1fc9e69f4602cced$var$RadarView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(RadarView, _super);
    function RadarView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = RadarView.type;
        return _this;
    }
    RadarView.prototype.render = function(seriesModel, ecModel, api) {
        var polar = seriesModel.coordinateSystem;
        var group = this.group;
        var data = seriesModel.getData();
        var oldData = this._data;
        function createSymbol(data, idx) {
            var symbolType = data.getItemVisual(idx, 'symbol') || 'circle';
            if (symbolType === 'none') return;
            var symbolSize = $5370466dadc978d7$export$a84524f03e8e8dfb(data.getItemVisual(idx, 'symbolSize'));
            var symbolPath = $5370466dadc978d7$export$af050e04da3a02e8(symbolType, -1, -1, 2, 2);
            var symbolRotate = data.getItemVisual(idx, 'symbolRotate') || 0;
            symbolPath.attr({
                style: {
                    strokeNoScale: true
                },
                z2: 100,
                scaleX: symbolSize[0] / 2,
                scaleY: symbolSize[1] / 2,
                rotation: symbolRotate * Math.PI / 180 || 0
            });
            return symbolPath;
        }
        function updateSymbols(oldPoints, newPoints, symbolGroup, data, idx, isInit) {
            // Simply rerender all
            symbolGroup.removeAll();
            for(var i = 0; i < newPoints.length - 1; i++){
                var symbolPath = createSymbol(data, idx);
                if (symbolPath) {
                    symbolPath.__dimIdx = i;
                    if (oldPoints[i]) {
                        symbolPath.setPosition(oldPoints[i]);
                        $5b455ae6f843ac47$exports[isInit ? 'initProps' : 'updateProps'](symbolPath, {
                            x: newPoints[i][0],
                            y: newPoints[i][1]
                        }, seriesModel, idx);
                    } else symbolPath.setPosition(newPoints[i]);
                    symbolGroup.add(symbolPath);
                }
            }
        }
        function getInitialPoints(points) {
            return $7a1bd9c2710fea0d$export$871de8747c9eaa88(points, function(pt) {
                return [
                    polar.cx,
                    polar.cy
                ];
            });
        }
        data.diff(oldData).add(function(idx) {
            var points = data.getItemLayout(idx);
            if (!points) return;
            var polygon = new $5b455ae6f843ac47$exports.Polygon();
            var polyline = new $5b455ae6f843ac47$exports.Polyline();
            var target = {
                shape: {
                    points: points
                }
            };
            polygon.shape.points = getInitialPoints(points);
            polyline.shape.points = getInitialPoints(points);
            $5b455ae6f843ac47$exports.initProps(polygon, target, seriesModel, idx);
            $5b455ae6f843ac47$exports.initProps(polyline, target, seriesModel, idx);
            var itemGroup = new $5b455ae6f843ac47$exports.Group();
            var symbolGroup = new $5b455ae6f843ac47$exports.Group();
            itemGroup.add(polyline);
            itemGroup.add(polygon);
            itemGroup.add(symbolGroup);
            updateSymbols(polyline.shape.points, points, symbolGroup, data, idx, true);
            data.setItemGraphicEl(idx, itemGroup);
        }).update(function(newIdx, oldIdx) {
            var itemGroup = oldData.getItemGraphicEl(oldIdx);
            var polyline = itemGroup.childAt(0);
            var polygon = itemGroup.childAt(1);
            var symbolGroup = itemGroup.childAt(2);
            var target = {
                shape: {
                    points: data.getItemLayout(newIdx)
                }
            };
            if (!target.shape.points) return;
            updateSymbols(polyline.shape.points, target.shape.points, symbolGroup, data, newIdx, false);
            (0, $8b353638fbedfefa$export$bca7290a9faf0ec9)(polygon);
            (0, $8b353638fbedfefa$export$bca7290a9faf0ec9)(polyline);
            $5b455ae6f843ac47$exports.updateProps(polyline, target, seriesModel);
            $5b455ae6f843ac47$exports.updateProps(polygon, target, seriesModel);
            data.setItemGraphicEl(newIdx, itemGroup);
        }).remove(function(idx) {
            group.remove(oldData.getItemGraphicEl(idx));
        }).execute();
        data.eachItemGraphicEl(function(itemGroup, idx) {
            var itemModel = data.getItemModel(idx);
            var polyline = itemGroup.childAt(0);
            var polygon = itemGroup.childAt(1);
            var symbolGroup = itemGroup.childAt(2);
            // Radar uses the visual encoded from itemStyle.
            var itemStyle = data.getItemVisual(idx, 'style');
            var color = itemStyle.fill;
            group.add(itemGroup);
            polyline.useStyle($7a1bd9c2710fea0d$export$ebe90cb607ad99e(itemModel.getModel('lineStyle').getLineStyle(), {
                fill: 'none',
                stroke: color
            }));
            (0, $2bf82c0980125b62$export$48b68047d330bbc9)(polyline, itemModel, 'lineStyle');
            (0, $2bf82c0980125b62$export$48b68047d330bbc9)(polygon, itemModel, 'areaStyle');
            var areaStyleModel = itemModel.getModel('areaStyle');
            var polygonIgnore = areaStyleModel.isEmpty() && areaStyleModel.parentModel.isEmpty();
            polygon.ignore = polygonIgnore;
            $7a1bd9c2710fea0d$export$79b2f7037acddd43([
                'emphasis',
                'select',
                'blur'
            ], function(stateName) {
                var stateModel = itemModel.getModel([
                    stateName,
                    'areaStyle'
                ]);
                var stateIgnore = stateModel.isEmpty() && stateModel.parentModel.isEmpty();
                // Won't be ignore if normal state is not ignore.
                polygon.ensureState(stateName).ignore = stateIgnore && polygonIgnore;
            });
            polygon.useStyle($7a1bd9c2710fea0d$export$ebe90cb607ad99e(areaStyleModel.getAreaStyle(), {
                fill: color,
                opacity: 0.7,
                decal: itemStyle.decal
            }));
            var emphasisModel = itemModel.getModel('emphasis');
            var itemHoverStyle = emphasisModel.getModel('itemStyle').getItemStyle();
            symbolGroup.eachChild(function(symbolPath) {
                if (symbolPath instanceof (0, $86adec94217b86c6$export$2e2bcd8739ae039)) {
                    var pathStyle = symbolPath.style;
                    symbolPath.useStyle($7a1bd9c2710fea0d$export$8b58be045bf06082({
                        // TODO other properties like x, y ?
                        image: pathStyle.image,
                        x: pathStyle.x,
                        y: pathStyle.y,
                        width: pathStyle.width,
                        height: pathStyle.height
                    }, itemStyle));
                } else {
                    symbolPath.useStyle(itemStyle);
                    symbolPath.setColor(color);
                    symbolPath.style.strokeNoScale = true;
                }
                var pathEmphasisState = symbolPath.ensureState('emphasis');
                pathEmphasisState.style = $7a1bd9c2710fea0d$export$9cd59f9826255e47(itemHoverStyle);
                var defaultText = data.getStore().get(data.getDimensionIndex(symbolPath.__dimIdx), idx);
                (defaultText == null || isNaN(defaultText)) && (defaultText = '');
                (0, $6800dfcb6e1e2a44$export$9a13992917966657)(symbolPath, (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(itemModel), {
                    labelFetcher: data.hostModel,
                    labelDataIndex: idx,
                    labelDimIndex: symbolPath.__dimIdx,
                    defaultText: defaultText,
                    inheritColor: color,
                    defaultOpacity: itemStyle.opacity
                });
            });
            (0, $2bf82c0980125b62$export$e51187539ff11209)(itemGroup, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
        });
        this._data = data;
    };
    RadarView.prototype.remove = function() {
        this.group.removeAll();
        this._data = null;
    };
    RadarView.type = 'radar';
    return RadarView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $1fc9e69f4602cced$export$2e2bcd8739ae039 = $1fc9e69f4602cced$var$RadarView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $3895e6b103877b59$var$RadarSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(RadarSeriesModel, _super);
    function RadarSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = RadarSeriesModel.type;
        _this.hasSymbolVisual = true;
        return _this;
    }
    // Overwrite
    RadarSeriesModel.prototype.init = function(option) {
        _super.prototype.init.apply(this, arguments);
        // Enable legend selection for each data item
        // Use a function instead of direct access because data reference may changed
        this.legendVisualProvider = new (0, $cf24728fc17c4ab6$export$2e2bcd8739ae039)($7a1bd9c2710fea0d$export$2385a24977818dd0(this.getData, this), $7a1bd9c2710fea0d$export$2385a24977818dd0(this.getRawData, this));
    };
    RadarSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $7e5c3511527c9907$export$2e2bcd8739ae039)(this, {
            generateCoord: 'indicator_',
            generateCoordCount: Infinity
        });
    };
    RadarSeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        var data = this.getData();
        var coordSys = this.coordinateSystem;
        var indicatorAxes = coordSys.getIndicatorAxes();
        var name = this.getData().getName(dataIndex);
        var nameToDisplay = name === '' ? this.name : name;
        var markerColor = (0, $d5ab84c08d6657ec$export$ea15628039c0fa93)(this, dataIndex);
        return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)('section', {
            header: nameToDisplay,
            sortBlocks: true,
            blocks: $7a1bd9c2710fea0d$export$871de8747c9eaa88(indicatorAxes, function(axis) {
                var val = data.get(data.mapDimension(axis.dim), dataIndex);
                return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)('nameValue', {
                    markerType: 'subItem',
                    markerColor: markerColor,
                    name: axis.name,
                    value: val,
                    sortParam: val
                });
            })
        });
    };
    RadarSeriesModel.prototype.getTooltipPosition = function(dataIndex) {
        if (dataIndex != null) {
            var data_1 = this.getData();
            var coordSys = this.coordinateSystem;
            var values = data_1.getValues($7a1bd9c2710fea0d$export$871de8747c9eaa88(coordSys.dimensions, function(dim) {
                return data_1.mapDimension(dim);
            }), dataIndex);
            for(var i = 0, len = values.length; i < len; i++)if (!isNaN(values[i])) {
                var indicatorAxes = coordSys.getIndicatorAxes();
                return coordSys.coordToPoint(indicatorAxes[i].dataToCoord(values[i]), i);
            }
        }
    };
    RadarSeriesModel.type = 'series.radar';
    RadarSeriesModel.dependencies = [
        'radar'
    ];
    RadarSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        colorBy: 'data',
        coordinateSystem: 'radar',
        legendHoverLink: true,
        radarIndex: 0,
        lineStyle: {
            width: 2,
            type: 'solid',
            join: 'round'
        },
        label: {
            position: 'top'
        },
        // areaStyle: {
        // },
        // itemStyle: {}
        symbolSize: 8
    };
    return RadarSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $3895e6b103877b59$export$2e2bcd8739ae039 = $3895e6b103877b59$var$RadarSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $19c8b0d3f7411edb$var$valueAxisDefault = (0, $ad861b9162f24222$export$2e2bcd8739ae039).value;
function $19c8b0d3f7411edb$var$defaultsShow(opt, show) {
    return $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
        show: show
    }, opt);
}
var $19c8b0d3f7411edb$var$RadarModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(RadarModel, _super);
    function RadarModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = RadarModel.type;
        return _this;
    }
    RadarModel.prototype.optionUpdated = function() {
        var boundaryGap = this.get('boundaryGap');
        var splitNumber = this.get('splitNumber');
        var scale = this.get('scale');
        var axisLine = this.get('axisLine');
        var axisTick = this.get('axisTick');
        // let axisType = this.get('axisType');
        var axisLabel = this.get('axisLabel');
        var nameTextStyle = this.get('axisName');
        var showName = this.get([
            'axisName',
            'show'
        ]);
        var nameFormatter = this.get([
            'axisName',
            'formatter'
        ]);
        var nameGap = this.get('axisNameGap');
        var triggerEvent = this.get('triggerEvent');
        var indicatorModels = $7a1bd9c2710fea0d$export$871de8747c9eaa88(this.get('indicator') || [], function(indicatorOpt) {
            // PENDING
            if (indicatorOpt.max != null && indicatorOpt.max > 0 && !indicatorOpt.min) indicatorOpt.min = 0;
            else if (indicatorOpt.min != null && indicatorOpt.min < 0 && !indicatorOpt.max) indicatorOpt.max = 0;
            var iNameTextStyle = nameTextStyle;
            if (indicatorOpt.color != null) iNameTextStyle = $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                color: indicatorOpt.color
            }, nameTextStyle);
            // Use same configuration
            var innerIndicatorOpt = $7a1bd9c2710fea0d$export$4950aa0f605343fb($7a1bd9c2710fea0d$export$9cd59f9826255e47(indicatorOpt), {
                boundaryGap: boundaryGap,
                splitNumber: splitNumber,
                scale: scale,
                axisLine: axisLine,
                axisTick: axisTick,
                // axisType: axisType,
                axisLabel: axisLabel,
                // Compatible with 2 and use text
                name: indicatorOpt.text,
                showName: showName,
                nameLocation: 'end',
                nameGap: nameGap,
                // min: 0,
                nameTextStyle: iNameTextStyle,
                triggerEvent: triggerEvent
            }, false);
            if ($7a1bd9c2710fea0d$export$844ec244b1367d54(nameFormatter)) {
                var indName = innerIndicatorOpt.name;
                innerIndicatorOpt.name = nameFormatter.replace('{value}', indName != null ? indName : '');
            } else if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(nameFormatter)) innerIndicatorOpt.name = nameFormatter(innerIndicatorOpt.name, innerIndicatorOpt);
            var model = new (0, $6818646a97528290$export$2e2bcd8739ae039)(innerIndicatorOpt, null, this.ecModel);
            $7a1bd9c2710fea0d$export$e36fc9d62a853069(model, (0, $3449fd4c0590d99e$export$5c54b224726edb5a).prototype);
            // For triggerEvent.
            model.mainType = 'radar';
            model.componentIndex = this.componentIndex;
            return model;
        }, this);
        this._indicatorModels = indicatorModels;
    };
    RadarModel.prototype.getIndicatorModels = function() {
        return this._indicatorModels;
    };
    RadarModel.type = 'radar';
    RadarModel.defaultOption = {
        // zlevel: 0,
        z: 0,
        center: [
            '50%',
            '50%'
        ],
        radius: '75%',
        startAngle: 90,
        axisName: {
            show: true
        },
        boundaryGap: [
            0,
            0
        ],
        splitNumber: 5,
        axisNameGap: 15,
        scale: false,
        // Polygon or circle
        shape: 'polygon',
        axisLine: $7a1bd9c2710fea0d$export$4950aa0f605343fb({
            lineStyle: {
                color: '#bbb'
            }
        }, $19c8b0d3f7411edb$var$valueAxisDefault.axisLine),
        axisLabel: $19c8b0d3f7411edb$var$defaultsShow($19c8b0d3f7411edb$var$valueAxisDefault.axisLabel, false),
        axisTick: $19c8b0d3f7411edb$var$defaultsShow($19c8b0d3f7411edb$var$valueAxisDefault.axisTick, false),
        // axisType: 'value',
        splitLine: $19c8b0d3f7411edb$var$defaultsShow($19c8b0d3f7411edb$var$valueAxisDefault.splitLine, true),
        splitArea: $19c8b0d3f7411edb$var$defaultsShow($19c8b0d3f7411edb$var$valueAxisDefault.splitArea, true),
        // {text, min, max}
        indicator: []
    };
    return RadarModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $19c8b0d3f7411edb$export$2e2bcd8739ae039 = $19c8b0d3f7411edb$var$RadarModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $9604af4c260571a1$var$axisBuilderAttrs = [
    'axisLine',
    'axisTickLabel',
    'axisName'
];
var $9604af4c260571a1$var$RadarView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(RadarView, _super);
    function RadarView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = RadarView.type;
        return _this;
    }
    RadarView.prototype.render = function(radarModel, ecModel, api) {
        var group = this.group;
        group.removeAll();
        this._buildAxes(radarModel);
        this._buildSplitLineAndArea(radarModel);
    };
    RadarView.prototype._buildAxes = function(radarModel) {
        var radar = radarModel.coordinateSystem;
        var indicatorAxes = radar.getIndicatorAxes();
        var axisBuilders = $7a1bd9c2710fea0d$export$871de8747c9eaa88(indicatorAxes, function(indicatorAxis) {
            var axisName = indicatorAxis.model.get('showName') ? indicatorAxis.name : ''; // hide name
            var axisBuilder = new (0, $dfe15f745e1c3c2b$export$2e2bcd8739ae039)(indicatorAxis.model, {
                axisName: axisName,
                position: [
                    radar.cx,
                    radar.cy
                ],
                rotation: indicatorAxis.angle,
                labelDirection: -1,
                tickDirection: -1,
                nameDirection: 1
            });
            return axisBuilder;
        });
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(axisBuilders, function(axisBuilder) {
            $7a1bd9c2710fea0d$export$79b2f7037acddd43($9604af4c260571a1$var$axisBuilderAttrs, axisBuilder.add, axisBuilder);
            this.group.add(axisBuilder.getGroup());
        }, this);
    };
    RadarView.prototype._buildSplitLineAndArea = function(radarModel) {
        var radar = radarModel.coordinateSystem;
        var indicatorAxes = radar.getIndicatorAxes();
        if (!indicatorAxes.length) return;
        var shape = radarModel.get('shape');
        var splitLineModel = radarModel.getModel('splitLine');
        var splitAreaModel = radarModel.getModel('splitArea');
        var lineStyleModel = splitLineModel.getModel('lineStyle');
        var areaStyleModel = splitAreaModel.getModel('areaStyle');
        var showSplitLine = splitLineModel.get('show');
        var showSplitArea = splitAreaModel.get('show');
        var splitLineColors = lineStyleModel.get('color');
        var splitAreaColors = areaStyleModel.get('color');
        var splitLineColorsArr = $7a1bd9c2710fea0d$export$43bee75e5e14138e(splitLineColors) ? splitLineColors : [
            splitLineColors
        ];
        var splitAreaColorsArr = $7a1bd9c2710fea0d$export$43bee75e5e14138e(splitAreaColors) ? splitAreaColors : [
            splitAreaColors
        ];
        var splitLines = [];
        var splitAreas = [];
        function getColorIndex(areaOrLine, areaOrLineColorList, idx) {
            var colorIndex = idx % areaOrLineColorList.length;
            areaOrLine[colorIndex] = areaOrLine[colorIndex] || [];
            return colorIndex;
        }
        if (shape === 'circle') {
            var ticksRadius = indicatorAxes[0].getTicksCoords();
            var cx = radar.cx;
            var cy = radar.cy;
            for(var i = 0; i < ticksRadius.length; i++){
                if (showSplitLine) {
                    var colorIndex = getColorIndex(splitLines, splitLineColorsArr, i);
                    splitLines[colorIndex].push(new $1e68d8727773abb7$export$2e2bcd8739ae039({
                        shape: {
                            cx: cx,
                            cy: cy,
                            r: ticksRadius[i].coord
                        }
                    }));
                }
                if (showSplitArea && i < ticksRadius.length - 1) {
                    var colorIndex = getColorIndex(splitAreas, splitAreaColorsArr, i);
                    splitAreas[colorIndex].push(new $9da0cbfd3f86fdc1$export$2e2bcd8739ae039({
                        shape: {
                            cx: cx,
                            cy: cy,
                            r0: ticksRadius[i].coord,
                            r: ticksRadius[i + 1].coord
                        }
                    }));
                }
            }
        } else {
            var realSplitNumber_1;
            var axesTicksPoints = $7a1bd9c2710fea0d$export$871de8747c9eaa88(indicatorAxes, function(indicatorAxis, idx) {
                var ticksCoords = indicatorAxis.getTicksCoords();
                realSplitNumber_1 = realSplitNumber_1 == null ? ticksCoords.length - 1 : Math.min(ticksCoords.length - 1, realSplitNumber_1);
                return $7a1bd9c2710fea0d$export$871de8747c9eaa88(ticksCoords, function(tickCoord) {
                    return radar.coordToPoint(tickCoord.coord, idx);
                });
            });
            var prevPoints = [];
            for(var i = 0; i <= realSplitNumber_1; i++){
                var points = [];
                for(var j = 0; j < indicatorAxes.length; j++)points.push(axesTicksPoints[j][i]);
                // Close
                if (points[0]) points.push(points[0].slice());
                if (showSplitLine) {
                    var colorIndex = getColorIndex(splitLines, splitLineColorsArr, i);
                    splitLines[colorIndex].push(new $d28119f30e6bb670$export$2e2bcd8739ae039({
                        shape: {
                            points: points
                        }
                    }));
                }
                if (showSplitArea && prevPoints) {
                    var colorIndex = getColorIndex(splitAreas, splitAreaColorsArr, i - 1);
                    splitAreas[colorIndex].push(new $51acf033123e1a30$export$2e2bcd8739ae039({
                        shape: {
                            points: points.concat(prevPoints)
                        }
                    }));
                }
                prevPoints = points.slice().reverse();
            }
        }
        var lineStyle = lineStyleModel.getLineStyle();
        var areaStyle = areaStyleModel.getAreaStyle();
        // Add splitArea before splitLine
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(splitAreas, function(splitAreas, idx) {
            this.group.add($5b455ae6f843ac47$export$7b1dd269fbc4e903(splitAreas, {
                style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                    stroke: 'none',
                    fill: splitAreaColorsArr[idx % splitAreaColorsArr.length]
                }, areaStyle),
                silent: true
            }));
        }, this);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(splitLines, function(splitLines, idx) {
            this.group.add($5b455ae6f843ac47$export$7b1dd269fbc4e903(splitLines, {
                style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                    fill: 'none',
                    stroke: splitLineColorsArr[idx % splitLineColorsArr.length]
                }, lineStyle),
                silent: true
            }));
        }, this);
    };
    RadarView.type = 'radar';
    return RadarView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $9604af4c260571a1$export$2e2bcd8739ae039 = $9604af4c260571a1$var$RadarView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // TODO clockwise
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $5d6acabddf826472$var$IndicatorAxis = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(IndicatorAxis, _super);
    function IndicatorAxis(dim, scale, radiusExtent) {
        var _this = _super.call(this, dim, scale, radiusExtent) || this;
        _this.type = 'value';
        _this.angle = 0;
        _this.name = '';
        return _this;
    }
    return IndicatorAxis;
}((0, $c2b1efffe5ae3f42$export$2e2bcd8739ae039));
var $5d6acabddf826472$export$2e2bcd8739ae039 = $5d6acabddf826472$var$IndicatorAxis;





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $0591b52263f31374$var$mathLog = Math.log;
function $0591b52263f31374$export$c0b3be0e9eb0c2d9(scale, axisModel, alignToScale) {
    var intervalScaleProto = (0, $dddb89ade16db3d5$export$2e2bcd8739ae039).prototype;
    // NOTE: There is a precondition for log scale  here:
    // In log scale we store _interval and _extent of exponent value.
    // So if we use the method of InternalScale to set/get these data.
    // It process the exponent value, which is linear and what we want here.
    var alignToTicks = intervalScaleProto.getTicks.call(alignToScale);
    var alignToNicedTicks = intervalScaleProto.getTicks.call(alignToScale, true);
    var alignToSplitNumber = alignToTicks.length - 1;
    var alignToInterval = intervalScaleProto.getInterval.call(alignToScale);
    var scaleExtent = (0, $2d646e51cc34f840$export$9c0ba8df7eb7b328)(scale, axisModel);
    var rawExtent = scaleExtent.extent;
    var isMinFixed = scaleExtent.fixMin;
    var isMaxFixed = scaleExtent.fixMax;
    if (scale.type === 'log') {
        var logBase = $0591b52263f31374$var$mathLog(scale.base);
        rawExtent = [
            $0591b52263f31374$var$mathLog(rawExtent[0]) / logBase,
            $0591b52263f31374$var$mathLog(rawExtent[1]) / logBase
        ];
    }
    scale.setExtent(rawExtent[0], rawExtent[1]);
    scale.calcNiceExtent({
        splitNumber: alignToSplitNumber,
        fixMin: isMinFixed,
        fixMax: isMaxFixed
    });
    var extent = intervalScaleProto.getExtent.call(scale);
    // Need to update the rawExtent.
    // Because value in rawExtent may be not parsed. e.g. 'dataMin', 'dataMax'
    if (isMinFixed) rawExtent[0] = extent[0];
    if (isMaxFixed) rawExtent[1] = extent[1];
    var interval = intervalScaleProto.getInterval.call(scale);
    var min = rawExtent[0];
    var max = rawExtent[1];
    if (isMinFixed && isMaxFixed) // User set min, max, divide to get new interval
    interval = (max - min) / alignToSplitNumber;
    else if (isMinFixed) {
        max = rawExtent[0] + interval * alignToSplitNumber;
        // User set min, expand extent on the other side
        while(max < rawExtent[1] && isFinite(max) && isFinite(rawExtent[1])){
            interval = (0, $60f7f1f3e3996637$export$f39031e8422f329d)(interval);
            max = rawExtent[0] + interval * alignToSplitNumber;
        }
    } else if (isMaxFixed) {
        // User set max, expand extent on the other side
        min = rawExtent[1] - interval * alignToSplitNumber;
        while(min > rawExtent[0] && isFinite(min) && isFinite(rawExtent[0])){
            interval = (0, $60f7f1f3e3996637$export$f39031e8422f329d)(interval);
            min = rawExtent[1] - interval * alignToSplitNumber;
        }
    } else {
        var nicedSplitNumber = scale.getTicks().length - 1;
        if (nicedSplitNumber > alignToSplitNumber) interval = (0, $60f7f1f3e3996637$export$f39031e8422f329d)(interval);
        var range = interval * alignToSplitNumber;
        max = Math.ceil(rawExtent[1] / interval) * interval;
        min = (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(max - range);
        // Not change the result that crossing zero.
        if (min < 0 && rawExtent[0] >= 0) {
            min = 0;
            max = (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(range);
        } else if (max > 0 && rawExtent[1] <= 0) {
            max = 0;
            min = -(0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(range);
        }
    }
    // Adjust min, max based on the extent of alignTo. When min or max is set in alignTo scale
    var t0 = (alignToTicks[0].value - alignToNicedTicks[0].value) / alignToInterval;
    var t1 = (alignToTicks[alignToSplitNumber].value - alignToNicedTicks[alignToSplitNumber].value) / alignToInterval;
    // NOTE: Must in setExtent -> setInterval -> setNiceExtent order.
    intervalScaleProto.setExtent.call(scale, min + interval * t0, max + interval * t1);
    intervalScaleProto.setInterval.call(scale, interval);
    if (t0 || t1) intervalScaleProto.setNiceExtent.call(scale, min + interval, max - interval);
    var ticks;
}


var $11c0ac35da5ff3e8$var$Radar = /** @class */ function() {
    function Radar(radarModel, ecModel, api) {
        /**
     *
     * Radar dimensions
     */ this.dimensions = [];
        this._model = radarModel;
        this._indicatorAxes = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(radarModel.getIndicatorModels(), function(indicatorModel, idx) {
            var dim = 'indicator_' + idx;
            var indicatorAxis = new (0, $5d6acabddf826472$export$2e2bcd8739ae039)(dim, new (0, $dddb89ade16db3d5$export$2e2bcd8739ae039)());
            indicatorAxis.name = indicatorModel.get('name');
            // Inject model and axis
            indicatorAxis.model = indicatorModel;
            indicatorModel.axis = indicatorAxis;
            this.dimensions.push(dim);
            return indicatorAxis;
        }, this);
        this.resize(radarModel, api);
    }
    Radar.prototype.getIndicatorAxes = function() {
        return this._indicatorAxes;
    };
    Radar.prototype.dataToPoint = function(value, indicatorIndex) {
        var indicatorAxis = this._indicatorAxes[indicatorIndex];
        return this.coordToPoint(indicatorAxis.dataToCoord(value), indicatorIndex);
    };
    // TODO: API should be coordToPoint([coord, indicatorIndex])
    Radar.prototype.coordToPoint = function(coord, indicatorIndex) {
        var indicatorAxis = this._indicatorAxes[indicatorIndex];
        var angle = indicatorAxis.angle;
        var x = this.cx + coord * Math.cos(angle);
        var y = this.cy - coord * Math.sin(angle);
        return [
            x,
            y
        ];
    };
    Radar.prototype.pointToData = function(pt) {
        var dx = pt[0] - this.cx;
        var dy = pt[1] - this.cy;
        var radius = Math.sqrt(dx * dx + dy * dy);
        dx /= radius;
        dy /= radius;
        var radian = Math.atan2(-dy, dx);
        // Find the closest angle
        // FIXME index can calculated directly
        var minRadianDiff = Infinity;
        var closestAxis;
        var closestAxisIdx = -1;
        for(var i = 0; i < this._indicatorAxes.length; i++){
            var indicatorAxis = this._indicatorAxes[i];
            var diff = Math.abs(radian - indicatorAxis.angle);
            if (diff < minRadianDiff) {
                closestAxis = indicatorAxis;
                closestAxisIdx = i;
                minRadianDiff = diff;
            }
        }
        return [
            closestAxisIdx,
            +(closestAxis && closestAxis.coordToData(radius))
        ];
    };
    Radar.prototype.resize = function(radarModel, api) {
        var center = radarModel.get('center');
        var viewWidth = api.getWidth();
        var viewHeight = api.getHeight();
        var viewSize = Math.min(viewWidth, viewHeight) / 2;
        this.cx = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(center[0], viewWidth);
        this.cy = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(center[1], viewHeight);
        this.startAngle = radarModel.get('startAngle') * Math.PI / 180;
        // radius may be single value like `20`, `'80%'`, or array like `[10, '80%']`
        var radius = radarModel.get('radius');
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(radius) || (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(radius)) radius = [
            0,
            radius
        ];
        this.r0 = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(radius[0], viewSize);
        this.r = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(radius[1], viewSize);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._indicatorAxes, function(indicatorAxis, idx) {
            indicatorAxis.setExtent(this.r0, this.r);
            var angle = this.startAngle + idx * Math.PI * 2 / this._indicatorAxes.length;
            // Normalize to [-PI, PI]
            angle = Math.atan2(Math.sin(angle), Math.cos(angle));
            indicatorAxis.angle = angle;
        }, this);
    };
    Radar.prototype.update = function(ecModel, api) {
        var indicatorAxes = this._indicatorAxes;
        var radarModel = this._model;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(indicatorAxes, function(indicatorAxis) {
            indicatorAxis.scale.setExtent(Infinity, -Infinity);
        });
        ecModel.eachSeriesByType('radar', function(radarSeries, idx) {
            if (radarSeries.get('coordinateSystem') !== 'radar' || ecModel.getComponent('radar', radarSeries.get('radarIndex')) !== radarModel) return;
            var data = radarSeries.getData();
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(indicatorAxes, function(indicatorAxis) {
                indicatorAxis.scale.unionExtentFromData(data, data.mapDimension(indicatorAxis.dim));
            });
        }, this);
        var splitNumber = radarModel.get('splitNumber');
        var dummyScale = new (0, $dddb89ade16db3d5$export$2e2bcd8739ae039)();
        dummyScale.setExtent(0, splitNumber);
        dummyScale.setInterval(1);
        // Force all the axis fixing the maxSplitNumber.
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(indicatorAxes, function(indicatorAxis, idx) {
            (0, $0591b52263f31374$export$c0b3be0e9eb0c2d9)(indicatorAxis.scale, indicatorAxis.model, dummyScale);
        });
    };
    Radar.prototype.convertToPixel = function(ecModel, finder, value) {
        console.warn('Not implemented.');
        return null;
    };
    Radar.prototype.convertFromPixel = function(ecModel, finder, pixel) {
        console.warn('Not implemented.');
        return null;
    };
    Radar.prototype.containPoint = function(point) {
        console.warn('Not implemented.');
        return false;
    };
    Radar.create = function(ecModel, api) {
        var radarList = [];
        ecModel.eachComponent('radar', function(radarModel) {
            var radar = new Radar(radarModel, ecModel, api);
            radarList.push(radar);
            radarModel.coordinateSystem = radar;
        });
        ecModel.eachSeriesByType('radar', function(radarSeries) {
            if (radarSeries.get('coordinateSystem') === 'radar') // Inject coordinate system
            // @ts-ignore
            radarSeries.coordinateSystem = radarList[radarSeries.get('radarIndex') || 0];
        });
        return radarList;
    };
    /**
   * Radar dimensions is based on the data
   */ Radar.dimensions = [];
    return Radar;
}();
var $11c0ac35da5ff3e8$export$2e2bcd8739ae039 = $11c0ac35da5ff3e8$var$Radar;


function $82e3ee94e7369a99$export$4b3e715f166fdd78(registers) {
    registers.registerCoordinateSystem('radar', (0, $11c0ac35da5ff3e8$export$2e2bcd8739ae039));
    registers.registerComponentModel((0, $19c8b0d3f7411edb$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $9604af4c260571a1$export$2e2bcd8739ae039));
    registers.registerVisual({
        seriesType: 'radar',
        reset: function(seriesModel) {
            var data = seriesModel.getData();
            // itemVisual symbol is for selected data
            data.each(function(idx) {
                data.setItemVisual(idx, 'legendIcon', 'roundRect');
            });
            // visual is for unselected data
            data.setVisual('legendIcon', 'roundRect');
        }
    });
}


function $a8120efef8bcaaa0$export$4b3e715f166fdd78(registers) {
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $82e3ee94e7369a99$export$4b3e715f166fdd78));
    registers.registerChartView((0, $1fc9e69f4602cced$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $3895e6b103877b59$export$2e2bcd8739ae039));
    registers.registerLayout((0, $bec68b02ebcf9063$export$2e2bcd8739ae039));
    registers.registerProcessor((0, $e11a533bf70b759c$export$2e2bcd8739ae039)('radar'));
    registers.registerPreprocessor((0, $506480c8f28f74be$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $58364a2c82b0ec77$var$SankeyPathShape = /** @class */ function() {
    function SankeyPathShape() {
        this.x1 = 0;
        this.y1 = 0;
        this.x2 = 0;
        this.y2 = 0;
        this.cpx1 = 0;
        this.cpy1 = 0;
        this.cpx2 = 0;
        this.cpy2 = 0;
        this.extent = 0;
    }
    return SankeyPathShape;
}();
var $58364a2c82b0ec77$var$SankeyPath = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SankeyPath, _super);
    function SankeyPath(opts) {
        return _super.call(this, opts) || this;
    }
    SankeyPath.prototype.getDefaultShape = function() {
        return new $58364a2c82b0ec77$var$SankeyPathShape();
    };
    SankeyPath.prototype.buildPath = function(ctx, shape) {
        var extent = shape.extent;
        ctx.moveTo(shape.x1, shape.y1);
        ctx.bezierCurveTo(shape.cpx1, shape.cpy1, shape.cpx2, shape.cpy2, shape.x2, shape.y2);
        if (shape.orient === 'vertical') {
            ctx.lineTo(shape.x2 + extent, shape.y2);
            ctx.bezierCurveTo(shape.cpx2 + extent, shape.cpy2, shape.cpx1 + extent, shape.cpy1, shape.x1 + extent, shape.y1);
        } else {
            ctx.lineTo(shape.x2, shape.y2 + extent);
            ctx.bezierCurveTo(shape.cpx2, shape.cpy2 + extent, shape.cpx1, shape.cpy1 + extent, shape.x1, shape.y1 + extent);
        }
        ctx.closePath();
    };
    SankeyPath.prototype.highlight = function() {
        (0, $2bf82c0980125b62$export$b2d02638cc34c042)(this);
    };
    SankeyPath.prototype.downplay = function() {
        (0, $2bf82c0980125b62$export$11be6f716239ac55)(this);
    };
    return SankeyPath;
}($b02ffe7acd508c08$export$2e2bcd8739ae039);
var $58364a2c82b0ec77$var$SankeyView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SankeyView, _super);
    function SankeyView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SankeyView.type;
        _this._focusAdjacencyDisabled = false;
        return _this;
    }
    SankeyView.prototype.render = function(seriesModel, ecModel, api) {
        var sankeyView = this;
        var graph = seriesModel.getGraph();
        var group = this.group;
        var layoutInfo = seriesModel.layoutInfo;
        // view width
        var width = layoutInfo.width;
        // view height
        var height = layoutInfo.height;
        var nodeData = seriesModel.getData();
        var edgeData = seriesModel.getData('edge');
        var orient = seriesModel.get('orient');
        this._model = seriesModel;
        group.removeAll();
        group.x = layoutInfo.x;
        group.y = layoutInfo.y;
        // generate a bezire Curve for each edge
        graph.eachEdge(function(edge) {
            var curve = new $58364a2c82b0ec77$var$SankeyPath();
            var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(curve);
            ecData.dataIndex = edge.dataIndex;
            ecData.seriesIndex = seriesModel.seriesIndex;
            ecData.dataType = 'edge';
            var edgeModel = edge.getModel();
            var lineStyleModel = edgeModel.getModel('lineStyle');
            var curvature = lineStyleModel.get('curveness');
            var n1Layout = edge.node1.getLayout();
            var node1Model = edge.node1.getModel();
            var dragX1 = node1Model.get('localX');
            var dragY1 = node1Model.get('localY');
            var n2Layout = edge.node2.getLayout();
            var node2Model = edge.node2.getModel();
            var dragX2 = node2Model.get('localX');
            var dragY2 = node2Model.get('localY');
            var edgeLayout = edge.getLayout();
            var x1;
            var y1;
            var x2;
            var y2;
            var cpx1;
            var cpy1;
            var cpx2;
            var cpy2;
            curve.shape.extent = Math.max(1, edgeLayout.dy);
            curve.shape.orient = orient;
            if (orient === 'vertical') {
                x1 = (dragX1 != null ? dragX1 * width : n1Layout.x) + edgeLayout.sy;
                y1 = (dragY1 != null ? dragY1 * height : n1Layout.y) + n1Layout.dy;
                x2 = (dragX2 != null ? dragX2 * width : n2Layout.x) + edgeLayout.ty;
                y2 = dragY2 != null ? dragY2 * height : n2Layout.y;
                cpx1 = x1;
                cpy1 = y1 * (1 - curvature) + y2 * curvature;
                cpx2 = x2;
                cpy2 = y1 * curvature + y2 * (1 - curvature);
            } else {
                x1 = (dragX1 != null ? dragX1 * width : n1Layout.x) + n1Layout.dx;
                y1 = (dragY1 != null ? dragY1 * height : n1Layout.y) + edgeLayout.sy;
                x2 = dragX2 != null ? dragX2 * width : n2Layout.x;
                y2 = (dragY2 != null ? dragY2 * height : n2Layout.y) + edgeLayout.ty;
                cpx1 = x1 * (1 - curvature) + x2 * curvature;
                cpy1 = y1;
                cpx2 = x1 * curvature + x2 * (1 - curvature);
                cpy2 = y2;
            }
            curve.setShape({
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2,
                cpx1: cpx1,
                cpy1: cpy1,
                cpx2: cpx2,
                cpy2: cpy2
            });
            curve.useStyle(lineStyleModel.getItemStyle());
            // Special color, use source node color or target node color
            $58364a2c82b0ec77$var$applyCurveStyle(curve.style, orient, edge);
            var defaultEdgeLabelText = "" + edgeModel.get('value');
            var edgeLabelStateModels = (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(edgeModel, 'edgeLabel');
            (0, $6800dfcb6e1e2a44$export$9a13992917966657)(curve, edgeLabelStateModels, {
                labelFetcher: {
                    getFormattedLabel: function(dataIndex, stateName, dataType, labelDimIndex, formatter, extendParams) {
                        return seriesModel.getFormattedLabel(dataIndex, stateName, 'edge', labelDimIndex, // ensure edgeLabel formatter is provided
                        // to prevent the inheritance from `label.formatter` of the series
                        (0, $7a1bd9c2710fea0d$export$2e94551289abb95b)(formatter, edgeLabelStateModels.normal && edgeLabelStateModels.normal.get('formatter'), defaultEdgeLabelText), extendParams);
                    }
                },
                labelDataIndex: edge.dataIndex,
                defaultText: defaultEdgeLabelText
            });
            curve.setTextConfig({
                position: 'inside'
            });
            var emphasisModel = edgeModel.getModel('emphasis');
            (0, $2bf82c0980125b62$export$48b68047d330bbc9)(curve, edgeModel, 'lineStyle', function(model) {
                var style = model.getItemStyle();
                $58364a2c82b0ec77$var$applyCurveStyle(style, orient, edge);
                return style;
            });
            group.add(curve);
            edgeData.setItemGraphicEl(edge.dataIndex, curve);
            var focus = emphasisModel.get('focus');
            (0, $2bf82c0980125b62$export$e51187539ff11209)(curve, focus === 'adjacency' ? edge.getAdjacentDataIndices() : focus === 'trajectory' ? edge.getTrajectoryDataIndices() : focus, emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
        });
        // Generate a rect for each node
        graph.eachNode(function(node) {
            var layout = node.getLayout();
            var itemModel = node.getModel();
            var dragX = itemModel.get('localX');
            var dragY = itemModel.get('localY');
            var emphasisModel = itemModel.getModel('emphasis');
            var borderRadius = itemModel.get([
                'itemStyle',
                'borderRadius'
            ]) || 0;
            var rect = new $419e5ff2f303755e$export$2e2bcd8739ae039({
                shape: {
                    x: dragX != null ? dragX * width : layout.x,
                    y: dragY != null ? dragY * height : layout.y,
                    width: layout.dx,
                    height: layout.dy,
                    r: borderRadius
                },
                style: itemModel.getModel('itemStyle').getItemStyle(),
                z2: 10
            });
            (0, $6800dfcb6e1e2a44$export$9a13992917966657)(rect, (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(itemModel), {
                labelFetcher: {
                    getFormattedLabel: function(dataIndex, stateName) {
                        return seriesModel.getFormattedLabel(dataIndex, stateName, 'node');
                    }
                },
                labelDataIndex: node.dataIndex,
                defaultText: node.id
            });
            rect.disableLabelAnimation = true;
            rect.setStyle('fill', node.getVisual('color'));
            rect.setStyle('decal', node.getVisual('style').decal);
            (0, $2bf82c0980125b62$export$48b68047d330bbc9)(rect, itemModel);
            group.add(rect);
            nodeData.setItemGraphicEl(node.dataIndex, rect);
            (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(rect).dataType = 'node';
            var focus = emphasisModel.get('focus');
            (0, $2bf82c0980125b62$export$e51187539ff11209)(rect, focus === 'adjacency' ? node.getAdjacentDataIndices() : focus === 'trajectory' ? node.getTrajectoryDataIndices() : focus, emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
        });
        nodeData.eachItemGraphicEl(function(el, dataIndex) {
            var itemModel = nodeData.getItemModel(dataIndex);
            if (itemModel.get('draggable')) {
                el.drift = function(dx, dy) {
                    sankeyView._focusAdjacencyDisabled = true;
                    this.shape.x += dx;
                    this.shape.y += dy;
                    this.dirty();
                    api.dispatchAction({
                        type: 'dragNode',
                        seriesId: seriesModel.id,
                        dataIndex: nodeData.getRawIndex(dataIndex),
                        localX: this.shape.x / width,
                        localY: this.shape.y / height
                    });
                };
                el.ondragend = function() {
                    sankeyView._focusAdjacencyDisabled = false;
                };
                el.draggable = true;
                el.cursor = 'move';
            }
        });
        if (!this._data && seriesModel.isAnimationEnabled()) group.setClipPath($58364a2c82b0ec77$var$createGridClipShape(group.getBoundingRect(), seriesModel, function() {
            group.removeClipPath();
        }));
        this._data = seriesModel.getData();
    };
    SankeyView.prototype.dispose = function() {};
    SankeyView.type = 'sankey';
    return SankeyView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
/**
 * Special color, use source node color or target node color
 * @param curveProps curve's style to parse
 * @param orient direction
 * @param edge current curve data
 */ function $58364a2c82b0ec77$var$applyCurveStyle(curveProps, orient, edge) {
    switch(curveProps.fill){
        case 'source':
            curveProps.fill = edge.node1.getVisual('color');
            curveProps.decal = edge.node1.getVisual('style').decal;
            break;
        case 'target':
            curveProps.fill = edge.node2.getVisual('color');
            curveProps.decal = edge.node2.getVisual('style').decal;
            break;
        case 'gradient':
            var sourceColor = edge.node1.getVisual('color');
            var targetColor = edge.node2.getVisual('color');
            if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(sourceColor) && (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(targetColor)) curveProps.fill = new $cf44c01491b58e53$export$2e2bcd8739ae039(0, 0, +(orient === 'horizontal'), +(orient === 'vertical'), [
                {
                    color: sourceColor,
                    offset: 0
                },
                {
                    color: targetColor,
                    offset: 1
                }
            ]);
    }
}
// Add animation to the view
function $58364a2c82b0ec77$var$createGridClipShape(rect, seriesModel, cb) {
    var rectEl = new $419e5ff2f303755e$export$2e2bcd8739ae039({
        shape: {
            x: rect.x - 10,
            y: rect.y - 10,
            width: 0,
            height: rect.height + 20
        }
    });
    $8b353638fbedfefa$export$a121566aadcfe021(rectEl, {
        shape: {
            width: rect.width + 20
        }
    }, seriesModel, cb);
    return rectEl;
}
var $58364a2c82b0ec77$export$2e2bcd8739ae039 = $58364a2c82b0ec77$var$SankeyView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $f213d63e219306d2$var$SankeySeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SankeySeriesModel, _super);
    function SankeySeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SankeySeriesModel.type;
        return _this;
    }
    /**
   * Init a graph data structure from data in option series
   */ SankeySeriesModel.prototype.getInitialData = function(option, ecModel) {
        var links = option.edges || option.links || [];
        var nodes = option.data || option.nodes || [];
        var levels = option.levels || [];
        this.levelModels = [];
        var levelModels = this.levelModels;
        for(var i = 0; i < levels.length; i++)if (levels[i].depth != null && levels[i].depth >= 0) levelModels[levels[i].depth] = new (0, $6818646a97528290$export$2e2bcd8739ae039)(levels[i], this, ecModel);
        var graph = (0, $09eb5d193a1ecbce$export$2e2bcd8739ae039)(nodes, links, this, true, beforeLink);
        return graph.data;
        function beforeLink(nodeData, edgeData) {
            nodeData.wrapMethod('getItemModel', function(model, idx) {
                var seriesModel = model.parentModel;
                var layout = seriesModel.getData().getItemLayout(idx);
                if (layout) {
                    var nodeDepth = layout.depth;
                    var levelModel = seriesModel.levelModels[nodeDepth];
                    if (levelModel) model.parentModel = levelModel;
                }
                return model;
            });
            edgeData.wrapMethod('getItemModel', function(model, idx) {
                var seriesModel = model.parentModel;
                var edge = seriesModel.getGraph().getEdgeByIndex(idx);
                var layout = edge.node1.getLayout();
                if (layout) {
                    var depth = layout.depth;
                    var levelModel = seriesModel.levelModels[depth];
                    if (levelModel) model.parentModel = levelModel;
                }
                return model;
            });
        }
    };
    SankeySeriesModel.prototype.setNodePosition = function(dataIndex, localPosition) {
        var nodes = this.option.data || this.option.nodes;
        var dataItem = nodes[dataIndex];
        dataItem.localX = localPosition[0];
        dataItem.localY = localPosition[1];
    };
    /**
   * Return the graphic data structure
   *
   * @return graphic data structure
   */ SankeySeriesModel.prototype.getGraph = function() {
        return this.getData().graph;
    };
    /**
   * Get edge data of graphic data structure
   *
   * @return data structure of list
   */ SankeySeriesModel.prototype.getEdgeData = function() {
        return this.getGraph().edgeData;
    };
    SankeySeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        function noValue(val) {
            return isNaN(val) || val == null;
        }
        // dataType === 'node' or empty do not show tooltip by default
        if (dataType === 'edge') {
            var params = this.getDataParams(dataIndex, dataType);
            var rawDataOpt = params.data;
            var edgeValue = params.value;
            var edgeName = rawDataOpt.source + ' -- ' + rawDataOpt.target;
            return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)('nameValue', {
                name: edgeName,
                value: edgeValue,
                noValue: noValue(edgeValue)
            });
        } else {
            var node = this.getGraph().getNodeByIndex(dataIndex);
            var value = node.getLayout().value;
            var name_1 = this.getDataParams(dataIndex, dataType).data.name;
            return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)('nameValue', {
                name: name_1 != null ? name_1 + '' : null,
                value: value,
                noValue: noValue(value)
            });
        }
    };
    SankeySeriesModel.prototype.optionUpdated = function() {};
    // Override Series.getDataParams()
    SankeySeriesModel.prototype.getDataParams = function(dataIndex, dataType) {
        var params = _super.prototype.getDataParams.call(this, dataIndex, dataType);
        if (params.value == null && dataType === 'node') {
            var node = this.getGraph().getNodeByIndex(dataIndex);
            var nodeValue = node.getLayout().value;
            params.value = nodeValue;
        }
        return params;
    };
    SankeySeriesModel.type = 'series.sankey';
    SankeySeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        coordinateSystem: 'view',
        left: '5%',
        top: '5%',
        right: '20%',
        bottom: '5%',
        orient: 'horizontal',
        nodeWidth: 20,
        nodeGap: 8,
        draggable: true,
        layoutIterations: 32,
        label: {
            show: true,
            position: 'right',
            fontSize: 12
        },
        edgeLabel: {
            show: false,
            fontSize: 12
        },
        levels: [],
        nodeAlign: 'justify',
        lineStyle: {
            color: '#314656',
            opacity: 0.2,
            curveness: 0.5
        },
        emphasis: {
            label: {
                show: true
            },
            lineStyle: {
                opacity: 0.5
            }
        },
        select: {
            itemStyle: {
                borderColor: '#212121'
            }
        },
        animationEasing: 'linear',
        animationDuration: 1000
    };
    return SankeySeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $f213d63e219306d2$export$2e2bcd8739ae039 = $f213d63e219306d2$var$SankeySeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $b2e36df99c285454$export$2e2bcd8739ae039(ecModel, api) {
    ecModel.eachSeriesByType('sankey', function(seriesModel) {
        var nodeWidth = seriesModel.get('nodeWidth');
        var nodeGap = seriesModel.get('nodeGap');
        var layoutInfo = $b2e36df99c285454$var$getViewRect(seriesModel, api);
        seriesModel.layoutInfo = layoutInfo;
        var width = layoutInfo.width;
        var height = layoutInfo.height;
        var graph = seriesModel.getGraph();
        var nodes = graph.nodes;
        var edges = graph.edges;
        $b2e36df99c285454$var$computeNodeValues(nodes);
        var filteredNodes = $7a1bd9c2710fea0d$export$3dea766d36a8935f(nodes, function(node) {
            return node.getLayout().value === 0;
        });
        var iterations = filteredNodes.length !== 0 ? 0 : seriesModel.get('layoutIterations');
        var orient = seriesModel.get('orient');
        var nodeAlign = seriesModel.get('nodeAlign');
        $b2e36df99c285454$var$layoutSankey(nodes, edges, nodeWidth, nodeGap, width, height, iterations, orient, nodeAlign);
    });
}
/**
 * Get the layout position of the whole view
 */ function $b2e36df99c285454$var$getViewRect(seriesModel, api) {
    return $93b9bc7f22ac7369$export$4517a5ca639a7293(seriesModel.getBoxLayoutParams(), {
        width: api.getWidth(),
        height: api.getHeight()
    });
}
function $b2e36df99c285454$var$layoutSankey(nodes, edges, nodeWidth, nodeGap, width, height, iterations, orient, nodeAlign) {
    $b2e36df99c285454$var$computeNodeBreadths(nodes, edges, nodeWidth, width, height, orient, nodeAlign);
    $b2e36df99c285454$var$computeNodeDepths(nodes, edges, height, width, nodeGap, iterations, orient);
    $b2e36df99c285454$var$computeEdgeDepths(nodes, orient);
}
/**
 * Compute the value of each node by summing the associated edge's value
 */ function $b2e36df99c285454$var$computeNodeValues(nodes) {
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node) {
        var value1 = $b2e36df99c285454$var$sum(node.outEdges, $b2e36df99c285454$var$getEdgeValue);
        var value2 = $b2e36df99c285454$var$sum(node.inEdges, $b2e36df99c285454$var$getEdgeValue);
        var nodeRawValue = node.getValue() || 0;
        var value = Math.max(value1, value2, nodeRawValue);
        node.setLayout({
            value: value
        }, true);
    });
}
/**
 * Compute the x-position for each node.
 *
 * Here we use Kahn algorithm to detect cycle when we traverse
 * the node to computer the initial x position.
 */ function $b2e36df99c285454$var$computeNodeBreadths(nodes, edges, nodeWidth, width, height, orient, nodeAlign) {
    // Used to mark whether the edge is deleted. if it is deleted,
    // the value is 0, otherwise it is 1.
    var remainEdges = [];
    // Storage each node's indegree.
    var indegreeArr = [];
    // Used to storage the node with indegree is equal to 0.
    var zeroIndegrees = [];
    var nextTargetNode = [];
    var x = 0;
    // let kx = 0;
    for(var i = 0; i < edges.length; i++)remainEdges[i] = 1;
    for(var i = 0; i < nodes.length; i++){
        indegreeArr[i] = nodes[i].inEdges.length;
        if (indegreeArr[i] === 0) zeroIndegrees.push(nodes[i]);
    }
    var maxNodeDepth = -1;
    // Traversing nodes using topological sorting to calculate the
    // horizontal(if orient === 'horizontal') or vertical(if orient === 'vertical')
    // position of the nodes.
    while(zeroIndegrees.length){
        for(var idx = 0; idx < zeroIndegrees.length; idx++){
            var node = zeroIndegrees[idx];
            var item = node.hostGraph.data.getRawDataItem(node.dataIndex);
            var isItemDepth = item.depth != null && item.depth >= 0;
            if (isItemDepth && item.depth > maxNodeDepth) maxNodeDepth = item.depth;
            node.setLayout({
                depth: isItemDepth ? item.depth : x
            }, true);
            orient === 'vertical' ? node.setLayout({
                dy: nodeWidth
            }, true) : node.setLayout({
                dx: nodeWidth
            }, true);
            for(var edgeIdx = 0; edgeIdx < node.outEdges.length; edgeIdx++){
                var edge = node.outEdges[edgeIdx];
                var indexEdge = edges.indexOf(edge);
                remainEdges[indexEdge] = 0;
                var targetNode = edge.node2;
                var nodeIndex = nodes.indexOf(targetNode);
                if (--indegreeArr[nodeIndex] === 0 && nextTargetNode.indexOf(targetNode) < 0) nextTargetNode.push(targetNode);
            }
        }
        ++x;
        zeroIndegrees = nextTargetNode;
        nextTargetNode = [];
    }
    for(var i = 0; i < remainEdges.length; i++){
        if (remainEdges[i] === 1) throw new Error('Sankey is a DAG, the original data has cycle!');
    }
    var maxDepth = maxNodeDepth > x - 1 ? maxNodeDepth : x - 1;
    if (nodeAlign && nodeAlign !== 'left') $b2e36df99c285454$var$adjustNodeWithNodeAlign(nodes, nodeAlign, orient, maxDepth);
    var kx = orient === 'vertical' ? (height - nodeWidth) / maxDepth : (width - nodeWidth) / maxDepth;
    $b2e36df99c285454$var$scaleNodeBreadths(nodes, kx, orient);
}
function $b2e36df99c285454$var$isNodeDepth(node) {
    var item = node.hostGraph.data.getRawDataItem(node.dataIndex);
    return item.depth != null && item.depth >= 0;
}
function $b2e36df99c285454$var$adjustNodeWithNodeAlign(nodes, nodeAlign, orient, maxDepth) {
    if (nodeAlign === 'right') {
        var nextSourceNode = [];
        var remainNodes = nodes;
        var nodeHeight = 0;
        while(remainNodes.length){
            for(var i = 0; i < remainNodes.length; i++){
                var node = remainNodes[i];
                node.setLayout({
                    skNodeHeight: nodeHeight
                }, true);
                for(var j = 0; j < node.inEdges.length; j++){
                    var edge = node.inEdges[j];
                    if (nextSourceNode.indexOf(edge.node1) < 0) nextSourceNode.push(edge.node1);
                }
            }
            remainNodes = nextSourceNode;
            nextSourceNode = [];
            ++nodeHeight;
        }
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node) {
            if (!$b2e36df99c285454$var$isNodeDepth(node)) node.setLayout({
                depth: Math.max(0, maxDepth - node.getLayout().skNodeHeight)
            }, true);
        });
    } else if (nodeAlign === 'justify') $b2e36df99c285454$var$moveSinksRight(nodes, maxDepth);
}
/**
 * All the node without outEgdes are assigned maximum x-position and
 *     be aligned in the last column.
 *
 * @param nodes.  node of sankey view.
 * @param maxDepth.  use to assign to node without outEdges as x-position.
 */ function $b2e36df99c285454$var$moveSinksRight(nodes, maxDepth) {
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node) {
        if (!$b2e36df99c285454$var$isNodeDepth(node) && !node.outEdges.length) node.setLayout({
            depth: maxDepth
        }, true);
    });
}
/**
 * Scale node x-position to the width
 *
 * @param nodes  node of sankey view
 * @param kx   multiple used to scale nodes
 */ function $b2e36df99c285454$var$scaleNodeBreadths(nodes, kx, orient) {
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node) {
        var nodeDepth = node.getLayout().depth * kx;
        orient === 'vertical' ? node.setLayout({
            y: nodeDepth
        }, true) : node.setLayout({
            x: nodeDepth
        }, true);
    });
}
/**
 * Using Gauss-Seidel iterations method to compute the node depth(y-position)
 *
 * @param nodes  node of sankey view
 * @param edges  edge of sankey view
 * @param height  the whole height of the area to draw the view
 * @param nodeGap  the vertical distance between two nodes
 *     in the same column.
 * @param iterations  the number of iterations for the algorithm
 */ function $b2e36df99c285454$var$computeNodeDepths(nodes, edges, height, width, nodeGap, iterations, orient) {
    var nodesByBreadth = $b2e36df99c285454$var$prepareNodesByBreadth(nodes, orient);
    $b2e36df99c285454$var$initializeNodeDepth(nodesByBreadth, edges, height, width, nodeGap, orient);
    $b2e36df99c285454$var$resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);
    for(var alpha = 1; iterations > 0; iterations--){
        // 0.99 is a experience parameter, ensure that each iterations of
        // changes as small as possible.
        alpha *= 0.99;
        $b2e36df99c285454$var$relaxRightToLeft(nodesByBreadth, alpha, orient);
        $b2e36df99c285454$var$resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);
        $b2e36df99c285454$var$relaxLeftToRight(nodesByBreadth, alpha, orient);
        $b2e36df99c285454$var$resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);
    }
}
function $b2e36df99c285454$var$prepareNodesByBreadth(nodes, orient) {
    var nodesByBreadth = [];
    var keyAttr = orient === 'vertical' ? 'y' : 'x';
    var groupResult = (0, $76d619f648247e6d$export$7ab5bda43e13168f)(nodes, function(node) {
        return node.getLayout()[keyAttr];
    });
    groupResult.keys.sort(function(a, b) {
        return a - b;
    });
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(groupResult.keys, function(key) {
        nodesByBreadth.push(groupResult.buckets.get(key));
    });
    return nodesByBreadth;
}
/**
 * Compute the original y-position for each node
 */ function $b2e36df99c285454$var$initializeNodeDepth(nodesByBreadth, edges, height, width, nodeGap, orient) {
    var minKy = Infinity;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodesByBreadth, function(nodes) {
        var n = nodes.length;
        var sum = 0;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node) {
            sum += node.getLayout().value;
        });
        var ky = orient === 'vertical' ? (width - (n - 1) * nodeGap) / sum : (height - (n - 1) * nodeGap) / sum;
        if (ky < minKy) minKy = ky;
    });
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodesByBreadth, function(nodes) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node, i) {
            var nodeDy = node.getLayout().value * minKy;
            if (orient === 'vertical') {
                node.setLayout({
                    x: i
                }, true);
                node.setLayout({
                    dx: nodeDy
                }, true);
            } else {
                node.setLayout({
                    y: i
                }, true);
                node.setLayout({
                    dy: nodeDy
                }, true);
            }
        });
    });
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(edges, function(edge) {
        var edgeDy = +edge.getValue() * minKy;
        edge.setLayout({
            dy: edgeDy
        }, true);
    });
}
/**
 * Resolve the collision of initialized depth (y-position)
 */ function $b2e36df99c285454$var$resolveCollisions(nodesByBreadth, nodeGap, height, width, orient) {
    var keyAttr = orient === 'vertical' ? 'x' : 'y';
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodesByBreadth, function(nodes) {
        nodes.sort(function(a, b) {
            return a.getLayout()[keyAttr] - b.getLayout()[keyAttr];
        });
        var nodeX;
        var node;
        var dy;
        var y0 = 0;
        var n = nodes.length;
        var nodeDyAttr = orient === 'vertical' ? 'dx' : 'dy';
        for(var i = 0; i < n; i++){
            node = nodes[i];
            dy = y0 - node.getLayout()[keyAttr];
            if (dy > 0) {
                nodeX = node.getLayout()[keyAttr] + dy;
                orient === 'vertical' ? node.setLayout({
                    x: nodeX
                }, true) : node.setLayout({
                    y: nodeX
                }, true);
            }
            y0 = node.getLayout()[keyAttr] + node.getLayout()[nodeDyAttr] + nodeGap;
        }
        var viewWidth = orient === 'vertical' ? width : height;
        // If the bottommost node goes outside the bounds, push it back up
        dy = y0 - nodeGap - viewWidth;
        if (dy > 0) {
            nodeX = node.getLayout()[keyAttr] - dy;
            orient === 'vertical' ? node.setLayout({
                x: nodeX
            }, true) : node.setLayout({
                y: nodeX
            }, true);
            y0 = nodeX;
            for(var i = n - 2; i >= 0; --i){
                node = nodes[i];
                dy = node.getLayout()[keyAttr] + node.getLayout()[nodeDyAttr] + nodeGap - y0;
                if (dy > 0) {
                    nodeX = node.getLayout()[keyAttr] - dy;
                    orient === 'vertical' ? node.setLayout({
                        x: nodeX
                    }, true) : node.setLayout({
                        y: nodeX
                    }, true);
                }
                y0 = node.getLayout()[keyAttr];
            }
        }
    });
}
/**
 * Change the y-position of the nodes, except most the right side nodes
 * @param nodesByBreadth
 * @param alpha  parameter used to adjust the nodes y-position
 */ function $b2e36df99c285454$var$relaxRightToLeft(nodesByBreadth, alpha, orient) {
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodesByBreadth.slice().reverse(), function(nodes) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node) {
            if (node.outEdges.length) {
                var y = $b2e36df99c285454$var$sum(node.outEdges, $b2e36df99c285454$var$weightedTarget, orient) / $b2e36df99c285454$var$sum(node.outEdges, $b2e36df99c285454$var$getEdgeValue);
                if (isNaN(y)) {
                    var len = node.outEdges.length;
                    y = len ? $b2e36df99c285454$var$sum(node.outEdges, $b2e36df99c285454$var$centerTarget, orient) / len : 0;
                }
                if (orient === 'vertical') {
                    var nodeX = node.getLayout().x + (y - $b2e36df99c285454$var$center(node, orient)) * alpha;
                    node.setLayout({
                        x: nodeX
                    }, true);
                } else {
                    var nodeY = node.getLayout().y + (y - $b2e36df99c285454$var$center(node, orient)) * alpha;
                    node.setLayout({
                        y: nodeY
                    }, true);
                }
            }
        });
    });
}
function $b2e36df99c285454$var$weightedTarget(edge, orient) {
    return $b2e36df99c285454$var$center(edge.node2, orient) * edge.getValue();
}
function $b2e36df99c285454$var$centerTarget(edge, orient) {
    return $b2e36df99c285454$var$center(edge.node2, orient);
}
function $b2e36df99c285454$var$weightedSource(edge, orient) {
    return $b2e36df99c285454$var$center(edge.node1, orient) * edge.getValue();
}
function $b2e36df99c285454$var$centerSource(edge, orient) {
    return $b2e36df99c285454$var$center(edge.node1, orient);
}
function $b2e36df99c285454$var$center(node, orient) {
    return orient === 'vertical' ? node.getLayout().x + node.getLayout().dx / 2 : node.getLayout().y + node.getLayout().dy / 2;
}
function $b2e36df99c285454$var$getEdgeValue(edge) {
    return edge.getValue();
}
function $b2e36df99c285454$var$sum(array, cb, orient) {
    var sum = 0;
    var len = array.length;
    var i = -1;
    while(++i < len){
        var value = +cb(array[i], orient);
        if (!isNaN(value)) sum += value;
    }
    return sum;
}
/**
 * Change the y-position of the nodes, except most the left side nodes
 */ function $b2e36df99c285454$var$relaxLeftToRight(nodesByBreadth, alpha, orient) {
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodesByBreadth, function(nodes) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node) {
            if (node.inEdges.length) {
                var y = $b2e36df99c285454$var$sum(node.inEdges, $b2e36df99c285454$var$weightedSource, orient) / $b2e36df99c285454$var$sum(node.inEdges, $b2e36df99c285454$var$getEdgeValue);
                if (isNaN(y)) {
                    var len = node.inEdges.length;
                    y = len ? $b2e36df99c285454$var$sum(node.inEdges, $b2e36df99c285454$var$centerSource, orient) / len : 0;
                }
                if (orient === 'vertical') {
                    var nodeX = node.getLayout().x + (y - $b2e36df99c285454$var$center(node, orient)) * alpha;
                    node.setLayout({
                        x: nodeX
                    }, true);
                } else {
                    var nodeY = node.getLayout().y + (y - $b2e36df99c285454$var$center(node, orient)) * alpha;
                    node.setLayout({
                        y: nodeY
                    }, true);
                }
            }
        });
    });
}
/**
 * Compute the depth(y-position) of each edge
 */ function $b2e36df99c285454$var$computeEdgeDepths(nodes, orient) {
    var keyAttr = orient === 'vertical' ? 'x' : 'y';
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node) {
        node.outEdges.sort(function(a, b) {
            return a.node2.getLayout()[keyAttr] - b.node2.getLayout()[keyAttr];
        });
        node.inEdges.sort(function(a, b) {
            return a.node1.getLayout()[keyAttr] - b.node1.getLayout()[keyAttr];
        });
    });
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node) {
        var sy = 0;
        var ty = 0;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(node.outEdges, function(edge) {
            edge.setLayout({
                sy: sy
            }, true);
            sy += edge.getLayout().dy;
        });
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(node.inEdges, function(edge) {
            edge.setLayout({
                ty: ty
            }, true);
            ty += edge.getLayout().dy;
        });
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $7b50f502cfd189d5$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
var $7b50f502cfd189d5$var$isObject = $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a;
var $7b50f502cfd189d5$var$CATEGORY_DEFAULT_VISUAL_INDEX = -1;
var $7b50f502cfd189d5$var$VisualMapping = /** @class */ function() {
    function VisualMapping(option) {
        var mappingMethod = option.mappingMethod;
        var visualType = option.type;
        var thisOption = this.option = $7a1bd9c2710fea0d$export$9cd59f9826255e47(option);
        this.type = visualType;
        this.mappingMethod = mappingMethod;
        this._normalizeData = $7b50f502cfd189d5$var$normalizers[mappingMethod];
        var visualHandler = VisualMapping.visualHandlers[visualType];
        this.applyVisual = visualHandler.applyVisual;
        this.getColorMapper = visualHandler.getColorMapper;
        this._normalizedToVisual = visualHandler._normalizedToVisual[mappingMethod];
        if (mappingMethod === 'piecewise') {
            $7b50f502cfd189d5$var$normalizeVisualRange(thisOption);
            $7b50f502cfd189d5$var$preprocessForPiecewise(thisOption);
        } else if (mappingMethod === 'category') thisOption.categories ? $7b50f502cfd189d5$var$preprocessForSpecifiedCategory(thisOption) : $7b50f502cfd189d5$var$normalizeVisualRange(thisOption, true);
        else {
            // mappingMethod === 'linear' or 'fixed'
            $7a1bd9c2710fea0d$export$a7a9523472993e97(mappingMethod !== 'linear' || thisOption.dataExtent);
            $7b50f502cfd189d5$var$normalizeVisualRange(thisOption);
        }
    }
    VisualMapping.prototype.mapValueToVisual = function(value) {
        var normalized = this._normalizeData(value);
        return this._normalizedToVisual(normalized, value);
    };
    VisualMapping.prototype.getNormalizer = function() {
        return $7a1bd9c2710fea0d$export$2385a24977818dd0(this._normalizeData, this);
    };
    /**
   * List available visual types.
   *
   * @public
   * @return {Array.<string>}
   */ VisualMapping.listVisualTypes = function() {
        return $7a1bd9c2710fea0d$export$ed97f33186d4b816(VisualMapping.visualHandlers);
    };
    // /**
    //  * @public
    //  */
    // static addVisualHandler(name, handler) {
    //     visualHandlers[name] = handler;
    // }
    /**
   * @public
   */ VisualMapping.isValidType = function(visualType) {
        return VisualMapping.visualHandlers.hasOwnProperty(visualType);
    };
    /**
   * Convenient method.
   * Visual can be Object or Array or primary type.
   */ VisualMapping.eachVisual = function(visual, callback, context) {
        if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(visual)) $7a1bd9c2710fea0d$export$79b2f7037acddd43(visual, callback, context);
        else callback.call(context, visual);
    };
    VisualMapping.mapVisual = function(visual, callback, context) {
        var isPrimary;
        var newVisual = $7a1bd9c2710fea0d$export$43bee75e5e14138e(visual) ? [] : $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(visual) ? {} : (isPrimary = true, null);
        VisualMapping.eachVisual(visual, function(v, key) {
            var newVal = callback.call(context, v, key);
            isPrimary ? newVisual = newVal : newVisual[key] = newVal;
        });
        return newVisual;
    };
    /**
   * Retrieve visual properties from given object.
   */ VisualMapping.retrieveVisuals = function(obj) {
        var ret = {};
        var hasVisual;
        obj && $7b50f502cfd189d5$var$each(VisualMapping.visualHandlers, function(h, visualType) {
            if (obj.hasOwnProperty(visualType)) {
                ret[visualType] = obj[visualType];
                hasVisual = true;
            }
        });
        return hasVisual ? ret : null;
    };
    /**
   * Give order to visual types, considering colorSaturation, colorAlpha depends on color.
   *
   * @public
   * @param {(Object|Array)} visualTypes If Object, like: {color: ..., colorSaturation: ...}
   *                                     IF Array, like: ['color', 'symbol', 'colorSaturation']
   * @return {Array.<string>} Sorted visual types.
   */ VisualMapping.prepareVisualTypes = function(visualTypes) {
        if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(visualTypes)) visualTypes = visualTypes.slice();
        else if ($7b50f502cfd189d5$var$isObject(visualTypes)) {
            var types_1 = [];
            $7b50f502cfd189d5$var$each(visualTypes, function(item, type) {
                types_1.push(type);
            });
            visualTypes = types_1;
        } else return [];
        visualTypes.sort(function(type1, type2) {
            // color should be front of colorSaturation, colorAlpha, ...
            // symbol and symbolSize do not matter.
            return type2 === 'color' && type1 !== 'color' && type1.indexOf('color') === 0 ? 1 : -1;
        });
        return visualTypes;
    };
    /**
   * 'color', 'colorSaturation', 'colorAlpha', ... are depends on 'color'.
   * Other visuals are only depends on themself.
   */ VisualMapping.dependsOn = function(visualType1, visualType2) {
        return visualType2 === 'color' ? !!(visualType1 && visualType1.indexOf(visualType2) === 0) : visualType1 === visualType2;
    };
    /**
   * @param value
   * @param pieceList [{value: ..., interval: [min, max]}, ...]
   *                         Always from small to big.
   * @param findClosestWhenOutside Default to be false
   * @return index
   */ VisualMapping.findPieceIndex = function(value, pieceList, findClosestWhenOutside) {
        var possibleI;
        var abs = Infinity;
        // value has the higher priority.
        for(var i = 0, len = pieceList.length; i < len; i++){
            var pieceValue = pieceList[i].value;
            if (pieceValue != null) {
                if (pieceValue === value || $7a1bd9c2710fea0d$export$844ec244b1367d54(pieceValue) && pieceValue === value + '') return i;
                findClosestWhenOutside && updatePossible(pieceValue, i);
            }
        }
        for(var i = 0, len = pieceList.length; i < len; i++){
            var piece = pieceList[i];
            var interval = piece.interval;
            var close_1 = piece.close;
            if (interval) {
                if (interval[0] === -Infinity) {
                    if ($7b50f502cfd189d5$var$littleThan(close_1[1], value, interval[1])) return i;
                } else if (interval[1] === Infinity) {
                    if ($7b50f502cfd189d5$var$littleThan(close_1[0], interval[0], value)) return i;
                } else if ($7b50f502cfd189d5$var$littleThan(close_1[0], interval[0], value) && $7b50f502cfd189d5$var$littleThan(close_1[1], value, interval[1])) return i;
                findClosestWhenOutside && updatePossible(interval[0], i);
                findClosestWhenOutside && updatePossible(interval[1], i);
            }
        }
        if (findClosestWhenOutside) return value === Infinity ? pieceList.length - 1 : value === -Infinity ? 0 : possibleI;
        function updatePossible(val, index) {
            var newAbs = Math.abs(val - value);
            if (newAbs < abs) {
                abs = newAbs;
                possibleI = index;
            }
        }
    };
    VisualMapping.visualHandlers = {
        color: {
            applyVisual: $7b50f502cfd189d5$var$makeApplyVisual('color'),
            getColorMapper: function() {
                var thisOption = this.option;
                return $7a1bd9c2710fea0d$export$2385a24977818dd0(thisOption.mappingMethod === 'category' ? function(value, isNormalized) {
                    !isNormalized && (value = this._normalizeData(value));
                    return $7b50f502cfd189d5$var$doMapCategory.call(this, value);
                } : function(value, isNormalized, out) {
                    // If output rgb array
                    // which will be much faster and useful in pixel manipulation
                    var returnRGBArray = !!out;
                    !isNormalized && (value = this._normalizeData(value));
                    out = $2c037f5bda6341ca$export$66cb3c0e9efc61c8(value, thisOption.parsedVisual, out);
                    return returnRGBArray ? out : $2c037f5bda6341ca$export$fac44ee5b035f737(out, 'rgba');
                }, this);
            },
            _normalizedToVisual: {
                linear: function(normalized) {
                    return $2c037f5bda6341ca$export$fac44ee5b035f737($2c037f5bda6341ca$export$66cb3c0e9efc61c8(normalized, this.option.parsedVisual), 'rgba');
                },
                category: $7b50f502cfd189d5$var$doMapCategory,
                piecewise: function(normalized, value) {
                    var result = $7b50f502cfd189d5$var$getSpecifiedVisual.call(this, value);
                    if (result == null) result = $2c037f5bda6341ca$export$fac44ee5b035f737($2c037f5bda6341ca$export$66cb3c0e9efc61c8(normalized, this.option.parsedVisual), 'rgba');
                    return result;
                },
                fixed: $7b50f502cfd189d5$var$doMapFixed
            }
        },
        colorHue: $7b50f502cfd189d5$var$makePartialColorVisualHandler(function(color, value) {
            return $2c037f5bda6341ca$export$d898ae866e27bf18(color, value);
        }),
        colorSaturation: $7b50f502cfd189d5$var$makePartialColorVisualHandler(function(color, value) {
            return $2c037f5bda6341ca$export$d898ae866e27bf18(color, null, value);
        }),
        colorLightness: $7b50f502cfd189d5$var$makePartialColorVisualHandler(function(color, value) {
            return $2c037f5bda6341ca$export$d898ae866e27bf18(color, null, null, value);
        }),
        colorAlpha: $7b50f502cfd189d5$var$makePartialColorVisualHandler(function(color, value) {
            return $2c037f5bda6341ca$export$ab4754bf42583a26(color, value);
        }),
        decal: {
            applyVisual: $7b50f502cfd189d5$var$makeApplyVisual('decal'),
            _normalizedToVisual: {
                linear: null,
                category: $7b50f502cfd189d5$var$doMapCategory,
                piecewise: null,
                fixed: null
            }
        },
        opacity: {
            applyVisual: $7b50f502cfd189d5$var$makeApplyVisual('opacity'),
            _normalizedToVisual: $7b50f502cfd189d5$var$createNormalizedToNumericVisual([
                0,
                1
            ])
        },
        liftZ: {
            applyVisual: $7b50f502cfd189d5$var$makeApplyVisual('liftZ'),
            _normalizedToVisual: {
                linear: $7b50f502cfd189d5$var$doMapFixed,
                category: $7b50f502cfd189d5$var$doMapFixed,
                piecewise: $7b50f502cfd189d5$var$doMapFixed,
                fixed: $7b50f502cfd189d5$var$doMapFixed
            }
        },
        symbol: {
            applyVisual: function(value, getter, setter) {
                var symbolCfg = this.mapValueToVisual(value);
                setter('symbol', symbolCfg);
            },
            _normalizedToVisual: {
                linear: $7b50f502cfd189d5$var$doMapToArray,
                category: $7b50f502cfd189d5$var$doMapCategory,
                piecewise: function(normalized, value) {
                    var result = $7b50f502cfd189d5$var$getSpecifiedVisual.call(this, value);
                    if (result == null) result = $7b50f502cfd189d5$var$doMapToArray.call(this, normalized);
                    return result;
                },
                fixed: $7b50f502cfd189d5$var$doMapFixed
            }
        },
        symbolSize: {
            applyVisual: $7b50f502cfd189d5$var$makeApplyVisual('symbolSize'),
            _normalizedToVisual: $7b50f502cfd189d5$var$createNormalizedToNumericVisual([
                0,
                1
            ])
        }
    };
    return VisualMapping;
}();
function $7b50f502cfd189d5$var$preprocessForPiecewise(thisOption) {
    var pieceList = thisOption.pieceList;
    thisOption.hasSpecialVisual = false;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(pieceList, function(piece, index) {
        piece.originIndex = index;
        // piece.visual is "result visual value" but not
        // a visual range, so it does not need to be normalized.
        if (piece.visual != null) thisOption.hasSpecialVisual = true;
    });
}
function $7b50f502cfd189d5$var$preprocessForSpecifiedCategory(thisOption) {
    // Hash categories.
    var categories = thisOption.categories;
    var categoryMap = thisOption.categoryMap = {};
    var visual = thisOption.visual;
    $7b50f502cfd189d5$var$each(categories, function(cate, index) {
        categoryMap[cate] = index;
    });
    // Process visual map input.
    if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(visual)) {
        var visualArr_1 = [];
        if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(visual)) $7b50f502cfd189d5$var$each(visual, function(v, cate) {
            var index = categoryMap[cate];
            visualArr_1[index != null ? index : $7b50f502cfd189d5$var$CATEGORY_DEFAULT_VISUAL_INDEX] = v;
        });
        else // Is primary type, represents default visual.
        visualArr_1[$7b50f502cfd189d5$var$CATEGORY_DEFAULT_VISUAL_INDEX] = visual;
        visual = $7b50f502cfd189d5$var$setVisualToOption(thisOption, visualArr_1);
    }
    // Remove categories that has no visual,
    // then we can mapping them to CATEGORY_DEFAULT_VISUAL_INDEX.
    for(var i = categories.length - 1; i >= 0; i--)if (visual[i] == null) {
        delete categoryMap[categories[i]];
        categories.pop();
    }
}
function $7b50f502cfd189d5$var$normalizeVisualRange(thisOption, isCategory) {
    var visual = thisOption.visual;
    var visualArr = [];
    if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(visual)) $7b50f502cfd189d5$var$each(visual, function(v) {
        visualArr.push(v);
    });
    else if (visual != null) visualArr.push(visual);
    var doNotNeedPair = {
        color: 1,
        symbol: 1
    };
    if (!isCategory && visualArr.length === 1 && !doNotNeedPair.hasOwnProperty(thisOption.type)) // Do not care visualArr.length === 0, which is illegal.
    visualArr[1] = visualArr[0];
    $7b50f502cfd189d5$var$setVisualToOption(thisOption, visualArr);
}
function $7b50f502cfd189d5$var$makePartialColorVisualHandler(applyValue) {
    return {
        applyVisual: function(value, getter, setter) {
            // Only used in HSL
            var colorChannel = this.mapValueToVisual(value);
            // Must not be array value
            setter('color', applyValue(getter('color'), colorChannel));
        },
        _normalizedToVisual: $7b50f502cfd189d5$var$createNormalizedToNumericVisual([
            0,
            1
        ])
    };
}
function $7b50f502cfd189d5$var$doMapToArray(normalized) {
    var visual = this.option.visual;
    return visual[Math.round((0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(normalized, [
        0,
        1
    ], [
        0,
        visual.length - 1
    ], true))] || {}; // TODO {}?
}
function $7b50f502cfd189d5$var$makeApplyVisual(visualType) {
    return function(value, getter, setter) {
        setter(visualType, this.mapValueToVisual(value));
    };
}
function $7b50f502cfd189d5$var$doMapCategory(normalized) {
    var visual = this.option.visual;
    return visual[this.option.loop && normalized !== $7b50f502cfd189d5$var$CATEGORY_DEFAULT_VISUAL_INDEX ? normalized % visual.length : normalized];
}
function $7b50f502cfd189d5$var$doMapFixed() {
    // visual will be convert to array.
    return this.option.visual[0];
}
/**
 * Create mapped to numeric visual
 */ function $7b50f502cfd189d5$var$createNormalizedToNumericVisual(sourceExtent) {
    return {
        linear: function(normalized) {
            return (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(normalized, sourceExtent, this.option.visual, true);
        },
        category: $7b50f502cfd189d5$var$doMapCategory,
        piecewise: function(normalized, value) {
            var result = $7b50f502cfd189d5$var$getSpecifiedVisual.call(this, value);
            if (result == null) result = (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(normalized, sourceExtent, this.option.visual, true);
            return result;
        },
        fixed: $7b50f502cfd189d5$var$doMapFixed
    };
}
function $7b50f502cfd189d5$var$getSpecifiedVisual(value) {
    var thisOption = this.option;
    var pieceList = thisOption.pieceList;
    if (thisOption.hasSpecialVisual) {
        var pieceIndex = $7b50f502cfd189d5$var$VisualMapping.findPieceIndex(value, pieceList);
        var piece = pieceList[pieceIndex];
        if (piece && piece.visual) return piece.visual[this.type];
    }
}
function $7b50f502cfd189d5$var$setVisualToOption(thisOption, visualArr) {
    thisOption.visual = visualArr;
    if (thisOption.type === 'color') thisOption.parsedVisual = $7a1bd9c2710fea0d$export$871de8747c9eaa88(visualArr, function(item) {
        var color = $2c037f5bda6341ca$export$98e6a39c04603d36(item);
        color;
        return color || [
            0,
            0,
            0,
            1
        ];
    });
    return visualArr;
}
/**
 * Normalizers by mapping methods.
 */ var $7b50f502cfd189d5$var$normalizers = {
    linear: function(value) {
        return (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(value, this.option.dataExtent, [
            0,
            1
        ], true);
    },
    piecewise: function(value) {
        var pieceList = this.option.pieceList;
        var pieceIndex = $7b50f502cfd189d5$var$VisualMapping.findPieceIndex(value, pieceList, true);
        if (pieceIndex != null) return (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(pieceIndex, [
            0,
            pieceList.length - 1
        ], [
            0,
            1
        ], true);
    },
    category: function(value) {
        var index = this.option.categories ? this.option.categoryMap[value] : value; // ordinal value
        return index == null ? $7b50f502cfd189d5$var$CATEGORY_DEFAULT_VISUAL_INDEX : index;
    },
    fixed: $7a1bd9c2710fea0d$export$8793edee2d425525
};
function $7b50f502cfd189d5$var$littleThan(close, a, b) {
    return close ? a <= b : a < b;
}
var $7b50f502cfd189d5$export$2e2bcd8739ae039 = $7b50f502cfd189d5$var$VisualMapping;


function $5379d5704c92d7dd$export$2e2bcd8739ae039(ecModel) {
    ecModel.eachSeriesByType('sankey', function(seriesModel) {
        var graph = seriesModel.getGraph();
        var nodes = graph.nodes;
        var edges = graph.edges;
        if (nodes.length) {
            var minValue_1 = Infinity;
            var maxValue_1 = -Infinity;
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node) {
                var nodeValue = node.getLayout().value;
                if (nodeValue < minValue_1) minValue_1 = nodeValue;
                if (nodeValue > maxValue_1) maxValue_1 = nodeValue;
            });
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node) {
                var mapping = new (0, $7b50f502cfd189d5$export$2e2bcd8739ae039)({
                    type: 'color',
                    mappingMethod: 'linear',
                    dataExtent: [
                        minValue_1,
                        maxValue_1
                    ],
                    visual: seriesModel.get('color')
                });
                var mapValueToColor = mapping.mapValueToVisual(node.getLayout().value);
                var customColor = node.getModel().get([
                    'itemStyle',
                    'color'
                ]);
                if (customColor != null) {
                    node.setVisual('color', customColor);
                    node.setVisual('style', {
                        fill: customColor
                    });
                } else {
                    node.setVisual('color', mapValueToColor);
                    node.setVisual('style', {
                        fill: mapValueToColor
                    });
                }
            });
        }
        if (edges.length) $7a1bd9c2710fea0d$export$79b2f7037acddd43(edges, function(edge) {
            var edgeStyle = edge.getModel().get('lineStyle');
            edge.setVisual('style', edgeStyle);
        });
    });
}


function $2439b31c49c21b38$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $58364a2c82b0ec77$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $f213d63e219306d2$export$2e2bcd8739ae039));
    registers.registerLayout((0, $b2e36df99c285454$export$2e2bcd8739ae039));
    registers.registerVisual((0, $5379d5704c92d7dd$export$2e2bcd8739ae039));
    registers.registerAction({
        type: 'dragNode',
        event: 'dragnode',
        // here can only use 'update' now, other value is not support in echarts.
        update: 'update'
    }, function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: 'series',
            subType: 'sankey',
            query: payload
        }, function(seriesModel) {
            seriesModel.setNodePosition(payload.dataIndex, [
                payload.localX,
                payload.localY
            ]);
        });
    });
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $00ab9646b588965f$var$ScatterSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ScatterSeriesModel, _super);
    function ScatterSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ScatterSeriesModel.type;
        _this.hasSymbolVisual = true;
        return _this;
    }
    ScatterSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $8afdec5f59c90781$export$2e2bcd8739ae039)(null, this, {
            useEncodeDefaulter: true
        });
    };
    ScatterSeriesModel.prototype.getProgressive = function() {
        var progressive = this.option.progressive;
        if (progressive == null) // PENDING
        return this.option.large ? 5e3 : this.get('progressive');
        return progressive;
    };
    ScatterSeriesModel.prototype.getProgressiveThreshold = function() {
        var progressiveThreshold = this.option.progressiveThreshold;
        if (progressiveThreshold == null) // PENDING
        return this.option.large ? 1e4 : this.get('progressiveThreshold');
        return progressiveThreshold;
    };
    ScatterSeriesModel.prototype.brushSelector = function(dataIndex, data, selectors) {
        return selectors.point(data.getItemLayout(dataIndex));
    };
    ScatterSeriesModel.prototype.getZLevelKey = function() {
        // Each progressive series has individual key.
        return this.getData().count() > this.getProgressiveThreshold() ? this.id : '';
    };
    ScatterSeriesModel.type = 'series.scatter';
    ScatterSeriesModel.dependencies = [
        'grid',
        'polar',
        'geo',
        'singleAxis',
        'calendar'
    ];
    ScatterSeriesModel.defaultOption = {
        coordinateSystem: 'cartesian2d',
        // zlevel: 0,
        z: 2,
        legendHoverLink: true,
        symbolSize: 10,
        // symbolRotate: null,  // 图形旋转控制
        large: false,
        // Available when large is true
        largeThreshold: 2000,
        // cursor: null,
        itemStyle: {
            opacity: 0.8
        },
        emphasis: {
            scale: true
        },
        // If clip the overflow graphics
        // Works on cartesian / polar series
        clip: true,
        select: {
            itemStyle: {
                borderColor: '#212121'
            }
        },
        universalTransition: {
            divideShape: 'clone'
        }
    };
    return ScatterSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $00ab9646b588965f$export$2e2bcd8739ae039 = $00ab9646b588965f$var$ScatterSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $69bbf770a3ca2c75$var$BOOST_SIZE_THRESHOLD = 4;
var $69bbf770a3ca2c75$var$LargeSymbolPathShape = /** @class */ function() {
    function LargeSymbolPathShape() {}
    return LargeSymbolPathShape;
}();
var $69bbf770a3ca2c75$var$LargeSymbolPath = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(LargeSymbolPath, _super);
    function LargeSymbolPath(opts) {
        var _this = _super.call(this, opts) || this;
        _this._off = 0;
        _this.hoverDataIdx = -1;
        return _this;
    }
    LargeSymbolPath.prototype.getDefaultShape = function() {
        return new $69bbf770a3ca2c75$var$LargeSymbolPathShape();
    };
    LargeSymbolPath.prototype.reset = function() {
        this.notClear = false;
        this._off = 0;
    };
    LargeSymbolPath.prototype.buildPath = function(path, shape) {
        var points = shape.points;
        var size = shape.size;
        var symbolProxy = this.symbolProxy;
        var symbolProxyShape = symbolProxy.shape;
        var ctx = path.getContext ? path.getContext() : path;
        var canBoost = ctx && size[0] < $69bbf770a3ca2c75$var$BOOST_SIZE_THRESHOLD;
        var softClipShape = this.softClipShape;
        var i;
        // Do draw in afterBrush.
        if (canBoost) {
            this._ctx = ctx;
            return;
        }
        this._ctx = null;
        for(i = this._off; i < points.length;){
            var x = points[i++];
            var y = points[i++];
            if (isNaN(x) || isNaN(y)) continue;
            if (softClipShape && !softClipShape.contain(x, y)) continue;
            symbolProxyShape.x = x - size[0] / 2;
            symbolProxyShape.y = y - size[1] / 2;
            symbolProxyShape.width = size[0];
            symbolProxyShape.height = size[1];
            symbolProxy.buildPath(path, symbolProxyShape, true);
        }
        if (this.incremental) {
            this._off = i;
            this.notClear = true;
        }
    };
    LargeSymbolPath.prototype.afterBrush = function() {
        var shape = this.shape;
        var points = shape.points;
        var size = shape.size;
        var ctx = this._ctx;
        var softClipShape = this.softClipShape;
        var i;
        if (!ctx) return;
        // PENDING If style or other canvas status changed?
        for(i = this._off; i < points.length;){
            var x = points[i++];
            var y = points[i++];
            if (isNaN(x) || isNaN(y)) continue;
            if (softClipShape && !softClipShape.contain(x, y)) continue;
            // fillRect is faster than building a rect path and draw.
            // And it support light globalCompositeOperation.
            ctx.fillRect(x - size[0] / 2, y - size[1] / 2, size[0], size[1]);
        }
        if (this.incremental) {
            this._off = i;
            this.notClear = true;
        }
    };
    LargeSymbolPath.prototype.findDataIndex = function(x, y) {
        // TODO ???
        // Consider transform
        var shape = this.shape;
        var points = shape.points;
        var size = shape.size;
        var w = Math.max(size[0], 4);
        var h = Math.max(size[1], 4);
        // Not consider transform
        // Treat each element as a rect
        // top down traverse
        for(var idx = points.length / 2 - 1; idx >= 0; idx--){
            var i = idx * 2;
            var x0 = points[i] - w / 2;
            var y0 = points[i + 1] - h / 2;
            if (x >= x0 && y >= y0 && x <= x0 + w && y <= y0 + h) return idx;
        }
        return -1;
    };
    LargeSymbolPath.prototype.contain = function(x, y) {
        var localPos = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        x = localPos[0];
        y = localPos[1];
        if (rect.contain(x, y)) {
            // Cache found data index.
            var dataIdx = this.hoverDataIdx = this.findDataIndex(x, y);
            return dataIdx >= 0;
        }
        this.hoverDataIdx = -1;
        return false;
    };
    LargeSymbolPath.prototype.getBoundingRect = function() {
        // Ignore stroke for large symbol draw.
        var rect = this._rect;
        if (!rect) {
            var shape = this.shape;
            var points = shape.points;
            var size = shape.size;
            var w = size[0];
            var h = size[1];
            var minX = Infinity;
            var minY = Infinity;
            var maxX = -Infinity;
            var maxY = -Infinity;
            for(var i = 0; i < points.length;){
                var x = points[i++];
                var y = points[i++];
                minX = Math.min(x, minX);
                maxX = Math.max(x, maxX);
                minY = Math.min(y, minY);
                maxY = Math.max(y, maxY);
            }
            rect = this._rect = new $1bebe7106c895823$export$2e2bcd8739ae039(minX - w / 2, minY - h / 2, maxX - minX + w, maxY - minY + h);
        }
        return rect;
    };
    return LargeSymbolPath;
}($b02ffe7acd508c08$export$2e2bcd8739ae039);
var $69bbf770a3ca2c75$var$LargeSymbolDraw = /** @class */ function() {
    function LargeSymbolDraw() {
        this.group = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
    }
    /**
   * Update symbols draw by new data
   */ LargeSymbolDraw.prototype.updateData = function(data, opt) {
        this._clear();
        var symbolEl = this._create();
        symbolEl.setShape({
            points: data.getLayout('points')
        });
        this._setCommon(symbolEl, data, opt);
    };
    LargeSymbolDraw.prototype.updateLayout = function(data) {
        var points = data.getLayout('points');
        this.group.eachChild(function(child) {
            if (child.startIndex != null) {
                var len = (child.endIndex - child.startIndex) * 2;
                var byteOffset = child.startIndex * 8;
                points = new Float32Array(points.buffer, byteOffset, len);
            }
            child.setShape('points', points);
            // Reset draw cursor.
            child.reset();
        });
    };
    LargeSymbolDraw.prototype.incrementalPrepareUpdate = function(data) {
        this._clear();
    };
    LargeSymbolDraw.prototype.incrementalUpdate = function(taskParams, data, opt) {
        var lastAdded = this._newAdded[0];
        var points = data.getLayout('points');
        var oldPoints = lastAdded && lastAdded.shape.points;
        // Merging the exists. Each element has 1e4 points.
        // Consider the performance balance between too much elements and too much points in one shape(may affect hover optimization)
        if (oldPoints && oldPoints.length < 2e4) {
            var oldLen = oldPoints.length;
            var newPoints = new Float32Array(oldLen + points.length);
            // Concat two array
            newPoints.set(oldPoints);
            newPoints.set(points, oldLen);
            // Update endIndex
            lastAdded.endIndex = taskParams.end;
            lastAdded.setShape({
                points: newPoints
            });
        } else {
            // Clear
            this._newAdded = [];
            var symbolEl = this._create();
            symbolEl.startIndex = taskParams.start;
            symbolEl.endIndex = taskParams.end;
            symbolEl.incremental = true;
            symbolEl.setShape({
                points: points
            });
            this._setCommon(symbolEl, data, opt);
        }
    };
    LargeSymbolDraw.prototype.eachRendered = function(cb) {
        this._newAdded[0] && cb(this._newAdded[0]);
    };
    LargeSymbolDraw.prototype._create = function() {
        var symbolEl = new $69bbf770a3ca2c75$var$LargeSymbolPath({
            cursor: 'default'
        });
        symbolEl.ignoreCoarsePointer = true;
        this.group.add(symbolEl);
        this._newAdded.push(symbolEl);
        return symbolEl;
    };
    LargeSymbolDraw.prototype._setCommon = function(symbolEl, data, opt) {
        var hostModel = data.hostModel;
        opt = opt || {};
        var size = data.getVisual('symbolSize');
        symbolEl.setShape('size', size instanceof Array ? size : [
            size,
            size
        ]);
        symbolEl.softClipShape = opt.clipShape || null;
        // Create symbolProxy to build path for each data
        symbolEl.symbolProxy = (0, $5370466dadc978d7$export$af050e04da3a02e8)(data.getVisual('symbol'), 0, 0, 0, 0);
        // Use symbolProxy setColor method
        symbolEl.setColor = symbolEl.symbolProxy.setColor;
        var extrudeShadow = symbolEl.shape.size[0] < $69bbf770a3ca2c75$var$BOOST_SIZE_THRESHOLD;
        symbolEl.useStyle(// Draw shadow when doing fillRect is extremely slow.
        hostModel.getModel('itemStyle').getItemStyle(extrudeShadow ? [
            'color',
            'shadowBlur',
            'shadowColor'
        ] : [
            'color'
        ]));
        var globalStyle = data.getVisual('style');
        var visualColor = globalStyle && globalStyle.fill;
        if (visualColor) symbolEl.setColor(visualColor);
        var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(symbolEl);
        // Enable tooltip
        // PENDING May have performance issue when path is extremely large
        ecData.seriesIndex = hostModel.seriesIndex;
        symbolEl.on('mousemove', function(e) {
            ecData.dataIndex = null;
            var dataIndex = symbolEl.hoverDataIdx;
            if (dataIndex >= 0) // Provide dataIndex for tooltip
            ecData.dataIndex = dataIndex + (symbolEl.startIndex || 0);
        });
    };
    LargeSymbolDraw.prototype.remove = function() {
        this._clear();
    };
    LargeSymbolDraw.prototype._clear = function() {
        this._newAdded = [];
        this.group.removeAll();
    };
    return LargeSymbolDraw;
}();
var $69bbf770a3ca2c75$export$2e2bcd8739ae039 = $69bbf770a3ca2c75$var$LargeSymbolDraw;




var $c92a7ada0c69ef68$var$ScatterView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ScatterView, _super);
    function ScatterView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ScatterView.type;
        return _this;
    }
    ScatterView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var symbolDraw = this._updateSymbolDraw(data, seriesModel);
        symbolDraw.updateData(data, {
            // TODO
            // If this parameter should be a shape or a bounding volume
            // shape will be more general.
            // But bounding volume like bounding rect will be much faster in the contain calculation
            clipShape: this._getClipShape(seriesModel)
        });
        this._finished = true;
    };
    ScatterView.prototype.incrementalPrepareRender = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var symbolDraw = this._updateSymbolDraw(data, seriesModel);
        symbolDraw.incrementalPrepareUpdate(data);
        this._finished = false;
    };
    ScatterView.prototype.incrementalRender = function(taskParams, seriesModel, ecModel) {
        this._symbolDraw.incrementalUpdate(taskParams, seriesModel.getData(), {
            clipShape: this._getClipShape(seriesModel)
        });
        this._finished = taskParams.end === seriesModel.getData().count();
    };
    ScatterView.prototype.updateTransform = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        // Must mark group dirty and make sure the incremental layer will be cleared
        // PENDING
        this.group.dirty();
        if (!this._finished || data.count() > 1e4) return {
            update: true
        };
        else {
            var res = (0, $73b014aa594ea652$export$2e2bcd8739ae039)('').reset(seriesModel, ecModel, api);
            if (res.progress) res.progress({
                start: 0,
                end: data.count(),
                count: data.count()
            }, data);
            this._symbolDraw.updateLayout(data);
        }
    };
    ScatterView.prototype.eachRendered = function(cb) {
        this._symbolDraw && this._symbolDraw.eachRendered(cb);
    };
    ScatterView.prototype._getClipShape = function(seriesModel) {
        if (!seriesModel.get('clip', true)) return;
        var coordSys = seriesModel.coordinateSystem;
        // PENDING make `0.1` configurable, for example, `clipTolerance`?
        return coordSys && coordSys.getArea && coordSys.getArea(.1);
    };
    ScatterView.prototype._updateSymbolDraw = function(data, seriesModel) {
        var symbolDraw = this._symbolDraw;
        var pipelineContext = seriesModel.pipelineContext;
        var isLargeDraw = pipelineContext.large;
        if (!symbolDraw || isLargeDraw !== this._isLargeDraw) {
            symbolDraw && symbolDraw.remove();
            symbolDraw = this._symbolDraw = isLargeDraw ? new (0, $69bbf770a3ca2c75$export$2e2bcd8739ae039)() : new (0, $fedf62268297fcbb$export$2e2bcd8739ae039)();
            this._isLargeDraw = isLargeDraw;
            this.group.removeAll();
        }
        this.group.add(symbolDraw.group);
        return symbolDraw;
    };
    ScatterView.prototype.remove = function(ecModel, api) {
        this._symbolDraw && this._symbolDraw.remove(true);
        this._symbolDraw = null;
    };
    ScatterView.prototype.dispose = function() {};
    ScatterView.type = 'scatter';
    return ScatterView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $c92a7ada0c69ef68$export$2e2bcd8739ae039 = $c92a7ada0c69ef68$var$ScatterView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $d67c268180aaad04$var$GridModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(GridModel, _super);
    function GridModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GridModel.type = 'grid';
    GridModel.dependencies = [
        'xAxis',
        'yAxis'
    ];
    GridModel.layoutMode = 'box';
    GridModel.defaultOption = {
        show: false,
        // zlevel: 0,
        z: 0,
        left: '10%',
        top: 60,
        right: '10%',
        bottom: 70,
        // If grid size contain label
        containLabel: false,
        // width: {totalWidth} - left - right,
        // height: {totalHeight} - top - bottom,
        backgroundColor: 'rgba(0,0,0,0)',
        borderWidth: 1,
        borderColor: '#ccc'
    };
    return GridModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $d67c268180aaad04$export$2e2bcd8739ae039 = $d67c268180aaad04$var$GridModel;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $008426c98740266e$export$483dc37e6ad83a3c = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(CartesianAxisModel, _super);
    function CartesianAxisModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CartesianAxisModel.prototype.getCoordSysModel = function() {
        return this.getReferringComponents('grid', (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
    };
    CartesianAxisModel.type = 'cartesian2dAxis';
    return CartesianAxisModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
$7a1bd9c2710fea0d$export$e36fc9d62a853069($008426c98740266e$export$483dc37e6ad83a3c, (0, $3449fd4c0590d99e$export$5c54b224726edb5a));
var $008426c98740266e$export$2e2bcd8739ae039 = $008426c98740266e$export$483dc37e6ad83a3c;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Grid is a region which contains at most 4 cartesian systems
 *
 * TODO Default cartesian
 */ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $f0775b150bc00f28$var$Cartesian = /** @class */ function() {
    function Cartesian(name) {
        this.type = 'cartesian';
        this._dimList = [];
        this._axes = {};
        this.name = name || '';
    }
    Cartesian.prototype.getAxis = function(dim) {
        return this._axes[dim];
    };
    Cartesian.prototype.getAxes = function() {
        return $7a1bd9c2710fea0d$export$871de8747c9eaa88(this._dimList, function(dim) {
            return this._axes[dim];
        }, this);
    };
    Cartesian.prototype.getAxesByScale = function(scaleType) {
        scaleType = scaleType.toLowerCase();
        return $7a1bd9c2710fea0d$export$3dea766d36a8935f(this.getAxes(), function(axis) {
            return axis.scale.type === scaleType;
        });
    };
    Cartesian.prototype.addAxis = function(axis) {
        var dim = axis.dim;
        this._axes[dim] = axis;
        this._dimList.push(dim);
    };
    return Cartesian;
}();
var $f0775b150bc00f28$export$2e2bcd8739ae039 = $f0775b150bc00f28$var$Cartesian;




var $6bea838ef63ff2bb$export$988a008d2b9120f4 = [
    'x',
    'y'
];
function $6bea838ef63ff2bb$var$canCalculateAffineTransform(scale) {
    return scale.type === 'interval' || scale.type === 'time';
}
var $6bea838ef63ff2bb$var$Cartesian2D = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(Cartesian2D, _super);
    function Cartesian2D() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'cartesian2d';
        _this.dimensions = $6bea838ef63ff2bb$export$988a008d2b9120f4;
        return _this;
    }
    /**
   * Calculate an affine transform matrix if two axes are time or value.
   * It's mainly for accelartion on the large time series data.
   */ Cartesian2D.prototype.calcAffineTransform = function() {
        this._transform = this._invTransform = null;
        var xAxisScale = this.getAxis('x').scale;
        var yAxisScale = this.getAxis('y').scale;
        if (!$6bea838ef63ff2bb$var$canCalculateAffineTransform(xAxisScale) || !$6bea838ef63ff2bb$var$canCalculateAffineTransform(yAxisScale)) return;
        var xScaleExtent = xAxisScale.getExtent();
        var yScaleExtent = yAxisScale.getExtent();
        var start = this.dataToPoint([
            xScaleExtent[0],
            yScaleExtent[0]
        ]);
        var end = this.dataToPoint([
            xScaleExtent[1],
            yScaleExtent[1]
        ]);
        var xScaleSpan = xScaleExtent[1] - xScaleExtent[0];
        var yScaleSpan = yScaleExtent[1] - yScaleExtent[0];
        if (!xScaleSpan || !yScaleSpan) return;
        // Accelerate data to point calculation on the special large time series data.
        var scaleX = (end[0] - start[0]) / xScaleSpan;
        var scaleY = (end[1] - start[1]) / yScaleSpan;
        var translateX = start[0] - xScaleExtent[0] * scaleX;
        var translateY = start[1] - yScaleExtent[0] * scaleY;
        var m = this._transform = [
            scaleX,
            0,
            0,
            scaleY,
            translateX,
            translateY
        ];
        this._invTransform = (0, $f41ebb9dd60b55b4$export$6897c284b6f9f4dc)([], m);
    };
    /**
   * Base axis will be used on stacking.
   */ Cartesian2D.prototype.getBaseAxis = function() {
        return this.getAxesByScale('ordinal')[0] || this.getAxesByScale('time')[0] || this.getAxis('x');
    };
    Cartesian2D.prototype.containPoint = function(point) {
        var axisX = this.getAxis('x');
        var axisY = this.getAxis('y');
        return axisX.contain(axisX.toLocalCoord(point[0])) && axisY.contain(axisY.toLocalCoord(point[1]));
    };
    Cartesian2D.prototype.containData = function(data) {
        return this.getAxis('x').containData(data[0]) && this.getAxis('y').containData(data[1]);
    };
    Cartesian2D.prototype.containZone = function(data1, data2) {
        var zoneDiag1 = this.dataToPoint(data1);
        var zoneDiag2 = this.dataToPoint(data2);
        var area = this.getArea();
        var zone = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(zoneDiag1[0], zoneDiag1[1], zoneDiag2[0] - zoneDiag1[0], zoneDiag2[1] - zoneDiag1[1]);
        return area.intersect(zone);
    };
    Cartesian2D.prototype.dataToPoint = function(data, clamp, out) {
        out = out || [];
        var xVal = data[0];
        var yVal = data[1];
        // Fast path
        if (this._transform && xVal != null && isFinite(xVal) && yVal != null && isFinite(yVal)) return (0, $6de594cf8ac295ff$export$9f9dcb98c894b623)(out, data, this._transform);
        var xAxis = this.getAxis('x');
        var yAxis = this.getAxis('y');
        out[0] = xAxis.toGlobalCoord(xAxis.dataToCoord(xVal, clamp));
        out[1] = yAxis.toGlobalCoord(yAxis.dataToCoord(yVal, clamp));
        return out;
    };
    Cartesian2D.prototype.clampData = function(data, out) {
        var xScale = this.getAxis('x').scale;
        var yScale = this.getAxis('y').scale;
        var xAxisExtent = xScale.getExtent();
        var yAxisExtent = yScale.getExtent();
        var x = xScale.parse(data[0]);
        var y = yScale.parse(data[1]);
        out = out || [];
        out[0] = Math.min(Math.max(Math.min(xAxisExtent[0], xAxisExtent[1]), x), Math.max(xAxisExtent[0], xAxisExtent[1]));
        out[1] = Math.min(Math.max(Math.min(yAxisExtent[0], yAxisExtent[1]), y), Math.max(yAxisExtent[0], yAxisExtent[1]));
        return out;
    };
    Cartesian2D.prototype.pointToData = function(point, clamp) {
        var out = [];
        if (this._invTransform) return (0, $6de594cf8ac295ff$export$9f9dcb98c894b623)(out, point, this._invTransform);
        var xAxis = this.getAxis('x');
        var yAxis = this.getAxis('y');
        out[0] = xAxis.coordToData(xAxis.toLocalCoord(point[0]), clamp);
        out[1] = yAxis.coordToData(yAxis.toLocalCoord(point[1]), clamp);
        return out;
    };
    Cartesian2D.prototype.getOtherAxis = function(axis) {
        return this.getAxis(axis.dim === 'x' ? 'y' : 'x');
    };
    /**
   * Get rect area of cartesian.
   * Area will have a contain function to determine if a point is in the coordinate system.
   */ Cartesian2D.prototype.getArea = function(tolerance) {
        tolerance = tolerance || 0;
        var xExtent = this.getAxis('x').getGlobalExtent();
        var yExtent = this.getAxis('y').getGlobalExtent();
        var x = Math.min(xExtent[0], xExtent[1]) - tolerance;
        var y = Math.min(yExtent[0], yExtent[1]) - tolerance;
        var width = Math.max(xExtent[0], xExtent[1]) - x + tolerance;
        var height = Math.max(yExtent[0], yExtent[1]) - y + tolerance;
        return new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(x, y, width, height);
    };
    return Cartesian2D;
}((0, $f0775b150bc00f28$export$2e2bcd8739ae039));
var $6bea838ef63ff2bb$export$2e2bcd8739ae039 = $6bea838ef63ff2bb$var$Cartesian2D;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $23369073c2236a8d$var$Axis2D = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(Axis2D, _super);
    function Axis2D(dim, scale, coordExtent, axisType, position) {
        var _this = _super.call(this, dim, scale, coordExtent) || this;
        /**
     * Index of axis, can be used as key
     * Injected outside.
     */ _this.index = 0;
        _this.type = axisType || 'value';
        _this.position = position || 'bottom';
        return _this;
    }
    Axis2D.prototype.isHorizontal = function() {
        var position = this.position;
        return position === 'top' || position === 'bottom';
    };
    /**
   * Each item cooresponds to this.getExtent(), which
   * means globalExtent[0] may greater than globalExtent[1],
   * unless `asc` is input.
   *
   * @param {boolean} [asc]
   * @return {Array.<number>}
   */ Axis2D.prototype.getGlobalExtent = function(asc) {
        var ret = this.getExtent();
        ret[0] = this.toGlobalCoord(ret[0]);
        ret[1] = this.toGlobalCoord(ret[1]);
        asc && ret[0] > ret[1] && ret.reverse();
        return ret;
    };
    Axis2D.prototype.pointToData = function(point, clamp) {
        return this.coordToData(this.toLocalCoord(point[this.dim === 'x' ? 0 : 1]), clamp);
    };
    /**
   * Set ordinalSortInfo
   * @param info new OrdinalSortInfo
   */ Axis2D.prototype.setCategorySortInfo = function(info) {
        if (this.type !== 'category') return false;
        this.model.option.categorySortInfo = info;
        this.scale.setSortInfo(info);
    };
    return Axis2D;
}((0, $c2b1efffe5ae3f42$export$2e2bcd8739ae039));
var $23369073c2236a8d$export$2e2bcd8739ae039 = $23369073c2236a8d$var$Axis2D;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $88c937c9bc0ca068$export$b3219800bda33a1f(gridModel, axisModel, opt) {
    opt = opt || {};
    var grid = gridModel.coordinateSystem;
    var axis = axisModel.axis;
    var layout = {};
    var otherAxisOnZeroOf = axis.getAxesOnZeroOf()[0];
    var rawAxisPosition = axis.position;
    var axisPosition = otherAxisOnZeroOf ? 'onZero' : rawAxisPosition;
    var axisDim = axis.dim;
    var rect = grid.getRect();
    var rectBound = [
        rect.x,
        rect.x + rect.width,
        rect.y,
        rect.y + rect.height
    ];
    var idx = {
        left: 0,
        right: 1,
        top: 0,
        bottom: 1,
        onZero: 2
    };
    var axisOffset = axisModel.get('offset') || 0;
    var posBound = axisDim === 'x' ? [
        rectBound[2] - axisOffset,
        rectBound[3] + axisOffset
    ] : [
        rectBound[0] - axisOffset,
        rectBound[1] + axisOffset
    ];
    if (otherAxisOnZeroOf) {
        var onZeroCoord = otherAxisOnZeroOf.toGlobalCoord(otherAxisOnZeroOf.dataToCoord(0));
        posBound[idx.onZero] = Math.max(Math.min(onZeroCoord, posBound[1]), posBound[0]);
    }
    // Axis position
    layout.position = [
        axisDim === 'y' ? posBound[idx[axisPosition]] : rectBound[0],
        axisDim === 'x' ? posBound[idx[axisPosition]] : rectBound[3]
    ];
    // Axis rotation
    layout.rotation = Math.PI / 2 * (axisDim === 'x' ? 0 : 1);
    // Tick and label direction, x y is axisDim
    var dirMap = {
        top: -1,
        bottom: 1,
        left: -1,
        right: 1
    };
    layout.labelDirection = layout.tickDirection = layout.nameDirection = dirMap[rawAxisPosition];
    layout.labelOffset = otherAxisOnZeroOf ? posBound[idx[rawAxisPosition]] - posBound[idx.onZero] : 0;
    if (axisModel.get([
        'axisTick',
        'inside'
    ])) layout.tickDirection = -layout.tickDirection;
    if ($7a1bd9c2710fea0d$export$8a4d17b6e8486e66(opt.labelInside, axisModel.get([
        'axisLabel',
        'inside'
    ]))) layout.labelDirection = -layout.labelDirection;
    // Special label rotation
    var labelRotate = axisModel.get([
        'axisLabel',
        'rotate'
    ]);
    layout.labelRotate = axisPosition === 'top' ? -labelRotate : labelRotate;
    // Over splitLine and splitArea
    layout.z2 = 1;
    return layout;
}
function $88c937c9bc0ca068$export$c2a0b77974c5e35d(seriesModel) {
    return seriesModel.get('coordinateSystem') === 'cartesian2d';
}
function $88c937c9bc0ca068$export$8220131ac1d61d28(seriesModel) {
    var axisModelMap = {
        xAxisModel: null,
        yAxisModel: null
    };
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(axisModelMap, function(v, key) {
        var axisType = key.replace(/Model$/, '');
        var axisModel = seriesModel.getReferringComponents(axisType, (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
        axisModelMap[key] = axisModel;
    });
    return axisModelMap;
}




var $8e1d1b12d8439742$var$Grid = /** @class */ function() {
    function Grid(gridModel, ecModel, api) {
        // FIXME:TS where used (different from registered type 'cartesian2d')?
        this.type = 'grid';
        this._coordsMap = {};
        this._coordsList = [];
        this._axesMap = {};
        this._axesList = [];
        this.axisPointerEnabled = true;
        this.dimensions = (0, $6bea838ef63ff2bb$export$988a008d2b9120f4);
        this._initCartesian(gridModel, ecModel, api);
        this.model = gridModel;
    }
    Grid.prototype.getRect = function() {
        return this._rect;
    };
    Grid.prototype.update = function(ecModel, api) {
        var axesMap = this._axesMap;
        this._updateScale(ecModel, this.model);
        function updateAxisTicks(axes) {
            var alignTo;
            // Axis is added in order of axisIndex.
            var axesIndices = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(axes);
            var len = axesIndices.length;
            if (!len) return;
            var axisNeedsAlign = [];
            // Process once and calculate the ticks for those don't use alignTicks.
            for(var i = len - 1; i >= 0; i--){
                var idx = +axesIndices[i]; // Convert to number.
                var axis = axes[idx];
                var model = axis.model;
                var scale = axis.scale;
                if (// Only value and log axis without interval support alignTicks.
                (0, $60f7f1f3e3996637$export$dfc8cd28ed7b22a0)(scale) && model.get('alignTicks') && model.get('interval') == null) axisNeedsAlign.push(axis);
                else {
                    (0, $2d646e51cc34f840$export$51f3e70a54405d5a)(scale, model);
                    if ((0, $60f7f1f3e3996637$export$dfc8cd28ed7b22a0)(scale)) // Can only align to interval or log axis.
                    alignTo = axis;
                }
            }
            // All axes has set alignTicks. Pick the first one.
            // PENDING. Should we find the axis that both set interval, min, max and align to this one?
            if (axisNeedsAlign.length) {
                if (!alignTo) {
                    alignTo = axisNeedsAlign.pop();
                    (0, $2d646e51cc34f840$export$51f3e70a54405d5a)(alignTo.scale, alignTo.model);
                }
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axisNeedsAlign, function(axis) {
                    (0, $0591b52263f31374$export$c0b3be0e9eb0c2d9)(axis.scale, axis.model, alignTo.scale);
                });
            }
        }
        updateAxisTicks(axesMap.x);
        updateAxisTicks(axesMap.y);
        // Key: axisDim_axisIndex, value: boolean, whether onZero target.
        var onZeroRecords = {};
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axesMap.x, function(xAxis) {
            $8e1d1b12d8439742$var$fixAxisOnZero(axesMap, 'y', xAxis, onZeroRecords);
        });
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axesMap.y, function(yAxis) {
            $8e1d1b12d8439742$var$fixAxisOnZero(axesMap, 'x', yAxis, onZeroRecords);
        });
        // Resize again if containLabel is enabled
        // FIXME It may cause getting wrong grid size in data processing stage
        this.resize(this.model, api);
    };
    /**
   * Resize the grid
   */ Grid.prototype.resize = function(gridModel, api, ignoreContainLabel) {
        var boxLayoutParams = gridModel.getBoxLayoutParams();
        var isContainLabel = !ignoreContainLabel && gridModel.get('containLabel');
        var gridRect = (0, $93b9bc7f22ac7369$export$4517a5ca639a7293)(boxLayoutParams, {
            width: api.getWidth(),
            height: api.getHeight()
        });
        this._rect = gridRect;
        var axesList = this._axesList;
        adjustAxes();
        // Minus label size
        if (isContainLabel) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axesList, function(axis) {
                if (!axis.model.get([
                    'axisLabel',
                    'inside'
                ])) {
                    var labelUnionRect = (0, $2d646e51cc34f840$export$fef1c7f0af0b48d)(axis);
                    if (labelUnionRect) {
                        var dim = axis.isHorizontal() ? 'height' : 'width';
                        var margin = axis.model.get([
                            'axisLabel',
                            'margin'
                        ]);
                        gridRect[dim] -= labelUnionRect[dim] + margin;
                        if (axis.position === 'top') gridRect.y += labelUnionRect.height + margin;
                        else if (axis.position === 'left') gridRect.x += labelUnionRect.width + margin;
                    }
                }
            });
            adjustAxes();
        }
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._coordsList, function(coord) {
            // Calculate affine matrix to accelerate the data to point transform.
            // If all the axes scales are time or value.
            coord.calcAffineTransform();
        });
        function adjustAxes() {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axesList, function(axis) {
                var isHorizontal = axis.isHorizontal();
                var extent = isHorizontal ? [
                    0,
                    gridRect.width
                ] : [
                    0,
                    gridRect.height
                ];
                var idx = axis.inverse ? 1 : 0;
                axis.setExtent(extent[idx], extent[1 - idx]);
                $8e1d1b12d8439742$var$updateAxisTransform(axis, isHorizontal ? gridRect.x : gridRect.y);
            });
        }
    };
    Grid.prototype.getAxis = function(dim, axisIndex) {
        var axesMapOnDim = this._axesMap[dim];
        if (axesMapOnDim != null) return axesMapOnDim[axisIndex || 0];
    };
    Grid.prototype.getAxes = function() {
        return this._axesList.slice();
    };
    Grid.prototype.getCartesian = function(xAxisIndex, yAxisIndex) {
        if (xAxisIndex != null && yAxisIndex != null) {
            var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
            return this._coordsMap[key];
        }
        if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(xAxisIndex)) {
            yAxisIndex = xAxisIndex.yAxisIndex;
            xAxisIndex = xAxisIndex.xAxisIndex;
        }
        for(var i = 0, coordList = this._coordsList; i < coordList.length; i++){
            if (coordList[i].getAxis('x').index === xAxisIndex || coordList[i].getAxis('y').index === yAxisIndex) return coordList[i];
        }
    };
    Grid.prototype.getCartesians = function() {
        return this._coordsList.slice();
    };
    /**
   * @implements
   */ Grid.prototype.convertToPixel = function(ecModel, finder, value) {
        var target = this._findConvertTarget(finder);
        return target.cartesian ? target.cartesian.dataToPoint(value) : target.axis ? target.axis.toGlobalCoord(target.axis.dataToCoord(value)) : null;
    };
    /**
   * @implements
   */ Grid.prototype.convertFromPixel = function(ecModel, finder, value) {
        var target = this._findConvertTarget(finder);
        return target.cartesian ? target.cartesian.pointToData(value) : target.axis ? target.axis.coordToData(target.axis.toLocalCoord(value)) : null;
    };
    Grid.prototype._findConvertTarget = function(finder) {
        var seriesModel = finder.seriesModel;
        var xAxisModel = finder.xAxisModel || seriesModel && seriesModel.getReferringComponents('xAxis', (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
        var yAxisModel = finder.yAxisModel || seriesModel && seriesModel.getReferringComponents('yAxis', (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
        var gridModel = finder.gridModel;
        var coordsList = this._coordsList;
        var cartesian;
        var axis;
        if (seriesModel) {
            cartesian = seriesModel.coordinateSystem;
            (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(coordsList, cartesian) < 0 && (cartesian = null);
        } else if (xAxisModel && yAxisModel) cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
        else if (xAxisModel) axis = this.getAxis('x', xAxisModel.componentIndex);
        else if (yAxisModel) axis = this.getAxis('y', yAxisModel.componentIndex);
        else if (gridModel) {
            var grid = gridModel.coordinateSystem;
            if (grid === this) cartesian = this._coordsList[0];
        }
        return {
            cartesian: cartesian,
            axis: axis
        };
    };
    /**
   * @implements
   */ Grid.prototype.containPoint = function(point) {
        var coord = this._coordsList[0];
        if (coord) return coord.containPoint(point);
    };
    /**
   * Initialize cartesian coordinate systems
   */ Grid.prototype._initCartesian = function(gridModel, ecModel, api) {
        var _this = this;
        var grid = this;
        var axisPositionUsed = {
            left: false,
            right: false,
            top: false,
            bottom: false
        };
        var axesMap = {
            x: {},
            y: {}
        };
        var axesCount = {
            x: 0,
            y: 0
        };
        // Create axis
        ecModel.eachComponent('xAxis', createAxisCreator('x'), this);
        ecModel.eachComponent('yAxis', createAxisCreator('y'), this);
        if (!axesCount.x || !axesCount.y) {
            // Roll back when there no either x or y axis
            this._axesMap = {};
            this._axesList = [];
            return;
        }
        this._axesMap = axesMap;
        // Create cartesian2d
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axesMap.x, function(xAxis, xAxisIndex) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axesMap.y, function(yAxis, yAxisIndex) {
                var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
                var cartesian = new (0, $6bea838ef63ff2bb$export$2e2bcd8739ae039)(key);
                cartesian.master = _this;
                cartesian.model = gridModel;
                _this._coordsMap[key] = cartesian;
                _this._coordsList.push(cartesian);
                cartesian.addAxis(xAxis);
                cartesian.addAxis(yAxis);
            });
        });
        function createAxisCreator(dimName) {
            return function(axisModel, idx) {
                if (!$8e1d1b12d8439742$var$isAxisUsedInTheGrid(axisModel, gridModel)) return;
                var axisPosition = axisModel.get('position');
                if (dimName === 'x') // Fix position
                {
                    if (axisPosition !== 'top' && axisPosition !== 'bottom') // Default bottom of X
                    axisPosition = axisPositionUsed.bottom ? 'top' : 'bottom';
                } else // Fix position
                if (axisPosition !== 'left' && axisPosition !== 'right') // Default left of Y
                axisPosition = axisPositionUsed.left ? 'right' : 'left';
                axisPositionUsed[axisPosition] = true;
                var axis = new (0, $23369073c2236a8d$export$2e2bcd8739ae039)(dimName, (0, $2d646e51cc34f840$export$8941c4cacdc8f5a5)(axisModel), [
                    0,
                    0
                ], axisModel.get('type'), axisPosition);
                var isCategory = axis.type === 'category';
                axis.onBand = isCategory && axisModel.get('boundaryGap');
                axis.inverse = axisModel.get('inverse');
                // Inject axis into axisModel
                axisModel.axis = axis;
                // Inject axisModel into axis
                axis.model = axisModel;
                // Inject grid info axis
                axis.grid = grid;
                // Index of axis, can be used as key
                axis.index = idx;
                grid._axesList.push(axis);
                axesMap[dimName][idx] = axis;
                axesCount[dimName]++;
            };
        }
    };
    /**
   * Update cartesian properties from series.
   */ Grid.prototype._updateScale = function(ecModel, gridModel) {
        // Reset scale
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._axesList, function(axis) {
            axis.scale.setExtent(Infinity, -Infinity);
            if (axis.type === 'category') {
                var categorySortInfo = axis.model.get('categorySortInfo');
                axis.scale.setSortInfo(categorySortInfo);
            }
        });
        ecModel.eachSeries(function(seriesModel) {
            if ((0, $88c937c9bc0ca068$export$c2a0b77974c5e35d)(seriesModel)) {
                var axesModelMap = (0, $88c937c9bc0ca068$export$8220131ac1d61d28)(seriesModel);
                var xAxisModel = axesModelMap.xAxisModel;
                var yAxisModel = axesModelMap.yAxisModel;
                if (!$8e1d1b12d8439742$var$isAxisUsedInTheGrid(xAxisModel, gridModel) || !$8e1d1b12d8439742$var$isAxisUsedInTheGrid(yAxisModel, gridModel)) return;
                var cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
                var data = seriesModel.getData();
                var xAxis = cartesian.getAxis('x');
                var yAxis = cartesian.getAxis('y');
                unionExtent(data, xAxis);
                unionExtent(data, yAxis);
            }
        }, this);
        function unionExtent(data, axis) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $2d646e51cc34f840$export$e4cf30b1e74cd69d)(data, axis.dim), function(dim) {
                axis.scale.unionExtentFromData(data, dim);
            });
        }
    };
    /**
   * @param dim 'x' or 'y' or 'auto' or null/undefined
   */ Grid.prototype.getTooltipAxes = function(dim) {
        var baseAxes = [];
        var otherAxes = [];
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this.getCartesians(), function(cartesian) {
            var baseAxis = dim != null && dim !== 'auto' ? cartesian.getAxis(dim) : cartesian.getBaseAxis();
            var otherAxis = cartesian.getOtherAxis(baseAxis);
            (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(baseAxes, baseAxis) < 0 && baseAxes.push(baseAxis);
            (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(otherAxes, otherAxis) < 0 && otherAxes.push(otherAxis);
        });
        return {
            baseAxes: baseAxes,
            otherAxes: otherAxes
        };
    };
    Grid.create = function(ecModel, api) {
        var grids = [];
        ecModel.eachComponent('grid', function(gridModel, idx) {
            var grid = new Grid(gridModel, ecModel, api);
            grid.name = 'grid_' + idx;
            // dataSampling requires axis extent, so resize
            // should be performed in create stage.
            grid.resize(gridModel, api, true);
            gridModel.coordinateSystem = grid;
            grids.push(grid);
        });
        // Inject the coordinateSystems into seriesModel
        ecModel.eachSeries(function(seriesModel) {
            if (!(0, $88c937c9bc0ca068$export$c2a0b77974c5e35d)(seriesModel)) return;
            var axesModelMap = (0, $88c937c9bc0ca068$export$8220131ac1d61d28)(seriesModel);
            var xAxisModel = axesModelMap.xAxisModel;
            var yAxisModel = axesModelMap.yAxisModel;
            var gridModel = xAxisModel.getCoordSysModel();
            var grid = gridModel.coordinateSystem;
            seriesModel.coordinateSystem = grid.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
        });
        return grids;
    };
    // For deciding which dimensions to use when creating list data
    Grid.dimensions = (0, $6bea838ef63ff2bb$export$988a008d2b9120f4);
    return Grid;
}();
/**
 * Check if the axis is used in the specified grid.
 */ function $8e1d1b12d8439742$var$isAxisUsedInTheGrid(axisModel, gridModel) {
    return axisModel.getCoordSysModel() === gridModel;
}
function $8e1d1b12d8439742$var$fixAxisOnZero(axesMap, otherAxisDim, axis, // Key: see `getOnZeroRecordKey`
onZeroRecords) {
    axis.getAxesOnZeroOf = function() {
        // TODO: onZero of multiple axes.
        return otherAxisOnZeroOf ? [
            otherAxisOnZeroOf
        ] : [];
    };
    // onZero can not be enabled in these two situations:
    // 1. When any other axis is a category axis.
    // 2. When no axis is cross 0 point.
    var otherAxes = axesMap[otherAxisDim];
    var otherAxisOnZeroOf;
    var axisModel = axis.model;
    var onZero = axisModel.get([
        'axisLine',
        'onZero'
    ]);
    var onZeroAxisIndex = axisModel.get([
        'axisLine',
        'onZeroAxisIndex'
    ]);
    if (!onZero) return;
    // If target axis is specified.
    if (onZeroAxisIndex != null) {
        if ($8e1d1b12d8439742$var$canOnZeroToAxis(otherAxes[onZeroAxisIndex])) otherAxisOnZeroOf = otherAxes[onZeroAxisIndex];
    } else {
        // Find the first available other axis.
        for(var idx in otherAxes)if (otherAxes.hasOwnProperty(idx) && $8e1d1b12d8439742$var$canOnZeroToAxis(otherAxes[idx]) && !onZeroRecords[getOnZeroRecordKey(otherAxes[idx])]) {
            otherAxisOnZeroOf = otherAxes[idx];
            break;
        }
    }
    if (otherAxisOnZeroOf) onZeroRecords[getOnZeroRecordKey(otherAxisOnZeroOf)] = true;
    function getOnZeroRecordKey(axis) {
        return axis.dim + '_' + axis.index;
    }
}
function $8e1d1b12d8439742$var$canOnZeroToAxis(axis) {
    return axis && axis.type !== 'category' && axis.type !== 'time' && (0, $2d646e51cc34f840$export$3eac36a69f37d52)(axis);
}
function $8e1d1b12d8439742$var$updateAxisTransform(axis, coordBase) {
    var axisExtent = axis.getExtent();
    var axisExtentSum = axisExtent[0] + axisExtent[1];
    // Fast transform
    axis.toGlobalCoord = axis.dim === 'x' ? function(coord) {
        return coord + coordBase;
    } : function(coord) {
        return axisExtentSum - coord + coordBase;
    };
    axis.toLocalCoord = axis.dim === 'x' ? function(coord) {
        return coord - coordBase;
    } : function(coord) {
        return axisExtentSum - coord + coordBase;
    };
}
var $8e1d1b12d8439742$export$2e2bcd8739ae039 = $8e1d1b12d8439742$var$Grid;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $84d826b9ba8bf009$export$bb44f104e3c54dae(ecModel, api) {
    var result = {
        /**
     * key: makeKey(axis.model)
     * value: {
     *      axis,
     *      coordSys,
     *      axisPointerModel,
     *      triggerTooltip,
     *      triggerEmphasis,
     *      involveSeries,
     *      snap,
     *      seriesModels,
     *      seriesDataCount
     * }
     */ axesInfo: {},
        seriesInvolved: false,
        /**
     * key: makeKey(coordSys.model)
     * value: Object: key makeKey(axis.model), value: axisInfo
     */ coordSysAxesInfo: {},
        coordSysMap: {}
    };
    $84d826b9ba8bf009$var$collectAxesInfo(result, ecModel, api);
    // Check seriesInvolved for performance, in case too many series in some chart.
    result.seriesInvolved && $84d826b9ba8bf009$var$collectSeriesInfo(result, ecModel);
    return result;
}
function $84d826b9ba8bf009$var$collectAxesInfo(result, ecModel, api) {
    var globalTooltipModel = ecModel.getComponent('tooltip');
    var globalAxisPointerModel = ecModel.getComponent('axisPointer');
    // links can only be set on global.
    var linksOption = globalAxisPointerModel.get('link', true) || [];
    var linkGroups = [];
    // Collect axes info.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(api.getCoordinateSystems(), function(coordSys) {
        // Some coordinate system do not support axes, like geo.
        if (!coordSys.axisPointerEnabled) return;
        var coordSysKey = $84d826b9ba8bf009$export$d01b444bafb1a792(coordSys.model);
        var axesInfoInCoordSys = result.coordSysAxesInfo[coordSysKey] = {};
        result.coordSysMap[coordSysKey] = coordSys;
        // Set tooltip (like 'cross') is a convenient way to show axisPointer
        // for user. So we enable setting tooltip on coordSys model.
        var coordSysModel = coordSys.model;
        var baseTooltipModel = coordSysModel.getModel('tooltip', globalTooltipModel);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(coordSys.getAxes(), (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)(saveTooltipAxisInfo, false, null));
        // If axis tooltip used, choose tooltip axis for each coordSys.
        // Notice this case: coordSys is `grid` but not `cartesian2D` here.
        if (coordSys.getTooltipAxes && globalTooltipModel && baseTooltipModel.get('show')) {
            // Compatible with previous logic. But series.tooltip.trigger: 'axis'
            // or series.data[n].tooltip.trigger: 'axis' are not support any more.
            var triggerAxis = baseTooltipModel.get('trigger') === 'axis';
            var cross = baseTooltipModel.get([
                'axisPointer',
                'type'
            ]) === 'cross';
            var tooltipAxes = coordSys.getTooltipAxes(baseTooltipModel.get([
                'axisPointer',
                'axis'
            ]));
            if (triggerAxis || cross) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(tooltipAxes.baseAxes, (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)(saveTooltipAxisInfo, cross ? 'cross' : true, triggerAxis));
            if (cross) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(tooltipAxes.otherAxes, (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)(saveTooltipAxisInfo, 'cross', false));
        }
        // fromTooltip: true | false | 'cross'
        // triggerTooltip: true | false | null
        function saveTooltipAxisInfo(fromTooltip, triggerTooltip, axis) {
            var axisPointerModel = axis.model.getModel('axisPointer', globalAxisPointerModel);
            var axisPointerShow = axisPointerModel.get('show');
            if (!axisPointerShow || axisPointerShow === 'auto' && !fromTooltip && !$84d826b9ba8bf009$var$isHandleTrigger(axisPointerModel)) return;
            if (triggerTooltip == null) triggerTooltip = axisPointerModel.get('triggerTooltip');
            axisPointerModel = fromTooltip ? $84d826b9ba8bf009$var$makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) : axisPointerModel;
            var snap = axisPointerModel.get('snap');
            var triggerEmphasis = axisPointerModel.get('triggerEmphasis');
            var axisKey = $84d826b9ba8bf009$export$d01b444bafb1a792(axis.model);
            var involveSeries = triggerTooltip || snap || axis.type === 'category';
            // If result.axesInfo[key] exist, override it (tooltip has higher priority).
            var axisInfo = result.axesInfo[axisKey] = {
                key: axisKey,
                axis: axis,
                coordSys: coordSys,
                axisPointerModel: axisPointerModel,
                triggerTooltip: triggerTooltip,
                triggerEmphasis: triggerEmphasis,
                involveSeries: involveSeries,
                snap: snap,
                useHandle: $84d826b9ba8bf009$var$isHandleTrigger(axisPointerModel),
                seriesModels: [],
                linkGroup: null
            };
            axesInfoInCoordSys[axisKey] = axisInfo;
            result.seriesInvolved = result.seriesInvolved || involveSeries;
            var groupIndex = $84d826b9ba8bf009$var$getLinkGroupIndex(linksOption, axis);
            if (groupIndex != null) {
                var linkGroup = linkGroups[groupIndex] || (linkGroups[groupIndex] = {
                    axesInfo: {}
                });
                linkGroup.axesInfo[axisKey] = axisInfo;
                linkGroup.mapper = linksOption[groupIndex].mapper;
                axisInfo.linkGroup = linkGroup;
            }
        }
    });
}
function $84d826b9ba8bf009$var$makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) {
    var tooltipAxisPointerModel = baseTooltipModel.getModel('axisPointer');
    var fields = [
        'type',
        'snap',
        'lineStyle',
        'shadowStyle',
        'label',
        'animation',
        'animationDurationUpdate',
        'animationEasingUpdate',
        'z'
    ];
    var volatileOption = {};
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(fields, function(field) {
        volatileOption[field] = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(tooltipAxisPointerModel.get(field));
    });
    // category axis do not auto snap, otherwise some tick that do not
    // has value can not be hovered. value/time/log axis default snap if
    // triggered from tooltip and trigger tooltip.
    volatileOption.snap = axis.type !== 'category' && !!triggerTooltip;
    // Compatible with previous behavior, tooltip axis does not show label by default.
    // Only these properties can be overridden from tooltip to axisPointer.
    if (tooltipAxisPointerModel.get('type') === 'cross') volatileOption.type = 'line';
    var labelOption = volatileOption.label || (volatileOption.label = {});
    // Follow the convention, do not show label when triggered by tooltip by default.
    labelOption.show == null && (labelOption.show = false);
    if (fromTooltip === 'cross') {
        // When 'cross', both axes show labels.
        var tooltipAxisPointerLabelShow = tooltipAxisPointerModel.get([
            'label',
            'show'
        ]);
        labelOption.show = tooltipAxisPointerLabelShow != null ? tooltipAxisPointerLabelShow : true;
        // If triggerTooltip, this is a base axis, which should better not use cross style
        // (cross style is dashed by default)
        if (!triggerTooltip) {
            var crossStyle = volatileOption.lineStyle = tooltipAxisPointerModel.get('crossStyle');
            crossStyle && (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(labelOption, crossStyle.textStyle);
        }
    }
    return axis.model.getModel('axisPointer', new (0, $6818646a97528290$export$2e2bcd8739ae039)(volatileOption, globalAxisPointerModel, ecModel));
}
function $84d826b9ba8bf009$var$collectSeriesInfo(result, ecModel) {
    // Prepare data for axis trigger
    ecModel.eachSeries(function(seriesModel) {
        // Notice this case: this coordSys is `cartesian2D` but not `grid`.
        var coordSys = seriesModel.coordinateSystem;
        var seriesTooltipTrigger = seriesModel.get([
            'tooltip',
            'trigger'
        ], true);
        var seriesTooltipShow = seriesModel.get([
            'tooltip',
            'show'
        ], true);
        if (!coordSys || seriesTooltipTrigger === 'none' || seriesTooltipTrigger === false || seriesTooltipTrigger === 'item' || seriesTooltipShow === false || seriesModel.get([
            'axisPointer',
            'show'
        ], true) === false) return;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(result.coordSysAxesInfo[$84d826b9ba8bf009$export$d01b444bafb1a792(coordSys.model)], function(axisInfo) {
            var axis = axisInfo.axis;
            if (coordSys.getAxis(axis.dim) === axis) {
                axisInfo.seriesModels.push(seriesModel);
                axisInfo.seriesDataCount == null && (axisInfo.seriesDataCount = 0);
                axisInfo.seriesDataCount += seriesModel.getData().count();
            }
        });
    });
}
/**
 * For example:
 * {
 *     axisPointer: {
 *         links: [{
 *             xAxisIndex: [2, 4],
 *             yAxisIndex: 'all'
 *         }, {
 *             xAxisId: ['a5', 'a7'],
 *             xAxisName: 'xxx'
 *         }]
 *     }
 * }
 */ function $84d826b9ba8bf009$var$getLinkGroupIndex(linksOption, axis) {
    var axisModel = axis.model;
    var dim = axis.dim;
    for(var i = 0; i < linksOption.length; i++){
        var linkOption = linksOption[i] || {};
        if ($84d826b9ba8bf009$var$checkPropInLink(linkOption[dim + 'AxisId'], axisModel.id) || $84d826b9ba8bf009$var$checkPropInLink(linkOption[dim + 'AxisIndex'], axisModel.componentIndex) || $84d826b9ba8bf009$var$checkPropInLink(linkOption[dim + 'AxisName'], axisModel.name)) return i;
    }
}
function $84d826b9ba8bf009$var$checkPropInLink(linkPropValue, axisPropValue) {
    return linkPropValue === 'all' || (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(linkPropValue) && (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(linkPropValue, axisPropValue) >= 0 || linkPropValue === axisPropValue;
}
function $84d826b9ba8bf009$export$f5ea32e3629d8043(axisModel) {
    var axisInfo = $84d826b9ba8bf009$export$bd39458db76002ab(axisModel);
    if (!axisInfo) return;
    var axisPointerModel = axisInfo.axisPointerModel;
    var scale = axisInfo.axis.scale;
    var option = axisPointerModel.option;
    var status = axisPointerModel.get('status');
    var value = axisPointerModel.get('value');
    // Parse init value for category and time axis.
    if (value != null) value = scale.parse(value);
    var useHandle = $84d826b9ba8bf009$var$isHandleTrigger(axisPointerModel);
    // If `handle` used, `axisPointer` will always be displayed, so value
    // and status should be initialized.
    if (status == null) option.status = useHandle ? 'show' : 'hide';
    var extent = scale.getExtent().slice();
    extent[0] > extent[1] && extent.reverse();
    if (// Pick a value on axis when initializing.
    value == null || value > extent[1]) // Make handle displayed on the end of the axis when init, which looks better.
    value = extent[1];
    if (value < extent[0]) value = extent[0];
    option.value = value;
    if (useHandle) option.status = axisInfo.axis.scale.isBlank() ? 'hide' : 'show';
}
function $84d826b9ba8bf009$export$bd39458db76002ab(axisModel) {
    var coordSysAxesInfo = (axisModel.ecModel.getComponent('axisPointer') || {}).coordSysAxesInfo;
    return coordSysAxesInfo && coordSysAxesInfo.axesInfo[$84d826b9ba8bf009$export$d01b444bafb1a792(axisModel)];
}
function $84d826b9ba8bf009$export$3b06fce3f68b734(axisModel) {
    var axisInfo = $84d826b9ba8bf009$export$bd39458db76002ab(axisModel);
    return axisInfo && axisInfo.axisPointerModel;
}
function $84d826b9ba8bf009$var$isHandleTrigger(axisPointerModel) {
    return !!axisPointerModel.get([
        'handle',
        'show'
    ]);
}
function $84d826b9ba8bf009$export$d01b444bafb1a792(model) {
    return model.type + '||' + model.id;
}



var $58c48a3ef1aa0746$var$axisPointerClazz = {};
/**
 * Base class of AxisView.
 */ var $58c48a3ef1aa0746$var$AxisView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(AxisView, _super);
    function AxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AxisView.type;
        return _this;
    }
    /**
   * @override
   */ AxisView.prototype.render = function(axisModel, ecModel, api, payload) {
        // FIXME
        // This process should proformed after coordinate systems updated
        // (axis scale updated), and should be performed each time update.
        // So put it here temporarily, although it is not appropriate to
        // put a model-writing procedure in `view`.
        this.axisPointerClass && $84d826b9ba8bf009$export$f5ea32e3629d8043(axisModel);
        _super.prototype.render.apply(this, arguments);
        this._doUpdateAxisPointerClass(axisModel, api, true);
    };
    /**
   * Action handler.
   */ AxisView.prototype.updateAxisPointer = function(axisModel, ecModel, api, payload) {
        this._doUpdateAxisPointerClass(axisModel, api, false);
    };
    /**
   * @override
   */ AxisView.prototype.remove = function(ecModel, api) {
        var axisPointer = this._axisPointer;
        axisPointer && axisPointer.remove(api);
    };
    /**
   * @override
   */ AxisView.prototype.dispose = function(ecModel, api) {
        this._disposeAxisPointer(api);
        _super.prototype.dispose.apply(this, arguments);
    };
    AxisView.prototype._doUpdateAxisPointerClass = function(axisModel, api, forceRender) {
        var Clazz = AxisView.getAxisPointerClass(this.axisPointerClass);
        if (!Clazz) return;
        var axisPointerModel = $84d826b9ba8bf009$export$3b06fce3f68b734(axisModel);
        axisPointerModel ? (this._axisPointer || (this._axisPointer = new Clazz())).render(axisModel, axisPointerModel, api, forceRender) : this._disposeAxisPointer(api);
    };
    AxisView.prototype._disposeAxisPointer = function(api) {
        this._axisPointer && this._axisPointer.dispose(api);
        this._axisPointer = null;
    };
    AxisView.registerAxisPointerClass = function(type, clazz) {
        $58c48a3ef1aa0746$var$axisPointerClazz[type] = clazz;
    };
    AxisView.getAxisPointerClass = function(type) {
        return type && $58c48a3ef1aa0746$var$axisPointerClazz[type];
    };
    AxisView.type = 'axis';
    return AxisView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $58c48a3ef1aa0746$export$2e2bcd8739ae039 = $58c48a3ef1aa0746$var$AxisView;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $ff3096b1f24c33b6$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $ff3096b1f24c33b6$export$c80b7ef1527ec8c9(axisView, axisGroup, axisModel, gridModel) {
    var axis = axisModel.axis;
    if (axis.scale.isBlank()) return;
    // TODO: TYPE
    var splitAreaModel = axisModel.getModel('splitArea');
    var areaStyleModel = splitAreaModel.getModel('areaStyle');
    var areaColors = areaStyleModel.get('color');
    var gridRect = gridModel.coordinateSystem.getRect();
    var ticksCoords = axis.getTicksCoords({
        tickModel: splitAreaModel,
        clamp: true
    });
    if (!ticksCoords.length) return;
    // For Making appropriate splitArea animation, the color and anid
    // should be corresponding to previous one if possible.
    var areaColorsLen = areaColors.length;
    var lastSplitAreaColors = $ff3096b1f24c33b6$var$inner(axisView).splitAreaColors;
    var newSplitAreaColors = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
    var colorIndex = 0;
    if (lastSplitAreaColors) for(var i = 0; i < ticksCoords.length; i++){
        var cIndex = lastSplitAreaColors.get(ticksCoords[i].tickValue);
        if (cIndex != null) {
            colorIndex = (cIndex + (areaColorsLen - 1) * i) % areaColorsLen;
            break;
        }
    }
    var prev = axis.toGlobalCoord(ticksCoords[0].coord);
    var areaStyle = areaStyleModel.getAreaStyle();
    areaColors = $7a1bd9c2710fea0d$export$43bee75e5e14138e(areaColors) ? areaColors : [
        areaColors
    ];
    for(var i = 1; i < ticksCoords.length; i++){
        var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
        var x = void 0;
        var y = void 0;
        var width = void 0;
        var height = void 0;
        if (axis.isHorizontal()) {
            x = prev;
            y = gridRect.y;
            width = tickCoord - x;
            height = gridRect.height;
            prev = x + width;
        } else {
            x = gridRect.x;
            y = prev;
            width = gridRect.width;
            height = tickCoord - y;
            prev = y + height;
        }
        var tickValue = ticksCoords[i - 1].tickValue;
        tickValue != null && newSplitAreaColors.set(tickValue, colorIndex);
        axisGroup.add(new $419e5ff2f303755e$export$2e2bcd8739ae039({
            anid: tickValue != null ? 'area_' + tickValue : null,
            shape: {
                x: x,
                y: y,
                width: width,
                height: height
            },
            style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                fill: areaColors[colorIndex]
            }, areaStyle),
            autoBatch: true,
            silent: true
        }));
        colorIndex = (colorIndex + 1) % areaColorsLen;
    }
    $ff3096b1f24c33b6$var$inner(axisView).splitAreaColors = newSplitAreaColors;
}
function $ff3096b1f24c33b6$export$48ebf2d6ce8ad076(axisView) {
    $ff3096b1f24c33b6$var$inner(axisView).splitAreaColors = null;
}



var $c87c0ba584696283$var$axisBuilderAttrs = [
    'axisLine',
    'axisTickLabel',
    'axisName'
];
var $c87c0ba584696283$var$selfBuilderAttrs = [
    'splitArea',
    'splitLine',
    'minorSplitLine'
];
var $c87c0ba584696283$var$CartesianAxisView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(CartesianAxisView, _super);
    function CartesianAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CartesianAxisView.type;
        _this.axisPointerClass = 'CartesianAxisPointer';
        return _this;
    }
    /**
   * @override
   */ CartesianAxisView.prototype.render = function(axisModel, ecModel, api, payload) {
        this.group.removeAll();
        var oldAxisGroup = this._axisGroup;
        this._axisGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        this.group.add(this._axisGroup);
        if (!axisModel.get('show')) return;
        var gridModel = axisModel.getCoordSysModel();
        var layout = $88c937c9bc0ca068$export$b3219800bda33a1f(gridModel, axisModel);
        var axisBuilder = new (0, $dfe15f745e1c3c2b$export$2e2bcd8739ae039)(axisModel, $7a1bd9c2710fea0d$export$8b58be045bf06082({
            handleAutoShown: function(elementType) {
                var cartesians = gridModel.coordinateSystem.getCartesians();
                for(var i = 0; i < cartesians.length; i++){
                    if ((0, $60f7f1f3e3996637$export$dfc8cd28ed7b22a0)(cartesians[i].getOtherAxis(axisModel.axis).scale)) // Still show axis tick or axisLine if other axis is value / log
                    return true;
                }
                // Not show axisTick or axisLine if other axis is category / time
                return false;
            }
        }, layout));
        $7a1bd9c2710fea0d$export$79b2f7037acddd43($c87c0ba584696283$var$axisBuilderAttrs, axisBuilder.add, axisBuilder);
        this._axisGroup.add(axisBuilder.getGroup());
        $7a1bd9c2710fea0d$export$79b2f7037acddd43($c87c0ba584696283$var$selfBuilderAttrs, function(name) {
            if (axisModel.get([
                name,
                'show'
            ])) $c87c0ba584696283$var$axisElementBuilders[name](this, this._axisGroup, axisModel, gridModel);
        }, this);
        // THIS is a special case for bar racing chart.
        // Update the axis label from the natural initial layout to
        // sorted layout should has no animation.
        var isInitialSortFromBarRacing = payload && payload.type === 'changeAxisOrder' && payload.isInitSort;
        if (!isInitialSortFromBarRacing) $5b455ae6f843ac47$export$64fcab7860c216ae(oldAxisGroup, this._axisGroup, axisModel);
        _super.prototype.render.call(this, axisModel, ecModel, api, payload);
    };
    CartesianAxisView.prototype.remove = function() {
        (0, $ff3096b1f24c33b6$export$48ebf2d6ce8ad076)(this);
    };
    CartesianAxisView.type = 'cartesianAxis';
    return CartesianAxisView;
}((0, $58c48a3ef1aa0746$export$2e2bcd8739ae039));
var $c87c0ba584696283$var$axisElementBuilders = {
    splitLine: function(axisView, axisGroup, axisModel, gridModel) {
        var axis = axisModel.axis;
        if (axis.scale.isBlank()) return;
        var splitLineModel = axisModel.getModel('splitLine');
        var lineStyleModel = splitLineModel.getModel('lineStyle');
        var lineColors = lineStyleModel.get('color');
        var showMinLine = splitLineModel.get('showMinLine') !== false;
        var showMaxLine = splitLineModel.get('showMaxLine') !== false;
        lineColors = $7a1bd9c2710fea0d$export$43bee75e5e14138e(lineColors) ? lineColors : [
            lineColors
        ];
        var gridRect = gridModel.coordinateSystem.getRect();
        var isHorizontal = axis.isHorizontal();
        var lineCount = 0;
        var ticksCoords = axis.getTicksCoords({
            tickModel: splitLineModel
        });
        var p1 = [];
        var p2 = [];
        var lineStyle = lineStyleModel.getLineStyle();
        for(var i = 0; i < ticksCoords.length; i++){
            var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
            if (i === 0 && !showMinLine || i === ticksCoords.length - 1 && !showMaxLine) continue;
            var tickValue = ticksCoords[i].tickValue;
            if (isHorizontal) {
                p1[0] = tickCoord;
                p1[1] = gridRect.y;
                p2[0] = tickCoord;
                p2[1] = gridRect.y + gridRect.height;
            } else {
                p1[0] = gridRect.x;
                p1[1] = tickCoord;
                p2[0] = gridRect.x + gridRect.width;
                p2[1] = tickCoord;
            }
            var colorIndex = lineCount++ % lineColors.length;
            var line = new $7a316ae5ceff7b27$export$2e2bcd8739ae039({
                anid: tickValue != null ? 'line_' + tickValue : null,
                autoBatch: true,
                shape: {
                    x1: p1[0],
                    y1: p1[1],
                    x2: p2[0],
                    y2: p2[1]
                },
                style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                    stroke: lineColors[colorIndex]
                }, lineStyle),
                silent: true
            });
            $5b455ae6f843ac47$export$8b4b620d7f4aad1b(line.shape, lineStyle.lineWidth);
            axisGroup.add(line);
        }
    },
    minorSplitLine: function(axisView, axisGroup, axisModel, gridModel) {
        var axis = axisModel.axis;
        var minorSplitLineModel = axisModel.getModel('minorSplitLine');
        var lineStyleModel = minorSplitLineModel.getModel('lineStyle');
        var gridRect = gridModel.coordinateSystem.getRect();
        var isHorizontal = axis.isHorizontal();
        var minorTicksCoords = axis.getMinorTicksCoords();
        if (!minorTicksCoords.length) return;
        var p1 = [];
        var p2 = [];
        var lineStyle = lineStyleModel.getLineStyle();
        for(var i = 0; i < minorTicksCoords.length; i++)for(var k = 0; k < minorTicksCoords[i].length; k++){
            var tickCoord = axis.toGlobalCoord(minorTicksCoords[i][k].coord);
            if (isHorizontal) {
                p1[0] = tickCoord;
                p1[1] = gridRect.y;
                p2[0] = tickCoord;
                p2[1] = gridRect.y + gridRect.height;
            } else {
                p1[0] = gridRect.x;
                p1[1] = tickCoord;
                p2[0] = gridRect.x + gridRect.width;
                p2[1] = tickCoord;
            }
            var line = new $7a316ae5ceff7b27$export$2e2bcd8739ae039({
                anid: 'minor_line_' + minorTicksCoords[i][k].tickValue,
                autoBatch: true,
                shape: {
                    x1: p1[0],
                    y1: p1[1],
                    x2: p2[0],
                    y2: p2[1]
                },
                style: lineStyle,
                silent: true
            });
            $5b455ae6f843ac47$export$8b4b620d7f4aad1b(line.shape, lineStyle.lineWidth);
            axisGroup.add(line);
        }
    },
    splitArea: function(axisView, axisGroup, axisModel, gridModel) {
        (0, $ff3096b1f24c33b6$export$c80b7ef1527ec8c9)(axisView, axisGroup, axisModel, gridModel);
    }
};
var $c87c0ba584696283$export$b6d40cd875b8a1c8 = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(CartesianXAxisView, _super);
    function CartesianXAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CartesianXAxisView.type;
        return _this;
    }
    CartesianXAxisView.type = 'xAxis';
    return CartesianXAxisView;
}($c87c0ba584696283$var$CartesianAxisView);
var $c87c0ba584696283$export$417e1bdd0616e0dc = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(CartesianYAxisView, _super);
    function CartesianYAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = $c87c0ba584696283$export$b6d40cd875b8a1c8.type;
        return _this;
    }
    CartesianYAxisView.type = 'yAxis';
    return CartesianYAxisView;
}($c87c0ba584696283$var$CartesianAxisView);
var $c87c0ba584696283$export$2e2bcd8739ae039 = $c87c0ba584696283$var$CartesianAxisView;


// Grid view
var $1021478d6a16b0aa$var$GridView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(GridView, _super);
    function GridView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'grid';
        return _this;
    }
    GridView.prototype.render = function(gridModel, ecModel) {
        this.group.removeAll();
        if (gridModel.get('show')) this.group.add(new (0, $419e5ff2f303755e$export$2e2bcd8739ae039)({
            shape: gridModel.coordinateSystem.getRect(),
            style: (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
                fill: gridModel.get('backgroundColor')
            }, gridModel.getItemStyle()),
            silent: true,
            z2: -1
        }));
    };
    GridView.type = 'grid';
    return GridView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $1021478d6a16b0aa$var$extraOption = {
    // gridIndex: 0,
    // gridId: '',
    offset: 0
};
function $1021478d6a16b0aa$export$4b3e715f166fdd78(registers) {
    registers.registerComponentView($1021478d6a16b0aa$var$GridView);
    registers.registerComponentModel((0, $d67c268180aaad04$export$2e2bcd8739ae039));
    registers.registerCoordinateSystem('cartesian2d', (0, $8e1d1b12d8439742$export$2e2bcd8739ae039));
    (0, $c5c4c85259d60abe$export$2e2bcd8739ae039)(registers, 'x', (0, $008426c98740266e$export$483dc37e6ad83a3c), $1021478d6a16b0aa$var$extraOption);
    (0, $c5c4c85259d60abe$export$2e2bcd8739ae039)(registers, 'y', (0, $008426c98740266e$export$483dc37e6ad83a3c), $1021478d6a16b0aa$var$extraOption);
    registers.registerComponentView((0, $c87c0ba584696283$export$b6d40cd875b8a1c8));
    registers.registerComponentView((0, $c87c0ba584696283$export$417e1bdd0616e0dc));
    registers.registerPreprocessor(function(option) {
        // Only create grid when need
        if (option.xAxis && option.yAxis && !option.grid) option.grid = {};
    });
}



function $1214e5d7a4a6f990$export$4b3e715f166fdd78(registers) {
    // In case developer forget to include grid component
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $1021478d6a16b0aa$export$4b3e715f166fdd78));
    registers.registerSeriesModel((0, $00ab9646b588965f$export$2e2bcd8739ae039));
    registers.registerChartView((0, $c92a7ada0c69ef68$export$2e2bcd8739ae039));
    registers.registerLayout((0, $73b014aa594ea652$export$2e2bcd8739ae039)('scatter'));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 










var $9b5b8a865cafa8ae$var$DEFAULT_SECTOR_Z = 2;
var $9b5b8a865cafa8ae$var$DEFAULT_TEXT_Z = 4;
/**
 * Sunburstce of Sunburst including Sector, Label, LabelLine
 */ var $9b5b8a865cafa8ae$var$SunburstPiece = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SunburstPiece, _super);
    function SunburstPiece(node, seriesModel, ecModel, api) {
        var _this = _super.call(this) || this;
        _this.z2 = $9b5b8a865cafa8ae$var$DEFAULT_SECTOR_Z;
        _this.textConfig = {
            inside: true
        };
        (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(_this).seriesIndex = seriesModel.seriesIndex;
        var text = new $fe885cc21795562b$export$2e2bcd8739ae039({
            z2: $9b5b8a865cafa8ae$var$DEFAULT_TEXT_Z,
            silent: node.getModel().get([
                'label',
                'silent'
            ])
        });
        _this.setTextContent(text);
        _this.updateData(true, node, seriesModel, ecModel, api);
        return _this;
    }
    SunburstPiece.prototype.updateData = function(firstCreate, node, // state: 'emphasis' | 'normal' | 'highlight' | 'downplay',
    seriesModel, ecModel, api) {
        this.node = node;
        node.piece = this;
        seriesModel = seriesModel || this._seriesModel;
        ecModel = ecModel || this._ecModel;
        var sector = this;
        (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(sector).dataIndex = node.dataIndex;
        var itemModel = node.getModel();
        var emphasisModel = itemModel.getModel('emphasis');
        var layout = node.getLayout();
        var sectorShape = $7a1bd9c2710fea0d$export$8b58be045bf06082({}, layout);
        sectorShape.label = null;
        var normalStyle = node.getVisual('style');
        normalStyle.lineJoin = 'bevel';
        var decal = node.getVisual('decal');
        if (decal) normalStyle.decal = (0, $c6d646aacd243427$export$a3ba048e1a648972)(decal, api);
        var cornerRadius = (0, $9491a9b96e203579$export$b395eeeb2ad7cce5)(itemModel.getModel('itemStyle'), sectorShape, true);
        $7a1bd9c2710fea0d$export$8b58be045bf06082(sectorShape, cornerRadius);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43((0, $2bf82c0980125b62$export$151308dceb52d5b), function(stateName) {
            var state = sector.ensureState(stateName);
            var itemStyleModel = itemModel.getModel([
                stateName,
                'itemStyle'
            ]);
            state.style = itemStyleModel.getItemStyle();
            // border radius
            var cornerRadius = (0, $9491a9b96e203579$export$b395eeeb2ad7cce5)(itemStyleModel, sectorShape);
            if (cornerRadius) state.shape = cornerRadius;
        });
        if (firstCreate) {
            sector.setShape(sectorShape);
            sector.shape.r = layout.r0;
            $8b353638fbedfefa$export$a121566aadcfe021(sector, {
                shape: {
                    r: layout.r
                }
            }, seriesModel, node.dataIndex);
        } else {
            // Disable animation for gradient since no interpolation method
            // is supported for gradient
            $8b353638fbedfefa$export$c8dce3c08436e91e(sector, {
                shape: sectorShape
            }, seriesModel);
            (0, $8b353638fbedfefa$export$bca7290a9faf0ec9)(sector);
        }
        sector.useStyle(normalStyle);
        this._updateLabel(seriesModel);
        var cursorStyle = itemModel.getShallow('cursor');
        cursorStyle && sector.attr('cursor', cursorStyle);
        this._seriesModel = seriesModel || this._seriesModel;
        this._ecModel = ecModel || this._ecModel;
        var focus = emphasisModel.get('focus');
        var focusOrIndices = focus === 'relative' ? $7a1bd9c2710fea0d$export$4fd8af2c48c43416(node.getAncestorsIndices(), node.getDescendantIndices()) : focus === 'ancestor' ? node.getAncestorsIndices() : focus === 'descendant' ? node.getDescendantIndices() : focus;
        (0, $2bf82c0980125b62$export$e51187539ff11209)(this, focusOrIndices, emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
    };
    SunburstPiece.prototype._updateLabel = function(seriesModel) {
        var _this = this;
        var itemModel = this.node.getModel();
        var normalLabelModel = itemModel.getModel('label');
        var layout = this.node.getLayout();
        var angle = layout.endAngle - layout.startAngle;
        var midAngle = (layout.startAngle + layout.endAngle) / 2;
        var dx = Math.cos(midAngle);
        var dy = Math.sin(midAngle);
        var sector = this;
        var label = sector.getTextContent();
        var dataIndex = this.node.dataIndex;
        var labelMinAngle = normalLabelModel.get('minAngle') / 180 * Math.PI;
        var isNormalShown = normalLabelModel.get('show') && !(labelMinAngle != null && Math.abs(angle) < labelMinAngle);
        label.ignore = !isNormalShown;
        // TODO use setLabelStyle
        $7a1bd9c2710fea0d$export$79b2f7037acddd43((0, $2bf82c0980125b62$export$57ee5306b85ad7d5), function(stateName) {
            var labelStateModel = stateName === 'normal' ? itemModel.getModel('label') : itemModel.getModel([
                stateName,
                'label'
            ]);
            var isNormal = stateName === 'normal';
            var state = isNormal ? label : label.ensureState(stateName);
            var text = seriesModel.getFormattedLabel(dataIndex, stateName);
            if (isNormal) text = text || _this.node.name;
            state.style = (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(labelStateModel, {}, null, stateName !== 'normal', true);
            if (text) state.style.text = text;
            // Not displaying text when angle is too small
            var isShown = labelStateModel.get('show');
            if (isShown != null && !isNormal) state.ignore = !isShown;
            var labelPosition = getLabelAttr(labelStateModel, 'position');
            var sectorState = isNormal ? sector : sector.states[stateName];
            var labelColor = sectorState.style.fill;
            sectorState.textConfig = {
                outsideFill: labelStateModel.get('color') === 'inherit' ? labelColor : null,
                inside: labelPosition !== 'outside'
            };
            var r;
            var labelPadding = getLabelAttr(labelStateModel, 'distance') || 0;
            var textAlign = getLabelAttr(labelStateModel, 'align');
            var rotateType = getLabelAttr(labelStateModel, 'rotate');
            var flipStartAngle = Math.PI * 0.5;
            var flipEndAngle = Math.PI * 1.5;
            var midAngleNormal = (0, $b44a8536c7214e4f$export$d44861331f213635)(rotateType === 'tangential' ? Math.PI / 2 - midAngle : midAngle);
            // For text that is up-side down, rotate 180 degrees to make sure
            // it's readable
            var needsFlip = midAngleNormal > flipStartAngle && !(0, $cfc1f3b422a3185f$export$d1df570aea2868f)(midAngleNormal - flipStartAngle) && midAngleNormal < flipEndAngle;
            if (labelPosition === 'outside') {
                r = layout.r + labelPadding;
                textAlign = needsFlip ? 'right' : 'left';
            } else {
                if (!textAlign || textAlign === 'center') {
                    // Put label in the center if it's a circle
                    if (angle === 2 * Math.PI && layout.r0 === 0) r = 0;
                    else r = (layout.r + layout.r0) / 2;
                    textAlign = 'center';
                } else if (textAlign === 'left') {
                    r = layout.r0 + labelPadding;
                    textAlign = needsFlip ? 'right' : 'left';
                } else if (textAlign === 'right') {
                    r = layout.r - labelPadding;
                    textAlign = needsFlip ? 'left' : 'right';
                }
            }
            state.style.align = textAlign;
            state.style.verticalAlign = getLabelAttr(labelStateModel, 'verticalAlign') || 'middle';
            state.x = r * dx + layout.cx;
            state.y = r * dy + layout.cy;
            var rotate = 0;
            if (rotateType === 'radial') rotate = (0, $b44a8536c7214e4f$export$d44861331f213635)(-midAngle) + (needsFlip ? Math.PI : 0);
            else if (rotateType === 'tangential') rotate = (0, $b44a8536c7214e4f$export$d44861331f213635)(Math.PI / 2 - midAngle) + (needsFlip ? Math.PI : 0);
            else if ($7a1bd9c2710fea0d$export$7e4aa119212bc614(rotateType)) rotate = rotateType * Math.PI / 180;
            state.rotation = (0, $b44a8536c7214e4f$export$d44861331f213635)(rotate);
        });
        function getLabelAttr(model, name) {
            var stateAttr = model.get(name);
            if (stateAttr == null) return normalLabelModel.get(name);
            return stateAttr;
        }
        label.dirtyStyle();
    };
    return SunburstPiece;
}($a3e1dec0a3875b49$export$2e2bcd8739ae039);
var $9b5b8a865cafa8ae$export$2e2bcd8739ae039 = $9b5b8a865cafa8ae$var$SunburstPiece;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $6341f66602946a06$export$c5445fa59c15dec4(payload, validPayloadTypes, seriesModel) {
    if (payload && $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(validPayloadTypes, payload.type) >= 0) {
        var root = seriesModel.getData().tree.root;
        var targetNode = payload.targetNode;
        if ($7a1bd9c2710fea0d$export$844ec244b1367d54(targetNode)) targetNode = root.getNodeById(targetNode);
        if (targetNode && root.contains(targetNode)) return {
            node: targetNode
        };
        var targetNodeId = payload.targetNodeId;
        if (targetNodeId != null && (targetNode = root.getNodeById(targetNodeId))) return {
            node: targetNode
        };
    }
}
function $6341f66602946a06$export$6be31fe4499506f9(node) {
    var path = [];
    while(node){
        node = node.parentNode;
        node && path.push(node);
    }
    return path.reverse();
}
function $6341f66602946a06$export$df59de26c77b5bea(viewRoot, node) {
    var viewPath = $6341f66602946a06$export$6be31fe4499506f9(viewRoot);
    return $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(viewPath, node) >= 0;
}
function $6341f66602946a06$export$c5baa480d6ceb0a3(node, seriesModel) {
    var treePathInfo = [];
    while(node){
        var nodeDataIndex = node.dataIndex;
        treePathInfo.push({
            name: node.name,
            dataIndex: nodeDataIndex,
            value: seriesModel.getRawValue(nodeDataIndex)
        });
        node = node.parentNode;
    }
    treePathInfo.reverse();
    return treePathInfo;
}


var $aae4889dfc91fba0$export$b06afbbb40399c8b = 'sunburstRootToNode';
var $aae4889dfc91fba0$var$HIGHLIGHT_ACTION = 'sunburstHighlight';
var $aae4889dfc91fba0$var$UNHIGHLIGHT_ACTION = 'sunburstUnhighlight';
function $aae4889dfc91fba0$export$d2def111ea616eb3(registers) {
    registers.registerAction({
        type: $aae4889dfc91fba0$export$b06afbbb40399c8b,
        update: 'updateView'
    }, function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: 'series',
            subType: 'sunburst',
            query: payload
        }, handleRootToNode);
        function handleRootToNode(model, index) {
            var targetInfo = (0, $6341f66602946a06$export$c5445fa59c15dec4)(payload, [
                $aae4889dfc91fba0$export$b06afbbb40399c8b
            ], model);
            if (targetInfo) {
                var originViewRoot = model.getViewRoot();
                if (originViewRoot) payload.direction = (0, $6341f66602946a06$export$df59de26c77b5bea)(originViewRoot, targetInfo.node) ? 'rollUp' : 'drillDown';
                model.resetViewRoot(targetInfo.node);
            }
        }
    });
    registers.registerAction({
        type: $aae4889dfc91fba0$var$HIGHLIGHT_ACTION,
        update: 'none'
    }, function(payload, ecModel, api) {
        // Clone
        payload = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, payload);
        ecModel.eachComponent({
            mainType: 'series',
            subType: 'sunburst',
            query: payload
        }, handleHighlight);
        function handleHighlight(model) {
            var targetInfo = (0, $6341f66602946a06$export$c5445fa59c15dec4)(payload, [
                $aae4889dfc91fba0$var$HIGHLIGHT_ACTION
            ], model);
            if (targetInfo) payload.dataIndex = targetInfo.node.dataIndex;
        }
        // Fast forward action
        api.dispatchAction((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(payload, {
            type: 'highlight'
        }));
    });
    registers.registerAction({
        type: $aae4889dfc91fba0$var$UNHIGHLIGHT_ACTION,
        update: 'updateView'
    }, function(payload, ecModel, api) {
        payload = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, payload);
        api.dispatchAction((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(payload, {
            type: 'downplay'
        }));
    });
}



var $270cb27be00846ce$var$SunburstView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SunburstView, _super);
    function SunburstView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SunburstView.type;
        return _this;
    }
    SunburstView.prototype.render = function(seriesModel, ecModel, api, // @ts-ignore
    payload) {
        var self = this;
        this.seriesModel = seriesModel;
        this.api = api;
        this.ecModel = ecModel;
        var data = seriesModel.getData();
        var virtualRoot = data.tree.root;
        var newRoot = seriesModel.getViewRoot();
        var group = this.group;
        var renderLabelForZeroData = seriesModel.get('renderLabelForZeroData');
        var newChildren = [];
        newRoot.eachNode(function(node) {
            newChildren.push(node);
        });
        var oldChildren = this._oldChildren || [];
        dualTravel(newChildren, oldChildren);
        renderRollUp(virtualRoot, newRoot);
        this._initEvents();
        this._oldChildren = newChildren;
        function dualTravel(newChildren, oldChildren) {
            if (newChildren.length === 0 && oldChildren.length === 0) return;
            new (0, $306d1c87baff8a10$export$2e2bcd8739ae039)(oldChildren, newChildren, getKey, getKey).add(processNode).update(processNode).remove($7a1bd9c2710fea0d$export$c3095a23b368d1f2(processNode, null)).execute();
            function getKey(node) {
                return node.getId();
            }
            function processNode(newIdx, oldIdx) {
                var newNode = newIdx == null ? null : newChildren[newIdx];
                var oldNode = oldIdx == null ? null : oldChildren[oldIdx];
                doRenderNode(newNode, oldNode);
            }
        }
        function doRenderNode(newNode, oldNode) {
            if (!renderLabelForZeroData && newNode && !newNode.getValue()) // Not render data with value 0
            newNode = null;
            if (newNode !== virtualRoot && oldNode !== virtualRoot) {
                if (oldNode && oldNode.piece) {
                    if (newNode) {
                        // Update
                        oldNode.piece.updateData(false, newNode, seriesModel, ecModel, api);
                        // For tooltip
                        data.setItemGraphicEl(newNode.dataIndex, oldNode.piece);
                    } else // Remove
                    removeNode(oldNode);
                } else if (newNode) {
                    // Add
                    var piece = new (0, $9b5b8a865cafa8ae$export$2e2bcd8739ae039)(newNode, seriesModel, ecModel, api);
                    group.add(piece);
                    // For tooltip
                    data.setItemGraphicEl(newNode.dataIndex, piece);
                }
            }
        }
        function removeNode(node) {
            if (!node) return;
            if (node.piece) {
                group.remove(node.piece);
                node.piece = null;
            }
        }
        function renderRollUp(virtualRoot, viewRoot) {
            if (viewRoot.depth > 0) {
                // Render
                if (self.virtualPiece) // Update
                self.virtualPiece.updateData(false, virtualRoot, seriesModel, ecModel, api);
                else {
                    // Add
                    self.virtualPiece = new (0, $9b5b8a865cafa8ae$export$2e2bcd8739ae039)(virtualRoot, seriesModel, ecModel, api);
                    group.add(self.virtualPiece);
                }
                // TODO event scope
                viewRoot.piece.off('click');
                self.virtualPiece.on('click', function(e) {
                    self._rootToNode(viewRoot.parentNode);
                });
            } else if (self.virtualPiece) {
                // Remove
                group.remove(self.virtualPiece);
                self.virtualPiece = null;
            }
        }
    };
    /**
   * @private
   */ SunburstView.prototype._initEvents = function() {
        var _this = this;
        this.group.off('click');
        this.group.on('click', function(e) {
            var targetFound = false;
            var viewRoot = _this.seriesModel.getViewRoot();
            viewRoot.eachNode(function(node) {
                if (!targetFound && node.piece && node.piece === e.target) {
                    var nodeClick = node.getModel().get('nodeClick');
                    if (nodeClick === 'rootToNode') _this._rootToNode(node);
                    else if (nodeClick === 'link') {
                        var itemModel = node.getModel();
                        var link = itemModel.get('link');
                        if (link) {
                            var linkTarget = itemModel.get('target', true) || '_blank';
                            (0, $c84c9521536c601a$export$13e13f9b96dbe8fa)(link, linkTarget);
                        }
                    }
                    targetFound = true;
                }
            });
        });
    };
    /**
   * @private
   */ SunburstView.prototype._rootToNode = function(node) {
        if (node !== this.seriesModel.getViewRoot()) this.api.dispatchAction({
            type: (0, $aae4889dfc91fba0$export$b06afbbb40399c8b),
            from: this.uid,
            seriesId: this.seriesModel.id,
            targetNode: node
        });
    };
    /**
   * @implement
   */ SunburstView.prototype.containPoint = function(point, seriesModel) {
        var treeRoot = seriesModel.getData();
        var itemLayout = treeRoot.getItemLayout(0);
        if (itemLayout) {
            var dx = point[0] - itemLayout.cx;
            var dy = point[1] - itemLayout.cy;
            var radius = Math.sqrt(dx * dx + dy * dy);
            return radius <= itemLayout.r && radius >= itemLayout.r0;
        }
    };
    SunburstView.type = 'sunburst';
    return SunburstView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $270cb27be00846ce$export$2e2bcd8739ae039 = $270cb27be00846ce$var$SunburstView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Tree data structure
 */ 




var $116fa5bb9335391f$export$2eba8ec3a333fdbb = /** @class */ function() {
    function TreeNode(name, hostTree) {
        this.depth = 0;
        this.height = 0;
        /**
     * Reference to list item.
     * Do not persistent dataIndex outside,
     * besause it may be changed by list.
     * If dataIndex -1,
     * this node is logical deleted (filtered) in list.
     */ this.dataIndex = -1;
        this.children = [];
        this.viewChildren = [];
        this.isExpand = false;
        this.name = name || '';
        this.hostTree = hostTree;
    }
    /**
   * The node is removed.
   */ TreeNode.prototype.isRemoved = function() {
        return this.dataIndex < 0;
    };
    TreeNode.prototype.eachNode = function(options, cb, context) {
        if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(options)) {
            context = cb;
            cb = options;
            options = null;
        }
        options = options || {};
        if ($7a1bd9c2710fea0d$export$844ec244b1367d54(options)) options = {
            order: options
        };
        var order = options.order || 'preorder';
        var children = this[options.attr || 'children'];
        var suppressVisitSub;
        order === 'preorder' && (suppressVisitSub = cb.call(context, this));
        for(var i = 0; !suppressVisitSub && i < children.length; i++)children[i].eachNode(options, cb, context);
        order === 'postorder' && cb.call(context, this);
    };
    /**
   * Update depth and height of this subtree.
   */ TreeNode.prototype.updateDepthAndHeight = function(depth) {
        var height = 0;
        this.depth = depth;
        for(var i = 0; i < this.children.length; i++){
            var child = this.children[i];
            child.updateDepthAndHeight(depth + 1);
            if (child.height > height) height = child.height;
        }
        this.height = height + 1;
    };
    TreeNode.prototype.getNodeById = function(id) {
        if (this.getId() === id) return this;
        for(var i = 0, children = this.children, len = children.length; i < len; i++){
            var res = children[i].getNodeById(id);
            if (res) return res;
        }
    };
    TreeNode.prototype.contains = function(node) {
        if (node === this) return true;
        for(var i = 0, children = this.children, len = children.length; i < len; i++){
            var res = children[i].contains(node);
            if (res) return res;
        }
    };
    /**
   * @param includeSelf Default false.
   * @return order: [root, child, grandchild, ...]
   */ TreeNode.prototype.getAncestors = function(includeSelf) {
        var ancestors = [];
        var node = includeSelf ? this : this.parentNode;
        while(node){
            ancestors.push(node);
            node = node.parentNode;
        }
        ancestors.reverse();
        return ancestors;
    };
    TreeNode.prototype.getAncestorsIndices = function() {
        var indices = [];
        var currNode = this;
        while(currNode){
            indices.push(currNode.dataIndex);
            currNode = currNode.parentNode;
        }
        indices.reverse();
        return indices;
    };
    TreeNode.prototype.getDescendantIndices = function() {
        var indices = [];
        this.eachNode(function(childNode) {
            indices.push(childNode.dataIndex);
        });
        return indices;
    };
    TreeNode.prototype.getValue = function(dimension) {
        var data = this.hostTree.data;
        return data.getStore().get(data.getDimensionIndex(dimension || 'value'), this.dataIndex);
    };
    TreeNode.prototype.setLayout = function(layout, merge) {
        this.dataIndex >= 0 && this.hostTree.data.setItemLayout(this.dataIndex, layout, merge);
    };
    /**
   * @return {Object} layout
   */ TreeNode.prototype.getLayout = function() {
        return this.hostTree.data.getItemLayout(this.dataIndex);
    };
    // @depcrecated
    // getModel<T = unknown, S extends keyof T = keyof T>(path: S): Model<T[S]>
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    TreeNode.prototype.getModel = function(path) {
        if (this.dataIndex < 0) return;
        var hostTree = this.hostTree;
        var itemModel = hostTree.data.getItemModel(this.dataIndex);
        return itemModel.getModel(path);
    };
    // TODO: TYPE More specific model
    TreeNode.prototype.getLevelModel = function() {
        return (this.hostTree.levelModels || [])[this.depth];
    };
    TreeNode.prototype.setVisual = function(key, value) {
        this.dataIndex >= 0 && this.hostTree.data.setItemVisual(this.dataIndex, key, value);
    };
    /**
   * Get item visual
   * FIXME: make return type better
   */ TreeNode.prototype.getVisual = function(key) {
        return this.hostTree.data.getItemVisual(this.dataIndex, key);
    };
    TreeNode.prototype.getRawIndex = function() {
        return this.hostTree.data.getRawIndex(this.dataIndex);
    };
    TreeNode.prototype.getId = function() {
        return this.hostTree.data.getId(this.dataIndex);
    };
    /**
   * index in parent's children
   */ TreeNode.prototype.getChildIndex = function() {
        if (this.parentNode) {
            var children = this.parentNode.children;
            for(var i = 0; i < children.length; ++i){
                if (children[i] === this) return i;
            }
            return -1;
        }
        return -1;
    };
    /**
   * if this is an ancestor of another node
   *
   * @param node another node
   * @return if is ancestor
   */ TreeNode.prototype.isAncestorOf = function(node) {
        var parent = node.parentNode;
        while(parent){
            if (parent === this) return true;
            parent = parent.parentNode;
        }
        return false;
    };
    /**
   * if this is an descendant of another node
   *
   * @param node another node
   * @return if is descendant
   */ TreeNode.prototype.isDescendantOf = function(node) {
        return node !== this && node.isAncestorOf(this);
    };
    return TreeNode;
}();
var $116fa5bb9335391f$var$Tree = /** @class */ function() {
    function Tree(hostModel) {
        this.type = 'tree';
        this._nodes = [];
        this.hostModel = hostModel;
    }
    Tree.prototype.eachNode = function(options, cb, context) {
        this.root.eachNode(options, cb, context);
    };
    Tree.prototype.getNodeByDataIndex = function(dataIndex) {
        var rawIndex = this.data.getRawIndex(dataIndex);
        return this._nodes[rawIndex];
    };
    Tree.prototype.getNodeById = function(name) {
        return this.root.getNodeById(name);
    };
    /**
   * Update item available by list,
   * when list has been performed options like 'filterSelf' or 'map'.
   */ Tree.prototype.update = function() {
        var data = this.data;
        var nodes = this._nodes;
        for(var i = 0, len = nodes.length; i < len; i++)nodes[i].dataIndex = -1;
        for(var i = 0, len = data.count(); i < len; i++)nodes[data.getRawIndex(i)].dataIndex = i;
    };
    /**
   * Clear all layouts
   */ Tree.prototype.clearLayouts = function() {
        this.data.clearItemLayouts();
    };
    /**
   * data node format:
   * {
   *     name: ...
   *     value: ...
   *     children: [
   *         {
   *             name: ...
   *             value: ...
   *             children: ...
   *         },
   *         ...
   *     ]
   * }
   */ Tree.createTree = function(dataRoot, hostModel, beforeLink) {
        var tree = new Tree(hostModel);
        var listData = [];
        var dimMax = 1;
        buildHierarchy(dataRoot);
        function buildHierarchy(dataNode, parentNode) {
            var value = dataNode.value;
            dimMax = Math.max(dimMax, $7a1bd9c2710fea0d$export$43bee75e5e14138e(value) ? value.length : 1);
            listData.push(dataNode);
            var node = new $116fa5bb9335391f$export$2eba8ec3a333fdbb((0, $76d619f648247e6d$export$fb1a222ba5dd6e51)(dataNode.name, ''), tree);
            parentNode ? $116fa5bb9335391f$var$addChild(node, parentNode) : tree.root = node;
            tree._nodes.push(node);
            var children = dataNode.children;
            if (children) for(var i = 0; i < children.length; i++)buildHierarchy(children[i], node);
        }
        tree.root.updateDepthAndHeight(0);
        var dimensions = (0, $a27631012b7b377c$export$2e2bcd8739ae039)(listData, {
            coordDimensions: [
                'value'
            ],
            dimensionsCount: dimMax
        }).dimensions;
        var list = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)(dimensions, hostModel);
        list.initData(listData);
        beforeLink && beforeLink(list);
        (0, $4a8451eb7786c849$export$2e2bcd8739ae039)({
            mainData: list,
            struct: tree,
            structAttr: 'tree'
        });
        tree.update();
        return tree;
    };
    return Tree;
}();
/**
 * It is needed to consider the mess of 'list', 'hostModel' when creating a TreeNote,
 * so this function is not ready and not necessary to be public.
 */ function $116fa5bb9335391f$var$addChild(child, node) {
    var children = node.children;
    if (child.parentNode === node) return;
    children.push(child);
    child.parentNode = node;
}
var $116fa5bb9335391f$export$2e2bcd8739ae039 = $116fa5bb9335391f$var$Tree;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $a116b59e46d9072c$export$2e2bcd8739ae039(seriesModel) {
    var data = seriesModel.getData();
    var tree = data.tree;
    var decalPaletteScope = {};
    tree.eachNode(function(node) {
        // Use decal of level 1 node
        var current = node;
        while(current && current.depth > 1)current = current.parentNode;
        var decal = (0, $e7fbd47751ca3c28$export$e4d892222945a227)(seriesModel.ecModel, current.name || current.dataIndex + '', decalPaletteScope);
        node.setVisual('decal', decal);
    });
}


var $5204df39d5781117$var$SunburstSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SunburstSeriesModel, _super);
    function SunburstSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SunburstSeriesModel.type;
        _this.ignoreStyleOnData = true;
        return _this;
    }
    SunburstSeriesModel.prototype.getInitialData = function(option, ecModel) {
        // Create a virtual root.
        var root = {
            name: option.name,
            children: option.data
        };
        $5204df39d5781117$var$completeTreeValue(root);
        var levelModels = this._levelModels = $7a1bd9c2710fea0d$export$871de8747c9eaa88(option.levels || [], function(levelDefine) {
            return new (0, $6818646a97528290$export$2e2bcd8739ae039)(levelDefine, this, ecModel);
        }, this);
        // Make sure always a new tree is created when setOption,
        // in TreemapView, we check whether oldTree === newTree
        // to choose mappings approach among old shapes and new shapes.
        var tree = (0, $116fa5bb9335391f$export$2e2bcd8739ae039).createTree(root, this, beforeLink);
        function beforeLink(nodeData) {
            nodeData.wrapMethod('getItemModel', function(model, idx) {
                var node = tree.getNodeByDataIndex(idx);
                var levelModel = levelModels[node.depth];
                levelModel && (model.parentModel = levelModel);
                return model;
            });
        }
        return tree.data;
    };
    SunburstSeriesModel.prototype.optionUpdated = function() {
        this.resetViewRoot();
    };
    /*
   * @override
   */ SunburstSeriesModel.prototype.getDataParams = function(dataIndex) {
        var params = _super.prototype.getDataParams.apply(this, arguments);
        var node = this.getData().tree.getNodeByDataIndex(dataIndex);
        params.treePathInfo = (0, $6341f66602946a06$export$c5baa480d6ceb0a3)(node, this);
        return params;
    };
    SunburstSeriesModel.prototype.getLevelModel = function(node) {
        return this._levelModels && this._levelModels[node.depth];
    };
    SunburstSeriesModel.prototype.getViewRoot = function() {
        return this._viewRoot;
    };
    SunburstSeriesModel.prototype.resetViewRoot = function(viewRoot) {
        viewRoot ? this._viewRoot = viewRoot : viewRoot = this._viewRoot;
        var root = this.getRawData().tree.root;
        if (!viewRoot || viewRoot !== root && !root.contains(viewRoot)) this._viewRoot = root;
    };
    SunburstSeriesModel.prototype.enableAriaDecal = function() {
        (0, $a116b59e46d9072c$export$2e2bcd8739ae039)(this);
    };
    SunburstSeriesModel.type = 'series.sunburst';
    SunburstSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        // 默认全局居中
        center: [
            '50%',
            '50%'
        ],
        radius: [
            0,
            '75%'
        ],
        // 默认顺时针
        clockwise: true,
        startAngle: 90,
        // 最小角度改为0
        minAngle: 0,
        // If still show when all data zero.
        stillShowZeroSum: true,
        // 'rootToNode', 'link', or false
        nodeClick: 'rootToNode',
        renderLabelForZeroData: false,
        label: {
            // could be: 'radial', 'tangential', or 'none'
            rotate: 'radial',
            show: true,
            opacity: 1,
            // 'left' is for inner side of inside, and 'right' is for outer
            // side for inside
            align: 'center',
            position: 'inside',
            distance: 5,
            silent: true
        },
        itemStyle: {
            borderWidth: 1,
            borderColor: 'white',
            borderType: 'solid',
            shadowBlur: 0,
            shadowColor: 'rgba(0, 0, 0, 0.2)',
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            opacity: 1
        },
        emphasis: {
            focus: 'descendant'
        },
        blur: {
            itemStyle: {
                opacity: 0.2
            },
            label: {
                opacity: 0.1
            }
        },
        // Animation type can be expansion, scale.
        animationType: 'expansion',
        animationDuration: 1000,
        animationDurationUpdate: 500,
        data: [],
        /**
     * Sort order.
     *
     * Valid values: 'desc', 'asc', null, or callback function.
     * 'desc' and 'asc' for descend and ascendant order;
     * null for not sorting;
     * example of callback function:
     * function(nodeA, nodeB) {
     *     return nodeA.getValue() - nodeB.getValue();
     * }
     */ sort: 'desc'
    };
    return SunburstSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
function $5204df39d5781117$var$completeTreeValue(dataNode) {
    // Postorder travel tree.
    // If value of none-leaf node is not set,
    // calculate it by suming up the value of all children.
    var sum = 0;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(dataNode.children, function(child) {
        $5204df39d5781117$var$completeTreeValue(child);
        var childValue = child.value;
        // TODO First value of array must be a number
        $7a1bd9c2710fea0d$export$43bee75e5e14138e(childValue) && (childValue = childValue[0]);
        sum += childValue;
    });
    var thisValue = dataNode.value;
    if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(thisValue)) thisValue = thisValue[0];
    if (thisValue == null || isNaN(thisValue)) thisValue = sum;
    // Value should not less than 0.
    if (thisValue < 0) thisValue = 0;
    $7a1bd9c2710fea0d$export$43bee75e5e14138e(dataNode.value) ? dataNode.value[0] = thisValue : dataNode.value = thisValue;
}
var $5204df39d5781117$export$2e2bcd8739ae039 = $5204df39d5781117$var$SunburstSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

// let PI2 = Math.PI * 2;
var $2ac615e1f67ae37a$var$RADIAN = Math.PI / 180;
function $2ac615e1f67ae37a$export$2e2bcd8739ae039(seriesType, ecModel, api) {
    ecModel.eachSeriesByType(seriesType, function(seriesModel) {
        var center = seriesModel.get('center');
        var radius = seriesModel.get('radius');
        if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(radius)) radius = [
            0,
            radius
        ];
        if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(center)) center = [
            center,
            center
        ];
        var width = api.getWidth();
        var height = api.getHeight();
        var size = Math.min(width, height);
        var cx = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(center[0], width);
        var cy = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(center[1], height);
        var r0 = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(radius[0], size / 2);
        var r = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(radius[1], size / 2);
        var startAngle = -seriesModel.get('startAngle') * $2ac615e1f67ae37a$var$RADIAN;
        var minAngle = seriesModel.get('minAngle') * $2ac615e1f67ae37a$var$RADIAN;
        var virtualRoot = seriesModel.getData().tree.root;
        var treeRoot = seriesModel.getViewRoot();
        var rootDepth = treeRoot.depth;
        var sort = seriesModel.get('sort');
        if (sort != null) $2ac615e1f67ae37a$var$initChildren(treeRoot, sort);
        var validDataCount = 0;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(treeRoot.children, function(child) {
            !isNaN(child.getValue()) && validDataCount++;
        });
        var sum = treeRoot.getValue();
        // Sum may be 0
        var unitRadian = Math.PI / (sum || validDataCount) * 2;
        var renderRollupNode = treeRoot.depth > 0;
        var levels = treeRoot.height - (renderRollupNode ? -1 : 1);
        var rPerLevel = (r - r0) / (levels || 1);
        var clockwise = seriesModel.get('clockwise');
        var stillShowZeroSum = seriesModel.get('stillShowZeroSum');
        // In the case some sector angle is smaller than minAngle
        // let restAngle = PI2;
        // let valueSumLargerThanMinAngle = 0;
        var dir = clockwise ? 1 : -1;
        /**
     * Render a tree
     * @return increased angle
     */ var renderNode = function(node, startAngle) {
            if (!node) return;
            var endAngle = startAngle;
            // Render self
            if (node !== virtualRoot) {
                // Tree node is virtual, so it doesn't need to be drawn
                var value = node.getValue();
                var angle = sum === 0 && stillShowZeroSum ? unitRadian : value * unitRadian;
                if (angle < minAngle) angle = minAngle;
                // else {
                //     valueSumLargerThanMinAngle += value;
                // }
                endAngle = startAngle + dir * angle;
                var depth = node.depth - rootDepth - (renderRollupNode ? -1 : 1);
                var rStart = r0 + rPerLevel * depth;
                var rEnd = r0 + rPerLevel * (depth + 1);
                var levelModel = seriesModel.getLevelModel(node);
                if (levelModel) {
                    var r0_1 = levelModel.get('r0', true);
                    var r_1 = levelModel.get('r', true);
                    var radius_1 = levelModel.get('radius', true);
                    if (radius_1 != null) {
                        r0_1 = radius_1[0];
                        r_1 = radius_1[1];
                    }
                    r0_1 != null && (rStart = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(r0_1, size / 2));
                    r_1 != null && (rEnd = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(r_1, size / 2));
                }
                node.setLayout({
                    angle: angle,
                    startAngle: startAngle,
                    endAngle: endAngle,
                    clockwise: clockwise,
                    cx: cx,
                    cy: cy,
                    r0: rStart,
                    r: rEnd
                });
            }
            // Render children
            if (node.children && node.children.length) {
                // currentAngle = startAngle;
                var siblingAngle_1 = 0;
                $7a1bd9c2710fea0d$export$79b2f7037acddd43(node.children, function(node) {
                    siblingAngle_1 += renderNode(node, startAngle + siblingAngle_1);
                });
            }
            return endAngle - startAngle;
        };
        // Virtual root node for roll up
        if (renderRollupNode) {
            var rStart = r0;
            var rEnd = r0 + rPerLevel;
            var angle = Math.PI * 2;
            virtualRoot.setLayout({
                angle: angle,
                startAngle: startAngle,
                endAngle: startAngle + angle,
                clockwise: clockwise,
                cx: cx,
                cy: cy,
                r0: rStart,
                r: rEnd
            });
        }
        renderNode(treeRoot, startAngle);
    });
}
/**
 * Init node children by order and update visual
 */ function $2ac615e1f67ae37a$var$initChildren(node, sortOrder) {
    var children = node.children || [];
    node.children = $2ac615e1f67ae37a$var$sort(children, sortOrder);
    // Init children recursively
    if (children.length) $7a1bd9c2710fea0d$export$79b2f7037acddd43(node.children, function(child) {
        $2ac615e1f67ae37a$var$initChildren(child, sortOrder);
    });
}
/**
 * Sort children nodes
 *
 * @param {TreeNode[]}               children children of node to be sorted
 * @param {string | function | null} sort sort method
 *                                   See SunburstSeries.js for details.
 */ function $2ac615e1f67ae37a$var$sort(children, sortOrder) {
    if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(sortOrder)) {
        var sortTargets = $7a1bd9c2710fea0d$export$871de8747c9eaa88(children, function(child, idx) {
            var value = child.getValue();
            return {
                params: {
                    depth: child.depth,
                    height: child.height,
                    dataIndex: child.dataIndex,
                    getValue: function() {
                        return value;
                    }
                },
                index: idx
            };
        });
        sortTargets.sort(function(a, b) {
            return sortOrder(a.params, b.params);
        });
        return $7a1bd9c2710fea0d$export$871de8747c9eaa88(sortTargets, function(target) {
            return children[target.index];
        });
    } else {
        var isAsc_1 = sortOrder === 'asc';
        return children.sort(function(a, b) {
            var diff = (a.getValue() - b.getValue()) * (isAsc_1 ? 1 : -1);
            return diff === 0 ? (a.dataIndex - b.dataIndex) * (isAsc_1 ? -1 : 1) : diff;
        });
    }
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $a3ad73d5b7f783f0$export$2e2bcd8739ae039(ecModel) {
    var paletteScope = {};
    // Default color strategy
    function pickColor(node, seriesModel, treeHeight) {
        // Choose color from palette based on the first level.
        var current = node;
        while(current && current.depth > 1)current = current.parentNode;
        var color = seriesModel.getColorFromPalette(current.name || current.dataIndex + '', paletteScope);
        if (node.depth > 1 && (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(color)) // Lighter on the deeper level.
        color = (0, $2c037f5bda6341ca$export$590e8b2c435046d9)(color, (node.depth - 1) / (treeHeight - 1) * 0.5);
        return color;
    }
    ecModel.eachSeriesByType('sunburst', function(seriesModel) {
        var data = seriesModel.getData();
        var tree = data.tree;
        tree.eachNode(function(node) {
            var model = node.getModel();
            var style = model.getModel('itemStyle').getItemStyle();
            if (!style.fill) style.fill = pickColor(node, seriesModel, tree.root.height);
            var existsStyle = data.ensureUniqueItemVisual(node.dataIndex, 'style');
            (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(existsStyle, style);
        });
    });
}





function $b7341ef122ec790d$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $270cb27be00846ce$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $5204df39d5781117$export$2e2bcd8739ae039));
    registers.registerLayout((0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)((0, $2ac615e1f67ae37a$export$2e2bcd8739ae039), 'sunburst'));
    registers.registerProcessor((0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)((0, $e11a533bf70b759c$export$2e2bcd8739ae039), 'sunburst'));
    registers.registerVisual((0, $a3ad73d5b7f783f0$export$2e2bcd8739ae039));
    (0, $aae4889dfc91fba0$export$d2def111ea616eb3)(registers);
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 








var $91b53b7eca57e10b$var$ThemeRiverView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ThemeRiverView, _super);
    function ThemeRiverView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ThemeRiverView.type;
        _this._layers = [];
        return _this;
    }
    ThemeRiverView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var self = this;
        var group = this.group;
        var layersSeries = seriesModel.getLayerSeries();
        var layoutInfo = data.getLayout('layoutInfo');
        var rect = layoutInfo.rect;
        var boundaryGap = layoutInfo.boundaryGap;
        group.x = 0;
        group.y = rect.y + boundaryGap[0];
        function keyGetter(item) {
            return item.name;
        }
        var dataDiffer = new (0, $306d1c87baff8a10$export$2e2bcd8739ae039)(this._layersSeries || [], layersSeries, keyGetter, keyGetter);
        var newLayersGroups = [];
        dataDiffer.add((0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(process, this, 'add')).update((0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(process, this, 'update')).remove((0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(process, this, 'remove')).execute();
        function process(status, idx, oldIdx) {
            var oldLayersGroups = self._layers;
            if (status === 'remove') {
                group.remove(oldLayersGroups[idx]);
                return;
            }
            var points0 = [];
            var points1 = [];
            var style;
            var indices = layersSeries[idx].indices;
            var j = 0;
            for(; j < indices.length; j++){
                var layout = data.getItemLayout(indices[j]);
                var x = layout.x;
                var y0 = layout.y0;
                var y = layout.y;
                points0.push(x, y0);
                points1.push(x, y0 + y);
                style = data.getItemVisual(indices[j], 'style');
            }
            var polygon;
            var textLayout = data.getItemLayout(indices[0]);
            var labelModel = seriesModel.getModel('label');
            var margin = labelModel.get('margin');
            var emphasisModel = seriesModel.getModel('emphasis');
            if (status === 'add') {
                var layerGroup = newLayersGroups[idx] = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
                polygon = new (0, $5c417e1ed90142c5$export$6042a400d113f2bd)({
                    shape: {
                        points: points0,
                        stackedOnPoints: points1,
                        smooth: 0.4,
                        stackedOnSmooth: 0.4,
                        smoothConstraint: false
                    },
                    z2: 0
                });
                layerGroup.add(polygon);
                group.add(layerGroup);
                if (seriesModel.isAnimationEnabled()) polygon.setClipPath($91b53b7eca57e10b$var$createGridClipShape(polygon.getBoundingRect(), seriesModel, function() {
                    polygon.removeClipPath();
                }));
            } else {
                var layerGroup = oldLayersGroups[oldIdx];
                polygon = layerGroup.childAt(0);
                group.add(layerGroup);
                newLayersGroups[idx] = layerGroup;
                $8b353638fbedfefa$export$c8dce3c08436e91e(polygon, {
                    shape: {
                        points: points0,
                        stackedOnPoints: points1
                    }
                }, seriesModel);
                (0, $8b353638fbedfefa$export$bca7290a9faf0ec9)(polygon);
            }
            (0, $6800dfcb6e1e2a44$export$9a13992917966657)(polygon, (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(seriesModel), {
                labelDataIndex: indices[j - 1],
                defaultText: data.getName(indices[j - 1]),
                inheritColor: style.fill
            }, {
                normal: {
                    verticalAlign: 'middle'
                }
            });
            polygon.setTextConfig({
                position: null,
                local: true
            });
            var labelEl = polygon.getTextContent();
            // TODO More label position options.
            if (labelEl) {
                labelEl.x = textLayout.x - margin;
                labelEl.y = textLayout.y0 + textLayout.y / 2;
            }
            polygon.useStyle(style);
            data.setItemGraphicEl(idx, polygon);
            (0, $2bf82c0980125b62$export$48b68047d330bbc9)(polygon, seriesModel);
            (0, $2bf82c0980125b62$export$e51187539ff11209)(polygon, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
        }
        this._layersSeries = layersSeries;
        this._layers = newLayersGroups;
    };
    ThemeRiverView.type = 'themeRiver';
    return ThemeRiverView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
// add animation to the view
function $91b53b7eca57e10b$var$createGridClipShape(rect, seriesModel, cb) {
    var rectEl = new $419e5ff2f303755e$export$2e2bcd8739ae039({
        shape: {
            x: rect.x - 10,
            y: rect.y - 10,
            width: 0,
            height: rect.height + 20
        }
    });
    $8b353638fbedfefa$export$a121566aadcfe021(rectEl, {
        shape: {
            x: rect.x - 50,
            width: rect.width + 100,
            height: rect.height + 20
        }
    }, seriesModel, cb);
    return rectEl;
}
var $91b53b7eca57e10b$export$2e2bcd8739ae039 = $91b53b7eca57e10b$var$ThemeRiverView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 








var $5814c4cad54e1e96$var$DATA_NAME_INDEX = 2;
var $5814c4cad54e1e96$var$ThemeRiverSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ThemeRiverSeriesModel, _super);
    function ThemeRiverSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ThemeRiverSeriesModel.type;
        return _this;
    }
    /**
   * @override
   */ ThemeRiverSeriesModel.prototype.init = function(option) {
        // eslint-disable-next-line
        _super.prototype.init.apply(this, arguments);
        // Put this function here is for the sake of consistency of code style.
        // Enable legend selection for each data item
        // Use a function instead of direct access because data reference may changed
        this.legendVisualProvider = new (0, $cf24728fc17c4ab6$export$2e2bcd8739ae039)($7a1bd9c2710fea0d$export$2385a24977818dd0(this.getData, this), $7a1bd9c2710fea0d$export$2385a24977818dd0(this.getRawData, this));
    };
    /**
   * If there is no value of a certain point in the time for some event,set it value to 0.
   *
   * @param {Array} data  initial data in the option
   * @return {Array}
   */ ThemeRiverSeriesModel.prototype.fixData = function(data) {
        var rawDataLength = data.length;
        /**
     * Make sure every layer data get the same keys.
     * The value index tells which layer has visited.
     * {
     *  2014/01/01: -1
     * }
     */ var timeValueKeys = {};
        // grouped data by name
        var groupResult = (0, $76d619f648247e6d$export$7ab5bda43e13168f)(data, function(item) {
            if (!timeValueKeys.hasOwnProperty(item[0] + '')) timeValueKeys[item[0] + ''] = -1;
            return item[2];
        });
        var layerData = [];
        groupResult.buckets.each(function(items, key) {
            layerData.push({
                name: key,
                dataList: items
            });
        });
        var layerNum = layerData.length;
        for(var k = 0; k < layerNum; ++k){
            var name_1 = layerData[k].name;
            for(var j = 0; j < layerData[k].dataList.length; ++j){
                var timeValue = layerData[k].dataList[j][0] + '';
                timeValueKeys[timeValue] = k;
            }
            for(var timeValue in timeValueKeys)if (timeValueKeys.hasOwnProperty(timeValue) && timeValueKeys[timeValue] !== k) {
                timeValueKeys[timeValue] = k;
                data[rawDataLength] = [
                    timeValue,
                    0,
                    name_1
                ];
                rawDataLength++;
            }
        }
        return data;
    };
    /**
   * @override
   * @param  option  the initial option that user gave
   * @param  ecModel  the model object for themeRiver option
   */ ThemeRiverSeriesModel.prototype.getInitialData = function(option, ecModel) {
        var singleAxisModel = this.getReferringComponents('singleAxis', (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
        var axisType = singleAxisModel.get('type');
        // filter the data item with the value of label is undefined
        var filterData = $7a1bd9c2710fea0d$export$3dea766d36a8935f(option.data, function(dataItem) {
            return dataItem[2] !== undefined;
        });
        // ??? TODO design a stage to transfer data for themeRiver and lines?
        var data = this.fixData(filterData || []);
        var nameList = [];
        var nameMap = this.nameMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        var count = 0;
        for(var i = 0; i < data.length; ++i){
            nameList.push(data[i][$5814c4cad54e1e96$var$DATA_NAME_INDEX]);
            if (!nameMap.get(data[i][$5814c4cad54e1e96$var$DATA_NAME_INDEX])) {
                nameMap.set(data[i][$5814c4cad54e1e96$var$DATA_NAME_INDEX], count);
                count++;
            }
        }
        var dimensions = (0, $a27631012b7b377c$export$2e2bcd8739ae039)(data, {
            coordDimensions: [
                'single'
            ],
            dimensionsDefine: [
                {
                    name: 'time',
                    type: (0, $18085de91ae59d03$export$af1622903e71278e)(axisType)
                },
                {
                    name: 'value',
                    type: 'float'
                },
                {
                    name: 'name',
                    type: 'ordinal'
                }
            ],
            encodeDefine: {
                single: 0,
                value: 1,
                itemName: 2
            }
        }).dimensions;
        var list = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)(dimensions, this);
        list.initData(data);
        return list;
    };
    /**
   * The raw data is divided into multiple layers and each layer
   *     has same name.
   */ ThemeRiverSeriesModel.prototype.getLayerSeries = function() {
        var data = this.getData();
        var lenCount = data.count();
        var indexArr = [];
        for(var i = 0; i < lenCount; ++i)indexArr[i] = i;
        var timeDim = data.mapDimension('single');
        // data group by name
        var groupResult = (0, $76d619f648247e6d$export$7ab5bda43e13168f)(indexArr, function(index) {
            return data.get('name', index);
        });
        var layerSeries = [];
        groupResult.buckets.each(function(items, key) {
            items.sort(function(index1, index2) {
                return data.get(timeDim, index1) - data.get(timeDim, index2);
            });
            layerSeries.push({
                name: key,
                indices: items
            });
        });
        return layerSeries;
    };
    /**
   * Get data indices for show tooltip content
   */ ThemeRiverSeriesModel.prototype.getAxisTooltipData = function(dim, value, baseAxis) {
        if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(dim)) dim = dim ? [
            dim
        ] : [];
        var data = this.getData();
        var layerSeries = this.getLayerSeries();
        var indices = [];
        var layerNum = layerSeries.length;
        var nestestValue;
        for(var i = 0; i < layerNum; ++i){
            var minDist = Number.MAX_VALUE;
            var nearestIdx = -1;
            var pointNum = layerSeries[i].indices.length;
            for(var j = 0; j < pointNum; ++j){
                var theValue = data.get(dim[0], layerSeries[i].indices[j]);
                var dist = Math.abs(theValue - value);
                if (dist <= minDist) {
                    nestestValue = theValue;
                    minDist = dist;
                    nearestIdx = layerSeries[i].indices[j];
                }
            }
            indices.push(nearestIdx);
        }
        return {
            dataIndices: indices,
            nestestValue: nestestValue
        };
    };
    ThemeRiverSeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        var data = this.getData();
        var name = data.getName(dataIndex);
        var value = data.get(data.mapDimension('value'), dataIndex);
        return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)('nameValue', {
            name: name,
            value: value
        });
    };
    ThemeRiverSeriesModel.type = 'series.themeRiver';
    ThemeRiverSeriesModel.dependencies = [
        'singleAxis'
    ];
    ThemeRiverSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        colorBy: 'data',
        coordinateSystem: 'singleAxis',
        // gap in axis's orthogonal orientation
        boundaryGap: [
            '10%',
            '10%'
        ],
        // legendHoverLink: true,
        singleAxisIndex: 0,
        animationEasing: 'linear',
        label: {
            margin: 4,
            show: true,
            position: 'left',
            fontSize: 11
        },
        emphasis: {
            label: {
                show: true
            }
        }
    };
    return ThemeRiverSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $5814c4cad54e1e96$export$2e2bcd8739ae039 = $5814c4cad54e1e96$var$ThemeRiverSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $7dda345d99fef8ed$export$2e2bcd8739ae039(ecModel, api) {
    ecModel.eachSeriesByType('themeRiver', function(seriesModel) {
        var data = seriesModel.getData();
        var single = seriesModel.coordinateSystem;
        var layoutInfo = {};
        // use the axis boundingRect for view
        var rect = single.getRect();
        layoutInfo.rect = rect;
        var boundaryGap = seriesModel.get('boundaryGap');
        var axis = single.getAxis();
        layoutInfo.boundaryGap = boundaryGap;
        if (axis.orient === 'horizontal') {
            boundaryGap[0] = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(boundaryGap[0], rect.height);
            boundaryGap[1] = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(boundaryGap[1], rect.height);
            var height = rect.height - boundaryGap[0] - boundaryGap[1];
            $7dda345d99fef8ed$var$doThemeRiverLayout(data, seriesModel, height);
        } else {
            boundaryGap[0] = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(boundaryGap[0], rect.width);
            boundaryGap[1] = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(boundaryGap[1], rect.width);
            var width = rect.width - boundaryGap[0] - boundaryGap[1];
            $7dda345d99fef8ed$var$doThemeRiverLayout(data, seriesModel, width);
        }
        data.setLayout('layoutInfo', layoutInfo);
    });
}
/**
 * The layout information about themeriver
 *
 * @param data  data in the series
 * @param seriesModel  the model object of themeRiver series
 * @param height  value used to compute every series height
 */ function $7dda345d99fef8ed$var$doThemeRiverLayout(data, seriesModel, height) {
    if (!data.count()) return;
    var coordSys = seriesModel.coordinateSystem;
    // the data in each layer are organized into a series.
    var layerSeries = seriesModel.getLayerSeries();
    // the points in each layer.
    var timeDim = data.mapDimension('single');
    var valueDim = data.mapDimension('value');
    var layerPoints = $7a1bd9c2710fea0d$export$871de8747c9eaa88(layerSeries, function(singleLayer) {
        return $7a1bd9c2710fea0d$export$871de8747c9eaa88(singleLayer.indices, function(idx) {
            var pt = coordSys.dataToPoint(data.get(timeDim, idx));
            pt[1] = data.get(valueDim, idx);
            return pt;
        });
    });
    var base = $7dda345d99fef8ed$var$computeBaseline(layerPoints);
    var baseLine = base.y0;
    var ky = height / base.max;
    // set layout information for each item.
    var n = layerSeries.length;
    var m = layerSeries[0].indices.length;
    var baseY0;
    for(var j = 0; j < m; ++j){
        baseY0 = baseLine[j] * ky;
        data.setItemLayout(layerSeries[0].indices[j], {
            layerIndex: 0,
            x: layerPoints[0][j][0],
            y0: baseY0,
            y: layerPoints[0][j][1] * ky
        });
        for(var i = 1; i < n; ++i){
            baseY0 += layerPoints[i - 1][j][1] * ky;
            data.setItemLayout(layerSeries[i].indices[j], {
                layerIndex: i,
                x: layerPoints[i][j][0],
                y0: baseY0,
                y: layerPoints[i][j][1] * ky
            });
        }
    }
}
/**
 * Compute the baseLine of the rawdata
 * Inspired by Lee Byron's paper Stacked Graphs - Geometry & Aesthetics
 *
 * @param  data  the points in each layer
 */ function $7dda345d99fef8ed$var$computeBaseline(data) {
    var layerNum = data.length;
    var pointNum = data[0].length;
    var sums = [];
    var y0 = [];
    var max = 0;
    for(var i = 0; i < pointNum; ++i){
        var temp = 0;
        for(var j = 0; j < layerNum; ++j)temp += data[j][i][1];
        if (temp > max) max = temp;
        sums.push(temp);
    }
    for(var k = 0; k < pointNum; ++k)y0[k] = (max - sums[k]) / 2;
    max = 0;
    for(var l = 0; l < pointNum; ++l){
        var sum = sums[l] + y0[l];
        if (sum > max) max = sum;
    }
    return {
        y0: y0,
        max: max
    };
}



function $e883cd02390b2e6d$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $91b53b7eca57e10b$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $5814c4cad54e1e96$export$2e2bcd8739ae039));
    registers.registerLayout((0, $7dda345d99fef8ed$export$2e2bcd8739ae039));
    registers.registerProcessor((0, $e11a533bf70b759c$export$2e2bcd8739ae039)('themeRiver'));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* A third-party license is embedded for some of the code in this file:
* The tree layoutHelper implementation was originally copied from
* "d3.js"(https://github.com/d3/d3-hierarchy) with
* some modifications made for this project.
* (see more details in the comment of the specific method below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the licence of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/ /**
 * @file The layout algorithm of node-link tree diagrams. Here we using Reingold-Tilford algorithm to drawing
 *       the tree.
 */ 
function $172d7581b75555e9$export$2cd8252107eb640b(inRoot) {
    var root = inRoot;
    root.hierNode = {
        defaultAncestor: null,
        ancestor: root,
        prelim: 0,
        modifier: 0,
        change: 0,
        shift: 0,
        i: 0,
        thread: null
    };
    var nodes = [
        root
    ];
    var node;
    var children;
    while(node = nodes.pop()){
        // jshint ignore:line
        children = node.children;
        if (node.isExpand && children.length) {
            var n = children.length;
            for(var i = n - 1; i >= 0; i--){
                var child = children[i];
                child.hierNode = {
                    defaultAncestor: null,
                    ancestor: child,
                    prelim: 0,
                    modifier: 0,
                    change: 0,
                    shift: 0,
                    i: i,
                    thread: null
                };
                nodes.push(child);
            }
        }
    }
}
function $172d7581b75555e9$export$f7eff93d75358a2c(node, separation) {
    var children = node.isExpand ? node.children : [];
    var siblings = node.parentNode.children;
    var subtreeW = node.hierNode.i ? siblings[node.hierNode.i - 1] : null;
    if (children.length) {
        $172d7581b75555e9$var$executeShifts(node);
        var midPoint = (children[0].hierNode.prelim + children[children.length - 1].hierNode.prelim) / 2;
        if (subtreeW) {
            node.hierNode.prelim = subtreeW.hierNode.prelim + separation(node, subtreeW);
            node.hierNode.modifier = node.hierNode.prelim - midPoint;
        } else node.hierNode.prelim = midPoint;
    } else if (subtreeW) node.hierNode.prelim = subtreeW.hierNode.prelim + separation(node, subtreeW);
    node.parentNode.hierNode.defaultAncestor = $172d7581b75555e9$var$apportion(node, subtreeW, node.parentNode.hierNode.defaultAncestor || siblings[0], separation);
}
function $172d7581b75555e9$export$39e6f19b1ce889be(node) {
    var nodeX = node.hierNode.prelim + node.parentNode.hierNode.modifier;
    node.setLayout({
        x: nodeX
    }, true);
    node.hierNode.modifier += node.parentNode.hierNode.modifier;
}
function $172d7581b75555e9$export$3bf720ece7bc7b2e(cb) {
    return arguments.length ? cb : $172d7581b75555e9$var$defaultSeparation;
}
function $172d7581b75555e9$export$60198ec123d36099(rad, r) {
    rad -= Math.PI / 2;
    return {
        x: r * Math.cos(rad),
        y: r * Math.sin(rad)
    };
}
function $172d7581b75555e9$export$c02eeb5f98d59b89(seriesModel, api) {
    return $93b9bc7f22ac7369$export$4517a5ca639a7293(seriesModel.getBoxLayoutParams(), {
        width: api.getWidth(),
        height: api.getHeight()
    });
}
/**
 * All other shifts, applied to the smaller subtrees between w- and w+, are
 * performed by this function.
 *
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 */ function $172d7581b75555e9$var$executeShifts(node) {
    var children = node.children;
    var n = children.length;
    var shift = 0;
    var change = 0;
    while(--n >= 0){
        var child = children[n];
        child.hierNode.prelim += shift;
        child.hierNode.modifier += shift;
        change += child.hierNode.change;
        shift += child.hierNode.shift + change;
    }
}
/**
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 *
 * The core of the algorithm. Here, a new subtree is combined with the
 * previous subtrees. Threads are used to traverse the inside and outside
 * contours of the left and right subtree up to the highest common level.
 * Whenever two nodes of the inside contours conflict, we compute the left
 * one of the greatest uncommon ancestors using the function nextAncestor()
 * and call moveSubtree() to shift the subtree and prepare the shifts of
 * smaller subtrees. Finally, we add a new thread (if necessary).
 */ function $172d7581b75555e9$var$apportion(subtreeV, subtreeW, ancestor, separation) {
    if (subtreeW) {
        var nodeOutRight = subtreeV;
        var nodeInRight = subtreeV;
        var nodeOutLeft = nodeInRight.parentNode.children[0];
        var nodeInLeft = subtreeW;
        var sumOutRight = nodeOutRight.hierNode.modifier;
        var sumInRight = nodeInRight.hierNode.modifier;
        var sumOutLeft = nodeOutLeft.hierNode.modifier;
        var sumInLeft = nodeInLeft.hierNode.modifier;
        while(nodeInLeft = $172d7581b75555e9$var$nextRight(nodeInLeft), nodeInRight = $172d7581b75555e9$var$nextLeft(nodeInRight), nodeInLeft && nodeInRight){
            nodeOutRight = $172d7581b75555e9$var$nextRight(nodeOutRight);
            nodeOutLeft = $172d7581b75555e9$var$nextLeft(nodeOutLeft);
            nodeOutRight.hierNode.ancestor = subtreeV;
            var shift = nodeInLeft.hierNode.prelim + sumInLeft - nodeInRight.hierNode.prelim - sumInRight + separation(nodeInLeft, nodeInRight);
            if (shift > 0) {
                $172d7581b75555e9$var$moveSubtree($172d7581b75555e9$var$nextAncestor(nodeInLeft, subtreeV, ancestor), subtreeV, shift);
                sumInRight += shift;
                sumOutRight += shift;
            }
            sumInLeft += nodeInLeft.hierNode.modifier;
            sumInRight += nodeInRight.hierNode.modifier;
            sumOutRight += nodeOutRight.hierNode.modifier;
            sumOutLeft += nodeOutLeft.hierNode.modifier;
        }
        if (nodeInLeft && !$172d7581b75555e9$var$nextRight(nodeOutRight)) {
            nodeOutRight.hierNode.thread = nodeInLeft;
            nodeOutRight.hierNode.modifier += sumInLeft - sumOutRight;
        }
        if (nodeInRight && !$172d7581b75555e9$var$nextLeft(nodeOutLeft)) {
            nodeOutLeft.hierNode.thread = nodeInRight;
            nodeOutLeft.hierNode.modifier += sumInRight - sumOutLeft;
            ancestor = subtreeV;
        }
    }
    return ancestor;
}
/**
 * This function is used to traverse the right contour of a subtree.
 * It returns the rightmost child of node or the thread of node. The function
 * returns null if and only if node is on the highest depth of its subtree.
 */ function $172d7581b75555e9$var$nextRight(node) {
    var children = node.children;
    return children.length && node.isExpand ? children[children.length - 1] : node.hierNode.thread;
}
/**
 * This function is used to traverse the left contour of a subtree (or a subforest).
 * It returns the leftmost child of node or the thread of node. The function
 * returns null if and only if node is on the highest depth of its subtree.
 */ function $172d7581b75555e9$var$nextLeft(node) {
    var children = node.children;
    return children.length && node.isExpand ? children[0] : node.hierNode.thread;
}
/**
 * If nodeInLeft’s ancestor is a sibling of node, returns nodeInLeft’s ancestor.
 * Otherwise, returns the specified ancestor.
 */ function $172d7581b75555e9$var$nextAncestor(nodeInLeft, node, ancestor) {
    return nodeInLeft.hierNode.ancestor.parentNode === node.parentNode ? nodeInLeft.hierNode.ancestor : ancestor;
}
/**
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 *
 * Shifts the current subtree rooted at wr.
 * This is done by increasing prelim(w+) and modifier(w+) by shift.
 */ function $172d7581b75555e9$var$moveSubtree(wl, wr, shift) {
    var change = shift / (wr.hierNode.i - wl.hierNode.i);
    wr.hierNode.change -= change;
    wr.hierNode.shift += shift;
    wr.hierNode.modifier += shift;
    wr.hierNode.prelim += shift;
    wl.hierNode.change += change;
}
/**
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 */ function $172d7581b75555e9$var$defaultSeparation(node1, node2) {
    return node1.parentNode === node2.parentNode ? 1 : 2;
}











var $c673dc2ab6ad4136$var$TreeEdgeShape = /** @class */ function() {
    function TreeEdgeShape() {
        this.parentPoint = [];
        this.childPoints = [];
    }
    return TreeEdgeShape;
}();
var $c673dc2ab6ad4136$var$TreePath = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(TreePath, _super);
    function TreePath(opts) {
        return _super.call(this, opts) || this;
    }
    TreePath.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    TreePath.prototype.getDefaultShape = function() {
        return new $c673dc2ab6ad4136$var$TreeEdgeShape();
    };
    TreePath.prototype.buildPath = function(ctx, shape) {
        var childPoints = shape.childPoints;
        var childLen = childPoints.length;
        var parentPoint = shape.parentPoint;
        var firstChildPos = childPoints[0];
        var lastChildPos = childPoints[childLen - 1];
        if (childLen === 1) {
            ctx.moveTo(parentPoint[0], parentPoint[1]);
            ctx.lineTo(firstChildPos[0], firstChildPos[1]);
            return;
        }
        var orient = shape.orient;
        var forkDim = orient === 'TB' || orient === 'BT' ? 0 : 1;
        var otherDim = 1 - forkDim;
        var forkPosition = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(shape.forkPosition, 1);
        var tmpPoint = [];
        tmpPoint[forkDim] = parentPoint[forkDim];
        tmpPoint[otherDim] = parentPoint[otherDim] + (lastChildPos[otherDim] - parentPoint[otherDim]) * forkPosition;
        ctx.moveTo(parentPoint[0], parentPoint[1]);
        ctx.lineTo(tmpPoint[0], tmpPoint[1]);
        ctx.moveTo(firstChildPos[0], firstChildPos[1]);
        tmpPoint[forkDim] = firstChildPos[forkDim];
        ctx.lineTo(tmpPoint[0], tmpPoint[1]);
        tmpPoint[forkDim] = lastChildPos[forkDim];
        ctx.lineTo(tmpPoint[0], tmpPoint[1]);
        ctx.lineTo(lastChildPos[0], lastChildPos[1]);
        for(var i = 1; i < childLen - 1; i++){
            var point = childPoints[i];
            ctx.moveTo(point[0], point[1]);
            tmpPoint[forkDim] = point[forkDim];
            ctx.lineTo(tmpPoint[0], tmpPoint[1]);
        }
    };
    return TreePath;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
var $c673dc2ab6ad4136$var$TreeView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(TreeView, _super);
    function TreeView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TreeView.type;
        _this._mainGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        return _this;
    }
    TreeView.prototype.init = function(ecModel, api) {
        this._controller = new (0, $15927f329deeab51$export$2e2bcd8739ae039)(api.getZr());
        this._controllerHost = {
            target: this.group
        };
        this.group.add(this._mainGroup);
    };
    TreeView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var layoutInfo = seriesModel.layoutInfo;
        var group = this._mainGroup;
        var layout = seriesModel.get('layout');
        if (layout === 'radial') {
            group.x = layoutInfo.x + layoutInfo.width / 2;
            group.y = layoutInfo.y + layoutInfo.height / 2;
        } else {
            group.x = layoutInfo.x;
            group.y = layoutInfo.y;
        }
        this._updateViewCoordSys(seriesModel, api);
        this._updateController(seriesModel, ecModel, api);
        var oldData = this._data;
        data.diff(oldData).add(function(newIdx) {
            if ($c673dc2ab6ad4136$var$symbolNeedsDraw(data, newIdx)) // Create node and edge
            $c673dc2ab6ad4136$var$updateNode(data, newIdx, null, group, seriesModel);
        }).update(function(newIdx, oldIdx) {
            var symbolEl = oldData.getItemGraphicEl(oldIdx);
            if (!$c673dc2ab6ad4136$var$symbolNeedsDraw(data, newIdx)) {
                symbolEl && $c673dc2ab6ad4136$var$removeNode(oldData, oldIdx, symbolEl, group, seriesModel);
                return;
            }
            // Update node and edge
            $c673dc2ab6ad4136$var$updateNode(data, newIdx, symbolEl, group, seriesModel);
        }).remove(function(oldIdx) {
            var symbolEl = oldData.getItemGraphicEl(oldIdx);
            // When remove a collapsed node of subtree, since the collapsed
            // node haven't been initialized with a symbol element,
            // you can't found it's symbol element through index.
            // so if we want to remove the symbol element we should insure
            // that the symbol element is not null.
            if (symbolEl) $c673dc2ab6ad4136$var$removeNode(oldData, oldIdx, symbolEl, group, seriesModel);
        }).execute();
        this._nodeScaleRatio = seriesModel.get('nodeScaleRatio');
        this._updateNodeAndLinkScale(seriesModel);
        if (seriesModel.get('expandAndCollapse') === true) data.eachItemGraphicEl(function(el, dataIndex) {
            el.off('click').on('click', function() {
                api.dispatchAction({
                    type: 'treeExpandAndCollapse',
                    seriesId: seriesModel.id,
                    dataIndex: dataIndex
                });
            });
        });
        this._data = data;
    };
    TreeView.prototype._updateViewCoordSys = function(seriesModel, api) {
        var data = seriesModel.getData();
        var points = [];
        data.each(function(idx) {
            var layout = data.getItemLayout(idx);
            if (layout && !isNaN(layout.x) && !isNaN(layout.y)) points.push([
                +layout.x,
                +layout.y
            ]);
        });
        var min = [];
        var max = [];
        $af3aab2435198f82$export$188c3cd07b4129dd(points, min, max);
        // If don't Store min max when collapse the root node after roam,
        // the root node will disappear.
        var oldMin = this._min;
        var oldMax = this._max;
        // If width or height is 0
        if (max[0] - min[0] === 0) {
            min[0] = oldMin ? oldMin[0] : min[0] - 1;
            max[0] = oldMax ? oldMax[0] : max[0] + 1;
        }
        if (max[1] - min[1] === 0) {
            min[1] = oldMin ? oldMin[1] : min[1] - 1;
            max[1] = oldMax ? oldMax[1] : max[1] + 1;
        }
        var viewCoordSys = seriesModel.coordinateSystem = new (0, $4a92e7570d47c1fe$export$2e2bcd8739ae039)();
        viewCoordSys.zoomLimit = seriesModel.get('scaleLimit');
        viewCoordSys.setBoundingRect(min[0], min[1], max[0] - min[0], max[1] - min[1]);
        viewCoordSys.setCenter(seriesModel.get('center'), api);
        viewCoordSys.setZoom(seriesModel.get('zoom'));
        // Here we use viewCoordSys just for computing the 'position' and 'scale' of the group
        this.group.attr({
            x: viewCoordSys.x,
            y: viewCoordSys.y,
            scaleX: viewCoordSys.scaleX,
            scaleY: viewCoordSys.scaleY
        });
        this._min = min;
        this._max = max;
    };
    TreeView.prototype._updateController = function(seriesModel, ecModel, api) {
        var _this = this;
        var controller = this._controller;
        var controllerHost = this._controllerHost;
        var group = this.group;
        controller.setPointerChecker(function(e, x, y) {
            var rect = group.getBoundingRect();
            rect.applyTransform(group.transform);
            return rect.contain(x, y) && !(0, $bee256db41541054$export$8a33eacb690eac07)(e, api, seriesModel);
        });
        controller.enable(seriesModel.get('roam'));
        controllerHost.zoomLimit = seriesModel.get('scaleLimit');
        controllerHost.zoom = seriesModel.coordinateSystem.getZoom();
        controller.off('pan').off('zoom').on('pan', function(e) {
            $35fd859fd545c4be$export$1e6abcd98caba733(controllerHost, e.dx, e.dy);
            api.dispatchAction({
                seriesId: seriesModel.id,
                type: 'treeRoam',
                dx: e.dx,
                dy: e.dy
            });
        }).on('zoom', function(e) {
            $35fd859fd545c4be$export$29b3c66d30a4866(controllerHost, e.scale, e.originX, e.originY);
            api.dispatchAction({
                seriesId: seriesModel.id,
                type: 'treeRoam',
                zoom: e.scale,
                originX: e.originX,
                originY: e.originY
            });
            _this._updateNodeAndLinkScale(seriesModel);
            // Only update label layout on zoom
            api.updateLabelLayout();
        });
    };
    TreeView.prototype._updateNodeAndLinkScale = function(seriesModel) {
        var data = seriesModel.getData();
        var nodeScale = this._getNodeGlobalScale(seriesModel);
        data.eachItemGraphicEl(function(el, idx) {
            el.setSymbolScale(nodeScale);
        });
    };
    TreeView.prototype._getNodeGlobalScale = function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys.type !== 'view') return 1;
        var nodeScaleRatio = this._nodeScaleRatio;
        var groupZoom = coordSys.scaleX || 1;
        // Scale node when zoom changes
        var roamZoom = coordSys.getZoom();
        var nodeScale = (roamZoom - 1) * nodeScaleRatio + 1;
        return nodeScale / groupZoom;
    };
    TreeView.prototype.dispose = function() {
        this._controller && this._controller.dispose();
        this._controllerHost = null;
    };
    TreeView.prototype.remove = function() {
        this._mainGroup.removeAll();
        this._data = null;
    };
    TreeView.type = 'tree';
    return TreeView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
function $c673dc2ab6ad4136$var$symbolNeedsDraw(data, dataIndex) {
    var layout = data.getItemLayout(dataIndex);
    return layout && !isNaN(layout.x) && !isNaN(layout.y);
}
function $c673dc2ab6ad4136$var$updateNode(data, dataIndex, symbolEl, group, seriesModel) {
    var isInit = !symbolEl;
    var node = data.tree.getNodeByDataIndex(dataIndex);
    var itemModel = node.getModel();
    var visualColor = node.getVisual('style').fill;
    var symbolInnerColor = node.isExpand === false && node.children.length !== 0 ? visualColor : '#fff';
    var virtualRoot = data.tree.root;
    var source = node.parentNode === virtualRoot ? node : node.parentNode || node;
    var sourceSymbolEl = data.getItemGraphicEl(source.dataIndex);
    var sourceLayout = source.getLayout();
    var sourceOldLayout = sourceSymbolEl ? {
        x: sourceSymbolEl.__oldX,
        y: sourceSymbolEl.__oldY,
        rawX: sourceSymbolEl.__radialOldRawX,
        rawY: sourceSymbolEl.__radialOldRawY
    } : sourceLayout;
    var targetLayout = node.getLayout();
    if (isInit) {
        symbolEl = new (0, $b1d9c3e17ccace80$export$2e2bcd8739ae039)(data, dataIndex, null, {
            symbolInnerColor: symbolInnerColor,
            useNameLabel: true
        });
        symbolEl.x = sourceOldLayout.x;
        symbolEl.y = sourceOldLayout.y;
    } else symbolEl.updateData(data, dataIndex, null, {
        symbolInnerColor: symbolInnerColor,
        useNameLabel: true
    });
    symbolEl.__radialOldRawX = symbolEl.__radialRawX;
    symbolEl.__radialOldRawY = symbolEl.__radialRawY;
    symbolEl.__radialRawX = targetLayout.rawX;
    symbolEl.__radialRawY = targetLayout.rawY;
    group.add(symbolEl);
    data.setItemGraphicEl(dataIndex, symbolEl);
    symbolEl.__oldX = symbolEl.x;
    symbolEl.__oldY = symbolEl.y;
    $8b353638fbedfefa$export$c8dce3c08436e91e(symbolEl, {
        x: targetLayout.x,
        y: targetLayout.y
    }, seriesModel);
    var symbolPath = symbolEl.getSymbolPath();
    if (seriesModel.get('layout') === 'radial') {
        var realRoot = virtualRoot.children[0];
        var rootLayout = realRoot.getLayout();
        var length_1 = realRoot.children.length;
        var rad = void 0;
        var isLeft = void 0;
        if (targetLayout.x === rootLayout.x && node.isExpand === true && realRoot.children.length) {
            var center = {
                x: (realRoot.children[0].getLayout().x + realRoot.children[length_1 - 1].getLayout().x) / 2,
                y: (realRoot.children[0].getLayout().y + realRoot.children[length_1 - 1].getLayout().y) / 2
            };
            rad = Math.atan2(center.y - rootLayout.y, center.x - rootLayout.x);
            if (rad < 0) rad = Math.PI * 2 + rad;
            isLeft = center.x < rootLayout.x;
            if (isLeft) rad = rad - Math.PI;
        } else {
            rad = Math.atan2(targetLayout.y - rootLayout.y, targetLayout.x - rootLayout.x);
            if (rad < 0) rad = Math.PI * 2 + rad;
            if (node.children.length === 0 || node.children.length !== 0 && node.isExpand === false) {
                isLeft = targetLayout.x < rootLayout.x;
                if (isLeft) rad = rad - Math.PI;
            } else {
                isLeft = targetLayout.x > rootLayout.x;
                if (!isLeft) rad = rad - Math.PI;
            }
        }
        var textPosition = isLeft ? 'left' : 'right';
        var normalLabelModel = itemModel.getModel('label');
        var rotate = normalLabelModel.get('rotate');
        var labelRotateRadian = rotate * (Math.PI / 180);
        var textContent = symbolPath.getTextContent();
        if (textContent) {
            symbolPath.setTextConfig({
                position: normalLabelModel.get('position') || textPosition,
                rotation: rotate == null ? -rad : labelRotateRadian,
                origin: 'center'
            });
            textContent.setStyle('verticalAlign', 'middle');
        }
    }
    // Handle status
    var focus = itemModel.get([
        'emphasis',
        'focus'
    ]);
    var focusDataIndices = focus === 'relative' ? $7a1bd9c2710fea0d$export$4fd8af2c48c43416(node.getAncestorsIndices(), node.getDescendantIndices()) : focus === 'ancestor' ? node.getAncestorsIndices() : focus === 'descendant' ? node.getDescendantIndices() : null;
    if (focusDataIndices) // Modify the focus to data indices.
    (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(symbolEl).focus = focusDataIndices;
    $c673dc2ab6ad4136$var$drawEdge(seriesModel, node, virtualRoot, symbolEl, sourceOldLayout, sourceLayout, targetLayout, group);
    if (symbolEl.__edge) symbolEl.onHoverStateChange = function(toState) {
        if (toState !== 'blur') {
            // NOTE: Ensure the parent elements will been blurred firstly.
            // According to the return of getAncestorsIndices and getDescendantIndices
            // TODO: A bit tricky.
            var parentEl = node.parentNode && data.getItemGraphicEl(node.parentNode.dataIndex);
            if (!(parentEl && parentEl.hoverState === (0, $2bf82c0980125b62$export$1307d6a87d56baa))) (0, $2bf82c0980125b62$export$868ba38adffa9e39)(symbolEl.__edge, toState);
        }
    };
}
function $c673dc2ab6ad4136$var$drawEdge(seriesModel, node, virtualRoot, symbolEl, sourceOldLayout, sourceLayout, targetLayout, group) {
    var itemModel = node.getModel();
    var edgeShape = seriesModel.get('edgeShape');
    var layout = seriesModel.get('layout');
    var orient = seriesModel.getOrient();
    var curvature = seriesModel.get([
        'lineStyle',
        'curveness'
    ]);
    var edgeForkPosition = seriesModel.get('edgeForkPosition');
    var lineStyle = itemModel.getModel('lineStyle').getLineStyle();
    var edge = symbolEl.__edge;
    // curve edge from node -> parent
    // polyline edge from node -> children
    if (edgeShape === 'curve') {
        if (node.parentNode && node.parentNode !== virtualRoot) {
            if (!edge) edge = symbolEl.__edge = new $6c7800c49630e431$export$2e2bcd8739ae039({
                shape: $c673dc2ab6ad4136$var$getEdgeShape(layout, orient, curvature, sourceOldLayout, sourceOldLayout)
            });
            $8b353638fbedfefa$export$c8dce3c08436e91e(edge, {
                shape: $c673dc2ab6ad4136$var$getEdgeShape(layout, orient, curvature, sourceLayout, targetLayout)
            }, seriesModel);
        }
    } else if (edgeShape === 'polyline') {
        if (layout === 'orthogonal') {
            if (node !== virtualRoot && node.children && node.children.length !== 0 && node.isExpand === true) {
                var children = node.children;
                var childPoints = [];
                for(var i = 0; i < children.length; i++){
                    var childLayout = children[i].getLayout();
                    childPoints.push([
                        childLayout.x,
                        childLayout.y
                    ]);
                }
                if (!edge) edge = symbolEl.__edge = new $c673dc2ab6ad4136$var$TreePath({
                    shape: {
                        parentPoint: [
                            targetLayout.x,
                            targetLayout.y
                        ],
                        childPoints: [
                            [
                                targetLayout.x,
                                targetLayout.y
                            ]
                        ],
                        orient: orient,
                        forkPosition: edgeForkPosition
                    }
                });
                $8b353638fbedfefa$export$c8dce3c08436e91e(edge, {
                    shape: {
                        parentPoint: [
                            targetLayout.x,
                            targetLayout.y
                        ],
                        childPoints: childPoints
                    }
                }, seriesModel);
            }
        }
    }
    // show all edge when edgeShape is 'curve', filter node `isExpand` is false when edgeShape is 'polyline'
    if (edge && !(edgeShape === 'polyline' && !node.isExpand)) {
        edge.useStyle($7a1bd9c2710fea0d$export$ebe90cb607ad99e({
            strokeNoScale: true,
            fill: null
        }, lineStyle));
        (0, $2bf82c0980125b62$export$48b68047d330bbc9)(edge, itemModel, 'lineStyle');
        (0, $2bf82c0980125b62$export$20f39bbe322fb9ab)(edge);
        group.add(edge);
    }
}
function $c673dc2ab6ad4136$var$removeNodeEdge(node, data, group, seriesModel, removeAnimationOpt) {
    var virtualRoot = data.tree.root;
    var _a = $c673dc2ab6ad4136$var$getSourceNode(virtualRoot, node), source = _a.source, sourceLayout = _a.sourceLayout;
    var symbolEl = data.getItemGraphicEl(node.dataIndex);
    if (!symbolEl) return;
    var sourceSymbolEl = data.getItemGraphicEl(source.dataIndex);
    var sourceEdge = sourceSymbolEl.__edge;
    // 1. when expand the sub tree, delete the children node should delete the edge of
    // the source at the same time. because the polyline edge shape is only owned by the source.
    // 2.when the node is the only children of the source, delete the node should delete the edge of
    // the source at the same time. the same reason as above.
    var edge = symbolEl.__edge || (source.isExpand === false || source.children.length === 1 ? sourceEdge : undefined);
    var edgeShape = seriesModel.get('edgeShape');
    var layoutOpt = seriesModel.get('layout');
    var orient = seriesModel.get('orient');
    var curvature = seriesModel.get([
        'lineStyle',
        'curveness'
    ]);
    if (edge) {
        if (edgeShape === 'curve') $8b353638fbedfefa$export$f883456a56996078(edge, {
            shape: $c673dc2ab6ad4136$var$getEdgeShape(layoutOpt, orient, curvature, sourceLayout, sourceLayout),
            style: {
                opacity: 0
            }
        }, seriesModel, {
            cb: function() {
                group.remove(edge);
            },
            removeOpt: removeAnimationOpt
        });
        else if (edgeShape === 'polyline' && seriesModel.get('layout') === 'orthogonal') $8b353638fbedfefa$export$f883456a56996078(edge, {
            shape: {
                parentPoint: [
                    sourceLayout.x,
                    sourceLayout.y
                ],
                childPoints: [
                    [
                        sourceLayout.x,
                        sourceLayout.y
                    ]
                ]
            },
            style: {
                opacity: 0
            }
        }, seriesModel, {
            cb: function() {
                group.remove(edge);
            },
            removeOpt: removeAnimationOpt
        });
    }
}
function $c673dc2ab6ad4136$var$getSourceNode(virtualRoot, node) {
    var source = node.parentNode === virtualRoot ? node : node.parentNode || node;
    var sourceLayout;
    while(sourceLayout = source.getLayout(), sourceLayout == null)source = source.parentNode === virtualRoot ? source : source.parentNode || source;
    return {
        source: source,
        sourceLayout: sourceLayout
    };
}
function $c673dc2ab6ad4136$var$removeNode(data, dataIndex, symbolEl, group, seriesModel) {
    var node = data.tree.getNodeByDataIndex(dataIndex);
    var virtualRoot = data.tree.root;
    var sourceLayout = $c673dc2ab6ad4136$var$getSourceNode(virtualRoot, node).sourceLayout;
    // Use same duration and easing with update to have more consistent animation.
    var removeAnimationOpt = {
        duration: seriesModel.get('animationDurationUpdate'),
        easing: seriesModel.get('animationEasingUpdate')
    };
    $8b353638fbedfefa$export$f883456a56996078(symbolEl, {
        x: sourceLayout.x + 1,
        y: sourceLayout.y + 1
    }, seriesModel, {
        cb: function() {
            group.remove(symbolEl);
            data.setItemGraphicEl(dataIndex, null);
        },
        removeOpt: removeAnimationOpt
    });
    symbolEl.fadeOut(null, data.hostModel, {
        fadeLabel: true,
        animation: removeAnimationOpt
    });
    // remove edge as parent node
    node.children.forEach(function(childNode) {
        $c673dc2ab6ad4136$var$removeNodeEdge(childNode, data, group, seriesModel, removeAnimationOpt);
    });
    // remove edge as child node
    $c673dc2ab6ad4136$var$removeNodeEdge(node, data, group, seriesModel, removeAnimationOpt);
}
function $c673dc2ab6ad4136$var$getEdgeShape(layoutOpt, orient, curvature, sourceLayout, targetLayout) {
    var cpx1;
    var cpy1;
    var cpx2;
    var cpy2;
    var x1;
    var x2;
    var y1;
    var y2;
    if (layoutOpt === 'radial') {
        x1 = sourceLayout.rawX;
        y1 = sourceLayout.rawY;
        x2 = targetLayout.rawX;
        y2 = targetLayout.rawY;
        var radialCoor1 = (0, $172d7581b75555e9$export$60198ec123d36099)(x1, y1);
        var radialCoor2 = (0, $172d7581b75555e9$export$60198ec123d36099)(x1, y1 + (y2 - y1) * curvature);
        var radialCoor3 = (0, $172d7581b75555e9$export$60198ec123d36099)(x2, y2 + (y1 - y2) * curvature);
        var radialCoor4 = (0, $172d7581b75555e9$export$60198ec123d36099)(x2, y2);
        return {
            x1: radialCoor1.x || 0,
            y1: radialCoor1.y || 0,
            x2: radialCoor4.x || 0,
            y2: radialCoor4.y || 0,
            cpx1: radialCoor2.x || 0,
            cpy1: radialCoor2.y || 0,
            cpx2: radialCoor3.x || 0,
            cpy2: radialCoor3.y || 0
        };
    } else {
        x1 = sourceLayout.x;
        y1 = sourceLayout.y;
        x2 = targetLayout.x;
        y2 = targetLayout.y;
        if (orient === 'LR' || orient === 'RL') {
            cpx1 = x1 + (x2 - x1) * curvature;
            cpy1 = y1;
            cpx2 = x2 + (x1 - x2) * curvature;
            cpy2 = y2;
        }
        if (orient === 'TB' || orient === 'BT') {
            cpx1 = x1;
            cpy1 = y1 + (y2 - y1) * curvature;
            cpx2 = x2;
            cpy2 = y2 + (y1 - y2) * curvature;
        }
    }
    return {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2,
        cpx1: cpx1,
        cpy1: cpy1,
        cpx2: cpx2,
        cpy2: cpy2
    };
}
var $c673dc2ab6ad4136$export$2e2bcd8739ae039 = $c673dc2ab6ad4136$var$TreeView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $908076d89767d409$var$TreeSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(TreeSeriesModel, _super);
    function TreeSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hasSymbolVisual = true;
        // Do it self.
        _this.ignoreStyleOnData = true;
        return _this;
    }
    /**
   * Init a tree data structure from data in option series
   */ TreeSeriesModel.prototype.getInitialData = function(option) {
        // create a virtual root
        var root = {
            name: option.name,
            children: option.data
        };
        var leaves = option.leaves || {};
        var leavesModel = new (0, $6818646a97528290$export$2e2bcd8739ae039)(leaves, this, this.ecModel);
        var tree = (0, $116fa5bb9335391f$export$2e2bcd8739ae039).createTree(root, this, beforeLink);
        function beforeLink(nodeData) {
            nodeData.wrapMethod('getItemModel', function(model, idx) {
                var node = tree.getNodeByDataIndex(idx);
                if (!(node && node.children.length && node.isExpand)) model.parentModel = leavesModel;
                return model;
            });
        }
        var treeDepth = 0;
        tree.eachNode('preorder', function(node) {
            if (node.depth > treeDepth) treeDepth = node.depth;
        });
        var expandAndCollapse = option.expandAndCollapse;
        var expandTreeDepth = expandAndCollapse && option.initialTreeDepth >= 0 ? option.initialTreeDepth : treeDepth;
        tree.root.eachNode('preorder', function(node) {
            var item = node.hostTree.data.getRawDataItem(node.dataIndex);
            // Add item.collapsed != null, because users can collapse node original in the series.data.
            node.isExpand = item && item.collapsed != null ? !item.collapsed : node.depth <= expandTreeDepth;
        });
        return tree.data;
    };
    /**
   * Make the configuration 'orient' backward compatibly, with 'horizontal = LR', 'vertical = TB'.
   * @returns {string} orient
   */ TreeSeriesModel.prototype.getOrient = function() {
        var orient = this.get('orient');
        if (orient === 'horizontal') orient = 'LR';
        else if (orient === 'vertical') orient = 'TB';
        return orient;
    };
    TreeSeriesModel.prototype.setZoom = function(zoom) {
        this.option.zoom = zoom;
    };
    TreeSeriesModel.prototype.setCenter = function(center) {
        this.option.center = center;
    };
    TreeSeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        var tree = this.getData().tree;
        var realRoot = tree.root.children[0];
        var node = tree.getNodeByDataIndex(dataIndex);
        var value = node.getValue();
        var name = node.name;
        while(node && node !== realRoot){
            name = node.parentNode.name + '.' + name;
            node = node.parentNode;
        }
        return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)('nameValue', {
            name: name,
            value: value,
            noValue: isNaN(value) || value == null
        });
    };
    // Add tree path to tooltip param
    TreeSeriesModel.prototype.getDataParams = function(dataIndex) {
        var params = _super.prototype.getDataParams.apply(this, arguments);
        var node = this.getData().tree.getNodeByDataIndex(dataIndex);
        params.treeAncestors = (0, $6341f66602946a06$export$c5baa480d6ceb0a3)(node, this);
        params.collapsed = !node.isExpand;
        return params;
    };
    TreeSeriesModel.type = 'series.tree';
    // can support the position parameters 'left', 'top','right','bottom', 'width',
    // 'height' in the setOption() with 'merge' mode normal.
    TreeSeriesModel.layoutMode = 'box';
    TreeSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        coordinateSystem: 'view',
        // the position of the whole view
        left: '12%',
        top: '12%',
        right: '12%',
        bottom: '12%',
        // the layout of the tree, two value can be selected, 'orthogonal' or 'radial'
        layout: 'orthogonal',
        // value can be 'polyline'
        edgeShape: 'curve',
        edgeForkPosition: '50%',
        // true | false | 'move' | 'scale', see module:component/helper/RoamController.
        roam: false,
        // Symbol size scale ratio in roam
        nodeScaleRatio: 0.4,
        // Default on center of graph
        center: null,
        zoom: 1,
        orient: 'LR',
        symbol: 'emptyCircle',
        symbolSize: 7,
        expandAndCollapse: true,
        initialTreeDepth: 2,
        lineStyle: {
            color: '#ccc',
            width: 1.5,
            curveness: 0.5
        },
        itemStyle: {
            color: 'lightsteelblue',
            // borderColor: '#c23531',
            borderWidth: 1.5
        },
        label: {
            show: true
        },
        animationEasing: 'linear',
        animationDuration: 700,
        animationDurationUpdate: 500
    };
    return TreeSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $908076d89767d409$export$2e2bcd8739ae039 = $908076d89767d409$var$TreeSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Traverse the tree from bottom to top and do something
 */ function $40241c7ef27c3238$export$bd961f70bc91ffb4(root, callback, separation) {
    var nodes = [
        root
    ];
    var next = [];
    var node;
    while(node = nodes.pop()){
        // jshint ignore:line
        next.push(node);
        if (node.isExpand) {
            var children = node.children;
            if (children.length) for(var i = 0; i < children.length; i++)nodes.push(children[i]);
        }
    }
    while(node = next.pop())// jshint ignore:line
    callback(node, separation);
}
/**
 * Traverse the tree from top to bottom and do something
 */ function $40241c7ef27c3238$export$32a66ec2b39acdac(root, callback) {
    var nodes = [
        root
    ];
    var node;
    while(node = nodes.pop()){
        // jshint ignore:line
        callback(node);
        if (node.isExpand) {
            var children = node.children;
            if (children.length) for(var i = children.length - 1; i >= 0; i--)nodes.push(children[i]);
        }
    }
}



function $121bf97d85edc8b9$export$2e2bcd8739ae039(ecModel, api) {
    ecModel.eachSeriesByType('tree', function(seriesModel) {
        $121bf97d85edc8b9$var$commonLayout(seriesModel, api);
    });
}
function $121bf97d85edc8b9$var$commonLayout(seriesModel, api) {
    var layoutInfo = (0, $172d7581b75555e9$export$c02eeb5f98d59b89)(seriesModel, api);
    seriesModel.layoutInfo = layoutInfo;
    var layout = seriesModel.get('layout');
    var width = 0;
    var height = 0;
    var separation = null;
    if (layout === 'radial') {
        width = 2 * Math.PI;
        height = Math.min(layoutInfo.height, layoutInfo.width) / 2;
        separation = (0, $172d7581b75555e9$export$3bf720ece7bc7b2e)(function(node1, node2) {
            return (node1.parentNode === node2.parentNode ? 1 : 2) / node1.depth;
        });
    } else {
        width = layoutInfo.width;
        height = layoutInfo.height;
        separation = (0, $172d7581b75555e9$export$3bf720ece7bc7b2e)();
    }
    var virtualRoot = seriesModel.getData().tree.root;
    var realRoot = virtualRoot.children[0];
    if (realRoot) {
        (0, $172d7581b75555e9$export$2cd8252107eb640b)(virtualRoot);
        (0, $40241c7ef27c3238$export$bd961f70bc91ffb4)(realRoot, (0, $172d7581b75555e9$export$f7eff93d75358a2c), separation);
        virtualRoot.hierNode.modifier = -realRoot.hierNode.prelim;
        (0, $40241c7ef27c3238$export$32a66ec2b39acdac)(realRoot, (0, $172d7581b75555e9$export$39e6f19b1ce889be));
        var left_1 = realRoot;
        var right_1 = realRoot;
        var bottom_1 = realRoot;
        (0, $40241c7ef27c3238$export$32a66ec2b39acdac)(realRoot, function(node) {
            var x = node.getLayout().x;
            if (x < left_1.getLayout().x) left_1 = node;
            if (x > right_1.getLayout().x) right_1 = node;
            if (node.depth > bottom_1.depth) bottom_1 = node;
        });
        var delta = left_1 === right_1 ? 1 : separation(left_1, right_1) / 2;
        var tx_1 = delta - left_1.getLayout().x;
        var kx_1 = 0;
        var ky_1 = 0;
        var coorX_1 = 0;
        var coorY_1 = 0;
        if (layout === 'radial') {
            kx_1 = width / (right_1.getLayout().x + delta + tx_1);
            // here we use (node.depth - 1), bucause the real root's depth is 1
            ky_1 = height / (bottom_1.depth - 1 || 1);
            (0, $40241c7ef27c3238$export$32a66ec2b39acdac)(realRoot, function(node) {
                coorX_1 = (node.getLayout().x + tx_1) * kx_1;
                coorY_1 = (node.depth - 1) * ky_1;
                var finalCoor = (0, $172d7581b75555e9$export$60198ec123d36099)(coorX_1, coorY_1);
                node.setLayout({
                    x: finalCoor.x,
                    y: finalCoor.y,
                    rawX: coorX_1,
                    rawY: coorY_1
                }, true);
            });
        } else {
            var orient_1 = seriesModel.getOrient();
            if (orient_1 === 'RL' || orient_1 === 'LR') {
                ky_1 = height / (right_1.getLayout().x + delta + tx_1);
                kx_1 = width / (bottom_1.depth - 1 || 1);
                (0, $40241c7ef27c3238$export$32a66ec2b39acdac)(realRoot, function(node) {
                    coorY_1 = (node.getLayout().x + tx_1) * ky_1;
                    coorX_1 = orient_1 === 'LR' ? (node.depth - 1) * kx_1 : width - (node.depth - 1) * kx_1;
                    node.setLayout({
                        x: coorX_1,
                        y: coorY_1
                    }, true);
                });
            } else if (orient_1 === 'TB' || orient_1 === 'BT') {
                kx_1 = width / (right_1.getLayout().x + delta + tx_1);
                ky_1 = height / (bottom_1.depth - 1 || 1);
                (0, $40241c7ef27c3238$export$32a66ec2b39acdac)(realRoot, function(node) {
                    coorX_1 = (node.getLayout().x + tx_1) * kx_1;
                    coorY_1 = orient_1 === 'TB' ? (node.depth - 1) * ky_1 : height - (node.depth - 1) * ky_1;
                    node.setLayout({
                        x: coorX_1,
                        y: coorY_1
                    }, true);
                });
            }
        }
    }
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $d90852cc2c74d10f$export$2e2bcd8739ae039(ecModel) {
    ecModel.eachSeriesByType('tree', function(seriesModel) {
        var data = seriesModel.getData();
        var tree = data.tree;
        tree.eachNode(function(node) {
            var model = node.getModel();
            // TODO Optimize
            var style = model.getModel('itemStyle').getItemStyle();
            var existsStyle = data.ensureUniqueItemVisual(node.dataIndex, 'style');
            (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(existsStyle, style);
        });
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $0f83bac2aba33cc4$export$83b6a0f4104bd4f4(registers) {
    registers.registerAction({
        type: 'treeExpandAndCollapse',
        event: 'treeExpandAndCollapse',
        update: 'update'
    }, function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: 'series',
            subType: 'tree',
            query: payload
        }, function(seriesModel) {
            var dataIndex = payload.dataIndex;
            var tree = seriesModel.getData().tree;
            var node = tree.getNodeByDataIndex(dataIndex);
            node.isExpand = !node.isExpand;
        });
    });
    registers.registerAction({
        type: 'treeRoam',
        event: 'treeRoam',
        // Here we set 'none' instead of 'update', because roam action
        // just need to update the transform matrix without having to recalculate
        // the layout. So don't need to go through the whole update process, such
        // as 'dataPrcocess', 'coordSystemUpdate', 'layout' and so on.
        update: 'none'
    }, function(payload, ecModel, api) {
        ecModel.eachComponent({
            mainType: 'series',
            subType: 'tree',
            query: payload
        }, function(seriesModel) {
            var coordSys = seriesModel.coordinateSystem;
            var res = (0, $799fe5cfb5042219$export$797ecc50d262ebd8)(coordSys, payload, undefined, api);
            seriesModel.setCenter && seriesModel.setCenter(res.center);
            seriesModel.setZoom && seriesModel.setZoom(res.zoom);
        });
    });
}


function $44a5d4d260c7de78$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $c673dc2ab6ad4136$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $908076d89767d409$export$2e2bcd8739ae039));
    registers.registerLayout((0, $121bf97d85edc8b9$export$2e2bcd8739ae039));
    registers.registerVisual((0, $d90852cc2c74d10f$export$2e2bcd8739ae039));
    (0, $0f83bac2aba33cc4$export$83b6a0f4104bd4f4)(registers);
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $26d493e9cdfadb01$var$actionTypes = [
    'treemapZoomToNode',
    'treemapRender',
    'treemapMove'
];
function $26d493e9cdfadb01$export$1ad90fc3f3a8bbf9(registers) {
    for(var i = 0; i < $26d493e9cdfadb01$var$actionTypes.length; i++)registers.registerAction({
        type: $26d493e9cdfadb01$var$actionTypes[i],
        update: 'updateView'
    }, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));
    registers.registerAction({
        type: 'treemapRootToNode',
        update: 'updateView'
    }, function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: 'series',
            subType: 'treemap',
            query: payload
        }, handleRootToNode);
        function handleRootToNode(model, index) {
            var types = [
                'treemapZoomToNode',
                'treemapRootToNode'
            ];
            var targetInfo = $6341f66602946a06$export$c5445fa59c15dec4(payload, types, model);
            if (targetInfo) {
                var originViewRoot = model.getViewRoot();
                if (originViewRoot) payload.direction = $6341f66602946a06$export$df59de26c77b5bea(originViewRoot, targetInfo.node) ? 'rollUp' : 'drillDown';
                model.resetViewRoot(targetInfo.node);
            }
        }
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 








var $10d079b37d9731a3$var$TreemapSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(TreemapSeriesModel, _super);
    function TreemapSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TreemapSeriesModel.type;
        _this.preventUsingHoverLayer = true;
        return _this;
    }
    /**
   * @override
   */ TreemapSeriesModel.prototype.getInitialData = function(option, ecModel) {
        // Create a virtual root.
        var root = {
            name: option.name,
            children: option.data
        };
        $10d079b37d9731a3$var$completeTreeValue(root);
        var levels = option.levels || [];
        // Used in "visual priority" in `treemapVisual.js`.
        // This way is a little tricky, must satisfy the precondition:
        //   1. There is no `treeNode.getModel('itemStyle.xxx')` used.
        //   2. The `Model.prototype.getModel()` will not use any clone-like way.
        var designatedVisualItemStyle = this.designatedVisualItemStyle = {};
        var designatedVisualModel = new (0, $6818646a97528290$export$2e2bcd8739ae039)({
            itemStyle: designatedVisualItemStyle
        }, this, ecModel);
        levels = option.levels = $10d079b37d9731a3$var$setDefault(levels, ecModel);
        var levelModels = $7a1bd9c2710fea0d$export$871de8747c9eaa88(levels || [], function(levelDefine) {
            return new (0, $6818646a97528290$export$2e2bcd8739ae039)(levelDefine, designatedVisualModel, ecModel);
        }, this);
        // Make sure always a new tree is created when setOption,
        // in TreemapView, we check whether oldTree === newTree
        // to choose mappings approach among old shapes and new shapes.
        var tree = (0, $116fa5bb9335391f$export$2e2bcd8739ae039).createTree(root, this, beforeLink);
        function beforeLink(nodeData) {
            nodeData.wrapMethod('getItemModel', function(model, idx) {
                var node = tree.getNodeByDataIndex(idx);
                var levelModel = node ? levelModels[node.depth] : null;
                // If no levelModel, we also need `designatedVisualModel`.
                model.parentModel = levelModel || designatedVisualModel;
                return model;
            });
        }
        return tree.data;
    };
    TreemapSeriesModel.prototype.optionUpdated = function() {
        this.resetViewRoot();
    };
    /**
   * @override
   * @param {number} dataIndex
   * @param {boolean} [mutipleSeries=false]
   */ TreemapSeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        var data = this.getData();
        var value = this.getRawValue(dataIndex);
        var name = data.getName(dataIndex);
        return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)('nameValue', {
            name: name,
            value: value
        });
    };
    /**
   * Add tree path to tooltip param
   *
   * @override
   * @param {number} dataIndex
   * @return {Object}
   */ TreemapSeriesModel.prototype.getDataParams = function(dataIndex) {
        var params = _super.prototype.getDataParams.apply(this, arguments);
        var node = this.getData().tree.getNodeByDataIndex(dataIndex);
        params.treeAncestors = (0, $6341f66602946a06$export$c5baa480d6ceb0a3)(node, this);
        // compatitable the previous code.
        params.treePathInfo = params.treeAncestors;
        return params;
    };
    /**
   * @public
   * @param {Object} layoutInfo {
   *                                x: containerGroup x
   *                                y: containerGroup y
   *                                width: containerGroup width
   *                                height: containerGroup height
   *                            }
   */ TreemapSeriesModel.prototype.setLayoutInfo = function(layoutInfo) {
        /**
     * @readOnly
     * @type {Object}
     */ this.layoutInfo = this.layoutInfo || {};
        $7a1bd9c2710fea0d$export$8b58be045bf06082(this.layoutInfo, layoutInfo);
    };
    /**
   * @param  {string} id
   * @return {number} index
   */ TreemapSeriesModel.prototype.mapIdToIndex = function(id) {
        // A feature is implemented:
        // index is monotone increasing with the sequence of
        // input id at the first time.
        // This feature can make sure that each data item and its
        // mapped color have the same index between data list and
        // color list at the beginning, which is useful for user
        // to adjust data-color mapping.
        /**
     * @private
     * @type {Object}
     */ var idIndexMap = this._idIndexMap;
        if (!idIndexMap) {
            idIndexMap = this._idIndexMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
            /**
       * @private
       * @type {number}
       */ this._idIndexMapCount = 0;
        }
        var index = idIndexMap.get(id);
        if (index == null) idIndexMap.set(id, index = this._idIndexMapCount++);
        return index;
    };
    TreemapSeriesModel.prototype.getViewRoot = function() {
        return this._viewRoot;
    };
    TreemapSeriesModel.prototype.resetViewRoot = function(viewRoot) {
        viewRoot ? this._viewRoot = viewRoot : viewRoot = this._viewRoot;
        var root = this.getRawData().tree.root;
        if (!viewRoot || viewRoot !== root && !root.contains(viewRoot)) this._viewRoot = root;
    };
    TreemapSeriesModel.prototype.enableAriaDecal = function() {
        (0, $a116b59e46d9072c$export$2e2bcd8739ae039)(this);
    };
    TreemapSeriesModel.type = 'series.treemap';
    TreemapSeriesModel.layoutMode = 'box';
    TreemapSeriesModel.defaultOption = {
        // Disable progressive rendering
        progressive: 0,
        // size: ['80%', '80%'],            // deprecated, compatible with ec2.
        left: 'center',
        top: 'middle',
        width: '80%',
        height: '80%',
        sort: true,
        clipWindow: 'origin',
        squareRatio: 0.5 * (1 + Math.sqrt(5)),
        leafDepth: null,
        drillDownIcon: "\u25B6",
        // to align specialized icon. ▷▶❒❐▼✚
        zoomToNodeRatio: 0.1024,
        scaleLimit: null,
        roam: true,
        nodeClick: 'zoomToNode',
        animation: true,
        animationDurationUpdate: 900,
        animationEasing: 'quinticInOut',
        breadcrumb: {
            show: true,
            height: 22,
            left: 'center',
            top: 'bottom',
            // right
            // bottom
            emptyItemWidth: 25,
            itemStyle: {
                color: 'rgba(0,0,0,0.7)',
                textStyle: {
                    color: '#fff'
                }
            },
            emphasis: {
                itemStyle: {
                    color: 'rgba(0,0,0,0.9)' // '#5793f3',
                }
            }
        },
        label: {
            show: true,
            // Do not use textDistance, for ellipsis rect just the same as treemap node rect.
            distance: 0,
            padding: 5,
            position: 'inside',
            // formatter: null,
            color: '#fff',
            overflow: 'truncate'
        },
        upperLabel: {
            show: false,
            position: [
                0,
                '50%'
            ],
            height: 20,
            // formatter: null,
            // color: '#fff',
            overflow: 'truncate',
            // align: null,
            verticalAlign: 'middle'
        },
        itemStyle: {
            color: null,
            colorAlpha: null,
            colorSaturation: null,
            borderWidth: 0,
            gapWidth: 0,
            borderColor: '#fff',
            borderColorSaturation: null // If specified, borderColor will be ineffective, and the
        },
        emphasis: {
            upperLabel: {
                show: true,
                position: [
                    0,
                    '50%'
                ],
                overflow: 'truncate',
                verticalAlign: 'middle'
            }
        },
        visualDimension: 0,
        visualMin: null,
        visualMax: null,
        color: [],
        // level[n].color (if necessary).
        // + Specify color list of each level. level[0].color would be global
        // color list if not specified. (see method `setDefault`).
        // + But set as a empty array to forbid fetch color from global palette
        // when using nodeModel.get('color'), otherwise nodes on deep level
        // will always has color palette set and are not able to inherit color
        // from parent node.
        // + TreemapSeries.color can not be set as 'none', otherwise effect
        // legend color fetching (see seriesColor.js).
        colorAlpha: null,
        colorSaturation: null,
        colorMappingBy: 'index',
        visibleMin: 10,
        // be rendered. Only works when sort is 'asc' or 'desc'.
        childrenVisibleMin: null,
        // grandchildren will not show.
        // Why grandchildren? If not grandchildren but children,
        // some siblings show children and some not,
        // the appearance may be mess and not consistent,
        levels: [] // Each item: {
    };
    return TreemapSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
/**
 * @param {Object} dataNode
 */ function $10d079b37d9731a3$var$completeTreeValue(dataNode) {
    // Postorder travel tree.
    // If value of none-leaf node is not set,
    // calculate it by suming up the value of all children.
    var sum = 0;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(dataNode.children, function(child) {
        $10d079b37d9731a3$var$completeTreeValue(child);
        var childValue = child.value;
        $7a1bd9c2710fea0d$export$43bee75e5e14138e(childValue) && (childValue = childValue[0]);
        sum += childValue;
    });
    var thisValue = dataNode.value;
    if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(thisValue)) thisValue = thisValue[0];
    if (thisValue == null || isNaN(thisValue)) thisValue = sum;
    // Value should not less than 0.
    if (thisValue < 0) thisValue = 0;
    $7a1bd9c2710fea0d$export$43bee75e5e14138e(dataNode.value) ? dataNode.value[0] = thisValue : dataNode.value = thisValue;
}
/**
 * set default to level configuration
 */ function $10d079b37d9731a3$var$setDefault(levels, ecModel) {
    var globalColorList = (0, $76d619f648247e6d$export$4f07b212a02c8051)(ecModel.get('color'));
    var globalDecalList = (0, $76d619f648247e6d$export$4f07b212a02c8051)(ecModel.get([
        'aria',
        'decal',
        'decals'
    ]));
    if (!globalColorList) return;
    levels = levels || [];
    var hasColorDefine;
    var hasDecalDefine;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(levels, function(levelDefine) {
        var model = new (0, $6818646a97528290$export$2e2bcd8739ae039)(levelDefine);
        var modelColor = model.get('color');
        var modelDecal = model.get('decal');
        if (model.get([
            'itemStyle',
            'color'
        ]) || modelColor && modelColor !== 'none') hasColorDefine = true;
        if (model.get([
            'itemStyle',
            'decal'
        ]) || modelDecal && modelDecal !== 'none') hasDecalDefine = true;
    });
    var level0 = levels[0] || (levels[0] = {});
    if (!hasColorDefine) level0.color = globalColorList.slice();
    if (!hasDecalDefine && globalDecalList) level0.decal = globalDecalList.slice();
    return levels;
}
var $10d079b37d9731a3$export$2e2bcd8739ae039 = $10d079b37d9731a3$var$TreemapSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







var $504a89857fe7780b$var$TEXT_PADDING = 8;
var $504a89857fe7780b$var$ITEM_GAP = 8;
var $504a89857fe7780b$var$ARRAY_LENGTH = 5;
var $504a89857fe7780b$var$Breadcrumb = /** @class */ function() {
    function Breadcrumb(containerGroup) {
        this.group = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        containerGroup.add(this.group);
    }
    Breadcrumb.prototype.render = function(seriesModel, api, targetNode, onSelect) {
        var model = seriesModel.getModel('breadcrumb');
        var thisGroup = this.group;
        thisGroup.removeAll();
        if (!model.get('show') || !targetNode) return;
        var normalStyleModel = model.getModel('itemStyle');
        var emphasisModel = model.getModel('emphasis');
        var textStyleModel = normalStyleModel.getModel('textStyle');
        var emphasisTextStyleModel = emphasisModel.getModel([
            'itemStyle',
            'textStyle'
        ]);
        var layoutParam = {
            pos: {
                left: model.get('left'),
                right: model.get('right'),
                top: model.get('top'),
                bottom: model.get('bottom')
            },
            box: {
                width: api.getWidth(),
                height: api.getHeight()
            },
            emptyItemWidth: model.get('emptyItemWidth'),
            totalWidth: 0,
            renderList: []
        };
        this._prepare(targetNode, layoutParam, textStyleModel);
        this._renderContent(seriesModel, layoutParam, normalStyleModel, emphasisModel, textStyleModel, emphasisTextStyleModel, onSelect);
        $93b9bc7f22ac7369$export$74054bd96b5eeef1(thisGroup, layoutParam.pos, layoutParam.box);
    };
    /**
   * Prepare render list and total width
   * @private
   */ Breadcrumb.prototype._prepare = function(targetNode, layoutParam, textStyleModel) {
        for(var node = targetNode; node; node = node.parentNode){
            var text = (0, $76d619f648247e6d$export$fb1a222ba5dd6e51)(node.getModel().get('name'), '');
            var textRect = textStyleModel.getTextRect(text);
            var itemWidth = Math.max(textRect.width + $504a89857fe7780b$var$TEXT_PADDING * 2, layoutParam.emptyItemWidth);
            layoutParam.totalWidth += itemWidth + $504a89857fe7780b$var$ITEM_GAP;
            layoutParam.renderList.push({
                node: node,
                text: text,
                width: itemWidth
            });
        }
    };
    /**
   * @private
   */ Breadcrumb.prototype._renderContent = function(seriesModel, layoutParam, normalStyleModel, emphasisModel, textStyleModel, emphasisTextStyleModel, onSelect) {
        // Start rendering.
        var lastX = 0;
        var emptyItemWidth = layoutParam.emptyItemWidth;
        var height = seriesModel.get([
            'breadcrumb',
            'height'
        ]);
        var availableSize = $93b9bc7f22ac7369$export$145a8938a85a22b1(layoutParam.pos, layoutParam.box);
        var totalWidth = layoutParam.totalWidth;
        var renderList = layoutParam.renderList;
        var emphasisItemStyle = emphasisModel.getModel('itemStyle').getItemStyle();
        for(var i = renderList.length - 1; i >= 0; i--){
            var item = renderList[i];
            var itemNode = item.node;
            var itemWidth = item.width;
            var text = item.text;
            // Hdie text and shorten width if necessary.
            if (totalWidth > availableSize.width) {
                totalWidth -= itemWidth - emptyItemWidth;
                itemWidth = emptyItemWidth;
                text = null;
            }
            var el = new $51acf033123e1a30$export$2e2bcd8739ae039({
                shape: {
                    points: $504a89857fe7780b$var$makeItemPoints(lastX, 0, itemWidth, height, i === renderList.length - 1, i === 0)
                },
                style: (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(normalStyleModel.getItemStyle(), {
                    lineJoin: 'bevel'
                }),
                textContent: new $fe885cc21795562b$export$2e2bcd8739ae039({
                    style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(textStyleModel, {
                        text: text
                    })
                }),
                textConfig: {
                    position: 'inside'
                },
                z2: (0, $2bf82c0980125b62$export$1cb9fc6ed5b9836c) * 1e4,
                onclick: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)(onSelect, itemNode)
            });
            el.disableLabelAnimation = true;
            el.getTextContent().ensureState('emphasis').style = (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(emphasisTextStyleModel, {
                text: text
            });
            el.ensureState('emphasis').style = emphasisItemStyle;
            (0, $2bf82c0980125b62$export$e51187539ff11209)(el, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
            this.group.add(el);
            $504a89857fe7780b$var$packEventData(el, seriesModel, itemNode);
            lastX += itemWidth + $504a89857fe7780b$var$ITEM_GAP;
        }
    };
    Breadcrumb.prototype.remove = function() {
        this.group.removeAll();
    };
    return Breadcrumb;
}();
function $504a89857fe7780b$var$makeItemPoints(x, y, itemWidth, itemHeight, head, tail) {
    var points = [
        [
            head ? x : x - $504a89857fe7780b$var$ARRAY_LENGTH,
            y
        ],
        [
            x + itemWidth,
            y
        ],
        [
            x + itemWidth,
            y + itemHeight
        ],
        [
            head ? x : x - $504a89857fe7780b$var$ARRAY_LENGTH,
            y + itemHeight
        ]
    ];
    !tail && points.splice(2, 0, [
        x + itemWidth + $504a89857fe7780b$var$ARRAY_LENGTH,
        y + itemHeight / 2
    ]);
    !head && points.push([
        x,
        y + itemHeight / 2
    ]);
    return points;
}
// Package custom mouse event.
function $504a89857fe7780b$var$packEventData(el, seriesModel, itemNode) {
    (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).eventData = {
        componentType: 'series',
        componentSubType: 'treemap',
        componentIndex: seriesModel.componentIndex,
        seriesIndex: seriesModel.seriesIndex,
        seriesName: seriesModel.name,
        seriesType: 'treemap',
        selfType: 'breadcrumb',
        nodeData: {
            dataIndex: itemNode && itemNode.dataIndex,
            name: itemNode && itemNode.name
        },
        treePathInfo: itemNode && (0, $6341f66602946a06$export$c5baa480d6ceb0a3)(itemNode, seriesModel)
    };
}
var $504a89857fe7780b$export$2e2bcd8739ae039 = $504a89857fe7780b$var$Breadcrumb;





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Animate multiple elements with a single done-callback.
 *
 * @example
 *  animation
 *      .createWrap()
 *      .add(el1, {x: 10, y: 10})
 *      .add(el2, {shape: {width: 500}, style: {fill: 'red'}}, 400)
 *      .done(function () { // done })
 *      .start('cubicOut');
 */ var $d83d3d8d08e5712f$var$AnimationWrap = /** @class */ function() {
    function AnimationWrap() {
        this._storage = [];
        this._elExistsMap = {};
    }
    /**
   * Caution: a el can only be added once, otherwise 'done'
   * might not be called. This method checks this (by el.id),
   * suppresses adding and returns false when existing el found.
   *
   * @return Whether adding succeeded.
   */ AnimationWrap.prototype.add = function(el, target, duration, delay, easing) {
        if (this._elExistsMap[el.id]) return false;
        this._elExistsMap[el.id] = true;
        this._storage.push({
            el: el,
            target: target,
            duration: duration,
            delay: delay,
            easing: easing
        });
        return true;
    };
    /**
   * Only execute when animation done/aborted.
   */ AnimationWrap.prototype.finished = function(callback) {
        this._finishedCallback = callback;
        return this;
    };
    /**
   * Will stop exist animation firstly.
   */ AnimationWrap.prototype.start = function() {
        var _this = this;
        var count = this._storage.length;
        var checkTerminate = function() {
            count--;
            if (count <= 0) {
                // Guard.
                _this._storage.length = 0;
                _this._elExistsMap = {};
                _this._finishedCallback && _this._finishedCallback();
            }
        };
        for(var i = 0, len = this._storage.length; i < len; i++){
            var item = this._storage[i];
            item.el.animateTo(item.target, {
                duration: item.duration,
                delay: item.delay,
                easing: item.easing,
                setToFinal: true,
                done: checkTerminate,
                aborted: checkTerminate
            });
        }
        return this;
    };
    return AnimationWrap;
}();
function $d83d3d8d08e5712f$export$944643101ee10c7() {
    return new $d83d3d8d08e5712f$var$AnimationWrap();
}








var $ca67abe413e4c090$var$Group = $7ef7583d8302ffce$export$2e2bcd8739ae039;
var $ca67abe413e4c090$var$Rect = $419e5ff2f303755e$export$2e2bcd8739ae039;
var $ca67abe413e4c090$var$DRAG_THRESHOLD = 3;
var $ca67abe413e4c090$var$PATH_LABEL_NOAMAL = 'label';
var $ca67abe413e4c090$var$PATH_UPPERLABEL_NORMAL = 'upperLabel';
// Should larger than emphasis states lift z
var $ca67abe413e4c090$var$Z2_BASE = (0, $2bf82c0980125b62$export$1cb9fc6ed5b9836c) * 10; // Should bigger than every z2.
var $ca67abe413e4c090$var$Z2_BG = (0, $2bf82c0980125b62$export$1cb9fc6ed5b9836c) * 2;
var $ca67abe413e4c090$var$Z2_CONTENT = (0, $2bf82c0980125b62$export$1cb9fc6ed5b9836c) * 3;
var $ca67abe413e4c090$var$getStateItemStyle = (0, $06542048a26d4d91$export$2e2bcd8739ae039)([
    [
        'fill',
        'color'
    ],
    // `borderColor` and `borderWidth` has been occupied,
    // so use `stroke` to indicate the stroke of the rect.
    [
        'stroke',
        'strokeColor'
    ],
    [
        'lineWidth',
        'strokeWidth'
    ],
    [
        'shadowBlur'
    ],
    [
        'shadowOffsetX'
    ],
    [
        'shadowOffsetY'
    ],
    [
        'shadowColor'
    ]
]);
var $ca67abe413e4c090$var$getItemStyleNormal = function(model) {
    // Normal style props should include emphasis style props.
    var itemStyle = $ca67abe413e4c090$var$getStateItemStyle(model);
    // Clear styles set by emphasis.
    itemStyle.stroke = itemStyle.fill = itemStyle.lineWidth = null;
    return itemStyle;
};
var $ca67abe413e4c090$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $ca67abe413e4c090$var$TreemapView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(TreemapView, _super);
    function TreemapView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TreemapView.type;
        _this._state = 'ready';
        _this._storage = $ca67abe413e4c090$var$createStorage();
        return _this;
    }
    /**
   * @override
   */ TreemapView.prototype.render = function(seriesModel, ecModel, api, payload) {
        var models = ecModel.findComponents({
            mainType: 'series',
            subType: 'treemap',
            query: payload
        });
        if ((0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(models, seriesModel) < 0) return;
        this.seriesModel = seriesModel;
        this.api = api;
        this.ecModel = ecModel;
        var types = [
            'treemapZoomToNode',
            'treemapRootToNode'
        ];
        var targetInfo = $6341f66602946a06$export$c5445fa59c15dec4(payload, types, seriesModel);
        var payloadType = payload && payload.type;
        var layoutInfo = seriesModel.layoutInfo;
        var isInit = !this._oldTree;
        var thisStorage = this._storage;
        // Mark new root when action is treemapRootToNode.
        var reRoot = payloadType === 'treemapRootToNode' && targetInfo && thisStorage ? {
            rootNodeGroup: thisStorage.nodeGroup[targetInfo.node.getRawIndex()],
            direction: payload.direction
        } : null;
        var containerGroup = this._giveContainerGroup(layoutInfo);
        var hasAnimation = seriesModel.get('animation');
        var renderResult = this._doRender(containerGroup, seriesModel, reRoot);
        hasAnimation && !isInit && (!payloadType || payloadType === 'treemapZoomToNode' || payloadType === 'treemapRootToNode') ? this._doAnimation(containerGroup, renderResult, seriesModel, reRoot) : renderResult.renderFinally();
        this._resetController(api);
        this._renderBreadcrumb(seriesModel, api, targetInfo);
    };
    TreemapView.prototype._giveContainerGroup = function(layoutInfo) {
        var containerGroup = this._containerGroup;
        if (!containerGroup) {
            // FIXME
            // 加一层containerGroup是为了clip，但是现在clip功能并没有实现。
            containerGroup = this._containerGroup = new $ca67abe413e4c090$var$Group();
            this._initEvents(containerGroup);
            this.group.add(containerGroup);
        }
        containerGroup.x = layoutInfo.x;
        containerGroup.y = layoutInfo.y;
        return containerGroup;
    };
    TreemapView.prototype._doRender = function(containerGroup, seriesModel, reRoot) {
        var thisTree = seriesModel.getData().tree;
        var oldTree = this._oldTree;
        // Clear last shape records.
        var lastsForAnimation = $ca67abe413e4c090$var$createStorage();
        var thisStorage = $ca67abe413e4c090$var$createStorage();
        var oldStorage = this._storage;
        var willInvisibleEls = [];
        function doRenderNode(thisNode, oldNode, parentGroup, depth) {
            return $ca67abe413e4c090$var$renderNode(seriesModel, thisStorage, oldStorage, reRoot, lastsForAnimation, willInvisibleEls, thisNode, oldNode, parentGroup, depth);
        }
        // Notice: When thisTree and oldTree are the same tree (see list.cloneShallow),
        // the oldTree is actually losted, so we cannot find all of the old graphic
        // elements from tree. So we use this strategy: make element storage, move
        // from old storage to new storage, clear old storage.
        dualTravel(thisTree.root ? [
            thisTree.root
        ] : [], oldTree && oldTree.root ? [
            oldTree.root
        ] : [], containerGroup, thisTree === oldTree || !oldTree, 0);
        // Process all removing.
        var willDeleteEls = clearStorage(oldStorage);
        this._oldTree = thisTree;
        this._storage = thisStorage;
        if (this._controllerHost) {
            var _oldRootLayout = this.seriesModel.layoutInfo;
            var rootLayout = thisTree.root.getLayout();
            if (rootLayout.width === _oldRootLayout.width && rootLayout.height === _oldRootLayout.height) this._controllerHost.zoom = 1;
        }
        return {
            lastsForAnimation: lastsForAnimation,
            willDeleteEls: willDeleteEls,
            renderFinally: renderFinally
        };
        function dualTravel(thisViewChildren, oldViewChildren, parentGroup, sameTree, depth) {
            // When 'render' is triggered by action,
            // 'this' and 'old' may be the same tree,
            // we use rawIndex in that case.
            if (sameTree) {
                oldViewChildren = thisViewChildren;
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(thisViewChildren, function(child, index) {
                    !child.isRemoved() && processNode(index, index);
                });
            } else new (0, $306d1c87baff8a10$export$2e2bcd8739ae039)(oldViewChildren, thisViewChildren, getKey, getKey).add(processNode).update(processNode).remove((0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)(processNode, null)).execute();
            function getKey(node) {
                // Identify by name or raw index.
                return node.getId();
            }
            function processNode(newIndex, oldIndex) {
                var thisNode = newIndex != null ? thisViewChildren[newIndex] : null;
                var oldNode = oldIndex != null ? oldViewChildren[oldIndex] : null;
                var group = doRenderNode(thisNode, oldNode, parentGroup, depth);
                group && dualTravel(thisNode && thisNode.viewChildren || [], oldNode && oldNode.viewChildren || [], group, sameTree, depth + 1);
            }
        }
        function clearStorage(storage) {
            var willDeleteEls = $ca67abe413e4c090$var$createStorage();
            storage && (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(storage, function(store, storageName) {
                var delEls = willDeleteEls[storageName];
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(store, function(el) {
                    el && (delEls.push(el), $ca67abe413e4c090$var$inner(el).willDelete = true);
                });
            });
            return willDeleteEls;
        }
        function renderFinally() {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(willDeleteEls, function(els) {
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(els, function(el) {
                    el.parent && el.parent.remove(el);
                });
            });
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(willInvisibleEls, function(el) {
                el.invisible = true;
                // Setting invisible is for optimizing, so no need to set dirty,
                // just mark as invisible.
                el.dirty();
            });
        }
    };
    TreemapView.prototype._doAnimation = function(containerGroup, renderResult, seriesModel, reRoot) {
        var durationOption = seriesModel.get('animationDurationUpdate');
        var easingOption = seriesModel.get('animationEasing');
        // TODO: do not support function until necessary.
        var duration = ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(durationOption) ? 0 : durationOption) || 0;
        var easing = ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(easingOption) ? null : easingOption) || 'cubicOut';
        var animationWrap = $d83d3d8d08e5712f$export$944643101ee10c7();
        // Make delete animations.
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(renderResult.willDeleteEls, function(store, storageName) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(store, function(el, rawIndex) {
                if (el.invisible) return;
                var parent = el.parent; // Always has parent, and parent is nodeGroup.
                var target;
                var innerStore = $ca67abe413e4c090$var$inner(parent);
                if (reRoot && reRoot.direction === 'drillDown') target = parent === reRoot.rootNodeGroup ? {
                    shape: {
                        x: 0,
                        y: 0,
                        width: innerStore.nodeWidth,
                        height: innerStore.nodeHeight
                    },
                    style: {
                        opacity: 0
                    }
                } : {
                    style: {
                        opacity: 0
                    }
                };
                else {
                    var targetX = 0;
                    var targetY = 0;
                    if (!innerStore.willDelete) {
                        // Let node animate to right-bottom corner, cooperating with fadeout,
                        // which is appropriate for user understanding.
                        // Divided by 2 for reRoot rolling up effect.
                        targetX = innerStore.nodeWidth / 2;
                        targetY = innerStore.nodeHeight / 2;
                    }
                    target = storageName === 'nodeGroup' ? {
                        x: targetX,
                        y: targetY,
                        style: {
                            opacity: 0
                        }
                    } : {
                        shape: {
                            x: targetX,
                            y: targetY,
                            width: 0,
                            height: 0
                        },
                        style: {
                            opacity: 0
                        }
                    };
                }
                // TODO: do not support delay until necessary.
                target && animationWrap.add(el, target, duration, 0, easing);
            });
        });
        // Make other animations
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._storage, function(store, storageName) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(store, function(el, rawIndex) {
                var last = renderResult.lastsForAnimation[storageName][rawIndex];
                var target = {};
                if (!last) return;
                if (el instanceof $7ef7583d8302ffce$export$2e2bcd8739ae039) {
                    if (last.oldX != null) {
                        target.x = el.x;
                        target.y = el.y;
                        el.x = last.oldX;
                        el.y = last.oldY;
                    }
                } else {
                    if (last.oldShape) {
                        target.shape = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, el.shape);
                        el.setShape(last.oldShape);
                    }
                    if (last.fadein) {
                        el.setStyle('opacity', 0);
                        target.style = {
                            opacity: 1
                        };
                    } else if (el.style.opacity !== 1) target.style = {
                        opacity: 1
                    };
                }
                animationWrap.add(el, target, duration, 0, easing);
            });
        }, this);
        this._state = 'animating';
        animationWrap.finished((0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(function() {
            this._state = 'ready';
            renderResult.renderFinally();
        }, this)).start();
    };
    TreemapView.prototype._resetController = function(api) {
        var controller = this._controller;
        var controllerHost = this._controllerHost;
        if (!controllerHost) {
            this._controllerHost = {
                target: this.group
            };
            controllerHost = this._controllerHost;
        }
        // Init controller.
        if (!controller) {
            controller = this._controller = new (0, $15927f329deeab51$export$2e2bcd8739ae039)(api.getZr());
            controller.enable(this.seriesModel.get('roam'));
            controllerHost.zoomLimit = this.seriesModel.get('scaleLimit');
            controllerHost.zoom = this.seriesModel.get('zoom');
            controller.on('pan', (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._onPan, this));
            controller.on('zoom', (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._onZoom, this));
        }
        var rect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, api.getWidth(), api.getHeight());
        controller.setPointerChecker(function(e, x, y) {
            return rect.contain(x, y);
        });
    };
    TreemapView.prototype._clearController = function() {
        var controller = this._controller;
        this._controllerHost = null;
        if (controller) {
            controller.dispose();
            controller = null;
        }
    };
    TreemapView.prototype._onPan = function(e) {
        if (this._state !== 'animating' && (Math.abs(e.dx) > $ca67abe413e4c090$var$DRAG_THRESHOLD || Math.abs(e.dy) > $ca67abe413e4c090$var$DRAG_THRESHOLD)) {
            // These param must not be cached.
            var root = this.seriesModel.getData().tree.root;
            if (!root) return;
            var rootLayout = root.getLayout();
            if (!rootLayout) return;
            this.api.dispatchAction({
                type: 'treemapMove',
                from: this.uid,
                seriesId: this.seriesModel.id,
                rootRect: {
                    x: rootLayout.x + e.dx,
                    y: rootLayout.y + e.dy,
                    width: rootLayout.width,
                    height: rootLayout.height
                }
            });
        }
    };
    TreemapView.prototype._onZoom = function(e) {
        var mouseX = e.originX;
        var mouseY = e.originY;
        var zoomDelta = e.scale;
        if (this._state !== 'animating') {
            // These param must not be cached.
            var root = this.seriesModel.getData().tree.root;
            if (!root) return;
            var rootLayout = root.getLayout();
            if (!rootLayout) return;
            var rect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(rootLayout.x, rootLayout.y, rootLayout.width, rootLayout.height);
            // scaleLimit
            var zoomLimit = null;
            var _controllerHost = this._controllerHost;
            zoomLimit = _controllerHost.zoomLimit;
            var newZoom = _controllerHost.zoom = _controllerHost.zoom || 1;
            newZoom *= zoomDelta;
            if (zoomLimit) {
                var zoomMin = zoomLimit.min || 0;
                var zoomMax = zoomLimit.max || Infinity;
                newZoom = Math.max(Math.min(zoomMax, newZoom), zoomMin);
            }
            var zoomScale = newZoom / _controllerHost.zoom;
            _controllerHost.zoom = newZoom;
            var layoutInfo = this.seriesModel.layoutInfo;
            // Transform mouse coord from global to containerGroup.
            mouseX -= layoutInfo.x;
            mouseY -= layoutInfo.y;
            // Scale root bounding rect.
            var m = $f41ebb9dd60b55b4$export$185802fd694ee1f5();
            $f41ebb9dd60b55b4$export$d73ee8ef04f5226a(m, m, [
                -mouseX,
                -mouseY
            ]);
            $f41ebb9dd60b55b4$export$dcdf75081b88279d(m, m, [
                zoomScale,
                zoomScale
            ]);
            $f41ebb9dd60b55b4$export$d73ee8ef04f5226a(m, m, [
                mouseX,
                mouseY
            ]);
            rect.applyTransform(m);
            this.api.dispatchAction({
                type: 'treemapRender',
                from: this.uid,
                seriesId: this.seriesModel.id,
                rootRect: {
                    x: rect.x,
                    y: rect.y,
                    width: rect.width,
                    height: rect.height
                }
            });
        }
    };
    TreemapView.prototype._initEvents = function(containerGroup) {
        var _this = this;
        containerGroup.on('click', function(e) {
            if (_this._state !== 'ready') return;
            var nodeClick = _this.seriesModel.get('nodeClick', true);
            if (!nodeClick) return;
            var targetInfo = _this.findTarget(e.offsetX, e.offsetY);
            if (!targetInfo) return;
            var node = targetInfo.node;
            if (node.getLayout().isLeafRoot) _this._rootToNode(targetInfo);
            else {
                if (nodeClick === 'zoomToNode') _this._zoomToNode(targetInfo);
                else if (nodeClick === 'link') {
                    var itemModel = node.hostTree.data.getItemModel(node.dataIndex);
                    var link = itemModel.get('link', true);
                    var linkTarget = itemModel.get('target', true) || 'blank';
                    link && (0, $c84c9521536c601a$export$13e13f9b96dbe8fa)(link, linkTarget);
                }
            }
        }, this);
    };
    TreemapView.prototype._renderBreadcrumb = function(seriesModel, api, targetInfo) {
        var _this = this;
        if (!targetInfo) {
            targetInfo = seriesModel.get('leafDepth', true) != null ? {
                node: seriesModel.getViewRoot()
            } : this.findTarget(api.getWidth() / 2, api.getHeight() / 2);
            if (!targetInfo) targetInfo = {
                node: seriesModel.getData().tree.root
            };
        }
        (this._breadcrumb || (this._breadcrumb = new (0, $504a89857fe7780b$export$2e2bcd8739ae039)(this.group))).render(seriesModel, api, targetInfo.node, function(node) {
            if (_this._state !== 'animating') $6341f66602946a06$export$df59de26c77b5bea(seriesModel.getViewRoot(), node) ? _this._rootToNode({
                node: node
            }) : _this._zoomToNode({
                node: node
            });
        });
    };
    /**
   * @override
   */ TreemapView.prototype.remove = function() {
        this._clearController();
        this._containerGroup && this._containerGroup.removeAll();
        this._storage = $ca67abe413e4c090$var$createStorage();
        this._state = 'ready';
        this._breadcrumb && this._breadcrumb.remove();
    };
    TreemapView.prototype.dispose = function() {
        this._clearController();
    };
    TreemapView.prototype._zoomToNode = function(targetInfo) {
        this.api.dispatchAction({
            type: 'treemapZoomToNode',
            from: this.uid,
            seriesId: this.seriesModel.id,
            targetNode: targetInfo.node
        });
    };
    TreemapView.prototype._rootToNode = function(targetInfo) {
        this.api.dispatchAction({
            type: 'treemapRootToNode',
            from: this.uid,
            seriesId: this.seriesModel.id,
            targetNode: targetInfo.node
        });
    };
    /**
   * @public
   * @param {number} x Global coord x.
   * @param {number} y Global coord y.
   * @return {Object} info If not found, return undefined;
   * @return {number} info.node Target node.
   * @return {number} info.offsetX x refer to target node.
   * @return {number} info.offsetY y refer to target node.
   */ TreemapView.prototype.findTarget = function(x, y) {
        var targetInfo;
        var viewRoot = this.seriesModel.getViewRoot();
        viewRoot.eachNode({
            attr: 'viewChildren',
            order: 'preorder'
        }, function(node) {
            var bgEl = this._storage.background[node.getRawIndex()];
            // If invisible, there might be no element.
            if (bgEl) {
                var point = bgEl.transformCoordToLocal(x, y);
                var shape = bgEl.shape;
                // For performance consideration, don't use 'getBoundingRect'.
                if (shape.x <= point[0] && point[0] <= shape.x + shape.width && shape.y <= point[1] && point[1] <= shape.y + shape.height) targetInfo = {
                    node: node,
                    offsetX: point[0],
                    offsetY: point[1]
                };
                else return false; // Suppress visit subtree.
            }
        }, this);
        return targetInfo;
    };
    TreemapView.type = 'treemap';
    return TreemapView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
/**
 * @inner
 */ function $ca67abe413e4c090$var$createStorage() {
    return {
        nodeGroup: [],
        background: [],
        content: []
    };
}
/**
 * @inner
 * @return Return undefined means do not travel further.
 */ function $ca67abe413e4c090$var$renderNode(seriesModel, thisStorage, oldStorage, reRoot, lastsForAnimation, willInvisibleEls, thisNode, oldNode, parentGroup, depth) {
    // Whether under viewRoot.
    if (!thisNode) // Deleting nodes will be performed finally. This method just find
    // element from old storage, or create new element, set them to new
    // storage, and set styles.
    return;
    // -------------------------------------------------------------------
    // Start of closure variables available in "Procedures in renderNode".
    var thisLayout = thisNode.getLayout();
    var data = seriesModel.getData();
    var nodeModel = thisNode.getModel();
    // Only for enabling highlight/downplay. Clear firstly.
    // Because some node will not be rendered.
    data.setItemGraphicEl(thisNode.dataIndex, null);
    if (!thisLayout || !thisLayout.isInView) return;
    var thisWidth = thisLayout.width;
    var thisHeight = thisLayout.height;
    var borderWidth = thisLayout.borderWidth;
    var thisInvisible = thisLayout.invisible;
    var thisRawIndex = thisNode.getRawIndex();
    var oldRawIndex = oldNode && oldNode.getRawIndex();
    var thisViewChildren = thisNode.viewChildren;
    var upperHeight = thisLayout.upperHeight;
    var isParent = thisViewChildren && thisViewChildren.length;
    var itemStyleNormalModel = nodeModel.getModel('itemStyle');
    var itemStyleEmphasisModel = nodeModel.getModel([
        'emphasis',
        'itemStyle'
    ]);
    var itemStyleBlurModel = nodeModel.getModel([
        'blur',
        'itemStyle'
    ]);
    var itemStyleSelectModel = nodeModel.getModel([
        'select',
        'itemStyle'
    ]);
    var borderRadius = itemStyleNormalModel.get('borderRadius') || 0;
    // End of closure ariables available in "Procedures in renderNode".
    // -----------------------------------------------------------------
    // Node group
    var group = giveGraphic('nodeGroup', $ca67abe413e4c090$var$Group);
    if (!group) return;
    parentGroup.add(group);
    // x,y are not set when el is above view root.
    group.x = thisLayout.x || 0;
    group.y = thisLayout.y || 0;
    group.markRedraw();
    $ca67abe413e4c090$var$inner(group).nodeWidth = thisWidth;
    $ca67abe413e4c090$var$inner(group).nodeHeight = thisHeight;
    if (thisLayout.isAboveViewRoot) return group;
    // Background
    var bg = giveGraphic('background', $ca67abe413e4c090$var$Rect, depth, $ca67abe413e4c090$var$Z2_BG);
    bg && renderBackground(group, bg, isParent && thisLayout.upperLabelHeight);
    var emphasisModel = nodeModel.getModel('emphasis');
    var focus = emphasisModel.get('focus');
    var blurScope = emphasisModel.get('blurScope');
    var isDisabled = emphasisModel.get('disabled');
    var focusOrIndices = focus === 'ancestor' ? thisNode.getAncestorsIndices() : focus === 'descendant' ? thisNode.getDescendantIndices() : focus;
    // No children, render content.
    if (isParent) {
        // Because of the implementation about "traverse" in graphic hover style, we
        // can not set hover listener on the "group" of non-leaf node. Otherwise the
        // hover event from the descendents will be listenered.
        if ((0, $2bf82c0980125b62$export$77d1445f699c58b5)(group)) (0, $2bf82c0980125b62$export$9ba15aea1e048d48)(group, false);
        if (bg) {
            (0, $2bf82c0980125b62$export$9ba15aea1e048d48)(bg, !isDisabled);
            // Only for enabling highlight/downplay.
            data.setItemGraphicEl(thisNode.dataIndex, bg);
            (0, $2bf82c0980125b62$export$24972466b2b62ac2)(bg, focusOrIndices, blurScope);
        }
    } else {
        var content = giveGraphic('content', $ca67abe413e4c090$var$Rect, depth, $ca67abe413e4c090$var$Z2_CONTENT);
        content && renderContent(group, content);
        bg.disableMorphing = true;
        if (bg && (0, $2bf82c0980125b62$export$77d1445f699c58b5)(bg)) (0, $2bf82c0980125b62$export$9ba15aea1e048d48)(bg, false);
        (0, $2bf82c0980125b62$export$9ba15aea1e048d48)(group, !isDisabled);
        // Only for enabling highlight/downplay.
        data.setItemGraphicEl(thisNode.dataIndex, group);
        var cursorStyle = nodeModel.getShallow('cursor');
        cursorStyle && content.attr('cursor', cursorStyle);
        (0, $2bf82c0980125b62$export$24972466b2b62ac2)(group, focusOrIndices, blurScope);
    }
    return group;
    // ----------------------------
    // | Procedures in renderNode |
    // ----------------------------
    function renderBackground(group, bg, useUpperLabel) {
        var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(bg);
        // For tooltip.
        ecData.dataIndex = thisNode.dataIndex;
        ecData.seriesIndex = seriesModel.seriesIndex;
        bg.setShape({
            x: 0,
            y: 0,
            width: thisWidth,
            height: thisHeight,
            r: borderRadius
        });
        if (thisInvisible) // If invisible, do not set visual, otherwise the element will
        // change immediately before animation. We think it is OK to
        // remain its origin color when moving out of the view window.
        processInvisible(bg);
        else {
            bg.invisible = false;
            var style = thisNode.getVisual('style');
            var visualBorderColor = style.stroke;
            var normalStyle = $ca67abe413e4c090$var$getItemStyleNormal(itemStyleNormalModel);
            normalStyle.fill = visualBorderColor;
            var emphasisStyle = $ca67abe413e4c090$var$getStateItemStyle(itemStyleEmphasisModel);
            emphasisStyle.fill = itemStyleEmphasisModel.get('borderColor');
            var blurStyle = $ca67abe413e4c090$var$getStateItemStyle(itemStyleBlurModel);
            blurStyle.fill = itemStyleBlurModel.get('borderColor');
            var selectStyle = $ca67abe413e4c090$var$getStateItemStyle(itemStyleSelectModel);
            selectStyle.fill = itemStyleSelectModel.get('borderColor');
            if (useUpperLabel) {
                var upperLabelWidth = thisWidth - 2 * borderWidth;
                prepareText(// PENDING: convert ZRColor to ColorString for text.
                bg, visualBorderColor, style.opacity, {
                    x: borderWidth,
                    y: 0,
                    width: upperLabelWidth,
                    height: upperHeight
                });
            } else bg.removeTextContent();
            bg.setStyle(normalStyle);
            bg.ensureState('emphasis').style = emphasisStyle;
            bg.ensureState('blur').style = blurStyle;
            bg.ensureState('select').style = selectStyle;
            (0, $2bf82c0980125b62$export$20f39bbe322fb9ab)(bg);
        }
        group.add(bg);
    }
    function renderContent(group, content) {
        var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(content);
        // For tooltip.
        ecData.dataIndex = thisNode.dataIndex;
        ecData.seriesIndex = seriesModel.seriesIndex;
        var contentWidth = Math.max(thisWidth - 2 * borderWidth, 0);
        var contentHeight = Math.max(thisHeight - 2 * borderWidth, 0);
        content.culling = true;
        content.setShape({
            x: borderWidth,
            y: borderWidth,
            width: contentWidth,
            height: contentHeight,
            r: borderRadius
        });
        if (thisInvisible) // If invisible, do not set visual, otherwise the element will
        // change immediately before animation. We think it is OK to
        // remain its origin color when moving out of the view window.
        processInvisible(content);
        else {
            content.invisible = false;
            var nodeStyle = thisNode.getVisual('style');
            var visualColor = nodeStyle.fill;
            var normalStyle = $ca67abe413e4c090$var$getItemStyleNormal(itemStyleNormalModel);
            normalStyle.fill = visualColor;
            normalStyle.decal = nodeStyle.decal;
            var emphasisStyle = $ca67abe413e4c090$var$getStateItemStyle(itemStyleEmphasisModel);
            var blurStyle = $ca67abe413e4c090$var$getStateItemStyle(itemStyleBlurModel);
            var selectStyle = $ca67abe413e4c090$var$getStateItemStyle(itemStyleSelectModel);
            // PENDING: convert ZRColor to ColorString for text.
            prepareText(content, visualColor, nodeStyle.opacity, null);
            content.setStyle(normalStyle);
            content.ensureState('emphasis').style = emphasisStyle;
            content.ensureState('blur').style = blurStyle;
            content.ensureState('select').style = selectStyle;
            (0, $2bf82c0980125b62$export$20f39bbe322fb9ab)(content);
        }
        group.add(content);
    }
    function processInvisible(element) {
        // Delay invisible setting utill animation finished,
        // avoid element vanish suddenly before animation.
        !element.invisible && willInvisibleEls.push(element);
    }
    function prepareText(rectEl, visualColor, visualOpacity, // Can be null/undefined
    upperLabelRect) {
        var normalLabelModel = nodeModel.getModel(upperLabelRect ? $ca67abe413e4c090$var$PATH_UPPERLABEL_NORMAL : $ca67abe413e4c090$var$PATH_LABEL_NOAMAL);
        var defaultText = (0, $76d619f648247e6d$export$fb1a222ba5dd6e51)(nodeModel.get('name'), null);
        var isShow = normalLabelModel.getShallow('show');
        (0, $6800dfcb6e1e2a44$export$9a13992917966657)(rectEl, (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(nodeModel, upperLabelRect ? $ca67abe413e4c090$var$PATH_UPPERLABEL_NORMAL : $ca67abe413e4c090$var$PATH_LABEL_NOAMAL), {
            defaultText: isShow ? defaultText : null,
            inheritColor: visualColor,
            defaultOpacity: visualOpacity,
            labelFetcher: seriesModel,
            labelDataIndex: thisNode.dataIndex
        });
        var textEl = rectEl.getTextContent();
        if (!textEl) return;
        var textStyle = textEl.style;
        var textPadding = (0, $7a1bd9c2710fea0d$export$f3a38102c49f4268)(textStyle.padding || 0);
        if (upperLabelRect) {
            rectEl.setTextConfig({
                layoutRect: upperLabelRect
            });
            textEl.disableLabelLayout = true;
        }
        textEl.beforeUpdate = function() {
            var width = Math.max((upperLabelRect ? upperLabelRect.width : rectEl.shape.width) - textPadding[1] - textPadding[3], 0);
            var height = Math.max((upperLabelRect ? upperLabelRect.height : rectEl.shape.height) - textPadding[0] - textPadding[2], 0);
            if (textStyle.width !== width || textStyle.height !== height) textEl.setStyle({
                width: width,
                height: height
            });
        };
        textStyle.truncateMinChar = 2;
        textStyle.lineOverflow = 'truncate';
        addDrillDownIcon(textStyle, upperLabelRect, thisLayout);
        var textEmphasisState = textEl.getState('emphasis');
        addDrillDownIcon(textEmphasisState ? textEmphasisState.style : null, upperLabelRect, thisLayout);
    }
    function addDrillDownIcon(style, upperLabelRect, thisLayout) {
        var text = style ? style.text : null;
        if (!upperLabelRect && thisLayout.isLeafRoot && text != null) {
            var iconChar = seriesModel.get('drillDownIcon', true);
            style.text = iconChar ? iconChar + ' ' + text : text;
        }
    }
    function giveGraphic(storageName, Ctor, depth, z) {
        var element = oldRawIndex != null && oldStorage[storageName][oldRawIndex];
        var lasts = lastsForAnimation[storageName];
        if (element) {
            // Remove from oldStorage
            oldStorage[storageName][oldRawIndex] = null;
            prepareAnimationWhenHasOld(lasts, element);
        } else if (!thisInvisible) {
            element = new Ctor();
            if (element instanceof (0, $56206a6cb4666931$export$2e2bcd8739ae039)) element.z2 = $ca67abe413e4c090$var$calculateZ2(depth, z);
            prepareAnimationWhenNoOld(lasts, element);
        }
        // Set to thisStorage
        return thisStorage[storageName][thisRawIndex] = element;
    }
    function prepareAnimationWhenHasOld(lasts, element) {
        var lastCfg = lasts[thisRawIndex] = {};
        if (element instanceof $ca67abe413e4c090$var$Group) {
            lastCfg.oldX = element.x;
            lastCfg.oldY = element.y;
        } else lastCfg.oldShape = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, element.shape);
    }
    // If a element is new, we need to find the animation start point carefully,
    // otherwise it will looks strange when 'zoomToNode'.
    function prepareAnimationWhenNoOld(lasts, element) {
        var lastCfg = lasts[thisRawIndex] = {};
        var parentNode = thisNode.parentNode;
        var isGroup = element instanceof $7ef7583d8302ffce$export$2e2bcd8739ae039;
        if (parentNode && (!reRoot || reRoot.direction === 'drillDown')) {
            var parentOldX = 0;
            var parentOldY = 0;
            // New nodes appear from right-bottom corner in 'zoomToNode' animation.
            // For convenience, get old bounding rect from background.
            var parentOldBg = lastsForAnimation.background[parentNode.getRawIndex()];
            if (!reRoot && parentOldBg && parentOldBg.oldShape) {
                parentOldX = parentOldBg.oldShape.width;
                parentOldY = parentOldBg.oldShape.height;
            }
            // When no parent old shape found, its parent is new too,
            // so we can just use {x:0, y:0}.
            if (isGroup) {
                lastCfg.oldX = 0;
                lastCfg.oldY = parentOldY;
            } else lastCfg.oldShape = {
                x: parentOldX,
                y: parentOldY,
                width: 0,
                height: 0
            };
        }
        // Fade in, user can be aware that these nodes are new.
        lastCfg.fadein = !isGroup;
    }
}
// We cannot set all background with the same z, because the behaviour of
// drill down and roll up differ background creation sequence from tree
// hierarchy sequence, which cause lower background elements to overlap
// upper ones. So we calculate z based on depth.
// Moreover, we try to shrink down z interval to [0, 1] to avoid that
// treemap with large z overlaps other components.
function $ca67abe413e4c090$var$calculateZ2(depth, z2InLevel) {
    return depth * $ca67abe413e4c090$var$Z2_BASE + z2InLevel;
}
var $ca67abe413e4c090$export$2e2bcd8739ae039 = $ca67abe413e4c090$var$TreemapView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $e6cba72659c474bb$var$ITEM_STYLE_NORMAL = 'itemStyle';
var $e6cba72659c474bb$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $e6cba72659c474bb$export$2e2bcd8739ae039 = {
    seriesType: 'treemap',
    reset: function(seriesModel) {
        var tree = seriesModel.getData().tree;
        var root = tree.root;
        if (root.isRemoved()) return;
        $e6cba72659c474bb$var$travelTree(root, // Visual should calculate from tree root but not view root.
        {}, seriesModel.getViewRoot().getAncestors(), seriesModel);
    }
};
function $e6cba72659c474bb$var$travelTree(node, designatedVisual, viewRootAncestors, seriesModel) {
    var nodeModel = node.getModel();
    var nodeLayout = node.getLayout();
    var data = node.hostTree.data;
    // Optimize
    if (!nodeLayout || nodeLayout.invisible || !nodeLayout.isInView) return;
    var nodeItemStyleModel = nodeModel.getModel($e6cba72659c474bb$var$ITEM_STYLE_NORMAL);
    var visuals = $e6cba72659c474bb$var$buildVisuals(nodeItemStyleModel, designatedVisual, seriesModel);
    var existsStyle = data.ensureUniqueItemVisual(node.dataIndex, 'style');
    // calculate border color
    var borderColor = nodeItemStyleModel.get('borderColor');
    var borderColorSaturation = nodeItemStyleModel.get('borderColorSaturation');
    var thisNodeColor;
    if (borderColorSaturation != null) {
        // For performance, do not always execute 'calculateColor'.
        thisNodeColor = $e6cba72659c474bb$var$calculateColor(visuals);
        borderColor = $e6cba72659c474bb$var$calculateBorderColor(borderColorSaturation, thisNodeColor);
    }
    existsStyle.stroke = borderColor;
    var viewChildren = node.viewChildren;
    if (!viewChildren || !viewChildren.length) {
        thisNodeColor = $e6cba72659c474bb$var$calculateColor(visuals);
        // Apply visual to this node.
        existsStyle.fill = thisNodeColor;
    } else {
        var mapping_1 = $e6cba72659c474bb$var$buildVisualMapping(node, nodeModel, nodeLayout, nodeItemStyleModel, visuals, viewChildren);
        // Designate visual to children.
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(viewChildren, function(child, index) {
            // If higher than viewRoot, only ancestors of viewRoot is needed to visit.
            if (child.depth >= viewRootAncestors.length || child === viewRootAncestors[child.depth]) {
                var childVisual = $e6cba72659c474bb$var$mapVisual(nodeModel, visuals, child, index, mapping_1, seriesModel);
                $e6cba72659c474bb$var$travelTree(child, childVisual, viewRootAncestors, seriesModel);
            }
        });
    }
}
function $e6cba72659c474bb$var$buildVisuals(nodeItemStyleModel, designatedVisual, seriesModel) {
    var visuals = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, designatedVisual);
    var designatedVisualItemStyle = seriesModel.designatedVisualItemStyle;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
        'color',
        'colorAlpha',
        'colorSaturation'
    ], function(visualName) {
        // Priority: thisNode > thisLevel > parentNodeDesignated > seriesModel
        designatedVisualItemStyle[visualName] = designatedVisual[visualName];
        var val = nodeItemStyleModel.get(visualName);
        designatedVisualItemStyle[visualName] = null;
        val != null && (visuals[visualName] = val);
    });
    return visuals;
}
function $e6cba72659c474bb$var$calculateColor(visuals) {
    var color = $e6cba72659c474bb$var$getValueVisualDefine(visuals, 'color');
    if (color) {
        var colorAlpha = $e6cba72659c474bb$var$getValueVisualDefine(visuals, 'colorAlpha');
        var colorSaturation = $e6cba72659c474bb$var$getValueVisualDefine(visuals, 'colorSaturation');
        if (colorSaturation) color = (0, $2c037f5bda6341ca$export$d898ae866e27bf18)(color, null, null, colorSaturation);
        if (colorAlpha) color = (0, $2c037f5bda6341ca$export$ab4754bf42583a26)(color, colorAlpha);
        return color;
    }
}
function $e6cba72659c474bb$var$calculateBorderColor(borderColorSaturation, thisNodeColor) {
    return thisNodeColor != null ? (0, $2c037f5bda6341ca$export$d898ae866e27bf18)(thisNodeColor, null, null, borderColorSaturation) : null;
}
function $e6cba72659c474bb$var$getValueVisualDefine(visuals, name) {
    var value = visuals[name];
    if (value != null && value !== 'none') return value;
}
function $e6cba72659c474bb$var$buildVisualMapping(node, nodeModel, nodeLayout, nodeItemStyleModel, visuals, viewChildren) {
    if (!viewChildren || !viewChildren.length) return;
    var rangeVisual = $e6cba72659c474bb$var$getRangeVisual(nodeModel, 'color') || visuals.color != null && visuals.color !== 'none' && ($e6cba72659c474bb$var$getRangeVisual(nodeModel, 'colorAlpha') || $e6cba72659c474bb$var$getRangeVisual(nodeModel, 'colorSaturation'));
    if (!rangeVisual) return;
    var visualMin = nodeModel.get('visualMin');
    var visualMax = nodeModel.get('visualMax');
    var dataExtent = nodeLayout.dataExtent.slice();
    visualMin != null && visualMin < dataExtent[0] && (dataExtent[0] = visualMin);
    visualMax != null && visualMax > dataExtent[1] && (dataExtent[1] = visualMax);
    var colorMappingBy = nodeModel.get('colorMappingBy');
    var opt = {
        type: rangeVisual.name,
        dataExtent: dataExtent,
        visual: rangeVisual.range
    };
    if (opt.type === 'color' && (colorMappingBy === 'index' || colorMappingBy === 'id')) {
        opt.mappingMethod = 'category';
        opt.loop = true;
    // categories is ordinal, so do not set opt.categories.
    } else opt.mappingMethod = 'linear';
    var mapping = new (0, $7b50f502cfd189d5$export$2e2bcd8739ae039)(opt);
    $e6cba72659c474bb$var$inner(mapping).drColorMappingBy = colorMappingBy;
    return mapping;
}
// Notice: If we don't have the attribute 'colorRange', but only use
// attribute 'color' to represent both concepts of 'colorRange' and 'color',
// (It means 'colorRange' when 'color' is Array, means 'color' when not array),
// this problem will be encountered:
// If a level-1 node doesn't have children, and its siblings have children,
// and colorRange is set on level-1, then the node cannot be colored.
// So we separate 'colorRange' and 'color' to different attributes.
function $e6cba72659c474bb$var$getRangeVisual(nodeModel, name) {
    // 'colorRange', 'colorARange', 'colorSRange'.
    // If not exists on this node, fetch from levels and series.
    var range = nodeModel.get(name);
    return (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(range) && range.length ? {
        name: name,
        range: range
    } : null;
}
function $e6cba72659c474bb$var$mapVisual(nodeModel, visuals, child, index, mapping, seriesModel) {
    var childVisuals = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, visuals);
    if (mapping) {
        // Only support color, colorAlpha, colorSaturation.
        var mappingType = mapping.type;
        var colorMappingBy = mappingType === 'color' && $e6cba72659c474bb$var$inner(mapping).drColorMappingBy;
        var value = colorMappingBy === 'index' ? index : colorMappingBy === 'id' ? seriesModel.mapIdToIndex(child.getId()) : child.getValue(nodeModel.get('visualDimension'));
        childVisuals[mappingType] = mapping.mapValueToVisual(value);
    }
    return childVisuals;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* A third-party license is embedded for some of the code in this file:
* The treemap layout implementation was originally copied from
* "d3.js" with some modifications made for this project.
* (See more details in the comment of the method "squarify" below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the license of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/ 




var $2f13a432668907b0$var$mathMax = Math.max;
var $2f13a432668907b0$var$mathMin = Math.min;
var $2f13a432668907b0$var$retrieveValue = $7a1bd9c2710fea0d$export$8a4d17b6e8486e66;
var $2f13a432668907b0$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
var $2f13a432668907b0$var$PATH_BORDER_WIDTH = [
    'itemStyle',
    'borderWidth'
];
var $2f13a432668907b0$var$PATH_GAP_WIDTH = [
    'itemStyle',
    'gapWidth'
];
var $2f13a432668907b0$var$PATH_UPPER_LABEL_SHOW = [
    'upperLabel',
    'show'
];
var $2f13a432668907b0$var$PATH_UPPER_LABEL_HEIGHT = [
    'upperLabel',
    'height'
];
var /**
 * @public
 */ $2f13a432668907b0$export$2e2bcd8739ae039 = {
    seriesType: 'treemap',
    reset: function(seriesModel, ecModel, api, payload) {
        // Layout result in each node:
        // {x, y, width, height, area, borderWidth}
        var ecWidth = api.getWidth();
        var ecHeight = api.getHeight();
        var seriesOption = seriesModel.option;
        var layoutInfo = $93b9bc7f22ac7369$export$4517a5ca639a7293(seriesModel.getBoxLayoutParams(), {
            width: api.getWidth(),
            height: api.getHeight()
        });
        var size = seriesOption.size || []; // Compatible with ec2.
        var containerWidth = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)($2f13a432668907b0$var$retrieveValue(layoutInfo.width, size[0]), ecWidth);
        var containerHeight = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)($2f13a432668907b0$var$retrieveValue(layoutInfo.height, size[1]), ecHeight);
        // Fetch payload info.
        var payloadType = payload && payload.type;
        var types = [
            'treemapZoomToNode',
            'treemapRootToNode'
        ];
        var targetInfo = $6341f66602946a06$export$c5445fa59c15dec4(payload, types, seriesModel);
        var rootRect = payloadType === 'treemapRender' || payloadType === 'treemapMove' ? payload.rootRect : null;
        var viewRoot = seriesModel.getViewRoot();
        var viewAbovePath = $6341f66602946a06$export$6be31fe4499506f9(viewRoot);
        if (payloadType !== 'treemapMove') {
            var rootSize = payloadType === 'treemapZoomToNode' ? $2f13a432668907b0$var$estimateRootSize(seriesModel, targetInfo, viewRoot, containerWidth, containerHeight) : rootRect ? [
                rootRect.width,
                rootRect.height
            ] : [
                containerWidth,
                containerHeight
            ];
            var sort_1 = seriesOption.sort;
            if (sort_1 && sort_1 !== 'asc' && sort_1 !== 'desc') // Default to be desc order.
            sort_1 = 'desc';
            var options = {
                squareRatio: seriesOption.squareRatio,
                sort: sort_1,
                leafDepth: seriesOption.leafDepth
            };
            // layout should be cleared because using updateView but not update.
            viewRoot.hostTree.clearLayouts();
            // TODO
            // optimize: if out of view clip, do not layout.
            // But take care that if do not render node out of view clip,
            // how to calculate start po
            var viewRootLayout_1 = {
                x: 0,
                y: 0,
                width: rootSize[0],
                height: rootSize[1],
                area: rootSize[0] * rootSize[1]
            };
            viewRoot.setLayout(viewRootLayout_1);
            $2f13a432668907b0$var$squarify(viewRoot, options, false, 0);
            // Supplement layout.
            viewRootLayout_1 = viewRoot.getLayout();
            $2f13a432668907b0$var$each(viewAbovePath, function(node, index) {
                var childValue = (viewAbovePath[index + 1] || viewRoot).getValue();
                node.setLayout($7a1bd9c2710fea0d$export$8b58be045bf06082({
                    dataExtent: [
                        childValue,
                        childValue
                    ],
                    borderWidth: 0,
                    upperHeight: 0
                }, viewRootLayout_1));
            });
        }
        var treeRoot = seriesModel.getData().tree.root;
        treeRoot.setLayout($2f13a432668907b0$var$calculateRootPosition(layoutInfo, rootRect, targetInfo), true);
        seriesModel.setLayoutInfo(layoutInfo);
        // FIXME
        // 现在没有clip功能，暂时取ec高宽。
        $2f13a432668907b0$var$prunning(treeRoot, // Transform to base element coordinate system.
        new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(-layoutInfo.x, -layoutInfo.y, ecWidth, ecHeight), viewAbovePath, viewRoot, 0);
    }
};
/**
 * Layout treemap with squarify algorithm.
 * The original presentation of this algorithm
 * was made by Mark Bruls, Kees Huizing, and Jarke J. van Wijk
 * <https://graphics.ethz.ch/teaching/scivis_common/Literature/squarifiedTreeMaps.pdf>.
 * The implementation of this algorithm was originally copied from "d3.js"
 * <https://github.com/d3/d3/blob/9cc9a875e636a1dcf36cc1e07bdf77e1ad6e2c74/src/layout/treemap.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 *
 * @protected
 * @param {module:echarts/data/Tree~TreeNode} node
 * @param {Object} options
 * @param {string} options.sort 'asc' or 'desc'
 * @param {number} options.squareRatio
 * @param {boolean} hideChildren
 * @param {number} depth
 */ function $2f13a432668907b0$var$squarify(node, options, hideChildren, depth) {
    var width;
    var height;
    if (node.isRemoved()) return;
    var thisLayout = node.getLayout();
    width = thisLayout.width;
    height = thisLayout.height;
    // Considering border and gap
    var nodeModel = node.getModel();
    var borderWidth = nodeModel.get($2f13a432668907b0$var$PATH_BORDER_WIDTH);
    var halfGapWidth = nodeModel.get($2f13a432668907b0$var$PATH_GAP_WIDTH) / 2;
    var upperLabelHeight = $2f13a432668907b0$var$getUpperLabelHeight(nodeModel);
    var upperHeight = Math.max(borderWidth, upperLabelHeight);
    var layoutOffset = borderWidth - halfGapWidth;
    var layoutOffsetUpper = upperHeight - halfGapWidth;
    node.setLayout({
        borderWidth: borderWidth,
        upperHeight: upperHeight,
        upperLabelHeight: upperLabelHeight
    }, true);
    width = $2f13a432668907b0$var$mathMax(width - 2 * layoutOffset, 0);
    height = $2f13a432668907b0$var$mathMax(height - layoutOffset - layoutOffsetUpper, 0);
    var totalArea = width * height;
    var viewChildren = $2f13a432668907b0$var$initChildren(node, nodeModel, totalArea, options, hideChildren, depth);
    if (!viewChildren.length) return;
    var rect = {
        x: layoutOffset,
        y: layoutOffsetUpper,
        width: width,
        height: height
    };
    var rowFixedLength = $2f13a432668907b0$var$mathMin(width, height);
    var best = Infinity; // the best row score so far
    var row = [];
    row.area = 0;
    for(var i = 0, len = viewChildren.length; i < len;){
        var child = viewChildren[i];
        row.push(child);
        row.area += child.getLayout().area;
        var score = $2f13a432668907b0$var$worst(row, rowFixedLength, options.squareRatio);
        // continue with this orientation
        if (score <= best) {
            i++;
            best = score;
        } else {
            row.area -= row.pop().getLayout().area;
            $2f13a432668907b0$var$position(row, rowFixedLength, rect, halfGapWidth, false);
            rowFixedLength = $2f13a432668907b0$var$mathMin(rect.width, rect.height);
            row.length = row.area = 0;
            best = Infinity;
        }
    }
    if (row.length) $2f13a432668907b0$var$position(row, rowFixedLength, rect, halfGapWidth, true);
    if (!hideChildren) {
        var childrenVisibleMin = nodeModel.get('childrenVisibleMin');
        if (childrenVisibleMin != null && totalArea < childrenVisibleMin) hideChildren = true;
    }
    for(var i = 0, len = viewChildren.length; i < len; i++)$2f13a432668907b0$var$squarify(viewChildren[i], options, hideChildren, depth + 1);
}
/**
 * Set area to each child, and calculate data extent for visual coding.
 */ function $2f13a432668907b0$var$initChildren(node, nodeModel, totalArea, options, hideChildren, depth) {
    var viewChildren = node.children || [];
    var orderBy = options.sort;
    orderBy !== 'asc' && orderBy !== 'desc' && (orderBy = null);
    var overLeafDepth = options.leafDepth != null && options.leafDepth <= depth;
    // leafDepth has higher priority.
    if (hideChildren && !overLeafDepth) return node.viewChildren = [];
    // Sort children, order by desc.
    viewChildren = $7a1bd9c2710fea0d$export$3dea766d36a8935f(viewChildren, function(child) {
        return !child.isRemoved();
    });
    $2f13a432668907b0$var$sort(viewChildren, orderBy);
    var info = $2f13a432668907b0$var$statistic(nodeModel, viewChildren, orderBy);
    if (info.sum === 0) return node.viewChildren = [];
    info.sum = $2f13a432668907b0$var$filterByThreshold(nodeModel, totalArea, info.sum, orderBy, viewChildren);
    if (info.sum === 0) return node.viewChildren = [];
    // Set area to each child.
    for(var i = 0, len = viewChildren.length; i < len; i++){
        var area = viewChildren[i].getValue() / info.sum * totalArea;
        // Do not use setLayout({...}, true), because it is needed to clear last layout.
        viewChildren[i].setLayout({
            area: area
        });
    }
    if (overLeafDepth) {
        viewChildren.length && node.setLayout({
            isLeafRoot: true
        }, true);
        viewChildren.length = 0;
    }
    node.viewChildren = viewChildren;
    node.setLayout({
        dataExtent: info.dataExtent
    }, true);
    return viewChildren;
}
/**
 * Consider 'visibleMin'. Modify viewChildren and get new sum.
 */ function $2f13a432668907b0$var$filterByThreshold(nodeModel, totalArea, sum, orderBy, orderedChildren) {
    // visibleMin is not supported yet when no option.sort.
    if (!orderBy) return sum;
    var visibleMin = nodeModel.get('visibleMin');
    var len = orderedChildren.length;
    var deletePoint = len;
    // Always travel from little value to big value.
    for(var i = len - 1; i >= 0; i--){
        var value = orderedChildren[orderBy === 'asc' ? len - i - 1 : i].getValue();
        if (value / sum * totalArea < visibleMin) {
            deletePoint = i;
            sum -= value;
        }
    }
    orderBy === 'asc' ? orderedChildren.splice(0, len - deletePoint) : orderedChildren.splice(deletePoint, len - deletePoint);
    return sum;
}
/**
 * Sort
 */ function $2f13a432668907b0$var$sort(viewChildren, orderBy) {
    if (orderBy) viewChildren.sort(function(a, b) {
        var diff = orderBy === 'asc' ? a.getValue() - b.getValue() : b.getValue() - a.getValue();
        return diff === 0 ? orderBy === 'asc' ? a.dataIndex - b.dataIndex : b.dataIndex - a.dataIndex : diff;
    });
    return viewChildren;
}
/**
 * Statistic
 */ function $2f13a432668907b0$var$statistic(nodeModel, children, orderBy) {
    // Calculate sum.
    var sum = 0;
    for(var i = 0, len = children.length; i < len; i++)sum += children[i].getValue();
    // Statistic data extent for latter visual coding.
    // Notice: data extent should be calculate based on raw children
    // but not filtered view children, otherwise visual mapping will not
    // be stable when zoom (where children is filtered by visibleMin).
    var dimension = nodeModel.get('visualDimension');
    var dataExtent;
    // The same as area dimension.
    if (!children || !children.length) dataExtent = [
        NaN,
        NaN
    ];
    else if (dimension === 'value' && orderBy) {
        dataExtent = [
            children[children.length - 1].getValue(),
            children[0].getValue()
        ];
        orderBy === 'asc' && dataExtent.reverse();
    } else {
        dataExtent = [
            Infinity,
            -Infinity
        ];
        $2f13a432668907b0$var$each(children, function(child) {
            var value = child.getValue(dimension);
            value < dataExtent[0] && (dataExtent[0] = value);
            value > dataExtent[1] && (dataExtent[1] = value);
        });
    }
    return {
        sum: sum,
        dataExtent: dataExtent
    };
}
/**
 * Computes the score for the specified row,
 * as the worst aspect ratio.
 */ function $2f13a432668907b0$var$worst(row, rowFixedLength, ratio) {
    var areaMax = 0;
    var areaMin = Infinity;
    for(var i = 0, area = void 0, len = row.length; i < len; i++){
        area = row[i].getLayout().area;
        if (area) {
            area < areaMin && (areaMin = area);
            area > areaMax && (areaMax = area);
        }
    }
    var squareArea = row.area * row.area;
    var f = rowFixedLength * rowFixedLength * ratio;
    return squareArea ? $2f13a432668907b0$var$mathMax(f * areaMax / squareArea, squareArea / (f * areaMin)) : Infinity;
}
/**
 * Positions the specified row of nodes. Modifies `rect`.
 */ function $2f13a432668907b0$var$position(row, rowFixedLength, rect, halfGapWidth, flush) {
    // When rowFixedLength === rect.width,
    // it is horizontal subdivision,
    // rowFixedLength is the width of the subdivision,
    // rowOtherLength is the height of the subdivision,
    // and nodes will be positioned from left to right.
    // wh[idx0WhenH] means: when horizontal,
    //      wh[idx0WhenH] => wh[0] => 'width'.
    //      xy[idx1WhenH] => xy[1] => 'y'.
    var idx0WhenH = rowFixedLength === rect.width ? 0 : 1;
    var idx1WhenH = 1 - idx0WhenH;
    var xy = [
        'x',
        'y'
    ];
    var wh = [
        'width',
        'height'
    ];
    var last = rect[xy[idx0WhenH]];
    var rowOtherLength = rowFixedLength ? row.area / rowFixedLength : 0;
    if (flush || rowOtherLength > rect[wh[idx1WhenH]]) rowOtherLength = rect[wh[idx1WhenH]]; // over+underflow
    for(var i = 0, rowLen = row.length; i < rowLen; i++){
        var node = row[i];
        var nodeLayout = {};
        var step = rowOtherLength ? node.getLayout().area / rowOtherLength : 0;
        var wh1 = nodeLayout[wh[idx1WhenH]] = $2f13a432668907b0$var$mathMax(rowOtherLength - 2 * halfGapWidth, 0);
        // We use Math.max/min to avoid negative width/height when considering gap width.
        var remain = rect[xy[idx0WhenH]] + rect[wh[idx0WhenH]] - last;
        var modWH = i === rowLen - 1 || remain < step ? remain : step;
        var wh0 = nodeLayout[wh[idx0WhenH]] = $2f13a432668907b0$var$mathMax(modWH - 2 * halfGapWidth, 0);
        nodeLayout[xy[idx1WhenH]] = rect[xy[idx1WhenH]] + $2f13a432668907b0$var$mathMin(halfGapWidth, wh1 / 2);
        nodeLayout[xy[idx0WhenH]] = last + $2f13a432668907b0$var$mathMin(halfGapWidth, wh0 / 2);
        last += modWH;
        node.setLayout(nodeLayout, true);
    }
    rect[xy[idx1WhenH]] += rowOtherLength;
    rect[wh[idx1WhenH]] -= rowOtherLength;
}
// Return [containerWidth, containerHeight] as default.
function $2f13a432668907b0$var$estimateRootSize(seriesModel, targetInfo, viewRoot, containerWidth, containerHeight) {
    // If targetInfo.node exists, we zoom to the node,
    // so estimate whole width and height by target node.
    var currNode = (targetInfo || {}).node;
    var defaultSize = [
        containerWidth,
        containerHeight
    ];
    if (!currNode || currNode === viewRoot) return defaultSize;
    var parent;
    var viewArea = containerWidth * containerHeight;
    var area = viewArea * seriesModel.option.zoomToNodeRatio;
    while(parent = currNode.parentNode){
        // jshint ignore:line
        var sum = 0;
        var siblings = parent.children;
        for(var i = 0, len = siblings.length; i < len; i++)sum += siblings[i].getValue();
        var currNodeValue = currNode.getValue();
        if (currNodeValue === 0) return defaultSize;
        area *= sum / currNodeValue;
        // Considering border, suppose aspect ratio is 1.
        var parentModel = parent.getModel();
        var borderWidth = parentModel.get($2f13a432668907b0$var$PATH_BORDER_WIDTH);
        var upperHeight = Math.max(borderWidth, $2f13a432668907b0$var$getUpperLabelHeight(parentModel));
        area += 4 * borderWidth * borderWidth + (3 * borderWidth + upperHeight) * Math.pow(area, 0.5);
        area > (0, $cfc1f3b422a3185f$export$18510406f204a1b9) && (area = (0, $cfc1f3b422a3185f$export$18510406f204a1b9));
        currNode = parent;
    }
    area < viewArea && (area = viewArea);
    var scale = Math.pow(area / viewArea, 0.5);
    return [
        containerWidth * scale,
        containerHeight * scale
    ];
}
// Root position based on coord of containerGroup
function $2f13a432668907b0$var$calculateRootPosition(layoutInfo, rootRect, targetInfo) {
    if (rootRect) return {
        x: rootRect.x,
        y: rootRect.y
    };
    var defaultPosition = {
        x: 0,
        y: 0
    };
    if (!targetInfo) return defaultPosition;
    // If targetInfo is fetched by 'retrieveTargetInfo',
    // old tree and new tree are the same tree,
    // so the node still exists and we can visit it.
    var targetNode = targetInfo.node;
    var layout = targetNode.getLayout();
    if (!layout) return defaultPosition;
    // Transform coord from local to container.
    var targetCenter = [
        layout.width / 2,
        layout.height / 2
    ];
    var node = targetNode;
    while(node){
        var nodeLayout = node.getLayout();
        targetCenter[0] += nodeLayout.x;
        targetCenter[1] += nodeLayout.y;
        node = node.parentNode;
    }
    return {
        x: layoutInfo.width / 2 - targetCenter[0],
        y: layoutInfo.height / 2 - targetCenter[1]
    };
}
// Mark nodes visible for prunning when visual coding and rendering.
// Prunning depends on layout and root position, so we have to do it after layout.
function $2f13a432668907b0$var$prunning(node, clipRect, viewAbovePath, viewRoot, depth) {
    var nodeLayout = node.getLayout();
    var nodeInViewAbovePath = viewAbovePath[depth];
    var isAboveViewRoot = nodeInViewAbovePath && nodeInViewAbovePath === node;
    if (nodeInViewAbovePath && !isAboveViewRoot || depth === viewAbovePath.length && node !== viewRoot) return;
    node.setLayout({
        // isInView means: viewRoot sub tree + viewAbovePath
        isInView: true,
        // invisible only means: outside view clip so that the node can not
        // see but still layout for animation preparation but not render.
        invisible: !isAboveViewRoot && !clipRect.intersect(nodeLayout),
        isAboveViewRoot: isAboveViewRoot
    }, true);
    // Transform to child coordinate.
    var childClipRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(clipRect.x - nodeLayout.x, clipRect.y - nodeLayout.y, clipRect.width, clipRect.height);
    $2f13a432668907b0$var$each(node.viewChildren || [], function(child) {
        $2f13a432668907b0$var$prunning(child, childClipRect, viewAbovePath, viewRoot, depth + 1);
    });
}
function $2f13a432668907b0$var$getUpperLabelHeight(model) {
    return model.get($2f13a432668907b0$var$PATH_UPPER_LABEL_SHOW) ? model.get($2f13a432668907b0$var$PATH_UPPER_LABEL_HEIGHT) : 0;
}


function $330b7dc841112eff$export$4b3e715f166fdd78(registers) {
    registers.registerSeriesModel((0, $10d079b37d9731a3$export$2e2bcd8739ae039));
    registers.registerChartView((0, $ca67abe413e4c090$export$2e2bcd8739ae039));
    registers.registerVisual((0, $e6cba72659c474bb$export$2e2bcd8739ae039));
    registers.registerLayout((0, $2f13a432668907b0$export$2e2bcd8739ae039));
    (0, $26d493e9cdfadb01$export$1ad90fc3f3a8bbf9)(registers);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $98990baee36aa4ed$var$DEFAULT_OPTION = {
    label: {
        enabled: true
    },
    decal: {
        show: false
    }
};
var $98990baee36aa4ed$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $98990baee36aa4ed$var$decalPaletteScope = {};
function $98990baee36aa4ed$export$2e2bcd8739ae039(ecModel, api) {
    var ariaModel = ecModel.getModel('aria');
    // See "area enabled" detection code in `GlobalModel.ts`.
    if (!ariaModel.get('enabled')) return;
    var defaultOption = $7a1bd9c2710fea0d$export$9cd59f9826255e47($98990baee36aa4ed$var$DEFAULT_OPTION);
    $7a1bd9c2710fea0d$export$4950aa0f605343fb(defaultOption.label, ecModel.getLocaleModel().get('aria'), false);
    $7a1bd9c2710fea0d$export$4950aa0f605343fb(ariaModel.option, defaultOption, false);
    setDecal();
    setLabel();
    function setDecal() {
        var decalModel = ariaModel.getModel('decal');
        var useDecal = decalModel.get('show');
        if (useDecal) {
            // Each type of series use one scope.
            // Pie and funnel are using different scopes.
            var paletteScopeGroupByType_1 = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
            ecModel.eachSeries(function(seriesModel) {
                if (seriesModel.isColorBySeries()) return;
                var decalScope = paletteScopeGroupByType_1.get(seriesModel.type);
                if (!decalScope) {
                    decalScope = {};
                    paletteScopeGroupByType_1.set(seriesModel.type, decalScope);
                }
                $98990baee36aa4ed$var$inner(seriesModel).scope = decalScope;
            });
            ecModel.eachRawSeries(function(seriesModel) {
                if (ecModel.isSeriesFiltered(seriesModel)) return;
                if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(seriesModel.enableAriaDecal)) {
                    // Let series define how to use decal palette on data
                    seriesModel.enableAriaDecal();
                    return;
                }
                var data = seriesModel.getData();
                if (!seriesModel.isColorBySeries()) {
                    var dataAll_1 = seriesModel.getRawData();
                    var idxMap_1 = {};
                    var decalScope_1 = $98990baee36aa4ed$var$inner(seriesModel).scope;
                    data.each(function(idx) {
                        var rawIdx = data.getRawIndex(idx);
                        idxMap_1[rawIdx] = idx;
                    });
                    var dataCount_1 = dataAll_1.count();
                    dataAll_1.each(function(rawIdx) {
                        var idx = idxMap_1[rawIdx];
                        var name = dataAll_1.getName(rawIdx) || rawIdx + '';
                        var paletteDecal = (0, $e7fbd47751ca3c28$export$e4d892222945a227)(seriesModel.ecModel, name, decalScope_1, dataCount_1);
                        var specifiedDecal = data.getItemVisual(idx, 'decal');
                        data.setItemVisual(idx, 'decal', mergeDecal(specifiedDecal, paletteDecal));
                    });
                } else {
                    var paletteDecal = (0, $e7fbd47751ca3c28$export$e4d892222945a227)(seriesModel.ecModel, seriesModel.name, $98990baee36aa4ed$var$decalPaletteScope, ecModel.getSeriesCount());
                    var specifiedDecal = data.getVisual('decal');
                    data.setVisual('decal', mergeDecal(specifiedDecal, paletteDecal));
                }
                function mergeDecal(specifiedDecal, paletteDecal) {
                    // Merge decal from palette to decal from itemStyle.
                    // User do not need to specify all of the decal props.
                    var resultDecal = specifiedDecal ? $7a1bd9c2710fea0d$export$8b58be045bf06082($7a1bd9c2710fea0d$export$8b58be045bf06082({}, paletteDecal), specifiedDecal) : paletteDecal;
                    resultDecal.dirty = true;
                    return resultDecal;
                }
            });
        }
    }
    function setLabel() {
        var dom = api.getZr().dom;
        // TODO: support for SSR
        if (!dom) return;
        var labelLocale = ecModel.getLocaleModel().get('aria');
        var labelModel = ariaModel.getModel('label');
        labelModel.option = $7a1bd9c2710fea0d$export$ebe90cb607ad99e(labelModel.option, labelLocale);
        if (!labelModel.get('enabled')) return;
        dom.setAttribute('role', 'img');
        if (labelModel.get('description')) {
            dom.setAttribute('aria-label', labelModel.get('description'));
            return;
        }
        var seriesCnt = ecModel.getSeriesCount();
        var maxDataCnt = labelModel.get([
            'data',
            'maxCount'
        ]) || 10;
        var maxSeriesCnt = labelModel.get([
            'series',
            'maxCount'
        ]) || 10;
        var displaySeriesCnt = Math.min(seriesCnt, maxSeriesCnt);
        var ariaLabel;
        if (seriesCnt < 1) // No series, no aria label
        return;
        else {
            var title = getTitle();
            if (title) {
                var withTitle = labelModel.get([
                    'general',
                    'withTitle'
                ]);
                ariaLabel = replace(withTitle, {
                    title: title
                });
            } else ariaLabel = labelModel.get([
                'general',
                'withoutTitle'
            ]);
            var seriesLabels_1 = [];
            var prefix = seriesCnt > 1 ? labelModel.get([
                'series',
                'multiple',
                'prefix'
            ]) : labelModel.get([
                'series',
                'single',
                'prefix'
            ]);
            ariaLabel += replace(prefix, {
                seriesCount: seriesCnt
            });
            ecModel.eachSeries(function(seriesModel, idx) {
                if (idx < displaySeriesCnt) {
                    var seriesLabel = void 0;
                    var seriesName = seriesModel.get('name');
                    var withName = seriesName ? 'withName' : 'withoutName';
                    seriesLabel = seriesCnt > 1 ? labelModel.get([
                        'series',
                        'multiple',
                        withName
                    ]) : labelModel.get([
                        'series',
                        'single',
                        withName
                    ]);
                    seriesLabel = replace(seriesLabel, {
                        seriesId: seriesModel.seriesIndex,
                        seriesName: seriesModel.get('name'),
                        seriesType: getSeriesTypeName(seriesModel.subType)
                    });
                    var data = seriesModel.getData();
                    if (data.count() > maxDataCnt) {
                        // Show part of data
                        var partialLabel = labelModel.get([
                            'data',
                            'partialData'
                        ]);
                        seriesLabel += replace(partialLabel, {
                            displayCnt: maxDataCnt
                        });
                    } else seriesLabel += labelModel.get([
                        'data',
                        'allData'
                    ]);
                    var middleSeparator_1 = labelModel.get([
                        'data',
                        'separator',
                        'middle'
                    ]);
                    var endSeparator_1 = labelModel.get([
                        'data',
                        'separator',
                        'end'
                    ]);
                    var excludeDimensionId_1 = labelModel.get([
                        'data',
                        'excludeDimensionId'
                    ]);
                    var dataLabels = [];
                    for(var i = 0; i < data.count(); i++)if (i < maxDataCnt) {
                        var name_1 = data.getName(i);
                        var value = !excludeDimensionId_1 ? data.getValues(i) : $7a1bd9c2710fea0d$export$3dea766d36a8935f(data.getValues(i), function(v, j) {
                            return $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(excludeDimensionId_1, j) === -1;
                        });
                        var dataLabel = labelModel.get([
                            'data',
                            name_1 ? 'withName' : 'withoutName'
                        ]);
                        dataLabels.push(replace(dataLabel, {
                            name: name_1,
                            value: value.join(middleSeparator_1)
                        }));
                    }
                    seriesLabel += dataLabels.join(middleSeparator_1) + endSeparator_1;
                    seriesLabels_1.push(seriesLabel);
                }
            });
            var separatorModel = labelModel.getModel([
                'series',
                'multiple',
                'separator'
            ]);
            var middleSeparator = separatorModel.get('middle');
            var endSeparator = separatorModel.get('end');
            ariaLabel += seriesLabels_1.join(middleSeparator) + endSeparator;
            dom.setAttribute('aria-label', ariaLabel);
        }
    }
    function replace(str, keyValues) {
        if (!$7a1bd9c2710fea0d$export$844ec244b1367d54(str)) return str;
        var result = str;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(keyValues, function(value, key) {
            result = result.replace(new RegExp('\\{\\s*' + key + '\\s*\\}', 'g'), value);
        });
        return result;
    }
    function getTitle() {
        var title = ecModel.get('title');
        if (title && title.length) title = title[0];
        return title && title.text;
    }
    function getSeriesTypeName(type) {
        var typeNames = ecModel.getLocaleModel().get([
            'series',
            'typeNames'
        ]);
        return typeNames[type] || typeNames.chart;
    }
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $6f6d6469de000c68$export$2e2bcd8739ae039(option) {
    if (!option || !option.aria) return;
    var aria = option.aria;
    // aria.show is deprecated and should use aria.enabled instead
    if (aria.show != null) aria.enabled = aria.show;
    aria.label = aria.label || {};
    // move description, general, series, data to be under aria.label
    $7a1bd9c2710fea0d$export$79b2f7037acddd43([
        'description',
        'general',
        'series',
        'data'
    ], function(name) {
        if (aria[name] != null) aria.label[name] = aria[name];
    });
}


function $772c09ed30d27c33$export$4b3e715f166fdd78(registers) {
    registers.registerPreprocessor((0, $6f6d6469de000c68$export$2e2bcd8739ae039));
    registers.registerVisual(registers.PRIORITY.VISUAL.ARIA, (0, $98990baee36aa4ed$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $a331d7a6c631e6d9$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $a331d7a6c631e6d9$var$clone = $7a1bd9c2710fea0d$export$9cd59f9826255e47;
var $a331d7a6c631e6d9$var$bind = $7a1bd9c2710fea0d$export$2385a24977818dd0;
/**
 * Base axis pointer class in 2D.
 */ var $a331d7a6c631e6d9$var$BaseAxisPointer = /** @class */ function() {
    function BaseAxisPointer() {
        this._dragging = false;
        /**
     * In px, arbitrary value. Do not set too small,
     * no animation is ok for most cases.
     */ this.animationThreshold = 15;
    }
    /**
   * @implement
   */ BaseAxisPointer.prototype.render = function(axisModel, axisPointerModel, api, forceRender) {
        var value = axisPointerModel.get('value');
        var status = axisPointerModel.get('status');
        // Bind them to `this`, not in closure, otherwise they will not
        // be replaced when user calling setOption in not merge mode.
        this._axisModel = axisModel;
        this._axisPointerModel = axisPointerModel;
        this._api = api;
        // Optimize: `render` will be called repeatedly during mouse move.
        // So it is power consuming if performing `render` each time,
        // especially on mobile device.
        if (!forceRender && this._lastValue === value && this._lastStatus === status) return;
        this._lastValue = value;
        this._lastStatus = status;
        var group = this._group;
        var handle = this._handle;
        if (!status || status === 'hide') {
            // Do not clear here, for animation better.
            group && group.hide();
            handle && handle.hide();
            return;
        }
        group && group.show();
        handle && handle.show();
        // Otherwise status is 'show'
        var elOption = {};
        this.makeElOption(elOption, value, axisModel, axisPointerModel, api);
        // Enable change axis pointer type.
        var graphicKey = elOption.graphicKey;
        if (graphicKey !== this._lastGraphicKey) this.clear(api);
        this._lastGraphicKey = graphicKey;
        var moveAnimation = this._moveAnimation = this.determineAnimation(axisModel, axisPointerModel);
        if (!group) {
            group = this._group = new $5b455ae6f843ac47$exports.Group();
            this.createPointerEl(group, elOption, axisModel, axisPointerModel);
            this.createLabelEl(group, elOption, axisModel, axisPointerModel);
            api.getZr().add(group);
        } else {
            var doUpdateProps = $7a1bd9c2710fea0d$export$c3095a23b368d1f2($a331d7a6c631e6d9$var$updateProps, axisPointerModel, moveAnimation);
            this.updatePointerEl(group, elOption, doUpdateProps);
            this.updateLabelEl(group, elOption, doUpdateProps, axisPointerModel);
        }
        $a331d7a6c631e6d9$var$updateMandatoryProps(group, axisPointerModel, true);
        this._renderHandle(value);
    };
    /**
   * @implement
   */ BaseAxisPointer.prototype.remove = function(api) {
        this.clear(api);
    };
    /**
   * @implement
   */ BaseAxisPointer.prototype.dispose = function(api) {
        this.clear(api);
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.determineAnimation = function(axisModel, axisPointerModel) {
        var animation = axisPointerModel.get('animation');
        var axis = axisModel.axis;
        var isCategoryAxis = axis.type === 'category';
        var useSnap = axisPointerModel.get('snap');
        // Value axis without snap always do not snap.
        if (!useSnap && !isCategoryAxis) return false;
        if (animation === 'auto' || animation == null) {
            var animationThreshold = this.animationThreshold;
            if (isCategoryAxis && axis.getBandWidth() > animationThreshold) return true;
            // It is important to auto animation when snap used. Consider if there is
            // a dataZoom, animation will be disabled when too many points exist, while
            // it will be enabled for better visual effect when little points exist.
            if (useSnap) {
                var seriesDataCount = $84d826b9ba8bf009$export$bd39458db76002ab(axisModel).seriesDataCount;
                var axisExtent = axis.getExtent();
                // Approximate band width
                return Math.abs(axisExtent[0] - axisExtent[1]) / seriesDataCount > animationThreshold;
            }
            return false;
        }
        return animation === true;
    };
    /**
   * add {pointer, label, graphicKey} to elOption
   * @protected
   */ BaseAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {
    // Should be implemenented by sub-class.
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.createPointerEl = function(group, elOption, axisModel, axisPointerModel) {
        var pointerOption = elOption.pointer;
        if (pointerOption) {
            var pointerEl = $a331d7a6c631e6d9$var$inner(group).pointerEl = new $5b455ae6f843ac47$exports[pointerOption.type]($a331d7a6c631e6d9$var$clone(elOption.pointer));
            group.add(pointerEl);
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.createLabelEl = function(group, elOption, axisModel, axisPointerModel) {
        if (elOption.label) {
            var labelEl = $a331d7a6c631e6d9$var$inner(group).labelEl = new $5b455ae6f843ac47$exports.Text($a331d7a6c631e6d9$var$clone(elOption.label));
            group.add(labelEl);
            $a331d7a6c631e6d9$var$updateLabelShowHide(labelEl, axisPointerModel);
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.updatePointerEl = function(group, elOption, updateProps) {
        var pointerEl = $a331d7a6c631e6d9$var$inner(group).pointerEl;
        if (pointerEl && elOption.pointer) {
            pointerEl.setStyle(elOption.pointer.style);
            updateProps(pointerEl, {
                shape: elOption.pointer.shape
            });
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.updateLabelEl = function(group, elOption, updateProps, axisPointerModel) {
        var labelEl = $a331d7a6c631e6d9$var$inner(group).labelEl;
        if (labelEl) {
            labelEl.setStyle(elOption.label.style);
            updateProps(labelEl, {
                // Consider text length change in vertical axis, animation should
                // be used on shape, otherwise the effect will be weird.
                // TODOTODO
                // shape: elOption.label.shape,
                x: elOption.label.x,
                y: elOption.label.y
            });
            $a331d7a6c631e6d9$var$updateLabelShowHide(labelEl, axisPointerModel);
        }
    };
    /**
   * @private
   */ BaseAxisPointer.prototype._renderHandle = function(value) {
        if (this._dragging || !this.updateHandleTransform) return;
        var axisPointerModel = this._axisPointerModel;
        var zr = this._api.getZr();
        var handle = this._handle;
        var handleModel = axisPointerModel.getModel('handle');
        var status = axisPointerModel.get('status');
        if (!handleModel.get('show') || !status || status === 'hide') {
            handle && zr.remove(handle);
            this._handle = null;
            return;
        }
        var isInit;
        if (!this._handle) {
            isInit = true;
            handle = this._handle = $5b455ae6f843ac47$exports.createIcon(handleModel.get('icon'), {
                cursor: 'move',
                draggable: true,
                onmousemove: function(e) {
                    // For mobile device, prevent screen slider on the button.
                    $b3864a78637ff9ed$export$fa6813432f753b0d(e.event);
                },
                onmousedown: $a331d7a6c631e6d9$var$bind(this._onHandleDragMove, this, 0, 0),
                drift: $a331d7a6c631e6d9$var$bind(this._onHandleDragMove, this),
                ondragend: $a331d7a6c631e6d9$var$bind(this._onHandleDragEnd, this)
            });
            zr.add(handle);
        }
        $a331d7a6c631e6d9$var$updateMandatoryProps(handle, axisPointerModel, false);
        // update style
        handle.setStyle(handleModel.getItemStyle(null, [
            'color',
            'borderColor',
            'borderWidth',
            'opacity',
            'shadowColor',
            'shadowBlur',
            'shadowOffsetX',
            'shadowOffsetY'
        ]));
        // update position
        var handleSize = handleModel.get('size');
        if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(handleSize)) handleSize = [
            handleSize,
            handleSize
        ];
        handle.scaleX = handleSize[0] / 2;
        handle.scaleY = handleSize[1] / 2;
        $c98659a9437a3d2e$export$958e3e1a02eac4b6(this, '_doDispatchAxisPointer', handleModel.get('throttle') || 0, 'fixRate');
        this._moveHandleToValue(value, isInit);
    };
    BaseAxisPointer.prototype._moveHandleToValue = function(value, isInit) {
        $a331d7a6c631e6d9$var$updateProps(this._axisPointerModel, !isInit && this._moveAnimation, this._handle, $a331d7a6c631e6d9$var$getHandleTransProps(this.getHandleTransform(value, this._axisModel, this._axisPointerModel)));
    };
    BaseAxisPointer.prototype._onHandleDragMove = function(dx, dy) {
        var handle = this._handle;
        if (!handle) return;
        this._dragging = true;
        // Persistent for throttle.
        var trans = this.updateHandleTransform($a331d7a6c631e6d9$var$getHandleTransProps(handle), [
            dx,
            dy
        ], this._axisModel, this._axisPointerModel);
        this._payloadInfo = trans;
        handle.stopAnimation();
        handle.attr($a331d7a6c631e6d9$var$getHandleTransProps(trans));
        $a331d7a6c631e6d9$var$inner(handle).lastProp = null;
        this._doDispatchAxisPointer();
    };
    /**
   * Throttled method.
   */ BaseAxisPointer.prototype._doDispatchAxisPointer = function() {
        var handle = this._handle;
        if (!handle) return;
        var payloadInfo = this._payloadInfo;
        var axisModel = this._axisModel;
        this._api.dispatchAction({
            type: 'updateAxisPointer',
            x: payloadInfo.cursorPoint[0],
            y: payloadInfo.cursorPoint[1],
            tooltipOption: payloadInfo.tooltipOption,
            axesInfo: [
                {
                    axisDim: axisModel.axis.dim,
                    axisIndex: axisModel.componentIndex
                }
            ]
        });
    };
    BaseAxisPointer.prototype._onHandleDragEnd = function() {
        this._dragging = false;
        var handle = this._handle;
        if (!handle) return;
        var value = this._axisPointerModel.get('value');
        // Consider snap or categroy axis, handle may be not consistent with
        // axisPointer. So move handle to align the exact value position when
        // drag ended.
        this._moveHandleToValue(value);
        // For the effect: tooltip will be shown when finger holding on handle
        // button, and will be hidden after finger left handle button.
        this._api.dispatchAction({
            type: 'hideTip'
        });
    };
    /**
   * @private
   */ BaseAxisPointer.prototype.clear = function(api) {
        this._lastValue = null;
        this._lastStatus = null;
        var zr = api.getZr();
        var group = this._group;
        var handle = this._handle;
        if (zr && group) {
            this._lastGraphicKey = null;
            group && zr.remove(group);
            handle && zr.remove(handle);
            this._group = null;
            this._handle = null;
            this._payloadInfo = null;
        }
        $c98659a9437a3d2e$export$42ffd38884aecdac(this, '_doDispatchAxisPointer');
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.doClear = function() {
    // Implemented by sub-class if necessary.
    };
    BaseAxisPointer.prototype.buildLabel = function(xy, wh, xDimIndex) {
        xDimIndex = xDimIndex || 0;
        return {
            x: xy[xDimIndex],
            y: xy[1 - xDimIndex],
            width: wh[xDimIndex],
            height: wh[1 - xDimIndex]
        };
    };
    return BaseAxisPointer;
}();
function $a331d7a6c631e6d9$var$updateProps(animationModel, moveAnimation, el, props) {
    // Animation optimize.
    if (!$a331d7a6c631e6d9$var$propsEqual($a331d7a6c631e6d9$var$inner(el).lastProp, props)) {
        $a331d7a6c631e6d9$var$inner(el).lastProp = props;
        moveAnimation ? $5b455ae6f843ac47$exports.updateProps(el, props, animationModel) : (el.stopAnimation(), el.attr(props));
    }
}
function $a331d7a6c631e6d9$var$propsEqual(lastProps, newProps) {
    if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(lastProps) && $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(newProps)) {
        var equals_1 = true;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(newProps, function(item, key) {
            equals_1 = equals_1 && $a331d7a6c631e6d9$var$propsEqual(lastProps[key], item);
        });
        return !!equals_1;
    } else return lastProps === newProps;
}
function $a331d7a6c631e6d9$var$updateLabelShowHide(labelEl, axisPointerModel) {
    labelEl[axisPointerModel.get([
        'label',
        'show'
    ]) ? 'show' : 'hide']();
}
function $a331d7a6c631e6d9$var$getHandleTransProps(trans) {
    return {
        x: trans.x || 0,
        y: trans.y || 0,
        rotation: trans.rotation || 0
    };
}
function $a331d7a6c631e6d9$var$updateMandatoryProps(group, axisPointerModel, silent) {
    var z = axisPointerModel.get('z');
    var zlevel = axisPointerModel.get('zlevel');
    group && group.traverse(function(el) {
        if (el.type !== 'group') {
            z != null && (el.z = z);
            zlevel != null && (el.zlevel = zlevel);
            el.silent = silent;
        }
    });
}
var $a331d7a6c631e6d9$export$2e2bcd8739ae039 = $a331d7a6c631e6d9$var$BaseAxisPointer;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







function $51dec70890757374$export$b7fe459c7cc50060(axisPointerModel) {
    var axisPointerType = axisPointerModel.get('type');
    var styleModel = axisPointerModel.getModel(axisPointerType + 'Style');
    var style;
    if (axisPointerType === 'line') {
        style = styleModel.getLineStyle();
        style.fill = null;
    } else if (axisPointerType === 'shadow') {
        style = styleModel.getAreaStyle();
        style.stroke = null;
    }
    return style;
}
function $51dec70890757374$export$8206a9937c45910f(elOption, axisModel, axisPointerModel, api, labelPos) {
    var value = axisPointerModel.get('value');
    var text = $51dec70890757374$export$7cffee0f9aed39d0(value, axisModel.axis, axisModel.ecModel, axisPointerModel.get('seriesDataIndices'), {
        precision: axisPointerModel.get([
            'label',
            'precision'
        ]),
        formatter: axisPointerModel.get([
            'label',
            'formatter'
        ])
    });
    var labelModel = axisPointerModel.getModel('label');
    var paddings = $c84c9521536c601a$export$f3a38102c49f4268(labelModel.get('padding') || 0);
    var font = labelModel.getFont();
    var textRect = $6c308355c7107803$export$c381147bfed79d9f(text, font);
    var position = labelPos.position;
    var width = textRect.width + paddings[1] + paddings[3];
    var height = textRect.height + paddings[0] + paddings[2];
    // Adjust by align.
    var align = labelPos.align;
    align === 'right' && (position[0] -= width);
    align === 'center' && (position[0] -= width / 2);
    var verticalAlign = labelPos.verticalAlign;
    verticalAlign === 'bottom' && (position[1] -= height);
    verticalAlign === 'middle' && (position[1] -= height / 2);
    // Not overflow ec container
    $51dec70890757374$var$confineInContainer(position, width, height, api);
    var bgColor = labelModel.get('backgroundColor');
    if (!bgColor || bgColor === 'auto') bgColor = axisModel.get([
        'axisLine',
        'lineStyle',
        'color'
    ]);
    elOption.label = {
        // shape: {x: 0, y: 0, width: width, height: height, r: labelModel.get('borderRadius')},
        x: position[0],
        y: position[1],
        style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(labelModel, {
            text: text,
            font: font,
            fill: labelModel.getTextColor(),
            padding: paddings,
            backgroundColor: bgColor
        }),
        // Label should be over axisPointer.
        z2: 10
    };
}
// Do not overflow ec container
function $51dec70890757374$var$confineInContainer(position, width, height, api) {
    var viewWidth = api.getWidth();
    var viewHeight = api.getHeight();
    position[0] = Math.min(position[0] + width, viewWidth) - width;
    position[1] = Math.min(position[1] + height, viewHeight) - height;
    position[0] = Math.max(position[0], 0);
    position[1] = Math.max(position[1], 0);
}
function $51dec70890757374$export$7cffee0f9aed39d0(value, axis, ecModel, seriesDataIndices, opt) {
    value = axis.scale.parse(value);
    var text = axis.scale.getLabel({
        value: value
    }, {
        // If `precision` is set, width can be fixed (like '12.00500'), which
        // helps to debounce when when moving label.
        precision: opt.precision
    });
    var formatter = opt.formatter;
    if (formatter) {
        var params_1 = {
            value: $2d646e51cc34f840$export$a5a32f324c1fa457(axis, {
                value: value
            }),
            axisDimension: axis.dim,
            axisIndex: axis.index,
            seriesData: []
        };
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(seriesDataIndices, function(idxItem) {
            var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
            var dataIndex = idxItem.dataIndexInside;
            var dataParams = series && series.getDataParams(dataIndex);
            dataParams && params_1.seriesData.push(dataParams);
        });
        if ($7a1bd9c2710fea0d$export$844ec244b1367d54(formatter)) text = formatter.replace('{value}', text);
        else if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(formatter)) text = formatter(params_1);
    }
    return text;
}
function $51dec70890757374$export$4bb66440324c3a3d(axis, value, layoutInfo) {
    var transform = $f41ebb9dd60b55b4$export$185802fd694ee1f5();
    $f41ebb9dd60b55b4$export$bb628a54ab399bc9(transform, transform, layoutInfo.rotation);
    $f41ebb9dd60b55b4$export$d73ee8ef04f5226a(transform, transform, layoutInfo.position);
    return $5b455ae6f843ac47$export$9f9dcb98c894b623([
        axis.dataToCoord(value),
        (layoutInfo.labelOffset || 0) + (layoutInfo.labelDirection || 1) * (layoutInfo.labelMargin || 0)
    ], transform);
}
function $51dec70890757374$export$fd3eb3812211a173(value, elOption, layoutInfo, axisModel, axisPointerModel, api) {
    // @ts-ignore
    var textLayout = (0, $dfe15f745e1c3c2b$export$2e2bcd8739ae039).innerTextLayout(layoutInfo.rotation, 0, layoutInfo.labelDirection);
    layoutInfo.labelMargin = axisPointerModel.get([
        'label',
        'margin'
    ]);
    $51dec70890757374$export$8206a9937c45910f(elOption, axisModel, axisPointerModel, api, {
        position: $51dec70890757374$export$4bb66440324c3a3d(axisModel.axis, value, layoutInfo),
        align: textLayout.textAlign,
        verticalAlign: textLayout.textVerticalAlign
    });
}
function $51dec70890757374$export$885fa0ad5a826207(p1, p2, xDimIndex) {
    xDimIndex = xDimIndex || 0;
    return {
        x1: p1[xDimIndex],
        y1: p1[1 - xDimIndex],
        x2: p2[xDimIndex],
        y2: p2[1 - xDimIndex]
    };
}
function $51dec70890757374$export$a8b35248bcc02756(xy, wh, xDimIndex) {
    xDimIndex = xDimIndex || 0;
    return {
        x: xy[xDimIndex],
        y: xy[1 - xDimIndex],
        width: wh[xDimIndex],
        height: wh[1 - xDimIndex]
    };
}
function $51dec70890757374$export$b0cf82e7ebc0d7d0(cx, cy, r0, r, startAngle, endAngle) {
    return {
        cx: cx,
        cy: cy,
        r0: r0,
        r: r,
        startAngle: startAngle,
        endAngle: endAngle,
        clockwise: true
    };
}



var $044c80eefb03ac3d$var$CartesianAxisPointer = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(CartesianAxisPointer, _super);
    function CartesianAxisPointer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
   * @override
   */ CartesianAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {
        var axis = axisModel.axis;
        var grid = axis.grid;
        var axisPointerType = axisPointerModel.get('type');
        var otherExtent = $044c80eefb03ac3d$var$getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
        var pixelValue = axis.toGlobalCoord(axis.dataToCoord(value, true));
        if (axisPointerType && axisPointerType !== 'none') {
            var elStyle = $51dec70890757374$export$b7fe459c7cc50060(axisPointerModel);
            var pointerOption = $044c80eefb03ac3d$var$pointerShapeBuilder[axisPointerType](axis, pixelValue, otherExtent);
            pointerOption.style = elStyle;
            elOption.graphicKey = pointerOption.type;
            elOption.pointer = pointerOption;
        }
        var layoutInfo = $88c937c9bc0ca068$export$b3219800bda33a1f(grid.model, axisModel);
        $51dec70890757374$export$fd3eb3812211a173(// @ts-ignore
        value, elOption, layoutInfo, axisModel, axisPointerModel, api);
    };
    /**
   * @override
   */ CartesianAxisPointer.prototype.getHandleTransform = function(value, axisModel, axisPointerModel) {
        var layoutInfo = $88c937c9bc0ca068$export$b3219800bda33a1f(axisModel.axis.grid.model, axisModel, {
            labelInside: false
        });
        // @ts-ignore
        layoutInfo.labelMargin = axisPointerModel.get([
            'handle',
            'margin'
        ]);
        var pos = $51dec70890757374$export$4bb66440324c3a3d(axisModel.axis, value, layoutInfo);
        return {
            x: pos[0],
            y: pos[1],
            rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
        };
    };
    /**
   * @override
   */ CartesianAxisPointer.prototype.updateHandleTransform = function(transform, delta, axisModel, axisPointerModel) {
        var axis = axisModel.axis;
        var grid = axis.grid;
        var axisExtent = axis.getGlobalExtent(true);
        var otherExtent = $044c80eefb03ac3d$var$getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
        var dimIndex = axis.dim === 'x' ? 0 : 1;
        var currPosition = [
            transform.x,
            transform.y
        ];
        currPosition[dimIndex] += delta[dimIndex];
        currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
        currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
        var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
        var cursorPoint = [
            cursorOtherValue,
            cursorOtherValue
        ];
        cursorPoint[dimIndex] = currPosition[dimIndex];
        // Make tooltip do not overlap axisPointer and in the middle of the grid.
        var tooltipOptions = [
            {
                verticalAlign: 'middle'
            },
            {
                align: 'center'
            }
        ];
        return {
            x: currPosition[0],
            y: currPosition[1],
            rotation: transform.rotation,
            cursorPoint: cursorPoint,
            tooltipOption: tooltipOptions[dimIndex]
        };
    };
    return CartesianAxisPointer;
}((0, $a331d7a6c631e6d9$export$2e2bcd8739ae039));
function $044c80eefb03ac3d$var$getCartesian(grid, axis) {
    var opt = {};
    opt[axis.dim + 'AxisIndex'] = axis.index;
    return grid.getCartesian(opt);
}
var $044c80eefb03ac3d$var$pointerShapeBuilder = {
    line: function(axis, pixelValue, otherExtent) {
        var targetShape = $51dec70890757374$export$885fa0ad5a826207([
            pixelValue,
            otherExtent[0]
        ], [
            pixelValue,
            otherExtent[1]
        ], $044c80eefb03ac3d$var$getAxisDimIndex(axis));
        return {
            type: 'Line',
            subPixelOptimize: true,
            shape: targetShape
        };
    },
    shadow: function(axis, pixelValue, otherExtent) {
        var bandWidth = Math.max(1, axis.getBandWidth());
        var span = otherExtent[1] - otherExtent[0];
        return {
            type: 'Rect',
            shape: $51dec70890757374$export$a8b35248bcc02756([
                pixelValue - bandWidth / 2,
                otherExtent[0]
            ], [
                bandWidth,
                span
            ], $044c80eefb03ac3d$var$getAxisDimIndex(axis))
        };
    }
};
function $044c80eefb03ac3d$var$getAxisDimIndex(axis) {
    return axis.dim === 'x' ? 0 : 1;
}
var $044c80eefb03ac3d$export$2e2bcd8739ae039 = $044c80eefb03ac3d$var$CartesianAxisPointer;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $f55b7040bd1041c6$var$AxisPointerModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(AxisPointerModel, _super);
    function AxisPointerModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AxisPointerModel.type;
        return _this;
    }
    AxisPointerModel.type = 'axisPointer';
    AxisPointerModel.defaultOption = {
        // 'auto' means that show when triggered by tooltip or handle.
        show: 'auto',
        // zlevel: 0,
        z: 50,
        type: 'line',
        // axispointer triggered by tootip determine snap automatically,
        // see `modelHelper`.
        snap: false,
        triggerTooltip: true,
        triggerEmphasis: true,
        value: null,
        status: null,
        link: [],
        // Do not set 'auto' here, otherwise global animation: false
        // will not effect at this axispointer.
        animation: null,
        animationDurationUpdate: 200,
        lineStyle: {
            color: '#B9BEC9',
            width: 1,
            type: 'dashed'
        },
        shadowStyle: {
            color: 'rgba(210,219,238,0.2)'
        },
        label: {
            show: true,
            formatter: null,
            precision: 'auto',
            margin: 3,
            color: '#fff',
            padding: [
                5,
                7,
                5,
                7
            ],
            backgroundColor: 'auto',
            borderColor: null,
            borderWidth: 0,
            borderRadius: 3
        },
        handle: {
            show: false,
            // eslint-disable-next-line
            icon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7v-1.2h6.6z M13.3,22H6.7v-1.2h6.6z M13.3,19.6H6.7v-1.2h6.6z',
            size: 45,
            // handle margin is from symbol center to axis, which is stable when circular move.
            margin: 50,
            // color: '#1b8bbd'
            // color: '#2f4554'
            color: '#333',
            shadowBlur: 3,
            shadowColor: '#aaa',
            shadowOffsetX: 0,
            shadowOffsetY: 2,
            // For mobile performance
            throttle: 40
        }
    };
    return AxisPointerModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $f55b7040bd1041c6$export$2e2bcd8739ae039 = $f55b7040bd1041c6$var$AxisPointerModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $84450f5aa7fbde00$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $84450f5aa7fbde00$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
function $84450f5aa7fbde00$export$6503ec6e8aabbaf(key, api, handler) {
    if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).node) return;
    var zr = api.getZr();
    $84450f5aa7fbde00$var$inner(zr).records || ($84450f5aa7fbde00$var$inner(zr).records = {});
    $84450f5aa7fbde00$var$initGlobalListeners(zr, api);
    var record = $84450f5aa7fbde00$var$inner(zr).records[key] || ($84450f5aa7fbde00$var$inner(zr).records[key] = {});
    record.handler = handler;
}
function $84450f5aa7fbde00$var$initGlobalListeners(zr, api) {
    if ($84450f5aa7fbde00$var$inner(zr).initialized) return;
    $84450f5aa7fbde00$var$inner(zr).initialized = true;
    useHandler('click', $7a1bd9c2710fea0d$export$c3095a23b368d1f2($84450f5aa7fbde00$var$doEnter, 'click'));
    useHandler('mousemove', $7a1bd9c2710fea0d$export$c3095a23b368d1f2($84450f5aa7fbde00$var$doEnter, 'mousemove'));
    // useHandler('mouseout', onLeave);
    useHandler('globalout', $84450f5aa7fbde00$var$onLeave);
    function useHandler(eventType, cb) {
        zr.on(eventType, function(e) {
            var dis = $84450f5aa7fbde00$var$makeDispatchAction(api);
            $84450f5aa7fbde00$var$each($84450f5aa7fbde00$var$inner(zr).records, function(record) {
                record && cb(record, e, dis.dispatchAction);
            });
            $84450f5aa7fbde00$var$dispatchTooltipFinally(dis.pendings, api);
        });
    }
}
function $84450f5aa7fbde00$var$dispatchTooltipFinally(pendings, api) {
    var showLen = pendings.showTip.length;
    var hideLen = pendings.hideTip.length;
    var actuallyPayload;
    if (showLen) actuallyPayload = pendings.showTip[showLen - 1];
    else if (hideLen) actuallyPayload = pendings.hideTip[hideLen - 1];
    if (actuallyPayload) {
        actuallyPayload.dispatchAction = null;
        api.dispatchAction(actuallyPayload);
    }
}
function $84450f5aa7fbde00$var$onLeave(record, e, dispatchAction) {
    record.handler('leave', null, dispatchAction);
}
function $84450f5aa7fbde00$var$doEnter(currTrigger, record, e, dispatchAction) {
    record.handler(currTrigger, e, dispatchAction);
}
function $84450f5aa7fbde00$var$makeDispatchAction(api) {
    var pendings = {
        showTip: [],
        hideTip: []
    };
    // FIXME
    // better approach?
    // 'showTip' and 'hideTip' can be triggered by axisPointer and tooltip,
    // which may be conflict, (axisPointer call showTip but tooltip call hideTip);
    // So we have to add "final stage" to merge those dispatched actions.
    var dispatchAction = function(payload) {
        var pendingList = pendings[payload.type];
        if (pendingList) pendingList.push(payload);
        else {
            payload.dispatchAction = dispatchAction;
            api.dispatchAction(payload);
        }
    };
    return {
        dispatchAction: dispatchAction,
        pendings: pendings
    };
}
function $84450f5aa7fbde00$export$d07f55d4c15c0440(key, api) {
    if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).node) return;
    var zr = api.getZr();
    var record = ($84450f5aa7fbde00$var$inner(zr).records || {})[key];
    if (record) $84450f5aa7fbde00$var$inner(zr).records[key] = null;
}



var $615cfe2d5ef5fcce$var$AxisPointerView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(AxisPointerView, _super);
    function AxisPointerView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AxisPointerView.type;
        return _this;
    }
    AxisPointerView.prototype.render = function(globalAxisPointerModel, ecModel, api) {
        var globalTooltipModel = ecModel.getComponent('tooltip');
        var triggerOn = globalAxisPointerModel.get('triggerOn') || globalTooltipModel && globalTooltipModel.get('triggerOn') || 'mousemove|click';
        // Register global listener in AxisPointerView to enable
        // AxisPointerView to be independent to Tooltip.
        $84450f5aa7fbde00$export$6503ec6e8aabbaf('axisPointer', api, function(currTrigger, e, dispatchAction) {
            // If 'none', it is not controlled by mouse totally.
            if (triggerOn !== 'none' && (currTrigger === 'leave' || triggerOn.indexOf(currTrigger) >= 0)) dispatchAction({
                type: 'updateAxisPointer',
                currTrigger: currTrigger,
                x: e && e.offsetX,
                y: e && e.offsetY
            });
        });
    };
    AxisPointerView.prototype.remove = function(ecModel, api) {
        $84450f5aa7fbde00$export$d07f55d4c15c0440('axisPointer', api);
    };
    AxisPointerView.prototype.dispose = function(ecModel, api) {
        $84450f5aa7fbde00$export$d07f55d4c15c0440('axisPointer', api);
    };
    AxisPointerView.type = 'axisPointer';
    return AxisPointerView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $615cfe2d5ef5fcce$export$2e2bcd8739ae039 = $615cfe2d5ef5fcce$var$AxisPointerView;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $4cab5d8b3532dad5$export$2e2bcd8739ae039(finder, ecModel) {
    var point = [];
    var seriesIndex = finder.seriesIndex;
    var seriesModel;
    if (seriesIndex == null || !(seriesModel = ecModel.getSeriesByIndex(seriesIndex))) return {
        point: []
    };
    var data = seriesModel.getData();
    var dataIndex = $76d619f648247e6d$export$42b26cae8b8d10(data, finder);
    if (dataIndex == null || dataIndex < 0 || $7a1bd9c2710fea0d$export$43bee75e5e14138e(dataIndex)) return {
        point: []
    };
    var el = data.getItemGraphicEl(dataIndex);
    var coordSys = seriesModel.coordinateSystem;
    if (seriesModel.getTooltipPosition) point = seriesModel.getTooltipPosition(dataIndex) || [];
    else if (coordSys && coordSys.dataToPoint) {
        if (finder.isStacked) {
            var baseAxis = coordSys.getBaseAxis();
            var valueAxis = coordSys.getOtherAxis(baseAxis);
            var valueAxisDim = valueAxis.dim;
            var baseAxisDim = baseAxis.dim;
            var baseDataOffset = valueAxisDim === 'x' || valueAxisDim === 'radius' ? 1 : 0;
            var baseDim = data.mapDimension(baseAxisDim);
            var stackedData = [];
            stackedData[baseDataOffset] = data.get(baseDim, dataIndex);
            stackedData[1 - baseDataOffset] = data.get(data.getCalculationInfo('stackResultDimension'), dataIndex);
            point = coordSys.dataToPoint(stackedData) || [];
        } else point = coordSys.dataToPoint(data.getValues($7a1bd9c2710fea0d$export$871de8747c9eaa88(coordSys.dimensions, function(dim) {
            return data.mapDimension(dim);
        }), dataIndex)) || [];
    } else if (el) {
        // Use graphic bounding rect
        var rect = el.getBoundingRect().clone();
        rect.applyTransform(el.transform);
        point = [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
    }
    return {
        point: point,
        el: el
    };
}



var $1cb2191f8bc71b5b$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $1cb2191f8bc71b5b$export$2e2bcd8739ae039(payload, ecModel, api) {
    var currTrigger = payload.currTrigger;
    var point = [
        payload.x,
        payload.y
    ];
    var finder = payload;
    var dispatchAction = payload.dispatchAction || (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(api.dispatchAction, api);
    var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo;
    // Pending
    // See #6121. But we are not able to reproduce it yet.
    if (!coordSysAxesInfo) return;
    if ($1cb2191f8bc71b5b$var$illegalPoint(point)) // Used in the default behavior of `connection`: use the sample seriesIndex
    // and dataIndex. And also used in the tooltipView trigger.
    point = (0, $4cab5d8b3532dad5$export$2e2bcd8739ae039)({
        seriesIndex: finder.seriesIndex,
        // Do not use dataIndexInside from other ec instance.
        // FIXME: auto detect it?
        dataIndex: finder.dataIndex
    }, ecModel).point;
    var isIllegalPoint = $1cb2191f8bc71b5b$var$illegalPoint(point);
    // Axis and value can be specified when calling dispatchAction({type: 'updateAxisPointer'}).
    // Notice: In this case, it is difficult to get the `point` (which is necessary to show
    // tooltip, so if point is not given, we just use the point found by sample seriesIndex
    // and dataIndex.
    var inputAxesInfo = finder.axesInfo;
    var axesInfo = coordSysAxesInfo.axesInfo;
    var shouldHide = currTrigger === 'leave' || $1cb2191f8bc71b5b$var$illegalPoint(point);
    var outputPayload = {};
    var showValueMap = {};
    var dataByCoordSys = {
        list: [],
        map: {}
    };
    var updaters = {
        showPointer: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($1cb2191f8bc71b5b$var$showPointer, showValueMap),
        showTooltip: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($1cb2191f8bc71b5b$var$showTooltip, dataByCoordSys)
    };
    // Process for triggered axes.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(coordSysAxesInfo.coordSysMap, function(coordSys, coordSysKey) {
        // If a point given, it must be contained by the coordinate system.
        var coordSysContainsPoint = isIllegalPoint || coordSys.containPoint(point);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(coordSysAxesInfo.coordSysAxesInfo[coordSysKey], function(axisInfo, key) {
            var axis = axisInfo.axis;
            var inputAxisInfo = $1cb2191f8bc71b5b$var$findInputAxisInfo(inputAxesInfo, axisInfo);
            // If no inputAxesInfo, no axis is restricted.
            if (!shouldHide && coordSysContainsPoint && (!inputAxesInfo || inputAxisInfo)) {
                var val = inputAxisInfo && inputAxisInfo.value;
                if (val == null && !isIllegalPoint) val = axis.pointToData(point);
                val != null && $1cb2191f8bc71b5b$var$processOnAxis(axisInfo, val, updaters, false, outputPayload);
            }
        });
    });
    // Process for linked axes.
    var linkTriggers = {};
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axesInfo, function(tarAxisInfo, tarKey) {
        var linkGroup = tarAxisInfo.linkGroup;
        // If axis has been triggered in the previous stage, it should not be triggered by link.
        if (linkGroup && !showValueMap[tarKey]) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(linkGroup.axesInfo, function(srcAxisInfo, srcKey) {
            var srcValItem = showValueMap[srcKey];
            // If srcValItem exist, source axis is triggered, so link to target axis.
            if (srcAxisInfo !== tarAxisInfo && srcValItem) {
                var val = srcValItem.value;
                linkGroup.mapper && (val = tarAxisInfo.axis.scale.parse(linkGroup.mapper(val, $1cb2191f8bc71b5b$var$makeMapperParam(srcAxisInfo), $1cb2191f8bc71b5b$var$makeMapperParam(tarAxisInfo))));
                linkTriggers[tarAxisInfo.key] = val;
            }
        });
    });
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(linkTriggers, function(val, tarKey) {
        $1cb2191f8bc71b5b$var$processOnAxis(axesInfo[tarKey], val, updaters, true, outputPayload);
    });
    $1cb2191f8bc71b5b$var$updateModelActually(showValueMap, axesInfo, outputPayload);
    $1cb2191f8bc71b5b$var$dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction);
    $1cb2191f8bc71b5b$var$dispatchHighDownActually(axesInfo, dispatchAction, api);
    return outputPayload;
}
function $1cb2191f8bc71b5b$var$processOnAxis(axisInfo, newValue, updaters, noSnap, outputFinder) {
    var axis = axisInfo.axis;
    if (axis.scale.isBlank() || !axis.containData(newValue)) return;
    if (!axisInfo.involveSeries) {
        updaters.showPointer(axisInfo, newValue);
        return;
    }
    // Heavy calculation. So put it after axis.containData checking.
    var payloadInfo = $1cb2191f8bc71b5b$var$buildPayloadsBySeries(newValue, axisInfo);
    var payloadBatch = payloadInfo.payloadBatch;
    var snapToValue = payloadInfo.snapToValue;
    // Fill content of event obj for echarts.connect.
    // By default use the first involved series data as a sample to connect.
    if (payloadBatch[0] && outputFinder.seriesIndex == null) (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(outputFinder, payloadBatch[0]);
    // If no linkSource input, this process is for collecting link
    // target, where snap should not be accepted.
    if (!noSnap && axisInfo.snap) {
        if (axis.containData(snapToValue) && snapToValue != null) newValue = snapToValue;
    }
    updaters.showPointer(axisInfo, newValue, payloadBatch);
    // Tooltip should always be snapToValue, otherwise there will be
    // incorrect "axis value ~ series value" mapping displayed in tooltip.
    updaters.showTooltip(axisInfo, payloadInfo, snapToValue);
}
function $1cb2191f8bc71b5b$var$buildPayloadsBySeries(value, axisInfo) {
    var axis = axisInfo.axis;
    var dim = axis.dim;
    var snapToValue = value;
    var payloadBatch = [];
    var minDist = Number.MAX_VALUE;
    var minDiff = -1;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axisInfo.seriesModels, function(series, idx) {
        var dataDim = series.getData().mapDimensionsAll(dim);
        var seriesNestestValue;
        var dataIndices;
        if (series.getAxisTooltipData) {
            var result = series.getAxisTooltipData(dataDim, value, axis);
            dataIndices = result.dataIndices;
            seriesNestestValue = result.nestestValue;
        } else {
            dataIndices = series.getData().indicesOfNearest(dataDim[0], value, // Add a threshold to avoid find the wrong dataIndex
            // when data length is not same.
            // false,
            axis.type === 'category' ? 0.5 : null);
            if (!dataIndices.length) return;
            seriesNestestValue = series.getData().get(dataDim[0], dataIndices[0]);
        }
        if (seriesNestestValue == null || !isFinite(seriesNestestValue)) return;
        var diff = value - seriesNestestValue;
        var dist = Math.abs(diff);
        // Consider category case
        if (dist <= minDist) {
            if (dist < minDist || diff >= 0 && minDiff < 0) {
                minDist = dist;
                minDiff = diff;
                snapToValue = seriesNestestValue;
                payloadBatch.length = 0;
            }
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dataIndices, function(dataIndex) {
                payloadBatch.push({
                    seriesIndex: series.seriesIndex,
                    dataIndexInside: dataIndex,
                    dataIndex: series.getData().getRawIndex(dataIndex)
                });
            });
        }
    });
    return {
        payloadBatch: payloadBatch,
        snapToValue: snapToValue
    };
}
function $1cb2191f8bc71b5b$var$showPointer(showValueMap, axisInfo, value, payloadBatch) {
    showValueMap[axisInfo.key] = {
        value: value,
        payloadBatch: payloadBatch
    };
}
function $1cb2191f8bc71b5b$var$showTooltip(dataByCoordSys, axisInfo, payloadInfo, value) {
    var payloadBatch = payloadInfo.payloadBatch;
    var axis = axisInfo.axis;
    var axisModel = axis.model;
    var axisPointerModel = axisInfo.axisPointerModel;
    // If no data, do not create anything in dataByCoordSys,
    // whose length will be used to judge whether dispatch action.
    if (!axisInfo.triggerTooltip || !payloadBatch.length) return;
    var coordSysModel = axisInfo.coordSys.model;
    var coordSysKey = $84d826b9ba8bf009$export$d01b444bafb1a792(coordSysModel);
    var coordSysItem = dataByCoordSys.map[coordSysKey];
    if (!coordSysItem) {
        coordSysItem = dataByCoordSys.map[coordSysKey] = {
            coordSysId: coordSysModel.id,
            coordSysIndex: coordSysModel.componentIndex,
            coordSysType: coordSysModel.type,
            coordSysMainType: coordSysModel.mainType,
            dataByAxis: []
        };
        dataByCoordSys.list.push(coordSysItem);
    }
    coordSysItem.dataByAxis.push({
        axisDim: axis.dim,
        axisIndex: axisModel.componentIndex,
        axisType: axisModel.type,
        axisId: axisModel.id,
        value: value,
        // Caustion: viewHelper.getValueLabel is actually on "view stage", which
        // depends that all models have been updated. So it should not be performed
        // here. Considering axisPointerModel used here is volatile, which is hard
        // to be retrieve in TooltipView, we prepare parameters here.
        valueLabelOpt: {
            precision: axisPointerModel.get([
                'label',
                'precision'
            ]),
            formatter: axisPointerModel.get([
                'label',
                'formatter'
            ])
        },
        seriesDataIndices: payloadBatch.slice()
    });
}
function $1cb2191f8bc71b5b$var$updateModelActually(showValueMap, axesInfo, outputPayload) {
    var outputAxesInfo = outputPayload.axesInfo = [];
    // Basic logic: If no 'show' required, 'hide' this axisPointer.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axesInfo, function(axisInfo, key) {
        var option = axisInfo.axisPointerModel.option;
        var valItem = showValueMap[key];
        if (valItem) {
            !axisInfo.useHandle && (option.status = 'show');
            option.value = valItem.value;
            // For label formatter param and highlight.
            option.seriesDataIndices = (valItem.payloadBatch || []).slice();
        } else // If hide, value still need to be set, consider
        // click legend to toggle axis blank.
        !axisInfo.useHandle && (option.status = 'hide');
        // If status is 'hide', should be no info in payload.
        option.status === 'show' && outputAxesInfo.push({
            axisDim: axisInfo.axis.dim,
            axisIndex: axisInfo.axis.model.componentIndex,
            value: option.value
        });
    });
}
function $1cb2191f8bc71b5b$var$dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction) {
    // Basic logic: If no showTip required, hideTip will be dispatched.
    if ($1cb2191f8bc71b5b$var$illegalPoint(point) || !dataByCoordSys.list.length) {
        dispatchAction({
            type: 'hideTip'
        });
        return;
    }
    // In most case only one axis (or event one series is used). It is
    // convenient to fetch payload.seriesIndex and payload.dataIndex
    // directly. So put the first seriesIndex and dataIndex of the first
    // axis on the payload.
    var sampleItem = ((dataByCoordSys.list[0].dataByAxis[0] || {}).seriesDataIndices || [])[0] || {};
    dispatchAction({
        type: 'showTip',
        escapeConnect: true,
        x: point[0],
        y: point[1],
        tooltipOption: payload.tooltipOption,
        position: payload.position,
        dataIndexInside: sampleItem.dataIndexInside,
        dataIndex: sampleItem.dataIndex,
        seriesIndex: sampleItem.seriesIndex,
        dataByCoordSys: dataByCoordSys.list
    });
}
function $1cb2191f8bc71b5b$var$dispatchHighDownActually(axesInfo, dispatchAction, api) {
    // FIXME
    // highlight status modification should be a stage of main process?
    // (Consider confilct (e.g., legend and axisPointer) and setOption)
    var zr = api.getZr();
    var highDownKey = 'axisPointerLastHighlights';
    var lastHighlights = $1cb2191f8bc71b5b$var$inner(zr)[highDownKey] || {};
    var newHighlights = $1cb2191f8bc71b5b$var$inner(zr)[highDownKey] = {};
    // Update highlight/downplay status according to axisPointer model.
    // Build hash map and remove duplicate incidentally.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axesInfo, function(axisInfo, key) {
        var option = axisInfo.axisPointerModel.option;
        option.status === 'show' && axisInfo.triggerEmphasis && (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(option.seriesDataIndices, function(batchItem) {
            var key = batchItem.seriesIndex + ' | ' + batchItem.dataIndex;
            newHighlights[key] = batchItem;
        });
    });
    // Diff.
    var toHighlight = [];
    var toDownplay = [];
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(lastHighlights, function(batchItem, key) {
        !newHighlights[key] && toDownplay.push(batchItem);
    });
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(newHighlights, function(batchItem, key) {
        !lastHighlights[key] && toHighlight.push(batchItem);
    });
    toDownplay.length && api.dispatchAction({
        type: 'downplay',
        escapeConnect: true,
        // Not blur others when highlight in axisPointer.
        notBlur: true,
        batch: toDownplay
    });
    toHighlight.length && api.dispatchAction({
        type: 'highlight',
        escapeConnect: true,
        // Not blur others when highlight in axisPointer.
        notBlur: true,
        batch: toHighlight
    });
}
function $1cb2191f8bc71b5b$var$findInputAxisInfo(inputAxesInfo, axisInfo) {
    for(var i = 0; i < (inputAxesInfo || []).length; i++){
        var inputAxisInfo = inputAxesInfo[i];
        if (axisInfo.axis.dim === inputAxisInfo.axisDim && axisInfo.axis.model.componentIndex === inputAxisInfo.axisIndex) return inputAxisInfo;
    }
}
function $1cb2191f8bc71b5b$var$makeMapperParam(axisInfo) {
    var axisModel = axisInfo.axis.model;
    var item = {};
    var dim = item.axisDim = axisInfo.axis.dim;
    item.axisIndex = item[dim + 'AxisIndex'] = axisModel.componentIndex;
    item.axisName = item[dim + 'AxisName'] = axisModel.name;
    item.axisId = item[dim + 'AxisId'] = axisModel.id;
    return item;
}
function $1cb2191f8bc71b5b$var$illegalPoint(point) {
    return !point || point[0] == null || isNaN(point[0]) || point[1] == null || isNaN(point[1]);
}


function $589507869c21caa1$export$4b3e715f166fdd78(registers) {
    // CartesianAxisPointer is not supposed to be required here. But consider
    // echarts.simple.js and online build tooltip, which only require gridSimple,
    // CartesianAxisPointer should be able to required somewhere.
    (0, $58c48a3ef1aa0746$export$2e2bcd8739ae039).registerAxisPointerClass('CartesianAxisPointer', (0, $044c80eefb03ac3d$export$2e2bcd8739ae039));
    registers.registerComponentModel((0, $f55b7040bd1041c6$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $615cfe2d5ef5fcce$export$2e2bcd8739ae039));
    registers.registerPreprocessor(function(option) {
        // Always has a global axisPointerModel for default setting.
        if (option) {
            (!option.axisPointer || option.axisPointer.length === 0) && (option.axisPointer = {});
            var link = option.axisPointer.link;
            // Normalize to array to avoid object mergin. But if link
            // is not set, remain null/undefined, otherwise it will
            // override existent link setting.
            if (link && !(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(link)) option.axisPointer.link = [
                link
            ];
        }
    });
    // This process should proformed after coordinate systems created
    // and series data processed. So put it on statistic processing stage.
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, function(ecModel, api) {
        // Build axisPointerModel, mergin tooltip.axisPointer model for each axis.
        // allAxesInfo should be updated when setOption performed.
        ecModel.getComponent('axisPointer').coordSysAxesInfo = (0, $84d826b9ba8bf009$export$bb44f104e3c54dae)(ecModel, api);
    });
    // Broadcast to all views.
    registers.registerAction({
        type: 'updateAxisPointer',
        event: 'updateAxisPointer',
        update: ':updateAxisPointer'
    }, (0, $1cb2191f8bc71b5b$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $860dd9ca08385e85$var$DEFAULT_TOOLBOX_BTNS = [
    'rect',
    'polygon',
    'keep',
    'clear'
];
function $860dd9ca08385e85$export$2e2bcd8739ae039(option, isNew) {
    var brushComponents = (0, $76d619f648247e6d$export$4f07b212a02c8051)(option ? option.brush : []);
    if (!brushComponents.length) return;
    var brushComponentSpecifiedBtns = [];
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(brushComponents, function(brushOpt) {
        var tbs = brushOpt.hasOwnProperty('toolbox') ? brushOpt.toolbox : [];
        if (tbs instanceof Array) brushComponentSpecifiedBtns = brushComponentSpecifiedBtns.concat(tbs);
    });
    var toolbox = option && option.toolbox;
    if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(toolbox)) toolbox = toolbox[0];
    if (!toolbox) {
        toolbox = {
            feature: {}
        };
        option.toolbox = [
            toolbox
        ];
    }
    var toolboxFeature = toolbox.feature || (toolbox.feature = {});
    var toolboxBrush = toolboxFeature.brush || (toolboxFeature.brush = {});
    var brushTypes = toolboxBrush.type || (toolboxBrush.type = []);
    brushTypes.push.apply(brushTypes, brushComponentSpecifiedBtns);
    $860dd9ca08385e85$var$removeDuplicate(brushTypes);
    if (isNew && !brushTypes.length) brushTypes.push.apply(brushTypes, $860dd9ca08385e85$var$DEFAULT_TOOLBOX_BTNS);
}
function $860dd9ca08385e85$var$removeDuplicate(arr) {
    var map = {};
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(arr, function(val) {
        map[val] = 1;
    });
    arr.length = 0;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(map, function(flag, val) {
        arr.push(val);
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @file Visual solution, for consistent option specification.
 */ 


var $87ea23222d1c134e$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
function $87ea23222d1c134e$var$hasKeys(obj) {
    if (obj) for(var name_1 in obj){
        if (obj.hasOwnProperty(name_1)) return true;
    }
}
function $87ea23222d1c134e$export$89974527642f24a0(option, stateList, supplementVisualOption) {
    var visualMappings = {};
    $87ea23222d1c134e$var$each(stateList, function(state) {
        var mappings = visualMappings[state] = createMappings();
        $87ea23222d1c134e$var$each(option[state], function(visualData, visualType) {
            if (!(0, $7b50f502cfd189d5$export$2e2bcd8739ae039).isValidType(visualType)) return;
            var mappingOption = {
                type: visualType,
                visual: visualData
            };
            supplementVisualOption && supplementVisualOption(mappingOption, state);
            mappings[visualType] = new (0, $7b50f502cfd189d5$export$2e2bcd8739ae039)(mappingOption);
            // Prepare a alpha for opacity, for some case that opacity
            // is not supported, such as rendering using gradient color.
            if (visualType === 'opacity') {
                mappingOption = $7a1bd9c2710fea0d$export$9cd59f9826255e47(mappingOption);
                mappingOption.type = 'colorAlpha';
                mappings.__hidden.__alphaForOpacity = new (0, $7b50f502cfd189d5$export$2e2bcd8739ae039)(mappingOption);
            }
        });
    });
    return visualMappings;
    function createMappings() {
        var Creater = function() {};
        // Make sure hidden fields will not be visited by
        // object iteration (with hasOwnProperty checking).
        Creater.prototype.__hidden = Creater.prototype;
        var obj = new Creater();
        return obj;
    }
}
function $87ea23222d1c134e$export$797d20c0a6de578f(thisOption, newOption, keys) {
    // Visual attributes merge is not supported, otherwise it
    // brings overcomplicated merge logic. See #2853. So if
    // newOption has anyone of these keys, all of these keys
    // will be reset. Otherwise, all keys remain.
    var has;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(keys, function(key) {
        if (newOption.hasOwnProperty(key) && $87ea23222d1c134e$var$hasKeys(newOption[key])) has = true;
    });
    has && $7a1bd9c2710fea0d$export$79b2f7037acddd43(keys, function(key) {
        if (newOption.hasOwnProperty(key) && $87ea23222d1c134e$var$hasKeys(newOption[key])) thisOption[key] = $7a1bd9c2710fea0d$export$9cd59f9826255e47(newOption[key]);
        else delete thisOption[key];
    });
}
function $87ea23222d1c134e$export$bb1ef43951d58629(stateList, visualMappings, data, getValueState, scope, dimension) {
    var visualTypesMap = {};
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(stateList, function(state) {
        var visualTypes = (0, $7b50f502cfd189d5$export$2e2bcd8739ae039).prepareVisualTypes(visualMappings[state]);
        visualTypesMap[state] = visualTypes;
    });
    var dataIndex;
    function getVisual(key) {
        return (0, $ea13f1ab2169d82d$export$91d919a86b2df624)(data, dataIndex, key);
    }
    function setVisual(key, value) {
        (0, $ea13f1ab2169d82d$export$3aab879e9d0e7c75)(data, dataIndex, key, value);
    }
    if (dimension == null) data.each(eachItem);
    else data.each([
        dimension
    ], eachItem);
    function eachItem(valueOrIndex, index) {
        dataIndex = dimension == null ? valueOrIndex // First argument is index
         : index;
        var rawDataItem = data.getRawDataItem(dataIndex);
        // Consider performance
        // @ts-ignore
        if (rawDataItem && rawDataItem.visualMap === false) return;
        var valueState = getValueState.call(scope, valueOrIndex);
        var mappings = visualMappings[valueState];
        var visualTypes = visualTypesMap[valueState];
        for(var i = 0, len = visualTypes.length; i < len; i++){
            var type = visualTypes[i];
            mappings[type] && mappings[type].applyVisual(valueOrIndex, getVisual, setVisual);
        }
    }
}
function $87ea23222d1c134e$export$fc0ef8703cccf128(stateList, visualMappings, getValueState, dim) {
    var visualTypesMap = {};
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(stateList, function(state) {
        var visualTypes = (0, $7b50f502cfd189d5$export$2e2bcd8739ae039).prepareVisualTypes(visualMappings[state]);
        visualTypesMap[state] = visualTypes;
    });
    return {
        progress: function progress(params, data) {
            var dimIndex;
            if (dim != null) dimIndex = data.getDimensionIndex(dim);
            function getVisual(key) {
                return (0, $ea13f1ab2169d82d$export$91d919a86b2df624)(data, dataIndex, key);
            }
            function setVisual(key, value) {
                (0, $ea13f1ab2169d82d$export$3aab879e9d0e7c75)(data, dataIndex, key, value);
            }
            var dataIndex;
            var store = data.getStore();
            while((dataIndex = params.next()) != null){
                var rawDataItem = data.getRawDataItem(dataIndex);
                // Consider performance
                // @ts-ignore
                if (rawDataItem && rawDataItem.visualMap === false) continue;
                var value = dim != null ? store.get(dimIndex, dataIndex) : dataIndex;
                var valueState = getValueState(value);
                var mappings = visualMappings[valueState];
                var visualTypes = visualTypesMap[valueState];
                for(var i = 0, len = visualTypes.length; i < len; i++){
                    var type = visualTypes[i];
                    mappings[type] && mappings[type].applyVisual(value, getVisual, setVisual);
                }
            }
        }
    };
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $431fae42b264171b$export$2225cfa0a999c142(area) {
    var brushType = area.brushType;
    // Do not use function binding or curry for performance.
    var selectors = {
        point: function(itemLayout) {
            return $431fae42b264171b$var$selector[brushType].point(itemLayout, selectors, area);
        },
        rect: function(itemLayout) {
            return $431fae42b264171b$var$selector[brushType].rect(itemLayout, selectors, area);
        }
    };
    return selectors;
}
var $431fae42b264171b$var$selector = {
    lineX: $431fae42b264171b$var$getLineSelectors(0),
    lineY: $431fae42b264171b$var$getLineSelectors(1),
    rect: {
        point: function(itemLayout, selectors, area) {
            return itemLayout && area.boundingRect.contain(itemLayout[0], itemLayout[1]);
        },
        rect: function(itemLayout, selectors, area) {
            return itemLayout && area.boundingRect.intersect(itemLayout);
        }
    },
    polygon: {
        point: function(itemLayout, selectors, area) {
            return itemLayout && area.boundingRect.contain(itemLayout[0], itemLayout[1]) && $b4726ec5f917394d$export$8893e2b90ba10d92(area.range, itemLayout[0], itemLayout[1]);
        },
        rect: function(itemLayout, selectors, area) {
            var points = area.range;
            if (!itemLayout || points.length <= 1) return false;
            var x = itemLayout.x;
            var y = itemLayout.y;
            var width = itemLayout.width;
            var height = itemLayout.height;
            var p = points[0];
            if ($b4726ec5f917394d$export$8893e2b90ba10d92(points, x, y) || $b4726ec5f917394d$export$8893e2b90ba10d92(points, x + width, y) || $b4726ec5f917394d$export$8893e2b90ba10d92(points, x, y + height) || $b4726ec5f917394d$export$8893e2b90ba10d92(points, x + width, y + height) || (0, $1bebe7106c895823$export$2e2bcd8739ae039).create(itemLayout).contain(p[0], p[1]) || (0, $5b455ae6f843ac47$export$4f47c855a5e9ae9)(x, y, x + width, y, points) || (0, $5b455ae6f843ac47$export$4f47c855a5e9ae9)(x, y, x, y + height, points) || (0, $5b455ae6f843ac47$export$4f47c855a5e9ae9)(x + width, y, x + width, y + height, points) || (0, $5b455ae6f843ac47$export$4f47c855a5e9ae9)(x, y + height, x + width, y + height, points)) return true;
        }
    }
};
function $431fae42b264171b$var$getLineSelectors(xyIndex) {
    var xy = [
        'x',
        'y'
    ];
    var wh = [
        'width',
        'height'
    ];
    return {
        point: function(itemLayout, selectors, area) {
            if (itemLayout) {
                var range = area.range;
                var p = itemLayout[xyIndex];
                return $431fae42b264171b$var$inLineRange(p, range);
            }
        },
        rect: function(itemLayout, selectors, area) {
            if (itemLayout) {
                var range = area.range;
                var layoutRange = [
                    itemLayout[xy[xyIndex]],
                    itemLayout[xy[xyIndex]] + itemLayout[wh[xyIndex]]
                ];
                layoutRange[1] < layoutRange[0] && layoutRange.reverse();
                return $431fae42b264171b$var$inLineRange(layoutRange[0], range) || $431fae42b264171b$var$inLineRange(layoutRange[1], range) || $431fae42b264171b$var$inLineRange(range[0], layoutRange) || $431fae42b264171b$var$inLineRange(range[1], layoutRange);
            }
        }
    };
}
function $431fae42b264171b$var$inLineRange(p, range) {
    return range[0] <= p && p <= range[1];
}
var $431fae42b264171b$export$2e2bcd8739ae039 = $431fae42b264171b$var$selector;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



// FIXME
// how to genarialize to more coordinate systems.
var $6213fed8aa63fab1$var$INCLUDE_FINDER_MAIN_TYPES = [
    'grid',
    'xAxis',
    'yAxis',
    'geo',
    'graph',
    'polar',
    'radiusAxis',
    'angleAxis',
    'bmap'
];
var $6213fed8aa63fab1$var$BrushTargetManager = /** @class */ function() {
    /**
   * @param finder contains Index/Id/Name of xAxis/yAxis/geo/grid
   *        Each can be {number|Array.<number>}. like: {xAxisIndex: [3, 4]}
   * @param opt.include include coordinate system types.
   */ function BrushTargetManager(finder, ecModel, opt) {
        var _this = this;
        this._targetInfoList = [];
        var foundCpts = $6213fed8aa63fab1$var$parseFinder(ecModel, finder);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($6213fed8aa63fab1$var$targetInfoBuilders, function(builder, type) {
            if (!opt || !opt.include || (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(opt.include, type) >= 0) builder(foundCpts, _this._targetInfoList);
        });
    }
    BrushTargetManager.prototype.setOutputRanges = function(areas, ecModel) {
        this.matchOutputRanges(areas, ecModel, function(area, coordRange, coordSys) {
            (area.coordRanges || (area.coordRanges = [])).push(coordRange);
            // area.coordRange is the first of area.coordRanges
            if (!area.coordRange) {
                area.coordRange = coordRange;
                // In 'category' axis, coord to pixel is not reversible, so we can not
                // rebuild range by coordRange accrately, which may bring trouble when
                // brushing only one item. So we use __rangeOffset to rebuilding range
                // by coordRange. And this it only used in brush component so it is no
                // need to be adapted to coordRanges.
                var result = $6213fed8aa63fab1$var$coordConvert[area.brushType](0, coordSys, coordRange);
                area.__rangeOffset = {
                    offset: $6213fed8aa63fab1$var$diffProcessor[area.brushType](result.values, area.range, [
                        1,
                        1
                    ]),
                    xyMinMax: result.xyMinMax
                };
            }
        });
        return areas;
    };
    BrushTargetManager.prototype.matchOutputRanges = function(areas, ecModel, cb) {
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(areas, function(area) {
            var targetInfo = this.findTargetInfo(area, ecModel);
            if (targetInfo && targetInfo !== true) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(targetInfo.coordSyses, function(coordSys) {
                var result = $6213fed8aa63fab1$var$coordConvert[area.brushType](1, coordSys, area.range, true);
                cb(area, result.values, coordSys, ecModel);
            });
        }, this);
    };
    /**
   * the `areas` is `BrushModel.areas`.
   * Called in layout stage.
   * convert `area.coordRange` to global range and set panelId to `area.range`.
   */ BrushTargetManager.prototype.setInputRanges = function(areas, ecModel) {
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(areas, function(area) {
            var targetInfo = this.findTargetInfo(area, ecModel);
            area.range = area.range || [];
            // convert coordRange to global range and set panelId.
            if (targetInfo && targetInfo !== true) {
                area.panelId = targetInfo.panelId;
                // (1) area.range should always be calculate from coordRange but does
                // not keep its original value, for the sake of the dataZoom scenario,
                // where area.coordRange remains unchanged but area.range may be changed.
                // (2) Only support converting one coordRange to pixel range in brush
                // component. So do not consider `coordRanges`.
                // (3) About __rangeOffset, see comment above.
                var result = $6213fed8aa63fab1$var$coordConvert[area.brushType](0, targetInfo.coordSys, area.coordRange);
                var rangeOffset = area.__rangeOffset;
                area.range = rangeOffset ? $6213fed8aa63fab1$var$diffProcessor[area.brushType](result.values, rangeOffset.offset, $6213fed8aa63fab1$var$getScales(result.xyMinMax, rangeOffset.xyMinMax)) : result.values;
            }
        }, this);
    };
    BrushTargetManager.prototype.makePanelOpts = function(api, getDefaultBrushType) {
        return (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(this._targetInfoList, function(targetInfo) {
            var rect = targetInfo.getPanelRect();
            return {
                panelId: targetInfo.panelId,
                defaultBrushType: getDefaultBrushType ? getDefaultBrushType(targetInfo) : null,
                clipPath: $d9c171f7dfe1f12f$export$fee17964a62a87a7(rect),
                isTargetByCursor: $d9c171f7dfe1f12f$export$e63e66b3b18aa99f(rect, api, targetInfo.coordSysModel),
                getLinearBrushOtherExtent: $d9c171f7dfe1f12f$export$7280070e90fad7a0(rect)
            };
        });
    };
    BrushTargetManager.prototype.controlSeries = function(area, seriesModel, ecModel) {
        // Check whether area is bound in coord, and series do not belong to that coord.
        // If do not do this check, some brush (like lineX) will controll all axes.
        var targetInfo = this.findTargetInfo(area, ecModel);
        return targetInfo === true || targetInfo && (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(targetInfo.coordSyses, seriesModel.coordinateSystem) >= 0;
    };
    /**
   * If return Object, a coord found.
   * If return true, global found.
   * Otherwise nothing found.
   */ BrushTargetManager.prototype.findTargetInfo = function(area, ecModel) {
        var targetInfoList = this._targetInfoList;
        var foundCpts = $6213fed8aa63fab1$var$parseFinder(ecModel, area);
        for(var i = 0; i < targetInfoList.length; i++){
            var targetInfo = targetInfoList[i];
            var areaPanelId = area.panelId;
            if (areaPanelId) {
                if (targetInfo.panelId === areaPanelId) return targetInfo;
            } else for(var j = 0; j < $6213fed8aa63fab1$var$targetInfoMatchers.length; j++){
                if ($6213fed8aa63fab1$var$targetInfoMatchers[j](foundCpts, targetInfo)) return targetInfo;
            }
        }
        return true;
    };
    return BrushTargetManager;
}();
function $6213fed8aa63fab1$var$formatMinMax(minMax) {
    minMax[0] > minMax[1] && minMax.reverse();
    return minMax;
}
function $6213fed8aa63fab1$var$parseFinder(ecModel, finder) {
    return (0, $76d619f648247e6d$export$95de80076abac814)(ecModel, finder, {
        includeMainTypes: $6213fed8aa63fab1$var$INCLUDE_FINDER_MAIN_TYPES
    });
}
var $6213fed8aa63fab1$var$targetInfoBuilders = {
    grid: function(foundCpts, targetInfoList) {
        var xAxisModels = foundCpts.xAxisModels;
        var yAxisModels = foundCpts.yAxisModels;
        var gridModels = foundCpts.gridModels;
        // Remove duplicated.
        var gridModelMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        var xAxesHas = {};
        var yAxesHas = {};
        if (!xAxisModels && !yAxisModels && !gridModels) return;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(xAxisModels, function(axisModel) {
            var gridModel = axisModel.axis.grid.model;
            gridModelMap.set(gridModel.id, gridModel);
            xAxesHas[gridModel.id] = true;
        });
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(yAxisModels, function(axisModel) {
            var gridModel = axisModel.axis.grid.model;
            gridModelMap.set(gridModel.id, gridModel);
            yAxesHas[gridModel.id] = true;
        });
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(gridModels, function(gridModel) {
            gridModelMap.set(gridModel.id, gridModel);
            xAxesHas[gridModel.id] = true;
            yAxesHas[gridModel.id] = true;
        });
        gridModelMap.each(function(gridModel) {
            var grid = gridModel.coordinateSystem;
            var cartesians = [];
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(grid.getCartesians(), function(cartesian, index) {
                if ((0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(xAxisModels, cartesian.getAxis('x').model) >= 0 || (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(yAxisModels, cartesian.getAxis('y').model) >= 0) cartesians.push(cartesian);
            });
            targetInfoList.push({
                panelId: 'grid--' + gridModel.id,
                gridModel: gridModel,
                coordSysModel: gridModel,
                // Use the first one as the representitive coordSys.
                coordSys: cartesians[0],
                coordSyses: cartesians,
                getPanelRect: $6213fed8aa63fab1$var$panelRectBuilders.grid,
                xAxisDeclared: xAxesHas[gridModel.id],
                yAxisDeclared: yAxesHas[gridModel.id]
            });
        });
    },
    geo: function(foundCpts, targetInfoList) {
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(foundCpts.geoModels, function(geoModel) {
            var coordSys = geoModel.coordinateSystem;
            targetInfoList.push({
                panelId: 'geo--' + geoModel.id,
                geoModel: geoModel,
                coordSysModel: geoModel,
                coordSys: coordSys,
                coordSyses: [
                    coordSys
                ],
                getPanelRect: $6213fed8aa63fab1$var$panelRectBuilders.geo
            });
        });
    }
};
var $6213fed8aa63fab1$var$targetInfoMatchers = [
    // grid
    function(foundCpts, targetInfo) {
        var xAxisModel = foundCpts.xAxisModel;
        var yAxisModel = foundCpts.yAxisModel;
        var gridModel = foundCpts.gridModel;
        !gridModel && xAxisModel && (gridModel = xAxisModel.axis.grid.model);
        !gridModel && yAxisModel && (gridModel = yAxisModel.axis.grid.model);
        return gridModel && gridModel === targetInfo.gridModel;
    },
    // geo
    function(foundCpts, targetInfo) {
        var geoModel = foundCpts.geoModel;
        return geoModel && geoModel === targetInfo.geoModel;
    }
];
var $6213fed8aa63fab1$var$panelRectBuilders = {
    grid: function() {
        // grid is not Transformable.
        return this.coordSys.master.getRect().clone();
    },
    geo: function() {
        var coordSys = this.coordSys;
        var rect = coordSys.getBoundingRect().clone();
        // geo roam and zoom transform
        rect.applyTransform($5b455ae6f843ac47$export$fce0c6cfca85ed96(coordSys));
        return rect;
    }
};
var $6213fed8aa63fab1$var$coordConvert = {
    lineX: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($6213fed8aa63fab1$var$axisConvert, 0),
    lineY: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($6213fed8aa63fab1$var$axisConvert, 1),
    rect: function(to, coordSys, rangeOrCoordRange, clamp) {
        var xminymin = to ? coordSys.pointToData([
            rangeOrCoordRange[0][0],
            rangeOrCoordRange[1][0]
        ], clamp) : coordSys.dataToPoint([
            rangeOrCoordRange[0][0],
            rangeOrCoordRange[1][0]
        ], clamp);
        var xmaxymax = to ? coordSys.pointToData([
            rangeOrCoordRange[0][1],
            rangeOrCoordRange[1][1]
        ], clamp) : coordSys.dataToPoint([
            rangeOrCoordRange[0][1],
            rangeOrCoordRange[1][1]
        ], clamp);
        var values = [
            $6213fed8aa63fab1$var$formatMinMax([
                xminymin[0],
                xmaxymax[0]
            ]),
            $6213fed8aa63fab1$var$formatMinMax([
                xminymin[1],
                xmaxymax[1]
            ])
        ];
        return {
            values: values,
            xyMinMax: values
        };
    },
    polygon: function(to, coordSys, rangeOrCoordRange, clamp) {
        var xyMinMax = [
            [
                Infinity,
                -Infinity
            ],
            [
                Infinity,
                -Infinity
            ]
        ];
        var values = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(rangeOrCoordRange, function(item) {
            var p = to ? coordSys.pointToData(item, clamp) : coordSys.dataToPoint(item, clamp);
            xyMinMax[0][0] = Math.min(xyMinMax[0][0], p[0]);
            xyMinMax[1][0] = Math.min(xyMinMax[1][0], p[1]);
            xyMinMax[0][1] = Math.max(xyMinMax[0][1], p[0]);
            xyMinMax[1][1] = Math.max(xyMinMax[1][1], p[1]);
            return p;
        });
        return {
            values: values,
            xyMinMax: xyMinMax
        };
    }
};
function $6213fed8aa63fab1$var$axisConvert(axisNameIndex, to, coordSys, rangeOrCoordRange) {
    var axis = coordSys.getAxis([
        'x',
        'y'
    ][axisNameIndex]);
    var values = $6213fed8aa63fab1$var$formatMinMax((0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)([
        0,
        1
    ], function(i) {
        return to ? axis.coordToData(axis.toLocalCoord(rangeOrCoordRange[i]), true) : axis.toGlobalCoord(axis.dataToCoord(rangeOrCoordRange[i]));
    }));
    var xyMinMax = [];
    xyMinMax[axisNameIndex] = values;
    xyMinMax[1 - axisNameIndex] = [
        NaN,
        NaN
    ];
    return {
        values: values,
        xyMinMax: xyMinMax
    };
}
var $6213fed8aa63fab1$var$diffProcessor = {
    lineX: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($6213fed8aa63fab1$var$axisDiffProcessor, 0),
    lineY: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($6213fed8aa63fab1$var$axisDiffProcessor, 1),
    rect: function(values, refer, scales) {
        return [
            [
                values[0][0] - scales[0] * refer[0][0],
                values[0][1] - scales[0] * refer[0][1]
            ],
            [
                values[1][0] - scales[1] * refer[1][0],
                values[1][1] - scales[1] * refer[1][1]
            ]
        ];
    },
    polygon: function(values, refer, scales) {
        return (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(values, function(item, idx) {
            return [
                item[0] - scales[0] * refer[idx][0],
                item[1] - scales[1] * refer[idx][1]
            ];
        });
    }
};
function $6213fed8aa63fab1$var$axisDiffProcessor(axisNameIndex, values, refer, scales) {
    return [
        values[0] - scales[axisNameIndex] * refer[0],
        values[1] - scales[axisNameIndex] * refer[1]
    ];
}
// We have to process scale caused by dataZoom manually,
// although it might be not accurate.
// Return [0~1, 0~1]
function $6213fed8aa63fab1$var$getScales(xyMinMaxCurr, xyMinMaxOrigin) {
    var sizeCurr = $6213fed8aa63fab1$var$getSize(xyMinMaxCurr);
    var sizeOrigin = $6213fed8aa63fab1$var$getSize(xyMinMaxOrigin);
    var scales = [
        sizeCurr[0] / sizeOrigin[0],
        sizeCurr[1] / sizeOrigin[1]
    ];
    isNaN(scales[0]) && (scales[0] = 1);
    isNaN(scales[1]) && (scales[1] = 1);
    return scales;
}
function $6213fed8aa63fab1$var$getSize(xyMinMax) {
    return xyMinMax ? [
        xyMinMax[0][1] - xyMinMax[0][0],
        xyMinMax[1][1] - xyMinMax[1][0]
    ] : [
        NaN,
        NaN
    ];
}
var $6213fed8aa63fab1$export$2e2bcd8739ae039 = $6213fed8aa63fab1$var$BrushTargetManager;


var $8c565e07fd43a6ee$var$STATE_LIST = [
    'inBrush',
    'outOfBrush'
];
var $8c565e07fd43a6ee$var$DISPATCH_METHOD = '__ecBrushSelect';
var $8c565e07fd43a6ee$var$DISPATCH_FLAG = '__ecInBrushSelectEvent';
function $8c565e07fd43a6ee$export$ead1205d8c0d8375(ecModel) {
    ecModel.eachComponent({
        mainType: 'brush'
    }, function(brushModel) {
        var brushTargetManager = brushModel.brushTargetManager = new (0, $6213fed8aa63fab1$export$2e2bcd8739ae039)(brushModel.option, ecModel);
        brushTargetManager.setInputRanges(brushModel.areas, ecModel);
    });
}
function $8c565e07fd43a6ee$export$2e2bcd8739ae039(ecModel, api, payload) {
    var brushSelected = [];
    var throttleType;
    var throttleDelay;
    ecModel.eachComponent({
        mainType: 'brush'
    }, function(brushModel) {
        payload && payload.type === 'takeGlobalCursor' && brushModel.setBrushOption(payload.key === 'brush' ? payload.brushOption : {
            brushType: false
        });
    });
    $8c565e07fd43a6ee$export$ead1205d8c0d8375(ecModel);
    ecModel.eachComponent({
        mainType: 'brush'
    }, function(brushModel, brushIndex) {
        var thisBrushSelected = {
            brushId: brushModel.id,
            brushIndex: brushIndex,
            brushName: brushModel.name,
            areas: $7a1bd9c2710fea0d$export$9cd59f9826255e47(brushModel.areas),
            selected: []
        };
        // Every brush component exists in event params, convenient
        // for user to find by index.
        brushSelected.push(thisBrushSelected);
        var brushOption = brushModel.option;
        var brushLink = brushOption.brushLink;
        var linkedSeriesMap = [];
        var selectedDataIndexForLink = [];
        var rangeInfoBySeries = [];
        var hasBrushExists = false;
        if (!brushIndex) {
            // Only the first throttle setting works.
            throttleType = brushOption.throttleType;
            throttleDelay = brushOption.throttleDelay;
        }
        // Add boundingRect and selectors to range.
        var areas = $7a1bd9c2710fea0d$export$871de8747c9eaa88(brushModel.areas, function(area) {
            var builder = $8c565e07fd43a6ee$var$boundingRectBuilders[area.brushType];
            var selectableArea = $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                boundingRect: builder ? builder(area) : void 0
            }, area);
            selectableArea.selectors = (0, $431fae42b264171b$export$2225cfa0a999c142)(selectableArea);
            return selectableArea;
        });
        var visualMappings = $87ea23222d1c134e$export$89974527642f24a0(brushModel.option, $8c565e07fd43a6ee$var$STATE_LIST, function(mappingOption) {
            mappingOption.mappingMethod = 'fixed';
        });
        $7a1bd9c2710fea0d$export$43bee75e5e14138e(brushLink) && $7a1bd9c2710fea0d$export$79b2f7037acddd43(brushLink, function(seriesIndex) {
            linkedSeriesMap[seriesIndex] = 1;
        });
        function linkOthers(seriesIndex) {
            return brushLink === 'all' || !!linkedSeriesMap[seriesIndex];
        }
        // If no supported brush or no brush on the series,
        // all visuals should be in original state.
        function brushed(rangeInfoList) {
            return !!rangeInfoList.length;
        }
        /**
     * Logic for each series: (If the logic has to be modified one day, do it carefully!)
     *
     * ( brushed ┬ && ┬hasBrushExist ┬ && linkOthers  ) => StepA: ┬record, ┬ StepB: ┬visualByRecord.
     *   !brushed┘    ├hasBrushExist ┤                            └nothing,┘        ├visualByRecord.
     *                └!hasBrushExist┘                                              └nothing.
     * ( !brushed  && ┬hasBrushExist ┬ && linkOthers  ) => StepA:  nothing,  StepB: ┬visualByRecord.
     *                └!hasBrushExist┘                                              └nothing.
     * ( brushed ┬ &&                     !linkOthers ) => StepA:  nothing,  StepB: ┬visualByCheck.
     *   !brushed┘                                                                  └nothing.
     * ( !brushed  &&                     !linkOthers ) => StepA:  nothing,  StepB:  nothing.
     */ // Step A
        ecModel.eachSeries(function(seriesModel, seriesIndex) {
            var rangeInfoList = rangeInfoBySeries[seriesIndex] = [];
            seriesModel.subType === 'parallel' ? stepAParallel(seriesModel, seriesIndex) : stepAOthers(seriesModel, seriesIndex, rangeInfoList);
        });
        function stepAParallel(seriesModel, seriesIndex) {
            var coordSys = seriesModel.coordinateSystem;
            hasBrushExists = hasBrushExists || coordSys.hasAxisBrushed();
            linkOthers(seriesIndex) && coordSys.eachActiveState(seriesModel.getData(), function(activeState, dataIndex) {
                activeState === 'active' && (selectedDataIndexForLink[dataIndex] = 1);
            });
        }
        function stepAOthers(seriesModel, seriesIndex, rangeInfoList) {
            if (!seriesModel.brushSelector || $8c565e07fd43a6ee$var$brushModelNotControll(brushModel, seriesIndex)) return;
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(areas, function(area) {
                if (brushModel.brushTargetManager.controlSeries(area, seriesModel, ecModel)) rangeInfoList.push(area);
                hasBrushExists = hasBrushExists || brushed(rangeInfoList);
            });
            if (linkOthers(seriesIndex) && brushed(rangeInfoList)) {
                var data_1 = seriesModel.getData();
                data_1.each(function(dataIndex) {
                    if ($8c565e07fd43a6ee$var$checkInRange(seriesModel, rangeInfoList, data_1, dataIndex)) selectedDataIndexForLink[dataIndex] = 1;
                });
            }
        }
        // Step B
        ecModel.eachSeries(function(seriesModel, seriesIndex) {
            var seriesBrushSelected = {
                seriesId: seriesModel.id,
                seriesIndex: seriesIndex,
                seriesName: seriesModel.name,
                dataIndex: []
            };
            // Every series exists in event params, convenient
            // for user to find series by seriesIndex.
            thisBrushSelected.selected.push(seriesBrushSelected);
            var rangeInfoList = rangeInfoBySeries[seriesIndex];
            var data = seriesModel.getData();
            var getValueState = linkOthers(seriesIndex) ? function(dataIndex) {
                return selectedDataIndexForLink[dataIndex] ? (seriesBrushSelected.dataIndex.push(data.getRawIndex(dataIndex)), 'inBrush') : 'outOfBrush';
            } : function(dataIndex) {
                return $8c565e07fd43a6ee$var$checkInRange(seriesModel, rangeInfoList, data, dataIndex) ? (seriesBrushSelected.dataIndex.push(data.getRawIndex(dataIndex)), 'inBrush') : 'outOfBrush';
            };
            // If no supported brush or no brush, all visuals are in original state.
            (linkOthers(seriesIndex) ? hasBrushExists : brushed(rangeInfoList)) && $87ea23222d1c134e$export$bb1ef43951d58629($8c565e07fd43a6ee$var$STATE_LIST, visualMappings, data, getValueState);
        });
    });
    $8c565e07fd43a6ee$var$dispatchAction(api, throttleType, throttleDelay, brushSelected, payload);
}
function $8c565e07fd43a6ee$var$dispatchAction(api, throttleType, throttleDelay, brushSelected, payload) {
    // This event will not be triggered when `setOpion`, otherwise dead lock may
    // triggered when do `setOption` in event listener, which we do not find
    // satisfactory way to solve yet. Some considered resolutions:
    // (a) Diff with prevoius selected data ant only trigger event when changed.
    // But store previous data and diff precisely (i.e., not only by dataIndex, but
    // also detect value changes in selected data) might bring complexity or fragility.
    // (b) Use spectial param like `silent` to suppress event triggering.
    // But such kind of volatile param may be weird in `setOption`.
    if (!payload) return;
    var zr = api.getZr();
    if (zr[$8c565e07fd43a6ee$var$DISPATCH_FLAG]) return;
    if (!zr[$8c565e07fd43a6ee$var$DISPATCH_METHOD]) zr[$8c565e07fd43a6ee$var$DISPATCH_METHOD] = $8c565e07fd43a6ee$var$doDispatch;
    var fn = $c98659a9437a3d2e$export$958e3e1a02eac4b6(zr, $8c565e07fd43a6ee$var$DISPATCH_METHOD, throttleDelay, throttleType);
    fn(api, brushSelected);
}
function $8c565e07fd43a6ee$var$doDispatch(api, brushSelected) {
    if (!api.isDisposed()) {
        var zr = api.getZr();
        zr[$8c565e07fd43a6ee$var$DISPATCH_FLAG] = true;
        api.dispatchAction({
            type: 'brushSelect',
            batch: brushSelected
        });
        zr[$8c565e07fd43a6ee$var$DISPATCH_FLAG] = false;
    }
}
function $8c565e07fd43a6ee$var$checkInRange(seriesModel, rangeInfoList, data, dataIndex) {
    for(var i = 0, len = rangeInfoList.length; i < len; i++){
        var area = rangeInfoList[i];
        if (seriesModel.brushSelector(dataIndex, data, area.selectors, area)) return true;
    }
}
function $8c565e07fd43a6ee$var$brushModelNotControll(brushModel, seriesIndex) {
    var seriesIndices = brushModel.option.seriesIndex;
    return seriesIndices != null && seriesIndices !== 'all' && ($7a1bd9c2710fea0d$export$43bee75e5e14138e(seriesIndices) ? $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(seriesIndices, seriesIndex) < 0 : seriesIndex !== seriesIndices);
}
var $8c565e07fd43a6ee$var$boundingRectBuilders = {
    rect: function(area) {
        return $8c565e07fd43a6ee$var$getBoundingRectFromMinMax(area.range);
    },
    polygon: function(area) {
        var minMax;
        var range = area.range;
        for(var i = 0, len = range.length; i < len; i++){
            minMax = minMax || [
                [
                    Infinity,
                    -Infinity
                ],
                [
                    Infinity,
                    -Infinity
                ]
            ];
            var rg = range[i];
            rg[0] < minMax[0][0] && (minMax[0][0] = rg[0]);
            rg[0] > minMax[0][1] && (minMax[0][1] = rg[0]);
            rg[1] < minMax[1][0] && (minMax[1][0] = rg[1]);
            rg[1] > minMax[1][1] && (minMax[1][1] = rg[1]);
        }
        return minMax && $8c565e07fd43a6ee$var$getBoundingRectFromMinMax(minMax);
    }
};
function $8c565e07fd43a6ee$var$getBoundingRectFromMinMax(minMax) {
    return new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(minMax[0][0], minMax[1][0], minMax[0][1] - minMax[0][0], minMax[1][1] - minMax[1][0]);
}



var $b3094615d1ff0264$var$BrushView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(BrushView, _super);
    function BrushView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BrushView.type;
        return _this;
    }
    BrushView.prototype.init = function(ecModel, api) {
        this.ecModel = ecModel;
        this.api = api;
        this.model;
        (this._brushController = new (0, $91342d1cfa622c5a$export$2e2bcd8739ae039)(api.getZr())).on('brush', $7a1bd9c2710fea0d$export$2385a24977818dd0(this._onBrush, this)).mount();
    };
    BrushView.prototype.render = function(brushModel, ecModel, api, payload) {
        this.model = brushModel;
        this._updateController(brushModel, ecModel, api, payload);
    };
    BrushView.prototype.updateTransform = function(brushModel, ecModel, api, payload) {
        // PENDING: `updateTransform` is a little tricky, whose layout need
        // to be calculate mandatorily and other stages will not be performed.
        // Take care the correctness of the logic. See #11754 .
        (0, $8c565e07fd43a6ee$export$ead1205d8c0d8375)(ecModel);
        this._updateController(brushModel, ecModel, api, payload);
    };
    BrushView.prototype.updateVisual = function(brushModel, ecModel, api, payload) {
        this.updateTransform(brushModel, ecModel, api, payload);
    };
    BrushView.prototype.updateView = function(brushModel, ecModel, api, payload) {
        this._updateController(brushModel, ecModel, api, payload);
    };
    BrushView.prototype._updateController = function(brushModel, ecModel, api, payload) {
        // Do not update controller when drawing.
        (!payload || payload.$from !== brushModel.id) && this._brushController.setPanels(brushModel.brushTargetManager.makePanelOpts(api)).enableBrush(brushModel.brushOption).updateCovers(brushModel.areas.slice());
    };
    // updateLayout: updateController,
    // updateVisual: updateController,
    BrushView.prototype.dispose = function() {
        this._brushController.dispose();
    };
    BrushView.prototype._onBrush = function(eventParam) {
        var modelId = this.model.id;
        var areas = this.model.brushTargetManager.setOutputRanges(eventParam.areas, this.ecModel);
        // Action is not dispatched on drag end, because the drag end
        // emits the same params with the last drag move event, and
        // may have some delay when using touch pad, which makes
        // animation not smooth (when using debounce).
        (!eventParam.isEnd || eventParam.removeOnClick) && this.api.dispatchAction({
            type: 'brush',
            brushId: modelId,
            areas: $7a1bd9c2710fea0d$export$9cd59f9826255e47(areas),
            $from: modelId
        });
        eventParam.isEnd && this.api.dispatchAction({
            type: 'brushEnd',
            brushId: modelId,
            areas: $7a1bd9c2710fea0d$export$9cd59f9826255e47(areas),
            $from: modelId
        });
    };
    BrushView.type = 'brush';
    return BrushView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $b3094615d1ff0264$export$2e2bcd8739ae039 = $b3094615d1ff0264$var$BrushView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $c309289727ee7770$var$DEFAULT_OUT_OF_BRUSH_COLOR = '#ddd';
var $c309289727ee7770$var$BrushModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(BrushModel, _super);
    function BrushModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BrushModel.type;
        /**
     * @readOnly
     */ _this.areas = [];
        /**
     * Current brush painting area settings.
     * @readOnly
     */ _this.brushOption = {};
        return _this;
    }
    BrushModel.prototype.optionUpdated = function(newOption, isInit) {
        var thisOption = this.option;
        !isInit && $87ea23222d1c134e$export$797d20c0a6de578f(thisOption, newOption, [
            'inBrush',
            'outOfBrush'
        ]);
        var inBrush = thisOption.inBrush = thisOption.inBrush || {};
        // Always give default visual, consider setOption at the second time.
        thisOption.outOfBrush = thisOption.outOfBrush || {
            color: $c309289727ee7770$var$DEFAULT_OUT_OF_BRUSH_COLOR
        };
        if (!inBrush.hasOwnProperty('liftZ')) // Bigger than the highlight z lift, otherwise it will
        // be effected by the highlight z when brush.
        inBrush.liftZ = 5;
    };
    /**
   * If `areas` is null/undefined, range state remain.
   */ BrushModel.prototype.setAreas = function(areas) {
        // If areas is null/undefined, range state remain.
        // This helps user to dispatchAction({type: 'brush'}) with no areas
        // set but just want to get the current brush select info from a `brush` event.
        if (!areas) return;
        this.areas = $7a1bd9c2710fea0d$export$871de8747c9eaa88(areas, function(area) {
            return $c309289727ee7770$var$generateBrushOption(this.option, area);
        }, this);
    };
    /**
   * Set the current painting brush option.
   */ BrushModel.prototype.setBrushOption = function(brushOption) {
        this.brushOption = $c309289727ee7770$var$generateBrushOption(this.option, brushOption);
        this.brushType = this.brushOption.brushType;
    };
    BrushModel.type = 'brush';
    BrushModel.dependencies = [
        'geo',
        'grid',
        'xAxis',
        'yAxis',
        'parallel',
        'series'
    ];
    BrushModel.defaultOption = {
        seriesIndex: 'all',
        brushType: 'rect',
        brushMode: 'single',
        transformable: true,
        brushStyle: {
            borderWidth: 1,
            color: 'rgba(210,219,238,0.3)',
            borderColor: '#D2DBEE'
        },
        throttleType: 'fixRate',
        throttleDelay: 0,
        removeOnClick: true,
        z: 10000
    };
    return BrushModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
function $c309289727ee7770$var$generateBrushOption(option, brushOption) {
    return $7a1bd9c2710fea0d$export$4950aa0f605343fb({
        brushType: option.brushType,
        brushMode: option.brushMode,
        transformable: option.transformable,
        brushStyle: new (0, $6818646a97528290$export$2e2bcd8739ae039)(option.brushStyle).getItemStyle(),
        removeOnClick: option.removeOnClick,
        z: option.z
    }, brushOption, true);
}
var $c309289727ee7770$export$2e2bcd8739ae039 = $c309289727ee7770$var$BrushModel;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ var $974ee7656e10f2d0$export$1426bfb1b0bcf539 = /** @class */ function() {
    function ToolboxFeature() {}
    return ToolboxFeature;
}();
var $974ee7656e10f2d0$var$features = {};
function $974ee7656e10f2d0$export$c6213a6f247cf906(name, ctor) {
    $974ee7656e10f2d0$var$features[name] = ctor;
}
function $974ee7656e10f2d0$export$bba2e7bbd72e62e1(name) {
    return $974ee7656e10f2d0$var$features[name];
}


var $0ea8e48a326f7b6d$var$ICON_TYPES = [
    'rect',
    'polygon',
    'lineX',
    'lineY',
    'keep',
    'clear'
];
var $0ea8e48a326f7b6d$var$BrushFeature = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(BrushFeature, _super);
    function BrushFeature() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BrushFeature.prototype.render = function(featureModel, ecModel, api) {
        var brushType;
        var brushMode;
        var isBrushed;
        ecModel.eachComponent({
            mainType: 'brush'
        }, function(brushModel) {
            brushType = brushModel.brushType;
            brushMode = brushModel.brushOption.brushMode || 'single';
            isBrushed = isBrushed || !!brushModel.areas.length;
        });
        this._brushType = brushType;
        this._brushMode = brushMode;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(featureModel.get('type', true), function(type) {
            featureModel.setIconStatus(type, (type === 'keep' ? brushMode === 'multiple' : type === 'clear' ? isBrushed : type === brushType) ? 'emphasis' : 'normal');
        });
    };
    BrushFeature.prototype.updateView = function(featureModel, ecModel, api) {
        this.render(featureModel, ecModel, api);
    };
    BrushFeature.prototype.getIcons = function() {
        var model = this.model;
        var availableIcons = model.get('icon', true);
        var icons = {};
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(model.get('type', true), function(type) {
            if (availableIcons[type]) icons[type] = availableIcons[type];
        });
        return icons;
    };
    BrushFeature.prototype.onclick = function(ecModel, api, type) {
        var brushType = this._brushType;
        var brushMode = this._brushMode;
        if (type === 'clear') {
            // Trigger parallel action firstly
            api.dispatchAction({
                type: 'axisAreaSelect',
                intervals: []
            });
            api.dispatchAction({
                type: 'brush',
                command: 'clear',
                // Clear all areas of all brush components.
                areas: []
            });
        } else api.dispatchAction({
            type: 'takeGlobalCursor',
            key: 'brush',
            brushOption: {
                brushType: type === 'keep' ? brushType : brushType === type ? false : type,
                brushMode: type === 'keep' ? brushMode === 'multiple' ? 'single' : 'multiple' : brushMode
            }
        });
    };
    BrushFeature.getDefaultOption = function(ecModel) {
        var defaultOption = {
            show: true,
            type: $0ea8e48a326f7b6d$var$ICON_TYPES.slice(),
            icon: {
                /* eslint-disable */ rect: 'M7.3,34.7 M0.4,10V-0.2h9.8 M89.6,10V-0.2h-9.8 M0.4,60v10.2h9.8 M89.6,60v10.2h-9.8 M12.3,22.4V10.5h13.1 M33.6,10.5h7.8 M49.1,10.5h7.8 M77.5,22.4V10.5h-13 M12.3,31.1v8.2 M77.7,31.1v8.2 M12.3,47.6v11.9h13.1 M33.6,59.5h7.6 M49.1,59.5 h7.7 M77.5,47.6v11.9h-13',
                polygon: 'M55.2,34.9c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1 s-3.1-1.4-3.1-3.1S53.5,34.9,55.2,34.9z M50.4,51c1.7,0,3.1,1.4,3.1,3.1c0,1.7-1.4,3.1-3.1,3.1c-1.7,0-3.1-1.4-3.1-3.1 C47.3,52.4,48.7,51,50.4,51z M55.6,37.1l1.5-7.8 M60.1,13.5l1.6-8.7l-7.8,4 M59,19l-1,5.3 M24,16.1l6.4,4.9l6.4-3.3 M48.5,11.6 l-5.9,3.1 M19.1,12.8L9.7,5.1l1.1,7.7 M13.4,29.8l1,7.3l6.6,1.6 M11.6,18.4l1,6.1 M32.8,41.9 M26.6,40.4 M27.3,40.2l6.1,1.6 M49.9,52.1l-5.6-7.6l-4.9-1.2',
                lineX: 'M15.2,30 M19.7,15.6V1.9H29 M34.8,1.9H40.4 M55.3,15.6V1.9H45.9 M19.7,44.4V58.1H29 M34.8,58.1H40.4 M55.3,44.4 V58.1H45.9 M12.5,20.3l-9.4,9.6l9.6,9.8 M3.1,29.9h16.5 M62.5,20.3l9.4,9.6L62.3,39.7 M71.9,29.9H55.4',
                lineY: 'M38.8,7.7 M52.7,12h13.2v9 M65.9,26.6V32 M52.7,46.3h13.2v-9 M24.9,12H11.8v9 M11.8,26.6V32 M24.9,46.3H11.8v-9 M48.2,5.1l-9.3-9l-9.4,9.2 M38.9-3.9V12 M48.2,53.3l-9.3,9l-9.4-9.2 M38.9,62.3V46.4',
                keep: 'M4,10.5V1h10.3 M20.7,1h6.1 M33,1h6.1 M55.4,10.5V1H45.2 M4,17.3v6.6 M55.6,17.3v6.6 M4,30.5V40h10.3 M20.7,40 h6.1 M33,40h6.1 M55.4,30.5V40H45.2 M21,18.9h62.9v48.6H21V18.9z',
                clear: 'M22,14.7l30.9,31 M52.9,14.7L22,45.7 M4.7,16.8V4.2h13.1 M26,4.2h7.8 M41.6,4.2h7.8 M70.3,16.8V4.2H57.2 M4.7,25.9v8.6 M70.3,25.9v8.6 M4.7,43.2v12.6h13.1 M26,55.8h7.8 M41.6,55.8h7.8 M70.3,43.2v12.6H57.2' // jshint ignore:line
            },
            // `rect`, `polygon`, `lineX`, `lineY`, `keep`, `clear`
            title: ecModel.getLocaleModel().get([
                'toolbox',
                'brush',
                'title'
            ])
        };
        return defaultOption;
    };
    return BrushFeature;
}((0, $974ee7656e10f2d0$export$1426bfb1b0bcf539));
var $0ea8e48a326f7b6d$export$2e2bcd8739ae039 = $0ea8e48a326f7b6d$var$BrushFeature;




function $e97a928e0b93a54f$export$4b3e715f166fdd78(registers) {
    registers.registerComponentView((0, $b3094615d1ff0264$export$2e2bcd8739ae039));
    registers.registerComponentModel((0, $c309289727ee7770$export$2e2bcd8739ae039));
    registers.registerPreprocessor((0, $860dd9ca08385e85$export$2e2bcd8739ae039));
    registers.registerVisual(registers.PRIORITY.VISUAL.BRUSH, (0, $8c565e07fd43a6ee$export$2e2bcd8739ae039));
    registers.registerAction({
        type: 'brush',
        event: 'brush',
        update: 'updateVisual'
    }, function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: 'brush',
            query: payload
        }, function(brushModel) {
            brushModel.setAreas(payload.areas);
        });
    });
    /**
   * payload: {
   *      brushComponents: [
   *          {
   *              brushId,
   *              brushIndex,
   *              brushName,
   *              series: [
   *                  {
   *                      seriesId,
   *                      seriesIndex,
   *                      seriesName,
   *                      rawIndices: [21, 34, ...]
   *                  },
   *                  ...
   *              ]
   *          },
   *          ...
   *      ]
   * }
   */ registers.registerAction({
        type: 'brushSelect',
        event: 'brushSelected',
        update: 'none'
    }, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));
    registers.registerAction({
        type: 'brushEnd',
        event: 'brushEnd',
        update: 'none'
    }, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));
    (0, $974ee7656e10f2d0$export$c6213a6f247cf906)('brush', (0, $0ea8e48a326f7b6d$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $795d2d92b1d02c70$var$CalendarModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(CalendarModel, _super);
    function CalendarModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CalendarModel.type;
        return _this;
    }
    /**
   * @override
   */ CalendarModel.prototype.init = function(option, parentModel, ecModel) {
        var inputPositionParams = (0, $93b9bc7f22ac7369$export$4b0d20af19c9875e)(option);
        _super.prototype.init.apply(this, arguments);
        $795d2d92b1d02c70$var$mergeAndNormalizeLayoutParams(option, inputPositionParams);
    };
    /**
   * @override
   */ CalendarModel.prototype.mergeOption = function(option) {
        _super.prototype.mergeOption.apply(this, arguments);
        $795d2d92b1d02c70$var$mergeAndNormalizeLayoutParams(this.option, option);
    };
    CalendarModel.prototype.getCellSize = function() {
        // Has been normalized
        return this.option.cellSize;
    };
    CalendarModel.type = 'calendar';
    CalendarModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        left: 80,
        top: 60,
        cellSize: 20,
        // horizontal vertical
        orient: 'horizontal',
        // month separate line style
        splitLine: {
            show: true,
            lineStyle: {
                color: '#000',
                width: 1,
                type: 'solid'
            }
        },
        // rect style  temporarily unused emphasis
        itemStyle: {
            color: '#fff',
            borderWidth: 1,
            borderColor: '#ccc'
        },
        // week text style
        dayLabel: {
            show: true,
            firstDay: 0,
            // start end
            position: 'start',
            margin: '50%',
            color: '#000'
        },
        // month text style
        monthLabel: {
            show: true,
            // start end
            position: 'start',
            margin: 5,
            // center or left
            align: 'center',
            formatter: null,
            color: '#000'
        },
        // year text style
        yearLabel: {
            show: true,
            // top bottom left right
            position: null,
            margin: 30,
            formatter: null,
            color: '#ccc',
            fontFamily: 'sans-serif',
            fontWeight: 'bolder',
            fontSize: 20
        }
    };
    return CalendarModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
function $795d2d92b1d02c70$var$mergeAndNormalizeLayoutParams(target, raw) {
    // Normalize cellSize
    var cellSize = target.cellSize;
    var cellSizeArr;
    if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(cellSize)) cellSizeArr = target.cellSize = [
        cellSize,
        cellSize
    ];
    else cellSizeArr = cellSize;
    if (cellSizeArr.length === 1) cellSizeArr[1] = cellSizeArr[0];
    var ignoreSize = $7a1bd9c2710fea0d$export$871de8747c9eaa88([
        0,
        1
    ], function(hvIdx) {
        // If user have set `width` or both `left` and `right`, cellSizeArr
        // will be automatically set to 'auto', otherwise the default
        // setting of cellSizeArr will make `width` setting not work.
        if ((0, $93b9bc7f22ac7369$export$7ede609e8ebc9650)(raw, hvIdx)) cellSizeArr[hvIdx] = 'auto';
        return cellSizeArr[hvIdx] != null && cellSizeArr[hvIdx] !== 'auto';
    });
    (0, $93b9bc7f22ac7369$export$1754cb91f16ca028)(target, raw, {
        type: 'box',
        ignoreSize: ignoreSize
    });
}
var $795d2d92b1d02c70$export$2e2bcd8739ae039 = $795d2d92b1d02c70$var$CalendarModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







var $e6b2dc17a91ad4af$var$CalendarView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(CalendarView, _super);
    function CalendarView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CalendarView.type;
        return _this;
    }
    CalendarView.prototype.render = function(calendarModel, ecModel, api) {
        var group = this.group;
        group.removeAll();
        var coordSys = calendarModel.coordinateSystem;
        // range info
        var rangeData = coordSys.getRangeInfo();
        var orient = coordSys.getOrient();
        // locale
        var localeModel = ecModel.getLocaleModel();
        this._renderDayRect(calendarModel, rangeData, group);
        // _renderLines must be called prior to following function
        this._renderLines(calendarModel, rangeData, orient, group);
        this._renderYearText(calendarModel, rangeData, orient, group);
        this._renderMonthText(calendarModel, localeModel, orient, group);
        this._renderWeekText(calendarModel, localeModel, rangeData, orient, group);
    };
    // render day rect
    CalendarView.prototype._renderDayRect = function(calendarModel, rangeData, group) {
        var coordSys = calendarModel.coordinateSystem;
        var itemRectStyleModel = calendarModel.getModel('itemStyle').getItemStyle();
        var sw = coordSys.getCellWidth();
        var sh = coordSys.getCellHeight();
        for(var i = rangeData.start.time; i <= rangeData.end.time; i = coordSys.getNextNDay(i, 1).time){
            var point = coordSys.dataToRect([
                i
            ], false).tl;
            // every rect
            var rect = new $419e5ff2f303755e$export$2e2bcd8739ae039({
                shape: {
                    x: point[0],
                    y: point[1],
                    width: sw,
                    height: sh
                },
                cursor: 'default',
                style: itemRectStyleModel
            });
            group.add(rect);
        }
    };
    // render separate line
    CalendarView.prototype._renderLines = function(calendarModel, rangeData, orient, group) {
        var self = this;
        var coordSys = calendarModel.coordinateSystem;
        var lineStyleModel = calendarModel.getModel([
            'splitLine',
            'lineStyle'
        ]).getLineStyle();
        var show = calendarModel.get([
            'splitLine',
            'show'
        ]);
        var lineWidth = lineStyleModel.lineWidth;
        this._tlpoints = [];
        this._blpoints = [];
        this._firstDayOfMonth = [];
        this._firstDayPoints = [];
        var firstDay = rangeData.start;
        for(var i = 0; firstDay.time <= rangeData.end.time; i++){
            addPoints(firstDay.formatedDate);
            if (i === 0) firstDay = coordSys.getDateInfo(rangeData.start.y + '-' + rangeData.start.m);
            var date = firstDay.date;
            date.setMonth(date.getMonth() + 1);
            firstDay = coordSys.getDateInfo(date);
        }
        addPoints(coordSys.getNextNDay(rangeData.end.time, 1).formatedDate);
        function addPoints(date) {
            self._firstDayOfMonth.push(coordSys.getDateInfo(date));
            self._firstDayPoints.push(coordSys.dataToRect([
                date
            ], false).tl);
            var points = self._getLinePointsOfOneWeek(calendarModel, date, orient);
            self._tlpoints.push(points[0]);
            self._blpoints.push(points[points.length - 1]);
            show && self._drawSplitline(points, lineStyleModel, group);
        }
        // render top/left line
        show && this._drawSplitline(self._getEdgesPoints(self._tlpoints, lineWidth, orient), lineStyleModel, group);
        // render bottom/right line
        show && this._drawSplitline(self._getEdgesPoints(self._blpoints, lineWidth, orient), lineStyleModel, group);
    };
    // get points at both ends
    CalendarView.prototype._getEdgesPoints = function(points, lineWidth, orient) {
        var rs = [
            points[0].slice(),
            points[points.length - 1].slice()
        ];
        var idx = orient === 'horizontal' ? 0 : 1;
        // both ends of the line are extend half lineWidth
        rs[0][idx] = rs[0][idx] - lineWidth / 2;
        rs[1][idx] = rs[1][idx] + lineWidth / 2;
        return rs;
    };
    // render split line
    CalendarView.prototype._drawSplitline = function(points, lineStyle, group) {
        var poyline = new $d28119f30e6bb670$export$2e2bcd8739ae039({
            z2: 20,
            shape: {
                points: points
            },
            style: lineStyle
        });
        group.add(poyline);
    };
    // render month line of one week points
    CalendarView.prototype._getLinePointsOfOneWeek = function(calendarModel, date, orient) {
        var coordSys = calendarModel.coordinateSystem;
        var parsedDate = coordSys.getDateInfo(date);
        var points = [];
        for(var i = 0; i < 7; i++){
            var tmpD = coordSys.getNextNDay(parsedDate.time, i);
            var point = coordSys.dataToRect([
                tmpD.time
            ], false);
            points[2 * tmpD.day] = point.tl;
            points[2 * tmpD.day + 1] = point[orient === 'horizontal' ? 'bl' : 'tr'];
        }
        return points;
    };
    CalendarView.prototype._formatterLabel = function(formatter, params) {
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(formatter) && formatter) return (0, $c84c9521536c601a$export$2fa08233ee42f8e1)(formatter, params);
        if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(formatter)) return formatter(params);
        return params.nameMap;
    };
    CalendarView.prototype._yearTextPositionControl = function(textEl, point, orient, position, margin) {
        var x = point[0];
        var y = point[1];
        var aligns = [
            'center',
            'bottom'
        ];
        if (position === 'bottom') {
            y += margin;
            aligns = [
                'center',
                'top'
            ];
        } else if (position === 'left') x -= margin;
        else if (position === 'right') {
            x += margin;
            aligns = [
                'center',
                'top'
            ];
        } else // top
        y -= margin;
        var rotate = 0;
        if (position === 'left' || position === 'right') rotate = Math.PI / 2;
        return {
            rotation: rotate,
            x: x,
            y: y,
            style: {
                align: aligns[0],
                verticalAlign: aligns[1]
            }
        };
    };
    // render year
    CalendarView.prototype._renderYearText = function(calendarModel, rangeData, orient, group) {
        var yearLabel = calendarModel.getModel('yearLabel');
        if (!yearLabel.get('show')) return;
        var margin = yearLabel.get('margin');
        var pos = yearLabel.get('position');
        if (!pos) pos = orient !== 'horizontal' ? 'top' : 'left';
        var points = [
            this._tlpoints[this._tlpoints.length - 1],
            this._blpoints[0]
        ];
        var xc = (points[0][0] + points[1][0]) / 2;
        var yc = (points[0][1] + points[1][1]) / 2;
        var idx = orient === 'horizontal' ? 0 : 1;
        var posPoints = {
            top: [
                xc,
                points[idx][1]
            ],
            bottom: [
                xc,
                points[1 - idx][1]
            ],
            left: [
                points[1 - idx][0],
                yc
            ],
            right: [
                points[idx][0],
                yc
            ]
        };
        var name = rangeData.start.y;
        if (+rangeData.end.y > +rangeData.start.y) name = name + '-' + rangeData.end.y;
        var formatter = yearLabel.get('formatter');
        var params = {
            start: rangeData.start.y,
            end: rangeData.end.y,
            nameMap: name
        };
        var content = this._formatterLabel(formatter, params);
        var yearText = new $fe885cc21795562b$export$2e2bcd8739ae039({
            z2: 30,
            style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(yearLabel, {
                text: content
            }),
            silent: yearLabel.get('silent')
        });
        yearText.attr(this._yearTextPositionControl(yearText, posPoints[pos], orient, pos, margin));
        group.add(yearText);
    };
    CalendarView.prototype._monthTextPositionControl = function(point, isCenter, orient, position, margin) {
        var align = 'left';
        var vAlign = 'top';
        var x = point[0];
        var y = point[1];
        if (orient === 'horizontal') {
            y = y + margin;
            if (isCenter) align = 'center';
            if (position === 'start') vAlign = 'bottom';
        } else {
            x = x + margin;
            if (isCenter) vAlign = 'middle';
            if (position === 'start') align = 'right';
        }
        return {
            x: x,
            y: y,
            align: align,
            verticalAlign: vAlign
        };
    };
    // render month and year text
    CalendarView.prototype._renderMonthText = function(calendarModel, localeModel, orient, group) {
        var monthLabel = calendarModel.getModel('monthLabel');
        if (!monthLabel.get('show')) return;
        var nameMap = monthLabel.get('nameMap');
        var margin = monthLabel.get('margin');
        var pos = monthLabel.get('position');
        var align = monthLabel.get('align');
        var termPoints = [
            this._tlpoints,
            this._blpoints
        ];
        if (!nameMap || (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(nameMap)) {
            if (nameMap) // case-sensitive
            localeModel = (0, $9b0a1ef4bcc91e7d$export$37cc638e0e11865f)(nameMap) || localeModel;
            // PENDING
            // for ZH locale, original form is `一月` but current form is `1月`
            nameMap = localeModel.get([
                'time',
                'monthAbbr'
            ]) || [];
        }
        var idx = pos === 'start' ? 0 : 1;
        var axis = orient === 'horizontal' ? 0 : 1;
        margin = pos === 'start' ? -margin : margin;
        var isCenter = align === 'center';
        var labelSilent = monthLabel.get('silent');
        for(var i = 0; i < termPoints[idx].length - 1; i++){
            var tmp = termPoints[idx][i].slice();
            var firstDay = this._firstDayOfMonth[i];
            if (isCenter) {
                var firstDayPoints = this._firstDayPoints[i];
                tmp[axis] = (firstDayPoints[axis] + termPoints[0][i + 1][axis]) / 2;
            }
            var formatter = monthLabel.get('formatter');
            var name_1 = nameMap[+firstDay.m - 1];
            var params = {
                yyyy: firstDay.y,
                yy: (firstDay.y + '').slice(2),
                MM: firstDay.m,
                M: +firstDay.m,
                nameMap: name_1
            };
            var content = this._formatterLabel(formatter, params);
            var monthText = new $fe885cc21795562b$export$2e2bcd8739ae039({
                z2: 30,
                style: (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)((0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(monthLabel, {
                    text: content
                }), this._monthTextPositionControl(tmp, isCenter, orient, pos, margin)),
                silent: labelSilent
            });
            group.add(monthText);
        }
    };
    CalendarView.prototype._weekTextPositionControl = function(point, orient, position, margin, cellSize) {
        var align = 'center';
        var vAlign = 'middle';
        var x = point[0];
        var y = point[1];
        var isStart = position === 'start';
        if (orient === 'horizontal') {
            x = x + margin + (isStart ? 1 : -1) * cellSize[0] / 2;
            align = isStart ? 'right' : 'left';
        } else {
            y = y + margin + (isStart ? 1 : -1) * cellSize[1] / 2;
            vAlign = isStart ? 'bottom' : 'top';
        }
        return {
            x: x,
            y: y,
            align: align,
            verticalAlign: vAlign
        };
    };
    // render weeks
    CalendarView.prototype._renderWeekText = function(calendarModel, localeModel, rangeData, orient, group) {
        var dayLabel = calendarModel.getModel('dayLabel');
        if (!dayLabel.get('show')) return;
        var coordSys = calendarModel.coordinateSystem;
        var pos = dayLabel.get('position');
        var nameMap = dayLabel.get('nameMap');
        var margin = dayLabel.get('margin');
        var firstDayOfWeek = coordSys.getFirstDayOfWeek();
        if (!nameMap || (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(nameMap)) {
            if (nameMap) // case-sensitive
            localeModel = (0, $9b0a1ef4bcc91e7d$export$37cc638e0e11865f)(nameMap) || localeModel;
            // Use the first letter of `dayOfWeekAbbr` if `dayOfWeekShort` doesn't exist in the locale file
            var dayOfWeekShort = localeModel.get([
                'time',
                'dayOfWeekShort'
            ]);
            nameMap = dayOfWeekShort || (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(localeModel.get([
                'time',
                'dayOfWeekAbbr'
            ]), function(val) {
                return val[0];
            });
        }
        var start = coordSys.getNextNDay(rangeData.end.time, 7 - rangeData.lweek).time;
        var cellSize = [
            coordSys.getCellWidth(),
            coordSys.getCellHeight()
        ];
        margin = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(margin, Math.min(cellSize[1], cellSize[0]));
        if (pos === 'start') {
            start = coordSys.getNextNDay(rangeData.start.time, -(7 + rangeData.fweek)).time;
            margin = -margin;
        }
        var labelSilent = dayLabel.get('silent');
        for(var i = 0; i < 7; i++){
            var tmpD = coordSys.getNextNDay(start, i);
            var point = coordSys.dataToRect([
                tmpD.time
            ], false).center;
            var day = i;
            day = Math.abs((i + firstDayOfWeek) % 7);
            var weekText = new $fe885cc21795562b$export$2e2bcd8739ae039({
                z2: 30,
                style: (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)((0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(dayLabel, {
                    text: nameMap[day]
                }), this._weekTextPositionControl(point, orient, pos, margin, cellSize)),
                silent: labelSilent
            });
            group.add(weekText);
        }
    };
    CalendarView.type = 'calendar';
    return CalendarView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $e6b2dc17a91ad4af$export$2e2bcd8739ae039 = $e6b2dc17a91ad4af$var$CalendarView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


// (24*60*60*1000)
var $be2279b8e0028cb2$var$PROXIMATE_ONE_DAY = 86400000;
var $be2279b8e0028cb2$var$Calendar = /** @class */ function() {
    function Calendar(calendarModel, ecModel, api) {
        this.type = 'calendar';
        this.dimensions = Calendar.dimensions;
        // Required in createListFromData
        this.getDimensionsInfo = Calendar.getDimensionsInfo;
        this._model = calendarModel;
    }
    Calendar.getDimensionsInfo = function() {
        return [
            {
                name: 'time',
                type: 'time'
            },
            'value'
        ];
    };
    Calendar.prototype.getRangeInfo = function() {
        return this._rangeInfo;
    };
    Calendar.prototype.getModel = function() {
        return this._model;
    };
    Calendar.prototype.getRect = function() {
        return this._rect;
    };
    Calendar.prototype.getCellWidth = function() {
        return this._sw;
    };
    Calendar.prototype.getCellHeight = function() {
        return this._sh;
    };
    Calendar.prototype.getOrient = function() {
        return this._orient;
    };
    /**
   * getFirstDayOfWeek
   *
   * @example
   *     0 : start at Sunday
   *     1 : start at Monday
   *
   * @return {number}
   */ Calendar.prototype.getFirstDayOfWeek = function() {
        return this._firstDayOfWeek;
    };
    /**
   * get date info
   * }
   */ Calendar.prototype.getDateInfo = function(date) {
        date = $cfc1f3b422a3185f$export$6b862160d295c8e(date);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        var mStr = m < 10 ? '0' + m : '' + m;
        var d = date.getDate();
        var dStr = d < 10 ? '0' + d : '' + d;
        var day = date.getDay();
        day = Math.abs((day + 7 - this.getFirstDayOfWeek()) % 7);
        return {
            y: y + '',
            m: mStr,
            d: dStr,
            day: day,
            time: date.getTime(),
            formatedDate: y + '-' + mStr + '-' + dStr,
            date: date
        };
    };
    Calendar.prototype.getNextNDay = function(date, n) {
        n = n || 0;
        if (n === 0) return this.getDateInfo(date);
        date = new Date(this.getDateInfo(date).time);
        date.setDate(date.getDate() + n);
        return this.getDateInfo(date);
    };
    Calendar.prototype.update = function(ecModel, api) {
        this._firstDayOfWeek = +this._model.getModel('dayLabel').get('firstDay');
        this._orient = this._model.get('orient');
        this._lineWidth = this._model.getModel('itemStyle').getItemStyle().lineWidth || 0;
        this._rangeInfo = this._getRangeInfo(this._initRangeOption());
        var weeks = this._rangeInfo.weeks || 1;
        var whNames = [
            'width',
            'height'
        ];
        var cellSize = this._model.getCellSize().slice();
        var layoutParams = this._model.getBoxLayoutParams();
        var cellNumbers = this._orient === 'horizontal' ? [
            weeks,
            7
        ] : [
            7,
            weeks
        ];
        $7a1bd9c2710fea0d$export$79b2f7037acddd43([
            0,
            1
        ], function(idx) {
            if (cellSizeSpecified(cellSize, idx)) layoutParams[whNames[idx]] = cellSize[idx] * cellNumbers[idx];
        });
        var whGlobal = {
            width: api.getWidth(),
            height: api.getHeight()
        };
        var calendarRect = this._rect = $93b9bc7f22ac7369$export$4517a5ca639a7293(layoutParams, whGlobal);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43([
            0,
            1
        ], function(idx) {
            if (!cellSizeSpecified(cellSize, idx)) cellSize[idx] = calendarRect[whNames[idx]] / cellNumbers[idx];
        });
        function cellSizeSpecified(cellSize, idx) {
            return cellSize[idx] != null && cellSize[idx] !== 'auto';
        }
        // Has been calculated out number.
        this._sw = cellSize[0];
        this._sh = cellSize[1];
    };
    /**
   * Convert a time data(time, value) item to (x, y) point.
   */ // TODO Clamp of calendar is not same with cartesian coordinate systems.
    // It will return NaN if data exceeds.
    Calendar.prototype.dataToPoint = function(data, clamp) {
        $7a1bd9c2710fea0d$export$43bee75e5e14138e(data) && (data = data[0]);
        clamp == null && (clamp = true);
        var dayInfo = this.getDateInfo(data);
        var range = this._rangeInfo;
        var date = dayInfo.formatedDate;
        // if not in range return [NaN, NaN]
        if (clamp && !(dayInfo.time >= range.start.time && dayInfo.time < range.end.time + $be2279b8e0028cb2$var$PROXIMATE_ONE_DAY)) return [
            NaN,
            NaN
        ];
        var week = dayInfo.day;
        var nthWeek = this._getRangeInfo([
            range.start.time,
            date
        ]).nthWeek;
        if (this._orient === 'vertical') return [
            this._rect.x + week * this._sw + this._sw / 2,
            this._rect.y + nthWeek * this._sh + this._sh / 2
        ];
        return [
            this._rect.x + nthWeek * this._sw + this._sw / 2,
            this._rect.y + week * this._sh + this._sh / 2
        ];
    };
    /**
   * Convert a (x, y) point to time data
   */ Calendar.prototype.pointToData = function(point) {
        var date = this.pointToDate(point);
        return date && date.time;
    };
    /**
   * Convert a time date item to (x, y) four point.
   */ Calendar.prototype.dataToRect = function(data, clamp) {
        var point = this.dataToPoint(data, clamp);
        return {
            contentShape: {
                x: point[0] - (this._sw - this._lineWidth) / 2,
                y: point[1] - (this._sh - this._lineWidth) / 2,
                width: this._sw - this._lineWidth,
                height: this._sh - this._lineWidth
            },
            center: point,
            tl: [
                point[0] - this._sw / 2,
                point[1] - this._sh / 2
            ],
            tr: [
                point[0] + this._sw / 2,
                point[1] - this._sh / 2
            ],
            br: [
                point[0] + this._sw / 2,
                point[1] + this._sh / 2
            ],
            bl: [
                point[0] - this._sw / 2,
                point[1] + this._sh / 2
            ]
        };
    };
    /**
   * Convert a (x, y) point to time date
   *
   * @param  {Array} point point
   * @return {Object}       date
   */ Calendar.prototype.pointToDate = function(point) {
        var nthX = Math.floor((point[0] - this._rect.x) / this._sw) + 1;
        var nthY = Math.floor((point[1] - this._rect.y) / this._sh) + 1;
        var range = this._rangeInfo.range;
        if (this._orient === 'vertical') return this._getDateByWeeksAndDay(nthY, nthX - 1, range);
        return this._getDateByWeeksAndDay(nthX, nthY - 1, range);
    };
    Calendar.prototype.convertToPixel = function(ecModel, finder, value) {
        var coordSys = $be2279b8e0028cb2$var$getCoordSys(finder);
        return coordSys === this ? coordSys.dataToPoint(value) : null;
    };
    Calendar.prototype.convertFromPixel = function(ecModel, finder, pixel) {
        var coordSys = $be2279b8e0028cb2$var$getCoordSys(finder);
        return coordSys === this ? coordSys.pointToData(pixel) : null;
    };
    Calendar.prototype.containPoint = function(point) {
        console.warn('Not implemented.');
        return false;
    };
    /**
   * initRange
   * Normalize to an [start, end] array
   */ Calendar.prototype._initRangeOption = function() {
        var range = this._model.get('range');
        var normalizedRange;
        // Convert [1990] to 1990
        if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(range) && range.length === 1) range = range[0];
        if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(range)) {
            var rangeStr = range.toString();
            // One year.
            if (/^\d{4}$/.test(rangeStr)) normalizedRange = [
                rangeStr + '-01-01',
                rangeStr + '-12-31'
            ];
            // One month
            if (/^\d{4}[\/|-]\d{1,2}$/.test(rangeStr)) {
                var start = this.getDateInfo(rangeStr);
                var firstDay = start.date;
                firstDay.setMonth(firstDay.getMonth() + 1);
                var end = this.getNextNDay(firstDay, -1);
                normalizedRange = [
                    start.formatedDate,
                    end.formatedDate
                ];
            }
            // One day
            if (/^\d{4}[\/|-]\d{1,2}[\/|-]\d{1,2}$/.test(rangeStr)) normalizedRange = [
                rangeStr,
                rangeStr
            ];
        } else normalizedRange = range;
        if (!normalizedRange) // Not handling it.
        return range;
        var tmp = this._getRangeInfo(normalizedRange);
        if (tmp.start.time > tmp.end.time) normalizedRange.reverse();
        return normalizedRange;
    };
    /**
   * range info
   *
   * @private
   * @param  {Array} range range ['2017-01-01', '2017-07-08']
   *  If range[0] > range[1], they will not be reversed.
   * @return {Object}       obj
   */ Calendar.prototype._getRangeInfo = function(range) {
        var parsedRange = [
            this.getDateInfo(range[0]),
            this.getDateInfo(range[1])
        ];
        var reversed;
        if (parsedRange[0].time > parsedRange[1].time) {
            reversed = true;
            parsedRange.reverse();
        }
        var allDay = Math.floor(parsedRange[1].time / $be2279b8e0028cb2$var$PROXIMATE_ONE_DAY) - Math.floor(parsedRange[0].time / $be2279b8e0028cb2$var$PROXIMATE_ONE_DAY) + 1;
        // Consider case1 (#11677 #10430):
        // Set the system timezone as "UK", set the range to `['2016-07-01', '2016-12-31']`
        // Consider case2:
        // Firstly set system timezone as "Time Zone: America/Toronto",
        // ```
        // let first = new Date(1478412000000 - 3600 * 1000 * 2.5);
        // let second = new Date(1478412000000);
        // let allDays = Math.floor(second / ONE_DAY) - Math.floor(first / ONE_DAY) + 1;
        // ```
        // will get wrong result because of DST. So we should fix it.
        var date = new Date(parsedRange[0].time);
        var startDateNum = date.getDate();
        var endDateNum = parsedRange[1].date.getDate();
        date.setDate(startDateNum + allDay - 1);
        // The bias can not over a month, so just compare date.
        var dateNum = date.getDate();
        if (dateNum !== endDateNum) {
            var sign = date.getTime() - parsedRange[1].time > 0 ? 1 : -1;
            while((dateNum = date.getDate()) !== endDateNum && (date.getTime() - parsedRange[1].time) * sign > 0){
                allDay -= sign;
                date.setDate(dateNum - sign);
            }
        }
        var weeks = Math.floor((allDay + parsedRange[0].day + 6) / 7);
        var nthWeek = reversed ? -weeks + 1 : weeks - 1;
        reversed && parsedRange.reverse();
        return {
            range: [
                parsedRange[0].formatedDate,
                parsedRange[1].formatedDate
            ],
            start: parsedRange[0],
            end: parsedRange[1],
            allDay: allDay,
            weeks: weeks,
            // From 0.
            nthWeek: nthWeek,
            fweek: parsedRange[0].day,
            lweek: parsedRange[1].day
        };
    };
    /**
   * get date by nthWeeks and week day in range
   *
   * @private
   * @param  {number} nthWeek the week
   * @param  {number} day   the week day
   * @param  {Array} range [d1, d2]
   * @return {Object}
   */ Calendar.prototype._getDateByWeeksAndDay = function(nthWeek, day, range) {
        var rangeInfo = this._getRangeInfo(range);
        if (nthWeek > rangeInfo.weeks || nthWeek === 0 && day < rangeInfo.fweek || nthWeek === rangeInfo.weeks && day > rangeInfo.lweek) return null;
        var nthDay = (nthWeek - 1) * 7 - rangeInfo.fweek + day;
        var date = new Date(rangeInfo.start.time);
        date.setDate(+rangeInfo.start.d + nthDay);
        return this.getDateInfo(date);
    };
    Calendar.create = function(ecModel, api) {
        var calendarList = [];
        ecModel.eachComponent('calendar', function(calendarModel) {
            var calendar = new Calendar(calendarModel, ecModel, api);
            calendarList.push(calendar);
            calendarModel.coordinateSystem = calendar;
        });
        ecModel.eachSeries(function(calendarSeries) {
            if (calendarSeries.get('coordinateSystem') === 'calendar') // Inject coordinate system
            calendarSeries.coordinateSystem = calendarList[calendarSeries.get('calendarIndex') || 0];
        });
        return calendarList;
    };
    Calendar.dimensions = [
        'time',
        'value'
    ];
    return Calendar;
}();
function $be2279b8e0028cb2$var$getCoordSys(finder) {
    var calendarModel = finder.calendarModel;
    var seriesModel = finder.seriesModel;
    var coordSys = calendarModel ? calendarModel.coordinateSystem : seriesModel ? seriesModel.coordinateSystem : null;
    return coordSys;
}
var $be2279b8e0028cb2$export$2e2bcd8739ae039 = $be2279b8e0028cb2$var$Calendar;


function $c1c3b68ff9dcc3e7$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $795d2d92b1d02c70$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $e6b2dc17a91ad4af$export$2e2bcd8739ae039));
    registers.registerCoordinateSystem('calendar', (0, $be2279b8e0028cb2$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $afb70cea6fec4fe0$export$83e718f1c3c9edae = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(DatasetModel, _super);
    function DatasetModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'dataset';
        return _this;
    }
    DatasetModel.prototype.init = function(option, parentModel, ecModel) {
        _super.prototype.init.call(this, option, parentModel, ecModel);
        this._sourceManager = new (0, $1c87d176de397e7e$export$af4db9ec7e200ea2)(this);
        (0, $1c87d176de397e7e$export$9451f4e9047441ec)(this);
    };
    DatasetModel.prototype.mergeOption = function(newOption, ecModel) {
        _super.prototype.mergeOption.call(this, newOption, ecModel);
        (0, $1c87d176de397e7e$export$9451f4e9047441ec)(this);
    };
    DatasetModel.prototype.optionUpdated = function() {
        this._sourceManager.dirty();
    };
    DatasetModel.prototype.getSourceManager = function() {
        return this._sourceManager;
    };
    DatasetModel.type = 'dataset';
    DatasetModel.defaultOption = {
        seriesLayoutBy: (0, $cab29724515ce2b8$export$7b3f3c6551b4949b)
    };
    return DatasetModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $afb70cea6fec4fe0$var$DatasetView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(DatasetView, _super);
    function DatasetView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'dataset';
        return _this;
    }
    DatasetView.type = 'dataset';
    return DatasetView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
function $afb70cea6fec4fe0$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel($afb70cea6fec4fe0$export$83e718f1c3c9edae);
    registers.registerComponentView($afb70cea6fec4fe0$var$DatasetView);
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $554cb472ba0e05d3$export$f25521e726513e83 = [
    'x',
    'y',
    'radius',
    'angle',
    'single'
];
// Supported coords.
// FIXME: polar has been broken (but rarely used).
var $554cb472ba0e05d3$var$SERIES_COORDS = [
    'cartesian2d',
    'polar',
    'singleAxis'
];
function $554cb472ba0e05d3$export$2d449d4adc0d2cfc(seriesModel) {
    var coordType = seriesModel.get('coordinateSystem');
    return (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)($554cb472ba0e05d3$var$SERIES_COORDS, coordType) >= 0;
}
function $554cb472ba0e05d3$export$90855f7219399082(axisDim) {
    return axisDim + 'Axis';
}
function $554cb472ba0e05d3$export$f9c16e110bf1e902(axisDim) {
    return axisDim + 'AxisIndex';
}
function $554cb472ba0e05d3$export$fa8714b2310ddff9(axisDim) {
    return axisDim + 'AxisId';
}
function $554cb472ba0e05d3$export$9e00b6c2b8b2e9a7(ecModel, payload) {
    // Key: `DataZoomAxisDimension`
    var axisRecords = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    var effectedModels = [];
    // Key: uid of dataZoomModel
    var effectedModelMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    // Find the dataZooms specified by payload.
    ecModel.eachComponent({
        mainType: 'dataZoom',
        query: payload
    }, function(dataZoomModel) {
        if (!effectedModelMap.get(dataZoomModel.uid)) addToEffected(dataZoomModel);
    });
    // Start from the given dataZoomModels, travel the graph to find
    // all of the linked dataZoom models.
    var foundNewLink;
    do {
        foundNewLink = false;
        ecModel.eachComponent('dataZoom', processSingle);
    }while (foundNewLink);
    function processSingle(dataZoomModel) {
        if (!effectedModelMap.get(dataZoomModel.uid) && isLinked(dataZoomModel)) {
            addToEffected(dataZoomModel);
            foundNewLink = true;
        }
    }
    function addToEffected(dataZoom) {
        effectedModelMap.set(dataZoom.uid, true);
        effectedModels.push(dataZoom);
        markAxisControlled(dataZoom);
    }
    function isLinked(dataZoomModel) {
        var isLink = false;
        dataZoomModel.eachTargetAxis(function(axisDim, axisIndex) {
            var axisIdxArr = axisRecords.get(axisDim);
            if (axisIdxArr && axisIdxArr[axisIndex]) isLink = true;
        });
        return isLink;
    }
    function markAxisControlled(dataZoomModel) {
        dataZoomModel.eachTargetAxis(function(axisDim, axisIndex) {
            (axisRecords.get(axisDim) || axisRecords.set(axisDim, []))[axisIndex] = true;
        });
    }
    return effectedModels;
}
function $554cb472ba0e05d3$export$b41173dee9da195b(dataZoomModel) {
    var ecModel = dataZoomModel.ecModel;
    var coordSysInfoWrap = {
        infoList: [],
        infoMap: (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)()
    };
    dataZoomModel.eachTargetAxis(function(axisDim, axisIndex) {
        var axisModel = ecModel.getComponent($554cb472ba0e05d3$export$90855f7219399082(axisDim), axisIndex);
        if (!axisModel) return;
        var coordSysModel = axisModel.getCoordSysModel();
        if (!coordSysModel) return;
        var coordSysUid = coordSysModel.uid;
        var coordSysInfo = coordSysInfoWrap.infoMap.get(coordSysUid);
        if (!coordSysInfo) {
            coordSysInfo = {
                model: coordSysModel,
                axisModels: []
            };
            coordSysInfoWrap.infoList.push(coordSysInfo);
            coordSysInfoWrap.infoMap.set(coordSysUid, coordSysInfo);
        }
        coordSysInfo.axisModels.push(axisModel);
    });
    return coordSysInfoWrap;
}



var $41d57478d16bff21$var$DataZoomAxisInfo = /** @class */ function() {
    function DataZoomAxisInfo() {
        this.indexList = [];
        this.indexMap = [];
    }
    DataZoomAxisInfo.prototype.add = function(axisCmptIdx) {
        // Remove duplication.
        if (!this.indexMap[axisCmptIdx]) {
            this.indexList.push(axisCmptIdx);
            this.indexMap[axisCmptIdx] = true;
        }
    };
    return DataZoomAxisInfo;
}();
var $41d57478d16bff21$var$DataZoomModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(DataZoomModel, _super);
    function DataZoomModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = DataZoomModel.type;
        _this._autoThrottle = true;
        _this._noTarget = true;
        /**
     * It is `[rangeModeForMin, rangeModeForMax]`.
     * The optional values for `rangeMode`:
     * + `'value'` mode: the axis extent will always be determined by
     *     `dataZoom.startValue` and `dataZoom.endValue`, despite
     *     how data like and how `axis.min` and `axis.max` are.
     * + `'percent'` mode: `100` represents 100% of the `[dMin, dMax]`,
     *     where `dMin` is `axis.min` if `axis.min` specified, otherwise `data.extent[0]`,
     *     and `dMax` is `axis.max` if `axis.max` specified, otherwise `data.extent[1]`.
     *     Axis extent will be determined by the result of the percent of `[dMin, dMax]`.
     *
     * For example, when users are using dynamic data (update data periodically via `setOption`),
     * if in `'value`' mode, the window will be kept in a fixed value range despite how
     * data are appended, while if in `'percent'` mode, whe window range will be changed alone with
     * the appended data (suppose `axis.min` and `axis.max` are not specified).
     */ _this._rangePropMode = [
            'percent',
            'percent'
        ];
        return _this;
    }
    DataZoomModel.prototype.init = function(option, parentModel, ecModel) {
        var inputRawOption = $41d57478d16bff21$var$retrieveRawOption(option);
        /**
     * Suppose a "main process" start at the point that model prepared (that is,
     * model initialized or merged or method called in `action`).
     * We should keep the `main process` idempotent, that is, given a set of values
     * on `option`, we get the same result.
     *
     * But sometimes, values on `option` will be updated for providing users
     * a "final calculated value" (`dataZoomProcessor` will do that). Those value
     * should not be the base/input of the `main process`.
     *
     * So in that case we should save and keep the input of the `main process`
     * separately, called `settledOption`.
     *
     * For example, consider the case:
     * (Step_1) brush zoom the grid by `toolbox.dataZoom`,
     *     where the original input `option.startValue`, `option.endValue` are earsed by
     *     calculated value.
     * (Step)2) click the legend to hide and show a series,
     *     where the new range is calculated by the earsed `startValue` and `endValue`,
     *     which brings incorrect result.
     */ this.settledOption = inputRawOption;
        this.mergeDefaultAndTheme(option, ecModel);
        this._doInit(inputRawOption);
    };
    DataZoomModel.prototype.mergeOption = function(newOption) {
        var inputRawOption = $41d57478d16bff21$var$retrieveRawOption(newOption);
        // FIX #2591
        (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)(this.option, newOption, true);
        (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)(this.settledOption, inputRawOption, true);
        this._doInit(inputRawOption);
    };
    DataZoomModel.prototype._doInit = function(inputRawOption) {
        var thisOption = this.option;
        this._setDefaultThrottle(inputRawOption);
        this._updateRangeUse(inputRawOption);
        var settledOption = this.settledOption;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
            [
                'start',
                'startValue'
            ],
            [
                'end',
                'endValue'
            ]
        ], function(names, index) {
            // start/end has higher priority over startValue/endValue if they
            // both set, but we should make chart.setOption({endValue: 1000})
            // effective, rather than chart.setOption({endValue: 1000, end: null}).
            if (this._rangePropMode[index] === 'value') thisOption[names[0]] = settledOption[names[0]] = null;
        // Otherwise do nothing and use the merge result.
        }, this);
        this._resetTarget();
    };
    DataZoomModel.prototype._resetTarget = function() {
        var optionOrient = this.get('orient', true);
        var targetAxisIndexMap = this._targetAxisInfoMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        var hasAxisSpecified = this._fillSpecifiedTargetAxis(targetAxisIndexMap);
        if (hasAxisSpecified) this._orient = optionOrient || this._makeAutoOrientByTargetAxis();
        else {
            this._orient = optionOrient || 'horizontal';
            this._fillAutoTargetAxisByOrient(targetAxisIndexMap, this._orient);
        }
        this._noTarget = true;
        targetAxisIndexMap.each(function(axisInfo) {
            if (axisInfo.indexList.length) this._noTarget = false;
        }, this);
    };
    DataZoomModel.prototype._fillSpecifiedTargetAxis = function(targetAxisIndexMap) {
        var hasAxisSpecified = false;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $554cb472ba0e05d3$export$f25521e726513e83), function(axisDim) {
            var refering = this.getReferringComponents((0, $554cb472ba0e05d3$export$90855f7219399082)(axisDim), (0, $76d619f648247e6d$export$48d598924ce4892c));
            // When user set axisIndex as a empty array, we think that user specify axisIndex
            // but do not want use auto mode. Because empty array may be encountered when
            // some error occurred.
            if (!refering.specified) return;
            hasAxisSpecified = true;
            var axisInfo = new $41d57478d16bff21$var$DataZoomAxisInfo();
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(refering.models, function(axisModel) {
                axisInfo.add(axisModel.componentIndex);
            });
            targetAxisIndexMap.set(axisDim, axisInfo);
        }, this);
        return hasAxisSpecified;
    };
    DataZoomModel.prototype._fillAutoTargetAxisByOrient = function(targetAxisIndexMap, orient) {
        var ecModel = this.ecModel;
        var needAuto = true;
        // Find axis that parallel to dataZoom as default.
        if (needAuto) {
            var axisDim = orient === 'vertical' ? 'y' : 'x';
            var axisModels = ecModel.findComponents({
                mainType: axisDim + 'Axis'
            });
            setParallelAxis(axisModels, axisDim);
        }
        // Find axis that parallel to dataZoom as default.
        if (needAuto) {
            var axisModels = ecModel.findComponents({
                mainType: 'singleAxis',
                filter: function(axisModel) {
                    return axisModel.get('orient', true) === orient;
                }
            });
            setParallelAxis(axisModels, 'single');
        }
        function setParallelAxis(axisModels, axisDim) {
            // At least use the first parallel axis as the target axis.
            var axisModel = axisModels[0];
            if (!axisModel) return;
            var axisInfo = new $41d57478d16bff21$var$DataZoomAxisInfo();
            axisInfo.add(axisModel.componentIndex);
            targetAxisIndexMap.set(axisDim, axisInfo);
            needAuto = false;
            // Find parallel axes in the same grid.
            if (axisDim === 'x' || axisDim === 'y') {
                var gridModel_1 = axisModel.getReferringComponents('grid', (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
                gridModel_1 && (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axisModels, function(axModel) {
                    if (axisModel.componentIndex !== axModel.componentIndex && gridModel_1 === axModel.getReferringComponents('grid', (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0]) axisInfo.add(axModel.componentIndex);
                });
            }
        }
        if (needAuto) // If no parallel axis, find the first category axis as default. (Also consider polar).
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $554cb472ba0e05d3$export$f25521e726513e83), function(axisDim) {
            if (!needAuto) return;
            var axisModels = ecModel.findComponents({
                mainType: (0, $554cb472ba0e05d3$export$90855f7219399082)(axisDim),
                filter: function(axisModel) {
                    return axisModel.get('type', true) === 'category';
                }
            });
            if (axisModels[0]) {
                var axisInfo = new $41d57478d16bff21$var$DataZoomAxisInfo();
                axisInfo.add(axisModels[0].componentIndex);
                targetAxisIndexMap.set(axisDim, axisInfo);
                needAuto = false;
            }
        }, this);
    };
    DataZoomModel.prototype._makeAutoOrientByTargetAxis = function() {
        var dim;
        // Find the first axis
        this.eachTargetAxis(function(axisDim) {
            !dim && (dim = axisDim);
        }, this);
        return dim === 'y' ? 'vertical' : 'horizontal';
    };
    DataZoomModel.prototype._setDefaultThrottle = function(inputRawOption) {
        // When first time user set throttle, auto throttle ends.
        if (inputRawOption.hasOwnProperty('throttle')) this._autoThrottle = false;
        if (this._autoThrottle) {
            var globalOption = this.ecModel.option;
            this.option.throttle = globalOption.animation && globalOption.animationDurationUpdate > 0 ? 100 : 20;
        }
    };
    DataZoomModel.prototype._updateRangeUse = function(inputRawOption) {
        var rangePropMode = this._rangePropMode;
        var rangeModeInOption = this.get('rangeMode');
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
            [
                'start',
                'startValue'
            ],
            [
                'end',
                'endValue'
            ]
        ], function(names, index) {
            var percentSpecified = inputRawOption[names[0]] != null;
            var valueSpecified = inputRawOption[names[1]] != null;
            if (percentSpecified && !valueSpecified) rangePropMode[index] = 'percent';
            else if (!percentSpecified && valueSpecified) rangePropMode[index] = 'value';
            else if (rangeModeInOption) rangePropMode[index] = rangeModeInOption[index];
            else if (percentSpecified) // percentSpecified && valueSpecified
            rangePropMode[index] = 'percent';
        // else remain its original setting.
        });
    };
    DataZoomModel.prototype.noTarget = function() {
        return this._noTarget;
    };
    DataZoomModel.prototype.getFirstTargetAxisModel = function() {
        var firstAxisModel;
        this.eachTargetAxis(function(axisDim, axisIndex) {
            if (firstAxisModel == null) firstAxisModel = this.ecModel.getComponent((0, $554cb472ba0e05d3$export$90855f7219399082)(axisDim), axisIndex);
        }, this);
        return firstAxisModel;
    };
    /**
   * @param {Function} callback param: axisModel, dimNames, axisIndex, dataZoomModel, ecModel
   */ DataZoomModel.prototype.eachTargetAxis = function(callback, context) {
        this._targetAxisInfoMap.each(function(axisInfo, axisDim) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axisInfo.indexList, function(axisIndex) {
                callback.call(context, axisDim, axisIndex);
            });
        });
    };
    /**
   * @return If not found, return null/undefined.
   */ DataZoomModel.prototype.getAxisProxy = function(axisDim, axisIndex) {
        var axisModel = this.getAxisModel(axisDim, axisIndex);
        if (axisModel) return axisModel.__dzAxisProxy;
    };
    /**
   * @return If not found, return null/undefined.
   */ DataZoomModel.prototype.getAxisModel = function(axisDim, axisIndex) {
        var axisInfo = this._targetAxisInfoMap.get(axisDim);
        if (axisInfo && axisInfo.indexMap[axisIndex]) return this.ecModel.getComponent((0, $554cb472ba0e05d3$export$90855f7219399082)(axisDim), axisIndex);
    };
    /**
   * If not specified, set to undefined.
   */ DataZoomModel.prototype.setRawRange = function(opt) {
        var thisOption = this.option;
        var settledOption = this.settledOption;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
            [
                'start',
                'startValue'
            ],
            [
                'end',
                'endValue'
            ]
        ], function(names) {
            // Consider the pair <start, startValue>:
            // If one has value and the other one is `null/undefined`, we both set them
            // to `settledOption`. This strategy enables the feature to clear the original
            // value in `settledOption` to `null/undefined`.
            // But if both of them are `null/undefined`, we do not set them to `settledOption`
            // and keep `settledOption` with the original value. This strategy enables users to
            // only set <end or endValue> but not set <start or startValue> when calling
            // `dispatchAction`.
            // The pair <end, endValue> is treated in the same way.
            if (opt[names[0]] != null || opt[names[1]] != null) {
                thisOption[names[0]] = settledOption[names[0]] = opt[names[0]];
                thisOption[names[1]] = settledOption[names[1]] = opt[names[1]];
            }
        }, this);
        this._updateRangeUse(opt);
    };
    DataZoomModel.prototype.setCalculatedRange = function(opt) {
        var option = this.option;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
            'start',
            'startValue',
            'end',
            'endValue'
        ], function(name) {
            option[name] = opt[name];
        });
    };
    DataZoomModel.prototype.getPercentRange = function() {
        var axisProxy = this.findRepresentativeAxisProxy();
        if (axisProxy) return axisProxy.getDataPercentWindow();
    };
    /**
   * For example, chart.getModel().getComponent('dataZoom').getValueRange('y', 0);
   *
   * @return [startValue, endValue] value can only be '-' or finite number.
   */ DataZoomModel.prototype.getValueRange = function(axisDim, axisIndex) {
        if (axisDim == null && axisIndex == null) {
            var axisProxy = this.findRepresentativeAxisProxy();
            if (axisProxy) return axisProxy.getDataValueWindow();
        } else return this.getAxisProxy(axisDim, axisIndex).getDataValueWindow();
    };
    /**
   * @param axisModel If axisModel given, find axisProxy
   *      corresponding to the axisModel
   */ DataZoomModel.prototype.findRepresentativeAxisProxy = function(axisModel) {
        if (axisModel) return axisModel.__dzAxisProxy;
        // Find the first hosted axisProxy
        var firstProxy;
        var axisDimList = this._targetAxisInfoMap.keys();
        for(var i = 0; i < axisDimList.length; i++){
            var axisDim = axisDimList[i];
            var axisInfo = this._targetAxisInfoMap.get(axisDim);
            for(var j = 0; j < axisInfo.indexList.length; j++){
                var proxy = this.getAxisProxy(axisDim, axisInfo.indexList[j]);
                if (proxy.hostedBy(this)) return proxy;
                if (!firstProxy) firstProxy = proxy;
            }
        }
        // If no hosted proxy found, still need to return a proxy.
        // This case always happens in toolbox dataZoom, where axes are all hosted by
        // other dataZooms.
        return firstProxy;
    };
    DataZoomModel.prototype.getRangePropMode = function() {
        return this._rangePropMode.slice();
    };
    DataZoomModel.prototype.getOrient = function() {
        return this._orient;
    };
    DataZoomModel.type = 'dataZoom';
    DataZoomModel.dependencies = [
        'xAxis',
        'yAxis',
        'radiusAxis',
        'angleAxis',
        'singleAxis',
        'series',
        'toolbox'
    ];
    DataZoomModel.defaultOption = {
        // zlevel: 0,
        z: 4,
        filterMode: 'filter',
        start: 0,
        end: 100
    };
    return DataZoomModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
/**
 * Retrieve those raw params from option, which will be cached separately,
 * because they will be overwritten by normalized/calculated values in the main
 * process.
 */ function $41d57478d16bff21$var$retrieveRawOption(option) {
    var ret = {};
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
        'start',
        'end',
        'startValue',
        'endValue',
        'throttle'
    ], function(name) {
        option.hasOwnProperty(name) && (ret[name] = option[name]);
    });
    return ret;
}
var $41d57478d16bff21$export$2e2bcd8739ae039 = $41d57478d16bff21$var$DataZoomModel;



var $6cccca1a1040a7a1$var$InsideZoomModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(InsideZoomModel, _super);
    function InsideZoomModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = InsideZoomModel.type;
        return _this;
    }
    InsideZoomModel.type = 'dataZoom.inside';
    InsideZoomModel.defaultOption = (0, $5370df662b2caf37$export$68acc510e46fef2)((0, $41d57478d16bff21$export$2e2bcd8739ae039).defaultOption, {
        disabled: false,
        zoomLock: false,
        zoomOnMouseWheel: true,
        moveOnMouseMove: true,
        moveOnMouseWheel: false,
        preventDefaultMouseMove: true
    });
    return InsideZoomModel;
}((0, $41d57478d16bff21$export$2e2bcd8739ae039));
var $6cccca1a1040a7a1$export$2e2bcd8739ae039 = $6cccca1a1040a7a1$var$InsideZoomModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $80d6a03162f25654$var$DataZoomView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(DataZoomView, _super);
    function DataZoomView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = DataZoomView.type;
        return _this;
    }
    DataZoomView.prototype.render = function(dataZoomModel, ecModel, api, payload) {
        this.dataZoomModel = dataZoomModel;
        this.ecModel = ecModel;
        this.api = api;
    };
    DataZoomView.type = 'dataZoom';
    return DataZoomView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $80d6a03162f25654$export$2e2bcd8739ae039 = $80d6a03162f25654$var$DataZoomView;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Only create one roam controller for each coordinate system.
// one roam controller might be refered by two inside data zoom
// components (for example, one for x and one for y). When user
// pan or zoom, only dispatch one action for those data zoom
// components.





var $6379ab7b9c3fbfb6$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $6379ab7b9c3fbfb6$export$c499fdc26107c565(api, dataZoomModel, getRange) {
    $6379ab7b9c3fbfb6$var$inner(api).coordSysRecordMap.each(function(coordSysRecord) {
        var dzInfo = coordSysRecord.dataZoomInfoMap.get(dataZoomModel.uid);
        if (dzInfo) dzInfo.getRange = getRange;
    });
}
function $6379ab7b9c3fbfb6$export$d074fdbbb2bf218c(api, dataZoomModel) {
    var coordSysRecordMap = $6379ab7b9c3fbfb6$var$inner(api).coordSysRecordMap;
    var coordSysKeyArr = coordSysRecordMap.keys();
    for(var i = 0; i < coordSysKeyArr.length; i++){
        var coordSysKey = coordSysKeyArr[i];
        var coordSysRecord = coordSysRecordMap.get(coordSysKey);
        var dataZoomInfoMap = coordSysRecord.dataZoomInfoMap;
        if (dataZoomInfoMap) {
            var dzUid = dataZoomModel.uid;
            var dzInfo = dataZoomInfoMap.get(dzUid);
            if (dzInfo) {
                dataZoomInfoMap.removeKey(dzUid);
                if (!dataZoomInfoMap.keys().length) $6379ab7b9c3fbfb6$var$disposeCoordSysRecord(coordSysRecordMap, coordSysRecord);
            }
        }
    }
}
function $6379ab7b9c3fbfb6$var$disposeCoordSysRecord(coordSysRecordMap, coordSysRecord) {
    if (coordSysRecord) {
        coordSysRecordMap.removeKey(coordSysRecord.model.uid);
        var controller = coordSysRecord.controller;
        controller && controller.dispose();
    }
}
function $6379ab7b9c3fbfb6$var$createCoordSysRecord(api, coordSysModel) {
    // These init props will never change after record created.
    var coordSysRecord = {
        model: coordSysModel,
        containsPoint: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($6379ab7b9c3fbfb6$var$containsPoint, coordSysModel),
        dispatchAction: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($6379ab7b9c3fbfb6$var$dispatchAction, api),
        dataZoomInfoMap: null,
        controller: null
    };
    // Must not do anything depends on coordSysRecord outside the event handler here,
    // because coordSysRecord not completed yet.
    var controller = coordSysRecord.controller = new (0, $15927f329deeab51$export$2e2bcd8739ae039)(api.getZr());
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
        'pan',
        'zoom',
        'scrollMove'
    ], function(eventName) {
        controller.on(eventName, function(event) {
            var batch = [];
            coordSysRecord.dataZoomInfoMap.each(function(dzInfo) {
                // Check whether the behaviors (zoomOnMouseWheel, moveOnMouseMove,
                // moveOnMouseWheel, ...) enabled.
                if (!event.isAvailableBehavior(dzInfo.model.option)) return;
                var method = (dzInfo.getRange || {})[eventName];
                var range = method && method(dzInfo.dzReferCoordSysInfo, coordSysRecord.model.mainType, coordSysRecord.controller, event);
                !dzInfo.model.get('disabled', true) && range && batch.push({
                    dataZoomId: dzInfo.model.id,
                    start: range[0],
                    end: range[1]
                });
            });
            batch.length && coordSysRecord.dispatchAction(batch);
        });
    });
    return coordSysRecord;
}
/**
 * This action will be throttled.
 */ function $6379ab7b9c3fbfb6$var$dispatchAction(api, batch) {
    if (!api.isDisposed()) api.dispatchAction({
        type: 'dataZoom',
        animation: {
            easing: 'cubicOut',
            duration: 100
        },
        batch: batch
    });
}
function $6379ab7b9c3fbfb6$var$containsPoint(coordSysModel, e, x, y) {
    return coordSysModel.coordinateSystem.containPoint([
        x,
        y
    ]);
}
/**
 * Merge roamController settings when multiple dataZooms share one roamController.
 */ function $6379ab7b9c3fbfb6$var$mergeControllerParams(dataZoomInfoMap) {
    var controlType;
    // DO NOT use reserved word (true, false, undefined) as key literally. Even if encapsulated
    // as string, it is probably revert to reserved word by compress tool. See #7411.
    var prefix = 'type_';
    var typePriority = {
        'type_true': 2,
        'type_move': 1,
        'type_false': 0,
        'type_undefined': -1
    };
    var preventDefaultMouseMove = true;
    dataZoomInfoMap.each(function(dataZoomInfo) {
        var dataZoomModel = dataZoomInfo.model;
        var oneType = dataZoomModel.get('disabled', true) ? false : dataZoomModel.get('zoomLock', true) ? 'move' : true;
        if (typePriority[prefix + oneType] > typePriority[prefix + controlType]) controlType = oneType;
        // Prevent default move event by default. If one false, do not prevent. Otherwise
        // users may be confused why it does not work when multiple insideZooms exist.
        preventDefaultMouseMove = preventDefaultMouseMove && dataZoomModel.get('preventDefaultMouseMove', true);
    });
    return {
        controlType: controlType,
        opt: {
            // RoamController will enable all of these functionalities,
            // and the final behavior is determined by its event listener
            // provided by each inside zoom.
            zoomOnMouseWheel: true,
            moveOnMouseMove: true,
            moveOnMouseWheel: true,
            preventDefaultMouseMove: !!preventDefaultMouseMove
        }
    };
}
function $6379ab7b9c3fbfb6$export$f3632ddafc9ea51e(registers) {
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.FILTER, function(ecModel, api) {
        var apiInner = $6379ab7b9c3fbfb6$var$inner(api);
        var coordSysRecordMap = apiInner.coordSysRecordMap || (apiInner.coordSysRecordMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)());
        coordSysRecordMap.each(function(coordSysRecord) {
            // `coordSysRecordMap` always exists (because it holds the `roam controller`, which should
            // better not re-create each time), but clear `dataZoomInfoMap` each round of the workflow.
            coordSysRecord.dataZoomInfoMap = null;
        });
        ecModel.eachComponent({
            mainType: 'dataZoom',
            subType: 'inside'
        }, function(dataZoomModel) {
            var dzReferCoordSysWrap = (0, $554cb472ba0e05d3$export$b41173dee9da195b)(dataZoomModel);
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dzReferCoordSysWrap.infoList, function(dzCoordSysInfo) {
                var coordSysUid = dzCoordSysInfo.model.uid;
                var coordSysRecord = coordSysRecordMap.get(coordSysUid) || coordSysRecordMap.set(coordSysUid, $6379ab7b9c3fbfb6$var$createCoordSysRecord(api, dzCoordSysInfo.model));
                var dataZoomInfoMap = coordSysRecord.dataZoomInfoMap || (coordSysRecord.dataZoomInfoMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)());
                // Notice these props might be changed each time for a single dataZoomModel.
                dataZoomInfoMap.set(dataZoomModel.uid, {
                    dzReferCoordSysInfo: dzCoordSysInfo,
                    model: dataZoomModel,
                    getRange: null
                });
            });
        });
        // (1) Merge dataZoom settings for each coord sys and set to the roam controller.
        // (2) Clear coord sys if not refered by any dataZoom.
        coordSysRecordMap.each(function(coordSysRecord) {
            var controller = coordSysRecord.controller;
            var firstDzInfo;
            var dataZoomInfoMap = coordSysRecord.dataZoomInfoMap;
            if (dataZoomInfoMap) {
                var firstDzKey = dataZoomInfoMap.keys()[0];
                if (firstDzKey != null) firstDzInfo = dataZoomInfoMap.get(firstDzKey);
            }
            if (!firstDzInfo) {
                $6379ab7b9c3fbfb6$var$disposeCoordSysRecord(coordSysRecordMap, coordSysRecord);
                return;
            }
            var controllerParams = $6379ab7b9c3fbfb6$var$mergeControllerParams(dataZoomInfoMap);
            controller.enable(controllerParams.controlType, controllerParams.opt);
            controller.setPointerChecker(coordSysRecord.containsPoint);
            $c98659a9437a3d2e$export$958e3e1a02eac4b6(coordSysRecord, 'dispatchAction', firstDzInfo.model.get('throttle', true), 'fixRate');
        });
    });
}



var $ad4d16a462c12aaf$var$InsideZoomView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(InsideZoomView, _super);
    function InsideZoomView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'dataZoom.inside';
        return _this;
    }
    InsideZoomView.prototype.render = function(dataZoomModel, ecModel, api) {
        _super.prototype.render.apply(this, arguments);
        if (dataZoomModel.noTarget()) {
            this._clear();
            return;
        }
        // Hence the `throttle` util ensures to preserve command order,
        // here simply updating range all the time will not cause missing
        // any of the the roam change.
        this.range = dataZoomModel.getPercentRange();
        // Reset controllers.
        $6379ab7b9c3fbfb6$export$c499fdc26107c565(api, dataZoomModel, {
            pan: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)($ad4d16a462c12aaf$var$getRangeHandlers.pan, this),
            zoom: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)($ad4d16a462c12aaf$var$getRangeHandlers.zoom, this),
            scrollMove: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)($ad4d16a462c12aaf$var$getRangeHandlers.scrollMove, this)
        });
    };
    InsideZoomView.prototype.dispose = function() {
        this._clear();
        _super.prototype.dispose.apply(this, arguments);
    };
    InsideZoomView.prototype._clear = function() {
        $6379ab7b9c3fbfb6$export$d074fdbbb2bf218c(this.api, this.dataZoomModel);
        this.range = null;
    };
    InsideZoomView.type = 'dataZoom.inside';
    return InsideZoomView;
}((0, $80d6a03162f25654$export$2e2bcd8739ae039));
var $ad4d16a462c12aaf$var$getRangeHandlers = {
    zoom: function(coordSysInfo, coordSysMainType, controller, e) {
        var lastRange = this.range;
        var range = lastRange.slice();
        // Calculate transform by the first axis.
        var axisModel = coordSysInfo.axisModels[0];
        if (!axisModel) return;
        var directionInfo = $ad4d16a462c12aaf$var$getDirectionInfo[coordSysMainType](null, [
            e.originX,
            e.originY
        ], axisModel, controller, coordSysInfo);
        var percentPoint = (directionInfo.signal > 0 ? directionInfo.pixelStart + directionInfo.pixelLength - directionInfo.pixel : directionInfo.pixel - directionInfo.pixelStart) / directionInfo.pixelLength * (range[1] - range[0]) + range[0];
        var scale = Math.max(1 / e.scale, 0);
        range[0] = (range[0] - percentPoint) * scale + percentPoint;
        range[1] = (range[1] - percentPoint) * scale + percentPoint;
        // Restrict range.
        var minMaxSpan = this.dataZoomModel.findRepresentativeAxisProxy().getMinMaxSpan();
        (0, $00a8003b34293330$export$2e2bcd8739ae039)(0, range, [
            0,
            100
        ], 0, minMaxSpan.minSpan, minMaxSpan.maxSpan);
        this.range = range;
        if (lastRange[0] !== range[0] || lastRange[1] !== range[1]) return range;
    },
    pan: $ad4d16a462c12aaf$var$makeMover(function(range, axisModel, coordSysInfo, coordSysMainType, controller, e) {
        var directionInfo = $ad4d16a462c12aaf$var$getDirectionInfo[coordSysMainType]([
            e.oldX,
            e.oldY
        ], [
            e.newX,
            e.newY
        ], axisModel, controller, coordSysInfo);
        return directionInfo.signal * (range[1] - range[0]) * directionInfo.pixel / directionInfo.pixelLength;
    }),
    scrollMove: $ad4d16a462c12aaf$var$makeMover(function(range, axisModel, coordSysInfo, coordSysMainType, controller, e) {
        var directionInfo = $ad4d16a462c12aaf$var$getDirectionInfo[coordSysMainType]([
            0,
            0
        ], [
            e.scrollDelta,
            e.scrollDelta
        ], axisModel, controller, coordSysInfo);
        return directionInfo.signal * (range[1] - range[0]) * e.scrollDelta;
    })
};
function $ad4d16a462c12aaf$var$makeMover(getPercentDelta) {
    return function(coordSysInfo, coordSysMainType, controller, e) {
        var lastRange = this.range;
        var range = lastRange.slice();
        // Calculate transform by the first axis.
        var axisModel = coordSysInfo.axisModels[0];
        if (!axisModel) return;
        var percentDelta = getPercentDelta(range, axisModel, coordSysInfo, coordSysMainType, controller, e);
        (0, $00a8003b34293330$export$2e2bcd8739ae039)(percentDelta, range, [
            0,
            100
        ], 'all');
        this.range = range;
        if (lastRange[0] !== range[0] || lastRange[1] !== range[1]) return range;
    };
}
var $ad4d16a462c12aaf$var$getDirectionInfo = {
    grid: function(oldPoint, newPoint, axisModel, controller, coordSysInfo) {
        var axis = axisModel.axis;
        var ret = {};
        var rect = coordSysInfo.model.coordinateSystem.getRect();
        oldPoint = oldPoint || [
            0,
            0
        ];
        if (axis.dim === 'x') {
            ret.pixel = newPoint[0] - oldPoint[0];
            ret.pixelLength = rect.width;
            ret.pixelStart = rect.x;
            ret.signal = axis.inverse ? 1 : -1;
        } else {
            // axis.dim === 'y'
            ret.pixel = newPoint[1] - oldPoint[1];
            ret.pixelLength = rect.height;
            ret.pixelStart = rect.y;
            ret.signal = axis.inverse ? -1 : 1;
        }
        return ret;
    },
    polar: function(oldPoint, newPoint, axisModel, controller, coordSysInfo) {
        var axis = axisModel.axis;
        var ret = {};
        var polar = coordSysInfo.model.coordinateSystem;
        var radiusExtent = polar.getRadiusAxis().getExtent();
        var angleExtent = polar.getAngleAxis().getExtent();
        oldPoint = oldPoint ? polar.pointToCoord(oldPoint) : [
            0,
            0
        ];
        newPoint = polar.pointToCoord(newPoint);
        if (axisModel.mainType === 'radiusAxis') {
            ret.pixel = newPoint[0] - oldPoint[0];
            // ret.pixelLength = Math.abs(radiusExtent[1] - radiusExtent[0]);
            // ret.pixelStart = Math.min(radiusExtent[0], radiusExtent[1]);
            ret.pixelLength = radiusExtent[1] - radiusExtent[0];
            ret.pixelStart = radiusExtent[0];
            ret.signal = axis.inverse ? 1 : -1;
        } else {
            // 'angleAxis'
            ret.pixel = newPoint[1] - oldPoint[1];
            // ret.pixelLength = Math.abs(angleExtent[1] - angleExtent[0]);
            // ret.pixelStart = Math.min(angleExtent[0], angleExtent[1]);
            ret.pixelLength = angleExtent[1] - angleExtent[0];
            ret.pixelStart = angleExtent[0];
            ret.signal = axis.inverse ? -1 : 1;
        }
        return ret;
    },
    singleAxis: function(oldPoint, newPoint, axisModel, controller, coordSysInfo) {
        var axis = axisModel.axis;
        var rect = coordSysInfo.model.coordinateSystem.getRect();
        var ret = {};
        oldPoint = oldPoint || [
            0,
            0
        ];
        if (axis.orient === 'horizontal') {
            ret.pixel = newPoint[0] - oldPoint[0];
            ret.pixelLength = rect.width;
            ret.pixelStart = rect.x;
            ret.signal = axis.inverse ? 1 : -1;
        } else {
            // 'vertical'
            ret.pixel = newPoint[1] - oldPoint[1];
            ret.pixelLength = rect.height;
            ret.pixelStart = rect.y;
            ret.signal = axis.inverse ? -1 : 1;
        }
        return ret;
    }
};
var $ad4d16a462c12aaf$export$2e2bcd8739ae039 = $ad4d16a462c12aaf$var$InsideZoomView;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $06639d6035d20694$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
var $06639d6035d20694$var$asc = $cfc1f3b422a3185f$export$debe6e778e0a6d32;
/**
 * Operate single axis.
 * One axis can only operated by one axis operator.
 * Different dataZoomModels may be defined to operate the same axis.
 * (i.e. 'inside' data zoom and 'slider' data zoom components)
 * So dataZoomModels share one axisProxy in that case.
 */ var $06639d6035d20694$var$AxisProxy = /** @class */ function() {
    function AxisProxy(dimName, axisIndex, dataZoomModel, ecModel) {
        this._dimName = dimName;
        this._axisIndex = axisIndex;
        this.ecModel = ecModel;
        this._dataZoomModel = dataZoomModel;
    // /**
    //  * @readOnly
    //  * @private
    //  */
    // this.hasSeriesStacked;
    }
    /**
   * Whether the axisProxy is hosted by dataZoomModel.
   */ AxisProxy.prototype.hostedBy = function(dataZoomModel) {
        return this._dataZoomModel === dataZoomModel;
    };
    /**
   * @return Value can only be NaN or finite value.
   */ AxisProxy.prototype.getDataValueWindow = function() {
        return this._valueWindow.slice();
    };
    /**
   * @return {Array.<number>}
   */ AxisProxy.prototype.getDataPercentWindow = function() {
        return this._percentWindow.slice();
    };
    AxisProxy.prototype.getTargetSeriesModels = function() {
        var seriesModels = [];
        this.ecModel.eachSeries(function(seriesModel) {
            if ((0, $554cb472ba0e05d3$export$2d449d4adc0d2cfc)(seriesModel)) {
                var axisMainType = (0, $554cb472ba0e05d3$export$90855f7219399082)(this._dimName);
                var axisModel = seriesModel.getReferringComponents(axisMainType, (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
                if (axisModel && this._axisIndex === axisModel.componentIndex) seriesModels.push(seriesModel);
            }
        }, this);
        return seriesModels;
    };
    AxisProxy.prototype.getAxisModel = function() {
        return this.ecModel.getComponent(this._dimName + 'Axis', this._axisIndex);
    };
    AxisProxy.prototype.getMinMaxSpan = function() {
        return $7a1bd9c2710fea0d$export$9cd59f9826255e47(this._minMaxSpan);
    };
    /**
   * Only calculate by given range and this._dataExtent, do not change anything.
   */ AxisProxy.prototype.calculateDataWindow = function(opt) {
        var dataExtent = this._dataExtent;
        var axisModel = this.getAxisModel();
        var scale = axisModel.axis.scale;
        var rangePropMode = this._dataZoomModel.getRangePropMode();
        var percentExtent = [
            0,
            100
        ];
        var percentWindow = [];
        var valueWindow = [];
        var hasPropModeValue;
        $06639d6035d20694$var$each([
            'start',
            'end'
        ], function(prop, idx) {
            var boundPercent = opt[prop];
            var boundValue = opt[prop + 'Value'];
            // Notice: dataZoom is based either on `percentProp` ('start', 'end') or
            // on `valueProp` ('startValue', 'endValue'). (They are based on the data extent
            // but not min/max of axis, which will be calculated by data window then).
            // The former one is suitable for cases that a dataZoom component controls multiple
            // axes with different unit or extent, and the latter one is suitable for accurate
            // zoom by pixel (e.g., in dataZoomSelect).
            // we use `getRangePropMode()` to mark which prop is used. `rangePropMode` is updated
            // only when setOption or dispatchAction, otherwise it remains its original value.
            // (Why not only record `percentProp` and always map to `valueProp`? Because
            // the map `valueProp` -> `percentProp` -> `valueProp` probably not the original
            // `valueProp`. consider two axes constrolled by one dataZoom. They have different
            // data extent. All of values that are overflow the `dataExtent` will be calculated
            // to percent '100%').
            if (rangePropMode[idx] === 'percent') {
                boundPercent == null && (boundPercent = percentExtent[idx]);
                // Use scale.parse to math round for category or time axis.
                boundValue = scale.parse($cfc1f3b422a3185f$export$d3f68fbaa670562(boundPercent, percentExtent, dataExtent));
            } else {
                hasPropModeValue = true;
                boundValue = boundValue == null ? dataExtent[idx] : scale.parse(boundValue);
                // Calculating `percent` from `value` may be not accurate, because
                // This calculation can not be inversed, because all of values that
                // are overflow the `dataExtent` will be calculated to percent '100%'
                boundPercent = $cfc1f3b422a3185f$export$d3f68fbaa670562(boundValue, dataExtent, percentExtent);
            }
            // valueWindow[idx] = round(boundValue);
            // percentWindow[idx] = round(boundPercent);
            // fallback to extent start/end when parsed value or percent is invalid
            valueWindow[idx] = boundValue == null || isNaN(boundValue) ? dataExtent[idx] : boundValue;
            percentWindow[idx] = boundPercent == null || isNaN(boundPercent) ? percentExtent[idx] : boundPercent;
        });
        $06639d6035d20694$var$asc(valueWindow);
        $06639d6035d20694$var$asc(percentWindow);
        // The windows from user calling of `dispatchAction` might be out of the extent,
        // or do not obey the `min/maxSpan`, `min/maxValueSpan`. But we don't restrict window
        // by `zoomLock` here, because we see `zoomLock` just as a interaction constraint,
        // where API is able to initialize/modify the window size even though `zoomLock`
        // specified.
        var spans = this._minMaxSpan;
        hasPropModeValue ? restrictSet(valueWindow, percentWindow, dataExtent, percentExtent, false) : restrictSet(percentWindow, valueWindow, percentExtent, dataExtent, true);
        function restrictSet(fromWindow, toWindow, fromExtent, toExtent, toValue) {
            var suffix = toValue ? 'Span' : 'ValueSpan';
            (0, $00a8003b34293330$export$2e2bcd8739ae039)(0, fromWindow, fromExtent, 'all', spans['min' + suffix], spans['max' + suffix]);
            for(var i = 0; i < 2; i++){
                toWindow[i] = $cfc1f3b422a3185f$export$d3f68fbaa670562(fromWindow[i], fromExtent, toExtent, true);
                toValue && (toWindow[i] = scale.parse(toWindow[i]));
            }
        }
        return {
            valueWindow: valueWindow,
            percentWindow: percentWindow
        };
    };
    /**
   * Notice: reset should not be called before series.restoreData() is called,
   * so it is recommended to be called in "process stage" but not "model init
   * stage".
   */ AxisProxy.prototype.reset = function(dataZoomModel) {
        if (dataZoomModel !== this._dataZoomModel) return;
        var targetSeries = this.getTargetSeriesModels();
        // Culculate data window and data extent, and record them.
        this._dataExtent = $06639d6035d20694$var$calculateDataExtent(this, this._dimName, targetSeries);
        // `calculateDataWindow` uses min/maxSpan.
        this._updateMinMaxSpan();
        var dataWindow = this.calculateDataWindow(dataZoomModel.settledOption);
        this._valueWindow = dataWindow.valueWindow;
        this._percentWindow = dataWindow.percentWindow;
        // Update axis setting then.
        this._setAxisModel();
    };
    AxisProxy.prototype.filterData = function(dataZoomModel, api) {
        if (dataZoomModel !== this._dataZoomModel) return;
        var axisDim = this._dimName;
        var seriesModels = this.getTargetSeriesModels();
        var filterMode = dataZoomModel.get('filterMode');
        var valueWindow = this._valueWindow;
        if (filterMode === 'none') return;
        // FIXME
        // Toolbox may has dataZoom injected. And if there are stacked bar chart
        // with NaN data, NaN will be filtered and stack will be wrong.
        // So we need to force the mode to be set empty.
        // In fect, it is not a big deal that do not support filterMode-'filter'
        // when using toolbox#dataZoom, utill tooltip#dataZoom support "single axis
        // selection" some day, which might need "adapt to data extent on the
        // otherAxis", which is disabled by filterMode-'empty'.
        // But currently, stack has been fixed to based on value but not index,
        // so this is not an issue any more.
        // let otherAxisModel = this.getOtherAxisModel();
        // if (dataZoomModel.get('$fromToolbox')
        //     && otherAxisModel
        //     && otherAxisModel.hasSeriesStacked
        // ) {
        //     filterMode = 'empty';
        // }
        // TODO
        // filterMode 'weakFilter' and 'empty' is not optimized for huge data yet.
        $06639d6035d20694$var$each(seriesModels, function(seriesModel) {
            var seriesData = seriesModel.getData();
            var dataDims = seriesData.mapDimensionsAll(axisDim);
            if (!dataDims.length) return;
            if (filterMode === 'weakFilter') {
                var store_1 = seriesData.getStore();
                var dataDimIndices_1 = $7a1bd9c2710fea0d$export$871de8747c9eaa88(dataDims, function(dim) {
                    return seriesData.getDimensionIndex(dim);
                }, seriesData);
                seriesData.filterSelf(function(dataIndex) {
                    var leftOut;
                    var rightOut;
                    var hasValue;
                    for(var i = 0; i < dataDims.length; i++){
                        var value = store_1.get(dataDimIndices_1[i], dataIndex);
                        var thisHasValue = !isNaN(value);
                        var thisLeftOut = value < valueWindow[0];
                        var thisRightOut = value > valueWindow[1];
                        if (thisHasValue && !thisLeftOut && !thisRightOut) return true;
                        thisHasValue && (hasValue = true);
                        thisLeftOut && (leftOut = true);
                        thisRightOut && (rightOut = true);
                    }
                    // If both left out and right out, do not filter.
                    return hasValue && leftOut && rightOut;
                });
            } else $06639d6035d20694$var$each(dataDims, function(dim) {
                if (filterMode === 'empty') seriesModel.setData(seriesData = seriesData.map(dim, function(value) {
                    return !isInWindow(value) ? NaN : value;
                }));
                else {
                    var range = {};
                    range[dim] = valueWindow;
                    // console.time('select');
                    seriesData.selectRange(range);
                // console.timeEnd('select');
                }
            });
            $06639d6035d20694$var$each(dataDims, function(dim) {
                seriesData.setApproximateExtent(valueWindow, dim);
            });
        });
        function isInWindow(value) {
            return value >= valueWindow[0] && value <= valueWindow[1];
        }
    };
    AxisProxy.prototype._updateMinMaxSpan = function() {
        var minMaxSpan = this._minMaxSpan = {};
        var dataZoomModel = this._dataZoomModel;
        var dataExtent = this._dataExtent;
        $06639d6035d20694$var$each([
            'min',
            'max'
        ], function(minMax) {
            var percentSpan = dataZoomModel.get(minMax + 'Span');
            var valueSpan = dataZoomModel.get(minMax + 'ValueSpan');
            valueSpan != null && (valueSpan = this.getAxisModel().axis.scale.parse(valueSpan));
            // minValueSpan and maxValueSpan has higher priority than minSpan and maxSpan
            if (valueSpan != null) percentSpan = $cfc1f3b422a3185f$export$d3f68fbaa670562(dataExtent[0] + valueSpan, dataExtent, [
                0,
                100
            ], true);
            else if (percentSpan != null) valueSpan = $cfc1f3b422a3185f$export$d3f68fbaa670562(percentSpan, [
                0,
                100
            ], dataExtent, true) - dataExtent[0];
            minMaxSpan[minMax + 'Span'] = percentSpan;
            minMaxSpan[minMax + 'ValueSpan'] = valueSpan;
        }, this);
    };
    AxisProxy.prototype._setAxisModel = function() {
        var axisModel = this.getAxisModel();
        var percentWindow = this._percentWindow;
        var valueWindow = this._valueWindow;
        if (!percentWindow) return;
        // [0, 500]: arbitrary value, guess axis extent.
        var precision = $cfc1f3b422a3185f$export$666260d9a2dda8a7(valueWindow, [
            0,
            500
        ]);
        precision = Math.min(precision, 20);
        // For value axis, if min/max/scale are not set, we just use the extent obtained
        // by series data, which may be a little different from the extent calculated by
        // `axisHelper.getScaleExtent`. But the different just affects the experience a
        // little when zooming. So it will not be fixed until some users require it strongly.
        var rawExtentInfo = axisModel.axis.scale.rawExtentInfo;
        if (percentWindow[0] !== 0) rawExtentInfo.setDeterminedMinMax('min', +valueWindow[0].toFixed(precision));
        if (percentWindow[1] !== 100) rawExtentInfo.setDeterminedMinMax('max', +valueWindow[1].toFixed(precision));
        rawExtentInfo.freeze();
    };
    return AxisProxy;
}();
function $06639d6035d20694$var$calculateDataExtent(axisProxy, axisDim, seriesModels) {
    var dataExtent = [
        Infinity,
        -Infinity
    ];
    $06639d6035d20694$var$each(seriesModels, function(seriesModel) {
        (0, $2d646e51cc34f840$export$635fe7f20d0f4c70)(dataExtent, seriesModel.getData(), axisDim);
    });
    // It is important to get "consistent" extent when more then one axes is
    // controlled by a `dataZoom`, otherwise those axes will not be synchronized
    // when zooming. But it is difficult to know what is "consistent", considering
    // axes have different type or even different meanings (For example, two
    // time axes are used to compare data of the same date in different years).
    // So basically dataZoom just obtains extent by series.data (in category axis
    // extent can be obtained from axis.data).
    // Nevertheless, user can set min/max/scale on axes to make extent of axes
    // consistent.
    var axisModel = axisProxy.getAxisModel();
    var rawExtentResult = (0, $483be9695e74220c$export$5c3dbcbeb9ce7f5a)(axisModel.axis.scale, axisModel, dataExtent).calculate();
    return [
        rawExtentResult.min,
        rawExtentResult.max
    ];
}
var $06639d6035d20694$export$2e2bcd8739ae039 = $06639d6035d20694$var$AxisProxy;


var $e1090934575f11ee$var$dataZoomProcessor = {
    // `dataZoomProcessor` will only be performed in needed series. Consider if
    // there is a line series and a pie series, it is better not to update the
    // line series if only pie series is needed to be updated.
    getTargetSeries: function(ecModel) {
        function eachAxisModel(cb) {
            ecModel.eachComponent('dataZoom', function(dataZoomModel) {
                dataZoomModel.eachTargetAxis(function(axisDim, axisIndex) {
                    var axisModel = ecModel.getComponent((0, $554cb472ba0e05d3$export$90855f7219399082)(axisDim), axisIndex);
                    cb(axisDim, axisIndex, axisModel, dataZoomModel);
                });
            });
        }
        // FIXME: it brings side-effect to `getTargetSeries`.
        // Prepare axis proxies.
        eachAxisModel(function(axisDim, axisIndex, axisModel, dataZoomModel) {
            // dispose all last axis proxy, in case that some axis are deleted.
            axisModel.__dzAxisProxy = null;
        });
        var proxyList = [];
        eachAxisModel(function(axisDim, axisIndex, axisModel, dataZoomModel) {
            // Different dataZooms may constrol the same axis. In that case,
            // an axisProxy serves both of them.
            if (!axisModel.__dzAxisProxy) {
                // Use the first dataZoomModel as the main model of axisProxy.
                axisModel.__dzAxisProxy = new (0, $06639d6035d20694$export$2e2bcd8739ae039)(axisDim, axisIndex, dataZoomModel, ecModel);
                proxyList.push(axisModel.__dzAxisProxy);
            }
        });
        var seriesModelMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(proxyList, function(axisProxy) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axisProxy.getTargetSeriesModels(), function(seriesModel) {
                seriesModelMap.set(seriesModel.uid, seriesModel);
            });
        });
        return seriesModelMap;
    },
    // Consider appendData, where filter should be performed. Because data process is
    // in block mode currently, it is not need to worry about that the overallProgress
    // execute every frame.
    overallReset: function(ecModel, api) {
        ecModel.eachComponent('dataZoom', function(dataZoomModel) {
            // We calculate window and reset axis here but not in model
            // init stage and not after action dispatch handler, because
            // reset should be called after seriesData.restoreData.
            dataZoomModel.eachTargetAxis(function(axisDim, axisIndex) {
                dataZoomModel.getAxisProxy(axisDim, axisIndex).reset(dataZoomModel);
            });
            // Caution: data zoom filtering is order sensitive when using
            // percent range and no min/max/scale set on axis.
            // For example, we have dataZoom definition:
            // [
            //      {xAxisIndex: 0, start: 30, end: 70},
            //      {yAxisIndex: 0, start: 20, end: 80}
            // ]
            // In this case, [20, 80] of y-dataZoom should be based on data
            // that have filtered by x-dataZoom using range of [30, 70],
            // but should not be based on full raw data. Thus sliding
            // x-dataZoom will change both ranges of xAxis and yAxis,
            // while sliding y-dataZoom will only change the range of yAxis.
            // So we should filter x-axis after reset x-axis immediately,
            // and then reset y-axis and filter y-axis.
            dataZoomModel.eachTargetAxis(function(axisDim, axisIndex) {
                dataZoomModel.getAxisProxy(axisDim, axisIndex).filterData(dataZoomModel, api);
            });
        });
        ecModel.eachComponent('dataZoom', function(dataZoomModel) {
            // Fullfill all of the range props so that user
            // is able to get them from chart.getOption().
            var axisProxy = dataZoomModel.findRepresentativeAxisProxy();
            if (axisProxy) {
                var percentRange = axisProxy.getDataPercentWindow();
                var valueRange = axisProxy.getDataValueWindow();
                dataZoomModel.setCalculatedRange({
                    start: percentRange[0],
                    end: percentRange[1],
                    startValue: valueRange[0],
                    endValue: valueRange[1]
                });
            }
        });
    }
};
var $e1090934575f11ee$export$2e2bcd8739ae039 = $e1090934575f11ee$var$dataZoomProcessor;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $de61ff13130c6dae$export$2e2bcd8739ae039(registers) {
    registers.registerAction('dataZoom', function(payload, ecModel) {
        var effectedModels = (0, $554cb472ba0e05d3$export$9e00b6c2b8b2e9a7)(ecModel, payload);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(effectedModels, function(dataZoomModel) {
            dataZoomModel.setRawRange({
                start: payload.start,
                end: payload.end,
                startValue: payload.startValue,
                endValue: payload.endValue
            });
        });
    });
}


var $8904ef10f452e35c$var$installed = false;
function $8904ef10f452e35c$export$2e2bcd8739ae039(registers) {
    if ($8904ef10f452e35c$var$installed) return;
    $8904ef10f452e35c$var$installed = true;
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.FILTER, (0, $e1090934575f11ee$export$2e2bcd8739ae039));
    (0, $de61ff13130c6dae$export$2e2bcd8739ae039)(registers);
    registers.registerSubTypeDefaulter('dataZoom', function() {
        // Default 'slider' when no type specified.
        return 'slider';
    });
}


function $b5ee445cd897e37a$export$4b3e715f166fdd78(registers) {
    (0, $8904ef10f452e35c$export$2e2bcd8739ae039)(registers);
    registers.registerComponentModel((0, $6cccca1a1040a7a1$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $ad4d16a462c12aaf$export$2e2bcd8739ae039));
    (0, $6379ab7b9c3fbfb6$export$f3632ddafc9ea51e)(registers);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $8fa9b5e71c234965$var$SliderZoomModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SliderZoomModel, _super);
    function SliderZoomModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SliderZoomModel.type;
        return _this;
    }
    SliderZoomModel.type = 'dataZoom.slider';
    SliderZoomModel.layoutMode = 'box';
    SliderZoomModel.defaultOption = (0, $5370df662b2caf37$export$68acc510e46fef2)((0, $41d57478d16bff21$export$2e2bcd8739ae039).defaultOption, {
        show: true,
        // deault value can only be drived in view stage.
        right: 'ph',
        top: 'ph',
        width: 'ph',
        height: 'ph',
        left: null,
        bottom: null,
        borderColor: '#d2dbee',
        borderRadius: 3,
        backgroundColor: 'rgba(47,69,84,0)',
        // dataBackgroundColor: '#ddd',
        dataBackground: {
            lineStyle: {
                color: '#d2dbee',
                width: 0.5
            },
            areaStyle: {
                color: '#d2dbee',
                opacity: 0.2
            }
        },
        selectedDataBackground: {
            lineStyle: {
                color: '#8fb0f7',
                width: 0.5
            },
            areaStyle: {
                color: '#8fb0f7',
                opacity: 0.2
            }
        },
        // Color of selected window.
        fillerColor: 'rgba(135,175,274,0.2)',
        handleIcon: 'path://M-9.35,34.56V42m0-40V9.5m-2,0h4a2,2,0,0,1,2,2v21a2,2,0,0,1-2,2h-4a2,2,0,0,1-2-2v-21A2,2,0,0,1-11.35,9.5Z',
        // Percent of the slider height
        handleSize: '100%',
        handleStyle: {
            color: '#fff',
            borderColor: '#ACB8D1'
        },
        moveHandleSize: 7,
        moveHandleIcon: 'path://M-320.9-50L-320.9-50c18.1,0,27.1,9,27.1,27.1V85.7c0,18.1-9,27.1-27.1,27.1l0,0c-18.1,0-27.1-9-27.1-27.1V-22.9C-348-41-339-50-320.9-50z M-212.3-50L-212.3-50c18.1,0,27.1,9,27.1,27.1V85.7c0,18.1-9,27.1-27.1,27.1l0,0c-18.1,0-27.1-9-27.1-27.1V-22.9C-239.4-41-230.4-50-212.3-50z M-103.7-50L-103.7-50c18.1,0,27.1,9,27.1,27.1V85.7c0,18.1-9,27.1-27.1,27.1l0,0c-18.1,0-27.1-9-27.1-27.1V-22.9C-130.9-41-121.8-50-103.7-50z',
        moveHandleStyle: {
            color: '#D2DBEE',
            opacity: 0.7
        },
        showDetail: true,
        showDataShadow: 'auto',
        realtime: true,
        zoomLock: false,
        textStyle: {
            color: '#6E7079'
        },
        brushSelect: true,
        brushStyle: {
            color: 'rgba(135,175,274,0.15)'
        },
        emphasis: {
            handleLabel: {
                show: true
            },
            handleStyle: {
                borderColor: '#8FB0F7'
            },
            moveHandleStyle: {
                color: '#8FB0F7'
            }
        }
    });
    return SliderZoomModel;
}((0, $41d57478d16bff21$export$2e2bcd8739ae039));
var $8fa9b5e71c234965$export$2e2bcd8739ae039 = $8fa9b5e71c234965$var$SliderZoomModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 













var $eee50458c1b708ef$var$Rect = $419e5ff2f303755e$export$2e2bcd8739ae039;
// Constants
var $eee50458c1b708ef$var$DEFAULT_LOCATION_EDGE_GAP = 7;
var $eee50458c1b708ef$var$DEFAULT_FRAME_BORDER_WIDTH = 1;
var $eee50458c1b708ef$var$DEFAULT_FILLER_SIZE = 30;
var $eee50458c1b708ef$var$DEFAULT_MOVE_HANDLE_SIZE = 7;
var $eee50458c1b708ef$var$HORIZONTAL = 'horizontal';
var $eee50458c1b708ef$var$VERTICAL = 'vertical';
var $eee50458c1b708ef$var$LABEL_GAP = 5;
var $eee50458c1b708ef$var$SHOW_DATA_SHADOW_SERIES_TYPE = [
    'line',
    'bar',
    'candlestick',
    'scatter'
];
var $eee50458c1b708ef$var$REALTIME_ANIMATION_CONFIG = {
    easing: 'cubicOut',
    duration: 100,
    delay: 0
};
var $eee50458c1b708ef$var$SliderZoomView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SliderZoomView, _super);
    function SliderZoomView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SliderZoomView.type;
        _this._displayables = {};
        return _this;
    }
    SliderZoomView.prototype.init = function(ecModel, api) {
        this.api = api;
        // A unique handler for each dataZoom component
        this._onBrush = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._onBrush, this);
        this._onBrushEnd = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._onBrushEnd, this);
    };
    SliderZoomView.prototype.render = function(dataZoomModel, ecModel, api, payload) {
        _super.prototype.render.apply(this, arguments);
        $c98659a9437a3d2e$export$958e3e1a02eac4b6(this, '_dispatchZoomAction', dataZoomModel.get('throttle'), 'fixRate');
        this._orient = dataZoomModel.getOrient();
        if (dataZoomModel.get('show') === false) {
            this.group.removeAll();
            return;
        }
        if (dataZoomModel.noTarget()) {
            this._clear();
            this.group.removeAll();
            return;
        }
        // Notice: this._resetInterval() should not be executed when payload.type
        // is 'dataZoom', origin this._range should be maintained, otherwise 'pan'
        // or 'zoom' info will be missed because of 'throttle' of this.dispatchAction,
        if (!payload || payload.type !== 'dataZoom' || payload.from !== this.uid) this._buildView();
        this._updateView();
    };
    SliderZoomView.prototype.dispose = function() {
        this._clear();
        _super.prototype.dispose.apply(this, arguments);
    };
    SliderZoomView.prototype._clear = function() {
        $c98659a9437a3d2e$export$42ffd38884aecdac(this, '_dispatchZoomAction');
        var zr = this.api.getZr();
        zr.off('mousemove', this._onBrush);
        zr.off('mouseup', this._onBrushEnd);
    };
    SliderZoomView.prototype._buildView = function() {
        var thisGroup = this.group;
        thisGroup.removeAll();
        this._brushing = false;
        this._displayables.brushRect = null;
        this._resetLocation();
        this._resetInterval();
        var barGroup = this._displayables.sliderGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        this._renderBackground();
        this._renderHandle();
        this._renderDataShadow();
        thisGroup.add(barGroup);
        this._positionGroup();
    };
    SliderZoomView.prototype._resetLocation = function() {
        var dataZoomModel = this.dataZoomModel;
        var api = this.api;
        var showMoveHandle = dataZoomModel.get('brushSelect');
        var moveHandleSize = showMoveHandle ? $eee50458c1b708ef$var$DEFAULT_MOVE_HANDLE_SIZE : 0;
        // If some of x/y/width/height are not specified,
        // auto-adapt according to target grid.
        var coordRect = this._findCoordRect();
        var ecSize = {
            width: api.getWidth(),
            height: api.getHeight()
        };
        // Default align by coordinate system rect.
        var positionInfo = this._orient === $eee50458c1b708ef$var$HORIZONTAL ? {
            // Why using 'right', because right should be used in vertical,
            // and it is better to be consistent for dealing with position param merge.
            right: ecSize.width - coordRect.x - coordRect.width,
            top: ecSize.height - $eee50458c1b708ef$var$DEFAULT_FILLER_SIZE - $eee50458c1b708ef$var$DEFAULT_LOCATION_EDGE_GAP - moveHandleSize,
            width: coordRect.width,
            height: $eee50458c1b708ef$var$DEFAULT_FILLER_SIZE
        } : {
            right: $eee50458c1b708ef$var$DEFAULT_LOCATION_EDGE_GAP,
            top: coordRect.y,
            width: $eee50458c1b708ef$var$DEFAULT_FILLER_SIZE,
            height: coordRect.height
        };
        // Do not write back to option and replace value 'ph', because
        // the 'ph' value should be recalculated when resize.
        var layoutParams = $93b9bc7f22ac7369$export$4b0d20af19c9875e(dataZoomModel.option);
        // Replace the placeholder value.
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
            'right',
            'top',
            'width',
            'height'
        ], function(name) {
            if (layoutParams[name] === 'ph') layoutParams[name] = positionInfo[name];
        });
        var layoutRect = $93b9bc7f22ac7369$export$4517a5ca639a7293(layoutParams, ecSize);
        this._location = {
            x: layoutRect.x,
            y: layoutRect.y
        };
        this._size = [
            layoutRect.width,
            layoutRect.height
        ];
        this._orient === $eee50458c1b708ef$var$VERTICAL && this._size.reverse();
    };
    SliderZoomView.prototype._positionGroup = function() {
        var thisGroup = this.group;
        var location = this._location;
        var orient = this._orient;
        // Just use the first axis to determine mapping.
        var targetAxisModel = this.dataZoomModel.getFirstTargetAxisModel();
        var inverse = targetAxisModel && targetAxisModel.get('inverse');
        var sliderGroup = this._displayables.sliderGroup;
        var otherAxisInverse = (this._dataShadowInfo || {}).otherAxisInverse;
        // Transform barGroup.
        sliderGroup.attr(orient === $eee50458c1b708ef$var$HORIZONTAL && !inverse ? {
            scaleY: otherAxisInverse ? 1 : -1,
            scaleX: 1
        } : orient === $eee50458c1b708ef$var$HORIZONTAL && inverse ? {
            scaleY: otherAxisInverse ? 1 : -1,
            scaleX: -1
        } : orient === $eee50458c1b708ef$var$VERTICAL && !inverse ? {
            scaleY: otherAxisInverse ? -1 : 1,
            scaleX: 1,
            rotation: Math.PI / 2
        } : {
            scaleY: otherAxisInverse ? -1 : 1,
            scaleX: -1,
            rotation: Math.PI / 2
        });
        // Position barGroup
        var rect = thisGroup.getBoundingRect([
            sliderGroup
        ]);
        thisGroup.x = location.x - rect.x;
        thisGroup.y = location.y - rect.y;
        thisGroup.markRedraw();
    };
    SliderZoomView.prototype._getViewExtent = function() {
        return [
            0,
            this._size[0]
        ];
    };
    SliderZoomView.prototype._renderBackground = function() {
        var dataZoomModel = this.dataZoomModel;
        var size = this._size;
        var barGroup = this._displayables.sliderGroup;
        var brushSelect = dataZoomModel.get('brushSelect');
        barGroup.add(new $eee50458c1b708ef$var$Rect({
            silent: true,
            shape: {
                x: 0,
                y: 0,
                width: size[0],
                height: size[1]
            },
            style: {
                fill: dataZoomModel.get('backgroundColor')
            },
            z2: -40
        }));
        // Click panel, over shadow, below handles.
        var clickPanel = new $eee50458c1b708ef$var$Rect({
            shape: {
                x: 0,
                y: 0,
                width: size[0],
                height: size[1]
            },
            style: {
                fill: 'transparent'
            },
            z2: 0,
            onclick: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._onClickPanel, this)
        });
        var zr = this.api.getZr();
        if (brushSelect) {
            clickPanel.on('mousedown', this._onBrushStart, this);
            clickPanel.cursor = 'crosshair';
            zr.on('mousemove', this._onBrush);
            zr.on('mouseup', this._onBrushEnd);
        } else {
            zr.off('mousemove', this._onBrush);
            zr.off('mouseup', this._onBrushEnd);
        }
        barGroup.add(clickPanel);
    };
    SliderZoomView.prototype._renderDataShadow = function() {
        var info = this._dataShadowInfo = this._prepareDataShadowInfo();
        this._displayables.dataShadowSegs = [];
        if (!info) return;
        var size = this._size;
        var oldSize = this._shadowSize || [];
        var seriesModel = info.series;
        var data = seriesModel.getRawData();
        var candlestickDim = seriesModel.getShadowDim && seriesModel.getShadowDim();
        var otherDim = candlestickDim && data.getDimensionInfo(candlestickDim) ? seriesModel.getShadowDim() // @see candlestick
         : info.otherDim;
        if (otherDim == null) return;
        var polygonPts = this._shadowPolygonPts;
        var polylinePts = this._shadowPolylinePts;
        // Not re-render if data doesn't change.
        if (data !== this._shadowData || otherDim !== this._shadowDim || size[0] !== oldSize[0] || size[1] !== oldSize[1]) {
            var otherDataExtent_1 = data.getDataExtent(otherDim);
            // Nice extent.
            var otherOffset = (otherDataExtent_1[1] - otherDataExtent_1[0]) * 0.3;
            otherDataExtent_1 = [
                otherDataExtent_1[0] - otherOffset,
                otherDataExtent_1[1] + otherOffset
            ];
            var otherShadowExtent_1 = [
                0,
                size[1]
            ];
            var thisShadowExtent = [
                0,
                size[0]
            ];
            var areaPoints_1 = [
                [
                    size[0],
                    0
                ],
                [
                    0,
                    0
                ]
            ];
            var linePoints_1 = [];
            var step_1 = thisShadowExtent[1] / (data.count() - 1);
            var thisCoord_1 = 0;
            // Optimize for large data shadow
            var stride_1 = Math.round(data.count() / size[0]);
            var lastIsEmpty_1;
            data.each([
                otherDim
            ], function(value, index) {
                if (stride_1 > 0 && index % stride_1) {
                    thisCoord_1 += step_1;
                    return;
                }
                // FIXME
                // Should consider axis.min/axis.max when drawing dataShadow.
                // FIXME
                // 应该使用统一的空判断？还是在list里进行空判断？
                var isEmpty = value == null || isNaN(value) || value === '';
                // See #4235.
                var otherCoord = isEmpty ? 0 : (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(value, otherDataExtent_1, otherShadowExtent_1, true);
                // Attempt to draw data shadow precisely when there are empty value.
                if (isEmpty && !lastIsEmpty_1 && index) {
                    areaPoints_1.push([
                        areaPoints_1[areaPoints_1.length - 1][0],
                        0
                    ]);
                    linePoints_1.push([
                        linePoints_1[linePoints_1.length - 1][0],
                        0
                    ]);
                } else if (!isEmpty && lastIsEmpty_1) {
                    areaPoints_1.push([
                        thisCoord_1,
                        0
                    ]);
                    linePoints_1.push([
                        thisCoord_1,
                        0
                    ]);
                }
                areaPoints_1.push([
                    thisCoord_1,
                    otherCoord
                ]);
                linePoints_1.push([
                    thisCoord_1,
                    otherCoord
                ]);
                thisCoord_1 += step_1;
                lastIsEmpty_1 = isEmpty;
            });
            polygonPts = this._shadowPolygonPts = areaPoints_1;
            polylinePts = this._shadowPolylinePts = linePoints_1;
        }
        this._shadowData = data;
        this._shadowDim = otherDim;
        this._shadowSize = [
            size[0],
            size[1]
        ];
        var dataZoomModel = this.dataZoomModel;
        function createDataShadowGroup(isSelectedArea) {
            var model = dataZoomModel.getModel(isSelectedArea ? 'selectedDataBackground' : 'dataBackground');
            var group = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
            var polygon = new $51acf033123e1a30$export$2e2bcd8739ae039({
                shape: {
                    points: polygonPts
                },
                segmentIgnoreThreshold: 1,
                style: model.getModel('areaStyle').getAreaStyle(),
                silent: true,
                z2: -20
            });
            var polyline = new $d28119f30e6bb670$export$2e2bcd8739ae039({
                shape: {
                    points: polylinePts
                },
                segmentIgnoreThreshold: 1,
                style: model.getModel('lineStyle').getLineStyle(),
                silent: true,
                z2: -19
            });
            group.add(polygon);
            group.add(polyline);
            return group;
        }
        // let dataBackgroundModel = dataZoomModel.getModel('dataBackground');
        for(var i = 0; i < 3; i++){
            var group = createDataShadowGroup(i === 1);
            this._displayables.sliderGroup.add(group);
            this._displayables.dataShadowSegs.push(group);
        }
    };
    SliderZoomView.prototype._prepareDataShadowInfo = function() {
        var dataZoomModel = this.dataZoomModel;
        var showDataShadow = dataZoomModel.get('showDataShadow');
        if (showDataShadow === false) return;
        // Find a representative series.
        var result;
        var ecModel = this.ecModel;
        dataZoomModel.eachTargetAxis(function(axisDim, axisIndex) {
            var seriesModels = dataZoomModel.getAxisProxy(axisDim, axisIndex).getTargetSeriesModels();
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(seriesModels, function(seriesModel) {
                if (result) return;
                if (showDataShadow !== true && (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)($eee50458c1b708ef$var$SHOW_DATA_SHADOW_SERIES_TYPE, seriesModel.get('type')) < 0) return;
                var thisAxis = ecModel.getComponent((0, $554cb472ba0e05d3$export$90855f7219399082)(axisDim), axisIndex).axis;
                var otherDim = $eee50458c1b708ef$var$getOtherDim(axisDim);
                var otherAxisInverse;
                var coordSys = seriesModel.coordinateSystem;
                if (otherDim != null && coordSys.getOtherAxis) otherAxisInverse = coordSys.getOtherAxis(thisAxis).inverse;
                otherDim = seriesModel.getData().mapDimension(otherDim);
                result = {
                    thisAxis: thisAxis,
                    series: seriesModel,
                    thisDim: axisDim,
                    otherDim: otherDim,
                    otherAxisInverse: otherAxisInverse
                };
            }, this);
        }, this);
        return result;
    };
    SliderZoomView.prototype._renderHandle = function() {
        var thisGroup = this.group;
        var displayables = this._displayables;
        var handles = displayables.handles = [
            null,
            null
        ];
        var handleLabels = displayables.handleLabels = [
            null,
            null
        ];
        var sliderGroup = this._displayables.sliderGroup;
        var size = this._size;
        var dataZoomModel = this.dataZoomModel;
        var api = this.api;
        var borderRadius = dataZoomModel.get('borderRadius') || 0;
        var brushSelect = dataZoomModel.get('brushSelect');
        var filler = displayables.filler = new $eee50458c1b708ef$var$Rect({
            silent: brushSelect,
            style: {
                fill: dataZoomModel.get('fillerColor')
            },
            textConfig: {
                position: 'inside'
            }
        });
        sliderGroup.add(filler);
        // Frame border.
        sliderGroup.add(new $eee50458c1b708ef$var$Rect({
            silent: true,
            subPixelOptimize: true,
            shape: {
                x: 0,
                y: 0,
                width: size[0],
                height: size[1],
                r: borderRadius
            },
            style: {
                // deprecated option
                stroke: dataZoomModel.get('dataBackgroundColor') || dataZoomModel.get('borderColor'),
                lineWidth: $eee50458c1b708ef$var$DEFAULT_FRAME_BORDER_WIDTH,
                fill: 'rgba(0,0,0,0)'
            }
        }));
        // Left and right handle to resize
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
            0,
            1
        ], function(handleIndex) {
            var iconStr = dataZoomModel.get('handleIcon');
            if (!(0, $5370466dadc978d7$export$33fc3b478d332725)[iconStr] && iconStr.indexOf('path://') < 0 && iconStr.indexOf('image://') < 0) // Compatitable with the old icon parsers. Which can use a path string without path://
            iconStr = 'path://' + iconStr;
            var path = (0, $5370466dadc978d7$export$af050e04da3a02e8)(iconStr, -1, 0, 2, 2, null, true);
            path.attr({
                cursor: $eee50458c1b708ef$var$getCursor(this._orient),
                draggable: true,
                drift: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._onDragMove, this, handleIndex),
                ondragend: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._onDragEnd, this),
                onmouseover: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._showDataInfo, this, true),
                onmouseout: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._showDataInfo, this, false),
                z2: 5
            });
            var bRect = path.getBoundingRect();
            var handleSize = dataZoomModel.get('handleSize');
            this._handleHeight = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(handleSize, this._size[1]);
            this._handleWidth = bRect.width / bRect.height * this._handleHeight;
            path.setStyle(dataZoomModel.getModel('handleStyle').getItemStyle());
            path.style.strokeNoScale = true;
            path.rectHover = true;
            path.ensureState('emphasis').style = dataZoomModel.getModel([
                'emphasis',
                'handleStyle'
            ]).getItemStyle();
            (0, $2bf82c0980125b62$export$5f393df0b5aee2e7)(path);
            var handleColor = dataZoomModel.get('handleColor'); // deprecated option
            // Compatitable with previous version
            if (handleColor != null) path.style.fill = handleColor;
            sliderGroup.add(handles[handleIndex] = path);
            var textStyleModel = dataZoomModel.getModel('textStyle');
            var handleLabel = dataZoomModel.get('handleLabel') || {};
            var handleLabelShow = handleLabel.show || false;
            thisGroup.add(handleLabels[handleIndex] = new $fe885cc21795562b$export$2e2bcd8739ae039({
                silent: true,
                invisible: !handleLabelShow,
                style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(textStyleModel, {
                    x: 0,
                    y: 0,
                    text: '',
                    verticalAlign: 'middle',
                    align: 'center',
                    fill: textStyleModel.getTextColor(),
                    font: textStyleModel.getFont()
                }),
                z2: 10
            }));
        }, this);
        // Handle to move. Only visible when brushSelect is set true.
        var actualMoveZone = filler;
        if (brushSelect) {
            var moveHandleHeight = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(dataZoomModel.get('moveHandleSize'), size[1]);
            var moveHandle_1 = displayables.moveHandle = new $419e5ff2f303755e$export$2e2bcd8739ae039({
                style: dataZoomModel.getModel('moveHandleStyle').getItemStyle(),
                silent: true,
                shape: {
                    r: [
                        0,
                        0,
                        2,
                        2
                    ],
                    y: size[1] - 0.5,
                    height: moveHandleHeight
                }
            });
            var iconSize = moveHandleHeight * 0.8;
            var moveHandleIcon = displayables.moveHandleIcon = (0, $5370466dadc978d7$export$af050e04da3a02e8)(dataZoomModel.get('moveHandleIcon'), -iconSize / 2, -iconSize / 2, iconSize, iconSize, '#fff', true);
            moveHandleIcon.silent = true;
            moveHandleIcon.y = size[1] + moveHandleHeight / 2 - 0.5;
            moveHandle_1.ensureState('emphasis').style = dataZoomModel.getModel([
                'emphasis',
                'moveHandleStyle'
            ]).getItemStyle();
            var moveZoneExpandSize = Math.min(size[1] / 2, Math.max(moveHandleHeight, 10));
            actualMoveZone = displayables.moveZone = new $419e5ff2f303755e$export$2e2bcd8739ae039({
                invisible: true,
                shape: {
                    y: size[1] - moveZoneExpandSize,
                    height: moveHandleHeight + moveZoneExpandSize
                }
            });
            actualMoveZone.on('mouseover', function() {
                api.enterEmphasis(moveHandle_1);
            }).on('mouseout', function() {
                api.leaveEmphasis(moveHandle_1);
            });
            sliderGroup.add(moveHandle_1);
            sliderGroup.add(moveHandleIcon);
            sliderGroup.add(actualMoveZone);
        }
        actualMoveZone.attr({
            draggable: true,
            cursor: $eee50458c1b708ef$var$getCursor(this._orient),
            drift: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._onDragMove, this, 'all'),
            ondragstart: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._showDataInfo, this, true),
            ondragend: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._onDragEnd, this),
            onmouseover: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._showDataInfo, this, true),
            onmouseout: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._showDataInfo, this, false)
        });
    };
    SliderZoomView.prototype._resetInterval = function() {
        var range = this._range = this.dataZoomModel.getPercentRange();
        var viewExtent = this._getViewExtent();
        this._handleEnds = [
            (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(range[0], [
                0,
                100
            ], viewExtent, true),
            (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(range[1], [
                0,
                100
            ], viewExtent, true)
        ];
    };
    SliderZoomView.prototype._updateInterval = function(handleIndex, delta) {
        var dataZoomModel = this.dataZoomModel;
        var handleEnds = this._handleEnds;
        var viewExtend = this._getViewExtent();
        var minMaxSpan = dataZoomModel.findRepresentativeAxisProxy().getMinMaxSpan();
        var percentExtent = [
            0,
            100
        ];
        (0, $00a8003b34293330$export$2e2bcd8739ae039)(delta, handleEnds, viewExtend, dataZoomModel.get('zoomLock') ? 'all' : handleIndex, minMaxSpan.minSpan != null ? (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(minMaxSpan.minSpan, percentExtent, viewExtend, true) : null, minMaxSpan.maxSpan != null ? (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(minMaxSpan.maxSpan, percentExtent, viewExtend, true) : null);
        var lastRange = this._range;
        var range = this._range = (0, $cfc1f3b422a3185f$export$debe6e778e0a6d32)([
            (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(handleEnds[0], viewExtend, percentExtent, true),
            (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(handleEnds[1], viewExtend, percentExtent, true)
        ]);
        return !lastRange || lastRange[0] !== range[0] || lastRange[1] !== range[1];
    };
    SliderZoomView.prototype._updateView = function(nonRealtime) {
        var displaybles = this._displayables;
        var handleEnds = this._handleEnds;
        var handleInterval = (0, $cfc1f3b422a3185f$export$debe6e778e0a6d32)(handleEnds.slice());
        var size = this._size;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
            0,
            1
        ], function(handleIndex) {
            // Handles
            var handle = displaybles.handles[handleIndex];
            var handleHeight = this._handleHeight;
            handle.attr({
                scaleX: handleHeight / 2,
                scaleY: handleHeight / 2,
                // This is a trick, by adding an extra tiny offset to let the default handle's end point align to the drag window.
                // NOTE: It may affect some custom shapes a bit. But we prefer to have better result by default.
                x: handleEnds[handleIndex] + (handleIndex ? -1 : 1),
                y: size[1] / 2 - handleHeight / 2
            });
        }, this);
        // Filler
        displaybles.filler.setShape({
            x: handleInterval[0],
            y: 0,
            width: handleInterval[1] - handleInterval[0],
            height: size[1]
        });
        var viewExtent = {
            x: handleInterval[0],
            width: handleInterval[1] - handleInterval[0]
        };
        // Move handle
        if (displaybles.moveHandle) {
            displaybles.moveHandle.setShape(viewExtent);
            displaybles.moveZone.setShape(viewExtent);
            // Force update path on the invisible object
            displaybles.moveZone.getBoundingRect();
            displaybles.moveHandleIcon && displaybles.moveHandleIcon.attr('x', viewExtent.x + viewExtent.width / 2);
        }
        // update clip path of shadow.
        var dataShadowSegs = displaybles.dataShadowSegs;
        var segIntervals = [
            0,
            handleInterval[0],
            handleInterval[1],
            size[0]
        ];
        for(var i = 0; i < dataShadowSegs.length; i++){
            var segGroup = dataShadowSegs[i];
            var clipPath = segGroup.getClipPath();
            if (!clipPath) {
                clipPath = new $419e5ff2f303755e$export$2e2bcd8739ae039();
                segGroup.setClipPath(clipPath);
            }
            clipPath.setShape({
                x: segIntervals[i],
                y: 0,
                width: segIntervals[i + 1] - segIntervals[i],
                height: size[1]
            });
        }
        this._updateDataInfo(nonRealtime);
    };
    SliderZoomView.prototype._updateDataInfo = function(nonRealtime) {
        var dataZoomModel = this.dataZoomModel;
        var displaybles = this._displayables;
        var handleLabels = displaybles.handleLabels;
        var orient = this._orient;
        var labelTexts = [
            '',
            ''
        ];
        // FIXME
        // date型，支持formatter，autoformatter（ec2 date.getAutoFormatter）
        if (dataZoomModel.get('showDetail')) {
            var axisProxy = dataZoomModel.findRepresentativeAxisProxy();
            if (axisProxy) {
                var axis = axisProxy.getAxisModel().axis;
                var range = this._range;
                var dataInterval = nonRealtime ? axisProxy.calculateDataWindow({
                    start: range[0],
                    end: range[1]
                }).valueWindow : axisProxy.getDataValueWindow();
                labelTexts = [
                    this._formatLabel(dataInterval[0], axis),
                    this._formatLabel(dataInterval[1], axis)
                ];
            }
        }
        var orderedHandleEnds = (0, $cfc1f3b422a3185f$export$debe6e778e0a6d32)(this._handleEnds.slice());
        setLabel.call(this, 0);
        setLabel.call(this, 1);
        function setLabel(handleIndex) {
            // Label
            // Text should not transform by barGroup.
            // Ignore handlers transform
            var barTransform = $5b455ae6f843ac47$export$fce0c6cfca85ed96(displaybles.handles[handleIndex].parent, this.group);
            var direction = $5b455ae6f843ac47$export$fff94e9792354cfa(handleIndex === 0 ? 'right' : 'left', barTransform);
            var offset = this._handleWidth / 2 + $eee50458c1b708ef$var$LABEL_GAP;
            var textPoint = $5b455ae6f843ac47$export$9f9dcb98c894b623([
                orderedHandleEnds[handleIndex] + (handleIndex === 0 ? -offset : offset),
                this._size[1] / 2
            ], barTransform);
            handleLabels[handleIndex].setStyle({
                x: textPoint[0],
                y: textPoint[1],
                verticalAlign: orient === $eee50458c1b708ef$var$HORIZONTAL ? 'middle' : direction,
                align: orient === $eee50458c1b708ef$var$HORIZONTAL ? direction : 'center',
                text: labelTexts[handleIndex]
            });
        }
    };
    SliderZoomView.prototype._formatLabel = function(value, axis) {
        var dataZoomModel = this.dataZoomModel;
        var labelFormatter = dataZoomModel.get('labelFormatter');
        var labelPrecision = dataZoomModel.get('labelPrecision');
        if (labelPrecision == null || labelPrecision === 'auto') labelPrecision = axis.getPixelPrecision();
        var valueStr = value == null || isNaN(value) ? '' : axis.type === 'category' || axis.type === 'time' ? axis.scale.getLabel({
            value: Math.round(value)
        }) : value.toFixed(Math.min(labelPrecision, 20));
        return (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(labelFormatter) ? labelFormatter(value, valueStr) : (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(labelFormatter) ? labelFormatter.replace('{value}', valueStr) : valueStr;
    };
    /**
   * @param isEmphasis true: show, false: hide
   */ SliderZoomView.prototype._showDataInfo = function(isEmphasis) {
        var handleLabel = this.dataZoomModel.get('handleLabel') || {};
        var normalShow = handleLabel.show || false;
        var emphasisHandleLabel = this.dataZoomModel.getModel([
            'emphasis',
            'handleLabel'
        ]);
        var emphasisShow = emphasisHandleLabel.get('show') || false;
        // Dragging is considered as emphasis, unless emphasisShow is false
        var toShow = isEmphasis || this._dragging ? emphasisShow : normalShow;
        var displayables = this._displayables;
        var handleLabels = displayables.handleLabels;
        handleLabels[0].attr('invisible', !toShow);
        handleLabels[1].attr('invisible', !toShow);
        // Highlight move handle
        displayables.moveHandle && this.api[toShow ? 'enterEmphasis' : 'leaveEmphasis'](displayables.moveHandle, 1);
    };
    SliderZoomView.prototype._onDragMove = function(handleIndex, dx, dy, event) {
        this._dragging = true;
        // For mobile device, prevent screen slider on the button.
        $b3864a78637ff9ed$export$fa6813432f753b0d(event.event);
        // Transform dx, dy to bar coordination.
        var barTransform = this._displayables.sliderGroup.getLocalTransform();
        var vertex = $5b455ae6f843ac47$export$9f9dcb98c894b623([
            dx,
            dy
        ], barTransform, true);
        var changed = this._updateInterval(handleIndex, vertex[0]);
        var realtime = this.dataZoomModel.get('realtime');
        this._updateView(!realtime);
        // Avoid dispatch dataZoom repeatly but range not changed,
        // which cause bad visual effect when progressive enabled.
        changed && realtime && this._dispatchZoomAction(true);
    };
    SliderZoomView.prototype._onDragEnd = function() {
        this._dragging = false;
        this._showDataInfo(false);
        // While in realtime mode and stream mode, dispatch action when
        // drag end will cause the whole view rerender, which is unnecessary.
        var realtime = this.dataZoomModel.get('realtime');
        !realtime && this._dispatchZoomAction(false);
    };
    SliderZoomView.prototype._onClickPanel = function(e) {
        var size = this._size;
        var localPoint = this._displayables.sliderGroup.transformCoordToLocal(e.offsetX, e.offsetY);
        if (localPoint[0] < 0 || localPoint[0] > size[0] || localPoint[1] < 0 || localPoint[1] > size[1]) return;
        var handleEnds = this._handleEnds;
        var center = (handleEnds[0] + handleEnds[1]) / 2;
        var changed = this._updateInterval('all', localPoint[0] - center);
        this._updateView();
        changed && this._dispatchZoomAction(false);
    };
    SliderZoomView.prototype._onBrushStart = function(e) {
        var x = e.offsetX;
        var y = e.offsetY;
        this._brushStart = new $b887f038f104fe7e$export$2e2bcd8739ae039(x, y);
        this._brushing = true;
        this._brushStartTime = +new Date();
    // this._updateBrushRect(x, y);
    };
    SliderZoomView.prototype._onBrushEnd = function(e) {
        if (!this._brushing) return;
        var brushRect = this._displayables.brushRect;
        this._brushing = false;
        if (!brushRect) return;
        brushRect.attr('ignore', true);
        var brushShape = brushRect.shape;
        var brushEndTime = +new Date();
        // console.log(brushEndTime - this._brushStartTime);
        if (brushEndTime - this._brushStartTime < 200 && Math.abs(brushShape.width) < 5) // Will treat it as a click
        return;
        var viewExtend = this._getViewExtent();
        var percentExtent = [
            0,
            100
        ];
        this._range = (0, $cfc1f3b422a3185f$export$debe6e778e0a6d32)([
            (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(brushShape.x, viewExtend, percentExtent, true),
            (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(brushShape.x + brushShape.width, viewExtend, percentExtent, true)
        ]);
        this._handleEnds = [
            brushShape.x,
            brushShape.x + brushShape.width
        ];
        this._updateView();
        this._dispatchZoomAction(false);
    };
    SliderZoomView.prototype._onBrush = function(e) {
        if (this._brushing) {
            // For mobile device, prevent screen slider on the button.
            $b3864a78637ff9ed$export$fa6813432f753b0d(e.event);
            this._updateBrushRect(e.offsetX, e.offsetY);
        }
    };
    SliderZoomView.prototype._updateBrushRect = function(mouseX, mouseY) {
        var displayables = this._displayables;
        var dataZoomModel = this.dataZoomModel;
        var brushRect = displayables.brushRect;
        if (!brushRect) {
            brushRect = displayables.brushRect = new $eee50458c1b708ef$var$Rect({
                silent: true,
                style: dataZoomModel.getModel('brushStyle').getItemStyle()
            });
            displayables.sliderGroup.add(brushRect);
        }
        brushRect.attr('ignore', false);
        var brushStart = this._brushStart;
        var sliderGroup = this._displayables.sliderGroup;
        var endPoint = sliderGroup.transformCoordToLocal(mouseX, mouseY);
        var startPoint = sliderGroup.transformCoordToLocal(brushStart.x, brushStart.y);
        var size = this._size;
        endPoint[0] = Math.max(Math.min(size[0], endPoint[0]), 0);
        brushRect.setShape({
            x: startPoint[0],
            y: 0,
            width: endPoint[0] - startPoint[0],
            height: size[1]
        });
    };
    /**
   * This action will be throttled.
   */ SliderZoomView.prototype._dispatchZoomAction = function(realtime) {
        var range = this._range;
        this.api.dispatchAction({
            type: 'dataZoom',
            from: this.uid,
            dataZoomId: this.dataZoomModel.id,
            animation: realtime ? $eee50458c1b708ef$var$REALTIME_ANIMATION_CONFIG : null,
            start: range[0],
            end: range[1]
        });
    };
    SliderZoomView.prototype._findCoordRect = function() {
        // Find the grid corresponding to the first axis referred by dataZoom.
        var rect;
        var coordSysInfoList = (0, $554cb472ba0e05d3$export$b41173dee9da195b)(this.dataZoomModel).infoList;
        if (!rect && coordSysInfoList.length) {
            var coordSys = coordSysInfoList[0].model.coordinateSystem;
            rect = coordSys.getRect && coordSys.getRect();
        }
        if (!rect) {
            var width = this.api.getWidth();
            var height = this.api.getHeight();
            rect = {
                x: width * 0.2,
                y: height * 0.2,
                width: width * 0.6,
                height: height * 0.6
            };
        }
        return rect;
    };
    SliderZoomView.type = 'dataZoom.slider';
    return SliderZoomView;
}((0, $80d6a03162f25654$export$2e2bcd8739ae039));
function $eee50458c1b708ef$var$getOtherDim(thisDim) {
    // FIXME
    // 这个逻辑和getOtherAxis里一致，但是写在这里是否不好
    var map = {
        x: 'y',
        y: 'x',
        radius: 'angle',
        angle: 'radius'
    };
    return map[thisDim];
}
function $eee50458c1b708ef$var$getCursor(orient) {
    return orient === 'vertical' ? 'ns-resize' : 'ew-resize';
}
var $eee50458c1b708ef$export$2e2bcd8739ae039 = $eee50458c1b708ef$var$SliderZoomView;



function $794c23331e97718e$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $8fa9b5e71c234965$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $eee50458c1b708ef$export$2e2bcd8739ae039));
    (0, $8904ef10f452e35c$export$2e2bcd8739ae039)(registers);
}


function $aa2dc70f9fa9453b$export$4b3e715f166fdd78(registers) {
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $b5ee445cd897e37a$export$4b3e715f166fdd78));
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $794c23331e97718e$export$4b3e715f166fdd78));
// Do not install './dataZoomSelect',
// since it only work for toolbox dataZoom.
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




function $21e1121941dbd8a9$export$f6339b3d96c5d3d7(resultItem, newElOption) {
    var existElOption = resultItem.existing;
    // Set id and type after id assigned.
    newElOption.id = resultItem.keyInfo.id;
    !newElOption.type && existElOption && (newElOption.type = existElOption.type);
    // Set parent id if not specified
    if (newElOption.parentId == null) {
        var newElParentOption = newElOption.parentOption;
        if (newElParentOption) newElOption.parentId = newElParentOption.id;
        else if (existElOption) newElOption.parentId = existElOption.parentId;
    }
    // Clear
    newElOption.parentOption = null;
}
function $21e1121941dbd8a9$var$isSetLoc(obj, props) {
    var isSet;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(props, function(prop) {
        obj[prop] != null && obj[prop] !== 'auto' && (isSet = true);
    });
    return isSet;
}
function $21e1121941dbd8a9$var$mergeNewElOptionToExist(existList, index, newElOption) {
    // Update existing options, for `getOption` feature.
    var newElOptCopy = $7a1bd9c2710fea0d$export$8b58be045bf06082({}, newElOption);
    var existElOption = existList[index];
    var $action = newElOption.$action || 'merge';
    if ($action === 'merge') {
        if (existElOption) {
            var newType;
            // We can ensure that newElOptCopy and existElOption are not
            // the same object, so `merge` will not change newElOptCopy.
            $7a1bd9c2710fea0d$export$4950aa0f605343fb(existElOption, newElOptCopy, true);
            // Rigid body, use ignoreSize.
            (0, $93b9bc7f22ac7369$export$1754cb91f16ca028)(existElOption, newElOptCopy, {
                ignoreSize: true
            });
            // Will be used in render.
            (0, $93b9bc7f22ac7369$export$7438999faea9b6cc)(newElOption, existElOption);
            // Copy transition info to new option so it can be used in the transition.
            // DO IT AFTER merge
            $21e1121941dbd8a9$var$copyTransitionInfo(newElOption, existElOption);
            $21e1121941dbd8a9$var$copyTransitionInfo(newElOption, existElOption, 'shape');
            $21e1121941dbd8a9$var$copyTransitionInfo(newElOption, existElOption, 'style');
            $21e1121941dbd8a9$var$copyTransitionInfo(newElOption, existElOption, 'extra');
            // Copy clipPath
            newElOption.clipPath = existElOption.clipPath;
        } else existList[index] = newElOptCopy;
    } else if ($action === 'replace') existList[index] = newElOptCopy;
    else if ($action === 'remove') // null will be cleaned later.
    existElOption && (existList[index] = null);
}
var $21e1121941dbd8a9$var$TRANSITION_PROPS_TO_COPY = [
    'transition',
    'enterFrom',
    'leaveTo'
];
var $21e1121941dbd8a9$var$ROOT_TRANSITION_PROPS_TO_COPY = $21e1121941dbd8a9$var$TRANSITION_PROPS_TO_COPY.concat([
    'enterAnimation',
    'updateAnimation',
    'leaveAnimation'
]);
function $21e1121941dbd8a9$var$copyTransitionInfo(target, source, targetProp) {
    if (targetProp) {
        if (!target[targetProp] && source[targetProp]) // TODO avoid creating this empty object when there is no transition configuration.
        target[targetProp] = {};
        target = target[targetProp];
        source = source[targetProp];
    }
    if (!target || !source) return;
    var props = targetProp ? $21e1121941dbd8a9$var$TRANSITION_PROPS_TO_COPY : $21e1121941dbd8a9$var$ROOT_TRANSITION_PROPS_TO_COPY;
    for(var i = 0; i < props.length; i++){
        var prop = props[i];
        if (target[prop] == null && source[prop] != null) target[prop] = source[prop];
    }
}
function $21e1121941dbd8a9$var$setLayoutInfoToExist(existItem, newElOption) {
    if (!existItem) return;
    existItem.hv = newElOption.hv = [
        // Rigid body, don't care about `width`.
        $21e1121941dbd8a9$var$isSetLoc(newElOption, [
            'left',
            'right'
        ]),
        // Rigid body, don't care about `height`.
        $21e1121941dbd8a9$var$isSetLoc(newElOption, [
            'top',
            'bottom'
        ])
    ];
    // Give default group size. Otherwise layout error may occur.
    if (existItem.type === 'group') {
        var existingGroupOpt = existItem;
        var newGroupOpt = newElOption;
        existingGroupOpt.width == null && (existingGroupOpt.width = newGroupOpt.width = 0);
        existingGroupOpt.height == null && (existingGroupOpt.height = newGroupOpt.height = 0);
    }
}
var $21e1121941dbd8a9$export$6d85925da4d2cf23 = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(GraphicComponentModel, _super);
    function GraphicComponentModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GraphicComponentModel.type;
        _this.preventAutoZ = true;
        return _this;
    }
    GraphicComponentModel.prototype.mergeOption = function(option, ecModel) {
        // Prevent default merge to elements
        var elements = this.option.elements;
        this.option.elements = null;
        _super.prototype.mergeOption.call(this, option, ecModel);
        this.option.elements = elements;
    };
    GraphicComponentModel.prototype.optionUpdated = function(newOption, isInit) {
        var thisOption = this.option;
        var newList = (isInit ? thisOption : newOption).elements;
        var existList = thisOption.elements = isInit ? [] : thisOption.elements;
        var flattenedList = [];
        this._flatten(newList, flattenedList, null);
        var mappingResult = $76d619f648247e6d$export$574f818966e4da87(existList, flattenedList, 'normalMerge');
        // Clear elOptionsToUpdate
        var elOptionsToUpdate = this._elOptionsToUpdate = [];
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(mappingResult, function(resultItem, index) {
            var newElOption = resultItem.newOption;
            if (!newElOption) return;
            elOptionsToUpdate.push(newElOption);
            $21e1121941dbd8a9$export$f6339b3d96c5d3d7(resultItem, newElOption);
            $21e1121941dbd8a9$var$mergeNewElOptionToExist(existList, index, newElOption);
            $21e1121941dbd8a9$var$setLayoutInfoToExist(existList[index], newElOption);
        }, this);
        // Clean
        thisOption.elements = $7a1bd9c2710fea0d$export$3dea766d36a8935f(existList, function(item) {
            // $action should be volatile, otherwise option gotten from
            // `getOption` will contain unexpected $action.
            item && delete item.$action;
            return item != null;
        });
    };
    /**
   * Convert
   * [{
   *  type: 'group',
   *  id: 'xx',
   *  children: [{type: 'circle'}, {type: 'polygon'}]
   * }]
   * to
   * [
   *  {type: 'group', id: 'xx'},
   *  {type: 'circle', parentId: 'xx'},
   *  {type: 'polygon', parentId: 'xx'}
   * ]
   */ GraphicComponentModel.prototype._flatten = function(optionList, result, parentOption) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(optionList, function(option) {
            if (!option) return;
            if (parentOption) option.parentOption = parentOption;
            result.push(option);
            var children = option.children;
            // here we don't judge if option.type is `group`
            // when new option doesn't provide `type`, it will cause that the children can't be updated.
            if (children && children.length) this._flatten(children, result, option);
            // Deleting for JSON output, and for not affecting group creation.
            delete option.children;
        }, this);
    };
    // FIXME
    // Pass to view using payload? setOption has a payload?
    GraphicComponentModel.prototype.useElOptionsToUpdate = function() {
        var els = this._elOptionsToUpdate;
        // Clear to avoid render duplicately when zooming.
        this._elOptionsToUpdate = null;
        return els;
    };
    GraphicComponentModel.type = 'graphic';
    GraphicComponentModel.defaultOption = {
        elements: []
    };
    return GraphicComponentModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 












var $2b680c3ccdb25c77$var$nonShapeGraphicElements = {
    // Reserved but not supported in graphic component.
    path: null,
    compoundPath: null,
    // Supported in graphic component.
    group: $7ef7583d8302ffce$export$2e2bcd8739ae039,
    image: $86adec94217b86c6$export$2e2bcd8739ae039,
    text: $fe885cc21795562b$export$2e2bcd8739ae039
};
var $2b680c3ccdb25c77$export$4ae363f1d88fb658 = $76d619f648247e6d$export$64df9f8d92ae083f();
// ------------------------
// View
// ------------------------
var $2b680c3ccdb25c77$export$1132c9ab9ad80748 = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(GraphicComponentView, _super);
    function GraphicComponentView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GraphicComponentView.type;
        return _this;
    }
    GraphicComponentView.prototype.init = function() {
        this._elMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
    };
    GraphicComponentView.prototype.render = function(graphicModel, ecModel, api) {
        // Having leveraged between use cases and algorithm complexity, a very
        // simple layout mechanism is used:
        // The size(width/height) can be determined by itself or its parent (not
        // implemented yet), but can not by its children. (Top-down travel)
        // The location(x/y) can be determined by the bounding rect of itself
        // (can including its descendants or not) and the size of its parent.
        // (Bottom-up travel)
        // When `chart.clear()` or `chart.setOption({...}, true)` with the same id,
        // view will be reused.
        if (graphicModel !== this._lastGraphicModel) this._clear();
        this._lastGraphicModel = graphicModel;
        this._updateElements(graphicModel);
        this._relocate(graphicModel, api);
    };
    /**
   * Update graphic elements.
   */ GraphicComponentView.prototype._updateElements = function(graphicModel) {
        var elOptionsToUpdate = graphicModel.useElOptionsToUpdate();
        if (!elOptionsToUpdate) return;
        var elMap = this._elMap;
        var rootGroup = this.group;
        var globalZ = graphicModel.get('z');
        var globalZLevel = graphicModel.get('zlevel');
        // Top-down tranverse to assign graphic settings to each elements.
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(elOptionsToUpdate, function(elOption) {
            var id = $76d619f648247e6d$export$fb1a222ba5dd6e51(elOption.id, null);
            var elExisting = id != null ? elMap.get(id) : null;
            var parentId = $76d619f648247e6d$export$fb1a222ba5dd6e51(elOption.parentId, null);
            var targetElParent = parentId != null ? elMap.get(parentId) : rootGroup;
            var elType = elOption.type;
            var elOptionStyle = elOption.style;
            if (elType === 'text' && elOptionStyle) // In top/bottom mode, textVerticalAlign should not be used, which cause
            // inaccurately locating.
            {
                if (elOption.hv && elOption.hv[1]) elOptionStyle.textVerticalAlign = elOptionStyle.textBaseline = elOptionStyle.verticalAlign = elOptionStyle.align = null;
            }
            var textContentOption = elOption.textContent;
            var textConfig = elOption.textConfig;
            if (elOptionStyle && (0, $daa53642c3afcc30$export$3b868abde5eae7d1)(elOptionStyle, elType, !!textConfig, !!textContentOption)) {
                var convertResult = (0, $daa53642c3afcc30$export$7748133eaaa8aecc)(elOptionStyle, elType, true);
                if (!textConfig && convertResult.textConfig) textConfig = elOption.textConfig = convertResult.textConfig;
                if (!textContentOption && convertResult.textContent) textContentOption = convertResult.textContent;
            }
            // Remove unnecessary props to avoid potential problems.
            var elOptionCleaned = $2b680c3ccdb25c77$var$getCleanedElOption(elOption);
            var $action = elOption.$action || 'merge';
            var isMerge = $action === 'merge';
            var isReplace = $action === 'replace';
            if (isMerge) {
                var isInit = !elExisting;
                var el_1 = elExisting;
                if (isInit) el_1 = $2b680c3ccdb25c77$var$createEl(id, targetElParent, elOption.type, elMap);
                else {
                    el_1 && ($2b680c3ccdb25c77$export$4ae363f1d88fb658(el_1).isNew = false);
                    // Stop and restore before update any other attributes.
                    (0, $ab8d73690f09fb6d$export$9e5c70edf1ec0cb4)(el_1);
                }
                if (el_1) {
                    (0, $7c104376a000308e$export$4342b281b9b5d77e)(el_1, elOptionCleaned, graphicModel, {
                        isInit: isInit
                    });
                    $2b680c3ccdb25c77$var$updateCommonAttrs(el_1, elOption, globalZ, globalZLevel);
                }
            } else if (isReplace) {
                $2b680c3ccdb25c77$var$removeEl(elExisting, elOption, elMap, graphicModel);
                var el_2 = $2b680c3ccdb25c77$var$createEl(id, targetElParent, elOption.type, elMap);
                if (el_2) {
                    (0, $7c104376a000308e$export$4342b281b9b5d77e)(el_2, elOptionCleaned, graphicModel, {
                        isInit: true
                    });
                    $2b680c3ccdb25c77$var$updateCommonAttrs(el_2, elOption, globalZ, globalZLevel);
                }
            } else if ($action === 'remove') {
                (0, $7c104376a000308e$export$a6f11bb1cb100e2a)(elExisting, elOption);
                $2b680c3ccdb25c77$var$removeEl(elExisting, elOption, elMap, graphicModel);
            }
            var el = elMap.get(id);
            if (el && textContentOption) {
                if (isMerge) {
                    var textContentExisting = el.getTextContent();
                    textContentExisting ? textContentExisting.attr(textContentOption) : el.setTextContent(new $fe885cc21795562b$export$2e2bcd8739ae039(textContentOption));
                } else if (isReplace) el.setTextContent(new $fe885cc21795562b$export$2e2bcd8739ae039(textContentOption));
            }
            if (el) {
                var clipPathOption = elOption.clipPath;
                if (clipPathOption) {
                    var clipPathType = clipPathOption.type;
                    var clipPath = void 0;
                    var isInit = false;
                    if (isMerge) {
                        var oldClipPath = el.getClipPath();
                        isInit = !oldClipPath || $2b680c3ccdb25c77$export$4ae363f1d88fb658(oldClipPath).type !== clipPathType;
                        clipPath = isInit ? $2b680c3ccdb25c77$var$newEl(clipPathType) : oldClipPath;
                    } else if (isReplace) {
                        isInit = true;
                        clipPath = $2b680c3ccdb25c77$var$newEl(clipPathType);
                    }
                    el.setClipPath(clipPath);
                    (0, $7c104376a000308e$export$4342b281b9b5d77e)(clipPath, clipPathOption, graphicModel, {
                        isInit: isInit
                    });
                    (0, $ab8d73690f09fb6d$export$b0aa6a5f01693fa4)(clipPath, clipPathOption.keyframeAnimation, graphicModel);
                }
                var elInner = $2b680c3ccdb25c77$export$4ae363f1d88fb658(el);
                el.setTextConfig(textConfig);
                elInner.option = elOption;
                $2b680c3ccdb25c77$var$setEventData(el, graphicModel, elOption);
                $5b455ae6f843ac47$export$fc6410d97fab306c({
                    el: el,
                    componentModel: graphicModel,
                    itemName: el.name,
                    itemTooltipOption: elOption.tooltip
                });
                (0, $ab8d73690f09fb6d$export$b0aa6a5f01693fa4)(el, elOption.keyframeAnimation, graphicModel);
            }
        });
    };
    /**
   * Locate graphic elements.
   */ GraphicComponentView.prototype._relocate = function(graphicModel, api) {
        var elOptions = graphicModel.option.elements;
        var rootGroup = this.group;
        var elMap = this._elMap;
        var apiWidth = api.getWidth();
        var apiHeight = api.getHeight();
        var xy = [
            'x',
            'y'
        ];
        // Top-down to calculate percentage width/height of group
        for(var i = 0; i < elOptions.length; i++){
            var elOption = elOptions[i];
            var id = $76d619f648247e6d$export$fb1a222ba5dd6e51(elOption.id, null);
            var el = id != null ? elMap.get(id) : null;
            if (!el || !el.isGroup) continue;
            var parentEl = el.parent;
            var isParentRoot = parentEl === rootGroup;
            // Like 'position:absolut' in css, default 0.
            var elInner = $2b680c3ccdb25c77$export$4ae363f1d88fb658(el);
            var parentElInner = $2b680c3ccdb25c77$export$4ae363f1d88fb658(parentEl);
            elInner.width = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(elInner.option.width, isParentRoot ? apiWidth : parentElInner.width) || 0;
            elInner.height = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(elInner.option.height, isParentRoot ? apiHeight : parentElInner.height) || 0;
        }
        // Bottom-up tranvese all elements (consider ec resize) to locate elements.
        for(var i = elOptions.length - 1; i >= 0; i--){
            var elOption = elOptions[i];
            var id = $76d619f648247e6d$export$fb1a222ba5dd6e51(elOption.id, null);
            var el = id != null ? elMap.get(id) : null;
            if (!el) continue;
            var parentEl = el.parent;
            var parentElInner = $2b680c3ccdb25c77$export$4ae363f1d88fb658(parentEl);
            var containerInfo = parentEl === rootGroup ? {
                width: apiWidth,
                height: apiHeight
            } : {
                width: parentElInner.width,
                height: parentElInner.height
            };
            // PENDING
            // Currently, when `bounding: 'all'`, the union bounding rect of the group
            // does not include the rect of [0, 0, group.width, group.height], which
            // is probably weird for users. Should we make a break change for it?
            var layoutPos = {};
            var layouted = $93b9bc7f22ac7369$export$74054bd96b5eeef1(el, elOption, containerInfo, null, {
                hv: elOption.hv,
                boundingMode: elOption.bounding
            }, layoutPos);
            if (!$2b680c3ccdb25c77$export$4ae363f1d88fb658(el).isNew && layouted) {
                var transition = elOption.transition;
                var animatePos = {};
                for(var k = 0; k < xy.length; k++){
                    var key = xy[k];
                    var val = layoutPos[key];
                    if (transition && ((0, $7c104376a000308e$export$6f3361b4b8d7a8ba)(transition) || $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(transition, key) >= 0)) animatePos[key] = val;
                    else el[key] = val;
                }
                (0, $8b353638fbedfefa$export$c8dce3c08436e91e)(el, animatePos, graphicModel, 0);
            } else el.attr(layoutPos);
        }
    };
    /**
   * Clear all elements.
   */ GraphicComponentView.prototype._clear = function() {
        var _this = this;
        var elMap = this._elMap;
        elMap.each(function(el) {
            $2b680c3ccdb25c77$var$removeEl(el, $2b680c3ccdb25c77$export$4ae363f1d88fb658(el).option, elMap, _this._lastGraphicModel);
        });
        this._elMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
    };
    GraphicComponentView.prototype.dispose = function() {
        this._clear();
    };
    GraphicComponentView.type = 'graphic';
    return GraphicComponentView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
function $2b680c3ccdb25c77$var$newEl(graphicType) {
    var Clz = $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3($2b680c3ccdb25c77$var$nonShapeGraphicElements, graphicType) ? $2b680c3ccdb25c77$var$nonShapeGraphicElements[graphicType] : $5b455ae6f843ac47$export$51df4b5565a58189(graphicType);
    var el = new Clz({});
    $2b680c3ccdb25c77$export$4ae363f1d88fb658(el).type = graphicType;
    return el;
}
function $2b680c3ccdb25c77$var$createEl(id, targetElParent, graphicType, elMap) {
    var el = $2b680c3ccdb25c77$var$newEl(graphicType);
    targetElParent.add(el);
    elMap.set(id, el);
    $2b680c3ccdb25c77$export$4ae363f1d88fb658(el).id = id;
    $2b680c3ccdb25c77$export$4ae363f1d88fb658(el).isNew = true;
    return el;
}
function $2b680c3ccdb25c77$var$removeEl(elExisting, elOption, elMap, graphicModel) {
    var existElParent = elExisting && elExisting.parent;
    if (existElParent) {
        elExisting.type === 'group' && elExisting.traverse(function(el) {
            $2b680c3ccdb25c77$var$removeEl(el, elOption, elMap, graphicModel);
        });
        (0, $7c104376a000308e$export$15575b6d82d35bb3)(elExisting, elOption, graphicModel);
        elMap.removeKey($2b680c3ccdb25c77$export$4ae363f1d88fb658(elExisting).id);
    }
}
function $2b680c3ccdb25c77$var$updateCommonAttrs(el, elOption, defaultZ, defaultZlevel) {
    if (!el.isGroup) $7a1bd9c2710fea0d$export$79b2f7037acddd43([
        [
            'cursor',
            (0, $56206a6cb4666931$export$2e2bcd8739ae039).prototype.cursor
        ],
        // We should not support configure z and zlevel in the element level.
        // But seems we didn't limit it previously. So here still use it to avoid breaking.
        [
            'zlevel',
            defaultZlevel || 0
        ],
        [
            'z',
            defaultZ || 0
        ],
        // z2 must not be null/undefined, otherwise sort error may occur.
        [
            'z2',
            0
        ]
    ], function(item) {
        var prop = item[0];
        if ($7a1bd9c2710fea0d$export$b5a638e9b3fff9f3(elOption, prop)) el[prop] = $7a1bd9c2710fea0d$export$995e01f2f5c9d030(elOption[prop], item[1]);
        else if (el[prop] == null) el[prop] = item[1];
    });
    $7a1bd9c2710fea0d$export$79b2f7037acddd43($7a1bd9c2710fea0d$export$ed97f33186d4b816(elOption), function(key) {
        // Assign event handlers.
        // PENDING: should enumerate all event names or use pattern matching?
        if (key.indexOf('on') === 0) {
            var val = elOption[key];
            el[key] = $7a1bd9c2710fea0d$export$f6e2535fb5126e54(val) ? val : null;
        }
    });
    if ($7a1bd9c2710fea0d$export$b5a638e9b3fff9f3(elOption, 'draggable')) el.draggable = elOption.draggable;
    // Other attributes
    elOption.name != null && (el.name = elOption.name);
    elOption.id != null && (el.id = elOption.id);
}
// Remove unnecessary props to avoid potential problems.
function $2b680c3ccdb25c77$var$getCleanedElOption(elOption) {
    elOption = $7a1bd9c2710fea0d$export$8b58be045bf06082({}, elOption);
    $7a1bd9c2710fea0d$export$79b2f7037acddd43([
        'id',
        'parentId',
        '$action',
        'hv',
        'bounding',
        'textContent',
        'clipPath'
    ].concat($93b9bc7f22ac7369$export$a9aa2cc018afbed), function(name) {
        delete elOption[name];
    });
    return elOption;
}
function $2b680c3ccdb25c77$var$setEventData(el, graphicModel, elOption) {
    var eventData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).eventData;
    // Simple optimize for large amount of elements that no need event.
    if (!el.silent && !el.ignore && !eventData) eventData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).eventData = {
        componentType: 'graphic',
        componentIndex: graphicModel.componentIndex,
        name: el.name
    };
    // `elOption.info` enables user to mount some info on
    // elements and use them in event handlers.
    if (eventData) eventData.info = elOption.info;
}


function $48174658d54922b7$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $21e1121941dbd8a9$export$6d85925da4d2cf23));
    registers.registerComponentView((0, $2b680c3ccdb25c77$export$1132c9ab9ad80748));
    registers.registerPreprocessor(function(option) {
        var graphicOption = option.graphic;
        // Convert
        // {graphic: [{left: 10, type: 'circle'}, ...]}
        // or
        // {graphic: {left: 10, type: 'circle'}}
        // to
        // {graphic: [{elements: [{left: 10, type: 'circle'}, ...]}]}
        if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(graphicOption)) {
            if (!graphicOption[0] || !graphicOption[0].elements) option.graphic = [
                {
                    elements: graphicOption
                }
            ];
            else // Only one graphic instance can be instantiated. (We don't
            // want that too many views are created in echarts._viewMap.)
            option.graphic = [
                option.graphic[0]
            ];
        } else if (graphicOption && !graphicOption.elements) option.graphic = [
            {
                elements: [
                    graphicOption
                ]
            }
        ];
    });
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $30909b2e837c2175$export$4b3e715f166fdd78(registers) {
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $1021478d6a16b0aa$export$4b3e715f166fdd78));
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $589507869c21caa1$export$4b3e715f166fdd78));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $0fbb1ae1b8df4cab$var$getDefaultSelectorOptions = function(ecModel, type) {
    if (type === 'all') return {
        type: 'all',
        title: ecModel.getLocaleModel().get([
            'legend',
            'selector',
            'all'
        ])
    };
    else if (type === 'inverse') return {
        type: 'inverse',
        title: ecModel.getLocaleModel().get([
            'legend',
            'selector',
            'inverse'
        ])
    };
};
var $0fbb1ae1b8df4cab$var$LegendModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(LegendModel, _super);
    function LegendModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = LegendModel.type;
        _this.layoutMode = {
            type: 'box',
            // legend.width/height are maxWidth/maxHeight actually,
            // whereas real width/height is calculated by its content.
            // (Setting {left: 10, right: 10} does not make sense).
            // So consider the case:
            // `setOption({legend: {left: 10});`
            // then `setOption({legend: {right: 10});`
            // The previous `left` should be cleared by setting `ignoreSize`.
            ignoreSize: true
        };
        return _this;
    }
    LegendModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
        option.selected = option.selected || {};
        this._updateSelector(option);
    };
    LegendModel.prototype.mergeOption = function(option, ecModel) {
        _super.prototype.mergeOption.call(this, option, ecModel);
        this._updateSelector(option);
    };
    LegendModel.prototype._updateSelector = function(option) {
        var selector = option.selector;
        var ecModel = this.ecModel;
        if (selector === true) selector = option.selector = [
            'all',
            'inverse'
        ];
        if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(selector)) $7a1bd9c2710fea0d$export$79b2f7037acddd43(selector, function(item, index) {
            $7a1bd9c2710fea0d$export$844ec244b1367d54(item) && (item = {
                type: item
            });
            selector[index] = $7a1bd9c2710fea0d$export$4950aa0f605343fb(item, $0fbb1ae1b8df4cab$var$getDefaultSelectorOptions(ecModel, item.type));
        });
    };
    LegendModel.prototype.optionUpdated = function() {
        this._updateData(this.ecModel);
        var legendData = this._data;
        // If selectedMode is single, try to select one
        if (legendData[0] && this.get('selectedMode') === 'single') {
            var hasSelected = false;
            // If has any selected in option.selected
            for(var i = 0; i < legendData.length; i++){
                var name_1 = legendData[i].get('name');
                if (this.isSelected(name_1)) {
                    // Force to unselect others
                    this.select(name_1);
                    hasSelected = true;
                    break;
                }
            }
            // Try select the first if selectedMode is single
            !hasSelected && this.select(legendData[0].get('name'));
        }
    };
    LegendModel.prototype._updateData = function(ecModel) {
        var potentialData = [];
        var availableNames = [];
        ecModel.eachRawSeries(function(seriesModel) {
            var seriesName = seriesModel.name;
            availableNames.push(seriesName);
            var isPotential;
            if (seriesModel.legendVisualProvider) {
                var provider = seriesModel.legendVisualProvider;
                var names = provider.getAllNames();
                if (!ecModel.isSeriesFiltered(seriesModel)) availableNames = availableNames.concat(names);
                if (names.length) potentialData = potentialData.concat(names);
                else isPotential = true;
            } else isPotential = true;
            if (isPotential && (0, $76d619f648247e6d$export$beae19a2652b3368)(seriesModel)) potentialData.push(seriesModel.name);
        });
        /**
     * @type {Array.<string>}
     * @private
     */ this._availableNames = availableNames;
        // If legend.data is not specified in option, use availableNames as data,
        // which is convenient for user preparing option.
        var rawData = this.get('data') || potentialData;
        var legendNameMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        var legendData = $7a1bd9c2710fea0d$export$871de8747c9eaa88(rawData, function(dataItem) {
            // Can be string or number
            if ($7a1bd9c2710fea0d$export$844ec244b1367d54(dataItem) || $7a1bd9c2710fea0d$export$7e4aa119212bc614(dataItem)) dataItem = {
                name: dataItem
            };
            if (legendNameMap.get(dataItem.name)) // remove legend name duplicate
            return null;
            legendNameMap.set(dataItem.name, true);
            return new (0, $6818646a97528290$export$2e2bcd8739ae039)(dataItem, this, this.ecModel);
        }, this);
        /**
     * @type {Array.<module:echarts/model/Model>}
     * @private
     */ this._data = $7a1bd9c2710fea0d$export$3dea766d36a8935f(legendData, function(item) {
            return !!item;
        });
    };
    LegendModel.prototype.getData = function() {
        return this._data;
    };
    LegendModel.prototype.select = function(name) {
        var selected = this.option.selected;
        var selectedMode = this.get('selectedMode');
        if (selectedMode === 'single') {
            var data = this._data;
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(data, function(dataItem) {
                selected[dataItem.get('name')] = false;
            });
        }
        selected[name] = true;
    };
    LegendModel.prototype.unSelect = function(name) {
        if (this.get('selectedMode') !== 'single') this.option.selected[name] = false;
    };
    LegendModel.prototype.toggleSelected = function(name) {
        var selected = this.option.selected;
        // Default is true
        if (!selected.hasOwnProperty(name)) selected[name] = true;
        this[selected[name] ? 'unSelect' : 'select'](name);
    };
    LegendModel.prototype.allSelect = function() {
        var data = this._data;
        var selected = this.option.selected;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(data, function(dataItem) {
            selected[dataItem.get('name', true)] = true;
        });
    };
    LegendModel.prototype.inverseSelect = function() {
        var data = this._data;
        var selected = this.option.selected;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(data, function(dataItem) {
            var name = dataItem.get('name', true);
            // Initially, default value is true
            if (!selected.hasOwnProperty(name)) selected[name] = true;
            selected[name] = !selected[name];
        });
    };
    LegendModel.prototype.isSelected = function(name) {
        var selected = this.option.selected;
        return !(selected.hasOwnProperty(name) && !selected[name]) && $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(this._availableNames, name) >= 0;
    };
    LegendModel.prototype.getOrient = function() {
        return this.get('orient') === 'vertical' ? {
            index: 1,
            name: 'vertical'
        } : {
            index: 0,
            name: 'horizontal'
        };
    };
    LegendModel.type = 'legend.plain';
    LegendModel.dependencies = [
        'series'
    ];
    LegendModel.defaultOption = {
        // zlevel: 0,
        z: 4,
        show: true,
        orient: 'horizontal',
        left: 'center',
        // right: 'center',
        top: 0,
        // bottom: null,
        align: 'auto',
        backgroundColor: 'rgba(0,0,0,0)',
        borderColor: '#ccc',
        borderRadius: 0,
        borderWidth: 0,
        padding: 5,
        itemGap: 10,
        itemWidth: 25,
        itemHeight: 14,
        symbolRotate: 'inherit',
        symbolKeepAspect: true,
        inactiveColor: '#ccc',
        inactiveBorderColor: '#ccc',
        inactiveBorderWidth: 'auto',
        itemStyle: {
            color: 'inherit',
            opacity: 'inherit',
            borderColor: 'inherit',
            borderWidth: 'auto',
            borderCap: 'inherit',
            borderJoin: 'inherit',
            borderDashOffset: 'inherit',
            borderMiterLimit: 'inherit'
        },
        lineStyle: {
            width: 'auto',
            color: 'inherit',
            inactiveColor: '#ccc',
            inactiveWidth: 2,
            opacity: 'inherit',
            type: 'inherit',
            cap: 'inherit',
            join: 'inherit',
            dashOffset: 'inherit',
            miterLimit: 'inherit'
        },
        textStyle: {
            color: '#333'
        },
        selectedMode: true,
        selector: false,
        selectorLabel: {
            show: true,
            borderRadius: 10,
            padding: [
                3,
                5,
                3,
                5
            ],
            fontSize: 12,
            fontFamily: 'sans-serif',
            color: '#666',
            borderWidth: 1,
            borderColor: '#666'
        },
        emphasis: {
            selectorLabel: {
                show: true,
                color: '#eee',
                backgroundColor: '#666'
            }
        },
        selectorPosition: 'auto',
        selectorItemGap: 7,
        selectorButtonGap: 10,
        tooltip: {
            show: false
        }
    };
    return LegendModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $0fbb1ae1b8df4cab$export$2e2bcd8739ae039 = $0fbb1ae1b8df4cab$var$LegendModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // @ts-nocheck



function $40fca678c85406ff$export$b3219800bda33a1f(group, componentModel, api) {
    var boxLayoutParams = componentModel.getBoxLayoutParams();
    var padding = componentModel.get('padding');
    var viewportSize = {
        width: api.getWidth(),
        height: api.getHeight()
    };
    var rect = (0, $93b9bc7f22ac7369$export$4517a5ca639a7293)(boxLayoutParams, viewportSize, padding);
    (0, $93b9bc7f22ac7369$export$827f4ee28efc37)(componentModel.get('orient'), group, componentModel.get('itemGap'), rect.width, rect.height);
    (0, $93b9bc7f22ac7369$export$74054bd96b5eeef1)(group, boxLayoutParams, viewportSize, padding);
}
function $40fca678c85406ff$export$fae23936eedfad4f(rect, componentModel) {
    var padding = $c84c9521536c601a$export$f3a38102c49f4268(componentModel.get('padding'));
    var style = componentModel.getItemStyle([
        'color',
        'opacity'
    ]);
    style.fill = componentModel.get('backgroundColor');
    rect = new $419e5ff2f303755e$export$2e2bcd8739ae039({
        shape: {
            x: rect.x - padding[3],
            y: rect.y - padding[0],
            width: rect.width + padding[1] + padding[3],
            height: rect.height + padding[0] + padding[2],
            r: componentModel.get('borderRadius')
        },
        style: style,
        silent: true,
        z2: -1
    });
    // FIXME
    // `subPixelOptimizeRect` may bring some gap between edge of viewpart
    // and background rect when setting like `left: 0`, `top: 0`.
    // graphic.subPixelOptimizeRect(rect);
    return rect;
}







var $c2e212625ccc38b4$var$curry = $7a1bd9c2710fea0d$export$c3095a23b368d1f2;
var $c2e212625ccc38b4$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
var $c2e212625ccc38b4$var$Group = $7ef7583d8302ffce$export$2e2bcd8739ae039;
var $c2e212625ccc38b4$var$LegendView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(LegendView, _super);
    function LegendView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = LegendView.type;
        _this.newlineDisabled = false;
        return _this;
    }
    LegendView.prototype.init = function() {
        this.group.add(this._contentGroup = new $c2e212625ccc38b4$var$Group());
        this.group.add(this._selectorGroup = new $c2e212625ccc38b4$var$Group());
        this._isFirstRender = true;
    };
    /**
   * @protected
   */ LegendView.prototype.getContentGroup = function() {
        return this._contentGroup;
    };
    /**
   * @protected
   */ LegendView.prototype.getSelectorGroup = function() {
        return this._selectorGroup;
    };
    /**
   * @override
   */ LegendView.prototype.render = function(legendModel, ecModel, api) {
        var isFirstRender = this._isFirstRender;
        this._isFirstRender = false;
        this.resetInner();
        if (!legendModel.get('show', true)) return;
        var itemAlign = legendModel.get('align');
        var orient = legendModel.get('orient');
        if (!itemAlign || itemAlign === 'auto') itemAlign = legendModel.get('left') === 'right' && orient === 'vertical' ? 'right' : 'left';
        // selector has been normalized to an array in model
        var selector = legendModel.get('selector', true);
        var selectorPosition = legendModel.get('selectorPosition', true);
        if (selector && (!selectorPosition || selectorPosition === 'auto')) selectorPosition = orient === 'horizontal' ? 'end' : 'start';
        this.renderInner(itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition);
        // Perform layout.
        var positionInfo = legendModel.getBoxLayoutParams();
        var viewportSize = {
            width: api.getWidth(),
            height: api.getHeight()
        };
        var padding = legendModel.get('padding');
        var maxSize = $93b9bc7f22ac7369$export$4517a5ca639a7293(positionInfo, viewportSize, padding);
        var mainRect = this.layoutInner(legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition);
        // Place mainGroup, based on the calculated `mainRect`.
        var layoutRect = $93b9bc7f22ac7369$export$4517a5ca639a7293($7a1bd9c2710fea0d$export$ebe90cb607ad99e({
            width: mainRect.width,
            height: mainRect.height
        }, positionInfo), viewportSize, padding);
        this.group.x = layoutRect.x - mainRect.x;
        this.group.y = layoutRect.y - mainRect.y;
        this.group.markRedraw();
        // Render background after group is layout.
        this.group.add(this._backgroundEl = (0, $40fca678c85406ff$export$fae23936eedfad4f)(mainRect, legendModel));
    };
    LegendView.prototype.resetInner = function() {
        this.getContentGroup().removeAll();
        this._backgroundEl && this.group.remove(this._backgroundEl);
        this.getSelectorGroup().removeAll();
    };
    LegendView.prototype.renderInner = function(itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition) {
        var contentGroup = this.getContentGroup();
        var legendDrawnMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        var selectMode = legendModel.get('selectedMode');
        var excludeSeriesId = [];
        ecModel.eachRawSeries(function(seriesModel) {
            !seriesModel.get('legendHoverLink') && excludeSeriesId.push(seriesModel.id);
        });
        $c2e212625ccc38b4$var$each(legendModel.getData(), function(legendItemModel, dataIndex) {
            var name = legendItemModel.get('name');
            // Use empty string or \n as a newline string
            if (!this.newlineDisabled && (name === '' || name === '\n')) {
                var g = new $c2e212625ccc38b4$var$Group();
                // @ts-ignore
                g.newline = true;
                contentGroup.add(g);
                return;
            }
            // Representitive series.
            var seriesModel = ecModel.getSeriesByName(name)[0];
            if (legendDrawnMap.get(name)) // Have been drawn
            return;
            // Legend to control series.
            if (seriesModel) {
                var data = seriesModel.getData();
                var lineVisualStyle = data.getVisual('legendLineStyle') || {};
                var legendIcon = data.getVisual('legendIcon');
                /**
         * `data.getVisual('style')` may be the color from the register
         * in series. For example, for line series,
         */ var style = data.getVisual('style');
                var itemGroup = this._createItem(seriesModel, name, dataIndex, legendItemModel, legendModel, itemAlign, lineVisualStyle, style, legendIcon, selectMode, api);
                itemGroup.on('click', $c2e212625ccc38b4$var$curry($c2e212625ccc38b4$var$dispatchSelectAction, name, null, api, excludeSeriesId)).on('mouseover', $c2e212625ccc38b4$var$curry($c2e212625ccc38b4$var$dispatchHighlightAction, seriesModel.name, null, api, excludeSeriesId)).on('mouseout', $c2e212625ccc38b4$var$curry($c2e212625ccc38b4$var$dispatchDownplayAction, seriesModel.name, null, api, excludeSeriesId));
                if (ecModel.ssr) itemGroup.eachChild(function(child) {
                    var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(child);
                    ecData.seriesIndex = seriesModel.seriesIndex;
                    ecData.dataIndex = dataIndex;
                    ecData.ssrType = 'legend';
                });
                legendDrawnMap.set(name, true);
            } else // Legend to control data. In pie and funnel.
            ecModel.eachRawSeries(function(seriesModel) {
                // In case multiple series has same data name
                if (legendDrawnMap.get(name)) return;
                if (seriesModel.legendVisualProvider) {
                    var provider = seriesModel.legendVisualProvider;
                    if (!provider.containName(name)) return;
                    var idx = provider.indexOfName(name);
                    var style = provider.getItemVisual(idx, 'style');
                    var legendIcon = provider.getItemVisual(idx, 'legendIcon');
                    var colorArr = (0, $2c037f5bda6341ca$export$98e6a39c04603d36)(style.fill);
                    // Color may be set to transparent in visualMap when data is out of range.
                    // Do not show nothing.
                    if (colorArr && colorArr[3] === 0) {
                        colorArr[3] = 0.2;
                        // TODO color is set to 0, 0, 0, 0. Should show correct RGBA
                        style = $7a1bd9c2710fea0d$export$8b58be045bf06082($7a1bd9c2710fea0d$export$8b58be045bf06082({}, style), {
                            fill: (0, $2c037f5bda6341ca$export$fac44ee5b035f737)(colorArr, 'rgba')
                        });
                    }
                    var itemGroup = this._createItem(seriesModel, name, dataIndex, legendItemModel, legendModel, itemAlign, {}, style, legendIcon, selectMode, api);
                    // FIXME: consider different series has items with the same name.
                    itemGroup.on('click', $c2e212625ccc38b4$var$curry($c2e212625ccc38b4$var$dispatchSelectAction, null, name, api, excludeSeriesId))// Should not specify the series name, consider legend controls
                    // more than one pie series.
                    .on('mouseover', $c2e212625ccc38b4$var$curry($c2e212625ccc38b4$var$dispatchHighlightAction, null, name, api, excludeSeriesId)).on('mouseout', $c2e212625ccc38b4$var$curry($c2e212625ccc38b4$var$dispatchDownplayAction, null, name, api, excludeSeriesId));
                    if (ecModel.ssr) itemGroup.eachChild(function(child) {
                        var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(child);
                        ecData.seriesIndex = seriesModel.seriesIndex;
                        ecData.dataIndex = dataIndex;
                        ecData.ssrType = 'legend';
                    });
                    legendDrawnMap.set(name, true);
                }
            }, this);
        }, this);
        if (selector) this._createSelector(selector, legendModel, api, orient, selectorPosition);
    };
    LegendView.prototype._createSelector = function(selector, legendModel, api, orient, selectorPosition) {
        var selectorGroup = this.getSelectorGroup();
        $c2e212625ccc38b4$var$each(selector, function createSelectorButton(selectorItem) {
            var type = selectorItem.type;
            var labelText = new $fe885cc21795562b$export$2e2bcd8739ae039({
                style: {
                    x: 0,
                    y: 0,
                    align: 'center',
                    verticalAlign: 'middle'
                },
                onclick: function() {
                    api.dispatchAction({
                        type: type === 'all' ? 'legendAllSelect' : 'legendInverseSelect',
                        legendId: legendModel.id
                    });
                }
            });
            selectorGroup.add(labelText);
            var labelModel = legendModel.getModel('selectorLabel');
            var emphasisLabelModel = legendModel.getModel([
                'emphasis',
                'selectorLabel'
            ]);
            (0, $6800dfcb6e1e2a44$export$9a13992917966657)(labelText, {
                normal: labelModel,
                emphasis: emphasisLabelModel
            }, {
                defaultText: selectorItem.title
            });
            (0, $2bf82c0980125b62$export$5f393df0b5aee2e7)(labelText);
        });
    };
    LegendView.prototype._createItem = function(seriesModel, name, dataIndex, legendItemModel, legendModel, itemAlign, lineVisualStyle, itemVisualStyle, legendIcon, selectMode, api) {
        var drawType = seriesModel.visualDrawType;
        var itemWidth = legendModel.get('itemWidth');
        var itemHeight = legendModel.get('itemHeight');
        var isSelected = legendModel.isSelected(name);
        var iconRotate = legendItemModel.get('symbolRotate');
        var symbolKeepAspect = legendItemModel.get('symbolKeepAspect');
        var legendIconType = legendItemModel.get('icon');
        legendIcon = legendIconType || legendIcon || 'roundRect';
        var style = $c2e212625ccc38b4$var$getLegendStyle(legendIcon, legendItemModel, lineVisualStyle, itemVisualStyle, drawType, isSelected, api);
        var itemGroup = new $c2e212625ccc38b4$var$Group();
        var textStyleModel = legendItemModel.getModel('textStyle');
        if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(seriesModel.getLegendIcon) && (!legendIconType || legendIconType === 'inherit')) // Series has specific way to define legend icon
        itemGroup.add(seriesModel.getLegendIcon({
            itemWidth: itemWidth,
            itemHeight: itemHeight,
            icon: legendIcon,
            iconRotate: iconRotate,
            itemStyle: style.itemStyle,
            lineStyle: style.lineStyle,
            symbolKeepAspect: symbolKeepAspect
        }));
        else {
            // Use default legend icon policy for most series
            var rotate = legendIconType === 'inherit' && seriesModel.getData().getVisual('symbol') ? iconRotate === 'inherit' ? seriesModel.getData().getVisual('symbolRotate') : iconRotate : 0; // No rotation for no icon
            itemGroup.add($c2e212625ccc38b4$var$getDefaultLegendIcon({
                itemWidth: itemWidth,
                itemHeight: itemHeight,
                icon: legendIcon,
                iconRotate: rotate,
                itemStyle: style.itemStyle,
                lineStyle: style.lineStyle,
                symbolKeepAspect: symbolKeepAspect
            }));
        }
        var textX = itemAlign === 'left' ? itemWidth + 5 : -5;
        var textAlign = itemAlign;
        var formatter = legendModel.get('formatter');
        var content = name;
        if ($7a1bd9c2710fea0d$export$844ec244b1367d54(formatter) && formatter) content = formatter.replace('{name}', name != null ? name : '');
        else if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(formatter)) content = formatter(name);
        var textColor = isSelected ? textStyleModel.getTextColor() : legendItemModel.get('inactiveColor');
        itemGroup.add(new $fe885cc21795562b$export$2e2bcd8739ae039({
            style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(textStyleModel, {
                text: content,
                x: textX,
                y: itemHeight / 2,
                fill: textColor,
                align: textAlign,
                verticalAlign: 'middle'
            }, {
                inheritColor: textColor
            })
        }));
        // Add a invisible rect to increase the area of mouse hover
        var hitRect = new $419e5ff2f303755e$export$2e2bcd8739ae039({
            shape: itemGroup.getBoundingRect(),
            style: {
                // Cannot use 'invisible' because SVG SSR will miss the node
                fill: 'transparent'
            }
        });
        var tooltipModel = legendItemModel.getModel('tooltip');
        if (tooltipModel.get('show')) $5b455ae6f843ac47$export$fc6410d97fab306c({
            el: hitRect,
            componentModel: legendModel,
            itemName: name,
            itemTooltipOption: tooltipModel.option
        });
        itemGroup.add(hitRect);
        itemGroup.eachChild(function(child) {
            child.silent = true;
        });
        hitRect.silent = !selectMode;
        this.getContentGroup().add(itemGroup);
        (0, $2bf82c0980125b62$export$5f393df0b5aee2e7)(itemGroup);
        // @ts-ignore
        itemGroup.__legendDataIndex = dataIndex;
        return itemGroup;
    };
    LegendView.prototype.layoutInner = function(legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition) {
        var contentGroup = this.getContentGroup();
        var selectorGroup = this.getSelectorGroup();
        // Place items in contentGroup.
        $93b9bc7f22ac7369$export$827f4ee28efc37(legendModel.get('orient'), contentGroup, legendModel.get('itemGap'), maxSize.width, maxSize.height);
        var contentRect = contentGroup.getBoundingRect();
        var contentPos = [
            -contentRect.x,
            -contentRect.y
        ];
        selectorGroup.markRedraw();
        contentGroup.markRedraw();
        if (selector) {
            // Place buttons in selectorGroup
            $93b9bc7f22ac7369$export$827f4ee28efc37(// Buttons in selectorGroup always layout horizontally
            'horizontal', selectorGroup, legendModel.get('selectorItemGap', true));
            var selectorRect = selectorGroup.getBoundingRect();
            var selectorPos = [
                -selectorRect.x,
                -selectorRect.y
            ];
            var selectorButtonGap = legendModel.get('selectorButtonGap', true);
            var orientIdx = legendModel.getOrient().index;
            var wh = orientIdx === 0 ? 'width' : 'height';
            var hw = orientIdx === 0 ? 'height' : 'width';
            var yx = orientIdx === 0 ? 'y' : 'x';
            if (selectorPosition === 'end') selectorPos[orientIdx] += contentRect[wh] + selectorButtonGap;
            else contentPos[orientIdx] += selectorRect[wh] + selectorButtonGap;
            // Always align selector to content as 'middle'
            selectorPos[1 - orientIdx] += contentRect[hw] / 2 - selectorRect[hw] / 2;
            selectorGroup.x = selectorPos[0];
            selectorGroup.y = selectorPos[1];
            contentGroup.x = contentPos[0];
            contentGroup.y = contentPos[1];
            var mainRect = {
                x: 0,
                y: 0
            };
            mainRect[wh] = contentRect[wh] + selectorButtonGap + selectorRect[wh];
            mainRect[hw] = Math.max(contentRect[hw], selectorRect[hw]);
            mainRect[yx] = Math.min(0, selectorRect[yx] + selectorPos[1 - orientIdx]);
            return mainRect;
        } else {
            contentGroup.x = contentPos[0];
            contentGroup.y = contentPos[1];
            return this.group.getBoundingRect();
        }
    };
    /**
   * @protected
   */ LegendView.prototype.remove = function() {
        this.getContentGroup().removeAll();
        this._isFirstRender = true;
    };
    LegendView.type = 'legend.plain';
    return LegendView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
function $c2e212625ccc38b4$var$getLegendStyle(iconType, legendItemModel, lineVisualStyle, itemVisualStyle, drawType, isSelected, api) {
    /**
   * Use series style if is inherit;
   * elsewise, use legend style
   */ function handleCommonProps(style, visualStyle) {
        // If lineStyle.width is 'auto', it is set to be 2 if series has border
        if (style.lineWidth === 'auto') style.lineWidth = visualStyle.lineWidth > 0 ? 2 : 0;
        $c2e212625ccc38b4$var$each(style, function(propVal, propName) {
            style[propName] === 'inherit' && (style[propName] = visualStyle[propName]);
        });
    }
    // itemStyle
    var itemStyleModel = legendItemModel.getModel('itemStyle');
    var itemStyle = itemStyleModel.getItemStyle();
    var iconBrushType = iconType.lastIndexOf('empty', 0) === 0 ? 'fill' : 'stroke';
    var decalStyle = itemStyleModel.getShallow('decal');
    itemStyle.decal = !decalStyle || decalStyle === 'inherit' ? itemVisualStyle.decal : (0, $c6d646aacd243427$export$a3ba048e1a648972)(decalStyle, api);
    if (itemStyle.fill === 'inherit') /**
     * Series with visualDrawType as 'stroke' should have
     * series stroke as legend fill
     */ itemStyle.fill = itemVisualStyle[drawType];
    if (itemStyle.stroke === 'inherit') /**
     * icon type with "emptyXXX" should use fill color
     * in visual style
     */ itemStyle.stroke = itemVisualStyle[iconBrushType];
    if (itemStyle.opacity === 'inherit') /**
     * Use lineStyle.opacity if drawType is stroke
     */ itemStyle.opacity = (drawType === 'fill' ? itemVisualStyle : lineVisualStyle).opacity;
    handleCommonProps(itemStyle, itemVisualStyle);
    // lineStyle
    var legendLineModel = legendItemModel.getModel('lineStyle');
    var lineStyle = legendLineModel.getLineStyle();
    handleCommonProps(lineStyle, lineVisualStyle);
    // Fix auto color to real color
    itemStyle.fill === 'auto' && (itemStyle.fill = itemVisualStyle.fill);
    itemStyle.stroke === 'auto' && (itemStyle.stroke = itemVisualStyle.fill);
    lineStyle.stroke === 'auto' && (lineStyle.stroke = itemVisualStyle.fill);
    if (!isSelected) {
        var borderWidth = legendItemModel.get('inactiveBorderWidth');
        /**
     * Since stroke is set to be inactiveBorderColor, it may occur that
     * there is no border in series but border in legend, so we need to
     * use border only when series has border if is set to be auto
     */ var visualHasBorder = itemStyle[iconBrushType];
        itemStyle.lineWidth = borderWidth === 'auto' ? itemVisualStyle.lineWidth > 0 && visualHasBorder ? 2 : 0 : itemStyle.lineWidth;
        itemStyle.fill = legendItemModel.get('inactiveColor');
        itemStyle.stroke = legendItemModel.get('inactiveBorderColor');
        lineStyle.stroke = legendLineModel.get('inactiveColor');
        lineStyle.lineWidth = legendLineModel.get('inactiveWidth');
    }
    return {
        itemStyle: itemStyle,
        lineStyle: lineStyle
    };
}
function $c2e212625ccc38b4$var$getDefaultLegendIcon(opt) {
    var symboType = opt.icon || 'roundRect';
    var icon = (0, $5370466dadc978d7$export$af050e04da3a02e8)(symboType, 0, 0, opt.itemWidth, opt.itemHeight, opt.itemStyle.fill, opt.symbolKeepAspect);
    icon.setStyle(opt.itemStyle);
    icon.rotation = (opt.iconRotate || 0) * Math.PI / 180;
    icon.setOrigin([
        opt.itemWidth / 2,
        opt.itemHeight / 2
    ]);
    if (symboType.indexOf('empty') > -1) {
        icon.style.stroke = icon.style.fill;
        icon.style.fill = '#fff';
        icon.style.lineWidth = 2;
    }
    return icon;
}
function $c2e212625ccc38b4$var$dispatchSelectAction(seriesName, dataName, api, excludeSeriesId) {
    // downplay before unselect
    $c2e212625ccc38b4$var$dispatchDownplayAction(seriesName, dataName, api, excludeSeriesId);
    api.dispatchAction({
        type: 'legendToggleSelect',
        name: seriesName != null ? seriesName : dataName
    });
    // highlight after select
    // TODO highlight immediately may cause animation loss.
    $c2e212625ccc38b4$var$dispatchHighlightAction(seriesName, dataName, api, excludeSeriesId);
}
function $c2e212625ccc38b4$var$isUseHoverLayer(api) {
    var list = api.getZr().storage.getDisplayList();
    var emphasisState;
    var i = 0;
    var len = list.length;
    while(i < len && !(emphasisState = list[i].states.emphasis))i++;
    return emphasisState && emphasisState.hoverLayer;
}
function $c2e212625ccc38b4$var$dispatchHighlightAction(seriesName, dataName, api, excludeSeriesId) {
    // If element hover will move to a hoverLayer.
    if (!$c2e212625ccc38b4$var$isUseHoverLayer(api)) api.dispatchAction({
        type: 'highlight',
        seriesName: seriesName,
        name: dataName,
        excludeSeriesId: excludeSeriesId
    });
}
function $c2e212625ccc38b4$var$dispatchDownplayAction(seriesName, dataName, api, excludeSeriesId) {
    // If element hover will move to a hoverLayer.
    if (!$c2e212625ccc38b4$var$isUseHoverLayer(api)) api.dispatchAction({
        type: 'downplay',
        seriesName: seriesName,
        name: dataName,
        excludeSeriesId: excludeSeriesId
    });
}
var $c2e212625ccc38b4$export$2e2bcd8739ae039 = $c2e212625ccc38b4$var$LegendView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $c618818715ebe216$export$2e2bcd8739ae039(ecModel) {
    var legendModels = ecModel.findComponents({
        mainType: 'legend'
    });
    if (legendModels && legendModels.length) ecModel.filterSeries(function(series) {
        // If in any legend component the status is not selected.
        // Because in legend series is assumed selected when it is not in the legend data.
        for(var i = 0; i < legendModels.length; i++){
            if (!legendModels[i].isSelected(series.name)) return false;
        }
        return true;
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $19822663d90c963e$var$legendSelectActionHandler(methodName, payload, ecModel) {
    var isAllSelect = methodName === 'allSelect' || methodName === 'inverseSelect';
    var selectedMap = {};
    var actionLegendIndices = [];
    ecModel.eachComponent({
        mainType: 'legend',
        query: payload
    }, function(legendModel) {
        if (isAllSelect) legendModel[methodName]();
        else legendModel[methodName](payload.name);
        $19822663d90c963e$var$makeSelectedMap(legendModel, selectedMap);
        actionLegendIndices.push(legendModel.componentIndex);
    });
    var allSelectedMap = {};
    // make selectedMap from all legend components
    ecModel.eachComponent('legend', function(legendModel) {
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(selectedMap, function(isSelected, name) {
            // Force other legend has same selected status
            // Or the first is toggled to true and other are toggled to false
            // In the case one legend has some item unSelected in option. And if other legend
            // doesn't has the item, they will assume it is selected.
            legendModel[isSelected ? 'select' : 'unSelect'](name);
        });
        $19822663d90c963e$var$makeSelectedMap(legendModel, allSelectedMap);
    });
    // Return the event explicitly
    return isAllSelect ? {
        selected: allSelectedMap,
        // return legendIndex array to tell the developers which legends are allSelect / inverseSelect
        legendIndex: actionLegendIndices
    } : {
        name: payload.name,
        selected: allSelectedMap
    };
}
function $19822663d90c963e$var$makeSelectedMap(legendModel, out) {
    var selectedMap = out || {};
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(legendModel.getData(), function(model) {
        var name = model.get('name');
        // Wrap element
        if (name === '\n' || name === '') return;
        var isItemSelected = legendModel.isSelected(name);
        if ((0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(selectedMap, name)) // Unselected if any legend is unselected
        selectedMap[name] = selectedMap[name] && isItemSelected;
        else selectedMap[name] = isItemSelected;
    });
    return selectedMap;
}
function $19822663d90c963e$export$139982ea529c452f(registers) {
    /**
   * @event legendToggleSelect
   * @type {Object}
   * @property {string} type 'legendToggleSelect'
   * @property {string} [from]
   * @property {string} name Series name or data item name
   */ registers.registerAction('legendToggleSelect', 'legendselectchanged', (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($19822663d90c963e$var$legendSelectActionHandler, 'toggleSelected'));
    registers.registerAction('legendAllSelect', 'legendselectall', (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($19822663d90c963e$var$legendSelectActionHandler, 'allSelect'));
    registers.registerAction('legendInverseSelect', 'legendinverseselect', (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($19822663d90c963e$var$legendSelectActionHandler, 'inverseSelect'));
    /**
   * @event legendSelect
   * @type {Object}
   * @property {string} type 'legendSelect'
   * @property {string} name Series name or data item name
   */ registers.registerAction('legendSelect', 'legendselected', (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($19822663d90c963e$var$legendSelectActionHandler, 'select'));
    /**
   * @event legendUnSelect
   * @type {Object}
   * @property {string} type 'legendUnSelect'
   * @property {string} name Series name or data item name
   */ registers.registerAction('legendUnSelect', 'legendunselected', (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($19822663d90c963e$var$legendSelectActionHandler, 'unSelect'));
}


function $407c7fdad108ade5$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $0fbb1ae1b8df4cab$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $c2e212625ccc38b4$export$2e2bcd8739ae039));
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.SERIES_FILTER, (0, $c618818715ebe216$export$2e2bcd8739ae039));
    registers.registerSubTypeDefaulter('legend', function() {
        return 'plain';
    });
    (0, $19822663d90c963e$export$139982ea529c452f)(registers);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $a19f9768bdff02b5$var$ScrollableLegendModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ScrollableLegendModel, _super);
    function ScrollableLegendModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ScrollableLegendModel.type;
        return _this;
    }
    /**
   * @param {number} scrollDataIndex
   */ ScrollableLegendModel.prototype.setScrollDataIndex = function(scrollDataIndex) {
        this.option.scrollDataIndex = scrollDataIndex;
    };
    ScrollableLegendModel.prototype.init = function(option, parentModel, ecModel) {
        var inputPositionParams = (0, $93b9bc7f22ac7369$export$4b0d20af19c9875e)(option);
        _super.prototype.init.call(this, option, parentModel, ecModel);
        $a19f9768bdff02b5$var$mergeAndNormalizeLayoutParams(this, option, inputPositionParams);
    };
    /**
   * @override
   */ ScrollableLegendModel.prototype.mergeOption = function(option, ecModel) {
        _super.prototype.mergeOption.call(this, option, ecModel);
        $a19f9768bdff02b5$var$mergeAndNormalizeLayoutParams(this, this.option, option);
    };
    ScrollableLegendModel.type = 'legend.scroll';
    ScrollableLegendModel.defaultOption = (0, $5370df662b2caf37$export$68acc510e46fef2)((0, $0fbb1ae1b8df4cab$export$2e2bcd8739ae039).defaultOption, {
        scrollDataIndex: 0,
        pageButtonItemGap: 5,
        pageButtonGap: null,
        pageButtonPosition: 'end',
        pageFormatter: '{current}/{total}',
        pageIcons: {
            horizontal: [
                'M0,0L12,-10L12,10z',
                'M0,0L-12,-10L-12,10z'
            ],
            vertical: [
                'M0,0L20,0L10,-20z',
                'M0,0L20,0L10,20z'
            ]
        },
        pageIconColor: '#2f4554',
        pageIconInactiveColor: '#aaa',
        pageIconSize: 15,
        pageTextStyle: {
            color: '#333'
        },
        animationDurationUpdate: 800
    });
    return ScrollableLegendModel;
}((0, $0fbb1ae1b8df4cab$export$2e2bcd8739ae039));
// Do not `ignoreSize` to enable setting {left: 10, right: 10}.
function $a19f9768bdff02b5$var$mergeAndNormalizeLayoutParams(legendModel, target, raw) {
    var orient = legendModel.getOrient();
    var ignoreSize = [
        1,
        1
    ];
    ignoreSize[orient.index] = 0;
    (0, $93b9bc7f22ac7369$export$1754cb91f16ca028)(target, raw, {
        type: 'box',
        ignoreSize: !!ignoreSize
    });
}
var $a19f9768bdff02b5$export$2e2bcd8739ae039 = $a19f9768bdff02b5$var$ScrollableLegendModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $47ff4587191e73cd$var$Group = $7ef7583d8302ffce$export$2e2bcd8739ae039;
var $47ff4587191e73cd$var$WH = [
    'width',
    'height'
];
var $47ff4587191e73cd$var$XY = [
    'x',
    'y'
];
var $47ff4587191e73cd$var$ScrollableLegendView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ScrollableLegendView, _super);
    function ScrollableLegendView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ScrollableLegendView.type;
        _this.newlineDisabled = true;
        _this._currentIndex = 0;
        return _this;
    }
    ScrollableLegendView.prototype.init = function() {
        _super.prototype.init.call(this);
        this.group.add(this._containerGroup = new $47ff4587191e73cd$var$Group());
        this._containerGroup.add(this.getContentGroup());
        this.group.add(this._controllerGroup = new $47ff4587191e73cd$var$Group());
    };
    /**
   * @override
   */ ScrollableLegendView.prototype.resetInner = function() {
        _super.prototype.resetInner.call(this);
        this._controllerGroup.removeAll();
        this._containerGroup.removeClipPath();
        this._containerGroup.__rectSize = null;
    };
    /**
   * @override
   */ ScrollableLegendView.prototype.renderInner = function(itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition) {
        var self = this;
        // Render content items.
        _super.prototype.renderInner.call(this, itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition);
        var controllerGroup = this._controllerGroup;
        // FIXME: support be 'auto' adapt to size number text length,
        // e.g., '3/12345' should not overlap with the control arrow button.
        var pageIconSize = legendModel.get('pageIconSize', true);
        var pageIconSizeArr = $7a1bd9c2710fea0d$export$43bee75e5e14138e(pageIconSize) ? pageIconSize : [
            pageIconSize,
            pageIconSize
        ];
        createPageButton('pagePrev', 0);
        var pageTextStyleModel = legendModel.getModel('pageTextStyle');
        controllerGroup.add(new $fe885cc21795562b$export$2e2bcd8739ae039({
            name: 'pageText',
            style: {
                // Placeholder to calculate a proper layout.
                text: 'xx/xx',
                fill: pageTextStyleModel.getTextColor(),
                font: pageTextStyleModel.getFont(),
                verticalAlign: 'middle',
                align: 'center'
            },
            silent: true
        }));
        createPageButton('pageNext', 1);
        function createPageButton(name, iconIdx) {
            var pageDataIndexName = name + 'DataIndex';
            var icon = $5b455ae6f843ac47$export$274edc73af1ae9c8(legendModel.get('pageIcons', true)[legendModel.getOrient().name][iconIdx], {
                // Buttons will be created in each render, so we do not need
                // to worry about avoiding using legendModel kept in scope.
                onclick: $7a1bd9c2710fea0d$export$2385a24977818dd0(self._pageGo, self, pageDataIndexName, legendModel, api)
            }, {
                x: -pageIconSizeArr[0] / 2,
                y: -pageIconSizeArr[1] / 2,
                width: pageIconSizeArr[0],
                height: pageIconSizeArr[1]
            });
            icon.name = name;
            controllerGroup.add(icon);
        }
    };
    /**
   * @override
   */ ScrollableLegendView.prototype.layoutInner = function(legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition) {
        var selectorGroup = this.getSelectorGroup();
        var orientIdx = legendModel.getOrient().index;
        var wh = $47ff4587191e73cd$var$WH[orientIdx];
        var xy = $47ff4587191e73cd$var$XY[orientIdx];
        var hw = $47ff4587191e73cd$var$WH[1 - orientIdx];
        var yx = $47ff4587191e73cd$var$XY[1 - orientIdx];
        selector && $93b9bc7f22ac7369$export$827f4ee28efc37(// Buttons in selectorGroup always layout horizontally
        'horizontal', selectorGroup, legendModel.get('selectorItemGap', true));
        var selectorButtonGap = legendModel.get('selectorButtonGap', true);
        var selectorRect = selectorGroup.getBoundingRect();
        var selectorPos = [
            -selectorRect.x,
            -selectorRect.y
        ];
        var processMaxSize = $7a1bd9c2710fea0d$export$9cd59f9826255e47(maxSize);
        selector && (processMaxSize[wh] = maxSize[wh] - selectorRect[wh] - selectorButtonGap);
        var mainRect = this._layoutContentAndController(legendModel, isFirstRender, processMaxSize, orientIdx, wh, hw, yx, xy);
        if (selector) {
            if (selectorPosition === 'end') selectorPos[orientIdx] += mainRect[wh] + selectorButtonGap;
            else {
                var offset = selectorRect[wh] + selectorButtonGap;
                selectorPos[orientIdx] -= offset;
                mainRect[xy] -= offset;
            }
            mainRect[wh] += selectorRect[wh] + selectorButtonGap;
            selectorPos[1 - orientIdx] += mainRect[yx] + mainRect[hw] / 2 - selectorRect[hw] / 2;
            mainRect[hw] = Math.max(mainRect[hw], selectorRect[hw]);
            mainRect[yx] = Math.min(mainRect[yx], selectorRect[yx] + selectorPos[1 - orientIdx]);
            selectorGroup.x = selectorPos[0];
            selectorGroup.y = selectorPos[1];
            selectorGroup.markRedraw();
        }
        return mainRect;
    };
    ScrollableLegendView.prototype._layoutContentAndController = function(legendModel, isFirstRender, maxSize, orientIdx, wh, hw, yx, xy) {
        var contentGroup = this.getContentGroup();
        var containerGroup = this._containerGroup;
        var controllerGroup = this._controllerGroup;
        // Place items in contentGroup.
        $93b9bc7f22ac7369$export$827f4ee28efc37(legendModel.get('orient'), contentGroup, legendModel.get('itemGap'), !orientIdx ? null : maxSize.width, orientIdx ? null : maxSize.height);
        $93b9bc7f22ac7369$export$827f4ee28efc37(// Buttons in controller are layout always horizontally.
        'horizontal', controllerGroup, legendModel.get('pageButtonItemGap', true));
        var contentRect = contentGroup.getBoundingRect();
        var controllerRect = controllerGroup.getBoundingRect();
        var showController = this._showController = contentRect[wh] > maxSize[wh];
        // In case that the inner elements of contentGroup layout do not based on [0, 0]
        var contentPos = [
            -contentRect.x,
            -contentRect.y
        ];
        // Remain contentPos when scroll animation perfroming.
        // If first rendering, `contentGroup.position` is [0, 0], which
        // does not make sense and may cause unexepcted animation if adopted.
        if (!isFirstRender) contentPos[orientIdx] = contentGroup[xy];
        // Layout container group based on 0.
        var containerPos = [
            0,
            0
        ];
        var controllerPos = [
            -controllerRect.x,
            -controllerRect.y
        ];
        var pageButtonGap = $7a1bd9c2710fea0d$export$995e01f2f5c9d030(legendModel.get('pageButtonGap', true), legendModel.get('itemGap', true));
        // Place containerGroup and controllerGroup and contentGroup.
        if (showController) {
            var pageButtonPosition = legendModel.get('pageButtonPosition', true);
            // controller is on the right / bottom.
            if (pageButtonPosition === 'end') controllerPos[orientIdx] += maxSize[wh] - controllerRect[wh];
            else containerPos[orientIdx] += controllerRect[wh] + pageButtonGap;
        }
        // Always align controller to content as 'middle'.
        controllerPos[1 - orientIdx] += contentRect[hw] / 2 - controllerRect[hw] / 2;
        contentGroup.setPosition(contentPos);
        containerGroup.setPosition(containerPos);
        controllerGroup.setPosition(controllerPos);
        // Calculate `mainRect` and set `clipPath`.
        // mainRect should not be calculated by `this.group.getBoundingRect()`
        // for sake of the overflow.
        var mainRect = {
            x: 0,
            y: 0
        };
        // Consider content may be overflow (should be clipped).
        mainRect[wh] = showController ? maxSize[wh] : contentRect[wh];
        mainRect[hw] = Math.max(contentRect[hw], controllerRect[hw]);
        // `containerRect[yx] + containerPos[1 - orientIdx]` is 0.
        mainRect[yx] = Math.min(0, controllerRect[yx] + controllerPos[1 - orientIdx]);
        containerGroup.__rectSize = maxSize[wh];
        if (showController) {
            var clipShape = {
                x: 0,
                y: 0
            };
            clipShape[wh] = Math.max(maxSize[wh] - controllerRect[wh] - pageButtonGap, 0);
            clipShape[hw] = mainRect[hw];
            containerGroup.setClipPath(new $419e5ff2f303755e$export$2e2bcd8739ae039({
                shape: clipShape
            }));
            // Consider content may be larger than container, container rect
            // can not be obtained from `containerGroup.getBoundingRect()`.
            containerGroup.__rectSize = clipShape[wh];
        } else // Do not remove or ignore controller. Keep them set as placeholders.
        controllerGroup.eachChild(function(child) {
            child.attr({
                invisible: true,
                silent: true
            });
        });
        // Content translate animation.
        var pageInfo = this._getPageInfo(legendModel);
        pageInfo.pageIndex != null && $8b353638fbedfefa$export$c8dce3c08436e91e(contentGroup, {
            x: pageInfo.contentPosition[0],
            y: pageInfo.contentPosition[1]
        }, // When switch from "show controller" to "not show controller", view should be
        // updated immediately without animation, otherwise causes weird effect.
        showController ? legendModel : null);
        this._updatePageInfoView(legendModel, pageInfo);
        return mainRect;
    };
    ScrollableLegendView.prototype._pageGo = function(to, legendModel, api) {
        var scrollDataIndex = this._getPageInfo(legendModel)[to];
        scrollDataIndex != null && api.dispatchAction({
            type: 'legendScroll',
            scrollDataIndex: scrollDataIndex,
            legendId: legendModel.id
        });
    };
    ScrollableLegendView.prototype._updatePageInfoView = function(legendModel, pageInfo) {
        var controllerGroup = this._controllerGroup;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43([
            'pagePrev',
            'pageNext'
        ], function(name) {
            var key = name + 'DataIndex';
            var canJump = pageInfo[key] != null;
            var icon = controllerGroup.childOfName(name);
            if (icon) {
                icon.setStyle('fill', canJump ? legendModel.get('pageIconColor', true) : legendModel.get('pageIconInactiveColor', true));
                icon.cursor = canJump ? 'pointer' : 'default';
            }
        });
        var pageText = controllerGroup.childOfName('pageText');
        var pageFormatter = legendModel.get('pageFormatter');
        var pageIndex = pageInfo.pageIndex;
        var current = pageIndex != null ? pageIndex + 1 : 0;
        var total = pageInfo.pageCount;
        pageText && pageFormatter && pageText.setStyle('text', $7a1bd9c2710fea0d$export$844ec244b1367d54(pageFormatter) ? pageFormatter.replace('{current}', current == null ? '' : current + '').replace('{total}', total == null ? '' : total + '') : pageFormatter({
            current: current,
            total: total
        }));
    };
    /**
   *  contentPosition: Array.<number>, null when data item not found.
   *  pageIndex: number, null when data item not found.
   *  pageCount: number, always be a number, can be 0.
   *  pagePrevDataIndex: number, null when no previous page.
   *  pageNextDataIndex: number, null when no next page.
   * }
   */ ScrollableLegendView.prototype._getPageInfo = function(legendModel) {
        var scrollDataIndex = legendModel.get('scrollDataIndex', true);
        var contentGroup = this.getContentGroup();
        var containerRectSize = this._containerGroup.__rectSize;
        var orientIdx = legendModel.getOrient().index;
        var wh = $47ff4587191e73cd$var$WH[orientIdx];
        var xy = $47ff4587191e73cd$var$XY[orientIdx];
        var targetItemIndex = this._findTargetItemIndex(scrollDataIndex);
        var children = contentGroup.children();
        var targetItem = children[targetItemIndex];
        var itemCount = children.length;
        var pCount = !itemCount ? 0 : 1;
        var result = {
            contentPosition: [
                contentGroup.x,
                contentGroup.y
            ],
            pageCount: pCount,
            pageIndex: pCount - 1,
            pagePrevDataIndex: null,
            pageNextDataIndex: null
        };
        if (!targetItem) return result;
        var targetItemInfo = getItemInfo(targetItem);
        result.contentPosition[orientIdx] = -targetItemInfo.s;
        // Strategy:
        // (1) Always align based on the left/top most item.
        // (2) It is user-friendly that the last item shown in the
        // current window is shown at the begining of next window.
        // Otherwise if half of the last item is cut by the window,
        // it will have no chance to display entirely.
        // (3) Consider that item size probably be different, we
        // have calculate pageIndex by size rather than item index,
        // and we can not get page index directly by division.
        // (4) The window is to narrow to contain more than
        // one item, we should make sure that the page can be fliped.
        for(var i = targetItemIndex + 1, winStartItemInfo = targetItemInfo, winEndItemInfo = targetItemInfo, currItemInfo = null; i <= itemCount; ++i){
            currItemInfo = getItemInfo(children[i]);
            if (// Half of the last item is out of the window.
            !currItemInfo && winEndItemInfo.e > winStartItemInfo.s + containerRectSize || currItemInfo && !intersect(currItemInfo, winStartItemInfo.s)) {
                if (winEndItemInfo.i > winStartItemInfo.i) winStartItemInfo = winEndItemInfo;
                else // e.g., when page size is smaller than item size.
                winStartItemInfo = currItemInfo;
                if (winStartItemInfo) {
                    if (result.pageNextDataIndex == null) result.pageNextDataIndex = winStartItemInfo.i;
                    ++result.pageCount;
                }
            }
            winEndItemInfo = currItemInfo;
        }
        for(var i = targetItemIndex - 1, winStartItemInfo = targetItemInfo, winEndItemInfo = targetItemInfo, currItemInfo = null; i >= -1; --i){
            currItemInfo = getItemInfo(children[i]);
            if (// If the the end item does not intersect with the window started
            // from the current item, a page can be settled.
            (!currItemInfo || !intersect(winEndItemInfo, currItemInfo.s)) && winStartItemInfo.i < winEndItemInfo.i) {
                winEndItemInfo = winStartItemInfo;
                if (result.pagePrevDataIndex == null) result.pagePrevDataIndex = winStartItemInfo.i;
                ++result.pageCount;
                ++result.pageIndex;
            }
            winStartItemInfo = currItemInfo;
        }
        return result;
        function getItemInfo(el) {
            if (el) {
                var itemRect = el.getBoundingRect();
                var start = itemRect[xy] + el[xy];
                return {
                    s: start,
                    e: start + itemRect[wh],
                    i: el.__legendDataIndex
                };
            }
        }
        function intersect(itemInfo, winStart) {
            return itemInfo.e >= winStart && itemInfo.s <= winStart + containerRectSize;
        }
    };
    ScrollableLegendView.prototype._findTargetItemIndex = function(targetDataIndex) {
        if (!this._showController) return 0;
        var index;
        var contentGroup = this.getContentGroup();
        var defaultIndex;
        contentGroup.eachChild(function(child, idx) {
            var legendDataIdx = child.__legendDataIndex;
            // FIXME
            // If the given targetDataIndex (from model) is illegal,
            // we use defaultIndex. But the index on the legend model and
            // action payload is still illegal. That case will not be
            // changed until some scenario requires.
            if (defaultIndex == null && legendDataIdx != null) defaultIndex = idx;
            if (legendDataIdx === targetDataIndex) index = idx;
        });
        return index != null ? index : defaultIndex;
    };
    ScrollableLegendView.type = 'legend.scroll';
    return ScrollableLegendView;
}((0, $c2e212625ccc38b4$export$2e2bcd8739ae039));
var $47ff4587191e73cd$export$2e2bcd8739ae039 = $47ff4587191e73cd$var$ScrollableLegendView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $8ff9a37bcf939bdd$export$2e2bcd8739ae039(registers) {
    /**
   * @event legendScroll
   * @type {Object}
   * @property {string} type 'legendScroll'
   * @property {string} scrollDataIndex
   */ registers.registerAction('legendScroll', 'legendscroll', function(payload, ecModel) {
        var scrollDataIndex = payload.scrollDataIndex;
        scrollDataIndex != null && ecModel.eachComponent({
            mainType: 'legend',
            subType: 'scroll',
            query: payload
        }, function(legendModel) {
            legendModel.setScrollDataIndex(scrollDataIndex);
        });
    });
}


function $2861842f2dfd6682$export$4b3e715f166fdd78(registers) {
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $407c7fdad108ade5$export$4b3e715f166fdd78));
    registers.registerComponentModel((0, $a19f9768bdff02b5$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $47ff4587191e73cd$export$2e2bcd8739ae039));
    (0, $8ff9a37bcf939bdd$export$2e2bcd8739ae039)(registers);
}


function $1a0761510a437d9f$export$4b3e715f166fdd78(registers) {
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $407c7fdad108ade5$export$4b3e715f166fdd78));
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $2861842f2dfd6682$export$4b3e715f166fdd78));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $bab2c9b6be98f0ce$export$2e2bcd8739ae039(seriesOpts, markerType) {
    if (!seriesOpts) return false;
    var seriesOptArr = (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(seriesOpts) ? seriesOpts : [
        seriesOpts
    ];
    for(var idx = 0; idx < seriesOptArr.length; idx++){
        if (seriesOptArr[idx] && seriesOptArr[idx][markerType]) return true;
    }
    return false;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






function $1bab71219c0cd9a9$var$fillLabel(opt) {
    (0, $76d619f648247e6d$export$abdcc6a26372f94b)(opt, 'label', [
        'show'
    ]);
}
// { [componentType]: MarkerModel }
var $1bab71219c0cd9a9$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $1bab71219c0cd9a9$var$MarkerModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(MarkerModel, _super);
    function MarkerModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkerModel.type;
        /**
     * If marker model is created by self from series
     */ _this.createdBySelf = false;
        return _this;
    }
    /**
   * @overrite
   */ MarkerModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
        this._mergeOption(option, ecModel, false, true);
    };
    MarkerModel.prototype.isAnimationEnabled = function() {
        if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).node) return false;
        var hostSeries = this.__hostSeries;
        return this.getShallow('animation') && hostSeries && hostSeries.isAnimationEnabled();
    };
    /**
   * @overrite
   */ MarkerModel.prototype.mergeOption = function(newOpt, ecModel) {
        this._mergeOption(newOpt, ecModel, false, false);
    };
    MarkerModel.prototype._mergeOption = function(newOpt, ecModel, createdBySelf, isInit) {
        var componentType = this.mainType;
        if (!createdBySelf) ecModel.eachSeries(function(seriesModel) {
            // mainType can be markPoint, markLine, markArea
            var markerOpt = seriesModel.get(this.mainType, true);
            var markerModel = $1bab71219c0cd9a9$var$inner(seriesModel)[componentType];
            if (!markerOpt || !markerOpt.data) {
                $1bab71219c0cd9a9$var$inner(seriesModel)[componentType] = null;
                return;
            }
            if (!markerModel) {
                if (isInit) // Default label emphasis `position` and `show`
                $1bab71219c0cd9a9$var$fillLabel(markerOpt);
                $7a1bd9c2710fea0d$export$79b2f7037acddd43(markerOpt.data, function(item) {
                    // FIXME Overwrite fillLabel method ?
                    if (item instanceof Array) {
                        $1bab71219c0cd9a9$var$fillLabel(item[0]);
                        $1bab71219c0cd9a9$var$fillLabel(item[1]);
                    } else $1bab71219c0cd9a9$var$fillLabel(item);
                });
                markerModel = this.createMarkerModelFromSeries(markerOpt, this, ecModel);
                // markerModel = new ImplementedMarkerModel(
                //     markerOpt, this, ecModel
                // );
                $7a1bd9c2710fea0d$export$8b58be045bf06082(markerModel, {
                    mainType: this.mainType,
                    // Use the same series index and name
                    seriesIndex: seriesModel.seriesIndex,
                    name: seriesModel.name,
                    createdBySelf: true
                });
                markerModel.__hostSeries = seriesModel;
            } else markerModel._mergeOption(markerOpt, ecModel, true);
            $1bab71219c0cd9a9$var$inner(seriesModel)[componentType] = markerModel;
        }, this);
    };
    MarkerModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        var data = this.getData();
        var value = this.getRawValue(dataIndex);
        var itemName = data.getName(dataIndex);
        return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)('section', {
            header: this.name,
            blocks: [
                (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)('nameValue', {
                    name: itemName,
                    value: value,
                    noName: !itemName,
                    noValue: value == null
                })
            ]
        });
    };
    MarkerModel.prototype.getData = function() {
        return this._data;
    };
    MarkerModel.prototype.setData = function(data) {
        this._data = data;
    };
    MarkerModel.prototype.getDataParams = function(dataIndex, dataType) {
        var params = (0, $655dd6075cc63601$export$f23396ae04ea95a7).prototype.getDataParams.call(this, dataIndex, dataType);
        var hostSeries = this.__hostSeries;
        if (hostSeries) {
            params.seriesId = hostSeries.id;
            params.seriesName = hostSeries.name;
            params.seriesType = hostSeries.subType;
        }
        return params;
    };
    MarkerModel.getMarkerModelFromSeries = function(seriesModel, // Support three types of markers. Strict check.
    componentType) {
        return $1bab71219c0cd9a9$var$inner(seriesModel)[componentType];
    };
    MarkerModel.type = 'marker';
    MarkerModel.dependencies = [
        'series',
        'grid',
        'polar',
        'geo'
    ];
    return MarkerModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
$7a1bd9c2710fea0d$export$e36fc9d62a853069($1bab71219c0cd9a9$var$MarkerModel, (0, $655dd6075cc63601$export$f23396ae04ea95a7).prototype);
var $1bab71219c0cd9a9$export$2e2bcd8739ae039 = $1bab71219c0cd9a9$var$MarkerModel;


var $a4d9f6e367e83128$var$MarkAreaModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(MarkAreaModel, _super);
    function MarkAreaModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkAreaModel.type;
        return _this;
    }
    MarkAreaModel.prototype.createMarkerModelFromSeries = function(markerOpt, masterMarkerModel, ecModel) {
        return new MarkAreaModel(markerOpt, masterMarkerModel, ecModel);
    };
    MarkAreaModel.type = 'markArea';
    MarkAreaModel.defaultOption = {
        // zlevel: 0,
        // PENDING
        z: 1,
        tooltip: {
            trigger: 'item'
        },
        // markArea should fixed on the coordinate system
        animation: false,
        label: {
            show: true,
            position: 'top'
        },
        itemStyle: {
            // color and borderColor default to use color from series
            // color: 'auto'
            // borderColor: 'auto'
            borderWidth: 0
        },
        emphasis: {
            label: {
                show: true,
                position: 'top'
            }
        }
    };
    return MarkAreaModel;
}((0, $1bab71219c0cd9a9$export$2e2bcd8739ae039));
var $a4d9f6e367e83128$export$2e2bcd8739ae039 = $a4d9f6e367e83128$var$MarkAreaModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



function $e4ec0ddef831b3b2$var$hasXOrY(item) {
    return !(isNaN(parseFloat(item.x)) && isNaN(parseFloat(item.y)));
}
function $e4ec0ddef831b3b2$var$hasXAndY(item) {
    return !isNaN(parseFloat(item.x)) && !isNaN(parseFloat(item.y));
}
function $e4ec0ddef831b3b2$var$markerTypeCalculatorWithExtent(markerType, data, otherDataDim, targetDataDim, otherCoordIndex, targetCoordIndex) {
    var coordArr = [];
    var stacked = (0, $efdd976e4917927c$export$1dedc39359ae35c)(data, targetDataDim /* , otherDataDim */ );
    var calcDataDim = stacked ? data.getCalculationInfo('stackResultDimension') : targetDataDim;
    var value = $e4ec0ddef831b3b2$export$18ddefb55c03640b(data, calcDataDim, markerType);
    var dataIndex = data.indicesOfNearest(calcDataDim, value)[0];
    coordArr[otherCoordIndex] = data.get(otherDataDim, dataIndex);
    coordArr[targetCoordIndex] = data.get(calcDataDim, dataIndex);
    var coordArrValue = data.get(targetDataDim, dataIndex);
    // Make it simple, do not visit all stacked value to count precision.
    var precision = $cfc1f3b422a3185f$export$e0c74b50bbd10f68(data.get(targetDataDim, dataIndex));
    precision = Math.min(precision, 20);
    if (precision >= 0) coordArr[targetCoordIndex] = +coordArr[targetCoordIndex].toFixed(precision);
    return [
        coordArr,
        coordArrValue
    ];
}
// TODO Specified percent
var $e4ec0ddef831b3b2$var$markerTypeCalculator = {
    min: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($e4ec0ddef831b3b2$var$markerTypeCalculatorWithExtent, 'min'),
    max: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($e4ec0ddef831b3b2$var$markerTypeCalculatorWithExtent, 'max'),
    average: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($e4ec0ddef831b3b2$var$markerTypeCalculatorWithExtent, 'average'),
    median: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($e4ec0ddef831b3b2$var$markerTypeCalculatorWithExtent, 'median')
};
function $e4ec0ddef831b3b2$export$3eebd2d54b98c04f(seriesModel, item) {
    if (!item) return;
    var data = seriesModel.getData();
    var coordSys = seriesModel.coordinateSystem;
    var dims = coordSys && coordSys.dimensions;
    // 1. If not specify the position with pixel directly
    // 2. If `coord` is not a data array. Which uses `xAxis`,
    // `yAxis` to specify the coord on each dimension
    // parseFloat first because item.x and item.y can be percent string like '20%'
    if (!$e4ec0ddef831b3b2$var$hasXAndY(item) && !(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(item.coord) && (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(dims)) {
        var axisInfo = $e4ec0ddef831b3b2$export$bd39458db76002ab(item, data, coordSys, seriesModel);
        // Clone the option
        // Transform the properties xAxis, yAxis, radiusAxis, angleAxis, geoCoord to value
        item = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(item);
        if (item.type && $e4ec0ddef831b3b2$var$markerTypeCalculator[item.type] && axisInfo.baseAxis && axisInfo.valueAxis) {
            var otherCoordIndex = (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(dims, axisInfo.baseAxis.dim);
            var targetCoordIndex = (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(dims, axisInfo.valueAxis.dim);
            var coordInfo = $e4ec0ddef831b3b2$var$markerTypeCalculator[item.type](data, axisInfo.baseDataDim, axisInfo.valueDataDim, otherCoordIndex, targetCoordIndex);
            item.coord = coordInfo[0];
            // Force to use the value of calculated value.
            // let item use the value without stack.
            item.value = coordInfo[1];
        } else // FIXME Only has one of xAxis and yAxis.
        item.coord = [
            item.xAxis != null ? item.xAxis : item.radiusAxis,
            item.yAxis != null ? item.yAxis : item.angleAxis
        ];
    }
    // x y is provided
    if (item.coord == null || !(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(dims)) item.coord = [];
    else {
        // Each coord support max, min, average
        var coord = item.coord;
        for(var i = 0; i < 2; i++)if ($e4ec0ddef831b3b2$var$markerTypeCalculator[coord[i]]) coord[i] = $e4ec0ddef831b3b2$export$18ddefb55c03640b(data, data.mapDimension(dims[i]), coord[i]);
    }
    return item;
}
function $e4ec0ddef831b3b2$export$bd39458db76002ab(item, data, coordSys, seriesModel) {
    var ret = {};
    if (item.valueIndex != null || item.valueDim != null) {
        ret.valueDataDim = item.valueIndex != null ? data.getDimension(item.valueIndex) : item.valueDim;
        ret.valueAxis = coordSys.getAxis($e4ec0ddef831b3b2$var$dataDimToCoordDim(seriesModel, ret.valueDataDim));
        ret.baseAxis = coordSys.getOtherAxis(ret.valueAxis);
        ret.baseDataDim = data.mapDimension(ret.baseAxis.dim);
    } else {
        ret.baseAxis = seriesModel.getBaseAxis();
        ret.valueAxis = coordSys.getOtherAxis(ret.baseAxis);
        ret.baseDataDim = data.mapDimension(ret.baseAxis.dim);
        ret.valueDataDim = data.mapDimension(ret.valueAxis.dim);
    }
    return ret;
}
function $e4ec0ddef831b3b2$var$dataDimToCoordDim(seriesModel, dataDim) {
    var dimItem = seriesModel.getData().getDimensionInfo(dataDim);
    return dimItem && dimItem.coordDim;
}
function $e4ec0ddef831b3b2$export$179695f4a9040f73(// Currently only polar and cartesian has containData.
coordSys, item) {
    // Always return true if there is no coordSys
    return coordSys && coordSys.containData && item.coord && !$e4ec0ddef831b3b2$var$hasXOrY(item) ? coordSys.containData(item.coord) : true;
}
function $e4ec0ddef831b3b2$export$c869311b63462da6(// Currently only polar and cartesian has containData.
coordSys, item1, item2) {
    // Always return true if there is no coordSys
    return coordSys && coordSys.containZone && item1.coord && item2.coord && !$e4ec0ddef831b3b2$var$hasXOrY(item1) && !$e4ec0ddef831b3b2$var$hasXOrY(item2) ? coordSys.containZone(item1.coord, item2.coord) : true;
}
function $e4ec0ddef831b3b2$export$a53767c3c8f69cf7(inCoordSys, dims) {
    return inCoordSys ? function(item, dimName, dataIndex, dimIndex) {
        var rawVal = dimIndex < 2 ? item.coord && item.coord[dimIndex] : item.value;
        return (0, $40ab59f44b7d2db6$export$cc7175145baad076)(rawVal, dims[dimIndex]);
    } : function(item, dimName, dataIndex, dimIndex) {
        return (0, $40ab59f44b7d2db6$export$cc7175145baad076)(item.value, dims[dimIndex]);
    };
}
function $e4ec0ddef831b3b2$export$18ddefb55c03640b(data, valueDataDim, type) {
    if (type === 'average') {
        var sum_1 = 0;
        var count_1 = 0;
        data.each(valueDataDim, function(val, idx) {
            if (!isNaN(val)) {
                sum_1 += val;
                count_1++;
            }
        });
        return sum_1 / count_1;
    } else if (type === 'median') return data.getMedian(valueDataDim);
    else // max & min
    return data.getDataExtent(valueDataDim)[type === 'max' ? 1 : 0];
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $ed6cf827ec8a4c83$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $ed6cf827ec8a4c83$var$MarkerView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(MarkerView, _super);
    function MarkerView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkerView.type;
        return _this;
    }
    MarkerView.prototype.init = function() {
        this.markerGroupMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    };
    MarkerView.prototype.render = function(markerModel, ecModel, api) {
        var _this = this;
        var markerGroupMap = this.markerGroupMap;
        markerGroupMap.each(function(item) {
            $ed6cf827ec8a4c83$var$inner(item).keep = false;
        });
        ecModel.eachSeries(function(seriesModel) {
            var markerModel = (0, $1bab71219c0cd9a9$export$2e2bcd8739ae039).getMarkerModelFromSeries(seriesModel, _this.type);
            markerModel && _this.renderSeries(seriesModel, markerModel, ecModel, api);
        });
        markerGroupMap.each(function(item) {
            !$ed6cf827ec8a4c83$var$inner(item).keep && _this.group.remove(item.group);
        });
    };
    MarkerView.prototype.markKeep = function(drawGroup) {
        $ed6cf827ec8a4c83$var$inner(drawGroup).keep = true;
    };
    MarkerView.prototype.toggleBlurSeries = function(seriesModelList, isBlur) {
        var _this = this;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(seriesModelList, function(seriesModel) {
            var markerModel = (0, $1bab71219c0cd9a9$export$2e2bcd8739ae039).getMarkerModelFromSeries(seriesModel, _this.type);
            if (markerModel) {
                var data = markerModel.getData();
                data.eachItemGraphicEl(function(el) {
                    if (el) isBlur ? (0, $2bf82c0980125b62$export$207f9cb3e1099375)(el) : (0, $2bf82c0980125b62$export$fd4a9ec75456d3c1)(el);
                });
            }
        });
    };
    MarkerView.type = 'marker';
    return MarkerView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $ed6cf827ec8a4c83$export$2e2bcd8739ae039 = $ed6cf827ec8a4c83$var$MarkerView;










var $83ebccb52de64002$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $83ebccb52de64002$var$markAreaTransform = function(seriesModel, coordSys, maModel, item) {
    // item may be null
    var item0 = item[0];
    var item1 = item[1];
    if (!item0 || !item1) return;
    var lt = $e4ec0ddef831b3b2$export$3eebd2d54b98c04f(seriesModel, item0);
    var rb = $e4ec0ddef831b3b2$export$3eebd2d54b98c04f(seriesModel, item1);
    // FIXME make sure lt is less than rb
    var ltCoord = lt.coord;
    var rbCoord = rb.coord;
    ltCoord[0] = (0, $7a1bd9c2710fea0d$export$8a4d17b6e8486e66)(ltCoord[0], -Infinity);
    ltCoord[1] = (0, $7a1bd9c2710fea0d$export$8a4d17b6e8486e66)(ltCoord[1], -Infinity);
    rbCoord[0] = (0, $7a1bd9c2710fea0d$export$8a4d17b6e8486e66)(rbCoord[0], Infinity);
    rbCoord[1] = (0, $7a1bd9c2710fea0d$export$8a4d17b6e8486e66)(rbCoord[1], Infinity);
    // Merge option into one
    var result = (0, $7a1bd9c2710fea0d$export$18aef43295bbe906)([
        {},
        lt,
        rb
    ]);
    result.coord = [
        lt.coord,
        rb.coord
    ];
    result.x0 = lt.x;
    result.y0 = lt.y;
    result.x1 = rb.x;
    result.y1 = rb.y;
    return result;
};
function $83ebccb52de64002$var$isInfinity(val) {
    return !isNaN(val) && !isFinite(val);
}
// If a markArea has one dim
function $83ebccb52de64002$var$ifMarkAreaHasOnlyDim(dimIndex, fromCoord, toCoord, coordSys) {
    var otherDimIndex = 1 - dimIndex;
    return $83ebccb52de64002$var$isInfinity(fromCoord[otherDimIndex]) && $83ebccb52de64002$var$isInfinity(toCoord[otherDimIndex]);
}
function $83ebccb52de64002$var$markAreaFilter(coordSys, item) {
    var fromCoord = item.coord[0];
    var toCoord = item.coord[1];
    var item0 = {
        coord: fromCoord,
        x: item.x0,
        y: item.y0
    };
    var item1 = {
        coord: toCoord,
        x: item.x1,
        y: item.y1
    };
    if ((0, $3fea949f0512eb55$export$8567506e6336616)(coordSys, 'cartesian2d')) {
        // In case
        // {
        //  markArea: {
        //    data: [{ yAxis: 2 }]
        //  }
        // }
        if (fromCoord && toCoord && ($83ebccb52de64002$var$ifMarkAreaHasOnlyDim(1, fromCoord, toCoord, coordSys) || $83ebccb52de64002$var$ifMarkAreaHasOnlyDim(0, fromCoord, toCoord, coordSys))) return true;
        // Directly returning true may also do the work,
        // because markArea will not be shown automatically
        // when it's not included in coordinate system.
        // But filtering ahead can avoid keeping rendering markArea
        // when there are too many of them.
        return $e4ec0ddef831b3b2$export$c869311b63462da6(coordSys, item0, item1);
    }
    return $e4ec0ddef831b3b2$export$179695f4a9040f73(coordSys, item0) || $e4ec0ddef831b3b2$export$179695f4a9040f73(coordSys, item1);
}
// dims can be ['x0', 'y0'], ['x1', 'y1'], ['x0', 'y1'], ['x1', 'y0']
function $83ebccb52de64002$var$getSingleMarkerEndPoint(data, idx, dims, seriesModel, api) {
    var coordSys = seriesModel.coordinateSystem;
    var itemModel = data.getItemModel(idx);
    var point;
    var xPx = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(itemModel.get(dims[0]), api.getWidth());
    var yPx = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(itemModel.get(dims[1]), api.getHeight());
    if (!isNaN(xPx) && !isNaN(yPx)) point = [
        xPx,
        yPx
    ];
    else {
        // Chart like bar may have there own marker positioning logic
        if (seriesModel.getMarkerPosition) {
            // Consider the case that user input the right-bottom point first
            // Pick the larger x and y as 'x1' and 'y1'
            var pointValue0 = data.getValues([
                'x0',
                'y0'
            ], idx);
            var pointValue1 = data.getValues([
                'x1',
                'y1'
            ], idx);
            var clampPointValue0 = coordSys.clampData(pointValue0);
            var clampPointValue1 = coordSys.clampData(pointValue1);
            var pointValue = [];
            if (dims[0] === 'x0') pointValue[0] = clampPointValue0[0] > clampPointValue1[0] ? pointValue1[0] : pointValue0[0];
            else pointValue[0] = clampPointValue0[0] > clampPointValue1[0] ? pointValue0[0] : pointValue1[0];
            if (dims[1] === 'y0') pointValue[1] = clampPointValue0[1] > clampPointValue1[1] ? pointValue1[1] : pointValue0[1];
            else pointValue[1] = clampPointValue0[1] > clampPointValue1[1] ? pointValue0[1] : pointValue1[1];
            // Use the getMarkerPosition
            point = seriesModel.getMarkerPosition(pointValue, dims, true);
        } else {
            var x = data.get(dims[0], idx);
            var y = data.get(dims[1], idx);
            var pt = [
                x,
                y
            ];
            coordSys.clampData && coordSys.clampData(pt, pt);
            point = coordSys.dataToPoint(pt, true);
        }
        if ((0, $3fea949f0512eb55$export$8567506e6336616)(coordSys, 'cartesian2d')) {
            // TODO: TYPE ts@4.1 may still infer it as Axis instead of Axis2D. Not sure if it's a bug
            var xAxis = coordSys.getAxis('x');
            var yAxis = coordSys.getAxis('y');
            var x = data.get(dims[0], idx);
            var y = data.get(dims[1], idx);
            if ($83ebccb52de64002$var$isInfinity(x)) point[0] = xAxis.toGlobalCoord(xAxis.getExtent()[dims[0] === 'x0' ? 0 : 1]);
            else if ($83ebccb52de64002$var$isInfinity(y)) point[1] = yAxis.toGlobalCoord(yAxis.getExtent()[dims[1] === 'y0' ? 0 : 1]);
        }
        // Use x, y if has any
        if (!isNaN(xPx)) point[0] = xPx;
        if (!isNaN(yPx)) point[1] = yPx;
    }
    return point;
}
var $83ebccb52de64002$export$fc5a505a325de211 = [
    [
        'x0',
        'y0'
    ],
    [
        'x1',
        'y0'
    ],
    [
        'x1',
        'y1'
    ],
    [
        'x0',
        'y1'
    ]
];
var $83ebccb52de64002$var$MarkAreaView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(MarkAreaView, _super);
    function MarkAreaView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkAreaView.type;
        return _this;
    }
    MarkAreaView.prototype.updateTransform = function(markAreaModel, ecModel, api) {
        ecModel.eachSeries(function(seriesModel) {
            var maModel = (0, $1bab71219c0cd9a9$export$2e2bcd8739ae039).getMarkerModelFromSeries(seriesModel, 'markArea');
            if (maModel) {
                var areaData_1 = maModel.getData();
                areaData_1.each(function(idx) {
                    var points = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)($83ebccb52de64002$export$fc5a505a325de211, function(dim) {
                        return $83ebccb52de64002$var$getSingleMarkerEndPoint(areaData_1, idx, dim, seriesModel, api);
                    });
                    // Layout
                    areaData_1.setItemLayout(idx, points);
                    var el = areaData_1.getItemGraphicEl(idx);
                    el.setShape('points', points);
                });
            }
        }, this);
    };
    MarkAreaView.prototype.renderSeries = function(seriesModel, maModel, ecModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        var seriesId = seriesModel.id;
        var seriesData = seriesModel.getData();
        var areaGroupMap = this.markerGroupMap;
        var polygonGroup = areaGroupMap.get(seriesId) || areaGroupMap.set(seriesId, {
            group: new $7ef7583d8302ffce$export$2e2bcd8739ae039()
        });
        this.group.add(polygonGroup.group);
        this.markKeep(polygonGroup);
        var areaData = $83ebccb52de64002$var$createList(coordSys, seriesModel, maModel);
        // Line data for tooltip and formatter
        maModel.setData(areaData);
        // Update visual and layout of line
        areaData.each(function(idx) {
            // Layout
            var points = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)($83ebccb52de64002$export$fc5a505a325de211, function(dim) {
                return $83ebccb52de64002$var$getSingleMarkerEndPoint(areaData, idx, dim, seriesModel, api);
            });
            var xAxisScale = coordSys.getAxis('x').scale;
            var yAxisScale = coordSys.getAxis('y').scale;
            var xAxisExtent = xAxisScale.getExtent();
            var yAxisExtent = yAxisScale.getExtent();
            var xPointExtent = [
                xAxisScale.parse(areaData.get('x0', idx)),
                xAxisScale.parse(areaData.get('x1', idx))
            ];
            var yPointExtent = [
                yAxisScale.parse(areaData.get('y0', idx)),
                yAxisScale.parse(areaData.get('y1', idx))
            ];
            $cfc1f3b422a3185f$export$debe6e778e0a6d32(xPointExtent);
            $cfc1f3b422a3185f$export$debe6e778e0a6d32(yPointExtent);
            var overlapped = !(xAxisExtent[0] > xPointExtent[1] || xAxisExtent[1] < xPointExtent[0] || yAxisExtent[0] > yPointExtent[1] || yAxisExtent[1] < yPointExtent[0]);
            // If none of the area is inside coordSys, allClipped is set to be true
            // in layout so that label will not be displayed. See #12591
            var allClipped = !overlapped;
            areaData.setItemLayout(idx, {
                points: points,
                allClipped: allClipped
            });
            var style = areaData.getItemModel(idx).getModel('itemStyle').getItemStyle();
            var color = (0, $ea13f1ab2169d82d$export$d76e333a86ea1a2)(seriesData, 'color');
            if (!style.fill) {
                style.fill = color;
                if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(style.fill)) style.fill = $2c037f5bda6341ca$export$ab4754bf42583a26(style.fill, 0.4);
            }
            if (!style.stroke) style.stroke = color;
            // Visual
            areaData.setItemVisual(idx, 'style', style);
        });
        areaData.diff($83ebccb52de64002$var$inner(polygonGroup).data).add(function(idx) {
            var layout = areaData.getItemLayout(idx);
            if (!layout.allClipped) {
                var polygon = new $51acf033123e1a30$export$2e2bcd8739ae039({
                    shape: {
                        points: layout.points
                    }
                });
                areaData.setItemGraphicEl(idx, polygon);
                polygonGroup.group.add(polygon);
            }
        }).update(function(newIdx, oldIdx) {
            var polygon = $83ebccb52de64002$var$inner(polygonGroup).data.getItemGraphicEl(oldIdx);
            var layout = areaData.getItemLayout(newIdx);
            if (!layout.allClipped) {
                if (polygon) $8b353638fbedfefa$export$c8dce3c08436e91e(polygon, {
                    shape: {
                        points: layout.points
                    }
                }, maModel, newIdx);
                else polygon = new $51acf033123e1a30$export$2e2bcd8739ae039({
                    shape: {
                        points: layout.points
                    }
                });
                areaData.setItemGraphicEl(newIdx, polygon);
                polygonGroup.group.add(polygon);
            } else if (polygon) polygonGroup.group.remove(polygon);
        }).remove(function(idx) {
            var polygon = $83ebccb52de64002$var$inner(polygonGroup).data.getItemGraphicEl(idx);
            polygonGroup.group.remove(polygon);
        }).execute();
        areaData.eachItemGraphicEl(function(polygon, idx) {
            var itemModel = areaData.getItemModel(idx);
            var style = areaData.getItemVisual(idx, 'style');
            polygon.useStyle(areaData.getItemVisual(idx, 'style'));
            (0, $6800dfcb6e1e2a44$export$9a13992917966657)(polygon, (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(itemModel), {
                labelFetcher: maModel,
                labelDataIndex: idx,
                defaultText: areaData.getName(idx) || '',
                inheritColor: (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(style.fill) ? $2c037f5bda6341ca$export$ab4754bf42583a26(style.fill, 1) : '#000'
            });
            (0, $2bf82c0980125b62$export$48b68047d330bbc9)(polygon, itemModel);
            (0, $2bf82c0980125b62$export$e51187539ff11209)(polygon, null, null, itemModel.get([
                'emphasis',
                'disabled'
            ]));
            (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(polygon).dataModel = maModel;
        });
        $83ebccb52de64002$var$inner(polygonGroup).data = areaData;
        polygonGroup.group.silent = maModel.get('silent') || seriesModel.get('silent');
    };
    MarkAreaView.type = 'markArea';
    return MarkAreaView;
}((0, $ed6cf827ec8a4c83$export$2e2bcd8739ae039));
function $83ebccb52de64002$var$createList(coordSys, seriesModel, maModel) {
    var areaData;
    var dataDims;
    var dims = [
        'x0',
        'y0',
        'x1',
        'y1'
    ];
    if (coordSys) {
        var coordDimsInfos_1 = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(coordSys && coordSys.dimensions, function(coordDim) {
            var data = seriesModel.getData();
            var info = data.getDimensionInfo(data.mapDimension(coordDim)) || {};
            // In map series data don't have lng and lat dimension. Fallback to same with coordSys
            return (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, info), {
                name: coordDim,
                // DON'T use ordinalMeta to parse and collect ordinal.
                ordinalMeta: null
            });
        });
        dataDims = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(dims, function(dim, idx) {
            return {
                name: dim,
                type: coordDimsInfos_1[idx % 2].type
            };
        });
        areaData = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)(dataDims, maModel);
    } else {
        dataDims = [
            {
                name: 'value',
                type: 'float'
            }
        ];
        areaData = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)(dataDims, maModel);
    }
    var optData = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(maModel.get('data'), (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($83ebccb52de64002$var$markAreaTransform, seriesModel, coordSys, maModel));
    if (coordSys) optData = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(optData, (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($83ebccb52de64002$var$markAreaFilter, coordSys));
    var dimValueGetter = coordSys ? function(item, dimName, dataIndex, dimIndex) {
        // TODO should convert to ParsedValue?
        var rawVal = item.coord[Math.floor(dimIndex / 2)][dimIndex % 2];
        return (0, $40ab59f44b7d2db6$export$cc7175145baad076)(rawVal, dataDims[dimIndex]);
    } : function(item, dimName, dataIndex, dimIndex) {
        return (0, $40ab59f44b7d2db6$export$cc7175145baad076)(item.value, dataDims[dimIndex]);
    };
    areaData.initData(optData, null, dimValueGetter);
    areaData.hasItemOption = true;
    return areaData;
}
var $83ebccb52de64002$export$2e2bcd8739ae039 = $83ebccb52de64002$var$MarkAreaView;


function $8a8e80722bf1c081$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $a4d9f6e367e83128$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $83ebccb52de64002$export$2e2bcd8739ae039));
    registers.registerPreprocessor(function(opt) {
        if ((0, $bab2c9b6be98f0ce$export$2e2bcd8739ae039)(opt.series, 'markArea')) // Make sure markArea component is enabled
        opt.markArea = opt.markArea || {};
    });
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $ed1b4c8534a4bb68$var$MarkLineModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(MarkLineModel, _super);
    function MarkLineModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkLineModel.type;
        return _this;
    }
    MarkLineModel.prototype.createMarkerModelFromSeries = function(markerOpt, masterMarkerModel, ecModel) {
        return new MarkLineModel(markerOpt, masterMarkerModel, ecModel);
    };
    MarkLineModel.type = 'markLine';
    MarkLineModel.defaultOption = {
        // zlevel: 0,
        z: 5,
        symbol: [
            'circle',
            'arrow'
        ],
        symbolSize: [
            8,
            16
        ],
        // symbolRotate: 0,
        symbolOffset: 0,
        precision: 2,
        tooltip: {
            trigger: 'item'
        },
        label: {
            show: true,
            position: 'end',
            distance: 5
        },
        lineStyle: {
            type: 'dashed'
        },
        emphasis: {
            label: {
                show: true
            },
            lineStyle: {
                width: 3
            }
        },
        animationEasing: 'linear'
    };
    return MarkLineModel;
}((0, $1bab71219c0cd9a9$export$2e2bcd8739ae039));
var $ed1b4c8534a4bb68$export$2e2bcd8739ae039 = $ed1b4c8534a4bb68$var$MarkLineModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 












var $87a9be5fb3657486$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $87a9be5fb3657486$var$markLineTransform = function(seriesModel, coordSys, mlModel, item) {
    var data = seriesModel.getData();
    var itemArray;
    if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(item)) {
        // Special type markLine like 'min', 'max', 'average', 'median'
        var mlType = item.type;
        if (mlType === 'min' || mlType === 'max' || mlType === 'average' || mlType === 'median' || item.xAxis != null || item.yAxis != null) {
            var valueAxis = void 0;
            var value = void 0;
            if (item.yAxis != null || item.xAxis != null) {
                valueAxis = coordSys.getAxis(item.yAxis != null ? 'y' : 'x');
                value = (0, $7a1bd9c2710fea0d$export$8a4d17b6e8486e66)(item.yAxis, item.xAxis);
            } else {
                var axisInfo = $e4ec0ddef831b3b2$export$bd39458db76002ab(item, data, coordSys, seriesModel);
                valueAxis = axisInfo.valueAxis;
                var valueDataDim = (0, $efdd976e4917927c$export$909db2be4938fbdf)(data, axisInfo.valueDataDim);
                value = $e4ec0ddef831b3b2$export$18ddefb55c03640b(data, valueDataDim, mlType);
            }
            var valueIndex = valueAxis.dim === 'x' ? 0 : 1;
            var baseIndex = 1 - valueIndex;
            // Normized to 2d data with start and end point
            var mlFrom = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(item);
            var mlTo = {
                coord: []
            };
            mlFrom.type = null;
            mlFrom.coord = [];
            mlFrom.coord[baseIndex] = -Infinity;
            mlTo.coord[baseIndex] = Infinity;
            var precision = mlModel.get('precision');
            if (precision >= 0 && (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(value)) value = +value.toFixed(Math.min(precision, 20));
            mlFrom.coord[valueIndex] = mlTo.coord[valueIndex] = value;
            itemArray = [
                mlFrom,
                mlTo,
                {
                    type: mlType,
                    valueIndex: item.valueIndex,
                    // Force to use the value of calculated value.
                    value: value
                }
            ];
        } else itemArray = [];
    } else itemArray = item;
    var normalizedItem = [
        $e4ec0ddef831b3b2$export$3eebd2d54b98c04f(seriesModel, itemArray[0]),
        $e4ec0ddef831b3b2$export$3eebd2d54b98c04f(seriesModel, itemArray[1]),
        (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, itemArray[2])
    ];
    // Avoid line data type is extended by from(to) data type
    normalizedItem[2].type = normalizedItem[2].type || null;
    // Merge from option and to option into line option
    (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)(normalizedItem[2], normalizedItem[0]);
    (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)(normalizedItem[2], normalizedItem[1]);
    return normalizedItem;
};
function $87a9be5fb3657486$var$isInfinity(val) {
    return !isNaN(val) && !isFinite(val);
}
// If a markLine has one dim
function $87a9be5fb3657486$var$ifMarkLineHasOnlyDim(dimIndex, fromCoord, toCoord, coordSys) {
    var otherDimIndex = 1 - dimIndex;
    var dimName = coordSys.dimensions[dimIndex];
    return $87a9be5fb3657486$var$isInfinity(fromCoord[otherDimIndex]) && $87a9be5fb3657486$var$isInfinity(toCoord[otherDimIndex]) && fromCoord[dimIndex] === toCoord[dimIndex] && coordSys.getAxis(dimName).containData(fromCoord[dimIndex]);
}
function $87a9be5fb3657486$var$markLineFilter(coordSys, item) {
    if (coordSys.type === 'cartesian2d') {
        var fromCoord = item[0].coord;
        var toCoord = item[1].coord;
        // In case
        // {
        //  markLine: {
        //    data: [{ yAxis: 2 }]
        //  }
        // }
        if (fromCoord && toCoord && ($87a9be5fb3657486$var$ifMarkLineHasOnlyDim(1, fromCoord, toCoord, coordSys) || $87a9be5fb3657486$var$ifMarkLineHasOnlyDim(0, fromCoord, toCoord, coordSys))) return true;
    }
    return $e4ec0ddef831b3b2$export$179695f4a9040f73(coordSys, item[0]) && $e4ec0ddef831b3b2$export$179695f4a9040f73(coordSys, item[1]);
}
function $87a9be5fb3657486$var$updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api) {
    var coordSys = seriesModel.coordinateSystem;
    var itemModel = data.getItemModel(idx);
    var point;
    var xPx = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(itemModel.get('x'), api.getWidth());
    var yPx = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(itemModel.get('y'), api.getHeight());
    if (!isNaN(xPx) && !isNaN(yPx)) point = [
        xPx,
        yPx
    ];
    else {
        // Chart like bar may have there own marker positioning logic
        if (seriesModel.getMarkerPosition) // Use the getMarkerPosition
        point = seriesModel.getMarkerPosition(data.getValues(data.dimensions, idx));
        else {
            var dims = coordSys.dimensions;
            var x = data.get(dims[0], idx);
            var y = data.get(dims[1], idx);
            point = coordSys.dataToPoint([
                x,
                y
            ]);
        }
        // Expand line to the edge of grid if value on one axis is Inifnity
        // In case
        //  markLine: {
        //    data: [{
        //      yAxis: 2
        //      // or
        //      type: 'average'
        //    }]
        //  }
        if ((0, $3fea949f0512eb55$export$8567506e6336616)(coordSys, 'cartesian2d')) {
            // TODO: TYPE ts@4.1 may still infer it as Axis instead of Axis2D. Not sure if it's a bug
            var xAxis = coordSys.getAxis('x');
            var yAxis = coordSys.getAxis('y');
            var dims = coordSys.dimensions;
            if ($87a9be5fb3657486$var$isInfinity(data.get(dims[0], idx))) point[0] = xAxis.toGlobalCoord(xAxis.getExtent()[isFrom ? 0 : 1]);
            else if ($87a9be5fb3657486$var$isInfinity(data.get(dims[1], idx))) point[1] = yAxis.toGlobalCoord(yAxis.getExtent()[isFrom ? 0 : 1]);
        }
        // Use x, y if has any
        if (!isNaN(xPx)) point[0] = xPx;
        if (!isNaN(yPx)) point[1] = yPx;
    }
    data.setItemLayout(idx, point);
}
var $87a9be5fb3657486$var$MarkLineView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(MarkLineView, _super);
    function MarkLineView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkLineView.type;
        return _this;
    }
    MarkLineView.prototype.updateTransform = function(markLineModel, ecModel, api) {
        ecModel.eachSeries(function(seriesModel) {
            var mlModel = (0, $1bab71219c0cd9a9$export$2e2bcd8739ae039).getMarkerModelFromSeries(seriesModel, 'markLine');
            if (mlModel) {
                var mlData_1 = mlModel.getData();
                var fromData_1 = $87a9be5fb3657486$var$inner(mlModel).from;
                var toData_1 = $87a9be5fb3657486$var$inner(mlModel).to;
                // Update visual and layout of from symbol and to symbol
                fromData_1.each(function(idx) {
                    $87a9be5fb3657486$var$updateSingleMarkerEndLayout(fromData_1, idx, true, seriesModel, api);
                    $87a9be5fb3657486$var$updateSingleMarkerEndLayout(toData_1, idx, false, seriesModel, api);
                });
                // Update layout of line
                mlData_1.each(function(idx) {
                    mlData_1.setItemLayout(idx, [
                        fromData_1.getItemLayout(idx),
                        toData_1.getItemLayout(idx)
                    ]);
                });
                this.markerGroupMap.get(seriesModel.id).updateLayout();
            }
        }, this);
    };
    MarkLineView.prototype.renderSeries = function(seriesModel, mlModel, ecModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        var seriesId = seriesModel.id;
        var seriesData = seriesModel.getData();
        var lineDrawMap = this.markerGroupMap;
        var lineDraw = lineDrawMap.get(seriesId) || lineDrawMap.set(seriesId, new (0, $a2fd63a0fc11274a$export$2e2bcd8739ae039)());
        this.group.add(lineDraw.group);
        var mlData = $87a9be5fb3657486$var$createList(coordSys, seriesModel, mlModel);
        var fromData = mlData.from;
        var toData = mlData.to;
        var lineData = mlData.line;
        $87a9be5fb3657486$var$inner(mlModel).from = fromData;
        $87a9be5fb3657486$var$inner(mlModel).to = toData;
        // Line data for tooltip and formatter
        mlModel.setData(lineData);
        // TODO
        // Functionally, `symbolSize` & `symbolOffset` can also be 2D array now.
        // But the related logic and type definition are not finished yet.
        // Finish it if required
        var symbolType = mlModel.get('symbol');
        var symbolSize = mlModel.get('symbolSize');
        var symbolRotate = mlModel.get('symbolRotate');
        var symbolOffset = mlModel.get('symbolOffset');
        // TODO: support callback function like markPoint
        if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(symbolType)) symbolType = [
            symbolType,
            symbolType
        ];
        if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(symbolSize)) symbolSize = [
            symbolSize,
            symbolSize
        ];
        if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(symbolRotate)) symbolRotate = [
            symbolRotate,
            symbolRotate
        ];
        if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(symbolOffset)) symbolOffset = [
            symbolOffset,
            symbolOffset
        ];
        // Update visual and layout of from symbol and to symbol
        mlData.from.each(function(idx) {
            updateDataVisualAndLayout(fromData, idx, true);
            updateDataVisualAndLayout(toData, idx, false);
        });
        // Update visual and layout of line
        lineData.each(function(idx) {
            var lineStyle = lineData.getItemModel(idx).getModel('lineStyle').getLineStyle();
            // lineData.setItemVisual(idx, {
            //     color: lineColor || fromData.getItemVisual(idx, 'color')
            // });
            lineData.setItemLayout(idx, [
                fromData.getItemLayout(idx),
                toData.getItemLayout(idx)
            ]);
            if (lineStyle.stroke == null) lineStyle.stroke = fromData.getItemVisual(idx, 'style').fill;
            lineData.setItemVisual(idx, {
                fromSymbolKeepAspect: fromData.getItemVisual(idx, 'symbolKeepAspect'),
                fromSymbolOffset: fromData.getItemVisual(idx, 'symbolOffset'),
                fromSymbolRotate: fromData.getItemVisual(idx, 'symbolRotate'),
                fromSymbolSize: fromData.getItemVisual(idx, 'symbolSize'),
                fromSymbol: fromData.getItemVisual(idx, 'symbol'),
                toSymbolKeepAspect: toData.getItemVisual(idx, 'symbolKeepAspect'),
                toSymbolOffset: toData.getItemVisual(idx, 'symbolOffset'),
                toSymbolRotate: toData.getItemVisual(idx, 'symbolRotate'),
                toSymbolSize: toData.getItemVisual(idx, 'symbolSize'),
                toSymbol: toData.getItemVisual(idx, 'symbol'),
                style: lineStyle
            });
        });
        lineDraw.updateData(lineData);
        // Set host model for tooltip
        // FIXME
        mlData.line.eachItemGraphicEl(function(el) {
            (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).dataModel = mlModel;
            el.traverse(function(child) {
                (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(child).dataModel = mlModel;
            });
        });
        function updateDataVisualAndLayout(data, idx, isFrom) {
            var itemModel = data.getItemModel(idx);
            $87a9be5fb3657486$var$updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api);
            var style = itemModel.getModel('itemStyle').getItemStyle();
            if (style.fill == null) style.fill = (0, $ea13f1ab2169d82d$export$d76e333a86ea1a2)(seriesData, 'color');
            data.setItemVisual(idx, {
                symbolKeepAspect: itemModel.get('symbolKeepAspect'),
                // `0` should be considered as a valid value, so use `retrieve2` instead of `||`
                symbolOffset: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(itemModel.get('symbolOffset', true), symbolOffset[isFrom ? 0 : 1]),
                symbolRotate: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(itemModel.get('symbolRotate', true), symbolRotate[isFrom ? 0 : 1]),
                // TODO: when 2d array is supported, it should ignore parent
                symbolSize: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(itemModel.get('symbolSize'), symbolSize[isFrom ? 0 : 1]),
                symbol: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(itemModel.get('symbol', true), symbolType[isFrom ? 0 : 1]),
                style: style
            });
        }
        this.markKeep(lineDraw);
        lineDraw.group.silent = mlModel.get('silent') || seriesModel.get('silent');
    };
    MarkLineView.type = 'markLine';
    return MarkLineView;
}((0, $ed6cf827ec8a4c83$export$2e2bcd8739ae039));
function $87a9be5fb3657486$var$createList(coordSys, seriesModel, mlModel) {
    var coordDimsInfos;
    if (coordSys) coordDimsInfos = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(coordSys && coordSys.dimensions, function(coordDim) {
        var info = seriesModel.getData().getDimensionInfo(seriesModel.getData().mapDimension(coordDim)) || {};
        // In map series data don't have lng and lat dimension. Fallback to same with coordSys
        return (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, info), {
            name: coordDim,
            // DON'T use ordinalMeta to parse and collect ordinal.
            ordinalMeta: null
        });
    });
    else coordDimsInfos = [
        {
            name: 'value',
            type: 'float'
        }
    ];
    var fromData = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)(coordDimsInfos, mlModel);
    var toData = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)(coordDimsInfos, mlModel);
    // No dimensions
    var lineData = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)([], mlModel);
    var optData = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(mlModel.get('data'), (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($87a9be5fb3657486$var$markLineTransform, seriesModel, coordSys, mlModel));
    if (coordSys) optData = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(optData, (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($87a9be5fb3657486$var$markLineFilter, coordSys));
    var dimValueGetter = $e4ec0ddef831b3b2$export$a53767c3c8f69cf7(!!coordSys, coordDimsInfos);
    fromData.initData((0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(optData, function(item) {
        return item[0];
    }), null, dimValueGetter);
    toData.initData((0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(optData, function(item) {
        return item[1];
    }), null, dimValueGetter);
    lineData.initData((0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(optData, function(item) {
        return item[2];
    }));
    lineData.hasItemOption = true;
    return {
        from: fromData,
        to: toData,
        line: lineData
    };
}
var $87a9be5fb3657486$export$2e2bcd8739ae039 = $87a9be5fb3657486$var$MarkLineView;


function $0fc27d0a088604ed$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $ed1b4c8534a4bb68$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $87a9be5fb3657486$export$2e2bcd8739ae039));
    registers.registerPreprocessor(function(opt) {
        if ((0, $bab2c9b6be98f0ce$export$2e2bcd8739ae039)(opt.series, 'markLine')) // Make sure markLine component is enabled
        opt.markLine = opt.markLine || {};
    });
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $2a559db54433a753$var$MarkPointModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(MarkPointModel, _super);
    function MarkPointModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkPointModel.type;
        return _this;
    }
    MarkPointModel.prototype.createMarkerModelFromSeries = function(markerOpt, masterMarkerModel, ecModel) {
        return new MarkPointModel(markerOpt, masterMarkerModel, ecModel);
    };
    MarkPointModel.type = 'markPoint';
    MarkPointModel.defaultOption = {
        // zlevel: 0,
        z: 5,
        symbol: 'pin',
        symbolSize: 50,
        // symbolRotate: 0,
        // symbolOffset: [0, 0]
        tooltip: {
            trigger: 'item'
        },
        label: {
            show: true,
            position: 'inside'
        },
        itemStyle: {
            borderWidth: 2
        },
        emphasis: {
            label: {
                show: true
            }
        }
    };
    return MarkPointModel;
}((0, $1bab71219c0cd9a9$export$2e2bcd8739ae039));
var $2a559db54433a753$export$2e2bcd8739ae039 = $2a559db54433a753$var$MarkPointModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 









function $80c0cdc6385c1c58$var$updateMarkerLayout(mpData, seriesModel, api) {
    var coordSys = seriesModel.coordinateSystem;
    mpData.each(function(idx) {
        var itemModel = mpData.getItemModel(idx);
        var point;
        var xPx = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(itemModel.get('x'), api.getWidth());
        var yPx = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(itemModel.get('y'), api.getHeight());
        if (!isNaN(xPx) && !isNaN(yPx)) point = [
            xPx,
            yPx
        ];
        else if (seriesModel.getMarkerPosition) // Use the getMarkerPosition
        point = seriesModel.getMarkerPosition(mpData.getValues(mpData.dimensions, idx));
        else if (coordSys) {
            var x = mpData.get(coordSys.dimensions[0], idx);
            var y = mpData.get(coordSys.dimensions[1], idx);
            point = coordSys.dataToPoint([
                x,
                y
            ]);
        }
        // Use x, y if has any
        if (!isNaN(xPx)) point[0] = xPx;
        if (!isNaN(yPx)) point[1] = yPx;
        mpData.setItemLayout(idx, point);
    });
}
var $80c0cdc6385c1c58$var$MarkPointView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(MarkPointView, _super);
    function MarkPointView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkPointView.type;
        return _this;
    }
    MarkPointView.prototype.updateTransform = function(markPointModel, ecModel, api) {
        ecModel.eachSeries(function(seriesModel) {
            var mpModel = (0, $1bab71219c0cd9a9$export$2e2bcd8739ae039).getMarkerModelFromSeries(seriesModel, 'markPoint');
            if (mpModel) {
                $80c0cdc6385c1c58$var$updateMarkerLayout(mpModel.getData(), seriesModel, api);
                this.markerGroupMap.get(seriesModel.id).updateLayout();
            }
        }, this);
    };
    MarkPointView.prototype.renderSeries = function(seriesModel, mpModel, ecModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        var seriesId = seriesModel.id;
        var seriesData = seriesModel.getData();
        var symbolDrawMap = this.markerGroupMap;
        var symbolDraw = symbolDrawMap.get(seriesId) || symbolDrawMap.set(seriesId, new (0, $fedf62268297fcbb$export$2e2bcd8739ae039)());
        var mpData = $80c0cdc6385c1c58$var$createData(coordSys, seriesModel, mpModel);
        // FIXME
        mpModel.setData(mpData);
        $80c0cdc6385c1c58$var$updateMarkerLayout(mpModel.getData(), seriesModel, api);
        mpData.each(function(idx) {
            var itemModel = mpData.getItemModel(idx);
            var symbol = itemModel.getShallow('symbol');
            var symbolSize = itemModel.getShallow('symbolSize');
            var symbolRotate = itemModel.getShallow('symbolRotate');
            var symbolOffset = itemModel.getShallow('symbolOffset');
            var symbolKeepAspect = itemModel.getShallow('symbolKeepAspect');
            // TODO: refactor needed: single data item should not support callback function
            if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(symbol) || (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(symbolSize) || (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(symbolRotate) || (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(symbolOffset)) {
                var rawIdx = mpModel.getRawValue(idx);
                var dataParams = mpModel.getDataParams(idx);
                if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(symbol)) symbol = symbol(rawIdx, dataParams);
                if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(symbolSize)) // FIXME 这里不兼容 ECharts 2.x，2.x 貌似参数是整个数据？
                symbolSize = symbolSize(rawIdx, dataParams);
                if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(symbolRotate)) symbolRotate = symbolRotate(rawIdx, dataParams);
                if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(symbolOffset)) symbolOffset = symbolOffset(rawIdx, dataParams);
            }
            var style = itemModel.getModel('itemStyle').getItemStyle();
            var color = (0, $ea13f1ab2169d82d$export$d76e333a86ea1a2)(seriesData, 'color');
            if (!style.fill) style.fill = color;
            mpData.setItemVisual(idx, {
                symbol: symbol,
                symbolSize: symbolSize,
                symbolRotate: symbolRotate,
                symbolOffset: symbolOffset,
                symbolKeepAspect: symbolKeepAspect,
                style: style
            });
        });
        // TODO Text are wrong
        symbolDraw.updateData(mpData);
        this.group.add(symbolDraw.group);
        // Set host model for tooltip
        // FIXME
        mpData.eachItemGraphicEl(function(el) {
            el.traverse(function(child) {
                (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(child).dataModel = mpModel;
            });
        });
        this.markKeep(symbolDraw);
        symbolDraw.group.silent = mpModel.get('silent') || seriesModel.get('silent');
    };
    MarkPointView.type = 'markPoint';
    return MarkPointView;
}((0, $ed6cf827ec8a4c83$export$2e2bcd8739ae039));
function $80c0cdc6385c1c58$var$createData(coordSys, seriesModel, mpModel) {
    var coordDimsInfos;
    if (coordSys) coordDimsInfos = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(coordSys && coordSys.dimensions, function(coordDim) {
        var info = seriesModel.getData().getDimensionInfo(seriesModel.getData().mapDimension(coordDim)) || {};
        // In map series data don't have lng and lat dimension. Fallback to same with coordSys
        return (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, info), {
            name: coordDim,
            // DON'T use ordinalMeta to parse and collect ordinal.
            ordinalMeta: null
        });
    });
    else coordDimsInfos = [
        {
            name: 'value',
            type: 'float'
        }
    ];
    var mpData = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)(coordDimsInfos, mpModel);
    var dataOpt = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(mpModel.get('data'), (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($e4ec0ddef831b3b2$export$3eebd2d54b98c04f, seriesModel));
    if (coordSys) dataOpt = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(dataOpt, (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($e4ec0ddef831b3b2$export$179695f4a9040f73, coordSys));
    var dimValueGetter = $e4ec0ddef831b3b2$export$a53767c3c8f69cf7(!!coordSys, coordDimsInfos);
    mpData.initData(dataOpt, null, dimValueGetter);
    return mpData;
}
var $80c0cdc6385c1c58$export$2e2bcd8739ae039 = $80c0cdc6385c1c58$var$MarkPointView;


function $4edaa7c972a7e0d1$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $2a559db54433a753$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $80c0cdc6385c1c58$export$2e2bcd8739ae039));
    registers.registerPreprocessor(function(opt) {
        if ((0, $bab2c9b6be98f0ce$export$2e2bcd8739ae039)(opt.series, 'markPoint')) // Make sure markPoint component is enabled
        opt.markPoint = opt.markPoint || {};
    });
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $692a4df2164e3c50$var$PolarAxisPointer = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(PolarAxisPointer, _super);
    function PolarAxisPointer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
   * @override
   */ PolarAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {
        var axis = axisModel.axis;
        if (axis.dim === 'angle') this.animationThreshold = Math.PI / 18;
        var polar = axis.polar;
        var otherAxis = polar.getOtherAxis(axis);
        var otherExtent = otherAxis.getExtent();
        var coordValue = axis.dataToCoord(value);
        var axisPointerType = axisPointerModel.get('type');
        if (axisPointerType && axisPointerType !== 'none') {
            var elStyle = $51dec70890757374$export$b7fe459c7cc50060(axisPointerModel);
            var pointerOption = $692a4df2164e3c50$var$pointerShapeBuilder[axisPointerType](axis, polar, coordValue, otherExtent);
            pointerOption.style = elStyle;
            elOption.graphicKey = pointerOption.type;
            elOption.pointer = pointerOption;
        }
        var labelMargin = axisPointerModel.get([
            'label',
            'margin'
        ]);
        var labelPos = $692a4df2164e3c50$var$getLabelPosition(value, axisModel, axisPointerModel, polar, labelMargin);
        $51dec70890757374$export$8206a9937c45910f(elOption, axisModel, axisPointerModel, api, labelPos);
    };
    return PolarAxisPointer;
}((0, $a331d7a6c631e6d9$export$2e2bcd8739ae039));
function $692a4df2164e3c50$var$getLabelPosition(value, axisModel, axisPointerModel, polar, labelMargin) {
    var axis = axisModel.axis;
    var coord = axis.dataToCoord(value);
    var axisAngle = polar.getAngleAxis().getExtent()[0];
    axisAngle = axisAngle / 180 * Math.PI;
    var radiusExtent = polar.getRadiusAxis().getExtent();
    var position;
    var align;
    var verticalAlign;
    if (axis.dim === 'radius') {
        var transform = $f41ebb9dd60b55b4$export$185802fd694ee1f5();
        $f41ebb9dd60b55b4$export$bb628a54ab399bc9(transform, transform, axisAngle);
        $f41ebb9dd60b55b4$export$d73ee8ef04f5226a(transform, transform, [
            polar.cx,
            polar.cy
        ]);
        position = $5b455ae6f843ac47$export$9f9dcb98c894b623([
            coord,
            -labelMargin
        ], transform);
        var labelRotation = axisModel.getModel('axisLabel').get('rotate') || 0;
        // @ts-ignore
        var labelLayout = (0, $dfe15f745e1c3c2b$export$2e2bcd8739ae039).innerTextLayout(axisAngle, labelRotation * Math.PI / 180, -1);
        align = labelLayout.textAlign;
        verticalAlign = labelLayout.textVerticalAlign;
    } else {
        // angle axis
        var r = radiusExtent[1];
        position = polar.coordToPoint([
            r + labelMargin,
            coord
        ]);
        var cx = polar.cx;
        var cy = polar.cy;
        align = Math.abs(position[0] - cx) / r < 0.3 ? 'center' : position[0] > cx ? 'left' : 'right';
        verticalAlign = Math.abs(position[1] - cy) / r < 0.3 ? 'middle' : position[1] > cy ? 'top' : 'bottom';
    }
    return {
        position: position,
        align: align,
        verticalAlign: verticalAlign
    };
}
var $692a4df2164e3c50$var$pointerShapeBuilder = {
    line: function(axis, polar, coordValue, otherExtent) {
        return axis.dim === 'angle' ? {
            type: 'Line',
            shape: $51dec70890757374$export$885fa0ad5a826207(polar.coordToPoint([
                otherExtent[0],
                coordValue
            ]), polar.coordToPoint([
                otherExtent[1],
                coordValue
            ]))
        } : {
            type: 'Circle',
            shape: {
                cx: polar.cx,
                cy: polar.cy,
                r: coordValue
            }
        };
    },
    shadow: function(axis, polar, coordValue, otherExtent) {
        var bandWidth = Math.max(1, axis.getBandWidth());
        var radian = Math.PI / 180;
        return axis.dim === 'angle' ? {
            type: 'Sector',
            shape: $51dec70890757374$export$b0cf82e7ebc0d7d0(polar.cx, polar.cy, otherExtent[0], otherExtent[1], // In ECharts y is negative if angle is positive
            (-coordValue - bandWidth / 2) * radian, (-coordValue + bandWidth / 2) * radian)
        } : {
            type: 'Sector',
            shape: $51dec70890757374$export$b0cf82e7ebc0d7d0(polar.cx, polar.cy, coordValue - bandWidth / 2, coordValue + bandWidth / 2, 0, Math.PI * 2)
        };
    }
};
var $692a4df2164e3c50$export$2e2bcd8739ae039 = $692a4df2164e3c50$var$PolarAxisPointer;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $657132d924424c20$var$PolarModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(PolarModel, _super);
    function PolarModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = PolarModel.type;
        return _this;
    }
    PolarModel.prototype.findAxisModel = function(axisType) {
        var foundAxisModel;
        var ecModel = this.ecModel;
        ecModel.eachComponent(axisType, function(axisModel) {
            if (axisModel.getCoordSysModel() === this) foundAxisModel = axisModel;
        }, this);
        return foundAxisModel;
    };
    PolarModel.type = 'polar';
    PolarModel.dependencies = [
        'radiusAxis',
        'angleAxis'
    ];
    PolarModel.defaultOption = {
        // zlevel: 0,
        z: 0,
        center: [
            '50%',
            '50%'
        ],
        radius: '80%'
    };
    return PolarModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $657132d924424c20$export$2e2bcd8739ae039 = $657132d924424c20$var$PolarModel;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $d885303d9d4b2eee$export$ae9b190f9f84c66f = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(PolarAxisModel, _super);
    function PolarAxisModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PolarAxisModel.prototype.getCoordSysModel = function() {
        return this.getReferringComponents('polar', (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
    };
    PolarAxisModel.type = 'polarAxis';
    return PolarAxisModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
$7a1bd9c2710fea0d$export$e36fc9d62a853069($d885303d9d4b2eee$export$ae9b190f9f84c66f, (0, $3449fd4c0590d99e$export$5c54b224726edb5a));
var $d885303d9d4b2eee$export$34735c2c701428ca = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(AngleAxisModel, _super);
    function AngleAxisModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AngleAxisModel.type;
        return _this;
    }
    AngleAxisModel.type = 'angleAxis';
    return AngleAxisModel;
}($d885303d9d4b2eee$export$ae9b190f9f84c66f);
var $d885303d9d4b2eee$export$de202388c212a23b = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(RadiusAxisModel, _super);
    function RadiusAxisModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = RadiusAxisModel.type;
        return _this;
    }
    RadiusAxisModel.type = 'radiusAxis';
    return RadiusAxisModel;
}($d885303d9d4b2eee$export$ae9b190f9f84c66f);


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // TODO Axis scale

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $bf08c49320f1faba$var$RadiusAxis = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(RadiusAxis, _super);
    function RadiusAxis(scale, radiusExtent) {
        return _super.call(this, 'radius', scale, radiusExtent) || this;
    }
    RadiusAxis.prototype.pointToData = function(point, clamp) {
        return this.polar.pointToData(point, clamp)[this.dim === 'radius' ? 0 : 1];
    };
    return RadiusAxis;
}((0, $c2b1efffe5ae3f42$export$2e2bcd8739ae039));
$bf08c49320f1faba$var$RadiusAxis.prototype.dataToRadius = (0, $c2b1efffe5ae3f42$export$2e2bcd8739ae039).prototype.dataToCoord;
$bf08c49320f1faba$var$RadiusAxis.prototype.radiusToData = (0, $c2b1efffe5ae3f42$export$2e2bcd8739ae039).prototype.coordToData;
var $bf08c49320f1faba$export$2e2bcd8739ae039 = $bf08c49320f1faba$var$RadiusAxis;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $4a9e505d5dd42027$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $4a9e505d5dd42027$var$AngleAxis = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(AngleAxis, _super);
    function AngleAxis(scale, angleExtent) {
        return _super.call(this, 'angle', scale, angleExtent || [
            0,
            360
        ]) || this;
    }
    AngleAxis.prototype.pointToData = function(point, clamp) {
        return this.polar.pointToData(point, clamp)[this.dim === 'radius' ? 0 : 1];
    };
    /**
   * Only be called in category axis.
   * Angle axis uses text height to decide interval
   *
   * @override
   * @return {number} Auto interval for cateogry axis tick and label
   */ AngleAxis.prototype.calculateCategoryInterval = function() {
        var axis = this;
        var labelModel = axis.getLabelModel();
        var ordinalScale = axis.scale;
        var ordinalExtent = ordinalScale.getExtent();
        // Providing this method is for optimization:
        // avoid generating a long array by `getTicks`
        // in large category data case.
        var tickCount = ordinalScale.count();
        if (ordinalExtent[1] - ordinalExtent[0] < 1) return 0;
        var tickValue = ordinalExtent[0];
        var unitSpan = axis.dataToCoord(tickValue + 1) - axis.dataToCoord(tickValue);
        var unitH = Math.abs(unitSpan);
        // Not precise, just use height as text width
        // and each distance from axis line yet.
        var rect = $6c308355c7107803$export$c381147bfed79d9f(tickValue == null ? '' : tickValue + '', labelModel.getFont(), 'center', 'top');
        var maxH = Math.max(rect.height, 7);
        var dh = maxH / unitH;
        // 0/0 is NaN, 1/0 is Infinity.
        isNaN(dh) && (dh = Infinity);
        var interval = Math.max(0, Math.floor(dh));
        var cache = $4a9e505d5dd42027$var$inner(axis.model);
        var lastAutoInterval = cache.lastAutoInterval;
        var lastTickCount = cache.lastTickCount;
        // Use cache to keep interval stable while moving zoom window,
        // otherwise the calculated interval might jitter when the zoom
        // window size is close to the interval-changing size.
        if (lastAutoInterval != null && lastTickCount != null && Math.abs(lastAutoInterval - interval) <= 1 && Math.abs(lastTickCount - tickCount) <= 1 && lastAutoInterval > interval) interval = lastAutoInterval;
        else {
            cache.lastTickCount = tickCount;
            cache.lastAutoInterval = interval;
        }
        return interval;
    };
    return AngleAxis;
}((0, $c2b1efffe5ae3f42$export$2e2bcd8739ae039));
$4a9e505d5dd42027$var$AngleAxis.prototype.dataToAngle = (0, $c2b1efffe5ae3f42$export$2e2bcd8739ae039).prototype.dataToCoord;
$4a9e505d5dd42027$var$AngleAxis.prototype.angleToData = (0, $c2b1efffe5ae3f42$export$2e2bcd8739ae039).prototype.coordToData;
var $4a9e505d5dd42027$export$2e2bcd8739ae039 = $4a9e505d5dd42027$var$AngleAxis;


var $bbec1db3de81c4bf$export$f6d9521c10640456 = [
    'radius',
    'angle'
];
var $bbec1db3de81c4bf$var$Polar = /** @class */ function() {
    function Polar(name) {
        this.dimensions = $bbec1db3de81c4bf$export$f6d9521c10640456;
        this.type = 'polar';
        /**
     * x of polar center
     */ this.cx = 0;
        /**
     * y of polar center
     */ this.cy = 0;
        this._radiusAxis = new (0, $bf08c49320f1faba$export$2e2bcd8739ae039)();
        this._angleAxis = new (0, $4a9e505d5dd42027$export$2e2bcd8739ae039)();
        this.axisPointerEnabled = true;
        this.name = name || '';
        this._radiusAxis.polar = this._angleAxis.polar = this;
    }
    /**
   * If contain coord
   */ Polar.prototype.containPoint = function(point) {
        var coord = this.pointToCoord(point);
        return this._radiusAxis.contain(coord[0]) && this._angleAxis.contain(coord[1]);
    };
    /**
   * If contain data
   */ Polar.prototype.containData = function(data) {
        return this._radiusAxis.containData(data[0]) && this._angleAxis.containData(data[1]);
    };
    Polar.prototype.getAxis = function(dim) {
        var key = '_' + dim + 'Axis';
        return this[key];
    };
    Polar.prototype.getAxes = function() {
        return [
            this._radiusAxis,
            this._angleAxis
        ];
    };
    /**
   * Get axes by type of scale
   */ Polar.prototype.getAxesByScale = function(scaleType) {
        var axes = [];
        var angleAxis = this._angleAxis;
        var radiusAxis = this._radiusAxis;
        angleAxis.scale.type === scaleType && axes.push(angleAxis);
        radiusAxis.scale.type === scaleType && axes.push(radiusAxis);
        return axes;
    };
    Polar.prototype.getAngleAxis = function() {
        return this._angleAxis;
    };
    Polar.prototype.getRadiusAxis = function() {
        return this._radiusAxis;
    };
    Polar.prototype.getOtherAxis = function(axis) {
        var angleAxis = this._angleAxis;
        return axis === angleAxis ? this._radiusAxis : angleAxis;
    };
    /**
   * Base axis will be used on stacking.
   *
   */ Polar.prototype.getBaseAxis = function() {
        return this.getAxesByScale('ordinal')[0] || this.getAxesByScale('time')[0] || this.getAngleAxis();
    };
    Polar.prototype.getTooltipAxes = function(dim) {
        var baseAxis = dim != null && dim !== 'auto' ? this.getAxis(dim) : this.getBaseAxis();
        return {
            baseAxes: [
                baseAxis
            ],
            otherAxes: [
                this.getOtherAxis(baseAxis)
            ]
        };
    };
    /**
   * Convert a single data item to (x, y) point.
   * Parameter data is an array which the first element is radius and the second is angle
   */ Polar.prototype.dataToPoint = function(data, clamp) {
        return this.coordToPoint([
            this._radiusAxis.dataToRadius(data[0], clamp),
            this._angleAxis.dataToAngle(data[1], clamp)
        ]);
    };
    /**
   * Convert a (x, y) point to data
   */ Polar.prototype.pointToData = function(point, clamp) {
        var coord = this.pointToCoord(point);
        return [
            this._radiusAxis.radiusToData(coord[0], clamp),
            this._angleAxis.angleToData(coord[1], clamp)
        ];
    };
    /**
   * Convert a (x, y) point to (radius, angle) coord
   */ Polar.prototype.pointToCoord = function(point) {
        var dx = point[0] - this.cx;
        var dy = point[1] - this.cy;
        var angleAxis = this.getAngleAxis();
        var extent = angleAxis.getExtent();
        var minAngle = Math.min(extent[0], extent[1]);
        var maxAngle = Math.max(extent[0], extent[1]);
        // Fix fixed extent in polarCreator
        // FIXME
        angleAxis.inverse ? minAngle = maxAngle - 360 : maxAngle = minAngle + 360;
        var radius = Math.sqrt(dx * dx + dy * dy);
        dx /= radius;
        dy /= radius;
        var radian = Math.atan2(-dy, dx) / Math.PI * 180;
        // move to angleExtent
        var dir = radian < minAngle ? 1 : -1;
        while(radian < minAngle || radian > maxAngle)radian += dir * 360;
        return [
            radius,
            radian
        ];
    };
    /**
   * Convert a (radius, angle) coord to (x, y) point
   */ Polar.prototype.coordToPoint = function(coord) {
        var radius = coord[0];
        var radian = coord[1] / 180 * Math.PI;
        var x = Math.cos(radian) * radius + this.cx;
        // Inverse the y
        var y = -Math.sin(radian) * radius + this.cy;
        return [
            x,
            y
        ];
    };
    /**
   * Get ring area of cartesian.
   * Area will have a contain function to determine if a point is in the coordinate system.
   */ Polar.prototype.getArea = function() {
        var angleAxis = this.getAngleAxis();
        var radiusAxis = this.getRadiusAxis();
        var radiusExtent = radiusAxis.getExtent().slice();
        radiusExtent[0] > radiusExtent[1] && radiusExtent.reverse();
        var angleExtent = angleAxis.getExtent();
        var RADIAN = Math.PI / 180;
        var EPSILON = 1e-4;
        return {
            cx: this.cx,
            cy: this.cy,
            r0: radiusExtent[0],
            r: radiusExtent[1],
            startAngle: -angleExtent[0] * RADIAN,
            endAngle: -angleExtent[1] * RADIAN,
            clockwise: angleAxis.inverse,
            contain: function(x, y) {
                // It's a ring shape.
                // Start angle and end angle don't matter
                var dx = x - this.cx;
                var dy = y - this.cy;
                var d2 = dx * dx + dy * dy;
                var r = this.r;
                var r0 = this.r0;
                // minus a tiny value 1e-4 in double side to avoid being clipped unexpectedly
                // r == r0 contain nothing
                return r !== r0 && d2 - EPSILON <= r * r && d2 + EPSILON >= r0 * r0;
            }
        };
    };
    Polar.prototype.convertToPixel = function(ecModel, finder, value) {
        var coordSys = $bbec1db3de81c4bf$var$getCoordSys(finder);
        return coordSys === this ? this.dataToPoint(value) : null;
    };
    Polar.prototype.convertFromPixel = function(ecModel, finder, pixel) {
        var coordSys = $bbec1db3de81c4bf$var$getCoordSys(finder);
        return coordSys === this ? this.pointToData(pixel) : null;
    };
    return Polar;
}();
function $bbec1db3de81c4bf$var$getCoordSys(finder) {
    var seriesModel = finder.seriesModel;
    var polarModel = finder.polarModel;
    return polarModel && polarModel.coordinateSystem || seriesModel && seriesModel.coordinateSystem;
}
var $bbec1db3de81c4bf$export$2e2bcd8739ae039 = $bbec1db3de81c4bf$var$Polar;





/**
 * Resize method bound to the polar
 */ function $45211ba328a63245$var$resizePolar(polar, polarModel, api) {
    var center = polarModel.get('center');
    var width = api.getWidth();
    var height = api.getHeight();
    polar.cx = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(center[0], width);
    polar.cy = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(center[1], height);
    var radiusAxis = polar.getRadiusAxis();
    var size = Math.min(width, height) / 2;
    var radius = polarModel.get('radius');
    if (radius == null) radius = [
        0,
        '100%'
    ];
    else if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(radius)) // r0 = 0
    radius = [
        0,
        radius
    ];
    var parsedRadius = [
        (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(radius[0], size),
        (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(radius[1], size)
    ];
    radiusAxis.inverse ? radiusAxis.setExtent(parsedRadius[1], parsedRadius[0]) : radiusAxis.setExtent(parsedRadius[0], parsedRadius[1]);
}
/**
 * Update polar
 */ function $45211ba328a63245$var$updatePolarScale(ecModel, api) {
    var polar = this;
    var angleAxis = polar.getAngleAxis();
    var radiusAxis = polar.getRadiusAxis();
    // Reset scale
    angleAxis.scale.setExtent(Infinity, -Infinity);
    radiusAxis.scale.setExtent(Infinity, -Infinity);
    ecModel.eachSeries(function(seriesModel) {
        if (seriesModel.coordinateSystem === polar) {
            var data_1 = seriesModel.getData();
            $7a1bd9c2710fea0d$export$79b2f7037acddd43((0, $2d646e51cc34f840$export$e4cf30b1e74cd69d)(data_1, 'radius'), function(dim) {
                radiusAxis.scale.unionExtentFromData(data_1, dim);
            });
            $7a1bd9c2710fea0d$export$79b2f7037acddd43((0, $2d646e51cc34f840$export$e4cf30b1e74cd69d)(data_1, 'angle'), function(dim) {
                angleAxis.scale.unionExtentFromData(data_1, dim);
            });
        }
    });
    (0, $2d646e51cc34f840$export$51f3e70a54405d5a)(angleAxis.scale, angleAxis.model);
    (0, $2d646e51cc34f840$export$51f3e70a54405d5a)(radiusAxis.scale, radiusAxis.model);
    // Fix extent of category angle axis
    if (angleAxis.type === 'category' && !angleAxis.onBand) {
        var extent = angleAxis.getExtent();
        var diff = 360 / angleAxis.scale.count();
        angleAxis.inverse ? extent[1] += diff : extent[1] -= diff;
        angleAxis.setExtent(extent[0], extent[1]);
    }
}
function $45211ba328a63245$var$isAngleAxisModel(axisModel) {
    return axisModel.mainType === 'angleAxis';
}
/**
 * Set common axis properties
 */ function $45211ba328a63245$var$setAxis(axis, axisModel) {
    var _a;
    axis.type = axisModel.get('type');
    axis.scale = (0, $2d646e51cc34f840$export$8941c4cacdc8f5a5)(axisModel);
    axis.onBand = axisModel.get('boundaryGap') && axis.type === 'category';
    axis.inverse = axisModel.get('inverse');
    if ($45211ba328a63245$var$isAngleAxisModel(axisModel)) {
        axis.inverse = axis.inverse !== axisModel.get('clockwise');
        var startAngle = axisModel.get('startAngle');
        var endAngle = (_a = axisModel.get('endAngle')) !== null && _a !== void 0 ? _a : startAngle + (axis.inverse ? -360 : 360);
        axis.setExtent(startAngle, endAngle);
    }
    // Inject axis instance
    axisModel.axis = axis;
    axis.model = axisModel;
}
var $45211ba328a63245$var$polarCreator = {
    dimensions: (0, $bbec1db3de81c4bf$export$f6d9521c10640456),
    create: function(ecModel, api) {
        var polarList = [];
        ecModel.eachComponent('polar', function(polarModel, idx) {
            var polar = new (0, $bbec1db3de81c4bf$export$2e2bcd8739ae039)(idx + '');
            // Inject resize and update method
            polar.update = $45211ba328a63245$var$updatePolarScale;
            var radiusAxis = polar.getRadiusAxis();
            var angleAxis = polar.getAngleAxis();
            var radiusAxisModel = polarModel.findAxisModel('radiusAxis');
            var angleAxisModel = polarModel.findAxisModel('angleAxis');
            $45211ba328a63245$var$setAxis(radiusAxis, radiusAxisModel);
            $45211ba328a63245$var$setAxis(angleAxis, angleAxisModel);
            $45211ba328a63245$var$resizePolar(polar, polarModel, api);
            polarList.push(polar);
            polarModel.coordinateSystem = polar;
            polar.model = polarModel;
        });
        // Inject coordinateSystem to series
        ecModel.eachSeries(function(seriesModel) {
            if (seriesModel.get('coordinateSystem') === 'polar') {
                var polarModel = seriesModel.getReferringComponents('polar', (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
                seriesModel.coordinateSystem = polarModel.coordinateSystem;
            }
        });
        return polarList;
    }
};
var $45211ba328a63245$export$2e2bcd8739ae039 = $45211ba328a63245$var$polarCreator;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







var $6fbccfdf5ee55341$var$elementList = [
    'axisLine',
    'axisLabel',
    'axisTick',
    'minorTick',
    'splitLine',
    'minorSplitLine',
    'splitArea'
];
function $6fbccfdf5ee55341$var$getAxisLineShape(polar, rExtent, angle) {
    rExtent[1] > rExtent[0] && (rExtent = rExtent.slice().reverse());
    var start = polar.coordToPoint([
        rExtent[0],
        angle
    ]);
    var end = polar.coordToPoint([
        rExtent[1],
        angle
    ]);
    return {
        x1: start[0],
        y1: start[1],
        x2: end[0],
        y2: end[1]
    };
}
function $6fbccfdf5ee55341$var$getRadiusIdx(polar) {
    var radiusAxis = polar.getRadiusAxis();
    return radiusAxis.inverse ? 0 : 1;
}
// Remove the last tick which will overlap the first tick
function $6fbccfdf5ee55341$var$fixAngleOverlap(list) {
    var firstItem = list[0];
    var lastItem = list[list.length - 1];
    if (firstItem && lastItem && Math.abs(Math.abs(firstItem.coord - lastItem.coord) - 360) < 1e-4) list.pop();
}
var $6fbccfdf5ee55341$var$AngleAxisView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(AngleAxisView, _super);
    function AngleAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AngleAxisView.type;
        _this.axisPointerClass = 'PolarAxisPointer';
        return _this;
    }
    AngleAxisView.prototype.render = function(angleAxisModel, ecModel) {
        this.group.removeAll();
        if (!angleAxisModel.get('show')) return;
        var angleAxis = angleAxisModel.axis;
        var polar = angleAxis.polar;
        var radiusExtent = polar.getRadiusAxis().getExtent();
        var ticksAngles = angleAxis.getTicksCoords();
        var minorTickAngles = angleAxis.getMinorTicksCoords();
        var labels = $7a1bd9c2710fea0d$export$871de8747c9eaa88(angleAxis.getViewLabels(), function(labelItem) {
            labelItem = $7a1bd9c2710fea0d$export$9cd59f9826255e47(labelItem);
            var scale = angleAxis.scale;
            var tickValue = scale.type === 'ordinal' ? scale.getRawOrdinalNumber(labelItem.tickValue) : labelItem.tickValue;
            labelItem.coord = angleAxis.dataToCoord(tickValue);
            return labelItem;
        });
        $6fbccfdf5ee55341$var$fixAngleOverlap(labels);
        $6fbccfdf5ee55341$var$fixAngleOverlap(ticksAngles);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43($6fbccfdf5ee55341$var$elementList, function(name) {
            if (angleAxisModel.get([
                name,
                'show'
            ]) && (!angleAxis.scale.isBlank() || name === 'axisLine')) $6fbccfdf5ee55341$var$angelAxisElementsBuilders[name](this.group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent, labels);
        }, this);
    };
    AngleAxisView.type = 'angleAxis';
    return AngleAxisView;
}((0, $58c48a3ef1aa0746$export$2e2bcd8739ae039));
var $6fbccfdf5ee55341$var$angelAxisElementsBuilders = {
    axisLine: function(group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
        var lineStyleModel = angleAxisModel.getModel([
            'axisLine',
            'lineStyle'
        ]);
        var angleAxis = polar.getAngleAxis();
        var RADIAN = Math.PI / 180;
        var angleExtent = angleAxis.getExtent();
        // extent id of the axis radius (r0 and r)
        var rId = $6fbccfdf5ee55341$var$getRadiusIdx(polar);
        var r0Id = rId ? 0 : 1;
        var shape;
        var shapeType = Math.abs(angleExtent[1] - angleExtent[0]) === 360 ? 'Circle' : 'Arc';
        if (radiusExtent[r0Id] === 0) shape = new $5b455ae6f843ac47$exports[shapeType]({
            shape: {
                cx: polar.cx,
                cy: polar.cy,
                r: radiusExtent[rId],
                startAngle: -angleExtent[0] * RADIAN,
                endAngle: -angleExtent[1] * RADIAN,
                clockwise: angleAxis.inverse
            },
            style: lineStyleModel.getLineStyle(),
            z2: 1,
            silent: true
        });
        else shape = new $5b455ae6f843ac47$exports.Ring({
            shape: {
                cx: polar.cx,
                cy: polar.cy,
                r: radiusExtent[rId],
                r0: radiusExtent[r0Id]
            },
            style: lineStyleModel.getLineStyle(),
            z2: 1,
            silent: true
        });
        shape.style.fill = null;
        group.add(shape);
    },
    axisTick: function(group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
        var tickModel = angleAxisModel.getModel('axisTick');
        var tickLen = (tickModel.get('inside') ? -1 : 1) * tickModel.get('length');
        var radius = radiusExtent[$6fbccfdf5ee55341$var$getRadiusIdx(polar)];
        var lines = $7a1bd9c2710fea0d$export$871de8747c9eaa88(ticksAngles, function(tickAngleItem) {
            return new $5b455ae6f843ac47$exports.Line({
                shape: $6fbccfdf5ee55341$var$getAxisLineShape(polar, [
                    radius,
                    radius + tickLen
                ], tickAngleItem.coord)
            });
        });
        group.add($5b455ae6f843ac47$exports.mergePath(lines, {
            style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e(tickModel.getModel('lineStyle').getLineStyle(), {
                stroke: angleAxisModel.get([
                    'axisLine',
                    'lineStyle',
                    'color'
                ])
            })
        }));
    },
    minorTick: function(group, angleAxisModel, polar, tickAngles, minorTickAngles, radiusExtent) {
        if (!minorTickAngles.length) return;
        var tickModel = angleAxisModel.getModel('axisTick');
        var minorTickModel = angleAxisModel.getModel('minorTick');
        var tickLen = (tickModel.get('inside') ? -1 : 1) * minorTickModel.get('length');
        var radius = radiusExtent[$6fbccfdf5ee55341$var$getRadiusIdx(polar)];
        var lines = [];
        for(var i = 0; i < minorTickAngles.length; i++)for(var k = 0; k < minorTickAngles[i].length; k++)lines.push(new $5b455ae6f843ac47$exports.Line({
            shape: $6fbccfdf5ee55341$var$getAxisLineShape(polar, [
                radius,
                radius + tickLen
            ], minorTickAngles[i][k].coord)
        }));
        group.add($5b455ae6f843ac47$exports.mergePath(lines, {
            style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e(minorTickModel.getModel('lineStyle').getLineStyle(), $7a1bd9c2710fea0d$export$ebe90cb607ad99e(tickModel.getLineStyle(), {
                stroke: angleAxisModel.get([
                    'axisLine',
                    'lineStyle',
                    'color'
                ])
            }))
        }));
    },
    axisLabel: function(group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent, labels) {
        var rawCategoryData = angleAxisModel.getCategories(true);
        var commonLabelModel = angleAxisModel.getModel('axisLabel');
        var labelMargin = commonLabelModel.get('margin');
        var triggerEvent = angleAxisModel.get('triggerEvent');
        // Use length of ticksAngles because it may remove the last tick to avoid overlapping
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(labels, function(labelItem, idx) {
            var labelModel = commonLabelModel;
            var tickValue = labelItem.tickValue;
            var r = radiusExtent[$6fbccfdf5ee55341$var$getRadiusIdx(polar)];
            var p = polar.coordToPoint([
                r + labelMargin,
                labelItem.coord
            ]);
            var cx = polar.cx;
            var cy = polar.cy;
            var labelTextAlign = Math.abs(p[0] - cx) / r < 0.3 ? 'center' : p[0] > cx ? 'left' : 'right';
            var labelTextVerticalAlign = Math.abs(p[1] - cy) / r < 0.3 ? 'middle' : p[1] > cy ? 'top' : 'bottom';
            if (rawCategoryData && rawCategoryData[tickValue]) {
                var rawCategoryItem = rawCategoryData[tickValue];
                if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(rawCategoryItem) && rawCategoryItem.textStyle) labelModel = new (0, $6818646a97528290$export$2e2bcd8739ae039)(rawCategoryItem.textStyle, commonLabelModel, commonLabelModel.ecModel);
            }
            var textEl = new $5b455ae6f843ac47$exports.Text({
                silent: (0, $dfe15f745e1c3c2b$export$2e2bcd8739ae039).isLabelSilent(angleAxisModel),
                style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(labelModel, {
                    x: p[0],
                    y: p[1],
                    fill: labelModel.getTextColor() || angleAxisModel.get([
                        'axisLine',
                        'lineStyle',
                        'color'
                    ]),
                    text: labelItem.formattedLabel,
                    align: labelTextAlign,
                    verticalAlign: labelTextVerticalAlign
                })
            });
            group.add(textEl);
            // Pack data for mouse event
            if (triggerEvent) {
                var eventData = (0, $dfe15f745e1c3c2b$export$2e2bcd8739ae039).makeAxisEventDataBase(angleAxisModel);
                eventData.targetType = 'axisLabel';
                eventData.value = labelItem.rawLabel;
                (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(textEl).eventData = eventData;
            }
        }, this);
    },
    splitLine: function(group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
        var splitLineModel = angleAxisModel.getModel('splitLine');
        var lineStyleModel = splitLineModel.getModel('lineStyle');
        var lineColors = lineStyleModel.get('color');
        var lineCount = 0;
        lineColors = lineColors instanceof Array ? lineColors : [
            lineColors
        ];
        var splitLines = [];
        for(var i = 0; i < ticksAngles.length; i++){
            var colorIndex = lineCount++ % lineColors.length;
            splitLines[colorIndex] = splitLines[colorIndex] || [];
            splitLines[colorIndex].push(new $5b455ae6f843ac47$exports.Line({
                shape: $6fbccfdf5ee55341$var$getAxisLineShape(polar, radiusExtent, ticksAngles[i].coord)
            }));
        }
        // Simple optimization
        // Batching the lines if color are the same
        for(var i = 0; i < splitLines.length; i++)group.add($5b455ae6f843ac47$exports.mergePath(splitLines[i], {
            style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                stroke: lineColors[i % lineColors.length]
            }, lineStyleModel.getLineStyle()),
            silent: true,
            z: angleAxisModel.get('z')
        }));
    },
    minorSplitLine: function(group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
        if (!minorTickAngles.length) return;
        var minorSplitLineModel = angleAxisModel.getModel('minorSplitLine');
        var lineStyleModel = minorSplitLineModel.getModel('lineStyle');
        var lines = [];
        for(var i = 0; i < minorTickAngles.length; i++)for(var k = 0; k < minorTickAngles[i].length; k++)lines.push(new $5b455ae6f843ac47$exports.Line({
            shape: $6fbccfdf5ee55341$var$getAxisLineShape(polar, radiusExtent, minorTickAngles[i][k].coord)
        }));
        group.add($5b455ae6f843ac47$exports.mergePath(lines, {
            style: lineStyleModel.getLineStyle(),
            silent: true,
            z: angleAxisModel.get('z')
        }));
    },
    splitArea: function(group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
        if (!ticksAngles.length) return;
        var splitAreaModel = angleAxisModel.getModel('splitArea');
        var areaStyleModel = splitAreaModel.getModel('areaStyle');
        var areaColors = areaStyleModel.get('color');
        var lineCount = 0;
        areaColors = areaColors instanceof Array ? areaColors : [
            areaColors
        ];
        var splitAreas = [];
        var RADIAN = Math.PI / 180;
        var prevAngle = -ticksAngles[0].coord * RADIAN;
        var r0 = Math.min(radiusExtent[0], radiusExtent[1]);
        var r1 = Math.max(radiusExtent[0], radiusExtent[1]);
        var clockwise = angleAxisModel.get('clockwise');
        for(var i = 1, len = ticksAngles.length; i <= len; i++){
            var coord = i === len ? ticksAngles[0].coord : ticksAngles[i].coord;
            var colorIndex = lineCount++ % areaColors.length;
            splitAreas[colorIndex] = splitAreas[colorIndex] || [];
            splitAreas[colorIndex].push(new $5b455ae6f843ac47$exports.Sector({
                shape: {
                    cx: polar.cx,
                    cy: polar.cy,
                    r0: r0,
                    r: r1,
                    startAngle: prevAngle,
                    endAngle: -coord * RADIAN,
                    clockwise: clockwise
                },
                silent: true
            }));
            prevAngle = -coord * RADIAN;
        }
        // Simple optimization
        // Batching the lines if color are the same
        for(var i = 0; i < splitAreas.length; i++)group.add($5b455ae6f843ac47$exports.mergePath(splitAreas[i], {
            style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                fill: areaColors[i % areaColors.length]
            }, areaStyleModel.getAreaStyle()),
            silent: true
        }));
    }
};
var $6fbccfdf5ee55341$export$2e2bcd8739ae039 = $6fbccfdf5ee55341$var$AngleAxisView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $e1f5ed5855e953f0$var$axisBuilderAttrs = [
    'axisLine',
    'axisTickLabel',
    'axisName'
];
var $e1f5ed5855e953f0$var$selfBuilderAttrs = [
    'splitLine',
    'splitArea',
    'minorSplitLine'
];
var $e1f5ed5855e953f0$var$RadiusAxisView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(RadiusAxisView, _super);
    function RadiusAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = RadiusAxisView.type;
        _this.axisPointerClass = 'PolarAxisPointer';
        return _this;
    }
    RadiusAxisView.prototype.render = function(radiusAxisModel, ecModel) {
        this.group.removeAll();
        if (!radiusAxisModel.get('show')) return;
        var oldAxisGroup = this._axisGroup;
        var newAxisGroup = this._axisGroup = new $5b455ae6f843ac47$exports.Group();
        this.group.add(newAxisGroup);
        var radiusAxis = radiusAxisModel.axis;
        var polar = radiusAxis.polar;
        var angleAxis = polar.getAngleAxis();
        var ticksCoords = radiusAxis.getTicksCoords();
        var minorTicksCoords = radiusAxis.getMinorTicksCoords();
        var axisAngle = angleAxis.getExtent()[0];
        var radiusExtent = radiusAxis.getExtent();
        var layout = $e1f5ed5855e953f0$var$layoutAxis(polar, radiusAxisModel, axisAngle);
        var axisBuilder = new (0, $dfe15f745e1c3c2b$export$2e2bcd8739ae039)(radiusAxisModel, layout);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43($e1f5ed5855e953f0$var$axisBuilderAttrs, axisBuilder.add, axisBuilder);
        newAxisGroup.add(axisBuilder.getGroup());
        $5b455ae6f843ac47$exports.groupTransition(oldAxisGroup, newAxisGroup, radiusAxisModel);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43($e1f5ed5855e953f0$var$selfBuilderAttrs, function(name) {
            if (radiusAxisModel.get([
                name,
                'show'
            ]) && !radiusAxis.scale.isBlank()) $e1f5ed5855e953f0$var$axisElementBuilders[name](this.group, radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords, minorTicksCoords);
        }, this);
    };
    RadiusAxisView.type = 'radiusAxis';
    return RadiusAxisView;
}((0, $58c48a3ef1aa0746$export$2e2bcd8739ae039));
var $e1f5ed5855e953f0$var$axisElementBuilders = {
    splitLine: function(group, radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords) {
        var splitLineModel = radiusAxisModel.getModel('splitLine');
        var lineStyleModel = splitLineModel.getModel('lineStyle');
        var lineColors = lineStyleModel.get('color');
        var lineCount = 0;
        var angleAxis = polar.getAngleAxis();
        var RADIAN = Math.PI / 180;
        var angleExtent = angleAxis.getExtent();
        var shapeType = Math.abs(angleExtent[1] - angleExtent[0]) === 360 ? 'Circle' : 'Arc';
        lineColors = lineColors instanceof Array ? lineColors : [
            lineColors
        ];
        var splitLines = [];
        for(var i = 0; i < ticksCoords.length; i++){
            var colorIndex = lineCount++ % lineColors.length;
            splitLines[colorIndex] = splitLines[colorIndex] || [];
            splitLines[colorIndex].push(new $5b455ae6f843ac47$exports[shapeType]({
                shape: {
                    cx: polar.cx,
                    cy: polar.cy,
                    // ensure circle radius >= 0
                    r: Math.max(ticksCoords[i].coord, 0),
                    startAngle: -angleExtent[0] * RADIAN,
                    endAngle: -angleExtent[1] * RADIAN,
                    clockwise: angleAxis.inverse
                }
            }));
        }
        // Simple optimization
        // Batching the lines if color are the same
        for(var i = 0; i < splitLines.length; i++)group.add($5b455ae6f843ac47$exports.mergePath(splitLines[i], {
            style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                stroke: lineColors[i % lineColors.length],
                fill: null
            }, lineStyleModel.getLineStyle()),
            silent: true
        }));
    },
    minorSplitLine: function(group, radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords, minorTicksCoords) {
        if (!minorTicksCoords.length) return;
        var minorSplitLineModel = radiusAxisModel.getModel('minorSplitLine');
        var lineStyleModel = minorSplitLineModel.getModel('lineStyle');
        var lines = [];
        for(var i = 0; i < minorTicksCoords.length; i++)for(var k = 0; k < minorTicksCoords[i].length; k++)lines.push(new $5b455ae6f843ac47$exports.Circle({
            shape: {
                cx: polar.cx,
                cy: polar.cy,
                r: minorTicksCoords[i][k].coord
            }
        }));
        group.add($5b455ae6f843ac47$exports.mergePath(lines, {
            style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                fill: null
            }, lineStyleModel.getLineStyle()),
            silent: true
        }));
    },
    splitArea: function(group, radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords) {
        if (!ticksCoords.length) return;
        var splitAreaModel = radiusAxisModel.getModel('splitArea');
        var areaStyleModel = splitAreaModel.getModel('areaStyle');
        var areaColors = areaStyleModel.get('color');
        var lineCount = 0;
        areaColors = areaColors instanceof Array ? areaColors : [
            areaColors
        ];
        var splitAreas = [];
        var prevRadius = ticksCoords[0].coord;
        for(var i = 1; i < ticksCoords.length; i++){
            var colorIndex = lineCount++ % areaColors.length;
            splitAreas[colorIndex] = splitAreas[colorIndex] || [];
            splitAreas[colorIndex].push(new $5b455ae6f843ac47$exports.Sector({
                shape: {
                    cx: polar.cx,
                    cy: polar.cy,
                    r0: prevRadius,
                    r: ticksCoords[i].coord,
                    startAngle: 0,
                    endAngle: Math.PI * 2
                },
                silent: true
            }));
            prevRadius = ticksCoords[i].coord;
        }
        // Simple optimization
        // Batching the lines if color are the same
        for(var i = 0; i < splitAreas.length; i++)group.add($5b455ae6f843ac47$exports.mergePath(splitAreas[i], {
            style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                fill: areaColors[i % areaColors.length]
            }, areaStyleModel.getAreaStyle()),
            silent: true
        }));
    }
};
/**
 * @inner
 */ function $e1f5ed5855e953f0$var$layoutAxis(polar, radiusAxisModel, axisAngle) {
    return {
        position: [
            polar.cx,
            polar.cy
        ],
        rotation: axisAngle / 180 * Math.PI,
        labelDirection: -1,
        tickDirection: -1,
        nameDirection: 1,
        labelRotate: radiusAxisModel.getModel('axisLabel').get('rotate'),
        // Over splitLine and splitArea
        z2: 1
    };
}
var $e1f5ed5855e953f0$export$2e2bcd8739ae039 = $e1f5ed5855e953f0$var$RadiusAxisView;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $ee4ff9541971b552$var$getSeriesStackId(seriesModel) {
    return seriesModel.get('stack') || '__ec_stack_' + seriesModel.seriesIndex;
}
function $ee4ff9541971b552$var$getAxisKey(polar, axis) {
    return axis.dim + polar.model.componentIndex;
}
function $ee4ff9541971b552$var$barLayoutPolar(seriesType, ecModel, api) {
    var lastStackCoords = {};
    var barWidthAndOffset = $ee4ff9541971b552$var$calRadialBar($7a1bd9c2710fea0d$export$3dea766d36a8935f(ecModel.getSeriesByType(seriesType), function(seriesModel) {
        return !ecModel.isSeriesFiltered(seriesModel) && seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === 'polar';
    }));
    ecModel.eachSeriesByType(seriesType, function(seriesModel) {
        // Check series coordinate, do layout for polar only
        if (seriesModel.coordinateSystem.type !== 'polar') return;
        var data = seriesModel.getData();
        var polar = seriesModel.coordinateSystem;
        var baseAxis = polar.getBaseAxis();
        var axisKey = $ee4ff9541971b552$var$getAxisKey(polar, baseAxis);
        var stackId = $ee4ff9541971b552$var$getSeriesStackId(seriesModel);
        var columnLayoutInfo = barWidthAndOffset[axisKey][stackId];
        var columnOffset = columnLayoutInfo.offset;
        var columnWidth = columnLayoutInfo.width;
        var valueAxis = polar.getOtherAxis(baseAxis);
        var cx = seriesModel.coordinateSystem.cx;
        var cy = seriesModel.coordinateSystem.cy;
        var barMinHeight = seriesModel.get('barMinHeight') || 0;
        var barMinAngle = seriesModel.get('barMinAngle') || 0;
        lastStackCoords[stackId] = lastStackCoords[stackId] || [];
        var valueDim = data.mapDimension(valueAxis.dim);
        var baseDim = data.mapDimension(baseAxis.dim);
        var stacked = (0, $efdd976e4917927c$export$1dedc39359ae35c)(data, valueDim /* , baseDim */ );
        var clampLayout = baseAxis.dim !== 'radius' || !seriesModel.get('roundCap', true);
        var valueAxisModel = valueAxis.model;
        var startValue = valueAxisModel.get('startValue');
        var valueAxisStart = valueAxis.dataToCoord(startValue || 0);
        for(var idx = 0, len = data.count(); idx < len; idx++){
            var value = data.get(valueDim, idx);
            var baseValue = data.get(baseDim, idx);
            var sign = value >= 0 ? 'p' : 'n';
            var baseCoord = valueAxisStart;
            // Because of the barMinHeight, we can not use the value in
            // stackResultDimension directly.
            // Only ordinal axis can be stacked.
            if (stacked) {
                if (!lastStackCoords[stackId][baseValue]) lastStackCoords[stackId][baseValue] = {
                    p: valueAxisStart,
                    n: valueAxisStart // Negative stack
                };
                // Should also consider #4243
                baseCoord = lastStackCoords[stackId][baseValue][sign];
            }
            var r0 = void 0;
            var r = void 0;
            var startAngle = void 0;
            var endAngle = void 0;
            // radial sector
            if (valueAxis.dim === 'radius') {
                var radiusSpan = valueAxis.dataToCoord(value) - valueAxisStart;
                var angle = baseAxis.dataToCoord(baseValue);
                if (Math.abs(radiusSpan) < barMinHeight) radiusSpan = (radiusSpan < 0 ? -1 : 1) * barMinHeight;
                r0 = baseCoord;
                r = baseCoord + radiusSpan;
                startAngle = angle - columnOffset;
                endAngle = startAngle - columnWidth;
                stacked && (lastStackCoords[stackId][baseValue][sign] = r);
            } else {
                var angleSpan = valueAxis.dataToCoord(value, clampLayout) - valueAxisStart;
                var radius = baseAxis.dataToCoord(baseValue);
                if (Math.abs(angleSpan) < barMinAngle) angleSpan = (angleSpan < 0 ? -1 : 1) * barMinAngle;
                r0 = radius + columnOffset;
                r = r0 + columnWidth;
                startAngle = baseCoord;
                endAngle = baseCoord + angleSpan;
                // if the previous stack is at the end of the ring,
                // add a round to differentiate it from origin
                // let extent = angleAxis.getExtent();
                // let stackCoord = angle;
                // if (stackCoord === extent[0] && value > 0) {
                //     stackCoord = extent[1];
                // }
                // else if (stackCoord === extent[1] && value < 0) {
                //     stackCoord = extent[0];
                // }
                stacked && (lastStackCoords[stackId][baseValue][sign] = endAngle);
            }
            data.setItemLayout(idx, {
                cx: cx,
                cy: cy,
                r0: r0,
                r: r,
                // Consider that positive angle is anti-clockwise,
                // while positive radian of sector is clockwise
                startAngle: -startAngle * Math.PI / 180,
                endAngle: -endAngle * Math.PI / 180,
                /**
         * Keep the same logic with bar in catesion: use end value to
         * control direction. Notice that if clockwise is true (by
         * default), the sector will always draw clockwisely, no matter
         * whether endAngle is greater or less than startAngle.
         */ clockwise: startAngle >= endAngle
            });
        }
    });
}
/**
 * Calculate bar width and offset for radial bar charts
 */ function $ee4ff9541971b552$var$calRadialBar(barSeries) {
    // Columns info on each category axis. Key is polar name
    var columnsMap = {};
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(barSeries, function(seriesModel, idx) {
        var data = seriesModel.getData();
        var polar = seriesModel.coordinateSystem;
        var baseAxis = polar.getBaseAxis();
        var axisKey = $ee4ff9541971b552$var$getAxisKey(polar, baseAxis);
        var axisExtent = baseAxis.getExtent();
        var bandWidth = baseAxis.type === 'category' ? baseAxis.getBandWidth() : Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
        var columnsOnAxis = columnsMap[axisKey] || {
            bandWidth: bandWidth,
            remainedWidth: bandWidth,
            autoWidthCount: 0,
            categoryGap: '20%',
            gap: '30%',
            stacks: {}
        };
        var stacks = columnsOnAxis.stacks;
        columnsMap[axisKey] = columnsOnAxis;
        var stackId = $ee4ff9541971b552$var$getSeriesStackId(seriesModel);
        if (!stacks[stackId]) columnsOnAxis.autoWidthCount++;
        stacks[stackId] = stacks[stackId] || {
            width: 0,
            maxWidth: 0
        };
        var barWidth = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(seriesModel.get('barWidth'), bandWidth);
        var barMaxWidth = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(seriesModel.get('barMaxWidth'), bandWidth);
        var barGap = seriesModel.get('barGap');
        var barCategoryGap = seriesModel.get('barCategoryGap');
        if (barWidth && !stacks[stackId].width) {
            barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
            stacks[stackId].width = barWidth;
            columnsOnAxis.remainedWidth -= barWidth;
        }
        barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
        barGap != null && (columnsOnAxis.gap = barGap);
        barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
    });
    var result = {};
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(columnsMap, function(columnsOnAxis, coordSysName) {
        result[coordSysName] = {};
        var stacks = columnsOnAxis.stacks;
        var bandWidth = columnsOnAxis.bandWidth;
        var categoryGap = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(columnsOnAxis.categoryGap, bandWidth);
        var barGapPercent = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(columnsOnAxis.gap, 1);
        var remainedWidth = columnsOnAxis.remainedWidth;
        var autoWidthCount = columnsOnAxis.autoWidthCount;
        var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
        autoWidth = Math.max(autoWidth, 0);
        // Find if any auto calculated bar exceeded maxBarWidth
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(stacks, function(column, stack) {
            var maxWidth = column.maxWidth;
            if (maxWidth && maxWidth < autoWidth) {
                maxWidth = Math.min(maxWidth, remainedWidth);
                if (column.width) maxWidth = Math.min(maxWidth, column.width);
                remainedWidth -= maxWidth;
                column.width = maxWidth;
                autoWidthCount--;
            }
        });
        // Recalculate width again
        autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
        autoWidth = Math.max(autoWidth, 0);
        var widthSum = 0;
        var lastColumn;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(stacks, function(column, idx) {
            if (!column.width) column.width = autoWidth;
            lastColumn = column;
            widthSum += column.width * (1 + barGapPercent);
        });
        if (lastColumn) widthSum -= lastColumn.width * barGapPercent;
        var offset = -widthSum / 2;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(stacks, function(column, stackId) {
            result[coordSysName][stackId] = result[coordSysName][stackId] || {
                offset: offset,
                width: column.width
            };
            offset += column.width * (1 + barGapPercent);
        });
    });
    return result;
}
var $ee4ff9541971b552$export$2e2bcd8739ae039 = $ee4ff9541971b552$var$barLayoutPolar;


var $0a6536a72e92ce0b$var$angleAxisExtraOption = {
    startAngle: 90,
    clockwise: true,
    splitNumber: 12,
    axisLabel: {
        rotate: 0
    }
};
var $0a6536a72e92ce0b$var$radiusAxisExtraOption = {
    splitNumber: 5
};
var $0a6536a72e92ce0b$var$PolarView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(PolarView, _super);
    function PolarView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = PolarView.type;
        return _this;
    }
    PolarView.type = 'polar';
    return PolarView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
function $0a6536a72e92ce0b$export$4b3e715f166fdd78(registers) {
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $589507869c21caa1$export$4b3e715f166fdd78));
    (0, $58c48a3ef1aa0746$export$2e2bcd8739ae039).registerAxisPointerClass('PolarAxisPointer', (0, $692a4df2164e3c50$export$2e2bcd8739ae039));
    registers.registerCoordinateSystem('polar', (0, $45211ba328a63245$export$2e2bcd8739ae039));
    registers.registerComponentModel((0, $657132d924424c20$export$2e2bcd8739ae039));
    registers.registerComponentView($0a6536a72e92ce0b$var$PolarView);
    // Model and view for angleAxis and radiusAxis
    (0, $c5c4c85259d60abe$export$2e2bcd8739ae039)(registers, 'angle', (0, $d885303d9d4b2eee$export$34735c2c701428ca), $0a6536a72e92ce0b$var$angleAxisExtraOption);
    (0, $c5c4c85259d60abe$export$2e2bcd8739ae039)(registers, 'radius', (0, $d885303d9d4b2eee$export$de202388c212a23b), $0a6536a72e92ce0b$var$radiusAxisExtraOption);
    registers.registerComponentView((0, $6fbccfdf5ee55341$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $e1f5ed5855e953f0$export$2e2bcd8739ae039));
    registers.registerLayout((0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)((0, $ee4ff9541971b552$export$2e2bcd8739ae039), 'bar'));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $eb958aa0a28bdfd8$export$b3219800bda33a1f(axisModel, opt) {
    opt = opt || {};
    var single = axisModel.coordinateSystem;
    var axis = axisModel.axis;
    var layout = {};
    var axisPosition = axis.position;
    var orient = axis.orient;
    var rect = single.getRect();
    var rectBound = [
        rect.x,
        rect.x + rect.width,
        rect.y,
        rect.y + rect.height
    ];
    var positionMap = {
        horizontal: {
            top: rectBound[2],
            bottom: rectBound[3]
        },
        vertical: {
            left: rectBound[0],
            right: rectBound[1]
        }
    };
    layout.position = [
        orient === 'vertical' ? positionMap.vertical[axisPosition] : rectBound[0],
        orient === 'horizontal' ? positionMap.horizontal[axisPosition] : rectBound[3]
    ];
    var r = {
        horizontal: 0,
        vertical: 1
    };
    layout.rotation = Math.PI / 2 * r[orient];
    var directionMap = {
        top: -1,
        bottom: 1,
        right: 1,
        left: -1
    };
    layout.labelDirection = layout.tickDirection = layout.nameDirection = directionMap[axisPosition];
    if (axisModel.get([
        'axisTick',
        'inside'
    ])) layout.tickDirection = -layout.tickDirection;
    if ($7a1bd9c2710fea0d$export$8a4d17b6e8486e66(opt.labelInside, axisModel.get([
        'axisLabel',
        'inside'
    ]))) layout.labelDirection = -layout.labelDirection;
    var labelRotation = opt.rotate;
    labelRotation == null && (labelRotation = axisModel.get([
        'axisLabel',
        'rotate'
    ]));
    layout.labelRotation = axisPosition === 'top' ? -labelRotation : labelRotation;
    layout.z2 = 1;
    return layout;
}




var $e0635e836f59c3c6$var$axisBuilderAttrs = [
    'axisLine',
    'axisTickLabel',
    'axisName'
];
var $e0635e836f59c3c6$var$selfBuilderAttrs = [
    'splitArea',
    'splitLine'
];
var $e0635e836f59c3c6$var$SingleAxisView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SingleAxisView, _super);
    function SingleAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SingleAxisView.type;
        _this.axisPointerClass = 'SingleAxisPointer';
        return _this;
    }
    SingleAxisView.prototype.render = function(axisModel, ecModel, api, payload) {
        var group = this.group;
        group.removeAll();
        var oldAxisGroup = this._axisGroup;
        this._axisGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        var layout = $eb958aa0a28bdfd8$export$b3219800bda33a1f(axisModel);
        var axisBuilder = new (0, $dfe15f745e1c3c2b$export$2e2bcd8739ae039)(axisModel, layout);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43($e0635e836f59c3c6$var$axisBuilderAttrs, axisBuilder.add, axisBuilder);
        group.add(this._axisGroup);
        group.add(axisBuilder.getGroup());
        $7a1bd9c2710fea0d$export$79b2f7037acddd43($e0635e836f59c3c6$var$selfBuilderAttrs, function(name) {
            if (axisModel.get([
                name,
                'show'
            ])) $e0635e836f59c3c6$var$axisElementBuilders[name](this, this.group, this._axisGroup, axisModel);
        }, this);
        $5b455ae6f843ac47$export$64fcab7860c216ae(oldAxisGroup, this._axisGroup, axisModel);
        _super.prototype.render.call(this, axisModel, ecModel, api, payload);
    };
    SingleAxisView.prototype.remove = function() {
        (0, $ff3096b1f24c33b6$export$48ebf2d6ce8ad076)(this);
    };
    SingleAxisView.type = 'singleAxis';
    return SingleAxisView;
}((0, $58c48a3ef1aa0746$export$2e2bcd8739ae039));
var $e0635e836f59c3c6$var$axisElementBuilders = {
    splitLine: function(axisView, group, axisGroup, axisModel) {
        var axis = axisModel.axis;
        if (axis.scale.isBlank()) return;
        var splitLineModel = axisModel.getModel('splitLine');
        var lineStyleModel = splitLineModel.getModel('lineStyle');
        var lineColors = lineStyleModel.get('color');
        lineColors = lineColors instanceof Array ? lineColors : [
            lineColors
        ];
        var lineWidth = lineStyleModel.get('width');
        var gridRect = axisModel.coordinateSystem.getRect();
        var isHorizontal = axis.isHorizontal();
        var splitLines = [];
        var lineCount = 0;
        var ticksCoords = axis.getTicksCoords({
            tickModel: splitLineModel
        });
        var p1 = [];
        var p2 = [];
        for(var i = 0; i < ticksCoords.length; ++i){
            var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
            if (isHorizontal) {
                p1[0] = tickCoord;
                p1[1] = gridRect.y;
                p2[0] = tickCoord;
                p2[1] = gridRect.y + gridRect.height;
            } else {
                p1[0] = gridRect.x;
                p1[1] = tickCoord;
                p2[0] = gridRect.x + gridRect.width;
                p2[1] = tickCoord;
            }
            var line = new $7a316ae5ceff7b27$export$2e2bcd8739ae039({
                shape: {
                    x1: p1[0],
                    y1: p1[1],
                    x2: p2[0],
                    y2: p2[1]
                },
                silent: true
            });
            $5b455ae6f843ac47$export$8b4b620d7f4aad1b(line.shape, lineWidth);
            var colorIndex = lineCount++ % lineColors.length;
            splitLines[colorIndex] = splitLines[colorIndex] || [];
            splitLines[colorIndex].push(line);
        }
        var lineStyle = lineStyleModel.getLineStyle([
            'color'
        ]);
        for(var i = 0; i < splitLines.length; ++i)group.add($5b455ae6f843ac47$export$7b1dd269fbc4e903(splitLines[i], {
            style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                stroke: lineColors[i % lineColors.length]
            }, lineStyle),
            silent: true
        }));
    },
    splitArea: function(axisView, group, axisGroup, axisModel) {
        (0, $ff3096b1f24c33b6$export$c80b7ef1527ec8c9)(axisView, axisGroup, axisModel, axisModel);
    }
};
var $e0635e836f59c3c6$export$2e2bcd8739ae039 = $e0635e836f59c3c6$var$SingleAxisView;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $0b0fbc117344336a$var$SingleAxisModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SingleAxisModel, _super);
    function SingleAxisModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SingleAxisModel.type;
        return _this;
    }
    SingleAxisModel.prototype.getCoordSysModel = function() {
        return this;
    };
    SingleAxisModel.type = 'singleAxis';
    SingleAxisModel.layoutMode = 'box';
    SingleAxisModel.defaultOption = {
        left: '5%',
        top: '5%',
        right: '5%',
        bottom: '5%',
        type: 'value',
        position: 'bottom',
        orient: 'horizontal',
        axisLine: {
            show: true,
            lineStyle: {
                width: 1,
                type: 'solid'
            }
        },
        // Single coordinate system and single axis is the,
        // which is used as the parent tooltip model.
        // same model, so we set default tooltip show as true.
        tooltip: {
            show: true
        },
        axisTick: {
            show: true,
            length: 6,
            lineStyle: {
                width: 1
            }
        },
        axisLabel: {
            show: true,
            interval: 'auto'
        },
        splitLine: {
            show: true,
            lineStyle: {
                type: 'dashed',
                opacity: 0.2
            }
        }
    };
    return SingleAxisModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
(0, $7a1bd9c2710fea0d$export$e36fc9d62a853069)($0b0fbc117344336a$var$SingleAxisModel, (0, $3449fd4c0590d99e$export$5c54b224726edb5a).prototype);
var $0b0fbc117344336a$export$2e2bcd8739ae039 = $0b0fbc117344336a$var$SingleAxisModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Single coordinate system creator.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Single coordinates system.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $75328fa4f01e808e$var$SingleAxis = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SingleAxis, _super);
    function SingleAxis(dim, scale, coordExtent, axisType, position) {
        var _this = _super.call(this, dim, scale, coordExtent) || this;
        _this.type = axisType || 'value';
        _this.position = position || 'bottom';
        return _this;
    }
    /**
   * Judge the orient of the axis.
   */ SingleAxis.prototype.isHorizontal = function() {
        var position = this.position;
        return position === 'top' || position === 'bottom';
    };
    SingleAxis.prototype.pointToData = function(point, clamp) {
        return this.coordinateSystem.pointToData(point)[0];
    };
    return SingleAxis;
}((0, $c2b1efffe5ae3f42$export$2e2bcd8739ae039));
var $75328fa4f01e808e$export$2e2bcd8739ae039 = $75328fa4f01e808e$var$SingleAxis;





var $2e4ce743775bada6$export$28486687f659fb1a = [
    'single'
];
/**
 * Create a single coordinates system.
 */ var $2e4ce743775bada6$var$Single = /** @class */ function() {
    function Single(axisModel, ecModel, api) {
        this.type = 'single';
        this.dimension = 'single';
        /**
     * Add it just for draw tooltip.
     */ this.dimensions = $2e4ce743775bada6$export$28486687f659fb1a;
        this.axisPointerEnabled = true;
        this.model = axisModel;
        this._init(axisModel, ecModel, api);
    }
    /**
   * Initialize single coordinate system.
   */ Single.prototype._init = function(axisModel, ecModel, api) {
        var dim = this.dimension;
        var axis = new (0, $75328fa4f01e808e$export$2e2bcd8739ae039)(dim, $2d646e51cc34f840$export$8941c4cacdc8f5a5(axisModel), [
            0,
            0
        ], axisModel.get('type'), axisModel.get('position'));
        var isCategory = axis.type === 'category';
        axis.onBand = isCategory && axisModel.get('boundaryGap');
        axis.inverse = axisModel.get('inverse');
        axis.orient = axisModel.get('orient');
        axisModel.axis = axis;
        axis.model = axisModel;
        axis.coordinateSystem = this;
        this._axis = axis;
    };
    /**
   * Update axis scale after data processed
   */ Single.prototype.update = function(ecModel, api) {
        ecModel.eachSeries(function(seriesModel) {
            if (seriesModel.coordinateSystem === this) {
                var data_1 = seriesModel.getData();
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(data_1.mapDimensionsAll(this.dimension), function(dim) {
                    this._axis.scale.unionExtentFromData(data_1, dim);
                }, this);
                $2d646e51cc34f840$export$51f3e70a54405d5a(this._axis.scale, this._axis.model);
            }
        }, this);
    };
    /**
   * Resize the single coordinate system.
   */ Single.prototype.resize = function(axisModel, api) {
        this._rect = (0, $93b9bc7f22ac7369$export$4517a5ca639a7293)({
            left: axisModel.get('left'),
            top: axisModel.get('top'),
            right: axisModel.get('right'),
            bottom: axisModel.get('bottom'),
            width: axisModel.get('width'),
            height: axisModel.get('height')
        }, {
            width: api.getWidth(),
            height: api.getHeight()
        });
        this._adjustAxis();
    };
    Single.prototype.getRect = function() {
        return this._rect;
    };
    Single.prototype._adjustAxis = function() {
        var rect = this._rect;
        var axis = this._axis;
        var isHorizontal = axis.isHorizontal();
        var extent = isHorizontal ? [
            0,
            rect.width
        ] : [
            0,
            rect.height
        ];
        var idx = axis.inverse ? 1 : 0;
        axis.setExtent(extent[idx], extent[1 - idx]);
        this._updateAxisTransform(axis, isHorizontal ? rect.x : rect.y);
    };
    Single.prototype._updateAxisTransform = function(axis, coordBase) {
        var axisExtent = axis.getExtent();
        var extentSum = axisExtent[0] + axisExtent[1];
        var isHorizontal = axis.isHorizontal();
        axis.toGlobalCoord = isHorizontal ? function(coord) {
            return coord + coordBase;
        } : function(coord) {
            return extentSum - coord + coordBase;
        };
        axis.toLocalCoord = isHorizontal ? function(coord) {
            return coord - coordBase;
        } : function(coord) {
            return extentSum - coord + coordBase;
        };
    };
    /**
   * Get axis.
   */ Single.prototype.getAxis = function() {
        return this._axis;
    };
    /**
   * Get axis, add it just for draw tooltip.
   */ Single.prototype.getBaseAxis = function() {
        return this._axis;
    };
    Single.prototype.getAxes = function() {
        return [
            this._axis
        ];
    };
    Single.prototype.getTooltipAxes = function() {
        return {
            baseAxes: [
                this.getAxis()
            ],
            // Empty otherAxes
            otherAxes: []
        };
    };
    /**
   * If contain point.
   */ Single.prototype.containPoint = function(point) {
        var rect = this.getRect();
        var axis = this.getAxis();
        var orient = axis.orient;
        if (orient === 'horizontal') return axis.contain(axis.toLocalCoord(point[0])) && point[1] >= rect.y && point[1] <= rect.y + rect.height;
        else return axis.contain(axis.toLocalCoord(point[1])) && point[0] >= rect.y && point[0] <= rect.y + rect.height;
    };
    Single.prototype.pointToData = function(point) {
        var axis = this.getAxis();
        return [
            axis.coordToData(axis.toLocalCoord(point[axis.orient === 'horizontal' ? 0 : 1]))
        ];
    };
    /**
   * Convert the series data to concrete point.
   * Can be [val] | val
   */ Single.prototype.dataToPoint = function(val) {
        var axis = this.getAxis();
        var rect = this.getRect();
        var pt = [];
        var idx = axis.orient === 'horizontal' ? 0 : 1;
        if (val instanceof Array) val = val[0];
        pt[idx] = axis.toGlobalCoord(axis.dataToCoord(+val));
        pt[1 - idx] = idx === 0 ? rect.y + rect.height / 2 : rect.x + rect.width / 2;
        return pt;
    };
    Single.prototype.convertToPixel = function(ecModel, finder, value) {
        var coordSys = $2e4ce743775bada6$var$getCoordSys(finder);
        return coordSys === this ? this.dataToPoint(value) : null;
    };
    Single.prototype.convertFromPixel = function(ecModel, finder, pixel) {
        var coordSys = $2e4ce743775bada6$var$getCoordSys(finder);
        return coordSys === this ? this.pointToData(pixel) : null;
    };
    return Single;
}();
function $2e4ce743775bada6$var$getCoordSys(finder) {
    var seriesModel = finder.seriesModel;
    var singleModel = finder.singleAxisModel;
    return singleModel && singleModel.coordinateSystem || seriesModel && seriesModel.coordinateSystem;
}
var $2e4ce743775bada6$export$2e2bcd8739ae039 = $2e4ce743775bada6$var$Single;



/**
 * Create single coordinate system and inject it into seriesModel.
 */ function $65313efe3e93ec7e$var$create(ecModel, api) {
    var singles = [];
    ecModel.eachComponent('singleAxis', function(axisModel, idx) {
        var single = new (0, $2e4ce743775bada6$export$2e2bcd8739ae039)(axisModel, ecModel, api);
        single.name = 'single_' + idx;
        single.resize(axisModel, api);
        axisModel.coordinateSystem = single;
        singles.push(single);
    });
    ecModel.eachSeries(function(seriesModel) {
        if (seriesModel.get('coordinateSystem') === 'singleAxis') {
            var singleAxisModel = seriesModel.getReferringComponents('singleAxis', (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
            seriesModel.coordinateSystem = singleAxisModel && singleAxisModel.coordinateSystem;
        }
    });
    return singles;
}
var $65313efe3e93ec7e$var$singleCreator = {
    create: $65313efe3e93ec7e$var$create,
    dimensions: (0, $2e4ce743775bada6$export$28486687f659fb1a)
};
var $65313efe3e93ec7e$export$2e2bcd8739ae039 = $65313efe3e93ec7e$var$singleCreator;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $26df41956a30cbbf$var$XY = [
    'x',
    'y'
];
var $26df41956a30cbbf$var$WH = [
    'width',
    'height'
];
var $26df41956a30cbbf$var$SingleAxisPointer = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SingleAxisPointer, _super);
    function SingleAxisPointer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
   * @override
   */ SingleAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {
        var axis = axisModel.axis;
        var coordSys = axis.coordinateSystem;
        var otherExtent = $26df41956a30cbbf$var$getGlobalExtent(coordSys, 1 - $26df41956a30cbbf$var$getPointDimIndex(axis));
        var pixelValue = coordSys.dataToPoint(value)[0];
        var axisPointerType = axisPointerModel.get('type');
        if (axisPointerType && axisPointerType !== 'none') {
            var elStyle = $51dec70890757374$export$b7fe459c7cc50060(axisPointerModel);
            var pointerOption = $26df41956a30cbbf$var$pointerShapeBuilder[axisPointerType](axis, pixelValue, otherExtent);
            pointerOption.style = elStyle;
            elOption.graphicKey = pointerOption.type;
            elOption.pointer = pointerOption;
        }
        var layoutInfo = $eb958aa0a28bdfd8$export$b3219800bda33a1f(axisModel);
        $51dec70890757374$export$fd3eb3812211a173(// @ts-ignore
        value, elOption, layoutInfo, axisModel, axisPointerModel, api);
    };
    /**
   * @override
   */ SingleAxisPointer.prototype.getHandleTransform = function(value, axisModel, axisPointerModel) {
        var layoutInfo = $eb958aa0a28bdfd8$export$b3219800bda33a1f(axisModel, {
            labelInside: false
        });
        // @ts-ignore
        layoutInfo.labelMargin = axisPointerModel.get([
            'handle',
            'margin'
        ]);
        var position = $51dec70890757374$export$4bb66440324c3a3d(axisModel.axis, value, layoutInfo);
        return {
            x: position[0],
            y: position[1],
            rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
        };
    };
    /**
   * @override
   */ SingleAxisPointer.prototype.updateHandleTransform = function(transform, delta, axisModel, axisPointerModel) {
        var axis = axisModel.axis;
        var coordSys = axis.coordinateSystem;
        var dimIndex = $26df41956a30cbbf$var$getPointDimIndex(axis);
        var axisExtent = $26df41956a30cbbf$var$getGlobalExtent(coordSys, dimIndex);
        var currPosition = [
            transform.x,
            transform.y
        ];
        currPosition[dimIndex] += delta[dimIndex];
        currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
        currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
        var otherExtent = $26df41956a30cbbf$var$getGlobalExtent(coordSys, 1 - dimIndex);
        var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
        var cursorPoint = [
            cursorOtherValue,
            cursorOtherValue
        ];
        cursorPoint[dimIndex] = currPosition[dimIndex];
        return {
            x: currPosition[0],
            y: currPosition[1],
            rotation: transform.rotation,
            cursorPoint: cursorPoint,
            tooltipOption: {
                verticalAlign: 'middle'
            }
        };
    };
    return SingleAxisPointer;
}((0, $a331d7a6c631e6d9$export$2e2bcd8739ae039));
var $26df41956a30cbbf$var$pointerShapeBuilder = {
    line: function(axis, pixelValue, otherExtent) {
        var targetShape = $51dec70890757374$export$885fa0ad5a826207([
            pixelValue,
            otherExtent[0]
        ], [
            pixelValue,
            otherExtent[1]
        ], $26df41956a30cbbf$var$getPointDimIndex(axis));
        return {
            type: 'Line',
            subPixelOptimize: true,
            shape: targetShape
        };
    },
    shadow: function(axis, pixelValue, otherExtent) {
        var bandWidth = axis.getBandWidth();
        var span = otherExtent[1] - otherExtent[0];
        return {
            type: 'Rect',
            shape: $51dec70890757374$export$a8b35248bcc02756([
                pixelValue - bandWidth / 2,
                otherExtent[0]
            ], [
                bandWidth,
                span
            ], $26df41956a30cbbf$var$getPointDimIndex(axis))
        };
    }
};
function $26df41956a30cbbf$var$getPointDimIndex(axis) {
    return axis.isHorizontal() ? 0 : 1;
}
function $26df41956a30cbbf$var$getGlobalExtent(coordSys, dimIndex) {
    var rect = coordSys.getRect();
    return [
        rect[$26df41956a30cbbf$var$XY[dimIndex]],
        rect[$26df41956a30cbbf$var$XY[dimIndex]] + rect[$26df41956a30cbbf$var$WH[dimIndex]]
    ];
}
var $26df41956a30cbbf$export$2e2bcd8739ae039 = $26df41956a30cbbf$var$SingleAxisPointer;


var $2e3198006a202a14$var$SingleView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SingleView, _super);
    function SingleView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SingleView.type;
        return _this;
    }
    SingleView.type = 'single';
    return SingleView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
function $2e3198006a202a14$export$4b3e715f166fdd78(registers) {
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $589507869c21caa1$export$4b3e715f166fdd78));
    (0, $58c48a3ef1aa0746$export$2e2bcd8739ae039).registerAxisPointerClass('SingleAxisPointer', (0, $26df41956a30cbbf$export$2e2bcd8739ae039));
    registers.registerComponentView($2e3198006a202a14$var$SingleView);
    // Axis
    registers.registerComponentView((0, $e0635e836f59c3c6$export$2e2bcd8739ae039));
    registers.registerComponentModel((0, $0b0fbc117344336a$export$2e2bcd8739ae039));
    (0, $c5c4c85259d60abe$export$2e2bcd8739ae039)(registers, 'single', (0, $0b0fbc117344336a$export$2e2bcd8739ae039), (0, $0b0fbc117344336a$export$2e2bcd8739ae039).defaultOption);
    registers.registerCoordinateSystem('single', (0, $65313efe3e93ec7e$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $0a5c39a9e7129dc4$var$TimelineModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(TimelineModel, _super);
    function TimelineModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TimelineModel.type;
        _this.layoutMode = 'box';
        return _this;
    }
    /**
   * @override
   */ TimelineModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
        this._initData();
    };
    /**
   * @override
   */ TimelineModel.prototype.mergeOption = function(option) {
        _super.prototype.mergeOption.apply(this, arguments);
        this._initData();
    };
    TimelineModel.prototype.setCurrentIndex = function(currentIndex) {
        if (currentIndex == null) currentIndex = this.option.currentIndex;
        var count = this._data.count();
        if (this.option.loop) currentIndex = (currentIndex % count + count) % count;
        else {
            currentIndex >= count && (currentIndex = count - 1);
            currentIndex < 0 && (currentIndex = 0);
        }
        this.option.currentIndex = currentIndex;
    };
    /**
   * @return {number} currentIndex
   */ TimelineModel.prototype.getCurrentIndex = function() {
        return this.option.currentIndex;
    };
    /**
   * @return {boolean}
   */ TimelineModel.prototype.isIndexMax = function() {
        return this.getCurrentIndex() >= this._data.count() - 1;
    };
    /**
   * @param {boolean} state true: play, false: stop
   */ TimelineModel.prototype.setPlayState = function(state) {
        this.option.autoPlay = !!state;
    };
    /**
   * @return {boolean} true: play, false: stop
   */ TimelineModel.prototype.getPlayState = function() {
        return !!this.option.autoPlay;
    };
    /**
   * @private
   */ TimelineModel.prototype._initData = function() {
        var thisOption = this.option;
        var dataArr = thisOption.data || [];
        var axisType = thisOption.axisType;
        var names = this._names = [];
        var processedDataArr;
        if (axisType === 'category') {
            processedDataArr = [];
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dataArr, function(item, index) {
                var value = (0, $76d619f648247e6d$export$fb1a222ba5dd6e51)((0, $76d619f648247e6d$export$2c944e12edb48d4b)(item), '');
                var newItem;
                if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(item)) {
                    newItem = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(item);
                    newItem.value = index;
                } else newItem = index;
                processedDataArr.push(newItem);
                names.push(value);
            });
        } else processedDataArr = dataArr;
        var dimType = {
            category: 'ordinal',
            time: 'time',
            value: 'number'
        }[axisType] || 'number';
        var data = this._data = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)([
            {
                name: 'value',
                type: dimType
            }
        ], this);
        data.initData(processedDataArr, names);
    };
    TimelineModel.prototype.getData = function() {
        return this._data;
    };
    /**
   * @public
   * @return {Array.<string>} categoreis
   */ TimelineModel.prototype.getCategories = function() {
        if (this.get('axisType') === 'category') return this._names.slice();
    };
    TimelineModel.type = 'timeline';
    /**
   * @protected
   */ TimelineModel.defaultOption = {
        // zlevel: 0,                  // 一级层叠
        z: 4,
        show: true,
        axisType: 'time',
        realtime: true,
        left: '20%',
        top: null,
        right: '20%',
        bottom: 0,
        width: null,
        height: 40,
        padding: 5,
        controlPosition: 'left',
        autoPlay: false,
        rewind: false,
        loop: true,
        playInterval: 2000,
        currentIndex: 0,
        itemStyle: {},
        label: {
            color: '#000'
        },
        data: []
    };
    return TimelineModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $0a5c39a9e7129dc4$export$2e2bcd8739ae039 = $0a5c39a9e7129dc4$var$TimelineModel;





var $22b93c2a0cce341f$var$SliderTimelineModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SliderTimelineModel, _super);
    function SliderTimelineModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SliderTimelineModel.type;
        return _this;
    }
    SliderTimelineModel.type = 'timeline.slider';
    /**
   * @protected
   */ SliderTimelineModel.defaultOption = (0, $5370df662b2caf37$export$68acc510e46fef2)((0, $0a5c39a9e7129dc4$export$2e2bcd8739ae039).defaultOption, {
        backgroundColor: 'rgba(0,0,0,0)',
        borderColor: '#ccc',
        borderWidth: 0,
        orient: 'horizontal',
        inverse: false,
        tooltip: {
            trigger: 'item' // data item may also have tootip attr.
        },
        symbol: 'circle',
        symbolSize: 12,
        lineStyle: {
            show: true,
            width: 2,
            color: '#DAE1F5'
        },
        label: {
            position: 'auto',
            // When using number, label position is not
            // restricted by viewRect.
            // positive: right/bottom, negative: left/top
            show: true,
            interval: 'auto',
            rotate: 0,
            // formatter: null,
            // 其余属性默认使用全局文本样式，详见TEXTSTYLE
            color: '#A4B1D7'
        },
        itemStyle: {
            color: '#A4B1D7',
            borderWidth: 1
        },
        checkpointStyle: {
            symbol: 'circle',
            symbolSize: 15,
            color: '#316bf3',
            borderColor: '#fff',
            borderWidth: 2,
            shadowBlur: 2,
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowColor: 'rgba(0, 0, 0, 0.3)',
            // borderColor: 'rgba(194,53,49, 0.5)',
            animation: true,
            animationDuration: 300,
            animationEasing: 'quinticInOut'
        },
        controlStyle: {
            show: true,
            showPlayBtn: true,
            showPrevBtn: true,
            showNextBtn: true,
            itemSize: 24,
            itemGap: 12,
            position: 'left',
            playIcon: 'path://M31.6,53C17.5,53,6,41.5,6,27.4S17.5,1.8,31.6,1.8C45.7,1.8,57.2,13.3,57.2,27.4S45.7,53,31.6,53z M31.6,3.3 C18.4,3.3,7.5,14.1,7.5,27.4c0,13.3,10.8,24.1,24.1,24.1C44.9,51.5,55.7,40.7,55.7,27.4C55.7,14.1,44.9,3.3,31.6,3.3z M24.9,21.3 c0-2.2,1.6-3.1,3.5-2l10.5,6.1c1.899,1.1,1.899,2.9,0,4l-10.5,6.1c-1.9,1.1-3.5,0.2-3.5-2V21.3z',
            stopIcon: 'path://M30.9,53.2C16.8,53.2,5.3,41.7,5.3,27.6S16.8,2,30.9,2C45,2,56.4,13.5,56.4,27.6S45,53.2,30.9,53.2z M30.9,3.5C17.6,3.5,6.8,14.4,6.8,27.6c0,13.3,10.8,24.1,24.101,24.1C44.2,51.7,55,40.9,55,27.6C54.9,14.4,44.1,3.5,30.9,3.5z M36.9,35.8c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H36c0.5,0,0.9,0.4,0.9,1V35.8z M27.8,35.8 c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H27c0.5,0,0.9,0.4,0.9,1L27.8,35.8L27.8,35.8z',
            // eslint-disable-next-line max-len
            nextIcon: 'M2,18.5A1.52,1.52,0,0,1,.92,18a1.49,1.49,0,0,1,0-2.12L7.81,9.36,1,3.11A1.5,1.5,0,1,1,3,.89l8,7.34a1.48,1.48,0,0,1,.49,1.09,1.51,1.51,0,0,1-.46,1.1L3,18.08A1.5,1.5,0,0,1,2,18.5Z',
            // eslint-disable-next-line max-len
            prevIcon: 'M10,.5A1.52,1.52,0,0,1,11.08,1a1.49,1.49,0,0,1,0,2.12L4.19,9.64,11,15.89a1.5,1.5,0,1,1-2,2.22L1,10.77A1.48,1.48,0,0,1,.5,9.68,1.51,1.51,0,0,1,1,8.58L9,.92A1.5,1.5,0,0,1,10,.5Z',
            prevBtnSize: 18,
            nextBtnSize: 18,
            color: '#A4B1D7',
            borderColor: '#A4B1D7',
            borderWidth: 1
        },
        emphasis: {
            label: {
                show: true,
                // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                color: '#6f778d'
            },
            itemStyle: {
                color: '#316BF3'
            },
            controlStyle: {
                color: '#316BF3',
                borderColor: '#316BF3',
                borderWidth: 2
            }
        },
        progress: {
            lineStyle: {
                color: '#316BF3'
            },
            itemStyle: {
                color: '#316BF3'
            },
            label: {
                color: '#6f778d'
            }
        },
        data: []
    });
    return SliderTimelineModel;
}((0, $0a5c39a9e7129dc4$export$2e2bcd8739ae039));
(0, $7a1bd9c2710fea0d$export$e36fc9d62a853069)($22b93c2a0cce341f$var$SliderTimelineModel, (0, $655dd6075cc63601$export$f23396ae04ea95a7).prototype);
var $22b93c2a0cce341f$export$2e2bcd8739ae039 = $22b93c2a0cce341f$var$SliderTimelineModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $79b71ced407c5926$var$TimelineView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(TimelineView, _super);
    function TimelineView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TimelineView.type;
        return _this;
    }
    TimelineView.type = 'timeline';
    return TimelineView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $79b71ced407c5926$export$2e2bcd8739ae039 = $79b71ced407c5926$var$TimelineView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/**
 * Extend axis 2d
 */ var $d38633a847120ec8$var$TimelineAxis = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(TimelineAxis, _super);
    function TimelineAxis(dim, scale, coordExtent, axisType) {
        var _this = _super.call(this, dim, scale, coordExtent) || this;
        _this.type = axisType || 'value';
        return _this;
    }
    /**
   * @override
   */ TimelineAxis.prototype.getLabelModel = function() {
        // Force override
        return this.model.getModel('label');
    };
    /**
   * @override
   */ TimelineAxis.prototype.isHorizontal = function() {
        return this.model.get('orient') === 'horizontal';
    };
    return TimelineAxis;
}((0, $c2b1efffe5ae3f42$export$2e2bcd8739ae039));
var $d38633a847120ec8$export$2e2bcd8739ae039 = $d38633a847120ec8$var$TimelineAxis;













var $aba52479ef639cd6$var$PI = Math.PI;
var $aba52479ef639cd6$var$labelDataIndexStore = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $aba52479ef639cd6$var$SliderTimelineView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SliderTimelineView, _super);
    function SliderTimelineView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SliderTimelineView.type;
        return _this;
    }
    SliderTimelineView.prototype.init = function(ecModel, api) {
        this.api = api;
    };
    /**
   * @override
   */ SliderTimelineView.prototype.render = function(timelineModel, ecModel, api) {
        this.model = timelineModel;
        this.api = api;
        this.ecModel = ecModel;
        this.group.removeAll();
        if (timelineModel.get('show', true)) {
            var layoutInfo_1 = this._layout(timelineModel, api);
            var mainGroup_1 = this._createGroup('_mainGroup');
            var labelGroup = this._createGroup('_labelGroup');
            var axis_1 = this._axis = this._createAxis(layoutInfo_1, timelineModel);
            timelineModel.formatTooltip = function(dataIndex) {
                var name = axis_1.scale.getLabel({
                    value: dataIndex
                });
                return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)('nameValue', {
                    noName: true,
                    value: name
                });
            };
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
                'AxisLine',
                'AxisTick',
                'Control',
                'CurrentPointer'
            ], function(name) {
                this['_render' + name](layoutInfo_1, mainGroup_1, axis_1, timelineModel);
            }, this);
            this._renderAxisLabel(layoutInfo_1, labelGroup, axis_1, timelineModel);
            this._position(layoutInfo_1, timelineModel);
        }
        this._doPlayStop();
        this._updateTicksStatus();
    };
    /**
   * @override
   */ SliderTimelineView.prototype.remove = function() {
        this._clearTimer();
        this.group.removeAll();
    };
    /**
   * @override
   */ SliderTimelineView.prototype.dispose = function() {
        this._clearTimer();
    };
    SliderTimelineView.prototype._layout = function(timelineModel, api) {
        var labelPosOpt = timelineModel.get([
            'label',
            'position'
        ]);
        var orient = timelineModel.get('orient');
        var viewRect = $aba52479ef639cd6$var$getViewRect(timelineModel, api);
        var parsedLabelPos;
        // Auto label offset.
        if (labelPosOpt == null || labelPosOpt === 'auto') parsedLabelPos = orient === 'horizontal' ? viewRect.y + viewRect.height / 2 < api.getHeight() / 2 ? '-' : '+' : viewRect.x + viewRect.width / 2 < api.getWidth() / 2 ? '+' : '-';
        else if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(labelPosOpt)) parsedLabelPos = ({
            horizontal: {
                top: '-',
                bottom: '+'
            },
            vertical: {
                left: '-',
                right: '+'
            }
        })[orient][labelPosOpt];
        else // is number
        parsedLabelPos = labelPosOpt;
        var labelAlignMap = {
            horizontal: 'center',
            vertical: parsedLabelPos >= 0 || parsedLabelPos === '+' ? 'left' : 'right'
        };
        var labelBaselineMap = {
            horizontal: parsedLabelPos >= 0 || parsedLabelPos === '+' ? 'top' : 'bottom',
            vertical: 'middle'
        };
        var rotationMap = {
            horizontal: 0,
            vertical: $aba52479ef639cd6$var$PI / 2
        };
        // Position
        var mainLength = orient === 'vertical' ? viewRect.height : viewRect.width;
        var controlModel = timelineModel.getModel('controlStyle');
        var showControl = controlModel.get('show', true);
        var controlSize = showControl ? controlModel.get('itemSize') : 0;
        var controlGap = showControl ? controlModel.get('itemGap') : 0;
        var sizePlusGap = controlSize + controlGap;
        // Special label rotate.
        var labelRotation = timelineModel.get([
            'label',
            'rotate'
        ]) || 0;
        labelRotation = labelRotation * $aba52479ef639cd6$var$PI / 180; // To radian.
        var playPosition;
        var prevBtnPosition;
        var nextBtnPosition;
        var controlPosition = controlModel.get('position', true);
        var showPlayBtn = showControl && controlModel.get('showPlayBtn', true);
        var showPrevBtn = showControl && controlModel.get('showPrevBtn', true);
        var showNextBtn = showControl && controlModel.get('showNextBtn', true);
        var xLeft = 0;
        var xRight = mainLength;
        // position[0] means left, position[1] means middle.
        if (controlPosition === 'left' || controlPosition === 'bottom') {
            showPlayBtn && (playPosition = [
                0,
                0
            ], xLeft += sizePlusGap);
            showPrevBtn && (prevBtnPosition = [
                xLeft,
                0
            ], xLeft += sizePlusGap);
            showNextBtn && (nextBtnPosition = [
                xRight - controlSize,
                0
            ], xRight -= sizePlusGap);
        } else {
            // 'top' 'right'
            showPlayBtn && (playPosition = [
                xRight - controlSize,
                0
            ], xRight -= sizePlusGap);
            showPrevBtn && (prevBtnPosition = [
                0,
                0
            ], xLeft += sizePlusGap);
            showNextBtn && (nextBtnPosition = [
                xRight - controlSize,
                0
            ], xRight -= sizePlusGap);
        }
        var axisExtent = [
            xLeft,
            xRight
        ];
        if (timelineModel.get('inverse')) axisExtent.reverse();
        return {
            viewRect: viewRect,
            mainLength: mainLength,
            orient: orient,
            rotation: rotationMap[orient],
            labelRotation: labelRotation,
            labelPosOpt: parsedLabelPos,
            labelAlign: timelineModel.get([
                'label',
                'align'
            ]) || labelAlignMap[orient],
            labelBaseline: timelineModel.get([
                'label',
                'verticalAlign'
            ]) || timelineModel.get([
                'label',
                'baseline'
            ]) || labelBaselineMap[orient],
            // Based on mainGroup.
            playPosition: playPosition,
            prevBtnPosition: prevBtnPosition,
            nextBtnPosition: nextBtnPosition,
            axisExtent: axisExtent,
            controlSize: controlSize,
            controlGap: controlGap
        };
    };
    SliderTimelineView.prototype._position = function(layoutInfo, timelineModel) {
        // Position is be called finally, because bounding rect is needed for
        // adapt content to fill viewRect (auto adapt offset).
        // Timeline may be not all in the viewRect when 'offset' is specified
        // as a number, because it is more appropriate that label aligns at
        // 'offset' but not the other edge defined by viewRect.
        var mainGroup = this._mainGroup;
        var labelGroup = this._labelGroup;
        var viewRect = layoutInfo.viewRect;
        if (layoutInfo.orient === 'vertical') {
            // transform to horizontal, inverse rotate by left-top point.
            var m = $f41ebb9dd60b55b4$export$185802fd694ee1f5();
            var rotateOriginX = viewRect.x;
            var rotateOriginY = viewRect.y + viewRect.height;
            $f41ebb9dd60b55b4$export$d73ee8ef04f5226a(m, m, [
                -rotateOriginX,
                -rotateOriginY
            ]);
            $f41ebb9dd60b55b4$export$bb628a54ab399bc9(m, m, -$aba52479ef639cd6$var$PI / 2);
            $f41ebb9dd60b55b4$export$d73ee8ef04f5226a(m, m, [
                rotateOriginX,
                rotateOriginY
            ]);
            viewRect = viewRect.clone();
            viewRect.applyTransform(m);
        }
        var viewBound = getBound(viewRect);
        var mainBound = getBound(mainGroup.getBoundingRect());
        var labelBound = getBound(labelGroup.getBoundingRect());
        var mainPosition = [
            mainGroup.x,
            mainGroup.y
        ];
        var labelsPosition = [
            labelGroup.x,
            labelGroup.y
        ];
        labelsPosition[0] = mainPosition[0] = viewBound[0][0];
        var labelPosOpt = layoutInfo.labelPosOpt;
        if (labelPosOpt == null || (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(labelPosOpt)) {
            // '+' or '-'
            var mainBoundIdx = labelPosOpt === '+' ? 0 : 1;
            toBound(mainPosition, mainBound, viewBound, 1, mainBoundIdx);
            toBound(labelsPosition, labelBound, viewBound, 1, 1 - mainBoundIdx);
        } else {
            var mainBoundIdx = labelPosOpt >= 0 ? 0 : 1;
            toBound(mainPosition, mainBound, viewBound, 1, mainBoundIdx);
            labelsPosition[1] = mainPosition[1] + labelPosOpt;
        }
        mainGroup.setPosition(mainPosition);
        labelGroup.setPosition(labelsPosition);
        mainGroup.rotation = labelGroup.rotation = layoutInfo.rotation;
        setOrigin(mainGroup);
        setOrigin(labelGroup);
        function setOrigin(targetGroup) {
            targetGroup.originX = viewBound[0][0] - targetGroup.x;
            targetGroup.originY = viewBound[1][0] - targetGroup.y;
        }
        function getBound(rect) {
            // [[xmin, xmax], [ymin, ymax]]
            return [
                [
                    rect.x,
                    rect.x + rect.width
                ],
                [
                    rect.y,
                    rect.y + rect.height
                ]
            ];
        }
        function toBound(fromPos, from, to, dimIdx, boundIdx) {
            fromPos[dimIdx] += to[dimIdx][boundIdx] - from[dimIdx][boundIdx];
        }
    };
    SliderTimelineView.prototype._createAxis = function(layoutInfo, timelineModel) {
        var data = timelineModel.getData();
        var axisType = timelineModel.get('axisType');
        var scale = $aba52479ef639cd6$var$createScaleByModel(timelineModel, axisType);
        // Customize scale. The `tickValue` is `dataIndex`.
        scale.getTicks = function() {
            return data.mapArray([
                'value'
            ], function(value) {
                return {
                    value: value
                };
            });
        };
        var dataExtent = data.getDataExtent('value');
        scale.setExtent(dataExtent[0], dataExtent[1]);
        scale.calcNiceTicks();
        var axis = new (0, $d38633a847120ec8$export$2e2bcd8739ae039)('value', scale, layoutInfo.axisExtent, axisType);
        axis.model = timelineModel;
        return axis;
    };
    SliderTimelineView.prototype._createGroup = function(key) {
        var newGroup = this[key] = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        this.group.add(newGroup);
        return newGroup;
    };
    SliderTimelineView.prototype._renderAxisLine = function(layoutInfo, group, axis, timelineModel) {
        var axisExtent = axis.getExtent();
        if (!timelineModel.get([
            'lineStyle',
            'show'
        ])) return;
        var line = new $7a316ae5ceff7b27$export$2e2bcd8739ae039({
            shape: {
                x1: axisExtent[0],
                y1: 0,
                x2: axisExtent[1],
                y2: 0
            },
            style: (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
                lineCap: 'round'
            }, timelineModel.getModel('lineStyle').getLineStyle()),
            silent: true,
            z2: 1
        });
        group.add(line);
        var progressLine = this._progressLine = new $7a316ae5ceff7b27$export$2e2bcd8739ae039({
            shape: {
                x1: axisExtent[0],
                x2: this._currentPointer ? this._currentPointer.x : axisExtent[0],
                y1: 0,
                y2: 0
            },
            style: (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
                lineCap: 'round',
                lineWidth: line.style.lineWidth
            }, timelineModel.getModel([
                'progress',
                'lineStyle'
            ]).getLineStyle()),
            silent: true,
            z2: 1
        });
        group.add(progressLine);
    };
    SliderTimelineView.prototype._renderAxisTick = function(layoutInfo, group, axis, timelineModel) {
        var _this = this;
        var data = timelineModel.getData();
        // Show all ticks, despite ignoring strategy.
        var ticks = axis.scale.getTicks();
        this._tickSymbols = [];
        // The value is dataIndex, see the customized scale.
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(ticks, function(tick) {
            var tickCoord = axis.dataToCoord(tick.value);
            var itemModel = data.getItemModel(tick.value);
            var itemStyleModel = itemModel.getModel('itemStyle');
            var hoverStyleModel = itemModel.getModel([
                'emphasis',
                'itemStyle'
            ]);
            var progressStyleModel = itemModel.getModel([
                'progress',
                'itemStyle'
            ]);
            var symbolOpt = {
                x: tickCoord,
                y: 0,
                onclick: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(_this._changeTimeline, _this, tick.value)
            };
            var el = $aba52479ef639cd6$var$giveSymbol(itemModel, itemStyleModel, group, symbolOpt);
            el.ensureState('emphasis').style = hoverStyleModel.getItemStyle();
            el.ensureState('progress').style = progressStyleModel.getItemStyle();
            (0, $2bf82c0980125b62$export$5f393df0b5aee2e7)(el);
            var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el);
            if (itemModel.get('tooltip')) {
                ecData.dataIndex = tick.value;
                ecData.dataModel = timelineModel;
            } else ecData.dataIndex = ecData.dataModel = null;
            _this._tickSymbols.push(el);
        });
    };
    SliderTimelineView.prototype._renderAxisLabel = function(layoutInfo, group, axis, timelineModel) {
        var _this = this;
        var labelModel = axis.getLabelModel();
        if (!labelModel.get('show')) return;
        var data = timelineModel.getData();
        var labels = axis.getViewLabels();
        this._tickLabels = [];
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(labels, function(labelItem) {
            // The tickValue is dataIndex, see the customized scale.
            var dataIndex = labelItem.tickValue;
            var itemModel = data.getItemModel(dataIndex);
            var normalLabelModel = itemModel.getModel('label');
            var hoverLabelModel = itemModel.getModel([
                'emphasis',
                'label'
            ]);
            var progressLabelModel = itemModel.getModel([
                'progress',
                'label'
            ]);
            var tickCoord = axis.dataToCoord(labelItem.tickValue);
            var textEl = new $fe885cc21795562b$export$2e2bcd8739ae039({
                x: tickCoord,
                y: 0,
                rotation: layoutInfo.labelRotation - layoutInfo.rotation,
                onclick: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(_this._changeTimeline, _this, dataIndex),
                silent: false,
                style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(normalLabelModel, {
                    text: labelItem.formattedLabel,
                    align: layoutInfo.labelAlign,
                    verticalAlign: layoutInfo.labelBaseline
                })
            });
            textEl.ensureState('emphasis').style = (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(hoverLabelModel);
            textEl.ensureState('progress').style = (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(progressLabelModel);
            group.add(textEl);
            (0, $2bf82c0980125b62$export$5f393df0b5aee2e7)(textEl);
            $aba52479ef639cd6$var$labelDataIndexStore(textEl).dataIndex = dataIndex;
            _this._tickLabels.push(textEl);
        });
    };
    SliderTimelineView.prototype._renderControl = function(layoutInfo, group, axis, timelineModel) {
        var controlSize = layoutInfo.controlSize;
        var rotation = layoutInfo.rotation;
        var itemStyle = timelineModel.getModel('controlStyle').getItemStyle();
        var hoverStyle = timelineModel.getModel([
            'emphasis',
            'controlStyle'
        ]).getItemStyle();
        var playState = timelineModel.getPlayState();
        var inverse = timelineModel.get('inverse', true);
        makeBtn(layoutInfo.nextBtnPosition, 'next', (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._changeTimeline, this, inverse ? '-' : '+'));
        makeBtn(layoutInfo.prevBtnPosition, 'prev', (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._changeTimeline, this, inverse ? '+' : '-'));
        makeBtn(layoutInfo.playPosition, playState ? 'stop' : 'play', (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._handlePlayClick, this, !playState), true);
        function makeBtn(position, iconName, onclick, willRotate) {
            if (!position) return;
            var iconSize = (0, $6c308355c7107803$export$e8514cb5a5e2b40f)((0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(timelineModel.get([
                'controlStyle',
                iconName + 'BtnSize'
            ]), controlSize), controlSize);
            var rect = [
                0,
                -iconSize / 2,
                iconSize,
                iconSize
            ];
            var btn = $aba52479ef639cd6$var$makeControlIcon(timelineModel, iconName + 'Icon', rect, {
                x: position[0],
                y: position[1],
                originX: controlSize / 2,
                originY: 0,
                rotation: willRotate ? -rotation : 0,
                rectHover: true,
                style: itemStyle,
                onclick: onclick
            });
            btn.ensureState('emphasis').style = hoverStyle;
            group.add(btn);
            (0, $2bf82c0980125b62$export$5f393df0b5aee2e7)(btn);
        }
    };
    SliderTimelineView.prototype._renderCurrentPointer = function(layoutInfo, group, axis, timelineModel) {
        var data = timelineModel.getData();
        var currentIndex = timelineModel.getCurrentIndex();
        var pointerModel = data.getItemModel(currentIndex).getModel('checkpointStyle');
        var me = this;
        var callback = {
            onCreate: function(pointer) {
                pointer.draggable = true;
                pointer.drift = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(me._handlePointerDrag, me);
                pointer.ondragend = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(me._handlePointerDragend, me);
                $aba52479ef639cd6$var$pointerMoveTo(pointer, me._progressLine, currentIndex, axis, timelineModel, true);
            },
            onUpdate: function(pointer) {
                $aba52479ef639cd6$var$pointerMoveTo(pointer, me._progressLine, currentIndex, axis, timelineModel);
            }
        };
        // Reuse when exists, for animation and drag.
        this._currentPointer = $aba52479ef639cd6$var$giveSymbol(pointerModel, pointerModel, this._mainGroup, {}, this._currentPointer, callback);
    };
    SliderTimelineView.prototype._handlePlayClick = function(nextState) {
        this._clearTimer();
        this.api.dispatchAction({
            type: 'timelinePlayChange',
            playState: nextState,
            from: this.uid
        });
    };
    SliderTimelineView.prototype._handlePointerDrag = function(dx, dy, e) {
        this._clearTimer();
        this._pointerChangeTimeline([
            e.offsetX,
            e.offsetY
        ]);
    };
    SliderTimelineView.prototype._handlePointerDragend = function(e) {
        this._pointerChangeTimeline([
            e.offsetX,
            e.offsetY
        ], true);
    };
    SliderTimelineView.prototype._pointerChangeTimeline = function(mousePos, trigger) {
        var toCoord = this._toAxisCoord(mousePos)[0];
        var axis = this._axis;
        var axisExtent = $cfc1f3b422a3185f$export$debe6e778e0a6d32(axis.getExtent().slice());
        toCoord > axisExtent[1] && (toCoord = axisExtent[1]);
        toCoord < axisExtent[0] && (toCoord = axisExtent[0]);
        this._currentPointer.x = toCoord;
        this._currentPointer.markRedraw();
        var progressLine = this._progressLine;
        if (progressLine) {
            progressLine.shape.x2 = toCoord;
            progressLine.dirty();
        }
        var targetDataIndex = this._findNearestTick(toCoord);
        var timelineModel = this.model;
        if (trigger || targetDataIndex !== timelineModel.getCurrentIndex() && timelineModel.get('realtime')) this._changeTimeline(targetDataIndex);
    };
    SliderTimelineView.prototype._doPlayStop = function() {
        var _this = this;
        this._clearTimer();
        if (this.model.getPlayState()) this._timer = setTimeout(function() {
            // Do not cache
            var timelineModel = _this.model;
            _this._changeTimeline(timelineModel.getCurrentIndex() + (timelineModel.get('rewind', true) ? -1 : 1));
        }, this.model.get('playInterval'));
    };
    SliderTimelineView.prototype._toAxisCoord = function(vertex) {
        var trans = this._mainGroup.getLocalTransform();
        return $5b455ae6f843ac47$export$9f9dcb98c894b623(vertex, trans, true);
    };
    SliderTimelineView.prototype._findNearestTick = function(axisCoord) {
        var data = this.model.getData();
        var dist = Infinity;
        var targetDataIndex;
        var axis = this._axis;
        data.each([
            'value'
        ], function(value, dataIndex) {
            var coord = axis.dataToCoord(value);
            var d = Math.abs(coord - axisCoord);
            if (d < dist) {
                dist = d;
                targetDataIndex = dataIndex;
            }
        });
        return targetDataIndex;
    };
    SliderTimelineView.prototype._clearTimer = function() {
        if (this._timer) {
            clearTimeout(this._timer);
            this._timer = null;
        }
    };
    SliderTimelineView.prototype._changeTimeline = function(nextIndex) {
        var currentIndex = this.model.getCurrentIndex();
        if (nextIndex === '+') nextIndex = currentIndex + 1;
        else if (nextIndex === '-') nextIndex = currentIndex - 1;
        this.api.dispatchAction({
            type: 'timelineChange',
            currentIndex: nextIndex,
            from: this.uid
        });
    };
    SliderTimelineView.prototype._updateTicksStatus = function() {
        var currentIndex = this.model.getCurrentIndex();
        var tickSymbols = this._tickSymbols;
        var tickLabels = this._tickLabels;
        if (tickSymbols) for(var i = 0; i < tickSymbols.length; i++)tickSymbols && tickSymbols[i] && tickSymbols[i].toggleState('progress', i < currentIndex);
        if (tickLabels) for(var i = 0; i < tickLabels.length; i++)tickLabels && tickLabels[i] && tickLabels[i].toggleState('progress', $aba52479ef639cd6$var$labelDataIndexStore(tickLabels[i]).dataIndex <= currentIndex);
    };
    SliderTimelineView.type = 'timeline.slider';
    return SliderTimelineView;
}((0, $79b71ced407c5926$export$2e2bcd8739ae039));
function $aba52479ef639cd6$var$createScaleByModel(model, axisType) {
    axisType = axisType || model.get('type');
    if (axisType) switch(axisType){
        // Buildin scale
        case 'category':
            return new (0, $6e82606ec775d365$export$2e2bcd8739ae039)({
                ordinalMeta: model.getCategories(),
                extent: [
                    Infinity,
                    -Infinity
                ]
            });
        case 'time':
            return new (0, $7729d7ac367e621c$export$2e2bcd8739ae039)({
                locale: model.ecModel.getLocaleModel(),
                useUTC: model.ecModel.get('useUTC')
            });
        default:
            // default to be value
            return new (0, $dddb89ade16db3d5$export$2e2bcd8739ae039)();
    }
}
function $aba52479ef639cd6$var$getViewRect(model, api) {
    return $93b9bc7f22ac7369$export$4517a5ca639a7293(model.getBoxLayoutParams(), {
        width: api.getWidth(),
        height: api.getHeight()
    }, model.get('padding'));
}
function $aba52479ef639cd6$var$makeControlIcon(timelineModel, objPath, rect, opts) {
    var style = opts.style;
    var icon = $5b455ae6f843ac47$export$274edc73af1ae9c8(timelineModel.get([
        'controlStyle',
        objPath
    ]), opts || {}, new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(rect[0], rect[1], rect[2], rect[3]));
    // TODO createIcon won't use style in opt.
    if (style) icon.setStyle(style);
    return icon;
}
/**
 * Create symbol or update symbol
 * opt: basic position and event handlers
 */ function $aba52479ef639cd6$var$giveSymbol(hostModel, itemStyleModel, group, opt, symbol, callback) {
    var color = itemStyleModel.get('color');
    if (!symbol) {
        var symbolType = hostModel.get('symbol');
        symbol = (0, $5370466dadc978d7$export$af050e04da3a02e8)(symbolType, -1, -1, 2, 2, color);
        symbol.setStyle('strokeNoScale', true);
        group.add(symbol);
        callback && callback.onCreate(symbol);
    } else {
        symbol.setColor(color);
        group.add(symbol); // Group may be new, also need to add.
        callback && callback.onUpdate(symbol);
    }
    // Style
    var itemStyle = itemStyleModel.getItemStyle([
        'color'
    ]);
    symbol.setStyle(itemStyle);
    // Transform and events.
    opt = (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)({
        rectHover: true,
        z2: 100
    }, opt, true);
    var symbolSize = (0, $5370466dadc978d7$export$a84524f03e8e8dfb)(hostModel.get('symbolSize'));
    opt.scaleX = symbolSize[0] / 2;
    opt.scaleY = symbolSize[1] / 2;
    var symbolOffset = (0, $5370466dadc978d7$export$e3e292895c033f6d)(hostModel.get('symbolOffset'), symbolSize);
    if (symbolOffset) {
        opt.x = (opt.x || 0) + symbolOffset[0];
        opt.y = (opt.y || 0) + symbolOffset[1];
    }
    var symbolRotate = hostModel.get('symbolRotate');
    opt.rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
    symbol.attr(opt);
    // FIXME
    // (1) When symbol.style.strokeNoScale is true and updateTransform is not performed,
    // getBoundingRect will return wrong result.
    // (This is supposed to be resolved in zrender, but it is a little difficult to
    // leverage performance and auto updateTransform)
    // (2) All of ancesters of symbol do not scale, so we can just updateTransform symbol.
    symbol.updateTransform();
    return symbol;
}
function $aba52479ef639cd6$var$pointerMoveTo(pointer, progressLine, dataIndex, axis, timelineModel, noAnimation) {
    if (pointer.dragging) return;
    var pointerModel = timelineModel.getModel('checkpointStyle');
    var toCoord = axis.dataToCoord(timelineModel.getData().get('value', dataIndex));
    if (noAnimation || !pointerModel.get('animation', true)) {
        pointer.attr({
            x: toCoord,
            y: 0
        });
        progressLine && progressLine.attr({
            shape: {
                x2: toCoord
            }
        });
    } else {
        var animationCfg = {
            duration: pointerModel.get('animationDuration', true),
            easing: pointerModel.get('animationEasing', true)
        };
        pointer.stopAnimation(null, true);
        pointer.animateTo({
            x: toCoord,
            y: 0
        }, animationCfg);
        progressLine && progressLine.animateTo({
            shape: {
                x2: toCoord
            }
        }, animationCfg);
    }
}
var $aba52479ef639cd6$export$2e2bcd8739ae039 = $aba52479ef639cd6$var$SliderTimelineView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $001a2b3d09da4e02$export$780c34b7cfe44e86(registers) {
    registers.registerAction({
        type: 'timelineChange',
        event: 'timelineChanged',
        update: 'prepareAndUpdate'
    }, function(payload, ecModel, api) {
        var timelineModel = ecModel.getComponent('timeline');
        if (timelineModel && payload.currentIndex != null) {
            timelineModel.setCurrentIndex(payload.currentIndex);
            if (!timelineModel.get('loop', true) && timelineModel.isIndexMax() && timelineModel.getPlayState()) {
                timelineModel.setPlayState(false);
                // The timeline has played to the end, trigger event
                api.dispatchAction({
                    type: 'timelinePlayChange',
                    playState: false,
                    from: payload.from
                });
            }
        }
        // Set normalized currentIndex to payload.
        ecModel.resetOption('timeline', {
            replaceMerge: timelineModel.get('replaceMerge', true)
        });
        return (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
            currentIndex: timelineModel.option.currentIndex
        }, payload);
    });
    registers.registerAction({
        type: 'timelinePlayChange',
        event: 'timelinePlayChanged',
        update: 'update'
    }, function(payload, ecModel) {
        var timelineModel = ecModel.getComponent('timeline');
        if (timelineModel && payload.playState != null) timelineModel.setPlayState(payload.playState);
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // @ts-nocheck

function $a77b6788fc89e6e1$export$2e2bcd8739ae039(option) {
    var timelineOpt = option && option.timeline;
    if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(timelineOpt)) timelineOpt = timelineOpt ? [
        timelineOpt
    ] : [];
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(timelineOpt, function(opt) {
        if (!opt) return;
        $a77b6788fc89e6e1$var$compatibleEC2(opt);
    });
}
function $a77b6788fc89e6e1$var$compatibleEC2(opt) {
    var type = opt.type;
    var ec2Types = {
        'number': 'value',
        'time': 'time'
    };
    // Compatible with ec2
    if (ec2Types[type]) {
        opt.axisType = ec2Types[type];
        delete opt.type;
    }
    $a77b6788fc89e6e1$var$transferItem(opt);
    if ($a77b6788fc89e6e1$var$has(opt, 'controlPosition')) {
        var controlStyle = opt.controlStyle || (opt.controlStyle = {});
        if (!$a77b6788fc89e6e1$var$has(controlStyle, 'position')) controlStyle.position = opt.controlPosition;
        if (controlStyle.position === 'none' && !$a77b6788fc89e6e1$var$has(controlStyle, 'show')) {
            controlStyle.show = false;
            delete controlStyle.position;
        }
        delete opt.controlPosition;
    }
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(opt.data || [], function(dataItem) {
        if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(dataItem) && !$7a1bd9c2710fea0d$export$43bee75e5e14138e(dataItem)) {
            if (!$a77b6788fc89e6e1$var$has(dataItem, 'value') && $a77b6788fc89e6e1$var$has(dataItem, 'name')) // In ec2, using name as value.
            dataItem.value = dataItem.name;
            $a77b6788fc89e6e1$var$transferItem(dataItem);
        }
    });
}
function $a77b6788fc89e6e1$var$transferItem(opt) {
    var itemStyle = opt.itemStyle || (opt.itemStyle = {});
    var itemStyleEmphasis = itemStyle.emphasis || (itemStyle.emphasis = {});
    // Transfer label out
    var label = opt.label || opt.label || {};
    var labelNormal = label.normal || (label.normal = {});
    var excludeLabelAttr = {
        normal: 1,
        emphasis: 1
    };
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(label, function(value, name) {
        if (!excludeLabelAttr[name] && !$a77b6788fc89e6e1$var$has(labelNormal, name)) labelNormal[name] = value;
    });
    if (itemStyleEmphasis.label && !$a77b6788fc89e6e1$var$has(label, 'emphasis')) {
        label.emphasis = itemStyleEmphasis.label;
        delete itemStyleEmphasis.label;
    }
}
function $a77b6788fc89e6e1$var$has(obj, attr) {
    return obj.hasOwnProperty(attr);
}


function $d41f79c5664eb934$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $22b93c2a0cce341f$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $aba52479ef639cd6$export$2e2bcd8739ae039));
    registers.registerSubTypeDefaulter('timeline', function() {
        // Only slider now.
        return 'slider';
    });
    (0, $001a2b3d09da4e02$export$780c34b7cfe44e86)(registers);
    registers.registerPreprocessor((0, $a77b6788fc89e6e1$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 








var $66707465bee49836$var$TitleModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(TitleModel, _super);
    function TitleModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TitleModel.type;
        _this.layoutMode = {
            type: 'box',
            ignoreSize: true
        };
        return _this;
    }
    TitleModel.type = 'title';
    TitleModel.defaultOption = {
        // zlevel: 0,
        z: 6,
        show: true,
        text: '',
        target: 'blank',
        subtext: '',
        subtarget: 'blank',
        left: 0,
        top: 0,
        backgroundColor: 'rgba(0,0,0,0)',
        borderColor: '#ccc',
        borderWidth: 0,
        padding: 5,
        itemGap: 10,
        textStyle: {
            fontSize: 18,
            fontWeight: 'bold',
            color: '#464646'
        },
        subtextStyle: {
            fontSize: 12,
            color: '#6E7079'
        }
    };
    return TitleModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
// View
var $66707465bee49836$var$TitleView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(TitleView, _super);
    function TitleView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TitleView.type;
        return _this;
    }
    TitleView.prototype.render = function(titleModel, ecModel, api) {
        this.group.removeAll();
        if (!titleModel.get('show')) return;
        var group = this.group;
        var textStyleModel = titleModel.getModel('textStyle');
        var subtextStyleModel = titleModel.getModel('subtextStyle');
        var textAlign = titleModel.get('textAlign');
        var textVerticalAlign = $7a1bd9c2710fea0d$export$995e01f2f5c9d030(titleModel.get('textBaseline'), titleModel.get('textVerticalAlign'));
        var textEl = new $fe885cc21795562b$export$2e2bcd8739ae039({
            style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(textStyleModel, {
                text: titleModel.get('text'),
                fill: textStyleModel.getTextColor()
            }, {
                disableBox: true
            }),
            z2: 10
        });
        var textRect = textEl.getBoundingRect();
        var subText = titleModel.get('subtext');
        var subTextEl = new $fe885cc21795562b$export$2e2bcd8739ae039({
            style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(subtextStyleModel, {
                text: subText,
                fill: subtextStyleModel.getTextColor(),
                y: textRect.height + titleModel.get('itemGap'),
                verticalAlign: 'top'
            }, {
                disableBox: true
            }),
            z2: 10
        });
        var link = titleModel.get('link');
        var sublink = titleModel.get('sublink');
        var triggerEvent = titleModel.get('triggerEvent', true);
        textEl.silent = !link && !triggerEvent;
        subTextEl.silent = !sublink && !triggerEvent;
        if (link) textEl.on('click', function() {
            (0, $c84c9521536c601a$export$13e13f9b96dbe8fa)(link, '_' + titleModel.get('target'));
        });
        if (sublink) subTextEl.on('click', function() {
            (0, $c84c9521536c601a$export$13e13f9b96dbe8fa)(sublink, '_' + titleModel.get('subtarget'));
        });
        (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(textEl).eventData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(subTextEl).eventData = triggerEvent ? {
            componentType: 'title',
            componentIndex: titleModel.componentIndex
        } : null;
        group.add(textEl);
        subText && group.add(subTextEl);
        // If no subText, but add subTextEl, there will be an empty line.
        var groupRect = group.getBoundingRect();
        var layoutOption = titleModel.getBoxLayoutParams();
        layoutOption.width = groupRect.width;
        layoutOption.height = groupRect.height;
        var layoutRect = (0, $93b9bc7f22ac7369$export$4517a5ca639a7293)(layoutOption, {
            width: api.getWidth(),
            height: api.getHeight()
        }, titleModel.get('padding'));
        // Adjust text align based on position
        if (!textAlign) {
            // Align left if title is on the left. center and right is same
            textAlign = titleModel.get('left') || titleModel.get('right');
            // @ts-ignore
            if (textAlign === 'middle') textAlign = 'center';
            // Adjust layout by text align
            if (textAlign === 'right') layoutRect.x += layoutRect.width;
            else if (textAlign === 'center') layoutRect.x += layoutRect.width / 2;
        }
        if (!textVerticalAlign) {
            textVerticalAlign = titleModel.get('top') || titleModel.get('bottom');
            // @ts-ignore
            if (textVerticalAlign === 'center') textVerticalAlign = 'middle';
            if (textVerticalAlign === 'bottom') layoutRect.y += layoutRect.height;
            else if (textVerticalAlign === 'middle') layoutRect.y += layoutRect.height / 2;
            textVerticalAlign = textVerticalAlign || 'top';
        }
        group.x = layoutRect.x;
        group.y = layoutRect.y;
        group.markRedraw();
        var alignStyle = {
            align: textAlign,
            verticalAlign: textVerticalAlign
        };
        textEl.setStyle(alignStyle);
        subTextEl.setStyle(alignStyle);
        // Render background
        // Get groupRect again because textAlign has been changed
        groupRect = group.getBoundingRect();
        var padding = layoutRect.margin;
        var style = titleModel.getItemStyle([
            'color',
            'opacity'
        ]);
        style.fill = titleModel.get('backgroundColor');
        var rect = new $419e5ff2f303755e$export$2e2bcd8739ae039({
            shape: {
                x: groupRect.x - padding[3],
                y: groupRect.y - padding[0],
                width: groupRect.width + padding[1] + padding[3],
                height: groupRect.height + padding[0] + padding[2],
                r: titleModel.get('borderRadius')
            },
            style: style,
            subPixelOptimize: true,
            silent: true
        });
        group.add(rect);
    };
    TitleView.type = 'title';
    return TitleView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
function $66707465bee49836$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel($66707465bee49836$var$TitleModel);
    registers.registerComponentView($66707465bee49836$var$TitleView);
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $4f28f1fbb9446d57$var$SelectDataZoomModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SelectDataZoomModel, _super);
    function SelectDataZoomModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SelectDataZoomModel.type;
        return _this;
    }
    SelectDataZoomModel.type = 'dataZoom.select';
    return SelectDataZoomModel;
}((0, $41d57478d16bff21$export$2e2bcd8739ae039));
var $4f28f1fbb9446d57$export$2e2bcd8739ae039 = $4f28f1fbb9446d57$var$SelectDataZoomModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $ee4d1f83b7568801$var$SelectDataZoomView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SelectDataZoomView, _super);
    function SelectDataZoomView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SelectDataZoomView.type;
        return _this;
    }
    SelectDataZoomView.type = 'dataZoom.select';
    return SelectDataZoomView;
}((0, $80d6a03162f25654$export$2e2bcd8739ae039));
var $ee4d1f83b7568801$export$2e2bcd8739ae039 = $ee4d1f83b7568801$var$SelectDataZoomView;



function $738a563bbc36032b$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $4f28f1fbb9446d57$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $ee4d1f83b7568801$export$2e2bcd8739ae039));
    (0, $8904ef10f452e35c$export$2e2bcd8739ae039)(registers);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $f3a05ea4ae929f91$var$ToolboxModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ToolboxModel, _super);
    function ToolboxModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ToolboxModel.type;
        return _this;
    }
    ToolboxModel.prototype.optionUpdated = function() {
        _super.prototype.optionUpdated.apply(this, arguments);
        var ecModel = this.ecModel;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(this.option.feature, function(featureOpt, featureName) {
            var Feature = $974ee7656e10f2d0$export$bba2e7bbd72e62e1(featureName);
            if (Feature) {
                if (Feature.getDefaultOption) Feature.defaultOption = Feature.getDefaultOption(ecModel);
                $7a1bd9c2710fea0d$export$4950aa0f605343fb(featureOpt, Feature.defaultOption);
            }
        });
    };
    ToolboxModel.type = 'toolbox';
    ToolboxModel.layoutMode = {
        type: 'box',
        ignoreSize: true
    };
    ToolboxModel.defaultOption = {
        show: true,
        z: 6,
        // zlevel: 0,
        orient: 'horizontal',
        left: 'right',
        top: 'top',
        // right
        // bottom
        backgroundColor: 'transparent',
        borderColor: '#ccc',
        borderRadius: 0,
        borderWidth: 0,
        padding: 5,
        itemSize: 15,
        itemGap: 8,
        showTitle: true,
        iconStyle: {
            borderColor: '#666',
            color: 'none'
        },
        emphasis: {
            iconStyle: {
                borderColor: '#3E98C5'
            }
        },
        // textStyle: {},
        // feature
        tooltip: {
            show: false,
            position: 'bottom'
        }
    };
    return ToolboxModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $f3a05ea4ae929f91$export$2e2bcd8739ae039 = $f3a05ea4ae929f91$var$ToolboxModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 












var $e0876f124cc8d5c9$var$ToolboxView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ToolboxView, _super);
    function ToolboxView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ToolboxView.prototype.render = function(toolboxModel, ecModel, api, payload) {
        var group = this.group;
        group.removeAll();
        if (!toolboxModel.get('show')) return;
        var itemSize = +toolboxModel.get('itemSize');
        var isVertical = toolboxModel.get('orient') === 'vertical';
        var featureOpts = toolboxModel.get('feature') || {};
        var features = this._features || (this._features = {});
        var featureNames = [];
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(featureOpts, function(opt, name) {
            featureNames.push(name);
        });
        new (0, $306d1c87baff8a10$export$2e2bcd8739ae039)(this._featureNames || [], featureNames).add(processFeature).update(processFeature).remove($7a1bd9c2710fea0d$export$c3095a23b368d1f2(processFeature, null)).execute();
        // Keep for diff.
        this._featureNames = featureNames;
        function processFeature(newIndex, oldIndex) {
            var featureName = featureNames[newIndex];
            var oldName = featureNames[oldIndex];
            var featureOpt = featureOpts[featureName];
            var featureModel = new (0, $6818646a97528290$export$2e2bcd8739ae039)(featureOpt, toolboxModel, toolboxModel.ecModel);
            var feature;
            // FIX#11236, merge feature title from MagicType newOption. TODO: consider seriesIndex ?
            if (payload && payload.newTitle != null && payload.featureName === featureName) featureOpt.title = payload.newTitle;
            if (featureName && !oldName) {
                // Create
                if ($e0876f124cc8d5c9$var$isUserFeatureName(featureName)) feature = {
                    onclick: featureModel.option.onclick,
                    featureName: featureName
                };
                else {
                    var Feature = (0, $974ee7656e10f2d0$export$bba2e7bbd72e62e1)(featureName);
                    if (!Feature) return;
                    feature = new Feature();
                }
                features[featureName] = feature;
            } else {
                feature = features[oldName];
                // If feature does not exist.
                if (!feature) return;
            }
            feature.uid = (0, $5370df662b2caf37$export$6d2b3473b0986646)('toolbox-feature');
            feature.model = featureModel;
            feature.ecModel = ecModel;
            feature.api = api;
            var isToolboxFeature = feature instanceof (0, $974ee7656e10f2d0$export$1426bfb1b0bcf539);
            if (!featureName && oldName) {
                isToolboxFeature && feature.dispose && feature.dispose(ecModel, api);
                return;
            }
            if (!featureModel.get('show') || isToolboxFeature && feature.unusable) {
                isToolboxFeature && feature.remove && feature.remove(ecModel, api);
                return;
            }
            createIconPaths(featureModel, feature, featureName);
            featureModel.setIconStatus = function(iconName, status) {
                var option = this.option;
                var iconPaths = this.iconPaths;
                option.iconStatus = option.iconStatus || {};
                option.iconStatus[iconName] = status;
                if (iconPaths[iconName]) (status === 'emphasis' ? (0, $2bf82c0980125b62$export$b2d02638cc34c042) : (0, $2bf82c0980125b62$export$11be6f716239ac55))(iconPaths[iconName]);
            };
            if (feature instanceof (0, $974ee7656e10f2d0$export$1426bfb1b0bcf539)) {
                if (feature.render) feature.render(featureModel, ecModel, api, payload);
            }
        }
        function createIconPaths(featureModel, feature, featureName) {
            var iconStyleModel = featureModel.getModel('iconStyle');
            var iconStyleEmphasisModel = featureModel.getModel([
                'emphasis',
                'iconStyle'
            ]);
            // If one feature has multiple icons, they are organized as
            // {
            //     icon: {
            //         foo: '',
            //         bar: ''
            //     },
            //     title: {
            //         foo: '',
            //         bar: ''
            //     }
            // }
            var icons = feature instanceof (0, $974ee7656e10f2d0$export$1426bfb1b0bcf539) && feature.getIcons ? feature.getIcons() : featureModel.get('icon');
            var titles = featureModel.get('title') || {};
            var iconsMap;
            var titlesMap;
            if ($7a1bd9c2710fea0d$export$844ec244b1367d54(icons)) {
                iconsMap = {};
                iconsMap[featureName] = icons;
            } else iconsMap = icons;
            if ($7a1bd9c2710fea0d$export$844ec244b1367d54(titles)) {
                titlesMap = {};
                titlesMap[featureName] = titles;
            } else titlesMap = titles;
            var iconPaths = featureModel.iconPaths = {};
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(iconsMap, function(iconStr, iconName) {
                var path = $5b455ae6f843ac47$export$274edc73af1ae9c8(iconStr, {}, {
                    x: -itemSize / 2,
                    y: -itemSize / 2,
                    width: itemSize,
                    height: itemSize
                }); // TODO handling image
                path.setStyle(iconStyleModel.getItemStyle());
                var pathEmphasisState = path.ensureState('emphasis');
                pathEmphasisState.style = iconStyleEmphasisModel.getItemStyle();
                // Text position calculation
                // TODO: extract `textStyle` from `iconStyle` and use `createTextStyle`
                var textContent = new (0, $fe885cc21795562b$export$2e2bcd8739ae039)({
                    style: {
                        text: titlesMap[iconName],
                        align: iconStyleEmphasisModel.get('textAlign'),
                        borderRadius: iconStyleEmphasisModel.get('textBorderRadius'),
                        padding: iconStyleEmphasisModel.get('textPadding'),
                        fill: null,
                        font: (0, $6800dfcb6e1e2a44$export$155316a870a9d61e)({
                            fontStyle: iconStyleEmphasisModel.get('textFontStyle'),
                            fontFamily: iconStyleEmphasisModel.get('textFontFamily'),
                            fontSize: iconStyleEmphasisModel.get('textFontSize'),
                            fontWeight: iconStyleEmphasisModel.get('textFontWeight')
                        }, ecModel)
                    },
                    ignore: true
                });
                path.setTextContent(textContent);
                $5b455ae6f843ac47$export$fc6410d97fab306c({
                    el: path,
                    componentModel: toolboxModel,
                    itemName: iconName,
                    formatterParamsExtra: {
                        title: titlesMap[iconName]
                    }
                });
                path.__title = titlesMap[iconName];
                path.on('mouseover', function() {
                    // Should not reuse above hoverStyle, which might be modified.
                    var hoverStyle = iconStyleEmphasisModel.getItemStyle();
                    var defaultTextPosition = isVertical ? toolboxModel.get('right') == null && toolboxModel.get('left') !== 'right' ? 'right' : 'left' : toolboxModel.get('bottom') == null && toolboxModel.get('top') !== 'bottom' ? 'bottom' : 'top';
                    textContent.setStyle({
                        fill: iconStyleEmphasisModel.get('textFill') || hoverStyle.fill || hoverStyle.stroke || '#000',
                        backgroundColor: iconStyleEmphasisModel.get('textBackgroundColor')
                    });
                    path.setTextConfig({
                        position: iconStyleEmphasisModel.get('textPosition') || defaultTextPosition
                    });
                    textContent.ignore = !toolboxModel.get('showTitle');
                    // Use enterEmphasis and leaveEmphasis provide by ec.
                    // There are flags managed by the echarts.
                    api.enterEmphasis(this);
                }).on('mouseout', function() {
                    if (featureModel.get([
                        'iconStatus',
                        iconName
                    ]) !== 'emphasis') api.leaveEmphasis(this);
                    textContent.hide();
                });
                (featureModel.get([
                    'iconStatus',
                    iconName
                ]) === 'emphasis' ? (0, $2bf82c0980125b62$export$b2d02638cc34c042) : (0, $2bf82c0980125b62$export$11be6f716239ac55))(path);
                group.add(path);
                path.on('click', $7a1bd9c2710fea0d$export$2385a24977818dd0(feature.onclick, feature, ecModel, api, iconName));
                iconPaths[iconName] = path;
            });
        }
        $40fca678c85406ff$export$b3219800bda33a1f(group, toolboxModel, api);
        // Render background after group is layout
        // FIXME
        group.add($40fca678c85406ff$export$fae23936eedfad4f(group.getBoundingRect(), toolboxModel));
        // Adjust icon title positions to avoid them out of screen
        isVertical || group.eachChild(function(icon) {
            var titleText = icon.__title;
            // const hoverStyle = icon.hoverStyle;
            // TODO simplify code?
            var emphasisState = icon.ensureState('emphasis');
            var emphasisTextConfig = emphasisState.textConfig || (emphasisState.textConfig = {});
            var textContent = icon.getTextContent();
            var emphasisTextState = textContent && textContent.ensureState('emphasis');
            // May be background element
            if (emphasisTextState && !$7a1bd9c2710fea0d$export$f6e2535fb5126e54(emphasisTextState) && titleText) {
                var emphasisTextStyle = emphasisTextState.style || (emphasisTextState.style = {});
                var rect = $6c308355c7107803$export$c381147bfed79d9f(titleText, (0, $fe885cc21795562b$export$2e2bcd8739ae039).makeFont(emphasisTextStyle));
                var offsetX = icon.x + group.x;
                var offsetY = icon.y + group.y + itemSize;
                var needPutOnTop = false;
                if (offsetY + rect.height > api.getHeight()) {
                    emphasisTextConfig.position = 'top';
                    needPutOnTop = true;
                }
                var topOffset = needPutOnTop ? -5 - rect.height : itemSize + 10;
                if (offsetX + rect.width / 2 > api.getWidth()) {
                    emphasisTextConfig.position = [
                        '100%',
                        topOffset
                    ];
                    emphasisTextStyle.align = 'right';
                } else if (offsetX - rect.width / 2 < 0) {
                    emphasisTextConfig.position = [
                        0,
                        topOffset
                    ];
                    emphasisTextStyle.align = 'left';
                }
            }
        });
    };
    ToolboxView.prototype.updateView = function(toolboxModel, ecModel, api, payload) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(this._features, function(feature) {
            feature instanceof (0, $974ee7656e10f2d0$export$1426bfb1b0bcf539) && feature.updateView && feature.updateView(feature.model, ecModel, api, payload);
        });
    };
    // updateLayout(toolboxModel, ecModel, api, payload) {
    //     zrUtil.each(this._features, function (feature) {
    //         feature.updateLayout && feature.updateLayout(feature.model, ecModel, api, payload);
    //     });
    // },
    ToolboxView.prototype.remove = function(ecModel, api) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(this._features, function(feature) {
            feature instanceof (0, $974ee7656e10f2d0$export$1426bfb1b0bcf539) && feature.remove && feature.remove(ecModel, api);
        });
        this.group.removeAll();
    };
    ToolboxView.prototype.dispose = function(ecModel, api) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(this._features, function(feature) {
            feature instanceof (0, $974ee7656e10f2d0$export$1426bfb1b0bcf539) && feature.dispose && feature.dispose(ecModel, api);
        });
    };
    ToolboxView.type = 'toolbox';
    return ToolboxView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
function $e0876f124cc8d5c9$var$isUserFeatureName(featureName) {
    return featureName.indexOf('my') === 0;
}
var $e0876f124cc8d5c9$export$2e2bcd8739ae039 = $e0876f124cc8d5c9$var$ToolboxView;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $1abd70fc7852729e$var$SaveAsImage = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SaveAsImage, _super);
    function SaveAsImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SaveAsImage.prototype.onclick = function(ecModel, api) {
        var model = this.model;
        var title = model.get('name') || ecModel.get('title.0.text') || 'echarts';
        var isSvg = api.getZr().painter.getType() === 'svg';
        var type = isSvg ? 'svg' : model.get('type', true) || 'png';
        var url = api.getConnectedDataURL({
            type: type,
            backgroundColor: model.get('backgroundColor', true) || ecModel.get('backgroundColor') || '#fff',
            connectedBackgroundColor: model.get('connectedBackgroundColor'),
            excludeComponents: model.get('excludeComponents'),
            pixelRatio: model.get('pixelRatio')
        });
        var browser = (0, $ce6dd58693a21851$export$2e2bcd8739ae039).browser;
        // Chrome, Firefox, New Edge
        if (typeof MouseEvent === 'function' && (browser.newEdge || !browser.ie && !browser.edge)) {
            var $a = document.createElement('a');
            $a.download = title + '.' + type;
            $a.target = '_blank';
            $a.href = url;
            var evt = new MouseEvent('click', {
                // some micro front-end framework， window maybe is a Proxy
                view: document.defaultView,
                bubbles: true,
                cancelable: false
            });
            $a.dispatchEvent(evt);
        } else // @ts-ignore
        if (window.navigator.msSaveOrOpenBlob || isSvg) {
            var parts = url.split(',');
            // data:[<mime type>][;charset=<charset>][;base64],<encoded data>
            var base64Encoded = parts[0].indexOf('base64') > -1;
            var bstr = isSvg ? decodeURIComponent(parts[1]) : parts[1];
            // only `atob` when the data uri is encoded with base64
            // otherwise, like `svg` data uri exported by zrender,
            // there will be an error, for it's not encoded with base64.
            // (just a url-encoded string through `encodeURIComponent`)
            base64Encoded && (bstr = window.atob(bstr));
            var filename = title + '.' + type;
            // @ts-ignore
            if (window.navigator.msSaveOrOpenBlob) {
                var n = bstr.length;
                var u8arr = new Uint8Array(n);
                while(n--)u8arr[n] = bstr.charCodeAt(n);
                var blob = new Blob([
                    u8arr
                ]); // @ts-ignore
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                var frame = document.createElement('iframe');
                document.body.appendChild(frame);
                var cw = frame.contentWindow;
                var doc = cw.document;
                doc.open('image/svg+xml', 'replace');
                doc.write(bstr);
                doc.close();
                cw.focus();
                doc.execCommand('SaveAs', true, filename);
                document.body.removeChild(frame);
            }
        } else {
            var lang = model.get('lang');
            var html = '<body style="margin:0;"><img src="' + url + '" style="max-width:100%;" title="' + (lang && lang[0] || '') + '" />' + '</body>';
            var tab = window.open();
            tab.document.write(html);
            tab.document.title = title;
        }
    };
    SaveAsImage.getDefaultOption = function(ecModel) {
        var defaultOption = {
            show: true,
            icon: 'M4.7,22.9L29.3,45.5L54.7,23.4M4.6,43.6L4.6,58L53.8,58L53.8,43.6M29.2,45.1L29.2,0',
            title: ecModel.getLocaleModel().get([
                'toolbox',
                'saveAsImage',
                'title'
            ]),
            type: 'png',
            // Default use option.backgroundColor
            // backgroundColor: '#fff',
            connectedBackgroundColor: '#fff',
            name: '',
            excludeComponents: [
                'toolbox'
            ],
            // use current pixel ratio of device by default
            // pixelRatio: 1,
            lang: ecModel.getLocaleModel().get([
                'toolbox',
                'saveAsImage',
                'lang'
            ])
        };
        return defaultOption;
    };
    return SaveAsImage;
}((0, $974ee7656e10f2d0$export$1426bfb1b0bcf539));
var $1abd70fc7852729e$export$2e2bcd8739ae039 = $1abd70fc7852729e$var$SaveAsImage;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $1a3c941566c70505$var$INNER_STACK_KEYWORD = '__ec_magicType_stack__';
var $1a3c941566c70505$var$ICON_TYPES = [
    'line',
    'bar',
    'stack'
];
// stack and tiled appears in pair for the title
var $1a3c941566c70505$var$TITLE_TYPES = [
    'line',
    'bar',
    'stack',
    'tiled'
];
var $1a3c941566c70505$var$radioTypes = [
    [
        'line',
        'bar'
    ],
    [
        'stack'
    ]
];
var $1a3c941566c70505$var$MagicType = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(MagicType, _super);
    function MagicType() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MagicType.prototype.getIcons = function() {
        var model = this.model;
        var availableIcons = model.get('icon');
        var icons = {};
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(model.get('type'), function(type) {
            if (availableIcons[type]) icons[type] = availableIcons[type];
        });
        return icons;
    };
    MagicType.getDefaultOption = function(ecModel) {
        var defaultOption = {
            show: true,
            type: [],
            // Icon group
            icon: {
                line: 'M4.1,28.9h7.1l9.3-22l7.4,38l9.7-19.7l3,12.8h14.9M4.1,58h51.4',
                bar: 'M6.7,22.9h10V48h-10V22.9zM24.9,13h10v35h-10V13zM43.2,2h10v46h-10V2zM3.1,58h53.7',
                // eslint-disable-next-line
                stack: 'M8.2,38.4l-8.4,4.1l30.6,15.3L60,42.5l-8.1-4.1l-21.5,11L8.2,38.4z M51.9,30l-8.1,4.2l-13.4,6.9l-13.9-6.9L8.2,30l-8.4,4.2l8.4,4.2l22.2,11l21.5-11l8.1-4.2L51.9,30z M51.9,21.7l-8.1,4.2L35.7,30l-5.3,2.8L24.9,30l-8.4-4.1l-8.3-4.2l-8.4,4.2L8.2,30l8.3,4.2l13.9,6.9l13.4-6.9l8.1-4.2l8.1-4.1L51.9,21.7zM30.4,2.2L-0.2,17.5l8.4,4.1l8.3,4.2l8.4,4.2l5.5,2.7l5.3-2.7l8.1-4.2l8.1-4.2l8.1-4.1L30.4,2.2z' // jshint ignore:line
            },
            // `line`, `bar`, `stack`, `tiled`
            title: ecModel.getLocaleModel().get([
                'toolbox',
                'magicType',
                'title'
            ]),
            option: {},
            seriesIndex: {}
        };
        return defaultOption;
    };
    MagicType.prototype.onclick = function(ecModel, api, type) {
        var model = this.model;
        var seriesIndex = model.get([
            'seriesIndex',
            type
        ]);
        // Not supported magicType
        if (!$1a3c941566c70505$var$seriesOptGenreator[type]) return;
        var newOption = {
            series: []
        };
        var generateNewSeriesTypes = function(seriesModel) {
            var seriesType = seriesModel.subType;
            var seriesId = seriesModel.id;
            var newSeriesOpt = $1a3c941566c70505$var$seriesOptGenreator[type](seriesType, seriesId, seriesModel, model);
            if (newSeriesOpt) {
                // PENDING If merge original option?
                $7a1bd9c2710fea0d$export$ebe90cb607ad99e(newSeriesOpt, seriesModel.option);
                newOption.series.push(newSeriesOpt);
            }
            // Modify boundaryGap
            var coordSys = seriesModel.coordinateSystem;
            if (coordSys && coordSys.type === 'cartesian2d' && (type === 'line' || type === 'bar')) {
                var categoryAxis = coordSys.getAxesByScale('ordinal')[0];
                if (categoryAxis) {
                    var axisDim = categoryAxis.dim;
                    var axisType = axisDim + 'Axis';
                    var axisModel = seriesModel.getReferringComponents(axisType, (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
                    var axisIndex = axisModel.componentIndex;
                    newOption[axisType] = newOption[axisType] || [];
                    for(var i = 0; i <= axisIndex; i++)newOption[axisType][axisIndex] = newOption[axisType][axisIndex] || {};
                    newOption[axisType][axisIndex].boundaryGap = type === 'bar';
                }
            }
        };
        $7a1bd9c2710fea0d$export$79b2f7037acddd43($1a3c941566c70505$var$radioTypes, function(radio) {
            if ($7a1bd9c2710fea0d$export$305f7d4e9d4624f2(radio, type) >= 0) $7a1bd9c2710fea0d$export$79b2f7037acddd43(radio, function(item) {
                model.setIconStatus(item, 'normal');
            });
        });
        model.setIconStatus(type, 'emphasis');
        ecModel.eachComponent({
            mainType: 'series',
            query: seriesIndex == null ? null : {
                seriesIndex: seriesIndex
            }
        }, generateNewSeriesTypes);
        var newTitle;
        var currentType = type;
        // Change title of stack
        if (type === 'stack') {
            // use titles in model instead of ecModel
            // as stack and tiled appears in pair, just flip them
            // no need of checking stack state
            newTitle = $7a1bd9c2710fea0d$export$4950aa0f605343fb({
                stack: model.option.title.tiled,
                tiled: model.option.title.stack
            }, model.option.title);
            if (model.get([
                'iconStatus',
                type
            ]) !== 'emphasis') currentType = 'tiled';
        }
        api.dispatchAction({
            type: 'changeMagicType',
            currentType: currentType,
            newOption: newOption,
            newTitle: newTitle,
            featureName: 'magicType'
        });
    };
    return MagicType;
}((0, $974ee7656e10f2d0$export$1426bfb1b0bcf539));
var $1a3c941566c70505$var$seriesOptGenreator = {
    'line': function(seriesType, seriesId, seriesModel, model) {
        if (seriesType === 'bar') return $7a1bd9c2710fea0d$export$4950aa0f605343fb({
            id: seriesId,
            type: 'line',
            // Preserve data related option
            data: seriesModel.get('data'),
            stack: seriesModel.get('stack'),
            markPoint: seriesModel.get('markPoint'),
            markLine: seriesModel.get('markLine')
        }, model.get([
            'option',
            'line'
        ]) || {}, true);
    },
    'bar': function(seriesType, seriesId, seriesModel, model) {
        if (seriesType === 'line') return $7a1bd9c2710fea0d$export$4950aa0f605343fb({
            id: seriesId,
            type: 'bar',
            // Preserve data related option
            data: seriesModel.get('data'),
            stack: seriesModel.get('stack'),
            markPoint: seriesModel.get('markPoint'),
            markLine: seriesModel.get('markLine')
        }, model.get([
            'option',
            'bar'
        ]) || {}, true);
    },
    'stack': function(seriesType, seriesId, seriesModel, model) {
        var isStack = seriesModel.get('stack') === $1a3c941566c70505$var$INNER_STACK_KEYWORD;
        if (seriesType === 'line' || seriesType === 'bar') {
            model.setIconStatus('stack', isStack ? 'normal' : 'emphasis');
            return $7a1bd9c2710fea0d$export$4950aa0f605343fb({
                id: seriesId,
                stack: isStack ? '' : $1a3c941566c70505$var$INNER_STACK_KEYWORD
            }, model.get([
                'option',
                'stack'
            ]) || {}, true);
        }
    }
};
// TODO: SELF REGISTERED.
$4d59907f44a2d0ad$export$408c24786cd729c6({
    type: 'changeMagicType',
    event: 'magicTypeChanged',
    update: 'prepareAndUpdate'
}, function(payload, ecModel) {
    ecModel.mergeOption(payload.newOption);
});
var $1a3c941566c70505$export$2e2bcd8739ae039 = $1a3c941566c70505$var$MagicType;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





/* global document */ var $c28a86c6c47fb2f6$var$BLOCK_SPLITER = new Array(60).join('-');
var $c28a86c6c47fb2f6$var$ITEM_SPLITER = '\t';
/**
 * Group series into two types
 *  1. on category axis, like line, bar
 *  2. others, like scatter, pie
 */ function $c28a86c6c47fb2f6$var$groupSeries(ecModel) {
    var seriesGroupByCategoryAxis = {};
    var otherSeries = [];
    var meta = [];
    ecModel.eachRawSeries(function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys && (coordSys.type === 'cartesian2d' || coordSys.type === 'polar')) {
            // TODO: TYPE Consider polar? Include polar may increase unecessary bundle size.
            var baseAxis = coordSys.getBaseAxis();
            if (baseAxis.type === 'category') {
                var key = baseAxis.dim + '_' + baseAxis.index;
                if (!seriesGroupByCategoryAxis[key]) {
                    seriesGroupByCategoryAxis[key] = {
                        categoryAxis: baseAxis,
                        valueAxis: coordSys.getOtherAxis(baseAxis),
                        series: []
                    };
                    meta.push({
                        axisDim: baseAxis.dim,
                        axisIndex: baseAxis.index
                    });
                }
                seriesGroupByCategoryAxis[key].series.push(seriesModel);
            } else otherSeries.push(seriesModel);
        } else otherSeries.push(seriesModel);
    });
    return {
        seriesGroupByCategoryAxis: seriesGroupByCategoryAxis,
        other: otherSeries,
        meta: meta
    };
}
/**
 * Assemble content of series on cateogory axis
 * @inner
 */ function $c28a86c6c47fb2f6$var$assembleSeriesWithCategoryAxis(groups) {
    var tables = [];
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(groups, function(group, key) {
        var categoryAxis = group.categoryAxis;
        var valueAxis = group.valueAxis;
        var valueAxisDim = valueAxis.dim;
        var headers = [
            ' '
        ].concat($7a1bd9c2710fea0d$export$871de8747c9eaa88(group.series, function(series) {
            return series.name;
        }));
        // @ts-ignore TODO Polar
        var columns = [
            categoryAxis.model.getCategories()
        ];
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(group.series, function(series) {
            var rawData = series.getRawData();
            columns.push(series.getRawData().mapArray(rawData.mapDimension(valueAxisDim), function(val) {
                return val;
            }));
        });
        // Assemble table content
        var lines = [
            headers.join($c28a86c6c47fb2f6$var$ITEM_SPLITER)
        ];
        for(var i = 0; i < columns[0].length; i++){
            var items = [];
            for(var j = 0; j < columns.length; j++)items.push(columns[j][i]);
            lines.push(items.join($c28a86c6c47fb2f6$var$ITEM_SPLITER));
        }
        tables.push(lines.join('\n'));
    });
    return tables.join('\n\n' + $c28a86c6c47fb2f6$var$BLOCK_SPLITER + '\n\n');
}
/**
 * Assemble content of other series
 */ function $c28a86c6c47fb2f6$var$assembleOtherSeries(series) {
    return $7a1bd9c2710fea0d$export$871de8747c9eaa88(series, function(series) {
        var data = series.getRawData();
        var lines = [
            series.name
        ];
        var vals = [];
        data.each(data.dimensions, function() {
            var argLen = arguments.length;
            var dataIndex = arguments[argLen - 1];
            var name = data.getName(dataIndex);
            for(var i = 0; i < argLen - 1; i++)vals[i] = arguments[i];
            lines.push((name ? name + $c28a86c6c47fb2f6$var$ITEM_SPLITER : '') + vals.join($c28a86c6c47fb2f6$var$ITEM_SPLITER));
        });
        return lines.join('\n');
    }).join('\n\n' + $c28a86c6c47fb2f6$var$BLOCK_SPLITER + '\n\n');
}
function $c28a86c6c47fb2f6$var$getContentFromModel(ecModel) {
    var result = $c28a86c6c47fb2f6$var$groupSeries(ecModel);
    return {
        value: $7a1bd9c2710fea0d$export$3dea766d36a8935f([
            $c28a86c6c47fb2f6$var$assembleSeriesWithCategoryAxis(result.seriesGroupByCategoryAxis),
            $c28a86c6c47fb2f6$var$assembleOtherSeries(result.other)
        ], function(str) {
            return !!str.replace(/[\n\t\s]/g, '');
        }).join('\n\n' + $c28a86c6c47fb2f6$var$BLOCK_SPLITER + '\n\n'),
        meta: result.meta
    };
}
function $c28a86c6c47fb2f6$var$trim(str) {
    return str.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
}
/**
 * If a block is tsv format
 */ function $c28a86c6c47fb2f6$var$isTSVFormat(block) {
    // Simple method to find out if a block is tsv format
    var firstLine = block.slice(0, block.indexOf('\n'));
    if (firstLine.indexOf($c28a86c6c47fb2f6$var$ITEM_SPLITER) >= 0) return true;
}
var $c28a86c6c47fb2f6$var$itemSplitRegex = new RegExp('[' + $c28a86c6c47fb2f6$var$ITEM_SPLITER + ']+', 'g');
/**
 * @param {string} tsv
 * @return {Object}
 */ function $c28a86c6c47fb2f6$var$parseTSVContents(tsv) {
    var tsvLines = tsv.split(/\n+/g);
    var headers = $c28a86c6c47fb2f6$var$trim(tsvLines.shift()).split($c28a86c6c47fb2f6$var$itemSplitRegex);
    var categories = [];
    var series = $7a1bd9c2710fea0d$export$871de8747c9eaa88(headers, function(header) {
        return {
            name: header,
            data: []
        };
    });
    for(var i = 0; i < tsvLines.length; i++){
        var items = $c28a86c6c47fb2f6$var$trim(tsvLines[i]).split($c28a86c6c47fb2f6$var$itemSplitRegex);
        categories.push(items.shift());
        for(var j = 0; j < items.length; j++)series[j] && (series[j].data[i] = items[j]);
    }
    return {
        series: series,
        categories: categories
    };
}
function $c28a86c6c47fb2f6$var$parseListContents(str) {
    var lines = str.split(/\n+/g);
    var seriesName = $c28a86c6c47fb2f6$var$trim(lines.shift());
    var data = [];
    for(var i = 0; i < lines.length; i++){
        // if line is empty, ignore it.
        // there is a case that a user forgot to delete `\n`.
        var line = $c28a86c6c47fb2f6$var$trim(lines[i]);
        if (!line) continue;
        var items = line.split($c28a86c6c47fb2f6$var$itemSplitRegex);
        var name_1 = '';
        var value = void 0;
        var hasName = false;
        if (isNaN(items[0])) {
            // First item is name
            hasName = true;
            name_1 = items[0];
            items = items.slice(1);
            data[i] = {
                name: name_1,
                value: []
            };
            value = data[i].value;
        } else value = data[i] = [];
        for(var j = 0; j < items.length; j++)value.push(+items[j]);
        if (value.length === 1) hasName ? data[i].value = value[0] : data[i] = value[0];
    }
    return {
        name: seriesName,
        data: data
    };
}
function $c28a86c6c47fb2f6$var$parseContents(str, blockMetaList) {
    var blocks = str.split(new RegExp('\n*' + $c28a86c6c47fb2f6$var$BLOCK_SPLITER + '\n*', 'g'));
    var newOption = {
        series: []
    };
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(blocks, function(block, idx) {
        if ($c28a86c6c47fb2f6$var$isTSVFormat(block)) {
            var result = $c28a86c6c47fb2f6$var$parseTSVContents(block);
            var blockMeta = blockMetaList[idx];
            var axisKey = blockMeta.axisDim + 'Axis';
            if (blockMeta) {
                newOption[axisKey] = newOption[axisKey] || [];
                newOption[axisKey][blockMeta.axisIndex] = {
                    data: result.categories
                };
                newOption.series = newOption.series.concat(result.series);
            }
        } else {
            var result = $c28a86c6c47fb2f6$var$parseListContents(block);
            newOption.series.push(result);
        }
    });
    return newOption;
}
var $c28a86c6c47fb2f6$var$DataView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(DataView, _super);
    function DataView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataView.prototype.onclick = function(ecModel, api) {
        // FIXME: better way?
        setTimeout(function() {
            api.dispatchAction({
                type: 'hideTip'
            });
        });
        var container = api.getDom();
        var model = this.model;
        if (this._dom) container.removeChild(this._dom);
        var root = document.createElement('div');
        // use padding to avoid 5px whitespace
        root.style.cssText = 'position:absolute;top:0;bottom:0;left:0;right:0;padding:5px';
        root.style.backgroundColor = model.get('backgroundColor') || '#fff';
        // Create elements
        var header = document.createElement('h4');
        var lang = model.get('lang') || [];
        header.innerHTML = lang[0] || model.get('title');
        header.style.cssText = 'margin:10px 20px';
        header.style.color = model.get('textColor');
        var viewMain = document.createElement('div');
        var textarea = document.createElement('textarea');
        viewMain.style.cssText = 'overflow:auto';
        var optionToContent = model.get('optionToContent');
        var contentToOption = model.get('contentToOption');
        var result = $c28a86c6c47fb2f6$var$getContentFromModel(ecModel);
        if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(optionToContent)) {
            var htmlOrDom = optionToContent(api.getOption());
            if ($7a1bd9c2710fea0d$export$844ec244b1367d54(htmlOrDom)) viewMain.innerHTML = htmlOrDom;
            else if ($7a1bd9c2710fea0d$export$9f57505b7bd8dae(htmlOrDom)) viewMain.appendChild(htmlOrDom);
        } else {
            // Use default textarea
            textarea.readOnly = model.get('readOnly');
            var style = textarea.style;
            // eslint-disable-next-line max-len
            style.cssText = 'display:block;width:100%;height:100%;font-family:monospace;font-size:14px;line-height:1.6rem;resize:none;box-sizing:border-box;outline:none';
            style.color = model.get('textColor');
            style.borderColor = model.get('textareaBorderColor');
            style.backgroundColor = model.get('textareaColor');
            textarea.value = result.value;
            viewMain.appendChild(textarea);
        }
        var blockMetaList = result.meta;
        var buttonContainer = document.createElement('div');
        buttonContainer.style.cssText = 'position:absolute;bottom:5px;left:0;right:0';
        // eslint-disable-next-line max-len
        var buttonStyle = 'float:right;margin-right:20px;border:none;cursor:pointer;padding:2px 5px;font-size:12px;border-radius:3px';
        var closeButton = document.createElement('div');
        var refreshButton = document.createElement('div');
        buttonStyle += ';background-color:' + model.get('buttonColor');
        buttonStyle += ';color:' + model.get('buttonTextColor');
        var self = this;
        function close() {
            container.removeChild(root);
            self._dom = null;
        }
        (0, $b3864a78637ff9ed$export$3f65cefe8380dbea)(closeButton, 'click', close);
        (0, $b3864a78637ff9ed$export$3f65cefe8380dbea)(refreshButton, 'click', function() {
            if (contentToOption == null && optionToContent != null || contentToOption != null && optionToContent == null) {
                close();
                return;
            }
            var newOption;
            try {
                if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(contentToOption)) newOption = contentToOption(viewMain, api.getOption());
                else newOption = $c28a86c6c47fb2f6$var$parseContents(textarea.value, blockMetaList);
            } catch (e) {
                close();
                throw new Error('Data view format error ' + e);
            }
            if (newOption) api.dispatchAction({
                type: 'changeDataView',
                newOption: newOption
            });
            close();
        });
        closeButton.innerHTML = lang[1];
        refreshButton.innerHTML = lang[2];
        refreshButton.style.cssText = closeButton.style.cssText = buttonStyle;
        !model.get('readOnly') && buttonContainer.appendChild(refreshButton);
        buttonContainer.appendChild(closeButton);
        root.appendChild(header);
        root.appendChild(viewMain);
        root.appendChild(buttonContainer);
        viewMain.style.height = container.clientHeight - 80 + 'px';
        container.appendChild(root);
        this._dom = root;
    };
    DataView.prototype.remove = function(ecModel, api) {
        this._dom && api.getDom().removeChild(this._dom);
    };
    DataView.prototype.dispose = function(ecModel, api) {
        this.remove(ecModel, api);
    };
    DataView.getDefaultOption = function(ecModel) {
        var defaultOption = {
            show: true,
            readOnly: false,
            optionToContent: null,
            contentToOption: null,
            // eslint-disable-next-line
            icon: 'M17.5,17.3H33 M17.5,17.3H33 M45.4,29.5h-28 M11.5,2v56H51V14.8L38.4,2H11.5z M38.4,2.2v12.7H51 M45.4,41.7h-28',
            title: ecModel.getLocaleModel().get([
                'toolbox',
                'dataView',
                'title'
            ]),
            lang: ecModel.getLocaleModel().get([
                'toolbox',
                'dataView',
                'lang'
            ]),
            backgroundColor: '#fff',
            textColor: '#000',
            textareaColor: '#fff',
            textareaBorderColor: '#333',
            buttonColor: '#c23531',
            buttonTextColor: '#fff'
        };
        return defaultOption;
    };
    return DataView;
}((0, $974ee7656e10f2d0$export$1426bfb1b0bcf539));
/**
 * @inner
 */ function $c28a86c6c47fb2f6$var$tryMergeDataOption(newData, originalData) {
    return $7a1bd9c2710fea0d$export$871de8747c9eaa88(newData, function(newVal, idx) {
        var original = originalData && originalData[idx];
        if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(original) && !$7a1bd9c2710fea0d$export$43bee75e5e14138e(original)) {
            var newValIsObject = $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(newVal) && !$7a1bd9c2710fea0d$export$43bee75e5e14138e(newVal);
            if (!newValIsObject) newVal = {
                value: newVal
            };
            // original data has name but new data has no name
            var shouldDeleteName = original.name != null && newVal.name == null;
            // Original data has option
            newVal = $7a1bd9c2710fea0d$export$ebe90cb607ad99e(newVal, original);
            shouldDeleteName && delete newVal.name;
            return newVal;
        } else return newVal;
    });
}
// TODO: SELF REGISTERED.
$4d59907f44a2d0ad$export$408c24786cd729c6({
    type: 'changeDataView',
    event: 'dataViewChanged',
    update: 'prepareAndUpdate'
}, function(payload, ecModel) {
    var newSeriesOptList = [];
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(payload.newOption.series, function(seriesOpt) {
        var seriesModel = ecModel.getSeriesByName(seriesOpt.name)[0];
        if (!seriesModel) // New created series
        // Geuss the series type
        newSeriesOptList.push($7a1bd9c2710fea0d$export$8b58be045bf06082({
            // Default is scatter
            type: 'scatter'
        }, seriesOpt));
        else {
            var originalData = seriesModel.get('data');
            newSeriesOptList.push({
                name: seriesOpt.name,
                data: $c28a86c6c47fb2f6$var$tryMergeDataOption(seriesOpt.data, originalData)
            });
        }
    });
    ecModel.mergeOption($7a1bd9c2710fea0d$export$ebe90cb607ad99e({
        series: newSeriesOptList
    }, payload.newOption));
});
var $c28a86c6c47fb2f6$export$2e2bcd8739ae039 = $c28a86c6c47fb2f6$var$DataView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $61ea33782638ccd3$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
var $61ea33782638ccd3$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $61ea33782638ccd3$export$4cbf152802aa238(ecModel, newSnapshot) {
    var storedSnapshots = $61ea33782638ccd3$var$getStoreSnapshots(ecModel);
    // If previous dataZoom can not be found,
    // complete an range with current range.
    $61ea33782638ccd3$var$each(newSnapshot, function(batchItem, dataZoomId) {
        var i = storedSnapshots.length - 1;
        for(; i >= 0; i--){
            var snapshot = storedSnapshots[i];
            if (snapshot[dataZoomId]) break;
        }
        if (i < 0) {
            // No origin range set, create one by current range.
            var dataZoomModel = ecModel.queryComponents({
                mainType: 'dataZoom',
                subType: 'select',
                id: dataZoomId
            })[0];
            if (dataZoomModel) {
                var percentRange = dataZoomModel.getPercentRange();
                storedSnapshots[0][dataZoomId] = {
                    dataZoomId: dataZoomId,
                    start: percentRange[0],
                    end: percentRange[1]
                };
            }
        }
    });
    storedSnapshots.push(newSnapshot);
}
function $61ea33782638ccd3$export$3e41007ebfff0e64(ecModel) {
    var storedSnapshots = $61ea33782638ccd3$var$getStoreSnapshots(ecModel);
    var head = storedSnapshots[storedSnapshots.length - 1];
    storedSnapshots.length > 1 && storedSnapshots.pop();
    // Find top for all dataZoom.
    var snapshot = {};
    $61ea33782638ccd3$var$each(head, function(batchItem, dataZoomId) {
        for(var i = storedSnapshots.length - 1; i >= 0; i--){
            batchItem = storedSnapshots[i][dataZoomId];
            if (batchItem) {
                snapshot[dataZoomId] = batchItem;
                break;
            }
        }
    });
    return snapshot;
}
function $61ea33782638ccd3$export$42ffd38884aecdac(ecModel) {
    $61ea33782638ccd3$var$inner(ecModel).snapshots = null;
}
function $61ea33782638ccd3$export$85b9a36db797e02b(ecModel) {
    return $61ea33782638ccd3$var$getStoreSnapshots(ecModel).length;
}
/**
 * History length of each dataZoom may be different.
 * this._history[0] is used to store origin range.
 */ function $61ea33782638ccd3$var$getStoreSnapshots(ecModel) {
    var store = $61ea33782638ccd3$var$inner(ecModel);
    if (!store.snapshots) store.snapshots = [
        {}
    ];
    return store.snapshots;
}



var $5719d35bf0243166$var$RestoreOption = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(RestoreOption, _super);
    function RestoreOption() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RestoreOption.prototype.onclick = function(ecModel, api) {
        $61ea33782638ccd3$export$42ffd38884aecdac(ecModel);
        api.dispatchAction({
            type: 'restore',
            from: this.uid
        });
    };
    RestoreOption.getDefaultOption = function(ecModel) {
        var defaultOption = {
            show: true,
            // eslint-disable-next-line
            icon: 'M3.8,33.4 M47,18.9h9.8V8.7 M56.3,20.1 C52.1,9,40.5,0.6,26.8,2.1C12.6,3.7,1.6,16.2,2.1,30.6 M13,41.1H3.1v10.2 M3.7,39.9c4.2,11.1,15.8,19.5,29.5,18 c14.2-1.6,25.2-14.1,24.7-28.5',
            title: ecModel.getLocaleModel().get([
                'toolbox',
                'restore',
                'title'
            ])
        };
        return defaultOption;
    };
    return RestoreOption;
}((0, $974ee7656e10f2d0$export$1426bfb1b0bcf539));
// TODO: SELF REGISTERED.
$4d59907f44a2d0ad$export$408c24786cd729c6({
    type: 'restore',
    event: 'restore',
    update: 'prepareAndUpdate'
}, function(payload, ecModel) {
    ecModel.resetOption('recreate');
});
var $5719d35bf0243166$export$2e2bcd8739ae039 = $5719d35bf0243166$var$RestoreOption;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 








var $d48e21e24ee5fc18$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
var $d48e21e24ee5fc18$var$DATA_ZOOM_ID_BASE = (0, $76d619f648247e6d$export$1753133c42e665e8)('toolbox-dataZoom_');
var $d48e21e24ee5fc18$var$ICON_TYPES = [
    'zoom',
    'back'
];
var $d48e21e24ee5fc18$var$DataZoomFeature = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(DataZoomFeature, _super);
    function DataZoomFeature() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataZoomFeature.prototype.render = function(featureModel, ecModel, api, payload) {
        if (!this._brushController) {
            this._brushController = new (0, $91342d1cfa622c5a$export$2e2bcd8739ae039)(api.getZr());
            this._brushController.on('brush', $7a1bd9c2710fea0d$export$2385a24977818dd0(this._onBrush, this)).mount();
        }
        $d48e21e24ee5fc18$var$updateZoomBtnStatus(featureModel, ecModel, this, payload, api);
        $d48e21e24ee5fc18$var$updateBackBtnStatus(featureModel, ecModel);
    };
    DataZoomFeature.prototype.onclick = function(ecModel, api, type) {
        $d48e21e24ee5fc18$var$handlers[type].call(this);
    };
    DataZoomFeature.prototype.remove = function(ecModel, api) {
        this._brushController && this._brushController.unmount();
    };
    DataZoomFeature.prototype.dispose = function(ecModel, api) {
        this._brushController && this._brushController.dispose();
    };
    DataZoomFeature.prototype._onBrush = function(eventParam) {
        var areas = eventParam.areas;
        if (!eventParam.isEnd || !areas.length) return;
        var snapshot = {};
        var ecModel = this.ecModel;
        this._brushController.updateCovers([]); // remove cover
        var brushTargetManager = new (0, $6213fed8aa63fab1$export$2e2bcd8739ae039)($d48e21e24ee5fc18$var$makeAxisFinder(this.model), ecModel, {
            include: [
                'grid'
            ]
        });
        brushTargetManager.matchOutputRanges(areas, ecModel, function(area, coordRange, coordSys) {
            if (coordSys.type !== 'cartesian2d') return;
            var brushType = area.brushType;
            if (brushType === 'rect') {
                setBatch('x', coordSys, coordRange[0]);
                setBatch('y', coordSys, coordRange[1]);
            } else setBatch({
                lineX: 'x',
                lineY: 'y'
            }[brushType], coordSys, coordRange);
        });
        $61ea33782638ccd3$export$4cbf152802aa238(ecModel, snapshot);
        this._dispatchZoomAction(snapshot);
        function setBatch(dimName, coordSys, minMax) {
            var axis = coordSys.getAxis(dimName);
            var axisModel = axis.model;
            var dataZoomModel = findDataZoom(dimName, axisModel, ecModel);
            // Restrict range.
            var minMaxSpan = dataZoomModel.findRepresentativeAxisProxy(axisModel).getMinMaxSpan();
            if (minMaxSpan.minValueSpan != null || minMaxSpan.maxValueSpan != null) minMax = (0, $00a8003b34293330$export$2e2bcd8739ae039)(0, minMax.slice(), axis.scale.getExtent(), 0, minMaxSpan.minValueSpan, minMaxSpan.maxValueSpan);
            dataZoomModel && (snapshot[dataZoomModel.id] = {
                dataZoomId: dataZoomModel.id,
                startValue: minMax[0],
                endValue: minMax[1]
            });
        }
        function findDataZoom(dimName, axisModel, ecModel) {
            var found;
            ecModel.eachComponent({
                mainType: 'dataZoom',
                subType: 'select'
            }, function(dzModel) {
                var has = dzModel.getAxisModel(dimName, axisModel.componentIndex);
                has && (found = dzModel);
            });
            return found;
        }
    };
    DataZoomFeature.prototype._dispatchZoomAction = function(snapshot) {
        var batch = [];
        // Convert from hash map to array.
        $d48e21e24ee5fc18$var$each(snapshot, function(batchItem, dataZoomId) {
            batch.push($7a1bd9c2710fea0d$export$9cd59f9826255e47(batchItem));
        });
        batch.length && this.api.dispatchAction({
            type: 'dataZoom',
            from: this.uid,
            batch: batch
        });
    };
    DataZoomFeature.getDefaultOption = function(ecModel) {
        var defaultOption = {
            show: true,
            filterMode: 'filter',
            // Icon group
            icon: {
                zoom: 'M0,13.5h26.9 M13.5,26.9V0 M32.1,13.5H58V58H13.5 V32.1',
                back: 'M22,1.4L9.9,13.5l12.3,12.3 M10.3,13.5H54.9v44.6 H10.3v-26'
            },
            // `zoom`, `back`
            title: ecModel.getLocaleModel().get([
                'toolbox',
                'dataZoom',
                'title'
            ]),
            brushStyle: {
                borderWidth: 0,
                color: 'rgba(210,219,238,0.2)'
            }
        };
        return defaultOption;
    };
    return DataZoomFeature;
}((0, $974ee7656e10f2d0$export$1426bfb1b0bcf539));
var $d48e21e24ee5fc18$var$handlers = {
    zoom: function() {
        var nextActive = !this._isZoomActive;
        this.api.dispatchAction({
            type: 'takeGlobalCursor',
            key: 'dataZoomSelect',
            dataZoomSelectActive: nextActive
        });
    },
    back: function() {
        this._dispatchZoomAction($61ea33782638ccd3$export$3e41007ebfff0e64(this.ecModel));
    }
};
function $d48e21e24ee5fc18$var$makeAxisFinder(dzFeatureModel) {
    var setting = {
        xAxisIndex: dzFeatureModel.get('xAxisIndex', true),
        yAxisIndex: dzFeatureModel.get('yAxisIndex', true),
        xAxisId: dzFeatureModel.get('xAxisId', true),
        yAxisId: dzFeatureModel.get('yAxisId', true)
    };
    // If both `xAxisIndex` `xAxisId` not set, it means 'all'.
    // If both `yAxisIndex` `yAxisId` not set, it means 'all'.
    // Some old cases set like this below to close yAxis control but leave xAxis control:
    // `{ feature: { dataZoom: { yAxisIndex: false } }`.
    if (setting.xAxisIndex == null && setting.xAxisId == null) setting.xAxisIndex = 'all';
    if (setting.yAxisIndex == null && setting.yAxisId == null) setting.yAxisIndex = 'all';
    return setting;
}
function $d48e21e24ee5fc18$var$updateBackBtnStatus(featureModel, ecModel) {
    featureModel.setIconStatus('back', $61ea33782638ccd3$export$85b9a36db797e02b(ecModel) > 1 ? 'emphasis' : 'normal');
}
function $d48e21e24ee5fc18$var$updateZoomBtnStatus(featureModel, ecModel, view, payload, api) {
    var zoomActive = view._isZoomActive;
    if (payload && payload.type === 'takeGlobalCursor') zoomActive = payload.key === 'dataZoomSelect' ? payload.dataZoomSelectActive : false;
    view._isZoomActive = zoomActive;
    featureModel.setIconStatus('zoom', zoomActive ? 'emphasis' : 'normal');
    var brushTargetManager = new (0, $6213fed8aa63fab1$export$2e2bcd8739ae039)($d48e21e24ee5fc18$var$makeAxisFinder(featureModel), ecModel, {
        include: [
            'grid'
        ]
    });
    var panels = brushTargetManager.makePanelOpts(api, function(targetInfo) {
        return targetInfo.xAxisDeclared && !targetInfo.yAxisDeclared ? 'lineX' : !targetInfo.xAxisDeclared && targetInfo.yAxisDeclared ? 'lineY' : 'rect';
    });
    view._brushController.setPanels(panels).enableBrush(zoomActive && panels.length ? {
        brushType: 'auto',
        brushStyle: featureModel.getModel('brushStyle').getItemStyle()
    } : false);
}
(0, $a625fe571efb4064$export$5a90be4668898d38)('dataZoom', function(ecModel) {
    var toolboxModel = ecModel.getComponent('toolbox', 0);
    var featureDataZoomPath = [
        'feature',
        'dataZoom'
    ];
    if (!toolboxModel || toolboxModel.get(featureDataZoomPath) == null) return;
    var dzFeatureModel = toolboxModel.getModel(featureDataZoomPath);
    var dzOptions = [];
    var finder = $d48e21e24ee5fc18$var$makeAxisFinder(dzFeatureModel);
    var finderResult = (0, $76d619f648247e6d$export$95de80076abac814)(ecModel, finder);
    $d48e21e24ee5fc18$var$each(finderResult.xAxisModels, function(axisModel) {
        return buildInternalOptions(axisModel, 'xAxis', 'xAxisIndex');
    });
    $d48e21e24ee5fc18$var$each(finderResult.yAxisModels, function(axisModel) {
        return buildInternalOptions(axisModel, 'yAxis', 'yAxisIndex');
    });
    function buildInternalOptions(axisModel, axisMainType, axisIndexPropName) {
        var axisIndex = axisModel.componentIndex;
        var newOpt = {
            type: 'select',
            $fromToolbox: true,
            // Default to be filter
            filterMode: dzFeatureModel.get('filterMode', true) || 'filter',
            // Id for merge mapping.
            id: $d48e21e24ee5fc18$var$DATA_ZOOM_ID_BASE + axisMainType + axisIndex
        };
        newOpt[axisIndexPropName] = axisIndex;
        dzOptions.push(newOpt);
    }
    return dzOptions;
});
var $d48e21e24ee5fc18$export$2e2bcd8739ae039 = $d48e21e24ee5fc18$var$DataZoomFeature;


function $db487da8ce0e4ca6$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $f3a05ea4ae929f91$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $e0876f124cc8d5c9$export$2e2bcd8739ae039));
    (0, $974ee7656e10f2d0$export$c6213a6f247cf906)('saveAsImage', (0, $1abd70fc7852729e$export$2e2bcd8739ae039));
    (0, $974ee7656e10f2d0$export$c6213a6f247cf906)('magicType', (0, $1a3c941566c70505$export$2e2bcd8739ae039));
    (0, $974ee7656e10f2d0$export$c6213a6f247cf906)('dataView', (0, $c28a86c6c47fb2f6$export$2e2bcd8739ae039));
    (0, $974ee7656e10f2d0$export$c6213a6f247cf906)('dataZoom', (0, $d48e21e24ee5fc18$export$2e2bcd8739ae039));
    (0, $974ee7656e10f2d0$export$c6213a6f247cf906)('restore', (0, $5719d35bf0243166$export$2e2bcd8739ae039));
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $738a563bbc36032b$export$4b3e715f166fdd78));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $310c8e7a9655a722$var$TooltipModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(TooltipModel, _super);
    function TooltipModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TooltipModel.type;
        return _this;
    }
    TooltipModel.type = 'tooltip';
    TooltipModel.dependencies = [
        'axisPointer'
    ];
    TooltipModel.defaultOption = {
        // zlevel: 0,
        z: 60,
        show: true,
        // tooltip main content
        showContent: true,
        // 'trigger' only works on coordinate system.
        // 'item' | 'axis' | 'none'
        trigger: 'item',
        // 'click' | 'mousemove' | 'none'
        triggerOn: 'mousemove|click',
        alwaysShowContent: false,
        displayMode: 'single',
        renderMode: 'auto',
        // whether restraint content inside viewRect.
        // If renderMode: 'richText', default true.
        // If renderMode: 'html', defaut false (for backward compat).
        confine: null,
        showDelay: 0,
        hideDelay: 100,
        // Animation transition time, unit is second
        transitionDuration: 0.4,
        enterable: false,
        backgroundColor: '#fff',
        // box shadow
        shadowBlur: 10,
        shadowColor: 'rgba(0, 0, 0, .2)',
        shadowOffsetX: 1,
        shadowOffsetY: 2,
        // tooltip border radius, unit is px, default is 4
        borderRadius: 4,
        // tooltip border width, unit is px, default is 0 (no border)
        borderWidth: 1,
        // Tooltip inside padding, default is 5 for all direction
        // Array is allowed to set up, right, bottom, left, same with css
        // The default value: See `tooltip/tooltipMarkup.ts#getPaddingFromTooltipModel`.
        padding: null,
        // Extra css text
        extraCssText: '',
        // axis indicator, trigger by axis
        axisPointer: {
            // default is line
            // legal values: 'line' | 'shadow' | 'cross'
            type: 'line',
            // Valid when type is line, appoint tooltip line locate on which line. Optional
            // legal values: 'x' | 'y' | 'angle' | 'radius' | 'auto'
            // default is 'auto', chose the axis which type is category.
            // for multiply y axis, cartesian coord chose x axis, polar chose angle axis
            axis: 'auto',
            animation: 'auto',
            animationDurationUpdate: 200,
            animationEasingUpdate: 'exponentialOut',
            crossStyle: {
                color: '#999',
                width: 1,
                type: 'dashed',
                // TODO formatter
                textStyle: {}
            }
        },
        textStyle: {
            color: '#666',
            fontSize: 14
        }
    };
    return TooltipModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $310c8e7a9655a722$export$2e2bcd8739ae039 = $310c8e7a9655a722$var$TooltipModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $c6d80cf697426e46$export$a309528050824ba4(tooltipModel) {
    var confineOption = tooltipModel.get('confine');
    return confineOption != null ? !!confineOption : tooltipModel.get('renderMode') === 'richText';
}
function $c6d80cf697426e46$var$testStyle(styleProps) {
    if (!(0, $ce6dd58693a21851$export$2e2bcd8739ae039).domSupported) return;
    var style = document.documentElement.style;
    for(var i = 0, len = styleProps.length; i < len; i++){
        if (styleProps[i] in style) return styleProps[i];
    }
}
var $c6d80cf697426e46$export$7b4286b1e4a23439 = $c6d80cf697426e46$var$testStyle([
    'transform',
    'webkitTransform',
    'OTransform',
    'MozTransform',
    'msTransform'
]);
var $c6d80cf697426e46$export$70a631ae991b5e76 = $c6d80cf697426e46$var$testStyle([
    'webkitTransition',
    'transition',
    'OTransition',
    'MozTransition',
    'msTransition'
]);
function $c6d80cf697426e46$export$5886acafe29a08d1(styleVendor, styleProp) {
    if (!styleVendor) return styleProp;
    styleProp = (0, $c84c9521536c601a$export$86f54f62aa7a7514)(styleProp, true);
    var idx = styleVendor.indexOf(styleProp);
    styleVendor = idx === -1 ? styleProp : "-" + styleVendor.slice(0, idx) + "-" + styleProp;
    return styleVendor.toLowerCase();
}
function $c6d80cf697426e46$export$3735103072e4a80(el, style) {
    var stl = el.currentStyle || document.defaultView && document.defaultView.getComputedStyle(el);
    return stl ? style ? stl[style] : stl : null;
}



/* global document, window */ var $501187a7e974c4e1$var$CSS_TRANSITION_VENDOR = (0, $c6d80cf697426e46$export$5886acafe29a08d1)((0, $c6d80cf697426e46$export$70a631ae991b5e76), 'transition');
var $501187a7e974c4e1$var$CSS_TRANSFORM_VENDOR = (0, $c6d80cf697426e46$export$5886acafe29a08d1)((0, $c6d80cf697426e46$export$7b4286b1e4a23439), 'transform');
// eslint-disable-next-line
var $501187a7e974c4e1$var$gCssText = "position:absolute;display:block;border-style:solid;white-space:nowrap;z-index:9999999;" + ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).transform3dSupported ? 'will-change:transform;' : '');
function $501187a7e974c4e1$var$mirrorPos(pos) {
    pos = pos === 'left' ? 'right' : pos === 'right' ? 'left' : pos === 'top' ? 'bottom' : 'top';
    return pos;
}
function $501187a7e974c4e1$var$assembleArrow(tooltipModel, borderColor, arrowPosition) {
    if (!(0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(arrowPosition) || arrowPosition === 'inside') return '';
    var backgroundColor = tooltipModel.get('backgroundColor');
    var borderWidth = tooltipModel.get('borderWidth');
    borderColor = (0, $c84c9521536c601a$export$cda04d03233e5555)(borderColor);
    var arrowPos = $501187a7e974c4e1$var$mirrorPos(arrowPosition);
    var arrowSize = Math.max(Math.round(borderWidth) * 1.5, 6);
    var positionStyle = '';
    var transformStyle = $501187a7e974c4e1$var$CSS_TRANSFORM_VENDOR + ':';
    var rotateDeg;
    if ((0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)([
        'left',
        'right'
    ], arrowPos) > -1) {
        positionStyle += 'top:50%';
        transformStyle += "translateY(-50%) rotate(" + (rotateDeg = arrowPos === 'left' ? -225 : -45) + "deg)";
    } else {
        positionStyle += 'left:50%';
        transformStyle += "translateX(-50%) rotate(" + (rotateDeg = arrowPos === 'top' ? 225 : 45) + "deg)";
    }
    var rotateRadian = rotateDeg * Math.PI / 180;
    var arrowWH = arrowSize + borderWidth;
    var rotatedWH = arrowWH * Math.abs(Math.cos(rotateRadian)) + arrowWH * Math.abs(Math.sin(rotateRadian));
    var arrowOffset = Math.round(((rotatedWH - Math.SQRT2 * borderWidth) / 2 + Math.SQRT2 * borderWidth - (rotatedWH - arrowWH) / 2) * 100) / 100;
    positionStyle += ";" + arrowPos + ":-" + arrowOffset + "px";
    var borderStyle = borderColor + " solid " + borderWidth + "px;";
    var styleCss = [
        "position:absolute;width:" + arrowSize + "px;height:" + arrowSize + "px;z-index:-1;",
        positionStyle + ";" + transformStyle + ";",
        "border-bottom:" + borderStyle,
        "border-right:" + borderStyle,
        "background-color:" + backgroundColor + ";"
    ];
    return "<div style=\"" + styleCss.join('') + "\"></div>";
}
function $501187a7e974c4e1$var$assembleTransition(duration, onlyFade) {
    var transitionCurve = 'cubic-bezier(0.23,1,0.32,1)';
    var transitionOption = " " + duration / 2 + "s " + transitionCurve;
    var transitionText = "opacity" + transitionOption + ",visibility" + transitionOption;
    if (!onlyFade) {
        transitionOption = " " + duration + "s " + transitionCurve;
        transitionText += (0, $ce6dd58693a21851$export$2e2bcd8739ae039).transformSupported ? "," + $501187a7e974c4e1$var$CSS_TRANSFORM_VENDOR + transitionOption : ",left" + transitionOption + ",top" + transitionOption;
    }
    return $501187a7e974c4e1$var$CSS_TRANSITION_VENDOR + ':' + transitionText;
}
function $501187a7e974c4e1$var$assembleTransform(x, y, toString) {
    // If using float on style, the final width of the dom might
    // keep changing slightly while mouse move. So `toFixed(0)` them.
    var x0 = x.toFixed(0) + 'px';
    var y0 = y.toFixed(0) + 'px';
    // not support transform, use `left` and `top` instead.
    if (!(0, $ce6dd58693a21851$export$2e2bcd8739ae039).transformSupported) return toString ? "top:" + y0 + ";left:" + x0 + ";" : [
        [
            'top',
            y0
        ],
        [
            'left',
            x0
        ]
    ];
    // support transform
    var is3d = (0, $ce6dd58693a21851$export$2e2bcd8739ae039).transform3dSupported;
    var translate = "translate" + (is3d ? '3d' : '') + "(" + x0 + "," + y0 + (is3d ? ',0' : '') + ")";
    return toString ? 'top:0;left:0;' + $501187a7e974c4e1$var$CSS_TRANSFORM_VENDOR + ':' + translate + ';' : [
        [
            'top',
            0
        ],
        [
            'left',
            0
        ],
        [
            (0, $c6d80cf697426e46$export$7b4286b1e4a23439),
            translate
        ]
    ];
}
/**
 * @param {Object} textStyle
 * @return {string}
 * @inner
 */ function $501187a7e974c4e1$var$assembleFont(textStyleModel) {
    var cssText = [];
    var fontSize = textStyleModel.get('fontSize');
    var color = textStyleModel.getTextColor();
    color && cssText.push('color:' + color);
    cssText.push('font:' + textStyleModel.getFont());
    // @ts-ignore, leave it to the tooltip refactor.
    var lineHeight = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(textStyleModel.get('lineHeight'), Math.round(fontSize * 3 / 2));
    fontSize && cssText.push('line-height:' + lineHeight + 'px');
    var shadowColor = textStyleModel.get('textShadowColor');
    var shadowBlur = textStyleModel.get('textShadowBlur') || 0;
    var shadowOffsetX = textStyleModel.get('textShadowOffsetX') || 0;
    var shadowOffsetY = textStyleModel.get('textShadowOffsetY') || 0;
    shadowColor && shadowBlur && cssText.push('text-shadow:' + shadowOffsetX + 'px ' + shadowOffsetY + 'px ' + shadowBlur + 'px ' + shadowColor);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
        'decoration',
        'align'
    ], function(name) {
        var val = textStyleModel.get(name);
        val && cssText.push('text-' + name + ':' + val);
    });
    return cssText.join(';');
}
function $501187a7e974c4e1$var$assembleCssText(tooltipModel, enableTransition, onlyFade) {
    var cssText = [];
    var transitionDuration = tooltipModel.get('transitionDuration');
    var backgroundColor = tooltipModel.get('backgroundColor');
    var shadowBlur = tooltipModel.get('shadowBlur');
    var shadowColor = tooltipModel.get('shadowColor');
    var shadowOffsetX = tooltipModel.get('shadowOffsetX');
    var shadowOffsetY = tooltipModel.get('shadowOffsetY');
    var textStyleModel = tooltipModel.getModel('textStyle');
    var padding = (0, $d5ab84c08d6657ec$export$3048212c802df496)(tooltipModel, 'html');
    var boxShadow = shadowOffsetX + "px " + shadowOffsetY + "px " + shadowBlur + "px " + shadowColor;
    cssText.push('box-shadow:' + boxShadow);
    // Animation transition. Do not animate when transitionDuration is 0.
    enableTransition && transitionDuration && cssText.push($501187a7e974c4e1$var$assembleTransition(transitionDuration, onlyFade));
    if (backgroundColor) cssText.push('background-color:' + backgroundColor);
    // Border style
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
        'width',
        'color',
        'radius'
    ], function(name) {
        var borderName = 'border-' + name;
        var camelCase = (0, $c84c9521536c601a$export$86f54f62aa7a7514)(borderName);
        var val = tooltipModel.get(camelCase);
        val != null && cssText.push(borderName + ':' + val + (name === 'color' ? '' : 'px'));
    });
    // Text style
    cssText.push($501187a7e974c4e1$var$assembleFont(textStyleModel));
    // Padding
    if (padding != null) cssText.push('padding:' + (0, $c84c9521536c601a$export$f3a38102c49f4268)(padding).join('px ') + 'px');
    return cssText.join(';') + ';';
}
// If not able to make, do not modify the input `out`.
function $501187a7e974c4e1$var$makeStyleCoord(out, zr, container, zrX, zrY) {
    var zrPainter = zr && zr.painter;
    if (container) {
        var zrViewportRoot = zrPainter && zrPainter.getViewportRoot();
        if (zrViewportRoot) // Some APPs might use scale on body, so we support CSS transform here.
        (0, $664e052f390bd76e$export$8c5c02e118307e20)(out, zrViewportRoot, container, zrX, zrY);
    } else {
        out[0] = zrX;
        out[1] = zrY;
        // xy should be based on canvas root. But tooltipContent is
        // the sibling of canvas root. So padding of ec container
        // should be considered here.
        var viewportRootOffset = zrPainter && zrPainter.getViewportRootOffset();
        if (viewportRootOffset) {
            out[0] += viewportRootOffset.offsetLeft;
            out[1] += viewportRootOffset.offsetTop;
        }
    }
    out[2] = out[0] / zr.getWidth();
    out[3] = out[1] / zr.getHeight();
}
var $501187a7e974c4e1$var$TooltipHTMLContent = /** @class */ function() {
    function TooltipHTMLContent(api, opt) {
        this._show = false;
        this._styleCoord = [
            0,
            0,
            0,
            0
        ];
        this._enterable = true;
        this._alwaysShowContent = false;
        this._firstShow = true;
        this._longHide = true;
        if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).wxa) return null;
        var el = document.createElement('div');
        // TODO: TYPE
        el.domBelongToZr = true;
        this.el = el;
        var zr = this._zr = api.getZr();
        var appendTo = opt.appendTo;
        var container = appendTo && ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(appendTo) ? document.querySelector(appendTo) : (0, $7a1bd9c2710fea0d$export$9f57505b7bd8dae)(appendTo) ? appendTo : (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(appendTo) && appendTo(api.getDom()));
        $501187a7e974c4e1$var$makeStyleCoord(this._styleCoord, zr, container, api.getWidth() / 2, api.getHeight() / 2);
        (container || api.getDom()).appendChild(el);
        this._api = api;
        this._container = container;
        // FIXME
        // Is it needed to trigger zr event manually if
        // the browser do not support `pointer-events: none`.
        var self = this;
        el.onmouseenter = function() {
            // clear the timeout in hideLater and keep showing tooltip
            if (self._enterable) {
                clearTimeout(self._hideTimeout);
                self._show = true;
            }
            self._inContent = true;
        };
        el.onmousemove = function(e) {
            e = e || window.event;
            if (!self._enterable) {
                // `pointer-events: none` is set to tooltip content div
                // if `enterable` is set as `false`, and `el.onmousemove`
                // can not be triggered. But in browser that do not
                // support `pointer-events`, we need to do this:
                // Try trigger zrender event to avoid mouse
                // in and out shape too frequently
                var handler = zr.handler;
                var zrViewportRoot = zr.painter.getViewportRoot();
                (0, $b3864a78637ff9ed$export$40fadb093aebad71)(zrViewportRoot, e, true);
                handler.dispatch('mousemove', e);
            }
        };
        el.onmouseleave = function() {
            // set `_inContent` to `false` before `hideLater`
            self._inContent = false;
            if (self._enterable) {
                if (self._show) self.hideLater(self._hideDelay);
            }
        };
    }
    /**
   * Update when tooltip is rendered
   */ TooltipHTMLContent.prototype.update = function(tooltipModel) {
        // FIXME
        // Move this logic to ec main?
        if (!this._container) {
            var container = this._api.getDom();
            var position = (0, $c6d80cf697426e46$export$3735103072e4a80)(container, 'position');
            var domStyle = container.style;
            if (domStyle.position !== 'absolute' && position !== 'absolute') domStyle.position = 'relative';
        }
        // move tooltip if chart resized
        var alwaysShowContent = tooltipModel.get('alwaysShowContent');
        alwaysShowContent && this._moveIfResized();
        // update alwaysShowContent
        this._alwaysShowContent = alwaysShowContent;
        // update className
        this.el.className = tooltipModel.get('className') || '';
    // Hide the tooltip
    // PENDING
    // this.hide();
    };
    TooltipHTMLContent.prototype.show = function(tooltipModel, nearPointColor) {
        clearTimeout(this._hideTimeout);
        clearTimeout(this._longHideTimeout);
        var el = this.el;
        var style = el.style;
        var styleCoord = this._styleCoord;
        if (!el.innerHTML) style.display = 'none';
        else style.cssText = $501187a7e974c4e1$var$gCssText + $501187a7e974c4e1$var$assembleCssText(tooltipModel, !this._firstShow, this._longHide) + $501187a7e974c4e1$var$assembleTransform(styleCoord[0], styleCoord[1], true) + ("border-color:" + (0, $c84c9521536c601a$export$cda04d03233e5555)(nearPointColor) + ";") + (tooltipModel.get('extraCssText') || '') + (";pointer-events:" + (this._enterable ? 'auto' : 'none'));
        this._show = true;
        this._firstShow = false;
        this._longHide = false;
    };
    TooltipHTMLContent.prototype.setContent = function(content, markers, tooltipModel, borderColor, arrowPosition) {
        var el = this.el;
        if (content == null) {
            el.innerHTML = '';
            return;
        }
        var arrow = '';
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(arrowPosition) && tooltipModel.get('trigger') === 'item' && !(0, $c6d80cf697426e46$export$a309528050824ba4)(tooltipModel)) arrow = $501187a7e974c4e1$var$assembleArrow(tooltipModel, borderColor, arrowPosition);
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(content)) el.innerHTML = content + arrow;
        else if (content) {
            // Clear previous
            el.innerHTML = '';
            if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(content)) content = [
                content
            ];
            for(var i = 0; i < content.length; i++)if ((0, $7a1bd9c2710fea0d$export$9f57505b7bd8dae)(content[i]) && content[i].parentNode !== el) el.appendChild(content[i]);
            // no arrow if empty
            if (arrow && el.childNodes.length) {
                // no need to create a new parent element, but it's not supported by IE 10 and older.
                // const arrowEl = document.createRange().createContextualFragment(arrow);
                var arrowEl = document.createElement('div');
                arrowEl.innerHTML = arrow;
                el.appendChild(arrowEl);
            }
        }
    };
    TooltipHTMLContent.prototype.setEnterable = function(enterable) {
        this._enterable = enterable;
    };
    TooltipHTMLContent.prototype.getSize = function() {
        var el = this.el;
        return el ? [
            el.offsetWidth,
            el.offsetHeight
        ] : [
            0,
            0
        ];
    };
    TooltipHTMLContent.prototype.moveTo = function(zrX, zrY) {
        if (!this.el) return;
        var styleCoord = this._styleCoord;
        $501187a7e974c4e1$var$makeStyleCoord(styleCoord, this._zr, this._container, zrX, zrY);
        if (styleCoord[0] != null && styleCoord[1] != null) {
            var style_1 = this.el.style;
            var transforms = $501187a7e974c4e1$var$assembleTransform(styleCoord[0], styleCoord[1]);
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(transforms, function(transform) {
                style_1[transform[0]] = transform[1];
            });
        }
    };
    /**
   * when `alwaysShowContent` is true,
   * move the tooltip after chart resized
   */ TooltipHTMLContent.prototype._moveIfResized = function() {
        // The ratio of left to width
        var ratioX = this._styleCoord[2];
        // The ratio of top to height
        var ratioY = this._styleCoord[3];
        this.moveTo(ratioX * this._zr.getWidth(), ratioY * this._zr.getHeight());
    };
    TooltipHTMLContent.prototype.hide = function() {
        var _this = this;
        var style = this.el.style;
        style.visibility = 'hidden';
        style.opacity = '0';
        (0, $ce6dd58693a21851$export$2e2bcd8739ae039).transform3dSupported && (style.willChange = '');
        this._show = false;
        this._longHideTimeout = setTimeout(function() {
            return _this._longHide = true;
        }, 500);
    };
    TooltipHTMLContent.prototype.hideLater = function(time) {
        if (this._show && !(this._inContent && this._enterable) && !this._alwaysShowContent) {
            if (time) {
                this._hideDelay = time;
                // Set show false to avoid invoke hideLater multiple times
                this._show = false;
                this._hideTimeout = setTimeout((0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this.hide, this), time);
            } else this.hide();
        }
    };
    TooltipHTMLContent.prototype.isShow = function() {
        return this._show;
    };
    TooltipHTMLContent.prototype.dispose = function() {
        clearTimeout(this._hideTimeout);
        clearTimeout(this._longHideTimeout);
        var parentNode = this.el.parentNode;
        parentNode && parentNode.removeChild(this.el);
        this.el = this._container = null;
    };
    return TooltipHTMLContent;
}();
var $501187a7e974c4e1$export$2e2bcd8739ae039 = $501187a7e974c4e1$var$TooltipHTMLContent;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $62f65ba5b769b0ae$var$TooltipRichContent = /** @class */ function() {
    function TooltipRichContent(api) {
        this._show = false;
        this._styleCoord = [
            0,
            0,
            0,
            0
        ];
        this._alwaysShowContent = false;
        this._enterable = true;
        this._zr = api.getZr();
        $62f65ba5b769b0ae$var$makeStyleCoord(this._styleCoord, this._zr, api.getWidth() / 2, api.getHeight() / 2);
    }
    /**
   * Update when tooltip is rendered
   */ TooltipRichContent.prototype.update = function(tooltipModel) {
        var alwaysShowContent = tooltipModel.get('alwaysShowContent');
        alwaysShowContent && this._moveIfResized();
        // update alwaysShowContent
        this._alwaysShowContent = alwaysShowContent;
    };
    TooltipRichContent.prototype.show = function() {
        if (this._hideTimeout) clearTimeout(this._hideTimeout);
        this.el.show();
        this._show = true;
    };
    /**
   * Set tooltip content
   */ TooltipRichContent.prototype.setContent = function(content, markupStyleCreator, tooltipModel, borderColor, arrowPosition) {
        var _this = this;
        if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(content)) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)('');
        if (this.el) this._zr.remove(this.el);
        var textStyleModel = tooltipModel.getModel('textStyle');
        this.el = new (0, $fe885cc21795562b$export$2e2bcd8739ae039)({
            style: {
                rich: markupStyleCreator.richTextStyles,
                text: content,
                lineHeight: 22,
                borderWidth: 1,
                borderColor: borderColor,
                textShadowColor: textStyleModel.get('textShadowColor'),
                fill: tooltipModel.get([
                    'textStyle',
                    'color'
                ]),
                padding: (0, $d5ab84c08d6657ec$export$3048212c802df496)(tooltipModel, 'richText'),
                verticalAlign: 'top',
                align: 'left'
            },
            z: tooltipModel.get('z')
        });
        $7a1bd9c2710fea0d$export$79b2f7037acddd43([
            'backgroundColor',
            'borderRadius',
            'shadowColor',
            'shadowBlur',
            'shadowOffsetX',
            'shadowOffsetY'
        ], function(propName) {
            _this.el.style[propName] = tooltipModel.get(propName);
        });
        $7a1bd9c2710fea0d$export$79b2f7037acddd43([
            'textShadowBlur',
            'textShadowOffsetX',
            'textShadowOffsetY'
        ], function(propName) {
            _this.el.style[propName] = textStyleModel.get(propName) || 0;
        });
        this._zr.add(this.el);
        var self = this;
        this.el.on('mouseover', function() {
            // clear the timeout in hideLater and keep showing tooltip
            if (self._enterable) {
                clearTimeout(self._hideTimeout);
                self._show = true;
            }
            self._inContent = true;
        });
        this.el.on('mouseout', function() {
            if (self._enterable) {
                if (self._show) self.hideLater(self._hideDelay);
            }
            self._inContent = false;
        });
    };
    TooltipRichContent.prototype.setEnterable = function(enterable) {
        this._enterable = enterable;
    };
    TooltipRichContent.prototype.getSize = function() {
        var el = this.el;
        var bounding = this.el.getBoundingRect();
        // bounding rect does not include shadow. For renderMode richText,
        // if overflow, it will be cut. So calculate them accurately.
        var shadowOuterSize = $62f65ba5b769b0ae$var$calcShadowOuterSize(el.style);
        return [
            bounding.width + shadowOuterSize.left + shadowOuterSize.right,
            bounding.height + shadowOuterSize.top + shadowOuterSize.bottom
        ];
    };
    TooltipRichContent.prototype.moveTo = function(x, y) {
        var el = this.el;
        if (el) {
            var styleCoord = this._styleCoord;
            $62f65ba5b769b0ae$var$makeStyleCoord(styleCoord, this._zr, x, y);
            x = styleCoord[0];
            y = styleCoord[1];
            var style = el.style;
            var borderWidth = $62f65ba5b769b0ae$var$mathMaxWith0(style.borderWidth || 0);
            var shadowOuterSize = $62f65ba5b769b0ae$var$calcShadowOuterSize(style);
            // rich text x, y do not include border.
            el.x = x + borderWidth + shadowOuterSize.left;
            el.y = y + borderWidth + shadowOuterSize.top;
            el.markRedraw();
        }
    };
    /**
   * when `alwaysShowContent` is true,
   * move the tooltip after chart resized
   */ TooltipRichContent.prototype._moveIfResized = function() {
        // The ratio of left to width
        var ratioX = this._styleCoord[2];
        // The ratio of top to height
        var ratioY = this._styleCoord[3];
        this.moveTo(ratioX * this._zr.getWidth(), ratioY * this._zr.getHeight());
    };
    TooltipRichContent.prototype.hide = function() {
        if (this.el) this.el.hide();
        this._show = false;
    };
    TooltipRichContent.prototype.hideLater = function(time) {
        if (this._show && !(this._inContent && this._enterable) && !this._alwaysShowContent) {
            if (time) {
                this._hideDelay = time;
                // Set show false to avoid invoke hideLater multiple times
                this._show = false;
                this._hideTimeout = setTimeout($7a1bd9c2710fea0d$export$2385a24977818dd0(this.hide, this), time);
            } else this.hide();
        }
    };
    TooltipRichContent.prototype.isShow = function() {
        return this._show;
    };
    TooltipRichContent.prototype.dispose = function() {
        this._zr.remove(this.el);
    };
    return TooltipRichContent;
}();
function $62f65ba5b769b0ae$var$mathMaxWith0(val) {
    return Math.max(0, val);
}
function $62f65ba5b769b0ae$var$calcShadowOuterSize(style) {
    var shadowBlur = $62f65ba5b769b0ae$var$mathMaxWith0(style.shadowBlur || 0);
    var shadowOffsetX = $62f65ba5b769b0ae$var$mathMaxWith0(style.shadowOffsetX || 0);
    var shadowOffsetY = $62f65ba5b769b0ae$var$mathMaxWith0(style.shadowOffsetY || 0);
    return {
        left: $62f65ba5b769b0ae$var$mathMaxWith0(shadowBlur - shadowOffsetX),
        right: $62f65ba5b769b0ae$var$mathMaxWith0(shadowBlur + shadowOffsetX),
        top: $62f65ba5b769b0ae$var$mathMaxWith0(shadowBlur - shadowOffsetY),
        bottom: $62f65ba5b769b0ae$var$mathMaxWith0(shadowBlur + shadowOffsetY)
    };
}
function $62f65ba5b769b0ae$var$makeStyleCoord(out, zr, zrX, zrY) {
    out[0] = zrX;
    out[1] = zrY;
    out[2] = out[0] / zr.getWidth();
    out[3] = out[1] / zr.getHeight();
}
var $62f65ba5b769b0ae$export$2e2bcd8739ae039 = $62f65ba5b769b0ae$var$TooltipRichContent;




















var $1b2ffe835052ab23$var$proxyRect = new (0, $419e5ff2f303755e$export$2e2bcd8739ae039)({
    shape: {
        x: -1,
        y: -1,
        width: 2,
        height: 2
    }
});
var $1b2ffe835052ab23$var$TooltipView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(TooltipView, _super);
    function TooltipView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TooltipView.type;
        return _this;
    }
    TooltipView.prototype.init = function(ecModel, api) {
        if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).node || !api.getDom()) return;
        var tooltipModel = ecModel.getComponent('tooltip');
        var renderMode = this._renderMode = (0, $76d619f648247e6d$export$cc0a17a5d27b4e17)(tooltipModel.get('renderMode'));
        this._tooltipContent = renderMode === 'richText' ? new (0, $62f65ba5b769b0ae$export$2e2bcd8739ae039)(api) : new (0, $501187a7e974c4e1$export$2e2bcd8739ae039)(api, {
            appendTo: tooltipModel.get('appendToBody', true) ? 'body' : tooltipModel.get('appendTo', true)
        });
    };
    TooltipView.prototype.render = function(tooltipModel, ecModel, api) {
        if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).node || !api.getDom()) return;
        // Reset
        this.group.removeAll();
        this._tooltipModel = tooltipModel;
        this._ecModel = ecModel;
        this._api = api;
        var tooltipContent = this._tooltipContent;
        tooltipContent.update(tooltipModel);
        tooltipContent.setEnterable(tooltipModel.get('enterable'));
        this._initGlobalListener();
        this._keepShow();
        // PENDING
        // `mousemove` event will be triggered very frequently when the mouse moves fast,
        // which causes that the `updatePosition` function was also called frequently.
        // In Chrome with devtools open and Firefox, tooltip looks laggy and shakes. See #14695 #16101
        // To avoid frequent triggering,
        // consider throttling it in 50ms when transition is enabled
        if (this._renderMode !== 'richText' && tooltipModel.get('transitionDuration')) (0, $c98659a9437a3d2e$export$958e3e1a02eac4b6)(this, '_updatePosition', 50, 'fixRate');
        else (0, $c98659a9437a3d2e$export$42ffd38884aecdac)(this, '_updatePosition');
    };
    TooltipView.prototype._initGlobalListener = function() {
        var tooltipModel = this._tooltipModel;
        var triggerOn = tooltipModel.get('triggerOn');
        $84450f5aa7fbde00$export$6503ec6e8aabbaf('itemTooltip', this._api, (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(function(currTrigger, e, dispatchAction) {
            // If 'none', it is not controlled by mouse totally.
            if (triggerOn !== 'none') {
                if (triggerOn.indexOf(currTrigger) >= 0) this._tryShow(e, dispatchAction);
                else if (currTrigger === 'leave') this._hide(dispatchAction);
            }
        }, this));
    };
    TooltipView.prototype._keepShow = function() {
        var tooltipModel = this._tooltipModel;
        var ecModel = this._ecModel;
        var api = this._api;
        var triggerOn = tooltipModel.get('triggerOn');
        // Try to keep the tooltip show when refreshing
        if (this._lastX != null && this._lastY != null && triggerOn !== 'none' && triggerOn !== 'click') {
            var self_1 = this;
            clearTimeout(this._refreshUpdateTimeout);
            this._refreshUpdateTimeout = setTimeout(function() {
                // Show tip next tick after other charts are rendered
                // In case highlight action has wrong result
                // FIXME
                !api.isDisposed() && self_1.manuallyShowTip(tooltipModel, ecModel, api, {
                    x: self_1._lastX,
                    y: self_1._lastY,
                    dataByCoordSys: self_1._lastDataByCoordSys
                });
            });
        }
    };
    /**
   * Show tip manually by
   * dispatchAction({
   *     type: 'showTip',
   *     x: 10,
   *     y: 10
   * });
   * Or
   * dispatchAction({
   *      type: 'showTip',
   *      seriesIndex: 0,
   *      dataIndex or dataIndexInside or name
   * });
   *
   *  TODO Batch
   */ TooltipView.prototype.manuallyShowTip = function(tooltipModel, ecModel, api, payload) {
        if (payload.from === this.uid || (0, $ce6dd58693a21851$export$2e2bcd8739ae039).node || !api.getDom()) return;
        var dispatchAction = $1b2ffe835052ab23$var$makeDispatchAction(payload, api);
        // Reset ticket
        this._ticket = '';
        // When triggered from axisPointer.
        var dataByCoordSys = payload.dataByCoordSys;
        var cmptRef = $1b2ffe835052ab23$var$findComponentReference(payload, ecModel, api);
        if (cmptRef) {
            var rect = cmptRef.el.getBoundingRect().clone();
            rect.applyTransform(cmptRef.el.transform);
            this._tryShow({
                offsetX: rect.x + rect.width / 2,
                offsetY: rect.y + rect.height / 2,
                target: cmptRef.el,
                position: payload.position,
                // When manully trigger, the mouse is not on the el, so we'd better to
                // position tooltip on the bottom of the el and display arrow is possible.
                positionDefault: 'bottom'
            }, dispatchAction);
        } else if (payload.tooltip && payload.x != null && payload.y != null) {
            var el = $1b2ffe835052ab23$var$proxyRect;
            el.x = payload.x;
            el.y = payload.y;
            el.update();
            (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).tooltipConfig = {
                name: null,
                option: payload.tooltip
            };
            // Manually show tooltip while view is not using zrender elements.
            this._tryShow({
                offsetX: payload.x,
                offsetY: payload.y,
                target: el
            }, dispatchAction);
        } else if (dataByCoordSys) this._tryShow({
            offsetX: payload.x,
            offsetY: payload.y,
            position: payload.position,
            dataByCoordSys: dataByCoordSys,
            tooltipOption: payload.tooltipOption
        }, dispatchAction);
        else if (payload.seriesIndex != null) {
            if (this._manuallyAxisShowTip(tooltipModel, ecModel, api, payload)) return;
            var pointInfo = (0, $4cab5d8b3532dad5$export$2e2bcd8739ae039)(payload, ecModel);
            var cx = pointInfo.point[0];
            var cy = pointInfo.point[1];
            if (cx != null && cy != null) this._tryShow({
                offsetX: cx,
                offsetY: cy,
                target: pointInfo.el,
                position: payload.position,
                // When manully trigger, the mouse is not on the el, so we'd better to
                // position tooltip on the bottom of the el and display arrow is possible.
                positionDefault: 'bottom'
            }, dispatchAction);
        } else if (payload.x != null && payload.y != null) {
            // FIXME
            // should wrap dispatchAction like `axisPointer/globalListener` ?
            api.dispatchAction({
                type: 'updateAxisPointer',
                x: payload.x,
                y: payload.y
            });
            this._tryShow({
                offsetX: payload.x,
                offsetY: payload.y,
                position: payload.position,
                target: api.getZr().findHover(payload.x, payload.y).target
            }, dispatchAction);
        }
    };
    TooltipView.prototype.manuallyHideTip = function(tooltipModel, ecModel, api, payload) {
        var tooltipContent = this._tooltipContent;
        if (this._tooltipModel) tooltipContent.hideLater(this._tooltipModel.get('hideDelay'));
        this._lastX = this._lastY = this._lastDataByCoordSys = null;
        if (payload.from !== this.uid) this._hide($1b2ffe835052ab23$var$makeDispatchAction(payload, api));
    };
    // Be compatible with previous design, that is, when tooltip.type is 'axis' and
    // dispatchAction 'showTip' with seriesIndex and dataIndex will trigger axis pointer
    // and tooltip.
    TooltipView.prototype._manuallyAxisShowTip = function(tooltipModel, ecModel, api, payload) {
        var seriesIndex = payload.seriesIndex;
        var dataIndex = payload.dataIndex;
        // @ts-ignore
        var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo;
        if (seriesIndex == null || dataIndex == null || coordSysAxesInfo == null) return;
        var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
        if (!seriesModel) return;
        var data = seriesModel.getData();
        var tooltipCascadedModel = $1b2ffe835052ab23$var$buildTooltipModel([
            data.getItemModel(dataIndex),
            seriesModel,
            (seriesModel.coordinateSystem || {}).model
        ], this._tooltipModel);
        if (tooltipCascadedModel.get('trigger') !== 'axis') return;
        api.dispatchAction({
            type: 'updateAxisPointer',
            seriesIndex: seriesIndex,
            dataIndex: dataIndex,
            position: payload.position
        });
        return true;
    };
    TooltipView.prototype._tryShow = function(e, dispatchAction) {
        var el = e.target;
        var tooltipModel = this._tooltipModel;
        if (!tooltipModel) return;
        // Save mouse x, mouse y. So we can try to keep showing the tip if chart is refreshed
        this._lastX = e.offsetX;
        this._lastY = e.offsetY;
        var dataByCoordSys = e.dataByCoordSys;
        if (dataByCoordSys && dataByCoordSys.length) this._showAxisTooltip(dataByCoordSys, e);
        else if (el) {
            var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el);
            if (ecData.ssrType === 'legend') // Don't trigger tooltip for legend tooltip item
            return;
            this._lastDataByCoordSys = null;
            var seriesDispatcher_1;
            var cmptDispatcher_1;
            (0, $808c5a2823518f68$export$8a4fca9e04eb4df6)(el, function(target) {
                // Always show item tooltip if mouse is on the element with dataIndex
                if ((0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(target).dataIndex != null) {
                    seriesDispatcher_1 = target;
                    return true;
                }
                // Tooltip provided directly. Like legend.
                if ((0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(target).tooltipConfig != null) {
                    cmptDispatcher_1 = target;
                    return true;
                }
            }, true);
            if (seriesDispatcher_1) this._showSeriesItemTooltip(e, seriesDispatcher_1, dispatchAction);
            else if (cmptDispatcher_1) this._showComponentItemTooltip(e, cmptDispatcher_1, dispatchAction);
            else this._hide(dispatchAction);
        } else {
            this._lastDataByCoordSys = null;
            this._hide(dispatchAction);
        }
    };
    TooltipView.prototype._showOrMove = function(tooltipModel, cb) {
        // showDelay is used in this case: tooltip.enterable is set
        // as true. User intent to move mouse into tooltip and click
        // something. `showDelay` makes it easier to enter the content
        // but tooltip do not move immediately.
        var delay = tooltipModel.get('showDelay');
        cb = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(cb, this);
        clearTimeout(this._showTimout);
        delay > 0 ? this._showTimout = setTimeout(cb, delay) : cb();
    };
    TooltipView.prototype._showAxisTooltip = function(dataByCoordSys, e) {
        var ecModel = this._ecModel;
        var globalTooltipModel = this._tooltipModel;
        var point = [
            e.offsetX,
            e.offsetY
        ];
        var singleTooltipModel = $1b2ffe835052ab23$var$buildTooltipModel([
            e.tooltipOption
        ], globalTooltipModel);
        var renderMode = this._renderMode;
        var cbParamsList = [];
        var articleMarkup = (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)('section', {
            blocks: [],
            noHeader: true
        });
        // Only for legacy: `Serise['formatTooltip']` returns a string.
        var markupTextArrLegacy = [];
        var markupStyleCreator = new (0, $d5ab84c08d6657ec$export$2fba3afbcdcf3e18)();
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dataByCoordSys, function(itemCoordSys) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(itemCoordSys.dataByAxis, function(axisItem) {
                var axisModel = ecModel.getComponent(axisItem.axisDim + 'Axis', axisItem.axisIndex);
                var axisValue = axisItem.value;
                if (!axisModel || axisValue == null) return;
                var axisValueLabel = $51dec70890757374$export$7cffee0f9aed39d0(axisValue, axisModel.axis, ecModel, axisItem.seriesDataIndices, axisItem.valueLabelOpt);
                var axisSectionMarkup = (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)('section', {
                    header: axisValueLabel,
                    noHeader: !(0, $7a1bd9c2710fea0d$export$87c2784dc9fc4ab)(axisValueLabel),
                    sortBlocks: true,
                    blocks: []
                });
                articleMarkup.blocks.push(axisSectionMarkup);
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axisItem.seriesDataIndices, function(idxItem) {
                    var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
                    var dataIndex = idxItem.dataIndexInside;
                    var cbParams = series.getDataParams(dataIndex);
                    // Can't find data.
                    if (cbParams.dataIndex < 0) return;
                    cbParams.axisDim = axisItem.axisDim;
                    cbParams.axisIndex = axisItem.axisIndex;
                    cbParams.axisType = axisItem.axisType;
                    cbParams.axisId = axisItem.axisId;
                    cbParams.axisValue = $2d646e51cc34f840$export$a5a32f324c1fa457(axisModel.axis, {
                        value: axisValue
                    });
                    cbParams.axisValueLabel = axisValueLabel;
                    // Pre-create marker style for makers. Users can assemble richText
                    // text in `formatter` callback and use those markers style.
                    cbParams.marker = markupStyleCreator.makeTooltipMarker('item', (0, $c84c9521536c601a$export$cda04d03233e5555)(cbParams.color), renderMode);
                    var seriesTooltipResult = (0, $655dd6075cc63601$export$2d16fa82a50c4741)(series.formatTooltip(dataIndex, true, null));
                    var frag = seriesTooltipResult.frag;
                    if (frag) {
                        var valueFormatter = $1b2ffe835052ab23$var$buildTooltipModel([
                            series
                        ], globalTooltipModel).get('valueFormatter');
                        axisSectionMarkup.blocks.push(valueFormatter ? (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
                            valueFormatter: valueFormatter
                        }, frag) : frag);
                    }
                    if (seriesTooltipResult.text) markupTextArrLegacy.push(seriesTooltipResult.text);
                    cbParamsList.push(cbParams);
                });
            });
        });
        // In most cases, the second axis is displays upper on the first one.
        // So we reverse it to look better.
        articleMarkup.blocks.reverse();
        markupTextArrLegacy.reverse();
        var positionExpr = e.position;
        var orderMode = singleTooltipModel.get('order');
        var builtMarkupText = (0, $d5ab84c08d6657ec$export$6969ffb02c1cb49a)(articleMarkup, markupStyleCreator, renderMode, orderMode, ecModel.get('useUTC'), singleTooltipModel.get('textStyle'));
        builtMarkupText && markupTextArrLegacy.unshift(builtMarkupText);
        var blockBreak = renderMode === 'richText' ? '\n\n' : '<br/>';
        var allMarkupText = markupTextArrLegacy.join(blockBreak);
        this._showOrMove(singleTooltipModel, function() {
            if (this._updateContentNotChangedOnAxis(dataByCoordSys, cbParamsList)) this._updatePosition(singleTooltipModel, positionExpr, point[0], point[1], this._tooltipContent, cbParamsList);
            else this._showTooltipContent(singleTooltipModel, allMarkupText, cbParamsList, Math.random() + '', point[0], point[1], positionExpr, null, markupStyleCreator);
        });
    // Do not trigger events here, because this branch only be entered
    // from dispatchAction.
    };
    TooltipView.prototype._showSeriesItemTooltip = function(e, dispatcher, dispatchAction) {
        var ecModel = this._ecModel;
        var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(dispatcher);
        // Use dataModel in element if possible
        // Used when mouseover on a element like markPoint or edge
        // In which case, the data is not main data in series.
        var seriesIndex = ecData.seriesIndex;
        var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
        // For example, graph link.
        var dataModel = ecData.dataModel || seriesModel;
        var dataIndex = ecData.dataIndex;
        var dataType = ecData.dataType;
        var data = dataModel.getData(dataType);
        var renderMode = this._renderMode;
        var positionDefault = e.positionDefault;
        var tooltipModel = $1b2ffe835052ab23$var$buildTooltipModel([
            data.getItemModel(dataIndex),
            dataModel,
            seriesModel && (seriesModel.coordinateSystem || {}).model
        ], this._tooltipModel, positionDefault ? {
            position: positionDefault
        } : null);
        var tooltipTrigger = tooltipModel.get('trigger');
        if (tooltipTrigger != null && tooltipTrigger !== 'item') return;
        var params = dataModel.getDataParams(dataIndex, dataType);
        var markupStyleCreator = new (0, $d5ab84c08d6657ec$export$2fba3afbcdcf3e18)();
        // Pre-create marker style for makers. Users can assemble richText
        // text in `formatter` callback and use those markers style.
        params.marker = markupStyleCreator.makeTooltipMarker('item', (0, $c84c9521536c601a$export$cda04d03233e5555)(params.color), renderMode);
        var seriesTooltipResult = (0, $655dd6075cc63601$export$2d16fa82a50c4741)(dataModel.formatTooltip(dataIndex, false, dataType));
        var orderMode = tooltipModel.get('order');
        var valueFormatter = tooltipModel.get('valueFormatter');
        var frag = seriesTooltipResult.frag;
        var markupText = frag ? (0, $d5ab84c08d6657ec$export$6969ffb02c1cb49a)(valueFormatter ? (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
            valueFormatter: valueFormatter
        }, frag) : frag, markupStyleCreator, renderMode, orderMode, ecModel.get('useUTC'), tooltipModel.get('textStyle')) : seriesTooltipResult.text;
        var asyncTicket = 'item_' + dataModel.name + '_' + dataIndex;
        this._showOrMove(tooltipModel, function() {
            this._showTooltipContent(tooltipModel, markupText, params, asyncTicket, e.offsetX, e.offsetY, e.position, e.target, markupStyleCreator);
        });
        // FIXME
        // duplicated showtip if manuallyShowTip is called from dispatchAction.
        dispatchAction({
            type: 'showTip',
            dataIndexInside: dataIndex,
            dataIndex: data.getRawIndex(dataIndex),
            seriesIndex: seriesIndex,
            from: this.uid
        });
    };
    TooltipView.prototype._showComponentItemTooltip = function(e, el, dispatchAction) {
        var isHTMLRenderMode = this._renderMode === 'html';
        var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el);
        var tooltipConfig = ecData.tooltipConfig;
        var tooltipOpt = tooltipConfig.option || {};
        var encodeHTMLContent = tooltipOpt.encodeHTMLContent;
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(tooltipOpt)) {
            var content = tooltipOpt;
            tooltipOpt = {
                content: content,
                // Fixed formatter
                formatter: content
            };
            // when `tooltipConfig.option` is a string rather than an object,
            // we can't know if the content needs to be encoded
            // for the sake of security, encode it by default.
            encodeHTMLContent = true;
        }
        if (encodeHTMLContent && isHTMLRenderMode && tooltipOpt.content) {
            // clone might be unnecessary?
            tooltipOpt = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(tooltipOpt);
            tooltipOpt.content = (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(tooltipOpt.content);
        }
        var tooltipModelCascade = [
            tooltipOpt
        ];
        var cmpt = this._ecModel.getComponent(ecData.componentMainType, ecData.componentIndex);
        if (cmpt) tooltipModelCascade.push(cmpt);
        // In most cases, component tooltip formatter has different params with series tooltip formatter,
        // so that they cannot share the same formatter. Since the global tooltip formatter is used for series
        // by convention, we do not use it as the default formatter for component.
        tooltipModelCascade.push({
            formatter: tooltipOpt.content
        });
        var positionDefault = e.positionDefault;
        var subTooltipModel = $1b2ffe835052ab23$var$buildTooltipModel(tooltipModelCascade, this._tooltipModel, positionDefault ? {
            position: positionDefault
        } : null);
        var defaultHtml = subTooltipModel.get('content');
        var asyncTicket = Math.random() + '';
        // PENDING: this case do not support richText style yet.
        var markupStyleCreator = new (0, $d5ab84c08d6657ec$export$2fba3afbcdcf3e18)();
        // Do not check whether `trigger` is 'none' here, because `trigger`
        // only works on coordinate system. In fact, we have not found case
        // that requires setting `trigger` nothing on component yet.
        this._showOrMove(subTooltipModel, function() {
            // Use formatterParams from element defined in component
            // Avoid users modify it.
            var formatterParams = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(subTooltipModel.get('formatterParams') || {});
            this._showTooltipContent(subTooltipModel, defaultHtml, formatterParams, asyncTicket, e.offsetX, e.offsetY, e.position, el, markupStyleCreator);
        });
        // If not dispatch showTip, tip may be hide triggered by axis.
        dispatchAction({
            type: 'showTip',
            from: this.uid
        });
    };
    TooltipView.prototype._showTooltipContent = function(// Use Model<TooltipOption> insteadof TooltipModel because this model may be from series or other options.
    // Instead of top level tooltip.
    tooltipModel, defaultHtml, params, asyncTicket, x, y, positionExpr, el, markupStyleCreator) {
        // Reset ticket
        this._ticket = '';
        if (!tooltipModel.get('showContent') || !tooltipModel.get('show')) return;
        var tooltipContent = this._tooltipContent;
        tooltipContent.setEnterable(tooltipModel.get('enterable'));
        var formatter = tooltipModel.get('formatter');
        positionExpr = positionExpr || tooltipModel.get('position');
        var html = defaultHtml;
        var nearPoint = this._getNearestPoint([
            x,
            y
        ], params, tooltipModel.get('trigger'), tooltipModel.get('borderColor'));
        var nearPointColor = nearPoint.color;
        if (formatter) {
            if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(formatter)) {
                var useUTC = tooltipModel.ecModel.get('useUTC');
                var params0 = (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(params) ? params[0] : params;
                var isTimeAxis = params0 && params0.axisType && params0.axisType.indexOf('time') >= 0;
                html = formatter;
                if (isTimeAxis) html = (0, $0ae0381fb3fd176f$export$d9468344d3651243)(params0.axisValue, html, useUTC);
                html = (0, $c84c9521536c601a$export$2028496a35766e41)(html, params, true);
            } else if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(formatter)) {
                var callback = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(function(cbTicket, html) {
                    if (cbTicket === this._ticket) {
                        tooltipContent.setContent(html, markupStyleCreator, tooltipModel, nearPointColor, positionExpr);
                        this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
                    }
                }, this);
                this._ticket = asyncTicket;
                html = formatter(params, asyncTicket, callback);
            } else html = formatter;
        }
        tooltipContent.setContent(html, markupStyleCreator, tooltipModel, nearPointColor, positionExpr);
        tooltipContent.show(tooltipModel, nearPointColor);
        this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
    };
    TooltipView.prototype._getNearestPoint = function(point, tooltipDataParams, trigger, borderColor) {
        if (trigger === 'axis' || (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(tooltipDataParams)) return {
            color: borderColor || (this._renderMode === 'html' ? '#fff' : 'none')
        };
        if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(tooltipDataParams)) return {
            color: borderColor || tooltipDataParams.color || tooltipDataParams.borderColor
        };
    };
    TooltipView.prototype._updatePosition = function(tooltipModel, positionExpr, x, // Mouse x
    y, // Mouse y
    content, params, el) {
        var viewWidth = this._api.getWidth();
        var viewHeight = this._api.getHeight();
        positionExpr = positionExpr || tooltipModel.get('position');
        var contentSize = content.getSize();
        var align = tooltipModel.get('align');
        var vAlign = tooltipModel.get('verticalAlign');
        var rect = el && el.getBoundingRect().clone();
        el && rect.applyTransform(el.transform);
        if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(positionExpr)) // Callback of position can be an array or a string specify the position
        positionExpr = positionExpr([
            x,
            y
        ], params, content.el, rect, {
            viewSize: [
                viewWidth,
                viewHeight
            ],
            contentSize: contentSize.slice()
        });
        if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(positionExpr)) {
            x = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(positionExpr[0], viewWidth);
            y = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(positionExpr[1], viewHeight);
        } else if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(positionExpr)) {
            var boxLayoutPosition = positionExpr;
            boxLayoutPosition.width = contentSize[0];
            boxLayoutPosition.height = contentSize[1];
            var layoutRect = (0, $93b9bc7f22ac7369$export$4517a5ca639a7293)(boxLayoutPosition, {
                width: viewWidth,
                height: viewHeight
            });
            x = layoutRect.x;
            y = layoutRect.y;
            align = null;
            // When positionExpr is left/top/right/bottom,
            // align and verticalAlign will not work.
            vAlign = null;
        } else if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(positionExpr) && el) {
            var pos = $1b2ffe835052ab23$var$calcTooltipPosition(positionExpr, rect, contentSize, tooltipModel.get('borderWidth'));
            x = pos[0];
            y = pos[1];
        } else {
            var pos = $1b2ffe835052ab23$var$refixTooltipPosition(x, y, content, viewWidth, viewHeight, align ? null : 20, vAlign ? null : 20);
            x = pos[0];
            y = pos[1];
        }
        align && (x -= $1b2ffe835052ab23$var$isCenterAlign(align) ? contentSize[0] / 2 : align === 'right' ? contentSize[0] : 0);
        vAlign && (y -= $1b2ffe835052ab23$var$isCenterAlign(vAlign) ? contentSize[1] / 2 : vAlign === 'bottom' ? contentSize[1] : 0);
        if ((0, $c6d80cf697426e46$export$a309528050824ba4)(tooltipModel)) {
            var pos = $1b2ffe835052ab23$var$confineTooltipPosition(x, y, content, viewWidth, viewHeight);
            x = pos[0];
            y = pos[1];
        }
        content.moveTo(x, y);
    };
    // FIXME
    // Should we remove this but leave this to user?
    TooltipView.prototype._updateContentNotChangedOnAxis = function(dataByCoordSys, cbParamsList) {
        var lastCoordSys = this._lastDataByCoordSys;
        var lastCbParamsList = this._cbParamsList;
        var contentNotChanged = !!lastCoordSys && lastCoordSys.length === dataByCoordSys.length;
        contentNotChanged && (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(lastCoordSys, function(lastItemCoordSys, indexCoordSys) {
            var lastDataByAxis = lastItemCoordSys.dataByAxis || [];
            var thisItemCoordSys = dataByCoordSys[indexCoordSys] || {};
            var thisDataByAxis = thisItemCoordSys.dataByAxis || [];
            contentNotChanged = contentNotChanged && lastDataByAxis.length === thisDataByAxis.length;
            contentNotChanged && (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(lastDataByAxis, function(lastItem, indexAxis) {
                var thisItem = thisDataByAxis[indexAxis] || {};
                var lastIndices = lastItem.seriesDataIndices || [];
                var newIndices = thisItem.seriesDataIndices || [];
                contentNotChanged = contentNotChanged && lastItem.value === thisItem.value && lastItem.axisType === thisItem.axisType && lastItem.axisId === thisItem.axisId && lastIndices.length === newIndices.length;
                contentNotChanged && (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(lastIndices, function(lastIdxItem, j) {
                    var newIdxItem = newIndices[j];
                    contentNotChanged = contentNotChanged && lastIdxItem.seriesIndex === newIdxItem.seriesIndex && lastIdxItem.dataIndex === newIdxItem.dataIndex;
                });
                // check is cbParams data value changed
                lastCbParamsList && (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(lastItem.seriesDataIndices, function(idxItem) {
                    var seriesIdx = idxItem.seriesIndex;
                    var cbParams = cbParamsList[seriesIdx];
                    var lastCbParams = lastCbParamsList[seriesIdx];
                    if (cbParams && lastCbParams && lastCbParams.data !== cbParams.data) contentNotChanged = false;
                });
            });
        });
        this._lastDataByCoordSys = dataByCoordSys;
        this._cbParamsList = cbParamsList;
        return !!contentNotChanged;
    };
    TooltipView.prototype._hide = function(dispatchAction) {
        // Do not directly hideLater here, because this behavior may be prevented
        // in dispatchAction when showTip is dispatched.
        // FIXME
        // duplicated hideTip if manuallyHideTip is called from dispatchAction.
        this._lastDataByCoordSys = null;
        dispatchAction({
            type: 'hideTip',
            from: this.uid
        });
    };
    TooltipView.prototype.dispose = function(ecModel, api) {
        if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).node || !api.getDom()) return;
        (0, $c98659a9437a3d2e$export$42ffd38884aecdac)(this, '_updatePosition');
        this._tooltipContent.dispose();
        $84450f5aa7fbde00$export$d07f55d4c15c0440('itemTooltip', api);
    };
    TooltipView.type = 'tooltip';
    return TooltipView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
/**
 * From top to bottom. (the last one should be globalTooltipModel);
 */ function $1b2ffe835052ab23$var$buildTooltipModel(modelCascade, globalTooltipModel, defaultTooltipOption) {
    // Last is always tooltip model.
    var ecModel = globalTooltipModel.ecModel;
    var resultModel;
    if (defaultTooltipOption) {
        resultModel = new (0, $6818646a97528290$export$2e2bcd8739ae039)(defaultTooltipOption, ecModel, ecModel);
        resultModel = new (0, $6818646a97528290$export$2e2bcd8739ae039)(globalTooltipModel.option, resultModel, ecModel);
    } else resultModel = globalTooltipModel;
    for(var i = modelCascade.length - 1; i >= 0; i--){
        var tooltipOpt = modelCascade[i];
        if (tooltipOpt) {
            if (tooltipOpt instanceof (0, $6818646a97528290$export$2e2bcd8739ae039)) tooltipOpt = tooltipOpt.get('tooltip', true);
            // In each data item tooltip can be simply write:
            // {
            //  value: 10,
            //  tooltip: 'Something you need to know'
            // }
            if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(tooltipOpt)) tooltipOpt = {
                formatter: tooltipOpt
            };
            if (tooltipOpt) resultModel = new (0, $6818646a97528290$export$2e2bcd8739ae039)(tooltipOpt, resultModel, ecModel);
        }
    }
    return resultModel;
}
function $1b2ffe835052ab23$var$makeDispatchAction(payload, api) {
    return payload.dispatchAction || (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(api.dispatchAction, api);
}
function $1b2ffe835052ab23$var$refixTooltipPosition(x, y, content, viewWidth, viewHeight, gapH, gapV) {
    var size = content.getSize();
    var width = size[0];
    var height = size[1];
    if (gapH != null) {
        // Add extra 2 pixels for this case:
        // At present the "values" in default tooltip are using CSS `float: right`.
        // When the right edge of the tooltip box is on the right side of the
        // viewport, the `float` layout might push the "values" to the second line.
        if (x + width + gapH + 2 > viewWidth) x -= width + gapH;
        else x += gapH;
    }
    if (gapV != null) {
        if (y + height + gapV > viewHeight) y -= height + gapV;
        else y += gapV;
    }
    return [
        x,
        y
    ];
}
function $1b2ffe835052ab23$var$confineTooltipPosition(x, y, content, viewWidth, viewHeight) {
    var size = content.getSize();
    var width = size[0];
    var height = size[1];
    x = Math.min(x + width, viewWidth) - width;
    y = Math.min(y + height, viewHeight) - height;
    x = Math.max(x, 0);
    y = Math.max(y, 0);
    return [
        x,
        y
    ];
}
function $1b2ffe835052ab23$var$calcTooltipPosition(position, rect, contentSize, borderWidth) {
    var domWidth = contentSize[0];
    var domHeight = contentSize[1];
    var offset = Math.ceil(Math.SQRT2 * borderWidth) + 8;
    var x = 0;
    var y = 0;
    var rectWidth = rect.width;
    var rectHeight = rect.height;
    switch(position){
        case 'inside':
            x = rect.x + rectWidth / 2 - domWidth / 2;
            y = rect.y + rectHeight / 2 - domHeight / 2;
            break;
        case 'top':
            x = rect.x + rectWidth / 2 - domWidth / 2;
            y = rect.y - domHeight - offset;
            break;
        case 'bottom':
            x = rect.x + rectWidth / 2 - domWidth / 2;
            y = rect.y + rectHeight + offset;
            break;
        case 'left':
            x = rect.x - domWidth - offset;
            y = rect.y + rectHeight / 2 - domHeight / 2;
            break;
        case 'right':
            x = rect.x + rectWidth + offset;
            y = rect.y + rectHeight / 2 - domHeight / 2;
    }
    return [
        x,
        y
    ];
}
function $1b2ffe835052ab23$var$isCenterAlign(align) {
    return align === 'center' || align === 'middle';
}
/**
 * Find target component by payload like:
 * ```js
 * { legendId: 'some_id', name: 'xxx' }
 * { toolboxIndex: 1, name: 'xxx' }
 * { geoName: 'some_name', name: 'xxx' }
 * ```
 * PENDING: at present only
 *
 * If not found, return null/undefined.
 */ function $1b2ffe835052ab23$var$findComponentReference(payload, ecModel, api) {
    var queryOptionMap = (0, $76d619f648247e6d$export$fe600815775d9400)(payload).queryOptionMap;
    var componentMainType = queryOptionMap.keys()[0];
    if (!componentMainType || componentMainType === 'series') return;
    var queryResult = (0, $76d619f648247e6d$export$dc741340f7e5f186)(ecModel, componentMainType, queryOptionMap.get(componentMainType), {
        useDefault: false,
        enableAll: false,
        enableNone: false
    });
    var model = queryResult.models[0];
    if (!model) return;
    var view = api.getViewOfComponentModel(model);
    var el;
    view.group.traverse(function(subEl) {
        var tooltipConfig = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(subEl).tooltipConfig;
        if (tooltipConfig && tooltipConfig.name === payload.name) {
            el = subEl;
            return true; // stop
        }
    });
    if (el) return {
        componentMainType: componentMainType,
        componentIndex: model.componentIndex,
        el: el
    };
}
var $1b2ffe835052ab23$export$2e2bcd8739ae039 = $1b2ffe835052ab23$var$TooltipView;



function $46e639bec576c55c$export$4b3e715f166fdd78(registers) {
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $589507869c21caa1$export$4b3e715f166fdd78));
    registers.registerComponentModel((0, $310c8e7a9655a722$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $1b2ffe835052ab23$export$2e2bcd8739ae039));
    /**
   * @action
   * @property {string} type
   * @property {number} seriesIndex
   * @property {number} dataIndex
   * @property {number} [x]
   * @property {number} [y]
   */ registers.registerAction({
        type: 'showTip',
        event: 'showTip',
        update: 'tooltip:manuallyShowTip'
    }, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));
    registers.registerAction({
        type: 'hideTip',
        event: 'hideTip',
        update: 'tooltip:manuallyHideTip'
    }, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $9c7e3d8a1f578014$var$RELATIONAL_EXPRESSION_OP_ALIAS_MAP = {
    value: 'eq',
    // PENDING: not good for literal semantic?
    '<': 'lt',
    '<=': 'lte',
    '>': 'gt',
    '>=': 'gte',
    '=': 'eq',
    '!=': 'ne',
    '<>': 'ne'
};
// type RelationalExpressionOpEvaluate = (tarVal: unknown, condVal: unknown) => boolean;
var $9c7e3d8a1f578014$var$RegExpEvaluator = /** @class */ function() {
    function RegExpEvaluator(rVal) {
        // Support condVal: RegExp | string
        var condValue = this._condVal = (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(rVal) ? new RegExp(rVal) : (0, $7a1bd9c2710fea0d$export$49841c62b9eff15)(rVal) ? rVal : null;
        if (condValue == null) {
            var errMsg = '';
            (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
        }
    }
    RegExpEvaluator.prototype.evaluate = function(lVal) {
        var type = typeof lVal;
        return (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(type) ? this._condVal.test(lVal) : (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(type) ? this._condVal.test(lVal + '') : false;
    };
    return RegExpEvaluator;
}();
var $9c7e3d8a1f578014$var$ConstConditionInternal = /** @class */ function() {
    function ConstConditionInternal() {}
    ConstConditionInternal.prototype.evaluate = function() {
        return this.value;
    };
    return ConstConditionInternal;
}();
var $9c7e3d8a1f578014$var$AndConditionInternal = /** @class */ function() {
    function AndConditionInternal() {}
    AndConditionInternal.prototype.evaluate = function() {
        var children = this.children;
        for(var i = 0; i < children.length; i++){
            if (!children[i].evaluate()) return false;
        }
        return true;
    };
    return AndConditionInternal;
}();
var $9c7e3d8a1f578014$var$OrConditionInternal = /** @class */ function() {
    function OrConditionInternal() {}
    OrConditionInternal.prototype.evaluate = function() {
        var children = this.children;
        for(var i = 0; i < children.length; i++){
            if (children[i].evaluate()) return true;
        }
        return false;
    };
    return OrConditionInternal;
}();
var $9c7e3d8a1f578014$var$NotConditionInternal = /** @class */ function() {
    function NotConditionInternal() {}
    NotConditionInternal.prototype.evaluate = function() {
        return !this.child.evaluate();
    };
    return NotConditionInternal;
}();
var $9c7e3d8a1f578014$var$RelationalConditionInternal = /** @class */ function() {
    function RelationalConditionInternal() {}
    RelationalConditionInternal.prototype.evaluate = function() {
        var needParse = !!this.valueParser;
        // Call getValue with no `this`.
        var getValue = this.getValue;
        var tarValRaw = getValue(this.valueGetterParam);
        var tarValParsed = needParse ? this.valueParser(tarValRaw) : null;
        // Relational cond follow "and" logic internally.
        for(var i = 0; i < this.subCondList.length; i++){
            if (!this.subCondList[i].evaluate(needParse ? tarValParsed : tarValRaw)) return false;
        }
        return true;
    };
    return RelationalConditionInternal;
}();
function $9c7e3d8a1f578014$var$parseOption(exprOption, getters) {
    if (exprOption === true || exprOption === false) {
        var cond = new $9c7e3d8a1f578014$var$ConstConditionInternal();
        cond.value = exprOption;
        return cond;
    }
    var errMsg = '';
    if (!$9c7e3d8a1f578014$var$isObjectNotArray(exprOption)) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    if (exprOption.and) return $9c7e3d8a1f578014$var$parseAndOrOption('and', exprOption, getters);
    else if (exprOption.or) return $9c7e3d8a1f578014$var$parseAndOrOption('or', exprOption, getters);
    else if (exprOption.not) return $9c7e3d8a1f578014$var$parseNotOption(exprOption, getters);
    return $9c7e3d8a1f578014$var$parseRelationalOption(exprOption, getters);
}
function $9c7e3d8a1f578014$var$parseAndOrOption(op, exprOption, getters) {
    var subOptionArr = exprOption[op];
    var errMsg = '';
    if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(subOptionArr)) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    if (!subOptionArr.length) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    var cond = op === 'and' ? new $9c7e3d8a1f578014$var$AndConditionInternal() : new $9c7e3d8a1f578014$var$OrConditionInternal();
    cond.children = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(subOptionArr, function(subOption) {
        return $9c7e3d8a1f578014$var$parseOption(subOption, getters);
    });
    if (!cond.children.length) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    return cond;
}
function $9c7e3d8a1f578014$var$parseNotOption(exprOption, getters) {
    var subOption = exprOption.not;
    var errMsg = '';
    if (!$9c7e3d8a1f578014$var$isObjectNotArray(subOption)) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    var cond = new $9c7e3d8a1f578014$var$NotConditionInternal();
    cond.child = $9c7e3d8a1f578014$var$parseOption(subOption, getters);
    if (!cond.child) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    return cond;
}
function $9c7e3d8a1f578014$var$parseRelationalOption(exprOption, getters) {
    var errMsg = '';
    var valueGetterParam = getters.prepareGetValue(exprOption);
    var subCondList = [];
    var exprKeys = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(exprOption);
    var parserName = exprOption.parser;
    var valueParser = parserName ? (0, $40ab59f44b7d2db6$export$c88237b7c265b36b)(parserName) : null;
    for(var i = 0; i < exprKeys.length; i++){
        var keyRaw = exprKeys[i];
        if (keyRaw === 'parser' || getters.valueGetterAttrMap.get(keyRaw)) continue;
        var op = (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)($9c7e3d8a1f578014$var$RELATIONAL_EXPRESSION_OP_ALIAS_MAP, keyRaw) ? $9c7e3d8a1f578014$var$RELATIONAL_EXPRESSION_OP_ALIAS_MAP[keyRaw] : keyRaw;
        var condValueRaw = exprOption[keyRaw];
        var condValueParsed = valueParser ? valueParser(condValueRaw) : condValueRaw;
        var evaluator = (0, $40ab59f44b7d2db6$export$f2644c3485f94c4e)(op, condValueParsed) || op === 'reg' && new $9c7e3d8a1f578014$var$RegExpEvaluator(condValueParsed);
        if (!evaluator) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
        subCondList.push(evaluator);
    }
    if (!subCondList.length) // No relational operator always disabled in case of dangers result.
    (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    var cond = new $9c7e3d8a1f578014$var$RelationalConditionInternal();
    cond.valueGetterParam = valueGetterParam;
    cond.valueParser = valueParser;
    cond.getValue = getters.getValue;
    cond.subCondList = subCondList;
    return cond;
}
function $9c7e3d8a1f578014$var$isObjectNotArray(val) {
    return (0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(val) && !(0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(val);
}
var $9c7e3d8a1f578014$var$ConditionalExpressionParsed = /** @class */ function() {
    function ConditionalExpressionParsed(exprOption, getters) {
        this._cond = $9c7e3d8a1f578014$var$parseOption(exprOption, getters);
    }
    ConditionalExpressionParsed.prototype.evaluate = function() {
        return this._cond.evaluate();
    };
    return ConditionalExpressionParsed;
}();
function $9c7e3d8a1f578014$export$cd61647d82cec762(exprOption, getters) {
    return new $9c7e3d8a1f578014$var$ConditionalExpressionParsed(exprOption, getters);
}




var $0e1e10ffafe52e71$export$dc15474d94cdc2b3 = {
    type: 'echarts:filter',
    // PENDING: enhance to filter by index rather than create new data
    transform: function(params) {
        // [Caveat] Fail-Fast:
        // Do not return the whole dataset unless user config indicates it explicitly.
        // For example, if no condition is specified by mistake, returning an empty result
        // is better than returning the entire raw source for the user to find the mistake.
        var upstream = params.upstream;
        var rawItem;
        var condition = (0, $9c7e3d8a1f578014$export$cd61647d82cec762)(params.config, {
            valueGetterAttrMap: (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)({
                dimension: true
            }),
            prepareGetValue: function(exprOption) {
                var errMsg = '';
                var dimLoose = exprOption.dimension;
                if (!(0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(exprOption, 'dimension')) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
                var dimInfo = upstream.getDimensionInfo(dimLoose);
                if (!dimInfo) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
                return {
                    dimIdx: dimInfo.index
                };
            },
            getValue: function(param) {
                return upstream.retrieveValueFromItem(rawItem, param.dimIdx);
            }
        });
        var resultData = [];
        for(var i = 0, len = upstream.count(); i < len; i++){
            rawItem = upstream.getRawDataItem(i);
            if (condition.evaluate()) resultData.push(rawItem);
        }
        return {
            data: resultData
        };
    }
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $7781c153e964c2e9$var$sampleLog = '';
var $7781c153e964c2e9$export$505f1bb66427eaee = {
    type: 'echarts:sort',
    transform: function(params) {
        var upstream = params.upstream;
        var config = params.config;
        var errMsg = '';
        // Normalize
        // const orderExprList: OrderExpression[] = isArray(config[0])
        //     ? config as OrderExpression[]
        //     : [config as OrderExpression];
        var orderExprList = (0, $76d619f648247e6d$export$4f07b212a02c8051)(config);
        if (!orderExprList.length) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
        var orderDefList = [];
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(orderExprList, function(orderExpr) {
            var dimLoose = orderExpr.dimension;
            var order = orderExpr.order;
            var parserName = orderExpr.parser;
            var incomparable = orderExpr.incomparable;
            if (dimLoose == null) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
            if (order !== 'asc' && order !== 'desc') (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
            if (incomparable && incomparable !== 'min' && incomparable !== 'max') {
                var errMsg_1 = '';
                (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg_1);
            }
            if (order !== 'asc' && order !== 'desc') {
                var errMsg_2 = '';
                (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg_2);
            }
            var dimInfo = upstream.getDimensionInfo(dimLoose);
            if (!dimInfo) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
            var parser = parserName ? (0, $40ab59f44b7d2db6$export$c88237b7c265b36b)(parserName) : null;
            if (parserName && !parser) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
            orderDefList.push({
                dimIdx: dimInfo.index,
                parser: parser,
                comparator: new (0, $40ab59f44b7d2db6$export$ed75a5d7b0144167)(order, incomparable)
            });
        });
        // TODO: support it?
        var sourceFormat = upstream.sourceFormat;
        if (sourceFormat !== (0, $cab29724515ce2b8$export$fcd62ebf51387903) && sourceFormat !== (0, $cab29724515ce2b8$export$703ae8a2d83f441)) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
        // Other upstream format are all array.
        var resultData = [];
        for(var i = 0, len = upstream.count(); i < len; i++)resultData.push(upstream.getRawDataItem(i));
        resultData.sort(function(item0, item1) {
            for(var i = 0; i < orderDefList.length; i++){
                var orderDef = orderDefList[i];
                var val0 = upstream.retrieveValueFromItem(item0, orderDef.dimIdx);
                var val1 = upstream.retrieveValueFromItem(item1, orderDef.dimIdx);
                if (orderDef.parser) {
                    val0 = orderDef.parser(val0);
                    val1 = orderDef.parser(val1);
                }
                var result = orderDef.comparator.evaluate(val0, val1);
                if (result !== 0) return result;
            }
            return 0;
        });
        return {
            data: resultData
        };
    }
};


function $d6bad095dfa9594d$export$4b3e715f166fdd78(registers) {
    registers.registerTransform((0, $0e1e10ffafe52e71$export$dc15474d94cdc2b3));
    registers.registerTransform((0, $7781c153e964c2e9$export$505f1bb66427eaee));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @file Visual mapping.
 */ 
var $ef3bd976f9d1f7a2$var$visualDefault = {
    /**
   * @public
   */ get: function(visualType, key, isCategory) {
        var value = $7a1bd9c2710fea0d$export$9cd59f9826255e47(($ef3bd976f9d1f7a2$var$defaultOption[visualType] || {})[key]);
        return isCategory ? $7a1bd9c2710fea0d$export$43bee75e5e14138e(value) ? value[value.length - 1] : value : value;
    }
};
var $ef3bd976f9d1f7a2$var$defaultOption = {
    color: {
        active: [
            '#006edd',
            '#e0ffff'
        ],
        inactive: [
            'rgba(0,0,0,0)'
        ]
    },
    colorHue: {
        active: [
            0,
            360
        ],
        inactive: [
            0,
            0
        ]
    },
    colorSaturation: {
        active: [
            0.3,
            1
        ],
        inactive: [
            0,
            0
        ]
    },
    colorLightness: {
        active: [
            0.9,
            0.5
        ],
        inactive: [
            0,
            0
        ]
    },
    colorAlpha: {
        active: [
            0.3,
            1
        ],
        inactive: [
            0,
            0
        ]
    },
    opacity: {
        active: [
            0.3,
            1
        ],
        inactive: [
            0,
            0
        ]
    },
    symbol: {
        active: [
            'circle',
            'roundRect',
            'diamond'
        ],
        inactive: [
            'none'
        ]
    },
    symbolSize: {
        active: [
            10,
            50
        ],
        inactive: [
            0,
            0
        ]
    }
};
var $ef3bd976f9d1f7a2$export$2e2bcd8739ae039 = $ef3bd976f9d1f7a2$var$visualDefault;







var $fca0c970f405ff38$var$mapVisual = (0, $7b50f502cfd189d5$export$2e2bcd8739ae039).mapVisual;
var $fca0c970f405ff38$var$eachVisual = (0, $7b50f502cfd189d5$export$2e2bcd8739ae039).eachVisual;
var $fca0c970f405ff38$var$isArray = $7a1bd9c2710fea0d$export$43bee75e5e14138e;
var $fca0c970f405ff38$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
var $fca0c970f405ff38$var$asc = $cfc1f3b422a3185f$export$debe6e778e0a6d32;
var $fca0c970f405ff38$var$linearMap = $cfc1f3b422a3185f$export$d3f68fbaa670562;
var $fca0c970f405ff38$var$VisualMapModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(VisualMapModel, _super);
    function VisualMapModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = VisualMapModel.type;
        _this.stateList = [
            'inRange',
            'outOfRange'
        ];
        _this.replacableOptionKeys = [
            'inRange',
            'outOfRange',
            'target',
            'controller',
            'color'
        ];
        _this.layoutMode = {
            type: 'box',
            ignoreSize: true
        };
        /**
     * [lowerBound, upperBound]
     */ _this.dataBound = [
            -Infinity,
            Infinity
        ];
        _this.targetVisuals = {};
        _this.controllerVisuals = {};
        return _this;
    }
    VisualMapModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
    };
    /**
   * @protected
   */ VisualMapModel.prototype.optionUpdated = function(newOption, isInit) {
        var thisOption = this.option;
        !isInit && $87ea23222d1c134e$export$797d20c0a6de578f(thisOption, newOption, this.replacableOptionKeys);
        this.textStyleModel = this.getModel('textStyle');
        this.resetItemSize();
        this.completeVisualOption();
    };
    /**
   * @protected
   */ VisualMapModel.prototype.resetVisual = function(supplementVisualOption) {
        var stateList = this.stateList;
        supplementVisualOption = $7a1bd9c2710fea0d$export$2385a24977818dd0(supplementVisualOption, this);
        this.controllerVisuals = $87ea23222d1c134e$export$89974527642f24a0(this.option.controller, stateList, supplementVisualOption);
        this.targetVisuals = $87ea23222d1c134e$export$89974527642f24a0(this.option.target, stateList, supplementVisualOption);
    };
    /**
   * @public
   */ VisualMapModel.prototype.getItemSymbol = function() {
        return null;
    };
    /**
   * @protected
   * @return {Array.<number>} An array of series indices.
   */ VisualMapModel.prototype.getTargetSeriesIndices = function() {
        var optionSeriesIndex = this.option.seriesIndex;
        var seriesIndices = [];
        if (optionSeriesIndex == null || optionSeriesIndex === 'all') this.ecModel.eachSeries(function(seriesModel, index) {
            seriesIndices.push(index);
        });
        else seriesIndices = $76d619f648247e6d$export$4f07b212a02c8051(optionSeriesIndex);
        return seriesIndices;
    };
    /**
   * @public
   */ VisualMapModel.prototype.eachTargetSeries = function(callback, context) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(this.getTargetSeriesIndices(), function(seriesIndex) {
            var seriesModel = this.ecModel.getSeriesByIndex(seriesIndex);
            if (seriesModel) callback.call(context, seriesModel);
        }, this);
    };
    /**
   * @pubilc
   */ VisualMapModel.prototype.isTargetSeries = function(seriesModel) {
        var is = false;
        this.eachTargetSeries(function(model) {
            model === seriesModel && (is = true);
        });
        return is;
    };
    /**
   * @example
   * this.formatValueText(someVal); // format single numeric value to text.
   * this.formatValueText(someVal, true); // format single category value to text.
   * this.formatValueText([min, max]); // format numeric min-max to text.
   * this.formatValueText([this.dataBound[0], max]); // using data lower bound.
   * this.formatValueText([min, this.dataBound[1]]); // using data upper bound.
   *
   * @param value Real value, or this.dataBound[0 or 1].
   * @param isCategory Only available when value is number.
   * @param edgeSymbols Open-close symbol when value is interval.
   * @protected
   */ VisualMapModel.prototype.formatValueText = function(value, isCategory, edgeSymbols) {
        var option = this.option;
        var precision = option.precision;
        var dataBound = this.dataBound;
        var formatter = option.formatter;
        var isMinMax;
        edgeSymbols = edgeSymbols || [
            '<',
            '>'
        ];
        if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(value)) {
            value = value.slice();
            isMinMax = true;
        }
        var textValue = isCategory ? value // Value is string when isCategory
         : isMinMax ? [
            toFixed(value[0]),
            toFixed(value[1])
        ] : toFixed(value);
        if ($7a1bd9c2710fea0d$export$844ec244b1367d54(formatter)) return formatter.replace('{value}', isMinMax ? textValue[0] : textValue).replace('{value2}', isMinMax ? textValue[1] : textValue);
        else if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(formatter)) return isMinMax ? formatter(value[0], value[1]) : formatter(value);
        if (isMinMax) {
            if (value[0] === dataBound[0]) return edgeSymbols[0] + ' ' + textValue[1];
            else if (value[1] === dataBound[1]) return edgeSymbols[1] + ' ' + textValue[0];
            else return textValue[0] + ' - ' + textValue[1];
        } else // Format single value (includes category case).
        return textValue;
        function toFixed(val) {
            return val === dataBound[0] ? 'min' : val === dataBound[1] ? 'max' : (+val).toFixed(Math.min(precision, 20));
        }
    };
    /**
   * @protected
   */ VisualMapModel.prototype.resetExtent = function() {
        var thisOption = this.option;
        // Can not calculate data extent by data here.
        // Because series and data may be modified in processing stage.
        // So we do not support the feature "auto min/max".
        var extent = $fca0c970f405ff38$var$asc([
            thisOption.min,
            thisOption.max
        ]);
        this._dataExtent = extent;
    };
    /**
   * PENDING:
   * delete this method if no outer usage.
   *
   * Return  Concrete dimension. If null/undefined is returned, no dimension is used.
   */ // getDataDimension(data: SeriesData) {
    //     const optDim = this.option.dimension;
    //     if (optDim != null) {
    //         return data.getDimension(optDim);
    //     }
    //     const dimNames = data.dimensions;
    //     for (let i = dimNames.length - 1; i >= 0; i--) {
    //         const dimName = dimNames[i];
    //         const dimInfo = data.getDimensionInfo(dimName);
    //         if (!dimInfo.isCalculationCoord) {
    //             return dimName;
    //         }
    //     }
    // }
    VisualMapModel.prototype.getDataDimensionIndex = function(data) {
        var optDim = this.option.dimension;
        if (optDim != null) return data.getDimensionIndex(optDim);
        var dimNames = data.dimensions;
        for(var i = dimNames.length - 1; i >= 0; i--){
            var dimName = dimNames[i];
            var dimInfo = data.getDimensionInfo(dimName);
            if (!dimInfo.isCalculationCoord) return dimInfo.storeDimIndex;
        }
    };
    VisualMapModel.prototype.getExtent = function() {
        return this._dataExtent.slice();
    };
    VisualMapModel.prototype.completeVisualOption = function() {
        var ecModel = this.ecModel;
        var thisOption = this.option;
        var base = {
            inRange: thisOption.inRange,
            outOfRange: thisOption.outOfRange
        };
        var target = thisOption.target || (thisOption.target = {});
        var controller = thisOption.controller || (thisOption.controller = {});
        $7a1bd9c2710fea0d$export$4950aa0f605343fb(target, base); // Do not override
        $7a1bd9c2710fea0d$export$4950aa0f605343fb(controller, base); // Do not override
        var isCategory = this.isCategory();
        completeSingle.call(this, target);
        completeSingle.call(this, controller);
        completeInactive.call(this, target, 'inRange', 'outOfRange');
        // completeInactive.call(this, target, 'outOfRange', 'inRange');
        completeController.call(this, controller);
        function completeSingle(base) {
            // Compatible with ec2 dataRange.color.
            // The mapping order of dataRange.color is: [high value, ..., low value]
            // whereas inRange.color and outOfRange.color is [low value, ..., high value]
            // Notice: ec2 has no inverse.
            if ($fca0c970f405ff38$var$isArray(thisOption.color) && !base.inRange) base.inRange = {
                color: thisOption.color.slice().reverse()
            };
            // Compatible with previous logic, always give a default color, otherwise
            // simple config with no inRange and outOfRange will not work.
            // Originally we use visualMap.color as the default color, but setOption at
            // the second time the default color will be erased. So we change to use
            // constant DEFAULT_COLOR.
            // If user do not want the default color, set inRange: {color: null}.
            base.inRange = base.inRange || {
                color: ecModel.get('gradientColor')
            };
        }
        function completeInactive(base, stateExist, stateAbsent) {
            var optExist = base[stateExist];
            var optAbsent = base[stateAbsent];
            if (optExist && !optAbsent) {
                optAbsent = base[stateAbsent] = {};
                $fca0c970f405ff38$var$each(optExist, function(visualData, visualType) {
                    if (!(0, $7b50f502cfd189d5$export$2e2bcd8739ae039).isValidType(visualType)) return;
                    var defa = (0, $ef3bd976f9d1f7a2$export$2e2bcd8739ae039).get(visualType, 'inactive', isCategory);
                    if (defa != null) {
                        optAbsent[visualType] = defa;
                        // Compatibable with ec2:
                        // Only inactive color to rgba(0,0,0,0) can not
                        // make label transparent, so use opacity also.
                        if (visualType === 'color' && !optAbsent.hasOwnProperty('opacity') && !optAbsent.hasOwnProperty('colorAlpha')) optAbsent.opacity = [
                            0,
                            0
                        ];
                    }
                });
            }
        }
        function completeController(controller) {
            var symbolExists = (controller.inRange || {}).symbol || (controller.outOfRange || {}).symbol;
            var symbolSizeExists = (controller.inRange || {}).symbolSize || (controller.outOfRange || {}).symbolSize;
            var inactiveColor = this.get('inactiveColor');
            var itemSymbol = this.getItemSymbol();
            var defaultSymbol = itemSymbol || 'roundRect';
            $fca0c970f405ff38$var$each(this.stateList, function(state) {
                var itemSize = this.itemSize;
                var visuals = controller[state];
                // Set inactive color for controller if no other color
                // attr (like colorAlpha) specified.
                if (!visuals) visuals = controller[state] = {
                    color: isCategory ? inactiveColor : [
                        inactiveColor
                    ]
                };
                // Consistent symbol and symbolSize if not specified.
                if (visuals.symbol == null) visuals.symbol = symbolExists && $7a1bd9c2710fea0d$export$9cd59f9826255e47(symbolExists) || (isCategory ? defaultSymbol : [
                    defaultSymbol
                ]);
                if (visuals.symbolSize == null) visuals.symbolSize = symbolSizeExists && $7a1bd9c2710fea0d$export$9cd59f9826255e47(symbolSizeExists) || (isCategory ? itemSize[0] : [
                    itemSize[0],
                    itemSize[0]
                ]);
                // Filter none
                visuals.symbol = $fca0c970f405ff38$var$mapVisual(visuals.symbol, function(symbol) {
                    return symbol === 'none' ? defaultSymbol : symbol;
                });
                // Normalize symbolSize
                var symbolSize = visuals.symbolSize;
                if (symbolSize != null) {
                    var max_1 = -Infinity;
                    // symbolSize can be object when categories defined.
                    $fca0c970f405ff38$var$eachVisual(symbolSize, function(value) {
                        value > max_1 && (max_1 = value);
                    });
                    visuals.symbolSize = $fca0c970f405ff38$var$mapVisual(symbolSize, function(value) {
                        return $fca0c970f405ff38$var$linearMap(value, [
                            0,
                            max_1
                        ], [
                            0,
                            itemSize[0]
                        ], true);
                    });
                }
            }, this);
        }
    };
    VisualMapModel.prototype.resetItemSize = function() {
        this.itemSize = [
            parseFloat(this.get('itemWidth')),
            parseFloat(this.get('itemHeight'))
        ];
    };
    VisualMapModel.prototype.isCategory = function() {
        return !!this.option.categories;
    };
    /**
   * @public
   * @abstract
   */ VisualMapModel.prototype.setSelected = function(selected) {};
    VisualMapModel.prototype.getSelected = function() {
        return null;
    };
    /**
   * @public
   * @abstract
   */ VisualMapModel.prototype.getValueState = function(value) {
        return null;
    };
    /**
   * FIXME
   * Do not publish to thirt-part-dev temporarily
   * util the interface is stable. (Should it return
   * a function but not visual meta?)
   *
   * @pubilc
   * @abstract
   * @param getColorVisual
   *        params: value, valueState
   *        return: color
   * @return {Object} visualMeta
   *        should includes {stops, outerColors}
   *        outerColor means [colorBeyondMinValue, colorBeyondMaxValue]
   */ VisualMapModel.prototype.getVisualMeta = function(getColorVisual) {
        return null;
    };
    VisualMapModel.type = 'visualMap';
    VisualMapModel.dependencies = [
        'series'
    ];
    VisualMapModel.defaultOption = {
        show: true,
        // zlevel: 0,
        z: 4,
        seriesIndex: 'all',
        min: 0,
        max: 200,
        left: 0,
        right: null,
        top: null,
        bottom: 0,
        itemWidth: null,
        itemHeight: null,
        inverse: false,
        orient: 'vertical',
        backgroundColor: 'rgba(0,0,0,0)',
        borderColor: '#ccc',
        contentColor: '#5793f3',
        inactiveColor: '#aaa',
        borderWidth: 0,
        padding: 5,
        // 接受数组分别设定上右下左边距，同css
        textGap: 10,
        precision: 0,
        textStyle: {
            color: '#333' // 值域文字颜色
        }
    };
    return VisualMapModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $fca0c970f405ff38$export$2e2bcd8739ae039 = $fca0c970f405ff38$var$VisualMapModel;




// Constant
var $91b3756da4f00019$var$DEFAULT_BAR_BOUND = [
    20,
    140
];
var $91b3756da4f00019$var$ContinuousModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ContinuousModel, _super);
    function ContinuousModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ContinuousModel.type;
        return _this;
    }
    /**
   * @override
   */ ContinuousModel.prototype.optionUpdated = function(newOption, isInit) {
        _super.prototype.optionUpdated.apply(this, arguments);
        this.resetExtent();
        this.resetVisual(function(mappingOption) {
            mappingOption.mappingMethod = 'linear';
            mappingOption.dataExtent = this.getExtent();
        });
        this._resetRange();
    };
    /**
   * @protected
   * @override
   */ ContinuousModel.prototype.resetItemSize = function() {
        _super.prototype.resetItemSize.apply(this, arguments);
        var itemSize = this.itemSize;
        (itemSize[0] == null || isNaN(itemSize[0])) && (itemSize[0] = $91b3756da4f00019$var$DEFAULT_BAR_BOUND[0]);
        (itemSize[1] == null || isNaN(itemSize[1])) && (itemSize[1] = $91b3756da4f00019$var$DEFAULT_BAR_BOUND[1]);
    };
    /**
   * @private
   */ ContinuousModel.prototype._resetRange = function() {
        var dataExtent = this.getExtent();
        var range = this.option.range;
        if (!range || range.auto) {
            // `range` should always be array (so we don't use other
            // value like 'auto') for user-friend. (consider getOption).
            dataExtent.auto = 1;
            this.option.range = dataExtent;
        } else if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(range)) {
            if (range[0] > range[1]) range.reverse();
            range[0] = Math.max(range[0], dataExtent[0]);
            range[1] = Math.min(range[1], dataExtent[1]);
        }
    };
    /**
   * @protected
   * @override
   */ ContinuousModel.prototype.completeVisualOption = function() {
        _super.prototype.completeVisualOption.apply(this, arguments);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(this.stateList, function(state) {
            var symbolSize = this.option.controller[state].symbolSize;
            if (symbolSize && symbolSize[0] !== symbolSize[1]) symbolSize[0] = symbolSize[1] / 3; // For good looking.
        }, this);
    };
    /**
   * @override
   */ ContinuousModel.prototype.setSelected = function(selected) {
        this.option.range = selected.slice();
        this._resetRange();
    };
    /**
   * @public
   */ ContinuousModel.prototype.getSelected = function() {
        var dataExtent = this.getExtent();
        var dataInterval = $cfc1f3b422a3185f$export$debe6e778e0a6d32((this.get('range') || []).slice());
        // Clamp
        dataInterval[0] > dataExtent[1] && (dataInterval[0] = dataExtent[1]);
        dataInterval[1] > dataExtent[1] && (dataInterval[1] = dataExtent[1]);
        dataInterval[0] < dataExtent[0] && (dataInterval[0] = dataExtent[0]);
        dataInterval[1] < dataExtent[0] && (dataInterval[1] = dataExtent[0]);
        return dataInterval;
    };
    /**
   * @override
   */ ContinuousModel.prototype.getValueState = function(value) {
        var range = this.option.range;
        var dataExtent = this.getExtent();
        // When range[0] === dataExtent[0], any value larger than dataExtent[0] maps to 'inRange'.
        // range[1] is processed likewise.
        return (range[0] <= dataExtent[0] || range[0] <= value) && (range[1] >= dataExtent[1] || value <= range[1]) ? 'inRange' : 'outOfRange';
    };
    ContinuousModel.prototype.findTargetDataIndices = function(range) {
        var result = [];
        this.eachTargetSeries(function(seriesModel) {
            var dataIndices = [];
            var data = seriesModel.getData();
            data.each(this.getDataDimensionIndex(data), function(value, dataIndex) {
                range[0] <= value && value <= range[1] && dataIndices.push(dataIndex);
            }, this);
            result.push({
                seriesId: seriesModel.id,
                dataIndex: dataIndices
            });
        }, this);
        return result;
    };
    /**
   * @implement
   */ ContinuousModel.prototype.getVisualMeta = function(getColorVisual) {
        var oVals = $91b3756da4f00019$var$getColorStopValues(this, 'outOfRange', this.getExtent());
        var iVals = $91b3756da4f00019$var$getColorStopValues(this, 'inRange', this.option.range.slice());
        var stops = [];
        function setStop(value, valueState) {
            stops.push({
                value: value,
                color: getColorVisual(value, valueState)
            });
        }
        // Format to: outOfRange -- inRange -- outOfRange.
        var iIdx = 0;
        var oIdx = 0;
        var iLen = iVals.length;
        var oLen = oVals.length;
        for(; oIdx < oLen && (!iVals.length || oVals[oIdx] <= iVals[0]); oIdx++)// If oVal[oIdx] === iVals[iIdx], oVal[oIdx] should be ignored.
        if (oVals[oIdx] < iVals[iIdx]) setStop(oVals[oIdx], 'outOfRange');
        for(var first = 1; iIdx < iLen; iIdx++, first = 0){
            // If range is full, value beyond min, max will be clamped.
            // make a singularity
            first && stops.length && setStop(iVals[iIdx], 'outOfRange');
            setStop(iVals[iIdx], 'inRange');
        }
        for(var first = 1; oIdx < oLen; oIdx++)if (!iVals.length || iVals[iVals.length - 1] < oVals[oIdx]) {
            // make a singularity
            if (first) {
                stops.length && setStop(stops[stops.length - 1].value, 'outOfRange');
                first = 0;
            }
            setStop(oVals[oIdx], 'outOfRange');
        }
        var stopsLen = stops.length;
        return {
            stops: stops,
            outerColors: [
                stopsLen ? stops[0].color : 'transparent',
                stopsLen ? stops[stopsLen - 1].color : 'transparent'
            ]
        };
    };
    ContinuousModel.type = 'visualMap.continuous';
    ContinuousModel.defaultOption = (0, $5370df662b2caf37$export$68acc510e46fef2)((0, $fca0c970f405ff38$export$2e2bcd8739ae039).defaultOption, {
        align: 'auto',
        calculable: false,
        hoverLink: true,
        realtime: true,
        handleIcon: 'path://M-11.39,9.77h0a3.5,3.5,0,0,1-3.5,3.5h-22a3.5,3.5,0,0,1-3.5-3.5h0a3.5,3.5,0,0,1,3.5-3.5h22A3.5,3.5,0,0,1-11.39,9.77Z',
        handleSize: '120%',
        handleStyle: {
            borderColor: '#fff',
            borderWidth: 1
        },
        indicatorIcon: 'circle',
        indicatorSize: '50%',
        indicatorStyle: {
            borderColor: '#fff',
            borderWidth: 2,
            shadowBlur: 2,
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowColor: 'rgba(0,0,0,0.2)'
        }
    });
    return ContinuousModel;
}((0, $fca0c970f405ff38$export$2e2bcd8739ae039));
function $91b3756da4f00019$var$getColorStopValues(visualMapModel, valueState, dataExtent) {
    if (dataExtent[0] === dataExtent[1]) return dataExtent.slice();
    // When using colorHue mapping, it is not linear color any more.
    // Moreover, canvas gradient seems not to be accurate linear.
    // FIXME
    // Should be arbitrary value 100? or based on pixel size?
    var count = 200;
    var step = (dataExtent[1] - dataExtent[0]) / count;
    var value = dataExtent[0];
    var stopValues = [];
    for(var i = 0; i <= count && value < dataExtent[1]; i++){
        stopValues.push(value);
        value += step;
    }
    stopValues.push(dataExtent[1]);
    return stopValues;
}
var $91b3756da4f00019$export$2e2bcd8739ae039 = $91b3756da4f00019$var$ContinuousModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $0eb56f276c16b145$var$VisualMapView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(VisualMapView, _super);
    function VisualMapView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = VisualMapView.type;
        _this.autoPositionValues = {
            left: 1,
            right: 1,
            top: 1,
            bottom: 1
        };
        return _this;
    }
    VisualMapView.prototype.init = function(ecModel, api) {
        this.ecModel = ecModel;
        this.api = api;
    };
    /**
   * @protected
   */ VisualMapView.prototype.render = function(visualMapModel, ecModel, api, payload // TODO: TYPE
    ) {
        this.visualMapModel = visualMapModel;
        if (visualMapModel.get('show') === false) {
            this.group.removeAll();
            return;
        }
        this.doRender(visualMapModel, ecModel, api, payload);
    };
    /**
   * @protected
   */ VisualMapView.prototype.renderBackground = function(group) {
        var visualMapModel = this.visualMapModel;
        var padding = $c84c9521536c601a$export$f3a38102c49f4268(visualMapModel.get('padding') || 0);
        var rect = group.getBoundingRect();
        group.add(new (0, $419e5ff2f303755e$export$2e2bcd8739ae039)({
            z2: -1,
            silent: true,
            shape: {
                x: rect.x - padding[3],
                y: rect.y - padding[0],
                width: rect.width + padding[3] + padding[1],
                height: rect.height + padding[0] + padding[2]
            },
            style: {
                fill: visualMapModel.get('backgroundColor'),
                stroke: visualMapModel.get('borderColor'),
                lineWidth: visualMapModel.get('borderWidth')
            }
        }));
    };
    /**
   * @protected
   * @param targetValue can be Infinity or -Infinity
   * @param visualCluster Only can be 'color' 'opacity' 'symbol' 'symbolSize'
   * @param opts
   * @param opts.forceState Specify state, instead of using getValueState method.
   * @param opts.convertOpacityToAlpha For color gradient in controller widget.
   * @return {*} Visual value.
   */ VisualMapView.prototype.getControllerVisual = function(targetValue, visualCluster, opts) {
        opts = opts || {};
        var forceState = opts.forceState;
        var visualMapModel = this.visualMapModel;
        var visualObj = {};
        // Default values.
        if (visualCluster === 'color') {
            var defaultColor = visualMapModel.get('contentColor');
            visualObj.color = defaultColor;
        }
        function getter(key) {
            return visualObj[key];
        }
        function setter(key, value) {
            visualObj[key] = value;
        }
        var mappings = visualMapModel.controllerVisuals[forceState || visualMapModel.getValueState(targetValue)];
        var visualTypes = (0, $7b50f502cfd189d5$export$2e2bcd8739ae039).prepareVisualTypes(mappings);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(visualTypes, function(type) {
            var visualMapping = mappings[type];
            if (opts.convertOpacityToAlpha && type === 'opacity') {
                type = 'colorAlpha';
                visualMapping = mappings.__alphaForOpacity;
            }
            if ((0, $7b50f502cfd189d5$export$2e2bcd8739ae039).dependsOn(type, visualCluster)) visualMapping && visualMapping.applyVisual(targetValue, getter, setter);
        });
        return visualObj[visualCluster];
    };
    VisualMapView.prototype.positionGroup = function(group) {
        var model = this.visualMapModel;
        var api = this.api;
        $93b9bc7f22ac7369$export$74054bd96b5eeef1(group, model.getBoxLayoutParams(), {
            width: api.getWidth(),
            height: api.getHeight()
        });
    };
    VisualMapView.prototype.doRender = function(visualMapModel, ecModel, api, payload) {};
    VisualMapView.type = 'visualMap';
    return VisualMapView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $0eb56f276c16b145$export$2e2bcd8739ae039 = $0eb56f276c16b145$var$VisualMapView;





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $1a17eb3ffb707117$var$paramsSet = [
    [
        'left',
        'right',
        'width'
    ],
    [
        'top',
        'bottom',
        'height'
    ]
];
function $1a17eb3ffb707117$export$dca53c4702e35c6(visualMapModel, api, itemSize) {
    var modelOption = visualMapModel.option;
    var itemAlign = modelOption.align;
    if (itemAlign != null && itemAlign !== 'auto') return itemAlign;
    // Auto decision align.
    var ecSize = {
        width: api.getWidth(),
        height: api.getHeight()
    };
    var realIndex = modelOption.orient === 'horizontal' ? 1 : 0;
    var reals = $1a17eb3ffb707117$var$paramsSet[realIndex];
    var fakeValue = [
        0,
        null,
        10
    ];
    var layoutInput = {};
    for(var i = 0; i < 3; i++){
        layoutInput[$1a17eb3ffb707117$var$paramsSet[1 - realIndex][i]] = fakeValue[i];
        layoutInput[reals[i]] = i === 2 ? itemSize[0] : modelOption[reals[i]];
    }
    var rParam = [
        [
            'x',
            'width',
            3
        ],
        [
            'y',
            'height',
            0
        ]
    ][realIndex];
    var rect = (0, $93b9bc7f22ac7369$export$4517a5ca639a7293)(layoutInput, ecSize, modelOption.padding);
    return reals[(rect.margin[rParam[2]] || 0) + rect[rParam[0]] + rect[rParam[1]] * 0.5 < ecSize[rParam[1]] * 0.5 ? 0 : 1];
}
function $1a17eb3ffb707117$export$5381a9dc5427ba18(batch, visualMapModel) {
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(batch || [], function(batchItem) {
        if (batchItem.dataIndex != null) {
            batchItem.dataIndexInside = batchItem.dataIndex;
            batchItem.dataIndex = null;
        }
        batchItem.highlightKey = 'visualMap' + (visualMapModel ? visualMapModel.componentIndex : '');
    });
    return batch;
}










var $46b89608ba6c0e8b$var$linearMap = $cfc1f3b422a3185f$export$d3f68fbaa670562;
var $46b89608ba6c0e8b$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
var $46b89608ba6c0e8b$var$mathMin = Math.min;
var $46b89608ba6c0e8b$var$mathMax = Math.max;
// Arbitrary value
var $46b89608ba6c0e8b$var$HOVER_LINK_SIZE = 12;
var $46b89608ba6c0e8b$var$HOVER_LINK_OUT = 6;
// Notice:
// Any "interval" should be by the order of [low, high].
// "handle0" (handleIndex === 0) maps to
// low data value: this._dataInterval[0] and has low coord.
// "handle1" (handleIndex === 1) maps to
// high data value: this._dataInterval[1] and has high coord.
// The logic of transform is implemented in this._createBarGroup.
var $46b89608ba6c0e8b$var$ContinuousView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ContinuousView, _super);
    function ContinuousView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ContinuousView.type;
        _this._shapes = {};
        _this._dataInterval = [];
        _this._handleEnds = [];
        _this._hoverLinkDataIndices = [];
        return _this;
    }
    ContinuousView.prototype.init = function(ecModel, api) {
        _super.prototype.init.call(this, ecModel, api);
        this._hoverLinkFromSeriesMouseOver = $7a1bd9c2710fea0d$export$2385a24977818dd0(this._hoverLinkFromSeriesMouseOver, this);
        this._hideIndicator = $7a1bd9c2710fea0d$export$2385a24977818dd0(this._hideIndicator, this);
    };
    ContinuousView.prototype.doRender = function(visualMapModel, ecModel, api, payload) {
        if (!payload || payload.type !== 'selectDataRange' || payload.from !== this.uid) this._buildView();
    };
    ContinuousView.prototype._buildView = function() {
        this.group.removeAll();
        var visualMapModel = this.visualMapModel;
        var thisGroup = this.group;
        this._orient = visualMapModel.get('orient');
        this._useHandle = visualMapModel.get('calculable');
        this._resetInterval();
        this._renderBar(thisGroup);
        var dataRangeText = visualMapModel.get('text');
        this._renderEndsText(thisGroup, dataRangeText, 0);
        this._renderEndsText(thisGroup, dataRangeText, 1);
        // Do this for background size calculation.
        this._updateView(true);
        // After updating view, inner shapes is built completely,
        // and then background can be rendered.
        this.renderBackground(thisGroup);
        // Real update view
        this._updateView();
        this._enableHoverLinkToSeries();
        this._enableHoverLinkFromSeries();
        this.positionGroup(thisGroup);
    };
    ContinuousView.prototype._renderEndsText = function(group, dataRangeText, endsIndex) {
        if (!dataRangeText) return;
        // Compatible with ec2, text[0] map to high value, text[1] map low value.
        var text = dataRangeText[1 - endsIndex];
        text = text != null ? text + '' : '';
        var visualMapModel = this.visualMapModel;
        var textGap = visualMapModel.get('textGap');
        var itemSize = visualMapModel.itemSize;
        var barGroup = this._shapes.mainGroup;
        var position = this._applyTransform([
            itemSize[0] / 2,
            endsIndex === 0 ? -textGap : itemSize[1] + textGap
        ], barGroup);
        var align = this._applyTransform(endsIndex === 0 ? 'bottom' : 'top', barGroup);
        var orient = this._orient;
        var textStyleModel = this.visualMapModel.textStyleModel;
        this.group.add(new $fe885cc21795562b$export$2e2bcd8739ae039({
            style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(textStyleModel, {
                x: position[0],
                y: position[1],
                verticalAlign: orient === 'horizontal' ? 'middle' : align,
                align: orient === 'horizontal' ? align : 'center',
                text: text
            })
        }));
    };
    ContinuousView.prototype._renderBar = function(targetGroup) {
        var visualMapModel = this.visualMapModel;
        var shapes = this._shapes;
        var itemSize = visualMapModel.itemSize;
        var orient = this._orient;
        var useHandle = this._useHandle;
        var itemAlign = $1a17eb3ffb707117$export$dca53c4702e35c6(visualMapModel, this.api, itemSize);
        var mainGroup = shapes.mainGroup = this._createBarGroup(itemAlign);
        var gradientBarGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        mainGroup.add(gradientBarGroup);
        // Bar
        gradientBarGroup.add(shapes.outOfRange = $46b89608ba6c0e8b$var$createPolygon());
        gradientBarGroup.add(shapes.inRange = $46b89608ba6c0e8b$var$createPolygon(null, useHandle ? $46b89608ba6c0e8b$var$getCursor(this._orient) : null, $7a1bd9c2710fea0d$export$2385a24977818dd0(this._dragHandle, this, 'all', false), $7a1bd9c2710fea0d$export$2385a24977818dd0(this._dragHandle, this, 'all', true)));
        // A border radius clip.
        gradientBarGroup.setClipPath(new $419e5ff2f303755e$export$2e2bcd8739ae039({
            shape: {
                x: 0,
                y: 0,
                width: itemSize[0],
                height: itemSize[1],
                r: 3
            }
        }));
        var textRect = visualMapModel.textStyleModel.getTextRect("\u56FD");
        var textSize = $46b89608ba6c0e8b$var$mathMax(textRect.width, textRect.height);
        // Handle
        if (useHandle) {
            shapes.handleThumbs = [];
            shapes.handleLabels = [];
            shapes.handleLabelPoints = [];
            this._createHandle(visualMapModel, mainGroup, 0, itemSize, textSize, orient);
            this._createHandle(visualMapModel, mainGroup, 1, itemSize, textSize, orient);
        }
        this._createIndicator(visualMapModel, mainGroup, itemSize, textSize, orient);
        targetGroup.add(mainGroup);
    };
    ContinuousView.prototype._createHandle = function(visualMapModel, mainGroup, handleIndex, itemSize, textSize, orient) {
        var onDrift = $7a1bd9c2710fea0d$export$2385a24977818dd0(this._dragHandle, this, handleIndex, false);
        var onDragEnd = $7a1bd9c2710fea0d$export$2385a24977818dd0(this._dragHandle, this, handleIndex, true);
        var handleSize = (0, $6c308355c7107803$export$e8514cb5a5e2b40f)(visualMapModel.get('handleSize'), itemSize[0]);
        var handleThumb = (0, $5370466dadc978d7$export$af050e04da3a02e8)(visualMapModel.get('handleIcon'), -handleSize / 2, -handleSize / 2, handleSize, handleSize, null, true);
        var cursor = $46b89608ba6c0e8b$var$getCursor(this._orient);
        handleThumb.attr({
            cursor: cursor,
            draggable: true,
            drift: onDrift,
            ondragend: onDragEnd,
            onmousemove: function(e) {
                $b3864a78637ff9ed$export$fa6813432f753b0d(e.event);
            }
        });
        handleThumb.x = itemSize[0] / 2;
        handleThumb.useStyle(visualMapModel.getModel('handleStyle').getItemStyle());
        handleThumb.setStyle({
            strokeNoScale: true,
            strokeFirst: true
        });
        handleThumb.style.lineWidth *= 2;
        handleThumb.ensureState('emphasis').style = visualMapModel.getModel([
            'emphasis',
            'handleStyle'
        ]).getItemStyle();
        (0, $2bf82c0980125b62$export$9ba15aea1e048d48)(handleThumb, true);
        mainGroup.add(handleThumb);
        // Text is always horizontal layout but should not be effected by
        // transform (orient/inverse). So label is built separately but not
        // use zrender/graphic/helper/RectText, and is located based on view
        // group (according to handleLabelPoint) but not barGroup.
        var textStyleModel = this.visualMapModel.textStyleModel;
        var handleLabel = new $fe885cc21795562b$export$2e2bcd8739ae039({
            cursor: cursor,
            draggable: true,
            drift: onDrift,
            onmousemove: function(e) {
                // For mobile device, prevent screen slider on the button.
                $b3864a78637ff9ed$export$fa6813432f753b0d(e.event);
            },
            ondragend: onDragEnd,
            style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(textStyleModel, {
                x: 0,
                y: 0,
                text: ''
            })
        });
        handleLabel.ensureState('blur').style = {
            opacity: 0.1
        };
        handleLabel.stateTransition = {
            duration: 200
        };
        this.group.add(handleLabel);
        var handleLabelPoint = [
            handleSize,
            0
        ];
        var shapes = this._shapes;
        shapes.handleThumbs[handleIndex] = handleThumb;
        shapes.handleLabelPoints[handleIndex] = handleLabelPoint;
        shapes.handleLabels[handleIndex] = handleLabel;
    };
    ContinuousView.prototype._createIndicator = function(visualMapModel, mainGroup, itemSize, textSize, orient) {
        var scale = (0, $6c308355c7107803$export$e8514cb5a5e2b40f)(visualMapModel.get('indicatorSize'), itemSize[0]);
        var indicator = (0, $5370466dadc978d7$export$af050e04da3a02e8)(visualMapModel.get('indicatorIcon'), -scale / 2, -scale / 2, scale, scale, null, true);
        indicator.attr({
            cursor: 'move',
            invisible: true,
            silent: true,
            x: itemSize[0] / 2
        });
        var indicatorStyle = visualMapModel.getModel('indicatorStyle').getItemStyle();
        if (indicator instanceof (0, $86adec94217b86c6$export$2e2bcd8739ae039)) {
            var pathStyle = indicator.style;
            indicator.useStyle($7a1bd9c2710fea0d$export$8b58be045bf06082({
                // TODO other properties like x, y ?
                image: pathStyle.image,
                x: pathStyle.x,
                y: pathStyle.y,
                width: pathStyle.width,
                height: pathStyle.height
            }, indicatorStyle));
        } else indicator.useStyle(indicatorStyle);
        mainGroup.add(indicator);
        var textStyleModel = this.visualMapModel.textStyleModel;
        var indicatorLabel = new $fe885cc21795562b$export$2e2bcd8739ae039({
            silent: true,
            invisible: true,
            style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(textStyleModel, {
                x: 0,
                y: 0,
                text: ''
            })
        });
        this.group.add(indicatorLabel);
        var indicatorLabelPoint = [
            (orient === 'horizontal' ? textSize / 2 : $46b89608ba6c0e8b$var$HOVER_LINK_OUT) + itemSize[0] / 2,
            0
        ];
        var shapes = this._shapes;
        shapes.indicator = indicator;
        shapes.indicatorLabel = indicatorLabel;
        shapes.indicatorLabelPoint = indicatorLabelPoint;
        this._firstShowIndicator = true;
    };
    ContinuousView.prototype._dragHandle = function(handleIndex, isEnd, // dx is event from ondragend if isEnd is true. It's not used
    dx, dy) {
        if (!this._useHandle) return;
        this._dragging = !isEnd;
        if (!isEnd) {
            // Transform dx, dy to bar coordination.
            var vertex = this._applyTransform([
                dx,
                dy
            ], this._shapes.mainGroup, true);
            this._updateInterval(handleIndex, vertex[1]);
            this._hideIndicator();
            // Considering realtime, update view should be executed
            // before dispatch action.
            this._updateView();
        }
        // dragEnd do not dispatch action when realtime.
        if (isEnd === !this.visualMapModel.get('realtime')) // jshint ignore:line
        this.api.dispatchAction({
            type: 'selectDataRange',
            from: this.uid,
            visualMapId: this.visualMapModel.id,
            selected: this._dataInterval.slice()
        });
        if (isEnd) !this._hovering && this._clearHoverLinkToSeries();
        else if ($46b89608ba6c0e8b$var$useHoverLinkOnHandle(this.visualMapModel)) this._doHoverLinkToSeries(this._handleEnds[handleIndex], false);
    };
    ContinuousView.prototype._resetInterval = function() {
        var visualMapModel = this.visualMapModel;
        var dataInterval = this._dataInterval = visualMapModel.getSelected();
        var dataExtent = visualMapModel.getExtent();
        var sizeExtent = [
            0,
            visualMapModel.itemSize[1]
        ];
        this._handleEnds = [
            $46b89608ba6c0e8b$var$linearMap(dataInterval[0], dataExtent, sizeExtent, true),
            $46b89608ba6c0e8b$var$linearMap(dataInterval[1], dataExtent, sizeExtent, true)
        ];
    };
    /**
   * @private
   * @param {(number|string)} handleIndex 0 or 1 or 'all'
   * @param {number} dx
   * @param {number} dy
   */ ContinuousView.prototype._updateInterval = function(handleIndex, delta) {
        delta = delta || 0;
        var visualMapModel = this.visualMapModel;
        var handleEnds = this._handleEnds;
        var sizeExtent = [
            0,
            visualMapModel.itemSize[1]
        ];
        (0, $00a8003b34293330$export$2e2bcd8739ae039)(delta, handleEnds, sizeExtent, handleIndex, // cross is forbidden
        0);
        var dataExtent = visualMapModel.getExtent();
        // Update data interval.
        this._dataInterval = [
            $46b89608ba6c0e8b$var$linearMap(handleEnds[0], sizeExtent, dataExtent, true),
            $46b89608ba6c0e8b$var$linearMap(handleEnds[1], sizeExtent, dataExtent, true)
        ];
    };
    ContinuousView.prototype._updateView = function(forSketch) {
        var visualMapModel = this.visualMapModel;
        var dataExtent = visualMapModel.getExtent();
        var shapes = this._shapes;
        var outOfRangeHandleEnds = [
            0,
            visualMapModel.itemSize[1]
        ];
        var inRangeHandleEnds = forSketch ? outOfRangeHandleEnds : this._handleEnds;
        var visualInRange = this._createBarVisual(this._dataInterval, dataExtent, inRangeHandleEnds, 'inRange');
        var visualOutOfRange = this._createBarVisual(dataExtent, dataExtent, outOfRangeHandleEnds, 'outOfRange');
        shapes.inRange.setStyle({
            fill: visualInRange.barColor
        }).setShape('points', visualInRange.barPoints);
        shapes.outOfRange.setStyle({
            fill: visualOutOfRange.barColor
        }).setShape('points', visualOutOfRange.barPoints);
        this._updateHandle(inRangeHandleEnds, visualInRange);
    };
    ContinuousView.prototype._createBarVisual = function(dataInterval, dataExtent, handleEnds, forceState) {
        var opts = {
            forceState: forceState,
            convertOpacityToAlpha: true
        };
        var colorStops = this._makeColorGradient(dataInterval, opts);
        var symbolSizes = [
            this.getControllerVisual(dataInterval[0], 'symbolSize', opts),
            this.getControllerVisual(dataInterval[1], 'symbolSize', opts)
        ];
        var barPoints = this._createBarPoints(handleEnds, symbolSizes);
        return {
            barColor: new (0, $cf44c01491b58e53$export$2e2bcd8739ae039)(0, 0, 0, 1, colorStops),
            barPoints: barPoints,
            handlesColor: [
                colorStops[0].color,
                colorStops[colorStops.length - 1].color
            ]
        };
    };
    ContinuousView.prototype._makeColorGradient = function(dataInterval, opts) {
        // Considering colorHue, which is not linear, so we have to sample
        // to calculate gradient color stops, but not only calculate head
        // and tail.
        var sampleNumber = 100; // Arbitrary value.
        var colorStops = [];
        var step = (dataInterval[1] - dataInterval[0]) / sampleNumber;
        colorStops.push({
            color: this.getControllerVisual(dataInterval[0], 'color', opts),
            offset: 0
        });
        for(var i = 1; i < sampleNumber; i++){
            var currValue = dataInterval[0] + step * i;
            if (currValue > dataInterval[1]) break;
            colorStops.push({
                color: this.getControllerVisual(currValue, 'color', opts),
                offset: i / sampleNumber
            });
        }
        colorStops.push({
            color: this.getControllerVisual(dataInterval[1], 'color', opts),
            offset: 1
        });
        return colorStops;
    };
    ContinuousView.prototype._createBarPoints = function(handleEnds, symbolSizes) {
        var itemSize = this.visualMapModel.itemSize;
        return [
            [
                itemSize[0] - symbolSizes[0],
                handleEnds[0]
            ],
            [
                itemSize[0],
                handleEnds[0]
            ],
            [
                itemSize[0],
                handleEnds[1]
            ],
            [
                itemSize[0] - symbolSizes[1],
                handleEnds[1]
            ]
        ];
    };
    ContinuousView.prototype._createBarGroup = function(itemAlign) {
        var orient = this._orient;
        var inverse = this.visualMapModel.get('inverse');
        return new $7ef7583d8302ffce$export$2e2bcd8739ae039(orient === 'horizontal' && !inverse ? {
            scaleX: itemAlign === 'bottom' ? 1 : -1,
            rotation: Math.PI / 2
        } : orient === 'horizontal' && inverse ? {
            scaleX: itemAlign === 'bottom' ? -1 : 1,
            rotation: -Math.PI / 2
        } : orient === 'vertical' && !inverse ? {
            scaleX: itemAlign === 'left' ? 1 : -1,
            scaleY: -1
        } : {
            scaleX: itemAlign === 'left' ? 1 : -1
        });
    };
    ContinuousView.prototype._updateHandle = function(handleEnds, visualInRange) {
        if (!this._useHandle) return;
        var shapes = this._shapes;
        var visualMapModel = this.visualMapModel;
        var handleThumbs = shapes.handleThumbs;
        var handleLabels = shapes.handleLabels;
        var itemSize = visualMapModel.itemSize;
        var dataExtent = visualMapModel.getExtent();
        var align = this._applyTransform('left', shapes.mainGroup);
        $46b89608ba6c0e8b$var$each([
            0,
            1
        ], function(handleIndex) {
            var handleThumb = handleThumbs[handleIndex];
            handleThumb.setStyle('fill', visualInRange.handlesColor[handleIndex]);
            handleThumb.y = handleEnds[handleIndex];
            var val = $46b89608ba6c0e8b$var$linearMap(handleEnds[handleIndex], [
                0,
                itemSize[1]
            ], dataExtent, true);
            var symbolSize = this.getControllerVisual(val, 'symbolSize');
            handleThumb.scaleX = handleThumb.scaleY = symbolSize / itemSize[0];
            handleThumb.x = itemSize[0] - symbolSize / 2;
            // Update handle label position.
            var textPoint = $5b455ae6f843ac47$export$9f9dcb98c894b623(shapes.handleLabelPoints[handleIndex], $5b455ae6f843ac47$export$fce0c6cfca85ed96(handleThumb, this.group));
            if (this._orient === 'horizontal') {
                // If visualMap controls symbol size, an additional offset needs to be added to labels to avoid collision at minimum size.
                // Offset reaches value of 0 at "maximum" position, so maximum position is not altered at all.
                var minimumOffset = align === 'left' || align === 'top' ? (itemSize[0] - symbolSize) / 2 : (itemSize[0] - symbolSize) / -2;
                textPoint[1] += minimumOffset;
            }
            handleLabels[handleIndex].setStyle({
                x: textPoint[0],
                y: textPoint[1],
                text: visualMapModel.formatValueText(this._dataInterval[handleIndex]),
                verticalAlign: 'middle',
                align: this._orient === 'vertical' ? this._applyTransform('left', shapes.mainGroup) : 'center'
            });
        }, this);
    };
    ContinuousView.prototype._showIndicator = function(cursorValue, textValue, rangeSymbol, halfHoverLinkSize) {
        var visualMapModel = this.visualMapModel;
        var dataExtent = visualMapModel.getExtent();
        var itemSize = visualMapModel.itemSize;
        var sizeExtent = [
            0,
            itemSize[1]
        ];
        var shapes = this._shapes;
        var indicator = shapes.indicator;
        if (!indicator) return;
        indicator.attr('invisible', false);
        var opts = {
            convertOpacityToAlpha: true
        };
        var color = this.getControllerVisual(cursorValue, 'color', opts);
        var symbolSize = this.getControllerVisual(cursorValue, 'symbolSize');
        var y = $46b89608ba6c0e8b$var$linearMap(cursorValue, dataExtent, sizeExtent, true);
        var x = itemSize[0] - symbolSize / 2;
        var oldIndicatorPos = {
            x: indicator.x,
            y: indicator.y
        };
        // Update handle label position.
        indicator.y = y;
        indicator.x = x;
        var textPoint = $5b455ae6f843ac47$export$9f9dcb98c894b623(shapes.indicatorLabelPoint, $5b455ae6f843ac47$export$fce0c6cfca85ed96(indicator, this.group));
        var indicatorLabel = shapes.indicatorLabel;
        indicatorLabel.attr('invisible', false);
        var align = this._applyTransform('left', shapes.mainGroup);
        var orient = this._orient;
        var isHorizontal = orient === 'horizontal';
        indicatorLabel.setStyle({
            text: (rangeSymbol ? rangeSymbol : '') + visualMapModel.formatValueText(textValue),
            verticalAlign: isHorizontal ? align : 'middle',
            align: isHorizontal ? 'center' : align
        });
        var indicatorNewProps = {
            x: x,
            y: y,
            style: {
                fill: color
            }
        };
        var labelNewProps = {
            style: {
                x: textPoint[0],
                y: textPoint[1]
            }
        };
        if (visualMapModel.ecModel.isAnimationEnabled() && !this._firstShowIndicator) {
            var animationCfg = {
                duration: 100,
                easing: 'cubicInOut',
                additive: true
            };
            indicator.x = oldIndicatorPos.x;
            indicator.y = oldIndicatorPos.y;
            indicator.animateTo(indicatorNewProps, animationCfg);
            indicatorLabel.animateTo(labelNewProps, animationCfg);
        } else {
            indicator.attr(indicatorNewProps);
            indicatorLabel.attr(labelNewProps);
        }
        this._firstShowIndicator = false;
        var handleLabels = this._shapes.handleLabels;
        if (handleLabels) for(var i = 0; i < handleLabels.length; i++)// Fade out handle labels.
        // NOTE: Must use api enter/leave on emphasis/blur/select state. Or the global states manager will change it.
        this.api.enterBlur(handleLabels[i]);
    };
    ContinuousView.prototype._enableHoverLinkToSeries = function() {
        var self = this;
        this._shapes.mainGroup.on('mousemove', function(e) {
            self._hovering = true;
            if (!self._dragging) {
                var itemSize = self.visualMapModel.itemSize;
                var pos = self._applyTransform([
                    e.offsetX,
                    e.offsetY
                ], self._shapes.mainGroup, true, true);
                // For hover link show when hover handle, which might be
                // below or upper than sizeExtent.
                pos[1] = $46b89608ba6c0e8b$var$mathMin($46b89608ba6c0e8b$var$mathMax(0, pos[1]), itemSize[1]);
                self._doHoverLinkToSeries(pos[1], 0 <= pos[0] && pos[0] <= itemSize[0]);
            }
        }).on('mouseout', function() {
            // When mouse is out of handle, hoverLink still need
            // to be displayed when realtime is set as false.
            self._hovering = false;
            !self._dragging && self._clearHoverLinkToSeries();
        });
    };
    ContinuousView.prototype._enableHoverLinkFromSeries = function() {
        var zr = this.api.getZr();
        if (this.visualMapModel.option.hoverLink) {
            zr.on('mouseover', this._hoverLinkFromSeriesMouseOver, this);
            zr.on('mouseout', this._hideIndicator, this);
        } else this._clearHoverLinkFromSeries();
    };
    ContinuousView.prototype._doHoverLinkToSeries = function(cursorPos, hoverOnBar) {
        var visualMapModel = this.visualMapModel;
        var itemSize = visualMapModel.itemSize;
        if (!visualMapModel.option.hoverLink) return;
        var sizeExtent = [
            0,
            itemSize[1]
        ];
        var dataExtent = visualMapModel.getExtent();
        // For hover link show when hover handle, which might be below or upper than sizeExtent.
        cursorPos = $46b89608ba6c0e8b$var$mathMin($46b89608ba6c0e8b$var$mathMax(sizeExtent[0], cursorPos), sizeExtent[1]);
        var halfHoverLinkSize = $46b89608ba6c0e8b$var$getHalfHoverLinkSize(visualMapModel, dataExtent, sizeExtent);
        var hoverRange = [
            cursorPos - halfHoverLinkSize,
            cursorPos + halfHoverLinkSize
        ];
        var cursorValue = $46b89608ba6c0e8b$var$linearMap(cursorPos, sizeExtent, dataExtent, true);
        var valueRange = [
            $46b89608ba6c0e8b$var$linearMap(hoverRange[0], sizeExtent, dataExtent, true),
            $46b89608ba6c0e8b$var$linearMap(hoverRange[1], sizeExtent, dataExtent, true)
        ];
        // Consider data range is out of visualMap range, see test/visualMap-continuous.html,
        // where china and india has very large population.
        hoverRange[0] < sizeExtent[0] && (valueRange[0] = -Infinity);
        hoverRange[1] > sizeExtent[1] && (valueRange[1] = Infinity);
        // Do not show indicator when mouse is over handle,
        // otherwise labels overlap, especially when dragging.
        if (hoverOnBar) {
            if (valueRange[0] === -Infinity) this._showIndicator(cursorValue, valueRange[1], '< ', halfHoverLinkSize);
            else if (valueRange[1] === Infinity) this._showIndicator(cursorValue, valueRange[0], '> ', halfHoverLinkSize);
            else this._showIndicator(cursorValue, cursorValue, "\u2248 ", halfHoverLinkSize);
        }
        // When realtime is set as false, handles, which are in barGroup,
        // also trigger hoverLink, which help user to realize where they
        // focus on when dragging. (see test/heatmap-large.html)
        // When realtime is set as true, highlight will not show when hover
        // handle, because the label on handle, which displays a exact value
        // but not range, might mislead users.
        var oldBatch = this._hoverLinkDataIndices;
        var newBatch = [];
        if (hoverOnBar || $46b89608ba6c0e8b$var$useHoverLinkOnHandle(visualMapModel)) newBatch = this._hoverLinkDataIndices = visualMapModel.findTargetDataIndices(valueRange);
        var resultBatches = $76d619f648247e6d$export$6d12cabb0c9bf8e3(oldBatch, newBatch);
        this._dispatchHighDown('downplay', $1a17eb3ffb707117$export$5381a9dc5427ba18(resultBatches[0], visualMapModel));
        this._dispatchHighDown('highlight', $1a17eb3ffb707117$export$5381a9dc5427ba18(resultBatches[1], visualMapModel));
    };
    ContinuousView.prototype._hoverLinkFromSeriesMouseOver = function(e) {
        var ecData;
        (0, $808c5a2823518f68$export$8a4fca9e04eb4df6)(e.target, function(target) {
            var currECData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(target);
            if (currECData.dataIndex != null) {
                ecData = currECData;
                return true;
            }
        }, true);
        if (!ecData) return;
        var dataModel = this.ecModel.getSeriesByIndex(ecData.seriesIndex);
        var visualMapModel = this.visualMapModel;
        if (!visualMapModel.isTargetSeries(dataModel)) return;
        var data = dataModel.getData(ecData.dataType);
        var value = data.getStore().get(visualMapModel.getDataDimensionIndex(data), ecData.dataIndex);
        if (!isNaN(value)) this._showIndicator(value, value);
    };
    ContinuousView.prototype._hideIndicator = function() {
        var shapes = this._shapes;
        shapes.indicator && shapes.indicator.attr('invisible', true);
        shapes.indicatorLabel && shapes.indicatorLabel.attr('invisible', true);
        var handleLabels = this._shapes.handleLabels;
        if (handleLabels) for(var i = 0; i < handleLabels.length; i++)// Fade out handle labels.
        // NOTE: Must use api enter/leave on emphasis/blur/select state. Or the global states manager will change it.
        this.api.leaveBlur(handleLabels[i]);
    };
    ContinuousView.prototype._clearHoverLinkToSeries = function() {
        this._hideIndicator();
        var indices = this._hoverLinkDataIndices;
        this._dispatchHighDown('downplay', $1a17eb3ffb707117$export$5381a9dc5427ba18(indices, this.visualMapModel));
        indices.length = 0;
    };
    ContinuousView.prototype._clearHoverLinkFromSeries = function() {
        this._hideIndicator();
        var zr = this.api.getZr();
        zr.off('mouseover', this._hoverLinkFromSeriesMouseOver);
        zr.off('mouseout', this._hideIndicator);
    };
    ContinuousView.prototype._applyTransform = function(vertex, element, inverse, global) {
        var transform = $5b455ae6f843ac47$export$fce0c6cfca85ed96(element, global ? null : this.group);
        return $7a1bd9c2710fea0d$export$43bee75e5e14138e(vertex) ? $5b455ae6f843ac47$export$9f9dcb98c894b623(vertex, transform, inverse) : $5b455ae6f843ac47$export$fff94e9792354cfa(vertex, transform, inverse);
    };
    // TODO: TYPE more specified payload types.
    ContinuousView.prototype._dispatchHighDown = function(type, batch) {
        batch && batch.length && this.api.dispatchAction({
            type: type,
            batch: batch
        });
    };
    /**
   * @override
   */ ContinuousView.prototype.dispose = function() {
        this._clearHoverLinkFromSeries();
        this._clearHoverLinkToSeries();
    };
    ContinuousView.type = 'visualMap.continuous';
    return ContinuousView;
}((0, $0eb56f276c16b145$export$2e2bcd8739ae039));
function $46b89608ba6c0e8b$var$createPolygon(points, cursor, onDrift, onDragEnd) {
    return new $51acf033123e1a30$export$2e2bcd8739ae039({
        shape: {
            points: points
        },
        draggable: !!onDrift,
        cursor: cursor,
        drift: onDrift,
        onmousemove: function(e) {
            // For mobile device, prevent screen slider on the button.
            $b3864a78637ff9ed$export$fa6813432f753b0d(e.event);
        },
        ondragend: onDragEnd
    });
}
function $46b89608ba6c0e8b$var$getHalfHoverLinkSize(visualMapModel, dataExtent, sizeExtent) {
    var halfHoverLinkSize = $46b89608ba6c0e8b$var$HOVER_LINK_SIZE / 2;
    var hoverLinkDataSize = visualMapModel.get('hoverLinkDataSize');
    if (hoverLinkDataSize) halfHoverLinkSize = $46b89608ba6c0e8b$var$linearMap(hoverLinkDataSize, dataExtent, sizeExtent, true) / 2;
    return halfHoverLinkSize;
}
function $46b89608ba6c0e8b$var$useHoverLinkOnHandle(visualMapModel) {
    var hoverLinkOnHandle = visualMapModel.get('hoverLinkOnHandle');
    return !!(hoverLinkOnHandle == null ? visualMapModel.get('realtime') : hoverLinkOnHandle);
}
function $46b89608ba6c0e8b$var$getCursor(orient) {
    return orient === 'vertical' ? 'ns-resize' : 'ew-resize';
}
var $46b89608ba6c0e8b$export$2e2bcd8739ae039 = $46b89608ba6c0e8b$var$ContinuousView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $395ebe650d46f583$export$c5097295b52f5ecd = {
    type: 'selectDataRange',
    event: 'dataRangeSelected',
    // FIXME use updateView appears wrong
    update: 'update'
};
var $395ebe650d46f583$export$8655c04a6fcbaa76 = function(payload, ecModel) {
    ecModel.eachComponent({
        mainType: 'visualMap',
        query: payload
    }, function(model) {
        model.setSelected(payload.selected);
    });
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $561e4a618ab15558$export$5933e7c74ab358d1 = [
    {
        createOnAllSeries: true,
        reset: function(seriesModel, ecModel) {
            var resetDefines = [];
            ecModel.eachComponent('visualMap', function(visualMapModel) {
                var pipelineContext = seriesModel.pipelineContext;
                if (!visualMapModel.isTargetSeries(seriesModel) || pipelineContext && pipelineContext.large) return;
                resetDefines.push($87ea23222d1c134e$export$fc0ef8703cccf128(visualMapModel.stateList, visualMapModel.targetVisuals, $7a1bd9c2710fea0d$export$2385a24977818dd0(visualMapModel.getValueState, visualMapModel), visualMapModel.getDataDimensionIndex(seriesModel.getData())));
            });
            return resetDefines;
        }
    },
    // Only support color.
    {
        createOnAllSeries: true,
        reset: function(seriesModel, ecModel) {
            var data = seriesModel.getData();
            var visualMetaList = [];
            ecModel.eachComponent('visualMap', function(visualMapModel) {
                if (visualMapModel.isTargetSeries(seriesModel)) {
                    var visualMeta = visualMapModel.getVisualMeta($7a1bd9c2710fea0d$export$2385a24977818dd0($561e4a618ab15558$var$getColorVisual, null, seriesModel, visualMapModel)) || {
                        stops: [],
                        outerColors: []
                    };
                    var dimIdx = visualMapModel.getDataDimensionIndex(data);
                    if (dimIdx >= 0) {
                        // visualMeta.dimension should be dimension index, but not concrete dimension.
                        visualMeta.dimension = dimIdx;
                        visualMetaList.push(visualMeta);
                    }
                }
            });
            // console.log(JSON.stringify(visualMetaList.map(a => a.stops)));
            seriesModel.getData().setVisual('visualMeta', visualMetaList);
        }
    }
];
// FIXME
// performance and export for heatmap?
// value can be Infinity or -Infinity
function $561e4a618ab15558$var$getColorVisual(seriesModel, visualMapModel, value, valueState) {
    var mappings = visualMapModel.targetVisuals[valueState];
    var visualTypes = (0, $7b50f502cfd189d5$export$2e2bcd8739ae039).prepareVisualTypes(mappings);
    var resultVisual = {
        color: (0, $ea13f1ab2169d82d$export$d76e333a86ea1a2)(seriesModel.getData(), 'color') // default color.
    };
    for(var i = 0, len = visualTypes.length; i < len; i++){
        var type = visualTypes[i];
        var mapping = mappings[type === 'opacity' ? '__alphaForOpacity' : type];
        mapping && mapping.applyVisual(value, getVisual, setVisual);
    }
    return resultVisual.color;
    function getVisual(key) {
        return resultVisual[key];
    }
    function setVisual(key, value) {
        resultVisual[key] = value;
    }
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // @ts-nocheck

var $92519f6317138812$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
function $92519f6317138812$export$2e2bcd8739ae039(option) {
    var visualMap = option && option.visualMap;
    if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(visualMap)) visualMap = visualMap ? [
        visualMap
    ] : [];
    $92519f6317138812$var$each(visualMap, function(opt) {
        if (!opt) return;
        // rename splitList to pieces
        if ($92519f6317138812$var$has(opt, 'splitList') && !$92519f6317138812$var$has(opt, 'pieces')) {
            opt.pieces = opt.splitList;
            delete opt.splitList;
        }
        var pieces = opt.pieces;
        if (pieces && $7a1bd9c2710fea0d$export$43bee75e5e14138e(pieces)) $92519f6317138812$var$each(pieces, function(piece) {
            if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(piece)) {
                if ($92519f6317138812$var$has(piece, 'start') && !$92519f6317138812$var$has(piece, 'min')) piece.min = piece.start;
                if ($92519f6317138812$var$has(piece, 'end') && !$92519f6317138812$var$has(piece, 'max')) piece.max = piece.end;
            }
        });
    });
}
function $92519f6317138812$var$has(obj, name) {
    return obj && obj.hasOwnProperty && obj.hasOwnProperty(name);
}


var $769f929efa66b3be$var$installed = false;
function $769f929efa66b3be$export$2e2bcd8739ae039(registers) {
    if ($769f929efa66b3be$var$installed) return;
    $769f929efa66b3be$var$installed = true;
    registers.registerSubTypeDefaulter('visualMap', function(option) {
        // Compatible with ec2, when splitNumber === 0, continuous visualMap will be used.
        return !option.categories && (!(option.pieces ? option.pieces.length > 0 : option.splitNumber > 0) || option.calculable) ? 'continuous' : 'piecewise';
    });
    registers.registerAction((0, $395ebe650d46f583$export$c5097295b52f5ecd), (0, $395ebe650d46f583$export$8655c04a6fcbaa76));
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $561e4a618ab15558$export$5933e7c74ab358d1), function(handler) {
        registers.registerVisual(registers.PRIORITY.VISUAL.COMPONENT, handler);
    });
    registers.registerPreprocessor((0, $92519f6317138812$export$2e2bcd8739ae039));
}


function $a0f8a196dd8b4cba$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $91b3756da4f00019$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $46b89608ba6c0e8b$export$2e2bcd8739ae039));
    (0, $769f929efa66b3be$export$2e2bcd8739ae039)(registers);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $800f031000e0c641$var$PiecewiseModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(PiecewiseModel, _super);
    function PiecewiseModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = PiecewiseModel.type;
        /**
     * The order is always [low, ..., high].
     * [{text: string, interval: Array.<number>}, ...]
     */ _this._pieceList = [];
        return _this;
    }
    PiecewiseModel.prototype.optionUpdated = function(newOption, isInit) {
        _super.prototype.optionUpdated.apply(this, arguments);
        this.resetExtent();
        var mode = this._mode = this._determineMode();
        this._pieceList = [];
        $800f031000e0c641$var$resetMethods[this._mode].call(this, this._pieceList);
        this._resetSelected(newOption, isInit);
        var categories = this.option.categories;
        this.resetVisual(function(mappingOption, state) {
            if (mode === 'categories') {
                mappingOption.mappingMethod = 'category';
                mappingOption.categories = $7a1bd9c2710fea0d$export$9cd59f9826255e47(categories);
            } else {
                mappingOption.dataExtent = this.getExtent();
                mappingOption.mappingMethod = 'piecewise';
                mappingOption.pieceList = $7a1bd9c2710fea0d$export$871de8747c9eaa88(this._pieceList, function(piece) {
                    piece = $7a1bd9c2710fea0d$export$9cd59f9826255e47(piece);
                    if (state !== 'inRange') // FIXME
                    // outOfRange do not support special visual in pieces.
                    piece.visual = null;
                    return piece;
                });
            }
        });
    };
    /**
   * @protected
   * @override
   */ PiecewiseModel.prototype.completeVisualOption = function() {
        // Consider this case:
        // visualMap: {
        //      pieces: [{symbol: 'circle', lt: 0}, {symbol: 'rect', gte: 0}]
        // }
        // where no inRange/outOfRange set but only pieces. So we should make
        // default inRange/outOfRange for this case, otherwise visuals that only
        // appear in `pieces` will not be taken into account in visual encoding.
        var option = this.option;
        var visualTypesInPieces = {};
        var visualTypes = (0, $7b50f502cfd189d5$export$2e2bcd8739ae039).listVisualTypes();
        var isCategory = this.isCategory();
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(option.pieces, function(piece) {
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(visualTypes, function(visualType) {
                if (piece.hasOwnProperty(visualType)) visualTypesInPieces[visualType] = 1;
            });
        });
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(visualTypesInPieces, function(v, visualType) {
            var exists = false;
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(this.stateList, function(state) {
                exists = exists || has(option, state, visualType) || has(option.target, state, visualType);
            }, this);
            !exists && $7a1bd9c2710fea0d$export$79b2f7037acddd43(this.stateList, function(state) {
                (option[state] || (option[state] = {}))[visualType] = (0, $ef3bd976f9d1f7a2$export$2e2bcd8739ae039).get(visualType, state === 'inRange' ? 'active' : 'inactive', isCategory);
            });
        }, this);
        function has(obj, state, visualType) {
            return obj && obj[state] && obj[state].hasOwnProperty(visualType);
        }
        _super.prototype.completeVisualOption.apply(this, arguments);
    };
    PiecewiseModel.prototype._resetSelected = function(newOption, isInit) {
        var thisOption = this.option;
        var pieceList = this._pieceList;
        // Selected do not merge but all override.
        var selected = (isInit ? thisOption : newOption).selected || {};
        thisOption.selected = selected;
        // Consider 'not specified' means true.
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(pieceList, function(piece, index) {
            var key = this.getSelectedMapKey(piece);
            if (!selected.hasOwnProperty(key)) selected[key] = true;
        }, this);
        if (thisOption.selectedMode === 'single') {
            // Ensure there is only one selected.
            var hasSel_1 = false;
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(pieceList, function(piece, index) {
                var key = this.getSelectedMapKey(piece);
                if (selected[key]) hasSel_1 ? selected[key] = false : hasSel_1 = true;
            }, this);
        }
    // thisOption.selectedMode === 'multiple', default: all selected.
    };
    /**
   * @public
   */ PiecewiseModel.prototype.getItemSymbol = function() {
        return this.get('itemSymbol');
    };
    /**
   * @public
   */ PiecewiseModel.prototype.getSelectedMapKey = function(piece) {
        return this._mode === 'categories' ? piece.value + '' : piece.index + '';
    };
    /**
   * @public
   */ PiecewiseModel.prototype.getPieceList = function() {
        return this._pieceList;
    };
    /**
   * @return {string}
   */ PiecewiseModel.prototype._determineMode = function() {
        var option = this.option;
        return option.pieces && option.pieces.length > 0 ? 'pieces' : this.option.categories ? 'categories' : 'splitNumber';
    };
    /**
   * @override
   */ PiecewiseModel.prototype.setSelected = function(selected) {
        this.option.selected = $7a1bd9c2710fea0d$export$9cd59f9826255e47(selected);
    };
    /**
   * @override
   */ PiecewiseModel.prototype.getValueState = function(value) {
        var index = (0, $7b50f502cfd189d5$export$2e2bcd8739ae039).findPieceIndex(value, this._pieceList);
        return index != null ? this.option.selected[this.getSelectedMapKey(this._pieceList[index])] ? 'inRange' : 'outOfRange' : 'outOfRange';
    };
    /**
   * @public
   * @param pieceIndex piece index in visualMapModel.getPieceList()
   */ PiecewiseModel.prototype.findTargetDataIndices = function(pieceIndex) {
        var result = [];
        var pieceList = this._pieceList;
        this.eachTargetSeries(function(seriesModel) {
            var dataIndices = [];
            var data = seriesModel.getData();
            data.each(this.getDataDimensionIndex(data), function(value, dataIndex) {
                // Should always base on model pieceList, because it is order sensitive.
                var pIdx = (0, $7b50f502cfd189d5$export$2e2bcd8739ae039).findPieceIndex(value, pieceList);
                pIdx === pieceIndex && dataIndices.push(dataIndex);
            }, this);
            result.push({
                seriesId: seriesModel.id,
                dataIndex: dataIndices
            });
        }, this);
        return result;
    };
    /**
   * @private
   * @param piece piece.value or piece.interval is required.
   * @return  Can be Infinity or -Infinity
   */ PiecewiseModel.prototype.getRepresentValue = function(piece) {
        var representValue;
        if (this.isCategory()) representValue = piece.value;
        else if (piece.value != null) representValue = piece.value;
        else {
            var pieceInterval = piece.interval || [];
            representValue = pieceInterval[0] === -Infinity && pieceInterval[1] === Infinity ? 0 : (pieceInterval[0] + pieceInterval[1]) / 2;
        }
        return representValue;
    };
    PiecewiseModel.prototype.getVisualMeta = function(getColorVisual) {
        // Do not support category. (category axis is ordinal, numerical)
        if (this.isCategory()) return;
        var stops = [];
        var outerColors = [
            '',
            ''
        ];
        var visualMapModel = this;
        function setStop(interval, valueState) {
            var representValue = visualMapModel.getRepresentValue({
                interval: interval
            }); // Not category
            if (!valueState) valueState = visualMapModel.getValueState(representValue);
            var color = getColorVisual(representValue, valueState);
            if (interval[0] === -Infinity) outerColors[0] = color;
            else if (interval[1] === Infinity) outerColors[1] = color;
            else stops.push({
                value: interval[0],
                color: color
            }, {
                value: interval[1],
                color: color
            });
        }
        // Suplement
        var pieceList = this._pieceList.slice();
        if (!pieceList.length) pieceList.push({
            interval: [
                -Infinity,
                Infinity
            ]
        });
        else {
            var edge = pieceList[0].interval[0];
            edge !== -Infinity && pieceList.unshift({
                interval: [
                    -Infinity,
                    edge
                ]
            });
            edge = pieceList[pieceList.length - 1].interval[1];
            edge !== Infinity && pieceList.push({
                interval: [
                    edge,
                    Infinity
                ]
            });
        }
        var curr = -Infinity;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(pieceList, function(piece) {
            var interval = piece.interval;
            if (interval) {
                // Fulfill gap.
                interval[0] > curr && setStop([
                    curr,
                    interval[0]
                ], 'outOfRange');
                setStop(interval.slice());
                curr = interval[1];
            }
        }, this);
        return {
            stops: stops,
            outerColors: outerColors
        };
    };
    PiecewiseModel.type = 'visualMap.piecewise';
    PiecewiseModel.defaultOption = (0, $5370df662b2caf37$export$68acc510e46fef2)((0, $fca0c970f405ff38$export$2e2bcd8739ae039).defaultOption, {
        selected: null,
        minOpen: false,
        maxOpen: false,
        align: 'auto',
        itemWidth: 20,
        itemHeight: 14,
        itemSymbol: 'roundRect',
        pieces: null,
        categories: null,
        splitNumber: 5,
        selectedMode: 'multiple',
        itemGap: 10,
        hoverLink: true // Enable hover highlight.
    });
    return PiecewiseModel;
}((0, $fca0c970f405ff38$export$2e2bcd8739ae039));
/**
 * Key is this._mode
 * @type {Object}
 * @this {module:echarts/component/viusalMap/PiecewiseMode}
 */ var $800f031000e0c641$var$resetMethods = {
    splitNumber: function(outPieceList) {
        var thisOption = this.option;
        var precision = Math.min(thisOption.precision, 20);
        var dataExtent = this.getExtent();
        var splitNumber = thisOption.splitNumber;
        splitNumber = Math.max(parseInt(splitNumber, 10), 1);
        thisOption.splitNumber = splitNumber;
        var splitStep = (dataExtent[1] - dataExtent[0]) / splitNumber;
        // Precision auto-adaption
        while(+splitStep.toFixed(precision) !== splitStep && precision < 5)precision++;
        thisOption.precision = precision;
        splitStep = +splitStep.toFixed(precision);
        if (thisOption.minOpen) outPieceList.push({
            interval: [
                -Infinity,
                dataExtent[0]
            ],
            close: [
                0,
                0
            ]
        });
        for(var index = 0, curr = dataExtent[0]; index < splitNumber; curr += splitStep, index++){
            var max = index === splitNumber - 1 ? dataExtent[1] : curr + splitStep;
            outPieceList.push({
                interval: [
                    curr,
                    max
                ],
                close: [
                    1,
                    1
                ]
            });
        }
        if (thisOption.maxOpen) outPieceList.push({
            interval: [
                dataExtent[1],
                Infinity
            ],
            close: [
                0,
                0
            ]
        });
        (0, $cfc1f3b422a3185f$export$12f7386070bc380a)(outPieceList);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(outPieceList, function(piece, index) {
            piece.index = index;
            piece.text = this.formatValueText(piece.interval);
        }, this);
    },
    categories: function(outPieceList) {
        var thisOption = this.option;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(thisOption.categories, function(cate) {
            // FIXME category模式也使用pieceList，但在visualMapping中不是使用pieceList。
            // 是否改一致。
            outPieceList.push({
                text: this.formatValueText(cate, true),
                value: cate
            });
        }, this);
        // See "Order Rule".
        $800f031000e0c641$var$normalizeReverse(thisOption, outPieceList);
    },
    pieces: function(outPieceList) {
        var thisOption = this.option;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(thisOption.pieces, function(pieceListItem, index) {
            if (!$7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(pieceListItem)) pieceListItem = {
                value: pieceListItem
            };
            var item = {
                text: '',
                index: index
            };
            if (pieceListItem.label != null) item.text = pieceListItem.label;
            if (pieceListItem.hasOwnProperty('value')) {
                var value = item.value = pieceListItem.value;
                item.interval = [
                    value,
                    value
                ];
                item.close = [
                    1,
                    1
                ];
            } else {
                // `min` `max` is legacy option.
                // `lt` `gt` `lte` `gte` is recommended.
                var interval = item.interval = [];
                var close_1 = item.close = [
                    0,
                    0
                ];
                var closeList = [
                    1,
                    0,
                    1
                ];
                var infinityList = [
                    -Infinity,
                    Infinity
                ];
                var useMinMax = [];
                for(var lg = 0; lg < 2; lg++){
                    var names = [
                        [
                            'gte',
                            'gt',
                            'min'
                        ],
                        [
                            'lte',
                            'lt',
                            'max'
                        ]
                    ][lg];
                    for(var i = 0; i < 3 && interval[lg] == null; i++){
                        interval[lg] = pieceListItem[names[i]];
                        close_1[lg] = closeList[i];
                        useMinMax[lg] = i === 2;
                    }
                    interval[lg] == null && (interval[lg] = infinityList[lg]);
                }
                useMinMax[0] && interval[1] === Infinity && (close_1[0] = 0);
                useMinMax[1] && interval[0] === -Infinity && (close_1[1] = 0);
                if (interval[0] === interval[1] && close_1[0] && close_1[1]) // Consider: [{min: 5, max: 5, visual: {...}}, {min: 0, max: 5}],
                // we use value to lift the priority when min === max
                item.value = interval[0];
            }
            item.visual = (0, $7b50f502cfd189d5$export$2e2bcd8739ae039).retrieveVisuals(pieceListItem);
            outPieceList.push(item);
        }, this);
        // See "Order Rule".
        $800f031000e0c641$var$normalizeReverse(thisOption, outPieceList);
        // Only pieces
        (0, $cfc1f3b422a3185f$export$12f7386070bc380a)(outPieceList);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(outPieceList, function(piece) {
            var close = piece.close;
            var edgeSymbols = [
                [
                    '<',
                    "\u2264"
                ][close[1]],
                [
                    '>',
                    "\u2265"
                ][close[0]]
            ];
            piece.text = piece.text || this.formatValueText(piece.value != null ? piece.value : piece.interval, false, edgeSymbols);
        }, this);
    }
};
function $800f031000e0c641$var$normalizeReverse(thisOption, pieceList) {
    var inverse = thisOption.inverse;
    if (thisOption.orient === 'vertical' ? !inverse : inverse) pieceList.reverse();
}
var $800f031000e0c641$export$2e2bcd8739ae039 = $800f031000e0c641$var$PiecewiseModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







var $54f263ebb7934a99$var$PiecewiseVisualMapView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(PiecewiseVisualMapView, _super);
    function PiecewiseVisualMapView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = PiecewiseVisualMapView.type;
        return _this;
    }
    PiecewiseVisualMapView.prototype.doRender = function() {
        var thisGroup = this.group;
        thisGroup.removeAll();
        var visualMapModel = this.visualMapModel;
        var textGap = visualMapModel.get('textGap');
        var textStyleModel = visualMapModel.textStyleModel;
        var textFont = textStyleModel.getFont();
        var textFill = textStyleModel.getTextColor();
        var itemAlign = this._getItemAlign();
        var itemSize = visualMapModel.itemSize;
        var viewData = this._getViewData();
        var endsText = viewData.endsText;
        var showLabel = $7a1bd9c2710fea0d$export$8a4d17b6e8486e66(visualMapModel.get('showLabel', true), !endsText);
        var silent = !visualMapModel.get('selectedMode');
        endsText && this._renderEndsText(thisGroup, endsText[0], itemSize, showLabel, itemAlign);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(viewData.viewPieceList, function(item) {
            var piece = item.piece;
            var itemGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
            itemGroup.onclick = $7a1bd9c2710fea0d$export$2385a24977818dd0(this._onItemClick, this, piece);
            this._enableHoverLink(itemGroup, item.indexInModelPieceList);
            // TODO Category
            var representValue = visualMapModel.getRepresentValue(piece);
            this._createItemSymbol(itemGroup, representValue, [
                0,
                0,
                itemSize[0],
                itemSize[1]
            ], silent);
            if (showLabel) {
                var visualState = this.visualMapModel.getValueState(representValue);
                itemGroup.add(new $fe885cc21795562b$export$2e2bcd8739ae039({
                    style: {
                        x: itemAlign === 'right' ? -textGap : itemSize[0] + textGap,
                        y: itemSize[1] / 2,
                        text: piece.text,
                        verticalAlign: 'middle',
                        align: itemAlign,
                        font: textFont,
                        fill: textFill,
                        opacity: visualState === 'outOfRange' ? 0.5 : 1
                    },
                    silent: silent
                }));
            }
            thisGroup.add(itemGroup);
        }, this);
        endsText && this._renderEndsText(thisGroup, endsText[1], itemSize, showLabel, itemAlign);
        $93b9bc7f22ac7369$export$827f4ee28efc37(visualMapModel.get('orient'), thisGroup, visualMapModel.get('itemGap'));
        this.renderBackground(thisGroup);
        this.positionGroup(thisGroup);
    };
    PiecewiseVisualMapView.prototype._enableHoverLink = function(itemGroup, pieceIndex) {
        var _this = this;
        itemGroup.on('mouseover', function() {
            return onHoverLink('highlight');
        }).on('mouseout', function() {
            return onHoverLink('downplay');
        });
        var onHoverLink = function(method) {
            var visualMapModel = _this.visualMapModel;
            // TODO: TYPE More detailed action types
            visualMapModel.option.hoverLink && _this.api.dispatchAction({
                type: method,
                batch: $1a17eb3ffb707117$export$5381a9dc5427ba18(visualMapModel.findTargetDataIndices(pieceIndex), visualMapModel)
            });
        };
    };
    PiecewiseVisualMapView.prototype._getItemAlign = function() {
        var visualMapModel = this.visualMapModel;
        var modelOption = visualMapModel.option;
        if (modelOption.orient === 'vertical') return $1a17eb3ffb707117$export$dca53c4702e35c6(visualMapModel, this.api, visualMapModel.itemSize);
        else {
            // horizontal, most case left unless specifying right.
            var align = modelOption.align;
            if (!align || align === 'auto') align = 'left';
            return align;
        }
    };
    PiecewiseVisualMapView.prototype._renderEndsText = function(group, text, itemSize, showLabel, itemAlign) {
        if (!text) return;
        var itemGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        var textStyleModel = this.visualMapModel.textStyleModel;
        itemGroup.add(new $fe885cc21795562b$export$2e2bcd8739ae039({
            style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(textStyleModel, {
                x: showLabel ? itemAlign === 'right' ? itemSize[0] : 0 : itemSize[0] / 2,
                y: itemSize[1] / 2,
                verticalAlign: 'middle',
                align: showLabel ? itemAlign : 'center',
                text: text
            })
        }));
        group.add(itemGroup);
    };
    /**
   * @private
   * @return {Object} {peiceList, endsText} The order is the same as screen pixel order.
   */ PiecewiseVisualMapView.prototype._getViewData = function() {
        var visualMapModel = this.visualMapModel;
        var viewPieceList = $7a1bd9c2710fea0d$export$871de8747c9eaa88(visualMapModel.getPieceList(), function(piece, index) {
            return {
                piece: piece,
                indexInModelPieceList: index
            };
        });
        var endsText = visualMapModel.get('text');
        // Consider orient and inverse.
        var orient = visualMapModel.get('orient');
        var inverse = visualMapModel.get('inverse');
        // Order of model pieceList is always [low, ..., high]
        if (orient === 'horizontal' ? inverse : !inverse) viewPieceList.reverse();
        else if (endsText) endsText = endsText.slice().reverse();
        return {
            viewPieceList: viewPieceList,
            endsText: endsText
        };
    };
    PiecewiseVisualMapView.prototype._createItemSymbol = function(group, representValue, shapeParam, silent) {
        var itemSymbol = (0, $5370466dadc978d7$export$af050e04da3a02e8)(// symbol will be string
        this.getControllerVisual(representValue, 'symbol'), shapeParam[0], shapeParam[1], shapeParam[2], shapeParam[3], // color will be string
        this.getControllerVisual(representValue, 'color'));
        itemSymbol.silent = silent;
        group.add(itemSymbol);
    };
    PiecewiseVisualMapView.prototype._onItemClick = function(piece) {
        var visualMapModel = this.visualMapModel;
        var option = visualMapModel.option;
        var selectedMode = option.selectedMode;
        if (!selectedMode) return;
        var selected = $7a1bd9c2710fea0d$export$9cd59f9826255e47(option.selected);
        var newKey = visualMapModel.getSelectedMapKey(piece);
        if (selectedMode === 'single' || selectedMode === true) {
            selected[newKey] = true;
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(selected, function(o, key) {
                selected[key] = key === newKey;
            });
        } else selected[newKey] = !selected[newKey];
        this.api.dispatchAction({
            type: 'selectDataRange',
            from: this.uid,
            visualMapId: this.visualMapModel.id,
            selected: selected
        });
    };
    PiecewiseVisualMapView.type = 'visualMap.piecewise';
    return PiecewiseVisualMapView;
}((0, $0eb56f276c16b145$export$2e2bcd8739ae039));
var $54f263ebb7934a99$export$2e2bcd8739ae039 = $54f263ebb7934a99$var$PiecewiseVisualMapView;



function $312d2d640a7c60e1$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $800f031000e0c641$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $54f263ebb7934a99$export$2e2bcd8739ae039));
    (0, $769f929efa66b3be$export$2e2bcd8739ae039)(registers);
}


function $1df0d53aa7db8747$export$4b3e715f166fdd78(registers) {
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $a0f8a196dd8b4cba$export$4b3e715f166fdd78));
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $312d2d640a7c60e1$export$4b3e715f166fdd78));
// Do not install './dataZoomSelect',
// since it only work for toolbox dataZoom.
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // TODO: move labels out of viewport.










function $e10cf2049e185956$var$cloneArr(points) {
    if (points) {
        var newPoints = [];
        for(var i = 0; i < points.length; i++)newPoints.push(points[i].slice());
        return newPoints;
    }
}
function $e10cf2049e185956$var$prepareLayoutCallbackParams(labelItem, hostEl) {
    var label = labelItem.label;
    var labelLine = hostEl && hostEl.getTextGuideLine();
    return {
        dataIndex: labelItem.dataIndex,
        dataType: labelItem.dataType,
        seriesIndex: labelItem.seriesModel.seriesIndex,
        text: labelItem.label.style.text,
        rect: labelItem.hostRect,
        labelRect: labelItem.rect,
        // x: labelAttr.x,
        // y: labelAttr.y,
        align: label.style.align,
        verticalAlign: label.style.verticalAlign,
        labelLinePoints: $e10cf2049e185956$var$cloneArr(labelLine && labelLine.shape.points)
    };
}
var $e10cf2049e185956$var$LABEL_OPTION_TO_STYLE_KEYS = [
    'align',
    'verticalAlign',
    'width',
    'height',
    'fontSize'
];
var $e10cf2049e185956$var$dummyTransformable = new (0, $becf2d727f9cf450$export$2e2bcd8739ae039)();
var $e10cf2049e185956$var$labelLayoutInnerStore = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $e10cf2049e185956$var$labelLineAnimationStore = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $e10cf2049e185956$var$extendWithKeys(target, source, keys) {
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (source[key] != null) target[key] = source[key];
    }
}
var $e10cf2049e185956$var$LABEL_LAYOUT_PROPS = [
    'x',
    'y',
    'rotation'
];
var $e10cf2049e185956$var$LabelManager = /** @class */ function() {
    function LabelManager() {
        this._labelList = [];
        this._chartViewList = [];
    }
    LabelManager.prototype.clearLabels = function() {
        this._labelList = [];
        this._chartViewList = [];
    };
    /**
   * Add label to manager
   */ LabelManager.prototype._addLabel = function(dataIndex, dataType, seriesModel, label, layoutOption) {
        var labelStyle = label.style;
        var hostEl = label.__hostTarget;
        var textConfig = hostEl.textConfig || {};
        // TODO: If label is in other state.
        var labelTransform = label.getComputedTransform();
        var labelRect = label.getBoundingRect().plain();
        (0, $1bebe7106c895823$export$2e2bcd8739ae039).applyTransform(labelRect, labelRect, labelTransform);
        if (labelTransform) $e10cf2049e185956$var$dummyTransformable.setLocalTransform(labelTransform);
        else {
            // Identity transform.
            $e10cf2049e185956$var$dummyTransformable.x = $e10cf2049e185956$var$dummyTransformable.y = $e10cf2049e185956$var$dummyTransformable.rotation = $e10cf2049e185956$var$dummyTransformable.originX = $e10cf2049e185956$var$dummyTransformable.originY = 0;
            $e10cf2049e185956$var$dummyTransformable.scaleX = $e10cf2049e185956$var$dummyTransformable.scaleY = 1;
        }
        $e10cf2049e185956$var$dummyTransformable.rotation = (0, $b44a8536c7214e4f$export$d44861331f213635)($e10cf2049e185956$var$dummyTransformable.rotation);
        var host = label.__hostTarget;
        var hostRect;
        if (host) {
            hostRect = host.getBoundingRect().plain();
            var transform = host.getComputedTransform();
            (0, $1bebe7106c895823$export$2e2bcd8739ae039).applyTransform(hostRect, hostRect, transform);
        }
        var labelGuide = hostRect && host.getTextGuideLine();
        this._labelList.push({
            label: label,
            labelLine: labelGuide,
            seriesModel: seriesModel,
            dataIndex: dataIndex,
            dataType: dataType,
            layoutOption: layoutOption,
            computedLayoutOption: null,
            rect: labelRect,
            hostRect: hostRect,
            // Label with lower priority will be hidden when overlapped
            // Use rect size as default priority
            priority: hostRect ? hostRect.width * hostRect.height : 0,
            // Save default label attributes.
            // For restore if developers want get back to default value in callback.
            defaultAttr: {
                ignore: label.ignore,
                labelGuideIgnore: labelGuide && labelGuide.ignore,
                x: $e10cf2049e185956$var$dummyTransformable.x,
                y: $e10cf2049e185956$var$dummyTransformable.y,
                scaleX: $e10cf2049e185956$var$dummyTransformable.scaleX,
                scaleY: $e10cf2049e185956$var$dummyTransformable.scaleY,
                rotation: $e10cf2049e185956$var$dummyTransformable.rotation,
                style: {
                    x: labelStyle.x,
                    y: labelStyle.y,
                    align: labelStyle.align,
                    verticalAlign: labelStyle.verticalAlign,
                    width: labelStyle.width,
                    height: labelStyle.height,
                    fontSize: labelStyle.fontSize
                },
                cursor: label.cursor,
                attachedPos: textConfig.position,
                attachedRot: textConfig.rotation
            }
        });
    };
    LabelManager.prototype.addLabelsOfSeries = function(chartView) {
        var _this = this;
        this._chartViewList.push(chartView);
        var seriesModel = chartView.__model;
        var layoutOption = seriesModel.get('labelLayout');
        /**
     * Ignore layouting if it's not specified anything.
     */ if (!((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(layoutOption) || (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(layoutOption).length)) return;
        chartView.group.traverse(function(child) {
            if (child.ignore) return true; // Stop traverse descendants.
            // Only support label being hosted on graphic elements.
            var textEl = child.getTextContent();
            var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(child);
            // Can only attach the text on the element with dataIndex
            if (textEl && !textEl.disableLabelLayout) _this._addLabel(ecData.dataIndex, ecData.dataType, seriesModel, textEl, layoutOption);
        });
    };
    LabelManager.prototype.updateLayoutConfig = function(api) {
        var width = api.getWidth();
        var height = api.getHeight();
        function createDragHandler(el, labelLineModel) {
            return function() {
                (0, $f4eb87a228be297f$export$cc93ba643cd97d83)(el, labelLineModel);
            };
        }
        for(var i = 0; i < this._labelList.length; i++){
            var labelItem = this._labelList[i];
            var label = labelItem.label;
            var hostEl = label.__hostTarget;
            var defaultLabelAttr = labelItem.defaultAttr;
            var layoutOption = void 0;
            // TODO A global layout option?
            if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(labelItem.layoutOption)) layoutOption = labelItem.layoutOption($e10cf2049e185956$var$prepareLayoutCallbackParams(labelItem, hostEl));
            else layoutOption = labelItem.layoutOption;
            layoutOption = layoutOption || {};
            labelItem.computedLayoutOption = layoutOption;
            var degreeToRadian = Math.PI / 180;
            // TODO hostEl should always exists.
            // Or label should not have parent because the x, y is all in global space.
            if (hostEl) hostEl.setTextConfig({
                // Force to set local false.
                local: false,
                // Ignore position and rotation config on the host el if x or y is changed.
                position: layoutOption.x != null || layoutOption.y != null ? null : defaultLabelAttr.attachedPos,
                // Ignore rotation config on the host el if rotation is changed.
                rotation: layoutOption.rotate != null ? layoutOption.rotate * degreeToRadian : defaultLabelAttr.attachedRot,
                offset: [
                    layoutOption.dx || 0,
                    layoutOption.dy || 0
                ]
            });
            var needsUpdateLabelLine = false;
            if (layoutOption.x != null) {
                // TODO width of chart view.
                label.x = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(layoutOption.x, width);
                label.setStyle('x', 0); // Ignore movement in style. TODO: origin.
                needsUpdateLabelLine = true;
            } else {
                label.x = defaultLabelAttr.x;
                label.setStyle('x', defaultLabelAttr.style.x);
            }
            if (layoutOption.y != null) {
                // TODO height of chart view.
                label.y = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(layoutOption.y, height);
                label.setStyle('y', 0); // Ignore movement in style.
                needsUpdateLabelLine = true;
            } else {
                label.y = defaultLabelAttr.y;
                label.setStyle('y', defaultLabelAttr.style.y);
            }
            if (layoutOption.labelLinePoints) {
                var guideLine = hostEl.getTextGuideLine();
                if (guideLine) {
                    guideLine.setShape({
                        points: layoutOption.labelLinePoints
                    });
                    // Not update
                    needsUpdateLabelLine = false;
                }
            }
            var labelLayoutStore = $e10cf2049e185956$var$labelLayoutInnerStore(label);
            labelLayoutStore.needsUpdateLabelLine = needsUpdateLabelLine;
            label.rotation = layoutOption.rotate != null ? layoutOption.rotate * degreeToRadian : defaultLabelAttr.rotation;
            label.scaleX = defaultLabelAttr.scaleX;
            label.scaleY = defaultLabelAttr.scaleY;
            for(var k = 0; k < $e10cf2049e185956$var$LABEL_OPTION_TO_STYLE_KEYS.length; k++){
                var key = $e10cf2049e185956$var$LABEL_OPTION_TO_STYLE_KEYS[k];
                label.setStyle(key, layoutOption[key] != null ? layoutOption[key] : defaultLabelAttr.style[key]);
            }
            if (layoutOption.draggable) {
                label.draggable = true;
                label.cursor = 'move';
                if (hostEl) {
                    var hostModel = labelItem.seriesModel;
                    if (labelItem.dataIndex != null) {
                        var data = labelItem.seriesModel.getData(labelItem.dataType);
                        hostModel = data.getItemModel(labelItem.dataIndex);
                    }
                    label.on('drag', createDragHandler(hostEl, hostModel.getModel('labelLine')));
                }
            } else {
                // TODO Other drag functions?
                label.off('drag');
                label.cursor = defaultLabelAttr.cursor;
            }
        }
    };
    LabelManager.prototype.layout = function(api) {
        var width = api.getWidth();
        var height = api.getHeight();
        var labelList = (0, $11dac7a73f36cc2c$export$6c403cad1ae3e239)(this._labelList);
        var labelsNeedsAdjustOnX = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(labelList, function(item) {
            return item.layoutOption.moveOverlap === 'shiftX';
        });
        var labelsNeedsAdjustOnY = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(labelList, function(item) {
            return item.layoutOption.moveOverlap === 'shiftY';
        });
        (0, $11dac7a73f36cc2c$export$b6b2b07f8ed32bd6)(labelsNeedsAdjustOnX, 0, width);
        (0, $11dac7a73f36cc2c$export$118c25e0932528e4)(labelsNeedsAdjustOnY, 0, height);
        var labelsNeedsHideOverlap = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(labelList, function(item) {
            return item.layoutOption.hideOverlap;
        });
        (0, $11dac7a73f36cc2c$export$8ce774e164a49410)(labelsNeedsHideOverlap);
    };
    /**
   * Process all labels. Not only labels with layoutOption.
   */ LabelManager.prototype.processLabelsOverall = function() {
        var _this = this;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._chartViewList, function(chartView) {
            var seriesModel = chartView.__model;
            var ignoreLabelLineUpdate = chartView.ignoreLabelLineUpdate;
            var animationEnabled = seriesModel.isAnimationEnabled();
            chartView.group.traverse(function(child) {
                if (child.ignore && !child.forceLabelAnimation) return true; // Stop traverse descendants.
                var needsUpdateLabelLine = !ignoreLabelLineUpdate;
                var label = child.getTextContent();
                if (!needsUpdateLabelLine && label) needsUpdateLabelLine = $e10cf2049e185956$var$labelLayoutInnerStore(label).needsUpdateLabelLine;
                if (needsUpdateLabelLine) _this._updateLabelLine(child, seriesModel);
                if (animationEnabled) _this._animateLabels(child, seriesModel);
            });
        });
    };
    LabelManager.prototype._updateLabelLine = function(el, seriesModel) {
        // Only support label being hosted on graphic elements.
        var textEl = el.getTextContent();
        // Update label line style.
        var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el);
        var dataIndex = ecData.dataIndex;
        // Only support labelLine on the labels represent data.
        if (textEl && dataIndex != null) {
            var data = seriesModel.getData(ecData.dataType);
            var itemModel = data.getItemModel(dataIndex);
            var defaultStyle = {};
            var visualStyle = data.getItemVisual(dataIndex, 'style');
            if (visualStyle) {
                var visualType = data.getVisual('drawType');
                // Default to be same with main color
                defaultStyle.stroke = visualStyle[visualType];
            }
            var labelLineModel = itemModel.getModel('labelLine');
            (0, $f4eb87a228be297f$export$c09e0b0574bdd2dc)(el, (0, $f4eb87a228be297f$export$2979fdbf5ebce521)(itemModel), defaultStyle);
            (0, $f4eb87a228be297f$export$cc93ba643cd97d83)(el, labelLineModel);
        }
    };
    LabelManager.prototype._animateLabels = function(el, seriesModel) {
        var textEl = el.getTextContent();
        var guideLine = el.getTextGuideLine();
        // Animate
        if (textEl && (el.forceLabelAnimation || !textEl.ignore && !textEl.invisible && !el.disableLabelAnimation && !(0, $8b353638fbedfefa$export$5b89d4b643713034)(el))) {
            var layoutStore = $e10cf2049e185956$var$labelLayoutInnerStore(textEl);
            var oldLayout = layoutStore.oldLayout;
            var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el);
            var dataIndex = ecData.dataIndex;
            var newProps = {
                x: textEl.x,
                y: textEl.y,
                rotation: textEl.rotation
            };
            var data = seriesModel.getData(ecData.dataType);
            if (!oldLayout) {
                textEl.attr(newProps);
                // Disable fade in animation if value animation is enabled.
                if (!(0, $6800dfcb6e1e2a44$export$f62786d3261ab0f4)(textEl).valueAnimation) {
                    var oldOpacity = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(textEl.style.opacity, 1);
                    // Fade in animation
                    textEl.style.opacity = 0;
                    (0, $8b353638fbedfefa$export$a121566aadcfe021)(textEl, {
                        style: {
                            opacity: oldOpacity
                        }
                    }, seriesModel, dataIndex);
                }
            } else {
                textEl.attr(oldLayout);
                // Make sure the animation from is in the right status.
                var prevStates = el.prevStates;
                if (prevStates) {
                    if ((0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(prevStates, 'select') >= 0) textEl.attr(layoutStore.oldLayoutSelect);
                    if ((0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(prevStates, 'emphasis') >= 0) textEl.attr(layoutStore.oldLayoutEmphasis);
                }
                (0, $8b353638fbedfefa$export$c8dce3c08436e91e)(textEl, newProps, seriesModel, dataIndex);
            }
            layoutStore.oldLayout = newProps;
            if (textEl.states.select) {
                var layoutSelect = layoutStore.oldLayoutSelect = {};
                $e10cf2049e185956$var$extendWithKeys(layoutSelect, newProps, $e10cf2049e185956$var$LABEL_LAYOUT_PROPS);
                $e10cf2049e185956$var$extendWithKeys(layoutSelect, textEl.states.select, $e10cf2049e185956$var$LABEL_LAYOUT_PROPS);
            }
            if (textEl.states.emphasis) {
                var layoutEmphasis = layoutStore.oldLayoutEmphasis = {};
                $e10cf2049e185956$var$extendWithKeys(layoutEmphasis, newProps, $e10cf2049e185956$var$LABEL_LAYOUT_PROPS);
                $e10cf2049e185956$var$extendWithKeys(layoutEmphasis, textEl.states.emphasis, $e10cf2049e185956$var$LABEL_LAYOUT_PROPS);
            }
            (0, $6800dfcb6e1e2a44$export$dd6101605f5c186)(textEl, dataIndex, data, seriesModel, seriesModel);
        }
        if (guideLine && !guideLine.ignore && !guideLine.invisible) {
            var layoutStore = $e10cf2049e185956$var$labelLineAnimationStore(guideLine);
            var oldLayout = layoutStore.oldLayout;
            var newLayout = {
                points: guideLine.shape.points
            };
            if (!oldLayout) {
                guideLine.setShape(newLayout);
                guideLine.style.strokePercent = 0;
                (0, $8b353638fbedfefa$export$a121566aadcfe021)(guideLine, {
                    style: {
                        strokePercent: 1
                    }
                }, seriesModel);
            } else {
                guideLine.attr({
                    shape: oldLayout
                });
                (0, $8b353638fbedfefa$export$c8dce3c08436e91e)(guideLine, {
                    shape: newLayout
                }, seriesModel);
            }
            layoutStore.oldLayout = newLayout;
        }
    };
    return LabelManager;
}();
var $e10cf2049e185956$export$2e2bcd8739ae039 = $e10cf2049e185956$var$LabelManager;


var $de19ea5da3bb8f56$var$getLabelManager = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $de19ea5da3bb8f56$export$5320d1b3745c02a5(registers) {
    registers.registerUpdateLifecycle('series:beforeupdate', function(ecModel, api, params) {
        // TODO api provide an namespace that can save stuff per instance
        var labelManager = $de19ea5da3bb8f56$var$getLabelManager(api).labelManager;
        if (!labelManager) labelManager = $de19ea5da3bb8f56$var$getLabelManager(api).labelManager = new (0, $e10cf2049e185956$export$2e2bcd8739ae039)();
        labelManager.clearLabels();
    });
    registers.registerUpdateLifecycle('series:layoutlabels', function(ecModel, api, params) {
        var labelManager = $de19ea5da3bb8f56$var$getLabelManager(api).labelManager;
        params.updatedSeries.forEach(function(series) {
            labelManager.addLabelsOfSeries(api.getViewOfSeriesModel(series));
        });
        labelManager.updateLayoutConfig(api);
        labelManager.layout(api);
        labelManager.processLabelsOverall();
    });
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Universal transitions that can animate between any shapes(series) and any properties in any amounts.


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 














var $2a60c506580ea7a9$var$CMD = (0, $20ebe2448f123f2e$export$2e2bcd8739ae039).CMD;
function $2a60c506580ea7a9$var$aroundEqual(a, b) {
    return Math.abs(a - b) < 1e-5;
}
function $2a60c506580ea7a9$export$fbc91cffd4bdf629(path) {
    var data = path.data;
    var len = path.len();
    var bezierArrayGroups = [];
    var currentSubpath;
    var xi = 0;
    var yi = 0;
    var x0 = 0;
    var y0 = 0;
    function createNewSubpath(x, y) {
        if (currentSubpath && currentSubpath.length > 2) bezierArrayGroups.push(currentSubpath);
        currentSubpath = [
            x,
            y
        ];
    }
    function addLine(x0, y0, x1, y1) {
        if (!($2a60c506580ea7a9$var$aroundEqual(x0, x1) && $2a60c506580ea7a9$var$aroundEqual(y0, y1))) currentSubpath.push(x0, y0, x1, y1, x1, y1);
    }
    function addArc(startAngle, endAngle, cx, cy, rx, ry) {
        var delta = Math.abs(endAngle - startAngle);
        var len = Math.tan(delta / 4) * 4 / 3;
        var dir = endAngle < startAngle ? -1 : 1;
        var c1 = Math.cos(startAngle);
        var s1 = Math.sin(startAngle);
        var c2 = Math.cos(endAngle);
        var s2 = Math.sin(endAngle);
        var x1 = c1 * rx + cx;
        var y1 = s1 * ry + cy;
        var x4 = c2 * rx + cx;
        var y4 = s2 * ry + cy;
        var hx = rx * len * dir;
        var hy = ry * len * dir;
        currentSubpath.push(x1 - hx * s1, y1 + hy * c1, x4 + hx * s2, y4 - hy * c2, x4, y4);
    }
    var x1;
    var y1;
    var x2;
    var y2;
    for(var i = 0; i < len;){
        var cmd = data[i++];
        var isFirst = i === 1;
        if (isFirst) {
            xi = data[i];
            yi = data[i + 1];
            x0 = xi;
            y0 = yi;
            if (cmd === $2a60c506580ea7a9$var$CMD.L || cmd === $2a60c506580ea7a9$var$CMD.C || cmd === $2a60c506580ea7a9$var$CMD.Q) currentSubpath = [
                x0,
                y0
            ];
        }
        switch(cmd){
            case $2a60c506580ea7a9$var$CMD.M:
                xi = x0 = data[i++];
                yi = y0 = data[i++];
                createNewSubpath(x0, y0);
                break;
            case $2a60c506580ea7a9$var$CMD.L:
                x1 = data[i++];
                y1 = data[i++];
                addLine(xi, yi, x1, y1);
                xi = x1;
                yi = y1;
                break;
            case $2a60c506580ea7a9$var$CMD.C:
                currentSubpath.push(data[i++], data[i++], data[i++], data[i++], xi = data[i++], yi = data[i++]);
                break;
            case $2a60c506580ea7a9$var$CMD.Q:
                x1 = data[i++];
                y1 = data[i++];
                x2 = data[i++];
                y2 = data[i++];
                currentSubpath.push(xi + 2 / 3 * (x1 - xi), yi + 2 / 3 * (y1 - yi), x2 + 2 / 3 * (x1 - x2), y2 + 2 / 3 * (y1 - y2), x2, y2);
                xi = x2;
                yi = y2;
                break;
            case $2a60c506580ea7a9$var$CMD.A:
                var cx = data[i++];
                var cy = data[i++];
                var rx = data[i++];
                var ry = data[i++];
                var startAngle = data[i++];
                var endAngle = data[i++] + startAngle;
                i += 1;
                var anticlockwise = !data[i++];
                x1 = Math.cos(startAngle) * rx + cx;
                y1 = Math.sin(startAngle) * ry + cy;
                if (isFirst) {
                    x0 = x1;
                    y0 = y1;
                    createNewSubpath(x0, y0);
                } else addLine(xi, yi, x1, y1);
                xi = Math.cos(endAngle) * rx + cx;
                yi = Math.sin(endAngle) * ry + cy;
                var step = (anticlockwise ? -1 : 1) * Math.PI / 2;
                for(var angle = startAngle; anticlockwise ? angle > endAngle : angle < endAngle; angle += step){
                    var nextAngle = anticlockwise ? Math.max(angle + step, endAngle) : Math.min(angle + step, endAngle);
                    addArc(angle, nextAngle, cx, cy, rx, ry);
                }
                break;
            case $2a60c506580ea7a9$var$CMD.R:
                x0 = xi = data[i++];
                y0 = yi = data[i++];
                x1 = x0 + data[i++];
                y1 = y0 + data[i++];
                createNewSubpath(x1, y0);
                addLine(x1, y0, x1, y1);
                addLine(x1, y1, x0, y1);
                addLine(x0, y1, x0, y0);
                addLine(x0, y0, x1, y0);
                break;
            case $2a60c506580ea7a9$var$CMD.Z:
                currentSubpath && addLine(xi, yi, x0, y0);
                xi = x0;
                yi = y0;
                break;
        }
    }
    if (currentSubpath && currentSubpath.length > 2) bezierArrayGroups.push(currentSubpath);
    return bezierArrayGroups;
}
function $2a60c506580ea7a9$var$adpativeBezier(x0, y0, x1, y1, x2, y2, x3, y3, out, scale) {
    if ($2a60c506580ea7a9$var$aroundEqual(x0, x1) && $2a60c506580ea7a9$var$aroundEqual(y0, y1) && $2a60c506580ea7a9$var$aroundEqual(x2, x3) && $2a60c506580ea7a9$var$aroundEqual(y2, y3)) {
        out.push(x3, y3);
        return;
    }
    var PIXEL_DISTANCE = 2 / scale;
    var PIXEL_DISTANCE_SQR = PIXEL_DISTANCE * PIXEL_DISTANCE;
    var dx = x3 - x0;
    var dy = y3 - y0;
    var d = Math.sqrt(dx * dx + dy * dy);
    dx /= d;
    dy /= d;
    var dx1 = x1 - x0;
    var dy1 = y1 - y0;
    var dx2 = x2 - x3;
    var dy2 = y2 - y3;
    var cp1LenSqr = dx1 * dx1 + dy1 * dy1;
    var cp2LenSqr = dx2 * dx2 + dy2 * dy2;
    if (cp1LenSqr < PIXEL_DISTANCE_SQR && cp2LenSqr < PIXEL_DISTANCE_SQR) {
        out.push(x3, y3);
        return;
    }
    var projLen1 = dx * dx1 + dy * dy1;
    var projLen2 = -dx * dx2 - dy * dy2;
    var d1Sqr = cp1LenSqr - projLen1 * projLen1;
    var d2Sqr = cp2LenSqr - projLen2 * projLen2;
    if (d1Sqr < PIXEL_DISTANCE_SQR && projLen1 >= 0 && d2Sqr < PIXEL_DISTANCE_SQR && projLen2 >= 0) {
        out.push(x3, y3);
        return;
    }
    var tmpSegX = [];
    var tmpSegY = [];
    (0, $747cfc5611b57cea$export$a2ee23a0567039da)(x0, x1, x2, x3, 0.5, tmpSegX);
    (0, $747cfc5611b57cea$export$a2ee23a0567039da)(y0, y1, y2, y3, 0.5, tmpSegY);
    $2a60c506580ea7a9$var$adpativeBezier(tmpSegX[0], tmpSegY[0], tmpSegX[1], tmpSegY[1], tmpSegX[2], tmpSegY[2], tmpSegX[3], tmpSegY[3], out, scale);
    $2a60c506580ea7a9$var$adpativeBezier(tmpSegX[4], tmpSegY[4], tmpSegX[5], tmpSegY[5], tmpSegX[6], tmpSegY[6], tmpSegX[7], tmpSegY[7], out, scale);
}
function $2a60c506580ea7a9$export$163f4950160f2337(path, scale) {
    var bezierArrayGroups = $2a60c506580ea7a9$export$fbc91cffd4bdf629(path);
    var polygons = [];
    scale = scale || 1;
    for(var i = 0; i < bezierArrayGroups.length; i++){
        var beziers = bezierArrayGroups[i];
        var polygon = [];
        var x0 = beziers[0];
        var y0 = beziers[1];
        polygon.push(x0, y0);
        for(var k = 2; k < beziers.length;){
            var x1 = beziers[k++];
            var y1 = beziers[k++];
            var x2 = beziers[k++];
            var y2 = beziers[k++];
            var x3 = beziers[k++];
            var y3 = beziers[k++];
            $2a60c506580ea7a9$var$adpativeBezier(x0, y0, x1, y1, x2, y2, x3, y3, polygon, scale);
            x0 = x3;
            y0 = y3;
        }
        polygons.push(polygon);
    }
    return polygons;
}



function $640f8b532a910a4f$var$getDividingGrids(dimSize, rowDim, count) {
    var rowSize = dimSize[rowDim];
    var columnSize = dimSize[1 - rowDim];
    var ratio = Math.abs(rowSize / columnSize);
    var rowCount = Math.ceil(Math.sqrt(ratio * count));
    var columnCount = Math.floor(count / rowCount);
    if (columnCount === 0) {
        columnCount = 1;
        rowCount = count;
    }
    var grids = [];
    for(var i = 0; i < rowCount; i++)grids.push(columnCount);
    var currentCount = rowCount * columnCount;
    var remained = count - currentCount;
    if (remained > 0) for(var i = 0; i < remained; i++)grids[i % rowCount] += 1;
    return grids;
}
function $640f8b532a910a4f$var$divideSector(sectorShape, count, outShapes) {
    var r0 = sectorShape.r0;
    var r = sectorShape.r;
    var startAngle = sectorShape.startAngle;
    var endAngle = sectorShape.endAngle;
    var angle = Math.abs(endAngle - startAngle);
    var arcLen = angle * r;
    var deltaR = r - r0;
    var isAngleRow = arcLen > Math.abs(deltaR);
    var grids = $640f8b532a910a4f$var$getDividingGrids([
        arcLen,
        deltaR
    ], isAngleRow ? 0 : 1, count);
    var rowSize = (isAngleRow ? angle : deltaR) / grids.length;
    for(var row = 0; row < grids.length; row++){
        var columnSize = (isAngleRow ? deltaR : angle) / grids[row];
        for(var column = 0; column < grids[row]; column++){
            var newShape = {};
            if (isAngleRow) {
                newShape.startAngle = startAngle + rowSize * row;
                newShape.endAngle = startAngle + rowSize * (row + 1);
                newShape.r0 = r0 + columnSize * column;
                newShape.r = r0 + columnSize * (column + 1);
            } else {
                newShape.startAngle = startAngle + columnSize * column;
                newShape.endAngle = startAngle + columnSize * (column + 1);
                newShape.r0 = r0 + rowSize * row;
                newShape.r = r0 + rowSize * (row + 1);
            }
            newShape.clockwise = sectorShape.clockwise;
            newShape.cx = sectorShape.cx;
            newShape.cy = sectorShape.cy;
            outShapes.push(newShape);
        }
    }
}
function $640f8b532a910a4f$var$divideRect(rectShape, count, outShapes) {
    var width = rectShape.width;
    var height = rectShape.height;
    var isHorizontalRow = width > height;
    var grids = $640f8b532a910a4f$var$getDividingGrids([
        width,
        height
    ], isHorizontalRow ? 0 : 1, count);
    var rowSizeDim = isHorizontalRow ? 'width' : 'height';
    var columnSizeDim = isHorizontalRow ? 'height' : 'width';
    var rowDim = isHorizontalRow ? 'x' : 'y';
    var columnDim = isHorizontalRow ? 'y' : 'x';
    var rowSize = rectShape[rowSizeDim] / grids.length;
    for(var row = 0; row < grids.length; row++){
        var columnSize = rectShape[columnSizeDim] / grids[row];
        for(var column = 0; column < grids[row]; column++){
            var newShape = {};
            newShape[rowDim] = row * rowSize;
            newShape[columnDim] = column * columnSize;
            newShape[rowSizeDim] = rowSize;
            newShape[columnSizeDim] = columnSize;
            newShape.x += rectShape.x;
            newShape.y += rectShape.y;
            outShapes.push(newShape);
        }
    }
}
function $640f8b532a910a4f$var$crossProduct2d(x1, y1, x2, y2) {
    return x1 * y2 - x2 * y1;
}
function $640f8b532a910a4f$var$lineLineIntersect(a1x, a1y, a2x, a2y, b1x, b1y, b2x, b2y) {
    var mx = a2x - a1x;
    var my = a2y - a1y;
    var nx = b2x - b1x;
    var ny = b2y - b1y;
    var nmCrossProduct = $640f8b532a910a4f$var$crossProduct2d(nx, ny, mx, my);
    if (Math.abs(nmCrossProduct) < 1e-6) return null;
    var b1a1x = a1x - b1x;
    var b1a1y = a1y - b1y;
    var p = $640f8b532a910a4f$var$crossProduct2d(b1a1x, b1a1y, nx, ny) / nmCrossProduct;
    if (p < 0 || p > 1) return null;
    return new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)(p * mx + a1x, p * my + a1y);
}
function $640f8b532a910a4f$var$projPtOnLine(pt, lineA, lineB) {
    var dir = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
    (0, $b887f038f104fe7e$export$2e2bcd8739ae039).sub(dir, lineB, lineA);
    dir.normalize();
    var dir2 = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
    (0, $b887f038f104fe7e$export$2e2bcd8739ae039).sub(dir2, pt, lineA);
    var len = dir2.dot(dir);
    return len;
}
function $640f8b532a910a4f$var$addToPoly(poly, pt) {
    var last = poly[poly.length - 1];
    if (last && last[0] === pt[0] && last[1] === pt[1]) return;
    poly.push(pt);
}
function $640f8b532a910a4f$var$splitPolygonByLine(points, lineA, lineB) {
    var len = points.length;
    var intersections = [];
    for(var i = 0; i < len; i++){
        var p0 = points[i];
        var p1 = points[(i + 1) % len];
        var intersectionPt = $640f8b532a910a4f$var$lineLineIntersect(p0[0], p0[1], p1[0], p1[1], lineA.x, lineA.y, lineB.x, lineB.y);
        if (intersectionPt) intersections.push({
            projPt: $640f8b532a910a4f$var$projPtOnLine(intersectionPt, lineA, lineB),
            pt: intersectionPt,
            idx: i
        });
    }
    if (intersections.length < 2) return [
        {
            points: points
        },
        {
            points: points
        }
    ];
    intersections.sort(function(a, b) {
        return a.projPt - b.projPt;
    });
    var splitPt0 = intersections[0];
    var splitPt1 = intersections[intersections.length - 1];
    if (splitPt1.idx < splitPt0.idx) {
        var tmp = splitPt0;
        splitPt0 = splitPt1;
        splitPt1 = tmp;
    }
    var splitPt0Arr = [
        splitPt0.pt.x,
        splitPt0.pt.y
    ];
    var splitPt1Arr = [
        splitPt1.pt.x,
        splitPt1.pt.y
    ];
    var newPolyA = [
        splitPt0Arr
    ];
    var newPolyB = [
        splitPt1Arr
    ];
    for(var i = splitPt0.idx + 1; i <= splitPt1.idx; i++)$640f8b532a910a4f$var$addToPoly(newPolyA, points[i].slice());
    $640f8b532a910a4f$var$addToPoly(newPolyA, splitPt1Arr);
    $640f8b532a910a4f$var$addToPoly(newPolyA, splitPt0Arr);
    for(var i = splitPt1.idx + 1; i <= splitPt0.idx + len; i++)$640f8b532a910a4f$var$addToPoly(newPolyB, points[i % len].slice());
    $640f8b532a910a4f$var$addToPoly(newPolyB, splitPt0Arr);
    $640f8b532a910a4f$var$addToPoly(newPolyB, splitPt1Arr);
    return [
        {
            points: newPolyA
        },
        {
            points: newPolyB
        }
    ];
}
function $640f8b532a910a4f$var$binaryDividePolygon(polygonShape) {
    var points = polygonShape.points;
    var min = [];
    var max = [];
    (0, $af3aab2435198f82$export$188c3cd07b4129dd)(points, min, max);
    var boundingRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(min[0], min[1], max[0] - min[0], max[1] - min[1]);
    var width = boundingRect.width;
    var height = boundingRect.height;
    var x = boundingRect.x;
    var y = boundingRect.y;
    var pt0 = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
    var pt1 = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
    if (width > height) {
        pt0.x = pt1.x = x + width / 2;
        pt0.y = y;
        pt1.y = y + height;
    } else {
        pt0.y = pt1.y = y + height / 2;
        pt0.x = x;
        pt1.x = x + width;
    }
    return $640f8b532a910a4f$var$splitPolygonByLine(points, pt0, pt1);
}
function $640f8b532a910a4f$var$binaryDivideRecursive(divider, shape, count, out) {
    if (count === 1) out.push(shape);
    else {
        var mid = Math.floor(count / 2);
        var sub = divider(shape);
        $640f8b532a910a4f$var$binaryDivideRecursive(divider, sub[0], mid, out);
        $640f8b532a910a4f$var$binaryDivideRecursive(divider, sub[1], count - mid, out);
    }
    return out;
}
function $640f8b532a910a4f$export$9cd59f9826255e47(path, count) {
    var paths = [];
    for(var i = 0; i < count; i++)paths.push((0, $15b38920672b9006$export$18711d956bf1c3eb)(path));
    return paths;
}
function $640f8b532a910a4f$var$copyPathProps(source, target) {
    target.setStyle(source.style);
    target.z = source.z;
    target.z2 = source.z2;
    target.zlevel = source.zlevel;
}
function $640f8b532a910a4f$var$polygonConvert(points) {
    var out = [];
    for(var i = 0; i < points.length;)out.push([
        points[i++],
        points[i++]
    ]);
    return out;
}
function $640f8b532a910a4f$export$65980d18b75784e2(path, count) {
    var outShapes = [];
    var shape = path.shape;
    var OutShapeCtor;
    switch(path.type){
        case 'rect':
            $640f8b532a910a4f$var$divideRect(shape, count, outShapes);
            OutShapeCtor = (0, $419e5ff2f303755e$export$2e2bcd8739ae039);
            break;
        case 'sector':
            $640f8b532a910a4f$var$divideSector(shape, count, outShapes);
            OutShapeCtor = (0, $a3e1dec0a3875b49$export$2e2bcd8739ae039);
            break;
        case 'circle':
            $640f8b532a910a4f$var$divideSector({
                r0: 0,
                r: shape.r,
                startAngle: 0,
                endAngle: Math.PI * 2,
                cx: shape.cx,
                cy: shape.cy
            }, count, outShapes);
            OutShapeCtor = (0, $a3e1dec0a3875b49$export$2e2bcd8739ae039);
            break;
        default:
            var m = path.getComputedTransform();
            var scale = m ? Math.sqrt(Math.max(m[0] * m[0] + m[1] * m[1], m[2] * m[2] + m[3] * m[3])) : 1;
            var polygons = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)((0, $2a60c506580ea7a9$export$163f4950160f2337)(path.getUpdatedPathProxy(), scale), function(poly) {
                return $640f8b532a910a4f$var$polygonConvert(poly);
            });
            var polygonCount = polygons.length;
            if (polygonCount === 0) $640f8b532a910a4f$var$binaryDivideRecursive($640f8b532a910a4f$var$binaryDividePolygon, {
                points: polygons[0]
            }, count, outShapes);
            else if (polygonCount === count) for(var i = 0; i < polygonCount; i++)outShapes.push({
                points: polygons[i]
            });
            else {
                var totalArea_1 = 0;
                var items = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(polygons, function(poly) {
                    var min = [];
                    var max = [];
                    (0, $af3aab2435198f82$export$188c3cd07b4129dd)(poly, min, max);
                    var area = (max[1] - min[1]) * (max[0] - min[0]);
                    totalArea_1 += area;
                    return {
                        poly: poly,
                        area: area
                    };
                });
                items.sort(function(a, b) {
                    return b.area - a.area;
                });
                var left = count;
                for(var i = 0; i < polygonCount; i++){
                    var item = items[i];
                    if (left <= 0) break;
                    var selfCount = i === polygonCount - 1 ? left : Math.ceil(item.area / totalArea_1 * count);
                    if (selfCount < 0) continue;
                    $640f8b532a910a4f$var$binaryDivideRecursive($640f8b532a910a4f$var$binaryDividePolygon, {
                        points: item.poly
                    }, selfCount, outShapes);
                    left -= selfCount;
                }
            }
            OutShapeCtor = (0, $51acf033123e1a30$export$2e2bcd8739ae039);
            break;
    }
    if (!OutShapeCtor) return $640f8b532a910a4f$export$9cd59f9826255e47(path, count);
    var out = [];
    for(var i = 0; i < outShapes.length; i++){
        var subPath = new OutShapeCtor();
        subPath.setShape(outShapes[i]);
        $640f8b532a910a4f$var$copyPathProps(path, subPath);
        out.push(subPath);
    }
    return out;
}



function $2ef03ef3a2bb366a$var$alignSubpath(subpath1, subpath2) {
    var len1 = subpath1.length;
    var len2 = subpath2.length;
    if (len1 === len2) return [
        subpath1,
        subpath2
    ];
    var tmpSegX = [];
    var tmpSegY = [];
    var shorterPath = len1 < len2 ? subpath1 : subpath2;
    var shorterLen = Math.min(len1, len2);
    var diff = Math.abs(len2 - len1) / 6;
    var shorterBezierCount = (shorterLen - 2) / 6;
    var eachCurveSubDivCount = Math.ceil(diff / shorterBezierCount) + 1;
    var newSubpath = [
        shorterPath[0],
        shorterPath[1]
    ];
    var remained = diff;
    for(var i = 2; i < shorterLen;){
        var x0 = shorterPath[i - 2];
        var y0 = shorterPath[i - 1];
        var x1 = shorterPath[i++];
        var y1 = shorterPath[i++];
        var x2 = shorterPath[i++];
        var y2 = shorterPath[i++];
        var x3 = shorterPath[i++];
        var y3 = shorterPath[i++];
        if (remained <= 0) {
            newSubpath.push(x1, y1, x2, y2, x3, y3);
            continue;
        }
        var actualSubDivCount = Math.min(remained, eachCurveSubDivCount - 1) + 1;
        for(var k = 1; k <= actualSubDivCount; k++){
            var p = k / actualSubDivCount;
            (0, $747cfc5611b57cea$export$a2ee23a0567039da)(x0, x1, x2, x3, p, tmpSegX);
            (0, $747cfc5611b57cea$export$a2ee23a0567039da)(y0, y1, y2, y3, p, tmpSegY);
            x0 = tmpSegX[3];
            y0 = tmpSegY[3];
            newSubpath.push(tmpSegX[1], tmpSegY[1], tmpSegX[2], tmpSegY[2], x0, y0);
            x1 = tmpSegX[5];
            y1 = tmpSegY[5];
            x2 = tmpSegX[6];
            y2 = tmpSegY[6];
        }
        remained -= actualSubDivCount - 1;
    }
    return shorterPath === subpath1 ? [
        newSubpath,
        subpath2
    ] : [
        subpath1,
        newSubpath
    ];
}
function $2ef03ef3a2bb366a$var$createSubpath(lastSubpathSubpath, otherSubpath) {
    var len = lastSubpathSubpath.length;
    var lastX = lastSubpathSubpath[len - 2];
    var lastY = lastSubpathSubpath[len - 1];
    var newSubpath = [];
    for(var i = 0; i < otherSubpath.length;){
        newSubpath[i++] = lastX;
        newSubpath[i++] = lastY;
    }
    return newSubpath;
}
function $2ef03ef3a2bb366a$export$d7b853a0ab412a07(array1, array2) {
    var _a;
    var lastSubpath1;
    var lastSubpath2;
    var newArray1 = [];
    var newArray2 = [];
    for(var i = 0; i < Math.max(array1.length, array2.length); i++){
        var subpath1 = array1[i];
        var subpath2 = array2[i];
        var newSubpath1 = void 0;
        var newSubpath2 = void 0;
        if (!subpath1) {
            newSubpath1 = $2ef03ef3a2bb366a$var$createSubpath(lastSubpath1 || subpath2, subpath2);
            newSubpath2 = subpath2;
        } else if (!subpath2) {
            newSubpath2 = $2ef03ef3a2bb366a$var$createSubpath(lastSubpath2 || subpath1, subpath1);
            newSubpath1 = subpath1;
        } else {
            _a = $2ef03ef3a2bb366a$var$alignSubpath(subpath1, subpath2), newSubpath1 = _a[0], newSubpath2 = _a[1];
            lastSubpath1 = newSubpath1;
            lastSubpath2 = newSubpath2;
        }
        newArray1.push(newSubpath1);
        newArray2.push(newSubpath2);
    }
    return [
        newArray1,
        newArray2
    ];
}
function $2ef03ef3a2bb366a$export$e2a20c553f6c85ce(array) {
    var signedArea = 0;
    var cx = 0;
    var cy = 0;
    var len = array.length;
    for(var i = 0, j = len - 2; i < len; j = i, i += 2){
        var x0 = array[j];
        var y0 = array[j + 1];
        var x1 = array[i];
        var y1 = array[i + 1];
        var a = x0 * y1 - x1 * y0;
        signedArea += a;
        cx += (x0 + x1) * a;
        cy += (y0 + y1) * a;
    }
    if (signedArea === 0) return [
        array[0] || 0,
        array[1] || 0
    ];
    return [
        cx / signedArea / 3,
        cy / signedArea / 3,
        signedArea
    ];
}
function $2ef03ef3a2bb366a$var$findBestRingOffset(fromSubBeziers, toSubBeziers, fromCp, toCp) {
    var bezierCount = (fromSubBeziers.length - 2) / 6;
    var bestScore = Infinity;
    var bestOffset = 0;
    var len = fromSubBeziers.length;
    var len2 = len - 2;
    for(var offset = 0; offset < bezierCount; offset++){
        var cursorOffset = offset * 6;
        var score = 0;
        for(var k = 0; k < len; k += 2){
            var idx = k === 0 ? cursorOffset : (cursorOffset + k - 2) % len2 + 2;
            var x0 = fromSubBeziers[idx] - fromCp[0];
            var y0 = fromSubBeziers[idx + 1] - fromCp[1];
            var x1 = toSubBeziers[k] - toCp[0];
            var y1 = toSubBeziers[k + 1] - toCp[1];
            var dx = x1 - x0;
            var dy = y1 - y0;
            score += dx * dx + dy * dy;
        }
        if (score < bestScore) {
            bestScore = score;
            bestOffset = offset;
        }
    }
    return bestOffset;
}
function $2ef03ef3a2bb366a$var$reverse(array) {
    var newArr = [];
    var len = array.length;
    for(var i = 0; i < len; i += 2){
        newArr[i] = array[len - i - 2];
        newArr[i + 1] = array[len - i - 1];
    }
    return newArr;
}
function $2ef03ef3a2bb366a$var$findBestMorphingRotation(fromArr, toArr, searchAngleIteration, searchAngleRange) {
    var result = [];
    var fromNeedsReverse;
    for(var i = 0; i < fromArr.length; i++){
        var fromSubpathBezier = fromArr[i];
        var toSubpathBezier = toArr[i];
        var fromCp = $2ef03ef3a2bb366a$export$e2a20c553f6c85ce(fromSubpathBezier);
        var toCp = $2ef03ef3a2bb366a$export$e2a20c553f6c85ce(toSubpathBezier);
        if (fromNeedsReverse == null) fromNeedsReverse = fromCp[2] < 0 !== toCp[2] < 0;
        var newFromSubpathBezier = [];
        var newToSubpathBezier = [];
        var bestAngle = 0;
        var bestScore = Infinity;
        var tmpArr = [];
        var len = fromSubpathBezier.length;
        if (fromNeedsReverse) fromSubpathBezier = $2ef03ef3a2bb366a$var$reverse(fromSubpathBezier);
        var offset = $2ef03ef3a2bb366a$var$findBestRingOffset(fromSubpathBezier, toSubpathBezier, fromCp, toCp) * 6;
        var len2 = len - 2;
        for(var k = 0; k < len2; k += 2){
            var idx = (offset + k) % len2 + 2;
            newFromSubpathBezier[k + 2] = fromSubpathBezier[idx] - fromCp[0];
            newFromSubpathBezier[k + 3] = fromSubpathBezier[idx + 1] - fromCp[1];
        }
        newFromSubpathBezier[0] = fromSubpathBezier[offset] - fromCp[0];
        newFromSubpathBezier[1] = fromSubpathBezier[offset + 1] - fromCp[1];
        if (searchAngleIteration > 0) {
            var step = searchAngleRange / searchAngleIteration;
            for(var angle = -searchAngleRange / 2; angle <= searchAngleRange / 2; angle += step){
                var sa = Math.sin(angle);
                var ca = Math.cos(angle);
                var score = 0;
                for(var k = 0; k < fromSubpathBezier.length; k += 2){
                    var x0 = newFromSubpathBezier[k];
                    var y0 = newFromSubpathBezier[k + 1];
                    var x1 = toSubpathBezier[k] - toCp[0];
                    var y1 = toSubpathBezier[k + 1] - toCp[1];
                    var newX1 = x1 * ca - y1 * sa;
                    var newY1 = x1 * sa + y1 * ca;
                    tmpArr[k] = newX1;
                    tmpArr[k + 1] = newY1;
                    var dx = newX1 - x0;
                    var dy = newY1 - y0;
                    score += dx * dx + dy * dy;
                }
                if (score < bestScore) {
                    bestScore = score;
                    bestAngle = angle;
                    for(var m = 0; m < tmpArr.length; m++)newToSubpathBezier[m] = tmpArr[m];
                }
            }
        } else for(var i_1 = 0; i_1 < len; i_1 += 2){
            newToSubpathBezier[i_1] = toSubpathBezier[i_1] - toCp[0];
            newToSubpathBezier[i_1 + 1] = toSubpathBezier[i_1 + 1] - toCp[1];
        }
        result.push({
            from: newFromSubpathBezier,
            to: newToSubpathBezier,
            fromCp: fromCp,
            toCp: toCp,
            rotation: -bestAngle
        });
    }
    return result;
}
function $2ef03ef3a2bb366a$export$f9f720a01590a46f(path) {
    return path.__isCombineMorphing;
}
function $2ef03ef3a2bb366a$export$ddee3124b756354f(el) {
    return el.__morphT >= 0;
}
var $2ef03ef3a2bb366a$var$SAVED_METHOD_PREFIX = '__mOriginal_';
function $2ef03ef3a2bb366a$var$saveAndModifyMethod(obj, methodName, modifiers) {
    var savedMethodName = $2ef03ef3a2bb366a$var$SAVED_METHOD_PREFIX + methodName;
    var originalMethod = obj[savedMethodName] || obj[methodName];
    if (!obj[savedMethodName]) obj[savedMethodName] = obj[methodName];
    var replace = modifiers.replace;
    var after = modifiers.after;
    var before = modifiers.before;
    obj[methodName] = function() {
        var args = arguments;
        var res;
        before && before.apply(this, args);
        if (replace) res = replace.apply(this, args);
        else res = originalMethod.apply(this, args);
        after && after.apply(this, args);
        return res;
    };
}
function $2ef03ef3a2bb366a$var$restoreMethod(obj, methodName) {
    var savedMethodName = $2ef03ef3a2bb366a$var$SAVED_METHOD_PREFIX + methodName;
    if (obj[savedMethodName]) {
        obj[methodName] = obj[savedMethodName];
        obj[savedMethodName] = null;
    }
}
function $2ef03ef3a2bb366a$var$applyTransformOnBeziers(bezierCurves, mm) {
    for(var i = 0; i < bezierCurves.length; i++){
        var subBeziers = bezierCurves[i];
        for(var k = 0; k < subBeziers.length;){
            var x = subBeziers[k];
            var y = subBeziers[k + 1];
            subBeziers[k++] = mm[0] * x + mm[2] * y + mm[4];
            subBeziers[k++] = mm[1] * x + mm[3] * y + mm[5];
        }
    }
}
function $2ef03ef3a2bb366a$var$prepareMorphPath(fromPath, toPath) {
    var fromPathProxy = fromPath.getUpdatedPathProxy();
    var toPathProxy = toPath.getUpdatedPathProxy();
    var _a = $2ef03ef3a2bb366a$export$d7b853a0ab412a07((0, $2a60c506580ea7a9$export$fbc91cffd4bdf629)(fromPathProxy), (0, $2a60c506580ea7a9$export$fbc91cffd4bdf629)(toPathProxy)), fromBezierCurves = _a[0], toBezierCurves = _a[1];
    var fromPathTransform = fromPath.getComputedTransform();
    var toPathTransform = toPath.getComputedTransform();
    function updateIdentityTransform() {
        this.transform = null;
    }
    fromPathTransform && $2ef03ef3a2bb366a$var$applyTransformOnBeziers(fromBezierCurves, fromPathTransform);
    toPathTransform && $2ef03ef3a2bb366a$var$applyTransformOnBeziers(toBezierCurves, toPathTransform);
    $2ef03ef3a2bb366a$var$saveAndModifyMethod(toPath, 'updateTransform', {
        replace: updateIdentityTransform
    });
    toPath.transform = null;
    var morphingData = $2ef03ef3a2bb366a$var$findBestMorphingRotation(fromBezierCurves, toBezierCurves, 10, Math.PI);
    var tmpArr = [];
    $2ef03ef3a2bb366a$var$saveAndModifyMethod(toPath, 'buildPath', {
        replace: function(path) {
            var t = toPath.__morphT;
            var onet = 1 - t;
            var newCp = [];
            for(var i = 0; i < morphingData.length; i++){
                var item = morphingData[i];
                var from = item.from;
                var to = item.to;
                var angle = item.rotation * t;
                var fromCp = item.fromCp;
                var toCp = item.toCp;
                var sa = Math.sin(angle);
                var ca = Math.cos(angle);
                (0, $6de594cf8ac295ff$export$3a89f8d6f6bf6c9f)(newCp, fromCp, toCp, t);
                for(var m = 0; m < from.length; m += 2){
                    var x0_1 = from[m];
                    var y0_1 = from[m + 1];
                    var x1 = to[m];
                    var y1 = to[m + 1];
                    var x = x0_1 * onet + x1 * t;
                    var y = y0_1 * onet + y1 * t;
                    tmpArr[m] = x * ca - y * sa + newCp[0];
                    tmpArr[m + 1] = x * sa + y * ca + newCp[1];
                }
                var x0 = tmpArr[0];
                var y0 = tmpArr[1];
                path.moveTo(x0, y0);
                for(var m = 2; m < from.length;){
                    var x1 = tmpArr[m++];
                    var y1 = tmpArr[m++];
                    var x2 = tmpArr[m++];
                    var y2 = tmpArr[m++];
                    var x3 = tmpArr[m++];
                    var y3 = tmpArr[m++];
                    if (x0 === x1 && y0 === y1 && x2 === x3 && y2 === y3) path.lineTo(x3, y3);
                    else path.bezierCurveTo(x1, y1, x2, y2, x3, y3);
                    x0 = x3;
                    y0 = y3;
                }
            }
        }
    });
}
function $2ef03ef3a2bb366a$export$7174e282c1c7df1c(fromPath, toPath, animationOpts) {
    if (!fromPath || !toPath) return toPath;
    var oldDone = animationOpts.done;
    var oldDuring = animationOpts.during;
    $2ef03ef3a2bb366a$var$prepareMorphPath(fromPath, toPath);
    toPath.__morphT = 0;
    function restoreToPath() {
        $2ef03ef3a2bb366a$var$restoreMethod(toPath, 'buildPath');
        $2ef03ef3a2bb366a$var$restoreMethod(toPath, 'updateTransform');
        toPath.__morphT = -1;
        toPath.createPathProxy();
        toPath.dirtyShape();
    }
    toPath.animateTo({
        __morphT: 1
    }, (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
        during: function(p) {
            toPath.dirtyShape();
            oldDuring && oldDuring(p);
        },
        done: function() {
            restoreToPath();
            oldDone && oldDone();
        }
    }, animationOpts));
    return toPath;
}
function $2ef03ef3a2bb366a$var$hilbert(x, y, minX, minY, maxX, maxY) {
    var bits = 16;
    x = maxX === minX ? 0 : Math.round(32767 * (x - minX) / (maxX - minX));
    y = maxY === minY ? 0 : Math.round(32767 * (y - minY) / (maxY - minY));
    var d = 0;
    var tmp;
    for(var s = (1 << bits) / 2; s > 0; s /= 2){
        var rx = 0;
        var ry = 0;
        if ((x & s) > 0) rx = 1;
        if ((y & s) > 0) ry = 1;
        d += s * s * (3 * rx ^ ry);
        if (ry === 0) {
            if (rx === 1) {
                x = s - 1 - x;
                y = s - 1 - y;
            }
            tmp = x;
            x = y;
            y = tmp;
        }
    }
    return d;
}
function $2ef03ef3a2bb366a$var$sortPaths(pathList) {
    var xMin = Infinity;
    var yMin = Infinity;
    var xMax = -Infinity;
    var yMax = -Infinity;
    var cps = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(pathList, function(path) {
        var rect = path.getBoundingRect();
        var m = path.getComputedTransform();
        var x = rect.x + rect.width / 2 + (m ? m[4] : 0);
        var y = rect.y + rect.height / 2 + (m ? m[5] : 0);
        xMin = Math.min(x, xMin);
        yMin = Math.min(y, yMin);
        xMax = Math.max(x, xMax);
        yMax = Math.max(y, yMax);
        return [
            x,
            y
        ];
    });
    var items = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(cps, function(cp, idx) {
        return {
            cp: cp,
            z: $2ef03ef3a2bb366a$var$hilbert(cp[0], cp[1], xMin, yMin, xMax, yMax),
            path: pathList[idx]
        };
    });
    return items.sort(function(a, b) {
        return a.z - b.z;
    }).map(function(item) {
        return item.path;
    });
}
function $2ef03ef3a2bb366a$var$defaultDividePath(param) {
    return (0, $640f8b532a910a4f$export$65980d18b75784e2)(param.path, param.count);
}
function $2ef03ef3a2bb366a$var$createEmptyReturn() {
    return {
        fromIndividuals: [],
        toIndividuals: [],
        count: 0
    };
}
function $2ef03ef3a2bb366a$export$57d3bac3565fd555(fromList, toPath, animationOpts) {
    var fromPathList = [];
    function addFromPath(fromList) {
        for(var i = 0; i < fromList.length; i++){
            var from = fromList[i];
            if ($2ef03ef3a2bb366a$export$f9f720a01590a46f(from)) addFromPath(from.childrenRef());
            else if (from instanceof (0, $b02ffe7acd508c08$export$2e2bcd8739ae039)) fromPathList.push(from);
        }
    }
    addFromPath(fromList);
    var separateCount = fromPathList.length;
    if (!separateCount) return $2ef03ef3a2bb366a$var$createEmptyReturn();
    var dividePath = animationOpts.dividePath || $2ef03ef3a2bb366a$var$defaultDividePath;
    var toSubPathList = dividePath({
        path: toPath,
        count: separateCount
    });
    if (toSubPathList.length !== separateCount) {
        console.error('Invalid morphing: unmatched splitted path');
        return $2ef03ef3a2bb366a$var$createEmptyReturn();
    }
    fromPathList = $2ef03ef3a2bb366a$var$sortPaths(fromPathList);
    toSubPathList = $2ef03ef3a2bb366a$var$sortPaths(toSubPathList);
    var oldDone = animationOpts.done;
    var oldDuring = animationOpts.during;
    var individualDelay = animationOpts.individualDelay;
    var identityTransform = new (0, $becf2d727f9cf450$export$2e2bcd8739ae039)();
    for(var i = 0; i < separateCount; i++){
        var from = fromPathList[i];
        var to = toSubPathList[i];
        to.parent = toPath;
        to.copyTransform(identityTransform);
        if (!individualDelay) $2ef03ef3a2bb366a$var$prepareMorphPath(from, to);
    }
    toPath.__isCombineMorphing = true;
    toPath.childrenRef = function() {
        return toSubPathList;
    };
    function addToSubPathListToZr(zr) {
        for(var i = 0; i < toSubPathList.length; i++)toSubPathList[i].addSelfToZr(zr);
    }
    $2ef03ef3a2bb366a$var$saveAndModifyMethod(toPath, 'addSelfToZr', {
        after: function(zr) {
            addToSubPathListToZr(zr);
        }
    });
    $2ef03ef3a2bb366a$var$saveAndModifyMethod(toPath, 'removeSelfFromZr', {
        after: function(zr) {
            for(var i = 0; i < toSubPathList.length; i++)toSubPathList[i].removeSelfFromZr(zr);
        }
    });
    function restoreToPath() {
        toPath.__isCombineMorphing = false;
        toPath.__morphT = -1;
        toPath.childrenRef = null;
        $2ef03ef3a2bb366a$var$restoreMethod(toPath, 'addSelfToZr');
        $2ef03ef3a2bb366a$var$restoreMethod(toPath, 'removeSelfFromZr');
    }
    var toLen = toSubPathList.length;
    if (individualDelay) {
        var animating_1 = toLen;
        var eachDone = function() {
            animating_1--;
            if (animating_1 === 0) {
                restoreToPath();
                oldDone && oldDone();
            }
        };
        for(var i = 0; i < toLen; i++){
            var indivdualAnimationOpts = individualDelay ? (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
                delay: (animationOpts.delay || 0) + individualDelay(i, toLen, fromPathList[i], toSubPathList[i]),
                done: eachDone
            }, animationOpts) : animationOpts;
            $2ef03ef3a2bb366a$export$7174e282c1c7df1c(fromPathList[i], toSubPathList[i], indivdualAnimationOpts);
        }
    } else {
        toPath.__morphT = 0;
        toPath.animateTo({
            __morphT: 1
        }, (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
            during: function(p) {
                for(var i = 0; i < toLen; i++){
                    var child = toSubPathList[i];
                    child.__morphT = toPath.__morphT;
                    child.dirtyShape();
                }
                oldDuring && oldDuring(p);
            },
            done: function() {
                restoreToPath();
                for(var i = 0; i < fromList.length; i++)$2ef03ef3a2bb366a$var$restoreMethod(fromList[i], 'updateTransform');
                oldDone && oldDone();
            }
        }, animationOpts));
    }
    if (toPath.__zr) addToSubPathListToZr(toPath.__zr);
    return {
        fromIndividuals: fromPathList,
        toIndividuals: toSubPathList,
        count: toLen
    };
}
function $2ef03ef3a2bb366a$export$b6ed198024fe6db8(fromPath, toPathList, animationOpts) {
    var toLen = toPathList.length;
    var fromPathList = [];
    var dividePath = animationOpts.dividePath || $2ef03ef3a2bb366a$var$defaultDividePath;
    function addFromPath(fromList) {
        for(var i = 0; i < fromList.length; i++){
            var from = fromList[i];
            if ($2ef03ef3a2bb366a$export$f9f720a01590a46f(from)) addFromPath(from.childrenRef());
            else if (from instanceof (0, $b02ffe7acd508c08$export$2e2bcd8739ae039)) fromPathList.push(from);
        }
    }
    if ($2ef03ef3a2bb366a$export$f9f720a01590a46f(fromPath)) {
        addFromPath(fromPath.childrenRef());
        var fromLen = fromPathList.length;
        if (fromLen < toLen) {
            var k = 0;
            for(var i = fromLen; i < toLen; i++)fromPathList.push((0, $15b38920672b9006$export$18711d956bf1c3eb)(fromPathList[k++ % fromLen]));
        }
        fromPathList.length = toLen;
    } else {
        fromPathList = dividePath({
            path: fromPath,
            count: toLen
        });
        var fromPathTransform = fromPath.getComputedTransform();
        for(var i = 0; i < fromPathList.length; i++)fromPathList[i].setLocalTransform(fromPathTransform);
        if (fromPathList.length !== toLen) {
            console.error('Invalid morphing: unmatched splitted path');
            return $2ef03ef3a2bb366a$var$createEmptyReturn();
        }
    }
    fromPathList = $2ef03ef3a2bb366a$var$sortPaths(fromPathList);
    toPathList = $2ef03ef3a2bb366a$var$sortPaths(toPathList);
    var individualDelay = animationOpts.individualDelay;
    for(var i = 0; i < toLen; i++){
        var indivdualAnimationOpts = individualDelay ? (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
            delay: (animationOpts.delay || 0) + individualDelay(i, toLen, fromPathList[i], toPathList[i])
        }, animationOpts) : animationOpts;
        $2ef03ef3a2bb366a$export$7174e282c1c7df1c(fromPathList[i], toPathList[i], indivdualAnimationOpts);
    }
    return {
        fromIndividuals: fromPathList,
        toIndividuals: toPathList,
        count: toPathList.length
    };
}






function $2a0c51260032b767$var$isMultiple(elements) {
    return (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(elements[0]);
}
function $2a0c51260032b767$var$prepareMorphBatches(one, many) {
    var batches = [];
    var batchCount = one.length;
    for(var i = 0; i < batchCount; i++)batches.push({
        one: one[i],
        many: []
    });
    for(var i = 0; i < many.length; i++){
        var len = many[i].length;
        var k = void 0;
        for(k = 0; k < len; k++)batches[k % batchCount].many.push(many[i][k]);
    }
    var off = 0;
    // If one has more paths than each one of many. average them.
    for(var i = batchCount - 1; i >= 0; i--)if (!batches[i].many.length) {
        var moveFrom = batches[off].many;
        if (moveFrom.length <= 1) {
            // Not enough
            // Start from the first one.
            if (off) off = 0;
            else return batches;
        }
        var len = moveFrom.length;
        var mid = Math.ceil(len / 2);
        batches[i].many = moveFrom.slice(mid, len);
        batches[off].many = moveFrom.slice(0, mid);
        off++;
    }
    return batches;
}
var $2a0c51260032b767$var$pathDividers = {
    clone: function(params) {
        var ret = [];
        // Fitting the alpha
        var approxOpacity = 1 - Math.pow(1 - params.path.style.opacity, 1 / params.count);
        for(var i = 0; i < params.count; i++){
            var cloned = (0, $15b38920672b9006$export$18711d956bf1c3eb)(params.path);
            cloned.setStyle('opacity', approxOpacity);
            ret.push(cloned);
        }
        return ret;
    },
    // Use the default divider
    split: null
};
function $2a0c51260032b767$export$c6ab3ab2bfe1ec39(from, to, divideShape, seriesModel, dataIndex, animateOtherProps) {
    if (!from.length || !to.length) return;
    var updateAnimationCfg = (0, $8b353638fbedfefa$export$5cc7add7ab591d0a)('update', seriesModel, dataIndex);
    if (!(updateAnimationCfg && updateAnimationCfg.duration > 0)) return;
    var animationDelay = seriesModel.getModel('universalTransition').get('delay');
    var animationCfg = Object.assign({
        // Need to setToFinal so the further calculation based on the style can be correct.
        // Like emphasis color.
        setToFinal: true
    }, updateAnimationCfg);
    var many;
    var one;
    if ($2a0c51260032b767$var$isMultiple(from)) {
        // manyToOne
        many = from;
        one = to;
    }
    if ($2a0c51260032b767$var$isMultiple(to)) {
        // oneToMany
        many = to;
        one = from;
    }
    function morphOneBatch(batch, fromIsMany, animateIndex, animateCount, forceManyOne) {
        var batchMany = batch.many;
        var batchOne = batch.one;
        if (batchMany.length === 1 && !forceManyOne) {
            // Is one to one
            var batchFrom = fromIsMany ? batchMany[0] : batchOne;
            var batchTo = fromIsMany ? batchOne : batchMany[0];
            if ((0, $2ef03ef3a2bb366a$export$f9f720a01590a46f)(batchFrom)) // Keep doing combine animation.
            morphOneBatch({
                many: [
                    batchFrom
                ],
                one: batchTo
            }, true, animateIndex, animateCount, true);
            else {
                var individualAnimationCfg = animationDelay ? (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
                    delay: animationDelay(animateIndex, animateCount)
                }, animationCfg) : animationCfg;
                (0, $2ef03ef3a2bb366a$export$7174e282c1c7df1c)(batchFrom, batchTo, individualAnimationCfg);
                animateOtherProps(batchFrom, batchTo, batchFrom, batchTo, individualAnimationCfg);
            }
        } else {
            var separateAnimationCfg = (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
                dividePath: $2a0c51260032b767$var$pathDividers[divideShape],
                individualDelay: animationDelay && function(idx, count, fromPath, toPath) {
                    return animationDelay(idx + animateIndex, animateCount);
                }
            }, animationCfg);
            var _a = fromIsMany ? (0, $2ef03ef3a2bb366a$export$57d3bac3565fd555)(batchMany, batchOne, separateAnimationCfg) : (0, $2ef03ef3a2bb366a$export$b6ed198024fe6db8)(batchOne, batchMany, separateAnimationCfg), fromIndividuals = _a.fromIndividuals, toIndividuals = _a.toIndividuals;
            var count = fromIndividuals.length;
            for(var k = 0; k < count; k++){
                var individualAnimationCfg = animationDelay ? (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
                    delay: animationDelay(k, count)
                }, animationCfg) : animationCfg;
                animateOtherProps(fromIndividuals[k], toIndividuals[k], fromIsMany ? batchMany[k] : batch.one, fromIsMany ? batch.one : batchMany[k], individualAnimationCfg);
            }
        }
    }
    var fromIsMany = many ? many === from : from.length > to.length;
    var morphBatches = many ? $2a0c51260032b767$var$prepareMorphBatches(one, many) : $2a0c51260032b767$var$prepareMorphBatches(fromIsMany ? to : from, [
        fromIsMany ? from : to
    ]);
    var animateCount = 0;
    for(var i = 0; i < morphBatches.length; i++)animateCount += morphBatches[i].many.length;
    var animateIndex = 0;
    for(var i = 0; i < morphBatches.length; i++){
        morphOneBatch(morphBatches[i], fromIsMany, animateIndex, animateCount);
        animateIndex += morphBatches[i].many.length;
    }
}
function $2a0c51260032b767$export$ad61593d7c3fa814(elements) {
    if (!elements) return [];
    if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(elements)) {
        var pathList_1 = [];
        for(var i = 0; i < elements.length; i++)pathList_1.push($2a0c51260032b767$export$ad61593d7c3fa814(elements[i]));
        return pathList_1;
    }
    var pathList = [];
    elements.traverse(function(el) {
        if (el instanceof (0, $b02ffe7acd508c08$export$2e2bcd8739ae039) && !el.disableMorphing && !el.invisible && !el.ignore) pathList.push(el);
    });
    return pathList;
}









var $2915cc4a2282c523$var$DATA_COUNT_THRESHOLD = 1e4;
var $2915cc4a2282c523$var$TRANSITION_NONE = 0;
var $2915cc4a2282c523$var$TRANSITION_P2C = 1;
var $2915cc4a2282c523$var$TRANSITION_C2P = 2;
var $2915cc4a2282c523$var$getUniversalTransitionGlobalStore = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $2915cc4a2282c523$var$getDimension(data, visualDimension) {
    var dimensions = data.dimensions;
    for(var i = 0; i < dimensions.length; i++){
        var dimInfo = data.getDimensionInfo(dimensions[i]);
        if (dimInfo && dimInfo.otherDims[visualDimension] === 0) return dimensions[i];
    }
}
// get value by dimension. (only get value of itemGroupId or childGroupId, so convert it to string)
function $2915cc4a2282c523$var$getValueByDimension(data, dataIndex, dimension) {
    var dimInfo = data.getDimensionInfo(dimension);
    var dimOrdinalMeta = dimInfo && dimInfo.ordinalMeta;
    if (dimInfo) {
        var value = data.get(dimInfo.name, dataIndex);
        if (dimOrdinalMeta) return dimOrdinalMeta.categories[value] || value + '';
        return value + '';
    }
}
function $2915cc4a2282c523$var$getGroupId(data, dataIndex, dataGroupId, isChild) {
    // try to get groupId from encode
    var visualDimension = isChild ? 'itemChildGroupId' : 'itemGroupId';
    var groupIdDim = $2915cc4a2282c523$var$getDimension(data, visualDimension);
    if (groupIdDim) {
        var groupId = $2915cc4a2282c523$var$getValueByDimension(data, dataIndex, groupIdDim);
        return groupId;
    }
    // try to get groupId from raw data item
    var rawDataItem = data.getRawDataItem(dataIndex);
    var property = isChild ? 'childGroupId' : 'groupId';
    if (rawDataItem && rawDataItem[property]) return rawDataItem[property] + '';
    // fallback
    if (isChild) return;
    // try to use series.dataGroupId as groupId, otherwise use dataItem's id as groupId
    return dataGroupId || data.getId(dataIndex);
}
// flatten all data items from different serieses into one arrary
function $2915cc4a2282c523$var$flattenDataDiffItems(list) {
    var items = [];
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(list, function(seriesInfo) {
        var data = seriesInfo.data;
        var dataGroupId = seriesInfo.dataGroupId;
        if (data.count() > $2915cc4a2282c523$var$DATA_COUNT_THRESHOLD) return;
        var indices = data.getIndices();
        for(var dataIndex = 0; dataIndex < indices.length; dataIndex++)items.push({
            data: data,
            groupId: $2915cc4a2282c523$var$getGroupId(data, dataIndex, dataGroupId, false),
            childGroupId: $2915cc4a2282c523$var$getGroupId(data, dataIndex, dataGroupId, true),
            divide: seriesInfo.divide,
            dataIndex: dataIndex
        });
    });
    return items;
}
function $2915cc4a2282c523$var$fadeInElement(newEl, newSeries, newIndex) {
    newEl.traverse(function(el) {
        if (el instanceof (0, $b02ffe7acd508c08$export$2e2bcd8739ae039)) // TODO use fade in animation for target element.
        (0, $8b353638fbedfefa$export$a121566aadcfe021)(el, {
            style: {
                opacity: 0
            }
        }, newSeries, {
            dataIndex: newIndex,
            isFrom: true
        });
    });
}
function $2915cc4a2282c523$var$removeEl(el) {
    if (el.parent) {
        // Bake parent transform to element.
        // So it can still have proper transform to transition after it's removed.
        var computedTransform = el.getComputedTransform();
        el.setLocalTransform(computedTransform);
        el.parent.remove(el);
    }
}
function $2915cc4a2282c523$var$stopAnimation(el) {
    el.stopAnimation();
    if (el.isGroup) el.traverse(function(child) {
        child.stopAnimation();
    });
}
function $2915cc4a2282c523$var$animateElementStyles(el, dataIndex, seriesModel) {
    var animationConfig = (0, $8b353638fbedfefa$export$5cc7add7ab591d0a)('update', seriesModel, dataIndex);
    animationConfig && el.traverse(function(child) {
        if (child instanceof (0, $56206a6cb4666931$export$2e2bcd8739ae039)) {
            var oldStyle = (0, $8b353638fbedfefa$export$ccb1f1e4d2fa86ac)(child);
            if (oldStyle) child.animateFrom({
                style: oldStyle
            }, animationConfig);
        }
    });
}
function $2915cc4a2282c523$var$isAllIdSame(oldDiffItems, newDiffItems) {
    var len = oldDiffItems.length;
    if (len !== newDiffItems.length) return false;
    for(var i = 0; i < len; i++){
        var oldItem = oldDiffItems[i];
        var newItem = newDiffItems[i];
        if (oldItem.data.getId(oldItem.dataIndex) !== newItem.data.getId(newItem.dataIndex)) return false;
    }
    return true;
}
function $2915cc4a2282c523$var$transitionBetween(oldList, newList, api) {
    var oldDiffItems = $2915cc4a2282c523$var$flattenDataDiffItems(oldList);
    var newDiffItems = $2915cc4a2282c523$var$flattenDataDiffItems(newList);
    function updateMorphingPathProps(from, to, rawFrom, rawTo, animationCfg) {
        if (rawFrom || from) to.animateFrom({
            style: rawFrom && rawFrom !== from ? (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, rawFrom.style), from.style) : from.style
        }, animationCfg);
    }
    var hasMorphAnimation = false;
    /**
   * With groupId and childGroupId, we can build parent-child relationships between dataItems.
   * However, we should mind the parent-child "direction" between old and new options.
   *
   * For example, suppose we have two dataItems from two series.data:
   *
   * dataA: [                          dataB: [
   *   {                                 {
   *     value: 5,                         value: 3,
   *     groupId: 'creatures',             groupId: 'animals',
   *     childGroupId: 'animals'           childGroupId: 'dogs'
   *   },                                },
   *   ...                               ...
   * ]                                 ]
   *
   * where dataA is belong to optionA and dataB is belong to optionB.
   *
   * When we `setOption(optionB)` from optionA, we choose childGroupId of dataItemA and groupId of
   * dataItemB as keys so the two keys are matched (both are 'animals'), then universalTransition
   * will work. This derection is "parent -> child".
   *
   * If we `setOption(optionA)` from optionB, we also choose groupId of dataItemB and childGroupId
   * of dataItemA as keys and universalTransition will work. This derection is "child -> parent".
   *
   * If there is no childGroupId specified, which means no multiLevelDrillDown/Up is needed and no
   * parent-child relationship exists. This direction is "none".
   *
   * So we need to know whether to use groupId or childGroupId as the key when we call the keyGetter
   * functions. Thus, we need to decide the direction first.
   *
   * The rule is:
   *
   * if (all childGroupIds in oldDiffItems and all groupIds in newDiffItems have common value) {
   *   direction = 'parent -> child';
   * } else if (all groupIds in oldDiffItems and all childGroupIds in newDiffItems have common value) {
   *   direction = 'child -> parent';
   * } else {
   *   direction = 'none';
   * }
   */ var direction = $2915cc4a2282c523$var$TRANSITION_NONE;
    // find all groupIds and childGroupIds from oldDiffItems
    var oldGroupIds = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    var oldChildGroupIds = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    oldDiffItems.forEach(function(item) {
        item.groupId && oldGroupIds.set(item.groupId, true);
        item.childGroupId && oldChildGroupIds.set(item.childGroupId, true);
    });
    // traverse newDiffItems and decide the direction according to the rule
    for(var i = 0; i < newDiffItems.length; i++){
        var newGroupId = newDiffItems[i].groupId;
        if (oldChildGroupIds.get(newGroupId)) {
            direction = $2915cc4a2282c523$var$TRANSITION_P2C;
            break;
        }
        var newChildGroupId = newDiffItems[i].childGroupId;
        if (newChildGroupId && oldGroupIds.get(newChildGroupId)) {
            direction = $2915cc4a2282c523$var$TRANSITION_C2P;
            break;
        }
    }
    function createKeyGetter(isOld, onlyGetId) {
        return function(diffItem) {
            var data = diffItem.data;
            var dataIndex = diffItem.dataIndex;
            // TODO if specified dim
            if (onlyGetId) return data.getId(dataIndex);
            if (isOld) return direction === $2915cc4a2282c523$var$TRANSITION_P2C ? diffItem.childGroupId : diffItem.groupId;
            else return direction === $2915cc4a2282c523$var$TRANSITION_C2P ? diffItem.childGroupId : diffItem.groupId;
        };
    }
    // Use id if it's very likely to be an one to one animation
    // It's more robust than groupId
    // TODO Check if key dimension is specified.
    var useId = $2915cc4a2282c523$var$isAllIdSame(oldDiffItems, newDiffItems);
    var isElementStillInChart = {};
    if (!useId) // We may have different diff strategy with basicTransition if we use other dimension as key.
    // If so, we can't simply check if oldEl is same with newEl. We need a map to check if oldEl is still being used in the new chart.
    // We can't use the elements that already being morphed. Let it keep it's original basic transition.
    for(var i = 0; i < newDiffItems.length; i++){
        var newItem = newDiffItems[i];
        var el = newItem.data.getItemGraphicEl(newItem.dataIndex);
        if (el) isElementStillInChart[el.id] = true;
    }
    function updateOneToOne(newIndex, oldIndex) {
        var oldItem = oldDiffItems[oldIndex];
        var newItem = newDiffItems[newIndex];
        var newSeries = newItem.data.hostModel;
        // TODO Mark this elements is morphed and don't morph them anymore
        var oldEl = oldItem.data.getItemGraphicEl(oldItem.dataIndex);
        var newEl = newItem.data.getItemGraphicEl(newItem.dataIndex);
        // Can't handle same elements.
        if (oldEl === newEl) {
            newEl && $2915cc4a2282c523$var$animateElementStyles(newEl, newItem.dataIndex, newSeries);
            return;
        }
        if (// We can't use the elements that already being morphed
        oldEl && isElementStillInChart[oldEl.id]) return;
        if (newEl) {
            // TODO: If keep animating the group in case
            // some of the elements don't want to be morphed.
            // TODO Label?
            $2915cc4a2282c523$var$stopAnimation(newEl);
            if (oldEl) {
                $2915cc4a2282c523$var$stopAnimation(oldEl);
                // If old element is doing leaving animation. stop it and remove it immediately.
                $2915cc4a2282c523$var$removeEl(oldEl);
                hasMorphAnimation = true;
                (0, $2a0c51260032b767$export$c6ab3ab2bfe1ec39)((0, $2a0c51260032b767$export$ad61593d7c3fa814)(oldEl), (0, $2a0c51260032b767$export$ad61593d7c3fa814)(newEl), newItem.divide, newSeries, newIndex, updateMorphingPathProps);
            } else $2915cc4a2282c523$var$fadeInElement(newEl, newSeries, newIndex);
        }
    // else keep oldEl leaving animation.
    }
    new (0, $306d1c87baff8a10$export$2e2bcd8739ae039)(oldDiffItems, newDiffItems, createKeyGetter(true, useId), createKeyGetter(false, useId), null, 'multiple').update(updateOneToOne).updateManyToOne(function(newIndex, oldIndices) {
        var newItem = newDiffItems[newIndex];
        var newData = newItem.data;
        var newSeries = newData.hostModel;
        var newEl = newData.getItemGraphicEl(newItem.dataIndex);
        var oldElsList = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)((0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(oldIndices, function(idx) {
            return oldDiffItems[idx].data.getItemGraphicEl(oldDiffItems[idx].dataIndex);
        }), function(oldEl) {
            return oldEl && oldEl !== newEl && !isElementStillInChart[oldEl.id];
        });
        if (newEl) {
            $2915cc4a2282c523$var$stopAnimation(newEl);
            if (oldElsList.length) {
                // If old element is doing leaving animation. stop it and remove it immediately.
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(oldElsList, function(oldEl) {
                    $2915cc4a2282c523$var$stopAnimation(oldEl);
                    $2915cc4a2282c523$var$removeEl(oldEl);
                });
                hasMorphAnimation = true;
                (0, $2a0c51260032b767$export$c6ab3ab2bfe1ec39)((0, $2a0c51260032b767$export$ad61593d7c3fa814)(oldElsList), (0, $2a0c51260032b767$export$ad61593d7c3fa814)(newEl), newItem.divide, newSeries, newIndex, updateMorphingPathProps);
            } else $2915cc4a2282c523$var$fadeInElement(newEl, newSeries, newItem.dataIndex);
        }
    // else keep oldEl leaving animation.
    }).updateOneToMany(function(newIndices, oldIndex) {
        var oldItem = oldDiffItems[oldIndex];
        var oldEl = oldItem.data.getItemGraphicEl(oldItem.dataIndex);
        // We can't use the elements that already being morphed
        if (oldEl && isElementStillInChart[oldEl.id]) return;
        var newElsList = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)((0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(newIndices, function(idx) {
            return newDiffItems[idx].data.getItemGraphicEl(newDiffItems[idx].dataIndex);
        }), function(el) {
            return el && el !== oldEl;
        });
        var newSeris = newDiffItems[newIndices[0]].data.hostModel;
        if (newElsList.length) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(newElsList, function(newEl) {
                return $2915cc4a2282c523$var$stopAnimation(newEl);
            });
            if (oldEl) {
                $2915cc4a2282c523$var$stopAnimation(oldEl);
                // If old element is doing leaving animation. stop it and remove it immediately.
                $2915cc4a2282c523$var$removeEl(oldEl);
                hasMorphAnimation = true;
                (0, $2a0c51260032b767$export$c6ab3ab2bfe1ec39)((0, $2a0c51260032b767$export$ad61593d7c3fa814)(oldEl), (0, $2a0c51260032b767$export$ad61593d7c3fa814)(newElsList), oldItem.divide, // Use divide on old.
                newSeris, newIndices[0], updateMorphingPathProps);
            } else (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(newElsList, function(newEl) {
                return $2915cc4a2282c523$var$fadeInElement(newEl, newSeris, newIndices[0]);
            });
        }
    // else keep oldEl leaving animation.
    }).updateManyToMany(function(newIndices, oldIndices) {
        // If two data are same and both have groupId.
        // Normally they should be diff by id.
        new (0, $306d1c87baff8a10$export$2e2bcd8739ae039)(oldIndices, newIndices, function(rawIdx) {
            return oldDiffItems[rawIdx].data.getId(oldDiffItems[rawIdx].dataIndex);
        }, function(rawIdx) {
            return newDiffItems[rawIdx].data.getId(newDiffItems[rawIdx].dataIndex);
        }).update(function(newIndex, oldIndex) {
            // Use the original index
            updateOneToOne(newIndices[newIndex], oldIndices[oldIndex]);
        }).execute();
    }).execute();
    if (hasMorphAnimation) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(newList, function(_a) {
        var data = _a.data;
        var seriesModel = data.hostModel;
        var view = seriesModel && api.getViewOfSeriesModel(seriesModel);
        var animationCfg = (0, $8b353638fbedfefa$export$5cc7add7ab591d0a)('update', seriesModel, 0); // use 0 index.
        if (view && seriesModel.isAnimationEnabled() && animationCfg && animationCfg.duration > 0) view.group.traverse(function(el) {
            if (el instanceof (0, $b02ffe7acd508c08$export$2e2bcd8739ae039) && !el.animators.length) // We can't accept there still exists element that has no animation
            // if universalTransition is enabled
            el.animateFrom({
                style: {
                    opacity: 0
                }
            }, animationCfg);
        });
    });
}
function $2915cc4a2282c523$var$getSeriesTransitionKey(series) {
    var seriesKey = series.getModel('universalTransition').get('seriesKey');
    if (!seriesKey) // Use series id by default.
    return series.id;
    return seriesKey;
}
function $2915cc4a2282c523$var$convertArraySeriesKeyToString(seriesKey) {
    if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(seriesKey)) // Order independent.
    return seriesKey.sort().join(',');
    return seriesKey;
}
function $2915cc4a2282c523$var$getDivideShapeFromData(data) {
    if (data.hostModel) return data.hostModel.getModel('universalTransition').get('divideShape');
}
function $2915cc4a2282c523$var$findTransitionSeriesBatches(globalStore, params) {
    var updateBatches = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    var oldDataMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    // Map that only store key in array seriesKey.
    // Which is used to query the old data when transition from one to multiple series.
    var oldDataMapForSplit = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(globalStore.oldSeries, function(series, idx) {
        var oldDataGroupId = globalStore.oldDataGroupIds[idx];
        var oldData = globalStore.oldData[idx];
        var transitionKey = $2915cc4a2282c523$var$getSeriesTransitionKey(series);
        var transitionKeyStr = $2915cc4a2282c523$var$convertArraySeriesKeyToString(transitionKey);
        oldDataMap.set(transitionKeyStr, {
            dataGroupId: oldDataGroupId,
            data: oldData
        });
        if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(transitionKey)) // Same key can't in different array seriesKey.
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(transitionKey, function(key) {
            oldDataMapForSplit.set(key, {
                key: transitionKeyStr,
                dataGroupId: oldDataGroupId,
                data: oldData
            });
        });
    });
    function checkTransitionSeriesKeyDuplicated(transitionKeyStr) {
        if (updateBatches.get(transitionKeyStr)) (0, $84bc7667c27ccedc$export$c106dd0671a0fc2d)("Duplicated seriesKey in universalTransition " + transitionKeyStr);
    }
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(params.updatedSeries, function(series) {
        if (series.isUniversalTransitionEnabled() && series.isAnimationEnabled()) {
            var newDataGroupId = series.get('dataGroupId');
            var newData = series.getData();
            var transitionKey = $2915cc4a2282c523$var$getSeriesTransitionKey(series);
            var transitionKeyStr = $2915cc4a2282c523$var$convertArraySeriesKeyToString(transitionKey);
            // Only transition between series with same id.
            var oldData = oldDataMap.get(transitionKeyStr);
            // string transition key is the best match.
            if (oldData) // TODO check if data is same?
            updateBatches.set(transitionKeyStr, {
                oldSeries: [
                    {
                        dataGroupId: oldData.dataGroupId,
                        divide: $2915cc4a2282c523$var$getDivideShapeFromData(oldData.data),
                        data: oldData.data
                    }
                ],
                newSeries: [
                    {
                        dataGroupId: newDataGroupId,
                        divide: $2915cc4a2282c523$var$getDivideShapeFromData(newData),
                        data: newData
                    }
                ]
            });
            else // Transition from multiple series.
            // e.g. 'female', 'male' -> ['female', 'male']
            if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(transitionKey)) {
                var oldSeries_1 = [];
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(transitionKey, function(key) {
                    var oldData = oldDataMap.get(key);
                    if (oldData.data) oldSeries_1.push({
                        dataGroupId: oldData.dataGroupId,
                        divide: $2915cc4a2282c523$var$getDivideShapeFromData(oldData.data),
                        data: oldData.data
                    });
                });
                if (oldSeries_1.length) updateBatches.set(transitionKeyStr, {
                    oldSeries: oldSeries_1,
                    newSeries: [
                        {
                            dataGroupId: newDataGroupId,
                            data: newData,
                            divide: $2915cc4a2282c523$var$getDivideShapeFromData(newData)
                        }
                    ]
                });
            } else {
                // Try transition to multiple series.
                // e.g. ['female', 'male'] -> 'female', 'male'
                var oldData_1 = oldDataMapForSplit.get(transitionKey);
                if (oldData_1) {
                    var batch = updateBatches.get(oldData_1.key);
                    if (!batch) {
                        batch = {
                            oldSeries: [
                                {
                                    dataGroupId: oldData_1.dataGroupId,
                                    data: oldData_1.data,
                                    divide: $2915cc4a2282c523$var$getDivideShapeFromData(oldData_1.data)
                                }
                            ],
                            newSeries: []
                        };
                        updateBatches.set(oldData_1.key, batch);
                    }
                    batch.newSeries.push({
                        dataGroupId: newDataGroupId,
                        data: newData,
                        divide: $2915cc4a2282c523$var$getDivideShapeFromData(newData)
                    });
                }
            }
        }
    });
    return updateBatches;
}
function $2915cc4a2282c523$var$querySeries(series, finder) {
    for(var i = 0; i < series.length; i++){
        var found = finder.seriesIndex != null && finder.seriesIndex === series[i].seriesIndex || finder.seriesId != null && finder.seriesId === series[i].id;
        if (found) return i;
    }
}
function $2915cc4a2282c523$var$transitionSeriesFromOpt(transitionOpt, globalStore, params, api) {
    var from = [];
    var to = [];
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $76d619f648247e6d$export$4f07b212a02c8051)(transitionOpt.from), function(finder) {
        var idx = $2915cc4a2282c523$var$querySeries(globalStore.oldSeries, finder);
        if (idx >= 0) from.push({
            dataGroupId: globalStore.oldDataGroupIds[idx],
            data: globalStore.oldData[idx],
            // TODO can specify divideShape in transition.
            divide: $2915cc4a2282c523$var$getDivideShapeFromData(globalStore.oldData[idx]),
            groupIdDim: finder.dimension
        });
    });
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $76d619f648247e6d$export$4f07b212a02c8051)(transitionOpt.to), function(finder) {
        var idx = $2915cc4a2282c523$var$querySeries(params.updatedSeries, finder);
        if (idx >= 0) {
            var data = params.updatedSeries[idx].getData();
            to.push({
                dataGroupId: globalStore.oldDataGroupIds[idx],
                data: data,
                divide: $2915cc4a2282c523$var$getDivideShapeFromData(data),
                groupIdDim: finder.dimension
            });
        }
    });
    if (from.length > 0 && to.length > 0) $2915cc4a2282c523$var$transitionBetween(from, to, api);
}
function $2915cc4a2282c523$export$efd07f28fd73e88c(registers) {
    registers.registerUpdateLifecycle('series:beforeupdate', function(ecMOdel, api, params) {
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $76d619f648247e6d$export$4f07b212a02c8051)(params.seriesTransition), function(transOpt) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $76d619f648247e6d$export$4f07b212a02c8051)(transOpt.to), function(finder) {
                var series = params.updatedSeries;
                for(var i = 0; i < series.length; i++)if (finder.seriesIndex != null && finder.seriesIndex === series[i].seriesIndex || finder.seriesId != null && finder.seriesId === series[i].id) series[i][0, $7c10febb2cdef0d8$export$e960441116ae2799] = true;
            });
        });
    });
    registers.registerUpdateLifecycle('series:transition', function(ecModel, api, params) {
        // TODO api provide an namespace that can save stuff per instance
        var globalStore = $2915cc4a2282c523$var$getUniversalTransitionGlobalStore(api);
        // TODO multiple to multiple series.
        if (globalStore.oldSeries && params.updatedSeries && params.optionChanged) {
            // TODO transitionOpt was used in an old implementation and can be removed now
            // Use give transition config if its' give;
            var transitionOpt = params.seriesTransition;
            if (transitionOpt) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $76d619f648247e6d$export$4f07b212a02c8051)(transitionOpt), function(opt) {
                $2915cc4a2282c523$var$transitionSeriesFromOpt(opt, globalStore, params, api);
            });
            else {
                // Else guess from series based on transition series key.
                var updateBatches_1 = $2915cc4a2282c523$var$findTransitionSeriesBatches(globalStore, params);
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(updateBatches_1.keys(), function(key) {
                    var batch = updateBatches_1.get(key);
                    $2915cc4a2282c523$var$transitionBetween(batch.oldSeries, batch.newSeries, api);
                });
            }
            // Reset
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(params.updatedSeries, function(series) {
                // Reset;
                if (series[0, $7c10febb2cdef0d8$export$e960441116ae2799]) series[0, $7c10febb2cdef0d8$export$e960441116ae2799] = false;
            });
        }
        // Save all series of current update. Not only the updated one.
        var allSeries = ecModel.getSeries();
        var savedSeries = globalStore.oldSeries = [];
        var savedDataGroupIds = globalStore.oldDataGroupIds = [];
        var savedData = globalStore.oldData = [];
        for(var i = 0; i < allSeries.length; i++){
            var data = allSeries[i].getData();
            // Only save the data that can have transition.
            // Avoid large data costing too much extra memory
            if (data.count() < $2915cc4a2282c523$var$DATA_COUNT_THRESHOLD) {
                savedSeries.push(allSeries[i]);
                savedDataGroupIds.push(allSeries[i].get('dataGroupId'));
                savedData.push(data);
            }
        }
    });
}


// -----------------
// Render engines
// -----------------
// Render via Canvas.
// echarts.init(dom, null, { renderer: 'canvas' })
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)([
    (0, $e792bf2f67d76098$export$4b3e715f166fdd78)
]);
// Render via SVG.
// echarts.init(dom, null, { renderer: 'svg' })
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)([
    (0, $8d8c6eb926bbdd0e$export$4b3e715f166fdd78)
]);
// ----------------
// Charts (series)
// ----------------
// All of the series types, for example:
// chart.setOption({
//     series: [{
//         type: 'line' // or 'bar', 'pie', ...
//     }]
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)([
    (0, $9c1bfdc9a4f78f2d$export$4b3e715f166fdd78),
    (0, $4bb56d1f08552ff4$export$4b3e715f166fdd78),
    (0, $6b7ead9b40180cba$export$4b3e715f166fdd78),
    (0, $1214e5d7a4a6f990$export$4b3e715f166fdd78),
    (0, $a8120efef8bcaaa0$export$4b3e715f166fdd78),
    (0, $6c94070aa7d5e098$export$4b3e715f166fdd78),
    (0, $44a5d4d260c7de78$export$4b3e715f166fdd78),
    (0, $330b7dc841112eff$export$4b3e715f166fdd78),
    (0, $b48bd73bf5d69641$export$4b3e715f166fdd78),
    (0, $bf7cb565bb1d2308$export$4b3e715f166fdd78),
    (0, $2bdc3734cdc2f6c8$export$4b3e715f166fdd78),
    (0, $4d1dc874f9d8653d$export$4b3e715f166fdd78),
    (0, $2439b31c49c21b38$export$4b3e715f166fdd78),
    (0, $0fd6296850ce3099$export$4b3e715f166fdd78),
    (0, $21999577dfdc5807$export$4b3e715f166fdd78),
    (0, $a0fd335cdafe9e6e$export$4b3e715f166fdd78),
    (0, $52dd2448928cc7d8$export$4b3e715f166fdd78),
    (0, $c53e84d38e53ec61$export$4b3e715f166fdd78),
    (0, $7e25595b74be81a3$export$4b3e715f166fdd78),
    (0, $e883cd02390b2e6d$export$4b3e715f166fdd78),
    (0, $b7341ef122ec790d$export$4b3e715f166fdd78),
    (0, $3fd02cf8c6a1578a$export$4b3e715f166fdd78)
]);
// -------------------
// Coordinate systems
// -------------------
// All of the axis modules have been included in the
// coordinate system module below, do not need to
// make extra import.
// `cartesian` coordinate system. For some historical
// reasons, it is named as grid, for example:
// chart.setOption({
//     grid: {...},
//     xAxis: {...},
//     yAxis: {...},
//     series: [{...}]
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $30909b2e837c2175$export$4b3e715f166fdd78));
// `polar` coordinate system, for example:
// chart.setOption({
//     polar: {...},
//     radiusAxis: {...},
//     angleAxis: {...},
//     series: [{
//         coordinateSystem: 'polar'
//     }]
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $0a6536a72e92ce0b$export$4b3e715f166fdd78));
// `geo` coordinate system, for example:
// chart.setOption({
//     geo: {...},
//     series: [{
//         coordinateSystem: 'geo'
//     }]
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $8082b8b129488d44$export$4b3e715f166fdd78));
// `singleAxis` coordinate system (notice, it is a coordinate system
// with only one axis, work for chart like theme river), for example:
// chart.setOption({
//     singleAxis: {...}
//     series: [{type: 'themeRiver', ...}]
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $2e3198006a202a14$export$4b3e715f166fdd78));
// `parallel` coordinate system, only work for parallel series, for example:
// chart.setOption({
//     parallel: {...},
//     parallelAxis: [{...}, ...],
//     series: [{
//         type: 'parallel'
//     }]
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $462857bad733a944$export$4b3e715f166fdd78));
// `calendar` coordinate system. for example,
// chart.setOption({
//     calendar: {...},
//     series: [{
//         coordinateSystem: 'calendar'
//     }]
// );
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $c1c3b68ff9dcc3e7$export$4b3e715f166fdd78));
// ------------------
// Other components
// ------------------
// `graphic` component, for example:
// chart.setOption({
//     graphic: {...}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $48174658d54922b7$export$4b3e715f166fdd78));
// `toolbox` component, for example:
// chart.setOption({
//     toolbox: {...}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $db487da8ce0e4ca6$export$4b3e715f166fdd78));
// `tooltip` component, for example:
// chart.setOption({
//     tooltip: {...}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $46e639bec576c55c$export$4b3e715f166fdd78));
// `axisPointer` component, for example:
// chart.setOption({
//     tooltip: {axisPointer: {...}, ...}
// });
// Or
// chart.setOption({
//     axisPointer: {...}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $589507869c21caa1$export$4b3e715f166fdd78));
// `brush` component, for example:
// chart.setOption({
//     brush: {...}
// });
// Or
// chart.setOption({
//     tooltip: {feature: {brush: {...}}
// })
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $e97a928e0b93a54f$export$4b3e715f166fdd78));
// `title` component, for example:
// chart.setOption({
//     title: {...}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $66707465bee49836$export$4b3e715f166fdd78));
// `timeline` component, for example:
// chart.setOption({
//     timeline: {...}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $d41f79c5664eb934$export$4b3e715f166fdd78));
// `markPoint` component, for example:
// chart.setOption({
//     series: [{markPoint: {...}}]
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $4edaa7c972a7e0d1$export$4b3e715f166fdd78));
// `markLine` component, for example:
// chart.setOption({
//     series: [{markLine: {...}}]
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $0fc27d0a088604ed$export$4b3e715f166fdd78));
// `markArea` component, for example:
// chart.setOption({
//     series: [{markArea: {...}}]
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $8a8e80722bf1c081$export$4b3e715f166fdd78));
// `legend` component not scrollable. for example:
// chart.setOption({
//     legend: {...}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $1a0761510a437d9f$export$4b3e715f166fdd78));
// `dataZoom` component including both `dataZoomInside` and `dataZoomSlider`.
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $aa2dc70f9fa9453b$export$4b3e715f166fdd78));
// `dataZoom` component providing drag, pinch, wheel behaviors
// inside coordinate system, for example:
// chart.setOption({
//     dataZoom: {type: 'inside'}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $b5ee445cd897e37a$export$4b3e715f166fdd78));
// `dataZoom` component providing a slider bar, for example:
// chart.setOption({
//     dataZoom: {type: 'slider'}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $794c23331e97718e$export$4b3e715f166fdd78));
// `visualMap` component including both `visualMapContinuous` and `visualMapPiecewise`.
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $1df0d53aa7db8747$export$4b3e715f166fdd78));
// `visualMap` component providing continuous bar, for example:
// chart.setOption({
//     visualMap: {type: 'continuous'}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $a0f8a196dd8b4cba$export$4b3e715f166fdd78));
// `visualMap` component providing pieces bar, for example:
// chart.setOption({
//     visualMap: {type: 'piecewise'}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $312d2d640a7c60e1$export$4b3e715f166fdd78));
// `aria` component providing aria, for example:
// chart.setOption({
//     aria: {...}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $772c09ed30d27c33$export$4b3e715f166fdd78));
// dataset transform
// chart.setOption({
//     dataset: {
//          transform: []
//     }
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $d6bad095dfa9594d$export$4b3e715f166fdd78));
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $afb70cea6fec4fe0$export$4b3e715f166fdd78));
// universal transition
// chart.setOption({
//     series: {
//         universalTransition: { enabled: true }
//     }
// })
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $2915cc4a2282c523$export$efd07f28fd73e88c));
// label layout
// chart.setOption({
//     series: {
//         labelLayout: { hideOverlap: true }
//     }
// })
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $de19ea5da3bb8f56$export$5320d1b3745c02a5));



// Array of years to plot time series
const $a8303d5548eab261$var$years = [
    1851,
    1852,
    1853,
    1854,
    1855,
    1856,
    1857,
    1858,
    1859,
    1860,
    1861,
    1862,
    1863,
    1864,
    1865,
    1866,
    1867,
    1868,
    1869,
    1870,
    1871,
    1872,
    1873,
    1874,
    1875,
    1876,
    1877,
    1878,
    1879,
    1880,
    1881,
    1882,
    1883,
    1884,
    1885,
    1886,
    1887,
    1888,
    1889,
    1890,
    1891,
    1892,
    1893,
    1894,
    1895,
    1896,
    1897,
    1898,
    1899,
    1900,
    1901,
    1902,
    1903,
    1904,
    1905,
    1906,
    1907,
    1908,
    1909,
    1910,
    1911,
    1912,
    1913,
    1914,
    1915,
    1916,
    1917,
    1918,
    1919,
    1920,
    1921,
    1922,
    1923,
    1924,
    1925,
    1926,
    1927,
    1928,
    1929,
    1930,
    1931,
    1932,
    1933,
    1934,
    1935,
    1936,
    1937,
    1938,
    1939,
    1940,
    1941,
    1942,
    1943,
    1944,
    1945,
    1946,
    1947,
    1948,
    1949,
    1950,
    1951,
    1952,
    1953,
    1954,
    1955,
    1956,
    1957,
    1958,
    1959,
    1960,
    1961,
    1962,
    1963,
    1964,
    1965,
    1966,
    1967,
    1968,
    1969,
    1970,
    1971,
    1972,
    1973,
    1974,
    1975,
    1976,
    1977,
    1978,
    1979,
    1980,
    1981,
    1982,
    1983,
    1984,
    1985,
    1986,
    1987,
    1988,
    1989,
    1990,
    1991,
    1992,
    1993,
    1994,
    1995,
    1996,
    1997,
    1998,
    1999,
    2000,
    2001,
    2002,
    2003,
    2004,
    2005,
    2006,
    2007,
    2008,
    2009,
    2010,
    2011,
    2012,
    2013,
    2014,
    2015,
    2016,
    2017,
    2018,
    2019,
    2020,
    2021,
    2022
];
function $a8303d5548eab261$export$94998eaeecec5e7b(data, variable, scale, colPalette, ID) {
    // Select element from DOM
    const plotElement = document.getElementById(ID);
    // Initiate echarts instance locally (no global variable)
    const echartsPlot = $4d59907f44a2d0ad$export$2cd8252107eb640b(plotElement, null, {
        renderer: "svg"
    });
    // Get the correct colour using function
    const colour = (0, $24badfeb4d36b999$export$13746b04065d45d9)(data[variable], scale, colPalette);
    // Determine the maximum value from your data
    const maxValue = Math.max(...data[`${variable}_timeseries`]);
    // Specify the configuration items and data for the chart
    const option = {
        // title: {
        //   text: "GMST contribution",
        //   textStyle: {
        //     fontSize: 12,
        //   },
        // },
        // Global text style
        textStyle: {
            fontFamily: "Work Sans, Arial, sans-serif"
        },
        xAxis: {
            type: "category",
            data: $a8303d5548eab261$var$years,
            axisLabel: {
                interval: 170
            },
            axisTick: {
                interval: 170,
                alignWithLabel: true
            }
        },
        yAxis: {
            name: "Contribution to GMST",
            nameTextStyle: {
                fontSize: 12,
                align: "left"
            },
            type: "value",
            axisLabel: {
                show: false
            },
            minInterval: maxValue / 2,
            max: maxValue
        },
        color: colour,
        series: [
            {
                data: data[`${variable}_timeseries`],
                type: "line",
                silent: true,
                showSymbol: true,
                symbol: "circle",
                symbolSize: 8,
                cursor: "default",
                label: {
                    show: true,
                    position: "top",
                    // formatter: `{c}°C`, // Format to show the value
                    formatter: (params)=>{
                        if (params.dataIndex === 0) return "";
                        else return `${Number(params.value).toPrecision(2)}\xb0C`;
                    }
                }
            }
        ],
        grid: {
            top: "25%",
            bottom: "20%",
            left: "5%"
        },
        tooltip: {
            show: false
        }
    };
    // Display the chart using the configuration options
    echartsPlot.setOption(option, true);
}


const $b9f6d098b860a8ad$var$geojsonObj = {
    1851: (0, $202d9c9f4997d984$export$ec896fb550a5e0a)
};



// console.log(gmst1851);
// Function to dynamically load additional data after initial load
function $b9f6d098b860a8ad$var$loadAdditionalData() {
    Promise.all([
        (parcelRequire("ayUSI")),
        (parcelRequire("8gngE")),
        (parcelRequire("eRNLR"))
    ]).then(([module2, module3, module4])=>{
        // 1990
        const gmst1990 = module2.gmst1990;
        $b9f6d098b860a8ad$var$geojsonObj["1990"] = gmst1990;
        // 2005
        const gmst2005 = module3.gmst2005;
        $b9f6d098b860a8ad$var$geojsonObj["2005"] = gmst2005;
        // 2020
        const gmst2020 = module4.gmst2020;
        $b9f6d098b860a8ad$var$geojsonObj["2020"] = gmst2020;
    }).catch((error)=>{
        console.error("Error loading additional data:", error);
    });
}
// Load additional data after initial load
window.addEventListener("load", ()=>{
    $b9f6d098b860a8ad$var$loadAdditionalData();
});
// Get selector elements from DOM
const $b9f6d098b860a8ad$var$sourceSelector = document.getElementById("source-selector");
const $b9f6d098b860a8ad$var$gasSelector = document.getElementById("gas-selector");
const $b9f6d098b860a8ad$var$periodSelector = document.getElementById("period-selector");
// Array of EU27 countries
const $b9f6d098b860a8ad$var$EU27 = [
    "Austria",
    "Belgium",
    "Bulgaria",
    "Cyprus",
    "Czechia",
    "Germany",
    "Denmark",
    "Spain",
    "Estonia",
    "Finland",
    "France",
    "Greece",
    "Croatia",
    "Hungary",
    "Ireland",
    "Italy",
    "Lithuania",
    "Luxembourg",
    "Latvia",
    "Malta",
    "Netherlands",
    "Poland",
    "Portugal",
    "Romania",
    "Slovakia",
    "Slovenia",
    "Sweden"
];
// Function to deep clone an object or array
const $b9f6d098b860a8ad$var$deepClone = function(variable) {
    return JSON.parse(JSON.stringify(variable));
};
// ------------------- //
// Get Active Selectors Functions
// ------------------- //
// Function to return data for the current selected time period
const $b9f6d098b860a8ad$var$returnSelectedPeriodData = function(year = null) {
    // Get year selected by user (or input into function)
    const period = year === null ? $b9f6d098b860a8ad$var$periodSelector.value : year;
    // Extract data for period selected
    const data = $b9f6d098b860a8ad$var$deepClone($b9f6d098b860a8ad$var$geojsonObj[period]);
    // Get checked status of EU switch
    const isChecked = document.getElementById("eu-switch").checked;
    // If checked, add single EU27 polygon
    if (isChecked) {
        // Find and remove all EU countries from current data
        for(let i = 0; i < $b9f6d098b860a8ad$var$EU27.length; i++){
            const country = $b9f6d098b860a8ad$var$EU27[i];
            const idx = data.features.map((feature)=>feature.properties.Country).indexOf(country);
            if (idx !== -1) data.features.splice(idx, 1);
        }
        // Return data
        return data;
    }
    // If NOT checked, remove single EU polygon and add EU27 countries as separate polygons
    if (!isChecked) {
        // Index position of EU27 polygon
        const indexEU27 = data.features.map((i)=>i.properties.Country).indexOf("EU27");
        // Remove EU27 element at array position indexEU27
        if (indexEU27 !== -1) data.features.splice(indexEU27, 1);
        // Return data
        return data;
    }
};
// Function to find the active selectors for displaying correct gmst values
const $b9f6d098b860a8ad$var$activeSelectors = function() {
    const source = $b9f6d098b860a8ad$var$sourceSelector.value;
    const gas = $b9f6d098b860a8ad$var$gasSelector.value;
    return `${source}_${gas}`; // Return string in the format Total_3GHG, Fossil_CO2, etc.
};
// Define the Robinson projection using Proj4
const $b9f6d098b860a8ad$var$robinsonProj = "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +ellps=WGS84 +datum=WGS84 +units=m +no_defs";
// Define a custom CRS for Robinson
const $b9f6d098b860a8ad$var$robinsonCRS = new (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).Proj.CRS("EPSG:54030", $b9f6d098b860a8ad$var$robinsonProj, {
    origin: [
        -20037508.342789244,
        20037508.342789244
    ],
    // define zoom level array
    resolutions: [
        // 156543.033928041,
        // 110407.27494603075,
        // 78271.5169640205,
        55271.63772301539,
        39135.75848201024,
        27613.818861507695,
        19567.87924100512,
        13875.859050753847,
        9783.93962050256,
        6891.954715377821,
        4891.96981025128,
        3468.9773576889106,
        1734.4886788444553,
        867.2443394222277,
        433.6221697111138
    ]
});
// Initialize the map
const $b9f6d098b860a8ad$var$map = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).map("map", {
    // crs: L.CRS.Simple,
    crs: $b9f6d098b860a8ad$var$robinsonCRS,
    center: [
        0,
        0
    ],
    zoom: 1,
    maxZoom: 11,
    closeTooltipOnClick: false
});
// Set map boundary [ymin, xmin, ymax, xmax]
// map.fitBounds([[-45, -130], [75, 130]]);
// Add no tiles to map
(0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).tileLayer("").addTo($b9f6d098b860a8ad$var$map);
// ------------------- //
// Add Reset Map button
// ------------------- //
// Add a custom control button to the top-left corner of the map
const $b9f6d098b860a8ad$var$resetView = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).Control.extend({
    options: {
        position: "topleft"
    },
    onAdd: function() {
        const divContainer = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create("div", "leaflet-control leaflet-bar");
        divContainer.setAttribute("id", "btn-reset-view");
        divContainer.setAttribute("style", "cursor: pointer;");
        divContainer.insertAdjacentHTML("afterbegin", `
        <a title="Reset view">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-arrow-repeat" viewBox="0 0 16 16">
            <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z"/>
            <path fill-rule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z"/>
          </svg>
        </a>
      
      `);
        document.getElementById("map").style.outlineStyle = "none";
        return divContainer;
    }
});
$b9f6d098b860a8ad$var$map.addControl(new $b9f6d098b860a8ad$var$resetView());
// Reset view to default view when button is clicked
document.getElementById("btn-reset-view").addEventListener("click", ()=>{
    // map.fitBounds([[-45, -130], [75, 130]]);
    $b9f6d098b860a8ad$var$map.setView([
        0,
        0
    ], 1);
});
// Add scalebar to the bottom-left corner of the map
// L.control.scale({imperial: false}).addTo(map);
// ------------------- //
// Add Save Image Button
// ------------------- //
// Add a custom control button to the top-left corner of the map
const $b9f6d098b860a8ad$var$saveImageIcon = `
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-image" viewBox="0 0 16 16">
    <path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"/>
    <path d="M2.002 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm12 1a1 1 0 0 1 1 1v6.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12V3a1 1 0 0 1 1-1z"/>
  </svg>`;
const $b9f6d098b860a8ad$var$saveImage = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).Control.extend({
    options: {
        position: "topleft"
    },
    onAdd: function() {
        const divContainer = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create("div", "leaflet-control leaflet-bar");
        divContainer.setAttribute("id", "btn-save-image");
        divContainer.setAttribute("style", "cursor: pointer;");
        divContainer.insertAdjacentHTML("afterbegin", `
      <a title="Download screenshot">
        ${$b9f6d098b860a8ad$var$saveImageIcon}
      </a>
    `);
        document.getElementById("map").style.outlineStyle = "none";
        return divContainer;
    }
});
$b9f6d098b860a8ad$var$map.addControl(new $b9f6d098b860a8ad$var$saveImage());
// Inititate screenshot on map with the default button hidden
const $b9f6d098b860a8ad$var$simpleMapScreenshoter = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).simpleMapScreenshoter({
    hidden: true,
    hideElementsWithSelectors: [
        ".leaflet-control-zoom",
        "#btn-reset-view",
        "#btn-info-modal",
        "#eu-toggle"
    ]
}).addTo($b9f6d098b860a8ad$var$map);
// Remove screenshoter logo entirely from DOM
document.querySelector(".leaflet-control-simpleMapScreenshoter").remove();
// Download an image when save-image button is clicked
document.getElementById("btn-save-image").addEventListener("click", ()=>{
    // first hide the btn-save-image
    document.querySelector("#btn-save-image").style.display = "none";
    // second change the display hover text in the display info element to none
    const displayInfoSpan = document.querySelector("#display-info-widget > span");
    if (displayInfoSpan) displayInfoSpan.textContent = $b9f6d098b860a8ad$var$choices3.getValue().label;
    // add temporary title
    const tempTitle = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).control({
        position: "topleft"
    });
    tempTitle.onAdd = function(map) {
        this._div = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create("div", "displayInfo"); // create div with class "displayInfo"
        this._div.setAttribute("id", "temp-title");
        this._div.innerHTML = `<h3 style="margin-bottom:0; font-size: 1.5em;">National Contributions to Global Warming</h3>`;
        this._div.style.position = "absolute";
        this._div.style.top = "1px"; // Distance from top of the map container
        this._div.style.left = "1px"; // Distance from left of the map container
        this._div.style.width = "max-content";
        return this._div;
    };
    tempTitle.addTo($b9f6d098b860a8ad$var$map);
    // take screenshot
    $b9f6d098b860a8ad$var$simpleMapScreenshoter.takeScreen("blob", {
    }).then((blob)=>{
        saveAs(blob, "National-Contributions-UEA-Map.png");
        // last unhide the btn-save-image
        document.querySelector("#btn-save-image").style.display = "block";
        // default text back on display info widget
        if (displayInfoSpan) displayInfoSpan.textContent = "Hover over a polygon";
        // remove temp title
        tempTitle.remove();
    }).catch((e)=>{
        console.error(e.toString());
    });
});
// ------------------- //
// Add Information Modal Button
// ------------------- //
// Add a custom control button to the top-left corner of the map
const $b9f6d098b860a8ad$var$infoModal = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).Control.extend({
    options: {
        position: "topleft"
    },
    onAdd: function() {
        const divContainer = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create("div", "leaflet-control leaflet-bar");
        divContainer.setAttribute("id", "btn-info-modal");
        divContainer.setAttribute("style", "cursor: pointer;");
        divContainer.insertAdjacentHTML("afterbegin", `
      <a title="More information">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-info" viewBox="0 0 16 16">
          <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
        </svg>
      </a>
    `);
        // Add event listener to show the modal
        divContainer.addEventListener("click", ()=>{
            const infoModal = new (0, $e9dd36436aec3b21$export$2b77a92f1a5ad772)(document.getElementById("infoModal"));
            infoModal.show();
        });
        document.getElementById("map").style.outlineStyle = "none";
        return divContainer;
    }
});
$b9f6d098b860a8ad$var$map.addControl(new $b9f6d098b860a8ad$var$infoModal());
// Add a custom control to display the region and value on the top-right of the map
const $b9f6d098b860a8ad$var$displayInfo = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).control();
// Function when element is added to map
$b9f6d098b860a8ad$var$displayInfo.onAdd = function(map) {
    this._div = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create("div", "displayInfo"); // create div with class "displayInfo"
    this._div.setAttribute("id", "display-info-widget");
    this.update();
    return this._div;
};
// Function when user hovers over polygons
$b9f6d098b860a8ad$var$displayInfo.update = function(property) {
    const activeVariables = $b9f6d098b860a8ad$var$activeSelectors();
    const sourceText = $b9f6d098b860a8ad$var$sourceSelector.options[$b9f6d098b860a8ad$var$sourceSelector.selectedIndex].textContent;
    const gasText = $b9f6d098b860a8ad$var$gasSelector.options[$b9f6d098b860a8ad$var$sourceSelector.selectedIndex].textContent;
    // const activeSource = activeVariables.split("_")[0];
    // const activeGas = activeVariables.split("_")[1];
    if (property) this._div.innerHTML = `
      <h4>${sourceText}</br>${gasText}</h4>
      <b>${property.Country}: ${property[activeVariables] !== null ? (0, $24badfeb4d36b999$export$ef5a49dd25f32dd3)(property[activeVariables]) : "No Data"}</b>
      <b>${property[activeVariables] !== null ? "%" : ""}</b>`;
    else this._div.innerHTML = `
      <h4>${sourceText}</br>${gasText}</h4>
      <span>Hover over a polygon</span>`;
};
// Add display widget to map
$b9f6d098b860a8ad$var$displayInfo.addTo($b9f6d098b860a8ad$var$map);
// ------------------- //
// Add EU27 Toggle Button
// ------------------- //
// Add EU27 toggle button on the top-right of the map
const $b9f6d098b860a8ad$var$euToggle = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).Control.extend({
    options: {
        position: "topright"
    },
    onAdd: function() {
        const divContainer = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create("div", "leaflet-control leaflet-bar");
        divContainer.setAttribute("id", "eu-toggle");
        divContainer.setAttribute("style", "width: 60px; background-color: white; cursor: grab;");
        divContainer.insertAdjacentHTML("afterbegin", `
      <div title="Toggle EU27 layer">
        <span class="form-switch">
          <input id="eu-switch" class="form-check-input" style="cursor: pointer; width: 85%; height: 1.70em;" type="checkbox" role="switch" checked>
        </span>
        <span class="fw-bold" style="font-size: 1.30em;">EU27</span>
      </div>
    `);
        document.getElementById("map").style.outlineStyle = "none";
        return divContainer;
    }
});
$b9f6d098b860a8ad$var$map.addControl(new $b9f6d098b860a8ad$var$euToggle());
// ------------------- //
// Add UEA Logo
// ------------------- //
// Add UEA logo to the bottom-right corner of the map
const $b9f6d098b860a8ad$var$ueaLogo = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).Control.extend({
    options: {
        position: "bottomright"
    },
    onAdd: function() {
        const divContainer = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create("div", "leaflet-control leaflet-bar");
        divContainer.setAttribute("id", "uea-logo");
        divContainer.setAttribute("style", "border: none; pointer-events: none; width: 50px; height: 100%; background-color: white; padding: 2px; opacity: 0.80;");
        divContainer.insertAdjacentHTML("afterbegin", `

      <svg width="100%" height="100%" viewBox="0 0 1963 1184" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
        <g><path d="M481.442,886.217c-10.679,-0 -3.421,-0.279 -13.421,-0.279c-123.821,-0 -216.754,-85.088 -216.754,-323.28l-0,-351.079c-0,-120.362 53.266,-166.041 128.541,-166.041l0,-14.321l-379.808,-0l0,14.146c66.008,1.27 89.863,57.379 89.863,131.166l-0,346.059c-0,260.729 124.825,378.454 351.108,378.454l40.437,-0l0.034,-14.825Z" style="fill:#231f20;fill-rule:nonzero;"/><path d="M1244.58,644.079c-1.458,-130.675 -30.937,-158.783 -161.441,-160.05l-0,-12.916c130.504,-1.288 159.983,-29.325 161.441,-160.021l12.292,-0c1.513,130.696 30.921,158.646 161.425,159.916l0,13.021c-130.504,1.267 -159.912,29.375 -161.425,160.05l-12.292,0Z" style="fill:#00aeef;fill-rule:nonzero;"/><path d="M544.238,886.304c118.124,0 170.087,-80.192 170.087,-193.525c0,-135.766 0,0 0,0l-0.125,-492.866c0,-115.763 -57.983,-154.271 -128.313,-154.271l-0.054,-14.463l670.904,0l0.292,182.084l-11.891,-0.034c-20.034,-107.029 -61.771,-148.837 -197.9,-148.837l-31.542,-0c-128.021,-0 -153.179,40.816 -153.179,155.4l-0,106.562c-0,138.925 56.721,144.638 163.629,144.638l-0,13.021c-106.908,-0 -163.629,11.645 -163.629,151.924l-0,45.609c-0,171.858 21.683,183.279 166.112,183.279c85.379,-0 189.463,-21.875 216.217,-139.671l12.204,0.054l0,175.834l-712.812,-0l-0,-14.738Z" style="fill:#231f20;fill-rule:nonzero;"/><path d="M1495.75,886.217c117.933,-0 147.725,-76.146 94.271,-195.609l-180.729,-451.979l52.22,-223.541l9.95,-0.038c0,0 248.525,590.104 310.175,709.5c65.05,126.004 119.721,161.754 173.646,161.754l0,14.738l-459.533,-0l-0,-14.825Z" style="fill:#231f20;fill-rule:nonzero;"/><path d="M138.158,1152.17c-31.129,-0 -49.737,-22.413 -49.737,-59.95l-0,-76.788l19.167,0l-0,75.817c-0,28.158 12.795,40.85 30.937,40.85c18.054,0 30.4,-12.342 30.4,-39.879l-0,-76.788l19.167,0l-0,75.625c-0,38.246 -18.667,61.113 -49.934,61.113Z" style="fill:#231f20;fill-rule:nonzero;"/><path d="M286.738,1149.12l-18.717,-0l-0,-59.621c-0,-16.858 -7.067,-25.796 -19.167,-25.796c-12.692,0 -22.692,10.138 -22.692,26.996l0,58.421l-18.679,-0l0,-102.363l17.588,0l-0,14.446c5.987,-11.062 15.45,-16.583 27.462,-16.583c20.767,-0 34.205,16.162 34.205,41.233l-0,63.267Z" style="fill:#231f20;fill-rule:nonzero;"/><path d="M329.217,1034.51l-18.438,-0l0,-18.921l18.438,-0l-0,18.921Zm0.158,114.604l-18.679,-0l-0,-102.363l18.679,0l0,102.363Z" style="fill:#231f20;fill-rule:nonzero;"/><path d="M396.546,1149.86l-16.513,-0.001l-36.683,-103.108l19.792,0l25.175,76.7l25.329,-76.7l19.446,0l-36.546,103.108Z" style="fill:#231f20;fill-rule:nonzero;"/><path d="M457.188,1089.69l47.516,-0.001c-1.612,-15.295 -9.392,-27.308 -23.404,-27.308c-13.313,0 -22.533,12.446 -24.113,27.308Zm26.092,61.755c-26.283,-0 -45.433,-22.971 -45.433,-53.421c-0,-30.45 19.012,-53.404 43.767,-53.404c24.758,-0 42.137,21.754 42.137,54.166c0,1.392 0,2.971 -0.175,5.334l-0.087,2.204l-66.18,-0c2.084,18.437 13.475,27.604 26.305,27.604c8.312,-0 17.254,-3.454 25,-12.829l0.745,-0.871l10.259,10.262l0.816,0.834l-0.712,0.954c-9.513,13.108 -21.509,19.167 -36.442,19.167Z" style="fill:#231f20;fill-rule:nonzero;"/><path d="M558.629,1149.12l-18.387,-0l-0,-102.363l17.954,0l-0,21.963c6.196,-15.904 17.15,-23.734 30.675,-23.734c0.537,0 2.587,0.071 2.587,0.071l0,21.996l-2.083,0c-16.858,0 -30.746,13.229 -30.746,41.004l0,41.063Z" style="fill:#231f20;fill-rule:nonzero;"/><path d="M632.013,1151.01c-11.371,0 -24.217,-4.637 -34.08,-13.891l-0.795,-0.709l8.399,-14.62l0.905,0.783c9.425,8.158 17.741,11.421 27.445,11.421c10.055,-0 15.955,-4.792 15.955,-12.621c-0,-8.196 -6.334,-11.108 -18.105,-14.913c-12.412,-4.062 -29.395,-9.966 -29.395,-31.233c-0,-17.95 14.691,-30.208 32.625,-30.208c10.658,-0 21.041,3.125 30.225,10.137l0.883,0.646l-7.583,15.363l-0.905,-0.713c-8.195,-6.129 -17.395,-8.421 -23.42,-8.421c-9.2,0 -14.721,4.879 -14.721,11.271c-0,8.071 5.121,10 20.362,14.721c16.771,5.208 27.067,14.846 27.067,31.425c-0,19.042 -14.375,31.562 -34.863,31.562Z" style="fill:#231f20;fill-rule:nonzero;"/><path d="M805.746,1180.55c-12.484,0 -24.342,-8.646 -24.342,-8.646l6.25,-17.187c0,-0 9.638,7.171 17.05,7.171c9.967,-0 14.517,-6.234 18.142,-16.65l-38.942,-98.488l20.246,0l27.742,73.125l22.708,-73.125l19.725,0l-36.912,104.842c-7.084,18.612 -17.43,28.958 -31.25,28.958" style="fill:#231f20;fill-rule:nonzero;"/><path d="M949.704,1062.9c-14.446,0 -27.604,13.142 -27.604,34.442c0,21.425 13.3,35.108 27.933,35.108c14.584,0 27.867,-13.179 27.867,-34.325c0,-19.496 -12.204,-35.192 -28.196,-35.192m0,88.213c-25.729,-0 -46.612,-23.317 -46.612,-53.021c-0,-30.346 21.025,-53.783 46.941,-53.783c25.817,-0 46.98,23.279 46.98,53c-0,30.316 -21.284,53.804 -47.309,53.804Z" style="fill:#231f20;fill-rule:nonzero;"/><path d="M1034.36,1149.01l-18.975,0l0,-83.85l-11.895,0l-0,-18.508l11.895,0l0,-6.65c0,-24.967 19.2,-30.05 28.071,-30.05c6.684,0 11.079,1.196 14.584,2.621l0.729,0.292l-0,18.524l-0.938,-0.45c-2.741,-1.387 -7.466,-2.466 -10.591,-2.466c-9.375,-0 -13.055,5.262 -13.055,13.716l0,4.655l24.392,-0l0,18.316l-24.217,0l0,83.85Z" style="fill:#231f20;fill-rule:nonzero;"/><path d="M1188.54,1148.96l-82.5,0l-0,-133.75l81.666,0l0,19.321l-62.204,0l0,34.759l54.688,-0l-0,19.308l-54.688,-0l0,41.229l63.038,0l-0,19.133Z" style="fill:#231f20;fill-rule:nonzero;"/><path d="M1218.17,1117.28c0,10.571 7.675,16.042 17.642,16.042c15.779,-0 24.758,-11.425 24.758,-24.513l0,-5.591c-4.204,-2.534 -11.65,-4.325 -19.671,-4.325c-11.425,-0 -22.729,5.729 -22.729,18.387Zm15.108,33.504c-16.562,0 -34.045,-10.537 -34.045,-33.021c-0,-21.612 15.795,-36.229 39.67,-36.229c9.2,0 16.821,1.996 21.284,3.871l-0,-1.425c-0,-10.746 -5.488,-20.779 -20.4,-20.779c-10.696,-0 -20.834,3.871 -28.975,9.25l-1.042,0.696l-5.4,-17.588l0.883,-0.675c8.005,-5.242 21.234,-10.137 34.896,-10.137c12.329,-0 22.659,3.937 29.1,11.387c6.284,7.275 9.688,17.154 9.688,30.242l-0,62.587l-16.392,0l0,-12.966c-3.679,6.995 -14.458,14.787 -29.267,14.787Z" style="fill:#231f20;fill-rule:nonzero;"/><path d="M1543.33,1095.87l-20.712,-52.654l-20.642,52.708l41.354,-0.054Zm40.675,53.091l-20.829,0l-12.658,-33.8l-55.659,0l-12.675,33.8l-20.591,0l53.7,-133.558l15.016,0l53.696,133.558Z" style="fill:#231f20;fill-rule:nonzero;"/><path d="M1732.43,1063.17c-13.504,0 -25.121,10.558 -25.121,29.292c0,18.733 12.067,30.104 25.121,30.104c14.742,-0 27.379,-11.946 27.379,-29.533c0,-20.746 -13.8,-29.863 -27.379,-29.863Zm0.159,117.05c-14.825,0 -28.23,-4.737 -39.93,-14.133l-0.816,-0.659l8.071,-16.858l0.975,0.854c9.825,8.296 20.812,12.5 32.62,12.5c19.271,0 28.109,-13.458 28.109,-31.25l-0,-8.108c-5.942,12.567 -18.65,18.646 -31.671,18.646c-20.521,-0 -41.771,-17.938 -41.771,-47.954c0,-30.709 21.25,-48.784 41.771,-48.784c13.058,0 26.337,6.267 32.675,17.725l-0,-15.625l16.633,0l0,83.734c0,15.329 -3.854,27.516 -11.371,36.233c-7.762,8.942 -20.975,13.679 -35.295,13.679Z" style="fill:#231f20;fill-rule:nonzero;"/><rect x="1800.14" y="1015.49" width="18.679" height="133.471" style="fill:#231f20;"/><path d="M757.742,1150.95c-16.404,0 -26.404,-10.487 -26.404,-29.479l-0,-55.938l-12.034,0.001l0,-18.734l11.771,-0.016l-0.017,-28.35l19.063,-0l-0,28.404l25.296,-0l-0,18.696l-25.296,-0l-0,50.991c-0,9.634 3.212,15.329 11.321,15.329c4.271,0 8.437,-1.025 11.546,-2.85l1.562,-0.866l-0.071,18.058l-0.696,0.346c-4.979,3.004 -10.104,4.408 -16.041,4.408Z" style="fill:#231f20;fill-rule:nonzero;"/><path d="M1408.56,1150.62c-16.441,0 -26.441,-10.487 -26.441,-29.446l-0,-55.954l-12.03,-0l0,-18.525l11.684,-0.017l-0.034,-28.591l19.151,-0l-0,28.416l25.291,0l0,18.717l-25.291,-0l-0,50.992c-0,9.6 3.225,15.291 11.354,15.291c4.271,0 8.416,-0.971 11.541,-2.829l1.563,-0.867l0.037,18.075l-0.816,0.346c-4.984,3.005 -10.105,4.392 -16.009,4.392Z" style="fill:#231f20;fill-rule:nonzero;"/><path d="M1673.05,1149.03l-18.712,0l-0,-59.583c-0,-16.875 -7.067,-25.817 -19.167,-25.817c-12.708,0 -22.692,10.138 -22.692,26.979l0,58.421l-18.7,0l0,-102.346l17.588,0l-0,14.446c5.991,-11.079 15.471,-16.579 27.45,-16.579c20.796,0 34.233,16.163 34.233,41.229l0,63.25Z" style="fill:#231f20;fill-rule:nonzero;"/><path d="M703.263,1034.57l-18.455,-0l0,-18.925l18.455,-0l-0,18.925Zm0.174,114.791l-18.716,0l-0,-102.57l18.716,-0l0,102.57Z" style="fill:#231f20;fill-rule:nonzero;"/><path d="M1859.42,1034.64l-18.471,-0l0,-18.942l18.471,-0l0,18.942Zm0.158,114.27l-18.679,0l0,-102.362l18.679,-0l0,102.362Z" style="fill:#231f20;fill-rule:nonzero;"/><path d="M1325.68,1150.61c-11.391,0 -24.221,-4.67 -34.083,-13.908l-0.796,-0.708l8.4,-14.654l0.921,0.816c9.412,8.175 17.725,11.442 27.433,11.442c10.05,-0 15.971,-4.792 15.971,-12.625c0,-8.208 -6.354,-11.146 -18.142,-14.946c-12.395,-4.063 -29.375,-9.983 -29.375,-31.2c0,-17.967 14.671,-30.225 32.605,-30.225c10.691,0 21.041,3.108 30.241,10.138l0.867,0.662l-7.567,15.313l-0.904,-0.68c-8.212,-6.125 -17.396,-8.4 -23.437,-8.4c-9.2,0 -14.705,4.842 -14.705,11.25c0,8.071 5.121,9.984 20.363,14.705c16.754,5.208 27.067,14.858 27.067,31.458c-0,19.008 -14.392,31.562 -34.859,31.562Z" style="fill:#231f20;fill-rule:nonzero;"/><path d="M1894.6,1117.69c0,10.591 7.692,16.025 17.638,16.025c15.783,-0 24.775,-11.409 24.775,-24.5l-0,-5.571c-4.2,-2.554 -11.646,-4.304 -19.688,-4.304c-11.387,-0 -22.725,5.691 -22.725,18.35Zm15.104,33.508c-16.546,-0 -34.046,-10.521 -34.046,-33.004c0,-21.617 15.85,-36.217 39.688,-36.217c9.166,0 16.825,1.963 21.287,3.871l0,-1.442c0,-10.746 -5.487,-20.779 -20.416,-20.779c-10.696,0 -20.834,3.871 -28.975,9.254l-1.063,0.675l-5.396,-17.587l0.9,-0.642c8.004,-5.279 21.234,-10.137 34.913,-10.137c12.312,-0 22.658,3.887 29.116,11.354c6.25,7.275 9.65,17.15 9.65,30.241l0,62.292l-16.387,0l-0,-12.654c-3.679,6.996 -14.463,14.775 -29.271,14.775Z" style="fill:#231f20;fill-rule:nonzero;"/></g>
      </svg>

    `);
        // document.getElementById("map").style.outlineStyle = "none";
        return divContainer;
    }
});
$b9f6d098b860a8ad$var$map.addControl(new $b9f6d098b860a8ad$var$ueaLogo());
// ------------------- //
// Leaflet Map Parameters
// ------------------- //
// Scale
// const scale = [20, 15, 10, 8, 6, 4, 2, 1, 0, 0];
const $b9f6d098b860a8ad$var$scale = [
    15,
    10,
    5,
    4,
    3,
    2,
    1,
    0.5,
    0.1,
    0,
    0
];
// Colour palette (darks first, lights last, icy blue final)
const $b9f6d098b860a8ad$var$colPalette = [
    "#13051D",
    "#3A0E5B",
    "#9D2A62",
    "#D74F3E",
    "#E9672C",
    "#F68614",
    "#FAB124",
    "#FBD54F",
    "#FDED81",
    "#FCFC9E",
    "#DEEEF8"
];
// Function to style polygons
const $b9f6d098b860a8ad$var$stylePolygons = function(variable) {
    return function(feature) {
        return {
            fillColor: (0, $24badfeb4d36b999$export$13746b04065d45d9)(feature.properties[variable], $b9f6d098b860a8ad$var$scale, $b9f6d098b860a8ad$var$colPalette),
            weight: 0.5,
            opacity: 1,
            color: "black",
            dashArray: "1",
            fillOpacity: 1
        };
    };
};
// Function to highlight polygon borders and show popup on mouseover (when mouse hovers over them)
const $b9f6d098b860a8ad$var$highlightPolygon = function(e) {
    const polygon = e.target;
    // Polygon borders
    polygon.setStyle({
        weight: 2,
        color: "black",
        fillOpacity: 1
    });
    // Update display information in top-right box
    $b9f6d098b860a8ad$var$displayInfo.update(polygon.feature.properties);
    polygon.bringToFront();
};
// Functions to trigger white and black transition when a polygon is clicked
const $b9f6d098b860a8ad$var$triggerWhite = (e)=>{
    e.target.setStyle({
        color: "white"
    });
};
const $b9f6d098b860a8ad$var$triggerBlack = (e)=>{
    e.target.setStyle({
        color: "black"
    });
};
// Popup options
// https://leafletjs.com/reference.html#popup
const $b9f6d098b860a8ad$var$popupOptions = {
    className: "popupCustom",
    closeButton: true,
    autoPan: false
};
// Function to show popup on mouse click
const $b9f6d098b860a8ad$var$showPopup = function(e) {
    const polygon = e.target;
    // console.log(polygon._leaflet_id);
    // Remove any previous content binded to popup
    polygon.unbindPopup();
    // Extract the unique chart ID
    const chartId = `chart-${polygon.feature.properties.Country.replace(/\s/g, "")}`;
    // Remove any previous plot element from DOM
    const elementExist = document.getElementById(chartId);
    if (elementExist) elementExist.remove();
    // Get active variable combination
    const activeVariables = $b9f6d098b860a8ad$var$activeSelectors();
    // Popup content with a unique chart ID
    const popupContentHtml = (0, $24badfeb4d36b999$export$ebcd05299db66cf5)(polygon.feature.properties, $b9f6d098b860a8ad$var$gasSelector.textContent, $b9f6d098b860a8ad$var$sourceSelector.textContent, chartId);
    // Create popup that stays within map boundary
    const popup = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).responsivePopup({
        offset: [
            0,
            0
        ]
    }).setContent(popupContentHtml);
    // Bind the popup with unique content
    polygon.bindPopup(popup, $b9f6d098b860a8ad$var$popupOptions).openPopup();
    // Render time series on popup
    if (polygon.feature.properties[activeVariables] !== null) (0, $a8303d5548eab261$export$94998eaeecec5e7b)(polygon.feature.properties, activeVariables, $b9f6d098b860a8ad$var$scale, $b9f6d098b860a8ad$var$colPalette, chartId);
    else document.getElementById(chartId).insertAdjacentHTML("beforeend", `
      <p class="text-start">No Data To Display</p>
    `);
};
// Function to reset border to original style on mouseout (when mouse is not hovering over a polygon)
const $b9f6d098b860a8ad$var$resetHighlight = function(e) {
    $b9f6d098b860a8ad$var$geojsonLayer.resetStyle(e.target);
    $b9f6d098b860a8ad$var$displayInfo.update();
};
// Function to add highlighting parameters to a layer
const $b9f6d098b860a8ad$var$onEachFeature = function(feature, layer) {
    layer.on({
        mouseover: $b9f6d098b860a8ad$var$highlightPolygon,
        mouseout: $b9f6d098b860a8ad$var$resetHighlight,
        click: $b9f6d098b860a8ad$var$showPopup,
        mousedown: $b9f6d098b860a8ad$var$triggerWhite,
        mouseup: $b9f6d098b860a8ad$var$triggerBlack
    });
};
// ------------------- //
// Default Leaflet Map
// ------------------- //
// Add default layer to map
let $b9f6d098b860a8ad$var$geojsonLayer = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).geoJson($b9f6d098b860a8ad$var$returnSelectedPeriodData(), {
    style: $b9f6d098b860a8ad$var$stylePolygons($b9f6d098b860a8ad$var$activeSelectors()),
    onEachFeature: $b9f6d098b860a8ad$var$onEachFeature
}).addTo($b9f6d098b860a8ad$var$map);
// ------------------- //
// Leaflet Map Legend
// ------------------- //
// Inititate legend control
let $b9f6d098b860a8ad$var$legend = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).control({
    position: "bottomleft"
});
// Function when element is added to map
$b9f6d098b860a8ad$var$legend.onAdd = function(map) {
    const div = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create("div", "displayInfo legend"), grades = $b9f6d098b860a8ad$var$scale, labels = $b9f6d098b860a8ad$var$scale;
    // Legend title
    div.innerHTML += `
    <span id="legend-title">
      <p class="text-start legendTooltip" style="display: none; font-size: 105%;">Warming Contribution (%)</p>
      <p class="text-start" style="margin-bottom: 0.4rem;">
        <span style="font-size: 105%;">Legend</span>
        <br>
        <span>(%)</span>
      </p>
    </span>
  `;
    // Legend content
    for(let i = 0; i < grades.length - 1; i++)div.innerHTML += `
      <i style="background:${$b9f6d098b860a8ad$var$colPalette[i]}; margin-right: 0;"></i>
      <span class="legend-text">${grades[i]}</span>
      <br>
    `;
    // Last item in legend (negative values)
    div.innerHTML += `
      <i style="background:${$b9f6d098b860a8ad$var$colPalette[grades.length - 1]}; margin-right: 0;"></i>
      <span class="legend-text">${`< ${grades[grades.length - 1]}`}</span>
    `;
    return div;
};
// Add legend to map
$b9f6d098b860a8ad$var$legend.addTo($b9f6d098b860a8ad$var$map);
$b9f6d098b860a8ad$var$tooltipEventListener();
// ------------------- //
// Choices Event Listeners
// ------------------- //
// Initiate variables
let $b9f6d098b860a8ad$var$choices1, $b9f6d098b860a8ad$var$choices2, $b9f6d098b860a8ad$var$choices3;
// Choices select input functionality and styling
document.addEventListener("DOMContentLoaded", function() {
    const first = document.getElementById("source-selector");
    const second = document.getElementById("gas-selector");
    const third = document.getElementById("period-selector");
    const options = {
        searchEnabled: false,
        allowHTML: true,
        shouldSort: false,
        itemSelectText: "click to select"
    };
    $b9f6d098b860a8ad$var$choices1 = new (0, (/*@__PURE__*/$parcel$interopDefault($125d88de280575d0$exports)))(first, {
        searchEnabled: false,
        allowHTML: true,
        shouldSort: false,
        itemSelectText: ""
    });
    $b9f6d098b860a8ad$var$choices2 = new (0, (/*@__PURE__*/$parcel$interopDefault($125d88de280575d0$exports)))(second, options);
    $b9f6d098b860a8ad$var$choices3 = new (0, (/*@__PURE__*/$parcel$interopDefault($125d88de280575d0$exports)))(third, options);
});
// Change the data displayed when a different source is selected
document.getElementById("source-selector").addEventListener("change", ()=>{
    // Remove active layer from map
    $b9f6d098b860a8ad$var$map.removeLayer($b9f6d098b860a8ad$var$geojsonLayer);
    // Add new layer to map
    $b9f6d098b860a8ad$var$geojsonLayer = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).geoJson($b9f6d098b860a8ad$var$returnSelectedPeriodData(), {
        style: $b9f6d098b860a8ad$var$stylePolygons($b9f6d098b860a8ad$var$activeSelectors()),
        onEachFeature: $b9f6d098b860a8ad$var$onEachFeature
    }).addTo($b9f6d098b860a8ad$var$map);
    // Change text content of displayInfo on top-right widget
    const sourceText = $b9f6d098b860a8ad$var$sourceSelector.options[$b9f6d098b860a8ad$var$sourceSelector.selectedIndex].textContent;
    const gasText = $b9f6d098b860a8ad$var$gasSelector.options[$b9f6d098b860a8ad$var$sourceSelector.selectedIndex].textContent;
    document.querySelector("#display-info-widget > h4").innerHTML = `${sourceText}<br>${gasText}`;
});
// Change the data displayed when a different gas is selected
document.getElementById("gas-selector").addEventListener("change", ()=>{
    // Remove active layer from map
    $b9f6d098b860a8ad$var$map.removeLayer($b9f6d098b860a8ad$var$geojsonLayer);
    // Add new layer to map
    $b9f6d098b860a8ad$var$geojsonLayer = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).geoJson($b9f6d098b860a8ad$var$returnSelectedPeriodData(), {
        style: $b9f6d098b860a8ad$var$stylePolygons($b9f6d098b860a8ad$var$activeSelectors()),
        onEachFeature: $b9f6d098b860a8ad$var$onEachFeature
    }).addTo($b9f6d098b860a8ad$var$map);
    // Change text content of displayInfo on top-right widget
    const sourceText = $b9f6d098b860a8ad$var$sourceSelector.options[$b9f6d098b860a8ad$var$sourceSelector.selectedIndex].textContent;
    const gasText = $b9f6d098b860a8ad$var$gasSelector.options[$b9f6d098b860a8ad$var$sourceSelector.selectedIndex].textContent;
    document.querySelector(".displayInfo > h4").innerHTML = `${sourceText}<br>${gasText}`;
});
// Change the data displayed when a different time period is selected
document.getElementById("period-selector").addEventListener("change", ()=>{
    // Remove active layer from map
    $b9f6d098b860a8ad$var$map.removeLayer($b9f6d098b860a8ad$var$geojsonLayer);
    // Add new layer to map
    $b9f6d098b860a8ad$var$geojsonLayer = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).geoJson($b9f6d098b860a8ad$var$returnSelectedPeriodData(), {
        style: $b9f6d098b860a8ad$var$stylePolygons($b9f6d098b860a8ad$var$activeSelectors()),
        onEachFeature: $b9f6d098b860a8ad$var$onEachFeature
    }).addTo($b9f6d098b860a8ad$var$map);
});
// ------------------- //
// EU27 Polygon Event Listener
// ------------------- //
// Toggle EU layer
document.getElementById("eu-switch").addEventListener("change", ()=>{
    // Remove active layer from map
    $b9f6d098b860a8ad$var$map.removeLayer($b9f6d098b860a8ad$var$geojsonLayer);
    // Add new layer to map
    $b9f6d098b860a8ad$var$geojsonLayer = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).geoJson($b9f6d098b860a8ad$var$returnSelectedPeriodData(), {
        style: $b9f6d098b860a8ad$var$stylePolygons($b9f6d098b860a8ad$var$activeSelectors()),
        onEachFeature: $b9f6d098b860a8ad$var$onEachFeature
    }).addTo($b9f6d098b860a8ad$var$map);
});
// ------------------- //
// Legend Tooltip Event Listener
// ------------------- //
// Function to toggle legend text on hover
function $b9f6d098b860a8ad$var$tooltipEventListener() {
    document.querySelector("#legend-title").addEventListener("mouseenter", function() {
        document.querySelector(".legendTooltip").style.display = "flex";
    });
    document.querySelector("#legend-title").addEventListener("mouseleave", function() {
        document.querySelector(".legendTooltip").style.display = "none";
    });
}
// ------------------- //
// Save Image Event listener
// ------------------- //
// // Add event listener to the save image button
// document.getElementById("btn-save-image").addEventListener("click", () => {
//   // const scale = 2;
//   // leafletImage(map, function(err, canvas) {
//   //     if (err) {
//   //         console.error(err);
//   //         return;
//   //     }
//   //     // Create a scaled canvas
//   //     const scaledCanvas = document.createElement("canvas");
//   //     scaledCanvas.width = canvas.width * scale;
//   //     scaledCanvas.height = canvas.height * scale;
//   //     const ctx = scaledCanvas.getContext("2d");
//   //     // Fill the canvas with grey background
//   //     ctx.fillStyle = "#ddd";
//   //     ctx.fillRect(0, 0, scaledCanvas.width, scaledCanvas.height);
//   //     // Scale and draw the map image onto the canvas
//   //     ctx.scale(scale, scale);
//   //     ctx.drawImage(canvas, 0, 0);
//   //     // Create an image from the scaled canvas
//   //     const img = document.createElement("img");
//   //     img.width = scaledCanvas.width;
//   //     img.height = scaledCanvas.height;
//   //     img.src = scaledCanvas.toDataURL();
//   //     // Create a link to download the image
//   //     const link = document.createElement("a");
//   //     link.href = img.src;
//   //     link.download = "National-Contributions-map-image.png";
//   //     link.appendChild(img);
//   //     link.click();
//   // });
// });
// ------------------- //
// Animate Time Period Event Listener
// ------------------- //
// Years to animate
const $b9f6d098b860a8ad$var$animateYears = [
    "1851",
    "1990",
    "2005",
    "2020"
];
// Function to create new Promise
const $b9f6d098b860a8ad$var$wait = function(time) {
    return new Promise((resolve)=>setTimeout(resolve, time));
};
// Function to process each map layer sequentially to animate map layers
const $b9f6d098b860a8ad$var$mapAnimation = async function() {
    // first map layer
    $b9f6d098b860a8ad$var$map.removeLayer($b9f6d098b860a8ad$var$geojsonLayer);
    const layer1 = $b9f6d098b860a8ad$var$returnSelectedPeriodData($b9f6d098b860a8ad$var$animateYears[0]);
    $b9f6d098b860a8ad$var$geojsonLayer = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).geoJson(layer1, {
        style: $b9f6d098b860a8ad$var$stylePolygons($b9f6d098b860a8ad$var$activeSelectors()),
        onEachFeature: $b9f6d098b860a8ad$var$onEachFeature
    }).addTo($b9f6d098b860a8ad$var$map);
    $b9f6d098b860a8ad$var$choices3.setChoiceByValue($b9f6d098b860a8ad$var$animateYears[0]);
    await $b9f6d098b860a8ad$var$wait(1000); // wait 1 second
    // second map layer
    $b9f6d098b860a8ad$var$map.removeLayer($b9f6d098b860a8ad$var$geojsonLayer);
    const layer2 = $b9f6d098b860a8ad$var$returnSelectedPeriodData($b9f6d098b860a8ad$var$animateYears[1]);
    $b9f6d098b860a8ad$var$geojsonLayer = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).geoJson(layer2, {
        style: $b9f6d098b860a8ad$var$stylePolygons($b9f6d098b860a8ad$var$activeSelectors()),
        onEachFeature: $b9f6d098b860a8ad$var$onEachFeature
    }).addTo($b9f6d098b860a8ad$var$map);
    $b9f6d098b860a8ad$var$choices3.setChoiceByValue($b9f6d098b860a8ad$var$animateYears[1]);
    await $b9f6d098b860a8ad$var$wait(1000); // wait 1 second
    // third map layer
    $b9f6d098b860a8ad$var$map.removeLayer($b9f6d098b860a8ad$var$geojsonLayer);
    const layer3 = $b9f6d098b860a8ad$var$returnSelectedPeriodData($b9f6d098b860a8ad$var$animateYears[2]);
    $b9f6d098b860a8ad$var$geojsonLayer = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).geoJson(layer3, {
        style: $b9f6d098b860a8ad$var$stylePolygons($b9f6d098b860a8ad$var$activeSelectors()),
        onEachFeature: $b9f6d098b860a8ad$var$onEachFeature
    }).addTo($b9f6d098b860a8ad$var$map);
    $b9f6d098b860a8ad$var$choices3.setChoiceByValue($b9f6d098b860a8ad$var$animateYears[2]);
    await $b9f6d098b860a8ad$var$wait(1000); // wait 1 second
    // fourth map layer
    $b9f6d098b860a8ad$var$map.removeLayer($b9f6d098b860a8ad$var$geojsonLayer);
    const layer4 = $b9f6d098b860a8ad$var$returnSelectedPeriodData($b9f6d098b860a8ad$var$animateYears[3]);
    $b9f6d098b860a8ad$var$geojsonLayer = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).geoJson(layer4, {
        style: $b9f6d098b860a8ad$var$stylePolygons($b9f6d098b860a8ad$var$activeSelectors()),
        onEachFeature: $b9f6d098b860a8ad$var$onEachFeature
    }).addTo($b9f6d098b860a8ad$var$map);
    $b9f6d098b860a8ad$var$choices3.setChoiceByValue($b9f6d098b860a8ad$var$animateYears[3]);
};
// Run animation when user clicks button
document.getElementById("btn-animate").addEventListener("click", $b9f6d098b860a8ad$var$mapAnimation);
// ------------------- //
// Top Right Reset Button
// ------------------- //
// Reset map to default state
document.getElementById("btn-reset").addEventListener("click", (e)=>{
    e.preventDefault();
    // Remove active layer from map
    $b9f6d098b860a8ad$var$map.removeLayer($b9f6d098b860a8ad$var$geojsonLayer);
    // Add new layer to map
    $b9f6d098b860a8ad$var$geojsonLayer = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).geoJson($b9f6d098b860a8ad$var$returnSelectedPeriodData("1851"), {
        style: $b9f6d098b860a8ad$var$stylePolygons("Total_3GHG"),
        onEachFeature: $b9f6d098b860a8ad$var$onEachFeature
    }).addTo($b9f6d098b860a8ad$var$map);
    // Change choices to default settings
    $b9f6d098b860a8ad$var$choices1.setChoiceByValue("Total");
    $b9f6d098b860a8ad$var$choices2.setChoiceByValue("3GHG");
    $b9f6d098b860a8ad$var$choices3.setChoiceByValue("1851");
    // Change text content of displayInfo on top-right widget
    const sourceText = $b9f6d098b860a8ad$var$sourceSelector.options[$b9f6d098b860a8ad$var$sourceSelector.selectedIndex].textContent;
    const gasText = $b9f6d098b860a8ad$var$gasSelector.options[$b9f6d098b860a8ad$var$sourceSelector.selectedIndex].textContent;
    document.querySelector("#display-info-widget > h4").innerHTML = `${sourceText}<br>${gasText}`;
    // Reset map view
    $b9f6d098b860a8ad$var$map.setView([
        0,
        0
    ], 1);
});
// ------------------- //
// Top Right Download Data Button
// ------------------- //
// Function to download data when download button is clicked
const $b9f6d098b860a8ad$var$exportCSV = function() {
    // 1. Prepare layer data for download
    let csv = "";
    let row = "";
    // Programmatically extract keys from the first object to use as headers
    const keys = [
        "Country",
        "ISO3",
        "Total_3GHG",
        "Fossil_3GHG",
        "Land_3GHG",
        "Total_CO2",
        "Fossil_CO2",
        "Land_CO2",
        "Total_CH4",
        "Fossil_CH4",
        "Land_CH4",
        "Total_N2O",
        "Fossil_N2O",
        "Land_N2O"
    ];
    // Add keys to CSV as first row
    row = keys.join(",");
    csv += row + "\r\n";
    // Deep clone data
    const data = $b9f6d098b860a8ad$var$deepClone($b9f6d098b860a8ad$var$returnSelectedPeriodData());
    // console.log(data)
    // Number of countries to loop over
    const numCountries = data.features.map((property)=>property.properties).length - 1;
    // console.log(data.features.map(property => property.properties)[0][keys[0]]);
    // console.log(data.features.map(property => property.properties))
    // Loop through each feature, extract values for each country and add to CSV
    for(let i = 0; i < numCountries; i++){
        let line = "";
        for(let j = 0; j < keys.length; j++){
            if (line !== "") line += ",";
            // For country names, remove any commas that may be present
            let value = "";
            if (keys[j] === "Country") value = data.features.map((property)=>property.properties)[i][keys[j]].replace(",", "");
            else value = data.features.map((property)=>property.properties)[i][keys[j]];
            line += value;
        }
        csv += line + "\r\n";
    }
    // console.log(csv)
    // 2. Create a blob, configure it, create an object URL and pass the blob object into the object URL
    const blob = new Blob([
        csv
    ], {
        type: "text/csv;charset=utf-8,"
    });
    // 3. Create temporary link to download in the browser
    const downloadLink = document.createElement("a");
    downloadLink.download = `percentage_contribution_${data.name}`;
    downloadLink.href = window.URL.createObjectURL(blob);
    downloadLink.style.display = "none"; // hide temporary link in browser
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
};
document.getElementById("btn-download-data").addEventListener("click", (e)=>{
    e.preventDefault();
    $b9f6d098b860a8ad$var$exportCSV();
});


//# sourceMappingURL=National-Contributions-Map.f31489d0.js.map
